import * as vue from 'vue';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, '__esModule')) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var controller_bc$1 = {exports: {}};

var dist = {};

var hasRequiredDist;

function requireDist () {
	if (hasRequiredDist) return dist;
	hasRequiredDist = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.PerformanceObserver = exports.performance = void 0;
		var perf_hooks_1 = requireDist();
		Object.defineProperty(exports, "performance", { enumerable: true, get: function () { return perf_hooks_1.performance; } });
		Object.defineProperty(exports, "PerformanceObserver", { enumerable: true, get: function () { return perf_hooks_1.PerformanceObserver; } }); 
	} (dist));
	return dist;
}

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1;
  let step = -~((1.6 * mask * defaultSize) / alphabet.length);
  return (size = defaultSize) => {
    let id = '';
    while (true) {
      let bytes = getRandom(step);
      let j = step;
      while (j--) {
        id += alphabet[bytes[j] & mask] || '';
        if (id.length === size) return id
      }
    }
  }
};
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random);
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63;
    if (byte < 36) {
      id += byte.toString(36);
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase();
    } else if (byte > 62) {
      id += '-';
    } else {
      id += '_';
    }
    return id
  }, '');

var index_browser = /*#__PURE__*/Object.freeze({
	__proto__: null,
	customAlphabet: customAlphabet,
	customRandom: customRandom,
	nanoid: nanoid,
	random: random,
	urlAlphabet: urlAlphabet
});

var require$$1$2 = /*@__PURE__*/getAugmentedNamespace(index_browser);

var prod = {};

var feedbackAsync = {};

var cjs$4 = {};

var cjs$3 = {};

var errors = {};

var debugBuild$2 = {};

var hasRequiredDebugBuild$2;

function requireDebugBuild$2 () {
	if (hasRequiredDebugBuild$2) return debugBuild$2;
	hasRequiredDebugBuild$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

		exports.DEBUG_BUILD = DEBUG_BUILD;
		
	} (debugBuild$2));
	return debugBuild$2;
}

var globalError = {};

var worldwide = {};

var hasRequiredWorldwide;

function requireWorldwide () {
	if (hasRequiredWorldwide) return worldwide;
	hasRequiredWorldwide = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const GLOBAL_OBJ = globalThis;

		exports.GLOBAL_OBJ = GLOBAL_OBJ;
		
	} (worldwide));
	return worldwide;
}

var handlers$1 = {};

var debugLogger = {};

var carrier = {};

var version$1 = {};

var hasRequiredVersion;

function requireVersion () {
	if (hasRequiredVersion) return version$1;
	hasRequiredVersion = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const SDK_VERSION = "10.60.0" ;

		exports.SDK_VERSION = SDK_VERSION;
		
	} (version$1));
	return version$1;
}

var hasRequiredCarrier;

function requireCarrier () {
	if (hasRequiredCarrier) return carrier;
	hasRequiredCarrier = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const version = /*@__PURE__*/ requireVersion();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		function getMainCarrier() {
		  getSentryCarrier(worldwide.GLOBAL_OBJ);
		  return worldwide.GLOBAL_OBJ;
		}
		function getSentryCarrier(carrier) {
		  const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
		  __SENTRY__.version = __SENTRY__.version || version.SDK_VERSION;
		  return __SENTRY__[version.SDK_VERSION] = __SENTRY__[version.SDK_VERSION] || {};
		}
		function getGlobalSingleton(name, creator, obj = worldwide.GLOBAL_OBJ) {
		  const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
		  const carrier = __SENTRY__[version.SDK_VERSION] = __SENTRY__[version.SDK_VERSION] || {};
		  return carrier[name] || (carrier[name] = creator());
		}

		exports.getGlobalSingleton = getGlobalSingleton;
		exports.getMainCarrier = getMainCarrier;
		exports.getSentryCarrier = getSentryCarrier;
		
	} (carrier));
	return carrier;
}

var hasRequiredDebugLogger;

function requireDebugLogger () {
	if (hasRequiredDebugLogger) return debugLogger;
	hasRequiredDebugLogger = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const carrier = /*@__PURE__*/ requireCarrier();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const CONSOLE_LEVELS = [
		  "debug",
		  "info",
		  "warn",
		  "error",
		  "log",
		  "assert",
		  "trace"
		];
		const PREFIX = "Sentry Logger ";
		const originalConsoleMethods = {};
		function consoleSandbox(callback) {
		  if (!("console" in worldwide.GLOBAL_OBJ)) {
		    return callback();
		  }
		  const console = worldwide.GLOBAL_OBJ.console;
		  const wrappedFuncs = {};
		  const wrappedLevels = Object.keys(originalConsoleMethods);
		  wrappedLevels.forEach((level) => {
		    const originalConsoleMethod = originalConsoleMethods[level];
		    wrappedFuncs[level] = console[level];
		    console[level] = originalConsoleMethod;
		  });
		  try {
		    return callback();
		  } finally {
		    wrappedLevels.forEach((level) => {
		      console[level] = wrappedFuncs[level];
		    });
		  }
		}
		function enable() {
		  _getLoggerSettings().enabled = true;
		}
		function disable() {
		  _getLoggerSettings().enabled = false;
		}
		function isEnabled() {
		  return _getLoggerSettings().enabled;
		}
		function log(...args) {
		  _maybeLog("log", ...args);
		}
		function warn(...args) {
		  _maybeLog("warn", ...args);
		}
		function error(...args) {
		  _maybeLog("error", ...args);
		}
		function _maybeLog(level, ...args) {
		  if (!debugBuild.DEBUG_BUILD) {
		    return;
		  }
		  if (isEnabled()) {
		    consoleSandbox(() => {
		      worldwide.GLOBAL_OBJ.console[level](`${PREFIX}[${level}]:`, ...args);
		    });
		  }
		}
		function _getLoggerSettings() {
		  if (!debugBuild.DEBUG_BUILD) {
		    return { enabled: false };
		  }
		  return carrier.getGlobalSingleton("loggerSettings", () => ({ enabled: false }));
		}
		const debug = {
		  /** Enable logging. */
		  enable,
		  /** Disable logging. */
		  disable,
		  /** Check if logging is enabled. */
		  isEnabled,
		  /** Log a message. */
		  log,
		  /** Log a warning. */
		  warn,
		  /** Log an error. */
		  error
		};

		exports.CONSOLE_LEVELS = CONSOLE_LEVELS;
		exports.consoleSandbox = consoleSandbox;
		exports.debug = debug;
		exports.originalConsoleMethods = originalConsoleMethods;
		
	} (debugLogger));
	return debugLogger;
}

var stacktrace = {};

var hasRequiredStacktrace;

function requireStacktrace () {
	if (hasRequiredStacktrace) return stacktrace;
	hasRequiredStacktrace = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const STACKTRACE_FRAME_LIMIT = 50;
		const UNKNOWN_FUNCTION = "?";
		const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
		const STRIP_FRAME_REGEXP = /captureMessage|captureException/;
		function createStackParser(...parsers) {
		  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map((p) => p[1]);
		  return (stack, skipFirstLines = 0, framesToPop = 0) => {
		    const frames = [];
		    const lines = stack.split("\n");
		    for (let i = skipFirstLines; i < lines.length; i++) {
		      let line = lines[i];
		      if (line.length > 1024) {
		        line = line.slice(0, 1024);
		      }
		      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
		      if (cleanedLine.includes("Error: ")) {
		        continue;
		      }
		      for (const parser of sortedParsers) {
		        const frame = parser(cleanedLine);
		        if (frame) {
		          frames.push(frame);
		          break;
		        }
		      }
		      if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) {
		        break;
		      }
		    }
		    return stripSentryFramesAndReverse(frames.slice(framesToPop));
		  };
		}
		function stackParserFromStackParserOptions(stackParser) {
		  if (Array.isArray(stackParser)) {
		    return createStackParser(...stackParser);
		  }
		  return stackParser;
		}
		function stripSentryFramesAndReverse(stack) {
		  if (!stack.length) {
		    return [];
		  }
		  const localStack = Array.from(stack);
		  if (/sentryWrapped/.test(getLastStackFrame(localStack).function || "")) {
		    localStack.pop();
		  }
		  localStack.reverse();
		  if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) {
		    localStack.pop();
		    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) {
		      localStack.pop();
		    }
		  }
		  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map((frame) => ({
		    ...frame,
		    filename: frame.filename || getLastStackFrame(localStack).filename,
		    function: frame.function || UNKNOWN_FUNCTION
		  }));
		}
		function getLastStackFrame(arr) {
		  return arr[arr.length - 1] || {};
		}
		const defaultFunctionName = "<anonymous>";
		function getFunctionName(fn) {
		  try {
		    if (!fn || typeof fn !== "function") {
		      return defaultFunctionName;
		    }
		    return fn.name || defaultFunctionName;
		  } catch {
		    return defaultFunctionName;
		  }
		}
		function getFramesFromEvent(event) {
		  const exception = event.exception;
		  if (exception) {
		    const frames = [];
		    try {
		      exception.values.forEach((value) => {
		        if (value.stacktrace.frames) {
		          frames.push(...value.stacktrace.frames);
		        }
		      });
		      return frames;
		    } catch {
		      return void 0;
		    }
		  }
		  return void 0;
		}
		function normalizeStackTracePath(path) {
		  let filename = path?.startsWith("file://") ? path.slice(7) : path;
		  if (filename?.match(/\/[A-Z]:/)) {
		    filename = filename.slice(1);
		  }
		  return filename;
		}

		exports.UNKNOWN_FUNCTION = UNKNOWN_FUNCTION;
		exports.createStackParser = createStackParser;
		exports.getFramesFromEvent = getFramesFromEvent;
		exports.getFunctionName = getFunctionName;
		exports.normalizeStackTracePath = normalizeStackTracePath;
		exports.stackParserFromStackParserOptions = stackParserFromStackParserOptions;
		exports.stripSentryFramesAndReverse = stripSentryFramesAndReverse;
		
	} (stacktrace));
	return stacktrace;
}

var hasRequiredHandlers$1;

function requireHandlers$1 () {
	if (hasRequiredHandlers$1) return handlers$1;
	hasRequiredHandlers$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const stacktrace = /*@__PURE__*/ requireStacktrace();

		const handlers = {};
		const instrumented = {};
		function addHandler(type, handler) {
		  handlers[type] = handlers[type] || [];
		  handlers[type].push(handler);
		  return () => {
		    const typeHandlers = handlers[type];
		    if (typeHandlers) {
		      const index = typeHandlers.indexOf(handler);
		      if (index !== -1) {
		        typeHandlers.splice(index, 1);
		      }
		    }
		  };
		}
		function resetInstrumentationHandlers() {
		  Object.keys(handlers).forEach((key) => {
		    handlers[key] = void 0;
		  });
		}
		function maybeInstrument(type, instrumentFn) {
		  if (!instrumented[type]) {
		    instrumented[type] = true;
		    try {
		      instrumentFn();
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.error(`Error while instrumenting ${type}`, e);
		    }
		  }
		}
		function triggerHandlers(type, data) {
		  const typeHandlers = type && handlers[type];
		  if (!typeHandlers) {
		    return;
		  }
		  for (const handler of typeHandlers) {
		    try {
		      handler(data);
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.error(
		        `Error while triggering instrumentation handler.
Type: ${type}
Name: ${stacktrace.getFunctionName(handler)}
Error:`,
		        e
		      );
		    }
		  }
		}

		exports.addHandler = addHandler;
		exports.maybeInstrument = maybeInstrument;
		exports.resetInstrumentationHandlers = resetInstrumentationHandlers;
		exports.triggerHandlers = triggerHandlers;
		
	} (handlers$1));
	return handlers$1;
}

var hasRequiredGlobalError;

function requireGlobalError () {
	if (hasRequiredGlobalError) return globalError;
	hasRequiredGlobalError = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const worldwide = /*@__PURE__*/ requireWorldwide();
		const handlers = /*@__PURE__*/ requireHandlers$1();

		let _oldOnErrorHandler = null;
		function addGlobalErrorInstrumentationHandler(handler) {
		  const type = "error";
		  handlers.addHandler(type, handler);
		  handlers.maybeInstrument(type, instrumentError);
		}
		function instrumentError() {
		  _oldOnErrorHandler = worldwide.GLOBAL_OBJ.onerror;
		  worldwide.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
		    const handlerData = {
		      column,
		      error,
		      line,
		      msg,
		      url
		    };
		    handlers.triggerHandlers("error", handlerData);
		    if (_oldOnErrorHandler) {
		      return _oldOnErrorHandler.apply(this, arguments);
		    }
		    return false;
		  };
		  worldwide.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
		}

		exports.addGlobalErrorInstrumentationHandler = addGlobalErrorInstrumentationHandler;
		
	} (globalError));
	return globalError;
}

var globalUnhandledRejection = {};

var hasRequiredGlobalUnhandledRejection;

function requireGlobalUnhandledRejection () {
	if (hasRequiredGlobalUnhandledRejection) return globalUnhandledRejection;
	hasRequiredGlobalUnhandledRejection = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const worldwide = /*@__PURE__*/ requireWorldwide();
		const handlers = /*@__PURE__*/ requireHandlers$1();

		let _oldOnUnhandledRejectionHandler = null;
		function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
		  const type = "unhandledrejection";
		  handlers.addHandler(type, handler);
		  handlers.maybeInstrument(type, instrumentUnhandledRejection);
		}
		function instrumentUnhandledRejection() {
		  _oldOnUnhandledRejectionHandler = worldwide.GLOBAL_OBJ.onunhandledrejection;
		  worldwide.GLOBAL_OBJ.onunhandledrejection = function(e) {
		    const handlerData = e;
		    handlers.triggerHandlers("unhandledrejection", handlerData);
		    if (_oldOnUnhandledRejectionHandler) {
		      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
		    }
		    return true;
		  };
		  worldwide.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
		}

		exports.addGlobalUnhandledRejectionInstrumentationHandler = addGlobalUnhandledRejectionInstrumentationHandler;
		
	} (globalUnhandledRejection));
	return globalUnhandledRejection;
}

var spanUtils = {};

var asyncContext = {};

var stackStrategy = {};

var defaultScopes = {};

var scope = {};

var session = {};

var misc = {};

var object = {};

var is$1 = {};

var hasRequiredIs$1;

function requireIs$1 () {
	if (hasRequiredIs$1) return is$1;
	hasRequiredIs$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const objectToString = Object.prototype.toString;
		function isError(wat) {
		  switch (objectToString.call(wat)) {
		    case "[object Error]":
		    case "[object Exception]":
		    case "[object DOMException]":
		    case "[object WebAssembly.Exception]":
		      return true;
		    default:
		      return isInstanceOf(wat, Error);
		  }
		}
		function isBuiltin(wat, className) {
		  return objectToString.call(wat) === `[object ${className}]`;
		}
		function isErrorEvent(wat) {
		  return isBuiltin(wat, "ErrorEvent");
		}
		function isDOMError(wat) {
		  return isBuiltin(wat, "DOMError");
		}
		function isDOMException(wat) {
		  return isBuiltin(wat, "DOMException");
		}
		function isString(wat) {
		  return isBuiltin(wat, "String");
		}
		function isParameterizedString(wat) {
		  return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
		}
		function isPrimitive(wat) {
		  return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
		}
		function isPlainObject(wat) {
		  return isBuiltin(wat, "Object");
		}
		function isEvent(wat) {
		  return typeof Event !== "undefined" && isInstanceOf(wat, Event);
		}
		function isElement(wat) {
		  return typeof Element !== "undefined" && isInstanceOf(wat, Element);
		}
		function isRegExp(wat) {
		  return isBuiltin(wat, "RegExp");
		}
		function isThenable(wat) {
		  return Boolean(wat?.then && typeof wat.then === "function");
		}
		function isSyntheticEvent(wat) {
		  return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
		}
		function isInstanceOf(wat, base) {
		  try {
		    return wat instanceof base;
		  } catch {
		    return false;
		  }
		}
		function isVueViewModel(wat) {
		  return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
		}
		function isRequest(request) {
		  return typeof Request !== "undefined" && isInstanceOf(request, Request);
		}

		exports.isDOMError = isDOMError;
		exports.isDOMException = isDOMException;
		exports.isElement = isElement;
		exports.isError = isError;
		exports.isErrorEvent = isErrorEvent;
		exports.isEvent = isEvent;
		exports.isInstanceOf = isInstanceOf;
		exports.isParameterizedString = isParameterizedString;
		exports.isPlainObject = isPlainObject;
		exports.isPrimitive = isPrimitive;
		exports.isRegExp = isRegExp;
		exports.isRequest = isRequest;
		exports.isString = isString;
		exports.isSyntheticEvent = isSyntheticEvent;
		exports.isThenable = isThenable;
		exports.isVueViewModel = isVueViewModel;
		
	} (is$1));
	return is$1;
}

var hasRequiredObject;

function requireObject () {
	if (hasRequiredObject) return object;
	hasRequiredObject = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();

		function fill(source, name, replacementFactory) {
		  if (!(name in source)) {
		    return;
		  }
		  const original = source[name];
		  if (typeof original !== "function") {
		    return;
		  }
		  const wrapped = replacementFactory(original);
		  if (typeof wrapped === "function") {
		    markFunctionWrapped(wrapped, original);
		  }
		  try {
		    source[name] = wrapped;
		  } catch {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Failed to replace method "${name}" in object`, source);
		  }
		}
		function addNonEnumerableProperty(obj, name, value) {
		  try {
		    Object.defineProperty(obj, name, {
		      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
		      value,
		      writable: true,
		      configurable: true
		    });
		  } catch {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
		  }
		}
		function markFunctionWrapped(wrapped, original) {
		  try {
		    const proto = original.prototype || {};
		    wrapped.prototype = original.prototype = proto;
		    addNonEnumerableProperty(wrapped, "__sentry_original__", original);
		  } catch {
		  }
		}
		function wrapMethod(obj, field, wrapped, enumerable = true) {
		  const original = obj[field];
		  if (typeof original !== "function") {
		    throw new Error(`Cannot wrap method: ${field} is not a function`);
		  }
		  if (getOriginalFunction(original)) {
		    throw new Error(`Attempting to wrap method ${field} multiple times`);
		  }
		  markFunctionWrapped(wrapped, original);
		  Object.defineProperty(obj, field, {
		    writable: true,
		    configurable: true,
		    enumerable,
		    value: wrapped
		  });
		}
		function getOriginalFunction(func) {
		  return func.__sentry_original__;
		}
		function convertToPlainObject(value) {
		  if (is.isError(value)) {
		    return {
		      message: value.message,
		      name: value.name,
		      stack: value.stack,
		      ...getOwnProperties(value)
		    };
		  }
		  if (is.isEvent(value)) {
		    const { type, target, currentTarget, detail } = value;
		    return {
		      type,
		      target,
		      currentTarget,
		      ...detail ? { detail } : {},
		      ...getOwnProperties(value)
		    };
		  }
		  return value;
		}
		function getOwnProperties(obj) {
		  if (typeof obj === "object" && obj !== null) {
		    return Object.fromEntries(Object.entries(obj));
		  }
		  return {};
		}
		function extractExceptionKeysForMessage(exception) {
		  const keys = Object.keys(convertToPlainObject(exception));
		  keys.sort();
		  return !keys[0] ? "[object has no keys]" : keys.join(", ");
		}
		function dropUndefinedKeys(inputValue) {
		  const memoizationMap = /* @__PURE__ */ new Map();
		  return _dropUndefinedKeys(inputValue, memoizationMap);
		}
		function _dropUndefinedKeys(inputValue, memoizationMap) {
		  if (inputValue === null || typeof inputValue !== "object") {
		    return inputValue;
		  }
		  const memoVal = memoizationMap.get(inputValue);
		  if (memoVal !== void 0) {
		    return memoVal;
		  }
		  if (Array.isArray(inputValue)) {
		    const returnValue = [];
		    memoizationMap.set(inputValue, returnValue);
		    inputValue.forEach((value) => {
		      returnValue.push(_dropUndefinedKeys(value, memoizationMap));
		    });
		    return returnValue;
		  }
		  if (isPojo(inputValue)) {
		    const returnValue = {};
		    memoizationMap.set(inputValue, returnValue);
		    const keys = Object.keys(inputValue);
		    keys.forEach((key) => {
		      const val = inputValue[key];
		      if (val !== void 0) {
		        returnValue[key] = _dropUndefinedKeys(val, memoizationMap);
		      }
		    });
		    return returnValue;
		  }
		  return inputValue;
		}
		function isPojo(input) {
		  const constructor = input.constructor;
		  return constructor === Object || constructor === void 0;
		}
		function objectify(wat) {
		  let objectified;
		  switch (true) {
		    // this will catch both undefined and null
		    case wat == void 0:
		      objectified = new String(wat);
		      break;
		    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
		    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
		    // an object in order to wrap it.
		    case (typeof wat === "symbol" || typeof wat === "bigint"):
		      objectified = Object(wat);
		      break;
		    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
		    case is.isPrimitive(wat):
		      objectified = new wat.constructor(wat);
		      break;
		    // by process of elimination, at this point we know that `wat` must already be an object
		    default:
		      objectified = wat;
		      break;
		  }
		  return objectified;
		}

		exports.addNonEnumerableProperty = addNonEnumerableProperty;
		exports.convertToPlainObject = convertToPlainObject;
		exports.dropUndefinedKeys = dropUndefinedKeys;
		exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
		exports.fill = fill;
		exports.getOriginalFunction = getOriginalFunction;
		exports.markFunctionWrapped = markFunctionWrapped;
		exports.objectify = objectify;
		exports.wrapMethod = wrapMethod;
		
	} (object));
	return object;
}

var randomSafeContext = {};

var hasRequiredRandomSafeContext;

function requireRandomSafeContext () {
	if (hasRequiredRandomSafeContext) return randomSafeContext;
	hasRequiredRandomSafeContext = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const worldwide = /*@__PURE__*/ requireWorldwide();

		let RESOLVED_RUNNER;
		function withRandomSafeContext(cb) {
		  if (RESOLVED_RUNNER !== void 0) {
		    return RESOLVED_RUNNER ? RESOLVED_RUNNER(cb) : cb();
		  }
		  const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
		  const globalWithSymbol = worldwide.GLOBAL_OBJ;
		  if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
		    RESOLVED_RUNNER = globalWithSymbol[sym];
		    return RESOLVED_RUNNER(cb);
		  }
		  RESOLVED_RUNNER = null;
		  return cb();
		}
		function safeMathRandom() {
		  return withRandomSafeContext(() => Math.random());
		}
		function safeDateNow() {
		  return withRandomSafeContext(() => Date.now());
		}

		exports.safeDateNow = safeDateNow;
		exports.safeMathRandom = safeMathRandom;
		exports.withRandomSafeContext = withRandomSafeContext;
		
	} (randomSafeContext));
	return randomSafeContext;
}

var string = {};

var normalize = {};

var normalizationHints = {};

var hasRequiredNormalizationHints;

function requireNormalizationHints () {
	if (hasRequiredNormalizationHints) return normalizationHints;
	hasRequiredNormalizationHints = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const object = /*@__PURE__*/ requireObject();

		const SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
		const SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
		function setSkipNormalizationHint(obj) {
		  object.addNonEnumerableProperty(obj, SENTRY_SKIP_NORMALIZATION, true);
		}
		function setNormalizationDepthOverrideHint(obj, depth) {
		  object.addNonEnumerableProperty(obj, SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
		}
		function hasSkipNormalizationHint(value) {
		  return Boolean(value[SENTRY_SKIP_NORMALIZATION]);
		}
		function getNormalizationDepthOverrideHint(value) {
		  const v = value[SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
		  return typeof v === "number" ? v : void 0;
		}

		exports.getNormalizationDepthOverrideHint = getNormalizationDepthOverrideHint;
		exports.hasSkipNormalizationHint = hasSkipNormalizationHint;
		exports.setNormalizationDepthOverrideHint = setNormalizationDepthOverrideHint;
		exports.setSkipNormalizationHint = setSkipNormalizationHint;
		
	} (normalizationHints));
	return normalizationHints;
}

var hasRequiredNormalize;

function requireNormalize () {
	if (hasRequiredNormalize) return normalize;
	hasRequiredNormalize = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const normalizationHints = /*@__PURE__*/ requireNormalizationHints();
		const object = /*@__PURE__*/ requireObject();
		const stacktrace = /*@__PURE__*/ requireStacktrace();

		let stringifier;
		function setNormalizeStringifier(newStringifier) {
		  stringifier = newStringifier;
		}
		function normalize(input, depth = 100, maxProperties = Infinity) {
		  try {
		    return visit("", input, depth, maxProperties);
		  } catch (err) {
		    return { ERROR: `**non-serializable** (${err})` };
		  }
		}
		function normalizeToSize(object, depth = 3, maxSize = 100 * 1024) {
		  const normalized = normalize(object, depth);
		  if (jsonSize(normalized) > maxSize) {
		    return normalizeToSize(object, depth - 1, maxSize);
		  }
		  return normalized;
		}
		function visit(key, value, depth = Infinity, maxProperties = Infinity, memo = memoBuilder()) {
		  const [memoize, unmemoize] = memo;
		  if (value == null || // this matches null and undefined -> eqeq not eqeqeq
		  ["boolean", "string"].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) {
		    return value;
		  }
		  const stringified = stringifyValue(key, value);
		  if (!stringified.startsWith("[object ")) {
		    return stringified;
		  }
		  if (normalizationHints.hasSkipNormalizationHint(value)) {
		    return value;
		  }
		  const overrideDepth = normalizationHints.getNormalizationDepthOverrideHint(value);
		  const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
		  if (remainingDepth === 0) {
		    return stringified.replace("object ", "");
		  }
		  if (memoize(value)) {
		    return "[Circular ~]";
		  }
		  const valueWithToJSON = value;
		  if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
		    try {
		      const jsonValue = valueWithToJSON.toJSON();
		      return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
		    } catch {
		    }
		  }
		  const normalized = Array.isArray(value) ? [] : {};
		  let numAdded = 0;
		  const visitable = object.convertToPlainObject(value);
		  for (const visitKey in visitable) {
		    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
		      continue;
		    }
		    if (numAdded >= maxProperties) {
		      normalized[visitKey] = "[MaxProperties ~]";
		      break;
		    }
		    const visitValue = visitable[visitKey];
		    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
		    numAdded++;
		  }
		  unmemoize(value);
		  return normalized;
		}
		function stringifyValue(key, value) {
		  try {
		    if (stringifier) {
		      const stringified = stringifier(value);
		      if (stringified) {
		        return stringified;
		      }
		    }
		    if (typeof commonjsGlobal !== "undefined" && value === commonjsGlobal) {
		      return "[Global]";
		    }
		    if (typeof value === "number" && !Number.isFinite(value)) {
		      return `[${value}]`;
		    }
		    if (typeof value === "function") {
		      return `[Function: ${stacktrace.getFunctionName(value)}]`;
		    }
		    if (typeof value === "symbol") {
		      return `[${String(value)}]`;
		    }
		    if (typeof value === "bigint") {
		      return `[BigInt: ${String(value)}]`;
		    }
		    const objName = getConstructorName(value);
		    return `[object ${objName}]`;
		  } catch (err) {
		    return `**non-serializable** (${err})`;
		  }
		}
		function getConstructorName(value) {
		  const prototype = Object.getPrototypeOf(value);
		  return prototype?.constructor ? prototype.constructor.name : "null prototype";
		}
		function utf8Length(value) {
		  return ~-encodeURI(value).split(/%..|./).length;
		}
		function jsonSize(value) {
		  return utf8Length(JSON.stringify(value));
		}
		function normalizeUrlToBase(url, basePath) {
		  const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
		  let newUrl = url;
		  try {
		    newUrl = decodeURI(url);
		  } catch {
		  }
		  return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
		}
		function memoBuilder() {
		  const inner = /* @__PURE__ */ new WeakSet();
		  function memoize(obj) {
		    if (inner.has(obj)) {
		      return true;
		    }
		    inner.add(obj);
		    return false;
		  }
		  function unmemoize(obj) {
		    inner.delete(obj);
		  }
		  return [memoize, unmemoize];
		}

		exports.normalize = normalize;
		exports.normalizeToSize = normalizeToSize;
		exports.normalizeUrlToBase = normalizeUrlToBase;
		exports.setNormalizeStringifier = setNormalizeStringifier;
		exports.stringifyValue = stringifyValue;
		
	} (normalize));
	return normalize;
}

var hasRequiredString;

function requireString () {
	if (hasRequiredString) return string;
	hasRequiredString = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const is = /*@__PURE__*/ requireIs$1();
		const normalize = /*@__PURE__*/ requireNormalize();

		function truncate(str, max = 0) {
		  if (typeof str !== "string" || max === 0) {
		    return str;
		  }
		  return str.length <= max ? str : `${str.slice(0, max)}...`;
		}
		function snipLine(line, colno) {
		  let newLine = line;
		  const lineLength = newLine.length;
		  if (lineLength <= 150) {
		    return newLine;
		  }
		  if (colno > lineLength) {
		    colno = lineLength;
		  }
		  let start = Math.max(colno - 60, 0);
		  if (start < 5) {
		    start = 0;
		  }
		  let end = Math.min(start + 140, lineLength);
		  if (end > lineLength - 5) {
		    end = lineLength;
		  }
		  if (end === lineLength) {
		    start = Math.max(end - 140, 0);
		  }
		  newLine = newLine.slice(start, end);
		  if (start > 0) {
		    newLine = `'{snip} ${newLine}`;
		  }
		  if (end < lineLength) {
		    newLine += " {snip}";
		  }
		  return newLine;
		}
		function safeJoin(input, delimiter) {
		  if (!Array.isArray(input)) {
		    return "";
		  }
		  const output = [];
		  for (let i = 0; i < input.length; i++) {
		    const value = input[i];
		    if (is.isPrimitive(value)) {
		      output.push(String(value));
		    } else if (value instanceof Error) {
		      output.push(value.message ? `${value.name}: ${value.message}` : value.name);
		    } else {
		      output.push(normalize.stringifyValue(void 0, value));
		    }
		  }
		  return output.join(delimiter);
		}
		function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
		  if (!is.isString(value)) {
		    return false;
		  }
		  if (is.isRegExp(pattern)) {
		    return pattern.test(value);
		  }
		  if (is.isString(pattern)) {
		    return requireExactStringMatch ? value === pattern : value.includes(pattern);
		  }
		  if (typeof pattern === "function") {
		    return pattern(value);
		  }
		  return false;
		}
		function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
		  for (const pattern of patterns) {
		    if (isMatchingPattern(testString, pattern, requireExactStringMatch)) {
		      return true;
		    }
		  }
		  return false;
		}

		exports.isMatchingPattern = isMatchingPattern;
		exports.safeJoin = safeJoin;
		exports.snipLine = snipLine;
		exports.stringMatchesSomePattern = stringMatchesSomePattern;
		exports.truncate = truncate;
		
	} (string));
	return string;
}

var hasRequiredMisc;

function requireMisc () {
	if (hasRequiredMisc) return misc;
	hasRequiredMisc = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const object = /*@__PURE__*/ requireObject();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const string = /*@__PURE__*/ requireString();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		function getCrypto() {
		  const gbl = worldwide.GLOBAL_OBJ;
		  return gbl.crypto || gbl.msCrypto;
		}
		let emptyUuid;
		function getRandomByte() {
		  return randomSafeContext.safeMathRandom() * 16;
		}
		function uuid4(crypto = getCrypto()) {
		  try {
		    if (crypto?.randomUUID) {
		      return randomSafeContext.withRandomSafeContext(() => crypto.randomUUID()).replace(/-/g, "");
		    }
		  } catch {
		  }
		  if (!emptyUuid) {
		    emptyUuid = "10000000100040008000" + 1e11;
		  }
		  return emptyUuid.replace(
		    /[018]/g,
		    (c) => (
		      // eslint-disable-next-line no-bitwise
		      (c ^ (getRandomByte() & 15) >> c / 4).toString(16)
		    )
		  );
		}
		function getFirstException(event) {
		  return event.exception?.values?.[0];
		}
		function getEventDescription(event) {
		  const { message, event_id: eventId } = event;
		  if (message) {
		    return message;
		  }
		  const firstException = getFirstException(event);
		  if (firstException) {
		    if (firstException.type && firstException.value) {
		      return `${firstException.type}: ${firstException.value}`;
		    }
		    return firstException.type || firstException.value || eventId || "<unknown>";
		  }
		  return eventId || "<unknown>";
		}
		function addExceptionTypeValue(event, value, type) {
		  const exception = event.exception = event.exception || {};
		  const values = exception.values = exception.values || [];
		  const firstException = values[0] = values[0] || {};
		  if (!firstException.value) {
		    firstException.value = value || "";
		  }
		  if (!firstException.type) {
		    firstException.type = type || "Error";
		  }
		}
		function addExceptionMechanism(event, newMechanism) {
		  const firstException = getFirstException(event);
		  if (!firstException) {
		    return;
		  }
		  const defaultMechanism = { type: "generic", handled: true };
		  const currentMechanism = firstException.mechanism;
		  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };
		  if (newMechanism && "data" in newMechanism) {
		    const mergedData = { ...currentMechanism?.data, ...newMechanism.data };
		    firstException.mechanism.data = mergedData;
		  }
		}
		const SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
		function _parseInt(input) {
		  return parseInt(input || "", 10);
		}
		function parseSemver(input) {
		  const match = input.match(SEMVER_REGEXP) || [];
		  const major = _parseInt(match[1]);
		  const minor = _parseInt(match[2]);
		  const patch = _parseInt(match[3]);
		  return {
		    buildmetadata: match[5],
		    major: isNaN(major) ? void 0 : major,
		    minor: isNaN(minor) ? void 0 : minor,
		    patch: isNaN(patch) ? void 0 : patch,
		    prerelease: match[4]
		  };
		}
		function addContextToFrame(lines, frame, linesOfContext = 5) {
		  if (frame.lineno === void 0) {
		    return;
		  }
		  const maxLines = lines.length;
		  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
		  frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line) => string.snipLine(line, 0));
		  const lineIndex = Math.min(maxLines - 1, sourceLine);
		  frame.context_line = string.snipLine(lines[lineIndex], frame.colno || 0);
		  frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line) => string.snipLine(line, 0));
		}
		function checkOrSetAlreadyCaught(exception) {
		  if (isAlreadyCaptured(exception)) {
		    return true;
		  }
		  try {
		    object.addNonEnumerableProperty(exception, "__sentry_captured__", true);
		  } catch {
		  }
		  return false;
		}
		function isAlreadyCaptured(exception) {
		  try {
		    return exception.__sentry_captured__;
		  } catch {
		  }
		}

		exports.addContextToFrame = addContextToFrame;
		exports.addExceptionMechanism = addExceptionMechanism;
		exports.addExceptionTypeValue = addExceptionTypeValue;
		exports.checkOrSetAlreadyCaught = checkOrSetAlreadyCaught;
		exports.getEventDescription = getEventDescription;
		exports.isAlreadyCaptured = isAlreadyCaptured;
		exports.parseSemver = parseSemver;
		exports.uuid4 = uuid4;
		
	} (misc));
	return misc;
}

var time = {};

var hasRequiredTime;

function requireTime () {
	if (hasRequiredTime) return time;
	hasRequiredTime = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const ONE_SECOND_IN_MS = 1e3;
		function dateTimestampInSeconds() {
		  return randomSafeContext.safeDateNow() / ONE_SECOND_IN_MS;
		}
		function createUnixTimestampInSecondsFunc() {
		  const { performance } = worldwide.GLOBAL_OBJ;
		  if (!performance?.now || !performance.timeOrigin) {
		    return dateTimestampInSeconds;
		  }
		  const timeOrigin = performance.timeOrigin;
		  return () => {
		    return (timeOrigin + randomSafeContext.withRandomSafeContext(() => performance.now())) / ONE_SECOND_IN_MS;
		  };
		}
		let _cachedTimestampInSeconds;
		function timestampInSeconds() {
		  const func = _cachedTimestampInSeconds ?? (_cachedTimestampInSeconds = createUnixTimestampInSecondsFunc());
		  return func();
		}
		let cachedTimeOrigin = null;
		function getBrowserTimeOrigin() {
		  const { performance } = worldwide.GLOBAL_OBJ;
		  if (!performance?.now) {
		    return void 0;
		  }
		  const threshold = 3e5;
		  const performanceNow = randomSafeContext.withRandomSafeContext(() => performance.now());
		  const dateNow = randomSafeContext.safeDateNow();
		  const timeOrigin = performance.timeOrigin;
		  if (typeof timeOrigin === "number") {
		    const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
		    if (timeOriginDelta < threshold) {
		      return timeOrigin;
		    }
		  }
		  const navigationStart = performance.timing?.navigationStart;
		  if (typeof navigationStart === "number") {
		    const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
		    if (navigationStartDelta < threshold) {
		      return navigationStart;
		    }
		  }
		  return dateNow - performanceNow;
		}
		function browserPerformanceTimeOrigin() {
		  if (cachedTimeOrigin === null) {
		    cachedTimeOrigin = getBrowserTimeOrigin();
		  }
		  return cachedTimeOrigin;
		}

		exports.browserPerformanceTimeOrigin = browserPerformanceTimeOrigin;
		exports.dateTimestampInSeconds = dateTimestampInSeconds;
		exports.timestampInSeconds = timestampInSeconds;
		
	} (time));
	return time;
}

var hasRequiredSession;

function requireSession () {
	if (hasRequiredSession) return session;
	hasRequiredSession = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const misc = /*@__PURE__*/ requireMisc();
		const time = /*@__PURE__*/ requireTime();

		function makeSession(context) {
		  const startingTime = time.timestampInSeconds();
		  const session = {
		    sid: misc.uuid4(),
		    init: true,
		    timestamp: startingTime,
		    started: startingTime,
		    duration: 0,
		    status: "ok",
		    errors: 0,
		    ignoreDuration: false,
		    toJSON: () => sessionToJSON(session)
		  };
		  if (context) {
		    updateSession(session, context);
		  }
		  return session;
		}
		function updateSession(session, context = {}) {
		  if (context.user) {
		    if (!session.ipAddress && context.user.ip_address) {
		      session.ipAddress = context.user.ip_address;
		    }
		    if (!session.did && !context.did) {
		      session.did = context.user.id || context.user.email || context.user.username;
		    }
		  }
		  session.timestamp = context.timestamp || time.timestampInSeconds();
		  if (context.abnormal_mechanism) {
		    session.abnormal_mechanism = context.abnormal_mechanism;
		  }
		  if (context.ignoreDuration) {
		    session.ignoreDuration = context.ignoreDuration;
		  }
		  if (context.sid) {
		    session.sid = context.sid.length === 32 ? context.sid : misc.uuid4();
		  }
		  if (context.init !== void 0) {
		    session.init = context.init;
		  }
		  if (!session.did && context.did) {
		    session.did = `${context.did}`;
		  }
		  if (typeof context.started === "number") {
		    session.started = context.started;
		  }
		  if (session.ignoreDuration) {
		    session.duration = void 0;
		  } else if (typeof context.duration === "number") {
		    session.duration = context.duration;
		  } else {
		    const duration = session.timestamp - session.started;
		    session.duration = duration >= 0 ? duration : 0;
		  }
		  if (context.release) {
		    session.release = context.release;
		  }
		  if (context.environment) {
		    session.environment = context.environment;
		  }
		  if (!session.ipAddress && context.ipAddress) {
		    session.ipAddress = context.ipAddress;
		  }
		  if (!session.userAgent && context.userAgent) {
		    session.userAgent = context.userAgent;
		  }
		  if (typeof context.errors === "number") {
		    session.errors = context.errors;
		  }
		  if (context.status) {
		    session.status = context.status;
		  }
		}
		function closeSession(session, status) {
		  let context = {};
		  if (status) {
		    context = { status };
		  } else if (session.status === "ok") {
		    context = { status: "exited" };
		  }
		  updateSession(session, context);
		}
		function sessionToJSON(session) {
		  return {
		    sid: `${session.sid}`,
		    init: session.init,
		    // Make sure that sec is converted to ms for date constructor
		    started: new Date(session.started * 1e3).toISOString(),
		    timestamp: new Date(session.timestamp * 1e3).toISOString(),
		    status: session.status,
		    errors: session.errors,
		    did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
		    duration: session.duration,
		    abnormal_mechanism: session.abnormal_mechanism,
		    attrs: {
		      release: session.release,
		      environment: session.environment,
		      ip_address: session.ipAddress,
		      user_agent: session.userAgent
		    }
		  };
		}

		exports.closeSession = closeSession;
		exports.makeSession = makeSession;
		exports.updateSession = updateSession;
		
	} (session));
	return session;
}

var merge = {};

var hasRequiredMerge;

function requireMerge () {
	if (hasRequiredMerge) return merge;
	hasRequiredMerge = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function merge(initialObj, mergeObj, levels = 2) {
		  if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) {
		    return mergeObj;
		  }
		  if (initialObj && Object.keys(mergeObj).length === 0) {
		    return initialObj;
		  }
		  const output = { ...initialObj };
		  for (const key in mergeObj) {
		    if (Object.prototype.hasOwnProperty.call(mergeObj, key)) {
		      output[key] = merge(output[key], mergeObj[key], levels - 1);
		    }
		  }
		  return output;
		}

		exports.merge = merge;
		
	} (merge));
	return merge;
}

var propagationContext = {};

var hasRequiredPropagationContext;

function requirePropagationContext () {
	if (hasRequiredPropagationContext) return propagationContext;
	hasRequiredPropagationContext = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const misc = /*@__PURE__*/ requireMisc();

		function generateTraceId() {
		  return misc.uuid4();
		}
		function generateSpanId() {
		  return misc.uuid4().substring(16);
		}

		exports.generateSpanId = generateSpanId;
		exports.generateTraceId = generateTraceId;
		
	} (propagationContext));
	return propagationContext;
}

var spanOnScope = {};

var weakRef = {};

var hasRequiredWeakRef;

function requireWeakRef () {
	if (hasRequiredWeakRef) return weakRef;
	hasRequiredWeakRef = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const worldwide = /*@__PURE__*/ requireWorldwide();

		function makeWeakRef(value) {
		  try {
		    const WeakRefImpl = worldwide.GLOBAL_OBJ.WeakRef;
		    if (typeof WeakRefImpl === "function") {
		      return new WeakRefImpl(value);
		    }
		  } catch {
		  }
		  return value;
		}
		function derefWeakRef(ref) {
		  if (!ref) {
		    return void 0;
		  }
		  if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") {
		    try {
		      return ref.deref();
		    } catch {
		      return void 0;
		    }
		  }
		  return ref;
		}

		exports.derefWeakRef = derefWeakRef;
		exports.makeWeakRef = makeWeakRef;
		
	} (weakRef));
	return weakRef;
}

var hasRequiredSpanOnScope;

function requireSpanOnScope () {
	if (hasRequiredSpanOnScope) return spanOnScope;
	hasRequiredSpanOnScope = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const object = /*@__PURE__*/ requireObject();
		const weakRef = /*@__PURE__*/ requireWeakRef();

		const SCOPE_SPAN_FIELD = "_sentrySpan";
		function _setSpanForScope(scope, span) {
		  if (span) {
		    object.addNonEnumerableProperty(scope, SCOPE_SPAN_FIELD, weakRef.makeWeakRef(span));
		  } else {
		    delete scope[SCOPE_SPAN_FIELD];
		  }
		}
		function _getSpanForScope(scope) {
		  return weakRef.derefWeakRef(scope[SCOPE_SPAN_FIELD]);
		}

		exports._getSpanForScope = _getSpanForScope;
		exports._setSpanForScope = _setSpanForScope;
		
	} (spanOnScope));
	return spanOnScope;
}

var hasRequiredScope;

function requireScope () {
	if (hasRequiredScope) return scope;
	hasRequiredScope = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const session = /*@__PURE__*/ requireSession();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();
		const merge = /*@__PURE__*/ requireMerge();
		const misc = /*@__PURE__*/ requireMisc();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();
		const string = /*@__PURE__*/ requireString();
		const time = /*@__PURE__*/ requireTime();

		const DEFAULT_MAX_BREADCRUMBS = 100;
		class Scope {
		  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
		  constructor() {
		    this._notifyingListeners = false;
		    this._scopeListeners = [];
		    this._eventProcessors = [];
		    this._breadcrumbs = [];
		    this._attachments = [];
		    this._user = {};
		    this._tags = {};
		    this._attributes = {};
		    this._extra = {};
		    this._contexts = {};
		    this._sdkProcessingMetadata = {};
		    this._propagationContext = {
		      traceId: propagationContext.generateTraceId(),
		      sampleRand: randomSafeContext.safeMathRandom()
		    };
		  }
		  /**
		   * Clone all data from this scope into a new scope.
		   */
		  clone() {
		    const newScope = new Scope();
		    newScope._breadcrumbs = [...this._breadcrumbs];
		    newScope._tags = { ...this._tags };
		    newScope._attributes = { ...this._attributes };
		    newScope._extra = { ...this._extra };
		    newScope._contexts = { ...this._contexts };
		    if (this._contexts.flags) {
		      newScope._contexts.flags = {
		        values: [...this._contexts.flags.values]
		      };
		    }
		    newScope._user = this._user;
		    newScope._level = this._level;
		    newScope._session = this._session;
		    newScope._transactionName = this._transactionName;
		    newScope._fingerprint = this._fingerprint;
		    newScope._eventProcessors = [...this._eventProcessors];
		    newScope._attachments = [...this._attachments];
		    newScope._sdkProcessingMetadata = { ...this._sdkProcessingMetadata };
		    newScope._propagationContext = { ...this._propagationContext };
		    newScope._client = this._client;
		    newScope._lastEventId = this._lastEventId;
		    newScope._conversationId = this._conversationId;
		    spanOnScope._setSpanForScope(newScope, spanOnScope._getSpanForScope(this));
		    return newScope;
		  }
		  /**
		   * Update the client assigned to this scope.
		   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
		   * as well as manually created scopes.
		   */
		  setClient(client) {
		    this._client = client;
		  }
		  /**
		   * Set the ID of the last captured error event.
		   * This is generally only captured on the isolation scope.
		   */
		  setLastEventId(lastEventId) {
		    this._lastEventId = lastEventId;
		  }
		  /**
		   * Get the client assigned to this scope.
		   */
		  getClient() {
		    return this._client;
		  }
		  /**
		   * Get the ID of the last captured error event.
		   * This is generally only available on the isolation scope.
		   */
		  lastEventId() {
		    return this._lastEventId;
		  }
		  /**
		   * @inheritDoc
		   */
		  addScopeListener(callback) {
		    this._scopeListeners.push(callback);
		  }
		  /**
		   * Add an event processor that will be called before an event is sent.
		   */
		  addEventProcessor(callback) {
		    this._eventProcessors.push(callback);
		    return this;
		  }
		  /**
		   * Set the user for this scope.
		   * Set to `null` to unset the user.
		   */
		  setUser(user) {
		    this._user = user || {
		      email: void 0,
		      id: void 0,
		      ip_address: void 0,
		      username: void 0
		    };
		    if (this._session) {
		      session.updateSession(this._session, { user });
		    }
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Get the user from this scope.
		   */
		  getUser() {
		    return this._user;
		  }
		  /**
		   * Set the conversation ID for this scope.
		   * Set to `null` to unset the conversation ID.
		   */
		  setConversationId(conversationId) {
		    this._conversationId = conversationId || void 0;
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Set an object that will be merged into existing tags on the scope,
		   * and will be sent as tags data with the event.
		   */
		  setTags(tags) {
		    this._tags = {
		      ...this._tags,
		      ...tags
		    };
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Set a single tag that will be sent as tags data with the event.
		   */
		  setTag(key, value) {
		    return this.setTags({ [key]: value });
		  }
		  /**
		   * Sets attributes onto the scope.
		   *
		   * These attributes are currently applied to logs and metrics.
		   * In the future, they will also be applied to spans.
		   *
		   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
		   * more complex attribute types. We'll add this support in the future but already specify the wider type to
		   * avoid a breaking change in the future.
		   *
		   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
		   * an object with a `value` and an optional `unit` (if applicable to your attribute).
		   *
		   * @example
		   * ```typescript
		   * scope.setAttributes({
		   *   is_admin: true,
		   *   payment_selection: 'credit_card',
		   *   render_duration: { value: 'render_duration', unit: 'ms' },
		   * });
		   * ```
		   */
		  setAttributes(newAttributes) {
		    this._attributes = {
		      ...this._attributes,
		      ...newAttributes
		    };
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Sets an attribute onto the scope.
		   *
		   * These attributes are currently applied to logs and metrics.
		   * In the future, they will also be applied to spans.
		   *
		   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
		   * more complex attribute types. We'll add this support in the future but already specify the wider type to
		   * avoid a breaking change in the future.
		   *
		   * @param key - The attribute key.
		   * @param value - the attribute value. You can either pass in a raw value, or an attribute
		   * object with a `value` and an optional `unit` (if applicable to your attribute).
		   *
		   * @example
		   * ```typescript
		   * scope.setAttribute('is_admin', true);
		   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
		   * ```
		   */
		  // eslint-disable-next-line @typescript-eslint/no-explicit-any
		  setAttribute(key, value) {
		    return this.setAttributes({ [key]: value });
		  }
		  /**
		   * Removes the attribute with the given key from the scope.
		   *
		   * @param key - The attribute key.
		   *
		   * @example
		   * ```typescript
		   * scope.removeAttribute('is_admin');
		   * ```
		   */
		  removeAttribute(key) {
		    if (key in this._attributes) {
		      delete this._attributes[key];
		      this._notifyScopeListeners();
		    }
		    return this;
		  }
		  /**
		   * Set an object that will be merged into existing extra on the scope,
		   * and will be sent as extra data with the event.
		   */
		  setExtras(extras) {
		    this._extra = {
		      ...this._extra,
		      ...extras
		    };
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Set a single key:value extra entry that will be sent as extra data with the event.
		   */
		  setExtra(key, extra) {
		    this._extra = { ...this._extra, [key]: extra };
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Sets the fingerprint on the scope to send with the events.
		   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
		   */
		  setFingerprint(fingerprint) {
		    this._fingerprint = fingerprint;
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Sets the level on the scope for future events.
		   */
		  setLevel(level) {
		    this._level = level;
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Sets the transaction name on the scope so that the name of e.g. taken server route or
		   * the page location is attached to future events.
		   *
		   * IMPORTANT: Calling this function does NOT change the name of the currently active
		   * root span. If you want to change the name of the active root span, use
		   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
		   *
		   * By default, the SDK updates the scope's transaction name automatically on sensible
		   * occasions, such as a page navigation or when handling a new request on the server.
		   */
		  setTransactionName(name) {
		    this._transactionName = name;
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Sets context data with the given name.
		   * Data passed as context will be normalized. You can also pass `null` to unset the context.
		   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
		   */
		  setContext(key, context) {
		    if (context === null) {
		      delete this._contexts[key];
		    } else {
		      this._contexts[key] = context;
		    }
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Set the session for the scope.
		   */
		  setSession(session) {
		    if (!session) {
		      delete this._session;
		    } else {
		      this._session = session;
		    }
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Get the session from the scope.
		   */
		  getSession() {
		    return this._session;
		  }
		  /**
		   * Updates the scope with provided data. Can work in three variations:
		   * - plain object containing updatable attributes
		   * - Scope instance that'll extract the attributes from
		   * - callback function that'll receive the current scope as an argument and allow for modifications
		   */
		  update(captureContext) {
		    if (!captureContext) {
		      return this;
		    }
		    const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
		    const scopeInstance = scopeToMerge instanceof Scope ? scopeToMerge.getScopeData() : is.isPlainObject(scopeToMerge) ? captureContext : void 0;
		    const {
		      tags,
		      attributes,
		      extra,
		      user,
		      contexts,
		      level,
		      fingerprint = [],
		      propagationContext,
		      conversationId
		    } = scopeInstance || {};
		    this._tags = { ...this._tags, ...tags };
		    this._attributes = { ...this._attributes, ...attributes };
		    this._extra = { ...this._extra, ...extra };
		    this._contexts = { ...this._contexts, ...contexts };
		    if (user && Object.keys(user).length) {
		      this._user = user;
		    }
		    if (level) {
		      this._level = level;
		    }
		    if (fingerprint.length) {
		      this._fingerprint = fingerprint;
		    }
		    if (propagationContext) {
		      this._propagationContext = propagationContext;
		    }
		    if (conversationId) {
		      this._conversationId = conversationId;
		    }
		    return this;
		  }
		  /**
		   * Clears the current scope and resets its properties.
		   * Note: The client will not be cleared.
		   */
		  clear() {
		    this._breadcrumbs = [];
		    this._tags = {};
		    this._attributes = {};
		    this._extra = {};
		    this._user = {};
		    this._contexts = {};
		    this._level = void 0;
		    this._transactionName = void 0;
		    this._fingerprint = void 0;
		    this._session = void 0;
		    this._conversationId = void 0;
		    spanOnScope._setSpanForScope(this, void 0);
		    this._attachments = [];
		    this.setPropagationContext({
		      traceId: propagationContext.generateTraceId(),
		      sampleRand: randomSafeContext.safeMathRandom()
		    });
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Adds a breadcrumb to the scope.
		   * By default, the last 100 breadcrumbs are kept.
		   */
		  addBreadcrumb(breadcrumb, maxBreadcrumbs) {
		    const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
		    if (maxCrumbs <= 0) {
		      return this;
		    }
		    const mergedBreadcrumb = {
		      timestamp: time.dateTimestampInSeconds(),
		      ...breadcrumb,
		      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
		      message: breadcrumb.message ? string.truncate(breadcrumb.message, 2048) : breadcrumb.message
		    };
		    this._breadcrumbs.push(mergedBreadcrumb);
		    if (this._breadcrumbs.length > maxCrumbs) {
		      this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
		      this._client?.recordDroppedEvent("buffer_overflow", "log_item");
		    }
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Get the last breadcrumb of the scope.
		   */
		  getLastBreadcrumb() {
		    return this._breadcrumbs[this._breadcrumbs.length - 1];
		  }
		  /**
		   * Clear all breadcrumbs from the scope.
		   */
		  clearBreadcrumbs() {
		    this._breadcrumbs = [];
		    this._notifyScopeListeners();
		    return this;
		  }
		  /**
		   * Add an attachment to the scope.
		   */
		  addAttachment(attachment) {
		    this._attachments.push(attachment);
		    return this;
		  }
		  /**
		   * Clear all attachments from the scope.
		   */
		  clearAttachments() {
		    this._attachments = [];
		    return this;
		  }
		  /**
		   * Get the data of this scope, which should be applied to an event during processing.
		   */
		  getScopeData() {
		    return {
		      breadcrumbs: this._breadcrumbs,
		      attachments: this._attachments,
		      contexts: this._contexts,
		      tags: this._tags,
		      attributes: this._attributes,
		      extra: this._extra,
		      user: this._user,
		      level: this._level,
		      fingerprint: this._fingerprint || [],
		      eventProcessors: this._eventProcessors,
		      propagationContext: this._propagationContext,
		      sdkProcessingMetadata: this._sdkProcessingMetadata,
		      transactionName: this._transactionName,
		      span: spanOnScope._getSpanForScope(this),
		      conversationId: this._conversationId
		    };
		  }
		  /**
		   * Add data which will be accessible during event processing but won't get sent to Sentry.
		   */
		  setSDKProcessingMetadata(newData) {
		    this._sdkProcessingMetadata = merge.merge(this._sdkProcessingMetadata, newData, 2);
		    return this;
		  }
		  /**
		   * Add propagation context to the scope, used for distributed tracing
		   */
		  setPropagationContext(context) {
		    this._propagationContext = context;
		    return this;
		  }
		  /**
		   * Get propagation context from the scope, used for distributed tracing
		   */
		  getPropagationContext() {
		    return this._propagationContext;
		  }
		  /**
		   * Capture an exception for this scope.
		   *
		   * @returns {string} The id of the captured Sentry event.
		   */
		  captureException(exception, hint) {
		    const eventId = hint?.event_id || misc.uuid4();
		    if (!this._client) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No client configured on scope - will not capture exception!");
		      return eventId;
		    }
		    const syntheticException = new Error("Sentry syntheticException");
		    this._client.captureException(
		      exception,
		      {
		        originalException: exception,
		        syntheticException,
		        ...hint,
		        event_id: eventId
		      },
		      this
		    );
		    return eventId;
		  }
		  /**
		   * Capture a message for this scope.
		   *
		   * @returns {string} The id of the captured message.
		   */
		  captureMessage(message, level, hint) {
		    const eventId = hint?.event_id || misc.uuid4();
		    if (!this._client) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No client configured on scope - will not capture message!");
		      return eventId;
		    }
		    const syntheticException = hint?.syntheticException ?? new Error(message);
		    this._client.captureMessage(
		      message,
		      level,
		      {
		        originalException: message,
		        syntheticException,
		        ...hint,
		        event_id: eventId
		      },
		      this
		    );
		    return eventId;
		  }
		  /**
		   * Capture a Sentry event for this scope.
		   *
		   * @returns {string} The id of the captured event.
		   */
		  captureEvent(event, hint) {
		    const eventId = event.event_id || hint?.event_id || misc.uuid4();
		    if (!this._client) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No client configured on scope - will not capture event!");
		      return eventId;
		    }
		    this._client.captureEvent(event, { ...hint, event_id: eventId }, this);
		    return eventId;
		  }
		  /**
		   * This will be called on every set call.
		   */
		  _notifyScopeListeners() {
		    if (!this._notifyingListeners) {
		      this._notifyingListeners = true;
		      this._scopeListeners.forEach((callback) => {
		        callback(this);
		      });
		      this._notifyingListeners = false;
		    }
		  }
		}

		exports.Scope = Scope;
		
	} (scope));
	return scope;
}

var hasRequiredDefaultScopes;

function requireDefaultScopes () {
	if (hasRequiredDefaultScopes) return defaultScopes;
	hasRequiredDefaultScopes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const carrier = /*@__PURE__*/ requireCarrier();
		const scope = /*@__PURE__*/ requireScope();

		function getDefaultCurrentScope() {
		  return carrier.getGlobalSingleton("defaultCurrentScope", () => new scope.Scope());
		}
		function getDefaultIsolationScope() {
		  return carrier.getGlobalSingleton("defaultIsolationScope", () => new scope.Scope());
		}

		exports.getDefaultCurrentScope = getDefaultCurrentScope;
		exports.getDefaultIsolationScope = getDefaultIsolationScope;
		
	} (defaultScopes));
	return defaultScopes;
}

var chainAndCopyPromiselike = {};

var hasRequiredChainAndCopyPromiselike;

function requireChainAndCopyPromiselike () {
	if (hasRequiredChainAndCopyPromiselike) return chainAndCopyPromiselike;
	hasRequiredChainAndCopyPromiselike = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const isActualPromise = (p) => p instanceof Promise && !p[kChainedCopy];
		const kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
		const chainAndCopyPromiseLike = (original, onSuccess, onError) => {
		  const chained = original.then(
		    (value) => {
		      onSuccess(value);
		      return value;
		    },
		    (err) => {
		      onError(err);
		      throw err;
		    }
		  );
		  return isActualPromise(chained) && isActualPromise(original) ? chained : copyProps(original, chained);
		};
		const copyProps = (original, chained) => {
		  if (!chained) return original;
		  let mutated = false;
		  for (const key in original) {
		    if (key in chained) continue;
		    mutated = true;
		    const value = original[key];
		    if (typeof value === "function") {
		      Object.defineProperty(chained, key, {
		        value: (...args) => value.apply(original, args),
		        enumerable: true,
		        configurable: true,
		        writable: true
		      });
		    } else {
		      chained[key] = value;
		    }
		  }
		  if (mutated) Object.assign(chained, { [kChainedCopy]: true });
		  return chained;
		};

		exports.chainAndCopyPromiseLike = chainAndCopyPromiseLike;
		
	} (chainAndCopyPromiselike));
	return chainAndCopyPromiselike;
}

var hasRequiredStackStrategy;

function requireStackStrategy () {
	if (hasRequiredStackStrategy) return stackStrategy;
	hasRequiredStackStrategy = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const defaultScopes = /*@__PURE__*/ requireDefaultScopes();
		const scope = /*@__PURE__*/ requireScope();
		const chainAndCopyPromiselike = /*@__PURE__*/ requireChainAndCopyPromiselike();
		const is = /*@__PURE__*/ requireIs$1();
		const carrier = /*@__PURE__*/ requireCarrier();

		class AsyncContextStack {
		  constructor(scope$1, isolationScope) {
		    let assignedScope;
		    if (!scope$1) {
		      assignedScope = new scope.Scope();
		    } else {
		      assignedScope = scope$1;
		    }
		    let assignedIsolationScope;
		    if (!isolationScope) {
		      assignedIsolationScope = new scope.Scope();
		    } else {
		      assignedIsolationScope = isolationScope;
		    }
		    this._stack = [{ scope: assignedScope }];
		    this._isolationScope = assignedIsolationScope;
		  }
		  /**
		   * Fork a scope for the stack.
		   */
		  withScope(callback) {
		    const scope = this._pushScope();
		    let maybePromiseResult;
		    try {
		      maybePromiseResult = callback(scope);
		    } catch (e) {
		      this._popScope();
		      throw e;
		    }
		    if (is.isThenable(maybePromiseResult)) {
		      return chainAndCopyPromiselike.chainAndCopyPromiseLike(
		        maybePromiseResult,
		        () => this._popScope(),
		        () => this._popScope()
		      );
		    }
		    this._popScope();
		    return maybePromiseResult;
		  }
		  /**
		   * Get the client of the stack.
		   */
		  getClient() {
		    return this.getStackTop().client;
		  }
		  /**
		   * Returns the scope of the top stack.
		   */
		  getScope() {
		    return this.getStackTop().scope;
		  }
		  /**
		   * Get the isolation scope for the stack.
		   */
		  getIsolationScope() {
		    return this._isolationScope;
		  }
		  /**
		   * Returns the topmost scope layer in the order domain > local > process.
		   */
		  getStackTop() {
		    return this._stack[this._stack.length - 1];
		  }
		  /**
		   * Push a scope to the stack.
		   */
		  _pushScope() {
		    const scope = this.getScope().clone();
		    this._stack.push({
		      client: this.getClient(),
		      scope
		    });
		    return scope;
		  }
		  /**
		   * Pop a scope from the stack.
		   */
		  _popScope() {
		    if (this._stack.length <= 1) return false;
		    return !!this._stack.pop();
		  }
		}
		function getAsyncContextStack() {
		  const registry = carrier.getMainCarrier();
		  const sentry = carrier.getSentryCarrier(registry);
		  return sentry.stack = sentry.stack || new AsyncContextStack(defaultScopes.getDefaultCurrentScope(), defaultScopes.getDefaultIsolationScope());
		}
		function withScope(callback) {
		  return getAsyncContextStack().withScope(callback);
		}
		function withSetScope(scope, callback) {
		  const stack = getAsyncContextStack();
		  return stack.withScope(() => {
		    stack.getStackTop().scope = scope;
		    return callback(scope);
		  });
		}
		function withIsolationScope(callback) {
		  return getAsyncContextStack().withScope(() => {
		    return callback(getAsyncContextStack().getIsolationScope());
		  });
		}
		function getStackAsyncContextStrategy() {
		  return {
		    withIsolationScope,
		    withScope,
		    withSetScope,
		    withSetIsolationScope: (_isolationScope, callback) => {
		      return withIsolationScope(callback);
		    },
		    getCurrentScope: () => getAsyncContextStack().getScope(),
		    getIsolationScope: () => getAsyncContextStack().getIsolationScope()
		  };
		}

		exports.AsyncContextStack = AsyncContextStack;
		exports.getStackAsyncContextStrategy = getStackAsyncContextStrategy;
		
	} (stackStrategy));
	return stackStrategy;
}

var hasRequiredAsyncContext;

function requireAsyncContext () {
	if (hasRequiredAsyncContext) return asyncContext;
	hasRequiredAsyncContext = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const carrier = /*@__PURE__*/ requireCarrier();
		const stackStrategy = /*@__PURE__*/ requireStackStrategy();

		function setAsyncContextStrategy(strategy) {
		  const registry = carrier.getMainCarrier();
		  const sentry = carrier.getSentryCarrier(registry);
		  sentry.acs = strategy;
		}
		function getAsyncContextStrategy(carrier$1) {
		  const sentry = carrier.getSentryCarrier(carrier$1);
		  if (sentry.acs) {
		    return sentry.acs;
		  }
		  return stackStrategy.getStackAsyncContextStrategy();
		}

		exports.getAsyncContextStrategy = getAsyncContextStrategy;
		exports.setAsyncContextStrategy = setAsyncContextStrategy;
		
	} (asyncContext));
	return asyncContext;
}

var attributes$1 = {};

var hasRequiredAttributes$1;

function requireAttributes$1 () {
	if (hasRequiredAttributes$1) return attributes$1;
	hasRequiredAttributes$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const is = /*@__PURE__*/ requireIs$1();

		function isAttributeObject(maybeObj) {
		  return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
		}
		function attributeValueToTypedAttributeValue(rawValue, useFallback) {
		  const { value, unit } = isAttributeObject(rawValue) ? rawValue : { value: rawValue, unit: void 0 };
		  const attributeValue = getTypedAttributeValue(value);
		  const checkedUnit = unit && typeof unit === "string" ? { unit } : {};
		  if (attributeValue) {
		    return { ...attributeValue, ...checkedUnit };
		  }
		  if (!useFallback || useFallback === "skip-undefined" && value === void 0) {
		    return;
		  }
		  let stringValue = "";
		  try {
		    stringValue = JSON.stringify(value) ?? "";
		  } catch {
		  }
		  return {
		    value: stringValue,
		    type: "string",
		    ...checkedUnit
		  };
		}
		function serializeAttributes(attributes, fallback = false) {
		  const serializedAttributes = {};
		  for (const [key, value] of Object.entries(attributes ?? {})) {
		    const typedValue = attributeValueToTypedAttributeValue(value, fallback);
		    if (typedValue) {
		      serializedAttributes[key] = typedValue;
		    }
		  }
		  return serializedAttributes;
		}
		function estimateTypedAttributesSizeInBytes(attributes) {
		  if (!attributes) {
		    return 0;
		  }
		  let weight = 0;
		  for (const [key, attr] of Object.entries(attributes)) {
		    weight += key.length * 2;
		    weight += attr.type.length * 2;
		    weight += (attr.unit?.length ?? 0) * 2;
		    const val = attr.value;
		    if (Array.isArray(val)) {
		      weight += estimatePrimitiveSizeInBytes(val[0]) * val.length;
		    } else if (is.isPrimitive(val)) {
		      weight += estimatePrimitiveSizeInBytes(val);
		    } else {
		      weight += 100;
		    }
		  }
		  return weight;
		}
		function estimatePrimitiveSizeInBytes(value) {
		  if (typeof value === "string") {
		    return value.length * 2;
		  } else if (typeof value === "boolean") {
		    return 4;
		  } else if (typeof value === "number") {
		    return 8;
		  }
		  return 0;
		}
		function getTypedAttributeValue(value) {
		  if (Array.isArray(value)) {
		    return { value, type: "array" };
		  }
		  const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
		  if (primitiveType) {
		    return { value, type: primitiveType };
		  }
		}

		exports.attributeValueToTypedAttributeValue = attributeValueToTypedAttributeValue;
		exports.estimateTypedAttributesSizeInBytes = estimateTypedAttributesSizeInBytes;
		exports.isAttributeObject = isAttributeObject;
		exports.serializeAttributes = serializeAttributes;
		
	} (attributes$1));
	return attributes$1;
}

var currentScopes = {};

var hasRequiredCurrentScopes;

function requireCurrentScopes () {
	if (hasRequiredCurrentScopes) return currentScopes;
	hasRequiredCurrentScopes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const index = /*@__PURE__*/ requireAsyncContext();
		const carrier = /*@__PURE__*/ requireCarrier();
		const scope = /*@__PURE__*/ requireScope();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();

		let _externalPropagationContextProvider;
		function registerExternalPropagationContext(fn) {
		  _externalPropagationContextProvider = fn;
		}
		function getExternalPropagationContext() {
		  return _externalPropagationContextProvider?.();
		}
		function hasExternalPropagationContext() {
		  return _externalPropagationContextProvider !== void 0;
		}
		function getCurrentScope() {
		  const carrier$1 = carrier.getMainCarrier();
		  const acs = index.getAsyncContextStrategy(carrier$1);
		  return acs.getCurrentScope();
		}
		function getIsolationScope() {
		  const carrier$1 = carrier.getMainCarrier();
		  const acs = index.getAsyncContextStrategy(carrier$1);
		  return acs.getIsolationScope();
		}
		function getGlobalScope() {
		  return carrier.getGlobalSingleton("globalScope", () => new scope.Scope());
		}
		function withScope(...rest) {
		  const carrier$1 = carrier.getMainCarrier();
		  const acs = index.getAsyncContextStrategy(carrier$1);
		  if (rest.length === 2) {
		    const [scope, callback] = rest;
		    if (!scope) {
		      return acs.withScope(callback);
		    }
		    return acs.withSetScope(scope, callback);
		  }
		  return acs.withScope(rest[0]);
		}
		function withIsolationScope(...rest) {
		  const carrier$1 = carrier.getMainCarrier();
		  const acs = index.getAsyncContextStrategy(carrier$1);
		  if (rest.length === 2) {
		    const [isolationScope, callback] = rest;
		    if (!isolationScope) {
		      return acs.withIsolationScope(callback);
		    }
		    return acs.withSetIsolationScope(isolationScope, callback);
		  }
		  return acs.withIsolationScope(rest[0]);
		}
		function getClient() {
		  return getCurrentScope().getClient();
		}
		function getTraceContextFromScope(scope) {
		  const externalContext = getExternalPropagationContext();
		  if (externalContext) {
		    return { trace_id: externalContext.traceId, span_id: externalContext.spanId };
		  }
		  const propagationContext$1 = scope.getPropagationContext();
		  const { traceId, parentSpanId, propagationSpanId } = propagationContext$1;
		  const traceContext = {
		    trace_id: traceId,
		    span_id: propagationSpanId || propagationContext.generateSpanId()
		  };
		  if (parentSpanId) {
		    traceContext.parent_span_id = parentSpanId;
		  }
		  return traceContext;
		}

		exports.getClient = getClient;
		exports.getCurrentScope = getCurrentScope;
		exports.getExternalPropagationContext = getExternalPropagationContext;
		exports.getGlobalScope = getGlobalScope;
		exports.getIsolationScope = getIsolationScope;
		exports.getTraceContextFromScope = getTraceContextFromScope;
		exports.hasExternalPropagationContext = hasExternalPropagationContext;
		exports.registerExternalPropagationContext = registerExternalPropagationContext;
		exports.withIsolationScope = withIsolationScope;
		exports.withScope = withScope;
		
	} (currentScopes));
	return currentScopes;
}

var semanticAttributes = {};

var hasRequiredSemanticAttributes;

function requireSemanticAttributes () {
	if (hasRequiredSemanticAttributes) return semanticAttributes;
	hasRequiredSemanticAttributes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
		const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
		const SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
		const SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
		const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
		const SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
		const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
		const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
		const SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
		const SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
		const SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
		const SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
		const SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
		const SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
		const SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
		const SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
		const SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
		const SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
		const SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
		const SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
		const SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
		const SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
		const SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
		const SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
		const SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
		const SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
		const SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
		const SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
		const GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";

		exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = GEN_AI_CONVERSATION_ID_ATTRIBUTE;
		exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = SEMANTIC_ATTRIBUTE_CACHE_HIT;
		exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
		exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = SEMANTIC_ATTRIBUTE_CACHE_KEY;
		exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
		exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
		exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = SEMANTIC_ATTRIBUTE_PROFILE_ID;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = SEMANTIC_ATTRIBUTE_SENTRY_OP;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
		exports.SEMANTIC_ATTRIBUTE_URL_FULL = SEMANTIC_ATTRIBUTE_URL_FULL;
		exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = SEMANTIC_ATTRIBUTE_USER_EMAIL;
		exports.SEMANTIC_ATTRIBUTE_USER_ID = SEMANTIC_ATTRIBUTE_USER_ID;
		exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
		exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = SEMANTIC_ATTRIBUTE_USER_USERNAME;
		exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
		
	} (semanticAttributes));
	return semanticAttributes;
}

var spanstatus = {};

var hasRequiredSpanstatus;

function requireSpanstatus () {
	if (hasRequiredSpanstatus) return spanstatus;
	hasRequiredSpanstatus = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const SPAN_STATUS_UNSET = 0;
		const SPAN_STATUS_OK = 1;
		const SPAN_STATUS_ERROR = 2;
		function getSpanStatusFromHttpCode(httpStatus) {
		  if (httpStatus < 400 && httpStatus >= 100) {
		    return { code: SPAN_STATUS_OK };
		  }
		  if (httpStatus >= 400 && httpStatus < 500) {
		    switch (httpStatus) {
		      case 401:
		        return { code: SPAN_STATUS_ERROR, message: "unauthenticated" };
		      case 403:
		        return { code: SPAN_STATUS_ERROR, message: "permission_denied" };
		      case 404:
		        return { code: SPAN_STATUS_ERROR, message: "not_found" };
		      case 409:
		        return { code: SPAN_STATUS_ERROR, message: "already_exists" };
		      case 413:
		        return { code: SPAN_STATUS_ERROR, message: "failed_precondition" };
		      case 429:
		        return { code: SPAN_STATUS_ERROR, message: "resource_exhausted" };
		      case 499:
		        return { code: SPAN_STATUS_ERROR, message: "cancelled" };
		      default:
		        return { code: SPAN_STATUS_ERROR, message: "invalid_argument" };
		    }
		  }
		  if (httpStatus >= 500 && httpStatus < 600) {
		    switch (httpStatus) {
		      case 501:
		        return { code: SPAN_STATUS_ERROR, message: "unimplemented" };
		      case 503:
		        return { code: SPAN_STATUS_ERROR, message: "unavailable" };
		      case 504:
		        return { code: SPAN_STATUS_ERROR, message: "deadline_exceeded" };
		      default:
		        return { code: SPAN_STATUS_ERROR, message: "internal_error" };
		    }
		  }
		  return { code: SPAN_STATUS_ERROR, message: "internal_error" };
		}
		function setHttpStatus(span, httpStatus) {
		  span.setAttribute("http.response.status_code", httpStatus);
		  const spanStatus = getSpanStatusFromHttpCode(httpStatus);
		  if (spanStatus.message !== "unknown_error") {
		    span.setStatus(spanStatus);
		  }
		}

		exports.SPAN_STATUS_ERROR = SPAN_STATUS_ERROR;
		exports.SPAN_STATUS_OK = SPAN_STATUS_OK;
		exports.SPAN_STATUS_UNSET = SPAN_STATUS_UNSET;
		exports.getSpanStatusFromHttpCode = getSpanStatusFromHttpCode;
		exports.setHttpStatus = setHttpStatus;
		
	} (spanstatus));
	return spanstatus;
}

var utils$g = {};

var hasRequiredUtils$g;

function requireUtils$g () {
	if (hasRequiredUtils$g) return utils$g;
	hasRequiredUtils$g = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const object = /*@__PURE__*/ requireObject();
		const weakRef = /*@__PURE__*/ requireWeakRef();

		const SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
		const ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
		const OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
		function setCapturedScopesOnSpan(span, scope, isolationScope) {
		  if (span) {
		    object.addNonEnumerableProperty(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, weakRef.makeWeakRef(isolationScope));
		    object.addNonEnumerableProperty(span, SCOPE_ON_START_SPAN_FIELD, scope);
		  }
		}
		function getCapturedScopesOnSpan(span) {
		  const spanWithScopes = span;
		  return {
		    scope: spanWithScopes[SCOPE_ON_START_SPAN_FIELD],
		    isolationScope: weakRef.derefWeakRef(spanWithScopes[ISOLATION_SCOPE_ON_START_SPAN_FIELD])
		  };
		}
		function markSpanForOtelSourceInference(span) {
		  object.addNonEnumerableProperty(span, OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
		}
		function spanShouldInferOtelSource(span) {
		  return span[OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
		}

		exports.getCapturedScopesOnSpan = getCapturedScopesOnSpan;
		exports.markSpanForOtelSourceInference = markSpanForOtelSourceInference;
		exports.setCapturedScopesOnSpan = setCapturedScopesOnSpan;
		exports.spanShouldInferOtelSource = spanShouldInferOtelSource;
		
	} (utils$g));
	return utils$g;
}

var tracing = {};

var baggage = {};

var hasRequiredBaggage;

function requireBaggage () {
	if (hasRequiredBaggage) return baggage;
	hasRequiredBaggage = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();

		const SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
		const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
		const MAX_BAGGAGE_STRING_LENGTH = 8192;
		function baggageHeaderToDynamicSamplingContext(baggageHeader) {
		  const baggageObject = parseBaggageHeader(baggageHeader);
		  if (!baggageObject) {
		    return void 0;
		  }
		  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
		    if (key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
		      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
		      acc[nonPrefixedKey] = value;
		    }
		    return acc;
		  }, {});
		  if (Object.keys(dynamicSamplingContext).length > 0) {
		    return dynamicSamplingContext;
		  } else {
		    return void 0;
		  }
		}
		function dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
		  if (!dynamicSamplingContext) {
		    return void 0;
		  }
		  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
		    (acc, [dscKey, dscValue]) => {
		      if (dscValue) {
		        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
		      }
		      return acc;
		    },
		    {}
		  );
		  return objectToBaggageHeader(sentryPrefixedDSC);
		}
		function parseBaggageHeader(baggageHeader) {
		  if (!baggageHeader || !is.isString(baggageHeader) && !Array.isArray(baggageHeader)) {
		    return void 0;
		  }
		  if (Array.isArray(baggageHeader)) {
		    return baggageHeader.reduce((acc, curr) => {
		      const currBaggageObject = baggageHeaderToObject(curr);
		      Object.entries(currBaggageObject).forEach(([key, value]) => {
		        acc[key] = value;
		      });
		      return acc;
		    }, {});
		  }
		  return baggageHeaderToObject(baggageHeader);
		}
		function baggageHeaderToObject(baggageHeader) {
		  return baggageHeader.split(",").map((baggageEntry) => {
		    const eqIdx = baggageEntry.indexOf("=");
		    if (eqIdx === -1) {
		      return [];
		    }
		    const key = baggageEntry.slice(0, eqIdx);
		    const value = baggageEntry.slice(eqIdx + 1);
		    return [key, value].map((keyOrValue) => {
		      try {
		        return decodeURIComponent(keyOrValue.trim());
		      } catch {
		        return;
		      }
		    });
		  }).reduce((acc, [key, value]) => {
		    if (key && value) {
		      acc[key] = value;
		    }
		    return acc;
		  }, {});
		}
		function objectToBaggageHeader(object) {
		  if (Object.keys(object).length === 0) {
		    return void 0;
		  }
		  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
		    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
		    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
		    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		        `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`
		      );
		      return baggageHeader;
		    } else {
		      return newBaggageHeader;
		    }
		  }, "");
		}
		function mergeBaggageHeaders(existing, incoming) {
		  if (!existing) {
		    return incoming;
		  }
		  const existingEntries = parseBaggageHeader(existing);
		  const incomingEntries = parseBaggageHeader(incoming);
		  if (!incomingEntries) {
		    return existing;
		  }
		  const merged = {};
		  let hasNewSentryEntries = false;
		  const newSentryEntries = {};
		  const newNonSentryEntries = {};
		  for (const [key, value] of Object.entries(incomingEntries)) {
		    if (key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
		      newSentryEntries[key] = value;
		      hasNewSentryEntries = true;
		    } else {
		      newNonSentryEntries[key] = value;
		    }
		  }
		  if (existingEntries) {
		    for (const [key, value] of Object.entries(existingEntries)) {
		      if (!hasNewSentryEntries || !key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
		        merged[key] = value;
		      }
		    }
		  }
		  if (hasNewSentryEntries) {
		    Object.assign(merged, newSentryEntries);
		  }
		  for (const [key, value] of Object.entries(newNonSentryEntries)) {
		    merged[key] ?? (merged[key] = value);
		  }
		  return objectToBaggageHeader(merged);
		}

		exports.MAX_BAGGAGE_STRING_LENGTH = MAX_BAGGAGE_STRING_LENGTH;
		exports.SENTRY_BAGGAGE_KEY_PREFIX = SENTRY_BAGGAGE_KEY_PREFIX;
		exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
		exports.baggageHeaderToDynamicSamplingContext = baggageHeaderToDynamicSamplingContext;
		exports.dynamicSamplingContextToSentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader;
		exports.mergeBaggageHeaders = mergeBaggageHeaders;
		exports.objectToBaggageHeader = objectToBaggageHeader;
		exports.parseBaggageHeader = parseBaggageHeader;
		
	} (baggage));
	return baggage;
}

var dsn = {};

var hasRequiredDsn;

function requireDsn () {
	if (hasRequiredDsn) return dsn;
	hasRequiredDsn = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();

		const ORG_ID_REGEX = /^o(\d+)\./;
		const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
		function isValidProtocol(protocol) {
		  return protocol === "http" || protocol === "https";
		}
		function dsnToString(dsn, withPassword = false) {
		  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
		  return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
		}
		function dsnFromString(str) {
		  const match = DSN_REGEX.exec(str);
		  if (!match) {
		    debugLogger.consoleSandbox(() => {
		      console.error(`Invalid Sentry Dsn: ${str}`);
		    });
		    return void 0;
		  }
		  const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
		  let path = "";
		  let projectId = lastPath;
		  const split = projectId.split("/");
		  if (split.length > 1) {
		    path = split.slice(0, -1).join("/");
		    projectId = split.pop();
		  }
		  if (projectId) {
		    const projectMatch = projectId.match(/^\d+/);
		    if (projectMatch) {
		      projectId = projectMatch[0];
		    }
		  }
		  return dsnFromComponents({ host, pass, path, projectId, port, protocol, publicKey });
		}
		function dsnFromComponents(components) {
		  return {
		    protocol: components.protocol,
		    publicKey: components.publicKey || "",
		    pass: components.pass || "",
		    host: components.host,
		    port: components.port || "",
		    path: components.path || "",
		    projectId: components.projectId
		  };
		}
		function validateDsn(dsn) {
		  if (!debugBuild.DEBUG_BUILD) {
		    return true;
		  }
		  const { port, projectId, protocol } = dsn;
		  const requiredComponents = ["protocol", "publicKey", "host", "projectId"];
		  const hasMissingRequiredComponent = requiredComponents.find((component) => {
		    if (!dsn[component]) {
		      debugLogger.debug.error(`Invalid Sentry Dsn: ${component} missing`);
		      return true;
		    }
		    return false;
		  });
		  if (hasMissingRequiredComponent) {
		    return false;
		  }
		  if (!projectId.match(/^\d+$/)) {
		    debugLogger.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
		    return false;
		  }
		  if (!isValidProtocol(protocol)) {
		    debugLogger.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
		    return false;
		  }
		  if (port && isNaN(parseInt(port, 10))) {
		    debugLogger.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
		    return false;
		  }
		  return true;
		}
		function extractOrgIdFromDsnHost(host) {
		  const match = host.match(ORG_ID_REGEX);
		  return match?.[1];
		}
		function extractOrgIdFromClient(client) {
		  const options = client.getOptions();
		  const { host } = client.getDsn() || {};
		  let org_id;
		  if (options.orgId) {
		    org_id = String(options.orgId);
		  } else if (host) {
		    org_id = extractOrgIdFromDsnHost(host);
		  }
		  return org_id;
		}
		function makeDsn(from) {
		  const components = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
		  if (!components || !validateDsn(components)) {
		    return void 0;
		  }
		  return components;
		}

		exports.dsnFromString = dsnFromString;
		exports.dsnToString = dsnToString;
		exports.extractOrgIdFromClient = extractOrgIdFromClient;
		exports.extractOrgIdFromDsnHost = extractOrgIdFromDsnHost;
		exports.makeDsn = makeDsn;
		
	} (dsn));
	return dsn;
}

var parseSampleRate = {};

var hasRequiredParseSampleRate;

function requireParseSampleRate () {
	if (hasRequiredParseSampleRate) return parseSampleRate;
	hasRequiredParseSampleRate = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function parseSampleRate(sampleRate) {
		  if (typeof sampleRate === "boolean") {
		    return Number(sampleRate);
		  }
		  const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
		  if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
		    return void 0;
		  }
		  return rate;
		}

		exports.parseSampleRate = parseSampleRate;
		
	} (parseSampleRate));
	return parseSampleRate;
}

var hasRequiredTracing;

function requireTracing () {
	if (hasRequiredTracing) return tracing;
	hasRequiredTracing = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const baggage = /*@__PURE__*/ requireBaggage();
		const dsn = /*@__PURE__*/ requireDsn();
		const parseSampleRate = /*@__PURE__*/ requireParseSampleRate();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();

		const TRACEPARENT_REGEXP = new RegExp(
		  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
		  // whitespace
		);
		function extractTraceparentData(traceparent) {
		  if (!traceparent) {
		    return void 0;
		  }
		  const matches = traceparent.match(TRACEPARENT_REGEXP);
		  if (!matches) {
		    return void 0;
		  }
		  let parentSampled;
		  if (matches[3] === "1") {
		    parentSampled = true;
		  } else if (matches[3] === "0") {
		    parentSampled = false;
		  }
		  return {
		    traceId: matches[1],
		    parentSampled,
		    parentSpanId: matches[2]
		  };
		}
		function propagationContextFromHeaders(sentryTrace, baggage$1) {
		  const traceparentData = extractTraceparentData(sentryTrace);
		  const dynamicSamplingContext = baggage.baggageHeaderToDynamicSamplingContext(baggage$1);
		  if (!traceparentData?.traceId) {
		    return {
		      traceId: propagationContext.generateTraceId(),
		      sampleRand: randomSafeContext.safeMathRandom()
		    };
		  }
		  const sampleRand = getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
		  if (dynamicSamplingContext) {
		    dynamicSamplingContext.sample_rand = sampleRand.toString();
		  }
		  const { traceId, parentSpanId, parentSampled } = traceparentData;
		  return {
		    traceId,
		    parentSpanId,
		    sampled: parentSampled,
		    dsc: dynamicSamplingContext || {},
		    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
		    sampleRand
		  };
		}
		function generateSentryTraceHeader(traceId = propagationContext.generateTraceId(), spanId = propagationContext.generateSpanId(), sampled) {
		  let sampledString = "";
		  if (sampled !== void 0) {
		    sampledString = sampled ? "-1" : "-0";
		  }
		  return `${traceId}-${spanId}${sampledString}`;
		}
		function generateTraceparentHeader(traceId = propagationContext.generateTraceId(), spanId = propagationContext.generateSpanId(), sampled) {
		  return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
		}
		function getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
		  const parsedSampleRand = parseSampleRate.parseSampleRate(dsc?.sample_rand);
		  if (parsedSampleRand !== void 0) {
		    return parsedSampleRand;
		  }
		  const parsedSampleRate = parseSampleRate.parseSampleRate(dsc?.sample_rate);
		  if (parsedSampleRate && traceparentData?.parentSampled !== void 0) {
		    return traceparentData.parentSampled ? (
		      // Returns a sample rand with positive sampling decision [0, sampleRate)
		      randomSafeContext.safeMathRandom() * parsedSampleRate
		    ) : (
		      // Returns a sample rand with negative sampling decision [sampleRate, 1)
		      parsedSampleRate + randomSafeContext.safeMathRandom() * (1 - parsedSampleRate)
		    );
		  } else {
		    return randomSafeContext.safeMathRandom();
		  }
		}
		function shouldContinueTrace(client, baggageOrgId) {
		  const clientOrgId = dsn.extractOrgIdFromClient(client);
		  if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
		    debugLogger.debug.log(
		      `Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`
		    );
		    return false;
		  }
		  const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
		  if (strictTraceContinuation) {
		    if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
		      debugLogger.debug.log(
		        `Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`
		      );
		      return false;
		    }
		  }
		  return true;
		}

		exports.TRACEPARENT_REGEXP = TRACEPARENT_REGEXP;
		exports.extractTraceparentData = extractTraceparentData;
		exports.generateSentryTraceHeader = generateSentryTraceHeader;
		exports.generateTraceparentHeader = generateTraceparentHeader;
		exports.propagationContextFromHeaders = propagationContextFromHeaders;
		exports.shouldContinueTrace = shouldContinueTrace;
		
	} (tracing));
	return tracing;
}

var hasRequiredSpanUtils;

function requireSpanUtils () {
	if (hasRequiredSpanUtils) return spanUtils;
	hasRequiredSpanUtils = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const index = /*@__PURE__*/ requireAsyncContext();
		const attributes = /*@__PURE__*/ requireAttributes$1();
		const carrier = /*@__PURE__*/ requireCarrier();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const utils = /*@__PURE__*/ requireUtils$g();
		const object = /*@__PURE__*/ requireObject();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const time = /*@__PURE__*/ requireTime();
		const tracing = /*@__PURE__*/ requireTracing();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();

		const TRACE_FLAG_NONE = 0;
		const TRACE_FLAG_SAMPLED = 1;
		let hasShownSpanDropWarning = false;
		function spanToTransactionTraceContext(span) {
		  const { spanId: span_id, traceId: trace_id } = span.spanContext();
		  const { data, op, parent_span_id, status, origin, links } = spanToJSON(span);
		  return {
		    parent_span_id,
		    span_id,
		    trace_id,
		    data,
		    op,
		    status,
		    origin,
		    links
		  };
		}
		function spanToTraceContext(span) {
		  const { spanId, traceId: trace_id, isRemote } = span.spanContext();
		  const parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
		  const scope = utils.getCapturedScopesOnSpan(span).scope;
		  const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || propagationContext.generateSpanId() : spanId;
		  return {
		    parent_span_id,
		    span_id,
		    trace_id
		  };
		}
		function spanToTraceHeader(span) {
		  const { traceId, spanId } = span.spanContext();
		  const sampled = spanIsSampled(span);
		  return tracing.generateSentryTraceHeader(traceId, spanId, sampled);
		}
		function spanToTraceparentHeader(span) {
		  const { traceId, spanId } = span.spanContext();
		  const sampled = spanIsSampled(span);
		  return tracing.generateTraceparentHeader(traceId, spanId, sampled);
		}
		function convertSpanLinksForEnvelope(links) {
		  if (links && links.length > 0) {
		    return links.map(({ context: { spanId, traceId, traceFlags, ...restContext }, attributes }) => ({
		      span_id: spanId,
		      trace_id: traceId,
		      sampled: traceFlags === TRACE_FLAG_SAMPLED,
		      attributes,
		      ...restContext
		    }));
		  } else {
		    return void 0;
		  }
		}
		function getStreamedSpanLinks(links) {
		  if (links?.length) {
		    return links.map(({ context: { spanId, traceId, traceFlags }, attributes }) => ({
		      span_id: spanId,
		      trace_id: traceId,
		      sampled: traceFlags === TRACE_FLAG_SAMPLED,
		      attributes
		    }));
		  } else {
		    return void 0;
		  }
		}
		function spanTimeInputToSeconds(input) {
		  if (typeof input === "number") {
		    return ensureTimestampInSeconds(input);
		  }
		  if (Array.isArray(input)) {
		    return input[0] + input[1] / 1e9;
		  }
		  if (input instanceof Date) {
		    return ensureTimestampInSeconds(input.getTime());
		  }
		  return time.timestampInSeconds();
		}
		function ensureTimestampInSeconds(timestamp) {
		  const isMs = timestamp > 9999999999;
		  return isMs ? timestamp / 1e3 : timestamp;
		}
		function spanToJSON(span) {
		  if (spanIsSentrySpan(span)) {
		    return span.getSpanJSON();
		  }
		  const { spanId: span_id, traceId: trace_id } = span.spanContext();
		  if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
		    const { attributes, startTime, name, endTime, status, links } = span;
		    return {
		      span_id,
		      trace_id,
		      data: attributes,
		      description: name,
		      parent_span_id: getOtelParentSpanId(span),
		      start_timestamp: spanTimeInputToSeconds(startTime),
		      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
		      timestamp: spanTimeInputToSeconds(endTime) || void 0,
		      status: getStatusMessage(status),
		      op: attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP],
		      origin: attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
		      links: convertSpanLinksForEnvelope(links)
		    };
		  }
		  return {
		    span_id,
		    trace_id,
		    start_timestamp: 0,
		    data: {}
		  };
		}
		function spanToStreamedSpanJSON(span) {
		  if (spanIsSentrySpan(span)) {
		    return span.getStreamedSpanJSON();
		  }
		  const { spanId: span_id, traceId: trace_id } = span.spanContext();
		  if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
		    const { attributes, startTime, name, endTime, status, links } = span;
		    return {
		      name,
		      span_id,
		      trace_id,
		      parent_span_id: getOtelParentSpanId(span),
		      start_timestamp: spanTimeInputToSeconds(startTime),
		      end_timestamp: spanTimeInputToSeconds(endTime),
		      is_segment: span === INTERNAL_getSegmentSpan(span),
		      status: getSimpleStatusMessage(status),
		      attributes,
		      links: getStreamedSpanLinks(links)
		    };
		  }
		  return {
		    span_id,
		    trace_id,
		    start_timestamp: 0,
		    name: "",
		    end_timestamp: 0,
		    status: "ok",
		    is_segment: span === INTERNAL_getSegmentSpan(span)
		  };
		}
		function getOtelParentSpanId(span) {
		  return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
		}
		function streamedSpanJsonToSerializedSpan(spanJson) {
		  return {
		    ...spanJson,
		    attributes: attributes.serializeAttributes(spanJson.attributes),
		    links: spanJson.links?.map((link) => ({
		      ...link,
		      attributes: attributes.serializeAttributes(link.attributes)
		    }))
		  };
		}
		function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
		  const castSpan = span;
		  return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
		}
		function spanIsSentrySpan(span) {
		  return typeof span.getSpanJSON === "function";
		}
		function spanIsSampled(span) {
		  const { traceFlags } = span.spanContext();
		  return traceFlags === TRACE_FLAG_SAMPLED;
		}
		function getStatusMessage(status) {
		  if (!status || status.code === spanstatus.SPAN_STATUS_UNSET) {
		    return void 0;
		  }
		  if (status.code === spanstatus.SPAN_STATUS_OK) {
		    return "ok";
		  }
		  return status.message || "internal_error";
		}
		function getSimpleStatusMessage(status) {
		  return !status || status.code === spanstatus.SPAN_STATUS_OK || status.code === spanstatus.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
		}
		const CHILD_SPANS_FIELD = "_sentryChildSpans";
		const ROOT_SPAN_FIELD = "_sentryRootSpan";
		function addChildSpanToSpan(span, childSpan) {
		  const rootSpan = span[ROOT_SPAN_FIELD] || span;
		  object.addNonEnumerableProperty(childSpan, ROOT_SPAN_FIELD, rootSpan);
		  if (span[CHILD_SPANS_FIELD]) {
		    span[CHILD_SPANS_FIELD].add(childSpan);
		  } else {
		    object.addNonEnumerableProperty(span, CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([childSpan]));
		  }
		}
		function removeChildSpanFromSpan(span, childSpan) {
		  if (span[CHILD_SPANS_FIELD]) {
		    span[CHILD_SPANS_FIELD].delete(childSpan);
		  }
		}
		function getSpanDescendants(span) {
		  const resultSet = /* @__PURE__ */ new Set();
		  function addSpanChildren(span2) {
		    if (resultSet.has(span2)) {
		      return;
		    } else if (spanIsSampled(span2)) {
		      resultSet.add(span2);
		      const childSpans = span2[CHILD_SPANS_FIELD] ? Array.from(span2[CHILD_SPANS_FIELD]) : [];
		      for (const childSpan of childSpans) {
		        addSpanChildren(childSpan);
		      }
		    }
		  }
		  addSpanChildren(span);
		  return Array.from(resultSet);
		}
		const getRootSpan = INTERNAL_getSegmentSpan;
		function INTERNAL_getSegmentSpan(span) {
		  return span[ROOT_SPAN_FIELD] || span;
		}
		function getActiveSpan() {
		  const carrier$1 = carrier.getMainCarrier();
		  const acs = index.getAsyncContextStrategy(carrier$1);
		  if (acs.getActiveSpan) {
		    return acs.getActiveSpan();
		  }
		  return spanOnScope._getSpanForScope(currentScopes.getCurrentScope());
		}
		function showSpanDropWarning() {
		  if (!hasShownSpanDropWarning) {
		    debugLogger.consoleSandbox(() => {
		      console.warn(
		        "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`."
		      );
		    });
		    hasShownSpanDropWarning = true;
		  }
		}
		function updateSpanName(span, name) {
		  span.updateName(name);
		  span.setAttributes({
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
		  });
		}

		exports.INTERNAL_getSegmentSpan = INTERNAL_getSegmentSpan;
		exports.TRACE_FLAG_NONE = TRACE_FLAG_NONE;
		exports.TRACE_FLAG_SAMPLED = TRACE_FLAG_SAMPLED;
		exports.addChildSpanToSpan = addChildSpanToSpan;
		exports.convertSpanLinksForEnvelope = convertSpanLinksForEnvelope;
		exports.getActiveSpan = getActiveSpan;
		exports.getRootSpan = getRootSpan;
		exports.getSimpleStatusMessage = getSimpleStatusMessage;
		exports.getSpanDescendants = getSpanDescendants;
		exports.getStatusMessage = getStatusMessage;
		exports.getStreamedSpanLinks = getStreamedSpanLinks;
		exports.removeChildSpanFromSpan = removeChildSpanFromSpan;
		exports.showSpanDropWarning = showSpanDropWarning;
		exports.spanIsSampled = spanIsSampled;
		exports.spanTimeInputToSeconds = spanTimeInputToSeconds;
		exports.spanToJSON = spanToJSON;
		exports.spanToStreamedSpanJSON = spanToStreamedSpanJSON;
		exports.spanToTraceContext = spanToTraceContext;
		exports.spanToTraceHeader = spanToTraceHeader;
		exports.spanToTraceparentHeader = spanToTraceparentHeader;
		exports.spanToTransactionTraceContext = spanToTransactionTraceContext;
		exports.streamedSpanJsonToSerializedSpan = streamedSpanJsonToSerializedSpan;
		exports.updateSpanName = updateSpanName;
		
	} (spanUtils));
	return spanUtils;
}

var hasRequiredErrors;

function requireErrors () {
	if (hasRequiredErrors) return errors;
	hasRequiredErrors = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const globalError = /*@__PURE__*/ requireGlobalError();
		const globalUnhandledRejection = /*@__PURE__*/ requireGlobalUnhandledRejection();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();

		let errorsInstrumented = false;
		function registerSpanErrorInstrumentation() {
		  if (errorsInstrumented) {
		    return;
		  }
		  function errorCallback() {
		    const activeSpan = spanUtils.getActiveSpan();
		    const rootSpan = activeSpan && spanUtils.getRootSpan(activeSpan);
		    if (rootSpan) {
		      const message = "internal_error";
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
		      rootSpan.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message });
		    }
		  }
		  errorsInstrumented = true;
		  globalError.addGlobalErrorInstrumentationHandler(errorCallback);
		  globalUnhandledRejection.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
		}

		exports.registerSpanErrorInstrumentation = registerSpanErrorInstrumentation;
		
	} (errors));
	return errors;
}

var idleSpan = {};

var hasSpansEnabled = {};

var hasRequiredHasSpansEnabled;

function requireHasSpansEnabled () {
	if (hasRequiredHasSpansEnabled) return hasSpansEnabled;
	hasRequiredHasSpansEnabled = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();

		function hasSpansEnabled(maybeOptions) {
		  if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) {
		    return false;
		  }
		  const options = maybeOptions || currentScopes.getClient()?.getOptions();
		  return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
		  (options.tracesSampleRate != null || !!options.tracesSampler);
		}

		exports.hasSpansEnabled = hasSpansEnabled;
		
	} (hasSpansEnabled));
	return hasSpansEnabled;
}

var shouldIgnoreSpan = {};

var hasRequiredShouldIgnoreSpan;

function requireShouldIgnoreSpan () {
	if (hasRequiredShouldIgnoreSpan) return shouldIgnoreSpan;
	hasRequiredShouldIgnoreSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const string = /*@__PURE__*/ requireString();

		function logIgnoredSpan(droppedSpan) {
		  debugLogger.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
		}
		function shouldIgnoreSpan(span, ignoreSpans) {
		  if (!ignoreSpans?.length) {
		    return false;
		  }
		  for (const pattern of ignoreSpans) {
		    if (isStringOrRegExp(pattern)) {
		      if (span.description && string.isMatchingPattern(span.description, pattern)) {
		        debugBuild.DEBUG_BUILD && logIgnoredSpan(span);
		        return true;
		      }
		      continue;
		    }
		    const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
		    if (!pattern.name && !pattern.op && !hasAttributes) {
		      continue;
		    }
		    const nameMatches = pattern.name ? span.description && string.isMatchingPattern(span.description, pattern.name) : true;
		    const opMatches = pattern.op ? span.op && string.isMatchingPattern(span.op, pattern.op) : true;
		    const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(
		      ([key, valuePattern]) => _matchesAttributeValue(span.attributes?.[key], valuePattern)
		    ) : true;
		    if (nameMatches && opMatches && attrsMatch) {
		      debugBuild.DEBUG_BUILD && logIgnoredSpan(span);
		      return true;
		    }
		  }
		  return false;
		}
		function _matchesAttributeValue(actual, pat) {
		  if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) {
		    return string.isMatchingPattern(actual, pat);
		  }
		  if (Array.isArray(actual) && Array.isArray(pat)) {
		    return actual.length === pat.length && actual.every((v, i) => v === pat[i]);
		  }
		  return actual === pat;
		}
		function reparentChildSpans(spans, dropSpan) {
		  const droppedSpanParentId = dropSpan.parent_span_id;
		  const droppedSpanId = dropSpan.span_id;
		  if (!droppedSpanParentId) {
		    return;
		  }
		  for (const span of spans) {
		    if (span.parent_span_id === droppedSpanId) {
		      span.parent_span_id = droppedSpanParentId;
		    }
		  }
		}
		function isStringOrRegExp(value) {
		  return typeof value === "string" || value instanceof RegExp;
		}

		exports.reparentChildSpans = reparentChildSpans;
		exports.shouldIgnoreSpan = shouldIgnoreSpan;
		
	} (shouldIgnoreSpan));
	return shouldIgnoreSpan;
}

var sentryNonRecordingSpan = {};

var hasRequiredSentryNonRecordingSpan;

function requireSentryNonRecordingSpan () {
	if (hasRequiredSentryNonRecordingSpan) return sentryNonRecordingSpan;
	hasRequiredSentryNonRecordingSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const object = /*@__PURE__*/ requireObject();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		const NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
		class SentryNonRecordingSpan {
		  constructor(spanContext = {}) {
		    this._traceId = spanContext.traceId || propagationContext.generateTraceId();
		    this._spanId = spanContext.spanId || propagationContext.generateSpanId();
		    this.dropReason = spanContext.dropReason;
		    object.addNonEnumerableProperty(this, NON_RECORDING_SPAN_FIELD, true);
		  }
		  /** @inheritdoc */
		  spanContext() {
		    return {
		      spanId: this._spanId,
		      traceId: this._traceId,
		      traceFlags: spanUtils.TRACE_FLAG_NONE
		    };
		  }
		  /** @inheritdoc */
		  end(_timestamp) {
		  }
		  /** @inheritdoc */
		  setAttribute(_key, _value) {
		    return this;
		  }
		  /** @inheritdoc */
		  setAttributes(_values) {
		    return this;
		  }
		  /** @inheritdoc */
		  setStatus(_status) {
		    return this;
		  }
		  /** @inheritdoc */
		  updateName(_name) {
		    return this;
		  }
		  /** @inheritdoc */
		  isRecording() {
		    return false;
		  }
		  /** @inheritdoc */
		  addEvent(_name, _attributesOrStartTime, _startTime) {
		    return this;
		  }
		  /** @inheritDoc */
		  addLink(_link) {
		    return this;
		  }
		  /** @inheritDoc */
		  addLinks(_links) {
		    return this;
		  }
		  /**
		   * This should generally not be used,
		   * but we need it for being compliant with the OTEL Span interface.
		   *
		   * @hidden
		   * @internal
		   */
		  recordException(_exception, _time) {
		  }
		}
		function spanIsNonRecordingSpan(span) {
		  return !!span && span[NON_RECORDING_SPAN_FIELD] === true;
		}

		exports.SentryNonRecordingSpan = SentryNonRecordingSpan;
		exports.spanIsNonRecordingSpan = spanIsNonRecordingSpan;
		
	} (sentryNonRecordingSpan));
	return sentryNonRecordingSpan;
}

var sentrySpan = {};

var envelope$4 = {};

var dynamicSamplingContext = {};

var constants$9 = {};

var hasRequiredConstants$9;

function requireConstants$9 () {
	if (hasRequiredConstants$9) return constants$9;
	hasRequiredConstants$9 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const DEFAULT_ENVIRONMENT = "production";
		const DEV_ENVIRONMENT = "development";

		exports.DEFAULT_ENVIRONMENT = DEFAULT_ENVIRONMENT;
		exports.DEV_ENVIRONMENT = DEV_ENVIRONMENT;
		
	} (constants$9));
	return constants$9;
}

var hasRequiredDynamicSamplingContext;

function requireDynamicSamplingContext () {
	if (hasRequiredDynamicSamplingContext) return dynamicSamplingContext;
	hasRequiredDynamicSamplingContext = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const constants = /*@__PURE__*/ requireConstants$9();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const baggage = /*@__PURE__*/ requireBaggage();
		const dsn = /*@__PURE__*/ requireDsn();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const object = /*@__PURE__*/ requireObject();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const sentryNonRecordingSpan = /*@__PURE__*/ requireSentryNonRecordingSpan();
		const utils = /*@__PURE__*/ requireUtils$g();

		const FROZEN_DSC_FIELD = "_frozenDsc";
		function freezeDscOnSpan(span, dsc) {
		  const spanWithMaybeDsc = span;
		  object.addNonEnumerableProperty(spanWithMaybeDsc, FROZEN_DSC_FIELD, dsc);
		}
		function getDynamicSamplingContextFromClient(trace_id, client) {
		  const options = client.getOptions();
		  const { publicKey: public_key } = client.getDsn() || {};
		  const dsc = {
		    environment: options.environment || constants.DEFAULT_ENVIRONMENT,
		    release: options.release,
		    public_key,
		    trace_id,
		    org_id: dsn.extractOrgIdFromClient(client)
		  };
		  client.emit("createDsc", dsc);
		  return dsc;
		}
		function getDynamicSamplingContextFromScope(client, scope) {
		  const propagationContext = scope.getPropagationContext();
		  return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
		}
		function getDynamicSamplingContextFromSpan(span) {
		  const client = currentScopes.getClient();
		  if (!client) {
		    return {};
		  }
		  const rootSpan = spanUtils.getRootSpan(span);
		  const rootSpanJson = spanUtils.spanToJSON(rootSpan);
		  const rootSpanAttributes = rootSpanJson.data;
		  const traceState = rootSpan.spanContext().traceState;
		  const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
		  function applyLocalSampleRateToDsc(dsc2) {
		    if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") {
		      dsc2.sample_rate = `${rootSpanSampleRate}`;
		    }
		    return dsc2;
		  }
		  const frozenDsc = rootSpan[FROZEN_DSC_FIELD];
		  if (frozenDsc) {
		    return applyLocalSampleRateToDsc(frozenDsc);
		  }
		  if (sentryNonRecordingSpan.spanIsNonRecordingSpan(rootSpan) && !hasSpansEnabled.hasSpansEnabled(client.getOptions())) {
		    const capturedScope = utils.getCapturedScopesOnSpan(rootSpan).scope;
		    if (capturedScope) {
		      return applyLocalSampleRateToDsc({ ...getDynamicSamplingContextFromScope(client, capturedScope) });
		    }
		  }
		  const traceStateDsc = traceState?.get("sentry.dsc");
		  const dscOnTraceState = traceStateDsc && baggage.baggageHeaderToDynamicSamplingContext(traceStateDsc);
		  if (dscOnTraceState) {
		    return applyLocalSampleRateToDsc(dscOnTraceState);
		  }
		  const dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
		  const source = rootSpanAttributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.span.source"];
		  const name = rootSpanJson.description;
		  if (source !== "url" && name) {
		    dsc.transaction = name;
		  }
		  if (hasSpansEnabled.hasSpansEnabled()) {
		    dsc.sampled = String(spanUtils.spanIsSampled(rootSpan));
		    dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
		    // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
		    traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
		    utils.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
		  }
		  applyLocalSampleRateToDsc(dsc);
		  client.emit("createDsc", dsc, rootSpan);
		  return dsc;
		}
		function spanToBaggageHeader(span) {
		  const dsc = getDynamicSamplingContextFromSpan(span);
		  return baggage.dynamicSamplingContextToSentryBaggageHeader(dsc);
		}

		exports.freezeDscOnSpan = freezeDscOnSpan;
		exports.getDynamicSamplingContextFromClient = getDynamicSamplingContextFromClient;
		exports.getDynamicSamplingContextFromScope = getDynamicSamplingContextFromScope;
		exports.getDynamicSamplingContextFromSpan = getDynamicSamplingContextFromSpan;
		exports.spanToBaggageHeader = spanToBaggageHeader;
		
	} (dynamicSamplingContext));
	return dynamicSamplingContext;
}

var beforeSendSpan = {};

var hasRequiredBeforeSendSpan;

function requireBeforeSendSpan () {
	if (hasRequiredBeforeSendSpan) return beforeSendSpan;
	hasRequiredBeforeSendSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const object = /*@__PURE__*/ requireObject();

		function withStreamedSpan(callback) {
		  object.addNonEnumerableProperty(callback, "_streamed", true);
		  return callback;
		}
		function isStreamedBeforeSendSpanCallback(callback) {
		  return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
		}

		exports.isStreamedBeforeSendSpanCallback = isStreamedBeforeSendSpanCallback;
		exports.withStreamedSpan = withStreamedSpan;
		
	} (beforeSendSpan));
	return beforeSendSpan;
}

var envelope$3 = {};

var hasRequiredEnvelope$4;

function requireEnvelope$4 () {
	if (hasRequiredEnvelope$4) return envelope$3;
	hasRequiredEnvelope$4 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const carrier = /*@__PURE__*/ requireCarrier();
		const dsn = /*@__PURE__*/ requireDsn();
		const normalize = /*@__PURE__*/ requireNormalize();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		function createEnvelope(headers, items = []) {
		  return [headers, items];
		}
		function addItemToEnvelope(envelope, newItem) {
		  const [headers, items] = envelope;
		  return [headers, [...items, newItem]];
		}
		function forEachEnvelopeItem(envelope, callback) {
		  const envelopeItems = envelope[1];
		  for (const envelopeItem of envelopeItems) {
		    const envelopeItemType = envelopeItem[0].type;
		    const result = callback(envelopeItem, envelopeItemType);
		    if (result) {
		      return true;
		    }
		  }
		  return false;
		}
		function envelopeContainsItemType(envelope, types) {
		  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
		}
		function encodeUTF8(input) {
		  const carrier$1 = carrier.getSentryCarrier(worldwide.GLOBAL_OBJ);
		  return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
		}
		function decodeUTF8(input) {
		  const carrier$1 = carrier.getSentryCarrier(worldwide.GLOBAL_OBJ);
		  return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
		}
		function serializeEnvelope(envelope) {
		  const [envHeaders, items] = envelope;
		  let parts = JSON.stringify(envHeaders);
		  function append(next) {
		    if (typeof parts === "string") {
		      parts = typeof next === "string" ? parts + next : [encodeUTF8(parts), next];
		    } else {
		      parts.push(typeof next === "string" ? encodeUTF8(next) : next);
		    }
		  }
		  for (const item of items) {
		    const [itemHeaders, payload] = item;
		    append(`
${JSON.stringify(itemHeaders)}
`);
		    if (typeof payload === "string" || payload instanceof Uint8Array) {
		      append(payload);
		    } else {
		      let stringifiedPayload;
		      try {
		        stringifiedPayload = JSON.stringify(payload);
		      } catch {
		        stringifiedPayload = JSON.stringify(normalize.normalize(payload));
		      }
		      append(stringifiedPayload);
		    }
		  }
		  return typeof parts === "string" ? parts : concatBuffers(parts);
		}
		function concatBuffers(buffers) {
		  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);
		  const merged = new Uint8Array(totalLength);
		  let offset = 0;
		  for (const buffer of buffers) {
		    merged.set(buffer, offset);
		    offset += buffer.length;
		  }
		  return merged;
		}
		function parseEnvelope(env) {
		  let buffer = typeof env === "string" ? encodeUTF8(env) : env;
		  function readBinary(length) {
		    const bin = buffer.subarray(0, length);
		    buffer = buffer.subarray(length + 1);
		    return bin;
		  }
		  function readJson() {
		    let i = buffer.indexOf(10);
		    if (i < 0) {
		      i = buffer.length;
		    }
		    return JSON.parse(decodeUTF8(readBinary(i)));
		  }
		  const envelopeHeader = readJson();
		  const items = [];
		  while (buffer.length) {
		    const itemHeader = readJson();
		    const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
		    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
		  }
		  return [envelopeHeader, items];
		}
		function createSpanEnvelopeItem(spanJson) {
		  const spanHeaders = {
		    type: "span"
		  };
		  return [spanHeaders, spanJson];
		}
		function createAttachmentEnvelopeItem(attachment) {
		  const buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data) : attachment.data;
		  return [
		    {
		      type: "attachment",
		      length: buffer.length,
		      filename: attachment.filename,
		      content_type: attachment.contentType,
		      attachment_type: attachment.attachmentType
		    },
		    buffer
		  ];
		}
		const DATA_CATEGORY_OVERRIDES = {
		  sessions: "session",
		  event: "error",
		  client_report: "internal",
		  user_report: "default",
		  profile_chunk: "profile",
		  replay_event: "replay",
		  replay_recording: "replay",
		  check_in: "monitor",
		  raw_security: "security",
		  log: "log_item",
		  trace_metric: "metric"
		};
		function _isOverriddenType(type) {
		  return type in DATA_CATEGORY_OVERRIDES;
		}
		function envelopeItemTypeToDataCategory(type) {
		  return _isOverriddenType(type) ? DATA_CATEGORY_OVERRIDES[type] : type;
		}
		function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
		  if (!metadataOrEvent?.sdk) {
		    return;
		  }
		  const { name, version } = metadataOrEvent.sdk;
		  return { name, version };
		}
		function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
		  const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
		  return {
		    event_id: event.event_id,
		    sent_at: new Date(randomSafeContext.safeDateNow()).toISOString(),
		    ...sdkInfo && { sdk: sdkInfo },
		    ...!!tunnel && dsn$1 && { dsn: dsn.dsnToString(dsn$1) },
		    ...dynamicSamplingContext && {
		      trace: dynamicSamplingContext
		    }
		  };
		}

		exports.addItemToEnvelope = addItemToEnvelope;
		exports.createAttachmentEnvelopeItem = createAttachmentEnvelopeItem;
		exports.createEnvelope = createEnvelope;
		exports.createEventEnvelopeHeaders = createEventEnvelopeHeaders;
		exports.createSpanEnvelopeItem = createSpanEnvelopeItem;
		exports.envelopeContainsItemType = envelopeContainsItemType;
		exports.envelopeItemTypeToDataCategory = envelopeItemTypeToDataCategory;
		exports.forEachEnvelopeItem = forEachEnvelopeItem;
		exports.getSdkMetadataForEnvelopeHeader = getSdkMetadataForEnvelopeHeader;
		exports.parseEnvelope = parseEnvelope;
		exports.serializeEnvelope = serializeEnvelope;
		
	} (envelope$3));
	return envelope$3;
}

var hasRequiredEnvelope$3;

function requireEnvelope$3 () {
	if (hasRequiredEnvelope$3) return envelope$4;
	hasRequiredEnvelope$3 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const beforeSendSpan = /*@__PURE__*/ requireBeforeSendSpan();
		const dsn = /*@__PURE__*/ requireDsn();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const shouldIgnoreSpan = /*@__PURE__*/ requireShouldIgnoreSpan();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		function _enhanceEventWithSdkInfo(event, newSdkInfo) {
		  if (!newSdkInfo) {
		    return event;
		  }
		  const eventSdkInfo = event.sdk || {};
		  event.sdk = {
		    ...eventSdkInfo,
		    name: eventSdkInfo.name || newSdkInfo.name,
		    version: eventSdkInfo.version || newSdkInfo.version,
		    integrations: [...event.sdk?.integrations || [], ...newSdkInfo.integrations || []],
		    packages: [...event.sdk?.packages || [], ...newSdkInfo.packages || []],
		    settings: event.sdk?.settings || newSdkInfo.settings ? {
		      ...event.sdk?.settings,
		      ...newSdkInfo.settings
		    } : void 0
		  };
		  return event;
		}
		function createSessionEnvelope(session, dsn$1, metadata, tunnel) {
		  const sdkInfo = envelope.getSdkMetadataForEnvelopeHeader(metadata);
		  const envelopeHeaders = {
		    sent_at: new Date(randomSafeContext.safeDateNow()).toISOString(),
		    ...sdkInfo && { sdk: sdkInfo },
		    ...!!tunnel && dsn$1 && { dsn: dsn.dsnToString(dsn$1) }
		  };
		  const envelopeItem = "aggregates" in session ? [{ type: "sessions" }, session] : [{ type: "session" }, session.toJSON()];
		  return envelope.createEnvelope(envelopeHeaders, [envelopeItem]);
		}
		function createEventEnvelope(event, dsn, metadata, tunnel) {
		  const sdkInfo = envelope.getSdkMetadataForEnvelopeHeader(metadata);
		  const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
		  _enhanceEventWithSdkInfo(event, metadata?.sdk);
		  const envelopeHeaders = envelope.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
		  delete event.sdkProcessingMetadata;
		  const eventItem = [{ type: eventType }, event];
		  return envelope.createEnvelope(envelopeHeaders, [eventItem]);
		}
		function createSpanEnvelope(spans, client) {
		  function dscHasRequiredProps(dsc2) {
		    return !!dsc2.trace_id && !!dsc2.public_key;
		  }
		  const dsc = dynamicSamplingContext.getDynamicSamplingContextFromSpan(spans[0]);
		  const dsn$1 = client?.getDsn();
		  const tunnel = client?.getOptions().tunnel;
		  const headers = {
		    sent_at: new Date(randomSafeContext.safeDateNow()).toISOString(),
		    ...dscHasRequiredProps(dsc) && { trace: dsc },
		    ...!!tunnel && dsn$1 && { dsn: dsn.dsnToString(dsn$1) }
		  };
		  const { beforeSendSpan: beforeSendSpan$1, ignoreSpans } = client?.getOptions() || {};
		  const filteredSpans = ignoreSpans?.length ? spans.filter((span) => {
		    const json = spanUtils.spanToJSON(span);
		    return !shouldIgnoreSpan.shouldIgnoreSpan({ description: json.description, op: json.op, attributes: json.data }, ignoreSpans);
		  }) : spans;
		  const droppedSpans = spans.length - filteredSpans.length;
		  if (droppedSpans) {
		    client?.recordDroppedEvent("before_send", "span", droppedSpans);
		  }
		  const convertToSpanJSON = beforeSendSpan$1 ? (span) => {
		    const spanJson = spanUtils.spanToJSON(span);
		    const processedSpan = !beforeSendSpan.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
		    if (!processedSpan) {
		      spanUtils.showSpanDropWarning();
		      return spanJson;
		    }
		    return processedSpan;
		  } : spanUtils.spanToJSON;
		  const items = [];
		  for (const span of filteredSpans) {
		    const spanJson = convertToSpanJSON(span);
		    if (spanJson) {
		      items.push(envelope.createSpanEnvelopeItem(spanJson));
		    }
		  }
		  return envelope.createEnvelope(headers, items);
		}

		exports._enhanceEventWithSdkInfo = _enhanceEventWithSdkInfo;
		exports.createEventEnvelope = createEventEnvelope;
		exports.createSessionEnvelope = createSessionEnvelope;
		exports.createSpanEnvelope = createSpanEnvelope;
		
	} (envelope$4));
	return envelope$4;
}

var logSpans = {};

var hasRequiredLogSpans;

function requireLogSpans () {
	if (hasRequiredLogSpans) return logSpans;
	hasRequiredLogSpans = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		function logSpanStart(span) {
		  if (!debugBuild.DEBUG_BUILD) return;
		  const { description = "< unknown name >", op = "< unknown op >", parent_span_id: parentSpanId } = spanUtils.spanToJSON(span);
		  const { spanId } = span.spanContext();
		  const sampled = spanUtils.spanIsSampled(span);
		  const rootSpan = spanUtils.getRootSpan(span);
		  const isRootSpan = rootSpan === span;
		  const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
		  const infoParts = [`op: ${op}`, `name: ${description}`, `ID: ${spanId}`];
		  if (parentSpanId) {
		    infoParts.push(`parent ID: ${parentSpanId}`);
		  }
		  if (!isRootSpan) {
		    const { op: op2, description: description2 } = spanUtils.spanToJSON(rootSpan);
		    infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
		    if (op2) {
		      infoParts.push(`root op: ${op2}`);
		    }
		    if (description2) {
		      infoParts.push(`root description: ${description2}`);
		    }
		  }
		  debugLogger.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
		}
		function logSpanEnd(span) {
		  if (!debugBuild.DEBUG_BUILD) return;
		  const { description = "< unknown name >", op = "< unknown op >" } = spanUtils.spanToJSON(span);
		  const { spanId } = span.spanContext();
		  const rootSpan = spanUtils.getRootSpan(span);
		  const isRootSpan = rootSpan === span;
		  const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
		  debugLogger.debug.log(msg);
		}

		exports.logSpanEnd = logSpanEnd;
		exports.logSpanStart = logSpanStart;
		
	} (logSpans));
	return logSpans;
}

var measurement = {};

var hasRequiredMeasurement;

function requireMeasurement () {
	if (hasRequiredMeasurement) return measurement;
	hasRequiredMeasurement = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		function setMeasurement(name, value, unit, activeSpan = spanUtils.getActiveSpan()) {
		  const rootSpan = activeSpan && spanUtils.getRootSpan(activeSpan);
		  if (rootSpan) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
		    rootSpan.addEvent(name, {
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
		    });
		  }
		}
		function timedEventsToMeasurements(events) {
		  if (!events || events.length === 0) {
		    return void 0;
		  }
		  const measurements = {};
		  events.forEach((event) => {
		    const attributes = event.attributes || {};
		    const unit = attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
		    const value = attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
		    if (typeof unit === "string" && typeof value === "number") {
		      measurements[event.name] = { value, unit };
		    }
		  });
		  return measurements;
		}

		exports.setMeasurement = setMeasurement;
		exports.timedEventsToMeasurements = timedEventsToMeasurements;
		
	} (measurement));
	return measurement;
}

var hasSpanStreamingEnabled = {};

var hasRequiredHasSpanStreamingEnabled;

function requireHasSpanStreamingEnabled () {
	if (hasRequiredHasSpanStreamingEnabled) return hasSpanStreamingEnabled;
	hasRequiredHasSpanStreamingEnabled = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function hasSpanStreamingEnabled(client) {
		  return client.getOptions().traceLifecycle === "stream";
		}

		exports.hasSpanStreamingEnabled = hasSpanStreamingEnabled;
		
	} (hasSpanStreamingEnabled));
	return hasSpanStreamingEnabled;
}

var hasRequiredSentrySpan;

function requireSentrySpan () {
	if (hasRequiredSentrySpan) return sentrySpan;
	hasRequiredSentrySpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const envelope = /*@__PURE__*/ requireEnvelope$3();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const time = /*@__PURE__*/ requireTime();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const logSpans = /*@__PURE__*/ requireLogSpans();
		const measurement = /*@__PURE__*/ requireMeasurement();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const utils = /*@__PURE__*/ requireUtils$g();

		const MAX_SPAN_COUNT = 1e3;
		class SentrySpan {
		  /**
		   * You should never call the constructor manually, always use `Sentry.startSpan()`
		   * or other span methods.
		   * @internal
		   * @hideconstructor
		   * @hidden
		   */
		  constructor(spanContext = {}) {
		    this._traceId = spanContext.traceId || propagationContext.generateTraceId();
		    this._spanId = spanContext.spanId || propagationContext.generateSpanId();
		    this._startTime = spanContext.startTimestamp || time.timestampInSeconds();
		    this._links = spanContext.links;
		    this._attributes = {};
		    this.setAttributes({
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
		      ...spanContext.attributes
		    });
		    this._name = spanContext.name;
		    if (spanContext.parentSpanId) {
		      this._parentSpanId = spanContext.parentSpanId;
		    }
		    if ("sampled" in spanContext) {
		      this._sampled = spanContext.sampled;
		    }
		    if (spanContext.endTimestamp) {
		      this._endTime = spanContext.endTimestamp;
		    }
		    this._events = [];
		    this._isStandaloneSpan = spanContext.isStandalone;
		    if (this._endTime) {
		      this._onSpanEnded();
		    }
		  }
		  /** @inheritDoc */
		  addLink(link) {
		    if (this._links) {
		      this._links.push(link);
		    } else {
		      this._links = [link];
		    }
		    return this;
		  }
		  /** @inheritDoc */
		  addLinks(links) {
		    if (this._links) {
		      this._links.push(...links);
		    } else {
		      this._links = links;
		    }
		    return this;
		  }
		  /**
		   * This should generally not be used,
		   * but it is needed for being compliant with the OTEL Span interface.
		   *
		   * @hidden
		   * @internal
		   */
		  recordException(_exception, _time) {
		  }
		  /** @inheritdoc */
		  spanContext() {
		    const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
		    return {
		      spanId,
		      traceId,
		      traceFlags: sampled ? spanUtils.TRACE_FLAG_SAMPLED : spanUtils.TRACE_FLAG_NONE
		    };
		  }
		  /** @inheritdoc */
		  setAttribute(key, value) {
		    if (value === void 0) {
		      delete this._attributes[key];
		    } else {
		      this._attributes[key] = value;
		    }
		    return this;
		  }
		  /** @inheritdoc */
		  setAttributes(attributes) {
		    Object.keys(attributes).forEach((key) => this.setAttribute(key, attributes[key]));
		    return this;
		  }
		  /**
		   * This should generally not be used,
		   * but we need it for browser tracing where we want to adjust the start time afterwards.
		   * USE THIS WITH CAUTION!
		   *
		   * @hidden
		   * @internal
		   */
		  updateStartTime(timeInput) {
		    this._startTime = spanUtils.spanTimeInputToSeconds(timeInput);
		  }
		  /**
		   * @inheritDoc
		   */
		  setStatus(value) {
		    this._status = value;
		    return this;
		  }
		  /**
		   * @inheritDoc
		   */
		  updateName(name) {
		    this._name = name;
		    if (!utils.spanShouldInferOtelSource(this)) {
		      this.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
		    }
		    return this;
		  }
		  /** @inheritdoc */
		  end(endTimestamp) {
		    if (this._endTime) {
		      return;
		    }
		    this._endTime = spanUtils.spanTimeInputToSeconds(endTimestamp);
		    logSpans.logSpanEnd(this);
		    this._onSpanEnded();
		  }
		  /**
		   * Get JSON representation of this span.
		   *
		   * @hidden
		   * @internal This method is purely for internal purposes and should not be used outside
		   * of SDK code. If you need to get a JSON representation of a span,
		   * use `spanToJSON(span)` instead.
		   */
		  getSpanJSON() {
		    return {
		      data: this._attributes,
		      description: this._name,
		      op: this._attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP],
		      parent_span_id: this._parentSpanId,
		      span_id: this._spanId,
		      start_timestamp: this._startTime,
		      status: spanUtils.getStatusMessage(this._status),
		      timestamp: this._endTime,
		      trace_id: this._traceId,
		      origin: this._attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
		      profile_id: this._attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID],
		      exclusive_time: this._attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
		      measurements: measurement.timedEventsToMeasurements(this._events),
		      is_segment: this._isStandaloneSpan && spanUtils.getRootSpan(this) === this || void 0,
		      segment_id: this._isStandaloneSpan ? spanUtils.getRootSpan(this).spanContext().spanId : void 0,
		      links: spanUtils.convertSpanLinksForEnvelope(this._links)
		    };
		  }
		  /**
		   * Get {@link StreamedSpanJSON} representation of this span.
		   *
		   * @hidden
		   * @internal This method is purely for internal purposes and should not be used outside
		   * of SDK code. If you need to get a JSON representation of a span,
		   * use `spanToStreamedSpanJSON(span)` instead.
		   */
		  getStreamedSpanJSON() {
		    return {
		      name: this._name ?? "",
		      span_id: this._spanId,
		      trace_id: this._traceId,
		      parent_span_id: this._parentSpanId,
		      start_timestamp: this._startTime,
		      // just in case _endTime is not set, we use the start time (i.e. duration 0)
		      end_timestamp: this._endTime ?? this._startTime,
		      is_segment: this._isStandaloneSpan || this === spanUtils.getRootSpan(this),
		      status: spanUtils.getSimpleStatusMessage(this._status),
		      attributes: this._attributes,
		      links: spanUtils.getStreamedSpanLinks(this._links)
		    };
		  }
		  /** @inheritdoc */
		  isRecording() {
		    return !this._endTime && !!this._sampled;
		  }
		  /**
		   * @inheritdoc
		   */
		  addEvent(name, attributesOrStartTime, startTime) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("[Tracing] Adding an event to span:", name);
		    const time$1 = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || time.timestampInSeconds();
		    const attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
		    const event = {
		      name,
		      time: spanUtils.spanTimeInputToSeconds(time$1),
		      attributes
		    };
		    this._events.push(event);
		    return this;
		  }
		  /**
		   * This method should generally not be used,
		   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
		   * USE THIS WITH CAUTION!
		   * @internal
		   * @hidden
		   * @experimental
		   */
		  isStandaloneSpan() {
		    return !!this._isStandaloneSpan;
		  }
		  /** Emit `spanEnd` when the span is ended. */
		  _onSpanEnded() {
		    const client = currentScopes.getClient();
		    if (client) {
		      client.emit("spanEnd", this);
		      if (!this._isStandaloneSpan) {
		        client.emit("afterSpanEnd", this);
		      }
		    }
		    const isSegmentSpan = this._isStandaloneSpan || this === spanUtils.getRootSpan(this);
		    if (!isSegmentSpan) {
		      return;
		    }
		    if (this._isStandaloneSpan) {
		      if (this._sampled) {
		        sendSpanEnvelope(envelope.createSpanEnvelope([this], client));
		      } else {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
		        if (client) {
		          client.recordDroppedEvent("sample_rate", "span");
		        }
		      }
		      return;
		    } else if (client && hasSpanStreamingEnabled.hasSpanStreamingEnabled(client)) {
		      client.emit("afterSegmentSpanEnd", this);
		      return;
		    }
		    const transactionEvent = this._convertSpanToTransaction();
		    if (transactionEvent) {
		      const scope = utils.getCapturedScopesOnSpan(this).scope || currentScopes.getCurrentScope();
		      scope.captureEvent(transactionEvent);
		    }
		  }
		  /**
		   * Finish the transaction & prepare the event to send to Sentry.
		   */
		  _convertSpanToTransaction() {
		    if (!isFullFinishedSpan(spanUtils.spanToJSON(this))) {
		      return void 0;
		    }
		    if (!this._name) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
		      this._name = "<unlabeled transaction>";
		    }
		    const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = utils.getCapturedScopesOnSpan(this);
		    const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
		    if (this._sampled !== true) {
		      return void 0;
		    }
		    const finishedSpans = spanUtils.getSpanDescendants(this).filter((span) => span !== this && !isStandaloneSpan(span));
		    const spans = finishedSpans.map((span) => spanUtils.spanToJSON(span)).filter(isFullFinishedSpan);
		    const source = this._attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
		    delete this._attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
		    let hasGenAiSpans = false;
		    spans.forEach((span) => {
		      delete span.data[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
		      if (span.op?.startsWith("gen_ai.")) {
		        hasGenAiSpans = true;
		      }
		    });
		    const transaction = {
		      contexts: {
		        trace: spanUtils.spanToTransactionTraceContext(this)
		      },
		      spans: (
		        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
		        // we do not use spans anymore after this point
		        spans.length > MAX_SPAN_COUNT ? spans.sort((a, b) => a.start_timestamp - b.start_timestamp).slice(0, MAX_SPAN_COUNT) : spans
		      ),
		      start_timestamp: this._startTime,
		      timestamp: this._endTime,
		      transaction: this._name,
		      type: "transaction",
		      sdkProcessingMetadata: {
		        capturedSpanScope,
		        capturedSpanIsolationScope,
		        dynamicSamplingContext: dynamicSamplingContext.getDynamicSamplingContextFromSpan(this),
		        hasGenAiSpans
		      },
		      request: normalizedRequest,
		      ...source && {
		        transaction_info: {
		          source
		        }
		      }
		    };
		    const measurements = measurement.timedEventsToMeasurements(this._events);
		    const hasMeasurements = measurements && Object.keys(measurements).length;
		    if (hasMeasurements) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(
		        "[Measurements] Adding measurements to transaction event",
		        JSON.stringify(measurements, void 0, 2)
		      );
		      transaction.measurements = measurements;
		    }
		    return transaction;
		  }
		}
		function isSpanTimeInput(value) {
		  return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
		}
		function isFullFinishedSpan(input) {
		  return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
		}
		function isStandaloneSpan(span) {
		  return span instanceof SentrySpan && span.isStandaloneSpan();
		}
		function sendSpanEnvelope(envelope) {
		  const client = currentScopes.getClient();
		  if (!client) {
		    return;
		  }
		  const spanItems = envelope[1];
		  if (!spanItems || spanItems.length === 0) {
		    client.recordDroppedEvent("before_send", "span");
		    return;
		  }
		  client.sendEnvelope(envelope);
		}

		exports.SentrySpan = SentrySpan;
		
	} (sentrySpan));
	return sentrySpan;
}

var trace = {};

var handleCallbackErrors = {};

var hasRequiredHandleCallbackErrors;

function requireHandleCallbackErrors () {
	if (hasRequiredHandleCallbackErrors) return handleCallbackErrors;
	hasRequiredHandleCallbackErrors = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const chainAndCopyPromiselike = /*@__PURE__*/ requireChainAndCopyPromiselike();
		const is = /*@__PURE__*/ requireIs$1();

		function handleCallbackErrors(fn, onError, onFinally = () => {
		}, onSuccess = () => {
		}) {
		  let maybePromiseResult;
		  try {
		    maybePromiseResult = fn();
		  } catch (e) {
		    onError(e);
		    onFinally();
		    throw e;
		  }
		  return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
		}
		function maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
		  if (is.isThenable(value)) {
		    return chainAndCopyPromiselike.chainAndCopyPromiseLike(
		      value,
		      (result) => {
		        onFinally();
		        onSuccess(result);
		      },
		      (err) => {
		        onError(err);
		        onFinally();
		      }
		    );
		  }
		  onFinally();
		  onSuccess(value);
		  return value;
		}

		exports.handleCallbackErrors = handleCallbackErrors;
		
	} (handleCallbackErrors));
	return handleCallbackErrors;
}

var sampling = {};

var hasRequiredSampling;

function requireSampling () {
	if (hasRequiredSampling) return sampling;
	hasRequiredSampling = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const parseSampleRate = /*@__PURE__*/ requireParseSampleRate();

		function sampleSpan(options, samplingContext, sampleRand) {
		  if (!hasSpansEnabled.hasSpansEnabled(options)) {
		    return [false];
		  }
		  let localSampleRateWasApplied = void 0;
		  let sampleRate;
		  if (typeof options.tracesSampler === "function") {
		    sampleRate = options.tracesSampler({
		      ...samplingContext,
		      inheritOrSampleWith: (fallbackSampleRate) => {
		        if (typeof samplingContext.parentSampleRate === "number") {
		          return samplingContext.parentSampleRate;
		        }
		        if (typeof samplingContext.parentSampled === "boolean") {
		          return Number(samplingContext.parentSampled);
		        }
		        return fallbackSampleRate;
		      }
		    });
		    localSampleRateWasApplied = true;
		  } else if (samplingContext.parentSampled !== void 0) {
		    sampleRate = samplingContext.parentSampled;
		  } else if (typeof options.tracesSampleRate !== "undefined") {
		    sampleRate = options.tracesSampleRate;
		    localSampleRateWasApplied = true;
		  }
		  const parsedSampleRate = parseSampleRate.parseSampleRate(sampleRate);
		  if (parsedSampleRate === void 0) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		      `[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
		        sampleRate
		      )} of type ${JSON.stringify(typeof sampleRate)}.`
		    );
		    return [false];
		  }
		  if (!parsedSampleRate) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(
		      `[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
		    );
		    return [false, parsedSampleRate, localSampleRateWasApplied];
		  }
		  const shouldSample = sampleRand < parsedSampleRate;
		  if (!shouldSample) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(
		      `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
		        sampleRate
		      )})`
		    );
		  }
		  return [shouldSample, parsedSampleRate, localSampleRateWasApplied];
		}

		exports.sampleSpan = sampleSpan;
		
	} (sampling));
	return sampling;
}

var hasRequiredTrace;

function requireTrace () {
	if (hasRequiredTrace) return trace;
	hasRequiredTrace = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const index = /*@__PURE__*/ requireAsyncContext();
		const carrier = /*@__PURE__*/ requireCarrier();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const baggage = /*@__PURE__*/ requireBaggage();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const handleCallbackErrors = /*@__PURE__*/ requireHandleCallbackErrors();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const shouldIgnoreSpan = /*@__PURE__*/ requireShouldIgnoreSpan();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const parseSampleRate = /*@__PURE__*/ requireParseSampleRate();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const tracing = /*@__PURE__*/ requireTracing();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const logSpans = /*@__PURE__*/ requireLogSpans();
		const sampling = /*@__PURE__*/ requireSampling();
		const sentryNonRecordingSpan = /*@__PURE__*/ requireSentryNonRecordingSpan();
		const sentrySpan = /*@__PURE__*/ requireSentrySpan();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const utils = /*@__PURE__*/ requireUtils$g();

		const SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
		function startSpan(options, callback) {
		  const acs = getAcs();
		  if (acs.startSpan) {
		    return acs.startSpan(options, callback);
		  }
		  const spanArguments = parseSentrySpanArguments(options);
		  const { forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
		  const customForkedScope = customScope?.clone();
		  return currentScopes.withScope(customForkedScope, () => {
		    const wrapper = getActiveSpanWrapper(customParentSpan);
		    return wrapper(() => {
		      const scope = currentScopes.getCurrentScope();
		      const parentSpan = getParentSpan(scope, customParentSpan);
		      const client = currentScopes.getClient();
		      const missingRequiredParent = options.onlyIfParent && !parentSpan;
		      const activeSpan = missingRequiredParent ? startMissingRequiredParentSpan(scope, client) : createChildOrRootSpan({
		        parentSpan,
		        spanArguments,
		        forceTransaction,
		        scope
		      });
		      if (!_isIgnoredSpan(activeSpan) || !parentSpan) {
		        spanOnScope._setSpanForScope(scope, activeSpan);
		      }
		      return handleCallbackErrors.handleCallbackErrors(
		        () => callback(activeSpan),
		        () => {
		          const { status } = spanUtils.spanToJSON(activeSpan);
		          if (activeSpan.isRecording() && (!status || status === "ok")) {
		            activeSpan.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		          }
		        },
		        () => {
		          activeSpan.end();
		        }
		      );
		    });
		  });
		}
		function startSpanManual(options, callback) {
		  const acs = getAcs();
		  if (acs.startSpanManual) {
		    return acs.startSpanManual(options, callback);
		  }
		  const spanArguments = parseSentrySpanArguments(options);
		  const { forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
		  const customForkedScope = customScope?.clone();
		  return currentScopes.withScope(customForkedScope, () => {
		    const wrapper = getActiveSpanWrapper(customParentSpan);
		    return wrapper(() => {
		      const scope = currentScopes.getCurrentScope();
		      const parentSpan = getParentSpan(scope, customParentSpan);
		      const missingRequiredParent = options.onlyIfParent && !parentSpan;
		      const activeSpan = missingRequiredParent ? startMissingRequiredParentSpan(scope, currentScopes.getClient()) : createChildOrRootSpan({
		        parentSpan,
		        spanArguments,
		        forceTransaction,
		        scope
		      });
		      if (!_isIgnoredSpan(activeSpan) || !parentSpan) {
		        spanOnScope._setSpanForScope(scope, activeSpan);
		      }
		      return handleCallbackErrors.handleCallbackErrors(
		        // We pass the `finish` function to the callback, so the user can finish the span manually
		        // this is mainly here for historic purposes because previously, we instructed users to call
		        // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
		        // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
		        () => callback(activeSpan, () => activeSpan.end()),
		        () => {
		          const { status } = spanUtils.spanToJSON(activeSpan);
		          if (activeSpan.isRecording() && (!status || status === "ok")) {
		            activeSpan.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		          }
		        }
		      );
		    });
		  });
		}
		function startInactiveSpan(options) {
		  const acs = getAcs();
		  if (acs.startInactiveSpan) {
		    return acs.startInactiveSpan(options);
		  }
		  const spanArguments = parseSentrySpanArguments(options);
		  const { forceTransaction, parentSpan: customParentSpan } = options;
		  const wrapper = options.scope ? (callback) => currentScopes.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback) => withActiveSpan(customParentSpan, callback) : (callback) => callback();
		  return wrapper(() => {
		    const scope = currentScopes.getCurrentScope();
		    const parentSpan = getParentSpan(scope, customParentSpan);
		    const client = currentScopes.getClient();
		    const missingRequiredParent = options.onlyIfParent && !parentSpan;
		    if (missingRequiredParent) {
		      return startMissingRequiredParentSpan(scope, client);
		    }
		    return createChildOrRootSpan({
		      parentSpan,
		      spanArguments,
		      forceTransaction,
		      scope
		    });
		  });
		}
		const continueTrace = (options, callback) => {
		  const carrier$1 = carrier.getMainCarrier();
		  const acs = index.getAsyncContextStrategy(carrier$1);
		  if (acs.continueTrace) {
		    return acs.continueTrace(options, callback);
		  }
		  const { sentryTrace, baggage: baggage$1 } = options;
		  const client = currentScopes.getClient();
		  const incomingDsc = baggage.baggageHeaderToDynamicSamplingContext(baggage$1);
		  if (client && !tracing.shouldContinueTrace(client, incomingDsc?.org_id)) {
		    return startNewTrace(callback);
		  }
		  return currentScopes.withScope((scope) => {
		    const propagationContext = tracing.propagationContextFromHeaders(sentryTrace, baggage$1);
		    scope.setPropagationContext(propagationContext);
		    spanOnScope._setSpanForScope(scope, void 0);
		    return callback();
		  });
		};
		function withActiveSpan(span, callback) {
		  const acs = getAcs();
		  if (acs.withActiveSpan) {
		    return acs.withActiveSpan(span, callback);
		  }
		  return currentScopes.withScope((scope) => {
		    spanOnScope._setSpanForScope(scope, span || void 0);
		    return callback(scope);
		  });
		}
		function suppressTracing(callback) {
		  const acs = getAcs();
		  if (acs.suppressTracing) {
		    return acs.suppressTracing(callback);
		  }
		  return currentScopes.withScope((scope) => {
		    scope.setSDKProcessingMetadata({ [SUPPRESS_TRACING_KEY]: true });
		    const res = callback();
		    scope.setSDKProcessingMetadata({ [SUPPRESS_TRACING_KEY]: void 0 });
		    return res;
		  });
		}
		function startNewTrace(callback) {
		  const acs = getAcs();
		  if (acs.startNewTrace) {
		    return acs.startNewTrace(callback);
		  }
		  return currentScopes.withScope((scope) => {
		    scope.setPropagationContext({
		      traceId: propagationContext.generateTraceId(),
		      sampleRand: randomSafeContext.safeMathRandom()
		    });
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
		    return withActiveSpan(null, callback);
		  });
		}
		function startMissingRequiredParentSpan(scope, client) {
		  client?.recordDroppedEvent("no_parent_span", "span");
		  const span = new sentryNonRecordingSpan.SentryNonRecordingSpan({ traceId: scope.getPropagationContext().traceId });
		  utils.setCapturedScopesOnSpan(span, scope, currentScopes.getIsolationScope());
		  return span;
		}
		function createChildOrRootSpan({
		  parentSpan,
		  spanArguments,
		  forceTransaction,
		  scope
		}) {
		  const isolationScope = currentScopes.getIsolationScope();
		  if (!hasSpansEnabled.hasSpansEnabled()) {
		    const scopePropagationContext = { ...isolationScope.getPropagationContext(), ...scope.getPropagationContext() };
		    const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
		    const span2 = new sentryNonRecordingSpan.SentryNonRecordingSpan({ traceId });
		    if (parentSpan && !forceTransaction) {
		      spanUtils.addChildSpanToSpan(parentSpan, span2);
		    }
		    utils.setCapturedScopesOnSpan(span2, scope, isolationScope);
		    return span2;
		  }
		  const client = currentScopes.getClient();
		  if (_shouldIgnoreStreamedSpan(client, spanArguments)) {
		    if (!_isTracingSuppressed(scope)) {
		      client?.recordDroppedEvent("ignored", "span");
		    }
		    const ignoredSpan = new sentryNonRecordingSpan.SentryNonRecordingSpan({
		      dropReason: "ignored",
		      traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
		    });
		    utils.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
		    return ignoredSpan;
		  }
		  let span;
		  if (parentSpan && !forceTransaction) {
		    span = _startChildSpan(parentSpan, scope, spanArguments, isolationScope);
		    spanUtils.addChildSpanToSpan(parentSpan, span);
		  } else if (parentSpan) {
		    const dsc = dynamicSamplingContext.getDynamicSamplingContextFromSpan(parentSpan);
		    const { traceId, spanId: parentSpanId } = parentSpan.spanContext();
		    const parentSampled = spanUtils.spanIsSampled(parentSpan);
		    span = _startRootSpan(
		      {
		        traceId,
		        parentSpanId,
		        ...spanArguments
		      },
		      scope,
		      isolationScope,
		      parentSampled
		    );
		    dynamicSamplingContext.freezeDscOnSpan(span, dsc);
		  } else {
		    const {
		      traceId,
		      dsc,
		      parentSpanId,
		      sampled: parentSampled
		    } = {
		      ...isolationScope.getPropagationContext(),
		      ...scope.getPropagationContext()
		    };
		    span = _startRootSpan(
		      {
		        traceId,
		        parentSpanId,
		        ...spanArguments
		      },
		      scope,
		      isolationScope,
		      parentSampled
		    );
		    if (dsc) {
		      dynamicSamplingContext.freezeDscOnSpan(span, dsc);
		    }
		  }
		  logSpans.logSpanStart(span);
		  return span;
		}
		function parseSentrySpanArguments(options) {
		  const exp = options.experimental || {};
		  const initialCtx = {
		    isStandalone: exp.standalone,
		    ...options
		  };
		  if (options.startTime) {
		    const ctx = { ...initialCtx };
		    ctx.startTimestamp = spanUtils.spanTimeInputToSeconds(options.startTime);
		    delete ctx.startTime;
		    return ctx;
		  }
		  return initialCtx;
		}
		function getAcs() {
		  const carrier$1 = carrier.getMainCarrier();
		  return index.getAsyncContextStrategy(carrier$1);
		}
		function _startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
		  const client = currentScopes.getClient();
		  const options = client?.getOptions() || {};
		  const { name = "" } = spanArguments;
		  const mutableSpanSamplingData = { spanAttributes: { ...spanArguments.attributes }, spanName: name, parentSampled };
		  client?.emit("beforeSampling", mutableSpanSamplingData, { decision: false });
		  const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
		  const finalAttributes = mutableSpanSamplingData.spanAttributes;
		  const currentPropagationContext = scope.getPropagationContext();
		  const isTracingSuppressed = _isTracingSuppressed(scope);
		  const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [false] : sampling.sampleSpan(
		    options,
		    {
		      name,
		      parentSampled: finalParentSampled,
		      attributes: finalAttributes,
		      parentSampleRate: parseSampleRate.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
		    },
		    currentPropagationContext.sampleRand
		  );
		  const rootSpan = new sentrySpan.SentrySpan({
		    ...spanArguments,
		    attributes: {
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
		      ...finalAttributes
		    },
		    sampled
		  });
		  if (!sampled && client && !isTracingSuppressed) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
		    client.recordDroppedEvent("sample_rate", hasSpanStreamingEnabled.hasSpanStreamingEnabled(client) ? "span" : "transaction");
		  }
		  utils.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
		  if (client) {
		    client.emit("spanStart", rootSpan);
		  }
		  return rootSpan;
		}
		function _startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
		  const { spanId, traceId } = parentSpan.spanContext();
		  const isTracingSuppressed = _isTracingSuppressed(scope);
		  const sampled = isTracingSuppressed ? false : spanUtils.spanIsSampled(parentSpan);
		  const childSpan = sampled ? new sentrySpan.SentrySpan({
		    ...spanArguments,
		    parentSpanId: spanId,
		    traceId,
		    sampled
		  }) : new sentryNonRecordingSpan.SentryNonRecordingSpan({ traceId });
		  spanUtils.addChildSpanToSpan(parentSpan, childSpan);
		  utils.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
		  const client = currentScopes.getClient();
		  if (!client) {
		    return childSpan;
		  }
		  if (hasSpanStreamingEnabled.hasSpanStreamingEnabled(client) && sentryNonRecordingSpan.spanIsNonRecordingSpan(childSpan)) {
		    if (sentryNonRecordingSpan.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
		      childSpan.dropReason = parentSpan.dropReason;
		      client.recordDroppedEvent(parentSpan.dropReason, "span");
		    } else if (!isTracingSuppressed) {
		      childSpan.dropReason = "sample_rate";
		      client.recordDroppedEvent("sample_rate", "span");
		    }
		  }
		  client.emit("spanStart", childSpan);
		  if (spanArguments.endTimestamp) {
		    client.emit("spanEnd", childSpan);
		    client.emit("afterSpanEnd", childSpan);
		  }
		  return childSpan;
		}
		function getParentSpan(scope, customParentSpan) {
		  if (customParentSpan) {
		    return customParentSpan;
		  }
		  if (customParentSpan === null) {
		    return void 0;
		  }
		  const span = spanOnScope._getSpanForScope(scope);
		  if (!span) {
		    return void 0;
		  }
		  const client = currentScopes.getClient();
		  const options = client ? client.getOptions() : {};
		  if (options.parentSpanIsAlwaysRootSpan) {
		    return spanUtils.getRootSpan(span);
		  }
		  return span;
		}
		function getActiveSpanWrapper(parentSpan) {
		  return parentSpan !== void 0 ? (callback) => {
		    return withActiveSpan(parentSpan, callback);
		  } : (callback) => callback();
		}
		function _shouldIgnoreStreamedSpan(client, spanArguments) {
		  const ignoreSpans = client?.getOptions().ignoreSpans;
		  if (!client || !hasSpanStreamingEnabled.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) {
		    return false;
		  }
		  return shouldIgnoreSpan.shouldIgnoreSpan(
		    {
		      description: spanArguments.name || "",
		      op: spanArguments.attributes?.[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
		      attributes: spanArguments.attributes
		    },
		    ignoreSpans
		  );
		}
		function _isIgnoredSpan(span) {
		  return sentryNonRecordingSpan.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
		}
		function _isTracingSuppressed(scope) {
		  return scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] === true;
		}

		exports.SUPPRESS_TRACING_KEY = SUPPRESS_TRACING_KEY;
		exports.continueTrace = continueTrace;
		exports.startInactiveSpan = startInactiveSpan;
		exports.startNewTrace = startNewTrace;
		exports.startSpan = startSpan;
		exports.startSpanManual = startSpanManual;
		exports.suppressTracing = suppressTracing;
		exports.withActiveSpan = withActiveSpan;
		
	} (trace));
	return trace;
}

var hasRequiredIdleSpan;

function requireIdleSpan () {
	if (hasRequiredIdleSpan) return idleSpan;
	hasRequiredIdleSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const shouldIgnoreSpan = /*@__PURE__*/ requireShouldIgnoreSpan();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const time = /*@__PURE__*/ requireTime();
		const sentryNonRecordingSpan = /*@__PURE__*/ requireSentryNonRecordingSpan();
		const sentrySpan = /*@__PURE__*/ requireSentrySpan();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const utils = /*@__PURE__*/ requireUtils$g();

		const TRACING_DEFAULTS = {
		  idleTimeout: 1e3,
		  finalTimeout: 3e4,
		  childSpanTimeout: 15e3
		};
		const FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
		const FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
		const FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
		const FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
		function startIdleSpan(startSpanOptions, options = {}) {
		  const activities = /* @__PURE__ */ new Map();
		  let _finished = false;
		  let _idleTimeoutID;
		  let _finishReason = FINISH_REASON_EXTERNAL_FINISH;
		  let _autoFinishAllowed = !options.disableAutoFinish;
		  const _cleanupHooks = [];
		  const {
		    idleTimeout = TRACING_DEFAULTS.idleTimeout,
		    finalTimeout = TRACING_DEFAULTS.finalTimeout,
		    childSpanTimeout = TRACING_DEFAULTS.childSpanTimeout,
		    beforeSpanEnd,
		    trimIdleSpanEndTimestamp = true
		  } = options;
		  const client = currentScopes.getClient();
		  const scope = currentScopes.getCurrentScope();
		  if (!client || !hasSpansEnabled.hasSpansEnabled()) {
		    const span2 = new sentryNonRecordingSpan.SentryNonRecordingSpan({ traceId: scope.getPropagationContext().traceId });
		    utils.setCapturedScopesOnSpan(span2, scope, currentScopes.getIsolationScope());
		    return span2;
		  }
		  const previousActiveSpan = spanUtils.getActiveSpan();
		  const span = _startIdleSpan(startSpanOptions);
		  span.end = new Proxy(span.end, {
		    apply(target, thisArg, args) {
		      if (beforeSpanEnd) {
		        beforeSpanEnd(span);
		      }
		      if (sentryNonRecordingSpan.spanIsNonRecordingSpan(thisArg)) {
		        return;
		      }
		      const [definedEndTimestamp, ...rest] = args;
		      const timestamp = definedEndTimestamp || time.timestampInSeconds();
		      const spanEndTimestamp = spanUtils.spanTimeInputToSeconds(timestamp);
		      const spans = spanUtils.getSpanDescendants(span).filter((child) => child !== span);
		      const spanJson = spanUtils.spanToJSON(span);
		      if (!spans.length || !trimIdleSpanEndTimestamp) {
		        onIdleSpanEnded(spanEndTimestamp);
		        return Reflect.apply(target, thisArg, [spanEndTimestamp, ...rest]);
		      }
		      const ignoreSpans = client.getOptions().ignoreSpans;
		      const latestSpanEndTimestamp = spans?.reduce((acc, current) => {
		        const currentSpanJson = spanUtils.spanToJSON(current);
		        if (!currentSpanJson.timestamp) {
		          return acc;
		        }
		        if (ignoreSpans && shouldIgnoreSpan.shouldIgnoreSpan(
		          { description: currentSpanJson.description, op: currentSpanJson.op, attributes: currentSpanJson.data },
		          ignoreSpans
		        )) {
		          return acc;
		        }
		        return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
		      }, void 0);
		      const spanStartTimestamp = spanJson.start_timestamp;
		      const endTimestamp = Math.min(
		        spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity,
		        Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity))
		      );
		      onIdleSpanEnded(endTimestamp);
		      return Reflect.apply(target, thisArg, [endTimestamp, ...rest]);
		    }
		  });
		  function _cancelIdleTimeout() {
		    if (_idleTimeoutID) {
		      clearTimeout(_idleTimeoutID);
		      _idleTimeoutID = void 0;
		    }
		  }
		  function _restartIdleTimeout(endTimestamp) {
		    _cancelIdleTimeout();
		    _idleTimeoutID = setTimeout(() => {
		      if (!_finished && activities.size === 0 && _autoFinishAllowed) {
		        _finishReason = FINISH_REASON_IDLE_TIMEOUT;
		        span.end(endTimestamp);
		      }
		    }, idleTimeout);
		  }
		  function _restartChildSpanTimeout(endTimestamp) {
		    _idleTimeoutID = setTimeout(() => {
		      if (!_finished && _autoFinishAllowed) {
		        _finishReason = FINISH_REASON_HEARTBEAT_FAILED;
		        span.end(endTimestamp);
		      }
		    }, childSpanTimeout);
		  }
		  function _pushActivity(spanId) {
		    _cancelIdleTimeout();
		    activities.set(spanId, true);
		    const endTimestamp = time.timestampInSeconds();
		    _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
		  }
		  function _popActivity(spanId) {
		    if (activities.has(spanId)) {
		      activities.delete(spanId);
		    }
		    if (activities.size === 0) {
		      const endTimestamp = time.timestampInSeconds();
		      _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
		    }
		  }
		  function onIdleSpanEnded(endTimestamp) {
		    _finished = true;
		    activities.clear();
		    _cleanupHooks.forEach((cleanup) => cleanup());
		    spanOnScope._setSpanForScope(scope, previousActiveSpan);
		    const spanJSON = spanUtils.spanToJSON(span);
		    const { start_timestamp: startTimestamp } = spanJSON;
		    if (!startTimestamp) {
		      return;
		    }
		    const attributes = spanJSON.data;
		    if (!attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) {
		      span.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
		    }
		    const currentStatus = spanJSON.status;
		    if (!currentStatus || currentStatus === "unknown") {
		      span.setStatus({ code: spanstatus.SPAN_STATUS_OK });
		    }
		    debugLogger.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
		    const childSpans = spanUtils.getSpanDescendants(span).filter((child) => child !== span);
		    let discardedSpans = 0;
		    childSpans.forEach((childSpan) => {
		      if (childSpan.isRecording()) {
		        childSpan.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "cancelled" });
		        childSpan.end(endTimestamp);
		        debugBuild.DEBUG_BUILD && debugLogger.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
		      }
		      const childSpanJSON = spanUtils.spanToJSON(childSpan);
		      const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
		      const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
		      const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
		      const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
		      if (debugBuild.DEBUG_BUILD) {
		        const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
		        if (!spanStartedBeforeIdleSpanEnd) {
		          debugLogger.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
		        } else if (!spanEndedBeforeFinalTimeout) {
		          debugLogger.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
		        }
		      }
		      if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
		        spanUtils.removeChildSpanFromSpan(span, childSpan);
		        discardedSpans++;
		      }
		    });
		    if (discardedSpans > 0) {
		      span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
		    }
		  }
		  _cleanupHooks.push(
		    client.on("spanStart", (startedSpan) => {
		      if (_finished || startedSpan === span || !!spanUtils.spanToJSON(startedSpan).timestamp || startedSpan instanceof sentrySpan.SentrySpan && startedSpan.isStandaloneSpan()) {
		        return;
		      }
		      const allSpans = spanUtils.getSpanDescendants(span);
		      if (allSpans.includes(startedSpan)) {
		        _pushActivity(startedSpan.spanContext().spanId);
		      }
		    })
		  );
		  _cleanupHooks.push(
		    client.on("spanEnd", (endedSpan) => {
		      if (_finished) {
		        return;
		      }
		      _popActivity(endedSpan.spanContext().spanId);
		    })
		  );
		  _cleanupHooks.push(
		    client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish) => {
		      if (spanToAllowAutoFinish === span) {
		        _autoFinishAllowed = true;
		        _restartIdleTimeout();
		        if (activities.size) {
		          _restartChildSpanTimeout();
		        }
		      }
		    })
		  );
		  if (!options.disableAutoFinish) {
		    _restartIdleTimeout();
		  }
		  setTimeout(() => {
		    if (!_finished) {
		      span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "deadline_exceeded" });
		      _finishReason = FINISH_REASON_FINAL_TIMEOUT;
		      span.end();
		    }
		  }, finalTimeout);
		  return span;
		}
		function _startIdleSpan(options) {
		  const span = trace.startInactiveSpan(options);
		  spanOnScope._setSpanForScope(currentScopes.getCurrentScope(), span);
		  debugBuild.DEBUG_BUILD && debugLogger.debug.log("[Tracing] Started span is an idle span");
		  return span;
		}

		exports.TRACING_DEFAULTS = TRACING_DEFAULTS;
		exports.startIdleSpan = startIdleSpan;
		
	} (idleSpan));
	return idleSpan;
}

var bindScopeToEmitter = {};

var hasRequiredBindScopeToEmitter;

function requireBindScopeToEmitter () {
	if (hasRequiredBindScopeToEmitter) return bindScopeToEmitter;
	hasRequiredBindScopeToEmitter = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();

		const ADD_LISTENER_METHODS = [
		  "addListener",
		  "on",
		  "once",
		  "prependListener",
		  "prependOnceListener",
		  "addEventListener"
		];
		const REMOVE_LISTENER_METHODS = ["removeListener", "off", "removeEventListener"];
		const SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
		let registeringWrapper;
		function isReentrantWrapperRegistration(listener) {
		  return registeringWrapper !== void 0 && (listener === registeringWrapper || listener.listener === registeringWrapper);
		}
		function bindScopeToEmitter(emitter, scope = currentScopes.getCurrentScope()) {
		  const ee = emitter;
		  if (getPatchMap(ee)) {
		    return emitter;
		  }
		  createPatchMap(ee);
		  for (const methodName of ADD_LISTENER_METHODS) {
		    if (typeof ee[methodName] !== "function") {
		      continue;
		    }
		    ee[methodName] = patchAddListener(ee, ee[methodName], scope);
		  }
		  for (const methodName of REMOVE_LISTENER_METHODS) {
		    if (typeof ee[methodName] !== "function") {
		      continue;
		    }
		    ee[methodName] = patchRemoveListener(ee, ee[methodName]);
		  }
		  if (typeof ee.removeAllListeners === "function") {
		    ee.removeAllListeners = patchRemoveAllListeners(ee, ee.removeAllListeners);
		  }
		  return emitter;
		}
		function bindListenerToScope(listener, scope) {
		  return function(...args) {
		    return currentScopes.withScope(scope, () => listener.apply(this, args));
		  };
		}
		function isBoundListener(listener) {
		  return typeof listener === "function";
		}
		function patchAddListener(ee, original, scope) {
		  return function(...args) {
		    const event = args[0];
		    const listener = args[1];
		    const rest = args.slice(2);
		    if (!isBoundListener(listener) || isReentrantWrapperRegistration(listener)) {
		      return original.apply(this, args);
		    }
		    const map = getPatchMap(ee) || createPatchMap(ee);
		    let listeners = map.get(event);
		    if (!listeners) {
		      listeners = /* @__PURE__ */ new WeakMap();
		      map.set(event, listeners);
		    }
		    let boundListener = listeners.get(listener);
		    if (!boundListener) {
		      boundListener = bindListenerToScope(listener, scope);
		      listeners.set(listener, boundListener);
		    }
		    const previous = registeringWrapper;
		    registeringWrapper = boundListener;
		    try {
		      return original.call(this, event, boundListener, ...rest);
		    } finally {
		      registeringWrapper = previous;
		    }
		  };
		}
		function patchRemoveListener(ee, original) {
		  return function(...args) {
		    const event = args[0];
		    const listener = args[1];
		    const rest = args.slice(2);
		    const boundListener = isBoundListener(listener) ? getPatchMap(ee)?.get(event)?.get(listener) : void 0;
		    if (!boundListener) {
		      return original.apply(this, args);
		    }
		    return original.call(this, event, boundListener, ...rest);
		  };
		}
		function patchRemoveAllListeners(ee, original) {
		  return function(...args) {
		    const map = getPatchMap(ee);
		    if (map) {
		      if (args.length === 0) {
		        createPatchMap(ee);
		      } else {
		        const event = args[0];
		        map.delete(event);
		      }
		    }
		    return original.apply(this, args);
		  };
		}
		function createPatchMap(ee) {
		  const map = /* @__PURE__ */ new Map();
		  ee[SCOPE_BOUND_LISTENERS] = map;
		  return map;
		}
		function getPatchMap(ee) {
		  return ee[SCOPE_BOUND_LISTENERS];
		}

		exports.bindScopeToEmitter = bindScopeToEmitter;
		
	} (bindScopeToEmitter));
	return bindScopeToEmitter;
}

var captureSpan = {};

var scopeData = {};

var hasRequiredScopeData;

function requireScopeData () {
	if (hasRequiredScopeData) return scopeData;
	hasRequiredScopeData = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const merge = /*@__PURE__*/ requireMerge();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		function applyScopeDataToEvent(event, data) {
		  const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;
		  applyDataToEvent(event, data);
		  if (span) {
		    applySpanToEvent(event, span);
		  }
		  applyFingerprintToEvent(event, fingerprint);
		  applyBreadcrumbsToEvent(event, breadcrumbs);
		  applySdkMetadataToEvent(event, sdkProcessingMetadata);
		}
		function mergeScopeData(data, mergeData) {
		  const {
		    extra,
		    tags,
		    attributes,
		    user,
		    contexts,
		    level,
		    sdkProcessingMetadata,
		    breadcrumbs,
		    fingerprint,
		    eventProcessors,
		    attachments,
		    propagationContext,
		    transactionName,
		    span
		  } = mergeData;
		  mergeAndOverwriteScopeData(data, "extra", extra);
		  mergeAndOverwriteScopeData(data, "tags", tags);
		  mergeAndOverwriteScopeData(data, "attributes", attributes);
		  mergeAndOverwriteScopeData(data, "user", user);
		  mergeAndOverwriteScopeData(data, "contexts", contexts);
		  data.sdkProcessingMetadata = merge.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
		  if (level) {
		    data.level = level;
		  }
		  if (transactionName) {
		    data.transactionName = transactionName;
		  }
		  if (span) {
		    data.span = span;
		  }
		  if (breadcrumbs.length) {
		    data.breadcrumbs = [...data.breadcrumbs, ...breadcrumbs];
		  }
		  if (fingerprint.length) {
		    data.fingerprint = [...data.fingerprint, ...fingerprint];
		  }
		  if (eventProcessors.length) {
		    data.eventProcessors = [...data.eventProcessors, ...eventProcessors];
		  }
		  if (attachments.length) {
		    data.attachments = [...data.attachments, ...attachments];
		  }
		  data.propagationContext = { ...data.propagationContext, ...propagationContext };
		}
		function mergeAndOverwriteScopeData(data, prop, mergeVal) {
		  data[prop] = merge.merge(data[prop], mergeVal, 1);
		}
		function getCombinedScopeData(isolationScope, currentScope) {
		  const scopeData = currentScopes.getGlobalScope().getScopeData();
		  isolationScope && mergeScopeData(scopeData, isolationScope.getScopeData());
		  currentScope && mergeScopeData(scopeData, currentScope.getScopeData());
		  return scopeData;
		}
		function applyDataToEvent(event, data) {
		  const { extra, tags, user, contexts, level, transactionName } = data;
		  if (Object.keys(extra).length) {
		    event.extra = { ...extra, ...event.extra };
		  }
		  if (Object.keys(tags).length) {
		    event.tags = { ...tags, ...event.tags };
		  }
		  if (Object.keys(user).length) {
		    event.user = { ...user, ...event.user };
		  }
		  if (Object.keys(contexts).length) {
		    event.contexts = { ...contexts, ...event.contexts };
		  }
		  if (level) {
		    event.level = level;
		  }
		  if (transactionName && event.type !== "transaction") {
		    event.transaction = transactionName;
		  }
		}
		function applyBreadcrumbsToEvent(event, breadcrumbs) {
		  const mergedBreadcrumbs = [...event.breadcrumbs || [], ...breadcrumbs];
		  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
		}
		function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
		  event.sdkProcessingMetadata = {
		    ...event.sdkProcessingMetadata,
		    ...sdkProcessingMetadata
		  };
		}
		function applySpanToEvent(event, span) {
		  event.contexts = {
		    trace: spanUtils.spanToTraceContext(span),
		    ...event.contexts
		  };
		  event.sdkProcessingMetadata = {
		    dynamicSamplingContext: dynamicSamplingContext.getDynamicSamplingContextFromSpan(span),
		    ...event.sdkProcessingMetadata
		  };
		  const rootSpan = spanUtils.getRootSpan(span);
		  const transactionName = spanUtils.spanToJSON(rootSpan).description;
		  if (transactionName && !event.transaction && event.type === "transaction") {
		    event.transaction = transactionName;
		  }
		}
		function applyFingerprintToEvent(event, fingerprint) {
		  event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [event.fingerprint] : [];
		  if (fingerprint) {
		    event.fingerprint = event.fingerprint.concat(fingerprint);
		  }
		  if (!event.fingerprint.length) {
		    delete event.fingerprint;
		  }
		}

		exports.applyScopeDataToEvent = applyScopeDataToEvent;
		exports.getCombinedScopeData = getCombinedScopeData;
		exports.mergeAndOverwriteScopeData = mergeAndOverwriteScopeData;
		exports.mergeScopeData = mergeScopeData;
		
	} (scopeData));
	return scopeData;
}

var scopeContextAttributes = {};

var hasRequiredScopeContextAttributes;

function requireScopeContextAttributes () {
	if (hasRequiredScopeContextAttributes) return scopeContextAttributes;
	hasRequiredScopeContextAttributes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function scopeContextsToSpanAttributes(contexts) {
		  const attrs = {};
		  const { response, profile, cloud_resource, culture, state } = contexts;
		  if (response) {
		    if (response.status_code != null) {
		      attrs["http.response.status_code"] = response.status_code;
		    }
		    if (response.body_size != null) {
		      attrs["http.response.body.size"] = response.body_size;
		    }
		  }
		  if (profile) {
		    if (profile.profile_id) {
		      attrs["sentry.profile_id"] = profile.profile_id;
		    }
		    if (profile.profiler_id) {
		      attrs["sentry.profiler_id"] = profile.profiler_id;
		    }
		  }
		  if (cloud_resource) {
		    for (const [key, value] of Object.entries(cloud_resource)) {
		      if (value != null) {
		        attrs[key] = value;
		      }
		    }
		  }
		  if (culture) {
		    if (culture.locale) {
		      attrs["culture.locale"] = culture.locale;
		    }
		    if (culture.timezone) {
		      attrs["culture.timezone"] = culture.timezone;
		    }
		  }
		  if (state?.state && typeof state.state.type === "string") {
		    attrs["state.type"] = state.state.type;
		  }
		  const angular = contexts["angular"];
		  if (angular) {
		    const version = angular["version"];
		    if (typeof version === "string" || typeof version === "number") {
		      attrs["angular.version"] = version;
		    }
		  }
		  const react = contexts["react"];
		  if (react) {
		    const version = react["version"];
		    if (typeof version === "string" || typeof version === "number") {
		      attrs["react.version"] = version;
		    }
		  }
		  return attrs;
		}

		exports.scopeContextsToSpanAttributes = scopeContextsToSpanAttributes;
		
	} (scopeContextAttributes));
	return scopeContextAttributes;
}

var hasRequiredCaptureSpan;

function requireCaptureSpan () {
	if (hasRequiredCaptureSpan) return captureSpan;
	hasRequiredCaptureSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const scopeData = /*@__PURE__*/ requireScopeData();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const utils = /*@__PURE__*/ requireUtils$g();
		const beforeSendSpan = /*@__PURE__*/ requireBeforeSendSpan();
		const scopeContextAttributes = /*@__PURE__*/ requireScopeContextAttributes();
		const constants = /*@__PURE__*/ requireConstants$9();

		function captureSpan(span, client) {
		  const spanJSON = spanUtils.spanToStreamedSpanJSON(span);
		  const segmentSpan = spanUtils.INTERNAL_getSegmentSpan(span);
		  const serializedSegmentSpan = spanUtils.spanToStreamedSpanJSON(segmentSpan);
		  const { isolationScope: spanIsolationScope, scope: spanScope } = utils.getCapturedScopesOnSpan(span);
		  const finalScopeData = scopeData.getCombinedScopeData(spanIsolationScope, spanScope);
		  applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
		  const spanKind = span.kind;
		  client.emit("preprocessSpan", spanJSON, { spanKind });
		  if (spanJSON.is_segment) {
		    applyScopeToSegmentSpan(spanJSON, finalScopeData);
		    applySdkMetadataToSegmentSpan(spanJSON, client);
		    client.emit("processSegmentSpan", spanJSON);
		  }
		  client.emit("processSpan", spanJSON);
		  const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
		  const processedSpan = beforeSendSpan$1 && beforeSendSpan.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
		  const spanNameSource = processedSpan.attributes?.[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
		  if (spanNameSource) {
		    safeSetSpanJSONAttributes(processedSpan, {
		      // Purposefully not using a constant defined here like in other attributes:
		      // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
		      "sentry.span.source": spanNameSource
		    });
		  }
		  return {
		    ...spanUtils.streamedSpanJsonToSerializedSpan(processedSpan),
		    _segmentSpan: segmentSpan
		  };
		}
		function applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
		  const contextAttributes = scopeContextAttributes.scopeContextsToSpanAttributes(scopeData.contexts);
		  safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
		}
		function safeSetSpanJSONAttributes(spanJSON, newAttributes) {
		  const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
		  Object.entries(newAttributes).forEach(([key, value]) => {
		    if (value != null && !(key in originalAttributes)) {
		      originalAttributes[key] = value;
		    }
		  });
		}
		function applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
		  const integrationNames = client.getIntegrationNames();
		  if (!integrationNames.length) return;
		  safeSetSpanJSONAttributes(segmentSpanJSON, {
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
		  });
		}
		function applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
		  const sdk = client.getSdkMetadata();
		  const { release, environment } = client.getOptions();
		  safeSetSpanJSONAttributes(spanJSON, {
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || constants.DEFAULT_ENVIRONMENT,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk?.sdk?.name,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk?.sdk?.version,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
		    ...scopeData.attributes
		  });
		}
		function applyBeforeSendSpanCallback(span, beforeSendSpan) {
		  const modifedSpan = beforeSendSpan(span);
		  if (!modifedSpan) {
		    spanUtils.showSpanDropWarning();
		    return span;
		  }
		  return modifedSpan;
		}

		exports.applyBeforeSendSpanCallback = applyBeforeSendSpanCallback;
		exports.captureSpan = captureSpan;
		exports.safeSetSpanJSONAttributes = safeSetSpanJSONAttributes;
		
	} (captureSpan));
	return captureSpan;
}

var exports$1 = {};

var prepareEvent = {};

var eventProcessors = {};

var syncpromise = {};

var hasRequiredSyncpromise;

function requireSyncpromise () {
	if (hasRequiredSyncpromise) return syncpromise;
	hasRequiredSyncpromise = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const is = /*@__PURE__*/ requireIs$1();

		const STATE_PENDING = 0;
		const STATE_RESOLVED = 1;
		const STATE_REJECTED = 2;
		function resolvedSyncPromise(value) {
		  return new SyncPromise((resolve) => {
		    resolve(value);
		  });
		}
		function rejectedSyncPromise(reason) {
		  return new SyncPromise((_, reject) => {
		    reject(reason);
		  });
		}
		class SyncPromise {
		  constructor(executor) {
		    this._state = STATE_PENDING;
		    this._handlers = [];
		    this._runExecutor(executor);
		  }
		  /** @inheritdoc */
		  then(onfulfilled, onrejected) {
		    return new SyncPromise((resolve, reject) => {
		      this._handlers.push([
		        false,
		        (result) => {
		          if (!onfulfilled) {
		            resolve(result);
		          } else {
		            try {
		              resolve(onfulfilled(result));
		            } catch (e) {
		              reject(e);
		            }
		          }
		        },
		        (reason) => {
		          if (!onrejected) {
		            reject(reason);
		          } else {
		            try {
		              resolve(onrejected(reason));
		            } catch (e) {
		              reject(e);
		            }
		          }
		        }
		      ]);
		      this._executeHandlers();
		    });
		  }
		  /** @inheritdoc */
		  catch(onrejected) {
		    return this.then((val) => val, onrejected);
		  }
		  /** @inheritdoc */
		  finally(onfinally) {
		    return new SyncPromise((resolve, reject) => {
		      let val;
		      let isRejected;
		      return this.then(
		        (value) => {
		          isRejected = false;
		          val = value;
		          if (onfinally) {
		            onfinally();
		          }
		        },
		        (reason) => {
		          isRejected = true;
		          val = reason;
		          if (onfinally) {
		            onfinally();
		          }
		        }
		      ).then(() => {
		        if (isRejected) {
		          reject(val);
		          return;
		        }
		        resolve(val);
		      });
		    });
		  }
		  /** Excute the resolve/reject handlers. */
		  _executeHandlers() {
		    if (this._state === STATE_PENDING) {
		      return;
		    }
		    const cachedHandlers = this._handlers.slice();
		    this._handlers = [];
		    cachedHandlers.forEach((handler) => {
		      if (handler[0]) {
		        return;
		      }
		      if (this._state === STATE_RESOLVED) {
		        handler[1](this._value);
		      }
		      if (this._state === STATE_REJECTED) {
		        handler[2](this._value);
		      }
		      handler[0] = true;
		    });
		  }
		  /** Run the executor for the SyncPromise. */
		  _runExecutor(executor) {
		    const setResult = (state, value) => {
		      if (this._state !== STATE_PENDING) {
		        return;
		      }
		      if (is.isThenable(value)) {
		        void value.then(resolve, reject);
		        return;
		      }
		      this._state = state;
		      this._value = value;
		      this._executeHandlers();
		    };
		    const resolve = (value) => {
		      setResult(STATE_RESOLVED, value);
		    };
		    const reject = (reason) => {
		      setResult(STATE_REJECTED, reason);
		    };
		    try {
		      executor(resolve, reject);
		    } catch (e) {
		      reject(e);
		    }
		  }
		}

		exports.SyncPromise = SyncPromise;
		exports.rejectedSyncPromise = rejectedSyncPromise;
		exports.resolvedSyncPromise = resolvedSyncPromise;
		
	} (syncpromise));
	return syncpromise;
}

var hasRequiredEventProcessors;

function requireEventProcessors () {
	if (hasRequiredEventProcessors) return eventProcessors;
	hasRequiredEventProcessors = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();
		const syncpromise = /*@__PURE__*/ requireSyncpromise();

		function notifyEventProcessors(processors, event, hint, index = 0) {
		  try {
		    const result = _notifyEventProcessors(event, hint, processors, index);
		    return is.isThenable(result) ? result : syncpromise.resolvedSyncPromise(result);
		  } catch (error) {
		    return syncpromise.rejectedSyncPromise(error);
		  }
		}
		function _notifyEventProcessors(event, hint, processors, index) {
		  const processor = processors[index];
		  if (!event || !processor) {
		    return event;
		  }
		  const result = processor({ ...event }, hint);
		  debugBuild.DEBUG_BUILD && result === null && debugLogger.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
		  if (is.isThenable(result)) {
		    return result.then((final) => _notifyEventProcessors(final, hint, processors, index + 1));
		  }
		  return _notifyEventProcessors(result, hint, processors, index + 1);
		}

		exports.notifyEventProcessors = notifyEventProcessors;
		
	} (eventProcessors));
	return eventProcessors;
}

var debugIds = {};

var hasRequiredDebugIds;

function requireDebugIds () {
	if (hasRequiredDebugIds) return debugIds;
	hasRequiredDebugIds = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const stacktrace = /*@__PURE__*/ requireStacktrace();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		let parsedStackResults;
		let lastSentryKeysCount;
		let lastNativeKeysCount;
		let cachedFilenameDebugIds;
		function getFilenameToDebugIdMap(stackParser) {
		  const sentryDebugIdMap = worldwide.GLOBAL_OBJ._sentryDebugIds;
		  const nativeDebugIdMap = worldwide.GLOBAL_OBJ._debugIds;
		  if (!sentryDebugIdMap && !nativeDebugIdMap) {
		    return {};
		  }
		  const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
		  const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
		  if (cachedFilenameDebugIds && sentryDebugIdKeys.length === lastSentryKeysCount && nativeDebugIdKeys.length === lastNativeKeysCount) {
		    return cachedFilenameDebugIds;
		  }
		  lastSentryKeysCount = sentryDebugIdKeys.length;
		  lastNativeKeysCount = nativeDebugIdKeys.length;
		  cachedFilenameDebugIds = {};
		  if (!parsedStackResults) {
		    parsedStackResults = {};
		  }
		  const processDebugIds = (debugIdKeys, debugIdMap) => {
		    for (const key of debugIdKeys) {
		      const debugId = debugIdMap[key];
		      const result = parsedStackResults?.[key];
		      if (result && cachedFilenameDebugIds && debugId) {
		        cachedFilenameDebugIds[result[0]] = debugId;
		        if (parsedStackResults) {
		          parsedStackResults[key] = [result[0], debugId];
		        }
		      } else if (debugId) {
		        const parsedStack = stackParser(key);
		        for (let i = parsedStack.length - 1; i >= 0; i--) {
		          const stackFrame = parsedStack[i];
		          const filename = stackFrame?.filename;
		          if (filename && cachedFilenameDebugIds && parsedStackResults) {
		            cachedFilenameDebugIds[filename] = debugId;
		            parsedStackResults[key] = [filename, debugId];
		            break;
		          }
		        }
		      }
		    }
		  };
		  if (sentryDebugIdMap) {
		    processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
		  }
		  if (nativeDebugIdMap) {
		    processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
		  }
		  return cachedFilenameDebugIds;
		}
		function getDebugImagesForResources(stackParser, resource_paths) {
		  const filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
		  if (!filenameDebugIdMap) {
		    return [];
		  }
		  const images = [];
		  for (const path of resource_paths) {
		    const normalizedPath = stacktrace.normalizeStackTracePath(path);
		    if (normalizedPath && filenameDebugIdMap[normalizedPath]) {
		      images.push({
		        type: "sourcemap",
		        code_file: path,
		        debug_id: filenameDebugIdMap[normalizedPath]
		      });
		    }
		  }
		  return images;
		}

		exports.getDebugImagesForResources = getDebugImagesForResources;
		exports.getFilenameToDebugIdMap = getFilenameToDebugIdMap;
		
	} (debugIds));
	return debugIds;
}

var hasRequiredPrepareEvent;

function requirePrepareEvent () {
	if (hasRequiredPrepareEvent) return prepareEvent;
	hasRequiredPrepareEvent = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const constants = /*@__PURE__*/ requireConstants$9();
		const eventProcessors = /*@__PURE__*/ requireEventProcessors();
		const scope = /*@__PURE__*/ requireScope();
		const debugIds = /*@__PURE__*/ requireDebugIds();
		const misc = /*@__PURE__*/ requireMisc();
		const normalize = /*@__PURE__*/ requireNormalize();
		const scopeData = /*@__PURE__*/ requireScopeData();
		const string = /*@__PURE__*/ requireString();
		const syncpromise = /*@__PURE__*/ requireSyncpromise();
		const time = /*@__PURE__*/ requireTime();

		function prepareEvent(options, event, hint, scope, client, isolationScope) {
		  const { normalizeDepth = 3, normalizeMaxBreadth = 1e3 } = options;
		  const prepared = {
		    ...event,
		    event_id: event.event_id || hint.event_id || misc.uuid4(),
		    timestamp: event.timestamp || time.dateTimestampInSeconds()
		  };
		  const integrations = hint.integrations || options.integrations.map((i) => i.name);
		  applyClientOptions(prepared, options);
		  applyIntegrationsMetadata(prepared, integrations);
		  if (client) {
		    client.emit("applyFrameMetadata", event);
		  }
		  if (event.type === void 0) {
		    applyDebugIds(prepared, options.stackParser);
		  }
		  const finalScope = getFinalScope(scope, hint.captureContext);
		  if (hint.mechanism) {
		    misc.addExceptionMechanism(prepared, hint.mechanism);
		  }
		  const clientEventProcessors = client ? client.getEventProcessors() : [];
		  const data = scopeData.getCombinedScopeData(isolationScope, finalScope);
		  const attachments = [...hint.attachments || [], ...data.attachments];
		  if (attachments.length) {
		    hint.attachments = attachments;
		  }
		  scopeData.applyScopeDataToEvent(prepared, data);
		  const eventProcessors$1 = [
		    ...clientEventProcessors,
		    // Run scope event processors _after_ all other processors
		    ...data.eventProcessors
		  ];
		  const isInternalException = hint.data && hint.data.__sentry__ === true;
		  const result = isInternalException ? syncpromise.resolvedSyncPromise(prepared) : eventProcessors.notifyEventProcessors(eventProcessors$1, prepared, hint);
		  return result.then((evt) => {
		    if (evt) {
		      applyDebugMeta(evt);
		    }
		    if (typeof normalizeDepth === "number" && normalizeDepth > 0) {
		      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
		    }
		    return evt;
		  });
		}
		function applyClientOptions(event, options) {
		  const { environment, release, dist, maxValueLength } = options;
		  event.environment = event.environment || environment || constants.DEFAULT_ENVIRONMENT;
		  if (!event.release && release) {
		    event.release = release;
		  }
		  if (!event.dist && dist) {
		    event.dist = dist;
		  }
		  const request = event.request;
		  if (request?.url && maxValueLength) {
		    request.url = string.truncate(request.url, maxValueLength);
		  }
		  if (maxValueLength) {
		    event.exception?.values?.forEach((exception) => {
		      if (exception.value) {
		        exception.value = string.truncate(exception.value, maxValueLength);
		      }
		    });
		  }
		}
		function applyDebugIds(event, stackParser) {
		  const filenameDebugIdMap = debugIds.getFilenameToDebugIdMap(stackParser);
		  event.exception?.values?.forEach((exception) => {
		    exception.stacktrace?.frames?.forEach((frame) => {
		      if (frame.filename) {
		        frame.debug_id = filenameDebugIdMap[frame.filename];
		      }
		    });
		  });
		}
		function applyDebugMeta(event) {
		  const filenameDebugIdMap = {};
		  event.exception?.values?.forEach((exception) => {
		    exception.stacktrace?.frames?.forEach((frame) => {
		      if (frame.debug_id) {
		        if (frame.abs_path) {
		          filenameDebugIdMap[frame.abs_path] = frame.debug_id;
		        } else if (frame.filename) {
		          filenameDebugIdMap[frame.filename] = frame.debug_id;
		        }
		        delete frame.debug_id;
		      }
		    });
		  });
		  if (Object.keys(filenameDebugIdMap).length === 0) {
		    return;
		  }
		  event.debug_meta = event.debug_meta || {};
		  event.debug_meta.images = event.debug_meta.images || [];
		  const images = event.debug_meta.images;
		  Object.entries(filenameDebugIdMap).forEach(([filename, debug_id]) => {
		    images.push({
		      type: "sourcemap",
		      code_file: filename,
		      debug_id
		    });
		  });
		}
		function applyIntegrationsMetadata(event, integrationNames) {
		  if (integrationNames.length > 0) {
		    event.sdk = event.sdk || {};
		    event.sdk.integrations = [...event.sdk.integrations || [], ...integrationNames];
		  }
		}
		function normalizeEvent(event, depth, maxBreadth) {
		  if (!event) {
		    return null;
		  }
		  const normalized = {
		    ...event,
		    ...event.breadcrumbs && {
		      breadcrumbs: event.breadcrumbs.map((b) => ({
		        ...b,
		        ...b.data && {
		          data: normalize.normalize(b.data, depth, maxBreadth)
		        }
		      }))
		    },
		    ...event.user && {
		      user: normalize.normalize(event.user, depth, maxBreadth)
		    },
		    ...event.contexts && {
		      contexts: normalize.normalize(event.contexts, depth, maxBreadth)
		    },
		    ...event.extra && {
		      extra: normalize.normalize(event.extra, depth, maxBreadth)
		    }
		  };
		  if (event.contexts?.trace && normalized.contexts) {
		    normalized.contexts.trace = event.contexts.trace;
		    if (event.contexts.trace.data) {
		      normalized.contexts.trace.data = normalize.normalize(event.contexts.trace.data, depth, maxBreadth);
		    }
		  }
		  if (event.spans) {
		    normalized.spans = event.spans.map((span) => {
		      return {
		        ...span,
		        ...span.data && {
		          data: normalize.normalize(span.data, depth, maxBreadth)
		        }
		      };
		    });
		  }
		  if (event.contexts?.flags && normalized.contexts) {
		    normalized.contexts.flags = normalize.normalize(event.contexts.flags, 3, maxBreadth);
		  }
		  return normalized;
		}
		function getFinalScope(scope$1, captureContext) {
		  if (!captureContext) {
		    return scope$1;
		  }
		  const finalScope = scope$1 ? scope$1.clone() : new scope.Scope();
		  finalScope.update(captureContext);
		  return finalScope;
		}
		function parseEventHintOrCaptureContext(hint) {
		  if (!hint) {
		    return void 0;
		  }
		  if (hintIsScopeOrFunction(hint)) {
		    return { captureContext: hint };
		  }
		  if (hintIsScopeContext(hint)) {
		    return {
		      captureContext: hint
		    };
		  }
		  return hint;
		}
		function hintIsScopeOrFunction(hint) {
		  return hint instanceof scope.Scope || typeof hint === "function";
		}
		const captureContextKeys = [
		  "user",
		  "level",
		  "extra",
		  "contexts",
		  "tags",
		  "fingerprint",
		  "propagationContext"
		];
		function hintIsScopeContext(hint) {
		  return Object.keys(hint).some((key) => captureContextKeys.includes(key));
		}

		exports.applyClientOptions = applyClientOptions;
		exports.applyDebugIds = applyDebugIds;
		exports.applyDebugMeta = applyDebugMeta;
		exports.parseEventHintOrCaptureContext = parseEventHintOrCaptureContext;
		exports.prepareEvent = prepareEvent;
		
	} (prepareEvent));
	return prepareEvent;
}

var hasRequiredExports$1;

function requireExports$1 () {
	if (hasRequiredExports$1) return exports$1;
	hasRequiredExports$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const session = /*@__PURE__*/ requireSession();
		const trace = /*@__PURE__*/ requireTrace();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();
		const misc = /*@__PURE__*/ requireMisc();
		const prepareEvent = /*@__PURE__*/ requirePrepareEvent();
		const scopeData = /*@__PURE__*/ requireScopeData();
		const time = /*@__PURE__*/ requireTime();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		function captureException(exception, hint) {
		  return currentScopes.getCurrentScope().captureException(exception, prepareEvent.parseEventHintOrCaptureContext(hint));
		}
		function captureMessage(message, captureContext) {
		  const level = typeof captureContext === "string" ? captureContext : void 0;
		  const hint = typeof captureContext !== "string" ? { captureContext } : void 0;
		  return currentScopes.getCurrentScope().captureMessage(message, level, hint);
		}
		function captureEvent(event, hint) {
		  return currentScopes.getCurrentScope().captureEvent(event, hint);
		}
		function setContext(name, context) {
		  currentScopes.getIsolationScope().setContext(name, context);
		}
		function setExtras(extras) {
		  currentScopes.getIsolationScope().setExtras(extras);
		}
		function setExtra(key, extra) {
		  currentScopes.getIsolationScope().setExtra(key, extra);
		}
		function setTags(tags) {
		  currentScopes.getIsolationScope().setTags(tags);
		}
		function setTag(key, value) {
		  currentScopes.getIsolationScope().setTag(key, value);
		}
		function setUser(user) {
		  currentScopes.getIsolationScope().setUser(user);
		}
		function setConversationId(conversationId) {
		  currentScopes.getIsolationScope().setConversationId(conversationId);
		}
		function lastEventId() {
		  return currentScopes.getIsolationScope().lastEventId();
		}
		function captureCheckIn(checkIn, upsertMonitorConfig) {
		  const scope = currentScopes.getCurrentScope();
		  const client = currentScopes.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Cannot capture check-in. No client defined.");
		  } else if (!client.captureCheckIn) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
		  } else {
		    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
		  }
		  return misc.uuid4();
		}
		function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
		  function runCallback() {
		    const checkInId = captureCheckIn({ monitorSlug, status: "in_progress" }, upsertMonitorConfig);
		    const now = time.timestampInSeconds();
		    function finishCheckIn(status) {
		      captureCheckIn({ monitorSlug, status, checkInId, duration: time.timestampInSeconds() - now });
		    }
		    let maybePromiseResult;
		    try {
		      maybePromiseResult = callback();
		    } catch (e) {
		      finishCheckIn("error");
		      throw e;
		    }
		    if (is.isThenable(maybePromiseResult)) {
		      return maybePromiseResult.then(
		        (r) => {
		          finishCheckIn("ok");
		          return r;
		        },
		        (e) => {
		          finishCheckIn("error");
		          throw e;
		        }
		      );
		    }
		    finishCheckIn("ok");
		    return maybePromiseResult;
		  }
		  return currentScopes.withIsolationScope(() => upsertMonitorConfig?.isolateTrace ? trace.startNewTrace(runCallback) : runCallback());
		}
		async function flush(timeout) {
		  const client = currentScopes.getClient();
		  if (client) {
		    return client.flush(timeout);
		  }
		  debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Cannot flush events. No client defined.");
		  return Promise.resolve(false);
		}
		async function close(timeout) {
		  const client = currentScopes.getClient();
		  if (client) {
		    return client.close(timeout);
		  }
		  debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Cannot flush events and disable SDK. No client defined.");
		  return Promise.resolve(false);
		}
		function isInitialized() {
		  return !!currentScopes.getClient();
		}
		function isEnabled() {
		  const client = currentScopes.getClient();
		  return client?.getOptions().enabled !== false && !!client?.getTransport();
		}
		function addEventProcessor(callback) {
		  currentScopes.getIsolationScope().addEventProcessor(callback);
		}
		function startSession(context) {
		  const isolationScope = currentScopes.getIsolationScope();
		  const { user } = scopeData.getCombinedScopeData(isolationScope, currentScopes.getCurrentScope());
		  const { userAgent } = worldwide.GLOBAL_OBJ.navigator || {};
		  const session$1 = session.makeSession({
		    user,
		    ...userAgent && { userAgent },
		    ...context
		  });
		  const currentSession = isolationScope.getSession();
		  if (currentSession?.status === "ok") {
		    session.updateSession(currentSession, { status: "exited" });
		  }
		  endSession();
		  isolationScope.setSession(session$1);
		  return session$1;
		}
		function endSession() {
		  const isolationScope = currentScopes.getIsolationScope();
		  const currentScope = currentScopes.getCurrentScope();
		  const session$1 = currentScope.getSession() || isolationScope.getSession();
		  if (session$1) {
		    session.closeSession(session$1);
		  }
		  _sendSessionUpdate();
		  isolationScope.setSession();
		}
		function _sendSessionUpdate() {
		  const isolationScope = currentScopes.getIsolationScope();
		  const client = currentScopes.getClient();
		  const session = isolationScope.getSession();
		  if (session && client) {
		    client.captureSession(session);
		  }
		}
		function captureSession(end = false) {
		  if (end) {
		    endSession();
		    return;
		  }
		  _sendSessionUpdate();
		}

		exports.addEventProcessor = addEventProcessor;
		exports.captureCheckIn = captureCheckIn;
		exports.captureEvent = captureEvent;
		exports.captureException = captureException;
		exports.captureMessage = captureMessage;
		exports.captureSession = captureSession;
		exports.close = close;
		exports.endSession = endSession;
		exports.flush = flush;
		exports.isEnabled = isEnabled;
		exports.isInitialized = isInitialized;
		exports.lastEventId = lastEventId;
		exports.setContext = setContext;
		exports.setConversationId = setConversationId;
		exports.setExtra = setExtra;
		exports.setExtras = setExtras;
		exports.setTag = setTag;
		exports.setTags = setTags;
		exports.setUser = setUser;
		exports.startSession = startSession;
		exports.withMonitor = withMonitor;
		
	} (exports$1));
	return exports$1;
}

var api$1 = {};

var hasRequiredApi$1;

function requireApi$1 () {
	if (hasRequiredApi$1) return api$1;
	hasRequiredApi$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const dsn = /*@__PURE__*/ requireDsn();

		const SENTRY_API_VERSION = "7";
		function getBaseApiEndpoint(dsn) {
		  const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
		  const port = dsn.port ? `:${dsn.port}` : "";
		  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
		}
		function _getIngestEndpoint(dsn) {
		  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
		}
		function _encodedAuth(dsn, sdkInfo) {
		  const params = {
		    sentry_version: SENTRY_API_VERSION
		  };
		  if (dsn.publicKey) {
		    params.sentry_key = dsn.publicKey;
		  }
		  if (sdkInfo) {
		    params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
		  }
		  return new URLSearchParams(params).toString();
		}
		function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
		  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
		}
		function getReportDialogEndpoint(dsnLike, dialogOptions) {
		  const dsn$1 = dsn.makeDsn(dsnLike);
		  if (!dsn$1) {
		    return "";
		  }
		  const endpoint = `${getBaseApiEndpoint(dsn$1)}embed/error-page/`;
		  let encodedOptions = `dsn=${dsn.dsnToString(dsn$1)}`;
		  for (const key in dialogOptions) {
		    if (key === "dsn") {
		      continue;
		    }
		    if (key === "onClose") {
		      continue;
		    }
		    if (key === "user") {
		      const user = dialogOptions.user;
		      if (!user) {
		        continue;
		      }
		      if (user.name) {
		        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
		      }
		      if (user.email) {
		        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
		      }
		    } else {
		      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
		    }
		  }
		  return `${endpoint}?${encodedOptions}`;
		}

		exports.SENTRY_API_VERSION = SENTRY_API_VERSION;
		exports.getEnvelopeEndpointWithUrlEncodedAuth = getEnvelopeEndpointWithUrlEncodedAuth;
		exports.getReportDialogEndpoint = getReportDialogEndpoint;
		
	} (api$1));
	return api$1;
}

var client$1 = {};

var integration$6 = {};

var hasRequiredIntegration$6;

function requireIntegration$6 () {
	if (hasRequiredIntegration$6) return integration$6;
	hasRequiredIntegration$6 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();

		const installedIntegrations = [];
		function filterDuplicates(integrations) {
		  const integrationsByName = {};
		  integrations.forEach((currentInstance) => {
		    const { name } = currentInstance;
		    const existingInstance = integrationsByName[name];
		    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
		      return;
		    }
		    integrationsByName[name] = currentInstance;
		  });
		  return Object.values(integrationsByName);
		}
		function getIntegrationsToSetup(options) {
		  const defaultIntegrations = options.defaultIntegrations || [];
		  const userIntegrations = options.integrations;
		  defaultIntegrations.forEach((integration) => {
		    integration.isDefaultInstance = true;
		  });
		  let integrations;
		  if (Array.isArray(userIntegrations)) {
		    integrations = [...defaultIntegrations, ...userIntegrations];
		  } else if (typeof userIntegrations === "function") {
		    const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
		    integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [resolvedUserIntegrations];
		  } else {
		    integrations = defaultIntegrations;
		  }
		  return filterDuplicates(integrations);
		}
		function setupIntegrations(client, integrations) {
		  const integrationIndex = {};
		  integrations.forEach((integration) => {
		    if (integration?.beforeSetup) {
		      integration.beforeSetup(client);
		    }
		  });
		  integrations.forEach((integration) => {
		    if (integration) {
		      setupIntegration(client, integration, integrationIndex);
		    }
		  });
		  return integrationIndex;
		}
		function afterSetupIntegrations(client, integrations) {
		  for (const integration of integrations) {
		    if (integration?.afterAllSetup) {
		      integration.afterAllSetup(client);
		    }
		  }
		}
		function setupIntegration(client, integration, integrationIndex) {
		  if (integrationIndex[integration.name]) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
		    return;
		  }
		  integrationIndex[integration.name] = integration;
		  if (!installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
		    integration.setupOnce();
		    installedIntegrations.push(integration.name);
		  }
		  if (integration.setup && typeof integration.setup === "function") {
		    integration.setup(client);
		  }
		  if (typeof integration.preprocessEvent === "function") {
		    const callback = integration.preprocessEvent.bind(integration);
		    client.on("preprocessEvent", (event, hint) => callback(event, hint, client));
		  }
		  if (typeof integration.processEvent === "function") {
		    const callback = integration.processEvent.bind(integration);
		    const processor = Object.assign((event, hint) => callback(event, hint, client), {
		      id: integration.name
		    });
		    client.addEventProcessor(processor);
		  }
		  ["processSpan", "processSegmentSpan"].forEach((hook) => {
		    const callback = integration[hook];
		    if (typeof callback === "function") {
		      client.on(hook, (span) => callback.call(integration, span, client));
		    }
		  });
		  debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Integration installed: ${integration.name}`);
		}
		function addIntegration(integration) {
		  const client = currentScopes.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
		    return;
		  }
		  client.addIntegration(integration);
		}
		function defineIntegration(fn) {
		  return fn;
		}

		exports.addIntegration = addIntegration;
		exports.afterSetupIntegrations = afterSetupIntegrations;
		exports.defineIntegration = defineIntegration;
		exports.getIntegrationsToSetup = getIntegrationsToSetup;
		exports.installedIntegrations = installedIntegrations;
		exports.setupIntegration = setupIntegration;
		exports.setupIntegrations = setupIntegrations;
		
	} (integration$6));
	return integration$6;
}

var internal$1 = {};

var timestampSequence = {};

var hasRequiredTimestampSequence;

function requireTimestampSequence () {
	if (hasRequiredTimestampSequence) return timestampSequence;
	hasRequiredTimestampSequence = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
		let _sequenceNumber = 0;
		let _previousTimestampMs;
		function getSequenceAttribute(timestampInSeconds) {
		  const nowMs = Math.floor(timestampInSeconds * 1e3);
		  if (_previousTimestampMs !== void 0 && nowMs !== _previousTimestampMs) {
		    _sequenceNumber = 0;
		  }
		  const value = _sequenceNumber;
		  _sequenceNumber++;
		  _previousTimestampMs = nowMs;
		  return {
		    key: SEQUENCE_ATTR_KEY,
		    value: { value, type: "integer" }
		  };
		}

		exports.getSequenceAttribute = getSequenceAttribute;
		
	} (timestampSequence));
	return timestampSequence;
}

var traceInfo = {};

var hasRequiredTraceInfo;

function requireTraceInfo () {
	if (hasRequiredTraceInfo) return traceInfo;
	hasRequiredTraceInfo = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		function _getTraceInfoFromScope(client, scope) {
		  if (!scope) {
		    return [void 0, void 0];
		  }
		  return currentScopes.withScope(scope, () => {
		    const span = spanUtils.getActiveSpan();
		    const traceContext = span ? spanUtils.spanToTraceContext(span) : currentScopes.getTraceContextFromScope(scope);
		    const dynamicSamplingContext$1 = span ? dynamicSamplingContext.getDynamicSamplingContextFromSpan(span) : dynamicSamplingContext.getDynamicSamplingContextFromScope(client, scope);
		    return [dynamicSamplingContext$1, traceContext];
		  });
		}

		exports._getTraceInfoFromScope = _getTraceInfoFromScope;
		
	} (traceInfo));
	return traceInfo;
}

var constants$8 = {};

var hasRequiredConstants$8;

function requireConstants$8 () {
	if (hasRequiredConstants$8) return constants$8;
	hasRequiredConstants$8 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
		  trace: 1,
		  debug: 5,
		  info: 9,
		  warn: 13,
		  error: 17,
		  fatal: 21
		};

		exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = SEVERITY_TEXT_TO_SEVERITY_NUMBER;
		
	} (constants$8));
	return constants$8;
}

var envelope$2 = {};

var isBrowser = {};

var node$1 = {exports: {}};

var env = {};

var hasRequiredEnv;

function requireEnv () {
	if (hasRequiredEnv) return env;
	hasRequiredEnv = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function isBrowserBundle() {
		  return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
		}
		function getSDKSource() {
		  /*! __SENTRY_SDK_SOURCE__ */
		  return "npm";
		}

		exports.getSDKSource = getSDKSource;
		exports.isBrowserBundle = isBrowserBundle;
		
	} (env));
	return env;
}

node$1.exports;

var hasRequiredNode$1;

function requireNode$1 () {
	if (hasRequiredNode$1) return node$1.exports;
	hasRequiredNode$1 = 1;
	(function (module, exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const env = /*@__PURE__*/ requireEnv();

		function isNodeEnv() {
		  return !env.isBrowserBundle() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
		}
		function dynamicRequire(mod, request) {
		  return mod.require(request);
		}
		function loadModule(moduleName, existingModule = module) {
		  let mod;
		  try {
		    mod = dynamicRequire(existingModule, moduleName);
		  } catch {
		  }
		  if (!mod) {
		    try {
		      const { cwd } = dynamicRequire(existingModule, "process");
		      mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
		    } catch {
		    }
		  }
		  return mod;
		}

		exports.isNodeEnv = isNodeEnv;
		exports.loadModule = loadModule;
		
	} (node$1, node$1.exports));
	return node$1.exports;
}

var hasRequiredIsBrowser;

function requireIsBrowser () {
	if (hasRequiredIsBrowser) return isBrowser;
	hasRequiredIsBrowser = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const node = /*@__PURE__*/ requireNode$1();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		function isBrowser() {
		  return typeof window !== "undefined" && (!node.isNodeEnv() || isElectronNodeRenderer());
		}
		function isElectronNodeRenderer() {
		  const process = worldwide.GLOBAL_OBJ.process;
		  return process?.type === "renderer";
		}

		exports.isBrowser = isBrowser;
		
	} (isBrowser));
	return isBrowser;
}

var hasRequiredEnvelope$2;

function requireEnvelope$2 () {
	if (hasRequiredEnvelope$2) return envelope$2;
	hasRequiredEnvelope$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const dsn = /*@__PURE__*/ requireDsn();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const isBrowser = /*@__PURE__*/ requireIsBrowser();

		function createLogContainerEnvelopeItem(items, inferUserData) {
		  const inferSetting = inferUserData ? "auto" : "never";
		  return [
		    {
		      type: "log",
		      item_count: items.length,
		      content_type: "application/vnd.sentry.items.log+json"
		    },
		    {
		      version: 2,
		      ...isBrowser.isBrowser() && {
		        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
		      },
		      items
		    }
		  ];
		}
		function createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
		  const headers = {};
		  if (metadata?.sdk) {
		    headers.sdk = {
		      name: metadata.sdk.name,
		      version: metadata.sdk.version
		    };
		  }
		  if (!!tunnel && !!dsn$1) {
		    headers.dsn = dsn.dsnToString(dsn$1);
		  }
		  return envelope.createEnvelope(headers, [createLogContainerEnvelopeItem(logs, inferUserData)]);
		}

		exports.createLogContainerEnvelopeItem = createLogContainerEnvelopeItem;
		exports.createLogEnvelope = createLogEnvelope;
		
	} (envelope$2));
	return envelope$2;
}

var hasRequiredInternal$1;

function requireInternal$1 () {
	if (hasRequiredInternal$1) return internal$1;
	hasRequiredInternal$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const attributes = /*@__PURE__*/ requireAttributes$1();
		const carrier = /*@__PURE__*/ requireCarrier();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();
		const scopeData = /*@__PURE__*/ requireScopeData();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();
		const time = /*@__PURE__*/ requireTime();
		const timestampSequence = /*@__PURE__*/ requireTimestampSequence();
		const traceInfo = /*@__PURE__*/ requireTraceInfo();
		const constants = /*@__PURE__*/ requireConstants$8();
		const envelope = /*@__PURE__*/ requireEnvelope$2();

		const MAX_LOG_BUFFER_SIZE = 100;
		function setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
		  if (value && (!logAttributes[key] || setEvenIfPresent)) {
		    logAttributes[key] = value;
		  }
		}
		function _INTERNAL_captureSerializedLog(client, serializedLog) {
		  const bufferMap = _getBufferMap();
		  const logBuffer = _INTERNAL_getLogBuffer(client);
		  if (logBuffer === void 0) {
		    bufferMap.set(client, [serializedLog]);
		  } else {
		    if (logBuffer.length >= MAX_LOG_BUFFER_SIZE) {
		      _INTERNAL_flushLogsBuffer(client, logBuffer);
		      bufferMap.set(client, [serializedLog]);
		    } else {
		      bufferMap.set(client, [...logBuffer, serializedLog]);
		    }
		  }
		}
		function _INTERNAL_captureLog(beforeLog, currentScope = currentScopes.getCurrentScope(), captureSerializedLog = _INTERNAL_captureSerializedLog) {
		  const client = currentScope?.getClient() ?? currentScopes.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No client available to capture log.");
		    return;
		  }
		  const { release, environment, enableLogs = false, beforeSendLog } = client.getOptions();
		  if (!enableLogs) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("logging option not enabled, log will not be captured.");
		    return;
		  }
		  const [, traceContext] = traceInfo._getTraceInfoFromScope(client, currentScope);
		  const processedLogAttributes = {
		    ...beforeLog.attributes
		  };
		  const {
		    user: { id, email, username },
		    attributes: scopeAttributes = {}
		  } = scopeData.getCombinedScopeData(currentScopes.getIsolationScope(), currentScope);
		  setLogAttribute(processedLogAttributes, "user.id", id, false);
		  setLogAttribute(processedLogAttributes, "user.email", email, false);
		  setLogAttribute(processedLogAttributes, "user.name", username, false);
		  setLogAttribute(processedLogAttributes, "sentry.release", release);
		  setLogAttribute(processedLogAttributes, "sentry.environment", environment);
		  const { name, version } = client.getSdkMetadata()?.sdk ?? {};
		  setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
		  setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
		  const replay = client.getIntegrationByName("Replay");
		  const replayId = replay?.getReplayId(true);
		  setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
		  if (replayId && replay?.getRecordingMode() === "buffer") {
		    setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
		  }
		  const beforeLogMessage = beforeLog.message;
		  if (is.isParameterizedString(beforeLogMessage)) {
		    const { __sentry_template_string__, __sentry_template_values__ = [] } = beforeLogMessage;
		    if (__sentry_template_values__?.length) {
		      processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
		    }
		    __sentry_template_values__.forEach((param, index) => {
		      processedLogAttributes[`sentry.message.parameter.${index}`] = param;
		    });
		  }
		  const span = spanOnScope._getSpanForScope(currentScope);
		  setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
		  const processedLog = { ...beforeLog, attributes: processedLogAttributes };
		  client.emit("beforeCaptureLog", processedLog);
		  const log = beforeSendLog ? debugLogger.consoleSandbox(() => beforeSendLog(processedLog)) : processedLog;
		  if (!log) {
		    client.recordDroppedEvent("before_send", "log_item", 1);
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("beforeSendLog returned null, log will not be captured.");
		    return;
		  }
		  const { level, message, attributes: logAttributes = {}, severityNumber } = log;
		  const timestamp = time.timestampInSeconds();
		  const sequenceAttr = timestampSequence.getSequenceAttribute(timestamp);
		  const serializedLog = {
		    timestamp,
		    level,
		    body: _removeLoneSurrogates(String(message)),
		    trace_id: traceContext?.trace_id,
		    severity_number: severityNumber ?? constants.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
		    attributes: sanitizeLogAttributes({
		      ...attributes.serializeAttributes(scopeAttributes),
		      ...attributes.serializeAttributes(logAttributes, true),
		      [sequenceAttr.key]: sequenceAttr.value
		    })
		  };
		  captureSerializedLog(client, serializedLog);
		  client.emit("afterCaptureLog", log);
		}
		function _INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
		  const logBuffer = maybeLogBuffer ?? _INTERNAL_getLogBuffer(client) ?? [];
		  if (logBuffer.length === 0) {
		    return;
		  }
		  const clientOptions = client.getOptions();
		  const envelope$1 = envelope.createLogEnvelope(
		    logBuffer,
		    clientOptions._metadata,
		    clientOptions.tunnel,
		    client.getDsn(),
		    client.getDataCollectionOptions().userInfo
		  );
		  _getBufferMap().set(client, []);
		  client.emit("flushLogs");
		  client.sendEnvelope(envelope$1);
		}
		function _INTERNAL_getLogBuffer(client) {
		  return _getBufferMap().get(client);
		}
		function _getBufferMap() {
		  return carrier.getGlobalSingleton("clientToLogBufferMap", () => /* @__PURE__ */ new WeakMap());
		}
		function sanitizeLogAttributes(attributes) {
		  const sanitized = {};
		  for (const [key, attr] of Object.entries(attributes)) {
		    const sanitizedKey = _removeLoneSurrogates(key);
		    if (attr.type === "string") {
		      sanitized[sanitizedKey] = { ...attr, value: _removeLoneSurrogates(attr.value) };
		    } else {
		      sanitized[sanitizedKey] = attr;
		    }
		  }
		  return sanitized;
		}
		function _removeLoneSurrogates(str) {
		  const strObj = Object(str);
		  const isWellFormed = strObj["isWellFormed"];
		  const toWellFormed = strObj["toWellFormed"];
		  if (typeof isWellFormed === "function" && typeof toWellFormed === "function") {
		    return isWellFormed.call(str) ? str : toWellFormed.call(str);
		  }
		  return str;
		}

		exports._INTERNAL_captureLog = _INTERNAL_captureLog;
		exports._INTERNAL_captureSerializedLog = _INTERNAL_captureSerializedLog;
		exports._INTERNAL_flushLogsBuffer = _INTERNAL_flushLogsBuffer;
		exports._INTERNAL_getLogBuffer = _INTERNAL_getLogBuffer;
		exports._removeLoneSurrogates = _removeLoneSurrogates;
		
	} (internal$1));
	return internal$1;
}

var internal = {};

var envelope$1 = {};

var hasRequiredEnvelope$1;

function requireEnvelope$1 () {
	if (hasRequiredEnvelope$1) return envelope$1;
	hasRequiredEnvelope$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const dsn = /*@__PURE__*/ requireDsn();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const isBrowser = /*@__PURE__*/ requireIsBrowser();

		function createMetricContainerEnvelopeItem(items, inferUserData) {
		  const inferSetting = inferUserData ? "auto" : "never";
		  return [
		    {
		      type: "trace_metric",
		      item_count: items.length,
		      content_type: "application/vnd.sentry.items.trace-metric+json"
		    },
		    {
		      version: 2,
		      ...isBrowser.isBrowser() && {
		        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
		      },
		      items
		    }
		  ];
		}
		function createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
		  const headers = {};
		  if (metadata?.sdk) {
		    headers.sdk = {
		      name: metadata.sdk.name,
		      version: metadata.sdk.version
		    };
		  }
		  if (!!tunnel && !!dsn$1) {
		    headers.dsn = dsn.dsnToString(dsn$1);
		  }
		  return envelope.createEnvelope(headers, [createMetricContainerEnvelopeItem(metrics, inferUserData)]);
		}

		exports.createMetricContainerEnvelopeItem = createMetricContainerEnvelopeItem;
		exports.createMetricEnvelope = createMetricEnvelope;
		
	} (envelope$1));
	return envelope$1;
}

var hasRequiredInternal;

function requireInternal () {
	if (hasRequiredInternal) return internal;
	hasRequiredInternal = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const attributes = /*@__PURE__*/ requireAttributes$1();
		const carrier = /*@__PURE__*/ requireCarrier();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const scopeData = /*@__PURE__*/ requireScopeData();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();
		const time = /*@__PURE__*/ requireTime();
		const timestampSequence = /*@__PURE__*/ requireTimestampSequence();
		const traceInfo = /*@__PURE__*/ requireTraceInfo();
		const envelope = /*@__PURE__*/ requireEnvelope$1();

		const MAX_METRIC_BUFFER_SIZE = 1e3;
		function setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
		  if (value && (setEvenIfPresent || !(key in metricAttributes))) {
		    metricAttributes[key] = value;
		  }
		}
		function _INTERNAL_captureSerializedMetric(client, serializedMetric) {
		  const bufferMap = _getBufferMap();
		  const metricBuffer = _INTERNAL_getMetricBuffer(client);
		  if (metricBuffer === void 0) {
		    bufferMap.set(client, [serializedMetric]);
		  } else {
		    if (metricBuffer.length >= MAX_METRIC_BUFFER_SIZE) {
		      _INTERNAL_flushMetricsBuffer(client, metricBuffer);
		      bufferMap.set(client, [serializedMetric]);
		    } else {
		      bufferMap.set(client, [...metricBuffer, serializedMetric]);
		    }
		  }
		}
		function _enrichMetricAttributes(beforeMetric, client, user) {
		  const { release, environment } = client.getOptions();
		  const processedMetricAttributes = {
		    ...beforeMetric.attributes
		  };
		  setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
		  setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
		  setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
		  setMetricAttribute(processedMetricAttributes, "sentry.release", release);
		  setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
		  const { name, version } = client.getSdkMetadata()?.sdk ?? {};
		  setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
		  setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
		  const replay = client.getIntegrationByName("Replay");
		  const replayId = replay?.getReplayId(true);
		  setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
		  if (replayId && replay?.getRecordingMode() === "buffer") {
		    setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
		  }
		  return {
		    ...beforeMetric,
		    attributes: processedMetricAttributes
		  };
		}
		function _buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
		  const [, traceContext] = traceInfo._getTraceInfoFromScope(client, currentScope);
		  const span = spanOnScope._getSpanForScope(currentScope);
		  const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
		  const spanId = span ? span.spanContext().spanId : void 0;
		  const timestamp = time.timestampInSeconds();
		  const sequenceAttr = timestampSequence.getSequenceAttribute(timestamp);
		  return {
		    timestamp,
		    trace_id: traceId ?? "",
		    span_id: spanId,
		    name: metric.name,
		    type: metric.type,
		    unit: metric.unit,
		    value: metric.value,
		    attributes: {
		      ...attributes.serializeAttributes(scopeAttributes),
		      ...attributes.serializeAttributes(metric.attributes, "skip-undefined"),
		      [sequenceAttr.key]: sequenceAttr.value
		    }
		  };
		}
		function _INTERNAL_captureMetric(beforeMetric, options) {
		  const currentScope = options?.scope ?? currentScopes.getCurrentScope();
		  const captureSerializedMetric = options?.captureSerializedMetric ?? _INTERNAL_captureSerializedMetric;
		  const client = currentScope?.getClient() ?? currentScopes.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No client available to capture metric.");
		    return;
		  }
		  const { _experiments, enableMetrics, beforeSendMetric } = client.getOptions();
		  const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
		  if (!metricsEnabled) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("metrics option not enabled, metric will not be captured.");
		    return;
		  }
		  const { user, attributes: scopeAttributes } = scopeData.getCombinedScopeData(currentScopes.getIsolationScope(), currentScope);
		  const enrichedMetric = _enrichMetricAttributes(beforeMetric, client, user);
		  client.emit("processMetric", enrichedMetric);
		  const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
		  const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
		  if (!processedMetric) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
		    return;
		  }
		  const serializedMetric = _buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
		  debugBuild.DEBUG_BUILD && debugLogger.debug.log("[Metric]", serializedMetric);
		  captureSerializedMetric(client, serializedMetric);
		  client.emit("afterCaptureMetric", processedMetric);
		}
		function _INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
		  const metricBuffer = maybeMetricBuffer ?? _INTERNAL_getMetricBuffer(client) ?? [];
		  if (metricBuffer.length === 0) {
		    return;
		  }
		  const clientOptions = client.getOptions();
		  const envelope$1 = envelope.createMetricEnvelope(
		    metricBuffer,
		    clientOptions._metadata,
		    clientOptions.tunnel,
		    client.getDsn(),
		    client.getDataCollectionOptions().userInfo
		  );
		  _getBufferMap().set(client, []);
		  client.emit("flushMetrics");
		  client.sendEnvelope(envelope$1);
		}
		function _INTERNAL_getMetricBuffer(client) {
		  return _getBufferMap().get(client);
		}
		function _getBufferMap() {
		  return carrier.getGlobalSingleton("clientToMetricBufferMap", () => /* @__PURE__ */ new WeakMap());
		}

		exports._INTERNAL_captureMetric = _INTERNAL_captureMetric;
		exports._INTERNAL_captureSerializedMetric = _INTERNAL_captureSerializedMetric;
		exports._INTERNAL_flushMetricsBuffer = _INTERNAL_flushMetricsBuffer;
		exports._INTERNAL_getMetricBuffer = _INTERNAL_getMetricBuffer;
		
	} (internal));
	return internal;
}

var extractGenAiSpans = {};

var spanJsonToStreamedSpan = {};

var hasRequiredSpanJsonToStreamedSpan;

function requireSpanJsonToStreamedSpan () {
	if (hasRequiredSpanJsonToStreamedSpan) return spanJsonToStreamedSpan;
	hasRequiredSpanJsonToStreamedSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		function spanJsonToSerializedStreamedSpan(span) {
		  const streamedSpan = {
		    trace_id: span.trace_id,
		    span_id: span.span_id,
		    parent_span_id: span.parent_span_id,
		    name: span.description || "",
		    start_timestamp: span.start_timestamp,
		    end_timestamp: span.timestamp || span.start_timestamp,
		    status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
		    is_segment: false,
		    attributes: { ...span.data },
		    links: span.links
		  };
		  return spanUtils.streamedSpanJsonToSerializedSpan(streamedSpan);
		}

		exports.spanJsonToSerializedStreamedSpan = spanJsonToSerializedStreamedSpan;
		
	} (spanJsonToStreamedSpan));
	return spanJsonToStreamedSpan;
}

var hasRequiredExtractGenAiSpans;

function requireExtractGenAiSpans () {
	if (hasRequiredExtractGenAiSpans) return extractGenAiSpans;
	hasRequiredExtractGenAiSpans = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const isBrowser = /*@__PURE__*/ requireIsBrowser();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const spanJsonToStreamedSpan = /*@__PURE__*/ requireSpanJsonToStreamedSpan();

		function extractGenAiSpansFromEvent(event, client) {
		  if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || !client.getOptions().streamGenAiSpans || hasSpanStreamingEnabled.hasSpanStreamingEnabled(client)) {
		    return void 0;
		  }
		  const genAiSpans = [];
		  const remainingSpans = [];
		  for (const span of event.spans) {
		    if (span.op?.startsWith("gen_ai.")) {
		      genAiSpans.push(spanJsonToStreamedSpan.spanJsonToSerializedStreamedSpan(span));
		    } else {
		      remainingSpans.push(span);
		    }
		  }
		  if (genAiSpans.length === 0) {
		    return void 0;
		  }
		  event.spans = remainingSpans;
		  const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
		  return [
		    { type: "span", item_count: genAiSpans.length, content_type: "application/vnd.sentry.items.span.v2+json" },
		    {
		      version: 2,
		      ...isBrowser.isBrowser() && {
		        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
		      },
		      items: genAiSpans
		    }
		  ];
		}

		exports.extractGenAiSpansFromEvent = extractGenAiSpansFromEvent;
		
	} (extractGenAiSpans));
	return extractGenAiSpans;
}

var base$2 = {};

var promisebuffer = {};

var timer = {};

var hasRequiredTimer;

function requireTimer () {
	if (hasRequiredTimer) return timer;
	hasRequiredTimer = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function safeUnref(timer) {
		  if (typeof timer === "object" && typeof timer.unref === "function") {
		    timer.unref();
		  }
		  return timer;
		}

		exports.safeUnref = safeUnref;
		
	} (timer));
	return timer;
}

var hasRequiredPromisebuffer;

function requirePromisebuffer () {
	if (hasRequiredPromisebuffer) return promisebuffer;
	hasRequiredPromisebuffer = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const syncpromise = /*@__PURE__*/ requireSyncpromise();
		const timer = /*@__PURE__*/ requireTimer();

		const SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
		function makePromiseBuffer(limit = 100) {
		  const buffer = /* @__PURE__ */ new Set();
		  function isReady() {
		    return buffer.size < limit;
		  }
		  function remove(task) {
		    buffer.delete(task);
		  }
		  function add(taskProducer) {
		    if (!isReady()) {
		      return syncpromise.rejectedSyncPromise(SENTRY_BUFFER_FULL_ERROR);
		    }
		    const task = taskProducer();
		    buffer.add(task);
		    void task.then(
		      () => remove(task),
		      () => remove(task)
		    );
		    return task;
		  }
		  function drain(timeout) {
		    if (!buffer.size) {
		      return syncpromise.resolvedSyncPromise(true);
		    }
		    const drainPromise = Promise.allSettled(Array.from(buffer)).then(() => true);
		    if (!timeout) {
		      return drainPromise;
		    }
		    const promises = [
		      drainPromise,
		      new Promise((resolve) => timer.safeUnref(setTimeout(() => resolve(false), timeout)))
		    ];
		    return Promise.race(promises);
		  }
		  return {
		    get $() {
		      return Array.from(buffer);
		    },
		    add,
		    drain
		  };
		}

		exports.SENTRY_BUFFER_FULL_ERROR = SENTRY_BUFFER_FULL_ERROR;
		exports.makePromiseBuffer = makePromiseBuffer;
		
	} (promisebuffer));
	return promisebuffer;
}

var ratelimit = {};

var hasRequiredRatelimit;

function requireRatelimit () {
	if (hasRequiredRatelimit) return ratelimit;
	hasRequiredRatelimit = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();

		const DEFAULT_RETRY_AFTER = 60 * 1e3;
		function parseRetryAfterHeader(header, now = randomSafeContext.safeDateNow()) {
		  const headerDelay = parseInt(`${header}`, 10);
		  if (!isNaN(headerDelay)) {
		    return headerDelay * 1e3;
		  }
		  const headerDate = Date.parse(`${header}`);
		  if (!isNaN(headerDate)) {
		    return headerDate - now;
		  }
		  return DEFAULT_RETRY_AFTER;
		}
		function disabledUntil(limits, dataCategory) {
		  return limits[dataCategory] || limits.all || 0;
		}
		function isRateLimited(limits, dataCategory, now = randomSafeContext.safeDateNow()) {
		  return disabledUntil(limits, dataCategory) > now;
		}
		function updateRateLimits(limits, { statusCode, headers }, now = randomSafeContext.safeDateNow()) {
		  const updatedRateLimits = {
		    ...limits
		  };
		  const rateLimitHeader = headers?.["x-sentry-rate-limits"];
		  const retryAfterHeader = headers?.["retry-after"];
		  if (rateLimitHeader) {
		    for (const limit of rateLimitHeader.trim().split(",")) {
		      const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
		      const headerDelay = parseInt(retryAfter, 10);
		      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
		      if (!categories) {
		        updatedRateLimits.all = now + delay;
		      } else {
		        for (const category of categories.split(";")) {
		          if (category === "metric_bucket") {
		            if (!namespaces || namespaces.split(";").includes("custom")) {
		              updatedRateLimits[category] = now + delay;
		            }
		          } else {
		            updatedRateLimits[category] = now + delay;
		          }
		        }
		      }
		    }
		  } else if (retryAfterHeader) {
		    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
		  } else if (statusCode === 429) {
		    updatedRateLimits.all = now + 60 * 1e3;
		  }
		  return updatedRateLimits;
		}

		exports.DEFAULT_RETRY_AFTER = DEFAULT_RETRY_AFTER;
		exports.disabledUntil = disabledUntil;
		exports.isRateLimited = isRateLimited;
		exports.parseRetryAfterHeader = parseRetryAfterHeader;
		exports.updateRateLimits = updateRateLimits;
		
	} (ratelimit));
	return ratelimit;
}

var hasRequiredBase$2;

function requireBase$2 () {
	if (hasRequiredBase$2) return base$2;
	hasRequiredBase$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const promisebuffer = /*@__PURE__*/ requirePromisebuffer();
		const ratelimit = /*@__PURE__*/ requireRatelimit();

		const DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
		function createTransport(options, makeRequest, buffer = promisebuffer.makePromiseBuffer(
		  options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE
		)) {
		  let rateLimits = {};
		  const flush = (timeout) => buffer.drain(timeout);
		  function send(envelope$1) {
		    const filteredEnvelopeItems = [];
		    envelope.forEachEnvelopeItem(envelope$1, (item, type) => {
		      const dataCategory = envelope.envelopeItemTypeToDataCategory(type);
		      if (ratelimit.isRateLimited(rateLimits, dataCategory)) {
		        options.recordDroppedEvent("ratelimit_backoff", dataCategory);
		      } else {
		        filteredEnvelopeItems.push(item);
		      }
		    });
		    if (filteredEnvelopeItems.length === 0) {
		      return Promise.resolve({});
		    }
		    const filteredEnvelope = envelope.createEnvelope(envelope$1[0], filteredEnvelopeItems);
		    const recordEnvelopeLoss = (reason) => {
		      if (envelope.envelopeContainsItemType(filteredEnvelope, ["client_report"])) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
		        return;
		      }
		      envelope.forEachEnvelopeItem(filteredEnvelope, (item, type) => {
		        options.recordDroppedEvent(reason, envelope.envelopeItemTypeToDataCategory(type));
		      });
		    };
		    const requestTask = () => makeRequest({ body: envelope.serializeEnvelope(filteredEnvelope) }).then(
		      (response) => {
		        if (response.statusCode === 413) {
		          debugBuild.DEBUG_BUILD && debugLogger.debug.error(
		            "Sentry responded with status code 413. Envelope was discarded due to exceeding size limits."
		          );
		          recordEnvelopeLoss("send_error");
		          return response;
		        }
		        if (debugBuild.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) {
		          debugLogger.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
		        }
		        rateLimits = ratelimit.updateRateLimits(rateLimits, response);
		        return response;
		      },
		      (error) => {
		        recordEnvelopeLoss("network_error");
		        debugBuild.DEBUG_BUILD && debugLogger.debug.error("Encountered error running transport request:", error);
		        throw error;
		      }
		    );
		    return buffer.add(requestTask).then(
		      (result) => result,
		      (error) => {
		        if (error === promisebuffer.SENTRY_BUFFER_FULL_ERROR) {
		          debugBuild.DEBUG_BUILD && debugLogger.debug.error("Skipped sending event because buffer is full.");
		          recordEnvelopeLoss("queue_overflow");
		          return Promise.resolve({});
		        } else {
		          throw error;
		        }
		      }
		    );
		  }
		  return {
		    send,
		    flush
		  };
		}

		exports.DEFAULT_TRANSPORT_BUFFER_SIZE = DEFAULT_TRANSPORT_BUFFER_SIZE;
		exports.createTransport = createTransport;
		
	} (base$2));
	return base$2;
}

var clientreport = {};

var hasRequiredClientreport;

function requireClientreport () {
	if (hasRequiredClientreport) return clientreport;
	hasRequiredClientreport = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const time = /*@__PURE__*/ requireTime();

		function createClientReportEnvelope(discarded_events, dsn, timestamp) {
		  const clientReportItem = [
		    { type: "client_report" },
		    {
		      timestamp: timestamp || time.dateTimestampInSeconds(),
		      discarded_events
		    }
		  ];
		  return envelope.createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
		}

		exports.createClientReportEnvelope = createClientReportEnvelope;
		
	} (clientreport));
	return clientreport;
}

var eventUtils = {};

var hasRequiredEventUtils;

function requireEventUtils () {
	if (hasRequiredEventUtils) return eventUtils;
	hasRequiredEventUtils = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function getPossibleEventMessages(event) {
		  const possibleMessages = [];
		  if (event.message) {
		    possibleMessages.push(event.message);
		  }
		  try {
		    const lastException = event.exception.values[event.exception.values.length - 1];
		    if (lastException?.value) {
		      possibleMessages.push(lastException.value);
		      if (lastException.type) {
		        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
		      }
		    }
		  } catch {
		  }
		  return possibleMessages;
		}

		exports.getPossibleEventMessages = getPossibleEventMessages;
		
	} (eventUtils));
	return eventUtils;
}

var transactionEvent = {};

var hasRequiredTransactionEvent;

function requireTransactionEvent () {
	if (hasRequiredTransactionEvent) return transactionEvent;
	hasRequiredTransactionEvent = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();

		function convertTransactionEventToSpanJson(event) {
		  const { trace_id, parent_span_id, span_id, status, origin, data, op } = event.contexts?.trace ?? {};
		  return {
		    data: data ?? {},
		    description: event.transaction,
		    op,
		    parent_span_id,
		    span_id: span_id ?? "",
		    start_timestamp: event.start_timestamp ?? 0,
		    status,
		    timestamp: event.timestamp,
		    trace_id: trace_id ?? "",
		    origin,
		    profile_id: data?.[semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID],
		    exclusive_time: data?.[semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
		    measurements: event.measurements,
		    is_segment: true
		  };
		}
		function convertSpanJsonToTransactionEvent(span) {
		  return {
		    type: "transaction",
		    timestamp: span.timestamp,
		    start_timestamp: span.start_timestamp,
		    transaction: span.description,
		    contexts: {
		      trace: {
		        trace_id: span.trace_id,
		        span_id: span.span_id,
		        parent_span_id: span.parent_span_id,
		        op: span.op,
		        status: span.status,
		        origin: span.origin,
		        data: {
		          ...span.data,
		          ...span.profile_id && { [semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id },
		          ...span.exclusive_time && { [semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time }
		        }
		      }
		    },
		    measurements: span.measurements
		  };
		}

		exports.convertSpanJsonToTransactionEvent = convertSpanJsonToTransactionEvent;
		exports.convertTransactionEventToSpanJson = convertTransactionEventToSpanJson;
		
	} (transactionEvent));
	return transactionEvent;
}

var resolveDataCollectionOptions = {};

var defaultPiiToCollectionOptions = {};

var filteringSnippets = {};

var hasRequiredFilteringSnippets;

function requireFilteringSnippets () {
	if (hasRequiredFilteringSnippets) return filteringSnippets;
	hasRequiredFilteringSnippets = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const FILTERED_VALUE = "[Filtered]";
		const PII_HEADER_SNIPPETS = ["forwarded", "-ip", "remote-", "via", "-user"];
		const SENSITIVE_KEY_SNIPPETS = [
		  "auth",
		  "token",
		  "secret",
		  "session",
		  // for the user_session cookie
		  "password",
		  "passwd",
		  "pwd",
		  "key",
		  "jwt",
		  "bearer",
		  "sso",
		  "saml",
		  "csrf",
		  "xsrf",
		  "credentials",
		  "sid",
		  "identity",
		  // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
		  "set-cookie",
		  "cookie"
		];
		const SENSITIVE_COOKIE_NAME_SNIPPETS = [
		  // Express / Connect default session cookie
		  ".sid",
		  // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
		  "sessid",
		  // Laravel etc. "remember me" tokens
		  "remember",
		  // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
		  "oidc",
		  "pkce",
		  "nonce",
		  // RFC 6265bis high-security cookie name prefixes
		  "__secure-",
		  "__host-",
		  // Load balancer / CDN sticky-session cookies (opaque routing tokens)
		  "awsalb",
		  "awselb",
		  "akamai",
		  // BaaS / IdP session cookies (names often omit "session")
		  "__stripe",
		  "cognito",
		  "firebase",
		  "supabase",
		  "sb-",
		  // Step-up / MFA cookies
		  "mfa",
		  "2fa"
		];

		exports.FILTERED_VALUE = FILTERED_VALUE;
		exports.PII_HEADER_SNIPPETS = PII_HEADER_SNIPPETS;
		exports.SENSITIVE_COOKIE_NAME_SNIPPETS = SENSITIVE_COOKIE_NAME_SNIPPETS;
		exports.SENSITIVE_KEY_SNIPPETS = SENSITIVE_KEY_SNIPPETS;
		
	} (filteringSnippets));
	return filteringSnippets;
}

var hasRequiredDefaultPiiToCollectionOptions;

function requireDefaultPiiToCollectionOptions () {
	if (hasRequiredDefaultPiiToCollectionOptions) return defaultPiiToCollectionOptions;
	hasRequiredDefaultPiiToCollectionOptions = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const filteringSnippets = /*@__PURE__*/ requireFilteringSnippets();

		function defaultPiiToCollectionOptions(sendDefaultPii) {
		  return sendDefaultPii === true ? {
		    userInfo: true,
		    cookies: true,
		    httpHeaders: { request: true, response: true },
		    httpBodies: ["incomingRequest", "outgoingRequest", "incomingResponse", "outgoingResponse"],
		    queryParams: true,
		    genAI: { inputs: true, outputs: true },
		    stackFrameVariables: true,
		    frameContextLines: 7
		    // default should be 5, but ContextLines integration uses 7
		  } : {
		    userInfo: false,
		    cookies: { deny: filteringSnippets.PII_HEADER_SNIPPETS },
		    httpHeaders: { request: { deny: filteringSnippets.PII_HEADER_SNIPPETS }, response: { deny: filteringSnippets.PII_HEADER_SNIPPETS } },
		    httpBodies: [],
		    queryParams: { deny: filteringSnippets.PII_HEADER_SNIPPETS },
		    genAI: { inputs: false, outputs: false },
		    stackFrameVariables: true,
		    frameContextLines: 7
		    // default should be 5, but ContextLines integration uses 7
		  };
		}

		exports.defaultPiiToCollectionOptions = defaultPiiToCollectionOptions;
		
	} (defaultPiiToCollectionOptions));
	return defaultPiiToCollectionOptions;
}

var hasRequiredResolveDataCollectionOptions;

function requireResolveDataCollectionOptions () {
	if (hasRequiredResolveDataCollectionOptions) return resolveDataCollectionOptions;
	hasRequiredResolveDataCollectionOptions = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const defaultPiiToCollectionOptions = /*@__PURE__*/ requireDefaultPiiToCollectionOptions();

		const DEFAULTS = {
		  userInfo: true,
		  cookies: true,
		  httpHeaders: { request: true, response: true },
		  httpBodies: ["incomingRequest", "outgoingRequest", "incomingResponse", "outgoingResponse"],
		  queryParams: true,
		  genAI: { inputs: true, outputs: true },
		  stackFrameVariables: true,
		  frameContextLines: 5
		};
		function resolveDataCollectionOptions(options) {
		  const base = options.dataCollection != null ? DEFAULTS : defaultPiiToCollectionOptions.defaultPiiToCollectionOptions(options.sendDefaultPii);
		  const dc = options.dataCollection ?? {};
		  return {
		    userInfo: dc.userInfo ?? base.userInfo,
		    cookies: dc.cookies ?? base.cookies,
		    httpHeaders: {
		      request: dc.httpHeaders?.request ?? base.httpHeaders.request,
		      response: dc.httpHeaders?.response ?? base.httpHeaders.response
		    },
		    httpBodies: dc.httpBodies ?? base.httpBodies,
		    queryParams: dc.queryParams ?? base.queryParams,
		    genAI: {
		      inputs: dc.genAI?.inputs ?? base.genAI.inputs,
		      outputs: dc.genAI?.outputs ?? base.genAI.outputs
		    },
		    stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
		    frameContextLines: dc.frameContextLines ?? base.frameContextLines
		  };
		}

		exports.resolveDataCollectionOptions = resolveDataCollectionOptions;
		
	} (resolveDataCollectionOptions));
	return resolveDataCollectionOptions;
}

var hasRequiredClient$1;

function requireClient$1 () {
	if (hasRequiredClient$1) return client$1;
	hasRequiredClient$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const api = /*@__PURE__*/ requireApi$1();
		const constants = /*@__PURE__*/ requireConstants$9();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const envelope = /*@__PURE__*/ requireEnvelope$3();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const internal = /*@__PURE__*/ requireInternal$1();
		const internal$1 = /*@__PURE__*/ requireInternal();
		const session = /*@__PURE__*/ requireSession();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const beforeSendSpan = /*@__PURE__*/ requireBeforeSendSpan();
		const extractGenAiSpans = /*@__PURE__*/ requireExtractGenAiSpans();
		const base = /*@__PURE__*/ requireBase$2();
		const clientreport = /*@__PURE__*/ requireClientreport();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const dsn = /*@__PURE__*/ requireDsn();
		const envelope$1 = /*@__PURE__*/ requireEnvelope$4();
		const eventUtils = /*@__PURE__*/ requireEventUtils();
		const is = /*@__PURE__*/ requireIs$1();
		const merge = /*@__PURE__*/ requireMerge();
		const misc = /*@__PURE__*/ requireMisc();
		const parseSampleRate = /*@__PURE__*/ requireParseSampleRate();
		const prepareEvent = /*@__PURE__*/ requirePrepareEvent();
		const promisebuffer = /*@__PURE__*/ requirePromisebuffer();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const shouldIgnoreSpan = /*@__PURE__*/ requireShouldIgnoreSpan();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const syncpromise = /*@__PURE__*/ requireSyncpromise();
		const timer = /*@__PURE__*/ requireTimer();
		const transactionEvent = /*@__PURE__*/ requireTransactionEvent();
		const resolveDataCollectionOptions = /*@__PURE__*/ requireResolveDataCollectionOptions();

		const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
		const MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
		const INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
		const DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
		const DEFAULT_FLUSH_INTERVAL = 5e3;
		function _makeInternalError(message) {
		  return {
		    message,
		    [INTERNAL_ERROR_SYMBOL]: true
		  };
		}
		function _makeDoNotSendEventError(message) {
		  return {
		    message,
		    [DO_NOT_SEND_EVENT_SYMBOL]: true
		  };
		}
		function _isInternalError(error) {
		  return !!error && typeof error === "object" && INTERNAL_ERROR_SYMBOL in error;
		}
		function _isDoNotSendEventError(error) {
		  return !!error && typeof error === "object" && DO_NOT_SEND_EVENT_SYMBOL in error;
		}
		function setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
		  let weight = 0;
		  let flushTimeout;
		  let isTimerActive = false;
		  client.on(flushHook, () => {
		    weight = 0;
		    clearTimeout(flushTimeout);
		    isTimerActive = false;
		  });
		  client.on(afterCaptureHook, (item) => {
		    weight += estimateSizeFn(item);
		    if (weight >= 8e5) {
		      flushFn(client);
		    } else if (!isTimerActive) {
		      const flushInterval = client.getOptions()._flushInterval ?? DEFAULT_FLUSH_INTERVAL;
		      if (flushInterval > 0) {
		        isTimerActive = true;
		        flushTimeout = timer.safeUnref(
		          setTimeout(() => {
		            flushFn(client);
		          }, flushInterval)
		        );
		      }
		    }
		  });
		  client.on("flush", () => {
		    flushFn(client);
		  });
		}
		class Client {
		  /**
		   * Initializes this client instance.
		   *
		   * @param options Options for the client.
		   */
		  constructor(options) {
		    this._options = options;
		    this._integrations = {};
		    this._numProcessing = 0;
		    this._outcomes = {};
		    this._hooks = {};
		    this._eventProcessors = [];
		    this._promiseBuffer = promisebuffer.makePromiseBuffer(options.transportOptions?.bufferSize ?? base.DEFAULT_TRANSPORT_BUFFER_SIZE);
		    this._dataCollection = resolveDataCollectionOptions.resolveDataCollectionOptions(options);
		    if (options.dsn) {
		      this._dsn = dsn.makeDsn(options.dsn);
		    } else {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No DSN provided, client will not send events.");
		    }
		    if (this._dsn) {
		      const url = api.getEnvelopeEndpointWithUrlEncodedAuth(
		        this._dsn,
		        options.tunnel,
		        options._metadata ? options._metadata.sdk : void 0
		      );
		      this._transport = options.transport({
		        tunnel: this._options.tunnel,
		        recordDroppedEvent: this.recordDroppedEvent.bind(this),
		        ...options.transportOptions,
		        url
		      });
		    }
		    this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
		    if (this._options.enableLogs) {
		      setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", estimateLogSizeInBytes, internal._INTERNAL_flushLogsBuffer);
		    }
		    const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
		    if (enableMetrics) {
		      setupWeightBasedFlushing(
		        this,
		        "afterCaptureMetric",
		        "flushMetrics",
		        estimateMetricSizeInBytes,
		        internal$1._INTERNAL_flushMetricsBuffer
		      );
		    }
		  }
		  /**
		   * Captures an exception event and sends it to Sentry.
		   *
		   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
		   */
		  captureException(exception, hint, scope) {
		    const eventId = misc.uuid4();
		    if (misc.checkOrSetAlreadyCaught(exception)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(ALREADY_SEEN_ERROR);
		      return eventId;
		    }
		    const hintWithEventId = {
		      event_id: eventId,
		      ...hint
		    };
		    this._process(
		      () => this.eventFromException(exception, hintWithEventId).then((event) => this._captureEvent(event, hintWithEventId, scope)).then((res) => res),
		      "error"
		    );
		    return hintWithEventId.event_id;
		  }
		  /**
		   * Captures a message event and sends it to Sentry.
		   *
		   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
		   */
		  captureMessage(message, level, hint, currentScope) {
		    const hintWithEventId = {
		      event_id: misc.uuid4(),
		      ...hint
		    };
		    const eventMessage = is.isParameterizedString(message) ? message : String(message);
		    const isMessage = is.isPrimitive(message);
		    const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
		    this._process(
		      () => promisedEvent.then((event) => this._captureEvent(event, hintWithEventId, currentScope)),
		      isMessage ? "unknown" : "error"
		    );
		    return hintWithEventId.event_id;
		  }
		  /**
		   * Captures a manually created event and sends it to Sentry.
		   *
		   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
		   */
		  captureEvent(event, hint, currentScope) {
		    const eventId = misc.uuid4();
		    if (hint?.originalException && misc.checkOrSetAlreadyCaught(hint.originalException)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(ALREADY_SEEN_ERROR);
		      return eventId;
		    }
		    const hintWithEventId = {
		      event_id: eventId,
		      ...hint
		    };
		    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
		    const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
		    const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
		    const dataCategory = getDataCategoryByType(event.type);
		    this._process(
		      () => this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope),
		      dataCategory
		    );
		    return hintWithEventId.event_id;
		  }
		  /**
		   * Captures a session.
		   */
		  captureSession(session$1) {
		    this.sendSession(session$1);
		    session.updateSession(session$1, { init: false });
		  }
		  /**
		   * Get the current Dsn.
		   */
		  getDsn() {
		    return this._dsn;
		  }
		  /**
		   * Get the current options.
		   */
		  getOptions() {
		    return this._options;
		  }
		  /**
		   * Get the resolved data collection configuration.
		   */
		  getDataCollectionOptions() {
		    return this._dataCollection;
		  }
		  /**
		   * Get the SDK metadata.
		   * @see SdkMetadata
		   */
		  getSdkMetadata() {
		    return this._options._metadata;
		  }
		  /**
		   * Returns the transport that is used by the client.
		   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
		   */
		  getTransport() {
		    return this._transport;
		  }
		  /**
		   * Wait for all events to be sent or the timeout to expire, whichever comes first.
		   *
		   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
		   *   cause the client to wait until all events are sent before resolving the promise.
		   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
		   * still events in the queue when the timeout is reached.
		   */
		  // @ts-expect-error - PromiseLike is a subset of Promise
		  async flush(timeout) {
		    const transport = this._transport;
		    this.emit("flush");
		    if (!transport) {
		      return true;
		    }
		    const clientFinished = await this._isClientDoneProcessing(timeout);
		    const transportFlushed = await transport.flush(timeout);
		    return clientFinished && transportFlushed;
		  }
		  /**
		   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
		   *
		   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
		   *   the client to wait until all events are sent before disabling itself.
		   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
		   * it doesn't.
		   */
		  // @ts-expect-error - PromiseLike is a subset of Promise
		  async close(timeout) {
		    internal._INTERNAL_flushLogsBuffer(this);
		    const result = await this.flush(timeout);
		    this.getOptions().enabled = false;
		    this.emit("close");
		    return result;
		  }
		  /**
		   * Get all installed event processors.
		   */
		  getEventProcessors() {
		    return this._eventProcessors;
		  }
		  /**
		   * Adds an event processor that applies to any event processed by this client.
		   */
		  addEventProcessor(eventProcessor) {
		    this._eventProcessors.push(eventProcessor);
		  }
		  /**
		   * Initialize this client.
		   * Call this after the client was set on a scope.
		   */
		  init() {
		    if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
		    // Spotlight enabled. This is particularly important for browser as we
		    // don't support the `spotlight` option there and rely on the users
		    // adding the `spotlightBrowserIntegration()` to their integrations which
		    // wouldn't get initialized with the check below when there's no DSN set.
		    this._options.integrations.some(({ name }) => name.startsWith("Spotlight"))) {
		      this._setupIntegrations();
		    }
		  }
		  /**
		   * Gets an installed integration by its name.
		   *
		   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
		   */
		  getIntegrationByName(integrationName) {
		    return this._integrations[integrationName];
		  }
		  /**
		   * Returns the names of all installed integrations.
		   */
		  getIntegrationNames() {
		    return Object.keys(this._integrations);
		  }
		  /**
		   * Add an integration to the client.
		   * This can be used to e.g. lazy load integrations.
		   * In most cases, this should not be necessary,
		   * and you're better off just passing the integrations via `integrations: []` at initialization time.
		   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
		   */
		  addIntegration(integration$1) {
		    const isAlreadyInstalled = this._integrations[integration$1.name];
		    if (!isAlreadyInstalled && integration$1.beforeSetup) {
		      integration$1.beforeSetup(this);
		    }
		    integration.setupIntegration(this, integration$1, this._integrations);
		    if (!isAlreadyInstalled) {
		      integration.afterSetupIntegrations(this, [integration$1]);
		    }
		  }
		  /**
		   * Send a fully prepared event to Sentry.
		   */
		  sendEvent(event, hint = {}) {
		    this.emit("beforeSendEvent", event, hint);
		    const genAiSpanItem = extractGenAiSpans.extractGenAiSpansFromEvent(event, this);
		    let env = envelope.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
		    for (const attachment of hint.attachments || []) {
		      env = envelope$1.addItemToEnvelope(env, envelope$1.createAttachmentEnvelopeItem(attachment));
		    }
		    if (genAiSpanItem) {
		      env = envelope$1.addItemToEnvelope(env, genAiSpanItem);
		    }
		    this.sendEnvelope(env).then((sendResponse) => this.emit("afterSendEvent", event, sendResponse));
		  }
		  /**
		   * Send a session or session aggregrates to Sentry.
		   */
		  sendSession(session) {
		    const { release: clientReleaseOption, environment: clientEnvironmentOption = constants.DEFAULT_ENVIRONMENT } = this._options;
		    if ("aggregates" in session) {
		      const sessionAttrs = session.attrs || {};
		      if (!sessionAttrs.release && !clientReleaseOption) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
		        return;
		      }
		      sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
		      sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
		      session.attrs = sessionAttrs;
		    } else {
		      if (!session.release && !clientReleaseOption) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
		        return;
		      }
		      session.release = session.release || clientReleaseOption;
		      session.environment = session.environment || clientEnvironmentOption;
		    }
		    this.emit("beforeSendSession", session);
		    const env = envelope.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
		    this.sendEnvelope(env);
		  }
		  /**
		   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
		   */
		  recordDroppedEvent(reason, category, count = 1) {
		    if (this._options.sendClientReports) {
		      const key = `${reason}:${category}`;
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
		      this._outcomes[key] = (this._outcomes[key] || 0) + count;
		    }
		  }
		  /**
		   * Register a hook on this client.
		   */
		  on(hook, callback) {
		    const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
		    const uniqueCallback = (...args) => callback(...args);
		    hookCallbacks.add(uniqueCallback);
		    return () => {
		      hookCallbacks.delete(uniqueCallback);
		    };
		  }
		  /**
		   * Emit a hook that was previously registered via `on()`.
		   */
		  emit(hook, ...rest) {
		    const callbacks = this._hooks[hook];
		    if (callbacks) {
		      callbacks.forEach((callback) => callback(...rest));
		    }
		  }
		  /**
		   * Send an envelope to Sentry.
		   */
		  // @ts-expect-error - PromiseLike is a subset of Promise
		  async sendEnvelope(envelope) {
		    this.emit("beforeEnvelope", envelope);
		    if (this._isEnabled() && this._transport) {
		      try {
		        return await this._transport.send(envelope);
		      } catch (reason) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.error("Error while sending envelope:", reason);
		        return {};
		      }
		    }
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error("Transport disabled");
		    return {};
		  }
		  /**
		   * Register a cleanup function to be called when the client is disposed.
		   * This is useful for integrations that need to clean up global state.
		   *
		   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
		   * override this method to actually register and execute cleanup callbacks.
		   */
		  // eslint-disable-next-line @typescript-eslint/no-unused-vars
		  registerCleanup(callback) {
		  }
		  /**
		   * Disposes of the client and releases all resources.
		   *
		   * Subclasses should override this method to clean up their own resources, including invoking
		   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
		   * no-op and does NOT execute registered cleanup callbacks.
		   *
		   * After calling dispose(), the client should not be used anymore.
		   */
		  dispose() {
		  }
		  /* eslint-enable @typescript-eslint/unified-signatures */
		  /** Setup integrations for this client. */
		  _setupIntegrations() {
		    const { integrations } = this._options;
		    this._integrations = integration.setupIntegrations(this, integrations);
		    integration.afterSetupIntegrations(this, integrations);
		  }
		  /** Updates existing session based on the provided event */
		  _updateSessionFromEvent(session$1, event) {
		    let crashed = event.level === "fatal";
		    let errored = false;
		    const exceptions = event.exception?.values;
		    if (exceptions) {
		      errored = true;
		      crashed = false;
		      for (const ex of exceptions) {
		        if (ex.mechanism?.handled === false) {
		          crashed = true;
		          break;
		        }
		      }
		    }
		    const sessionNonTerminal = session$1.status === "ok";
		    const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
		    if (shouldUpdateAndSend) {
		      session.updateSession(session$1, {
		        ...crashed && { status: "crashed" },
		        errors: session$1.errors || Number(errored || crashed)
		      });
		      this.captureSession(session$1);
		    }
		  }
		  /**
		   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
		   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
		   *
		   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
		   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
		   * `true`.
		   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
		   * `false` otherwise
		   */
		  async _isClientDoneProcessing(timeout) {
		    let ticked = 0;
		    while (!timeout || ticked < timeout) {
		      await new Promise((resolve) => setTimeout(resolve, 1));
		      if (!this._numProcessing) {
		        return true;
		      }
		      ticked++;
		    }
		    return false;
		  }
		  /** Determines whether this SDK is enabled and a transport is present. */
		  _isEnabled() {
		    return this.getOptions().enabled !== false && this._transport !== void 0;
		  }
		  /**
		   * Adds common information to events.
		   *
		   * The information includes release and environment from `options`,
		   * breadcrumbs and context (extra, tags and user) from the scope.
		   *
		   * Information that is already present in the event is never overwritten. For
		   * nested objects, such as the context, keys are merged.
		   *
		   * @param event The original event.
		   * @param hint May contain additional information about the original exception.
		   * @param currentScope A scope containing event metadata.
		   * @returns A new event with more information.
		   */
		  _prepareEvent(event, hint, currentScope, isolationScope) {
		    const options = this.getOptions();
		    const integrations = this.getIntegrationNames();
		    if (!hint.integrations && integrations.length) {
		      hint.integrations = integrations;
		    }
		    this.emit("preprocessEvent", event, hint);
		    if (!event.type) {
		      isolationScope.setLastEventId(event.event_id || hint.event_id);
		    }
		    return prepareEvent.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt) => {
		      if (evt === null) {
		        return evt;
		      }
		      this.emit("postprocessEvent", evt, hint);
		      evt.contexts = {
		        trace: { ...evt.contexts?.trace, ...currentScopes.getTraceContextFromScope(currentScope) },
		        ...evt.contexts
		      };
		      const dynamicSamplingContext$1 = dynamicSamplingContext.getDynamicSamplingContextFromScope(this, currentScope);
		      evt.sdkProcessingMetadata = {
		        dynamicSamplingContext: dynamicSamplingContext$1,
		        ...evt.sdkProcessingMetadata
		      };
		      return evt;
		    });
		  }
		  /**
		   * Processes the event and logs an error in case of rejection
		   * @param event
		   * @param hint
		   * @param scope
		   */
		  _captureEvent(event, hint = {}, currentScope = currentScopes.getCurrentScope(), isolationScope = currentScopes.getIsolationScope()) {
		    if (debugBuild.DEBUG_BUILD && isErrorEvent(event)) {
		      debugLogger.debug.log(`Captured error event \`${eventUtils.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
		    }
		    return this._processEvent(event, hint, currentScope, isolationScope).then(
		      (finalEvent) => {
		        return finalEvent.event_id;
		      },
		      (reason) => {
		        if (debugBuild.DEBUG_BUILD) {
		          if (_isDoNotSendEventError(reason)) {
		            debugLogger.debug.log(reason.message);
		          } else if (_isInternalError(reason)) {
		            debugLogger.debug.warn(reason.message);
		          } else {
		            debugLogger.debug.warn(reason);
		          }
		        }
		        return void 0;
		      }
		    );
		  }
		  /**
		   * Processes an event (either error or message) and sends it to Sentry.
		   *
		   * This also adds breadcrumbs and context information to the event. However,
		   * platform specific meta data (such as the User's IP address) must be added
		   * by the SDK implementor.
		   *
		   *
		   * @param event The event to send to Sentry.
		   * @param hint May contain additional information about the original exception.
		   * @param currentScope A scope containing event metadata.
		   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
		   */
		  _processEvent(event, hint, currentScope, isolationScope) {
		    const options = this.getOptions();
		    const { sampleRate } = options;
		    const isTransaction = isTransactionEvent(event);
		    const isError = isErrorEvent(event);
		    const eventType = event.type || "error";
		    const beforeSendLabel = `before send for type \`${eventType}\``;
		    const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : parseSampleRate.parseSampleRate(sampleRate);
		    if (isError && typeof parsedSampleRate === "number" && randomSafeContext.safeMathRandom() > parsedSampleRate) {
		      this.recordDroppedEvent("sample_rate", "error");
		      return syncpromise.rejectedSyncPromise(
		        _makeDoNotSendEventError(
		          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`
		        )
		      );
		    }
		    const dataCategory = getDataCategoryByType(event.type);
		    return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared) => {
		      if (prepared === null) {
		        this.recordDroppedEvent("event_processor", dataCategory);
		        throw _makeDoNotSendEventError("An event processor returned `null`, will not send event.");
		      }
		      const isInternalException = hint.data?.__sentry__ === true;
		      if (isInternalException) {
		        return prepared;
		      }
		      const result = processBeforeSend(this, options, prepared, hint);
		      return _validateBeforeSendResult(result, beforeSendLabel);
		    }).then((processedEvent) => {
		      if (processedEvent === null) {
		        this.recordDroppedEvent("before_send", dataCategory);
		        if (isTransaction) {
		          const spans = event.spans || [];
		          const spanCount = 1 + spans.length;
		          this.recordDroppedEvent("before_send", "span", spanCount);
		        }
		        throw _makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
		      }
		      const session = currentScope.getSession() || isolationScope.getSession();
		      if (isError && session) {
		        this._updateSessionFromEvent(session, processedEvent);
		      }
		      if (isTransaction) {
		        const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
		        const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
		        const droppedSpanCount = spanCountBefore - spanCountAfter;
		        if (droppedSpanCount > 0) {
		          this.recordDroppedEvent("before_send", "span", droppedSpanCount);
		        }
		      }
		      const transactionInfo = processedEvent.transaction_info;
		      if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
		        const source = "custom";
		        processedEvent.transaction_info = {
		          ...transactionInfo,
		          source
		        };
		      }
		      this.sendEvent(processedEvent, hint);
		      return processedEvent;
		    }).then(null, (reason) => {
		      if (_isDoNotSendEventError(reason) || _isInternalError(reason)) {
		        throw reason;
		      }
		      this.captureException(reason, {
		        mechanism: {
		          handled: false,
		          type: "internal"
		        },
		        data: {
		          __sentry__: true
		        },
		        originalException: reason
		      });
		      throw _makeInternalError(
		        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`
		      );
		    });
		  }
		  /**
		   * Occupies the client with processing and event
		   */
		  _process(taskProducer, dataCategory) {
		    this._numProcessing++;
		    void this._promiseBuffer.add(taskProducer).then(
		      (value) => {
		        this._numProcessing--;
		        return value;
		      },
		      (reason) => {
		        this._numProcessing--;
		        if (reason === promisebuffer.SENTRY_BUFFER_FULL_ERROR) {
		          this.recordDroppedEvent("queue_overflow", dataCategory);
		        }
		        return reason;
		      }
		    );
		  }
		  /**
		   * Clears outcomes on this client and returns them.
		   */
		  _clearOutcomes() {
		    const outcomes = this._outcomes;
		    this._outcomes = {};
		    return Object.entries(outcomes).map(([key, quantity]) => {
		      const [reason, category] = key.split(":");
		      return {
		        reason,
		        category,
		        quantity
		      };
		    });
		  }
		  /**
		   * Sends client reports as an envelope.
		   */
		  _flushOutcomes() {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("Flushing outcomes...");
		    const outcomes = this._clearOutcomes();
		    if (outcomes.length === 0) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log("No outcomes to send");
		      return;
		    }
		    if (!this._dsn) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log("No dsn provided, will not send outcomes");
		      return;
		    }
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("Sending outcomes:", outcomes);
		    const envelope = clientreport.createClientReportEnvelope(outcomes, this._options.tunnel && dsn.dsnToString(this._dsn));
		    this.sendEnvelope(envelope);
		  }
		}
		function getDataCategoryByType(type) {
		  return type === "replay_event" ? "replay" : type || "error";
		}
		function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
		  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
		  if (is.isThenable(beforeSendResult)) {
		    return beforeSendResult.then(
		      (event) => {
		        if (!is.isPlainObject(event) && event !== null) {
		          throw _makeInternalError(invalidValueError);
		        }
		        return event;
		      },
		      (e) => {
		        throw _makeInternalError(`${beforeSendLabel} rejected with ${e}`);
		      }
		    );
		  } else if (!is.isPlainObject(beforeSendResult) && beforeSendResult !== null) {
		    throw _makeInternalError(invalidValueError);
		  }
		  return beforeSendResult;
		}
		function processBeforeSend(client, options, event, hint) {
		  const { beforeSend, beforeSendTransaction, ignoreSpans } = options;
		  const beforeSendSpan$1 = !beforeSendSpan.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
		  let processedEvent = event;
		  if (isErrorEvent(processedEvent) && beforeSend) {
		    return beforeSend(processedEvent, hint);
		  }
		  if (isTransactionEvent(processedEvent)) {
		    if (beforeSendSpan$1 || ignoreSpans) {
		      const rootSpanJson = transactionEvent.convertTransactionEventToSpanJson(processedEvent);
		      if (ignoreSpans?.length && shouldIgnoreSpan.shouldIgnoreSpan(
		        { description: rootSpanJson.description, op: rootSpanJson.op, attributes: rootSpanJson.data },
		        ignoreSpans
		      )) {
		        return null;
		      }
		      if (beforeSendSpan$1) {
		        const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
		        if (!processedRootSpanJson) {
		          spanUtils.showSpanDropWarning();
		        } else {
		          processedEvent = merge.merge(event, transactionEvent.convertSpanJsonToTransactionEvent(processedRootSpanJson));
		        }
		      }
		      if (processedEvent.spans) {
		        const processedSpans = [];
		        const initialSpans = processedEvent.spans;
		        for (const span of initialSpans) {
		          if (ignoreSpans?.length && shouldIgnoreSpan.shouldIgnoreSpan({ description: span.description, op: span.op, attributes: span.data }, ignoreSpans)) {
		            shouldIgnoreSpan.reparentChildSpans(initialSpans, span);
		            continue;
		          }
		          if (beforeSendSpan$1) {
		            const processedSpan = beforeSendSpan$1(span);
		            if (!processedSpan) {
		              spanUtils.showSpanDropWarning();
		              processedSpans.push(span);
		            } else {
		              processedSpans.push(processedSpan);
		            }
		          } else {
		            processedSpans.push(span);
		          }
		        }
		        const droppedSpans = processedEvent.spans.length - processedSpans.length;
		        if (droppedSpans) {
		          client.recordDroppedEvent("before_send", "span", droppedSpans);
		        }
		        processedEvent.spans = processedSpans;
		      }
		    }
		    if (beforeSendTransaction) {
		      if (processedEvent.spans) {
		        const spanCountBefore = processedEvent.spans.length;
		        processedEvent.sdkProcessingMetadata = {
		          ...event.sdkProcessingMetadata,
		          spanCountBeforeProcessing: spanCountBefore
		        };
		      }
		      return beforeSendTransaction(processedEvent, hint);
		    }
		  }
		  return processedEvent;
		}
		function isErrorEvent(event) {
		  return event.type === void 0;
		}
		function isTransactionEvent(event) {
		  return event.type === "transaction";
		}
		function estimateMetricSizeInBytes(metric) {
		  let weight = 0;
		  if (metric.name) {
		    weight += metric.name.length * 2;
		  }
		  weight += 8;
		  return weight + estimateAttributesSizeInBytes(metric.attributes);
		}
		function estimateLogSizeInBytes(log) {
		  let weight = 0;
		  if (log.message) {
		    weight += log.message.length * 2;
		  }
		  return weight + estimateAttributesSizeInBytes(log.attributes);
		}
		function estimateAttributesSizeInBytes(attributes) {
		  if (!attributes) {
		    return 0;
		  }
		  let weight = 0;
		  Object.values(attributes).forEach((value) => {
		    if (Array.isArray(value)) {
		      weight += value.length * estimatePrimitiveSizeInBytes(value[0]);
		    } else if (is.isPrimitive(value)) {
		      weight += estimatePrimitiveSizeInBytes(value);
		    } else {
		      weight += 100;
		    }
		  });
		  return weight;
		}
		function estimatePrimitiveSizeInBytes(value) {
		  if (typeof value === "string") {
		    return value.length * 2;
		  } else if (typeof value === "number") {
		    return 8;
		  } else if (typeof value === "boolean") {
		    return 4;
		  }
		  return 0;
		}

		exports.Client = Client;
		
	} (client$1));
	return client$1;
}

var sdk$1 = {};

var hasRequiredSdk$1;

function requireSdk$1 () {
	if (hasRequiredSdk$1) return sdk$1;
	hasRequiredSdk$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();

		function initAndBind(clientClass, options) {
		  if (options.debug === true) {
		    if (debugBuild.DEBUG_BUILD) {
		      debugLogger.debug.enable();
		    } else {
		      debugLogger.consoleSandbox(() => {
		        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
		      });
		    }
		  }
		  const scope = currentScopes.getCurrentScope();
		  scope.update(options.initialScope);
		  const client = new clientClass(options);
		  setCurrentClient(client);
		  client.init();
		  return client;
		}
		function setCurrentClient(client) {
		  currentScopes.getCurrentScope().setClient(client);
		}

		exports.initAndBind = initAndBind;
		exports.setCurrentClient = setCurrentClient;
		
	} (sdk$1));
	return sdk$1;
}

var offline$1 = {};

var hasRequiredOffline$1;

function requireOffline$1 () {
	if (hasRequiredOffline$1) return offline$1;
	hasRequiredOffline$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const ratelimit = /*@__PURE__*/ requireRatelimit();
		const timer = /*@__PURE__*/ requireTimer();

		const MIN_DELAY = 100;
		const START_DELAY = 5e3;
		const MAX_DELAY = 36e5;
		function makeOfflineTransport(createTransport) {
		  function log(...args) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("[Offline]:", ...args);
		  }
		  return (options) => {
		    const transport = createTransport(options);
		    if (!options.createStore) {
		      throw new Error("No `createStore` function was provided");
		    }
		    const store = options.createStore(options);
		    let retryDelay = START_DELAY;
		    let flushTimer;
		    function shouldQueue(env, error, retryDelay2) {
		      if (envelope.envelopeContainsItemType(env, ["client_report"])) {
		        return false;
		      }
		      if (options.shouldStore) {
		        return options.shouldStore(env, error, retryDelay2);
		      }
		      return true;
		    }
		    function flushIn(delay) {
		      if (flushTimer) {
		        clearTimeout(flushTimer);
		      }
		      flushTimer = timer.safeUnref(
		        setTimeout(async () => {
		          flushTimer = void 0;
		          const found = await store.shift();
		          if (found) {
		            log("Attempting to send previously queued event");
		            found[0].sent_at = new Date(randomSafeContext.safeDateNow()).toISOString();
		            void send(found, true).catch((e) => {
		              log("Failed to retry sending", e);
		            });
		          }
		        }, delay)
		      );
		    }
		    function flushWithBackOff() {
		      if (flushTimer) {
		        return;
		      }
		      flushIn(retryDelay);
		      retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
		    }
		    async function send(envelope$1, isRetry = false) {
		      if (!isRetry && envelope.envelopeContainsItemType(envelope$1, ["replay_event", "replay_recording"])) {
		        await store.push(envelope$1);
		        flushIn(MIN_DELAY);
		        return {};
		      }
		      try {
		        if (options.shouldSend && await options.shouldSend(envelope$1) === false) {
		          throw new Error("Envelope not sent because `shouldSend` callback returned false");
		        }
		        const result = await transport.send(envelope$1);
		        let delay = MIN_DELAY;
		        if (result) {
		          if (result.headers?.["retry-after"]) {
		            delay = ratelimit.parseRetryAfterHeader(result.headers["retry-after"]);
		          } else if (result.headers?.["x-sentry-rate-limits"]) {
		            delay = 6e4;
		          } else if ((result.statusCode || 0) >= 400) {
		            return result;
		          }
		        }
		        flushIn(delay);
		        retryDelay = START_DELAY;
		        return result;
		      } catch (e) {
		        if (await shouldQueue(envelope$1, e, retryDelay)) {
		          if (isRetry) {
		            await store.unshift(envelope$1);
		          } else {
		            await store.push(envelope$1);
		          }
		          flushWithBackOff();
		          log("Error sending. Event queued.", e);
		          return {};
		        } else {
		          throw e;
		        }
		      }
		    }
		    if (options.flushAtStartup) {
		      flushWithBackOff();
		    }
		    return {
		      send,
		      flush: (timeout) => {
		        if (timeout === void 0) {
		          retryDelay = START_DELAY;
		          flushIn(MIN_DELAY);
		        }
		        return transport.flush(timeout);
		      }
		    };
		  };
		}

		exports.MIN_DELAY = MIN_DELAY;
		exports.START_DELAY = START_DELAY;
		exports.makeOfflineTransport = makeOfflineTransport;
		
	} (offline$1));
	return offline$1;
}

var multiplexed = {};

var hasRequiredMultiplexed;

function requireMultiplexed () {
	if (hasRequiredMultiplexed) return multiplexed;
	hasRequiredMultiplexed = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const api = /*@__PURE__*/ requireApi$1();
		const dsn = /*@__PURE__*/ requireDsn();
		const envelope = /*@__PURE__*/ requireEnvelope$4();

		const MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
		function eventFromEnvelope(env, types) {
		  let event;
		  envelope.forEachEnvelopeItem(env, (item, type) => {
		    if (types.includes(type)) {
		      event = Array.isArray(item) ? item[1] : void 0;
		    }
		    return !!event;
		  });
		  return event;
		}
		function makeOverrideReleaseTransport(createTransport, release) {
		  return (options) => {
		    const transport = createTransport(options);
		    return {
		      ...transport,
		      send: async (envelope) => {
		        const event = eventFromEnvelope(envelope, ["event", "transaction", "profile", "replay_event"]);
		        if (event) {
		          event.release = release;
		        }
		        return transport.send(envelope);
		      }
		    };
		  };
		}
		function overrideDsn(envelope$1, dsn) {
		  return envelope.createEnvelope(
		    dsn ? {
		      ...envelope$1[0],
		      dsn
		    } : envelope$1[0],
		    envelope$1[1]
		  );
		}
		function makeMultiplexedTransport(createTransport, matcher) {
		  return (options) => {
		    const fallbackTransport = createTransport(options);
		    const otherTransports = /* @__PURE__ */ new Map();
		    const actualMatcher = matcher || ((args) => {
		      const event = args.getEvent();
		      if (event?.extra?.[MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY])) {
		        return event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY];
		      }
		      return [];
		    });
		    function getTransport(dsn$1, release) {
		      const key = release ? `${dsn$1}:${release}` : dsn$1;
		      let transport = otherTransports.get(key);
		      if (!transport) {
		        const validatedDsn = dsn.dsnFromString(dsn$1);
		        if (!validatedDsn) {
		          return void 0;
		        }
		        const url = api.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
		        transport = release ? makeOverrideReleaseTransport(createTransport, release)({ ...options, url }) : createTransport({ ...options, url });
		        otherTransports.set(key, transport);
		      }
		      return [dsn$1, transport];
		    }
		    async function send(envelope) {
		      function getEvent(types) {
		        const eventTypes = types?.length ? types : ["event"];
		        return eventFromEnvelope(envelope, eventTypes);
		      }
		      const transports = actualMatcher({ envelope, getEvent }).map((result) => {
		        if (typeof result === "string") {
		          return getTransport(result, void 0);
		        } else {
		          return getTransport(result.dsn, result.release);
		        }
		      }).filter((t) => !!t);
		      const transportsWithFallback = transports.length ? transports : [["", fallbackTransport]];
		      const results = await Promise.all(
		        transportsWithFallback.map(([dsn, transport]) => transport.send(overrideDsn(envelope, dsn)))
		      );
		      return results[0];
		    }
		    async function flush(timeout) {
		      const allTransports = [...otherTransports.values(), fallbackTransport];
		      const results = await Promise.all(allTransports.map((transport) => transport.flush(timeout)));
		      return results.every((r) => r);
		    }
		    return {
		      send,
		      flush
		    };
		  };
		}

		exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = MULTIPLEXED_TRANSPORT_EXTRA_KEY;
		exports.eventFromEnvelope = eventFromEnvelope;
		exports.makeMultiplexedTransport = makeMultiplexedTransport;
		
	} (multiplexed));
	return multiplexed;
}

var providerSkip = {};

var hasRequiredProviderSkip;

function requireProviderSkip () {
	if (hasRequiredProviderSkip) return providerSkip;
	hasRequiredProviderSkip = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();

		const SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
		function _INTERNAL_skipAiProviderWrapping(modules) {
		  modules.forEach((module) => {
		    SKIPPED_AI_PROVIDERS.add(module);
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`AI provider "${module}" wrapping will be skipped`);
		  });
		}
		function _INTERNAL_shouldSkipAiProviderWrapping(module) {
		  return SKIPPED_AI_PROVIDERS.has(module);
		}
		function _INTERNAL_clearAiProviderSkips() {
		  SKIPPED_AI_PROVIDERS.clear();
		  debugBuild.DEBUG_BUILD && debugLogger.debug.log("Cleared AI provider skip registrations");
		}

		exports._INTERNAL_clearAiProviderSkips = _INTERNAL_clearAiProviderSkips;
		exports._INTERNAL_shouldSkipAiProviderWrapping = _INTERNAL_shouldSkipAiProviderWrapping;
		exports._INTERNAL_skipAiProviderWrapping = _INTERNAL_skipAiProviderWrapping;
		
	} (providerSkip));
	return providerSkip;
}

var filterKeyValueData = {};

var hasRequiredFilterKeyValueData;

function requireFilterKeyValueData () {
	if (hasRequiredFilterKeyValueData) return filterKeyValueData;
	hasRequiredFilterKeyValueData = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const filteringSnippets = /*@__PURE__*/ requireFilteringSnippets();

		function isSensitiveKey(lower, denySnippets) {
		  return denySnippets.some((snippet) => lower.includes(snippet));
		}
		function filterKeyValueData(data, behavior, additionalDenyTerms) {
		  if (behavior === false) {
		    return {};
		  }
		  const denySnippets = additionalDenyTerms != null ? [...filteringSnippets.SENSITIVE_KEY_SNIPPETS, ...additionalDenyTerms] : filteringSnippets.SENSITIVE_KEY_SNIPPETS;
		  const result = {};
		  if (behavior === true) {
		    for (const key of Object.keys(data)) {
		      result[key] = isSensitiveKey(key.toLowerCase(), denySnippets) ? filteringSnippets.FILTERED_VALUE : data[key];
		    }
		    return result;
		  }
		  if ("deny" in behavior) {
		    const lowerTerms2 = behavior.deny.map((t) => t.toLowerCase());
		    for (const key of Object.keys(data)) {
		      const lower = key.toLowerCase();
		      const isDenied = isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term) => lower.includes(term));
		      result[key] = isDenied ? filteringSnippets.FILTERED_VALUE : data[key];
		    }
		    return result;
		  }
		  const lowerTerms = behavior.allow.map((t) => t.toLowerCase());
		  for (const key of Object.keys(data)) {
		    const lower = key.toLowerCase();
		    if (isSensitiveKey(lower, denySnippets)) {
		      result[key] = filteringSnippets.FILTERED_VALUE;
		    } else {
		      const isAllowed = lowerTerms.some((term) => lower.includes(term));
		      result[key] = isAllowed ? data[key] : filteringSnippets.FILTERED_VALUE;
		    }
		  }
		  return result;
		}

		exports.filterKeyValueData = filterKeyValueData;
		
	} (filterKeyValueData));
	return filterKeyValueData;
}

var filterCookies = {};

var cookie = {};

var hasRequiredCookie;

function requireCookie () {
	if (hasRequiredCookie) return cookie;
	hasRequiredCookie = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function parseCookie(str) {
		  const obj = {};
		  let index = 0;
		  while (index < str.length) {
		    const eqIdx = str.indexOf("=", index);
		    if (eqIdx === -1) {
		      break;
		    }
		    let endIdx = str.indexOf(";", index);
		    if (endIdx === -1) {
		      endIdx = str.length;
		    } else if (endIdx < eqIdx) {
		      index = str.lastIndexOf(";", eqIdx - 1) + 1;
		      continue;
		    }
		    const key = str.slice(index, eqIdx).trim();
		    if (void 0 === obj[key]) {
		      let val = str.slice(eqIdx + 1, endIdx).trim();
		      if (val.charCodeAt(0) === 34) {
		        val = val.slice(1, -1);
		      }
		      try {
		        obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
		      } catch {
		        obj[key] = val;
		      }
		    }
		    index = endIdx + 1;
		  }
		  return obj;
		}

		exports.parseCookie = parseCookie;
		
	} (cookie));
	return cookie;
}

var hasRequiredFilterCookies;

function requireFilterCookies () {
	if (hasRequiredFilterCookies) return filterCookies;
	hasRequiredFilterCookies = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const cookie = /*@__PURE__*/ requireCookie();
		const filteringSnippets = /*@__PURE__*/ requireFilteringSnippets();
		const filterKeyValueData = /*@__PURE__*/ requireFilterKeyValueData();

		function filterCookies(cookieString, behavior) {
		  if (behavior === false) {
		    return {};
		  }
		  try {
		    const parsed = cookie.parseCookie(cookieString);
		    if (Object.keys(parsed).length === 0) {
		      return {};
		    }
		    return filterKeyValueData.filterKeyValueData(parsed, behavior, filteringSnippets.SENSITIVE_COOKIE_NAME_SNIPPETS);
		  } catch {
		    return filteringSnippets.FILTERED_VALUE;
		  }
		}

		exports.filterCookies = filterCookies;
		
	} (filterCookies));
	return filterCookies;
}

var filterQueryParams = {};

var hasRequiredFilterQueryParams;

function requireFilterQueryParams () {
	if (hasRequiredFilterQueryParams) return filterQueryParams;
	hasRequiredFilterQueryParams = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const filteringSnippets = /*@__PURE__*/ requireFilteringSnippets();
		const filterKeyValueData = /*@__PURE__*/ requireFilterKeyValueData();

		function filterQueryParams(queryString, behavior) {
		  if (behavior === false) {
		    return {};
		  }
		  try {
		    const params = new URLSearchParams(queryString);
		    const parsed = {};
		    params.forEach((value, key) => {
		      parsed[key] = value;
		    });
		    if (Object.keys(parsed).length === 0) {
		      return {};
		    }
		    return filterKeyValueData.filterKeyValueData(parsed, behavior);
		  } catch {
		    return filteringSnippets.FILTERED_VALUE;
		  }
		}

		exports.filterQueryParams = filterQueryParams;
		
	} (filterQueryParams));
	return filterQueryParams;
}

var envToBool = {};

var hasRequiredEnvToBool;

function requireEnvToBool () {
	if (hasRequiredEnvToBool) return envToBool;
	hasRequiredEnvToBool = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const FALSY_ENV_VALUES = /* @__PURE__ */ new Set(["false", "f", "n", "no", "off", "0"]);
		const TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set(["true", "t", "y", "yes", "on", "1"]);
		function envToBool(value, options) {
		  const normalized = String(value).toLowerCase();
		  if (FALSY_ENV_VALUES.has(normalized)) {
		    return false;
		  }
		  if (TRUTHY_ENV_VALUES.has(normalized)) {
		    return true;
		  }
		  return options?.strict ? null : Boolean(value);
		}

		exports.FALSY_ENV_VALUES = FALSY_ENV_VALUES;
		exports.TRUTHY_ENV_VALUES = TRUTHY_ENV_VALUES;
		exports.envToBool = envToBool;
		
	} (envToBool));
	return envToBool;
}

var checkin = {};

var hasRequiredCheckin;

function requireCheckin () {
	if (hasRequiredCheckin) return checkin;
	hasRequiredCheckin = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const dsn = /*@__PURE__*/ requireDsn();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();

		function createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
		  const headers = {
		    sent_at: new Date(randomSafeContext.safeDateNow()).toISOString()
		  };
		  if (metadata?.sdk) {
		    headers.sdk = {
		      name: metadata.sdk.name,
		      version: metadata.sdk.version
		    };
		  }
		  if (!!tunnel && !!dsn$1) {
		    headers.dsn = dsn.dsnToString(dsn$1);
		  }
		  if (dynamicSamplingContext) {
		    headers.trace = dynamicSamplingContext;
		  }
		  const item = createCheckInEnvelopeItem(checkIn);
		  return envelope.createEnvelope(headers, [item]);
		}
		function createCheckInEnvelopeItem(checkIn) {
		  const checkInHeaders = {
		    type: "check_in"
		  };
		  return [checkInHeaders, checkIn];
		}

		exports.createCheckInEnvelope = createCheckInEnvelope;
		
	} (checkin));
	return checkin;
}

var isSentryRequestUrl = {};

var url = {};

var hasRequiredUrl;

function requireUrl () {
	if (hasRequiredUrl) return url;
	hasRequiredUrl = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();

		const DEFAULT_BASE_URL = "thismessage:/";
		function isURLObjectRelative(url) {
		  return "isRelative" in url;
		}
		function parseStringToURLObject(url, urlBase) {
		  const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
		  const base = urlBase ?? (isRelative ? DEFAULT_BASE_URL : void 0);
		  try {
		    if ("canParse" in URL && !URL.canParse(url, base)) {
		      return void 0;
		    }
		    const fullUrlObject = new URL(url, base);
		    if (isRelative) {
		      return {
		        isRelative,
		        pathname: fullUrlObject.pathname,
		        search: fullUrlObject.search,
		        hash: fullUrlObject.hash
		      };
		    }
		    return fullUrlObject;
		  } catch {
		  }
		  return void 0;
		}
		function getSanitizedUrlStringFromUrlObject(url) {
		  if (isURLObjectRelative(url)) {
		    return url.pathname;
		  }
		  const newUrl = new URL(url);
		  newUrl.search = "";
		  newUrl.hash = "";
		  if (["80", "443"].includes(newUrl.port)) {
		    newUrl.port = "";
		  }
		  if (newUrl.password) {
		    newUrl.password = "%filtered%";
		  }
		  if (newUrl.username) {
		    newUrl.username = "%filtered%";
		  }
		  return newUrl.toString();
		}
		function getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
		  const method = request?.method?.toUpperCase() ?? "GET";
		  const route = routeName ? routeName : urlObject ? kind === "client" ? getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
		  return `${method} ${route}`;
		}
		function getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
		  const attributes = {
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
		  };
		  if (routeName) {
		    attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
		    attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
		  }
		  if (request?.method) {
		    attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
		  }
		  if (urlObject) {
		    if (urlObject.search) {
		      attributes["url.query"] = urlObject.search;
		    }
		    if (urlObject.hash) {
		      attributes["url.fragment"] = urlObject.hash;
		    }
		    if (urlObject.pathname) {
		      attributes["url.path"] = urlObject.pathname;
		      if (urlObject.pathname === "/") {
		        attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
		      }
		    }
		    if (!isURLObjectRelative(urlObject)) {
		      attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
		      if (urlObject.port) {
		        attributes["url.port"] = urlObject.port;
		      }
		      if (urlObject.protocol) {
		        attributes["url.scheme"] = urlObject.protocol;
		      }
		      if (urlObject.hostname) {
		        attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
		      }
		    }
		  }
		  return [getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName), attributes];
		}
		function parseUrl(url) {
		  if (!url) {
		    return {};
		  }
		  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
		  if (!match) {
		    return {};
		  }
		  const query = match[6] || "";
		  const fragment = match[8] || "";
		  return {
		    host: match[4],
		    path: match[5],
		    protocol: match[2],
		    search: query,
		    hash: fragment,
		    relative: match[5] + query + fragment
		    // everything minus origin
		  };
		}
		function stripUrlQueryAndFragment(urlPath) {
		  return urlPath.split(/[?#]/, 1)[0];
		}
		function getSanitizedUrlString(url) {
		  const { protocol, host, path } = url;
		  const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
		  return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
		}
		function stripDataUrlContent(url, includeDataPrefix = true) {
		  if (url.startsWith("data:")) {
		    const match = url.match(/^data:([^;,]+)/);
		    const mimeType = match ? match[1] : "text/plain";
		    const isBase64 = url.includes(";base64,");
		    const dataStart = url.indexOf(",");
		    let dataPrefix = "";
		    if (includeDataPrefix && dataStart !== -1) {
		      const data = url.slice(dataStart + 1);
		      dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
		    }
		    return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
		  }
		  return url;
		}

		exports.getHttpSpanDetailsFromUrlObject = getHttpSpanDetailsFromUrlObject;
		exports.getSanitizedUrlString = getSanitizedUrlString;
		exports.getSanitizedUrlStringFromUrlObject = getSanitizedUrlStringFromUrlObject;
		exports.isURLObjectRelative = isURLObjectRelative;
		exports.parseStringToURLObject = parseStringToURLObject;
		exports.parseUrl = parseUrl;
		exports.stripDataUrlContent = stripDataUrlContent;
		exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
		
	} (url));
	return url;
}

var hasRequiredIsSentryRequestUrl;

function requireIsSentryRequestUrl () {
	if (hasRequiredIsSentryRequestUrl) return isSentryRequestUrl;
	hasRequiredIsSentryRequestUrl = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const url = /*@__PURE__*/ requireUrl();

		function isSentryRequestUrl(url, client) {
		  const dsn = client?.getDsn();
		  const tunnel = client?.getOptions().tunnel;
		  return checkDsn(url, dsn) || checkTunnel(url, tunnel);
		}
		function checkTunnel(url, tunnel) {
		  if (!tunnel) {
		    return false;
		  }
		  return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
		}
		function checkDsn(url$1, dsn) {
		  const urlParts = url.parseStringToURLObject(url$1);
		  if (!urlParts || url.isURLObjectRelative(urlParts)) {
		    return false;
		  }
		  if (!dsn) {
		    return false;
		  }
		  return hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
		}
		function hostnameMatchesDsnHost(hostname, dsnHost) {
		  return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
		}
		function removeTrailingSlash(str) {
		  return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
		}

		exports.isSentryRequestUrl = isSentryRequestUrl;
		
	} (isSentryRequestUrl));
	return isSentryRequestUrl;
}

var parameterize = {};

var hasRequiredParameterize;

function requireParameterize () {
	if (hasRequiredParameterize) return parameterize;
	hasRequiredParameterize = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function parameterize(strings, ...values) {
		  const formatted = new String(String.raw(strings, ...values));
		  formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
		  formatted.__sentry_template_values__ = values;
		  return formatted;
		}
		const fmt = parameterize;

		exports.fmt = fmt;
		exports.parameterize = parameterize;
		
	} (parameterize));
	return parameterize;
}

var tunnel = {};

var hasRequiredTunnel;

function requireTunnel () {
	if (hasRequiredTunnel) return tunnel;
	hasRequiredTunnel = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const api = /*@__PURE__*/ requireApi$1();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const dsn = /*@__PURE__*/ requireDsn();
		const envelope = /*@__PURE__*/ requireEnvelope$4();

		async function handleTunnelRequest(options) {
		  const { request, allowedDsns } = options;
		  if (allowedDsns.length === 0) {
		    return new Response("Tunnel not configured", { status: 500 });
		  }
		  const body = new Uint8Array(await request.arrayBuffer());
		  let envelopeHeader;
		  try {
		    [envelopeHeader] = envelope.parseEnvelope(body);
		  } catch {
		    return new Response("Invalid envelope", { status: 400 });
		  }
		  if (!envelopeHeader) {
		    return new Response("Invalid envelope: missing header", { status: 400 });
		  }
		  const dsn$1 = envelopeHeader.dsn;
		  if (!dsn$1) {
		    return new Response("Invalid envelope: missing DSN", { status: 400 });
		  }
		  const isAllowed = allowedDsns.some((allowed) => allowed === dsn$1);
		  if (!isAllowed) {
		    debugLogger.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
		    return new Response("DSN not allowed", { status: 403 });
		  }
		  const dsnComponents = dsn.makeDsn(dsn$1);
		  if (!dsnComponents) {
		    debugLogger.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
		    return new Response("Invalid DSN", { status: 403 });
		  }
		  const sentryIngestUrl = api.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
		  try {
		    return await fetch(sentryIngestUrl, {
		      method: "POST",
		      headers: {
		        "Content-Type": "application/x-sentry-envelope"
		      },
		      body
		    });
		  } catch (error) {
		    debugLogger.debug.error("Sentry tunnel: failed to forward envelope", error);
		    return new Response("Failed to forward envelope to Sentry", { status: 500 });
		  }
		}

		exports.handleTunnelRequest = handleTunnelRequest;
		
	} (tunnel));
	return tunnel;
}

var ipAddress = {};

var hasRequiredIpAddress;

function requireIpAddress () {
	if (hasRequiredIpAddress) return ipAddress;
	hasRequiredIpAddress = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function addAutoIpAddressToUser(objWithMaybeUser) {
		  if (objWithMaybeUser.user?.ip_address === void 0) {
		    objWithMaybeUser.user = {
		      ...objWithMaybeUser.user,
		      ip_address: "{{auto}}"
		    };
		  }
		}
		function addAutoIpAddressToSession(session) {
		  if ("aggregates" in session) {
		    if (session.attrs?.["ip_address"] === void 0) {
		      session.attrs = {
		        ...session.attrs,
		        ip_address: "{{auto}}"
		      };
		    }
		  } else {
		    if (session.ipAddress === void 0) {
		      session.ipAddress = "{{auto}}";
		    }
		  }
		}

		exports.addAutoIpAddressToSession = addAutoIpAddressToSession;
		exports.addAutoIpAddressToUser = addAutoIpAddressToUser;
		
	} (ipAddress));
	return ipAddress;
}

var sdkMetadata = {};

var hasRequiredSdkMetadata;

function requireSdkMetadata () {
	if (hasRequiredSdkMetadata) return sdkMetadata;
	hasRequiredSdkMetadata = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const version = /*@__PURE__*/ requireVersion();

		function applySdkMetadata(options, name, names = [name], source = "npm") {
		  const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
		  if (!sdk.name) {
		    sdk.name = `sentry.javascript.${name}`;
		    sdk.packages = names.map((name2) => ({
		      name: `${source}:@sentry/${name2}`,
		      version: version.SDK_VERSION
		    }));
		    sdk.version = version.SDK_VERSION;
		  }
		}

		exports.applySdkMetadata = applySdkMetadata;
		
	} (sdkMetadata));
	return sdkMetadata;
}

var traceData = {};

var hasRequiredTraceData;

function requireTraceData () {
	if (hasRequiredTraceData) return traceData;
	hasRequiredTraceData = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const index = /*@__PURE__*/ requireAsyncContext();
		const carrier = /*@__PURE__*/ requireCarrier();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const sentryNonRecordingSpan = /*@__PURE__*/ requireSentryNonRecordingSpan();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const baggage = /*@__PURE__*/ requireBaggage();
		const tracing = /*@__PURE__*/ requireTracing();

		function getTraceData(options = {}) {
		  const client = options.client || currentScopes.getClient();
		  if (!exports$1.isEnabled() || !client) {
		    return {};
		  }
		  const carrier$1 = carrier.getMainCarrier();
		  const acs = index.getAsyncContextStrategy(carrier$1);
		  if (acs.getTraceData) {
		    return acs.getTraceData(options);
		  }
		  const scope = options.scope || currentScopes.getCurrentScope();
		  const span = options.span || spanUtils.getActiveSpan();
		  const isTwpPlaceholder = sentryNonRecordingSpan.spanIsNonRecordingSpan(span) && !hasSpansEnabled.hasSpansEnabled(client.getOptions());
		  if (!span && currentScopes.hasExternalPropagationContext()) {
		    return {};
		  }
		  const sentryTrace = span && !isTwpPlaceholder ? spanUtils.spanToTraceHeader(span) : scopeToTraceHeader(scope);
		  const dsc = span ? dynamicSamplingContext.getDynamicSamplingContextFromSpan(span) : dynamicSamplingContext.getDynamicSamplingContextFromScope(client, scope);
		  const baggage$1 = baggage.dynamicSamplingContextToSentryBaggageHeader(dsc);
		  const isValidSentryTraceHeader = tracing.TRACEPARENT_REGEXP.test(sentryTrace);
		  if (!isValidSentryTraceHeader) {
		    debugLogger.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
		    return {};
		  }
		  const traceData = {
		    "sentry-trace": sentryTrace,
		    baggage: baggage$1
		  };
		  if (options.propagateTraceparent) {
		    traceData.traceparent = span && !isTwpPlaceholder ? spanUtils.spanToTraceparentHeader(span) : scopeToTraceparentHeader(scope);
		  }
		  return traceData;
		}
		function scopeToTraceHeader(scope) {
		  const { traceId, sampled, propagationSpanId } = scope.getPropagationContext();
		  return tracing.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
		}
		function scopeToTraceparentHeader(scope) {
		  const { traceId, sampled, propagationSpanId } = scope.getPropagationContext();
		  return tracing.generateTraceparentHeader(traceId, propagationSpanId, sampled);
		}

		exports.getTraceData = getTraceData;
		
	} (traceData));
	return traceData;
}

var tracePropagationTargets = {};

var hasRequiredTracePropagationTargets;

function requireTracePropagationTargets () {
	if (hasRequiredTracePropagationTargets) return tracePropagationTargets;
	hasRequiredTracePropagationTargets = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const string = /*@__PURE__*/ requireString();

		const NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
		function shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
		  if (typeof url !== "string" || !tracePropagationTargets) {
		    return true;
		  }
		  const cachedDecision = decisionMap?.get(url);
		  if (cachedDecision !== void 0) {
		    debugBuild.DEBUG_BUILD && !cachedDecision && debugLogger.debug.log(NOT_PROPAGATED_MESSAGE, url);
		    return cachedDecision;
		  }
		  const decision = string.stringMatchesSomePattern(url, tracePropagationTargets);
		  decisionMap?.set(url, decision);
		  debugBuild.DEBUG_BUILD && !decision && debugLogger.debug.log(NOT_PROPAGATED_MESSAGE, url);
		  return decision;
		}

		exports.shouldPropagateTraceForUrl = shouldPropagateTraceForUrl;
		
	} (tracePropagationTargets));
	return tracePropagationTargets;
}

var meta = {};

var hasRequiredMeta;

function requireMeta () {
	if (hasRequiredMeta) return meta;
	hasRequiredMeta = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const traceData = /*@__PURE__*/ requireTraceData();

		function getTraceMetaTags(traceData$1) {
		  return Object.entries(traceData$1 || traceData.getTraceData()).map(([key, value]) => `<meta name="${key}" content="${value}"/>`).join("\n");
		}

		exports.getTraceMetaTags = getTraceMetaTags;
		
	} (meta));
	return meta;
}

var debounce = {};

var hasRequiredDebounce;

function requireDebounce () {
	if (hasRequiredDebounce) return debounce;
	hasRequiredDebounce = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function debounce(func, wait, options) {
		  let callbackReturnValue;
		  let timerId;
		  let maxTimerId;
		  const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
		  const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
		  function invokeFunc() {
		    cancelTimers();
		    callbackReturnValue = func();
		    return callbackReturnValue;
		  }
		  function cancelTimers() {
		    timerId !== void 0 && clearTimeout(timerId);
		    maxTimerId !== void 0 && clearTimeout(maxTimerId);
		    timerId = maxTimerId = void 0;
		  }
		  function flush() {
		    if (timerId !== void 0 || maxTimerId !== void 0) {
		      return invokeFunc();
		    }
		    return callbackReturnValue;
		  }
		  function debounced() {
		    if (timerId) {
		      clearTimeout(timerId);
		    }
		    timerId = setTimeoutImpl(invokeFunc, wait);
		    if (maxWait && maxTimerId === void 0) {
		      maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
		    }
		    return callbackReturnValue;
		  }
		  debounced.cancel = cancelTimers;
		  debounced.flush = flush;
		  return debounced;
		}

		exports.debounce = debounce;
		
	} (debounce));
	return debounce;
}

var request$1 = {};

var hasRequiredRequest$1;

function requireRequest$1 () {
	if (hasRequiredRequest$1) return request$1;
	hasRequiredRequest$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const defaultPiiToCollectionOptions = /*@__PURE__*/ requireDefaultPiiToCollectionOptions();
		const filteringSnippets = /*@__PURE__*/ requireFilteringSnippets();
		const filterKeyValueData = /*@__PURE__*/ requireFilterKeyValueData();
		const timer = /*@__PURE__*/ requireTimer();

		const MAX_BODY_BYTE_LENGTH = 1024 * 1024;
		const TEXT_CONTENT_TYPES = [
		  "text/",
		  "application/json",
		  "application/x-www-form-urlencoded",
		  "application/xml",
		  "application/graphql"
		];
		function getMaxBodyByteLength(maxRequestBodySize) {
		  if (maxRequestBodySize === "small") return 1e3;
		  if (maxRequestBodySize === "medium") return 1e4;
		  return MAX_BODY_BYTE_LENGTH;
		}
		function winterCGHeadersToDict(winterCGHeaders) {
		  const headers = {};
		  try {
		    winterCGHeaders.forEach((value, key) => {
		      if (typeof value === "string") {
		        headers[key] = value;
		      }
		    });
		  } catch {
		  }
		  return headers;
		}
		function headersToDict(reqHeaders) {
		  const headers = /* @__PURE__ */ Object.create(null);
		  try {
		    Object.entries(reqHeaders).forEach(([key, value]) => {
		      if (typeof value === "string") {
		        headers[key] = value;
		      } else if (typeof value === "number") {
		        headers[key] = String(value);
		      }
		    });
		  } catch {
		  }
		  return headers;
		}
		function winterCGRequestToRequestData(req) {
		  const headers = winterCGHeadersToDict(req.headers);
		  return {
		    method: req.method,
		    url: req.url,
		    query_string: extractQueryParamsFromUrl(req.url),
		    headers
		    // TODO: Can we extract body data from the request?
		  };
		}
		function isTextualContentType(contentType) {
		  if (!contentType) {
		    return false;
		  }
		  const lowerContentType = contentType.toLowerCase();
		  return TEXT_CONTENT_TYPES.some((type) => lowerContentType.includes(type));
		}
		async function captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
		  try {
		    const contentType = request.headers.get("content-type");
		    if (!isTextualContentType(contentType)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log("Skipping body capture for non-textual content type:", contentType);
		      return;
		    }
		    if (!request.body) {
		      return;
		    }
		    const contentLength = request.headers.get("content-length");
		    const maxBodySize = getMaxBodyByteLength(maxRequestBodySize);
		    if (contentLength) {
		      const length = parseInt(contentLength, 10);
		      if (!isNaN(length) && length > MAX_BODY_BYTE_LENGTH) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.log("Skipping body capture: body too large", length);
		        return;
		      }
		    }
		    const clonedRequest = request.clone();
		    const bodyPromise = clonedRequest.text();
		    const timeoutPromise = new Promise((resolve) => {
		      timer.safeUnref(setTimeout(() => resolve(null), 2e3));
		    });
		    const body = await Promise.race([bodyPromise, timeoutPromise]);
		    if (body === null) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log("Timeout reading request body");
		      return;
		    }
		    if (!body) {
		      return;
		    }
		    const encoder = new TextEncoder();
		    const bytes = encoder.encode(body);
		    const bodyByteLength = bytes.length;
		    let truncatedBody;
		    if (bodyByteLength > maxBodySize) {
		      const decoder = new TextDecoder();
		      truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
		    } else {
		      truncatedBody = body;
		    }
		    isolationScope.setSDKProcessingMetadata({ normalizedRequest: { data: truncatedBody } });
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("Captured request body:", bodyByteLength, "bytes");
		  } catch (error) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error("Error capturing request body:", error);
		  }
		}
		function httpRequestToRequestData(request) {
		  const headers = request.headers || {};
		  const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
		  const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
		  const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
		  const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
		  const url = request.url || "";
		  const absoluteUrl = getAbsoluteUrl({
		    url,
		    host,
		    protocol
		  });
		  const data = request.body || void 0;
		  const cookies = request.cookies;
		  return {
		    url: absoluteUrl,
		    method: request.method,
		    query_string: extractQueryParamsFromUrl(url),
		    headers: headersToDict(headers),
		    cookies,
		    data
		  };
		}
		function getAbsoluteUrl({
		  url,
		  protocol,
		  host
		}) {
		  if (url?.startsWith("http")) {
		    return url;
		  }
		  if (url && host) {
		    return `${protocol}://${host}${url}`;
		  }
		  return void 0;
		}
		function httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
		  const resolvedDataCollection = typeof dataCollection === "boolean" ? defaultPiiToCollectionOptions.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
		  const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
		  const cookieBehavior = resolvedDataCollection.cookies;
		  const prefix = `http.${lifecycle}.header.`;
		  const spanAttributes = {};
		  try {
		    const regularHeaders = {};
		    for (const [key, value] of Object.entries(headers)) {
		      if (value == null) {
		        continue;
		      }
		      const lowerKey = key.toLowerCase();
		      const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
		      if (isCookieHeader) {
		        if (cookieBehavior === false) {
		          continue;
		        }
		        if (typeof value === "string" && value !== "") {
		          const parsed = parseCookieHeader(value, lowerKey === "set-cookie");
		          const filtered = filterKeyValueData.filterKeyValueData(parsed, cookieBehavior, filteringSnippets.SENSITIVE_COOKIE_NAME_SNIPPETS);
		          for (const [cookieKey, cookieValue] of Object.entries(filtered)) {
		            spanAttributes[`${prefix}${normalizeAttributeKey(lowerKey)}.${normalizeAttributeKey(cookieKey)}`] = cookieValue;
		          }
		        } else {
		          spanAttributes[`${prefix}${normalizeAttributeKey(lowerKey)}`] = filteringSnippets.FILTERED_VALUE;
		        }
		      } else {
		        if (headerBehavior === false) {
		          continue;
		        }
		        if (Array.isArray(value)) {
		          regularHeaders[lowerKey] = value.map((v) => v != null ? String(v) : v).join(";");
		        } else if (typeof value === "string") {
		          regularHeaders[lowerKey] = value;
		        }
		      }
		    }
		    if (headerBehavior !== false) {
		      const filtered = filterKeyValueData.filterKeyValueData(regularHeaders, headerBehavior);
		      for (const [headerKey, headerValue] of Object.entries(filtered)) {
		        spanAttributes[`${prefix}${normalizeAttributeKey(headerKey)}`] = headerValue;
		      }
		    }
		  } catch {
		  }
		  return spanAttributes;
		}
		function normalizeAttributeKey(key) {
		  return key.replace(/-/g, "_");
		}
		function parseCookieHeader(value, isSetCookie) {
		  const semicolonIndex = value.indexOf(";");
		  const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
		  const cookies = isSetCookie ? [cookieString] : cookieString.split("; ");
		  const result = {};
		  for (const cookie of cookies) {
		    const equalSignIndex = cookie.indexOf("=");
		    const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
		    const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
		    result[cookieKey] = cookieValue;
		  }
		  return result;
		}
		function extractQueryParamsFromUrl(url) {
		  if (!url) {
		    return;
		  }
		  try {
		    const queryParams = new URL(url, "http://s.io").search.slice(1);
		    return queryParams.length ? queryParams : void 0;
		  } catch {
		    return void 0;
		  }
		}

		exports.MAX_BODY_BYTE_LENGTH = MAX_BODY_BYTE_LENGTH;
		exports.captureBodyFromWinterCGRequest = captureBodyFromWinterCGRequest;
		exports.extractQueryParamsFromUrl = extractQueryParamsFromUrl;
		exports.getMaxBodyByteLength = getMaxBodyByteLength;
		exports.headersToDict = headersToDict;
		exports.httpHeadersToSpanAttributes = httpHeadersToSpanAttributes;
		exports.httpRequestToRequestData = httpRequestToRequestData;
		exports.winterCGHeadersToDict = winterCGHeadersToDict;
		exports.winterCGRequestToRequestData = winterCGRequestToRequestData;
		
	} (request$1));
	return request$1;
}

var breadcrumbs$1 = {};

var hasRequiredBreadcrumbs$1;

function requireBreadcrumbs$1 () {
	if (hasRequiredBreadcrumbs$1) return breadcrumbs$1;
	hasRequiredBreadcrumbs$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const time = /*@__PURE__*/ requireTime();

		const DEFAULT_BREADCRUMBS = 100;
		function addBreadcrumb(breadcrumb, hint) {
		  const client = currentScopes.getClient();
		  const isolationScope = currentScopes.getIsolationScope();
		  if (!client) return;
		  const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } = client.getOptions();
		  if (maxBreadcrumbs <= 0) return;
		  const timestamp = time.dateTimestampInSeconds();
		  const mergedBreadcrumb = { timestamp, ...breadcrumb };
		  const finalBreadcrumb = beforeBreadcrumb ? debugLogger.consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
		  if (finalBreadcrumb === null) return;
		  if (client.emit) {
		    client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
		  }
		  isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
		}

		exports.addBreadcrumb = addBreadcrumb;
		
	} (breadcrumbs$1));
	return breadcrumbs$1;
}

var functiontostring = {};

var hasRequiredFunctiontostring;

function requireFunctiontostring () {
	if (hasRequiredFunctiontostring) return functiontostring;
	hasRequiredFunctiontostring = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const object = /*@__PURE__*/ requireObject();

		let originalFunctionToString;
		const INTEGRATION_NAME = "FunctionToString";
		const SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
		const _functionToStringIntegration = (() => {
		  return {
		    name: INTEGRATION_NAME,
		    setupOnce() {
		      originalFunctionToString = Function.prototype.toString;
		      try {
		        Function.prototype.toString = function(...args) {
		          const originalFunction = object.getOriginalFunction(this);
		          const context = SETUP_CLIENTS.has(currentScopes.getClient()) && originalFunction !== void 0 ? originalFunction : this;
		          return originalFunctionToString.apply(context, args);
		        };
		      } catch {
		      }
		    },
		    setup(client) {
		      SETUP_CLIENTS.set(client, true);
		    }
		  };
		});
		const functionToStringIntegration = integration.defineIntegration(_functionToStringIntegration);

		exports.functionToStringIntegration = functionToStringIntegration;
		
	} (functiontostring));
	return functiontostring;
}

var eventFilters = {};

var hasRequiredEventFilters;

function requireEventFilters () {
	if (hasRequiredEventFilters) return eventFilters;
	hasRequiredEventFilters = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const eventUtils = /*@__PURE__*/ requireEventUtils();
		const misc = /*@__PURE__*/ requireMisc();
		const string = /*@__PURE__*/ requireString();

		const DEFAULT_IGNORE_ERRORS = [
		  /^Script error\.?$/,
		  /^Javascript error: Script error\.? on line 0$/,
		  /^ResizeObserver loop completed with undelivered notifications.$/,
		  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
		  /^Cannot redefine property: googletag$/,
		  // This is thrown when google tag manager is used in combination with an ad blocker
		  /^Can't find variable: gmo$/,
		  // Error from Google Search App https://issuetracker.google.com/issues/396043331
		  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
		  // Random error that happens but not actionable or noticeable to end-users.
		  /can't redefine non-configurable property "solana"/,
		  // Probably a browser extension or custom browser (Brave) throwing this error
		  /vv\(\)\.getRestrictions is not a function/,
		  // Error thrown by GTM, seemingly not affecting end-users
		  /Can't find variable: _AutofillCallbackHandler/,
		  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
		  /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
		  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
		  /^Java exception was raised during method invocation$/
		  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
		];
		const INTEGRATION_NAME = "EventFilters";
		const eventFiltersIntegration = integration.defineIntegration((options = {}) => {
		  let mergedOptions;
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      const clientOptions = client.getOptions();
		      mergedOptions = _mergeOptions(options, clientOptions);
		    },
		    processEvent(event, _hint, client) {
		      if (!mergedOptions) {
		        const clientOptions = client.getOptions();
		        mergedOptions = _mergeOptions(options, clientOptions);
		      }
		      return _shouldDropEvent(event, mergedOptions) ? null : event;
		    }
		  };
		});
		const inboundFiltersIntegration = integration.defineIntegration(((options = {}) => {
		  return {
		    ...eventFiltersIntegration(options),
		    name: "InboundFilters"
		  };
		}));
		function _mergeOptions(internalOptions = {}, clientOptions = {}) {
		  return {
		    allowUrls: [...internalOptions.allowUrls || [], ...clientOptions.allowUrls || []],
		    denyUrls: [...internalOptions.denyUrls || [], ...clientOptions.denyUrls || []],
		    ignoreErrors: [
		      ...internalOptions.ignoreErrors || [],
		      ...clientOptions.ignoreErrors || [],
		      ...internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS
		    ],
		    ignoreTransactions: [...internalOptions.ignoreTransactions || [], ...clientOptions.ignoreTransactions || []]
		  };
		}
		function _shouldDropEvent(event, options) {
		  if (!event.type) {
		    if (_isIgnoredError(event, options.ignoreErrors)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${misc.getEventDescription(event)}`
		      );
		      return true;
		    }
		    if (_isUselessError(event)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${misc.getEventDescription(
		          event
		        )}`
		      );
		      return true;
		    }
		    if (_isDeniedUrl(event, options.denyUrls)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${misc.getEventDescription(
		          event
		        )}.
Url: ${_getEventFilterUrl(event)}`
		      );
		      return true;
		    }
		    if (!_isAllowedUrl(event, options.allowUrls)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${misc.getEventDescription(
		          event
		        )}.
Url: ${_getEventFilterUrl(event)}`
		      );
		      return true;
		    }
		  } else if (event.type === "transaction") {
		    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${misc.getEventDescription(event)}`
		      );
		      return true;
		    }
		  }
		  return false;
		}
		function _isIgnoredError(event, ignoreErrors) {
		  if (!ignoreErrors?.length) {
		    return false;
		  }
		  return eventUtils.getPossibleEventMessages(event).some((message) => string.stringMatchesSomePattern(message, ignoreErrors));
		}
		function _isIgnoredTransaction(event, ignoreTransactions) {
		  if (!ignoreTransactions?.length) {
		    return false;
		  }
		  const name = event.transaction;
		  return name ? string.stringMatchesSomePattern(name, ignoreTransactions) : false;
		}
		function _isDeniedUrl(event, denyUrls) {
		  if (!denyUrls?.length) {
		    return false;
		  }
		  const url = _getEventFilterUrl(event);
		  return !url ? false : string.stringMatchesSomePattern(url, denyUrls);
		}
		function _isAllowedUrl(event, allowUrls) {
		  if (!allowUrls?.length) {
		    return true;
		  }
		  const url = _getEventFilterUrl(event);
		  return !url ? true : string.stringMatchesSomePattern(url, allowUrls);
		}
		function _getLastValidUrl(frames = []) {
		  for (let i = frames.length - 1; i >= 0; i--) {
		    const frame = frames[i];
		    if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") {
		      return frame.filename || null;
		    }
		  }
		  return null;
		}
		function _getEventFilterUrl(event) {
		  try {
		    const rootException = [...event.exception?.values ?? []].reverse().find((value) => value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
		    const frames = rootException?.stacktrace?.frames;
		    return frames ? _getLastValidUrl(frames) : null;
		  } catch {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error(`Cannot extract url for event ${misc.getEventDescription(event)}`);
		    return null;
		  }
		}
		function _isUselessError(event) {
		  if (!event.exception?.values?.length) {
		    return false;
		  }
		  return (
		    // No top-level message
		    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
		    !event.exception.values.some((value) => value.stacktrace || value.type && value.type !== "Error" || value.value)
		  );
		}

		exports.eventFiltersIntegration = eventFiltersIntegration;
		exports.inboundFiltersIntegration = inboundFiltersIntegration;
		
	} (eventFilters));
	return eventFilters;
}

var linkederrors$1 = {};

var aggregateErrors = {};

var hasRequiredAggregateErrors;

function requireAggregateErrors () {
	if (hasRequiredAggregateErrors) return aggregateErrors;
	hasRequiredAggregateErrors = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const is = /*@__PURE__*/ requireIs$1();

		function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
		  if (!event.exception?.values || !hint || !is.isInstanceOf(hint.originalException, Error)) {
		    return;
		  }
		  const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
		  if (originalException) {
		    event.exception.values = aggregateExceptionsFromError(
		      exceptionFromErrorImplementation,
		      parser,
		      limit,
		      hint.originalException,
		      key,
		      event.exception.values,
		      originalException,
		      0
		    );
		  }
		}
		function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
		  if (prevExceptions.length >= limit + 1) {
		    return prevExceptions;
		  }
		  let newExceptions = [...prevExceptions];
		  if (is.isInstanceOf(error[key], Error)) {
		    applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
		    const newException = exceptionFromErrorImplementation(parser, error[key]);
		    const newExceptionId = newExceptions.length;
		    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
		    newExceptions = aggregateExceptionsFromError(
		      exceptionFromErrorImplementation,
		      parser,
		      limit,
		      error[key],
		      key,
		      [newException, ...newExceptions],
		      newException,
		      newExceptionId
		    );
		  }
		  if (isExceptionGroup(error)) {
		    error.errors.forEach((childError, i) => {
		      if (is.isInstanceOf(childError, Error)) {
		        applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
		        const newException = exceptionFromErrorImplementation(parser, childError);
		        const newExceptionId = newExceptions.length;
		        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
		        newExceptions = aggregateExceptionsFromError(
		          exceptionFromErrorImplementation,
		          parser,
		          limit,
		          childError,
		          key,
		          [newException, ...newExceptions],
		          newException,
		          newExceptionId
		        );
		      }
		    });
		  }
		  return newExceptions;
		}
		function isExceptionGroup(error) {
		  return Array.isArray(error.errors);
		}
		function applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
		  exception.mechanism = {
		    handled: true,
		    type: "auto.core.linked_errors",
		    ...isExceptionGroup(error) && { is_exception_group: true },
		    ...exception.mechanism,
		    exception_id: exceptionId
		  };
		}
		function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
		  exception.mechanism = {
		    handled: true,
		    ...exception.mechanism,
		    type: "chained",
		    source,
		    exception_id: exceptionId,
		    parent_id: parentId
		  };
		}

		exports.applyAggregateErrorsToEvent = applyAggregateErrorsToEvent;
		
	} (aggregateErrors));
	return aggregateErrors;
}

var eventbuilder$1 = {};

var hasRequiredEventbuilder$1;

function requireEventbuilder$1 () {
	if (hasRequiredEventbuilder$1) return eventbuilder$1;
	hasRequiredEventbuilder$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const is = /*@__PURE__*/ requireIs$1();
		const misc = /*@__PURE__*/ requireMisc();
		const normalize = /*@__PURE__*/ requireNormalize();
		const object = /*@__PURE__*/ requireObject();

		function parseStackFrames(stackParser, error) {
		  return stackParser(error.stack || "", 1);
		}
		function hasSentryFetchUrlHost(error) {
		  return is.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
		}
		function _enhanceErrorWithSentryInfo(error) {
		  if (hasSentryFetchUrlHost(error)) {
		    return `${error.message} (${error.__sentry_fetch_url_host__})`;
		  }
		  return error.message;
		}
		function exceptionFromError(stackParser, error) {
		  const exception = {
		    type: error.name || error.constructor.name,
		    value: _enhanceErrorWithSentryInfo(error)
		  };
		  const frames = parseStackFrames(stackParser, error);
		  if (frames.length) {
		    exception.stacktrace = { frames };
		  }
		  return exception;
		}
		function getErrorPropertyFromObject(obj) {
		  for (const prop in obj) {
		    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
		      const value = obj[prop];
		      if (value instanceof Error) {
		        return value;
		      }
		    }
		  }
		  return void 0;
		}
		function getMessageForObject(exception) {
		  if ("name" in exception && typeof exception.name === "string") {
		    let message = `'${exception.name}' captured as exception`;
		    if ("message" in exception && typeof exception.message === "string") {
		      message += ` with message '${exception.message}'`;
		    }
		    return message;
		  } else if ("message" in exception && typeof exception.message === "string") {
		    return exception.message;
		  }
		  const keys = object.extractExceptionKeysForMessage(exception);
		  if (is.isErrorEvent(exception)) {
		    return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
		  }
		  const className = getObjectClassName(exception);
		  return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
		}
		function getObjectClassName(obj) {
		  try {
		    const prototype = Object.getPrototypeOf(obj);
		    return prototype ? prototype.constructor.name : void 0;
		  } catch {
		  }
		}
		function getException(client, mechanism, exception, hint) {
		  if (is.isError(exception)) {
		    return [exception, void 0];
		  }
		  mechanism.synthetic = true;
		  if (is.isPlainObject(exception)) {
		    const normalizeDepth = client?.getOptions().normalizeDepth;
		    const extras = { ["__serialized__"]: normalize.normalizeToSize(exception, normalizeDepth) };
		    const errorFromProp = getErrorPropertyFromObject(exception);
		    if (errorFromProp) {
		      return [errorFromProp, extras];
		    }
		    const message = getMessageForObject(exception);
		    const ex2 = hint?.syntheticException || new Error(message);
		    ex2.message = message;
		    return [ex2, extras];
		  }
		  const ex = hint?.syntheticException || new Error(exception);
		  ex.message = `${exception}`;
		  return [ex, void 0];
		}
		function eventFromUnknownInput(client, stackParser, exception, hint) {
		  const providedMechanism = hint?.data && hint.data.mechanism;
		  const mechanism = providedMechanism || {
		    handled: true,
		    type: "generic"
		  };
		  const [ex, extras] = getException(client, mechanism, exception, hint);
		  const event = {
		    exception: {
		      values: [exceptionFromError(stackParser, ex)]
		    }
		  };
		  if (extras) {
		    event.extra = extras;
		  }
		  misc.addExceptionTypeValue(event, void 0, void 0);
		  misc.addExceptionMechanism(event, mechanism);
		  return {
		    ...event,
		    event_id: hint?.event_id
		  };
		}
		function eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
		  const event = {
		    event_id: hint?.event_id,
		    level
		  };
		  if (attachStacktrace && hint?.syntheticException) {
		    const frames = parseStackFrames(stackParser, hint.syntheticException);
		    if (frames.length) {
		      event.exception = {
		        values: [
		          {
		            value: message,
		            stacktrace: { frames }
		          }
		        ]
		      };
		      misc.addExceptionMechanism(event, { synthetic: true });
		    }
		  }
		  if (is.isParameterizedString(message)) {
		    const { __sentry_template_string__, __sentry_template_values__ } = message;
		    event.logentry = {
		      message: __sentry_template_string__,
		      params: __sentry_template_values__
		    };
		    return event;
		  }
		  event.message = message;
		  return event;
		}

		exports._enhanceErrorWithSentryInfo = _enhanceErrorWithSentryInfo;
		exports.eventFromMessage = eventFromMessage;
		exports.eventFromUnknownInput = eventFromUnknownInput;
		exports.exceptionFromError = exceptionFromError;
		exports.parseStackFrames = parseStackFrames;
		
	} (eventbuilder$1));
	return eventbuilder$1;
}

var hasRequiredLinkederrors$1;

function requireLinkederrors$1 () {
	if (hasRequiredLinkederrors$1) return linkederrors$1;
	hasRequiredLinkederrors$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const integration = /*@__PURE__*/ requireIntegration$6();
		const aggregateErrors = /*@__PURE__*/ requireAggregateErrors();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder$1();

		const DEFAULT_KEY = "cause";
		const DEFAULT_LIMIT = 5;
		const INTEGRATION_NAME = "LinkedErrors";
		const _linkedErrorsIntegration = ((options = {}) => {
		  const limit = options.limit || DEFAULT_LIMIT;
		  const key = options.key || DEFAULT_KEY;
		  return {
		    name: INTEGRATION_NAME,
		    preprocessEvent(event, hint, client) {
		      const options2 = client.getOptions();
		      aggregateErrors.applyAggregateErrorsToEvent(eventbuilder.exceptionFromError, options2.stackParser, key, limit, event, hint);
		    }
		  };
		});
		const linkedErrorsIntegration = integration.defineIntegration(_linkedErrorsIntegration);

		exports.linkedErrorsIntegration = linkedErrorsIntegration;
		
	} (linkederrors$1));
	return linkederrors$1;
}

var moduleMetadata = {};

var metadata = {};

var hasRequiredMetadata;

function requireMetadata () {
	if (hasRequiredMetadata) return metadata;
	hasRequiredMetadata = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const worldwide = /*@__PURE__*/ requireWorldwide();

		const filenameMetadataMap = /* @__PURE__ */ new Map();
		const parsedStacks = /* @__PURE__ */ new Set();
		function getFilenameToMetadataMap(parser) {
		  if (!worldwide.GLOBAL_OBJ._sentryModuleMetadata) {
		    return {};
		  }
		  const filenameMap = {};
		  for (const stack of Object.keys(worldwide.GLOBAL_OBJ._sentryModuleMetadata)) {
		    const metadata = worldwide.GLOBAL_OBJ._sentryModuleMetadata[stack];
		    const frames = parser(stack);
		    for (const frame of frames.reverse()) {
		      if (frame.filename) {
		        filenameMap[frame.filename] = metadata;
		        break;
		      }
		    }
		  }
		  return filenameMap;
		}
		function ensureMetadataStacksAreParsed(parser) {
		  if (!worldwide.GLOBAL_OBJ._sentryModuleMetadata) {
		    return;
		  }
		  for (const stack of Object.keys(worldwide.GLOBAL_OBJ._sentryModuleMetadata)) {
		    const metadata = worldwide.GLOBAL_OBJ._sentryModuleMetadata[stack];
		    if (parsedStacks.has(stack)) {
		      continue;
		    }
		    parsedStacks.add(stack);
		    const frames = parser(stack);
		    for (const frame of frames.reverse()) {
		      if (frame.filename) {
		        filenameMetadataMap.set(frame.filename, metadata);
		        break;
		      }
		    }
		  }
		}
		function getMetadataForUrl(parser, filename) {
		  ensureMetadataStacksAreParsed(parser);
		  return filenameMetadataMap.get(filename);
		}
		function addMetadataToStackFrames(parser, event) {
		  event.exception?.values?.forEach((exception) => {
		    exception.stacktrace?.frames?.forEach((frame) => {
		      if (!frame.filename || frame.module_metadata) {
		        return;
		      }
		      const metadata = getMetadataForUrl(parser, frame.filename);
		      if (metadata) {
		        frame.module_metadata = metadata;
		      }
		    });
		  });
		}
		function stripMetadataFromStackFrames(event) {
		  event.exception?.values?.forEach((exception) => {
		    exception.stacktrace?.frames?.forEach((frame) => {
		      delete frame.module_metadata;
		    });
		  });
		}

		exports.addMetadataToStackFrames = addMetadataToStackFrames;
		exports.getFilenameToMetadataMap = getFilenameToMetadataMap;
		exports.getMetadataForUrl = getMetadataForUrl;
		exports.stripMetadataFromStackFrames = stripMetadataFromStackFrames;
		
	} (metadata));
	return metadata;
}

var hasRequiredModuleMetadata;

function requireModuleMetadata () {
	if (hasRequiredModuleMetadata) return moduleMetadata;
	hasRequiredModuleMetadata = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const integration = /*@__PURE__*/ requireIntegration$6();
		const metadata = /*@__PURE__*/ requireMetadata();
		const envelope = /*@__PURE__*/ requireEnvelope$4();

		const moduleMetadataIntegration = integration.defineIntegration(() => {
		  return {
		    name: "ModuleMetadata",
		    setup(client) {
		      client.on("beforeEnvelope", (envelope$1) => {
		        envelope.forEachEnvelopeItem(envelope$1, (item, type) => {
		          if (type === "event") {
		            const event = Array.isArray(item) ? item[1] : void 0;
		            if (event) {
		              metadata.stripMetadataFromStackFrames(event);
		              item[1] = event;
		            }
		          }
		        });
		      });
		      client.on("applyFrameMetadata", (event) => {
		        if (event.type) {
		          return;
		        }
		        const stackParser = client.getOptions().stackParser;
		        metadata.addMetadataToStackFrames(stackParser, event);
		      });
		    }
		  };
		});

		exports.moduleMetadataIntegration = moduleMetadataIntegration;
		
	} (moduleMetadata));
	return moduleMetadata;
}

var requestdata = {};

var getIpAddress = {};

var hasRequiredGetIpAddress;

function requireGetIpAddress () {
	if (hasRequiredGetIpAddress) return getIpAddress;
	hasRequiredGetIpAddress = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const ipHeaderNames = [
		  "X-Client-IP",
		  "X-Forwarded-For",
		  "Fly-Client-IP",
		  "CF-Connecting-IP",
		  "Fastly-Client-Ip",
		  "True-Client-Ip",
		  "X-Real-IP",
		  "X-Cluster-Client-IP",
		  "X-Forwarded",
		  "Forwarded-For",
		  "Forwarded",
		  "X-Vercel-Forwarded-For"
		];
		function getClientIPAddress(headers) {
		  const lowerCaseHeaders = {};
		  for (const key of Object.keys(headers)) {
		    lowerCaseHeaders[key.toLowerCase()] = headers[key];
		  }
		  const headerValues = ipHeaderNames.map((headerName) => {
		    const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
		    const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
		    if (headerName === "Forwarded") {
		      return parseForwardedHeader(value);
		    }
		    return value?.split(",").map((v) => v.trim());
		  });
		  const flattenedHeaderValues = headerValues.reduce((acc, val) => {
		    if (!val) {
		      return acc;
		    }
		    return acc.concat(val);
		  }, []);
		  const ipAddress = flattenedHeaderValues.find((ip) => ip !== null && isIP(ip));
		  return ipAddress || null;
		}
		function parseForwardedHeader(value) {
		  if (!value) {
		    return null;
		  }
		  for (const part of value.split(";")) {
		    if (part.startsWith("for=")) {
		      return part.slice(4);
		    }
		  }
		  return null;
		}
		function isIP(str) {
		  const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
		  return regex.test(str);
		}

		exports.getClientIPAddress = getClientIPAddress;
		exports.ipHeaderNames = ipHeaderNames;
		
	} (getIpAddress));
	return getIpAddress;
}

var hasRequiredRequestdata;

function requireRequestdata () {
	if (hasRequiredRequestdata) return requestdata;
	hasRequiredRequestdata = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const cookie = /*@__PURE__*/ requireCookie();
		const request = /*@__PURE__*/ requireRequest$1();
		const getIpAddress = /*@__PURE__*/ requireGetIpAddress();
		const captureSpan = /*@__PURE__*/ requireCaptureSpan();

		const INTEGRATION_NAME = "RequestData";
		const _requestDataIntegration = ((options = {}) => {
		  function resolveIncludeAndDataCollection(client) {
		    const dc = client.getDataCollectionOptions();
		    const dataCollection = {
		      ...dc,
		      ...options.include?.cookies === true && dc.cookies === false && { cookies: true },
		      ...options.include?.headers === true && dc.httpHeaders.request === false && {
		        httpHeaders: { ...dc.httpHeaders, request: true }
		      }
		    };
		    return {
		      dataCollection,
		      include: {
		        cookies: dataCollection.cookies !== false,
		        // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
		        data: true,
		        headers: dataCollection.httpHeaders.request !== false,
		        ip: dataCollection.userInfo,
		        query_string: dataCollection.queryParams !== false,
		        // No dataCollection equivalent — URL is always included
		        url: true,
		        ...options.include
		      }
		    };
		  }
		  return {
		    name: INTEGRATION_NAME,
		    processEvent(event, _hint, client) {
		      const { sdkProcessingMetadata = {} } = event;
		      const { normalizedRequest, ipAddress } = sdkProcessingMetadata;
		      const { include } = resolveIncludeAndDataCollection(client);
		      if (normalizedRequest) {
		        addNormalizedRequestDataToEvent(event, normalizedRequest, { ipAddress }, include);
		      }
		      return event;
		    },
		    processSegmentSpan(span, client) {
		      const { sdkProcessingMetadata = {} } = currentScopes.getIsolationScope().getScopeData();
		      const { normalizedRequest, ipAddress } = sdkProcessingMetadata;
		      if (!normalizedRequest) {
		        return;
		      }
		      const { include, dataCollection } = resolveIncludeAndDataCollection(client);
		      addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
		    }
		  };
		});
		const requestDataIntegration = integration.defineIntegration(_requestDataIntegration);
		function addNormalizedRequestDataToEvent(event, req, additionalData, include) {
		  event.request = {
		    ...event.request,
		    ...extractNormalizedRequestData(req, include)
		  };
		  if (include.ip) {
		    const ip = req.headers && getIpAddress.getClientIPAddress(req.headers) || additionalData.ipAddress;
		    if (ip) {
		      event.user = {
		        ...event.user,
		        ip_address: ip
		      };
		    }
		  }
		}
		function addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
		  const requestData = extractNormalizedRequestData(normalizedRequest, include);
		  const attributes = {};
		  if (requestData.url) {
		    attributes["url.full"] = requestData.url;
		  }
		  if (requestData.method) {
		    attributes["http.request.method"] = requestData.method;
		  }
		  if (requestData.query_string) {
		    attributes["url.query"] = normalizeQueryString(requestData.query_string);
		  }
		  captureSpan.safeSetSpanJSONAttributes(span, attributes);
		  if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
		    const cookieString = Object.entries(requestData.cookies).map(([name, value]) => `${name}=${value}`).join("; ");
		    const cookieAttributes = request.httpHeadersToSpanAttributes({ cookie: cookieString }, dataCollection, "request");
		    captureSpan.safeSetSpanJSONAttributes(span, cookieAttributes);
		  }
		  if (requestData.headers) {
		    const headerAttributes = request.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
		    captureSpan.safeSetSpanJSONAttributes(span, headerAttributes);
		  }
		  if (requestData.data != null) {
		    const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
		    if (serialized) {
		      captureSpan.safeSetSpanJSONAttributes(span, { "http.request.body.data": serialized });
		    }
		  }
		  if (include.ip) {
		    const ip = normalizedRequest.headers && getIpAddress.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
		    if (ip) {
		      captureSpan.safeSetSpanJSONAttributes(span, { [semanticAttributes.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip });
		    }
		  }
		}
		function extractNormalizedRequestData(normalizedRequest, include) {
		  const requestData = {};
		  const headers = { ...normalizedRequest.headers };
		  if (include.headers) {
		    requestData.headers = headers;
		    if (!include.cookies) {
		      delete headers.cookie;
		    }
		    if (!include.ip) {
		      const ipHeaderNamesLower = new Set(getIpAddress.ipHeaderNames.map((name) => name.toLowerCase()));
		      for (const key of Object.keys(headers)) {
		        if (ipHeaderNamesLower.has(key.toLowerCase())) {
		          delete headers[key];
		        }
		      }
		    }
		  }
		  requestData.method = normalizedRequest.method;
		  if (include.url) {
		    requestData.url = normalizedRequest.url;
		  }
		  if (include.cookies) {
		    const cookies = normalizedRequest.cookies || (headers?.cookie ? cookie.parseCookie(headers.cookie) : void 0);
		    requestData.cookies = cookies || {};
		  }
		  if (include.query_string) {
		    requestData.query_string = normalizedRequest.query_string;
		  }
		  if (include.data) {
		    requestData.data = normalizedRequest.data;
		  }
		  return requestData;
		}
		function normalizeQueryString(queryString) {
		  if (typeof queryString === "string") {
		    return queryString || void 0;
		  }
		  const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
		  const result = pairs.map(([key, value]) => `${key}=${value}`).join("&");
		  return result || void 0;
		}

		exports.requestDataIntegration = requestDataIntegration;
		
	} (requestdata));
	return requestdata;
}

var captureconsole = {};

var console$2 = {};

var hasRequiredConsole$1;

function requireConsole$1 () {
	if (hasRequiredConsole$1) return console$2;
	hasRequiredConsole$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const object = /*@__PURE__*/ requireObject();
		const string = /*@__PURE__*/ requireString();
		const worldwide = /*@__PURE__*/ requireWorldwide();
		const handlers = /*@__PURE__*/ requireHandlers$1();

		const _filter = /* @__PURE__ */ new Set([]);
		function addConsoleInstrumentationHandler(handler) {
		  const type = "console";
		  const removeHandler = handlers.addHandler(type, handler);
		  handlers.maybeInstrument(type, instrumentConsole);
		  return removeHandler;
		}
		function addConsoleInstrumentationFilter(filter) {
		  for (const f of filter) {
		    _filter.add(f);
		  }
		  return () => {
		    for (const f of filter) {
		      _filter.delete(f);
		    }
		  };
		}
		function instrumentConsole() {
		  if (!("console" in worldwide.GLOBAL_OBJ)) {
		    return;
		  }
		  debugLogger.CONSOLE_LEVELS.forEach(function(level) {
		    if (!(level in worldwide.GLOBAL_OBJ.console)) {
		      return;
		    }
		    object.fill(worldwide.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
		      debugLogger.originalConsoleMethods[level] = originalConsoleMethod;
		      return function(...args) {
		        const firstArg = args[0];
		        const log = debugLogger.originalConsoleMethods[level];
		        const isFiltered = _filter.size && typeof firstArg === "string" && string.stringMatchesSomePattern(firstArg, _filter);
		        if (!isFiltered) {
		          handlers.triggerHandlers("console", { args, level });
		        }
		        if (!isFiltered || debugBuild.DEBUG_BUILD && debugLogger.debug.isEnabled()) {
		          log?.apply(worldwide.GLOBAL_OBJ.console, args);
		        }
		      };
		    });
		  });
		}

		exports.addConsoleInstrumentationFilter = addConsoleInstrumentationFilter;
		exports.addConsoleInstrumentationHandler = addConsoleInstrumentationHandler;
		
	} (console$2));
	return console$2;
}

var severity = {};

var hasRequiredSeverity;

function requireSeverity () {
	if (hasRequiredSeverity) return severity;
	hasRequiredSeverity = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function severityLevelFromString(level) {
		  return level === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(level) ? level : "log";
		}

		exports.severityLevelFromString = severityLevelFromString;
		
	} (severity));
	return severity;
}

var hasRequiredCaptureconsole;

function requireCaptureconsole () {
	if (hasRequiredCaptureconsole) return captureconsole;
	hasRequiredCaptureconsole = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const console = /*@__PURE__*/ requireConsole$1();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const misc = /*@__PURE__*/ requireMisc();
		const severity = /*@__PURE__*/ requireSeverity();
		const string = /*@__PURE__*/ requireString();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const INTEGRATION_NAME = "CaptureConsole";
		const _captureConsoleIntegration = ((options = {}) => {
		  const levels = options.levels || debugLogger.CONSOLE_LEVELS;
		  const handled = options.handled ?? true;
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      if (!("console" in worldwide.GLOBAL_OBJ)) {
		        return;
		      }
		      console.addConsoleInstrumentationHandler(({ args, level }) => {
		        if (currentScopes.getClient() !== client || !levels.includes(level)) {
		          return;
		        }
		        consoleHandler(args, level, handled);
		      });
		    }
		  };
		});
		const captureConsoleIntegration = integration.defineIntegration(_captureConsoleIntegration);
		function consoleHandler(args, level, handled) {
		  const severityLevel = severity.severityLevelFromString(level);
		  const syntheticException = new Error();
		  const captureContext = {
		    level: severity.severityLevelFromString(level),
		    extra: {
		      arguments: args
		    }
		  };
		  currentScopes.withScope((scope) => {
		    scope.addEventProcessor((event) => {
		      event.logger = "console";
		      misc.addExceptionMechanism(event, {
		        handled,
		        type: "auto.core.capture_console"
		      });
		      return event;
		    });
		    if (level === "assert") {
		      if (!args[0]) {
		        const message2 = `Assertion failed: ${string.safeJoin(args.slice(1), " ") || "console.assert"}`;
		        scope.setExtra("arguments", args.slice(1));
		        scope.captureMessage(message2, severityLevel, { captureContext, syntheticException });
		      }
		      return;
		    }
		    const error = args.find((arg) => arg instanceof Error);
		    if (error) {
		      exports$1.captureException(error, captureContext);
		      return;
		    }
		    const message = string.safeJoin(args, " ");
		    scope.captureMessage(message, severityLevel, { captureContext, syntheticException });
		  });
		}

		exports.captureConsoleIntegration = captureConsoleIntegration;
		
	} (captureconsole));
	return captureconsole;
}

var dedupe = {};

var hasRequiredDedupe;

function requireDedupe () {
	if (hasRequiredDedupe) return dedupe;
	hasRequiredDedupe = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const stacktrace = /*@__PURE__*/ requireStacktrace();

		const INTEGRATION_NAME = "Dedupe";
		const _dedupeIntegration = (() => {
		  let previousEvent;
		  return {
		    name: INTEGRATION_NAME,
		    processEvent(currentEvent) {
		      if (currentEvent.type) {
		        return currentEvent;
		      }
		      try {
		        if (_shouldDropEvent(currentEvent, previousEvent)) {
		          debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Event dropped due to being a duplicate of previously captured event.");
		          return null;
		        }
		      } catch {
		      }
		      return previousEvent = currentEvent;
		    }
		  };
		});
		const dedupeIntegration = integration.defineIntegration(_dedupeIntegration);
		function _shouldDropEvent(currentEvent, previousEvent) {
		  if (!previousEvent) {
		    return false;
		  }
		  if (_isSameMessageEvent(currentEvent, previousEvent)) {
		    return true;
		  }
		  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
		    return true;
		  }
		  return false;
		}
		function _isSameMessageEvent(currentEvent, previousEvent) {
		  const currentMessage = currentEvent.message;
		  const previousMessage = previousEvent.message;
		  if (!currentMessage && !previousMessage) {
		    return false;
		  }
		  if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
		    return false;
		  }
		  if (currentMessage !== previousMessage) {
		    return false;
		  }
		  if (!_isSameFingerprint(currentEvent, previousEvent)) {
		    return false;
		  }
		  if (!_isSameStacktrace(currentEvent, previousEvent)) {
		    return false;
		  }
		  return true;
		}
		function _isSameExceptionEvent(currentEvent, previousEvent) {
		  const previousException = _getExceptionFromEvent(previousEvent);
		  const currentException = _getExceptionFromEvent(currentEvent);
		  if (!previousException || !currentException) {
		    return false;
		  }
		  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
		    return false;
		  }
		  if (!_isSameFingerprint(currentEvent, previousEvent)) {
		    return false;
		  }
		  if (!_isSameStacktrace(currentEvent, previousEvent)) {
		    return false;
		  }
		  return true;
		}
		function _isSameStacktrace(currentEvent, previousEvent) {
		  let currentFrames = stacktrace.getFramesFromEvent(currentEvent);
		  let previousFrames = stacktrace.getFramesFromEvent(previousEvent);
		  if (!currentFrames && !previousFrames) {
		    return true;
		  }
		  if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
		    return false;
		  }
		  currentFrames = currentFrames;
		  previousFrames = previousFrames;
		  if (previousFrames.length !== currentFrames.length) {
		    return false;
		  }
		  for (let i = 0; i < previousFrames.length; i++) {
		    const frameA = previousFrames[i];
		    const frameB = currentFrames[i];
		    if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
		      return false;
		    }
		  }
		  return true;
		}
		function _isSameFingerprint(currentEvent, previousEvent) {
		  let currentFingerprint = currentEvent.fingerprint;
		  let previousFingerprint = previousEvent.fingerprint;
		  if (!currentFingerprint && !previousFingerprint) {
		    return true;
		  }
		  if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
		    return false;
		  }
		  currentFingerprint = currentFingerprint;
		  previousFingerprint = previousFingerprint;
		  try {
		    return !!(currentFingerprint.join("") === previousFingerprint.join(""));
		  } catch {
		    return false;
		  }
		}
		function _getExceptionFromEvent(event) {
		  return event.exception?.values?.[0];
		}

		exports._shouldDropEvent = _shouldDropEvent;
		exports.dedupeIntegration = dedupeIntegration;
		
	} (dedupe));
	return dedupe;
}

var extraerrordata = {};

var hasRequiredExtraerrordata;

function requireExtraerrordata () {
	if (hasRequiredExtraerrordata) return extraerrordata;
	hasRequiredExtraerrordata = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();
		const normalize = /*@__PURE__*/ requireNormalize();
		const normalizationHints = /*@__PURE__*/ requireNormalizationHints();
		const string = /*@__PURE__*/ requireString();

		const INTEGRATION_NAME = "ExtraErrorData";
		const _extraErrorDataIntegration = ((options = {}) => {
		  const { depth = 3, captureErrorCause = true } = options;
		  return {
		    name: INTEGRATION_NAME,
		    processEvent(event, hint, client) {
		      const { maxValueLength } = client.getOptions();
		      return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
		    }
		  };
		});
		const extraErrorDataIntegration = integration.defineIntegration(_extraErrorDataIntegration);
		function _enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
		  if (!hint.originalException || !is.isError(hint.originalException)) {
		    return event;
		  }
		  const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
		  const errorData = _extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
		  if (errorData) {
		    const contexts = {
		      ...event.contexts
		    };
		    const normalizedErrorData = normalize.normalize(errorData, depth);
		    if (is.isPlainObject(normalizedErrorData)) {
		      normalizationHints.setSkipNormalizationHint(normalizedErrorData);
		      contexts[exceptionName] = normalizedErrorData;
		    }
		    return {
		      ...event,
		      contexts
		    };
		  }
		  return event;
		}
		function _extractErrorData(error, captureErrorCause, maxValueLength) {
		  try {
		    const nativeKeys = [
		      "name",
		      "message",
		      "stack",
		      "line",
		      "column",
		      "fileName",
		      "lineNumber",
		      "columnNumber",
		      "toJSON"
		    ];
		    const extraErrorInfo = {};
		    for (const key of Object.keys(error)) {
		      if (nativeKeys.indexOf(key) !== -1) {
		        continue;
		      }
		      const value = error[key];
		      extraErrorInfo[key] = is.isError(value) || typeof value === "string" ? maxValueLength ? string.truncate(`${value}`, maxValueLength) : `${value}` : value;
		    }
		    if (captureErrorCause && error.cause !== void 0) {
		      if (is.isError(error.cause)) {
		        const errorName = error.cause.name || error.cause.constructor.name;
		        extraErrorInfo.cause = { [errorName]: _extractErrorData(error.cause, false, maxValueLength) };
		      } else {
		        extraErrorInfo.cause = error.cause;
		      }
		    }
		    if (typeof error.toJSON === "function") {
		      const serializedError = error.toJSON();
		      for (const key of Object.keys(serializedError)) {
		        const value = serializedError[key];
		        extraErrorInfo[key] = is.isError(value) ? value.toString() : value;
		      }
		    }
		    return extraErrorInfo;
		  } catch (oO) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error("Unable to extract extra data from the Error object:", oO);
		  }
		  return null;
		}

		exports.extraErrorDataIntegration = extraErrorDataIntegration;
		
	} (extraerrordata));
	return extraerrordata;
}

var rewriteframes = {};

var path = {};

var hasRequiredPath;

function requirePath () {
	if (hasRequiredPath) return path;
	hasRequiredPath = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function normalizeArray(parts, allowAboveRoot) {
		  let up = 0;
		  for (let i = parts.length - 1; i >= 0; i--) {
		    const last = parts[i];
		    if (last === ".") {
		      parts.splice(i, 1);
		    } else if (last === "..") {
		      parts.splice(i, 1);
		      up++;
		    } else if (up) {
		      parts.splice(i, 1);
		      up--;
		    }
		  }
		  if (allowAboveRoot) {
		    for (; up--; up) {
		      parts.unshift("..");
		    }
		  }
		  return parts;
		}
		const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
		function splitPath(filename) {
		  const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
		  const parts = splitPathRe.exec(truncated);
		  return parts ? parts.slice(1) : [];
		}
		function resolve(...args) {
		  let resolvedPath = "";
		  let resolvedAbsolute = false;
		  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
		    const path = i >= 0 ? args[i] : "/";
		    if (!path) {
		      continue;
		    }
		    resolvedPath = `${path}/${resolvedPath}`;
		    resolvedAbsolute = path.charAt(0) === "/";
		  }
		  resolvedPath = normalizeArray(
		    resolvedPath.split("/").filter((p) => !!p),
		    !resolvedAbsolute
		  ).join("/");
		  return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
		}
		function trim(arr) {
		  let start = 0;
		  for (; start < arr.length; start++) {
		    if (arr[start] !== "") {
		      break;
		    }
		  }
		  let end = arr.length - 1;
		  for (; end >= 0; end--) {
		    if (arr[end] !== "") {
		      break;
		    }
		  }
		  if (start > end) {
		    return [];
		  }
		  return arr.slice(start, end - start + 1);
		}
		function relative(from, to) {
		  from = resolve(from).slice(1);
		  to = resolve(to).slice(1);
		  const fromParts = trim(from.split("/"));
		  const toParts = trim(to.split("/"));
		  const length = Math.min(fromParts.length, toParts.length);
		  let samePartsLength = length;
		  for (let i = 0; i < length; i++) {
		    if (fromParts[i] !== toParts[i]) {
		      samePartsLength = i;
		      break;
		    }
		  }
		  let outputParts = [];
		  for (let i = samePartsLength; i < fromParts.length; i++) {
		    outputParts.push("..");
		  }
		  outputParts = outputParts.concat(toParts.slice(samePartsLength));
		  return outputParts.join("/");
		}
		function normalizePath(path) {
		  const isPathAbsolute = isAbsolute(path);
		  const trailingSlash = path.slice(-1) === "/";
		  let normalizedPath = normalizeArray(
		    path.split("/").filter((p) => !!p),
		    !isPathAbsolute
		  ).join("/");
		  if (!normalizedPath && !isPathAbsolute) {
		    normalizedPath = ".";
		  }
		  if (normalizedPath && trailingSlash) {
		    normalizedPath += "/";
		  }
		  return (isPathAbsolute ? "/" : "") + normalizedPath;
		}
		function isAbsolute(path) {
		  return path.charAt(0) === "/";
		}
		function join(...args) {
		  return normalizePath(args.join("/"));
		}
		function dirname(path) {
		  const result = splitPath(path);
		  const root = result[0] || "";
		  let dir = result[1];
		  if (!root && !dir) {
		    return ".";
		  }
		  if (dir) {
		    dir = dir.slice(0, dir.length - 1);
		  }
		  return root + dir;
		}
		function basename(path, ext) {
		  let f = splitPath(path)[2] || "";
		  if (ext && f.slice(ext.length * -1) === ext) {
		    f = f.slice(0, f.length - ext.length);
		  }
		  return f;
		}

		exports.basename = basename;
		exports.dirname = dirname;
		exports.isAbsolute = isAbsolute;
		exports.join = join;
		exports.normalizePath = normalizePath;
		exports.relative = relative;
		exports.resolve = resolve;
		
	} (path));
	return path;
}

var hasRequiredRewriteframes;

function requireRewriteframes () {
	if (hasRequiredRewriteframes) return rewriteframes;
	hasRequiredRewriteframes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const integration = /*@__PURE__*/ requireIntegration$6();
		const path = /*@__PURE__*/ requirePath();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const INTEGRATION_NAME = "RewriteFrames";
		const rewriteFramesIntegration = integration.defineIntegration((options = {}) => {
		  const root = options.root;
		  const prefix = options.prefix || "app:///";
		  const isBrowser = "window" in worldwide.GLOBAL_OBJ && !!worldwide.GLOBAL_OBJ.window;
		  const iteratee = options.iteratee || generateIteratee({ isBrowser, root, prefix });
		  function _processExceptionsEvent(event) {
		    try {
		      return {
		        ...event,
		        exception: {
		          ...event.exception,
		          // The check for this is performed inside `process` call itself, safe to skip here
		          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		          values: event.exception.values.map((value) => ({
		            ...value,
		            ...value.stacktrace && { stacktrace: _processStacktrace(value.stacktrace) }
		          }))
		        }
		      };
		    } catch {
		      return event;
		    }
		  }
		  function _processStacktrace(stacktrace) {
		    return {
		      ...stacktrace,
		      frames: stacktrace?.frames?.map((f) => iteratee(f))
		    };
		  }
		  return {
		    name: INTEGRATION_NAME,
		    processEvent(originalEvent) {
		      let processedEvent = originalEvent;
		      if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
		        processedEvent = _processExceptionsEvent(processedEvent);
		      }
		      return processedEvent;
		    }
		  };
		});
		function generateIteratee({
		  isBrowser,
		  root,
		  prefix
		}) {
		  return (frame) => {
		    if (!frame.filename) {
		      return frame;
		    }
		    const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
		    frame.filename.includes("\\") && !frame.filename.includes("/");
		    const startsWithSlash = /^\//.test(frame.filename);
		    if (isBrowser) {
		      if (root) {
		        const oldFilename = frame.filename;
		        if (oldFilename.indexOf(root) === 0) {
		          frame.filename = oldFilename.replace(root, prefix);
		        }
		      }
		    } else {
		      if (isWindowsFrame || startsWithSlash) {
		        const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
		        const base = root ? path.relative(root, filename) : path.basename(filename);
		        frame.filename = `${prefix}${base}`;
		      }
		    }
		    return frame;
		  };
		}

		exports.generateIteratee = generateIteratee;
		exports.rewriteFramesIntegration = rewriteFramesIntegration;
		
	} (rewriteframes));
	return rewriteframes;
}

var supabase = {};

var hasRequiredSupabase;

function requireSupabase () {
	if (hasRequiredSupabase) return supabase;
	hasRequiredSupabase = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const breadcrumbs = /*@__PURE__*/ requireBreadcrumbs$1();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const misc = /*@__PURE__*/ requireMisc();
		const is = /*@__PURE__*/ requireIs$1();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();

		const AUTH_OPERATIONS_TO_INSTRUMENT = [
		  "reauthenticate",
		  "signInAnonymously",
		  "signInWithOAuth",
		  "signInWithIdToken",
		  "signInWithOtp",
		  "signInWithPassword",
		  "signInWithSSO",
		  "signOut",
		  "signUp",
		  "verifyOtp"
		];
		const AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
		  "createUser",
		  "deleteUser",
		  "listUsers",
		  "getUserById",
		  "updateUserById",
		  "inviteUserByEmail"
		];
		const FILTER_MAPPINGS = {
		  eq: "eq",
		  neq: "neq",
		  gt: "gt",
		  gte: "gte",
		  lt: "lt",
		  lte: "lte",
		  like: "like",
		  "like(all)": "likeAllOf",
		  "like(any)": "likeAnyOf",
		  ilike: "ilike",
		  "ilike(all)": "ilikeAllOf",
		  "ilike(any)": "ilikeAnyOf",
		  is: "is",
		  in: "in",
		  cs: "contains",
		  cd: "containedBy",
		  sr: "rangeGt",
		  nxl: "rangeGte",
		  sl: "rangeLt",
		  nxr: "rangeLte",
		  adj: "rangeAdjacent",
		  ov: "overlaps",
		  fts: "",
		  plfts: "plain",
		  phfts: "phrase",
		  wfts: "websearch",
		  not: "not"
		};
		const DB_OPERATIONS_TO_INSTRUMENT = ["select", "insert", "upsert", "update", "delete"];
		function markAsInstrumented(fn) {
		  try {
		    fn.__SENTRY_INSTRUMENTED__ = true;
		  } catch {
		  }
		}
		function isInstrumented(fn) {
		  try {
		    return fn.__SENTRY_INSTRUMENTED__;
		  } catch {
		    return false;
		  }
		}
		function getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
		  if (Object.keys(plainBody).length > 0) {
		    return plainBody;
		  }
		  if (Array.isArray(rawBody) && rawBody.length > 0) {
		    return rawBody;
		  }
		  return void 0;
		}
		function hasMutationBodyForDescription(rawBody, plainBody) {
		  return getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
		}
		function extractOperation(method, headers = {}) {
		  switch (method) {
		    case "GET": {
		      return "select";
		    }
		    case "POST": {
		      if (headers["Prefer"]?.includes("resolution=")) {
		        return "upsert";
		      } else {
		        return "insert";
		      }
		    }
		    case "PATCH": {
		      return "update";
		    }
		    case "DELETE": {
		      return "delete";
		    }
		    default: {
		      return "<unknown-op>";
		    }
		  }
		}
		function translateFiltersIntoMethods(key, query) {
		  if (query === "" || query === "*") {
		    return "select(*)";
		  }
		  if (key === "select") {
		    return `select(${query})`;
		  }
		  if (key === "or" || key.endsWith(".or")) {
		    return `${key}${query}`;
		  }
		  const [filter, ...value] = query.split(".");
		  let method;
		  if (filter?.startsWith("fts")) {
		    method = "textSearch";
		  } else if (filter?.startsWith("plfts")) {
		    method = "textSearch[plain]";
		  } else if (filter?.startsWith("phfts")) {
		    method = "textSearch[phrase]";
		  } else if (filter?.startsWith("wfts")) {
		    method = "textSearch[websearch]";
		  } else {
		    method = filter && FILTER_MAPPINGS[filter] || "filter";
		  }
		  return `${method}(${key}, ${value.join(".")})`;
		}
		function instrumentAuthOperation(operation, isAdmin = false) {
		  return new Proxy(operation, {
		    apply(target, thisArg, argumentsList) {
		      return trace.startSpan(
		        {
		          name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
		          attributes: {
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
		            "db.system": "postgresql",
		            "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
		          }
		        },
		        (span) => {
		          return Reflect.apply(target, thisArg, argumentsList).then((res) => {
		            if (res && typeof res === "object" && "error" in res && res.error) {
		              span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR });
		              exports$1.captureException(res.error, {
		                mechanism: {
		                  handled: false,
		                  type: "auto.db.supabase.auth"
		                }
		              });
		            } else {
		              span.setStatus({ code: spanstatus.SPAN_STATUS_OK });
		            }
		            span.end();
		            return res;
		          }).catch((err) => {
		            span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR });
		            span.end();
		            exports$1.captureException(err, {
		              mechanism: {
		                handled: false,
		                type: "auto.db.supabase.auth"
		              }
		            });
		            throw err;
		          }).then(...argumentsList);
		        }
		      );
		    }
		  });
		}
		function instrumentSupabaseAuthClient(supabaseClientInstance) {
		  const auth = supabaseClientInstance.auth;
		  if (!auth || isInstrumented(supabaseClientInstance.auth)) {
		    return;
		  }
		  for (const operation of AUTH_OPERATIONS_TO_INSTRUMENT) {
		    const authOperation = auth[operation];
		    if (!authOperation) {
		      continue;
		    }
		    if (typeof supabaseClientInstance.auth[operation] === "function") {
		      supabaseClientInstance.auth[operation] = instrumentAuthOperation(authOperation);
		    }
		  }
		  for (const operation of AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT) {
		    const authOperation = auth.admin[operation];
		    if (!authOperation) {
		      continue;
		    }
		    if (typeof supabaseClientInstance.auth.admin[operation] === "function") {
		      supabaseClientInstance.auth.admin[operation] = instrumentAuthOperation(authOperation, true);
		    }
		  }
		  markAsInstrumented(supabaseClientInstance.auth);
		}
		function instrumentSupabaseClientConstructor(SupabaseClient, _options) {
		  if (isInstrumented(SupabaseClient.prototype.from)) {
		    return;
		  }
		  SupabaseClient.prototype.from = new Proxy(
		    SupabaseClient.prototype.from,
		    {
		      apply(target, thisArg, argumentsList) {
		        const rv = Reflect.apply(target, thisArg, argumentsList);
		        const PostgRESTQueryBuilder = rv.constructor;
		        instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
		        return rv;
		      }
		    }
		  );
		  markAsInstrumented(SupabaseClient.prototype.from);
		}
		function instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
		  if (isInstrumented(PostgRESTFilterBuilder.prototype.then)) {
		    return;
		  }
		  PostgRESTFilterBuilder.prototype.then = new Proxy(
		    PostgRESTFilterBuilder.prototype.then,
		    {
		      apply(target, thisArg, argumentsList) {
		        const operations = DB_OPERATIONS_TO_INSTRUMENT;
		        const typedThis = thisArg;
		        const operation = extractOperation(typedThis.method, typedThis.headers);
		        if (!operations.includes(operation)) {
		          return Reflect.apply(target, thisArg, argumentsList);
		        }
		        if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") {
		          return Reflect.apply(target, thisArg, argumentsList);
		        }
		        const pathParts = typedThis.url.pathname.split("/");
		        const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
		        const queryItems = [];
		        for (const [key, value] of typedThis.url.searchParams.entries()) {
		          queryItems.push(translateFiltersIntoMethods(key, value));
		        }
		        const body = /* @__PURE__ */ Object.create(null);
		        if (is.isPlainObject(typedThis.body)) {
		          for (const [key, value] of Object.entries(typedThis.body)) {
		            body[key] = value;
		          }
		        }
		        const client = currentScopes.getClient();
		        const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().userInfo === true;
		        const bodyPayload = getMutationBodyPayloadForTelemetry(typedThis.body, body);
		        const mutationPart = operation === "select" ? "" : `${operation}${hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
		        const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
		        const descriptionMiddle = [mutationPart.trimEnd(), queryPart].filter(Boolean).join(" ");
		        const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
		        const attributes = {
		          "db.table": table,
		          "db.schema": typedThis.schema,
		          "db.url": typedThis.url.origin,
		          "db.sdk": typedThis.headers["X-Client-Info"],
		          "db.system": "postgresql",
		          "db.operation": operation,
		          [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
		          [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
		        };
		        if (queryItems.length && shouldSendData) {
		          attributes["db.query"] = queryItems;
		        }
		        if (bodyPayload !== void 0 && shouldSendData) {
		          attributes["db.body"] = bodyPayload;
		        }
		        return trace.startSpan(
		          {
		            name: description,
		            attributes
		          },
		          (span) => {
		            return Reflect.apply(target, thisArg, []).then(
		              (res) => {
		                if (span) {
		                  if (res && typeof res === "object" && "status" in res) {
		                    spanstatus.setHttpStatus(span, res.status || 500);
		                  }
		                  span.end();
		                }
		                if (res?.error) {
		                  const err = new Error(res.error.message);
		                  if (res.error.code) {
		                    err.code = res.error.code;
		                  }
		                  if (res.error.details) {
		                    err.details = res.error.details;
		                  }
		                  const supabaseContext = {};
		                  if (queryItems.length && shouldSendData) {
		                    supabaseContext.query = queryItems;
		                  }
		                  if (bodyPayload !== void 0 && shouldSendData) {
		                    supabaseContext.body = bodyPayload;
		                  }
		                  exports$1.captureException(err, (scope) => {
		                    scope.addEventProcessor((e) => {
		                      misc.addExceptionMechanism(e, {
		                        handled: false,
		                        type: "auto.db.supabase.postgres"
		                      });
		                      return e;
		                    });
		                    scope.setContext("supabase", supabaseContext);
		                    return scope;
		                  });
		                }
		                const breadcrumb = {
		                  type: "supabase",
		                  category: `db.${operation}`,
		                  message: description
		                };
		                const data = {};
		                if (queryItems.length && shouldSendData) {
		                  data.query = queryItems;
		                }
		                if (bodyPayload !== void 0 && shouldSendData) {
		                  data.body = bodyPayload;
		                }
		                if (Object.keys(data).length) {
		                  breadcrumb.data = data;
		                }
		                breadcrumbs.addBreadcrumb(breadcrumb);
		                return res;
		              },
		              (err) => {
		                if (span) {
		                  spanstatus.setHttpStatus(span, 500);
		                  span.end();
		                }
		                throw err;
		              }
		            ).then(...argumentsList);
		          }
		        );
		      }
		    }
		  );
		  markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
		}
		function instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
		  for (const operation of DB_OPERATIONS_TO_INSTRUMENT) {
		    if (isInstrumented(PostgRESTQueryBuilder.prototype[operation])) {
		      continue;
		    }
		    PostgRESTQueryBuilder.prototype[operation] = new Proxy(
		      PostgRESTQueryBuilder.prototype[operation],
		      {
		        apply(target, thisArg, argumentsList) {
		          const rv = Reflect.apply(target, thisArg, argumentsList);
		          const PostgRESTFilterBuilder = rv.constructor;
		          debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
		          instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
		          return rv;
		        }
		      }
		    );
		    markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
		  }
		}
		const instrumentSupabaseClient = (supabaseClient, options = {}) => {
		  if (!supabaseClient) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
		    return;
		  }
		  const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
		  instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
		  instrumentSupabaseAuthClient(supabaseClient);
		};
		const INTEGRATION_NAME = "Supabase";
		const _supabaseIntegration = ((supabaseClient, options) => {
		  return {
		    setupOnce() {
		      instrumentSupabaseClient(supabaseClient, options);
		    },
		    name: INTEGRATION_NAME
		  };
		});
		const supabaseIntegration = integration.defineIntegration((options) => {
		  return _supabaseIntegration(options.supabaseClient, { sendOperationData: options.sendOperationData });
		});

		exports.DB_OPERATIONS_TO_INSTRUMENT = DB_OPERATIONS_TO_INSTRUMENT;
		exports.FILTER_MAPPINGS = FILTER_MAPPINGS;
		exports.extractOperation = extractOperation;
		exports.instrumentSupabaseClient = instrumentSupabaseClient;
		exports.supabaseIntegration = supabaseIntegration;
		exports.translateFiltersIntoMethods = translateFiltersIntoMethods;
		
	} (supabase));
	return supabase;
}

var zoderrors = {};

var hasRequiredZoderrors;

function requireZoderrors () {
	if (hasRequiredZoderrors) return zoderrors;
	hasRequiredZoderrors = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const integration = /*@__PURE__*/ requireIntegration$6();
		const is = /*@__PURE__*/ requireIs$1();
		const string = /*@__PURE__*/ requireString();

		const DEFAULT_LIMIT = 10;
		const INTEGRATION_NAME = "ZodErrors";
		function originalExceptionIsZodError(originalException) {
		  return is.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
		}
		function flattenIssue(issue) {
		  return {
		    ...issue,
		    path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
		    keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
		    unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
		  };
		}
		function flattenIssuePath(path) {
		  return path.map((p) => {
		    if (typeof p === "number") {
		      return "<array>";
		    } else {
		      return p;
		    }
		  }).join(".");
		}
		function formatIssueMessage(zodError) {
		  const errorKeyMap = /* @__PURE__ */ new Set();
		  for (const iss of zodError.issues) {
		    const issuePath = flattenIssuePath(iss.path);
		    if (issuePath.length > 0) {
		      errorKeyMap.add(issuePath);
		    }
		  }
		  const errorKeys = Array.from(errorKeyMap);
		  if (errorKeys.length === 0) {
		    let rootExpectedType = "variable";
		    if (zodError.issues.length > 0) {
		      const iss = zodError.issues[0];
		      if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") {
		        rootExpectedType = iss.expected;
		      }
		    }
		    return `Failed to validate ${rootExpectedType}`;
		  }
		  return `Failed to validate keys: ${string.truncate(errorKeys.join(", "), 100)}`;
		}
		function applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
		  if (!event.exception?.values || !hint.originalException || !originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) {
		    return event;
		  }
		  try {
		    const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
		    const flattenedIssues = issuesToFlatten.map(flattenIssue);
		    if (saveZodIssuesAsAttachment) {
		      if (!Array.isArray(hint.attachments)) {
		        hint.attachments = [];
		      }
		      hint.attachments.push({
		        filename: "zod_issues.json",
		        data: JSON.stringify({
		          issues: flattenedIssues
		        })
		      });
		    }
		    return {
		      ...event,
		      exception: {
		        ...event.exception,
		        values: [
		          {
		            ...event.exception.values[0],
		            value: formatIssueMessage(hint.originalException)
		          },
		          ...event.exception.values.slice(1)
		        ]
		      },
		      extra: {
		        ...event.extra,
		        "zoderror.issues": flattenedIssues.slice(0, limit)
		      }
		    };
		  } catch (e) {
		    return {
		      ...event,
		      extra: {
		        ...event.extra,
		        "zoderrors sentry integration parse error": {
		          message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
		          error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
		        }
		      }
		    };
		  }
		}
		const _zodErrorsIntegration = ((options = {}) => {
		  const limit = options.limit ?? DEFAULT_LIMIT;
		  return {
		    name: INTEGRATION_NAME,
		    processEvent(originalEvent, hint) {
		      const processedEvent = applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
		      return processedEvent;
		    }
		  };
		});
		const zodErrorsIntegration = integration.defineIntegration(_zodErrorsIntegration);

		exports.applyZodErrorsToEvent = applyZodErrorsToEvent;
		exports.flattenIssue = flattenIssue;
		exports.flattenIssuePath = flattenIssuePath;
		exports.formatIssueMessage = formatIssueMessage;
		exports.zodErrorsIntegration = zodErrorsIntegration;
		
	} (zoderrors));
	return zoderrors;
}

var thirdPartyErrorsFilter = {};

var hasRequiredThirdPartyErrorsFilter;

function requireThirdPartyErrorsFilter () {
	if (hasRequiredThirdPartyErrorsFilter) return thirdPartyErrorsFilter;
	hasRequiredThirdPartyErrorsFilter = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const integration = /*@__PURE__*/ requireIntegration$6();
		const metadata = /*@__PURE__*/ requireMetadata();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const stacktrace = /*@__PURE__*/ requireStacktrace();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const thirdPartyErrorFilterIntegration = integration.defineIntegration((options) => {
		  return {
		    name: "ThirdPartyErrorsFilter",
		    setup(client) {
		      client.on("beforeEnvelope", (envelope$1) => {
		        envelope.forEachEnvelopeItem(envelope$1, (item, type) => {
		          if (type === "event") {
		            const event = Array.isArray(item) ? item[1] : void 0;
		            if (event) {
		              metadata.stripMetadataFromStackFrames(event);
		              item[1] = event;
		            }
		          }
		        });
		      });
		      client.on("applyFrameMetadata", (event) => {
		        if (event.type) {
		          return;
		        }
		        const stackParser = client.getOptions().stackParser;
		        metadata.addMetadataToStackFrames(stackParser, event);
		      });
		    },
		    preprocessEvent(event) {
		      if (options.ignoreSentryInternalFrames && (worldwide.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) {
		        event.sdkProcessingMetadata = {
		          ...event.sdkProcessingMetadata,
		          insideSentryWrapped: true
		        };
		      }
		    },
		    processEvent(event) {
		      const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
		      const frameKeys = getBundleKeysForAllFramesWithFilenames(
		        event,
		        options.ignoreSentryInternalFrames,
		        insideSentryWrapped
		      );
		      if (frameKeys) {
		        const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
		        const behaviourApplies = frameKeys[arrayMethod]((keys) => !keys.some((key) => options.filterKeys.includes(key)));
		        if (behaviourApplies) {
		          const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
		          if (shouldDrop) {
		            return null;
		          } else {
		            event.tags = {
		              ...event.tags,
		              third_party_code: true
		            };
		          }
		        }
		      }
		      return event;
		    }
		  };
		});
		function isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
		  if (frameIndex !== 0) {
		    return false;
		  }
		  if (insideSentryWrapped && isLikelyMinifiedSentryWrappedFrame(frame)) {
		    return true;
		  }
		  if (frame.function === "sentryWrapped") {
		    return true;
		  }
		  if (!frame.context_line || !frame.filename) {
		    return false;
		  }
		  if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
		  !frame.context_line.includes(SENTRY_INTERNAL_FN_APPLY)) {
		    return false;
		  }
		  if (frame.pre_context) {
		    const len = frame.pre_context.length;
		    for (let i = 0; i < len; i++) {
		      if (frame.pre_context[i]?.includes(SENTRY_INTERNAL_COMMENT)) {
		        return true;
		      }
		    }
		  }
		  return false;
		}
		function getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
		  const frames = stacktrace.getFramesFromEvent(event);
		  if (!frames) {
		    return void 0;
		  }
		  return frames.filter((frame, index) => {
		    if (!frame.filename) {
		      return false;
		    }
		    if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) {
		      return false;
		    }
		    return !ignoreSentryInternalFrames || !isSentryInternalFrame(frame, index, !!insideSentryWrapped);
		  }).map((frame) => {
		    if (!frame.module_metadata) {
		      return [];
		    }
		    return Object.keys(frame.module_metadata).filter((key) => key.startsWith(BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key) => key.slice(BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
		  });
		}
		function isLikelyMinifiedSentryWrappedFrame(frame) {
		  return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
		}
		const BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
		const SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
		const SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";

		exports.thirdPartyErrorFilterIntegration = thirdPartyErrorFilterIntegration;
		
	} (thirdPartyErrorsFilter));
	return thirdPartyErrorsFilter;
}

var console$1 = {};

var hasRequiredConsole;

function requireConsole () {
	if (hasRequiredConsole) return console$1;
	hasRequiredConsole = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const breadcrumbs = /*@__PURE__*/ requireBreadcrumbs$1();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const console = /*@__PURE__*/ requireConsole$1();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const severity = /*@__PURE__*/ requireSeverity();
		const string = /*@__PURE__*/ requireString();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const INTEGRATION_NAME = "Console";
		const consoleIntegration = integration.defineIntegration((options = {}) => {
		  const levels = new Set(options.levels || debugLogger.CONSOLE_LEVELS);
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      const unsubscribe = console.addConsoleInstrumentationHandler(({ args, level }) => {
		        if (currentScopes.getClient() !== client || !levels.has(level)) {
		          return;
		        }
		        addConsoleBreadcrumb(level, args);
		      });
		      client.registerCleanup(unsubscribe);
		      if (options.filter) {
		        const unsubscribe2 = console.addConsoleInstrumentationFilter(options.filter);
		        client.registerCleanup(unsubscribe2);
		      }
		    }
		  };
		});
		function addConsoleBreadcrumb(level, args) {
		  const breadcrumb = {
		    category: "console",
		    data: {
		      arguments: args,
		      logger: "console"
		    },
		    level: severity.severityLevelFromString(level),
		    message: formatConsoleArgs(args)
		  };
		  if (level === "assert") {
		    if (args[0] === false) {
		      const assertionArgs = args.slice(1);
		      breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${formatConsoleArgs(assertionArgs)}` : "Assertion failed";
		      breadcrumb.data.arguments = assertionArgs;
		    } else {
		      return;
		    }
		  }
		  breadcrumbs.addBreadcrumb(breadcrumb, {
		    input: args,
		    level
		  });
		}
		function formatConsoleArgs(values) {
		  return "util" in worldwide.GLOBAL_OBJ && typeof worldwide.GLOBAL_OBJ.util.format === "function" ? worldwide.GLOBAL_OBJ.util.format(...values) : string.safeJoin(values, " ");
		}

		exports.addConsoleBreadcrumb = addConsoleBreadcrumb;
		exports.consoleIntegration = consoleIntegration;
		
	} (console$1));
	return console$1;
}

var featureFlagsIntegration = {};

var featureFlags = {};

var hasRequiredFeatureFlags;

function requireFeatureFlags () {
	if (hasRequiredFeatureFlags) return featureFlags;
	hasRequiredFeatureFlags = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		const _INTERNAL_FLAG_BUFFER_SIZE = 100;
		const _INTERNAL_MAX_FLAGS_PER_SPAN = 10;
		const SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
		function _INTERNAL_copyFlagsFromScopeToEvent(event) {
		  if (event.type) {
		    return event;
		  }
		  const scope = currentScopes.getCurrentScope();
		  const flagContext = scope.getScopeData().contexts.flags;
		  const flagBuffer = flagContext ? flagContext.values : [];
		  if (!flagBuffer.length) {
		    return event;
		  }
		  if (event.contexts === void 0) {
		    event.contexts = {};
		  }
		  event.contexts.flags = { values: [...flagBuffer] };
		  return event;
		}
		function _INTERNAL_insertFlagToScope(name, value, maxSize = _INTERNAL_FLAG_BUFFER_SIZE) {
		  const scopeContexts = currentScopes.getCurrentScope().getScopeData().contexts;
		  if (!scopeContexts.flags) {
		    scopeContexts.flags = { values: [] };
		  }
		  const flags = scopeContexts.flags.values;
		  _INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
		}
		function _INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
		  if (typeof value !== "boolean") {
		    return;
		  }
		  if (flags.length > maxSize) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
		    return;
		  }
		  const index = flags.findIndex((f) => f.flag === name);
		  if (index !== -1) {
		    flags.splice(index, 1);
		  }
		  if (flags.length === maxSize) {
		    flags.shift();
		  }
		  flags.push({
		    flag: name,
		    result: value
		  });
		}
		function _INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = _INTERNAL_MAX_FLAGS_PER_SPAN) {
		  if (typeof value !== "boolean") {
		    return;
		  }
		  const span = spanUtils.getActiveSpan();
		  if (!span) {
		    return;
		  }
		  const attributes = spanUtils.spanToJSON(span).data;
		  if (`${SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
		    span.setAttribute(`${SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
		    return;
		  }
		  const numOfAddedFlags = Object.keys(attributes).filter((key) => key.startsWith(SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
		  if (numOfAddedFlags < maxFlagsPerSpan) {
		    span.setAttribute(`${SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
		  }
		}

		exports._INTERNAL_FLAG_BUFFER_SIZE = _INTERNAL_FLAG_BUFFER_SIZE;
		exports._INTERNAL_MAX_FLAGS_PER_SPAN = _INTERNAL_MAX_FLAGS_PER_SPAN;
		exports._INTERNAL_addFeatureFlagToActiveSpan = _INTERNAL_addFeatureFlagToActiveSpan;
		exports._INTERNAL_copyFlagsFromScopeToEvent = _INTERNAL_copyFlagsFromScopeToEvent;
		exports._INTERNAL_insertFlagToScope = _INTERNAL_insertFlagToScope;
		exports._INTERNAL_insertToFlagBuffer = _INTERNAL_insertToFlagBuffer;
		
	} (featureFlags));
	return featureFlags;
}

var hasRequiredFeatureFlagsIntegration;

function requireFeatureFlagsIntegration () {
	if (hasRequiredFeatureFlagsIntegration) return featureFlagsIntegration;
	hasRequiredFeatureFlagsIntegration = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const integration = /*@__PURE__*/ requireIntegration$6();
		const featureFlags = /*@__PURE__*/ requireFeatureFlags();

		const featureFlagsIntegration = integration.defineIntegration(() => {
		  return {
		    name: "FeatureFlags",
		    processEvent(event, _hint, _client) {
		      return featureFlags._INTERNAL_copyFlagsFromScopeToEvent(event);
		    },
		    addFeatureFlag(name, value) {
		      featureFlags._INTERNAL_insertFlagToScope(name, value);
		      featureFlags._INTERNAL_addFeatureFlagToActiveSpan(name, value);
		    }
		  };
		});

		exports.featureFlagsIntegration = featureFlagsIntegration;
		
	} (featureFlagsIntegration));
	return featureFlagsIntegration;
}

var growthbook = {};

var hasRequiredGrowthbook;

function requireGrowthbook () {
	if (hasRequiredGrowthbook) return growthbook;
	hasRequiredGrowthbook = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const integration = /*@__PURE__*/ requireIntegration$6();
		const featureFlags = /*@__PURE__*/ requireFeatureFlags();
		const object = /*@__PURE__*/ requireObject();

		const growthbookIntegration = integration.defineIntegration(
		  ({ growthbookClass }) => {
		    return {
		      name: "GrowthBook",
		      setupOnce() {
		        const proto = growthbookClass.prototype;
		        if (typeof proto.isOn === "function") {
		          object.fill(proto, "isOn", _wrapAndCaptureBooleanResult);
		        }
		        if (typeof proto.getFeatureValue === "function") {
		          object.fill(proto, "getFeatureValue", _wrapAndCaptureBooleanResult);
		        }
		      },
		      processEvent(event, _hint, _client) {
		        return featureFlags._INTERNAL_copyFlagsFromScopeToEvent(event);
		      }
		    };
		  }
		);
		function _wrapAndCaptureBooleanResult(original) {
		  return function(...args) {
		    const flagName = args[0];
		    const result = original.apply(this, args);
		    if (typeof flagName === "string" && typeof result === "boolean") {
		      featureFlags._INTERNAL_insertFlagToScope(flagName, result);
		      featureFlags._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
		    }
		    return result;
		  };
		}

		exports.growthbookIntegration = growthbookIntegration;
		
	} (growthbook));
	return growthbook;
}

var conversationId = {};

var hasRequiredConversationId;

function requireConversationId () {
	if (hasRequiredConversationId) return conversationId;
	hasRequiredConversationId = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		const INTEGRATION_NAME = "ConversationId";
		const _conversationIdIntegration = (() => {
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      client.on("spanStart", (span) => {
		        const scopeData = currentScopes.getCurrentScope().getScopeData();
		        const isolationScopeData = currentScopes.getIsolationScope().getScopeData();
		        const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
		        if (conversationId) {
		          const { op, data: attributes, description: name } = spanUtils.spanToJSON(span);
		          if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) {
		            return;
		          }
		          span.setAttribute(semanticAttributes.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
		        }
		      });
		    }
		  };
		});
		const conversationIdIntegration = integration.defineIntegration(_conversationIdIntegration);

		exports.conversationIdIntegration = conversationIdIntegration;
		
	} (conversationId));
	return conversationId;
}

var profiling$1 = {};

var hasRequiredProfiling$1;

function requireProfiling$1 () {
	if (hasRequiredProfiling$1) return profiling$1;
	hasRequiredProfiling$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();

		function isProfilingIntegrationWithProfiler(integration) {
		  return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
		}
		function startProfiler() {
		  const client = currentScopes.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No Sentry client available, profiling is not started");
		    return;
		  }
		  const integration = client.getIntegrationByName("ProfilingIntegration");
		  if (!integration) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("ProfilingIntegration is not available");
		    return;
		  }
		  if (!isProfilingIntegrationWithProfiler(integration)) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Profiler is not available on profiling integration.");
		    return;
		  }
		  integration._profiler.start();
		}
		function stopProfiler() {
		  const client = currentScopes.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No Sentry client available, profiling is not started");
		    return;
		  }
		  const integration = client.getIntegrationByName("ProfilingIntegration");
		  if (!integration) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("ProfilingIntegration is not available");
		    return;
		  }
		  if (!isProfilingIntegrationWithProfiler(integration)) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Profiler is not available on profiling integration.");
		    return;
		  }
		  integration._profiler.stop();
		}
		const profiler = {
		  startProfiler,
		  stopProfiler
		};

		exports.profiler = profiler;
		
	} (profiling$1));
	return profiling$1;
}

var fetch$3 = {};

var hasRequiredFetch$2;

function requireFetch$2 () {
	if (hasRequiredFetch$2) return fetch$3;
	hasRequiredFetch$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const is = /*@__PURE__*/ requireIs$1();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const sentryNonRecordingSpan = /*@__PURE__*/ requireSentryNonRecordingSpan();
		const baggage = /*@__PURE__*/ requireBaggage();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const trace = /*@__PURE__*/ requireTrace();
		const traceData = /*@__PURE__*/ requireTraceData();
		const url = /*@__PURE__*/ requireUrl();

		function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
		  if (!handlerData.fetchData) {
		    return void 0;
		  }
		  const { method, url } = handlerData.fetchData;
		  const shouldCreateSpanResult = hasSpansEnabled.hasSpansEnabled() && shouldCreateSpan(url);
		  if (handlerData.endTimestamp) {
		    const spanId = handlerData.fetchData.__span;
		    if (!spanId) return;
		    const span2 = spans[spanId];
		    if (span2) {
		      if (shouldCreateSpanResult) {
		        endSpan(span2, handlerData);
		        _callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
		      }
		      delete spans[spanId];
		    }
		    return void 0;
		  }
		  const { spanOrigin = "auto.http.browser", propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : { spanOrigin: spanOriginOrOptions };
		  const client = currentScopes.getClient();
		  const hasParent = !!spanUtils.getActiveSpan();
		  const shouldEmitSpan = hasParent || !!client && hasSpanStreamingEnabled.hasSpanStreamingEnabled(client);
		  const span = shouldCreateSpanResult && shouldEmitSpan ? trace.startInactiveSpan(getSpanStartOptions(url, method, spanOrigin)) : new sentryNonRecordingSpan.SentryNonRecordingSpan();
		  if (shouldCreateSpanResult && !shouldEmitSpan) {
		    client?.recordDroppedEvent("no_parent_span", "span");
		  }
		  handlerData.fetchData.__span = span.spanContext().spanId;
		  spans[span.spanContext().spanId] = span;
		  if (shouldAttachHeaders(handlerData.fetchData.url)) {
		    const request = handlerData.args[0];
		    const options = { ...handlerData.args[1] || {} };
		    const headers = _INTERNAL_getTracingHeadersForFetchRequest(
		      request,
		      options,
		      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
		      // we do not want to use the span as base for the trace headers,
		      // which means that the headers will be generated from the scope and the sampling decision is deferred
		      hasSpansEnabled.hasSpansEnabled() && shouldEmitSpan ? span : void 0,
		      propagateTraceparent
		    );
		    if (headers) {
		      handlerData.args[1] = options;
		      options.headers = headers;
		    }
		  }
		  if (client) {
		    const fetchHint = {
		      input: handlerData.args,
		      response: handlerData.response,
		      startTimestamp: handlerData.startTimestamp,
		      endTimestamp: handlerData.endTimestamp
		    };
		    client.emit("beforeOutgoingRequestSpan", span, fetchHint);
		  }
		  return span;
		}
		function _callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
		  const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
		  onRequestSpanEnd?.(span, {
		    headers: handlerData.response?.headers,
		    error: handlerData.error
		  });
		}
		function _INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
		  const traceHeaders = traceData.getTraceData({ span, propagateTraceparent });
		  const sentryTrace = traceHeaders["sentry-trace"];
		  const baggage = traceHeaders.baggage;
		  const traceparent = traceHeaders.traceparent;
		  if (!sentryTrace) {
		    return void 0;
		  }
		  const originalHeaders = fetchOptionsObj.headers || (is.isRequest(request) ? request.headers : void 0);
		  if (!originalHeaders) {
		    return { ...traceHeaders };
		  } else if (isHeaders(originalHeaders)) {
		    const newHeaders = new Headers(originalHeaders);
		    if (!newHeaders.get("sentry-trace")) {
		      newHeaders.set("sentry-trace", sentryTrace);
		    }
		    if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) {
		      newHeaders.set("traceparent", traceparent);
		    }
		    if (baggage) {
		      const prevBaggageHeader = newHeaders.get("baggage");
		      if (!prevBaggageHeader) {
		        newHeaders.set("baggage", baggage);
		      } else if (!baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) {
		        newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
		      }
		    }
		    return newHeaders;
		  } else if (isHeadersInitTupleArray(originalHeaders)) {
		    const newHeaders = [...originalHeaders];
		    if (!newHeaders.find((header) => header[0] === "sentry-trace")) {
		      newHeaders.push(["sentry-trace", sentryTrace]);
		    }
		    if (propagateTraceparent && traceparent && !newHeaders.find((header) => header[0] === "traceparent")) {
		      newHeaders.push(["traceparent", traceparent]);
		    }
		    const prevBaggageHeaderWithSentryValues = originalHeaders.find(
		      (header) => header[0] === "baggage" && typeof header[1] === "string" && baggageHeaderHasSentryBaggageValues(header[1])
		    );
		    if (baggage && !prevBaggageHeaderWithSentryValues) {
		      newHeaders.push(["baggage", baggage]);
		    }
		    return newHeaders;
		  } else {
		    const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
		    const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
		    const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
		    const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [...existingBaggageHeader] : [existingBaggageHeader] : [];
		    const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem) => baggageHeaderHasSentryBaggageValues(headerItem)) : baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
		    if (baggage && !prevBaggageHeaderWithSentryValues) {
		      newBaggageHeaders.push(baggage);
		    }
		    const newHeaders = Object.assign({}, originalHeaders, {
		      "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
		      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
		    });
		    if (propagateTraceparent && traceparent && !existingTraceparentHeader) {
		      newHeaders.traceparent = traceparent;
		    }
		    return newHeaders;
		  }
		}
		function endSpan(span, handlerData) {
		  if (handlerData.response) {
		    spanstatus.setHttpStatus(span, handlerData.response.status);
		    const contentLength = handlerData.response?.headers?.get("content-length");
		    if (contentLength) {
		      const contentLengthNum = parseInt(contentLength);
		      if (contentLengthNum > 0) {
		        span.setAttribute("http.response_content_length", contentLengthNum);
		      }
		    }
		  } else if (handlerData.error) {
		    span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		  }
		  span.end();
		}
		function baggageHeaderHasSentryBaggageValues(baggageHeader) {
		  if (typeof baggageHeader !== "string") {
		    return false;
		  }
		  return baggageHeader.split(",").some((baggageEntry) => baggageEntry.trim().startsWith(baggage.SENTRY_BAGGAGE_KEY_PREFIX));
		}
		function isHeaders(headers) {
		  return typeof Headers !== "undefined" && is.isInstanceOf(headers, Headers);
		}
		function isHeadersInitTupleArray(headers) {
		  if (!Array.isArray(headers)) {
		    return false;
		  }
		  return headers.every(
		    (item) => Array.isArray(item) && item.length === 2 && typeof item[0] === "string"
		  );
		}
		function getSpanStartOptions(url$1, method, spanOrigin) {
		  if (url$1.startsWith("data:")) {
		    const sanitizedUrl2 = url.stripDataUrlContent(url$1);
		    return {
		      name: `${method} ${sanitizedUrl2}`,
		      attributes: getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
		    };
		  }
		  const parsedUrl = url.parseStringToURLObject(url$1);
		  const sanitizedUrl = parsedUrl ? url.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
		  return {
		    name: `${method} ${sanitizedUrl}`,
		    attributes: getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
		  };
		}
		function getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
		  const attributes = {
		    url: url.stripDataUrlContent(url$1),
		    type: "fetch",
		    "http.method": method,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
		  };
		  if (parsedUrl) {
		    if (!url.isURLObjectRelative(parsedUrl)) {
		      attributes["http.url"] = url.stripDataUrlContent(parsedUrl.href);
		      attributes["server.address"] = parsedUrl.host;
		    }
		    if (parsedUrl.search) {
		      attributes["http.query"] = parsedUrl.search;
		    }
		    if (parsedUrl.hash) {
		      attributes["http.fragment"] = parsedUrl.hash;
		    }
		  }
		  return attributes;
		}

		exports._INTERNAL_getTracingHeadersForFetchRequest = _INTERNAL_getTracingHeadersForFetchRequest;
		exports._callOnRequestSpanEnd = _callOnRequestSpanEnd;
		exports.instrumentFetchRequest = instrumentFetchRequest;
		
	} (fetch$3));
	return fetch$3;
}

var feedback = {};

var hasRequiredFeedback;

function requireFeedback () {
	if (hasRequiredFeedback) return feedback;
	hasRequiredFeedback = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();

		function captureFeedback(params, hint = {}, scope = currentScopes.getCurrentScope()) {
		  const { message, name, email, url, source, associatedEventId, tags } = params;
		  const feedbackEvent = {
		    contexts: {
		      feedback: {
		        contact_email: email,
		        name,
		        message,
		        url,
		        source,
		        associated_event_id: associatedEventId
		      }
		    },
		    type: "feedback",
		    level: "info",
		    tags
		  };
		  const client = scope?.getClient() || currentScopes.getClient();
		  if (client) {
		    client.emit("beforeSendFeedback", feedbackEvent, hint);
		  }
		  const eventId = scope.captureEvent(feedbackEvent, hint);
		  return eventId;
		}

		exports.captureFeedback = captureFeedback;
		
	} (feedback));
	return feedback;
}

var publicApi$1 = {};

var hasRequiredPublicApi$1;

function requirePublicApi$1 () {
	if (hasRequiredPublicApi$1) return publicApi$1;
	hasRequiredPublicApi$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const internal = /*@__PURE__*/ requireInternal$1();
		const parameterize = /*@__PURE__*/ requireParameterize();

		function captureLog(level, message, attributes, scope, severityNumber) {
		  internal._INTERNAL_captureLog({ level, message, attributes, severityNumber }, scope);
		}
		function trace(message, attributes, { scope } = {}) {
		  captureLog("trace", message, attributes, scope);
		}
		function debug(message, attributes, { scope } = {}) {
		  captureLog("debug", message, attributes, scope);
		}
		function info(message, attributes, { scope } = {}) {
		  captureLog("info", message, attributes, scope);
		}
		function warn(message, attributes, { scope } = {}) {
		  captureLog("warn", message, attributes, scope);
		}
		function error(message, attributes, { scope } = {}) {
		  captureLog("error", message, attributes, scope);
		}
		function fatal(message, attributes, { scope } = {}) {
		  captureLog("fatal", message, attributes, scope);
		}

		exports.fmt = parameterize.fmt;
		exports.debug = debug;
		exports.error = error;
		exports.fatal = fatal;
		exports.info = info;
		exports.trace = trace;
		exports.warn = warn;
		
	} (publicApi$1));
	return publicApi$1;
}

var consoleIntegration = {};

var utils$f = {};

var hasRequiredUtils$f;

function requireUtils$f () {
	if (hasRequiredUtils$f) return utils$f;
	hasRequiredUtils$f = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const is = /*@__PURE__*/ requireIs$1();
		const normalize = /*@__PURE__*/ requireNormalize();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		function formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
		  return "util" in worldwide.GLOBAL_OBJ && typeof worldwide.GLOBAL_OBJ.util.format === "function" ? worldwide.GLOBAL_OBJ.util.format(...values) : safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
		}
		function safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
		  return values.map(
		    (value) => is.isPrimitive(value) ? String(value) : JSON.stringify(normalize.normalize(value, normalizeDepth, normalizeMaxBreadth))
		  ).join(" ");
		}
		function hasConsoleSubstitutions(str) {
		  return /%[sdifocO]/.test(str);
		}
		function createConsoleTemplateAttributes(firstArg, followingArgs) {
		  const attributes = {};
		  const template = new Array(followingArgs.length).fill("{}").join(" ");
		  attributes["sentry.message.template"] = `${firstArg} ${template}`;
		  followingArgs.forEach((arg, index) => {
		    attributes[`sentry.message.parameter.${index}`] = arg;
		  });
		  return attributes;
		}

		exports.createConsoleTemplateAttributes = createConsoleTemplateAttributes;
		exports.formatConsoleArgs = formatConsoleArgs;
		exports.hasConsoleSubstitutions = hasConsoleSubstitutions;
		exports.safeJoinConsoleArgs = safeJoinConsoleArgs;
		
	} (utils$f));
	return utils$f;
}

var hasRequiredConsoleIntegration;

function requireConsoleIntegration () {
	if (hasRequiredConsoleIntegration) return consoleIntegration;
	hasRequiredConsoleIntegration = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const console = /*@__PURE__*/ requireConsole$1();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();
		const normalize = /*@__PURE__*/ requireNormalize();
		const internal = /*@__PURE__*/ requireInternal$1();
		const utils = /*@__PURE__*/ requireUtils$f();

		const INTEGRATION_NAME = "ConsoleLogs";
		const DEFAULT_ATTRIBUTES = {
		  [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
		};
		const _consoleLoggingIntegration = ((options = {}) => {
		  const levels = options.levels || debugLogger.CONSOLE_LEVELS;
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      const { enableLogs, normalizeDepth = 3, normalizeMaxBreadth = 1e3 } = client.getOptions();
		      if (!enableLogs) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
		        return;
		      }
		      const unsubscribe = console.addConsoleInstrumentationHandler(({ args, level }) => {
		        if (currentScopes.getClient() !== client || !levels.includes(level)) {
		          return;
		        }
		        const firstArg = args[0];
		        const followingArgs = args.slice(1);
		        if (level === "assert") {
		          if (!firstArg) {
		            const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${utils.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
		            internal._INTERNAL_captureLog({ level: "error", message: assertionMessage, attributes: DEFAULT_ATTRIBUTES });
		          }
		          return;
		        }
		        const isLevelLog = level === "log";
		        const attributes = { ...DEFAULT_ATTRIBUTES };
		        if (is.isPlainObject(firstArg)) {
		          Object.assign(attributes, normalize.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
		          const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
		          const remainingArgs = args.slice(remainingArgsStartIndex);
		          remainingArgs.forEach((arg, index) => {
		            attributes[`sentry.message.parameter.${index}`] = normalize.normalize(arg, normalizeDepth, normalizeMaxBreadth);
		          });
		        } else {
		          const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !utils.hasConsoleSubstitutions(firstArg);
		          if (shouldGenerateTemplate) {
		            const templateAttrs = utils.createConsoleTemplateAttributes(firstArg, followingArgs);
		            for (const [key, value] of Object.entries(templateAttrs)) {
		              attributes[key] = key.startsWith("sentry.message.parameter.") ? normalize.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
		            }
		          }
		        }
		        internal._INTERNAL_captureLog({
		          level: isLevelLog ? "info" : level,
		          message: utils.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
		          severityNumber: isLevelLog ? 10 : void 0,
		          attributes
		        });
		      });
		      client.registerCleanup(unsubscribe);
		    }
		  };
		});
		const consoleLoggingIntegration = integration.defineIntegration(_consoleLoggingIntegration);

		exports.consoleLoggingIntegration = consoleLoggingIntegration;
		
	} (consoleIntegration));
	return consoleIntegration;
}

var publicApi = {};

var hasRequiredPublicApi;

function requirePublicApi () {
	if (hasRequiredPublicApi) return publicApi;
	hasRequiredPublicApi = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const internal = /*@__PURE__*/ requireInternal();

		function captureMetric(type, name, value, options) {
		  internal._INTERNAL_captureMetric(
		    { type, name, value, unit: options?.unit, attributes: options?.attributes },
		    { scope: options?.scope }
		  );
		}
		function count(name, value = 1, options) {
		  captureMetric("counter", name, value, options);
		}
		function gauge(name, value, options) {
		  captureMetric("gauge", name, value, options);
		}
		function distribution(name, value, options) {
		  captureMetric("distribution", name, value, options);
		}

		exports.count = count;
		exports.distribution = distribution;
		exports.gauge = gauge;
		
	} (publicApi));
	return publicApi;
}

var consola = {};

var hasRequiredConsola;

function requireConsola () {
	if (hasRequiredConsola) return consola;
	hasRequiredConsola = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const internal = /*@__PURE__*/ requireInternal$1();
		const utils = /*@__PURE__*/ requireUtils$f();
		const is = /*@__PURE__*/ requireIs$1();
		const normalize = /*@__PURE__*/ requireNormalize();

		const DEFAULT_CAPTURED_LEVELS = ["trace", "debug", "info", "warn", "error", "fatal"];
		function createConsolaReporter(options = {}) {
		  const levels = new Set(options.levels ?? DEFAULT_CAPTURED_LEVELS);
		  const providedClient = options.client;
		  return {
		    log(logObj) {
		      const { type, level, message: consolaMessage, args, tag, date: _date, ...rest } = logObj;
		      const client = providedClient || currentScopes.getClient();
		      if (!client) {
		        return;
		      }
		      const logSeverityLevel = getLogSeverityLevel(type, level);
		      if (!levels.has(logSeverityLevel)) {
		        return;
		      }
		      const { normalizeDepth = 3, normalizeMaxBreadth = 1e3 } = client.getOptions();
		      const attributes = {};
		      for (const [key, value] of Object.entries(rest)) {
		        attributes[key] = normalize.normalize(value, normalizeDepth, normalizeMaxBreadth);
		      }
		      attributes["sentry.origin"] = "auto.log.consola";
		      if (tag) {
		        attributes["consola.tag"] = tag;
		      }
		      if (type) {
		        attributes["consola.type"] = type;
		      }
		      if (level != null && typeof level === "number") {
		        attributes["consola.level"] = level;
		      }
		      const extractionResult = processExtractedAttributes(
		        defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth),
		        normalizeDepth,
		        normalizeMaxBreadth
		      );
		      if (extractionResult?.attributes) {
		        Object.assign(attributes, extractionResult.attributes);
		      }
		      internal._INTERNAL_captureLog({
		        level: logSeverityLevel,
		        message: extractionResult?.message || consolaMessage || args && utils.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
		        attributes
		      });
		    }
		  };
		}
		const CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
		  // Consola built-in types
		  silent: "trace",
		  fatal: "fatal",
		  error: "error",
		  warn: "warn",
		  log: "info",
		  info: "info",
		  success: "info",
		  fail: "error",
		  ready: "info",
		  start: "info",
		  box: "info",
		  debug: "debug",
		  trace: "trace",
		  verbose: "debug",
		  // Custom types that might exist
		  critical: "fatal",
		  notice: "info"
		};
		const CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
		  0: "fatal",
		  // Fatal and Error
		  1: "warn",
		  // Warnings
		  2: "info",
		  // Normal logs
		  3: "info",
		  // Informational logs, success, fail, ready, start, ...
		  4: "debug",
		  // Debug logs
		  5: "trace"
		  // Trace logs
		};
		function getLogSeverityLevel(type, level) {
		  if (type === "verbose") {
		    return "debug";
		  }
		  if (type === "silent") {
		    return "trace";
		  }
		  if (type) {
		    const mappedLevel = CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
		    if (mappedLevel) {
		      return mappedLevel;
		    }
		  }
		  if (typeof level === "number") {
		    const mappedLevel = CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
		    if (mappedLevel) {
		      return mappedLevel;
		    }
		  }
		  return "info";
		}
		function defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
		  if (!args?.length) {
		    return { message: "" };
		  }
		  const message = utils.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
		  const firstArg = args[0];
		  if (is.isPlainObject(firstArg)) {
		    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
		    const remainingArgs = args.slice(remainingArgsStartIndex);
		    return {
		      message,
		      // Object content from first arg is added as attributes
		      attributes: firstArg,
		      // Add remaining args as message parameters
		      messageParameters: remainingArgs
		    };
		  } else {
		    const followingArgs = args.slice(1);
		    const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !utils.hasConsoleSubstitutions(firstArg);
		    return {
		      message,
		      messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
		      messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
		    };
		  }
		}
		function processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
		  const { message, attributes, messageTemplate, messageParameters } = extractionResult;
		  const messageParamAttributes = {};
		  if (messageTemplate && messageParameters) {
		    const templateAttrs = utils.createConsoleTemplateAttributes(messageTemplate, messageParameters);
		    for (const [key, value] of Object.entries(templateAttrs)) {
		      messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? normalize.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
		    }
		  } else if (messageParameters && messageParameters.length > 0) {
		    messageParameters.forEach((arg, index) => {
		      messageParamAttributes[`sentry.message.parameter.${index}`] = normalize.normalize(arg, normalizeDepth, normalizeMaxBreadth);
		    });
		  }
		  return {
		    message,
		    attributes: {
		      ...normalize.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
		      ...messageParamAttributes
		    }
		  };
		}

		exports.createConsolaReporter = createConsolaReporter;
		
	} (consola));
	return consola;
}

var vercelAi = {};

var utils$e = {};

var genAiAttributes = {};

var hasRequiredGenAiAttributes;

function requireGenAiAttributes () {
	if (hasRequiredGenAiAttributes) return genAiAttributes;
	hasRequiredGenAiAttributes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
		const GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
		const GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
		const GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
		const GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
		const GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
		const GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
		const GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
		const GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
		const GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
		const GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
		const GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
		const GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
		const GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
		const GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
		const GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
		const GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
		const GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
		const GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
		const GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
		const GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
		const GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
		const GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
		const GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
		const GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
		const GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
		const GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
		const GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
		const GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
		const GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
		const GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
		const GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
		const GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
		const GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
		const GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
		const GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
		const GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
		const GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
		const GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
		const GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
		const GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
		const GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
		const GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
		const GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
		const GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";

		exports.GEN_AI_AGENT_NAME_ATTRIBUTE = GEN_AI_AGENT_NAME_ATTRIBUTE;
		exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = GEN_AI_CONVERSATION_ID_ATTRIBUTE;
		exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
		exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
		exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
		exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
		exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
		exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
		exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = GEN_AI_OPERATION_NAME_ATTRIBUTE;
		exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
		exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = GEN_AI_PIPELINE_NAME_ATTRIBUTE;
		exports.GEN_AI_PROMPT_ATTRIBUTE = GEN_AI_PROMPT_ATTRIBUTE;
		exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
		exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
		exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
		exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
		exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
		exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = GEN_AI_REQUEST_MODEL_ATTRIBUTE;
		exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
		exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = GEN_AI_REQUEST_STREAM_ATTRIBUTE;
		exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
		exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
		exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
		exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
		exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = GEN_AI_RESPONSE_ID_ATTRIBUTE;
		exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
		exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
		exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
		exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
		exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
		exports.GEN_AI_SYSTEM_ATTRIBUTE = GEN_AI_SYSTEM_ATTRIBUTE;
		exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
		exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
		exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
		exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = GEN_AI_TOOL_INPUT_ATTRIBUTE;
		exports.GEN_AI_TOOL_NAME_ATTRIBUTE = GEN_AI_TOOL_NAME_ATTRIBUTE;
		exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
		exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = GEN_AI_TOOL_TYPE_ATTRIBUTE;
		exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
		exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
		exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
		exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
		exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
		exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
		exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;
		
	} (genAiAttributes));
	return genAiAttributes;
}

var messageTruncation = {};

var mediaStripping = {};

var hasRequiredMediaStripping;

function requireMediaStripping () {
	if (hasRequiredMediaStripping) return mediaStripping;
	hasRequiredMediaStripping = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function isContentMedia(part) {
		  if (!part || typeof part !== "object") return false;
		  return isContentMediaSource(part) || hasInlineData(part) || hasImageUrl(part) || hasInputAudio(part) || hasFileData(part) || hasMediaTypeData(part) || hasVercelFileData(part) || hasVercelImageData(part) || hasBlobOrBase64Type(part) || hasB64Json(part) || hasImageGenerationResult(part) || hasDataUri(part);
		}
		function hasImageUrl(part) {
		  if (!("image_url" in part)) return false;
		  if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
		  return hasNestedImageUrl(part);
		}
		function hasNestedImageUrl(part) {
		  return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
		}
		function isContentMediaSource(part) {
		  return "type" in part && typeof part.type === "string" && "source" in part && isContentMedia(part.source);
		}
		function hasInlineData(part) {
		  return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
		}
		function hasInputAudio(part) {
		  return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
		}
		function hasFileData(part) {
		  return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
		}
		function hasMediaTypeData(part) {
		  return "media_type" in part && typeof part.media_type === "string" && "data" in part;
		}
		function hasVercelFileData(part) {
		  return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
		  !part.data.startsWith("http://") && !part.data.startsWith("https://");
		}
		function hasVercelImageData(part) {
		  return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
		  !part.image.startsWith("http://") && !part.image.startsWith("https://");
		}
		function hasBlobOrBase64Type(part) {
		  return "type" in part && (part.type === "blob" || part.type === "base64");
		}
		function hasB64Json(part) {
		  return "b64_json" in part;
		}
		function hasImageGenerationResult(part) {
		  return "type" in part && "result" in part && part.type === "image_generation";
		}
		function hasDataUri(part) {
		  return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
		}
		const REMOVED_STRING = "[Blob substitute]";
		const MEDIA_FIELDS = ["image_url", "data", "content", "b64_json", "result", "uri", "image"];
		function stripInlineMediaFromSingleMessage(part) {
		  const strip = { ...part };
		  if (isContentMedia(strip.source)) {
		    strip.source = stripInlineMediaFromSingleMessage(strip.source);
		  }
		  if (hasInlineData(part)) {
		    strip.inlineData = { ...part.inlineData, data: REMOVED_STRING };
		  }
		  if (hasNestedImageUrl(part)) {
		    strip.image_url = { ...part.image_url, url: REMOVED_STRING };
		  }
		  if (hasInputAudio(part)) {
		    strip.input_audio = { ...part.input_audio, data: REMOVED_STRING };
		  }
		  if (hasFileData(part)) {
		    strip.file = { ...part.file, file_data: REMOVED_STRING };
		  }
		  for (const field of MEDIA_FIELDS) {
		    if (typeof strip[field] === "string") strip[field] = REMOVED_STRING;
		  }
		  return strip;
		}

		exports.isContentMedia = isContentMedia;
		exports.stripInlineMediaFromSingleMessage = stripInlineMediaFromSingleMessage;
		
	} (mediaStripping));
	return mediaStripping;
}

var hasRequiredMessageTruncation;

function requireMessageTruncation () {
	if (hasRequiredMessageTruncation) return messageTruncation;
	hasRequiredMessageTruncation = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const mediaStripping = /*@__PURE__*/ requireMediaStripping();

		const DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
		const utf8Bytes = (text) => {
		  return new TextEncoder().encode(text).length;
		};
		const jsonBytes = (value) => {
		  return utf8Bytes(JSON.stringify(value));
		};
		function truncateTextByBytes(text, maxBytes) {
		  if (utf8Bytes(text) <= maxBytes) {
		    return text;
		  }
		  let low = 0;
		  let high = text.length;
		  let bestFit = "";
		  while (low <= high) {
		    const mid = Math.floor((low + high) / 2);
		    const candidate = text.slice(0, mid);
		    const byteSize = utf8Bytes(candidate);
		    if (byteSize <= maxBytes) {
		      bestFit = candidate;
		      low = mid + 1;
		    } else {
		      high = mid - 1;
		    }
		  }
		  return bestFit;
		}
		function getItemText(item) {
		  if (typeof item === "string") {
		    return item;
		  }
		  if ("text" in item && typeof item.text === "string") {
		    return item.text;
		  }
		  return "";
		}
		function withItemText(item, text) {
		  if (typeof item === "string") {
		    return text;
		  }
		  return { ...item, text };
		}
		function isContentMessage(message) {
		  return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
		}
		function isContentArrayMessage(message) {
		  return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
		}
		function isPartsMessage(message) {
		  return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
		}
		function truncateContentMessage(message, maxBytes) {
		  const emptyMessage = { ...message, content: "" };
		  const overhead = jsonBytes(emptyMessage);
		  const availableForContent = maxBytes - overhead;
		  if (availableForContent <= 0) {
		    return [];
		  }
		  const truncatedContent = truncateTextByBytes(message.content, availableForContent);
		  return [{ ...message, content: truncatedContent }];
		}
		function getArrayItems(message) {
		  if ("parts" in message && Array.isArray(message.parts)) {
		    return { key: "parts", items: message.parts };
		  }
		  if ("content" in message && Array.isArray(message.content)) {
		    return { key: "content", items: message.content };
		  }
		  return { key: null, items: [] };
		}
		function truncateArrayMessage(message, maxBytes) {
		  const { key, items } = getArrayItems(message);
		  if (key === null || items.length === 0) {
		    return [];
		  }
		  const emptyItems = items.map((item) => withItemText(item, ""));
		  const overhead = jsonBytes({ ...message, [key]: emptyItems });
		  let remainingBytes = maxBytes - overhead;
		  if (remainingBytes <= 0) {
		    return [];
		  }
		  const includedItems = [];
		  for (const item of items) {
		    const text = getItemText(item);
		    const textSize = utf8Bytes(text);
		    if (textSize <= remainingBytes) {
		      includedItems.push(item);
		      remainingBytes -= textSize;
		    } else if (includedItems.length === 0) {
		      const truncated = truncateTextByBytes(text, remainingBytes);
		      if (truncated) {
		        includedItems.push(withItemText(item, truncated));
		      }
		      break;
		    } else {
		      break;
		    }
		  }
		  if (includedItems.length <= 0) {
		    return [];
		  } else {
		    return [{ ...message, [key]: includedItems }];
		  }
		}
		function truncateSingleMessage(message, maxBytes) {
		  if (!message) return [];
		  if (typeof message === "string") {
		    const truncated = truncateTextByBytes(message, maxBytes);
		    return truncated ? [truncated] : [];
		  }
		  if (typeof message !== "object") {
		    return [];
		  }
		  if (isContentMessage(message)) {
		    return truncateContentMessage(message, maxBytes);
		  }
		  if (isContentArrayMessage(message) || isPartsMessage(message)) {
		    return truncateArrayMessage(message, maxBytes);
		  }
		  return [];
		}
		function stripInlineMediaFromMessages(messages) {
		  const stripped = messages.map((message) => {
		    let newMessage = void 0;
		    if (!!message && typeof message === "object") {
		      if (isContentArrayMessage(message)) {
		        newMessage = {
		          ...message,
		          content: stripInlineMediaFromMessages(message.content)
		        };
		      } else if ("content" in message && mediaStripping.isContentMedia(message.content)) {
		        newMessage = {
		          ...message,
		          content: mediaStripping.stripInlineMediaFromSingleMessage(message.content)
		        };
		      }
		      if (isPartsMessage(message)) {
		        newMessage = {
		          // might have to strip content AND parts
		          ...newMessage ?? message,
		          parts: stripInlineMediaFromMessages(message.parts)
		        };
		      }
		      if (mediaStripping.isContentMedia(newMessage)) {
		        newMessage = mediaStripping.stripInlineMediaFromSingleMessage(newMessage);
		      } else if (mediaStripping.isContentMedia(message)) {
		        newMessage = mediaStripping.stripInlineMediaFromSingleMessage(message);
		      }
		    }
		    return newMessage ?? message;
		  });
		  return stripped;
		}
		function truncateMessagesByBytes(messages, maxBytes) {
		  if (!Array.isArray(messages) || messages.length === 0) {
		    return messages;
		  }
		  const effectiveMaxBytes = maxBytes - 2;
		  const lastMessage = messages[messages.length - 1];
		  const stripped = stripInlineMediaFromMessages([lastMessage]);
		  const strippedMessage = stripped[0];
		  const messageBytes = jsonBytes(strippedMessage);
		  if (messageBytes <= effectiveMaxBytes) {
		    return stripped;
		  }
		  return truncateSingleMessage(strippedMessage, effectiveMaxBytes);
		}
		function truncateGenAiMessages(messages) {
		  return truncateMessagesByBytes(messages, DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
		}
		function truncateGenAiStringInput(input) {
		  return truncateTextByBytes(input, DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
		}

		exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
		exports.truncateGenAiMessages = truncateGenAiMessages;
		exports.truncateGenAiStringInput = truncateGenAiStringInput;
		
	} (messageTruncation));
	return messageTruncation;
}

var hasRequiredUtils$e;

function requireUtils$e () {
	if (hasRequiredUtils$e) return utils$e;
	hasRequiredUtils$e = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const is = /*@__PURE__*/ requireIs$1();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const messageTruncation = /*@__PURE__*/ requireMessageTruncation();

		function resolveAIRecordingOptions(options) {
		  const genAI = currentScopes.getClient()?.getDataCollectionOptions().genAI;
		  return {
		    ...options,
		    recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
		    recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
		  };
		}
		function shouldEnableTruncation(enableTruncation) {
		  if (enableTruncation !== void 0) {
		    return enableTruncation;
		  }
		  const client = currentScopes.getClient();
		  if (!client) {
		    return true;
		  }
		  return !hasSpanStreamingEnabled.hasSpanStreamingEnabled(client) && !client.getOptions().streamGenAiSpans;
		}
		function buildMethodPath(currentPath, prop) {
		  return currentPath ? `${currentPath}.${prop}` : prop;
		}
		function setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
		  if (promptTokens !== void 0) {
		    span.setAttributes({
		      [genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
		    });
		  }
		  if (completionTokens !== void 0) {
		    span.setAttributes({
		      [genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
		    });
		  }
		  if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
		    const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
		    span.setAttributes({
		      [genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
		    });
		  }
		}
		function endStreamSpan(span, state, recordOutputs) {
		  if (!span.isRecording()) {
		    return;
		  }
		  const attrs = {
		    [genAiAttributes.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
		  };
		  if (state.responseId) attrs[genAiAttributes.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
		  if (state.responseModel) attrs[genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
		  if (state.promptTokens !== void 0) attrs[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
		  if (state.completionTokens !== void 0) attrs[genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
		  if (state.totalTokens !== void 0) {
		    attrs[genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
		  } else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) {
		    attrs[genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
		  }
		  if (state.finishReasons.length) {
		    attrs[genAiAttributes.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
		  }
		  if (recordOutputs && state.responseTexts.length) {
		    attrs[genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
		  }
		  if (recordOutputs && state.toolCalls.length) {
		    attrs[genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
		  }
		  span.setAttributes(attrs);
		  span.end();
		}
		function getJsonString(value) {
		  if (typeof value === "string") {
		    return value;
		  }
		  return JSON.stringify(value);
		}
		function getTruncatedJsonString(value) {
		  if (typeof value === "string") {
		    return messageTruncation.truncateGenAiStringInput(value);
		  }
		  if (Array.isArray(value)) {
		    const truncatedMessages = messageTruncation.truncateGenAiMessages(value);
		    return JSON.stringify(truncatedMessages);
		  }
		  return JSON.stringify(value);
		}
		function extractSystemInstructions(messages) {
		  if (!Array.isArray(messages)) {
		    return { systemInstructions: void 0, filteredMessages: messages };
		  }
		  const systemMessageIndex = messages.findIndex(
		    (msg) => msg && typeof msg === "object" && "role" in msg && msg.role === "system"
		  );
		  if (systemMessageIndex === -1) {
		    return { systemInstructions: void 0, filteredMessages: messages };
		  }
		  const systemMessage = messages[systemMessageIndex];
		  const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
		  if (!systemContent) {
		    return { systemInstructions: void 0, filteredMessages: messages };
		  }
		  const systemInstructions = JSON.stringify([{ type: "text", content: systemContent }]);
		  const filteredMessages = [...messages.slice(0, systemMessageIndex), ...messages.slice(systemMessageIndex + 1)];
		  return { systemInstructions, filteredMessages };
		}
		async function createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
		  const safeOriginalWithResponse = originalWithResponse.catch((error) => {
		    exports$1.captureException(error, {
		      mechanism: {
		        handled: false,
		        type: mechanismType
		      }
		    });
		    throw error;
		  });
		  const instrumentedResult = await instrumentedPromise;
		  const originalWrapper = await safeOriginalWithResponse;
		  if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) {
		    return {
		      ...originalWrapper,
		      data: instrumentedResult
		    };
		  }
		  return instrumentedResult;
		}
		function wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
		  if (!is.isThenable(originalPromiseLike)) {
		    return instrumentedPromise;
		  }
		  return new Proxy(originalPromiseLike, {
		    get(target, prop) {
		      const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
		      const source = useInstrumentedPromise ? instrumentedPromise : target;
		      const value = Reflect.get(source, prop);
		      if (prop === "withResponse" && typeof value === "function") {
		        return function wrappedWithResponse() {
		          const originalWithResponse = value.call(target);
		          return createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
		        };
		      }
		      return typeof value === "function" ? value.bind(source) : value;
		    }
		  });
		}

		exports.buildMethodPath = buildMethodPath;
		exports.endStreamSpan = endStreamSpan;
		exports.extractSystemInstructions = extractSystemInstructions;
		exports.getJsonString = getJsonString;
		exports.getTruncatedJsonString = getTruncatedJsonString;
		exports.resolveAIRecordingOptions = resolveAIRecordingOptions;
		exports.setTokenUsageAttributes = setTokenUsageAttributes;
		exports.shouldEnableTruncation = shouldEnableTruncation;
		exports.wrapPromiseWithMethods = wrapPromiseWithMethods;
		
	} (utils$e));
	return utils$e;
}

var constants$7 = {};

var hasRequiredConstants$7;

function requireConstants$7 () {
	if (hasRequiredConstants$7) return constants$7;
	hasRequiredConstants$7 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const toolCallSpanContextMap = /* @__PURE__ */ new Map();
		const toolDescriptionMap = /* @__PURE__ */ new Map();
		const SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
		  ["ai.generateText", "invoke_agent"],
		  ["ai.streamText", "invoke_agent"],
		  ["ai.generateObject", "invoke_agent"],
		  ["ai.streamObject", "invoke_agent"],
		  ["ai.generateText.doGenerate", "generate_content"],
		  ["ai.streamText.doStream", "generate_content"],
		  ["ai.generateObject.doGenerate", "generate_content"],
		  ["ai.streamObject.doStream", "generate_content"],
		  ["ai.embed.doEmbed", "embeddings"],
		  ["ai.embedMany.doEmbed", "embeddings"],
		  ["ai.rerank.doRerank", "rerank"],
		  ["ai.toolCall", "execute_tool"]
		]);

		exports.SPAN_TO_OPERATION_NAME = SPAN_TO_OPERATION_NAME;
		exports.toolCallSpanContextMap = toolCallSpanContextMap;
		exports.toolDescriptionMap = toolDescriptionMap;
		
	} (constants$7));
	return constants$7;
}

var utils$d = {};

var vercelAiAttributes = {};

var hasRequiredVercelAiAttributes;

function requireVercelAiAttributes () {
	if (hasRequiredVercelAiAttributes) return vercelAiAttributes;
	hasRequiredVercelAiAttributes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const OPERATION_NAME_ATTRIBUTE = "operation.name";
		const AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
		const AI_PROMPT_ATTRIBUTE = "ai.prompt";
		const AI_SCHEMA_ATTRIBUTE = "ai.schema";
		const AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
		const AI_VALUES_ATTRIBUTE = "ai.values";
		const AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
		const AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
		const AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
		const AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
		const AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
		const AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
		const AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
		const AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
		const AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
		const AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
		const AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
		const AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
		const AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
		const AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
		const AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
		const AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
		const AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";

		exports.AI_MODEL_ID_ATTRIBUTE = AI_MODEL_ID_ATTRIBUTE;
		exports.AI_OPERATION_ID_ATTRIBUTE = AI_OPERATION_ID_ATTRIBUTE;
		exports.AI_PROMPT_ATTRIBUTE = AI_PROMPT_ATTRIBUTE;
		exports.AI_PROMPT_MESSAGES_ATTRIBUTE = AI_PROMPT_MESSAGES_ATTRIBUTE;
		exports.AI_PROMPT_TOOLS_ATTRIBUTE = AI_PROMPT_TOOLS_ATTRIBUTE;
		exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
		exports.AI_RESPONSE_OBJECT_ATTRIBUTE = AI_RESPONSE_OBJECT_ATTRIBUTE;
		exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
		exports.AI_RESPONSE_TEXT_ATTRIBUTE = AI_RESPONSE_TEXT_ATTRIBUTE;
		exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
		exports.AI_SCHEMA_ATTRIBUTE = AI_SCHEMA_ATTRIBUTE;
		exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
		exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = AI_TOOL_CALL_ARGS_ATTRIBUTE;
		exports.AI_TOOL_CALL_ID_ATTRIBUTE = AI_TOOL_CALL_ID_ATTRIBUTE;
		exports.AI_TOOL_CALL_NAME_ATTRIBUTE = AI_TOOL_CALL_NAME_ATTRIBUTE;
		exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = AI_TOOL_CALL_RESULT_ATTRIBUTE;
		exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
		exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
		exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
		exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
		exports.AI_USAGE_TOKENS_ATTRIBUTE = AI_USAGE_TOKENS_ATTRIBUTE;
		exports.AI_VALUES_ATTRIBUTE = AI_VALUES_ATTRIBUTE;
		exports.OPERATION_NAME_ATTRIBUTE = OPERATION_NAME_ATTRIBUTE;
		
	} (vercelAiAttributes));
	return vercelAiAttributes;
}

var hasRequiredUtils$d;

function requireUtils$d () {
	if (hasRequiredUtils$d) return utils$d;
	hasRequiredUtils$d = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$7();
		const vercelAiAttributes = /*@__PURE__*/ requireVercelAiAttributes();

		function accumulateTokensForParent(span, tokenAccumulator) {
		  const parentSpanId = span.parent_span_id;
		  if (!parentSpanId) {
		    return;
		  }
		  const inputTokens = span.data[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
		  const outputTokens = span.data[genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
		  if (typeof inputTokens === "number" || typeof outputTokens === "number") {
		    const existing = tokenAccumulator.get(parentSpanId) || { inputTokens: 0, outputTokens: 0 };
		    if (typeof inputTokens === "number") {
		      existing.inputTokens += inputTokens;
		    }
		    if (typeof outputTokens === "number") {
		      existing.outputTokens += outputTokens;
		    }
		    tokenAccumulator.set(parentSpanId, existing);
		  }
		}
		function applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
		  const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
		  if (!accumulated || !spanOrTrace.data) {
		    return;
		  }
		  if (accumulated.inputTokens > 0) {
		    spanOrTrace.data[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
		  }
		  if (accumulated.outputTokens > 0) {
		    spanOrTrace.data[genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
		  }
		  if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) {
		    spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
		  }
		}
		function buildToolDescriptionMap(spans) {
		  const toolDescriptions = /* @__PURE__ */ new Map();
		  for (const span of spans) {
		    const availableTools = span.data[genAiAttributes.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
		    if (typeof availableTools !== "string") {
		      continue;
		    }
		    try {
		      const tools = JSON.parse(availableTools);
		      for (const tool of tools) {
		        if (tool.name && tool.description && !toolDescriptions.has(tool.name)) {
		          toolDescriptions.set(tool.name, tool.description);
		        }
		      }
		    } catch {
		    }
		  }
		  return toolDescriptions;
		}
		function applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
		  const toolDescriptions = buildToolDescriptionMap(spans);
		  for (const span of spans) {
		    if (span.op === "gen_ai.execute_tool") {
		      const toolName = span.data[genAiAttributes.GEN_AI_TOOL_NAME_ATTRIBUTE];
		      if (typeof toolName === "string") {
		        const description = toolDescriptions.get(toolName);
		        if (description) {
		          span.data[genAiAttributes.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
		        }
		      }
		    }
		    if (span.op === "gen_ai.invoke_agent") {
		      applyAccumulatedTokens(span, tokenAccumulator);
		    }
		  }
		}
		function _INTERNAL_getSpanContextForToolCallId(toolCallId) {
		  return constants.toolCallSpanContextMap.get(toolCallId);
		}
		function _INTERNAL_cleanupToolCallSpanContext(toolCallId) {
		  constants.toolCallSpanContextMap.delete(toolCallId);
		}
		function convertAvailableToolsToJsonString(tools) {
		  const toolObjects = tools.map((tool) => {
		    if (typeof tool === "string") {
		      try {
		        return JSON.parse(tool);
		      } catch {
		        return tool;
		      }
		    }
		    return tool;
		  });
		  return JSON.stringify(toolObjects);
		}
		function filterMessagesArray(input) {
		  return input.filter(
		    (m) => !!m && typeof m === "object" && "role" in m && "content" in m
		  );
		}
		function convertUserInputToMessagesFormat(userInput) {
		  try {
		    const p = JSON.parse(userInput);
		    if (!!p && typeof p === "object") {
		      let { messages } = p;
		      const { prompt, system } = p;
		      const result = [];
		      if (typeof system === "string") {
		        result.push({ role: "system", content: system });
		      }
		      if (typeof messages === "string") {
		        try {
		          messages = JSON.parse(messages);
		        } catch {
		        }
		      }
		      if (Array.isArray(messages)) {
		        result.push(...filterMessagesArray(messages));
		        return result;
		      }
		      if (Array.isArray(prompt)) {
		        result.push(...filterMessagesArray(prompt));
		        return result;
		      }
		      if (typeof prompt === "string") {
		        result.push({ role: "user", content: prompt });
		      }
		      if (result.length > 0) {
		        return result;
		      }
		    }
		  } catch {
		  }
		  return [];
		}
		function requestMessagesFromPrompt(span, attributes, enableTruncation) {
		  if (typeof attributes[vercelAiAttributes.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[vercelAiAttributes.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
		    const userInput = attributes[vercelAiAttributes.AI_PROMPT_ATTRIBUTE];
		    const messages = convertUserInputToMessagesFormat(userInput);
		    if (messages.length) {
		      const { systemInstructions, filteredMessages } = utils.extractSystemInstructions(messages);
		      if (systemInstructions) {
		        span.setAttribute(genAiAttributes.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
		      }
		      const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
		      const messagesJson = enableTruncation ? utils.getTruncatedJsonString(filteredMessages) : utils.getJsonString(filteredMessages);
		      span.setAttributes({
		        [vercelAiAttributes.AI_PROMPT_ATTRIBUTE]: messagesJson,
		        [genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
		        [genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
		      });
		    }
		  } else if (typeof attributes[vercelAiAttributes.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
		    const originalMessagesJson = attributes[vercelAiAttributes.AI_PROMPT_MESSAGES_ATTRIBUTE];
		    try {
		      const messages = JSON.parse(originalMessagesJson);
		      if (Array.isArray(messages)) {
		        const { systemInstructions, filteredMessages } = utils.extractSystemInstructions(messages);
		        if (systemInstructions) {
		          span.setAttribute(genAiAttributes.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
		        }
		        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
		        const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? utils.getTruncatedJsonString(filteredMessages) : utils.getJsonString(filteredMessages);
		        span.setAttributes({
		          [vercelAiAttributes.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
		          [genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
		          [genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
		        });
		      }
		    } catch {
		    }
		  }
		}

		exports._INTERNAL_cleanupToolCallSpanContext = _INTERNAL_cleanupToolCallSpanContext;
		exports._INTERNAL_getSpanContextForToolCallId = _INTERNAL_getSpanContextForToolCallId;
		exports.accumulateTokensForParent = accumulateTokensForParent;
		exports.applyAccumulatedTokens = applyAccumulatedTokens;
		exports.applyToolDescriptionsAndTokens = applyToolDescriptionsAndTokens;
		exports.convertAvailableToolsToJsonString = convertAvailableToolsToJsonString;
		exports.convertUserInputToMessagesFormat = convertUserInputToMessagesFormat;
		exports.requestMessagesFromPrompt = requestMessagesFromPrompt;
		
	} (utils$d));
	return utils$d;
}

var hasRequiredVercelAi;

function requireVercelAi () {
	if (hasRequiredVercelAi) return vercelAi;
	hasRequiredVercelAi = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const constants = /*@__PURE__*/ requireConstants$7();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const utils$1 = /*@__PURE__*/ requireUtils$d();
		const vercelAiAttributes = /*@__PURE__*/ requireVercelAiAttributes();

		function onVercelAiSpanStart(span) {
		  const { data: attributes, description: name } = spanUtils.spanToJSON(span);
		  if (!name) {
		    return;
		  }
		  if (attributes[vercelAiAttributes.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[vercelAiAttributes.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
		    processToolCallSpan(span, attributes);
		    return;
		  }
		  if (!attributes[vercelAiAttributes.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) {
		    return;
		  }
		  const client = currentScopes.getClient();
		  const integration = client?.getIntegrationByName("VercelAI");
		  const enableTruncation = utils.shouldEnableTruncation(integration?.options?.enableTruncation);
		  processGenerateSpan(span, name, attributes, enableTruncation);
		}
		function vercelAiEventProcessor(event) {
		  if (event.type === "transaction" && event.spans) {
		    const tokenAccumulator = /* @__PURE__ */ new Map();
		    for (const span of event.spans) {
		      processEndedVercelAiSpan(span);
		      utils$1.accumulateTokensForParent(span, tokenAccumulator);
		    }
		    utils$1.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
		    const trace = event.contexts?.trace;
		    if (trace?.op === "gen_ai.invoke_agent") {
		      utils$1.applyAccumulatedTokens(trace, tokenAccumulator);
		    }
		  }
		  return event;
		}
		function normalizeFinishReason(finishReason) {
		  if (typeof finishReason !== "string") {
		    return "stop";
		  }
		  switch (finishReason) {
		    case "tool-calls":
		      return "tool_call";
		    case "stop":
		    case "length":
		    case "content_filter":
		    case "error":
		      return finishReason;
		    default:
		      return finishReason;
		  }
		}
		function buildOutputMessages(attributes) {
		  const responseText = attributes[vercelAiAttributes.AI_RESPONSE_TEXT_ATTRIBUTE];
		  const responseToolCalls = attributes[vercelAiAttributes.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
		  const finishReason = attributes[vercelAiAttributes.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
		  if (responseText == null && responseToolCalls == null) {
		    return;
		  }
		  const parts = [];
		  if (typeof responseText === "string" && responseText.length > 0) {
		    parts.push({
		      type: "text",
		      content: responseText
		    });
		  }
		  if (responseToolCalls != null) {
		    try {
		      const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
		      if (Array.isArray(toolCalls)) {
		        for (const toolCall of toolCalls) {
		          const args = toolCall.input ?? toolCall.args;
		          parts.push({
		            type: "tool_call",
		            id: toolCall.toolCallId,
		            name: toolCall.toolName,
		            // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
		            // which would cause the property to be omitted from the final JSON output
		            arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
		          });
		        }
		        delete attributes[vercelAiAttributes.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
		      }
		    } catch {
		    }
		  }
		  if (parts.length > 0) {
		    const outputMessage = {
		      role: "assistant",
		      parts,
		      finish_reason: normalizeFinishReason(finishReason)
		    };
		    attributes[genAiAttributes.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([outputMessage]);
		    delete attributes[vercelAiAttributes.AI_RESPONSE_TEXT_ATTRIBUTE];
		  }
		}
		function processVercelAiSpanAttributes(attributes) {
		  renameAttributeKey(attributes, vercelAiAttributes.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
		  renameAttributeKey(attributes, vercelAiAttributes.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
		  renameAttributeKey(attributes, vercelAiAttributes.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
		  renameAttributeKey(attributes, "ai.usage.inputTokens", genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
		  renameAttributeKey(attributes, "ai.usage.outputTokens", genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
		  renameAttributeKey(attributes, vercelAiAttributes.AI_USAGE_TOKENS_ATTRIBUTE, genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
		  renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
		  const inputTokensAreCacheInclusive = Object.keys(attributes).some(
		    (key) => key.startsWith(vercelAiAttributes.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX)
		  );
		  if (!inputTokensAreCacheInclusive && typeof attributes[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") {
		    attributes[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
		  }
		  if (typeof attributes[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
		    const outputTokens = typeof attributes[genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
		    attributes[genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
		  }
		  if (attributes[vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE])) {
		    attributes[vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE] = utils$1.convertAvailableToolsToJsonString(
		      attributes[vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE]
		    );
		  }
		  if (attributes[vercelAiAttributes.OPERATION_NAME_ATTRIBUTE]) {
		    const rawOperationName = attributes[vercelAiAttributes.AI_OPERATION_ID_ATTRIBUTE] ? attributes[vercelAiAttributes.AI_OPERATION_ID_ATTRIBUTE] : attributes[vercelAiAttributes.OPERATION_NAME_ATTRIBUTE];
		    const operationName = constants.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
		    attributes[genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
		    delete attributes[vercelAiAttributes.OPERATION_NAME_ATTRIBUTE];
		  }
		  renameAttributeKey(attributes, vercelAiAttributes.AI_PROMPT_MESSAGES_ATTRIBUTE, genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
		  buildOutputMessages(attributes);
		  renameAttributeKey(attributes, vercelAiAttributes.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
		  renameAttributeKey(attributes, vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
		  renameAttributeKey(attributes, vercelAiAttributes.AI_TOOL_CALL_ARGS_ATTRIBUTE, genAiAttributes.GEN_AI_TOOL_INPUT_ATTRIBUTE);
		  renameAttributeKey(attributes, vercelAiAttributes.AI_TOOL_CALL_RESULT_ATTRIBUTE, genAiAttributes.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
		  renameAttributeKey(attributes, vercelAiAttributes.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
		  renameAttributeKey(attributes, vercelAiAttributes.AI_MODEL_ID_ATTRIBUTE, genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
		  if (Array.isArray(attributes[vercelAiAttributes.AI_VALUES_ATTRIBUTE])) {
		    const parsed = attributes[vercelAiAttributes.AI_VALUES_ATTRIBUTE].map((v) => {
		      try {
		        return JSON.parse(v);
		      } catch {
		        return v;
		      }
		    });
		    attributes[genAiAttributes.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
		  }
		  addProviderMetadataToAttributes(attributes);
		  for (const key of Object.keys(attributes)) {
		    if (Array.isArray(attributes[key])) {
		      attributes[key] = JSON.stringify(attributes[key]);
		    }
		    if (key.startsWith("ai.")) {
		      renameAttributeKey(attributes, key, `vercel.${key}`);
		    }
		  }
		}
		function processEndedVercelAiSpan(span) {
		  const { data: attributes, origin } = span;
		  if (origin !== "auto.vercelai.otel") {
		    return;
		  }
		  if (span.status && span.status !== "ok") {
		    span.status = "internal_error";
		  }
		  processVercelAiSpanAttributes(attributes);
		}
		function processVercelAiStreamedSpan(span) {
		  const attributes = span.attributes;
		  if (attributes?.[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") {
		    return;
		  }
		  processVercelAiSpanAttributes(attributes);
		  if (attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
		    const descriptions = constants.toolDescriptionMap.get(span.parent_span_id);
		    if (descriptions) {
		      const toolName = attributes[genAiAttributes.GEN_AI_TOOL_NAME_ATTRIBUTE];
		      if (typeof toolName === "string") {
		        const desc = descriptions.get(toolName);
		        if (desc) {
		          attributes[genAiAttributes.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
		        }
		      }
		    }
		  }
		  constants.toolDescriptionMap.delete(span.span_id);
		}
		function renameAttributeKey(attributes, oldKey, newKey) {
		  if (attributes[oldKey] != null) {
		    attributes[newKey] = attributes[oldKey];
		    delete attributes[oldKey];
		  }
		}
		function processToolCallSpan(span, attributes) {
		  span.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
		  span.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
		  span.setAttribute(genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
		  renameAttributeKey(attributes, vercelAiAttributes.AI_TOOL_CALL_NAME_ATTRIBUTE, genAiAttributes.GEN_AI_TOOL_NAME_ATTRIBUTE);
		  renameAttributeKey(attributes, vercelAiAttributes.AI_TOOL_CALL_ID_ATTRIBUTE, genAiAttributes.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
		  const toolCallId = attributes[genAiAttributes.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
		  if (typeof toolCallId === "string") {
		    constants.toolCallSpanContextMap.set(toolCallId, span.spanContext());
		  }
		  if (!attributes[genAiAttributes.GEN_AI_TOOL_TYPE_ATTRIBUTE]) {
		    span.setAttribute(genAiAttributes.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
		  }
		  const toolName = attributes[genAiAttributes.GEN_AI_TOOL_NAME_ATTRIBUTE];
		  if (toolName) {
		    span.updateName(`execute_tool ${toolName}`);
		  }
		}
		function processGenerateSpan(span, name, attributes, enableTruncation) {
		  span.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
		  const nameWthoutAi = name.replace("ai.", "");
		  span.setAttribute("ai.pipeline.name", nameWthoutAi);
		  span.updateName(nameWthoutAi);
		  const functionId = attributes[vercelAiAttributes.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
		  if (functionId && typeof functionId === "string") {
		    span.setAttribute("gen_ai.function_id", functionId);
		  }
		  utils$1.requestMessagesFromPrompt(span, attributes, enableTruncation);
		  if (attributes[vercelAiAttributes.AI_MODEL_ID_ATTRIBUTE] && !attributes[genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) {
		    span.setAttribute(genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[vercelAiAttributes.AI_MODEL_ID_ATTRIBUTE]);
		  }
		  span.setAttribute("ai.streaming", name.includes("stream"));
		  const operationName = constants.SPAN_TO_OPERATION_NAME.get(name);
		  if (operationName) {
		    span.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
		  } else if (name.startsWith("ai.stream")) {
		    span.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
		  }
		  if (operationName === "invoke_agent") {
		    if (functionId && typeof functionId === "string") {
		      span.updateName(`invoke_agent ${functionId}`);
		    } else {
		      span.updateName("invoke_agent");
		    }
		    return;
		  }
		  const modelId = attributes[vercelAiAttributes.AI_MODEL_ID_ATTRIBUTE];
		  if (modelId && operationName) {
		    span.updateName(`${operationName} ${modelId}`);
		  }
		  const client = currentScopes.getClient();
		  if (client && hasSpanStreamingEnabled.hasSpanStreamingEnabled(client) && attributes[vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE])) {
		    const descriptions = /* @__PURE__ */ new Map();
		    for (const toolStr of attributes[vercelAiAttributes.AI_PROMPT_TOOLS_ATTRIBUTE]) {
		      try {
		        const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
		        if (parsed?.name && parsed?.description) {
		          descriptions.set(parsed.name, parsed.description);
		        }
		      } catch {
		      }
		    }
		    if (descriptions.size > 0) {
		      const parentSpanId = spanUtils.spanToJSON(span).parent_span_id;
		      if (parentSpanId) {
		        constants.toolDescriptionMap.set(parentSpanId, descriptions);
		      }
		    }
		  }
		}
		function addVercelAiProcessors(client) {
		  client.on("spanStart", onVercelAiSpanStart);
		  client.addEventProcessor(Object.assign(vercelAiEventProcessor, { id: "VercelAiEventProcessor" }));
		  client.on("processSpan", (span) => {
		    processVercelAiStreamedSpan(span);
		  });
		}
		function addProviderMetadataToAttributes(attributes) {
		  const providerMetadata = attributes[vercelAiAttributes.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
		  if (providerMetadata) {
		    try {
		      const providerMetadataObject = JSON.parse(providerMetadata);
		      const openaiMetadata = providerMetadataObject.openai ?? providerMetadataObject.azure;
		      if (openaiMetadata) {
		        setAttributeIfDefined(
		          attributes,
		          genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE,
		          openaiMetadata.cachedPromptTokens
		        );
		        setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
		        setAttributeIfDefined(
		          attributes,
		          "gen_ai.usage.output_tokens.prediction_accepted",
		          openaiMetadata.acceptedPredictionTokens
		        );
		        setAttributeIfDefined(
		          attributes,
		          "gen_ai.usage.output_tokens.prediction_rejected",
		          openaiMetadata.rejectedPredictionTokens
		        );
		        if (!attributes["gen_ai.conversation.id"]) {
		          setAttributeIfDefined(attributes, "gen_ai.conversation.id", openaiMetadata.responseId);
		        }
		      }
		      if (providerMetadataObject.anthropic) {
		        const cachedInputTokens = providerMetadataObject.anthropic.usage?.cache_read_input_tokens ?? providerMetadataObject.anthropic.cacheReadInputTokens;
		        setAttributeIfDefined(attributes, genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
		        const cacheWriteInputTokens = providerMetadataObject.anthropic.usage?.cache_creation_input_tokens ?? providerMetadataObject.anthropic.cacheCreationInputTokens;
		        setAttributeIfDefined(attributes, genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
		      }
		      if (providerMetadataObject.bedrock?.usage) {
		        setAttributeIfDefined(
		          attributes,
		          genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE,
		          providerMetadataObject.bedrock.usage.cacheReadInputTokens
		        );
		        setAttributeIfDefined(
		          attributes,
		          genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE,
		          providerMetadataObject.bedrock.usage.cacheWriteInputTokens
		        );
		      }
		      if (providerMetadataObject.deepseek) {
		        setAttributeIfDefined(
		          attributes,
		          genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE,
		          providerMetadataObject.deepseek.promptCacheHitTokens
		        );
		        setAttributeIfDefined(
		          attributes,
		          "gen_ai.usage.input_tokens.cache_miss",
		          providerMetadataObject.deepseek.promptCacheMissTokens
		        );
		      }
		    } catch {
		    }
		  }
		}
		function setAttributeIfDefined(attributes, key, value) {
		  if (value != null) {
		    attributes[key] = value;
		  }
		}

		exports.addVercelAiProcessors = addVercelAiProcessors;
		exports.processVercelAiSpanAttributes = processVercelAiSpanAttributes;
		
	} (vercelAi));
	return vercelAi;
}

var openai = {};

var constants$6 = {};

var hasRequiredConstants$6;

function requireConstants$6 () {
	if (hasRequiredConstants$6) return constants$6;
	hasRequiredConstants$6 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const OPENAI_INTEGRATION_NAME = "OpenAI";
		const OPENAI_METHOD_REGISTRY = {
		  "responses.create": { operation: "chat" },
		  "chat.completions.create": { operation: "chat" },
		  "embeddings.create": { operation: "embeddings" },
		  // Conversations API - for conversation state management
		  // https://platform.openai.com/docs/guides/conversation-state
		  "conversations.create": { operation: "chat" }
		};
		const RESPONSES_TOOL_CALL_EVENT_TYPES = [
		  "response.output_item.added",
		  "response.function_call_arguments.delta",
		  "response.function_call_arguments.done",
		  "response.output_item.done"
		];
		const RESPONSE_EVENT_TYPES = [
		  "response.created",
		  "response.in_progress",
		  "response.failed",
		  "response.completed",
		  "response.incomplete",
		  "response.queued",
		  "response.output_text.delta",
		  ...RESPONSES_TOOL_CALL_EVENT_TYPES
		];

		exports.OPENAI_INTEGRATION_NAME = OPENAI_INTEGRATION_NAME;
		exports.OPENAI_METHOD_REGISTRY = OPENAI_METHOD_REGISTRY;
		exports.RESPONSES_TOOL_CALL_EVENT_TYPES = RESPONSES_TOOL_CALL_EVENT_TYPES;
		exports.RESPONSE_EVENT_TYPES = RESPONSE_EVENT_TYPES;
		
	} (constants$6));
	return constants$6;
}

var streaming$2 = {};

var utils$c = {};

var hasRequiredUtils$c;

function requireUtils$c () {
	if (hasRequiredUtils$c) return utils$c;
	hasRequiredUtils$c = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();

		function isResponsesApiStreamEvent(event) {
		  return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
		}
		function isChatCompletionChunk(event) {
		  return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
		}
		function addResponseAttributes(span, result, recordOutputs) {
		  if (!result || typeof result !== "object") return;
		  const response = result;
		  const attrs = {};
		  if (typeof response.id === "string") {
		    attrs[genAiAttributes.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
		  }
		  if (typeof response.model === "string") {
		    attrs[genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
		  }
		  if (response.object === "conversation" && typeof response.id === "string") {
		    attrs[genAiAttributes.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
		  }
		  if (response.usage && typeof response.usage === "object") {
		    const usage = response.usage;
		    const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
		    if (typeof inputTokens === "number") {
		      attrs[genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
		    }
		    const outputTokens = usage.completion_tokens ?? usage.output_tokens;
		    if (typeof outputTokens === "number") {
		      attrs[genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
		    }
		    if (typeof usage.total_tokens === "number") {
		      attrs[genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
		    }
		  }
		  if (Array.isArray(response.choices)) {
		    const choices = response.choices;
		    const finishReasons = choices.map((choice) => choice.finish_reason).filter((reason) => typeof reason === "string");
		    if (finishReasons.length > 0) {
		      attrs[genAiAttributes.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
		    }
		    if (recordOutputs) {
		      const responseTexts = choices.map((choice) => {
		        const message = choice.message;
		        return message?.content || "";
		      });
		      attrs[genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
		      const toolCalls = choices.map((choice) => {
		        const message = choice.message;
		        return message?.tool_calls;
		      }).filter((calls) => Array.isArray(calls) && calls.length > 0).flat();
		      if (toolCalls.length > 0) {
		        attrs[genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
		      }
		    }
		  }
		  if (typeof response.status === "string") {
		    if (!attrs[genAiAttributes.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) {
		      attrs[genAiAttributes.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([response.status]);
		    }
		  }
		  if (recordOutputs) {
		    if (typeof response.output_text === "string" && !attrs[genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) {
		      attrs[genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
		    }
		    if (Array.isArray(response.output) && response.output.length > 0 && !attrs[genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
		      const functionCalls = response.output.filter(
		        (item) => item?.type === "function_call"
		      );
		      if (functionCalls.length > 0) {
		        attrs[genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
		      }
		    }
		  }
		  span.setAttributes(attrs);
		}
		function extractConversationId(params) {
		  if ("conversation" in params && typeof params.conversation === "string") {
		    return params.conversation;
		  }
		  if ("previous_response_id" in params && typeof params.previous_response_id === "string") {
		    return params.previous_response_id;
		  }
		  return void 0;
		}
		function extractRequestParameters(params) {
		  const attributes = {
		    [genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
		  };
		  if ("temperature" in params) attributes[genAiAttributes.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
		  if ("top_p" in params) attributes[genAiAttributes.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
		  if ("frequency_penalty" in params) attributes[genAiAttributes.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
		  if ("presence_penalty" in params) attributes[genAiAttributes.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
		  if ("stream" in params) attributes[genAiAttributes.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
		  if ("encoding_format" in params) attributes[genAiAttributes.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
		  if ("dimensions" in params) attributes[genAiAttributes.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
		  const conversationId = extractConversationId(params);
		  if (conversationId) {
		    attributes[genAiAttributes.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
		  }
		  return attributes;
		}

		exports.addResponseAttributes = addResponseAttributes;
		exports.extractRequestParameters = extractRequestParameters;
		exports.isChatCompletionChunk = isChatCompletionChunk;
		exports.isResponsesApiStreamEvent = isResponsesApiStreamEvent;
		
	} (utils$c));
	return utils$c;
}

var hasRequiredStreaming$2;

function requireStreaming$2 () {
	if (hasRequiredStreaming$2) return streaming$2;
	hasRequiredStreaming$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const utils$1 = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$6();
		const utils = /*@__PURE__*/ requireUtils$c();

		function processChatCompletionToolCalls(toolCalls, state) {
		  for (const toolCall of toolCalls) {
		    const index = toolCall.index;
		    if (index === void 0 || !toolCall.function) continue;
		    if (!(index in state.chatCompletionToolCalls)) {
		      state.chatCompletionToolCalls[index] = {
		        ...toolCall,
		        function: {
		          name: toolCall.function.name,
		          arguments: toolCall.function.arguments || ""
		        }
		      };
		    } else {
		      const existingToolCall = state.chatCompletionToolCalls[index];
		      if (toolCall.function.arguments && existingToolCall?.function) {
		        existingToolCall.function.arguments += toolCall.function.arguments;
		      }
		    }
		  }
		}
		function processChatCompletionChunk(chunk, state, recordOutputs) {
		  state.responseId = chunk.id ?? state.responseId;
		  state.responseModel = chunk.model ?? state.responseModel;
		  if (chunk.usage) {
		    state.promptTokens = chunk.usage.prompt_tokens;
		    state.completionTokens = chunk.usage.completion_tokens;
		    state.totalTokens = chunk.usage.total_tokens;
		  }
		  for (const choice of chunk.choices ?? []) {
		    if (recordOutputs) {
		      if (choice.delta?.content) {
		        state.responseTexts.push(choice.delta.content);
		      }
		      if (choice.delta?.tool_calls) {
		        processChatCompletionToolCalls(choice.delta.tool_calls, state);
		      }
		    }
		    if (choice.finish_reason) {
		      state.finishReasons.push(choice.finish_reason);
		    }
		  }
		}
		function processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
		  if (!(streamEvent && typeof streamEvent === "object")) {
		    state.eventTypes.push("unknown:non-object");
		    return;
		  }
		  if (streamEvent instanceof Error) {
		    span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		    exports$1.captureException(streamEvent, {
		      mechanism: {
		        handled: false,
		        type: "auto.ai.openai.stream-response"
		      }
		    });
		    return;
		  }
		  if (!("type" in streamEvent)) return;
		  const event = streamEvent;
		  if (!constants.RESPONSE_EVENT_TYPES.includes(event.type)) {
		    state.eventTypes.push(event.type);
		    return;
		  }
		  if (recordOutputs) {
		    if (event.type === "response.output_item.done" && "item" in event) {
		      state.responsesApiToolCalls.push(event.item);
		    }
		    if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
		      state.responseTexts.push(event.delta);
		      return;
		    }
		  }
		  if ("response" in event) {
		    const { response } = event;
		    state.responseId = response.id ?? state.responseId;
		    state.responseModel = response.model ?? state.responseModel;
		    if (response.usage) {
		      state.promptTokens = response.usage.input_tokens;
		      state.completionTokens = response.usage.output_tokens;
		      state.totalTokens = response.usage.total_tokens;
		    }
		    if (response.status) {
		      state.finishReasons.push(response.status);
		    }
		    if (recordOutputs && response.output_text) {
		      state.responseTexts.push(response.output_text);
		    }
		  }
		}
		async function* instrumentStream(stream, span, recordOutputs) {
		  const state = {
		    eventTypes: [],
		    responseTexts: [],
		    finishReasons: [],
		    responseId: "",
		    responseModel: "",
		    promptTokens: void 0,
		    completionTokens: void 0,
		    totalTokens: void 0,
		    chatCompletionToolCalls: {},
		    responsesApiToolCalls: []
		  };
		  try {
		    for await (const event of stream) {
		      if (utils.isChatCompletionChunk(event)) {
		        processChatCompletionChunk(event, state, recordOutputs);
		      } else if (utils.isResponsesApiStreamEvent(event)) {
		        processResponsesApiEvent(event, state, recordOutputs, span);
		      }
		      yield event;
		    }
		  } finally {
		    const allToolCalls = [...Object.values(state.chatCompletionToolCalls), ...state.responsesApiToolCalls];
		    utils$1.endStreamSpan(span, { ...state, toolCalls: allToolCalls }, recordOutputs);
		  }
		}

		exports.instrumentStream = instrumentStream;
		
	} (streaming$2));
	return streaming$2;
}

var hasRequiredOpenai;

function requireOpenai () {
	if (hasRequiredOpenai) return openai;
	hasRequiredOpenai = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$6();
		const streaming = /*@__PURE__*/ requireStreaming$2();
		const utils$1 = /*@__PURE__*/ requireUtils$c();

		function extractAvailableTools(params) {
		  const tools = Array.isArray(params.tools) ? params.tools : [];
		  const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
		  const webSearchOptions = hasWebSearchOptions ? [{ type: "web_search_options", ...params.web_search_options }] : [];
		  const availableTools = [...tools, ...webSearchOptions];
		  if (availableTools.length === 0) {
		    return void 0;
		  }
		  try {
		    return JSON.stringify(availableTools);
		  } catch (error) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error("Failed to serialize OpenAI tools:", error);
		    return void 0;
		  }
		}
		function extractRequestAttributes(args, operationName) {
		  const attributes = {
		    [genAiAttributes.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
		    [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
		  };
		  if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
		    const params = args[0];
		    const availableTools = extractAvailableTools(params);
		    if (availableTools) {
		      attributes[genAiAttributes.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
		    }
		    Object.assign(attributes, utils$1.extractRequestParameters(params));
		  } else {
		    attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
		  }
		  return attributes;
		}
		function addRequestAttributes(span, params, operationName, enableTruncation) {
		  if (operationName === "embeddings" && "input" in params) {
		    const input = params.input;
		    if (input == null) {
		      return;
		    }
		    if (typeof input === "string" && input.length === 0) {
		      return;
		    }
		    if (Array.isArray(input) && input.length === 0) {
		      return;
		    }
		    span.setAttribute(genAiAttributes.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
		    return;
		  }
		  const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
		  if (!src) {
		    return;
		  }
		  if (Array.isArray(src) && src.length === 0) {
		    return;
		  }
		  const { systemInstructions, filteredMessages } = utils.extractSystemInstructions(src);
		  if (systemInstructions) {
		    span.setAttribute(genAiAttributes.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
		  }
		  span.setAttribute(
		    genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE,
		    enableTruncation ? utils.getTruncatedJsonString(filteredMessages) : utils.getJsonString(filteredMessages)
		  );
		  if (Array.isArray(filteredMessages)) {
		    span.setAttribute(genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
		  } else {
		    span.setAttribute(genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
		  }
		}
		function instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
		  return function instrumentedCall(...args) {
		    const operationName = instrumentedMethod.operation || "unknown";
		    const requestAttributes = extractRequestAttributes(args, operationName);
		    const model = requestAttributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
		    const params = args[0];
		    const isStreamRequested = params && typeof params === "object" && params.stream === true;
		    const spanConfig = {
		      name: `${operationName} ${model}`,
		      op: `gen_ai.${operationName}`,
		      attributes: requestAttributes
		    };
		    if (isStreamRequested) {
		      let originalResult2;
		      const instrumentedPromise2 = trace.startSpanManual(spanConfig, (span) => {
		        originalResult2 = originalMethod.apply(context, args);
		        if (options.recordInputs && params) {
		          addRequestAttributes(span, params, operationName, utils.shouldEnableTruncation(options.enableTruncation));
		        }
		        return (async () => {
		          try {
		            const result = await originalResult2;
		            return streaming.instrumentStream(
		              result,
		              span,
		              options.recordOutputs ?? false
		            );
		          } catch (error) {
		            span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		            exports$1.captureException(error, {
		              mechanism: {
		                handled: false,
		                type: "auto.ai.openai.stream",
		                data: { function: methodPath }
		              }
		            });
		            span.end();
		            throw error;
		          }
		        })();
		      });
		      return utils.wrapPromiseWithMethods(originalResult2, instrumentedPromise2, "auto.ai.openai");
		    }
		    let originalResult;
		    const instrumentedPromise = trace.startSpan(spanConfig, (span) => {
		      originalResult = originalMethod.apply(context, args);
		      if (options.recordInputs && params) {
		        addRequestAttributes(span, params, operationName, utils.shouldEnableTruncation(options.enableTruncation));
		      }
		      return originalResult.then(
		        (result) => {
		          utils$1.addResponseAttributes(span, result, options.recordOutputs);
		          return result;
		        },
		        (error) => {
		          exports$1.captureException(error, {
		            mechanism: {
		              handled: false,
		              type: "auto.ai.openai",
		              data: { function: methodPath }
		            }
		          });
		          throw error;
		        }
		      );
		    });
		    return utils.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.openai");
		  };
		}
		function createDeepProxy(target, currentPath = "", options) {
		  return new Proxy(target, {
		    get(obj, prop) {
		      const value = obj[prop];
		      const methodPath = utils.buildMethodPath(currentPath, String(prop));
		      const instrumentedMethod = constants.OPENAI_METHOD_REGISTRY[methodPath];
		      if (typeof value === "function" && instrumentedMethod) {
		        return instrumentMethod(
		          value,
		          methodPath,
		          instrumentedMethod,
		          obj,
		          options
		        );
		      }
		      if (typeof value === "function") {
		        return value.bind(obj);
		      }
		      if (value && typeof value === "object") {
		        return createDeepProxy(value, methodPath, options);
		      }
		      return value;
		    }
		  });
		}
		function instrumentOpenAiClient(client, options) {
		  return createDeepProxy(client, "", utils.resolveAIRecordingOptions(options));
		}

		exports.instrumentOpenAiClient = instrumentOpenAiClient;
		
	} (openai));
	return openai;
}

var anthropicAi = {};

var constants$5 = {};

var hasRequiredConstants$5;

function requireConstants$5 () {
	if (hasRequiredConstants$5) return constants$5;
	hasRequiredConstants$5 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
		const ANTHROPIC_METHOD_REGISTRY = {
		  "messages.create": { operation: "chat" },
		  "messages.stream": { operation: "chat", streaming: true },
		  "messages.countTokens": { operation: "chat" },
		  "models.get": { operation: "models" },
		  "completions.create": { operation: "chat" },
		  "models.retrieve": { operation: "models" },
		  "beta.messages.create": { operation: "chat" }
		};

		exports.ANTHROPIC_AI_INTEGRATION_NAME = ANTHROPIC_AI_INTEGRATION_NAME;
		exports.ANTHROPIC_METHOD_REGISTRY = ANTHROPIC_METHOD_REGISTRY;
		
	} (constants$5));
	return constants$5;
}

var streaming$1 = {};

var utils$b = {};

var hasRequiredUtils$b;

function requireUtils$b () {
	if (hasRequiredUtils$b) return utils$b;
	hasRequiredUtils$b = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();

		function setMessagesAttribute(span, messages, enableTruncation) {
		  if (Array.isArray(messages) && messages.length === 0) {
		    return;
		  }
		  const { systemInstructions, filteredMessages } = utils.extractSystemInstructions(messages);
		  if (systemInstructions) {
		    span.setAttributes({
		      [genAiAttributes.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
		    });
		  }
		  const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
		  span.setAttributes({
		    [genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? utils.getTruncatedJsonString(filteredMessages) : utils.getJsonString(filteredMessages),
		    [genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
		  });
		}
		const ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
		  invalid_request_error: "invalid_argument",
		  authentication_error: "unauthenticated",
		  permission_error: "permission_denied",
		  not_found_error: "not_found",
		  request_too_large: "failed_precondition",
		  rate_limit_error: "resource_exhausted",
		  api_error: "internal_error",
		  overloaded_error: "unavailable"
		};
		function mapAnthropicErrorToStatusMessage(errorType) {
		  if (!errorType) {
		    return "internal_error";
		  }
		  return ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
		}
		function handleResponseError(span, response) {
		  if (response.error) {
		    span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: mapAnthropicErrorToStatusMessage(response.error.type) });
		    exports$1.captureException(response.error, {
		      mechanism: {
		        handled: false,
		        type: "auto.ai.anthropic.anthropic_error"
		      }
		    });
		  }
		}
		function messagesFromParams(params) {
		  const { system, messages, input } = params;
		  const systemMessages = typeof system === "string" ? [{ role: "system", content: params.system }] : [];
		  const inputParamMessages = Array.isArray(input) ? input : input != null ? [input] : void 0;
		  const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [messages] : [];
		  const userMessages = inputParamMessages ?? messagesParamMessages;
		  return [...systemMessages, ...userMessages];
		}

		exports.handleResponseError = handleResponseError;
		exports.mapAnthropicErrorToStatusMessage = mapAnthropicErrorToStatusMessage;
		exports.messagesFromParams = messagesFromParams;
		exports.setMessagesAttribute = setMessagesAttribute;
		
	} (utils$b));
	return utils$b;
}

var hasRequiredStreaming$1;

function requireStreaming$1 () {
	if (hasRequiredStreaming$1) return streaming$1;
	hasRequiredStreaming$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const utils = /*@__PURE__*/ requireUtils$e();
		const utils$1 = /*@__PURE__*/ requireUtils$b();

		function isErrorEvent(event, span) {
		  if ("type" in event && typeof event.type === "string") {
		    if (event.type === "error") {
		      span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: utils$1.mapAnthropicErrorToStatusMessage(event.error?.type) });
		      exports$1.captureException(event.error, {
		        mechanism: {
		          handled: false,
		          type: "auto.ai.anthropic.anthropic_error"
		        }
		      });
		      return true;
		    }
		  }
		  return false;
		}
		function handleMessageMetadata(event, state) {
		  if (event.type === "message_delta" && event.usage) {
		    if ("output_tokens" in event.usage && typeof event.usage.output_tokens === "number") {
		      state.completionTokens = event.usage.output_tokens;
		    }
		  }
		  if (event.message) {
		    const message = event.message;
		    if (message.id) state.responseId = message.id;
		    if (message.model) state.responseModel = message.model;
		    if (message.stop_reason) state.finishReasons.push(message.stop_reason);
		    if (message.usage) {
		      if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
		      if (typeof message.usage.cache_creation_input_tokens === "number")
		        state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
		      if (typeof message.usage.cache_read_input_tokens === "number")
		        state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
		    }
		  }
		}
		function handleContentBlockStart(event, state) {
		  if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
		  if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") {
		    state.activeToolBlocks[event.index] = {
		      id: event.content_block.id,
		      name: event.content_block.name,
		      inputJsonParts: []
		    };
		  }
		}
		function handleContentBlockDelta(event, state, recordOutputs) {
		  if (event.type !== "content_block_delta" || !event.delta) return;
		  if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
		    const active = state.activeToolBlocks[event.index];
		    if (active) {
		      active.inputJsonParts.push(event.delta.partial_json);
		    }
		  }
		  if (recordOutputs && typeof event.delta.text === "string") {
		    state.responseTexts.push(event.delta.text);
		  }
		}
		function handleContentBlockStop(event, state) {
		  if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
		  const active = state.activeToolBlocks[event.index];
		  if (!active) return;
		  const raw = active.inputJsonParts.join("");
		  let parsedInput;
		  try {
		    parsedInput = raw ? JSON.parse(raw) : {};
		  } catch {
		    parsedInput = { __unparsed: raw };
		  }
		  state.toolCalls.push({
		    type: "tool_use",
		    id: active.id,
		    name: active.name,
		    input: parsedInput
		  });
		  delete state.activeToolBlocks[event.index];
		}
		function processEvent(event, state, recordOutputs, span) {
		  if (!(event && typeof event === "object")) {
		    return;
		  }
		  const isError = isErrorEvent(event, span);
		  if (isError) return;
		  handleMessageMetadata(event, state);
		  handleContentBlockStart(event, state);
		  handleContentBlockDelta(event, state, recordOutputs);
		  handleContentBlockStop(event, state);
		}
		async function* instrumentAsyncIterableStream(stream, span, recordOutputs) {
		  const state = {
		    responseTexts: [],
		    finishReasons: [],
		    responseId: "",
		    responseModel: "",
		    promptTokens: void 0,
		    completionTokens: void 0,
		    cacheCreationInputTokens: void 0,
		    cacheReadInputTokens: void 0,
		    toolCalls: [],
		    activeToolBlocks: {}
		  };
		  try {
		    for await (const event of stream) {
		      processEvent(event, state, recordOutputs, span);
		      yield event;
		    }
		  } finally {
		    utils.endStreamSpan(span, state, recordOutputs);
		  }
		}
		function instrumentMessageStream(stream, span, recordOutputs) {
		  const state = {
		    responseTexts: [],
		    finishReasons: [],
		    responseId: "",
		    responseModel: "",
		    promptTokens: void 0,
		    completionTokens: void 0,
		    cacheCreationInputTokens: void 0,
		    cacheReadInputTokens: void 0,
		    toolCalls: [],
		    activeToolBlocks: {}
		  };
		  stream.on("streamEvent", (event) => {
		    processEvent(event, state, recordOutputs, span);
		  });
		  stream.on("message", () => {
		    utils.endStreamSpan(span, state, recordOutputs);
		  });
		  stream.on("error", (error) => {
		    exports$1.captureException(error, {
		      mechanism: {
		        handled: false,
		        type: "auto.ai.anthropic.stream_error"
		      }
		    });
		    if (span.isRecording()) {
		      span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		      span.end();
		    }
		  });
		  return stream;
		}

		exports.instrumentAsyncIterableStream = instrumentAsyncIterableStream;
		exports.instrumentMessageStream = instrumentMessageStream;
		
	} (streaming$1));
	return streaming$1;
}

var hasRequiredAnthropicAi;

function requireAnthropicAi () {
	if (hasRequiredAnthropicAi) return anthropicAi;
	hasRequiredAnthropicAi = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$5();
		const streaming = /*@__PURE__*/ requireStreaming$1();
		const utils$1 = /*@__PURE__*/ requireUtils$b();

		function extractRequestAttributes(args, methodPath, operationName) {
		  const attributes = {
		    [genAiAttributes.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
		    [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
		  };
		  if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
		    const params = args[0];
		    if (params.tools && Array.isArray(params.tools)) {
		      attributes[genAiAttributes.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
		    }
		    attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
		    if ("temperature" in params) attributes[genAiAttributes.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
		    if ("top_p" in params) attributes[genAiAttributes.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
		    if ("stream" in params) attributes[genAiAttributes.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
		    if ("top_k" in params) attributes[genAiAttributes.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
		    if ("frequency_penalty" in params)
		      attributes[genAiAttributes.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
		    if ("max_tokens" in params) attributes[genAiAttributes.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
		  } else {
		    if (methodPath === "models.retrieve" || methodPath === "models.get") {
		      attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
		    } else {
		      attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
		    }
		  }
		  return attributes;
		}
		function addPrivateRequestAttributes(span, params, enableTruncation) {
		  const messages = utils$1.messagesFromParams(params);
		  utils$1.setMessagesAttribute(span, messages, enableTruncation);
		  if ("prompt" in params) {
		    span.setAttributes({ [genAiAttributes.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt) });
		  }
		}
		function addContentAttributes(span, response) {
		  if ("content" in response) {
		    if (Array.isArray(response.content)) {
		      span.setAttributes({
		        [genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item) => item.text).filter((text) => !!text).join("")
		      });
		      const toolCalls = [];
		      for (const item of response.content) {
		        if (item.type === "tool_use" || item.type === "server_tool_use") {
		          toolCalls.push(item);
		        }
		      }
		      if (toolCalls.length > 0) {
		        span.setAttributes({ [genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls) });
		      }
		    }
		  }
		  if ("completion" in response) {
		    span.setAttributes({ [genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion });
		  }
		  if ("input_tokens" in response) {
		    span.setAttributes({ [genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens) });
		  }
		}
		function addMetadataAttributes(span, response) {
		  if ("id" in response && "model" in response) {
		    span.setAttributes({
		      [genAiAttributes.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
		      [genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
		    });
		    if ("usage" in response && response.usage) {
		      utils.setTokenUsageAttributes(
		        span,
		        response.usage.input_tokens,
		        response.usage.output_tokens,
		        response.usage.cache_creation_input_tokens,
		        response.usage.cache_read_input_tokens
		      );
		    }
		  }
		}
		function addResponseAttributes(span, response, recordOutputs) {
		  if (!response || typeof response !== "object") return;
		  if ("type" in response && response.type === "error") {
		    utils$1.handleResponseError(span, response);
		    return;
		  }
		  if (recordOutputs) {
		    addContentAttributes(span, response);
		  }
		  addMetadataAttributes(span, response);
		}
		function handleStreamingError(error, span, methodPath) {
		  exports$1.captureException(error, {
		    mechanism: { handled: false, type: "auto.ai.anthropic", data: { function: methodPath } }
		  });
		  if (span.isRecording()) {
		    span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		    span.end();
		  }
		  throw error;
		}
		function handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
		  const model = requestAttributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
		  const spanConfig = {
		    name: `${operationName} ${model}`,
		    op: `gen_ai.${operationName}`,
		    attributes: requestAttributes
		  };
		  if (isStreamRequested && !isStreamingMethod) {
		    let originalResult;
		    const instrumentedPromise = trace.startSpanManual(spanConfig, (span) => {
		      originalResult = originalMethod.apply(context, args);
		      if (options.recordInputs && params) {
		        addPrivateRequestAttributes(span, params, utils.shouldEnableTruncation(options.enableTruncation));
		      }
		      return (async () => {
		        try {
		          const result = await originalResult;
		          return streaming.instrumentAsyncIterableStream(
		            result,
		            span,
		            options.recordOutputs ?? false
		          );
		        } catch (error) {
		          return handleStreamingError(error, span, methodPath);
		        }
		      })();
		    });
		    return utils.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
		  } else {
		    return trace.startSpanManual(spanConfig, (span) => {
		      try {
		        if (options.recordInputs && params) {
		          addPrivateRequestAttributes(span, params, utils.shouldEnableTruncation(options.enableTruncation));
		        }
		        const messageStream = target.apply(context, args);
		        return streaming.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
		      } catch (error) {
		        return handleStreamingError(error, span, methodPath);
		      }
		    });
		  }
		}
		function instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
		  return new Proxy(originalMethod, {
		    apply(target, thisArg, args) {
		      const operationName = instrumentedMethod.operation || "unknown";
		      const requestAttributes = extractRequestAttributes(args, methodPath, operationName);
		      const model = requestAttributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
		      const params = typeof args[0] === "object" ? args[0] : void 0;
		      const isStreamRequested = Boolean(params?.stream);
		      const isStreamingMethod = instrumentedMethod.streaming === true;
		      if (isStreamRequested || isStreamingMethod) {
		        return handleStreamingRequest(
		          originalMethod,
		          target,
		          context,
		          args,
		          requestAttributes,
		          operationName,
		          methodPath,
		          params,
		          options,
		          isStreamRequested,
		          isStreamingMethod
		        );
		      }
		      let originalResult;
		      const instrumentedPromise = trace.startSpan(
		        {
		          name: `${operationName} ${model}`,
		          op: `gen_ai.${operationName}`,
		          attributes: requestAttributes
		        },
		        (span) => {
		          originalResult = target.apply(context, args);
		          if (options.recordInputs && params) {
		            addPrivateRequestAttributes(span, params, utils.shouldEnableTruncation(options.enableTruncation));
		          }
		          return originalResult.then(
		            (result) => {
		              addResponseAttributes(span, result, options.recordOutputs);
		              return result;
		            },
		            (error) => {
		              exports$1.captureException(error, {
		                mechanism: {
		                  handled: false,
		                  type: "auto.ai.anthropic",
		                  data: {
		                    function: methodPath
		                  }
		                }
		              });
		              throw error;
		            }
		          );
		        }
		      );
		      return utils.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
		    }
		  });
		}
		function createDeepProxy(target, currentPath = "", options) {
		  return new Proxy(target, {
		    get(obj, prop) {
		      const value = obj[prop];
		      const methodPath = utils.buildMethodPath(currentPath, String(prop));
		      const instrumentedMethod = constants.ANTHROPIC_METHOD_REGISTRY[methodPath];
		      if (typeof value === "function" && instrumentedMethod) {
		        return instrumentMethod(
		          value,
		          methodPath,
		          instrumentedMethod,
		          obj,
		          options
		        );
		      }
		      if (typeof value === "function") {
		        return value.bind(obj);
		      }
		      if (value && typeof value === "object") {
		        return createDeepProxy(value, methodPath, options);
		      }
		      return value;
		    }
		  });
		}
		function instrumentAnthropicAiClient(anthropicAiClient, options) {
		  return createDeepProxy(anthropicAiClient, "", utils.resolveAIRecordingOptions(options));
		}

		exports.instrumentAnthropicAiClient = instrumentAnthropicAiClient;
		
	} (anthropicAi));
	return anthropicAi;
}

var googleGenai = {};

var constants$4 = {};

var hasRequiredConstants$4;

function requireConstants$4 () {
	if (hasRequiredConstants$4) return constants$4;
	hasRequiredConstants$4 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
		const GOOGLE_GENAI_METHOD_REGISTRY = {
		  "models.generateContent": { operation: "generate_content" },
		  "models.generateContentStream": { operation: "generate_content", streaming: true },
		  "models.embedContent": { operation: "embeddings" },
		  "chats.create": { proxyResultPath: "chat" },
		  "chat.sendMessage": { operation: "chat" },
		  "chat.sendMessageStream": { operation: "chat", streaming: true }
		};
		const GOOGLE_GENAI_SYSTEM_NAME = "google_genai";

		exports.GOOGLE_GENAI_INTEGRATION_NAME = GOOGLE_GENAI_INTEGRATION_NAME;
		exports.GOOGLE_GENAI_METHOD_REGISTRY = GOOGLE_GENAI_METHOD_REGISTRY;
		exports.GOOGLE_GENAI_SYSTEM_NAME = GOOGLE_GENAI_SYSTEM_NAME;
		
	} (constants$4));
	return constants$4;
}

var streaming = {};

var hasRequiredStreaming;

function requireStreaming () {
	if (hasRequiredStreaming) return streaming;
	hasRequiredStreaming = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const utils = /*@__PURE__*/ requireUtils$e();

		function isErrorChunk(chunk, span) {
		  const feedback = chunk?.promptFeedback;
		  if (feedback?.blockReason) {
		    const message = feedback.blockReasonMessage ?? feedback.blockReason;
		    span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		    exports$1.captureException(`Content blocked: ${message}`, {
		      mechanism: { handled: false, type: "auto.ai.google_genai" }
		    });
		    return true;
		  }
		  return false;
		}
		function handleResponseMetadata(chunk, state) {
		  if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
		  if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
		  const usage = chunk.usageMetadata;
		  if (usage) {
		    if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
		    if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
		    if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
		  }
		}
		function handleCandidateContent(chunk, state, recordOutputs) {
		  if (Array.isArray(chunk.functionCalls)) {
		    state.toolCalls.push(...chunk.functionCalls);
		  }
		  for (const candidate of chunk.candidates ?? []) {
		    if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) {
		      state.finishReasons.push(candidate.finishReason);
		    }
		    for (const part of candidate?.content?.parts ?? []) {
		      if (recordOutputs && part.text) state.responseTexts.push(part.text);
		      if (part.functionCall) {
		        state.toolCalls.push({
		          type: "function",
		          id: part.functionCall.id,
		          name: part.functionCall.name,
		          arguments: part.functionCall.args
		        });
		      }
		    }
		  }
		}
		function processChunk(chunk, state, recordOutputs, span) {
		  if (!chunk || isErrorChunk(chunk, span)) return;
		  handleResponseMetadata(chunk, state);
		  handleCandidateContent(chunk, state, recordOutputs);
		}
		async function* instrumentStream(stream, span, recordOutputs) {
		  const state = {
		    responseTexts: [],
		    finishReasons: [],
		    toolCalls: []
		  };
		  try {
		    for await (const chunk of stream) {
		      processChunk(chunk, state, recordOutputs, span);
		      yield chunk;
		    }
		  } finally {
		    utils.endStreamSpan(span, state, recordOutputs);
		  }
		}

		exports.instrumentStream = instrumentStream;
		
	} (streaming));
	return streaming;
}

var utils$a = {};

var hasRequiredUtils$a;

function requireUtils$a () {
	if (hasRequiredUtils$a) return utils$a;
	hasRequiredUtils$a = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function contentUnionToMessages(content, role = "user") {
		  if (typeof content === "string") {
		    return [{ role, content }];
		  }
		  if (Array.isArray(content)) {
		    return content.flatMap((content2) => contentUnionToMessages(content2, role));
		  }
		  if (typeof content !== "object" || !content) return [];
		  if ("role" in content && typeof content.role === "string") {
		    return [content];
		  }
		  if ("parts" in content) {
		    return [{ ...content, role }];
		  }
		  return [{ role, content }];
		}

		exports.contentUnionToMessages = contentUnionToMessages;
		
	} (utils$a));
	return utils$a;
}

var hasRequiredGoogleGenai;

function requireGoogleGenai () {
	if (hasRequiredGoogleGenai) return googleGenai;
	hasRequiredGoogleGenai = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const handleCallbackErrors = /*@__PURE__*/ requireHandleCallbackErrors();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$4();
		const streaming = /*@__PURE__*/ requireStreaming();
		const utils$1 = /*@__PURE__*/ requireUtils$a();

		function extractModel(params, context) {
		  if ("model" in params && typeof params.model === "string") {
		    return params.model;
		  }
		  if (context && typeof context === "object") {
		    const contextObj = context;
		    if ("model" in contextObj && typeof contextObj.model === "string") {
		      return contextObj.model;
		    }
		    if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") {
		      return contextObj.modelVersion;
		    }
		  }
		  return "unknown";
		}
		function extractConfigAttributes(config) {
		  const attributes = {};
		  if ("temperature" in config && typeof config.temperature === "number") {
		    attributes[genAiAttributes.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
		  }
		  if ("topP" in config && typeof config.topP === "number") {
		    attributes[genAiAttributes.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
		  }
		  if ("topK" in config && typeof config.topK === "number") {
		    attributes[genAiAttributes.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
		  }
		  if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") {
		    attributes[genAiAttributes.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
		  }
		  if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") {
		    attributes[genAiAttributes.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
		  }
		  if ("presencePenalty" in config && typeof config.presencePenalty === "number") {
		    attributes[genAiAttributes.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
		  }
		  return attributes;
		}
		function extractRequestAttributes(operationName, params, context) {
		  const attributes = {
		    [genAiAttributes.GEN_AI_SYSTEM_ATTRIBUTE]: constants.GOOGLE_GENAI_SYSTEM_NAME,
		    [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
		  };
		  if (params) {
		    attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = extractModel(params, context);
		    if ("config" in params && typeof params.config === "object" && params.config) {
		      const config = params.config;
		      Object.assign(attributes, extractConfigAttributes(config));
		      if ("tools" in config && Array.isArray(config.tools)) {
		        const functionDeclarations = config.tools.flatMap(
		          (tool) => tool.functionDeclarations
		        );
		        attributes[genAiAttributes.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
		      }
		    }
		  } else {
		    attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = extractModel({}, context);
		  }
		  return attributes;
		}
		function addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
		  if (isEmbeddings) {
		    const contents = params.contents;
		    if (contents != null) {
		      span.setAttribute(
		        genAiAttributes.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE,
		        typeof contents === "string" ? contents : JSON.stringify(contents)
		      );
		    }
		    return;
		  }
		  const messages = [];
		  if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) {
		    messages.push(...utils$1.contentUnionToMessages(params.config.systemInstruction, "system"));
		  }
		  if ("history" in params) {
		    messages.push(...utils$1.contentUnionToMessages(params.history, "user"));
		  }
		  if ("contents" in params) {
		    messages.push(...utils$1.contentUnionToMessages(params.contents, "user"));
		  }
		  if ("message" in params) {
		    messages.push(...utils$1.contentUnionToMessages(params.message, "user"));
		  }
		  if (Array.isArray(messages) && messages.length) {
		    const { systemInstructions, filteredMessages } = utils.extractSystemInstructions(messages);
		    if (systemInstructions) {
		      span.setAttribute(genAiAttributes.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
		    }
		    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
		    span.setAttributes({
		      [genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
		      [genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? utils.getTruncatedJsonString(filteredMessages) : utils.getJsonString(filteredMessages)
		    });
		  }
		}
		function addResponseAttributes(span, response, recordOutputs) {
		  if (!response || typeof response !== "object") return;
		  if (response.modelVersion) {
		    span.setAttribute(genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
		  }
		  if (response.usageMetadata && typeof response.usageMetadata === "object") {
		    const usage = response.usageMetadata;
		    if (typeof usage.promptTokenCount === "number") {
		      span.setAttributes({
		        [genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
		      });
		    }
		    if (typeof usage.candidatesTokenCount === "number") {
		      span.setAttributes({
		        [genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
		      });
		    }
		    if (typeof usage.totalTokenCount === "number") {
		      span.setAttributes({
		        [genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
		      });
		    }
		  }
		  if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
		    const responseTexts = response.candidates.map((candidate) => {
		      if (candidate.content?.parts && Array.isArray(candidate.content.parts)) {
		        return candidate.content.parts.map((part) => typeof part.text === "string" ? part.text : "").filter((text) => text.length > 0).join("");
		      }
		      return "";
		    }).filter((text) => text.length > 0);
		    if (responseTexts.length > 0) {
		      span.setAttributes({
		        [genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
		      });
		    }
		  }
		  if (recordOutputs && response.functionCalls) {
		    const functionCalls = response.functionCalls;
		    if (Array.isArray(functionCalls) && functionCalls.length > 0) {
		      span.setAttributes({
		        [genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
		      });
		    }
		  }
		}
		function instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
		  const isEmbeddings = instrumentedMethod.operation === "embeddings";
		  return new Proxy(originalMethod, {
		    apply(target, _, args) {
		      const operationName = instrumentedMethod.operation || "unknown";
		      const params = args[0];
		      const requestAttributes = extractRequestAttributes(operationName, params, context);
		      const model = requestAttributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
		      if (instrumentedMethod.streaming) {
		        return trace.startSpanManual(
		          {
		            name: `${operationName} ${model}`,
		            op: `gen_ai.${operationName}`,
		            attributes: requestAttributes
		          },
		          async (span) => {
		            try {
		              if (options.recordInputs && params) {
		                addPrivateRequestAttributes(
		                  span,
		                  params,
		                  isEmbeddings,
		                  utils.shouldEnableTruncation(options.enableTruncation)
		                );
		              }
		              const stream = await target.apply(context, args);
		              return streaming.instrumentStream(stream, span, Boolean(options.recordOutputs));
		            } catch (error) {
		              span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		              exports$1.captureException(error, {
		                mechanism: {
		                  handled: false,
		                  type: "auto.ai.google_genai",
		                  data: { function: methodPath }
		                }
		              });
		              span.end();
		              throw error;
		            }
		          }
		        );
		      }
		      return trace.startSpan(
		        {
		          name: `${operationName} ${model}`,
		          op: `gen_ai.${operationName}`,
		          attributes: requestAttributes
		        },
		        (span) => {
		          if (options.recordInputs && params) {
		            addPrivateRequestAttributes(span, params, isEmbeddings, utils.shouldEnableTruncation(options.enableTruncation));
		          }
		          return handleCallbackErrors.handleCallbackErrors(
		            () => target.apply(context, args),
		            (error) => {
		              exports$1.captureException(error, {
		                mechanism: { handled: false, type: "auto.ai.google_genai", data: { function: methodPath } }
		              });
		            },
		            () => {
		            },
		            (result) => {
		              if (!isEmbeddings) {
		                addResponseAttributes(span, result, options.recordOutputs);
		              }
		            }
		          );
		        }
		      );
		    }
		  });
		}
		function createDeepProxy(target, currentPath = "", options) {
		  return new Proxy(target, {
		    get: (t, prop, receiver) => {
		      const value = Reflect.get(t, prop, receiver);
		      const methodPath = utils.buildMethodPath(currentPath, String(prop));
		      const instrumentedMethod = constants.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
		      if (typeof value === "function" && instrumentedMethod) {
		        const wrappedMethod = instrumentedMethod.operation ? instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
		        if (!instrumentedMethod.proxyResultPath) {
		          return wrappedMethod;
		        }
		        return function(...args) {
		          const result = wrappedMethod(...args);
		          if (result && typeof result === "object") {
		            return createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
		          }
		          return result;
		        };
		      }
		      if (typeof value === "function") {
		        return value.bind(t);
		      }
		      if (value && typeof value === "object") {
		        return createDeepProxy(value, methodPath, options);
		      }
		      return value;
		    }
		  });
		}
		function instrumentGoogleGenAIClient(client, options) {
		  return createDeepProxy(client, "", utils.resolveAIRecordingOptions(options));
		}

		exports.extractModel = extractModel;
		exports.instrumentGoogleGenAIClient = instrumentGoogleGenAIClient;
		
	} (googleGenai));
	return googleGenai;
}

var langchain = {};

var constants$3 = {};

var hasRequiredConstants$3;

function requireConstants$3 () {
	if (hasRequiredConstants$3) return constants$3;
	hasRequiredConstants$3 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const LANGCHAIN_INTEGRATION_NAME = "LangChain";
		const LANGCHAIN_ORIGIN = "auto.ai.langchain";
		const ROLE_MAP = {
		  human: "user",
		  ai: "assistant",
		  assistant: "assistant",
		  system: "system",
		  function: "function",
		  tool: "tool"
		};

		exports.LANGCHAIN_INTEGRATION_NAME = LANGCHAIN_INTEGRATION_NAME;
		exports.LANGCHAIN_ORIGIN = LANGCHAIN_ORIGIN;
		exports.ROLE_MAP = ROLE_MAP;
		
	} (constants$3));
	return constants$3;
}

var utils$9 = {};

var hasRequiredUtils$9;

function requireUtils$9 () {
	if (hasRequiredUtils$9) return utils$9;
	hasRequiredUtils$9 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const mediaStripping = /*@__PURE__*/ requireMediaStripping();
		const utils = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$3();

		const setIfDefined = (target, key, value) => {
		  if (value != null) target[key] = value;
		};
		const setNumberIfDefined = (target, key, value) => {
		  const n = Number(value);
		  if (!Number.isNaN(n)) target[key] = n;
		};
		function asString(v) {
		  if (typeof v === "string") return v;
		  try {
		    return JSON.stringify(v);
		  } catch {
		    return String(v);
		  }
		}
		function normalizeContent(v) {
		  if (Array.isArray(v)) {
		    try {
		      const stripped = v.map(
		        (part) => part && typeof part === "object" && mediaStripping.isContentMedia(part) ? mediaStripping.stripInlineMediaFromSingleMessage(part) : part
		      );
		      return JSON.stringify(stripped);
		    } catch {
		      return String(v);
		    }
		  }
		  return asString(v);
		}
		function normalizeMessageRole(role) {
		  const normalized = role.toLowerCase();
		  return constants.ROLE_MAP[normalized] ?? normalized;
		}
		function normalizeRoleNameFromCtor(name) {
		  if (name.includes("System")) return "system";
		  if (name.includes("Human")) return "user";
		  if (name.includes("AI") || name.includes("Assistant")) return "assistant";
		  if (name.includes("Function")) return "function";
		  if (name.includes("Tool")) return "tool";
		  return "user";
		}
		function getInvocationParams(tags) {
		  if (!tags || Array.isArray(tags)) return void 0;
		  return tags.invocation_params;
		}
		function normalizeLangChainMessages(messages) {
		  return messages.map((message) => {
		    const maybeGetType = message._getType;
		    if (typeof maybeGetType === "function") {
		      const messageType = maybeGetType.call(message);
		      return {
		        role: normalizeMessageRole(messageType),
		        content: normalizeContent(message.content)
		      };
		    }
		    if (message.lc === 1 && message.kwargs) {
		      const id = message.id;
		      const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
		      const role = typeof messageType === "string" ? normalizeRoleNameFromCtor(messageType) : "user";
		      return {
		        role: normalizeMessageRole(role),
		        content: normalizeContent(message.kwargs?.content)
		      };
		    }
		    if (message.type) {
		      const role = String(message.type).toLowerCase();
		      return {
		        role: normalizeMessageRole(role),
		        content: normalizeContent(message.content)
		      };
		    }
		    if (message.role) {
		      return {
		        role: normalizeMessageRole(String(message.role)),
		        content: normalizeContent(message.content)
		      };
		    }
		    const ctor = message.constructor?.name;
		    if (ctor && ctor !== "Object") {
		      return {
		        role: normalizeMessageRole(normalizeRoleNameFromCtor(ctor)),
		        content: normalizeContent(message.content)
		      };
		    }
		    return {
		      role: "user",
		      content: normalizeContent(message.content)
		    };
		  });
		}
		function extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
		  const attrs = {};
		  const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
		  const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
		  setNumberIfDefined(attrs, genAiAttributes.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
		  const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
		  setNumberIfDefined(attrs, genAiAttributes.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
		  const topP = invocationParams?.top_p ?? kwargs?.top_p;
		  setNumberIfDefined(attrs, genAiAttributes.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
		  const frequencyPenalty = invocationParams?.frequency_penalty;
		  setNumberIfDefined(attrs, genAiAttributes.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
		  const presencePenalty = invocationParams?.presence_penalty;
		  setNumberIfDefined(attrs, genAiAttributes.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
		  if (invocationParams && "stream" in invocationParams) {
		    setIfDefined(attrs, genAiAttributes.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
		  }
		  return attrs;
		}
		function baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
		  return {
		    [genAiAttributes.GEN_AI_SYSTEM_ATTRIBUTE]: asString(system ?? "langchain"),
		    [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
		    [genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: asString(modelName),
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: constants.LANGCHAIN_ORIGIN,
		    ...extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
		  };
		}
		function extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
		  const system = langSmithMetadata?.ls_provider;
		  const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
		  const attrs = baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
		  if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
		    setIfDefined(attrs, genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
		    const messages = prompts.map((p) => ({ role: "user", content: p }));
		    setIfDefined(
		      attrs,
		      genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE,
		      enableTruncation ? utils.getTruncatedJsonString(messages) : utils.getJsonString(messages)
		    );
		  }
		  return attrs;
		}
		function extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
		  const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
		  const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
		  const attrs = baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
		  if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
		    const normalized = normalizeLangChainMessages(langChainMessages.flat());
		    const { systemInstructions, filteredMessages } = utils.extractSystemInstructions(normalized);
		    if (systemInstructions) {
		      setIfDefined(attrs, genAiAttributes.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
		    }
		    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
		    setIfDefined(attrs, genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
		    setIfDefined(
		      attrs,
		      genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE,
		      enableTruncation ? utils.getTruncatedJsonString(filteredMessages) : utils.getJsonString(filteredMessages)
		    );
		  }
		  return attrs;
		}
		function addToolCallsAttributes(generations, attrs) {
		  const toolCalls = [];
		  const flatGenerations = generations.flat();
		  for (const gen of flatGenerations) {
		    const msg = gen.message;
		    const msgToolCalls = msg?.tool_calls;
		    if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) {
		      toolCalls.push(...msgToolCalls);
		    } else {
		      const content = gen.message?.content;
		      if (Array.isArray(content)) {
		        for (const item of content) {
		          const t = item;
		          if (t.type === "tool_use") toolCalls.push(t);
		        }
		      }
		    }
		  }
		  if (toolCalls.length > 0) {
		    setIfDefined(attrs, genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, asString(toolCalls));
		  }
		}
		function addTokenUsageAttributes(llmOutput, attrs) {
		  if (!llmOutput) return;
		  const tokenUsage = llmOutput.tokenUsage;
		  const anthropicUsage = llmOutput.usage;
		  if (tokenUsage) {
		    setNumberIfDefined(attrs, genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
		    setNumberIfDefined(attrs, genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
		    setNumberIfDefined(attrs, genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
		  } else if (anthropicUsage) {
		    setNumberIfDefined(attrs, genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
		    setNumberIfDefined(attrs, genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
		    const input = Number(anthropicUsage.input_tokens);
		    const output = Number(anthropicUsage.output_tokens);
		    const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
		    if (total > 0) setNumberIfDefined(attrs, genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
		    if (anthropicUsage.cache_creation_input_tokens !== void 0)
		      setNumberIfDefined(
		        attrs,
		        genAiAttributes.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE,
		        anthropicUsage.cache_creation_input_tokens
		      );
		    if (anthropicUsage.cache_read_input_tokens !== void 0)
		      setNumberIfDefined(attrs, genAiAttributes.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
		  }
		}
		function extractLlmResponseAttributes(llmResult, recordOutputs) {
		  if (!llmResult) return;
		  const attrs = {};
		  if (Array.isArray(llmResult.generations)) {
		    const finishReasons = llmResult.generations.flat().map((g) => {
		      if (g.generationInfo?.finish_reason) {
		        return g.generationInfo.finish_reason;
		      }
		      if (g.generation_info?.finish_reason) {
		        return g.generation_info.finish_reason;
		      }
		      return null;
		    }).filter((r) => typeof r === "string");
		    if (finishReasons.length > 0) {
		      setIfDefined(attrs, genAiAttributes.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, asString(finishReasons));
		    }
		    addToolCallsAttributes(llmResult.generations, attrs);
		    if (recordOutputs) {
		      const texts = llmResult.generations.flat().map((gen) => gen.text ?? gen.message?.content).filter((t) => typeof t === "string");
		      if (texts.length > 0) {
		        setIfDefined(attrs, genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, asString(texts));
		      }
		    }
		  }
		  addTokenUsageAttributes(llmResult.llmOutput, attrs);
		  const llmOutput = llmResult.llmOutput;
		  const firstGeneration = llmResult.generations?.[0]?.[0];
		  const v1Message = firstGeneration?.message;
		  const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
		  if (modelName) setIfDefined(attrs, genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
		  const responseId = llmOutput?.id ?? v1Message?.id;
		  if (responseId) {
		    setIfDefined(attrs, genAiAttributes.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
		  }
		  const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
		  if (stopReason) {
		    setIfDefined(attrs, genAiAttributes.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, asString(stopReason));
		  }
		  return attrs;
		}
		function getAgentNameFromMetadata(metadata) {
		  const attrs = {};
		  const agentName = metadata?.lc_agent_name;
		  if (typeof agentName === "string") {
		    attrs[genAiAttributes.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
		  }
		  return attrs;
		}
		function extractToolDefinitions(extraParams) {
		  const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
		  if (!Array.isArray(tools) || tools.length === 0) return void 0;
		  const toolDefs = tools.map((tool) => {
		    const fn = tool.function;
		    return {
		      type: "function",
		      name: tool.name ?? fn?.name ?? "",
		      description: tool.description ?? fn?.description
		    };
		  });
		  return JSON.stringify(toolDefs);
		}
		function isCallbackManager(value) {
		  if (!value || typeof value !== "object") {
		    return false;
		  }
		  const candidate = value;
		  return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
		}
		function isSentryHandler(handler) {
		  return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
		}
		function containsSentryHandler(handlers) {
		  return handlers.some(isSentryHandler);
		}
		function _INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
		  if (!existing) {
		    return [sentryHandler];
		  }
		  if (isCallbackManager(existing)) {
		    if (containsSentryHandler(existing.handlers ?? [])) {
		      return existing;
		    }
		    const copied = existing.copy();
		    copied.addHandler(sentryHandler, true);
		    return copied;
		  }
		  const handlers = Array.isArray(existing) ? existing : [existing];
		  if (containsSentryHandler(handlers)) {
		    return existing;
		  }
		  return [...handlers, sentryHandler];
		}

		exports._INTERNAL_mergeLangChainCallbackHandler = _INTERNAL_mergeLangChainCallbackHandler;
		exports.extractChatModelRequestAttributes = extractChatModelRequestAttributes;
		exports.extractLLMRequestAttributes = extractLLMRequestAttributes;
		exports.extractLlmResponseAttributes = extractLlmResponseAttributes;
		exports.extractToolDefinitions = extractToolDefinitions;
		exports.getAgentNameFromMetadata = getAgentNameFromMetadata;
		exports.getInvocationParams = getInvocationParams;
		exports.normalizeLangChainMessages = normalizeLangChainMessages;
		
	} (utils$9));
	return utils$9;
}

var hasRequiredLangchain;

function requireLangchain () {
	if (hasRequiredLangchain) return langchain;
	hasRequiredLangchain = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$3();
		const utils$1 = /*@__PURE__*/ requireUtils$9();

		function createLangChainCallbackHandler(options = {}) {
		  const { recordInputs, recordOutputs } = utils.resolveAIRecordingOptions(options);
		  const enableTruncation = utils.shouldEnableTruncation(options.enableTruncation);
		  const spanMap = /* @__PURE__ */ new Map();
		  const exitSpan = (runId) => {
		    const span = spanMap.get(runId);
		    if (span?.isRecording()) {
		      span.end();
		      spanMap.delete(runId);
		    }
		  };
		  const handler = {
		    // Required LangChain BaseCallbackHandler properties
		    lc_serializable: false,
		    lc_namespace: ["langchain_core", "callbacks", "sentry"],
		    lc_secrets: void 0,
		    lc_attributes: void 0,
		    lc_aliases: void 0,
		    lc_serializable_keys: void 0,
		    lc_id: ["langchain_core", "callbacks", "sentry"],
		    lc_kwargs: {},
		    name: "SentryCallbackHandler",
		    // BaseCallbackHandlerInput boolean flags
		    ignoreLLM: false,
		    ignoreChain: false,
		    ignoreAgent: false,
		    ignoreRetriever: false,
		    ignoreCustomEvent: false,
		    raiseError: false,
		    awaitHandlers: true,
		    handleLLMStart(llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
		      const invocationParams = utils$1.getInvocationParams(tags);
		      const attributes = utils$1.extractLLMRequestAttributes(
		        llm,
		        prompts,
		        recordInputs,
		        enableTruncation,
		        invocationParams,
		        metadata
		      );
		      const modelName = attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
		      const operationName = attributes[genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE];
		      trace.startSpanManual(
		        {
		          name: `${operationName} ${modelName}`,
		          op: "gen_ai.chat",
		          attributes: {
		            ...utils$1.getAgentNameFromMetadata(metadata),
		            ...attributes,
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
		          }
		        },
		        (span) => {
		          spanMap.set(runId, span);
		          return span;
		        }
		      );
		    },
		    // Chat Model Start Handler
		    handleChatModelStart(llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
		      const invocationParams = utils$1.getInvocationParams(tags);
		      const attributes = utils$1.extractChatModelRequestAttributes(
		        llm,
		        messages,
		        recordInputs,
		        enableTruncation,
		        invocationParams,
		        metadata
		      );
		      const toolDefsJson = utils$1.extractToolDefinitions(extraParams);
		      if (toolDefsJson) {
		        attributes[genAiAttributes.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
		      }
		      const modelName = attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
		      const operationName = attributes[genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE];
		      trace.startSpanManual(
		        {
		          name: `${operationName} ${modelName}`,
		          op: "gen_ai.chat",
		          attributes: {
		            ...utils$1.getAgentNameFromMetadata(metadata),
		            ...attributes,
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
		          }
		        },
		        (span) => {
		          spanMap.set(runId, span);
		          return span;
		        }
		      );
		    },
		    // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
		    handleLLMEnd(output, runId, _parentRunId, _tags, _extraParams) {
		      const span = spanMap.get(runId);
		      if (span?.isRecording()) {
		        const attributes = utils$1.extractLlmResponseAttributes(output, recordOutputs);
		        if (attributes) {
		          span.setAttributes(attributes);
		        }
		        exitSpan(runId);
		      }
		    },
		    // LLM Error Handler - note: handleLLMError with capital LLM
		    handleLLMError(error, runId) {
		      const span = spanMap.get(runId);
		      if (span?.isRecording()) {
		        span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		        exitSpan(runId);
		      }
		      exports$1.captureException(error, {
		        mechanism: {
		          handled: false,
		          type: `${constants.LANGCHAIN_ORIGIN}.llm_error_handler`
		        }
		      });
		    },
		    // Chain Start Handler
		    handleChainStart(chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
		      if (metadata?.__sentry_langgraph__) {
		        return;
		      }
		      const chainName = runName || chain.name || "unknown_chain";
		      const attributes = {
		        [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
		        "langchain.chain.name": chainName
		      };
		      if (recordInputs) {
		        attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
		      }
		      trace.startSpanManual(
		        {
		          name: `chain ${chainName}`,
		          op: "gen_ai.invoke_agent",
		          attributes: {
		            ...attributes,
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
		          }
		        },
		        (span) => {
		          spanMap.set(runId, span);
		          return span;
		        }
		      );
		    },
		    // Chain End Handler
		    handleChainEnd(outputs, runId) {
		      const span = spanMap.get(runId);
		      if (span?.isRecording()) {
		        if (recordOutputs) {
		          span.setAttributes({
		            "langchain.chain.outputs": JSON.stringify(outputs)
		          });
		        }
		        exitSpan(runId);
		      }
		    },
		    // Chain Error Handler
		    handleChainError(error, runId) {
		      const span = spanMap.get(runId);
		      if (span?.isRecording()) {
		        span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		        exitSpan(runId);
		      }
		      exports$1.captureException(error, {
		        mechanism: {
		          handled: false,
		          type: `${constants.LANGCHAIN_ORIGIN}.chain_error_handler`
		        }
		      });
		    },
		    // Tool Start Handler
		    handleToolStart(tool, input, runId, _parentRunId, _tags, metadata, runName) {
		      if (metadata?.__sentry_langgraph__) {
		        return;
		      }
		      const toolName = runName || tool.name || "unknown_tool";
		      const attributes = {
		        ...utils$1.getAgentNameFromMetadata(metadata),
		        [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: constants.LANGCHAIN_ORIGIN,
		        [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
		        [genAiAttributes.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
		      };
		      if (recordInputs) {
		        attributes[genAiAttributes.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
		      }
		      trace.startSpanManual(
		        {
		          name: `execute_tool ${toolName}`,
		          op: "gen_ai.execute_tool",
		          attributes: {
		            ...attributes,
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
		          }
		        },
		        (span) => {
		          spanMap.set(runId, span);
		          return span;
		        }
		      );
		    },
		    // Tool End Handler
		    handleToolEnd(output, runId) {
		      const span = spanMap.get(runId);
		      if (span?.isRecording()) {
		        if (recordOutputs) {
		          const outputObj = output;
		          const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
		          span.setAttributes({
		            [genAiAttributes.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
		          });
		        }
		        exitSpan(runId);
		      }
		    },
		    // Tool Error Handler
		    handleToolError(error, runId) {
		      const span = spanMap.get(runId);
		      if (span?.isRecording()) {
		        span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		        exitSpan(runId);
		      }
		      exports$1.captureException(error, {
		        mechanism: {
		          handled: false,
		          type: `${constants.LANGCHAIN_ORIGIN}.tool_error_handler`
		        }
		      });
		    },
		    // LangChain BaseCallbackHandler required methods
		    copy() {
		      return handler;
		    },
		    toJSON() {
		      return {
		        lc: 1,
		        type: "not_implemented",
		        id: handler.lc_id
		      };
		    },
		    toJSONNotImplemented() {
		      return {
		        lc: 1,
		        type: "not_implemented",
		        id: handler.lc_id
		      };
		    }
		  };
		  return handler;
		}

		exports.createLangChainCallbackHandler = createLangChainCallbackHandler;
		
	} (langchain));
	return langchain;
}

var langgraph = {};

var constants$2 = {};

var hasRequiredConstants$2;

function requireConstants$2 () {
	if (hasRequiredConstants$2) return constants$2;
	hasRequiredConstants$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const LANGGRAPH_INTEGRATION_NAME = "LangGraph";
		const LANGGRAPH_ORIGIN = "auto.ai.langgraph";

		exports.LANGGRAPH_INTEGRATION_NAME = LANGGRAPH_INTEGRATION_NAME;
		exports.LANGGRAPH_ORIGIN = LANGGRAPH_ORIGIN;
		
	} (constants$2));
	return constants$2;
}

var utils$8 = {};

var hasRequiredUtils$8;

function requireUtils$8 () {
	if (hasRequiredUtils$8) return utils$8;
	hasRequiredUtils$8 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$9();
		const constants = /*@__PURE__*/ requireConstants$2();

		function extractLLMFromParams(args) {
		  const arg = args[0];
		  if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") {
		    return null;
		  }
		  const llm = arg.llm;
		  if (typeof llm.modelName !== "string" && typeof llm.model !== "string") {
		    return null;
		  }
		  return llm;
		}
		function extractAgentNameFromParams(args) {
		  const arg = args[0];
		  if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") {
		    return arg.name;
		  }
		  return null;
		}
		function wrapToolsWithSpans(tools, options, agentName) {
		  const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
		  for (const tool of tools) {
		    if (!tool || typeof tool !== "object") {
		      continue;
		    }
		    const t = tool;
		    const originalInvoke = t.invoke;
		    if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) {
		      continue;
		    }
		    const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
		    const toolDescription = typeof t.description === "string" ? t.description : void 0;
		    const wrappedInvoke = new Proxy(originalInvoke, {
		      apply(target, thisArg, args) {
		        const spanAttributes = {
		          [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: constants.LANGGRAPH_ORIGIN,
		          [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: genAiAttributes.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
		          [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
		          [genAiAttributes.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
		          [genAiAttributes.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
		        };
		        const callConfig = args[1];
		        const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
		        if (typeof callAgentName === "string") {
		          spanAttributes[genAiAttributes.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
		        }
		        if (toolDescription) {
		          spanAttributes[genAiAttributes.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
		        }
		        const input = args[0];
		        if (typeof input === "object" && !!input) {
		          if ("id" in input && typeof input.id === "string") {
		            spanAttributes[genAiAttributes.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
		          }
		          if (options.recordInputs) {
		            const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
		            try {
		              spanAttributes[genAiAttributes.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
		            } catch {
		            }
		          }
		        }
		        return trace.startSpan(
		          {
		            op: genAiAttributes.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
		            name: `execute_tool ${toolName}`,
		            attributes: spanAttributes
		          },
		          async (span) => {
		            try {
		              const result = await Reflect.apply(target, thisArg, args);
		              if (options.recordOutputs) {
		                try {
		                  const resultObj = result;
		                  const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
		                  span.setAttribute(
		                    genAiAttributes.GEN_AI_TOOL_OUTPUT_ATTRIBUTE,
		                    typeof content === "string" ? content : JSON.stringify(content)
		                  );
		                } catch {
		                }
		              }
		              return result;
		            } catch (error) {
		              span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		              exports$1.captureException(error, {
		                mechanism: {
		                  handled: false,
		                  type: "auto.ai.langgraph.error"
		                }
		              });
		              throw error;
		            }
		          }
		        );
		      }
		    });
		    t.invoke = wrappedInvoke;
		    Object.defineProperty(t, SENTRY_WRAPPED, { value: true, enumerable: false });
		  }
		  return tools;
		}
		function extractToolCalls(messages) {
		  if (!messages || messages.length === 0) {
		    return null;
		  }
		  const toolCalls = [];
		  for (const message of messages) {
		    if (message && typeof message === "object") {
		      const msgToolCalls = message.tool_calls;
		      if (msgToolCalls && Array.isArray(msgToolCalls)) {
		        toolCalls.push(...msgToolCalls);
		      }
		    }
		  }
		  return toolCalls.length > 0 ? toolCalls : null;
		}
		function extractTokenUsageFromMessage(message) {
		  const msg = message;
		  let inputTokens = 0;
		  let outputTokens = 0;
		  let totalTokens = 0;
		  if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
		    const usage = msg.usage_metadata;
		    if (typeof usage.input_tokens === "number") {
		      inputTokens = usage.input_tokens;
		    }
		    if (typeof usage.output_tokens === "number") {
		      outputTokens = usage.output_tokens;
		    }
		    if (typeof usage.total_tokens === "number") {
		      totalTokens = usage.total_tokens;
		    }
		    return { inputTokens, outputTokens, totalTokens };
		  }
		  if (msg.response_metadata && typeof msg.response_metadata === "object") {
		    const metadata = msg.response_metadata;
		    if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
		      const tokenUsage = metadata.tokenUsage;
		      if (typeof tokenUsage.promptTokens === "number") {
		        inputTokens = tokenUsage.promptTokens;
		      }
		      if (typeof tokenUsage.completionTokens === "number") {
		        outputTokens = tokenUsage.completionTokens;
		      }
		      if (typeof tokenUsage.totalTokens === "number") {
		        totalTokens = tokenUsage.totalTokens;
		      }
		    }
		  }
		  return { inputTokens, outputTokens, totalTokens };
		}
		function extractModelMetadata(span, message) {
		  const msg = message;
		  if (msg.response_metadata && typeof msg.response_metadata === "object") {
		    const metadata = msg.response_metadata;
		    if (metadata.model_name && typeof metadata.model_name === "string") {
		      span.setAttribute(genAiAttributes.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
		    }
		    if (metadata.finish_reason && typeof metadata.finish_reason === "string") {
		      span.setAttribute(genAiAttributes.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [metadata.finish_reason]);
		    }
		  }
		}
		function extractToolsFromCompiledGraph(compiledGraph) {
		  if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) {
		    return null;
		  }
		  const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
		  if (!tools || !Array.isArray(tools) || tools.length === 0) {
		    return null;
		  }
		  return tools.map((tool) => ({
		    name: tool.lc_kwargs?.name,
		    description: tool.lc_kwargs?.description,
		    schema: tool.lc_kwargs?.schema
		  }));
		}
		function setResponseAttributes(span, inputMessages, result) {
		  const resultObj = result;
		  const outputMessages = resultObj?.messages;
		  if (!outputMessages || !Array.isArray(outputMessages)) {
		    return;
		  }
		  const inputCount = inputMessages?.length ?? 0;
		  const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
		  if (newMessages.length === 0) {
		    return;
		  }
		  const toolCalls = extractToolCalls(newMessages);
		  if (toolCalls) {
		    span.setAttribute(genAiAttributes.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
		  }
		  const normalizedNewMessages = utils.normalizeLangChainMessages(newMessages);
		  span.setAttribute(genAiAttributes.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
		  let totalInputTokens = 0;
		  let totalOutputTokens = 0;
		  let totalTokens = 0;
		  for (const message of newMessages) {
		    const tokens = extractTokenUsageFromMessage(message);
		    totalInputTokens += tokens.inputTokens;
		    totalOutputTokens += tokens.outputTokens;
		    totalTokens += tokens.totalTokens;
		    extractModelMetadata(span, message);
		  }
		  if (totalInputTokens > 0) {
		    span.setAttribute(genAiAttributes.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
		  }
		  if (totalOutputTokens > 0) {
		    span.setAttribute(genAiAttributes.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
		  }
		  if (totalTokens > 0) {
		    span.setAttribute(genAiAttributes.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
		  }
		}

		exports.extractAgentNameFromParams = extractAgentNameFromParams;
		exports.extractLLMFromParams = extractLLMFromParams;
		exports.extractModelMetadata = extractModelMetadata;
		exports.extractTokenUsageFromMessage = extractTokenUsageFromMessage;
		exports.extractToolCalls = extractToolCalls;
		exports.extractToolsFromCompiledGraph = extractToolsFromCompiledGraph;
		exports.setResponseAttributes = setResponseAttributes;
		exports.wrapToolsWithSpans = wrapToolsWithSpans;
		
	} (utils$8));
	return utils$8;
}

var hasRequiredLanggraph;

function requireLanggraph () {
	if (hasRequiredLanggraph) return langgraph;
	hasRequiredLanggraph = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const index = /*@__PURE__*/ requireLangchain();
		const utils$2 = /*@__PURE__*/ requireUtils$9();
		const constants = /*@__PURE__*/ requireConstants$2();
		const utils$1 = /*@__PURE__*/ requireUtils$8();

		let _insideCreateReactAgent = false;
		const SENTRY_PATCHED = "__sentry_patched__";
		function instrumentStateGraphCompile(originalCompile, options) {
		  if (Object.prototype.hasOwnProperty.call(originalCompile, SENTRY_PATCHED)) {
		    return originalCompile;
		  }
		  const sentryHandler = index.createLangChainCallbackHandler(options);
		  const wrapped = new Proxy(originalCompile, {
		    apply(target, thisArg, args) {
		      if (_insideCreateReactAgent) {
		        return Reflect.apply(target, thisArg, args);
		      }
		      return trace.startSpan(
		        {
		          op: "gen_ai.create_agent",
		          name: "create_agent",
		          attributes: {
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: constants.LANGGRAPH_ORIGIN,
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
		            [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
		          }
		        },
		        (span) => {
		          try {
		            const compiledGraph = Reflect.apply(target, thisArg, args);
		            const compileOptions = args.length > 0 ? args[0] : {};
		            if (compileOptions?.name && typeof compileOptions.name === "string") {
		              span.setAttribute(genAiAttributes.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
		              span.updateName(`create_agent ${compileOptions.name}`);
		            }
		            const originalInvoke = compiledGraph.invoke;
		            if (originalInvoke && typeof originalInvoke === "function") {
		              compiledGraph.invoke = instrumentCompiledGraphInvoke(
		                originalInvoke.bind(compiledGraph),
		                compiledGraph,
		                compileOptions,
		                options,
		                void 0,
		                sentryHandler
		              );
		            }
		            return compiledGraph;
		          } catch (error) {
		            span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		            exports$1.captureException(error, {
		              mechanism: {
		                handled: false,
		                type: "auto.ai.langgraph.error"
		              }
		            });
		            throw error;
		          }
		        }
		      );
		    }
		  });
		  Object.defineProperty(wrapped, SENTRY_PATCHED, { value: true, enumerable: false });
		  return wrapped;
		}
		function instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
		  return new Proxy(originalInvoke, {
		    apply(target, thisArg, args) {
		      const modelName = llm?.modelName ?? llm?.model;
		      return trace.startSpan(
		        {
		          op: "gen_ai.invoke_agent",
		          name: "invoke_agent",
		          attributes: {
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: constants.LANGGRAPH_ORIGIN,
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: genAiAttributes.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
		            [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
		          }
		        },
		        async (span) => {
		          try {
		            const graphName = compileOptions?.name;
		            if (graphName && typeof graphName === "string") {
		              span.setAttribute(genAiAttributes.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
		              span.setAttribute(genAiAttributes.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
		              span.updateName(`invoke_agent ${graphName}`);
		            }
		            if (modelName) {
		              span.setAttribute(genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
		            }
		            const config = args.length > 1 ? args[1] : void 0;
		            const configurable = config?.configurable;
		            const threadId = configurable?.thread_id;
		            if (threadId && typeof threadId === "string") {
		              span.setAttribute(genAiAttributes.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
		            }
		            if (sentryCallbackHandler) {
		              const invokeConfig = args[1] ?? {};
		              args[1] = invokeConfig;
		              const existingMetadata = invokeConfig.metadata ?? {};
		              invokeConfig.metadata = {
		                ...existingMetadata,
		                __sentry_langgraph__: true,
		                ...typeof graphName === "string" ? { lc_agent_name: graphName } : {}
		              };
		              invokeConfig.callbacks = utils$2._INTERNAL_mergeLangChainCallbackHandler(
		                invokeConfig.callbacks,
		                sentryCallbackHandler
		              );
		            }
		            const tools = utils$1.extractToolsFromCompiledGraph(graphInstance);
		            if (tools) {
		              span.setAttribute(genAiAttributes.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
		            }
		            const recordInputs = options.recordInputs;
		            const recordOutputs = options.recordOutputs;
		            const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
		            if (inputMessages && recordInputs) {
		              const normalizedMessages = utils$2.normalizeLangChainMessages(inputMessages);
		              const { systemInstructions, filteredMessages } = utils.extractSystemInstructions(normalizedMessages);
		              if (systemInstructions) {
		                span.setAttribute(genAiAttributes.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
		              }
		              const enableTruncation = utils.shouldEnableTruncation(options.enableTruncation);
		              const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
		              span.setAttributes({
		                [genAiAttributes.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? utils.getTruncatedJsonString(filteredMessages) : utils.getJsonString(filteredMessages),
		                [genAiAttributes.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
		              });
		            }
		            const result = await Reflect.apply(target, thisArg, args);
		            if (recordOutputs) {
		              utils$1.setResponseAttributes(span, inputMessages ?? null, result);
		            }
		            return result;
		          } catch (error) {
		            span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		            exports$1.captureException(error, {
		              mechanism: {
		                handled: false,
		                type: "auto.ai.langgraph.error"
		              }
		            });
		            throw error;
		          }
		        }
		      );
		    }
		  });
		}
		function instrumentCreateReactAgent(originalCreateReactAgent, options) {
		  if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, SENTRY_PATCHED)) {
		    return originalCreateReactAgent;
		  }
		  const resolvedOptions = utils.resolveAIRecordingOptions(options);
		  const sentryHandler = index.createLangChainCallbackHandler(resolvedOptions);
		  const wrapped = new Proxy(originalCreateReactAgent, {
		    apply(target, thisArg, args) {
		      const llm = utils$1.extractLLMFromParams(args);
		      const agentName = utils$1.extractAgentNameFromParams(args);
		      const params = args[0];
		      if (params && Array.isArray(params.tools) && params.tools.length > 0) {
		        utils$1.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
		      }
		      _insideCreateReactAgent = true;
		      let compiledGraph;
		      try {
		        compiledGraph = Reflect.apply(target, thisArg, args);
		      } finally {
		        _insideCreateReactAgent = false;
		      }
		      const originalInvoke = compiledGraph.invoke;
		      if (originalInvoke && typeof originalInvoke === "function") {
		        const compileOptions = {};
		        if (agentName) {
		          compileOptions.name = agentName;
		        }
		        compiledGraph.invoke = instrumentCompiledGraphInvoke(
		          originalInvoke.bind(compiledGraph),
		          compiledGraph,
		          compileOptions,
		          resolvedOptions,
		          llm,
		          sentryHandler
		        );
		      }
		      return compiledGraph;
		    }
		  });
		  Object.defineProperty(wrapped, SENTRY_PATCHED, { value: true, enumerable: false });
		  return wrapped;
		}
		function instrumentLangGraph(stateGraph, options) {
		  stateGraph.compile = instrumentStateGraphCompile(stateGraph.compile, utils.resolveAIRecordingOptions(options));
		  return stateGraph;
		}

		exports.instrumentCreateReactAgent = instrumentCreateReactAgent;
		exports.instrumentLangGraph = instrumentLangGraph;
		exports.instrumentStateGraphCompile = instrumentStateGraphCompile;
		
	} (langgraph));
	return langgraph;
}

var spanBuffer = {};

var envelope = {};

var hasRequiredEnvelope;

function requireEnvelope () {
	if (hasRequiredEnvelope) return envelope;
	hasRequiredEnvelope = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const dsn = /*@__PURE__*/ requireDsn();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const isBrowser = /*@__PURE__*/ requireIsBrowser();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();

		function createStreamedSpanEnvelope(serializedSpans, dsc, client) {
		  const options = client.getOptions();
		  const dsn$1 = client.getDsn();
		  const tunnel = options.tunnel;
		  const sdk = envelope.getSdkMetadataForEnvelopeHeader(options._metadata);
		  const headers = {
		    sent_at: new Date(randomSafeContext.safeDateNow()).toISOString(),
		    ...dscHasRequiredProps(dsc) && { trace: dsc },
		    ...sdk && { sdk },
		    ...!!tunnel && dsn$1 && { dsn: dsn.dsnToString(dsn$1) }
		  };
		  const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
		  const spanContainer = [
		    { type: "span", item_count: serializedSpans.length, content_type: "application/vnd.sentry.items.span.v2+json" },
		    {
		      version: 2,
		      ...isBrowser.isBrowser() && {
		        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
		      },
		      items: serializedSpans
		    }
		  ];
		  return envelope.createEnvelope(headers, [spanContainer]);
		}
		function dscHasRequiredProps(dsc) {
		  return !!dsc.trace_id && !!dsc.public_key;
		}

		exports.createStreamedSpanEnvelope = createStreamedSpanEnvelope;
		
	} (envelope));
	return envelope;
}

var estimateSize = {};

var hasRequiredEstimateSize;

function requireEstimateSize () {
	if (hasRequiredEstimateSize) return estimateSize;
	hasRequiredEstimateSize = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const attributes = /*@__PURE__*/ requireAttributes$1();

		function estimateSerializedSpanSizeInBytes(span) {
		  let weight = 156;
		  weight += span.name.length * 2;
		  weight += attributes.estimateTypedAttributesSizeInBytes(span.attributes);
		  if (span.links && span.links.length > 0) {
		    const firstLink = span.links[0];
		    const attributes$1 = firstLink?.attributes;
		    const linkWeight = 100 + (attributes$1 ? attributes.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
		    weight += linkWeight * span.links.length;
		  }
		  return weight;
		}

		exports.estimateSerializedSpanSizeInBytes = estimateSerializedSpanSizeInBytes;
		
	} (estimateSize));
	return estimateSize;
}

var hasRequiredSpanBuffer;

function requireSpanBuffer () {
	if (hasRequiredSpanBuffer) return spanBuffer;
	hasRequiredSpanBuffer = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const timer = /*@__PURE__*/ requireTimer();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const envelope = /*@__PURE__*/ requireEnvelope();
		const estimateSize = /*@__PURE__*/ requireEstimateSize();

		const MAX_SPANS_PER_ENVELOPE = 1e3;
		const MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
		class SpanBuffer {
		  constructor(client, options) {
		    this._traceBuckets = /* @__PURE__ */ new Map();
		    this._client = client;
		    const { maxSpanLimit, flushInterval, maxTraceWeightInBytes } = options ?? {};
		    this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : MAX_SPANS_PER_ENVELOPE;
		    this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
		    this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : MAX_TRACE_WEIGHT_IN_BYTES;
		    this._client.on("flush", () => {
		      this.drain();
		    });
		    this._client.on("close", () => {
		      this._traceBuckets.forEach((bucket) => {
		        clearTimeout(bucket.timeout);
		      });
		      this._traceBuckets.clear();
		    });
		  }
		  /**
		   * Add a span to the buffer.
		   */
		  add(spanJSON) {
		    const traceId = spanJSON.trace_id;
		    let bucket = this._traceBuckets.get(traceId);
		    if (!bucket) {
		      bucket = {
		        spans: /* @__PURE__ */ new Set(),
		        size: 0,
		        timeout: timer.safeUnref(
		          setTimeout(() => {
		            this.flush(traceId);
		          }, this._flushInterval)
		        )
		      };
		      this._traceBuckets.set(traceId, bucket);
		    }
		    bucket.spans.add(spanJSON);
		    bucket.size += estimateSize.estimateSerializedSpanSizeInBytes(spanJSON);
		    if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) {
		      this.flush(traceId);
		    }
		  }
		  /**
		   * Drain and flush all buffered traces.
		   */
		  drain() {
		    if (!this._traceBuckets.size) {
		      return;
		    }
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
		    this._traceBuckets.forEach((_, traceId) => {
		      this.flush(traceId);
		    });
		  }
		  /**
		   * Flush spans of a specific trace.
		   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
		   */
		  flush(traceId) {
		    const bucket = this._traceBuckets.get(traceId);
		    if (!bucket) {
		      return;
		    }
		    if (!bucket.spans.size) {
		      this._removeTrace(traceId);
		      return;
		    }
		    const spans = Array.from(bucket.spans);
		    const segmentSpan = spans[0]?._segmentSpan;
		    if (!segmentSpan) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
		      this._removeTrace(traceId);
		      return;
		    }
		    const dsc = dynamicSamplingContext.getDynamicSamplingContextFromSpan(segmentSpan);
		    const cleanedSpans = spans.map((spanJSON) => {
		      const { _segmentSpan, ...cleanSpanJSON } = spanJSON;
		      return cleanSpanJSON;
		    });
		    const envelope$1 = envelope.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
		    this._client.sendEnvelope(envelope$1).then(null, (reason) => {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.error("Error while sending streamed span envelope:", reason);
		    });
		    this._removeTrace(traceId);
		  }
		  _removeTrace(traceId) {
		    const bucket = this._traceBuckets.get(traceId);
		    if (bucket) {
		      clearTimeout(bucket.timeout);
		    }
		    this._traceBuckets.delete(traceId);
		  }
		}

		exports.SpanBuffer = SpanBuffer;
		
	} (spanBuffer));
	return spanBuffer;
}

var spanStreaming = {};

var hasRequiredSpanStreaming;

function requireSpanStreaming () {
	if (hasRequiredSpanStreaming) return spanStreaming;
	hasRequiredSpanStreaming = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const beforeSendSpan = /*@__PURE__*/ requireBeforeSendSpan();
		const captureSpan = /*@__PURE__*/ requireCaptureSpan();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const spanBuffer = /*@__PURE__*/ requireSpanBuffer();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();

		const spanStreamingIntegration = integration.defineIntegration(() => {
		  return {
		    name: "SpanStreaming",
		    setup(client) {
		      const initialMessage = "SpanStreaming integration requires";
		      const fallbackMsg = "Falling back to static trace lifecycle.";
		      const clientOptions = client.getOptions();
		      if (!hasSpanStreamingEnabled.hasSpanStreamingEnabled(client)) {
		        clientOptions.traceLifecycle = "static";
		        debugBuild.DEBUG_BUILD && debugLogger.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
		        return;
		      }
		      const beforeSendSpan$1 = clientOptions.beforeSendSpan;
		      if (beforeSendSpan$1 && !beforeSendSpan.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
		        clientOptions.traceLifecycle = "static";
		        debugBuild.DEBUG_BUILD && debugLogger.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
		        return;
		      }
		      const buffer = new spanBuffer.SpanBuffer(client);
		      client.on("afterSpanEnd", (span) => {
		        if (!spanUtils.spanIsSampled(span)) {
		          return;
		        }
		        buffer.add(captureSpan.captureSpan(span, client));
		      });
		    }
		  };
		});

		exports.spanStreamingIntegration = spanStreamingIntegration;
		
	} (spanStreaming));
	return spanStreaming;
}

var breadcrumbLogLevel = {};

var hasRequiredBreadcrumbLogLevel;

function requireBreadcrumbLogLevel () {
	if (hasRequiredBreadcrumbLogLevel) return breadcrumbLogLevel;
	hasRequiredBreadcrumbLogLevel = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
		  if (statusCode === void 0) {
		    return void 0;
		  } else if (statusCode >= 400 && statusCode < 500) {
		    return "warning";
		  } else if (statusCode >= 500) {
		    return "error";
		  } else {
		    return void 0;
		  }
		}

		exports.getBreadcrumbLogLevelFromHttpStatusCode = getBreadcrumbLogLevelFromHttpStatusCode;
		
	} (breadcrumbLogLevel));
	return breadcrumbLogLevel;
}

var error = {};

var hasRequiredError;

function requireError () {
	if (hasRequiredError) return error;
	hasRequiredError = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		class SentryError extends Error {
		  constructor(message, logLevel = "warn") {
		    super(message);
		    this.message = message;
		    this.logLevel = logLevel;
		  }
		}

		exports.SentryError = SentryError;
		
	} (error));
	return error;
}

var fetch$2 = {};

var supports = {};

var hasRequiredSupports;

function requireSupports () {
	if (hasRequiredSupports) return supports;
	hasRequiredSupports = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const WINDOW = worldwide.GLOBAL_OBJ;
		function supportsErrorEvent() {
		  try {
		    new ErrorEvent("");
		    return true;
		  } catch {
		    return false;
		  }
		}
		function supportsDOMError() {
		  try {
		    new DOMError("");
		    return true;
		  } catch {
		    return false;
		  }
		}
		function supportsDOMException() {
		  try {
		    new DOMException("");
		    return true;
		  } catch {
		    return false;
		  }
		}
		function supportsHistory() {
		  return "history" in WINDOW && !!WINDOW.history;
		}
		const supportsFetch = _isFetchSupported;
		function _isFetchSupported() {
		  if (!("fetch" in WINDOW)) {
		    return false;
		  }
		  try {
		    new Headers();
		    new Request("data:,");
		    new Response();
		    return true;
		  } catch {
		    return false;
		  }
		}
		function isNativeFunction(func) {
		  return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
		}
		function supportsNativeFetch() {
		  if (typeof EdgeRuntime === "string") {
		    return true;
		  }
		  if (!_isFetchSupported()) {
		    return false;
		  }
		  if (isNativeFunction(WINDOW.fetch)) {
		    return true;
		  }
		  let result = false;
		  const doc = WINDOW.document;
		  if (doc && typeof doc.createElement === "function") {
		    try {
		      const sandbox = doc.createElement("iframe");
		      sandbox.hidden = true;
		      doc.head.appendChild(sandbox);
		      if (sandbox.contentWindow?.fetch) {
		        result = isNativeFunction(sandbox.contentWindow.fetch);
		      }
		      doc.head.removeChild(sandbox);
		    } catch (err) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
		    }
		  }
		  return result;
		}
		function supportsReportingObserver() {
		  return "ReportingObserver" in WINDOW;
		}
		function supportsReferrerPolicy() {
		  if (!_isFetchSupported()) {
		    return false;
		  }
		  try {
		    new Request("_", {
		      referrerPolicy: "origin"
		    });
		    return true;
		  } catch {
		    return false;
		  }
		}

		exports.isNativeFunction = isNativeFunction;
		exports.supportsDOMError = supportsDOMError;
		exports.supportsDOMException = supportsDOMException;
		exports.supportsErrorEvent = supportsErrorEvent;
		exports.supportsFetch = supportsFetch;
		exports.supportsHistory = supportsHistory;
		exports.supportsNativeFetch = supportsNativeFetch;
		exports.supportsReferrerPolicy = supportsReferrerPolicy;
		exports.supportsReportingObserver = supportsReportingObserver;
		
	} (supports));
	return supports;
}

var hasRequiredFetch$1;

function requireFetch$1 () {
	if (hasRequiredFetch$1) return fetch$2;
	hasRequiredFetch$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const is = /*@__PURE__*/ requireIs$1();
		const object = /*@__PURE__*/ requireObject();
		const supports = /*@__PURE__*/ requireSupports();
		const time = /*@__PURE__*/ requireTime();
		const worldwide = /*@__PURE__*/ requireWorldwide();
		const handlers = /*@__PURE__*/ requireHandlers$1();

		function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
		  const type = "fetch";
		  const removeHandler = handlers.addHandler(type, handler);
		  handlers.maybeInstrument(type, () => instrumentFetch(void 0, skipNativeFetchCheck));
		  return removeHandler;
		}
		function addFetchEndInstrumentationHandler(handler) {
		  const type = "fetch-body-resolved";
		  const removeHandler = handlers.addHandler(type, handler);
		  handlers.maybeInstrument(type, () => instrumentFetch(streamHandler));
		  return removeHandler;
		}
		function instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
		  if (skipNativeFetchCheck && !supports.supportsNativeFetch()) {
		    return;
		  }
		  object.fill(worldwide.GLOBAL_OBJ, "fetch", function(originalFetch) {
		    return function(...args) {
		      const virtualError = new Error();
		      const { method, url } = parseFetchArgs(args);
		      const handlerData = {
		        args,
		        fetchData: {
		          method,
		          url
		        },
		        startTimestamp: time.timestampInSeconds() * 1e3,
		        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
		        virtualError,
		        headers: getHeadersFromFetchArgs(args)
		      };
		      if (!onFetchResolved) {
		        handlers.triggerHandlers("fetch", {
		          ...handlerData
		        });
		      }
		      return originalFetch.apply(worldwide.GLOBAL_OBJ, args).then(
		        async (response) => {
		          if (onFetchResolved) {
		            onFetchResolved(response);
		          } else {
		            handlers.triggerHandlers("fetch", {
		              ...handlerData,
		              endTimestamp: time.timestampInSeconds() * 1e3,
		              response
		            });
		          }
		          return response;
		        },
		        (error) => {
		          handlers.triggerHandlers("fetch", {
		            ...handlerData,
		            endTimestamp: time.timestampInSeconds() * 1e3,
		            error
		          });
		          if (is.isError(error) && error.stack === void 0) {
		            error.stack = virtualError.stack;
		            object.addNonEnumerableProperty(error, "framesToPop", 1);
		          }
		          const client = currentScopes.getClient();
		          const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
		          const shouldEnhance = enhanceOption !== false;
		          if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) {
		            try {
		              const url2 = new URL(handlerData.fetchData.url);
		              const hostname = url2.host;
		              if (enhanceOption === "always") {
		                error.message = `${error.message} (${hostname})`;
		              } else {
		                object.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
		              }
		            } catch {
		            }
		          }
		          throw error;
		        }
		      );
		    };
		  });
		}
		async function resolveResponse(res, onFinishedResolving) {
		  if (res?.body) {
		    const body = res.body;
		    const responseReader = body.getReader();
		    const maxFetchDurationTimeout = setTimeout(
		      () => {
		        body.cancel().then(null, () => {
		        });
		      },
		      90 * 1e3
		      // 90s
		    );
		    let readingActive = true;
		    while (readingActive) {
		      let chunkTimeout;
		      try {
		        chunkTimeout = setTimeout(() => {
		          body.cancel().then(null, () => {
		          });
		        }, 5e3);
		        const { done } = await responseReader.read();
		        clearTimeout(chunkTimeout);
		        if (done) {
		          onFinishedResolving();
		          readingActive = false;
		        }
		      } catch {
		        readingActive = false;
		      } finally {
		        clearTimeout(chunkTimeout);
		      }
		    }
		    clearTimeout(maxFetchDurationTimeout);
		    responseReader.releaseLock();
		    body.cancel().then(null, () => {
		    });
		  }
		}
		function streamHandler(response) {
		  let clonedResponseForResolving;
		  try {
		    clonedResponseForResolving = response.clone();
		  } catch {
		    return;
		  }
		  resolveResponse(clonedResponseForResolving, () => {
		    handlers.triggerHandlers("fetch-body-resolved", {
		      endTimestamp: time.timestampInSeconds() * 1e3,
		      response
		    });
		  });
		}
		function hasProp(obj, prop) {
		  return !!obj && typeof obj === "object" && !!obj[prop];
		}
		function getUrlFromResource(resource) {
		  if (typeof resource === "string") {
		    return resource;
		  }
		  if (!resource) {
		    return "";
		  }
		  if (hasProp(resource, "url")) {
		    return resource.url;
		  }
		  if (resource.toString) {
		    return resource.toString();
		  }
		  return "";
		}
		function parseFetchArgs(fetchArgs) {
		  if (fetchArgs.length === 0) {
		    return { method: "GET", url: "" };
		  }
		  if (fetchArgs.length === 2) {
		    const [resource, options] = fetchArgs;
		    return {
		      url: getUrlFromResource(resource),
		      method: hasProp(options, "method") ? String(options.method).toUpperCase() : (
		        // Request object as first argument
		        is.isRequest(resource) && hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
		      )
		    };
		  }
		  const arg = fetchArgs[0];
		  return {
		    url: getUrlFromResource(arg),
		    method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
		  };
		}
		function getHeadersFromFetchArgs(fetchArgs) {
		  const [requestArgument, optionsArgument] = fetchArgs;
		  try {
		    if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) {
		      return new Headers(optionsArgument.headers);
		    }
		    if (is.isRequest(requestArgument)) {
		      return new Headers(requestArgument.headers);
		    }
		  } catch {
		  }
		  return;
		}

		exports.addFetchEndInstrumentationHandler = addFetchEndInstrumentationHandler;
		exports.addFetchInstrumentationHandler = addFetchInstrumentationHandler;
		exports.parseFetchArgs = parseFetchArgs;
		
	} (fetch$2));
	return fetch$2;
}

var exports = {};

var hasRequiredExports;

function requireExports () {
	if (hasRequiredExports) return exports;
	hasRequiredExports = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function replaceExports(exports, exportName, wrappedConstructor) {
		  const original = exports[exportName];
		  if (typeof original !== "function") {
		    return;
		  }
		  try {
		    exports[exportName] = wrappedConstructor;
		  } catch {
		    Object.defineProperty(exports, exportName, {
		      value: wrappedConstructor,
		      writable: true,
		      configurable: true,
		      enumerable: true
		    });
		  }
		  if (exports.default === original) {
		    try {
		      exports.default = wrappedConstructor;
		    } catch {
		      Object.defineProperty(exports, "default", {
		        value: wrappedConstructor,
		        writable: true,
		        configurable: true,
		        enumerable: true
		      });
		    }
		  }
		}

		exports.replaceExports = replaceExports;
		
	} (exports));
	return exports;
}

var lru = {};

var hasRequiredLru;

function requireLru () {
	if (hasRequiredLru) return lru;
	hasRequiredLru = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		class LRUMap {
		  constructor(_maxSize) {
		    this._maxSize = _maxSize;
		    this._cache = /* @__PURE__ */ new Map();
		  }
		  /** Get the current size of the cache */
		  get size() {
		    return this._cache.size;
		  }
		  /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */
		  get(key) {
		    const value = this._cache.get(key);
		    if (value === void 0) {
		      return void 0;
		    }
		    this._cache.delete(key);
		    this._cache.set(key, value);
		    return value;
		  }
		  /** Insert an entry and evict an older entry if we've reached maxSize */
		  set(key, value) {
		    if (this._cache.size >= this._maxSize) {
		      const nextKey = this._cache.keys().next().value;
		      this._cache.delete(nextKey);
		    }
		    this._cache.set(key, value);
		  }
		  /** Remove an entry and return the entry if it was in the cache */
		  remove(key) {
		    const value = this._cache.get(key);
		    if (value) {
		      this._cache.delete(key);
		    }
		    return value;
		  }
		  /** Clear all entries */
		  clear() {
		    this._cache.clear();
		  }
		  /** Get all the keys */
		  keys() {
		    return Array.from(this._cache.keys());
		  }
		  /** Get all the values */
		  values() {
		    const values = [];
		    this._cache.forEach((value) => values.push(value));
		    return values;
		  }
		}

		exports.LRUMap = LRUMap;
		
	} (lru));
	return lru;
}

var escapeStringForRegex = {};

var hasRequiredEscapeStringForRegex;

function requireEscapeStringForRegex () {
	if (hasRequiredEscapeStringForRegex) return escapeStringForRegex;
	hasRequiredEscapeStringForRegex = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function escapeStringForRegex(regexString) {
		  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
		}

		exports.escapeStringForRegex = escapeStringForRegex;
		
	} (escapeStringForRegex));
	return escapeStringForRegex;
}

var serverRuntimeClient = {};

var userAgent = {};

var hasRequiredUserAgent;

function requireUserAgent () {
	if (hasRequiredUserAgent) return userAgent;
	hasRequiredUserAgent = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function addUserAgentToTransportHeaders(options) {
		  const sdkMetadata = options._metadata?.sdk;
		  const sdkUserAgent = sdkMetadata?.name && sdkMetadata?.version ? `${sdkMetadata?.name}/${sdkMetadata?.version}` : void 0;
		  options.transportOptions = {
		    ...options.transportOptions,
		    headers: {
		      ...sdkUserAgent && { "user-agent": sdkUserAgent },
		      ...options.transportOptions?.headers
		    }
		  };
		}

		exports.addUserAgentToTransportHeaders = addUserAgentToTransportHeaders;
		
	} (userAgent));
	return userAgent;
}

var hasRequiredServerRuntimeClient;

function requireServerRuntimeClient () {
	if (hasRequiredServerRuntimeClient) return serverRuntimeClient;
	hasRequiredServerRuntimeClient = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const checkin = /*@__PURE__*/ requireCheckin();
		const client = /*@__PURE__*/ requireClient$1();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const base = /*@__PURE__*/ requireBase$2();
		const userAgent = /*@__PURE__*/ requireUserAgent();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder$1();
		const misc = /*@__PURE__*/ requireMisc();
		const promisebuffer = /*@__PURE__*/ requirePromisebuffer();
		const syncpromise = /*@__PURE__*/ requireSyncpromise();
		const traceInfo = /*@__PURE__*/ requireTraceInfo();

		class ServerRuntimeClient extends client.Client {
		  /**
		   * Creates a new Edge SDK instance.
		   * @param options Configuration options for this SDK.
		   */
		  constructor(options) {
		    userAgent.addUserAgentToTransportHeaders(options);
		    super(options);
		    this._disposeCallbacks = [];
		    this._setUpMetricsProcessing();
		  }
		  /**
		   * @inheritDoc
		   */
		  eventFromException(exception, hint) {
		    const event = eventbuilder.eventFromUnknownInput(this, this._options.stackParser, exception, hint);
		    event.level = "error";
		    return syncpromise.resolvedSyncPromise(event);
		  }
		  /**
		   * @inheritDoc
		   */
		  eventFromMessage(message, level = "info", hint) {
		    return syncpromise.resolvedSyncPromise(
		      eventbuilder.eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace)
		    );
		  }
		  /**
		   * @inheritDoc
		   */
		  captureException(exception, hint, scope) {
		    setCurrentRequestSessionErroredOrCrashed(hint);
		    return super.captureException(exception, hint, scope);
		  }
		  /**
		   * @inheritDoc
		   */
		  captureEvent(event, hint, scope) {
		    const isException = !event.type && event.exception?.values && event.exception.values.length > 0;
		    if (isException) {
		      setCurrentRequestSessionErroredOrCrashed(hint);
		    }
		    return super.captureEvent(event, hint, scope);
		  }
		  /**
		   * Create a cron monitor check in and send it to Sentry.
		   *
		   * @param checkIn An object that describes a check in.
		   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
		   * to create a monitor automatically when sending a check in.
		   */
		  captureCheckIn(checkIn, monitorConfig, scope) {
		    const id = "checkInId" in checkIn && checkIn.checkInId ? checkIn.checkInId : misc.uuid4();
		    if (!this._isEnabled()) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("SDK not enabled, will not capture check-in.");
		      return id;
		    }
		    const options = this.getOptions();
		    const { release, environment, tunnel } = options;
		    const serializedCheckIn = {
		      check_in_id: id,
		      monitor_slug: checkIn.monitorSlug,
		      status: checkIn.status,
		      release,
		      environment
		    };
		    if ("duration" in checkIn) {
		      serializedCheckIn.duration = checkIn.duration;
		    }
		    if (monitorConfig) {
		      serializedCheckIn.monitor_config = {
		        schedule: monitorConfig.schedule,
		        checkin_margin: monitorConfig.checkinMargin,
		        max_runtime: monitorConfig.maxRuntime,
		        timezone: monitorConfig.timezone,
		        failure_issue_threshold: monitorConfig.failureIssueThreshold,
		        recovery_threshold: monitorConfig.recoveryThreshold
		      };
		    }
		    const [dynamicSamplingContext, traceContext] = traceInfo._getTraceInfoFromScope(this, scope);
		    if (traceContext) {
		      serializedCheckIn.contexts = {
		        trace: traceContext
		      };
		    }
		    const envelope = checkin.createCheckInEnvelope(
		      serializedCheckIn,
		      dynamicSamplingContext,
		      this.getSdkMetadata(),
		      tunnel,
		      this.getDsn()
		    );
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("Sending checkin:", checkIn.monitorSlug, checkIn.status);
		    this.sendEnvelope(envelope);
		    return id;
		  }
		  /**
		   * @inheritDoc
		   */
		  registerCleanup(callback) {
		    this._disposeCallbacks.push(callback);
		  }
		  /**
		   * Disposes of the client and releases all resources.
		   *
		   * This method clears all internal state to allow the client to be garbage collected.
		   * It clears hooks, event processors, integrations, transport, and other internal references.
		   *
		   * Call this method after flushing to allow the client to be garbage collected.
		   * After calling dispose(), the client should not be used anymore.
		   *
		   * Subclasses should override this method to clean up their own resources and call `super.dispose()`.
		   */
		  dispose() {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.log("Disposing client...");
		    for (const callback of this._disposeCallbacks) {
		      try {
		        callback();
		      } catch {
		      }
		    }
		    this._disposeCallbacks.length = 0;
		    for (const hookName of Object.keys(this._hooks)) {
		      this._hooks[hookName]?.clear();
		    }
		    this._hooks = {};
		    this._eventProcessors.length = 0;
		    this._integrations = {};
		    this._outcomes = {};
		    this._transport = void 0;
		    this._promiseBuffer = promisebuffer.makePromiseBuffer(base.DEFAULT_TRANSPORT_BUFFER_SIZE);
		  }
		  /**
		   * @inheritDoc
		   */
		  _prepareEvent(event, hint, currentScope, isolationScope) {
		    if (this._options.platform) {
		      event.platform = event.platform || this._options.platform;
		    }
		    if (this._options.runtime) {
		      event.contexts = {
		        ...event.contexts,
		        runtime: event.contexts?.runtime || this._options.runtime
		      };
		    }
		    if (this._options.serverName) {
		      event.server_name = event.server_name || this._options.serverName;
		    }
		    return super._prepareEvent(event, hint, currentScope, isolationScope);
		  }
		  /**
		   * Process a server-side metric before it is captured.
		   */
		  _setUpMetricsProcessing() {
		    this.on("processMetric", (metric) => {
		      if (this._options.serverName) {
		        metric.attributes = {
		          "server.address": this._options.serverName,
		          ...metric.attributes
		        };
		      }
		    });
		  }
		}
		function setCurrentRequestSessionErroredOrCrashed(eventHint) {
		  const requestSession = currentScopes.getIsolationScope().getScopeData().sdkProcessingMetadata.requestSession;
		  if (requestSession) {
		    const isHandledException = eventHint?.mechanism?.handled ?? true;
		    if (isHandledException && requestSession.status !== "crashed") {
		      requestSession.status = "errored";
		    } else if (!isHandledException) {
		      requestSession.status = "crashed";
		    }
		  }
		}

		exports.ServerRuntimeClient = ServerRuntimeClient;
		
	} (serverRuntimeClient));
	return serverRuntimeClient;
}

var trpc = {};

var hasRequiredTrpc;

function requireTrpc () {
	if (hasRequiredTrpc) return trpc;
	hasRequiredTrpc = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const normalize = /*@__PURE__*/ requireNormalize();
		const trace = /*@__PURE__*/ requireTrace();
		const normalizationHints = /*@__PURE__*/ requireNormalizationHints();

		const trpcCaptureContext = { mechanism: { handled: false, type: "auto.rpc.trpc.middleware" } };
		function captureIfError(nextResult) {
		  if (typeof nextResult === "object" && nextResult !== null && "ok" in nextResult && !nextResult.ok && "error" in nextResult) {
		    exports$1.captureException(nextResult.error, trpcCaptureContext);
		  }
		}
		function trpcMiddleware(options = {}) {
		  return async function(opts) {
		    const { path, type, next, rawInput, getRawInput } = opts;
		    const client = currentScopes.getClient();
		    const clientOptions = client?.getOptions();
		    const dataCollection = client?.getDataCollectionOptions();
		    const trpcContext = {
		      procedure_path: path,
		      procedure_type: type
		    };
		    normalizationHints.setNormalizationDepthOverrideHint(
		      trpcContext,
		      1 + // 1 for context.input + the normal normalization depth
		      (clientOptions?.normalizeDepth ?? 5)
		      // 5 is a sane depth
		    );
		    if (options.attachRpcInput !== void 0 ? options.attachRpcInput : dataCollection?.httpBodies.includes("incomingRequest")) {
		      if (rawInput !== void 0) {
		        trpcContext.input = normalize.normalize(rawInput);
		      }
		      if (getRawInput !== void 0 && typeof getRawInput === "function") {
		        try {
		          const rawRes = await getRawInput();
		          trpcContext.input = normalize.normalize(rawRes);
		        } catch {
		        }
		      }
		    }
		    return currentScopes.withIsolationScope((scope) => {
		      scope.setContext("trpc", trpcContext);
		      return trace.startSpanManual(
		        {
		          name: `trpc/${path}`,
		          op: "rpc.server",
		          attributes: {
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "route",
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.rpc.trpc"
		          },
		          forceTransaction: !!options.forceTransaction
		        },
		        async (span) => {
		          try {
		            const nextResult = await next();
		            captureIfError(nextResult);
		            span.end();
		            return nextResult;
		          } catch (e) {
		            exports$1.captureException(e, trpcCaptureContext);
		            span.end();
		            throw e;
		          }
		        }
		      );
		    });
		  };
		}

		exports.trpcMiddleware = trpcMiddleware;
		
	} (trpc));
	return trpc;
}

var mcpServer = {};

var handlers = {};

var errorCapture = {};

var hasRequiredErrorCapture;

function requireErrorCapture () {
	if (hasRequiredErrorCapture) return errorCapture;
	hasRequiredErrorCapture = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();

		function captureError(error, errorType, extraData) {
		  try {
		    const client = currentScopes.getClient();
		    if (!client) {
		      return;
		    }
		    const activeSpan = spanUtils.getActiveSpan();
		    if (activeSpan?.isRecording()) {
		      activeSpan.setStatus({
		        code: spanstatus.SPAN_STATUS_ERROR,
		        message: "internal_error"
		      });
		    }
		    exports$1.captureException(error, {
		      mechanism: {
		        type: "auto.ai.mcp_server",
		        handled: false,
		        data: {
		          error_type: errorType || "handler_execution",
		          ...extraData
		        }
		      }
		    });
		  } catch {
		  }
		}

		exports.captureError = captureError;
		
	} (errorCapture));
	return errorCapture;
}

var hasRequiredHandlers;

function requireHandlers () {
	if (hasRequiredHandlers) return handlers;
	hasRequiredHandlers = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const object = /*@__PURE__*/ requireObject();
		const errorCapture = /*@__PURE__*/ requireErrorCapture();

		function wrapMethodHandler(serverInstance, methodName) {
		  object.fill(serverInstance, methodName, (originalMethod) => {
		    return function(name, ...args) {
		      const handler = args[args.length - 1];
		      if (typeof handler !== "function") {
		        return originalMethod.call(this, name, ...args);
		      }
		      const wrappedHandler = createWrappedHandler(handler, methodName, name);
		      return originalMethod.call(this, name, ...args.slice(0, -1), wrappedHandler);
		    };
		  });
		}
		function createWrappedHandler(originalHandler, methodName, handlerName) {
		  return function(...handlerArgs) {
		    try {
		      return createErrorCapturingHandler.call(this, originalHandler, methodName, handlerName, handlerArgs);
		    } catch (error) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("MCP handler wrapping failed:", error);
		      return originalHandler.apply(this, handlerArgs);
		    }
		  };
		}
		function createErrorCapturingHandler(originalHandler, methodName, handlerName, handlerArgs) {
		  try {
		    const result = originalHandler.apply(this, handlerArgs);
		    if (result && typeof result === "object" && typeof result.then === "function") {
		      return Promise.resolve(result).catch((error) => {
		        captureHandlerError(error, methodName, handlerName);
		        throw error;
		      });
		    }
		    return result;
		  } catch (error) {
		    captureHandlerError(error, methodName, handlerName);
		    throw error;
		  }
		}
		function captureHandlerError(error, methodName, handlerName) {
		  try {
		    const extraData = {};
		    if (methodName === "tool" || methodName === "registerTool") {
		      extraData.tool_name = handlerName;
		      if (error.name === "ProtocolValidationError" || error.message.includes("validation") || error.message.includes("protocol")) {
		        errorCapture.captureError(error, "validation", extraData);
		      } else if (error.name === "ServerTimeoutError" || error.message.includes("timed out") || error.message.includes("timeout")) {
		        errorCapture.captureError(error, "timeout", extraData);
		      } else {
		        errorCapture.captureError(error, "tool_execution", extraData);
		      }
		    } else if (methodName === "resource" || methodName === "registerResource") {
		      extraData.resource_uri = handlerName;
		      errorCapture.captureError(error, "resource_execution", extraData);
		    } else if (methodName === "prompt" || methodName === "registerPrompt") {
		      extraData.prompt_name = handlerName;
		      errorCapture.captureError(error, "prompt_execution", extraData);
		    }
		  } catch (_captureErr) {
		  }
		}
		function wrapToolHandlers(serverInstance) {
		  if (typeof serverInstance.tool === "function") wrapMethodHandler(serverInstance, "tool");
		  if (typeof serverInstance.registerTool === "function") wrapMethodHandler(serverInstance, "registerTool");
		}
		function wrapResourceHandlers(serverInstance) {
		  if (typeof serverInstance.resource === "function") wrapMethodHandler(serverInstance, "resource");
		  if (typeof serverInstance.registerResource === "function") wrapMethodHandler(serverInstance, "registerResource");
		}
		function wrapPromptHandlers(serverInstance) {
		  if (typeof serverInstance.prompt === "function") wrapMethodHandler(serverInstance, "prompt");
		  if (typeof serverInstance.registerPrompt === "function") wrapMethodHandler(serverInstance, "registerPrompt");
		}
		function wrapAllMCPHandlers(serverInstance) {
		  wrapToolHandlers(serverInstance);
		  wrapResourceHandlers(serverInstance);
		  wrapPromptHandlers(serverInstance);
		}
		function wrapExistingHandlers(serverInstance) {
		  const server = serverInstance;
		  const registeredTools = server["_registeredTools"];
		  if (registeredTools && typeof registeredTools === "object") {
		    for (const [name, tool] of Object.entries(registeredTools)) {
		      if (typeof tool["executor"] === "function") {
		        tool["executor"] = createWrappedHandler(tool["executor"], "registerTool", name);
		      }
		    }
		  }
		  const registeredResources = server["_registeredResources"];
		  if (registeredResources && typeof registeredResources === "object") {
		    for (const [name, resource] of Object.entries(registeredResources)) {
		      if (typeof resource["readCallback"] === "function") {
		        resource["readCallback"] = createWrappedHandler(
		          resource["readCallback"],
		          "registerResource",
		          name
		        );
		      }
		    }
		  }
		  const registeredResourceTemplates = server["_registeredResourceTemplates"];
		  if (registeredResourceTemplates && typeof registeredResourceTemplates === "object") {
		    for (const [name, template] of Object.entries(
		      registeredResourceTemplates
		    )) {
		      if (typeof template["readCallback"] === "function") {
		        template["readCallback"] = createWrappedHandler(
		          template["readCallback"],
		          "registerResource",
		          name
		        );
		      }
		    }
		  }
		  const registeredPrompts = server["_registeredPrompts"];
		  if (registeredPrompts && typeof registeredPrompts === "object") {
		    for (const [name, prompt] of Object.entries(registeredPrompts)) {
		      if (typeof prompt["handler"] === "function") {
		        prompt["handler"] = createWrappedHandler(prompt["handler"], "registerPrompt", name);
		      }
		    }
		  }
		}

		exports.wrapAllMCPHandlers = wrapAllMCPHandlers;
		exports.wrapExistingHandlers = wrapExistingHandlers;
		exports.wrapPromptHandlers = wrapPromptHandlers;
		exports.wrapResourceHandlers = wrapResourceHandlers;
		exports.wrapToolHandlers = wrapToolHandlers;
		
	} (handlers));
	return handlers;
}

var transport = {};

var attributes = {};

var hasRequiredAttributes;

function requireAttributes () {
	if (hasRequiredAttributes) return attributes;
	hasRequiredAttributes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const MCP_METHOD_NAME_ATTRIBUTE = "mcp.method.name";
		const MCP_REQUEST_ID_ATTRIBUTE = "mcp.request.id";
		const MCP_SESSION_ID_ATTRIBUTE = "mcp.session.id";
		const MCP_TRANSPORT_ATTRIBUTE = "mcp.transport";
		const MCP_SERVER_NAME_ATTRIBUTE = "mcp.server.name";
		const MCP_SERVER_TITLE_ATTRIBUTE = "mcp.server.title";
		const MCP_SERVER_VERSION_ATTRIBUTE = "mcp.server.version";
		const MCP_PROTOCOL_VERSION_ATTRIBUTE = "mcp.protocol.version";
		const MCP_TOOL_NAME_ATTRIBUTE = "mcp.tool.name";
		const MCP_RESOURCE_URI_ATTRIBUTE = "mcp.resource.uri";
		const MCP_PROMPT_NAME_ATTRIBUTE = "mcp.prompt.name";
		const MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE = "mcp.tool.result.is_error";
		const MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE = "mcp.tool.result.content_count";
		const MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE = "mcp.prompt.result.description";
		const MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE = "mcp.prompt.result.message_count";
		const MCP_REQUEST_ARGUMENT = "mcp.request.argument";
		const MCP_LOGGING_LEVEL_ATTRIBUTE = "mcp.logging.level";
		const MCP_LOGGING_LOGGER_ATTRIBUTE = "mcp.logging.logger";
		const MCP_LOGGING_DATA_TYPE_ATTRIBUTE = "mcp.logging.data_type";
		const MCP_LOGGING_MESSAGE_ATTRIBUTE = "mcp.logging.message";
		const NETWORK_TRANSPORT_ATTRIBUTE = "network.transport";
		const NETWORK_PROTOCOL_VERSION_ATTRIBUTE = "network.protocol.version";
		const CLIENT_ADDRESS_ATTRIBUTE = "client.address";
		const CLIENT_PORT_ATTRIBUTE = "client.port";
		const MCP_SERVER_OP_VALUE = "mcp.server";
		const MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE = "mcp.notification.client_to_server";
		const MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE = "mcp.notification.server_to_client";
		const MCP_FUNCTION_ORIGIN_VALUE = "auto.function.mcp_server";
		const MCP_NOTIFICATION_ORIGIN_VALUE = "auto.mcp.notification";
		const MCP_ROUTE_SOURCE_VALUE = "route";

		exports.CLIENT_ADDRESS_ATTRIBUTE = CLIENT_ADDRESS_ATTRIBUTE;
		exports.CLIENT_PORT_ATTRIBUTE = CLIENT_PORT_ATTRIBUTE;
		exports.MCP_FUNCTION_ORIGIN_VALUE = MCP_FUNCTION_ORIGIN_VALUE;
		exports.MCP_LOGGING_DATA_TYPE_ATTRIBUTE = MCP_LOGGING_DATA_TYPE_ATTRIBUTE;
		exports.MCP_LOGGING_LEVEL_ATTRIBUTE = MCP_LOGGING_LEVEL_ATTRIBUTE;
		exports.MCP_LOGGING_LOGGER_ATTRIBUTE = MCP_LOGGING_LOGGER_ATTRIBUTE;
		exports.MCP_LOGGING_MESSAGE_ATTRIBUTE = MCP_LOGGING_MESSAGE_ATTRIBUTE;
		exports.MCP_METHOD_NAME_ATTRIBUTE = MCP_METHOD_NAME_ATTRIBUTE;
		exports.MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE = MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE;
		exports.MCP_NOTIFICATION_ORIGIN_VALUE = MCP_NOTIFICATION_ORIGIN_VALUE;
		exports.MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE = MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE;
		exports.MCP_PROMPT_NAME_ATTRIBUTE = MCP_PROMPT_NAME_ATTRIBUTE;
		exports.MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE = MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE;
		exports.MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE = MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE;
		exports.MCP_PROTOCOL_VERSION_ATTRIBUTE = MCP_PROTOCOL_VERSION_ATTRIBUTE;
		exports.MCP_REQUEST_ARGUMENT = MCP_REQUEST_ARGUMENT;
		exports.MCP_REQUEST_ID_ATTRIBUTE = MCP_REQUEST_ID_ATTRIBUTE;
		exports.MCP_RESOURCE_URI_ATTRIBUTE = MCP_RESOURCE_URI_ATTRIBUTE;
		exports.MCP_ROUTE_SOURCE_VALUE = MCP_ROUTE_SOURCE_VALUE;
		exports.MCP_SERVER_NAME_ATTRIBUTE = MCP_SERVER_NAME_ATTRIBUTE;
		exports.MCP_SERVER_OP_VALUE = MCP_SERVER_OP_VALUE;
		exports.MCP_SERVER_TITLE_ATTRIBUTE = MCP_SERVER_TITLE_ATTRIBUTE;
		exports.MCP_SERVER_VERSION_ATTRIBUTE = MCP_SERVER_VERSION_ATTRIBUTE;
		exports.MCP_SESSION_ID_ATTRIBUTE = MCP_SESSION_ID_ATTRIBUTE;
		exports.MCP_TOOL_NAME_ATTRIBUTE = MCP_TOOL_NAME_ATTRIBUTE;
		exports.MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE = MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE;
		exports.MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE = MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE;
		exports.MCP_TRANSPORT_ATTRIBUTE = MCP_TRANSPORT_ATTRIBUTE;
		exports.NETWORK_PROTOCOL_VERSION_ATTRIBUTE = NETWORK_PROTOCOL_VERSION_ATTRIBUTE;
		exports.NETWORK_TRANSPORT_ATTRIBUTE = NETWORK_TRANSPORT_ATTRIBUTE;
		
	} (attributes));
	return attributes;
}

var correlation = {};

var resultExtraction = {};

var validation = {};

var hasRequiredValidation;

function requireValidation () {
	if (hasRequiredValidation) return validation;
	hasRequiredValidation = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();

		function isJsonRpcRequest(message) {
		  return typeof message === "object" && message !== null && "jsonrpc" in message && message.jsonrpc === "2.0" && "method" in message && "id" in message;
		}
		function isJsonRpcNotification(message) {
		  return typeof message === "object" && message !== null && "jsonrpc" in message && message.jsonrpc === "2.0" && "method" in message && !("id" in message);
		}
		function isJsonRpcResponse(message) {
		  return typeof message === "object" && message !== null && "jsonrpc" in message && message.jsonrpc === "2.0" && "id" in message && ("result" in message || "error" in message);
		}
		function validateMcpServerInstance(instance) {
		  if (typeof instance === "object" && instance !== null && "connect" in instance && ("tool" in instance && "resource" in instance && "prompt" in instance || "registerTool" in instance && "registerResource" in instance && "registerPrompt" in instance)) {
		    return true;
		  }
		  debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Did not patch MCP server. Interface is incompatible.");
		  return false;
		}
		function isValidContentItem(item) {
		  return item != null && typeof item === "object";
		}

		exports.isJsonRpcNotification = isJsonRpcNotification;
		exports.isJsonRpcRequest = isJsonRpcRequest;
		exports.isJsonRpcResponse = isJsonRpcResponse;
		exports.isValidContentItem = isValidContentItem;
		exports.validateMcpServerInstance = validateMcpServerInstance;
		
	} (validation));
	return validation;
}

var hasRequiredResultExtraction;

function requireResultExtraction () {
	if (hasRequiredResultExtraction) return resultExtraction;
	hasRequiredResultExtraction = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const attributes = /*@__PURE__*/ requireAttributes();
		const validation = /*@__PURE__*/ requireValidation();

		function buildAllContentItemAttributes(content, includeContent) {
		  const attributes$1 = {
		    [attributes.MCP_TOOL_RESULT_CONTENT_COUNT_ATTRIBUTE]: content.length
		  };
		  for (const [i, item] of content.entries()) {
		    if (!validation.isValidContentItem(item)) {
		      continue;
		    }
		    const prefix = content.length === 1 ? "mcp.tool.result" : `mcp.tool.result.${i}`;
		    if (typeof item.type === "string") {
		      attributes$1[`${prefix}.content_type`] = item.type;
		    }
		    if (includeContent) {
		      const safeSet = (key, value) => {
		        if (typeof value === "string") {
		          attributes$1[`${prefix}.${key}`] = value;
		        }
		      };
		      safeSet("mime_type", item.mimeType);
		      safeSet("uri", item.uri);
		      safeSet("name", item.name);
		      if (typeof item.text === "string") {
		        attributes$1[`${prefix}.content`] = item.text;
		      }
		      if (typeof item.data === "string") {
		        attributes$1[`${prefix}.data_size`] = item.data.length;
		      }
		      const resource = item.resource;
		      if (validation.isValidContentItem(resource)) {
		        safeSet("resource_uri", resource.uri);
		        safeSet("resource_mime_type", resource.mimeType);
		      }
		    }
		  }
		  return attributes$1;
		}
		function extractToolResultAttributes(result, recordOutputs) {
		  if (!validation.isValidContentItem(result)) {
		    return {};
		  }
		  const attributes$1 = Array.isArray(result.content) ? buildAllContentItemAttributes(result.content, recordOutputs) : {};
		  if (typeof result.isError === "boolean") {
		    attributes$1[attributes.MCP_TOOL_RESULT_IS_ERROR_ATTRIBUTE] = result.isError;
		  }
		  return attributes$1;
		}
		function extractPromptResultAttributes(result, recordOutputs) {
		  const attributes$1 = {};
		  if (!validation.isValidContentItem(result)) {
		    return attributes$1;
		  }
		  if (recordOutputs && typeof result.description === "string") {
		    attributes$1[attributes.MCP_PROMPT_RESULT_DESCRIPTION_ATTRIBUTE] = result.description;
		  }
		  if (Array.isArray(result.messages)) {
		    attributes$1[attributes.MCP_PROMPT_RESULT_MESSAGE_COUNT_ATTRIBUTE] = result.messages.length;
		    if (recordOutputs) {
		      const messages = result.messages;
		      for (const [i, message] of messages.entries()) {
		        if (!validation.isValidContentItem(message)) {
		          continue;
		        }
		        const prefix = messages.length === 1 ? "mcp.prompt.result" : `mcp.prompt.result.${i}`;
		        const safeSet = (key, value) => {
		          if (typeof value === "string") {
		            const attrName = messages.length === 1 ? `${prefix}.message_${key}` : `${prefix}.${key}`;
		            attributes$1[attrName] = value;
		          }
		        };
		        safeSet("role", message.role);
		        if (validation.isValidContentItem(message.content)) {
		          const content = message.content;
		          if (typeof content.text === "string") {
		            const attrName = messages.length === 1 ? `${prefix}.message_content` : `${prefix}.content`;
		            attributes$1[attrName] = content.text;
		          }
		        }
		      }
		    }
		  }
		  return attributes$1;
		}

		exports.extractPromptResultAttributes = extractPromptResultAttributes;
		exports.extractToolResultAttributes = extractToolResultAttributes;
		
	} (resultExtraction));
	return resultExtraction;
}

var sessionExtraction = {};

var sessionManagement = {};

var hasRequiredSessionManagement;

function requireSessionManagement () {
	if (hasRequiredSessionManagement) return sessionManagement;
	hasRequiredSessionManagement = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const sessionToSessionData = /* @__PURE__ */ new Map();
		const statelessSessionData = /* @__PURE__ */ new WeakMap();
		function getSessionData(transport) {
		  const sessionId = transport.sessionId;
		  if (sessionId) {
		    return sessionToSessionData.get(sessionId);
		  }
		  return statelessSessionData.get(transport);
		}
		function setSessionData(transport, data) {
		  const sessionId = transport.sessionId;
		  if (sessionId) {
		    sessionToSessionData.set(sessionId, data);
		  } else {
		    statelessSessionData.set(transport, data);
		  }
		}
		function storeSessionDataForTransport(transport, sessionData) {
		  setSessionData(transport, sessionData);
		}
		function updateSessionDataForTransport(transport, partialSessionData) {
		  const existingData = getSessionData(transport) || {};
		  setSessionData(transport, { ...existingData, ...partialSessionData });
		}
		function getClientInfoForTransport(transport) {
		  return getSessionData(transport)?.clientInfo;
		}
		function getProtocolVersionForTransport(transport) {
		  return getSessionData(transport)?.protocolVersion;
		}
		function getSessionDataForTransport(transport) {
		  return getSessionData(transport);
		}
		function cleanupSessionDataForTransport(transport) {
		  const sessionId = transport.sessionId;
		  if (sessionId) {
		    sessionToSessionData.delete(sessionId);
		  }
		}

		exports.cleanupSessionDataForTransport = cleanupSessionDataForTransport;
		exports.getClientInfoForTransport = getClientInfoForTransport;
		exports.getProtocolVersionForTransport = getProtocolVersionForTransport;
		exports.getSessionDataForTransport = getSessionDataForTransport;
		exports.storeSessionDataForTransport = storeSessionDataForTransport;
		exports.updateSessionDataForTransport = updateSessionDataForTransport;
		
	} (sessionManagement));
	return sessionManagement;
}

var hasRequiredSessionExtraction;

function requireSessionExtraction () {
	if (hasRequiredSessionExtraction) return sessionExtraction;
	hasRequiredSessionExtraction = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const attributes = /*@__PURE__*/ requireAttributes();
		const sessionManagement = /*@__PURE__*/ requireSessionManagement();
		const validation = /*@__PURE__*/ requireValidation();

		function extractPartyInfo(obj) {
		  const partyInfo = {};
		  if (validation.isValidContentItem(obj)) {
		    if (typeof obj.name === "string") {
		      partyInfo.name = obj.name;
		    }
		    if (typeof obj.title === "string") {
		      partyInfo.title = obj.title;
		    }
		    if (typeof obj.version === "string") {
		      partyInfo.version = obj.version;
		    }
		  }
		  return partyInfo;
		}
		function extractSessionDataFromInitializeRequest(request) {
		  const sessionData = {};
		  if (validation.isValidContentItem(request.params)) {
		    if (typeof request.params.protocolVersion === "string") {
		      sessionData.protocolVersion = request.params.protocolVersion;
		    }
		    if (request.params.clientInfo) {
		      sessionData.clientInfo = extractPartyInfo(request.params.clientInfo);
		    }
		  }
		  return sessionData;
		}
		function extractSessionDataFromInitializeResponse(result) {
		  const sessionData = {};
		  if (validation.isValidContentItem(result)) {
		    if (typeof result.protocolVersion === "string") {
		      sessionData.protocolVersion = result.protocolVersion;
		    }
		    if (result.serverInfo) {
		      sessionData.serverInfo = extractPartyInfo(result.serverInfo);
		    }
		  }
		  return sessionData;
		}
		function getClientAttributes(transport) {
		  const clientInfo = sessionManagement.getClientInfoForTransport(transport);
		  const attributes = {};
		  if (clientInfo?.name) {
		    attributes["mcp.client.name"] = clientInfo.name;
		  }
		  if (clientInfo?.title) {
		    attributes["mcp.client.title"] = clientInfo.title;
		  }
		  if (clientInfo?.version) {
		    attributes["mcp.client.version"] = clientInfo.version;
		  }
		  return attributes;
		}
		function buildClientAttributesFromInfo(clientInfo) {
		  const attributes = {};
		  if (clientInfo?.name) {
		    attributes["mcp.client.name"] = clientInfo.name;
		  }
		  if (clientInfo?.title) {
		    attributes["mcp.client.title"] = clientInfo.title;
		  }
		  if (clientInfo?.version) {
		    attributes["mcp.client.version"] = clientInfo.version;
		  }
		  return attributes;
		}
		function getServerAttributes(transport) {
		  const serverInfo = sessionManagement.getSessionDataForTransport(transport)?.serverInfo;
		  const attributes$1 = {};
		  if (serverInfo?.name) {
		    attributes$1[attributes.MCP_SERVER_NAME_ATTRIBUTE] = serverInfo.name;
		  }
		  if (serverInfo?.title) {
		    attributes$1[attributes.MCP_SERVER_TITLE_ATTRIBUTE] = serverInfo.title;
		  }
		  if (serverInfo?.version) {
		    attributes$1[attributes.MCP_SERVER_VERSION_ATTRIBUTE] = serverInfo.version;
		  }
		  return attributes$1;
		}
		function buildServerAttributesFromInfo(serverInfo) {
		  const attributes$1 = {};
		  if (serverInfo?.name) {
		    attributes$1[attributes.MCP_SERVER_NAME_ATTRIBUTE] = serverInfo.name;
		  }
		  if (serverInfo?.title) {
		    attributes$1[attributes.MCP_SERVER_TITLE_ATTRIBUTE] = serverInfo.title;
		  }
		  if (serverInfo?.version) {
		    attributes$1[attributes.MCP_SERVER_VERSION_ATTRIBUTE] = serverInfo.version;
		  }
		  return attributes$1;
		}
		function extractClientInfo(extra) {
		  return {
		    address: extra?.requestInfo?.remoteAddress || extra?.clientAddress || extra?.request?.ip || extra?.request?.connection?.remoteAddress,
		    port: extra?.requestInfo?.remotePort || extra?.clientPort || extra?.request?.connection?.remotePort
		  };
		}
		function getTransportTypes(transport) {
		  if (!transport?.constructor) {
		    return { mcpTransport: "unknown", networkTransport: "unknown" };
		  }
		  const transportName = typeof transport.constructor?.name === "string" ? transport.constructor.name : "unknown";
		  let networkTransport = "unknown";
		  const lowerTransportName = transportName.toLowerCase();
		  if (lowerTransportName.includes("stdio")) {
		    networkTransport = "pipe";
		  } else if (lowerTransportName.includes("http") || lowerTransportName.includes("sse")) {
		    networkTransport = "tcp";
		  }
		  return {
		    mcpTransport: transportName,
		    networkTransport
		  };
		}
		function buildTransportAttributes(transport, extra) {
		  const sessionId = transport && "sessionId" in transport ? transport.sessionId : void 0;
		  const clientInfo = extra ? extractClientInfo(extra) : {};
		  const { mcpTransport, networkTransport } = getTransportTypes(transport);
		  const clientAttributes = getClientAttributes(transport);
		  const serverAttributes = getServerAttributes(transport);
		  const protocolVersion = sessionManagement.getProtocolVersionForTransport(transport);
		  const attributes$1 = {
		    ...sessionId && { [attributes.MCP_SESSION_ID_ATTRIBUTE]: sessionId },
		    ...clientInfo.address && { [attributes.CLIENT_ADDRESS_ATTRIBUTE]: clientInfo.address },
		    ...clientInfo.port && { [attributes.CLIENT_PORT_ATTRIBUTE]: clientInfo.port },
		    [attributes.MCP_TRANSPORT_ATTRIBUTE]: mcpTransport,
		    [attributes.NETWORK_TRANSPORT_ATTRIBUTE]: networkTransport,
		    [attributes.NETWORK_PROTOCOL_VERSION_ATTRIBUTE]: "2.0",
		    ...protocolVersion && { [attributes.MCP_PROTOCOL_VERSION_ATTRIBUTE]: protocolVersion },
		    ...clientAttributes,
		    ...serverAttributes
		  };
		  return attributes$1;
		}

		exports.buildClientAttributesFromInfo = buildClientAttributesFromInfo;
		exports.buildServerAttributesFromInfo = buildServerAttributesFromInfo;
		exports.buildTransportAttributes = buildTransportAttributes;
		exports.extractClientInfo = extractClientInfo;
		exports.extractSessionDataFromInitializeRequest = extractSessionDataFromInitializeRequest;
		exports.extractSessionDataFromInitializeResponse = extractSessionDataFromInitializeResponse;
		exports.getClientAttributes = getClientAttributes;
		exports.getServerAttributes = getServerAttributes;
		exports.getTransportTypes = getTransportTypes;
		
	} (sessionExtraction));
	return sessionExtraction;
}

var hasRequiredCorrelation;

function requireCorrelation () {
	if (hasRequiredCorrelation) return correlation;
	hasRequiredCorrelation = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const attributes = /*@__PURE__*/ requireAttributes();
		const resultExtraction = /*@__PURE__*/ requireResultExtraction();
		const sessionExtraction = /*@__PURE__*/ requireSessionExtraction();

		const sessionToSpanMap = /* @__PURE__ */ new Map();
		const statelessSpanMap = /* @__PURE__ */ new WeakMap();
		function getOrCreateSpanMap(transport) {
		  const sessionId = transport.sessionId;
		  if (sessionId) {
		    let spanMap2 = sessionToSpanMap.get(sessionId);
		    if (!spanMap2) {
		      spanMap2 = /* @__PURE__ */ new Map();
		      sessionToSpanMap.set(sessionId, spanMap2);
		    }
		    return spanMap2;
		  }
		  let spanMap = statelessSpanMap.get(transport);
		  if (!spanMap) {
		    spanMap = /* @__PURE__ */ new Map();
		    statelessSpanMap.set(transport, spanMap);
		  }
		  return spanMap;
		}
		function storeSpanForRequest(transport, requestId, span, method) {
		  const spanMap = getOrCreateSpanMap(transport);
		  spanMap.set(requestId, {
		    span,
		    method,
		    // oxlint-disable-next-line sdk/no-unsafe-random-apis
		    startTime: Date.now()
		  });
		}
		function completeSpanWithResults(transport, requestId, result, options, hasError = false) {
		  const spanMap = getOrCreateSpanMap(transport);
		  const spanData = spanMap.get(requestId);
		  if (spanData) {
		    const { span, method } = spanData;
		    if (hasError) {
		      span.setStatus({ code: spanstatus.SPAN_STATUS_ERROR, message: "internal_error" });
		    } else if (method === "initialize") {
		      const sessionData = sessionExtraction.extractSessionDataFromInitializeResponse(result);
		      const serverAttributes = sessionExtraction.buildServerAttributesFromInfo(sessionData.serverInfo);
		      const initAttributes = {
		        ...serverAttributes
		      };
		      if (sessionData.protocolVersion) {
		        initAttributes[attributes.MCP_PROTOCOL_VERSION_ATTRIBUTE] = sessionData.protocolVersion;
		      }
		      span.setAttributes(initAttributes);
		    } else if (method === "tools/call") {
		      const toolAttributes = resultExtraction.extractToolResultAttributes(result, options.recordOutputs);
		      span.setAttributes(toolAttributes);
		    } else if (method === "prompts/get") {
		      const promptAttributes = resultExtraction.extractPromptResultAttributes(result, options.recordOutputs);
		      span.setAttributes(promptAttributes);
		    }
		    span.end();
		    spanMap.delete(requestId);
		  }
		}
		function cleanupPendingSpansForTransport(transport) {
		  const sessionId = transport.sessionId;
		  if (sessionId) {
		    const spanMap2 = sessionToSpanMap.get(sessionId);
		    if (spanMap2) {
		      for (const [, spanData] of spanMap2) {
		        spanData.span.setStatus({
		          code: spanstatus.SPAN_STATUS_ERROR,
		          message: "cancelled"
		        });
		        spanData.span.end();
		      }
		      sessionToSpanMap.delete(sessionId);
		    }
		    return;
		  }
		  const spanMap = statelessSpanMap.get(transport);
		  if (spanMap) {
		    for (const [, spanData] of spanMap) {
		      spanData.span.setStatus({
		        code: spanstatus.SPAN_STATUS_ERROR,
		        message: "cancelled"
		      });
		      spanData.span.end();
		    }
		    spanMap.clear();
		  }
		}

		exports.cleanupPendingSpansForTransport = cleanupPendingSpansForTransport;
		exports.completeSpanWithResults = completeSpanWithResults;
		exports.storeSpanForRequest = storeSpanForRequest;
		
	} (correlation));
	return correlation;
}

var spans = {};

var attributeExtraction = {};

var methodConfig = {};

var hasRequiredMethodConfig;

function requireMethodConfig () {
	if (hasRequiredMethodConfig) return methodConfig;
	hasRequiredMethodConfig = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const attributes = /*@__PURE__*/ requireAttributes();

		const METHOD_CONFIGS = {
		  "tools/call": {
		    targetField: "name",
		    targetAttribute: attributes.MCP_TOOL_NAME_ATTRIBUTE,
		    captureArguments: true,
		    argumentsField: "arguments"
		  },
		  "resources/read": {
		    targetField: "uri",
		    targetAttribute: attributes.MCP_RESOURCE_URI_ATTRIBUTE,
		    captureUri: true
		  },
		  "resources/subscribe": {
		    targetField: "uri",
		    targetAttribute: attributes.MCP_RESOURCE_URI_ATTRIBUTE
		  },
		  "resources/unsubscribe": {
		    targetField: "uri",
		    targetAttribute: attributes.MCP_RESOURCE_URI_ATTRIBUTE
		  },
		  "prompts/get": {
		    targetField: "name",
		    targetAttribute: attributes.MCP_PROMPT_NAME_ATTRIBUTE,
		    captureName: true,
		    captureArguments: true,
		    argumentsField: "arguments"
		  }
		};
		function extractTargetInfo(method, params) {
		  const config = METHOD_CONFIGS[method];
		  if (!config) {
		    return { attributes: {} };
		  }
		  const target = config.targetField && typeof params?.[config.targetField] === "string" ? params[config.targetField] : void 0;
		  return {
		    target,
		    attributes: target && config.targetAttribute ? { [config.targetAttribute]: target } : {}
		  };
		}
		function getRequestArguments(method, params) {
		  const args = {};
		  const config = METHOD_CONFIGS[method];
		  if (!config) {
		    return args;
		  }
		  if (config.captureArguments && config.argumentsField && params?.[config.argumentsField]) {
		    const argumentsObj = params[config.argumentsField];
		    if (typeof argumentsObj === "object" && argumentsObj !== null) {
		      for (const [key, value] of Object.entries(argumentsObj)) {
		        args[`${attributes.MCP_REQUEST_ARGUMENT}.${key.toLowerCase()}`] = JSON.stringify(value);
		      }
		    }
		  }
		  if (config.captureUri && params?.uri) {
		    args[`${attributes.MCP_REQUEST_ARGUMENT}.uri`] = JSON.stringify(params.uri);
		  }
		  if (config.captureName && params?.name) {
		    args[`${attributes.MCP_REQUEST_ARGUMENT}.name`] = JSON.stringify(params.name);
		  }
		  return args;
		}

		exports.extractTargetInfo = extractTargetInfo;
		exports.getRequestArguments = getRequestArguments;
		
	} (methodConfig));
	return methodConfig;
}

var hasRequiredAttributeExtraction;

function requireAttributeExtraction () {
	if (hasRequiredAttributeExtraction) return attributeExtraction;
	hasRequiredAttributeExtraction = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const url = /*@__PURE__*/ requireUrl();
		const attributes = /*@__PURE__*/ requireAttributes();
		const methodConfig = /*@__PURE__*/ requireMethodConfig();

		function formatLoggingData(data) {
		  return typeof data === "string" ? data : JSON.stringify(data);
		}
		function getNotificationAttributes(method, params, recordInputs) {
		  const attributes$1 = {};
		  switch (method) {
		    case "notifications/cancelled":
		      if (params?.requestId) {
		        attributes$1["mcp.cancelled.request_id"] = String(params.requestId);
		      }
		      if (params?.reason) {
		        attributes$1["mcp.cancelled.reason"] = String(params.reason);
		      }
		      break;
		    case "notifications/message":
		      if (params?.level) {
		        attributes$1[attributes.MCP_LOGGING_LEVEL_ATTRIBUTE] = String(params.level);
		      }
		      if (params?.logger) {
		        attributes$1[attributes.MCP_LOGGING_LOGGER_ATTRIBUTE] = String(params.logger);
		      }
		      if (params?.data !== void 0) {
		        attributes$1[attributes.MCP_LOGGING_DATA_TYPE_ATTRIBUTE] = typeof params.data;
		        if (recordInputs) {
		          attributes$1[attributes.MCP_LOGGING_MESSAGE_ATTRIBUTE] = formatLoggingData(params.data);
		        }
		      }
		      break;
		    case "notifications/progress":
		      if (params?.progressToken) {
		        attributes$1["mcp.progress.token"] = String(params.progressToken);
		      }
		      if (typeof params?.progress === "number") {
		        attributes$1["mcp.progress.current"] = params.progress;
		      }
		      if (typeof params?.total === "number") {
		        attributes$1["mcp.progress.total"] = params.total;
		        if (typeof params?.progress === "number") {
		          attributes$1["mcp.progress.percentage"] = params.progress / params.total * 100;
		        }
		      }
		      if (params?.message) {
		        attributes$1["mcp.progress.message"] = String(params.message);
		      }
		      break;
		    case "notifications/resources/updated":
		      if (params?.uri) {
		        attributes$1[attributes.MCP_RESOURCE_URI_ATTRIBUTE] = String(params.uri);
		        const urlObject = url.parseStringToURLObject(String(params.uri));
		        if (urlObject && !url.isURLObjectRelative(urlObject)) {
		          attributes$1["mcp.resource.protocol"] = urlObject.protocol.replace(":", "");
		        }
		      }
		      break;
		    case "notifications/initialized":
		      attributes$1["mcp.lifecycle.phase"] = "initialization_complete";
		      attributes$1["mcp.protocol.ready"] = 1;
		      break;
		  }
		  return attributes$1;
		}
		function buildTypeSpecificAttributes(type, message, params, recordInputs) {
		  if (type === "request") {
		    const request = message;
		    const targetInfo = methodConfig.extractTargetInfo(request.method, params || {});
		    return {
		      ...request.id !== void 0 && { [attributes.MCP_REQUEST_ID_ATTRIBUTE]: String(request.id) },
		      ...targetInfo.attributes,
		      ...recordInputs ? methodConfig.getRequestArguments(request.method, params || {}) : {}
		    };
		  }
		  return getNotificationAttributes(message.method, params || {}, recordInputs);
		}

		exports.buildTypeSpecificAttributes = buildTypeSpecificAttributes;
		exports.getNotificationAttributes = getNotificationAttributes;
		
	} (attributeExtraction));
	return attributeExtraction;
}

var piiFiltering = {};

var hasRequiredPiiFiltering;

function requirePiiFiltering () {
	if (hasRequiredPiiFiltering) return piiFiltering;
	hasRequiredPiiFiltering = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const attributes = /*@__PURE__*/ requireAttributes();

		const NETWORK_PII_ATTRIBUTES = /* @__PURE__ */ new Set([attributes.CLIENT_ADDRESS_ATTRIBUTE, attributes.CLIENT_PORT_ATTRIBUTE, attributes.MCP_RESOURCE_URI_ATTRIBUTE]);
		function isNetworkPiiAttribute(key) {
		  return NETWORK_PII_ATTRIBUTES.has(key);
		}
		function filterMcpPiiFromSpanData(spanData, userInfo) {
		  if (userInfo) {
		    return spanData;
		  }
		  return Object.entries(spanData).reduce(
		    (acc, [key, value]) => {
		      if (!isNetworkPiiAttribute(key)) {
		        acc[key] = value;
		      }
		      return acc;
		    },
		    {}
		  );
		}

		exports.filterMcpPiiFromSpanData = filterMcpPiiFromSpanData;
		
	} (piiFiltering));
	return piiFiltering;
}

var hasRequiredSpans;

function requireSpans () {
	if (hasRequiredSpans) return spans;
	hasRequiredSpans = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const trace = /*@__PURE__*/ requireTrace();
		const attributeExtraction = /*@__PURE__*/ requireAttributeExtraction();
		const attributes = /*@__PURE__*/ requireAttributes();
		const methodConfig = /*@__PURE__*/ requireMethodConfig();
		const piiFiltering = /*@__PURE__*/ requirePiiFiltering();
		const sessionExtraction = /*@__PURE__*/ requireSessionExtraction();

		function createSpanName(method, target) {
		  return target ? `${method} ${target}` : method;
		}
		function buildSentryAttributes(type) {
		  let op;
		  let origin;
		  switch (type) {
		    case "request":
		      op = attributes.MCP_SERVER_OP_VALUE;
		      origin = attributes.MCP_FUNCTION_ORIGIN_VALUE;
		      break;
		    case "notification-incoming":
		      op = attributes.MCP_NOTIFICATION_CLIENT_TO_SERVER_OP_VALUE;
		      origin = attributes.MCP_NOTIFICATION_ORIGIN_VALUE;
		      break;
		    case "notification-outgoing":
		      op = attributes.MCP_NOTIFICATION_SERVER_TO_CLIENT_OP_VALUE;
		      origin = attributes.MCP_NOTIFICATION_ORIGIN_VALUE;
		      break;
		  }
		  return {
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: op,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: origin,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: attributes.MCP_ROUTE_SOURCE_VALUE
		  };
		}
		function createMcpSpan(config) {
		  const { type, message, transport, extra, callback, options } = config;
		  const { method } = message;
		  const params = message.params;
		  let spanName;
		  if (type === "request") {
		    const targetInfo = methodConfig.extractTargetInfo(method, params || {});
		    spanName = createSpanName(method, targetInfo.target);
		  } else {
		    spanName = method;
		  }
		  const rawAttributes = {
		    ...sessionExtraction.buildTransportAttributes(transport, extra),
		    [attributes.MCP_METHOD_NAME_ATTRIBUTE]: method,
		    ...attributeExtraction.buildTypeSpecificAttributes(type, message, params, options?.recordInputs),
		    ...buildSentryAttributes(type)
		  };
		  const client = currentScopes.getClient();
		  const userInfo = Boolean(client?.getDataCollectionOptions().userInfo);
		  const attributes$1 = piiFiltering.filterMcpPiiFromSpanData(rawAttributes, userInfo);
		  return trace.startSpan(
		    {
		      name: spanName,
		      forceTransaction: true,
		      attributes: attributes$1
		    },
		    callback
		  );
		}
		function createMcpNotificationSpan(jsonRpcMessage, transport, extra, options, callback) {
		  return createMcpSpan({
		    type: "notification-incoming",
		    message: jsonRpcMessage,
		    transport,
		    extra,
		    callback,
		    options
		  });
		}
		function createMcpOutgoingNotificationSpan(jsonRpcMessage, transport, options, callback) {
		  return createMcpSpan({
		    type: "notification-outgoing",
		    message: jsonRpcMessage,
		    transport,
		    options,
		    callback
		  });
		}
		function buildMcpServerSpanConfig(jsonRpcMessage, transport, extra, options) {
		  const { method } = jsonRpcMessage;
		  const params = jsonRpcMessage.params;
		  const targetInfo = methodConfig.extractTargetInfo(method, params || {});
		  const spanName = createSpanName(method, targetInfo.target);
		  const rawAttributes = {
		    ...sessionExtraction.buildTransportAttributes(transport, extra),
		    [attributes.MCP_METHOD_NAME_ATTRIBUTE]: method,
		    ...attributeExtraction.buildTypeSpecificAttributes("request", jsonRpcMessage, params, options?.recordInputs),
		    ...buildSentryAttributes("request")
		  };
		  const client = currentScopes.getClient();
		  const userInfo = Boolean(client?.getDataCollectionOptions().userInfo);
		  const attributes$1 = piiFiltering.filterMcpPiiFromSpanData(rawAttributes, userInfo);
		  return {
		    name: spanName,
		    op: attributes.MCP_SERVER_OP_VALUE,
		    forceTransaction: true,
		    attributes: attributes$1
		  };
		}

		exports.buildMcpServerSpanConfig = buildMcpServerSpanConfig;
		exports.createMcpNotificationSpan = createMcpNotificationSpan;
		exports.createMcpOutgoingNotificationSpan = createMcpOutgoingNotificationSpan;
		
	} (spans));
	return spans;
}

var hasRequiredTransport;

function requireTransport () {
	if (hasRequiredTransport) return transport;
	hasRequiredTransport = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const object = /*@__PURE__*/ requireObject();
		const trace = /*@__PURE__*/ requireTrace();
		const attributes = /*@__PURE__*/ requireAttributes();
		const correlation = /*@__PURE__*/ requireCorrelation();
		const errorCapture = /*@__PURE__*/ requireErrorCapture();
		const sessionExtraction = /*@__PURE__*/ requireSessionExtraction();
		const sessionManagement = /*@__PURE__*/ requireSessionManagement();
		const spans = /*@__PURE__*/ requireSpans();
		const validation = /*@__PURE__*/ requireValidation();

		function wrapTransportOnMessage(transport, options) {
		  if (transport.onmessage) {
		    object.fill(transport, "onmessage", (originalOnMessage) => {
		      return function(message, extra) {
		        if (validation.isJsonRpcRequest(message)) {
		          const isInitialize = message.method === "initialize";
		          let initSessionData;
		          if (isInitialize) {
		            try {
		              initSessionData = sessionExtraction.extractSessionDataFromInitializeRequest(message);
		              sessionManagement.storeSessionDataForTransport(transport, initSessionData);
		            } catch {
		            }
		          }
		          const isolationScope = currentScopes.getIsolationScope().clone();
		          return currentScopes.withIsolationScope(isolationScope, () => {
		            const spanConfig = spans.buildMcpServerSpanConfig(message, transport, extra, options);
		            const span = trace.startInactiveSpan(spanConfig);
		            if (isInitialize && initSessionData) {
		              span.setAttributes({
		                ...sessionExtraction.buildClientAttributesFromInfo(initSessionData.clientInfo),
		                ...initSessionData.protocolVersion && {
		                  [attributes.MCP_PROTOCOL_VERSION_ATTRIBUTE]: initSessionData.protocolVersion
		                }
		              });
		            }
		            correlation.storeSpanForRequest(transport, message.id, span, message.method);
		            return trace.withActiveSpan(span, () => {
		              return originalOnMessage.call(this, message, extra);
		            });
		          });
		        }
		        if (validation.isJsonRpcNotification(message)) {
		          return spans.createMcpNotificationSpan(message, transport, extra, options, () => {
		            return originalOnMessage.call(this, message, extra);
		          });
		        }
		        return originalOnMessage.call(this, message, extra);
		      };
		    });
		  }
		}
		function wrapTransportSend(transport, options) {
		  if (transport.send) {
		    object.fill(transport, "send", (originalSend) => {
		      return async function(...args) {
		        const [message] = args;
		        if (validation.isJsonRpcNotification(message)) {
		          return spans.createMcpOutgoingNotificationSpan(message, transport, options, () => {
		            return originalSend.call(this, ...args);
		          });
		        }
		        if (validation.isJsonRpcResponse(message)) {
		          if (message.id !== null && message.id !== void 0) {
		            if (message.error) {
		              captureJsonRpcErrorResponse(message.error);
		            }
		            if (validation.isValidContentItem(message.result)) {
		              if (message.result.protocolVersion || message.result.serverInfo) {
		                try {
		                  const serverData = sessionExtraction.extractSessionDataFromInitializeResponse(message.result);
		                  sessionManagement.updateSessionDataForTransport(transport, serverData);
		                } catch {
		                }
		              }
		            }
		            correlation.completeSpanWithResults(transport, message.id, message.result, options, !!message.error);
		          }
		        }
		        return originalSend.call(this, ...args);
		      };
		    });
		  }
		}
		function wrapTransportOnClose(transport) {
		  if (transport.onclose) {
		    object.fill(transport, "onclose", (originalOnClose) => {
		      return function(...args) {
		        correlation.cleanupPendingSpansForTransport(transport);
		        sessionManagement.cleanupSessionDataForTransport(transport);
		        return originalOnClose.call(this, ...args);
		      };
		    });
		  }
		}
		function wrapTransportError(transport) {
		  if (transport.onerror) {
		    object.fill(transport, "onerror", (originalOnError) => {
		      return function(error) {
		        captureTransportError(error);
		        return originalOnError.call(this, error);
		      };
		    });
		  }
		}
		function captureJsonRpcErrorResponse(errorResponse) {
		  try {
		    if (errorResponse && typeof errorResponse === "object" && "code" in errorResponse && "message" in errorResponse) {
		      const jsonRpcError = errorResponse;
		      const isServerError = jsonRpcError.code === -32603 || jsonRpcError.code >= -32099 && jsonRpcError.code <= -32e3;
		      if (isServerError) {
		        const error = new Error(jsonRpcError.message);
		        error.name = `JsonRpcError_${jsonRpcError.code}`;
		        errorCapture.captureError(error, "protocol");
		      }
		    }
		  } catch {
		  }
		}
		function captureTransportError(error) {
		  try {
		    errorCapture.captureError(error, "transport");
		  } catch {
		  }
		}

		exports.wrapTransportError = wrapTransportError;
		exports.wrapTransportOnClose = wrapTransportOnClose;
		exports.wrapTransportOnMessage = wrapTransportOnMessage;
		exports.wrapTransportSend = wrapTransportSend;
		
	} (transport));
	return transport;
}

var hasRequiredMcpServer;

function requireMcpServer () {
	if (hasRequiredMcpServer) return mcpServer;
	hasRequiredMcpServer = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const object = /*@__PURE__*/ requireObject();
		const handlers = /*@__PURE__*/ requireHandlers();
		const transport = /*@__PURE__*/ requireTransport();
		const validation = /*@__PURE__*/ requireValidation();

		const wrappedMcpServerInstances = /* @__PURE__ */ new WeakSet();
		function wrapMcpServerWithSentry(mcpServerInstance, options) {
		  if (wrappedMcpServerInstances.has(mcpServerInstance)) {
		    return mcpServerInstance;
		  }
		  if (!validation.validateMcpServerInstance(mcpServerInstance)) {
		    return mcpServerInstance;
		  }
		  const serverInstance = mcpServerInstance;
		  const client = currentScopes.getClient();
		  const genAI = client?.getDataCollectionOptions().genAI;
		  const resolvedOptions = {
		    recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
		    recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
		  };
		  object.fill(serverInstance, "connect", (originalConnect) => {
		    return async function(transport$1, ...restArgs) {
		      const result = await originalConnect.call(
		        this,
		        transport$1,
		        ...restArgs
		      );
		      transport.wrapTransportOnMessage(transport$1, resolvedOptions);
		      transport.wrapTransportSend(transport$1, resolvedOptions);
		      transport.wrapTransportOnClose(transport$1);
		      transport.wrapTransportError(transport$1);
		      return result;
		    };
		  });
		  handlers.wrapAllMCPHandlers(serverInstance);
		  handlers.wrapExistingHandlers(serverInstance);
		  wrappedMcpServerInstances.add(mcpServerInstance);
		  return mcpServerInstance;
		}

		exports.wrapMcpServerWithSentry = wrapMcpServerWithSentry;
		
	} (mcpServer));
	return mcpServer;
}

var nodeStackTrace = {};

var hasRequiredNodeStackTrace;

function requireNodeStackTrace () {
	if (hasRequiredNodeStackTrace) return nodeStackTrace;
	hasRequiredNodeStackTrace = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const stacktrace = /*@__PURE__*/ requireStacktrace();

		function filenameIsInApp(filename, isNative = false) {
		  const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
		  !filename.startsWith("/") && // It's not internal if it's an absolute windows path
		  !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
		  !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
		  !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//);
		  return !isInternal && filename !== void 0 && !filename.includes("node_modules/");
		}
		function node(getModule) {
		  const FILENAME_MATCH = /^\s*[-]{4,}$/;
		  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
		  const DATA_URI_MATCH = /at (?:async )?(.+?) \(data:(.*?),/;
		  return (line) => {
		    const dataUriMatch = line.match(DATA_URI_MATCH);
		    if (dataUriMatch) {
		      return {
		        filename: `<data:${dataUriMatch[2]}>`,
		        function: dataUriMatch[1]
		      };
		    }
		    const lineMatch = line.match(FULL_MATCH);
		    if (lineMatch) {
		      let object;
		      let method;
		      let functionName;
		      let typeName;
		      let methodName;
		      if (lineMatch[1]) {
		        functionName = lineMatch[1];
		        let methodStart = functionName.lastIndexOf(".");
		        if (functionName[methodStart - 1] === ".") {
		          methodStart--;
		        }
		        if (methodStart > 0) {
		          object = functionName.slice(0, methodStart);
		          method = functionName.slice(methodStart + 1);
		          const objectEnd = object.indexOf(".Module");
		          if (objectEnd > 0) {
		            functionName = functionName.slice(objectEnd + 1);
		            object = object.slice(0, objectEnd);
		          }
		        }
		        typeName = void 0;
		      }
		      if (method) {
		        typeName = object;
		        methodName = method;
		      }
		      if (method === "<anonymous>") {
		        methodName = void 0;
		        functionName = void 0;
		      }
		      if (functionName === void 0) {
		        methodName = methodName || stacktrace.UNKNOWN_FUNCTION;
		        functionName = typeName ? `${typeName}.${methodName}` : methodName;
		      }
		      let filename = stacktrace.normalizeStackTracePath(lineMatch[2]);
		      const isNative = lineMatch[5] === "native";
		      if (!filename && lineMatch[5] && !isNative) {
		        filename = lineMatch[5];
		      }
		      const maybeDecodedFilename = filename ? _safeDecodeURI(filename) : void 0;
		      return {
		        filename: maybeDecodedFilename ?? filename,
		        module: maybeDecodedFilename && getModule?.(maybeDecodedFilename),
		        function: functionName,
		        lineno: _parseIntOrUndefined(lineMatch[3]),
		        colno: _parseIntOrUndefined(lineMatch[4]),
		        in_app: filenameIsInApp(filename || "", isNative)
		      };
		    }
		    if (line.match(FILENAME_MATCH)) {
		      return {
		        filename: line
		      };
		    }
		    return void 0;
		  };
		}
		function nodeStackLineParser(getModule) {
		  return [90, node(getModule)];
		}
		function _parseIntOrUndefined(input) {
		  return parseInt(input || "", 10) || void 0;
		}
		function _safeDecodeURI(filename) {
		  try {
		    return decodeURI(filename);
		  } catch {
		    return void 0;
		  }
		}

		exports.filenameIsInApp = filenameIsInApp;
		exports.node = node;
		exports.nodeStackLineParser = nodeStackLineParser;
		
	} (nodeStackTrace));
	return nodeStackTrace;
}

var vercelWaitUntil = {};

var hasRequiredVercelWaitUntil;

function requireVercelWaitUntil () {
	if (hasRequiredVercelWaitUntil) return vercelWaitUntil;
	hasRequiredVercelWaitUntil = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const worldwide = /*@__PURE__*/ requireWorldwide();

		function vercelWaitUntil(task) {
		  if (typeof EdgeRuntime !== "string") {
		    return;
		  }
		  const vercelRequestContextGlobal = (
		    // @ts-expect-error This is not typed
		    worldwide.GLOBAL_OBJ[/* @__PURE__ */ Symbol.for("@vercel/request-context")]
		  );
		  const ctx = vercelRequestContextGlobal?.get?.();
		  if (ctx?.waitUntil) {
		    ctx.waitUntil(task);
		  }
		}

		exports.vercelWaitUntil = vercelWaitUntil;
		
	} (vercelWaitUntil));
	return vercelWaitUntil;
}

var flushIfServerless = {};

var hasRequiredFlushIfServerless;

function requireFlushIfServerless () {
	if (hasRequiredFlushIfServerless) return flushIfServerless;
	hasRequiredFlushIfServerless = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const vercelWaitUntil = /*@__PURE__*/ requireVercelWaitUntil();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		async function flushWithTimeout(timeout) {
		  try {
		    debugLogger.debug.log("Flushing events...");
		    await exports$1.flush(timeout);
		    debugLogger.debug.log("Done flushing events");
		  } catch (e) {
		    debugLogger.debug.log("Error while flushing events:\n", e);
		  }
		}
		async function flushIfServerless(params = {}) {
		  const { timeout = 2e3 } = params;
		  if ("cloudflareWaitUntil" in params && typeof params?.cloudflareWaitUntil === "function") {
		    params.cloudflareWaitUntil(flushWithTimeout(timeout));
		    return;
		  }
		  if ("cloudflareCtx" in params && typeof params.cloudflareCtx?.waitUntil === "function") {
		    params.cloudflareCtx.waitUntil(flushWithTimeout(timeout));
		    return;
		  }
		  if (worldwide.GLOBAL_OBJ[/* @__PURE__ */ Symbol.for("@vercel/request-context")]) {
		    vercelWaitUntil.vercelWaitUntil(flushWithTimeout(timeout));
		    return;
		  }
		  if (typeof process === "undefined") {
		    return;
		  }
		  const isServerless = !!process.env.FUNCTIONS_WORKER_RUNTIME || // Azure Functions
		  !!process.env.LAMBDA_TASK_ROOT || // AWS Lambda
		  !!process.env.K_SERVICE || // Google Cloud Run
		  !!process.env.CF_PAGES || // Cloudflare Pages
		  !!process.env.VERCEL || !!process.env.NETLIFY;
		  if (isServerless) {
		    await flushWithTimeout(timeout);
		  }
		}

		exports.flushIfServerless = flushIfServerless;
		
	} (flushIfServerless));
	return flushIfServerless;
}

var anr = {};

var hasRequiredAnr;

function requireAnr () {
	if (hasRequiredAnr) return anr;
	hasRequiredAnr = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const nodeStackTrace = /*@__PURE__*/ requireNodeStackTrace();
		const stacktrace = /*@__PURE__*/ requireStacktrace();

		function watchdogTimer(createTimer, pollInterval, anrThreshold, callback) {
		  const timer = createTimer();
		  let triggered = false;
		  let enabled = true;
		  setInterval(() => {
		    const diffMs = timer.getTimeMs();
		    if (triggered === false && diffMs > pollInterval + anrThreshold) {
		      triggered = true;
		      if (enabled) {
		        callback();
		      }
		    }
		    if (diffMs < pollInterval + anrThreshold) {
		      triggered = false;
		    }
		  }, 20);
		  return {
		    poll: () => {
		      timer.reset();
		    },
		    enabled: (state) => {
		      enabled = state;
		    }
		  };
		}
		function callFrameToStackFrame(frame, url, getModuleFromFilename) {
		  const filename = url ? url.replace(/^file:\/\//, "") : void 0;
		  const colno = frame.location.columnNumber ? frame.location.columnNumber + 1 : void 0;
		  const lineno = frame.location.lineNumber ? frame.location.lineNumber + 1 : void 0;
		  return {
		    filename,
		    module: getModuleFromFilename(filename),
		    function: frame.functionName || stacktrace.UNKNOWN_FUNCTION,
		    colno,
		    lineno,
		    in_app: filename ? nodeStackTrace.filenameIsInApp(filename) : void 0
		  };
		}

		exports.callFrameToStackFrame = callFrameToStackFrame;
		exports.watchdogTimer = watchdogTimer;
		
	} (anr));
	return anr;
}

var express = {};

var utils$7 = {};

var requestLayerStore = {};

var hasRequiredRequestLayerStore;

function requireRequestLayerStore () {
	if (hasRequiredRequestLayerStore) return requestLayerStore;
	hasRequiredRequestLayerStore = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const requestLayerStore = /* @__PURE__ */ new WeakMap();
		const storeLayer = (req, layer) => {
		  const store = requestLayerStore.get(req);
		  if (!store) {
		    requestLayerStore.set(req, [layer]);
		  } else {
		    store.push(layer);
		  }
		};
		const getStoredLayers = (req) => {
		  let store = requestLayerStore.get(req);
		  if (!store) {
		    store = [];
		    requestLayerStore.set(req, store);
		  }
		  return store;
		};

		exports.getStoredLayers = getStoredLayers;
		exports.storeLayer = storeLayer;
		
	} (requestLayerStore));
	return requestLayerStore;
}

var types$1 = {};

var hasRequiredTypes$1;

function requireTypes$1 () {
	if (hasRequiredTypes$1) return types$1;
	hasRequiredTypes$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const ATTR_EXPRESS_NAME = "express.name";
		const ATTR_HTTP_ROUTE = "http.route";
		const ATTR_EXPRESS_TYPE = "express.type";
		const ExpressLayerType_ROUTER = "router";
		const ExpressLayerType_MIDDLEWARE = "middleware";
		const ExpressLayerType_REQUEST_HANDLER = "request_handler";

		exports.ATTR_EXPRESS_NAME = ATTR_EXPRESS_NAME;
		exports.ATTR_EXPRESS_TYPE = ATTR_EXPRESS_TYPE;
		exports.ATTR_HTTP_ROUTE = ATTR_HTTP_ROUTE;
		exports.ExpressLayerType_MIDDLEWARE = ExpressLayerType_MIDDLEWARE;
		exports.ExpressLayerType_REQUEST_HANDLER = ExpressLayerType_REQUEST_HANDLER;
		exports.ExpressLayerType_ROUTER = ExpressLayerType_ROUTER;
		
	} (types$1));
	return types$1;
}

var hasRequiredUtils$7;

function requireUtils$7 () {
	if (hasRequiredUtils$7) return utils$7;
	hasRequiredUtils$7 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const requestLayerStore = /*@__PURE__*/ requireRequestLayerStore();
		const types = /*@__PURE__*/ requireTypes$1();
		const string = /*@__PURE__*/ requireString();

		const asErrorAndMessage = (error) => error instanceof Error ? [error, error.message] : [String(error), String(error)];
		function isRoutePattern(route) {
		  return route.includes(":") || route.includes("*");
		}
		const getLayerMetadata = (route, layer, layerPath) => {
		  if (layer.name === "router") {
		    const maybeRouterPath = getRouterPath("", layer);
		    const extractedRouterPath = maybeRouterPath ? maybeRouterPath : layerPath || route || "/";
		    return {
		      attributes: {
		        [types.ATTR_EXPRESS_NAME]: extractedRouterPath,
		        [types.ATTR_EXPRESS_TYPE]: types.ExpressLayerType_ROUTER
		      },
		      name: `router - ${extractedRouterPath}`
		    };
		  } else if (layer.name === "bound dispatch" || layer.name === "handle") {
		    return {
		      attributes: {
		        [types.ATTR_EXPRESS_NAME]: (route || layerPath) ?? "request handler",
		        [types.ATTR_EXPRESS_TYPE]: types.ExpressLayerType_REQUEST_HANDLER
		      },
		      name: `request handler${layer.path ? ` - ${route || layerPath}` : ""}`
		    };
		  } else {
		    return {
		      attributes: {
		        [types.ATTR_EXPRESS_NAME]: layer.name,
		        [types.ATTR_EXPRESS_TYPE]: types.ExpressLayerType_MIDDLEWARE
		      },
		      name: `middleware - ${layer.name}`
		    };
		  }
		};
		const getRouterPath = (path, layer) => {
		  const stackLayer = Array.isArray(layer.handle?.stack) ? layer.handle?.stack?.[0] : void 0;
		  if (stackLayer?.route?.path) {
		    return `${path}${stackLayer.route.path}`;
		  }
		  if (stackLayer && Array.isArray(stackLayer?.handle?.stack)) {
		    return getRouterPath(path, stackLayer);
		  }
		  return path;
		};
		const isLayerIgnored = (name, type, config) => {
		  if (Array.isArray(config?.ignoreLayersType) && config?.ignoreLayersType?.includes(type)) {
		    return true;
		  }
		  if (!Array.isArray(config?.ignoreLayers)) {
		    return false;
		  }
		  try {
		    return string.stringMatchesSomePattern(name, config.ignoreLayers, true);
		  } catch {
		  }
		  return false;
		};
		function getActualMatchedRoute(req, constructedRoute) {
		  const layersStore = requestLayerStore.getStoredLayers(req);
		  if (layersStore.length === 0) {
		    return void 0;
		  }
		  if (layersStore.every((path) => path === "/")) {
		    return req.originalUrl === "/" ? "/" : void 0;
		  }
		  if (constructedRoute === "*") {
		    return constructedRoute;
		  }
		  if (constructedRoute.includes("/") && (constructedRoute.includes(",") || constructedRoute.includes("\\") || constructedRoute.includes("*") || constructedRoute.includes("["))) {
		    return constructedRoute;
		  }
		  const normalizedRoute = constructedRoute.startsWith("/") ? constructedRoute : `/${constructedRoute}`;
		  const isValidRoute = normalizedRoute.length > 0 && (req.originalUrl === normalizedRoute || req.originalUrl.startsWith(normalizedRoute) || isRoutePattern(normalizedRoute));
		  return isValidRoute ? normalizedRoute : void 0;
		}
		function getConstructedRoute(req) {
		  const layersStore = requestLayerStore.getStoredLayers(req);
		  let constructedRoute = "";
		  for (const path of layersStore) {
		    if (path === "/" || path === "/*") {
		      continue;
		    }
		    constructedRoute += !constructedRoute || constructedRoute.endsWith("/") ? path : `/${path}`;
		  }
		  return constructedRoute.replace(/\/{2,}/g, "/");
		}
		const getLayerPath = (args) => {
		  const firstArg = args[0];
		  if (Array.isArray(firstArg)) {
		    return firstArg.map((arg) => extractLayerPathSegment(arg) || "").join(",");
		  }
		  return extractLayerPathSegment(firstArg);
		};
		const extractLayerPathSegment = (arg) => typeof arg === "string" ? arg : arg instanceof RegExp || typeof arg === "number" ? String(arg) : void 0;
		const isExpressWithRouterPrototype = (express) => isExpressRouterPrototype(express?.Router?.prototype);
		const isExpressRouterPrototype = (routerProto) => (typeof routerProto === "object" || typeof routerProto === "function") && !!routerProto && "route" in routerProto && typeof routerProto.route === "function";
		const isExpressWithoutRouterPrototype = (express) => isExpressRouterPrototype(express.Router) && !isExpressWithRouterPrototype(express);
		function getStatusCodeFromResponse(error) {
		  const statusCode = error.status || error.statusCode || error.status_code || error.output?.statusCode;
		  return statusCode ? parseInt(statusCode, 10) : 500;
		}
		function defaultShouldHandleError(error) {
		  const status = getStatusCodeFromResponse(error);
		  return status >= 500;
		}

		exports.asErrorAndMessage = asErrorAndMessage;
		exports.defaultShouldHandleError = defaultShouldHandleError;
		exports.getActualMatchedRoute = getActualMatchedRoute;
		exports.getConstructedRoute = getConstructedRoute;
		exports.getLayerMetadata = getLayerMetadata;
		exports.getLayerPath = getLayerPath;
		exports.getRouterPath = getRouterPath;
		exports.isExpressWithRouterPrototype = isExpressWithRouterPrototype;
		exports.isExpressWithoutRouterPrototype = isExpressWithoutRouterPrototype;
		exports.isLayerIgnored = isLayerIgnored;
		exports.isRoutePattern = isRoutePattern;
		
	} (utils$7));
	return utils$7;
}

var patchLayer = {};

var setSdkProcessingMetadata = {};

var hasRequiredSetSdkProcessingMetadata;

function requireSetSdkProcessingMetadata () {
	if (hasRequiredSetSdkProcessingMetadata) return setSdkProcessingMetadata;
	hasRequiredSetSdkProcessingMetadata = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const request = /*@__PURE__*/ requireRequest$1();

		function setSDKProcessingMetadata(request$1) {
		  const sdkProcMeta = currentScopes.getIsolationScope()?.getScopeData()?.sdkProcessingMetadata;
		  if (!sdkProcMeta?.normalizedRequest) {
		    const normalizedRequest = request.httpRequestToRequestData(request$1);
		    currentScopes.getIsolationScope().setSDKProcessingMetadata({ normalizedRequest });
		  }
		}

		exports.setSDKProcessingMetadata = setSDKProcessingMetadata;
		
	} (setSdkProcessingMetadata));
	return setSdkProcessingMetadata;
}

var hasRequiredPatchLayer;

function requirePatchLayer () {
	if (hasRequiredPatchLayer) return patchLayer;
	hasRequiredPatchLayer = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const object = /*@__PURE__*/ requireObject();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const trace = /*@__PURE__*/ requireTrace();
		const requestLayerStore = /*@__PURE__*/ requireRequestLayerStore();
		const types = /*@__PURE__*/ requireTypes$1();
		const utils = /*@__PURE__*/ requireUtils$7();
		const defaultScopes = /*@__PURE__*/ requireDefaultScopes();
		const setSdkProcessingMetadata = /*@__PURE__*/ requireSetSdkProcessingMetadata();

		function patchLayer(getOptions, maybeLayer, layerPath) {
		  if (!maybeLayer?.handle) {
		    return;
		  }
		  const layer = maybeLayer;
		  const layerHandleOriginal = layer.handle;
		  if (object.getOriginalFunction(layerHandleOriginal)) {
		    return;
		  }
		  if (layerHandleOriginal.length === 4) {
		    return;
		  }
		  function layerHandlePatched(req, res, ...otherArgs) {
		    const options = getOptions();
		    setSdkProcessingMetadata.setSDKProcessingMetadata(req);
		    const parentSpan = spanUtils.getActiveSpan();
		    if (!parentSpan) {
		      return layerHandleOriginal.apply(this, [req, res, ...otherArgs]);
		    }
		    if (layerPath) {
		      requestLayerStore.storeLayer(req, layerPath);
		    }
		    const storedLayers = requestLayerStore.getStoredLayers(req);
		    const isLayerPathStored = !!layerPath;
		    const constructedRoute = utils.getConstructedRoute(req);
		    const actualMatchedRoute = utils.getActualMatchedRoute(req, constructedRoute);
		    options.onRouteResolved?.(actualMatchedRoute);
		    const metadata = utils.getLayerMetadata(constructedRoute, layer, layerPath);
		    const name = metadata.attributes[types.ATTR_EXPRESS_NAME];
		    const type = metadata.attributes[types.ATTR_EXPRESS_TYPE];
		    const attributes = Object.assign(metadata.attributes, {
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.http.express",
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `${type}.express`
		    });
		    if (actualMatchedRoute) {
		      attributes[types.ATTR_HTTP_ROUTE] = actualMatchedRoute;
		    }
		    if (utils.isLayerIgnored(metadata.attributes[types.ATTR_EXPRESS_NAME], type, options)) {
		      if (isLayerPathStored) {
		        storedLayers.pop();
		      }
		      return layerHandleOriginal.apply(this, [req, res, ...otherArgs]);
		    }
		    const currentScope = currentScopes.getIsolationScope();
		    if (currentScope !== defaultScopes.getDefaultIsolationScope()) {
		      if (type === "request_handler") {
		        const method = req.method ? req.method.toUpperCase() : "GET";
		        currentScope.setTransactionName(`${method} ${constructedRoute}`);
		      }
		    } else {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.warn("Isolation scope is still default isolation scope - skipping setting transactionName");
		    }
		    return trace.startSpanManual({ name, attributes }, (span) => {
		      let spanHasEnded = false;
		      if (metadata.attributes[types.ATTR_EXPRESS_TYPE] === types.ExpressLayerType_ROUTER) {
		        span.end();
		        spanHasEnded = true;
		      }
		      const onResponseFinish = () => {
		        if (!spanHasEnded) {
		          spanHasEnded = true;
		          span.end();
		        }
		      };
		      for (let i = 0; i < otherArgs.length; i++) {
		        const callback = otherArgs[i];
		        if (typeof callback !== "function") {
		          continue;
		        }
		        otherArgs[i] = function(...args) {
		          const maybeError = args[0];
		          const isError = !!maybeError && maybeError !== "route" && maybeError !== "router";
		          if (!spanHasEnded && isError) {
		            const [_, message] = utils.asErrorAndMessage(maybeError);
		            span.setStatus({
		              code: spanstatus.SPAN_STATUS_ERROR,
		              message
		            });
		          }
		          if (!spanHasEnded) {
		            spanHasEnded = true;
		            res.removeListener("finish", onResponseFinish);
		            span.end();
		          }
		          if (!(req.route && isError) && isLayerPathStored) {
		            storedLayers.pop();
		          }
		          return trace.withActiveSpan(parentSpan, () => callback.apply(this, args));
		        };
		        break;
		      }
		      try {
		        return layerHandleOriginal.apply(this, [req, res, ...otherArgs]);
		      } catch (anyError) {
		        const [_, message] = utils.asErrorAndMessage(anyError);
		        span.setStatus({
		          code: spanstatus.SPAN_STATUS_ERROR,
		          message
		        });
		        throw anyError;
		      } finally {
		        if (!spanHasEnded) {
		          res.once("finish", onResponseFinish);
		        }
		      }
		    });
		  }
		  for (const key in layerHandleOriginal) {
		    if (key in layerHandlePatched) {
		      continue;
		    }
		    Object.defineProperty(layerHandlePatched, key, {
		      get() {
		        return layerHandleOriginal[key];
		      },
		      set(value) {
		        layerHandleOriginal[key] = value;
		      }
		    });
		  }
		  object.markFunctionWrapped(layerHandlePatched, layerHandleOriginal);
		  Object.defineProperty(layer, "handle", {
		    enumerable: true,
		    configurable: true,
		    writable: true,
		    value: layerHandlePatched
		  });
		}

		exports.patchLayer = patchLayer;
		
	} (patchLayer));
	return patchLayer;
}

var getDefaultExport = {};

var hasRequiredGetDefaultExport;

function requireGetDefaultExport () {
	if (hasRequiredGetDefaultExport) return getDefaultExport;
	hasRequiredGetDefaultExport = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function getDefaultExport(moduleExport) {
		  return !!moduleExport && typeof moduleExport === "object" && "default" in moduleExport && moduleExport.default || moduleExport;
		}

		exports.getDefaultExport = getDefaultExport;
		
	} (getDefaultExport));
	return getDefaultExport;
}

var hasRequiredExpress;

function requireExpress () {
	if (hasRequiredExpress) return express;
	hasRequiredExpress = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const utils = /*@__PURE__*/ requireUtils$7();
		const object = /*@__PURE__*/ requireObject();
		const patchLayer = /*@__PURE__*/ requirePatchLayer();
		const setSdkProcessingMetadata = /*@__PURE__*/ requireSetSdkProcessingMetadata();
		const getDefaultExport = /*@__PURE__*/ requireGetDefaultExport();

		function isLegacyOptions(options) {
		  return !!options.express;
		}
		let didLegacyDeprecationWarning = false;
		function deprecationWarning() {
		  if (!didLegacyDeprecationWarning) {
		    didLegacyDeprecationWarning = true;
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn(
		      "[Express] `patchExpressModule(options)` is deprecated. Use `patchExpressModule(moduleExports, getOptions)` instead."
		    );
		  }
		}
		function patchExpressModule(optionsOrExports, maybeGetOptions) {
		  let getOptions;
		  let moduleExports;
		  if (!maybeGetOptions && isLegacyOptions(optionsOrExports)) {
		    const { express: express2, ...options } = optionsOrExports;
		    moduleExports = express2;
		    getOptions = () => options;
		    deprecationWarning();
		  } else if (typeof maybeGetOptions !== "function") {
		    throw new TypeError("`patchExpressModule(moduleExports, getOptions)` requires a `getOptions` callback");
		  } else {
		    getOptions = maybeGetOptions;
		    moduleExports = optionsOrExports;
		  }
		  const express = getDefaultExport.getDefaultExport(moduleExports);
		  const routerProto = utils.isExpressWithRouterPrototype(express) ? express.Router.prototype : utils.isExpressWithoutRouterPrototype(express) ? express.Router : void 0;
		  if (!routerProto) {
		    throw new TypeError("no valid Express route function to instrument");
		  }
		  const originalRouteMethod = routerProto.route;
		  try {
		    object.wrapMethod(
		      routerProto,
		      "route",
		      function routeTrace(...args) {
		        const route = originalRouteMethod.apply(this, args);
		        const layer = this.stack[this.stack.length - 1];
		        patchLayer.patchLayer(getOptions, layer, utils.getLayerPath(args));
		        return route;
		      }
		    );
		  } catch (e) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error("Failed to patch express route method:", e);
		  }
		  const originalRouterUse = routerProto.use;
		  try {
		    object.wrapMethod(
		      routerProto,
		      "use",
		      function useTrace(...args) {
		        const route = originalRouterUse.apply(this, args);
		        const layer = this.stack[this.stack.length - 1];
		        if (!layer) {
		          return route;
		        }
		        patchLayer.patchLayer(getOptions, layer, utils.getLayerPath(args));
		        return route;
		      }
		    );
		  } catch (e) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error("Failed to patch express use method:", e);
		  }
		  const { application } = express;
		  const originalApplicationUse = application.use;
		  try {
		    object.wrapMethod(
		      application,
		      "use",
		      function appUseTrace(...args) {
		        const route = originalApplicationUse.apply(this, args);
		        const router = utils.isExpressWithRouterPrototype(express) ? this.router : this._router;
		        if (router) {
		          const layer = router.stack[router.stack.length - 1];
		          if (layer) {
		            patchLayer.patchLayer(getOptions, layer, utils.getLayerPath(args));
		          }
		        }
		        return route;
		      }
		    );
		  } catch (e) {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.error("Failed to patch express application.use method:", e);
		  }
		  return express;
		}
		function expressErrorHandler(options) {
		  return function sentryErrorMiddleware(error, request, res, next) {
		    setSdkProcessingMetadata.setSDKProcessingMetadata(request);
		    const shouldHandleError = options?.shouldHandleError || utils.defaultShouldHandleError;
		    if (shouldHandleError(error)) {
		      const eventId = exports$1.captureException(error, {
		        mechanism: { type: "auto.middleware.express", handled: false }
		      });
		      res.sentry = eventId;
		    }
		    next(error);
		  };
		}
		function setupExpressErrorHandler(app, options) {
		  app.use(expressRequestHandler());
		  app.use(expressErrorHandler(options));
		}
		function expressRequestHandler() {
		  return function sentryRequestMiddleware(request, _res, next) {
		    setSdkProcessingMetadata.setSDKProcessingMetadata(request);
		    next();
		  };
		}

		exports.expressErrorHandler = expressErrorHandler;
		exports.patchExpressModule = patchExpressModule;
		exports.setupExpressErrorHandler = setupExpressErrorHandler;
		
	} (express));
	return express;
}

var postgresjs = {};

var hasRequiredPostgresjs;

function requirePostgresjs () {
	if (hasRequiredPostgresjs) return postgresjs;
	hasRequiredPostgresjs = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();

		const SQL_OPERATION_REGEX = /^(SELECT|INSERT|UPDATE|DELETE|CREATE|DROP|ALTER)/i;
		const CONNECTION_CONTEXT_SYMBOL = /* @__PURE__ */ Symbol("sentryPostgresConnectionContext");
		const INSTRUMENTED_MARKER = /* @__PURE__ */ Symbol.for("sentry.instrumented.postgresjs");
		const QUERY_FROM_INSTRUMENTED_SQL = /* @__PURE__ */ Symbol.for("sentry.query.from.instrumented.sql");
		function instrumentPostgresJsSql(sql, options) {
		  if (!sql || typeof sql !== "function") {
		    debugBuild.DEBUG_BUILD && debugLogger.debug.warn("instrumentPostgresJsSql: provided value is not a valid postgres.js sql instance");
		    return sql;
		  }
		  return _instrumentSqlInstance(sql, { requireParentSpan: true, ...options });
		}
		function _instrumentSqlInstance(sql, options, parentConnectionContext) {
		  if (sql[INSTRUMENTED_MARKER]) {
		    return sql;
		  }
		  const proxiedSql = new Proxy(sql, {
		    apply(target, thisArg, argumentsList) {
		      const query = Reflect.apply(target, thisArg, argumentsList);
		      if (query && typeof query === "object" && "handle" in query) {
		        _wrapSingleQueryHandle(query, proxiedSql, options);
		      }
		      return query;
		    },
		    get(target, prop) {
		      const original = target[prop];
		      if (typeof prop !== "string" || typeof original !== "function") {
		        return original;
		      }
		      if (prop === "unsafe" || prop === "file") {
		        return _wrapQueryMethod(original, target, proxiedSql, options);
		      }
		      if (prop === "begin" || prop === "reserve") {
		        return _wrapCallbackMethod(original, target, proxiedSql, options);
		      }
		      return original;
		    }
		  });
		  if (parentConnectionContext) {
		    proxiedSql[CONNECTION_CONTEXT_SYMBOL] = parentConnectionContext;
		  } else {
		    _attachConnectionContext(sql, proxiedSql);
		  }
		  sql[INSTRUMENTED_MARKER] = true;
		  proxiedSql[INSTRUMENTED_MARKER] = true;
		  return proxiedSql;
		}
		function _wrapQueryMethod(original, target, proxiedSql, options) {
		  return function(...args) {
		    const query = Reflect.apply(original, target, args);
		    if (query && typeof query === "object" && "handle" in query) {
		      _wrapSingleQueryHandle(query, proxiedSql, options);
		    }
		    return query;
		  };
		}
		function _wrapCallbackMethod(original, target, parentSqlInstance, options) {
		  return function(...args) {
		    const parentContext = parentSqlInstance[CONNECTION_CONTEXT_SYMBOL];
		    const isCallbackBased = typeof args[args.length - 1] === "function";
		    if (!isCallbackBased) {
		      const result = Reflect.apply(original, target, args);
		      if (result && typeof result.then === "function") {
		        return result.then((sqlInstance) => {
		          return _instrumentSqlInstance(sqlInstance, options, parentContext);
		        });
		      }
		      return result;
		    }
		    const callback = args.length === 1 ? args[0] : args[1];
		    const wrappedCallback = function(sqlInstance) {
		      const instrumentedSql = _instrumentSqlInstance(sqlInstance, options, parentContext);
		      return callback(instrumentedSql);
		    };
		    const newArgs = args.length === 1 ? [wrappedCallback] : [args[0], wrappedCallback];
		    return Reflect.apply(original, target, newArgs);
		  };
		}
		function _wrapSingleQueryHandle(query, sqlInstance, options) {
		  if (query.handle?.__sentryWrapped) {
		    return;
		  }
		  query[QUERY_FROM_INSTRUMENTED_SQL] = true;
		  const originalHandle = query.handle;
		  const wrappedHandle = async function(...args) {
		    if (this.executed || !_shouldCreateSpans(options)) {
		      return originalHandle.apply(this, args);
		    }
		    const fullQuery = _reconstructQuery(query.strings);
		    const sanitizedSqlQuery = _sanitizeSqlQuery(fullQuery);
		    return trace.startSpanManual(
		      {
		        name: sanitizedSqlQuery || "postgresjs.query",
		        op: "db"
		      },
		      (span) => {
		        span.setAttribute(semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.db.postgresjs");
		        span.setAttributes({
		          "db.system.name": "postgres",
		          "db.query.text": sanitizedSqlQuery
		        });
		        const connectionContext = sqlInstance ? sqlInstance[CONNECTION_CONTEXT_SYMBOL] : void 0;
		        _setConnectionAttributes(span, connectionContext);
		        if (options.requestHook) {
		          try {
		            options.requestHook(span, sanitizedSqlQuery, connectionContext);
		          } catch (e) {
		            span.setAttribute("sentry.hook.error", "requestHook failed");
		            debugBuild.DEBUG_BUILD && debugLogger.debug.error("Error in requestHook for PostgresJs instrumentation:", e);
		          }
		        }
		        const queryWithCallbacks = this;
		        queryWithCallbacks.resolve = new Proxy(queryWithCallbacks.resolve, {
		          apply: (resolveTarget, resolveThisArg, resolveArgs) => {
		            try {
		              _setOperationName(span, sanitizedSqlQuery, resolveArgs?.[0]?.command);
		              span.end();
		            } catch (e) {
		              debugBuild.DEBUG_BUILD && debugLogger.debug.error("Error ending span in resolve callback:", e);
		            }
		            return Reflect.apply(resolveTarget, resolveThisArg, resolveArgs);
		          }
		        });
		        queryWithCallbacks.reject = new Proxy(queryWithCallbacks.reject, {
		          apply: (rejectTarget, rejectThisArg, rejectArgs) => {
		            try {
		              span.setStatus({
		                code: spanstatus.SPAN_STATUS_ERROR,
		                message: rejectArgs?.[0]?.message || "unknown_error"
		              });
		              span.setAttribute("db.response.status_code", rejectArgs?.[0]?.code || "unknown");
		              span.setAttribute("error.type", rejectArgs?.[0]?.name || "unknown");
		              _setOperationName(span, sanitizedSqlQuery);
		              span.end();
		            } catch (e) {
		              debugBuild.DEBUG_BUILD && debugLogger.debug.error("Error ending span in reject callback:", e);
		            }
		            return Reflect.apply(rejectTarget, rejectThisArg, rejectArgs);
		          }
		        });
		        try {
		          return originalHandle.apply(this, args);
		        } catch (e) {
		          span.setStatus({
		            code: spanstatus.SPAN_STATUS_ERROR,
		            message: e instanceof Error ? e.message : "unknown_error"
		          });
		          span.end();
		          throw e;
		        }
		      }
		    );
		  };
		  wrappedHandle.__sentryWrapped = true;
		  query.handle = wrappedHandle;
		}
		function _shouldCreateSpans(options) {
		  const hasParentSpan = spanUtils.getActiveSpan() !== void 0;
		  return hasParentSpan || !options.requireParentSpan;
		}
		function _reconstructQuery(strings) {
		  if (!strings?.length) {
		    return void 0;
		  }
		  if (strings.length === 1) {
		    return strings[0] || void 0;
		  }
		  return strings.reduce((acc, str, i) => i === 0 ? str : `${acc}$${i}${str}`, "");
		}
		let integerLiteralRE;
		function _sanitizeSqlQuery(sqlQuery) {
		  if (!sqlQuery) {
		    return "Unknown SQL Query";
		  }
		  if (!integerLiteralRE) {
		    integerLiteralRE = new RegExp("(?<!\\$)-?\\b\\d+\\b", "g");
		  }
		  return sqlQuery.replace(/--.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "").replace(/;\s*$/, "").replace(/\s+/g, " ").trim().replace(/\bX'[0-9A-Fa-f]*'/gi, "?").replace(/\bB'[01]*'/gi, "?").replace(/'(?:[^']|'')*'/g, "?").replace(/\b0x[0-9A-Fa-f]+/gi, "?").replace(/\b(?:TRUE|FALSE)\b/gi, "?").replace(/-?\b\d+\.?\d*[eE][+-]?\d+\b/g, "?").replace(/-?\b\d+\.\d+\b/g, "?").replace(/-?\.\d+\b/g, "?").replace(integerLiteralRE, "?").replace(/\bIN\b\s*\(\s*\?(?:\s*,\s*\?)*\s*\)/gi, "IN (?)").replace(/\bIN\b\s*\(\s*\$\d+(?:\s*,\s*\$\d+)*\s*\)/gi, "IN ($?)");
		}
		function _setConnectionAttributes(span, connectionContext) {
		  if (!connectionContext) {
		    return;
		  }
		  if (connectionContext.ATTR_DB_NAMESPACE) {
		    span.setAttribute("db.namespace", connectionContext.ATTR_DB_NAMESPACE);
		  }
		  if (connectionContext.ATTR_SERVER_ADDRESS) {
		    span.setAttribute("server.address", connectionContext.ATTR_SERVER_ADDRESS);
		  }
		  if (connectionContext.ATTR_SERVER_PORT !== void 0) {
		    const portNumber = parseInt(connectionContext.ATTR_SERVER_PORT, 10);
		    if (!isNaN(portNumber)) {
		      span.setAttribute("server.port", portNumber);
		    }
		  }
		}
		function _setOperationName(span, sanitizedQuery, command) {
		  if (command) {
		    span.setAttribute("db.operation.name", command);
		    return;
		  }
		  const operationMatch = sanitizedQuery?.match(SQL_OPERATION_REGEX);
		  if (operationMatch?.[1]) {
		    span.setAttribute("db.operation.name", operationMatch[1].toUpperCase());
		  }
		}
		function _attachConnectionContext(sql, proxiedSql) {
		  const sqlInstance = sql;
		  if (!sqlInstance.options || typeof sqlInstance.options !== "object") {
		    return;
		  }
		  const opts = sqlInstance.options;
		  const host = opts.host?.[0] || "localhost";
		  const port = opts.port?.[0] || 5432;
		  const connectionContext = {
		    ATTR_DB_NAMESPACE: typeof opts.database === "string" && opts.database !== "" ? opts.database : void 0,
		    ATTR_SERVER_ADDRESS: host,
		    ATTR_SERVER_PORT: String(port)
		  };
		  proxiedSql[CONNECTION_CONTEXT_SYMBOL] = connectionContext;
		}

		exports._reconstructQuery = _reconstructQuery;
		exports._sanitizeSqlQuery = _sanitizeSqlQuery;
		exports.instrumentPostgresJsSql = instrumentPostgresJsSql;
		
	} (postgresjs));
	return postgresjs;
}

var clientPatch = {};

var constants$1 = {};

var hasRequiredConstants$1;

function requireConstants$1 () {
	if (hasRequiredConstants$1) return constants$1;
	hasRequiredConstants$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const LOG_PREFIX = "@sentry/instrumentation-http";
		const HTTP_ON_CLIENT_REQUEST = "http.client.request.created";
		const HTTP_ON_SERVER_REQUEST = "http.server.request.start";

		exports.HTTP_ON_CLIENT_REQUEST = HTTP_ON_CLIENT_REQUEST;
		exports.HTTP_ON_SERVER_REQUEST = HTTP_ON_SERVER_REQUEST;
		exports.LOG_PREFIX = LOG_PREFIX;
		
	} (constants$1));
	return constants$1;
}

var clientSubscriptions = {};

var addOutgoingRequestBreadcrumb = {};

var getRequestUrl = {};

var hasRequiredGetRequestUrl;

function requireGetRequestUrl () {
	if (hasRequiredGetRequestUrl) return getRequestUrl;
	hasRequiredGetRequestUrl = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function getRequestOptions(request) {
		  const hostWithPort = request.host || "";
		  const portInHost = /^(.*):(\d+)$/.exec(hostWithPort);
		  const hostname = portInHost ? portInHost[1] : hostWithPort;
		  const port = request.port ?? (portInHost ? Number(portInHost[2]) : void 0);
		  return {
		    method: request.method,
		    port,
		    protocol: request.protocol,
		    host: request.host,
		    hostname,
		    path: request.path,
		    headers: request.getHeaders()
		  };
		}
		function getRequestUrl(requestOptions) {
		  try {
		    return String(getRequestUrlObject(requestOptions));
		  } catch {
		    return "";
		  }
		}
		function getRequestUrlObject(requestOptions) {
		  const protocol = requestOptions.protocol || "http:";
		  const hostHeader = requestOptions.headers?.host && String(requestOptions.headers?.host);
		  const hostname = hostHeader || requestOptions.hostname || requestOptions.host || "";
		  const port = !requestOptions.port || requestOptions.port === 80 || requestOptions.port === 443 || /^(.*):(\d+)$/.test(hostname) ? "" : `:${requestOptions.port}`;
		  const path = requestOptions.path ? requestOptions.path : "/";
		  const base = `${protocol}//${hostname}${port}`;
		  return new URL(path.startsWith("//") ? `${base}${path}` : path, base);
		}
		function getRequestUrlFromClientRequest(request) {
		  return String(getRequestUrl(getRequestOptions(request)));
		}

		exports.getRequestOptions = getRequestOptions;
		exports.getRequestUrl = getRequestUrl;
		exports.getRequestUrlFromClientRequest = getRequestUrlFromClientRequest;
		exports.getRequestUrlObject = getRequestUrlObject;
		
	} (getRequestUrl));
	return getRequestUrl;
}

var hasRequiredAddOutgoingRequestBreadcrumb;

function requireAddOutgoingRequestBreadcrumb () {
	if (hasRequiredAddOutgoingRequestBreadcrumb) return addOutgoingRequestBreadcrumb;
	hasRequiredAddOutgoingRequestBreadcrumb = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const breadcrumbs = /*@__PURE__*/ requireBreadcrumbs$1();
		const breadcrumbLogLevel = /*@__PURE__*/ requireBreadcrumbLogLevel();
		const url = /*@__PURE__*/ requireUrl();
		const getRequestUrl = /*@__PURE__*/ requireGetRequestUrl();

		function addOutgoingRequestBreadcrumb(request, response) {
		  const url$1 = getRequestUrl.getRequestUrlFromClientRequest(request);
		  const parsedUrl = url.parseUrl(url$1);
		  const statusCode = response?.statusCode;
		  const level = breadcrumbLogLevel.getBreadcrumbLogLevelFromHttpStatusCode(statusCode);
		  breadcrumbs.addBreadcrumb(
		    {
		      category: "http",
		      data: {
		        status_code: statusCode,
		        url: url.getSanitizedUrlString(parsedUrl),
		        "http.method": request.method || "GET",
		        ...parsedUrl.search ? { "http.query": parsedUrl.search } : {},
		        ...parsedUrl.hash ? { "http.fragment": parsedUrl.hash } : {}
		      },
		      type: "http",
		      level
		    },
		    {
		      event: "response",
		      request,
		      response
		    }
		  );
		}

		exports.addOutgoingRequestBreadcrumb = addOutgoingRequestBreadcrumb;
		
	} (addOutgoingRequestBreadcrumb));
	return addOutgoingRequestBreadcrumb;
}

var getOutgoingSpanData = {};

var hasRequiredGetOutgoingSpanData;

function requireGetOutgoingSpanData () {
	if (hasRequiredGetOutgoingSpanData) return getOutgoingSpanData;
	hasRequiredGetOutgoingSpanData = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const url = /*@__PURE__*/ requireUrl();
		const getRequestUrl = /*@__PURE__*/ requireGetRequestUrl();

		function getOutgoingRequestSpanData(request) {
		  const url$1 = getRequestUrl.getRequestUrlFromClientRequest(request);
		  const [name, attributes] = url.getHttpSpanDetailsFromUrlObject(
		    url.parseStringToURLObject(url$1),
		    "client",
		    "auto.http.client",
		    request
		  );
		  const userAgent = request.getHeader("user-agent");
		  return {
		    name,
		    attributes: {
		      // TODO(v11): Update these to the Sentry semantic attributes for urls.
		      // https://getsentry.github.io/sentry-conventions/attributes/
		      [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client",
		      "otel.kind": "CLIENT",
		      "http.url": url$1,
		      "http.method": request.method,
		      "http.target": request.path || "/",
		      "net.peer.name": request.host,
		      "http.host": request.getHeader("host"),
		      ...userAgent ? { "user_agent.original": userAgent } : {},
		      ...attributes
		    },
		    onlyIfParent: true
		  };
		}
		function setIncomingResponseSpanData(response, span) {
		  const { statusCode, statusMessage, httpVersion, socket } = response;
		  const transport = httpVersion?.toUpperCase() !== "QUIC" ? "ip_tcp" : "ip_udp";
		  span.setAttributes({
		    "http.response.status_code": statusCode,
		    "network.protocol.version": httpVersion,
		    // TODO(v11): Update these to the Sentry semantic attributes for urls.
		    // https://getsentry.github.io/sentry-conventions/attributes/
		    "http.flavor": httpVersion,
		    "network.transport": transport,
		    "net.transport": transport,
		    "http.status_text": statusMessage?.toUpperCase(),
		    "http.status_code": statusCode,
		    ...getResponseContentLengthAttributes(response),
		    ...getSocketAttrs(socket)
		  });
		}
		function getSocketAttrs(socket) {
		  if (!socket) return {};
		  const { remoteAddress, remotePort } = socket;
		  return {
		    "network.peer.address": remoteAddress,
		    "network.peer.port": remotePort,
		    "net.peer.ip": remoteAddress,
		    "net.peer.port": remotePort
		  };
		}
		function getResponseContentLengthAttributes(response) {
		  const { headers } = response;
		  const contentLengthHeader = headers["content-length"];
		  const length = contentLengthHeader ? parseInt(String(contentLengthHeader), 10) : -1;
		  const encoding = headers["content-encoding"];
		  return length >= 0 ? encoding && encoding !== "identity" ? { "http.response_content_length": length } : { "http.response_content_length_uncompressed": length } : {};
		}

		exports.getOutgoingRequestSpanData = getOutgoingRequestSpanData;
		exports.setIncomingResponseSpanData = setIncomingResponseSpanData;
		
	} (getOutgoingSpanData));
	return getOutgoingSpanData;
}

var injectTracePropagationHeaders = {};

var hasRequiredInjectTracePropagationHeaders;

function requireInjectTracePropagationHeaders () {
	if (hasRequiredInjectTracePropagationHeaders) return injectTracePropagationHeaders;
	hasRequiredInjectTracePropagationHeaders = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const is = /*@__PURE__*/ requireIs$1();
		const traceData = /*@__PURE__*/ requireTraceData();
		const tracePropagationTargets = /*@__PURE__*/ requireTracePropagationTargets();
		const constants = /*@__PURE__*/ requireConstants$1();
		const getRequestUrl = /*@__PURE__*/ requireGetRequestUrl();
		const baggage = /*@__PURE__*/ requireBaggage();

		function injectTracePropagationHeaders(request, propagationDecisionMap) {
		  const url = getRequestUrl.getRequestUrlFromClientRequest(request);
		  const clientOptions = currentScopes.getClient()?.getOptions();
		  const { tracePropagationTargets: tracePropagationTargets$1, propagateTraceparent } = clientOptions ?? {};
		  if (!tracePropagationTargets.shouldPropagateTraceForUrl(url, tracePropagationTargets$1, propagationDecisionMap)) {
		    return;
		  }
		  const hasExistingSentryTraceHeader = !!request.getHeader("sentry-trace");
		  if (hasExistingSentryTraceHeader) {
		    return;
		  }
		  const traceData$1 = traceData.getTraceData({ propagateTraceparent });
		  if (!traceData$1) return;
		  const { "sentry-trace": sentryTrace, baggage: baggage$1, traceparent } = traceData$1;
		  if (sentryTrace) {
		    try {
		      request.setHeader("sentry-trace", sentryTrace);
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(constants.LOG_PREFIX, "Added sentry-trace header");
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.error(constants.LOG_PREFIX, "Failed to set sentry-trace header:", is.isError(e) ? e.message : "Unknown error");
		    }
		  }
		  if (traceparent && !request.getHeader("traceparent")) {
		    try {
		      request.setHeader("traceparent", traceparent);
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(constants.LOG_PREFIX, "Added traceparent header");
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.error(constants.LOG_PREFIX, "Failed to set traceparent header:", is.isError(e) ? e.message : "Unknown error");
		    }
		  }
		  if (baggage$1) {
		    const merged = baggage.mergeBaggageHeaders(request.getHeader("baggage"), baggage$1);
		    if (merged) {
		      try {
		        request.setHeader("baggage", merged);
		        debugBuild.DEBUG_BUILD && debugLogger.debug.log(constants.LOG_PREFIX, "Added baggage header");
		      } catch (e) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.error(constants.LOG_PREFIX, "Failed to set baggage header:", is.isError(e) ? e.message : "Unknown error");
		      }
		    }
		  }
		}

		exports.injectTracePropagationHeaders = injectTracePropagationHeaders;
		
	} (injectTracePropagationHeaders));
	return injectTracePropagationHeaders;
}

var doubleWrapWarning = {};

var hasRequiredDoubleWrapWarning;

function requireDoubleWrapWarning () {
	if (hasRequiredDoubleWrapWarning) return doubleWrapWarning;
	hasRequiredDoubleWrapWarning = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();

		const isOtelWrapped = (fn) => typeof fn.__unwrap === "function";
		const warning = "Double-wrapped http.client detected. Either disable spans in Sentry.httpIntegration, or disable the OpenTelemetry HTTP instrumentation. See: https://docs.sentry.io/platforms/javascript/guides/express/opentelemetry/custom-setup/#custom-http-instrumentation";
		let didDoubleWrapWarning = false;
		const doubleWrapWarning = debugBuild.DEBUG_BUILD ? (http) => {
		  if (!didDoubleWrapWarning) {
		    if (isOtelWrapped(http.request) || isOtelWrapped(http.get)) {
		      didDoubleWrapWarning = true;
		      debugLogger.debug.warn(warning);
		    }
		  }
		} : () => {
		};

		exports.doubleWrapWarning = doubleWrapWarning;
		exports.warning = warning;
		
	} (doubleWrapWarning));
	return doubleWrapWarning;
}

var hasRequiredClientSubscriptions;

function requireClientSubscriptions () {
	if (hasRequiredClientSubscriptions) return clientSubscriptions;
	hasRequiredClientSubscriptions = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const addOutgoingRequestBreadcrumb = /*@__PURE__*/ requireAddOutgoingRequestBreadcrumb();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const trace = /*@__PURE__*/ requireTrace();
		const lru = /*@__PURE__*/ requireLru();
		const getOutgoingSpanData = /*@__PURE__*/ requireGetOutgoingSpanData();
		const getRequestUrl = /*@__PURE__*/ requireGetRequestUrl();
		const injectTracePropagationHeaders = /*@__PURE__*/ requireInjectTracePropagationHeaders();
		const constants = /*@__PURE__*/ requireConstants$1();
		const doubleWrapWarning = /*@__PURE__*/ requireDoubleWrapWarning();

		function getHttpClientSubscriptions(options) {
		  const propagationDecisionMap = new lru.LRUMap(100);
		  const getConfig = () => currentScopes.getClient()?.getOptions();
		  const onHttpClientRequestCreated = (data) => {
		    if (currentScopes.getCurrentScope().getScopeData().sdkProcessingMetadata[trace.SUPPRESS_TRACING_KEY] === true) {
		      return;
		    }
		    const clientOptions = getConfig();
		    const {
		      errorMonitor = "error",
		      spans: createSpans = clientOptions ? hasSpansEnabled.hasSpansEnabled(clientOptions) : true,
		      propagateTrace = false,
		      breadcrumbs = true,
		      http,
		      https,
		      suppressOtelWarning = false
		    } = options;
		    const { request } = data;
		    if (options.ignoreOutgoingRequests?.(getRequestUrl.getRequestUrlFromClientRequest(request), request)) {
		      return;
		    }
		    let addedBreadcrumbs = false;
		    function addBreadcrumbs(request2, response) {
		      if (!addedBreadcrumbs) {
		        addedBreadcrumbs = true;
		        addOutgoingRequestBreadcrumb.addOutgoingRequestBreadcrumb(request2, response);
		      }
		    }
		    function breadcrumbsOnly(request2) {
		      request2.on(errorMonitor, () => addBreadcrumbs(request2, void 0));
		      request2.prependListener("response", (response) => {
		        if (request2.listenerCount("response") <= 1) {
		          response.resume();
		        }
		        response.on("end", () => addBreadcrumbs(request2, response));
		        response.on(errorMonitor, () => addBreadcrumbs(request2, response));
		      });
		    }
		    if (!createSpans) {
		      if (breadcrumbs) {
		        breadcrumbsOnly(request);
		      }
		      if (propagateTrace) {
		        injectTracePropagationHeaders.injectTracePropagationHeaders(request, propagationDecisionMap);
		      }
		      return;
		    }
		    if (!suppressOtelWarning) {
		      if (http) doubleWrapWarning.doubleWrapWarning(http);
		      if (https) doubleWrapWarning.doubleWrapWarning(https);
		    }
		    const span = trace.startInactiveSpan(getOutgoingSpanData.getOutgoingRequestSpanData(request));
		    options.outgoingRequestHook?.(span, request);
		    if (propagateTrace) {
		      if (span.isRecording()) {
		        trace.withActiveSpan(span, () => {
		          injectTracePropagationHeaders.injectTracePropagationHeaders(request, propagationDecisionMap);
		        });
		      } else {
		        injectTracePropagationHeaders.injectTracePropagationHeaders(request, propagationDecisionMap);
		      }
		    }
		    let spanEnded = false;
		    function endSpan(status) {
		      if (!spanEnded) {
		        spanEnded = true;
		        span.setStatus(status);
		        span.end();
		      }
		    }
		    const requestOnClose = () => endSpan({ code: spanstatus.SPAN_STATUS_UNSET });
		    request.on("close", requestOnClose);
		    request.on(errorMonitor, (error) => {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(constants.LOG_PREFIX, "outgoingRequest on request error()", error);
		      if (breadcrumbs) {
		        addBreadcrumbs(request, void 0);
		      }
		      endSpan({ code: spanstatus.SPAN_STATUS_ERROR });
		    });
		    request.prependListener("response", (response) => {
		      request.removeListener("close", requestOnClose);
		      if (request.listenerCount("response") <= 1) {
		        response.resume();
		      }
		      getOutgoingSpanData.setIncomingResponseSpanData(response, span);
		      options.outgoingResponseHook?.(span, response);
		      let finished = false;
		      function finishWithResponse(error) {
		        if (!finished) {
		          finished = true;
		          if (error) {
		            debugBuild.DEBUG_BUILD && debugLogger.debug.log(constants.LOG_PREFIX, "outgoingRequest on response error()", error);
		          }
		          if (breadcrumbs) {
		            addBreadcrumbs(request, response);
		          }
		          const aborted = response.aborted && !response.complete;
		          const status = error || typeof response.statusCode !== "number" || aborted ? { code: spanstatus.SPAN_STATUS_ERROR } : spanstatus.getSpanStatusFromHttpCode(response.statusCode);
		          options.applyCustomAttributesOnSpan?.(span, request, response);
		          endSpan(status);
		        }
		      }
		      response.on("end", () => finishWithResponse());
		      response.on(errorMonitor, finishWithResponse);
		    });
		  };
		  return {
		    [constants.HTTP_ON_CLIENT_REQUEST]: onHttpClientRequestCreated
		  };
		}

		exports.getHttpClientSubscriptions = getHttpClientSubscriptions;
		
	} (clientSubscriptions));
	return clientSubscriptions;
}

var hasRequiredClientPatch;

function requireClientPatch () {
	if (hasRequiredClientPatch) return clientPatch;
	hasRequiredClientPatch = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const getDefaultExport = /*@__PURE__*/ requireGetDefaultExport();
		const constants = /*@__PURE__*/ requireConstants$1();
		const object = /*@__PURE__*/ requireObject();
		const clientSubscriptions = /*@__PURE__*/ requireClientSubscriptions();

		function patchHttpRequest(httpModule, options) {
		  if (!object.getOriginalFunction(httpModule.request)) {
		    const { [constants.HTTP_ON_CLIENT_REQUEST]: onHttpClientRequestCreated } = clientSubscriptions.getHttpClientSubscriptions({
		      ...options,
		      http: httpModule
		    });
		    const originalRequest = httpModule.request;
		    object.wrapMethod(httpModule, "request", function patchedRequest(...args) {
		      const request = originalRequest.apply(this, args);
		      onHttpClientRequestCreated({ request }, constants.HTTP_ON_CLIENT_REQUEST);
		      return request;
		    });
		  }
		}
		function patchHttpGet(httpModule) {
		  if (!object.getOriginalFunction(httpModule.get)) {
		    object.wrapMethod(httpModule, "get", function patchedGet(input, options, cb) {
		      const request = httpModule.request.call(this, input, options, cb);
		      request.end();
		      return request;
		    });
		  }
		}
		function patchModule(httpModuleExport, options = {}) {
		  const httpDefault = getDefaultExport.getDefaultExport(httpModuleExport);
		  const httpModule = httpModuleExport;
		  if (httpDefault !== httpModuleExport) {
		    patchModule(httpDefault, options);
		    for (const method of ["get", "request"]) {
		      const desc = Object.getOwnPropertyDescriptor(httpDefault, method);
		      if (desc) {
		        Object.defineProperty(httpModule, method, desc);
		      }
		    }
		    return httpModule;
		  }
		  patchHttpRequest(httpModule, options);
		  patchHttpGet(httpModule);
		  return httpModuleExport;
		}
		const patchHttpModuleClient = (httpModuleExport, options = {}) => patchModule(httpModuleExport, options);

		exports.patchHttpModuleClient = patchHttpModuleClient;
		
	} (clientPatch));
	return clientPatch;
}

var serverSubscription = {};

var patchRequestToCaptureBody = {};

var hasRequiredPatchRequestToCaptureBody;

function requirePatchRequestToCaptureBody () {
	if (hasRequiredPatchRequestToCaptureBody) return patchRequestToCaptureBody;
	hasRequiredPatchRequestToCaptureBody = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const request = /*@__PURE__*/ requireRequest$1();

		function patchRequestToCaptureBody(req, isolationScope, maxIncomingRequestBodySize, integrationName) {
		  let bodyByteLength = 0;
		  const chunks = [];
		  debugBuild.DEBUG_BUILD && debugLogger.debug.log(integrationName, "Patching request.on");
		  const callbackMap = /* @__PURE__ */ new WeakMap();
		  const maxBodySize = request.getMaxBodyByteLength(maxIncomingRequestBodySize);
		  try {
		    req.on = req.addListener = new Proxy(req.on, {
		      apply: (target, thisArg, args) => {
		        const [event, listener, ...restArgs] = args;
		        if (event === "data") {
		          debugBuild.DEBUG_BUILD && debugLogger.debug.log(integrationName, `Handling request.on("data") with maximum body size of ${maxBodySize}b`);
		          const callback = new Proxy(listener, {
		            apply: (target2, thisArg2, args2) => {
		              try {
		                const chunk = args2[0];
		                const bufferifiedChunk = Buffer.from(chunk);
		                if (bodyByteLength < maxBodySize) {
		                  chunks.push(bufferifiedChunk);
		                  bodyByteLength += bufferifiedChunk.byteLength;
		                } else if (debugBuild.DEBUG_BUILD) {
		                  debugLogger.debug.log(
		                    integrationName,
		                    `Dropping request body chunk because maximum body length of ${maxBodySize}b is exceeded.`
		                  );
		                }
		              } catch (_err) {
		                debugBuild.DEBUG_BUILD && debugLogger.debug.error(integrationName, "Encountered error while storing body chunk.");
		              }
		              return Reflect.apply(target2, thisArg2, args2);
		            }
		          });
		          callbackMap.set(listener, callback);
		          return Reflect.apply(target, thisArg, [event, callback, ...restArgs]);
		        }
		        return Reflect.apply(target, thisArg, args);
		      }
		    });
		    req.off = req.removeListener = new Proxy(req.off, {
		      apply: (target, thisArg, args) => {
		        const [, listener] = args;
		        const callback = callbackMap.get(listener);
		        if (callback) {
		          callbackMap.delete(listener);
		          const modifiedArgs = args.slice();
		          modifiedArgs[1] = callback;
		          return Reflect.apply(target, thisArg, modifiedArgs);
		        }
		        return Reflect.apply(target, thisArg, args);
		      }
		    });
		    req.on("end", () => {
		      try {
		        const body = Buffer.concat(chunks).toString("utf-8");
		        if (body) {
		          const bodyByteLength2 = Buffer.byteLength(body, "utf-8");
		          const truncatedBody = bodyByteLength2 > maxBodySize ? `${Buffer.from(body).subarray(0, maxBodySize - 3).toString("utf-8")}...` : body;
		          isolationScope.setSDKProcessingMetadata({ normalizedRequest: { data: truncatedBody } });
		        }
		      } catch (error) {
		        if (debugBuild.DEBUG_BUILD) {
		          debugLogger.debug.error(integrationName, "Error building captured request body", error);
		        }
		      }
		    });
		  } catch (error) {
		    if (debugBuild.DEBUG_BUILD) {
		      debugLogger.debug.error(integrationName, "Error patching request to capture body", error);
		    }
		  }
		}

		exports.patchRequestToCaptureBody = patchRequestToCaptureBody;
		
	} (patchRequestToCaptureBody));
	return patchRequestToCaptureBody;
}

var recordRequestSession = {};

var hasRequiredRecordRequestSession;

function requireRecordRequestSession () {
	if (hasRequiredRecordRequestSession) return recordRequestSession;
	hasRequiredRecordRequestSession = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const timer = /*@__PURE__*/ requireTimer();

		const clientToRequestSessionAggregatesMap = /* @__PURE__ */ new WeakMap();
		function recordRequestSession(client, {
		  requestIsolationScope,
		  response,
		  sessionFlushingDelayMS
		}) {
		  requestIsolationScope.setSDKProcessingMetadata({
		    requestSession: { status: "ok" }
		  });
		  response.once("close", () => {
		    const requestSession = requestIsolationScope.getScopeData().sdkProcessingMetadata.requestSession;
		    if (client && requestSession) {
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(`Recorded request session with status: ${requestSession.status}`);
		      const roundedDate = new Date(randomSafeContext.safeDateNow());
		      roundedDate.setSeconds(0, 0);
		      const dateBucketKey = roundedDate.toISOString();
		      const existingClientAggregate = clientToRequestSessionAggregatesMap.get(client);
		      const bucket = existingClientAggregate?.[dateBucketKey] || { exited: 0, crashed: 0, errored: 0 };
		      bucket[{ ok: "exited", crashed: "crashed", errored: "errored" }[requestSession.status]]++;
		      if (existingClientAggregate) {
		        existingClientAggregate[dateBucketKey] = bucket;
		      } else {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.log("Opened new request session aggregate.");
		        const newClientAggregate = { [dateBucketKey]: bucket };
		        clientToRequestSessionAggregatesMap.set(client, newClientAggregate);
		        const flushPendingClientAggregates = () => {
		          clearTimeout(timeout);
		          unregisterClientFlushHook();
		          clientToRequestSessionAggregatesMap.delete(client);
		          const aggregatePayload = Object.entries(newClientAggregate).map(
		            ([timestamp, value]) => ({
		              started: timestamp,
		              exited: value.exited,
		              errored: value.errored,
		              crashed: value.crashed
		            })
		          );
		          client.sendSession({ aggregates: aggregatePayload });
		        };
		        const unregisterClientFlushHook = client.on("flush", () => {
		          debugBuild.DEBUG_BUILD && debugLogger.debug.log("Sending request session aggregate due to client flush");
		          flushPendingClientAggregates();
		        });
		        const timeout = setTimeout(() => {
		          debugBuild.DEBUG_BUILD && debugLogger.debug.log("Sending request session aggregate due to flushing schedule");
		          flushPendingClientAggregates();
		        }, sessionFlushingDelayMS);
		        timer.safeUnref(timeout);
		      }
		    }
		  });
		}

		exports.recordRequestSession = recordRequestSession;
		
	} (recordRequestSession));
	return recordRequestSession;
}

var hasRequiredServerSubscription;

function requireServerSubscription () {
	if (hasRequiredServerSubscription) return serverSubscription;
	hasRequiredServerSubscription = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const constants = /*@__PURE__*/ requireConstants$1();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$2();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const request = /*@__PURE__*/ requireRequest$1();
		const patchRequestToCaptureBody = /*@__PURE__*/ requirePatchRequestToCaptureBody();
		const url = /*@__PURE__*/ requireUrl();
		const recordRequestSession = /*@__PURE__*/ requireRecordRequestSession();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const trace = /*@__PURE__*/ requireTrace();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();

		const INTEGRATION_NAME = "Http.Server";
		const SPANS_INTEGRATION_NAME = "Http.SentryServerSpans";
		const lastSentryEmitMap = /* @__PURE__ */ new WeakMap();
		const kRequestMark = /* @__PURE__ */ Symbol.for("sentry_http_server_instrumented");
		function markRequest(request) {
		  return !request[kRequestMark] && (request[kRequestMark] = true);
		}
		function instrumentServer(options, server) {
		  const currentEmit = server.emit;
		  const instrumentedEmit = lastSentryEmitMap.get(server);
		  if (currentEmit === instrumentedEmit) {
		    return;
		  }
		  const newEmit = new Proxy(currentEmit, {
		    apply(target, thisArg, args) {
		      const [event, ...data] = args;
		      if (event !== "request") {
		        return target.apply(thisArg, args);
		      }
		      const client = currentScopes.getClient();
		      const [request$1, response] = data;
		      if (!client || !markRequest(request$1)) {
		        return target.apply(thisArg, args);
		      }
		      debugBuild.DEBUG_BUILD && debugLogger.debug.log(INTEGRATION_NAME, "Handling incoming request");
		      const isolationScope = currentScopes.getIsolationScope().clone();
		      isolationScope.setClient(client);
		      const ipAddress = request$1.socket?.remoteAddress;
		      const url$1 = request$1.url || "/";
		      const normalizedRequest = request.httpRequestToRequestData(request$1);
		      const {
		        maxRequestBodySize = "medium",
		        ignoreRequestBody,
		        sessions = true,
		        sessionFlushingDelayMS = 6e4
		      } = options;
		      if (maxRequestBodySize !== "none" && !ignoreRequestBody?.(url$1, request$1)) {
		        patchRequestToCaptureBody.patchRequestToCaptureBody(request$1, isolationScope, maxRequestBodySize, INTEGRATION_NAME);
		      }
		      isolationScope.setSDKProcessingMetadata({ normalizedRequest, ipAddress });
		      const httpMethod = (request$1.method || "GET").toUpperCase();
		      const httpTargetWithoutQueryFragment = url.stripUrlQueryAndFragment(url$1);
		      const bestEffortTransactionName = `${httpMethod} ${httpTargetWithoutQueryFragment}`;
		      isolationScope.setTransactionName(bestEffortTransactionName);
		      if (sessions) {
		        recordRequestSession.recordRequestSession(client, {
		          requestIsolationScope: isolationScope,
		          response,
		          sessionFlushingDelayMS: sessionFlushingDelayMS ?? 6e4
		        });
		      }
		      return currentScopes.withIsolationScope(isolationScope, () => {
		        const sentryTrace = normalizedRequest.headers?.["sentry-trace"];
		        const baggage = normalizedRequest.headers?.["baggage"];
		        const sentryTraceValue = Array.isArray(sentryTrace) ? sentryTrace[0] : sentryTrace;
		        return trace.continueTrace(
		          {
		            sentryTrace: sentryTraceValue,
		            baggage: Array.isArray(baggage) ? baggage[0] : baggage
		          },
		          () => {
		            const propagationContext$1 = currentScopes.getCurrentScope().getPropagationContext();
		            propagationContext$1.propagationSpanId = propagationContext.generateSpanId();
		            if (!sentryTraceValue) {
		              propagationContext$1.traceId = propagationContext.generateTraceId();
		              propagationContext$1.sampleRand = randomSafeContext.safeMathRandom();
		            }
		            response.once("close", () => {
		              isolationScope.setContext("response", {
		                status_code: response.statusCode
		              });
		            });
		            const wrap = options.wrapServerEmitRequest;
		            let emitResult = false;
		            if (wrap) {
		              wrap(request$1, response, normalizedRequest, () => {
		                emitResult = target.apply(thisArg, args);
		              });
		            } else {
		              emitResult = target.apply(thisArg, args);
		            }
		            return emitResult;
		          }
		        );
		      });
		    }
		  });
		  lastSentryEmitMap.set(server, newEmit);
		  server.emit = newEmit;
		}
		function getHttpServerSubscriptions(options) {
		  const userWrap = options.wrapServerEmitRequest;
		  const spanWrap = buildServerSpanWrap(options);
		  const effectiveOptions = {
		    ...options,
		    wrapServerEmitRequest(request, response, normalizedRequest, next) {
		      const clientOptions = currentScopes.getClient()?.getOptions();
		      const createSpans = options.spans ?? (clientOptions ? hasSpansEnabled.hasSpansEnabled(clientOptions) : false);
		      if (createSpans) {
		        spanWrap(request, response, normalizedRequest, next);
		      } else if (userWrap) {
		        userWrap(request, response, normalizedRequest, next);
		      } else {
		        next();
		      }
		    }
		  };
		  const onHttpServerRequest = (data) => {
		    const { server } = data;
		    instrumentServer(effectiveOptions, server);
		  };
		  return { [constants.HTTP_ON_SERVER_REQUEST]: onHttpServerRequest };
		}
		function buildServerSpanWrap(options) {
		  const {
		    wrapServerEmitRequest: userWrap,
		    ignoreIncomingRequests,
		    ignoreStaticAssets = true,
		    onSpanCreated,
		    errorMonitor = "error",
		    onSpanEnd
		  } = options;
		  return (request$1, response, normalizedRequest, next) => {
		    if (typeof __SENTRY_TRACING__ !== "undefined" && !__SENTRY_TRACING__) {
		      return next();
		    }
		    return userWrap ? userWrap(request$1, response, normalizedRequest, createSpan) : createSpan();
		    function createSpan() {
		      const isolationScope = currentScopes.getIsolationScope();
		      const client = isolationScope.getClient();
		      if (!client) {
		        return next();
		      }
		      if (shouldIgnoreSpansForIncomingRequest(request$1, {
		        ignoreStaticAssets,
		        ignoreIncomingRequests
		      })) {
		        debugBuild.DEBUG_BUILD && debugLogger.debug.log(SPANS_INTEGRATION_NAME, "Skipping span creation for incoming request", request$1.url);
		        return next();
		      }
		      const fullUrl = normalizedRequest.url || request$1.url || "/";
		      const urlObj = url.parseStringToURLObject(fullUrl);
		      const httpTargetWithoutQueryFragment = urlObj ? urlObj.pathname : url.stripUrlQueryAndFragment(fullUrl);
		      const method = (request$1.method || "GET").toUpperCase();
		      const name = `${method} ${httpTargetWithoutQueryFragment}`;
		      const headers = request$1.headers;
		      const userAgent = headers["user-agent"];
		      const ips = headers["x-forwarded-for"];
		      const httpVersion = request$1.httpVersion;
		      const host = headers.host;
		      const hostname = host?.replace(/^(.*)(:[0-9]{1,5})/, "$1") || "localhost";
		      const scheme = fullUrl.startsWith("https") ? "https" : "http";
		      const { socket } = request$1;
		      const { localAddress, localPort, remoteAddress, remotePort } = socket ?? {};
		      return trace.startSpanManual(
		        {
		          name,
		          // SpanKind.SERVER = 1; pass this so the OTel sampler infers
		          // op='http.server' rather than 'http', which it does for
		          // SpanKind.INTERNAL = 0, the default
		          kind: 1,
		          attributes: {
		            // Sentry-specific attributes
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.server",
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.http.server",
		            [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url",
		            // Set http.route to the URL path as a best-effort route name.
		            // Framework integrations (Express, etc.) update this via onSpanEnd.
		            "http.route": httpTargetWithoutQueryFragment,
		            // OTel kind (explicit attribute so it appears in span data)
		            "otel.kind": "SERVER",
		            // Network attributes
		            "net.host.ip": localAddress,
		            "net.host.port": localPort,
		            "net.peer.ip": remoteAddress,
		            "net.peer.port": remotePort,
		            "sentry.http.prefetch": isKnownPrefetchRequest(request$1) || void 0,
		            // Old Semantic Conventions attributes for compatibility
		            "http.url": fullUrl,
		            "http.method": method,
		            "http.target": urlObj ? `${urlObj.pathname}${urlObj.search}` : httpTargetWithoutQueryFragment,
		            "http.host": host,
		            "net.host.name": hostname,
		            "http.client_ip": typeof ips === "string" ? ips.split(",")[0] : void 0,
		            "http.user_agent": userAgent,
		            "http.scheme": scheme,
		            "http.flavor": httpVersion,
		            "net.transport": httpVersion?.toUpperCase() === "QUIC" ? "ip_udp" : "ip_tcp",
		            ...getRequestContentLengthAttribute(request$1),
		            ...request.httpHeadersToSpanAttributes(normalizedRequest.headers || {}, client.getDataCollectionOptions())
		          }
		        },
		        (span) => {
		          onSpanCreated?.(span, request$1, response);
		          let isEnded = false;
		          function endSpan(status) {
		            if (isEnded) {
		              return;
		            }
		            isEnded = true;
		            span.setAttributes({
		              "http.status_text": response.statusMessage?.toUpperCase(),
		              "http.response.status_code": response.statusCode,
		              "http.status_code": response.statusCode,
		              ...request.httpHeadersToSpanAttributes(
		                request.headersToDict(response.headers),
		                client?.getDataCollectionOptions() ?? false,
		                "response"
		              )
		            });
		            span.setStatus(status);
		            onSpanEnd?.(span, request$1, response);
		            span.end();
		          }
		          response.once("close", () => {
		            endSpan(spanstatus.getSpanStatusFromHttpCode(response.statusCode));
		          });
		          response.once(errorMonitor, () => {
		            const httpStatus = spanstatus.getSpanStatusFromHttpCode(response.statusCode);
		            endSpan(httpStatus.code === spanstatus.SPAN_STATUS_ERROR ? httpStatus : { code: spanstatus.SPAN_STATUS_ERROR });
		          });
		          next();
		        }
		      );
		    }
		  };
		}
		function shouldIgnoreSpansForIncomingRequest(request, {
		  ignoreStaticAssets,
		  ignoreIncomingRequests
		}) {
		  const urlPath = request.url;
		  const method = request.method?.toUpperCase();
		  if (method === "OPTIONS" || method === "HEAD" || !urlPath) {
		    return true;
		  }
		  if (ignoreStaticAssets && method === "GET" && isStaticAssetRequest(urlPath)) {
		    return true;
		  }
		  if (ignoreIncomingRequests?.(urlPath, request)) {
		    return true;
		  }
		  return false;
		}
		function isStaticAssetRequest(urlPath) {
		  const path = url.stripUrlQueryAndFragment(urlPath);
		  if (path.match(/\.(ico|png|jpg|jpeg|gif|svg|css|js|woff|woff2|ttf|eot|webp|avif)$/)) {
		    return true;
		  }
		  if (path.match(/^\/(robots\.txt|sitemap\.xml|manifest\.json|browserconfig\.xml)$/)) {
		    return true;
		  }
		  return false;
		}
		function isKnownPrefetchRequest(req) {
		  return req.headers["next-router-prefetch"] === "1";
		}
		function getRequestContentLengthAttribute(request) {
		  const { headers } = request;
		  const contentLengthHeader = headers["content-length"];
		  const length = contentLengthHeader ? parseInt(String(contentLengthHeader), 10) : -1;
		  const encoding = headers["content-encoding"];
		  return length >= 0 ? encoding && encoding !== "identity" ? { "http.request_content_length": length } : { "http.request_content_length_uncompressed": length } : {};
		}

		exports.getHttpServerSubscriptions = getHttpServerSubscriptions;
		exports.instrumentServer = instrumentServer;
		exports.isStaticAssetRequest = isStaticAssetRequest;
		
	} (serverSubscription));
	return serverSubscription;
}

var browser$d = {};

var hasRequiredBrowser$d;

function requireBrowser$d () {
	if (hasRequiredBrowser$d) return browser$d;
	hasRequiredBrowser$d = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const is = /*@__PURE__*/ requireIs$1();
		const worldwide = /*@__PURE__*/ requireWorldwide();

		const WINDOW = worldwide.GLOBAL_OBJ;
		const DEFAULT_MAX_STRING_LENGTH = 80;
		function htmlTreeAsString(elem, options = {}) {
		  if (!elem) {
		    return "<unknown>";
		  }
		  try {
		    let currentElem = elem;
		    const MAX_TRAVERSE_HEIGHT = 5;
		    const out = [];
		    let height = 0;
		    let len = 0;
		    const separator = " > ";
		    const sepLength = separator.length;
		    let nextStr;
		    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
		    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
		    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
		      nextStr = _htmlElementAsString(currentElem, keyAttrs);
		      if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
		        break;
		      }
		      out.push(nextStr);
		      len += nextStr.length;
		      currentElem = currentElem.parentNode;
		    }
		    return out.reverse().join(separator);
		  } catch {
		    return "<unknown>";
		  }
		}
		function _htmlElementAsString(el, keyAttrs) {
		  const elem = el;
		  const out = [];
		  if (!elem?.tagName) {
		    return "";
		  }
		  if (WINDOW.HTMLElement) {
		    if (elem instanceof HTMLElement && elem.dataset) {
		      if (elem.dataset["sentryComponent"]) {
		        return elem.dataset["sentryComponent"];
		      }
		      if (elem.dataset["sentryElement"]) {
		        return elem.dataset["sentryElement"];
		      }
		    }
		  }
		  out.push(elem.tagName.toLowerCase());
		  const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr) => elem.getAttribute(keyAttr)).map((keyAttr) => [keyAttr, elem.getAttribute(keyAttr)]) : null;
		  if (keyAttrPairs?.length) {
		    keyAttrPairs.forEach((keyAttrPair) => {
		      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
		    });
		  } else {
		    if (elem.id) {
		      out.push(`#${elem.id}`);
		    }
		    const className = elem.className;
		    if (className && is.isString(className)) {
		      const classes = className.split(/\s+/);
		      for (const c of classes) {
		        out.push(`.${c}`);
		      }
		    }
		  }
		  for (const k of ["aria-label", "type", "name", "title", "alt"]) {
		    const attr = elem.getAttribute(k);
		    if (attr) {
		      out.push(`[${k}="${attr}"]`);
		    }
		  }
		  return out.join("");
		}
		function getLocationHref() {
		  try {
		    return WINDOW.document.location.href;
		  } catch {
		    return "";
		  }
		}
		function getComponentName(elem, maxTraverseHeight = 5) {
		  if (!WINDOW.HTMLElement) {
		    return null;
		  }
		  let currentElem = elem;
		  for (let i = 0; i < maxTraverseHeight; i++) {
		    if (!currentElem) {
		      return null;
		    }
		    if (currentElem instanceof HTMLElement) {
		      if (currentElem.dataset["sentryComponent"]) {
		        return currentElem.dataset["sentryComponent"];
		      }
		      if (currentElem.dataset["sentryElement"]) {
		        return currentElem.dataset["sentryElement"];
		      }
		    }
		    currentElem = currentElem.parentNode;
		  }
		  return null;
		}

		exports.getComponentName = getComponentName;
		exports.getLocationHref = getLocationHref;
		exports.htmlTreeAsString = htmlTreeAsString;
		
	} (browser$d));
	return browser$d;
}

var embeddings = {};

var hasRequiredEmbeddings;

function requireEmbeddings () {
	if (hasRequiredEmbeddings) return embeddings;
	hasRequiredEmbeddings = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const exports$1 = /*@__PURE__*/ requireExports$1();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const trace = /*@__PURE__*/ requireTrace();
		const genAiAttributes = /*@__PURE__*/ requireGenAiAttributes();
		const utils = /*@__PURE__*/ requireUtils$e();
		const constants = /*@__PURE__*/ requireConstants$3();

		function inferSystemFromInstance(instance) {
		  const name = instance.constructor?.name ?? "";
		  if (name.includes("OpenAI")) return "openai";
		  if (name.includes("Google")) return "google_genai";
		  if (name.includes("Mistral")) return "mistralai";
		  if (name.includes("Vertex")) return "google_vertexai";
		  if (name.includes("Bedrock")) return "aws_bedrock";
		  if (name.includes("Ollama")) return "ollama";
		  if (name.includes("Cloudflare")) return "cloudflare";
		  if (name.includes("Cohere")) return "cohere";
		  return "langchain";
		}
		function extractEmbeddingAttributes(instance) {
		  const embeddingsInstance = instance ?? {};
		  const attributes = {
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: constants.LANGCHAIN_ORIGIN,
		    [semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP]: genAiAttributes.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
		    [genAiAttributes.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
		    [genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
		  };
		  attributes[genAiAttributes.GEN_AI_SYSTEM_ATTRIBUTE] = inferSystemFromInstance(embeddingsInstance);
		  if ("dimensions" in embeddingsInstance) {
		    attributes[genAiAttributes.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
		  }
		  if ("encodingFormat" in embeddingsInstance) {
		    attributes[genAiAttributes.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
		  }
		  return attributes;
		}
		function instrumentEmbeddingMethod(originalMethod, options = {}) {
		  const { recordInputs } = utils.resolveAIRecordingOptions(options);
		  return new Proxy(originalMethod, {
		    apply(target, thisArg, args) {
		      const attributes = extractEmbeddingAttributes(thisArg);
		      const modelName = attributes[genAiAttributes.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
		      if (recordInputs) {
		        const input = args[0];
		        if (input != null) {
		          attributes[genAiAttributes.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
		        }
		      }
		      return trace.startSpan(
		        {
		          name: `embeddings ${modelName}`,
		          op: genAiAttributes.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
		          attributes
		        },
		        () => {
		          return Reflect.apply(target, thisArg, args).then(void 0, (error) => {
		            exports$1.captureException(error, {
		              mechanism: { handled: false, type: "auto.ai.langchain" }
		            });
		            throw error;
		          });
		        }
		      );
		    }
		  });
		}
		function instrumentLangChainEmbeddings(instance, options) {
		  const embeddingsInstance = instance;
		  if (typeof embeddingsInstance.embedQuery === "function") {
		    embeddingsInstance.embedQuery = instrumentEmbeddingMethod(
		      embeddingsInstance.embedQuery,
		      options
		    );
		  }
		  if (typeof embeddingsInstance.embedDocuments === "function") {
		    embeddingsInstance.embedDocuments = instrumentEmbeddingMethod(
		      embeddingsInstance.embedDocuments,
		      options
		    );
		  }
		  return instance;
		}

		exports.instrumentEmbeddingMethod = instrumentEmbeddingMethod;
		exports.instrumentLangChainEmbeddings = instrumentLangChainEmbeddings;
		
	} (embeddings));
	return embeddings;
}

var hasRequiredCjs$4;

function requireCjs$4 () {
	if (hasRequiredCjs$4) return cjs$3;
	hasRequiredCjs$4 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const errors = /*@__PURE__*/ requireErrors();
		const utils$2 = /*@__PURE__*/ requireUtils$g();
		const idleSpan = /*@__PURE__*/ requireIdleSpan();
		const sentrySpan = /*@__PURE__*/ requireSentrySpan();
		const sentryNonRecordingSpan = /*@__PURE__*/ requireSentryNonRecordingSpan();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const bindScopeToEmitter = /*@__PURE__*/ requireBindScopeToEmitter();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const measurement = /*@__PURE__*/ requireMeasurement();
		const sampling = /*@__PURE__*/ requireSampling();
		const logSpans = /*@__PURE__*/ requireLogSpans();
		const captureSpan = /*@__PURE__*/ requireCaptureSpan();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const envelope$1 = /*@__PURE__*/ requireEnvelope$3();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const defaultScopes = /*@__PURE__*/ requireDefaultScopes();
		const index$7 = /*@__PURE__*/ requireAsyncContext();
		const carrier = /*@__PURE__*/ requireCarrier();
		const session = /*@__PURE__*/ requireSession();
		const scope = /*@__PURE__*/ requireScope();
		const eventProcessors = /*@__PURE__*/ requireEventProcessors();
		const api = /*@__PURE__*/ requireApi$1();
		const client = /*@__PURE__*/ requireClient$1();
		const sdk = /*@__PURE__*/ requireSdk$1();
		const base = /*@__PURE__*/ requireBase$2();
		const offline = /*@__PURE__*/ requireOffline$1();
		const multiplexed = /*@__PURE__*/ requireMultiplexed();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const providerSkip = /*@__PURE__*/ requireProviderSkip();
		const filterKeyValueData = /*@__PURE__*/ requireFilterKeyValueData();
		const filterCookies = /*@__PURE__*/ requireFilterCookies();
		const filterQueryParams = /*@__PURE__*/ requireFilterQueryParams();
		const envToBool = /*@__PURE__*/ requireEnvToBool();
		const scopeData = /*@__PURE__*/ requireScopeData();
		const prepareEvent = /*@__PURE__*/ requirePrepareEvent();
		const checkin = /*@__PURE__*/ requireCheckin();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const beforeSendSpan = /*@__PURE__*/ requireBeforeSendSpan();
		const isSentryRequestUrl = /*@__PURE__*/ requireIsSentryRequestUrl();
		const handleCallbackErrors = /*@__PURE__*/ requireHandleCallbackErrors();
		const parameterize = /*@__PURE__*/ requireParameterize();
		const tunnel = /*@__PURE__*/ requireTunnel();
		const ipAddress = /*@__PURE__*/ requireIpAddress();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();
		const parseSampleRate = /*@__PURE__*/ requireParseSampleRate();
		const sdkMetadata = /*@__PURE__*/ requireSdkMetadata();
		const traceData = /*@__PURE__*/ requireTraceData();
		const tracePropagationTargets = /*@__PURE__*/ requireTracePropagationTargets();
		const meta = /*@__PURE__*/ requireMeta();
		const debounce = /*@__PURE__*/ requireDebounce();
		const weakRef = /*@__PURE__*/ requireWeakRef();
		const shouldIgnoreSpan = /*@__PURE__*/ requireShouldIgnoreSpan();
		const request = /*@__PURE__*/ requireRequest$1();
		const constants$1 = /*@__PURE__*/ requireConstants$9();
		const breadcrumbs = /*@__PURE__*/ requireBreadcrumbs$1();
		const functiontostring = /*@__PURE__*/ requireFunctiontostring();
		const eventFilters = /*@__PURE__*/ requireEventFilters();
		const linkederrors = /*@__PURE__*/ requireLinkederrors$1();
		const moduleMetadata = /*@__PURE__*/ requireModuleMetadata();
		const requestdata = /*@__PURE__*/ requireRequestdata();
		const captureconsole = /*@__PURE__*/ requireCaptureconsole();
		const dedupe = /*@__PURE__*/ requireDedupe();
		const extraerrordata = /*@__PURE__*/ requireExtraerrordata();
		const rewriteframes = /*@__PURE__*/ requireRewriteframes();
		const supabase = /*@__PURE__*/ requireSupabase();
		const zoderrors = /*@__PURE__*/ requireZoderrors();
		const thirdPartyErrorsFilter = /*@__PURE__*/ requireThirdPartyErrorsFilter();
		const console$1 = /*@__PURE__*/ requireConsole();
		const featureFlagsIntegration = /*@__PURE__*/ requireFeatureFlagsIntegration();
		const growthbook = /*@__PURE__*/ requireGrowthbook();
		const conversationId = /*@__PURE__*/ requireConversationId();
		const profiling = /*@__PURE__*/ requireProfiling$1();
		const fetch = /*@__PURE__*/ requireFetch$2();
		const feedback = /*@__PURE__*/ requireFeedback();
		const internal = /*@__PURE__*/ requireInternal$1();
		const publicApi = /*@__PURE__*/ requirePublicApi$1();
		const consoleIntegration = /*@__PURE__*/ requireConsoleIntegration();
		const internal$1 = /*@__PURE__*/ requireInternal();
		const publicApi$1 = /*@__PURE__*/ requirePublicApi();
		const consola = /*@__PURE__*/ requireConsola();
		const index = /*@__PURE__*/ requireVercelAi();
		const utils = /*@__PURE__*/ requireUtils$d();
		const constants$7 = /*@__PURE__*/ requireConstants$7();
		const index$6 = /*@__PURE__*/ requireOpenai();
		const constants$6 = /*@__PURE__*/ requireConstants$6();
		const index$3 = /*@__PURE__*/ requireAnthropicAi();
		const constants = /*@__PURE__*/ requireConstants$5();
		const index$5 = /*@__PURE__*/ requireGoogleGenai();
		const constants$2 = /*@__PURE__*/ requireConstants$4();
		const index$1 = /*@__PURE__*/ requireLangchain();
		const utils$1 = /*@__PURE__*/ requireUtils$9();
		const constants$4 = /*@__PURE__*/ requireConstants$3();
		const index$4 = /*@__PURE__*/ requireLanggraph();
		const constants$5 = /*@__PURE__*/ requireConstants$2();
		const spanBuffer = /*@__PURE__*/ requireSpanBuffer();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const spanStreaming = /*@__PURE__*/ requireSpanStreaming();
		const featureFlags = /*@__PURE__*/ requireFeatureFlags();
		const aggregateErrors = /*@__PURE__*/ requireAggregateErrors();
		const breadcrumbLogLevel = /*@__PURE__*/ requireBreadcrumbLogLevel();
		const dsn = /*@__PURE__*/ requireDsn();
		const error = /*@__PURE__*/ requireError();
		const worldwide = /*@__PURE__*/ requireWorldwide();
		const console = /*@__PURE__*/ requireConsole$1();
		const fetch$1 = /*@__PURE__*/ requireFetch$1();
		const globalError = /*@__PURE__*/ requireGlobalError();
		const globalUnhandledRejection = /*@__PURE__*/ requireGlobalUnhandledRejection();
		const handlers = /*@__PURE__*/ requireHandlers$1();
		const is = /*@__PURE__*/ requireIs$1();
		const isBrowser = /*@__PURE__*/ requireIsBrowser();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const misc = /*@__PURE__*/ requireMisc();
		const normalize = /*@__PURE__*/ requireNormalize();
		const normalizationHints = /*@__PURE__*/ requireNormalizationHints();
		const object = /*@__PURE__*/ requireObject();
		const path = /*@__PURE__*/ requirePath();
		const promisebuffer = /*@__PURE__*/ requirePromisebuffer();
		const severity = /*@__PURE__*/ requireSeverity();
		const exports$2 = /*@__PURE__*/ requireExports();
		const stacktrace = /*@__PURE__*/ requireStacktrace();
		const string = /*@__PURE__*/ requireString();
		const supports = /*@__PURE__*/ requireSupports();
		const syncpromise = /*@__PURE__*/ requireSyncpromise();
		const time = /*@__PURE__*/ requireTime();
		const tracing = /*@__PURE__*/ requireTracing();
		const env = /*@__PURE__*/ requireEnv();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const clientreport = /*@__PURE__*/ requireClientreport();
		const ratelimit = /*@__PURE__*/ requireRatelimit();
		const baggage = /*@__PURE__*/ requireBaggage();
		const url = /*@__PURE__*/ requireUrl();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder$1();
		const lru = /*@__PURE__*/ requireLru();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const version = /*@__PURE__*/ requireVersion();
		const debugIds = /*@__PURE__*/ requireDebugIds();
		const metadata = /*@__PURE__*/ requireMetadata();
		const escapeStringForRegex = /*@__PURE__*/ requireEscapeStringForRegex();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const serverRuntimeClient = /*@__PURE__*/ requireServerRuntimeClient();
		const trpc = /*@__PURE__*/ requireTrpc();
		const index$8 = /*@__PURE__*/ requireMcpServer();
		const node = /*@__PURE__*/ requireNode$1();
		const nodeStackTrace = /*@__PURE__*/ requireNodeStackTrace();
		const vercelWaitUntil = /*@__PURE__*/ requireVercelWaitUntil();
		const flushIfServerless = /*@__PURE__*/ requireFlushIfServerless();
		const anr = /*@__PURE__*/ requireAnr();
		const timer = /*@__PURE__*/ requireTimer();
		const index$2 = /*@__PURE__*/ requireExpress();
		const postgresjs = /*@__PURE__*/ requirePostgresjs();
		const clientPatch = /*@__PURE__*/ requireClientPatch();
		const clientSubscriptions = /*@__PURE__*/ requireClientSubscriptions();
		const serverSubscription = /*@__PURE__*/ requireServerSubscription();
		const recordRequestSession = /*@__PURE__*/ requireRecordRequestSession();
		const addOutgoingRequestBreadcrumb = /*@__PURE__*/ requireAddOutgoingRequestBreadcrumb();
		const getRequestUrl = /*@__PURE__*/ requireGetRequestUrl();
		const constants$3 = /*@__PURE__*/ requireConstants$1();
		const browser = /*@__PURE__*/ requireBrowser$d();
		const embeddings = /*@__PURE__*/ requireEmbeddings();



		exports.registerSpanErrorInstrumentation = errors.registerSpanErrorInstrumentation;
		exports.getCapturedScopesOnSpan = utils$2.getCapturedScopesOnSpan;
		exports.markSpanForOtelSourceInference = utils$2.markSpanForOtelSourceInference;
		exports.setCapturedScopesOnSpan = utils$2.setCapturedScopesOnSpan;
		exports.spanShouldInferOtelSource = utils$2.spanShouldInferOtelSource;
		exports.TRACING_DEFAULTS = idleSpan.TRACING_DEFAULTS;
		exports.startIdleSpan = idleSpan.startIdleSpan;
		exports.SentrySpan = sentrySpan.SentrySpan;
		exports.SentryNonRecordingSpan = sentryNonRecordingSpan.SentryNonRecordingSpan;
		exports.SPAN_STATUS_ERROR = spanstatus.SPAN_STATUS_ERROR;
		exports.SPAN_STATUS_OK = spanstatus.SPAN_STATUS_OK;
		exports.SPAN_STATUS_UNSET = spanstatus.SPAN_STATUS_UNSET;
		exports.getSpanStatusFromHttpCode = spanstatus.getSpanStatusFromHttpCode;
		exports.setHttpStatus = spanstatus.setHttpStatus;
		exports.SUPPRESS_TRACING_KEY = trace.SUPPRESS_TRACING_KEY;
		exports.continueTrace = trace.continueTrace;
		exports.startInactiveSpan = trace.startInactiveSpan;
		exports.startNewTrace = trace.startNewTrace;
		exports.startSpan = trace.startSpan;
		exports.startSpanManual = trace.startSpanManual;
		exports.suppressTracing = trace.suppressTracing;
		exports.withActiveSpan = trace.withActiveSpan;
		exports.bindScopeToEmitter = bindScopeToEmitter.bindScopeToEmitter;
		exports.getDynamicSamplingContextFromClient = dynamicSamplingContext.getDynamicSamplingContextFromClient;
		exports.getDynamicSamplingContextFromScope = dynamicSamplingContext.getDynamicSamplingContextFromScope;
		exports.getDynamicSamplingContextFromSpan = dynamicSamplingContext.getDynamicSamplingContextFromSpan;
		exports.spanToBaggageHeader = dynamicSamplingContext.spanToBaggageHeader;
		exports.setMeasurement = measurement.setMeasurement;
		exports.timedEventsToMeasurements = measurement.timedEventsToMeasurements;
		exports.sampleSpan = sampling.sampleSpan;
		exports.logSpanEnd = logSpans.logSpanEnd;
		exports.logSpanStart = logSpans.logSpanStart;
		exports.captureSpan = captureSpan.captureSpan;
		exports.safeSetSpanJSONAttributes = captureSpan.safeSetSpanJSONAttributes;
		exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = semanticAttributes.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
		exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_HIT;
		exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
		exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_KEY;
		exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
		exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = semanticAttributes.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
		exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
		exports.SEMANTIC_ATTRIBUTE_URL_FULL = semanticAttributes.SEMANTIC_ATTRIBUTE_URL_FULL;
		exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_EMAIL;
		exports.SEMANTIC_ATTRIBUTE_USER_ID = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_ID;
		exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
		exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_USERNAME;
		exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = semanticAttributes.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
		exports.createEventEnvelope = envelope$1.createEventEnvelope;
		exports.createSessionEnvelope = envelope$1.createSessionEnvelope;
		exports.createSpanEnvelope = envelope$1.createSpanEnvelope;
		exports.addEventProcessor = exports$1.addEventProcessor;
		exports.captureCheckIn = exports$1.captureCheckIn;
		exports.captureEvent = exports$1.captureEvent;
		exports.captureException = exports$1.captureException;
		exports.captureMessage = exports$1.captureMessage;
		exports.captureSession = exports$1.captureSession;
		exports.close = exports$1.close;
		exports.endSession = exports$1.endSession;
		exports.flush = exports$1.flush;
		exports.isEnabled = exports$1.isEnabled;
		exports.isInitialized = exports$1.isInitialized;
		exports.lastEventId = exports$1.lastEventId;
		exports.setContext = exports$1.setContext;
		exports.setConversationId = exports$1.setConversationId;
		exports.setExtra = exports$1.setExtra;
		exports.setExtras = exports$1.setExtras;
		exports.setTag = exports$1.setTag;
		exports.setTags = exports$1.setTags;
		exports.setUser = exports$1.setUser;
		exports.startSession = exports$1.startSession;
		exports.withMonitor = exports$1.withMonitor;
		exports.getClient = currentScopes.getClient;
		exports.getCurrentScope = currentScopes.getCurrentScope;
		exports.getExternalPropagationContext = currentScopes.getExternalPropagationContext;
		exports.getGlobalScope = currentScopes.getGlobalScope;
		exports.getIsolationScope = currentScopes.getIsolationScope;
		exports.getTraceContextFromScope = currentScopes.getTraceContextFromScope;
		exports.hasExternalPropagationContext = currentScopes.hasExternalPropagationContext;
		exports.registerExternalPropagationContext = currentScopes.registerExternalPropagationContext;
		exports.withIsolationScope = currentScopes.withIsolationScope;
		exports.withScope = currentScopes.withScope;
		exports.getDefaultCurrentScope = defaultScopes.getDefaultCurrentScope;
		exports.getDefaultIsolationScope = defaultScopes.getDefaultIsolationScope;
		exports.setAsyncContextStrategy = index$7.setAsyncContextStrategy;
		exports.getGlobalSingleton = carrier.getGlobalSingleton;
		exports.getMainCarrier = carrier.getMainCarrier;
		exports.closeSession = session.closeSession;
		exports.makeSession = session.makeSession;
		exports.updateSession = session.updateSession;
		exports.Scope = scope.Scope;
		exports.notifyEventProcessors = eventProcessors.notifyEventProcessors;
		exports.SENTRY_API_VERSION = api.SENTRY_API_VERSION;
		exports.getEnvelopeEndpointWithUrlEncodedAuth = api.getEnvelopeEndpointWithUrlEncodedAuth;
		exports.getReportDialogEndpoint = api.getReportDialogEndpoint;
		exports.Client = client.Client;
		exports.initAndBind = sdk.initAndBind;
		exports.setCurrentClient = sdk.setCurrentClient;
		exports.createTransport = base.createTransport;
		exports.makeOfflineTransport = offline.makeOfflineTransport;
		exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = multiplexed.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
		exports.makeMultiplexedTransport = multiplexed.makeMultiplexedTransport;
		exports.addIntegration = integration.addIntegration;
		exports.defineIntegration = integration.defineIntegration;
		exports.getIntegrationsToSetup = integration.getIntegrationsToSetup;
		exports.installedIntegrations = integration.installedIntegrations;
		exports._INTERNAL_clearAiProviderSkips = providerSkip._INTERNAL_clearAiProviderSkips;
		exports._INTERNAL_shouldSkipAiProviderWrapping = providerSkip._INTERNAL_shouldSkipAiProviderWrapping;
		exports._INTERNAL_skipAiProviderWrapping = providerSkip._INTERNAL_skipAiProviderWrapping;
		exports._INTERNAL_filterKeyValueData = filterKeyValueData.filterKeyValueData;
		exports._INTERNAL_filterCookies = filterCookies.filterCookies;
		exports._INTERNAL_filterQueryParams = filterQueryParams.filterQueryParams;
		exports.envToBool = envToBool.envToBool;
		exports.applyScopeDataToEvent = scopeData.applyScopeDataToEvent;
		exports.getCombinedScopeData = scopeData.getCombinedScopeData;
		exports.mergeScopeData = scopeData.mergeScopeData;
		exports.prepareEvent = prepareEvent.prepareEvent;
		exports.createCheckInEnvelope = checkin.createCheckInEnvelope;
		exports.hasSpansEnabled = hasSpansEnabled.hasSpansEnabled;
		exports.isStreamedBeforeSendSpanCallback = beforeSendSpan.isStreamedBeforeSendSpanCallback;
		exports.withStreamedSpan = beforeSendSpan.withStreamedSpan;
		exports.isSentryRequestUrl = isSentryRequestUrl.isSentryRequestUrl;
		exports.handleCallbackErrors = handleCallbackErrors.handleCallbackErrors;
		exports.fmt = parameterize.fmt;
		exports.parameterize = parameterize.parameterize;
		exports.handleTunnelRequest = tunnel.handleTunnelRequest;
		exports.addAutoIpAddressToSession = ipAddress.addAutoIpAddressToSession;
		exports.addAutoIpAddressToUser = ipAddress.addAutoIpAddressToUser;
		exports.INTERNAL_getSegmentSpan = spanUtils.INTERNAL_getSegmentSpan;
		exports.addChildSpanToSpan = spanUtils.addChildSpanToSpan;
		exports.convertSpanLinksForEnvelope = spanUtils.convertSpanLinksForEnvelope;
		exports.getActiveSpan = spanUtils.getActiveSpan;
		exports.getRootSpan = spanUtils.getRootSpan;
		exports.getSpanDescendants = spanUtils.getSpanDescendants;
		exports.getStatusMessage = spanUtils.getStatusMessage;
		exports.spanIsSampled = spanUtils.spanIsSampled;
		exports.spanTimeInputToSeconds = spanUtils.spanTimeInputToSeconds;
		exports.spanToJSON = spanUtils.spanToJSON;
		exports.spanToStreamedSpanJSON = spanUtils.spanToStreamedSpanJSON;
		exports.spanToTraceContext = spanUtils.spanToTraceContext;
		exports.spanToTraceHeader = spanUtils.spanToTraceHeader;
		exports.updateSpanName = spanUtils.updateSpanName;
		exports._INTERNAL_setSpanForScope = spanOnScope._setSpanForScope;
		exports.parseSampleRate = parseSampleRate.parseSampleRate;
		exports.applySdkMetadata = sdkMetadata.applySdkMetadata;
		exports.getTraceData = traceData.getTraceData;
		exports.shouldPropagateTraceForUrl = tracePropagationTargets.shouldPropagateTraceForUrl;
		exports.getTraceMetaTags = meta.getTraceMetaTags;
		exports.debounce = debounce.debounce;
		exports.derefWeakRef = weakRef.derefWeakRef;
		exports.makeWeakRef = weakRef.makeWeakRef;
		exports.shouldIgnoreSpan = shouldIgnoreSpan.shouldIgnoreSpan;
		exports.MAX_BODY_BYTE_LENGTH = request.MAX_BODY_BYTE_LENGTH;
		exports.captureBodyFromWinterCGRequest = request.captureBodyFromWinterCGRequest;
		exports.extractQueryParamsFromUrl = request.extractQueryParamsFromUrl;
		exports.getMaxBodyByteLength = request.getMaxBodyByteLength;
		exports.headersToDict = request.headersToDict;
		exports.httpHeadersToSpanAttributes = request.httpHeadersToSpanAttributes;
		exports.httpRequestToRequestData = request.httpRequestToRequestData;
		exports.winterCGHeadersToDict = request.winterCGHeadersToDict;
		exports.winterCGRequestToRequestData = request.winterCGRequestToRequestData;
		exports.DEFAULT_ENVIRONMENT = constants$1.DEFAULT_ENVIRONMENT;
		exports.DEV_ENVIRONMENT = constants$1.DEV_ENVIRONMENT;
		exports.addBreadcrumb = breadcrumbs.addBreadcrumb;
		exports.functionToStringIntegration = functiontostring.functionToStringIntegration;
		exports.eventFiltersIntegration = eventFilters.eventFiltersIntegration;
		exports.inboundFiltersIntegration = eventFilters.inboundFiltersIntegration;
		exports.linkedErrorsIntegration = linkederrors.linkedErrorsIntegration;
		exports.moduleMetadataIntegration = moduleMetadata.moduleMetadataIntegration;
		exports.requestDataIntegration = requestdata.requestDataIntegration;
		exports.captureConsoleIntegration = captureconsole.captureConsoleIntegration;
		exports.dedupeIntegration = dedupe.dedupeIntegration;
		exports.extraErrorDataIntegration = extraerrordata.extraErrorDataIntegration;
		exports.rewriteFramesIntegration = rewriteframes.rewriteFramesIntegration;
		exports.instrumentSupabaseClient = supabase.instrumentSupabaseClient;
		exports.supabaseIntegration = supabase.supabaseIntegration;
		exports.zodErrorsIntegration = zoderrors.zodErrorsIntegration;
		exports.thirdPartyErrorFilterIntegration = thirdPartyErrorsFilter.thirdPartyErrorFilterIntegration;
		exports.consoleIntegration = console$1.consoleIntegration;
		exports.featureFlagsIntegration = featureFlagsIntegration.featureFlagsIntegration;
		exports.growthbookIntegration = growthbook.growthbookIntegration;
		exports.conversationIdIntegration = conversationId.conversationIdIntegration;
		exports.profiler = profiling.profiler;
		exports._INTERNAL_getTracingHeadersForFetchRequest = fetch._INTERNAL_getTracingHeadersForFetchRequest;
		exports.instrumentFetchRequest = fetch.instrumentFetchRequest;
		exports.captureFeedback = feedback.captureFeedback;
		exports._INTERNAL_captureLog = internal._INTERNAL_captureLog;
		exports._INTERNAL_captureSerializedLog = internal._INTERNAL_captureSerializedLog;
		exports._INTERNAL_flushLogsBuffer = internal._INTERNAL_flushLogsBuffer;
		exports.logger = publicApi;
		exports.consoleLoggingIntegration = consoleIntegration.consoleLoggingIntegration;
		exports._INTERNAL_captureMetric = internal$1._INTERNAL_captureMetric;
		exports._INTERNAL_captureSerializedMetric = internal$1._INTERNAL_captureSerializedMetric;
		exports._INTERNAL_flushMetricsBuffer = internal$1._INTERNAL_flushMetricsBuffer;
		exports.metrics = publicApi$1;
		exports.createConsolaReporter = consola.createConsolaReporter;
		exports.addVercelAiProcessors = index.addVercelAiProcessors;
		exports._INTERNAL_cleanupToolCallSpanContext = utils._INTERNAL_cleanupToolCallSpanContext;
		exports._INTERNAL_getSpanContextForToolCallId = utils._INTERNAL_getSpanContextForToolCallId;
		exports._INTERNAL_toolCallSpanContextMap = constants$7.toolCallSpanContextMap;
		exports.instrumentOpenAiClient = index$6.instrumentOpenAiClient;
		exports.OPENAI_INTEGRATION_NAME = constants$6.OPENAI_INTEGRATION_NAME;
		exports.instrumentAnthropicAiClient = index$3.instrumentAnthropicAiClient;
		exports.ANTHROPIC_AI_INTEGRATION_NAME = constants.ANTHROPIC_AI_INTEGRATION_NAME;
		exports.instrumentGoogleGenAIClient = index$5.instrumentGoogleGenAIClient;
		exports.GOOGLE_GENAI_INTEGRATION_NAME = constants$2.GOOGLE_GENAI_INTEGRATION_NAME;
		exports.createLangChainCallbackHandler = index$1.createLangChainCallbackHandler;
		exports._INTERNAL_mergeLangChainCallbackHandler = utils$1._INTERNAL_mergeLangChainCallbackHandler;
		exports.LANGCHAIN_INTEGRATION_NAME = constants$4.LANGCHAIN_INTEGRATION_NAME;
		exports.instrumentCreateReactAgent = index$4.instrumentCreateReactAgent;
		exports.instrumentLangGraph = index$4.instrumentLangGraph;
		exports.instrumentStateGraphCompile = index$4.instrumentStateGraphCompile;
		exports.LANGGRAPH_INTEGRATION_NAME = constants$5.LANGGRAPH_INTEGRATION_NAME;
		exports.SpanBuffer = spanBuffer.SpanBuffer;
		exports.hasSpanStreamingEnabled = hasSpanStreamingEnabled.hasSpanStreamingEnabled;
		exports.spanStreamingIntegration = spanStreaming.spanStreamingIntegration;
		exports._INTERNAL_FLAG_BUFFER_SIZE = featureFlags._INTERNAL_FLAG_BUFFER_SIZE;
		exports._INTERNAL_MAX_FLAGS_PER_SPAN = featureFlags._INTERNAL_MAX_FLAGS_PER_SPAN;
		exports._INTERNAL_addFeatureFlagToActiveSpan = featureFlags._INTERNAL_addFeatureFlagToActiveSpan;
		exports._INTERNAL_copyFlagsFromScopeToEvent = featureFlags._INTERNAL_copyFlagsFromScopeToEvent;
		exports._INTERNAL_insertFlagToScope = featureFlags._INTERNAL_insertFlagToScope;
		exports.applyAggregateErrorsToEvent = aggregateErrors.applyAggregateErrorsToEvent;
		exports.getBreadcrumbLogLevelFromHttpStatusCode = breadcrumbLogLevel.getBreadcrumbLogLevelFromHttpStatusCode;
		exports.dsnFromString = dsn.dsnFromString;
		exports.dsnToString = dsn.dsnToString;
		exports.makeDsn = dsn.makeDsn;
		exports.SentryError = error.SentryError;
		exports.GLOBAL_OBJ = worldwide.GLOBAL_OBJ;
		exports.addConsoleInstrumentationFilter = console.addConsoleInstrumentationFilter;
		exports.addConsoleInstrumentationHandler = console.addConsoleInstrumentationHandler;
		exports.addFetchEndInstrumentationHandler = fetch$1.addFetchEndInstrumentationHandler;
		exports.addFetchInstrumentationHandler = fetch$1.addFetchInstrumentationHandler;
		exports.addGlobalErrorInstrumentationHandler = globalError.addGlobalErrorInstrumentationHandler;
		exports.addGlobalUnhandledRejectionInstrumentationHandler = globalUnhandledRejection.addGlobalUnhandledRejectionInstrumentationHandler;
		exports.addHandler = handlers.addHandler;
		exports.maybeInstrument = handlers.maybeInstrument;
		exports.resetInstrumentationHandlers = handlers.resetInstrumentationHandlers;
		exports.triggerHandlers = handlers.triggerHandlers;
		exports.isDOMError = is.isDOMError;
		exports.isDOMException = is.isDOMException;
		exports.isElement = is.isElement;
		exports.isError = is.isError;
		exports.isErrorEvent = is.isErrorEvent;
		exports.isEvent = is.isEvent;
		exports.isInstanceOf = is.isInstanceOf;
		exports.isParameterizedString = is.isParameterizedString;
		exports.isPlainObject = is.isPlainObject;
		exports.isPrimitive = is.isPrimitive;
		exports.isRegExp = is.isRegExp;
		exports.isString = is.isString;
		exports.isSyntheticEvent = is.isSyntheticEvent;
		exports.isThenable = is.isThenable;
		exports.isVueViewModel = is.isVueViewModel;
		exports.isBrowser = isBrowser.isBrowser;
		exports.CONSOLE_LEVELS = debugLogger.CONSOLE_LEVELS;
		exports.consoleSandbox = debugLogger.consoleSandbox;
		exports.debug = debugLogger.debug;
		exports.originalConsoleMethods = debugLogger.originalConsoleMethods;
		exports.addContextToFrame = misc.addContextToFrame;
		exports.addExceptionMechanism = misc.addExceptionMechanism;
		exports.addExceptionTypeValue = misc.addExceptionTypeValue;
		exports.checkOrSetAlreadyCaught = misc.checkOrSetAlreadyCaught;
		exports.getEventDescription = misc.getEventDescription;
		exports.isAlreadyCaptured = misc.isAlreadyCaptured;
		exports.parseSemver = misc.parseSemver;
		exports.uuid4 = misc.uuid4;
		exports.normalize = normalize.normalize;
		exports.normalizeToSize = normalize.normalizeToSize;
		exports.normalizeUrlToBase = normalize.normalizeUrlToBase;
		exports.setNormalizeStringifier = normalize.setNormalizeStringifier;
		exports.setNormalizationDepthOverrideHint = normalizationHints.setNormalizationDepthOverrideHint;
		exports.setSkipNormalizationHint = normalizationHints.setSkipNormalizationHint;
		exports.addNonEnumerableProperty = object.addNonEnumerableProperty;
		exports.convertToPlainObject = object.convertToPlainObject;
		exports.dropUndefinedKeys = object.dropUndefinedKeys;
		exports.extractExceptionKeysForMessage = object.extractExceptionKeysForMessage;
		exports.fill = object.fill;
		exports.getOriginalFunction = object.getOriginalFunction;
		exports.markFunctionWrapped = object.markFunctionWrapped;
		exports.objectify = object.objectify;
		exports.basename = path.basename;
		exports.dirname = path.dirname;
		exports.isAbsolute = path.isAbsolute;
		exports.join = path.join;
		exports.normalizePath = path.normalizePath;
		exports.relative = path.relative;
		exports.resolve = path.resolve;
		exports.SENTRY_BUFFER_FULL_ERROR = promisebuffer.SENTRY_BUFFER_FULL_ERROR;
		exports.makePromiseBuffer = promisebuffer.makePromiseBuffer;
		exports.severityLevelFromString = severity.severityLevelFromString;
		exports.replaceExports = exports$2.replaceExports;
		exports.UNKNOWN_FUNCTION = stacktrace.UNKNOWN_FUNCTION;
		exports.createStackParser = stacktrace.createStackParser;
		exports.getFramesFromEvent = stacktrace.getFramesFromEvent;
		exports.getFunctionName = stacktrace.getFunctionName;
		exports.stackParserFromStackParserOptions = stacktrace.stackParserFromStackParserOptions;
		exports.stripSentryFramesAndReverse = stacktrace.stripSentryFramesAndReverse;
		exports.isMatchingPattern = string.isMatchingPattern;
		exports.safeJoin = string.safeJoin;
		exports.snipLine = string.snipLine;
		exports.stringMatchesSomePattern = string.stringMatchesSomePattern;
		exports.truncate = string.truncate;
		exports.isNativeFunction = supports.isNativeFunction;
		exports.supportsDOMError = supports.supportsDOMError;
		exports.supportsDOMException = supports.supportsDOMException;
		exports.supportsErrorEvent = supports.supportsErrorEvent;
		exports.supportsFetch = supports.supportsFetch;
		exports.supportsHistory = supports.supportsHistory;
		exports.supportsNativeFetch = supports.supportsNativeFetch;
		exports.supportsReferrerPolicy = supports.supportsReferrerPolicy;
		exports.supportsReportingObserver = supports.supportsReportingObserver;
		exports.SyncPromise = syncpromise.SyncPromise;
		exports.rejectedSyncPromise = syncpromise.rejectedSyncPromise;
		exports.resolvedSyncPromise = syncpromise.resolvedSyncPromise;
		exports.browserPerformanceTimeOrigin = time.browserPerformanceTimeOrigin;
		exports.dateTimestampInSeconds = time.dateTimestampInSeconds;
		exports.timestampInSeconds = time.timestampInSeconds;
		exports.TRACEPARENT_REGEXP = tracing.TRACEPARENT_REGEXP;
		exports.extractTraceparentData = tracing.extractTraceparentData;
		exports.generateSentryTraceHeader = tracing.generateSentryTraceHeader;
		exports.generateTraceparentHeader = tracing.generateTraceparentHeader;
		exports.propagationContextFromHeaders = tracing.propagationContextFromHeaders;
		exports.shouldContinueTrace = tracing.shouldContinueTrace;
		exports.getSDKSource = env.getSDKSource;
		exports.isBrowserBundle = env.isBrowserBundle;
		exports.addItemToEnvelope = envelope.addItemToEnvelope;
		exports.createAttachmentEnvelopeItem = envelope.createAttachmentEnvelopeItem;
		exports.createEnvelope = envelope.createEnvelope;
		exports.createEventEnvelopeHeaders = envelope.createEventEnvelopeHeaders;
		exports.createSpanEnvelopeItem = envelope.createSpanEnvelopeItem;
		exports.envelopeContainsItemType = envelope.envelopeContainsItemType;
		exports.envelopeItemTypeToDataCategory = envelope.envelopeItemTypeToDataCategory;
		exports.forEachEnvelopeItem = envelope.forEachEnvelopeItem;
		exports.getSdkMetadataForEnvelopeHeader = envelope.getSdkMetadataForEnvelopeHeader;
		exports.parseEnvelope = envelope.parseEnvelope;
		exports.serializeEnvelope = envelope.serializeEnvelope;
		exports.createClientReportEnvelope = clientreport.createClientReportEnvelope;
		exports.DEFAULT_RETRY_AFTER = ratelimit.DEFAULT_RETRY_AFTER;
		exports.disabledUntil = ratelimit.disabledUntil;
		exports.isRateLimited = ratelimit.isRateLimited;
		exports.parseRetryAfterHeader = ratelimit.parseRetryAfterHeader;
		exports.updateRateLimits = ratelimit.updateRateLimits;
		exports.MAX_BAGGAGE_STRING_LENGTH = baggage.MAX_BAGGAGE_STRING_LENGTH;
		exports.SENTRY_BAGGAGE_KEY_PREFIX = baggage.SENTRY_BAGGAGE_KEY_PREFIX;
		exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = baggage.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
		exports.baggageHeaderToDynamicSamplingContext = baggage.baggageHeaderToDynamicSamplingContext;
		exports.dynamicSamplingContextToSentryBaggageHeader = baggage.dynamicSamplingContextToSentryBaggageHeader;
		exports.mergeBaggageHeaders = baggage.mergeBaggageHeaders;
		exports.objectToBaggageHeader = baggage.objectToBaggageHeader;
		exports.parseBaggageHeader = baggage.parseBaggageHeader;
		exports.getHttpSpanDetailsFromUrlObject = url.getHttpSpanDetailsFromUrlObject;
		exports.getSanitizedUrlString = url.getSanitizedUrlString;
		exports.getSanitizedUrlStringFromUrlObject = url.getSanitizedUrlStringFromUrlObject;
		exports.isURLObjectRelative = url.isURLObjectRelative;
		exports.parseStringToURLObject = url.parseStringToURLObject;
		exports.parseUrl = url.parseUrl;
		exports.stripDataUrlContent = url.stripDataUrlContent;
		exports.stripUrlQueryAndFragment = url.stripUrlQueryAndFragment;
		exports._INTERNAL_enhanceErrorWithSentryInfo = eventbuilder._enhanceErrorWithSentryInfo;
		exports.eventFromMessage = eventbuilder.eventFromMessage;
		exports.eventFromUnknownInput = eventbuilder.eventFromUnknownInput;
		exports.exceptionFromError = eventbuilder.exceptionFromError;
		exports.parseStackFrames = eventbuilder.parseStackFrames;
		exports.LRUMap = lru.LRUMap;
		exports.generateSpanId = propagationContext.generateSpanId;
		exports.generateTraceId = propagationContext.generateTraceId;
		exports.SDK_VERSION = version.SDK_VERSION;
		exports.getDebugImagesForResources = debugIds.getDebugImagesForResources;
		exports.getFilenameToDebugIdMap = debugIds.getFilenameToDebugIdMap;
		exports.getFilenameToMetadataMap = metadata.getFilenameToMetadataMap;
		exports.escapeStringForRegex = escapeStringForRegex.escapeStringForRegex;
		exports._INTERNAL_safeDateNow = randomSafeContext.safeDateNow;
		exports._INTERNAL_safeMathRandom = randomSafeContext.safeMathRandom;
		exports._INTERNAL_withRandomSafeContext = randomSafeContext.withRandomSafeContext;
		exports.ServerRuntimeClient = serverRuntimeClient.ServerRuntimeClient;
		exports.trpcMiddleware = trpc.trpcMiddleware;
		exports.wrapMcpServerWithSentry = index$8.wrapMcpServerWithSentry;
		exports.isNodeEnv = node.isNodeEnv;
		exports.loadModule = node.loadModule;
		exports.filenameIsInApp = nodeStackTrace.filenameIsInApp;
		exports.node = nodeStackTrace.node;
		exports.nodeStackLineParser = nodeStackTrace.nodeStackLineParser;
		exports.vercelWaitUntil = vercelWaitUntil.vercelWaitUntil;
		exports.flushIfServerless = flushIfServerless.flushIfServerless;
		exports.callFrameToStackFrame = anr.callFrameToStackFrame;
		exports.watchdogTimer = anr.watchdogTimer;
		exports._INTERNAL_safeUnref = timer.safeUnref;
		exports.expressErrorHandler = index$2.expressErrorHandler;
		exports.patchExpressModule = index$2.patchExpressModule;
		exports.setupExpressErrorHandler = index$2.setupExpressErrorHandler;
		exports.instrumentPostgresJsSql = postgresjs.instrumentPostgresJsSql;
		exports.patchHttpModuleClient = clientPatch.patchHttpModuleClient;
		exports.getHttpClientSubscriptions = clientSubscriptions.getHttpClientSubscriptions;
		exports.getHttpServerSubscriptions = serverSubscription.getHttpServerSubscriptions;
		exports.isStaticAssetRequest = serverSubscription.isStaticAssetRequest;
		exports.recordRequestSession = recordRequestSession.recordRequestSession;
		exports.addOutgoingRequestBreadcrumb = addOutgoingRequestBreadcrumb.addOutgoingRequestBreadcrumb;
		exports.getRequestOptions = getRequestUrl.getRequestOptions;
		exports.getRequestUrl = getRequestUrl.getRequestUrl;
		exports.getRequestUrlFromClientRequest = getRequestUrl.getRequestUrlFromClientRequest;
		exports.getRequestUrlObject = getRequestUrl.getRequestUrlObject;
		exports.HTTP_ON_CLIENT_REQUEST = constants$3.HTTP_ON_CLIENT_REQUEST;
		exports.HTTP_ON_SERVER_REQUEST = constants$3.HTTP_ON_SERVER_REQUEST;
		exports.getComponentName = browser.getComponentName;
		exports.getLocationHref = browser.getLocationHref;
		exports.htmlTreeAsString = browser.htmlTreeAsString;
		exports.instrumentLangChainEmbeddings = embeddings.instrumentLangChainEmbeddings;
		
	} (cjs$3));
	return cjs$3;
}

var hasRequiredCjs$3;

function requireCjs$3 () {
	if (hasRequiredCjs$3) return cjs$4;
	hasRequiredCjs$3 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();

		const WINDOW = core.GLOBAL_OBJ;
		const DOCUMENT = WINDOW.document;
		const NAVIGATOR = WINDOW.navigator;
		const TRIGGER_LABEL = "Report a Bug";
		const CANCEL_BUTTON_LABEL = "Cancel";
		const SUBMIT_BUTTON_LABEL = "Send Bug Report";
		const CONFIRM_BUTTON_LABEL = "Confirm";
		const FORM_TITLE = "Report a Bug";
		const EMAIL_PLACEHOLDER = "your.email@example.org";
		const EMAIL_LABEL = "Email";
		const MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
		const MESSAGE_LABEL = "Description";
		const NAME_PLACEHOLDER = "Your Name";
		const NAME_LABEL = "Name";
		const SUCCESS_MESSAGE_TEXT = "Thank you for your report!";
		const IS_REQUIRED_LABEL = "(required)";
		const ADD_SCREENSHOT_LABEL = "Add a screenshot";
		const REMOVE_SCREENSHOT_LABEL = "Remove screenshot";
		const HIGHLIGHT_TOOL_TEXT = "Highlight";
		const HIDE_TOOL_TEXT = "Hide";
		const REMOVE_HIGHLIGHT_TEXT = "Remove";
		const ERROR_EMPTY_MESSAGE_TEXT = "Unable to submit feedback with empty message";
		const ERROR_NO_CLIENT_TEXT = "No client setup, cannot send feedback.";
		const ERROR_TIMEOUT_TEXT = "Unable to determine if Feedback was correctly sent.";
		const ERROR_FORBIDDEN_TEXT = "Unable to send feedback. This could be because this domain is not in your list of allowed domains.";
		const ERROR_GENERIC_TEXT = "Unable to send feedback. This could be because of network issues, or because you are using an ad-blocker.";
		const FEEDBACK_WIDGET_SOURCE = "widget";
		const FEEDBACK_API_SOURCE = "api";
		const SUCCESS_MESSAGE_TIMEOUT = 5e3;

		const DEFAULT_MESSAGES = {
		  ERROR_EMPTY_MESSAGE: ERROR_EMPTY_MESSAGE_TEXT,
		  ERROR_NO_CLIENT: ERROR_NO_CLIENT_TEXT,
		  ERROR_TIMEOUT: ERROR_TIMEOUT_TEXT,
		  ERROR_FORBIDDEN: ERROR_FORBIDDEN_TEXT,
		  ERROR_GENERIC: ERROR_GENERIC_TEXT
		};
		function resolveFeedbackErrorMessage(code, messages) {
		  return messages?.[code] ?? DEFAULT_MESSAGES[code];
		}
		function createFeedbackError(code, messages) {
		  return new Error(resolveFeedbackErrorMessage(code, messages));
		}

		const sendFeedback = (params, hint = { includeReplay: true }) => {
		  const errorMessages = hint.errorMessages;
		  if (!params.message) {
		    throw createFeedbackError("ERROR_EMPTY_MESSAGE", errorMessages);
		  }
		  const client = core.getClient();
		  if (!client) {
		    throw createFeedbackError("ERROR_NO_CLIENT", errorMessages);
		  }
		  if (params.tags && Object.keys(params.tags).length) {
		    core.getCurrentScope().setTags(params.tags);
		  }
		  const eventId = core.captureFeedback(
		    {
		      source: FEEDBACK_API_SOURCE,
		      url: core.getLocationHref(),
		      ...params
		    },
		    hint
		  );
		  return new Promise((resolve, reject) => {
		    const timeout = setTimeout(() => {
		      cleanup();
		      reject(resolveFeedbackErrorMessage("ERROR_TIMEOUT", errorMessages));
		    }, 3e4);
		    const cleanup = client.on("afterSendEvent", (event, response) => {
		      if (event.event_id !== eventId) {
		        return;
		      }
		      clearTimeout(timeout);
		      cleanup();
		      if (response?.statusCode && response.statusCode >= 200 && response.statusCode < 300) {
		        return resolve(eventId);
		      }
		      if (response?.statusCode === 403) {
		        return reject(resolveFeedbackErrorMessage("ERROR_FORBIDDEN", errorMessages));
		      }
		      return reject(resolveFeedbackErrorMessage("ERROR_GENERIC", errorMessages));
		    });
		  });
		};

		const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

		function isScreenshotSupported() {
		  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(NAVIGATOR.userAgent)) {
		    return false;
		  }
		  if (/Macintosh/i.test(NAVIGATOR.userAgent) && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 1) {
		    return false;
		  }
		  if (!isSecureContext) {
		    return false;
		  }
		  return true;
		}

		function mergeOptions(defaultOptions, optionOverrides) {
		  return {
		    ...defaultOptions,
		    ...optionOverrides,
		    tags: {
		      ...defaultOptions.tags,
		      ...optionOverrides.tags
		    },
		    onFormOpen: () => {
		      optionOverrides.onFormOpen?.();
		      defaultOptions.onFormOpen?.();
		    },
		    onFormClose: () => {
		      optionOverrides.onFormClose?.();
		      defaultOptions.onFormClose?.();
		    },
		    onSubmitSuccess: (data, eventId) => {
		      optionOverrides.onSubmitSuccess?.(data, eventId);
		      defaultOptions.onSubmitSuccess?.(data, eventId);
		    },
		    onSubmitError: (error) => {
		      optionOverrides.onSubmitError?.(error);
		      defaultOptions.onSubmitError?.(error);
		    },
		    onFormSubmitted: () => {
		      optionOverrides.onFormSubmitted?.();
		      defaultOptions.onFormSubmitted?.();
		    },
		    themeDark: {
		      ...defaultOptions.themeDark,
		      ...optionOverrides.themeDark
		    },
		    themeLight: {
		      ...defaultOptions.themeLight,
		      ...optionOverrides.themeLight
		    }
		  };
		}

		function createActorStyles(styleNonce) {
		  const style = DOCUMENT.createElement("style");
		  style.textContent = `
.widget__actor {
  position: fixed;
  z-index: var(--z-index);
  margin: var(--page-margin);
  inset: var(--actor-inset);

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;

  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  line-height: 1.14em;
  text-decoration: none;

  background: var(--actor-background, var(--background));
  border-radius: var(--actor-border-radius, 1.7em/50%);
  border: var(--actor-border, var(--border));
  box-shadow: var(--actor-box-shadow, var(--box-shadow));
  color: var(--actor-color, var(--foreground));
  fill: var(--actor-color, var(--foreground));
  cursor: pointer;
  opacity: 1;
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}
.widget__actor[aria-hidden="true"] {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transform: translate(0, 16px) scale(0.98);
}

.widget__actor:hover {
  background: var(--actor-hover-background, var(--background));
  filter: var(--interactive-filter);
}

.widget__actor svg {
  width: 1.14em;
  height: 1.14em;
}

@media (max-width: 600px) {
  .widget__actor span {
    display: none;
  }
}
`;
		  if (styleNonce) {
		    style.setAttribute("nonce", styleNonce);
		  }
		  return style;
		}

		function setAttributesNS(el, attributes) {
		  Object.entries(attributes).forEach(([key, val]) => {
		    el.setAttributeNS(null, key, val);
		  });
		  return el;
		}

		const SIZE = 20;
		const XMLNS$2 = "http://www.w3.org/2000/svg";
		function FeedbackIcon() {
		  const createElementNS = (tagName) => WINDOW.document.createElementNS(XMLNS$2, tagName);
		  const svg = setAttributesNS(createElementNS("svg"), {
		    width: `${SIZE}`,
		    height: `${SIZE}`,
		    viewBox: `0 0 ${SIZE} ${SIZE}`,
		    fill: "var(--actor-color, var(--foreground))"
		  });
		  const g = setAttributesNS(createElementNS("g"), {
		    clipPath: "url(#clip0_57_80)"
		  });
		  const path = setAttributesNS(createElementNS("path"), {
		    ["fill-rule"]: "evenodd",
		    ["clip-rule"]: "evenodd",
		    d: "M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z"
		  });
		  svg.appendChild(g).appendChild(path);
		  const speakerDefs = createElementNS("defs");
		  const speakerClipPathDef = setAttributesNS(createElementNS("clipPath"), {
		    id: "clip0_57_80"
		  });
		  const speakerRect = setAttributesNS(createElementNS("rect"), {
		    width: `${SIZE}`,
		    height: `${SIZE}`,
		    fill: "white"
		  });
		  speakerClipPathDef.appendChild(speakerRect);
		  speakerDefs.appendChild(speakerClipPathDef);
		  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
		  return svg;
		}

		function Actor({ triggerLabel, triggerAriaLabel, shadow, styleNonce }) {
		  const el = DOCUMENT.createElement("button");
		  el.type = "button";
		  el.className = "widget__actor";
		  el.ariaHidden = "false";
		  el.ariaLabel = triggerAriaLabel || triggerLabel || TRIGGER_LABEL;
		  el.appendChild(FeedbackIcon());
		  if (triggerLabel) {
		    const label = DOCUMENT.createElement("span");
		    label.appendChild(DOCUMENT.createTextNode(triggerLabel));
		    el.appendChild(label);
		  }
		  const style = createActorStyles(styleNonce);
		  return {
		    el,
		    appendToDom() {
		      shadow.appendChild(style);
		      shadow.appendChild(el);
		    },
		    removeFromDom() {
		      el.remove();
		      style.remove();
		    },
		    show() {
		      el.ariaHidden = "false";
		    },
		    hide() {
		      el.ariaHidden = "true";
		    }
		  };
		}

		const PURPLE = "rgba(88, 74, 192, 1)";
		const DEFAULT_LIGHT = {
		  foreground: "#2b2233",
		  background: "#ffffff",
		  accentForeground: "white",
		  accentBackground: PURPLE,
		  successColor: "#268d75",
		  errorColor: "#df3338",
		  border: "1.5px solid rgba(41, 35, 47, 0.13)",
		  boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
		  outline: "1px auto var(--accent-background)",
		  interactiveFilter: "brightness(95%)"
		};
		const DEFAULT_DARK = {
		  foreground: "#ebe6ef",
		  background: "#29232f",
		  accentForeground: "white",
		  accentBackground: PURPLE,
		  successColor: "#2da98c",
		  errorColor: "#f55459",
		  border: "1.5px solid rgba(235, 230, 239, 0.15)",
		  boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
		  outline: "1px auto var(--accent-background)",
		  interactiveFilter: "brightness(150%)"
		};
		function getThemedCssVariables(theme) {
		  return `
  --foreground: ${theme.foreground};
  --background: ${theme.background};
  --accent-foreground: ${theme.accentForeground};
  --accent-background: ${theme.accentBackground};
  --success-color: ${theme.successColor};
  --error-color: ${theme.errorColor};
  --border: ${theme.border};
  --box-shadow: ${theme.boxShadow};
  --outline: ${theme.outline};
  --interactive-filter: ${theme.interactiveFilter};
  `;
		}
		function createMainStyles({
		  colorScheme,
		  themeDark,
		  themeLight,
		  styleNonce
		}) {
		  const style = DOCUMENT.createElement("style");
		  style.textContent = `
:host {
  --font-family: system-ui, 'Helvetica Neue', Arial, sans-serif;
  --font-size: 14px;
  --z-index: 100000;

  --page-margin: 16px;
  --inset: auto 0 0 auto;
  --actor-inset: var(--inset);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${colorScheme !== "system" ? `color-scheme: only ${colorScheme};` : ""}

  ${getThemedCssVariables(
		    colorScheme === "dark" ? { ...DEFAULT_DARK, ...themeDark } : { ...DEFAULT_LIGHT, ...themeLight }
		  )}
}

${colorScheme === "system" ? `
@media (prefers-color-scheme: dark) {
  :host {
    color-scheme: only dark;

    ${getThemedCssVariables({ ...DEFAULT_DARK, ...themeDark })}
  }
}` : ""}
`;
		  if (styleNonce) {
		    style.setAttribute("nonce", styleNonce);
		  }
		  return style;
		}

		const buildFeedbackIntegration = ({
		  lazyLoadIntegration,
		  getModalIntegration,
		  getScreenshotIntegration
		}) => {
		  const feedbackIntegration = (({
		    // FeedbackGeneralConfiguration
		    id = "sentry-feedback",
		    autoInject = true,
		    showBranding = true,
		    isEmailRequired = false,
		    isNameRequired = false,
		    showEmail = true,
		    showName = true,
		    enableScreenshot = true,
		    useSentryUser = {
		      email: "email",
		      name: "username"
		    },
		    tags,
		    styleNonce,
		    scriptNonce,
		    // FeedbackThemeConfiguration
		    colorScheme = "system",
		    themeLight = {},
		    themeDark = {},
		    // FeedbackTextConfiguration
		    addScreenshotButtonLabel = ADD_SCREENSHOT_LABEL,
		    cancelButtonLabel = CANCEL_BUTTON_LABEL,
		    confirmButtonLabel = CONFIRM_BUTTON_LABEL,
		    emailLabel = EMAIL_LABEL,
		    emailPlaceholder = EMAIL_PLACEHOLDER,
		    formTitle = FORM_TITLE,
		    isRequiredLabel = IS_REQUIRED_LABEL,
		    messageLabel = MESSAGE_LABEL,
		    messagePlaceholder = MESSAGE_PLACEHOLDER,
		    nameLabel = NAME_LABEL,
		    namePlaceholder = NAME_PLACEHOLDER,
		    removeScreenshotButtonLabel = REMOVE_SCREENSHOT_LABEL,
		    submitButtonLabel = SUBMIT_BUTTON_LABEL,
		    successMessageText = SUCCESS_MESSAGE_TEXT,
		    triggerLabel = TRIGGER_LABEL,
		    triggerAriaLabel = "",
		    highlightToolText = HIGHLIGHT_TOOL_TEXT,
		    hideToolText = HIDE_TOOL_TEXT,
		    removeHighlightText = REMOVE_HIGHLIGHT_TEXT,
		    errorEmptyMessageText = ERROR_EMPTY_MESSAGE_TEXT,
		    errorNoClientText = ERROR_NO_CLIENT_TEXT,
		    errorTimeoutText = ERROR_TIMEOUT_TEXT,
		    errorForbiddenText = ERROR_FORBIDDEN_TEXT,
		    errorGenericText = ERROR_GENERIC_TEXT,
		    // FeedbackCallbacks
		    onFormOpen,
		    onFormClose,
		    onSubmitSuccess,
		    onSubmitError,
		    onFormSubmitted
		  } = {}) => {
		    const _options = {
		      id,
		      autoInject,
		      showBranding,
		      isEmailRequired,
		      isNameRequired,
		      showEmail,
		      showName,
		      enableScreenshot,
		      useSentryUser,
		      tags,
		      styleNonce,
		      scriptNonce,
		      colorScheme,
		      themeDark,
		      themeLight,
		      triggerLabel,
		      triggerAriaLabel,
		      cancelButtonLabel,
		      submitButtonLabel,
		      confirmButtonLabel,
		      formTitle,
		      emailLabel,
		      emailPlaceholder,
		      messageLabel,
		      messagePlaceholder,
		      nameLabel,
		      namePlaceholder,
		      successMessageText,
		      isRequiredLabel,
		      addScreenshotButtonLabel,
		      removeScreenshotButtonLabel,
		      highlightToolText,
		      hideToolText,
		      removeHighlightText,
		      errorEmptyMessageText,
		      errorNoClientText,
		      errorTimeoutText,
		      errorForbiddenText,
		      errorGenericText,
		      onFormClose,
		      onFormOpen,
		      onSubmitError,
		      onSubmitSuccess,
		      onFormSubmitted
		    };
		    let _shadow = null;
		    let _mainStyle = null;
		    let _subscriptions = [];
		    const _createShadow = (options) => {
		      if (!_shadow) {
		        const host = DOCUMENT.createElement("div");
		        host.id = String(options.id);
		        DOCUMENT.body.appendChild(host);
		        _shadow = host.attachShadow({ mode: "open" });
		        _mainStyle = createMainStyles(options);
		        _shadow.appendChild(_mainStyle);
		      }
		      return _shadow;
		    };
		    const _loadAndRenderDialog = async (options) => {
		      const screenshotRequired = options.enableScreenshot && isScreenshotSupported();
		      let modalIntegration;
		      let screenshotIntegration;
		      try {
		        const modalIntegrationFn = getModalIntegration ? getModalIntegration() : await lazyLoadIntegration("feedbackModalIntegration", scriptNonce);
		        modalIntegration = modalIntegrationFn();
		        core.addIntegration(modalIntegration);
		      } catch {
		        DEBUG_BUILD && core.debug.error(
		          "[Feedback] Error when trying to load feedback integrations. Try using `feedbackSyncIntegration` in your `Sentry.init`."
		        );
		        throw new Error("[Feedback] Missing feedback modal integration!");
		      }
		      try {
		        const screenshotIntegrationFn = screenshotRequired ? getScreenshotIntegration ? getScreenshotIntegration() : await lazyLoadIntegration("feedbackScreenshotIntegration", scriptNonce) : void 0;
		        if (screenshotIntegrationFn) {
		          screenshotIntegration = screenshotIntegrationFn();
		          core.addIntegration(screenshotIntegration);
		        }
		      } catch {
		        DEBUG_BUILD && core.debug.error("[Feedback] Missing feedback screenshot integration. Proceeding without screenshots.");
		      }
		      const errorMessages = {
		        ERROR_EMPTY_MESSAGE: options.errorEmptyMessageText,
		        ERROR_NO_CLIENT: options.errorNoClientText,
		        ERROR_TIMEOUT: options.errorTimeoutText,
		        ERROR_FORBIDDEN: options.errorForbiddenText,
		        ERROR_GENERIC: options.errorGenericText
		      };
		      const wrappedSendFeedback = (params, hint) => sendFeedback(params, { includeReplay: true, ...hint, errorMessages });
		      const dialog = modalIntegration.createDialog({
		        options: {
		          ...options,
		          onFormClose: () => {
		            dialog?.close();
		            options.onFormClose?.();
		          },
		          onFormSubmitted: () => {
		            dialog?.close();
		            options.onFormSubmitted?.();
		          }
		        },
		        screenshotIntegration,
		        sendFeedback: wrappedSendFeedback,
		        shadow: _createShadow(options)
		      });
		      return dialog;
		    };
		    const _attachTo = (el, optionOverrides = {}) => {
		      const mergedOptions = mergeOptions(_options, optionOverrides);
		      const targetEl = typeof el === "string" ? DOCUMENT.querySelector(el) : typeof el.addEventListener === "function" ? el : null;
		      if (!targetEl) {
		        DEBUG_BUILD && core.debug.error("[Feedback] Unable to attach to target element");
		        throw new Error("Unable to attach to target element");
		      }
		      let dialog = null;
		      const handleClick = async () => {
		        if (!dialog) {
		          dialog = await _loadAndRenderDialog({
		            ...mergedOptions,
		            onFormSubmitted: () => {
		              dialog?.removeFromDom();
		              mergedOptions.onFormSubmitted?.();
		            }
		          });
		        }
		        dialog.appendToDom();
		        dialog.open();
		      };
		      targetEl.addEventListener("click", handleClick);
		      const unsubscribe = () => {
		        _subscriptions = _subscriptions.filter((sub) => sub !== unsubscribe);
		        dialog?.removeFromDom();
		        dialog = null;
		        targetEl.removeEventListener("click", handleClick);
		      };
		      _subscriptions.push(unsubscribe);
		      return unsubscribe;
		    };
		    const _createActor = (optionOverrides = {}) => {
		      const mergedOptions = mergeOptions(_options, optionOverrides);
		      const shadow = _createShadow(mergedOptions);
		      const actor = Actor({
		        triggerLabel: mergedOptions.triggerLabel,
		        triggerAriaLabel: mergedOptions.triggerAriaLabel,
		        shadow,
		        styleNonce
		      });
		      _attachTo(actor.el, {
		        ...mergedOptions,
		        onFormOpen() {
		          actor.hide();
		        },
		        onFormClose() {
		          actor.show();
		        },
		        onFormSubmitted() {
		          actor.show();
		        }
		      });
		      return actor;
		    };
		    return {
		      name: "Feedback",
		      setupOnce() {
		        if (!core.isBrowser() || !_options.autoInject) {
		          return;
		        }
		        if (DOCUMENT.readyState === "loading") {
		          DOCUMENT.addEventListener("DOMContentLoaded", () => _createActor().appendToDom());
		        } else {
		          _createActor().appendToDom();
		        }
		      },
		      /**
		       * Adds click listener to the element to open a feedback dialog
		       *
		       * The returned function can be used to remove the click listener
		       */
		      attachTo: _attachTo,
		      /**
		       * Creates a new widget which is composed of a Button which triggers a Dialog.
		       * Accepts partial options to override any options passed to constructor.
		       */
		      createWidget(optionOverrides = {}) {
		        const actor = _createActor(mergeOptions(_options, optionOverrides));
		        actor.appendToDom();
		        return actor;
		      },
		      /**
		       * Creates a new Form which you can
		       * Accepts partial options to override any options passed to constructor.
		       */
		      async createForm(optionOverrides = {}) {
		        return _loadAndRenderDialog(mergeOptions(_options, optionOverrides));
		      },
		      /**
		       * Updates the color scheme of the feedback widget at runtime.
		       */
		      setTheme(colorScheme2) {
		        _options.colorScheme = colorScheme2;
		        if (_shadow) {
		          const newStyle = createMainStyles(_options);
		          if (_mainStyle) {
		            _shadow.replaceChild(newStyle, _mainStyle);
		          } else {
		            _shadow.prepend(newStyle);
		          }
		          _mainStyle = newStyle;
		        }
		      },
		      /**
		       * Removes the Feedback integration (including host, shadow DOM, and all widgets)
		       */
		      remove() {
		        if (_shadow) {
		          _shadow.parentElement?.remove();
		          _shadow = null;
		          _mainStyle = null;
		        }
		        _subscriptions.forEach((sub) => sub());
		        _subscriptions = [];
		      }
		    };
		  });
		  return feedbackIntegration;
		};

		function getFeedback() {
		  const client = core.getClient();
		  return client?.getIntegrationByName("Feedback");
		}

		var n,l$1,u$1,i$1,o$1,r$1,f$1,c$1={},s$1=[],a$1=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,h$1=Array.isArray;function v$1(n,l){for(var u in l)n[u]=l[u];return n}function p$1(n){var l=n.parentNode;l&&l.removeChild(n);}function y$1(l,u,t){var i,o,r,f={};for(r in u)"key"==r?i=u[r]:"ref"==r?o=u[r]:f[r]=u[r];if(arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):t),"function"==typeof l&&null!=l.defaultProps)for(r in l.defaultProps) void 0===f[r]&&(f[r]=l.defaultProps[r]);return d$1(l,f,i,o,null)}function d$1(n,t,i,o,r){var f={type:n,props:t,key:i,ref:o,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,constructor:void 0,__v:null==r?++u$1:r,__i:-1,__u:0};return null==r&&null!=l$1.vnode&&l$1.vnode(f),f}function g$1(n){return n.children}function b$1(n,l){this.props=n,this.context=l;}function m$1(n,l){if(null==l)return n.__?m$1(n.__,n.__i+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?m$1(n):null}function w$1(n,u,t){var i,o=n.__v,r=o.__e,f=n.__P;if(f)return (i=v$1({},o)).__v=o.__v+1,l$1.vnode&&l$1.vnode(i),M(f,i,o,n.__n,void 0!==f.ownerSVGElement,32&o.__u?[r]:null,u,null==r?m$1(o):r,!!(32&o.__u),t),i.__.__k[i.__i]=i,i.__d=void 0,i.__e!=r&&k$1(i),i}function k$1(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return k$1(n)}}function x$1(n){(!n.__d&&(n.__d=true)&&i$1.push(n)&&!C$1.__r++||o$1!==l$1.debounceRendering)&&((o$1=l$1.debounceRendering)||r$1)(C$1);}function C$1(){var n,u,t,o=[],r=[];for(i$1.sort(f$1);n=i$1.shift();)n.__d&&(t=i$1.length,u=w$1(n,o,r)||u,0===t||i$1.length>t?(j$1(o,u,r),r.length=o.length=0,u=void 0,i$1.sort(f$1)):u&&l$1.__c&&l$1.__c(u,s$1));u&&j$1(o,u,r),C$1.__r=0;}function P$1(n,l,u,t,i,o,r,f,e,a,h){var v,p,y,d,_,g=t&&t.__k||s$1,b=l.length;for(u.__d=e,S(u,l,g),e=u.__d,v=0;v<b;v++)null!=(y=u.__k[v])&&"boolean"!=typeof y&&"function"!=typeof y&&(p=-1===y.__i?c$1:g[y.__i]||c$1,y.__i=v,M(n,y,p,i,o,r,f,e,a,h),d=y.__e,y.ref&&p.ref!=y.ref&&(p.ref&&N(p.ref,null,y),h.push(y.ref,y.__c||d,y)),null==_&&null!=d&&(_=d),65536&y.__u||p.__k===y.__k?e=$(y,e,n):"function"==typeof y.type&&void 0!==y.__d?e=y.__d:d&&(e=d.nextSibling),y.__d=void 0,y.__u&=-196609);u.__d=e,u.__e=_;}function S(n,l,u){var t,i,o,r,f,e=l.length,c=u.length,s=c,a=0;for(n.__k=[],t=0;t<e;t++)null!=(i=n.__k[t]=null==(i=l[t])||"boolean"==typeof i||"function"==typeof i?null:"string"==typeof i||"number"==typeof i||"bigint"==typeof i||i.constructor==String?d$1(null,i,null,null,i):h$1(i)?d$1(g$1,{children:i},null,null,null):void 0===i.constructor&&i.__b>0?d$1(i.type,i.props,i.key,i.ref?i.ref:null,i.__v):i)?(i.__=n,i.__b=n.__b+1,f=I(i,u,r=t+a,s),i.__i=f,o=null,-1!==f&&(s--,(o=u[f])&&(o.__u|=131072)),null==o||null===o.__v?(-1==f&&a--,"function"!=typeof i.type&&(i.__u|=65536)):f!==r&&(f===r+1?a++:f>r?s>e-r?a+=f-r:a--:a=f<r&&f==r-1?f-r:0,f!==t+a&&(i.__u|=65536))):(o=u[t])&&null==o.key&&o.__e&&(o.__e==n.__d&&(n.__d=m$1(o)),O(o,o,false),u[t]=null,s--);if(s)for(t=0;t<c;t++)null!=(o=u[t])&&0==(131072&o.__u)&&(o.__e==n.__d&&(n.__d=m$1(o)),O(o,o));}function $(n,l,u){var t,i;if("function"==typeof n.type){for(t=n.__k,i=0;t&&i<t.length;i++)t[i]&&(t[i].__=n,l=$(t[i],l,u));return l}n.__e!=l&&(u.insertBefore(n.__e,l||null),l=n.__e);do{l=l&&l.nextSibling;}while(null!=l&&8===l.nodeType);return l}function I(n,l,u,t){var i=n.key,o=n.type,r=u-1,f=u+1,e=l[u];if(null===e||e&&i==e.key&&o===e.type)return u;if(t>(null!=e&&0==(131072&e.__u)?1:0))for(;r>=0||f<l.length;){if(r>=0){if((e=l[r])&&0==(131072&e.__u)&&i==e.key&&o===e.type)return r;r--;}if(f<l.length){if((e=l[f])&&0==(131072&e.__u)&&i==e.key&&o===e.type)return f;f++;}}return  -1}function T$1(n,l,u){"-"===l[0]?n.setProperty(l,null==u?"":u):n[l]=null==u?"":"number"!=typeof u||a$1.test(l)?u:u+"px";}function A$1(n,l,u,t,i){var o;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else {if("string"==typeof t&&(n.style.cssText=t=""),t)for(l in t)u&&l in u||T$1(n.style,l,"");if(u)for(l in u)t&&u[l]===t[l]||T$1(n.style,l,u[l]);}else if("o"===l[0]&&"n"===l[1])o=l!==(l=l.replace(/(PointerCapture)$|Capture$/i,"$1")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+o]=u,u?t?u.u=t.u:(u.u=Date.now(),n.addEventListener(l,o?L:D$1,o)):n.removeEventListener(l,o?L:D$1,o);else {if(i)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!==l&&"height"!==l&&"href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&"rowSpan"!==l&&"colSpan"!==l&&"role"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null==u||false===u&&"-"!==l[4]?n.removeAttribute(l):n.setAttribute(l,u));}}function D$1(n){if(this.l){var u=this.l[n.type+false];if(n.t){if(n.t<=u.u)return}else n.t=Date.now();return u(l$1.event?l$1.event(n):n)}}function L(n){if(this.l)return this.l[n.type+true](l$1.event?l$1.event(n):n)}function M(n,u,t,i,o,r,f,e,c,s){var a,p,y,d,_,m,w,k,x,C,S,$,H,I,T,A=u.type;if(void 0!==u.constructor)return null;128&t.__u&&(c=!!(32&t.__u),r=[e=u.__e=t.__e]),(a=l$1.__b)&&a(u);n:if("function"==typeof A)try{if(k=u.props,x=(a=A.contextType)&&i[a.__c],C=a?x?x.props.value:a.__:i,t.__c?w=(p=u.__c=t.__c).__=p.__E:("prototype"in A&&A.prototype.render?u.__c=p=new A(k,C):(u.__c=p=new b$1(k,C),p.constructor=A,p.render=q$1),x&&x.sub(p),p.props=k,p.state||(p.state={}),p.context=C,p.__n=i,y=p.__d=!0,p.__h=[],p._sb=[]),null==p.__s&&(p.__s=p.state),null!=A.getDerivedStateFromProps&&(p.__s==p.state&&(p.__s=v$1({},p.__s)),v$1(p.__s,A.getDerivedStateFromProps(k,p.__s))),d=p.props,_=p.state,p.__v=u,y)null==A.getDerivedStateFromProps&&null!=p.componentWillMount&&p.componentWillMount(),null!=p.componentDidMount&&p.__h.push(p.componentDidMount);else {if(null==A.getDerivedStateFromProps&&k!==d&&null!=p.componentWillReceiveProps&&p.componentWillReceiveProps(k,C),!p.__e&&(null!=p.shouldComponentUpdate&&!1===p.shouldComponentUpdate(k,p.__s,C)||u.__v===t.__v)){for(u.__v!==t.__v&&(p.props=k,p.state=p.__s,p.__d=!1),u.__e=t.__e,u.__k=t.__k,u.__k.forEach(function(n){n&&(n.__=u);}),S=0;S<p._sb.length;S++)p.__h.push(p._sb[S]);p._sb=[],p.__h.length&&f.push(p);break n}null!=p.componentWillUpdate&&p.componentWillUpdate(k,p.__s,C),null!=p.componentDidUpdate&&p.__h.push(function(){p.componentDidUpdate(d,_,m);});}if(p.context=C,p.props=k,p.__P=n,p.__e=!1,$=l$1.__r,H=0,"prototype"in A&&A.prototype.render){for(p.state=p.__s,p.__d=!1,$&&$(u),a=p.render(p.props,p.state,p.context),I=0;I<p._sb.length;I++)p.__h.push(p._sb[I]);p._sb=[];}else do{p.__d=!1,$&&$(u),a=p.render(p.props,p.state,p.context),p.state=p.__s;}while(p.__d&&++H<25);p.state=p.__s,null!=p.getChildContext&&(i=v$1(v$1({},i),p.getChildContext())),y||null==p.getSnapshotBeforeUpdate||(m=p.getSnapshotBeforeUpdate(d,_)),P$1(n,h$1(T=null!=a&&a.type===g$1&&null==a.key?a.props.children:a)?T:[T],u,t,i,o,r,f,e,c,s),p.base=u.__e,u.__u&=-161,p.__h.length&&f.push(p),w&&(p.__E=p.__=null);}catch(n){u.__v=null,c||null!=r?(u.__e=e,u.__u|=c?160:32,r[r.indexOf(e)]=null):(u.__e=t.__e,u.__k=t.__k),l$1.__e(n,u,t);}else null==r&&u.__v===t.__v?(u.__k=t.__k,u.__e=t.__e):u.__e=z$1(t.__e,u,t,i,o,r,f,c,s);(a=l$1.diffed)&&a(u);}function j$1(n,u,t){for(var i=0;i<t.length;i++)N(t[i],t[++i],t[++i]);l$1.__c&&l$1.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u);});}catch(n){l$1.__e(n,u.__v);}});}function z$1(l,u,t,i,o,r,f,e,s){var a,v,y,d,_,g,b,w=t.props,k=u.props,x=u.type;if("svg"===x&&(o=true),null!=r)for(a=0;a<r.length;a++)if((_=r[a])&&"setAttribute"in _==!!x&&(x?_.localName===x:3===_.nodeType)){l=_,r[a]=null;break}if(null==l){if(null===x)return document.createTextNode(k);l=o?document.createElementNS("http://www.w3.org/2000/svg",x):document.createElement(x,k.is&&k),r=null,e=false;}if(null===x)w===k||e&&l.data===k||(l.data=k);else {if(r=r&&n.call(l.childNodes),w=t.props||c$1,!e&&null!=r)for(w={},a=0;a<l.attributes.length;a++)w[(_=l.attributes[a]).name]=_.value;for(a in w)_=w[a],"children"==a||("dangerouslySetInnerHTML"==a?y=_:"key"===a||a in k||A$1(l,a,null,_,o));for(a in k)_=k[a],"children"==a?d=_:"dangerouslySetInnerHTML"==a?v=_:"value"==a?g=_:"checked"==a?b=_:"key"===a||e&&"function"!=typeof _||w[a]===_||A$1(l,a,_,w[a],o);if(v)e||y&&(v.__html===y.__html||v.__html===l.innerHTML)||(l.innerHTML=v.__html),u.__k=[];else if(y&&(l.innerHTML=""),P$1(l,h$1(d)?d:[d],u,t,i,o&&"foreignObject"!==x,r,f,r?r[0]:t.__k&&m$1(t,0),e,s),null!=r)for(a=r.length;a--;)null!=r[a]&&p$1(r[a]);e||(a="value",void 0!==g&&(g!==l[a]||"progress"===x&&!g||"option"===x&&g!==w[a])&&A$1(l,a,g,w[a],false),a="checked",void 0!==b&&b!==l[a]&&A$1(l,a,b,w[a],false));}return l}function N(n,u,t){try{"function"==typeof n?n(u):n.current=u;}catch(n){l$1.__e(n,t);}}function O(n,u,t){var i,o;if(l$1.unmount&&l$1.unmount(n),(i=n.ref)&&(i.current&&i.current!==n.__e||N(i,null,u)),null!=(i=n.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount();}catch(n){l$1.__e(n,u);}i.base=i.__P=null,n.__c=void 0;}if(i=n.__k)for(o=0;o<i.length;o++)i[o]&&O(i[o],u,t||"function"!=typeof n.type);t||null==n.__e||p$1(n.__e),n.__=n.__e=n.__d=void 0;}function q$1(n,l,u){return this.constructor(n,u)}function B$1(u,t,i){var o,r,f,e;l$1.__&&l$1.__(u,t),r=(o="function"=="undefined")?null:t.__k,f=[],e=[],M(t,u=(t).__k=y$1(g$1,null,[u]),r||c$1,c$1,void 0!==t.ownerSVGElement,r?null:t.firstChild?n.call(t.childNodes):null,f,r?r.__e:t.firstChild,o,e),u.__d=void 0,j$1(f,u,e);}n=s$1.slice,l$1={__e:function(n,l,u,t){for(var i,o,r;l=l.__;)if((i=l.__c)&&!i.__)try{if((o=i.constructor)&&null!=o.getDerivedStateFromError&&(i.setState(o.getDerivedStateFromError(n)),r=i.__d),null!=i.componentDidCatch&&(i.componentDidCatch(n,t||{}),r=i.__d),r)return i.__E=i}catch(l){n=l;}throw n}},u$1=0,b$1.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=v$1({},this.state),"function"==typeof n&&(n=n(v$1({},u),this.props)),n&&v$1(u,n),null!=n&&this.__v&&(l&&this._sb.push(l),x$1(this));},b$1.prototype.forceUpdate=function(n){this.__v&&(this.__e=true,n&&this.__h.push(n),x$1(this));},b$1.prototype.render=g$1,i$1=[],r$1="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,f$1=function(n,l){return n.__v.__b-l.__v.__b},C$1.__r=0;

		var t,r,u,i,o=0,f=[],c=[],e=l$1,a=e.__b,v=e.__r,l=e.diffed,m=e.__c,s=e.unmount,d=e.__;function h(n,t){e.__h&&e.__h(r,n,o||t),o=0;var u=r.__H||(r.__H={__:[],__h:[]});return n>=u.__.length&&u.__.push({__V:c}),u.__[n]}function p(n){return o=1,y(D,n)}function y(n,u,i){var o=h(t++,2);if(o.t=n,!o.__c&&(o.__=[i?i(u):D(void 0,u),function(n){var t=o.__N?o.__N[0]:o.__[0],r=o.t(t,n);t!==r&&(o.__N=[r,o.__[1]],o.__c.setState({}));}],o.__c=r,!r.u)){var f=function(n,t,r){if(!o.__c.__H)return  true;var u=o.__c.__H.__.filter(function(n){return !!n.__c});if(u.every(function(n){return !n.__N}))return !c||c.call(this,n,t,r);var i=false;return u.forEach(function(n){if(n.__N){var t=n.__[0];n.__=n.__N,n.__N=void 0,t!==n.__[0]&&(i=true);}}),!(!i&&o.__c.props===n)&&(!c||c.call(this,n,t,r))};r.u=true;var c=r.shouldComponentUpdate,e=r.componentWillUpdate;r.componentWillUpdate=function(n,t,r){if(this.__e){var u=c;c=void 0,f(n,t,r),c=u;}e&&e.call(this,n,t,r);},r.shouldComponentUpdate=f;}return o.__N||o.__}function _(n,u){var i=h(t++,3);!e.__s&&C(i.__H,u)&&(i.__=n,i.i=u,r.__H.__h.push(i));}function A(n,u){var i=h(t++,4);!e.__s&&C(i.__H,u)&&(i.__=n,i.i=u,r.__h.push(i));}function F(n){return o=5,q(function(){return {current:n}},[])}function T(n,t,r){o=6,A(function(){return "function"==typeof n?(n(t()),function(){return n(null)}):n?(n.current=t(),function(){return n.current=null}):void 0},null==r?r:r.concat(n));}function q(n,r){var u=h(t++,7);return C(u.__H,r)?(u.__V=n(),u.i=r,u.__h=n,u.__V):u.__}function x(n,t){return o=8,q(function(){return n},t)}function P(n){var u=r.context[n.__c],i=h(t++,9);return i.c=n,u?(null==i.__&&(i.__=true,u.sub(r)),u.props.value):n.__}function V(n,t){e.useDebugValue&&e.useDebugValue(t?t(n):n);}function b(n){var u=h(t++,10),i=p();return u.__=n,r.componentDidCatch||(r.componentDidCatch=function(n,t){u.__&&u.__(n,t),i[1](n);}),[i[0],function(){i[1](void 0);}]}function g(){var n=h(t++,11);if(!n.__){for(var u=r.__v;null!==u&&!u.__m&&null!==u.__;)u=u.__;var i=u.__m||(u.__m=[0,0]);n.__="P"+i[0]+"-"+i[1]++;}return n.__}function j(){for(var n;n=f.shift();)if(n.__P&&n.__H)try{n.__H.__h.forEach(z),n.__H.__h.forEach(B),n.__H.__h=[];}catch(t){n.__H.__h=[],e.__e(t,n.__v);}}e.__b=function(n){r=null,a&&a(n);},e.__=function(n,t){t.__k&&t.__k.__m&&(n.__m=t.__k.__m),d&&d(n,t);},e.__r=function(n){v&&v(n),t=0;var i=(r=n.__c).__H;i&&(u===r?(i.__h=[],r.__h=[],i.__.forEach(function(n){n.__N&&(n.__=n.__N),n.__V=c,n.__N=n.i=void 0;})):(i.__h.forEach(z),i.__h.forEach(B),i.__h=[],t=0)),u=r;},e.diffed=function(n){l&&l(n);var t=n.__c;t&&t.__H&&(t.__H.__h.length&&(1!==f.push(t)&&i===e.requestAnimationFrame||((i=e.requestAnimationFrame)||w)(j)),t.__H.__.forEach(function(n){n.i&&(n.__H=n.i),n.__V!==c&&(n.__=n.__V),n.i=void 0,n.__V=c;})),u=r=null;},e.__c=function(n,t){t.some(function(n){try{n.__h.forEach(z),n.__h=n.__h.filter(function(n){return !n.__||B(n)});}catch(r){t.some(function(n){n.__h&&(n.__h=[]);}),t=[],e.__e(r,n.__v);}}),m&&m(n,t);},e.unmount=function(n){s&&s(n);var t,r=n.__c;r&&r.__H&&(r.__H.__.forEach(function(n){try{z(n);}catch(n){t=n;}}),r.__H=void 0,t&&e.__e(t,r.__v));};var k="function"==typeof requestAnimationFrame;function w(n){var t,r=function(){clearTimeout(u),k&&cancelAnimationFrame(t),setTimeout(n);},u=setTimeout(r,100);k&&(t=requestAnimationFrame(r));}function z(n){var t=r,u=n.__c;"function"==typeof u&&(n.__c=void 0,u()),r=t;}function B(n){var t=r;n.__c=n.__(),r=t;}function C(n,t){return !n||n.length!==t.length||t.some(function(t,r){return t!==n[r]})}function D(n,t){return "function"==typeof t?t(n):t}

		const hooks = /*#__PURE__*/Object.defineProperty({
		  __proto__: null,
		  useCallback: x,
		  useContext: P,
		  useDebugValue: V,
		  useEffect: _,
		  useErrorBoundary: b,
		  useId: g,
		  useImperativeHandle: T,
		  useLayoutEffect: A,
		  useMemo: q,
		  useReducer: y,
		  useRef: F,
		  useState: p
		}, Symbol.toStringTag, { value: 'Module' });

		const XMLNS$1 = "http://www.w3.org/2000/svg";
		function SentryLogo() {
		  const createElementNS = (tagName) => DOCUMENT.createElementNS(XMLNS$1, tagName);
		  const svg = setAttributesNS(createElementNS("svg"), {
		    width: "32",
		    height: "30",
		    viewBox: "0 0 72 66",
		    fill: "inherit"
		  });
		  const path = setAttributesNS(createElementNS("path"), {
		    transform: "translate(11, 11)",
		    d: "M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
		  });
		  svg.appendChild(path);
		  return svg;
		}

		function DialogHeader({ options }) {
		  const logoHtml = q(() => ({ __html: SentryLogo().outerHTML }), []);
		  return /* @__PURE__ */ y$1("h2", { class: "dialog__header" }, /* @__PURE__ */ y$1("span", { class: "dialog__title" }, options.formTitle), options.showBranding ? /* @__PURE__ */ y$1(
		    "a",
		    {
		      class: "brand-link",
		      target: "_blank",
		      href: "https://sentry.io/welcome/",
		      title: "Powered by Sentry",
		      rel: "noopener noreferrer",
		      dangerouslySetInnerHTML: logoHtml
		    }
		  ) : null);
		}

		function getMissingFields(feedback, props) {
		  const emptyFields = [];
		  if (props.isNameRequired && !feedback.name) {
		    emptyFields.push(props.nameLabel);
		  }
		  if (props.isEmailRequired && !feedback.email) {
		    emptyFields.push(props.emailLabel);
		  }
		  if (!feedback.message) {
		    emptyFields.push(props.messageLabel);
		  }
		  return emptyFields;
		}

		function retrieveStringValue(formData, key) {
		  const value = formData.get(key);
		  if (typeof value === "string") {
		    return value.trim();
		  }
		  return "";
		}
		function Form({
		  options,
		  defaultEmail,
		  defaultName,
		  onFormClose,
		  onSubmit,
		  onSubmitSuccess,
		  onSubmitError,
		  showEmail,
		  showName,
		  screenshotInput
		}) {
		  const {
		    tags,
		    addScreenshotButtonLabel,
		    removeScreenshotButtonLabel,
		    cancelButtonLabel,
		    emailLabel,
		    emailPlaceholder,
		    isEmailRequired,
		    isNameRequired,
		    messageLabel,
		    messagePlaceholder,
		    nameLabel,
		    namePlaceholder,
		    submitButtonLabel,
		    isRequiredLabel
		  } = options;
		  const [isSubmitting, setIsSubmitting] = p(false);
		  const [error, setError] = p(null);
		  const [showScreenshotInput, setShowScreenshotInput] = p(false);
		  const ScreenshotInputComponent = screenshotInput?.input;
		  const [screenshotError, setScreenshotError] = p(null);
		  const onScreenshotError = x((error2) => {
		    setScreenshotError(error2);
		    setShowScreenshotInput(false);
		  }, []);
		  const hasAllRequiredFields = x(
		    (data) => {
		      const missingFields = getMissingFields(data, {
		        emailLabel,
		        isEmailRequired,
		        isNameRequired,
		        messageLabel,
		        nameLabel
		      });
		      if (missingFields.length > 0) {
		        setError(`Please enter in the following required fields: ${missingFields.join(", ")}`);
		      } else {
		        setError(null);
		      }
		      return missingFields.length === 0;
		    },
		    [emailLabel, isEmailRequired, isNameRequired, messageLabel, nameLabel]
		  );
		  const handleSubmit = x(
		    async (e) => {
		      setIsSubmitting(true);
		      try {
		        e.preventDefault();
		        if (!(e.target instanceof HTMLFormElement)) {
		          return;
		        }
		        const formData = new FormData(e.target);
		        const attachment = await (screenshotInput && showScreenshotInput ? screenshotInput.value() : void 0);
		        const data = {
		          name: retrieveStringValue(formData, "name"),
		          email: retrieveStringValue(formData, "email"),
		          message: retrieveStringValue(formData, "message"),
		          attachments: attachment ? [attachment] : void 0
		        };
		        if (!hasAllRequiredFields(data)) {
		          return;
		        }
		        try {
		          const eventId = await onSubmit(
		            {
		              name: data.name,
		              email: data.email,
		              message: data.message,
		              source: FEEDBACK_WIDGET_SOURCE,
		              tags
		            },
		            { attachments: data.attachments }
		          );
		          onSubmitSuccess(data, eventId);
		        } catch (error2) {
		          DEBUG_BUILD && core.debug.error(error2);
		          const err = error2 instanceof Error ? error2 : new Error(String(error2));
		          setError(err.message);
		          onSubmitError(err);
		        }
		      } finally {
		        setIsSubmitting(false);
		      }
		    },
		    [screenshotInput && showScreenshotInput, onSubmitSuccess, onSubmitError]
		  );
		  return /* @__PURE__ */ y$1("form", { class: "form", onSubmit: handleSubmit }, ScreenshotInputComponent && showScreenshotInput ? /* @__PURE__ */ y$1(ScreenshotInputComponent, { onError: onScreenshotError }) : null, /* @__PURE__ */ y$1("fieldset", { class: "form__right", "data-sentry-feedback": true, disabled: isSubmitting }, /* @__PURE__ */ y$1("div", { class: "form__top" }, error ? /* @__PURE__ */ y$1("div", { class: "form__error-container" }, error) : null, showName ? /* @__PURE__ */ y$1("label", { for: "name", class: "form__label" }, /* @__PURE__ */ y$1(LabelText, { label: nameLabel, isRequiredLabel, isRequired: isNameRequired }), /* @__PURE__ */ y$1(
		    "input",
		    {
		      class: "form__input",
		      defaultValue: defaultName,
		      id: "name",
		      name: "name",
		      placeholder: namePlaceholder,
		      required: isNameRequired,
		      type: "text"
		    }
		  )) : /* @__PURE__ */ y$1("input", { "aria-hidden": true, value: defaultName, name: "name", type: "hidden" }), showEmail ? /* @__PURE__ */ y$1("label", { for: "email", class: "form__label" }, /* @__PURE__ */ y$1(LabelText, { label: emailLabel, isRequiredLabel, isRequired: isEmailRequired }), /* @__PURE__ */ y$1(
		    "input",
		    {
		      class: "form__input",
		      defaultValue: defaultEmail,
		      id: "email",
		      name: "email",
		      placeholder: emailPlaceholder,
		      required: isEmailRequired,
		      type: "email"
		    }
		  )) : /* @__PURE__ */ y$1("input", { "aria-hidden": true, value: defaultEmail, name: "email", type: "hidden" }), /* @__PURE__ */ y$1("label", { for: "message", class: "form__label" }, /* @__PURE__ */ y$1(LabelText, { label: messageLabel, isRequiredLabel, isRequired: true }), /* @__PURE__ */ y$1(
		    "textarea",
		    {
		      autoFocus: true,
		      class: "form__input form__input--textarea",
		      id: "message",
		      name: "message",
		      placeholder: messagePlaceholder,
		      required: true,
		      rows: 5
		    }
		  )), ScreenshotInputComponent ? /* @__PURE__ */ y$1("label", { for: "screenshot", class: "form__label" }, /* @__PURE__ */ y$1(
		    "button",
		    {
		      class: "btn btn--default",
		      disabled: isSubmitting,
		      type: "button",
		      onClick: () => {
		        setScreenshotError(null);
		        setShowScreenshotInput((prev) => !prev);
		      }
		    },
		    showScreenshotInput ? removeScreenshotButtonLabel : addScreenshotButtonLabel
		  ), screenshotError ? /* @__PURE__ */ y$1("div", { class: "form__error-container" }, screenshotError.message) : null) : null), /* @__PURE__ */ y$1("div", { class: "btn-group" }, /* @__PURE__ */ y$1("button", { class: "btn btn--primary", disabled: isSubmitting, type: "submit" }, submitButtonLabel), /* @__PURE__ */ y$1("button", { class: "btn btn--default", disabled: isSubmitting, type: "button", onClick: onFormClose }, cancelButtonLabel))));
		}
		function LabelText({
		  label,
		  isRequired,
		  isRequiredLabel
		}) {
		  return /* @__PURE__ */ y$1("span", { class: "form__label__text" }, label, isRequired && /* @__PURE__ */ y$1("span", { class: "form__label__text--required" }, isRequiredLabel));
		}

		const WIDTH = 16;
		const HEIGHT = 17;
		const XMLNS = "http://www.w3.org/2000/svg";
		function SuccessIcon() {
		  const createElementNS = (tagName) => WINDOW.document.createElementNS(XMLNS, tagName);
		  const svg = setAttributesNS(createElementNS("svg"), {
		    width: `${WIDTH}`,
		    height: `${HEIGHT}`,
		    viewBox: `0 0 ${WIDTH} ${HEIGHT}`,
		    fill: "inherit"
		  });
		  const g = setAttributesNS(createElementNS("g"), {
		    clipPath: "url(#clip0_57_156)"
		  });
		  const path2 = setAttributesNS(createElementNS("path"), {
		    ["fill-rule"]: "evenodd",
		    ["clip-rule"]: "evenodd",
		    d: "M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z"
		  });
		  const path = setAttributesNS(createElementNS("path"), {
		    d: "M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z"
		  });
		  svg.appendChild(g).append(path, path2);
		  const speakerDefs = createElementNS("defs");
		  const speakerClipPathDef = setAttributesNS(createElementNS("clipPath"), {
		    id: "clip0_57_156"
		  });
		  const speakerRect = setAttributesNS(createElementNS("rect"), {
		    width: `${WIDTH}`,
		    height: `${WIDTH}`,
		    fill: "white",
		    transform: "translate(0 0.5)"
		  });
		  speakerClipPathDef.appendChild(speakerRect);
		  speakerDefs.appendChild(speakerClipPathDef);
		  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
		  return svg;
		}

		function Dialog({ open, onFormSubmitted, ...props }) {
		  const options = props.options;
		  const successIconHtml = q(() => ({ __html: SuccessIcon().outerHTML }), []);
		  const [timeoutId, setTimeoutId] = p(null);
		  const handleOnSuccessClick = x(() => {
		    if (timeoutId) {
		      clearTimeout(timeoutId);
		      setTimeoutId(null);
		    }
		    onFormSubmitted();
		  }, [timeoutId]);
		  const onSubmitSuccess = x(
		    (data, eventId) => {
		      props.onSubmitSuccess(data, eventId);
		      setTimeoutId(
		        setTimeout(() => {
		          onFormSubmitted();
		          setTimeoutId(null);
		        }, SUCCESS_MESSAGE_TIMEOUT)
		      );
		    },
		    [onFormSubmitted]
		  );
		  return /* @__PURE__ */ y$1(g$1, null, timeoutId ? /* @__PURE__ */ y$1("div", { class: "success__position", onClick: handleOnSuccessClick }, /* @__PURE__ */ y$1("div", { class: "success__content" }, options.successMessageText, /* @__PURE__ */ y$1("span", { class: "success__icon", dangerouslySetInnerHTML: successIconHtml }))) : /* @__PURE__ */ y$1("dialog", { class: "dialog", onClick: options.onFormClose, open }, /* @__PURE__ */ y$1("div", { class: "dialog__position" }, /* @__PURE__ */ y$1(
		    "div",
		    {
		      class: "dialog__content",
		      onClick: (e) => {
		        e.stopPropagation();
		      }
		    },
		    /* @__PURE__ */ y$1(DialogHeader, { options }),
		    /* @__PURE__ */ y$1(Form, { ...props, onSubmitSuccess })
		  ))));
		}

		const DIALOG = `
.dialog {
  position: fixed;
  z-index: var(--z-index);
  margin: 0;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 100vh;
  width: 100vw;

  color: var(--dialog-color, var(--foreground));
  fill: var(--dialog-color, var(--foreground));
  line-height: 1.75em;

  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  inset: 0;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog__position {
  position: fixed;
  z-index: var(--z-index);
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  display: flex;
  max-height: calc(100vh - (2 * var(--page-margin)));
}
@media (max-width: 600px) {
  .dialog__position {
    inset: var(--page-margin);
    padding: 0;
  }
}

.dialog__position:has(.editor) {
  inset: var(--page-margin);
  padding: 0;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: var(--dialog-padding, 24px);
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  overflow: auto;

  background: var(--dialog-background, var(--background));
  border-radius: var(--dialog-border-radius, 20px);
  border: var(--dialog-border, var(--border));
  box-shadow: var(--dialog-box-shadow, var(--box-shadow));
  transform: translate(0, 0) scale(1);
  transition: transform 0.2s ease-in-out;
}

`;
		const DIALOG_HEADER = `
.dialog__header {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  font-weight: var(--dialog-header-weight, 600);
  margin: 0;
}
.dialog__title {
  align-self: center;
  width: var(--form-width, 272px);
}

@media (max-width: 600px) {
  .dialog__title {
    width: auto;
  }
}

.dialog__position:has(.editor) .dialog__title {
  width: auto;
}


.brand-link {
  display: inline-flex;
}
.brand-link:focus-visible {
  outline: var(--outline);
}
`;
		const FORM = `
.form {
  display: flex;
  overflow: auto;
  flex-direction: row;
  gap: 16px;
  flex: 1 0;
}

.form fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.form__right {
  flex: 0 0 auto;
  display: flex;
  overflow: auto;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  width: var(--form-width, 100%);
}

.dialog__position:has(.editor) .form__right {
  width: var(--form-width, 272px);
}

.form__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form__error-container {
  color: var(--error-color);
  fill: var(--error-color);
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  font-family: inherit;
  line-height: inherit;
  background: transparent;
  box-sizing: border-box;
  border: var(--input-border, var(--border));
  border-radius: var(--input-border-radius, 6px);
  color: var(--input-color, inherit);
  fill: var(--input-color, inherit);
  font-size: var(--input-font-size, inherit);
  font-weight: var(--input-font-weight, 500);
  padding: 6px 12px;
}

.form__input::placeholder {
  opacity: 0.65;
  color: var(--input-placeholder-color, inherit);
  filter: var(--interactive-filter);
}

.form__input:focus-visible {
  outline: var(--input-focus-outline, var(--outline));
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.error {
  color: var(--error-color);
  fill: var(--error-color);
}
`;
		const BUTTON = `
.btn-group {
  display: grid;
  gap: 8px;
}

.btn {
  line-height: inherit;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--button-font-size, inherit);
  font-weight: var(--button-font-weight, 600);
  padding: var(--button-padding, 6px 16px);
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  color: var(--button-primary-color, var(--accent-foreground));
  fill: var(--button-primary-color, var(--accent-foreground));
  background: var(--button-primary-background, var(--accent-background));
  border: var(--button-primary-border, var(--border));
  border-radius: var(--button-primary-border-radius, 6px);
  font-weight: var(--button-primary-font-weight, 500);
}
.btn--primary:hover {
  color: var(--button-primary-hover-color, var(--accent-foreground));
  fill: var(--button-primary-hover-color, var(--accent-foreground));
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
}
.btn--primary:focus-visible {
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
  outline: var(--button-primary-focus-outline, var(--outline));
}

.btn--default {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-background, var(--background));
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  font-weight: var(--button-font-weight, 500);
}
.btn--default:hover {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
}
.btn--default:focus-visible {
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
  outline: var(--button-focus-outline, var(--outline));
}
`;
		const SUCCESS = `
.success__position {
  position: fixed;
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  z-index: var(--z-index);
}
.success__content {
  background: var(--success-background, var(--background));
  border: var(--success-border, var(--border));
  border-radius: var(--success-border-radius, 1.7em/50%);
  box-shadow: var(--success-box-shadow, var(--box-shadow));
  font-weight: var(--success-font-weight, 600);
  color: var(--success-color);
  fill: var(--success-color);
  padding: 12px 24px;
  line-height: 1.75em;

  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success__icon {
  display: flex;
}
`;
		function createDialogStyles(styleNonce) {
		  const style = DOCUMENT.createElement("style");
		  style.textContent = `
:host {
  --dialog-inset: var(--inset);
}

${DIALOG}
${DIALOG_HEADER}
${FORM}
${BUTTON}
${SUCCESS}
`;
		  if (styleNonce) {
		    style.setAttribute("nonce", styleNonce);
		  }
		  return style;
		}

		function getUser() {
		  const currentUser = core.getCurrentScope().getUser();
		  const isolationUser = core.getIsolationScope().getUser();
		  const globalUser = core.getGlobalScope().getUser();
		  if (currentUser && Object.keys(currentUser).length) {
		    return currentUser;
		  }
		  if (isolationUser && Object.keys(isolationUser).length) {
		    return isolationUser;
		  }
		  return globalUser;
		}
		const feedbackModalIntegration = (() => {
		  return {
		    name: "FeedbackModal",
		    setupOnce() {
		    },
		    createDialog: ({ options, screenshotIntegration, sendFeedback, shadow }) => {
		      const shadowRoot = shadow;
		      const userKey = options.useSentryUser;
		      const user = getUser();
		      const el = DOCUMENT.createElement("div");
		      const style = createDialogStyles(options.styleNonce);
		      let originalOverflow = "";
		      const dialog = {
		        get el() {
		          return el;
		        },
		        appendToDom() {
		          if (!shadowRoot.contains(style) && !shadowRoot.contains(el)) {
		            shadowRoot.appendChild(style);
		            shadowRoot.appendChild(el);
		          }
		        },
		        removeFromDom() {
		          el.remove();
		          style.remove();
		          DOCUMENT.body.style.overflow = originalOverflow;
		        },
		        open() {
		          renderContent(true);
		          options.onFormOpen?.();
		          core.getClient()?.emit("openFeedbackWidget");
		          originalOverflow = DOCUMENT.body.style.overflow;
		          DOCUMENT.body.style.overflow = "hidden";
		        },
		        close() {
		          renderContent(false);
		          DOCUMENT.body.style.overflow = originalOverflow;
		        }
		      };
		      const screenshotInput = screenshotIntegration?.createInput({ h: y$1, hooks, dialog, options });
		      const renderContent = (open) => {
		        B$1(
		          /* @__PURE__ */ y$1(
		            Dialog,
		            {
		              options,
		              screenshotInput,
		              showName: options.showName || options.isNameRequired,
		              showEmail: options.showEmail || options.isEmailRequired,
		              defaultName: String(userKey && user?.[userKey.name] || ""),
		              defaultEmail: String(userKey && user?.[userKey.email] || ""),
		              onFormClose: () => {
		                renderContent(false);
		                options.onFormClose?.();
		              },
		              onSubmit: sendFeedback,
		              onSubmitSuccess: (data, eventId) => {
		                renderContent(false);
		                options.onSubmitSuccess?.(data, eventId);
		              },
		              onSubmitError: (error) => {
		                options.onSubmitError?.(error);
		              },
		              onFormSubmitted: () => {
		                options.onFormSubmitted?.();
		              },
		              open
		            }
		          ),
		          el
		        );
		      };
		      return dialog;
		    }
		  };
		});

		function IconCloseFactory({
		  h
		  // eslint-disable-line @typescript-eslint/no-unused-vars
		}) {
		  return function IconClose() {
		    return /* @__PURE__ */ h("svg", { "data-test-id": "icon-close", viewBox: "0 0 16 16", fill: "#2B2233", height: "25px", width: "25px" }, /* @__PURE__ */ h("circle", { r: "7", cx: "8", cy: "8", fill: "white" }), /* @__PURE__ */ h(
		      "path",
		      {
		        strokeWidth: "1.5",
		        d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.53A6.47,6.47,0,1,0,14.47,8,6.47,6.47,0,0,0,8,1.53Z"
		      }
		    ), /* @__PURE__ */ h(
		      "path",
		      {
		        strokeWidth: "1.5",
		        d: "M5.34,11.41a.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l5.32-5.32a.75.75,0,0,1,1.06,1.06L5.87,11.19A.74.74,0,0,1,5.34,11.41Z"
		      }
		    ), /* @__PURE__ */ h(
		      "path",
		      {
		        strokeWidth: "1.5",
		        d: "M10.66,11.41a.74.74,0,0,1-.53-.22L4.81,5.87A.75.75,0,0,1,5.87,4.81l5.32,5.32a.74.74,0,0,1,0,1.06A.71.71,0,0,1,10.66,11.41Z"
		      }
		    ));
		  };
		}

		function createScreenshotInputStyles(styleNonce) {
		  const style = DOCUMENT.createElement("style");
		  const surface200 = "#1A141F";
		  const gray100 = "#302735";
		  style.textContent = `
.editor {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.editor__image-container {
  justify-items: center;
  padding: 15px;
  position: relative;
  height: 100%;
  border-radius: var(--menu-border-radius, 6px);

  background-color: ${surface200};
  background-image: repeating-linear-gradient(
      -145deg,
      transparent,
      transparent 8px,
      ${surface200} 8px,
      ${surface200} 11px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 15px,
      ${gray100} 15px,
      ${gray100} 16px
    );
}

.editor__canvas-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editor__canvas-container > * {
  object-fit: contain;
  position: absolute;
}

.editor__tool-container {
  padding-top: 8px;
  display: flex;
  justify-content: center;
}

.editor__tool-bar {
  display: flex;
  gap: 8px;
}

.editor__tool {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  background: var(--button-background, var(--background));
  color: var(--button-color, var(--foreground));
}

.editor__tool--active {
  background: var(--button-primary-background, var(--accent-background));
  color: var(--button-primary-color, var(--accent-foreground));
}

.editor__rect {
  position: absolute;
  z-index: 2;
}

.editor__rect button {
  opacity: 0;
  position: absolute;
  top: -12px;
  right: -12px;
  cursor: pointer;
  padding: 0;
  z-index: 3;
  border: none;
  background: none;
}

.editor__rect:hover button {
  opacity: 1;
}
`;
		  if (styleNonce) {
		    style.setAttribute("nonce", styleNonce);
		  }
		  return style;
		}

		function ToolbarFactory({
		  h
		  // eslint-disable-line @typescript-eslint/no-unused-vars
		}) {
		  return function Toolbar({
		    action,
		    setAction,
		    options
		  }) {
		    return /* @__PURE__ */ h("div", { class: "editor__tool-container" }, /* @__PURE__ */ h("div", { class: "editor__tool-bar" }, /* @__PURE__ */ h(
		      "button",
		      {
		        type: "button",
		        class: `editor__tool ${action === "highlight" ? "editor__tool--active" : ""}`,
		        onClick: () => {
		          setAction(action === "highlight" ? "" : "highlight");
		        }
		      },
		      options.highlightToolText
		    ), /* @__PURE__ */ h(
		      "button",
		      {
		        type: "button",
		        class: `editor__tool ${action === "hide" ? "editor__tool--active" : ""}`,
		        onClick: () => {
		          setAction(action === "hide" ? "" : "hide");
		        }
		      },
		      options.hideToolText
		    )));
		  };
		}

		function useTakeScreenshotFactory({ hooks }) {
		  function useDpi() {
		    const [dpi, setDpi] = hooks.useState(WINDOW.devicePixelRatio ?? 1);
		    hooks.useEffect(() => {
		      const onChange = () => {
		        setDpi(WINDOW.devicePixelRatio);
		      };
		      const media = matchMedia(`(resolution: ${WINDOW.devicePixelRatio}dppx)`);
		      media.addEventListener("change", onChange);
		      return () => {
		        media.removeEventListener("change", onChange);
		      };
		    }, []);
		    return dpi;
		  }
		  return function useTakeScreenshot({ onBeforeScreenshot, onScreenshot, onAfterScreenshot, onError }) {
		    const dpi = useDpi();
		    hooks.useEffect(() => {
		      const takeScreenshot = async () => {
		        onBeforeScreenshot();
		        const stream = await NAVIGATOR.mediaDevices.getDisplayMedia({
		          video: {
		            width: WINDOW.innerWidth * dpi,
		            height: WINDOW.innerHeight * dpi
		          },
		          audio: false,
		          // @ts-expect-error experimental flags: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#prefercurrenttab
		          monitorTypeSurfaces: "exclude",
		          preferCurrentTab: true,
		          selfBrowserSurface: "include",
		          surfaceSwitching: "exclude"
		        });
		        const video = DOCUMENT.createElement("video");
		        await new Promise((resolve, reject) => {
		          video.srcObject = stream;
		          video.onloadedmetadata = () => {
		            onScreenshot(video, dpi);
		            stream.getTracks().forEach((track) => track.stop());
		            resolve();
		          };
		          video.play().catch(reject);
		        });
		        onAfterScreenshot();
		      };
		      takeScreenshot().catch(onError);
		    }, []);
		  };
		}

		function drawRect(command, ctx, color) {
		  switch (command.type) {
		    case "highlight": {
		      ctx.shadowColor = "rgba(0, 0, 0, 0.7)";
		      ctx.shadowBlur = 50;
		      ctx.fillStyle = color;
		      ctx.fillRect(command.x - 1, command.y - 1, command.w + 2, command.h + 2);
		      ctx.clearRect(command.x, command.y, command.w, command.h);
		      break;
		    }
		    case "hide":
		      ctx.fillStyle = "rgb(0, 0, 0)";
		      ctx.fillRect(command.x, command.y, command.w, command.h);
		      break;
		  }
		}
		function with2dContext(canvas, options, callback) {
		  if (!canvas) {
		    return;
		  }
		  const ctx = canvas.getContext("2d", options);
		  if (!ctx) {
		    return;
		  }
		  callback(canvas, ctx);
		}
		function paintImage(maybeDest, source) {
		  with2dContext(maybeDest, { alpha: true }, (destCanvas, destCtx) => {
		    destCtx.drawImage(source, 0, 0, source.width, source.height, 0, 0, destCanvas.width, destCanvas.height);
		  });
		}
		function paintForeground(maybeCanvas, strokeColor, drawCommands) {
		  with2dContext(maybeCanvas, { alpha: true }, (canvas, ctx) => {
		    if (drawCommands.length) {
		      ctx.fillStyle = "rgba(0, 0, 0, 0.25)";
		      ctx.fillRect(0, 0, canvas.width, canvas.height);
		    }
		    drawCommands.forEach((command) => {
		      drawRect(command, ctx, strokeColor);
		    });
		  });
		}
		function ScreenshotEditorFactory({
		  h: h2,
		  hooks,
		  outputBuffer,
		  dialog,
		  options
		}) {
		  const useTakeScreenshot = useTakeScreenshotFactory({ hooks });
		  const Toolbar = ToolbarFactory({ h: h2 });
		  const IconClose = IconCloseFactory({ h: h2 });
		  const editorStyleInnerText = { __html: createScreenshotInputStyles(options.styleNonce).innerText };
		  const dialogStyle = dialog.el.style;
		  const ScreenshotEditor = ({ screenshot }) => {
		    const [action, setAction] = hooks.useState("highlight");
		    const [drawCommands, setDrawCommands] = hooks.useState([]);
		    const measurementRef = hooks.useRef(null);
		    const backgroundRef = hooks.useRef(null);
		    const foregroundRef = hooks.useRef(null);
		    const mouseRef = hooks.useRef(null);
		    const [scaleFactor, setScaleFactor] = hooks.useState(1);
		    const strokeColor = hooks.useMemo(() => {
		      const sentryFeedback = DOCUMENT.getElementById(options.id);
		      if (!sentryFeedback) {
		        return "white";
		      }
		      const computedStyle = getComputedStyle(sentryFeedback);
		      return computedStyle.getPropertyValue("--button-primary-background") || computedStyle.getPropertyValue("--accent-background");
		    }, [options.id]);
		    hooks.useLayoutEffect(() => {
		      const handleResize = () => {
		        const measurementDiv = measurementRef.current;
		        if (!measurementDiv) {
		          return;
		        }
		        with2dContext(screenshot.canvas, { alpha: false }, (canvas) => {
		          const scale = Math.min(
		            measurementDiv.clientWidth / canvas.width,
		            measurementDiv.clientHeight / canvas.height
		          );
		          setScaleFactor(scale);
		        });
		        if (measurementDiv.clientHeight === 0 || measurementDiv.clientWidth === 0) {
		          setTimeout(handleResize, 0);
		        }
		      };
		      handleResize();
		      WINDOW.addEventListener("resize", handleResize);
		      return () => {
		        WINDOW.removeEventListener("resize", handleResize);
		      };
		    }, [screenshot]);
		    const setCanvasSize = hooks.useCallback(
		      (maybeCanvas, scale) => {
		        with2dContext(maybeCanvas, { alpha: true }, (canvas, ctx) => {
		          ctx.scale(scale, scale);
		          canvas.width = screenshot.canvas.width;
		          canvas.height = screenshot.canvas.height;
		        });
		      },
		      [screenshot]
		    );
		    hooks.useEffect(() => {
		      setCanvasSize(backgroundRef.current, screenshot.dpi);
		      paintImage(backgroundRef.current, screenshot.canvas);
		    }, [screenshot]);
		    hooks.useEffect(() => {
		      setCanvasSize(foregroundRef.current, screenshot.dpi);
		      with2dContext(foregroundRef.current, { alpha: true }, (canvas, ctx) => {
		        ctx.clearRect(0, 0, canvas.width, canvas.height);
		      });
		      paintForeground(foregroundRef.current, strokeColor, drawCommands);
		    }, [drawCommands, strokeColor]);
		    hooks.useEffect(() => {
		      setCanvasSize(outputBuffer, screenshot.dpi);
		      paintImage(outputBuffer, screenshot.canvas);
		      with2dContext(DOCUMENT.createElement("canvas"), { alpha: true }, (foreground, ctx) => {
		        ctx.scale(screenshot.dpi, screenshot.dpi);
		        foreground.width = screenshot.canvas.width;
		        foreground.height = screenshot.canvas.height;
		        paintForeground(foreground, strokeColor, drawCommands);
		        paintImage(outputBuffer, foreground);
		      });
		    }, [drawCommands, screenshot, strokeColor]);
		    const handleMouseDown = (e) => {
		      if (!action || !mouseRef.current) {
		        return;
		      }
		      const boundingRect = mouseRef.current.getBoundingClientRect();
		      const startingPoint = {
		        type: action,
		        x: e.offsetX / scaleFactor,
		        y: e.offsetY / scaleFactor};
		      const getDrawCommand = (startingPoint2, e2) => {
		        const x = (e2.clientX - boundingRect.x) / scaleFactor;
		        const y = (e2.clientY - boundingRect.y) / scaleFactor;
		        return {
		          type: startingPoint2.type,
		          x: Math.min(startingPoint2.x, x),
		          y: Math.min(startingPoint2.y, y),
		          w: Math.abs(x - startingPoint2.x),
		          h: Math.abs(y - startingPoint2.y)
		        };
		      };
		      const handleMouseMove = (e2) => {
		        with2dContext(foregroundRef.current, { alpha: true }, (canvas, ctx) => {
		          ctx.clearRect(0, 0, canvas.width, canvas.height);
		        });
		        paintForeground(foregroundRef.current, strokeColor, [...drawCommands, getDrawCommand(startingPoint, e2)]);
		      };
		      const handleMouseUp = (e2) => {
		        const drawCommand = getDrawCommand(startingPoint, e2);
		        if (drawCommand.w * scaleFactor >= 1 && drawCommand.h * scaleFactor >= 1) {
		          setDrawCommands((prev) => [...prev, drawCommand]);
		        }
		        DOCUMENT.removeEventListener("mousemove", handleMouseMove);
		        DOCUMENT.removeEventListener("mouseup", handleMouseUp);
		      };
		      DOCUMENT.addEventListener("mousemove", handleMouseMove);
		      DOCUMENT.addEventListener("mouseup", handleMouseUp);
		    };
		    const deleteRect = hooks.useCallback((index) => {
		      return (e) => {
		        e.preventDefault();
		        e.stopPropagation();
		        setDrawCommands((prev) => {
		          const updatedRects = [...prev];
		          updatedRects.splice(index, 1);
		          return updatedRects;
		        });
		      };
		    }, []);
		    const dimensions = {
		      width: `${screenshot.canvas.width * scaleFactor}px`,
		      height: `${screenshot.canvas.height * scaleFactor}px`
		    };
		    const handleStopPropagation = (e) => {
		      e.stopPropagation();
		    };
		    return /* @__PURE__ */ h2("div", { class: "editor" }, /* @__PURE__ */ h2("style", { nonce: options.styleNonce, dangerouslySetInnerHTML: editorStyleInnerText }), /* @__PURE__ */ h2("div", { class: "editor__image-container" }, /* @__PURE__ */ h2("div", { class: "editor__canvas-container", ref: measurementRef }, /* @__PURE__ */ h2("canvas", { ref: backgroundRef, id: "background", style: dimensions }), /* @__PURE__ */ h2("canvas", { ref: foregroundRef, id: "foreground", style: dimensions }), /* @__PURE__ */ h2("div", { ref: mouseRef, onMouseDown: handleMouseDown, style: dimensions }, drawCommands.map((rect, index) => /* @__PURE__ */ h2(
		      "div",
		      {
		        key: index,
		        class: "editor__rect",
		        style: {
		          top: `${rect.y * scaleFactor}px`,
		          left: `${rect.x * scaleFactor}px`,
		          width: `${rect.w * scaleFactor}px`,
		          height: `${rect.h * scaleFactor}px`
		        }
		      },
		      /* @__PURE__ */ h2(
		        "button",
		        {
		          "aria-label": options.removeHighlightText,
		          onClick: deleteRect(index),
		          onMouseDown: handleStopPropagation,
		          onMouseUp: handleStopPropagation,
		          type: "button"
		        },
		        /* @__PURE__ */ h2(IconClose, null)
		      )
		    ))))), /* @__PURE__ */ h2(Toolbar, { options, action, setAction }));
		  };
		  return function Wrapper({ onError }) {
		    const [screenshot, setScreenshot] = hooks.useState();
		    useTakeScreenshot({
		      onBeforeScreenshot: hooks.useCallback(() => {
		        dialogStyle.display = "none";
		      }, []),
		      onScreenshot: hooks.useCallback((screenshotVideo, dpi) => {
		        with2dContext(DOCUMENT.createElement("canvas"), { alpha: false }, (canvas, ctx) => {
		          ctx.scale(dpi, dpi);
		          canvas.width = screenshotVideo.videoWidth;
		          canvas.height = screenshotVideo.videoHeight;
		          ctx.drawImage(screenshotVideo, 0, 0, canvas.width, canvas.height);
		          setScreenshot({ canvas, dpi });
		        });
		        outputBuffer.width = screenshotVideo.videoWidth;
		        outputBuffer.height = screenshotVideo.videoHeight;
		      }, []),
		      onAfterScreenshot: hooks.useCallback(() => {
		        dialogStyle.display = "block";
		      }, []),
		      onError: hooks.useCallback((error) => {
		        dialogStyle.display = "block";
		        onError(error);
		      }, [])
		    });
		    if (screenshot) {
		      return /* @__PURE__ */ h2(ScreenshotEditor, { screenshot });
		    }
		    return /* @__PURE__ */ h2("div", null);
		  };
		}

		const feedbackScreenshotIntegration = (() => {
		  return {
		    name: "FeedbackScreenshot",
		    setupOnce() {
		    },
		    createInput: ({ h, hooks, dialog, options }) => {
		      const outputBuffer = DOCUMENT.createElement("canvas");
		      return {
		        input: ScreenshotEditorFactory({
		          h,
		          hooks,
		          outputBuffer,
		          dialog,
		          options
		        }),
		        // eslint-disable-line @typescript-eslint/no-explicit-any
		        value: async () => {
		          const blob = await new Promise((resolve) => {
		            outputBuffer.toBlob(resolve, "image/png");
		          });
		          if (blob) {
		            const data = new Uint8Array(await blob.arrayBuffer());
		            const attachment = {
		              data,
		              filename: "screenshot.png",
		              contentType: "application/png"
		              // attachmentType?: string;
		            };
		            return attachment;
		          }
		          return void 0;
		        }
		      };
		    }
		  };
		});

		exports.buildFeedbackIntegration = buildFeedbackIntegration;
		exports.feedbackModalIntegration = feedbackModalIntegration;
		exports.feedbackScreenshotIntegration = feedbackScreenshotIntegration;
		exports.getFeedback = getFeedback;
		exports.sendFeedback = sendFeedback;
		
	} (cjs$4));
	return cjs$4;
}

var lazyLoadIntegration = {};

var browser$c = {};

var hasRequiredBrowser$c;

function requireBrowser$c () {
	if (hasRequiredBrowser$c) return browser$c;
	hasRequiredBrowser$c = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const errors = /*@__PURE__*/ requireErrors();
		const utils$2 = /*@__PURE__*/ requireUtils$g();
		const idleSpan = /*@__PURE__*/ requireIdleSpan();
		const sentrySpan = /*@__PURE__*/ requireSentrySpan();
		const sentryNonRecordingSpan = /*@__PURE__*/ requireSentryNonRecordingSpan();
		const spanstatus = /*@__PURE__*/ requireSpanstatus();
		const trace = /*@__PURE__*/ requireTrace();
		const bindScopeToEmitter = /*@__PURE__*/ requireBindScopeToEmitter();
		const dynamicSamplingContext = /*@__PURE__*/ requireDynamicSamplingContext();
		const measurement = /*@__PURE__*/ requireMeasurement();
		const sampling = /*@__PURE__*/ requireSampling();
		const logSpans = /*@__PURE__*/ requireLogSpans();
		const captureSpan = /*@__PURE__*/ requireCaptureSpan();
		const semanticAttributes = /*@__PURE__*/ requireSemanticAttributes();
		const envelope$1 = /*@__PURE__*/ requireEnvelope$3();
		const exports$1 = /*@__PURE__*/ requireExports$1();
		const currentScopes = /*@__PURE__*/ requireCurrentScopes();
		const defaultScopes = /*@__PURE__*/ requireDefaultScopes();
		const index$6 = /*@__PURE__*/ requireAsyncContext();
		const carrier = /*@__PURE__*/ requireCarrier();
		const session = /*@__PURE__*/ requireSession();
		const scope = /*@__PURE__*/ requireScope();
		const eventProcessors = /*@__PURE__*/ requireEventProcessors();
		const api = /*@__PURE__*/ requireApi$1();
		const client = /*@__PURE__*/ requireClient$1();
		const sdk = /*@__PURE__*/ requireSdk$1();
		const base = /*@__PURE__*/ requireBase$2();
		const offline = /*@__PURE__*/ requireOffline$1();
		const multiplexed = /*@__PURE__*/ requireMultiplexed();
		const integration = /*@__PURE__*/ requireIntegration$6();
		const providerSkip = /*@__PURE__*/ requireProviderSkip();
		const filterKeyValueData = /*@__PURE__*/ requireFilterKeyValueData();
		const filterCookies = /*@__PURE__*/ requireFilterCookies();
		const filterQueryParams = /*@__PURE__*/ requireFilterQueryParams();
		const envToBool = /*@__PURE__*/ requireEnvToBool();
		const scopeData = /*@__PURE__*/ requireScopeData();
		const prepareEvent = /*@__PURE__*/ requirePrepareEvent();
		const checkin = /*@__PURE__*/ requireCheckin();
		const hasSpansEnabled = /*@__PURE__*/ requireHasSpansEnabled();
		const beforeSendSpan = /*@__PURE__*/ requireBeforeSendSpan();
		const isSentryRequestUrl = /*@__PURE__*/ requireIsSentryRequestUrl();
		const handleCallbackErrors = /*@__PURE__*/ requireHandleCallbackErrors();
		const parameterize = /*@__PURE__*/ requireParameterize();
		const tunnel = /*@__PURE__*/ requireTunnel();
		const ipAddress = /*@__PURE__*/ requireIpAddress();
		const spanUtils = /*@__PURE__*/ requireSpanUtils();
		const spanOnScope = /*@__PURE__*/ requireSpanOnScope();
		const parseSampleRate = /*@__PURE__*/ requireParseSampleRate();
		const sdkMetadata = /*@__PURE__*/ requireSdkMetadata();
		const traceData = /*@__PURE__*/ requireTraceData();
		const tracePropagationTargets = /*@__PURE__*/ requireTracePropagationTargets();
		const meta = /*@__PURE__*/ requireMeta();
		const debounce = /*@__PURE__*/ requireDebounce();
		const weakRef = /*@__PURE__*/ requireWeakRef();
		const shouldIgnoreSpan = /*@__PURE__*/ requireShouldIgnoreSpan();
		const request = /*@__PURE__*/ requireRequest$1();
		const constants$1 = /*@__PURE__*/ requireConstants$9();
		const breadcrumbs = /*@__PURE__*/ requireBreadcrumbs$1();
		const functiontostring = /*@__PURE__*/ requireFunctiontostring();
		const eventFilters = /*@__PURE__*/ requireEventFilters();
		const linkederrors = /*@__PURE__*/ requireLinkederrors$1();
		const moduleMetadata = /*@__PURE__*/ requireModuleMetadata();
		const requestdata = /*@__PURE__*/ requireRequestdata();
		const captureconsole = /*@__PURE__*/ requireCaptureconsole();
		const dedupe = /*@__PURE__*/ requireDedupe();
		const extraerrordata = /*@__PURE__*/ requireExtraerrordata();
		const rewriteframes = /*@__PURE__*/ requireRewriteframes();
		const supabase = /*@__PURE__*/ requireSupabase();
		const zoderrors = /*@__PURE__*/ requireZoderrors();
		const thirdPartyErrorsFilter = /*@__PURE__*/ requireThirdPartyErrorsFilter();
		const console$1 = /*@__PURE__*/ requireConsole();
		const featureFlagsIntegration = /*@__PURE__*/ requireFeatureFlagsIntegration();
		const growthbook = /*@__PURE__*/ requireGrowthbook();
		const conversationId = /*@__PURE__*/ requireConversationId();
		const profiling = /*@__PURE__*/ requireProfiling$1();
		const fetch = /*@__PURE__*/ requireFetch$2();
		const feedback = /*@__PURE__*/ requireFeedback();
		const internal = /*@__PURE__*/ requireInternal$1();
		const publicApi = /*@__PURE__*/ requirePublicApi$1();
		const consoleIntegration = /*@__PURE__*/ requireConsoleIntegration();
		const internal$1 = /*@__PURE__*/ requireInternal();
		const publicApi$1 = /*@__PURE__*/ requirePublicApi();
		const consola = /*@__PURE__*/ requireConsola();
		const index = /*@__PURE__*/ requireVercelAi();
		const utils = /*@__PURE__*/ requireUtils$d();
		const constants$6 = /*@__PURE__*/ requireConstants$7();
		const index$5 = /*@__PURE__*/ requireOpenai();
		const constants$5 = /*@__PURE__*/ requireConstants$6();
		const index$2 = /*@__PURE__*/ requireAnthropicAi();
		const constants = /*@__PURE__*/ requireConstants$5();
		const index$4 = /*@__PURE__*/ requireGoogleGenai();
		const constants$2 = /*@__PURE__*/ requireConstants$4();
		const index$1 = /*@__PURE__*/ requireLangchain();
		const utils$1 = /*@__PURE__*/ requireUtils$9();
		const constants$3 = /*@__PURE__*/ requireConstants$3();
		const index$3 = /*@__PURE__*/ requireLanggraph();
		const constants$4 = /*@__PURE__*/ requireConstants$2();
		const spanBuffer = /*@__PURE__*/ requireSpanBuffer();
		const hasSpanStreamingEnabled = /*@__PURE__*/ requireHasSpanStreamingEnabled();
		const spanStreaming = /*@__PURE__*/ requireSpanStreaming();
		const featureFlags = /*@__PURE__*/ requireFeatureFlags();
		const aggregateErrors = /*@__PURE__*/ requireAggregateErrors();
		const breadcrumbLogLevel = /*@__PURE__*/ requireBreadcrumbLogLevel();
		const dsn = /*@__PURE__*/ requireDsn();
		const error = /*@__PURE__*/ requireError();
		const worldwide = /*@__PURE__*/ requireWorldwide();
		const console = /*@__PURE__*/ requireConsole$1();
		const fetch$1 = /*@__PURE__*/ requireFetch$1();
		const globalError = /*@__PURE__*/ requireGlobalError();
		const globalUnhandledRejection = /*@__PURE__*/ requireGlobalUnhandledRejection();
		const handlers = /*@__PURE__*/ requireHandlers$1();
		const is = /*@__PURE__*/ requireIs$1();
		const isBrowser = /*@__PURE__*/ requireIsBrowser();
		const debugLogger = /*@__PURE__*/ requireDebugLogger();
		const misc = /*@__PURE__*/ requireMisc();
		const normalize = /*@__PURE__*/ requireNormalize();
		const normalizationHints = /*@__PURE__*/ requireNormalizationHints();
		const object = /*@__PURE__*/ requireObject();
		const path = /*@__PURE__*/ requirePath();
		const promisebuffer = /*@__PURE__*/ requirePromisebuffer();
		const severity = /*@__PURE__*/ requireSeverity();
		const exports$2 = /*@__PURE__*/ requireExports();
		const stacktrace = /*@__PURE__*/ requireStacktrace();
		const string = /*@__PURE__*/ requireString();
		const supports = /*@__PURE__*/ requireSupports();
		const syncpromise = /*@__PURE__*/ requireSyncpromise();
		const time = /*@__PURE__*/ requireTime();
		const tracing = /*@__PURE__*/ requireTracing();
		const env = /*@__PURE__*/ requireEnv();
		const envelope = /*@__PURE__*/ requireEnvelope$4();
		const clientreport = /*@__PURE__*/ requireClientreport();
		const ratelimit = /*@__PURE__*/ requireRatelimit();
		const baggage = /*@__PURE__*/ requireBaggage();
		const url = /*@__PURE__*/ requireUrl();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder$1();
		const lru = /*@__PURE__*/ requireLru();
		const propagationContext = /*@__PURE__*/ requirePropagationContext();
		const version = /*@__PURE__*/ requireVersion();
		const debugIds = /*@__PURE__*/ requireDebugIds();
		const metadata = /*@__PURE__*/ requireMetadata();
		const escapeStringForRegex = /*@__PURE__*/ requireEscapeStringForRegex();
		const randomSafeContext = /*@__PURE__*/ requireRandomSafeContext();
		const browser = /*@__PURE__*/ requireBrowser$d();
		const embeddings = /*@__PURE__*/ requireEmbeddings();



		exports.registerSpanErrorInstrumentation = errors.registerSpanErrorInstrumentation;
		exports.getCapturedScopesOnSpan = utils$2.getCapturedScopesOnSpan;
		exports.markSpanForOtelSourceInference = utils$2.markSpanForOtelSourceInference;
		exports.setCapturedScopesOnSpan = utils$2.setCapturedScopesOnSpan;
		exports.spanShouldInferOtelSource = utils$2.spanShouldInferOtelSource;
		exports.TRACING_DEFAULTS = idleSpan.TRACING_DEFAULTS;
		exports.startIdleSpan = idleSpan.startIdleSpan;
		exports.SentrySpan = sentrySpan.SentrySpan;
		exports.SentryNonRecordingSpan = sentryNonRecordingSpan.SentryNonRecordingSpan;
		exports.SPAN_STATUS_ERROR = spanstatus.SPAN_STATUS_ERROR;
		exports.SPAN_STATUS_OK = spanstatus.SPAN_STATUS_OK;
		exports.SPAN_STATUS_UNSET = spanstatus.SPAN_STATUS_UNSET;
		exports.getSpanStatusFromHttpCode = spanstatus.getSpanStatusFromHttpCode;
		exports.setHttpStatus = spanstatus.setHttpStatus;
		exports.SUPPRESS_TRACING_KEY = trace.SUPPRESS_TRACING_KEY;
		exports.continueTrace = trace.continueTrace;
		exports.startInactiveSpan = trace.startInactiveSpan;
		exports.startNewTrace = trace.startNewTrace;
		exports.startSpan = trace.startSpan;
		exports.startSpanManual = trace.startSpanManual;
		exports.suppressTracing = trace.suppressTracing;
		exports.withActiveSpan = trace.withActiveSpan;
		exports.bindScopeToEmitter = bindScopeToEmitter.bindScopeToEmitter;
		exports.getDynamicSamplingContextFromClient = dynamicSamplingContext.getDynamicSamplingContextFromClient;
		exports.getDynamicSamplingContextFromScope = dynamicSamplingContext.getDynamicSamplingContextFromScope;
		exports.getDynamicSamplingContextFromSpan = dynamicSamplingContext.getDynamicSamplingContextFromSpan;
		exports.spanToBaggageHeader = dynamicSamplingContext.spanToBaggageHeader;
		exports.setMeasurement = measurement.setMeasurement;
		exports.timedEventsToMeasurements = measurement.timedEventsToMeasurements;
		exports.sampleSpan = sampling.sampleSpan;
		exports.logSpanEnd = logSpans.logSpanEnd;
		exports.logSpanStart = logSpans.logSpanStart;
		exports.captureSpan = captureSpan.captureSpan;
		exports.safeSetSpanJSONAttributes = captureSpan.safeSetSpanJSONAttributes;
		exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = semanticAttributes.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
		exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_HIT;
		exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
		exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_KEY;
		exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
		exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = semanticAttributes.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
		exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
		exports.SEMANTIC_ATTRIBUTE_URL_FULL = semanticAttributes.SEMANTIC_ATTRIBUTE_URL_FULL;
		exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_EMAIL;
		exports.SEMANTIC_ATTRIBUTE_USER_ID = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_ID;
		exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
		exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = semanticAttributes.SEMANTIC_ATTRIBUTE_USER_USERNAME;
		exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = semanticAttributes.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
		exports.createEventEnvelope = envelope$1.createEventEnvelope;
		exports.createSessionEnvelope = envelope$1.createSessionEnvelope;
		exports.createSpanEnvelope = envelope$1.createSpanEnvelope;
		exports.addEventProcessor = exports$1.addEventProcessor;
		exports.captureCheckIn = exports$1.captureCheckIn;
		exports.captureEvent = exports$1.captureEvent;
		exports.captureException = exports$1.captureException;
		exports.captureMessage = exports$1.captureMessage;
		exports.captureSession = exports$1.captureSession;
		exports.close = exports$1.close;
		exports.endSession = exports$1.endSession;
		exports.flush = exports$1.flush;
		exports.isEnabled = exports$1.isEnabled;
		exports.isInitialized = exports$1.isInitialized;
		exports.lastEventId = exports$1.lastEventId;
		exports.setContext = exports$1.setContext;
		exports.setConversationId = exports$1.setConversationId;
		exports.setExtra = exports$1.setExtra;
		exports.setExtras = exports$1.setExtras;
		exports.setTag = exports$1.setTag;
		exports.setTags = exports$1.setTags;
		exports.setUser = exports$1.setUser;
		exports.startSession = exports$1.startSession;
		exports.withMonitor = exports$1.withMonitor;
		exports.getClient = currentScopes.getClient;
		exports.getCurrentScope = currentScopes.getCurrentScope;
		exports.getExternalPropagationContext = currentScopes.getExternalPropagationContext;
		exports.getGlobalScope = currentScopes.getGlobalScope;
		exports.getIsolationScope = currentScopes.getIsolationScope;
		exports.getTraceContextFromScope = currentScopes.getTraceContextFromScope;
		exports.hasExternalPropagationContext = currentScopes.hasExternalPropagationContext;
		exports.registerExternalPropagationContext = currentScopes.registerExternalPropagationContext;
		exports.withIsolationScope = currentScopes.withIsolationScope;
		exports.withScope = currentScopes.withScope;
		exports.getDefaultCurrentScope = defaultScopes.getDefaultCurrentScope;
		exports.getDefaultIsolationScope = defaultScopes.getDefaultIsolationScope;
		exports.setAsyncContextStrategy = index$6.setAsyncContextStrategy;
		exports.getGlobalSingleton = carrier.getGlobalSingleton;
		exports.getMainCarrier = carrier.getMainCarrier;
		exports.closeSession = session.closeSession;
		exports.makeSession = session.makeSession;
		exports.updateSession = session.updateSession;
		exports.Scope = scope.Scope;
		exports.notifyEventProcessors = eventProcessors.notifyEventProcessors;
		exports.SENTRY_API_VERSION = api.SENTRY_API_VERSION;
		exports.getEnvelopeEndpointWithUrlEncodedAuth = api.getEnvelopeEndpointWithUrlEncodedAuth;
		exports.getReportDialogEndpoint = api.getReportDialogEndpoint;
		exports.Client = client.Client;
		exports.initAndBind = sdk.initAndBind;
		exports.setCurrentClient = sdk.setCurrentClient;
		exports.createTransport = base.createTransport;
		exports.makeOfflineTransport = offline.makeOfflineTransport;
		exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = multiplexed.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
		exports.makeMultiplexedTransport = multiplexed.makeMultiplexedTransport;
		exports.addIntegration = integration.addIntegration;
		exports.defineIntegration = integration.defineIntegration;
		exports.getIntegrationsToSetup = integration.getIntegrationsToSetup;
		exports.installedIntegrations = integration.installedIntegrations;
		exports._INTERNAL_clearAiProviderSkips = providerSkip._INTERNAL_clearAiProviderSkips;
		exports._INTERNAL_shouldSkipAiProviderWrapping = providerSkip._INTERNAL_shouldSkipAiProviderWrapping;
		exports._INTERNAL_skipAiProviderWrapping = providerSkip._INTERNAL_skipAiProviderWrapping;
		exports._INTERNAL_filterKeyValueData = filterKeyValueData.filterKeyValueData;
		exports._INTERNAL_filterCookies = filterCookies.filterCookies;
		exports._INTERNAL_filterQueryParams = filterQueryParams.filterQueryParams;
		exports.envToBool = envToBool.envToBool;
		exports.applyScopeDataToEvent = scopeData.applyScopeDataToEvent;
		exports.getCombinedScopeData = scopeData.getCombinedScopeData;
		exports.mergeScopeData = scopeData.mergeScopeData;
		exports.prepareEvent = prepareEvent.prepareEvent;
		exports.createCheckInEnvelope = checkin.createCheckInEnvelope;
		exports.hasSpansEnabled = hasSpansEnabled.hasSpansEnabled;
		exports.isStreamedBeforeSendSpanCallback = beforeSendSpan.isStreamedBeforeSendSpanCallback;
		exports.withStreamedSpan = beforeSendSpan.withStreamedSpan;
		exports.isSentryRequestUrl = isSentryRequestUrl.isSentryRequestUrl;
		exports.handleCallbackErrors = handleCallbackErrors.handleCallbackErrors;
		exports.fmt = parameterize.fmt;
		exports.parameterize = parameterize.parameterize;
		exports.handleTunnelRequest = tunnel.handleTunnelRequest;
		exports.addAutoIpAddressToSession = ipAddress.addAutoIpAddressToSession;
		exports.addAutoIpAddressToUser = ipAddress.addAutoIpAddressToUser;
		exports.INTERNAL_getSegmentSpan = spanUtils.INTERNAL_getSegmentSpan;
		exports.addChildSpanToSpan = spanUtils.addChildSpanToSpan;
		exports.convertSpanLinksForEnvelope = spanUtils.convertSpanLinksForEnvelope;
		exports.getActiveSpan = spanUtils.getActiveSpan;
		exports.getRootSpan = spanUtils.getRootSpan;
		exports.getSpanDescendants = spanUtils.getSpanDescendants;
		exports.getStatusMessage = spanUtils.getStatusMessage;
		exports.spanIsSampled = spanUtils.spanIsSampled;
		exports.spanTimeInputToSeconds = spanUtils.spanTimeInputToSeconds;
		exports.spanToJSON = spanUtils.spanToJSON;
		exports.spanToStreamedSpanJSON = spanUtils.spanToStreamedSpanJSON;
		exports.spanToTraceContext = spanUtils.spanToTraceContext;
		exports.spanToTraceHeader = spanUtils.spanToTraceHeader;
		exports.updateSpanName = spanUtils.updateSpanName;
		exports._INTERNAL_setSpanForScope = spanOnScope._setSpanForScope;
		exports.parseSampleRate = parseSampleRate.parseSampleRate;
		exports.applySdkMetadata = sdkMetadata.applySdkMetadata;
		exports.getTraceData = traceData.getTraceData;
		exports.shouldPropagateTraceForUrl = tracePropagationTargets.shouldPropagateTraceForUrl;
		exports.getTraceMetaTags = meta.getTraceMetaTags;
		exports.debounce = debounce.debounce;
		exports.derefWeakRef = weakRef.derefWeakRef;
		exports.makeWeakRef = weakRef.makeWeakRef;
		exports.shouldIgnoreSpan = shouldIgnoreSpan.shouldIgnoreSpan;
		exports.MAX_BODY_BYTE_LENGTH = request.MAX_BODY_BYTE_LENGTH;
		exports.captureBodyFromWinterCGRequest = request.captureBodyFromWinterCGRequest;
		exports.extractQueryParamsFromUrl = request.extractQueryParamsFromUrl;
		exports.getMaxBodyByteLength = request.getMaxBodyByteLength;
		exports.headersToDict = request.headersToDict;
		exports.httpHeadersToSpanAttributes = request.httpHeadersToSpanAttributes;
		exports.httpRequestToRequestData = request.httpRequestToRequestData;
		exports.winterCGHeadersToDict = request.winterCGHeadersToDict;
		exports.winterCGRequestToRequestData = request.winterCGRequestToRequestData;
		exports.DEFAULT_ENVIRONMENT = constants$1.DEFAULT_ENVIRONMENT;
		exports.DEV_ENVIRONMENT = constants$1.DEV_ENVIRONMENT;
		exports.addBreadcrumb = breadcrumbs.addBreadcrumb;
		exports.functionToStringIntegration = functiontostring.functionToStringIntegration;
		exports.eventFiltersIntegration = eventFilters.eventFiltersIntegration;
		exports.inboundFiltersIntegration = eventFilters.inboundFiltersIntegration;
		exports.linkedErrorsIntegration = linkederrors.linkedErrorsIntegration;
		exports.moduleMetadataIntegration = moduleMetadata.moduleMetadataIntegration;
		exports.requestDataIntegration = requestdata.requestDataIntegration;
		exports.captureConsoleIntegration = captureconsole.captureConsoleIntegration;
		exports.dedupeIntegration = dedupe.dedupeIntegration;
		exports.extraErrorDataIntegration = extraerrordata.extraErrorDataIntegration;
		exports.rewriteFramesIntegration = rewriteframes.rewriteFramesIntegration;
		exports.instrumentSupabaseClient = supabase.instrumentSupabaseClient;
		exports.supabaseIntegration = supabase.supabaseIntegration;
		exports.zodErrorsIntegration = zoderrors.zodErrorsIntegration;
		exports.thirdPartyErrorFilterIntegration = thirdPartyErrorsFilter.thirdPartyErrorFilterIntegration;
		exports.consoleIntegration = console$1.consoleIntegration;
		exports.featureFlagsIntegration = featureFlagsIntegration.featureFlagsIntegration;
		exports.growthbookIntegration = growthbook.growthbookIntegration;
		exports.conversationIdIntegration = conversationId.conversationIdIntegration;
		exports.profiler = profiling.profiler;
		exports._INTERNAL_getTracingHeadersForFetchRequest = fetch._INTERNAL_getTracingHeadersForFetchRequest;
		exports.instrumentFetchRequest = fetch.instrumentFetchRequest;
		exports.captureFeedback = feedback.captureFeedback;
		exports._INTERNAL_captureLog = internal._INTERNAL_captureLog;
		exports._INTERNAL_captureSerializedLog = internal._INTERNAL_captureSerializedLog;
		exports._INTERNAL_flushLogsBuffer = internal._INTERNAL_flushLogsBuffer;
		exports.logger = publicApi;
		exports.consoleLoggingIntegration = consoleIntegration.consoleLoggingIntegration;
		exports._INTERNAL_captureMetric = internal$1._INTERNAL_captureMetric;
		exports._INTERNAL_captureSerializedMetric = internal$1._INTERNAL_captureSerializedMetric;
		exports._INTERNAL_flushMetricsBuffer = internal$1._INTERNAL_flushMetricsBuffer;
		exports.metrics = publicApi$1;
		exports.createConsolaReporter = consola.createConsolaReporter;
		exports.addVercelAiProcessors = index.addVercelAiProcessors;
		exports._INTERNAL_cleanupToolCallSpanContext = utils._INTERNAL_cleanupToolCallSpanContext;
		exports._INTERNAL_getSpanContextForToolCallId = utils._INTERNAL_getSpanContextForToolCallId;
		exports._INTERNAL_toolCallSpanContextMap = constants$6.toolCallSpanContextMap;
		exports.instrumentOpenAiClient = index$5.instrumentOpenAiClient;
		exports.OPENAI_INTEGRATION_NAME = constants$5.OPENAI_INTEGRATION_NAME;
		exports.instrumentAnthropicAiClient = index$2.instrumentAnthropicAiClient;
		exports.ANTHROPIC_AI_INTEGRATION_NAME = constants.ANTHROPIC_AI_INTEGRATION_NAME;
		exports.instrumentGoogleGenAIClient = index$4.instrumentGoogleGenAIClient;
		exports.GOOGLE_GENAI_INTEGRATION_NAME = constants$2.GOOGLE_GENAI_INTEGRATION_NAME;
		exports.createLangChainCallbackHandler = index$1.createLangChainCallbackHandler;
		exports._INTERNAL_mergeLangChainCallbackHandler = utils$1._INTERNAL_mergeLangChainCallbackHandler;
		exports.LANGCHAIN_INTEGRATION_NAME = constants$3.LANGCHAIN_INTEGRATION_NAME;
		exports.instrumentCreateReactAgent = index$3.instrumentCreateReactAgent;
		exports.instrumentLangGraph = index$3.instrumentLangGraph;
		exports.instrumentStateGraphCompile = index$3.instrumentStateGraphCompile;
		exports.LANGGRAPH_INTEGRATION_NAME = constants$4.LANGGRAPH_INTEGRATION_NAME;
		exports.SpanBuffer = spanBuffer.SpanBuffer;
		exports.hasSpanStreamingEnabled = hasSpanStreamingEnabled.hasSpanStreamingEnabled;
		exports.spanStreamingIntegration = spanStreaming.spanStreamingIntegration;
		exports._INTERNAL_FLAG_BUFFER_SIZE = featureFlags._INTERNAL_FLAG_BUFFER_SIZE;
		exports._INTERNAL_MAX_FLAGS_PER_SPAN = featureFlags._INTERNAL_MAX_FLAGS_PER_SPAN;
		exports._INTERNAL_addFeatureFlagToActiveSpan = featureFlags._INTERNAL_addFeatureFlagToActiveSpan;
		exports._INTERNAL_copyFlagsFromScopeToEvent = featureFlags._INTERNAL_copyFlagsFromScopeToEvent;
		exports._INTERNAL_insertFlagToScope = featureFlags._INTERNAL_insertFlagToScope;
		exports.applyAggregateErrorsToEvent = aggregateErrors.applyAggregateErrorsToEvent;
		exports.getBreadcrumbLogLevelFromHttpStatusCode = breadcrumbLogLevel.getBreadcrumbLogLevelFromHttpStatusCode;
		exports.dsnFromString = dsn.dsnFromString;
		exports.dsnToString = dsn.dsnToString;
		exports.makeDsn = dsn.makeDsn;
		exports.SentryError = error.SentryError;
		exports.GLOBAL_OBJ = worldwide.GLOBAL_OBJ;
		exports.addConsoleInstrumentationFilter = console.addConsoleInstrumentationFilter;
		exports.addConsoleInstrumentationHandler = console.addConsoleInstrumentationHandler;
		exports.addFetchEndInstrumentationHandler = fetch$1.addFetchEndInstrumentationHandler;
		exports.addFetchInstrumentationHandler = fetch$1.addFetchInstrumentationHandler;
		exports.addGlobalErrorInstrumentationHandler = globalError.addGlobalErrorInstrumentationHandler;
		exports.addGlobalUnhandledRejectionInstrumentationHandler = globalUnhandledRejection.addGlobalUnhandledRejectionInstrumentationHandler;
		exports.addHandler = handlers.addHandler;
		exports.maybeInstrument = handlers.maybeInstrument;
		exports.resetInstrumentationHandlers = handlers.resetInstrumentationHandlers;
		exports.triggerHandlers = handlers.triggerHandlers;
		exports.isDOMError = is.isDOMError;
		exports.isDOMException = is.isDOMException;
		exports.isElement = is.isElement;
		exports.isError = is.isError;
		exports.isErrorEvent = is.isErrorEvent;
		exports.isEvent = is.isEvent;
		exports.isInstanceOf = is.isInstanceOf;
		exports.isParameterizedString = is.isParameterizedString;
		exports.isPlainObject = is.isPlainObject;
		exports.isPrimitive = is.isPrimitive;
		exports.isRegExp = is.isRegExp;
		exports.isString = is.isString;
		exports.isSyntheticEvent = is.isSyntheticEvent;
		exports.isThenable = is.isThenable;
		exports.isVueViewModel = is.isVueViewModel;
		exports.isBrowser = isBrowser.isBrowser;
		exports.CONSOLE_LEVELS = debugLogger.CONSOLE_LEVELS;
		exports.consoleSandbox = debugLogger.consoleSandbox;
		exports.debug = debugLogger.debug;
		exports.originalConsoleMethods = debugLogger.originalConsoleMethods;
		exports.addContextToFrame = misc.addContextToFrame;
		exports.addExceptionMechanism = misc.addExceptionMechanism;
		exports.addExceptionTypeValue = misc.addExceptionTypeValue;
		exports.checkOrSetAlreadyCaught = misc.checkOrSetAlreadyCaught;
		exports.getEventDescription = misc.getEventDescription;
		exports.isAlreadyCaptured = misc.isAlreadyCaptured;
		exports.parseSemver = misc.parseSemver;
		exports.uuid4 = misc.uuid4;
		exports.normalize = normalize.normalize;
		exports.normalizeToSize = normalize.normalizeToSize;
		exports.normalizeUrlToBase = normalize.normalizeUrlToBase;
		exports.setNormalizeStringifier = normalize.setNormalizeStringifier;
		exports.setNormalizationDepthOverrideHint = normalizationHints.setNormalizationDepthOverrideHint;
		exports.setSkipNormalizationHint = normalizationHints.setSkipNormalizationHint;
		exports.addNonEnumerableProperty = object.addNonEnumerableProperty;
		exports.convertToPlainObject = object.convertToPlainObject;
		exports.dropUndefinedKeys = object.dropUndefinedKeys;
		exports.extractExceptionKeysForMessage = object.extractExceptionKeysForMessage;
		exports.fill = object.fill;
		exports.getOriginalFunction = object.getOriginalFunction;
		exports.markFunctionWrapped = object.markFunctionWrapped;
		exports.objectify = object.objectify;
		exports.basename = path.basename;
		exports.dirname = path.dirname;
		exports.isAbsolute = path.isAbsolute;
		exports.join = path.join;
		exports.normalizePath = path.normalizePath;
		exports.relative = path.relative;
		exports.resolve = path.resolve;
		exports.SENTRY_BUFFER_FULL_ERROR = promisebuffer.SENTRY_BUFFER_FULL_ERROR;
		exports.makePromiseBuffer = promisebuffer.makePromiseBuffer;
		exports.severityLevelFromString = severity.severityLevelFromString;
		exports.replaceExports = exports$2.replaceExports;
		exports.UNKNOWN_FUNCTION = stacktrace.UNKNOWN_FUNCTION;
		exports.createStackParser = stacktrace.createStackParser;
		exports.getFramesFromEvent = stacktrace.getFramesFromEvent;
		exports.getFunctionName = stacktrace.getFunctionName;
		exports.stackParserFromStackParserOptions = stacktrace.stackParserFromStackParserOptions;
		exports.stripSentryFramesAndReverse = stacktrace.stripSentryFramesAndReverse;
		exports.isMatchingPattern = string.isMatchingPattern;
		exports.safeJoin = string.safeJoin;
		exports.snipLine = string.snipLine;
		exports.stringMatchesSomePattern = string.stringMatchesSomePattern;
		exports.truncate = string.truncate;
		exports.isNativeFunction = supports.isNativeFunction;
		exports.supportsDOMError = supports.supportsDOMError;
		exports.supportsDOMException = supports.supportsDOMException;
		exports.supportsErrorEvent = supports.supportsErrorEvent;
		exports.supportsFetch = supports.supportsFetch;
		exports.supportsHistory = supports.supportsHistory;
		exports.supportsNativeFetch = supports.supportsNativeFetch;
		exports.supportsReferrerPolicy = supports.supportsReferrerPolicy;
		exports.supportsReportingObserver = supports.supportsReportingObserver;
		exports.SyncPromise = syncpromise.SyncPromise;
		exports.rejectedSyncPromise = syncpromise.rejectedSyncPromise;
		exports.resolvedSyncPromise = syncpromise.resolvedSyncPromise;
		exports.browserPerformanceTimeOrigin = time.browserPerformanceTimeOrigin;
		exports.dateTimestampInSeconds = time.dateTimestampInSeconds;
		exports.timestampInSeconds = time.timestampInSeconds;
		exports.TRACEPARENT_REGEXP = tracing.TRACEPARENT_REGEXP;
		exports.extractTraceparentData = tracing.extractTraceparentData;
		exports.generateSentryTraceHeader = tracing.generateSentryTraceHeader;
		exports.generateTraceparentHeader = tracing.generateTraceparentHeader;
		exports.propagationContextFromHeaders = tracing.propagationContextFromHeaders;
		exports.shouldContinueTrace = tracing.shouldContinueTrace;
		exports.getSDKSource = env.getSDKSource;
		exports.isBrowserBundle = env.isBrowserBundle;
		exports.addItemToEnvelope = envelope.addItemToEnvelope;
		exports.createAttachmentEnvelopeItem = envelope.createAttachmentEnvelopeItem;
		exports.createEnvelope = envelope.createEnvelope;
		exports.createEventEnvelopeHeaders = envelope.createEventEnvelopeHeaders;
		exports.createSpanEnvelopeItem = envelope.createSpanEnvelopeItem;
		exports.envelopeContainsItemType = envelope.envelopeContainsItemType;
		exports.envelopeItemTypeToDataCategory = envelope.envelopeItemTypeToDataCategory;
		exports.forEachEnvelopeItem = envelope.forEachEnvelopeItem;
		exports.getSdkMetadataForEnvelopeHeader = envelope.getSdkMetadataForEnvelopeHeader;
		exports.parseEnvelope = envelope.parseEnvelope;
		exports.serializeEnvelope = envelope.serializeEnvelope;
		exports.createClientReportEnvelope = clientreport.createClientReportEnvelope;
		exports.DEFAULT_RETRY_AFTER = ratelimit.DEFAULT_RETRY_AFTER;
		exports.disabledUntil = ratelimit.disabledUntil;
		exports.isRateLimited = ratelimit.isRateLimited;
		exports.parseRetryAfterHeader = ratelimit.parseRetryAfterHeader;
		exports.updateRateLimits = ratelimit.updateRateLimits;
		exports.MAX_BAGGAGE_STRING_LENGTH = baggage.MAX_BAGGAGE_STRING_LENGTH;
		exports.SENTRY_BAGGAGE_KEY_PREFIX = baggage.SENTRY_BAGGAGE_KEY_PREFIX;
		exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = baggage.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
		exports.baggageHeaderToDynamicSamplingContext = baggage.baggageHeaderToDynamicSamplingContext;
		exports.dynamicSamplingContextToSentryBaggageHeader = baggage.dynamicSamplingContextToSentryBaggageHeader;
		exports.mergeBaggageHeaders = baggage.mergeBaggageHeaders;
		exports.objectToBaggageHeader = baggage.objectToBaggageHeader;
		exports.parseBaggageHeader = baggage.parseBaggageHeader;
		exports.getHttpSpanDetailsFromUrlObject = url.getHttpSpanDetailsFromUrlObject;
		exports.getSanitizedUrlString = url.getSanitizedUrlString;
		exports.getSanitizedUrlStringFromUrlObject = url.getSanitizedUrlStringFromUrlObject;
		exports.isURLObjectRelative = url.isURLObjectRelative;
		exports.parseStringToURLObject = url.parseStringToURLObject;
		exports.parseUrl = url.parseUrl;
		exports.stripDataUrlContent = url.stripDataUrlContent;
		exports.stripUrlQueryAndFragment = url.stripUrlQueryAndFragment;
		exports._INTERNAL_enhanceErrorWithSentryInfo = eventbuilder._enhanceErrorWithSentryInfo;
		exports.eventFromMessage = eventbuilder.eventFromMessage;
		exports.eventFromUnknownInput = eventbuilder.eventFromUnknownInput;
		exports.exceptionFromError = eventbuilder.exceptionFromError;
		exports.parseStackFrames = eventbuilder.parseStackFrames;
		exports.LRUMap = lru.LRUMap;
		exports.generateSpanId = propagationContext.generateSpanId;
		exports.generateTraceId = propagationContext.generateTraceId;
		exports.SDK_VERSION = version.SDK_VERSION;
		exports.getDebugImagesForResources = debugIds.getDebugImagesForResources;
		exports.getFilenameToDebugIdMap = debugIds.getFilenameToDebugIdMap;
		exports.getFilenameToMetadataMap = metadata.getFilenameToMetadataMap;
		exports.escapeStringForRegex = escapeStringForRegex.escapeStringForRegex;
		exports._INTERNAL_safeDateNow = randomSafeContext.safeDateNow;
		exports._INTERNAL_safeMathRandom = randomSafeContext.safeMathRandom;
		exports._INTERNAL_withRandomSafeContext = randomSafeContext.withRandomSafeContext;
		exports.getComponentName = browser.getComponentName;
		exports.getLocationHref = browser.getLocationHref;
		exports.htmlTreeAsString = browser.htmlTreeAsString;
		exports.instrumentLangChainEmbeddings = embeddings.instrumentLangChainEmbeddings;
		
	} (browser$c));
	return browser$c;
}

var helpers = {};

var hasRequiredHelpers;

function requireHelpers () {
	if (hasRequiredHelpers) return helpers;
	hasRequiredHelpers = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const WINDOW = browser.GLOBAL_OBJ;
		let ignoreOnError = 0;
		function shouldIgnoreOnError() {
		  return ignoreOnError > 0;
		}
		function ignoreNextOnError() {
		  ignoreOnError++;
		  setTimeout(() => {
		    ignoreOnError--;
		  });
		}
		function wrap(fn, options = {}) {
		  function isFunction(fn2) {
		    return typeof fn2 === "function";
		  }
		  if (!isFunction(fn)) {
		    return fn;
		  }
		  try {
		    const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
		    if (hasOwnWrapper) {
		      const wrapper = fn.__sentry_wrapped__;
		      if (typeof wrapper === "function") {
		        return wrapper;
		      } else {
		        return fn;
		      }
		    }
		    if (browser.getOriginalFunction(fn)) {
		      return fn;
		    }
		  } catch {
		    return fn;
		  }
		  const sentryWrapped = function(...args) {
		    browser.GLOBAL_OBJ._sentryWrappedDepth = (browser.GLOBAL_OBJ._sentryWrappedDepth || 0) + 1;
		    try {
		      const wrappedArguments = args.map((arg) => wrap(arg, options));
		      return fn.apply(this, wrappedArguments);
		    } catch (ex) {
		      ignoreNextOnError();
		      browser.withScope((scope) => {
		        scope.addEventProcessor((event) => {
		          if (options.mechanism) {
		            browser.addExceptionTypeValue(event, void 0, void 0);
		            browser.addExceptionMechanism(event, options.mechanism);
		          }
		          event.extra = {
		            ...event.extra,
		            arguments: args
		          };
		          return event;
		        });
		        browser.captureException(ex);
		      });
		      throw ex;
		    } finally {
		      browser.GLOBAL_OBJ._sentryWrappedDepth = (browser.GLOBAL_OBJ._sentryWrappedDepth || 0) - 1;
		    }
		  };
		  try {
		    for (const property in fn) {
		      if (Object.prototype.hasOwnProperty.call(fn, property)) {
		        sentryWrapped[property] = fn[property];
		      }
		    }
		  } catch {
		  }
		  browser.markFunctionWrapped(sentryWrapped, fn);
		  browser.addNonEnumerableProperty(fn, "__sentry_wrapped__", sentryWrapped);
		  try {
		    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
		    if (descriptor.configurable) {
		      Object.defineProperty(sentryWrapped, "name", {
		        get() {
		          return fn.name;
		        }
		      });
		    }
		  } catch {
		  }
		  return sentryWrapped;
		}
		function getHttpRequestData() {
		  const url = browser.getLocationHref();
		  const { referrer } = WINDOW.document || {};
		  const { userAgent } = WINDOW.navigator || {};
		  const headers = {
		    ...referrer && { Referer: referrer },
		    ...userAgent && { "User-Agent": userAgent }
		  };
		  const request = {
		    url,
		    headers
		  };
		  return request;
		}

		exports.WINDOW = WINDOW;
		exports.getHttpRequestData = getHttpRequestData;
		exports.ignoreNextOnError = ignoreNextOnError;
		exports.shouldIgnoreOnError = shouldIgnoreOnError;
		exports.wrap = wrap;
		
	} (helpers));
	return helpers;
}

var hasRequiredLazyLoadIntegration;

function requireLazyLoadIntegration () {
	if (hasRequiredLazyLoadIntegration) return lazyLoadIntegration;
	hasRequiredLazyLoadIntegration = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const helpers = /*@__PURE__*/ requireHelpers();

		const LAZY_LOADABLE_NAMES = [
		  "replayIntegration",
		  "replayCanvasIntegration",
		  "feedbackIntegration",
		  "feedbackModalIntegration",
		  "feedbackScreenshotIntegration",
		  "captureConsoleIntegration",
		  "contextLinesIntegration",
		  "linkedErrorsIntegration",
		  "dedupeIntegration",
		  "extraErrorDataIntegration",
		  "graphqlClientIntegration",
		  "httpClientIntegration",
		  "reportingObserverIntegration",
		  "rewriteFramesIntegration",
		  "browserProfilingIntegration",
		  "moduleMetadataIntegration",
		  "instrumentAnthropicAiClient",
		  "instrumentOpenAiClient",
		  "instrumentGoogleGenAIClient",
		  "instrumentLangGraph",
		  "createLangChainCallbackHandler",
		  "instrumentLangChainEmbeddings"
		];
		const HYPHENATED_BUNDLES = {
		  replayCanvasIntegration: "replay-canvas",
		  feedbackModalIntegration: "feedback-modal",
		  feedbackScreenshotIntegration: "feedback-screenshot"
		};
		function getBundleName(name) {
		  return HYPHENATED_BUNDLES[name] || name.replace("Integration", "").toLowerCase();
		}
		const WindowWithMaybeIntegration = helpers.WINDOW;
		async function lazyLoadIntegration(name, scriptNonce) {
		  const bundle = LAZY_LOADABLE_NAMES.includes(name) ? getBundleName(name) : void 0;
		  const sentryOnWindow = WindowWithMaybeIntegration.Sentry = WindowWithMaybeIntegration.Sentry || {};
		  if (!bundle) {
		    throw new Error(`Cannot lazy load integration: ${name}`);
		  }
		  const existing = sentryOnWindow[name];
		  if (typeof existing === "function" && !("_isShim" in existing)) {
		    return existing;
		  }
		  const url = getScriptURL(bundle);
		  const script = helpers.WINDOW.document.createElement("script");
		  script.src = url;
		  script.crossOrigin = "anonymous";
		  script.referrerPolicy = "strict-origin";
		  if (scriptNonce) {
		    script.setAttribute("nonce", scriptNonce);
		  }
		  const waitForLoad = new Promise((resolve, reject) => {
		    script.addEventListener("load", () => resolve());
		    script.addEventListener("error", reject);
		  });
		  const currentScript = helpers.WINDOW.document.currentScript;
		  const parent = helpers.WINDOW.document.body || helpers.WINDOW.document.head || currentScript?.parentElement;
		  if (parent) {
		    parent.appendChild(script);
		  } else {
		    throw new Error(`Could not find parent element to insert lazy-loaded ${name} script`);
		  }
		  try {
		    await waitForLoad;
		  } catch {
		    throw new Error(`Error when loading integration: ${name}`);
		  }
		  const integrationFn = sentryOnWindow[name];
		  if (typeof integrationFn !== "function") {
		    throw new Error(`Could not load integration: ${name}`);
		  }
		  return integrationFn;
		}
		function getScriptURL(bundle) {
		  const client = browser.getClient();
		  const baseURL = client?.getOptions()?.cdnBaseUrl || "https://browser.sentry-cdn.com";
		  return new URL(`/${browser.SDK_VERSION}/${bundle}.min.js`, baseURL).toString();
		}

		exports.lazyLoadIntegration = lazyLoadIntegration;
		
	} (lazyLoadIntegration));
	return lazyLoadIntegration;
}

var hasRequiredFeedbackAsync;

function requireFeedbackAsync () {
	if (hasRequiredFeedbackAsync) return feedbackAsync;
	hasRequiredFeedbackAsync = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const feedback = /*@__PURE__*/ requireCjs$3();
		const lazyLoadIntegration = /*@__PURE__*/ requireLazyLoadIntegration();

		const feedbackAsyncIntegration = feedback.buildFeedbackIntegration({
		  lazyLoadIntegration: lazyLoadIntegration.lazyLoadIntegration
		});

		exports.feedbackAsyncIntegration = feedbackAsyncIntegration;
		
	} (feedbackAsync));
	return feedbackAsync;
}

var feedbackSync = {};

var hasRequiredFeedbackSync;

function requireFeedbackSync () {
	if (hasRequiredFeedbackSync) return feedbackSync;
	hasRequiredFeedbackSync = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const feedback = /*@__PURE__*/ requireCjs$3();

		const feedbackSyncIntegration = feedback.buildFeedbackIntegration({
		  getModalIntegration: () => feedback.feedbackModalIntegration,
		  getScreenshotIntegration: () => feedback.feedbackScreenshotIntegration
		});

		exports.feedbackSyncIntegration = feedbackSyncIntegration;
		
	} (feedbackSync));
	return feedbackSync;
}

var client = {};

var eventbuilder = {};

var hasRequiredEventbuilder;

function requireEventbuilder () {
	if (hasRequiredEventbuilder) return eventbuilder;
	hasRequiredEventbuilder = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		function exceptionFromError(stackParser, ex) {
		  const frames = parseStackFrames(stackParser, ex);
		  const exception = {
		    type: extractType(ex),
		    value: extractMessage(ex)
		  };
		  if (frames.length) {
		    exception.stacktrace = { frames };
		  }
		  if (exception.type === void 0 && exception.value === "") {
		    exception.value = "Unrecoverable error caught";
		  }
		  return exception;
		}
		function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
		  const client = browser.getClient();
		  const normalizeDepth = client?.getOptions().normalizeDepth;
		  const errorFromProp = getErrorPropertyFromObject(exception);
		  const extra = {
		    __serialized__: browser.normalizeToSize(exception, normalizeDepth)
		  };
		  if (errorFromProp) {
		    return {
		      exception: {
		        values: [exceptionFromError(stackParser, errorFromProp)]
		      },
		      extra
		    };
		  }
		  const event = {
		    exception: {
		      values: [
		        {
		          type: browser.isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
		          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection })
		        }
		      ]
		    },
		    extra
		  };
		  if (syntheticException) {
		    const frames = parseStackFrames(stackParser, syntheticException);
		    if (frames.length) {
		      event.exception.values[0].stacktrace = { frames };
		    }
		  }
		  return event;
		}
		function eventFromError(stackParser, ex) {
		  return {
		    exception: {
		      values: [exceptionFromError(stackParser, ex)]
		    }
		  };
		}
		function parseStackFrames(stackParser, ex) {
		  const stacktrace = ex.stacktrace || ex.stack || "";
		  const skipLines = getSkipFirstStackStringLines(ex);
		  const framesToPop = getPopFirstTopFrames(ex);
		  try {
		    return stackParser(stacktrace, skipLines, framesToPop);
		  } catch {
		  }
		  return [];
		}
		const reactMinifiedRegexp = /Minified React error #\d+;/i;
		function getSkipFirstStackStringLines(ex) {
		  if (ex && reactMinifiedRegexp.test(ex.message)) {
		    return 1;
		  }
		  return 0;
		}
		function getPopFirstTopFrames(ex) {
		  if (typeof ex.framesToPop === "number") {
		    return ex.framesToPop;
		  }
		  return 0;
		}
		function isWebAssemblyException(exception) {
		  if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") {
		    return exception instanceof WebAssembly.Exception;
		  } else {
		    return false;
		  }
		}
		function extractType(ex) {
		  const name = ex?.name;
		  if (!name && isWebAssemblyException(ex)) {
		    const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
		    return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
		  }
		  return name;
		}
		function extractMessage(ex) {
		  const message = ex?.message;
		  if (isWebAssemblyException(ex)) {
		    if (Array.isArray(ex.message) && ex.message.length == 2) {
		      return ex.message[1];
		    }
		    return "wasm exception";
		  }
		  if (!message) {
		    return "No error message";
		  }
		  if (message.error && typeof message.error.message === "string") {
		    return browser._INTERNAL_enhanceErrorWithSentryInfo(message.error);
		  }
		  return browser._INTERNAL_enhanceErrorWithSentryInfo(ex);
		}
		function eventFromException(stackParser, exception, hint, attachStacktrace) {
		  const syntheticException = hint?.syntheticException || void 0;
		  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
		  browser.addExceptionMechanism(event);
		  event.level = "error";
		  if (hint?.event_id) {
		    event.event_id = hint.event_id;
		  }
		  return browser.resolvedSyncPromise(event);
		}
		function eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
		  const syntheticException = hint?.syntheticException || void 0;
		  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
		  event.level = level;
		  if (hint?.event_id) {
		    event.event_id = hint.event_id;
		  }
		  return browser.resolvedSyncPromise(event);
		}
		function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
		  let event;
		  if (browser.isErrorEvent(exception) && exception.error) {
		    const errorEvent = exception;
		    return eventFromError(stackParser, errorEvent.error);
		  }
		  if (browser.isDOMError(exception) || browser.isDOMException(exception)) {
		    const domException = exception;
		    if ("stack" in exception) {
		      event = eventFromError(stackParser, exception);
		      const firstException = event.exception?.values?.[0];
		      if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
		        const frames = parseStackFrames(stackParser, syntheticException);
		        if (frames.length) {
		          firstException.stacktrace = { frames };
		          browser.addExceptionMechanism(event, { synthetic: true });
		        }
		      }
		    } else {
		      const name = domException.name || (browser.isDOMError(domException) ? "DOMError" : "DOMException");
		      const message = domException.message ? `${name}: ${domException.message}` : name;
		      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
		      browser.addExceptionTypeValue(event, message);
		    }
		    if ("code" in domException) {
		      event.tags = { ...event.tags, "DOMException.code": `${domException.code}` };
		    }
		    return event;
		  }
		  if (browser.isError(exception)) {
		    return eventFromError(stackParser, exception);
		  }
		  if (browser.isPlainObject(exception) || browser.isEvent(exception)) {
		    const objectException = exception;
		    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
		    browser.addExceptionMechanism(event, {
		      synthetic: true
		    });
		    return event;
		  }
		  event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
		  browser.addExceptionTypeValue(event, `${exception}`, void 0);
		  browser.addExceptionMechanism(event, {
		    synthetic: true
		  });
		  return event;
		}
		function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
		  const event = {};
		  if (attachStacktrace && syntheticException) {
		    const frames = parseStackFrames(stackParser, syntheticException);
		    if (frames.length) {
		      event.exception = {
		        values: [{ value: message, stacktrace: { frames } }]
		      };
		    }
		    browser.addExceptionMechanism(event, { synthetic: true });
		  }
		  if (browser.isParameterizedString(message)) {
		    const { __sentry_template_string__, __sentry_template_values__ } = message;
		    event.logentry = {
		      message: __sentry_template_string__,
		      params: __sentry_template_values__
		    };
		    return event;
		  }
		  event.message = message;
		  return event;
		}
		function getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }) {
		  const keys = browser.extractExceptionKeysForMessage(exception);
		  const captureType = isUnhandledRejection ? "promise rejection" : "exception";
		  if (browser.isErrorEvent(exception)) {
		    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
		  }
		  if (browser.isEvent(exception)) {
		    const className = getObjectClassName(exception);
		    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
		  }
		  return `Object captured as ${captureType} with keys: ${keys}`;
		}
		function getObjectClassName(obj) {
		  try {
		    const prototype = Object.getPrototypeOf(obj);
		    return prototype ? prototype.constructor.name : void 0;
		  } catch {
		  }
		}
		function getErrorPropertyFromObject(obj) {
		  return Object.values(obj).find((v) => v instanceof Error);
		}

		exports.eventFromException = eventFromException;
		exports.eventFromMessage = eventFromMessage;
		exports.eventFromUnknownInput = eventFromUnknownInput;
		exports.exceptionFromError = exceptionFromError;
		exports.extractMessage = extractMessage;
		exports.extractType = extractType;
		
	} (eventbuilder));
	return eventbuilder;
}

var hasRequiredClient;

function requireClient () {
	if (hasRequiredClient) return client;
	hasRequiredClient = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder();
		const helpers = /*@__PURE__*/ requireHelpers();

		class BrowserClient extends browser.Client {
		  /**
		   * Creates a new Browser SDK instance.
		   *
		   * @param options Configuration options for this SDK.
		   */
		  constructor(options) {
		    const opts = applyDefaultOptions(options);
		    const sdkSource = helpers.WINDOW.SENTRY_SDK_SOURCE || browser.getSDKSource();
		    browser.applySdkMetadata(opts, "browser", ["browser"], sdkSource);
		    super(opts);
		    const { userInfo } = this.getDataCollectionOptions();
		    if (opts._metadata?.sdk) {
		      opts._metadata.sdk.settings = {
		        // Only allow IP inferral by Relay if the user opted in via dataCollection
		        infer_ip: userInfo ? "auto" : "never",
		        // purposefully allowing already passed settings to override the default
		        ...opts._metadata.sdk.settings
		      };
		    }
		    const { sendClientReports, enableLogs, _experiments, enableMetrics: enableMetricsOption } = this._options;
		    const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
		    if (helpers.WINDOW.document && (sendClientReports || enableLogs || enableMetrics)) {
		      helpers.WINDOW.document.addEventListener("visibilitychange", () => {
		        if (helpers.WINDOW.document.visibilityState === "hidden") {
		          if (sendClientReports) {
		            this._flushOutcomes();
		          }
		          if (enableLogs) {
		            browser._INTERNAL_flushLogsBuffer(this);
		          }
		          if (enableMetrics) {
		            browser._INTERNAL_flushMetricsBuffer(this);
		          }
		        }
		      });
		    }
		    if (userInfo) {
		      this.on("beforeSendSession", browser.addAutoIpAddressToSession);
		    }
		  }
		  /**
		   * @inheritDoc
		   */
		  eventFromException(exception, hint) {
		    return eventbuilder.eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
		  }
		  /**
		   * @inheritDoc
		   */
		  eventFromMessage(message, level = "info", hint) {
		    return eventbuilder.eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
		  }
		  /**
		   * @inheritDoc
		   */
		  _prepareEvent(event, hint, currentScope, isolationScope) {
		    event.platform = event.platform || "javascript";
		    return super._prepareEvent(event, hint, currentScope, isolationScope);
		  }
		}
		function applyDefaultOptions(optionsArg) {
		  return {
		    release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : helpers.WINDOW.SENTRY_RELEASE?.id,
		    // This supports the variable that sentry-webpack-plugin injects
		    sendClientReports: true,
		    // We default this to true, as it is the safer scenario
		    parentSpanIsAlwaysRootSpan: true,
		    ...optionsArg
		  };
		}

		exports.BrowserClient = BrowserClient;
		exports.applyDefaultOptions = applyDefaultOptions;
		
	} (client));
	return client;
}

var fetch$1 = {};

var cjs$2 = {};

var instrument = {};

var debugBuild$1 = {};

var hasRequiredDebugBuild$1;

function requireDebugBuild$1 () {
	if (hasRequiredDebugBuild$1) return debugBuild$1;
	hasRequiredDebugBuild$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

		exports.DEBUG_BUILD = DEBUG_BUILD;
		
	} (debugBuild$1));
	return debugBuild$1;
}

var getCLS = {};

var types = {};

var hasRequiredTypes;

function requireTypes () {
	if (hasRequiredTypes) return types;
	hasRequiredTypes = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();

		const WINDOW = core.GLOBAL_OBJ;

		exports.WINDOW = WINDOW;
		
	} (types));
	return types;
}

var bindReporter = {};

var hasRequiredBindReporter;

function requireBindReporter () {
	if (hasRequiredBindReporter) return bindReporter;
	hasRequiredBindReporter = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const getRating = (value, thresholds) => {
		  if (value > thresholds[1]) {
		    return "poor";
		  }
		  if (value > thresholds[0]) {
		    return "needs-improvement";
		  }
		  return "good";
		};
		const bindReporter = (callback, metric, thresholds, reportAllChanges) => {
		  let prevValue;
		  let delta;
		  return (forceReport) => {
		    if (metric.value >= 0) {
		      if (forceReport || reportAllChanges) {
		        delta = metric.value - (prevValue ?? 0);
		        if (delta || prevValue === void 0) {
		          prevValue = metric.value;
		          metric.delta = delta;
		          metric.rating = getRating(metric.value, thresholds);
		          callback(metric);
		        }
		      }
		    }
		  };
		};

		exports.bindReporter = bindReporter;
		
	} (bindReporter));
	return bindReporter;
}

var getVisibilityWatcher = {};

var getActivationStart = {};

var getNavigationEntry = {};

var hasRequiredGetNavigationEntry;

function requireGetNavigationEntry () {
	if (hasRequiredGetNavigationEntry) return getNavigationEntry;
	hasRequiredGetNavigationEntry = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();

		const getNavigationEntry = (checkResponseStart = true) => {
		  const navigationEntry = types.WINDOW.performance?.getEntriesByType?.("navigation")[0];
		  if (
		    // sentry-specific change:
		    // We don't want to check for responseStart for our own use of `getNavigationEntry`
		    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()
		  ) {
		    return navigationEntry;
		  }
		};

		exports.getNavigationEntry = getNavigationEntry;
		
	} (getNavigationEntry));
	return getNavigationEntry;
}

var hasRequiredGetActivationStart;

function requireGetActivationStart () {
	if (hasRequiredGetActivationStart) return getActivationStart;
	hasRequiredGetActivationStart = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const getNavigationEntry = /*@__PURE__*/ requireGetNavigationEntry();

		const getActivationStart = () => {
		  const navEntry = getNavigationEntry.getNavigationEntry();
		  return navEntry?.activationStart ?? 0;
		};

		exports.getActivationStart = getActivationStart;
		
	} (getActivationStart));
	return getActivationStart;
}

var globalListeners = {};

var hasRequiredGlobalListeners;

function requireGlobalListeners () {
	if (hasRequiredGlobalListeners) return globalListeners;
	hasRequiredGlobalListeners = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();

		function addPageListener(type, listener, options) {
		  if (types.WINDOW.document) {
		    types.WINDOW.addEventListener(type, listener, options);
		  }
		}
		function removePageListener(type, listener, options) {
		  if (types.WINDOW.document) {
		    types.WINDOW.removeEventListener(type, listener, options);
		  }
		}

		exports.addPageListener = addPageListener;
		exports.removePageListener = removePageListener;
		
	} (globalListeners));
	return globalListeners;
}

var hasRequiredGetVisibilityWatcher;

function requireGetVisibilityWatcher () {
	if (hasRequiredGetVisibilityWatcher) return getVisibilityWatcher;
	hasRequiredGetVisibilityWatcher = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();
		const getActivationStart = /*@__PURE__*/ requireGetActivationStart();
		const globalListeners = /*@__PURE__*/ requireGlobalListeners();

		let firstHiddenTime = -1;
		const onHiddenFunctions = /* @__PURE__ */ new Set();
		const initHiddenTime = () => {
		  return types.WINDOW.document?.visibilityState === "hidden" && !types.WINDOW.document?.prerendering ? 0 : Infinity;
		};
		const onVisibilityUpdate = (event) => {
		  if (isPageHidden(event) && firstHiddenTime > -1) {
		    if (event.type === "visibilitychange" || event.type === "pagehide") {
		      for (const onHiddenFunction of onHiddenFunctions) {
		        onHiddenFunction();
		      }
		    }
		    if (!isFinite(firstHiddenTime)) {
		      firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
		      globalListeners.removePageListener("prerenderingchange", onVisibilityUpdate, true);
		    }
		  }
		};
		const getVisibilityWatcher = () => {
		  if (types.WINDOW.document && firstHiddenTime < 0) {
		    const activationStart = getActivationStart.getActivationStart();
		    const firstVisibilityStateHiddenTime = !types.WINDOW.document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e) => e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
		    firstHiddenTime = firstVisibilityStateHiddenTime ?? initHiddenTime();
		    globalListeners.addPageListener("visibilitychange", onVisibilityUpdate, true);
		    globalListeners.addPageListener("pagehide", onVisibilityUpdate, true);
		    globalListeners.addPageListener("prerenderingchange", onVisibilityUpdate, true);
		  }
		  return {
		    get firstHiddenTime() {
		      return firstHiddenTime;
		    },
		    onHidden(cb) {
		      onHiddenFunctions.add(cb);
		    }
		  };
		};
		function isPageHidden(event) {
		  return event.type === "pagehide" || types.WINDOW.document?.visibilityState === "hidden";
		}

		exports.getVisibilityWatcher = getVisibilityWatcher;
		
	} (getVisibilityWatcher));
	return getVisibilityWatcher;
}

var initMetric = {};

var generateUniqueID = {};

var hasRequiredGenerateUniqueID;

function requireGenerateUniqueID () {
	if (hasRequiredGenerateUniqueID) return generateUniqueID;
	hasRequiredGenerateUniqueID = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const generateUniqueID = () => {
		  return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
		};

		exports.generateUniqueID = generateUniqueID;
		
	} (generateUniqueID));
	return generateUniqueID;
}

var hasRequiredInitMetric;

function requireInitMetric () {
	if (hasRequiredInitMetric) return initMetric;
	hasRequiredInitMetric = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();
		const generateUniqueID = /*@__PURE__*/ requireGenerateUniqueID();
		const getActivationStart = /*@__PURE__*/ requireGetActivationStart();
		const getNavigationEntry = /*@__PURE__*/ requireGetNavigationEntry();

		const initMetric = (name, value = -1) => {
		  const navEntry = getNavigationEntry.getNavigationEntry();
		  let navigationType = "navigate";
		  if (navEntry) {
		    if (types.WINDOW.document?.prerendering || getActivationStart.getActivationStart() > 0) {
		      navigationType = "prerender";
		    } else if (types.WINDOW.document?.wasDiscarded) {
		      navigationType = "restore";
		    } else if (navEntry.type) {
		      navigationType = navEntry.type.replace(/_/g, "-");
		    }
		  }
		  const entries = [];
		  return {
		    name,
		    value,
		    rating: "good",
		    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
		    delta: 0,
		    entries,
		    id: generateUniqueID.generateUniqueID(),
		    navigationType
		  };
		};

		exports.initMetric = initMetric;
		
	} (initMetric));
	return initMetric;
}

var initUnique = {};

var hasRequiredInitUnique;

function requireInitUnique () {
	if (hasRequiredInitUnique) return initUnique;
	hasRequiredInitUnique = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const instanceMap = /* @__PURE__ */ new WeakMap();
		function initUnique(identityObj, ClassObj) {
		  try {
		    if (!instanceMap.get(identityObj)) {
		      instanceMap.set(identityObj, new ClassObj());
		    }
		    return instanceMap.get(identityObj);
		  } catch (_e) {
		    return new ClassObj();
		  }
		}

		exports.initUnique = initUnique;
		
	} (initUnique));
	return initUnique;
}

var LayoutShiftManager = {};

var hasRequiredLayoutShiftManager;

function requireLayoutShiftManager () {
	if (hasRequiredLayoutShiftManager) return LayoutShiftManager;
	hasRequiredLayoutShiftManager = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		class LayoutShiftManager {
		  constructor() {
		    // oxlint-disable-next-line sdk/no-class-field-initializers
		    this._sessionValue = 0;
		    // oxlint-disable-next-line sdk/no-class-field-initializers
		    this._sessionEntries = [];
		  }
		  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
		  _processEntry(entry) {
		    if (entry.hadRecentInput) return;
		    const firstSessionEntry = this._sessionEntries[0];
		    const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
		    if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
		      this._sessionValue += entry.value;
		      this._sessionEntries.push(entry);
		    } else {
		      this._sessionValue = entry.value;
		      this._sessionEntries = [entry];
		    }
		    this._onAfterProcessingUnexpectedShift?.(entry);
		  }
		}

		exports.LayoutShiftManager = LayoutShiftManager;
		
	} (LayoutShiftManager));
	return LayoutShiftManager;
}

var observe = {};

var hasRequiredObserve;

function requireObserve () {
	if (hasRequiredObserve) return observe;
	hasRequiredObserve = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const observe = (type, callback, opts = {}) => {
		  try {
		    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
		      const po = new PerformanceObserver((list) => {
		        Promise.resolve().then(() => {
		          callback(list.getEntries());
		        });
		      });
		      po.observe({ type, buffered: true, ...opts });
		      return po;
		    }
		  } catch {
		  }
		  return;
		};

		exports.observe = observe;
		
	} (observe));
	return observe;
}

var runOnce = {};

var hasRequiredRunOnce;

function requireRunOnce () {
	if (hasRequiredRunOnce) return runOnce;
	hasRequiredRunOnce = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const runOnce = (cb) => {
		  let called = false;
		  return () => {
		    if (!called) {
		      cb();
		      called = true;
		    }
		  };
		};

		exports.runOnce = runOnce;
		
	} (runOnce));
	return runOnce;
}

var onFCP = {};

var whenActivated = {};

var hasRequiredWhenActivated;

function requireWhenActivated () {
	if (hasRequiredWhenActivated) return whenActivated;
	hasRequiredWhenActivated = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();

		const whenActivated = (callback) => {
		  if (types.WINDOW.document?.prerendering) {
		    addEventListener("prerenderingchange", () => callback(), true);
		  } else {
		    callback();
		  }
		};

		exports.whenActivated = whenActivated;
		
	} (whenActivated));
	return whenActivated;
}

var hasRequiredOnFCP;

function requireOnFCP () {
	if (hasRequiredOnFCP) return onFCP;
	hasRequiredOnFCP = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const bindReporter = /*@__PURE__*/ requireBindReporter();
		const getActivationStart = /*@__PURE__*/ requireGetActivationStart();
		const getVisibilityWatcher = /*@__PURE__*/ requireGetVisibilityWatcher();
		const initMetric = /*@__PURE__*/ requireInitMetric();
		const observe = /*@__PURE__*/ requireObserve();
		const whenActivated = /*@__PURE__*/ requireWhenActivated();

		const FCPThresholds = [1800, 3e3];
		const onFCP = (onReport, opts = {}) => {
		  whenActivated.whenActivated(() => {
		    const visibilityWatcher = getVisibilityWatcher.getVisibilityWatcher();
		    const metric = initMetric.initMetric("FCP");
		    let report;
		    const handleEntries = (entries) => {
		      for (const entry of entries) {
		        if (entry.name === "first-contentful-paint") {
		          po.disconnect();
		          if (entry.startTime < visibilityWatcher.firstHiddenTime) {
		            metric.value = Math.max(entry.startTime - getActivationStart.getActivationStart(), 0);
		            metric.entries.push(entry);
		            report(true);
		          }
		        }
		      }
		    };
		    const po = observe.observe("paint", handleEntries);
		    if (po) {
		      report = bindReporter.bindReporter(onReport, metric, FCPThresholds, opts.reportAllChanges);
		    }
		  });
		};

		exports.FCPThresholds = FCPThresholds;
		exports.onFCP = onFCP;
		
	} (onFCP));
	return onFCP;
}

var hasRequiredGetCLS;

function requireGetCLS () {
	if (hasRequiredGetCLS) return getCLS;
	hasRequiredGetCLS = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();
		const bindReporter = /*@__PURE__*/ requireBindReporter();
		const getVisibilityWatcher = /*@__PURE__*/ requireGetVisibilityWatcher();
		const initMetric = /*@__PURE__*/ requireInitMetric();
		const initUnique = /*@__PURE__*/ requireInitUnique();
		const LayoutShiftManager = /*@__PURE__*/ requireLayoutShiftManager();
		const observe = /*@__PURE__*/ requireObserve();
		const runOnce = /*@__PURE__*/ requireRunOnce();
		const onFCP = /*@__PURE__*/ requireOnFCP();

		const CLSThresholds = [0.1, 0.25];
		const onCLS = (onReport, opts = {}) => {
		  onFCP.onFCP(
		    runOnce.runOnce(() => {
		      const metric = initMetric.initMetric("CLS", 0);
		      let report;
		      const visibilityWatcher = getVisibilityWatcher.getVisibilityWatcher();
		      const layoutShiftManager = initUnique.initUnique(opts, LayoutShiftManager.LayoutShiftManager);
		      const handleEntries = (entries) => {
		        for (const entry of entries) {
		          layoutShiftManager._processEntry(entry);
		        }
		        if (layoutShiftManager._sessionValue > metric.value) {
		          metric.value = layoutShiftManager._sessionValue;
		          metric.entries = layoutShiftManager._sessionEntries;
		          report();
		        }
		      };
		      const po = observe.observe("layout-shift", handleEntries);
		      if (po) {
		        report = bindReporter.bindReporter(onReport, metric, CLSThresholds, opts.reportAllChanges);
		        visibilityWatcher.onHidden(() => {
		          handleEntries(po.takeRecords());
		          report(true);
		        });
		        types.WINDOW?.setTimeout?.(report);
		      }
		    })
		  );
		};

		exports.CLSThresholds = CLSThresholds;
		exports.onCLS = onCLS;
		
	} (getCLS));
	return getCLS;
}

var getINP = {};

var InteractionManager = {};

var interactionCountPolyfill = {};

var hasRequiredInteractionCountPolyfill;

function requireInteractionCountPolyfill () {
	if (hasRequiredInteractionCountPolyfill) return interactionCountPolyfill;
	hasRequiredInteractionCountPolyfill = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const observe = /*@__PURE__*/ requireObserve();

		let interactionCountEstimate = 0;
		let minKnownInteractionId = Infinity;
		let maxKnownInteractionId = 0;
		const updateEstimate = (entries) => {
		  entries.forEach((e) => {
		    if (e.interactionId) {
		      minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
		      maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
		      interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
		    }
		  });
		};
		let po;
		const getInteractionCount = () => {
		  return po ? interactionCountEstimate : performance.interactionCount || 0;
		};
		const initInteractionCountPolyfill = () => {
		  if ("interactionCount" in performance || po) return;
		  po = observe.observe("event", updateEstimate, {
		    type: "event",
		    buffered: true,
		    durationThreshold: 0
		  });
		};

		exports.getInteractionCount = getInteractionCount;
		exports.initInteractionCountPolyfill = initInteractionCountPolyfill;
		
	} (interactionCountPolyfill));
	return interactionCountPolyfill;
}

var hasRequiredInteractionManager;

function requireInteractionManager () {
	if (hasRequiredInteractionManager) return InteractionManager;
	hasRequiredInteractionManager = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const interactionCountPolyfill = /*@__PURE__*/ requireInteractionCountPolyfill();

		const MAX_INTERACTIONS_TO_CONSIDER = 10;
		let prevInteractionCount = 0;
		const getInteractionCountForNavigation = () => {
		  return interactionCountPolyfill.getInteractionCount() - prevInteractionCount;
		};
		class InteractionManager {
		  constructor() {
		    /**
		     * A list of longest interactions on the page (by latency) sorted so the
		     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
		     * long.
		     */
		    // oxlint-disable-next-line sdk/no-class-field-initializers
		    this._longestInteractionList = [];
		    /**
		     * A mapping of longest interactions by their interaction ID.
		     * This is used for faster lookup.
		     */
		    // oxlint-disable-next-line sdk/no-class-field-initializers
		    this._longestInteractionMap = /* @__PURE__ */ new Map();
		  }
		  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
		  _resetInteractions() {
		    prevInteractionCount = interactionCountPolyfill.getInteractionCount();
		    this._longestInteractionList.length = 0;
		    this._longestInteractionMap.clear();
		  }
		  /**
		   * Returns the estimated p98 longest interaction based on the stored
		   * interaction candidates and the interaction count for the current page.
		   */
		  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
		  _estimateP98LongestInteraction() {
		    const candidateInteractionIndex = Math.min(
		      this._longestInteractionList.length - 1,
		      Math.floor(getInteractionCountForNavigation() / 50)
		    );
		    return this._longestInteractionList[candidateInteractionIndex];
		  }
		  /**
		   * Takes a performance entry and adds it to the list of worst interactions
		   * if its duration is long enough to make it among the worst. If the
		   * entry is part of an existing interaction, it is merged and the latency
		   * and entries list is updated as needed.
		   */
		  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
		  _processEntry(entry) {
		    this._onBeforeProcessingEntry?.(entry);
		    if (!(entry.interactionId || entry.entryType === "first-input")) return;
		    const minLongestInteraction = this._longestInteractionList.at(-1);
		    let interaction = this._longestInteractionMap.get(entry.interactionId);
		    if (interaction || this._longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
		    entry.duration > minLongestInteraction._latency) {
		      if (interaction) {
		        if (entry.duration > interaction._latency) {
		          interaction.entries = [entry];
		          interaction._latency = entry.duration;
		        } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) {
		          interaction.entries.push(entry);
		        }
		      } else {
		        interaction = {
		          id: entry.interactionId,
		          entries: [entry],
		          _latency: entry.duration
		        };
		        this._longestInteractionMap.set(interaction.id, interaction);
		        this._longestInteractionList.push(interaction);
		      }
		      this._longestInteractionList.sort((a, b) => b._latency - a._latency);
		      if (this._longestInteractionList.length > MAX_INTERACTIONS_TO_CONSIDER) {
		        const removedInteractions = this._longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER);
		        for (const interaction2 of removedInteractions) {
		          this._longestInteractionMap.delete(interaction2.id);
		        }
		      }
		      this._onAfterProcessingINPCandidate?.(interaction);
		    }
		  }
		}

		exports.InteractionManager = InteractionManager;
		
	} (InteractionManager));
	return InteractionManager;
}

var whenIdleOrHidden = {};

var hasRequiredWhenIdleOrHidden;

function requireWhenIdleOrHidden () {
	if (hasRequiredWhenIdleOrHidden) return whenIdleOrHidden;
	hasRequiredWhenIdleOrHidden = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();
		const globalListeners = /*@__PURE__*/ requireGlobalListeners();
		const runOnce = /*@__PURE__*/ requireRunOnce();

		const whenIdleOrHidden = (cb) => {
		  const rIC = types.WINDOW.requestIdleCallback || types.WINDOW.setTimeout;
		  if (types.WINDOW.document?.visibilityState === "hidden") {
		    cb();
		  } else {
		    cb = runOnce.runOnce(cb);
		    globalListeners.addPageListener("visibilitychange", cb, { once: true, capture: true });
		    globalListeners.addPageListener("pagehide", cb, { once: true, capture: true });
		    rIC(() => {
		      cb();
		      globalListeners.removePageListener("visibilitychange", cb, { capture: true });
		      globalListeners.removePageListener("pagehide", cb, { capture: true });
		    });
		  }
		};

		exports.whenIdleOrHidden = whenIdleOrHidden;
		
	} (whenIdleOrHidden));
	return whenIdleOrHidden;
}

var hasRequiredGetINP;

function requireGetINP () {
	if (hasRequiredGetINP) return getINP;
	hasRequiredGetINP = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const bindReporter = /*@__PURE__*/ requireBindReporter();
		const getVisibilityWatcher = /*@__PURE__*/ requireGetVisibilityWatcher();
		const initMetric = /*@__PURE__*/ requireInitMetric();
		const initUnique = /*@__PURE__*/ requireInitUnique();
		const InteractionManager = /*@__PURE__*/ requireInteractionManager();
		const observe = /*@__PURE__*/ requireObserve();
		const interactionCountPolyfill = /*@__PURE__*/ requireInteractionCountPolyfill();
		const whenActivated = /*@__PURE__*/ requireWhenActivated();
		const whenIdleOrHidden = /*@__PURE__*/ requireWhenIdleOrHidden();

		const INPThresholds = [200, 500];
		const DEFAULT_DURATION_THRESHOLD = 40;
		const onINP = (onReport, opts = {}) => {
		  if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) {
		    return;
		  }
		  const visibilityWatcher = getVisibilityWatcher.getVisibilityWatcher();
		  whenActivated.whenActivated(() => {
		    interactionCountPolyfill.initInteractionCountPolyfill();
		    const metric = initMetric.initMetric("INP");
		    let report;
		    const interactionManager = initUnique.initUnique(opts, InteractionManager.InteractionManager);
		    const handleEntries = (entries) => {
		      whenIdleOrHidden.whenIdleOrHidden(() => {
		        for (const entry of entries) {
		          interactionManager._processEntry(entry);
		        }
		        const inp = interactionManager._estimateP98LongestInteraction();
		        if (inp && inp._latency !== metric.value) {
		          metric.value = inp._latency;
		          metric.entries = inp.entries;
		          report();
		        }
		      });
		    };
		    const po = observe.observe("event", handleEntries, {
		      // Event Timing entries have their durations rounded to the nearest 8ms,
		      // so a duration of 40ms would be any event that spans 2.5 or more frames
		      // at 60Hz. This threshold is chosen to strike a balance between usefulness
		      // and performance. Running this callback for any interaction that spans
		      // just one or two frames is likely not worth the insight that could be
		      // gained.
		      durationThreshold: opts.durationThreshold ?? DEFAULT_DURATION_THRESHOLD
		    });
		    report = bindReporter.bindReporter(onReport, metric, INPThresholds, opts.reportAllChanges);
		    if (po) {
		      po.observe({ type: "first-input", buffered: true });
		      visibilityWatcher.onHidden(() => {
		        handleEntries(po.takeRecords());
		        report(true);
		      });
		    }
		  });
		};

		exports.INPThresholds = INPThresholds;
		exports.onINP = onINP;
		
	} (getINP));
	return getINP;
}

var getLCP = {};

var LCPEntryManager = {};

var hasRequiredLCPEntryManager;

function requireLCPEntryManager () {
	if (hasRequiredLCPEntryManager) return LCPEntryManager;
	hasRequiredLCPEntryManager = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		class LCPEntryManager {
		  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
		  _processEntry(entry) {
		    this._onBeforeProcessingEntry?.(entry);
		  }
		}

		exports.LCPEntryManager = LCPEntryManager;
		
	} (LCPEntryManager));
	return LCPEntryManager;
}

var hasRequiredGetLCP;

function requireGetLCP () {
	if (hasRequiredGetLCP) return getLCP;
	hasRequiredGetLCP = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const bindReporter = /*@__PURE__*/ requireBindReporter();
		const getActivationStart = /*@__PURE__*/ requireGetActivationStart();
		const getVisibilityWatcher = /*@__PURE__*/ requireGetVisibilityWatcher();
		const globalListeners = /*@__PURE__*/ requireGlobalListeners();
		const initMetric = /*@__PURE__*/ requireInitMetric();
		const initUnique = /*@__PURE__*/ requireInitUnique();
		const LCPEntryManager = /*@__PURE__*/ requireLCPEntryManager();
		const observe = /*@__PURE__*/ requireObserve();
		const runOnce = /*@__PURE__*/ requireRunOnce();
		const whenActivated = /*@__PURE__*/ requireWhenActivated();
		const whenIdleOrHidden = /*@__PURE__*/ requireWhenIdleOrHidden();

		const LCPThresholds = [2500, 4e3];
		const onLCP = (onReport, opts = {}) => {
		  whenActivated.whenActivated(() => {
		    const visibilityWatcher = getVisibilityWatcher.getVisibilityWatcher();
		    const metric = initMetric.initMetric("LCP");
		    let report;
		    const lcpEntryManager = initUnique.initUnique(opts, LCPEntryManager.LCPEntryManager);
		    const handleEntries = (entries) => {
		      if (!opts.reportAllChanges) {
		        entries = entries.slice(-1);
		      }
		      for (const entry of entries) {
		        lcpEntryManager._processEntry(entry);
		        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
		          metric.value = Math.max(entry.startTime - getActivationStart.getActivationStart(), 0);
		          metric.entries = [entry];
		          report();
		        }
		      }
		    };
		    const po = observe.observe("largest-contentful-paint", handleEntries);
		    if (po) {
		      report = bindReporter.bindReporter(onReport, metric, LCPThresholds, opts.reportAllChanges);
		      const stopListening = runOnce.runOnce(() => {
		        handleEntries(po.takeRecords());
		        po.disconnect();
		        report(true);
		      });
		      const stopListeningWrapper = (event) => {
		        if (event.isTrusted) {
		          whenIdleOrHidden.whenIdleOrHidden(stopListening);
		          globalListeners.removePageListener(event.type, stopListeningWrapper, {
		            capture: true
		          });
		        }
		      };
		      for (const type of ["keydown", "click", "visibilitychange"]) {
		        globalListeners.addPageListener(type, stopListeningWrapper, {
		          capture: true
		        });
		      }
		    }
		  });
		};

		exports.LCPThresholds = LCPThresholds;
		exports.onLCP = onLCP;
		
	} (getLCP));
	return getLCP;
}

var onTTFB = {};

var hasRequiredOnTTFB;

function requireOnTTFB () {
	if (hasRequiredOnTTFB) return onTTFB;
	hasRequiredOnTTFB = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();
		const bindReporter = /*@__PURE__*/ requireBindReporter();
		const getActivationStart = /*@__PURE__*/ requireGetActivationStart();
		const getNavigationEntry = /*@__PURE__*/ requireGetNavigationEntry();
		const initMetric = /*@__PURE__*/ requireInitMetric();
		const whenActivated = /*@__PURE__*/ requireWhenActivated();

		const TTFBThresholds = [800, 1800];
		const whenReady = (callback) => {
		  if (types.WINDOW.document?.prerendering) {
		    whenActivated.whenActivated(() => whenReady(callback));
		  } else if (types.WINDOW.document?.readyState !== "complete") {
		    addEventListener("load", () => whenReady(callback), true);
		  } else {
		    setTimeout(callback);
		  }
		};
		const onTTFB = (onReport, opts = {}) => {
		  const metric = initMetric.initMetric("TTFB");
		  const report = bindReporter.bindReporter(onReport, metric, TTFBThresholds, opts.reportAllChanges);
		  whenReady(() => {
		    const navigationEntry = getNavigationEntry.getNavigationEntry();
		    if (navigationEntry) {
		      metric.value = Math.max(navigationEntry.responseStart - getActivationStart.getActivationStart(), 0);
		      metric.entries = [navigationEntry];
		      report(true);
		    }
		  });
		};

		exports.TTFBThresholds = TTFBThresholds;
		exports.onTTFB = onTTFB;
		
	} (onTTFB));
	return onTTFB;
}

var hasRequiredInstrument;

function requireInstrument () {
	if (hasRequiredInstrument) return instrument;
	hasRequiredInstrument = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$1();
		const getCLS = /*@__PURE__*/ requireGetCLS();
		const getINP = /*@__PURE__*/ requireGetINP();
		const getLCP = /*@__PURE__*/ requireGetLCP();
		const observe = /*@__PURE__*/ requireObserve();
		const onTTFB = /*@__PURE__*/ requireOnTTFB();

		const handlers = {};
		const instrumented = {};
		let _previousCls;
		let _previousLcp;
		let _previousTtfb;
		let _previousInp;
		function addClsInstrumentationHandler(callback, stopOnCallback = false) {
		  return addMetricObserver("cls", callback, instrumentCls, _previousCls, stopOnCallback);
		}
		function addLcpInstrumentationHandler(callback, stopOnCallback = false) {
		  return addMetricObserver("lcp", callback, instrumentLcp, _previousLcp, stopOnCallback);
		}
		function addTtfbInstrumentationHandler(callback) {
		  return addMetricObserver("ttfb", callback, instrumentTtfb, _previousTtfb);
		}
		function addInpInstrumentationHandler(callback) {
		  return addMetricObserver("inp", callback, instrumentInp, _previousInp);
		}
		function addPerformanceInstrumentationHandler(type, callback) {
		  addHandler(type, callback);
		  if (!instrumented[type]) {
		    instrumentPerformanceObserver(type);
		    instrumented[type] = true;
		  }
		  return getCleanupCallback(type, callback);
		}
		function triggerHandlers(type, data) {
		  const typeHandlers = handlers[type];
		  if (!typeHandlers?.length) {
		    return;
		  }
		  for (const handler of typeHandlers) {
		    try {
		      handler(data);
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && core.debug.error(
		        `Error while triggering instrumentation handler.
Type: ${type}
Name: ${core.getFunctionName(handler)}
Error:`,
		        e
		      );
		    }
		  }
		}
		function instrumentCls() {
		  return getCLS.onCLS(
		    (metric) => {
		      triggerHandlers("cls", {
		        metric
		      });
		      _previousCls = metric;
		    },
		    // We want the callback to be called whenever the CLS value updates.
		    // By default, the callback is only called when the tab goes to the background.
		    { reportAllChanges: true }
		  );
		}
		function instrumentLcp() {
		  return getLCP.onLCP(
		    (metric) => {
		      triggerHandlers("lcp", {
		        metric
		      });
		      _previousLcp = metric;
		    },
		    // We want the callback to be called whenever the LCP value updates.
		    // By default, the callback is only called when the tab goes to the background.
		    { reportAllChanges: true }
		  );
		}
		function instrumentTtfb() {
		  return onTTFB.onTTFB((metric) => {
		    triggerHandlers("ttfb", {
		      metric
		    });
		    _previousTtfb = metric;
		  });
		}
		function instrumentInp() {
		  return getINP.onINP((metric) => {
		    triggerHandlers("inp", {
		      metric
		    });
		    _previousInp = metric;
		  });
		}
		function addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
		  addHandler(type, callback);
		  let stopListening;
		  if (!instrumented[type]) {
		    stopListening = instrumentFn();
		    instrumented[type] = true;
		  }
		  if (previousValue) {
		    callback({ metric: previousValue });
		  }
		  return getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
		}
		function instrumentPerformanceObserver(type) {
		  const options = {};
		  if (type === "event") {
		    options.durationThreshold = 0;
		  }
		  observe.observe(
		    type,
		    (entries) => {
		      triggerHandlers(type, { entries });
		    },
		    options
		  );
		}
		function addHandler(type, handler) {
		  handlers[type] = handlers[type] || [];
		  handlers[type].push(handler);
		}
		function getCleanupCallback(type, callback, stopListening) {
		  return () => {
		    if (stopListening) {
		      stopListening();
		    }
		    const typeHandlers = handlers[type];
		    if (!typeHandlers) {
		      return;
		    }
		    const index = typeHandlers.indexOf(callback);
		    if (index !== -1) {
		      typeHandlers.splice(index, 1);
		    }
		  };
		}
		function isPerformanceEventTiming(entry) {
		  return "duration" in entry;
		}

		exports.addClsInstrumentationHandler = addClsInstrumentationHandler;
		exports.addInpInstrumentationHandler = addInpInstrumentationHandler;
		exports.addLcpInstrumentationHandler = addLcpInstrumentationHandler;
		exports.addPerformanceInstrumentationHandler = addPerformanceInstrumentationHandler;
		exports.addTtfbInstrumentationHandler = addTtfbInstrumentationHandler;
		exports.isPerformanceEventTiming = isPerformanceEventTiming;
		
	} (instrument));
	return instrument;
}

var browserMetrics = {};

var htmlTreeAsString = {};

var hasRequiredHtmlTreeAsString;

function requireHtmlTreeAsString () {
	if (hasRequiredHtmlTreeAsString) return htmlTreeAsString;
	hasRequiredHtmlTreeAsString = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();

		const DEFAULT_MAX_STRING_LENGTH = 80;
		const accessors = {};
		try {
		  if (typeof Node !== "undefined") {
		    accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
		  }
		  if (typeof Element !== "undefined") {
		    accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
		    accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
		    accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
		    accessors.getAttribute = Element.prototype.getAttribute;
		  }
		  if (typeof HTMLElement !== "undefined") {
		    accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
		  }
		} catch {
		}
		function _safeRead(el, prop, arg) {
		  const fn = accessors[prop];
		  if (fn) {
		    try {
		      return fn.call(el, arg);
		    } catch {
		    }
		  }
		  const val = el[prop];
		  return typeof val === "function" ? val.call(el, arg) : val;
		}
		function htmlTreeAsString(elem, options = {}) {
		  if (!elem) {
		    return "<unknown>";
		  }
		  try {
		    let currentElem = elem;
		    const MAX_TRAVERSE_HEIGHT = 5;
		    const out = [];
		    let height = 0;
		    let len = 0;
		    const separator = " > ";
		    const sepLength = separator.length;
		    let nextStr;
		    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
		    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
		    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
		      nextStr = _htmlElementAsString(currentElem, keyAttrs);
		      if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
		        break;
		      }
		      out.push(nextStr);
		      len += nextStr.length;
		      currentElem = _safeRead(currentElem, "parentNode");
		    }
		    return out.reverse().join(separator);
		  } catch {
		    return "<unknown>";
		  }
		}
		function _htmlElementAsString(el, keyAttrs) {
		  const out = [];
		  const tagName = _safeRead(el, "tagName");
		  if (!tagName) {
		    return "";
		  }
		  if (typeof HTMLElement !== "undefined") {
		    if (el instanceof HTMLElement) {
		      const dataset = _safeRead(el, "dataset");
		      if (dataset) {
		        if (dataset["sentryComponent"]) {
		          return dataset["sentryComponent"];
		        }
		        if (dataset["sentryElement"]) {
		          return dataset["sentryElement"];
		        }
		      }
		    }
		  }
		  out.push(tagName.toLowerCase());
		  const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr) => _safeRead(el, "getAttribute", keyAttr)).map((keyAttr) => [keyAttr, _safeRead(el, "getAttribute", keyAttr)]) : null;
		  if (keyAttrPairs?.length) {
		    keyAttrPairs.forEach((keyAttrPair) => {
		      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
		    });
		  } else {
		    const id = _safeRead(el, "id");
		    if (id) {
		      out.push(`#${id}`);
		    }
		    const className = _safeRead(el, "className");
		    if (className && core.isString(className)) {
		      const classes = className.split(/\s+/);
		      for (const c of classes) {
		        out.push(`.${c}`);
		      }
		    }
		  }
		  for (const k of ["aria-label", "type", "name", "title", "alt"]) {
		    const attr = _safeRead(el, "getAttribute", k);
		    if (attr) {
		      out.push(`[${k}="${attr}"]`);
		    }
		  }
		  return out.join("");
		}

		exports.htmlTreeAsString = htmlTreeAsString;
		
	} (htmlTreeAsString));
	return htmlTreeAsString;
}

var cls = {};

var utils$6 = {};

var onHidden = {};

var hasRequiredOnHidden;

function requireOnHidden () {
	if (hasRequiredOnHidden) return onHidden;
	hasRequiredOnHidden = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const types = /*@__PURE__*/ requireTypes();
		const globalListeners = /*@__PURE__*/ requireGlobalListeners();

		const onHidden = (cb) => {
		  const onHiddenOrPageHide = (event) => {
		    if (event.type === "pagehide" || types.WINDOW.document?.visibilityState === "hidden") {
		      cb(event);
		    }
		  };
		  globalListeners.addPageListener("visibilitychange", onHiddenOrPageHide, { capture: true, once: true });
		  globalListeners.addPageListener("pagehide", onHiddenOrPageHide, { capture: true, once: true });
		};

		exports.onHidden = onHidden;
		
	} (onHidden));
	return onHidden;
}

var hasRequiredUtils$6;

function requireUtils$6 () {
	if (hasRequiredUtils$6) return utils$6;
	hasRequiredUtils$6 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const types = /*@__PURE__*/ requireTypes();
		const onHidden = /*@__PURE__*/ requireOnHidden();

		function isMeasurementValue(value) {
		  return typeof value === "number" && isFinite(value);
		}
		function startAndEndSpan(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
		  const parentStartTime = core.spanToJSON(parentSpan).start_timestamp;
		  if (parentStartTime && parentStartTime > startTimeInSeconds) {
		    if (typeof parentSpan.updateStartTime === "function") {
		      parentSpan.updateStartTime(startTimeInSeconds);
		    }
		  }
		  return core.withActiveSpan(parentSpan, () => {
		    const span = core.startInactiveSpan({
		      startTime: startTimeInSeconds,
		      ...ctx
		    });
		    if (span) {
		      span.end(endTime);
		    }
		    return span;
		  });
		}
		function startStandaloneWebVitalSpan(options) {
		  const client = core.getClient();
		  if (!client) {
		    return;
		  }
		  const { name, transaction, attributes: passedAttributes, startTime } = options;
		  const { release, environment } = client.getOptions();
		  const { userInfo } = client.getDataCollectionOptions();
		  const replay = client.getIntegrationByName("Replay");
		  const replayId = replay?.getReplayId();
		  const scope = core.getCurrentScope();
		  const user = scope.getUser();
		  const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
		  let profileId;
		  try {
		    profileId = scope.getScopeData().contexts.profile.profile_id;
		  } catch {
		  }
		  const attributes = {
		    release,
		    environment,
		    user: userDisplay || void 0,
		    profile_id: profileId || void 0,
		    replay_id: replayId || void 0,
		    transaction,
		    // Web vital score calculation relies on the user agent to account for different
		    // browsers setting different thresholds for what is considered a good/meh/bad value.
		    // For example: Chrome vs. Chrome Mobile
		    "user_agent.original": types.WINDOW.navigator?.userAgent,
		    // This tells Sentry to infer the IP address from the request
		    "client.address": userInfo ? "{{auto}}" : void 0,
		    ...passedAttributes
		  };
		  return core.startInactiveSpan({
		    name,
		    attributes,
		    startTime,
		    experimental: {
		      standalone: true
		    }
		  });
		}
		function getBrowserPerformanceAPI() {
		  return types.WINDOW.addEventListener && types.WINDOW.performance;
		}
		function msToSec(time) {
		  return time / 1e3;
		}
		function extractNetworkProtocol(nextHopProtocol) {
		  let name = "unknown";
		  let version = "unknown";
		  let _name = "";
		  for (const char of nextHopProtocol) {
		    if (char === "/") {
		      [name, version] = nextHopProtocol.split("/");
		      break;
		    }
		    if (!isNaN(Number(char))) {
		      name = _name === "h" ? "http" : _name;
		      version = nextHopProtocol.split(_name)[1];
		      break;
		    }
		    _name += char;
		  }
		  if (_name === nextHopProtocol) {
		    name = _name;
		  }
		  return { name, version };
		}
		function supportsWebVital(entryType) {
		  try {
		    return PerformanceObserver.supportedEntryTypes.includes(entryType);
		  } catch {
		    return false;
		  }
		}
		function listenForWebVitalReportEvents(client, collectorCallback) {
		  let pageloadSpan;
		  let collected = false;
		  function _runCollectorCallbackOnce(event) {
		    if (!collected && pageloadSpan) {
		      collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
		    }
		    collected = true;
		  }
		  onHidden.onHidden(() => {
		    _runCollectorCallbackOnce("pagehide");
		  });
		  const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options) => {
		    if (!options?.isRedirect) {
		      _runCollectorCallbackOnce("navigation");
		      unsubscribeStartNavigation();
		      unsubscribeAfterStartPageLoadSpan();
		    }
		  });
		  const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span) => {
		    pageloadSpan = span;
		    unsubscribeAfterStartPageLoadSpan();
		  });
		}

		exports.extractNetworkProtocol = extractNetworkProtocol;
		exports.getBrowserPerformanceAPI = getBrowserPerformanceAPI;
		exports.isMeasurementValue = isMeasurementValue;
		exports.listenForWebVitalReportEvents = listenForWebVitalReportEvents;
		exports.msToSec = msToSec;
		exports.startAndEndSpan = startAndEndSpan;
		exports.startStandaloneWebVitalSpan = startStandaloneWebVitalSpan;
		exports.supportsWebVital = supportsWebVital;
		
	} (utils$6));
	return utils$6;
}

var hasRequiredCls;

function requireCls () {
	if (hasRequiredCls) return cls;
	hasRequiredCls = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$1();
		const htmlTreeAsString = /*@__PURE__*/ requireHtmlTreeAsString();
		const instrument = /*@__PURE__*/ requireInstrument();
		const utils = /*@__PURE__*/ requireUtils$6();

		function trackClsAsStandaloneSpan(client) {
		  let standaloneCLsValue = 0;
		  let standaloneClsEntry;
		  if (!utils.supportsWebVital("layout-shift")) {
		    return;
		  }
		  const cleanupClsHandler = instrument.addClsInstrumentationHandler(({ metric }) => {
		    const entry = metric.entries[metric.entries.length - 1];
		    if (!entry) {
		      return;
		    }
		    standaloneCLsValue = metric.value;
		    standaloneClsEntry = entry;
		  }, true);
		  utils.listenForWebVitalReportEvents(client, (reportEvent, pageloadSpanId) => {
		    _sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
		    cleanupClsHandler();
		  });
		}
		function _sendStandaloneClsSpan(clsValue, entry, pageloadSpanId, reportEvent) {
		  debugBuild.DEBUG_BUILD && core.debug.log(`Sending CLS span (${clsValue})`);
		  const startTime = entry ? utils.msToSec((core.browserPerformanceTimeOrigin() || 0) + entry.startTime) : core.timestampInSeconds();
		  const routeName = core.getCurrentScope().getScopeData().transactionName;
		  const name = entry ? htmlTreeAsString.htmlTreeAsString(entry.sources[0]?.node) : "Layout shift";
		  const attributes = {
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.http.browser.cls",
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "ui.webvital.cls",
		    [core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: 0,
		    // attach the pageload span id to the CLS span so that we can link them in the UI
		    "sentry.pageload.span_id": pageloadSpanId,
		    // describes what triggered the web vital to be reported
		    "sentry.report_event": reportEvent
		  };
		  if (entry?.sources) {
		    entry.sources.forEach((source, index) => {
		      attributes[`cls.source.${index + 1}`] = htmlTreeAsString.htmlTreeAsString(source.node);
		    });
		  }
		  const span = utils.startStandaloneWebVitalSpan({
		    name,
		    transaction: routeName,
		    attributes,
		    startTime
		  });
		  if (span) {
		    span.addEvent("cls", {
		      [core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: "",
		      [core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: clsValue
		    });
		    span.end(startTime);
		  }
		}

		exports._sendStandaloneClsSpan = _sendStandaloneClsSpan;
		exports.trackClsAsStandaloneSpan = trackClsAsStandaloneSpan;
		
	} (cls));
	return cls;
}

var lcp = {};

var hasRequiredLcp;

function requireLcp () {
	if (hasRequiredLcp) return lcp;
	hasRequiredLcp = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$1();
		const htmlTreeAsString = /*@__PURE__*/ requireHtmlTreeAsString();
		const instrument = /*@__PURE__*/ requireInstrument();
		const utils = /*@__PURE__*/ requireUtils$6();

		const MAX_PLAUSIBLE_LCP_DURATION = 6e4;
		function isValidLcpMetric(lcpValue) {
		  return lcpValue != null && lcpValue > 0 && lcpValue <= MAX_PLAUSIBLE_LCP_DURATION;
		}
		function trackLcpAsStandaloneSpan(client) {
		  let standaloneLcpValue = 0;
		  let standaloneLcpEntry;
		  if (!utils.supportsWebVital("largest-contentful-paint")) {
		    return;
		  }
		  const cleanupLcpHandler = instrument.addLcpInstrumentationHandler(({ metric }) => {
		    const entry = metric.entries[metric.entries.length - 1];
		    if (!entry || !isValidLcpMetric(metric.value)) {
		      return;
		    }
		    standaloneLcpValue = metric.value;
		    standaloneLcpEntry = entry;
		  }, true);
		  utils.listenForWebVitalReportEvents(client, (reportEvent, pageloadSpanId) => {
		    _sendStandaloneLcpSpan(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
		    cleanupLcpHandler();
		  });
		}
		function _sendStandaloneLcpSpan(lcpValue, entry, pageloadSpanId, reportEvent) {
		  if (!isValidLcpMetric(lcpValue)) {
		    return;
		  }
		  debugBuild.DEBUG_BUILD && core.debug.log(`Sending LCP span (${lcpValue})`);
		  const startTime = utils.msToSec((core.browserPerformanceTimeOrigin() || 0) + (entry?.startTime || 0));
		  const routeName = core.getCurrentScope().getScopeData().transactionName;
		  const name = entry ? htmlTreeAsString.htmlTreeAsString(entry.element) : "Largest contentful paint";
		  const attributes = {
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.http.browser.lcp",
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "ui.webvital.lcp",
		    [core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: 0,
		    // LCP is a point-in-time metric
		    // attach the pageload span id to the LCP span so that we can link them in the UI
		    "sentry.pageload.span_id": pageloadSpanId,
		    // describes what triggered the web vital to be reported
		    "sentry.report_event": reportEvent
		  };
		  if (entry) {
		    entry.element && (attributes["lcp.element"] = htmlTreeAsString.htmlTreeAsString(entry.element));
		    entry.id && (attributes["lcp.id"] = entry.id);
		    entry.url && (attributes["lcp.url"] = entry.url);
		    entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
		    entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
		    entry.size != null && (attributes["lcp.size"] = entry.size);
		  }
		  const span = utils.startStandaloneWebVitalSpan({
		    name,
		    transaction: routeName,
		    attributes,
		    startTime
		  });
		  if (span) {
		    span.addEvent("lcp", {
		      [core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: "millisecond",
		      [core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: lcpValue
		    });
		    span.end(startTime);
		  }
		}

		exports.MAX_PLAUSIBLE_LCP_DURATION = MAX_PLAUSIBLE_LCP_DURATION;
		exports._sendStandaloneLcpSpan = _sendStandaloneLcpSpan;
		exports.isValidLcpMetric = isValidLcpMetric;
		exports.trackLcpAsStandaloneSpan = trackLcpAsStandaloneSpan;
		
	} (lcp));
	return lcp;
}

var resourceTiming = {};

var hasRequiredResourceTiming;

function requireResourceTiming () {
	if (hasRequiredResourceTiming) return resourceTiming;
	hasRequiredResourceTiming = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const utils = /*@__PURE__*/ requireUtils$6();

		function getAbsoluteTime(time) {
		  return time ? ((core.browserPerformanceTimeOrigin() || performance.timeOrigin) + time) / 1e3 : time;
		}
		function resourceTimingToSpanAttributes(resourceTiming) {
		  const timingSpanData = {};
		  if (resourceTiming.nextHopProtocol != void 0) {
		    const { name, version } = utils.extractNetworkProtocol(resourceTiming.nextHopProtocol);
		    timingSpanData["network.protocol.version"] = version;
		    timingSpanData["network.protocol.name"] = name;
		  }
		  if (!(core.browserPerformanceTimeOrigin() || utils.getBrowserPerformanceAPI()?.timeOrigin)) {
		    return timingSpanData;
		  }
		  return dropUndefinedKeysFromObject({
		    ...timingSpanData,
		    "http.request.redirect_start": getAbsoluteTime(resourceTiming.redirectStart),
		    "http.request.redirect_end": getAbsoluteTime(resourceTiming.redirectEnd),
		    "http.request.worker_start": getAbsoluteTime(resourceTiming.workerStart),
		    "http.request.fetch_start": getAbsoluteTime(resourceTiming.fetchStart),
		    "http.request.domain_lookup_start": getAbsoluteTime(resourceTiming.domainLookupStart),
		    "http.request.domain_lookup_end": getAbsoluteTime(resourceTiming.domainLookupEnd),
		    "http.request.connect_start": getAbsoluteTime(resourceTiming.connectStart),
		    "http.request.secure_connection_start": getAbsoluteTime(resourceTiming.secureConnectionStart),
		    "http.request.connection_end": getAbsoluteTime(resourceTiming.connectEnd),
		    "http.request.request_start": getAbsoluteTime(resourceTiming.requestStart),
		    "http.request.response_start": getAbsoluteTime(resourceTiming.responseStart),
		    "http.request.response_end": getAbsoluteTime(resourceTiming.responseEnd),
		    // For TTFB we actually want the relative time from timeOrigin to responseStart
		    // This way, TTFB always measures the "first page load" experience.
		    // see: https://web.dev/articles/ttfb#measure-resource-requests
		    "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
		  });
		}
		function dropUndefinedKeysFromObject(attrs) {
		  return Object.fromEntries(Object.entries(attrs).filter(([, value]) => value != null));
		}

		exports.resourceTimingToSpanAttributes = resourceTimingToSpanAttributes;
		
	} (resourceTiming));
	return resourceTiming;
}

var hasRequiredBrowserMetrics;

function requireBrowserMetrics () {
	if (hasRequiredBrowserMetrics) return browserMetrics;
	hasRequiredBrowserMetrics = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const htmlTreeAsString = /*@__PURE__*/ requireHtmlTreeAsString();
		const types = /*@__PURE__*/ requireTypes();
		const cls = /*@__PURE__*/ requireCls();
		const instrument = /*@__PURE__*/ requireInstrument();
		const lcp = /*@__PURE__*/ requireLcp();
		const resourceTiming = /*@__PURE__*/ requireResourceTiming();
		const utils = /*@__PURE__*/ requireUtils$6();
		const getActivationStart = /*@__PURE__*/ requireGetActivationStart();
		const getNavigationEntry = /*@__PURE__*/ requireGetNavigationEntry();
		const getVisibilityWatcher = /*@__PURE__*/ requireGetVisibilityWatcher();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$1();

		const MAX_INT_AS_BYTES = 2147483647;
		let _performanceCursor = 0;
		let _measurements = {};
		let _lcpEntry;
		let _clsEntry;
		function startTrackingWebVitals({
		  recordClsStandaloneSpans,
		  recordLcpStandaloneSpans,
		  client
		}) {
		  const performance = utils.getBrowserPerformanceAPI();
		  if (performance && core.browserPerformanceTimeOrigin()) {
		    if (performance.mark) {
		      types.WINDOW.performance.mark("sentry-tracing-init");
		    }
		    const lcpCleanupCallback = recordLcpStandaloneSpans ? lcp.trackLcpAsStandaloneSpan(client) : recordLcpStandaloneSpans === false ? _trackLCP() : void 0;
		    const clsCleanupCallback = recordClsStandaloneSpans ? cls.trackClsAsStandaloneSpan(client) : recordClsStandaloneSpans === false ? _trackCLS() : void 0;
		    const ttfbCleanupCallback = _trackTtfb();
		    const fpFcpCleanupCallback = _trackFpFcp();
		    return () => {
		      ttfbCleanupCallback();
		      fpFcpCleanupCallback();
		      lcpCleanupCallback?.();
		      clsCleanupCallback?.();
		    };
		  }
		  return () => void 0;
		}
		function startTrackingLongTasks() {
		  instrument.addPerformanceInstrumentationHandler("longtask", ({ entries }) => {
		    const parent = core.getActiveSpan();
		    if (!parent) {
		      return;
		    }
		    const { op: parentOp, start_timestamp: parentStartTimestamp } = core.spanToJSON(parent);
		    for (const entry of entries) {
		      const startTime = utils.msToSec(core.browserPerformanceTimeOrigin() + entry.startTime);
		      const duration = utils.msToSec(entry.duration);
		      if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) {
		        continue;
		      }
		      utils.startAndEndSpan(parent, startTime, startTime + duration, {
		        name: "Main UI thread blocked",
		        op: "ui.long-task",
		        attributes: {
		          [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ui.browser.metrics"
		        }
		      });
		    }
		  });
		}
		function startTrackingLongAnimationFrames() {
		  const observer = new PerformanceObserver((list) => {
		    const parent = core.getActiveSpan();
		    if (!parent) {
		      return;
		    }
		    for (const entry of list.getEntries()) {
		      if (!entry.scripts[0]) {
		        continue;
		      }
		      const startTime = utils.msToSec(core.browserPerformanceTimeOrigin() + entry.startTime);
		      const { start_timestamp: parentStartTimestamp, op: parentOp } = core.spanToJSON(parent);
		      if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) {
		        continue;
		      }
		      const duration = utils.msToSec(entry.duration);
		      const attributes = {
		        [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ui.browser.metrics"
		      };
		      const initialScript = entry.scripts[0];
		      const { invoker, invokerType, sourceURL, sourceFunctionName, sourceCharPosition } = initialScript;
		      attributes["browser.script.invoker"] = invoker;
		      attributes["browser.script.invoker_type"] = invokerType;
		      if (sourceURL) {
		        attributes["code.filepath"] = sourceURL;
		      }
		      if (sourceFunctionName) {
		        attributes["code.function"] = sourceFunctionName;
		      }
		      if (sourceCharPosition !== -1) {
		        attributes["browser.script.source_char_position"] = sourceCharPosition;
		      }
		      utils.startAndEndSpan(parent, startTime, startTime + duration, {
		        name: "Main UI thread blocked",
		        op: "ui.long-animation-frame",
		        attributes
		      });
		    }
		  });
		  observer.observe({ type: "long-animation-frame", buffered: true });
		}
		function startTrackingInteractions() {
		  instrument.addPerformanceInstrumentationHandler("event", ({ entries }) => {
		    const parent = core.getActiveSpan();
		    if (!parent) {
		      return;
		    }
		    for (const entry of entries) {
		      if (entry.name === "click") {
		        const startTime = utils.msToSec(core.browserPerformanceTimeOrigin() + entry.startTime);
		        const duration = utils.msToSec(entry.duration);
		        const spanOptions = {
		          name: htmlTreeAsString.htmlTreeAsString(entry.target),
		          op: `ui.interaction.${entry.name}`,
		          startTime,
		          attributes: {
		            [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ui.browser.metrics"
		          }
		        };
		        const componentName = core.getComponentName(entry.target);
		        if (componentName) {
		          spanOptions.attributes["ui.component_name"] = componentName;
		        }
		        utils.startAndEndSpan(parent, startTime, startTime + duration, spanOptions);
		      }
		    }
		  });
		}
		function _trackCLS() {
		  return instrument.addClsInstrumentationHandler(({ metric }) => {
		    const entry = metric.entries[metric.entries.length - 1];
		    if (!entry) {
		      return;
		    }
		    _measurements["cls"] = { value: metric.value, unit: "" };
		    _clsEntry = entry;
		  }, true);
		}
		function _trackLCP() {
		  return instrument.addLcpInstrumentationHandler(({ metric }) => {
		    const entry = metric.entries[metric.entries.length - 1];
		    if (!entry || !lcp.isValidLcpMetric(metric.value)) {
		      return;
		    }
		    _measurements["lcp"] = { value: metric.value, unit: "millisecond" };
		    _lcpEntry = entry;
		  }, true);
		}
		function _trackTtfb() {
		  return instrument.addTtfbInstrumentationHandler(({ metric }) => {
		    const entry = metric.entries[metric.entries.length - 1];
		    if (!entry) {
		      return;
		    }
		    _measurements["ttfb"] = { value: metric.value, unit: "millisecond" };
		  });
		}
		function _trackFpFcp() {
		  return instrument.addPerformanceInstrumentationHandler("paint", ({ entries }) => {
		    const firstHidden = getVisibilityWatcher.getVisibilityWatcher();
		    for (const entry of entries) {
		      const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
		      if (entry.name === "first-paint" && shouldRecord) {
		        _measurements["fp"] = { value: entry.startTime, unit: "millisecond" };
		      }
		      if (entry.name === "first-contentful-paint" && shouldRecord) {
		        _measurements["fcp"] = { value: entry.startTime, unit: "millisecond" };
		      }
		    }
		  });
		}
		function addPerformanceEntries(span, options) {
		  const performance = utils.getBrowserPerformanceAPI();
		  const origin = core.browserPerformanceTimeOrigin();
		  if (!performance?.getEntries || !origin) {
		    return;
		  }
		  const { spanStreamingEnabled, ignorePerformanceApiSpans, ignoreResourceSpans } = options;
		  const timeOrigin = utils.msToSec(origin);
		  const performanceEntries = performance.getEntries();
		  const { op, start_timestamp: transactionStartTime } = core.spanToJSON(span);
		  performanceEntries.slice(_performanceCursor).forEach((entry) => {
		    const startTime = utils.msToSec(entry.startTime);
		    const duration = utils.msToSec(
		      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
		      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
		      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
		      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
		      Math.max(0, entry.duration)
		    );
		    if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
		      return;
		    }
		    switch (entry.entryType) {
		      case "navigation": {
		        _addNavigationSpans(span, entry, timeOrigin);
		        break;
		      }
		      case "mark":
		      case "paint":
		      case "measure": {
		        _addMeasureSpans(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
		        break;
		      }
		      case "resource": {
		        _addResourceSpans(
		          span,
		          entry,
		          entry.name,
		          startTime,
		          duration,
		          timeOrigin,
		          ignoreResourceSpans
		        );
		        break;
		      }
		    }
		  });
		  _performanceCursor = Math.max(performanceEntries.length - 1, 0);
		  _trackNavigator(span, spanStreamingEnabled);
		}
		function addWebVitalsToSpan(span, options) {
		  const origin = core.browserPerformanceTimeOrigin();
		  if (!utils.getBrowserPerformanceAPI()?.getEntries || !origin) {
		    resetWebVitalState();
		    return;
		  }
		  const { spanStreamingEnabled, recordClsOnPageloadSpan, recordLcpOnPageloadSpan } = options;
		  const timeOrigin = utils.msToSec(origin);
		  if (core.spanToJSON(span).op === "pageload") {
		    _addTtfbRequestTimeToMeasurements(_measurements);
		    if (spanStreamingEnabled) {
		      const setAttr = (shortWebVitalName, value, customAttrName) => {
		        const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
		        span.setAttribute(attrKey, value);
		        debugBuild.DEBUG_BUILD && core.debug.log("Setting web vital attribute", { [attrKey]: value }, "on pageload span");
		      };
		      ["ttfb", "fp", "fcp"].forEach((measurementName) => {
		        if (_measurements[measurementName]) {
		          setAttr(measurementName, _measurements[measurementName].value);
		        }
		      });
		      if (_measurements["ttfb.requestTime"]) {
		        setAttr("ttfb.requestTime", _measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
		      }
		    } else {
		      if (!recordClsOnPageloadSpan) {
		        delete _measurements.cls;
		      }
		      if (!recordLcpOnPageloadSpan) {
		        delete _measurements.lcp;
		      }
		      Object.entries(_measurements).forEach(([measurementName, measurement]) => {
		        core.setMeasurement(measurementName, measurement.value, measurement.unit, span);
		      });
		      _setWebVitalAttributes(span, options);
		    }
		    span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
		    span.setAttribute(
		      spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart",
		      getActivationStart.getActivationStart()
		    );
		  }
		  resetWebVitalState();
		}
		function resetWebVitalState() {
		  _lcpEntry = void 0;
		  _clsEntry = void 0;
		  _measurements = {};
		}
		function isReact19MeasureEntry(entry) {
		  if (entry?.entryType !== "measure") {
		    return;
		  }
		  try {
		    return entry.detail.devtools.track === "Components \u269B";
		  } catch {
		    return;
		  }
		}
		function _addMeasureSpans(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
		  if (isReact19MeasureEntry(entry)) {
		    return;
		  }
		  if (["mark", "measure"].includes(entry.entryType) && core.stringMatchesSomePattern(entry.name, ignorePerformanceApiSpans)) {
		    return;
		  }
		  const navEntry = getNavigationEntry.getNavigationEntry(false);
		  const requestTime = utils.msToSec(navEntry ? navEntry.requestStart : 0);
		  const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
		  const startTimeStamp = timeOrigin + startTime;
		  const measureEndTimestamp = startTimeStamp + duration;
		  const attributes = {
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.resource.browser.metrics"
		  };
		  if (measureStartTimestamp !== startTimeStamp) {
		    attributes["sentry.browser.measure_happened_before_request"] = true;
		    attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
		  }
		  _addDetailToSpanAttributes(attributes, entry);
		  if (measureStartTimestamp <= measureEndTimestamp) {
		    utils.startAndEndSpan(span, measureStartTimestamp, measureEndTimestamp, {
		      name: entry.name,
		      op: entry.entryType,
		      attributes
		    });
		  }
		}
		function _addDetailToSpanAttributes(attributes, performanceMeasure) {
		  try {
		    const detail = performanceMeasure.detail;
		    if (!detail) {
		      return;
		    }
		    if (typeof detail === "object") {
		      for (const [key, value] of Object.entries(detail)) {
		        if (value && core.isPrimitive(value)) {
		          attributes[`sentry.browser.measure.detail.${key}`] = value;
		        } else if (value !== void 0) {
		          try {
		            attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
		          } catch {
		          }
		        }
		      }
		      return;
		    }
		    if (core.isPrimitive(detail)) {
		      attributes["sentry.browser.measure.detail"] = detail;
		      return;
		    }
		    try {
		      attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
		    } catch {
		    }
		  } catch {
		  }
		}
		function _addNavigationSpans(span, entry, timeOrigin) {
		  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((event) => {
		    _addPerformanceNavigationTiming(span, entry, event, timeOrigin);
		  });
		  _addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
		  _addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
		  _addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
		  _addRequest(span, entry, timeOrigin);
		}
		function _addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
		  const eventEnd = _getEndPropertyNameForNavigationTiming(event);
		  const end = entry[eventEnd];
		  const start = entry[`${event}Start`];
		  if (!start || !end) {
		    return;
		  }
		  utils.startAndEndSpan(span, timeOrigin + utils.msToSec(start), timeOrigin + utils.msToSec(end), {
		    op: `browser.${name}`,
		    name: entry.name,
		    attributes: {
		      [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ui.browser.metrics",
		      ...event === "redirect" && entry.redirectCount != null ? { "http.redirect_count": entry.redirectCount } : {}
		    }
		  });
		}
		function _getEndPropertyNameForNavigationTiming(event) {
		  if (event === "secureConnection") {
		    return "connectEnd";
		  }
		  if (event === "fetch") {
		    return "domainLookupStart";
		  }
		  return `${event}End`;
		}
		function _addRequest(span, entry, timeOrigin) {
		  const requestStartTimestamp = timeOrigin + utils.msToSec(entry.requestStart);
		  const responseEndTimestamp = timeOrigin + utils.msToSec(entry.responseEnd);
		  const responseStartTimestamp = timeOrigin + utils.msToSec(entry.responseStart);
		  if (entry.responseEnd) {
		    utils.startAndEndSpan(span, requestStartTimestamp, responseEndTimestamp, {
		      op: "browser.request",
		      name: entry.name,
		      attributes: {
		        [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ui.browser.metrics"
		      }
		    });
		    utils.startAndEndSpan(span, responseStartTimestamp, responseEndTimestamp, {
		      op: "browser.response",
		      name: entry.name,
		      attributes: {
		        [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ui.browser.metrics"
		      }
		    });
		  }
		}
		function _addResourceSpans(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
		  if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") {
		    return;
		  }
		  const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
		  if (ignoredResourceSpanOps?.includes(op)) {
		    return;
		  }
		  const attributes = {
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.resource.browser.metrics"
		  };
		  const parsedUrl = core.parseUrl(resourceUrl);
		  if (parsedUrl.protocol) {
		    attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
		  }
		  if (parsedUrl.host) {
		    attributes["server.address"] = parsedUrl.host;
		  }
		  attributes["url.same_origin"] = resourceUrl.includes(types.WINDOW.location.origin);
		  _setResourceRequestAttributes(entry, attributes, [
		    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
		    ["responseStatus", "http.response.status_code"],
		    ["transferSize", "http.response_transfer_size"],
		    ["encodedBodySize", "http.response_content_length"],
		    ["decodedBodySize", "http.decoded_response_content_length"],
		    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
		    ["renderBlockingStatus", "resource.render_blocking_status"],
		    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
		    ["deliveryType", "http.response_delivery_type"]
		  ]);
		  const attributesWithResourceTiming = { ...attributes, ...resourceTiming.resourceTimingToSpanAttributes(entry) };
		  const startTimestamp = timeOrigin + startTime;
		  const endTimestamp = startTimestamp + duration;
		  utils.startAndEndSpan(span, startTimestamp, endTimestamp, {
		    name: resourceUrl.replace(types.WINDOW.location.origin, ""),
		    op,
		    attributes: attributesWithResourceTiming
		  });
		}
		function _trackNavigator(span, spanStreamingEnabled) {
		  const navigator = types.WINDOW.navigator;
		  if (!navigator) {
		    return;
		  }
		  const connection = navigator.connection;
		  if (connection) {
		    if (connection.effectiveType) {
		      span.setAttribute(
		        spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType",
		        connection.effectiveType
		      );
		    }
		    if (connection.type) {
		      span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
		    }
		    if (utils.isMeasurementValue(connection.rtt)) {
		      if (spanStreamingEnabled) {
		        span.setAttribute("network.connection.rtt", connection.rtt);
		      } else if (core.spanToJSON(span).op === "pageload") {
		        core.setMeasurement("connection.rtt", connection.rtt, "millisecond");
		      }
		    }
		  }
		  if (utils.isMeasurementValue(navigator.deviceMemory)) {
		    if (spanStreamingEnabled) {
		      span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
		    } else {
		      span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
		    }
		  }
		  if (utils.isMeasurementValue(navigator.hardwareConcurrency)) {
		    if (spanStreamingEnabled) {
		      span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
		    } else {
		      span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
		    }
		  }
		}
		function _setWebVitalAttributes(span, options) {
		  if (_lcpEntry && options.recordLcpOnPageloadSpan) {
		    if (_lcpEntry.element) {
		      span.setAttribute("lcp.element", htmlTreeAsString.htmlTreeAsString(_lcpEntry.element));
		    }
		    if (_lcpEntry.id) {
		      span.setAttribute("lcp.id", _lcpEntry.id);
		    }
		    if (_lcpEntry.url) {
		      span.setAttribute("lcp.url", _lcpEntry.url.trim().slice(0, 200));
		    }
		    if (_lcpEntry.loadTime != null) {
		      span.setAttribute("lcp.loadTime", _lcpEntry.loadTime);
		    }
		    if (_lcpEntry.renderTime != null) {
		      span.setAttribute("lcp.renderTime", _lcpEntry.renderTime);
		    }
		    span.setAttribute("lcp.size", _lcpEntry.size);
		  }
		  if (_clsEntry?.sources && options.recordClsOnPageloadSpan) {
		    _clsEntry.sources.forEach(
		      (source, index) => span.setAttribute(`cls.source.${index + 1}`, htmlTreeAsString.htmlTreeAsString(source.node))
		    );
		  }
		}
		function _setResourceRequestAttributes(entry, attributes, properties) {
		  properties.forEach(([entryKey, attributeKey]) => {
		    const entryVal = entry[entryKey];
		    if (entryVal != null && (typeof entryVal === "number" && entryVal < MAX_INT_AS_BYTES || typeof entryVal === "string")) {
		      attributes[attributeKey] = entryVal;
		    }
		  });
		}
		function _addTtfbRequestTimeToMeasurements(_measurements2) {
		  const navEntry = getNavigationEntry.getNavigationEntry(false);
		  if (!navEntry) {
		    return;
		  }
		  const { responseStart, requestStart } = navEntry;
		  if (requestStart <= responseStart) {
		    _measurements2["ttfb.requestTime"] = {
		      value: responseStart - requestStart,
		      unit: "millisecond"
		    };
		  }
		}

		exports._addMeasureSpans = _addMeasureSpans;
		exports._addNavigationSpans = _addNavigationSpans;
		exports._addResourceSpans = _addResourceSpans;
		exports._setResourceRequestAttributes = _setResourceRequestAttributes;
		exports.addPerformanceEntries = addPerformanceEntries;
		exports.addWebVitalsToSpan = addWebVitalsToSpan;
		exports.startTrackingInteractions = startTrackingInteractions;
		exports.startTrackingLongAnimationFrames = startTrackingLongAnimationFrames;
		exports.startTrackingLongTasks = startTrackingLongTasks;
		exports.startTrackingWebVitals = startTrackingWebVitals;
		
	} (browserMetrics));
	return browserMetrics;
}

var elementTiming = {};

var hasRequiredElementTiming;

function requireElementTiming () {
	if (hasRequiredElementTiming) return elementTiming;
	hasRequiredElementTiming = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const instrument = /*@__PURE__*/ requireInstrument();
		const utils = /*@__PURE__*/ requireUtils$6();

		const INTEGRATION_NAME = "ElementTiming";
		const _elementTimingIntegration = (() => {
		  return {
		    name: INTEGRATION_NAME,
		    setup() {
		      const performance = utils.getBrowserPerformanceAPI();
		      if (!performance || !core.browserPerformanceTimeOrigin()) {
		        return;
		      }
		      instrument.addPerformanceInstrumentationHandler("element", ({ entries }) => {
		        for (const entry of entries) {
		          const elementEntry = entry;
		          if (!elementEntry.identifier) {
		            continue;
		          }
		          const identifier = elementEntry.identifier;
		          const paintType = elementEntry.name;
		          const renderTime = elementEntry.renderTime;
		          const loadTime = elementEntry.loadTime;
		          const metricAttributes = {
		            "sentry.origin": "auto.ui.browser.element_timing",
		            "ui.element.identifier": identifier
		          };
		          if (paintType) {
		            metricAttributes["ui.element.paint_type"] = paintType;
		          }
		          if (elementEntry.id) {
		            metricAttributes["ui.element.id"] = elementEntry.id;
		          }
		          if (elementEntry.element) {
		            metricAttributes["ui.element.type"] = elementEntry.element.tagName.toLowerCase();
		          }
		          if (elementEntry.url) {
		            metricAttributes["ui.element.url"] = elementEntry.url;
		          }
		          if (elementEntry.naturalWidth) {
		            metricAttributes["ui.element.width"] = elementEntry.naturalWidth;
		          }
		          if (elementEntry.naturalHeight) {
		            metricAttributes["ui.element.height"] = elementEntry.naturalHeight;
		          }
		          if (renderTime > 0) {
		            core.metrics.distribution(`ui.element.render_time`, renderTime, {
		              unit: "millisecond",
		              attributes: metricAttributes
		            });
		          }
		          if (loadTime > 0) {
		            core.metrics.distribution(`ui.element.load_time`, loadTime, {
		              unit: "millisecond",
		              attributes: metricAttributes
		            });
		          }
		        }
		      });
		    }
		  };
		});
		const elementTimingIntegration = core.defineIntegration(_elementTimingIntegration);
		function startTrackingElementTiming() {
		  return () => void 0;
		}

		exports.elementTimingIntegration = elementTimingIntegration;
		exports.startTrackingElementTiming = startTrackingElementTiming;
		
	} (elementTiming));
	return elementTiming;
}

var webVitalSpans = {};

var inp = {};

var hasRequiredInp;

function requireInp () {
	if (hasRequiredInp) return inp;
	hasRequiredInp = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const htmlTreeAsString = /*@__PURE__*/ requireHtmlTreeAsString();
		const types = /*@__PURE__*/ requireTypes();
		const instrument = /*@__PURE__*/ requireInstrument();
		const utils = /*@__PURE__*/ requireUtils$6();

		const LAST_INTERACTIONS = [];
		const INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
		const ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
		const MAX_PLAUSIBLE_INP_DURATION = 60;
		function startTrackingINP() {
		  const performance = utils.getBrowserPerformanceAPI();
		  if (performance && core.browserPerformanceTimeOrigin()) {
		    const inpCallback = _trackINP();
		    return () => {
		      inpCallback();
		    };
		  }
		  return () => void 0;
		}
		const INP_ENTRY_MAP = {
		  click: "click",
		  pointerdown: "click",
		  pointerup: "click",
		  mousedown: "click",
		  mouseup: "click",
		  touchstart: "click",
		  touchend: "click",
		  mouseover: "hover",
		  mouseout: "hover",
		  mouseenter: "hover",
		  mouseleave: "hover",
		  pointerover: "hover",
		  pointerout: "hover",
		  pointerenter: "hover",
		  pointerleave: "hover",
		  dragstart: "drag",
		  dragend: "drag",
		  drag: "drag",
		  dragenter: "drag",
		  dragleave: "drag",
		  dragover: "drag",
		  drop: "drag",
		  keydown: "press",
		  keyup: "press",
		  keypress: "press",
		  input: "press"
		};
		function _trackINP() {
		  return instrument.addInpInstrumentationHandler(_onInp);
		}
		const _onInp = ({ metric }) => {
		  if (metric.value == void 0) {
		    return;
		  }
		  const duration = utils.msToSec(metric.value);
		  if (duration > MAX_PLAUSIBLE_INP_DURATION) {
		    return;
		  }
		  const entry = metric.entries.find((entry2) => entry2.duration === metric.value && INP_ENTRY_MAP[entry2.name]);
		  if (!entry) {
		    return;
		  }
		  const { interactionId } = entry;
		  const interactionType = INP_ENTRY_MAP[entry.name];
		  const startTime = utils.msToSec(core.browserPerformanceTimeOrigin() + entry.startTime);
		  const activeSpan = core.getActiveSpan();
		  const rootSpan = activeSpan ? core.getRootSpan(activeSpan) : void 0;
		  const cachedInteractionContext = interactionId != null ? INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
		  const spanToUse = cachedInteractionContext?.span || rootSpan;
		  const routeName = spanToUse ? core.spanToJSON(spanToUse).description : core.getCurrentScope().getScopeData().transactionName;
		  const name = cachedInteractionContext?.elementName || htmlTreeAsString.htmlTreeAsString(entry.target);
		  const attributes = {
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.http.browser.inp",
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `ui.interaction.${interactionType}`,
		    [core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: entry.duration
		  };
		  const span = utils.startStandaloneWebVitalSpan({
		    name,
		    transaction: routeName,
		    attributes,
		    startTime
		  });
		  if (span) {
		    span.addEvent("inp", {
		      [core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: "millisecond",
		      [core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: metric.value
		    });
		    span.end(startTime + duration);
		  }
		};
		function getCachedInteractionContext(interactionId) {
		  return interactionId != null ? INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
		}
		function registerInpInteractionListener() {
		  const interactionEvents = Object.keys(INP_ENTRY_MAP);
		  if (core.isBrowser()) {
		    interactionEvents.forEach((eventType) => {
		      types.WINDOW.addEventListener(eventType, captureElementFromEvent, { capture: true, passive: true });
		    });
		  }
		  function captureElementFromEvent(event) {
		    const target = event.target;
		    if (!target) {
		      return;
		    }
		    const elementName = htmlTreeAsString.htmlTreeAsString(target);
		    const timestamp = Math.round(event.timeStamp);
		    ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
		    if (ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
		      const firstKey = ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
		      if (firstKey !== void 0) {
		        ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
		      }
		    }
		  }
		  function resolveElementNameFromEntry(entry) {
		    const timestamp = Math.round(entry.startTime);
		    let elementName = ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
		    if (!elementName) {
		      for (let offset = -5; offset <= 5; offset++) {
		        const nearbyName = ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
		        if (nearbyName) {
		          elementName = nearbyName;
		          break;
		        }
		      }
		    }
		    return elementName || "<unknown>";
		  }
		  const handleEntries = ({ entries }) => {
		    const activeSpan = core.getActiveSpan();
		    const activeRootSpan = activeSpan && core.getRootSpan(activeSpan);
		    entries.forEach((entry) => {
		      if (!instrument.isPerformanceEventTiming(entry)) {
		        return;
		      }
		      const interactionId = entry.interactionId;
		      if (interactionId == null) {
		        return;
		      }
		      if (INTERACTIONS_SPAN_MAP.has(interactionId)) {
		        return;
		      }
		      const elementName = entry.target ? htmlTreeAsString.htmlTreeAsString(entry.target) : resolveElementNameFromEntry(entry);
		      if (LAST_INTERACTIONS.length > 10) {
		        const last = LAST_INTERACTIONS.shift();
		        INTERACTIONS_SPAN_MAP.delete(last);
		      }
		      LAST_INTERACTIONS.push(interactionId);
		      INTERACTIONS_SPAN_MAP.set(interactionId, {
		        span: activeRootSpan,
		        elementName
		      });
		    });
		  };
		  instrument.addPerformanceInstrumentationHandler("event", handleEntries);
		  instrument.addPerformanceInstrumentationHandler("first-input", handleEntries);
		}

		exports.INP_ENTRY_MAP = INP_ENTRY_MAP;
		exports.MAX_PLAUSIBLE_INP_DURATION = MAX_PLAUSIBLE_INP_DURATION;
		exports._onInp = _onInp;
		exports._trackINP = _trackINP;
		exports.getCachedInteractionContext = getCachedInteractionContext;
		exports.registerInpInteractionListener = registerInpInteractionListener;
		exports.startTrackingINP = startTrackingINP;
		
	} (inp));
	return inp;
}

var hasRequiredWebVitalSpans;

function requireWebVitalSpans () {
	if (hasRequiredWebVitalSpans) return webVitalSpans;
	hasRequiredWebVitalSpans = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$1();
		const htmlTreeAsString = /*@__PURE__*/ requireHtmlTreeAsString();
		const types = /*@__PURE__*/ requireTypes();
		const inp = /*@__PURE__*/ requireInp();
		const instrument = /*@__PURE__*/ requireInstrument();
		const lcp = /*@__PURE__*/ requireLcp();
		const utils = /*@__PURE__*/ requireUtils$6();

		function _emitWebVitalSpan(options) {
		  const {
		    name,
		    op,
		    origin,
		    metricName,
		    value,
		    attributes: passedAttributes,
		    parentSpan,
		    reportEvent,
		    startTime,
		    endTime
		  } = options;
		  const routeName = core.getCurrentScope().getScopeData().transactionName;
		  const attributes = {
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: origin,
		    [core.SEMANTIC_ATTRIBUTE_SENTRY_OP]: op,
		    [core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: 0,
		    [`browser.web_vital.${metricName}.value`]: value,
		    "sentry.transaction": routeName,
		    // Web vital score calculation relies on the user agent
		    "user_agent.original": types.WINDOW.navigator?.userAgent,
		    ...passedAttributes
		  };
		  if (parentSpan && core.spanToStreamedSpanJSON(parentSpan).attributes?.[core.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "pageload") {
		    attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
		  }
		  if (reportEvent) {
		    attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
		  }
		  const span = core.startInactiveSpan({
		    name,
		    attributes,
		    startTime,
		    // if we have a pageload span, we let the web vital span start as its parent. This ensures that
		    // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
		    // that has `segment: false` but no actual parent span.
		    parentSpan
		  });
		  if (span) {
		    span.end(endTime ?? startTime);
		  }
		}
		function trackLcpAsSpan(client) {
		  let lcpValue = 0;
		  let lcpEntry;
		  if (!utils.supportsWebVital("largest-contentful-paint")) {
		    return;
		  }
		  const cleanupLcpHandler = instrument.addLcpInstrumentationHandler(({ metric }) => {
		    const entry = metric.entries[metric.entries.length - 1];
		    if (!entry || !lcp.isValidLcpMetric(metric.value)) {
		      return;
		    }
		    lcpValue = metric.value;
		    lcpEntry = entry;
		  }, true);
		  utils.listenForWebVitalReportEvents(client, (reportEvent, _, pageloadSpan) => {
		    _sendLcpSpan(lcpValue, lcpEntry, pageloadSpan, reportEvent);
		    cleanupLcpHandler();
		  });
		}
		function _sendLcpSpan(lcpValue, entry, pageloadSpan, reportEvent) {
		  if (!lcp.isValidLcpMetric(lcpValue)) {
		    return;
		  }
		  debugBuild.DEBUG_BUILD && core.debug.log(`Sending LCP span (${lcpValue})`);
		  const performanceTimeOrigin = core.browserPerformanceTimeOrigin() || 0;
		  const timeOrigin = utils.msToSec(performanceTimeOrigin);
		  const endTime = utils.msToSec(performanceTimeOrigin + (entry?.startTime || 0));
		  const name = entry ? htmlTreeAsString.htmlTreeAsString(entry.element) : "Largest contentful paint";
		  const attributes = {};
		  entry?.element && (attributes["browser.web_vital.lcp.element"] = htmlTreeAsString.htmlTreeAsString(entry.element));
		  entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
		  entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
		  entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
		  entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
		  entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
		  _emitWebVitalSpan({
		    name,
		    op: "ui.webvital.lcp",
		    origin: "auto.http.browser.lcp",
		    metricName: "lcp",
		    value: lcpValue,
		    attributes,
		    parentSpan: pageloadSpan,
		    reportEvent,
		    startTime: timeOrigin,
		    endTime
		  });
		}
		function trackClsAsSpan(client) {
		  let clsValue = 0;
		  let clsEntry;
		  if (!utils.supportsWebVital("layout-shift")) {
		    return;
		  }
		  const cleanupClsHandler = instrument.addClsInstrumentationHandler(({ metric }) => {
		    const entry = metric.entries[metric.entries.length - 1];
		    if (!entry) {
		      return;
		    }
		    clsValue = metric.value;
		    clsEntry = entry;
		  }, true);
		  utils.listenForWebVitalReportEvents(client, (reportEvent, _, pageloadSpan) => {
		    _sendClsSpan(clsValue, clsEntry, pageloadSpan, reportEvent);
		    cleanupClsHandler();
		  });
		}
		function _sendClsSpan(clsValue, entry, pageloadSpan, reportEvent) {
		  debugBuild.DEBUG_BUILD && core.debug.log(`Sending CLS span (${clsValue})`);
		  const startTime = entry ? utils.msToSec((core.browserPerformanceTimeOrigin() || 0) + entry.startTime) : core.timestampInSeconds();
		  const name = entry ? htmlTreeAsString.htmlTreeAsString(entry.sources[0]?.node) : "Layout shift";
		  const attributes = {};
		  if (entry?.sources) {
		    entry.sources.forEach((source, index) => {
		      attributes[`browser.web_vital.cls.source.${index + 1}`] = htmlTreeAsString.htmlTreeAsString(source.node);
		    });
		  }
		  _emitWebVitalSpan({
		    name,
		    op: "ui.webvital.cls",
		    origin: "auto.http.browser.cls",
		    metricName: "cls",
		    value: clsValue,
		    attributes,
		    parentSpan: pageloadSpan,
		    reportEvent,
		    startTime
		  });
		}
		function trackInpAsSpan() {
		  const performance = utils.getBrowserPerformanceAPI();
		  if (!performance || !core.browserPerformanceTimeOrigin()) {
		    return;
		  }
		  const onInp = ({ metric }) => {
		    if (metric.value == null) {
		      return;
		    }
		    const duration = utils.msToSec(metric.value);
		    if (duration > inp.MAX_PLAUSIBLE_INP_DURATION) {
		      return;
		    }
		    const entry = metric.entries.find((e) => e.duration === metric.value && inp.INP_ENTRY_MAP[e.name]);
		    if (!entry) {
		      return;
		    }
		    _sendInpSpan(metric.value, entry);
		  };
		  instrument.addInpInstrumentationHandler(onInp);
		}
		function _sendInpSpan(inpValue, entry) {
		  debugBuild.DEBUG_BUILD && core.debug.log(`Sending INP span (${inpValue})`);
		  const startTime = utils.msToSec(core.browserPerformanceTimeOrigin() + entry.startTime);
		  const duration = utils.msToSec(inpValue);
		  const interactionType = inp.INP_ENTRY_MAP[entry.name];
		  const cachedContext = inp.getCachedInteractionContext(entry.interactionId);
		  const activeSpan = core.getActiveSpan();
		  const rootSpan = activeSpan ? core.getRootSpan(activeSpan) : void 0;
		  const spanToUse = cachedContext?.span || rootSpan;
		  const routeName = spanToUse ? core.spanToStreamedSpanJSON(spanToUse).name : core.getCurrentScope().getScopeData().transactionName;
		  const name = cachedContext?.elementName || htmlTreeAsString.htmlTreeAsString(entry.target);
		  _emitWebVitalSpan({
		    name,
		    op: `ui.interaction.${interactionType}`,
		    origin: "auto.http.browser.inp",
		    metricName: "inp",
		    value: inpValue,
		    attributes: {
		      [core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: entry.duration,
		      "sentry.transaction": routeName
		    },
		    startTime,
		    endTime: startTime + duration,
		    parentSpan: spanToUse
		  });
		}

		exports._emitWebVitalSpan = _emitWebVitalSpan;
		exports._sendClsSpan = _sendClsSpan;
		exports._sendInpSpan = _sendInpSpan;
		exports._sendLcpSpan = _sendLcpSpan;
		exports.trackClsAsSpan = trackClsAsSpan;
		exports.trackInpAsSpan = trackInpAsSpan;
		exports.trackLcpAsSpan = trackLcpAsSpan;
		
	} (webVitalSpans));
	return webVitalSpans;
}

var dom = {};

var hasRequiredDom;

function requireDom () {
	if (hasRequiredDom) return dom;
	hasRequiredDom = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const types = /*@__PURE__*/ requireTypes();

		const DEBOUNCE_DURATION = 1e3;
		let debounceTimerID;
		let lastCapturedEventType;
		let lastCapturedEventTargetId;
		function addClickKeypressInstrumentationHandler(handler) {
		  const type = "dom";
		  core.addHandler(type, handler);
		  core.maybeInstrument(type, instrumentDOM);
		}
		function instrumentDOM() {
		  if (!types.WINDOW.document) {
		    return;
		  }
		  const triggerDOMHandler = core.triggerHandlers.bind(null, "dom");
		  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
		  types.WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
		  types.WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
		  ["EventTarget", "Node"].forEach((target) => {
		    const globalObject = types.WINDOW;
		    const proto = globalObject[target]?.prototype;
		    if (!proto?.hasOwnProperty?.("addEventListener")) {
		      return;
		    }
		    core.fill(proto, "addEventListener", function(originalAddEventListener) {
		      return function(type, listener, options) {
		        if (type === "click" || type == "keypress") {
		          try {
		            const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
		            const handlerForType = handlers[type] = handlers[type] || { refCount: 0 };
		            if (!handlerForType.handler) {
		              const handler = makeDOMEventHandler(triggerDOMHandler);
		              handlerForType.handler = handler;
		              originalAddEventListener.call(this, type, handler, options);
		            }
		            handlerForType.refCount++;
		          } catch {
		          }
		        }
		        return originalAddEventListener.call(this, type, listener, options);
		      };
		    });
		    core.fill(
		      proto,
		      "removeEventListener",
		      function(originalRemoveEventListener) {
		        return function(type, listener, options) {
		          if (type === "click" || type == "keypress") {
		            try {
		              const handlers = this.__sentry_instrumentation_handlers__ || {};
		              const handlerForType = handlers[type];
		              if (handlerForType) {
		                handlerForType.refCount--;
		                if (handlerForType.refCount <= 0) {
		                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
		                  handlerForType.handler = void 0;
		                  delete handlers[type];
		                }
		                if (Object.keys(handlers).length === 0) {
		                  delete this.__sentry_instrumentation_handlers__;
		                }
		              }
		            } catch {
		            }
		          }
		          return originalRemoveEventListener.call(this, type, listener, options);
		        };
		      }
		    );
		  });
		}
		function isSimilarToLastCapturedEvent(event) {
		  if (event.type !== lastCapturedEventType) {
		    return false;
		  }
		  try {
		    if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
		      return false;
		    }
		  } catch {
		  }
		  return true;
		}
		function shouldSkipDOMEvent(eventType, target) {
		  if (eventType !== "keypress") {
		    return false;
		  }
		  if (!target?.tagName) {
		    return true;
		  }
		  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
		    return false;
		  }
		  return true;
		}
		function makeDOMEventHandler(handler, globalListener = false) {
		  return (event) => {
		    if (!event || event["_sentryCaptured"]) {
		      return;
		    }
		    const target = getEventTarget(event);
		    if (shouldSkipDOMEvent(event.type, target)) {
		      return;
		    }
		    core.addNonEnumerableProperty(event, "_sentryCaptured", true);
		    if (target && !target._sentryId) {
		      core.addNonEnumerableProperty(target, "_sentryId", core.uuid4());
		    }
		    const name = event.type === "keypress" ? "input" : event.type;
		    if (!isSimilarToLastCapturedEvent(event)) {
		      const handlerData = { event, name, global: globalListener };
		      handler(handlerData);
		      lastCapturedEventType = event.type;
		      lastCapturedEventTargetId = target ? target._sentryId : void 0;
		    }
		    clearTimeout(debounceTimerID);
		    debounceTimerID = types.WINDOW.setTimeout(() => {
		      lastCapturedEventTargetId = void 0;
		      lastCapturedEventType = void 0;
		    }, DEBOUNCE_DURATION);
		  };
		}
		function getEventTarget(event) {
		  try {
		    return event.target;
		  } catch {
		    return null;
		  }
		}

		exports.addClickKeypressInstrumentationHandler = addClickKeypressInstrumentationHandler;
		exports.instrumentDOM = instrumentDOM;
		
	} (dom));
	return dom;
}

var history = {};

var hasRequiredHistory;

function requireHistory () {
	if (hasRequiredHistory) return history;
	hasRequiredHistory = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const types = /*@__PURE__*/ requireTypes();

		let lastHref;
		function addHistoryInstrumentationHandler(handler) {
		  const type = "history";
		  core.addHandler(type, handler);
		  core.maybeInstrument(type, instrumentHistory);
		}
		function instrumentHistory() {
		  types.WINDOW.addEventListener("popstate", () => {
		    const to = types.WINDOW.location.href;
		    const from = lastHref;
		    lastHref = to;
		    if (from === to) {
		      return;
		    }
		    const handlerData = { from, to };
		    core.triggerHandlers("history", handlerData);
		  });
		  if (!core.supportsHistory()) {
		    return;
		  }
		  function historyReplacementFunction(originalHistoryFunction) {
		    return function(...args) {
		      const url = args.length > 2 ? args[2] : void 0;
		      if (url) {
		        const from = lastHref;
		        const to = getAbsoluteUrl(String(url));
		        lastHref = to;
		        if (from === to) {
		          return originalHistoryFunction.apply(this, args);
		        }
		        const handlerData = { from, to };
		        core.triggerHandlers("history", handlerData);
		      }
		      return originalHistoryFunction.apply(this, args);
		    };
		  }
		  core.fill(types.WINDOW.history, "pushState", historyReplacementFunction);
		  core.fill(types.WINDOW.history, "replaceState", historyReplacementFunction);
		}
		function getAbsoluteUrl(urlOrPath) {
		  try {
		    const url = new URL(urlOrPath, types.WINDOW.location.origin);
		    return url.toString();
		  } catch {
		    return urlOrPath;
		  }
		}

		exports.addHistoryInstrumentationHandler = addHistoryInstrumentationHandler;
		exports.instrumentHistory = instrumentHistory;
		
	} (history));
	return history;
}

var getNativeImplementation = {};

var hasRequiredGetNativeImplementation;

function requireGetNativeImplementation () {
	if (hasRequiredGetNativeImplementation) return getNativeImplementation;
	hasRequiredGetNativeImplementation = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$1();
		const types = /*@__PURE__*/ requireTypes();

		const cachedImplementations = {};
		function getNativeImplementation(name) {
		  const cached = cachedImplementations[name];
		  if (cached) {
		    return cached;
		  }
		  let impl = types.WINDOW[name];
		  if (core.isNativeFunction(impl)) {
		    return cachedImplementations[name] = impl.bind(types.WINDOW);
		  }
		  const document = types.WINDOW.document;
		  if (document && typeof document.createElement === "function") {
		    try {
		      const sandbox = document.createElement("iframe");
		      sandbox.hidden = true;
		      document.head.appendChild(sandbox);
		      const contentWindow = sandbox.contentWindow;
		      if (contentWindow?.[name]) {
		        impl = contentWindow[name];
		      }
		      document.head.removeChild(sandbox);
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && core.debug.warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
		    }
		  }
		  if (!impl) {
		    return impl;
		  }
		  return cachedImplementations[name] = impl.bind(types.WINDOW);
		}
		function clearCachedImplementation(name) {
		  cachedImplementations[name] = void 0;
		}
		function fetch(...rest) {
		  return getNativeImplementation("fetch")(...rest);
		}
		function setTimeout(...rest) {
		  return getNativeImplementation("setTimeout")(...rest);
		}

		exports.clearCachedImplementation = clearCachedImplementation;
		exports.fetch = fetch;
		exports.getNativeImplementation = getNativeImplementation;
		exports.setTimeout = setTimeout;
		
	} (getNativeImplementation));
	return getNativeImplementation;
}

var xhr = {};

var hasRequiredXhr;

function requireXhr () {
	if (hasRequiredXhr) return xhr;
	hasRequiredXhr = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const types = /*@__PURE__*/ requireTypes();

		const SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
		function addXhrInstrumentationHandler(handler) {
		  const type = "xhr";
		  core.addHandler(type, handler);
		  core.maybeInstrument(type, instrumentXHR);
		}
		function instrumentXHR() {
		  if (!types.WINDOW.XMLHttpRequest) {
		    return;
		  }
		  const xhrproto = XMLHttpRequest.prototype;
		  xhrproto.open = new Proxy(xhrproto.open, {
		    apply(originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
		      const virtualError = new Error();
		      const startTimestamp = core.timestampInSeconds() * 1e3;
		      const method = core.isString(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
		      const url = parseXhrUrlArg(xhrOpenArgArray[1]);
		      if (!method || !url) {
		        return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
		      }
		      xhrOpenThisArg[SENTRY_XHR_DATA_KEY] = {
		        method,
		        url,
		        request_headers: {}
		      };
		      if (method === "POST" && url.match(/sentry_key/)) {
		        xhrOpenThisArg.__sentry_own_request__ = true;
		      }
		      const onreadystatechangeHandler = () => {
		        const xhrInfo = xhrOpenThisArg[SENTRY_XHR_DATA_KEY];
		        if (!xhrInfo) {
		          return;
		        }
		        if (xhrOpenThisArg.readyState === 4) {
		          try {
		            xhrInfo.status_code = xhrOpenThisArg.status;
		          } catch {
		          }
		          const handlerData = {
		            endTimestamp: core.timestampInSeconds() * 1e3,
		            startTimestamp,
		            xhr: xhrOpenThisArg,
		            virtualError
		          };
		          core.triggerHandlers("xhr", handlerData);
		        }
		      };
		      if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") {
		        xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
		          apply(originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
		            onreadystatechangeHandler();
		            return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
		          }
		        });
		      } else {
		        xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
		      }
		      xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
		        apply(originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
		          const [header, value] = setRequestHeaderArgArray;
		          const xhrInfo = setRequestHeaderThisArg[SENTRY_XHR_DATA_KEY];
		          if (xhrInfo && core.isString(header) && core.isString(value)) {
		            xhrInfo.request_headers[header.toLowerCase()] = value;
		          }
		          return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
		        }
		      });
		      return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
		    }
		  });
		  xhrproto.send = new Proxy(xhrproto.send, {
		    apply(originalSend, sendThisArg, sendArgArray) {
		      const sentryXhrData = sendThisArg[SENTRY_XHR_DATA_KEY];
		      if (!sentryXhrData) {
		        return originalSend.apply(sendThisArg, sendArgArray);
		      }
		      if (sendArgArray[0] !== void 0) {
		        sentryXhrData.body = sendArgArray[0];
		      }
		      const handlerData = {
		        startTimestamp: core.timestampInSeconds() * 1e3,
		        xhr: sendThisArg
		      };
		      core.triggerHandlers("xhr", handlerData);
		      return originalSend.apply(sendThisArg, sendArgArray);
		    }
		  });
		}
		function parseXhrUrlArg(url) {
		  if (core.isString(url)) {
		    return url;
		  }
		  try {
		    return url.toString();
		  } catch {
		  }
		  return void 0;
		}

		exports.SENTRY_XHR_DATA_KEY = SENTRY_XHR_DATA_KEY;
		exports.addXhrInstrumentationHandler = addXhrInstrumentationHandler;
		exports.instrumentXHR = instrumentXHR;
		
	} (xhr));
	return xhr;
}

var networkUtils = {};

var hasRequiredNetworkUtils;

function requireNetworkUtils () {
	if (hasRequiredNetworkUtils) return networkUtils;
	hasRequiredNetworkUtils = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const debugBuild = /*@__PURE__*/ requireDebugBuild$1();

		const ORIGINAL_REQ_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
		function serializeFormData(formData) {
		  return new URLSearchParams(formData).toString();
		}
		function getBodyString(body, _debug = core.debug) {
		  try {
		    if (typeof body === "string") {
		      return [body];
		    }
		    if (body instanceof URLSearchParams) {
		      return [body.toString()];
		    }
		    if (body instanceof FormData) {
		      return [serializeFormData(body)];
		    }
		    if (!body) {
		      return [void 0];
		    }
		  } catch (error) {
		    debugBuild.DEBUG_BUILD && _debug.error(error, "Failed to serialize body", body);
		    return [void 0, "BODY_PARSE_ERROR"];
		  }
		  debugBuild.DEBUG_BUILD && _debug.log("Skipping network body because of body type", body);
		  return [void 0, "UNPARSEABLE_BODY_TYPE"];
		}
		function getFetchRequestArgBody(fetchArgs = []) {
		  if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) {
		    return fetchArgs[1].body;
		  }
		  if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
		    const request = fetchArgs[0];
		    const originalBody = request[ORIGINAL_REQ_BODY];
		    if (originalBody !== void 0) {
		      return originalBody;
		    }
		    return void 0;
		  }
		  return void 0;
		}
		function parseXhrResponseHeaders(xhr) {
		  let headers;
		  try {
		    headers = xhr.getAllResponseHeaders();
		  } catch (error) {
		    debugBuild.DEBUG_BUILD && core.debug.error(error, "Failed to get xhr response headers", xhr);
		    return {};
		  }
		  if (!headers) {
		    return {};
		  }
		  return headers.split("\r\n").reduce((acc, line) => {
		    const [key, value] = line.split(": ");
		    if (value) {
		      acc[key.toLowerCase()] = value;
		    }
		    return acc;
		  }, {});
		}

		exports.ORIGINAL_REQ_BODY = ORIGINAL_REQ_BODY;
		exports.getBodyString = getBodyString;
		exports.getFetchRequestArgBody = getFetchRequestArgBody;
		exports.parseXhrResponseHeaders = parseXhrResponseHeaders;
		exports.serializeFormData = serializeFormData;
		
	} (networkUtils));
	return networkUtils;
}

var is = {};

var hasRequiredIs;

function requireIs () {
	if (hasRequiredIs) return is;
	hasRequiredIs = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		function isElement(wat) {
		  if (typeof Element === "undefined") {
		    return false;
		  }
		  try {
		    return wat instanceof Element;
		  } catch {
		    return false;
		  }
		}

		exports.isElement = isElement;
		
	} (is));
	return is;
}

var hasRequiredCjs$2;

function requireCjs$2 () {
	if (hasRequiredCjs$2) return cjs$2;
	hasRequiredCjs$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const instrument = /*@__PURE__*/ requireInstrument();
		const browserMetrics = /*@__PURE__*/ requireBrowserMetrics();
		const elementTiming = /*@__PURE__*/ requireElementTiming();
		const utils = /*@__PURE__*/ requireUtils$6();
		const webVitalSpans = /*@__PURE__*/ requireWebVitalSpans();
		const dom = /*@__PURE__*/ requireDom();
		const history = /*@__PURE__*/ requireHistory();
		const getNativeImplementation = /*@__PURE__*/ requireGetNativeImplementation();
		const xhr = /*@__PURE__*/ requireXhr();
		const networkUtils = /*@__PURE__*/ requireNetworkUtils();
		const resourceTiming = /*@__PURE__*/ requireResourceTiming();
		const htmlTreeAsString = /*@__PURE__*/ requireHtmlTreeAsString();
		const is = /*@__PURE__*/ requireIs();
		const inp = /*@__PURE__*/ requireInp();



		exports.addClsInstrumentationHandler = instrument.addClsInstrumentationHandler;
		exports.addInpInstrumentationHandler = instrument.addInpInstrumentationHandler;
		exports.addLcpInstrumentationHandler = instrument.addLcpInstrumentationHandler;
		exports.addPerformanceInstrumentationHandler = instrument.addPerformanceInstrumentationHandler;
		exports.addTtfbInstrumentationHandler = instrument.addTtfbInstrumentationHandler;
		exports.addPerformanceEntries = browserMetrics.addPerformanceEntries;
		exports.addWebVitalsToSpan = browserMetrics.addWebVitalsToSpan;
		exports.startTrackingInteractions = browserMetrics.startTrackingInteractions;
		exports.startTrackingLongAnimationFrames = browserMetrics.startTrackingLongAnimationFrames;
		exports.startTrackingLongTasks = browserMetrics.startTrackingLongTasks;
		exports.startTrackingWebVitals = browserMetrics.startTrackingWebVitals;
		exports.elementTimingIntegration = elementTiming.elementTimingIntegration;
		exports.startTrackingElementTiming = elementTiming.startTrackingElementTiming;
		exports.extractNetworkProtocol = utils.extractNetworkProtocol;
		exports.trackClsAsSpan = webVitalSpans.trackClsAsSpan;
		exports.trackInpAsSpan = webVitalSpans.trackInpAsSpan;
		exports.trackLcpAsSpan = webVitalSpans.trackLcpAsSpan;
		exports.addClickKeypressInstrumentationHandler = dom.addClickKeypressInstrumentationHandler;
		exports.addHistoryInstrumentationHandler = history.addHistoryInstrumentationHandler;
		exports.clearCachedImplementation = getNativeImplementation.clearCachedImplementation;
		exports.fetch = getNativeImplementation.fetch;
		exports.getNativeImplementation = getNativeImplementation.getNativeImplementation;
		exports.setTimeout = getNativeImplementation.setTimeout;
		exports.SENTRY_XHR_DATA_KEY = xhr.SENTRY_XHR_DATA_KEY;
		exports.addXhrInstrumentationHandler = xhr.addXhrInstrumentationHandler;
		exports.getBodyString = networkUtils.getBodyString;
		exports.getFetchRequestArgBody = networkUtils.getFetchRequestArgBody;
		exports.parseXhrResponseHeaders = networkUtils.parseXhrResponseHeaders;
		exports.serializeFormData = networkUtils.serializeFormData;
		exports.resourceTimingToSpanAttributes = resourceTiming.resourceTimingToSpanAttributes;
		exports.htmlTreeAsString = htmlTreeAsString.htmlTreeAsString;
		exports.isElement = is.isElement;
		exports.registerInpInteractionListener = inp.registerInpInteractionListener;
		exports.startTrackingINP = inp.startTrackingINP;
		
	} (cjs$2));
	return cjs$2;
}

var hasRequiredFetch;

function requireFetch () {
	if (hasRequiredFetch) return fetch$1;
	hasRequiredFetch = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();

		const DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
		function makeFetchTransport(options, nativeFetch = browserUtils.getNativeImplementation("fetch")) {
		  let pendingBodySize = 0;
		  let pendingCount = 0;
		  async function makeRequest(request) {
		    const requestSize = request.body.length;
		    pendingBodySize += requestSize;
		    pendingCount++;
		    const requestOptions = {
		      body: request.body,
		      method: "POST",
		      referrerPolicy: "strict-origin",
		      headers: options.headers,
		      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
		      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
		      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
		      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
		      // Gotchas:
		      // - `keepalive` isn't supported by Firefox
		      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
		      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
		      //   We will therefore only activate the flag when we're below that limit.
		      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
		      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
		      keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
		      ...options.fetchOptions
		    };
		    try {
		      const response = await nativeFetch(options.url, requestOptions);
		      return {
		        statusCode: response.status,
		        headers: {
		          "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
		          "retry-after": response.headers.get("Retry-After")
		        }
		      };
		    } catch (e) {
		      browserUtils.clearCachedImplementation("fetch");
		      throw e;
		    } finally {
		      pendingBodySize -= requestSize;
		      pendingCount--;
		    }
		  }
		  return browser.createTransport(
		    options,
		    makeRequest,
		    browser.makePromiseBuffer(options.bufferSize || DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE)
		  );
		}

		exports.makeFetchTransport = makeFetchTransport;
		
	} (fetch$1));
	return fetch$1;
}

var profiling = {};

var debugBuild = {};

var hasRequiredDebugBuild;

function requireDebugBuild () {
	if (hasRequiredDebugBuild) return debugBuild;
	hasRequiredDebugBuild = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

		exports.DEBUG_BUILD = DEBUG_BUILD;
		
	} (debugBuild));
	return debugBuild;
}

var hasRequiredProfiling;

function requireProfiling () {
	if (hasRequiredProfiling) return profiling;
	hasRequiredProfiling = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();

		function startProfiler() {
		  const client = browser.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("No Sentry client available, profiling is not started");
		    return;
		  }
		  const integration = client.getIntegrationByName("BrowserProfiling");
		  if (!integration) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("BrowserProfiling integration is not available");
		    return;
		  }
		  client.emit("startUIProfiler");
		}
		function stopProfiler() {
		  const client = browser.getClient();
		  if (!client) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("No Sentry client available, profiling is not started");
		    return;
		  }
		  const integration = client.getIntegrationByName("BrowserProfiling");
		  if (!integration) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("ProfilingIntegration is not available");
		    return;
		  }
		  client.emit("stopUIProfiler");
		}
		const uiProfiler = {
		  startProfiler,
		  stopProfiler
		};

		exports.uiProfiler = uiProfiler;
		
	} (profiling));
	return profiling;
}

var stackParsers = {};

var hasRequiredStackParsers;

function requireStackParsers () {
	if (hasRequiredStackParsers) return stackParsers;
	hasRequiredStackParsers = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const OPERA10_PRIORITY = 10;
		const OPERA11_PRIORITY = 20;
		const CHROME_PRIORITY = 30;
		const WINJS_PRIORITY = 40;
		const GECKO_PRIORITY = 50;
		function createFrame(filename, func, lineno, colno) {
		  const frame = {
		    filename,
		    function: func === "<anonymous>" ? browser.UNKNOWN_FUNCTION : func,
		    in_app: true
		    // All browser frames are considered in_app
		  };
		  if (lineno !== void 0) {
		    frame.lineno = lineno;
		  }
		  if (colno !== void 0) {
		    frame.colno = colno;
		  }
		  return frame;
		}
		const chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
		const chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
		const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
		const chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
		const chromeStackParserFn = (line) => {
		  const dataUriMatch = line.match(chromeDataUriRegex);
		  if (dataUriMatch) {
		    return {
		      filename: `<data:${dataUriMatch[2]}>`,
		      function: dataUriMatch[1]
		    };
		  }
		  const noFnParts = chromeRegexNoFnName.exec(line);
		  if (noFnParts) {
		    const [, filename, line2, col] = noFnParts;
		    return createFrame(filename, browser.UNKNOWN_FUNCTION, +line2, +col);
		  }
		  const parts = chromeRegex.exec(line);
		  if (parts) {
		    const isEval = parts[2]?.indexOf("eval") === 0;
		    if (isEval) {
		      const subMatch = chromeEvalRegex.exec(parts[2]);
		      if (subMatch) {
		        parts[2] = subMatch[1];
		        parts[3] = subMatch[2];
		        parts[4] = subMatch[3];
		      }
		    }
		    const [func, filename] = extractSafariExtensionDetails(parts[1] || browser.UNKNOWN_FUNCTION, parts[2]);
		    return createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
		  }
		  return;
		};
		const chromeStackLineParser = [CHROME_PRIORITY, chromeStackParserFn];
		const geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
		const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
		const gecko = (line) => {
		  const parts = geckoREgex.exec(line);
		  if (parts) {
		    const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
		    if (isEval) {
		      const subMatch = geckoEvalRegex.exec(parts[3]);
		      if (subMatch) {
		        parts[1] = parts[1] || "eval";
		        parts[3] = subMatch[1];
		        parts[4] = subMatch[2];
		        parts[5] = "";
		      }
		    }
		    let filename = parts[3];
		    let func = parts[1] || browser.UNKNOWN_FUNCTION;
		    [func, filename] = extractSafariExtensionDetails(func, filename);
		    return createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
		  }
		  return;
		};
		const geckoStackLineParser = [GECKO_PRIORITY, gecko];
		const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
		const winjs = (line) => {
		  const parts = winjsRegex.exec(line);
		  return parts ? createFrame(parts[2], parts[1] || browser.UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
		};
		const winjsStackLineParser = [WINJS_PRIORITY, winjs];
		const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
		const opera10 = (line) => {
		  const parts = opera10Regex.exec(line);
		  return parts ? createFrame(parts[2], parts[3] || browser.UNKNOWN_FUNCTION, +parts[1]) : void 0;
		};
		const opera10StackLineParser = [OPERA10_PRIORITY, opera10];
		const opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
		const opera11 = (line) => {
		  const parts = opera11Regex.exec(line);
		  return parts ? createFrame(parts[5], parts[3] || parts[4] || browser.UNKNOWN_FUNCTION, +parts[1], +parts[2]) : void 0;
		};
		const opera11StackLineParser = [OPERA11_PRIORITY, opera11];
		const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser];
		const defaultStackParser = browser.createStackParser(...defaultStackLineParsers);
		const extractSafariExtensionDetails = (func, filename) => {
		  const isSafariExtension = func.indexOf("safari-extension") !== -1;
		  const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
		  return isSafariExtension || isSafariWebExtension ? [
		    func.indexOf("@") !== -1 ? func.split("@")[0] : browser.UNKNOWN_FUNCTION,
		    isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
		  ] : [func, filename];
		};

		exports.chromeStackLineParser = chromeStackLineParser;
		exports.defaultStackLineParsers = defaultStackLineParsers;
		exports.defaultStackParser = defaultStackParser;
		exports.geckoStackLineParser = geckoStackLineParser;
		exports.opera10StackLineParser = opera10StackLineParser;
		exports.opera11StackLineParser = opera11StackLineParser;
		exports.winjsStackLineParser = winjsStackLineParser;
		
	} (stackParsers));
	return stackParsers;
}

var userfeedback = {};

var hasRequiredUserfeedback;

function requireUserfeedback () {
	if (hasRequiredUserfeedback) return userfeedback;
	hasRequiredUserfeedback = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		function createUserFeedbackEnvelope(feedback, {
		  metadata,
		  tunnel,
		  dsn
		}) {
		  const headers = {
		    event_id: feedback.event_id,
		    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
		    ...metadata?.sdk && {
		      sdk: {
		        name: metadata.sdk.name,
		        version: metadata.sdk.version
		      }
		    },
		    ...!!tunnel && !!dsn && { dsn: browser.dsnToString(dsn) }
		  };
		  const item = createUserFeedbackEnvelopeItem(feedback);
		  return browser.createEnvelope(headers, [item]);
		}
		function createUserFeedbackEnvelopeItem(feedback) {
		  const feedbackHeaders = {
		    type: "user_report"
		  };
		  return [feedbackHeaders, feedback];
		}

		exports.createUserFeedbackEnvelope = createUserFeedbackEnvelope;
		
	} (userfeedback));
	return userfeedback;
}

var sdk = {};

var breadcrumbs = {};

var hasRequiredBreadcrumbs;

function requireBreadcrumbs () {
	if (hasRequiredBreadcrumbs) return breadcrumbs;
	hasRequiredBreadcrumbs = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();

		const MAX_ALLOWED_STRING_LENGTH = 1024;
		const INTEGRATION_NAME = "Breadcrumbs";
		const _breadcrumbsIntegration = ((options = {}) => {
		  const _options = {
		    console: true,
		    dom: true,
		    fetch: true,
		    history: true,
		    sentry: true,
		    xhr: true,
		    ...options
		  };
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      if (_options.console) {
		        browser.addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client));
		      }
		      if (_options.dom) {
		        browserUtils.addClickKeypressInstrumentationHandler(_getDomBreadcrumbHandler(client, _options.dom));
		      }
		      if (_options.xhr) {
		        browserUtils.addXhrInstrumentationHandler(_getXhrBreadcrumbHandler(client));
		      }
		      if (_options.fetch) {
		        browser.addFetchInstrumentationHandler(_getFetchBreadcrumbHandler(client));
		      }
		      if (_options.history) {
		        browserUtils.addHistoryInstrumentationHandler(_getHistoryBreadcrumbHandler(client));
		      }
		      if (_options.sentry) {
		        client.on("beforeSendEvent", _getSentryBreadcrumbHandler(client));
		      }
		    }
		  };
		});
		const breadcrumbsIntegration = browser.defineIntegration(_breadcrumbsIntegration);
		function _getSentryBreadcrumbHandler(client) {
		  return function addSentryBreadcrumb(event) {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    browser.addBreadcrumb(
		      {
		        category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
		        event_id: event.event_id,
		        level: event.level,
		        message: browser.getEventDescription(event)
		      },
		      {
		        event
		      }
		    );
		  };
		}
		function _getDomBreadcrumbHandler(client, dom) {
		  return function _innerDomBreadcrumb(handlerData) {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    let target;
		    let componentName;
		    let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
		    let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
		    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
		      debugBuild.DEBUG_BUILD && browser.debug.warn(
		        `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`
		      );
		      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
		    }
		    if (typeof keyAttrs === "string") {
		      keyAttrs = [keyAttrs];
		    }
		    try {
		      const event = handlerData.event;
		      const element = _isEvent(event) ? event.target : event;
		      target = browserUtils.htmlTreeAsString(element, { keyAttrs, maxStringLength });
		      componentName = browser.getComponentName(element);
		    } catch {
		      target = "<unknown>";
		    }
		    if (target.length === 0) {
		      return;
		    }
		    const breadcrumb = {
		      category: `ui.${handlerData.name}`,
		      message: target
		    };
		    if (componentName) {
		      breadcrumb.data = { "ui.component_name": componentName };
		    }
		    browser.addBreadcrumb(breadcrumb, {
		      event: handlerData.event,
		      name: handlerData.name,
		      global: handlerData.global
		    });
		  };
		}
		function _getConsoleBreadcrumbHandler(client) {
		  return function _consoleBreadcrumb(handlerData) {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    const breadcrumb = {
		      category: "console",
		      data: {
		        arguments: handlerData.args,
		        logger: "console"
		      },
		      level: browser.severityLevelFromString(handlerData.level),
		      message: browser.safeJoin(handlerData.args, " ")
		    };
		    if (handlerData.level === "assert") {
		      if (handlerData.args[0] === false) {
		        breadcrumb.message = `Assertion failed: ${browser.safeJoin(handlerData.args.slice(1), " ") || "console.assert"}`;
		        breadcrumb.data.arguments = handlerData.args.slice(1);
		      } else {
		        return;
		      }
		    }
		    browser.addBreadcrumb(breadcrumb, {
		      input: handlerData.args,
		      level: handlerData.level
		    });
		  };
		}
		function _getXhrBreadcrumbHandler(client) {
		  return function _xhrBreadcrumb(handlerData) {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    const { startTimestamp, endTimestamp } = handlerData;
		    const sentryXhrData = handlerData.xhr[browserUtils.SENTRY_XHR_DATA_KEY];
		    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
		      return;
		    }
		    const { method, url, status_code, body } = sentryXhrData;
		    const data = {
		      method,
		      url,
		      status_code
		    };
		    const hint = {
		      xhr: handlerData.xhr,
		      input: body,
		      startTimestamp,
		      endTimestamp
		    };
		    const breadcrumb = {
		      category: "xhr",
		      data,
		      type: "http",
		      level: browser.getBreadcrumbLogLevelFromHttpStatusCode(status_code)
		    };
		    client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
		    browser.addBreadcrumb(breadcrumb, hint);
		  };
		}
		function _getFetchBreadcrumbHandler(client) {
		  return function _fetchBreadcrumb(handlerData) {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    const { startTimestamp, endTimestamp } = handlerData;
		    if (!endTimestamp) {
		      return;
		    }
		    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
		      return;
		    }
		    if (handlerData.error) {
		      const hint = {
		        data: handlerData.error,
		        input: handlerData.args,
		        startTimestamp,
		        endTimestamp
		      };
		      const breadcrumb = {
		        category: "fetch",
		        data: handlerData.fetchData,
		        level: "error",
		        type: "http"
		      };
		      client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
		      browser.addBreadcrumb(breadcrumb, hint);
		    } else {
		      const response = handlerData.response;
		      const data = {
		        ...handlerData.fetchData,
		        status_code: response?.status
		      };
		      const hint = {
		        input: handlerData.args,
		        response,
		        startTimestamp,
		        endTimestamp
		      };
		      const breadcrumb = {
		        category: "fetch",
		        data,
		        type: "http",
		        level: browser.getBreadcrumbLogLevelFromHttpStatusCode(data.status_code)
		      };
		      client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
		      browser.addBreadcrumb(breadcrumb, hint);
		    }
		  };
		}
		function _getHistoryBreadcrumbHandler(client) {
		  return function _historyBreadcrumb(handlerData) {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    let from = handlerData.from;
		    let to = handlerData.to;
		    const parsedLoc = browser.parseUrl(helpers.WINDOW.location.href);
		    let parsedFrom = from ? browser.parseUrl(from) : void 0;
		    const parsedTo = browser.parseUrl(to);
		    if (!parsedFrom?.path) {
		      parsedFrom = parsedLoc;
		    }
		    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
		      to = parsedTo.relative;
		    }
		    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
		      from = parsedFrom.relative;
		    }
		    browser.addBreadcrumb({
		      category: "navigation",
		      data: {
		        from,
		        to
		      }
		    });
		  };
		}
		function _isEvent(event) {
		  return !!event && !!event.target;
		}

		exports.breadcrumbsIntegration = breadcrumbsIntegration;
		
	} (breadcrumbs));
	return breadcrumbs;
}

var browserapierrors = {};

var hasRequiredBrowserapierrors;

function requireBrowserapierrors () {
	if (hasRequiredBrowserapierrors) return browserapierrors;
	hasRequiredBrowserapierrors = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const helpers = /*@__PURE__*/ requireHelpers();

		const DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(
		  ","
		);
		const INTEGRATION_NAME = "BrowserApiErrors";
		const _browserApiErrorsIntegration = ((options = {}) => {
		  const _options = {
		    XMLHttpRequest: true,
		    eventTarget: true,
		    requestAnimationFrame: true,
		    setInterval: true,
		    setTimeout: true,
		    unregisterOriginalCallbacks: false,
		    ...options
		  };
		  return {
		    name: INTEGRATION_NAME,
		    // TODO: This currently only works for the first client this is setup
		    // We may want to adjust this to check for client etc.
		    setupOnce() {
		      if (_options.setTimeout) {
		        browser.fill(helpers.WINDOW, "setTimeout", _wrapTimeFunction);
		      }
		      if (_options.setInterval) {
		        browser.fill(helpers.WINDOW, "setInterval", _wrapTimeFunction);
		      }
		      if (_options.requestAnimationFrame) {
		        browser.fill(helpers.WINDOW, "requestAnimationFrame", _wrapRAF);
		      }
		      if (_options.XMLHttpRequest && "XMLHttpRequest" in helpers.WINDOW) {
		        browser.fill(XMLHttpRequest.prototype, "send", _wrapXHR);
		      }
		      const eventTargetOption = _options.eventTarget;
		      if (eventTargetOption) {
		        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
		        eventTarget.forEach((target) => _wrapEventTarget(target, _options));
		      }
		    }
		  };
		});
		const browserApiErrorsIntegration = browser.defineIntegration(_browserApiErrorsIntegration);
		function _wrapTimeFunction(original) {
		  return function(...args) {
		    const originalCallback = args[0];
		    args[0] = helpers.wrap(originalCallback, {
		      mechanism: {
		        handled: false,
		        type: `auto.browser.browserapierrors.${browser.getFunctionName(original)}`
		      }
		    });
		    return original.apply(this, args);
		  };
		}
		function _wrapRAF(original) {
		  return function(callback) {
		    return original.apply(this, [
		      helpers.wrap(callback, {
		        mechanism: {
		          data: {
		            handler: browser.getFunctionName(original)
		          },
		          handled: false,
		          type: "auto.browser.browserapierrors.requestAnimationFrame"
		        }
		      })
		    ]);
		  };
		}
		function _wrapXHR(originalSend) {
		  return function(...args) {
		    const xhr = this;
		    const xmlHttpRequestProps = ["onload", "onerror", "onprogress", "onreadystatechange"];
		    xmlHttpRequestProps.forEach((prop) => {
		      if (prop in xhr && typeof xhr[prop] === "function") {
		        browser.fill(xhr, prop, function(original) {
		          const wrapOptions = {
		            mechanism: {
		              data: {
		                handler: browser.getFunctionName(original)
		              },
		              handled: false,
		              type: `auto.browser.browserapierrors.xhr.${prop}`
		            }
		          };
		          const originalFunction = browser.getOriginalFunction(original);
		          if (originalFunction) {
		            wrapOptions.mechanism.data.handler = browser.getFunctionName(originalFunction);
		          }
		          return helpers.wrap(original, wrapOptions);
		        });
		      }
		    });
		    return originalSend.apply(this, args);
		  };
		}
		function _wrapEventTarget(target, integrationOptions) {
		  const globalObject = helpers.WINDOW;
		  const proto = globalObject[target]?.prototype;
		  if (!proto?.hasOwnProperty?.("addEventListener")) {
		    return;
		  }
		  browser.fill(proto, "addEventListener", function(original) {
		    return function(eventName, fn, options) {
		      try {
		        if (isEventListenerObject(fn)) {
		          fn.handleEvent = helpers.wrap(fn.handleEvent, {
		            mechanism: {
		              data: {
		                handler: browser.getFunctionName(fn),
		                target
		              },
		              handled: false,
		              type: "auto.browser.browserapierrors.handleEvent"
		            }
		          });
		        }
		      } catch {
		      }
		      if (integrationOptions.unregisterOriginalCallbacks) {
		        unregisterOriginalCallback(this, eventName, fn);
		      }
		      return original.apply(this, [
		        eventName,
		        helpers.wrap(fn, {
		          mechanism: {
		            data: {
		              handler: browser.getFunctionName(fn),
		              target
		            },
		            handled: false,
		            type: "auto.browser.browserapierrors.addEventListener"
		          }
		        }),
		        options
		      ]);
		    };
		  });
		  browser.fill(proto, "removeEventListener", function(originalRemoveEventListener) {
		    return function(eventName, fn, options) {
		      try {
		        if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
		          const originalEventHandler = fn.__sentry_wrapped__;
		          if (originalEventHandler) {
		            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
		          }
		        }
		      } catch {
		      }
		      return originalRemoveEventListener.call(this, eventName, fn, options);
		    };
		  });
		}
		function isEventListenerObject(obj) {
		  return typeof obj.handleEvent === "function";
		}
		function unregisterOriginalCallback(target, eventName, fn) {
		  if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") {
		    target.removeEventListener(eventName, fn);
		  }
		}

		exports.browserApiErrorsIntegration = browserApiErrorsIntegration;
		
	} (browserapierrors));
	return browserapierrors;
}

var browsersession = {};

var hasRequiredBrowsersession;

function requireBrowsersession () {
	if (hasRequiredBrowsersession) return browsersession;
	hasRequiredBrowsersession = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();

		const browserSessionIntegration = browser.defineIntegration((options = {}) => {
		  const lifecycle = options.lifecycle ?? "route";
		  return {
		    name: "BrowserSession",
		    setupOnce() {
		      if (typeof helpers.WINDOW.document === "undefined") {
		        debugBuild.DEBUG_BUILD && browser.debug.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
		        return;
		      }
		      browser.startSession({ ignoreDuration: true });
		      browser.captureSession();
		      const isolationScope = browser.getIsolationScope();
		      let previousUser = isolationScope.getUser();
		      isolationScope.addScopeListener((scope) => {
		        const maybeNewUser = scope.getUser();
		        if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
		          browser.captureSession();
		          previousUser = maybeNewUser;
		        }
		      });
		      if (lifecycle === "route") {
		        browserUtils.addHistoryInstrumentationHandler(({ from, to }) => {
		          if (from !== to) {
		            browser.startSession({ ignoreDuration: true });
		            browser.captureSession();
		          }
		        });
		      }
		    }
		  };
		});

		exports.browserSessionIntegration = browserSessionIntegration;
		
	} (browsersession));
	return browsersession;
}

var culturecontext = {};

var hasRequiredCulturecontext;

function requireCulturecontext () {
	if (hasRequiredCulturecontext) return culturecontext;
	hasRequiredCulturecontext = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const helpers = /*@__PURE__*/ requireHelpers();

		const INTEGRATION_NAME = "CultureContext";
		const _cultureContextIntegration = (() => {
		  return {
		    name: INTEGRATION_NAME,
		    preprocessEvent(event) {
		      const culture = getCultureContext();
		      if (culture) {
		        event.contexts = {
		          ...event.contexts,
		          culture: { ...culture, ...event.contexts?.culture }
		        };
		      }
		    },
		    processSegmentSpan(span) {
		      const culture = getCultureContext();
		      if (culture) {
		        browser.safeSetSpanJSONAttributes(span, {
		          "culture.locale": culture.locale,
		          "culture.timezone": culture.timezone,
		          "culture.calendar": culture.calendar
		        });
		      }
		    }
		  };
		});
		const cultureContextIntegration = browser.defineIntegration(_cultureContextIntegration);
		function getCultureContext() {
		  try {
		    const intl = helpers.WINDOW.Intl;
		    if (!intl) {
		      return void 0;
		    }
		    const options = intl.DateTimeFormat().resolvedOptions();
		    return {
		      locale: options.locale,
		      timezone: options.timeZone,
		      calendar: options.calendar
		    };
		  } catch {
		    return void 0;
		  }
		}

		exports.cultureContextIntegration = cultureContextIntegration;
		
	} (culturecontext));
	return culturecontext;
}

var globalhandlers = {};

var hasRequiredGlobalhandlers;

function requireGlobalhandlers () {
	if (hasRequiredGlobalhandlers) return globalhandlers;
	hasRequiredGlobalhandlers = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder();
		const helpers = /*@__PURE__*/ requireHelpers();

		const INTEGRATION_NAME = "GlobalHandlers";
		const _globalHandlersIntegration = ((options = {}) => {
		  const _options = {
		    onerror: true,
		    onunhandledrejection: true,
		    ...options
		  };
		  return {
		    name: INTEGRATION_NAME,
		    setupOnce() {
		      Error.stackTraceLimit = 50;
		    },
		    setup(client) {
		      if (_options.onerror) {
		        _installGlobalOnErrorHandler(client);
		        globalHandlerLog("onerror");
		      }
		      if (_options.onunhandledrejection) {
		        _installGlobalOnUnhandledRejectionHandler(client);
		        globalHandlerLog("onunhandledrejection");
		      }
		    }
		  };
		});
		const globalHandlersIntegration = browser.defineIntegration(_globalHandlersIntegration);
		function _installGlobalOnErrorHandler(client) {
		  browser.addGlobalErrorInstrumentationHandler((data) => {
		    const { stackParser, attachStacktrace } = getOptions();
		    if (browser.getClient() !== client || helpers.shouldIgnoreOnError()) {
		      return;
		    }
		    const { msg, url, line, column, error } = data;
		    const event = _enhanceEventWithInitialFrame(
		      eventbuilder.eventFromUnknownInput(stackParser, error || msg, void 0, attachStacktrace, false),
		      url,
		      line,
		      column
		    );
		    event.level = "error";
		    browser.captureEvent(event, {
		      originalException: error,
		      mechanism: {
		        handled: false,
		        type: "auto.browser.global_handlers.onerror"
		      }
		    });
		  });
		}
		function _installGlobalOnUnhandledRejectionHandler(client) {
		  browser.addGlobalUnhandledRejectionInstrumentationHandler((e) => {
		    const { stackParser, attachStacktrace } = getOptions();
		    if (browser.getClient() !== client || helpers.shouldIgnoreOnError()) {
		      return;
		    }
		    const error = _getUnhandledRejectionError(e);
		    const event = browser.isPrimitive(error) ? _eventFromRejectionWithPrimitive(error) : eventbuilder.eventFromUnknownInput(stackParser, error, void 0, attachStacktrace, true);
		    event.level = "error";
		    browser.captureEvent(event, {
		      originalException: error,
		      mechanism: {
		        handled: false,
		        type: "auto.browser.global_handlers.onunhandledrejection"
		      }
		    });
		  });
		}
		function _getUnhandledRejectionError(error) {
		  if (browser.isPrimitive(error)) {
		    return error;
		  }
		  try {
		    if ("reason" in error) {
		      return error.reason;
		    }
		    if ("detail" in error && "reason" in error.detail) {
		      return error.detail.reason;
		    }
		  } catch {
		  }
		  return error;
		}
		function _eventFromRejectionWithPrimitive(reason) {
		  return {
		    exception: {
		      values: [
		        {
		          type: "UnhandledRejection",
		          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
		          value: `Non-Error promise rejection captured with value: ${String(reason)}`
		        }
		      ]
		    }
		  };
		}
		function _enhanceEventWithInitialFrame(event, url, lineno, colno) {
		  const e = event.exception = event.exception || {};
		  const ev = e.values = e.values || [];
		  const ev0 = ev[0] = ev[0] || {};
		  const ev0s = ev0.stacktrace = ev0.stacktrace || {};
		  const ev0sf = ev0s.frames = ev0s.frames || [];
		  if (ev0sf.length === 0) {
		    ev0sf.push({
		      colno,
		      lineno,
		      filename: getFilenameFromUrl(url) ?? browser.getLocationHref(),
		      function: browser.UNKNOWN_FUNCTION,
		      in_app: true
		    });
		  }
		  return event;
		}
		function globalHandlerLog(type) {
		  debugBuild.DEBUG_BUILD && browser.debug.log(`Global Handler attached: ${type}`);
		}
		function getOptions() {
		  const client = browser.getClient();
		  const options = client?.getOptions() || {
		    stackParser: () => [],
		    attachStacktrace: false
		  };
		  return options;
		}
		function getFilenameFromUrl(url) {
		  if (!browser.isString(url) || url.length === 0) {
		    return void 0;
		  }
		  if (url.startsWith("data:")) {
		    return `<${browser.stripDataUrlContent(url, false)}>`;
		  }
		  return url;
		}

		exports._eventFromRejectionWithPrimitive = _eventFromRejectionWithPrimitive;
		exports._getUnhandledRejectionError = _getUnhandledRejectionError;
		exports.globalHandlersIntegration = globalHandlersIntegration;
		
	} (globalhandlers));
	return globalhandlers;
}

var httpcontext = {};

var hasRequiredHttpcontext;

function requireHttpcontext () {
	if (hasRequiredHttpcontext) return httpcontext;
	hasRequiredHttpcontext = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const helpers = /*@__PURE__*/ requireHelpers();

		const httpContextIntegration = browser.defineIntegration(() => {
		  return {
		    name: "HttpContext",
		    preprocessEvent(event) {
		      if (!helpers.WINDOW.navigator && !helpers.WINDOW.location && !helpers.WINDOW.document) {
		        return;
		      }
		      const reqData = helpers.getHttpRequestData();
		      const headers = {
		        ...reqData.headers,
		        ...event.request?.headers
		      };
		      event.request = {
		        ...reqData,
		        ...event.request,
		        headers
		      };
		    },
		    processSegmentSpan(span) {
		      const spanOp = span.attributes?.[browser.SEMANTIC_ATTRIBUTE_SENTRY_OP];
		      if (!helpers.WINDOW.navigator && !helpers.WINDOW.location && !helpers.WINDOW.document) {
		        return;
		      }
		      const reqData = helpers.getHttpRequestData();
		      browser.safeSetSpanJSONAttributes(span, {
		        // Coerce empty string to undefined so the helper's nullish check drops it,
		        // rather than writing an empty `url.full` attribute onto the span.
		        "url.full": spanOp !== "http.client" ? reqData.url : void 0,
		        "http.request.header.user_agent": reqData.headers["User-Agent"],
		        "http.request.header.referer": reqData.headers["Referer"]
		      });
		    }
		  };
		});

		exports.httpContextIntegration = httpContextIntegration;
		
	} (httpcontext));
	return httpcontext;
}

var linkederrors = {};

var hasRequiredLinkederrors;

function requireLinkederrors () {
	if (hasRequiredLinkederrors) return linkederrors;
	hasRequiredLinkederrors = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder();

		const DEFAULT_KEY = "cause";
		const DEFAULT_LIMIT = 5;
		const INTEGRATION_NAME = "LinkedErrors";
		const _linkedErrorsIntegration = ((options = {}) => {
		  const limit = options.limit || DEFAULT_LIMIT;
		  const key = options.key || DEFAULT_KEY;
		  return {
		    name: INTEGRATION_NAME,
		    preprocessEvent(event, hint, client) {
		      const options2 = client.getOptions();
		      browser.applyAggregateErrorsToEvent(
		        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
		        eventbuilder.exceptionFromError,
		        options2.stackParser,
		        key,
		        limit,
		        event,
		        hint
		      );
		    }
		  };
		});
		const linkedErrorsIntegration = browser.defineIntegration(_linkedErrorsIntegration);

		exports.linkedErrorsIntegration = linkedErrorsIntegration;
		
	} (linkederrors));
	return linkederrors;
}

var normalizeStringifyValue = {};

var hasRequiredNormalizeStringifyValue;

function requireNormalizeStringifyValue () {
	if (hasRequiredNormalizeStringifyValue) return normalizeStringifyValue;
	hasRequiredNormalizeStringifyValue = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browserUtils = /*@__PURE__*/ requireCjs$2();

		const HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
		function normalizeStringifyValue(value) {
		  if (typeof window !== "undefined" && value === window) {
		    return "[Window]";
		  }
		  if (typeof document !== "undefined" && value === document) {
		    return "[Document]";
		  }
		  if (browserUtils.isElement(value)) {
		    const objName = getConstructorName(value);
		    if (HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) {
		      return `[HTMLElement: ${browserUtils.htmlTreeAsString(value)}]`;
		    }
		  }
		  return void 0;
		}
		function getConstructorName(value) {
		  const prototype = Object.getPrototypeOf(value);
		  return prototype?.constructor ? prototype.constructor.name : "null prototype";
		}

		exports.normalizeStringifyValue = normalizeStringifyValue;
		
	} (normalizeStringifyValue));
	return normalizeStringifyValue;
}

var detectBrowserExtension = {};

var hasRequiredDetectBrowserExtension;

function requireDetectBrowserExtension () {
	if (hasRequiredDetectBrowserExtension) return detectBrowserExtension;
	hasRequiredDetectBrowserExtension = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();

		function checkAndWarnIfIsEmbeddedBrowserExtension() {
		  if (_isEmbeddedBrowserExtension()) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.consoleSandbox(() => {
		        console.error(
		          "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
		        );
		      });
		    }
		    return true;
		  }
		  return false;
		}
		function _isEmbeddedBrowserExtension() {
		  if (typeof helpers.WINDOW.window === "undefined") {
		    return false;
		  }
		  const _window = helpers.WINDOW;
		  if (_window.nw) {
		    return false;
		  }
		  const extensionObject = _window["chrome"] || _window["browser"];
		  if (!extensionObject?.runtime?.id) {
		    return false;
		  }
		  const href = browser.getLocationHref();
		  const isDedicatedExtensionPage = helpers.WINDOW === helpers.WINDOW.top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
		  return !isDedicatedExtensionPage;
		}

		exports.checkAndWarnIfIsEmbeddedBrowserExtension = checkAndWarnIfIsEmbeddedBrowserExtension;
		
	} (detectBrowserExtension));
	return detectBrowserExtension;
}

var hasRequiredSdk;

function requireSdk () {
	if (hasRequiredSdk) return sdk;
	hasRequiredSdk = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const client = /*@__PURE__*/ requireClient();
		const breadcrumbs = /*@__PURE__*/ requireBreadcrumbs();
		const browserapierrors = /*@__PURE__*/ requireBrowserapierrors();
		const browsersession = /*@__PURE__*/ requireBrowsersession();
		const culturecontext = /*@__PURE__*/ requireCulturecontext();
		const globalhandlers = /*@__PURE__*/ requireGlobalhandlers();
		const httpcontext = /*@__PURE__*/ requireHttpcontext();
		const linkederrors = /*@__PURE__*/ requireLinkederrors();
		const stackParsers = /*@__PURE__*/ requireStackParsers();
		const fetch = /*@__PURE__*/ requireFetch();
		const normalizeStringifyValue = /*@__PURE__*/ requireNormalizeStringifyValue();
		const detectBrowserExtension = /*@__PURE__*/ requireDetectBrowserExtension();

		function getDefaultIntegrations(_options) {
		  return [
		    // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
		    // eslint-disable-next-line typescript/no-deprecated
		    browser.inboundFiltersIntegration(),
		    browser.functionToStringIntegration(),
		    browser.conversationIdIntegration(),
		    browserapierrors.browserApiErrorsIntegration(),
		    breadcrumbs.breadcrumbsIntegration(),
		    globalhandlers.globalHandlersIntegration(),
		    linkederrors.linkedErrorsIntegration(),
		    browser.dedupeIntegration(),
		    httpcontext.httpContextIntegration(),
		    culturecontext.cultureContextIntegration(),
		    browsersession.browserSessionIntegration()
		  ];
		}
		function init(options = {}) {
		  const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && detectBrowserExtension.checkAndWarnIfIsEmbeddedBrowserExtension();
		  let defaultIntegrations = options.defaultIntegrations == null ? getDefaultIntegrations() : options.defaultIntegrations;
		  const clientOptions = {
		    ...options,
		    enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
		    stackParser: browser.stackParserFromStackParserOptions(options.stackParser || stackParsers.defaultStackParser),
		    integrations: browser.getIntegrationsToSetup({
		      integrations: options.integrations,
		      defaultIntegrations
		    }),
		    transport: options.transport || fetch.makeFetchTransport
		  };
		  browser.setNormalizeStringifier(normalizeStringifyValue.normalizeStringifyValue);
		  return browser.initAndBind(client.BrowserClient, clientOptions);
		}
		function forceLoad() {
		}
		function onLoad(callback) {
		  callback();
		}

		exports.forceLoad = forceLoad;
		exports.getDefaultIntegrations = getDefaultIntegrations;
		exports.init = init;
		exports.onLoad = onLoad;
		
	} (sdk));
	return sdk;
}

var reportDialog = {};

var hasRequiredReportDialog;

function requireReportDialog () {
	if (hasRequiredReportDialog) return reportDialog;
	hasRequiredReportDialog = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();

		function showReportDialog(options = {}) {
		  const optionalDocument = helpers.WINDOW.document;
		  const injectionPoint = optionalDocument?.head || optionalDocument?.body;
		  if (!injectionPoint) {
		    debugBuild.DEBUG_BUILD && browser.debug.error("[showReportDialog] Global document not defined");
		    return;
		  }
		  const scope = browser.getCurrentScope();
		  const client = browser.getClient();
		  const dsn = client?.getDsn();
		  if (!dsn) {
		    debugBuild.DEBUG_BUILD && browser.debug.error("[showReportDialog] DSN not configured");
		    return;
		  }
		  const mergedOptions = {
		    ...options,
		    user: {
		      ...scope.getUser(),
		      ...options.user
		    },
		    eventId: options.eventId || browser.lastEventId()
		  };
		  const script = helpers.WINDOW.document.createElement("script");
		  script.async = true;
		  script.crossOrigin = "anonymous";
		  script.src = browser.getReportDialogEndpoint(dsn, mergedOptions);
		  const { onLoad, onClose } = mergedOptions;
		  if (onLoad) {
		    script.onload = onLoad;
		  }
		  if (onClose) {
		    const reportDialogClosedMessageHandler = (event) => {
		      if (event.data === "__sentry_reportdialog_closed__") {
		        try {
		          onClose();
		        } finally {
		          helpers.WINDOW.removeEventListener("message", reportDialogClosedMessageHandler);
		        }
		      }
		    };
		    helpers.WINDOW.addEventListener("message", reportDialogClosedMessageHandler);
		  }
		  injectionPoint.appendChild(script);
		}

		exports.showReportDialog = showReportDialog;
		
	} (reportDialog));
	return reportDialog;
}

var reportingobserver = {};

var hasRequiredReportingobserver;

function requireReportingobserver () {
	if (hasRequiredReportingobserver) return reportingobserver;
	hasRequiredReportingobserver = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const WINDOW = browser.GLOBAL_OBJ;
		const INTEGRATION_NAME = "ReportingObserver";
		const SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
		const _reportingObserverIntegration = ((options = {}) => {
		  const types = options.types || ["crash", "deprecation", "intervention"];
		  function handler(reports) {
		    if (!SETUP_CLIENTS.has(browser.getClient())) {
		      return;
		    }
		    for (const report of reports) {
		      browser.withScope((scope) => {
		        scope.setExtra("url", report.url);
		        const label = `ReportingObserver [${report.type}]`;
		        let details = "No details available";
		        if (report.body) {
		          const plainBody = {};
		          for (const prop in report.body) {
		            plainBody[prop] = report.body[prop];
		          }
		          scope.setExtra("body", plainBody);
		          if (report.type === "crash") {
		            const body = report.body;
		            details = [body.crashId || "", body.reason || ""].join(" ").trim() || details;
		          } else {
		            const body = report.body;
		            details = body.message || details;
		          }
		        }
		        browser.captureMessage(`${label}: ${details}`);
		      });
		    }
		  }
		  return {
		    name: INTEGRATION_NAME,
		    setupOnce() {
		      if (!browser.supportsReportingObserver()) {
		        return;
		      }
		      const observer = new WINDOW.ReportingObserver(
		        handler,
		        {
		          buffered: true,
		          types
		        }
		      );
		      observer.observe();
		    },
		    setup(client) {
		      SETUP_CLIENTS.set(client, true);
		    }
		  };
		});
		const reportingObserverIntegration = browser.defineIntegration(_reportingObserverIntegration);

		exports.reportingObserverIntegration = reportingObserverIntegration;
		
	} (reportingobserver));
	return reportingobserver;
}

var httpclient = {};

var hasRequiredHttpclient;

function requireHttpclient () {
	if (hasRequiredHttpclient) return httpclient;
	hasRequiredHttpclient = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();

		const INTEGRATION_NAME = "HttpClient";
		const _httpClientIntegration = ((options = {}) => {
		  const _options = {
		    failedRequestStatusCodes: [[500, 599]],
		    failedRequestTargets: [/.*/],
		    ...options
		  };
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      _wrapFetch(client, _options);
		      _wrapXHR(client, _options);
		    }
		  };
		});
		const httpClientIntegration = browser.defineIntegration(_httpClientIntegration);
		function _fetchResponseHandler(options, requestInfo, response, requestInit, error) {
		  if (_shouldCaptureResponse(options, response.status, response.url)) {
		    const request = _getRequest(requestInfo, requestInit);
		    let requestHeaders, responseHeaders, requestCookies, responseCookies;
		    const dc = _getDataCollectionSettings();
		    if (dc.requestHeaders !== false) {
		      requestHeaders = browser._INTERNAL_filterKeyValueData(_extractFetchHeaders(request.headers), dc.requestHeaders);
		    }
		    if (dc.responseHeaders !== false) {
		      responseHeaders = browser._INTERNAL_filterKeyValueData(_extractFetchHeaders(response.headers), dc.responseHeaders);
		    }
		    if (dc.cookies !== false) {
		      const reqCookieStr = request.headers.get("Cookie") || void 0;
		      if (reqCookieStr) {
		        const filtered = browser._INTERNAL_filterCookies(reqCookieStr, dc.cookies);
		        if (typeof filtered === "object") {
		          requestCookies = filtered;
		        }
		      }
		      const resCookieStr = response.headers.get("Set-Cookie") || void 0;
		      if (resCookieStr) {
		        const filtered = browser._INTERNAL_filterCookies(resCookieStr, dc.cookies);
		        if (typeof filtered === "object") {
		          responseCookies = filtered;
		        }
		      }
		    }
		    const event = _createEvent({
		      url: request.url,
		      method: request.method,
		      status: response.status,
		      requestHeaders,
		      responseHeaders,
		      requestCookies,
		      responseCookies,
		      error,
		      type: "fetch"
		    });
		    browser.captureEvent(event);
		  }
		}
		function _xhrResponseHandler(options, xhr, method, headers, error) {
		  if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
		    let requestHeaders, responseCookies, responseHeaders;
		    const dc = _getDataCollectionSettings();
		    if (dc.cookies !== false) {
		      try {
		        const cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || void 0;
		        if (cookieString) {
		          const filtered = browser._INTERNAL_filterCookies(cookieString, dc.cookies);
		          if (typeof filtered === "object") {
		            responseCookies = filtered;
		          }
		        }
		      } catch {
		      }
		    }
		    if (dc.responseHeaders !== false) {
		      try {
		        responseHeaders = browser._INTERNAL_filterKeyValueData(_getXHRResponseHeaders(xhr), dc.responseHeaders);
		      } catch {
		      }
		    }
		    if (dc.requestHeaders !== false) {
		      requestHeaders = browser._INTERNAL_filterKeyValueData(headers, dc.requestHeaders);
		    }
		    const event = _createEvent({
		      url: xhr.responseURL,
		      method,
		      status: xhr.status,
		      requestHeaders,
		      // Can't access request cookies from XHR
		      responseHeaders,
		      responseCookies,
		      error,
		      type: "xhr"
		    });
		    browser.captureEvent(event);
		  }
		}
		function _getResponseSizeFromHeaders(headers) {
		  if (headers) {
		    const contentLength = headers["Content-Length"] || headers["content-length"];
		    if (contentLength) {
		      return parseInt(contentLength, 10);
		    }
		  }
		  return void 0;
		}
		function _extractFetchHeaders(headers) {
		  const result = {};
		  headers.forEach((value, key) => {
		    result[key] = value;
		  });
		  return result;
		}
		function _getXHRResponseHeaders(xhr) {
		  const headers = xhr.getAllResponseHeaders();
		  if (!headers) {
		    return {};
		  }
		  return headers.split("\r\n").reduce((acc, line) => {
		    const [key, value] = line.split(": ");
		    if (key && value) {
		      acc[key] = value;
		    }
		    return acc;
		  }, {});
		}
		function _isInGivenRequestTargets(failedRequestTargets, target) {
		  return failedRequestTargets.some((givenRequestTarget) => {
		    if (typeof givenRequestTarget === "string") {
		      return target.includes(givenRequestTarget);
		    }
		    return givenRequestTarget.test(target);
		  });
		}
		function _isInGivenStatusRanges(failedRequestStatusCodes, status) {
		  return failedRequestStatusCodes.some((range) => {
		    if (typeof range === "number") {
		      return range === status;
		    }
		    return status >= range[0] && status <= range[1];
		  });
		}
		function _wrapFetch(client, options) {
		  if (!browser.supportsNativeFetch()) {
		    return;
		  }
		  browser.addFetchInstrumentationHandler((handlerData) => {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    const { response, args, error, virtualError } = handlerData;
		    const [requestInfo, requestInit] = args;
		    if (!response) {
		      return;
		    }
		    _fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
		  }, false);
		}
		function _wrapXHR(client, options) {
		  if (!("XMLHttpRequest" in browser.GLOBAL_OBJ)) {
		    return;
		  }
		  browserUtils.addXhrInstrumentationHandler((handlerData) => {
		    if (browser.getClient() !== client) {
		      return;
		    }
		    const { error, virtualError } = handlerData;
		    const xhr = handlerData.xhr;
		    const sentryXhrData = xhr[browserUtils.SENTRY_XHR_DATA_KEY];
		    if (!sentryXhrData) {
		      return;
		    }
		    const { method, request_headers: headers } = sentryXhrData;
		    try {
		      _xhrResponseHandler(options, xhr, method, headers, error || virtualError);
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && browser.debug.warn("Error while extracting response event form XHR response", e);
		    }
		  });
		}
		function _shouldCaptureResponse(options, status, url) {
		  return _isInGivenStatusRanges(options.failedRequestStatusCodes, status) && _isInGivenRequestTargets(options.failedRequestTargets, url) && !browser.isSentryRequestUrl(url, browser.getClient());
		}
		function _createEvent(data) {
		  const client = browser.getClient();
		  const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : void 0;
		  const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : void 0;
		  const message = `HTTP Client Error with status code: ${data.status}`;
		  const event = {
		    message,
		    exception: {
		      values: [
		        {
		          type: "Error",
		          value: message,
		          stacktrace: stack ? { frames: stack } : void 0
		        }
		      ]
		    },
		    request: {
		      url: data.url,
		      method: data.method,
		      headers: data.requestHeaders,
		      cookies: data.requestCookies
		    },
		    contexts: {
		      response: {
		        status_code: data.status,
		        headers: data.responseHeaders,
		        cookies: data.responseCookies,
		        body_size: _getResponseSizeFromHeaders(data.responseHeaders)
		      }
		    }
		  };
		  browser.addExceptionMechanism(event, {
		    type: `auto.http.client.${data.type}`,
		    handled: false
		  });
		  return event;
		}
		function _getRequest(requestInfo, requestInit) {
		  if (!requestInit && requestInfo instanceof Request) {
		    return requestInfo;
		  }
		  if (requestInfo instanceof Request && requestInfo.bodyUsed) {
		    return requestInfo;
		  }
		  return new Request(requestInfo, requestInit);
		}
		function _getDataCollectionSettings() {
		  const client = browser.getClient();
		  if (!client) {
		    return { cookies: false, requestHeaders: false, responseHeaders: false };
		  }
		  const options = client.getOptions();
		  if (options.dataCollection == null) {
		    const enabled = Boolean(options.sendDefaultPii);
		    return { cookies: enabled, requestHeaders: enabled, responseHeaders: enabled };
		  }
		  const { cookies, httpHeaders } = client.getDataCollectionOptions();
		  return { cookies, requestHeaders: httpHeaders.request, responseHeaders: httpHeaders.response };
		}

		exports.httpClientIntegration = httpClientIntegration;
		
	} (httpclient));
	return httpclient;
}

var contextlines = {};

var hasRequiredContextlines;

function requireContextlines () {
	if (hasRequiredContextlines) return contextlines;
	hasRequiredContextlines = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const WINDOW = browser.GLOBAL_OBJ;
		const DEFAULT_LINES_OF_CONTEXT = 7;
		const INTEGRATION_NAME = "ContextLines";
		const _contextLinesIntegration = ((options = {}) => {
		  return {
		    name: INTEGRATION_NAME,
		    processEvent(event, _hint, client) {
		      const contextLines = options.frameContextLines ?? client?.getDataCollectionOptions().frameContextLines ?? DEFAULT_LINES_OF_CONTEXT;
		      return addSourceContext(event, contextLines);
		    }
		  };
		});
		const contextLinesIntegration = browser.defineIntegration(_contextLinesIntegration);
		function addSourceContext(event, contextLines) {
		  const doc = WINDOW.document;
		  const htmlFilename = WINDOW.location && browser.stripUrlQueryAndFragment(WINDOW.location.href);
		  if (!doc || !htmlFilename) {
		    return event;
		  }
		  const exceptions = event.exception?.values;
		  if (!exceptions?.length) {
		    return event;
		  }
		  const html = doc.documentElement.innerHTML;
		  if (!html) {
		    return event;
		  }
		  const htmlLines = ["<!DOCTYPE html>", "<html>", ...html.split("\n"), "</html>"];
		  exceptions.forEach((exception) => {
		    const stacktrace = exception.stacktrace;
		    if (stacktrace?.frames) {
		      stacktrace.frames = stacktrace.frames.map(
		        (frame) => applySourceContextToFrame(frame, htmlLines, htmlFilename, contextLines)
		      );
		    }
		  });
		  return event;
		}
		function applySourceContextToFrame(frame, htmlLines, htmlFilename, linesOfContext) {
		  if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) {
		    return frame;
		  }
		  browser.addContextToFrame(htmlLines, frame, linesOfContext);
		  return frame;
		}

		exports.applySourceContextToFrame = applySourceContextToFrame;
		exports.contextLinesIntegration = contextLinesIntegration;
		
	} (contextlines));
	return contextlines;
}

var graphqlClient = {};

var hasRequiredGraphqlClient;

function requireGraphqlClient () {
	if (hasRequiredGraphqlClient) return graphqlClient;
	hasRequiredGraphqlClient = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();

		const INTEGRATION_NAME = "GraphQLClient";
		const _graphqlClientIntegration = ((options) => {
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      _updateSpanWithGraphQLData(client, options);
		      _updateBreadcrumbWithGraphQLData(client, options);
		    }
		  };
		});
		function _updateSpanWithGraphQLData(client, options) {
		  client.on("beforeOutgoingRequestSpan", (span, hint) => {
		    const spanJSON = browser.spanToJSON(span);
		    const spanAttributes = spanJSON.data || {};
		    const spanOp = spanAttributes[browser.SEMANTIC_ATTRIBUTE_SENTRY_OP];
		    const isHttpClientSpan = spanOp === "http.client";
		    if (!isHttpClientSpan) {
		      return;
		    }
		    const httpUrl = spanAttributes[browser.SEMANTIC_ATTRIBUTE_URL_FULL] || spanAttributes["http.url"] || spanAttributes["url"];
		    const httpMethod = spanAttributes[browser.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] || spanAttributes["http.method"];
		    if (!browser.isString(httpUrl) || !browser.isString(httpMethod)) {
		      return;
		    }
		    const { endpoints } = options;
		    const isTracedGraphqlEndpoint = browser.stringMatchesSomePattern(httpUrl, endpoints);
		    const payload = getRequestPayloadXhrOrFetch(hint);
		    if (isTracedGraphqlEndpoint && payload) {
		      const graphqlBody = getGraphQLRequestPayload(payload);
		      if (graphqlBody) {
		        const operationInfo = _getGraphQLOperation(graphqlBody);
		        span.updateName(`${httpMethod} ${httpUrl} (${operationInfo})`);
		        if (isStandardRequest(graphqlBody)) {
		          span.setAttribute("graphql.document", graphqlBody.query);
		        }
		        if (isPersistedRequest(graphqlBody)) {
		          span.setAttribute("graphql.persisted_query.hash.sha256", graphqlBody.extensions.persistedQuery.sha256Hash);
		          span.setAttribute("graphql.persisted_query.version", graphqlBody.extensions.persistedQuery.version);
		        }
		      }
		    }
		  });
		}
		function _updateBreadcrumbWithGraphQLData(client, options) {
		  client.on("beforeOutgoingRequestBreadcrumb", (breadcrumb, handlerData) => {
		    const { category, type, data } = breadcrumb;
		    const isFetch = category === "fetch";
		    const isXhr = category === "xhr";
		    const isHttpBreadcrumb = type === "http";
		    if (isHttpBreadcrumb && (isFetch || isXhr)) {
		      const httpUrl = data?.url;
		      const { endpoints } = options;
		      const isTracedGraphqlEndpoint = browser.stringMatchesSomePattern(httpUrl, endpoints);
		      const payload = getRequestPayloadXhrOrFetch(handlerData);
		      if (isTracedGraphqlEndpoint && data && payload) {
		        const graphqlBody = getGraphQLRequestPayload(payload);
		        if (!data.graphql && graphqlBody) {
		          const operationInfo = _getGraphQLOperation(graphqlBody);
		          data["graphql.operation"] = operationInfo;
		          if (isStandardRequest(graphqlBody)) {
		            data["graphql.document"] = graphqlBody.query;
		          }
		          if (isPersistedRequest(graphqlBody)) {
		            data["graphql.persisted_query.hash.sha256"] = graphqlBody.extensions.persistedQuery.sha256Hash;
		            data["graphql.persisted_query.version"] = graphqlBody.extensions.persistedQuery.version;
		          }
		        }
		      }
		    }
		  });
		}
		function _getGraphQLOperation(requestBody) {
		  if (isPersistedRequest(requestBody)) {
		    return `persisted ${requestBody.operationName}`;
		  }
		  if (isStandardRequest(requestBody)) {
		    const { query: graphqlQuery, operationName: graphqlOperationName } = requestBody;
		    const { operationName = graphqlOperationName, operationType } = parseGraphQLQuery(graphqlQuery);
		    const operationInfo = operationName ? `${operationType} ${operationName}` : `${operationType}`;
		    return operationInfo;
		  }
		  return "unknown";
		}
		function getRequestPayloadXhrOrFetch(hint) {
		  const isXhr = "xhr" in hint;
		  let body;
		  if (isXhr) {
		    const sentryXhrData = hint.xhr[browserUtils.SENTRY_XHR_DATA_KEY];
		    body = sentryXhrData && browserUtils.getBodyString(sentryXhrData.body)[0];
		  } else {
		    const sentryFetchData = browserUtils.getFetchRequestArgBody(hint.input);
		    body = browserUtils.getBodyString(sentryFetchData)[0];
		  }
		  return body;
		}
		function parseGraphQLQuery(query) {
		  const namedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)(\w+)(?:\s*)[{(]/;
		  const unnamedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)[{(]/;
		  const namedMatch = query.match(namedQueryRe);
		  if (namedMatch) {
		    return {
		      operationType: namedMatch[1],
		      operationName: namedMatch[2]
		    };
		  }
		  const unnamedMatch = query.match(unnamedQueryRe);
		  if (unnamedMatch) {
		    return {
		      operationType: unnamedMatch[1],
		      operationName: void 0
		    };
		  }
		  return {
		    operationType: void 0,
		    operationName: void 0
		  };
		}
		function isObject(value) {
		  return typeof value === "object" && value !== null;
		}
		function isStandardRequest(payload) {
		  return isObject(payload) && typeof payload.query === "string";
		}
		function isPersistedRequest(payload) {
		  return isObject(payload) && typeof payload.operationName === "string" && isObject(payload.extensions) && isObject(payload.extensions.persistedQuery) && typeof payload.extensions.persistedQuery.sha256Hash === "string" && typeof payload.extensions.persistedQuery.version === "number";
		}
		function getGraphQLRequestPayload(payload) {
		  try {
		    const requestBody = JSON.parse(payload);
		    if (isStandardRequest(requestBody) || isPersistedRequest(requestBody)) {
		      return requestBody;
		    }
		    return void 0;
		  } catch {
		    return void 0;
		  }
		}
		const graphqlClientIntegration = browser.defineIntegration(_graphqlClientIntegration);

		exports._getGraphQLOperation = _getGraphQLOperation;
		exports.getGraphQLRequestPayload = getGraphQLRequestPayload;
		exports.getRequestPayloadXhrOrFetch = getRequestPayloadXhrOrFetch;
		exports.graphqlClientIntegration = graphqlClientIntegration;
		exports.parseGraphQLQuery = parseGraphQLQuery;
		
	} (graphqlClient));
	return graphqlClient;
}

var viewHierarchy = {};

var hasRequiredViewHierarchy;

function requireViewHierarchy () {
	if (hasRequiredViewHierarchy) return viewHierarchy;
	hasRequiredViewHierarchy = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const helpers = /*@__PURE__*/ requireHelpers();

		const viewHierarchyIntegration = browser.defineIntegration((options = {}) => {
		  const skipHtmlTags = ["script"];
		  function walk(element, windows, depth = 0) {
		    if (!element) {
		      return;
		    }
		    const children = "shadowRoot" in element && element.shadowRoot ? element.shadowRoot.children : element.children;
		    for (const child of children) {
		      if (!(child instanceof HTMLElement)) {
		        continue;
		      }
		      const componentName = browser.getComponentName(child, 1) || void 0;
		      const tagName = child.tagName.toLowerCase();
		      if (skipHtmlTags.includes(tagName)) {
		        continue;
		      }
		      const result = options.onElement?.({ element: child, componentName, tagName, depth }) || {};
		      if (result === "skip") {
		        continue;
		      }
		      if (result === "children") {
		        walk(child, windows, depth + 1);
		        continue;
		      }
		      const { x, y, width, height } = child.getBoundingClientRect();
		      const window = {
		        identifier: child.id || void 0,
		        type: componentName || tagName,
		        visible: true,
		        alpha: 1,
		        height,
		        width,
		        x,
		        y,
		        ...result
		      };
		      const children2 = [];
		      window.children = children2;
		      walk(child, window.children, depth + 1);
		      windows.push(window);
		    }
		  }
		  return {
		    name: "ViewHierarchy",
		    processEvent: (event, hint) => {
		      if (event.type !== void 0 || options.shouldAttach?.(event, hint) === false) {
		        return event;
		      }
		      const root = {
		        rendering_system: "DOM",
		        positioning: "absolute",
		        windows: []
		      };
		      walk(options.rootElement?.() || helpers.WINDOW.document.body, root.windows);
		      const attachment = {
		        filename: "view-hierarchy.json",
		        attachmentType: "event.view_hierarchy",
		        contentType: "application/json",
		        data: JSON.stringify(root)
		      };
		      hint.attachments = hint.attachments || [];
		      hint.attachments.push(attachment);
		      return event;
		    }
		  };
		});

		exports.viewHierarchyIntegration = viewHierarchyIntegration;
		
	} (viewHierarchy));
	return viewHierarchy;
}

var cjs$1 = {};

var hasRequiredCjs$1;

function requireCjs$1 () {
	if (hasRequiredCjs$1) return cjs$1;
	hasRequiredCjs$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();
		const browserUtils = /*@__PURE__*/ requireCjs$2();

		const WINDOW = core.GLOBAL_OBJ;
		const REPLAY_SESSION_KEY = "sentryReplaySession";
		const REPLAY_EVENT_NAME = "replay_event";
		const UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
		const SESSION_IDLE_PAUSE_DURATION = 3e5;
		const SESSION_IDLE_EXPIRE_DURATION = 9e5;
		const DEFAULT_FLUSH_MIN_DELAY = 5e3;
		const DEFAULT_FLUSH_MAX_DELAY = 5500;
		const BUFFER_CHECKOUT_TIME = 6e4;
		const RETRY_BASE_INTERVAL = 5e3;
		const RETRY_MAX_COUNT = 3;
		const NETWORK_BODY_MAX_SIZE = 15e4;
		const CONSOLE_ARG_MAX_SIZE = 5e3;
		const SLOW_CLICK_THRESHOLD = 3e3;
		const SLOW_CLICK_SCROLL_TIMEOUT = 300;
		const REPLAY_MAX_EVENT_BUFFER_SIZE = 2e7;
		const MIN_REPLAY_DURATION = 4999;
		const MIN_REPLAY_DURATION_LIMIT = 5e4;
		const MAX_REPLAY_DURATION = 36e5;

		var __defProp = Object.defineProperty;
		var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
		var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
		var NodeType$1 = /* @__PURE__ */ ((NodeType2) => {
		  NodeType2[NodeType2["Document"] = 0] = "Document";
		  NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
		  NodeType2[NodeType2["Element"] = 2] = "Element";
		  NodeType2[NodeType2["Text"] = 3] = "Text";
		  NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
		  NodeType2[NodeType2["Comment"] = 5] = "Comment";
		  return NodeType2;
		})(NodeType$1 || {});
		function isElement$1(n) {
		  return n.nodeType === n.ELEMENT_NODE;
		}
		function isShadowRoot(n) {
		  const host = n?.host;
		  return Boolean(host?.shadowRoot === n);
		}
		function isNativeShadowDom(shadowRoot) {
		  return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
		}
		function fixBrowserCompatibilityIssuesInCSS(cssText) {
		  if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) {
		    cssText = cssText.replace(
		      /\sbackground-clip:\s*text;/g,
		      " -webkit-background-clip: text; background-clip: text;"
		    );
		  }
		  return cssText;
		}
		function escapeImportStatement(rule) {
		  const { cssText } = rule;
		  if (cssText.split('"').length < 3) return cssText;
		  const statement = ["@import", `url(${JSON.stringify(rule.href)})`];
		  if (rule.layerName === "") {
		    statement.push(`layer`);
		  } else if (rule.layerName) {
		    statement.push(`layer(${rule.layerName})`);
		  }
		  if (rule.supportsText) {
		    statement.push(`supports(${rule.supportsText})`);
		  }
		  if (rule.media.length) {
		    statement.push(rule.media.mediaText);
		  }
		  return statement.join(" ") + ";";
		}
		function stringifyStylesheet(s) {
		  try {
		    const rules = s.rules || s.cssRules;
		    return rules ? fixBrowserCompatibilityIssuesInCSS(
		      Array.from(rules, stringifyRule).join("")
		    ) : null;
		  } catch (error) {
		    return null;
		  }
		}
		function fixAllCssProperty(rule) {
		  let styles = "";
		  for (let i2 = 0; i2 < rule.style.length; i2++) {
		    const styleDeclaration = rule.style;
		    const attribute = styleDeclaration[i2];
		    const isImportant = styleDeclaration.getPropertyPriority(attribute);
		    styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
		  }
		  return `${rule.selectorText} { ${styles} }`;
		}
		function stringifyRule(rule) {
		  let importStringified;
		  if (isCSSImportRule(rule)) {
		    try {
		      importStringified = // for same-origin stylesheets,
		      // we can access the imported stylesheet rules directly
		      stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
		      escapeImportStatement(rule);
		    } catch (error) {
		    }
		  } else if (isCSSStyleRule(rule)) {
		    let cssText = rule.cssText;
		    const needsSafariColonFix = rule.selectorText.includes(":");
		    const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
		    if (needsAllFix) {
		      cssText = fixAllCssProperty(rule);
		    }
		    if (needsSafariColonFix) {
		      cssText = fixSafariColons(cssText);
		    }
		    if (needsSafariColonFix || needsAllFix) {
		      return cssText;
		    }
		  }
		  return importStringified || rule.cssText;
		}
		function fixSafariColons(cssStringified) {
		  const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
		  return cssStringified.replace(regex, "$1\\$2");
		}
		function isCSSImportRule(rule) {
		  return "styleSheet" in rule;
		}
		function isCSSStyleRule(rule) {
		  return "selectorText" in rule;
		}
		class Mirror {
		  constructor() {
		    __publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
		    __publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
		  }
		  getId(n) {
		    if (!n) return -1;
		    const id = this.getMeta(n)?.id;
		    return id ?? -1;
		  }
		  getNode(id) {
		    return this.idNodeMap.get(id) || null;
		  }
		  getIds() {
		    return Array.from(this.idNodeMap.keys());
		  }
		  getMeta(n) {
		    return this.nodeMetaMap.get(n) || null;
		  }
		  // removes the node from idNodeMap
		  // doesn't remove the node from nodeMetaMap
		  removeNodeFromMap(n) {
		    const id = this.getId(n);
		    this.idNodeMap.delete(id);
		    if (n.childNodes) {
		      n.childNodes.forEach(
		        (childNode) => this.removeNodeFromMap(childNode)
		      );
		    }
		  }
		  has(id) {
		    return this.idNodeMap.has(id);
		  }
		  hasNode(node) {
		    return this.nodeMetaMap.has(node);
		  }
		  add(n, meta) {
		    const id = meta.id;
		    this.idNodeMap.set(id, n);
		    this.nodeMetaMap.set(n, meta);
		  }
		  replace(id, n) {
		    const oldNode = this.getNode(id);
		    if (oldNode) {
		      const meta = this.nodeMetaMap.get(oldNode);
		      if (meta) this.nodeMetaMap.set(n, meta);
		    }
		    this.idNodeMap.set(id, n);
		  }
		  reset() {
		    this.idNodeMap = /* @__PURE__ */ new Map();
		    this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
		  }
		}
		function createMirror() {
		  return new Mirror();
		}
		function shouldMaskInput({
		  maskInputOptions,
		  tagName,
		  type
		}) {
		  if (tagName === "OPTION") {
		    tagName = "SELECT";
		  }
		  return Boolean(
		    maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
		    tagName === "INPUT" && !type && maskInputOptions["text"]
		  );
		}
		function maskInputValue({
		  isMasked,
		  element,
		  value,
		  maskInputFn
		}) {
		  let text = value || "";
		  if (!isMasked) {
		    return text;
		  }
		  if (maskInputFn) {
		    text = maskInputFn(text, element);
		  }
		  return "*".repeat(text.length);
		}
		function toLowerCase(str) {
		  return str.toLowerCase();
		}
		function toUpperCase(str) {
		  return str.toUpperCase();
		}
		const ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
		function is2DCanvasBlank(canvas) {
		  const ctx = canvas.getContext("2d");
		  if (!ctx) return true;
		  const chunkSize = 50;
		  for (let x = 0; x < canvas.width; x += chunkSize) {
		    for (let y = 0; y < canvas.height; y += chunkSize) {
		      const getImageData = ctx.getImageData;
		      const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
		      const pixelBuffer = new Uint32Array(
		        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
		        originalGetImageData.call(
		          ctx,
		          x,
		          y,
		          Math.min(chunkSize, canvas.width - x),
		          Math.min(chunkSize, canvas.height - y)
		        ).data.buffer
		      );
		      if (pixelBuffer.some((pixel) => pixel !== 0)) return false;
		    }
		  }
		  return true;
		}
		function getInputType(element) {
		  const type = element.type;
		  return element.hasAttribute("data-rr-is-password") ? "password" : type ? (
		    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
		    toLowerCase(type)
		  ) : null;
		}
		function getInputValue(el, tagName, type) {
		  if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) {
		    return el.getAttribute("value") || "";
		  }
		  return el.value;
		}
		function extractFileExtension(path, baseURL) {
		  let url;
		  try {
		    url = new URL(path, baseURL ?? window.location.href);
		  } catch (err) {
		    return null;
		  }
		  const regex = /\.([0-9a-z]+)(?:$)/i;
		  const match = url.pathname.match(regex);
		  return match?.[1] ?? null;
		}
		const cachedImplementations$1 = {};
		function getImplementation$1(name) {
		  const cached = cachedImplementations$1[name];
		  if (cached) {
		    return cached;
		  }
		  const document2 = window.document;
		  let impl = window[name];
		  if (document2 && typeof document2.createElement === "function") {
		    try {
		      const sandbox = document2.createElement("iframe");
		      sandbox.hidden = true;
		      document2.head.appendChild(sandbox);
		      const contentWindow = sandbox.contentWindow;
		      if (contentWindow && contentWindow[name]) {
		        impl = // eslint-disable-next-line @typescript-eslint/unbound-method
		        contentWindow[name];
		      }
		      document2.head.removeChild(sandbox);
		    } catch (e) {
		    }
		  }
		  return cachedImplementations$1[name] = impl.bind(
		    window
		  );
		}
		function setTimeout$1(...rest) {
		  return getImplementation$1("setTimeout")(...rest);
		}
		function clearTimeout$1(...rest) {
		  return getImplementation$1("clearTimeout")(...rest);
		}
		function getIFrameContentDocument$1(iframe) {
		  try {
		    return iframe.contentDocument;
		  } catch {
		  }
		}
		function getIFrameContentWindow$1(iframe) {
		  try {
		    return iframe.contentWindow;
		  } catch {
		  }
		}
		let _id = 1;
		const tagNameRegex = new RegExp("[^a-z0-9-_:]");
		const IGNORED_NODE = -2;
		function genId() {
		  return _id++;
		}
		function getValidTagName(element) {
		  if (element instanceof HTMLFormElement) {
		    return "form";
		  }
		  const processedTagName = toLowerCase(element.tagName);
		  if (tagNameRegex.test(processedTagName)) {
		    return "div";
		  }
		  return processedTagName;
		}
		function extractOrigin(url) {
		  let origin = "";
		  if (url.indexOf("//") > -1) {
		    origin = url.split("/").slice(0, 3).join("/");
		  } else {
		    origin = url.split("/")[0];
		  }
		  origin = origin.split("?")[0];
		  return origin;
		}
		let canvasService;
		let canvasCtx;
		const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
		const URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
		const URL_WWW_MATCH = /^www\..*/i;
		const DATA_URI = /^(data:)([^,]*),(.*)/i;
		function filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
		  if (!cssText || ignoredProperties.size === 0) {
		    return cssText;
		  }
		  try {
		    const properties = cssText.split(";");
		    const filteredProperties = [];
		    for (let property of properties) {
		      property = property.trim();
		      if (!property) continue;
		      const colonIndex = property.indexOf(":");
		      if (colonIndex === -1) {
		        filteredProperties.push(property);
		        continue;
		      }
		      const propertyName = property.slice(0, colonIndex).trim();
		      if (!ignoredProperties.has(propertyName)) {
		        filteredProperties.push(property);
		      }
		    }
		    return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
		  } catch (error) {
		    console.warn("Error filtering CSS properties:", error);
		    return cssText;
		  }
		}
		function absoluteToStylesheet(cssText, href) {
		  return (cssText || "").replace(
		    URL_IN_CSS_REF,
		    (origin, quote1, path1, quote2, path2, path3) => {
		      const filePath = path1 || path2 || path3;
		      const maybeQuote = quote1 || quote2 || "";
		      if (!filePath) {
		        return origin;
		      }
		      if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
		        return `url(${maybeQuote}${filePath}${maybeQuote})`;
		      }
		      if (DATA_URI.test(filePath)) {
		        return `url(${maybeQuote}${filePath}${maybeQuote})`;
		      }
		      if (filePath[0] === "/") {
		        return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
		      }
		      const stack = href.split("/");
		      const parts = filePath.split("/");
		      stack.pop();
		      for (const part of parts) {
		        if (part === ".") {
		          continue;
		        } else if (part === "..") {
		          stack.pop();
		        } else {
		          stack.push(part);
		        }
		      }
		      return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
		    }
		  );
		}
		const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
		const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
		function getAbsoluteSrcsetString(doc, attributeValue) {
		  if (attributeValue.trim() === "") {
		    return attributeValue;
		  }
		  let pos = 0;
		  function collectCharacters(regEx) {
		    let chars2;
		    const match = regEx.exec(attributeValue.substring(pos));
		    if (match) {
		      chars2 = match[0];
		      pos += chars2.length;
		      return chars2;
		    }
		    return "";
		  }
		  const output = [];
		  while (true) {
		    collectCharacters(SRCSET_COMMAS_OR_SPACES);
		    if (pos >= attributeValue.length) {
		      break;
		    }
		    let url = collectCharacters(SRCSET_NOT_SPACES);
		    if (url.slice(-1) === ",") {
		      url = absoluteToDoc(doc, url.substring(0, url.length - 1));
		      output.push(url);
		    } else {
		      let descriptorsStr = "";
		      url = absoluteToDoc(doc, url);
		      let inParens = false;
		      while (true) {
		        const c = attributeValue.charAt(pos);
		        if (c === "") {
		          output.push((url + descriptorsStr).trim());
		          break;
		        } else if (!inParens) {
		          if (c === ",") {
		            pos += 1;
		            output.push((url + descriptorsStr).trim());
		            break;
		          } else if (c === "(") {
		            inParens = true;
		          }
		        } else {
		          if (c === ")") {
		            inParens = false;
		          }
		        }
		        descriptorsStr += c;
		        pos += 1;
		      }
		    }
		  }
		  return output.join(", ");
		}
		const cachedDocument = /* @__PURE__ */ new WeakMap();
		function absoluteToDoc(doc, attributeValue) {
		  if (!attributeValue || attributeValue.trim() === "") {
		    return attributeValue;
		  }
		  return getHref(doc, attributeValue);
		}
		function isSVGElement(el) {
		  return Boolean(el.tagName === "svg" || el.ownerSVGElement);
		}
		function getHref(doc, customHref) {
		  let a = cachedDocument.get(doc);
		  if (!a) {
		    a = doc.createElement("a");
		    cachedDocument.set(doc, a);
		  }
		  if (!customHref) {
		    customHref = "";
		  } else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) {
		    return customHref;
		  }
		  a.setAttribute("href", customHref);
		  return a.href;
		}
		function transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
		  if (!value) {
		    return value;
		  }
		  if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) {
		    return absoluteToDoc(doc, value);
		  } else if (name === "xlink:href" && value[0] !== "#") {
		    return absoluteToDoc(doc, value);
		  } else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) {
		    return absoluteToDoc(doc, value);
		  } else if (name === "srcset") {
		    return getAbsoluteSrcsetString(doc, value);
		  } else if (name === "style") {
		    let processedStyle = absoluteToStylesheet(value, getHref(doc));
		    if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) {
		      processedStyle = filterCSSPropertiesFromInlineStyle(
		        processedStyle,
		        ignoreCSSAttributes
		      );
		    }
		    return processedStyle;
		  } else if (tagName === "object" && name === "data") {
		    return absoluteToDoc(doc, value);
		  }
		  if (typeof maskAttributeFn === "function") {
		    return maskAttributeFn(name, value, element);
		  }
		  return value;
		}
		function ignoreAttribute(tagName, name, _value) {
		  return (tagName === "video" || tagName === "audio") && name === "autoplay";
		}
		function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
		  try {
		    if (unblockSelector && element.matches(unblockSelector)) {
		      return false;
		    }
		    if (typeof blockClass === "string") {
		      if (element.classList.contains(blockClass)) {
		        return true;
		      }
		    } else {
		      for (let eIndex = element.classList.length; eIndex--; ) {
		        const className = element.classList[eIndex];
		        if (blockClass.test(className)) {
		          return true;
		        }
		      }
		    }
		    if (blockSelector) {
		      return element.matches(blockSelector);
		    }
		  } catch (e) {
		  }
		  return false;
		}
		function elementClassMatchesRegex(el, regex) {
		  for (let eIndex = el.classList.length; eIndex--; ) {
		    const className = el.classList[eIndex];
		    if (regex.test(className)) {
		      return true;
		    }
		  }
		  return false;
		}
		function distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
		  if (!node) return -1;
		  if (node.nodeType !== node.ELEMENT_NODE) return -1;
		  if (distance > limit) return -1;
		  if (matchPredicate(node)) return distance;
		  return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
		}
		function createMatchPredicate(className, selector) {
		  return (node) => {
		    const el = node;
		    if (el === null) return false;
		    try {
		      if (className) {
		        if (typeof className === "string") {
		          if (el.matches(`.${className}`)) return true;
		        } else if (elementClassMatchesRegex(el, className)) {
		          return true;
		        }
		      }
		      if (selector && el.matches(selector)) return true;
		      return false;
		    } catch {
		      return false;
		    }
		  };
		}
		function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
		  try {
		    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
		    if (el === null) return false;
		    if (el.tagName === "INPUT") {
		      const autocomplete = el.getAttribute("autocomplete");
		      const disallowedAutocompleteValues = [
		        "current-password",
		        "new-password",
		        "cc-number",
		        "cc-exp",
		        "cc-exp-month",
		        "cc-exp-year",
		        "cc-csc"
		      ];
		      if (disallowedAutocompleteValues.includes(autocomplete)) {
		        return true;
		      }
		    }
		    let maskDistance = -1;
		    let unmaskDistance = -1;
		    if (maskAllText) {
		      unmaskDistance = distanceToMatch(
		        el,
		        createMatchPredicate(unmaskTextClass, unmaskTextSelector)
		      );
		      if (unmaskDistance < 0) {
		        return true;
		      }
		      maskDistance = distanceToMatch(
		        el,
		        createMatchPredicate(maskTextClass, maskTextSelector),
		        unmaskDistance >= 0 ? unmaskDistance : Infinity
		      );
		    } else {
		      maskDistance = distanceToMatch(
		        el,
		        createMatchPredicate(maskTextClass, maskTextSelector)
		      );
		      if (maskDistance < 0) {
		        return false;
		      }
		      unmaskDistance = distanceToMatch(
		        el,
		        createMatchPredicate(unmaskTextClass, unmaskTextSelector),
		        maskDistance >= 0 ? maskDistance : Infinity
		      );
		    }
		    return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
		  } catch (e) {
		  }
		  return !!maskAllText;
		}
		function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
		  const win = getIFrameContentWindow$1(iframeEl);
		  if (!win) {
		    return;
		  }
		  let fired = false;
		  let readyState;
		  try {
		    readyState = win.document.readyState;
		  } catch (error) {
		    return;
		  }
		  if (readyState !== "complete") {
		    const timer = setTimeout$1(() => {
		      if (!fired) {
		        listener();
		        fired = true;
		      }
		    }, iframeLoadTimeout);
		    iframeEl.addEventListener("load", () => {
		      clearTimeout$1(timer);
		      fired = true;
		      listener();
		    });
		    return;
		  }
		  const blankUrl = "about:blank";
		  if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
		    setTimeout$1(listener, 0);
		    return iframeEl.addEventListener("load", listener);
		  }
		  iframeEl.addEventListener("load", listener);
		}
		function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
		  let fired = false;
		  let styleSheetLoaded;
		  try {
		    styleSheetLoaded = link.sheet;
		  } catch (error) {
		    styleSheetLoaded = null;
		  }
		  if (styleSheetLoaded) return;
		  const timer = setTimeout$1(() => {
		    if (!fired) {
		      listener();
		      fired = true;
		    }
		  }, styleSheetLoadTimeout);
		  link.addEventListener("load", () => {
		    clearTimeout$1(timer);
		    fired = true;
		    listener();
		  });
		}
		function serializeNode(n, options) {
		  const {
		    doc,
		    mirror,
		    blockClass,
		    blockSelector,
		    unblockSelector,
		    maskAllText,
		    maskAttributeFn,
		    maskTextClass,
		    unmaskTextClass,
		    maskTextSelector,
		    unmaskTextSelector,
		    inlineStylesheet,
		    maskInputOptions = {},
		    maskTextFn,
		    maskInputFn,
		    dataURLOptions = {},
		    inlineImages,
		    recordCanvas,
		    keepIframeSrcFn,
		    newlyAddedElement = false,
		    ignoreCSSAttributes
		  } = options;
		  const rootId = getRootId(doc, mirror);
		  switch (n.nodeType) {
		    case n.DOCUMENT_NODE:
		      if (n.compatMode !== "CSS1Compat") {
		        return {
		          type: NodeType$1.Document,
		          childNodes: [],
		          compatMode: n.compatMode
		          // probably "BackCompat"
		        };
		      } else {
		        return {
		          type: NodeType$1.Document,
		          childNodes: []
		        };
		      }
		    case n.DOCUMENT_TYPE_NODE:
		      return {
		        type: NodeType$1.DocumentType,
		        name: n.name,
		        publicId: n.publicId,
		        systemId: n.systemId,
		        rootId
		      };
		    case n.ELEMENT_NODE:
		      return serializeElementNode(n, {
		        doc,
		        blockClass,
		        blockSelector,
		        unblockSelector,
		        inlineStylesheet,
		        maskAttributeFn,
		        maskInputOptions,
		        maskInputFn,
		        dataURLOptions,
		        inlineImages,
		        recordCanvas,
		        keepIframeSrcFn,
		        newlyAddedElement,
		        rootId,
		        maskTextClass,
		        unmaskTextClass,
		        maskTextSelector,
		        unmaskTextSelector,
		        ignoreCSSAttributes
		      });
		    case n.TEXT_NODE:
		      return serializeTextNode(n, {
		        doc,
		        maskAllText,
		        maskTextClass,
		        unmaskTextClass,
		        maskTextSelector,
		        unmaskTextSelector,
		        maskTextFn,
		        maskInputOptions,
		        maskInputFn,
		        rootId
		      });
		    case n.CDATA_SECTION_NODE:
		      return {
		        type: NodeType$1.CDATA,
		        textContent: "",
		        rootId
		      };
		    case n.COMMENT_NODE:
		      return {
		        type: NodeType$1.Comment,
		        textContent: n.textContent || "",
		        rootId
		      };
		    default:
		      return false;
		  }
		}
		function getRootId(doc, mirror) {
		  if (!mirror.hasNode(doc)) return void 0;
		  const docId = mirror.getId(doc);
		  return docId === 1 ? void 0 : docId;
		}
		function serializeTextNode(n, options) {
		  const {
		    maskAllText,
		    maskTextClass,
		    unmaskTextClass,
		    maskTextSelector,
		    unmaskTextSelector,
		    maskTextFn,
		    maskInputOptions,
		    maskInputFn,
		    rootId
		  } = options;
		  const parentTagName = n.parentNode && n.parentNode.tagName;
		  let textContent = n.textContent;
		  const isStyle = parentTagName === "STYLE" ? true : void 0;
		  const isScript = parentTagName === "SCRIPT" ? true : void 0;
		  const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
		  if (isStyle && textContent) {
		    try {
		      if (n.nextSibling || n.previousSibling) {
		      } else if (n.parentNode.sheet?.cssRules) {
		        textContent = stringifyStylesheet(
		          n.parentNode.sheet
		        );
		      }
		    } catch (err) {
		      console.warn(
		        `Cannot get CSS styles from text's parentNode. Error: ${err}`,
		        n
		      );
		    }
		    textContent = absoluteToStylesheet(textContent, getHref(options.doc));
		  }
		  if (isScript) {
		    textContent = "SCRIPT_PLACEHOLDER";
		  }
		  const forceMask = needMaskingText(
		    n,
		    maskTextClass,
		    maskTextSelector,
		    unmaskTextClass,
		    unmaskTextSelector,
		    maskAllText
		  );
		  if (!isStyle && !isScript && !isTextarea && textContent && forceMask) {
		    textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
		  }
		  if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) {
		    textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
		  }
		  if (parentTagName === "OPTION" && textContent) {
		    const isInputMasked = shouldMaskInput({
		      type: null,
		      tagName: parentTagName,
		      maskInputOptions
		    });
		    textContent = maskInputValue({
		      isMasked: needMaskingText(
		        n,
		        maskTextClass,
		        maskTextSelector,
		        unmaskTextClass,
		        unmaskTextSelector,
		        isInputMasked
		      ),
		      element: n,
		      value: textContent,
		      maskInputFn
		    });
		  }
		  return {
		    type: NodeType$1.Text,
		    textContent: textContent || "",
		    isStyle,
		    rootId
		  };
		}
		function serializeElementNode(n, options) {
		  const {
		    doc,
		    blockClass,
		    blockSelector,
		    unblockSelector,
		    inlineStylesheet,
		    maskInputOptions = {},
		    maskAttributeFn,
		    maskInputFn,
		    dataURLOptions = {},
		    inlineImages,
		    recordCanvas,
		    keepIframeSrcFn,
		    newlyAddedElement = false,
		    rootId,
		    maskTextClass,
		    unmaskTextClass,
		    maskTextSelector,
		    unmaskTextSelector,
		    ignoreCSSAttributes
		  } = options;
		  const needBlock = _isBlockedElement(
		    n,
		    blockClass,
		    blockSelector,
		    unblockSelector
		  );
		  const tagName = getValidTagName(n);
		  let attributes2 = {};
		  const len = n.attributes.length;
		  for (let i2 = 0; i2 < len; i2++) {
		    const attr = n.attributes[i2];
		    if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) {
		      attributes2[attr.name] = transformAttribute(
		        doc,
		        tagName,
		        toLowerCase(attr.name),
		        attr.value,
		        n,
		        maskAttributeFn,
		        ignoreCSSAttributes
		      );
		    }
		  }
		  if (tagName === "link" && inlineStylesheet) {
		    const stylesheet = Array.from(doc.styleSheets).find((s) => {
		      return s.href === n.href;
		    });
		    let cssText = null;
		    if (stylesheet) {
		      cssText = stringifyStylesheet(stylesheet);
		    }
		    if (cssText) {
		      attributes2.rel = null;
		      attributes2.href = null;
		      attributes2.crossorigin = null;
		      attributes2._cssText = absoluteToStylesheet(cssText, stylesheet.href);
		    }
		  }
		  if (tagName === "style" && n.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
		  !(n.innerText || n.textContent || "").trim().length) {
		    const cssText = stringifyStylesheet(
		      n.sheet
		    );
		    if (cssText) {
		      attributes2._cssText = absoluteToStylesheet(cssText, getHref(doc));
		    }
		  }
		  if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
		    const el = n;
		    const type = getInputType(el);
		    const value = getInputValue(el, toUpperCase(tagName), type);
		    const checked = el.checked;
		    if (type !== "submit" && type !== "button" && value) {
		      const forceMask = needMaskingText(
		        el,
		        maskTextClass,
		        maskTextSelector,
		        unmaskTextClass,
		        unmaskTextSelector,
		        shouldMaskInput({
		          type,
		          tagName: toUpperCase(tagName),
		          maskInputOptions
		        })
		      );
		      attributes2.value = maskInputValue({
		        isMasked: forceMask,
		        element: el,
		        value,
		        maskInputFn
		      });
		    }
		    if (checked) {
		      attributes2.checked = checked;
		    }
		  }
		  if (tagName === "option") {
		    if (n.selected && !maskInputOptions["select"]) {
		      attributes2.selected = true;
		    } else {
		      delete attributes2.selected;
		    }
		  }
		  if (tagName === "canvas" && recordCanvas) {
		    if (n.__context === "2d") {
		      if (!is2DCanvasBlank(n)) {
		        attributes2.rr_dataURL = n.toDataURL(
		          dataURLOptions.type,
		          dataURLOptions.quality
		        );
		      }
		    } else if (!("__context" in n)) {
		      const canvasDataURL = n.toDataURL(
		        dataURLOptions.type,
		        dataURLOptions.quality
		      );
		      const blankCanvas = doc.createElement("canvas");
		      blankCanvas.width = n.width;
		      blankCanvas.height = n.height;
		      const blankCanvasDataURL = blankCanvas.toDataURL(
		        dataURLOptions.type,
		        dataURLOptions.quality
		      );
		      if (canvasDataURL !== blankCanvasDataURL) {
		        attributes2.rr_dataURL = canvasDataURL;
		      }
		    }
		  }
		  if (tagName === "img" && inlineImages) {
		    if (!canvasService) {
		      canvasService = doc.createElement("canvas");
		      canvasCtx = canvasService.getContext("2d");
		    }
		    const image = n;
		    const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
		    const priorCrossOrigin = image.crossOrigin;
		    const recordInlineImage = () => {
		      image.removeEventListener("load", recordInlineImage);
		      try {
		        canvasService.width = image.naturalWidth;
		        canvasService.height = image.naturalHeight;
		        canvasCtx.drawImage(image, 0, 0);
		        attributes2.rr_dataURL = canvasService.toDataURL(
		          dataURLOptions.type,
		          dataURLOptions.quality
		        );
		      } catch (err) {
		        if (image.crossOrigin !== "anonymous") {
		          image.crossOrigin = "anonymous";
		          if (image.complete && image.naturalWidth !== 0)
		            recordInlineImage();
		          else image.addEventListener("load", recordInlineImage);
		          return;
		        } else {
		          console.warn(
		            `Cannot inline img src=${imageSrc}! Error: ${err}`
		          );
		        }
		      }
		      if (image.crossOrigin === "anonymous") {
		        priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
		      }
		    };
		    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
		    else image.addEventListener("load", recordInlineImage);
		  }
		  if (tagName === "audio" || tagName === "video") {
		    attributes2.rr_mediaState = n.paused ? "paused" : "played";
		    attributes2.rr_mediaCurrentTime = n.currentTime;
		  }
		  if (!newlyAddedElement) {
		    if (n.scrollLeft) {
		      attributes2.rr_scrollLeft = n.scrollLeft;
		    }
		    if (n.scrollTop) {
		      attributes2.rr_scrollTop = n.scrollTop;
		    }
		  }
		  if (needBlock) {
		    const { width, height } = n.getBoundingClientRect();
		    attributes2 = {
		      class: attributes2.class,
		      rr_width: `${width}px`,
		      rr_height: `${height}px`
		    };
		  }
		  if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
		    if (!needBlock && !getIFrameContentDocument$1(n)) {
		      attributes2.rr_src = attributes2.src;
		    }
		    delete attributes2.src;
		  }
		  let isCustomElement;
		  try {
		    if (customElements.get(tagName)) isCustomElement = true;
		  } catch (e) {
		  }
		  return {
		    type: NodeType$1.Element,
		    tagName,
		    attributes: attributes2,
		    childNodes: [],
		    isSVG: isSVGElement(n) || void 0,
		    needBlock,
		    rootId,
		    isCustom: isCustomElement
		  };
		}
		function lowerIfExists(maybeAttr) {
		  if (maybeAttr === void 0 || maybeAttr === null) {
		    return "";
		  } else {
		    return maybeAttr.toLowerCase();
		  }
		}
		function slimDOMExcluded(sn, slimDOMOptions) {
		  if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) {
		    return true;
		  } else if (sn.type === NodeType$1.Element) {
		    if (slimDOMOptions.script && // script tag
		    (sn.tagName === "script" || // (module)preload link
		    sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
		    sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && extractFileExtension(sn.attributes.href) === "js")) {
		      return true;
		    } else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && (lowerIfExists(sn.attributes.name).match(
		      /^msapplication-tile(image|color)$/
		    ) || lowerIfExists(sn.attributes.name) === "application-name" || lowerIfExists(sn.attributes.rel) === "icon" || lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || lowerIfExists(sn.attributes.rel) === "shortcut icon"))) {
		      return true;
		    } else if (sn.tagName === "meta") {
		      if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
		        return true;
		      } else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
		      lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === "pinterest")) {
		        return true;
		      } else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === "robots" || lowerIfExists(sn.attributes.name) === "googlebot" || lowerIfExists(sn.attributes.name) === "bingbot")) {
		        return true;
		      } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) {
		        return true;
		      } else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === "author" || lowerIfExists(sn.attributes.name) === "generator" || lowerIfExists(sn.attributes.name) === "framework" || lowerIfExists(sn.attributes.name) === "publisher" || lowerIfExists(sn.attributes.name) === "progid" || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) {
		        return true;
		      } else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === "google-site-verification" || lowerIfExists(sn.attributes.name) === "yandex-verification" || lowerIfExists(sn.attributes.name) === "csrf-token" || lowerIfExists(sn.attributes.name) === "p:domain_verify" || lowerIfExists(sn.attributes.name) === "verify-v1" || lowerIfExists(sn.attributes.name) === "verification" || lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) {
		        return true;
		      }
		    }
		  }
		  return false;
		}
		function serializeNodeWithId(n, options) {
		  const {
		    doc,
		    mirror,
		    blockClass,
		    blockSelector,
		    unblockSelector,
		    maskAllText,
		    maskTextClass,
		    unmaskTextClass,
		    maskTextSelector,
		    unmaskTextSelector,
		    skipChild = false,
		    inlineStylesheet = true,
		    maskInputOptions = {},
		    maskAttributeFn,
		    maskTextFn,
		    maskInputFn,
		    slimDOMOptions,
		    dataURLOptions = {},
		    inlineImages = false,
		    recordCanvas = false,
		    onSerialize,
		    onIframeLoad,
		    iframeLoadTimeout = 5e3,
		    onBlockedImageLoad,
		    onStylesheetLoad,
		    stylesheetLoadTimeout = 5e3,
		    keepIframeSrcFn = () => false,
		    newlyAddedElement = false,
		    ignoreCSSAttributes
		  } = options;
		  let { preserveWhiteSpace = true } = options;
		  const _serializedNode = serializeNode(n, {
		    doc,
		    mirror,
		    blockClass,
		    blockSelector,
		    maskAllText,
		    unblockSelector,
		    maskTextClass,
		    unmaskTextClass,
		    maskTextSelector,
		    unmaskTextSelector,
		    inlineStylesheet,
		    maskInputOptions,
		    maskAttributeFn,
		    maskTextFn,
		    maskInputFn,
		    dataURLOptions,
		    inlineImages,
		    recordCanvas,
		    keepIframeSrcFn,
		    newlyAddedElement,
		    ignoreCSSAttributes
		  });
		  if (!_serializedNode) {
		    console.warn(n, "not serialized");
		    return null;
		  }
		  let id;
		  if (mirror.hasNode(n)) {
		    id = mirror.getId(n);
		  } else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.trim().length) {
		    id = IGNORED_NODE;
		  } else {
		    id = genId();
		  }
		  const serializedNode2 = Object.assign(_serializedNode, { id });
		  mirror.add(n, serializedNode2);
		  if (id === IGNORED_NODE) {
		    return null;
		  }
		  if (onSerialize) {
		    onSerialize(n);
		  }
		  let recordChild = !skipChild;
		  if (serializedNode2.type === NodeType$1.Element) {
		    recordChild = recordChild && !serializedNode2.needBlock;
		    const shadowRoot = n.shadowRoot;
		    if (shadowRoot && isNativeShadowDom(shadowRoot))
		      serializedNode2.isShadowHost = true;
		  }
		  if ((serializedNode2.type === NodeType$1.Document || serializedNode2.type === NodeType$1.Element) && recordChild) {
		    if (slimDOMOptions.headWhitespace && serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "head") {
		      preserveWhiteSpace = false;
		    }
		    const bypassOptions = {
		      doc,
		      mirror,
		      blockClass,
		      blockSelector,
		      maskAllText,
		      unblockSelector,
		      maskTextClass,
		      unmaskTextClass,
		      maskTextSelector,
		      unmaskTextSelector,
		      skipChild,
		      inlineStylesheet,
		      maskInputOptions,
		      maskAttributeFn,
		      maskTextFn,
		      maskInputFn,
		      slimDOMOptions,
		      dataURLOptions,
		      inlineImages,
		      recordCanvas,
		      preserveWhiteSpace,
		      onSerialize,
		      onIframeLoad,
		      iframeLoadTimeout,
		      onBlockedImageLoad,
		      onStylesheetLoad,
		      stylesheetLoadTimeout,
		      keepIframeSrcFn,
		      ignoreCSSAttributes
		    };
		    const childNodes = n.childNodes ? Array.from(n.childNodes) : [];
		    for (const childN of childNodes) {
		      const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
		      if (serializedChildNode) {
		        serializedNode2.childNodes.push(serializedChildNode);
		      }
		    }
		    if (isElement$1(n) && n.shadowRoot) {
		      for (const childN of Array.from(n.shadowRoot.childNodes)) {
		        const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
		        if (serializedChildNode) {
		          isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
		          serializedNode2.childNodes.push(serializedChildNode);
		        }
		      }
		    }
		  }
		  if (n.parentNode && isShadowRoot(n.parentNode) && isNativeShadowDom(n.parentNode)) {
		    serializedNode2.isShadow = true;
		  }
		  if (serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) {
		    onceIframeLoaded(
		      n,
		      () => {
		        const iframeDoc = getIFrameContentDocument$1(n);
		        if (iframeDoc && onIframeLoad) {
		          const serializedIframeNode = serializeNodeWithId(iframeDoc, {
		            doc: iframeDoc,
		            mirror,
		            blockClass,
		            blockSelector,
		            unblockSelector,
		            maskAllText,
		            maskTextClass,
		            unmaskTextClass,
		            maskTextSelector,
		            unmaskTextSelector,
		            skipChild: false,
		            inlineStylesheet,
		            maskInputOptions,
		            maskAttributeFn,
		            maskTextFn,
		            maskInputFn,
		            slimDOMOptions,
		            dataURLOptions,
		            inlineImages,
		            recordCanvas,
		            preserveWhiteSpace,
		            onSerialize,
		            onIframeLoad,
		            iframeLoadTimeout,
		            onStylesheetLoad,
		            stylesheetLoadTimeout,
		            keepIframeSrcFn,
		            ignoreCSSAttributes
		          });
		          if (serializedIframeNode) {
		            onIframeLoad(
		              n,
		              serializedIframeNode
		            );
		          }
		        }
		      },
		      iframeLoadTimeout
		    );
		  }
		  if (serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "img" && !n.complete && serializedNode2.needBlock) {
		    const image = n;
		    const updateImageDimensions = () => {
		      if (image.isConnected && !image.complete && onBlockedImageLoad) {
		        try {
		          const rect = image.getBoundingClientRect();
		          if (rect.width > 0 && rect.height > 0) {
		            onBlockedImageLoad(image, serializedNode2, rect);
		          }
		        } catch (error) {
		        }
		      }
		      image.removeEventListener("load", updateImageDimensions);
		    };
		    if (image.isConnected) {
		      image.addEventListener("load", updateImageDimensions);
		    }
		  }
		  if (serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && extractFileExtension(serializedNode2.attributes.href) === "css")) {
		    onceStylesheetLoaded(
		      n,
		      () => {
		        if (onStylesheetLoad) {
		          const serializedLinkNode = serializeNodeWithId(n, {
		            doc,
		            mirror,
		            blockClass,
		            blockSelector,
		            unblockSelector,
		            maskAllText,
		            maskTextClass,
		            unmaskTextClass,
		            maskTextSelector,
		            unmaskTextSelector,
		            skipChild: false,
		            inlineStylesheet,
		            maskInputOptions,
		            maskAttributeFn,
		            maskTextFn,
		            maskInputFn,
		            slimDOMOptions,
		            dataURLOptions,
		            inlineImages,
		            recordCanvas,
		            preserveWhiteSpace,
		            onSerialize,
		            onIframeLoad,
		            iframeLoadTimeout,
		            onStylesheetLoad,
		            stylesheetLoadTimeout,
		            keepIframeSrcFn,
		            ignoreCSSAttributes
		          });
		          if (serializedLinkNode) {
		            onStylesheetLoad(
		              n,
		              serializedLinkNode
		            );
		          }
		        }
		      },
		      stylesheetLoadTimeout
		    );
		  }
		  if (serializedNode2.type === NodeType$1.Element) {
		    delete serializedNode2.needBlock;
		  }
		  return serializedNode2;
		}
		function snapshot(n, options) {
		  const {
		    mirror = new Mirror(),
		    blockClass = "rr-block",
		    blockSelector = null,
		    unblockSelector = null,
		    maskAllText = false,
		    maskTextClass = "rr-mask",
		    unmaskTextClass = null,
		    maskTextSelector = null,
		    unmaskTextSelector = null,
		    inlineStylesheet = true,
		    inlineImages = false,
		    recordCanvas = false,
		    maskAllInputs = false,
		    maskAttributeFn,
		    maskTextFn,
		    maskInputFn,
		    slimDOM = false,
		    dataURLOptions,
		    preserveWhiteSpace,
		    onSerialize,
		    onIframeLoad,
		    iframeLoadTimeout,
		    onBlockedImageLoad,
		    onStylesheetLoad,
		    stylesheetLoadTimeout,
		    keepIframeSrcFn = () => false,
		    ignoreCSSAttributes = /* @__PURE__ */ new Set([])
		  } = options || {};
		  const maskInputOptions = maskAllInputs === true ? {
		    color: true,
		    date: true,
		    "datetime-local": true,
		    email: true,
		    month: true,
		    number: true,
		    range: true,
		    search: true,
		    tel: true,
		    text: true,
		    time: true,
		    url: true,
		    week: true,
		    textarea: true,
		    select: true
		  } : maskAllInputs === false ? {} : maskAllInputs;
		  const slimDOMOptions = slimDOM === true || slimDOM === "all" ? (
		    // if true: set of sensible options that should not throw away any information
		    {
		      script: true,
		      comment: true,
		      headFavicon: true,
		      headWhitespace: true,
		      headMetaDescKeywords: slimDOM === "all",
		      // destructive
		      headMetaSocial: true,
		      headMetaRobots: true,
		      headMetaHttpEquiv: true,
		      headMetaAuthorship: true,
		      headMetaVerification: true
		    }
		  ) : slimDOM === false ? {} : slimDOM;
		  return serializeNodeWithId(n, {
		    doc: n,
		    mirror,
		    blockClass,
		    blockSelector,
		    unblockSelector,
		    maskAllText,
		    maskTextClass,
		    unmaskTextClass,
		    maskTextSelector,
		    unmaskTextSelector,
		    skipChild: false,
		    inlineStylesheet,
		    maskInputOptions,
		    maskAttributeFn,
		    maskTextFn,
		    maskInputFn,
		    slimDOMOptions,
		    dataURLOptions,
		    inlineImages,
		    recordCanvas,
		    preserveWhiteSpace,
		    onSerialize,
		    onIframeLoad,
		    iframeLoadTimeout,
		    onBlockedImageLoad,
		    onStylesheetLoad,
		    stylesheetLoadTimeout,
		    keepIframeSrcFn,
		    newlyAddedElement: false,
		    ignoreCSSAttributes
		  });
		}
		function on(type, fn, target = document) {
		  const options = { capture: true, passive: true };
		  target.addEventListener(type, fn, options);
		  return () => target.removeEventListener(type, fn, options);
		}
		const DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
		let _mirror = {
		  map: {},
		  getId() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		    return -1;
		  },
		  getNode() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		    return null;
		  },
		  removeNodeFromMap() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		  },
		  has() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		    return false;
		  },
		  reset() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		  }
		};
		if (typeof window !== "undefined" && window.Proxy && window.Reflect) {
		  _mirror = new Proxy(_mirror, {
		    get(target, prop, receiver) {
		      if (prop === "map") {
		        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		      }
		      return Reflect.get(target, prop, receiver);
		    }
		  });
		}
		function throttle$1(func, wait, options = {}) {
		  let timeout = null;
		  let previous = 0;
		  return function(...args) {
		    const now = Date.now();
		    if (!previous && options.leading === false) {
		      previous = now;
		    }
		    const remaining = wait - (now - previous);
		    const context = this;
		    if (remaining <= 0 || remaining > wait) {
		      if (timeout) {
		        clearTimeout$2(timeout);
		        timeout = null;
		      }
		      previous = now;
		      func.apply(context, args);
		    } else if (!timeout && options.trailing !== false) {
		      timeout = setTimeout$2(() => {
		        previous = options.leading === false ? 0 : Date.now();
		        timeout = null;
		        func.apply(context, args);
		      }, remaining);
		    }
		  };
		}
		function hookSetter(target, key, d, isRevoked, win = window) {
		  const original = win.Object.getOwnPropertyDescriptor(target, key);
		  win.Object.defineProperty(
		    target,
		    key,
		    isRevoked ? d : {
		      set(value) {
		        setTimeout$2(() => {
		          d.set.call(this, value);
		        }, 0);
		        if (original && original.set) {
		          original.set.call(this, value);
		        }
		      }
		    }
		  );
		  return () => hookSetter(target, key, original || {}, true);
		}
		function patch(source, name, replacement) {
		  try {
		    if (!(name in source)) {
		      return () => {
		      };
		    }
		    const original = source[name];
		    const wrapped = replacement(original);
		    if (typeof wrapped === "function") {
		      wrapped.prototype = wrapped.prototype || {};
		      Object.defineProperties(wrapped, {
		        __rrweb_original__: {
		          enumerable: false,
		          value: original
		        }
		      });
		    }
		    source[name] = wrapped;
		    return () => {
		      source[name] = original;
		    };
		  } catch {
		    return () => {
		    };
		  }
		}
		let nowTimestamp = Date.now;
		if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) {
		  nowTimestamp = () => (/* @__PURE__ */ new Date()).getTime();
		}
		function getWindowScroll(win) {
		  const doc = win.document;
		  return {
		    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
		    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
		  };
		}
		function getWindowHeight() {
		  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
		}
		function getWindowWidth() {
		  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
		}
		function closestElementOfNode$1(node) {
		  if (!node) {
		    return null;
		  }
		  try {
		    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
		    return el;
		  } catch (error) {
		    return null;
		  }
		}
		function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
		  if (!node) {
		    return false;
		  }
		  const el = closestElementOfNode$1(node);
		  if (!el) {
		    return false;
		  }
		  const blockedPredicate = createMatchPredicate(blockClass, blockSelector);
		  if (!checkAncestors) {
		    const isUnblocked = unblockSelector && el.matches(unblockSelector);
		    return blockedPredicate(el) && !isUnblocked;
		  }
		  const blockDistance = distanceToMatch(el, blockedPredicate);
		  let unblockDistance = -1;
		  if (blockDistance < 0) {
		    return false;
		  }
		  if (unblockSelector) {
		    unblockDistance = distanceToMatch(
		      el,
		      createMatchPredicate(null, unblockSelector)
		    );
		  }
		  if (blockDistance > -1 && unblockDistance < 0) {
		    return true;
		  }
		  return blockDistance < unblockDistance;
		}
		function isSerialized(n, mirror) {
		  return mirror.getId(n) !== -1;
		}
		function isIgnored(n, mirror) {
		  return mirror.getId(n) === IGNORED_NODE;
		}
		function isAncestorRemoved(target, mirror) {
		  if (isShadowRoot(target)) {
		    return false;
		  }
		  const id = mirror.getId(target);
		  if (!mirror.has(id)) {
		    return true;
		  }
		  if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) {
		    return false;
		  }
		  if (!target.parentNode) {
		    return true;
		  }
		  return isAncestorRemoved(target.parentNode, mirror);
		}
		function legacy_isTouchEvent(event) {
		  return Boolean(event.changedTouches);
		}
		function polyfill(win = window) {
		  if ("NodeList" in win && !win.NodeList.prototype.forEach) {
		    win.NodeList.prototype.forEach = Array.prototype.forEach;
		  }
		  if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) {
		    win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
		  }
		  if (!Node.prototype.contains) {
		    Node.prototype.contains = (...args) => {
		      let node = args[0];
		      if (!(0 in args)) {
		        throw new TypeError("1 argument is required");
		      }
		      do {
		        if (this === node) {
		          return true;
		        }
		      } while (node = node && node.parentNode);
		      return false;
		    };
		  }
		}
		function isSerializedIframe(n, mirror) {
		  return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
		}
		function isSerializedStylesheet(n, mirror) {
		  return Boolean(
		    n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n)
		  );
		}
		function hasShadowRoot(n) {
		  return Boolean(n?.shadowRoot);
		}
		class StyleSheetMirror {
		  constructor() {
		    this.id = 1;
		    this.styleIDMap = /* @__PURE__ */ new WeakMap();
		    this.idStyleMap = /* @__PURE__ */ new Map();
		  }
		  getId(stylesheet) {
		    return this.styleIDMap.get(stylesheet) ?? -1;
		  }
		  has(stylesheet) {
		    return this.styleIDMap.has(stylesheet);
		  }
		  /**
		   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
		   */
		  add(stylesheet, id) {
		    if (this.has(stylesheet)) return this.getId(stylesheet);
		    let newId;
		    if (id === void 0) {
		      newId = this.id++;
		    } else newId = id;
		    this.styleIDMap.set(stylesheet, newId);
		    this.idStyleMap.set(newId, stylesheet);
		    return newId;
		  }
		  getStyle(id) {
		    return this.idStyleMap.get(id) || null;
		  }
		  reset() {
		    this.styleIDMap = /* @__PURE__ */ new WeakMap();
		    this.idStyleMap = /* @__PURE__ */ new Map();
		    this.id = 1;
		  }
		  generateId() {
		    return this.id++;
		  }
		}
		function getShadowHost(n) {
		  let shadowHost = null;
		  if (n.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host)
		    shadowHost = n.getRootNode().host;
		  return shadowHost;
		}
		function getRootShadowHost(n) {
		  let rootShadowHost = n;
		  let shadowHost;
		  while (shadowHost = getShadowHost(rootShadowHost))
		    rootShadowHost = shadowHost;
		  return rootShadowHost;
		}
		function shadowHostInDom(n) {
		  const doc = n.ownerDocument;
		  if (!doc) return false;
		  const shadowHost = getRootShadowHost(n);
		  return doc.contains(shadowHost);
		}
		function inDom(n) {
		  const doc = n.ownerDocument;
		  if (!doc) return false;
		  return doc.contains(n) || shadowHostInDom(n);
		}
		const cachedImplementations = {};
		function getImplementation(name) {
		  const cached = cachedImplementations[name];
		  if (cached) {
		    return cached;
		  }
		  const document2 = window.document;
		  let impl = window[name];
		  if (document2 && typeof document2.createElement === "function") {
		    try {
		      const sandbox = document2.createElement("iframe");
		      sandbox.hidden = true;
		      document2.head.appendChild(sandbox);
		      const contentWindow = sandbox.contentWindow;
		      if (contentWindow && contentWindow[name]) {
		        impl = // eslint-disable-next-line @typescript-eslint/unbound-method
		        contentWindow[name];
		      }
		      document2.head.removeChild(sandbox);
		    } catch (e) {
		    }
		  }
		  return cachedImplementations[name] = impl.bind(
		    window
		  );
		}
		function onRequestAnimationFrame(...rest) {
		  return getImplementation("requestAnimationFrame")(...rest);
		}
		function setTimeout$2(...rest) {
		  return getImplementation("setTimeout")(...rest);
		}
		function clearTimeout$2(...rest) {
		  return getImplementation("clearTimeout")(...rest);
		}
		var EventType = /* @__PURE__ */ ((EventType2) => {
		  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
		  EventType2[EventType2["Load"] = 1] = "Load";
		  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
		  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
		  EventType2[EventType2["Meta"] = 4] = "Meta";
		  EventType2[EventType2["Custom"] = 5] = "Custom";
		  EventType2[EventType2["Plugin"] = 6] = "Plugin";
		  return EventType2;
		})(EventType || {});
		var IncrementalSource = /* @__PURE__ */ ((IncrementalSource2) => {
		  IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
		  IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
		  IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
		  IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
		  IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
		  IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
		  IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
		  IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
		  IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
		  IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
		  IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
		  IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
		  IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
		  IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
		  IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
		  IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
		  IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
		  return IncrementalSource2;
		})(IncrementalSource || {});
		var MouseInteractions = /* @__PURE__ */ ((MouseInteractions2) => {
		  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
		  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
		  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
		  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
		  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
		  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
		  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
		  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
		  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
		  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
		  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
		  return MouseInteractions2;
		})(MouseInteractions || {});
		var PointerTypes = /* @__PURE__ */ ((PointerTypes2) => {
		  PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
		  PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
		  PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
		  return PointerTypes2;
		})(PointerTypes || {});
		var MediaInteractions = /* @__PURE__ */ ((MediaInteractions2) => {
		  MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
		  MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
		  MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
		  MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
		  MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
		  return MediaInteractions2;
		})(MediaInteractions || {});
		let errorHandler;
		function registerErrorHandler(handler) {
		  errorHandler = handler;
		}
		function unregisterErrorHandler() {
		  errorHandler = void 0;
		}
		const callbackWrapper = (cb) => {
		  if (!errorHandler) {
		    return cb;
		  }
		  const rrwebWrapped = ((...rest) => {
		    try {
		      return cb(...rest);
		    } catch (error) {
		      if (errorHandler && errorHandler(error) === true) {
		        return () => {
		        };
		      }
		      throw error;
		    }
		  });
		  return rrwebWrapped;
		};
		var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
		var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
		for (var i = 0; i < chars.length; i++) {
		  lookup[chars.charCodeAt(i)] = i;
		}
		class CanvasManagerNoop {
		  reset() {
		  }
		  freeze() {
		  }
		  unfreeze() {
		  }
		  lock() {
		  }
		  unlock() {
		  }
		  snapshot() {
		  }
		  addWindow() {
		  }
		  addShadowRoot() {
		  }
		  resetShadowRoots() {
		  }
		}

		function getIFrameContentDocument(iframe) {
		  try {
		    return iframe.contentDocument;
		  } catch (e2) {
		  }
		}
		function getIFrameContentWindow(iframe) {
		  try {
		    return iframe.contentWindow;
		  } catch (e2) {
		  }
		}
		class StyleDeclarationParser {
		  constructor(doc) {
		    this.doc = doc;
		    this.unattachedDoc = null;
		  }
		  parse(styleText) {
		    return this.parseWithConstructableStylesheet(styleText) || this.parseWithDetachedElement(styleText);
		  }
		  parseWithConstructableStylesheet(styleText) {
		    if (typeof CSSStyleSheet === "undefined" || typeof CSSStyleSheet.prototype.replaceSync !== "function") {
		      return null;
		    }
		    try {
		      const sheet = new CSSStyleSheet();
		      sheet.replaceSync(`x { ${styleText} }`);
		      const rule = sheet.cssRules[0];
		      if (!rule || rule.type !== CSSRule.STYLE_RULE) {
		        return null;
		      }
		      return rule.style;
		    } catch {
		      return null;
		    }
		  }
		  parseWithDetachedElement(styleText) {
		    const old = this.getUnattachedDoc().createElement("span");
		    old.setAttribute("style", styleText);
		    return old.style;
		  }
		  getUnattachedDoc() {
		    if (!this.unattachedDoc) {
		      try {
		        this.unattachedDoc = document.implementation.createHTMLDocument();
		      } catch {
		        this.unattachedDoc = this.doc;
		      }
		    }
		    return this.unattachedDoc;
		  }
		}
		function isNodeInLinkedList(n2) {
		  return "__ln" in n2;
		}
		class DoubleLinkedList {
		  constructor() {
		    this.length = 0;
		    this.head = null;
		    this.tail = null;
		  }
		  get(position) {
		    if (position >= this.length) {
		      throw new Error("Position outside of list range");
		    }
		    let current = this.head;
		    for (let index = 0; index < position; index++) {
		      current = current?.next || null;
		    }
		    return current;
		  }
		  addNode(n2) {
		    const node = {
		      value: n2,
		      previous: null,
		      next: null
		    };
		    n2.__ln = node;
		    if (n2.previousSibling && isNodeInLinkedList(n2.previousSibling)) {
		      const current = n2.previousSibling.__ln.next;
		      node.next = current;
		      node.previous = n2.previousSibling.__ln;
		      n2.previousSibling.__ln.next = node;
		      if (current) {
		        current.previous = node;
		      }
		    } else if (n2.nextSibling && isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
		      const current = n2.nextSibling.__ln.previous;
		      node.previous = current;
		      node.next = n2.nextSibling.__ln;
		      n2.nextSibling.__ln.previous = node;
		      if (current) {
		        current.next = node;
		      }
		    } else {
		      if (this.head) {
		        this.head.previous = node;
		      }
		      node.next = this.head;
		      this.head = node;
		    }
		    if (node.next === null) {
		      this.tail = node;
		    }
		    this.length++;
		  }
		  removeNode(n2) {
		    const current = n2.__ln;
		    if (!this.head) {
		      return;
		    }
		    if (!current.previous) {
		      this.head = current.next;
		      if (this.head) {
		        this.head.previous = null;
		      } else {
		        this.tail = null;
		      }
		    } else {
		      current.previous.next = current.next;
		      if (current.next) {
		        current.next.previous = current.previous;
		      } else {
		        this.tail = current.previous;
		      }
		    }
		    if (n2.__ln) {
		      delete n2.__ln;
		    }
		    this.length--;
		  }
		}
		const moveKey = (id, parentId) => `${id}@${parentId}`;
		class MutationBuffer {
		  constructor() {
		    this.frozen = false;
		    this.locked = false;
		    this.texts = [];
		    this.attributes = [];
		    this.attributeMap = /* @__PURE__ */ new WeakMap();
		    this.removes = [];
		    this.mapRemoves = [];
		    this.movedMap = {};
		    this.addedSet = /* @__PURE__ */ new Set();
		    this.movedSet = /* @__PURE__ */ new Set();
		    this.droppedSet = /* @__PURE__ */ new Set();
		    this.processMutations = (mutations) => {
		      mutations.forEach(this.processMutation);
		      this.emit();
		    };
		    this.emit = () => {
		      if (this.frozen || this.locked) {
		        return;
		      }
		      const adds = [];
		      const addedIds = /* @__PURE__ */ new Set();
		      const addList = new DoubleLinkedList();
		      const getNextId = (n2) => {
		        let ns = n2;
		        let nextId = IGNORED_NODE;
		        while (nextId === IGNORED_NODE) {
		          ns = ns && ns.nextSibling;
		          nextId = ns && this.mirror.getId(ns);
		        }
		        return nextId;
		      };
		      const pushAdd = (n2) => {
		        if (!n2.parentNode || !inDom(n2)) {
		          return;
		        }
		        const parentId = isShadowRoot(n2.parentNode) ? this.mirror.getId(getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
		        const nextId = getNextId(n2);
		        if (parentId === -1 || nextId === -1) {
		          return addList.addNode(n2);
		        }
		        const sn = serializeNodeWithId(n2, {
		          doc: this.doc,
		          mirror: this.mirror,
		          blockClass: this.blockClass,
		          blockSelector: this.blockSelector,
		          maskAllText: this.maskAllText,
		          unblockSelector: this.unblockSelector,
		          maskTextClass: this.maskTextClass,
		          unmaskTextClass: this.unmaskTextClass,
		          maskTextSelector: this.maskTextSelector,
		          unmaskTextSelector: this.unmaskTextSelector,
		          skipChild: true,
		          newlyAddedElement: true,
		          inlineStylesheet: this.inlineStylesheet,
		          maskInputOptions: this.maskInputOptions,
		          maskAttributeFn: this.maskAttributeFn,
		          maskTextFn: this.maskTextFn,
		          maskInputFn: this.maskInputFn,
		          slimDOMOptions: this.slimDOMOptions,
		          dataURLOptions: this.dataURLOptions,
		          recordCanvas: this.recordCanvas,
		          inlineImages: this.inlineImages,
		          onSerialize: (currentN) => {
		            if (isSerializedIframe(currentN, this.mirror) && !isBlocked(
		              currentN,
		              this.blockClass,
		              this.blockSelector,
		              this.unblockSelector,
		              false
		            )) {
		              this.iframeManager.addIframe(currentN);
		            }
		            if (isSerializedStylesheet(currentN, this.mirror)) {
		              this.stylesheetManager.trackLinkElement(
		                currentN
		              );
		            }
		            if (hasShadowRoot(n2)) {
		              this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
		            }
		          },
		          onIframeLoad: (iframe, childSn) => {
		            if (isBlocked(
		              iframe,
		              this.blockClass,
		              this.blockSelector,
		              this.unblockSelector,
		              false
		            )) {
		              return;
		            }
		            this.iframeManager.attachIframe(iframe, childSn);
		            const contentWindow = getIFrameContentWindow(iframe);
		            if (contentWindow) {
		              this.canvasManager.addWindow(contentWindow);
		            }
		            this.shadowDomManager.observeAttachShadow(iframe);
		          },
		          onStylesheetLoad: (link, childSn) => {
		            this.stylesheetManager.attachLinkElement(link, childSn);
		          },
		          onBlockedImageLoad: (_imageEl, serializedNode, { width, height }) => {
		            this.mutationCb({
		              adds: [],
		              removes: [],
		              texts: [],
		              attributes: [
		                {
		                  id: serializedNode.id,
		                  attributes: {
		                    style: {
		                      width: `${width}px`,
		                      height: `${height}px`
		                    }
		                  }
		                }
		              ]
		            });
		          },
		          ignoreCSSAttributes: this.ignoreCSSAttributes
		        });
		        if (sn) {
		          adds.push({
		            parentId,
		            nextId,
		            node: sn
		          });
		          addedIds.add(sn.id);
		        }
		      };
		      while (this.mapRemoves.length) {
		        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
		      }
		      for (const n2 of this.movedSet) {
		        if (isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) {
		          continue;
		        }
		        pushAdd(n2);
		      }
		      for (const n2 of this.addedSet) {
		        if (!isAncestorInSet(this.droppedSet, n2) && !isParentRemoved(this.removes, n2, this.mirror)) {
		          pushAdd(n2);
		        } else if (isAncestorInSet(this.movedSet, n2)) {
		          pushAdd(n2);
		        } else {
		          this.droppedSet.add(n2);
		        }
		      }
		      let candidate = null;
		      while (addList.length) {
		        let node = null;
		        if (candidate) {
		          const parentId = this.mirror.getId(candidate.value.parentNode);
		          const nextId = getNextId(candidate.value);
		          if (parentId !== -1 && nextId !== -1) {
		            node = candidate;
		          }
		        }
		        if (!node) {
		          let tailNode = addList.tail;
		          while (tailNode) {
		            const _node = tailNode;
		            tailNode = tailNode.previous;
		            if (_node) {
		              const parentId = this.mirror.getId(_node.value.parentNode);
		              const nextId = getNextId(_node.value);
		              if (nextId === -1) continue;
		              else if (parentId !== -1) {
		                node = _node;
		                break;
		              } else {
		                const unhandledNode = _node.value;
		                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
		                  const shadowHost = unhandledNode.parentNode.host;
		                  const parentId2 = this.mirror.getId(shadowHost);
		                  if (parentId2 !== -1) {
		                    node = _node;
		                    break;
		                  }
		                }
		              }
		            }
		          }
		        }
		        if (!node) {
		          while (addList.head) {
		            addList.removeNode(addList.head.value);
		          }
		          break;
		        }
		        candidate = node.previous;
		        addList.removeNode(node.value);
		        pushAdd(node.value);
		      }
		      const payload = {
		        texts: this.texts.map((text) => ({
		          id: this.mirror.getId(text.node),
		          value: text.value
		        })).filter((text) => !addedIds.has(text.id)).filter((text) => this.mirror.has(text.id)),
		        attributes: this.attributes.map((attribute) => {
		          const { attributes } = attribute;
		          if (typeof attributes.style === "string") {
		            const diffAsStr = JSON.stringify(attribute.styleDiff);
		            const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
		            if (diffAsStr.length < attributes.style.length) {
		              if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) {
		                attributes.style = attribute.styleDiff;
		              }
		            }
		          }
		          return {
		            id: this.mirror.getId(attribute.node),
		            attributes
		          };
		        }).filter((attribute) => !addedIds.has(attribute.id)).filter((attribute) => this.mirror.has(attribute.id)),
		        removes: this.removes,
		        adds
		      };
		      if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
		        return;
		      }
		      this.texts = [];
		      this.attributes = [];
		      this.attributeMap = /* @__PURE__ */ new WeakMap();
		      this.removes = [];
		      this.addedSet = /* @__PURE__ */ new Set();
		      this.movedSet = /* @__PURE__ */ new Set();
		      this.droppedSet = /* @__PURE__ */ new Set();
		      this.movedMap = {};
		      this.mutationCb(payload);
		    };
		    this.processMutation = (m) => {
		      if (isIgnored(m.target, this.mirror)) {
		        return;
		      }
		      switch (m.type) {
		        case "characterData": {
		          const value = m.target.textContent;
		          if (!isBlocked(
		            m.target,
		            this.blockClass,
		            this.blockSelector,
		            this.unblockSelector,
		            false
		          ) && value !== m.oldValue) {
		            this.texts.push({
		              value: needMaskingText(
		                m.target,
		                this.maskTextClass,
		                this.maskTextSelector,
		                this.unmaskTextClass,
		                this.unmaskTextSelector,
		                this.maskAllText
		              ) && value ? this.maskTextFn ? this.maskTextFn(value, closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
		              node: m.target
		            });
		          }
		          break;
		        }
		        case "attributes": {
		          const target = m.target;
		          let attributeName = m.attributeName;
		          let value = m.target.getAttribute(attributeName);
		          if (attributeName === "value") {
		            const type = getInputType(target);
		            const tagName = target.tagName;
		            value = getInputValue(target, tagName, type);
		            const isInputMasked = shouldMaskInput({
		              maskInputOptions: this.maskInputOptions,
		              tagName,
		              type
		            });
		            const forceMask = needMaskingText(
		              m.target,
		              this.maskTextClass,
		              this.maskTextSelector,
		              this.unmaskTextClass,
		              this.unmaskTextSelector,
		              isInputMasked
		            );
		            value = maskInputValue({
		              isMasked: forceMask,
		              element: target,
		              value,
		              maskInputFn: this.maskInputFn
		            });
		          }
		          if (isBlocked(
		            m.target,
		            this.blockClass,
		            this.blockSelector,
		            this.unblockSelector,
		            false
		          ) || value === m.oldValue) {
		            return;
		          }
		          let item = this.attributeMap.get(m.target);
		          if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
		            const iframeDoc = getIFrameContentDocument(
		              target
		            );
		            if (!iframeDoc) {
		              attributeName = "rr_src";
		            } else {
		              return;
		            }
		          }
		          if (!item) {
		            item = {
		              node: m.target,
		              attributes: {},
		              styleDiff: {},
		              _unchangedStyles: {}
		            };
		            this.attributes.push(item);
		            this.attributeMap.set(m.target, item);
		          }
		          if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") {
		            target.setAttribute("data-rr-is-password", "true");
		          }
		          if (!ignoreAttribute(target.tagName, attributeName)) {
		            item.attributes[attributeName] = transformAttribute(
		              this.doc,
		              toLowerCase(target.tagName),
		              toLowerCase(attributeName),
		              value,
		              target,
		              this.maskAttributeFn
		            );
		            if (attributeName === "style") {
		              const oldStyle = m.oldValue ? this.styleDeclarationParser.parse(m.oldValue) : null;
		              for (const pname of Array.from(target.style)) {
		                const newValue = target.style.getPropertyValue(pname);
		                const newPriority = target.style.getPropertyPriority(pname);
		                if (newValue !== (oldStyle?.getPropertyValue(pname) || "") || newPriority !== (oldStyle?.getPropertyPriority(pname) || "")) {
		                  if (newPriority === "") {
		                    item.styleDiff[pname] = newValue;
		                  } else {
		                    item.styleDiff[pname] = [newValue, newPriority];
		                  }
		                } else {
		                  item._unchangedStyles[pname] = [newValue, newPriority];
		                }
		              }
		              if (oldStyle) {
		                for (const pname of Array.from(oldStyle)) {
		                  if (target.style.getPropertyValue(pname) === "") {
		                    item.styleDiff[pname] = false;
		                  }
		                }
		              }
		            }
		          }
		          break;
		        }
		        case "childList": {
		          if (isBlocked(
		            m.target,
		            this.blockClass,
		            this.blockSelector,
		            this.unblockSelector,
		            true
		          )) {
		            return;
		          }
		          m.addedNodes.forEach((n2) => this.genAdds(n2, m.target));
		          m.removedNodes.forEach((n2) => {
		            const nodeId = this.mirror.getId(n2);
		            const parentId = isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
		            if (isBlocked(
		              m.target,
		              this.blockClass,
		              this.blockSelector,
		              this.unblockSelector,
		              false
		            ) || isIgnored(n2, this.mirror) || !isSerialized(n2, this.mirror)) {
		              return;
		            }
		            if (this.addedSet.has(n2)) {
		              deepDelete(this.addedSet, n2);
		              this.droppedSet.add(n2);
		            } else if (this.addedSet.has(m.target) && nodeId === -1) ;
		            else if (isAncestorRemoved(m.target, this.mirror)) ;
		            else if (this.movedSet.has(n2) && this.movedMap[moveKey(nodeId, parentId)]) {
		              deepDelete(this.movedSet, n2);
		            } else {
		              this.removes.push({
		                parentId,
		                id: nodeId,
		                isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : void 0
		              });
		            }
		            this.mapRemoves.push(n2);
		          });
		          break;
		        }
		      }
		    };
		    this.genAdds = (n2, target) => {
		      if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
		      if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
		      if (this.mirror.hasNode(n2)) {
		        if (isIgnored(n2, this.mirror)) {
		          return;
		        }
		        this.movedSet.add(n2);
		        let targetId = null;
		        if (target && this.mirror.hasNode(target)) {
		          targetId = this.mirror.getId(target);
		        }
		        if (targetId && targetId !== -1) {
		          this.movedMap[moveKey(this.mirror.getId(n2), targetId)] = true;
		        }
		      } else {
		        this.addedSet.add(n2);
		        this.droppedSet.delete(n2);
		      }
		      if (!isBlocked(
		        n2,
		        this.blockClass,
		        this.blockSelector,
		        this.unblockSelector,
		        false
		      )) {
		        if (n2.childNodes) {
		          n2.childNodes.forEach((childN) => this.genAdds(childN));
		        }
		        if (hasShadowRoot(n2)) {
		          n2.shadowRoot.childNodes.forEach((childN) => {
		            this.processedNodeManager.add(childN, this);
		            this.genAdds(childN, n2);
		          });
		        }
		      }
		    };
		  }
		  init(options) {
		    [
		      "mutationCb",
		      "blockClass",
		      "blockSelector",
		      "unblockSelector",
		      "maskAllText",
		      "maskTextClass",
		      "unmaskTextClass",
		      "maskTextSelector",
		      "unmaskTextSelector",
		      "inlineStylesheet",
		      "maskInputOptions",
		      "maskAttributeFn",
		      "maskTextFn",
		      "maskInputFn",
		      "keepIframeSrcFn",
		      "recordCanvas",
		      "inlineImages",
		      "slimDOMOptions",
		      "dataURLOptions",
		      "doc",
		      "mirror",
		      "iframeManager",
		      "stylesheetManager",
		      "shadowDomManager",
		      "canvasManager",
		      "processedNodeManager",
		      "ignoreCSSAttributes"
		    ].forEach((key) => {
		      this[key] = options[key];
		    });
		    this.styleDeclarationParser = new StyleDeclarationParser(this.doc);
		  }
		  freeze() {
		    this.frozen = true;
		    this.canvasManager.freeze();
		  }
		  unfreeze() {
		    this.frozen = false;
		    this.canvasManager.unfreeze();
		    this.emit();
		  }
		  isFrozen() {
		    return this.frozen;
		  }
		  lock() {
		    this.locked = true;
		    this.canvasManager.lock();
		  }
		  unlock() {
		    this.locked = false;
		    this.canvasManager.unlock();
		    this.emit();
		  }
		  reset() {
		    this.shadowDomManager.reset();
		    this.canvasManager.reset();
		  }
		}
		function deepDelete(addsSet, n2) {
		  addsSet.delete(n2);
		  n2.childNodes?.forEach((childN) => deepDelete(addsSet, childN));
		}
		function isParentRemoved(removes, n2, mirror2) {
		  if (removes.length === 0) return false;
		  return _isParentRemoved(removes, n2, mirror2);
		}
		function _isParentRemoved(removes, n2, mirror2) {
		  let node = n2.parentNode;
		  while (node) {
		    const parentId = mirror2.getId(node);
		    if (removes.some((r2) => r2.id === parentId)) {
		      return true;
		    }
		    node = node.parentNode;
		  }
		  return false;
		}
		function isAncestorInSet(set, n2) {
		  if (set.size === 0) return false;
		  return _isAncestorInSet(set, n2);
		}
		function _isAncestorInSet(set, n2) {
		  const { parentNode } = n2;
		  if (!parentNode) {
		    return false;
		  }
		  if (set.has(parentNode)) {
		    return true;
		  }
		  return _isAncestorInSet(set, parentNode);
		}
		const mutationBuffers = [];
		function getEventTarget(event) {
		  try {
		    if ("composedPath" in event) {
		      const path = event.composedPath();
		      if (path.length) {
		        return path[0];
		      }
		    } else if ("path" in event && event.path.length) {
		      return event.path[0];
		    }
		  } catch {
		  }
		  return event && event.target;
		}
		function initMutationObserver(options, rootEl) {
		  const mutationBuffer = new MutationBuffer();
		  mutationBuffers.push(mutationBuffer);
		  mutationBuffer.init(options);
		  let mutationObserverCtor = window.MutationObserver || /**
		  * Some websites may disable MutationObserver by removing it from the window object.
		  * If someone is using rrweb to build a browser extention or things like it, they
		  * could not change the website's code but can have an opportunity to inject some
		  * code before the website executing its JS logic.
		  * Then they can do this to store the native MutationObserver:
		  * window.__rrMutationObserver = MutationObserver
		  */
		  window.__rrMutationObserver;
		  const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
		  if (angularZoneSymbol && window[angularZoneSymbol]) {
		    mutationObserverCtor = window[angularZoneSymbol];
		  }
		  const observer = new mutationObserverCtor(
		    callbackWrapper((mutations) => {
		      if (options.onMutation && options.onMutation(mutations) === false) {
		        return;
		      }
		      mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
		    })
		  );
		  observer.observe(rootEl, {
		    attributes: true,
		    attributeOldValue: true,
		    characterData: true,
		    characterDataOldValue: true,
		    childList: true,
		    subtree: true
		  });
		  return observer;
		}
		function initMoveObserver({
		  mousemoveCb,
		  sampling,
		  doc,
		  mirror: mirror2
		}) {
		  if (sampling.mousemove === false) {
		    return () => {
		    };
		  }
		  const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
		  const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
		  let positions = [];
		  let timeBaseline;
		  const wrappedCb = throttle$1(
		    callbackWrapper(
		      (source) => {
		        const totalOffset = Date.now() - timeBaseline;
		        mousemoveCb(
		          positions.map((p) => {
		            p.timeOffset -= totalOffset;
		            return p;
		          }),
		          source
		        );
		        positions = [];
		        timeBaseline = null;
		      }
		    ),
		    callbackThreshold
		  );
		  const updatePosition = callbackWrapper(
		    throttle$1(
		      callbackWrapper((evt) => {
		        const target = getEventTarget(evt);
		        const { clientX, clientY } = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
		        if (!timeBaseline) {
		          timeBaseline = nowTimestamp();
		        }
		        positions.push({
		          x: clientX,
		          y: clientY,
		          id: mirror2.getId(target),
		          timeOffset: nowTimestamp() - timeBaseline
		        });
		        wrappedCb(
		          typeof DragEvent !== "undefined" && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove
		        );
		      }),
		      threshold,
		      {
		        trailing: false
		      }
		    )
		  );
		  const handlers = [
		    on("mousemove", updatePosition, doc),
		    on("touchmove", updatePosition, doc),
		    on("drag", updatePosition, doc)
		  ];
		  return callbackWrapper(() => {
		    handlers.forEach((h) => h());
		  });
		}
		function initMouseInteractionObserver({
		  mouseInteractionCb,
		  doc,
		  mirror: mirror2,
		  blockClass,
		  blockSelector,
		  unblockSelector,
		  sampling
		}) {
		  if (sampling.mouseInteraction === false) {
		    return () => {
		    };
		  }
		  const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
		  const handlers = [];
		  let currentPointerType = null;
		  const getHandler = (eventKey) => {
		    return (event) => {
		      const target = getEventTarget(event);
		      if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
		        return;
		      }
		      let pointerType = null;
		      let thisEventKey = eventKey;
		      if ("pointerType" in event) {
		        switch (event.pointerType) {
		          case "mouse":
		            pointerType = PointerTypes.Mouse;
		            break;
		          case "touch":
		            pointerType = PointerTypes.Touch;
		            break;
		          case "pen":
		            pointerType = PointerTypes.Pen;
		            break;
		        }
		        if (pointerType === PointerTypes.Touch) {
		          if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
		            thisEventKey = "TouchStart";
		          } else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
		            thisEventKey = "TouchEnd";
		          }
		        } else if (pointerType === PointerTypes.Pen) ;
		      } else if (legacy_isTouchEvent(event)) {
		        pointerType = PointerTypes.Touch;
		      }
		      if (pointerType !== null) {
		        currentPointerType = pointerType;
		        if (thisEventKey.startsWith("Touch") && pointerType === PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === PointerTypes.Mouse) {
		          pointerType = null;
		        }
		      } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
		        pointerType = currentPointerType;
		        currentPointerType = null;
		      }
		      const e2 = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
		      if (!e2) {
		        return;
		      }
		      const id = mirror2.getId(target);
		      const { clientX, clientY } = e2;
		      callbackWrapper(mouseInteractionCb)({
		        type: MouseInteractions[thisEventKey],
		        id,
		        x: clientX,
		        y: clientY,
		        ...pointerType !== null && { pointerType }
		      });
		    };
		  };
		  Object.keys(MouseInteractions).filter(
		    (key) => Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false
		  ).forEach((eventKey) => {
		    let eventName = toLowerCase(eventKey);
		    const handler = getHandler(eventKey);
		    if (window.PointerEvent) {
		      switch (MouseInteractions[eventKey]) {
		        case MouseInteractions.MouseDown:
		        case MouseInteractions.MouseUp:
		          eventName = eventName.replace(
		            "mouse",
		            "pointer"
		          );
		          break;
		        case MouseInteractions.TouchStart:
		        case MouseInteractions.TouchEnd:
		          return;
		      }
		    }
		    handlers.push(on(eventName, handler, doc));
		  });
		  return callbackWrapper(() => {
		    handlers.forEach((h) => h());
		  });
		}
		function initScrollObserver({
		  scrollCb,
		  doc,
		  mirror: mirror2,
		  blockClass,
		  blockSelector,
		  unblockSelector,
		  sampling
		}) {
		  const updatePosition = callbackWrapper(
		    throttle$1(
		      callbackWrapper((evt) => {
		        const target = getEventTarget(evt);
		        if (!target || isBlocked(
		          target,
		          blockClass,
		          blockSelector,
		          unblockSelector,
		          true
		        )) {
		          return;
		        }
		        const id = mirror2.getId(target);
		        if (target === doc && doc.defaultView) {
		          const scrollLeftTop = getWindowScroll(doc.defaultView);
		          scrollCb({
		            id,
		            x: scrollLeftTop.left,
		            y: scrollLeftTop.top
		          });
		        } else {
		          scrollCb({
		            id,
		            x: target.scrollLeft,
		            y: target.scrollTop
		          });
		        }
		      }),
		      sampling.scroll || 100
		    )
		  );
		  return on("scroll", updatePosition, doc);
		}
		function initViewportResizeObserver({ viewportResizeCb }, { win }) {
		  let lastH = -1;
		  let lastW = -1;
		  const updateDimension = callbackWrapper(
		    throttle$1(
		      callbackWrapper(() => {
		        const height = getWindowHeight();
		        const width = getWindowWidth();
		        if (lastH !== height || lastW !== width) {
		          viewportResizeCb({
		            width: Number(width),
		            height: Number(height)
		          });
		          lastH = height;
		          lastW = width;
		        }
		      }),
		      200
		    )
		  );
		  return on("resize", updateDimension, win);
		}
		const INPUT_TAGS = ["INPUT", "TEXTAREA", "SELECT"];
		const lastInputValueMap = /* @__PURE__ */ new WeakMap();
		function initInputObserver({
		  inputCb,
		  doc,
		  mirror: mirror2,
		  blockClass,
		  blockSelector,
		  unblockSelector,
		  ignoreClass,
		  ignoreSelector,
		  maskInputOptions,
		  maskInputFn,
		  sampling,
		  userTriggeredOnInput,
		  maskTextClass,
		  unmaskTextClass,
		  maskTextSelector,
		  unmaskTextSelector
		}) {
		  function eventHandler(event) {
		    let target = getEventTarget(event);
		    const userTriggered = event.isTrusted;
		    const tagName = target && toUpperCase(target.tagName);
		    if (tagName === "OPTION") target = target.parentElement;
		    if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(
		      target,
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      true
		    )) {
		      return;
		    }
		    const el = target;
		    if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) {
		      return;
		    }
		    const type = getInputType(target);
		    let text = getInputValue(el, tagName, type);
		    let isChecked = false;
		    const isInputMasked = shouldMaskInput({
		      maskInputOptions,
		      tagName,
		      type
		    });
		    const forceMask = needMaskingText(
		      target,
		      maskTextClass,
		      maskTextSelector,
		      unmaskTextClass,
		      unmaskTextSelector,
		      isInputMasked
		    );
		    if (type === "radio" || type === "checkbox") {
		      isChecked = target.checked;
		    }
		    text = maskInputValue({
		      isMasked: forceMask,
		      element: target,
		      value: text,
		      maskInputFn
		    });
		    cbWithDedup(
		      target,
		      userTriggeredOnInput ? { text, isChecked, userTriggered } : { text, isChecked }
		    );
		    const name = target.name;
		    if (type === "radio" && name && isChecked) {
		      doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2) => {
		        if (el2 !== target) {
		          const text2 = maskInputValue({
		            // share mask behavior of `target`
		            isMasked: forceMask,
		            element: el2,
		            value: getInputValue(el2, tagName, type),
		            maskInputFn
		          });
		          cbWithDedup(
		            el2,
		            userTriggeredOnInput ? { text: text2, isChecked: !isChecked, userTriggered: false } : { text: text2, isChecked: !isChecked }
		          );
		        }
		      });
		    }
		  }
		  function cbWithDedup(target, v2) {
		    const lastInputValue = lastInputValueMap.get(target);
		    if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
		      lastInputValueMap.set(target, v2);
		      const id = mirror2.getId(target);
		      callbackWrapper(inputCb)({
		        ...v2,
		        id
		      });
		    }
		  }
		  const events = sampling.input === "last" ? ["change"] : ["input", "change"];
		  const handlers = events.map(
		    (eventName) => on(eventName, callbackWrapper(eventHandler), doc)
		  );
		  const currentWindow = doc.defaultView;
		  if (!currentWindow) {
		    return () => {
		      handlers.forEach((h) => h());
		    };
		  }
		  const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(
		    currentWindow.HTMLInputElement.prototype,
		    "value"
		  );
		  const hookProperties = [
		    [currentWindow.HTMLInputElement.prototype, "value"],
		    [currentWindow.HTMLInputElement.prototype, "checked"],
		    [currentWindow.HTMLSelectElement.prototype, "value"],
		    [currentWindow.HTMLTextAreaElement.prototype, "value"],
		    // Some UI library use selectedIndex to set select value
		    [currentWindow.HTMLSelectElement.prototype, "selectedIndex"],
		    [currentWindow.HTMLOptionElement.prototype, "selected"]
		  ];
		  if (propertyDescriptor && propertyDescriptor.set) {
		    handlers.push(
		      ...hookProperties.map(
		        (p) => hookSetter(
		          p[0],
		          p[1],
		          {
		            set() {
		              callbackWrapper(eventHandler)({
		                target: this,
		                isTrusted: false
		                // userTriggered to false as this could well be programmatic
		              });
		            }
		          },
		          false,
		          currentWindow
		        )
		      )
		    );
		  }
		  return callbackWrapper(() => {
		    handlers.forEach((h) => h());
		  });
		}
		function getNestedCSSRulePositions(rule) {
		  const positions = [];
		  function recurse(childRule, pos) {
		    if (hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
		      const rules2 = Array.from(
		        childRule.parentRule.cssRules
		      );
		      const index = rules2.indexOf(childRule);
		      pos.unshift(index);
		    } else if (childRule.parentStyleSheet) {
		      const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
		      const index = rules2.indexOf(childRule);
		      pos.unshift(index);
		    }
		    return pos;
		  }
		  return recurse(rule, positions);
		}
		function getIdAndStyleId(sheet, mirror2, styleMirror) {
		  let id, styleId;
		  if (!sheet) return {};
		  if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
		  else styleId = styleMirror.getId(sheet);
		  return {
		    styleId,
		    id
		  };
		}
		function initStyleSheetObserver({ styleSheetRuleCb, mirror: mirror2, stylesheetManager }, { win }) {
		  if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
		    return () => {
		    };
		  }
		  const insertRule = win.CSSStyleSheet.prototype.insertRule;
		  win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
		    apply: callbackWrapper(
		      (target, thisArg, argumentsList) => {
		        const [rule, index] = argumentsList;
		        const { id, styleId } = getIdAndStyleId(
		          thisArg,
		          mirror2,
		          stylesheetManager.styleMirror
		        );
		        if (id && id !== -1 || styleId && styleId !== -1) {
		          styleSheetRuleCb({
		            id,
		            styleId,
		            adds: [{ rule, index }]
		          });
		        }
		        return target.apply(thisArg, argumentsList);
		      }
		    )
		  });
		  const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
		  win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
		    apply: callbackWrapper(
		      (target, thisArg, argumentsList) => {
		        const [index] = argumentsList;
		        const { id, styleId } = getIdAndStyleId(
		          thisArg,
		          mirror2,
		          stylesheetManager.styleMirror
		        );
		        if (id && id !== -1 || styleId && styleId !== -1) {
		          styleSheetRuleCb({
		            id,
		            styleId,
		            removes: [{ index }]
		          });
		        }
		        return target.apply(thisArg, argumentsList);
		      }
		    )
		  });
		  let replace;
		  if (win.CSSStyleSheet.prototype.replace) {
		    replace = win.CSSStyleSheet.prototype.replace;
		    win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
		      apply: callbackWrapper(
		        (target, thisArg, argumentsList) => {
		          const [text] = argumentsList;
		          const { id, styleId } = getIdAndStyleId(
		            thisArg,
		            mirror2,
		            stylesheetManager.styleMirror
		          );
		          if (id && id !== -1 || styleId && styleId !== -1) {
		            styleSheetRuleCb({
		              id,
		              styleId,
		              replace: text
		            });
		          }
		          return target.apply(thisArg, argumentsList);
		        }
		      )
		    });
		  }
		  let replaceSync;
		  if (win.CSSStyleSheet.prototype.replaceSync) {
		    replaceSync = win.CSSStyleSheet.prototype.replaceSync;
		    win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
		      apply: callbackWrapper(
		        (target, thisArg, argumentsList) => {
		          const [text] = argumentsList;
		          const { id, styleId } = getIdAndStyleId(
		            thisArg,
		            mirror2,
		            stylesheetManager.styleMirror
		          );
		          if (id && id !== -1 || styleId && styleId !== -1) {
		            styleSheetRuleCb({
		              id,
		              styleId,
		              replaceSync: text
		            });
		          }
		          return target.apply(thisArg, argumentsList);
		        }
		      )
		    });
		  }
		  const supportedNestedCSSRuleTypes = {};
		  if (canMonkeyPatchNestedCSSRule("CSSGroupingRule")) {
		    supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
		  } else {
		    if (canMonkeyPatchNestedCSSRule("CSSMediaRule")) {
		      supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
		    }
		    if (canMonkeyPatchNestedCSSRule("CSSConditionRule")) {
		      supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
		    }
		    if (canMonkeyPatchNestedCSSRule("CSSSupportsRule")) {
		      supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
		    }
		  }
		  const unmodifiedFunctions = {};
		  Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
		    unmodifiedFunctions[typeKey] = {
		      // eslint-disable-next-line @typescript-eslint/unbound-method
		      insertRule: type.prototype.insertRule,
		      // eslint-disable-next-line @typescript-eslint/unbound-method
		      deleteRule: type.prototype.deleteRule
		    };
		    type.prototype.insertRule = new Proxy(
		      unmodifiedFunctions[typeKey].insertRule,
		      {
		        apply: callbackWrapper(
		          (target, thisArg, argumentsList) => {
		            const [rule, index] = argumentsList;
		            const { id, styleId } = getIdAndStyleId(
		              thisArg.parentStyleSheet,
		              mirror2,
		              stylesheetManager.styleMirror
		            );
		            if (id && id !== -1 || styleId && styleId !== -1) {
		              styleSheetRuleCb({
		                id,
		                styleId,
		                adds: [
		                  {
		                    rule,
		                    index: [
		                      ...getNestedCSSRulePositions(thisArg),
		                      index || 0
		                      // defaults to 0
		                    ]
		                  }
		                ]
		              });
		            }
		            return target.apply(thisArg, argumentsList);
		          }
		        )
		      }
		    );
		    type.prototype.deleteRule = new Proxy(
		      unmodifiedFunctions[typeKey].deleteRule,
		      {
		        apply: callbackWrapper(
		          (target, thisArg, argumentsList) => {
		            const [index] = argumentsList;
		            const { id, styleId } = getIdAndStyleId(
		              thisArg.parentStyleSheet,
		              mirror2,
		              stylesheetManager.styleMirror
		            );
		            if (id && id !== -1 || styleId && styleId !== -1) {
		              styleSheetRuleCb({
		                id,
		                styleId,
		                removes: [
		                  { index: [...getNestedCSSRulePositions(thisArg), index] }
		                ]
		              });
		            }
		            return target.apply(thisArg, argumentsList);
		          }
		        )
		      }
		    );
		  });
		  return callbackWrapper(() => {
		    win.CSSStyleSheet.prototype.insertRule = insertRule;
		    win.CSSStyleSheet.prototype.deleteRule = deleteRule;
		    replace && (win.CSSStyleSheet.prototype.replace = replace);
		    replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
		    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
		      type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
		      type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
		    });
		  });
		}
		function initAdoptedStyleSheetObserver({
		  mirror: mirror2,
		  stylesheetManager
		}, host) {
		  let hostId = null;
		  if (host.nodeName === "#document") hostId = mirror2.getId(host);
		  else hostId = mirror2.getId(host.host);
		  const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
		  const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(
		    patchTarget?.prototype,
		    "adoptedStyleSheets"
		  ) : void 0;
		  if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor)
		    return () => {
		    };
		  Object.defineProperty(host, "adoptedStyleSheets", {
		    configurable: originalPropertyDescriptor.configurable,
		    enumerable: originalPropertyDescriptor.enumerable,
		    get() {
		      return originalPropertyDescriptor.get?.call(this);
		    },
		    set(sheets) {
		      const result = originalPropertyDescriptor.set?.call(this, sheets);
		      if (hostId !== null && hostId !== -1) {
		        try {
		          stylesheetManager.adoptStyleSheets(sheets, hostId);
		        } catch (e2) {
		        }
		      }
		      return result;
		    }
		  });
		  return callbackWrapper(() => {
		    Object.defineProperty(host, "adoptedStyleSheets", {
		      configurable: originalPropertyDescriptor.configurable,
		      enumerable: originalPropertyDescriptor.enumerable,
		      // eslint-disable-next-line @typescript-eslint/unbound-method
		      get: originalPropertyDescriptor.get,
		      // eslint-disable-next-line @typescript-eslint/unbound-method
		      set: originalPropertyDescriptor.set
		    });
		  });
		}
		function initStyleDeclarationObserver({
		  styleDeclarationCb,
		  mirror: mirror2,
		  ignoreCSSAttributes,
		  stylesheetManager
		}, { win }) {
		  const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
		  win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
		    apply: callbackWrapper(
		      (target, thisArg, argumentsList) => {
		        const [property, value, priority] = argumentsList;
		        if (ignoreCSSAttributes.has(property)) {
		          return setProperty.apply(thisArg, [property, value, priority]);
		        }
		        const { id, styleId } = getIdAndStyleId(
		          thisArg.parentRule?.parentStyleSheet,
		          mirror2,
		          stylesheetManager.styleMirror
		        );
		        if (id && id !== -1 || styleId && styleId !== -1) {
		          styleDeclarationCb({
		            id,
		            styleId,
		            set: {
		              property,
		              value,
		              priority
		            },
		            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		            index: getNestedCSSRulePositions(thisArg.parentRule)
		          });
		        }
		        return target.apply(thisArg, argumentsList);
		      }
		    )
		  });
		  const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
		  win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
		    apply: callbackWrapper(
		      (target, thisArg, argumentsList) => {
		        const [property] = argumentsList;
		        if (ignoreCSSAttributes.has(property)) {
		          return removeProperty.apply(thisArg, [property]);
		        }
		        const { id, styleId } = getIdAndStyleId(
		          thisArg.parentRule?.parentStyleSheet,
		          mirror2,
		          stylesheetManager.styleMirror
		        );
		        if (id && id !== -1 || styleId && styleId !== -1) {
		          styleDeclarationCb({
		            id,
		            styleId,
		            remove: {
		              property
		            },
		            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		            index: getNestedCSSRulePositions(thisArg.parentRule)
		          });
		        }
		        return target.apply(thisArg, argumentsList);
		      }
		    )
		  });
		  return callbackWrapper(() => {
		    win.CSSStyleDeclaration.prototype.setProperty = setProperty;
		    win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
		  });
		}
		function initMediaInteractionObserver({
		  mediaInteractionCb,
		  blockClass,
		  blockSelector,
		  unblockSelector,
		  mirror: mirror2,
		  sampling,
		  doc
		}) {
		  const handler = callbackWrapper(
		    (type) => throttle$1(
		      callbackWrapper((event) => {
		        const target = getEventTarget(event);
		        if (!target || isBlocked(
		          target,
		          blockClass,
		          blockSelector,
		          unblockSelector,
		          true
		        )) {
		          return;
		        }
		        const { currentTime, volume, muted, playbackRate } = target;
		        mediaInteractionCb({
		          type,
		          id: mirror2.getId(target),
		          currentTime,
		          volume,
		          muted,
		          playbackRate
		        });
		      }),
		      sampling.media || 500
		    )
		  );
		  const handlers = [
		    on("play", handler(MediaInteractions.Play), doc),
		    on("pause", handler(MediaInteractions.Pause), doc),
		    on("seeked", handler(MediaInteractions.Seeked), doc),
		    on("volumechange", handler(MediaInteractions.VolumeChange), doc),
		    on("ratechange", handler(MediaInteractions.RateChange), doc)
		  ];
		  return callbackWrapper(() => {
		    handlers.forEach((h) => h());
		  });
		}
		function initFontObserver({ fontCb, doc }) {
		  const win = doc.defaultView;
		  if (!win) {
		    return () => {
		    };
		  }
		  const handlers = [];
		  const fontMap = /* @__PURE__ */ new WeakMap();
		  const originalFontFace = win.FontFace;
		  win.FontFace = function FontFace2(family, source, descriptors) {
		    const fontFace = new originalFontFace(family, source, descriptors);
		    fontMap.set(fontFace, {
		      family,
		      buffer: typeof source !== "string",
		      descriptors,
		      fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
		    });
		    return fontFace;
		  };
		  const restoreHandler = patch(
		    doc.fonts,
		    "add",
		    function(original) {
		      return function(fontFace) {
		        setTimeout$2(
		          callbackWrapper(() => {
		            const p = fontMap.get(fontFace);
		            if (p) {
		              fontCb(p);
		              fontMap.delete(fontFace);
		            }
		          }),
		          0
		        );
		        return original.apply(this, [fontFace]);
		      };
		    }
		  );
		  handlers.push(() => {
		    win.FontFace = originalFontFace;
		  });
		  handlers.push(restoreHandler);
		  return callbackWrapper(() => {
		    handlers.forEach((h) => h());
		  });
		}
		function initSelectionObserver(param) {
		  const {
		    doc,
		    mirror: mirror2,
		    blockClass,
		    blockSelector,
		    unblockSelector,
		    selectionCb
		  } = param;
		  let collapsed = true;
		  const updateSelection = callbackWrapper(() => {
		    const selection = doc.getSelection();
		    if (!selection || collapsed && selection?.isCollapsed) return;
		    collapsed = selection.isCollapsed || false;
		    const ranges = [];
		    const count = selection.rangeCount || 0;
		    for (let i2 = 0; i2 < count; i2++) {
		      const range = selection.getRangeAt(i2);
		      const { startContainer, startOffset, endContainer, endOffset } = range;
		      const blocked = isBlocked(
		        startContainer,
		        blockClass,
		        blockSelector,
		        unblockSelector,
		        true
		      ) || isBlocked(
		        endContainer,
		        blockClass,
		        blockSelector,
		        unblockSelector,
		        true
		      );
		      if (blocked) continue;
		      ranges.push({
		        start: mirror2.getId(startContainer),
		        startOffset,
		        end: mirror2.getId(endContainer),
		        endOffset
		      });
		    }
		    selectionCb({ ranges });
		  });
		  updateSelection();
		  return on("selectionchange", updateSelection);
		}
		function initCustomElementObserver({
		  doc,
		  customElementCb
		}) {
		  const win = doc.defaultView;
		  if (!win || !win.customElements) return () => {
		  };
		  const restoreHandler = patch(
		    win.customElements,
		    "define",
		    function(original) {
		      return function(name, constructor, options) {
		        try {
		          customElementCb({
		            define: {
		              name
		            }
		          });
		        } catch (e2) {
		        }
		        return original.apply(this, [name, constructor, options]);
		      };
		    }
		  );
		  return restoreHandler;
		}
		function initObservers(o2, _hooks = {}) {
		  const currentWindow = o2.doc.defaultView;
		  if (!currentWindow) {
		    return () => {
		    };
		  }
		  let mutationObserver;
		  if (o2.recordDOM) {
		    mutationObserver = initMutationObserver(o2, o2.doc);
		  }
		  const mousemoveHandler = initMoveObserver(o2);
		  const mouseInteractionHandler = initMouseInteractionObserver(o2);
		  const scrollHandler = initScrollObserver(o2);
		  const viewportResizeHandler = initViewportResizeObserver(o2, {
		    win: currentWindow
		  });
		  const inputHandler = initInputObserver(o2);
		  const mediaInteractionHandler = initMediaInteractionObserver(o2);
		  let styleSheetObserver = () => {
		  };
		  let adoptedStyleSheetObserver = () => {
		  };
		  let styleDeclarationObserver = () => {
		  };
		  let fontObserver = () => {
		  };
		  if (o2.recordDOM) {
		    styleSheetObserver = initStyleSheetObserver(o2, { win: currentWindow });
		    adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o2, o2.doc);
		    styleDeclarationObserver = initStyleDeclarationObserver(o2, {
		      win: currentWindow
		    });
		    if (o2.collectFonts) {
		      fontObserver = initFontObserver(o2);
		    }
		  }
		  const selectionObserver = initSelectionObserver(o2);
		  const customElementObserver = initCustomElementObserver(o2);
		  const pluginHandlers = [];
		  for (const plugin of o2.plugins) {
		    pluginHandlers.push(
		      plugin.observer(plugin.callback, currentWindow, plugin.options)
		    );
		  }
		  return callbackWrapper(() => {
		    mutationBuffers.forEach((b) => b.reset());
		    mutationObserver?.disconnect();
		    mousemoveHandler();
		    mouseInteractionHandler();
		    scrollHandler();
		    viewportResizeHandler();
		    inputHandler();
		    mediaInteractionHandler();
		    styleSheetObserver();
		    adoptedStyleSheetObserver();
		    styleDeclarationObserver();
		    fontObserver();
		    selectionObserver();
		    customElementObserver();
		    pluginHandlers.forEach((h) => h());
		  });
		}
		function hasNestedCSSRule(prop) {
		  return typeof window[prop] !== "undefined";
		}
		function canMonkeyPatchNestedCSSRule(prop) {
		  return Boolean(
		    typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
		    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
		    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype
		  );
		}
		class CrossOriginIframeMirror {
		  constructor(generateIdFn) {
		    this.generateIdFn = generateIdFn;
		    this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
		    this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
		  }
		  getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
		    const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
		    const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
		    let id = idToRemoteIdMap.get(remoteId);
		    if (!id) {
		      id = this.generateIdFn();
		      idToRemoteIdMap.set(remoteId, id);
		      remoteIdToIdMap.set(id, remoteId);
		    }
		    return id;
		  }
		  getIds(iframe, remoteId) {
		    const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
		    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
		    return remoteId.map(
		      (id) => this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap)
		    );
		  }
		  getRemoteId(iframe, id, map) {
		    const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
		    if (typeof id !== "number") return id;
		    const remoteId = remoteIdToIdMap.get(id);
		    if (!remoteId) return -1;
		    return remoteId;
		  }
		  getRemoteIds(iframe, ids) {
		    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
		    return ids.map((id) => this.getRemoteId(iframe, id, remoteIdToIdMap));
		  }
		  reset(iframe) {
		    if (!iframe) {
		      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
		      this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
		      return;
		    }
		    this.iframeIdToRemoteIdMap.delete(iframe);
		    this.iframeRemoteIdToIdMap.delete(iframe);
		  }
		  getIdToRemoteIdMap(iframe) {
		    let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
		    if (!idToRemoteIdMap) {
		      idToRemoteIdMap = /* @__PURE__ */ new Map();
		      this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
		    }
		    return idToRemoteIdMap;
		  }
		  getRemoteIdToIdMap(iframe) {
		    let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
		    if (!remoteIdToIdMap) {
		      remoteIdToIdMap = /* @__PURE__ */ new Map();
		      this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
		    }
		    return remoteIdToIdMap;
		  }
		}
		class IframeManagerNoop {
		  constructor() {
		    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
		    this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
		  }
		  addIframe() {
		  }
		  addLoadListener() {
		  }
		  attachIframe() {
		  }
		}
		class IframeManager {
		  constructor(options) {
		    this.iframes = /* @__PURE__ */ new WeakMap();
		    this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
		    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
		    this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
		    this.mutationCb = options.mutationCb;
		    this.wrappedEmit = options.wrappedEmit;
		    this.stylesheetManager = options.stylesheetManager;
		    this.recordCrossOriginIframes = options.recordCrossOriginIframes;
		    this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(
		      this.stylesheetManager.styleMirror.generateId.bind(
		        this.stylesheetManager.styleMirror
		      )
		    );
		    this.mirror = options.mirror;
		    if (this.recordCrossOriginIframes) {
		      window.addEventListener("message", this.handleMessage.bind(this));
		    }
		  }
		  addIframe(iframeEl) {
		    this.iframes.set(iframeEl, true);
		    const contentWindow = getIFrameContentWindow(iframeEl);
		    if (contentWindow) this.crossOriginIframeMap.set(contentWindow, iframeEl);
		  }
		  addLoadListener(cb) {
		    this.loadListener = cb;
		  }
		  attachIframe(iframeEl, childSn) {
		    this.mutationCb({
		      adds: [
		        {
		          parentId: this.mirror.getId(iframeEl),
		          nextId: null,
		          node: childSn
		        }
		      ],
		      removes: [],
		      texts: [],
		      attributes: [],
		      isAttachIframe: true
		    });
		    if (this.recordCrossOriginIframes) {
		      getIFrameContentWindow(iframeEl)?.addEventListener(
		        "message",
		        this.handleMessage.bind(this)
		      );
		    }
		    this.loadListener?.(iframeEl);
		    const iframeDoc = getIFrameContentDocument(iframeEl);
		    if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0)
		      this.stylesheetManager.adoptStyleSheets(
		        iframeDoc.adoptedStyleSheets,
		        this.mirror.getId(iframeDoc)
		      );
		  }
		  handleMessage(message) {
		    const crossOriginMessageEvent = message;
		    if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
		    crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin)
		      return;
		    const iframeSourceWindow = message.source;
		    if (!iframeSourceWindow) return;
		    const iframeEl = this.crossOriginIframeMap.get(message.source);
		    if (!iframeEl) return;
		    const transformedEvent = this.transformCrossOriginEvent(
		      iframeEl,
		      crossOriginMessageEvent.data.event
		    );
		    if (transformedEvent)
		      this.wrappedEmit(
		        transformedEvent,
		        crossOriginMessageEvent.data.isCheckout
		      );
		  }
		  transformCrossOriginEvent(iframeEl, e2) {
		    switch (e2.type) {
		      case EventType.FullSnapshot: {
		        this.crossOriginIframeMirror.reset(iframeEl);
		        this.crossOriginIframeStyleMirror.reset(iframeEl);
		        this.replaceIdOnNode(e2.data.node, iframeEl);
		        const rootId = e2.data.node.id;
		        this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
		        this.patchRootIdOnNode(e2.data.node, rootId);
		        return {
		          timestamp: e2.timestamp,
		          type: EventType.IncrementalSnapshot,
		          data: {
		            source: IncrementalSource.Mutation,
		            adds: [
		              {
		                parentId: this.mirror.getId(iframeEl),
		                nextId: null,
		                node: e2.data.node
		              }
		            ],
		            removes: [],
		            texts: [],
		            attributes: [],
		            isAttachIframe: true
		          }
		        };
		      }
		      case EventType.Meta:
		      case EventType.Load:
		      case EventType.DomContentLoaded: {
		        return false;
		      }
		      case EventType.Plugin: {
		        return e2;
		      }
		      case EventType.Custom: {
		        this.replaceIds(
		          e2.data.payload,
		          iframeEl,
		          ["id", "parentId", "previousId", "nextId"]
		        );
		        return e2;
		      }
		      case EventType.IncrementalSnapshot: {
		        switch (e2.data.source) {
		          case IncrementalSource.Mutation: {
		            e2.data.adds.forEach((n2) => {
		              this.replaceIds(n2, iframeEl, [
		                "parentId",
		                "nextId",
		                "previousId"
		              ]);
		              this.replaceIdOnNode(n2.node, iframeEl);
		              const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
		              rootId && this.patchRootIdOnNode(n2.node, rootId);
		            });
		            e2.data.removes.forEach((n2) => {
		              this.replaceIds(n2, iframeEl, ["parentId", "id"]);
		            });
		            e2.data.attributes.forEach((n2) => {
		              this.replaceIds(n2, iframeEl, ["id"]);
		            });
		            e2.data.texts.forEach((n2) => {
		              this.replaceIds(n2, iframeEl, ["id"]);
		            });
		            return e2;
		          }
		          case IncrementalSource.Drag:
		          case IncrementalSource.TouchMove:
		          case IncrementalSource.MouseMove: {
		            e2.data.positions.forEach((p) => {
		              this.replaceIds(p, iframeEl, ["id"]);
		            });
		            return e2;
		          }
		          case IncrementalSource.ViewportResize: {
		            return false;
		          }
		          case IncrementalSource.MediaInteraction:
		          case IncrementalSource.MouseInteraction:
		          case IncrementalSource.Scroll:
		          case IncrementalSource.CanvasMutation:
		          case IncrementalSource.Input: {
		            this.replaceIds(e2.data, iframeEl, ["id"]);
		            return e2;
		          }
		          case IncrementalSource.StyleSheetRule:
		          case IncrementalSource.StyleDeclaration: {
		            this.replaceIds(e2.data, iframeEl, ["id"]);
		            this.replaceStyleIds(e2.data, iframeEl, ["styleId"]);
		            return e2;
		          }
		          case IncrementalSource.Font: {
		            return e2;
		          }
		          case IncrementalSource.Selection: {
		            e2.data.ranges.forEach((range) => {
		              this.replaceIds(range, iframeEl, ["start", "end"]);
		            });
		            return e2;
		          }
		          case IncrementalSource.AdoptedStyleSheet: {
		            this.replaceIds(e2.data, iframeEl, ["id"]);
		            this.replaceStyleIds(e2.data, iframeEl, ["styleIds"]);
		            e2.data.styles?.forEach((style) => {
		              this.replaceStyleIds(style, iframeEl, ["styleId"]);
		            });
		            return e2;
		          }
		        }
		      }
		    }
		    return false;
		  }
		  replace(iframeMirror, obj, iframeEl, keys) {
		    for (const key of keys) {
		      if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
		      if (Array.isArray(obj[key])) {
		        obj[key] = iframeMirror.getIds(
		          iframeEl,
		          obj[key]
		        );
		      } else {
		        obj[key] = iframeMirror.getId(iframeEl, obj[key]);
		      }
		    }
		    return obj;
		  }
		  replaceIds(obj, iframeEl, keys) {
		    return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
		  }
		  replaceStyleIds(obj, iframeEl, keys) {
		    return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
		  }
		  replaceIdOnNode(node, iframeEl) {
		    this.replaceIds(node, iframeEl, ["id", "rootId"]);
		    if ("childNodes" in node) {
		      node.childNodes.forEach((child) => {
		        this.replaceIdOnNode(child, iframeEl);
		      });
		    }
		  }
		  patchRootIdOnNode(node, rootId) {
		    if (node.type !== NodeType$1.Document && !node.rootId) node.rootId = rootId;
		    if ("childNodes" in node) {
		      node.childNodes.forEach((child) => {
		        this.patchRootIdOnNode(child, rootId);
		      });
		    }
		  }
		}
		class ShadowDomManagerNoop {
		  init() {
		  }
		  addShadowRoot() {
		  }
		  observeAttachShadow() {
		  }
		  reset() {
		  }
		}
		class ShadowDomManager {
		  constructor(options) {
		    this.shadowDoms = /* @__PURE__ */ new WeakSet();
		    this.restoreHandlers = [];
		    this.mutationCb = options.mutationCb;
		    this.scrollCb = options.scrollCb;
		    this.bypassOptions = options.bypassOptions;
		    this.mirror = options.mirror;
		    this.init();
		  }
		  init() {
		    this.reset();
		    this.patchAttachShadow(Element, document);
		  }
		  addShadowRoot(shadowRoot, doc) {
		    if (!isNativeShadowDom(shadowRoot)) return;
		    if (this.shadowDoms.has(shadowRoot)) return;
		    this.shadowDoms.add(shadowRoot);
		    this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
		    const observer = initMutationObserver(
		      {
		        ...this.bypassOptions,
		        doc,
		        mutationCb: this.mutationCb,
		        mirror: this.mirror,
		        shadowDomManager: this
		      },
		      shadowRoot
		    );
		    this.restoreHandlers.push(() => observer.disconnect());
		    this.restoreHandlers.push(
		      initScrollObserver({
		        ...this.bypassOptions,
		        scrollCb: this.scrollCb,
		        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
		        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
		        doc: shadowRoot,
		        mirror: this.mirror
		      })
		    );
		    setTimeout$2(() => {
		      if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0)
		        this.bypassOptions.stylesheetManager.adoptStyleSheets(
		          shadowRoot.adoptedStyleSheets,
		          this.mirror.getId(shadowRoot.host)
		        );
		      this.restoreHandlers.push(
		        initAdoptedStyleSheetObserver(
		          {
		            mirror: this.mirror,
		            stylesheetManager: this.bypassOptions.stylesheetManager
		          },
		          shadowRoot
		        )
		      );
		    }, 0);
		  }
		  /**
		   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
		   */
		  observeAttachShadow(iframeElement) {
		    const iframeDoc = getIFrameContentDocument(iframeElement);
		    const iframeWindow = getIFrameContentWindow(iframeElement);
		    if (!iframeDoc || !iframeWindow) return;
		    this.patchAttachShadow(
		      iframeWindow.Element,
		      iframeDoc
		    );
		  }
		  /**
		   * Patch 'attachShadow' to observe newly added shadow doms.
		   */
		  patchAttachShadow(element, doc) {
		    const manager = this;
		    this.restoreHandlers.push(
		      patch(
		        element.prototype,
		        "attachShadow",
		        function(original) {
		          return function(option) {
		            const shadowRoot = original.call(this, option);
		            if (this.shadowRoot && inDom(this))
		              manager.addShadowRoot(this.shadowRoot, doc);
		            return shadowRoot;
		          };
		        }
		      )
		    );
		  }
		  reset() {
		    this.restoreHandlers.forEach((handler) => {
		      try {
		        handler();
		      } catch (e2) {
		      }
		    });
		    this.restoreHandlers = [];
		    this.shadowDoms = /* @__PURE__ */ new WeakSet();
		    this.bypassOptions.canvasManager.resetShadowRoots();
		  }
		}
		class StylesheetManager {
		  constructor(options) {
		    this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
		    this.styleMirror = new StyleSheetMirror();
		    this.mutationCb = options.mutationCb;
		    this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
		  }
		  attachLinkElement(linkEl, childSn) {
		    if ("_cssText" in childSn.attributes)
		      this.mutationCb({
		        adds: [],
		        removes: [],
		        texts: [],
		        attributes: [
		          {
		            id: childSn.id,
		            attributes: childSn.attributes
		          }
		        ]
		      });
		    this.trackLinkElement(linkEl);
		  }
		  trackLinkElement(linkEl) {
		    if (this.trackedLinkElements.has(linkEl)) return;
		    this.trackedLinkElements.add(linkEl);
		    this.trackStylesheetInLinkElement(linkEl);
		  }
		  adoptStyleSheets(sheets, hostId) {
		    if (sheets.length === 0) return;
		    const adoptedStyleSheetData = {
		      id: hostId,
		      styleIds: []
		    };
		    const styles = [];
		    for (const sheet of sheets) {
		      let styleId;
		      if (!this.styleMirror.has(sheet)) {
		        styleId = this.styleMirror.add(sheet);
		        styles.push({
		          styleId,
		          rules: Array.from(sheet.rules || CSSRule, (r2, index) => ({
		            rule: stringifyRule(r2),
		            index
		          }))
		        });
		      } else styleId = this.styleMirror.getId(sheet);
		      adoptedStyleSheetData.styleIds.push(styleId);
		    }
		    if (styles.length > 0) adoptedStyleSheetData.styles = styles;
		    this.adoptedStyleSheetCb(adoptedStyleSheetData);
		  }
		  reset() {
		    this.styleMirror.reset();
		    this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
		  }
		  // TODO: take snapshot on stylesheet reload by applying event listener
		  trackStylesheetInLinkElement(_linkEl) {
		  }
		}
		class ProcessedNodeManager {
		  constructor() {
		    this.nodeMap = /* @__PURE__ */ new WeakMap();
		    this.active = false;
		  }
		  inOtherBuffer(node, thisBuffer) {
		    const buffers = this.nodeMap.get(node);
		    return buffers && Array.from(buffers).some((buffer) => buffer !== thisBuffer);
		  }
		  add(node, buffer) {
		    if (!this.active) {
		      this.active = true;
		      onRequestAnimationFrame(() => {
		        this.nodeMap = /* @__PURE__ */ new WeakMap();
		        this.active = false;
		      });
		    }
		    this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
		  }
		  destroy() {
		  }
		}
		let wrappedEmit;
		let _takeFullSnapshot;
		try {
		  if (Array.from([1], (x) => x * 2)[0] !== 2) {
		    const cleanFrame = document.createElement("iframe");
		    document.body.appendChild(cleanFrame);
		    Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
		    document.body.removeChild(cleanFrame);
		  }
		} catch (err) {
		  console.debug("Unable to override Array.from", err);
		}
		const mirror = createMirror();
		function record(options = {}) {
		  const {
		    emit,
		    checkoutEveryNms,
		    checkoutEveryNth,
		    blockClass = "rr-block",
		    blockSelector = null,
		    unblockSelector = null,
		    ignoreClass = "rr-ignore",
		    ignoreSelector = null,
		    maskAllText = false,
		    maskTextClass = "rr-mask",
		    unmaskTextClass = null,
		    maskTextSelector = null,
		    unmaskTextSelector = null,
		    inlineStylesheet = true,
		    maskAllInputs,
		    maskInputOptions: _maskInputOptions,
		    slimDOMOptions: _slimDOMOptions,
		    maskAttributeFn,
		    maskInputFn,
		    maskTextFn,
		    maxCanvasSize = null,
		    packFn,
		    sampling = {},
		    dataURLOptions = {},
		    mousemoveWait,
		    recordDOM = true,
		    recordCanvas = false,
		    recordCrossOriginIframes = false,
		    recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load",
		    userTriggeredOnInput = false,
		    collectFonts = false,
		    inlineImages = false,
		    plugins,
		    keepIframeSrcFn = () => false,
		    ignoreCSSAttributes = /* @__PURE__ */ new Set([]),
		    errorHandler,
		    onMutation,
		    getCanvasManager
		  } = options;
		  registerErrorHandler(errorHandler);
		  const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
		  let passEmitsToParent = false;
		  if (!inEmittingFrame) {
		    try {
		      if (window.parent.document) {
		        passEmitsToParent = false;
		      }
		    } catch (e2) {
		      passEmitsToParent = true;
		    }
		  }
		  if (inEmittingFrame && !emit) {
		    throw new Error("emit function is required");
		  }
		  if (!inEmittingFrame && !passEmitsToParent) {
		    return () => {
		    };
		  }
		  if (mousemoveWait !== void 0 && sampling.mousemove === void 0) {
		    sampling.mousemove = mousemoveWait;
		  }
		  mirror.reset();
		  const maskInputOptions = maskAllInputs === true ? {
		    color: true,
		    date: true,
		    "datetime-local": true,
		    email: true,
		    month: true,
		    number: true,
		    range: true,
		    search: true,
		    tel: true,
		    text: true,
		    time: true,
		    url: true,
		    week: true,
		    textarea: true,
		    select: true,
		    radio: true,
		    checkbox: true
		  } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
		  const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
		    script: true,
		    comment: true,
		    headFavicon: true,
		    headWhitespace: true,
		    headMetaSocial: true,
		    headMetaRobots: true,
		    headMetaHttpEquiv: true,
		    headMetaVerification: true,
		    // the following are off for slimDOMOptions === true,
		    // as they destroy some (hidden) info:
		    headMetaAuthorship: _slimDOMOptions === "all",
		    headMetaDescKeywords: _slimDOMOptions === "all"
		  } : _slimDOMOptions ? _slimDOMOptions : {};
		  polyfill();
		  let lastFullSnapshotEvent;
		  let incrementalSnapshotCount = 0;
		  const eventProcessor = (e2) => {
		    for (const plugin of plugins || []) {
		      if (plugin.eventProcessor) {
		        e2 = plugin.eventProcessor(e2);
		      }
		    }
		    if (packFn && // Disable packing events which will be emitted to parent frames.
		    !passEmitsToParent) {
		      e2 = packFn(e2);
		    }
		    return e2;
		  };
		  wrappedEmit = (r2, isCheckout) => {
		    const e2 = r2;
		    e2.timestamp = nowTimestamp();
		    if (mutationBuffers[0]?.isFrozen() && e2.type !== EventType.FullSnapshot && !(e2.type === EventType.IncrementalSnapshot && e2.data.source === IncrementalSource.Mutation)) {
		      mutationBuffers.forEach((buf) => buf.unfreeze());
		    }
		    if (inEmittingFrame) {
		      emit?.(eventProcessor(e2), isCheckout);
		    } else if (passEmitsToParent) {
		      const message = {
		        type: "rrweb",
		        event: eventProcessor(e2),
		        origin: window.location.origin,
		        isCheckout
		      };
		      window.parent.postMessage(message, "*");
		    }
		    if (e2.type === EventType.FullSnapshot) {
		      lastFullSnapshotEvent = e2;
		      incrementalSnapshotCount = 0;
		    } else if (e2.type === EventType.IncrementalSnapshot) {
		      if (e2.data.source === IncrementalSource.Mutation && e2.data.isAttachIframe) {
		        return;
		      }
		      incrementalSnapshotCount++;
		      const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
		      const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
		      if (exceedCount || exceedTime) {
		        takeFullSnapshot2(true);
		      }
		    }
		  };
		  const wrappedMutationEmit = (m) => {
		    wrappedEmit({
		      type: EventType.IncrementalSnapshot,
		      data: {
		        source: IncrementalSource.Mutation,
		        ...m
		      }
		    });
		  };
		  const wrappedScrollEmit = (p) => wrappedEmit({
		    type: EventType.IncrementalSnapshot,
		    data: {
		      source: IncrementalSource.Scroll,
		      ...p
		    }
		  });
		  const wrappedCanvasMutationEmit = (p) => wrappedEmit({
		    type: EventType.IncrementalSnapshot,
		    data: {
		      source: IncrementalSource.CanvasMutation,
		      ...p
		    }
		  });
		  const wrappedAdoptedStyleSheetEmit = (a2) => wrappedEmit({
		    type: EventType.IncrementalSnapshot,
		    data: {
		      source: IncrementalSource.AdoptedStyleSheet,
		      ...a2
		    }
		  });
		  const stylesheetManager = new StylesheetManager({
		    mutationCb: wrappedMutationEmit,
		    adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
		  });
		  const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new IframeManagerNoop() : new IframeManager({
		    mirror,
		    mutationCb: wrappedMutationEmit,
		    stylesheetManager,
		    recordCrossOriginIframes,
		    wrappedEmit
		  });
		  for (const plugin of plugins || []) {
		    if (plugin.getMirror)
		      plugin.getMirror({
		        nodeMirror: mirror,
		        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
		        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
		      });
		  }
		  const processedNodeManager = new ProcessedNodeManager();
		  const canvasManager = _getCanvasManager(
		    getCanvasManager,
		    {
		      mirror,
		      win: window,
		      mutationCb: (p) => wrappedEmit({
		        type: EventType.IncrementalSnapshot,
		        data: {
		          source: IncrementalSource.CanvasMutation,
		          ...p
		        }
		      }),
		      recordCanvas,
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      maxCanvasSize,
		      sampling: sampling["canvas"],
		      dataURLOptions,
		      errorHandler
		    }
		  );
		  const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new ShadowDomManagerNoop() : new ShadowDomManager({
		    mutationCb: wrappedMutationEmit,
		    scrollCb: wrappedScrollEmit,
		    bypassOptions: {
		      onMutation,
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      maskAllText,
		      maskTextClass,
		      unmaskTextClass,
		      maskTextSelector,
		      unmaskTextSelector,
		      inlineStylesheet,
		      maskInputOptions,
		      dataURLOptions,
		      maskAttributeFn,
		      maskTextFn,
		      maskInputFn,
		      recordCanvas,
		      inlineImages,
		      sampling,
		      slimDOMOptions,
		      iframeManager,
		      stylesheetManager,
		      canvasManager,
		      keepIframeSrcFn,
		      processedNodeManager,
		      ignoreCSSAttributes
		    },
		    mirror
		  });
		  const takeFullSnapshot2 = (isCheckout = false) => {
		    if (!recordDOM) {
		      return;
		    }
		    wrappedEmit(
		      {
		        type: EventType.Meta,
		        data: {
		          href: window.location.href,
		          width: getWindowWidth(),
		          height: getWindowHeight()
		        }
		      },
		      isCheckout
		    );
		    stylesheetManager.reset();
		    shadowDomManager.init();
		    mutationBuffers.forEach((buf) => buf.lock());
		    const node = snapshot(document, {
		      mirror,
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      maskAllText,
		      maskTextClass,
		      unmaskTextClass,
		      maskTextSelector,
		      unmaskTextSelector,
		      inlineStylesheet,
		      maskAllInputs: maskInputOptions,
		      maskAttributeFn,
		      maskInputFn,
		      maskTextFn,
		      slimDOM: slimDOMOptions,
		      dataURLOptions,
		      recordCanvas,
		      inlineImages,
		      onSerialize: (n2) => {
		        if (isSerializedIframe(n2, mirror)) {
		          iframeManager.addIframe(n2);
		        }
		        if (isSerializedStylesheet(n2, mirror)) {
		          stylesheetManager.trackLinkElement(n2);
		        }
		        if (hasShadowRoot(n2)) {
		          shadowDomManager.addShadowRoot(n2.shadowRoot, document);
		        }
		      },
		      onIframeLoad: (iframe, childSn) => {
		        iframeManager.attachIframe(iframe, childSn);
		        const contentWindow = getIFrameContentWindow(iframe);
		        if (contentWindow) {
		          canvasManager.addWindow(contentWindow);
		        }
		        shadowDomManager.observeAttachShadow(iframe);
		      },
		      onStylesheetLoad: (linkEl, childSn) => {
		        stylesheetManager.attachLinkElement(linkEl, childSn);
		      },
		      onBlockedImageLoad: (_imageEl, serializedNode, { width, height }) => {
		        wrappedMutationEmit({
		          adds: [],
		          removes: [],
		          texts: [],
		          attributes: [
		            {
		              id: serializedNode.id,
		              attributes: {
		                style: {
		                  width: `${width}px`,
		                  height: `${height}px`
		                }
		              }
		            }
		          ]
		        });
		      },
		      keepIframeSrcFn,
		      ignoreCSSAttributes
		    });
		    if (!node) {
		      return console.warn("Failed to snapshot the document");
		    }
		    wrappedEmit({
		      type: EventType.FullSnapshot,
		      data: {
		        node,
		        initialOffset: getWindowScroll(window)
		      }
		    });
		    mutationBuffers.forEach((buf) => buf.unlock());
		    if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0)
		      stylesheetManager.adoptStyleSheets(
		        document.adoptedStyleSheets,
		        mirror.getId(document)
		      );
		  };
		  _takeFullSnapshot = takeFullSnapshot2;
		  try {
		    const handlers = [];
		    const observe = (doc) => {
		      return callbackWrapper(initObservers)(
		        {
		          onMutation,
		          mutationCb: wrappedMutationEmit,
		          mousemoveCb: (positions, source) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source,
		              positions
		            }
		          }),
		          mouseInteractionCb: (d) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source: IncrementalSource.MouseInteraction,
		              ...d
		            }
		          }),
		          scrollCb: wrappedScrollEmit,
		          viewportResizeCb: (d) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source: IncrementalSource.ViewportResize,
		              ...d
		            }
		          }),
		          inputCb: (v2) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source: IncrementalSource.Input,
		              ...v2
		            }
		          }),
		          mediaInteractionCb: (p) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source: IncrementalSource.MediaInteraction,
		              ...p
		            }
		          }),
		          styleSheetRuleCb: (r2) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source: IncrementalSource.StyleSheetRule,
		              ...r2
		            }
		          }),
		          styleDeclarationCb: (r2) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source: IncrementalSource.StyleDeclaration,
		              ...r2
		            }
		          }),
		          canvasMutationCb: wrappedCanvasMutationEmit,
		          fontCb: (p) => wrappedEmit({
		            type: EventType.IncrementalSnapshot,
		            data: {
		              source: IncrementalSource.Font,
		              ...p
		            }
		          }),
		          selectionCb: (p) => {
		            wrappedEmit({
		              type: EventType.IncrementalSnapshot,
		              data: {
		                source: IncrementalSource.Selection,
		                ...p
		              }
		            });
		          },
		          customElementCb: (c2) => {
		            wrappedEmit({
		              type: EventType.IncrementalSnapshot,
		              data: {
		                source: IncrementalSource.CustomElement,
		                ...c2
		              }
		            });
		          },
		          blockClass,
		          ignoreClass,
		          ignoreSelector,
		          maskAllText,
		          maskTextClass,
		          unmaskTextClass,
		          maskTextSelector,
		          unmaskTextSelector,
		          maskInputOptions,
		          inlineStylesheet,
		          sampling,
		          recordDOM,
		          recordCanvas,
		          inlineImages,
		          userTriggeredOnInput,
		          collectFonts,
		          doc,
		          maskAttributeFn,
		          maskInputFn,
		          maskTextFn,
		          keepIframeSrcFn,
		          blockSelector,
		          unblockSelector,
		          slimDOMOptions,
		          dataURLOptions,
		          mirror,
		          iframeManager,
		          stylesheetManager,
		          shadowDomManager,
		          processedNodeManager,
		          canvasManager,
		          ignoreCSSAttributes,
		          plugins: plugins?.filter((p) => p.observer)?.map((p) => ({
		            observer: p.observer,
		            options: p.options,
		            callback: (payload) => wrappedEmit({
		              type: EventType.Plugin,
		              data: {
		                plugin: p.name,
		                payload
		              }
		            })
		          })) || []
		        },
		        {}
		      );
		    };
		    iframeManager.addLoadListener((iframeEl) => {
		      try {
		        handlers.push(observe(iframeEl.contentDocument));
		      } catch (error) {
		        console.warn(error);
		      }
		    });
		    const init = () => {
		      takeFullSnapshot2();
		      handlers.push(observe(document));
		    };
		    if (document.readyState === "interactive" || document.readyState === "complete") {
		      init();
		    } else {
		      handlers.push(
		        on("DOMContentLoaded", () => {
		          wrappedEmit({
		            type: EventType.DomContentLoaded,
		            data: {}
		          });
		          if (recordAfter === "DOMContentLoaded") init();
		        })
		      );
		      handlers.push(
		        on(
		          "load",
		          () => {
		            wrappedEmit({
		              type: EventType.Load,
		              data: {}
		            });
		            if (recordAfter === "load") init();
		          },
		          window
		        )
		      );
		    }
		    return () => {
		      handlers.forEach((h) => h());
		      processedNodeManager.destroy();
		      _takeFullSnapshot = void 0;
		      unregisterErrorHandler();
		    };
		  } catch (error) {
		    console.warn(error);
		  }
		}
		function takeFullSnapshot(isCheckout) {
		  if (!_takeFullSnapshot) {
		    throw new Error("please take full snapshot after start recording");
		  }
		  _takeFullSnapshot(isCheckout);
		}
		record.mirror = mirror;
		record.takeFullSnapshot = takeFullSnapshot;
		function _getCanvasManager(getCanvasManagerFn, options) {
		  try {
		    return getCanvasManagerFn ? getCanvasManagerFn(options) : new CanvasManagerNoop();
		  } catch {
		    console.warn("Unable to initialize CanvasManager");
		    return new CanvasManagerNoop();
		  }
		}
		var n;
		!(function(t2) {
		  t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
		})(n || (n = {}));

		const ReplayEventTypeIncrementalSnapshot = 3;
		const ReplayEventTypeCustom = 5;

		function timestampToMs(timestamp) {
		  const isMs = timestamp > 9999999999;
		  return isMs ? timestamp : timestamp * 1e3;
		}
		function timestampToS(timestamp) {
		  const isMs = timestamp > 9999999999;
		  return isMs ? timestamp / 1e3 : timestamp;
		}

		function addBreadcrumbEvent(replay, breadcrumb) {
		  if (breadcrumb.category === "sentry.transaction") {
		    return;
		  }
		  if (["ui.click", "ui.input"].includes(breadcrumb.category)) {
		    replay.triggerUserActivity();
		  } else {
		    replay.checkAndHandleExpiredSession();
		  }
		  replay.addUpdate(() => {
		    replay.throttledAddEvent({
		      type: EventType.Custom,
		      // TODO: We were converting from ms to seconds for breadcrumbs, spans,
		      // but maybe we should just keep them as milliseconds
		      timestamp: (breadcrumb.timestamp || 0) * 1e3,
		      data: {
		        tag: "breadcrumb",
		        // normalize to max. 10 depth and 1_000 properties per object
		        payload: core.normalize(breadcrumb, 10, 1e3)
		      }
		    });
		    return breadcrumb.category === "console";
		  });
		}

		const INTERACTIVE_SELECTOR = "button,a";
		function getClosestInteractive(element) {
		  const closestInteractive = element.closest(INTERACTIVE_SELECTOR);
		  return closestInteractive || element;
		}
		function getClickTargetNode(event) {
		  const target = getTargetNode(event);
		  if (!target || !(target instanceof Element)) {
		    return target;
		  }
		  return getClosestInteractive(target);
		}
		function getTargetNode(event) {
		  if (isEventWithTarget(event)) {
		    return event.target;
		  }
		  return event;
		}
		function isEventWithTarget(event) {
		  return typeof event === "object" && !!event && "target" in event;
		}

		let handlers;
		function onWindowOpen(cb) {
		  if (!handlers) {
		    handlers = [];
		    monkeyPatchWindowOpen();
		  }
		  handlers.push(cb);
		  return () => {
		    const pos = handlers ? handlers.indexOf(cb) : -1;
		    if (pos > -1) {
		      handlers.splice(pos, 1);
		    }
		  };
		}
		function monkeyPatchWindowOpen() {
		  core.fill(WINDOW, "open", function(originalWindowOpen) {
		    return function(...args) {
		      if (handlers) {
		        try {
		          handlers.forEach((handler) => handler());
		        } catch {
		        }
		      }
		      return originalWindowOpen.apply(WINDOW, args);
		    };
		  });
		}

		const IncrementalMutationSources = /* @__PURE__ */ new Set([
		  IncrementalSource.Mutation,
		  IncrementalSource.StyleSheetRule,
		  IncrementalSource.StyleDeclaration,
		  IncrementalSource.AdoptedStyleSheet,
		  IncrementalSource.CanvasMutation,
		  IncrementalSource.Selection,
		  IncrementalSource.MediaInteraction
		]);
		function handleClick(clickDetector, clickBreadcrumb, node) {
		  clickDetector.handleClick(clickBreadcrumb, node);
		}
		class ClickDetector {
		  constructor(replay, slowClickConfig, _addBreadcrumbEvent = addBreadcrumbEvent) {
		    this._lastMutation = 0;
		    this._lastScroll = 0;
		    this._clicks = [];
		    this._timeout = slowClickConfig.timeout / 1e3;
		    this._threshold = slowClickConfig.threshold / 1e3;
		    this._scrollTimeout = slowClickConfig.scrollTimeout / 1e3;
		    this._replay = replay;
		    this._ignoreSelector = slowClickConfig.ignoreSelector;
		    this._addBreadcrumbEvent = _addBreadcrumbEvent;
		  }
		  /** Register click detection handlers on mutation or scroll. */
		  addListeners() {
		    const cleanupWindowOpen = onWindowOpen(() => {
		      this._lastMutation = nowInSeconds();
		    });
		    this._teardown = () => {
		      cleanupWindowOpen();
		      this._clicks = [];
		      this._lastMutation = 0;
		      this._lastScroll = 0;
		    };
		  }
		  /** Clean up listeners. */
		  removeListeners() {
		    if (this._teardown) {
		      this._teardown();
		    }
		    if (this._checkClickTimeout) {
		      clearTimeout(this._checkClickTimeout);
		    }
		  }
		  /** @inheritDoc */
		  handleClick(breadcrumb, node) {
		    if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) {
		      return;
		    }
		    const newClick = {
		      timestamp: timestampToS(breadcrumb.timestamp),
		      clickBreadcrumb: breadcrumb,
		      // Set this to 0 so we know it originates from the click breadcrumb
		      clickCount: 0,
		      node
		    };
		    if (this._clicks.some((click) => click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) {
		      return;
		    }
		    this._clicks.push(newClick);
		    if (this._clicks.length === 1) {
		      this._scheduleCheckClicks();
		    }
		  }
		  /** @inheritDoc */
		  registerMutation(timestamp = Date.now()) {
		    this._lastMutation = timestampToS(timestamp);
		  }
		  /** @inheritDoc */
		  registerScroll(timestamp = Date.now()) {
		    this._lastScroll = timestampToS(timestamp);
		  }
		  /** @inheritDoc */
		  registerClick(element) {
		    const node = getClosestInteractive(element);
		    this._handleMultiClick(node);
		  }
		  /** Count multiple clicks on elements. */
		  _handleMultiClick(node) {
		    this._getClicks(node).forEach((click) => {
		      click.clickCount++;
		    });
		  }
		  /** Get all pending clicks for a given node. */
		  _getClicks(node) {
		    return this._clicks.filter((click) => click.node === node);
		  }
		  /** Check the clicks that happened. */
		  _checkClicks() {
		    const timedOutClicks = [];
		    const now = nowInSeconds();
		    this._clicks.forEach((click) => {
		      if (!click.mutationAfter && this._lastMutation) {
		        click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : void 0;
		      }
		      if (!click.scrollAfter && this._lastScroll) {
		        click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : void 0;
		      }
		      if (click.timestamp + this._timeout <= now) {
		        timedOutClicks.push(click);
		      }
		    });
		    for (const click of timedOutClicks) {
		      const pos = this._clicks.indexOf(click);
		      if (pos > -1) {
		        this._generateBreadcrumbs(click);
		        this._clicks.splice(pos, 1);
		      }
		    }
		    if (this._clicks.length) {
		      this._scheduleCheckClicks();
		    }
		  }
		  /** Generate matching breadcrumb(s) for the click. */
		  _generateBreadcrumbs(click) {
		    const replay = this._replay;
		    const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
		    const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
		    const isSlowClick = !hadScroll && !hadMutation;
		    const { clickCount, clickBreadcrumb } = click;
		    if (isSlowClick) {
		      const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1e3;
		      const endReason = timeAfterClickMs < this._timeout * 1e3 ? "mutation" : "timeout";
		      const breadcrumb = {
		        type: "default",
		        message: clickBreadcrumb.message,
		        timestamp: clickBreadcrumb.timestamp,
		        category: "ui.slowClickDetected",
		        data: {
		          ...clickBreadcrumb.data,
		          url: WINDOW.location.href,
		          route: replay.getCurrentRoute(),
		          timeAfterClickMs,
		          endReason,
		          // If clickCount === 0, it means multiClick was not correctly captured here
		          // - we still want to send 1 in this case
		          clickCount: clickCount || 1
		        }
		      };
		      this._addBreadcrumbEvent(replay, breadcrumb);
		      return;
		    }
		    if (clickCount > 1) {
		      const breadcrumb = {
		        type: "default",
		        message: clickBreadcrumb.message,
		        timestamp: clickBreadcrumb.timestamp,
		        category: "ui.multiClick",
		        data: {
		          ...clickBreadcrumb.data,
		          url: WINDOW.location.href,
		          route: replay.getCurrentRoute(),
		          clickCount,
		          metric: true
		        }
		      };
		      this._addBreadcrumbEvent(replay, breadcrumb);
		    }
		  }
		  /** Schedule to check current clicks. */
		  _scheduleCheckClicks() {
		    if (this._checkClickTimeout) {
		      clearTimeout(this._checkClickTimeout);
		    }
		    this._checkClickTimeout = browserUtils.setTimeout(() => this._checkClicks(), 1e3);
		  }
		}
		const SLOW_CLICK_TAGS = ["A", "BUTTON", "INPUT"];
		function ignoreElement(node, ignoreSelector) {
		  if (!SLOW_CLICK_TAGS.includes(node.tagName)) {
		    return true;
		  }
		  if (node.tagName === "INPUT" && !["submit", "button"].includes(node.getAttribute("type") || "")) {
		    return true;
		  }
		  if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) {
		    return true;
		  }
		  if (ignoreSelector && node.matches(ignoreSelector)) {
		    return true;
		  }
		  return false;
		}
		function isClickBreadcrumb(breadcrumb) {
		  return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
		}
		function nowInSeconds() {
		  return Date.now() / 1e3;
		}
		function updateClickDetectorForRecordingEvent(clickDetector, event) {
		  try {
		    if (!isIncrementalEvent(event)) {
		      return;
		    }
		    const { source } = event.data;
		    if (IncrementalMutationSources.has(source)) {
		      clickDetector.registerMutation(event.timestamp);
		    }
		    if (source === IncrementalSource.Scroll) {
		      clickDetector.registerScroll(event.timestamp);
		    }
		    if (isIncrementalMouseInteraction(event)) {
		      const { type, id } = event.data;
		      const node = record.mirror.getNode(id);
		      if (node instanceof HTMLElement && type === MouseInteractions.Click) {
		        clickDetector.registerClick(node);
		      }
		    }
		  } catch {
		  }
		}
		function isIncrementalEvent(event) {
		  return event.type === ReplayEventTypeIncrementalSnapshot;
		}
		function isIncrementalMouseInteraction(event) {
		  return event.data.source === IncrementalSource.MouseInteraction;
		}

		function createBreadcrumb(breadcrumb) {
		  return {
		    timestamp: Date.now() / 1e3,
		    type: "default",
		    ...breadcrumb
		  };
		}

		var NodeType = /* @__PURE__ */ ((NodeType2) => {
		  NodeType2[NodeType2["Document"] = 0] = "Document";
		  NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
		  NodeType2[NodeType2["Element"] = 2] = "Element";
		  NodeType2[NodeType2["Text"] = 3] = "Text";
		  NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
		  NodeType2[NodeType2["Comment"] = 5] = "Comment";
		  return NodeType2;
		})(NodeType || {});

		const ATTRIBUTES_TO_RECORD = /* @__PURE__ */ new Set([
		  "id",
		  "class",
		  "aria-label",
		  "role",
		  "name",
		  "alt",
		  "title",
		  "data-test-id",
		  "data-testid",
		  "disabled",
		  "aria-disabled",
		  "data-sentry-component"
		]);
		function getAttributesToRecord(attributes) {
		  const obj = {};
		  if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) {
		    attributes["data-sentry-component"] = attributes["data-sentry-element"];
		  }
		  for (const key in attributes) {
		    if (ATTRIBUTES_TO_RECORD.has(key)) {
		      let normalizedKey = key;
		      if (key === "data-testid" || key === "data-test-id") {
		        normalizedKey = "testId";
		      }
		      obj[normalizedKey] = attributes[key];
		    }
		  }
		  return obj;
		}

		const handleDomListener = (replay) => {
		  return (handlerData) => {
		    if (!replay.isEnabled()) {
		      return;
		    }
		    const result = handleDom(handlerData);
		    if (!result) {
		      return;
		    }
		    const isClick = handlerData.name === "click";
		    const event = isClick ? handlerData.event : void 0;
		    if (isClick && replay.clickDetector && event?.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
		      handleClick(
		        replay.clickDetector,
		        result,
		        getClickTargetNode(handlerData.event)
		      );
		    }
		    addBreadcrumbEvent(replay, result);
		  };
		};
		function getBaseDomBreadcrumb(target, message) {
		  const nodeId = record.mirror.getId(target);
		  const node = nodeId && record.mirror.getNode(nodeId);
		  const meta = node && record.mirror.getMeta(node);
		  const element = meta && isElement(meta) ? meta : null;
		  return {
		    message,
		    data: element ? {
		      nodeId,
		      node: {
		        id: nodeId,
		        tagName: element.tagName,
		        textContent: Array.from(element.childNodes).map((node2) => node2.type === NodeType.Text && node2.textContent).filter(Boolean).map((text) => text.trim()).join(""),
		        attributes: getAttributesToRecord(element.attributes)
		      }
		    } : {}
		  };
		}
		function handleDom(handlerData) {
		  const { target, message } = getDomTarget(handlerData);
		  return createBreadcrumb({
		    category: `ui.${handlerData.name}`,
		    ...getBaseDomBreadcrumb(target, message)
		  });
		}
		function getDomTarget(handlerData) {
		  const isClick = handlerData.name === "click";
		  let message;
		  let target = null;
		  try {
		    target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
		    message = browserUtils.htmlTreeAsString(target, { maxStringLength: 200 }) || "<unknown>";
		  } catch {
		    message = "<unknown>";
		  }
		  return { target, message };
		}
		function isElement(node) {
		  return node.type === NodeType.Element;
		}

		function handleKeyboardEvent(replay, event) {
		  if (!replay.isEnabled()) {
		    return;
		  }
		  replay.updateUserActivity();
		  const breadcrumb = getKeyboardBreadcrumb(event);
		  if (!breadcrumb) {
		    return;
		  }
		  addBreadcrumbEvent(replay, breadcrumb);
		}
		function getKeyboardBreadcrumb(event) {
		  const { metaKey, shiftKey, ctrlKey, altKey, key, target } = event;
		  if (!target || isInputElement(target) || !key) {
		    return null;
		  }
		  const hasModifierKey = metaKey || ctrlKey || altKey;
		  const isCharacterKey = key.length === 1;
		  if (!hasModifierKey && isCharacterKey) {
		    return null;
		  }
		  const message = browserUtils.htmlTreeAsString(target, { maxStringLength: 200 }) || "<unknown>";
		  const baseBreadcrumb = getBaseDomBreadcrumb(target, message);
		  return createBreadcrumb({
		    category: "ui.keyDown",
		    message,
		    data: {
		      ...baseBreadcrumb.data,
		      metaKey,
		      shiftKey,
		      ctrlKey,
		      altKey,
		      key
		    }
		  });
		}
		function isInputElement(target) {
		  return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
		}

		const ENTRY_TYPES = {
		  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
		  resource: createResourceEntry,
		  paint: createPaintEntry,
		  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
		  navigation: createNavigationEntry
		};
		function webVitalHandler(getter, replay) {
		  return ({ metric }) => void replay.replayPerformanceEntries.push(getter(metric));
		}
		function createPerformanceEntries(entries) {
		  return entries.map(createPerformanceEntry).filter(Boolean);
		}
		function createPerformanceEntry(entry) {
		  const entryType = ENTRY_TYPES[entry.entryType];
		  if (!entryType) {
		    return null;
		  }
		  return entryType(entry);
		}
		function getAbsoluteTime(time) {
		  return ((core.browserPerformanceTimeOrigin() || WINDOW.performance.timeOrigin) + time) / 1e3;
		}
		function createPaintEntry(entry) {
		  const { duration, entryType, name, startTime } = entry;
		  const start = getAbsoluteTime(startTime);
		  return {
		    type: entryType,
		    name,
		    start,
		    end: start + duration,
		    data: void 0
		  };
		}
		function createNavigationEntry(entry) {
		  const {
		    entryType,
		    name,
		    decodedBodySize,
		    duration,
		    domComplete,
		    encodedBodySize,
		    domContentLoadedEventStart,
		    domContentLoadedEventEnd,
		    domInteractive,
		    loadEventStart,
		    loadEventEnd,
		    redirectCount,
		    startTime,
		    transferSize,
		    type
		  } = entry;
		  if (duration === 0) {
		    return null;
		  }
		  return {
		    type: `${entryType}.${type}`,
		    start: getAbsoluteTime(startTime),
		    end: getAbsoluteTime(domComplete),
		    name,
		    data: {
		      size: transferSize,
		      decodedBodySize,
		      encodedBodySize,
		      duration,
		      domInteractive,
		      domContentLoadedEventStart,
		      domContentLoadedEventEnd,
		      loadEventStart,
		      loadEventEnd,
		      domComplete,
		      redirectCount
		    }
		  };
		}
		function createResourceEntry(entry) {
		  const {
		    entryType,
		    initiatorType,
		    name,
		    responseEnd,
		    startTime,
		    decodedBodySize,
		    encodedBodySize,
		    responseStatus,
		    transferSize
		  } = entry;
		  if (["fetch", "xmlhttprequest"].includes(initiatorType)) {
		    return null;
		  }
		  return {
		    type: `${entryType}.${initiatorType}`,
		    start: getAbsoluteTime(startTime),
		    end: getAbsoluteTime(responseEnd),
		    name,
		    data: {
		      size: transferSize,
		      statusCode: responseStatus,
		      decodedBodySize,
		      encodedBodySize
		    }
		  };
		}
		function getLargestContentfulPaint(metric) {
		  const lastEntry = metric.entries[metric.entries.length - 1];
		  const node = lastEntry?.element ? [lastEntry.element] : void 0;
		  return getWebVital(metric, "largest-contentful-paint", node);
		}
		function isLayoutShift(entry) {
		  return entry.sources !== void 0;
		}
		function getCumulativeLayoutShift(metric) {
		  const layoutShifts = [];
		  const nodes = [];
		  for (const entry of metric.entries) {
		    if (isLayoutShift(entry)) {
		      const nodeIds = [];
		      for (const source of entry.sources) {
		        if (source.node) {
		          nodes.push(source.node);
		          const nodeId = record.mirror.getId(source.node);
		          if (nodeId) {
		            nodeIds.push(nodeId);
		          }
		        }
		      }
		      layoutShifts.push({ value: entry.value, nodeIds: nodeIds.length ? nodeIds : void 0 });
		    }
		  }
		  return getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
		}
		function getInteractionToNextPaint(metric) {
		  const lastEntry = metric.entries[metric.entries.length - 1];
		  const node = lastEntry?.target ? [lastEntry.target] : void 0;
		  return getWebVital(metric, "interaction-to-next-paint", node);
		}
		function getWebVital(metric, name, nodes, attributions) {
		  const value = metric.value;
		  const rating = metric.rating;
		  const end = getAbsoluteTime(value);
		  return {
		    type: "web-vital",
		    name,
		    start: end,
		    end,
		    data: {
		      value,
		      size: value,
		      rating,
		      nodeIds: nodes ? nodes.map((node) => record.mirror.getId(node)) : void 0,
		      attributions
		    }
		  };
		}

		function setupPerformanceObserver(replay) {
		  function addPerformanceEntry(entry) {
		    if (!replay.performanceEntries.includes(entry)) {
		      replay.performanceEntries.push(entry);
		    }
		  }
		  function onEntries({ entries }) {
		    entries.forEach(addPerformanceEntry);
		  }
		  const clearCallbacks = [];
		  ["navigation", "paint", "resource"].forEach((type) => {
		    clearCallbacks.push(browserUtils.addPerformanceInstrumentationHandler(type, onEntries));
		  });
		  clearCallbacks.push(
		    browserUtils.addLcpInstrumentationHandler(webVitalHandler(getLargestContentfulPaint, replay)),
		    browserUtils.addClsInstrumentationHandler(webVitalHandler(getCumulativeLayoutShift, replay)),
		    browserUtils.addInpInstrumentationHandler(webVitalHandler(getInteractionToNextPaint, replay))
		  );
		  return () => {
		    clearCallbacks.forEach((clearCallback) => clearCallback());
		  };
		}

		const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

		const r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;

		function e() {
		  const e2 = new Blob([r]);
		  return URL.createObjectURL(e2);
		}

		const CONSOLE_LEVELS = ["log", "warn", "error"];
		const PREFIX = "[Replay] ";
		function _addBreadcrumb(message, level = "info") {
		  core.addBreadcrumb(
		    {
		      category: "console",
		      data: {
		        logger: "replay"
		      },
		      level,
		      message: `${PREFIX}${message}`
		    },
		    { level }
		  );
		}
		function makeReplayDebugLogger() {
		  let _capture = false;
		  let _trace = false;
		  const _debug = {
		    exception: () => void 0,
		    infoTick: () => void 0,
		    setConfig: (opts) => {
		      _capture = !!opts.captureExceptions;
		      _trace = !!opts.traceInternals;
		    }
		  };
		  if (DEBUG_BUILD) {
		    CONSOLE_LEVELS.forEach((name) => {
		      _debug[name] = (...args) => {
		        core.debug[name](PREFIX, ...args);
		        if (_trace) {
		          _addBreadcrumb(args.join(""), core.severityLevelFromString(name));
		        }
		      };
		    });
		    _debug.exception = (error, ...message) => {
		      if (message.length && _debug.error) {
		        _debug.error(...message);
		      }
		      core.debug.error(PREFIX, error);
		      if (_capture) {
		        core.captureException(error, {
		          mechanism: {
		            handled: true,
		            type: "auto.function.replay.debug"
		          }
		        });
		      } else if (_trace) {
		        _addBreadcrumb(error, "error");
		      }
		    };
		    _debug.infoTick = (...args) => {
		      core.debug.log(PREFIX, ...args);
		      if (_trace) {
		        setTimeout(() => _addBreadcrumb(args[0]), 0);
		      }
		    };
		  } else {
		    CONSOLE_LEVELS.forEach((name) => {
		      _debug[name] = () => void 0;
		    });
		  }
		  return _debug;
		}
		const debug = makeReplayDebugLogger();

		class EventBufferSizeExceededError extends Error {
		  constructor() {
		    super(`Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
		  }
		}

		class EventBufferArray {
		  constructor() {
		    this.events = [];
		    this._totalSize = 0;
		    this.hasCheckout = false;
		    this.waitForCheckout = false;
		  }
		  /** @inheritdoc */
		  get hasEvents() {
		    return this.events.length > 0;
		  }
		  /** @inheritdoc */
		  get type() {
		    return "sync";
		  }
		  /** @inheritdoc */
		  destroy() {
		    this.events = [];
		  }
		  /** @inheritdoc */
		  async addEvent(event) {
		    const eventSize = JSON.stringify(event).length;
		    this._totalSize += eventSize;
		    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
		      throw new EventBufferSizeExceededError();
		    }
		    this.events.push(event);
		  }
		  /** @inheritdoc */
		  finish() {
		    return new Promise((resolve) => {
		      const eventsRet = this.events;
		      this.clear();
		      resolve(JSON.stringify(eventsRet));
		    });
		  }
		  /** @inheritdoc */
		  clear() {
		    this.events = [];
		    this._totalSize = 0;
		    this.hasCheckout = false;
		  }
		  /** @inheritdoc */
		  getEarliestTimestamp() {
		    let ts = null;
		    for (const { timestamp } of this.events) {
		      if (ts === null || timestamp < ts) ts = timestamp;
		    }
		    return ts === null ? ts : timestampToMs(ts);
		  }
		}

		class WorkerHandler {
		  constructor(worker) {
		    this._onMessage = ({ data }) => {
		      const response = data;
		      if (typeof response.id !== "number") {
		        return;
		      }
		      const pending = this._pending.get(response.id);
		      if (!pending || pending.method !== response.method) {
		        return;
		      }
		      this._pending.delete(response.id);
		      if (!response.success) {
		        DEBUG_BUILD && debug.error("Error in compression worker: ", response.response);
		        pending.reject(new Error("Error in compression worker"));
		        return;
		      }
		      pending.resolve(response.response);
		    };
		    this._worker = worker;
		    this._id = 0;
		    this._pending = /* @__PURE__ */ new Map();
		    this._worker.addEventListener("message", this._onMessage);
		  }
		  /**
		   * Ensure the worker is ready (or not).
		   * This will either resolve when the worker is ready, or reject if an error occurred.
		   */
		  ensureReady() {
		    if (this._ensureReadyPromise) {
		      return this._ensureReadyPromise;
		    }
		    this._ensureReadyPromise = new Promise((resolve, reject) => {
		      this._worker.addEventListener(
		        "message",
		        ({ data }) => {
		          if (data.success) {
		            resolve();
		          } else {
		            DEBUG_BUILD && debug.warn("Received worker message with unsuccessful status", data);
		            reject(new Error("Received worker message with unsuccessful status"));
		          }
		        },
		        { once: true }
		      );
		      this._worker.addEventListener(
		        "error",
		        (error) => {
		          DEBUG_BUILD && debug.warn("Failed to load Replay compression worker", error);
		          reject(
		            new Error(
		              `Failed to load Replay compression worker: ${error instanceof ErrorEvent && error.message ? error.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load."}`
		            )
		          );
		        },
		        { once: true }
		      );
		    });
		    return this._ensureReadyPromise;
		  }
		  /**
		   * Destroy the worker.
		   */
		  destroy() {
		    DEBUG_BUILD && debug.log("Destroying compression worker");
		    this._worker.removeEventListener("message", this._onMessage);
		    this._pending.forEach((pending) => pending.reject(new Error("Worker destroyed")));
		    this._pending.clear();
		    this._worker.terminate();
		  }
		  /**
		   * Post message to worker and wait for response before resolving promise.
		   */
		  postMessage(method, arg) {
		    const id = this._getAndIncrementId();
		    return new Promise((resolve, reject) => {
		      this._pending.set(id, {
		        method,
		        resolve,
		        reject
		      });
		      try {
		        this._worker.postMessage({ id, method, arg });
		      } catch (error) {
		        this._pending.delete(id);
		        reject(error);
		      }
		    });
		  }
		  /** Get the current ID and increment it for the next call. */
		  _getAndIncrementId() {
		    return this._id++;
		  }
		}

		class EventBufferCompressionWorker {
		  constructor(worker) {
		    this._worker = new WorkerHandler(worker);
		    this._earliestTimestamp = null;
		    this._totalSize = 0;
		    this.hasCheckout = false;
		    this.waitForCheckout = false;
		  }
		  /** @inheritdoc */
		  get hasEvents() {
		    return !!this._earliestTimestamp;
		  }
		  /** @inheritdoc */
		  get type() {
		    return "worker";
		  }
		  /**
		   * Ensure the worker is ready (or not).
		   * This will either resolve when the worker is ready, or reject if an error occurred.
		   */
		  ensureReady() {
		    return this._worker.ensureReady();
		  }
		  /**
		   * Destroy the event buffer.
		   */
		  destroy() {
		    this._worker.destroy();
		  }
		  /**
		   * Add an event to the event buffer.
		   *
		   * Returns true if event was successfully received and processed by worker.
		   */
		  addEvent(event) {
		    const timestamp = timestampToMs(event.timestamp);
		    if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) {
		      this._earliestTimestamp = timestamp;
		    }
		    const data = JSON.stringify(event);
		    this._totalSize += data.length;
		    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
		      return Promise.reject(new EventBufferSizeExceededError());
		    }
		    return this._sendEventToWorker(data);
		  }
		  /**
		   * Finish the event buffer and return the compressed data.
		   */
		  finish() {
		    return this._finishRequest();
		  }
		  /** @inheritdoc */
		  clear() {
		    this._earliestTimestamp = null;
		    this._totalSize = 0;
		    this.hasCheckout = false;
		    this._worker.postMessage("clear").then(null, (e) => {
		      DEBUG_BUILD && debug.exception(e, 'Sending "clear" message to worker failed', e);
		    });
		  }
		  /** @inheritdoc */
		  getEarliestTimestamp() {
		    return this._earliestTimestamp;
		  }
		  /**
		   * Send the event to the worker.
		   */
		  _sendEventToWorker(data) {
		    return this._worker.postMessage("addEvent", data);
		  }
		  /**
		   * Finish the request and return the compressed data from the worker.
		   */
		  async _finishRequest() {
		    const response = await this._worker.postMessage("finish");
		    this._earliestTimestamp = null;
		    this._totalSize = 0;
		    return response;
		  }
		}

		class EventBufferProxy {
		  constructor(worker) {
		    this._fallback = new EventBufferArray();
		    this._compression = new EventBufferCompressionWorker(worker);
		    this._used = this._fallback;
		    this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
		  }
		  /** @inheritdoc */
		  get waitForCheckout() {
		    return this._used.waitForCheckout;
		  }
		  /** @inheritdoc */
		  get type() {
		    return this._used.type;
		  }
		  /** @inheritDoc */
		  get hasEvents() {
		    return this._used.hasEvents;
		  }
		  /** @inheritdoc */
		  get hasCheckout() {
		    return this._used.hasCheckout;
		  }
		  /** @inheritdoc */
		  set hasCheckout(value) {
		    this._used.hasCheckout = value;
		  }
		  /** @inheritdoc */
		  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
		  set waitForCheckout(value) {
		    this._used.waitForCheckout = value;
		  }
		  /** @inheritDoc */
		  destroy() {
		    this._fallback.destroy();
		    this._compression.destroy();
		  }
		  /** @inheritdoc */
		  clear() {
		    return this._used.clear();
		  }
		  /** @inheritdoc */
		  getEarliestTimestamp() {
		    return this._used.getEarliestTimestamp();
		  }
		  /**
		   * Add an event to the event buffer.
		   *
		   * Returns true if event was successfully added.
		   */
		  addEvent(event) {
		    return this._used.addEvent(event);
		  }
		  /** @inheritDoc */
		  async finish() {
		    await this.ensureWorkerIsLoaded();
		    return this._used.finish();
		  }
		  /** Ensure the worker has loaded. */
		  ensureWorkerIsLoaded() {
		    return this._ensureWorkerIsLoadedPromise;
		  }
		  /** Actually check if the worker has been loaded. */
		  async _ensureWorkerIsLoaded() {
		    try {
		      await this._compression.ensureReady();
		    } catch (error) {
		      DEBUG_BUILD && debug.exception(error, "Failed to load the compression worker, falling back to simple buffer");
		      return;
		    }
		    await this._switchToCompressionWorker();
		  }
		  /** Switch the used buffer to the compression worker. */
		  async _switchToCompressionWorker() {
		    const { events, hasCheckout, waitForCheckout } = this._fallback;
		    const addEventPromises = [];
		    for (const event of events) {
		      addEventPromises.push(this._compression.addEvent(event));
		    }
		    this._compression.hasCheckout = hasCheckout;
		    this._compression.waitForCheckout = waitForCheckout;
		    this._used = this._compression;
		    try {
		      await Promise.all(addEventPromises);
		      this._fallback.clear();
		    } catch (error) {
		      DEBUG_BUILD && debug.exception(error, "Failed to add events when switching buffers.");
		    }
		  }
		}

		function createEventBuffer({
		  useCompression,
		  workerUrl: customWorkerUrl
		}) {
		  if (useCompression && // eslint-disable-next-line no-restricted-globals
		  window.Worker) {
		    const worker = _loadWorker(customWorkerUrl);
		    if (worker) {
		      return worker;
		    }
		  }
		  DEBUG_BUILD && debug.log("Using simple buffer");
		  return new EventBufferArray();
		}
		function _loadWorker(customWorkerUrl) {
		  try {
		    const workerUrl = customWorkerUrl || _getWorkerUrl();
		    if (!workerUrl) {
		      return;
		    }
		    DEBUG_BUILD && debug.log(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
		    const worker = new Worker(workerUrl);
		    return new EventBufferProxy(worker);
		  } catch (error) {
		    DEBUG_BUILD && debug.exception(error, "Failed to create compression worker");
		  }
		}
		function _getWorkerUrl() {
		  if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) {
		    return e();
		  }
		  return "";
		}

		function hasSessionStorage() {
		  try {
		    return "sessionStorage" in WINDOW && !!WINDOW.sessionStorage;
		  } catch {
		    return false;
		  }
		}

		function clearSession(replay) {
		  deleteSession();
		  replay.session = void 0;
		}
		function deleteSession() {
		  if (!hasSessionStorage()) {
		    return;
		  }
		  try {
		    WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
		  } catch {
		  }
		}

		function isSampled(sampleRate) {
		  if (sampleRate === void 0) {
		    return false;
		  }
		  return Math.random() < sampleRate;
		}

		function saveSession(session) {
		  if (!hasSessionStorage()) {
		    return;
		  }
		  try {
		    WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
		  } catch {
		  }
		}

		function makeSession(session) {
		  const now = Date.now();
		  const id = session.id || core.uuid4();
		  const started = session.started || now;
		  const lastActivity = session.lastActivity || now;
		  const segmentId = session.segmentId || 0;
		  const sampled = session.sampled;
		  const previousSessionId = session.previousSessionId;
		  const dirty = session.dirty || false;
		  return {
		    id,
		    started,
		    lastActivity,
		    segmentId,
		    sampled,
		    previousSessionId,
		    dirty
		  };
		}

		function getSessionSampleType(sessionSampleRate, allowBuffering) {
		  return isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
		}
		function createSession({ sessionSampleRate, allowBuffering, stickySession = false }, { previousSessionId } = {}) {
		  const sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
		  const session = makeSession({
		    sampled,
		    previousSessionId
		  });
		  if (stickySession) {
		    saveSession(session);
		  }
		  return session;
		}

		function fetchSession() {
		  if (!hasSessionStorage()) {
		    return null;
		  }
		  try {
		    const sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);
		    if (!sessionStringFromStorage) {
		      return null;
		    }
		    const sessionObj = JSON.parse(sessionStringFromStorage);
		    DEBUG_BUILD && debug.infoTick("Loading existing session");
		    return makeSession(sessionObj);
		  } catch {
		    return null;
		  }
		}

		function isExpired(initialTime, expiry, targetTime = +/* @__PURE__ */ new Date()) {
		  if (initialTime === null || expiry === void 0 || expiry < 0) {
		    return true;
		  }
		  if (expiry === 0) {
		    return false;
		  }
		  return initialTime + expiry <= targetTime;
		}

		function isSessionExpired(session, {
		  maxReplayDuration,
		  sessionIdleExpire,
		  targetTime = Date.now()
		}) {
		  return (
		    // First, check that maximum session length has not been exceeded
		    isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
		    // performed an action within the last `sessionIdleExpire` ms)
		    isExpired(session.lastActivity, sessionIdleExpire, targetTime)
		  );
		}

		function shouldRefreshSession(session, { sessionIdleExpire, maxReplayDuration }) {
		  if (!isSessionExpired(session, { sessionIdleExpire, maxReplayDuration })) {
		    return false;
		  }
		  if (session.sampled === "buffer" && session.segmentId === 0) {
		    return false;
		  }
		  return true;
		}

		function loadOrCreateSession({
		  sessionIdleExpire,
		  maxReplayDuration,
		  previousSessionId
		}, sessionOptions) {
		  const existingSession = sessionOptions.stickySession && fetchSession();
		  if (!existingSession) {
		    DEBUG_BUILD && debug.infoTick("Creating new session");
		    return createSession(sessionOptions, { previousSessionId });
		  }
		  if (!shouldRefreshSession(existingSession, { sessionIdleExpire, maxReplayDuration })) {
		    return existingSession;
		  }
		  DEBUG_BUILD && debug.infoTick("Session in sessionStorage is expired, creating new one...");
		  return createSession(sessionOptions, { previousSessionId: existingSession.id });
		}

		function isCustomEvent(event) {
		  return event.type === EventType.Custom;
		}
		function addEventSync(replay, event, isCheckout) {
		  if (!shouldAddEvent(replay, event)) {
		    return false;
		  }
		  _addEvent(replay, event, isCheckout);
		  return true;
		}
		function addEvent(replay, event, isCheckout) {
		  if (!shouldAddEvent(replay, event)) {
		    return Promise.resolve(null);
		  }
		  return _addEvent(replay, event, isCheckout);
		}
		async function _addEvent(replay, event, isCheckout) {
		  const { eventBuffer } = replay;
		  if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) {
		    return null;
		  }
		  const isBufferMode = replay.recordingMode === "buffer";
		  try {
		    if (isCheckout && isBufferMode) {
		      eventBuffer.clear();
		    }
		    if (isCheckout) {
		      eventBuffer.hasCheckout = true;
		      eventBuffer.waitForCheckout = false;
		    }
		    const replayOptions = replay.getOptions();
		    const eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
		    if (!eventAfterPossibleCallback) {
		      return;
		    }
		    return await eventBuffer.addEvent(eventAfterPossibleCallback);
		  } catch (error) {
		    const isExceeded = error && error instanceof EventBufferSizeExceededError;
		    const reason = isExceeded ? "eventBufferOverflow" : "eventBufferError";
		    const client = core.getClient();
		    if (client) {
		      const dropReason = isExceeded ? "buffer_overflow" : "internal_sdk_error";
		      client.recordDroppedEvent(dropReason, "replay");
		    }
		    if (isExceeded && isBufferMode) {
		      eventBuffer.clear();
		      eventBuffer.waitForCheckout = true;
		      return null;
		    }
		    replay.handleException(error);
		    await replay.stop({ reason });
		  }
		}
		function shouldAddEvent(replay, event) {
		  if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) {
		    return false;
		  }
		  const timestampInMs = timestampToMs(event.timestamp);
		  if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) {
		    return false;
		  }
		  if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
		    DEBUG_BUILD && debug.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
		    return false;
		  }
		  return true;
		}
		function maybeApplyCallback(event, callback) {
		  try {
		    if (typeof callback === "function" && isCustomEvent(event)) {
		      return callback(event);
		    }
		  } catch (error) {
		    DEBUG_BUILD && debug.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
		    return null;
		  }
		  return event;
		}

		function isErrorEvent(event) {
		  return !event.type;
		}
		function isTransactionEvent(event) {
		  return event.type === "transaction";
		}
		function isReplayEvent(event) {
		  return event.type === "replay_event";
		}
		function isFeedbackEvent(event) {
		  return event.type === "feedback";
		}

		function handleAfterSendEvent(replay) {
		  return (event, sendResponse) => {
		    if (!replay.isEnabled() || !isErrorEvent(event) && !isTransactionEvent(event)) {
		      return;
		    }
		    const statusCode = sendResponse.statusCode;
		    if (!statusCode || statusCode < 200 || statusCode >= 300) {
		      return;
		    }
		    if (isTransactionEvent(event)) {
		      handleTransactionEvent(replay, event);
		      return;
		    }
		    handleErrorEvent(replay, event);
		  };
		}
		function handleTransactionEvent(replay, event) {
		  const replayContext = replay.getContext();
		  if (event.contexts?.trace?.trace_id && replayContext.traceIds.size < 100) {
		    replayContext.traceIds.add(event.contexts.trace.trace_id);
		  }
		}
		function handleErrorEvent(replay, event) {
		  const replayContext = replay.getContext();
		  if (event.event_id && replayContext.errorIds.size < 100) {
		    replayContext.errorIds.add(event.event_id);
		  }
		  if (replay.recordingMode !== "buffer" || !event.tags?.replayId) {
		    return;
		  }
		  const { beforeErrorSampling } = replay.getOptions();
		  if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) {
		    return;
		  }
		  browserUtils.setTimeout(async () => {
		    try {
		      await replay.sendBufferedReplayOrFlush();
		    } catch (err) {
		      replay.handleException(err);
		    }
		  });
		}

		function handleBeforeSendEvent(replay) {
		  return (event) => {
		    if (!replay.isEnabled() || !isErrorEvent(event)) {
		      return;
		    }
		    handleHydrationError(replay, event);
		  };
		}
		function handleHydrationError(replay, event) {
		  const exceptionValue = event.exception?.values?.[0]?.value;
		  if (typeof exceptionValue !== "string") {
		    return;
		  }
		  if (
		    // Only matches errors in production builds of react-dom
		    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
		    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
		    exceptionValue.match(
		      /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/
		    ) || // Development builds of react-dom
		    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
		    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
		    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)
		  ) {
		    const breadcrumb = createBreadcrumb({
		      category: "replay.hydrate-error",
		      data: {
		        url: core.getLocationHref()
		      }
		    });
		    addBreadcrumbEvent(replay, breadcrumb);
		  }
		}

		function handleBreadcrumbs(replay) {
		  const client = core.getClient();
		  if (!client) {
		    return;
		  }
		  client.on("beforeAddBreadcrumb", (breadcrumb) => beforeAddBreadcrumb(replay, breadcrumb));
		}
		function beforeAddBreadcrumb(replay, breadcrumb) {
		  if (!replay.isEnabled() || !isBreadcrumbWithCategory(breadcrumb)) {
		    return;
		  }
		  const result = normalizeBreadcrumb(breadcrumb);
		  if (result) {
		    addBreadcrumbEvent(replay, result);
		  }
		}
		function normalizeBreadcrumb(breadcrumb) {
		  if (!isBreadcrumbWithCategory(breadcrumb) || [
		    // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
		    "fetch",
		    "xhr",
		    // These two are breadcrumbs for emitted sentry events, we don't care about them
		    "sentry.event",
		    "sentry.transaction"
		  ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
		  breadcrumb.category.startsWith("ui.")) {
		    return null;
		  }
		  if (breadcrumb.category === "console") {
		    return normalizeConsoleBreadcrumb(breadcrumb);
		  }
		  return createBreadcrumb(breadcrumb);
		}
		function normalizeConsoleBreadcrumb(breadcrumb) {
		  const args = breadcrumb.data?.arguments;
		  if (!Array.isArray(args) || args.length === 0) {
		    return createBreadcrumb(breadcrumb);
		  }
		  let isTruncated = false;
		  const normalizedArgs = args.map((arg) => {
		    if (!arg) {
		      return arg;
		    }
		    if (typeof arg === "string") {
		      if (arg.length > CONSOLE_ARG_MAX_SIZE) {
		        isTruncated = true;
		        return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}\u2026`;
		      }
		      return arg;
		    }
		    if (typeof arg === "object") {
		      try {
		        const normalizedArg = core.normalize(arg, 7);
		        const stringified = JSON.stringify(normalizedArg);
		        if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
		          isTruncated = true;
		          return `${JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE)}\u2026`;
		        }
		        return normalizedArg;
		      } catch {
		      }
		    }
		    return arg;
		  });
		  return createBreadcrumb({
		    ...breadcrumb,
		    data: {
		      ...breadcrumb.data,
		      arguments: normalizedArgs,
		      ...isTruncated ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
		    }
		  });
		}
		function isBreadcrumbWithCategory(breadcrumb) {
		  return !!breadcrumb.category;
		}

		function isRrwebError(event, hint) {
		  if (event.type || !event.exception?.values?.length) {
		    return false;
		  }
		  if (hint.originalException?.__rrweb__) {
		    return true;
		  }
		  return false;
		}

		function resetReplayIdOnDynamicSamplingContext() {
		  const dsc = core.getCurrentScope().getPropagationContext().dsc;
		  if (dsc) {
		    delete dsc.replay_id;
		  }
		  const activeSpan = core.getActiveSpan();
		  if (activeSpan) {
		    const dsc2 = core.getDynamicSamplingContextFromSpan(activeSpan);
		    delete dsc2.replay_id;
		  }
		}
		function setReplayIdOnDynamicSamplingContext(replayId) {
		  const dsc = core.getCurrentScope().getPropagationContext().dsc;
		  if (dsc) {
		    dsc.replay_id = replayId;
		  }
		  const activeSpan = core.getActiveSpan();
		  if (activeSpan) {
		    const dsc2 = core.getDynamicSamplingContextFromSpan(activeSpan);
		    dsc2.replay_id = replayId;
		  }
		}

		function addFeedbackBreadcrumb(replay, event) {
		  replay.triggerUserActivity();
		  replay.addUpdate(() => {
		    if (!event.timestamp) {
		      return true;
		    }
		    replay.throttledAddEvent({
		      type: EventType.Custom,
		      timestamp: event.timestamp * 1e3,
		      data: {
		        tag: "breadcrumb",
		        payload: {
		          timestamp: event.timestamp,
		          type: "default",
		          category: "sentry.feedback",
		          data: {
		            feedbackId: event.event_id
		          }
		        }
		      }
		    });
		    return false;
		  });
		}

		function shouldSampleForBufferEvent(replay, event) {
		  if (replay.recordingMode !== "buffer") {
		    return false;
		  }
		  if (event.message === UNABLE_TO_SEND_REPLAY) {
		    return false;
		  }
		  if (!event.exception || event.type) {
		    return false;
		  }
		  return isSampled(replay.getOptions().errorSampleRate);
		}

		function handleGlobalEventListener(replay) {
		  return Object.assign(
		    (event, hint) => {
		      if (replay.session && shouldRefreshSession(replay.session, {
		        maxReplayDuration: replay.getOptions().maxReplayDuration,
		        sessionIdleExpire: replay.timeouts.sessionIdleExpire
		      })) {
		        resetReplayIdOnDynamicSamplingContext();
		      }
		      if (!replay.isEnabled() || replay.isPaused()) {
		        return event;
		      }
		      if (isReplayEvent(event)) {
		        delete event.breadcrumbs;
		        return event;
		      }
		      if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) {
		        return event;
		      }
		      const isSessionActive = replay.checkAndHandleExpiredSession();
		      if (!isSessionActive) {
		        resetReplayIdOnDynamicSamplingContext();
		        return event;
		      }
		      if (isFeedbackEvent(event)) {
		        replay.flush();
		        event.contexts.feedback.replay_id = replay.getSessionId();
		        addFeedbackBreadcrumb(replay, event);
		        return event;
		      }
		      if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
		        DEBUG_BUILD && debug.log("Ignoring error from rrweb internals", event);
		        return null;
		      }
		      const isErrorEventSampled = shouldSampleForBufferEvent(replay, event);
		      const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
		      if (shouldTagReplayId) {
		        event.tags = { ...event.tags, replayId: replay.getSessionId() };
		      }
		      if (isErrorEventSampled && replay.recordingMode === "buffer" && replay.session?.sampled === "buffer") {
		        const session = replay.session;
		        session.dirty = true;
		        if (replay.getOptions().stickySession) {
		          saveSession(session);
		        }
		      }
		      return event;
		    },
		    { id: "Replay" }
		  );
		}

		function createPerformanceSpans(replay, entries) {
		  return entries.map(({ type, start, end, name, data }) => {
		    const response = replay.throttledAddEvent({
		      type: EventType.Custom,
		      timestamp: start,
		      data: {
		        tag: "performanceSpan",
		        payload: {
		          op: type,
		          description: name,
		          startTimestamp: start,
		          endTimestamp: end,
		          data
		        }
		      }
		    });
		    return typeof response === "string" ? Promise.resolve(null) : response;
		  });
		}

		function handleHistory(handlerData) {
		  const { from, to } = handlerData;
		  const now = Date.now() / 1e3;
		  return {
		    type: "navigation.push",
		    start: now,
		    end: now,
		    name: to,
		    data: {
		      previous: from
		    }
		  };
		}
		function handleHistorySpanListener(replay) {
		  return (handlerData) => {
		    if (!replay.isEnabled()) {
		      return;
		    }
		    const result = handleHistory(handlerData);
		    if (result === null) {
		      return;
		    }
		    replay.getContext().urls.push(result.name);
		    replay.triggerUserActivity();
		    replay.addUpdate(() => {
		      createPerformanceSpans(replay, [result]);
		      return false;
		    });
		  };
		}

		function shouldFilterRequest(replay, url) {
		  if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) {
		    return false;
		  }
		  return core.isSentryRequestUrl(url, core.getClient());
		}

		function addNetworkBreadcrumb(replay, result) {
		  if (!replay.isEnabled()) {
		    return;
		  }
		  if (result === null) {
		    return;
		  }
		  if (shouldFilterRequest(replay, result.name)) {
		    return;
		  }
		  replay.addUpdate(() => {
		    createPerformanceSpans(replay, [result]);
		    return true;
		  });
		}

		function getBodySize(body) {
		  if (!body) {
		    return void 0;
		  }
		  const textEncoder = new TextEncoder();
		  try {
		    if (typeof body === "string") {
		      return textEncoder.encode(body).length;
		    }
		    if (body instanceof URLSearchParams) {
		      return textEncoder.encode(body.toString()).length;
		    }
		    if (body instanceof FormData) {
		      const formDataStr = browserUtils.serializeFormData(body);
		      return textEncoder.encode(formDataStr).length;
		    }
		    if (body instanceof Blob) {
		      return body.size;
		    }
		    if (body instanceof ArrayBuffer) {
		      return body.byteLength;
		    }
		  } catch {
		  }
		  return void 0;
		}
		function parseContentLengthHeader(header) {
		  if (!header) {
		    return void 0;
		  }
		  const size = parseInt(header, 10);
		  return isNaN(size) ? void 0 : size;
		}
		function mergeWarning(info, warning) {
		  if (!info) {
		    return {
		      headers: {},
		      size: void 0,
		      _meta: {
		        warnings: [warning]
		      }
		    };
		  }
		  const newMeta = { ...info._meta };
		  const existingWarnings = newMeta.warnings || [];
		  newMeta.warnings = [...existingWarnings, warning];
		  info._meta = newMeta;
		  return info;
		}
		function makeNetworkReplayBreadcrumb(type, data) {
		  if (!data) {
		    return null;
		  }
		  const { startTimestamp, endTimestamp, url, method, statusCode, request, response } = data;
		  const result = {
		    type,
		    start: startTimestamp / 1e3,
		    end: endTimestamp / 1e3,
		    name: url,
		    data: {
		      method,
		      statusCode,
		      request,
		      response
		    }
		  };
		  return result;
		}
		function buildSkippedNetworkRequestOrResponse(bodySize) {
		  return {
		    headers: {},
		    size: bodySize,
		    _meta: {
		      warnings: ["URL_SKIPPED"]
		    }
		  };
		}
		function buildNetworkRequestOrResponse(headers, bodySize, body) {
		  if (!bodySize && Object.keys(headers).length === 0) {
		    return void 0;
		  }
		  if (!bodySize) {
		    return {
		      headers
		    };
		  }
		  if (!body) {
		    return {
		      headers,
		      size: bodySize
		    };
		  }
		  const info = {
		    headers,
		    size: bodySize
		  };
		  const { body: normalizedBody, warnings } = normalizeNetworkBody(body);
		  info.body = normalizedBody;
		  if (warnings?.length) {
		    info._meta = {
		      warnings
		    };
		  }
		  return info;
		}
		function getAllowedHeaders(headers, allowedHeaders) {
		  return Object.entries(headers).reduce((filteredHeaders, [key, value]) => {
		    const normalizedKey = key.toLowerCase();
		    if (allowedHeaders.includes(normalizedKey) && headers[key]) {
		      filteredHeaders[normalizedKey] = value;
		    }
		    return filteredHeaders;
		  }, {});
		}
		function normalizeNetworkBody(body) {
		  if (!body || typeof body !== "string") {
		    return {
		      body
		    };
		  }
		  const exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
		  const isProbablyJson = _strIsProbablyJson(body);
		  if (exceedsSizeLimit) {
		    const truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);
		    if (isProbablyJson) {
		      return {
		        body: truncatedBody,
		        warnings: ["MAYBE_JSON_TRUNCATED"]
		      };
		    }
		    return {
		      body: `${truncatedBody}\u2026`,
		      warnings: ["TEXT_TRUNCATED"]
		    };
		  }
		  if (isProbablyJson) {
		    try {
		      const jsonBody = JSON.parse(body);
		      return {
		        body: jsonBody
		      };
		    } catch {
		    }
		  }
		  return {
		    body
		  };
		}
		function _strIsProbablyJson(str) {
		  const first = str[0];
		  const last = str[str.length - 1];
		  return first === "[" && last === "]" || first === "{" && last === "}";
		}
		function urlMatches(url, urls) {
		  const fullUrl = getFullUrl(url);
		  return core.stringMatchesSomePattern(fullUrl, urls);
		}
		function getFullUrl(url, baseURI = WINDOW.document.baseURI) {
		  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith(WINDOW.location.origin)) {
		    return url;
		  }
		  const fixedUrl = new URL(url, baseURI);
		  if (fixedUrl.origin !== new URL(baseURI).origin) {
		    return url;
		  }
		  const fullUrl = fixedUrl.href;
		  if (!url.endsWith("/") && fullUrl.endsWith("/")) {
		    return fullUrl.slice(0, -1);
		  }
		  return fullUrl;
		}

		async function captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
		  try {
		    const data = await _prepareFetchData(breadcrumb, hint, options);
		    const result = makeNetworkReplayBreadcrumb("resource.fetch", data);
		    addNetworkBreadcrumb(options.replay, result);
		  } catch (error) {
		    DEBUG_BUILD && debug.exception(error, "Failed to capture fetch breadcrumb");
		  }
		}
		function enrichFetchBreadcrumb(breadcrumb, hint) {
		  const { input, response } = hint;
		  const body = input ? browserUtils.getFetchRequestArgBody(input) : void 0;
		  const reqSize = getBodySize(body);
		  const resSize = response ? parseContentLengthHeader(response.headers.get("content-length")) : void 0;
		  if (reqSize !== void 0) {
		    breadcrumb.data.request_body_size = reqSize;
		  }
		  if (resSize !== void 0) {
		    breadcrumb.data.response_body_size = resSize;
		  }
		}
		async function _prepareFetchData(breadcrumb, hint, options) {
		  const now = Date.now();
		  const { startTimestamp = now, endTimestamp = now } = hint;
		  const {
		    url,
		    method,
		    status_code: statusCode = 0,
		    request_body_size: requestBodySize,
		    response_body_size: responseBodySize
		  } = breadcrumb.data;
		  const captureDetails = urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);
		  const request = captureDetails ? _getRequestInfo(options, hint.input, requestBodySize) : buildSkippedNetworkRequestOrResponse(requestBodySize);
		  const response = await _getResponseInfo(captureDetails, options, hint.response, responseBodySize);
		  return {
		    startTimestamp,
		    endTimestamp,
		    url,
		    method,
		    statusCode,
		    request,
		    response
		  };
		}
		function _getRequestInfo({ networkCaptureBodies, networkRequestHeaders }, input, requestBodySize) {
		  const headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};
		  if (!networkCaptureBodies) {
		    return buildNetworkRequestOrResponse(headers, requestBodySize, void 0);
		  }
		  const requestBody = browserUtils.getFetchRequestArgBody(input);
		  const [bodyStr, warning] = browserUtils.getBodyString(requestBody, debug);
		  const data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
		  if (warning) {
		    return mergeWarning(data, warning);
		  }
		  return data;
		}
		async function _getResponseInfo(captureDetails, {
		  networkCaptureBodies,
		  networkResponseHeaders
		}, response, responseBodySize) {
		  if (!captureDetails && responseBodySize !== void 0) {
		    return buildSkippedNetworkRequestOrResponse(responseBodySize);
		  }
		  const headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};
		  if (!response || !networkCaptureBodies && responseBodySize !== void 0) {
		    return buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
		  }
		  const [bodyText, warning] = await _parseFetchResponseBody(response);
		  const result = getResponseData(bodyText, {
		    networkCaptureBodies,
		    responseBodySize,
		    captureDetails,
		    headers
		  });
		  if (warning) {
		    return mergeWarning(result, warning);
		  }
		  return result;
		}
		function getResponseData(bodyText, {
		  networkCaptureBodies,
		  responseBodySize,
		  captureDetails,
		  headers
		}) {
		  try {
		    const size = bodyText?.length && responseBodySize === void 0 ? getBodySize(bodyText) : responseBodySize;
		    if (!captureDetails) {
		      return buildSkippedNetworkRequestOrResponse(size);
		    }
		    if (networkCaptureBodies) {
		      return buildNetworkRequestOrResponse(headers, size, bodyText);
		    }
		    return buildNetworkRequestOrResponse(headers, size, void 0);
		  } catch (error) {
		    DEBUG_BUILD && debug.exception(error, "Failed to serialize response body");
		    return buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
		  }
		}
		async function _parseFetchResponseBody(response) {
		  const res = _tryCloneResponse(response);
		  if (!res) {
		    return [void 0, "BODY_PARSE_ERROR"];
		  }
		  try {
		    const text = await _tryGetResponseText(res);
		    return [text];
		  } catch (error) {
		    if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
		      DEBUG_BUILD && debug.warn("Parsing text body from response timed out");
		      return [void 0, "BODY_PARSE_TIMEOUT"];
		    }
		    DEBUG_BUILD && debug.exception(error, "Failed to get text body from response");
		    return [void 0, "BODY_PARSE_ERROR"];
		  }
		}
		function getAllHeaders(headers, allowedHeaders) {
		  const allHeaders = {};
		  allowedHeaders.forEach((header) => {
		    if (headers.get(header)) {
		      allHeaders[header] = headers.get(header);
		    }
		  });
		  return allHeaders;
		}
		function getRequestHeaders(fetchArgs, allowedHeaders) {
		  if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") {
		    return getHeadersFromOptions(fetchArgs[0], allowedHeaders);
		  }
		  if (fetchArgs.length === 2) {
		    return getHeadersFromOptions(fetchArgs[1], allowedHeaders);
		  }
		  return {};
		}
		function getHeadersFromOptions(input, allowedHeaders) {
		  if (!input) {
		    return {};
		  }
		  const headers = input.headers;
		  if (!headers) {
		    return {};
		  }
		  if (headers instanceof Headers) {
		    return getAllHeaders(headers, allowedHeaders);
		  }
		  if (Array.isArray(headers)) {
		    return {};
		  }
		  return getAllowedHeaders(headers, allowedHeaders);
		}
		function _tryCloneResponse(response) {
		  try {
		    return response.clone();
		  } catch (error) {
		    DEBUG_BUILD && debug.exception(error, "Failed to clone response body");
		  }
		}
		function _tryGetResponseText(response) {
		  return new Promise((resolve, reject) => {
		    const timeout = browserUtils.setTimeout(() => reject(new Error("Timeout while trying to read response body")), 500);
		    _getResponseText(response).then(
		      (txt) => resolve(txt),
		      (reason) => reject(reason)
		    ).finally(() => clearTimeout(timeout));
		  });
		}
		async function _getResponseText(response) {
		  return await response.text();
		}

		async function captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
		  try {
		    const data = _prepareXhrData(breadcrumb, hint, options);
		    const result = makeNetworkReplayBreadcrumb("resource.xhr", data);
		    addNetworkBreadcrumb(options.replay, result);
		  } catch (error) {
		    DEBUG_BUILD && debug.exception(error, "Failed to capture xhr breadcrumb");
		  }
		}
		function enrichXhrBreadcrumb(breadcrumb, hint) {
		  const { xhr, input } = hint;
		  if (!xhr) {
		    return;
		  }
		  const reqSize = getBodySize(input);
		  const resSize = xhr.getResponseHeader("content-length") ? parseContentLengthHeader(xhr.getResponseHeader("content-length")) : _getBodySize(xhr.response, xhr.responseType);
		  if (reqSize !== void 0) {
		    breadcrumb.data.request_body_size = reqSize;
		  }
		  if (resSize !== void 0) {
		    breadcrumb.data.response_body_size = resSize;
		  }
		}
		function _prepareXhrData(breadcrumb, hint, options) {
		  const now = Date.now();
		  const { startTimestamp = now, endTimestamp = now, input, xhr } = hint;
		  const {
		    url,
		    method,
		    status_code: statusCode = 0,
		    request_body_size: requestBodySize,
		    response_body_size: responseBodySize
		  } = breadcrumb.data;
		  if (!url) {
		    return null;
		  }
		  if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
		    const request2 = buildSkippedNetworkRequestOrResponse(requestBodySize);
		    const response2 = buildSkippedNetworkRequestOrResponse(responseBodySize);
		    return {
		      startTimestamp,
		      endTimestamp,
		      url,
		      method,
		      statusCode,
		      request: request2,
		      response: response2
		    };
		  }
		  const xhrInfo = xhr[browserUtils.SENTRY_XHR_DATA_KEY];
		  const networkRequestHeaders = xhrInfo ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
		  const networkResponseHeaders = getAllowedHeaders(browserUtils.parseXhrResponseHeaders(xhr), options.networkResponseHeaders);
		  const [requestBody, requestWarning] = options.networkCaptureBodies ? browserUtils.getBodyString(input, debug) : [void 0];
		  const [responseBody, responseWarning] = options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [void 0];
		  const request = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
		  const response = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
		  return {
		    startTimestamp,
		    endTimestamp,
		    url,
		    method,
		    statusCode,
		    request: requestWarning ? mergeWarning(request, requestWarning) : request,
		    response: responseWarning ? mergeWarning(response, responseWarning) : response
		  };
		}
		function _getXhrResponseBody(xhr) {
		  const errors = [];
		  try {
		    return [xhr.responseText];
		  } catch (e) {
		    errors.push(e);
		  }
		  try {
		    return _parseXhrResponse(xhr.response, xhr.responseType);
		  } catch (e) {
		    errors.push(e);
		  }
		  DEBUG_BUILD && debug.warn("Failed to get xhr response body", ...errors);
		  return [void 0];
		}
		function _parseXhrResponse(body, responseType) {
		  try {
		    if (typeof body === "string") {
		      return [body];
		    }
		    if (body instanceof Document) {
		      return [body.body.outerHTML];
		    }
		    if (responseType === "json" && body && typeof body === "object") {
		      return [JSON.stringify(body)];
		    }
		    if (!body) {
		      return [void 0];
		    }
		  } catch (error) {
		    DEBUG_BUILD && debug.exception(error, "Failed to serialize body", body);
		    return [void 0, "BODY_PARSE_ERROR"];
		  }
		  DEBUG_BUILD && debug.log("Skipping network body because of body type", body);
		  return [void 0, "UNPARSEABLE_BODY_TYPE"];
		}
		function _getBodySize(body, responseType) {
		  try {
		    const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
		    return getBodySize(bodyStr);
		  } catch {
		    return void 0;
		  }
		}

		function handleNetworkBreadcrumbs(replay) {
		  const client = core.getClient();
		  try {
		    const {
		      networkDetailAllowUrls,
		      networkDetailDenyUrls,
		      networkCaptureBodies,
		      networkRequestHeaders,
		      networkResponseHeaders
		    } = replay.getOptions();
		    const options = {
		      replay,
		      networkDetailAllowUrls,
		      networkDetailDenyUrls,
		      networkCaptureBodies,
		      networkRequestHeaders,
		      networkResponseHeaders
		    };
		    if (client) {
		      client.on("beforeAddBreadcrumb", (breadcrumb, hint) => beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
		    }
		  } catch {
		  }
		}
		function beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
		  if (!breadcrumb.data) {
		    return;
		  }
		  try {
		    if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
		      enrichXhrBreadcrumb(breadcrumb, hint);
		      captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
		    }
		    if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
		      enrichFetchBreadcrumb(breadcrumb, hint);
		      captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
		    }
		  } catch (e) {
		    DEBUG_BUILD && debug.exception(e, "Error when enriching network breadcrumb");
		  }
		}
		function _isXhrBreadcrumb(breadcrumb) {
		  return breadcrumb.category === "xhr";
		}
		function _isFetchBreadcrumb(breadcrumb) {
		  return breadcrumb.category === "fetch";
		}
		function _isXhrHint(hint) {
		  return hint?.xhr;
		}
		function _isFetchHint(hint) {
		  return hint?.input !== void 0;
		}

		function addGlobalListeners(replay) {
		  const client = core.getClient();
		  browserUtils.addClickKeypressInstrumentationHandler(handleDomListener(replay));
		  browserUtils.addHistoryInstrumentationHandler(handleHistorySpanListener(replay));
		  handleBreadcrumbs(replay);
		  handleNetworkBreadcrumbs(replay);
		  const eventProcessor = handleGlobalEventListener(replay);
		  core.addEventProcessor(eventProcessor);
		  if (client) {
		    client.on("beforeSendEvent", handleBeforeSendEvent(replay));
		    client.on("afterSendEvent", handleAfterSendEvent(replay));
		    client.on("createDsc", (dsc) => {
		      const replayId = replay.getSessionId();
		      if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
		        const isSessionActive = replay.checkAndHandleExpiredSession();
		        if (isSessionActive) {
		          dsc.replay_id = replayId;
		        }
		      }
		    });
		    client.on("spanStart", (span) => {
		      replay.lastActiveSpan = span;
		    });
		    client.on("spanEnd", (span) => {
		      replay.lastActiveSpan = span;
		    });
		    client.on("beforeSendFeedback", async (feedbackEvent, options) => {
		      const replayId = replay.getSessionId();
		      if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
		        if (feedbackEvent.contexts.feedback.source === "api") {
		          await replay.sendBufferedReplayOrFlush();
		        }
		        feedbackEvent.contexts.feedback.replay_id = replayId;
		      }
		    });
		    client.on("openFeedbackWidget", async () => {
		      await replay.sendBufferedReplayOrFlush();
		    });
		  }
		}

		async function addMemoryEntry(replay) {
		  try {
		    return Promise.all(
		      createPerformanceSpans(replay, [
		        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
		        createMemoryEntry(WINDOW.performance.memory)
		      ])
		    );
		  } catch {
		    return [];
		  }
		}
		function createMemoryEntry(memoryEntry) {
		  const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memoryEntry;
		  const time = Date.now() / 1e3;
		  return {
		    type: "memory",
		    name: "memory",
		    start: time,
		    end: time,
		    data: {
		      memory: {
		        jsHeapSizeLimit,
		        totalJSHeapSize,
		        usedJSHeapSize
		      }
		    }
		  };
		}

		function debounce(func, wait, options) {
		  return core.debounce(func, wait, {
		    ...options,
		    // @ts-expect-error - Not quite sure why these types do not match, but this is fine
		    setTimeoutImpl: browserUtils.setTimeout
		  });
		}

		const NAVIGATOR = core.GLOBAL_OBJ.navigator;
		function getRecordingSamplingOptions() {
		  if (/iPhone|iPad|iPod/i.test(NAVIGATOR?.userAgent ?? "") || /Macintosh/i.test(NAVIGATOR?.userAgent ?? "") && NAVIGATOR?.maxTouchPoints && NAVIGATOR?.maxTouchPoints > 1) {
		    return {
		      sampling: {
		        mousemove: false
		      }
		    };
		  }
		  return {};
		}

		function getHandleRecordingEmit(replay) {
		  let hadFirstEvent = false;
		  return (event, _isCheckout) => {
		    if (!replay.checkAndHandleExpiredSession()) {
		      DEBUG_BUILD && debug.warn("Received replay event after session expired.");
		      return;
		    }
		    const isCheckout = _isCheckout || !hadFirstEvent;
		    hadFirstEvent = true;
		    syncMirrorAttributesFromMutationEvent(event);
		    if (replay.clickDetector) {
		      updateClickDetectorForRecordingEvent(replay.clickDetector, event);
		    }
		    replay.addUpdate(() => {
		      if (replay.recordingMode === "buffer" && isCheckout) {
		        replay.setInitialState();
		      }
		      if (!addEventSync(replay, event, isCheckout)) {
		        return true;
		      }
		      if (!isCheckout) {
		        return false;
		      }
		      const session = replay.session;
		      addSettingsEvent(replay, isCheckout);
		      if (replay.recordingMode === "buffer" && session && replay.eventBuffer && !session.dirty) {
		        const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
		        if (earliestEvent) {
		          DEBUG_BUILD && debug.log(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
		          session.started = earliestEvent;
		          if (replay.getOptions().stickySession) {
		            saveSession(session);
		          }
		        }
		      }
		      if (session?.previousSessionId) {
		        return true;
		      }
		      if (replay.recordingMode === "session") {
		        void replay.flush();
		      }
		      return true;
		    });
		  };
		}
		function syncMirrorAttributesFromMutationEvent(event) {
		  const data = event.data;
		  if (event.type !== EventType.IncrementalSnapshot || !data || typeof data !== "object" || !("source" in data) || data.source !== IncrementalSource.Mutation || !("attributes" in data) || !Array.isArray(data.attributes)) {
		    return;
		  }
		  for (const mutation of data.attributes) {
		    const node = record.mirror.getNode(mutation.id);
		    const meta = node && record.mirror.getMeta(node);
		    if (meta?.type !== NodeType.Element) {
		      continue;
		    }
		    for (const [attributeName, value] of Object.entries(mutation.attributes)) {
		      if (value === null) {
		        delete meta.attributes[attributeName];
		      } else {
		        meta.attributes[attributeName] = value;
		      }
		    }
		  }
		}
		function createOptionsEvent(replay) {
		  const options = replay.getOptions();
		  return {
		    type: EventType.Custom,
		    timestamp: Date.now(),
		    data: {
		      tag: "options",
		      payload: {
		        shouldRecordCanvas: replay.isRecordingCanvas(),
		        sessionSampleRate: options.sessionSampleRate,
		        errorSampleRate: options.errorSampleRate,
		        useCompressionOption: options.useCompression,
		        blockAllMedia: options.blockAllMedia,
		        maskAllText: options.maskAllText,
		        maskAllInputs: options.maskAllInputs,
		        useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
		        networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
		        networkCaptureBodies: options.networkCaptureBodies,
		        networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
		        networkResponseHasHeaders: options.networkResponseHeaders.length > 0
		      }
		    }
		  };
		}
		function addSettingsEvent(replay, isCheckout) {
		  if (!isCheckout || replay.session?.segmentId !== 0) {
		    return;
		  }
		  addEventSync(replay, createOptionsEvent(replay), false);
		}

		function closestElementOfNode(node) {
		  if (!node) {
		    return null;
		  }
		  try {
		    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
		    return el;
		  } catch {
		    return null;
		  }
		}

		function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
		  return core.createEnvelope(
		    core.createEventEnvelopeHeaders(replayEvent, core.getSdkMetadataForEnvelopeHeader(replayEvent), tunnel, dsn),
		    [
		      [{ type: "replay_event" }, replayEvent],
		      [
		        {
		          type: "replay_recording",
		          // If string then we need to encode to UTF8, otherwise will have
		          // wrong size. TextEncoder has similar browser support to
		          // MutationObserver, although it does not accept IE11.
		          length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
		        },
		        recordingData
		      ]
		    ]
		  );
		}

		function prepareRecordingData({
		  recordingData,
		  headers
		}) {
		  let payloadWithSequence;
		  const replayHeaders = `${JSON.stringify(headers)}
`;
		  if (typeof recordingData === "string") {
		    payloadWithSequence = `${replayHeaders}${recordingData}`;
		  } else {
		    const enc = new TextEncoder();
		    const sequence = enc.encode(replayHeaders);
		    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
		    payloadWithSequence.set(sequence);
		    payloadWithSequence.set(recordingData, sequence.length);
		  }
		  return payloadWithSequence;
		}

		async function prepareReplayEvent({
		  client,
		  scope,
		  replayId: event_id,
		  event
		}) {
		  const integrations = typeof client["_integrations"] === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : void 0;
		  const eventHint = { event_id, integrations };
		  client.emit("preprocessEvent", event, eventHint);
		  const preparedEvent = await core.prepareEvent(
		    client.getOptions(),
		    event,
		    eventHint,
		    scope,
		    client,
		    core.getIsolationScope()
		  );
		  if (!preparedEvent) {
		    return null;
		  }
		  client.emit("postprocessEvent", preparedEvent, eventHint);
		  preparedEvent.platform = preparedEvent.platform || "javascript";
		  const metadata = client.getSdkMetadata();
		  const { name, version, settings } = metadata?.sdk || {};
		  preparedEvent.sdk = {
		    ...preparedEvent.sdk,
		    name: name || "sentry.javascript.unknown",
		    version: version || "0.0.0",
		    settings
		  };
		  return preparedEvent;
		}

		async function sendReplayRequest({
		  recordingData,
		  replayId,
		  segmentId: segment_id,
		  eventContext,
		  timestamp,
		  session
		}) {
		  const preparedRecordingData = prepareRecordingData({
		    recordingData,
		    headers: {
		      segment_id
		    }
		  });
		  const { urls, errorIds, traceIds, initialTimestamp } = eventContext;
		  const client = core.getClient();
		  const scope = core.getCurrentScope();
		  const transport = client?.getTransport();
		  const dsn = client?.getDsn();
		  if (!client || !transport || !dsn || !session.sampled) {
		    return Promise.resolve({});
		  }
		  const baseEvent = {
		    type: REPLAY_EVENT_NAME,
		    replay_start_timestamp: initialTimestamp / 1e3,
		    timestamp: timestamp / 1e3,
		    error_ids: errorIds,
		    trace_ids: traceIds,
		    urls,
		    replay_id: replayId,
		    segment_id,
		    replay_type: session.sampled
		  };
		  const replayEvent = await prepareReplayEvent({ scope, client, replayId, event: baseEvent });
		  if (!replayEvent) {
		    client.recordDroppedEvent("event_processor", "replay");
		    DEBUG_BUILD && debug.log("An event processor returned `null`, will not send event.");
		    return Promise.resolve({});
		  }
		  delete replayEvent.sdkProcessingMetadata;
		  const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
		  let response;
		  try {
		    response = await transport.send(envelope);
		  } catch (err) {
		    const error = new Error(UNABLE_TO_SEND_REPLAY);
		    try {
		      error.cause = err;
		    } catch {
		    }
		    throw error;
		  }
		  const rateLimits = core.updateRateLimits({}, response);
		  if (core.isRateLimited(rateLimits, "replay")) {
		    throw new RateLimitError(rateLimits);
		  }
		  if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) {
		    throw new TransportStatusCodeError(response.statusCode);
		  }
		  return response;
		}
		class TransportStatusCodeError extends Error {
		  constructor(statusCode) {
		    super(`Transport returned status code ${statusCode}`);
		  }
		}
		class RateLimitError extends Error {
		  constructor(rateLimits) {
		    super("Rate limit hit");
		    this.rateLimits = rateLimits;
		  }
		}
		class ReplayDurationLimitError extends Error {
		  constructor() {
		    super("Session is too long, not sending replay");
		  }
		}

		async function sendReplay(replayData, retryConfig = {
		  count: 0,
		  interval: RETRY_BASE_INTERVAL
		}) {
		  const { recordingData, onError } = replayData;
		  if (!recordingData.length) {
		    return;
		  }
		  try {
		    await sendReplayRequest(replayData);
		    return true;
		  } catch (err) {
		    if (err instanceof TransportStatusCodeError || err instanceof RateLimitError) {
		      throw err;
		    }
		    core.setContext("Replays", {
		      _retryCount: retryConfig.count
		    });
		    if (onError) {
		      onError(err);
		    }
		    if (retryConfig.count >= RETRY_MAX_COUNT) {
		      const error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
		      try {
		        error.cause = err;
		      } catch {
		      }
		      throw error;
		    }
		    retryConfig.interval *= ++retryConfig.count;
		    return new Promise((resolve, reject) => {
		      browserUtils.setTimeout(async () => {
		        try {
		          await sendReplay(replayData, retryConfig);
		          resolve(true);
		        } catch (err2) {
		          reject(err2);
		        }
		      }, retryConfig.interval);
		    });
		  }
		}

		const THROTTLED = "__THROTTLED";
		const SKIPPED = "__SKIPPED";
		function throttle(fn, maxCount, durationSeconds) {
		  const counter = /* @__PURE__ */ new Map();
		  const _cleanup = (now) => {
		    const threshold = now - durationSeconds;
		    counter.forEach((_value, key) => {
		      if (key < threshold) {
		        counter.delete(key);
		      }
		    });
		  };
		  const _getTotalCount = () => {
		    return [...counter.values()].reduce((a, b) => a + b, 0);
		  };
		  let isThrottled = false;
		  return (...rest) => {
		    const now = Math.floor(Date.now() / 1e3);
		    _cleanup(now);
		    if (_getTotalCount() >= maxCount) {
		      const wasThrottled = isThrottled;
		      isThrottled = true;
		      return wasThrottled ? SKIPPED : THROTTLED;
		    }
		    isThrottled = false;
		    const count = counter.get(now) || 0;
		    counter.set(now, count + 1);
		    return fn(...rest);
		  };
		}

		class ReplayContainer {
		  constructor({
		    options,
		    recordingOptions
		  }) {
		    this.eventBuffer = null;
		    this.performanceEntries = [];
		    this.replayPerformanceEntries = [];
		    this.recordingMode = "session";
		    this.timeouts = {
		      sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
		      sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION
		    };
		    this._lastActivity = Date.now();
		    this._isEnabled = false;
		    this._isPaused = false;
		    this._requiresManualStart = false;
		    this._hasInitializedCoreListeners = false;
		    this._context = {
		      errorIds: /* @__PURE__ */ new Set(),
		      traceIds: /* @__PURE__ */ new Set(),
		      urls: [],
		      initialTimestamp: Date.now(),
		      initialUrl: ""
		    };
		    this._recordingOptions = recordingOptions;
		    this._options = options;
		    this._debouncedFlush = debounce(() => this._flush(), this._options.flushMinDelay, {
		      maxWait: this._options.flushMaxDelay
		    });
		    this._throttledAddEvent = throttle(
		      (event, isCheckout) => addEvent(this, event, isCheckout),
		      // Max 300 events...
		      300,
		      // ... per 5s
		      5
		    );
		    const { slowClickTimeout, slowClickIgnoreSelectors } = this.getOptions();
		    const slowClickConfig = slowClickTimeout ? {
		      threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
		      timeout: slowClickTimeout,
		      scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
		      ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
		    } : void 0;
		    if (slowClickConfig) {
		      this.clickDetector = new ClickDetector(this, slowClickConfig);
		    }
		    if (DEBUG_BUILD) {
		      const experiments = options._experiments;
		      debug.setConfig({
		        captureExceptions: !!experiments.captureExceptions,
		        traceInternals: !!experiments.traceInternals
		      });
		    }
		    this._handleVisibilityChange = () => {
		      if (WINDOW.document.visibilityState === "visible") {
		        this._doChangeToForegroundTasks();
		      } else {
		        this._doChangeToBackgroundTasks();
		      }
		    };
		    this._handleWindowBlur = () => {
		      const breadcrumb = createBreadcrumb({
		        category: "ui.blur"
		      });
		      this._doChangeToBackgroundTasks(breadcrumb);
		    };
		    this._handleWindowFocus = () => {
		      const breadcrumb = createBreadcrumb({
		        category: "ui.focus"
		      });
		      this._doChangeToForegroundTasks(breadcrumb);
		    };
		    this._handleKeyboardEvent = (event) => {
		      handleKeyboardEvent(this, event);
		    };
		  }
		  /** Get the event context. */
		  getContext() {
		    return this._context;
		  }
		  /** If recording is currently enabled. */
		  isEnabled() {
		    return this._isEnabled;
		  }
		  /** If recording is currently paused. */
		  isPaused() {
		    return this._isPaused;
		  }
		  /**
		   * Determine if canvas recording is enabled
		   */
		  isRecordingCanvas() {
		    return Boolean(this._canvas);
		  }
		  /** Get the replay integration options. */
		  getOptions() {
		    return this._options;
		  }
		  /** A wrapper to conditionally capture exceptions. */
		  handleException(error) {
		    DEBUG_BUILD && debug.exception(error);
		    if (this._options.onError) {
		      this._options.onError(error);
		    }
		  }
		  /**
		   * Initializes the plugin based on sampling configuration. Should not be
		   * called outside of constructor.
		   */
		  initializeSampling(previousSessionId) {
		    const { errorSampleRate, sessionSampleRate } = this._options;
		    const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
		    this._requiresManualStart = requiresManualStart;
		    if (requiresManualStart) {
		      return;
		    }
		    this._initializeSessionForSampling(previousSessionId);
		    if (!this.session) {
		      DEBUG_BUILD && debug.exception(new Error("Unable to initialize and create session"));
		      return;
		    }
		    if (this.session.sampled === false) {
		      return;
		    }
		    this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
		    DEBUG_BUILD && debug.infoTick(`Starting replay in ${this.recordingMode} mode`);
		    this._initializeRecording();
		  }
		  /**
		   * Start a replay regardless of sampling rate. Calling this will always
		   * create a new session. Will log a message if replay is already in progress.
		   *
		   * Creates or loads a session, attaches listeners to varying events (DOM,
		   * _performanceObserver, Recording, Sentry SDK, etc)
		   */
		  start() {
		    if (this._isEnabled && this.recordingMode === "session") {
		      DEBUG_BUILD && debug.log("Recording is already in progress");
		      return;
		    }
		    if (this._isEnabled && this.recordingMode === "buffer") {
		      DEBUG_BUILD && debug.log("Buffering is in progress, call `flush()` to save the replay");
		      return;
		    }
		    DEBUG_BUILD && debug.infoTick("Starting replay in session mode");
		    this._updateUserActivity();
		    const session = loadOrCreateSession(
		      {
		        maxReplayDuration: this._options.maxReplayDuration,
		        sessionIdleExpire: this.timeouts.sessionIdleExpire
		      },
		      {
		        stickySession: this._options.stickySession,
		        // This is intentional: create a new session-based replay when calling `start()`
		        sessionSampleRate: 1,
		        allowBuffering: false
		      }
		    );
		    this.session = session;
		    this.recordingMode = "session";
		    this._initializeRecording();
		  }
		  /**
		   * Start replay buffering. Buffers until `flush()` is called or, if
		   * `replaysOnErrorSampleRate` > 0, an error occurs.
		   */
		  startBuffering() {
		    if (this._isEnabled) {
		      DEBUG_BUILD && debug.log("Buffering is in progress, call `flush()` to save the replay");
		      return;
		    }
		    DEBUG_BUILD && debug.infoTick("Starting replay in buffer mode");
		    const session = loadOrCreateSession(
		      {
		        sessionIdleExpire: this.timeouts.sessionIdleExpire,
		        maxReplayDuration: this._options.maxReplayDuration
		      },
		      {
		        stickySession: this._options.stickySession,
		        sessionSampleRate: 0,
		        allowBuffering: true
		      }
		    );
		    this.session = session;
		    this.recordingMode = "buffer";
		    this._initializeRecording();
		  }
		  /**
		   * Start recording.
		   *
		   * Note that this will cause a new DOM checkout
		   */
		  startRecording() {
		    try {
		      const canvasOptions = this._canvas;
		      this._stopRecording = record({
		        ...this._recordingOptions,
		        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
		        // Without this, it would record forever, until an error happens, which we don't want
		        // instead, we'll always keep the last 60 seconds of replay before an error happened
		        ...this.recordingMode === "buffer" ? { checkoutEveryNms: BUFFER_CHECKOUT_TIME } : (
		          // Otherwise, use experimental option w/ min checkout time of 6 minutes
		          // This is to improve playback seeking as there could potentially be
		          // less mutations to process in the worse cases.
		          //
		          // checkout by "N" events is probably ideal, but means we have less
		          // control about the number of checkouts we make (which generally
		          // increases replay size)
		          this._options._experiments.continuousCheckout && {
		            // Minimum checkout time is 6 minutes
		            checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
		          }
		        ),
		        emit: getHandleRecordingEmit(this),
		        ...getRecordingSamplingOptions(),
		        onMutation: this._onMutationHandler.bind(this),
		        ...canvasOptions ? {
		          recordCanvas: canvasOptions.recordCanvas,
		          getCanvasManager: canvasOptions.getCanvasManager,
		          sampling: canvasOptions.sampling,
		          dataURLOptions: canvasOptions.dataURLOptions
		        } : {}
		      });
		    } catch (err) {
		      this.handleException(err);
		    }
		  }
		  /**
		   * Stops the recording, if it was running.
		   *
		   * Returns true if it was previously stopped, or is now stopped,
		   * otherwise false.
		   */
		  stopRecording() {
		    try {
		      if (this._stopRecording) {
		        this._stopRecording();
		        this._stopRecording = void 0;
		      }
		      return true;
		    } catch (err) {
		      this.handleException(err);
		      return false;
		    }
		  }
		  /**
		   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
		   * does not support a teardown
		   */
		  async stop({
		    forceFlush = false,
		    reason
		  } = {}) {
		    if (!this._isEnabled) {
		      return;
		    }
		    this._isEnabled = false;
		    this.recordingMode = "buffer";
		    const stopReason = reason ?? "manual";
		    core.getClient()?.emit("replayEnd", { sessionId: this.session?.id, reason: stopReason });
		    try {
		      DEBUG_BUILD && debug.log(`Stopping Replay triggered by ${stopReason}`);
		      resetReplayIdOnDynamicSamplingContext();
		      this._removeListeners();
		      this.stopRecording();
		      this._debouncedFlush.cancel();
		      if (forceFlush) {
		        await this._flush({ force: true });
		      }
		      this.eventBuffer?.destroy();
		      this.eventBuffer = null;
		      clearSession(this);
		    } catch (err) {
		      this.handleException(err);
		    }
		  }
		  /**
		   * Pause some replay functionality. See comments for `_isPaused`.
		   * This differs from stop as this only stops DOM recording, it is
		   * not as thorough of a shutdown as `stop()`.
		   */
		  pause() {
		    if (this._isPaused) {
		      return;
		    }
		    this._isPaused = true;
		    this.stopRecording();
		    DEBUG_BUILD && debug.log("Pausing replay");
		  }
		  /**
		   * Resumes recording, see notes for `pause().
		   *
		   * Note that calling `startRecording()` here will cause a
		   * new DOM checkout.`
		   */
		  resume() {
		    if (!this._isPaused || !this._checkSession()) {
		      return;
		    }
		    this._isPaused = false;
		    this.startRecording();
		    DEBUG_BUILD && debug.log("Resuming replay");
		  }
		  /**
		   * If not in "session" recording mode, flush event buffer which will create a new replay.
		   * Unless `continueRecording` is false, the replay will continue to record and
		   * behave as a "session"-based replay.
		   *
		   * Otherwise, queue up a flush.
		   */
		  async sendBufferedReplayOrFlush({ continueRecording = true } = {}) {
		    if (this.recordingMode === "session") {
		      return this.flushImmediate();
		    }
		    const activityTime = Date.now();
		    DEBUG_BUILD && debug.log("Converting buffer to session");
		    await this.flushImmediate();
		    const hasStoppedRecording = this.stopRecording();
		    if (!continueRecording || !hasStoppedRecording) {
		      return;
		    }
		    if (this.recordingMode === "session") {
		      return;
		    }
		    this.recordingMode = "session";
		    if (this.session) {
		      this.session.dirty = false;
		      this._updateUserActivity(activityTime);
		      this._updateSessionActivity(activityTime);
		      this._maybeSaveSession();
		      setReplayIdOnDynamicSamplingContext(this.session.id);
		    }
		    this.startRecording();
		  }
		  /**
		   * We want to batch uploads of replay events. Save events only if
		   * `<flushMinDelay>` milliseconds have elapsed since the last event
		   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
		   *
		   * Accepts a callback to perform side-effects and returns true to stop batch
		   * processing and hand back control to caller.
		   */
		  addUpdate(cb) {
		    const cbResult = cb();
		    if (this.recordingMode === "buffer" || !this._isEnabled) {
		      return;
		    }
		    if (cbResult === true) {
		      return;
		    }
		    this._debouncedFlush();
		  }
		  /**
		   * Updates the user activity timestamp and resumes recording. This should be
		   * called in an event handler for a user action that we consider as the user
		   * being "active" (e.g. a mouse click).
		   */
		  triggerUserActivity() {
		    this._updateUserActivity();
		    if (!this._stopRecording) {
		      if (!this._checkSession()) {
		        return;
		      }
		      this.resume();
		      return;
		    }
		    this.checkAndHandleExpiredSession();
		    this._updateSessionActivity();
		  }
		  /**
		   * Updates the user activity timestamp *without* resuming
		   * recording. Some user events (e.g. keydown) can be create
		   * low-value replays that only contain the keypress as a
		   * breadcrumb. Instead this would require other events to
		   * create a new replay after a session has expired.
		   */
		  updateUserActivity() {
		    this._updateUserActivity();
		    this._updateSessionActivity();
		  }
		  /**
		   * Only flush if `this.recordingMode === 'session'`
		   */
		  conditionalFlush() {
		    if (this.recordingMode === "buffer") {
		      return Promise.resolve();
		    }
		    return this.flushImmediate();
		  }
		  /**
		   * Flush using debounce flush
		   */
		  flush() {
		    return this._debouncedFlush();
		  }
		  /**
		   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
		   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
		   * cases of multiple flushes happening closely together.
		   */
		  flushImmediate() {
		    this._debouncedFlush();
		    return this._debouncedFlush.flush();
		  }
		  /**
		   * Cancels queued up flushes.
		   */
		  cancelFlush() {
		    this._debouncedFlush.cancel();
		  }
		  /** Get the current session (=replay) ID
		   *
		   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
		   */
		  getSessionId(onlyIfSampled) {
		    if (onlyIfSampled && this.session?.sampled === false) {
		      return void 0;
		    }
		    return this.session?.id;
		  }
		  /**
		   * Checks if recording should be stopped due to user inactivity. Otherwise
		   * check if session is expired and create a new session if so. Triggers a new
		   * full snapshot on new session.
		   *
		   * Returns true if session is not expired, false otherwise.
		   * @hidden
		   */
		  checkAndHandleExpiredSession() {
		    if (this._lastActivity && isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session?.sampled === "session") {
		      this.pause();
		      return;
		    }
		    if (!this._checkSession()) {
		      return false;
		    }
		    return true;
		  }
		  /**
		   * Capture some initial state that can change throughout the lifespan of the
		   * replay. This is required because otherwise they would be captured at the
		   * first flush.
		   */
		  setInitialState() {
		    const urlPath = `${WINDOW.location.pathname}${WINDOW.location.hash}${WINDOW.location.search}`;
		    const url = `${WINDOW.location.origin}${urlPath}`;
		    this.performanceEntries = [];
		    this.replayPerformanceEntries = [];
		    this._clearContext();
		    this._context.initialUrl = url;
		    this._context.initialTimestamp = Date.now();
		    this._context.urls.push(url);
		  }
		  /**
		   * Add a breadcrumb event, that may be throttled.
		   * If it was throttled, we add a custom breadcrumb to indicate that.
		   */
		  throttledAddEvent(event, isCheckout) {
		    const res = this._throttledAddEvent(event, isCheckout);
		    if (res === THROTTLED) {
		      const breadcrumb = createBreadcrumb({
		        category: "replay.throttled"
		      });
		      this.addUpdate(() => {
		        return !addEventSync(this, {
		          type: ReplayEventTypeCustom,
		          timestamp: breadcrumb.timestamp || 0,
		          data: {
		            tag: "breadcrumb",
		            payload: breadcrumb,
		            metric: true
		          }
		        });
		      });
		    }
		    return res;
		  }
		  /**
		   * This will get the parametrized route name of the current page.
		   * This is only available if performance is enabled, and if an instrumented router is used.
		   */
		  getCurrentRoute() {
		    const lastActiveSpan = this.lastActiveSpan || core.getActiveSpan();
		    const lastRootSpan = lastActiveSpan && core.getRootSpan(lastActiveSpan);
		    const attributes = lastRootSpan && core.spanToJSON(lastRootSpan).data || {};
		    const source = attributes[core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
		    if (!lastRootSpan || !source || !["route", "custom"].includes(source)) {
		      return void 0;
		    }
		    return core.spanToJSON(lastRootSpan).description;
		  }
		  /**
		   * Initialize and start all listeners to varying events (DOM,
		   * Performance Observer, Recording, Sentry SDK, etc)
		   */
		  _initializeRecording() {
		    this.setInitialState();
		    this._updateSessionActivity();
		    this.eventBuffer = createEventBuffer({
		      useCompression: this._options.useCompression,
		      workerUrl: this._options.workerUrl
		    });
		    this._removeListeners();
		    this._addListeners();
		    this._isEnabled = true;
		    this._isPaused = false;
		    if (this.session) {
		      core.getClient()?.emit("replayStart", {
		        sessionId: this.session.id,
		        recordingMode: this.recordingMode
		      });
		    }
		    this.startRecording();
		    if (this.recordingMode === "session" && this.session) {
		      setReplayIdOnDynamicSamplingContext(this.session.id);
		    }
		  }
		  /**
		   * Loads (or refreshes) the current session.
		   */
		  _initializeSessionForSampling(previousSessionId) {
		    const allowBuffering = this._options.errorSampleRate > 0;
		    const session = loadOrCreateSession(
		      {
		        sessionIdleExpire: this.timeouts.sessionIdleExpire,
		        maxReplayDuration: this._options.maxReplayDuration,
		        previousSessionId
		      },
		      {
		        stickySession: this._options.stickySession,
		        sessionSampleRate: this._options.sessionSampleRate,
		        allowBuffering
		      }
		    );
		    this.session = session;
		  }
		  /**
		   * Checks and potentially refreshes the current session.
		   * Returns false if session is not recorded.
		   */
		  _checkSession() {
		    if (!this.session) {
		      return false;
		    }
		    const currentSession = this.session;
		    if (shouldRefreshSession(currentSession, {
		      sessionIdleExpire: this.timeouts.sessionIdleExpire,
		      maxReplayDuration: this._options.maxReplayDuration
		    })) {
		      this._refreshSession(currentSession);
		      return false;
		    }
		    return true;
		  }
		  /**
		   * Refresh a session with a new one.
		   * This stops the current session (without forcing a flush, as that would never work since we are expired),
		   * and then does a new sampling based on the refreshed session.
		   */
		  async _refreshSession(session) {
		    if (!this._isEnabled) {
		      return;
		    }
		    await this.stop({ reason: "sessionExpired" });
		    this.initializeSampling(session.id);
		  }
		  /**
		   * Adds listeners to record events for the replay
		   */
		  _addListeners() {
		    try {
		      WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
		      WINDOW.addEventListener("blur", this._handleWindowBlur);
		      WINDOW.addEventListener("focus", this._handleWindowFocus);
		      WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
		      if (this.clickDetector) {
		        this.clickDetector.addListeners();
		      }
		      if (!this._hasInitializedCoreListeners) {
		        addGlobalListeners(this);
		        this._hasInitializedCoreListeners = true;
		      }
		    } catch (err) {
		      this.handleException(err);
		    }
		    this._performanceCleanupCallback = setupPerformanceObserver(this);
		  }
		  /**
		   * Cleans up listeners that were created in `_addListeners`
		   */
		  _removeListeners() {
		    try {
		      WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
		      WINDOW.removeEventListener("blur", this._handleWindowBlur);
		      WINDOW.removeEventListener("focus", this._handleWindowFocus);
		      WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
		      if (this.clickDetector) {
		        this.clickDetector.removeListeners();
		      }
		      if (this._performanceCleanupCallback) {
		        this._performanceCleanupCallback();
		      }
		    } catch (err) {
		      this.handleException(err);
		    }
		  }
		  /**
		   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
		   */
		  _doChangeToBackgroundTasks(breadcrumb) {
		    if (!this.session) {
		      return;
		    }
		    const expired = shouldRefreshSession(this.session, {
		      maxReplayDuration: this._options.maxReplayDuration,
		      sessionIdleExpire: this.timeouts.sessionIdleExpire
		    });
		    if (expired) {
		      resetReplayIdOnDynamicSamplingContext();
		      return;
		    }
		    if (breadcrumb) {
		      this._createCustomBreadcrumb(breadcrumb);
		    }
		    void this.conditionalFlush();
		  }
		  /**
		   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
		   */
		  _doChangeToForegroundTasks(breadcrumb) {
		    if (!this.session) {
		      return;
		    }
		    const isSessionActive = this.checkAndHandleExpiredSession();
		    if (!isSessionActive) {
		      DEBUG_BUILD && debug.log("Document has become active, but session has expired");
		      return;
		    }
		    if (breadcrumb) {
		      this._createCustomBreadcrumb(breadcrumb);
		    }
		  }
		  /**
		   * Update user activity (across session lifespans)
		   */
		  _updateUserActivity(_lastActivity = Date.now()) {
		    this._lastActivity = _lastActivity;
		  }
		  /**
		   * Updates the session's last activity timestamp
		   */
		  _updateSessionActivity(_lastActivity = Date.now()) {
		    if (this.session) {
		      this.session.lastActivity = _lastActivity;
		      this._maybeSaveSession();
		    }
		  }
		  /**
		   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
		   */
		  _createCustomBreadcrumb(breadcrumb) {
		    this.addUpdate(() => {
		      this.throttledAddEvent({
		        type: EventType.Custom,
		        timestamp: breadcrumb.timestamp || 0,
		        data: {
		          tag: "breadcrumb",
		          payload: breadcrumb
		        }
		      });
		    });
		  }
		  /**
		   * Observed performance events are added to `this.performanceEntries`. These
		   * are included in the replay event before it is finished and sent to Sentry.
		   */
		  _addPerformanceEntries() {
		    let performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
		    this.performanceEntries = [];
		    this.replayPerformanceEntries = [];
		    if (this._requiresManualStart) {
		      const initialTimestampInSeconds = this._context.initialTimestamp / 1e3;
		      performanceEntries = performanceEntries.filter((entry) => entry.start >= initialTimestampInSeconds);
		    }
		    return Promise.all(createPerformanceSpans(this, performanceEntries));
		  }
		  /**
		   * Clear _context
		   */
		  _clearContext() {
		    this._context.errorIds.clear();
		    this._context.traceIds.clear();
		    this._context.urls = [];
		  }
		  /** Update the initial timestamp based on the buffer content. */
		  _updateInitialTimestampFromEventBuffer() {
		    const { session, eventBuffer } = this;
		    if (!session || !eventBuffer || this._requiresManualStart) {
		      return;
		    }
		    if (session.segmentId) {
		      return;
		    }
		    const earliestEvent = eventBuffer.getEarliestTimestamp();
		    if (earliestEvent && earliestEvent < this._context.initialTimestamp) {
		      this._context.initialTimestamp = earliestEvent;
		    }
		  }
		  /**
		   * Return and clear _context
		   */
		  _popEventContext() {
		    const _context = {
		      initialTimestamp: this._context.initialTimestamp,
		      initialUrl: this._context.initialUrl,
		      errorIds: Array.from(this._context.errorIds),
		      traceIds: Array.from(this._context.traceIds),
		      urls: this._context.urls
		    };
		    this._clearContext();
		    return _context;
		  }
		  /**
		   * Flushes replay event buffer to Sentry.
		   *
		   * Performance events are only added right before flushing - this is
		   * due to the buffered performance observer events.
		   *
		   * Should never be called directly, only by `flush`
		   */
		  async _runFlush() {
		    const replayId = this.getSessionId();
		    if (!this.session || !this.eventBuffer || !replayId) {
		      DEBUG_BUILD && debug.error("No session or eventBuffer found to flush.");
		      return;
		    }
		    await this._addPerformanceEntries();
		    if (!this.eventBuffer?.hasEvents) {
		      return;
		    }
		    await addMemoryEntry(this);
		    if (!this.eventBuffer) {
		      return;
		    }
		    if (replayId !== this.getSessionId()) {
		      return;
		    }
		    try {
		      this._updateInitialTimestampFromEventBuffer();
		      const timestamp = Date.now();
		      if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4) {
		        throw new ReplayDurationLimitError();
		      }
		      const eventContext = this._popEventContext();
		      const segmentId = this.session.segmentId++;
		      this._maybeSaveSession();
		      const recordingData = await this.eventBuffer.finish();
		      await sendReplay({
		        replayId,
		        recordingData,
		        segmentId,
		        eventContext,
		        session: this.session,
		        timestamp,
		        onError: (err) => this.handleException(err)
		      });
		    } catch (err) {
		      this.handleException(err);
		      this.stop({ reason: "sendError" });
		      const client = core.getClient();
		      if (client) {
		        let dropReason;
		        if (err instanceof RateLimitError) {
		          dropReason = "ratelimit_backoff";
		        } else if (err instanceof ReplayDurationLimitError) {
		          dropReason = "invalid";
		        } else {
		          dropReason = "send_error";
		        }
		        client.recordDroppedEvent(dropReason, "replay");
		      }
		    }
		  }
		  /**
		   * Flush recording data to Sentry. Creates a lock so that only a single flush
		   * can be active at a time. Do not call this directly.
		   */
		  async _flush({
		    force = false
		  } = {}) {
		    if (!this._isEnabled && !force) {
		      return;
		    }
		    if (!this.checkAndHandleExpiredSession()) {
		      DEBUG_BUILD && debug.error("Attempting to finish replay event after session expired.");
		      return;
		    }
		    if (!this.session) {
		      return;
		    }
		    const start = this.session.started;
		    const now = Date.now();
		    const duration = now - start;
		    this._debouncedFlush.cancel();
		    const tooShort = duration < this._options.minReplayDuration;
		    const tooLong = duration > this._options.maxReplayDuration + 5e3;
		    if (tooShort || tooLong) {
		      DEBUG_BUILD && debug.log(
		        `Session duration (${Math.floor(duration / 1e3)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`
		      );
		      if (tooShort) {
		        this._debouncedFlush();
		      }
		      return;
		    }
		    const eventBuffer = this.eventBuffer;
		    if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) {
		      DEBUG_BUILD && debug.log("Flushing initial segment without checkout.");
		    }
		    const _flushInProgress = !!this._flushLock;
		    if (!this._flushLock) {
		      this._flushLock = this._runFlush();
		    }
		    try {
		      await this._flushLock;
		    } catch (err) {
		      this.handleException(err);
		    } finally {
		      this._flushLock = void 0;
		      if (_flushInProgress) {
		        this._debouncedFlush();
		      }
		    }
		  }
		  /** Save the session, if it is sticky */
		  _maybeSaveSession() {
		    if (this.session && this._options.stickySession) {
		      saveSession(this.session);
		    }
		  }
		  /** Handler for rrweb.record.onMutation */
		  _onMutationHandler(mutations) {
		    const { ignoreMutations } = this._options._experiments;
		    if (ignoreMutations?.length) {
		      if (mutations.some((mutation) => {
		        const el = closestElementOfNode(mutation.target);
		        const selector = ignoreMutations.join(",");
		        return el?.matches(selector);
		      })) {
		        return false;
		      }
		    }
		    const count = mutations.length;
		    const mutationLimit = this._options.mutationLimit;
		    const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
		    const overMutationLimit = mutationLimit && count > mutationLimit;
		    if (count > mutationBreadcrumbLimit || overMutationLimit) {
		      const breadcrumb = createBreadcrumb({
		        category: "replay.mutations",
		        data: {
		          count,
		          limit: overMutationLimit
		        }
		      });
		      this._createCustomBreadcrumb(breadcrumb);
		    }
		    if (overMutationLimit) {
		      this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" });
		      return false;
		    }
		    return true;
		  }
		}

		function getOption(selectors, defaultSelectors) {
		  return [
		    ...selectors,
		    // sentry defaults
		    ...defaultSelectors
		  ].join(",");
		}
		function getPrivacyOptions({ mask, unmask, block, unblock, ignore }) {
		  const defaultBlockedElements = ["base", "iframe[srcdoc]:not([src])"];
		  const maskSelector = getOption(mask, [".sentry-mask", "[data-sentry-mask]"]);
		  const unmaskSelector = getOption(unmask, []);
		  const options = {
		    // We are making the decision to make text and input selectors the same
		    maskTextSelector: maskSelector,
		    unmaskTextSelector: unmaskSelector,
		    blockSelector: getOption(block, [".sentry-block", "[data-sentry-block]", ...defaultBlockedElements]),
		    unblockSelector: getOption(unblock, []),
		    ignoreSelector: getOption(ignore, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'])
		  };
		  return options;
		}

		function maskAttribute({
		  el,
		  key,
		  maskAttributes,
		  maskAllText,
		  privacyOptions,
		  value
		}) {
		  if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) {
		    return value;
		  }
		  const masksNamedAttribute = maskAttributes.includes(key);
		  const masksSubmitButtonValue = maskAllText && key === "value" && el.tagName === "INPUT" && ["submit", "button"].includes(el.getAttribute("type") || "");
		  if (masksNamedAttribute || masksSubmitButtonValue) {
		    return value.replace(/[\S]/g, "*");
		  }
		  return value;
		}

		const MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
		const DEFAULT_NETWORK_HEADERS = ["content-length", "content-type", "accept"];
		const ORIGINAL_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
		let _initialized = false;
		let _isRequestInstrumented = false;
		function _INTERNAL_instrumentRequestInterface() {
		  if (typeof Request === "undefined" || _isRequestInstrumented) {
		    return;
		  }
		  const OriginalRequest = Request;
		  try {
		    const SentryRequest = function(input, init) {
		      const request = new OriginalRequest(input, init);
		      if (init?.body != null) {
		        request[ORIGINAL_BODY] = init.body;
		      }
		      return request;
		    };
		    SentryRequest.prototype = OriginalRequest.prototype;
		    core.GLOBAL_OBJ.Request = SentryRequest;
		    _isRequestInstrumented = true;
		  } catch {
		  }
		}
		const replayIntegration = ((options) => {
		  return new Replay(options);
		});
		class Replay {
		  constructor({
		    flushMinDelay = DEFAULT_FLUSH_MIN_DELAY,
		    flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY,
		    minReplayDuration = MIN_REPLAY_DURATION,
		    maxReplayDuration = MAX_REPLAY_DURATION,
		    stickySession = true,
		    useCompression = true,
		    workerUrl,
		    _experiments = {},
		    maskAllText = true,
		    maskAllInputs = true,
		    blockAllMedia = true,
		    mutationBreadcrumbLimit = 750,
		    mutationLimit = 1e4,
		    slowClickTimeout = 7e3,
		    slowClickIgnoreSelectors = [],
		    networkDetailAllowUrls = [],
		    networkDetailDenyUrls = [],
		    networkCaptureBodies = true,
		    networkRequestHeaders = [],
		    networkResponseHeaders = [],
		    mask = [],
		    maskAttributes = ["title", "placeholder", "aria-label"],
		    unmask = [],
		    block = [],
		    unblock = [],
		    ignore = [],
		    maskFn,
		    beforeAddRecordingEvent,
		    beforeErrorSampling,
		    onError,
		    attachRawBodyFromRequest = false
		  } = {}) {
		    this.name = "Replay";
		    const privacyOptions = getPrivacyOptions({
		      mask,
		      unmask,
		      block,
		      unblock,
		      ignore
		    });
		    this._recordingOptions = {
		      maskAllInputs,
		      maskAllText,
		      maskInputOptions: { password: true },
		      maskTextFn: maskFn,
		      maskInputFn: maskFn,
		      maskAttributeFn: (key, value, el) => maskAttribute({
		        maskAttributes,
		        maskAllText,
		        privacyOptions,
		        key,
		        value,
		        el
		      }),
		      ...privacyOptions,
		      // Our defaults
		      slimDOMOptions: "all",
		      inlineStylesheet: true,
		      // Disable inline images as it will increase segment/replay size
		      inlineImages: false,
		      // collect fonts, but be aware that `sentry.io` needs to be an allowed
		      // origin for playback
		      collectFonts: true,
		      errorHandler: (err) => {
		        try {
		          err.__rrweb__ = true;
		        } catch {
		        }
		      },
		      // experimental support for recording iframes from different origins
		      recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
		    };
		    this._initialOptions = {
		      flushMinDelay,
		      flushMaxDelay,
		      minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
		      maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
		      stickySession,
		      useCompression,
		      workerUrl,
		      blockAllMedia,
		      maskAllInputs,
		      maskAllText,
		      mutationBreadcrumbLimit,
		      mutationLimit,
		      slowClickTimeout,
		      slowClickIgnoreSelectors,
		      networkDetailAllowUrls,
		      networkDetailDenyUrls,
		      networkCaptureBodies,
		      networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
		      networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
		      beforeAddRecordingEvent,
		      beforeErrorSampling,
		      onError,
		      attachRawBodyFromRequest,
		      _experiments
		    };
		    if (this._initialOptions.blockAllMedia) {
		      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
		      this._recordingOptions.ignoreCSSAttributes = /* @__PURE__ */ new Set(["background-image"]);
		    }
		    if (this._isInitialized && core.isBrowser()) {
		      throw new Error("Multiple Sentry Session Replay instances are not supported");
		    }
		    this._isInitialized = true;
		  }
		  /** If replay has already been initialized */
		  get _isInitialized() {
		    return _initialized;
		  }
		  /** Update _isInitialized */
		  set _isInitialized(value) {
		    _initialized = value;
		  }
		  /**
		   * Setup and initialize replay container
		   */
		  afterAllSetup(client) {
		    if (!core.isBrowser() || this._replay) {
		      return;
		    }
		    if (this._initialOptions.attachRawBodyFromRequest) {
		      _INTERNAL_instrumentRequestInterface();
		    }
		    this._setup(client);
		    this._initialize(client);
		  }
		  /**
		   * Start a replay regardless of sampling rate. Calling this will always
		   * create a new session. Will log a message if replay is already in progress.
		   *
		   * Creates or loads a session, attaches listeners to varying events (DOM,
		   * PerformanceObserver, Recording, Sentry SDK, etc)
		   */
		  start() {
		    if (!this._replay) {
		      return;
		    }
		    this._replay.start();
		  }
		  /**
		   * Start replay buffering. Buffers until `flush()` is called or, if
		   * `replaysOnErrorSampleRate` > 0, until an error occurs.
		   */
		  startBuffering() {
		    if (!this._replay) {
		      return;
		    }
		    this._replay.startBuffering();
		  }
		  /**
		   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
		   * does not support a teardown
		   */
		  stop() {
		    if (!this._replay) {
		      return Promise.resolve();
		    }
		    return this._replay.stop({ forceFlush: this._replay.recordingMode === "session", reason: "manual" });
		  }
		  /**
		   * If not in "session" recording mode, flush event buffer which will create a new replay.
		   * If replay is not enabled, a new session replay is started.
		   * Unless `continueRecording` is false, the replay will continue to record and
		   * behave as a "session"-based replay.
		   *
		   * Otherwise, queue up a flush.
		   */
		  flush(options) {
		    if (!this._replay) {
		      return Promise.resolve();
		    }
		    if (!this._replay.isEnabled()) {
		      this._replay.start();
		      return Promise.resolve();
		    }
		    return this._replay.sendBufferedReplayOrFlush(options);
		  }
		  /**
		   * Get the current session ID.
		   *
		   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
		   *
		   */
		  getReplayId(onlyIfSampled) {
		    if (!this._replay?.isEnabled()) {
		      return;
		    }
		    return this._replay.getSessionId(onlyIfSampled);
		  }
		  /**
		   * Get the current recording mode. This can be either `session` or `buffer`.
		   *
		   * `session`: Recording the whole session, sending it continuously
		   * `buffer`: Always keeping the last 60s of recording, requires:
		   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
		   *   - or calling `flush()` to send the replay
		   */
		  getRecordingMode() {
		    if (!this._replay?.isEnabled()) {
		      return;
		    }
		    return this._replay.recordingMode;
		  }
		  processSpan(span) {
		    const replayId = this.getReplayId(true);
		    if (replayId) {
		      core.safeSetSpanJSONAttributes(span, { "sentry.replay_id": replayId });
		      if (this.getRecordingMode() === "buffer") {
		        core.safeSetSpanJSONAttributes(span, { "sentry._internal.replay_is_buffering": true });
		      }
		    }
		  }
		  /**
		   * Initializes replay.
		   */
		  _initialize(client) {
		    if (!this._replay) {
		      return;
		    }
		    this._maybeLoadFromReplayCanvasIntegration(client);
		    this._replay.initializeSampling();
		  }
		  /** Setup the integration. */
		  _setup(client) {
		    const finalOptions = loadReplayOptionsFromClient(this._initialOptions, client);
		    this._replay = new ReplayContainer({
		      options: finalOptions,
		      recordingOptions: this._recordingOptions
		    });
		  }
		  /** Get canvas options from ReplayCanvas integration, if it is also added. */
		  _maybeLoadFromReplayCanvasIntegration(client) {
		    try {
		      const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
		      if (!canvasIntegration) {
		        return;
		      }
		      this._replay["_canvas"] = canvasIntegration.getOptions();
		    } catch {
		    }
		  }
		}
		function loadReplayOptionsFromClient(initialOptions, client) {
		  const opt = client.getOptions();
		  const finalOptions = {
		    sessionSampleRate: 0,
		    errorSampleRate: 0,
		    ...initialOptions
		  };
		  const replaysSessionSampleRate = core.parseSampleRate(opt.replaysSessionSampleRate);
		  const replaysOnErrorSampleRate = core.parseSampleRate(opt.replaysOnErrorSampleRate);
		  if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) {
		    core.consoleSandbox(() => {
		      console.warn(
		        "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
		      );
		    });
		  }
		  if (replaysSessionSampleRate != null) {
		    finalOptions.sessionSampleRate = replaysSessionSampleRate;
		  }
		  if (replaysOnErrorSampleRate != null) {
		    finalOptions.errorSampleRate = replaysOnErrorSampleRate;
		  }
		  return finalOptions;
		}
		function _getMergedNetworkHeaders(headers) {
		  return [...DEFAULT_NETWORK_HEADERS, ...headers.map((header) => header.toLowerCase())];
		}

		function getReplay() {
		  const client = core.getClient();
		  return client?.getIntegrationByName("Replay");
		}

		exports.getReplay = getReplay;
		exports.replayIntegration = replayIntegration;
		
	} (cjs$1));
	return cjs$1;
}

var cjs = {};

var hasRequiredCjs;

function requireCjs () {
	if (hasRequiredCjs) return cjs;
	hasRequiredCjs = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();

		var __defProp = Object.defineProperty;
		var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
		var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
		class Mirror {
		  constructor() {
		    __publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
		    __publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
		  }
		  getId(n) {
		    if (!n) return -1;
		    const id = this.getMeta(n)?.id;
		    return id ?? -1;
		  }
		  getNode(id) {
		    return this.idNodeMap.get(id) || null;
		  }
		  getIds() {
		    return Array.from(this.idNodeMap.keys());
		  }
		  getMeta(n) {
		    return this.nodeMetaMap.get(n) || null;
		  }
		  // removes the node from idNodeMap
		  // doesn't remove the node from nodeMetaMap
		  removeNodeFromMap(n) {
		    const id = this.getId(n);
		    this.idNodeMap.delete(id);
		    if (n.childNodes) {
		      n.childNodes.forEach(
		        (childNode) => this.removeNodeFromMap(childNode)
		      );
		    }
		  }
		  has(id) {
		    return this.idNodeMap.has(id);
		  }
		  hasNode(node) {
		    return this.nodeMetaMap.has(node);
		  }
		  add(n, meta) {
		    const id = meta.id;
		    this.idNodeMap.set(id, n);
		    this.nodeMetaMap.set(n, meta);
		  }
		  replace(id, n) {
		    const oldNode = this.getNode(id);
		    if (oldNode) {
		      const meta = this.nodeMetaMap.get(oldNode);
		      if (meta) this.nodeMetaMap.set(n, meta);
		    }
		    this.idNodeMap.set(id, n);
		  }
		  reset() {
		    this.idNodeMap = /* @__PURE__ */ new Map();
		    this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
		  }
		}
		function createMirror() {
		  return new Mirror();
		}
		function elementClassMatchesRegex(el, regex) {
		  for (let eIndex = el.classList.length; eIndex--; ) {
		    const className = el.classList[eIndex];
		    if (regex.test(className)) {
		      return true;
		    }
		  }
		  return false;
		}
		function distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
		  if (!node) return -1;
		  if (node.nodeType !== node.ELEMENT_NODE) return -1;
		  if (distance > limit) return -1;
		  if (matchPredicate(node)) return distance;
		  return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
		}
		function createMatchPredicate(className, selector) {
		  return (node) => {
		    const el = node;
		    if (el === null) return false;
		    try {
		      if (className) {
		        if (typeof className === "string") {
		          if (el.matches(`.${className}`)) return true;
		        } else if (elementClassMatchesRegex(el, className)) {
		          return true;
		        }
		      }
		      if (selector && el.matches(selector)) return true;
		      return false;
		    } catch {
		      return false;
		    }
		  };
		}
		const DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
		let _mirror = {
		  map: {},
		  getId() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		    return -1;
		  },
		  getNode() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		    return null;
		  },
		  removeNodeFromMap() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		  },
		  has() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		    return false;
		  },
		  reset() {
		    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		  }
		};
		if (typeof window !== "undefined" && window.Proxy && window.Reflect) {
		  _mirror = new Proxy(_mirror, {
		    get(target, prop, receiver) {
		      if (prop === "map") {
		        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
		      }
		      return Reflect.get(target, prop, receiver);
		    }
		  });
		}
		function hookSetter(target, key, d, isRevoked, win = window) {
		  const original = win.Object.getOwnPropertyDescriptor(target, key);
		  win.Object.defineProperty(
		    target,
		    key,
		    isRevoked ? d : {
		      set(value) {
		        setTimeout(() => {
		          d.set.call(this, value);
		        }, 0);
		        if (original && original.set) {
		          original.set.call(this, value);
		        }
		      }
		    }
		  );
		  return () => hookSetter(target, key, original || {}, true);
		}
		function patch(source, name, replacement) {
		  try {
		    if (!(name in source)) {
		      return () => {
		      };
		    }
		    const original = source[name];
		    const wrapped = replacement(original);
		    if (typeof wrapped === "function") {
		      wrapped.prototype = wrapped.prototype || {};
		      Object.defineProperties(wrapped, {
		        __rrweb_original__: {
		          enumerable: false,
		          value: original
		        }
		      });
		    }
		    source[name] = wrapped;
		    return () => {
		      source[name] = original;
		    };
		  } catch {
		    return () => {
		    };
		  }
		}
		if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) ;
		function closestElementOfNode(node) {
		  if (!node) {
		    return null;
		  }
		  try {
		    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
		    return el;
		  } catch (error) {
		    return null;
		  }
		}
		function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
		  if (!node) {
		    return false;
		  }
		  const el = closestElementOfNode(node);
		  if (!el) {
		    return false;
		  }
		  const blockedPredicate = createMatchPredicate(blockClass, blockSelector);
		  const blockDistance = distanceToMatch(el, blockedPredicate);
		  let unblockDistance = -1;
		  if (blockDistance < 0) {
		    return false;
		  }
		  if (unblockSelector) {
		    unblockDistance = distanceToMatch(
		      el,
		      createMatchPredicate(null, unblockSelector)
		    );
		  }
		  if (blockDistance > -1 && unblockDistance < 0) {
		    return true;
		  }
		  return blockDistance < unblockDistance;
		}
		const cachedImplementations = {};
		function getImplementation(name) {
		  const cached = cachedImplementations[name];
		  if (cached) {
		    return cached;
		  }
		  const document2 = window.document;
		  let impl = window[name];
		  if (document2 && typeof document2.createElement === "function") {
		    try {
		      const sandbox = document2.createElement("iframe");
		      sandbox.hidden = true;
		      document2.head.appendChild(sandbox);
		      const contentWindow = sandbox.contentWindow;
		      if (contentWindow && contentWindow[name]) {
		        impl = // eslint-disable-next-line @typescript-eslint/unbound-method
		        contentWindow[name];
		      }
		      document2.head.removeChild(sandbox);
		    } catch (e) {
		    }
		  }
		  return cachedImplementations[name] = impl.bind(
		    window
		  );
		}
		function onRequestAnimationFrame(...rest) {
		  return getImplementation("requestAnimationFrame")(...rest);
		}
		function setTimeout(...rest) {
		  return getImplementation("setTimeout")(...rest);
		}
		var CanvasContext = /* @__PURE__ */ ((CanvasContext2) => {
		  CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
		  CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
		  CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
		  return CanvasContext2;
		})(CanvasContext || {});
		let errorHandler;
		function registerErrorHandler(handler) {
		  errorHandler = handler;
		}
		const callbackWrapper = (cb) => {
		  if (!errorHandler) {
		    return cb;
		  }
		  const rrwebWrapped = ((...rest) => {
		    try {
		      return cb(...rest);
		    } catch (error) {
		      if (errorHandler && errorHandler(error) === true) {
		        return () => {
		        };
		      }
		      throw error;
		    }
		  });
		  return rrwebWrapped;
		};
		var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
		var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
		for (var i = 0; i < chars.length; i++) {
		  lookup[chars.charCodeAt(i)] = i;
		}
		var encode = function(arraybuffer) {
		  var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
		  for (i2 = 0; i2 < len; i2 += 3) {
		    base64 += chars[bytes[i2] >> 2];
		    base64 += chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
		    base64 += chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
		    base64 += chars[bytes[i2 + 2] & 63];
		  }
		  if (len % 3 === 2) {
		    base64 = base64.substring(0, base64.length - 1) + "=";
		  } else if (len % 3 === 1) {
		    base64 = base64.substring(0, base64.length - 2) + "==";
		  }
		  return base64;
		};
		const canvasVarMap = /* @__PURE__ */ new Map();
		function variableListFor(ctx, ctor) {
		  let contextMap = canvasVarMap.get(ctx);
		  if (!contextMap) {
		    contextMap = /* @__PURE__ */ new Map();
		    canvasVarMap.set(ctx, contextMap);
		  }
		  if (!contextMap.has(ctor)) {
		    contextMap.set(ctor, []);
		  }
		  return contextMap.get(ctor);
		}
		const saveWebGLVar = (value, win, ctx) => {
		  if (!value || !(isInstanceOfWebGLObject(value, win) || typeof value === "object"))
		    return;
		  const name = value.constructor.name;
		  const list = variableListFor(ctx, name);
		  let index = list.indexOf(value);
		  if (index === -1) {
		    index = list.length;
		    list.push(value);
		  }
		  return index;
		};
		function serializeArg(value, win, ctx) {
		  if (value instanceof Array) {
		    return value.map((arg) => serializeArg(arg, win, ctx));
		  } else if (value === null) {
		    return value;
		  } else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
		    const name = value.constructor.name;
		    return {
		      rr_type: name,
		      args: [Object.values(value)]
		    };
		  } else if (
		    // SharedArrayBuffer disabled on most browsers due to spectre.
		    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
		    // value instanceof SharedArrayBuffer ||
		    value instanceof ArrayBuffer
		  ) {
		    const name = value.constructor.name;
		    const base64 = encode(value);
		    return {
		      rr_type: name,
		      base64
		    };
		  } else if (value instanceof DataView) {
		    const name = value.constructor.name;
		    return {
		      rr_type: name,
		      args: [
		        serializeArg(value.buffer, win, ctx),
		        value.byteOffset,
		        value.byteLength
		      ]
		    };
		  } else if (value instanceof HTMLImageElement) {
		    const name = value.constructor.name;
		    const { src } = value;
		    return {
		      rr_type: name,
		      src
		    };
		  } else if (value instanceof HTMLCanvasElement) {
		    const name = "HTMLImageElement";
		    const src = value.toDataURL();
		    return {
		      rr_type: name,
		      src
		    };
		  } else if (value instanceof ImageData) {
		    const name = value.constructor.name;
		    return {
		      rr_type: name,
		      args: [serializeArg(value.data, win, ctx), value.width, value.height]
		    };
		  } else if (isInstanceOfWebGLObject(value, win) || typeof value === "object") {
		    const name = value.constructor.name;
		    const index = saveWebGLVar(value, win, ctx);
		    return {
		      rr_type: name,
		      index
		    };
		  }
		  return value;
		}
		const serializeArgs = (args, win, ctx) => {
		  return args.map((arg) => serializeArg(arg, win, ctx));
		};
		const isInstanceOfWebGLObject = (value, win) => {
		  const webGLConstructorNames = [
		    "WebGLActiveInfo",
		    "WebGLBuffer",
		    "WebGLFramebuffer",
		    "WebGLProgram",
		    "WebGLRenderbuffer",
		    "WebGLShader",
		    "WebGLShaderPrecisionFormat",
		    "WebGLTexture",
		    "WebGLUniformLocation",
		    "WebGLVertexArrayObject",
		    // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
		    "WebGLVertexArrayObjectOES"
		  ];
		  const supportedWebGLConstructorNames = webGLConstructorNames.filter(
		    (name) => typeof win[name] === "function"
		  );
		  return Boolean(
		    supportedWebGLConstructorNames.find(
		      (name) => value instanceof win[name]
		    )
		  );
		};
		function initCanvas2DMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector) {
		  const handlers = [];
		  const props2D = Object.getOwnPropertyNames(
		    win.CanvasRenderingContext2D.prototype
		  );
		  for (const prop of props2D) {
		    try {
		      if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") {
		        continue;
		      }
		      const restoreHandler = patch(
		        win.CanvasRenderingContext2D.prototype,
		        prop,
		        function(original) {
		          return function(...args) {
		            if (!isBlocked(
		              this.canvas,
		              blockClass2,
		              blockSelector,
		              unblockSelector,
		              true
		            )) {
		              setTimeout(() => {
		                const recordArgs = serializeArgs(args, win, this);
		                cb(this.canvas, {
		                  type: CanvasContext["2D"],
		                  property: prop,
		                  args: recordArgs
		                });
		              }, 0);
		            }
		            return original.apply(this, args);
		          };
		        }
		      );
		      handlers.push(restoreHandler);
		    } catch {
		      const hookHandler = hookSetter(
		        win.CanvasRenderingContext2D.prototype,
		        prop,
		        {
		          set(v) {
		            cb(this.canvas, {
		              type: CanvasContext["2D"],
		              property: prop,
		              args: [v],
		              setter: true
		            });
		          }
		        }
		      );
		      handlers.push(hookHandler);
		    }
		  }
		  return () => {
		    handlers.forEach((h) => h());
		  };
		}
		function getNormalizedContextName(contextType) {
		  return contextType === "experimental-webgl" ? "webgl" : contextType;
		}
		function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
		  const handlers = [];
		  try {
		    const restoreHandler = patch(
		      win.HTMLCanvasElement.prototype,
		      "getContext",
		      function(original) {
		        return function(contextType, ...args) {
		          if (!isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
		            const ctxName = getNormalizedContextName(contextType);
		            if (!("__context" in this)) this.__context = ctxName;
		            if (setPreserveDrawingBufferToTrue && ["webgl", "webgl2"].includes(ctxName)) {
		              if (args[0] && typeof args[0] === "object") {
		                const contextAttributes = args[0];
		                if (!contextAttributes.preserveDrawingBuffer) {
		                  contextAttributes.preserveDrawingBuffer = true;
		                }
		              } else {
		                args.splice(0, 1, {
		                  preserveDrawingBuffer: true
		                });
		              }
		            }
		          }
		          return original.apply(this, [contextType, ...args]);
		        };
		      }
		    );
		    handlers.push(restoreHandler);
		  } catch {
		    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
		  }
		  return () => {
		    handlers.forEach((h) => h());
		  };
		}
		function patchGLPrototype(prototype, type, cb, blockClass2, blockSelector, unblockSelector, _mirror2, win) {
		  const handlers = [];
		  const props = Object.getOwnPropertyNames(prototype);
		  for (const prop of props) {
		    if (
		      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
		      [
		        "isContextLost",
		        "canvas",
		        "drawingBufferWidth",
		        "drawingBufferHeight"
		      ].includes(prop)
		    ) {
		      continue;
		    }
		    try {
		      if (typeof prototype[prop] !== "function") {
		        continue;
		      }
		      const restoreHandler = patch(
		        prototype,
		        prop,
		        function(original) {
		          return function(...args) {
		            const result = original.apply(this, args);
		            saveWebGLVar(result, win, this);
		            if ("tagName" in this.canvas && !isBlocked(
		              this.canvas,
		              blockClass2,
		              blockSelector,
		              unblockSelector,
		              true
		            )) {
		              const recordArgs = serializeArgs(args, win, this);
		              const mutation = {
		                type,
		                property: prop,
		                args: recordArgs
		              };
		              cb(this.canvas, mutation);
		            }
		            return result;
		          };
		        }
		      );
		      handlers.push(restoreHandler);
		    } catch {
		      const hookHandler = hookSetter(prototype, prop, {
		        set(v) {
		          cb(this.canvas, {
		            type,
		            property: prop,
		            args: [v],
		            setter: true
		          });
		        }
		      });
		      handlers.push(hookHandler);
		    }
		  }
		  return handlers;
		}
		function initCanvasWebGLMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector, mirror) {
		  const handlers = [];
		  handlers.push(
		    ...patchGLPrototype(
		      win.WebGLRenderingContext.prototype,
		      CanvasContext.WebGL,
		      cb,
		      blockClass2,
		      blockSelector,
		      unblockSelector,
		      mirror,
		      win
		    )
		  );
		  if (typeof win.WebGL2RenderingContext !== "undefined") {
		    handlers.push(
		      ...patchGLPrototype(
		        win.WebGL2RenderingContext.prototype,
		        CanvasContext.WebGL2,
		        cb,
		        blockClass2,
		        blockSelector,
		        unblockSelector,
		        mirror,
		        win
		      )
		    );
		  }
		  return () => {
		    handlers.forEach((h) => h());
		  };
		}
		const r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w?.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
		function t() {
		  const t2 = new Blob([r]);
		  return URL.createObjectURL(t2);
		}
		class CanvasManager {
		  constructor(options) {
		    this.pendingCanvasMutations = /* @__PURE__ */ new Map();
		    this.rafStamps = { latestId: 0, invokeId: null };
		    this.shadowDoms = /* @__PURE__ */ new Set();
		    this.windowsSet = /* @__PURE__ */ new WeakSet();
		    this.windows = [];
		    this.restoreHandlers = [];
		    this.frozen = false;
		    this.locked = false;
		    this.snapshotInProgressMap = /* @__PURE__ */ new Map();
		    this.worker = null;
		    this.lastSnapshotTime = 0;
		    this.processMutation = (target, mutation) => {
		      const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
		      if (newFrame || !this.rafStamps.invokeId)
		        this.rafStamps.invokeId = this.rafStamps.latestId;
		      if (!this.pendingCanvasMutations.has(target)) {
		        this.pendingCanvasMutations.set(target, []);
		      }
		      this.pendingCanvasMutations.get(target).push(mutation);
		    };
		    const {
		      enableManualSnapshot,
		      sampling = "all",
		      win,
		      recordCanvas,
		      errorHandler: errorHandler2
		    } = options;
		    options.sampling = sampling;
		    this.mutationCb = options.mutationCb;
		    this.mirror = options.mirror;
		    this.options = options;
		    if (errorHandler2) {
		      registerErrorHandler(errorHandler2);
		    }
		    if (recordCanvas && typeof sampling === "number" || enableManualSnapshot) {
		      this.worker = this.initFPSWorker();
		    }
		    this.addWindow(win);
		    if (enableManualSnapshot) {
		      return;
		    }
		    callbackWrapper(() => {
		      if (recordCanvas && sampling === "all") {
		        this.startRAFTimestamping();
		        this.startPendingCanvasMutationFlusher();
		      }
		      if (recordCanvas && typeof sampling === "number") {
		        this.initCanvasFPSObserver();
		      }
		    })();
		  }
		  reset() {
		    this.pendingCanvasMutations.clear();
		    this.restoreHandlers.forEach((handler) => {
		      try {
		        handler();
		      } catch (e) {
		      }
		    });
		    this.restoreHandlers = [];
		    this.windowsSet = /* @__PURE__ */ new WeakSet();
		    this.windows = [];
		    this.shadowDoms = /* @__PURE__ */ new Set();
		    this.worker?.terminate();
		    this.worker = null;
		    this.snapshotInProgressMap = /* @__PURE__ */ new Map();
		  }
		  freeze() {
		    this.frozen = true;
		  }
		  unfreeze() {
		    this.frozen = false;
		  }
		  lock() {
		    this.locked = true;
		  }
		  unlock() {
		    this.locked = false;
		  }
		  addWindow(win) {
		    const {
		      sampling = "all",
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      recordCanvas,
		      enableManualSnapshot
		    } = this.options;
		    if (this.windowsSet.has(win)) return;
		    if (enableManualSnapshot) {
		      this.windowsSet.add(win);
		      this.windows.push(new WeakRef(win));
		      return;
		    }
		    callbackWrapper(() => {
		      if (recordCanvas && sampling === "all") {
		        this.initCanvasMutationObserver(
		          win,
		          blockClass,
		          blockSelector,
		          unblockSelector
		        );
		      }
		      if (recordCanvas && typeof sampling === "number") {
		        const canvasContextReset = initCanvasContextObserver(
		          win,
		          blockClass,
		          blockSelector,
		          unblockSelector,
		          true
		        );
		        this.restoreHandlers.push(() => {
		          canvasContextReset();
		        });
		      }
		    })();
		    this.windowsSet.add(win);
		    this.windows.push(new WeakRef(win));
		  }
		  addShadowRoot(shadowRoot) {
		    this.shadowDoms.add(new WeakRef(shadowRoot));
		  }
		  resetShadowRoots() {
		    this.shadowDoms = /* @__PURE__ */ new Set();
		  }
		  snapshot(canvasElement, options) {
		    if (options?.skipRequestAnimationFrame) {
		      this.takeSnapshot(performance.now(), true, canvasElement);
		      return;
		    }
		    onRequestAnimationFrame(
		      (timestamp) => this.takeSnapshot(timestamp, true, canvasElement)
		    );
		  }
		  initFPSWorker() {
		    const worker = new Worker(t());
		    worker.onmessage = (e) => {
		      const data = e.data;
		      const { id } = data;
		      this.snapshotInProgressMap.set(id, false);
		      if (!("base64" in data)) return;
		      const { base64, type, width, height } = data;
		      this.mutationCb({
		        id,
		        type: CanvasContext["2D"],
		        commands: [
		          {
		            property: "clearRect",
		            // wipe canvas
		            args: [0, 0, width, height]
		          },
		          {
		            property: "drawImage",
		            // draws (semi-transparent) image
		            args: [
		              {
		                rr_type: "ImageBitmap",
		                args: [
		                  {
		                    rr_type: "Blob",
		                    data: [{ rr_type: "ArrayBuffer", base64 }],
		                    type
		                  }
		                ]
		              },
		              0,
		              0,
		              // The below args are needed if we enforce a max size, we want to
		              // retain the original size when drawing the image (which should be smaller)
		              width,
		              height
		            ]
		          }
		        ]
		      });
		    };
		    return worker;
		  }
		  initCanvasFPSObserver() {
		    let rafId;
		    if (!this.windows.length && !this.shadowDoms.size) {
		      return;
		    }
		    const rafCallback = (timestamp) => {
		      this.takeSnapshot(timestamp, false);
		      rafId = onRequestAnimationFrame(rafCallback);
		    };
		    rafId = onRequestAnimationFrame(rafCallback);
		    this.restoreHandlers.push(() => {
		      if (rafId) {
		        cancelAnimationFrame(rafId);
		      }
		    });
		  }
		  initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
		    const canvasContextReset = initCanvasContextObserver(
		      win,
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      false
		    );
		    const canvas2DReset = initCanvas2DMutationObserver(
		      this.processMutation.bind(this),
		      win,
		      blockClass,
		      blockSelector,
		      unblockSelector
		    );
		    const canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(
		      this.processMutation.bind(this),
		      win,
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      this.mirror
		    );
		    this.restoreHandlers.push(() => {
		      canvasContextReset();
		      canvas2DReset();
		      canvasWebGL1and2Reset();
		    });
		  }
		  /**
		   * Returns all `canvas` elements that are not blocked by the given selectors. Searches all windows and shadow roots.
		   */
		  getCanvasElements(blockClass, blockSelector, unblockSelector) {
		    const matchedCanvas = [];
		    const searchCanvas = (root) => {
		      root.querySelectorAll("canvas").forEach((canvas) => {
		        if (!isBlocked(canvas, blockClass, blockSelector, unblockSelector)) {
		          matchedCanvas.push(canvas);
		        }
		      });
		    };
		    for (const item of this.windows) {
		      const window2 = item.deref();
		      let _document;
		      try {
		        _document = window2 && window2.document;
		      } catch {
		      }
		      if (_document) {
		        searchCanvas(_document);
		      }
		    }
		    for (const item of this.shadowDoms) {
		      const shadowRoot = item.deref();
		      if (shadowRoot) {
		        searchCanvas(shadowRoot);
		      }
		    }
		    return matchedCanvas;
		  }
		  /**
		   * Takes a snapshot of the provided canvas element, or will search all windows/shadow roots for canvases. Will self-throttle based on `options.sampling`.
		   *
		   * @returns `true` if the snapshot was taken, `false` if it was throttled.
		   */
		  takeSnapshot(timestamp, isManualSnapshot, canvasElement) {
		    const {
		      sampling,
		      blockClass,
		      blockSelector,
		      unblockSelector,
		      dataURLOptions,
		      maxCanvasSize
		    } = this.options;
		    const fps = sampling === "all" ? 2 : sampling || 2;
		    const timeBetweenSnapshots = 1e3 / fps;
		    const shouldThrottle = this.lastSnapshotTime && timestamp - this.lastSnapshotTime < timeBetweenSnapshots;
		    if (shouldThrottle) {
		      return false;
		    }
		    this.lastSnapshotTime = timestamp;
		    const canvases = canvasElement ? [canvasElement] : this.getCanvasElements(blockClass, blockSelector, unblockSelector);
		    canvases.forEach((canvas) => {
		      const id = this.mirror.getId(canvas);
		      if (!this.mirror.hasNode(canvas) || !canvas.width || !canvas.height || this.snapshotInProgressMap.get(id)) {
		        return;
		      }
		      this.snapshotInProgressMap.set(id, true);
		      if (!isManualSnapshot && ["webgl", "webgl2"].includes(canvas.__context)) {
		        const context = canvas.getContext(canvas.__context);
		        if (context?.getContextAttributes()?.preserveDrawingBuffer === false) {
		          context.clear(context.COLOR_BUFFER_BIT);
		        }
		      }
		      createImageBitmap(canvas).then((bitmap) => {
		        this.worker?.postMessage(
		          {
		            id,
		            bitmap,
		            width: canvas.width,
		            height: canvas.height,
		            dataURLOptions,
		            maxCanvasSize
		          },
		          [bitmap]
		        );
		      }).catch((error) => {
		        callbackWrapper(() => {
		          this.snapshotInProgressMap.delete(id);
		          throw error;
		        })();
		      });
		    });
		    return true;
		  }
		  startPendingCanvasMutationFlusher() {
		    onRequestAnimationFrame(() => this.flushPendingCanvasMutations());
		  }
		  startRAFTimestamping() {
		    const setLatestRAFTimestamp = (timestamp) => {
		      this.rafStamps.latestId = timestamp;
		      onRequestAnimationFrame(setLatestRAFTimestamp);
		    };
		    onRequestAnimationFrame(setLatestRAFTimestamp);
		  }
		  flushPendingCanvasMutations() {
		    this.pendingCanvasMutations.forEach(
		      (_values, canvas) => {
		        const id = this.mirror.getId(canvas);
		        this.flushPendingCanvasMutationFor(canvas, id);
		      }
		    );
		    onRequestAnimationFrame(() => this.flushPendingCanvasMutations());
		  }
		  flushPendingCanvasMutationFor(canvas, id) {
		    if (this.frozen || this.locked) {
		      return;
		    }
		    const valuesWithType = this.pendingCanvasMutations.get(canvas);
		    if (!valuesWithType || id === -1) return;
		    const values = valuesWithType.map((value) => {
		      const { type: type2, ...rest } = value;
		      return rest;
		    });
		    const { type } = valuesWithType[0];
		    this.mutationCb({ id, type, commands: values });
		    this.pendingCanvasMutations.delete(canvas);
		  }
		}

		try {
		  if (Array.from([1], (x) => x * 2)[0] !== 2) {
		    const cleanFrame = document.createElement("iframe");
		    document.body.appendChild(cleanFrame);
		    Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
		    document.body.removeChild(cleanFrame);
		  }
		} catch (err) {
		  console.debug("Unable to override Array.from", err);
		}
		createMirror();
		var n;
		!(function(t2) {
		  t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
		})(n || (n = {}));

		const CANVAS_QUALITY = {
		  low: {
		    sampling: {
		      canvas: 1
		    },
		    dataURLOptions: {
		      type: "image/webp",
		      quality: 0.25
		    }
		  },
		  medium: {
		    sampling: {
		      canvas: 2
		    },
		    dataURLOptions: {
		      type: "image/webp",
		      quality: 0.4
		    }
		  },
		  high: {
		    sampling: {
		      canvas: 4
		    },
		    dataURLOptions: {
		      type: "image/webp",
		      quality: 0.5
		    }
		  }
		};
		const INTEGRATION_NAME = "ReplayCanvas";
		const DEFAULT_MAX_CANVAS_SIZE = 1280;
		const _replayCanvasIntegration = ((options = {}) => {
		  const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
		  const _canvasOptions = {
		    quality: options.quality || "medium",
		    enableManualSnapshot: options.enableManualSnapshot,
		    maxCanvasSize: [
		      maxCanvasWidth ? Math.min(maxCanvasWidth, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE,
		      maxCanvasHeight ? Math.min(maxCanvasHeight, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE
		    ]
		  };
		  let currentCanvasManager;
		  let canvasManagerResolve;
		  const _canvasManager = new Promise((resolve) => canvasManagerResolve = resolve);
		  return {
		    name: INTEGRATION_NAME,
		    getOptions() {
		      const { quality, enableManualSnapshot, maxCanvasSize } = _canvasOptions;
		      return {
		        enableManualSnapshot,
		        recordCanvas: true,
		        getCanvasManager: (getCanvasManagerOptions) => {
		          const manager = new CanvasManager({
		            ...getCanvasManagerOptions,
		            enableManualSnapshot,
		            maxCanvasSize,
		            errorHandler: (err) => {
		              try {
		                if (typeof err === "object") {
		                  err.__rrweb__ = true;
		                }
		              } catch {
		              }
		            }
		          });
		          currentCanvasManager = manager;
		          canvasManagerResolve(manager);
		          return manager;
		        },
		        ...CANVAS_QUALITY[quality] || CANVAS_QUALITY.medium
		      };
		    },
		    async snapshot(canvasElement, options2) {
		      const canvasManager = currentCanvasManager || await _canvasManager;
		      canvasManager.snapshot(canvasElement, options2);
		    }
		  };
		});
		const replayCanvasIntegration = core.defineIntegration(
		  _replayCanvasIntegration
		);

		exports.replayCanvasIntegration = replayCanvasIntegration;
		
	} (cjs));
	return cjs;
}

var request = {};

var utils$5 = {};

var hasRequiredUtils$5;

function requireUtils$5 () {
	if (hasRequiredUtils$5) return utils$5;
	hasRequiredUtils$5 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const helpers = /*@__PURE__*/ requireHelpers();

		function baggageHeaderHasSentryValues(baggageHeader) {
		  return baggageHeader.split(",").some((value) => value.trim().startsWith("sentry-"));
		}
		function getFullURL(url) {
		  try {
		    const parsed = new URL(url, helpers.WINDOW.location.origin);
		    return parsed.href;
		  } catch {
		    return void 0;
		  }
		}
		function isPerformanceResourceTiming(entry) {
		  return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
		}
		function createHeadersSafely(headers) {
		  try {
		    return new Headers(headers);
		  } catch {
		    return void 0;
		  }
		}

		exports.baggageHeaderHasSentryValues = baggageHeaderHasSentryValues;
		exports.createHeadersSafely = createHeadersSafely;
		exports.getFullURL = getFullURL;
		exports.isPerformanceResourceTiming = isPerformanceResourceTiming;
		
	} (utils$5));
	return utils$5;
}

var hasRequiredRequest;

function requireRequest () {
	if (hasRequiredRequest) return request;
	hasRequiredRequest = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();
		const utils = /*@__PURE__*/ requireUtils$5();

		const defaultRequestInstrumentationOptions = {
		  traceFetch: true,
		  traceXHR: true,
		  enableHTTPTimings: true,
		  trackFetchStreamPerformance: false
		};
		function instrumentOutgoingRequests(client, _options) {
		  const {
		    traceFetch,
		    traceXHR,
		    shouldCreateSpanForRequest,
		    enableHTTPTimings,
		    tracePropagationTargets,
		    onRequestSpanStart,
		    onRequestSpanEnd
		  } = {
		    ...defaultRequestInstrumentationOptions,
		    ..._options
		  };
		  const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_) => true;
		  const shouldAttachHeadersWithTargets = (url) => shouldAttachHeaders(url, tracePropagationTargets);
		  const spans = {};
		  const propagateTraceparent = client.getOptions().propagateTraceparent;
		  if (traceFetch) {
		    browser.addFetchInstrumentationHandler((handlerData) => {
		      const createdSpan = browser.instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
		        propagateTraceparent,
		        onRequestSpanEnd
		      });
		      if (createdSpan) {
		        const fullUrl = utils.getFullURL(handlerData.fetchData.url);
		        const host = fullUrl ? browser.parseUrl(fullUrl).host : void 0;
		        const sanitizedFullUrl = fullUrl ? browser.stripDataUrlContent(fullUrl) : void 0;
		        createdSpan.setAttributes({
		          "http.url": sanitizedFullUrl,
		          // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
		          // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
		          "url.full": sanitizedFullUrl,
		          "server.address": host
		        });
		        if (enableHTTPTimings) {
		          addHTTPTimings(createdSpan, client);
		        }
		        onRequestSpanStart?.(createdSpan, { headers: handlerData.headers });
		      }
		    });
		  }
		  if (traceXHR) {
		    browserUtils.addXhrInstrumentationHandler((handlerData) => {
		      const createdSpan = xhrCallback(
		        handlerData,
		        shouldCreateSpan,
		        shouldAttachHeadersWithTargets,
		        spans,
		        propagateTraceparent,
		        onRequestSpanEnd
		      );
		      if (createdSpan) {
		        if (enableHTTPTimings) {
		          addHTTPTimings(createdSpan, client);
		        }
		        onRequestSpanStart?.(createdSpan, {
		          headers: utils.createHeadersSafely(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
		        });
		      }
		    });
		  }
		}
		const HTTP_TIMING_WAIT_MS = 300;
		function addHTTPTimings(span, client) {
		  const { url } = browser.spanToJSON(span).data;
		  if (!url || typeof url !== "string") {
		    return;
		  }
		  let onEntryFound = () => void setTimeout(unsubscribePerformanceObsever);
		  if (browser.hasSpanStreamingEnabled(client)) {
		    const originalEnd = span.end.bind(span);
		    span.end = (endTimestamp) => {
		      const capturedEndTimestamp = endTimestamp ?? browser.timestampInSeconds();
		      let isEnded = false;
		      const endSpanAndCleanup = () => {
		        if (isEnded) {
		          return;
		        }
		        isEnded = true;
		        setTimeout(unsubscribePerformanceObsever);
		        originalEnd(capturedEndTimestamp);
		        clearTimeout(fallbackTimeout);
		      };
		      onEntryFound = endSpanAndCleanup;
		      const fallbackTimeout = setTimeout(endSpanAndCleanup, HTTP_TIMING_WAIT_MS);
		    };
		  }
		  const unsubscribePerformanceObsever = browserUtils.addPerformanceInstrumentationHandler("resource", ({ entries }) => {
		    entries.forEach((entry) => {
		      if (utils.isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
		        span.setAttributes(browserUtils.resourceTimingToSpanAttributes(entry));
		        onEntryFound();
		      }
		    });
		  });
		}
		function shouldAttachHeaders(targetUrl, tracePropagationTargets) {
		  const href = browser.getLocationHref();
		  if (!href) {
		    const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
		    if (!tracePropagationTargets) {
		      return isRelativeSameOriginRequest;
		    } else {
		      return browser.stringMatchesSomePattern(targetUrl, tracePropagationTargets);
		    }
		  } else {
		    let resolvedUrl;
		    let currentOrigin;
		    try {
		      resolvedUrl = new URL(targetUrl, href);
		      currentOrigin = new URL(href).origin;
		    } catch {
		      return false;
		    }
		    const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
		    if (!tracePropagationTargets) {
		      return isSameOriginRequest;
		    } else {
		      return browser.stringMatchesSomePattern(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && browser.stringMatchesSomePattern(resolvedUrl.pathname, tracePropagationTargets);
		    }
		  }
		}
		function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
		  const xhr = handlerData.xhr;
		  const sentryXhrData = xhr?.[browserUtils.SENTRY_XHR_DATA_KEY];
		  if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
		    return void 0;
		  }
		  const { url, method } = sentryXhrData;
		  const shouldCreateSpanResult = browser.hasSpansEnabled() && shouldCreateSpan(url);
		  if (handlerData.endTimestamp) {
		    const spanId = xhr.__sentry_xhr_span_id__;
		    if (!spanId) return;
		    const span2 = spans[spanId];
		    if (span2) {
		      if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
		        browser.setHttpStatus(span2, sentryXhrData.status_code);
		        span2.end();
		        onRequestSpanEnd?.(span2, {
		          headers: utils.createHeadersSafely(browserUtils.parseXhrResponseHeaders(xhr)),
		          error: handlerData.error
		        });
		      }
		      delete spans[spanId];
		    }
		    return void 0;
		  }
		  const fullUrl = utils.getFullURL(url);
		  const parsedUrl = fullUrl ? browser.parseUrl(fullUrl) : browser.parseUrl(url);
		  const sanitizedFullUrl = fullUrl ? browser.stripDataUrlContent(fullUrl) : void 0;
		  const urlForSpanName = browser.stripDataUrlContent(browser.stripUrlQueryAndFragment(url));
		  const client = browser.getClient();
		  const hasParent = !!browser.getActiveSpan();
		  const shouldEmitSpan = hasParent || !!client && browser.hasSpanStreamingEnabled(client);
		  const span = shouldCreateSpanResult && shouldEmitSpan ? browser.startInactiveSpan({
		    name: `${method} ${urlForSpanName}`,
		    attributes: {
		      url: browser.stripDataUrlContent(url),
		      type: "xhr",
		      "http.method": method,
		      "http.url": sanitizedFullUrl,
		      // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
		      // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
		      "url.full": sanitizedFullUrl,
		      "server.address": parsedUrl?.host,
		      [browser.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.http.browser",
		      [browser.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client",
		      ...parsedUrl?.search && { "http.query": parsedUrl?.search },
		      ...parsedUrl?.hash && { "http.fragment": parsedUrl?.hash }
		    }
		  }) : new browser.SentryNonRecordingSpan();
		  if (shouldCreateSpanResult && !shouldEmitSpan) {
		    client?.recordDroppedEvent("no_parent_span", "span");
		  }
		  xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
		  spans[xhr.__sentry_xhr_span_id__] = span;
		  if (shouldAttachHeaders2(url)) {
		    addTracingHeadersToXhrRequest(
		      xhr,
		      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
		      // we do not want to use the span as base for the trace headers,
		      // which means that the headers will be generated from the scope and the sampling decision is deferred
		      browser.hasSpansEnabled() && shouldEmitSpan ? span : void 0,
		      propagateTraceparent
		    );
		  }
		  if (client) {
		    client.emit("beforeOutgoingRequestSpan", span, handlerData);
		  }
		  return span;
		}
		function addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
		  const { "sentry-trace": sentryTrace, baggage, traceparent } = browser.getTraceData({ span, propagateTraceparent });
		  if (sentryTrace) {
		    setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
		  }
		}
		function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
		  const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
		  if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) {
		    return;
		  }
		  try {
		    xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
		    if (traceparentHeader && !originalHeaders?.["traceparent"]) {
		      xhr.setRequestHeader("traceparent", traceparentHeader);
		    }
		    if (sentryBaggageHeader) {
		      const originalBaggageHeader = originalHeaders?.["baggage"];
		      if (!originalBaggageHeader || !utils.baggageHeaderHasSentryValues(originalBaggageHeader)) {
		        xhr.setRequestHeader("baggage", sentryBaggageHeader);
		      }
		    }
		  } catch {
		  }
		}

		exports.defaultRequestInstrumentationOptions = defaultRequestInstrumentationOptions;
		exports.instrumentOutgoingRequests = instrumentOutgoingRequests;
		exports.shouldAttachHeaders = shouldAttachHeaders;
		
	} (request));
	return request;
}

var browserTracingIntegration = {};

var fetchStreamPerformance = {};

var hasRequiredFetchStreamPerformance;

function requireFetchStreamPerformance () {
	if (hasRequiredFetchStreamPerformance) return fetchStreamPerformance;
	hasRequiredFetchStreamPerformance = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const core = /*@__PURE__*/ requireCjs$4();

		const responseToStreamSpan = /* @__PURE__ */ new WeakMap();
		const responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
		const STREAM_RESOLVE_FALLBACK_MS = 9e4;
		const STREAMING_CONTENT_TYPES = ["text/event-stream", "application/x-ndjson", "application/stream+json"];
		const fetchStreamPerformanceIntegration = core.defineIntegration(() => {
		  return {
		    name: "FetchStreamPerformance",
		    setup() {
		      core.addFetchEndInstrumentationHandler((handlerData) => {
		        if (handlerData.response) {
		          const streamSpan = responseToStreamSpan.get(handlerData.response);
		          if (streamSpan && handlerData.endTimestamp) {
		            streamSpan.end(handlerData.endTimestamp);
		            const fallbackTimeout = responseToFallbackTimeout.get(handlerData.response);
		            if (fallbackTimeout) {
		              clearTimeout(fallbackTimeout);
		            }
		          }
		        }
		      });
		      core.addFetchInstrumentationHandler((handlerData) => {
		        if (handlerData.endTimestamp && handlerData.response) {
		          const contentType = handlerData.response.headers?.get("content-type") || "";
		          if (handlerData.response.headers?.get("content-length") || !STREAMING_CONTENT_TYPES.some((t) => contentType.startsWith(t))) {
		            return;
		          }
		          const url = handlerData.fetchData?.url || "";
		          const method = handlerData.fetchData?.method || "GET";
		          const parsedUrl = core.parseStringToURLObject(url);
		          const sanitizedUrl = url.startsWith("data:") ? core.stripDataUrlContent(url) : parsedUrl ? core.getSanitizedUrlStringFromUrlObject(parsedUrl) : url;
		          const streamSpan = core.startInactiveSpan({
		            name: `${method} ${sanitizedUrl}`,
		            startTime: handlerData.endTimestamp,
		            attributes: {
		              url: core.stripDataUrlContent(url),
		              "http.method": method,
		              type: "fetch",
		              [core.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client.stream",
		              [core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.http.browser.stream"
		            }
		          });
		          responseToStreamSpan.set(handlerData.response, streamSpan);
		          const fallbackTimeout = setTimeout(() => {
		            if (streamSpan.isRecording()) {
		              streamSpan.end();
		            }
		          }, STREAM_RESOLVE_FALLBACK_MS);
		          responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
		        }
		      });
		    }
		  };
		});

		exports.fetchStreamPerformanceIntegration = fetchStreamPerformanceIntegration;
		
	} (fetchStreamPerformance));
	return fetchStreamPerformance;
}

var webVitals = {};

var hasRequiredWebVitals;

function requireWebVitals () {
	if (hasRequiredWebVitals) return webVitals;
	hasRequiredWebVitals = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();

		const WEB_VITALS_INTEGRATION_NAME = "WebVitals";
		const webVitalsIntegration = browser.defineIntegration((options = {}) => {
		  const ignored = new Set(options.ignore ?? []);
		  return {
		    name: WEB_VITALS_INTEGRATION_NAME,
		    setup(client) {
		      const spanStreamingEnabled = browser.hasSpanStreamingEnabled(client);
		      const { enableStandaloneClsSpans, enableStandaloneLcpSpans } = options._experiments ?? {};
		      const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
		      const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
		      const finalizeWebVitals = browserUtils.startTrackingWebVitals({
		        recordClsStandaloneSpans,
		        recordLcpStandaloneSpans,
		        client
		      });
		      const pageloadSpans = /* @__PURE__ */ new WeakSet();
		      client.on("afterStartPageLoadSpan", (span) => {
		        pageloadSpans.add(span);
		      });
		      client.on("spanEnd", (span) => {
		        if (!pageloadSpans.delete(span)) {
		          return;
		        }
		        finalizeWebVitals();
		        browserUtils.addWebVitalsToSpan(span, {
		          // CLS/LCP are recorded as pageload span measurements only when they're neither
		          // tracked as standalone spans nor handled by span streaming (and not ignored).
		          recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
		          recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
		          spanStreamingEnabled
		        });
		      });
		      if (spanStreamingEnabled) {
		        if (!ignored.has("lcp")) {
		          browserUtils.trackLcpAsSpan(client);
		        }
		        if (!ignored.has("cls")) {
		          browserUtils.trackClsAsSpan(client);
		        }
		        if (!ignored.has("inp")) {
		          browserUtils.trackInpAsSpan();
		        }
		      } else if (!ignored.has("inp")) {
		        browserUtils.startTrackingINP();
		      }
		    },
		    afterAllSetup() {
		      if (!ignored.has("inp")) {
		        browserUtils.registerInpInteractionListener();
		      }
		    }
		  };
		});

		exports.WEB_VITALS_INTEGRATION_NAME = WEB_VITALS_INTEGRATION_NAME;
		exports.webVitalsIntegration = webVitalsIntegration;
		
	} (webVitals));
	return webVitals;
}

var backgroundtab = {};

var hasRequiredBackgroundtab;

function requireBackgroundtab () {
	if (hasRequiredBackgroundtab) return backgroundtab;
	hasRequiredBackgroundtab = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();

		function registerBackgroundTabDetection() {
		  if (helpers.WINDOW.document) {
		    helpers.WINDOW.document.addEventListener("visibilitychange", () => {
		      const activeSpan = browser.getActiveSpan();
		      if (!activeSpan) {
		        return;
		      }
		      const rootSpan = browser.getRootSpan(activeSpan);
		      if (helpers.WINDOW.document.hidden && rootSpan) {
		        const cancelledStatus = "cancelled";
		        const { op, status } = browser.spanToJSON(rootSpan);
		        if (debugBuild.DEBUG_BUILD) {
		          browser.debug.log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
		        }
		        if (!status) {
		          rootSpan.setStatus({ code: browser.SPAN_STATUS_ERROR, message: cancelledStatus });
		        }
		        rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
		        rootSpan.end();
		      }
		    });
		  } else {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("[Tracing] Could not set up background tab detection due to lack of global document");
		  }
		}

		exports.registerBackgroundTabDetection = registerBackgroundTabDetection;
		
	} (backgroundtab));
	return backgroundtab;
}

var linkedTraces = {};

var hasRequiredLinkedTraces;

function requireLinkedTraces () {
	if (hasRequiredLinkedTraces) return linkedTraces;
	hasRequiredLinkedTraces = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();

		const PREVIOUS_TRACE_MAX_DURATION = 3600;
		const PREVIOUS_TRACE_KEY = "sentry_previous_trace";
		const PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE = "sentry.previous_trace";
		function linkTraces(client, {
		  linkPreviousTrace,
		  consistentTraceSampling
		}) {
		  const useSessionStorage = linkPreviousTrace === "session-storage";
		  let inMemoryPreviousTraceInfo = useSessionStorage ? getPreviousTraceFromSessionStorage() : void 0;
		  client.on("spanStart", (span) => {
		    if (browser.getRootSpan(span) !== span) {
		      return;
		    }
		    const oldPropagationContext = browser.getCurrentScope().getPropagationContext();
		    inMemoryPreviousTraceInfo = addPreviousTraceSpanLink(inMemoryPreviousTraceInfo, span, oldPropagationContext);
		    if (useSessionStorage) {
		      storePreviousTraceInSessionStorage(inMemoryPreviousTraceInfo);
		    }
		  });
		  let isFirstTraceOnPageload = true;
		  if (consistentTraceSampling) {
		    client.on("beforeSampling", (mutableSamplingContextData) => {
		      if (!inMemoryPreviousTraceInfo) {
		        return;
		      }
		      const scope = browser.getCurrentScope();
		      const currentPropagationContext = scope.getPropagationContext();
		      if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
		        isFirstTraceOnPageload = false;
		        return;
		      }
		      scope.setPropagationContext({
		        ...currentPropagationContext,
		        dsc: {
		          ...currentPropagationContext.dsc,
		          sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
		          sampled: String(spanContextSampled(inMemoryPreviousTraceInfo.spanContext))
		        },
		        sampleRand: inMemoryPreviousTraceInfo.sampleRand
		      });
		      mutableSamplingContextData.parentSampled = spanContextSampled(inMemoryPreviousTraceInfo.spanContext);
		      mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
		      mutableSamplingContextData.spanAttributes = {
		        ...mutableSamplingContextData.spanAttributes,
		        [browser.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE]: inMemoryPreviousTraceInfo.sampleRate
		      };
		    });
		  }
		}
		function addPreviousTraceSpanLink(previousTraceInfo, span, oldPropagationContext) {
		  const spanJson = browser.spanToJSON(span);
		  function getSampleRate() {
		    try {
		      const oldSampleRate = Number(
		        spanJson.data?.[browser.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? oldPropagationContext.dsc?.sample_rate
		      );
		      return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
		    } catch {
		      return 0;
		    }
		  }
		  const updatedPreviousTraceInfo = {
		    spanContext: span.spanContext(),
		    startTimestamp: spanJson.start_timestamp,
		    sampleRate: getSampleRate(),
		    sampleRand: oldPropagationContext.sampleRand
		  };
		  if (!previousTraceInfo) {
		    return updatedPreviousTraceInfo;
		  }
		  const previousTraceSpanCtx = previousTraceInfo.spanContext;
		  if (previousTraceSpanCtx.traceId === spanJson.trace_id) {
		    return previousTraceInfo;
		  }
		  if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= PREVIOUS_TRACE_MAX_DURATION) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log(
		        `Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
		          op: spanJson.op,
		          ...span.spanContext()
		        })}\``
		      );
		    }
		    span.addLink({
		      context: previousTraceSpanCtx,
		      attributes: {
		        [browser.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE]: "previous_trace"
		      }
		    });
		    span.setAttribute(
		      PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE,
		      `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${spanContextSampled(previousTraceSpanCtx) ? 1 : 0}`
		    );
		  }
		  return updatedPreviousTraceInfo;
		}
		function storePreviousTraceInSessionStorage(previousTraceInfo) {
		  try {
		    helpers.WINDOW.sessionStorage.setItem(PREVIOUS_TRACE_KEY, JSON.stringify(previousTraceInfo));
		  } catch (e) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("Could not store previous trace in sessionStorage", e);
		  }
		}
		function getPreviousTraceFromSessionStorage() {
		  try {
		    const previousTraceInfo = helpers.WINDOW.sessionStorage?.getItem(PREVIOUS_TRACE_KEY);
		    return JSON.parse(previousTraceInfo);
		  } catch {
		    return void 0;
		  }
		}
		function spanContextSampled(ctx) {
		  return ctx.traceFlags === 1;
		}

		exports.PREVIOUS_TRACE_KEY = PREVIOUS_TRACE_KEY;
		exports.PREVIOUS_TRACE_MAX_DURATION = PREVIOUS_TRACE_MAX_DURATION;
		exports.PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE = PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE;
		exports.addPreviousTraceSpanLink = addPreviousTraceSpanLink;
		exports.getPreviousTraceFromSessionStorage = getPreviousTraceFromSessionStorage;
		exports.linkTraces = linkTraces;
		exports.spanContextSampled = spanContextSampled;
		exports.storePreviousTraceInSessionStorage = storePreviousTraceInSessionStorage;
		
	} (linkedTraces));
	return linkedTraces;
}

var hasRequiredBrowserTracingIntegration;

function requireBrowserTracingIntegration () {
	if (hasRequiredBrowserTracingIntegration) return browserTracingIntegration;
	hasRequiredBrowserTracingIntegration = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();
		const fetchStreamPerformance = /*@__PURE__*/ requireFetchStreamPerformance();
		const webVitals = /*@__PURE__*/ requireWebVitals();
		const backgroundtab = /*@__PURE__*/ requireBackgroundtab();
		const linkedTraces = /*@__PURE__*/ requireLinkedTraces();
		const request = /*@__PURE__*/ requireRequest();

		const BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
		const BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
		function isBotUserAgent() {
		  const nav = helpers.WINDOW.navigator;
		  if (!nav?.userAgent) {
		    return false;
		  }
		  return BOT_USER_AGENT_RE.test(nav.userAgent);
		}
		const DEFAULT_BROWSER_TRACING_OPTIONS = {
		  ...browser.TRACING_DEFAULTS,
		  instrumentNavigation: true,
		  instrumentPageLoad: true,
		  markBackgroundSpan: true,
		  enableLongTask: true,
		  enableLongAnimationFrame: true,
		  enableInp: true,
		  ignoreResourceSpans: [],
		  ignorePerformanceApiSpans: [],
		  detectRedirects: true,
		  linkPreviousTrace: "in-memory",
		  consistentTraceSampling: false,
		  enableReportPageLoaded: false,
		  _experiments: {},
		  ...request.defaultRequestInstrumentationOptions
		};
		const browserTracingIntegration = ((options = {}) => {
		  if ("enableElementTiming" in options) {
		    browser.consoleSandbox(() => {
		      console.warn(
		        "[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead."
		      );
		    });
		  }
		  const latestRoute = {
		    name: void 0,
		    source: void 0
		  };
		  const optionalWindowDocument = helpers.WINDOW.document;
		  const {
		    enableInp,
		    enableLongTask,
		    enableLongAnimationFrame,
		    _experiments: { enableInteractions, enableStandaloneClsSpans, enableStandaloneLcpSpans },
		    beforeStartSpan,
		    idleTimeout,
		    finalTimeout,
		    childSpanTimeout,
		    markBackgroundSpan,
		    traceFetch,
		    traceXHR,
		    // eslint-disable-next-line typescript/no-deprecated
		    trackFetchStreamPerformance,
		    shouldCreateSpanForRequest,
		    enableHTTPTimings,
		    ignoreResourceSpans,
		    ignorePerformanceApiSpans,
		    instrumentPageLoad,
		    instrumentNavigation,
		    detectRedirects,
		    linkPreviousTrace,
		    consistentTraceSampling,
		    enableReportPageLoaded,
		    onRequestSpanStart,
		    onRequestSpanEnd
		  } = {
		    ...DEFAULT_BROWSER_TRACING_OPTIONS,
		    ...options
		  };
		  const _isBot = isBotUserAgent();
		  let lastInteractionTimestamp;
		  let _pageloadSpan;
		  function _createRouteSpan(client, startSpanOptions, makeActive = true) {
		    const isPageloadSpan = startSpanOptions.op === "pageload";
		    const initialSpanName = startSpanOptions.name;
		    const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
		    const attributes = finalStartSpanOptions.attributes || {};
		    if (initialSpanName !== finalStartSpanOptions.name) {
		      attributes[browser.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
		      finalStartSpanOptions.attributes = attributes;
		    }
		    if (!makeActive) {
		      const now = browser.dateTimestampInSeconds();
		      browser.startInactiveSpan({
		        ...finalStartSpanOptions,
		        startTime: now
		      }).end(now);
		      return;
		    }
		    latestRoute.name = finalStartSpanOptions.name;
		    latestRoute.source = attributes[browser.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
		    const idleSpan = browser.startIdleSpan(finalStartSpanOptions, {
		      idleTimeout,
		      finalTimeout,
		      childSpanTimeout,
		      // should wait for finish signal if it's a pageload transaction
		      disableAutoFinish: isPageloadSpan,
		      beforeSpanEnd: (span) => {
		        browserUtils.addPerformanceEntries(span, {
		          ignoreResourceSpans,
		          ignorePerformanceApiSpans,
		          spanStreamingEnabled: browser.hasSpanStreamingEnabled(client)
		        });
		        setActiveIdleSpan(client, void 0);
		        const scope = browser.getCurrentScope();
		        const oldPropagationContext = scope.getPropagationContext();
		        scope.setPropagationContext({
		          ...oldPropagationContext,
		          traceId: idleSpan.spanContext().traceId,
		          sampled: browser.spanIsSampled(idleSpan),
		          dsc: browser.getDynamicSamplingContextFromSpan(span)
		        });
		        if (isPageloadSpan) {
		          _pageloadSpan = void 0;
		        }
		      },
		      trimIdleSpanEndTimestamp: !enableReportPageLoaded
		    });
		    if (isPageloadSpan && enableReportPageLoaded) {
		      _pageloadSpan = idleSpan;
		    }
		    setActiveIdleSpan(client, idleSpan);
		    function emitFinish() {
		      if (optionalWindowDocument && ["interactive", "complete"].includes(optionalWindowDocument.readyState)) {
		        client.emit("idleSpanEnableAutoFinish", idleSpan);
		        optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
		      }
		    }
		    if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
		      optionalWindowDocument.addEventListener("readystatechange", emitFinish);
		      emitFinish();
		    }
		  }
		  return {
		    name: BROWSER_TRACING_INTEGRATION_ID,
		    setup(client) {
		      if (_isBot) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
		        return;
		      }
		      browser.registerSpanErrorInstrumentation();
		      if (enableLongAnimationFrame && browser.GLOBAL_OBJ.PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) {
		        browserUtils.startTrackingLongAnimationFrames();
		      } else if (enableLongTask) {
		        browserUtils.startTrackingLongTasks();
		      }
		      if (enableInteractions) {
		        browserUtils.startTrackingInteractions();
		      }
		      if (detectRedirects && optionalWindowDocument) {
		        const interactionHandler = () => {
		          lastInteractionTimestamp = browser.timestampInSeconds();
		        };
		        addEventListener("click", interactionHandler, { capture: true });
		        addEventListener("keydown", interactionHandler, { capture: true, passive: true });
		      }
		      function maybeEndActiveSpan() {
		        const activeSpan = getActiveIdleSpan(client);
		        if (activeSpan && !browser.spanToJSON(activeSpan).timestamp) {
		          debugBuild.DEBUG_BUILD && browser.debug.log(`[Tracing] Finishing current active span with op: ${browser.spanToJSON(activeSpan).op}`);
		          activeSpan.setAttribute(browser.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, "cancelled");
		          activeSpan.end();
		        }
		      }
		      client.on("startNavigationSpan", (startSpanOptions, navigationOptions) => {
		        if (browser.getClient() !== client) {
		          return;
		        }
		        if (navigationOptions?.isRedirect) {
		          debugBuild.DEBUG_BUILD && browser.debug.warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
		          _createRouteSpan(
		            client,
		            {
		              op: "navigation.redirect",
		              ...startSpanOptions
		            },
		            false
		          );
		          return;
		        }
		        lastInteractionTimestamp = void 0;
		        maybeEndActiveSpan();
		        browser.getIsolationScope().setPropagationContext({
		          traceId: browser.generateTraceId(),
		          sampleRand: Math.random(),
		          propagationSpanId: browser.hasSpansEnabled() ? void 0 : browser.generateSpanId()
		        });
		        const scope = browser.getCurrentScope();
		        scope.setPropagationContext({
		          traceId: browser.generateTraceId(),
		          sampleRand: Math.random(),
		          propagationSpanId: browser.hasSpansEnabled() ? void 0 : browser.generateSpanId()
		        });
		        scope.setSDKProcessingMetadata({
		          normalizedRequest: void 0
		        });
		        _createRouteSpan(client, {
		          op: "navigation",
		          ...startSpanOptions,
		          // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
		          parentSpan: null,
		          forceTransaction: true
		        });
		      });
		      client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {}) => {
		        if (browser.getClient() !== client) {
		          return;
		        }
		        maybeEndActiveSpan();
		        const sentryTrace = traceOptions.sentryTrace || getMetaContent("sentry-trace") || getServerTiming("sentry-trace");
		        const baggage = traceOptions.baggage || getMetaContent("baggage") || getServerTiming("baggage");
		        const propagationContext = browser.propagationContextFromHeaders(sentryTrace, baggage);
		        const scope = browser.getCurrentScope();
		        scope.setPropagationContext(propagationContext);
		        if (!browser.hasSpansEnabled()) {
		          scope.getPropagationContext().propagationSpanId = browser.generateSpanId();
		        }
		        scope.setSDKProcessingMetadata({
		          normalizedRequest: helpers.getHttpRequestData()
		        });
		        _createRouteSpan(client, {
		          op: "pageload",
		          ...startSpanOptions
		        });
		      });
		      client.on("endPageloadSpan", () => {
		        if (enableReportPageLoaded && _pageloadSpan) {
		          _pageloadSpan.setAttribute(browser.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, "reportPageLoaded");
		          _pageloadSpan.end();
		        }
		      });
		    },
		    afterAllSetup(client) {
		      if (_isBot) {
		        return;
		      }
		      if (client.addIntegration && !client.getIntegrationByName?.(webVitals.WEB_VITALS_INTEGRATION_NAME)) {
		        client.addIntegration(
		          webVitals.webVitalsIntegration({
		            ignore: enableInp ? [] : ["inp"],
		            _experiments: {
		              enableStandaloneClsSpans,
		              enableStandaloneLcpSpans
		            }
		          })
		        );
		      }
		      let startingUrl = browser.getLocationHref();
		      if (linkPreviousTrace !== "off") {
		        linkedTraces.linkTraces(client, { linkPreviousTrace, consistentTraceSampling });
		      }
		      if (helpers.WINDOW.location) {
		        if (instrumentPageLoad) {
		          const origin = browser.browserPerformanceTimeOrigin();
		          startBrowserTracingPageLoadSpan(client, {
		            name: helpers.WINDOW.location.pathname,
		            // pageload should always start at timeOrigin (and needs to be in s, not ms)
		            startTime: origin ? origin / 1e3 : void 0,
		            attributes: {
		              [browser.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url",
		              [browser.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.pageload.browser"
		            }
		          });
		        }
		        if (instrumentNavigation) {
		          browserUtils.addHistoryInstrumentationHandler(({ to, from }) => {
		            if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
		              startingUrl = void 0;
		              return;
		            }
		            startingUrl = void 0;
		            const parsed = browser.parseStringToURLObject(to);
		            const activeSpan = getActiveIdleSpan(client);
		            const navigationIsRedirect = activeSpan && detectRedirects && isRedirect(activeSpan, lastInteractionTimestamp);
		            startBrowserTracingNavigationSpan(
		              client,
		              {
		                name: parsed?.pathname || helpers.WINDOW.location.pathname,
		                attributes: {
		                  [browser.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url",
		                  [browser.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.navigation.browser"
		                }
		              },
		              { url: to, isRedirect: navigationIsRedirect }
		            );
		          });
		        }
		      }
		      if (markBackgroundSpan) {
		        backgroundtab.registerBackgroundTabDetection();
		      }
		      if (enableInteractions) {
		        registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
		      }
		      request.instrumentOutgoingRequests(client, {
		        traceFetch,
		        traceXHR,
		        tracePropagationTargets: client.getOptions().tracePropagationTargets,
		        shouldCreateSpanForRequest,
		        enableHTTPTimings,
		        onRequestSpanStart,
		        onRequestSpanEnd
		      });
		      if (trackFetchStreamPerformance) {
		        client.addIntegration(fetchStreamPerformance.fetchStreamPerformanceIntegration());
		      }
		    }
		  };
		});
		function startBrowserTracingPageLoadSpan(client, spanOptions, traceOptions) {
		  client.emit("startPageLoadSpan", spanOptions, traceOptions);
		  browser.getCurrentScope().setTransactionName(spanOptions.name);
		  const pageloadSpan = getActiveIdleSpan(client);
		  if (pageloadSpan) {
		    client.emit("afterStartPageLoadSpan", pageloadSpan);
		  }
		  return pageloadSpan;
		}
		function startBrowserTracingNavigationSpan(client, spanOptions, options) {
		  const { url, isRedirect: isRedirect2 } = options || {};
		  client.emit("beforeStartNavigationSpan", spanOptions, { isRedirect: isRedirect2 });
		  client.emit("startNavigationSpan", spanOptions, { isRedirect: isRedirect2 });
		  const scope = browser.getCurrentScope();
		  scope.setTransactionName(spanOptions.name);
		  if (url && !isRedirect2) {
		    scope.setSDKProcessingMetadata({
		      normalizedRequest: {
		        ...helpers.getHttpRequestData(),
		        url
		      }
		    });
		  }
		  return getActiveIdleSpan(client);
		}
		function getMetaContent(metaName) {
		  const optionalWindowDocument = helpers.WINDOW.document;
		  const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
		  return metaTag?.getAttribute("content") || void 0;
		}
		function getServerTiming(name) {
		  const navigation = helpers.WINDOW.performance?.getEntriesByType?.("navigation")[0];
		  const entry = navigation?.serverTiming?.find((entry2) => entry2.name === name);
		  return entry?.description;
		}
		function registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
		  const optionalWindowDocument = helpers.WINDOW.document;
		  let inflightInteractionSpan;
		  const registerInteractionTransaction = () => {
		    const op = "ui.action.click";
		    const activeIdleSpan = getActiveIdleSpan(client);
		    if (activeIdleSpan) {
		      const currentRootSpanOp = browser.spanToJSON(activeIdleSpan).op;
		      if (["navigation", "pageload"].includes(currentRootSpanOp)) {
		        debugBuild.DEBUG_BUILD && browser.debug.warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
		        return void 0;
		      }
		    }
		    if (inflightInteractionSpan) {
		      inflightInteractionSpan.setAttribute(browser.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, "interactionInterrupted");
		      inflightInteractionSpan.end();
		      inflightInteractionSpan = void 0;
		    }
		    if (!latestRoute.name) {
		      debugBuild.DEBUG_BUILD && browser.debug.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
		      return void 0;
		    }
		    inflightInteractionSpan = browser.startIdleSpan(
		      {
		        name: latestRoute.name,
		        op,
		        attributes: {
		          [browser.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: latestRoute.source || "url"
		        }
		      },
		      {
		        idleTimeout,
		        finalTimeout,
		        childSpanTimeout
		      }
		    );
		  };
		  if (optionalWindowDocument) {
		    addEventListener("click", registerInteractionTransaction, { capture: true });
		  }
		}
		const ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
		function getActiveIdleSpan(client) {
		  return client[ACTIVE_IDLE_SPAN_PROPERTY];
		}
		function setActiveIdleSpan(client, span) {
		  browser.addNonEnumerableProperty(client, ACTIVE_IDLE_SPAN_PROPERTY, span);
		}
		const REDIRECT_THRESHOLD = 1.5;
		function isRedirect(activeSpan, lastInteractionTimestamp) {
		  const spanData = browser.spanToJSON(activeSpan);
		  const now = browser.dateTimestampInSeconds();
		  const startTimestamp = spanData.start_timestamp;
		  if (now - startTimestamp > REDIRECT_THRESHOLD) {
		    return false;
		  }
		  if (lastInteractionTimestamp && now - lastInteractionTimestamp <= REDIRECT_THRESHOLD) {
		    return false;
		  }
		  return true;
		}

		exports.BROWSER_TRACING_INTEGRATION_ID = BROWSER_TRACING_INTEGRATION_ID;
		exports.browserTracingIntegration = browserTracingIntegration;
		exports.getMetaContent = getMetaContent;
		exports.getServerTiming = getServerTiming;
		exports.isBotUserAgent = isBotUserAgent;
		exports.startBrowserTracingNavigationSpan = startBrowserTracingNavigationSpan;
		exports.startBrowserTracingPageLoadSpan = startBrowserTracingPageLoadSpan;
		
	} (browserTracingIntegration));
	return browserTracingIntegration;
}

var reportPageLoaded = {};

var hasRequiredReportPageLoaded;

function requireReportPageLoaded () {
	if (hasRequiredReportPageLoaded) return reportPageLoaded;
	hasRequiredReportPageLoaded = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		function reportPageLoaded(client = browser.getClient()) {
		  client?.emit("endPageloadSpan");
		}

		exports.reportPageLoaded = reportPageLoaded;
		
	} (reportPageLoaded));
	return reportPageLoaded;
}

var setActiveSpan = {};

var hasRequiredSetActiveSpan;

function requireSetActiveSpan () {
	if (hasRequiredSetActiveSpan) return setActiveSpan;
	hasRequiredSetActiveSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		function setActiveSpanInBrowser(span) {
		  const maybePreviousActiveSpan = browser.getActiveSpan();
		  if (maybePreviousActiveSpan === span) {
		    return;
		  }
		  const scope = browser.getCurrentScope();
		  span.end = new Proxy(span.end, {
		    apply(target, thisArg, args) {
		      browser._INTERNAL_setSpanForScope(scope, maybePreviousActiveSpan);
		      return Reflect.apply(target, thisArg, args);
		    }
		  });
		  browser._INTERNAL_setSpanForScope(scope, span);
		}

		exports.setActiveSpanInBrowser = setActiveSpanInBrowser;
		
	} (setActiveSpan));
	return setActiveSpan;
}

var spanstreaming = {};

var hasRequiredSpanstreaming;

function requireSpanstreaming () {
	if (hasRequiredSpanstreaming) return spanstreaming;
	hasRequiredSpanstreaming = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();

		const spanStreamingIntegration = browser.defineIntegration(() => {
		  return {
		    name: "SpanStreaming",
		    beforeSetup(client) {
		      const clientOptions = client.getOptions();
		      if (!clientOptions.traceLifecycle) {
		        debugBuild.DEBUG_BUILD && browser.debug.log('[SpanStreaming] setting `traceLifecycle` to "stream"');
		        clientOptions.traceLifecycle = "stream";
		      }
		    },
		    setup(client) {
		      const initialMessage = "SpanStreaming integration requires";
		      const fallbackMsg = "Falling back to static trace lifecycle.";
		      const clientOptions = client.getOptions();
		      if (!browser.hasSpanStreamingEnabled(client)) {
		        clientOptions.traceLifecycle = "static";
		        debugBuild.DEBUG_BUILD && browser.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
		        return;
		      }
		      const beforeSendSpan = clientOptions.beforeSendSpan;
		      if (beforeSendSpan && !browser.isStreamedBeforeSendSpanCallback(beforeSendSpan)) {
		        clientOptions.traceLifecycle = "static";
		        debugBuild.DEBUG_BUILD && browser.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
		        return;
		      }
		      const buffer = new browser.SpanBuffer(client);
		      client.on("afterSpanEnd", (span) => {
		        if (!browser.spanIsSampled(span)) {
		          return;
		        }
		        buffer.add(browser.captureSpan(span, client));
		      });
		      client.on("afterSegmentSpanEnd", (segmentSpan) => {
		        const traceId = segmentSpan.spanContext().traceId;
		        setTimeout(() => {
		          buffer.flush(traceId);
		        }, 500);
		      });
		    }
		  };
		});

		exports.spanStreamingIntegration = spanStreamingIntegration;
		
	} (spanstreaming));
	return spanstreaming;
}

var offline = {};

var hasRequiredOffline;

function requireOffline () {
	if (hasRequiredOffline) return offline;
	hasRequiredOffline = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const helpers = /*@__PURE__*/ requireHelpers();
		const fetch = /*@__PURE__*/ requireFetch();

		function promisifyRequest(request) {
		  return new Promise((resolve, reject) => {
		    request.oncomplete = request.onsuccess = () => resolve(request.result);
		    request.onabort = request.onerror = () => reject(request.error);
		  });
		}
		function createStore(dbName, storeName) {
		  const request = indexedDB.open(dbName);
		  request.onupgradeneeded = () => request.result.createObjectStore(storeName);
		  const dbp = promisifyRequest(request);
		  return (callback) => dbp.then((db) => callback(db.transaction(storeName, "readwrite").objectStore(storeName)));
		}
		function keys(store) {
		  return promisifyRequest(store.getAllKeys());
		}
		function push(store, value, maxQueueSize) {
		  return store((store2) => {
		    return keys(store2).then((keys2) => {
		      if (keys2.length >= maxQueueSize) {
		        return;
		      }
		      store2.put(value, Math.max(...keys2, 0) + 1);
		      return promisifyRequest(store2.transaction);
		    });
		  });
		}
		function unshift(store, value, maxQueueSize) {
		  return store((store2) => {
		    return keys(store2).then((keys2) => {
		      if (keys2.length >= maxQueueSize) {
		        return;
		      }
		      store2.put(value, Math.min(...keys2, 0) - 1);
		      return promisifyRequest(store2.transaction);
		    });
		  });
		}
		function shift(store) {
		  return store((store2) => {
		    return keys(store2).then((keys2) => {
		      const firstKey = keys2[0];
		      if (firstKey == null) {
		        return void 0;
		      }
		      return promisifyRequest(store2.get(firstKey)).then((value) => {
		        store2.delete(firstKey);
		        return promisifyRequest(store2.transaction).then(() => value);
		      });
		    });
		  });
		}
		function createIndexedDbStore(options) {
		  let store;
		  function getStore() {
		    if (store == void 0) {
		      store = createStore(options.dbName || "sentry-offline", options.storeName || "queue");
		    }
		    return store;
		  }
		  return {
		    push: async (env) => {
		      try {
		        const serialized = browser.serializeEnvelope(env);
		        await push(getStore(), serialized, options.maxQueueSize || 30);
		      } catch {
		      }
		    },
		    unshift: async (env) => {
		      try {
		        const serialized = browser.serializeEnvelope(env);
		        await unshift(getStore(), serialized, options.maxQueueSize || 30);
		      } catch {
		      }
		    },
		    shift: async () => {
		      try {
		        const deserialized = await shift(getStore());
		        if (deserialized) {
		          return browser.parseEnvelope(deserialized);
		        }
		      } catch {
		      }
		      return void 0;
		    }
		  };
		}
		function makeIndexedDbOfflineTransport(createTransport) {
		  return (options) => {
		    const transport = createTransport({ ...options, createStore: createIndexedDbStore });
		    helpers.WINDOW.addEventListener("online", async (_) => {
		      await transport.flush();
		    });
		    return transport;
		  };
		}
		function makeBrowserOfflineTransport(createTransport = fetch.makeFetchTransport) {
		  return makeIndexedDbOfflineTransport(browser.makeOfflineTransport(createTransport));
		}

		exports.createStore = createStore;
		exports.makeBrowserOfflineTransport = makeBrowserOfflineTransport;
		exports.push = push;
		exports.shift = shift;
		exports.unshift = unshift;
		
	} (offline));
	return offline;
}

var integration$5 = {};

var startProfileForSpan = {};

var utils$4 = {};

var hasRequiredUtils$4;

function requireUtils$4 () {
	if (hasRequiredUtils$4) return utils$4;
	hasRequiredUtils$4 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();

		const MS_TO_NS = 1e6;
		const isMainThread = "window" in browser.GLOBAL_OBJ && browser.GLOBAL_OBJ.window === browser.GLOBAL_OBJ && typeof importScripts === "undefined";
		const PROFILER_THREAD_ID_STRING = String(0);
		const PROFILER_THREAD_NAME = isMainThread ? "main" : "worker";
		const navigator = helpers.WINDOW.navigator;
		let OS_PLATFORM = "";
		let OS_PLATFORM_VERSION = "";
		let OS_ARCH = "";
		let OS_BROWSER = navigator?.userAgent || "";
		let OS_MODEL = "";
		const OS_LOCALE = navigator?.language || navigator?.languages?.[0] || "";
		function isUserAgentData(data) {
		  return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
		}
		const userAgentData = navigator?.userAgentData;
		if (isUserAgentData(userAgentData)) {
		  userAgentData.getHighEntropyValues(["architecture", "model", "platform", "platformVersion", "fullVersionList"]).then((ua) => {
		    OS_PLATFORM = ua.platform || "";
		    OS_ARCH = ua.architecture || "";
		    OS_MODEL = ua.model || "";
		    OS_PLATFORM_VERSION = ua.platformVersion || "";
		    if (ua.fullVersionList?.length) {
		      const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
		      OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
		    }
		  }).catch((e) => void 0);
		}
		function isProcessedJSSelfProfile(profile) {
		  return !("thread_metadata" in profile);
		}
		function enrichWithThreadInformation(profile) {
		  if (!isProcessedJSSelfProfile(profile)) {
		    return profile;
		  }
		  return convertJSSelfProfileToSampledFormat(profile);
		}
		function getTraceId(event) {
		  const traceId = event.contexts?.trace?.trace_id;
		  if (typeof traceId === "string" && traceId.length !== 32) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
		    }
		  }
		  if (typeof traceId !== "string") {
		    return "";
		  }
		  return traceId;
		}
		function createProfilePayload(profile_id, start_timestamp, processed_profile, event) {
		  if (event.type !== "transaction") {
		    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
		  }
		  if (processed_profile === void 0 || processed_profile === null) {
		    throw new TypeError(
		      `Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`
		    );
		  }
		  const traceId = getTraceId(event);
		  const enrichedThreadProfile = enrichWithThreadInformation(processed_profile);
		  const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1e3 : browser.timestampInSeconds() * 1e3;
		  const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1e3 : browser.timestampInSeconds() * 1e3;
		  const profile = {
		    event_id: profile_id,
		    timestamp: new Date(transactionStartMs).toISOString(),
		    platform: "javascript",
		    version: "1",
		    release: event.release || "",
		    environment: event.environment || browser.DEFAULT_ENVIRONMENT,
		    runtime: {
		      name: "javascript",
		      version: helpers.WINDOW.navigator.userAgent
		    },
		    os: {
		      name: OS_PLATFORM,
		      version: OS_PLATFORM_VERSION,
		      build_number: OS_BROWSER
		    },
		    device: {
		      locale: OS_LOCALE,
		      model: OS_MODEL,
		      manufacturer: OS_BROWSER,
		      architecture: OS_ARCH,
		      is_emulator: false
		    },
		    debug_meta: {
		      images: applyDebugMetadata(processed_profile.resources)
		    },
		    profile: enrichedThreadProfile,
		    transactions: [
		      {
		        name: event.transaction || "",
		        id: event.event_id || browser.uuid4(),
		        trace_id: traceId,
		        active_thread_id: PROFILER_THREAD_ID_STRING,
		        relative_start_ns: "0",
		        relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
		      }
		    ]
		  };
		  return profile;
		}
		function createProfileChunkPayload(jsSelfProfile, client, profilerId) {
		  if (jsSelfProfile == null) {
		    throw new TypeError(
		      `Cannot construct profiling event envelope without a valid profile. Got ${jsSelfProfile} instead.`
		    );
		  }
		  const continuousProfile = convertToContinuousProfile(jsSelfProfile);
		  const options = client.getOptions();
		  const sdk = client.getSdkMetadata?.()?.sdk;
		  return {
		    chunk_id: browser.uuid4(),
		    client_sdk: {
		      name: sdk?.name ?? "sentry.javascript.browser",
		      version: sdk?.version ?? "0.0.0"
		    },
		    profiler_id: profilerId || browser.uuid4(),
		    platform: "javascript",
		    version: "2",
		    release: options.release ?? "",
		    environment: options.environment ?? "production",
		    debug_meta: {
		      // function name obfuscation
		      images: applyDebugMetadata(jsSelfProfile.resources)
		    },
		    profile: continuousProfile
		  };
		}
		function validateProfileChunk(chunk) {
		  try {
		    if (!chunk || typeof chunk !== "object") {
		      return { reason: "chunk is not an object" };
		    }
		    const isHex32 = (val) => typeof val === "string" && /^[a-f0-9]{32}$/.test(val);
		    if (!isHex32(chunk.profiler_id)) {
		      return { reason: "missing or invalid profiler_id" };
		    }
		    if (!isHex32(chunk.chunk_id)) {
		      return { reason: "missing or invalid chunk_id" };
		    }
		    if (!chunk.client_sdk) {
		      return { reason: "missing client_sdk metadata" };
		    }
		    const profile = chunk.profile;
		    if (!profile) {
		      return { reason: "missing profile data" };
		    }
		    if (!Array.isArray(profile.frames) || !profile.frames.length) {
		      return { reason: "profile has no frames" };
		    }
		    if (!Array.isArray(profile.stacks) || !profile.stacks.length) {
		      return { reason: "profile has no stacks" };
		    }
		    if (!Array.isArray(profile.samples) || !profile.samples.length) {
		      return { reason: "profile has no samples" };
		    }
		    return { valid: true };
		  } catch (e) {
		    return { reason: `unknown validation error: ${e}` };
		  }
		}
		function convertToContinuousProfile(input) {
		  const frames = [];
		  for (let i = 0; i < input.frames.length; i++) {
		    const frame = input.frames[i];
		    if (!frame) {
		      continue;
		    }
		    frames[i] = {
		      function: frame.name,
		      abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : void 0,
		      lineno: frame.line,
		      colno: frame.column
		    };
		  }
		  const stacks = [];
		  for (let i = 0; i < input.stacks.length; i++) {
		    const stackHead = input.stacks[i];
		    if (!stackHead) {
		      continue;
		    }
		    const list = [];
		    let current = stackHead;
		    while (current) {
		      list.push(current.frameId);
		      current = current.parentId === void 0 ? void 0 : input.stacks[current.parentId];
		    }
		    stacks[i] = list;
		  }
		  const perfOrigin = browser.browserPerformanceTimeOrigin();
		  const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : perfOrigin || 0;
		  const adjustForOriginChange = origin - (perfOrigin || origin);
		  const samples = [];
		  for (let i = 0; i < input.samples.length; i++) {
		    const sample = input.samples[i];
		    if (!sample) {
		      continue;
		    }
		    const timestampSeconds = (origin + (sample.timestamp - adjustForOriginChange)) / 1e3;
		    samples[i] = {
		      stack_id: sample.stackId ?? 0,
		      thread_id: PROFILER_THREAD_ID_STRING,
		      timestamp: timestampSeconds
		    };
		  }
		  return {
		    frames,
		    stacks,
		    samples,
		    thread_metadata: { [PROFILER_THREAD_ID_STRING]: { name: PROFILER_THREAD_NAME } }
		  };
		}
		function isAutomatedPageLoadSpan(span) {
		  return browser.spanToJSON(span).op === "pageload";
		}
		function convertJSSelfProfileToSampledFormat(input) {
		  let EMPTY_STACK_ID = void 0;
		  let STACK_ID = 0;
		  const profile = {
		    samples: [],
		    stacks: [],
		    frames: [],
		    thread_metadata: {
		      [PROFILER_THREAD_ID_STRING]: { name: PROFILER_THREAD_NAME }
		    }
		  };
		  const firstSample = input.samples[0];
		  if (!firstSample) {
		    return profile;
		  }
		  const start = firstSample.timestamp;
		  const perfOrigin = browser.browserPerformanceTimeOrigin();
		  const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : perfOrigin || 0;
		  const adjustForOriginChange = origin - (perfOrigin || origin);
		  input.samples.forEach((jsSample, i) => {
		    if (jsSample.stackId === void 0) {
		      if (EMPTY_STACK_ID === void 0) {
		        EMPTY_STACK_ID = STACK_ID;
		        profile.stacks[EMPTY_STACK_ID] = [];
		        STACK_ID++;
		      }
		      profile["samples"][i] = {
		        // convert ms timestamp to ns
		        elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
		        stack_id: EMPTY_STACK_ID,
		        thread_id: PROFILER_THREAD_ID_STRING
		      };
		      return;
		    }
		    let stackTop = input.stacks[jsSample.stackId];
		    const stack = [];
		    while (stackTop) {
		      stack.push(stackTop.frameId);
		      const frame = input.frames[stackTop.frameId];
		      if (frame && profile.frames[stackTop.frameId] === void 0) {
		        profile.frames[stackTop.frameId] = {
		          function: frame.name,
		          abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : void 0,
		          lineno: frame.line,
		          colno: frame.column
		        };
		      }
		      stackTop = stackTop.parentId === void 0 ? void 0 : input.stacks[stackTop.parentId];
		    }
		    const sample = {
		      // convert ms timestamp to ns
		      elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
		      stack_id: STACK_ID,
		      thread_id: PROFILER_THREAD_ID_STRING
		    };
		    profile["stacks"][STACK_ID] = stack;
		    profile["samples"][i] = sample;
		    STACK_ID++;
		  });
		  return profile;
		}
		function addProfilesToEnvelope(envelope, profiles) {
		  if (!profiles.length) {
		    return envelope;
		  }
		  for (const profile of profiles) {
		    envelope[1].push([{ type: "profile" }, profile]);
		  }
		  return envelope;
		}
		function findProfiledTransactionsFromEnvelope(envelope) {
		  const events = [];
		  browser.forEachEnvelopeItem(envelope, (item, type) => {
		    if (type !== "transaction") {
		      return;
		    }
		    for (let j = 1; j < item.length; j++) {
		      const event = item[j];
		      if (event?.contexts?.profile?.profile_id) {
		        events.push(item[j]);
		      }
		    }
		  });
		  return events;
		}
		function applyDebugMetadata(resource_paths) {
		  const client = browser.getClient();
		  const options = client?.getOptions();
		  const stackParser = options?.stackParser;
		  if (!stackParser) {
		    return [];
		  }
		  return browser.getDebugImagesForResources(stackParser, resource_paths);
		}
		function isValidSampleRate(rate) {
		  if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn(
		      `[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
		        rate
		      )} of type ${JSON.stringify(typeof rate)}.`
		    );
		    return false;
		  }
		  if (rate === true || rate === false) {
		    return true;
		  }
		  if (rate < 0 || rate > 1) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
		    return false;
		  }
		  return true;
		}
		function isValidProfile(profile) {
		  if (profile.samples.length < 2) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log("[Profiling] Discarding profile because it contains less than 2 samples");
		    }
		    return false;
		  }
		  if (!profile.frames.length) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log("[Profiling] Discarding profile because it contains no frames");
		    }
		    return false;
		  }
		  return true;
		}
		let PROFILING_CONSTRUCTOR_FAILED = false;
		const MAX_PROFILE_DURATION_MS = 3e4;
		function isJSProfilerSupported(maybeProfiler) {
		  return typeof maybeProfiler === "function";
		}
		function startJSSelfProfile() {
		  const JSProfilerConstructor = helpers.WINDOW.Profiler;
		  if (!isJSProfilerSupported(JSProfilerConstructor)) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
		    }
		    return;
		  }
		  const samplingIntervalMS = 10;
		  const maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);
		  try {
		    return new JSProfilerConstructor({ sampleInterval: samplingIntervalMS, maxBufferSize: maxSamples });
		  } catch (_e) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log(
		        "[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header."
		      );
		      browser.debug.log("[Profiling] Disabling profiling for current user session.");
		    }
		    PROFILING_CONSTRUCTOR_FAILED = true;
		  }
		  return;
		}
		function shouldProfileSpanLegacy(span) {
		  if (PROFILING_CONSTRUCTOR_FAILED) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log("[Profiling] Profiling has been disabled for the duration of the current user session.");
		    }
		    return false;
		  }
		  if (!span.isRecording()) {
		    debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Discarding profile because root span was not sampled.");
		    return false;
		  }
		  const client = browser.getClient();
		  const options = client?.getOptions();
		  if (!options) {
		    debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Profiling disabled, no options found.");
		    return false;
		  }
		  const profilesSampleRate = options.profilesSampleRate;
		  if (!isValidSampleRate(profilesSampleRate)) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("[Profiling] Discarding profile because of invalid sample rate.");
		    return false;
		  }
		  if (!profilesSampleRate) {
		    debugBuild.DEBUG_BUILD && browser.debug.log(
		      "[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0"
		    );
		    return false;
		  }
		  const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
		  if (!sampled) {
		    debugBuild.DEBUG_BUILD && browser.debug.log(
		      `[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(
		        profilesSampleRate
		      )})`
		    );
		    return false;
		  }
		  return true;
		}
		function shouldProfileSession(options) {
		  if (PROFILING_CONSTRUCTOR_FAILED) {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log(
		        "[Profiling] Profiling has been disabled for the duration of the current user session as the JS Profiler could not be started."
		      );
		    }
		    return false;
		  }
		  if (options.profileLifecycle !== "trace" && options.profileLifecycle !== "manual") {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("[Profiling] Session not sampled. Invalid `profileLifecycle` option.");
		    return false;
		  }
		  const profileSessionSampleRate = options.profileSessionSampleRate;
		  if (!isValidSampleRate(profileSessionSampleRate)) {
		    debugBuild.DEBUG_BUILD && browser.debug.warn("[Profiling] Discarding profile because of invalid profileSessionSampleRate.");
		    return false;
		  }
		  if (!profileSessionSampleRate) {
		    debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Discarding profile because profileSessionSampleRate is not defined or set to 0");
		    return false;
		  }
		  return Math.random() <= profileSessionSampleRate;
		}
		function hasLegacyProfiling(options) {
		  return typeof options.profilesSampleRate !== "undefined";
		}
		function createProfilingEvent(profile_id, start_timestamp, profile, event) {
		  if (!isValidProfile(profile)) {
		    return null;
		  }
		  return createProfilePayload(profile_id, start_timestamp, profile, event);
		}
		const PROFILE_MAP = /* @__PURE__ */ new Map();
		function getActiveProfilesCount() {
		  return PROFILE_MAP.size;
		}
		function takeProfileFromGlobalCache(profile_id) {
		  const profile = PROFILE_MAP.get(profile_id);
		  if (profile) {
		    PROFILE_MAP.delete(profile_id);
		  }
		  return profile;
		}
		function addProfileToGlobalCache(profile_id, profile) {
		  PROFILE_MAP.set(profile_id, profile);
		  if (PROFILE_MAP.size > 30) {
		    const last = PROFILE_MAP.keys().next().value;
		    if (last !== void 0) {
		      PROFILE_MAP.delete(last);
		    }
		  }
		}
		const PROFILED_ROOT_SPANS = /* @__PURE__ */ new WeakSet();
		function setThreadAttributes(span) {
		  span.setAttribute("thread.id", PROFILER_THREAD_ID_STRING);
		  span.setAttribute("thread.name", PROFILER_THREAD_NAME);
		}

		exports.MAX_PROFILE_DURATION_MS = MAX_PROFILE_DURATION_MS;
		exports.PROFILED_ROOT_SPANS = PROFILED_ROOT_SPANS;
		exports.PROFILER_THREAD_ID_STRING = PROFILER_THREAD_ID_STRING;
		exports.PROFILER_THREAD_NAME = PROFILER_THREAD_NAME;
		exports.addProfileToGlobalCache = addProfileToGlobalCache;
		exports.addProfilesToEnvelope = addProfilesToEnvelope;
		exports.applyDebugMetadata = applyDebugMetadata;
		exports.convertJSSelfProfileToSampledFormat = convertJSSelfProfileToSampledFormat;
		exports.createProfileChunkPayload = createProfileChunkPayload;
		exports.createProfilePayload = createProfilePayload;
		exports.createProfilingEvent = createProfilingEvent;
		exports.enrichWithThreadInformation = enrichWithThreadInformation;
		exports.findProfiledTransactionsFromEnvelope = findProfiledTransactionsFromEnvelope;
		exports.getActiveProfilesCount = getActiveProfilesCount;
		exports.hasLegacyProfiling = hasLegacyProfiling;
		exports.isAutomatedPageLoadSpan = isAutomatedPageLoadSpan;
		exports.isValidSampleRate = isValidSampleRate;
		exports.setThreadAttributes = setThreadAttributes;
		exports.shouldProfileSession = shouldProfileSession;
		exports.shouldProfileSpanLegacy = shouldProfileSpanLegacy;
		exports.startJSSelfProfile = startJSSelfProfile;
		exports.takeProfileFromGlobalCache = takeProfileFromGlobalCache;
		exports.validateProfileChunk = validateProfileChunk;
		
	} (utils$4));
	return utils$4;
}

var hasRequiredStartProfileForSpan;

function requireStartProfileForSpan () {
	if (hasRequiredStartProfileForSpan) return startProfileForSpan;
	hasRequiredStartProfileForSpan = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();
		const utils = /*@__PURE__*/ requireUtils$4();

		function startProfileForSpan(span) {
		  let startTimestamp;
		  if (utils.isAutomatedPageLoadSpan(span)) {
		    startTimestamp = browser.timestampInSeconds() * 1e3;
		  }
		  const profiler = utils.startJSSelfProfile();
		  if (!profiler) {
		    return;
		  }
		  if (debugBuild.DEBUG_BUILD) {
		    browser.debug.log(`[Profiling] started profiling span: ${browser.spanToJSON(span).description}`);
		  }
		  const profileId = browser.uuid4();
		  let processedProfile = null;
		  browser.getCurrentScope().setContext("profile", {
		    profile_id: profileId,
		    start_timestamp: startTimestamp
		  });
		  utils.PROFILED_ROOT_SPANS.add(span);
		  utils.setThreadAttributes(span);
		  async function onProfileHandler() {
		    if (!span) {
		      return;
		    }
		    if (!profiler) {
		      return;
		    }
		    if (processedProfile) {
		      if (debugBuild.DEBUG_BUILD) {
		        browser.debug.log("[Profiling] profile for:", browser.spanToJSON(span).description, "already exists, returning early");
		      }
		      return;
		    }
		    return profiler.stop().then((profile) => {
		      if (maxDurationTimeoutID) {
		        helpers.WINDOW.clearTimeout(maxDurationTimeoutID);
		        maxDurationTimeoutID = void 0;
		      }
		      if (debugBuild.DEBUG_BUILD) {
		        browser.debug.log(`[Profiling] stopped profiling of span: ${browser.spanToJSON(span).description}`);
		      }
		      if (!profile) {
		        if (debugBuild.DEBUG_BUILD) {
		          browser.debug.log(
		            `[Profiling] profiler returned null profile for: ${browser.spanToJSON(span).description}`,
		            "this may indicate an overlapping span or a call to stopProfiling with a profile title that was never started"
		          );
		        }
		        return;
		      }
		      processedProfile = profile;
		      utils.addProfileToGlobalCache(profileId, profile);
		    }).catch((error) => {
		      if (debugBuild.DEBUG_BUILD) {
		        browser.debug.log("[Profiling] error while stopping profiler:", error);
		      }
		    });
		  }
		  let maxDurationTimeoutID = helpers.WINDOW.setTimeout(() => {
		    if (debugBuild.DEBUG_BUILD) {
		      browser.debug.log("[Profiling] max profile duration elapsed, stopping profiling for:", browser.spanToJSON(span).description);
		    }
		    onProfileHandler();
		  }, utils.MAX_PROFILE_DURATION_MS);
		  const originalEnd = span.end.bind(span);
		  function profilingWrappedSpanEnd() {
		    if (!span) {
		      return originalEnd();
		    }
		    void onProfileHandler().then(
		      () => {
		        originalEnd();
		      },
		      () => {
		        originalEnd();
		      }
		    );
		    return span;
		  }
		  span.end = profilingWrappedSpanEnd;
		}

		exports.startProfileForSpan = startProfileForSpan;
		
	} (startProfileForSpan));
	return startProfileForSpan;
}

var UIProfiler = {};

var hasRequiredUIProfiler;

function requireUIProfiler () {
	if (hasRequiredUIProfiler) return UIProfiler;
	hasRequiredUIProfiler = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const utils = /*@__PURE__*/ requireUtils$4();

		const CHUNK_INTERVAL_MS = 6e4;
		const MAX_ROOT_SPAN_PROFILE_MS = 3e5;
		class UIProfiler {
		  constructor() {
		    this._client = void 0;
		    this._profiler = void 0;
		    this._chunkTimer = void 0;
		    this._profilerId = void 0;
		    this._isRunning = false;
		    this._sessionSampled = false;
		    this._lifecycleMode = void 0;
		    this._activeRootSpanIds = /* @__PURE__ */ new Set();
		    this._rootSpanTimeouts = /* @__PURE__ */ new Map();
		  }
		  /**
		   * Initialize the profiler with client, session sampling and lifecycle mode.
		   */
		  initialize(client) {
		    const lifecycleMode = client.getOptions().profileLifecycle;
		    const sessionSampled = utils.shouldProfileSession(client.getOptions());
		    debugBuild.DEBUG_BUILD && browser.debug.log(`[Profiling] Initializing profiler (lifecycle='${lifecycleMode}').`);
		    if (!sessionSampled) {
		      debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Session not sampled. Skipping lifecycle profiler initialization.");
		    }
		    this._profilerId = browser.uuid4();
		    this._client = client;
		    this._sessionSampled = sessionSampled;
		    this._lifecycleMode = lifecycleMode;
		    if (lifecycleMode === "trace") {
		      this._setupTraceLifecycleListeners(client);
		    }
		    client.on("spanStart", (span) => {
		      if (this._isRunning) {
		        utils.setThreadAttributes(span);
		      }
		    });
		  }
		  /** Starts UI profiling (only effective in 'manual' mode and when sampled). */
		  start() {
		    if (this._lifecycleMode === "trace") {
		      debugBuild.DEBUG_BUILD && browser.debug.warn(
		        '[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.start()` are ignored in trace mode.'
		      );
		      return;
		    }
		    if (this._isRunning) {
		      debugBuild.DEBUG_BUILD && browser.debug.warn("[Profiling] Profile session is already running, `uiProfiler.start()` is a no-op.");
		      return;
		    }
		    if (!this._sessionSampled) {
		      debugBuild.DEBUG_BUILD && browser.debug.warn("[Profiling] Session is not sampled, `uiProfiler.start()` is a no-op.");
		      return;
		    }
		    this._beginProfiling();
		  }
		  /** Stops UI profiling (only effective in 'manual' mode). */
		  stop() {
		    if (this._lifecycleMode === "trace") {
		      debugBuild.DEBUG_BUILD && browser.debug.warn(
		        '[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.stop()` are ignored in trace mode.'
		      );
		      return;
		    }
		    if (!this._isRunning) {
		      debugBuild.DEBUG_BUILD && browser.debug.warn("[Profiling] Profiler is not running, `uiProfiler.stop()` is a no-op.");
		      return;
		    }
		    this._endProfiling();
		  }
		  /** Handle an already-active root span at integration setup time (used only in trace mode). */
		  notifyRootSpanActive(rootSpan) {
		    if (this._lifecycleMode !== "trace" || !this._sessionSampled) {
		      return;
		    }
		    const spanId = rootSpan.spanContext().spanId;
		    if (!spanId || this._activeRootSpanIds.has(spanId)) {
		      return;
		    }
		    this._registerTraceRootSpan(spanId);
		    const rootSpanCount = this._activeRootSpanIds.size;
		    if (rootSpanCount === 1) {
		      debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Detected already active root span during setup. Active root spans now:", rootSpanCount);
		      this._beginProfiling();
		    }
		    if (this._isRunning) {
		      utils.setThreadAttributes(rootSpan);
		    }
		  }
		  /**
		   * Begin profiling if not already running.
		   */
		  _beginProfiling() {
		    if (this._isRunning) {
		      return;
		    }
		    this._isRunning = true;
		    debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Started profiling with profiler ID:", this._profilerId);
		    browser.getGlobalScope().setContext("profile", { profiler_id: this._profilerId });
		    this._startProfilerInstance();
		    if (!this._profiler) {
		      debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Failed to start JS Profiler; stopping.");
		      this._resetProfilerInfo();
		      return;
		    }
		    this._startPeriodicChunking();
		  }
		  /** End profiling session; final chunk will be collected and sent. */
		  _endProfiling() {
		    if (!this._isRunning) {
		      return;
		    }
		    this._isRunning = false;
		    if (this._chunkTimer) {
		      clearTimeout(this._chunkTimer);
		      this._chunkTimer = void 0;
		    }
		    this._clearAllRootSpanTimeouts();
		    this._collectCurrentChunk().catch((e) => {
		      debugBuild.DEBUG_BUILD && browser.debug.error("[Profiling] Failed to collect current profile chunk on `stop()`:", e);
		    });
		    if (this._lifecycleMode === "manual") {
		      browser.getGlobalScope().setContext("profile", {});
		    }
		  }
		  /** Trace-mode: attach spanStart/spanEnd listeners. */
		  _setupTraceLifecycleListeners(client) {
		    client.on("spanStart", (span) => {
		      if (!this._sessionSampled) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Span not profiled because of negative sampling decision for user session.");
		        return;
		      }
		      if (span !== browser.getRootSpan(span)) {
		        return;
		      }
		      if (!span.isRecording()) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Discarding profile because root span was not sampled.");
		        return;
		      }
		      const spanId = span.spanContext().spanId;
		      if (!spanId || this._activeRootSpanIds.has(spanId)) {
		        return;
		      }
		      this._registerTraceRootSpan(spanId);
		      const rootSpanCount = this._activeRootSpanIds.size;
		      if (rootSpanCount === 1) {
		        debugBuild.DEBUG_BUILD && browser.debug.log(
		          `[Profiling] Root span ${spanId} started. Profiling active while there are active root spans (count=${rootSpanCount}).`
		        );
		        this._beginProfiling();
		      }
		    });
		    client.on("spanEnd", (span) => {
		      if (!this._sessionSampled) {
		        return;
		      }
		      const spanId = span.spanContext().spanId;
		      if (!spanId || !this._activeRootSpanIds.has(spanId)) {
		        return;
		      }
		      this._activeRootSpanIds.delete(spanId);
		      const rootSpanCount = this._activeRootSpanIds.size;
		      debugBuild.DEBUG_BUILD && browser.debug.log(
		        `[Profiling] Root span with ID ${spanId} ended. Will continue profiling for as long as there are active root spans (currently: ${rootSpanCount}).`
		      );
		      if (rootSpanCount === 0) {
		        this._collectCurrentChunk().catch((e) => {
		          debugBuild.DEBUG_BUILD && browser.debug.error("[Profiling] Failed to collect current profile chunk on last `spanEnd`:", e);
		        });
		        this._endProfiling();
		      }
		    });
		  }
		  /**
		   * Resets profiling information from scope and resets running state (used on failure)
		   */
		  _resetProfilerInfo() {
		    this._isRunning = false;
		    browser.getGlobalScope().setContext("profile", {});
		  }
		  /**
		   * Clear and reset all per-root-span timeouts.
		   */
		  _clearAllRootSpanTimeouts() {
		    this._rootSpanTimeouts.forEach((timeout) => clearTimeout(timeout));
		    this._rootSpanTimeouts.clear();
		  }
		  /** Keep track of root spans and schedule safeguard timeout (trace mode). */
		  _registerTraceRootSpan(spanId) {
		    this._activeRootSpanIds.add(spanId);
		    const timeout = setTimeout(() => this._onRootSpanTimeout(spanId), MAX_ROOT_SPAN_PROFILE_MS);
		    this._rootSpanTimeouts.set(spanId, timeout);
		  }
		  /**
		   * Start a profiler instance if needed.
		   */
		  _startProfilerInstance() {
		    if (this._profiler?.stopped === false) {
		      return;
		    }
		    const profiler = utils.startJSSelfProfile();
		    if (!profiler) {
		      debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Failed to start JS Profiler.");
		      return;
		    }
		    this._profiler = profiler;
		  }
		  /**
		   * Schedule the next 60s chunk while running.
		   * Each tick collects a chunk and restarts the profiler.
		   * A chunk should be closed when there are no active root spans anymore OR when the maximum chunk interval is reached.
		   */
		  _startPeriodicChunking() {
		    if (!this._isRunning) {
		      return;
		    }
		    this._chunkTimer = setTimeout(() => {
		      this._collectCurrentChunk().catch((e) => {
		        debugBuild.DEBUG_BUILD && browser.debug.error("[Profiling] Failed to collect current profile chunk during periodic chunking:", e);
		      });
		      if (this._isRunning) {
		        this._startProfilerInstance();
		        if (!this._profiler) {
		          this._resetProfilerInfo();
		          return;
		        }
		        this._startPeriodicChunking();
		      }
		    }, CHUNK_INTERVAL_MS);
		  }
		  /**
		   * Handle timeout for a specific root span ID to avoid indefinitely running profiler if `spanEnd` never fires.
		   * If this was the last active root span, collect the current chunk and stop profiling.
		   */
		  _onRootSpanTimeout(rootSpanId) {
		    if (!this._rootSpanTimeouts.has(rootSpanId)) {
		      return;
		    }
		    this._rootSpanTimeouts.delete(rootSpanId);
		    if (!this._activeRootSpanIds.has(rootSpanId)) {
		      return;
		    }
		    debugBuild.DEBUG_BUILD && browser.debug.log(
		      `[Profiling] Reached 5-minute timeout for root span ${rootSpanId}. You likely started a manual root span that never called \`.end()\`.`
		    );
		    this._activeRootSpanIds.delete(rootSpanId);
		    if (this._activeRootSpanIds.size === 0) {
		      this._endProfiling();
		    }
		  }
		  /**
		   * Stop current profiler instance, convert profile to chunk & send.
		   */
		  async _collectCurrentChunk() {
		    const prevProfiler = this._profiler;
		    this._profiler = void 0;
		    if (!prevProfiler) {
		      return;
		    }
		    try {
		      const profile = await prevProfiler.stop();
		      const chunk = utils.createProfileChunkPayload(profile, this._client, this._profilerId);
		      const validationReturn = utils.validateProfileChunk(chunk);
		      if ("reason" in validationReturn) {
		        debugBuild.DEBUG_BUILD && browser.debug.log(
		          "[Profiling] Discarding invalid profile chunk (this is probably a bug in the SDK):",
		          validationReturn.reason
		        );
		        return;
		      }
		      this._sendProfileChunk(chunk);
		      debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Collected browser profile chunk.");
		    } catch (e) {
		      debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Error while stopping JS Profiler for chunk:", e);
		    }
		  }
		  /**
		   * Send a profile chunk as a standalone envelope.
		   */
		  _sendProfileChunk(chunk) {
		    const client = this._client;
		    const sdkInfo = browser.getSdkMetadataForEnvelopeHeader(client.getSdkMetadata?.());
		    const dsn = client.getDsn();
		    const tunnel = client.getOptions().tunnel;
		    const envelope = browser.createEnvelope(
		      {
		        event_id: browser.uuid4(),
		        sent_at: (/* @__PURE__ */ new Date()).toISOString(),
		        ...sdkInfo && { sdk: sdkInfo },
		        ...!!tunnel && dsn && { dsn: browser.dsnToString(dsn) }
		      },
		      [[{ type: "profile_chunk", platform: "javascript" }, chunk]]
		    );
		    client.sendEnvelope(envelope).then(null, (reason) => {
		      debugBuild.DEBUG_BUILD && browser.debug.error("Error while sending profile chunk envelope:", reason);
		    });
		  }
		}

		exports.UIProfiler = UIProfiler;
		
	} (UIProfiler));
	return UIProfiler;
}

var hasRequiredIntegration$5;

function requireIntegration$5 () {
	if (hasRequiredIntegration$5) return integration$5;
	hasRequiredIntegration$5 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const helpers = /*@__PURE__*/ requireHelpers();
		const startProfileForSpan = /*@__PURE__*/ requireStartProfileForSpan();
		const UIProfiler = /*@__PURE__*/ requireUIProfiler();
		const utils = /*@__PURE__*/ requireUtils$4();

		const INTEGRATION_NAME = "BrowserProfiling";
		const _browserProfilingIntegration = (() => {
		  return {
		    name: INTEGRATION_NAME,
		    setup(client) {
		      const options = client.getOptions();
		      const profiler = new UIProfiler.UIProfiler();
		      if (!utils.hasLegacyProfiling(options) && !options.profileLifecycle) {
		        options.profileLifecycle = "manual";
		      }
		      if (utils.hasLegacyProfiling(options) && !options.profilesSampleRate) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] Profiling disabled, no profiling options found.");
		        return;
		      }
		      const activeSpan = browser.getActiveSpan();
		      const rootSpan = activeSpan && browser.getRootSpan(activeSpan);
		      if (utils.hasLegacyProfiling(options) && options.profileSessionSampleRate !== void 0) {
		        debugBuild.DEBUG_BUILD && browser.debug.warn(
		          "[Profiling] Both legacy profiling (`profilesSampleRate`) and UI profiling settings are defined. `profileSessionSampleRate` has no effect when legacy profiling is enabled."
		        );
		      }
		      if (!utils.hasLegacyProfiling(options)) {
		        const lifecycleMode = options.profileLifecycle;
		        client.on("startUIProfiler", () => profiler.start());
		        client.on("stopUIProfiler", () => profiler.stop());
		        if (lifecycleMode === "manual") {
		          profiler.initialize(client);
		        } else if (lifecycleMode === "trace") {
		          if (!browser.hasSpansEnabled(options)) {
		            debugBuild.DEBUG_BUILD && browser.debug.warn(
		              "[Profiling] `profileLifecycle` is 'trace' but tracing is disabled. Set a `tracesSampleRate` or `tracesSampler` to enable span tracing."
		            );
		            return;
		          }
		          profiler.initialize(client);
		          if (rootSpan) {
		            profiler.notifyRootSpanActive(rootSpan);
		          }
		          helpers.WINDOW.setTimeout(() => {
		            const laterActiveSpan = browser.getActiveSpan();
		            const laterRootSpan = laterActiveSpan && browser.getRootSpan(laterActiveSpan);
		            if (laterRootSpan) {
		              profiler.notifyRootSpanActive(laterRootSpan);
		            }
		          }, 0);
		        }
		      } else {
		        if (rootSpan && utils.isAutomatedPageLoadSpan(rootSpan)) {
		          if (utils.shouldProfileSpanLegacy(rootSpan)) {
		            startProfileForSpan.startProfileForSpan(rootSpan);
		          }
		        }
		        client.on("spanStart", (span) => {
		          const rootSpan2 = browser.getRootSpan(span);
		          if (span === rootSpan2) {
		            if (utils.shouldProfileSpanLegacy(span)) {
		              startProfileForSpan.startProfileForSpan(span);
		            }
		          } else if (utils.PROFILED_ROOT_SPANS.has(rootSpan2)) {
		            utils.setThreadAttributes(span);
		          }
		        });
		        client.on("beforeEnvelope", (envelope) => {
		          if (!utils.getActiveProfilesCount()) {
		            return;
		          }
		          const profiledTransactionEvents = utils.findProfiledTransactionsFromEnvelope(envelope);
		          if (!profiledTransactionEvents.length) {
		            return;
		          }
		          const profilesToAddToEnvelope = [];
		          for (const profiledTransaction of profiledTransactionEvents) {
		            const context = profiledTransaction?.contexts;
		            const profile_id = context?.profile?.["profile_id"];
		            const start_timestamp = context?.profile?.["start_timestamp"];
		            if (typeof profile_id !== "string") {
		              debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] cannot find profile for a span without a profile context");
		              continue;
		            }
		            if (!profile_id) {
		              debugBuild.DEBUG_BUILD && browser.debug.log("[Profiling] cannot find profile for a span without a profile context");
		              continue;
		            }
		            if (context?.profile) {
		              delete context.profile;
		            }
		            const profile = utils.takeProfileFromGlobalCache(profile_id);
		            if (!profile) {
		              debugBuild.DEBUG_BUILD && browser.debug.log(`[Profiling] Could not retrieve profile for span: ${profile_id}`);
		              continue;
		            }
		            const profileEvent = utils.createProfilingEvent(
		              profile_id,
		              start_timestamp,
		              profile,
		              profiledTransaction
		            );
		            if (profileEvent) {
		              profilesToAddToEnvelope.push(profileEvent);
		            }
		          }
		          utils.addProfilesToEnvelope(envelope, profilesToAddToEnvelope);
		        });
		      }
		    }
		  };
		});
		const browserProfilingIntegration = browser.defineIntegration(_browserProfilingIntegration);

		exports.browserProfilingIntegration = browserProfilingIntegration;
		
	} (integration$5));
	return integration$5;
}

var spotlight = {};

var hasRequiredSpotlight;

function requireSpotlight () {
	if (hasRequiredSpotlight) return spotlight;
	hasRequiredSpotlight = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const browserUtils = /*@__PURE__*/ requireCjs$2();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();

		const INTEGRATION_NAME = "SpotlightBrowser";
		const SPOTLIGHT_IGNORE_SPANS = [{ op: "ui.interaction.click", name: "#sentry-spotlight" }];
		const _spotlightIntegration = ((options = {}) => {
		  const sidecarUrl = options.sidecarUrl || "http://localhost:8969/stream";
		  return {
		    name: INTEGRATION_NAME,
		    setup: () => {
		      debugBuild.DEBUG_BUILD && browser.debug.log("Using Sidecar URL", sidecarUrl);
		    },
		    beforeSetup(client) {
		      const opts = client.getOptions();
		      opts.ignoreSpans = [...opts.ignoreSpans || [], ...SPOTLIGHT_IGNORE_SPANS];
		    },
		    afterAllSetup: (client) => {
		      setupSidecarForwarding(client, sidecarUrl);
		    }
		  };
		});
		function setupSidecarForwarding(client, sidecarUrl) {
		  const makeFetch = browserUtils.getNativeImplementation("fetch");
		  let failCount = 0;
		  client.on("beforeEnvelope", (envelope) => {
		    if (failCount > 3) {
		      browser.debug.warn("[Spotlight] Disabled Sentry -> Spotlight integration due to too many failed requests:", failCount);
		      return;
		    }
		    makeFetch(sidecarUrl, {
		      method: "POST",
		      body: browser.serializeEnvelope(envelope),
		      headers: {
		        "Content-Type": "application/x-sentry-envelope"
		      },
		      mode: "cors"
		    }).then(
		      (res) => {
		        if (res.status >= 200 && res.status < 400) {
		          failCount = 0;
		        }
		      },
		      (err) => {
		        failCount++;
		        browser.debug.error(
		          "Sentry SDK can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/",
		          err
		        );
		      }
		    );
		  });
		}
		const spotlightBrowserIntegration = browser.defineIntegration(_spotlightIntegration);

		exports.INTEGRATION_NAME = INTEGRATION_NAME;
		exports.SPOTLIGHT_IGNORE_SPANS = SPOTLIGHT_IGNORE_SPANS;
		exports.spotlightBrowserIntegration = spotlightBrowserIntegration;
		
	} (spotlight));
	return spotlight;
}

var integration$4 = {};

var hasRequiredIntegration$4;

function requireIntegration$4 () {
	if (hasRequiredIntegration$4) return integration$4;
	hasRequiredIntegration$4 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const launchDarklyIntegration = browser.defineIntegration(() => {
		  return {
		    name: "LaunchDarkly",
		    processEvent(event, _hint, _client) {
		      return browser._INTERNAL_copyFlagsFromScopeToEvent(event);
		    }
		  };
		});
		function buildLaunchDarklyFlagUsedHandler() {
		  return {
		    name: "sentry-flag-auditor",
		    type: "flag-used",
		    synchronous: true,
		    /**
		     * Handle a flag evaluation by storing its name and value on the current scope.
		     */
		    method: (flagKey, flagDetail, _context) => {
		      browser._INTERNAL_insertFlagToScope(flagKey, flagDetail.value);
		      browser._INTERNAL_addFeatureFlagToActiveSpan(flagKey, flagDetail.value);
		    }
		  };
		}

		exports.buildLaunchDarklyFlagUsedHandler = buildLaunchDarklyFlagUsedHandler;
		exports.launchDarklyIntegration = launchDarklyIntegration;
		
	} (integration$4));
	return integration$4;
}

var integration$3 = {};

var hasRequiredIntegration$3;

function requireIntegration$3 () {
	if (hasRequiredIntegration$3) return integration$3;
	hasRequiredIntegration$3 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const openFeatureIntegration = browser.defineIntegration(() => {
		  return {
		    name: "OpenFeature",
		    processEvent(event, _hint, _client) {
		      return browser._INTERNAL_copyFlagsFromScopeToEvent(event);
		    }
		  };
		});
		class OpenFeatureIntegrationHook {
		  /**
		   * Successful evaluation result.
		   */
		  after(_hookContext, evaluationDetails) {
		    browser._INTERNAL_insertFlagToScope(evaluationDetails.flagKey, evaluationDetails.value);
		    browser._INTERNAL_addFeatureFlagToActiveSpan(evaluationDetails.flagKey, evaluationDetails.value);
		  }
		  /**
		   * On error evaluation result.
		   */
		  error(hookContext, _error, _hookHints) {
		    browser._INTERNAL_insertFlagToScope(hookContext.flagKey, hookContext.defaultValue);
		    browser._INTERNAL_addFeatureFlagToActiveSpan(hookContext.flagKey, hookContext.defaultValue);
		  }
		}

		exports.OpenFeatureIntegrationHook = OpenFeatureIntegrationHook;
		exports.openFeatureIntegration = openFeatureIntegration;
		
	} (integration$3));
	return integration$3;
}

var integration$2 = {};

var hasRequiredIntegration$2;

function requireIntegration$2 () {
	if (hasRequiredIntegration$2) return integration$2;
	hasRequiredIntegration$2 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();

		const unleashIntegration = browser.defineIntegration(
		  ({ featureFlagClientClass: unleashClientClass }) => {
		    return {
		      name: "Unleash",
		      setupOnce() {
		        const unleashClientPrototype = unleashClientClass.prototype;
		        browser.fill(unleashClientPrototype, "isEnabled", _wrappedIsEnabled);
		      },
		      processEvent(event, _hint, _client) {
		        return browser._INTERNAL_copyFlagsFromScopeToEvent(event);
		      }
		    };
		  }
		);
		function _wrappedIsEnabled(original) {
		  return function(...args) {
		    const toggleName = args[0];
		    const result = original.apply(this, args);
		    if (typeof toggleName === "string" && typeof result === "boolean") {
		      browser._INTERNAL_insertFlagToScope(toggleName, result);
		      browser._INTERNAL_addFeatureFlagToActiveSpan(toggleName, result);
		    } else if (debugBuild.DEBUG_BUILD) {
		      browser.debug.error(
		        `[Feature Flags] UnleashClient.isEnabled does not match expected signature. arg0: ${toggleName} (${typeof toggleName}), result: ${result} (${typeof result})`
		      );
		    }
		    return result;
		  };
		}

		exports.unleashIntegration = unleashIntegration;
		
	} (integration$2));
	return integration$2;
}

var integration$1 = {};

var hasRequiredIntegration$1;

function requireIntegration$1 () {
	if (hasRequiredIntegration$1) return integration$1;
	hasRequiredIntegration$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const growthbookIntegration = (({ growthbookClass }) => browser.growthbookIntegration({ growthbookClass }));

		exports.growthbookIntegration = growthbookIntegration;
		
	} (integration$1));
	return integration$1;
}

var integration = {};

var hasRequiredIntegration;

function requireIntegration () {
	if (hasRequiredIntegration) return integration;
	hasRequiredIntegration = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		const statsigIntegration = browser.defineIntegration(
		  ({ featureFlagClient: statsigClient }) => {
		    return {
		      name: "Statsig",
		      setup(_client) {
		        statsigClient.on("gate_evaluation", (event) => {
		          browser._INTERNAL_insertFlagToScope(event.gate.name, event.gate.value);
		          browser._INTERNAL_addFeatureFlagToActiveSpan(event.gate.name, event.gate.value);
		        });
		      },
		      processEvent(event, _hint, _client) {
		        return browser._INTERNAL_copyFlagsFromScopeToEvent(event);
		      }
		    };
		  }
		);

		exports.statsigIntegration = statsigIntegration;
		
	} (integration));
	return integration;
}

var diagnoseSdk = {};

var hasRequiredDiagnoseSdk;

function requireDiagnoseSdk () {
	if (hasRequiredDiagnoseSdk) return diagnoseSdk;
	hasRequiredDiagnoseSdk = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();

		async function diagnoseSdkConnectivity() {
		  const client = browser.getClient();
		  if (!client) {
		    return "no-client-active";
		  }
		  if (!client.getDsn()) {
		    return "no-dsn-configured";
		  }
		  const tunnel = client.getOptions().tunnel;
		  const defaultUrl = "https://o447951.ingest.sentry.io/api/4509632503087104/envelope/?sentry_version=7&sentry_key=c1dfb07d783ad5325c245c1fd3725390&sentry_client=sentry.javascript.browser%2F1.33.7";
		  const url = tunnel || defaultUrl;
		  try {
		    await browser.suppressTracing(
		      () => (
		        // If fetch throws, there is likely an ad blocker active or there are other connective issues.
		        fetch(url, {
		          body: "{}",
		          method: "POST",
		          mode: "cors",
		          credentials: "omit"
		        })
		      )
		    );
		  } catch {
		    return "sentry-unreachable";
		  }
		}

		exports.diagnoseSdkConnectivity = diagnoseSdkConnectivity;
		
	} (diagnoseSdk));
	return diagnoseSdk;
}

var webWorker = {};

var hasRequiredWebWorker;

function requireWebWorker () {
	if (hasRequiredWebWorker) return webWorker;
	hasRequiredWebWorker = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const browser = /*@__PURE__*/ requireBrowser$c();
		const debugBuild = /*@__PURE__*/ requireDebugBuild();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder();
		const helpers = /*@__PURE__*/ requireHelpers();
		const globalhandlers = /*@__PURE__*/ requireGlobalhandlers();

		const INTEGRATION_NAME = "WebWorker";
		const webWorkerIntegration = browser.defineIntegration(({ worker }) => ({
		  name: INTEGRATION_NAME,
		  setupOnce: () => {
		    (Array.isArray(worker) ? worker : [worker]).forEach((w) => listenForSentryMessages(w));
		  },
		  addWorker: (worker2) => listenForSentryMessages(worker2)
		}));
		function listenForSentryMessages(worker) {
		  worker.addEventListener("message", (event) => {
		    if (isSentryMessage(event.data)) {
		      event.stopImmediatePropagation();
		      if (event.data._sentryDebugIds) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("Sentry debugId web worker message received", event.data);
		        helpers.WINDOW._sentryDebugIds = {
		          ...event.data._sentryDebugIds,
		          // debugIds of the main thread have precedence over the worker's in case of a collision.
		          ...helpers.WINDOW._sentryDebugIds
		        };
		      }
		      if (event.data._sentryModuleMetadata) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("Sentry module metadata web worker message received", event.data);
		        helpers.WINDOW._sentryModuleMetadata = {
		          ...event.data._sentryModuleMetadata,
		          // Module metadata of the main thread have precedence over the worker's in case of a collision.
		          ...helpers.WINDOW._sentryModuleMetadata
		        };
		      }
		      if (event.data._sentryWasmImages) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("Sentry WASM images web worker message received", event.data);
		        const existingImages = helpers.WINDOW._sentryWasmImages || [];
		        const newImages = event.data._sentryWasmImages.filter(
		          (newImg) => browser.isPlainObject(newImg) && typeof newImg.code_file === "string" && !existingImages.some((existing) => existing.code_file === newImg.code_file)
		        );
		        helpers.WINDOW._sentryWasmImages = [
		          ...existingImages,
		          ...newImages
		        ];
		      }
		      if (event.data._sentryWorkerError) {
		        debugBuild.DEBUG_BUILD && browser.debug.log("Sentry worker rejection message received", event.data._sentryWorkerError);
		        handleForwardedWorkerRejection(event.data._sentryWorkerError);
		      }
		    }
		  });
		}
		function handleForwardedWorkerRejection(workerError) {
		  const client = browser.getClient();
		  if (!client) {
		    return;
		  }
		  const stackParser = client.getOptions().stackParser;
		  const attachStacktrace = client.getOptions().attachStacktrace;
		  const error = workerError.reason;
		  const event = browser.isPrimitive(error) ? globalhandlers._eventFromRejectionWithPrimitive(error) : eventbuilder.eventFromUnknownInput(stackParser, error, void 0, attachStacktrace, true);
		  event.level = "error";
		  if (workerError.filename) {
		    event.contexts = {
		      ...event.contexts,
		      worker: {
		        filename: workerError.filename
		      }
		    };
		  }
		  browser.captureEvent(event, {
		    originalException: error,
		    mechanism: {
		      handled: false,
		      type: "auto.browser.web_worker.onunhandledrejection"
		    }
		  });
		  debugBuild.DEBUG_BUILD && browser.debug.log("Captured worker unhandled rejection", error);
		}
		function registerWebWorker({ self }) {
		  self.postMessage({
		    _sentryMessage: true,
		    _sentryDebugIds: self._sentryDebugIds ?? void 0,
		    _sentryModuleMetadata: self._sentryModuleMetadata ?? void 0
		  });
		  self.addEventListener("unhandledrejection", (event) => {
		    const reason = globalhandlers._getUnhandledRejectionError(event);
		    const serializedError = {
		      reason,
		      filename: self.location?.href
		    };
		    self.postMessage({
		      _sentryMessage: true,
		      _sentryWorkerError: serializedError
		    });
		    debugBuild.DEBUG_BUILD && browser.debug.log("[Sentry Worker] Forwarding unhandled rejection to parent", serializedError);
		  });
		  debugBuild.DEBUG_BUILD && browser.debug.log("[Sentry Worker] Registered worker with unhandled rejection handling");
		}
		function isSentryMessage(eventData) {
		  if (!browser.isPlainObject(eventData) || eventData._sentryMessage !== true) {
		    return false;
		  }
		  const hasDebugIds = "_sentryDebugIds" in eventData;
		  const hasModuleMetadata = "_sentryModuleMetadata" in eventData;
		  const hasWorkerError = "_sentryWorkerError" in eventData;
		  const hasWasmImages = "_sentryWasmImages" in eventData;
		  if (!hasDebugIds && !hasModuleMetadata && !hasWorkerError && !hasWasmImages) {
		    return false;
		  }
		  if (hasDebugIds && !(browser.isPlainObject(eventData._sentryDebugIds) || eventData._sentryDebugIds === void 0)) {
		    return false;
		  }
		  if (hasModuleMetadata && !(browser.isPlainObject(eventData._sentryModuleMetadata) || eventData._sentryModuleMetadata === void 0)) {
		    return false;
		  }
		  if (hasWorkerError && !browser.isPlainObject(eventData._sentryWorkerError)) {
		    return false;
		  }
		  if (hasWasmImages && (!Array.isArray(eventData._sentryWasmImages) || !eventData._sentryWasmImages.every(
		    (img) => browser.isPlainObject(img) && typeof img.code_file === "string"
		  ))) {
		    return false;
		  }
		  return true;
		}

		exports.INTEGRATION_NAME = INTEGRATION_NAME;
		exports.registerWebWorker = registerWebWorker;
		exports.webWorkerIntegration = webWorkerIntegration;
		
	} (webWorker));
	return webWorker;
}

var hasRequiredProd;

function requireProd () {
	if (hasRequiredProd) return prod;
	hasRequiredProd = 1;
	(function (exports) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

		const feedbackAsync = /*@__PURE__*/ requireFeedbackAsync();
		const feedbackSync = /*@__PURE__*/ requireFeedbackSync();
		const browser = /*@__PURE__*/ requireBrowser$c();
		const helpers = /*@__PURE__*/ requireHelpers();
		const client = /*@__PURE__*/ requireClient();
		const fetch = /*@__PURE__*/ requireFetch();
		const index = /*@__PURE__*/ requireProfiling();
		const stackParsers = /*@__PURE__*/ requireStackParsers();
		const eventbuilder = /*@__PURE__*/ requireEventbuilder();
		const userfeedback = /*@__PURE__*/ requireUserfeedback();
		const sdk = /*@__PURE__*/ requireSdk();
		const reportDialog = /*@__PURE__*/ requireReportDialog();
		const breadcrumbs = /*@__PURE__*/ requireBreadcrumbs();
		const globalhandlers = /*@__PURE__*/ requireGlobalhandlers();
		const httpcontext = /*@__PURE__*/ requireHttpcontext();
		const linkederrors = /*@__PURE__*/ requireLinkederrors();
		const browserapierrors = /*@__PURE__*/ requireBrowserapierrors();
		const browsersession = /*@__PURE__*/ requireBrowsersession();
		const lazyLoadIntegration = /*@__PURE__*/ requireLazyLoadIntegration();
		const reportingobserver = /*@__PURE__*/ requireReportingobserver();
		const httpclient = /*@__PURE__*/ requireHttpclient();
		const contextlines = /*@__PURE__*/ requireContextlines();
		const graphqlClient = /*@__PURE__*/ requireGraphqlClient();
		const viewHierarchy = /*@__PURE__*/ requireViewHierarchy();
		const replay = /*@__PURE__*/ requireCjs$1();
		const replayCanvas = /*@__PURE__*/ requireCjs();
		const feedback = /*@__PURE__*/ requireCjs$3();
		const request = /*@__PURE__*/ requireRequest();
		const browserTracingIntegration = /*@__PURE__*/ requireBrowserTracingIntegration();
		const browserUtils = /*@__PURE__*/ requireCjs$2();
		const normalizeStringifyValue = /*@__PURE__*/ requireNormalizeStringifyValue();
		const reportPageLoaded = /*@__PURE__*/ requireReportPageLoaded();
		const setActiveSpan = /*@__PURE__*/ requireSetActiveSpan();
		const spanstreaming = /*@__PURE__*/ requireSpanstreaming();
		const fetchStreamPerformance = /*@__PURE__*/ requireFetchStreamPerformance();
		const webVitals = /*@__PURE__*/ requireWebVitals();
		const offline = /*@__PURE__*/ requireOffline();
		const integration$1 = /*@__PURE__*/ requireIntegration$5();
		const spotlight = /*@__PURE__*/ requireSpotlight();
		const culturecontext = /*@__PURE__*/ requireCulturecontext();
		const integration$2 = /*@__PURE__*/ requireIntegration$4();
		const integration = /*@__PURE__*/ requireIntegration$3();
		const integration$5 = /*@__PURE__*/ requireIntegration$2();
		const integration$3 = /*@__PURE__*/ requireIntegration$1();
		const integration$4 = /*@__PURE__*/ requireIntegration();
		const diagnoseSdk = /*@__PURE__*/ requireDiagnoseSdk();
		const webWorker = /*@__PURE__*/ requireWebWorker();



		exports.feedbackAsyncIntegration = feedbackAsync.feedbackAsyncIntegration;
		exports.feedbackIntegration = feedbackSync.feedbackSyncIntegration;
		exports.feedbackSyncIntegration = feedbackSync.feedbackSyncIntegration;
		exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = browser.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
		exports.SDK_VERSION = browser.SDK_VERSION;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = browser.SEMANTIC_ATTRIBUTE_SENTRY_OP;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = browser.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = browser.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
		exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = browser.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
		exports.Scope = browser.Scope;
		exports.addBreadcrumb = browser.addBreadcrumb;
		exports.addEventProcessor = browser.addEventProcessor;
		exports.addIntegration = browser.addIntegration;
		exports.bindScopeToEmitter = browser.bindScopeToEmitter;
		exports.captureConsoleIntegration = browser.captureConsoleIntegration;
		exports.captureEvent = browser.captureEvent;
		exports.captureException = browser.captureException;
		exports.captureFeedback = browser.captureFeedback;
		exports.captureMessage = browser.captureMessage;
		exports.captureSession = browser.captureSession;
		exports.close = browser.close;
		exports.consoleLoggingIntegration = browser.consoleLoggingIntegration;
		exports.continueTrace = browser.continueTrace;
		exports.createConsolaReporter = browser.createConsolaReporter;
		exports.createLangChainCallbackHandler = browser.createLangChainCallbackHandler;
		exports.createTransport = browser.createTransport;
		exports.dedupeIntegration = browser.dedupeIntegration;
		exports.endSession = browser.endSession;
		exports.eventFiltersIntegration = browser.eventFiltersIntegration;
		exports.extraErrorDataIntegration = browser.extraErrorDataIntegration;
		exports.featureFlagsIntegration = browser.featureFlagsIntegration;
		exports.flush = browser.flush;
		exports.functionToStringIntegration = browser.functionToStringIntegration;
		exports.getActiveSpan = browser.getActiveSpan;
		exports.getClient = browser.getClient;
		exports.getCurrentScope = browser.getCurrentScope;
		exports.getGlobalScope = browser.getGlobalScope;
		exports.getIsolationScope = browser.getIsolationScope;
		exports.getRootSpan = browser.getRootSpan;
		exports.getSpanDescendants = browser.getSpanDescendants;
		exports.getSpanStatusFromHttpCode = browser.getSpanStatusFromHttpCode;
		exports.getTraceData = browser.getTraceData;
		exports.inboundFiltersIntegration = browser.inboundFiltersIntegration;
		exports.instrumentAnthropicAiClient = browser.instrumentAnthropicAiClient;
		exports.instrumentCreateReactAgent = browser.instrumentCreateReactAgent;
		exports.instrumentGoogleGenAIClient = browser.instrumentGoogleGenAIClient;
		exports.instrumentLangChainEmbeddings = browser.instrumentLangChainEmbeddings;
		exports.instrumentLangGraph = browser.instrumentLangGraph;
		exports.instrumentOpenAiClient = browser.instrumentOpenAiClient;
		exports.instrumentSupabaseClient = browser.instrumentSupabaseClient;
		exports.isEnabled = browser.isEnabled;
		exports.isInitialized = browser.isInitialized;
		exports.lastEventId = browser.lastEventId;
		exports.logger = browser.logger;
		exports.makeMultiplexedTransport = browser.makeMultiplexedTransport;
		exports.metrics = browser.metrics;
		exports.moduleMetadataIntegration = browser.moduleMetadataIntegration;
		exports.parameterize = browser.parameterize;
		exports.registerSpanErrorInstrumentation = browser.registerSpanErrorInstrumentation;
		exports.rewriteFramesIntegration = browser.rewriteFramesIntegration;
		exports.setContext = browser.setContext;
		exports.setConversationId = browser.setConversationId;
		exports.setCurrentClient = browser.setCurrentClient;
		exports.setExtra = browser.setExtra;
		exports.setExtras = browser.setExtras;
		exports.setHttpStatus = browser.setHttpStatus;
		exports.setMeasurement = browser.setMeasurement;
		exports.setTag = browser.setTag;
		exports.setTags = browser.setTags;
		exports.setUser = browser.setUser;
		exports.spanToBaggageHeader = browser.spanToBaggageHeader;
		exports.spanToJSON = browser.spanToJSON;
		exports.spanToTraceHeader = browser.spanToTraceHeader;
		exports.startInactiveSpan = browser.startInactiveSpan;
		exports.startNewTrace = browser.startNewTrace;
		exports.startSession = browser.startSession;
		exports.startSpan = browser.startSpan;
		exports.startSpanManual = browser.startSpanManual;
		exports.supabaseIntegration = browser.supabaseIntegration;
		exports.suppressTracing = browser.suppressTracing;
		exports.thirdPartyErrorFilterIntegration = browser.thirdPartyErrorFilterIntegration;
		exports.updateSpanName = browser.updateSpanName;
		exports.withActiveSpan = browser.withActiveSpan;
		exports.withIsolationScope = browser.withIsolationScope;
		exports.withScope = browser.withScope;
		exports.withStreamedSpan = browser.withStreamedSpan;
		exports.zodErrorsIntegration = browser.zodErrorsIntegration;
		exports.WINDOW = helpers.WINDOW;
		exports.BrowserClient = client.BrowserClient;
		exports.makeFetchTransport = fetch.makeFetchTransport;
		exports.uiProfiler = index.uiProfiler;
		exports.chromeStackLineParser = stackParsers.chromeStackLineParser;
		exports.defaultStackLineParsers = stackParsers.defaultStackLineParsers;
		exports.defaultStackParser = stackParsers.defaultStackParser;
		exports.geckoStackLineParser = stackParsers.geckoStackLineParser;
		exports.opera10StackLineParser = stackParsers.opera10StackLineParser;
		exports.opera11StackLineParser = stackParsers.opera11StackLineParser;
		exports.winjsStackLineParser = stackParsers.winjsStackLineParser;
		exports.eventFromException = eventbuilder.eventFromException;
		exports.eventFromMessage = eventbuilder.eventFromMessage;
		exports.exceptionFromError = eventbuilder.exceptionFromError;
		exports.createUserFeedbackEnvelope = userfeedback.createUserFeedbackEnvelope;
		exports.forceLoad = sdk.forceLoad;
		exports.getDefaultIntegrations = sdk.getDefaultIntegrations;
		exports.init = sdk.init;
		exports.onLoad = sdk.onLoad;
		exports.showReportDialog = reportDialog.showReportDialog;
		exports.breadcrumbsIntegration = breadcrumbs.breadcrumbsIntegration;
		exports.globalHandlersIntegration = globalhandlers.globalHandlersIntegration;
		exports.httpContextIntegration = httpcontext.httpContextIntegration;
		exports.linkedErrorsIntegration = linkederrors.linkedErrorsIntegration;
		exports.browserApiErrorsIntegration = browserapierrors.browserApiErrorsIntegration;
		exports.browserSessionIntegration = browsersession.browserSessionIntegration;
		exports.lazyLoadIntegration = lazyLoadIntegration.lazyLoadIntegration;
		exports.reportingObserverIntegration = reportingobserver.reportingObserverIntegration;
		exports.httpClientIntegration = httpclient.httpClientIntegration;
		exports.contextLinesIntegration = contextlines.contextLinesIntegration;
		exports.graphqlClientIntegration = graphqlClient.graphqlClientIntegration;
		exports.viewHierarchyIntegration = viewHierarchy.viewHierarchyIntegration;
		exports.getReplay = replay.getReplay;
		exports.replayIntegration = replay.replayIntegration;
		exports.replayCanvasIntegration = replayCanvas.replayCanvasIntegration;
		exports.getFeedback = feedback.getFeedback;
		exports.sendFeedback = feedback.sendFeedback;
		exports.defaultRequestInstrumentationOptions = request.defaultRequestInstrumentationOptions;
		exports.instrumentOutgoingRequests = request.instrumentOutgoingRequests;
		exports.browserTracingIntegration = browserTracingIntegration.browserTracingIntegration;
		exports.isBotUserAgent = browserTracingIntegration.isBotUserAgent;
		exports.startBrowserTracingNavigationSpan = browserTracingIntegration.startBrowserTracingNavigationSpan;
		exports.startBrowserTracingPageLoadSpan = browserTracingIntegration.startBrowserTracingPageLoadSpan;
		exports.elementTimingIntegration = browserUtils.elementTimingIntegration;
		exports.normalizeStringifyValue = normalizeStringifyValue.normalizeStringifyValue;
		exports.reportPageLoaded = reportPageLoaded.reportPageLoaded;
		exports.setActiveSpanInBrowser = setActiveSpan.setActiveSpanInBrowser;
		exports.spanStreamingIntegration = spanstreaming.spanStreamingIntegration;
		exports.fetchStreamPerformanceIntegration = fetchStreamPerformance.fetchStreamPerformanceIntegration;
		exports.webVitalsIntegration = webVitals.webVitalsIntegration;
		exports.makeBrowserOfflineTransport = offline.makeBrowserOfflineTransport;
		exports.browserProfilingIntegration = integration$1.browserProfilingIntegration;
		exports.spotlightBrowserIntegration = spotlight.spotlightBrowserIntegration;
		exports.cultureContextIntegration = culturecontext.cultureContextIntegration;
		exports.buildLaunchDarklyFlagUsedHandler = integration$2.buildLaunchDarklyFlagUsedHandler;
		exports.launchDarklyIntegration = integration$2.launchDarklyIntegration;
		exports.OpenFeatureIntegrationHook = integration.OpenFeatureIntegrationHook;
		exports.openFeatureIntegration = integration.openFeatureIntegration;
		exports.unleashIntegration = integration$5.unleashIntegration;
		exports.growthbookIntegration = integration$3.growthbookIntegration;
		exports.statsigIntegration = integration$4.statsigIntegration;
		exports.diagnoseSdkConnectivity = diagnoseSdk.diagnoseSdkConnectivity;
		exports.registerWebWorker = webWorker.registerWebWorker;
		exports.webWorkerIntegration = webWorker.webWorkerIntegration;
		
	} (prod));
	return prod;
}

var buffer$1 = {};

var base64Js = {};

var hasRequiredBase64Js;

function requireBase64Js () {
	if (hasRequiredBase64Js) return base64Js;
	hasRequiredBase64Js = 1;

	base64Js.byteLength = byteLength;
	base64Js.toByteArray = toByteArray;
	base64Js.fromByteArray = fromByteArray;

	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i];
	  revLookup[code.charCodeAt(i)] = i;
	}

	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;

	function getLens (b64) {
	  var len = b64.length;

	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=');
	  if (validLen === -1) validLen = len;

	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4);

	  return [validLen, placeHoldersLen]
	}

	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function toByteArray (b64) {
	  var tmp;
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];

	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

	  var curByte = 0;

	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen;

	  var i;
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)];
	    arr[curByte++] = (tmp >> 16) & 0xFF;
	    arr[curByte++] = (tmp >> 8) & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }

	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4);
	    arr[curByte++] = tmp & 0xFF;
	  }

	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2);
	    arr[curByte++] = (tmp >> 8) & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF);
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    );
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    );
	  }

	  return parts.join('')
	}
	return base64Js;
}

var ieee754 = {};

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */

var hasRequiredIeee754;

function requireIeee754 () {
	if (hasRequiredIeee754) return ieee754;
	hasRequiredIeee754 = 1;
	ieee754.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? (nBytes - 1) : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];

	  i += d;

	  e = s & ((1 << (-nBits)) - 1);
	  s >>= (-nBits);
	  nBits += eLen;
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1);
	  e >>= (-nBits);
	  nBits += mLen;
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	};

	ieee754.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
	  var i = isLE ? 0 : (nBytes - 1);
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

	  value = Math.abs(value);

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }

	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128;
	};
	return ieee754;
}

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var hasRequiredBuffer$1;

function requireBuffer$1 () {
	if (hasRequiredBuffer$1) return buffer$1;
	hasRequiredBuffer$1 = 1;
	(function (exports) {

		const base64 = requireBase64Js();
		const ieee754 = requireIeee754();
		const customInspectSymbol =
		  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
		    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
		    : null;

		exports.Buffer = Buffer;
		exports.SlowBuffer = SlowBuffer;
		exports.INSPECT_MAX_BYTES = 50;

		const K_MAX_LENGTH = 0x7fffffff;
		exports.kMaxLength = K_MAX_LENGTH;

		/**
		 * If `Buffer.TYPED_ARRAY_SUPPORT`:
		 *   === true    Use Uint8Array implementation (fastest)
		 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
		 *               implementation (most compatible, even IE6)
		 *
		 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
		 * Opera 11.6+, iOS 4.2+.
		 *
		 * We report that the browser does not support typed arrays if the are not subclassable
		 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
		 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
		 * for __proto__ and has a buggy typed array implementation.
		 */
		Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();

		if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
		    typeof console.error === 'function') {
		  console.error(
		    'This browser lacks typed array (Uint8Array) support which is required by ' +
		    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
		  );
		}

		function typedArraySupport () {
		  // Can typed array instances can be augmented?
		  try {
		    const arr = new Uint8Array(1);
		    const proto = { foo: function () { return 42 } };
		    Object.setPrototypeOf(proto, Uint8Array.prototype);
		    Object.setPrototypeOf(arr, proto);
		    return arr.foo() === 42
		  } catch (e) {
		    return false
		  }
		}

		Object.defineProperty(Buffer.prototype, 'parent', {
		  enumerable: true,
		  get: function () {
		    if (!Buffer.isBuffer(this)) return undefined
		    return this.buffer
		  }
		});

		Object.defineProperty(Buffer.prototype, 'offset', {
		  enumerable: true,
		  get: function () {
		    if (!Buffer.isBuffer(this)) return undefined
		    return this.byteOffset
		  }
		});

		function createBuffer (length) {
		  if (length > K_MAX_LENGTH) {
		    throw new RangeError('The value "' + length + '" is invalid for option "size"')
		  }
		  // Return an augmented `Uint8Array` instance
		  const buf = new Uint8Array(length);
		  Object.setPrototypeOf(buf, Buffer.prototype);
		  return buf
		}

		/**
		 * The Buffer constructor returns instances of `Uint8Array` that have their
		 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
		 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
		 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
		 * returns a single octet.
		 *
		 * The `Uint8Array` prototype remains unmodified.
		 */

		function Buffer (arg, encodingOrOffset, length) {
		  // Common case.
		  if (typeof arg === 'number') {
		    if (typeof encodingOrOffset === 'string') {
		      throw new TypeError(
		        'The "string" argument must be of type string. Received type number'
		      )
		    }
		    return allocUnsafe(arg)
		  }
		  return from(arg, encodingOrOffset, length)
		}

		Buffer.poolSize = 8192; // not used by this implementation

		function from (value, encodingOrOffset, length) {
		  if (typeof value === 'string') {
		    return fromString(value, encodingOrOffset)
		  }

		  if (ArrayBuffer.isView(value)) {
		    return fromArrayView(value)
		  }

		  if (value == null) {
		    throw new TypeError(
		      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
		      'or Array-like Object. Received type ' + (typeof value)
		    )
		  }

		  if (isInstance(value, ArrayBuffer) ||
		      (value && isInstance(value.buffer, ArrayBuffer))) {
		    return fromArrayBuffer(value, encodingOrOffset, length)
		  }

		  if (typeof SharedArrayBuffer !== 'undefined' &&
		      (isInstance(value, SharedArrayBuffer) ||
		      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
		    return fromArrayBuffer(value, encodingOrOffset, length)
		  }

		  if (typeof value === 'number') {
		    throw new TypeError(
		      'The "value" argument must not be of type number. Received type number'
		    )
		  }

		  const valueOf = value.valueOf && value.valueOf();
		  if (valueOf != null && valueOf !== value) {
		    return Buffer.from(valueOf, encodingOrOffset, length)
		  }

		  const b = fromObject(value);
		  if (b) return b

		  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
		      typeof value[Symbol.toPrimitive] === 'function') {
		    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
		  }

		  throw new TypeError(
		    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
		    'or Array-like Object. Received type ' + (typeof value)
		  )
		}

		/**
		 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
		 * if value is a number.
		 * Buffer.from(str[, encoding])
		 * Buffer.from(array)
		 * Buffer.from(buffer)
		 * Buffer.from(arrayBuffer[, byteOffset[, length]])
		 **/
		Buffer.from = function (value, encodingOrOffset, length) {
		  return from(value, encodingOrOffset, length)
		};

		// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
		// https://github.com/feross/buffer/pull/148
		Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
		Object.setPrototypeOf(Buffer, Uint8Array);

		function assertSize (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('"size" argument must be of type number')
		  } else if (size < 0) {
		    throw new RangeError('The value "' + size + '" is invalid for option "size"')
		  }
		}

		function alloc (size, fill, encoding) {
		  assertSize(size);
		  if (size <= 0) {
		    return createBuffer(size)
		  }
		  if (fill !== undefined) {
		    // Only pay attention to encoding if it's a string. This
		    // prevents accidentally sending in a number that would
		    // be interpreted as a start offset.
		    return typeof encoding === 'string'
		      ? createBuffer(size).fill(fill, encoding)
		      : createBuffer(size).fill(fill)
		  }
		  return createBuffer(size)
		}

		/**
		 * Creates a new filled Buffer instance.
		 * alloc(size[, fill[, encoding]])
		 **/
		Buffer.alloc = function (size, fill, encoding) {
		  return alloc(size, fill, encoding)
		};

		function allocUnsafe (size) {
		  assertSize(size);
		  return createBuffer(size < 0 ? 0 : checked(size) | 0)
		}

		/**
		 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
		 * */
		Buffer.allocUnsafe = function (size) {
		  return allocUnsafe(size)
		};
		/**
		 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
		 */
		Buffer.allocUnsafeSlow = function (size) {
		  return allocUnsafe(size)
		};

		function fromString (string, encoding) {
		  if (typeof encoding !== 'string' || encoding === '') {
		    encoding = 'utf8';
		  }

		  if (!Buffer.isEncoding(encoding)) {
		    throw new TypeError('Unknown encoding: ' + encoding)
		  }

		  const length = byteLength(string, encoding) | 0;
		  let buf = createBuffer(length);

		  const actual = buf.write(string, encoding);

		  if (actual !== length) {
		    // Writing a hex string, for example, that contains invalid characters will
		    // cause everything after the first invalid character to be ignored. (e.g.
		    // 'abxxcd' will be treated as 'ab')
		    buf = buf.slice(0, actual);
		  }

		  return buf
		}

		function fromArrayLike (array) {
		  const length = array.length < 0 ? 0 : checked(array.length) | 0;
		  const buf = createBuffer(length);
		  for (let i = 0; i < length; i += 1) {
		    buf[i] = array[i] & 255;
		  }
		  return buf
		}

		function fromArrayView (arrayView) {
		  if (isInstance(arrayView, Uint8Array)) {
		    const copy = new Uint8Array(arrayView);
		    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
		  }
		  return fromArrayLike(arrayView)
		}

		function fromArrayBuffer (array, byteOffset, length) {
		  if (byteOffset < 0 || array.byteLength < byteOffset) {
		    throw new RangeError('"offset" is outside of buffer bounds')
		  }

		  if (array.byteLength < byteOffset + (length || 0)) {
		    throw new RangeError('"length" is outside of buffer bounds')
		  }

		  let buf;
		  if (byteOffset === undefined && length === undefined) {
		    buf = new Uint8Array(array);
		  } else if (length === undefined) {
		    buf = new Uint8Array(array, byteOffset);
		  } else {
		    buf = new Uint8Array(array, byteOffset, length);
		  }

		  // Return an augmented `Uint8Array` instance
		  Object.setPrototypeOf(buf, Buffer.prototype);

		  return buf
		}

		function fromObject (obj) {
		  if (Buffer.isBuffer(obj)) {
		    const len = checked(obj.length) | 0;
		    const buf = createBuffer(len);

		    if (buf.length === 0) {
		      return buf
		    }

		    obj.copy(buf, 0, 0, len);
		    return buf
		  }

		  if (obj.length !== undefined) {
		    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
		      return createBuffer(0)
		    }
		    return fromArrayLike(obj)
		  }

		  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
		    return fromArrayLike(obj.data)
		  }
		}

		function checked (length) {
		  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
		  // length is NaN (which is otherwise coerced to zero.)
		  if (length >= K_MAX_LENGTH) {
		    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
		                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
		  }
		  return length | 0
		}

		function SlowBuffer (length) {
		  if (+length != length) { // eslint-disable-line eqeqeq
		    length = 0;
		  }
		  return Buffer.alloc(+length)
		}

		Buffer.isBuffer = function isBuffer (b) {
		  return b != null && b._isBuffer === true &&
		    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
		};

		Buffer.compare = function compare (a, b) {
		  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
		  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
		  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
		    throw new TypeError(
		      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
		    )
		  }

		  if (a === b) return 0

		  let x = a.length;
		  let y = b.length;

		  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
		    if (a[i] !== b[i]) {
		      x = a[i];
		      y = b[i];
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		};

		Buffer.isEncoding = function isEncoding (encoding) {
		  switch (String(encoding).toLowerCase()) {
		    case 'hex':
		    case 'utf8':
		    case 'utf-8':
		    case 'ascii':
		    case 'latin1':
		    case 'binary':
		    case 'base64':
		    case 'ucs2':
		    case 'ucs-2':
		    case 'utf16le':
		    case 'utf-16le':
		      return true
		    default:
		      return false
		  }
		};

		Buffer.concat = function concat (list, length) {
		  if (!Array.isArray(list)) {
		    throw new TypeError('"list" argument must be an Array of Buffers')
		  }

		  if (list.length === 0) {
		    return Buffer.alloc(0)
		  }

		  let i;
		  if (length === undefined) {
		    length = 0;
		    for (i = 0; i < list.length; ++i) {
		      length += list[i].length;
		    }
		  }

		  const buffer = Buffer.allocUnsafe(length);
		  let pos = 0;
		  for (i = 0; i < list.length; ++i) {
		    let buf = list[i];
		    if (isInstance(buf, Uint8Array)) {
		      if (pos + buf.length > buffer.length) {
		        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
		        buf.copy(buffer, pos);
		      } else {
		        Uint8Array.prototype.set.call(
		          buffer,
		          buf,
		          pos
		        );
		      }
		    } else if (!Buffer.isBuffer(buf)) {
		      throw new TypeError('"list" argument must be an Array of Buffers')
		    } else {
		      buf.copy(buffer, pos);
		    }
		    pos += buf.length;
		  }
		  return buffer
		};

		function byteLength (string, encoding) {
		  if (Buffer.isBuffer(string)) {
		    return string.length
		  }
		  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
		    return string.byteLength
		  }
		  if (typeof string !== 'string') {
		    throw new TypeError(
		      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
		      'Received type ' + typeof string
		    )
		  }

		  const len = string.length;
		  const mustMatch = (arguments.length > 2 && arguments[2] === true);
		  if (!mustMatch && len === 0) return 0

		  // Use a for loop to avoid recursion
		  let loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return len
		      case 'utf8':
		      case 'utf-8':
		        return utf8ToBytes(string).length
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return len * 2
		      case 'hex':
		        return len >>> 1
		      case 'base64':
		        return base64ToBytes(string).length
		      default:
		        if (loweredCase) {
		          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
		        }
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		}
		Buffer.byteLength = byteLength;

		function slowToString (encoding, start, end) {
		  let loweredCase = false;

		  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
		  // property of a typed array.

		  // This behaves neither like String nor Uint8Array in that we set start/end
		  // to their upper/lower bounds if the value passed is out of range.
		  // undefined is handled specially as per ECMA-262 6th Edition,
		  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
		  if (start === undefined || start < 0) {
		    start = 0;
		  }
		  // Return early if start > this.length. Done here to prevent potential uint32
		  // coercion fail below.
		  if (start > this.length) {
		    return ''
		  }

		  if (end === undefined || end > this.length) {
		    end = this.length;
		  }

		  if (end <= 0) {
		    return ''
		  }

		  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
		  end >>>= 0;
		  start >>>= 0;

		  if (end <= start) {
		    return ''
		  }

		  if (!encoding) encoding = 'utf8';

		  while (true) {
		    switch (encoding) {
		      case 'hex':
		        return hexSlice(this, start, end)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Slice(this, start, end)

		      case 'ascii':
		        return asciiSlice(this, start, end)

		      case 'latin1':
		      case 'binary':
		        return latin1Slice(this, start, end)

		      case 'base64':
		        return base64Slice(this, start, end)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return utf16leSlice(this, start, end)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = (encoding + '').toLowerCase();
		        loweredCase = true;
		    }
		  }
		}

		// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
		// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
		// reliably in a browserify context because there could be multiple different
		// copies of the 'buffer' package in use. This method works even for Buffer
		// instances that were created from another copy of the `buffer` package.
		// See: https://github.com/feross/buffer/issues/154
		Buffer.prototype._isBuffer = true;

		function swap (b, n, m) {
		  const i = b[n];
		  b[n] = b[m];
		  b[m] = i;
		}

		Buffer.prototype.swap16 = function swap16 () {
		  const len = this.length;
		  if (len % 2 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 16-bits')
		  }
		  for (let i = 0; i < len; i += 2) {
		    swap(this, i, i + 1);
		  }
		  return this
		};

		Buffer.prototype.swap32 = function swap32 () {
		  const len = this.length;
		  if (len % 4 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 32-bits')
		  }
		  for (let i = 0; i < len; i += 4) {
		    swap(this, i, i + 3);
		    swap(this, i + 1, i + 2);
		  }
		  return this
		};

		Buffer.prototype.swap64 = function swap64 () {
		  const len = this.length;
		  if (len % 8 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 64-bits')
		  }
		  for (let i = 0; i < len; i += 8) {
		    swap(this, i, i + 7);
		    swap(this, i + 1, i + 6);
		    swap(this, i + 2, i + 5);
		    swap(this, i + 3, i + 4);
		  }
		  return this
		};

		Buffer.prototype.toString = function toString () {
		  const length = this.length;
		  if (length === 0) return ''
		  if (arguments.length === 0) return utf8Slice(this, 0, length)
		  return slowToString.apply(this, arguments)
		};

		Buffer.prototype.toLocaleString = Buffer.prototype.toString;

		Buffer.prototype.equals = function equals (b) {
		  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
		  if (this === b) return true
		  return Buffer.compare(this, b) === 0
		};

		Buffer.prototype.inspect = function inspect () {
		  let str = '';
		  const max = exports.INSPECT_MAX_BYTES;
		  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
		  if (this.length > max) str += ' ... ';
		  return '<Buffer ' + str + '>'
		};
		if (customInspectSymbol) {
		  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
		}

		Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
		  if (isInstance(target, Uint8Array)) {
		    target = Buffer.from(target, target.offset, target.byteLength);
		  }
		  if (!Buffer.isBuffer(target)) {
		    throw new TypeError(
		      'The "target" argument must be one of type Buffer or Uint8Array. ' +
		      'Received type ' + (typeof target)
		    )
		  }

		  if (start === undefined) {
		    start = 0;
		  }
		  if (end === undefined) {
		    end = target ? target.length : 0;
		  }
		  if (thisStart === undefined) {
		    thisStart = 0;
		  }
		  if (thisEnd === undefined) {
		    thisEnd = this.length;
		  }

		  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
		    throw new RangeError('out of range index')
		  }

		  if (thisStart >= thisEnd && start >= end) {
		    return 0
		  }
		  if (thisStart >= thisEnd) {
		    return -1
		  }
		  if (start >= end) {
		    return 1
		  }

		  start >>>= 0;
		  end >>>= 0;
		  thisStart >>>= 0;
		  thisEnd >>>= 0;

		  if (this === target) return 0

		  let x = thisEnd - thisStart;
		  let y = end - start;
		  const len = Math.min(x, y);

		  const thisCopy = this.slice(thisStart, thisEnd);
		  const targetCopy = target.slice(start, end);

		  for (let i = 0; i < len; ++i) {
		    if (thisCopy[i] !== targetCopy[i]) {
		      x = thisCopy[i];
		      y = targetCopy[i];
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		};

		// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
		// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
		//
		// Arguments:
		// - buffer - a Buffer to search
		// - val - a string, Buffer, or number
		// - byteOffset - an index into `buffer`; will be clamped to an int32
		// - encoding - an optional encoding, relevant is val is a string
		// - dir - true for indexOf, false for lastIndexOf
		function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
		  // Empty buffer means no match
		  if (buffer.length === 0) return -1

		  // Normalize byteOffset
		  if (typeof byteOffset === 'string') {
		    encoding = byteOffset;
		    byteOffset = 0;
		  } else if (byteOffset > 0x7fffffff) {
		    byteOffset = 0x7fffffff;
		  } else if (byteOffset < -0x80000000) {
		    byteOffset = -0x80000000;
		  }
		  byteOffset = +byteOffset; // Coerce to Number.
		  if (numberIsNaN(byteOffset)) {
		    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
		    byteOffset = dir ? 0 : (buffer.length - 1);
		  }

		  // Normalize byteOffset: negative offsets start from the end of the buffer
		  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
		  if (byteOffset >= buffer.length) {
		    if (dir) return -1
		    else byteOffset = buffer.length - 1;
		  } else if (byteOffset < 0) {
		    if (dir) byteOffset = 0;
		    else return -1
		  }

		  // Normalize val
		  if (typeof val === 'string') {
		    val = Buffer.from(val, encoding);
		  }

		  // Finally, search either indexOf (if dir is true) or lastIndexOf
		  if (Buffer.isBuffer(val)) {
		    // Special case: looking for empty string/buffer always fails
		    if (val.length === 0) {
		      return -1
		    }
		    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
		  } else if (typeof val === 'number') {
		    val = val & 0xFF; // Search for a byte value [0-255]
		    if (typeof Uint8Array.prototype.indexOf === 'function') {
		      if (dir) {
		        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
		      } else {
		        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
		      }
		    }
		    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
		  }

		  throw new TypeError('val must be string, number or Buffer')
		}

		function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
		  let indexSize = 1;
		  let arrLength = arr.length;
		  let valLength = val.length;

		  if (encoding !== undefined) {
		    encoding = String(encoding).toLowerCase();
		    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
		        encoding === 'utf16le' || encoding === 'utf-16le') {
		      if (arr.length < 2 || val.length < 2) {
		        return -1
		      }
		      indexSize = 2;
		      arrLength /= 2;
		      valLength /= 2;
		      byteOffset /= 2;
		    }
		  }

		  function read (buf, i) {
		    if (indexSize === 1) {
		      return buf[i]
		    } else {
		      return buf.readUInt16BE(i * indexSize)
		    }
		  }

		  let i;
		  if (dir) {
		    let foundIndex = -1;
		    for (i = byteOffset; i < arrLength; i++) {
		      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
		        if (foundIndex === -1) foundIndex = i;
		        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
		      } else {
		        if (foundIndex !== -1) i -= i - foundIndex;
		        foundIndex = -1;
		      }
		    }
		  } else {
		    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
		    for (i = byteOffset; i >= 0; i--) {
		      let found = true;
		      for (let j = 0; j < valLength; j++) {
		        if (read(arr, i + j) !== read(val, j)) {
		          found = false;
		          break
		        }
		      }
		      if (found) return i
		    }
		  }

		  return -1
		}

		Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
		  return this.indexOf(val, byteOffset, encoding) !== -1
		};

		Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
		};

		Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
		};

		function hexWrite (buf, string, offset, length) {
		  offset = Number(offset) || 0;
		  const remaining = buf.length - offset;
		  if (!length) {
		    length = remaining;
		  } else {
		    length = Number(length);
		    if (length > remaining) {
		      length = remaining;
		    }
		  }

		  const strLen = string.length;

		  if (length > strLen / 2) {
		    length = strLen / 2;
		  }
		  let i;
		  for (i = 0; i < length; ++i) {
		    const parsed = parseInt(string.substr(i * 2, 2), 16);
		    if (numberIsNaN(parsed)) return i
		    buf[offset + i] = parsed;
		  }
		  return i
		}

		function utf8Write (buf, string, offset, length) {
		  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
		}

		function asciiWrite (buf, string, offset, length) {
		  return blitBuffer(asciiToBytes(string), buf, offset, length)
		}

		function base64Write (buf, string, offset, length) {
		  return blitBuffer(base64ToBytes(string), buf, offset, length)
		}

		function ucs2Write (buf, string, offset, length) {
		  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
		}

		Buffer.prototype.write = function write (string, offset, length, encoding) {
		  // Buffer#write(string)
		  if (offset === undefined) {
		    encoding = 'utf8';
		    length = this.length;
		    offset = 0;
		  // Buffer#write(string, encoding)
		  } else if (length === undefined && typeof offset === 'string') {
		    encoding = offset;
		    length = this.length;
		    offset = 0;
		  // Buffer#write(string, offset[, length][, encoding])
		  } else if (isFinite(offset)) {
		    offset = offset >>> 0;
		    if (isFinite(length)) {
		      length = length >>> 0;
		      if (encoding === undefined) encoding = 'utf8';
		    } else {
		      encoding = length;
		      length = undefined;
		    }
		  } else {
		    throw new Error(
		      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
		    )
		  }

		  const remaining = this.length - offset;
		  if (length === undefined || length > remaining) length = remaining;

		  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
		    throw new RangeError('Attempt to write outside buffer bounds')
		  }

		  if (!encoding) encoding = 'utf8';

		  let loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'hex':
		        return hexWrite(this, string, offset, length)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Write(this, string, offset, length)

		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return asciiWrite(this, string, offset, length)

		      case 'base64':
		        // Warning: maxLength not taken into account in base64Write
		        return base64Write(this, string, offset, length)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return ucs2Write(this, string, offset, length)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		};

		Buffer.prototype.toJSON = function toJSON () {
		  return {
		    type: 'Buffer',
		    data: Array.prototype.slice.call(this._arr || this, 0)
		  }
		};

		function base64Slice (buf, start, end) {
		  if (start === 0 && end === buf.length) {
		    return base64.fromByteArray(buf)
		  } else {
		    return base64.fromByteArray(buf.slice(start, end))
		  }
		}

		function utf8Slice (buf, start, end) {
		  end = Math.min(buf.length, end);
		  const res = [];

		  let i = start;
		  while (i < end) {
		    const firstByte = buf[i];
		    let codePoint = null;
		    let bytesPerSequence = (firstByte > 0xEF)
		      ? 4
		      : (firstByte > 0xDF)
		          ? 3
		          : (firstByte > 0xBF)
		              ? 2
		              : 1;

		    if (i + bytesPerSequence <= end) {
		      let secondByte, thirdByte, fourthByte, tempCodePoint;

		      switch (bytesPerSequence) {
		        case 1:
		          if (firstByte < 0x80) {
		            codePoint = firstByte;
		          }
		          break
		        case 2:
		          secondByte = buf[i + 1];
		          if ((secondByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
		            if (tempCodePoint > 0x7F) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break
		        case 3:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
		            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break
		        case 4:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          fourthByte = buf[i + 3];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
		            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
		              codePoint = tempCodePoint;
		            }
		          }
		      }
		    }

		    if (codePoint === null) {
		      // we did not generate a valid codePoint so insert a
		      // replacement char (U+FFFD) and advance only 1 byte
		      codePoint = 0xFFFD;
		      bytesPerSequence = 1;
		    } else if (codePoint > 0xFFFF) {
		      // encode to utf16 (surrogate pair dance)
		      codePoint -= 0x10000;
		      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
		      codePoint = 0xDC00 | codePoint & 0x3FF;
		    }

		    res.push(codePoint);
		    i += bytesPerSequence;
		  }

		  return decodeCodePointsArray(res)
		}

		// Based on http://stackoverflow.com/a/22747272/680742, the browser with
		// the lowest limit is Chrome, with 0x10000 args.
		// We go 1 magnitude less, for safety
		const MAX_ARGUMENTS_LENGTH = 0x1000;

		function decodeCodePointsArray (codePoints) {
		  const len = codePoints.length;
		  if (len <= MAX_ARGUMENTS_LENGTH) {
		    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
		  }

		  // Decode in chunks to avoid "call stack size exceeded".
		  let res = '';
		  let i = 0;
		  while (i < len) {
		    res += String.fromCharCode.apply(
		      String,
		      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
		    );
		  }
		  return res
		}

		function asciiSlice (buf, start, end) {
		  let ret = '';
		  end = Math.min(buf.length, end);

		  for (let i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i] & 0x7F);
		  }
		  return ret
		}

		function latin1Slice (buf, start, end) {
		  let ret = '';
		  end = Math.min(buf.length, end);

		  for (let i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i]);
		  }
		  return ret
		}

		function hexSlice (buf, start, end) {
		  const len = buf.length;

		  if (!start || start < 0) start = 0;
		  if (!end || end < 0 || end > len) end = len;

		  let out = '';
		  for (let i = start; i < end; ++i) {
		    out += hexSliceLookupTable[buf[i]];
		  }
		  return out
		}

		function utf16leSlice (buf, start, end) {
		  const bytes = buf.slice(start, end);
		  let res = '';
		  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
		  for (let i = 0; i < bytes.length - 1; i += 2) {
		    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256));
		  }
		  return res
		}

		Buffer.prototype.slice = function slice (start, end) {
		  const len = this.length;
		  start = ~~start;
		  end = end === undefined ? len : ~~end;

		  if (start < 0) {
		    start += len;
		    if (start < 0) start = 0;
		  } else if (start > len) {
		    start = len;
		  }

		  if (end < 0) {
		    end += len;
		    if (end < 0) end = 0;
		  } else if (end > len) {
		    end = len;
		  }

		  if (end < start) end = start;

		  const newBuf = this.subarray(start, end);
		  // Return an augmented `Uint8Array` instance
		  Object.setPrototypeOf(newBuf, Buffer.prototype);

		  return newBuf
		};

		/*
		 * Need to make sure that buffer isn't trying to write out of bounds.
		 */
		function checkOffset (offset, ext, length) {
		  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
		  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
		}

		Buffer.prototype.readUintLE =
		Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let val = this[offset];
		  let mul = 1;
		  let i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }

		  return val
		};

		Buffer.prototype.readUintBE =
		Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    checkOffset(offset, byteLength, this.length);
		  }

		  let val = this[offset + --byteLength];
		  let mul = 1;
		  while (byteLength > 0 && (mul *= 0x100)) {
		    val += this[offset + --byteLength] * mul;
		  }

		  return val
		};

		Buffer.prototype.readUint8 =
		Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  return this[offset]
		};

		Buffer.prototype.readUint16LE =
		Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return this[offset] | (this[offset + 1] << 8)
		};

		Buffer.prototype.readUint16BE =
		Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return (this[offset] << 8) | this[offset + 1]
		};

		Buffer.prototype.readUint32LE =
		Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return ((this[offset]) |
		      (this[offset + 1] << 8) |
		      (this[offset + 2] << 16)) +
		      (this[offset + 3] * 0x1000000)
		};

		Buffer.prototype.readUint32BE =
		Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset] * 0x1000000) +
		    ((this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    this[offset + 3])
		};

		Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const lo = first +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 24;

		  const hi = this[++offset] +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    last * 2 ** 24;

		  return BigInt(lo) + (BigInt(hi) << BigInt(32))
		});

		Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const hi = first * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    this[++offset];

		  const lo = this[++offset] * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    last;

		  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
		});

		Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let val = this[offset];
		  let mul = 1;
		  let i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }
		  mul *= 0x80;

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

		  return val
		};

		Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let i = byteLength;
		  let mul = 1;
		  let val = this[offset + --i];
		  while (i > 0 && (mul *= 0x100)) {
		    val += this[offset + --i] * mul;
		  }
		  mul *= 0x80;

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

		  return val
		};

		Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  if (!(this[offset] & 0x80)) return (this[offset])
		  return ((0xff - this[offset] + 1) * -1)
		};

		Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  const val = this[offset] | (this[offset + 1] << 8);
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		};

		Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  const val = this[offset + 1] | (this[offset] << 8);
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		};

		Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset]) |
		    (this[offset + 1] << 8) |
		    (this[offset + 2] << 16) |
		    (this[offset + 3] << 24)
		};

		Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset] << 24) |
		    (this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    (this[offset + 3])
		};

		Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const val = this[offset + 4] +
		    this[offset + 5] * 2 ** 8 +
		    this[offset + 6] * 2 ** 16 +
		    (last << 24); // Overflow

		  return (BigInt(val) << BigInt(32)) +
		    BigInt(first +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 24)
		});

		Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const val = (first << 24) + // Overflow
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    this[++offset];

		  return (BigInt(val) << BigInt(32)) +
		    BigInt(this[++offset] * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    last)
		});

		Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754.read(this, offset, true, 23, 4)
		};

		Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754.read(this, offset, false, 23, 4)
		};

		Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754.read(this, offset, true, 52, 8)
		};

		Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754.read(this, offset, false, 52, 8)
		};

		function checkInt (buf, value, offset, ext, max, min) {
		  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
		  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		}

		Buffer.prototype.writeUintLE =
		Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    const maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }

		  let mul = 1;
		  let i = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeUintBE =
		Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    const maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }

		  let i = byteLength - 1;
		  let mul = 1;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeUint8 =
		Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
		  this[offset] = (value & 0xff);
		  return offset + 1
		};

		Buffer.prototype.writeUint16LE =
		Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  return offset + 2
		};

		Buffer.prototype.writeUint16BE =
		Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  this[offset] = (value >>> 8);
		  this[offset + 1] = (value & 0xff);
		  return offset + 2
		};

		Buffer.prototype.writeUint32LE =
		Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  this[offset + 3] = (value >>> 24);
		  this[offset + 2] = (value >>> 16);
		  this[offset + 1] = (value >>> 8);
		  this[offset] = (value & 0xff);
		  return offset + 4
		};

		Buffer.prototype.writeUint32BE =
		Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  this[offset] = (value >>> 24);
		  this[offset + 1] = (value >>> 16);
		  this[offset + 2] = (value >>> 8);
		  this[offset + 3] = (value & 0xff);
		  return offset + 4
		};

		function wrtBigUInt64LE (buf, value, offset, min, max) {
		  checkIntBI(value, min, max, buf, offset, 7);

		  let lo = Number(value & BigInt(0xffffffff));
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  return offset
		}

		function wrtBigUInt64BE (buf, value, offset, min, max) {
		  checkIntBI(value, min, max, buf, offset, 7);

		  let lo = Number(value & BigInt(0xffffffff));
		  buf[offset + 7] = lo;
		  lo = lo >> 8;
		  buf[offset + 6] = lo;
		  lo = lo >> 8;
		  buf[offset + 5] = lo;
		  lo = lo >> 8;
		  buf[offset + 4] = lo;
		  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
		  buf[offset + 3] = hi;
		  hi = hi >> 8;
		  buf[offset + 2] = hi;
		  hi = hi >> 8;
		  buf[offset + 1] = hi;
		  hi = hi >> 8;
		  buf[offset] = hi;
		  return offset + 8
		}

		Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
		  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
		});

		Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
		  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
		});

		Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    const limit = Math.pow(2, (8 * byteLength) - 1);

		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }

		  let i = 0;
		  let mul = 1;
		  let sub = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    const limit = Math.pow(2, (8 * byteLength) - 1);

		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }

		  let i = byteLength - 1;
		  let mul = 1;
		  let sub = 0;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
		  if (value < 0) value = 0xff + value + 1;
		  this[offset] = (value & 0xff);
		  return offset + 1
		};

		Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  return offset + 2
		};

		Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
		  this[offset] = (value >>> 8);
		  this[offset + 1] = (value & 0xff);
		  return offset + 2
		};

		Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  this[offset + 2] = (value >>> 16);
		  this[offset + 3] = (value >>> 24);
		  return offset + 4
		};

		Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
		  if (value < 0) value = 0xffffffff + value + 1;
		  this[offset] = (value >>> 24);
		  this[offset + 1] = (value >>> 16);
		  this[offset + 2] = (value >>> 8);
		  this[offset + 3] = (value & 0xff);
		  return offset + 4
		};

		Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
		  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
		});

		Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
		  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
		});

		function checkIEEE754 (buf, value, offset, ext, max, min) {
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		  if (offset < 0) throw new RangeError('Index out of range')
		}

		function writeFloat (buf, value, offset, littleEndian, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 4);
		  }
		  ieee754.write(buf, value, offset, littleEndian, 23, 4);
		  return offset + 4
		}

		Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, true, noAssert)
		};

		Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, false, noAssert)
		};

		function writeDouble (buf, value, offset, littleEndian, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 8);
		  }
		  ieee754.write(buf, value, offset, littleEndian, 52, 8);
		  return offset + 8
		}

		Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, true, noAssert)
		};

		Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, false, noAssert)
		};

		// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
		Buffer.prototype.copy = function copy (target, targetStart, start, end) {
		  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
		  if (!start) start = 0;
		  if (!end && end !== 0) end = this.length;
		  if (targetStart >= target.length) targetStart = target.length;
		  if (!targetStart) targetStart = 0;
		  if (end > 0 && end < start) end = start;

		  // Copy 0 bytes; we're done
		  if (end === start) return 0
		  if (target.length === 0 || this.length === 0) return 0

		  // Fatal error conditions
		  if (targetStart < 0) {
		    throw new RangeError('targetStart out of bounds')
		  }
		  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
		  if (end < 0) throw new RangeError('sourceEnd out of bounds')

		  // Are we oob?
		  if (end > this.length) end = this.length;
		  if (target.length - targetStart < end - start) {
		    end = target.length - targetStart + start;
		  }

		  const len = end - start;

		  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
		    // Use built-in when available, missing from IE11
		    this.copyWithin(targetStart, start, end);
		  } else {
		    Uint8Array.prototype.set.call(
		      target,
		      this.subarray(start, end),
		      targetStart
		    );
		  }

		  return len
		};

		// Usage:
		//    buffer.fill(number[, offset[, end]])
		//    buffer.fill(buffer[, offset[, end]])
		//    buffer.fill(string[, offset[, end]][, encoding])
		Buffer.prototype.fill = function fill (val, start, end, encoding) {
		  // Handle string cases:
		  if (typeof val === 'string') {
		    if (typeof start === 'string') {
		      encoding = start;
		      start = 0;
		      end = this.length;
		    } else if (typeof end === 'string') {
		      encoding = end;
		      end = this.length;
		    }
		    if (encoding !== undefined && typeof encoding !== 'string') {
		      throw new TypeError('encoding must be a string')
		    }
		    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
		      throw new TypeError('Unknown encoding: ' + encoding)
		    }
		    if (val.length === 1) {
		      const code = val.charCodeAt(0);
		      if ((encoding === 'utf8' && code < 128) ||
		          encoding === 'latin1') {
		        // Fast path: If `val` fits into a single byte, use that numeric value.
		        val = code;
		      }
		    }
		  } else if (typeof val === 'number') {
		    val = val & 255;
		  } else if (typeof val === 'boolean') {
		    val = Number(val);
		  }

		  // Invalid ranges are not set to a default, so can range check early.
		  if (start < 0 || this.length < start || this.length < end) {
		    throw new RangeError('Out of range index')
		  }

		  if (end <= start) {
		    return this
		  }

		  start = start >>> 0;
		  end = end === undefined ? this.length : end >>> 0;

		  if (!val) val = 0;

		  let i;
		  if (typeof val === 'number') {
		    for (i = start; i < end; ++i) {
		      this[i] = val;
		    }
		  } else {
		    const bytes = Buffer.isBuffer(val)
		      ? val
		      : Buffer.from(val, encoding);
		    const len = bytes.length;
		    if (len === 0) {
		      throw new TypeError('The value "' + val +
		        '" is invalid for argument "value"')
		    }
		    for (i = 0; i < end - start; ++i) {
		      this[i + start] = bytes[i % len];
		    }
		  }

		  return this
		};

		// CUSTOM ERRORS
		// =============

		// Simplified versions from Node, changed for Buffer-only usage
		const errors = {};
		function E (sym, getMessage, Base) {
		  errors[sym] = class NodeError extends Base {
		    constructor () {
		      super();

		      Object.defineProperty(this, 'message', {
		        value: getMessage.apply(this, arguments),
		        writable: true,
		        configurable: true
		      });

		      // Add the error code to the name to include it in the stack trace.
		      this.name = `${this.name} [${sym}]`;
		      // Access the stack to generate the error message including the error code
		      // from the name.
		      this.stack; // eslint-disable-line no-unused-expressions
		      // Reset the name to the actual name.
		      delete this.name;
		    }

		    get code () {
		      return sym
		    }

		    set code (value) {
		      Object.defineProperty(this, 'code', {
		        configurable: true,
		        enumerable: true,
		        value,
		        writable: true
		      });
		    }

		    toString () {
		      return `${this.name} [${sym}]: ${this.message}`
		    }
		  };
		}

		E('ERR_BUFFER_OUT_OF_BOUNDS',
		  function (name) {
		    if (name) {
		      return `${name} is outside of buffer bounds`
		    }

		    return 'Attempt to access memory outside buffer bounds'
		  }, RangeError);
		E('ERR_INVALID_ARG_TYPE',
		  function (name, actual) {
		    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
		  }, TypeError);
		E('ERR_OUT_OF_RANGE',
		  function (str, range, input) {
		    let msg = `The value of "${str}" is out of range.`;
		    let received = input;
		    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
		      received = addNumericalSeparator(String(input));
		    } else if (typeof input === 'bigint') {
		      received = String(input);
		      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
		        received = addNumericalSeparator(received);
		      }
		      received += 'n';
		    }
		    msg += ` It must be ${range}. Received ${received}`;
		    return msg
		  }, RangeError);

		function addNumericalSeparator (val) {
		  let res = '';
		  let i = val.length;
		  const start = val[0] === '-' ? 1 : 0;
		  for (; i >= start + 4; i -= 3) {
		    res = `_${val.slice(i - 3, i)}${res}`;
		  }
		  return `${val.slice(0, i)}${res}`
		}

		// CHECK FUNCTIONS
		// ===============

		function checkBounds (buf, offset, byteLength) {
		  validateNumber(offset, 'offset');
		  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
		    boundsError(offset, buf.length - (byteLength + 1));
		  }
		}

		function checkIntBI (value, min, max, buf, offset, byteLength) {
		  if (value > max || value < min) {
		    const n = typeof min === 'bigint' ? 'n' : '';
		    let range;
		    {
		      if (min === 0 || min === BigInt(0)) {
		        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
		      } else {
		        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
		                `${(byteLength + 1) * 8 - 1}${n}`;
		      }
		    }
		    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
		  }
		  checkBounds(buf, offset, byteLength);
		}

		function validateNumber (value, name) {
		  if (typeof value !== 'number') {
		    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
		  }
		}

		function boundsError (value, length, type) {
		  if (Math.floor(value) !== value) {
		    validateNumber(value, type);
		    throw new errors.ERR_OUT_OF_RANGE('offset', 'an integer', value)
		  }

		  if (length < 0) {
		    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
		  }

		  throw new errors.ERR_OUT_OF_RANGE('offset',
		                                    `>= ${0} and <= ${length}`,
		                                    value)
		}

		// HELPER FUNCTIONS
		// ================

		const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;

		function base64clean (str) {
		  // Node takes equal signs as end of the Base64 encoding
		  str = str.split('=')[0];
		  // Node strips out invalid characters like \n and \t from the string, base64-js does not
		  str = str.trim().replace(INVALID_BASE64_RE, '');
		  // Node converts strings with length < 2 to ''
		  if (str.length < 2) return ''
		  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
		  while (str.length % 4 !== 0) {
		    str = str + '=';
		  }
		  return str
		}

		function utf8ToBytes (string, units) {
		  units = units || Infinity;
		  let codePoint;
		  const length = string.length;
		  let leadSurrogate = null;
		  const bytes = [];

		  for (let i = 0; i < length; ++i) {
		    codePoint = string.charCodeAt(i);

		    // is surrogate component
		    if (codePoint > 0xD7FF && codePoint < 0xE000) {
		      // last char was a lead
		      if (!leadSurrogate) {
		        // no lead yet
		        if (codePoint > 0xDBFF) {
		          // unexpected trail
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue
		        } else if (i + 1 === length) {
		          // unpaired lead
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue
		        }

		        // valid lead
		        leadSurrogate = codePoint;

		        continue
		      }

		      // 2 leads in a row
		      if (codePoint < 0xDC00) {
		        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		        leadSurrogate = codePoint;
		        continue
		      }

		      // valid surrogate pair
		      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
		    } else if (leadSurrogate) {
		      // valid bmp char, but last char was a lead
		      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		    }

		    leadSurrogate = null;

		    // encode utf8
		    if (codePoint < 0x80) {
		      if ((units -= 1) < 0) break
		      bytes.push(codePoint);
		    } else if (codePoint < 0x800) {
		      if ((units -= 2) < 0) break
		      bytes.push(
		        codePoint >> 0x6 | 0xC0,
		        codePoint & 0x3F | 0x80
		      );
		    } else if (codePoint < 0x10000) {
		      if ((units -= 3) < 0) break
		      bytes.push(
		        codePoint >> 0xC | 0xE0,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      );
		    } else if (codePoint < 0x110000) {
		      if ((units -= 4) < 0) break
		      bytes.push(
		        codePoint >> 0x12 | 0xF0,
		        codePoint >> 0xC & 0x3F | 0x80,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      );
		    } else {
		      throw new Error('Invalid code point')
		    }
		  }

		  return bytes
		}

		function asciiToBytes (str) {
		  const byteArray = [];
		  for (let i = 0; i < str.length; ++i) {
		    // Node's code seems to be doing this and not & 0x7F..
		    byteArray.push(str.charCodeAt(i) & 0xFF);
		  }
		  return byteArray
		}

		function utf16leToBytes (str, units) {
		  let c, hi, lo;
		  const byteArray = [];
		  for (let i = 0; i < str.length; ++i) {
		    if ((units -= 2) < 0) break

		    c = str.charCodeAt(i);
		    hi = c >> 8;
		    lo = c % 256;
		    byteArray.push(lo);
		    byteArray.push(hi);
		  }

		  return byteArray
		}

		function base64ToBytes (str) {
		  return base64.toByteArray(base64clean(str))
		}

		function blitBuffer (src, dst, offset, length) {
		  let i;
		  for (i = 0; i < length; ++i) {
		    if ((i + offset >= dst.length) || (i >= src.length)) break
		    dst[i + offset] = src[i];
		  }
		  return i
		}

		// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
		// the `instanceof` check but they should be treated as of that type.
		// See: https://github.com/feross/buffer/issues/166
		function isInstance (obj, type) {
		  return obj instanceof type ||
		    (obj != null && obj.constructor != null && obj.constructor.name != null &&
		      obj.constructor.name === type.name)
		}
		function numberIsNaN (obj) {
		  // For IE11 support
		  return obj !== obj // eslint-disable-line no-self-compare
		}

		// Create lookup table for `toString('hex')`
		// See: https://github.com/feross/buffer/issues/219
		const hexSliceLookupTable = (function () {
		  const alphabet = '0123456789abcdef';
		  const table = new Array(256);
		  for (let i = 0; i < 16; ++i) {
		    const i16 = i * 16;
		    for (let j = 0; j < 16; ++j) {
		      table[i16 + j] = alphabet[i] + alphabet[j];
		    }
		  }
		  return table
		})();

		// Return not function with Error if BigInt not supported
		function defineBigIntMethod (fn) {
		  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
		}

		function BufferBigIntNotDefined () {
		  throw new Error('BigInt not supported')
		} 
	} (buffer$1));
	return buffer$1;
}

var cryptoBrowserify = {};

var browser$b = {exports: {}};

var safeBuffer$2 = {exports: {}};

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

var hasRequiredSafeBuffer$2;

function requireSafeBuffer$2 () {
	if (hasRequiredSafeBuffer$2) return safeBuffer$2.exports;
	hasRequiredSafeBuffer$2 = 1;
	(function (module, exports) {
		/* eslint-disable node/no-deprecated-api */
		var buffer = requireBuffer$1();
		var Buffer = buffer.Buffer;

		// alternative to using Object.keys for old browsers
		function copyProps (src, dst) {
		  for (var key in src) {
		    dst[key] = src[key];
		  }
		}
		if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
		  module.exports = buffer;
		} else {
		  // Copy properties from require('buffer')
		  copyProps(buffer, exports);
		  exports.Buffer = SafeBuffer;
		}

		function SafeBuffer (arg, encodingOrOffset, length) {
		  return Buffer(arg, encodingOrOffset, length)
		}

		SafeBuffer.prototype = Object.create(Buffer.prototype);

		// Copy static methods from Buffer
		copyProps(Buffer, SafeBuffer);

		SafeBuffer.from = function (arg, encodingOrOffset, length) {
		  if (typeof arg === 'number') {
		    throw new TypeError('Argument must not be a number')
		  }
		  return Buffer(arg, encodingOrOffset, length)
		};

		SafeBuffer.alloc = function (size, fill, encoding) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  var buf = Buffer(size);
		  if (fill !== undefined) {
		    if (typeof encoding === 'string') {
		      buf.fill(fill, encoding);
		    } else {
		      buf.fill(fill);
		    }
		  } else {
		    buf.fill(0);
		  }
		  return buf
		};

		SafeBuffer.allocUnsafe = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return Buffer(size)
		};

		SafeBuffer.allocUnsafeSlow = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return buffer.SlowBuffer(size)
		}; 
	} (safeBuffer$2, safeBuffer$2.exports));
	return safeBuffer$2.exports;
}

var hasRequiredBrowser$b;

function requireBrowser$b () {
	if (hasRequiredBrowser$b) return browser$b.exports;
	hasRequiredBrowser$b = 1;

	// limit of Crypto.getRandomValues()
	// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
	var MAX_BYTES = 65536;

	// Node supports requesting up to this number of bytes
	// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
	var MAX_UINT32 = 4294967295;

	function oldBrowser () {
	  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
	}

	var Buffer = requireSafeBuffer$2().Buffer;
	var crypto = commonjsGlobal.crypto || commonjsGlobal.msCrypto;

	if (crypto && crypto.getRandomValues) {
	  browser$b.exports = randomBytes;
	} else {
	  browser$b.exports = oldBrowser;
	}

	function randomBytes (size, cb) {
	  // phantomjs needs to throw
	  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

	  var bytes = Buffer.allocUnsafe(size);

	  if (size > 0) {  // getRandomValues fails on IE if size == 0
	    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
	      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	      for (var generated = 0; generated < size; generated += MAX_BYTES) {
	        // buffer.slice automatically checks if the end is past the end of
	        // the buffer so we don't have to here
	        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
	      }
	    } else {
	      crypto.getRandomValues(bytes);
	    }
	  }

	  if (typeof cb === 'function') {
	    return process.nextTick(function () {
	      cb(null, bytes);
	    })
	  }

	  return bytes
	}
	return browser$b.exports;
}

var inherits_browser = {exports: {}};

var hasRequiredInherits_browser;

function requireInherits_browser () {
	if (hasRequiredInherits_browser) return inherits_browser.exports;
	hasRequiredInherits_browser = 1;
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  inherits_browser.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	    }
	  };
	} else {
	  // old school shim for old browsers
	  inherits_browser.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;
	      var TempCtor = function () {};
	      TempCtor.prototype = superCtor.prototype;
	      ctor.prototype = new TempCtor();
	      ctor.prototype.constructor = ctor;
	    }
	  };
	}
	return inherits_browser.exports;
}

var readableBrowser$1 = {exports: {}};

var events = {exports: {}};

var hasRequiredEvents;

function requireEvents () {
	if (hasRequiredEvents) return events.exports;
	hasRequiredEvents = 1;

	var R = typeof Reflect === 'object' ? Reflect : null;
	var ReflectApply = R && typeof R.apply === 'function'
	  ? R.apply
	  : function ReflectApply(target, receiver, args) {
	    return Function.prototype.apply.call(target, receiver, args);
	  };

	var ReflectOwnKeys;
	if (R && typeof R.ownKeys === 'function') {
	  ReflectOwnKeys = R.ownKeys;
	} else if (Object.getOwnPropertySymbols) {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target)
	      .concat(Object.getOwnPropertySymbols(target));
	  };
	} else {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target);
	  };
	}

	function ProcessEmitWarning(warning) {
	  if (console && console.warn) console.warn(warning);
	}

	var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
	  return value !== value;
	};

	function EventEmitter() {
	  EventEmitter.init.call(this);
	}
	events.exports = EventEmitter;
	events.exports.once = once;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._eventsCount = 0;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;

	function checkListener(listener) {
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	}

	Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	  enumerable: true,
	  get: function() {
	    return defaultMaxListeners;
	  },
	  set: function(arg) {
	    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
	      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
	    }
	    defaultMaxListeners = arg;
	  }
	});

	EventEmitter.init = function() {

	  if (this._events === undefined ||
	      this._events === Object.getPrototypeOf(this)._events) {
	    this._events = Object.create(null);
	    this._eventsCount = 0;
	  }

	  this._maxListeners = this._maxListeners || undefined;
	};

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
	    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
	  }
	  this._maxListeners = n;
	  return this;
	};

	function _getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}

	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return _getMaxListeners(this);
	};

	EventEmitter.prototype.emit = function emit(type) {
	  var args = [];
	  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	  var doError = (type === 'error');

	  var events = this._events;
	  if (events !== undefined)
	    doError = (doError && events.error === undefined);
	  else if (!doError)
	    return false;

	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    var er;
	    if (args.length > 0)
	      er = args[0];
	    if (er instanceof Error) {
	      // Note: The comments on the `throw` lines are intentional, they show
	      // up in Node's output if this results in an unhandled exception.
	      throw er; // Unhandled 'error' event
	    }
	    // At least give some kind of context to the user
	    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
	    err.context = er;
	    throw err; // Unhandled 'error' event
	  }

	  var handler = events[type];

	  if (handler === undefined)
	    return false;

	  if (typeof handler === 'function') {
	    ReflectApply(handler, this, args);
	  } else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      ReflectApply(listeners[i], this, args);
	  }

	  return true;
	};

	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;

	  checkListener(listener);

	  events = target._events;
	  if (events === undefined) {
	    events = target._events = Object.create(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener !== undefined) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);

	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }

	  if (existing === undefined) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	        prepend ? [listener, existing] : [existing, listener];
	      // If we've already got an array, just append.
	    } else if (prepend) {
	      existing.unshift(listener);
	    } else {
	      existing.push(listener);
	    }

	    // Check for listener leak
	    m = _getMaxListeners(target);
	    if (m > 0 && existing.length > m && !existing.warned) {
	      existing.warned = true;
	      // No error code for this since it is a Warning
	      // eslint-disable-next-line no-restricted-syntax
	      var w = new Error('Possible EventEmitter memory leak detected. ' +
	                          existing.length + ' ' + String(type) + ' listeners ' +
	                          'added. Use emitter.setMaxListeners() to ' +
	                          'increase limit');
	      w.name = 'MaxListenersExceededWarning';
	      w.emitter = target;
	      w.type = type;
	      w.count = existing.length;
	      ProcessEmitWarning(w);
	    }
	  }

	  return target;
	}

	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };

	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    if (arguments.length === 0)
	      return this.listener.call(this.target);
	    return this.listener.apply(this.target, arguments);
	  }
	}

	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = onceWrapper.bind(state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}

	EventEmitter.prototype.once = function once(type, listener) {
	  checkListener(listener);
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};

	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      checkListener(listener);
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };

	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;

	      checkListener(listener);

	      events = this._events;
	      if (events === undefined)
	        return this;

	      list = events[type];
	      if (list === undefined)
	        return this;

	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = Object.create(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;

	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }

	        if (position < 0)
	          return this;

	        if (position === 0)
	          list.shift();
	        else {
	          spliceOne(list, position);
	        }

	        if (list.length === 1)
	          events[type] = list[0];

	        if (events.removeListener !== undefined)
	          this.emit('removeListener', type, originalListener || listener);
	      }

	      return this;
	    };

	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;

	      events = this._events;
	      if (events === undefined)
	        return this;

	      // not listening for removeListener, no need to emit
	      if (events.removeListener === undefined) {
	        if (arguments.length === 0) {
	          this._events = Object.create(null);
	          this._eventsCount = 0;
	        } else if (events[type] !== undefined) {
	          if (--this._eventsCount === 0)
	            this._events = Object.create(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }

	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = Object.create(null);
	        this._eventsCount = 0;
	        return this;
	      }

	      listeners = events[type];

	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners !== undefined) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }

	      return this;
	    };

	function _listeners(target, type, unwrap) {
	  var events = target._events;

	  if (events === undefined)
	    return [];

	  var evlistener = events[type];
	  if (evlistener === undefined)
	    return [];

	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

	  return unwrap ?
	    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}

	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};

	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};

	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;

	  if (events !== undefined) {
	    var evlistener = events[type];

	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener !== undefined) {
	      return evlistener.length;
	    }
	  }

	  return 0;
	}

	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};

	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}

	function spliceOne(list, index) {
	  for (; index + 1 < list.length; index++)
	    list[index] = list[index + 1];
	  list.pop();
	}

	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}

	function once(emitter, name) {
	  return new Promise(function (resolve, reject) {
	    function errorListener(err) {
	      emitter.removeListener(name, resolver);
	      reject(err);
	    }

	    function resolver() {
	      if (typeof emitter.removeListener === 'function') {
	        emitter.removeListener('error', errorListener);
	      }
	      resolve([].slice.call(arguments));
	    }
	    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
	    if (name !== 'error') {
	      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
	    }
	  });
	}

	function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
	  if (typeof emitter.on === 'function') {
	    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
	  }
	}

	function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
	  if (typeof emitter.on === 'function') {
	    if (flags.once) {
	      emitter.once(name, listener);
	    } else {
	      emitter.on(name, listener);
	    }
	  } else if (typeof emitter.addEventListener === 'function') {
	    // EventTarget does not have `error` event semantics like Node
	    // EventEmitters, we do not listen for `error` events here.
	    emitter.addEventListener(name, function wrapListener(arg) {
	      // IE does not have builtin `{ once: true }` support so we
	      // have to do it manually.
	      if (flags.once) {
	        emitter.removeEventListener(name, wrapListener);
	      }
	      listener(arg);
	    });
	  } else {
	    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
	  }
	}
	return events.exports;
}

var streamBrowser$1;
var hasRequiredStreamBrowser$1;

function requireStreamBrowser$1 () {
	if (hasRequiredStreamBrowser$1) return streamBrowser$1;
	hasRequiredStreamBrowser$1 = 1;
	streamBrowser$1 = requireEvents().EventEmitter;
	return streamBrowser$1;
}

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: _nodeResolve_empty
});

var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var buffer_list;
var hasRequiredBuffer_list;

function requireBuffer_list () {
	if (hasRequiredBuffer_list) return buffer_list;
	hasRequiredBuffer_list = 1;

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var _require = requireBuffer$1(),
	  Buffer = _require.Buffer;
	var _require2 = require$$0$1,
	  inspect = _require2.inspect;
	var custom = inspect && inspect.custom || 'inspect';
	function copyBuffer(src, target, offset) {
	  Buffer.prototype.copy.call(src, target, offset);
	}
	buffer_list = /*#__PURE__*/function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	  _createClass(BufferList, [{
	    key: "push",
	    value: function push(v) {
	      var entry = {
	        data: v,
	        next: null
	      };
	      if (this.length > 0) this.tail.next = entry;else this.head = entry;
	      this.tail = entry;
	      ++this.length;
	    }
	  }, {
	    key: "unshift",
	    value: function unshift(v) {
	      var entry = {
	        data: v,
	        next: this.head
	      };
	      if (this.length === 0) this.tail = entry;
	      this.head = entry;
	      ++this.length;
	    }
	  }, {
	    key: "shift",
	    value: function shift() {
	      if (this.length === 0) return;
	      var ret = this.head.data;
	      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	      --this.length;
	      return ret;
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      this.head = this.tail = null;
	      this.length = 0;
	    }
	  }, {
	    key: "join",
	    value: function join(s) {
	      if (this.length === 0) return '';
	      var p = this.head;
	      var ret = '' + p.data;
	      while (p = p.next) ret += s + p.data;
	      return ret;
	    }
	  }, {
	    key: "concat",
	    value: function concat(n) {
	      if (this.length === 0) return Buffer.alloc(0);
	      var ret = Buffer.allocUnsafe(n >>> 0);
	      var p = this.head;
	      var i = 0;
	      while (p) {
	        copyBuffer(p.data, ret, i);
	        i += p.data.length;
	        p = p.next;
	      }
	      return ret;
	    }

	    // Consumes a specified amount of bytes or characters from the buffered data.
	  }, {
	    key: "consume",
	    value: function consume(n, hasStrings) {
	      var ret;
	      if (n < this.head.data.length) {
	        // `slice` is the same for buffers and strings.
	        ret = this.head.data.slice(0, n);
	        this.head.data = this.head.data.slice(n);
	      } else if (n === this.head.data.length) {
	        // First chunk is a perfect match.
	        ret = this.shift();
	      } else {
	        // Result spans more than one buffer.
	        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
	      }
	      return ret;
	    }
	  }, {
	    key: "first",
	    value: function first() {
	      return this.head.data;
	    }

	    // Consumes a specified amount of characters from the buffered data.
	  }, {
	    key: "_getString",
	    value: function _getString(n) {
	      var p = this.head;
	      var c = 1;
	      var ret = p.data;
	      n -= ret.length;
	      while (p = p.next) {
	        var str = p.data;
	        var nb = n > str.length ? str.length : n;
	        if (nb === str.length) ret += str;else ret += str.slice(0, n);
	        n -= nb;
	        if (n === 0) {
	          if (nb === str.length) {
	            ++c;
	            if (p.next) this.head = p.next;else this.head = this.tail = null;
	          } else {
	            this.head = p;
	            p.data = str.slice(nb);
	          }
	          break;
	        }
	        ++c;
	      }
	      this.length -= c;
	      return ret;
	    }

	    // Consumes a specified amount of bytes from the buffered data.
	  }, {
	    key: "_getBuffer",
	    value: function _getBuffer(n) {
	      var ret = Buffer.allocUnsafe(n);
	      var p = this.head;
	      var c = 1;
	      p.data.copy(ret);
	      n -= p.data.length;
	      while (p = p.next) {
	        var buf = p.data;
	        var nb = n > buf.length ? buf.length : n;
	        buf.copy(ret, ret.length - n, 0, nb);
	        n -= nb;
	        if (n === 0) {
	          if (nb === buf.length) {
	            ++c;
	            if (p.next) this.head = p.next;else this.head = this.tail = null;
	          } else {
	            this.head = p;
	            p.data = buf.slice(nb);
	          }
	          break;
	        }
	        ++c;
	      }
	      this.length -= c;
	      return ret;
	    }

	    // Make sure the linked list only shows the minimal necessary information.
	  }, {
	    key: custom,
	    value: function value(_, options) {
	      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
	        // Only inspect one level.
	        depth: 0,
	        // It should not recurse.
	        customInspect: false
	      }));
	    }
	  }]);
	  return BufferList;
	}();
	return buffer_list;
}

var destroy_1$1;
var hasRequiredDestroy$1;

function requireDestroy$1 () {
	if (hasRequiredDestroy$1) return destroy_1$1;
	hasRequiredDestroy$1 = 1;

	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err) {
	      if (!this._writableState) {
	        process.nextTick(emitErrorNT, this, err);
	      } else if (!this._writableState.errorEmitted) {
	        this._writableState.errorEmitted = true;
	        process.nextTick(emitErrorNT, this, err);
	      }
	    }
	    return this;
	  }

	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks

	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }

	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      if (!_this._writableState) {
	        process.nextTick(emitErrorAndCloseNT, _this, err);
	      } else if (!_this._writableState.errorEmitted) {
	        _this._writableState.errorEmitted = true;
	        process.nextTick(emitErrorAndCloseNT, _this, err);
	      } else {
	        process.nextTick(emitCloseNT, _this);
	      }
	    } else if (cb) {
	      process.nextTick(emitCloseNT, _this);
	      cb(err);
	    } else {
	      process.nextTick(emitCloseNT, _this);
	    }
	  });
	  return this;
	}
	function emitErrorAndCloseNT(self, err) {
	  emitErrorNT(self, err);
	  emitCloseNT(self);
	}
	function emitCloseNT(self) {
	  if (self._writableState && !self._writableState.emitClose) return;
	  if (self._readableState && !self._readableState.emitClose) return;
	  self.emit('close');
	}
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finalCalled = false;
	    this._writableState.prefinished = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	function errorOrDestroy(stream, err) {
	  // We have tests that rely on errors being emitted
	  // in the same tick, so changing this is semver major.
	  // For now when you opt-in to autoDestroy we allow
	  // the error to be emitted nextTick. In a future
	  // semver major update we should change the default to this.

	  var rState = stream._readableState;
	  var wState = stream._writableState;
	  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
	}
	destroy_1$1 = {
	  destroy: destroy,
	  undestroy: undestroy,
	  errorOrDestroy: errorOrDestroy
	};
	return destroy_1$1;
}

var errorsBrowser = {};

var hasRequiredErrorsBrowser;

function requireErrorsBrowser () {
	if (hasRequiredErrorsBrowser) return errorsBrowser;
	hasRequiredErrorsBrowser = 1;

	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

	var codes = {};

	function createErrorType(code, message, Base) {
	  if (!Base) {
	    Base = Error;
	  }

	  function getMessage(arg1, arg2, arg3) {
	    if (typeof message === 'string') {
	      return message;
	    } else {
	      return message(arg1, arg2, arg3);
	    }
	  }

	  var NodeError =
	  /*#__PURE__*/
	  function (_Base) {
	    _inheritsLoose(NodeError, _Base);

	    function NodeError(arg1, arg2, arg3) {
	      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
	    }

	    return NodeError;
	  }(Base);

	  NodeError.prototype.name = Base.name;
	  NodeError.prototype.code = code;
	  codes[code] = NodeError;
	} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


	function oneOf(expected, thing) {
	  if (Array.isArray(expected)) {
	    var len = expected.length;
	    expected = expected.map(function (i) {
	      return String(i);
	    });

	    if (len > 2) {
	      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
	    } else if (len === 2) {
	      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
	    } else {
	      return "of ".concat(thing, " ").concat(expected[0]);
	    }
	  } else {
	    return "of ".concat(thing, " ").concat(String(expected));
	  }
	} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


	function startsWith(str, search, pos) {
	  return str.substr(0 , search.length) === search;
	} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


	function endsWith(str, search, this_len) {
	  if (this_len === undefined || this_len > str.length) {
	    this_len = str.length;
	  }

	  return str.substring(this_len - search.length, this_len) === search;
	} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


	function includes(str, search, start) {
	  if (typeof start !== 'number') {
	    start = 0;
	  }

	  if (start + search.length > str.length) {
	    return false;
	  } else {
	    return str.indexOf(search, start) !== -1;
	  }
	}

	createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
	  return 'The value "' + value + '" is invalid for option "' + name + '"';
	}, TypeError);
	createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
	  // determiner: 'must be' or 'must not be'
	  var determiner;

	  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
	    determiner = 'must not be';
	    expected = expected.replace(/^not /, '');
	  } else {
	    determiner = 'must be';
	  }

	  var msg;

	  if (endsWith(name, ' argument')) {
	    // For cases like 'first argument'
	    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
	  } else {
	    var type = includes(name, '.') ? 'property' : 'argument';
	    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
	  }

	  msg += ". Received type ".concat(typeof actual);
	  return msg;
	}, TypeError);
	createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
	createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
	  return 'The ' + name + ' method is not implemented';
	});
	createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
	createErrorType('ERR_STREAM_DESTROYED', function (name) {
	  return 'Cannot call ' + name + ' after a stream was destroyed';
	});
	createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
	createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
	createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
	createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
	createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
	  return 'Unknown encoding: ' + arg;
	}, TypeError);
	createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
	errorsBrowser.codes = codes;
	return errorsBrowser;
}

var state;
var hasRequiredState;

function requireState () {
	if (hasRequiredState) return state;
	hasRequiredState = 1;

	var ERR_INVALID_OPT_VALUE = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
	function highWaterMarkFrom(options, isDuplex, duplexKey) {
	  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
	}
	function getHighWaterMark(state, options, duplexKey, isDuplex) {
	  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
	  if (hwm != null) {
	    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
	      var name = isDuplex ? duplexKey : 'highWaterMark';
	      throw new ERR_INVALID_OPT_VALUE(name, hwm);
	    }
	    return Math.floor(hwm);
	  }

	  // Default value
	  return state.objectMode ? 16 : 16 * 1024;
	}
	state = {
	  getHighWaterMark: getHighWaterMark
	};
	return state;
}

var browser$a;
var hasRequiredBrowser$a;

function requireBrowser$a () {
	if (hasRequiredBrowser$a) return browser$a;
	hasRequiredBrowser$a = 1;
	/**
	 * Module exports.
	 */

	browser$a = deprecate;

	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */

	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	}

	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */

	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!commonjsGlobal.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = commonjsGlobal.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	return browser$a;
}

var _stream_writable$1;
var hasRequired_stream_writable$1;

function require_stream_writable$1 () {
	if (hasRequired_stream_writable$1) return _stream_writable$1;
	hasRequired_stream_writable$1 = 1;

	_stream_writable$1 = Writable;

	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Writable.WritableState = WritableState;

	/*<replacement>*/
	var internalUtil = {
	  deprecate: requireBrowser$a()
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = requireStreamBrowser$1();
	/*</replacement>*/

	var Buffer = requireBuffer$1().Buffer;
	var OurUint8Array = (typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	var destroyImpl = requireDestroy$1();
	var _require = requireState(),
	  getHighWaterMark = _require.getHighWaterMark;
	var _require$codes = requireErrorsBrowser().codes,
	  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
	  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
	  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
	  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
	  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
	  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
	  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
	  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
	var errorOrDestroy = destroyImpl.errorOrDestroy;
	requireInherits_browser()(Writable, Stream);
	function nop() {}
	function WritableState(options, stream, isDuplex) {
	  Duplex = Duplex || require_stream_duplex$1();
	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream,
	  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
	  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

	  // if _final has been called
	  this.finalCalled = false;

	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;

	  // a flag to see when we're in the middle of a write.
	  this.writing = false;

	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;

	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;

	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;

	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };

	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;

	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;

	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;

	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;

	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;

	  // Should close be emitted on destroy. Defaults to true.
	  this.emitClose = options.emitClose !== false;

	  // Should .destroy() be called after 'finish' (and potentially 'end')
	  this.autoDestroy = !!options.autoDestroy;

	  // count buffered requests
	  this.bufferedRequestCount = 0;

	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function writableStateBufferGetter() {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();

	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function value(object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function realHasInstance(object) {
	    return object instanceof this;
	  };
	}
	function Writable(options) {
	  Duplex = Duplex || require_stream_duplex$1();

	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.

	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.

	  // Checking for a Stream.Duplex instance is faster here instead of inside
	  // the WritableState constructor, at least with V8 6.5
	  var isDuplex = this instanceof Duplex;
	  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
	  this._writableState = new WritableState(options, this, isDuplex);

	  // legacy.
	  this.writable = true;
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	    if (typeof options.writev === 'function') this._writev = options.writev;
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	  Stream.call(this);
	}

	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
	};
	function writeAfterEnd(stream, cb) {
	  var er = new ERR_STREAM_WRITE_AFTER_END();
	  // TODO: defer error events consistently everywhere, not just the cb
	  errorOrDestroy(stream, er);
	  process.nextTick(cb, er);
	}

	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var er;
	  if (chunk === null) {
	    er = new ERR_STREAM_NULL_VALUES();
	  } else if (typeof chunk !== 'string' && !state.objectMode) {
	    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
	  }
	  if (er) {
	    errorOrDestroy(stream, er);
	    process.nextTick(cb, er);
	    return false;
	  }
	  return true;
	}
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	  if (typeof cb !== 'function') cb = nop;
	  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	  return ret;
	};
	Writable.prototype.cork = function () {
	  this._writableState.corked++;
	};
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	  if (state.corked) {
	    state.corked--;
	    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	Object.defineProperty(Writable.prototype, 'writableBuffer', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._writableState && this._writableState.getBuffer();
	  }
	});
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._writableState.highWaterMark;
	  }
	});

	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	  state.length += len;
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	  return ret;
	}
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    process.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    process.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    errorOrDestroy(stream, er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    errorOrDestroy(stream, er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
	  onwriteStateUpdate(state);
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state) || stream.destroyed;
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	    if (sync) {
	      process.nextTick(afterWrite, stream, state, finished, cb);
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}

	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}

	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
	};
	Writable.prototype._writev = null;
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }

	  // ignore unnecessary end() calls.
	  if (!state.ending) endWritable(this, state, cb);
	  return this;
	};
	Object.defineProperty(Writable.prototype, 'writableLength', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._writableState.length;
	  }
	});
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      errorOrDestroy(stream, err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function' && !state.destroyed) {
	      state.pendingcb++;
	      state.finalCalled = true;
	      process.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	      if (state.autoDestroy) {
	        // In case of duplex streams we need a way to detect
	        // if the readable side is ready for autoDestroy as well
	        var rState = stream._readableState;
	        if (!rState || rState.autoDestroy && rState.endEmitted) {
	          stream.destroy();
	        }
	      }
	    }
	  }
	  return need;
	}
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }

	  // reuse the free corkReq.
	  state.corkedRequestsFree.next = corkReq;
	}
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function set(value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  cb(err);
	};
	return _stream_writable$1;
}

var _stream_duplex$1;
var hasRequired_stream_duplex$1;

function require_stream_duplex$1 () {
	if (hasRequired_stream_duplex$1) return _stream_duplex$1;
	hasRequired_stream_duplex$1 = 1;

	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	};
	/*</replacement>*/

	_stream_duplex$1 = Duplex;
	var Readable = require_stream_readable$1();
	var Writable = require_stream_writable$1();
	requireInherits_browser()(Duplex, Readable);
	{
	  // Allow the keys array to be GC'ed.
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	  Readable.call(this, options);
	  Writable.call(this, options);
	  this.allowHalfOpen = true;
	  if (options) {
	    if (options.readable === false) this.readable = false;
	    if (options.writable === false) this.writable = false;
	    if (options.allowHalfOpen === false) {
	      this.allowHalfOpen = false;
	      this.once('end', onend);
	    }
	  }
	}
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._writableState.highWaterMark;
	  }
	});
	Object.defineProperty(Duplex.prototype, 'writableBuffer', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._writableState && this._writableState.getBuffer();
	  }
	});
	Object.defineProperty(Duplex.prototype, 'writableLength', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._writableState.length;
	  }
	});

	// the no-half-open enforcer
	function onend() {
	  // If the writable side ended, then we're ok.
	  if (this._writableState.ended) return;

	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(onEndNT, this);
	}
	function onEndNT(self) {
	  self.end();
	}
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function set(value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	return _stream_duplex$1;
}

var string_decoder$1 = {};

var hasRequiredString_decoder$1;

function requireString_decoder$1 () {
	if (hasRequiredString_decoder$1) return string_decoder$1;
	hasRequiredString_decoder$1 = 1;

	/*<replacement>*/

	var Buffer = requireSafeBuffer$2().Buffer;
	/*</replacement>*/

	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};

	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	}
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}

	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	string_decoder$1.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}

	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};

	StringDecoder.prototype.end = utf8End;

	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;

	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};

	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}

	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}

	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}

	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}

	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}

	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}

	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}

	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}

	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}

	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}

	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}

	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}
	return string_decoder$1;
}

var endOfStream;
var hasRequiredEndOfStream;

function requireEndOfStream () {
	if (hasRequiredEndOfStream) return endOfStream;
	hasRequiredEndOfStream = 1;

	var ERR_STREAM_PREMATURE_CLOSE = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
	function once(callback) {
	  var called = false;
	  return function () {
	    if (called) return;
	    called = true;
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    callback.apply(this, args);
	  };
	}
	function noop() {}
	function isRequest(stream) {
	  return stream.setHeader && typeof stream.abort === 'function';
	}
	function eos(stream, opts, callback) {
	  if (typeof opts === 'function') return eos(stream, null, opts);
	  if (!opts) opts = {};
	  callback = once(callback || noop);
	  var readable = opts.readable || opts.readable !== false && stream.readable;
	  var writable = opts.writable || opts.writable !== false && stream.writable;
	  var onlegacyfinish = function onlegacyfinish() {
	    if (!stream.writable) onfinish();
	  };
	  var writableEnded = stream._writableState && stream._writableState.finished;
	  var onfinish = function onfinish() {
	    writable = false;
	    writableEnded = true;
	    if (!readable) callback.call(stream);
	  };
	  var readableEnded = stream._readableState && stream._readableState.endEmitted;
	  var onend = function onend() {
	    readable = false;
	    readableEnded = true;
	    if (!writable) callback.call(stream);
	  };
	  var onerror = function onerror(err) {
	    callback.call(stream, err);
	  };
	  var onclose = function onclose() {
	    var err;
	    if (readable && !readableEnded) {
	      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
	      return callback.call(stream, err);
	    }
	    if (writable && !writableEnded) {
	      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
	      return callback.call(stream, err);
	    }
	  };
	  var onrequest = function onrequest() {
	    stream.req.on('finish', onfinish);
	  };
	  if (isRequest(stream)) {
	    stream.on('complete', onfinish);
	    stream.on('abort', onclose);
	    if (stream.req) onrequest();else stream.on('request', onrequest);
	  } else if (writable && !stream._writableState) {
	    // legacy streams
	    stream.on('end', onlegacyfinish);
	    stream.on('close', onlegacyfinish);
	  }
	  stream.on('end', onend);
	  stream.on('finish', onfinish);
	  if (opts.error !== false) stream.on('error', onerror);
	  stream.on('close', onclose);
	  return function () {
	    stream.removeListener('complete', onfinish);
	    stream.removeListener('abort', onclose);
	    stream.removeListener('request', onrequest);
	    if (stream.req) stream.req.removeListener('finish', onfinish);
	    stream.removeListener('end', onlegacyfinish);
	    stream.removeListener('close', onlegacyfinish);
	    stream.removeListener('finish', onfinish);
	    stream.removeListener('end', onend);
	    stream.removeListener('error', onerror);
	    stream.removeListener('close', onclose);
	  };
	}
	endOfStream = eos;
	return endOfStream;
}

var async_iterator;
var hasRequiredAsync_iterator;

function requireAsync_iterator () {
	if (hasRequiredAsync_iterator) return async_iterator;
	hasRequiredAsync_iterator = 1;

	var _Object$setPrototypeO;
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var finished = requireEndOfStream();
	var kLastResolve = Symbol('lastResolve');
	var kLastReject = Symbol('lastReject');
	var kError = Symbol('error');
	var kEnded = Symbol('ended');
	var kLastPromise = Symbol('lastPromise');
	var kHandlePromise = Symbol('handlePromise');
	var kStream = Symbol('stream');
	function createIterResult(value, done) {
	  return {
	    value: value,
	    done: done
	  };
	}
	function readAndResolve(iter) {
	  var resolve = iter[kLastResolve];
	  if (resolve !== null) {
	    var data = iter[kStream].read();
	    // we defer if data is null
	    // we can be expecting either 'end' or
	    // 'error'
	    if (data !== null) {
	      iter[kLastPromise] = null;
	      iter[kLastResolve] = null;
	      iter[kLastReject] = null;
	      resolve(createIterResult(data, false));
	    }
	  }
	}
	function onReadable(iter) {
	  // we wait for the next tick, because it might
	  // emit an error with process.nextTick
	  process.nextTick(readAndResolve, iter);
	}
	function wrapForNext(lastPromise, iter) {
	  return function (resolve, reject) {
	    lastPromise.then(function () {
	      if (iter[kEnded]) {
	        resolve(createIterResult(undefined, true));
	        return;
	      }
	      iter[kHandlePromise](resolve, reject);
	    }, reject);
	  };
	}
	var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
	var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
	  get stream() {
	    return this[kStream];
	  },
	  next: function next() {
	    var _this = this;
	    // if we have detected an error in the meanwhile
	    // reject straight away
	    var error = this[kError];
	    if (error !== null) {
	      return Promise.reject(error);
	    }
	    if (this[kEnded]) {
	      return Promise.resolve(createIterResult(undefined, true));
	    }
	    if (this[kStream].destroyed) {
	      // We need to defer via nextTick because if .destroy(err) is
	      // called, the error will be emitted via nextTick, and
	      // we cannot guarantee that there is no error lingering around
	      // waiting to be emitted.
	      return new Promise(function (resolve, reject) {
	        process.nextTick(function () {
	          if (_this[kError]) {
	            reject(_this[kError]);
	          } else {
	            resolve(createIterResult(undefined, true));
	          }
	        });
	      });
	    }

	    // if we have multiple next() calls
	    // we will wait for the previous Promise to finish
	    // this logic is optimized to support for await loops,
	    // where next() is only called once at a time
	    var lastPromise = this[kLastPromise];
	    var promise;
	    if (lastPromise) {
	      promise = new Promise(wrapForNext(lastPromise, this));
	    } else {
	      // fast path needed to support multiple this.push()
	      // without triggering the next() queue
	      var data = this[kStream].read();
	      if (data !== null) {
	        return Promise.resolve(createIterResult(data, false));
	      }
	      promise = new Promise(this[kHandlePromise]);
	    }
	    this[kLastPromise] = promise;
	    return promise;
	  }
	}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
	  return this;
	}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
	  var _this2 = this;
	  // destroy(err, cb) is a private API
	  // we can guarantee we have that here, because we control the
	  // Readable class this is attached to
	  return new Promise(function (resolve, reject) {
	    _this2[kStream].destroy(null, function (err) {
	      if (err) {
	        reject(err);
	        return;
	      }
	      resolve(createIterResult(undefined, true));
	    });
	  });
	}), _Object$setPrototypeO), AsyncIteratorPrototype);
	var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
	  var _Object$create;
	  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
	    value: stream,
	    writable: true
	  }), _defineProperty(_Object$create, kLastResolve, {
	    value: null,
	    writable: true
	  }), _defineProperty(_Object$create, kLastReject, {
	    value: null,
	    writable: true
	  }), _defineProperty(_Object$create, kError, {
	    value: null,
	    writable: true
	  }), _defineProperty(_Object$create, kEnded, {
	    value: stream._readableState.endEmitted,
	    writable: true
	  }), _defineProperty(_Object$create, kHandlePromise, {
	    value: function value(resolve, reject) {
	      var data = iterator[kStream].read();
	      if (data) {
	        iterator[kLastPromise] = null;
	        iterator[kLastResolve] = null;
	        iterator[kLastReject] = null;
	        resolve(createIterResult(data, false));
	      } else {
	        iterator[kLastResolve] = resolve;
	        iterator[kLastReject] = reject;
	      }
	    },
	    writable: true
	  }), _Object$create));
	  iterator[kLastPromise] = null;
	  finished(stream, function (err) {
	    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
	      var reject = iterator[kLastReject];
	      // reject if we are waiting for data in the Promise
	      // returned by next() and store the error
	      if (reject !== null) {
	        iterator[kLastPromise] = null;
	        iterator[kLastResolve] = null;
	        iterator[kLastReject] = null;
	        reject(err);
	      }
	      iterator[kError] = err;
	      return;
	    }
	    var resolve = iterator[kLastResolve];
	    if (resolve !== null) {
	      iterator[kLastPromise] = null;
	      iterator[kLastResolve] = null;
	      iterator[kLastReject] = null;
	      resolve(createIterResult(undefined, true));
	    }
	    iterator[kEnded] = true;
	  });
	  stream.on('readable', onReadable.bind(null, iterator));
	  return iterator;
	};
	async_iterator = createReadableStreamAsyncIterator;
	return async_iterator;
}

var fromBrowser;
var hasRequiredFromBrowser;

function requireFromBrowser () {
	if (hasRequiredFromBrowser) return fromBrowser;
	hasRequiredFromBrowser = 1;
	fromBrowser = function () {
	  throw new Error('Readable.from is not available in the browser')
	};
	return fromBrowser;
}

var _stream_readable$1;
var hasRequired_stream_readable$1;

function require_stream_readable$1 () {
	if (hasRequired_stream_readable$1) return _stream_readable$1;
	hasRequired_stream_readable$1 = 1;

	_stream_readable$1 = Readable;

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Readable.ReadableState = ReadableState;

	/*<replacement>*/
	requireEvents().EventEmitter;
	var EElistenerCount = function EElistenerCount(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = requireStreamBrowser$1();
	/*</replacement>*/

	var Buffer = requireBuffer$1().Buffer;
	var OurUint8Array = (typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}

	/*<replacement>*/
	var debugUtil = require$$0$1;
	var debug;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function debug() {};
	}
	/*</replacement>*/

	var BufferList = requireBuffer_list();
	var destroyImpl = requireDestroy$1();
	var _require = requireState(),
	  getHighWaterMark = _require.getHighWaterMark;
	var _require$codes = requireErrorsBrowser().codes,
	  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
	  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
	  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
	  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

	// Lazy loaded to improve the startup performance.
	var StringDecoder;
	var createReadableStreamAsyncIterator;
	var from;
	requireInherits_browser()(Readable, Stream);
	var errorOrDestroy = destroyImpl.errorOrDestroy;
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	function ReadableState(options, stream, isDuplex) {
	  Duplex = Duplex || require_stream_duplex$1();
	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;

	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;

	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	  this.paused = true;

	  // Should close be emitted on destroy. Defaults to true.
	  this.emitClose = options.emitClose !== false;

	  // Should .destroy() be called after 'end' (and potentially 'finish')
	  this.autoDestroy = !!options.autoDestroy;

	  // has it been destroyed
	  this.destroyed = false;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;

	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = requireString_decoder$1().StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	function Readable(options) {
	  Duplex = Duplex || require_stream_duplex$1();
	  if (!(this instanceof Readable)) return new Readable(options);

	  // Checking for a Stream.Duplex instance is faster here instead of inside
	  // the ReadableState constructor, at least with V8 6.5
	  var isDuplex = this instanceof Duplex;
	  this._readableState = new ReadableState(options, this, isDuplex);

	  // legacy
	  this.readable = true;
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	  Stream.call(this);
	}
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function set(value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  cb(err);
	};

	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};

	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  debug('readableAddChunk', chunk);
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      errorOrDestroy(stream, er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	      if (addToFront) {
	        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
	      } else if (state.destroyed) {
	        return false;
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	      maybeReadMore(stream, state);
	    }
	  }

	  // We can push more data if we are below the highWaterMark.
	  // Also, if we have no data yet, we can stand some more bytes.
	  // This is to work around cases where hwm=0, such as the repl.
	  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
	}
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    state.awaitDrain = 0;
	    stream.emit('data', chunk);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
	  }
	  return er;
	}
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};

	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = requireString_decoder$1().StringDecoder;
	  var decoder = new StringDecoder(enc);
	  this._readableState.decoder = decoder;
	  // If setEncoding(null), decoder.encoding equals utf8
	  this._readableState.encoding = this._readableState.decoder.encoding;

	  // Iterate over current buffer to convert already stored Buffers:
	  var p = this._readableState.buffer.head;
	  var content = '';
	  while (p !== null) {
	    content += decoder.write(p.data);
	    p = p.next;
	  }
	  this._readableState.buffer.clear();
	  if (content !== '') this._readableState.buffer.push(content);
	  this._readableState.length = content.length;
	  return this;
	};

	// Don't raise the hwm > 1GB
	var MAX_HWM = 0x40000000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}

	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}

	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	  if (n !== 0) state.emittedReadable = false;

	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	  n = howMuchToRead(n, state);

	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }

	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.

	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);

	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }

	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	  if (ret === null) {
	    state.needReadable = state.length <= state.highWaterMark;
	    n = 0;
	  } else {
	    state.length -= n;
	    state.awaitDrain = 0;
	  }
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;

	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	  if (ret !== null) this.emit('data', ret);
	  return ret;
	};
	function onEofChunk(stream, state) {
	  debug('onEofChunk');
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	  if (state.sync) {
	    // if we are sync, wait until next tick to emit the data.
	    // Otherwise we risk emitting data in the flow()
	    // the readable code triggers during a read() call
	    emitReadable(stream);
	  } else {
	    // emit 'readable' now to make sure it gets picked up.
	    state.needReadable = false;
	    if (!state.emittedReadable) {
	      state.emittedReadable = true;
	      emitReadable_(stream);
	    }
	  }
	}

	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  debug('emitReadable', state.needReadable, state.emittedReadable);
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    process.nextTick(emitReadable_, stream);
	  }
	}
	function emitReadable_(stream) {
	  var state = stream._readableState;
	  debug('emitReadable_', state.destroyed, state.length, state.ended);
	  if (!state.destroyed && (state.length || state.ended)) {
	    stream.emit('readable');
	    state.emittedReadable = false;
	  }

	  // The stream needs another readable event if
	  // 1. It is not flowing, as the flow mechanism will take
	  //    care of it.
	  // 2. It is not ended.
	  // 3. It is below the highWaterMark, so we can schedule
	  //    another readable later.
	  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
	  flow(stream);
	}

	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(maybeReadMore_, stream, state);
	  }
	}
	function maybeReadMore_(stream, state) {
	  // Attempt to read more data if we should.
	  //
	  // The conditions for reading more data are (one of):
	  // - Not enough data buffered (state.length < state.highWaterMark). The loop
	  //   is responsible for filling the buffer with enough data if such data
	  //   is available. If highWaterMark is 0 and we are not in the flowing mode
	  //   we should _not_ attempt to buffer any extra data. We'll get more data
	  //   when the stream consumer calls read() instead.
	  // - No data in the buffer, and the stream is in flowing mode. In this mode
	  //   the loop below is responsible for ensuring read() is called. Failing to
	  //   call read here would abort the flow and there's no other mechanism for
	  //   continuing the flow if the stream consumer has just subscribed to the
	  //   'data' event.
	  //
	  // In addition to the above conditions to keep reading data, the following
	  // conditions prevent the data from being read:
	  // - The stream has ended (state.ended).
	  // - There is already a pending 'read' operation (state.reading). This is a
	  //   case where the the stream has called the implementation defined _read()
	  //   method, but they are processing the call asynchronously and have _not_
	  //   called push() with new data. In this case we skip performing more
	  //   read()s. The execution ends in this method again after the _read() ends
	  //   up calling push() with more data.
	  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
	    var len = state.length;
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	  }
	  state.readingMore = false;
	}

	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
	};
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	  function onend() {
	    debug('onend');
	    dest.end();
	  }

	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	    cleanedUp = true;

	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    debug('dest.write', ret);
	    if (ret === false) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', state.awaitDrain);
	        state.awaitDrain++;
	      }
	      src.pause();
	    }
	  }

	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
	  }

	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);

	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }

	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);

	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	  return dest;
	};
	function pipeOnDrain(src) {
	  return function pipeOnDrainFunctionResult() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = {
	    hasUnpiped: false
	  };

	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;

	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	    if (!dest) dest = state.pipes;

	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }

	  // slow case. multiple pipe destinations.

	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
	      hasUnpiped: false
	    });
	    return this;
	  }

	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	  dest.emit('unpipe', this, unpipeInfo);
	  return this;
	};

	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	  var state = this._readableState;
	  if (ev === 'data') {
	    // update readableListening so that resume() may be a no-op
	    // a few lines down. This is needed to support once('readable').
	    state.readableListening = this.listenerCount('readable') > 0;

	    // Try start flowing on next tick if stream isn't explicitly paused
	    if (state.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.flowing = false;
	      state.emittedReadable = false;
	      debug('on readable', state.length, state.reading);
	      if (state.length) {
	        emitReadable(this);
	      } else if (!state.reading) {
	        process.nextTick(nReadingNextTick, this);
	      }
	    }
	  }
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	Readable.prototype.removeListener = function (ev, fn) {
	  var res = Stream.prototype.removeListener.call(this, ev, fn);
	  if (ev === 'readable') {
	    // We need to check if there is someone still listening to
	    // readable and reset the state. However this needs to happen
	    // after readable has been emitted but before I/O (nextTick) to
	    // support once('readable', fn) cycles. This means that calling
	    // resume within the same tick will have no
	    // effect.
	    process.nextTick(updateReadableListening, this);
	  }
	  return res;
	};
	Readable.prototype.removeAllListeners = function (ev) {
	  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
	  if (ev === 'readable' || ev === undefined) {
	    // We need to check if there is someone still listening to
	    // readable and reset the state. However this needs to happen
	    // after readable has been emitted but before I/O (nextTick) to
	    // support once('readable', fn) cycles. This means that calling
	    // resume within the same tick will have no
	    // effect.
	    process.nextTick(updateReadableListening, this);
	  }
	  return res;
	};
	function updateReadableListening(self) {
	  var state = self._readableState;
	  state.readableListening = self.listenerCount('readable') > 0;
	  if (state.resumeScheduled && !state.paused) {
	    // flowing needs to be set to true now, otherwise
	    // the upcoming resume will not flow.
	    state.flowing = true;

	    // crude way to check if we should resume
	  } else if (self.listenerCount('data') > 0) {
	    self.resume();
	  }
	}
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}

	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    // we flow only if there is no one listening
	    // for readable, but we still have to call
	    // resume()
	    state.flowing = !state.readableListening;
	    resume(this, state);
	  }
	  state.paused = false;
	  return this;
	};
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(resume_, stream, state);
	  }
	}
	function resume_(stream, state) {
	  debug('resume', state.reading);
	  if (!state.reading) {
	    stream.read(0);
	  }
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (this._readableState.flowing !== false) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  this._readableState.paused = true;
	  return this;
	};
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null);
	}

	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	  var state = this._readableState;
	  var paused = false;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	    _this.push(null);
	  });
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);

	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });

	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function methodWrap(method) {
	        return function methodWrapReturnFunction() {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }

	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }

	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	  return this;
	};
	if (typeof Symbol === 'function') {
	  Readable.prototype[Symbol.asyncIterator] = function () {
	    if (createReadableStreamAsyncIterator === undefined) {
	      createReadableStreamAsyncIterator = requireAsync_iterator();
	    }
	    return createReadableStreamAsyncIterator(this);
	  };
	}
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._readableState.highWaterMark;
	  }
	});
	Object.defineProperty(Readable.prototype, 'readableBuffer', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._readableState && this._readableState.buffer;
	  }
	});
	Object.defineProperty(Readable.prototype, 'readableFlowing', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._readableState.flowing;
	  },
	  set: function set(state) {
	    if (this._readableState) {
	      this._readableState.flowing = state;
	    }
	  }
	});

	// exposed for testing purposes only.
	Readable._fromList = fromList;
	Object.defineProperty(Readable.prototype, 'readableLength', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function get() {
	    return this._readableState.length;
	  }
	});

	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = state.buffer.consume(n, state.decoder);
	  }
	  return ret;
	}
	function endReadable(stream) {
	  var state = stream._readableState;
	  debug('endReadable', state.endEmitted);
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(endReadableNT, state, stream);
	  }
	}
	function endReadableNT(state, stream) {
	  debug('endReadableNT', state.endEmitted, state.length);

	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	    if (state.autoDestroy) {
	      // In case of duplex streams we need a way to detect
	      // if the writable side is ready for autoDestroy as well
	      var wState = stream._writableState;
	      if (!wState || wState.autoDestroy && wState.finished) {
	        stream.destroy();
	      }
	    }
	  }
	}
	if (typeof Symbol === 'function') {
	  Readable.from = function (iterable, opts) {
	    if (from === undefined) {
	      from = requireFromBrowser();
	    }
	    return from(Readable, iterable, opts);
	  };
	}
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	return _stream_readable$1;
}

var _stream_transform$1;
var hasRequired_stream_transform$1;

function require_stream_transform$1 () {
	if (hasRequired_stream_transform$1) return _stream_transform$1;
	hasRequired_stream_transform$1 = 1;

	_stream_transform$1 = Transform;
	var _require$codes = requireErrorsBrowser().codes,
	  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
	  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
	  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
	  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
	var Duplex = require_stream_duplex$1();
	requireInherits_browser()(Transform, Duplex);
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	  var cb = ts.writecb;
	  if (cb === null) {
	    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
	  }
	  ts.writechunk = null;
	  ts.writecb = null;
	  if (data != null)
	    // single equals check for both `null` and `undefined`
	    this.push(data);
	  cb(er);
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	  Duplex.call(this, options);
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };

	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;

	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }

	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	function prefinish() {
	  var _this = this;
	  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};

	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
	};
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};

	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	  if (ts.writechunk !== null && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	Transform.prototype._destroy = function (err, cb) {
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	  });
	};
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	  if (data != null)
	    // single equals check for both `null` and `undefined`
	    stream.push(data);

	  // TODO(BridgeAR): Write a test for these two error cases
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
	  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
	  return stream.push(null);
	}
	return _stream_transform$1;
}

var _stream_passthrough$1;
var hasRequired_stream_passthrough$1;

function require_stream_passthrough$1 () {
	if (hasRequired_stream_passthrough$1) return _stream_passthrough$1;
	hasRequired_stream_passthrough$1 = 1;

	_stream_passthrough$1 = PassThrough;
	var Transform = require_stream_transform$1();
	requireInherits_browser()(PassThrough, Transform);
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	  Transform.call(this, options);
	}
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};
	return _stream_passthrough$1;
}

var pipeline_1;
var hasRequiredPipeline;

function requirePipeline () {
	if (hasRequiredPipeline) return pipeline_1;
	hasRequiredPipeline = 1;

	var eos;
	function once(callback) {
	  var called = false;
	  return function () {
	    if (called) return;
	    called = true;
	    callback.apply(void 0, arguments);
	  };
	}
	var _require$codes = requireErrorsBrowser().codes,
	  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
	  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
	function noop(err) {
	  // Rethrow the error if it exists to avoid swallowing it
	  if (err) throw err;
	}
	function isRequest(stream) {
	  return stream.setHeader && typeof stream.abort === 'function';
	}
	function destroyer(stream, reading, writing, callback) {
	  callback = once(callback);
	  var closed = false;
	  stream.on('close', function () {
	    closed = true;
	  });
	  if (eos === undefined) eos = requireEndOfStream();
	  eos(stream, {
	    readable: reading,
	    writable: writing
	  }, function (err) {
	    if (err) return callback(err);
	    closed = true;
	    callback();
	  });
	  var destroyed = false;
	  return function (err) {
	    if (closed) return;
	    if (destroyed) return;
	    destroyed = true;

	    // request.destroy just do .end - .abort is what we want
	    if (isRequest(stream)) return stream.abort();
	    if (typeof stream.destroy === 'function') return stream.destroy();
	    callback(err || new ERR_STREAM_DESTROYED('pipe'));
	  };
	}
	function call(fn) {
	  fn();
	}
	function pipe(from, to) {
	  return from.pipe(to);
	}
	function popCallback(streams) {
	  if (!streams.length) return noop;
	  if (typeof streams[streams.length - 1] !== 'function') return noop;
	  return streams.pop();
	}
	function pipeline() {
	  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
	    streams[_key] = arguments[_key];
	  }
	  var callback = popCallback(streams);
	  if (Array.isArray(streams[0])) streams = streams[0];
	  if (streams.length < 2) {
	    throw new ERR_MISSING_ARGS('streams');
	  }
	  var error;
	  var destroys = streams.map(function (stream, i) {
	    var reading = i < streams.length - 1;
	    var writing = i > 0;
	    return destroyer(stream, reading, writing, function (err) {
	      if (!error) error = err;
	      if (err) destroys.forEach(call);
	      if (reading) return;
	      destroys.forEach(call);
	      callback(error);
	    });
	  });
	  return streams.reduce(pipe);
	}
	pipeline_1 = pipeline;
	return pipeline_1;
}

var hasRequiredReadableBrowser$1;

function requireReadableBrowser$1 () {
	if (hasRequiredReadableBrowser$1) return readableBrowser$1.exports;
	hasRequiredReadableBrowser$1 = 1;
	(function (module, exports) {
		exports = module.exports = require_stream_readable$1();
		exports.Stream = exports;
		exports.Readable = exports;
		exports.Writable = require_stream_writable$1();
		exports.Duplex = require_stream_duplex$1();
		exports.Transform = require_stream_transform$1();
		exports.PassThrough = require_stream_passthrough$1();
		exports.finished = requireEndOfStream();
		exports.pipeline = requirePipeline(); 
	} (readableBrowser$1, readableBrowser$1.exports));
	return readableBrowser$1.exports;
}

var hashBase$1;
var hasRequiredHashBase$1;

function requireHashBase$1 () {
	if (hasRequiredHashBase$1) return hashBase$1;
	hasRequiredHashBase$1 = 1;
	var Buffer = requireSafeBuffer$2().Buffer;
	var Transform = requireReadableBrowser$1().Transform;
	var inherits = requireInherits_browser();

	function throwIfNotStringOrBuffer (val, prefix) {
	  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
	    throw new TypeError(prefix + ' must be a string or a buffer')
	  }
	}

	function HashBase (blockSize) {
	  Transform.call(this);

	  this._block = Buffer.allocUnsafe(blockSize);
	  this._blockSize = blockSize;
	  this._blockOffset = 0;
	  this._length = [0, 0, 0, 0];

	  this._finalized = false;
	}

	inherits(HashBase, Transform);

	HashBase.prototype._transform = function (chunk, encoding, callback) {
	  var error = null;
	  try {
	    this.update(chunk, encoding);
	  } catch (err) {
	    error = err;
	  }

	  callback(error);
	};

	HashBase.prototype._flush = function (callback) {
	  var error = null;
	  try {
	    this.push(this.digest());
	  } catch (err) {
	    error = err;
	  }

	  callback(error);
	};

	HashBase.prototype.update = function (data, encoding) {
	  throwIfNotStringOrBuffer(data, 'Data');
	  if (this._finalized) throw new Error('Digest already called')
	  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);

	  // consume data
	  var block = this._block;
	  var offset = 0;
	  while (this._blockOffset + data.length - offset >= this._blockSize) {
	    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++];
	    this._update();
	    this._blockOffset = 0;
	  }
	  while (offset < data.length) block[this._blockOffset++] = data[offset++];

	  // update length
	  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
	    this._length[j] += carry;
	    carry = (this._length[j] / 0x0100000000) | 0;
	    if (carry > 0) this._length[j] -= 0x0100000000 * carry;
	  }

	  return this
	};

	HashBase.prototype._update = function () {
	  throw new Error('_update is not implemented')
	};

	HashBase.prototype.digest = function (encoding) {
	  if (this._finalized) throw new Error('Digest already called')
	  this._finalized = true;

	  var digest = this._digest();
	  if (encoding !== undefined) digest = digest.toString(encoding);

	  // reset state
	  this._block.fill(0);
	  this._blockOffset = 0;
	  for (var i = 0; i < 4; ++i) this._length[i] = 0;

	  return digest
	};

	HashBase.prototype._digest = function () {
	  throw new Error('_digest is not implemented')
	};

	hashBase$1 = HashBase;
	return hashBase$1;
}

var md5_js;
var hasRequiredMd5_js;

function requireMd5_js () {
	if (hasRequiredMd5_js) return md5_js;
	hasRequiredMd5_js = 1;
	var inherits = requireInherits_browser();
	var HashBase = requireHashBase$1();
	var Buffer = requireSafeBuffer$2().Buffer;

	var ARRAY16 = new Array(16);

	function MD5 () {
	  HashBase.call(this, 64);

	  // state
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	}

	inherits(MD5, HashBase);

	MD5.prototype._update = function () {
	  var M = ARRAY16;
	  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4);

	  var a = this._a;
	  var b = this._b;
	  var c = this._c;
	  var d = this._d;

	  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
	  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
	  c = fnF(c, d, a, b, M[2], 0x242070db, 17);
	  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
	  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
	  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
	  c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
	  b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
	  a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
	  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
	  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
	  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
	  a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
	  d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
	  c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
	  b = fnF(b, c, d, a, M[15], 0x49b40821, 22);

	  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
	  d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
	  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
	  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
	  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
	  d = fnG(d, a, b, c, M[10], 0x02441453, 9);
	  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
	  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
	  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
	  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
	  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
	  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
	  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
	  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
	  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
	  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);

	  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
	  d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
	  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
	  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
	  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
	  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
	  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
	  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
	  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
	  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
	  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
	  b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
	  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
	  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
	  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
	  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);

	  a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
	  d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
	  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
	  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
	  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
	  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
	  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
	  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
	  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
	  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
	  c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
	  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
	  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
	  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
	  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
	  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);

	  this._a = (this._a + a) | 0;
	  this._b = (this._b + b) | 0;
	  this._c = (this._c + c) | 0;
	  this._d = (this._d + d) | 0;
	};

	MD5.prototype._digest = function () {
	  // create padding and handle blocks
	  this._block[this._blockOffset++] = 0x80;
	  if (this._blockOffset > 56) {
	    this._block.fill(0, this._blockOffset, 64);
	    this._update();
	    this._blockOffset = 0;
	  }

	  this._block.fill(0, this._blockOffset, 56);
	  this._block.writeUInt32LE(this._length[0], 56);
	  this._block.writeUInt32LE(this._length[1], 60);
	  this._update();

	  // produce result
	  var buffer = Buffer.allocUnsafe(16);
	  buffer.writeInt32LE(this._a, 0);
	  buffer.writeInt32LE(this._b, 4);
	  buffer.writeInt32LE(this._c, 8);
	  buffer.writeInt32LE(this._d, 12);
	  return buffer
	};

	function rotl (x, n) {
	  return (x << n) | (x >>> (32 - n))
	}

	function fnF (a, b, c, d, m, k, s) {
	  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
	}

	function fnG (a, b, c, d, m, k, s) {
	  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
	}

	function fnH (a, b, c, d, m, k, s) {
	  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
	}

	function fnI (a, b, c, d, m, k, s) {
	  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
	}

	md5_js = MD5;
	return md5_js;
}

var hashBase;
var hasRequiredHashBase;

function requireHashBase () {
	if (hasRequiredHashBase) return hashBase;
	hasRequiredHashBase = 1;
	var Buffer = requireSafeBuffer$2().Buffer;
	var Transform = requireReadableBrowser$1().Transform;
	var inherits = requireInherits_browser();

	function throwIfNotStringOrBuffer (val, prefix) {
	  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
	    throw new TypeError(prefix + ' must be a string or a buffer')
	  }
	}

	function HashBase (blockSize) {
	  Transform.call(this);

	  this._block = Buffer.allocUnsafe(blockSize);
	  this._blockSize = blockSize;
	  this._blockOffset = 0;
	  this._length = [0, 0, 0, 0];

	  this._finalized = false;
	}

	inherits(HashBase, Transform);

	HashBase.prototype._transform = function (chunk, encoding, callback) {
	  var error = null;
	  try {
	    this.update(chunk, encoding);
	  } catch (err) {
	    error = err;
	  }

	  callback(error);
	};

	HashBase.prototype._flush = function (callback) {
	  var error = null;
	  try {
	    this.push(this.digest());
	  } catch (err) {
	    error = err;
	  }

	  callback(error);
	};

	HashBase.prototype.update = function (data, encoding) {
	  throwIfNotStringOrBuffer(data, 'Data');
	  if (this._finalized) throw new Error('Digest already called')
	  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);

	  // consume data
	  var block = this._block;
	  var offset = 0;
	  while (this._blockOffset + data.length - offset >= this._blockSize) {
	    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++];
	    this._update();
	    this._blockOffset = 0;
	  }
	  while (offset < data.length) block[this._blockOffset++] = data[offset++];

	  // update length
	  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
	    this._length[j] += carry;
	    carry = (this._length[j] / 0x0100000000) | 0;
	    if (carry > 0) this._length[j] -= 0x0100000000 * carry;
	  }

	  return this
	};

	HashBase.prototype._update = function () {
	  throw new Error('_update is not implemented')
	};

	HashBase.prototype.digest = function (encoding) {
	  if (this._finalized) throw new Error('Digest already called')
	  this._finalized = true;

	  var digest = this._digest();
	  if (encoding !== undefined) digest = digest.toString(encoding);

	  // reset state
	  this._block.fill(0);
	  this._blockOffset = 0;
	  for (var i = 0; i < 4; ++i) this._length[i] = 0;

	  return digest
	};

	HashBase.prototype._digest = function () {
	  throw new Error('_digest is not implemented')
	};

	hashBase = HashBase;
	return hashBase;
}

var ripemd160;
var hasRequiredRipemd160;

function requireRipemd160 () {
	if (hasRequiredRipemd160) return ripemd160;
	hasRequiredRipemd160 = 1;
	var Buffer = requireBuffer$1().Buffer;
	var inherits = requireInherits_browser();
	var HashBase = requireHashBase();

	var ARRAY16 = new Array(16);

	var zl = [
	  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	];

	var zr = [
	  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	];

	var sl = [
	  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	];

	var sr = [
	  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	];

	var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
	var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];

	function RIPEMD160 () {
	  HashBase.call(this, 64);

	  // state
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;
	}

	inherits(RIPEMD160, HashBase);

	RIPEMD160.prototype._update = function () {
	  var words = ARRAY16;
	  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4);

	  var al = this._a | 0;
	  var bl = this._b | 0;
	  var cl = this._c | 0;
	  var dl = this._d | 0;
	  var el = this._e | 0;

	  var ar = this._a | 0;
	  var br = this._b | 0;
	  var cr = this._c | 0;
	  var dr = this._d | 0;
	  var er = this._e | 0;

	  // computation
	  for (var i = 0; i < 80; i += 1) {
	    var tl;
	    var tr;
	    if (i < 16) {
	      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
	      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
	    } else if (i < 32) {
	      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
	      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
	    } else if (i < 48) {
	      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
	      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
	    } else if (i < 64) {
	      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
	      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
	    } else { // if (i<80) {
	      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
	      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
	    }

	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = tl;

	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = tr;
	  }

	  // update state
	  var t = (this._b + cl + dr) | 0;
	  this._b = (this._c + dl + er) | 0;
	  this._c = (this._d + el + ar) | 0;
	  this._d = (this._e + al + br) | 0;
	  this._e = (this._a + bl + cr) | 0;
	  this._a = t;
	};

	RIPEMD160.prototype._digest = function () {
	  // create padding and handle blocks
	  this._block[this._blockOffset++] = 0x80;
	  if (this._blockOffset > 56) {
	    this._block.fill(0, this._blockOffset, 64);
	    this._update();
	    this._blockOffset = 0;
	  }

	  this._block.fill(0, this._blockOffset, 56);
	  this._block.writeUInt32LE(this._length[0], 56);
	  this._block.writeUInt32LE(this._length[1], 60);
	  this._update();

	  // produce result
	  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20);
	  buffer.writeInt32LE(this._a, 0);
	  buffer.writeInt32LE(this._b, 4);
	  buffer.writeInt32LE(this._c, 8);
	  buffer.writeInt32LE(this._d, 12);
	  buffer.writeInt32LE(this._e, 16);
	  return buffer
	};

	function rotl (x, n) {
	  return (x << n) | (x >>> (32 - n))
	}

	function fn1 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
	}

	function fn2 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
	}

	function fn3 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
	}

	function fn4 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
	}

	function fn5 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
	}

	ripemd160 = RIPEMD160;
	return ripemd160;
}

var sha_js = {exports: {}};

var hash$1;
var hasRequiredHash$1;

function requireHash$1 () {
	if (hasRequiredHash$1) return hash$1;
	hasRequiredHash$1 = 1;
	var Buffer = requireSafeBuffer$2().Buffer;

	// prototype class for hash functions
	function Hash (blockSize, finalSize) {
	  this._block = Buffer.alloc(blockSize);
	  this._finalSize = finalSize;
	  this._blockSize = blockSize;
	  this._len = 0;
	}

	Hash.prototype.update = function (data, enc) {
	  if (typeof data === 'string') {
	    enc = enc || 'utf8';
	    data = Buffer.from(data, enc);
	  }

	  var block = this._block;
	  var blockSize = this._blockSize;
	  var length = data.length;
	  var accum = this._len;

	  for (var offset = 0; offset < length;) {
	    var assigned = accum % blockSize;
	    var remainder = Math.min(length - offset, blockSize - assigned);

	    for (var i = 0; i < remainder; i++) {
	      block[assigned + i] = data[offset + i];
	    }

	    accum += remainder;
	    offset += remainder;

	    if ((accum % blockSize) === 0) {
	      this._update(block);
	    }
	  }

	  this._len += length;
	  return this
	};

	Hash.prototype.digest = function (enc) {
	  var rem = this._len % this._blockSize;

	  this._block[rem] = 0x80;

	  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	  this._block.fill(0, rem + 1);

	  if (rem >= this._finalSize) {
	    this._update(this._block);
	    this._block.fill(0);
	  }

	  var bits = this._len * 8;

	  // uint32
	  if (bits <= 0xffffffff) {
	    this._block.writeUInt32BE(bits, this._blockSize - 4);

	  // uint64
	  } else {
	    var lowBits = (bits & 0xffffffff) >>> 0;
	    var highBits = (bits - lowBits) / 0x100000000;

	    this._block.writeUInt32BE(highBits, this._blockSize - 8);
	    this._block.writeUInt32BE(lowBits, this._blockSize - 4);
	  }

	  this._update(this._block);
	  var hash = this._hash();

	  return enc ? hash.toString(enc) : hash
	};

	Hash.prototype._update = function () {
	  throw new Error('_update must be implemented by subclass')
	};

	hash$1 = Hash;
	return hash$1;
}

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var sha$1;
var hasRequiredSha$1;

function requireSha$1 () {
	if (hasRequiredSha$1) return sha$1;
	hasRequiredSha$1 = 1;
	var inherits = requireInherits_browser();
	var Hash = requireHash$1();
	var Buffer = requireSafeBuffer$2().Buffer;

	var K = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	];

	var W = new Array(80);

	function Sha () {
	  this.init();
	  this._w = W;

	  Hash.call(this, 64, 56);
	}

	inherits(Sha, Hash);

	Sha.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;

	  return this
	};

	function rotl5 (num) {
	  return (num << 5) | (num >>> 27)
	}

	function rotl30 (num) {
	  return (num << 30) | (num >>> 2)
	}

	function ft (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}

	Sha.prototype._update = function (M) {
	  var W = this._w;

	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;

	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
	  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];

	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0;

	    e = d;
	    d = c;
	    c = rotl30(b);
	    b = a;
	    a = t;
	  }

	  this._a = (a + this._a) | 0;
	  this._b = (b + this._b) | 0;
	  this._c = (c + this._c) | 0;
	  this._d = (d + this._d) | 0;
	  this._e = (e + this._e) | 0;
	};

	Sha.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20);

	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);

	  return H
	};

	sha$1 = Sha;
	return sha$1;
}

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var sha1;
var hasRequiredSha1;

function requireSha1 () {
	if (hasRequiredSha1) return sha1;
	hasRequiredSha1 = 1;
	var inherits = requireInherits_browser();
	var Hash = requireHash$1();
	var Buffer = requireSafeBuffer$2().Buffer;

	var K = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	];

	var W = new Array(80);

	function Sha1 () {
	  this.init();
	  this._w = W;

	  Hash.call(this, 64, 56);
	}

	inherits(Sha1, Hash);

	Sha1.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;

	  return this
	};

	function rotl1 (num) {
	  return (num << 1) | (num >>> 31)
	}

	function rotl5 (num) {
	  return (num << 5) | (num >>> 27)
	}

	function rotl30 (num) {
	  return (num << 30) | (num >>> 2)
	}

	function ft (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}

	Sha1.prototype._update = function (M) {
	  var W = this._w;

	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;

	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
	  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);

	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0;

	    e = d;
	    d = c;
	    c = rotl30(b);
	    b = a;
	    a = t;
	  }

	  this._a = (a + this._a) | 0;
	  this._b = (b + this._b) | 0;
	  this._c = (c + this._c) | 0;
	  this._d = (d + this._d) | 0;
	  this._e = (e + this._e) | 0;
	};

	Sha1.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20);

	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);

	  return H
	};

	sha1 = Sha1;
	return sha1;
}

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var sha256$1;
var hasRequiredSha256;

function requireSha256 () {
	if (hasRequiredSha256) return sha256$1;
	hasRequiredSha256 = 1;
	var inherits = requireInherits_browser();
	var Hash = requireHash$1();
	var Buffer = requireSafeBuffer$2().Buffer;

	var K = [
	  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	];

	var W = new Array(64);

	function Sha256 () {
	  this.init();

	  this._w = W; // new Array(64)

	  Hash.call(this, 64, 56);
	}

	inherits(Sha256, Hash);

	Sha256.prototype.init = function () {
	  this._a = 0x6a09e667;
	  this._b = 0xbb67ae85;
	  this._c = 0x3c6ef372;
	  this._d = 0xa54ff53a;
	  this._e = 0x510e527f;
	  this._f = 0x9b05688c;
	  this._g = 0x1f83d9ab;
	  this._h = 0x5be0cd19;

	  return this
	};

	function ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}

	function maj (x, y, z) {
	  return (x & y) | (z & (x | y))
	}

	function sigma0 (x) {
	  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
	}

	function sigma1 (x) {
	  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
	}

	function gamma0 (x) {
	  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
	}

	function gamma1 (x) {
	  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
	}

	Sha256.prototype._update = function (M) {
	  var W = this._w;

	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	  var f = this._f | 0;
	  var g = this._g | 0;
	  var h = this._h | 0;

	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
	  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0;

	  for (var j = 0; j < 64; ++j) {
	    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0;
	    var T2 = (sigma0(a) + maj(a, b, c)) | 0;

	    h = g;
	    g = f;
	    f = e;
	    e = (d + T1) | 0;
	    d = c;
	    c = b;
	    b = a;
	    a = (T1 + T2) | 0;
	  }

	  this._a = (a + this._a) | 0;
	  this._b = (b + this._b) | 0;
	  this._c = (c + this._c) | 0;
	  this._d = (d + this._d) | 0;
	  this._e = (e + this._e) | 0;
	  this._f = (f + this._f) | 0;
	  this._g = (g + this._g) | 0;
	  this._h = (h + this._h) | 0;
	};

	Sha256.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(32);

	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);
	  H.writeInt32BE(this._h, 28);

	  return H
	};

	sha256$1 = Sha256;
	return sha256$1;
}

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var sha224$1;
var hasRequiredSha224;

function requireSha224 () {
	if (hasRequiredSha224) return sha224$1;
	hasRequiredSha224 = 1;
	var inherits = requireInherits_browser();
	var Sha256 = requireSha256();
	var Hash = requireHash$1();
	var Buffer = requireSafeBuffer$2().Buffer;

	var W = new Array(64);

	function Sha224 () {
	  this.init();

	  this._w = W; // new Array(64)

	  Hash.call(this, 64, 56);
	}

	inherits(Sha224, Sha256);

	Sha224.prototype.init = function () {
	  this._a = 0xc1059ed8;
	  this._b = 0x367cd507;
	  this._c = 0x3070dd17;
	  this._d = 0xf70e5939;
	  this._e = 0xffc00b31;
	  this._f = 0x68581511;
	  this._g = 0x64f98fa7;
	  this._h = 0xbefa4fa4;

	  return this
	};

	Sha224.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(28);

	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);

	  return H
	};

	sha224$1 = Sha224;
	return sha224$1;
}

var sha512$1;
var hasRequiredSha512;

function requireSha512 () {
	if (hasRequiredSha512) return sha512$1;
	hasRequiredSha512 = 1;
	var inherits = requireInherits_browser();
	var Hash = requireHash$1();
	var Buffer = requireSafeBuffer$2().Buffer;

	var K = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	];

	var W = new Array(160);

	function Sha512 () {
	  this.init();
	  this._w = W;

	  Hash.call(this, 128, 112);
	}

	inherits(Sha512, Hash);

	Sha512.prototype.init = function () {
	  this._ah = 0x6a09e667;
	  this._bh = 0xbb67ae85;
	  this._ch = 0x3c6ef372;
	  this._dh = 0xa54ff53a;
	  this._eh = 0x510e527f;
	  this._fh = 0x9b05688c;
	  this._gh = 0x1f83d9ab;
	  this._hh = 0x5be0cd19;

	  this._al = 0xf3bcc908;
	  this._bl = 0x84caa73b;
	  this._cl = 0xfe94f82b;
	  this._dl = 0x5f1d36f1;
	  this._el = 0xade682d1;
	  this._fl = 0x2b3e6c1f;
	  this._gl = 0xfb41bd6b;
	  this._hl = 0x137e2179;

	  return this
	};

	function Ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}

	function maj (x, y, z) {
	  return (x & y) | (z & (x | y))
	}

	function sigma0 (x, xl) {
	  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
	}

	function sigma1 (x, xl) {
	  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
	}

	function Gamma0 (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
	}

	function Gamma0l (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
	}

	function Gamma1 (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
	}

	function Gamma1l (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
	}

	function getCarry (a, b) {
	  return (a >>> 0) < (b >>> 0) ? 1 : 0
	}

	Sha512.prototype._update = function (M) {
	  var W = this._w;

	  var ah = this._ah | 0;
	  var bh = this._bh | 0;
	  var ch = this._ch | 0;
	  var dh = this._dh | 0;
	  var eh = this._eh | 0;
	  var fh = this._fh | 0;
	  var gh = this._gh | 0;
	  var hh = this._hh | 0;

	  var al = this._al | 0;
	  var bl = this._bl | 0;
	  var cl = this._cl | 0;
	  var dl = this._dl | 0;
	  var el = this._el | 0;
	  var fl = this._fl | 0;
	  var gl = this._gl | 0;
	  var hl = this._hl | 0;

	  for (var i = 0; i < 32; i += 2) {
	    W[i] = M.readInt32BE(i * 4);
	    W[i + 1] = M.readInt32BE(i * 4 + 4);
	  }
	  for (; i < 160; i += 2) {
	    var xh = W[i - 15 * 2];
	    var xl = W[i - 15 * 2 + 1];
	    var gamma0 = Gamma0(xh, xl);
	    var gamma0l = Gamma0l(xl, xh);

	    xh = W[i - 2 * 2];
	    xl = W[i - 2 * 2 + 1];
	    var gamma1 = Gamma1(xh, xl);
	    var gamma1l = Gamma1l(xl, xh);

	    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	    var Wi7h = W[i - 7 * 2];
	    var Wi7l = W[i - 7 * 2 + 1];

	    var Wi16h = W[i - 16 * 2];
	    var Wi16l = W[i - 16 * 2 + 1];

	    var Wil = (gamma0l + Wi7l) | 0;
	    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0;
	    Wil = (Wil + gamma1l) | 0;
	    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0;
	    Wil = (Wil + Wi16l) | 0;
	    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0;

	    W[i] = Wih;
	    W[i + 1] = Wil;
	  }

	  for (var j = 0; j < 160; j += 2) {
	    Wih = W[j];
	    Wil = W[j + 1];

	    var majh = maj(ah, bh, ch);
	    var majl = maj(al, bl, cl);

	    var sigma0h = sigma0(ah, al);
	    var sigma0l = sigma0(al, ah);
	    var sigma1h = sigma1(eh, el);
	    var sigma1l = sigma1(el, eh);

	    // t1 = h + sigma1 + ch + K[j] + W[j]
	    var Kih = K[j];
	    var Kil = K[j + 1];

	    var chh = Ch(eh, fh, gh);
	    var chl = Ch(el, fl, gl);

	    var t1l = (hl + sigma1l) | 0;
	    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0;
	    t1l = (t1l + chl) | 0;
	    t1h = (t1h + chh + getCarry(t1l, chl)) | 0;
	    t1l = (t1l + Kil) | 0;
	    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0;
	    t1l = (t1l + Wil) | 0;
	    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0;

	    // t2 = sigma0 + maj
	    var t2l = (sigma0l + majl) | 0;
	    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0;

	    hh = gh;
	    hl = gl;
	    gh = fh;
	    gl = fl;
	    fh = eh;
	    fl = el;
	    el = (dl + t1l) | 0;
	    eh = (dh + t1h + getCarry(el, dl)) | 0;
	    dh = ch;
	    dl = cl;
	    ch = bh;
	    cl = bl;
	    bh = ah;
	    bl = al;
	    al = (t1l + t2l) | 0;
	    ah = (t1h + t2h + getCarry(al, t1l)) | 0;
	  }

	  this._al = (this._al + al) | 0;
	  this._bl = (this._bl + bl) | 0;
	  this._cl = (this._cl + cl) | 0;
	  this._dl = (this._dl + dl) | 0;
	  this._el = (this._el + el) | 0;
	  this._fl = (this._fl + fl) | 0;
	  this._gl = (this._gl + gl) | 0;
	  this._hl = (this._hl + hl) | 0;

	  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0;
	  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0;
	  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0;
	  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0;
	  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0;
	  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0;
	  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0;
	  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0;
	};

	Sha512.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(64);

	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }

	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);
	  writeInt64BE(this._gh, this._gl, 48);
	  writeInt64BE(this._hh, this._hl, 56);

	  return H
	};

	sha512$1 = Sha512;
	return sha512$1;
}

var sha384$1;
var hasRequiredSha384;

function requireSha384 () {
	if (hasRequiredSha384) return sha384$1;
	hasRequiredSha384 = 1;
	var inherits = requireInherits_browser();
	var SHA512 = requireSha512();
	var Hash = requireHash$1();
	var Buffer = requireSafeBuffer$2().Buffer;

	var W = new Array(160);

	function Sha384 () {
	  this.init();
	  this._w = W;

	  Hash.call(this, 128, 112);
	}

	inherits(Sha384, SHA512);

	Sha384.prototype.init = function () {
	  this._ah = 0xcbbb9d5d;
	  this._bh = 0x629a292a;
	  this._ch = 0x9159015a;
	  this._dh = 0x152fecd8;
	  this._eh = 0x67332667;
	  this._fh = 0x8eb44a87;
	  this._gh = 0xdb0c2e0d;
	  this._hh = 0x47b5481d;

	  this._al = 0xc1059ed8;
	  this._bl = 0x367cd507;
	  this._cl = 0x3070dd17;
	  this._dl = 0xf70e5939;
	  this._el = 0xffc00b31;
	  this._fl = 0x68581511;
	  this._gl = 0x64f98fa7;
	  this._hl = 0xbefa4fa4;

	  return this
	};

	Sha384.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(48);

	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }

	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);

	  return H
	};

	sha384$1 = Sha384;
	return sha384$1;
}

var hasRequiredSha_js;

function requireSha_js () {
	if (hasRequiredSha_js) return sha_js.exports;
	hasRequiredSha_js = 1;
	var exports = sha_js.exports = function SHA (algorithm) {
	  algorithm = algorithm.toLowerCase();

	  var Algorithm = exports[algorithm];
	  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

	  return new Algorithm()
	};

	exports.sha = requireSha$1();
	exports.sha1 = requireSha1();
	exports.sha224 = requireSha224();
	exports.sha256 = requireSha256();
	exports.sha384 = requireSha384();
	exports.sha512 = requireSha512();
	return sha_js.exports;
}

var streamBrowserify;
var hasRequiredStreamBrowserify;

function requireStreamBrowserify () {
	if (hasRequiredStreamBrowserify) return streamBrowserify;
	hasRequiredStreamBrowserify = 1;
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	streamBrowserify = Stream;

	var EE = requireEvents().EventEmitter;
	var inherits = requireInherits_browser();

	inherits(Stream, EE);
	Stream.Readable = require_stream_readable$1();
	Stream.Writable = require_stream_writable$1();
	Stream.Duplex = require_stream_duplex$1();
	Stream.Transform = require_stream_transform$1();
	Stream.PassThrough = require_stream_passthrough$1();
	Stream.finished = requireEndOfStream();
	Stream.pipeline = requirePipeline();

	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;



	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.

	function Stream() {
	  EE.call(this);
	}

	Stream.prototype.pipe = function(dest, options) {
	  var source = this;

	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }

	  source.on('data', ondata);

	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }

	  dest.on('drain', ondrain);

	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }

	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    dest.end();
	  }


	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    if (typeof dest.destroy === 'function') dest.destroy();
	  }

	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }

	  source.on('error', onerror);
	  dest.on('error', onerror);

	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);

	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);

	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);

	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);

	    dest.removeListener('close', cleanup);
	  }

	  source.on('end', cleanup);
	  source.on('close', cleanup);

	  dest.on('close', cleanup);

	  dest.emit('pipe', source);

	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};
	return streamBrowserify;
}

var cipherBase;
var hasRequiredCipherBase;

function requireCipherBase () {
	if (hasRequiredCipherBase) return cipherBase;
	hasRequiredCipherBase = 1;

	var Buffer = requireSafeBuffer$2().Buffer;
	var Transform = requireStreamBrowserify().Transform;
	var StringDecoder = requireString_decoder$1().StringDecoder;
	var inherits = requireInherits_browser();

	function CipherBase(hashMode) {
		Transform.call(this);
		this.hashMode = typeof hashMode === 'string';
		if (this.hashMode) {
			this[hashMode] = this._finalOrDigest;
		} else {
			this['final'] = this._finalOrDigest;
		}
		if (this._final) {
			this.__final = this._final;
			this._final = null;
		}
		this._decoder = null;
		this._encoding = null;
	}
	inherits(CipherBase, Transform);

	var useUint8Array = typeof Uint8Array !== 'undefined';
	var useArrayBuffer = typeof ArrayBuffer !== 'undefined'
		&& typeof Uint8Array !== 'undefined'
		&& ArrayBuffer.isView
		&& (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT);

	function toBuffer(data, encoding) {
		/*
		 * No need to do anything for exact instance
		 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
		 */
		if (data instanceof Buffer) {
			return data;
		}

		// Convert strings to Buffer
		if (typeof data === 'string') {
			return Buffer.from(data, encoding);
		}

		/*
		 * Wrap any TypedArray instances and DataViews
		 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
		 */
		if (useArrayBuffer && ArrayBuffer.isView(data)) {
			// Bug in Node.js <6.3.1, which treats this as out-of-bounds
			if (data.byteLength === 0) {
				return Buffer.alloc(0);
			}

			var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength);
			/*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */
			if (res.byteLength === data.byteLength) {
				return res;
			}
		}

		/*
		 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
		 * Doesn't make sense with other TypedArray instances
		 */
		if (useUint8Array && data instanceof Uint8Array) {
			return Buffer.from(data);
		}

		/*
		 * Old Buffer polyfill on an engine that doesn't have TypedArray support
		 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
		 * Convert to our current Buffer implementation
		 */
		if (
			Buffer.isBuffer(data)
				&& data.constructor
				&& typeof data.constructor.isBuffer === 'function'
				&& data.constructor.isBuffer(data)
		) {
			return Buffer.from(data);
		}

		throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
	}

	CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
		var bufferData = toBuffer(data, inputEnc); // asserts correct input type
		var outData = this._update(bufferData);
		if (this.hashMode) {
			return this;
		}

		if (outputEnc) {
			outData = this._toString(outData, outputEnc);
		}

		return outData;
	};

	CipherBase.prototype.setAutoPadding = function () {};
	CipherBase.prototype.getAuthTag = function () {
		throw new Error('trying to get auth tag in unsupported state');
	};

	CipherBase.prototype.setAuthTag = function () {
		throw new Error('trying to set auth tag in unsupported state');
	};

	CipherBase.prototype.setAAD = function () {
		throw new Error('trying to set aad in unsupported state');
	};

	CipherBase.prototype._transform = function (data, _, next) {
		var err;
		try {
			if (this.hashMode) {
				this._update(data);
			} else {
				this.push(this._update(data));
			}
		} catch (e) {
			err = e;
		} finally {
			next(err);
		}
	};
	CipherBase.prototype._flush = function (done) {
		var err;
		try {
			this.push(this.__final());
		} catch (e) {
			err = e;
		}

		done(err);
	};
	CipherBase.prototype._finalOrDigest = function (outputEnc) {
		var outData = this.__final() || Buffer.alloc(0);
		if (outputEnc) {
			outData = this._toString(outData, outputEnc, true);
		}
		return outData;
	};

	CipherBase.prototype._toString = function (value, enc, fin) {
		if (!this._decoder) {
			this._decoder = new StringDecoder(enc);
			this._encoding = enc;
		}

		if (this._encoding !== enc) {
			throw new Error('can’t switch encodings');
		}

		var out = this._decoder.write(value);
		if (fin) {
			out += this._decoder.end();
		}

		return out;
	};

	cipherBase = CipherBase;
	return cipherBase;
}

var browser$9;
var hasRequiredBrowser$9;

function requireBrowser$9 () {
	if (hasRequiredBrowser$9) return browser$9;
	hasRequiredBrowser$9 = 1;
	var inherits = requireInherits_browser();
	var MD5 = requireMd5_js();
	var RIPEMD160 = requireRipemd160();
	var sha = requireSha_js();
	var Base = requireCipherBase();

	function Hash (hash) {
	  Base.call(this, 'digest');

	  this._hash = hash;
	}

	inherits(Hash, Base);

	Hash.prototype._update = function (data) {
	  this._hash.update(data);
	};

	Hash.prototype._final = function () {
	  return this._hash.digest()
	};

	browser$9 = function createHash (alg) {
	  alg = alg.toLowerCase();
	  if (alg === 'md5') return new MD5()
	  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

	  return new Hash(sha(alg))
	};
	return browser$9;
}

var legacy;
var hasRequiredLegacy;

function requireLegacy () {
	if (hasRequiredLegacy) return legacy;
	hasRequiredLegacy = 1;
	var inherits = requireInherits_browser();
	var Buffer = requireSafeBuffer$2().Buffer;

	var Base = requireCipherBase();

	var ZEROS = Buffer.alloc(128);
	var blocksize = 64;

	function Hmac (alg, key) {
	  Base.call(this, 'digest');
	  if (typeof key === 'string') {
	    key = Buffer.from(key);
	  }

	  this._alg = alg;
	  this._key = key;

	  if (key.length > blocksize) {
	    key = alg(key);
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize);
	  }

	  var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
	  var opad = this._opad = Buffer.allocUnsafe(blocksize);

	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36;
	    opad[i] = key[i] ^ 0x5C;
	  }

	  this._hash = [ipad];
	}

	inherits(Hmac, Base);

	Hmac.prototype._update = function (data) {
	  this._hash.push(data);
	};

	Hmac.prototype._final = function () {
	  var h = this._alg(Buffer.concat(this._hash));
	  return this._alg(Buffer.concat([this._opad, h]))
	};
	legacy = Hmac;
	return legacy;
}

var md5;
var hasRequiredMd5;

function requireMd5 () {
	if (hasRequiredMd5) return md5;
	hasRequiredMd5 = 1;
	var MD5 = requireMd5_js();

	md5 = function (buffer) {
	  return new MD5().update(buffer).digest()
	};
	return md5;
}

var browser$8;
var hasRequiredBrowser$8;

function requireBrowser$8 () {
	if (hasRequiredBrowser$8) return browser$8;
	hasRequiredBrowser$8 = 1;
	var inherits = requireInherits_browser();
	var Legacy = requireLegacy();
	var Base = requireCipherBase();
	var Buffer = requireSafeBuffer$2().Buffer;
	var md5 = requireMd5();
	var RIPEMD160 = requireRipemd160();

	var sha = requireSha_js();

	var ZEROS = Buffer.alloc(128);

	function Hmac (alg, key) {
	  Base.call(this, 'digest');
	  if (typeof key === 'string') {
	    key = Buffer.from(key);
	  }

	  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64;

	  this._alg = alg;
	  this._key = key;
	  if (key.length > blocksize) {
	    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
	    key = hash.update(key).digest();
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize);
	  }

	  var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
	  var opad = this._opad = Buffer.allocUnsafe(blocksize);

	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36;
	    opad[i] = key[i] ^ 0x5C;
	  }
	  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
	  this._hash.update(ipad);
	}

	inherits(Hmac, Base);

	Hmac.prototype._update = function (data) {
	  this._hash.update(data);
	};

	Hmac.prototype._final = function () {
	  var h = this._hash.digest();
	  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg);
	  return hash.update(this._opad).update(h).digest()
	};

	browser$8 = function createHmac (alg, key) {
	  alg = alg.toLowerCase();
	  if (alg === 'rmd160' || alg === 'ripemd160') {
	    return new Hmac('rmd160', key)
	  }
	  if (alg === 'md5') {
	    return new Legacy(md5, key)
	  }
	  return new Hmac(alg, key)
	};
	return browser$8;
}

var sha224WithRSAEncryption = {
	sign: "rsa",
	hash: "sha224",
	id: "302d300d06096086480165030402040500041c"
};
var sha256WithRSAEncryption = {
	sign: "rsa",
	hash: "sha256",
	id: "3031300d060960864801650304020105000420"
};
var sha384WithRSAEncryption = {
	sign: "rsa",
	hash: "sha384",
	id: "3041300d060960864801650304020205000430"
};
var sha512WithRSAEncryption = {
	sign: "rsa",
	hash: "sha512",
	id: "3051300d060960864801650304020305000440"
};
var sha256 = {
	sign: "ecdsa",
	hash: "sha256",
	id: ""
};
var sha224 = {
	sign: "ecdsa",
	hash: "sha224",
	id: ""
};
var sha384 = {
	sign: "ecdsa",
	hash: "sha384",
	id: ""
};
var sha512 = {
	sign: "ecdsa",
	hash: "sha512",
	id: ""
};
var DSA = {
	sign: "dsa",
	hash: "sha1",
	id: ""
};
var ripemd160WithRSA = {
	sign: "rsa",
	hash: "rmd160",
	id: "3021300906052b2403020105000414"
};
var md5WithRSAEncryption = {
	sign: "rsa",
	hash: "md5",
	id: "3020300c06082a864886f70d020505000410"
};
var require$$6 = {
	sha224WithRSAEncryption: sha224WithRSAEncryption,
	"RSA-SHA224": {
	sign: "ecdsa/rsa",
	hash: "sha224",
	id: "302d300d06096086480165030402040500041c"
},
	sha256WithRSAEncryption: sha256WithRSAEncryption,
	"RSA-SHA256": {
	sign: "ecdsa/rsa",
	hash: "sha256",
	id: "3031300d060960864801650304020105000420"
},
	sha384WithRSAEncryption: sha384WithRSAEncryption,
	"RSA-SHA384": {
	sign: "ecdsa/rsa",
	hash: "sha384",
	id: "3041300d060960864801650304020205000430"
},
	sha512WithRSAEncryption: sha512WithRSAEncryption,
	"RSA-SHA512": {
	sign: "ecdsa/rsa",
	hash: "sha512",
	id: "3051300d060960864801650304020305000440"
},
	"RSA-SHA1": {
	sign: "rsa",
	hash: "sha1",
	id: "3021300906052b0e03021a05000414"
},
	"ecdsa-with-SHA1": {
	sign: "ecdsa",
	hash: "sha1",
	id: ""
},
	sha256: sha256,
	sha224: sha224,
	sha384: sha384,
	sha512: sha512,
	"DSA-SHA": {
	sign: "dsa",
	hash: "sha1",
	id: ""
},
	"DSA-SHA1": {
	sign: "dsa",
	hash: "sha1",
	id: ""
},
	DSA: DSA,
	"DSA-WITH-SHA224": {
	sign: "dsa",
	hash: "sha224",
	id: ""
},
	"DSA-SHA224": {
	sign: "dsa",
	hash: "sha224",
	id: ""
},
	"DSA-WITH-SHA256": {
	sign: "dsa",
	hash: "sha256",
	id: ""
},
	"DSA-SHA256": {
	sign: "dsa",
	hash: "sha256",
	id: ""
},
	"DSA-WITH-SHA384": {
	sign: "dsa",
	hash: "sha384",
	id: ""
},
	"DSA-SHA384": {
	sign: "dsa",
	hash: "sha384",
	id: ""
},
	"DSA-WITH-SHA512": {
	sign: "dsa",
	hash: "sha512",
	id: ""
},
	"DSA-SHA512": {
	sign: "dsa",
	hash: "sha512",
	id: ""
},
	"DSA-RIPEMD160": {
	sign: "dsa",
	hash: "rmd160",
	id: ""
},
	ripemd160WithRSA: ripemd160WithRSA,
	"RSA-RIPEMD160": {
	sign: "rsa",
	hash: "rmd160",
	id: "3021300906052b2403020105000414"
},
	md5WithRSAEncryption: md5WithRSAEncryption,
	"RSA-MD5": {
	sign: "rsa",
	hash: "md5",
	id: "3020300c06082a864886f70d020505000410"
}
};

var algos;
var hasRequiredAlgos;

function requireAlgos () {
	if (hasRequiredAlgos) return algos;
	hasRequiredAlgos = 1;

	algos = require$$6;
	return algos;
}

var browser$7 = {};

var precondition;
var hasRequiredPrecondition;

function requirePrecondition () {
	if (hasRequiredPrecondition) return precondition;
	hasRequiredPrecondition = 1;
	var MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs

	precondition = function (iterations, keylen) {
	  if (typeof iterations !== 'number') {
	    throw new TypeError('Iterations not a number')
	  }

	  if (iterations < 0) {
	    throw new TypeError('Bad iterations')
	  }

	  if (typeof keylen !== 'number') {
	    throw new TypeError('Key length not a number')
	  }

	  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
	    throw new TypeError('Bad key length')
	  }
	};
	return precondition;
}

var defaultEncoding_1;
var hasRequiredDefaultEncoding;

function requireDefaultEncoding () {
	if (hasRequiredDefaultEncoding) return defaultEncoding_1;
	hasRequiredDefaultEncoding = 1;
	var defaultEncoding;
	/* istanbul ignore next */
	if (commonjsGlobal.process && commonjsGlobal.true) {
	  defaultEncoding = 'utf-8';
	} else if (commonjsGlobal.process && commonjsGlobal.process.version) {
	  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10);

	  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary';
	} else {
	  defaultEncoding = 'utf-8';
	}
	defaultEncoding_1 = defaultEncoding;
	return defaultEncoding_1;
}

var toBuffer;
var hasRequiredToBuffer;

function requireToBuffer () {
	if (hasRequiredToBuffer) return toBuffer;
	hasRequiredToBuffer = 1;
	var Buffer = requireSafeBuffer$2().Buffer;

	toBuffer = function (thing, encoding, name) {
	  if (Buffer.isBuffer(thing)) {
	    return thing
	  } else if (typeof thing === 'string') {
	    return Buffer.from(thing, encoding)
	  } else if (ArrayBuffer.isView(thing)) {
	    return Buffer.from(thing.buffer)
	  } else {
	    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
	  }
	};
	return toBuffer;
}

var syncBrowser;
var hasRequiredSyncBrowser;

function requireSyncBrowser () {
	if (hasRequiredSyncBrowser) return syncBrowser;
	hasRequiredSyncBrowser = 1;
	var md5 = requireMd5();
	var RIPEMD160 = requireRipemd160();
	var sha = requireSha_js();
	var Buffer = requireSafeBuffer$2().Buffer;

	var checkParameters = requirePrecondition();
	var defaultEncoding = requireDefaultEncoding();
	var toBuffer = requireToBuffer();

	var ZEROS = Buffer.alloc(128);
	var sizes = {
	  md5: 16,
	  sha1: 20,
	  sha224: 28,
	  sha256: 32,
	  sha384: 48,
	  sha512: 64,
	  rmd160: 20,
	  ripemd160: 20
	};

	function Hmac (alg, key, saltLen) {
	  var hash = getDigest(alg);
	  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64;

	  if (key.length > blocksize) {
	    key = hash(key);
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize);
	  }

	  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
	  var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36;
	    opad[i] = key[i] ^ 0x5C;
	  }

	  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
	  ipad.copy(ipad1, 0, 0, blocksize);
	  this.ipad1 = ipad1;
	  this.ipad2 = ipad;
	  this.opad = opad;
	  this.alg = alg;
	  this.blocksize = blocksize;
	  this.hash = hash;
	  this.size = sizes[alg];
	}

	Hmac.prototype.run = function (data, ipad) {
	  data.copy(ipad, this.blocksize);
	  var h = this.hash(ipad);
	  h.copy(this.opad, this.blocksize);
	  return this.hash(this.opad)
	};

	function getDigest (alg) {
	  function shaFunc (data) {
	    return sha(alg).update(data).digest()
	  }
	  function rmd160Func (data) {
	    return new RIPEMD160().update(data).digest()
	  }

	  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
	  if (alg === 'md5') return md5
	  return shaFunc
	}

	function pbkdf2 (password, salt, iterations, keylen, digest) {
	  checkParameters(iterations, keylen);
	  password = toBuffer(password, defaultEncoding, 'Password');
	  salt = toBuffer(salt, defaultEncoding, 'Salt');

	  digest = digest || 'sha1';

	  var hmac = new Hmac(digest, password, salt.length);

	  var DK = Buffer.allocUnsafe(keylen);
	  var block1 = Buffer.allocUnsafe(salt.length + 4);
	  salt.copy(block1, 0, 0, salt.length);

	  var destPos = 0;
	  var hLen = sizes[digest];
	  var l = Math.ceil(keylen / hLen);

	  for (var i = 1; i <= l; i++) {
	    block1.writeUInt32BE(i, salt.length);

	    var T = hmac.run(block1, hmac.ipad1);
	    var U = T;

	    for (var j = 1; j < iterations; j++) {
	      U = hmac.run(U, hmac.ipad2);
	      for (var k = 0; k < hLen; k++) T[k] ^= U[k];
	    }

	    T.copy(DK, destPos);
	    destPos += hLen;
	  }

	  return DK
	}

	syncBrowser = pbkdf2;
	return syncBrowser;
}

var async;
var hasRequiredAsync;

function requireAsync () {
	if (hasRequiredAsync) return async;
	hasRequiredAsync = 1;
	var Buffer = requireSafeBuffer$2().Buffer;

	var checkParameters = requirePrecondition();
	var defaultEncoding = requireDefaultEncoding();
	var sync = requireSyncBrowser();
	var toBuffer = requireToBuffer();

	var ZERO_BUF;
	var subtle = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle;
	var toBrowser = {
	  sha: 'SHA-1',
	  'sha-1': 'SHA-1',
	  sha1: 'SHA-1',
	  sha256: 'SHA-256',
	  'sha-256': 'SHA-256',
	  sha384: 'SHA-384',
	  'sha-384': 'SHA-384',
	  'sha-512': 'SHA-512',
	  sha512: 'SHA-512'
	};
	var checks = [];
	function checkNative (algo) {
	  if (commonjsGlobal.process && !commonjsGlobal.true) {
	    return Promise.resolve(false)
	  }
	  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
	    return Promise.resolve(false)
	  }
	  if (checks[algo] !== undefined) {
	    return checks[algo]
	  }
	  ZERO_BUF = ZERO_BUF || Buffer.alloc(8);
	  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
	    .then(function () {
	      return true
	    }).catch(function () {
	      return false
	    });
	  checks[algo] = prom;
	  return prom
	}
	var nextTick;
	function getNextTick () {
	  if (nextTick) {
	    return nextTick
	  }
	  if (commonjsGlobal.process && commonjsGlobal.process.nextTick) {
	    nextTick = commonjsGlobal.process.nextTick;
	  } else if (commonjsGlobal.queueMicrotask) {
	    nextTick = commonjsGlobal.queueMicrotask;
	  } else if (commonjsGlobal.setImmediate) {
	    nextTick = commonjsGlobal.setImmediate;
	  } else {
	    nextTick = commonjsGlobal.setTimeout;
	  }
	  return nextTick
	}
	function browserPbkdf2 (password, salt, iterations, length, algo) {
	  return subtle.importKey(
	    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
	  ).then(function (key) {
	    return subtle.deriveBits({
	      name: 'PBKDF2',
	      salt: salt,
	      iterations: iterations,
	      hash: {
	        name: algo
	      }
	    }, key, length << 3)
	  }).then(function (res) {
	    return Buffer.from(res)
	  })
	}

	function resolvePromise (promise, callback) {
	  promise.then(function (out) {
	    getNextTick()(function () {
	      callback(null, out);
	    });
	  }, function (e) {
	    getNextTick()(function () {
	      callback(e);
	    });
	  });
	}
	async = function (password, salt, iterations, keylen, digest, callback) {
	  if (typeof digest === 'function') {
	    callback = digest;
	    digest = undefined;
	  }

	  digest = digest || 'sha1';
	  var algo = toBrowser[digest.toLowerCase()];

	  if (!algo || typeof commonjsGlobal.Promise !== 'function') {
	    getNextTick()(function () {
	      var out;
	      try {
	        out = sync(password, salt, iterations, keylen, digest);
	      } catch (e) {
	        return callback(e)
	      }
	      callback(null, out);
	    });
	    return
	  }

	  checkParameters(iterations, keylen);
	  password = toBuffer(password, defaultEncoding, 'Password');
	  salt = toBuffer(salt, defaultEncoding, 'Salt');
	  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

	  resolvePromise(checkNative(algo).then(function (resp) {
	    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

	    return sync(password, salt, iterations, keylen, digest)
	  }), callback);
	};
	return async;
}

var hasRequiredBrowser$7;

function requireBrowser$7 () {
	if (hasRequiredBrowser$7) return browser$7;
	hasRequiredBrowser$7 = 1;
	browser$7.pbkdf2 = requireAsync();
	browser$7.pbkdf2Sync = requireSyncBrowser();
	return browser$7;
}

var browser$6 = {};

var des$1 = {};

var utils$3 = {};

var hasRequiredUtils$3;

function requireUtils$3 () {
	if (hasRequiredUtils$3) return utils$3;
	hasRequiredUtils$3 = 1;

	utils$3.readUInt32BE = function readUInt32BE(bytes, off) {
	  var res =  (bytes[0 + off] << 24) |
	             (bytes[1 + off] << 16) |
	             (bytes[2 + off] << 8) |
	             bytes[3 + off];
	  return res >>> 0;
	};

	utils$3.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
	  bytes[0 + off] = value >>> 24;
	  bytes[1 + off] = (value >>> 16) & 0xff;
	  bytes[2 + off] = (value >>> 8) & 0xff;
	  bytes[3 + off] = value & 0xff;
	};

	utils$3.ip = function ip(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;

	  for (var i = 6; i >= 0; i -= 2) {
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inR >>> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inL >>> (j + i)) & 1;
	    }
	  }

	  for (var i = 6; i >= 0; i -= 2) {
	    for (var j = 1; j <= 25; j += 8) {
	      outR <<= 1;
	      outR |= (inR >>> (j + i)) & 1;
	    }
	    for (var j = 1; j <= 25; j += 8) {
	      outR <<= 1;
	      outR |= (inL >>> (j + i)) & 1;
	    }
	  }

	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};

	utils$3.rip = function rip(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;

	  for (var i = 0; i < 4; i++) {
	    for (var j = 24; j >= 0; j -= 8) {
	      outL <<= 1;
	      outL |= (inR >>> (j + i)) & 1;
	      outL <<= 1;
	      outL |= (inL >>> (j + i)) & 1;
	    }
	  }
	  for (var i = 4; i < 8; i++) {
	    for (var j = 24; j >= 0; j -= 8) {
	      outR <<= 1;
	      outR |= (inR >>> (j + i)) & 1;
	      outR <<= 1;
	      outR |= (inL >>> (j + i)) & 1;
	    }
	  }

	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};

	utils$3.pc1 = function pc1(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;

	  // 7, 15, 23, 31, 39, 47, 55, 63
	  // 6, 14, 22, 30, 39, 47, 55, 63
	  // 5, 13, 21, 29, 39, 47, 55, 63
	  // 4, 12, 20, 28
	  for (var i = 7; i >= 5; i--) {
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inR >> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inL >> (j + i)) & 1;
	    }
	  }
	  for (var j = 0; j <= 24; j += 8) {
	    outL <<= 1;
	    outL |= (inR >> (j + i)) & 1;
	  }

	  // 1, 9, 17, 25, 33, 41, 49, 57
	  // 2, 10, 18, 26, 34, 42, 50, 58
	  // 3, 11, 19, 27, 35, 43, 51, 59
	  // 36, 44, 52, 60
	  for (var i = 1; i <= 3; i++) {
	    for (var j = 0; j <= 24; j += 8) {
	      outR <<= 1;
	      outR |= (inR >> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outR <<= 1;
	      outR |= (inL >> (j + i)) & 1;
	    }
	  }
	  for (var j = 0; j <= 24; j += 8) {
	    outR <<= 1;
	    outR |= (inL >> (j + i)) & 1;
	  }

	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};

	utils$3.r28shl = function r28shl(num, shift) {
	  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
	};

	var pc2table = [
	  // inL => outL
	  14, 11, 17, 4, 27, 23, 25, 0,
	  13, 22, 7, 18, 5, 9, 16, 24,
	  2, 20, 12, 21, 1, 8, 15, 26,

	  // inR => outR
	  15, 4, 25, 19, 9, 1, 26, 16,
	  5, 11, 23, 8, 12, 7, 17, 0,
	  22, 3, 10, 14, 6, 20, 27, 24
	];

	utils$3.pc2 = function pc2(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;

	  var len = pc2table.length >>> 1;
	  for (var i = 0; i < len; i++) {
	    outL <<= 1;
	    outL |= (inL >>> pc2table[i]) & 0x1;
	  }
	  for (var i = len; i < pc2table.length; i++) {
	    outR <<= 1;
	    outR |= (inR >>> pc2table[i]) & 0x1;
	  }

	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};

	utils$3.expand = function expand(r, out, off) {
	  var outL = 0;
	  var outR = 0;

	  outL = ((r & 1) << 5) | (r >>> 27);
	  for (var i = 23; i >= 15; i -= 4) {
	    outL <<= 6;
	    outL |= (r >>> i) & 0x3f;
	  }
	  for (var i = 11; i >= 3; i -= 4) {
	    outR |= (r >>> i) & 0x3f;
	    outR <<= 6;
	  }
	  outR |= ((r & 0x1f) << 1) | (r >>> 31);

	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};

	var sTable = [
	  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
	  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
	  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
	  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

	  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
	  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
	  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
	  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

	  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
	  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
	  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
	  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

	  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
	  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
	  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
	  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

	  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
	  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
	  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
	  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

	  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
	  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
	  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
	  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

	  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
	  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
	  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
	  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

	  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
	  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
	  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
	  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
	];

	utils$3.substitute = function substitute(inL, inR) {
	  var out = 0;
	  for (var i = 0; i < 4; i++) {
	    var b = (inL >>> (18 - i * 6)) & 0x3f;
	    var sb = sTable[i * 0x40 + b];

	    out <<= 4;
	    out |= sb;
	  }
	  for (var i = 0; i < 4; i++) {
	    var b = (inR >>> (18 - i * 6)) & 0x3f;
	    var sb = sTable[4 * 0x40 + i * 0x40 + b];

	    out <<= 4;
	    out |= sb;
	  }
	  return out >>> 0;
	};

	var permuteTable = [
	  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
	  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
	];

	utils$3.permute = function permute(num) {
	  var out = 0;
	  for (var i = 0; i < permuteTable.length; i++) {
	    out <<= 1;
	    out |= (num >>> permuteTable[i]) & 0x1;
	  }
	  return out >>> 0;
	};

	utils$3.padSplit = function padSplit(num, size, group) {
	  var str = num.toString(2);
	  while (str.length < size)
	    str = '0' + str;

	  var out = [];
	  for (var i = 0; i < size; i += group)
	    out.push(str.slice(i, i + group));
	  return out.join(' ');
	};
	return utils$3;
}

var minimalisticAssert;
var hasRequiredMinimalisticAssert;

function requireMinimalisticAssert () {
	if (hasRequiredMinimalisticAssert) return minimalisticAssert;
	hasRequiredMinimalisticAssert = 1;
	minimalisticAssert = assert;

	function assert(val, msg) {
	  if (!val)
	    throw new Error(msg || 'Assertion failed');
	}

	assert.equal = function assertEqual(l, r, msg) {
	  if (l != r)
	    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
	};
	return minimalisticAssert;
}

var cipher;
var hasRequiredCipher;

function requireCipher () {
	if (hasRequiredCipher) return cipher;
	hasRequiredCipher = 1;

	var assert = requireMinimalisticAssert();

	function Cipher(options) {
	  this.options = options;

	  this.type = this.options.type;
	  this.blockSize = 8;
	  this._init();

	  this.buffer = new Array(this.blockSize);
	  this.bufferOff = 0;
	  this.padding = options.padding !== false;
	}
	cipher = Cipher;

	Cipher.prototype._init = function _init() {
	  // Might be overrided
	};

	Cipher.prototype.update = function update(data) {
	  if (data.length === 0)
	    return [];

	  if (this.type === 'decrypt')
	    return this._updateDecrypt(data);
	  else
	    return this._updateEncrypt(data);
	};

	Cipher.prototype._buffer = function _buffer(data, off) {
	  // Append data to buffer
	  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
	  for (var i = 0; i < min; i++)
	    this.buffer[this.bufferOff + i] = data[off + i];
	  this.bufferOff += min;

	  // Shift next
	  return min;
	};

	Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
	  this._update(this.buffer, 0, out, off);
	  this.bufferOff = 0;
	  return this.blockSize;
	};

	Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
	  var inputOff = 0;
	  var outputOff = 0;

	  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
	  var out = new Array(count * this.blockSize);

	  if (this.bufferOff !== 0) {
	    inputOff += this._buffer(data, inputOff);

	    if (this.bufferOff === this.buffer.length)
	      outputOff += this._flushBuffer(out, outputOff);
	  }

	  // Write blocks
	  var max = data.length - ((data.length - inputOff) % this.blockSize);
	  for (; inputOff < max; inputOff += this.blockSize) {
	    this._update(data, inputOff, out, outputOff);
	    outputOff += this.blockSize;
	  }

	  // Queue rest
	  for (; inputOff < data.length; inputOff++, this.bufferOff++)
	    this.buffer[this.bufferOff] = data[inputOff];

	  return out;
	};

	Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
	  var inputOff = 0;
	  var outputOff = 0;

	  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
	  var out = new Array(count * this.blockSize);

	  // TODO(indutny): optimize it, this is far from optimal
	  for (; count > 0; count--) {
	    inputOff += this._buffer(data, inputOff);
	    outputOff += this._flushBuffer(out, outputOff);
	  }

	  // Buffer rest of the input
	  inputOff += this._buffer(data, inputOff);

	  return out;
	};

	Cipher.prototype.final = function final(buffer) {
	  var first;
	  if (buffer)
	    first = this.update(buffer);

	  var last;
	  if (this.type === 'encrypt')
	    last = this._finalEncrypt();
	  else
	    last = this._finalDecrypt();

	  if (first)
	    return first.concat(last);
	  else
	    return last;
	};

	Cipher.prototype._pad = function _pad(buffer, off) {
	  if (off === 0)
	    return false;

	  while (off < buffer.length)
	    buffer[off++] = 0;

	  return true;
	};

	Cipher.prototype._finalEncrypt = function _finalEncrypt() {
	  if (!this._pad(this.buffer, this.bufferOff))
	    return [];

	  var out = new Array(this.blockSize);
	  this._update(this.buffer, 0, out, 0);
	  return out;
	};

	Cipher.prototype._unpad = function _unpad(buffer) {
	  return buffer;
	};

	Cipher.prototype._finalDecrypt = function _finalDecrypt() {
	  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
	  var out = new Array(this.blockSize);
	  this._flushBuffer(out, 0);

	  return this._unpad(out);
	};
	return cipher;
}

var des;
var hasRequiredDes$1;

function requireDes$1 () {
	if (hasRequiredDes$1) return des;
	hasRequiredDes$1 = 1;

	var assert = requireMinimalisticAssert();
	var inherits = requireInherits_browser();

	var utils = requireUtils$3();
	var Cipher = requireCipher();

	function DESState() {
	  this.tmp = new Array(2);
	  this.keys = null;
	}

	function DES(options) {
	  Cipher.call(this, options);

	  var state = new DESState();
	  this._desState = state;

	  this.deriveKeys(state, options.key);
	}
	inherits(DES, Cipher);
	des = DES;

	DES.create = function create(options) {
	  return new DES(options);
	};

	var shiftTable = [
	  1, 1, 2, 2, 2, 2, 2, 2,
	  1, 2, 2, 2, 2, 2, 2, 1
	];

	DES.prototype.deriveKeys = function deriveKeys(state, key) {
	  state.keys = new Array(16 * 2);

	  assert.equal(key.length, this.blockSize, 'Invalid key length');

	  var kL = utils.readUInt32BE(key, 0);
	  var kR = utils.readUInt32BE(key, 4);

	  utils.pc1(kL, kR, state.tmp, 0);
	  kL = state.tmp[0];
	  kR = state.tmp[1];
	  for (var i = 0; i < state.keys.length; i += 2) {
	    var shift = shiftTable[i >>> 1];
	    kL = utils.r28shl(kL, shift);
	    kR = utils.r28shl(kR, shift);
	    utils.pc2(kL, kR, state.keys, i);
	  }
	};

	DES.prototype._update = function _update(inp, inOff, out, outOff) {
	  var state = this._desState;

	  var l = utils.readUInt32BE(inp, inOff);
	  var r = utils.readUInt32BE(inp, inOff + 4);

	  // Initial Permutation
	  utils.ip(l, r, state.tmp, 0);
	  l = state.tmp[0];
	  r = state.tmp[1];

	  if (this.type === 'encrypt')
	    this._encrypt(state, l, r, state.tmp, 0);
	  else
	    this._decrypt(state, l, r, state.tmp, 0);

	  l = state.tmp[0];
	  r = state.tmp[1];

	  utils.writeUInt32BE(out, l, outOff);
	  utils.writeUInt32BE(out, r, outOff + 4);
	};

	DES.prototype._pad = function _pad(buffer, off) {
	  if (this.padding === false) {
	    return false;
	  }

	  var value = buffer.length - off;
	  for (var i = off; i < buffer.length; i++)
	    buffer[i] = value;

	  return true;
	};

	DES.prototype._unpad = function _unpad(buffer) {
	  if (this.padding === false) {
	    return buffer;
	  }

	  var pad = buffer[buffer.length - 1];
	  for (var i = buffer.length - pad; i < buffer.length; i++)
	    assert.equal(buffer[i], pad);

	  return buffer.slice(0, buffer.length - pad);
	};

	DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
	  var l = lStart;
	  var r = rStart;

	  // Apply f() x16 times
	  for (var i = 0; i < state.keys.length; i += 2) {
	    var keyL = state.keys[i];
	    var keyR = state.keys[i + 1];

	    // f(r, k)
	    utils.expand(r, state.tmp, 0);

	    keyL ^= state.tmp[0];
	    keyR ^= state.tmp[1];
	    var s = utils.substitute(keyL, keyR);
	    var f = utils.permute(s);

	    var t = r;
	    r = (l ^ f) >>> 0;
	    l = t;
	  }

	  // Reverse Initial Permutation
	  utils.rip(r, l, out, off);
	};

	DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
	  var l = rStart;
	  var r = lStart;

	  // Apply f() x16 times
	  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
	    var keyL = state.keys[i];
	    var keyR = state.keys[i + 1];

	    // f(r, k)
	    utils.expand(l, state.tmp, 0);

	    keyL ^= state.tmp[0];
	    keyR ^= state.tmp[1];
	    var s = utils.substitute(keyL, keyR);
	    var f = utils.permute(s);

	    var t = l;
	    l = (r ^ f) >>> 0;
	    r = t;
	  }

	  // Reverse Initial Permutation
	  utils.rip(l, r, out, off);
	};
	return des;
}

var cbc$1 = {};

var hasRequiredCbc$1;

function requireCbc$1 () {
	if (hasRequiredCbc$1) return cbc$1;
	hasRequiredCbc$1 = 1;

	var assert = requireMinimalisticAssert();
	var inherits = requireInherits_browser();

	var proto = {};

	function CBCState(iv) {
	  assert.equal(iv.length, 8, 'Invalid IV length');

	  this.iv = new Array(8);
	  for (var i = 0; i < this.iv.length; i++)
	    this.iv[i] = iv[i];
	}

	function instantiate(Base) {
	  function CBC(options) {
	    Base.call(this, options);
	    this._cbcInit();
	  }
	  inherits(CBC, Base);

	  var keys = Object.keys(proto);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    CBC.prototype[key] = proto[key];
	  }

	  CBC.create = function create(options) {
	    return new CBC(options);
	  };

	  return CBC;
	}

	cbc$1.instantiate = instantiate;

	proto._cbcInit = function _cbcInit() {
	  var state = new CBCState(this.options.iv);
	  this._cbcState = state;
	};

	proto._update = function _update(inp, inOff, out, outOff) {
	  var state = this._cbcState;
	  var superProto = this.constructor.super_.prototype;

	  var iv = state.iv;
	  if (this.type === 'encrypt') {
	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] ^= inp[inOff + i];

	    superProto._update.call(this, iv, 0, out, outOff);

	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] = out[outOff + i];
	  } else {
	    superProto._update.call(this, inp, inOff, out, outOff);

	    for (var i = 0; i < this.blockSize; i++)
	      out[outOff + i] ^= iv[i];

	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] = inp[inOff + i];
	  }
	};
	return cbc$1;
}

var ede;
var hasRequiredEde;

function requireEde () {
	if (hasRequiredEde) return ede;
	hasRequiredEde = 1;

	var assert = requireMinimalisticAssert();
	var inherits = requireInherits_browser();

	var Cipher = requireCipher();
	var DES = requireDes$1();

	function EDEState(type, key) {
	  assert.equal(key.length, 24, 'Invalid key length');

	  var k1 = key.slice(0, 8);
	  var k2 = key.slice(8, 16);
	  var k3 = key.slice(16, 24);

	  if (type === 'encrypt') {
	    this.ciphers = [
	      DES.create({ type: 'encrypt', key: k1 }),
	      DES.create({ type: 'decrypt', key: k2 }),
	      DES.create({ type: 'encrypt', key: k3 })
	    ];
	  } else {
	    this.ciphers = [
	      DES.create({ type: 'decrypt', key: k3 }),
	      DES.create({ type: 'encrypt', key: k2 }),
	      DES.create({ type: 'decrypt', key: k1 })
	    ];
	  }
	}

	function EDE(options) {
	  Cipher.call(this, options);

	  var state = new EDEState(this.type, this.options.key);
	  this._edeState = state;
	}
	inherits(EDE, Cipher);

	ede = EDE;

	EDE.create = function create(options) {
	  return new EDE(options);
	};

	EDE.prototype._update = function _update(inp, inOff, out, outOff) {
	  var state = this._edeState;

	  state.ciphers[0]._update(inp, inOff, out, outOff);
	  state.ciphers[1]._update(out, outOff, out, outOff);
	  state.ciphers[2]._update(out, outOff, out, outOff);
	};

	EDE.prototype._pad = DES.prototype._pad;
	EDE.prototype._unpad = DES.prototype._unpad;
	return ede;
}

var hasRequiredDes;

function requireDes () {
	if (hasRequiredDes) return des$1;
	hasRequiredDes = 1;

	des$1.utils = requireUtils$3();
	des$1.Cipher = requireCipher();
	des$1.DES = requireDes$1();
	des$1.CBC = requireCbc$1();
	des$1.EDE = requireEde();
	return des$1;
}

var browserifyDes;
var hasRequiredBrowserifyDes;

function requireBrowserifyDes () {
	if (hasRequiredBrowserifyDes) return browserifyDes;
	hasRequiredBrowserifyDes = 1;
	var CipherBase = requireCipherBase();
	var des = requireDes();
	var inherits = requireInherits_browser();
	var Buffer = requireSafeBuffer$2().Buffer;

	var modes = {
	  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
	  'des-ede3': des.EDE,
	  'des-ede-cbc': des.CBC.instantiate(des.EDE),
	  'des-ede': des.EDE,
	  'des-cbc': des.CBC.instantiate(des.DES),
	  'des-ecb': des.DES
	};
	modes.des = modes['des-cbc'];
	modes.des3 = modes['des-ede3-cbc'];
	browserifyDes = DES;
	inherits(DES, CipherBase);
	function DES (opts) {
	  CipherBase.call(this);
	  var modeName = opts.mode.toLowerCase();
	  var mode = modes[modeName];
	  var type;
	  if (opts.decrypt) {
	    type = 'decrypt';
	  } else {
	    type = 'encrypt';
	  }
	  var key = opts.key;
	  if (!Buffer.isBuffer(key)) {
	    key = Buffer.from(key);
	  }
	  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
	    key = Buffer.concat([key, key.slice(0, 8)]);
	  }
	  var iv = opts.iv;
	  if (!Buffer.isBuffer(iv)) {
	    iv = Buffer.from(iv);
	  }
	  this._des = mode.create({
	    key: key,
	    iv: iv,
	    type: type
	  });
	}
	DES.prototype._update = function (data) {
	  return Buffer.from(this._des.update(data))
	};
	DES.prototype._final = function () {
	  return Buffer.from(this._des.final())
	};
	return browserifyDes;
}

var browser$5 = {};

var encrypter = {};

var ecb = {};

var hasRequiredEcb;

function requireEcb () {
	if (hasRequiredEcb) return ecb;
	hasRequiredEcb = 1;
	ecb.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block)
	};

	ecb.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block)
	};
	return ecb;
}

var cbc = {};

var bufferXor;
var hasRequiredBufferXor;

function requireBufferXor () {
	if (hasRequiredBufferXor) return bufferXor;
	hasRequiredBufferXor = 1;
	bufferXor = function xor (a, b) {
	  var length = Math.min(a.length, b.length);
	  var buffer = new Buffer(length);

	  for (var i = 0; i < length; ++i) {
	    buffer[i] = a[i] ^ b[i];
	  }

	  return buffer
	};
	return bufferXor;
}

var hasRequiredCbc;

function requireCbc () {
	if (hasRequiredCbc) return cbc;
	hasRequiredCbc = 1;
	var xor = requireBufferXor();

	cbc.encrypt = function (self, block) {
	  var data = xor(block, self._prev);

	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev
	};

	cbc.decrypt = function (self, block) {
	  var pad = self._prev;

	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);

	  return xor(out, pad)
	};
	return cbc;
}

var cfb = {};

var hasRequiredCfb;

function requireCfb () {
	if (hasRequiredCfb) return cfb;
	hasRequiredCfb = 1;
	var Buffer = requireSafeBuffer$2().Buffer;
	var xor = requireBufferXor();

	function encryptStart (self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt ? data : out]);
	  return out
	}

	cfb.encrypt = function (self, data, decrypt) {
	  var out = Buffer.allocUnsafe(0);
	  var len;

	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = Buffer.allocUnsafe(0);
	    }

	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break
	    }
	  }

	  return out
	};
	return cfb;
}

var cfb8 = {};

var hasRequiredCfb8;

function requireCfb8 () {
	if (hasRequiredCfb8) return cfb8;
	hasRequiredCfb8 = 1;
	var Buffer = requireSafeBuffer$2().Buffer;

	function encryptByte (self, byteParam, decrypt) {
	  var pad = self._cipher.encryptBlock(self._prev);
	  var out = pad[0] ^ byteParam;

	  self._prev = Buffer.concat([
	    self._prev.slice(1),
	    Buffer.from([decrypt ? byteParam : out])
	  ]);

	  return out
	}

	cfb8.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length;
	  var out = Buffer.allocUnsafe(len);
	  var i = -1;

	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt);
	  }

	  return out
	};
	return cfb8;
}

var cfb1 = {};

var hasRequiredCfb1;

function requireCfb1 () {
	if (hasRequiredCfb1) return cfb1;
	hasRequiredCfb1 = 1;
	var Buffer = requireSafeBuffer$2().Buffer;

	function encryptByte (self, byteParam, decrypt) {
	  var pad;
	  var i = -1;
	  var len = 8;
	  var out = 0;
	  var bit, value;
	  while (++i < len) {
	    pad = self._cipher.encryptBlock(self._prev);
	    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0;
	    value = pad[0] ^ bit;
	    out += ((value & 0x80) >> (i % 8));
	    self._prev = shiftIn(self._prev, decrypt ? bit : value);
	  }
	  return out
	}

	function shiftIn (buffer, value) {
	  var len = buffer.length;
	  var i = -1;
	  var out = Buffer.allocUnsafe(buffer.length);
	  buffer = Buffer.concat([buffer, Buffer.from([value])]);

	  while (++i < len) {
	    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7);
	  }

	  return out
	}

	cfb1.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length;
	  var out = Buffer.allocUnsafe(len);
	  var i = -1;

	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt);
	  }

	  return out
	};
	return cfb1;
}

var ofb = {};

var hasRequiredOfb;

function requireOfb () {
	if (hasRequiredOfb) return ofb;
	hasRequiredOfb = 1;
	var xor = requireBufferXor();

	function getBlock (self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev
	}

	ofb.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }

	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad)
	};
	return ofb;
}

var ctr = {};

var incr32_1;
var hasRequiredIncr32;

function requireIncr32 () {
	if (hasRequiredIncr32) return incr32_1;
	hasRequiredIncr32 = 1;
	function incr32 (iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break
	    }
	  }
	}
	incr32_1 = incr32;
	return incr32_1;
}

var hasRequiredCtr;

function requireCtr () {
	if (hasRequiredCtr) return ctr;
	hasRequiredCtr = 1;
	var xor = requireBufferXor();
	var Buffer = requireSafeBuffer$2().Buffer;
	var incr32 = requireIncr32();

	function getBlock (self) {
	  var out = self._cipher.encryptBlockRaw(self._prev);
	  incr32(self._prev);
	  return out
	}

	var blockSize = 16;
	ctr.encrypt = function (self, chunk) {
	  var chunkNum = Math.ceil(chunk.length / blockSize);
	  var start = self._cache.length;
	  self._cache = Buffer.concat([
	    self._cache,
	    Buffer.allocUnsafe(chunkNum * blockSize)
	  ]);
	  for (var i = 0; i < chunkNum; i++) {
	    var out = getBlock(self);
	    var offset = start + i * blockSize;
	    self._cache.writeUInt32BE(out[0], offset + 0);
	    self._cache.writeUInt32BE(out[1], offset + 4);
	    self._cache.writeUInt32BE(out[2], offset + 8);
	    self._cache.writeUInt32BE(out[3], offset + 12);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad)
	};
	return ctr;
}

var aes128 = {
	cipher: "AES",
	key: 128,
	iv: 16,
	mode: "CBC",
	type: "block"
};
var aes192 = {
	cipher: "AES",
	key: 192,
	iv: 16,
	mode: "CBC",
	type: "block"
};
var aes256 = {
	cipher: "AES",
	key: 256,
	iv: 16,
	mode: "CBC",
	type: "block"
};
var require$$2 = {
	"aes-128-ecb": {
	cipher: "AES",
	key: 128,
	iv: 0,
	mode: "ECB",
	type: "block"
},
	"aes-192-ecb": {
	cipher: "AES",
	key: 192,
	iv: 0,
	mode: "ECB",
	type: "block"
},
	"aes-256-ecb": {
	cipher: "AES",
	key: 256,
	iv: 0,
	mode: "ECB",
	type: "block"
},
	"aes-128-cbc": {
	cipher: "AES",
	key: 128,
	iv: 16,
	mode: "CBC",
	type: "block"
},
	"aes-192-cbc": {
	cipher: "AES",
	key: 192,
	iv: 16,
	mode: "CBC",
	type: "block"
},
	"aes-256-cbc": {
	cipher: "AES",
	key: 256,
	iv: 16,
	mode: "CBC",
	type: "block"
},
	aes128: aes128,
	aes192: aes192,
	aes256: aes256,
	"aes-128-cfb": {
	cipher: "AES",
	key: 128,
	iv: 16,
	mode: "CFB",
	type: "stream"
},
	"aes-192-cfb": {
	cipher: "AES",
	key: 192,
	iv: 16,
	mode: "CFB",
	type: "stream"
},
	"aes-256-cfb": {
	cipher: "AES",
	key: 256,
	iv: 16,
	mode: "CFB",
	type: "stream"
},
	"aes-128-cfb8": {
	cipher: "AES",
	key: 128,
	iv: 16,
	mode: "CFB8",
	type: "stream"
},
	"aes-192-cfb8": {
	cipher: "AES",
	key: 192,
	iv: 16,
	mode: "CFB8",
	type: "stream"
},
	"aes-256-cfb8": {
	cipher: "AES",
	key: 256,
	iv: 16,
	mode: "CFB8",
	type: "stream"
},
	"aes-128-cfb1": {
	cipher: "AES",
	key: 128,
	iv: 16,
	mode: "CFB1",
	type: "stream"
},
	"aes-192-cfb1": {
	cipher: "AES",
	key: 192,
	iv: 16,
	mode: "CFB1",
	type: "stream"
},
	"aes-256-cfb1": {
	cipher: "AES",
	key: 256,
	iv: 16,
	mode: "CFB1",
	type: "stream"
},
	"aes-128-ofb": {
	cipher: "AES",
	key: 128,
	iv: 16,
	mode: "OFB",
	type: "stream"
},
	"aes-192-ofb": {
	cipher: "AES",
	key: 192,
	iv: 16,
	mode: "OFB",
	type: "stream"
},
	"aes-256-ofb": {
	cipher: "AES",
	key: 256,
	iv: 16,
	mode: "OFB",
	type: "stream"
},
	"aes-128-ctr": {
	cipher: "AES",
	key: 128,
	iv: 16,
	mode: "CTR",
	type: "stream"
},
	"aes-192-ctr": {
	cipher: "AES",
	key: 192,
	iv: 16,
	mode: "CTR",
	type: "stream"
},
	"aes-256-ctr": {
	cipher: "AES",
	key: 256,
	iv: 16,
	mode: "CTR",
	type: "stream"
},
	"aes-128-gcm": {
	cipher: "AES",
	key: 128,
	iv: 12,
	mode: "GCM",
	type: "auth"
},
	"aes-192-gcm": {
	cipher: "AES",
	key: 192,
	iv: 12,
	mode: "GCM",
	type: "auth"
},
	"aes-256-gcm": {
	cipher: "AES",
	key: 256,
	iv: 12,
	mode: "GCM",
	type: "auth"
}
};

var modes_1;
var hasRequiredModes$1;

function requireModes$1 () {
	if (hasRequiredModes$1) return modes_1;
	hasRequiredModes$1 = 1;
	var modeModules = {
	  ECB: requireEcb(),
	  CBC: requireCbc(),
	  CFB: requireCfb(),
	  CFB8: requireCfb8(),
	  CFB1: requireCfb1(),
	  OFB: requireOfb(),
	  CTR: requireCtr(),
	  GCM: requireCtr()
	};

	var modes = require$$2;

	for (var key in modes) {
	  modes[key].module = modeModules[modes[key].mode];
	}

	modes_1 = modes;
	return modes_1;
}

var aes = {};

var hasRequiredAes;

function requireAes () {
	if (hasRequiredAes) return aes;
	hasRequiredAes = 1;
	// based on the aes implimentation in triple sec
	// https://github.com/keybase/triplesec
	// which is in turn based on the one from crypto-js
	// https://code.google.com/p/crypto-js/

	var Buffer = requireSafeBuffer$2().Buffer;

	function asUInt32Array (buf) {
	  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);

	  var len = (buf.length / 4) | 0;
	  var out = new Array(len);

	  for (var i = 0; i < len; i++) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }

	  return out
	}

	function scrubVec (v) {
	  for (var i = 0; i < v.length; v++) {
	    v[i] = 0;
	  }
	}

	function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
	  var SUB_MIX0 = SUB_MIX[0];
	  var SUB_MIX1 = SUB_MIX[1];
	  var SUB_MIX2 = SUB_MIX[2];
	  var SUB_MIX3 = SUB_MIX[3];

	  var s0 = M[0] ^ keySchedule[0];
	  var s1 = M[1] ^ keySchedule[1];
	  var s2 = M[2] ^ keySchedule[2];
	  var s3 = M[3] ^ keySchedule[3];
	  var t0, t1, t2, t3;
	  var ksRow = 4;

	  for (var round = 1; round < nRounds; round++) {
	    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }

	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  t0 = t0 >>> 0;
	  t1 = t1 >>> 0;
	  t2 = t2 >>> 0;
	  t3 = t3 >>> 0;

	  return [t0, t1, t2, t3]
	}

	// AES constants
	var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	var G = (function () {
	  // Compute double table
	  var d = new Array(256);
	  for (var j = 0; j < 256; j++) {
	    if (j < 128) {
	      d[j] = j << 1;
	    } else {
	      d[j] = (j << 1) ^ 0x11b;
	    }
	  }

	  var SBOX = [];
	  var INV_SBOX = [];
	  var SUB_MIX = [[], [], [], []];
	  var INV_SUB_MIX = [[], [], [], []];

	  // Walk GF(2^8)
	  var x = 0;
	  var xi = 0;
	  for (var i = 0; i < 256; ++i) {
	    // Compute sbox
	    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    SBOX[x] = sx;
	    INV_SBOX[sx] = x;

	    // Compute multiplication
	    var x2 = d[x];
	    var x4 = d[x2];
	    var x8 = d[x4];

	    // Compute sub bytes, mix columns tables
	    var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    SUB_MIX[3][x] = t;

	    // Compute inv sub bytes, inv mix columns tables
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    INV_SUB_MIX[3][sx] = t;

	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }

	  return {
	    SBOX: SBOX,
	    INV_SBOX: INV_SBOX,
	    SUB_MIX: SUB_MIX,
	    INV_SUB_MIX: INV_SUB_MIX
	  }
	})();

	function AES (key) {
	  this._key = asUInt32Array(key);
	  this._reset();
	}

	AES.blockSize = 4 * 4;
	AES.keySize = 256 / 8;
	AES.prototype.blockSize = AES.blockSize;
	AES.prototype.keySize = AES.keySize;
	AES.prototype._reset = function () {
	  var keyWords = this._key;
	  var keySize = keyWords.length;
	  var nRounds = keySize + 6;
	  var ksRows = (nRounds + 1) * 4;

	  var keySchedule = [];
	  for (var k = 0; k < keySize; k++) {
	    keySchedule[k] = keyWords[k];
	  }

	  for (k = keySize; k < ksRows; k++) {
	    var t = keySchedule[k - 1];

	    if (k % keySize === 0) {
	      t = (t << 8) | (t >>> 24);
	      t =
	        (G.SBOX[t >>> 24] << 24) |
	        (G.SBOX[(t >>> 16) & 0xff] << 16) |
	        (G.SBOX[(t >>> 8) & 0xff] << 8) |
	        (G.SBOX[t & 0xff]);

	      t ^= RCON[(k / keySize) | 0] << 24;
	    } else if (keySize > 6 && k % keySize === 4) {
	      t =
	        (G.SBOX[t >>> 24] << 24) |
	        (G.SBOX[(t >>> 16) & 0xff] << 16) |
	        (G.SBOX[(t >>> 8) & 0xff] << 8) |
	        (G.SBOX[t & 0xff]);
	    }

	    keySchedule[k] = keySchedule[k - keySize] ^ t;
	  }

	  var invKeySchedule = [];
	  for (var ik = 0; ik < ksRows; ik++) {
	    var ksR = ksRows - ik;
	    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];

	    if (ik < 4 || ksR <= 4) {
	      invKeySchedule[ik] = tt;
	    } else {
	      invKeySchedule[ik] =
	        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
	        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
	        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
	        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]];
	    }
	  }

	  this._nRounds = nRounds;
	  this._keySchedule = keySchedule;
	  this._invKeySchedule = invKeySchedule;
	};

	AES.prototype.encryptBlockRaw = function (M) {
	  M = asUInt32Array(M);
	  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
	};

	AES.prototype.encryptBlock = function (M) {
	  var out = this.encryptBlockRaw(M);
	  var buf = Buffer.allocUnsafe(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf
	};

	AES.prototype.decryptBlock = function (M) {
	  M = asUInt32Array(M);

	  // swap
	  var m1 = M[1];
	  M[1] = M[3];
	  M[3] = m1;

	  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds);
	  var buf = Buffer.allocUnsafe(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf
	};

	AES.prototype.scrub = function () {
	  scrubVec(this._keySchedule);
	  scrubVec(this._invKeySchedule);
	  scrubVec(this._key);
	};

	aes.AES = AES;
	return aes;
}

var ghash;
var hasRequiredGhash;

function requireGhash () {
	if (hasRequiredGhash) return ghash;
	hasRequiredGhash = 1;
	var Buffer = requireSafeBuffer$2().Buffer;
	var ZEROES = Buffer.alloc(16, 0);

	function toArray (buf) {
	  return [
	    buf.readUInt32BE(0),
	    buf.readUInt32BE(4),
	    buf.readUInt32BE(8),
	    buf.readUInt32BE(12)
	  ]
	}

	function fromArray (out) {
	  var buf = Buffer.allocUnsafe(16);
	  buf.writeUInt32BE(out[0] >>> 0, 0);
	  buf.writeUInt32BE(out[1] >>> 0, 4);
	  buf.writeUInt32BE(out[2] >>> 0, 8);
	  buf.writeUInt32BE(out[3] >>> 0, 12);
	  return buf
	}

	function GHASH (key) {
	  this.h = key;
	  this.state = Buffer.alloc(16, 0);
	  this.cache = Buffer.allocUnsafe(0);
	}

	// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
	// by Juho Vähä-Herttua
	GHASH.prototype.ghash = function (block) {
	  var i = -1;
	  while (++i < block.length) {
	    this.state[i] ^= block[i];
	  }
	  this._multiply();
	};

	GHASH.prototype._multiply = function () {
	  var Vi = toArray(this.h);
	  var Zi = [0, 0, 0, 0];
	  var j, xi, lsbVi;
	  var i = -1;
	  while (++i < 128) {
	    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0;
	    if (xi) {
	      // Z_i+1 = Z_i ^ V_i
	      Zi[0] ^= Vi[0];
	      Zi[1] ^= Vi[1];
	      Zi[2] ^= Vi[2];
	      Zi[3] ^= Vi[3];
	    }

	    // Store the value of LSB(V_i)
	    lsbVi = (Vi[3] & 1) !== 0;

	    // V_i+1 = V_i >> 1
	    for (j = 3; j > 0; j--) {
	      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31);
	    }
	    Vi[0] = Vi[0] >>> 1;

	    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
	    if (lsbVi) {
	      Vi[0] = Vi[0] ^ (0xe1 << 24);
	    }
	  }
	  this.state = fromArray(Zi);
	};

	GHASH.prototype.update = function (buf) {
	  this.cache = Buffer.concat([this.cache, buf]);
	  var chunk;
	  while (this.cache.length >= 16) {
	    chunk = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    this.ghash(chunk);
	  }
	};

	GHASH.prototype.final = function (abl, bl) {
	  if (this.cache.length) {
	    this.ghash(Buffer.concat([this.cache, ZEROES], 16));
	  }

	  this.ghash(fromArray([0, abl, 0, bl]));
	  return this.state
	};

	ghash = GHASH;
	return ghash;
}

var authCipher;
var hasRequiredAuthCipher;

function requireAuthCipher () {
	if (hasRequiredAuthCipher) return authCipher;
	hasRequiredAuthCipher = 1;
	var aes = requireAes();
	var Buffer = requireSafeBuffer$2().Buffer;
	var Transform = requireCipherBase();
	var inherits = requireInherits_browser();
	var GHASH = requireGhash();
	var xor = requireBufferXor();
	var incr32 = requireIncr32();

	function xorTest (a, b) {
	  var out = 0;
	  if (a.length !== b.length) out++;

	  var len = Math.min(a.length, b.length);
	  for (var i = 0; i < len; ++i) {
	    out += (a[i] ^ b[i]);
	  }

	  return out
	}

	function calcIv (self, iv, ck) {
	  if (iv.length === 12) {
	    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])]);
	    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
	  }
	  var ghash = new GHASH(ck);
	  var len = iv.length;
	  var toPad = len % 16;
	  ghash.update(iv);
	  if (toPad) {
	    toPad = 16 - toPad;
	    ghash.update(Buffer.alloc(toPad, 0));
	  }
	  ghash.update(Buffer.alloc(8, 0));
	  var ivBits = len * 8;
	  var tail = Buffer.alloc(8);
	  tail.writeUIntBE(ivBits, 0, 8);
	  ghash.update(tail);
	  self._finID = ghash.state;
	  var out = Buffer.from(self._finID);
	  incr32(out);
	  return out
	}
	function StreamCipher (mode, key, iv, decrypt) {
	  Transform.call(this);

	  var h = Buffer.alloc(4, 0);

	  this._cipher = new aes.AES(key);
	  var ck = this._cipher.encryptBlock(h);
	  this._ghash = new GHASH(ck);
	  iv = calcIv(this, iv, ck);

	  this._prev = Buffer.from(iv);
	  this._cache = Buffer.allocUnsafe(0);
	  this._secCache = Buffer.allocUnsafe(0);
	  this._decrypt = decrypt;
	  this._alen = 0;
	  this._len = 0;
	  this._mode = mode;

	  this._authTag = null;
	  this._called = false;
	}

	inherits(StreamCipher, Transform);

	StreamCipher.prototype._update = function (chunk) {
	  if (!this._called && this._alen) {
	    var rump = 16 - (this._alen % 16);
	    if (rump < 16) {
	      rump = Buffer.alloc(rump, 0);
	      this._ghash.update(rump);
	    }
	  }

	  this._called = true;
	  var out = this._mode.encrypt(this, chunk);
	  if (this._decrypt) {
	    this._ghash.update(chunk);
	  } else {
	    this._ghash.update(out);
	  }
	  this._len += chunk.length;
	  return out
	};

	StreamCipher.prototype._final = function () {
	  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

	  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
	  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

	  this._authTag = tag;
	  this._cipher.scrub();
	};

	StreamCipher.prototype.getAuthTag = function getAuthTag () {
	  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

	  return this._authTag
	};

	StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
	  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

	  this._authTag = tag;
	};

	StreamCipher.prototype.setAAD = function setAAD (buf) {
	  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

	  this._ghash.update(buf);
	  this._alen += buf.length;
	};

	authCipher = StreamCipher;
	return authCipher;
}

var streamCipher;
var hasRequiredStreamCipher;

function requireStreamCipher () {
	if (hasRequiredStreamCipher) return streamCipher;
	hasRequiredStreamCipher = 1;
	var aes = requireAes();
	var Buffer = requireSafeBuffer$2().Buffer;
	var Transform = requireCipherBase();
	var inherits = requireInherits_browser();

	function StreamCipher (mode, key, iv, decrypt) {
	  Transform.call(this);

	  this._cipher = new aes.AES(key);
	  this._prev = Buffer.from(iv);
	  this._cache = Buffer.allocUnsafe(0);
	  this._secCache = Buffer.allocUnsafe(0);
	  this._decrypt = decrypt;
	  this._mode = mode;
	}

	inherits(StreamCipher, Transform);

	StreamCipher.prototype._update = function (chunk) {
	  return this._mode.encrypt(this, chunk, this._decrypt)
	};

	StreamCipher.prototype._final = function () {
	  this._cipher.scrub();
	};

	streamCipher = StreamCipher;
	return streamCipher;
}

var evp_bytestokey;
var hasRequiredEvp_bytestokey;

function requireEvp_bytestokey () {
	if (hasRequiredEvp_bytestokey) return evp_bytestokey;
	hasRequiredEvp_bytestokey = 1;
	var Buffer = requireSafeBuffer$2().Buffer;
	var MD5 = requireMd5_js();

	/* eslint-disable camelcase */
	function EVP_BytesToKey (password, salt, keyBits, ivLen) {
	  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary');
	  if (salt) {
	    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary');
	    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
	  }

	  var keyLen = keyBits / 8;
	  var key = Buffer.alloc(keyLen);
	  var iv = Buffer.alloc(ivLen || 0);
	  var tmp = Buffer.alloc(0);

	  while (keyLen > 0 || ivLen > 0) {
	    var hash = new MD5();
	    hash.update(tmp);
	    hash.update(password);
	    if (salt) hash.update(salt);
	    tmp = hash.digest();

	    var used = 0;

	    if (keyLen > 0) {
	      var keyStart = key.length - keyLen;
	      used = Math.min(keyLen, tmp.length);
	      tmp.copy(key, keyStart, 0, used);
	      keyLen -= used;
	    }

	    if (used < tmp.length && ivLen > 0) {
	      var ivStart = iv.length - ivLen;
	      var length = Math.min(ivLen, tmp.length - used);
	      tmp.copy(iv, ivStart, used, used + length);
	      ivLen -= length;
	    }
	  }

	  tmp.fill(0);
	  return { key: key, iv: iv }
	}

	evp_bytestokey = EVP_BytesToKey;
	return evp_bytestokey;
}

var hasRequiredEncrypter;

function requireEncrypter () {
	if (hasRequiredEncrypter) return encrypter;
	hasRequiredEncrypter = 1;
	var MODES = requireModes$1();
	var AuthCipher = requireAuthCipher();
	var Buffer = requireSafeBuffer$2().Buffer;
	var StreamCipher = requireStreamCipher();
	var Transform = requireCipherBase();
	var aes = requireAes();
	var ebtk = requireEvp_bytestokey();
	var inherits = requireInherits_browser();

	function Cipher (mode, key, iv) {
	  Transform.call(this);

	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = Buffer.from(iv);
	  this._mode = mode;
	  this._autopadding = true;
	}

	inherits(Cipher, Transform);

	Cipher.prototype._update = function (data) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  var out = [];

	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    out.push(thing);
	  }

	  return Buffer.concat(out)
	};

	var PADDING = Buffer.alloc(16, 0x10);

	Cipher.prototype._final = function () {
	  var chunk = this._cache.flush();
	  if (this._autopadding) {
	    chunk = this._mode.encrypt(this, chunk);
	    this._cipher.scrub();
	    return chunk
	  }

	  if (!chunk.equals(PADDING)) {
	    this._cipher.scrub();
	    throw new Error('data not multiple of block length')
	  }
	};

	Cipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo;
	  return this
	};

	function Splitter () {
	  this.cache = Buffer.allocUnsafe(0);
	}

	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};

	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out
	  }
	  return null
	};

	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = Buffer.allocUnsafe(len);

	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }

	  return Buffer.concat([this.cache, padBuff])
	};

	function createCipheriv (suite, password, iv) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type')

	  if (typeof password === 'string') password = Buffer.from(password);
	  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

	  if (typeof iv === 'string') iv = Buffer.from(iv);
	  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

	  if (config.type === 'stream') {
	    return new StreamCipher(config.module, password, iv)
	  } else if (config.type === 'auth') {
	    return new AuthCipher(config.module, password, iv)
	  }

	  return new Cipher(config.module, password, iv)
	}

	function createCipher (suite, password) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type')

	  var keys = ebtk(password, false, config.key, config.iv);
	  return createCipheriv(suite, keys.key, keys.iv)
	}

	encrypter.createCipheriv = createCipheriv;
	encrypter.createCipher = createCipher;
	return encrypter;
}

var decrypter = {};

var hasRequiredDecrypter;

function requireDecrypter () {
	if (hasRequiredDecrypter) return decrypter;
	hasRequiredDecrypter = 1;
	var AuthCipher = requireAuthCipher();
	var Buffer = requireSafeBuffer$2().Buffer;
	var MODES = requireModes$1();
	var StreamCipher = requireStreamCipher();
	var Transform = requireCipherBase();
	var aes = requireAes();
	var ebtk = requireEvp_bytestokey();
	var inherits = requireInherits_browser();

	function Decipher (mode, key, iv) {
	  Transform.call(this);

	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = Buffer.from(iv);
	  this._mode = mode;
	  this._autopadding = true;
	}

	inherits(Decipher, Transform);

	Decipher.prototype._update = function (data) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  var out = [];
	  while ((chunk = this._cache.get(this._autopadding))) {
	    thing = this._mode.decrypt(this, chunk);
	    out.push(thing);
	  }
	  return Buffer.concat(out)
	};

	Decipher.prototype._final = function () {
	  var chunk = this._cache.flush();
	  if (this._autopadding) {
	    return unpad(this._mode.decrypt(this, chunk))
	  } else if (chunk) {
	    throw new Error('data not multiple of block length')
	  }
	};

	Decipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo;
	  return this
	};

	function Splitter () {
	  this.cache = Buffer.allocUnsafe(0);
	}

	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};

	Splitter.prototype.get = function (autoPadding) {
	  var out;
	  if (autoPadding) {
	    if (this.cache.length > 16) {
	      out = this.cache.slice(0, 16);
	      this.cache = this.cache.slice(16);
	      return out
	    }
	  } else {
	    if (this.cache.length >= 16) {
	      out = this.cache.slice(0, 16);
	      this.cache = this.cache.slice(16);
	      return out
	    }
	  }

	  return null
	};

	Splitter.prototype.flush = function () {
	  if (this.cache.length) return this.cache
	};

	function unpad (last) {
	  var padded = last[15];
	  if (padded < 1 || padded > 16) {
	    throw new Error('unable to decrypt data')
	  }
	  var i = -1;
	  while (++i < padded) {
	    if (last[(i + (16 - padded))] !== padded) {
	      throw new Error('unable to decrypt data')
	    }
	  }
	  if (padded === 16) return

	  return last.slice(0, 16 - padded)
	}

	function createDecipheriv (suite, password, iv) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type')

	  if (typeof iv === 'string') iv = Buffer.from(iv);
	  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

	  if (typeof password === 'string') password = Buffer.from(password);
	  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

	  if (config.type === 'stream') {
	    return new StreamCipher(config.module, password, iv, true)
	  } else if (config.type === 'auth') {
	    return new AuthCipher(config.module, password, iv, true)
	  }

	  return new Decipher(config.module, password, iv)
	}

	function createDecipher (suite, password) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type')

	  var keys = ebtk(password, false, config.key, config.iv);
	  return createDecipheriv(suite, keys.key, keys.iv)
	}

	decrypter.createDecipher = createDecipher;
	decrypter.createDecipheriv = createDecipheriv;
	return decrypter;
}

var hasRequiredBrowser$6;

function requireBrowser$6 () {
	if (hasRequiredBrowser$6) return browser$5;
	hasRequiredBrowser$6 = 1;
	var ciphers = requireEncrypter();
	var deciphers = requireDecrypter();
	var modes = require$$2;

	function getCiphers () {
	  return Object.keys(modes)
	}

	browser$5.createCipher = browser$5.Cipher = ciphers.createCipher;
	browser$5.createCipheriv = browser$5.Cipheriv = ciphers.createCipheriv;
	browser$5.createDecipher = browser$5.Decipher = deciphers.createDecipher;
	browser$5.createDecipheriv = browser$5.Decipheriv = deciphers.createDecipheriv;
	browser$5.listCiphers = browser$5.getCiphers = getCiphers;
	return browser$5;
}

var modes = {};

var hasRequiredModes;

function requireModes () {
	if (hasRequiredModes) return modes;
	hasRequiredModes = 1;
	(function (exports) {
		exports['des-ecb'] = {
		  key: 8,
		  iv: 0
		};
		exports['des-cbc'] = exports.des = {
		  key: 8,
		  iv: 8
		};
		exports['des-ede3-cbc'] = exports.des3 = {
		  key: 24,
		  iv: 8
		};
		exports['des-ede3'] = {
		  key: 24,
		  iv: 0
		};
		exports['des-ede-cbc'] = {
		  key: 16,
		  iv: 8
		};
		exports['des-ede'] = {
		  key: 16,
		  iv: 0
		}; 
	} (modes));
	return modes;
}

var hasRequiredBrowser$5;

function requireBrowser$5 () {
	if (hasRequiredBrowser$5) return browser$6;
	hasRequiredBrowser$5 = 1;
	var DES = requireBrowserifyDes();
	var aes = requireBrowser$6();
	var aesModes = requireModes$1();
	var desModes = requireModes();
	var ebtk = requireEvp_bytestokey();

	function createCipher (suite, password) {
	  suite = suite.toLowerCase();

	  var keyLen, ivLen;
	  if (aesModes[suite]) {
	    keyLen = aesModes[suite].key;
	    ivLen = aesModes[suite].iv;
	  } else if (desModes[suite]) {
	    keyLen = desModes[suite].key * 8;
	    ivLen = desModes[suite].iv;
	  } else {
	    throw new TypeError('invalid suite type')
	  }

	  var keys = ebtk(password, false, keyLen, ivLen);
	  return createCipheriv(suite, keys.key, keys.iv)
	}

	function createDecipher (suite, password) {
	  suite = suite.toLowerCase();

	  var keyLen, ivLen;
	  if (aesModes[suite]) {
	    keyLen = aesModes[suite].key;
	    ivLen = aesModes[suite].iv;
	  } else if (desModes[suite]) {
	    keyLen = desModes[suite].key * 8;
	    ivLen = desModes[suite].iv;
	  } else {
	    throw new TypeError('invalid suite type')
	  }

	  var keys = ebtk(password, false, keyLen, ivLen);
	  return createDecipheriv(suite, keys.key, keys.iv)
	}

	function createCipheriv (suite, key, iv) {
	  suite = suite.toLowerCase();
	  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
	  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

	  throw new TypeError('invalid suite type')
	}

	function createDecipheriv (suite, key, iv) {
	  suite = suite.toLowerCase();
	  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
	  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

	  throw new TypeError('invalid suite type')
	}

	function getCiphers () {
	  return Object.keys(desModes).concat(aes.getCiphers())
	}

	browser$6.createCipher = browser$6.Cipher = createCipher;
	browser$6.createCipheriv = browser$6.Cipheriv = createCipheriv;
	browser$6.createDecipher = browser$6.Decipher = createDecipher;
	browser$6.createDecipheriv = browser$6.Decipheriv = createDecipheriv;
	browser$6.listCiphers = browser$6.getCiphers = getCiphers;
	return browser$6;
}

var browser$4 = {};

var bn$5 = {exports: {}};

var bn$4 = bn$5.exports;

var hasRequiredBn$2;

function requireBn$2 () {
	if (hasRequiredBn$2) return bn$5.exports;
	hasRequiredBn$2 = 1;
	(function (module) {
		(function (module, exports) {

		  // Utils
		  function assert (val, msg) {
		    if (!val) throw new Error(msg || 'Assertion failed');
		  }

		  // Could use `inherits` module, but don't want to move from single file
		  // architecture yet.
		  function inherits (ctor, superCtor) {
		    ctor.super_ = superCtor;
		    var TempCtor = function () {};
		    TempCtor.prototype = superCtor.prototype;
		    ctor.prototype = new TempCtor();
		    ctor.prototype.constructor = ctor;
		  }

		  // BN

		  function BN (number, base, endian) {
		    if (BN.isBN(number)) {
		      return number;
		    }

		    this.negative = 0;
		    this.words = null;
		    this.length = 0;

		    // Reduction context
		    this.red = null;

		    if (number !== null) {
		      if (base === 'le' || base === 'be') {
		        endian = base;
		        base = 10;
		      }

		      this._init(number || 0, base || 10, endian || 'be');
		    }
		  }
		  if (typeof module === 'object') {
		    module.exports = BN;
		  } else {
		    exports.BN = BN;
		  }

		  BN.BN = BN;
		  BN.wordSize = 26;

		  var Buffer;
		  try {
		    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
		      Buffer = window.Buffer;
		    } else {
		      Buffer = require$$0$1.Buffer;
		    }
		  } catch (e) {
		  }

		  BN.isBN = function isBN (num) {
		    if (num instanceof BN) {
		      return true;
		    }

		    return num !== null && typeof num === 'object' &&
		      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
		  };

		  BN.max = function max (left, right) {
		    if (left.cmp(right) > 0) return left;
		    return right;
		  };

		  BN.min = function min (left, right) {
		    if (left.cmp(right) < 0) return left;
		    return right;
		  };

		  BN.prototype._init = function init (number, base, endian) {
		    if (typeof number === 'number') {
		      return this._initNumber(number, base, endian);
		    }

		    if (typeof number === 'object') {
		      return this._initArray(number, base, endian);
		    }

		    if (base === 'hex') {
		      base = 16;
		    }
		    assert(base === (base | 0) && base >= 2 && base <= 36);

		    number = number.toString().replace(/\s+/g, '');
		    var start = 0;
		    if (number[0] === '-') {
		      start++;
		      this.negative = 1;
		    }

		    if (start < number.length) {
		      if (base === 16) {
		        this._parseHex(number, start, endian);
		      } else {
		        this._parseBase(number, base, start);
		        if (endian === 'le') {
		          this._initArray(this.toArray(), base, endian);
		        }
		      }
		    }
		  };

		  BN.prototype._initNumber = function _initNumber (number, base, endian) {
		    if (number < 0) {
		      this.negative = 1;
		      number = -number;
		    }
		    if (number < 0x4000000) {
		      this.words = [ number & 0x3ffffff ];
		      this.length = 1;
		    } else if (number < 0x10000000000000) {
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff
		      ];
		      this.length = 2;
		    } else {
		      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff,
		        1
		      ];
		      this.length = 3;
		    }

		    if (endian !== 'le') return;

		    // Reverse the bytes
		    this._initArray(this.toArray(), base, endian);
		  };

		  BN.prototype._initArray = function _initArray (number, base, endian) {
		    // Perhaps a Uint8Array
		    assert(typeof number.length === 'number');
		    if (number.length <= 0) {
		      this.words = [ 0 ];
		      this.length = 1;
		      return this;
		    }

		    this.length = Math.ceil(number.length / 3);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    var j, w;
		    var off = 0;
		    if (endian === 'be') {
		      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
		        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    } else if (endian === 'le') {
		      for (i = 0, j = 0; i < number.length; i += 3) {
		        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    }
		    return this.strip();
		  };

		  function parseHex4Bits (string, index) {
		    var c = string.charCodeAt(index);
		    // 'A' - 'F'
		    if (c >= 65 && c <= 70) {
		      return c - 55;
		    // 'a' - 'f'
		    } else if (c >= 97 && c <= 102) {
		      return c - 87;
		    // '0' - '9'
		    } else {
		      return (c - 48) & 0xf;
		    }
		  }

		  function parseHexByte (string, lowerBound, index) {
		    var r = parseHex4Bits(string, index);
		    if (index - 1 >= lowerBound) {
		      r |= parseHex4Bits(string, index - 1) << 4;
		    }
		    return r;
		  }

		  BN.prototype._parseHex = function _parseHex (number, start, endian) {
		    // Create possibly bigger array to ensure that it fits the number
		    this.length = Math.ceil((number.length - start) / 6);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    // 24-bits chunks
		    var off = 0;
		    var j = 0;

		    var w;
		    if (endian === 'be') {
		      for (i = number.length - 1; i >= start; i -= 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    } else {
		      var parseLength = number.length - start;
		      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    }

		    this.strip();
		  };

		  function parseBase (str, start, end, mul) {
		    var r = 0;
		    var len = Math.min(str.length, end);
		    for (var i = start; i < len; i++) {
		      var c = str.charCodeAt(i) - 48;

		      r *= mul;

		      // 'a'
		      if (c >= 49) {
		        r += c - 49 + 0xa;

		      // 'A'
		      } else if (c >= 17) {
		        r += c - 17 + 0xa;

		      // '0' - '9'
		      } else {
		        r += c;
		      }
		    }
		    return r;
		  }

		  BN.prototype._parseBase = function _parseBase (number, base, start) {
		    // Initialize as zero
		    this.words = [ 0 ];
		    this.length = 1;

		    // Find length of limb in base
		    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
		      limbLen++;
		    }
		    limbLen--;
		    limbPow = (limbPow / base) | 0;

		    var total = number.length - start;
		    var mod = total % limbLen;
		    var end = Math.min(total, total - mod) + start;

		    var word = 0;
		    for (var i = start; i < end; i += limbLen) {
		      word = parseBase(number, i, i + limbLen, base);

		      this.imuln(limbPow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    if (mod !== 0) {
		      var pow = 1;
		      word = parseBase(number, i, number.length, base);

		      for (i = 0; i < mod; i++) {
		        pow *= base;
		      }

		      this.imuln(pow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    this.strip();
		  };

		  BN.prototype.copy = function copy (dest) {
		    dest.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      dest.words[i] = this.words[i];
		    }
		    dest.length = this.length;
		    dest.negative = this.negative;
		    dest.red = this.red;
		  };

		  BN.prototype.clone = function clone () {
		    var r = new BN(null);
		    this.copy(r);
		    return r;
		  };

		  BN.prototype._expand = function _expand (size) {
		    while (this.length < size) {
		      this.words[this.length++] = 0;
		    }
		    return this;
		  };

		  // Remove leading `0` from `this`
		  BN.prototype.strip = function strip () {
		    while (this.length > 1 && this.words[this.length - 1] === 0) {
		      this.length--;
		    }
		    return this._normSign();
		  };

		  BN.prototype._normSign = function _normSign () {
		    // -0 = 0
		    if (this.length === 1 && this.words[0] === 0) {
		      this.negative = 0;
		    }
		    return this;
		  };

		  BN.prototype.inspect = function inspect () {
		    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
		  };

		  /*

		  var zeros = [];
		  var groupSizes = [];
		  var groupBases = [];

		  var s = '';
		  var i = -1;
		  while (++i < BN.wordSize) {
		    zeros[i] = s;
		    s += '0';
		  }
		  groupSizes[0] = 0;
		  groupSizes[1] = 0;
		  groupBases[0] = 0;
		  groupBases[1] = 0;
		  var base = 2 - 1;
		  while (++base < 36 + 1) {
		    var groupSize = 0;
		    var groupBase = 1;
		    while (groupBase < (1 << BN.wordSize) / base) {
		      groupBase *= base;
		      groupSize += 1;
		    }
		    groupSizes[base] = groupSize;
		    groupBases[base] = groupBase;
		  }

		  */

		  var zeros = [
		    '',
		    '0',
		    '00',
		    '000',
		    '0000',
		    '00000',
		    '000000',
		    '0000000',
		    '00000000',
		    '000000000',
		    '0000000000',
		    '00000000000',
		    '000000000000',
		    '0000000000000',
		    '00000000000000',
		    '000000000000000',
		    '0000000000000000',
		    '00000000000000000',
		    '000000000000000000',
		    '0000000000000000000',
		    '00000000000000000000',
		    '000000000000000000000',
		    '0000000000000000000000',
		    '00000000000000000000000',
		    '000000000000000000000000',
		    '0000000000000000000000000'
		  ];

		  var groupSizes = [
		    0, 0,
		    25, 16, 12, 11, 10, 9, 8,
		    8, 7, 7, 7, 7, 6, 6,
		    6, 6, 6, 6, 6, 5, 5,
		    5, 5, 5, 5, 5, 5, 5,
		    5, 5, 5, 5, 5, 5, 5
		  ];

		  var groupBases = [
		    0, 0,
		    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
		    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
		    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
		    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
		    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
		  ];

		  BN.prototype.toString = function toString (base, padding) {
		    base = base || 10;
		    padding = padding | 0 || 1;

		    var out;
		    if (base === 16 || base === 'hex') {
		      out = '';
		      var off = 0;
		      var carry = 0;
		      for (var i = 0; i < this.length; i++) {
		        var w = this.words[i];
		        var word = (((w << off) | carry) & 0xffffff).toString(16);
		        carry = (w >>> (24 - off)) & 0xffffff;
		        off += 2;
		        if (off >= 26) {
		          off -= 26;
		          i--;
		        }
		        if (carry !== 0 || i !== this.length - 1) {
		          out = zeros[6 - word.length] + word + out;
		        } else {
		          out = word + out;
		        }
		      }
		      if (carry !== 0) {
		        out = carry.toString(16) + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    if (base === (base | 0) && base >= 2 && base <= 36) {
		      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
		      var groupSize = groupSizes[base];
		      // var groupBase = Math.pow(base, groupSize);
		      var groupBase = groupBases[base];
		      out = '';
		      var c = this.clone();
		      c.negative = 0;
		      while (!c.isZero()) {
		        var r = c.modn(groupBase).toString(base);
		        c = c.idivn(groupBase);

		        if (!c.isZero()) {
		          out = zeros[groupSize - r.length] + r + out;
		        } else {
		          out = r + out;
		        }
		      }
		      if (this.isZero()) {
		        out = '0' + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    assert(false, 'Base should be between 2 and 36');
		  };

		  BN.prototype.toNumber = function toNumber () {
		    var ret = this.words[0];
		    if (this.length === 2) {
		      ret += this.words[1] * 0x4000000;
		    } else if (this.length === 3 && this.words[2] === 0x01) {
		      // NOTE: at this stage it is known that the top bit is set
		      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
		    } else if (this.length > 2) {
		      assert(false, 'Number can only safely store up to 53 bits');
		    }
		    return (this.negative !== 0) ? -ret : ret;
		  };

		  BN.prototype.toJSON = function toJSON () {
		    return this.toString(16);
		  };

		  BN.prototype.toBuffer = function toBuffer (endian, length) {
		    assert(typeof Buffer !== 'undefined');
		    return this.toArrayLike(Buffer, endian, length);
		  };

		  BN.prototype.toArray = function toArray (endian, length) {
		    return this.toArrayLike(Array, endian, length);
		  };

		  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
		    var byteLength = this.byteLength();
		    var reqLength = length || Math.max(1, byteLength);
		    assert(byteLength <= reqLength, 'byte array longer than desired length');
		    assert(reqLength > 0, 'Requested array length <= 0');

		    this.strip();
		    var littleEndian = endian === 'le';
		    var res = new ArrayType(reqLength);

		    var b, i;
		    var q = this.clone();
		    if (!littleEndian) {
		      // Assume big-endian
		      for (i = 0; i < reqLength - byteLength; i++) {
		        res[i] = 0;
		      }

		      for (i = 0; !q.isZero(); i++) {
		        b = q.andln(0xff);
		        q.iushrn(8);

		        res[reqLength - i - 1] = b;
		      }
		    } else {
		      for (i = 0; !q.isZero(); i++) {
		        b = q.andln(0xff);
		        q.iushrn(8);

		        res[i] = b;
		      }

		      for (; i < reqLength; i++) {
		        res[i] = 0;
		      }
		    }

		    return res;
		  };

		  if (Math.clz32) {
		    BN.prototype._countBits = function _countBits (w) {
		      return 32 - Math.clz32(w);
		    };
		  } else {
		    BN.prototype._countBits = function _countBits (w) {
		      var t = w;
		      var r = 0;
		      if (t >= 0x1000) {
		        r += 13;
		        t >>>= 13;
		      }
		      if (t >= 0x40) {
		        r += 7;
		        t >>>= 7;
		      }
		      if (t >= 0x8) {
		        r += 4;
		        t >>>= 4;
		      }
		      if (t >= 0x02) {
		        r += 2;
		        t >>>= 2;
		      }
		      return r + t;
		    };
		  }

		  BN.prototype._zeroBits = function _zeroBits (w) {
		    // Short-cut
		    if (w === 0) return 26;

		    var t = w;
		    var r = 0;
		    if ((t & 0x1fff) === 0) {
		      r += 13;
		      t >>>= 13;
		    }
		    if ((t & 0x7f) === 0) {
		      r += 7;
		      t >>>= 7;
		    }
		    if ((t & 0xf) === 0) {
		      r += 4;
		      t >>>= 4;
		    }
		    if ((t & 0x3) === 0) {
		      r += 2;
		      t >>>= 2;
		    }
		    if ((t & 0x1) === 0) {
		      r++;
		    }
		    return r;
		  };

		  // Return number of used bits in a BN
		  BN.prototype.bitLength = function bitLength () {
		    var w = this.words[this.length - 1];
		    var hi = this._countBits(w);
		    return (this.length - 1) * 26 + hi;
		  };

		  function toBitArray (num) {
		    var w = new Array(num.bitLength());

		    for (var bit = 0; bit < w.length; bit++) {
		      var off = (bit / 26) | 0;
		      var wbit = bit % 26;

		      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
		    }

		    return w;
		  }

		  // Number of trailing zero bits
		  BN.prototype.zeroBits = function zeroBits () {
		    if (this.isZero()) return 0;

		    var r = 0;
		    for (var i = 0; i < this.length; i++) {
		      var b = this._zeroBits(this.words[i]);
		      r += b;
		      if (b !== 26) break;
		    }
		    return r;
		  };

		  BN.prototype.byteLength = function byteLength () {
		    return Math.ceil(this.bitLength() / 8);
		  };

		  BN.prototype.toTwos = function toTwos (width) {
		    if (this.negative !== 0) {
		      return this.abs().inotn(width).iaddn(1);
		    }
		    return this.clone();
		  };

		  BN.prototype.fromTwos = function fromTwos (width) {
		    if (this.testn(width - 1)) {
		      return this.notn(width).iaddn(1).ineg();
		    }
		    return this.clone();
		  };

		  BN.prototype.isNeg = function isNeg () {
		    return this.negative !== 0;
		  };

		  // Return negative clone of `this`
		  BN.prototype.neg = function neg () {
		    return this.clone().ineg();
		  };

		  BN.prototype.ineg = function ineg () {
		    if (!this.isZero()) {
		      this.negative ^= 1;
		    }

		    return this;
		  };

		  // Or `num` with `this` in-place
		  BN.prototype.iuor = function iuor (num) {
		    while (this.length < num.length) {
		      this.words[this.length++] = 0;
		    }

		    for (var i = 0; i < num.length; i++) {
		      this.words[i] = this.words[i] | num.words[i];
		    }

		    return this.strip();
		  };

		  BN.prototype.ior = function ior (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuor(num);
		  };

		  // Or `num` with `this`
		  BN.prototype.or = function or (num) {
		    if (this.length > num.length) return this.clone().ior(num);
		    return num.clone().ior(this);
		  };

		  BN.prototype.uor = function uor (num) {
		    if (this.length > num.length) return this.clone().iuor(num);
		    return num.clone().iuor(this);
		  };

		  // And `num` with `this` in-place
		  BN.prototype.iuand = function iuand (num) {
		    // b = min-length(num, this)
		    var b;
		    if (this.length > num.length) {
		      b = num;
		    } else {
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = this.words[i] & num.words[i];
		    }

		    this.length = b.length;

		    return this.strip();
		  };

		  BN.prototype.iand = function iand (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuand(num);
		  };

		  // And `num` with `this`
		  BN.prototype.and = function and (num) {
		    if (this.length > num.length) return this.clone().iand(num);
		    return num.clone().iand(this);
		  };

		  BN.prototype.uand = function uand (num) {
		    if (this.length > num.length) return this.clone().iuand(num);
		    return num.clone().iuand(this);
		  };

		  // Xor `num` with `this` in-place
		  BN.prototype.iuxor = function iuxor (num) {
		    // a.length > b.length
		    var a;
		    var b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = a.words[i] ^ b.words[i];
		    }

		    if (this !== a) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = a.length;

		    return this.strip();
		  };

		  BN.prototype.ixor = function ixor (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuxor(num);
		  };

		  // Xor `num` with `this`
		  BN.prototype.xor = function xor (num) {
		    if (this.length > num.length) return this.clone().ixor(num);
		    return num.clone().ixor(this);
		  };

		  BN.prototype.uxor = function uxor (num) {
		    if (this.length > num.length) return this.clone().iuxor(num);
		    return num.clone().iuxor(this);
		  };

		  // Not ``this`` with ``width`` bitwidth
		  BN.prototype.inotn = function inotn (width) {
		    assert(typeof width === 'number' && width >= 0);

		    var bytesNeeded = Math.ceil(width / 26) | 0;
		    var bitsLeft = width % 26;

		    // Extend the buffer with leading zeroes
		    this._expand(bytesNeeded);

		    if (bitsLeft > 0) {
		      bytesNeeded--;
		    }

		    // Handle complete words
		    for (var i = 0; i < bytesNeeded; i++) {
		      this.words[i] = ~this.words[i] & 0x3ffffff;
		    }

		    // Handle the residue
		    if (bitsLeft > 0) {
		      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
		    }

		    // And remove leading zeroes
		    return this.strip();
		  };

		  BN.prototype.notn = function notn (width) {
		    return this.clone().inotn(width);
		  };

		  // Set `bit` of `this`
		  BN.prototype.setn = function setn (bit, val) {
		    assert(typeof bit === 'number' && bit >= 0);

		    var off = (bit / 26) | 0;
		    var wbit = bit % 26;

		    this._expand(off + 1);

		    if (val) {
		      this.words[off] = this.words[off] | (1 << wbit);
		    } else {
		      this.words[off] = this.words[off] & ~(1 << wbit);
		    }

		    return this.strip();
		  };

		  // Add `num` to `this` in-place
		  BN.prototype.iadd = function iadd (num) {
		    var r;

		    // negative + positive
		    if (this.negative !== 0 && num.negative === 0) {
		      this.negative = 0;
		      r = this.isub(num);
		      this.negative ^= 1;
		      return this._normSign();

		    // positive + negative
		    } else if (this.negative === 0 && num.negative !== 0) {
		      num.negative = 0;
		      r = this.isub(num);
		      num.negative = 1;
		      return r._normSign();
		    }

		    // a.length > b.length
		    var a, b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }

		    this.length = a.length;
		    if (carry !== 0) {
		      this.words[this.length] = carry;
		      this.length++;
		    // Copy the rest of the words
		    } else if (a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    return this;
		  };

		  // Add `num` to `this`
		  BN.prototype.add = function add (num) {
		    var res;
		    if (num.negative !== 0 && this.negative === 0) {
		      num.negative = 0;
		      res = this.sub(num);
		      num.negative ^= 1;
		      return res;
		    } else if (num.negative === 0 && this.negative !== 0) {
		      this.negative = 0;
		      res = num.sub(this);
		      this.negative = 1;
		      return res;
		    }

		    if (this.length > num.length) return this.clone().iadd(num);

		    return num.clone().iadd(this);
		  };

		  // Subtract `num` from `this` in-place
		  BN.prototype.isub = function isub (num) {
		    // this - (-num) = this + num
		    if (num.negative !== 0) {
		      num.negative = 0;
		      var r = this.iadd(num);
		      num.negative = 1;
		      return r._normSign();

		    // -this - num = -(this + num)
		    } else if (this.negative !== 0) {
		      this.negative = 0;
		      this.iadd(num);
		      this.negative = 1;
		      return this._normSign();
		    }

		    // At this point both numbers are positive
		    var cmp = this.cmp(num);

		    // Optimization - zeroify
		    if (cmp === 0) {
		      this.negative = 0;
		      this.length = 1;
		      this.words[0] = 0;
		      return this;
		    }

		    // a > b
		    var a, b;
		    if (cmp > 0) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }

		    // Copy rest of the words
		    if (carry === 0 && i < a.length && a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = Math.max(this.length, i);

		    if (a !== this) {
		      this.negative = 1;
		    }

		    return this.strip();
		  };

		  // Subtract `num` from `this`
		  BN.prototype.sub = function sub (num) {
		    return this.clone().isub(num);
		  };

		  function smallMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    var len = (self.length + num.length) | 0;
		    out.length = len;
		    len = (len - 1) | 0;

		    // Peel one iteration (compiler can't do it, because of code complexity)
		    var a = self.words[0] | 0;
		    var b = num.words[0] | 0;
		    var r = a * b;

		    var lo = r & 0x3ffffff;
		    var carry = (r / 0x4000000) | 0;
		    out.words[0] = lo;

		    for (var k = 1; k < len; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = carry >>> 26;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = (k - j) | 0;
		        a = self.words[i] | 0;
		        b = num.words[j] | 0;
		        r = a * b + rword;
		        ncarry += (r / 0x4000000) | 0;
		        rword = r & 0x3ffffff;
		      }
		      out.words[k] = rword | 0;
		      carry = ncarry | 0;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry | 0;
		    } else {
		      out.length--;
		    }

		    return out.strip();
		  }

		  // TODO(indutny): it may be reasonable to omit it for users who don't need
		  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
		  // multiplication (like elliptic secp256k1).
		  var comb10MulTo = function comb10MulTo (self, num, out) {
		    var a = self.words;
		    var b = num.words;
		    var o = out.words;
		    var c = 0;
		    var lo;
		    var mid;
		    var hi;
		    var a0 = a[0] | 0;
		    var al0 = a0 & 0x1fff;
		    var ah0 = a0 >>> 13;
		    var a1 = a[1] | 0;
		    var al1 = a1 & 0x1fff;
		    var ah1 = a1 >>> 13;
		    var a2 = a[2] | 0;
		    var al2 = a2 & 0x1fff;
		    var ah2 = a2 >>> 13;
		    var a3 = a[3] | 0;
		    var al3 = a3 & 0x1fff;
		    var ah3 = a3 >>> 13;
		    var a4 = a[4] | 0;
		    var al4 = a4 & 0x1fff;
		    var ah4 = a4 >>> 13;
		    var a5 = a[5] | 0;
		    var al5 = a5 & 0x1fff;
		    var ah5 = a5 >>> 13;
		    var a6 = a[6] | 0;
		    var al6 = a6 & 0x1fff;
		    var ah6 = a6 >>> 13;
		    var a7 = a[7] | 0;
		    var al7 = a7 & 0x1fff;
		    var ah7 = a7 >>> 13;
		    var a8 = a[8] | 0;
		    var al8 = a8 & 0x1fff;
		    var ah8 = a8 >>> 13;
		    var a9 = a[9] | 0;
		    var al9 = a9 & 0x1fff;
		    var ah9 = a9 >>> 13;
		    var b0 = b[0] | 0;
		    var bl0 = b0 & 0x1fff;
		    var bh0 = b0 >>> 13;
		    var b1 = b[1] | 0;
		    var bl1 = b1 & 0x1fff;
		    var bh1 = b1 >>> 13;
		    var b2 = b[2] | 0;
		    var bl2 = b2 & 0x1fff;
		    var bh2 = b2 >>> 13;
		    var b3 = b[3] | 0;
		    var bl3 = b3 & 0x1fff;
		    var bh3 = b3 >>> 13;
		    var b4 = b[4] | 0;
		    var bl4 = b4 & 0x1fff;
		    var bh4 = b4 >>> 13;
		    var b5 = b[5] | 0;
		    var bl5 = b5 & 0x1fff;
		    var bh5 = b5 >>> 13;
		    var b6 = b[6] | 0;
		    var bl6 = b6 & 0x1fff;
		    var bh6 = b6 >>> 13;
		    var b7 = b[7] | 0;
		    var bl7 = b7 & 0x1fff;
		    var bh7 = b7 >>> 13;
		    var b8 = b[8] | 0;
		    var bl8 = b8 & 0x1fff;
		    var bh8 = b8 >>> 13;
		    var b9 = b[9] | 0;
		    var bl9 = b9 & 0x1fff;
		    var bh9 = b9 >>> 13;

		    out.negative = self.negative ^ num.negative;
		    out.length = 19;
		    /* k = 0 */
		    lo = Math.imul(al0, bl0);
		    mid = Math.imul(al0, bh0);
		    mid = (mid + Math.imul(ah0, bl0)) | 0;
		    hi = Math.imul(ah0, bh0);
		    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
		    w0 &= 0x3ffffff;
		    /* k = 1 */
		    lo = Math.imul(al1, bl0);
		    mid = Math.imul(al1, bh0);
		    mid = (mid + Math.imul(ah1, bl0)) | 0;
		    hi = Math.imul(ah1, bh0);
		    lo = (lo + Math.imul(al0, bl1)) | 0;
		    mid = (mid + Math.imul(al0, bh1)) | 0;
		    mid = (mid + Math.imul(ah0, bl1)) | 0;
		    hi = (hi + Math.imul(ah0, bh1)) | 0;
		    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
		    w1 &= 0x3ffffff;
		    /* k = 2 */
		    lo = Math.imul(al2, bl0);
		    mid = Math.imul(al2, bh0);
		    mid = (mid + Math.imul(ah2, bl0)) | 0;
		    hi = Math.imul(ah2, bh0);
		    lo = (lo + Math.imul(al1, bl1)) | 0;
		    mid = (mid + Math.imul(al1, bh1)) | 0;
		    mid = (mid + Math.imul(ah1, bl1)) | 0;
		    hi = (hi + Math.imul(ah1, bh1)) | 0;
		    lo = (lo + Math.imul(al0, bl2)) | 0;
		    mid = (mid + Math.imul(al0, bh2)) | 0;
		    mid = (mid + Math.imul(ah0, bl2)) | 0;
		    hi = (hi + Math.imul(ah0, bh2)) | 0;
		    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
		    w2 &= 0x3ffffff;
		    /* k = 3 */
		    lo = Math.imul(al3, bl0);
		    mid = Math.imul(al3, bh0);
		    mid = (mid + Math.imul(ah3, bl0)) | 0;
		    hi = Math.imul(ah3, bh0);
		    lo = (lo + Math.imul(al2, bl1)) | 0;
		    mid = (mid + Math.imul(al2, bh1)) | 0;
		    mid = (mid + Math.imul(ah2, bl1)) | 0;
		    hi = (hi + Math.imul(ah2, bh1)) | 0;
		    lo = (lo + Math.imul(al1, bl2)) | 0;
		    mid = (mid + Math.imul(al1, bh2)) | 0;
		    mid = (mid + Math.imul(ah1, bl2)) | 0;
		    hi = (hi + Math.imul(ah1, bh2)) | 0;
		    lo = (lo + Math.imul(al0, bl3)) | 0;
		    mid = (mid + Math.imul(al0, bh3)) | 0;
		    mid = (mid + Math.imul(ah0, bl3)) | 0;
		    hi = (hi + Math.imul(ah0, bh3)) | 0;
		    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
		    w3 &= 0x3ffffff;
		    /* k = 4 */
		    lo = Math.imul(al4, bl0);
		    mid = Math.imul(al4, bh0);
		    mid = (mid + Math.imul(ah4, bl0)) | 0;
		    hi = Math.imul(ah4, bh0);
		    lo = (lo + Math.imul(al3, bl1)) | 0;
		    mid = (mid + Math.imul(al3, bh1)) | 0;
		    mid = (mid + Math.imul(ah3, bl1)) | 0;
		    hi = (hi + Math.imul(ah3, bh1)) | 0;
		    lo = (lo + Math.imul(al2, bl2)) | 0;
		    mid = (mid + Math.imul(al2, bh2)) | 0;
		    mid = (mid + Math.imul(ah2, bl2)) | 0;
		    hi = (hi + Math.imul(ah2, bh2)) | 0;
		    lo = (lo + Math.imul(al1, bl3)) | 0;
		    mid = (mid + Math.imul(al1, bh3)) | 0;
		    mid = (mid + Math.imul(ah1, bl3)) | 0;
		    hi = (hi + Math.imul(ah1, bh3)) | 0;
		    lo = (lo + Math.imul(al0, bl4)) | 0;
		    mid = (mid + Math.imul(al0, bh4)) | 0;
		    mid = (mid + Math.imul(ah0, bl4)) | 0;
		    hi = (hi + Math.imul(ah0, bh4)) | 0;
		    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
		    w4 &= 0x3ffffff;
		    /* k = 5 */
		    lo = Math.imul(al5, bl0);
		    mid = Math.imul(al5, bh0);
		    mid = (mid + Math.imul(ah5, bl0)) | 0;
		    hi = Math.imul(ah5, bh0);
		    lo = (lo + Math.imul(al4, bl1)) | 0;
		    mid = (mid + Math.imul(al4, bh1)) | 0;
		    mid = (mid + Math.imul(ah4, bl1)) | 0;
		    hi = (hi + Math.imul(ah4, bh1)) | 0;
		    lo = (lo + Math.imul(al3, bl2)) | 0;
		    mid = (mid + Math.imul(al3, bh2)) | 0;
		    mid = (mid + Math.imul(ah3, bl2)) | 0;
		    hi = (hi + Math.imul(ah3, bh2)) | 0;
		    lo = (lo + Math.imul(al2, bl3)) | 0;
		    mid = (mid + Math.imul(al2, bh3)) | 0;
		    mid = (mid + Math.imul(ah2, bl3)) | 0;
		    hi = (hi + Math.imul(ah2, bh3)) | 0;
		    lo = (lo + Math.imul(al1, bl4)) | 0;
		    mid = (mid + Math.imul(al1, bh4)) | 0;
		    mid = (mid + Math.imul(ah1, bl4)) | 0;
		    hi = (hi + Math.imul(ah1, bh4)) | 0;
		    lo = (lo + Math.imul(al0, bl5)) | 0;
		    mid = (mid + Math.imul(al0, bh5)) | 0;
		    mid = (mid + Math.imul(ah0, bl5)) | 0;
		    hi = (hi + Math.imul(ah0, bh5)) | 0;
		    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
		    w5 &= 0x3ffffff;
		    /* k = 6 */
		    lo = Math.imul(al6, bl0);
		    mid = Math.imul(al6, bh0);
		    mid = (mid + Math.imul(ah6, bl0)) | 0;
		    hi = Math.imul(ah6, bh0);
		    lo = (lo + Math.imul(al5, bl1)) | 0;
		    mid = (mid + Math.imul(al5, bh1)) | 0;
		    mid = (mid + Math.imul(ah5, bl1)) | 0;
		    hi = (hi + Math.imul(ah5, bh1)) | 0;
		    lo = (lo + Math.imul(al4, bl2)) | 0;
		    mid = (mid + Math.imul(al4, bh2)) | 0;
		    mid = (mid + Math.imul(ah4, bl2)) | 0;
		    hi = (hi + Math.imul(ah4, bh2)) | 0;
		    lo = (lo + Math.imul(al3, bl3)) | 0;
		    mid = (mid + Math.imul(al3, bh3)) | 0;
		    mid = (mid + Math.imul(ah3, bl3)) | 0;
		    hi = (hi + Math.imul(ah3, bh3)) | 0;
		    lo = (lo + Math.imul(al2, bl4)) | 0;
		    mid = (mid + Math.imul(al2, bh4)) | 0;
		    mid = (mid + Math.imul(ah2, bl4)) | 0;
		    hi = (hi + Math.imul(ah2, bh4)) | 0;
		    lo = (lo + Math.imul(al1, bl5)) | 0;
		    mid = (mid + Math.imul(al1, bh5)) | 0;
		    mid = (mid + Math.imul(ah1, bl5)) | 0;
		    hi = (hi + Math.imul(ah1, bh5)) | 0;
		    lo = (lo + Math.imul(al0, bl6)) | 0;
		    mid = (mid + Math.imul(al0, bh6)) | 0;
		    mid = (mid + Math.imul(ah0, bl6)) | 0;
		    hi = (hi + Math.imul(ah0, bh6)) | 0;
		    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
		    w6 &= 0x3ffffff;
		    /* k = 7 */
		    lo = Math.imul(al7, bl0);
		    mid = Math.imul(al7, bh0);
		    mid = (mid + Math.imul(ah7, bl0)) | 0;
		    hi = Math.imul(ah7, bh0);
		    lo = (lo + Math.imul(al6, bl1)) | 0;
		    mid = (mid + Math.imul(al6, bh1)) | 0;
		    mid = (mid + Math.imul(ah6, bl1)) | 0;
		    hi = (hi + Math.imul(ah6, bh1)) | 0;
		    lo = (lo + Math.imul(al5, bl2)) | 0;
		    mid = (mid + Math.imul(al5, bh2)) | 0;
		    mid = (mid + Math.imul(ah5, bl2)) | 0;
		    hi = (hi + Math.imul(ah5, bh2)) | 0;
		    lo = (lo + Math.imul(al4, bl3)) | 0;
		    mid = (mid + Math.imul(al4, bh3)) | 0;
		    mid = (mid + Math.imul(ah4, bl3)) | 0;
		    hi = (hi + Math.imul(ah4, bh3)) | 0;
		    lo = (lo + Math.imul(al3, bl4)) | 0;
		    mid = (mid + Math.imul(al3, bh4)) | 0;
		    mid = (mid + Math.imul(ah3, bl4)) | 0;
		    hi = (hi + Math.imul(ah3, bh4)) | 0;
		    lo = (lo + Math.imul(al2, bl5)) | 0;
		    mid = (mid + Math.imul(al2, bh5)) | 0;
		    mid = (mid + Math.imul(ah2, bl5)) | 0;
		    hi = (hi + Math.imul(ah2, bh5)) | 0;
		    lo = (lo + Math.imul(al1, bl6)) | 0;
		    mid = (mid + Math.imul(al1, bh6)) | 0;
		    mid = (mid + Math.imul(ah1, bl6)) | 0;
		    hi = (hi + Math.imul(ah1, bh6)) | 0;
		    lo = (lo + Math.imul(al0, bl7)) | 0;
		    mid = (mid + Math.imul(al0, bh7)) | 0;
		    mid = (mid + Math.imul(ah0, bl7)) | 0;
		    hi = (hi + Math.imul(ah0, bh7)) | 0;
		    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
		    w7 &= 0x3ffffff;
		    /* k = 8 */
		    lo = Math.imul(al8, bl0);
		    mid = Math.imul(al8, bh0);
		    mid = (mid + Math.imul(ah8, bl0)) | 0;
		    hi = Math.imul(ah8, bh0);
		    lo = (lo + Math.imul(al7, bl1)) | 0;
		    mid = (mid + Math.imul(al7, bh1)) | 0;
		    mid = (mid + Math.imul(ah7, bl1)) | 0;
		    hi = (hi + Math.imul(ah7, bh1)) | 0;
		    lo = (lo + Math.imul(al6, bl2)) | 0;
		    mid = (mid + Math.imul(al6, bh2)) | 0;
		    mid = (mid + Math.imul(ah6, bl2)) | 0;
		    hi = (hi + Math.imul(ah6, bh2)) | 0;
		    lo = (lo + Math.imul(al5, bl3)) | 0;
		    mid = (mid + Math.imul(al5, bh3)) | 0;
		    mid = (mid + Math.imul(ah5, bl3)) | 0;
		    hi = (hi + Math.imul(ah5, bh3)) | 0;
		    lo = (lo + Math.imul(al4, bl4)) | 0;
		    mid = (mid + Math.imul(al4, bh4)) | 0;
		    mid = (mid + Math.imul(ah4, bl4)) | 0;
		    hi = (hi + Math.imul(ah4, bh4)) | 0;
		    lo = (lo + Math.imul(al3, bl5)) | 0;
		    mid = (mid + Math.imul(al3, bh5)) | 0;
		    mid = (mid + Math.imul(ah3, bl5)) | 0;
		    hi = (hi + Math.imul(ah3, bh5)) | 0;
		    lo = (lo + Math.imul(al2, bl6)) | 0;
		    mid = (mid + Math.imul(al2, bh6)) | 0;
		    mid = (mid + Math.imul(ah2, bl6)) | 0;
		    hi = (hi + Math.imul(ah2, bh6)) | 0;
		    lo = (lo + Math.imul(al1, bl7)) | 0;
		    mid = (mid + Math.imul(al1, bh7)) | 0;
		    mid = (mid + Math.imul(ah1, bl7)) | 0;
		    hi = (hi + Math.imul(ah1, bh7)) | 0;
		    lo = (lo + Math.imul(al0, bl8)) | 0;
		    mid = (mid + Math.imul(al0, bh8)) | 0;
		    mid = (mid + Math.imul(ah0, bl8)) | 0;
		    hi = (hi + Math.imul(ah0, bh8)) | 0;
		    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
		    w8 &= 0x3ffffff;
		    /* k = 9 */
		    lo = Math.imul(al9, bl0);
		    mid = Math.imul(al9, bh0);
		    mid = (mid + Math.imul(ah9, bl0)) | 0;
		    hi = Math.imul(ah9, bh0);
		    lo = (lo + Math.imul(al8, bl1)) | 0;
		    mid = (mid + Math.imul(al8, bh1)) | 0;
		    mid = (mid + Math.imul(ah8, bl1)) | 0;
		    hi = (hi + Math.imul(ah8, bh1)) | 0;
		    lo = (lo + Math.imul(al7, bl2)) | 0;
		    mid = (mid + Math.imul(al7, bh2)) | 0;
		    mid = (mid + Math.imul(ah7, bl2)) | 0;
		    hi = (hi + Math.imul(ah7, bh2)) | 0;
		    lo = (lo + Math.imul(al6, bl3)) | 0;
		    mid = (mid + Math.imul(al6, bh3)) | 0;
		    mid = (mid + Math.imul(ah6, bl3)) | 0;
		    hi = (hi + Math.imul(ah6, bh3)) | 0;
		    lo = (lo + Math.imul(al5, bl4)) | 0;
		    mid = (mid + Math.imul(al5, bh4)) | 0;
		    mid = (mid + Math.imul(ah5, bl4)) | 0;
		    hi = (hi + Math.imul(ah5, bh4)) | 0;
		    lo = (lo + Math.imul(al4, bl5)) | 0;
		    mid = (mid + Math.imul(al4, bh5)) | 0;
		    mid = (mid + Math.imul(ah4, bl5)) | 0;
		    hi = (hi + Math.imul(ah4, bh5)) | 0;
		    lo = (lo + Math.imul(al3, bl6)) | 0;
		    mid = (mid + Math.imul(al3, bh6)) | 0;
		    mid = (mid + Math.imul(ah3, bl6)) | 0;
		    hi = (hi + Math.imul(ah3, bh6)) | 0;
		    lo = (lo + Math.imul(al2, bl7)) | 0;
		    mid = (mid + Math.imul(al2, bh7)) | 0;
		    mid = (mid + Math.imul(ah2, bl7)) | 0;
		    hi = (hi + Math.imul(ah2, bh7)) | 0;
		    lo = (lo + Math.imul(al1, bl8)) | 0;
		    mid = (mid + Math.imul(al1, bh8)) | 0;
		    mid = (mid + Math.imul(ah1, bl8)) | 0;
		    hi = (hi + Math.imul(ah1, bh8)) | 0;
		    lo = (lo + Math.imul(al0, bl9)) | 0;
		    mid = (mid + Math.imul(al0, bh9)) | 0;
		    mid = (mid + Math.imul(ah0, bl9)) | 0;
		    hi = (hi + Math.imul(ah0, bh9)) | 0;
		    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
		    w9 &= 0x3ffffff;
		    /* k = 10 */
		    lo = Math.imul(al9, bl1);
		    mid = Math.imul(al9, bh1);
		    mid = (mid + Math.imul(ah9, bl1)) | 0;
		    hi = Math.imul(ah9, bh1);
		    lo = (lo + Math.imul(al8, bl2)) | 0;
		    mid = (mid + Math.imul(al8, bh2)) | 0;
		    mid = (mid + Math.imul(ah8, bl2)) | 0;
		    hi = (hi + Math.imul(ah8, bh2)) | 0;
		    lo = (lo + Math.imul(al7, bl3)) | 0;
		    mid = (mid + Math.imul(al7, bh3)) | 0;
		    mid = (mid + Math.imul(ah7, bl3)) | 0;
		    hi = (hi + Math.imul(ah7, bh3)) | 0;
		    lo = (lo + Math.imul(al6, bl4)) | 0;
		    mid = (mid + Math.imul(al6, bh4)) | 0;
		    mid = (mid + Math.imul(ah6, bl4)) | 0;
		    hi = (hi + Math.imul(ah6, bh4)) | 0;
		    lo = (lo + Math.imul(al5, bl5)) | 0;
		    mid = (mid + Math.imul(al5, bh5)) | 0;
		    mid = (mid + Math.imul(ah5, bl5)) | 0;
		    hi = (hi + Math.imul(ah5, bh5)) | 0;
		    lo = (lo + Math.imul(al4, bl6)) | 0;
		    mid = (mid + Math.imul(al4, bh6)) | 0;
		    mid = (mid + Math.imul(ah4, bl6)) | 0;
		    hi = (hi + Math.imul(ah4, bh6)) | 0;
		    lo = (lo + Math.imul(al3, bl7)) | 0;
		    mid = (mid + Math.imul(al3, bh7)) | 0;
		    mid = (mid + Math.imul(ah3, bl7)) | 0;
		    hi = (hi + Math.imul(ah3, bh7)) | 0;
		    lo = (lo + Math.imul(al2, bl8)) | 0;
		    mid = (mid + Math.imul(al2, bh8)) | 0;
		    mid = (mid + Math.imul(ah2, bl8)) | 0;
		    hi = (hi + Math.imul(ah2, bh8)) | 0;
		    lo = (lo + Math.imul(al1, bl9)) | 0;
		    mid = (mid + Math.imul(al1, bh9)) | 0;
		    mid = (mid + Math.imul(ah1, bl9)) | 0;
		    hi = (hi + Math.imul(ah1, bh9)) | 0;
		    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
		    w10 &= 0x3ffffff;
		    /* k = 11 */
		    lo = Math.imul(al9, bl2);
		    mid = Math.imul(al9, bh2);
		    mid = (mid + Math.imul(ah9, bl2)) | 0;
		    hi = Math.imul(ah9, bh2);
		    lo = (lo + Math.imul(al8, bl3)) | 0;
		    mid = (mid + Math.imul(al8, bh3)) | 0;
		    mid = (mid + Math.imul(ah8, bl3)) | 0;
		    hi = (hi + Math.imul(ah8, bh3)) | 0;
		    lo = (lo + Math.imul(al7, bl4)) | 0;
		    mid = (mid + Math.imul(al7, bh4)) | 0;
		    mid = (mid + Math.imul(ah7, bl4)) | 0;
		    hi = (hi + Math.imul(ah7, bh4)) | 0;
		    lo = (lo + Math.imul(al6, bl5)) | 0;
		    mid = (mid + Math.imul(al6, bh5)) | 0;
		    mid = (mid + Math.imul(ah6, bl5)) | 0;
		    hi = (hi + Math.imul(ah6, bh5)) | 0;
		    lo = (lo + Math.imul(al5, bl6)) | 0;
		    mid = (mid + Math.imul(al5, bh6)) | 0;
		    mid = (mid + Math.imul(ah5, bl6)) | 0;
		    hi = (hi + Math.imul(ah5, bh6)) | 0;
		    lo = (lo + Math.imul(al4, bl7)) | 0;
		    mid = (mid + Math.imul(al4, bh7)) | 0;
		    mid = (mid + Math.imul(ah4, bl7)) | 0;
		    hi = (hi + Math.imul(ah4, bh7)) | 0;
		    lo = (lo + Math.imul(al3, bl8)) | 0;
		    mid = (mid + Math.imul(al3, bh8)) | 0;
		    mid = (mid + Math.imul(ah3, bl8)) | 0;
		    hi = (hi + Math.imul(ah3, bh8)) | 0;
		    lo = (lo + Math.imul(al2, bl9)) | 0;
		    mid = (mid + Math.imul(al2, bh9)) | 0;
		    mid = (mid + Math.imul(ah2, bl9)) | 0;
		    hi = (hi + Math.imul(ah2, bh9)) | 0;
		    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
		    w11 &= 0x3ffffff;
		    /* k = 12 */
		    lo = Math.imul(al9, bl3);
		    mid = Math.imul(al9, bh3);
		    mid = (mid + Math.imul(ah9, bl3)) | 0;
		    hi = Math.imul(ah9, bh3);
		    lo = (lo + Math.imul(al8, bl4)) | 0;
		    mid = (mid + Math.imul(al8, bh4)) | 0;
		    mid = (mid + Math.imul(ah8, bl4)) | 0;
		    hi = (hi + Math.imul(ah8, bh4)) | 0;
		    lo = (lo + Math.imul(al7, bl5)) | 0;
		    mid = (mid + Math.imul(al7, bh5)) | 0;
		    mid = (mid + Math.imul(ah7, bl5)) | 0;
		    hi = (hi + Math.imul(ah7, bh5)) | 0;
		    lo = (lo + Math.imul(al6, bl6)) | 0;
		    mid = (mid + Math.imul(al6, bh6)) | 0;
		    mid = (mid + Math.imul(ah6, bl6)) | 0;
		    hi = (hi + Math.imul(ah6, bh6)) | 0;
		    lo = (lo + Math.imul(al5, bl7)) | 0;
		    mid = (mid + Math.imul(al5, bh7)) | 0;
		    mid = (mid + Math.imul(ah5, bl7)) | 0;
		    hi = (hi + Math.imul(ah5, bh7)) | 0;
		    lo = (lo + Math.imul(al4, bl8)) | 0;
		    mid = (mid + Math.imul(al4, bh8)) | 0;
		    mid = (mid + Math.imul(ah4, bl8)) | 0;
		    hi = (hi + Math.imul(ah4, bh8)) | 0;
		    lo = (lo + Math.imul(al3, bl9)) | 0;
		    mid = (mid + Math.imul(al3, bh9)) | 0;
		    mid = (mid + Math.imul(ah3, bl9)) | 0;
		    hi = (hi + Math.imul(ah3, bh9)) | 0;
		    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
		    w12 &= 0x3ffffff;
		    /* k = 13 */
		    lo = Math.imul(al9, bl4);
		    mid = Math.imul(al9, bh4);
		    mid = (mid + Math.imul(ah9, bl4)) | 0;
		    hi = Math.imul(ah9, bh4);
		    lo = (lo + Math.imul(al8, bl5)) | 0;
		    mid = (mid + Math.imul(al8, bh5)) | 0;
		    mid = (mid + Math.imul(ah8, bl5)) | 0;
		    hi = (hi + Math.imul(ah8, bh5)) | 0;
		    lo = (lo + Math.imul(al7, bl6)) | 0;
		    mid = (mid + Math.imul(al7, bh6)) | 0;
		    mid = (mid + Math.imul(ah7, bl6)) | 0;
		    hi = (hi + Math.imul(ah7, bh6)) | 0;
		    lo = (lo + Math.imul(al6, bl7)) | 0;
		    mid = (mid + Math.imul(al6, bh7)) | 0;
		    mid = (mid + Math.imul(ah6, bl7)) | 0;
		    hi = (hi + Math.imul(ah6, bh7)) | 0;
		    lo = (lo + Math.imul(al5, bl8)) | 0;
		    mid = (mid + Math.imul(al5, bh8)) | 0;
		    mid = (mid + Math.imul(ah5, bl8)) | 0;
		    hi = (hi + Math.imul(ah5, bh8)) | 0;
		    lo = (lo + Math.imul(al4, bl9)) | 0;
		    mid = (mid + Math.imul(al4, bh9)) | 0;
		    mid = (mid + Math.imul(ah4, bl9)) | 0;
		    hi = (hi + Math.imul(ah4, bh9)) | 0;
		    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
		    w13 &= 0x3ffffff;
		    /* k = 14 */
		    lo = Math.imul(al9, bl5);
		    mid = Math.imul(al9, bh5);
		    mid = (mid + Math.imul(ah9, bl5)) | 0;
		    hi = Math.imul(ah9, bh5);
		    lo = (lo + Math.imul(al8, bl6)) | 0;
		    mid = (mid + Math.imul(al8, bh6)) | 0;
		    mid = (mid + Math.imul(ah8, bl6)) | 0;
		    hi = (hi + Math.imul(ah8, bh6)) | 0;
		    lo = (lo + Math.imul(al7, bl7)) | 0;
		    mid = (mid + Math.imul(al7, bh7)) | 0;
		    mid = (mid + Math.imul(ah7, bl7)) | 0;
		    hi = (hi + Math.imul(ah7, bh7)) | 0;
		    lo = (lo + Math.imul(al6, bl8)) | 0;
		    mid = (mid + Math.imul(al6, bh8)) | 0;
		    mid = (mid + Math.imul(ah6, bl8)) | 0;
		    hi = (hi + Math.imul(ah6, bh8)) | 0;
		    lo = (lo + Math.imul(al5, bl9)) | 0;
		    mid = (mid + Math.imul(al5, bh9)) | 0;
		    mid = (mid + Math.imul(ah5, bl9)) | 0;
		    hi = (hi + Math.imul(ah5, bh9)) | 0;
		    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
		    w14 &= 0x3ffffff;
		    /* k = 15 */
		    lo = Math.imul(al9, bl6);
		    mid = Math.imul(al9, bh6);
		    mid = (mid + Math.imul(ah9, bl6)) | 0;
		    hi = Math.imul(ah9, bh6);
		    lo = (lo + Math.imul(al8, bl7)) | 0;
		    mid = (mid + Math.imul(al8, bh7)) | 0;
		    mid = (mid + Math.imul(ah8, bl7)) | 0;
		    hi = (hi + Math.imul(ah8, bh7)) | 0;
		    lo = (lo + Math.imul(al7, bl8)) | 0;
		    mid = (mid + Math.imul(al7, bh8)) | 0;
		    mid = (mid + Math.imul(ah7, bl8)) | 0;
		    hi = (hi + Math.imul(ah7, bh8)) | 0;
		    lo = (lo + Math.imul(al6, bl9)) | 0;
		    mid = (mid + Math.imul(al6, bh9)) | 0;
		    mid = (mid + Math.imul(ah6, bl9)) | 0;
		    hi = (hi + Math.imul(ah6, bh9)) | 0;
		    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
		    w15 &= 0x3ffffff;
		    /* k = 16 */
		    lo = Math.imul(al9, bl7);
		    mid = Math.imul(al9, bh7);
		    mid = (mid + Math.imul(ah9, bl7)) | 0;
		    hi = Math.imul(ah9, bh7);
		    lo = (lo + Math.imul(al8, bl8)) | 0;
		    mid = (mid + Math.imul(al8, bh8)) | 0;
		    mid = (mid + Math.imul(ah8, bl8)) | 0;
		    hi = (hi + Math.imul(ah8, bh8)) | 0;
		    lo = (lo + Math.imul(al7, bl9)) | 0;
		    mid = (mid + Math.imul(al7, bh9)) | 0;
		    mid = (mid + Math.imul(ah7, bl9)) | 0;
		    hi = (hi + Math.imul(ah7, bh9)) | 0;
		    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
		    w16 &= 0x3ffffff;
		    /* k = 17 */
		    lo = Math.imul(al9, bl8);
		    mid = Math.imul(al9, bh8);
		    mid = (mid + Math.imul(ah9, bl8)) | 0;
		    hi = Math.imul(ah9, bh8);
		    lo = (lo + Math.imul(al8, bl9)) | 0;
		    mid = (mid + Math.imul(al8, bh9)) | 0;
		    mid = (mid + Math.imul(ah8, bl9)) | 0;
		    hi = (hi + Math.imul(ah8, bh9)) | 0;
		    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
		    w17 &= 0x3ffffff;
		    /* k = 18 */
		    lo = Math.imul(al9, bl9);
		    mid = Math.imul(al9, bh9);
		    mid = (mid + Math.imul(ah9, bl9)) | 0;
		    hi = Math.imul(ah9, bh9);
		    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
		    w18 &= 0x3ffffff;
		    o[0] = w0;
		    o[1] = w1;
		    o[2] = w2;
		    o[3] = w3;
		    o[4] = w4;
		    o[5] = w5;
		    o[6] = w6;
		    o[7] = w7;
		    o[8] = w8;
		    o[9] = w9;
		    o[10] = w10;
		    o[11] = w11;
		    o[12] = w12;
		    o[13] = w13;
		    o[14] = w14;
		    o[15] = w15;
		    o[16] = w16;
		    o[17] = w17;
		    o[18] = w18;
		    if (c !== 0) {
		      o[19] = c;
		      out.length++;
		    }
		    return out;
		  };

		  // Polyfill comb
		  if (!Math.imul) {
		    comb10MulTo = smallMulTo;
		  }

		  function bigMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    out.length = self.length + num.length;

		    var carry = 0;
		    var hncarry = 0;
		    for (var k = 0; k < out.length - 1; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = hncarry;
		      hncarry = 0;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = k - j;
		        var a = self.words[i] | 0;
		        var b = num.words[j] | 0;
		        var r = a * b;

		        var lo = r & 0x3ffffff;
		        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
		        lo = (lo + rword) | 0;
		        rword = lo & 0x3ffffff;
		        ncarry = (ncarry + (lo >>> 26)) | 0;

		        hncarry += ncarry >>> 26;
		        ncarry &= 0x3ffffff;
		      }
		      out.words[k] = rword;
		      carry = ncarry;
		      ncarry = hncarry;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry;
		    } else {
		      out.length--;
		    }

		    return out.strip();
		  }

		  function jumboMulTo (self, num, out) {
		    var fftm = new FFTM();
		    return fftm.mulp(self, num, out);
		  }

		  BN.prototype.mulTo = function mulTo (num, out) {
		    var res;
		    var len = this.length + num.length;
		    if (this.length === 10 && num.length === 10) {
		      res = comb10MulTo(this, num, out);
		    } else if (len < 63) {
		      res = smallMulTo(this, num, out);
		    } else if (len < 1024) {
		      res = bigMulTo(this, num, out);
		    } else {
		      res = jumboMulTo(this, num, out);
		    }

		    return res;
		  };

		  // Cooley-Tukey algorithm for FFT
		  // slightly revisited to rely on looping instead of recursion

		  function FFTM (x, y) {
		    this.x = x;
		    this.y = y;
		  }

		  FFTM.prototype.makeRBT = function makeRBT (N) {
		    var t = new Array(N);
		    var l = BN.prototype._countBits(N) - 1;
		    for (var i = 0; i < N; i++) {
		      t[i] = this.revBin(i, l, N);
		    }

		    return t;
		  };

		  // Returns binary-reversed representation of `x`
		  FFTM.prototype.revBin = function revBin (x, l, N) {
		    if (x === 0 || x === N - 1) return x;

		    var rb = 0;
		    for (var i = 0; i < l; i++) {
		      rb |= (x & 1) << (l - i - 1);
		      x >>= 1;
		    }

		    return rb;
		  };

		  // Performs "tweedling" phase, therefore 'emulating'
		  // behaviour of the recursive algorithm
		  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
		    for (var i = 0; i < N; i++) {
		      rtws[i] = rws[rbt[i]];
		      itws[i] = iws[rbt[i]];
		    }
		  };

		  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
		    this.permute(rbt, rws, iws, rtws, itws, N);

		    for (var s = 1; s < N; s <<= 1) {
		      var l = s << 1;

		      var rtwdf = Math.cos(2 * Math.PI / l);
		      var itwdf = Math.sin(2 * Math.PI / l);

		      for (var p = 0; p < N; p += l) {
		        var rtwdf_ = rtwdf;
		        var itwdf_ = itwdf;

		        for (var j = 0; j < s; j++) {
		          var re = rtws[p + j];
		          var ie = itws[p + j];

		          var ro = rtws[p + j + s];
		          var io = itws[p + j + s];

		          var rx = rtwdf_ * ro - itwdf_ * io;

		          io = rtwdf_ * io + itwdf_ * ro;
		          ro = rx;

		          rtws[p + j] = re + ro;
		          itws[p + j] = ie + io;

		          rtws[p + j + s] = re - ro;
		          itws[p + j + s] = ie - io;

		          /* jshint maxdepth : false */
		          if (j !== l) {
		            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

		            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
		            rtwdf_ = rx;
		          }
		        }
		      }
		    }
		  };

		  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
		    var N = Math.max(m, n) | 1;
		    var odd = N & 1;
		    var i = 0;
		    for (N = N / 2 | 0; N; N = N >>> 1) {
		      i++;
		    }

		    return 1 << i + 1 + odd;
		  };

		  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
		    if (N <= 1) return;

		    for (var i = 0; i < N / 2; i++) {
		      var t = rws[i];

		      rws[i] = rws[N - i - 1];
		      rws[N - i - 1] = t;

		      t = iws[i];

		      iws[i] = -iws[N - i - 1];
		      iws[N - i - 1] = -t;
		    }
		  };

		  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
		    var carry = 0;
		    for (var i = 0; i < N / 2; i++) {
		      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
		        Math.round(ws[2 * i] / N) +
		        carry;

		      ws[i] = w & 0x3ffffff;

		      if (w < 0x4000000) {
		        carry = 0;
		      } else {
		        carry = w / 0x4000000 | 0;
		      }
		    }

		    return ws;
		  };

		  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
		    var carry = 0;
		    for (var i = 0; i < len; i++) {
		      carry = carry + (ws[i] | 0);

		      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
		      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
		    }

		    // Pad with zeroes
		    for (i = 2 * len; i < N; ++i) {
		      rws[i] = 0;
		    }

		    assert(carry === 0);
		    assert((carry & ~0x1fff) === 0);
		  };

		  FFTM.prototype.stub = function stub (N) {
		    var ph = new Array(N);
		    for (var i = 0; i < N; i++) {
		      ph[i] = 0;
		    }

		    return ph;
		  };

		  FFTM.prototype.mulp = function mulp (x, y, out) {
		    var N = 2 * this.guessLen13b(x.length, y.length);

		    var rbt = this.makeRBT(N);

		    var _ = this.stub(N);

		    var rws = new Array(N);
		    var rwst = new Array(N);
		    var iwst = new Array(N);

		    var nrws = new Array(N);
		    var nrwst = new Array(N);
		    var niwst = new Array(N);

		    var rmws = out.words;
		    rmws.length = N;

		    this.convert13b(x.words, x.length, rws, N);
		    this.convert13b(y.words, y.length, nrws, N);

		    this.transform(rws, _, rwst, iwst, N, rbt);
		    this.transform(nrws, _, nrwst, niwst, N, rbt);

		    for (var i = 0; i < N; i++) {
		      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
		      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
		      rwst[i] = rx;
		    }

		    this.conjugate(rwst, iwst, N);
		    this.transform(rwst, iwst, rmws, _, N, rbt);
		    this.conjugate(rmws, _, N);
		    this.normalize13b(rmws, N);

		    out.negative = x.negative ^ y.negative;
		    out.length = x.length + y.length;
		    return out.strip();
		  };

		  // Multiply `this` by `num`
		  BN.prototype.mul = function mul (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return this.mulTo(num, out);
		  };

		  // Multiply employing FFT
		  BN.prototype.mulf = function mulf (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return jumboMulTo(this, num, out);
		  };

		  // In-place Multiplication
		  BN.prototype.imul = function imul (num) {
		    return this.clone().mulTo(num, this);
		  };

		  BN.prototype.imuln = function imuln (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);

		    // Carry
		    var carry = 0;
		    for (var i = 0; i < this.length; i++) {
		      var w = (this.words[i] | 0) * num;
		      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
		      carry >>= 26;
		      carry += (w / 0x4000000) | 0;
		      // NOTE: lo is 27bit maximum
		      carry += lo >>> 26;
		      this.words[i] = lo & 0x3ffffff;
		    }

		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }

		    return this;
		  };

		  BN.prototype.muln = function muln (num) {
		    return this.clone().imuln(num);
		  };

		  // `this` * `this`
		  BN.prototype.sqr = function sqr () {
		    return this.mul(this);
		  };

		  // `this` * `this` in-place
		  BN.prototype.isqr = function isqr () {
		    return this.imul(this.clone());
		  };

		  // Math.pow(`this`, `num`)
		  BN.prototype.pow = function pow (num) {
		    var w = toBitArray(num);
		    if (w.length === 0) return new BN(1);

		    // Skip leading zeroes
		    var res = this;
		    for (var i = 0; i < w.length; i++, res = res.sqr()) {
		      if (w[i] !== 0) break;
		    }

		    if (++i < w.length) {
		      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
		        if (w[i] === 0) continue;

		        res = res.mul(q);
		      }
		    }

		    return res;
		  };

		  // Shift-left in-place
		  BN.prototype.iushln = function iushln (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;
		    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
		    var i;

		    if (r !== 0) {
		      var carry = 0;

		      for (i = 0; i < this.length; i++) {
		        var newCarry = this.words[i] & carryMask;
		        var c = ((this.words[i] | 0) - newCarry) << r;
		        this.words[i] = c | carry;
		        carry = newCarry >>> (26 - r);
		      }

		      if (carry) {
		        this.words[i] = carry;
		        this.length++;
		      }
		    }

		    if (s !== 0) {
		      for (i = this.length - 1; i >= 0; i--) {
		        this.words[i + s] = this.words[i];
		      }

		      for (i = 0; i < s; i++) {
		        this.words[i] = 0;
		      }

		      this.length += s;
		    }

		    return this.strip();
		  };

		  BN.prototype.ishln = function ishln (bits) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushln(bits);
		  };

		  // Shift-right in-place
		  // NOTE: `hint` is a lowest bit before trailing zeroes
		  // NOTE: if `extended` is present - it will be filled with destroyed bits
		  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var h;
		    if (hint) {
		      h = (hint - (hint % 26)) / 26;
		    } else {
		      h = 0;
		    }

		    var r = bits % 26;
		    var s = Math.min((bits - r) / 26, this.length);
		    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		    var maskedWords = extended;

		    h -= s;
		    h = Math.max(0, h);

		    // Extended mode, copy masked part
		    if (maskedWords) {
		      for (var i = 0; i < s; i++) {
		        maskedWords.words[i] = this.words[i];
		      }
		      maskedWords.length = s;
		    }

		    if (s === 0) ; else if (this.length > s) {
		      this.length -= s;
		      for (i = 0; i < this.length; i++) {
		        this.words[i] = this.words[i + s];
		      }
		    } else {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    var carry = 0;
		    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
		      var word = this.words[i] | 0;
		      this.words[i] = (carry << (26 - r)) | (word >>> r);
		      carry = word & mask;
		    }

		    // Push carried bits as a mask
		    if (maskedWords && carry !== 0) {
		      maskedWords.words[maskedWords.length++] = carry;
		    }

		    if (this.length === 0) {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    return this.strip();
		  };

		  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushrn(bits, hint, extended);
		  };

		  // Shift-left
		  BN.prototype.shln = function shln (bits) {
		    return this.clone().ishln(bits);
		  };

		  BN.prototype.ushln = function ushln (bits) {
		    return this.clone().iushln(bits);
		  };

		  // Shift-right
		  BN.prototype.shrn = function shrn (bits) {
		    return this.clone().ishrn(bits);
		  };

		  BN.prototype.ushrn = function ushrn (bits) {
		    return this.clone().iushrn(bits);
		  };

		  // Test if n bit is set
		  BN.prototype.testn = function testn (bit) {
		    assert(typeof bit === 'number' && bit >= 0);
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) return false;

		    // Check bit and return
		    var w = this.words[s];

		    return !!(w & q);
		  };

		  // Return only lowers bits of number (in-place)
		  BN.prototype.imaskn = function imaskn (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;

		    assert(this.negative === 0, 'imaskn works only with positive numbers');

		    if (this.length <= s) {
		      return this;
		    }

		    if (r !== 0) {
		      s++;
		    }
		    this.length = Math.min(s, this.length);

		    if (r !== 0) {
		      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		      this.words[this.length - 1] &= mask;
		    }

		    return this.strip();
		  };

		  // Return only lowers bits of number
		  BN.prototype.maskn = function maskn (bits) {
		    return this.clone().imaskn(bits);
		  };

		  // Add plain number `num` to `this`
		  BN.prototype.iaddn = function iaddn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.isubn(-num);

		    // Possible sign change
		    if (this.negative !== 0) {
		      if (this.length === 1 && (this.words[0] | 0) < num) {
		        this.words[0] = num - (this.words[0] | 0);
		        this.negative = 0;
		        return this;
		      }

		      this.negative = 0;
		      this.isubn(num);
		      this.negative = 1;
		      return this;
		    }

		    // Add without checks
		    return this._iaddn(num);
		  };

		  BN.prototype._iaddn = function _iaddn (num) {
		    this.words[0] += num;

		    // Carry
		    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
		      this.words[i] -= 0x4000000;
		      if (i === this.length - 1) {
		        this.words[i + 1] = 1;
		      } else {
		        this.words[i + 1]++;
		      }
		    }
		    this.length = Math.max(this.length, i + 1);

		    return this;
		  };

		  // Subtract plain number `num` from `this`
		  BN.prototype.isubn = function isubn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.iaddn(-num);

		    if (this.negative !== 0) {
		      this.negative = 0;
		      this.iaddn(num);
		      this.negative = 1;
		      return this;
		    }

		    this.words[0] -= num;

		    if (this.length === 1 && this.words[0] < 0) {
		      this.words[0] = -this.words[0];
		      this.negative = 1;
		    } else {
		      // Carry
		      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
		        this.words[i] += 0x4000000;
		        this.words[i + 1] -= 1;
		      }
		    }

		    return this.strip();
		  };

		  BN.prototype.addn = function addn (num) {
		    return this.clone().iaddn(num);
		  };

		  BN.prototype.subn = function subn (num) {
		    return this.clone().isubn(num);
		  };

		  BN.prototype.iabs = function iabs () {
		    this.negative = 0;

		    return this;
		  };

		  BN.prototype.abs = function abs () {
		    return this.clone().iabs();
		  };

		  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
		    var len = num.length + shift;
		    var i;

		    this._expand(len);

		    var w;
		    var carry = 0;
		    for (i = 0; i < num.length; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      var right = (num.words[i] | 0) * mul;
		      w -= right & 0x3ffffff;
		      carry = (w >> 26) - ((right / 0x4000000) | 0);
		      this.words[i + shift] = w & 0x3ffffff;
		    }
		    for (; i < this.length - shift; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      carry = w >> 26;
		      this.words[i + shift] = w & 0x3ffffff;
		    }

		    if (carry === 0) return this.strip();

		    // Subtraction overflow
		    assert(carry === -1);
		    carry = 0;
		    for (i = 0; i < this.length; i++) {
		      w = -(this.words[i] | 0) + carry;
		      carry = w >> 26;
		      this.words[i] = w & 0x3ffffff;
		    }
		    this.negative = 1;

		    return this.strip();
		  };

		  BN.prototype._wordDiv = function _wordDiv (num, mode) {
		    var shift = this.length - num.length;

		    var a = this.clone();
		    var b = num;

		    // Normalize
		    var bhi = b.words[b.length - 1] | 0;
		    var bhiBits = this._countBits(bhi);
		    shift = 26 - bhiBits;
		    if (shift !== 0) {
		      b = b.ushln(shift);
		      a.iushln(shift);
		      bhi = b.words[b.length - 1] | 0;
		    }

		    // Initialize quotient
		    var m = a.length - b.length;
		    var q;

		    if (mode !== 'mod') {
		      q = new BN(null);
		      q.length = m + 1;
		      q.words = new Array(q.length);
		      for (var i = 0; i < q.length; i++) {
		        q.words[i] = 0;
		      }
		    }

		    var diff = a.clone()._ishlnsubmul(b, 1, m);
		    if (diff.negative === 0) {
		      a = diff;
		      if (q) {
		        q.words[m] = 1;
		      }
		    }

		    for (var j = m - 1; j >= 0; j--) {
		      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
		        (a.words[b.length + j - 1] | 0);

		      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
		      // (0x7ffffff)
		      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

		      a._ishlnsubmul(b, qj, j);
		      while (a.negative !== 0) {
		        qj--;
		        a.negative = 0;
		        a._ishlnsubmul(b, 1, j);
		        if (!a.isZero()) {
		          a.negative ^= 1;
		        }
		      }
		      if (q) {
		        q.words[j] = qj;
		      }
		    }
		    if (q) {
		      q.strip();
		    }
		    a.strip();

		    // Denormalize
		    if (mode !== 'div' && shift !== 0) {
		      a.iushrn(shift);
		    }

		    return {
		      div: q || null,
		      mod: a
		    };
		  };

		  // NOTE: 1) `mode` can be set to `mod` to request mod only,
		  //       to `div` to request div only, or be absent to
		  //       request both div & mod
		  //       2) `positive` is true if unsigned mod is requested
		  BN.prototype.divmod = function divmod (num, mode, positive) {
		    assert(!num.isZero());

		    if (this.isZero()) {
		      return {
		        div: new BN(0),
		        mod: new BN(0)
		      };
		    }

		    var div, mod, res;
		    if (this.negative !== 0 && num.negative === 0) {
		      res = this.neg().divmod(num, mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.iadd(num);
		        }
		      }

		      return {
		        div: div,
		        mod: mod
		      };
		    }

		    if (this.negative === 0 && num.negative !== 0) {
		      res = this.divmod(num.neg(), mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      return {
		        div: div,
		        mod: res.mod
		      };
		    }

		    if ((this.negative & num.negative) !== 0) {
		      res = this.neg().divmod(num.neg(), mode);

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.isub(num);
		        }
		      }

		      return {
		        div: res.div,
		        mod: mod
		      };
		    }

		    // Both numbers are positive at this point

		    // Strip both numbers to approximate shift value
		    if (num.length > this.length || this.cmp(num) < 0) {
		      return {
		        div: new BN(0),
		        mod: this
		      };
		    }

		    // Very short reduction
		    if (num.length === 1) {
		      if (mode === 'div') {
		        return {
		          div: this.divn(num.words[0]),
		          mod: null
		        };
		      }

		      if (mode === 'mod') {
		        return {
		          div: null,
		          mod: new BN(this.modn(num.words[0]))
		        };
		      }

		      return {
		        div: this.divn(num.words[0]),
		        mod: new BN(this.modn(num.words[0]))
		      };
		    }

		    return this._wordDiv(num, mode);
		  };

		  // Find `this` / `num`
		  BN.prototype.div = function div (num) {
		    return this.divmod(num, 'div', false).div;
		  };

		  // Find `this` % `num`
		  BN.prototype.mod = function mod (num) {
		    return this.divmod(num, 'mod', false).mod;
		  };

		  BN.prototype.umod = function umod (num) {
		    return this.divmod(num, 'mod', true).mod;
		  };

		  // Find Round(`this` / `num`)
		  BN.prototype.divRound = function divRound (num) {
		    var dm = this.divmod(num);

		    // Fast case - exact division
		    if (dm.mod.isZero()) return dm.div;

		    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

		    var half = num.ushrn(1);
		    var r2 = num.andln(1);
		    var cmp = mod.cmp(half);

		    // Round down
		    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

		    // Round up
		    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
		  };

		  BN.prototype.modn = function modn (num) {
		    assert(num <= 0x3ffffff);
		    var p = (1 << 26) % num;

		    var acc = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      acc = (p * acc + (this.words[i] | 0)) % num;
		    }

		    return acc;
		  };

		  // In-place division by number
		  BN.prototype.idivn = function idivn (num) {
		    assert(num <= 0x3ffffff);

		    var carry = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var w = (this.words[i] | 0) + carry * 0x4000000;
		      this.words[i] = (w / num) | 0;
		      carry = w % num;
		    }

		    return this.strip();
		  };

		  BN.prototype.divn = function divn (num) {
		    return this.clone().idivn(num);
		  };

		  BN.prototype.egcd = function egcd (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var x = this;
		    var y = p.clone();

		    if (x.negative !== 0) {
		      x = x.umod(p);
		    } else {
		      x = x.clone();
		    }

		    // A * x + B * y = x
		    var A = new BN(1);
		    var B = new BN(0);

		    // C * x + D * y = y
		    var C = new BN(0);
		    var D = new BN(1);

		    var g = 0;

		    while (x.isEven() && y.isEven()) {
		      x.iushrn(1);
		      y.iushrn(1);
		      ++g;
		    }

		    var yp = y.clone();
		    var xp = x.clone();

		    while (!x.isZero()) {
		      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        x.iushrn(i);
		        while (i-- > 0) {
		          if (A.isOdd() || B.isOdd()) {
		            A.iadd(yp);
		            B.isub(xp);
		          }

		          A.iushrn(1);
		          B.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        y.iushrn(j);
		        while (j-- > 0) {
		          if (C.isOdd() || D.isOdd()) {
		            C.iadd(yp);
		            D.isub(xp);
		          }

		          C.iushrn(1);
		          D.iushrn(1);
		        }
		      }

		      if (x.cmp(y) >= 0) {
		        x.isub(y);
		        A.isub(C);
		        B.isub(D);
		      } else {
		        y.isub(x);
		        C.isub(A);
		        D.isub(B);
		      }
		    }

		    return {
		      a: C,
		      b: D,
		      gcd: y.iushln(g)
		    };
		  };

		  // This is reduced incarnation of the binary EEA
		  // above, designated to invert members of the
		  // _prime_ fields F(p) at a maximal speed
		  BN.prototype._invmp = function _invmp (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var a = this;
		    var b = p.clone();

		    if (a.negative !== 0) {
		      a = a.umod(p);
		    } else {
		      a = a.clone();
		    }

		    var x1 = new BN(1);
		    var x2 = new BN(0);

		    var delta = b.clone();

		    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
		      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        a.iushrn(i);
		        while (i-- > 0) {
		          if (x1.isOdd()) {
		            x1.iadd(delta);
		          }

		          x1.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        b.iushrn(j);
		        while (j-- > 0) {
		          if (x2.isOdd()) {
		            x2.iadd(delta);
		          }

		          x2.iushrn(1);
		        }
		      }

		      if (a.cmp(b) >= 0) {
		        a.isub(b);
		        x1.isub(x2);
		      } else {
		        b.isub(a);
		        x2.isub(x1);
		      }
		    }

		    var res;
		    if (a.cmpn(1) === 0) {
		      res = x1;
		    } else {
		      res = x2;
		    }

		    if (res.cmpn(0) < 0) {
		      res.iadd(p);
		    }

		    return res;
		  };

		  BN.prototype.gcd = function gcd (num) {
		    if (this.isZero()) return num.abs();
		    if (num.isZero()) return this.abs();

		    var a = this.clone();
		    var b = num.clone();
		    a.negative = 0;
		    b.negative = 0;

		    // Remove common factor of two
		    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
		      a.iushrn(1);
		      b.iushrn(1);
		    }

		    do {
		      while (a.isEven()) {
		        a.iushrn(1);
		      }
		      while (b.isEven()) {
		        b.iushrn(1);
		      }

		      var r = a.cmp(b);
		      if (r < 0) {
		        // Swap `a` and `b` to make `a` always bigger than `b`
		        var t = a;
		        a = b;
		        b = t;
		      } else if (r === 0 || b.cmpn(1) === 0) {
		        break;
		      }

		      a.isub(b);
		    } while (true);

		    return b.iushln(shift);
		  };

		  // Invert number in the field F(num)
		  BN.prototype.invm = function invm (num) {
		    return this.egcd(num).a.umod(num);
		  };

		  BN.prototype.isEven = function isEven () {
		    return (this.words[0] & 1) === 0;
		  };

		  BN.prototype.isOdd = function isOdd () {
		    return (this.words[0] & 1) === 1;
		  };

		  // And first word and num
		  BN.prototype.andln = function andln (num) {
		    return this.words[0] & num;
		  };

		  // Increment at the bit position in-line
		  BN.prototype.bincn = function bincn (bit) {
		    assert(typeof bit === 'number');
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) {
		      this._expand(s + 1);
		      this.words[s] |= q;
		      return this;
		    }

		    // Add bit and propagate, if needed
		    var carry = q;
		    for (var i = s; carry !== 0 && i < this.length; i++) {
		      var w = this.words[i] | 0;
		      w += carry;
		      carry = w >>> 26;
		      w &= 0x3ffffff;
		      this.words[i] = w;
		    }
		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }
		    return this;
		  };

		  BN.prototype.isZero = function isZero () {
		    return this.length === 1 && this.words[0] === 0;
		  };

		  BN.prototype.cmpn = function cmpn (num) {
		    var negative = num < 0;

		    if (this.negative !== 0 && !negative) return -1;
		    if (this.negative === 0 && negative) return 1;

		    this.strip();

		    var res;
		    if (this.length > 1) {
		      res = 1;
		    } else {
		      if (negative) {
		        num = -num;
		      }

		      assert(num <= 0x3ffffff, 'Number is too big');

		      var w = this.words[0] | 0;
		      res = w === num ? 0 : w < num ? -1 : 1;
		    }
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Compare two numbers and return:
		  // 1 - if `this` > `num`
		  // 0 - if `this` == `num`
		  // -1 - if `this` < `num`
		  BN.prototype.cmp = function cmp (num) {
		    if (this.negative !== 0 && num.negative === 0) return -1;
		    if (this.negative === 0 && num.negative !== 0) return 1;

		    var res = this.ucmp(num);
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Unsigned comparison
		  BN.prototype.ucmp = function ucmp (num) {
		    // At this point both numbers have the same sign
		    if (this.length > num.length) return 1;
		    if (this.length < num.length) return -1;

		    var res = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var a = this.words[i] | 0;
		      var b = num.words[i] | 0;

		      if (a === b) continue;
		      if (a < b) {
		        res = -1;
		      } else if (a > b) {
		        res = 1;
		      }
		      break;
		    }
		    return res;
		  };

		  BN.prototype.gtn = function gtn (num) {
		    return this.cmpn(num) === 1;
		  };

		  BN.prototype.gt = function gt (num) {
		    return this.cmp(num) === 1;
		  };

		  BN.prototype.gten = function gten (num) {
		    return this.cmpn(num) >= 0;
		  };

		  BN.prototype.gte = function gte (num) {
		    return this.cmp(num) >= 0;
		  };

		  BN.prototype.ltn = function ltn (num) {
		    return this.cmpn(num) === -1;
		  };

		  BN.prototype.lt = function lt (num) {
		    return this.cmp(num) === -1;
		  };

		  BN.prototype.lten = function lten (num) {
		    return this.cmpn(num) <= 0;
		  };

		  BN.prototype.lte = function lte (num) {
		    return this.cmp(num) <= 0;
		  };

		  BN.prototype.eqn = function eqn (num) {
		    return this.cmpn(num) === 0;
		  };

		  BN.prototype.eq = function eq (num) {
		    return this.cmp(num) === 0;
		  };

		  //
		  // A reduce context, could be using montgomery or something better, depending
		  // on the `m` itself.
		  //
		  BN.red = function red (num) {
		    return new Red(num);
		  };

		  BN.prototype.toRed = function toRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    assert(this.negative === 0, 'red works only with positives');
		    return ctx.convertTo(this)._forceRed(ctx);
		  };

		  BN.prototype.fromRed = function fromRed () {
		    assert(this.red, 'fromRed works only with numbers in reduction context');
		    return this.red.convertFrom(this);
		  };

		  BN.prototype._forceRed = function _forceRed (ctx) {
		    this.red = ctx;
		    return this;
		  };

		  BN.prototype.forceRed = function forceRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    return this._forceRed(ctx);
		  };

		  BN.prototype.redAdd = function redAdd (num) {
		    assert(this.red, 'redAdd works only with red numbers');
		    return this.red.add(this, num);
		  };

		  BN.prototype.redIAdd = function redIAdd (num) {
		    assert(this.red, 'redIAdd works only with red numbers');
		    return this.red.iadd(this, num);
		  };

		  BN.prototype.redSub = function redSub (num) {
		    assert(this.red, 'redSub works only with red numbers');
		    return this.red.sub(this, num);
		  };

		  BN.prototype.redISub = function redISub (num) {
		    assert(this.red, 'redISub works only with red numbers');
		    return this.red.isub(this, num);
		  };

		  BN.prototype.redShl = function redShl (num) {
		    assert(this.red, 'redShl works only with red numbers');
		    return this.red.shl(this, num);
		  };

		  BN.prototype.redMul = function redMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.mul(this, num);
		  };

		  BN.prototype.redIMul = function redIMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.imul(this, num);
		  };

		  BN.prototype.redSqr = function redSqr () {
		    assert(this.red, 'redSqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqr(this);
		  };

		  BN.prototype.redISqr = function redISqr () {
		    assert(this.red, 'redISqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.isqr(this);
		  };

		  // Square root over p
		  BN.prototype.redSqrt = function redSqrt () {
		    assert(this.red, 'redSqrt works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqrt(this);
		  };

		  BN.prototype.redInvm = function redInvm () {
		    assert(this.red, 'redInvm works only with red numbers');
		    this.red._verify1(this);
		    return this.red.invm(this);
		  };

		  // Return negative clone of `this` % `red modulo`
		  BN.prototype.redNeg = function redNeg () {
		    assert(this.red, 'redNeg works only with red numbers');
		    this.red._verify1(this);
		    return this.red.neg(this);
		  };

		  BN.prototype.redPow = function redPow (num) {
		    assert(this.red && !num.red, 'redPow(normalNum)');
		    this.red._verify1(this);
		    return this.red.pow(this, num);
		  };

		  // Prime numbers with efficient reduction
		  var primes = {
		    k256: null,
		    p224: null,
		    p192: null,
		    p25519: null
		  };

		  // Pseudo-Mersenne prime
		  function MPrime (name, p) {
		    // P = 2 ^ N - K
		    this.name = name;
		    this.p = new BN(p, 16);
		    this.n = this.p.bitLength();
		    this.k = new BN(1).iushln(this.n).isub(this.p);

		    this.tmp = this._tmp();
		  }

		  MPrime.prototype._tmp = function _tmp () {
		    var tmp = new BN(null);
		    tmp.words = new Array(Math.ceil(this.n / 13));
		    return tmp;
		  };

		  MPrime.prototype.ireduce = function ireduce (num) {
		    // Assumes that `num` is less than `P^2`
		    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
		    var r = num;
		    var rlen;

		    do {
		      this.split(r, this.tmp);
		      r = this.imulK(r);
		      r = r.iadd(this.tmp);
		      rlen = r.bitLength();
		    } while (rlen > this.n);

		    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
		    if (cmp === 0) {
		      r.words[0] = 0;
		      r.length = 1;
		    } else if (cmp > 0) {
		      r.isub(this.p);
		    } else {
		      if (r.strip !== undefined) {
		        // r is BN v4 instance
		        r.strip();
		      } else {
		        // r is BN v5 instance
		        r._strip();
		      }
		    }

		    return r;
		  };

		  MPrime.prototype.split = function split (input, out) {
		    input.iushrn(this.n, 0, out);
		  };

		  MPrime.prototype.imulK = function imulK (num) {
		    return num.imul(this.k);
		  };

		  function K256 () {
		    MPrime.call(
		      this,
		      'k256',
		      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
		  }
		  inherits(K256, MPrime);

		  K256.prototype.split = function split (input, output) {
		    // 256 = 9 * 26 + 22
		    var mask = 0x3fffff;

		    var outLen = Math.min(input.length, 9);
		    for (var i = 0; i < outLen; i++) {
		      output.words[i] = input.words[i];
		    }
		    output.length = outLen;

		    if (input.length <= 9) {
		      input.words[0] = 0;
		      input.length = 1;
		      return;
		    }

		    // Shift by 9 limbs
		    var prev = input.words[9];
		    output.words[output.length++] = prev & mask;

		    for (i = 10; i < input.length; i++) {
		      var next = input.words[i] | 0;
		      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
		      prev = next;
		    }
		    prev >>>= 22;
		    input.words[i - 10] = prev;
		    if (prev === 0 && input.length > 10) {
		      input.length -= 10;
		    } else {
		      input.length -= 9;
		    }
		  };

		  K256.prototype.imulK = function imulK (num) {
		    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
		    num.words[num.length] = 0;
		    num.words[num.length + 1] = 0;
		    num.length += 2;

		    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
		    var lo = 0;
		    for (var i = 0; i < num.length; i++) {
		      var w = num.words[i] | 0;
		      lo += w * 0x3d1;
		      num.words[i] = lo & 0x3ffffff;
		      lo = w * 0x40 + ((lo / 0x4000000) | 0);
		    }

		    // Fast length reduction
		    if (num.words[num.length - 1] === 0) {
		      num.length--;
		      if (num.words[num.length - 1] === 0) {
		        num.length--;
		      }
		    }
		    return num;
		  };

		  function P224 () {
		    MPrime.call(
		      this,
		      'p224',
		      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
		  }
		  inherits(P224, MPrime);

		  function P192 () {
		    MPrime.call(
		      this,
		      'p192',
		      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
		  }
		  inherits(P192, MPrime);

		  function P25519 () {
		    // 2 ^ 255 - 19
		    MPrime.call(
		      this,
		      '25519',
		      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
		  }
		  inherits(P25519, MPrime);

		  P25519.prototype.imulK = function imulK (num) {
		    // K = 0x13
		    var carry = 0;
		    for (var i = 0; i < num.length; i++) {
		      var hi = (num.words[i] | 0) * 0x13 + carry;
		      var lo = hi & 0x3ffffff;
		      hi >>>= 26;

		      num.words[i] = lo;
		      carry = hi;
		    }
		    if (carry !== 0) {
		      num.words[num.length++] = carry;
		    }
		    return num;
		  };

		  // Exported mostly for testing purposes, use plain name instead
		  BN._prime = function prime (name) {
		    // Cached version of prime
		    if (primes[name]) return primes[name];

		    var prime;
		    if (name === 'k256') {
		      prime = new K256();
		    } else if (name === 'p224') {
		      prime = new P224();
		    } else if (name === 'p192') {
		      prime = new P192();
		    } else if (name === 'p25519') {
		      prime = new P25519();
		    } else {
		      throw new Error('Unknown prime ' + name);
		    }
		    primes[name] = prime;

		    return prime;
		  };

		  //
		  // Base reduction engine
		  //
		  function Red (m) {
		    if (typeof m === 'string') {
		      var prime = BN._prime(m);
		      this.m = prime.p;
		      this.prime = prime;
		    } else {
		      assert(m.gtn(1), 'modulus must be greater than 1');
		      this.m = m;
		      this.prime = null;
		    }
		  }

		  Red.prototype._verify1 = function _verify1 (a) {
		    assert(a.negative === 0, 'red works only with positives');
		    assert(a.red, 'red works only with red numbers');
		  };

		  Red.prototype._verify2 = function _verify2 (a, b) {
		    assert((a.negative | b.negative) === 0, 'red works only with positives');
		    assert(a.red && a.red === b.red,
		      'red works only with red numbers');
		  };

		  Red.prototype.imod = function imod (a) {
		    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
		    return a.umod(this.m)._forceRed(this);
		  };

		  Red.prototype.neg = function neg (a) {
		    if (a.isZero()) {
		      return a.clone();
		    }

		    return this.m.sub(a)._forceRed(this);
		  };

		  Red.prototype.add = function add (a, b) {
		    this._verify2(a, b);

		    var res = a.add(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.iadd = function iadd (a, b) {
		    this._verify2(a, b);

		    var res = a.iadd(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res;
		  };

		  Red.prototype.sub = function sub (a, b) {
		    this._verify2(a, b);

		    var res = a.sub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.isub = function isub (a, b) {
		    this._verify2(a, b);

		    var res = a.isub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res;
		  };

		  Red.prototype.shl = function shl (a, num) {
		    this._verify1(a);
		    return this.imod(a.ushln(num));
		  };

		  Red.prototype.imul = function imul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.imul(b));
		  };

		  Red.prototype.mul = function mul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.mul(b));
		  };

		  Red.prototype.isqr = function isqr (a) {
		    return this.imul(a, a.clone());
		  };

		  Red.prototype.sqr = function sqr (a) {
		    return this.mul(a, a);
		  };

		  Red.prototype.sqrt = function sqrt (a) {
		    if (a.isZero()) return a.clone();

		    var mod3 = this.m.andln(3);
		    assert(mod3 % 2 === 1);

		    // Fast case
		    if (mod3 === 3) {
		      var pow = this.m.add(new BN(1)).iushrn(2);
		      return this.pow(a, pow);
		    }

		    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
		    //
		    // Find Q and S, that Q * 2 ^ S = (P - 1)
		    var q = this.m.subn(1);
		    var s = 0;
		    while (!q.isZero() && q.andln(1) === 0) {
		      s++;
		      q.iushrn(1);
		    }
		    assert(!q.isZero());

		    var one = new BN(1).toRed(this);
		    var nOne = one.redNeg();

		    // Find quadratic non-residue
		    // NOTE: Max is such because of generalized Riemann hypothesis.
		    var lpow = this.m.subn(1).iushrn(1);
		    var z = this.m.bitLength();
		    z = new BN(2 * z * z).toRed(this);

		    while (this.pow(z, lpow).cmp(nOne) !== 0) {
		      z.redIAdd(nOne);
		    }

		    var c = this.pow(z, q);
		    var r = this.pow(a, q.addn(1).iushrn(1));
		    var t = this.pow(a, q);
		    var m = s;
		    while (t.cmp(one) !== 0) {
		      var tmp = t;
		      for (var i = 0; tmp.cmp(one) !== 0; i++) {
		        tmp = tmp.redSqr();
		      }
		      assert(i < m);
		      var b = this.pow(c, new BN(1).iushln(m - i - 1));

		      r = r.redMul(b);
		      c = b.redSqr();
		      t = t.redMul(c);
		      m = i;
		    }

		    return r;
		  };

		  Red.prototype.invm = function invm (a) {
		    var inv = a._invmp(this.m);
		    if (inv.negative !== 0) {
		      inv.negative = 0;
		      return this.imod(inv).redNeg();
		    } else {
		      return this.imod(inv);
		    }
		  };

		  Red.prototype.pow = function pow (a, num) {
		    if (num.isZero()) return new BN(1).toRed(this);
		    if (num.cmpn(1) === 0) return a.clone();

		    var windowSize = 4;
		    var wnd = new Array(1 << windowSize);
		    wnd[0] = new BN(1).toRed(this);
		    wnd[1] = a;
		    for (var i = 2; i < wnd.length; i++) {
		      wnd[i] = this.mul(wnd[i - 1], a);
		    }

		    var res = wnd[0];
		    var current = 0;
		    var currentLen = 0;
		    var start = num.bitLength() % 26;
		    if (start === 0) {
		      start = 26;
		    }

		    for (i = num.length - 1; i >= 0; i--) {
		      var word = num.words[i];
		      for (var j = start - 1; j >= 0; j--) {
		        var bit = (word >> j) & 1;
		        if (res !== wnd[0]) {
		          res = this.sqr(res);
		        }

		        if (bit === 0 && current === 0) {
		          currentLen = 0;
		          continue;
		        }

		        current <<= 1;
		        current |= bit;
		        currentLen++;
		        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

		        res = this.mul(res, wnd[current]);
		        currentLen = 0;
		        current = 0;
		      }
		      start = 26;
		    }

		    return res;
		  };

		  Red.prototype.convertTo = function convertTo (num) {
		    var r = num.umod(this.m);

		    return r === num ? r.clone() : r;
		  };

		  Red.prototype.convertFrom = function convertFrom (num) {
		    var res = num.clone();
		    res.red = null;
		    return res;
		  };

		  //
		  // Montgomery method engine
		  //

		  BN.mont = function mont (num) {
		    return new Mont(num);
		  };

		  function Mont (m) {
		    Red.call(this, m);

		    this.shift = this.m.bitLength();
		    if (this.shift % 26 !== 0) {
		      this.shift += 26 - (this.shift % 26);
		    }

		    this.r = new BN(1).iushln(this.shift);
		    this.r2 = this.imod(this.r.sqr());
		    this.rinv = this.r._invmp(this.m);

		    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
		    this.minv = this.minv.umod(this.r);
		    this.minv = this.r.sub(this.minv);
		  }
		  inherits(Mont, Red);

		  Mont.prototype.convertTo = function convertTo (num) {
		    return this.imod(num.ushln(this.shift));
		  };

		  Mont.prototype.convertFrom = function convertFrom (num) {
		    var r = this.imod(num.mul(this.rinv));
		    r.red = null;
		    return r;
		  };

		  Mont.prototype.imul = function imul (a, b) {
		    if (a.isZero() || b.isZero()) {
		      a.words[0] = 0;
		      a.length = 1;
		      return a;
		    }

		    var t = a.imul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;

		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.mul = function mul (a, b) {
		    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

		    var t = a.mul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;
		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.invm = function invm (a) {
		    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
		    var res = this.imod(a._invmp(this.m).mul(this.r2));
		    return res._forceRed(this);
		  };
		})(module, bn$4); 
	} (bn$5));
	return bn$5.exports;
}

var brorand = {exports: {}};

var hasRequiredBrorand;

function requireBrorand () {
	if (hasRequiredBrorand) return brorand.exports;
	hasRequiredBrorand = 1;
	var r;

	brorand.exports = function rand(len) {
	  if (!r)
	    r = new Rand(null);

	  return r.generate(len);
	};

	function Rand(rand) {
	  this.rand = rand;
	}
	brorand.exports.Rand = Rand;

	Rand.prototype.generate = function generate(len) {
	  return this._rand(len);
	};

	// Emulate crypto API using randy
	Rand.prototype._rand = function _rand(n) {
	  if (this.rand.getBytes)
	    return this.rand.getBytes(n);

	  var res = new Uint8Array(n);
	  for (var i = 0; i < res.length; i++)
	    res[i] = this.rand.getByte();
	  return res;
	};

	if (typeof self === 'object') {
	  if (self.crypto && self.crypto.getRandomValues) {
	    // Modern browsers
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      self.crypto.getRandomValues(arr);
	      return arr;
	    };
	  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
	    // IE
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      self.msCrypto.getRandomValues(arr);
	      return arr;
	    };

	  // Safari's WebWorkers do not have `crypto`
	  } else if (typeof window === 'object') {
	    // Old junk
	    Rand.prototype._rand = function() {
	      throw new Error('Not implemented yet');
	    };
	  }
	} else {
	  // Node.js or Web worker with no crypto support
	  try {
	    var crypto = /*@__PURE__*/ requireCryptoBrowserify();
	    if (typeof crypto.randomBytes !== 'function')
	      throw new Error('Not supported');

	    Rand.prototype._rand = function _rand(n) {
	      return crypto.randomBytes(n);
	    };
	  } catch (e) {
	  }
	}
	return brorand.exports;
}

var mr;
var hasRequiredMr;

function requireMr () {
	if (hasRequiredMr) return mr;
	hasRequiredMr = 1;
	var bn = requireBn$2();
	var brorand = requireBrorand();

	function MillerRabin(rand) {
	  this.rand = rand || new brorand.Rand();
	}
	mr = MillerRabin;

	MillerRabin.create = function create(rand) {
	  return new MillerRabin(rand);
	};

	MillerRabin.prototype._randbelow = function _randbelow(n) {
	  var len = n.bitLength();
	  var min_bytes = Math.ceil(len / 8);

	  // Generage random bytes until a number less than n is found.
	  // This ensures that 0..n-1 have an equal probability of being selected.
	  do
	    var a = new bn(this.rand.generate(min_bytes));
	  while (a.cmp(n) >= 0);

	  return a;
	};

	MillerRabin.prototype._randrange = function _randrange(start, stop) {
	  // Generate a random number greater than or equal to start and less than stop.
	  var size = stop.sub(start);
	  return start.add(this._randbelow(size));
	};

	MillerRabin.prototype.test = function test(n, k, cb) {
	  var len = n.bitLength();
	  var red = bn.mont(n);
	  var rone = new bn(1).toRed(red);

	  if (!k)
	    k = Math.max(1, (len / 48) | 0);

	  // Find d and s, (n - 1) = (2 ^ s) * d;
	  var n1 = n.subn(1);
	  for (var s = 0; !n1.testn(s); s++) {}
	  var d = n.shrn(s);

	  var rn1 = n1.toRed(red);

	  var prime = true;
	  for (; k > 0; k--) {
	    var a = this._randrange(new bn(2), n1);
	    if (cb)
	      cb(a);

	    var x = a.toRed(red).redPow(d);
	    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
	      continue;

	    for (var i = 1; i < s; i++) {
	      x = x.redSqr();

	      if (x.cmp(rone) === 0)
	        return false;
	      if (x.cmp(rn1) === 0)
	        break;
	    }

	    if (i === s)
	      return false;
	  }

	  return prime;
	};

	MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
	  var len = n.bitLength();
	  var red = bn.mont(n);
	  var rone = new bn(1).toRed(red);

	  if (!k)
	    k = Math.max(1, (len / 48) | 0);

	  // Find d and s, (n - 1) = (2 ^ s) * d;
	  var n1 = n.subn(1);
	  for (var s = 0; !n1.testn(s); s++) {}
	  var d = n.shrn(s);

	  var rn1 = n1.toRed(red);

	  for (; k > 0; k--) {
	    var a = this._randrange(new bn(2), n1);

	    var g = n.gcd(a);
	    if (g.cmpn(1) !== 0)
	      return g;

	    var x = a.toRed(red).redPow(d);
	    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
	      continue;

	    for (var i = 1; i < s; i++) {
	      x = x.redSqr();

	      if (x.cmp(rone) === 0)
	        return x.fromRed().subn(1).gcd(n);
	      if (x.cmp(rn1) === 0)
	        break;
	    }

	    if (i === s) {
	      x = x.redSqr();
	      return x.fromRed().subn(1).gcd(n);
	    }
	  }

	  return false;
	};
	return mr;
}

var generatePrime;
var hasRequiredGeneratePrime;

function requireGeneratePrime () {
	if (hasRequiredGeneratePrime) return generatePrime;
	hasRequiredGeneratePrime = 1;
	var randomBytes = requireBrowser$b();
	generatePrime = findPrime;
	findPrime.simpleSieve = simpleSieve;
	findPrime.fermatTest = fermatTest;
	var BN = requireBn$2();
	var TWENTYFOUR = new BN(24);
	var MillerRabin = requireMr();
	var millerRabin = new MillerRabin();
	var ONE = new BN(1);
	var TWO = new BN(2);
	var FIVE = new BN(5);
	new BN(16);
	new BN(8);
	var TEN = new BN(10);
	var THREE = new BN(3);
	new BN(7);
	var ELEVEN = new BN(11);
	var FOUR = new BN(4);
	new BN(12);
	var primes = null;

	function _getPrimes() {
	  if (primes !== null)
	    return primes;

	  var limit = 0x100000;
	  var res = [];
	  res[0] = 2;
	  for (var i = 1, k = 3; k < limit; k += 2) {
	    var sqrt = Math.ceil(Math.sqrt(k));
	    for (var j = 0; j < i && res[j] <= sqrt; j++)
	      if (k % res[j] === 0)
	        break;

	    if (i !== j && res[j] <= sqrt)
	      continue;

	    res[i++] = k;
	  }
	  primes = res;
	  return res;
	}

	function simpleSieve(p) {
	  var primes = _getPrimes();

	  for (var i = 0; i < primes.length; i++)
	    if (p.modn(primes[i]) === 0) {
	      if (p.cmpn(primes[i]) === 0) {
	        return true;
	      } else {
	        return false;
	      }
	    }

	  return true;
	}

	function fermatTest(p) {
	  var red = BN.mont(p);
	  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
	}

	function findPrime(bits, gen) {
	  if (bits < 16) {
	    // this is what openssl does
	    if (gen === 2 || gen === 5) {
	      return new BN([0x8c, 0x7b]);
	    } else {
	      return new BN([0x8c, 0x27]);
	    }
	  }
	  gen = new BN(gen);

	  var num, n2;

	  while (true) {
	    num = new BN(randomBytes(Math.ceil(bits / 8)));
	    while (num.bitLength() > bits) {
	      num.ishrn(1);
	    }
	    if (num.isEven()) {
	      num.iadd(ONE);
	    }
	    if (!num.testn(1)) {
	      num.iadd(TWO);
	    }
	    if (!gen.cmp(TWO)) {
	      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
	        num.iadd(FOUR);
	      }
	    } else if (!gen.cmp(FIVE)) {
	      while (num.mod(TEN).cmp(THREE)) {
	        num.iadd(FOUR);
	      }
	    }
	    n2 = num.shrn(1);
	    if (simpleSieve(n2) && simpleSieve(num) &&
	      fermatTest(n2) && fermatTest(num) &&
	      millerRabin.test(n2) && millerRabin.test(num)) {
	      return num;
	    }
	  }

	}
	return generatePrime;
}

var modp1 = {
	gen: "02",
	prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
};
var modp2 = {
	gen: "02",
	prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
};
var modp5 = {
	gen: "02",
	prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
};
var modp14 = {
	gen: "02",
	prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
};
var modp15 = {
	gen: "02",
	prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
};
var modp16 = {
	gen: "02",
	prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
};
var modp17 = {
	gen: "02",
	prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
};
var modp18 = {
	gen: "02",
	prime: "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"
};
var require$$1$1 = {
	modp1: modp1,
	modp2: modp2,
	modp5: modp5,
	modp14: modp14,
	modp15: modp15,
	modp16: modp16,
	modp17: modp17,
	modp18: modp18
};

var dh;
var hasRequiredDh;

function requireDh () {
	if (hasRequiredDh) return dh;
	hasRequiredDh = 1;
	var BN = requireBn$2();
	var MillerRabin = requireMr();
	var millerRabin = new MillerRabin();
	var TWENTYFOUR = new BN(24);
	var ELEVEN = new BN(11);
	var TEN = new BN(10);
	var THREE = new BN(3);
	var SEVEN = new BN(7);
	var primes = requireGeneratePrime();
	var randomBytes = requireBrowser$b();
	dh = DH;

	function setPublicKey(pub, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(pub)) {
	    pub = new Buffer(pub, enc);
	  }
	  this._pub = new BN(pub);
	  return this;
	}

	function setPrivateKey(priv, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(priv)) {
	    priv = new Buffer(priv, enc);
	  }
	  this._priv = new BN(priv);
	  return this;
	}

	var primeCache = {};
	function checkPrime(prime, generator) {
	  var gen = generator.toString('hex');
	  var hex = [gen, prime.toString(16)].join('_');
	  if (hex in primeCache) {
	    return primeCache[hex];
	  }
	  var error = 0;

	  if (prime.isEven() ||
	    !primes.simpleSieve ||
	    !primes.fermatTest(prime) ||
	    !millerRabin.test(prime)) {
	    //not a prime so +1
	    error += 1;

	    if (gen === '02' || gen === '05') {
	      // we'd be able to check the generator
	      // it would fail so +8
	      error += 8;
	    } else {
	      //we wouldn't be able to test the generator
	      // so +4
	      error += 4;
	    }
	    primeCache[hex] = error;
	    return error;
	  }
	  if (!millerRabin.test(prime.shrn(1))) {
	    //not a safe prime
	    error += 2;
	  }
	  var rem;
	  switch (gen) {
	    case '02':
	      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
	        // unsuidable generator
	        error += 8;
	      }
	      break;
	    case '05':
	      rem = prime.mod(TEN);
	      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
	        // prime mod 10 needs to equal 3 or 7
	        error += 8;
	      }
	      break;
	    default:
	      error += 4;
	  }
	  primeCache[hex] = error;
	  return error;
	}

	function DH(prime, generator, malleable) {
	  this.setGenerator(generator);
	  this.__prime = new BN(prime);
	  this._prime = BN.mont(this.__prime);
	  this._primeLen = prime.length;
	  this._pub = undefined;
	  this._priv = undefined;
	  this._primeCode = undefined;
	  if (malleable) {
	    this.setPublicKey = setPublicKey;
	    this.setPrivateKey = setPrivateKey;
	  } else {
	    this._primeCode = 8;
	  }
	}
	Object.defineProperty(DH.prototype, 'verifyError', {
	  enumerable: true,
	  get: function () {
	    if (typeof this._primeCode !== 'number') {
	      this._primeCode = checkPrime(this.__prime, this.__gen);
	    }
	    return this._primeCode;
	  }
	});
	DH.prototype.generateKeys = function () {
	  if (!this._priv) {
	    this._priv = new BN(randomBytes(this._primeLen));
	  }
	  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
	  return this.getPublicKey();
	};

	DH.prototype.computeSecret = function (other) {
	  other = new BN(other);
	  other = other.toRed(this._prime);
	  var secret = other.redPow(this._priv).fromRed();
	  var out = new Buffer(secret.toArray());
	  var prime = this.getPrime();
	  if (out.length < prime.length) {
	    var front = new Buffer(prime.length - out.length);
	    front.fill(0);
	    out = Buffer.concat([front, out]);
	  }
	  return out;
	};

	DH.prototype.getPublicKey = function getPublicKey(enc) {
	  return formatReturnValue(this._pub, enc);
	};

	DH.prototype.getPrivateKey = function getPrivateKey(enc) {
	  return formatReturnValue(this._priv, enc);
	};

	DH.prototype.getPrime = function (enc) {
	  return formatReturnValue(this.__prime, enc);
	};

	DH.prototype.getGenerator = function (enc) {
	  return formatReturnValue(this._gen, enc);
	};

	DH.prototype.setGenerator = function (gen, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(gen)) {
	    gen = new Buffer(gen, enc);
	  }
	  this.__gen = gen;
	  this._gen = new BN(gen);
	  return this;
	};

	function formatReturnValue(bn, enc) {
	  var buf = new Buffer(bn.toArray());
	  if (!enc) {
	    return buf;
	  } else {
	    return buf.toString(enc);
	  }
	}
	return dh;
}

var hasRequiredBrowser$4;

function requireBrowser$4 () {
	if (hasRequiredBrowser$4) return browser$4;
	hasRequiredBrowser$4 = 1;
	var generatePrime = requireGeneratePrime();
	var primes = require$$1$1;

	var DH = requireDh();

	function getDiffieHellman (mod) {
	  var prime = new Buffer(primes[mod].prime, 'hex');
	  var gen = new Buffer(primes[mod].gen, 'hex');

	  return new DH(prime, gen)
	}

	var ENCODINGS = {
	  'binary': true, 'hex': true, 'base64': true
	};

	function createDiffieHellman (prime, enc, generator, genc) {
	  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
	    return createDiffieHellman(prime, 'binary', enc, generator)
	  }

	  enc = enc || 'binary';
	  genc = genc || 'binary';
	  generator = generator || new Buffer([2]);

	  if (!Buffer.isBuffer(generator)) {
	    generator = new Buffer(generator, genc);
	  }

	  if (typeof prime === 'number') {
	    return new DH(generatePrime(prime, generator), generator, true)
	  }

	  if (!Buffer.isBuffer(prime)) {
	    prime = new Buffer(prime, enc);
	  }

	  return new DH(prime, generator, true)
	}

	browser$4.DiffieHellmanGroup = browser$4.createDiffieHellmanGroup = browser$4.getDiffieHellman = getDiffieHellman;
	browser$4.createDiffieHellman = browser$4.DiffieHellman = createDiffieHellman;
	return browser$4;
}

var readableBrowser = {exports: {}};

var processNextickArgs = {exports: {}};

var hasRequiredProcessNextickArgs;

function requireProcessNextickArgs () {
	if (hasRequiredProcessNextickArgs) return processNextickArgs.exports;
	hasRequiredProcessNextickArgs = 1;

	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  processNextickArgs.exports = { nextTick: nextTick };
	} else {
	  processNextickArgs.exports = process;
	}

	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	return processNextickArgs.exports;
}

var isarray;
var hasRequiredIsarray;

function requireIsarray () {
	if (hasRequiredIsarray) return isarray;
	hasRequiredIsarray = 1;
	var toString = {}.toString;

	isarray = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};
	return isarray;
}

var streamBrowser;
var hasRequiredStreamBrowser;

function requireStreamBrowser () {
	if (hasRequiredStreamBrowser) return streamBrowser;
	hasRequiredStreamBrowser = 1;
	streamBrowser = requireEvents().EventEmitter;
	return streamBrowser;
}

var safeBuffer$1 = {exports: {}};

/* eslint-disable node/no-deprecated-api */

var hasRequiredSafeBuffer$1;

function requireSafeBuffer$1 () {
	if (hasRequiredSafeBuffer$1) return safeBuffer$1.exports;
	hasRequiredSafeBuffer$1 = 1;
	(function (module, exports) {
		var buffer = requireBuffer$1();
		var Buffer = buffer.Buffer;

		// alternative to using Object.keys for old browsers
		function copyProps (src, dst) {
		  for (var key in src) {
		    dst[key] = src[key];
		  }
		}
		if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
		  module.exports = buffer;
		} else {
		  // Copy properties from require('buffer')
		  copyProps(buffer, exports);
		  exports.Buffer = SafeBuffer;
		}

		function SafeBuffer (arg, encodingOrOffset, length) {
		  return Buffer(arg, encodingOrOffset, length)
		}

		// Copy static methods from Buffer
		copyProps(Buffer, SafeBuffer);

		SafeBuffer.from = function (arg, encodingOrOffset, length) {
		  if (typeof arg === 'number') {
		    throw new TypeError('Argument must not be a number')
		  }
		  return Buffer(arg, encodingOrOffset, length)
		};

		SafeBuffer.alloc = function (size, fill, encoding) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  var buf = Buffer(size);
		  if (fill !== undefined) {
		    if (typeof encoding === 'string') {
		      buf.fill(fill, encoding);
		    } else {
		      buf.fill(fill);
		    }
		  } else {
		    buf.fill(0);
		  }
		  return buf
		};

		SafeBuffer.allocUnsafe = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return Buffer(size)
		};

		SafeBuffer.allocUnsafeSlow = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return buffer.SlowBuffer(size)
		}; 
	} (safeBuffer$1, safeBuffer$1.exports));
	return safeBuffer$1.exports;
}

var util = {};

var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return util;
	hasRequiredUtil = 1;
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.

	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	util.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	util.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	util.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	util.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	util.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	util.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	util.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	util.isUndefined = isUndefined;

	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	util.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	util.isObject = isObject;

	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	util.isDate = isDate;

	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	util.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	util.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	util.isPrimitive = isPrimitive;

	util.isBuffer = requireBuffer$1().Buffer.isBuffer;

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	return util;
}

var BufferList = {exports: {}};

var hasRequiredBufferList;

function requireBufferList () {
	if (hasRequiredBufferList) return BufferList.exports;
	hasRequiredBufferList = 1;
	(function (module) {

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		var Buffer = requireSafeBuffer$1().Buffer;
		var util = require$$0$1;

		function copyBuffer(src, target, offset) {
		  src.copy(target, offset);
		}

		module.exports = function () {
		  function BufferList() {
		    _classCallCheck(this, BufferList);

		    this.head = null;
		    this.tail = null;
		    this.length = 0;
		  }

		  BufferList.prototype.push = function push(v) {
		    var entry = { data: v, next: null };
		    if (this.length > 0) this.tail.next = entry;else this.head = entry;
		    this.tail = entry;
		    ++this.length;
		  };

		  BufferList.prototype.unshift = function unshift(v) {
		    var entry = { data: v, next: this.head };
		    if (this.length === 0) this.tail = entry;
		    this.head = entry;
		    ++this.length;
		  };

		  BufferList.prototype.shift = function shift() {
		    if (this.length === 0) return;
		    var ret = this.head.data;
		    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
		    --this.length;
		    return ret;
		  };

		  BufferList.prototype.clear = function clear() {
		    this.head = this.tail = null;
		    this.length = 0;
		  };

		  BufferList.prototype.join = function join(s) {
		    if (this.length === 0) return '';
		    var p = this.head;
		    var ret = '' + p.data;
		    while (p = p.next) {
		      ret += s + p.data;
		    }return ret;
		  };

		  BufferList.prototype.concat = function concat(n) {
		    if (this.length === 0) return Buffer.alloc(0);
		    var ret = Buffer.allocUnsafe(n >>> 0);
		    var p = this.head;
		    var i = 0;
		    while (p) {
		      copyBuffer(p.data, ret, i);
		      i += p.data.length;
		      p = p.next;
		    }
		    return ret;
		  };

		  return BufferList;
		}();

		if (util && util.inspect && util.inspect.custom) {
		  module.exports.prototype[util.inspect.custom] = function () {
		    var obj = util.inspect({ length: this.length });
		    return this.constructor.name + ' ' + obj;
		  };
		} 
	} (BufferList));
	return BufferList.exports;
}

var destroy_1;
var hasRequiredDestroy;

function requireDestroy () {
	if (hasRequiredDestroy) return destroy_1;
	hasRequiredDestroy = 1;

	/*<replacement>*/

	var pna = requireProcessNextickArgs();
	/*</replacement>*/

	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;

	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;

	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err) {
	      if (!this._writableState) {
	        pna.nextTick(emitErrorNT, this, err);
	      } else if (!this._writableState.errorEmitted) {
	        this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, this, err);
	      }
	    }

	    return this;
	  }

	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks

	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }

	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }

	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      if (!_this._writableState) {
	        pna.nextTick(emitErrorNT, _this, err);
	      } else if (!_this._writableState.errorEmitted) {
	        _this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, _this, err);
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });

	  return this;
	}

	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }

	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finalCalled = false;
	    this._writableState.prefinished = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}

	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}

	destroy_1 = {
	  destroy: destroy,
	  undestroy: undestroy
	};
	return destroy_1;
}

var _stream_writable;
var hasRequired_stream_writable;

function require_stream_writable () {
	if (hasRequired_stream_writable) return _stream_writable;
	hasRequired_stream_writable = 1;

	/*<replacement>*/

	var pna = requireProcessNextickArgs();
	/*</replacement>*/

	_stream_writable = Writable;

	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;

	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */

	/*<replacement>*/
	var asyncWrite = pna.nextTick;
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Writable.WritableState = WritableState;

	/*<replacement>*/
	var util = Object.create(requireUtil());
	util.inherits = requireInherits_browser();
	/*</replacement>*/

	/*<replacement>*/
	var internalUtil = {
	  deprecate: requireBrowser$a()
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = requireStreamBrowser();
	/*</replacement>*/

	/*<replacement>*/

	var Buffer = requireSafeBuffer$1().Buffer;
	var OurUint8Array = (typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}

	/*</replacement>*/

	var destroyImpl = requireDestroy();

	util.inherits(Writable, Stream);

	function nop() {}

	function WritableState(options, stream) {
	  Duplex = Duplex || require_stream_duplex();

	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;

	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;

	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // if _final has been called
	  this.finalCalled = false;

	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;

	  // a flag to see when we're in the middle of a write.
	  this.writing = false;

	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;

	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;

	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;

	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };

	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;

	  // the amount that is being written when _write is called.
	  this.writelen = 0;

	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;

	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;

	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;

	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;

	  // count buffered requests
	  this.bufferedRequestCount = 0;

	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}

	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};

	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();

	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;

	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}

	function Writable(options) {
	  Duplex = Duplex || require_stream_duplex();

	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.

	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }

	  this._writableState = new WritableState(options, this);

	  // legacy.
	  this.writable = true;

	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;

	    if (typeof options.writev === 'function') this._writev = options.writev;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;

	    if (typeof options.final === 'function') this._final = options.final;
	  }

	  Stream.call(this);
	}

	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};

	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}

	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;

	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}

	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);

	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }

	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

	  if (typeof cb !== 'function') cb = nop;

	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }

	  return ret;
	};

	Writable.prototype.cork = function () {
	  var state = this._writableState;

	  state.corked++;
	};

	Writable.prototype.uncork = function () {
	  var state = this._writableState;

	  if (state.corked) {
	    state.corked--;

	    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};

	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};

	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}

	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});

	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;

	  state.length += len;

	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;

	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }

	  return ret;
	}

	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}

	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;

	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}

	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}

	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;

	  onwriteStateUpdate(state);

	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);

	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }

	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}

	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}

	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}

	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;

	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;

	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;

	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;

	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }

	    if (entry === null) state.lastBufferedRequest = null;
	  }

	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}

	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};

	Writable.prototype._writev = null;

	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;

	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }

	  // ignore unnecessary end() calls.
	  if (!state.ending) endWritable(this, state, cb);
	};

	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}

	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}

	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}

	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }

	  // reuse the free corkReq.
	  state.corkedRequestsFree.next = corkReq;
	}

	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});

	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	return _stream_writable;
}

var _stream_duplex;
var hasRequired_stream_duplex;

function require_stream_duplex () {
	if (hasRequired_stream_duplex) return _stream_duplex;
	hasRequired_stream_duplex = 1;

	/*<replacement>*/

	var pna = requireProcessNextickArgs();
	/*</replacement>*/

	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/

	_stream_duplex = Duplex;

	/*<replacement>*/
	var util = Object.create(requireUtil());
	util.inherits = requireInherits_browser();
	/*</replacement>*/

	var Readable = require_stream_readable();
	var Writable = require_stream_writable();

	util.inherits(Duplex, Readable);

	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}

	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);

	  Readable.call(this, options);
	  Writable.call(this, options);

	  if (options && options.readable === false) this.readable = false;

	  if (options && options.writable === false) this.writable = false;

	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

	  this.once('end', onend);
	}

	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});

	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;

	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}

	function onEndNT(self) {
	  self.end();
	}

	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});

	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();

	  pna.nextTick(cb, err);
	};
	return _stream_duplex;
}

var string_decoder = {};

var safeBuffer = {exports: {}};

/* eslint-disable node/no-deprecated-api */

var hasRequiredSafeBuffer;

function requireSafeBuffer () {
	if (hasRequiredSafeBuffer) return safeBuffer.exports;
	hasRequiredSafeBuffer = 1;
	(function (module, exports) {
		var buffer = requireBuffer$1();
		var Buffer = buffer.Buffer;

		// alternative to using Object.keys for old browsers
		function copyProps (src, dst) {
		  for (var key in src) {
		    dst[key] = src[key];
		  }
		}
		if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
		  module.exports = buffer;
		} else {
		  // Copy properties from require('buffer')
		  copyProps(buffer, exports);
		  exports.Buffer = SafeBuffer;
		}

		function SafeBuffer (arg, encodingOrOffset, length) {
		  return Buffer(arg, encodingOrOffset, length)
		}

		// Copy static methods from Buffer
		copyProps(Buffer, SafeBuffer);

		SafeBuffer.from = function (arg, encodingOrOffset, length) {
		  if (typeof arg === 'number') {
		    throw new TypeError('Argument must not be a number')
		  }
		  return Buffer(arg, encodingOrOffset, length)
		};

		SafeBuffer.alloc = function (size, fill, encoding) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  var buf = Buffer(size);
		  if (fill !== undefined) {
		    if (typeof encoding === 'string') {
		      buf.fill(fill, encoding);
		    } else {
		      buf.fill(fill);
		    }
		  } else {
		    buf.fill(0);
		  }
		  return buf
		};

		SafeBuffer.allocUnsafe = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return Buffer(size)
		};

		SafeBuffer.allocUnsafeSlow = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return buffer.SlowBuffer(size)
		}; 
	} (safeBuffer, safeBuffer.exports));
	return safeBuffer.exports;
}

var hasRequiredString_decoder;

function requireString_decoder () {
	if (hasRequiredString_decoder) return string_decoder;
	hasRequiredString_decoder = 1;

	/*<replacement>*/

	var Buffer = requireSafeBuffer().Buffer;
	/*</replacement>*/

	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};

	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	}
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}

	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	string_decoder.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}

	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};

	StringDecoder.prototype.end = utf8End;

	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;

	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};

	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}

	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}

	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}

	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}

	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}

	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}

	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}

	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}

	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}

	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}

	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}

	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}
	return string_decoder;
}

var _stream_readable;
var hasRequired_stream_readable;

function require_stream_readable () {
	if (hasRequired_stream_readable) return _stream_readable;
	hasRequired_stream_readable = 1;

	/*<replacement>*/

	var pna = requireProcessNextickArgs();
	/*</replacement>*/

	_stream_readable = Readable;

	/*<replacement>*/
	var isArray = requireIsarray();
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Readable.ReadableState = ReadableState;

	/*<replacement>*/
	requireEvents().EventEmitter;

	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = requireStreamBrowser();
	/*</replacement>*/

	/*<replacement>*/

	var Buffer = requireSafeBuffer$1().Buffer;
	var OurUint8Array = (typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}

	/*</replacement>*/

	/*<replacement>*/
	var util = Object.create(requireUtil());
	util.inherits = requireInherits_browser();
	/*</replacement>*/

	/*<replacement>*/
	var debugUtil = require$$0$1;
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/

	var BufferList = requireBufferList();
	var destroyImpl = requireDestroy();
	var StringDecoder;

	util.inherits(Readable, Stream);

	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}

	function ReadableState(options, stream) {
	  Duplex = Duplex || require_stream_duplex();

	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;

	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;

	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;

	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;

	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;

	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;

	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = requireString_decoder().StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}

	function Readable(options) {
	  Duplex = Duplex || require_stream_duplex();

	  if (!(this instanceof Readable)) return new Readable(options);

	  this._readableState = new ReadableState(options, this);

	  // legacy
	  this.readable = true;

	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }

	  Stream.call(this);
	}

	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});

	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};

	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;

	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }

	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};

	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};

	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }

	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }

	  return needMoreData(state);
	}

	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}

	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}

	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}

	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};

	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = requireString_decoder().StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};

	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}

	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}

	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;

	  if (n !== 0) state.emittedReadable = false;

	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }

	  n = howMuchToRead(n, state);

	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }

	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.

	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);

	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }

	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }

	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;

	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }

	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;

	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }

	  if (ret !== null) this.emit('data', ret);

	  return ret;
	};

	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;

	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}

	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}

	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}

	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}

	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}

	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};

	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;

	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }

	  function onend() {
	    debug('onend');
	    dest.end();
	  }

	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);

	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);

	    cleanedUp = true;

	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }

	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', state.awaitDrain);
	        state.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }

	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }

	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);

	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);

	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }

	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);

	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }

	  return dest;
	};

	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}

	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };

	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;

	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;

	    if (!dest) dest = state.pipes;

	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }

	  // slow case. multiple pipe destinations.

	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;

	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, { hasUnpiped: false });
	    }return this;
	  }

	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;

	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];

	  dest.emit('unpipe', this, unpipeInfo);

	  return this;
	};

	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);

	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }

	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;

	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}

	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};

	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}

	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }

	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}

	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};

	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}

	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;

	  var state = this._readableState;
	  var paused = false;

	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }

	    _this.push(null);
	  });

	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);

	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });

	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }

	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }

	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };

	  return this;
	};

	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});

	// exposed for testing purposes only.
	Readable._fromList = fromList;

	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;

	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }

	  return ret;
	}

	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}

	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	function endReadable(stream) {
	  var state = stream._readableState;

	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}

	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}

	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	return _stream_readable;
}

var _stream_transform;
var hasRequired_stream_transform;

function require_stream_transform () {
	if (hasRequired_stream_transform) return _stream_transform;
	hasRequired_stream_transform = 1;

	_stream_transform = Transform;

	var Duplex = require_stream_duplex();

	/*<replacement>*/
	var util = Object.create(requireUtil());
	util.inherits = requireInherits_browser();
	/*</replacement>*/

	util.inherits(Transform, Duplex);

	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;

	  var cb = ts.writecb;

	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }

	  ts.writechunk = null;
	  ts.writecb = null;

	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);

	  cb(er);

	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}

	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);

	  Duplex.call(this, options);

	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };

	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;

	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;

	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;

	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }

	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}

	function prefinish() {
	  var _this = this;

	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}

	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};

	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};

	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};

	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;

	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};

	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;

	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};

	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);

	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);

	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

	  return stream.push(null);
	}
	return _stream_transform;
}

var _stream_passthrough;
var hasRequired_stream_passthrough;

function require_stream_passthrough () {
	if (hasRequired_stream_passthrough) return _stream_passthrough;
	hasRequired_stream_passthrough = 1;

	_stream_passthrough = PassThrough;

	var Transform = require_stream_transform();

	/*<replacement>*/
	var util = Object.create(requireUtil());
	util.inherits = requireInherits_browser();
	/*</replacement>*/

	util.inherits(PassThrough, Transform);

	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);

	  Transform.call(this, options);
	}

	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};
	return _stream_passthrough;
}

var hasRequiredReadableBrowser;

function requireReadableBrowser () {
	if (hasRequiredReadableBrowser) return readableBrowser.exports;
	hasRequiredReadableBrowser = 1;
	(function (module, exports) {
		exports = module.exports = require_stream_readable();
		exports.Stream = exports;
		exports.Readable = exports;
		exports.Writable = require_stream_writable();
		exports.Duplex = require_stream_duplex();
		exports.Transform = require_stream_transform();
		exports.PassThrough = require_stream_passthrough(); 
	} (readableBrowser, readableBrowser.exports));
	return readableBrowser.exports;
}

var sign = {exports: {}};

var bn$3 = {exports: {}};

var bn$2 = bn$3.exports;

var hasRequiredBn$1;

function requireBn$1 () {
	if (hasRequiredBn$1) return bn$3.exports;
	hasRequiredBn$1 = 1;
	(function (module) {
		(function (module, exports) {

		  // Utils
		  function assert (val, msg) {
		    if (!val) throw new Error(msg || 'Assertion failed');
		  }

		  // Could use `inherits` module, but don't want to move from single file
		  // architecture yet.
		  function inherits (ctor, superCtor) {
		    ctor.super_ = superCtor;
		    var TempCtor = function () {};
		    TempCtor.prototype = superCtor.prototype;
		    ctor.prototype = new TempCtor();
		    ctor.prototype.constructor = ctor;
		  }

		  // BN

		  function BN (number, base, endian) {
		    if (BN.isBN(number)) {
		      return number;
		    }

		    this.negative = 0;
		    this.words = null;
		    this.length = 0;

		    // Reduction context
		    this.red = null;

		    if (number !== null) {
		      if (base === 'le' || base === 'be') {
		        endian = base;
		        base = 10;
		      }

		      this._init(number || 0, base || 10, endian || 'be');
		    }
		  }
		  if (typeof module === 'object') {
		    module.exports = BN;
		  } else {
		    exports.BN = BN;
		  }

		  BN.BN = BN;
		  BN.wordSize = 26;

		  var Buffer;
		  try {
		    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
		      Buffer = window.Buffer;
		    } else {
		      Buffer = require$$0$1.Buffer;
		    }
		  } catch (e) {
		  }

		  BN.isBN = function isBN (num) {
		    if (num instanceof BN) {
		      return true;
		    }

		    return num !== null && typeof num === 'object' &&
		      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
		  };

		  BN.max = function max (left, right) {
		    if (left.cmp(right) > 0) return left;
		    return right;
		  };

		  BN.min = function min (left, right) {
		    if (left.cmp(right) < 0) return left;
		    return right;
		  };

		  BN.prototype._init = function init (number, base, endian) {
		    if (typeof number === 'number') {
		      return this._initNumber(number, base, endian);
		    }

		    if (typeof number === 'object') {
		      return this._initArray(number, base, endian);
		    }

		    if (base === 'hex') {
		      base = 16;
		    }
		    assert(base === (base | 0) && base >= 2 && base <= 36);

		    number = number.toString().replace(/\s+/g, '');
		    var start = 0;
		    if (number[0] === '-') {
		      start++;
		      this.negative = 1;
		    }

		    if (start < number.length) {
		      if (base === 16) {
		        this._parseHex(number, start, endian);
		      } else {
		        this._parseBase(number, base, start);
		        if (endian === 'le') {
		          this._initArray(this.toArray(), base, endian);
		        }
		      }
		    }
		  };

		  BN.prototype._initNumber = function _initNumber (number, base, endian) {
		    if (number < 0) {
		      this.negative = 1;
		      number = -number;
		    }
		    if (number < 0x4000000) {
		      this.words = [number & 0x3ffffff];
		      this.length = 1;
		    } else if (number < 0x10000000000000) {
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff
		      ];
		      this.length = 2;
		    } else {
		      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff,
		        1
		      ];
		      this.length = 3;
		    }

		    if (endian !== 'le') return;

		    // Reverse the bytes
		    this._initArray(this.toArray(), base, endian);
		  };

		  BN.prototype._initArray = function _initArray (number, base, endian) {
		    // Perhaps a Uint8Array
		    assert(typeof number.length === 'number');
		    if (number.length <= 0) {
		      this.words = [0];
		      this.length = 1;
		      return this;
		    }

		    this.length = Math.ceil(number.length / 3);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    var j, w;
		    var off = 0;
		    if (endian === 'be') {
		      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
		        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    } else if (endian === 'le') {
		      for (i = 0, j = 0; i < number.length; i += 3) {
		        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    }
		    return this._strip();
		  };

		  function parseHex4Bits (string, index) {
		    var c = string.charCodeAt(index);
		    // '0' - '9'
		    if (c >= 48 && c <= 57) {
		      return c - 48;
		    // 'A' - 'F'
		    } else if (c >= 65 && c <= 70) {
		      return c - 55;
		    // 'a' - 'f'
		    } else if (c >= 97 && c <= 102) {
		      return c - 87;
		    } else {
		      assert(false, 'Invalid character in ' + string);
		    }
		  }

		  function parseHexByte (string, lowerBound, index) {
		    var r = parseHex4Bits(string, index);
		    if (index - 1 >= lowerBound) {
		      r |= parseHex4Bits(string, index - 1) << 4;
		    }
		    return r;
		  }

		  BN.prototype._parseHex = function _parseHex (number, start, endian) {
		    // Create possibly bigger array to ensure that it fits the number
		    this.length = Math.ceil((number.length - start) / 6);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    // 24-bits chunks
		    var off = 0;
		    var j = 0;

		    var w;
		    if (endian === 'be') {
		      for (i = number.length - 1; i >= start; i -= 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    } else {
		      var parseLength = number.length - start;
		      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    }

		    this._strip();
		  };

		  function parseBase (str, start, end, mul) {
		    var r = 0;
		    var b = 0;
		    var len = Math.min(str.length, end);
		    for (var i = start; i < len; i++) {
		      var c = str.charCodeAt(i) - 48;

		      r *= mul;

		      // 'a'
		      if (c >= 49) {
		        b = c - 49 + 0xa;

		      // 'A'
		      } else if (c >= 17) {
		        b = c - 17 + 0xa;

		      // '0' - '9'
		      } else {
		        b = c;
		      }
		      assert(c >= 0 && b < mul, 'Invalid character');
		      r += b;
		    }
		    return r;
		  }

		  BN.prototype._parseBase = function _parseBase (number, base, start) {
		    // Initialize as zero
		    this.words = [0];
		    this.length = 1;

		    // Find length of limb in base
		    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
		      limbLen++;
		    }
		    limbLen--;
		    limbPow = (limbPow / base) | 0;

		    var total = number.length - start;
		    var mod = total % limbLen;
		    var end = Math.min(total, total - mod) + start;

		    var word = 0;
		    for (var i = start; i < end; i += limbLen) {
		      word = parseBase(number, i, i + limbLen, base);

		      this.imuln(limbPow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    if (mod !== 0) {
		      var pow = 1;
		      word = parseBase(number, i, number.length, base);

		      for (i = 0; i < mod; i++) {
		        pow *= base;
		      }

		      this.imuln(pow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    this._strip();
		  };

		  BN.prototype.copy = function copy (dest) {
		    dest.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      dest.words[i] = this.words[i];
		    }
		    dest.length = this.length;
		    dest.negative = this.negative;
		    dest.red = this.red;
		  };

		  function move (dest, src) {
		    dest.words = src.words;
		    dest.length = src.length;
		    dest.negative = src.negative;
		    dest.red = src.red;
		  }

		  BN.prototype._move = function _move (dest) {
		    move(dest, this);
		  };

		  BN.prototype.clone = function clone () {
		    var r = new BN(null);
		    this.copy(r);
		    return r;
		  };

		  BN.prototype._expand = function _expand (size) {
		    while (this.length < size) {
		      this.words[this.length++] = 0;
		    }
		    return this;
		  };

		  // Remove leading `0` from `this`
		  BN.prototype._strip = function strip () {
		    while (this.length > 1 && this.words[this.length - 1] === 0) {
		      this.length--;
		    }
		    return this._normSign();
		  };

		  BN.prototype._normSign = function _normSign () {
		    // -0 = 0
		    if (this.length === 1 && this.words[0] === 0) {
		      this.negative = 0;
		    }
		    return this;
		  };

		  // Check Symbol.for because not everywhere where Symbol defined
		  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
		  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
		    try {
		      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
		    } catch (e) {
		      BN.prototype.inspect = inspect;
		    }
		  } else {
		    BN.prototype.inspect = inspect;
		  }

		  function inspect () {
		    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
		  }

		  /*

		  var zeros = [];
		  var groupSizes = [];
		  var groupBases = [];

		  var s = '';
		  var i = -1;
		  while (++i < BN.wordSize) {
		    zeros[i] = s;
		    s += '0';
		  }
		  groupSizes[0] = 0;
		  groupSizes[1] = 0;
		  groupBases[0] = 0;
		  groupBases[1] = 0;
		  var base = 2 - 1;
		  while (++base < 36 + 1) {
		    var groupSize = 0;
		    var groupBase = 1;
		    while (groupBase < (1 << BN.wordSize) / base) {
		      groupBase *= base;
		      groupSize += 1;
		    }
		    groupSizes[base] = groupSize;
		    groupBases[base] = groupBase;
		  }

		  */

		  var zeros = [
		    '',
		    '0',
		    '00',
		    '000',
		    '0000',
		    '00000',
		    '000000',
		    '0000000',
		    '00000000',
		    '000000000',
		    '0000000000',
		    '00000000000',
		    '000000000000',
		    '0000000000000',
		    '00000000000000',
		    '000000000000000',
		    '0000000000000000',
		    '00000000000000000',
		    '000000000000000000',
		    '0000000000000000000',
		    '00000000000000000000',
		    '000000000000000000000',
		    '0000000000000000000000',
		    '00000000000000000000000',
		    '000000000000000000000000',
		    '0000000000000000000000000'
		  ];

		  var groupSizes = [
		    0, 0,
		    25, 16, 12, 11, 10, 9, 8,
		    8, 7, 7, 7, 7, 6, 6,
		    6, 6, 6, 6, 6, 5, 5,
		    5, 5, 5, 5, 5, 5, 5,
		    5, 5, 5, 5, 5, 5, 5
		  ];

		  var groupBases = [
		    0, 0,
		    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
		    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
		    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
		    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
		    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
		  ];

		  BN.prototype.toString = function toString (base, padding) {
		    base = base || 10;
		    padding = padding | 0 || 1;

		    var out;
		    if (base === 16 || base === 'hex') {
		      out = '';
		      var off = 0;
		      var carry = 0;
		      for (var i = 0; i < this.length; i++) {
		        var w = this.words[i];
		        var word = (((w << off) | carry) & 0xffffff).toString(16);
		        carry = (w >>> (24 - off)) & 0xffffff;
		        off += 2;
		        if (off >= 26) {
		          off -= 26;
		          i--;
		        }
		        if (carry !== 0 || i !== this.length - 1) {
		          out = zeros[6 - word.length] + word + out;
		        } else {
		          out = word + out;
		        }
		      }
		      if (carry !== 0) {
		        out = carry.toString(16) + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    if (base === (base | 0) && base >= 2 && base <= 36) {
		      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
		      var groupSize = groupSizes[base];
		      // var groupBase = Math.pow(base, groupSize);
		      var groupBase = groupBases[base];
		      out = '';
		      var c = this.clone();
		      c.negative = 0;
		      while (!c.isZero()) {
		        var r = c.modrn(groupBase).toString(base);
		        c = c.idivn(groupBase);

		        if (!c.isZero()) {
		          out = zeros[groupSize - r.length] + r + out;
		        } else {
		          out = r + out;
		        }
		      }
		      if (this.isZero()) {
		        out = '0' + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    assert(false, 'Base should be between 2 and 36');
		  };

		  BN.prototype.toNumber = function toNumber () {
		    var ret = this.words[0];
		    if (this.length === 2) {
		      ret += this.words[1] * 0x4000000;
		    } else if (this.length === 3 && this.words[2] === 0x01) {
		      // NOTE: at this stage it is known that the top bit is set
		      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
		    } else if (this.length > 2) {
		      assert(false, 'Number can only safely store up to 53 bits');
		    }
		    return (this.negative !== 0) ? -ret : ret;
		  };

		  BN.prototype.toJSON = function toJSON () {
		    return this.toString(16, 2);
		  };

		  if (Buffer) {
		    BN.prototype.toBuffer = function toBuffer (endian, length) {
		      return this.toArrayLike(Buffer, endian, length);
		    };
		  }

		  BN.prototype.toArray = function toArray (endian, length) {
		    return this.toArrayLike(Array, endian, length);
		  };

		  var allocate = function allocate (ArrayType, size) {
		    if (ArrayType.allocUnsafe) {
		      return ArrayType.allocUnsafe(size);
		    }
		    return new ArrayType(size);
		  };

		  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
		    this._strip();

		    var byteLength = this.byteLength();
		    var reqLength = length || Math.max(1, byteLength);
		    assert(byteLength <= reqLength, 'byte array longer than desired length');
		    assert(reqLength > 0, 'Requested array length <= 0');

		    var res = allocate(ArrayType, reqLength);
		    var postfix = endian === 'le' ? 'LE' : 'BE';
		    this['_toArrayLike' + postfix](res, byteLength);
		    return res;
		  };

		  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
		    var position = 0;
		    var carry = 0;

		    for (var i = 0, shift = 0; i < this.length; i++) {
		      var word = (this.words[i] << shift) | carry;

		      res[position++] = word & 0xff;
		      if (position < res.length) {
		        res[position++] = (word >> 8) & 0xff;
		      }
		      if (position < res.length) {
		        res[position++] = (word >> 16) & 0xff;
		      }

		      if (shift === 6) {
		        if (position < res.length) {
		          res[position++] = (word >> 24) & 0xff;
		        }
		        carry = 0;
		        shift = 0;
		      } else {
		        carry = word >>> 24;
		        shift += 2;
		      }
		    }

		    if (position < res.length) {
		      res[position++] = carry;

		      while (position < res.length) {
		        res[position++] = 0;
		      }
		    }
		  };

		  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
		    var position = res.length - 1;
		    var carry = 0;

		    for (var i = 0, shift = 0; i < this.length; i++) {
		      var word = (this.words[i] << shift) | carry;

		      res[position--] = word & 0xff;
		      if (position >= 0) {
		        res[position--] = (word >> 8) & 0xff;
		      }
		      if (position >= 0) {
		        res[position--] = (word >> 16) & 0xff;
		      }

		      if (shift === 6) {
		        if (position >= 0) {
		          res[position--] = (word >> 24) & 0xff;
		        }
		        carry = 0;
		        shift = 0;
		      } else {
		        carry = word >>> 24;
		        shift += 2;
		      }
		    }

		    if (position >= 0) {
		      res[position--] = carry;

		      while (position >= 0) {
		        res[position--] = 0;
		      }
		    }
		  };

		  if (Math.clz32) {
		    BN.prototype._countBits = function _countBits (w) {
		      return 32 - Math.clz32(w);
		    };
		  } else {
		    BN.prototype._countBits = function _countBits (w) {
		      var t = w;
		      var r = 0;
		      if (t >= 0x1000) {
		        r += 13;
		        t >>>= 13;
		      }
		      if (t >= 0x40) {
		        r += 7;
		        t >>>= 7;
		      }
		      if (t >= 0x8) {
		        r += 4;
		        t >>>= 4;
		      }
		      if (t >= 0x02) {
		        r += 2;
		        t >>>= 2;
		      }
		      return r + t;
		    };
		  }

		  BN.prototype._zeroBits = function _zeroBits (w) {
		    // Short-cut
		    if (w === 0) return 26;

		    var t = w;
		    var r = 0;
		    if ((t & 0x1fff) === 0) {
		      r += 13;
		      t >>>= 13;
		    }
		    if ((t & 0x7f) === 0) {
		      r += 7;
		      t >>>= 7;
		    }
		    if ((t & 0xf) === 0) {
		      r += 4;
		      t >>>= 4;
		    }
		    if ((t & 0x3) === 0) {
		      r += 2;
		      t >>>= 2;
		    }
		    if ((t & 0x1) === 0) {
		      r++;
		    }
		    return r;
		  };

		  // Return number of used bits in a BN
		  BN.prototype.bitLength = function bitLength () {
		    var w = this.words[this.length - 1];
		    var hi = this._countBits(w);
		    return (this.length - 1) * 26 + hi;
		  };

		  function toBitArray (num) {
		    var w = new Array(num.bitLength());

		    for (var bit = 0; bit < w.length; bit++) {
		      var off = (bit / 26) | 0;
		      var wbit = bit % 26;

		      w[bit] = (num.words[off] >>> wbit) & 0x01;
		    }

		    return w;
		  }

		  // Number of trailing zero bits
		  BN.prototype.zeroBits = function zeroBits () {
		    if (this.isZero()) return 0;

		    var r = 0;
		    for (var i = 0; i < this.length; i++) {
		      var b = this._zeroBits(this.words[i]);
		      r += b;
		      if (b !== 26) break;
		    }
		    return r;
		  };

		  BN.prototype.byteLength = function byteLength () {
		    return Math.ceil(this.bitLength() / 8);
		  };

		  BN.prototype.toTwos = function toTwos (width) {
		    if (this.negative !== 0) {
		      return this.abs().inotn(width).iaddn(1);
		    }
		    return this.clone();
		  };

		  BN.prototype.fromTwos = function fromTwos (width) {
		    if (this.testn(width - 1)) {
		      return this.notn(width).iaddn(1).ineg();
		    }
		    return this.clone();
		  };

		  BN.prototype.isNeg = function isNeg () {
		    return this.negative !== 0;
		  };

		  // Return negative clone of `this`
		  BN.prototype.neg = function neg () {
		    return this.clone().ineg();
		  };

		  BN.prototype.ineg = function ineg () {
		    if (!this.isZero()) {
		      this.negative ^= 1;
		    }

		    return this;
		  };

		  // Or `num` with `this` in-place
		  BN.prototype.iuor = function iuor (num) {
		    while (this.length < num.length) {
		      this.words[this.length++] = 0;
		    }

		    for (var i = 0; i < num.length; i++) {
		      this.words[i] = this.words[i] | num.words[i];
		    }

		    return this._strip();
		  };

		  BN.prototype.ior = function ior (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuor(num);
		  };

		  // Or `num` with `this`
		  BN.prototype.or = function or (num) {
		    if (this.length > num.length) return this.clone().ior(num);
		    return num.clone().ior(this);
		  };

		  BN.prototype.uor = function uor (num) {
		    if (this.length > num.length) return this.clone().iuor(num);
		    return num.clone().iuor(this);
		  };

		  // And `num` with `this` in-place
		  BN.prototype.iuand = function iuand (num) {
		    // b = min-length(num, this)
		    var b;
		    if (this.length > num.length) {
		      b = num;
		    } else {
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = this.words[i] & num.words[i];
		    }

		    this.length = b.length;

		    return this._strip();
		  };

		  BN.prototype.iand = function iand (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuand(num);
		  };

		  // And `num` with `this`
		  BN.prototype.and = function and (num) {
		    if (this.length > num.length) return this.clone().iand(num);
		    return num.clone().iand(this);
		  };

		  BN.prototype.uand = function uand (num) {
		    if (this.length > num.length) return this.clone().iuand(num);
		    return num.clone().iuand(this);
		  };

		  // Xor `num` with `this` in-place
		  BN.prototype.iuxor = function iuxor (num) {
		    // a.length > b.length
		    var a;
		    var b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = a.words[i] ^ b.words[i];
		    }

		    if (this !== a) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = a.length;

		    return this._strip();
		  };

		  BN.prototype.ixor = function ixor (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuxor(num);
		  };

		  // Xor `num` with `this`
		  BN.prototype.xor = function xor (num) {
		    if (this.length > num.length) return this.clone().ixor(num);
		    return num.clone().ixor(this);
		  };

		  BN.prototype.uxor = function uxor (num) {
		    if (this.length > num.length) return this.clone().iuxor(num);
		    return num.clone().iuxor(this);
		  };

		  // Not ``this`` with ``width`` bitwidth
		  BN.prototype.inotn = function inotn (width) {
		    assert(typeof width === 'number' && width >= 0);

		    var bytesNeeded = Math.ceil(width / 26) | 0;
		    var bitsLeft = width % 26;

		    // Extend the buffer with leading zeroes
		    this._expand(bytesNeeded);

		    if (bitsLeft > 0) {
		      bytesNeeded--;
		    }

		    // Handle complete words
		    for (var i = 0; i < bytesNeeded; i++) {
		      this.words[i] = ~this.words[i] & 0x3ffffff;
		    }

		    // Handle the residue
		    if (bitsLeft > 0) {
		      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
		    }

		    // And remove leading zeroes
		    return this._strip();
		  };

		  BN.prototype.notn = function notn (width) {
		    return this.clone().inotn(width);
		  };

		  // Set `bit` of `this`
		  BN.prototype.setn = function setn (bit, val) {
		    assert(typeof bit === 'number' && bit >= 0);

		    var off = (bit / 26) | 0;
		    var wbit = bit % 26;

		    this._expand(off + 1);

		    if (val) {
		      this.words[off] = this.words[off] | (1 << wbit);
		    } else {
		      this.words[off] = this.words[off] & ~(1 << wbit);
		    }

		    return this._strip();
		  };

		  // Add `num` to `this` in-place
		  BN.prototype.iadd = function iadd (num) {
		    var r;

		    // negative + positive
		    if (this.negative !== 0 && num.negative === 0) {
		      this.negative = 0;
		      r = this.isub(num);
		      this.negative ^= 1;
		      return this._normSign();

		    // positive + negative
		    } else if (this.negative === 0 && num.negative !== 0) {
		      num.negative = 0;
		      r = this.isub(num);
		      num.negative = 1;
		      return r._normSign();
		    }

		    // a.length > b.length
		    var a, b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }

		    this.length = a.length;
		    if (carry !== 0) {
		      this.words[this.length] = carry;
		      this.length++;
		    // Copy the rest of the words
		    } else if (a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    return this;
		  };

		  // Add `num` to `this`
		  BN.prototype.add = function add (num) {
		    var res;
		    if (num.negative !== 0 && this.negative === 0) {
		      num.negative = 0;
		      res = this.sub(num);
		      num.negative ^= 1;
		      return res;
		    } else if (num.negative === 0 && this.negative !== 0) {
		      this.negative = 0;
		      res = num.sub(this);
		      this.negative = 1;
		      return res;
		    }

		    if (this.length > num.length) return this.clone().iadd(num);

		    return num.clone().iadd(this);
		  };

		  // Subtract `num` from `this` in-place
		  BN.prototype.isub = function isub (num) {
		    // this - (-num) = this + num
		    if (num.negative !== 0) {
		      num.negative = 0;
		      var r = this.iadd(num);
		      num.negative = 1;
		      return r._normSign();

		    // -this - num = -(this + num)
		    } else if (this.negative !== 0) {
		      this.negative = 0;
		      this.iadd(num);
		      this.negative = 1;
		      return this._normSign();
		    }

		    // At this point both numbers are positive
		    var cmp = this.cmp(num);

		    // Optimization - zeroify
		    if (cmp === 0) {
		      this.negative = 0;
		      this.length = 1;
		      this.words[0] = 0;
		      return this;
		    }

		    // a > b
		    var a, b;
		    if (cmp > 0) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }

		    // Copy rest of the words
		    if (carry === 0 && i < a.length && a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = Math.max(this.length, i);

		    if (a !== this) {
		      this.negative = 1;
		    }

		    return this._strip();
		  };

		  // Subtract `num` from `this`
		  BN.prototype.sub = function sub (num) {
		    return this.clone().isub(num);
		  };

		  function smallMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    var len = (self.length + num.length) | 0;
		    out.length = len;
		    len = (len - 1) | 0;

		    // Peel one iteration (compiler can't do it, because of code complexity)
		    var a = self.words[0] | 0;
		    var b = num.words[0] | 0;
		    var r = a * b;

		    var lo = r & 0x3ffffff;
		    var carry = (r / 0x4000000) | 0;
		    out.words[0] = lo;

		    for (var k = 1; k < len; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = carry >>> 26;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = (k - j) | 0;
		        a = self.words[i] | 0;
		        b = num.words[j] | 0;
		        r = a * b + rword;
		        ncarry += (r / 0x4000000) | 0;
		        rword = r & 0x3ffffff;
		      }
		      out.words[k] = rword | 0;
		      carry = ncarry | 0;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry | 0;
		    } else {
		      out.length--;
		    }

		    return out._strip();
		  }

		  // TODO(indutny): it may be reasonable to omit it for users who don't need
		  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
		  // multiplication (like elliptic secp256k1).
		  var comb10MulTo = function comb10MulTo (self, num, out) {
		    var a = self.words;
		    var b = num.words;
		    var o = out.words;
		    var c = 0;
		    var lo;
		    var mid;
		    var hi;
		    var a0 = a[0] | 0;
		    var al0 = a0 & 0x1fff;
		    var ah0 = a0 >>> 13;
		    var a1 = a[1] | 0;
		    var al1 = a1 & 0x1fff;
		    var ah1 = a1 >>> 13;
		    var a2 = a[2] | 0;
		    var al2 = a2 & 0x1fff;
		    var ah2 = a2 >>> 13;
		    var a3 = a[3] | 0;
		    var al3 = a3 & 0x1fff;
		    var ah3 = a3 >>> 13;
		    var a4 = a[4] | 0;
		    var al4 = a4 & 0x1fff;
		    var ah4 = a4 >>> 13;
		    var a5 = a[5] | 0;
		    var al5 = a5 & 0x1fff;
		    var ah5 = a5 >>> 13;
		    var a6 = a[6] | 0;
		    var al6 = a6 & 0x1fff;
		    var ah6 = a6 >>> 13;
		    var a7 = a[7] | 0;
		    var al7 = a7 & 0x1fff;
		    var ah7 = a7 >>> 13;
		    var a8 = a[8] | 0;
		    var al8 = a8 & 0x1fff;
		    var ah8 = a8 >>> 13;
		    var a9 = a[9] | 0;
		    var al9 = a9 & 0x1fff;
		    var ah9 = a9 >>> 13;
		    var b0 = b[0] | 0;
		    var bl0 = b0 & 0x1fff;
		    var bh0 = b0 >>> 13;
		    var b1 = b[1] | 0;
		    var bl1 = b1 & 0x1fff;
		    var bh1 = b1 >>> 13;
		    var b2 = b[2] | 0;
		    var bl2 = b2 & 0x1fff;
		    var bh2 = b2 >>> 13;
		    var b3 = b[3] | 0;
		    var bl3 = b3 & 0x1fff;
		    var bh3 = b3 >>> 13;
		    var b4 = b[4] | 0;
		    var bl4 = b4 & 0x1fff;
		    var bh4 = b4 >>> 13;
		    var b5 = b[5] | 0;
		    var bl5 = b5 & 0x1fff;
		    var bh5 = b5 >>> 13;
		    var b6 = b[6] | 0;
		    var bl6 = b6 & 0x1fff;
		    var bh6 = b6 >>> 13;
		    var b7 = b[7] | 0;
		    var bl7 = b7 & 0x1fff;
		    var bh7 = b7 >>> 13;
		    var b8 = b[8] | 0;
		    var bl8 = b8 & 0x1fff;
		    var bh8 = b8 >>> 13;
		    var b9 = b[9] | 0;
		    var bl9 = b9 & 0x1fff;
		    var bh9 = b9 >>> 13;

		    out.negative = self.negative ^ num.negative;
		    out.length = 19;
		    /* k = 0 */
		    lo = Math.imul(al0, bl0);
		    mid = Math.imul(al0, bh0);
		    mid = (mid + Math.imul(ah0, bl0)) | 0;
		    hi = Math.imul(ah0, bh0);
		    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
		    w0 &= 0x3ffffff;
		    /* k = 1 */
		    lo = Math.imul(al1, bl0);
		    mid = Math.imul(al1, bh0);
		    mid = (mid + Math.imul(ah1, bl0)) | 0;
		    hi = Math.imul(ah1, bh0);
		    lo = (lo + Math.imul(al0, bl1)) | 0;
		    mid = (mid + Math.imul(al0, bh1)) | 0;
		    mid = (mid + Math.imul(ah0, bl1)) | 0;
		    hi = (hi + Math.imul(ah0, bh1)) | 0;
		    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
		    w1 &= 0x3ffffff;
		    /* k = 2 */
		    lo = Math.imul(al2, bl0);
		    mid = Math.imul(al2, bh0);
		    mid = (mid + Math.imul(ah2, bl0)) | 0;
		    hi = Math.imul(ah2, bh0);
		    lo = (lo + Math.imul(al1, bl1)) | 0;
		    mid = (mid + Math.imul(al1, bh1)) | 0;
		    mid = (mid + Math.imul(ah1, bl1)) | 0;
		    hi = (hi + Math.imul(ah1, bh1)) | 0;
		    lo = (lo + Math.imul(al0, bl2)) | 0;
		    mid = (mid + Math.imul(al0, bh2)) | 0;
		    mid = (mid + Math.imul(ah0, bl2)) | 0;
		    hi = (hi + Math.imul(ah0, bh2)) | 0;
		    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
		    w2 &= 0x3ffffff;
		    /* k = 3 */
		    lo = Math.imul(al3, bl0);
		    mid = Math.imul(al3, bh0);
		    mid = (mid + Math.imul(ah3, bl0)) | 0;
		    hi = Math.imul(ah3, bh0);
		    lo = (lo + Math.imul(al2, bl1)) | 0;
		    mid = (mid + Math.imul(al2, bh1)) | 0;
		    mid = (mid + Math.imul(ah2, bl1)) | 0;
		    hi = (hi + Math.imul(ah2, bh1)) | 0;
		    lo = (lo + Math.imul(al1, bl2)) | 0;
		    mid = (mid + Math.imul(al1, bh2)) | 0;
		    mid = (mid + Math.imul(ah1, bl2)) | 0;
		    hi = (hi + Math.imul(ah1, bh2)) | 0;
		    lo = (lo + Math.imul(al0, bl3)) | 0;
		    mid = (mid + Math.imul(al0, bh3)) | 0;
		    mid = (mid + Math.imul(ah0, bl3)) | 0;
		    hi = (hi + Math.imul(ah0, bh3)) | 0;
		    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
		    w3 &= 0x3ffffff;
		    /* k = 4 */
		    lo = Math.imul(al4, bl0);
		    mid = Math.imul(al4, bh0);
		    mid = (mid + Math.imul(ah4, bl0)) | 0;
		    hi = Math.imul(ah4, bh0);
		    lo = (lo + Math.imul(al3, bl1)) | 0;
		    mid = (mid + Math.imul(al3, bh1)) | 0;
		    mid = (mid + Math.imul(ah3, bl1)) | 0;
		    hi = (hi + Math.imul(ah3, bh1)) | 0;
		    lo = (lo + Math.imul(al2, bl2)) | 0;
		    mid = (mid + Math.imul(al2, bh2)) | 0;
		    mid = (mid + Math.imul(ah2, bl2)) | 0;
		    hi = (hi + Math.imul(ah2, bh2)) | 0;
		    lo = (lo + Math.imul(al1, bl3)) | 0;
		    mid = (mid + Math.imul(al1, bh3)) | 0;
		    mid = (mid + Math.imul(ah1, bl3)) | 0;
		    hi = (hi + Math.imul(ah1, bh3)) | 0;
		    lo = (lo + Math.imul(al0, bl4)) | 0;
		    mid = (mid + Math.imul(al0, bh4)) | 0;
		    mid = (mid + Math.imul(ah0, bl4)) | 0;
		    hi = (hi + Math.imul(ah0, bh4)) | 0;
		    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
		    w4 &= 0x3ffffff;
		    /* k = 5 */
		    lo = Math.imul(al5, bl0);
		    mid = Math.imul(al5, bh0);
		    mid = (mid + Math.imul(ah5, bl0)) | 0;
		    hi = Math.imul(ah5, bh0);
		    lo = (lo + Math.imul(al4, bl1)) | 0;
		    mid = (mid + Math.imul(al4, bh1)) | 0;
		    mid = (mid + Math.imul(ah4, bl1)) | 0;
		    hi = (hi + Math.imul(ah4, bh1)) | 0;
		    lo = (lo + Math.imul(al3, bl2)) | 0;
		    mid = (mid + Math.imul(al3, bh2)) | 0;
		    mid = (mid + Math.imul(ah3, bl2)) | 0;
		    hi = (hi + Math.imul(ah3, bh2)) | 0;
		    lo = (lo + Math.imul(al2, bl3)) | 0;
		    mid = (mid + Math.imul(al2, bh3)) | 0;
		    mid = (mid + Math.imul(ah2, bl3)) | 0;
		    hi = (hi + Math.imul(ah2, bh3)) | 0;
		    lo = (lo + Math.imul(al1, bl4)) | 0;
		    mid = (mid + Math.imul(al1, bh4)) | 0;
		    mid = (mid + Math.imul(ah1, bl4)) | 0;
		    hi = (hi + Math.imul(ah1, bh4)) | 0;
		    lo = (lo + Math.imul(al0, bl5)) | 0;
		    mid = (mid + Math.imul(al0, bh5)) | 0;
		    mid = (mid + Math.imul(ah0, bl5)) | 0;
		    hi = (hi + Math.imul(ah0, bh5)) | 0;
		    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
		    w5 &= 0x3ffffff;
		    /* k = 6 */
		    lo = Math.imul(al6, bl0);
		    mid = Math.imul(al6, bh0);
		    mid = (mid + Math.imul(ah6, bl0)) | 0;
		    hi = Math.imul(ah6, bh0);
		    lo = (lo + Math.imul(al5, bl1)) | 0;
		    mid = (mid + Math.imul(al5, bh1)) | 0;
		    mid = (mid + Math.imul(ah5, bl1)) | 0;
		    hi = (hi + Math.imul(ah5, bh1)) | 0;
		    lo = (lo + Math.imul(al4, bl2)) | 0;
		    mid = (mid + Math.imul(al4, bh2)) | 0;
		    mid = (mid + Math.imul(ah4, bl2)) | 0;
		    hi = (hi + Math.imul(ah4, bh2)) | 0;
		    lo = (lo + Math.imul(al3, bl3)) | 0;
		    mid = (mid + Math.imul(al3, bh3)) | 0;
		    mid = (mid + Math.imul(ah3, bl3)) | 0;
		    hi = (hi + Math.imul(ah3, bh3)) | 0;
		    lo = (lo + Math.imul(al2, bl4)) | 0;
		    mid = (mid + Math.imul(al2, bh4)) | 0;
		    mid = (mid + Math.imul(ah2, bl4)) | 0;
		    hi = (hi + Math.imul(ah2, bh4)) | 0;
		    lo = (lo + Math.imul(al1, bl5)) | 0;
		    mid = (mid + Math.imul(al1, bh5)) | 0;
		    mid = (mid + Math.imul(ah1, bl5)) | 0;
		    hi = (hi + Math.imul(ah1, bh5)) | 0;
		    lo = (lo + Math.imul(al0, bl6)) | 0;
		    mid = (mid + Math.imul(al0, bh6)) | 0;
		    mid = (mid + Math.imul(ah0, bl6)) | 0;
		    hi = (hi + Math.imul(ah0, bh6)) | 0;
		    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
		    w6 &= 0x3ffffff;
		    /* k = 7 */
		    lo = Math.imul(al7, bl0);
		    mid = Math.imul(al7, bh0);
		    mid = (mid + Math.imul(ah7, bl0)) | 0;
		    hi = Math.imul(ah7, bh0);
		    lo = (lo + Math.imul(al6, bl1)) | 0;
		    mid = (mid + Math.imul(al6, bh1)) | 0;
		    mid = (mid + Math.imul(ah6, bl1)) | 0;
		    hi = (hi + Math.imul(ah6, bh1)) | 0;
		    lo = (lo + Math.imul(al5, bl2)) | 0;
		    mid = (mid + Math.imul(al5, bh2)) | 0;
		    mid = (mid + Math.imul(ah5, bl2)) | 0;
		    hi = (hi + Math.imul(ah5, bh2)) | 0;
		    lo = (lo + Math.imul(al4, bl3)) | 0;
		    mid = (mid + Math.imul(al4, bh3)) | 0;
		    mid = (mid + Math.imul(ah4, bl3)) | 0;
		    hi = (hi + Math.imul(ah4, bh3)) | 0;
		    lo = (lo + Math.imul(al3, bl4)) | 0;
		    mid = (mid + Math.imul(al3, bh4)) | 0;
		    mid = (mid + Math.imul(ah3, bl4)) | 0;
		    hi = (hi + Math.imul(ah3, bh4)) | 0;
		    lo = (lo + Math.imul(al2, bl5)) | 0;
		    mid = (mid + Math.imul(al2, bh5)) | 0;
		    mid = (mid + Math.imul(ah2, bl5)) | 0;
		    hi = (hi + Math.imul(ah2, bh5)) | 0;
		    lo = (lo + Math.imul(al1, bl6)) | 0;
		    mid = (mid + Math.imul(al1, bh6)) | 0;
		    mid = (mid + Math.imul(ah1, bl6)) | 0;
		    hi = (hi + Math.imul(ah1, bh6)) | 0;
		    lo = (lo + Math.imul(al0, bl7)) | 0;
		    mid = (mid + Math.imul(al0, bh7)) | 0;
		    mid = (mid + Math.imul(ah0, bl7)) | 0;
		    hi = (hi + Math.imul(ah0, bh7)) | 0;
		    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
		    w7 &= 0x3ffffff;
		    /* k = 8 */
		    lo = Math.imul(al8, bl0);
		    mid = Math.imul(al8, bh0);
		    mid = (mid + Math.imul(ah8, bl0)) | 0;
		    hi = Math.imul(ah8, bh0);
		    lo = (lo + Math.imul(al7, bl1)) | 0;
		    mid = (mid + Math.imul(al7, bh1)) | 0;
		    mid = (mid + Math.imul(ah7, bl1)) | 0;
		    hi = (hi + Math.imul(ah7, bh1)) | 0;
		    lo = (lo + Math.imul(al6, bl2)) | 0;
		    mid = (mid + Math.imul(al6, bh2)) | 0;
		    mid = (mid + Math.imul(ah6, bl2)) | 0;
		    hi = (hi + Math.imul(ah6, bh2)) | 0;
		    lo = (lo + Math.imul(al5, bl3)) | 0;
		    mid = (mid + Math.imul(al5, bh3)) | 0;
		    mid = (mid + Math.imul(ah5, bl3)) | 0;
		    hi = (hi + Math.imul(ah5, bh3)) | 0;
		    lo = (lo + Math.imul(al4, bl4)) | 0;
		    mid = (mid + Math.imul(al4, bh4)) | 0;
		    mid = (mid + Math.imul(ah4, bl4)) | 0;
		    hi = (hi + Math.imul(ah4, bh4)) | 0;
		    lo = (lo + Math.imul(al3, bl5)) | 0;
		    mid = (mid + Math.imul(al3, bh5)) | 0;
		    mid = (mid + Math.imul(ah3, bl5)) | 0;
		    hi = (hi + Math.imul(ah3, bh5)) | 0;
		    lo = (lo + Math.imul(al2, bl6)) | 0;
		    mid = (mid + Math.imul(al2, bh6)) | 0;
		    mid = (mid + Math.imul(ah2, bl6)) | 0;
		    hi = (hi + Math.imul(ah2, bh6)) | 0;
		    lo = (lo + Math.imul(al1, bl7)) | 0;
		    mid = (mid + Math.imul(al1, bh7)) | 0;
		    mid = (mid + Math.imul(ah1, bl7)) | 0;
		    hi = (hi + Math.imul(ah1, bh7)) | 0;
		    lo = (lo + Math.imul(al0, bl8)) | 0;
		    mid = (mid + Math.imul(al0, bh8)) | 0;
		    mid = (mid + Math.imul(ah0, bl8)) | 0;
		    hi = (hi + Math.imul(ah0, bh8)) | 0;
		    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
		    w8 &= 0x3ffffff;
		    /* k = 9 */
		    lo = Math.imul(al9, bl0);
		    mid = Math.imul(al9, bh0);
		    mid = (mid + Math.imul(ah9, bl0)) | 0;
		    hi = Math.imul(ah9, bh0);
		    lo = (lo + Math.imul(al8, bl1)) | 0;
		    mid = (mid + Math.imul(al8, bh1)) | 0;
		    mid = (mid + Math.imul(ah8, bl1)) | 0;
		    hi = (hi + Math.imul(ah8, bh1)) | 0;
		    lo = (lo + Math.imul(al7, bl2)) | 0;
		    mid = (mid + Math.imul(al7, bh2)) | 0;
		    mid = (mid + Math.imul(ah7, bl2)) | 0;
		    hi = (hi + Math.imul(ah7, bh2)) | 0;
		    lo = (lo + Math.imul(al6, bl3)) | 0;
		    mid = (mid + Math.imul(al6, bh3)) | 0;
		    mid = (mid + Math.imul(ah6, bl3)) | 0;
		    hi = (hi + Math.imul(ah6, bh3)) | 0;
		    lo = (lo + Math.imul(al5, bl4)) | 0;
		    mid = (mid + Math.imul(al5, bh4)) | 0;
		    mid = (mid + Math.imul(ah5, bl4)) | 0;
		    hi = (hi + Math.imul(ah5, bh4)) | 0;
		    lo = (lo + Math.imul(al4, bl5)) | 0;
		    mid = (mid + Math.imul(al4, bh5)) | 0;
		    mid = (mid + Math.imul(ah4, bl5)) | 0;
		    hi = (hi + Math.imul(ah4, bh5)) | 0;
		    lo = (lo + Math.imul(al3, bl6)) | 0;
		    mid = (mid + Math.imul(al3, bh6)) | 0;
		    mid = (mid + Math.imul(ah3, bl6)) | 0;
		    hi = (hi + Math.imul(ah3, bh6)) | 0;
		    lo = (lo + Math.imul(al2, bl7)) | 0;
		    mid = (mid + Math.imul(al2, bh7)) | 0;
		    mid = (mid + Math.imul(ah2, bl7)) | 0;
		    hi = (hi + Math.imul(ah2, bh7)) | 0;
		    lo = (lo + Math.imul(al1, bl8)) | 0;
		    mid = (mid + Math.imul(al1, bh8)) | 0;
		    mid = (mid + Math.imul(ah1, bl8)) | 0;
		    hi = (hi + Math.imul(ah1, bh8)) | 0;
		    lo = (lo + Math.imul(al0, bl9)) | 0;
		    mid = (mid + Math.imul(al0, bh9)) | 0;
		    mid = (mid + Math.imul(ah0, bl9)) | 0;
		    hi = (hi + Math.imul(ah0, bh9)) | 0;
		    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
		    w9 &= 0x3ffffff;
		    /* k = 10 */
		    lo = Math.imul(al9, bl1);
		    mid = Math.imul(al9, bh1);
		    mid = (mid + Math.imul(ah9, bl1)) | 0;
		    hi = Math.imul(ah9, bh1);
		    lo = (lo + Math.imul(al8, bl2)) | 0;
		    mid = (mid + Math.imul(al8, bh2)) | 0;
		    mid = (mid + Math.imul(ah8, bl2)) | 0;
		    hi = (hi + Math.imul(ah8, bh2)) | 0;
		    lo = (lo + Math.imul(al7, bl3)) | 0;
		    mid = (mid + Math.imul(al7, bh3)) | 0;
		    mid = (mid + Math.imul(ah7, bl3)) | 0;
		    hi = (hi + Math.imul(ah7, bh3)) | 0;
		    lo = (lo + Math.imul(al6, bl4)) | 0;
		    mid = (mid + Math.imul(al6, bh4)) | 0;
		    mid = (mid + Math.imul(ah6, bl4)) | 0;
		    hi = (hi + Math.imul(ah6, bh4)) | 0;
		    lo = (lo + Math.imul(al5, bl5)) | 0;
		    mid = (mid + Math.imul(al5, bh5)) | 0;
		    mid = (mid + Math.imul(ah5, bl5)) | 0;
		    hi = (hi + Math.imul(ah5, bh5)) | 0;
		    lo = (lo + Math.imul(al4, bl6)) | 0;
		    mid = (mid + Math.imul(al4, bh6)) | 0;
		    mid = (mid + Math.imul(ah4, bl6)) | 0;
		    hi = (hi + Math.imul(ah4, bh6)) | 0;
		    lo = (lo + Math.imul(al3, bl7)) | 0;
		    mid = (mid + Math.imul(al3, bh7)) | 0;
		    mid = (mid + Math.imul(ah3, bl7)) | 0;
		    hi = (hi + Math.imul(ah3, bh7)) | 0;
		    lo = (lo + Math.imul(al2, bl8)) | 0;
		    mid = (mid + Math.imul(al2, bh8)) | 0;
		    mid = (mid + Math.imul(ah2, bl8)) | 0;
		    hi = (hi + Math.imul(ah2, bh8)) | 0;
		    lo = (lo + Math.imul(al1, bl9)) | 0;
		    mid = (mid + Math.imul(al1, bh9)) | 0;
		    mid = (mid + Math.imul(ah1, bl9)) | 0;
		    hi = (hi + Math.imul(ah1, bh9)) | 0;
		    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
		    w10 &= 0x3ffffff;
		    /* k = 11 */
		    lo = Math.imul(al9, bl2);
		    mid = Math.imul(al9, bh2);
		    mid = (mid + Math.imul(ah9, bl2)) | 0;
		    hi = Math.imul(ah9, bh2);
		    lo = (lo + Math.imul(al8, bl3)) | 0;
		    mid = (mid + Math.imul(al8, bh3)) | 0;
		    mid = (mid + Math.imul(ah8, bl3)) | 0;
		    hi = (hi + Math.imul(ah8, bh3)) | 0;
		    lo = (lo + Math.imul(al7, bl4)) | 0;
		    mid = (mid + Math.imul(al7, bh4)) | 0;
		    mid = (mid + Math.imul(ah7, bl4)) | 0;
		    hi = (hi + Math.imul(ah7, bh4)) | 0;
		    lo = (lo + Math.imul(al6, bl5)) | 0;
		    mid = (mid + Math.imul(al6, bh5)) | 0;
		    mid = (mid + Math.imul(ah6, bl5)) | 0;
		    hi = (hi + Math.imul(ah6, bh5)) | 0;
		    lo = (lo + Math.imul(al5, bl6)) | 0;
		    mid = (mid + Math.imul(al5, bh6)) | 0;
		    mid = (mid + Math.imul(ah5, bl6)) | 0;
		    hi = (hi + Math.imul(ah5, bh6)) | 0;
		    lo = (lo + Math.imul(al4, bl7)) | 0;
		    mid = (mid + Math.imul(al4, bh7)) | 0;
		    mid = (mid + Math.imul(ah4, bl7)) | 0;
		    hi = (hi + Math.imul(ah4, bh7)) | 0;
		    lo = (lo + Math.imul(al3, bl8)) | 0;
		    mid = (mid + Math.imul(al3, bh8)) | 0;
		    mid = (mid + Math.imul(ah3, bl8)) | 0;
		    hi = (hi + Math.imul(ah3, bh8)) | 0;
		    lo = (lo + Math.imul(al2, bl9)) | 0;
		    mid = (mid + Math.imul(al2, bh9)) | 0;
		    mid = (mid + Math.imul(ah2, bl9)) | 0;
		    hi = (hi + Math.imul(ah2, bh9)) | 0;
		    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
		    w11 &= 0x3ffffff;
		    /* k = 12 */
		    lo = Math.imul(al9, bl3);
		    mid = Math.imul(al9, bh3);
		    mid = (mid + Math.imul(ah9, bl3)) | 0;
		    hi = Math.imul(ah9, bh3);
		    lo = (lo + Math.imul(al8, bl4)) | 0;
		    mid = (mid + Math.imul(al8, bh4)) | 0;
		    mid = (mid + Math.imul(ah8, bl4)) | 0;
		    hi = (hi + Math.imul(ah8, bh4)) | 0;
		    lo = (lo + Math.imul(al7, bl5)) | 0;
		    mid = (mid + Math.imul(al7, bh5)) | 0;
		    mid = (mid + Math.imul(ah7, bl5)) | 0;
		    hi = (hi + Math.imul(ah7, bh5)) | 0;
		    lo = (lo + Math.imul(al6, bl6)) | 0;
		    mid = (mid + Math.imul(al6, bh6)) | 0;
		    mid = (mid + Math.imul(ah6, bl6)) | 0;
		    hi = (hi + Math.imul(ah6, bh6)) | 0;
		    lo = (lo + Math.imul(al5, bl7)) | 0;
		    mid = (mid + Math.imul(al5, bh7)) | 0;
		    mid = (mid + Math.imul(ah5, bl7)) | 0;
		    hi = (hi + Math.imul(ah5, bh7)) | 0;
		    lo = (lo + Math.imul(al4, bl8)) | 0;
		    mid = (mid + Math.imul(al4, bh8)) | 0;
		    mid = (mid + Math.imul(ah4, bl8)) | 0;
		    hi = (hi + Math.imul(ah4, bh8)) | 0;
		    lo = (lo + Math.imul(al3, bl9)) | 0;
		    mid = (mid + Math.imul(al3, bh9)) | 0;
		    mid = (mid + Math.imul(ah3, bl9)) | 0;
		    hi = (hi + Math.imul(ah3, bh9)) | 0;
		    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
		    w12 &= 0x3ffffff;
		    /* k = 13 */
		    lo = Math.imul(al9, bl4);
		    mid = Math.imul(al9, bh4);
		    mid = (mid + Math.imul(ah9, bl4)) | 0;
		    hi = Math.imul(ah9, bh4);
		    lo = (lo + Math.imul(al8, bl5)) | 0;
		    mid = (mid + Math.imul(al8, bh5)) | 0;
		    mid = (mid + Math.imul(ah8, bl5)) | 0;
		    hi = (hi + Math.imul(ah8, bh5)) | 0;
		    lo = (lo + Math.imul(al7, bl6)) | 0;
		    mid = (mid + Math.imul(al7, bh6)) | 0;
		    mid = (mid + Math.imul(ah7, bl6)) | 0;
		    hi = (hi + Math.imul(ah7, bh6)) | 0;
		    lo = (lo + Math.imul(al6, bl7)) | 0;
		    mid = (mid + Math.imul(al6, bh7)) | 0;
		    mid = (mid + Math.imul(ah6, bl7)) | 0;
		    hi = (hi + Math.imul(ah6, bh7)) | 0;
		    lo = (lo + Math.imul(al5, bl8)) | 0;
		    mid = (mid + Math.imul(al5, bh8)) | 0;
		    mid = (mid + Math.imul(ah5, bl8)) | 0;
		    hi = (hi + Math.imul(ah5, bh8)) | 0;
		    lo = (lo + Math.imul(al4, bl9)) | 0;
		    mid = (mid + Math.imul(al4, bh9)) | 0;
		    mid = (mid + Math.imul(ah4, bl9)) | 0;
		    hi = (hi + Math.imul(ah4, bh9)) | 0;
		    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
		    w13 &= 0x3ffffff;
		    /* k = 14 */
		    lo = Math.imul(al9, bl5);
		    mid = Math.imul(al9, bh5);
		    mid = (mid + Math.imul(ah9, bl5)) | 0;
		    hi = Math.imul(ah9, bh5);
		    lo = (lo + Math.imul(al8, bl6)) | 0;
		    mid = (mid + Math.imul(al8, bh6)) | 0;
		    mid = (mid + Math.imul(ah8, bl6)) | 0;
		    hi = (hi + Math.imul(ah8, bh6)) | 0;
		    lo = (lo + Math.imul(al7, bl7)) | 0;
		    mid = (mid + Math.imul(al7, bh7)) | 0;
		    mid = (mid + Math.imul(ah7, bl7)) | 0;
		    hi = (hi + Math.imul(ah7, bh7)) | 0;
		    lo = (lo + Math.imul(al6, bl8)) | 0;
		    mid = (mid + Math.imul(al6, bh8)) | 0;
		    mid = (mid + Math.imul(ah6, bl8)) | 0;
		    hi = (hi + Math.imul(ah6, bh8)) | 0;
		    lo = (lo + Math.imul(al5, bl9)) | 0;
		    mid = (mid + Math.imul(al5, bh9)) | 0;
		    mid = (mid + Math.imul(ah5, bl9)) | 0;
		    hi = (hi + Math.imul(ah5, bh9)) | 0;
		    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
		    w14 &= 0x3ffffff;
		    /* k = 15 */
		    lo = Math.imul(al9, bl6);
		    mid = Math.imul(al9, bh6);
		    mid = (mid + Math.imul(ah9, bl6)) | 0;
		    hi = Math.imul(ah9, bh6);
		    lo = (lo + Math.imul(al8, bl7)) | 0;
		    mid = (mid + Math.imul(al8, bh7)) | 0;
		    mid = (mid + Math.imul(ah8, bl7)) | 0;
		    hi = (hi + Math.imul(ah8, bh7)) | 0;
		    lo = (lo + Math.imul(al7, bl8)) | 0;
		    mid = (mid + Math.imul(al7, bh8)) | 0;
		    mid = (mid + Math.imul(ah7, bl8)) | 0;
		    hi = (hi + Math.imul(ah7, bh8)) | 0;
		    lo = (lo + Math.imul(al6, bl9)) | 0;
		    mid = (mid + Math.imul(al6, bh9)) | 0;
		    mid = (mid + Math.imul(ah6, bl9)) | 0;
		    hi = (hi + Math.imul(ah6, bh9)) | 0;
		    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
		    w15 &= 0x3ffffff;
		    /* k = 16 */
		    lo = Math.imul(al9, bl7);
		    mid = Math.imul(al9, bh7);
		    mid = (mid + Math.imul(ah9, bl7)) | 0;
		    hi = Math.imul(ah9, bh7);
		    lo = (lo + Math.imul(al8, bl8)) | 0;
		    mid = (mid + Math.imul(al8, bh8)) | 0;
		    mid = (mid + Math.imul(ah8, bl8)) | 0;
		    hi = (hi + Math.imul(ah8, bh8)) | 0;
		    lo = (lo + Math.imul(al7, bl9)) | 0;
		    mid = (mid + Math.imul(al7, bh9)) | 0;
		    mid = (mid + Math.imul(ah7, bl9)) | 0;
		    hi = (hi + Math.imul(ah7, bh9)) | 0;
		    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
		    w16 &= 0x3ffffff;
		    /* k = 17 */
		    lo = Math.imul(al9, bl8);
		    mid = Math.imul(al9, bh8);
		    mid = (mid + Math.imul(ah9, bl8)) | 0;
		    hi = Math.imul(ah9, bh8);
		    lo = (lo + Math.imul(al8, bl9)) | 0;
		    mid = (mid + Math.imul(al8, bh9)) | 0;
		    mid = (mid + Math.imul(ah8, bl9)) | 0;
		    hi = (hi + Math.imul(ah8, bh9)) | 0;
		    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
		    w17 &= 0x3ffffff;
		    /* k = 18 */
		    lo = Math.imul(al9, bl9);
		    mid = Math.imul(al9, bh9);
		    mid = (mid + Math.imul(ah9, bl9)) | 0;
		    hi = Math.imul(ah9, bh9);
		    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
		    w18 &= 0x3ffffff;
		    o[0] = w0;
		    o[1] = w1;
		    o[2] = w2;
		    o[3] = w3;
		    o[4] = w4;
		    o[5] = w5;
		    o[6] = w6;
		    o[7] = w7;
		    o[8] = w8;
		    o[9] = w9;
		    o[10] = w10;
		    o[11] = w11;
		    o[12] = w12;
		    o[13] = w13;
		    o[14] = w14;
		    o[15] = w15;
		    o[16] = w16;
		    o[17] = w17;
		    o[18] = w18;
		    if (c !== 0) {
		      o[19] = c;
		      out.length++;
		    }
		    return out;
		  };

		  // Polyfill comb
		  if (!Math.imul) {
		    comb10MulTo = smallMulTo;
		  }

		  function bigMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    out.length = self.length + num.length;

		    var carry = 0;
		    var hncarry = 0;
		    for (var k = 0; k < out.length - 1; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = hncarry;
		      hncarry = 0;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = k - j;
		        var a = self.words[i] | 0;
		        var b = num.words[j] | 0;
		        var r = a * b;

		        var lo = r & 0x3ffffff;
		        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
		        lo = (lo + rword) | 0;
		        rword = lo & 0x3ffffff;
		        ncarry = (ncarry + (lo >>> 26)) | 0;

		        hncarry += ncarry >>> 26;
		        ncarry &= 0x3ffffff;
		      }
		      out.words[k] = rword;
		      carry = ncarry;
		      ncarry = hncarry;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry;
		    } else {
		      out.length--;
		    }

		    return out._strip();
		  }

		  function jumboMulTo (self, num, out) {
		    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
		    // var fftm = new FFTM();
		    // return fftm.mulp(self, num, out);
		    return bigMulTo(self, num, out);
		  }

		  BN.prototype.mulTo = function mulTo (num, out) {
		    var res;
		    var len = this.length + num.length;
		    if (this.length === 10 && num.length === 10) {
		      res = comb10MulTo(this, num, out);
		    } else if (len < 63) {
		      res = smallMulTo(this, num, out);
		    } else if (len < 1024) {
		      res = bigMulTo(this, num, out);
		    } else {
		      res = jumboMulTo(this, num, out);
		    }

		    return res;
		  };

		  // Multiply `this` by `num`
		  BN.prototype.mul = function mul (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return this.mulTo(num, out);
		  };

		  // Multiply employing FFT
		  BN.prototype.mulf = function mulf (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return jumboMulTo(this, num, out);
		  };

		  // In-place Multiplication
		  BN.prototype.imul = function imul (num) {
		    return this.clone().mulTo(num, this);
		  };

		  BN.prototype.imuln = function imuln (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(typeof num === 'number');
		    assert(num < 0x4000000);

		    // Carry
		    var carry = 0;
		    for (var i = 0; i < this.length; i++) {
		      var w = (this.words[i] | 0) * num;
		      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
		      carry >>= 26;
		      carry += (w / 0x4000000) | 0;
		      // NOTE: lo is 27bit maximum
		      carry += lo >>> 26;
		      this.words[i] = lo & 0x3ffffff;
		    }

		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }

		    return isNegNum ? this.ineg() : this;
		  };

		  BN.prototype.muln = function muln (num) {
		    return this.clone().imuln(num);
		  };

		  // `this` * `this`
		  BN.prototype.sqr = function sqr () {
		    return this.mul(this);
		  };

		  // `this` * `this` in-place
		  BN.prototype.isqr = function isqr () {
		    return this.imul(this.clone());
		  };

		  // Math.pow(`this`, `num`)
		  BN.prototype.pow = function pow (num) {
		    var w = toBitArray(num);
		    if (w.length === 0) return new BN(1);

		    // Skip leading zeroes
		    var res = this;
		    for (var i = 0; i < w.length; i++, res = res.sqr()) {
		      if (w[i] !== 0) break;
		    }

		    if (++i < w.length) {
		      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
		        if (w[i] === 0) continue;

		        res = res.mul(q);
		      }
		    }

		    return res;
		  };

		  // Shift-left in-place
		  BN.prototype.iushln = function iushln (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;
		    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
		    var i;

		    if (r !== 0) {
		      var carry = 0;

		      for (i = 0; i < this.length; i++) {
		        var newCarry = this.words[i] & carryMask;
		        var c = ((this.words[i] | 0) - newCarry) << r;
		        this.words[i] = c | carry;
		        carry = newCarry >>> (26 - r);
		      }

		      if (carry) {
		        this.words[i] = carry;
		        this.length++;
		      }
		    }

		    if (s !== 0) {
		      for (i = this.length - 1; i >= 0; i--) {
		        this.words[i + s] = this.words[i];
		      }

		      for (i = 0; i < s; i++) {
		        this.words[i] = 0;
		      }

		      this.length += s;
		    }

		    return this._strip();
		  };

		  BN.prototype.ishln = function ishln (bits) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushln(bits);
		  };

		  // Shift-right in-place
		  // NOTE: `hint` is a lowest bit before trailing zeroes
		  // NOTE: if `extended` is present - it will be filled with destroyed bits
		  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var h;
		    if (hint) {
		      h = (hint - (hint % 26)) / 26;
		    } else {
		      h = 0;
		    }

		    var r = bits % 26;
		    var s = Math.min((bits - r) / 26, this.length);
		    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		    var maskedWords = extended;

		    h -= s;
		    h = Math.max(0, h);

		    // Extended mode, copy masked part
		    if (maskedWords) {
		      for (var i = 0; i < s; i++) {
		        maskedWords.words[i] = this.words[i];
		      }
		      maskedWords.length = s;
		    }

		    if (s === 0) ; else if (this.length > s) {
		      this.length -= s;
		      for (i = 0; i < this.length; i++) {
		        this.words[i] = this.words[i + s];
		      }
		    } else {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    var carry = 0;
		    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
		      var word = this.words[i] | 0;
		      this.words[i] = (carry << (26 - r)) | (word >>> r);
		      carry = word & mask;
		    }

		    // Push carried bits as a mask
		    if (maskedWords && carry !== 0) {
		      maskedWords.words[maskedWords.length++] = carry;
		    }

		    if (this.length === 0) {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    return this._strip();
		  };

		  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushrn(bits, hint, extended);
		  };

		  // Shift-left
		  BN.prototype.shln = function shln (bits) {
		    return this.clone().ishln(bits);
		  };

		  BN.prototype.ushln = function ushln (bits) {
		    return this.clone().iushln(bits);
		  };

		  // Shift-right
		  BN.prototype.shrn = function shrn (bits) {
		    return this.clone().ishrn(bits);
		  };

		  BN.prototype.ushrn = function ushrn (bits) {
		    return this.clone().iushrn(bits);
		  };

		  // Test if n bit is set
		  BN.prototype.testn = function testn (bit) {
		    assert(typeof bit === 'number' && bit >= 0);
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) return false;

		    // Check bit and return
		    var w = this.words[s];

		    return !!(w & q);
		  };

		  // Return only lowers bits of number (in-place)
		  BN.prototype.imaskn = function imaskn (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;

		    assert(this.negative === 0, 'imaskn works only with positive numbers');

		    if (this.length <= s) {
		      return this;
		    }

		    if (r !== 0) {
		      s++;
		    }
		    this.length = Math.min(s, this.length);

		    if (r !== 0) {
		      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		      this.words[this.length - 1] &= mask;
		    }

		    return this._strip();
		  };

		  // Return only lowers bits of number
		  BN.prototype.maskn = function maskn (bits) {
		    return this.clone().imaskn(bits);
		  };

		  // Add plain number `num` to `this`
		  BN.prototype.iaddn = function iaddn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.isubn(-num);

		    // Possible sign change
		    if (this.negative !== 0) {
		      if (this.length === 1 && (this.words[0] | 0) <= num) {
		        this.words[0] = num - (this.words[0] | 0);
		        this.negative = 0;
		        return this;
		      }

		      this.negative = 0;
		      this.isubn(num);
		      this.negative = 1;
		      return this;
		    }

		    // Add without checks
		    return this._iaddn(num);
		  };

		  BN.prototype._iaddn = function _iaddn (num) {
		    this.words[0] += num;

		    // Carry
		    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
		      this.words[i] -= 0x4000000;
		      if (i === this.length - 1) {
		        this.words[i + 1] = 1;
		      } else {
		        this.words[i + 1]++;
		      }
		    }
		    this.length = Math.max(this.length, i + 1);

		    return this;
		  };

		  // Subtract plain number `num` from `this`
		  BN.prototype.isubn = function isubn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.iaddn(-num);

		    if (this.negative !== 0) {
		      this.negative = 0;
		      this.iaddn(num);
		      this.negative = 1;
		      return this;
		    }

		    this.words[0] -= num;

		    if (this.length === 1 && this.words[0] < 0) {
		      this.words[0] = -this.words[0];
		      this.negative = 1;
		    } else {
		      // Carry
		      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
		        this.words[i] += 0x4000000;
		        this.words[i + 1] -= 1;
		      }
		    }

		    return this._strip();
		  };

		  BN.prototype.addn = function addn (num) {
		    return this.clone().iaddn(num);
		  };

		  BN.prototype.subn = function subn (num) {
		    return this.clone().isubn(num);
		  };

		  BN.prototype.iabs = function iabs () {
		    this.negative = 0;

		    return this;
		  };

		  BN.prototype.abs = function abs () {
		    return this.clone().iabs();
		  };

		  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
		    var len = num.length + shift;
		    var i;

		    this._expand(len);

		    var w;
		    var carry = 0;
		    for (i = 0; i < num.length; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      var right = (num.words[i] | 0) * mul;
		      w -= right & 0x3ffffff;
		      carry = (w >> 26) - ((right / 0x4000000) | 0);
		      this.words[i + shift] = w & 0x3ffffff;
		    }
		    for (; i < this.length - shift; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      carry = w >> 26;
		      this.words[i + shift] = w & 0x3ffffff;
		    }

		    if (carry === 0) return this._strip();

		    // Subtraction overflow
		    assert(carry === -1);
		    carry = 0;
		    for (i = 0; i < this.length; i++) {
		      w = -(this.words[i] | 0) + carry;
		      carry = w >> 26;
		      this.words[i] = w & 0x3ffffff;
		    }
		    this.negative = 1;

		    return this._strip();
		  };

		  BN.prototype._wordDiv = function _wordDiv (num, mode) {
		    var shift = this.length - num.length;

		    var a = this.clone();
		    var b = num;

		    // Normalize
		    var bhi = b.words[b.length - 1] | 0;
		    var bhiBits = this._countBits(bhi);
		    shift = 26 - bhiBits;
		    if (shift !== 0) {
		      b = b.ushln(shift);
		      a.iushln(shift);
		      bhi = b.words[b.length - 1] | 0;
		    }

		    // Initialize quotient
		    var m = a.length - b.length;
		    var q;

		    if (mode !== 'mod') {
		      q = new BN(null);
		      q.length = m + 1;
		      q.words = new Array(q.length);
		      for (var i = 0; i < q.length; i++) {
		        q.words[i] = 0;
		      }
		    }

		    var diff = a.clone()._ishlnsubmul(b, 1, m);
		    if (diff.negative === 0) {
		      a = diff;
		      if (q) {
		        q.words[m] = 1;
		      }
		    }

		    for (var j = m - 1; j >= 0; j--) {
		      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
		        (a.words[b.length + j - 1] | 0);

		      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
		      // (0x7ffffff)
		      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

		      a._ishlnsubmul(b, qj, j);
		      while (a.negative !== 0) {
		        qj--;
		        a.negative = 0;
		        a._ishlnsubmul(b, 1, j);
		        if (!a.isZero()) {
		          a.negative ^= 1;
		        }
		      }
		      if (q) {
		        q.words[j] = qj;
		      }
		    }
		    if (q) {
		      q._strip();
		    }
		    a._strip();

		    // Denormalize
		    if (mode !== 'div' && shift !== 0) {
		      a.iushrn(shift);
		    }

		    return {
		      div: q || null,
		      mod: a
		    };
		  };

		  // NOTE: 1) `mode` can be set to `mod` to request mod only,
		  //       to `div` to request div only, or be absent to
		  //       request both div & mod
		  //       2) `positive` is true if unsigned mod is requested
		  BN.prototype.divmod = function divmod (num, mode, positive) {
		    assert(!num.isZero());

		    if (this.isZero()) {
		      return {
		        div: new BN(0),
		        mod: new BN(0)
		      };
		    }

		    var div, mod, res;
		    if (this.negative !== 0 && num.negative === 0) {
		      res = this.neg().divmod(num, mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.iadd(num);
		        }
		      }

		      return {
		        div: div,
		        mod: mod
		      };
		    }

		    if (this.negative === 0 && num.negative !== 0) {
		      res = this.divmod(num.neg(), mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      return {
		        div: div,
		        mod: res.mod
		      };
		    }

		    if ((this.negative & num.negative) !== 0) {
		      res = this.neg().divmod(num.neg(), mode);

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.isub(num);
		        }
		      }

		      return {
		        div: res.div,
		        mod: mod
		      };
		    }

		    // Both numbers are positive at this point

		    // Strip both numbers to approximate shift value
		    if (num.length > this.length || this.cmp(num) < 0) {
		      return {
		        div: new BN(0),
		        mod: this
		      };
		    }

		    // Very short reduction
		    if (num.length === 1) {
		      if (mode === 'div') {
		        return {
		          div: this.divn(num.words[0]),
		          mod: null
		        };
		      }

		      if (mode === 'mod') {
		        return {
		          div: null,
		          mod: new BN(this.modrn(num.words[0]))
		        };
		      }

		      return {
		        div: this.divn(num.words[0]),
		        mod: new BN(this.modrn(num.words[0]))
		      };
		    }

		    return this._wordDiv(num, mode);
		  };

		  // Find `this` / `num`
		  BN.prototype.div = function div (num) {
		    return this.divmod(num, 'div', false).div;
		  };

		  // Find `this` % `num`
		  BN.prototype.mod = function mod (num) {
		    return this.divmod(num, 'mod', false).mod;
		  };

		  BN.prototype.umod = function umod (num) {
		    return this.divmod(num, 'mod', true).mod;
		  };

		  // Find Round(`this` / `num`)
		  BN.prototype.divRound = function divRound (num) {
		    var dm = this.divmod(num);

		    // Fast case - exact division
		    if (dm.mod.isZero()) return dm.div;

		    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

		    var half = num.ushrn(1);
		    var r2 = num.andln(1);
		    var cmp = mod.cmp(half);

		    // Round down
		    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

		    // Round up
		    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
		  };

		  BN.prototype.modrn = function modrn (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(num <= 0x3ffffff);
		    var p = (1 << 26) % num;

		    var acc = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      acc = (p * acc + (this.words[i] | 0)) % num;
		    }

		    return isNegNum ? -acc : acc;
		  };

		  // WARNING: DEPRECATED
		  BN.prototype.modn = function modn (num) {
		    return this.modrn(num);
		  };

		  // In-place division by number
		  BN.prototype.idivn = function idivn (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(num <= 0x3ffffff);

		    var carry = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var w = (this.words[i] | 0) + carry * 0x4000000;
		      this.words[i] = (w / num) | 0;
		      carry = w % num;
		    }

		    this._strip();
		    return isNegNum ? this.ineg() : this;
		  };

		  BN.prototype.divn = function divn (num) {
		    return this.clone().idivn(num);
		  };

		  BN.prototype.egcd = function egcd (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var x = this;
		    var y = p.clone();

		    if (x.negative !== 0) {
		      x = x.umod(p);
		    } else {
		      x = x.clone();
		    }

		    // A * x + B * y = x
		    var A = new BN(1);
		    var B = new BN(0);

		    // C * x + D * y = y
		    var C = new BN(0);
		    var D = new BN(1);

		    var g = 0;

		    while (x.isEven() && y.isEven()) {
		      x.iushrn(1);
		      y.iushrn(1);
		      ++g;
		    }

		    var yp = y.clone();
		    var xp = x.clone();

		    while (!x.isZero()) {
		      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        x.iushrn(i);
		        while (i-- > 0) {
		          if (A.isOdd() || B.isOdd()) {
		            A.iadd(yp);
		            B.isub(xp);
		          }

		          A.iushrn(1);
		          B.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        y.iushrn(j);
		        while (j-- > 0) {
		          if (C.isOdd() || D.isOdd()) {
		            C.iadd(yp);
		            D.isub(xp);
		          }

		          C.iushrn(1);
		          D.iushrn(1);
		        }
		      }

		      if (x.cmp(y) >= 0) {
		        x.isub(y);
		        A.isub(C);
		        B.isub(D);
		      } else {
		        y.isub(x);
		        C.isub(A);
		        D.isub(B);
		      }
		    }

		    return {
		      a: C,
		      b: D,
		      gcd: y.iushln(g)
		    };
		  };

		  // This is reduced incarnation of the binary EEA
		  // above, designated to invert members of the
		  // _prime_ fields F(p) at a maximal speed
		  BN.prototype._invmp = function _invmp (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var a = this;
		    var b = p.clone();

		    if (a.negative !== 0) {
		      a = a.umod(p);
		    } else {
		      a = a.clone();
		    }

		    var x1 = new BN(1);
		    var x2 = new BN(0);

		    var delta = b.clone();

		    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
		      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        a.iushrn(i);
		        while (i-- > 0) {
		          if (x1.isOdd()) {
		            x1.iadd(delta);
		          }

		          x1.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        b.iushrn(j);
		        while (j-- > 0) {
		          if (x2.isOdd()) {
		            x2.iadd(delta);
		          }

		          x2.iushrn(1);
		        }
		      }

		      if (a.cmp(b) >= 0) {
		        a.isub(b);
		        x1.isub(x2);
		      } else {
		        b.isub(a);
		        x2.isub(x1);
		      }
		    }

		    var res;
		    if (a.cmpn(1) === 0) {
		      res = x1;
		    } else {
		      res = x2;
		    }

		    if (res.cmpn(0) < 0) {
		      res.iadd(p);
		    }

		    return res;
		  };

		  BN.prototype.gcd = function gcd (num) {
		    if (this.isZero()) return num.abs();
		    if (num.isZero()) return this.abs();

		    var a = this.clone();
		    var b = num.clone();
		    a.negative = 0;
		    b.negative = 0;

		    // Remove common factor of two
		    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
		      a.iushrn(1);
		      b.iushrn(1);
		    }

		    do {
		      while (a.isEven()) {
		        a.iushrn(1);
		      }
		      while (b.isEven()) {
		        b.iushrn(1);
		      }

		      var r = a.cmp(b);
		      if (r < 0) {
		        // Swap `a` and `b` to make `a` always bigger than `b`
		        var t = a;
		        a = b;
		        b = t;
		      } else if (r === 0 || b.cmpn(1) === 0) {
		        break;
		      }

		      a.isub(b);
		    } while (true);

		    return b.iushln(shift);
		  };

		  // Invert number in the field F(num)
		  BN.prototype.invm = function invm (num) {
		    return this.egcd(num).a.umod(num);
		  };

		  BN.prototype.isEven = function isEven () {
		    return (this.words[0] & 1) === 0;
		  };

		  BN.prototype.isOdd = function isOdd () {
		    return (this.words[0] & 1) === 1;
		  };

		  // And first word and num
		  BN.prototype.andln = function andln (num) {
		    return this.words[0] & num;
		  };

		  // Increment at the bit position in-line
		  BN.prototype.bincn = function bincn (bit) {
		    assert(typeof bit === 'number');
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) {
		      this._expand(s + 1);
		      this.words[s] |= q;
		      return this;
		    }

		    // Add bit and propagate, if needed
		    var carry = q;
		    for (var i = s; carry !== 0 && i < this.length; i++) {
		      var w = this.words[i] | 0;
		      w += carry;
		      carry = w >>> 26;
		      w &= 0x3ffffff;
		      this.words[i] = w;
		    }
		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }
		    return this;
		  };

		  BN.prototype.isZero = function isZero () {
		    return this.length === 1 && this.words[0] === 0;
		  };

		  BN.prototype.cmpn = function cmpn (num) {
		    var negative = num < 0;

		    if (this.negative !== 0 && !negative) return -1;
		    if (this.negative === 0 && negative) return 1;

		    this._strip();

		    var res;
		    if (this.length > 1) {
		      res = 1;
		    } else {
		      if (negative) {
		        num = -num;
		      }

		      assert(num <= 0x3ffffff, 'Number is too big');

		      var w = this.words[0] | 0;
		      res = w === num ? 0 : w < num ? -1 : 1;
		    }
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Compare two numbers and return:
		  // 1 - if `this` > `num`
		  // 0 - if `this` == `num`
		  // -1 - if `this` < `num`
		  BN.prototype.cmp = function cmp (num) {
		    if (this.negative !== 0 && num.negative === 0) return -1;
		    if (this.negative === 0 && num.negative !== 0) return 1;

		    var res = this.ucmp(num);
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Unsigned comparison
		  BN.prototype.ucmp = function ucmp (num) {
		    // At this point both numbers have the same sign
		    if (this.length > num.length) return 1;
		    if (this.length < num.length) return -1;

		    var res = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var a = this.words[i] | 0;
		      var b = num.words[i] | 0;

		      if (a === b) continue;
		      if (a < b) {
		        res = -1;
		      } else if (a > b) {
		        res = 1;
		      }
		      break;
		    }
		    return res;
		  };

		  BN.prototype.gtn = function gtn (num) {
		    return this.cmpn(num) === 1;
		  };

		  BN.prototype.gt = function gt (num) {
		    return this.cmp(num) === 1;
		  };

		  BN.prototype.gten = function gten (num) {
		    return this.cmpn(num) >= 0;
		  };

		  BN.prototype.gte = function gte (num) {
		    return this.cmp(num) >= 0;
		  };

		  BN.prototype.ltn = function ltn (num) {
		    return this.cmpn(num) === -1;
		  };

		  BN.prototype.lt = function lt (num) {
		    return this.cmp(num) === -1;
		  };

		  BN.prototype.lten = function lten (num) {
		    return this.cmpn(num) <= 0;
		  };

		  BN.prototype.lte = function lte (num) {
		    return this.cmp(num) <= 0;
		  };

		  BN.prototype.eqn = function eqn (num) {
		    return this.cmpn(num) === 0;
		  };

		  BN.prototype.eq = function eq (num) {
		    return this.cmp(num) === 0;
		  };

		  //
		  // A reduce context, could be using montgomery or something better, depending
		  // on the `m` itself.
		  //
		  BN.red = function red (num) {
		    return new Red(num);
		  };

		  BN.prototype.toRed = function toRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    assert(this.negative === 0, 'red works only with positives');
		    return ctx.convertTo(this)._forceRed(ctx);
		  };

		  BN.prototype.fromRed = function fromRed () {
		    assert(this.red, 'fromRed works only with numbers in reduction context');
		    return this.red.convertFrom(this);
		  };

		  BN.prototype._forceRed = function _forceRed (ctx) {
		    this.red = ctx;
		    return this;
		  };

		  BN.prototype.forceRed = function forceRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    return this._forceRed(ctx);
		  };

		  BN.prototype.redAdd = function redAdd (num) {
		    assert(this.red, 'redAdd works only with red numbers');
		    return this.red.add(this, num);
		  };

		  BN.prototype.redIAdd = function redIAdd (num) {
		    assert(this.red, 'redIAdd works only with red numbers');
		    return this.red.iadd(this, num);
		  };

		  BN.prototype.redSub = function redSub (num) {
		    assert(this.red, 'redSub works only with red numbers');
		    return this.red.sub(this, num);
		  };

		  BN.prototype.redISub = function redISub (num) {
		    assert(this.red, 'redISub works only with red numbers');
		    return this.red.isub(this, num);
		  };

		  BN.prototype.redShl = function redShl (num) {
		    assert(this.red, 'redShl works only with red numbers');
		    return this.red.shl(this, num);
		  };

		  BN.prototype.redMul = function redMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.mul(this, num);
		  };

		  BN.prototype.redIMul = function redIMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.imul(this, num);
		  };

		  BN.prototype.redSqr = function redSqr () {
		    assert(this.red, 'redSqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqr(this);
		  };

		  BN.prototype.redISqr = function redISqr () {
		    assert(this.red, 'redISqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.isqr(this);
		  };

		  // Square root over p
		  BN.prototype.redSqrt = function redSqrt () {
		    assert(this.red, 'redSqrt works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqrt(this);
		  };

		  BN.prototype.redInvm = function redInvm () {
		    assert(this.red, 'redInvm works only with red numbers');
		    this.red._verify1(this);
		    return this.red.invm(this);
		  };

		  // Return negative clone of `this` % `red modulo`
		  BN.prototype.redNeg = function redNeg () {
		    assert(this.red, 'redNeg works only with red numbers');
		    this.red._verify1(this);
		    return this.red.neg(this);
		  };

		  BN.prototype.redPow = function redPow (num) {
		    assert(this.red && !num.red, 'redPow(normalNum)');
		    this.red._verify1(this);
		    return this.red.pow(this, num);
		  };

		  // Prime numbers with efficient reduction
		  var primes = {
		    k256: null,
		    p224: null,
		    p192: null,
		    p25519: null
		  };

		  // Pseudo-Mersenne prime
		  function MPrime (name, p) {
		    // P = 2 ^ N - K
		    this.name = name;
		    this.p = new BN(p, 16);
		    this.n = this.p.bitLength();
		    this.k = new BN(1).iushln(this.n).isub(this.p);

		    this.tmp = this._tmp();
		  }

		  MPrime.prototype._tmp = function _tmp () {
		    var tmp = new BN(null);
		    tmp.words = new Array(Math.ceil(this.n / 13));
		    return tmp;
		  };

		  MPrime.prototype.ireduce = function ireduce (num) {
		    // Assumes that `num` is less than `P^2`
		    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
		    var r = num;
		    var rlen;

		    do {
		      this.split(r, this.tmp);
		      r = this.imulK(r);
		      r = r.iadd(this.tmp);
		      rlen = r.bitLength();
		    } while (rlen > this.n);

		    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
		    if (cmp === 0) {
		      r.words[0] = 0;
		      r.length = 1;
		    } else if (cmp > 0) {
		      r.isub(this.p);
		    } else {
		      if (r.strip !== undefined) {
		        // r is a BN v4 instance
		        r.strip();
		      } else {
		        // r is a BN v5 instance
		        r._strip();
		      }
		    }

		    return r;
		  };

		  MPrime.prototype.split = function split (input, out) {
		    input.iushrn(this.n, 0, out);
		  };

		  MPrime.prototype.imulK = function imulK (num) {
		    return num.imul(this.k);
		  };

		  function K256 () {
		    MPrime.call(
		      this,
		      'k256',
		      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
		  }
		  inherits(K256, MPrime);

		  K256.prototype.split = function split (input, output) {
		    // 256 = 9 * 26 + 22
		    var mask = 0x3fffff;

		    var outLen = Math.min(input.length, 9);
		    for (var i = 0; i < outLen; i++) {
		      output.words[i] = input.words[i];
		    }
		    output.length = outLen;

		    if (input.length <= 9) {
		      input.words[0] = 0;
		      input.length = 1;
		      return;
		    }

		    // Shift by 9 limbs
		    var prev = input.words[9];
		    output.words[output.length++] = prev & mask;

		    for (i = 10; i < input.length; i++) {
		      var next = input.words[i] | 0;
		      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
		      prev = next;
		    }
		    prev >>>= 22;
		    input.words[i - 10] = prev;
		    if (prev === 0 && input.length > 10) {
		      input.length -= 10;
		    } else {
		      input.length -= 9;
		    }
		  };

		  K256.prototype.imulK = function imulK (num) {
		    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
		    num.words[num.length] = 0;
		    num.words[num.length + 1] = 0;
		    num.length += 2;

		    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
		    var lo = 0;
		    for (var i = 0; i < num.length; i++) {
		      var w = num.words[i] | 0;
		      lo += w * 0x3d1;
		      num.words[i] = lo & 0x3ffffff;
		      lo = w * 0x40 + ((lo / 0x4000000) | 0);
		    }

		    // Fast length reduction
		    if (num.words[num.length - 1] === 0) {
		      num.length--;
		      if (num.words[num.length - 1] === 0) {
		        num.length--;
		      }
		    }
		    return num;
		  };

		  function P224 () {
		    MPrime.call(
		      this,
		      'p224',
		      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
		  }
		  inherits(P224, MPrime);

		  function P192 () {
		    MPrime.call(
		      this,
		      'p192',
		      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
		  }
		  inherits(P192, MPrime);

		  function P25519 () {
		    // 2 ^ 255 - 19
		    MPrime.call(
		      this,
		      '25519',
		      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
		  }
		  inherits(P25519, MPrime);

		  P25519.prototype.imulK = function imulK (num) {
		    // K = 0x13
		    var carry = 0;
		    for (var i = 0; i < num.length; i++) {
		      var hi = (num.words[i] | 0) * 0x13 + carry;
		      var lo = hi & 0x3ffffff;
		      hi >>>= 26;

		      num.words[i] = lo;
		      carry = hi;
		    }
		    if (carry !== 0) {
		      num.words[num.length++] = carry;
		    }
		    return num;
		  };

		  // Exported mostly for testing purposes, use plain name instead
		  BN._prime = function prime (name) {
		    // Cached version of prime
		    if (primes[name]) return primes[name];

		    var prime;
		    if (name === 'k256') {
		      prime = new K256();
		    } else if (name === 'p224') {
		      prime = new P224();
		    } else if (name === 'p192') {
		      prime = new P192();
		    } else if (name === 'p25519') {
		      prime = new P25519();
		    } else {
		      throw new Error('Unknown prime ' + name);
		    }
		    primes[name] = prime;

		    return prime;
		  };

		  //
		  // Base reduction engine
		  //
		  function Red (m) {
		    if (typeof m === 'string') {
		      var prime = BN._prime(m);
		      this.m = prime.p;
		      this.prime = prime;
		    } else {
		      assert(m.gtn(1), 'modulus must be greater than 1');
		      this.m = m;
		      this.prime = null;
		    }
		  }

		  Red.prototype._verify1 = function _verify1 (a) {
		    assert(a.negative === 0, 'red works only with positives');
		    assert(a.red, 'red works only with red numbers');
		  };

		  Red.prototype._verify2 = function _verify2 (a, b) {
		    assert((a.negative | b.negative) === 0, 'red works only with positives');
		    assert(a.red && a.red === b.red,
		      'red works only with red numbers');
		  };

		  Red.prototype.imod = function imod (a) {
		    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

		    move(a, a.umod(this.m)._forceRed(this));
		    return a;
		  };

		  Red.prototype.neg = function neg (a) {
		    if (a.isZero()) {
		      return a.clone();
		    }

		    return this.m.sub(a)._forceRed(this);
		  };

		  Red.prototype.add = function add (a, b) {
		    this._verify2(a, b);

		    var res = a.add(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.iadd = function iadd (a, b) {
		    this._verify2(a, b);

		    var res = a.iadd(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res;
		  };

		  Red.prototype.sub = function sub (a, b) {
		    this._verify2(a, b);

		    var res = a.sub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.isub = function isub (a, b) {
		    this._verify2(a, b);

		    var res = a.isub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res;
		  };

		  Red.prototype.shl = function shl (a, num) {
		    this._verify1(a);
		    return this.imod(a.ushln(num));
		  };

		  Red.prototype.imul = function imul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.imul(b));
		  };

		  Red.prototype.mul = function mul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.mul(b));
		  };

		  Red.prototype.isqr = function isqr (a) {
		    return this.imul(a, a.clone());
		  };

		  Red.prototype.sqr = function sqr (a) {
		    return this.mul(a, a);
		  };

		  Red.prototype.sqrt = function sqrt (a) {
		    if (a.isZero()) return a.clone();

		    var mod3 = this.m.andln(3);
		    assert(mod3 % 2 === 1);

		    // Fast case
		    if (mod3 === 3) {
		      var pow = this.m.add(new BN(1)).iushrn(2);
		      return this.pow(a, pow);
		    }

		    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
		    //
		    // Find Q and S, that Q * 2 ^ S = (P - 1)
		    var q = this.m.subn(1);
		    var s = 0;
		    while (!q.isZero() && q.andln(1) === 0) {
		      s++;
		      q.iushrn(1);
		    }
		    assert(!q.isZero());

		    var one = new BN(1).toRed(this);
		    var nOne = one.redNeg();

		    // Find quadratic non-residue
		    // NOTE: Max is such because of generalized Riemann hypothesis.
		    var lpow = this.m.subn(1).iushrn(1);
		    var z = this.m.bitLength();
		    z = new BN(2 * z * z).toRed(this);

		    while (this.pow(z, lpow).cmp(nOne) !== 0) {
		      z.redIAdd(nOne);
		    }

		    var c = this.pow(z, q);
		    var r = this.pow(a, q.addn(1).iushrn(1));
		    var t = this.pow(a, q);
		    var m = s;
		    while (t.cmp(one) !== 0) {
		      var tmp = t;
		      for (var i = 0; tmp.cmp(one) !== 0; i++) {
		        tmp = tmp.redSqr();
		      }
		      assert(i < m);
		      var b = this.pow(c, new BN(1).iushln(m - i - 1));

		      r = r.redMul(b);
		      c = b.redSqr();
		      t = t.redMul(c);
		      m = i;
		    }

		    return r;
		  };

		  Red.prototype.invm = function invm (a) {
		    var inv = a._invmp(this.m);
		    if (inv.negative !== 0) {
		      inv.negative = 0;
		      return this.imod(inv).redNeg();
		    } else {
		      return this.imod(inv);
		    }
		  };

		  Red.prototype.pow = function pow (a, num) {
		    if (num.isZero()) return new BN(1).toRed(this);
		    if (num.cmpn(1) === 0) return a.clone();

		    var windowSize = 4;
		    var wnd = new Array(1 << windowSize);
		    wnd[0] = new BN(1).toRed(this);
		    wnd[1] = a;
		    for (var i = 2; i < wnd.length; i++) {
		      wnd[i] = this.mul(wnd[i - 1], a);
		    }

		    var res = wnd[0];
		    var current = 0;
		    var currentLen = 0;
		    var start = num.bitLength() % 26;
		    if (start === 0) {
		      start = 26;
		    }

		    for (i = num.length - 1; i >= 0; i--) {
		      var word = num.words[i];
		      for (var j = start - 1; j >= 0; j--) {
		        var bit = (word >> j) & 1;
		        if (res !== wnd[0]) {
		          res = this.sqr(res);
		        }

		        if (bit === 0 && current === 0) {
		          currentLen = 0;
		          continue;
		        }

		        current <<= 1;
		        current |= bit;
		        currentLen++;
		        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

		        res = this.mul(res, wnd[current]);
		        currentLen = 0;
		        current = 0;
		      }
		      start = 26;
		    }

		    return res;
		  };

		  Red.prototype.convertTo = function convertTo (num) {
		    var r = num.umod(this.m);

		    return r === num ? r.clone() : r;
		  };

		  Red.prototype.convertFrom = function convertFrom (num) {
		    var res = num.clone();
		    res.red = null;
		    return res;
		  };

		  //
		  // Montgomery method engine
		  //

		  BN.mont = function mont (num) {
		    return new Mont(num);
		  };

		  function Mont (m) {
		    Red.call(this, m);

		    this.shift = this.m.bitLength();
		    if (this.shift % 26 !== 0) {
		      this.shift += 26 - (this.shift % 26);
		    }

		    this.r = new BN(1).iushln(this.shift);
		    this.r2 = this.imod(this.r.sqr());
		    this.rinv = this.r._invmp(this.m);

		    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
		    this.minv = this.minv.umod(this.r);
		    this.minv = this.r.sub(this.minv);
		  }
		  inherits(Mont, Red);

		  Mont.prototype.convertTo = function convertTo (num) {
		    return this.imod(num.ushln(this.shift));
		  };

		  Mont.prototype.convertFrom = function convertFrom (num) {
		    var r = this.imod(num.mul(this.rinv));
		    r.red = null;
		    return r;
		  };

		  Mont.prototype.imul = function imul (a, b) {
		    if (a.isZero() || b.isZero()) {
		      a.words[0] = 0;
		      a.length = 1;
		      return a;
		    }

		    var t = a.imul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;

		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.mul = function mul (a, b) {
		    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

		    var t = a.mul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;
		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.invm = function invm (a) {
		    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
		    var res = this.imod(a._invmp(this.m).mul(this.r2));
		    return res._forceRed(this);
		  };
		})(module, bn$2); 
	} (bn$3));
	return bn$3.exports;
}

var browserifyRsa;
var hasRequiredBrowserifyRsa;

function requireBrowserifyRsa () {
	if (hasRequiredBrowserifyRsa) return browserifyRsa;
	hasRequiredBrowserifyRsa = 1;

	var BN = requireBn$1();
	var randomBytes = requireBrowser$b();
	var Buffer = requireSafeBuffer$2().Buffer;

	function getr(priv) {
		var len = priv.modulus.byteLength();
		var r;
		do {
			r = new BN(randomBytes(len));
		} while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
		return r;
	}

	function blind(priv) {
		var r = getr(priv);
		var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
		return { blinder: blinder, unblinder: r.invm(priv.modulus) };
	}

	function crt(msg, priv) {
		var blinds = blind(priv);
		var len = priv.modulus.byteLength();
		var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
		var c1 = blinded.toRed(BN.mont(priv.prime1));
		var c2 = blinded.toRed(BN.mont(priv.prime2));
		var qinv = priv.coefficient;
		var p = priv.prime1;
		var q = priv.prime2;
		var m1 = c1.redPow(priv.exponent1).fromRed();
		var m2 = c2.redPow(priv.exponent2).fromRed();
		var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
		return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len);
	}
	crt.getr = getr;

	browserifyRsa = crt;
	return browserifyRsa;
}

var elliptic = {};

var name = "elliptic";
var version = "6.6.1";
var description = "EC cryptography";
var main = "lib/elliptic.js";
var files = [
	"lib"
];
var scripts = {
	lint: "eslint lib test",
	"lint:fix": "npm run lint -- --fix",
	unit: "istanbul test _mocha --reporter=spec test/index.js",
	test: "npm run lint && npm run unit",
	version: "grunt dist && git add dist/"
};
var repository = {
	type: "git",
	url: "git@github.com:indutny/elliptic"
};
var keywords = [
	"EC",
	"Elliptic",
	"curve",
	"Cryptography"
];
var author = "Fedor Indutny <fedor@indutny.com>";
var license = "MIT";
var bugs = {
	url: "https://github.com/indutny/elliptic/issues"
};
var homepage = "https://github.com/indutny/elliptic";
var devDependencies = {
	brfs: "^2.0.2",
	coveralls: "^3.1.0",
	eslint: "^7.6.0",
	grunt: "^1.2.1",
	"grunt-browserify": "^5.3.0",
	"grunt-cli": "^1.3.2",
	"grunt-contrib-connect": "^3.0.0",
	"grunt-contrib-copy": "^1.0.0",
	"grunt-contrib-uglify": "^5.0.0",
	"grunt-mocha-istanbul": "^5.0.2",
	"grunt-saucelabs": "^9.0.1",
	istanbul: "^0.4.5",
	mocha: "^8.0.1"
};
var dependencies = {
	"bn.js": "^4.11.9",
	brorand: "^1.1.0",
	"hash.js": "^1.0.0",
	"hmac-drbg": "^1.0.1",
	inherits: "^2.0.4",
	"minimalistic-assert": "^1.0.1",
	"minimalistic-crypto-utils": "^1.0.1"
};
var require$$0 = {
	name: name,
	version: version,
	description: description,
	main: main,
	files: files,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	dependencies: dependencies
};

var utils$2 = {};

var utils$1 = {};

var hasRequiredUtils$2;

function requireUtils$2 () {
	if (hasRequiredUtils$2) return utils$1;
	hasRequiredUtils$2 = 1;
	(function (exports) {

		var utils = exports;

		function toArray(msg, enc) {
		  if (Array.isArray(msg))
		    return msg.slice();
		  if (!msg)
		    return [];
		  var res = [];
		  if (typeof msg !== 'string') {
		    for (var i = 0; i < msg.length; i++)
		      res[i] = msg[i] | 0;
		    return res;
		  }
		  if (enc === 'hex') {
		    msg = msg.replace(/[^a-z0-9]+/ig, '');
		    if (msg.length % 2 !== 0)
		      msg = '0' + msg;
		    for (var i = 0; i < msg.length; i += 2)
		      res.push(parseInt(msg[i] + msg[i + 1], 16));
		  } else {
		    for (var i = 0; i < msg.length; i++) {
		      var c = msg.charCodeAt(i);
		      var hi = c >> 8;
		      var lo = c & 0xff;
		      if (hi)
		        res.push(hi, lo);
		      else
		        res.push(lo);
		    }
		  }
		  return res;
		}
		utils.toArray = toArray;

		function zero2(word) {
		  if (word.length === 1)
		    return '0' + word;
		  else
		    return word;
		}
		utils.zero2 = zero2;

		function toHex(msg) {
		  var res = '';
		  for (var i = 0; i < msg.length; i++)
		    res += zero2(msg[i].toString(16));
		  return res;
		}
		utils.toHex = toHex;

		utils.encode = function encode(arr, enc) {
		  if (enc === 'hex')
		    return toHex(arr);
		  else
		    return arr;
		}; 
	} (utils$1));
	return utils$1;
}

var hasRequiredUtils$1;

function requireUtils$1 () {
	if (hasRequiredUtils$1) return utils$2;
	hasRequiredUtils$1 = 1;
	(function (exports) {

		var utils = exports;
		var BN = requireBn$2();
		var minAssert = requireMinimalisticAssert();
		var minUtils = requireUtils$2();

		utils.assert = minAssert;
		utils.toArray = minUtils.toArray;
		utils.zero2 = minUtils.zero2;
		utils.toHex = minUtils.toHex;
		utils.encode = minUtils.encode;

		// Represent num in a w-NAF form
		function getNAF(num, w, bits) {
		  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
		  var i;
		  for (i = 0; i < naf.length; i += 1) {
		    naf[i] = 0;
		  }

		  var ws = 1 << (w + 1);
		  var k = num.clone();

		  for (i = 0; i < naf.length; i++) {
		    var z;
		    var mod = k.andln(ws - 1);
		    if (k.isOdd()) {
		      if (mod > (ws >> 1) - 1)
		        z = (ws >> 1) - mod;
		      else
		        z = mod;
		      k.isubn(z);
		    } else {
		      z = 0;
		    }

		    naf[i] = z;
		    k.iushrn(1);
		  }

		  return naf;
		}
		utils.getNAF = getNAF;

		// Represent k1, k2 in a Joint Sparse Form
		function getJSF(k1, k2) {
		  var jsf = [
		    [],
		    [],
		  ];

		  k1 = k1.clone();
		  k2 = k2.clone();
		  var d1 = 0;
		  var d2 = 0;
		  var m8;
		  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
		    // First phase
		    var m14 = (k1.andln(3) + d1) & 3;
		    var m24 = (k2.andln(3) + d2) & 3;
		    if (m14 === 3)
		      m14 = -1;
		    if (m24 === 3)
		      m24 = -1;
		    var u1;
		    if ((m14 & 1) === 0) {
		      u1 = 0;
		    } else {
		      m8 = (k1.andln(7) + d1) & 7;
		      if ((m8 === 3 || m8 === 5) && m24 === 2)
		        u1 = -m14;
		      else
		        u1 = m14;
		    }
		    jsf[0].push(u1);

		    var u2;
		    if ((m24 & 1) === 0) {
		      u2 = 0;
		    } else {
		      m8 = (k2.andln(7) + d2) & 7;
		      if ((m8 === 3 || m8 === 5) && m14 === 2)
		        u2 = -m24;
		      else
		        u2 = m24;
		    }
		    jsf[1].push(u2);

		    // Second phase
		    if (2 * d1 === u1 + 1)
		      d1 = 1 - d1;
		    if (2 * d2 === u2 + 1)
		      d2 = 1 - d2;
		    k1.iushrn(1);
		    k2.iushrn(1);
		  }

		  return jsf;
		}
		utils.getJSF = getJSF;

		function cachedProperty(obj, name, computer) {
		  var key = '_' + name;
		  obj.prototype[name] = function cachedProperty() {
		    return this[key] !== undefined ? this[key] :
		      this[key] = computer.call(this);
		  };
		}
		utils.cachedProperty = cachedProperty;

		function parseBytes(bytes) {
		  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
		    bytes;
		}
		utils.parseBytes = parseBytes;

		function intFromLE(bytes) {
		  return new BN(bytes, 'hex', 'le');
		}
		utils.intFromLE = intFromLE; 
	} (utils$2));
	return utils$2;
}

var curve = {};

var base$1;
var hasRequiredBase$1;

function requireBase$1 () {
	if (hasRequiredBase$1) return base$1;
	hasRequiredBase$1 = 1;

	var BN = requireBn$2();
	var utils = requireUtils$1();
	var getNAF = utils.getNAF;
	var getJSF = utils.getJSF;
	var assert = utils.assert;

	function BaseCurve(type, conf) {
	  this.type = type;
	  this.p = new BN(conf.p, 16);

	  // Use Montgomery, when there is no fast reduction for the prime
	  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

	  // Useful for many curves
	  this.zero = new BN(0).toRed(this.red);
	  this.one = new BN(1).toRed(this.red);
	  this.two = new BN(2).toRed(this.red);

	  // Curve configuration, optional
	  this.n = conf.n && new BN(conf.n, 16);
	  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

	  // Temporary arrays
	  this._wnafT1 = new Array(4);
	  this._wnafT2 = new Array(4);
	  this._wnafT3 = new Array(4);
	  this._wnafT4 = new Array(4);

	  this._bitLength = this.n ? this.n.bitLength() : 0;

	  // Generalized Greg Maxwell's trick
	  var adjustCount = this.n && this.p.div(this.n);
	  if (!adjustCount || adjustCount.cmpn(100) > 0) {
	    this.redN = null;
	  } else {
	    this._maxwellTrick = true;
	    this.redN = this.n.toRed(this.red);
	  }
	}
	base$1 = BaseCurve;

	BaseCurve.prototype.point = function point() {
	  throw new Error('Not implemented');
	};

	BaseCurve.prototype.validate = function validate() {
	  throw new Error('Not implemented');
	};

	BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
	  assert(p.precomputed);
	  var doubles = p._getDoubles();

	  var naf = getNAF(k, 1, this._bitLength);
	  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
	  I /= 3;

	  // Translate into more windowed form
	  var repr = [];
	  var j;
	  var nafW;
	  for (j = 0; j < naf.length; j += doubles.step) {
	    nafW = 0;
	    for (var l = j + doubles.step - 1; l >= j; l--)
	      nafW = (nafW << 1) + naf[l];
	    repr.push(nafW);
	  }

	  var a = this.jpoint(null, null, null);
	  var b = this.jpoint(null, null, null);
	  for (var i = I; i > 0; i--) {
	    for (j = 0; j < repr.length; j++) {
	      nafW = repr[j];
	      if (nafW === i)
	        b = b.mixedAdd(doubles.points[j]);
	      else if (nafW === -i)
	        b = b.mixedAdd(doubles.points[j].neg());
	    }
	    a = a.add(b);
	  }
	  return a.toP();
	};

	BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
	  var w = 4;

	  // Precompute window
	  var nafPoints = p._getNAFPoints(w);
	  w = nafPoints.wnd;
	  var wnd = nafPoints.points;

	  // Get NAF form
	  var naf = getNAF(k, w, this._bitLength);

	  // Add `this`*(N+1) for every w-NAF index
	  var acc = this.jpoint(null, null, null);
	  for (var i = naf.length - 1; i >= 0; i--) {
	    // Count zeroes
	    for (var l = 0; i >= 0 && naf[i] === 0; i--)
	      l++;
	    if (i >= 0)
	      l++;
	    acc = acc.dblp(l);

	    if (i < 0)
	      break;
	    var z = naf[i];
	    assert(z !== 0);
	    if (p.type === 'affine') {
	      // J +- P
	      if (z > 0)
	        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
	    } else {
	      // J +- J
	      if (z > 0)
	        acc = acc.add(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.add(wnd[(-z - 1) >> 1].neg());
	    }
	  }
	  return p.type === 'affine' ? acc.toP() : acc;
	};

	BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
	  points,
	  coeffs,
	  len,
	  jacobianResult) {
	  var wndWidth = this._wnafT1;
	  var wnd = this._wnafT2;
	  var naf = this._wnafT3;

	  // Fill all arrays
	  var max = 0;
	  var i;
	  var j;
	  var p;
	  for (i = 0; i < len; i++) {
	    p = points[i];
	    var nafPoints = p._getNAFPoints(defW);
	    wndWidth[i] = nafPoints.wnd;
	    wnd[i] = nafPoints.points;
	  }

	  // Comb small window NAFs
	  for (i = len - 1; i >= 1; i -= 2) {
	    var a = i - 1;
	    var b = i;
	    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
	      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
	      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
	      max = Math.max(naf[a].length, max);
	      max = Math.max(naf[b].length, max);
	      continue;
	    }

	    var comb = [
	      points[a], /* 1 */
	      null, /* 3 */
	      null, /* 5 */
	      points[b], /* 7 */
	    ];

	    // Try to avoid Projective points, if possible
	    if (points[a].y.cmp(points[b].y) === 0) {
	      comb[1] = points[a].add(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].add(points[b].neg());
	    } else {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    }

	    var index = [
	      -3, /* -1 -1 */
	      -1, /* -1 0 */
	      -5, /* -1 1 */
	      -7, /* 0 -1 */
	      0, /* 0 0 */
	      7, /* 0 1 */
	      5, /* 1 -1 */
	      1, /* 1 0 */
	      3,  /* 1 1 */
	    ];

	    var jsf = getJSF(coeffs[a], coeffs[b]);
	    max = Math.max(jsf[0].length, max);
	    naf[a] = new Array(max);
	    naf[b] = new Array(max);
	    for (j = 0; j < max; j++) {
	      var ja = jsf[0][j] | 0;
	      var jb = jsf[1][j] | 0;

	      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
	      naf[b][j] = 0;
	      wnd[a] = comb;
	    }
	  }

	  var acc = this.jpoint(null, null, null);
	  var tmp = this._wnafT4;
	  for (i = max; i >= 0; i--) {
	    var k = 0;

	    while (i >= 0) {
	      var zero = true;
	      for (j = 0; j < len; j++) {
	        tmp[j] = naf[j][i] | 0;
	        if (tmp[j] !== 0)
	          zero = false;
	      }
	      if (!zero)
	        break;
	      k++;
	      i--;
	    }
	    if (i >= 0)
	      k++;
	    acc = acc.dblp(k);
	    if (i < 0)
	      break;

	    for (j = 0; j < len; j++) {
	      var z = tmp[j];
	      if (z === 0)
	        continue;
	      else if (z > 0)
	        p = wnd[j][(z - 1) >> 1];
	      else if (z < 0)
	        p = wnd[j][(-z - 1) >> 1].neg();

	      if (p.type === 'affine')
	        acc = acc.mixedAdd(p);
	      else
	        acc = acc.add(p);
	    }
	  }
	  // Zeroify references
	  for (i = 0; i < len; i++)
	    wnd[i] = null;

	  if (jacobianResult)
	    return acc;
	  else
	    return acc.toP();
	};

	function BasePoint(curve, type) {
	  this.curve = curve;
	  this.type = type;
	  this.precomputed = null;
	}
	BaseCurve.BasePoint = BasePoint;

	BasePoint.prototype.eq = function eq(/*other*/) {
	  throw new Error('Not implemented');
	};

	BasePoint.prototype.validate = function validate() {
	  return this.curve.validate(this);
	};

	BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  bytes = utils.toArray(bytes, enc);

	  var len = this.p.byteLength();

	  // uncompressed, hybrid-odd, hybrid-even
	  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
	      bytes.length - 1 === 2 * len) {
	    if (bytes[0] === 0x06)
	      assert(bytes[bytes.length - 1] % 2 === 0);
	    else if (bytes[0] === 0x07)
	      assert(bytes[bytes.length - 1] % 2 === 1);

	    var res =  this.point(bytes.slice(1, 1 + len),
	      bytes.slice(1 + len, 1 + 2 * len));

	    return res;
	  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
	              bytes.length - 1 === len) {
	    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
	  }
	  throw new Error('Unknown point format');
	};

	BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
	  return this.encode(enc, true);
	};

	BasePoint.prototype._encode = function _encode(compact) {
	  var len = this.curve.p.byteLength();
	  var x = this.getX().toArray('be', len);

	  if (compact)
	    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

	  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
	};

	BasePoint.prototype.encode = function encode(enc, compact) {
	  return utils.encode(this._encode(compact), enc);
	};

	BasePoint.prototype.precompute = function precompute(power) {
	  if (this.precomputed)
	    return this;

	  var precomputed = {
	    doubles: null,
	    naf: null,
	    beta: null,
	  };
	  precomputed.naf = this._getNAFPoints(8);
	  precomputed.doubles = this._getDoubles(4, power);
	  precomputed.beta = this._getBeta();
	  this.precomputed = precomputed;

	  return this;
	};

	BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
	  if (!this.precomputed)
	    return false;

	  var doubles = this.precomputed.doubles;
	  if (!doubles)
	    return false;

	  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
	};

	BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
	  if (this.precomputed && this.precomputed.doubles)
	    return this.precomputed.doubles;

	  var doubles = [ this ];
	  var acc = this;
	  for (var i = 0; i < power; i += step) {
	    for (var j = 0; j < step; j++)
	      acc = acc.dbl();
	    doubles.push(acc);
	  }
	  return {
	    step: step,
	    points: doubles,
	  };
	};

	BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
	  if (this.precomputed && this.precomputed.naf)
	    return this.precomputed.naf;

	  var res = [ this ];
	  var max = (1 << wnd) - 1;
	  var dbl = max === 1 ? null : this.dbl();
	  for (var i = 1; i < max; i++)
	    res[i] = res[i - 1].add(dbl);
	  return {
	    wnd: wnd,
	    points: res,
	  };
	};

	BasePoint.prototype._getBeta = function _getBeta() {
	  return null;
	};

	BasePoint.prototype.dblp = function dblp(k) {
	  var r = this;
	  for (var i = 0; i < k; i++)
	    r = r.dbl();
	  return r;
	};
	return base$1;
}

var short;
var hasRequiredShort;

function requireShort () {
	if (hasRequiredShort) return short;
	hasRequiredShort = 1;

	var utils = requireUtils$1();
	var BN = requireBn$2();
	var inherits = requireInherits_browser();
	var Base = requireBase$1();

	var assert = utils.assert;

	function ShortCurve(conf) {
	  Base.call(this, 'short', conf);

	  this.a = new BN(conf.a, 16).toRed(this.red);
	  this.b = new BN(conf.b, 16).toRed(this.red);
	  this.tinv = this.two.redInvm();

	  this.zeroA = this.a.fromRed().cmpn(0) === 0;
	  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

	  // If the curve is endomorphic, precalculate beta and lambda
	  this.endo = this._getEndomorphism(conf);
	  this._endoWnafT1 = new Array(4);
	  this._endoWnafT2 = new Array(4);
	}
	inherits(ShortCurve, Base);
	short = ShortCurve;

	ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
	  // No efficient endomorphism
	  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
	    return;

	  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
	  var beta;
	  var lambda;
	  if (conf.beta) {
	    beta = new BN(conf.beta, 16).toRed(this.red);
	  } else {
	    var betas = this._getEndoRoots(this.p);
	    // Choose the smallest beta
	    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
	    beta = beta.toRed(this.red);
	  }
	  if (conf.lambda) {
	    lambda = new BN(conf.lambda, 16);
	  } else {
	    // Choose the lambda that is matching selected beta
	    var lambdas = this._getEndoRoots(this.n);
	    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
	      lambda = lambdas[0];
	    } else {
	      lambda = lambdas[1];
	      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
	    }
	  }

	  // Get basis vectors, used for balanced length-two representation
	  var basis;
	  if (conf.basis) {
	    basis = conf.basis.map(function(vec) {
	      return {
	        a: new BN(vec.a, 16),
	        b: new BN(vec.b, 16),
	      };
	    });
	  } else {
	    basis = this._getEndoBasis(lambda);
	  }

	  return {
	    beta: beta,
	    lambda: lambda,
	    basis: basis,
	  };
	};

	ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
	  // Find roots of for x^2 + x + 1 in F
	  // Root = (-1 +- Sqrt(-3)) / 2
	  //
	  var red = num === this.p ? this.red : BN.mont(num);
	  var tinv = new BN(2).toRed(red).redInvm();
	  var ntinv = tinv.redNeg();

	  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

	  var l1 = ntinv.redAdd(s).fromRed();
	  var l2 = ntinv.redSub(s).fromRed();
	  return [ l1, l2 ];
	};

	ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
	  // aprxSqrt >= sqrt(this.n)
	  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

	  // 3.74
	  // Run EGCD, until r(L + 1) < aprxSqrt
	  var u = lambda;
	  var v = this.n.clone();
	  var x1 = new BN(1);
	  var y1 = new BN(0);
	  var x2 = new BN(0);
	  var y2 = new BN(1);

	  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
	  var a0;
	  var b0;
	  // First vector
	  var a1;
	  var b1;
	  // Second vector
	  var a2;
	  var b2;

	  var prevR;
	  var i = 0;
	  var r;
	  var x;
	  while (u.cmpn(0) !== 0) {
	    var q = v.div(u);
	    r = v.sub(q.mul(u));
	    x = x2.sub(q.mul(x1));
	    var y = y2.sub(q.mul(y1));

	    if (!a1 && r.cmp(aprxSqrt) < 0) {
	      a0 = prevR.neg();
	      b0 = x1;
	      a1 = r.neg();
	      b1 = x;
	    } else if (a1 && ++i === 2) {
	      break;
	    }
	    prevR = r;

	    v = u;
	    u = r;
	    x2 = x1;
	    x1 = x;
	    y2 = y1;
	    y1 = y;
	  }
	  a2 = r.neg();
	  b2 = x;

	  var len1 = a1.sqr().add(b1.sqr());
	  var len2 = a2.sqr().add(b2.sqr());
	  if (len2.cmp(len1) >= 0) {
	    a2 = a0;
	    b2 = b0;
	  }

	  // Normalize signs
	  if (a1.negative) {
	    a1 = a1.neg();
	    b1 = b1.neg();
	  }
	  if (a2.negative) {
	    a2 = a2.neg();
	    b2 = b2.neg();
	  }

	  return [
	    { a: a1, b: b1 },
	    { a: a2, b: b2 },
	  ];
	};

	ShortCurve.prototype._endoSplit = function _endoSplit(k) {
	  var basis = this.endo.basis;
	  var v1 = basis[0];
	  var v2 = basis[1];

	  var c1 = v2.b.mul(k).divRound(this.n);
	  var c2 = v1.b.neg().mul(k).divRound(this.n);

	  var p1 = c1.mul(v1.a);
	  var p2 = c2.mul(v2.a);
	  var q1 = c1.mul(v1.b);
	  var q2 = c2.mul(v2.b);

	  // Calculate answer
	  var k1 = k.sub(p1).sub(p2);
	  var k2 = q1.add(q2).neg();
	  return { k1: k1, k2: k2 };
	};

	ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);

	  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');

	  // XXX Is there any way to tell if the number is odd without converting it
	  // to non-red form?
	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();

	  return this.point(x, y);
	};

	ShortCurve.prototype.validate = function validate(point) {
	  if (point.inf)
	    return true;

	  var x = point.x;
	  var y = point.y;

	  var ax = this.a.redMul(x);
	  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
	  return y.redSqr().redISub(rhs).cmpn(0) === 0;
	};

	ShortCurve.prototype._endoWnafMulAdd =
	    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
	      var npoints = this._endoWnafT1;
	      var ncoeffs = this._endoWnafT2;
	      for (var i = 0; i < points.length; i++) {
	        var split = this._endoSplit(coeffs[i]);
	        var p = points[i];
	        var beta = p._getBeta();

	        if (split.k1.negative) {
	          split.k1.ineg();
	          p = p.neg(true);
	        }
	        if (split.k2.negative) {
	          split.k2.ineg();
	          beta = beta.neg(true);
	        }

	        npoints[i * 2] = p;
	        npoints[i * 2 + 1] = beta;
	        ncoeffs[i * 2] = split.k1;
	        ncoeffs[i * 2 + 1] = split.k2;
	      }
	      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

	      // Clean-up references to points and coefficients
	      for (var j = 0; j < i * 2; j++) {
	        npoints[j] = null;
	        ncoeffs[j] = null;
	      }
	      return res;
	    };

	function Point(curve, x, y, isRed) {
	  Base.BasePoint.call(this, curve, 'affine');
	  if (x === null && y === null) {
	    this.x = null;
	    this.y = null;
	    this.inf = true;
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    // Force redgomery representation when loading from JSON
	    if (isRed) {
	      this.x.forceRed(this.curve.red);
	      this.y.forceRed(this.curve.red);
	    }
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    this.inf = false;
	  }
	}
	inherits(Point, Base.BasePoint);

	ShortCurve.prototype.point = function point(x, y, isRed) {
	  return new Point(this, x, y, isRed);
	};

	ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
	  return Point.fromJSON(this, obj, red);
	};

	Point.prototype._getBeta = function _getBeta() {
	  if (!this.curve.endo)
	    return;

	  var pre = this.precomputed;
	  if (pre && pre.beta)
	    return pre.beta;

	  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
	  if (pre) {
	    var curve = this.curve;
	    var endoMul = function(p) {
	      return curve.point(p.x.redMul(curve.endo.beta), p.y);
	    };
	    pre.beta = beta;
	    beta.precomputed = {
	      beta: null,
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(endoMul),
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(endoMul),
	      },
	    };
	  }
	  return beta;
	};

	Point.prototype.toJSON = function toJSON() {
	  if (!this.precomputed)
	    return [ this.x, this.y ];

	  return [ this.x, this.y, this.precomputed && {
	    doubles: this.precomputed.doubles && {
	      step: this.precomputed.doubles.step,
	      points: this.precomputed.doubles.points.slice(1),
	    },
	    naf: this.precomputed.naf && {
	      wnd: this.precomputed.naf.wnd,
	      points: this.precomputed.naf.points.slice(1),
	    },
	  } ];
	};

	Point.fromJSON = function fromJSON(curve, obj, red) {
	  if (typeof obj === 'string')
	    obj = JSON.parse(obj);
	  var res = curve.point(obj[0], obj[1], red);
	  if (!obj[2])
	    return res;

	  function obj2point(obj) {
	    return curve.point(obj[0], obj[1], red);
	  }

	  var pre = obj[2];
	  res.precomputed = {
	    beta: null,
	    doubles: pre.doubles && {
	      step: pre.doubles.step,
	      points: [ res ].concat(pre.doubles.points.map(obj2point)),
	    },
	    naf: pre.naf && {
	      wnd: pre.naf.wnd,
	      points: [ res ].concat(pre.naf.points.map(obj2point)),
	    },
	  };
	  return res;
	};

	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
	};

	Point.prototype.isInfinity = function isInfinity() {
	  return this.inf;
	};

	Point.prototype.add = function add(p) {
	  // O + P = P
	  if (this.inf)
	    return p;

	  // P + O = P
	  if (p.inf)
	    return this;

	  // P + P = 2P
	  if (this.eq(p))
	    return this.dbl();

	  // P + (-P) = O
	  if (this.neg().eq(p))
	    return this.curve.point(null, null);

	  // P + Q = O
	  if (this.x.cmp(p.x) === 0)
	    return this.curve.point(null, null);

	  var c = this.y.redSub(p.y);
	  if (c.cmpn(0) !== 0)
	    c = c.redMul(this.x.redSub(p.x).redInvm());
	  var nx = c.redSqr().redISub(this.x).redISub(p.x);
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point.prototype.dbl = function dbl() {
	  if (this.inf)
	    return this;

	  // 2P = O
	  var ys1 = this.y.redAdd(this.y);
	  if (ys1.cmpn(0) === 0)
	    return this.curve.point(null, null);

	  var a = this.curve.a;

	  var x2 = this.x.redSqr();
	  var dyinv = ys1.redInvm();
	  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

	  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point.prototype.getX = function getX() {
	  return this.x.fromRed();
	};

	Point.prototype.getY = function getY() {
	  return this.y.fromRed();
	};

	Point.prototype.mul = function mul(k) {
	  k = new BN(k, 16);
	  if (this.isInfinity())
	    return this;
	  else if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else if (this.curve.endo)
	    return this.curve._endoWnafMulAdd([ this ], [ k ]);
	  else
	    return this.curve._wnafMul(this, k);
	};

	Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2);
	};

	Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs, true);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
	};

	Point.prototype.eq = function eq(p) {
	  return this === p ||
	         this.inf === p.inf &&
	             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
	};

	Point.prototype.neg = function neg(_precompute) {
	  if (this.inf)
	    return this;

	  var res = this.curve.point(this.x, this.y.redNeg());
	  if (_precompute && this.precomputed) {
	    var pre = this.precomputed;
	    var negate = function(p) {
	      return p.neg();
	    };
	    res.precomputed = {
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(negate),
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(negate),
	      },
	    };
	  }
	  return res;
	};

	Point.prototype.toJ = function toJ() {
	  if (this.inf)
	    return this.curve.jpoint(null, null, null);

	  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
	  return res;
	};

	function JPoint(curve, x, y, z) {
	  Base.BasePoint.call(this, curve, 'jacobian');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.one;
	    this.y = this.curve.one;
	    this.z = new BN(0);
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    this.z = new BN(z, 16);
	  }
	  if (!this.x.red)
	    this.x = this.x.toRed(this.curve.red);
	  if (!this.y.red)
	    this.y = this.y.toRed(this.curve.red);
	  if (!this.z.red)
	    this.z = this.z.toRed(this.curve.red);

	  this.zOne = this.z === this.curve.one;
	}
	inherits(JPoint, Base.BasePoint);

	ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
	  return new JPoint(this, x, y, z);
	};

	JPoint.prototype.toP = function toP() {
	  if (this.isInfinity())
	    return this.curve.point(null, null);

	  var zinv = this.z.redInvm();
	  var zinv2 = zinv.redSqr();
	  var ax = this.x.redMul(zinv2);
	  var ay = this.y.redMul(zinv2).redMul(zinv);

	  return this.curve.point(ax, ay);
	};

	JPoint.prototype.neg = function neg() {
	  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
	};

	JPoint.prototype.add = function add(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p;

	  // P + O = P
	  if (p.isInfinity())
	    return this;

	  // 12M + 4S + 7A
	  var pz2 = p.z.redSqr();
	  var z2 = this.z.redSqr();
	  var u1 = this.x.redMul(pz2);
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y.redMul(pz2.redMul(p.z));
	  var s2 = p.y.redMul(z2.redMul(this.z));

	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);

	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(p.z).redMul(h);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.mixedAdd = function mixedAdd(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p.toJ();

	  // P + O = P
	  if (p.isInfinity())
	    return this;

	  // 8M + 3S + 7A
	  var z2 = this.z.redSqr();
	  var u1 = this.x;
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y;
	  var s2 = p.y.redMul(z2).redMul(this.z);

	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);

	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(h);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.dblp = function dblp(pow) {
	  if (pow === 0)
	    return this;
	  if (this.isInfinity())
	    return this;
	  if (!pow)
	    return this.dbl();

	  var i;
	  if (this.curve.zeroA || this.curve.threeA) {
	    var r = this;
	    for (i = 0; i < pow; i++)
	      r = r.dbl();
	    return r;
	  }

	  // 1M + 2S + 1A + N * (4S + 5M + 8A)
	  // N = 1 => 6M + 6S + 9A
	  var a = this.curve.a;
	  var tinv = this.curve.tinv;

	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();

	  // Reuse results
	  var jyd = jy.redAdd(jy);
	  for (i = 0; i < pow; i++) {
	    var jx2 = jx.redSqr();
	    var jyd2 = jyd.redSqr();
	    var jyd4 = jyd2.redSqr();
	    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

	    var t1 = jx.redMul(jyd2);
	    var nx = c.redSqr().redISub(t1.redAdd(t1));
	    var t2 = t1.redISub(nx);
	    var dny = c.redMul(t2);
	    dny = dny.redIAdd(dny).redISub(jyd4);
	    var nz = jyd.redMul(jz);
	    if (i + 1 < pow)
	      jz4 = jz4.redMul(jyd4);

	    jx = nx;
	    jz = nz;
	    jyd = dny;
	  }

	  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
	};

	JPoint.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;

	  if (this.curve.zeroA)
	    return this._zeroDbl();
	  else if (this.curve.threeA)
	    return this._threeDbl();
	  else
	    return this._dbl();
	};

	JPoint.prototype._zeroDbl = function _zeroDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 14A

	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a; a = 0
	    var m = xx.redAdd(xx).redIAdd(xx);
	    // T = M ^ 2 - 2*S
	    var t = m.redSqr().redISub(s).redISub(s);

	    // 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);

	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2*Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-dbl-2009-l
	    // 2M + 5S + 13A

	    // A = X1^2
	    var a = this.x.redSqr();
	    // B = Y1^2
	    var b = this.y.redSqr();
	    // C = B^2
	    var c = b.redSqr();
	    // D = 2 * ((X1 + B)^2 - A - C)
	    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
	    d = d.redIAdd(d);
	    // E = 3 * A
	    var e = a.redAdd(a).redIAdd(a);
	    // F = E^2
	    var f = e.redSqr();

	    // 8 * C
	    var c8 = c.redIAdd(c);
	    c8 = c8.redIAdd(c8);
	    c8 = c8.redIAdd(c8);

	    // X3 = F - 2 * D
	    nx = f.redISub(d).redISub(d);
	    // Y3 = E * (D - X3) - 8 * C
	    ny = e.redMul(d.redISub(nx)).redISub(c8);
	    // Z3 = 2 * Y1 * Z1
	    nz = this.y.redMul(this.z);
	    nz = nz.redIAdd(nz);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype._threeDbl = function _threeDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 15A

	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a
	    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
	    // T = M^2 - 2 * S
	    var t = m.redSqr().redISub(s).redISub(s);
	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2 * Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
	    // 3M + 5S

	    // delta = Z1^2
	    var delta = this.z.redSqr();
	    // gamma = Y1^2
	    var gamma = this.y.redSqr();
	    // beta = X1 * gamma
	    var beta = this.x.redMul(gamma);
	    // alpha = 3 * (X1 - delta) * (X1 + delta)
	    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
	    alpha = alpha.redAdd(alpha).redIAdd(alpha);
	    // X3 = alpha^2 - 8 * beta
	    var beta4 = beta.redIAdd(beta);
	    beta4 = beta4.redIAdd(beta4);
	    var beta8 = beta4.redAdd(beta4);
	    nx = alpha.redSqr().redISub(beta8);
	    // Z3 = (Y1 + Z1)^2 - gamma - delta
	    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
	    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
	    var ggamma8 = gamma.redSqr();
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype._dbl = function _dbl() {
	  var a = this.curve.a;

	  // 4M + 6S + 10A
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();

	  var jx2 = jx.redSqr();
	  var jy2 = jy.redSqr();

	  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

	  var jxd4 = jx.redAdd(jx);
	  jxd4 = jxd4.redIAdd(jxd4);
	  var t1 = jxd4.redMul(jy2);
	  var nx = c.redSqr().redISub(t1.redAdd(t1));
	  var t2 = t1.redISub(nx);

	  var jyd8 = jy2.redSqr();
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  var ny = c.redMul(t2).redISub(jyd8);
	  var nz = jy.redAdd(jy).redMul(jz);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.trpl = function trpl() {
	  if (!this.curve.zeroA)
	    return this.dbl().add(this);

	  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
	  // 5M + 10S + ...

	  // XX = X1^2
	  var xx = this.x.redSqr();
	  // YY = Y1^2
	  var yy = this.y.redSqr();
	  // ZZ = Z1^2
	  var zz = this.z.redSqr();
	  // YYYY = YY^2
	  var yyyy = yy.redSqr();
	  // M = 3 * XX + a * ZZ2; a = 0
	  var m = xx.redAdd(xx).redIAdd(xx);
	  // MM = M^2
	  var mm = m.redSqr();
	  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
	  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	  e = e.redIAdd(e);
	  e = e.redAdd(e).redIAdd(e);
	  e = e.redISub(mm);
	  // EE = E^2
	  var ee = e.redSqr();
	  // T = 16*YYYY
	  var t = yyyy.redIAdd(yyyy);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  // U = (M + E)^2 - MM - EE - T
	  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
	  // X3 = 4 * (X1 * EE - 4 * YY * U)
	  var yyu4 = yy.redMul(u);
	  yyu4 = yyu4.redIAdd(yyu4);
	  yyu4 = yyu4.redIAdd(yyu4);
	  var nx = this.x.redMul(ee).redISub(yyu4);
	  nx = nx.redIAdd(nx);
	  nx = nx.redIAdd(nx);
	  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
	  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  // Z3 = (Z1 + E)^2 - ZZ - EE
	  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.mul = function mul(k, kbase) {
	  k = new BN(k, kbase);

	  return this.curve._wnafMul(this, k);
	};

	JPoint.prototype.eq = function eq(p) {
	  if (p.type === 'affine')
	    return this.eq(p.toJ());

	  if (this === p)
	    return true;

	  // x1 * z2^2 == x2 * z1^2
	  var z2 = this.z.redSqr();
	  var pz2 = p.z.redSqr();
	  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
	    return false;

	  // y1 * z2^3 == y2 * z1^3
	  var z3 = z2.redMul(this.z);
	  var pz3 = pz2.redMul(p.z);
	  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
	};

	JPoint.prototype.eqXToP = function eqXToP(x) {
	  var zs = this.z.redSqr();
	  var rx = x.toRed(this.curve.red).redMul(zs);
	  if (this.x.cmp(rx) === 0)
	    return true;

	  var xc = x.clone();
	  var t = this.curve.redN.redMul(zs);
	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0)
	      return false;

	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0)
	      return true;
	  }
	};

	JPoint.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC JPoint Infinity>';
	  return '<EC JPoint x: ' + this.x.toString(16, 2) +
	      ' y: ' + this.y.toString(16, 2) +
	      ' z: ' + this.z.toString(16, 2) + '>';
	};

	JPoint.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};
	return short;
}

var mont;
var hasRequiredMont;

function requireMont () {
	if (hasRequiredMont) return mont;
	hasRequiredMont = 1;

	var BN = requireBn$2();
	var inherits = requireInherits_browser();
	var Base = requireBase$1();

	var utils = requireUtils$1();

	function MontCurve(conf) {
	  Base.call(this, 'mont', conf);

	  this.a = new BN(conf.a, 16).toRed(this.red);
	  this.b = new BN(conf.b, 16).toRed(this.red);
	  this.i4 = new BN(4).toRed(this.red).redInvm();
	  this.two = new BN(2).toRed(this.red);
	  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
	}
	inherits(MontCurve, Base);
	mont = MontCurve;

	MontCurve.prototype.validate = function validate(point) {
	  var x = point.normalize().x;
	  var x2 = x.redSqr();
	  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
	  var y = rhs.redSqrt();

	  return y.redSqr().cmp(rhs) === 0;
	};

	function Point(curve, x, z) {
	  Base.BasePoint.call(this, curve, 'projective');
	  if (x === null && z === null) {
	    this.x = this.curve.one;
	    this.z = this.curve.zero;
	  } else {
	    this.x = new BN(x, 16);
	    this.z = new BN(z, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	  }
	}
	inherits(Point, Base.BasePoint);

	MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  return this.point(utils.toArray(bytes, enc), 1);
	};

	MontCurve.prototype.point = function point(x, z) {
	  return new Point(this, x, z);
	};

	MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point.fromJSON(this, obj);
	};

	Point.prototype.precompute = function precompute() {
	  // No-op
	};

	Point.prototype._encode = function _encode() {
	  return this.getX().toArray('be', this.curve.p.byteLength());
	};

	Point.fromJSON = function fromJSON(curve, obj) {
	  return new Point(curve, obj[0], obj[1] || curve.one);
	};

	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};

	Point.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};

	Point.prototype.dbl = function dbl() {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
	  // 2M + 2S + 4A

	  // A = X1 + Z1
	  var a = this.x.redAdd(this.z);
	  // AA = A^2
	  var aa = a.redSqr();
	  // B = X1 - Z1
	  var b = this.x.redSub(this.z);
	  // BB = B^2
	  var bb = b.redSqr();
	  // C = AA - BB
	  var c = aa.redSub(bb);
	  // X3 = AA * BB
	  var nx = aa.redMul(bb);
	  // Z3 = C * (BB + A24 * C)
	  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
	  return this.curve.point(nx, nz);
	};

	Point.prototype.add = function add() {
	  throw new Error('Not supported on Montgomery curve');
	};

	Point.prototype.diffAdd = function diffAdd(p, diff) {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
	  // 4M + 2S + 6A

	  // A = X2 + Z2
	  var a = this.x.redAdd(this.z);
	  // B = X2 - Z2
	  var b = this.x.redSub(this.z);
	  // C = X3 + Z3
	  var c = p.x.redAdd(p.z);
	  // D = X3 - Z3
	  var d = p.x.redSub(p.z);
	  // DA = D * A
	  var da = d.redMul(a);
	  // CB = C * B
	  var cb = c.redMul(b);
	  // X5 = Z1 * (DA + CB)^2
	  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
	  // Z5 = X1 * (DA - CB)^2
	  var nz = diff.x.redMul(da.redISub(cb).redSqr());
	  return this.curve.point(nx, nz);
	};

	Point.prototype.mul = function mul(k) {
	  var t = k.clone();
	  var a = this; // (N / 2) * Q + Q
	  var b = this.curve.point(null, null); // (N / 2) * Q
	  var c = this; // Q

	  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
	    bits.push(t.andln(1));

	  for (var i = bits.length - 1; i >= 0; i--) {
	    if (bits[i] === 0) {
	      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
	      a = a.diffAdd(b, c);
	      // N * Q = 2 * ((N / 2) * Q + Q))
	      b = b.dbl();
	    } else {
	      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
	      b = a.diffAdd(b, c);
	      // N * Q + Q = 2 * ((N / 2) * Q + Q)
	      a = a.dbl();
	    }
	  }
	  return b;
	};

	Point.prototype.mulAdd = function mulAdd() {
	  throw new Error('Not supported on Montgomery curve');
	};

	Point.prototype.jumlAdd = function jumlAdd() {
	  throw new Error('Not supported on Montgomery curve');
	};

	Point.prototype.eq = function eq(other) {
	  return this.getX().cmp(other.getX()) === 0;
	};

	Point.prototype.normalize = function normalize() {
	  this.x = this.x.redMul(this.z.redInvm());
	  this.z = this.curve.one;
	  return this;
	};

	Point.prototype.getX = function getX() {
	  // Normalize coordinates
	  this.normalize();

	  return this.x.fromRed();
	};
	return mont;
}

var edwards;
var hasRequiredEdwards;

function requireEdwards () {
	if (hasRequiredEdwards) return edwards;
	hasRequiredEdwards = 1;

	var utils = requireUtils$1();
	var BN = requireBn$2();
	var inherits = requireInherits_browser();
	var Base = requireBase$1();

	var assert = utils.assert;

	function EdwardsCurve(conf) {
	  // NOTE: Important as we are creating point in Base.call()
	  this.twisted = (conf.a | 0) !== 1;
	  this.mOneA = this.twisted && (conf.a | 0) === -1;
	  this.extended = this.mOneA;

	  Base.call(this, 'edwards', conf);

	  this.a = new BN(conf.a, 16).umod(this.red.m);
	  this.a = this.a.toRed(this.red);
	  this.c = new BN(conf.c, 16).toRed(this.red);
	  this.c2 = this.c.redSqr();
	  this.d = new BN(conf.d, 16).toRed(this.red);
	  this.dd = this.d.redAdd(this.d);

	  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
	  this.oneC = (conf.c | 0) === 1;
	}
	inherits(EdwardsCurve, Base);
	edwards = EdwardsCurve;

	EdwardsCurve.prototype._mulA = function _mulA(num) {
	  if (this.mOneA)
	    return num.redNeg();
	  else
	    return this.a.redMul(num);
	};

	EdwardsCurve.prototype._mulC = function _mulC(num) {
	  if (this.oneC)
	    return num;
	  else
	    return this.c.redMul(num);
	};

	// Just for compatibility with Short curve
	EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
	  return this.point(x, y, z, t);
	};

	EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);

	  var x2 = x.redSqr();
	  var rhs = this.c2.redSub(this.a.redMul(x2));
	  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

	  var y2 = rhs.redMul(lhs.redInvm());
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');

	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();

	  return this.point(x, y);
	};

	EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
	  y = new BN(y, 16);
	  if (!y.red)
	    y = y.toRed(this.red);

	  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
	  var y2 = y.redSqr();
	  var lhs = y2.redSub(this.c2);
	  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
	  var x2 = lhs.redMul(rhs.redInvm());

	  if (x2.cmp(this.zero) === 0) {
	    if (odd)
	      throw new Error('invalid point');
	    else
	      return this.point(this.zero, y);
	  }

	  var x = x2.redSqrt();
	  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');

	  if (x.fromRed().isOdd() !== odd)
	    x = x.redNeg();

	  return this.point(x, y);
	};

	EdwardsCurve.prototype.validate = function validate(point) {
	  if (point.isInfinity())
	    return true;

	  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
	  point.normalize();

	  var x2 = point.x.redSqr();
	  var y2 = point.y.redSqr();
	  var lhs = x2.redMul(this.a).redAdd(y2);
	  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

	  return lhs.cmp(rhs) === 0;
	};

	function Point(curve, x, y, z, t) {
	  Base.BasePoint.call(this, curve, 'projective');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.zero;
	    this.y = this.curve.one;
	    this.z = this.curve.one;
	    this.t = this.curve.zero;
	    this.zOne = true;
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    this.z = z ? new BN(z, 16) : this.curve.one;
	    this.t = t && new BN(t, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	    if (this.t && !this.t.red)
	      this.t = this.t.toRed(this.curve.red);
	    this.zOne = this.z === this.curve.one;

	    // Use extended coordinates
	    if (this.curve.extended && !this.t) {
	      this.t = this.x.redMul(this.y);
	      if (!this.zOne)
	        this.t = this.t.redMul(this.z.redInvm());
	    }
	  }
	}
	inherits(Point, Base.BasePoint);

	EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point.fromJSON(this, obj);
	};

	EdwardsCurve.prototype.point = function point(x, y, z, t) {
	  return new Point(this, x, y, z, t);
	};

	Point.fromJSON = function fromJSON(curve, obj) {
	  return new Point(curve, obj[0], obj[1], obj[2]);
	};

	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};

	Point.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.x.cmpn(0) === 0 &&
	    (this.y.cmp(this.z) === 0 ||
	    (this.zOne && this.y.cmp(this.curve.c) === 0));
	};

	Point.prototype._extDbl = function _extDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #doubling-dbl-2008-hwcd
	  // 4M + 4S

	  // A = X1^2
	  var a = this.x.redSqr();
	  // B = Y1^2
	  var b = this.y.redSqr();
	  // C = 2 * Z1^2
	  var c = this.z.redSqr();
	  c = c.redIAdd(c);
	  // D = a * A
	  var d = this.curve._mulA(a);
	  // E = (X1 + Y1)^2 - A - B
	  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
	  // G = D + B
	  var g = d.redAdd(b);
	  // F = G - C
	  var f = g.redSub(c);
	  // H = D - B
	  var h = d.redSub(b);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};

	Point.prototype._projDbl = function _projDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #doubling-dbl-2008-bbjlp
	  //     #doubling-dbl-2007-bl
	  // and others
	  // Generally 3M + 4S or 2M + 4S

	  // B = (X1 + Y1)^2
	  var b = this.x.redAdd(this.y).redSqr();
	  // C = X1^2
	  var c = this.x.redSqr();
	  // D = Y1^2
	  var d = this.y.redSqr();

	  var nx;
	  var ny;
	  var nz;
	  var e;
	  var h;
	  var j;
	  if (this.curve.twisted) {
	    // E = a * C
	    e = this.curve._mulA(c);
	    // F = E + D
	    var f = e.redAdd(d);
	    if (this.zOne) {
	      // X3 = (B - C - D) * (F - 2)
	      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F^2 - 2 * F
	      nz = f.redSqr().redSub(f).redSub(f);
	    } else {
	      // H = Z1^2
	      h = this.z.redSqr();
	      // J = F - 2 * H
	      j = f.redSub(h).redISub(h);
	      // X3 = (B-C-D)*J
	      nx = b.redSub(c).redISub(d).redMul(j);
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F * J
	      nz = f.redMul(j);
	    }
	  } else {
	    // E = C + D
	    e = c.redAdd(d);
	    // H = (c * Z1)^2
	    h = this.curve._mulC(this.z).redSqr();
	    // J = E - 2 * H
	    j = e.redSub(h).redSub(h);
	    // X3 = c * (B - E) * J
	    nx = this.curve._mulC(b.redISub(e)).redMul(j);
	    // Y3 = c * E * (C - D)
	    ny = this.curve._mulC(e).redMul(c.redISub(d));
	    // Z3 = E * J
	    nz = e.redMul(j);
	  }
	  return this.curve.point(nx, ny, nz);
	};

	Point.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;

	  // Double in extended coordinates
	  if (this.curve.extended)
	    return this._extDbl();
	  else
	    return this._projDbl();
	};

	Point.prototype._extAdd = function _extAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #addition-add-2008-hwcd-3
	  // 8M

	  // A = (Y1 - X1) * (Y2 - X2)
	  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
	  // B = (Y1 + X1) * (Y2 + X2)
	  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
	  // C = T1 * k * T2
	  var c = this.t.redMul(this.curve.dd).redMul(p.t);
	  // D = Z1 * 2 * Z2
	  var d = this.z.redMul(p.z.redAdd(p.z));
	  // E = B - A
	  var e = b.redSub(a);
	  // F = D - C
	  var f = d.redSub(c);
	  // G = D + C
	  var g = d.redAdd(c);
	  // H = B + A
	  var h = b.redAdd(a);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};

	Point.prototype._projAdd = function _projAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #addition-add-2008-bbjlp
	  //     #addition-add-2007-bl
	  // 10M + 1S

	  // A = Z1 * Z2
	  var a = this.z.redMul(p.z);
	  // B = A^2
	  var b = a.redSqr();
	  // C = X1 * X2
	  var c = this.x.redMul(p.x);
	  // D = Y1 * Y2
	  var d = this.y.redMul(p.y);
	  // E = d * C * D
	  var e = this.curve.d.redMul(c).redMul(d);
	  // F = B - E
	  var f = b.redSub(e);
	  // G = B + E
	  var g = b.redAdd(e);
	  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
	  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
	  var nx = a.redMul(f).redMul(tmp);
	  var ny;
	  var nz;
	  if (this.curve.twisted) {
	    // Y3 = A * G * (D - a * C)
	    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
	    // Z3 = F * G
	    nz = f.redMul(g);
	  } else {
	    // Y3 = A * G * (D - C)
	    ny = a.redMul(g).redMul(d.redSub(c));
	    // Z3 = c * F * G
	    nz = this.curve._mulC(f).redMul(g);
	  }
	  return this.curve.point(nx, ny, nz);
	};

	Point.prototype.add = function add(p) {
	  if (this.isInfinity())
	    return p;
	  if (p.isInfinity())
	    return this;

	  if (this.curve.extended)
	    return this._extAdd(p);
	  else
	    return this._projAdd(p);
	};

	Point.prototype.mul = function mul(k) {
	  if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else
	    return this.curve._wnafMul(this, k);
	};

	Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
	  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
	};

	Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
	  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
	};

	Point.prototype.normalize = function normalize() {
	  if (this.zOne)
	    return this;

	  // Normalize coordinates
	  var zi = this.z.redInvm();
	  this.x = this.x.redMul(zi);
	  this.y = this.y.redMul(zi);
	  if (this.t)
	    this.t = this.t.redMul(zi);
	  this.z = this.curve.one;
	  this.zOne = true;
	  return this;
	};

	Point.prototype.neg = function neg() {
	  return this.curve.point(this.x.redNeg(),
	    this.y,
	    this.z,
	    this.t && this.t.redNeg());
	};

	Point.prototype.getX = function getX() {
	  this.normalize();
	  return this.x.fromRed();
	};

	Point.prototype.getY = function getY() {
	  this.normalize();
	  return this.y.fromRed();
	};

	Point.prototype.eq = function eq(other) {
	  return this === other ||
	         this.getX().cmp(other.getX()) === 0 &&
	         this.getY().cmp(other.getY()) === 0;
	};

	Point.prototype.eqXToP = function eqXToP(x) {
	  var rx = x.toRed(this.curve.red).redMul(this.z);
	  if (this.x.cmp(rx) === 0)
	    return true;

	  var xc = x.clone();
	  var t = this.curve.redN.redMul(this.z);
	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0)
	      return false;

	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0)
	      return true;
	  }
	};

	// Compatibility with BaseCurve
	Point.prototype.toP = Point.prototype.normalize;
	Point.prototype.mixedAdd = Point.prototype.add;
	return edwards;
}

var hasRequiredCurve;

function requireCurve () {
	if (hasRequiredCurve) return curve;
	hasRequiredCurve = 1;
	(function (exports) {

		var curve = exports;

		curve.base = requireBase$1();
		curve.short = requireShort();
		curve.mont = requireMont();
		curve.edwards = requireEdwards(); 
	} (curve));
	return curve;
}

var curves = {};

var hash = {};

var utils = {};

var hasRequiredUtils;

function requireUtils () {
	if (hasRequiredUtils) return utils;
	hasRequiredUtils = 1;

	var assert = requireMinimalisticAssert();
	var inherits = requireInherits_browser();

	utils.inherits = inherits;

	function isSurrogatePair(msg, i) {
	  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
	    return false;
	  }
	  if (i < 0 || i + 1 >= msg.length) {
	    return false;
	  }
	  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
	}

	function toArray(msg, enc) {
	  if (Array.isArray(msg))
	    return msg.slice();
	  if (!msg)
	    return [];
	  var res = [];
	  if (typeof msg === 'string') {
	    if (!enc) {
	      // Inspired by stringToUtf8ByteArray() in closure-library by Google
	      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
	      // Apache License 2.0
	      // https://github.com/google/closure-library/blob/master/LICENSE
	      var p = 0;
	      for (var i = 0; i < msg.length; i++) {
	        var c = msg.charCodeAt(i);
	        if (c < 128) {
	          res[p++] = c;
	        } else if (c < 2048) {
	          res[p++] = (c >> 6) | 192;
	          res[p++] = (c & 63) | 128;
	        } else if (isSurrogatePair(msg, i)) {
	          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
	          res[p++] = (c >> 18) | 240;
	          res[p++] = ((c >> 12) & 63) | 128;
	          res[p++] = ((c >> 6) & 63) | 128;
	          res[p++] = (c & 63) | 128;
	        } else {
	          res[p++] = (c >> 12) | 224;
	          res[p++] = ((c >> 6) & 63) | 128;
	          res[p++] = (c & 63) | 128;
	        }
	      }
	    } else if (enc === 'hex') {
	      msg = msg.replace(/[^a-z0-9]+/ig, '');
	      if (msg.length % 2 !== 0)
	        msg = '0' + msg;
	      for (i = 0; i < msg.length; i += 2)
	        res.push(parseInt(msg[i] + msg[i + 1], 16));
	    }
	  } else {
	    for (i = 0; i < msg.length; i++)
	      res[i] = msg[i] | 0;
	  }
	  return res;
	}
	utils.toArray = toArray;

	function toHex(msg) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++)
	    res += zero2(msg[i].toString(16));
	  return res;
	}
	utils.toHex = toHex;

	function htonl(w) {
	  var res = (w >>> 24) |
	            ((w >>> 8) & 0xff00) |
	            ((w << 8) & 0xff0000) |
	            ((w & 0xff) << 24);
	  return res >>> 0;
	}
	utils.htonl = htonl;

	function toHex32(msg, endian) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++) {
	    var w = msg[i];
	    if (endian === 'little')
	      w = htonl(w);
	    res += zero8(w.toString(16));
	  }
	  return res;
	}
	utils.toHex32 = toHex32;

	function zero2(word) {
	  if (word.length === 1)
	    return '0' + word;
	  else
	    return word;
	}
	utils.zero2 = zero2;

	function zero8(word) {
	  if (word.length === 7)
	    return '0' + word;
	  else if (word.length === 6)
	    return '00' + word;
	  else if (word.length === 5)
	    return '000' + word;
	  else if (word.length === 4)
	    return '0000' + word;
	  else if (word.length === 3)
	    return '00000' + word;
	  else if (word.length === 2)
	    return '000000' + word;
	  else if (word.length === 1)
	    return '0000000' + word;
	  else
	    return word;
	}
	utils.zero8 = zero8;

	function join32(msg, start, end, endian) {
	  var len = end - start;
	  assert(len % 4 === 0);
	  var res = new Array(len / 4);
	  for (var i = 0, k = start; i < res.length; i++, k += 4) {
	    var w;
	    if (endian === 'big')
	      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
	    else
	      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
	    res[i] = w >>> 0;
	  }
	  return res;
	}
	utils.join32 = join32;

	function split32(msg, endian) {
	  var res = new Array(msg.length * 4);
	  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
	    var m = msg[i];
	    if (endian === 'big') {
	      res[k] = m >>> 24;
	      res[k + 1] = (m >>> 16) & 0xff;
	      res[k + 2] = (m >>> 8) & 0xff;
	      res[k + 3] = m & 0xff;
	    } else {
	      res[k + 3] = m >>> 24;
	      res[k + 2] = (m >>> 16) & 0xff;
	      res[k + 1] = (m >>> 8) & 0xff;
	      res[k] = m & 0xff;
	    }
	  }
	  return res;
	}
	utils.split32 = split32;

	function rotr32(w, b) {
	  return (w >>> b) | (w << (32 - b));
	}
	utils.rotr32 = rotr32;

	function rotl32(w, b) {
	  return (w << b) | (w >>> (32 - b));
	}
	utils.rotl32 = rotl32;

	function sum32(a, b) {
	  return (a + b) >>> 0;
	}
	utils.sum32 = sum32;

	function sum32_3(a, b, c) {
	  return (a + b + c) >>> 0;
	}
	utils.sum32_3 = sum32_3;

	function sum32_4(a, b, c, d) {
	  return (a + b + c + d) >>> 0;
	}
	utils.sum32_4 = sum32_4;

	function sum32_5(a, b, c, d, e) {
	  return (a + b + c + d + e) >>> 0;
	}
	utils.sum32_5 = sum32_5;

	function sum64(buf, pos, ah, al) {
	  var bh = buf[pos];
	  var bl = buf[pos + 1];

	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  buf[pos] = hi >>> 0;
	  buf[pos + 1] = lo;
	}
	utils.sum64 = sum64;

	function sum64_hi(ah, al, bh, bl) {
	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  return hi >>> 0;
	}
	utils.sum64_hi = sum64_hi;

	function sum64_lo(ah, al, bh, bl) {
	  var lo = al + bl;
	  return lo >>> 0;
	}
	utils.sum64_lo = sum64_lo;

	function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;

	  var hi = ah + bh + ch + dh + carry;
	  return hi >>> 0;
	}
	utils.sum64_4_hi = sum64_4_hi;

	function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
	  var lo = al + bl + cl + dl;
	  return lo >>> 0;
	}
	utils.sum64_4_lo = sum64_4_lo;

	function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;
	  lo = (lo + el) >>> 0;
	  carry += lo < el ? 1 : 0;

	  var hi = ah + bh + ch + dh + eh + carry;
	  return hi >>> 0;
	}
	utils.sum64_5_hi = sum64_5_hi;

	function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var lo = al + bl + cl + dl + el;

	  return lo >>> 0;
	}
	utils.sum64_5_lo = sum64_5_lo;

	function rotr64_hi(ah, al, num) {
	  var r = (al << (32 - num)) | (ah >>> num);
	  return r >>> 0;
	}
	utils.rotr64_hi = rotr64_hi;

	function rotr64_lo(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	}
	utils.rotr64_lo = rotr64_lo;

	function shr64_hi(ah, al, num) {
	  return ah >>> num;
	}
	utils.shr64_hi = shr64_hi;

	function shr64_lo(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	}
	utils.shr64_lo = shr64_lo;
	return utils;
}

var common$1 = {};

var hasRequiredCommon$1;

function requireCommon$1 () {
	if (hasRequiredCommon$1) return common$1;
	hasRequiredCommon$1 = 1;

	var utils = requireUtils();
	var assert = requireMinimalisticAssert();

	function BlockHash() {
	  this.pending = null;
	  this.pendingTotal = 0;
	  this.blockSize = this.constructor.blockSize;
	  this.outSize = this.constructor.outSize;
	  this.hmacStrength = this.constructor.hmacStrength;
	  this.padLength = this.constructor.padLength / 8;
	  this.endian = 'big';

	  this._delta8 = this.blockSize / 8;
	  this._delta32 = this.blockSize / 32;
	}
	common$1.BlockHash = BlockHash;

	BlockHash.prototype.update = function update(msg, enc) {
	  // Convert message to array, pad it, and join into 32bit blocks
	  msg = utils.toArray(msg, enc);
	  if (!this.pending)
	    this.pending = msg;
	  else
	    this.pending = this.pending.concat(msg);
	  this.pendingTotal += msg.length;

	  // Enough data, try updating
	  if (this.pending.length >= this._delta8) {
	    msg = this.pending;

	    // Process pending data in blocks
	    var r = msg.length % this._delta8;
	    this.pending = msg.slice(msg.length - r, msg.length);
	    if (this.pending.length === 0)
	      this.pending = null;

	    msg = utils.join32(msg, 0, msg.length - r, this.endian);
	    for (var i = 0; i < msg.length; i += this._delta32)
	      this._update(msg, i, i + this._delta32);
	  }

	  return this;
	};

	BlockHash.prototype.digest = function digest(enc) {
	  this.update(this._pad());
	  assert(this.pending === null);

	  return this._digest(enc);
	};

	BlockHash.prototype._pad = function pad() {
	  var len = this.pendingTotal;
	  var bytes = this._delta8;
	  var k = bytes - ((len + this.padLength) % bytes);
	  var res = new Array(k + this.padLength);
	  res[0] = 0x80;
	  for (var i = 1; i < k; i++)
	    res[i] = 0;

	  // Append length
	  len <<= 3;
	  if (this.endian === 'big') {
	    for (var t = 8; t < this.padLength; t++)
	      res[i++] = 0;

	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = len & 0xff;
	  } else {
	    res[i++] = len & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;

	    for (t = 8; t < this.padLength; t++)
	      res[i++] = 0;
	  }

	  return res;
	};
	return common$1;
}

var sha = {};

var common = {};

var hasRequiredCommon;

function requireCommon () {
	if (hasRequiredCommon) return common;
	hasRequiredCommon = 1;

	var utils = requireUtils();
	var rotr32 = utils.rotr32;

	function ft_1(s, x, y, z) {
	  if (s === 0)
	    return ch32(x, y, z);
	  if (s === 1 || s === 3)
	    return p32(x, y, z);
	  if (s === 2)
	    return maj32(x, y, z);
	}
	common.ft_1 = ft_1;

	function ch32(x, y, z) {
	  return (x & y) ^ ((~x) & z);
	}
	common.ch32 = ch32;

	function maj32(x, y, z) {
	  return (x & y) ^ (x & z) ^ (y & z);
	}
	common.maj32 = maj32;

	function p32(x, y, z) {
	  return x ^ y ^ z;
	}
	common.p32 = p32;

	function s0_256(x) {
	  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
	}
	common.s0_256 = s0_256;

	function s1_256(x) {
	  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
	}
	common.s1_256 = s1_256;

	function g0_256(x) {
	  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
	}
	common.g0_256 = g0_256;

	function g1_256(x) {
	  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
	}
	common.g1_256 = g1_256;
	return common;
}

var _1;
var hasRequired_1;

function require_1 () {
	if (hasRequired_1) return _1;
	hasRequired_1 = 1;

	var utils = requireUtils();
	var common = requireCommon$1();
	var shaCommon = requireCommon();

	var rotl32 = utils.rotl32;
	var sum32 = utils.sum32;
	var sum32_5 = utils.sum32_5;
	var ft_1 = shaCommon.ft_1;
	var BlockHash = common.BlockHash;

	var sha1_K = [
	  0x5A827999, 0x6ED9EBA1,
	  0x8F1BBCDC, 0xCA62C1D6
	];

	function SHA1() {
	  if (!(this instanceof SHA1))
	    return new SHA1();

	  BlockHash.call(this);
	  this.h = [
	    0x67452301, 0xefcdab89, 0x98badcfe,
	    0x10325476, 0xc3d2e1f0 ];
	  this.W = new Array(80);
	}

	utils.inherits(SHA1, BlockHash);
	_1 = SHA1;

	SHA1.blockSize = 512;
	SHA1.outSize = 160;
	SHA1.hmacStrength = 80;
	SHA1.padLength = 64;

	SHA1.prototype._update = function _update(msg, start) {
	  var W = this.W;

	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];

	  for(; i < W.length; i++)
	    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];

	  for (i = 0; i < W.length; i++) {
	    var s = ~~(i / 20);
	    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
	    e = d;
	    d = c;
	    c = rotl32(b, 30);
	    b = a;
	    a = t;
	  }

	  this.h[0] = sum32(this.h[0], a);
	  this.h[1] = sum32(this.h[1], b);
	  this.h[2] = sum32(this.h[2], c);
	  this.h[3] = sum32(this.h[3], d);
	  this.h[4] = sum32(this.h[4], e);
	};

	SHA1.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};
	return _1;
}

var _256;
var hasRequired_256;

function require_256 () {
	if (hasRequired_256) return _256;
	hasRequired_256 = 1;

	var utils = requireUtils();
	var common = requireCommon$1();
	var shaCommon = requireCommon();
	var assert = requireMinimalisticAssert();

	var sum32 = utils.sum32;
	var sum32_4 = utils.sum32_4;
	var sum32_5 = utils.sum32_5;
	var ch32 = shaCommon.ch32;
	var maj32 = shaCommon.maj32;
	var s0_256 = shaCommon.s0_256;
	var s1_256 = shaCommon.s1_256;
	var g0_256 = shaCommon.g0_256;
	var g1_256 = shaCommon.g1_256;

	var BlockHash = common.BlockHash;

	var sha256_K = [
	  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
	  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
	  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
	  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
	  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
	  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
	  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
	  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
	  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
	  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
	  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
	  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
	  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
	  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
	  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
	  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
	];

	function SHA256() {
	  if (!(this instanceof SHA256))
	    return new SHA256();

	  BlockHash.call(this);
	  this.h = [
	    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
	    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
	  ];
	  this.k = sha256_K;
	  this.W = new Array(64);
	}
	utils.inherits(SHA256, BlockHash);
	_256 = SHA256;

	SHA256.blockSize = 512;
	SHA256.outSize = 256;
	SHA256.hmacStrength = 192;
	SHA256.padLength = 64;

	SHA256.prototype._update = function _update(msg, start) {
	  var W = this.W;

	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i++)
	    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];
	  var f = this.h[5];
	  var g = this.h[6];
	  var h = this.h[7];

	  assert(this.k.length === W.length);
	  for (i = 0; i < W.length; i++) {
	    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
	    var T2 = sum32(s0_256(a), maj32(a, b, c));
	    h = g;
	    g = f;
	    f = e;
	    e = sum32(d, T1);
	    d = c;
	    c = b;
	    b = a;
	    a = sum32(T1, T2);
	  }

	  this.h[0] = sum32(this.h[0], a);
	  this.h[1] = sum32(this.h[1], b);
	  this.h[2] = sum32(this.h[2], c);
	  this.h[3] = sum32(this.h[3], d);
	  this.h[4] = sum32(this.h[4], e);
	  this.h[5] = sum32(this.h[5], f);
	  this.h[6] = sum32(this.h[6], g);
	  this.h[7] = sum32(this.h[7], h);
	};

	SHA256.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};
	return _256;
}

var _224;
var hasRequired_224;

function require_224 () {
	if (hasRequired_224) return _224;
	hasRequired_224 = 1;

	var utils = requireUtils();
	var SHA256 = require_256();

	function SHA224() {
	  if (!(this instanceof SHA224))
	    return new SHA224();

	  SHA256.call(this);
	  this.h = [
	    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
	}
	utils.inherits(SHA224, SHA256);
	_224 = SHA224;

	SHA224.blockSize = 512;
	SHA224.outSize = 224;
	SHA224.hmacStrength = 192;
	SHA224.padLength = 64;

	SHA224.prototype._digest = function digest(enc) {
	  // Just truncate output
	  if (enc === 'hex')
	    return utils.toHex32(this.h.slice(0, 7), 'big');
	  else
	    return utils.split32(this.h.slice(0, 7), 'big');
	};
	return _224;
}

var _512;
var hasRequired_512;

function require_512 () {
	if (hasRequired_512) return _512;
	hasRequired_512 = 1;

	var utils = requireUtils();
	var common = requireCommon$1();
	var assert = requireMinimalisticAssert();

	var rotr64_hi = utils.rotr64_hi;
	var rotr64_lo = utils.rotr64_lo;
	var shr64_hi = utils.shr64_hi;
	var shr64_lo = utils.shr64_lo;
	var sum64 = utils.sum64;
	var sum64_hi = utils.sum64_hi;
	var sum64_lo = utils.sum64_lo;
	var sum64_4_hi = utils.sum64_4_hi;
	var sum64_4_lo = utils.sum64_4_lo;
	var sum64_5_hi = utils.sum64_5_hi;
	var sum64_5_lo = utils.sum64_5_lo;

	var BlockHash = common.BlockHash;

	var sha512_K = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	];

	function SHA512() {
	  if (!(this instanceof SHA512))
	    return new SHA512();

	  BlockHash.call(this);
	  this.h = [
	    0x6a09e667, 0xf3bcc908,
	    0xbb67ae85, 0x84caa73b,
	    0x3c6ef372, 0xfe94f82b,
	    0xa54ff53a, 0x5f1d36f1,
	    0x510e527f, 0xade682d1,
	    0x9b05688c, 0x2b3e6c1f,
	    0x1f83d9ab, 0xfb41bd6b,
	    0x5be0cd19, 0x137e2179 ];
	  this.k = sha512_K;
	  this.W = new Array(160);
	}
	utils.inherits(SHA512, BlockHash);
	_512 = SHA512;

	SHA512.blockSize = 1024;
	SHA512.outSize = 512;
	SHA512.hmacStrength = 192;
	SHA512.padLength = 128;

	SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
	  var W = this.W;

	  // 32 x 32bit words
	  for (var i = 0; i < 32; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i += 2) {
	    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
	    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
	    var c1_hi = W[i - 14];  // i - 7
	    var c1_lo = W[i - 13];
	    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
	    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
	    var c3_hi = W[i - 32];  // i - 16
	    var c3_lo = W[i - 31];

	    W[i] = sum64_4_hi(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo);
	    W[i + 1] = sum64_4_lo(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo);
	  }
	};

	SHA512.prototype._update = function _update(msg, start) {
	  this._prepareBlock(msg, start);

	  var W = this.W;

	  var ah = this.h[0];
	  var al = this.h[1];
	  var bh = this.h[2];
	  var bl = this.h[3];
	  var ch = this.h[4];
	  var cl = this.h[5];
	  var dh = this.h[6];
	  var dl = this.h[7];
	  var eh = this.h[8];
	  var el = this.h[9];
	  var fh = this.h[10];
	  var fl = this.h[11];
	  var gh = this.h[12];
	  var gl = this.h[13];
	  var hh = this.h[14];
	  var hl = this.h[15];

	  assert(this.k.length === W.length);
	  for (var i = 0; i < W.length; i += 2) {
	    var c0_hi = hh;
	    var c0_lo = hl;
	    var c1_hi = s1_512_hi(eh, el);
	    var c1_lo = s1_512_lo(eh, el);
	    var c2_hi = ch64_hi(eh, el, fh, fl, gh);
	    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
	    var c3_hi = this.k[i];
	    var c3_lo = this.k[i + 1];
	    var c4_hi = W[i];
	    var c4_lo = W[i + 1];

	    var T1_hi = sum64_5_hi(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo,
	      c4_hi, c4_lo);
	    var T1_lo = sum64_5_lo(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo,
	      c4_hi, c4_lo);

	    c0_hi = s0_512_hi(ah, al);
	    c0_lo = s0_512_lo(ah, al);
	    c1_hi = maj64_hi(ah, al, bh, bl, ch);
	    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

	    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
	    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

	    hh = gh;
	    hl = gl;

	    gh = fh;
	    gl = fl;

	    fh = eh;
	    fl = el;

	    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
	    el = sum64_lo(dl, dl, T1_hi, T1_lo);

	    dh = ch;
	    dl = cl;

	    ch = bh;
	    cl = bl;

	    bh = ah;
	    bl = al;

	    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
	    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
	  }

	  sum64(this.h, 0, ah, al);
	  sum64(this.h, 2, bh, bl);
	  sum64(this.h, 4, ch, cl);
	  sum64(this.h, 6, dh, dl);
	  sum64(this.h, 8, eh, el);
	  sum64(this.h, 10, fh, fl);
	  sum64(this.h, 12, gh, gl);
	  sum64(this.h, 14, hh, hl);
	};

	SHA512.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};

	function ch64_hi(xh, xl, yh, yl, zh) {
	  var r = (xh & yh) ^ ((~xh) & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function ch64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ ((~xl) & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function maj64_hi(xh, xl, yh, yl, zh) {
	  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function maj64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 28);
	  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
	  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 28);
	  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
	  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 14);
	  var c1_hi = rotr64_hi(xh, xl, 18);
	  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 14);
	  var c1_lo = rotr64_lo(xh, xl, 18);
	  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 1);
	  var c1_hi = rotr64_hi(xh, xl, 8);
	  var c2_hi = shr64_hi(xh, xl, 7);

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 1);
	  var c1_lo = rotr64_lo(xh, xl, 8);
	  var c2_lo = shr64_lo(xh, xl, 7);

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 19);
	  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
	  var c2_hi = shr64_hi(xh, xl, 6);

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 19);
	  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
	  var c2_lo = shr64_lo(xh, xl, 6);

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	return _512;
}

var _384;
var hasRequired_384;

function require_384 () {
	if (hasRequired_384) return _384;
	hasRequired_384 = 1;

	var utils = requireUtils();

	var SHA512 = require_512();

	function SHA384() {
	  if (!(this instanceof SHA384))
	    return new SHA384();

	  SHA512.call(this);
	  this.h = [
	    0xcbbb9d5d, 0xc1059ed8,
	    0x629a292a, 0x367cd507,
	    0x9159015a, 0x3070dd17,
	    0x152fecd8, 0xf70e5939,
	    0x67332667, 0xffc00b31,
	    0x8eb44a87, 0x68581511,
	    0xdb0c2e0d, 0x64f98fa7,
	    0x47b5481d, 0xbefa4fa4 ];
	}
	utils.inherits(SHA384, SHA512);
	_384 = SHA384;

	SHA384.blockSize = 1024;
	SHA384.outSize = 384;
	SHA384.hmacStrength = 192;
	SHA384.padLength = 128;

	SHA384.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h.slice(0, 12), 'big');
	  else
	    return utils.split32(this.h.slice(0, 12), 'big');
	};
	return _384;
}

var hasRequiredSha;

function requireSha () {
	if (hasRequiredSha) return sha;
	hasRequiredSha = 1;

	sha.sha1 = require_1();
	sha.sha224 = require_224();
	sha.sha256 = require_256();
	sha.sha384 = require_384();
	sha.sha512 = require_512();
	return sha;
}

var ripemd = {};

var hasRequiredRipemd;

function requireRipemd () {
	if (hasRequiredRipemd) return ripemd;
	hasRequiredRipemd = 1;

	var utils = requireUtils();
	var common = requireCommon$1();

	var rotl32 = utils.rotl32;
	var sum32 = utils.sum32;
	var sum32_3 = utils.sum32_3;
	var sum32_4 = utils.sum32_4;
	var BlockHash = common.BlockHash;

	function RIPEMD160() {
	  if (!(this instanceof RIPEMD160))
	    return new RIPEMD160();

	  BlockHash.call(this);

	  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
	  this.endian = 'little';
	}
	utils.inherits(RIPEMD160, BlockHash);
	ripemd.ripemd160 = RIPEMD160;

	RIPEMD160.blockSize = 512;
	RIPEMD160.outSize = 160;
	RIPEMD160.hmacStrength = 192;
	RIPEMD160.padLength = 64;

	RIPEMD160.prototype._update = function update(msg, start) {
	  var A = this.h[0];
	  var B = this.h[1];
	  var C = this.h[2];
	  var D = this.h[3];
	  var E = this.h[4];
	  var Ah = A;
	  var Bh = B;
	  var Ch = C;
	  var Dh = D;
	  var Eh = E;
	  for (var j = 0; j < 80; j++) {
	    var T = sum32(
	      rotl32(
	        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
	        s[j]),
	      E);
	    A = E;
	    E = D;
	    D = rotl32(C, 10);
	    C = B;
	    B = T;
	    T = sum32(
	      rotl32(
	        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
	        sh[j]),
	      Eh);
	    Ah = Eh;
	    Eh = Dh;
	    Dh = rotl32(Ch, 10);
	    Ch = Bh;
	    Bh = T;
	  }
	  T = sum32_3(this.h[1], C, Dh);
	  this.h[1] = sum32_3(this.h[2], D, Eh);
	  this.h[2] = sum32_3(this.h[3], E, Ah);
	  this.h[3] = sum32_3(this.h[4], A, Bh);
	  this.h[4] = sum32_3(this.h[0], B, Ch);
	  this.h[0] = T;
	};

	RIPEMD160.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'little');
	  else
	    return utils.split32(this.h, 'little');
	};

	function f(j, x, y, z) {
	  if (j <= 15)
	    return x ^ y ^ z;
	  else if (j <= 31)
	    return (x & y) | ((~x) & z);
	  else if (j <= 47)
	    return (x | (~y)) ^ z;
	  else if (j <= 63)
	    return (x & z) | (y & (~z));
	  else
	    return x ^ (y | (~z));
	}

	function K(j) {
	  if (j <= 15)
	    return 0x00000000;
	  else if (j <= 31)
	    return 0x5a827999;
	  else if (j <= 47)
	    return 0x6ed9eba1;
	  else if (j <= 63)
	    return 0x8f1bbcdc;
	  else
	    return 0xa953fd4e;
	}

	function Kh(j) {
	  if (j <= 15)
	    return 0x50a28be6;
	  else if (j <= 31)
	    return 0x5c4dd124;
	  else if (j <= 47)
	    return 0x6d703ef3;
	  else if (j <= 63)
	    return 0x7a6d76e9;
	  else
	    return 0x00000000;
	}

	var r = [
	  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	];

	var rh = [
	  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	];

	var s = [
	  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	];

	var sh = [
	  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	];
	return ripemd;
}

var hmac;
var hasRequiredHmac;

function requireHmac () {
	if (hasRequiredHmac) return hmac;
	hasRequiredHmac = 1;

	var utils = requireUtils();
	var assert = requireMinimalisticAssert();

	function Hmac(hash, key, enc) {
	  if (!(this instanceof Hmac))
	    return new Hmac(hash, key, enc);
	  this.Hash = hash;
	  this.blockSize = hash.blockSize / 8;
	  this.outSize = hash.outSize / 8;
	  this.inner = null;
	  this.outer = null;

	  this._init(utils.toArray(key, enc));
	}
	hmac = Hmac;

	Hmac.prototype._init = function init(key) {
	  // Shorten key, if needed
	  if (key.length > this.blockSize)
	    key = new this.Hash().update(key).digest();
	  assert(key.length <= this.blockSize);

	  // Add padding to key
	  for (var i = key.length; i < this.blockSize; i++)
	    key.push(0);

	  for (i = 0; i < key.length; i++)
	    key[i] ^= 0x36;
	  this.inner = new this.Hash().update(key);

	  // 0x36 ^ 0x5c = 0x6a
	  for (i = 0; i < key.length; i++)
	    key[i] ^= 0x6a;
	  this.outer = new this.Hash().update(key);
	};

	Hmac.prototype.update = function update(msg, enc) {
	  this.inner.update(msg, enc);
	  return this;
	};

	Hmac.prototype.digest = function digest(enc) {
	  this.outer.update(this.inner.digest());
	  return this.outer.digest(enc);
	};
	return hmac;
}

var hasRequiredHash;

function requireHash () {
	if (hasRequiredHash) return hash;
	hasRequiredHash = 1;
	(function (exports) {
		var hash = exports;

		hash.utils = requireUtils();
		hash.common = requireCommon$1();
		hash.sha = requireSha();
		hash.ripemd = requireRipemd();
		hash.hmac = requireHmac();

		// Proxy hash functions to the main object
		hash.sha1 = hash.sha.sha1;
		hash.sha256 = hash.sha.sha256;
		hash.sha224 = hash.sha.sha224;
		hash.sha384 = hash.sha.sha384;
		hash.sha512 = hash.sha.sha512;
		hash.ripemd160 = hash.ripemd.ripemd160; 
	} (hash));
	return hash;
}

var secp256k1;
var hasRequiredSecp256k1;

function requireSecp256k1 () {
	if (hasRequiredSecp256k1) return secp256k1;
	hasRequiredSecp256k1 = 1;
	secp256k1 = {
	  doubles: {
	    step: 4,
	    points: [
	      [
	        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
	        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
	      ],
	      [
	        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
	        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
	      ],
	      [
	        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
	        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
	      ],
	      [
	        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
	        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
	      ],
	      [
	        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
	        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
	      ],
	      [
	        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
	        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
	      ],
	      [
	        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
	        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
	      ],
	      [
	        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
	        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
	      ],
	      [
	        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
	        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
	      ],
	      [
	        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
	        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
	      ],
	      [
	        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
	        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
	      ],
	      [
	        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
	        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
	      ],
	      [
	        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
	        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
	      ],
	      [
	        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
	        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
	      ],
	      [
	        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
	        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
	      ],
	      [
	        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
	        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
	      ],
	      [
	        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
	        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
	      ],
	      [
	        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
	        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
	      ],
	      [
	        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
	        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
	      ],
	      [
	        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
	        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
	      ],
	      [
	        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
	        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
	      ],
	      [
	        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
	        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
	      ],
	      [
	        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
	        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
	      ],
	      [
	        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
	        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
	      ],
	      [
	        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
	        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
	      ],
	      [
	        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
	        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
	      ],
	      [
	        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
	        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
	      ],
	      [
	        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
	        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
	      ],
	      [
	        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
	        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
	      ],
	      [
	        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
	        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
	      ],
	      [
	        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
	        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
	      ],
	      [
	        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
	        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
	      ],
	      [
	        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
	        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
	      ],
	      [
	        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
	        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
	      ],
	      [
	        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
	        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
	      ],
	      [
	        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
	        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
	      ],
	      [
	        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
	        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
	      ],
	      [
	        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
	        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
	      ],
	      [
	        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
	        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
	      ],
	      [
	        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
	        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
	      ],
	      [
	        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
	        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
	      ],
	      [
	        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
	        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
	      ],
	      [
	        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
	        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
	      ],
	      [
	        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
	        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
	      ],
	      [
	        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
	        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
	      ],
	      [
	        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
	        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
	      ],
	      [
	        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
	        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
	      ],
	      [
	        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
	        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
	      ],
	      [
	        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
	        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
	      ],
	      [
	        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
	        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
	      ],
	      [
	        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
	        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
	      ],
	      [
	        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
	        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
	      ],
	      [
	        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
	        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
	      ],
	      [
	        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
	        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
	      ],
	      [
	        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
	        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
	      ],
	      [
	        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
	        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
	      ],
	      [
	        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
	        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
	      ],
	      [
	        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
	        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
	      ],
	      [
	        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
	        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
	      ],
	      [
	        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
	        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
	      ],
	      [
	        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
	        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
	      ],
	      [
	        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
	        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
	      ],
	      [
	        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
	        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
	      ],
	      [
	        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
	        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
	      ],
	      [
	        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
	        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
	      ],
	    ],
	  },
	  naf: {
	    wnd: 7,
	    points: [
	      [
	        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
	        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
	      ],
	      [
	        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
	        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
	      ],
	      [
	        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
	        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
	      ],
	      [
	        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
	        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
	      ],
	      [
	        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
	        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
	      ],
	      [
	        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
	        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
	      ],
	      [
	        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
	        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
	      ],
	      [
	        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
	        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
	      ],
	      [
	        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
	        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
	      ],
	      [
	        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
	        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
	      ],
	      [
	        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
	        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
	      ],
	      [
	        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
	        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
	      ],
	      [
	        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
	        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
	      ],
	      [
	        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
	        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
	      ],
	      [
	        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
	        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
	      ],
	      [
	        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
	        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
	      ],
	      [
	        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
	        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
	      ],
	      [
	        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
	        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
	      ],
	      [
	        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
	        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
	      ],
	      [
	        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
	        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
	      ],
	      [
	        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
	        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
	      ],
	      [
	        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
	        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
	      ],
	      [
	        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
	        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
	      ],
	      [
	        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
	        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
	      ],
	      [
	        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
	        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
	      ],
	      [
	        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
	        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
	      ],
	      [
	        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
	        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
	      ],
	      [
	        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
	        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
	      ],
	      [
	        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
	        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
	      ],
	      [
	        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
	        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
	      ],
	      [
	        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
	        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
	      ],
	      [
	        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
	        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
	      ],
	      [
	        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
	        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
	      ],
	      [
	        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
	        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
	      ],
	      [
	        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
	        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
	      ],
	      [
	        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
	        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
	      ],
	      [
	        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
	        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
	      ],
	      [
	        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
	        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
	      ],
	      [
	        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
	        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
	      ],
	      [
	        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
	        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
	      ],
	      [
	        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
	        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
	      ],
	      [
	        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
	        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
	      ],
	      [
	        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
	        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
	      ],
	      [
	        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
	        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
	      ],
	      [
	        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
	        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
	      ],
	      [
	        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
	        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
	      ],
	      [
	        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
	        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
	      ],
	      [
	        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
	        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
	      ],
	      [
	        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
	        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
	      ],
	      [
	        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
	        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
	      ],
	      [
	        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
	        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
	      ],
	      [
	        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
	        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
	      ],
	      [
	        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
	        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
	      ],
	      [
	        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
	        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
	      ],
	      [
	        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
	        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
	      ],
	      [
	        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
	        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
	      ],
	      [
	        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
	        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
	      ],
	      [
	        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
	        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
	      ],
	      [
	        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
	        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
	      ],
	      [
	        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
	        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
	      ],
	      [
	        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
	        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
	      ],
	      [
	        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
	        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
	      ],
	      [
	        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
	        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
	      ],
	      [
	        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
	        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
	      ],
	      [
	        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
	        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
	      ],
	      [
	        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
	        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
	      ],
	      [
	        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
	        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
	      ],
	      [
	        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
	        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
	      ],
	      [
	        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
	        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
	      ],
	      [
	        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
	        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
	      ],
	      [
	        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
	        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
	      ],
	      [
	        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
	        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
	      ],
	      [
	        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
	        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
	      ],
	      [
	        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
	        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
	      ],
	      [
	        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
	        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
	      ],
	      [
	        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
	        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
	      ],
	      [
	        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
	        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
	      ],
	      [
	        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
	        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
	      ],
	      [
	        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
	        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
	      ],
	      [
	        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
	        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
	      ],
	      [
	        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
	        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
	      ],
	      [
	        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
	        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
	      ],
	      [
	        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
	        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
	      ],
	      [
	        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
	        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
	      ],
	      [
	        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
	        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
	      ],
	      [
	        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
	        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
	      ],
	      [
	        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
	        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
	      ],
	      [
	        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
	        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
	      ],
	      [
	        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
	        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
	      ],
	      [
	        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
	        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
	      ],
	      [
	        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
	        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
	      ],
	      [
	        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
	        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
	      ],
	      [
	        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
	        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
	      ],
	      [
	        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
	        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
	      ],
	      [
	        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
	        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
	      ],
	      [
	        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
	        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
	      ],
	      [
	        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
	        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
	      ],
	      [
	        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
	        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
	      ],
	      [
	        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
	        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
	      ],
	      [
	        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
	        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
	      ],
	      [
	        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
	        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
	      ],
	      [
	        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
	        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
	      ],
	      [
	        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
	        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
	      ],
	      [
	        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
	        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
	      ],
	      [
	        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
	        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
	      ],
	      [
	        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
	        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
	      ],
	      [
	        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
	        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
	      ],
	      [
	        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
	        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
	      ],
	      [
	        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
	        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
	      ],
	      [
	        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
	        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
	      ],
	      [
	        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
	        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
	      ],
	      [
	        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
	        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
	      ],
	      [
	        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
	        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
	      ],
	      [
	        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
	        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
	      ],
	      [
	        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
	        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
	      ],
	      [
	        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
	        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
	      ],
	      [
	        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
	        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
	      ],
	      [
	        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
	        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
	      ],
	      [
	        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
	        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
	      ],
	      [
	        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
	        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
	      ],
	      [
	        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
	        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
	      ],
	      [
	        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
	        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
	      ],
	      [
	        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
	        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
	      ],
	      [
	        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
	        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
	      ],
	      [
	        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
	        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
	      ],
	      [
	        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
	        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
	      ],
	      [
	        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
	        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
	      ],
	    ],
	  },
	};
	return secp256k1;
}

var hasRequiredCurves;

function requireCurves () {
	if (hasRequiredCurves) return curves;
	hasRequiredCurves = 1;
	(function (exports) {

		var curves = exports;

		var hash = requireHash();
		var curve = requireCurve();
		var utils = requireUtils$1();

		var assert = utils.assert;

		function PresetCurve(options) {
		  if (options.type === 'short')
		    this.curve = new curve.short(options);
		  else if (options.type === 'edwards')
		    this.curve = new curve.edwards(options);
		  else
		    this.curve = new curve.mont(options);
		  this.g = this.curve.g;
		  this.n = this.curve.n;
		  this.hash = options.hash;

		  assert(this.g.validate(), 'Invalid curve');
		  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
		}
		curves.PresetCurve = PresetCurve;

		function defineCurve(name, options) {
		  Object.defineProperty(curves, name, {
		    configurable: true,
		    enumerable: true,
		    get: function() {
		      var curve = new PresetCurve(options);
		      Object.defineProperty(curves, name, {
		        configurable: true,
		        enumerable: true,
		        value: curve,
		      });
		      return curve;
		    },
		  });
		}

		defineCurve('p192', {
		  type: 'short',
		  prime: 'p192',
		  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
		  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
		  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
		  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
		    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
		  ],
		});

		defineCurve('p224', {
		  type: 'short',
		  prime: 'p224',
		  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
		  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
		  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
		  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
		    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
		  ],
		});

		defineCurve('p256', {
		  type: 'short',
		  prime: null,
		  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
		  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
		  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
		  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
		    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
		  ],
		});

		defineCurve('p384', {
		  type: 'short',
		  prime: null,
		  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'fffffffe ffffffff 00000000 00000000 ffffffff',
		  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'fffffffe ffffffff 00000000 00000000 fffffffc',
		  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
		     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
		  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
		     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
		  hash: hash.sha384,
		  gRed: false,
		  g: [
		    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
		    '5502f25d bf55296c 3a545e38 72760ab7',
		    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
		    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
		  ],
		});

		defineCurve('p521', {
		  type: 'short',
		  prime: null,
		  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff ffffffff',
		  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff fffffffc',
		  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
		     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
		     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
		  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
		     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
		  hash: hash.sha512,
		  gRed: false,
		  g: [
		    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
		    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
		    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
		    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
		    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
		    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
		  ],
		});

		defineCurve('curve25519', {
		  type: 'mont',
		  prime: 'p25519',
		  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
		  a: '76d06',
		  b: '1',
		  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '9',
		  ],
		});

		defineCurve('ed25519', {
		  type: 'edwards',
		  prime: 'p25519',
		  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
		  a: '-1',
		  c: '1',
		  // -121665 * (121666^(-1)) (mod P)
		  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
		  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

		    // 4/5
		    '6666666666666666666666666666666666666666666666666666666666666658',
		  ],
		});

		var pre;
		try {
		  pre = requireSecp256k1();
		} catch (e) {
		  pre = undefined;
		}

		defineCurve('secp256k1', {
		  type: 'short',
		  prime: 'k256',
		  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
		  a: '0',
		  b: '7',
		  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
		  h: '1',
		  hash: hash.sha256,

		  // Precomputed endomorphism
		  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
		  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
		  basis: [
		    {
		      a: '3086d221a7d46bcde86c90e49284eb15',
		      b: '-e4437ed6010e88286f547fa90abfe4c3',
		    },
		    {
		      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
		      b: '3086d221a7d46bcde86c90e49284eb15',
		    },
		  ],

		  gRed: false,
		  g: [
		    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
		    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
		    pre,
		  ],
		}); 
	} (curves));
	return curves;
}

var hmacDrbg;
var hasRequiredHmacDrbg;

function requireHmacDrbg () {
	if (hasRequiredHmacDrbg) return hmacDrbg;
	hasRequiredHmacDrbg = 1;

	var hash = requireHash();
	var utils = requireUtils$2();
	var assert = requireMinimalisticAssert();

	function HmacDRBG(options) {
	  if (!(this instanceof HmacDRBG))
	    return new HmacDRBG(options);
	  this.hash = options.hash;
	  this.predResist = !!options.predResist;

	  this.outLen = this.hash.outSize;
	  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

	  this._reseed = null;
	  this.reseedInterval = null;
	  this.K = null;
	  this.V = null;

	  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
	  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
	  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
	  assert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
	  this._init(entropy, nonce, pers);
	}
	hmacDrbg = HmacDRBG;

	HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
	  var seed = entropy.concat(nonce).concat(pers);

	  this.K = new Array(this.outLen / 8);
	  this.V = new Array(this.outLen / 8);
	  for (var i = 0; i < this.V.length; i++) {
	    this.K[i] = 0x00;
	    this.V[i] = 0x01;
	  }

	  this._update(seed);
	  this._reseed = 1;
	  this.reseedInterval = 0x1000000000000;  // 2^48
	};

	HmacDRBG.prototype._hmac = function hmac() {
	  return new hash.hmac(this.hash, this.K);
	};

	HmacDRBG.prototype._update = function update(seed) {
	  var kmac = this._hmac()
	                 .update(this.V)
	                 .update([ 0x00 ]);
	  if (seed)
	    kmac = kmac.update(seed);
	  this.K = kmac.digest();
	  this.V = this._hmac().update(this.V).digest();
	  if (!seed)
	    return;

	  this.K = this._hmac()
	               .update(this.V)
	               .update([ 0x01 ])
	               .update(seed)
	               .digest();
	  this.V = this._hmac().update(this.V).digest();
	};

	HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
	  // Optional entropy enc
	  if (typeof entropyEnc !== 'string') {
	    addEnc = add;
	    add = entropyEnc;
	    entropyEnc = null;
	  }

	  entropy = utils.toArray(entropy, entropyEnc);
	  add = utils.toArray(add, addEnc);

	  assert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

	  this._update(entropy.concat(add || []));
	  this._reseed = 1;
	};

	HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
	  if (this._reseed > this.reseedInterval)
	    throw new Error('Reseed is required');

	  // Optional encoding
	  if (typeof enc !== 'string') {
	    addEnc = add;
	    add = enc;
	    enc = null;
	  }

	  // Optional additional data
	  if (add) {
	    add = utils.toArray(add, addEnc || 'hex');
	    this._update(add);
	  }

	  var temp = [];
	  while (temp.length < len) {
	    this.V = this._hmac().update(this.V).digest();
	    temp = temp.concat(this.V);
	  }

	  var res = temp.slice(0, len);
	  this._update(add);
	  this._reseed++;
	  return utils.encode(res, enc);
	};
	return hmacDrbg;
}

var key$1;
var hasRequiredKey$1;

function requireKey$1 () {
	if (hasRequiredKey$1) return key$1;
	hasRequiredKey$1 = 1;

	var BN = requireBn$2();
	var utils = requireUtils$1();
	var assert = utils.assert;

	function KeyPair(ec, options) {
	  this.ec = ec;
	  this.priv = null;
	  this.pub = null;

	  // KeyPair(ec, { priv: ..., pub: ... })
	  if (options.priv)
	    this._importPrivate(options.priv, options.privEnc);
	  if (options.pub)
	    this._importPublic(options.pub, options.pubEnc);
	}
	key$1 = KeyPair;

	KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
	  if (pub instanceof KeyPair)
	    return pub;

	  return new KeyPair(ec, {
	    pub: pub,
	    pubEnc: enc,
	  });
	};

	KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
	  if (priv instanceof KeyPair)
	    return priv;

	  return new KeyPair(ec, {
	    priv: priv,
	    privEnc: enc,
	  });
	};

	KeyPair.prototype.validate = function validate() {
	  var pub = this.getPublic();

	  if (pub.isInfinity())
	    return { result: false, reason: 'Invalid public key' };
	  if (!pub.validate())
	    return { result: false, reason: 'Public key is not a point' };
	  if (!pub.mul(this.ec.curve.n).isInfinity())
	    return { result: false, reason: 'Public key * N != O' };

	  return { result: true, reason: null };
	};

	KeyPair.prototype.getPublic = function getPublic(compact, enc) {
	  // compact is optional argument
	  if (typeof compact === 'string') {
	    enc = compact;
	    compact = null;
	  }

	  if (!this.pub)
	    this.pub = this.ec.g.mul(this.priv);

	  if (!enc)
	    return this.pub;

	  return this.pub.encode(enc, compact);
	};

	KeyPair.prototype.getPrivate = function getPrivate(enc) {
	  if (enc === 'hex')
	    return this.priv.toString(16, 2);
	  else
	    return this.priv;
	};

	KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
	  this.priv = new BN(key, enc || 16);

	  // Ensure that the priv won't be bigger than n, otherwise we may fail
	  // in fixed multiplication method
	  this.priv = this.priv.umod(this.ec.curve.n);
	};

	KeyPair.prototype._importPublic = function _importPublic(key, enc) {
	  if (key.x || key.y) {
	    // Montgomery points only have an `x` coordinate.
	    // Weierstrass/Edwards points on the other hand have both `x` and
	    // `y` coordinates.
	    if (this.ec.curve.type === 'mont') {
	      assert(key.x, 'Need x coordinate');
	    } else if (this.ec.curve.type === 'short' ||
	               this.ec.curve.type === 'edwards') {
	      assert(key.x && key.y, 'Need both x and y coordinate');
	    }
	    this.pub = this.ec.curve.point(key.x, key.y);
	    return;
	  }
	  this.pub = this.ec.curve.decodePoint(key, enc);
	};

	// ECDH
	KeyPair.prototype.derive = function derive(pub) {
	  if(!pub.validate()) {
	    assert(pub.validate(), 'public point not validated');
	  }
	  return pub.mul(this.priv).getX();
	};

	// ECDSA
	KeyPair.prototype.sign = function sign(msg, enc, options) {
	  return this.ec.sign(msg, this, enc, options);
	};

	KeyPair.prototype.verify = function verify(msg, signature, options) {
	  return this.ec.verify(msg, signature, this, undefined, options);
	};

	KeyPair.prototype.inspect = function inspect() {
	  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
	         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
	};
	return key$1;
}

var signature$1;
var hasRequiredSignature$1;

function requireSignature$1 () {
	if (hasRequiredSignature$1) return signature$1;
	hasRequiredSignature$1 = 1;

	var BN = requireBn$2();

	var utils = requireUtils$1();
	var assert = utils.assert;

	function Signature(options, enc) {
	  if (options instanceof Signature)
	    return options;

	  if (this._importDER(options, enc))
	    return;

	  assert(options.r && options.s, 'Signature without r or s');
	  this.r = new BN(options.r, 16);
	  this.s = new BN(options.s, 16);
	  if (options.recoveryParam === undefined)
	    this.recoveryParam = null;
	  else
	    this.recoveryParam = options.recoveryParam;
	}
	signature$1 = Signature;

	function Position() {
	  this.place = 0;
	}

	function getLength(buf, p) {
	  var initial = buf[p.place++];
	  if (!(initial & 0x80)) {
	    return initial;
	  }
	  var octetLen = initial & 0xf;

	  // Indefinite length or overflow
	  if (octetLen === 0 || octetLen > 4) {
	    return false;
	  }

	  if(buf[p.place] === 0x00) {
	    return false;
	  }

	  var val = 0;
	  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
	    val <<= 8;
	    val |= buf[off];
	    val >>>= 0;
	  }

	  // Leading zeroes
	  if (val <= 0x7f) {
	    return false;
	  }

	  p.place = off;
	  return val;
	}

	function rmPadding(buf) {
	  var i = 0;
	  var len = buf.length - 1;
	  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
	    i++;
	  }
	  if (i === 0) {
	    return buf;
	  }
	  return buf.slice(i);
	}

	Signature.prototype._importDER = function _importDER(data, enc) {
	  data = utils.toArray(data, enc);
	  var p = new Position();
	  if (data[p.place++] !== 0x30) {
	    return false;
	  }
	  var len = getLength(data, p);
	  if (len === false) {
	    return false;
	  }
	  if ((len + p.place) !== data.length) {
	    return false;
	  }
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var rlen = getLength(data, p);
	  if (rlen === false) {
	    return false;
	  }
	  if ((data[p.place] & 128) !== 0) {
	    return false;
	  }
	  var r = data.slice(p.place, rlen + p.place);
	  p.place += rlen;
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var slen = getLength(data, p);
	  if (slen === false) {
	    return false;
	  }
	  if (data.length !== slen + p.place) {
	    return false;
	  }
	  if ((data[p.place] & 128) !== 0) {
	    return false;
	  }
	  var s = data.slice(p.place, slen + p.place);
	  if (r[0] === 0) {
	    if (r[1] & 0x80) {
	      r = r.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }
	  if (s[0] === 0) {
	    if (s[1] & 0x80) {
	      s = s.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }

	  this.r = new BN(r);
	  this.s = new BN(s);
	  this.recoveryParam = null;

	  return true;
	};

	function constructLength(arr, len) {
	  if (len < 0x80) {
	    arr.push(len);
	    return;
	  }
	  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
	  arr.push(octets | 0x80);
	  while (--octets) {
	    arr.push((len >>> (octets << 3)) & 0xff);
	  }
	  arr.push(len);
	}

	Signature.prototype.toDER = function toDER(enc) {
	  var r = this.r.toArray();
	  var s = this.s.toArray();

	  // Pad values
	  if (r[0] & 0x80)
	    r = [ 0 ].concat(r);
	  // Pad values
	  if (s[0] & 0x80)
	    s = [ 0 ].concat(s);

	  r = rmPadding(r);
	  s = rmPadding(s);

	  while (!s[0] && !(s[1] & 0x80)) {
	    s = s.slice(1);
	  }
	  var arr = [ 0x02 ];
	  constructLength(arr, r.length);
	  arr = arr.concat(r);
	  arr.push(0x02);
	  constructLength(arr, s.length);
	  var backHalf = arr.concat(s);
	  var res = [ 0x30 ];
	  constructLength(res, backHalf.length);
	  res = res.concat(backHalf);
	  return utils.encode(res, enc);
	};
	return signature$1;
}

var ec;
var hasRequiredEc;

function requireEc () {
	if (hasRequiredEc) return ec;
	hasRequiredEc = 1;

	var BN = requireBn$2();
	var HmacDRBG = requireHmacDrbg();
	var utils = requireUtils$1();
	var curves = requireCurves();
	var rand = requireBrorand();
	var assert = utils.assert;

	var KeyPair = requireKey$1();
	var Signature = requireSignature$1();

	function EC(options) {
	  if (!(this instanceof EC))
	    return new EC(options);

	  // Shortcut `elliptic.ec(curve-name)`
	  if (typeof options === 'string') {
	    assert(Object.prototype.hasOwnProperty.call(curves, options),
	      'Unknown curve ' + options);

	    options = curves[options];
	  }

	  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
	  if (options instanceof curves.PresetCurve)
	    options = { curve: options };

	  this.curve = options.curve.curve;
	  this.n = this.curve.n;
	  this.nh = this.n.ushrn(1);
	  this.g = this.curve.g;

	  // Point on curve
	  this.g = options.curve.g;
	  this.g.precompute(options.curve.n.bitLength() + 1);

	  // Hash for function for DRBG
	  this.hash = options.hash || options.curve.hash;
	}
	ec = EC;

	EC.prototype.keyPair = function keyPair(options) {
	  return new KeyPair(this, options);
	};

	EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
	  return KeyPair.fromPrivate(this, priv, enc);
	};

	EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
	  return KeyPair.fromPublic(this, pub, enc);
	};

	EC.prototype.genKeyPair = function genKeyPair(options) {
	  if (!options)
	    options = {};

	  // Instantiate Hmac_DRBG
	  var drbg = new HmacDRBG({
	    hash: this.hash,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	    entropy: options.entropy || rand(this.hash.hmacStrength),
	    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
	    nonce: this.n.toArray(),
	  });

	  var bytes = this.n.byteLength();
	  var ns2 = this.n.sub(new BN(2));
	  for (;;) {
	    var priv = new BN(drbg.generate(bytes));
	    if (priv.cmp(ns2) > 0)
	      continue;

	    priv.iaddn(1);
	    return this.keyFromPrivate(priv);
	  }
	};

	EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
	  var byteLength;
	  if (BN.isBN(msg) || typeof msg === 'number') {
	    msg = new BN(msg, 16);
	    byteLength = msg.byteLength();
	  } else if (typeof msg === 'object') {
	    // BN assumes an array-like input and asserts length
	    byteLength = msg.length;
	    msg = new BN(msg, 16);
	  } else {
	    // BN converts the value to string
	    var str = msg.toString();
	    // HEX encoding
	    byteLength = (str.length + 1) >>> 1;
	    msg = new BN(str, 16);
	  }
	  // Allow overriding
	  if (typeof bitLength !== 'number') {
	    bitLength = byteLength * 8;
	  }
	  var delta = bitLength - this.n.bitLength();
	  if (delta > 0)
	    msg = msg.ushrn(delta);
	  if (!truncOnly && msg.cmp(this.n) >= 0)
	    return msg.sub(this.n);
	  else
	    return msg;
	};

	EC.prototype.sign = function sign(msg, key, enc, options) {
	  if (typeof enc === 'object') {
	    options = enc;
	    enc = null;
	  }
	  if (!options)
	    options = {};

	  if (typeof msg !== 'string' && typeof msg !== 'number' && !BN.isBN(msg)) {
	    assert(typeof msg === 'object' && msg && typeof msg.length === 'number',
	      'Expected message to be an array-like, a hex string, or a BN instance');
	    assert((msg.length >>> 0) === msg.length); // non-negative 32-bit integer
	    for (var i = 0; i < msg.length; i++) assert((msg[i] & 255) === msg[i]);
	  }

	  key = this.keyFromPrivate(key, enc);
	  msg = this._truncateToN(msg, false, options.msgBitLength);

	  // Would fail further checks, but let's make the error message clear
	  assert(!msg.isNeg(), 'Can not sign a negative message');

	  // Zero-extend key to provide enough entropy
	  var bytes = this.n.byteLength();
	  var bkey = key.getPrivate().toArray('be', bytes);

	  // Zero-extend nonce to have the same byte size as N
	  var nonce = msg.toArray('be', bytes);

	  // Recheck nonce to be bijective to msg
	  assert((new BN(nonce)).eq(msg), 'Can not sign message');

	  // Instantiate Hmac_DRBG
	  var drbg = new HmacDRBG({
	    hash: this.hash,
	    entropy: bkey,
	    nonce: nonce,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	  });

	  // Number of bytes to generate
	  var ns1 = this.n.sub(new BN(1));

	  for (var iter = 0; ; iter++) {
	    var k = options.k ?
	      options.k(iter) :
	      new BN(drbg.generate(this.n.byteLength()));
	    k = this._truncateToN(k, true);
	    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
	      continue;

	    var kp = this.g.mul(k);
	    if (kp.isInfinity())
	      continue;

	    var kpX = kp.getX();
	    var r = kpX.umod(this.n);
	    if (r.cmpn(0) === 0)
	      continue;

	    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
	    s = s.umod(this.n);
	    if (s.cmpn(0) === 0)
	      continue;

	    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
	                        (kpX.cmp(r) !== 0 ? 2 : 0);

	    // Use complement of `s`, if it is > `n / 2`
	    if (options.canonical && s.cmp(this.nh) > 0) {
	      s = this.n.sub(s);
	      recoveryParam ^= 1;
	    }

	    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
	  }
	};

	EC.prototype.verify = function verify(msg, signature, key, enc, options) {
	  if (!options)
	    options = {};

	  msg = this._truncateToN(msg, false, options.msgBitLength);
	  key = this.keyFromPublic(key, enc);
	  signature = new Signature(signature, 'hex');

	  // Perform primitive values validation
	  var r = signature.r;
	  var s = signature.s;
	  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
	    return false;
	  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
	    return false;

	  // Validate signature
	  var sinv = s.invm(this.n);
	  var u1 = sinv.mul(msg).umod(this.n);
	  var u2 = sinv.mul(r).umod(this.n);
	  var p;

	  if (!this.curve._maxwellTrick) {
	    p = this.g.mulAdd(u1, key.getPublic(), u2);
	    if (p.isInfinity())
	      return false;

	    return p.getX().umod(this.n).cmp(r) === 0;
	  }

	  // NOTE: Greg Maxwell's trick, inspired by:
	  // https://git.io/vad3K

	  p = this.g.jmulAdd(u1, key.getPublic(), u2);
	  if (p.isInfinity())
	    return false;

	  // Compare `p.x` of Jacobian point with `r`,
	  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
	  // inverse of `p.z^2`
	  return p.eqXToP(r);
	};

	EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
	  assert((3 & j) === j, 'The recovery param is more than two bits');
	  signature = new Signature(signature, enc);

	  var n = this.n;
	  var e = new BN(msg);
	  var r = signature.r;
	  var s = signature.s;

	  // A set LSB signifies that the y-coordinate is odd
	  var isYOdd = j & 1;
	  var isSecondKey = j >> 1;
	  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
	    throw new Error('Unable to find sencond key candinate');

	  // 1.1. Let x = r + jn.
	  if (isSecondKey)
	    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
	  else
	    r = this.curve.pointFromX(r, isYOdd);

	  var rInv = signature.r.invm(n);
	  var s1 = n.sub(e).mul(rInv).umod(n);
	  var s2 = s.mul(rInv).umod(n);

	  // 1.6.1 Compute Q = r^-1 (sR -  eG)
	  //               Q = r^-1 (sR + -eG)
	  return this.g.mulAdd(s1, r, s2);
	};

	EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
	  signature = new Signature(signature, enc);
	  if (signature.recoveryParam !== null)
	    return signature.recoveryParam;

	  for (var i = 0; i < 4; i++) {
	    var Qprime;
	    try {
	      Qprime = this.recoverPubKey(e, signature, i);
	    } catch (e) {
	      continue;
	    }

	    if (Qprime.eq(Q))
	      return i;
	  }
	  throw new Error('Unable to find valid recovery factor');
	};
	return ec;
}

var key;
var hasRequiredKey;

function requireKey () {
	if (hasRequiredKey) return key;
	hasRequiredKey = 1;

	var utils = requireUtils$1();
	var assert = utils.assert;
	var parseBytes = utils.parseBytes;
	var cachedProperty = utils.cachedProperty;

	/**
	* @param {EDDSA} eddsa - instance
	* @param {Object} params - public/private key parameters
	*
	* @param {Array<Byte>} [params.secret] - secret seed bytes
	* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
	* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
	*
	*/
	function KeyPair(eddsa, params) {
	  this.eddsa = eddsa;
	  this._secret = parseBytes(params.secret);
	  if (eddsa.isPoint(params.pub))
	    this._pub = params.pub;
	  else
	    this._pubBytes = parseBytes(params.pub);
	}

	KeyPair.fromPublic = function fromPublic(eddsa, pub) {
	  if (pub instanceof KeyPair)
	    return pub;
	  return new KeyPair(eddsa, { pub: pub });
	};

	KeyPair.fromSecret = function fromSecret(eddsa, secret) {
	  if (secret instanceof KeyPair)
	    return secret;
	  return new KeyPair(eddsa, { secret: secret });
	};

	KeyPair.prototype.secret = function secret() {
	  return this._secret;
	};

	cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
	  return this.eddsa.encodePoint(this.pub());
	});

	cachedProperty(KeyPair, 'pub', function pub() {
	  if (this._pubBytes)
	    return this.eddsa.decodePoint(this._pubBytes);
	  return this.eddsa.g.mul(this.priv());
	});

	cachedProperty(KeyPair, 'privBytes', function privBytes() {
	  var eddsa = this.eddsa;
	  var hash = this.hash();
	  var lastIx = eddsa.encodingLength - 1;

	  var a = hash.slice(0, eddsa.encodingLength);
	  a[0] &= 248;
	  a[lastIx] &= 127;
	  a[lastIx] |= 64;

	  return a;
	});

	cachedProperty(KeyPair, 'priv', function priv() {
	  return this.eddsa.decodeInt(this.privBytes());
	});

	cachedProperty(KeyPair, 'hash', function hash() {
	  return this.eddsa.hash().update(this.secret()).digest();
	});

	cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
	  return this.hash().slice(this.eddsa.encodingLength);
	});

	KeyPair.prototype.sign = function sign(message) {
	  assert(this._secret, 'KeyPair can only verify');
	  return this.eddsa.sign(message, this);
	};

	KeyPair.prototype.verify = function verify(message, sig) {
	  return this.eddsa.verify(message, sig, this);
	};

	KeyPair.prototype.getSecret = function getSecret(enc) {
	  assert(this._secret, 'KeyPair is public only');
	  return utils.encode(this.secret(), enc);
	};

	KeyPair.prototype.getPublic = function getPublic(enc) {
	  return utils.encode(this.pubBytes(), enc);
	};

	key = KeyPair;
	return key;
}

var signature;
var hasRequiredSignature;

function requireSignature () {
	if (hasRequiredSignature) return signature;
	hasRequiredSignature = 1;

	var BN = requireBn$2();
	var utils = requireUtils$1();
	var assert = utils.assert;
	var cachedProperty = utils.cachedProperty;
	var parseBytes = utils.parseBytes;

	/**
	* @param {EDDSA} eddsa - eddsa instance
	* @param {Array<Bytes>|Object} sig -
	* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
	* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
	* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
	* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
	*/
	function Signature(eddsa, sig) {
	  this.eddsa = eddsa;

	  if (typeof sig !== 'object')
	    sig = parseBytes(sig);

	  if (Array.isArray(sig)) {
	    assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
	    sig = {
	      R: sig.slice(0, eddsa.encodingLength),
	      S: sig.slice(eddsa.encodingLength),
	    };
	  }

	  assert(sig.R && sig.S, 'Signature without R or S');

	  if (eddsa.isPoint(sig.R))
	    this._R = sig.R;
	  if (sig.S instanceof BN)
	    this._S = sig.S;

	  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
	  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
	}

	cachedProperty(Signature, 'S', function S() {
	  return this.eddsa.decodeInt(this.Sencoded());
	});

	cachedProperty(Signature, 'R', function R() {
	  return this.eddsa.decodePoint(this.Rencoded());
	});

	cachedProperty(Signature, 'Rencoded', function Rencoded() {
	  return this.eddsa.encodePoint(this.R());
	});

	cachedProperty(Signature, 'Sencoded', function Sencoded() {
	  return this.eddsa.encodeInt(this.S());
	});

	Signature.prototype.toBytes = function toBytes() {
	  return this.Rencoded().concat(this.Sencoded());
	};

	Signature.prototype.toHex = function toHex() {
	  return utils.encode(this.toBytes(), 'hex').toUpperCase();
	};

	signature = Signature;
	return signature;
}

var eddsa;
var hasRequiredEddsa;

function requireEddsa () {
	if (hasRequiredEddsa) return eddsa;
	hasRequiredEddsa = 1;

	var hash = requireHash();
	var curves = requireCurves();
	var utils = requireUtils$1();
	var assert = utils.assert;
	var parseBytes = utils.parseBytes;
	var KeyPair = requireKey();
	var Signature = requireSignature();

	function EDDSA(curve) {
	  assert(curve === 'ed25519', 'only tested with ed25519 so far');

	  if (!(this instanceof EDDSA))
	    return new EDDSA(curve);

	  curve = curves[curve].curve;
	  this.curve = curve;
	  this.g = curve.g;
	  this.g.precompute(curve.n.bitLength() + 1);

	  this.pointClass = curve.point().constructor;
	  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
	  this.hash = hash.sha512;
	}

	eddsa = EDDSA;

	/**
	* @param {Array|String} message - message bytes
	* @param {Array|String|KeyPair} secret - secret bytes or a keypair
	* @returns {Signature} - signature
	*/
	EDDSA.prototype.sign = function sign(message, secret) {
	  message = parseBytes(message);
	  var key = this.keyFromSecret(secret);
	  var r = this.hashInt(key.messagePrefix(), message);
	  var R = this.g.mul(r);
	  var Rencoded = this.encodePoint(R);
	  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
	    .mul(key.priv());
	  var S = r.add(s_).umod(this.curve.n);
	  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
	};

	/**
	* @param {Array} message - message bytes
	* @param {Array|String|Signature} sig - sig bytes
	* @param {Array|String|Point|KeyPair} pub - public key
	* @returns {Boolean} - true if public key matches sig of message
	*/
	EDDSA.prototype.verify = function verify(message, sig, pub) {
	  message = parseBytes(message);
	  sig = this.makeSignature(sig);
	  if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) {
	    return false;
	  }
	  var key = this.keyFromPublic(pub);
	  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
	  var SG = this.g.mul(sig.S());
	  var RplusAh = sig.R().add(key.pub().mul(h));
	  return RplusAh.eq(SG);
	};

	EDDSA.prototype.hashInt = function hashInt() {
	  var hash = this.hash();
	  for (var i = 0; i < arguments.length; i++)
	    hash.update(arguments[i]);
	  return utils.intFromLE(hash.digest()).umod(this.curve.n);
	};

	EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
	  return KeyPair.fromPublic(this, pub);
	};

	EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
	  return KeyPair.fromSecret(this, secret);
	};

	EDDSA.prototype.makeSignature = function makeSignature(sig) {
	  if (sig instanceof Signature)
	    return sig;
	  return new Signature(this, sig);
	};

	/**
	* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
	*
	* EDDSA defines methods for encoding and decoding points and integers. These are
	* helper convenience methods, that pass along to utility functions implied
	* parameters.
	*
	*/
	EDDSA.prototype.encodePoint = function encodePoint(point) {
	  var enc = point.getY().toArray('le', this.encodingLength);
	  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
	  return enc;
	};

	EDDSA.prototype.decodePoint = function decodePoint(bytes) {
	  bytes = utils.parseBytes(bytes);

	  var lastIx = bytes.length - 1;
	  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
	  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

	  var y = utils.intFromLE(normed);
	  return this.curve.pointFromY(y, xIsOdd);
	};

	EDDSA.prototype.encodeInt = function encodeInt(num) {
	  return num.toArray('le', this.encodingLength);
	};

	EDDSA.prototype.decodeInt = function decodeInt(bytes) {
	  return utils.intFromLE(bytes);
	};

	EDDSA.prototype.isPoint = function isPoint(val) {
	  return val instanceof this.pointClass;
	};
	return eddsa;
}

var hasRequiredElliptic;

function requireElliptic () {
	if (hasRequiredElliptic) return elliptic;
	hasRequiredElliptic = 1;
	(function (exports) {

		var elliptic = exports;

		elliptic.version = require$$0.version;
		elliptic.utils = requireUtils$1();
		elliptic.rand = requireBrorand();
		elliptic.curve = requireCurve();
		elliptic.curves = requireCurves();

		// Protocols
		elliptic.ec = requireEc();
		elliptic.eddsa = requireEddsa(); 
	} (elliptic));
	return elliptic;
}

var bn$1 = {exports: {}};

var bn = bn$1.exports;

var hasRequiredBn;

function requireBn () {
	if (hasRequiredBn) return bn$1.exports;
	hasRequiredBn = 1;
	(function (module) {
		(function (module, exports) {

		  // Utils
		  function assert (val, msg) {
		    if (!val) throw new Error(msg || 'Assertion failed');
		  }

		  // Could use `inherits` module, but don't want to move from single file
		  // architecture yet.
		  function inherits (ctor, superCtor) {
		    ctor.super_ = superCtor;
		    var TempCtor = function () {};
		    TempCtor.prototype = superCtor.prototype;
		    ctor.prototype = new TempCtor();
		    ctor.prototype.constructor = ctor;
		  }

		  // BN

		  function BN (number, base, endian) {
		    if (BN.isBN(number)) {
		      return number;
		    }

		    this.negative = 0;
		    this.words = null;
		    this.length = 0;

		    // Reduction context
		    this.red = null;

		    if (number !== null) {
		      if (base === 'le' || base === 'be') {
		        endian = base;
		        base = 10;
		      }

		      this._init(number || 0, base || 10, endian || 'be');
		    }
		  }
		  if (typeof module === 'object') {
		    module.exports = BN;
		  } else {
		    exports.BN = BN;
		  }

		  BN.BN = BN;
		  BN.wordSize = 26;

		  var Buffer;
		  try {
		    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
		      Buffer = window.Buffer;
		    } else {
		      Buffer = require$$0$1.Buffer;
		    }
		  } catch (e) {
		  }

		  BN.isBN = function isBN (num) {
		    if (num instanceof BN) {
		      return true;
		    }

		    return num !== null && typeof num === 'object' &&
		      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
		  };

		  BN.max = function max (left, right) {
		    if (left.cmp(right) > 0) return left;
		    return right;
		  };

		  BN.min = function min (left, right) {
		    if (left.cmp(right) < 0) return left;
		    return right;
		  };

		  BN.prototype._init = function init (number, base, endian) {
		    if (typeof number === 'number') {
		      return this._initNumber(number, base, endian);
		    }

		    if (typeof number === 'object') {
		      return this._initArray(number, base, endian);
		    }

		    if (base === 'hex') {
		      base = 16;
		    }
		    assert(base === (base | 0) && base >= 2 && base <= 36);

		    number = number.toString().replace(/\s+/g, '');
		    var start = 0;
		    if (number[0] === '-') {
		      start++;
		      this.negative = 1;
		    }

		    if (start < number.length) {
		      if (base === 16) {
		        this._parseHex(number, start, endian);
		      } else {
		        this._parseBase(number, base, start);
		        if (endian === 'le') {
		          this._initArray(this.toArray(), base, endian);
		        }
		      }
		    }
		  };

		  BN.prototype._initNumber = function _initNumber (number, base, endian) {
		    if (number < 0) {
		      this.negative = 1;
		      number = -number;
		    }
		    if (number < 0x4000000) {
		      this.words = [number & 0x3ffffff];
		      this.length = 1;
		    } else if (number < 0x10000000000000) {
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff
		      ];
		      this.length = 2;
		    } else {
		      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff,
		        1
		      ];
		      this.length = 3;
		    }

		    if (endian !== 'le') return;

		    // Reverse the bytes
		    this._initArray(this.toArray(), base, endian);
		  };

		  BN.prototype._initArray = function _initArray (number, base, endian) {
		    // Perhaps a Uint8Array
		    assert(typeof number.length === 'number');
		    if (number.length <= 0) {
		      this.words = [0];
		      this.length = 1;
		      return this;
		    }

		    this.length = Math.ceil(number.length / 3);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    var j, w;
		    var off = 0;
		    if (endian === 'be') {
		      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
		        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    } else if (endian === 'le') {
		      for (i = 0, j = 0; i < number.length; i += 3) {
		        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    }
		    return this._strip();
		  };

		  function parseHex4Bits (string, index) {
		    var c = string.charCodeAt(index);
		    // '0' - '9'
		    if (c >= 48 && c <= 57) {
		      return c - 48;
		    // 'A' - 'F'
		    } else if (c >= 65 && c <= 70) {
		      return c - 55;
		    // 'a' - 'f'
		    } else if (c >= 97 && c <= 102) {
		      return c - 87;
		    } else {
		      assert(false, 'Invalid character in ' + string);
		    }
		  }

		  function parseHexByte (string, lowerBound, index) {
		    var r = parseHex4Bits(string, index);
		    if (index - 1 >= lowerBound) {
		      r |= parseHex4Bits(string, index - 1) << 4;
		    }
		    return r;
		  }

		  BN.prototype._parseHex = function _parseHex (number, start, endian) {
		    // Create possibly bigger array to ensure that it fits the number
		    this.length = Math.ceil((number.length - start) / 6);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    // 24-bits chunks
		    var off = 0;
		    var j = 0;

		    var w;
		    if (endian === 'be') {
		      for (i = number.length - 1; i >= start; i -= 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    } else {
		      var parseLength = number.length - start;
		      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    }

		    this._strip();
		  };

		  function parseBase (str, start, end, mul) {
		    var r = 0;
		    var b = 0;
		    var len = Math.min(str.length, end);
		    for (var i = start; i < len; i++) {
		      var c = str.charCodeAt(i) - 48;

		      r *= mul;

		      // 'a'
		      if (c >= 49) {
		        b = c - 49 + 0xa;

		      // 'A'
		      } else if (c >= 17) {
		        b = c - 17 + 0xa;

		      // '0' - '9'
		      } else {
		        b = c;
		      }
		      assert(c >= 0 && b < mul, 'Invalid character');
		      r += b;
		    }
		    return r;
		  }

		  BN.prototype._parseBase = function _parseBase (number, base, start) {
		    // Initialize as zero
		    this.words = [0];
		    this.length = 1;

		    // Find length of limb in base
		    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
		      limbLen++;
		    }
		    limbLen--;
		    limbPow = (limbPow / base) | 0;

		    var total = number.length - start;
		    var mod = total % limbLen;
		    var end = Math.min(total, total - mod) + start;

		    var word = 0;
		    for (var i = start; i < end; i += limbLen) {
		      word = parseBase(number, i, i + limbLen, base);

		      this.imuln(limbPow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    if (mod !== 0) {
		      var pow = 1;
		      word = parseBase(number, i, number.length, base);

		      for (i = 0; i < mod; i++) {
		        pow *= base;
		      }

		      this.imuln(pow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    this._strip();
		  };

		  BN.prototype.copy = function copy (dest) {
		    dest.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      dest.words[i] = this.words[i];
		    }
		    dest.length = this.length;
		    dest.negative = this.negative;
		    dest.red = this.red;
		  };

		  function move (dest, src) {
		    dest.words = src.words;
		    dest.length = src.length;
		    dest.negative = src.negative;
		    dest.red = src.red;
		  }

		  BN.prototype._move = function _move (dest) {
		    move(dest, this);
		  };

		  BN.prototype.clone = function clone () {
		    var r = new BN(null);
		    this.copy(r);
		    return r;
		  };

		  BN.prototype._expand = function _expand (size) {
		    while (this.length < size) {
		      this.words[this.length++] = 0;
		    }
		    return this;
		  };

		  // Remove leading `0` from `this`
		  BN.prototype._strip = function strip () {
		    while (this.length > 1 && this.words[this.length - 1] === 0) {
		      this.length--;
		    }
		    return this._normSign();
		  };

		  BN.prototype._normSign = function _normSign () {
		    // -0 = 0
		    if (this.length === 1 && this.words[0] === 0) {
		      this.negative = 0;
		    }
		    return this;
		  };

		  // Check Symbol.for because not everywhere where Symbol defined
		  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
		  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
		    try {
		      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
		    } catch (e) {
		      BN.prototype.inspect = inspect;
		    }
		  } else {
		    BN.prototype.inspect = inspect;
		  }

		  function inspect () {
		    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
		  }

		  /*

		  var zeros = [];
		  var groupSizes = [];
		  var groupBases = [];

		  var s = '';
		  var i = -1;
		  while (++i < BN.wordSize) {
		    zeros[i] = s;
		    s += '0';
		  }
		  groupSizes[0] = 0;
		  groupSizes[1] = 0;
		  groupBases[0] = 0;
		  groupBases[1] = 0;
		  var base = 2 - 1;
		  while (++base < 36 + 1) {
		    var groupSize = 0;
		    var groupBase = 1;
		    while (groupBase < (1 << BN.wordSize) / base) {
		      groupBase *= base;
		      groupSize += 1;
		    }
		    groupSizes[base] = groupSize;
		    groupBases[base] = groupBase;
		  }

		  */

		  var zeros = [
		    '',
		    '0',
		    '00',
		    '000',
		    '0000',
		    '00000',
		    '000000',
		    '0000000',
		    '00000000',
		    '000000000',
		    '0000000000',
		    '00000000000',
		    '000000000000',
		    '0000000000000',
		    '00000000000000',
		    '000000000000000',
		    '0000000000000000',
		    '00000000000000000',
		    '000000000000000000',
		    '0000000000000000000',
		    '00000000000000000000',
		    '000000000000000000000',
		    '0000000000000000000000',
		    '00000000000000000000000',
		    '000000000000000000000000',
		    '0000000000000000000000000'
		  ];

		  var groupSizes = [
		    0, 0,
		    25, 16, 12, 11, 10, 9, 8,
		    8, 7, 7, 7, 7, 6, 6,
		    6, 6, 6, 6, 6, 5, 5,
		    5, 5, 5, 5, 5, 5, 5,
		    5, 5, 5, 5, 5, 5, 5
		  ];

		  var groupBases = [
		    0, 0,
		    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
		    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
		    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
		    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
		    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
		  ];

		  BN.prototype.toString = function toString (base, padding) {
		    base = base || 10;
		    padding = padding | 0 || 1;

		    var out;
		    if (base === 16 || base === 'hex') {
		      out = '';
		      var off = 0;
		      var carry = 0;
		      for (var i = 0; i < this.length; i++) {
		        var w = this.words[i];
		        var word = (((w << off) | carry) & 0xffffff).toString(16);
		        carry = (w >>> (24 - off)) & 0xffffff;
		        off += 2;
		        if (off >= 26) {
		          off -= 26;
		          i--;
		        }
		        if (carry !== 0 || i !== this.length - 1) {
		          out = zeros[6 - word.length] + word + out;
		        } else {
		          out = word + out;
		        }
		      }
		      if (carry !== 0) {
		        out = carry.toString(16) + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    if (base === (base | 0) && base >= 2 && base <= 36) {
		      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
		      var groupSize = groupSizes[base];
		      // var groupBase = Math.pow(base, groupSize);
		      var groupBase = groupBases[base];
		      out = '';
		      var c = this.clone();
		      c.negative = 0;
		      while (!c.isZero()) {
		        var r = c.modrn(groupBase).toString(base);
		        c = c.idivn(groupBase);

		        if (!c.isZero()) {
		          out = zeros[groupSize - r.length] + r + out;
		        } else {
		          out = r + out;
		        }
		      }
		      if (this.isZero()) {
		        out = '0' + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    assert(false, 'Base should be between 2 and 36');
		  };

		  BN.prototype.toNumber = function toNumber () {
		    var ret = this.words[0];
		    if (this.length === 2) {
		      ret += this.words[1] * 0x4000000;
		    } else if (this.length === 3 && this.words[2] === 0x01) {
		      // NOTE: at this stage it is known that the top bit is set
		      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
		    } else if (this.length > 2) {
		      assert(false, 'Number can only safely store up to 53 bits');
		    }
		    return (this.negative !== 0) ? -ret : ret;
		  };

		  BN.prototype.toJSON = function toJSON () {
		    return this.toString(16, 2);
		  };

		  if (Buffer) {
		    BN.prototype.toBuffer = function toBuffer (endian, length) {
		      return this.toArrayLike(Buffer, endian, length);
		    };
		  }

		  BN.prototype.toArray = function toArray (endian, length) {
		    return this.toArrayLike(Array, endian, length);
		  };

		  var allocate = function allocate (ArrayType, size) {
		    if (ArrayType.allocUnsafe) {
		      return ArrayType.allocUnsafe(size);
		    }
		    return new ArrayType(size);
		  };

		  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
		    this._strip();

		    var byteLength = this.byteLength();
		    var reqLength = length || Math.max(1, byteLength);
		    assert(byteLength <= reqLength, 'byte array longer than desired length');
		    assert(reqLength > 0, 'Requested array length <= 0');

		    var res = allocate(ArrayType, reqLength);
		    var postfix = endian === 'le' ? 'LE' : 'BE';
		    this['_toArrayLike' + postfix](res, byteLength);
		    return res;
		  };

		  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
		    var position = 0;
		    var carry = 0;

		    for (var i = 0, shift = 0; i < this.length; i++) {
		      var word = (this.words[i] << shift) | carry;

		      res[position++] = word & 0xff;
		      if (position < res.length) {
		        res[position++] = (word >> 8) & 0xff;
		      }
		      if (position < res.length) {
		        res[position++] = (word >> 16) & 0xff;
		      }

		      if (shift === 6) {
		        if (position < res.length) {
		          res[position++] = (word >> 24) & 0xff;
		        }
		        carry = 0;
		        shift = 0;
		      } else {
		        carry = word >>> 24;
		        shift += 2;
		      }
		    }

		    if (position < res.length) {
		      res[position++] = carry;

		      while (position < res.length) {
		        res[position++] = 0;
		      }
		    }
		  };

		  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
		    var position = res.length - 1;
		    var carry = 0;

		    for (var i = 0, shift = 0; i < this.length; i++) {
		      var word = (this.words[i] << shift) | carry;

		      res[position--] = word & 0xff;
		      if (position >= 0) {
		        res[position--] = (word >> 8) & 0xff;
		      }
		      if (position >= 0) {
		        res[position--] = (word >> 16) & 0xff;
		      }

		      if (shift === 6) {
		        if (position >= 0) {
		          res[position--] = (word >> 24) & 0xff;
		        }
		        carry = 0;
		        shift = 0;
		      } else {
		        carry = word >>> 24;
		        shift += 2;
		      }
		    }

		    if (position >= 0) {
		      res[position--] = carry;

		      while (position >= 0) {
		        res[position--] = 0;
		      }
		    }
		  };

		  if (Math.clz32) {
		    BN.prototype._countBits = function _countBits (w) {
		      return 32 - Math.clz32(w);
		    };
		  } else {
		    BN.prototype._countBits = function _countBits (w) {
		      var t = w;
		      var r = 0;
		      if (t >= 0x1000) {
		        r += 13;
		        t >>>= 13;
		      }
		      if (t >= 0x40) {
		        r += 7;
		        t >>>= 7;
		      }
		      if (t >= 0x8) {
		        r += 4;
		        t >>>= 4;
		      }
		      if (t >= 0x02) {
		        r += 2;
		        t >>>= 2;
		      }
		      return r + t;
		    };
		  }

		  BN.prototype._zeroBits = function _zeroBits (w) {
		    // Short-cut
		    if (w === 0) return 26;

		    var t = w;
		    var r = 0;
		    if ((t & 0x1fff) === 0) {
		      r += 13;
		      t >>>= 13;
		    }
		    if ((t & 0x7f) === 0) {
		      r += 7;
		      t >>>= 7;
		    }
		    if ((t & 0xf) === 0) {
		      r += 4;
		      t >>>= 4;
		    }
		    if ((t & 0x3) === 0) {
		      r += 2;
		      t >>>= 2;
		    }
		    if ((t & 0x1) === 0) {
		      r++;
		    }
		    return r;
		  };

		  // Return number of used bits in a BN
		  BN.prototype.bitLength = function bitLength () {
		    var w = this.words[this.length - 1];
		    var hi = this._countBits(w);
		    return (this.length - 1) * 26 + hi;
		  };

		  function toBitArray (num) {
		    var w = new Array(num.bitLength());

		    for (var bit = 0; bit < w.length; bit++) {
		      var off = (bit / 26) | 0;
		      var wbit = bit % 26;

		      w[bit] = (num.words[off] >>> wbit) & 0x01;
		    }

		    return w;
		  }

		  // Number of trailing zero bits
		  BN.prototype.zeroBits = function zeroBits () {
		    if (this.isZero()) return 0;

		    var r = 0;
		    for (var i = 0; i < this.length; i++) {
		      var b = this._zeroBits(this.words[i]);
		      r += b;
		      if (b !== 26) break;
		    }
		    return r;
		  };

		  BN.prototype.byteLength = function byteLength () {
		    return Math.ceil(this.bitLength() / 8);
		  };

		  BN.prototype.toTwos = function toTwos (width) {
		    if (this.negative !== 0) {
		      return this.abs().inotn(width).iaddn(1);
		    }
		    return this.clone();
		  };

		  BN.prototype.fromTwos = function fromTwos (width) {
		    if (this.testn(width - 1)) {
		      return this.notn(width).iaddn(1).ineg();
		    }
		    return this.clone();
		  };

		  BN.prototype.isNeg = function isNeg () {
		    return this.negative !== 0;
		  };

		  // Return negative clone of `this`
		  BN.prototype.neg = function neg () {
		    return this.clone().ineg();
		  };

		  BN.prototype.ineg = function ineg () {
		    if (!this.isZero()) {
		      this.negative ^= 1;
		    }

		    return this;
		  };

		  // Or `num` with `this` in-place
		  BN.prototype.iuor = function iuor (num) {
		    while (this.length < num.length) {
		      this.words[this.length++] = 0;
		    }

		    for (var i = 0; i < num.length; i++) {
		      this.words[i] = this.words[i] | num.words[i];
		    }

		    return this._strip();
		  };

		  BN.prototype.ior = function ior (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuor(num);
		  };

		  // Or `num` with `this`
		  BN.prototype.or = function or (num) {
		    if (this.length > num.length) return this.clone().ior(num);
		    return num.clone().ior(this);
		  };

		  BN.prototype.uor = function uor (num) {
		    if (this.length > num.length) return this.clone().iuor(num);
		    return num.clone().iuor(this);
		  };

		  // And `num` with `this` in-place
		  BN.prototype.iuand = function iuand (num) {
		    // b = min-length(num, this)
		    var b;
		    if (this.length > num.length) {
		      b = num;
		    } else {
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = this.words[i] & num.words[i];
		    }

		    this.length = b.length;

		    return this._strip();
		  };

		  BN.prototype.iand = function iand (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuand(num);
		  };

		  // And `num` with `this`
		  BN.prototype.and = function and (num) {
		    if (this.length > num.length) return this.clone().iand(num);
		    return num.clone().iand(this);
		  };

		  BN.prototype.uand = function uand (num) {
		    if (this.length > num.length) return this.clone().iuand(num);
		    return num.clone().iuand(this);
		  };

		  // Xor `num` with `this` in-place
		  BN.prototype.iuxor = function iuxor (num) {
		    // a.length > b.length
		    var a;
		    var b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = a.words[i] ^ b.words[i];
		    }

		    if (this !== a) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = a.length;

		    return this._strip();
		  };

		  BN.prototype.ixor = function ixor (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuxor(num);
		  };

		  // Xor `num` with `this`
		  BN.prototype.xor = function xor (num) {
		    if (this.length > num.length) return this.clone().ixor(num);
		    return num.clone().ixor(this);
		  };

		  BN.prototype.uxor = function uxor (num) {
		    if (this.length > num.length) return this.clone().iuxor(num);
		    return num.clone().iuxor(this);
		  };

		  // Not ``this`` with ``width`` bitwidth
		  BN.prototype.inotn = function inotn (width) {
		    assert(typeof width === 'number' && width >= 0);

		    var bytesNeeded = Math.ceil(width / 26) | 0;
		    var bitsLeft = width % 26;

		    // Extend the buffer with leading zeroes
		    this._expand(bytesNeeded);

		    if (bitsLeft > 0) {
		      bytesNeeded--;
		    }

		    // Handle complete words
		    for (var i = 0; i < bytesNeeded; i++) {
		      this.words[i] = ~this.words[i] & 0x3ffffff;
		    }

		    // Handle the residue
		    if (bitsLeft > 0) {
		      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
		    }

		    // And remove leading zeroes
		    return this._strip();
		  };

		  BN.prototype.notn = function notn (width) {
		    return this.clone().inotn(width);
		  };

		  // Set `bit` of `this`
		  BN.prototype.setn = function setn (bit, val) {
		    assert(typeof bit === 'number' && bit >= 0);

		    var off = (bit / 26) | 0;
		    var wbit = bit % 26;

		    this._expand(off + 1);

		    if (val) {
		      this.words[off] = this.words[off] | (1 << wbit);
		    } else {
		      this.words[off] = this.words[off] & ~(1 << wbit);
		    }

		    return this._strip();
		  };

		  // Add `num` to `this` in-place
		  BN.prototype.iadd = function iadd (num) {
		    var r;

		    // negative + positive
		    if (this.negative !== 0 && num.negative === 0) {
		      this.negative = 0;
		      r = this.isub(num);
		      this.negative ^= 1;
		      return this._normSign();

		    // positive + negative
		    } else if (this.negative === 0 && num.negative !== 0) {
		      num.negative = 0;
		      r = this.isub(num);
		      num.negative = 1;
		      return r._normSign();
		    }

		    // a.length > b.length
		    var a, b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }

		    this.length = a.length;
		    if (carry !== 0) {
		      this.words[this.length] = carry;
		      this.length++;
		    // Copy the rest of the words
		    } else if (a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    return this;
		  };

		  // Add `num` to `this`
		  BN.prototype.add = function add (num) {
		    var res;
		    if (num.negative !== 0 && this.negative === 0) {
		      num.negative = 0;
		      res = this.sub(num);
		      num.negative ^= 1;
		      return res;
		    } else if (num.negative === 0 && this.negative !== 0) {
		      this.negative = 0;
		      res = num.sub(this);
		      this.negative = 1;
		      return res;
		    }

		    if (this.length > num.length) return this.clone().iadd(num);

		    return num.clone().iadd(this);
		  };

		  // Subtract `num` from `this` in-place
		  BN.prototype.isub = function isub (num) {
		    // this - (-num) = this + num
		    if (num.negative !== 0) {
		      num.negative = 0;
		      var r = this.iadd(num);
		      num.negative = 1;
		      return r._normSign();

		    // -this - num = -(this + num)
		    } else if (this.negative !== 0) {
		      this.negative = 0;
		      this.iadd(num);
		      this.negative = 1;
		      return this._normSign();
		    }

		    // At this point both numbers are positive
		    var cmp = this.cmp(num);

		    // Optimization - zeroify
		    if (cmp === 0) {
		      this.negative = 0;
		      this.length = 1;
		      this.words[0] = 0;
		      return this;
		    }

		    // a > b
		    var a, b;
		    if (cmp > 0) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }

		    // Copy rest of the words
		    if (carry === 0 && i < a.length && a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = Math.max(this.length, i);

		    if (a !== this) {
		      this.negative = 1;
		    }

		    return this._strip();
		  };

		  // Subtract `num` from `this`
		  BN.prototype.sub = function sub (num) {
		    return this.clone().isub(num);
		  };

		  function smallMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    var len = (self.length + num.length) | 0;
		    out.length = len;
		    len = (len - 1) | 0;

		    // Peel one iteration (compiler can't do it, because of code complexity)
		    var a = self.words[0] | 0;
		    var b = num.words[0] | 0;
		    var r = a * b;

		    var lo = r & 0x3ffffff;
		    var carry = (r / 0x4000000) | 0;
		    out.words[0] = lo;

		    for (var k = 1; k < len; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = carry >>> 26;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = (k - j) | 0;
		        a = self.words[i] | 0;
		        b = num.words[j] | 0;
		        r = a * b + rword;
		        ncarry += (r / 0x4000000) | 0;
		        rword = r & 0x3ffffff;
		      }
		      out.words[k] = rword | 0;
		      carry = ncarry | 0;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry | 0;
		    } else {
		      out.length--;
		    }

		    return out._strip();
		  }

		  // TODO(indutny): it may be reasonable to omit it for users who don't need
		  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
		  // multiplication (like elliptic secp256k1).
		  var comb10MulTo = function comb10MulTo (self, num, out) {
		    var a = self.words;
		    var b = num.words;
		    var o = out.words;
		    var c = 0;
		    var lo;
		    var mid;
		    var hi;
		    var a0 = a[0] | 0;
		    var al0 = a0 & 0x1fff;
		    var ah0 = a0 >>> 13;
		    var a1 = a[1] | 0;
		    var al1 = a1 & 0x1fff;
		    var ah1 = a1 >>> 13;
		    var a2 = a[2] | 0;
		    var al2 = a2 & 0x1fff;
		    var ah2 = a2 >>> 13;
		    var a3 = a[3] | 0;
		    var al3 = a3 & 0x1fff;
		    var ah3 = a3 >>> 13;
		    var a4 = a[4] | 0;
		    var al4 = a4 & 0x1fff;
		    var ah4 = a4 >>> 13;
		    var a5 = a[5] | 0;
		    var al5 = a5 & 0x1fff;
		    var ah5 = a5 >>> 13;
		    var a6 = a[6] | 0;
		    var al6 = a6 & 0x1fff;
		    var ah6 = a6 >>> 13;
		    var a7 = a[7] | 0;
		    var al7 = a7 & 0x1fff;
		    var ah7 = a7 >>> 13;
		    var a8 = a[8] | 0;
		    var al8 = a8 & 0x1fff;
		    var ah8 = a8 >>> 13;
		    var a9 = a[9] | 0;
		    var al9 = a9 & 0x1fff;
		    var ah9 = a9 >>> 13;
		    var b0 = b[0] | 0;
		    var bl0 = b0 & 0x1fff;
		    var bh0 = b0 >>> 13;
		    var b1 = b[1] | 0;
		    var bl1 = b1 & 0x1fff;
		    var bh1 = b1 >>> 13;
		    var b2 = b[2] | 0;
		    var bl2 = b2 & 0x1fff;
		    var bh2 = b2 >>> 13;
		    var b3 = b[3] | 0;
		    var bl3 = b3 & 0x1fff;
		    var bh3 = b3 >>> 13;
		    var b4 = b[4] | 0;
		    var bl4 = b4 & 0x1fff;
		    var bh4 = b4 >>> 13;
		    var b5 = b[5] | 0;
		    var bl5 = b5 & 0x1fff;
		    var bh5 = b5 >>> 13;
		    var b6 = b[6] | 0;
		    var bl6 = b6 & 0x1fff;
		    var bh6 = b6 >>> 13;
		    var b7 = b[7] | 0;
		    var bl7 = b7 & 0x1fff;
		    var bh7 = b7 >>> 13;
		    var b8 = b[8] | 0;
		    var bl8 = b8 & 0x1fff;
		    var bh8 = b8 >>> 13;
		    var b9 = b[9] | 0;
		    var bl9 = b9 & 0x1fff;
		    var bh9 = b9 >>> 13;

		    out.negative = self.negative ^ num.negative;
		    out.length = 19;
		    /* k = 0 */
		    lo = Math.imul(al0, bl0);
		    mid = Math.imul(al0, bh0);
		    mid = (mid + Math.imul(ah0, bl0)) | 0;
		    hi = Math.imul(ah0, bh0);
		    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
		    w0 &= 0x3ffffff;
		    /* k = 1 */
		    lo = Math.imul(al1, bl0);
		    mid = Math.imul(al1, bh0);
		    mid = (mid + Math.imul(ah1, bl0)) | 0;
		    hi = Math.imul(ah1, bh0);
		    lo = (lo + Math.imul(al0, bl1)) | 0;
		    mid = (mid + Math.imul(al0, bh1)) | 0;
		    mid = (mid + Math.imul(ah0, bl1)) | 0;
		    hi = (hi + Math.imul(ah0, bh1)) | 0;
		    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
		    w1 &= 0x3ffffff;
		    /* k = 2 */
		    lo = Math.imul(al2, bl0);
		    mid = Math.imul(al2, bh0);
		    mid = (mid + Math.imul(ah2, bl0)) | 0;
		    hi = Math.imul(ah2, bh0);
		    lo = (lo + Math.imul(al1, bl1)) | 0;
		    mid = (mid + Math.imul(al1, bh1)) | 0;
		    mid = (mid + Math.imul(ah1, bl1)) | 0;
		    hi = (hi + Math.imul(ah1, bh1)) | 0;
		    lo = (lo + Math.imul(al0, bl2)) | 0;
		    mid = (mid + Math.imul(al0, bh2)) | 0;
		    mid = (mid + Math.imul(ah0, bl2)) | 0;
		    hi = (hi + Math.imul(ah0, bh2)) | 0;
		    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
		    w2 &= 0x3ffffff;
		    /* k = 3 */
		    lo = Math.imul(al3, bl0);
		    mid = Math.imul(al3, bh0);
		    mid = (mid + Math.imul(ah3, bl0)) | 0;
		    hi = Math.imul(ah3, bh0);
		    lo = (lo + Math.imul(al2, bl1)) | 0;
		    mid = (mid + Math.imul(al2, bh1)) | 0;
		    mid = (mid + Math.imul(ah2, bl1)) | 0;
		    hi = (hi + Math.imul(ah2, bh1)) | 0;
		    lo = (lo + Math.imul(al1, bl2)) | 0;
		    mid = (mid + Math.imul(al1, bh2)) | 0;
		    mid = (mid + Math.imul(ah1, bl2)) | 0;
		    hi = (hi + Math.imul(ah1, bh2)) | 0;
		    lo = (lo + Math.imul(al0, bl3)) | 0;
		    mid = (mid + Math.imul(al0, bh3)) | 0;
		    mid = (mid + Math.imul(ah0, bl3)) | 0;
		    hi = (hi + Math.imul(ah0, bh3)) | 0;
		    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
		    w3 &= 0x3ffffff;
		    /* k = 4 */
		    lo = Math.imul(al4, bl0);
		    mid = Math.imul(al4, bh0);
		    mid = (mid + Math.imul(ah4, bl0)) | 0;
		    hi = Math.imul(ah4, bh0);
		    lo = (lo + Math.imul(al3, bl1)) | 0;
		    mid = (mid + Math.imul(al3, bh1)) | 0;
		    mid = (mid + Math.imul(ah3, bl1)) | 0;
		    hi = (hi + Math.imul(ah3, bh1)) | 0;
		    lo = (lo + Math.imul(al2, bl2)) | 0;
		    mid = (mid + Math.imul(al2, bh2)) | 0;
		    mid = (mid + Math.imul(ah2, bl2)) | 0;
		    hi = (hi + Math.imul(ah2, bh2)) | 0;
		    lo = (lo + Math.imul(al1, bl3)) | 0;
		    mid = (mid + Math.imul(al1, bh3)) | 0;
		    mid = (mid + Math.imul(ah1, bl3)) | 0;
		    hi = (hi + Math.imul(ah1, bh3)) | 0;
		    lo = (lo + Math.imul(al0, bl4)) | 0;
		    mid = (mid + Math.imul(al0, bh4)) | 0;
		    mid = (mid + Math.imul(ah0, bl4)) | 0;
		    hi = (hi + Math.imul(ah0, bh4)) | 0;
		    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
		    w4 &= 0x3ffffff;
		    /* k = 5 */
		    lo = Math.imul(al5, bl0);
		    mid = Math.imul(al5, bh0);
		    mid = (mid + Math.imul(ah5, bl0)) | 0;
		    hi = Math.imul(ah5, bh0);
		    lo = (lo + Math.imul(al4, bl1)) | 0;
		    mid = (mid + Math.imul(al4, bh1)) | 0;
		    mid = (mid + Math.imul(ah4, bl1)) | 0;
		    hi = (hi + Math.imul(ah4, bh1)) | 0;
		    lo = (lo + Math.imul(al3, bl2)) | 0;
		    mid = (mid + Math.imul(al3, bh2)) | 0;
		    mid = (mid + Math.imul(ah3, bl2)) | 0;
		    hi = (hi + Math.imul(ah3, bh2)) | 0;
		    lo = (lo + Math.imul(al2, bl3)) | 0;
		    mid = (mid + Math.imul(al2, bh3)) | 0;
		    mid = (mid + Math.imul(ah2, bl3)) | 0;
		    hi = (hi + Math.imul(ah2, bh3)) | 0;
		    lo = (lo + Math.imul(al1, bl4)) | 0;
		    mid = (mid + Math.imul(al1, bh4)) | 0;
		    mid = (mid + Math.imul(ah1, bl4)) | 0;
		    hi = (hi + Math.imul(ah1, bh4)) | 0;
		    lo = (lo + Math.imul(al0, bl5)) | 0;
		    mid = (mid + Math.imul(al0, bh5)) | 0;
		    mid = (mid + Math.imul(ah0, bl5)) | 0;
		    hi = (hi + Math.imul(ah0, bh5)) | 0;
		    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
		    w5 &= 0x3ffffff;
		    /* k = 6 */
		    lo = Math.imul(al6, bl0);
		    mid = Math.imul(al6, bh0);
		    mid = (mid + Math.imul(ah6, bl0)) | 0;
		    hi = Math.imul(ah6, bh0);
		    lo = (lo + Math.imul(al5, bl1)) | 0;
		    mid = (mid + Math.imul(al5, bh1)) | 0;
		    mid = (mid + Math.imul(ah5, bl1)) | 0;
		    hi = (hi + Math.imul(ah5, bh1)) | 0;
		    lo = (lo + Math.imul(al4, bl2)) | 0;
		    mid = (mid + Math.imul(al4, bh2)) | 0;
		    mid = (mid + Math.imul(ah4, bl2)) | 0;
		    hi = (hi + Math.imul(ah4, bh2)) | 0;
		    lo = (lo + Math.imul(al3, bl3)) | 0;
		    mid = (mid + Math.imul(al3, bh3)) | 0;
		    mid = (mid + Math.imul(ah3, bl3)) | 0;
		    hi = (hi + Math.imul(ah3, bh3)) | 0;
		    lo = (lo + Math.imul(al2, bl4)) | 0;
		    mid = (mid + Math.imul(al2, bh4)) | 0;
		    mid = (mid + Math.imul(ah2, bl4)) | 0;
		    hi = (hi + Math.imul(ah2, bh4)) | 0;
		    lo = (lo + Math.imul(al1, bl5)) | 0;
		    mid = (mid + Math.imul(al1, bh5)) | 0;
		    mid = (mid + Math.imul(ah1, bl5)) | 0;
		    hi = (hi + Math.imul(ah1, bh5)) | 0;
		    lo = (lo + Math.imul(al0, bl6)) | 0;
		    mid = (mid + Math.imul(al0, bh6)) | 0;
		    mid = (mid + Math.imul(ah0, bl6)) | 0;
		    hi = (hi + Math.imul(ah0, bh6)) | 0;
		    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
		    w6 &= 0x3ffffff;
		    /* k = 7 */
		    lo = Math.imul(al7, bl0);
		    mid = Math.imul(al7, bh0);
		    mid = (mid + Math.imul(ah7, bl0)) | 0;
		    hi = Math.imul(ah7, bh0);
		    lo = (lo + Math.imul(al6, bl1)) | 0;
		    mid = (mid + Math.imul(al6, bh1)) | 0;
		    mid = (mid + Math.imul(ah6, bl1)) | 0;
		    hi = (hi + Math.imul(ah6, bh1)) | 0;
		    lo = (lo + Math.imul(al5, bl2)) | 0;
		    mid = (mid + Math.imul(al5, bh2)) | 0;
		    mid = (mid + Math.imul(ah5, bl2)) | 0;
		    hi = (hi + Math.imul(ah5, bh2)) | 0;
		    lo = (lo + Math.imul(al4, bl3)) | 0;
		    mid = (mid + Math.imul(al4, bh3)) | 0;
		    mid = (mid + Math.imul(ah4, bl3)) | 0;
		    hi = (hi + Math.imul(ah4, bh3)) | 0;
		    lo = (lo + Math.imul(al3, bl4)) | 0;
		    mid = (mid + Math.imul(al3, bh4)) | 0;
		    mid = (mid + Math.imul(ah3, bl4)) | 0;
		    hi = (hi + Math.imul(ah3, bh4)) | 0;
		    lo = (lo + Math.imul(al2, bl5)) | 0;
		    mid = (mid + Math.imul(al2, bh5)) | 0;
		    mid = (mid + Math.imul(ah2, bl5)) | 0;
		    hi = (hi + Math.imul(ah2, bh5)) | 0;
		    lo = (lo + Math.imul(al1, bl6)) | 0;
		    mid = (mid + Math.imul(al1, bh6)) | 0;
		    mid = (mid + Math.imul(ah1, bl6)) | 0;
		    hi = (hi + Math.imul(ah1, bh6)) | 0;
		    lo = (lo + Math.imul(al0, bl7)) | 0;
		    mid = (mid + Math.imul(al0, bh7)) | 0;
		    mid = (mid + Math.imul(ah0, bl7)) | 0;
		    hi = (hi + Math.imul(ah0, bh7)) | 0;
		    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
		    w7 &= 0x3ffffff;
		    /* k = 8 */
		    lo = Math.imul(al8, bl0);
		    mid = Math.imul(al8, bh0);
		    mid = (mid + Math.imul(ah8, bl0)) | 0;
		    hi = Math.imul(ah8, bh0);
		    lo = (lo + Math.imul(al7, bl1)) | 0;
		    mid = (mid + Math.imul(al7, bh1)) | 0;
		    mid = (mid + Math.imul(ah7, bl1)) | 0;
		    hi = (hi + Math.imul(ah7, bh1)) | 0;
		    lo = (lo + Math.imul(al6, bl2)) | 0;
		    mid = (mid + Math.imul(al6, bh2)) | 0;
		    mid = (mid + Math.imul(ah6, bl2)) | 0;
		    hi = (hi + Math.imul(ah6, bh2)) | 0;
		    lo = (lo + Math.imul(al5, bl3)) | 0;
		    mid = (mid + Math.imul(al5, bh3)) | 0;
		    mid = (mid + Math.imul(ah5, bl3)) | 0;
		    hi = (hi + Math.imul(ah5, bh3)) | 0;
		    lo = (lo + Math.imul(al4, bl4)) | 0;
		    mid = (mid + Math.imul(al4, bh4)) | 0;
		    mid = (mid + Math.imul(ah4, bl4)) | 0;
		    hi = (hi + Math.imul(ah4, bh4)) | 0;
		    lo = (lo + Math.imul(al3, bl5)) | 0;
		    mid = (mid + Math.imul(al3, bh5)) | 0;
		    mid = (mid + Math.imul(ah3, bl5)) | 0;
		    hi = (hi + Math.imul(ah3, bh5)) | 0;
		    lo = (lo + Math.imul(al2, bl6)) | 0;
		    mid = (mid + Math.imul(al2, bh6)) | 0;
		    mid = (mid + Math.imul(ah2, bl6)) | 0;
		    hi = (hi + Math.imul(ah2, bh6)) | 0;
		    lo = (lo + Math.imul(al1, bl7)) | 0;
		    mid = (mid + Math.imul(al1, bh7)) | 0;
		    mid = (mid + Math.imul(ah1, bl7)) | 0;
		    hi = (hi + Math.imul(ah1, bh7)) | 0;
		    lo = (lo + Math.imul(al0, bl8)) | 0;
		    mid = (mid + Math.imul(al0, bh8)) | 0;
		    mid = (mid + Math.imul(ah0, bl8)) | 0;
		    hi = (hi + Math.imul(ah0, bh8)) | 0;
		    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
		    w8 &= 0x3ffffff;
		    /* k = 9 */
		    lo = Math.imul(al9, bl0);
		    mid = Math.imul(al9, bh0);
		    mid = (mid + Math.imul(ah9, bl0)) | 0;
		    hi = Math.imul(ah9, bh0);
		    lo = (lo + Math.imul(al8, bl1)) | 0;
		    mid = (mid + Math.imul(al8, bh1)) | 0;
		    mid = (mid + Math.imul(ah8, bl1)) | 0;
		    hi = (hi + Math.imul(ah8, bh1)) | 0;
		    lo = (lo + Math.imul(al7, bl2)) | 0;
		    mid = (mid + Math.imul(al7, bh2)) | 0;
		    mid = (mid + Math.imul(ah7, bl2)) | 0;
		    hi = (hi + Math.imul(ah7, bh2)) | 0;
		    lo = (lo + Math.imul(al6, bl3)) | 0;
		    mid = (mid + Math.imul(al6, bh3)) | 0;
		    mid = (mid + Math.imul(ah6, bl3)) | 0;
		    hi = (hi + Math.imul(ah6, bh3)) | 0;
		    lo = (lo + Math.imul(al5, bl4)) | 0;
		    mid = (mid + Math.imul(al5, bh4)) | 0;
		    mid = (mid + Math.imul(ah5, bl4)) | 0;
		    hi = (hi + Math.imul(ah5, bh4)) | 0;
		    lo = (lo + Math.imul(al4, bl5)) | 0;
		    mid = (mid + Math.imul(al4, bh5)) | 0;
		    mid = (mid + Math.imul(ah4, bl5)) | 0;
		    hi = (hi + Math.imul(ah4, bh5)) | 0;
		    lo = (lo + Math.imul(al3, bl6)) | 0;
		    mid = (mid + Math.imul(al3, bh6)) | 0;
		    mid = (mid + Math.imul(ah3, bl6)) | 0;
		    hi = (hi + Math.imul(ah3, bh6)) | 0;
		    lo = (lo + Math.imul(al2, bl7)) | 0;
		    mid = (mid + Math.imul(al2, bh7)) | 0;
		    mid = (mid + Math.imul(ah2, bl7)) | 0;
		    hi = (hi + Math.imul(ah2, bh7)) | 0;
		    lo = (lo + Math.imul(al1, bl8)) | 0;
		    mid = (mid + Math.imul(al1, bh8)) | 0;
		    mid = (mid + Math.imul(ah1, bl8)) | 0;
		    hi = (hi + Math.imul(ah1, bh8)) | 0;
		    lo = (lo + Math.imul(al0, bl9)) | 0;
		    mid = (mid + Math.imul(al0, bh9)) | 0;
		    mid = (mid + Math.imul(ah0, bl9)) | 0;
		    hi = (hi + Math.imul(ah0, bh9)) | 0;
		    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
		    w9 &= 0x3ffffff;
		    /* k = 10 */
		    lo = Math.imul(al9, bl1);
		    mid = Math.imul(al9, bh1);
		    mid = (mid + Math.imul(ah9, bl1)) | 0;
		    hi = Math.imul(ah9, bh1);
		    lo = (lo + Math.imul(al8, bl2)) | 0;
		    mid = (mid + Math.imul(al8, bh2)) | 0;
		    mid = (mid + Math.imul(ah8, bl2)) | 0;
		    hi = (hi + Math.imul(ah8, bh2)) | 0;
		    lo = (lo + Math.imul(al7, bl3)) | 0;
		    mid = (mid + Math.imul(al7, bh3)) | 0;
		    mid = (mid + Math.imul(ah7, bl3)) | 0;
		    hi = (hi + Math.imul(ah7, bh3)) | 0;
		    lo = (lo + Math.imul(al6, bl4)) | 0;
		    mid = (mid + Math.imul(al6, bh4)) | 0;
		    mid = (mid + Math.imul(ah6, bl4)) | 0;
		    hi = (hi + Math.imul(ah6, bh4)) | 0;
		    lo = (lo + Math.imul(al5, bl5)) | 0;
		    mid = (mid + Math.imul(al5, bh5)) | 0;
		    mid = (mid + Math.imul(ah5, bl5)) | 0;
		    hi = (hi + Math.imul(ah5, bh5)) | 0;
		    lo = (lo + Math.imul(al4, bl6)) | 0;
		    mid = (mid + Math.imul(al4, bh6)) | 0;
		    mid = (mid + Math.imul(ah4, bl6)) | 0;
		    hi = (hi + Math.imul(ah4, bh6)) | 0;
		    lo = (lo + Math.imul(al3, bl7)) | 0;
		    mid = (mid + Math.imul(al3, bh7)) | 0;
		    mid = (mid + Math.imul(ah3, bl7)) | 0;
		    hi = (hi + Math.imul(ah3, bh7)) | 0;
		    lo = (lo + Math.imul(al2, bl8)) | 0;
		    mid = (mid + Math.imul(al2, bh8)) | 0;
		    mid = (mid + Math.imul(ah2, bl8)) | 0;
		    hi = (hi + Math.imul(ah2, bh8)) | 0;
		    lo = (lo + Math.imul(al1, bl9)) | 0;
		    mid = (mid + Math.imul(al1, bh9)) | 0;
		    mid = (mid + Math.imul(ah1, bl9)) | 0;
		    hi = (hi + Math.imul(ah1, bh9)) | 0;
		    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
		    w10 &= 0x3ffffff;
		    /* k = 11 */
		    lo = Math.imul(al9, bl2);
		    mid = Math.imul(al9, bh2);
		    mid = (mid + Math.imul(ah9, bl2)) | 0;
		    hi = Math.imul(ah9, bh2);
		    lo = (lo + Math.imul(al8, bl3)) | 0;
		    mid = (mid + Math.imul(al8, bh3)) | 0;
		    mid = (mid + Math.imul(ah8, bl3)) | 0;
		    hi = (hi + Math.imul(ah8, bh3)) | 0;
		    lo = (lo + Math.imul(al7, bl4)) | 0;
		    mid = (mid + Math.imul(al7, bh4)) | 0;
		    mid = (mid + Math.imul(ah7, bl4)) | 0;
		    hi = (hi + Math.imul(ah7, bh4)) | 0;
		    lo = (lo + Math.imul(al6, bl5)) | 0;
		    mid = (mid + Math.imul(al6, bh5)) | 0;
		    mid = (mid + Math.imul(ah6, bl5)) | 0;
		    hi = (hi + Math.imul(ah6, bh5)) | 0;
		    lo = (lo + Math.imul(al5, bl6)) | 0;
		    mid = (mid + Math.imul(al5, bh6)) | 0;
		    mid = (mid + Math.imul(ah5, bl6)) | 0;
		    hi = (hi + Math.imul(ah5, bh6)) | 0;
		    lo = (lo + Math.imul(al4, bl7)) | 0;
		    mid = (mid + Math.imul(al4, bh7)) | 0;
		    mid = (mid + Math.imul(ah4, bl7)) | 0;
		    hi = (hi + Math.imul(ah4, bh7)) | 0;
		    lo = (lo + Math.imul(al3, bl8)) | 0;
		    mid = (mid + Math.imul(al3, bh8)) | 0;
		    mid = (mid + Math.imul(ah3, bl8)) | 0;
		    hi = (hi + Math.imul(ah3, bh8)) | 0;
		    lo = (lo + Math.imul(al2, bl9)) | 0;
		    mid = (mid + Math.imul(al2, bh9)) | 0;
		    mid = (mid + Math.imul(ah2, bl9)) | 0;
		    hi = (hi + Math.imul(ah2, bh9)) | 0;
		    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
		    w11 &= 0x3ffffff;
		    /* k = 12 */
		    lo = Math.imul(al9, bl3);
		    mid = Math.imul(al9, bh3);
		    mid = (mid + Math.imul(ah9, bl3)) | 0;
		    hi = Math.imul(ah9, bh3);
		    lo = (lo + Math.imul(al8, bl4)) | 0;
		    mid = (mid + Math.imul(al8, bh4)) | 0;
		    mid = (mid + Math.imul(ah8, bl4)) | 0;
		    hi = (hi + Math.imul(ah8, bh4)) | 0;
		    lo = (lo + Math.imul(al7, bl5)) | 0;
		    mid = (mid + Math.imul(al7, bh5)) | 0;
		    mid = (mid + Math.imul(ah7, bl5)) | 0;
		    hi = (hi + Math.imul(ah7, bh5)) | 0;
		    lo = (lo + Math.imul(al6, bl6)) | 0;
		    mid = (mid + Math.imul(al6, bh6)) | 0;
		    mid = (mid + Math.imul(ah6, bl6)) | 0;
		    hi = (hi + Math.imul(ah6, bh6)) | 0;
		    lo = (lo + Math.imul(al5, bl7)) | 0;
		    mid = (mid + Math.imul(al5, bh7)) | 0;
		    mid = (mid + Math.imul(ah5, bl7)) | 0;
		    hi = (hi + Math.imul(ah5, bh7)) | 0;
		    lo = (lo + Math.imul(al4, bl8)) | 0;
		    mid = (mid + Math.imul(al4, bh8)) | 0;
		    mid = (mid + Math.imul(ah4, bl8)) | 0;
		    hi = (hi + Math.imul(ah4, bh8)) | 0;
		    lo = (lo + Math.imul(al3, bl9)) | 0;
		    mid = (mid + Math.imul(al3, bh9)) | 0;
		    mid = (mid + Math.imul(ah3, bl9)) | 0;
		    hi = (hi + Math.imul(ah3, bh9)) | 0;
		    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
		    w12 &= 0x3ffffff;
		    /* k = 13 */
		    lo = Math.imul(al9, bl4);
		    mid = Math.imul(al9, bh4);
		    mid = (mid + Math.imul(ah9, bl4)) | 0;
		    hi = Math.imul(ah9, bh4);
		    lo = (lo + Math.imul(al8, bl5)) | 0;
		    mid = (mid + Math.imul(al8, bh5)) | 0;
		    mid = (mid + Math.imul(ah8, bl5)) | 0;
		    hi = (hi + Math.imul(ah8, bh5)) | 0;
		    lo = (lo + Math.imul(al7, bl6)) | 0;
		    mid = (mid + Math.imul(al7, bh6)) | 0;
		    mid = (mid + Math.imul(ah7, bl6)) | 0;
		    hi = (hi + Math.imul(ah7, bh6)) | 0;
		    lo = (lo + Math.imul(al6, bl7)) | 0;
		    mid = (mid + Math.imul(al6, bh7)) | 0;
		    mid = (mid + Math.imul(ah6, bl7)) | 0;
		    hi = (hi + Math.imul(ah6, bh7)) | 0;
		    lo = (lo + Math.imul(al5, bl8)) | 0;
		    mid = (mid + Math.imul(al5, bh8)) | 0;
		    mid = (mid + Math.imul(ah5, bl8)) | 0;
		    hi = (hi + Math.imul(ah5, bh8)) | 0;
		    lo = (lo + Math.imul(al4, bl9)) | 0;
		    mid = (mid + Math.imul(al4, bh9)) | 0;
		    mid = (mid + Math.imul(ah4, bl9)) | 0;
		    hi = (hi + Math.imul(ah4, bh9)) | 0;
		    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
		    w13 &= 0x3ffffff;
		    /* k = 14 */
		    lo = Math.imul(al9, bl5);
		    mid = Math.imul(al9, bh5);
		    mid = (mid + Math.imul(ah9, bl5)) | 0;
		    hi = Math.imul(ah9, bh5);
		    lo = (lo + Math.imul(al8, bl6)) | 0;
		    mid = (mid + Math.imul(al8, bh6)) | 0;
		    mid = (mid + Math.imul(ah8, bl6)) | 0;
		    hi = (hi + Math.imul(ah8, bh6)) | 0;
		    lo = (lo + Math.imul(al7, bl7)) | 0;
		    mid = (mid + Math.imul(al7, bh7)) | 0;
		    mid = (mid + Math.imul(ah7, bl7)) | 0;
		    hi = (hi + Math.imul(ah7, bh7)) | 0;
		    lo = (lo + Math.imul(al6, bl8)) | 0;
		    mid = (mid + Math.imul(al6, bh8)) | 0;
		    mid = (mid + Math.imul(ah6, bl8)) | 0;
		    hi = (hi + Math.imul(ah6, bh8)) | 0;
		    lo = (lo + Math.imul(al5, bl9)) | 0;
		    mid = (mid + Math.imul(al5, bh9)) | 0;
		    mid = (mid + Math.imul(ah5, bl9)) | 0;
		    hi = (hi + Math.imul(ah5, bh9)) | 0;
		    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
		    w14 &= 0x3ffffff;
		    /* k = 15 */
		    lo = Math.imul(al9, bl6);
		    mid = Math.imul(al9, bh6);
		    mid = (mid + Math.imul(ah9, bl6)) | 0;
		    hi = Math.imul(ah9, bh6);
		    lo = (lo + Math.imul(al8, bl7)) | 0;
		    mid = (mid + Math.imul(al8, bh7)) | 0;
		    mid = (mid + Math.imul(ah8, bl7)) | 0;
		    hi = (hi + Math.imul(ah8, bh7)) | 0;
		    lo = (lo + Math.imul(al7, bl8)) | 0;
		    mid = (mid + Math.imul(al7, bh8)) | 0;
		    mid = (mid + Math.imul(ah7, bl8)) | 0;
		    hi = (hi + Math.imul(ah7, bh8)) | 0;
		    lo = (lo + Math.imul(al6, bl9)) | 0;
		    mid = (mid + Math.imul(al6, bh9)) | 0;
		    mid = (mid + Math.imul(ah6, bl9)) | 0;
		    hi = (hi + Math.imul(ah6, bh9)) | 0;
		    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
		    w15 &= 0x3ffffff;
		    /* k = 16 */
		    lo = Math.imul(al9, bl7);
		    mid = Math.imul(al9, bh7);
		    mid = (mid + Math.imul(ah9, bl7)) | 0;
		    hi = Math.imul(ah9, bh7);
		    lo = (lo + Math.imul(al8, bl8)) | 0;
		    mid = (mid + Math.imul(al8, bh8)) | 0;
		    mid = (mid + Math.imul(ah8, bl8)) | 0;
		    hi = (hi + Math.imul(ah8, bh8)) | 0;
		    lo = (lo + Math.imul(al7, bl9)) | 0;
		    mid = (mid + Math.imul(al7, bh9)) | 0;
		    mid = (mid + Math.imul(ah7, bl9)) | 0;
		    hi = (hi + Math.imul(ah7, bh9)) | 0;
		    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
		    w16 &= 0x3ffffff;
		    /* k = 17 */
		    lo = Math.imul(al9, bl8);
		    mid = Math.imul(al9, bh8);
		    mid = (mid + Math.imul(ah9, bl8)) | 0;
		    hi = Math.imul(ah9, bh8);
		    lo = (lo + Math.imul(al8, bl9)) | 0;
		    mid = (mid + Math.imul(al8, bh9)) | 0;
		    mid = (mid + Math.imul(ah8, bl9)) | 0;
		    hi = (hi + Math.imul(ah8, bh9)) | 0;
		    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
		    w17 &= 0x3ffffff;
		    /* k = 18 */
		    lo = Math.imul(al9, bl9);
		    mid = Math.imul(al9, bh9);
		    mid = (mid + Math.imul(ah9, bl9)) | 0;
		    hi = Math.imul(ah9, bh9);
		    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
		    w18 &= 0x3ffffff;
		    o[0] = w0;
		    o[1] = w1;
		    o[2] = w2;
		    o[3] = w3;
		    o[4] = w4;
		    o[5] = w5;
		    o[6] = w6;
		    o[7] = w7;
		    o[8] = w8;
		    o[9] = w9;
		    o[10] = w10;
		    o[11] = w11;
		    o[12] = w12;
		    o[13] = w13;
		    o[14] = w14;
		    o[15] = w15;
		    o[16] = w16;
		    o[17] = w17;
		    o[18] = w18;
		    if (c !== 0) {
		      o[19] = c;
		      out.length++;
		    }
		    return out;
		  };

		  // Polyfill comb
		  if (!Math.imul) {
		    comb10MulTo = smallMulTo;
		  }

		  function bigMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    out.length = self.length + num.length;

		    var carry = 0;
		    var hncarry = 0;
		    for (var k = 0; k < out.length - 1; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = hncarry;
		      hncarry = 0;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = k - j;
		        var a = self.words[i] | 0;
		        var b = num.words[j] | 0;
		        var r = a * b;

		        var lo = r & 0x3ffffff;
		        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
		        lo = (lo + rword) | 0;
		        rword = lo & 0x3ffffff;
		        ncarry = (ncarry + (lo >>> 26)) | 0;

		        hncarry += ncarry >>> 26;
		        ncarry &= 0x3ffffff;
		      }
		      out.words[k] = rword;
		      carry = ncarry;
		      ncarry = hncarry;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry;
		    } else {
		      out.length--;
		    }

		    return out._strip();
		  }

		  function jumboMulTo (self, num, out) {
		    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
		    // var fftm = new FFTM();
		    // return fftm.mulp(self, num, out);
		    return bigMulTo(self, num, out);
		  }

		  BN.prototype.mulTo = function mulTo (num, out) {
		    var res;
		    var len = this.length + num.length;
		    if (this.length === 10 && num.length === 10) {
		      res = comb10MulTo(this, num, out);
		    } else if (len < 63) {
		      res = smallMulTo(this, num, out);
		    } else if (len < 1024) {
		      res = bigMulTo(this, num, out);
		    } else {
		      res = jumboMulTo(this, num, out);
		    }

		    return res;
		  };

		  // Multiply `this` by `num`
		  BN.prototype.mul = function mul (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return this.mulTo(num, out);
		  };

		  // Multiply employing FFT
		  BN.prototype.mulf = function mulf (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return jumboMulTo(this, num, out);
		  };

		  // In-place Multiplication
		  BN.prototype.imul = function imul (num) {
		    return this.clone().mulTo(num, this);
		  };

		  BN.prototype.imuln = function imuln (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(typeof num === 'number');
		    assert(num < 0x4000000);

		    // Carry
		    var carry = 0;
		    for (var i = 0; i < this.length; i++) {
		      var w = (this.words[i] | 0) * num;
		      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
		      carry >>= 26;
		      carry += (w / 0x4000000) | 0;
		      // NOTE: lo is 27bit maximum
		      carry += lo >>> 26;
		      this.words[i] = lo & 0x3ffffff;
		    }

		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }

		    return isNegNum ? this.ineg() : this;
		  };

		  BN.prototype.muln = function muln (num) {
		    return this.clone().imuln(num);
		  };

		  // `this` * `this`
		  BN.prototype.sqr = function sqr () {
		    return this.mul(this);
		  };

		  // `this` * `this` in-place
		  BN.prototype.isqr = function isqr () {
		    return this.imul(this.clone());
		  };

		  // Math.pow(`this`, `num`)
		  BN.prototype.pow = function pow (num) {
		    var w = toBitArray(num);
		    if (w.length === 0) return new BN(1);

		    // Skip leading zeroes
		    var res = this;
		    for (var i = 0; i < w.length; i++, res = res.sqr()) {
		      if (w[i] !== 0) break;
		    }

		    if (++i < w.length) {
		      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
		        if (w[i] === 0) continue;

		        res = res.mul(q);
		      }
		    }

		    return res;
		  };

		  // Shift-left in-place
		  BN.prototype.iushln = function iushln (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;
		    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
		    var i;

		    if (r !== 0) {
		      var carry = 0;

		      for (i = 0; i < this.length; i++) {
		        var newCarry = this.words[i] & carryMask;
		        var c = ((this.words[i] | 0) - newCarry) << r;
		        this.words[i] = c | carry;
		        carry = newCarry >>> (26 - r);
		      }

		      if (carry) {
		        this.words[i] = carry;
		        this.length++;
		      }
		    }

		    if (s !== 0) {
		      for (i = this.length - 1; i >= 0; i--) {
		        this.words[i + s] = this.words[i];
		      }

		      for (i = 0; i < s; i++) {
		        this.words[i] = 0;
		      }

		      this.length += s;
		    }

		    return this._strip();
		  };

		  BN.prototype.ishln = function ishln (bits) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushln(bits);
		  };

		  // Shift-right in-place
		  // NOTE: `hint` is a lowest bit before trailing zeroes
		  // NOTE: if `extended` is present - it will be filled with destroyed bits
		  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var h;
		    if (hint) {
		      h = (hint - (hint % 26)) / 26;
		    } else {
		      h = 0;
		    }

		    var r = bits % 26;
		    var s = Math.min((bits - r) / 26, this.length);
		    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		    var maskedWords = extended;

		    h -= s;
		    h = Math.max(0, h);

		    // Extended mode, copy masked part
		    if (maskedWords) {
		      for (var i = 0; i < s; i++) {
		        maskedWords.words[i] = this.words[i];
		      }
		      maskedWords.length = s;
		    }

		    if (s === 0) ; else if (this.length > s) {
		      this.length -= s;
		      for (i = 0; i < this.length; i++) {
		        this.words[i] = this.words[i + s];
		      }
		    } else {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    var carry = 0;
		    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
		      var word = this.words[i] | 0;
		      this.words[i] = (carry << (26 - r)) | (word >>> r);
		      carry = word & mask;
		    }

		    // Push carried bits as a mask
		    if (maskedWords && carry !== 0) {
		      maskedWords.words[maskedWords.length++] = carry;
		    }

		    if (this.length === 0) {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    return this._strip();
		  };

		  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushrn(bits, hint, extended);
		  };

		  // Shift-left
		  BN.prototype.shln = function shln (bits) {
		    return this.clone().ishln(bits);
		  };

		  BN.prototype.ushln = function ushln (bits) {
		    return this.clone().iushln(bits);
		  };

		  // Shift-right
		  BN.prototype.shrn = function shrn (bits) {
		    return this.clone().ishrn(bits);
		  };

		  BN.prototype.ushrn = function ushrn (bits) {
		    return this.clone().iushrn(bits);
		  };

		  // Test if n bit is set
		  BN.prototype.testn = function testn (bit) {
		    assert(typeof bit === 'number' && bit >= 0);
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) return false;

		    // Check bit and return
		    var w = this.words[s];

		    return !!(w & q);
		  };

		  // Return only lowers bits of number (in-place)
		  BN.prototype.imaskn = function imaskn (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;

		    assert(this.negative === 0, 'imaskn works only with positive numbers');

		    if (this.length <= s) {
		      return this;
		    }

		    if (r !== 0) {
		      s++;
		    }
		    this.length = Math.min(s, this.length);

		    if (r !== 0) {
		      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		      this.words[this.length - 1] &= mask;
		    }

		    return this._strip();
		  };

		  // Return only lowers bits of number
		  BN.prototype.maskn = function maskn (bits) {
		    return this.clone().imaskn(bits);
		  };

		  // Add plain number `num` to `this`
		  BN.prototype.iaddn = function iaddn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.isubn(-num);

		    // Possible sign change
		    if (this.negative !== 0) {
		      if (this.length === 1 && (this.words[0] | 0) <= num) {
		        this.words[0] = num - (this.words[0] | 0);
		        this.negative = 0;
		        return this;
		      }

		      this.negative = 0;
		      this.isubn(num);
		      this.negative = 1;
		      return this;
		    }

		    // Add without checks
		    return this._iaddn(num);
		  };

		  BN.prototype._iaddn = function _iaddn (num) {
		    this.words[0] += num;

		    // Carry
		    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
		      this.words[i] -= 0x4000000;
		      if (i === this.length - 1) {
		        this.words[i + 1] = 1;
		      } else {
		        this.words[i + 1]++;
		      }
		    }
		    this.length = Math.max(this.length, i + 1);

		    return this;
		  };

		  // Subtract plain number `num` from `this`
		  BN.prototype.isubn = function isubn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.iaddn(-num);

		    if (this.negative !== 0) {
		      this.negative = 0;
		      this.iaddn(num);
		      this.negative = 1;
		      return this;
		    }

		    this.words[0] -= num;

		    if (this.length === 1 && this.words[0] < 0) {
		      this.words[0] = -this.words[0];
		      this.negative = 1;
		    } else {
		      // Carry
		      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
		        this.words[i] += 0x4000000;
		        this.words[i + 1] -= 1;
		      }
		    }

		    return this._strip();
		  };

		  BN.prototype.addn = function addn (num) {
		    return this.clone().iaddn(num);
		  };

		  BN.prototype.subn = function subn (num) {
		    return this.clone().isubn(num);
		  };

		  BN.prototype.iabs = function iabs () {
		    this.negative = 0;

		    return this;
		  };

		  BN.prototype.abs = function abs () {
		    return this.clone().iabs();
		  };

		  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
		    var len = num.length + shift;
		    var i;

		    this._expand(len);

		    var w;
		    var carry = 0;
		    for (i = 0; i < num.length; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      var right = (num.words[i] | 0) * mul;
		      w -= right & 0x3ffffff;
		      carry = (w >> 26) - ((right / 0x4000000) | 0);
		      this.words[i + shift] = w & 0x3ffffff;
		    }
		    for (; i < this.length - shift; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      carry = w >> 26;
		      this.words[i + shift] = w & 0x3ffffff;
		    }

		    if (carry === 0) return this._strip();

		    // Subtraction overflow
		    assert(carry === -1);
		    carry = 0;
		    for (i = 0; i < this.length; i++) {
		      w = -(this.words[i] | 0) + carry;
		      carry = w >> 26;
		      this.words[i] = w & 0x3ffffff;
		    }
		    this.negative = 1;

		    return this._strip();
		  };

		  BN.prototype._wordDiv = function _wordDiv (num, mode) {
		    var shift = this.length - num.length;

		    var a = this.clone();
		    var b = num;

		    // Normalize
		    var bhi = b.words[b.length - 1] | 0;
		    var bhiBits = this._countBits(bhi);
		    shift = 26 - bhiBits;
		    if (shift !== 0) {
		      b = b.ushln(shift);
		      a.iushln(shift);
		      bhi = b.words[b.length - 1] | 0;
		    }

		    // Initialize quotient
		    var m = a.length - b.length;
		    var q;

		    if (mode !== 'mod') {
		      q = new BN(null);
		      q.length = m + 1;
		      q.words = new Array(q.length);
		      for (var i = 0; i < q.length; i++) {
		        q.words[i] = 0;
		      }
		    }

		    var diff = a.clone()._ishlnsubmul(b, 1, m);
		    if (diff.negative === 0) {
		      a = diff;
		      if (q) {
		        q.words[m] = 1;
		      }
		    }

		    for (var j = m - 1; j >= 0; j--) {
		      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
		        (a.words[b.length + j - 1] | 0);

		      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
		      // (0x7ffffff)
		      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

		      a._ishlnsubmul(b, qj, j);
		      while (a.negative !== 0) {
		        qj--;
		        a.negative = 0;
		        a._ishlnsubmul(b, 1, j);
		        if (!a.isZero()) {
		          a.negative ^= 1;
		        }
		      }
		      if (q) {
		        q.words[j] = qj;
		      }
		    }
		    if (q) {
		      q._strip();
		    }
		    a._strip();

		    // Denormalize
		    if (mode !== 'div' && shift !== 0) {
		      a.iushrn(shift);
		    }

		    return {
		      div: q || null,
		      mod: a
		    };
		  };

		  // NOTE: 1) `mode` can be set to `mod` to request mod only,
		  //       to `div` to request div only, or be absent to
		  //       request both div & mod
		  //       2) `positive` is true if unsigned mod is requested
		  BN.prototype.divmod = function divmod (num, mode, positive) {
		    assert(!num.isZero());

		    if (this.isZero()) {
		      return {
		        div: new BN(0),
		        mod: new BN(0)
		      };
		    }

		    var div, mod, res;
		    if (this.negative !== 0 && num.negative === 0) {
		      res = this.neg().divmod(num, mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.iadd(num);
		        }
		      }

		      return {
		        div: div,
		        mod: mod
		      };
		    }

		    if (this.negative === 0 && num.negative !== 0) {
		      res = this.divmod(num.neg(), mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      return {
		        div: div,
		        mod: res.mod
		      };
		    }

		    if ((this.negative & num.negative) !== 0) {
		      res = this.neg().divmod(num.neg(), mode);

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.isub(num);
		        }
		      }

		      return {
		        div: res.div,
		        mod: mod
		      };
		    }

		    // Both numbers are positive at this point

		    // Strip both numbers to approximate shift value
		    if (num.length > this.length || this.cmp(num) < 0) {
		      return {
		        div: new BN(0),
		        mod: this
		      };
		    }

		    // Very short reduction
		    if (num.length === 1) {
		      if (mode === 'div') {
		        return {
		          div: this.divn(num.words[0]),
		          mod: null
		        };
		      }

		      if (mode === 'mod') {
		        return {
		          div: null,
		          mod: new BN(this.modrn(num.words[0]))
		        };
		      }

		      return {
		        div: this.divn(num.words[0]),
		        mod: new BN(this.modrn(num.words[0]))
		      };
		    }

		    return this._wordDiv(num, mode);
		  };

		  // Find `this` / `num`
		  BN.prototype.div = function div (num) {
		    return this.divmod(num, 'div', false).div;
		  };

		  // Find `this` % `num`
		  BN.prototype.mod = function mod (num) {
		    return this.divmod(num, 'mod', false).mod;
		  };

		  BN.prototype.umod = function umod (num) {
		    return this.divmod(num, 'mod', true).mod;
		  };

		  // Find Round(`this` / `num`)
		  BN.prototype.divRound = function divRound (num) {
		    var dm = this.divmod(num);

		    // Fast case - exact division
		    if (dm.mod.isZero()) return dm.div;

		    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

		    var half = num.ushrn(1);
		    var r2 = num.andln(1);
		    var cmp = mod.cmp(half);

		    // Round down
		    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

		    // Round up
		    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
		  };

		  BN.prototype.modrn = function modrn (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(num <= 0x3ffffff);
		    var p = (1 << 26) % num;

		    var acc = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      acc = (p * acc + (this.words[i] | 0)) % num;
		    }

		    return isNegNum ? -acc : acc;
		  };

		  // WARNING: DEPRECATED
		  BN.prototype.modn = function modn (num) {
		    return this.modrn(num);
		  };

		  // In-place division by number
		  BN.prototype.idivn = function idivn (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(num <= 0x3ffffff);

		    var carry = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var w = (this.words[i] | 0) + carry * 0x4000000;
		      this.words[i] = (w / num) | 0;
		      carry = w % num;
		    }

		    this._strip();
		    return isNegNum ? this.ineg() : this;
		  };

		  BN.prototype.divn = function divn (num) {
		    return this.clone().idivn(num);
		  };

		  BN.prototype.egcd = function egcd (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var x = this;
		    var y = p.clone();

		    if (x.negative !== 0) {
		      x = x.umod(p);
		    } else {
		      x = x.clone();
		    }

		    // A * x + B * y = x
		    var A = new BN(1);
		    var B = new BN(0);

		    // C * x + D * y = y
		    var C = new BN(0);
		    var D = new BN(1);

		    var g = 0;

		    while (x.isEven() && y.isEven()) {
		      x.iushrn(1);
		      y.iushrn(1);
		      ++g;
		    }

		    var yp = y.clone();
		    var xp = x.clone();

		    while (!x.isZero()) {
		      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        x.iushrn(i);
		        while (i-- > 0) {
		          if (A.isOdd() || B.isOdd()) {
		            A.iadd(yp);
		            B.isub(xp);
		          }

		          A.iushrn(1);
		          B.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        y.iushrn(j);
		        while (j-- > 0) {
		          if (C.isOdd() || D.isOdd()) {
		            C.iadd(yp);
		            D.isub(xp);
		          }

		          C.iushrn(1);
		          D.iushrn(1);
		        }
		      }

		      if (x.cmp(y) >= 0) {
		        x.isub(y);
		        A.isub(C);
		        B.isub(D);
		      } else {
		        y.isub(x);
		        C.isub(A);
		        D.isub(B);
		      }
		    }

		    return {
		      a: C,
		      b: D,
		      gcd: y.iushln(g)
		    };
		  };

		  // This is reduced incarnation of the binary EEA
		  // above, designated to invert members of the
		  // _prime_ fields F(p) at a maximal speed
		  BN.prototype._invmp = function _invmp (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var a = this;
		    var b = p.clone();

		    if (a.negative !== 0) {
		      a = a.umod(p);
		    } else {
		      a = a.clone();
		    }

		    var x1 = new BN(1);
		    var x2 = new BN(0);

		    var delta = b.clone();

		    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
		      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        a.iushrn(i);
		        while (i-- > 0) {
		          if (x1.isOdd()) {
		            x1.iadd(delta);
		          }

		          x1.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        b.iushrn(j);
		        while (j-- > 0) {
		          if (x2.isOdd()) {
		            x2.iadd(delta);
		          }

		          x2.iushrn(1);
		        }
		      }

		      if (a.cmp(b) >= 0) {
		        a.isub(b);
		        x1.isub(x2);
		      } else {
		        b.isub(a);
		        x2.isub(x1);
		      }
		    }

		    var res;
		    if (a.cmpn(1) === 0) {
		      res = x1;
		    } else {
		      res = x2;
		    }

		    if (res.cmpn(0) < 0) {
		      res.iadd(p);
		    }

		    return res;
		  };

		  BN.prototype.gcd = function gcd (num) {
		    if (this.isZero()) return num.abs();
		    if (num.isZero()) return this.abs();

		    var a = this.clone();
		    var b = num.clone();
		    a.negative = 0;
		    b.negative = 0;

		    // Remove common factor of two
		    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
		      a.iushrn(1);
		      b.iushrn(1);
		    }

		    do {
		      while (a.isEven()) {
		        a.iushrn(1);
		      }
		      while (b.isEven()) {
		        b.iushrn(1);
		      }

		      var r = a.cmp(b);
		      if (r < 0) {
		        // Swap `a` and `b` to make `a` always bigger than `b`
		        var t = a;
		        a = b;
		        b = t;
		      } else if (r === 0 || b.cmpn(1) === 0) {
		        break;
		      }

		      a.isub(b);
		    } while (true);

		    return b.iushln(shift);
		  };

		  // Invert number in the field F(num)
		  BN.prototype.invm = function invm (num) {
		    return this.egcd(num).a.umod(num);
		  };

		  BN.prototype.isEven = function isEven () {
		    return (this.words[0] & 1) === 0;
		  };

		  BN.prototype.isOdd = function isOdd () {
		    return (this.words[0] & 1) === 1;
		  };

		  // And first word and num
		  BN.prototype.andln = function andln (num) {
		    return this.words[0] & num;
		  };

		  // Increment at the bit position in-line
		  BN.prototype.bincn = function bincn (bit) {
		    assert(typeof bit === 'number');
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) {
		      this._expand(s + 1);
		      this.words[s] |= q;
		      return this;
		    }

		    // Add bit and propagate, if needed
		    var carry = q;
		    for (var i = s; carry !== 0 && i < this.length; i++) {
		      var w = this.words[i] | 0;
		      w += carry;
		      carry = w >>> 26;
		      w &= 0x3ffffff;
		      this.words[i] = w;
		    }
		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }
		    return this;
		  };

		  BN.prototype.isZero = function isZero () {
		    return this.length === 1 && this.words[0] === 0;
		  };

		  BN.prototype.cmpn = function cmpn (num) {
		    var negative = num < 0;

		    if (this.negative !== 0 && !negative) return -1;
		    if (this.negative === 0 && negative) return 1;

		    this._strip();

		    var res;
		    if (this.length > 1) {
		      res = 1;
		    } else {
		      if (negative) {
		        num = -num;
		      }

		      assert(num <= 0x3ffffff, 'Number is too big');

		      var w = this.words[0] | 0;
		      res = w === num ? 0 : w < num ? -1 : 1;
		    }
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Compare two numbers and return:
		  // 1 - if `this` > `num`
		  // 0 - if `this` == `num`
		  // -1 - if `this` < `num`
		  BN.prototype.cmp = function cmp (num) {
		    if (this.negative !== 0 && num.negative === 0) return -1;
		    if (this.negative === 0 && num.negative !== 0) return 1;

		    var res = this.ucmp(num);
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Unsigned comparison
		  BN.prototype.ucmp = function ucmp (num) {
		    // At this point both numbers have the same sign
		    if (this.length > num.length) return 1;
		    if (this.length < num.length) return -1;

		    var res = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var a = this.words[i] | 0;
		      var b = num.words[i] | 0;

		      if (a === b) continue;
		      if (a < b) {
		        res = -1;
		      } else if (a > b) {
		        res = 1;
		      }
		      break;
		    }
		    return res;
		  };

		  BN.prototype.gtn = function gtn (num) {
		    return this.cmpn(num) === 1;
		  };

		  BN.prototype.gt = function gt (num) {
		    return this.cmp(num) === 1;
		  };

		  BN.prototype.gten = function gten (num) {
		    return this.cmpn(num) >= 0;
		  };

		  BN.prototype.gte = function gte (num) {
		    return this.cmp(num) >= 0;
		  };

		  BN.prototype.ltn = function ltn (num) {
		    return this.cmpn(num) === -1;
		  };

		  BN.prototype.lt = function lt (num) {
		    return this.cmp(num) === -1;
		  };

		  BN.prototype.lten = function lten (num) {
		    return this.cmpn(num) <= 0;
		  };

		  BN.prototype.lte = function lte (num) {
		    return this.cmp(num) <= 0;
		  };

		  BN.prototype.eqn = function eqn (num) {
		    return this.cmpn(num) === 0;
		  };

		  BN.prototype.eq = function eq (num) {
		    return this.cmp(num) === 0;
		  };

		  //
		  // A reduce context, could be using montgomery or something better, depending
		  // on the `m` itself.
		  //
		  BN.red = function red (num) {
		    return new Red(num);
		  };

		  BN.prototype.toRed = function toRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    assert(this.negative === 0, 'red works only with positives');
		    return ctx.convertTo(this)._forceRed(ctx);
		  };

		  BN.prototype.fromRed = function fromRed () {
		    assert(this.red, 'fromRed works only with numbers in reduction context');
		    return this.red.convertFrom(this);
		  };

		  BN.prototype._forceRed = function _forceRed (ctx) {
		    this.red = ctx;
		    return this;
		  };

		  BN.prototype.forceRed = function forceRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    return this._forceRed(ctx);
		  };

		  BN.prototype.redAdd = function redAdd (num) {
		    assert(this.red, 'redAdd works only with red numbers');
		    return this.red.add(this, num);
		  };

		  BN.prototype.redIAdd = function redIAdd (num) {
		    assert(this.red, 'redIAdd works only with red numbers');
		    return this.red.iadd(this, num);
		  };

		  BN.prototype.redSub = function redSub (num) {
		    assert(this.red, 'redSub works only with red numbers');
		    return this.red.sub(this, num);
		  };

		  BN.prototype.redISub = function redISub (num) {
		    assert(this.red, 'redISub works only with red numbers');
		    return this.red.isub(this, num);
		  };

		  BN.prototype.redShl = function redShl (num) {
		    assert(this.red, 'redShl works only with red numbers');
		    return this.red.shl(this, num);
		  };

		  BN.prototype.redMul = function redMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.mul(this, num);
		  };

		  BN.prototype.redIMul = function redIMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.imul(this, num);
		  };

		  BN.prototype.redSqr = function redSqr () {
		    assert(this.red, 'redSqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqr(this);
		  };

		  BN.prototype.redISqr = function redISqr () {
		    assert(this.red, 'redISqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.isqr(this);
		  };

		  // Square root over p
		  BN.prototype.redSqrt = function redSqrt () {
		    assert(this.red, 'redSqrt works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqrt(this);
		  };

		  BN.prototype.redInvm = function redInvm () {
		    assert(this.red, 'redInvm works only with red numbers');
		    this.red._verify1(this);
		    return this.red.invm(this);
		  };

		  // Return negative clone of `this` % `red modulo`
		  BN.prototype.redNeg = function redNeg () {
		    assert(this.red, 'redNeg works only with red numbers');
		    this.red._verify1(this);
		    return this.red.neg(this);
		  };

		  BN.prototype.redPow = function redPow (num) {
		    assert(this.red && !num.red, 'redPow(normalNum)');
		    this.red._verify1(this);
		    return this.red.pow(this, num);
		  };

		  // Prime numbers with efficient reduction
		  var primes = {
		    k256: null,
		    p224: null,
		    p192: null,
		    p25519: null
		  };

		  // Pseudo-Mersenne prime
		  function MPrime (name, p) {
		    // P = 2 ^ N - K
		    this.name = name;
		    this.p = new BN(p, 16);
		    this.n = this.p.bitLength();
		    this.k = new BN(1).iushln(this.n).isub(this.p);

		    this.tmp = this._tmp();
		  }

		  MPrime.prototype._tmp = function _tmp () {
		    var tmp = new BN(null);
		    tmp.words = new Array(Math.ceil(this.n / 13));
		    return tmp;
		  };

		  MPrime.prototype.ireduce = function ireduce (num) {
		    // Assumes that `num` is less than `P^2`
		    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
		    var r = num;
		    var rlen;

		    do {
		      this.split(r, this.tmp);
		      r = this.imulK(r);
		      r = r.iadd(this.tmp);
		      rlen = r.bitLength();
		    } while (rlen > this.n);

		    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
		    if (cmp === 0) {
		      r.words[0] = 0;
		      r.length = 1;
		    } else if (cmp > 0) {
		      r.isub(this.p);
		    } else {
		      if (r.strip !== undefined) {
		        // r is a BN v4 instance
		        r.strip();
		      } else {
		        // r is a BN v5 instance
		        r._strip();
		      }
		    }

		    return r;
		  };

		  MPrime.prototype.split = function split (input, out) {
		    input.iushrn(this.n, 0, out);
		  };

		  MPrime.prototype.imulK = function imulK (num) {
		    return num.imul(this.k);
		  };

		  function K256 () {
		    MPrime.call(
		      this,
		      'k256',
		      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
		  }
		  inherits(K256, MPrime);

		  K256.prototype.split = function split (input, output) {
		    // 256 = 9 * 26 + 22
		    var mask = 0x3fffff;

		    var outLen = Math.min(input.length, 9);
		    for (var i = 0; i < outLen; i++) {
		      output.words[i] = input.words[i];
		    }
		    output.length = outLen;

		    if (input.length <= 9) {
		      input.words[0] = 0;
		      input.length = 1;
		      return;
		    }

		    // Shift by 9 limbs
		    var prev = input.words[9];
		    output.words[output.length++] = prev & mask;

		    for (i = 10; i < input.length; i++) {
		      var next = input.words[i] | 0;
		      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
		      prev = next;
		    }
		    prev >>>= 22;
		    input.words[i - 10] = prev;
		    if (prev === 0 && input.length > 10) {
		      input.length -= 10;
		    } else {
		      input.length -= 9;
		    }
		  };

		  K256.prototype.imulK = function imulK (num) {
		    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
		    num.words[num.length] = 0;
		    num.words[num.length + 1] = 0;
		    num.length += 2;

		    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
		    var lo = 0;
		    for (var i = 0; i < num.length; i++) {
		      var w = num.words[i] | 0;
		      lo += w * 0x3d1;
		      num.words[i] = lo & 0x3ffffff;
		      lo = w * 0x40 + ((lo / 0x4000000) | 0);
		    }

		    // Fast length reduction
		    if (num.words[num.length - 1] === 0) {
		      num.length--;
		      if (num.words[num.length - 1] === 0) {
		        num.length--;
		      }
		    }
		    return num;
		  };

		  function P224 () {
		    MPrime.call(
		      this,
		      'p224',
		      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
		  }
		  inherits(P224, MPrime);

		  function P192 () {
		    MPrime.call(
		      this,
		      'p192',
		      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
		  }
		  inherits(P192, MPrime);

		  function P25519 () {
		    // 2 ^ 255 - 19
		    MPrime.call(
		      this,
		      '25519',
		      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
		  }
		  inherits(P25519, MPrime);

		  P25519.prototype.imulK = function imulK (num) {
		    // K = 0x13
		    var carry = 0;
		    for (var i = 0; i < num.length; i++) {
		      var hi = (num.words[i] | 0) * 0x13 + carry;
		      var lo = hi & 0x3ffffff;
		      hi >>>= 26;

		      num.words[i] = lo;
		      carry = hi;
		    }
		    if (carry !== 0) {
		      num.words[num.length++] = carry;
		    }
		    return num;
		  };

		  // Exported mostly for testing purposes, use plain name instead
		  BN._prime = function prime (name) {
		    // Cached version of prime
		    if (primes[name]) return primes[name];

		    var prime;
		    if (name === 'k256') {
		      prime = new K256();
		    } else if (name === 'p224') {
		      prime = new P224();
		    } else if (name === 'p192') {
		      prime = new P192();
		    } else if (name === 'p25519') {
		      prime = new P25519();
		    } else {
		      throw new Error('Unknown prime ' + name);
		    }
		    primes[name] = prime;

		    return prime;
		  };

		  //
		  // Base reduction engine
		  //
		  function Red (m) {
		    if (typeof m === 'string') {
		      var prime = BN._prime(m);
		      this.m = prime.p;
		      this.prime = prime;
		    } else {
		      assert(m.gtn(1), 'modulus must be greater than 1');
		      this.m = m;
		      this.prime = null;
		    }
		  }

		  Red.prototype._verify1 = function _verify1 (a) {
		    assert(a.negative === 0, 'red works only with positives');
		    assert(a.red, 'red works only with red numbers');
		  };

		  Red.prototype._verify2 = function _verify2 (a, b) {
		    assert((a.negative | b.negative) === 0, 'red works only with positives');
		    assert(a.red && a.red === b.red,
		      'red works only with red numbers');
		  };

		  Red.prototype.imod = function imod (a) {
		    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

		    move(a, a.umod(this.m)._forceRed(this));
		    return a;
		  };

		  Red.prototype.neg = function neg (a) {
		    if (a.isZero()) {
		      return a.clone();
		    }

		    return this.m.sub(a)._forceRed(this);
		  };

		  Red.prototype.add = function add (a, b) {
		    this._verify2(a, b);

		    var res = a.add(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.iadd = function iadd (a, b) {
		    this._verify2(a, b);

		    var res = a.iadd(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res;
		  };

		  Red.prototype.sub = function sub (a, b) {
		    this._verify2(a, b);

		    var res = a.sub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.isub = function isub (a, b) {
		    this._verify2(a, b);

		    var res = a.isub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res;
		  };

		  Red.prototype.shl = function shl (a, num) {
		    this._verify1(a);
		    return this.imod(a.ushln(num));
		  };

		  Red.prototype.imul = function imul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.imul(b));
		  };

		  Red.prototype.mul = function mul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.mul(b));
		  };

		  Red.prototype.isqr = function isqr (a) {
		    return this.imul(a, a.clone());
		  };

		  Red.prototype.sqr = function sqr (a) {
		    return this.mul(a, a);
		  };

		  Red.prototype.sqrt = function sqrt (a) {
		    if (a.isZero()) return a.clone();

		    var mod3 = this.m.andln(3);
		    assert(mod3 % 2 === 1);

		    // Fast case
		    if (mod3 === 3) {
		      var pow = this.m.add(new BN(1)).iushrn(2);
		      return this.pow(a, pow);
		    }

		    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
		    //
		    // Find Q and S, that Q * 2 ^ S = (P - 1)
		    var q = this.m.subn(1);
		    var s = 0;
		    while (!q.isZero() && q.andln(1) === 0) {
		      s++;
		      q.iushrn(1);
		    }
		    assert(!q.isZero());

		    var one = new BN(1).toRed(this);
		    var nOne = one.redNeg();

		    // Find quadratic non-residue
		    // NOTE: Max is such because of generalized Riemann hypothesis.
		    var lpow = this.m.subn(1).iushrn(1);
		    var z = this.m.bitLength();
		    z = new BN(2 * z * z).toRed(this);

		    while (this.pow(z, lpow).cmp(nOne) !== 0) {
		      z.redIAdd(nOne);
		    }

		    var c = this.pow(z, q);
		    var r = this.pow(a, q.addn(1).iushrn(1));
		    var t = this.pow(a, q);
		    var m = s;
		    while (t.cmp(one) !== 0) {
		      var tmp = t;
		      for (var i = 0; tmp.cmp(one) !== 0; i++) {
		        tmp = tmp.redSqr();
		      }
		      assert(i < m);
		      var b = this.pow(c, new BN(1).iushln(m - i - 1));

		      r = r.redMul(b);
		      c = b.redSqr();
		      t = t.redMul(c);
		      m = i;
		    }

		    return r;
		  };

		  Red.prototype.invm = function invm (a) {
		    var inv = a._invmp(this.m);
		    if (inv.negative !== 0) {
		      inv.negative = 0;
		      return this.imod(inv).redNeg();
		    } else {
		      return this.imod(inv);
		    }
		  };

		  Red.prototype.pow = function pow (a, num) {
		    if (num.isZero()) return new BN(1).toRed(this);
		    if (num.cmpn(1) === 0) return a.clone();

		    var windowSize = 4;
		    var wnd = new Array(1 << windowSize);
		    wnd[0] = new BN(1).toRed(this);
		    wnd[1] = a;
		    for (var i = 2; i < wnd.length; i++) {
		      wnd[i] = this.mul(wnd[i - 1], a);
		    }

		    var res = wnd[0];
		    var current = 0;
		    var currentLen = 0;
		    var start = num.bitLength() % 26;
		    if (start === 0) {
		      start = 26;
		    }

		    for (i = num.length - 1; i >= 0; i--) {
		      var word = num.words[i];
		      for (var j = start - 1; j >= 0; j--) {
		        var bit = (word >> j) & 1;
		        if (res !== wnd[0]) {
		          res = this.sqr(res);
		        }

		        if (bit === 0 && current === 0) {
		          currentLen = 0;
		          continue;
		        }

		        current <<= 1;
		        current |= bit;
		        currentLen++;
		        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

		        res = this.mul(res, wnd[current]);
		        currentLen = 0;
		        current = 0;
		      }
		      start = 26;
		    }

		    return res;
		  };

		  Red.prototype.convertTo = function convertTo (num) {
		    var r = num.umod(this.m);

		    return r === num ? r.clone() : r;
		  };

		  Red.prototype.convertFrom = function convertFrom (num) {
		    var res = num.clone();
		    res.red = null;
		    return res;
		  };

		  //
		  // Montgomery method engine
		  //

		  BN.mont = function mont (num) {
		    return new Mont(num);
		  };

		  function Mont (m) {
		    Red.call(this, m);

		    this.shift = this.m.bitLength();
		    if (this.shift % 26 !== 0) {
		      this.shift += 26 - (this.shift % 26);
		    }

		    this.r = new BN(1).iushln(this.shift);
		    this.r2 = this.imod(this.r.sqr());
		    this.rinv = this.r._invmp(this.m);

		    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
		    this.minv = this.minv.umod(this.r);
		    this.minv = this.r.sub(this.minv);
		  }
		  inherits(Mont, Red);

		  Mont.prototype.convertTo = function convertTo (num) {
		    return this.imod(num.ushln(this.shift));
		  };

		  Mont.prototype.convertFrom = function convertFrom (num) {
		    var r = this.imod(num.mul(this.rinv));
		    r.red = null;
		    return r;
		  };

		  Mont.prototype.imul = function imul (a, b) {
		    if (a.isZero() || b.isZero()) {
		      a.words[0] = 0;
		      a.length = 1;
		      return a;
		    }

		    var t = a.imul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;

		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.mul = function mul (a, b) {
		    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

		    var t = a.mul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;
		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.invm = function invm (a) {
		    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
		    var res = this.imod(a._invmp(this.m).mul(this.r2));
		    return res._forceRed(this);
		  };
		})(module, bn); 
	} (bn$1));
	return bn$1.exports;
}

var asn1$1 = {};

var asn1 = {};

var api = {};

var hasRequiredApi;

function requireApi () {
	if (hasRequiredApi) return api;
	hasRequiredApi = 1;
	(function (exports) {
		var asn1 = requireAsn1$1();
		var inherits = requireInherits_browser();

		var api = exports;

		api.define = function define(name, body) {
		  return new Entity(name, body);
		};

		function Entity(name, body) {
		  this.name = name;
		  this.body = body;

		  this.decoders = {};
		  this.encoders = {};
		}
		Entity.prototype._createNamed = function createNamed(base) {
		  var named;
		  try {
		    named = require('vm').runInThisContext(
		      '(function ' + this.name + '(entity) {\n' +
		      '  this._initNamed(entity);\n' +
		      '})'
		    );
		  } catch (e) {
		    named = function (entity) {
		      this._initNamed(entity);
		    };
		  }
		  inherits(named, base);
		  named.prototype._initNamed = function initnamed(entity) {
		    base.call(this, entity);
		  };

		  return new named(this);
		};

		Entity.prototype._getDecoder = function _getDecoder(enc) {
		  enc = enc || 'der';
		  // Lazily create decoder
		  if (!this.decoders.hasOwnProperty(enc))
		    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
		  return this.decoders[enc];
		};

		Entity.prototype.decode = function decode(data, enc, options) {
		  return this._getDecoder(enc).decode(data, options);
		};

		Entity.prototype._getEncoder = function _getEncoder(enc) {
		  enc = enc || 'der';
		  // Lazily create encoder
		  if (!this.encoders.hasOwnProperty(enc))
		    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
		  return this.encoders[enc];
		};

		Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
		  return this._getEncoder(enc).encode(data, reporter);
		}; 
	} (api));
	return api;
}

var base = {};

var reporter = {};

var hasRequiredReporter;

function requireReporter () {
	if (hasRequiredReporter) return reporter;
	hasRequiredReporter = 1;
	var inherits = requireInherits_browser();

	function Reporter(options) {
	  this._reporterState = {
	    obj: null,
	    path: [],
	    options: options || {},
	    errors: []
	  };
	}
	reporter.Reporter = Reporter;

	Reporter.prototype.isError = function isError(obj) {
	  return obj instanceof ReporterError;
	};

	Reporter.prototype.save = function save() {
	  var state = this._reporterState;

	  return { obj: state.obj, pathLen: state.path.length };
	};

	Reporter.prototype.restore = function restore(data) {
	  var state = this._reporterState;

	  state.obj = data.obj;
	  state.path = state.path.slice(0, data.pathLen);
	};

	Reporter.prototype.enterKey = function enterKey(key) {
	  return this._reporterState.path.push(key);
	};

	Reporter.prototype.exitKey = function exitKey(index) {
	  var state = this._reporterState;

	  state.path = state.path.slice(0, index - 1);
	};

	Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
	  var state = this._reporterState;

	  this.exitKey(index);
	  if (state.obj !== null)
	    state.obj[key] = value;
	};

	Reporter.prototype.path = function path() {
	  return this._reporterState.path.join('/');
	};

	Reporter.prototype.enterObject = function enterObject() {
	  var state = this._reporterState;

	  var prev = state.obj;
	  state.obj = {};
	  return prev;
	};

	Reporter.prototype.leaveObject = function leaveObject(prev) {
	  var state = this._reporterState;

	  var now = state.obj;
	  state.obj = prev;
	  return now;
	};

	Reporter.prototype.error = function error(msg) {
	  var err;
	  var state = this._reporterState;

	  var inherited = msg instanceof ReporterError;
	  if (inherited) {
	    err = msg;
	  } else {
	    err = new ReporterError(state.path.map(function(elem) {
	      return '[' + JSON.stringify(elem) + ']';
	    }).join(''), msg.message || msg, msg.stack);
	  }

	  if (!state.options.partial)
	    throw err;

	  if (!inherited)
	    state.errors.push(err);

	  return err;
	};

	Reporter.prototype.wrapResult = function wrapResult(result) {
	  var state = this._reporterState;
	  if (!state.options.partial)
	    return result;

	  return {
	    result: this.isError(result) ? null : result,
	    errors: state.errors
	  };
	};

	function ReporterError(path, msg) {
	  this.path = path;
	  this.rethrow(msg);
	}	inherits(ReporterError, Error);

	ReporterError.prototype.rethrow = function rethrow(msg) {
	  this.message = msg + ' at: ' + (this.path || '(shallow)');
	  if (Error.captureStackTrace)
	    Error.captureStackTrace(this, ReporterError);

	  if (!this.stack) {
	    try {
	      // IE only adds stack when thrown
	      throw new Error(this.message);
	    } catch (e) {
	      this.stack = e.stack;
	    }
	  }
	  return this;
	};
	return reporter;
}

var buffer = {};

var hasRequiredBuffer;

function requireBuffer () {
	if (hasRequiredBuffer) return buffer;
	hasRequiredBuffer = 1;
	var inherits = requireInherits_browser();
	var Reporter = requireBase().Reporter;
	var Buffer = requireBuffer$1().Buffer;

	function DecoderBuffer(base, options) {
	  Reporter.call(this, options);
	  if (!Buffer.isBuffer(base)) {
	    this.error('Input not Buffer');
	    return;
	  }

	  this.base = base;
	  this.offset = 0;
	  this.length = base.length;
	}
	inherits(DecoderBuffer, Reporter);
	buffer.DecoderBuffer = DecoderBuffer;

	DecoderBuffer.prototype.save = function save() {
	  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
	};

	DecoderBuffer.prototype.restore = function restore(save) {
	  // Return skipped data
	  var res = new DecoderBuffer(this.base);
	  res.offset = save.offset;
	  res.length = this.offset;

	  this.offset = save.offset;
	  Reporter.prototype.restore.call(this, save.reporter);

	  return res;
	};

	DecoderBuffer.prototype.isEmpty = function isEmpty() {
	  return this.offset === this.length;
	};

	DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
	  if (this.offset + 1 <= this.length)
	    return this.base.readUInt8(this.offset++, true);
	  else
	    return this.error(fail || 'DecoderBuffer overrun');
	};

	DecoderBuffer.prototype.skip = function skip(bytes, fail) {
	  if (!(this.offset + bytes <= this.length))
	    return this.error(fail || 'DecoderBuffer overrun');

	  var res = new DecoderBuffer(this.base);

	  // Share reporter state
	  res._reporterState = this._reporterState;

	  res.offset = this.offset;
	  res.length = this.offset + bytes;
	  this.offset += bytes;
	  return res;
	};

	DecoderBuffer.prototype.raw = function raw(save) {
	  return this.base.slice(save ? save.offset : this.offset, this.length);
	};

	function EncoderBuffer(value, reporter) {
	  if (Array.isArray(value)) {
	    this.length = 0;
	    this.value = value.map(function(item) {
	      if (!(item instanceof EncoderBuffer))
	        item = new EncoderBuffer(item, reporter);
	      this.length += item.length;
	      return item;
	    }, this);
	  } else if (typeof value === 'number') {
	    if (!(0 <= value && value <= 0xff))
	      return reporter.error('non-byte EncoderBuffer value');
	    this.value = value;
	    this.length = 1;
	  } else if (typeof value === 'string') {
	    this.value = value;
	    this.length = Buffer.byteLength(value);
	  } else if (Buffer.isBuffer(value)) {
	    this.value = value;
	    this.length = value.length;
	  } else {
	    return reporter.error('Unsupported type: ' + typeof value);
	  }
	}
	buffer.EncoderBuffer = EncoderBuffer;

	EncoderBuffer.prototype.join = function join(out, offset) {
	  if (!out)
	    out = new Buffer(this.length);
	  if (!offset)
	    offset = 0;

	  if (this.length === 0)
	    return out;

	  if (Array.isArray(this.value)) {
	    this.value.forEach(function(item) {
	      item.join(out, offset);
	      offset += item.length;
	    });
	  } else {
	    if (typeof this.value === 'number')
	      out[offset] = this.value;
	    else if (typeof this.value === 'string')
	      out.write(this.value, offset);
	    else if (Buffer.isBuffer(this.value))
	      this.value.copy(out, offset);
	    offset += this.length;
	  }

	  return out;
	};
	return buffer;
}

var node;
var hasRequiredNode;

function requireNode () {
	if (hasRequiredNode) return node;
	hasRequiredNode = 1;
	var Reporter = requireBase().Reporter;
	var EncoderBuffer = requireBase().EncoderBuffer;
	var DecoderBuffer = requireBase().DecoderBuffer;
	var assert = requireMinimalisticAssert();

	// Supported tags
	var tags = [
	  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
	  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
	  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
	  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
	];

	// Public methods list
	var methods = [
	  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
	  'any', 'contains'
	].concat(tags);

	// Overrided methods list
	var overrided = [
	  '_peekTag', '_decodeTag', '_use',
	  '_decodeStr', '_decodeObjid', '_decodeTime',
	  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

	  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
	  '_encodeNull', '_encodeInt', '_encodeBool'
	];

	function Node(enc, parent) {
	  var state = {};
	  this._baseState = state;

	  state.enc = enc;

	  state.parent = parent || null;
	  state.children = null;

	  // State
	  state.tag = null;
	  state.args = null;
	  state.reverseArgs = null;
	  state.choice = null;
	  state.optional = false;
	  state.any = false;
	  state.obj = false;
	  state.use = null;
	  state.useDecoder = null;
	  state.key = null;
	  state['default'] = null;
	  state.explicit = null;
	  state.implicit = null;
	  state.contains = null;

	  // Should create new instance on each method
	  if (!state.parent) {
	    state.children = [];
	    this._wrap();
	  }
	}
	node = Node;

	var stateProps = [
	  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
	  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
	  'implicit', 'contains'
	];

	Node.prototype.clone = function clone() {
	  var state = this._baseState;
	  var cstate = {};
	  stateProps.forEach(function(prop) {
	    cstate[prop] = state[prop];
	  });
	  var res = new this.constructor(cstate.parent);
	  res._baseState = cstate;
	  return res;
	};

	Node.prototype._wrap = function wrap() {
	  var state = this._baseState;
	  methods.forEach(function(method) {
	    this[method] = function _wrappedMethod() {
	      var clone = new this.constructor(this);
	      state.children.push(clone);
	      return clone[method].apply(clone, arguments);
	    };
	  }, this);
	};

	Node.prototype._init = function init(body) {
	  var state = this._baseState;

	  assert(state.parent === null);
	  body.call(this);

	  // Filter children
	  state.children = state.children.filter(function(child) {
	    return child._baseState.parent === this;
	  }, this);
	  assert.equal(state.children.length, 1, 'Root node can have only one child');
	};

	Node.prototype._useArgs = function useArgs(args) {
	  var state = this._baseState;

	  // Filter children and args
	  var children = args.filter(function(arg) {
	    return arg instanceof this.constructor;
	  }, this);
	  args = args.filter(function(arg) {
	    return !(arg instanceof this.constructor);
	  }, this);

	  if (children.length !== 0) {
	    assert(state.children === null);
	    state.children = children;

	    // Replace parent to maintain backward link
	    children.forEach(function(child) {
	      child._baseState.parent = this;
	    }, this);
	  }
	  if (args.length !== 0) {
	    assert(state.args === null);
	    state.args = args;
	    state.reverseArgs = args.map(function(arg) {
	      if (typeof arg !== 'object' || arg.constructor !== Object)
	        return arg;

	      var res = {};
	      Object.keys(arg).forEach(function(key) {
	        if (key == (key | 0))
	          key |= 0;
	        var value = arg[key];
	        res[value] = key;
	      });
	      return res;
	    });
	  }
	};

	//
	// Overrided methods
	//

	overrided.forEach(function(method) {
	  Node.prototype[method] = function _overrided() {
	    var state = this._baseState;
	    throw new Error(method + ' not implemented for encoding: ' + state.enc);
	  };
	});

	//
	// Public methods
	//

	tags.forEach(function(tag) {
	  Node.prototype[tag] = function _tagMethod() {
	    var state = this._baseState;
	    var args = Array.prototype.slice.call(arguments);

	    assert(state.tag === null);
	    state.tag = tag;

	    this._useArgs(args);

	    return this;
	  };
	});

	Node.prototype.use = function use(item) {
	  assert(item);
	  var state = this._baseState;

	  assert(state.use === null);
	  state.use = item;

	  return this;
	};

	Node.prototype.optional = function optional() {
	  var state = this._baseState;

	  state.optional = true;

	  return this;
	};

	Node.prototype.def = function def(val) {
	  var state = this._baseState;

	  assert(state['default'] === null);
	  state['default'] = val;
	  state.optional = true;

	  return this;
	};

	Node.prototype.explicit = function explicit(num) {
	  var state = this._baseState;

	  assert(state.explicit === null && state.implicit === null);
	  state.explicit = num;

	  return this;
	};

	Node.prototype.implicit = function implicit(num) {
	  var state = this._baseState;

	  assert(state.explicit === null && state.implicit === null);
	  state.implicit = num;

	  return this;
	};

	Node.prototype.obj = function obj() {
	  var state = this._baseState;
	  var args = Array.prototype.slice.call(arguments);

	  state.obj = true;

	  if (args.length !== 0)
	    this._useArgs(args);

	  return this;
	};

	Node.prototype.key = function key(newKey) {
	  var state = this._baseState;

	  assert(state.key === null);
	  state.key = newKey;

	  return this;
	};

	Node.prototype.any = function any() {
	  var state = this._baseState;

	  state.any = true;

	  return this;
	};

	Node.prototype.choice = function choice(obj) {
	  var state = this._baseState;

	  assert(state.choice === null);
	  state.choice = obj;
	  this._useArgs(Object.keys(obj).map(function(key) {
	    return obj[key];
	  }));

	  return this;
	};

	Node.prototype.contains = function contains(item) {
	  var state = this._baseState;

	  assert(state.use === null);
	  state.contains = item;

	  return this;
	};

	//
	// Decoding
	//

	Node.prototype._decode = function decode(input, options) {
	  var state = this._baseState;

	  // Decode root node
	  if (state.parent === null)
	    return input.wrapResult(state.children[0]._decode(input, options));

	  var result = state['default'];
	  var present = true;

	  var prevKey = null;
	  if (state.key !== null)
	    prevKey = input.enterKey(state.key);

	  // Check if tag is there
	  if (state.optional) {
	    var tag = null;
	    if (state.explicit !== null)
	      tag = state.explicit;
	    else if (state.implicit !== null)
	      tag = state.implicit;
	    else if (state.tag !== null)
	      tag = state.tag;

	    if (tag === null && !state.any) {
	      // Trial and Error
	      var save = input.save();
	      try {
	        if (state.choice === null)
	          this._decodeGeneric(state.tag, input, options);
	        else
	          this._decodeChoice(input, options);
	        present = true;
	      } catch (e) {
	        present = false;
	      }
	      input.restore(save);
	    } else {
	      present = this._peekTag(input, tag, state.any);

	      if (input.isError(present))
	        return present;
	    }
	  }

	  // Push object on stack
	  var prevObj;
	  if (state.obj && present)
	    prevObj = input.enterObject();

	  if (present) {
	    // Unwrap explicit values
	    if (state.explicit !== null) {
	      var explicit = this._decodeTag(input, state.explicit);
	      if (input.isError(explicit))
	        return explicit;
	      input = explicit;
	    }

	    var start = input.offset;

	    // Unwrap implicit and normal values
	    if (state.use === null && state.choice === null) {
	      if (state.any)
	        var save = input.save();
	      var body = this._decodeTag(
	        input,
	        state.implicit !== null ? state.implicit : state.tag,
	        state.any
	      );
	      if (input.isError(body))
	        return body;

	      if (state.any)
	        result = input.raw(save);
	      else
	        input = body;
	    }

	    if (options && options.track && state.tag !== null)
	      options.track(input.path(), start, input.length, 'tagged');

	    if (options && options.track && state.tag !== null)
	      options.track(input.path(), input.offset, input.length, 'content');

	    // Select proper method for tag
	    if (state.any)
	      result = result;
	    else if (state.choice === null)
	      result = this._decodeGeneric(state.tag, input, options);
	    else
	      result = this._decodeChoice(input, options);

	    if (input.isError(result))
	      return result;

	    // Decode children
	    if (!state.any && state.choice === null && state.children !== null) {
	      state.children.forEach(function decodeChildren(child) {
	        // NOTE: We are ignoring errors here, to let parser continue with other
	        // parts of encoded data
	        child._decode(input, options);
	      });
	    }

	    // Decode contained/encoded by schema, only in bit or octet strings
	    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
	      var data = new DecoderBuffer(result);
	      result = this._getUse(state.contains, input._reporterState.obj)
	          ._decode(data, options);
	    }
	  }

	  // Pop object
	  if (state.obj && present)
	    result = input.leaveObject(prevObj);

	  // Set key
	  if (state.key !== null && (result !== null || present === true))
	    input.leaveKey(prevKey, state.key, result);
	  else if (prevKey !== null)
	    input.exitKey(prevKey);

	  return result;
	};

	Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
	  var state = this._baseState;

	  if (tag === 'seq' || tag === 'set')
	    return null;
	  if (tag === 'seqof' || tag === 'setof')
	    return this._decodeList(input, tag, state.args[0], options);
	  else if (/str$/.test(tag))
	    return this._decodeStr(input, tag, options);
	  else if (tag === 'objid' && state.args)
	    return this._decodeObjid(input, state.args[0], state.args[1], options);
	  else if (tag === 'objid')
	    return this._decodeObjid(input, null, null, options);
	  else if (tag === 'gentime' || tag === 'utctime')
	    return this._decodeTime(input, tag, options);
	  else if (tag === 'null_')
	    return this._decodeNull(input, options);
	  else if (tag === 'bool')
	    return this._decodeBool(input, options);
	  else if (tag === 'objDesc')
	    return this._decodeStr(input, tag, options);
	  else if (tag === 'int' || tag === 'enum')
	    return this._decodeInt(input, state.args && state.args[0], options);

	  if (state.use !== null) {
	    return this._getUse(state.use, input._reporterState.obj)
	        ._decode(input, options);
	  } else {
	    return input.error('unknown tag: ' + tag);
	  }
	};

	Node.prototype._getUse = function _getUse(entity, obj) {

	  var state = this._baseState;
	  // Create altered use decoder if implicit is set
	  state.useDecoder = this._use(entity, obj);
	  assert(state.useDecoder._baseState.parent === null);
	  state.useDecoder = state.useDecoder._baseState.children[0];
	  if (state.implicit !== state.useDecoder._baseState.implicit) {
	    state.useDecoder = state.useDecoder.clone();
	    state.useDecoder._baseState.implicit = state.implicit;
	  }
	  return state.useDecoder;
	};

	Node.prototype._decodeChoice = function decodeChoice(input, options) {
	  var state = this._baseState;
	  var result = null;
	  var match = false;

	  Object.keys(state.choice).some(function(key) {
	    var save = input.save();
	    var node = state.choice[key];
	    try {
	      var value = node._decode(input, options);
	      if (input.isError(value))
	        return false;

	      result = { type: key, value: value };
	      match = true;
	    } catch (e) {
	      input.restore(save);
	      return false;
	    }
	    return true;
	  }, this);

	  if (!match)
	    return input.error('Choice not matched');

	  return result;
	};

	//
	// Encoding
	//

	Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
	  return new EncoderBuffer(data, this.reporter);
	};

	Node.prototype._encode = function encode(data, reporter, parent) {
	  var state = this._baseState;
	  if (state['default'] !== null && state['default'] === data)
	    return;

	  var result = this._encodeValue(data, reporter, parent);
	  if (result === undefined)
	    return;

	  if (this._skipDefault(result, reporter, parent))
	    return;

	  return result;
	};

	Node.prototype._encodeValue = function encode(data, reporter, parent) {
	  var state = this._baseState;

	  // Decode root node
	  if (state.parent === null)
	    return state.children[0]._encode(data, reporter || new Reporter());

	  var result = null;

	  // Set reporter to share it with a child class
	  this.reporter = reporter;

	  // Check if data is there
	  if (state.optional && data === undefined) {
	    if (state['default'] !== null)
	      data = state['default'];
	    else
	      return;
	  }

	  // Encode children first
	  var content = null;
	  var primitive = false;
	  if (state.any) {
	    // Anything that was given is translated to buffer
	    result = this._createEncoderBuffer(data);
	  } else if (state.choice) {
	    result = this._encodeChoice(data, reporter);
	  } else if (state.contains) {
	    content = this._getUse(state.contains, parent)._encode(data, reporter);
	    primitive = true;
	  } else if (state.children) {
	    content = state.children.map(function(child) {
	      if (child._baseState.tag === 'null_')
	        return child._encode(null, reporter, data);

	      if (child._baseState.key === null)
	        return reporter.error('Child should have a key');
	      var prevKey = reporter.enterKey(child._baseState.key);

	      if (typeof data !== 'object')
	        return reporter.error('Child expected, but input is not object');

	      var res = child._encode(data[child._baseState.key], reporter, data);
	      reporter.leaveKey(prevKey);

	      return res;
	    }, this).filter(function(child) {
	      return child;
	    });
	    content = this._createEncoderBuffer(content);
	  } else {
	    if (state.tag === 'seqof' || state.tag === 'setof') {
	      // TODO(indutny): this should be thrown on DSL level
	      if (!(state.args && state.args.length === 1))
	        return reporter.error('Too many args for : ' + state.tag);

	      if (!Array.isArray(data))
	        return reporter.error('seqof/setof, but data is not Array');

	      var child = this.clone();
	      child._baseState.implicit = null;
	      content = this._createEncoderBuffer(data.map(function(item) {
	        var state = this._baseState;

	        return this._getUse(state.args[0], data)._encode(item, reporter);
	      }, child));
	    } else if (state.use !== null) {
	      result = this._getUse(state.use, parent)._encode(data, reporter);
	    } else {
	      content = this._encodePrimitive(state.tag, data);
	      primitive = true;
	    }
	  }

	  // Encode data itself
	  var result;
	  if (!state.any && state.choice === null) {
	    var tag = state.implicit !== null ? state.implicit : state.tag;
	    var cls = state.implicit === null ? 'universal' : 'context';

	    if (tag === null) {
	      if (state.use === null)
	        reporter.error('Tag could be omitted only for .use()');
	    } else {
	      if (state.use === null)
	        result = this._encodeComposite(tag, primitive, cls, content);
	    }
	  }

	  // Wrap in explicit
	  if (state.explicit !== null)
	    result = this._encodeComposite(state.explicit, false, 'context', result);

	  return result;
	};

	Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
	  var state = this._baseState;

	  var node = state.choice[data.type];
	  if (!node) {
	    assert(
	        false,
	        data.type + ' not found in ' +
	            JSON.stringify(Object.keys(state.choice)));
	  }
	  return node._encode(data.value, reporter);
	};

	Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
	  var state = this._baseState;

	  if (/str$/.test(tag))
	    return this._encodeStr(data, tag);
	  else if (tag === 'objid' && state.args)
	    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
	  else if (tag === 'objid')
	    return this._encodeObjid(data, null, null);
	  else if (tag === 'gentime' || tag === 'utctime')
	    return this._encodeTime(data, tag);
	  else if (tag === 'null_')
	    return this._encodeNull();
	  else if (tag === 'int' || tag === 'enum')
	    return this._encodeInt(data, state.args && state.reverseArgs[0]);
	  else if (tag === 'bool')
	    return this._encodeBool(data);
	  else if (tag === 'objDesc')
	    return this._encodeStr(data, tag);
	  else
	    throw new Error('Unsupported tag: ' + tag);
	};

	Node.prototype._isNumstr = function isNumstr(str) {
	  return /^[0-9 ]*$/.test(str);
	};

	Node.prototype._isPrintstr = function isPrintstr(str) {
	  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
	};
	return node;
}

var hasRequiredBase;

function requireBase () {
	if (hasRequiredBase) return base;
	hasRequiredBase = 1;
	(function (exports) {
		var base = exports;

		base.Reporter = requireReporter().Reporter;
		base.DecoderBuffer = requireBuffer().DecoderBuffer;
		base.EncoderBuffer = requireBuffer().EncoderBuffer;
		base.Node = requireNode(); 
	} (base));
	return base;
}

var constants = {};

var der = {};

var hasRequiredDer$2;

function requireDer$2 () {
	if (hasRequiredDer$2) return der;
	hasRequiredDer$2 = 1;
	(function (exports) {
		var constants = requireConstants();

		exports.tagClass = {
		  0: 'universal',
		  1: 'application',
		  2: 'context',
		  3: 'private'
		};
		exports.tagClassByName = constants._reverse(exports.tagClass);

		exports.tag = {
		  0x00: 'end',
		  0x01: 'bool',
		  0x02: 'int',
		  0x03: 'bitstr',
		  0x04: 'octstr',
		  0x05: 'null_',
		  0x06: 'objid',
		  0x07: 'objDesc',
		  0x08: 'external',
		  0x09: 'real',
		  0x0a: 'enum',
		  0x0b: 'embed',
		  0x0c: 'utf8str',
		  0x0d: 'relativeOid',
		  0x10: 'seq',
		  0x11: 'set',
		  0x12: 'numstr',
		  0x13: 'printstr',
		  0x14: 't61str',
		  0x15: 'videostr',
		  0x16: 'ia5str',
		  0x17: 'utctime',
		  0x18: 'gentime',
		  0x19: 'graphstr',
		  0x1a: 'iso646str',
		  0x1b: 'genstr',
		  0x1c: 'unistr',
		  0x1d: 'charstr',
		  0x1e: 'bmpstr'
		};
		exports.tagByName = constants._reverse(exports.tag); 
	} (der));
	return der;
}

var hasRequiredConstants;

function requireConstants () {
	if (hasRequiredConstants) return constants;
	hasRequiredConstants = 1;
	(function (exports) {
		var constants = exports;

		// Helper
		constants._reverse = function reverse(map) {
		  var res = {};

		  Object.keys(map).forEach(function(key) {
		    // Convert key to integer if it is stringified
		    if ((key | 0) == key)
		      key = key | 0;

		    var value = map[key];
		    res[value] = key;
		  });

		  return res;
		};

		constants.der = requireDer$2(); 
	} (constants));
	return constants;
}

var decoders = {};

var der_1$1;
var hasRequiredDer$1;

function requireDer$1 () {
	if (hasRequiredDer$1) return der_1$1;
	hasRequiredDer$1 = 1;
	var inherits = requireInherits_browser();

	var asn1 = requireAsn1$1();
	var base = asn1.base;
	var bignum = asn1.bignum;

	// Import DER constants
	var der = asn1.constants.der;

	function DERDecoder(entity) {
	  this.enc = 'der';
	  this.name = entity.name;
	  this.entity = entity;

	  // Construct base tree
	  this.tree = new DERNode();
	  this.tree._init(entity.body);
	}	der_1$1 = DERDecoder;

	DERDecoder.prototype.decode = function decode(data, options) {
	  if (!(data instanceof base.DecoderBuffer))
	    data = new base.DecoderBuffer(data, options);

	  return this.tree._decode(data, options);
	};

	// Tree methods

	function DERNode(parent) {
	  base.Node.call(this, 'der', parent);
	}
	inherits(DERNode, base.Node);

	DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
	  if (buffer.isEmpty())
	    return false;

	  var state = buffer.save();
	  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
	  if (buffer.isError(decodedTag))
	    return decodedTag;

	  buffer.restore(state);

	  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
	    (decodedTag.tagStr + 'of') === tag || any;
	};

	DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
	  var decodedTag = derDecodeTag(buffer,
	                                'Failed to decode tag of "' + tag + '"');
	  if (buffer.isError(decodedTag))
	    return decodedTag;

	  var len = derDecodeLen(buffer,
	                         decodedTag.primitive,
	                         'Failed to get length of "' + tag + '"');

	  // Failure
	  if (buffer.isError(len))
	    return len;

	  if (!any &&
	      decodedTag.tag !== tag &&
	      decodedTag.tagStr !== tag &&
	      decodedTag.tagStr + 'of' !== tag) {
	    return buffer.error('Failed to match tag: "' + tag + '"');
	  }

	  if (decodedTag.primitive || len !== null)
	    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

	  // Indefinite length... find END tag
	  var state = buffer.save();
	  var res = this._skipUntilEnd(
	      buffer,
	      'Failed to skip indefinite length body: "' + this.tag + '"');
	  if (buffer.isError(res))
	    return res;

	  len = buffer.offset - state.offset;
	  buffer.restore(state);
	  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
	};

	DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
	  while (true) {
	    var tag = derDecodeTag(buffer, fail);
	    if (buffer.isError(tag))
	      return tag;
	    var len = derDecodeLen(buffer, tag.primitive, fail);
	    if (buffer.isError(len))
	      return len;

	    var res;
	    if (tag.primitive || len !== null)
	      res = buffer.skip(len);
	    else
	      res = this._skipUntilEnd(buffer, fail);

	    // Failure
	    if (buffer.isError(res))
	      return res;

	    if (tag.tagStr === 'end')
	      break;
	  }
	};

	DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
	                                                    options) {
	  var result = [];
	  while (!buffer.isEmpty()) {
	    var possibleEnd = this._peekTag(buffer, 'end');
	    if (buffer.isError(possibleEnd))
	      return possibleEnd;

	    var res = decoder.decode(buffer, 'der', options);
	    if (buffer.isError(res) && possibleEnd)
	      break;
	    result.push(res);
	  }
	  return result;
	};

	DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
	  if (tag === 'bitstr') {
	    var unused = buffer.readUInt8();
	    if (buffer.isError(unused))
	      return unused;
	    return { unused: unused, data: buffer.raw() };
	  } else if (tag === 'bmpstr') {
	    var raw = buffer.raw();
	    if (raw.length % 2 === 1)
	      return buffer.error('Decoding of string type: bmpstr length mismatch');

	    var str = '';
	    for (var i = 0; i < raw.length / 2; i++) {
	      str += String.fromCharCode(raw.readUInt16BE(i * 2));
	    }
	    return str;
	  } else if (tag === 'numstr') {
	    var numstr = buffer.raw().toString('ascii');
	    if (!this._isNumstr(numstr)) {
	      return buffer.error('Decoding of string type: ' +
	                          'numstr unsupported characters');
	    }
	    return numstr;
	  } else if (tag === 'octstr') {
	    return buffer.raw();
	  } else if (tag === 'objDesc') {
	    return buffer.raw();
	  } else if (tag === 'printstr') {
	    var printstr = buffer.raw().toString('ascii');
	    if (!this._isPrintstr(printstr)) {
	      return buffer.error('Decoding of string type: ' +
	                          'printstr unsupported characters');
	    }
	    return printstr;
	  } else if (/str$/.test(tag)) {
	    return buffer.raw().toString();
	  } else {
	    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
	  }
	};

	DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
	  var result;
	  var identifiers = [];
	  var ident = 0;
	  while (!buffer.isEmpty()) {
	    var subident = buffer.readUInt8();
	    ident <<= 7;
	    ident |= subident & 0x7f;
	    if ((subident & 0x80) === 0) {
	      identifiers.push(ident);
	      ident = 0;
	    }
	  }
	  if (subident & 0x80)
	    identifiers.push(ident);

	  var first = (identifiers[0] / 40) | 0;
	  var second = identifiers[0] % 40;

	  if (relative)
	    result = identifiers;
	  else
	    result = [first, second].concat(identifiers.slice(1));

	  if (values) {
	    var tmp = values[result.join(' ')];
	    if (tmp === undefined)
	      tmp = values[result.join('.')];
	    if (tmp !== undefined)
	      result = tmp;
	  }

	  return result;
	};

	DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
	  var str = buffer.raw().toString();
	  if (tag === 'gentime') {
	    var year = str.slice(0, 4) | 0;
	    var mon = str.slice(4, 6) | 0;
	    var day = str.slice(6, 8) | 0;
	    var hour = str.slice(8, 10) | 0;
	    var min = str.slice(10, 12) | 0;
	    var sec = str.slice(12, 14) | 0;
	  } else if (tag === 'utctime') {
	    var year = str.slice(0, 2) | 0;
	    var mon = str.slice(2, 4) | 0;
	    var day = str.slice(4, 6) | 0;
	    var hour = str.slice(6, 8) | 0;
	    var min = str.slice(8, 10) | 0;
	    var sec = str.slice(10, 12) | 0;
	    if (year < 70)
	      year = 2000 + year;
	    else
	      year = 1900 + year;
	  } else {
	    return buffer.error('Decoding ' + tag + ' time is not supported yet');
	  }

	  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
	};

	DERNode.prototype._decodeNull = function decodeNull(buffer) {
	  return null;
	};

	DERNode.prototype._decodeBool = function decodeBool(buffer) {
	  var res = buffer.readUInt8();
	  if (buffer.isError(res))
	    return res;
	  else
	    return res !== 0;
	};

	DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
	  // Bigint, return as it is (assume big endian)
	  var raw = buffer.raw();
	  var res = new bignum(raw);

	  if (values)
	    res = values[res.toString(10)] || res;

	  return res;
	};

	DERNode.prototype._use = function use(entity, obj) {
	  if (typeof entity === 'function')
	    entity = entity(obj);
	  return entity._getDecoder('der').tree;
	};

	// Utility methods

	function derDecodeTag(buf, fail) {
	  var tag = buf.readUInt8(fail);
	  if (buf.isError(tag))
	    return tag;

	  var cls = der.tagClass[tag >> 6];
	  var primitive = (tag & 0x20) === 0;

	  // Multi-octet tag - load
	  if ((tag & 0x1f) === 0x1f) {
	    var oct = tag;
	    tag = 0;
	    while ((oct & 0x80) === 0x80) {
	      oct = buf.readUInt8(fail);
	      if (buf.isError(oct))
	        return oct;

	      tag <<= 7;
	      tag |= oct & 0x7f;
	    }
	  } else {
	    tag &= 0x1f;
	  }
	  var tagStr = der.tag[tag];

	  return {
	    cls: cls,
	    primitive: primitive,
	    tag: tag,
	    tagStr: tagStr
	  };
	}

	function derDecodeLen(buf, primitive, fail) {
	  var len = buf.readUInt8(fail);
	  if (buf.isError(len))
	    return len;

	  // Indefinite form
	  if (!primitive && len === 0x80)
	    return null;

	  // Definite form
	  if ((len & 0x80) === 0) {
	    // Short form
	    return len;
	  }

	  // Long form
	  var num = len & 0x7f;
	  if (num > 4)
	    return buf.error('length octect is too long');

	  len = 0;
	  for (var i = 0; i < num; i++) {
	    len <<= 8;
	    var j = buf.readUInt8(fail);
	    if (buf.isError(j))
	      return j;
	    len |= j;
	  }

	  return len;
	}
	return der_1$1;
}

var pem$1;
var hasRequiredPem$1;

function requirePem$1 () {
	if (hasRequiredPem$1) return pem$1;
	hasRequiredPem$1 = 1;
	var inherits = requireInherits_browser();
	var Buffer = requireBuffer$1().Buffer;

	var DERDecoder = requireDer$1();

	function PEMDecoder(entity) {
	  DERDecoder.call(this, entity);
	  this.enc = 'pem';
	}	inherits(PEMDecoder, DERDecoder);
	pem$1 = PEMDecoder;

	PEMDecoder.prototype.decode = function decode(data, options) {
	  var lines = data.toString().split(/[\r\n]+/g);

	  var label = options.label.toUpperCase();

	  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
	  var start = -1;
	  var end = -1;
	  for (var i = 0; i < lines.length; i++) {
	    var match = lines[i].match(re);
	    if (match === null)
	      continue;

	    if (match[2] !== label)
	      continue;

	    if (start === -1) {
	      if (match[1] !== 'BEGIN')
	        break;
	      start = i;
	    } else {
	      if (match[1] !== 'END')
	        break;
	      end = i;
	      break;
	    }
	  }
	  if (start === -1 || end === -1)
	    throw new Error('PEM section not found for: ' + label);

	  var base64 = lines.slice(start + 1, end).join('');
	  // Remove excessive symbols
	  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

	  var input = new Buffer(base64, 'base64');
	  return DERDecoder.prototype.decode.call(this, input, options);
	};
	return pem$1;
}

var hasRequiredDecoders;

function requireDecoders () {
	if (hasRequiredDecoders) return decoders;
	hasRequiredDecoders = 1;
	(function (exports) {
		var decoders = exports;

		decoders.der = requireDer$1();
		decoders.pem = requirePem$1(); 
	} (decoders));
	return decoders;
}

var encoders = {};

var der_1;
var hasRequiredDer;

function requireDer () {
	if (hasRequiredDer) return der_1;
	hasRequiredDer = 1;
	var inherits = requireInherits_browser();
	var Buffer = requireBuffer$1().Buffer;

	var asn1 = requireAsn1$1();
	var base = asn1.base;

	// Import DER constants
	var der = asn1.constants.der;

	function DEREncoder(entity) {
	  this.enc = 'der';
	  this.name = entity.name;
	  this.entity = entity;

	  // Construct base tree
	  this.tree = new DERNode();
	  this.tree._init(entity.body);
	}	der_1 = DEREncoder;

	DEREncoder.prototype.encode = function encode(data, reporter) {
	  return this.tree._encode(data, reporter).join();
	};

	// Tree methods

	function DERNode(parent) {
	  base.Node.call(this, 'der', parent);
	}
	inherits(DERNode, base.Node);

	DERNode.prototype._encodeComposite = function encodeComposite(tag,
	                                                              primitive,
	                                                              cls,
	                                                              content) {
	  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

	  // Short form
	  if (content.length < 0x80) {
	    var header = new Buffer(2);
	    header[0] = encodedTag;
	    header[1] = content.length;
	    return this._createEncoderBuffer([ header, content ]);
	  }

	  // Long form
	  // Count octets required to store length
	  var lenOctets = 1;
	  for (var i = content.length; i >= 0x100; i >>= 8)
	    lenOctets++;

	  var header = new Buffer(1 + 1 + lenOctets);
	  header[0] = encodedTag;
	  header[1] = 0x80 | lenOctets;

	  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
	    header[i] = j & 0xff;

	  return this._createEncoderBuffer([ header, content ]);
	};

	DERNode.prototype._encodeStr = function encodeStr(str, tag) {
	  if (tag === 'bitstr') {
	    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
	  } else if (tag === 'bmpstr') {
	    var buf = new Buffer(str.length * 2);
	    for (var i = 0; i < str.length; i++) {
	      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
	    }
	    return this._createEncoderBuffer(buf);
	  } else if (tag === 'numstr') {
	    if (!this._isNumstr(str)) {
	      return this.reporter.error('Encoding of string type: numstr supports ' +
	                                 'only digits and space');
	    }
	    return this._createEncoderBuffer(str);
	  } else if (tag === 'printstr') {
	    if (!this._isPrintstr(str)) {
	      return this.reporter.error('Encoding of string type: printstr supports ' +
	                                 'only latin upper and lower case letters, ' +
	                                 'digits, space, apostrophe, left and rigth ' +
	                                 'parenthesis, plus sign, comma, hyphen, ' +
	                                 'dot, slash, colon, equal sign, ' +
	                                 'question mark');
	    }
	    return this._createEncoderBuffer(str);
	  } else if (/str$/.test(tag)) {
	    return this._createEncoderBuffer(str);
	  } else if (tag === 'objDesc') {
	    return this._createEncoderBuffer(str);
	  } else {
	    return this.reporter.error('Encoding of string type: ' + tag +
	                               ' unsupported');
	  }
	};

	DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
	  if (typeof id === 'string') {
	    if (!values)
	      return this.reporter.error('string objid given, but no values map found');
	    if (!values.hasOwnProperty(id))
	      return this.reporter.error('objid not found in values map');
	    id = values[id].split(/[\s\.]+/g);
	    for (var i = 0; i < id.length; i++)
	      id[i] |= 0;
	  } else if (Array.isArray(id)) {
	    id = id.slice();
	    for (var i = 0; i < id.length; i++)
	      id[i] |= 0;
	  }

	  if (!Array.isArray(id)) {
	    return this.reporter.error('objid() should be either array or string, ' +
	                               'got: ' + JSON.stringify(id));
	  }

	  if (!relative) {
	    if (id[1] >= 40)
	      return this.reporter.error('Second objid identifier OOB');
	    id.splice(0, 2, id[0] * 40 + id[1]);
	  }

	  // Count number of octets
	  var size = 0;
	  for (var i = 0; i < id.length; i++) {
	    var ident = id[i];
	    for (size++; ident >= 0x80; ident >>= 7)
	      size++;
	  }

	  var objid = new Buffer(size);
	  var offset = objid.length - 1;
	  for (var i = id.length - 1; i >= 0; i--) {
	    var ident = id[i];
	    objid[offset--] = ident & 0x7f;
	    while ((ident >>= 7) > 0)
	      objid[offset--] = 0x80 | (ident & 0x7f);
	  }

	  return this._createEncoderBuffer(objid);
	};

	function two(num) {
	  if (num < 10)
	    return '0' + num;
	  else
	    return num;
	}

	DERNode.prototype._encodeTime = function encodeTime(time, tag) {
	  var str;
	  var date = new Date(time);

	  if (tag === 'gentime') {
	    str = [
	      two(date.getFullYear()),
	      two(date.getUTCMonth() + 1),
	      two(date.getUTCDate()),
	      two(date.getUTCHours()),
	      two(date.getUTCMinutes()),
	      two(date.getUTCSeconds()),
	      'Z'
	    ].join('');
	  } else if (tag === 'utctime') {
	    str = [
	      two(date.getFullYear() % 100),
	      two(date.getUTCMonth() + 1),
	      two(date.getUTCDate()),
	      two(date.getUTCHours()),
	      two(date.getUTCMinutes()),
	      two(date.getUTCSeconds()),
	      'Z'
	    ].join('');
	  } else {
	    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
	  }

	  return this._encodeStr(str, 'octstr');
	};

	DERNode.prototype._encodeNull = function encodeNull() {
	  return this._createEncoderBuffer('');
	};

	DERNode.prototype._encodeInt = function encodeInt(num, values) {
	  if (typeof num === 'string') {
	    if (!values)
	      return this.reporter.error('String int or enum given, but no values map');
	    if (!values.hasOwnProperty(num)) {
	      return this.reporter.error('Values map doesn\'t contain: ' +
	                                 JSON.stringify(num));
	    }
	    num = values[num];
	  }

	  // Bignum, assume big endian
	  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
	    var numArray = num.toArray();
	    if (!num.sign && numArray[0] & 0x80) {
	      numArray.unshift(0);
	    }
	    num = new Buffer(numArray);
	  }

	  if (Buffer.isBuffer(num)) {
	    var size = num.length;
	    if (num.length === 0)
	      size++;

	    var out = new Buffer(size);
	    num.copy(out);
	    if (num.length === 0)
	      out[0] = 0;
	    return this._createEncoderBuffer(out);
	  }

	  if (num < 0x80)
	    return this._createEncoderBuffer(num);

	  if (num < 0x100)
	    return this._createEncoderBuffer([0, num]);

	  var size = 1;
	  for (var i = num; i >= 0x100; i >>= 8)
	    size++;

	  var out = new Array(size);
	  for (var i = out.length - 1; i >= 0; i--) {
	    out[i] = num & 0xff;
	    num >>= 8;
	  }
	  if(out[0] & 0x80) {
	    out.unshift(0);
	  }

	  return this._createEncoderBuffer(new Buffer(out));
	};

	DERNode.prototype._encodeBool = function encodeBool(value) {
	  return this._createEncoderBuffer(value ? 0xff : 0);
	};

	DERNode.prototype._use = function use(entity, obj) {
	  if (typeof entity === 'function')
	    entity = entity(obj);
	  return entity._getEncoder('der').tree;
	};

	DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
	  var state = this._baseState;
	  var i;
	  if (state['default'] === null)
	    return false;

	  var data = dataBuffer.join();
	  if (state.defaultBuffer === undefined)
	    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

	  if (data.length !== state.defaultBuffer.length)
	    return false;

	  for (i=0; i < data.length; i++)
	    if (data[i] !== state.defaultBuffer[i])
	      return false;

	  return true;
	};

	// Utility methods

	function encodeTag(tag, primitive, cls, reporter) {
	  var res;

	  if (tag === 'seqof')
	    tag = 'seq';
	  else if (tag === 'setof')
	    tag = 'set';

	  if (der.tagByName.hasOwnProperty(tag))
	    res = der.tagByName[tag];
	  else if (typeof tag === 'number' && (tag | 0) === tag)
	    res = tag;
	  else
	    return reporter.error('Unknown tag: ' + tag);

	  if (res >= 0x1f)
	    return reporter.error('Multi-octet tag encoding unsupported');

	  if (!primitive)
	    res |= 0x20;

	  res |= (der.tagClassByName[cls || 'universal'] << 6);

	  return res;
	}
	return der_1;
}

var pem;
var hasRequiredPem;

function requirePem () {
	if (hasRequiredPem) return pem;
	hasRequiredPem = 1;
	var inherits = requireInherits_browser();

	var DEREncoder = requireDer();

	function PEMEncoder(entity) {
	  DEREncoder.call(this, entity);
	  this.enc = 'pem';
	}	inherits(PEMEncoder, DEREncoder);
	pem = PEMEncoder;

	PEMEncoder.prototype.encode = function encode(data, options) {
	  var buf = DEREncoder.prototype.encode.call(this, data);

	  var p = buf.toString('base64');
	  var out = [ '-----BEGIN ' + options.label + '-----' ];
	  for (var i = 0; i < p.length; i += 64)
	    out.push(p.slice(i, i + 64));
	  out.push('-----END ' + options.label + '-----');
	  return out.join('\n');
	};
	return pem;
}

var hasRequiredEncoders;

function requireEncoders () {
	if (hasRequiredEncoders) return encoders;
	hasRequiredEncoders = 1;
	(function (exports) {
		var encoders = exports;

		encoders.der = requireDer();
		encoders.pem = requirePem(); 
	} (encoders));
	return encoders;
}

var hasRequiredAsn1$1;

function requireAsn1$1 () {
	if (hasRequiredAsn1$1) return asn1;
	hasRequiredAsn1$1 = 1;
	(function (exports) {
		var asn1 = exports;

		asn1.bignum = requireBn$2();

		asn1.define = requireApi().define;
		asn1.base = requireBase();
		asn1.constants = requireConstants();
		asn1.decoders = requireDecoders();
		asn1.encoders = requireEncoders(); 
	} (asn1));
	return asn1;
}

var certificate;
var hasRequiredCertificate;

function requireCertificate () {
	if (hasRequiredCertificate) return certificate;
	hasRequiredCertificate = 1;

	var asn = requireAsn1$1();

	var Time = asn.define('Time', function () {
		this.choice({
			utcTime: this.utctime(),
			generalTime: this.gentime()
		});
	});

	var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
		this.seq().obj(
			this.key('type').objid(),
			this.key('value').any()
		);
	});

	var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
		this.seq().obj(
			this.key('algorithm').objid(),
			this.key('parameters').optional(),
			this.key('curve').objid().optional()
		);
	});

	var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
		this.seq().obj(
			this.key('algorithm').use(AlgorithmIdentifier),
			this.key('subjectPublicKey').bitstr()
		);
	});

	var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
		this.setof(AttributeTypeValue);
	});

	var RDNSequence = asn.define('RDNSequence', function () {
		this.seqof(RelativeDistinguishedName);
	});

	var Name = asn.define('Name', function () {
		this.choice({
			rdnSequence: this.use(RDNSequence)
		});
	});

	var Validity = asn.define('Validity', function () {
		this.seq().obj(
			this.key('notBefore').use(Time),
			this.key('notAfter').use(Time)
		);
	});

	var Extension = asn.define('Extension', function () {
		this.seq().obj(
			this.key('extnID').objid(),
			this.key('critical').bool().def(false),
			this.key('extnValue').octstr()
		);
	});

	var TBSCertificate = asn.define('TBSCertificate', function () {
		this.seq().obj(
			this.key('version').explicit(0)['int']().optional(),
			this.key('serialNumber')['int'](),
			this.key('signature').use(AlgorithmIdentifier),
			this.key('issuer').use(Name),
			this.key('validity').use(Validity),
			this.key('subject').use(Name),
			this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
			this.key('issuerUniqueID').implicit(1).bitstr().optional(),
			this.key('subjectUniqueID').implicit(2).bitstr().optional(),
			this.key('extensions').explicit(3).seqof(Extension).optional()
		);
	});

	var X509Certificate = asn.define('X509Certificate', function () {
		this.seq().obj(
			this.key('tbsCertificate').use(TBSCertificate),
			this.key('signatureAlgorithm').use(AlgorithmIdentifier),
			this.key('signatureValue').bitstr()
		);
	});

	certificate = X509Certificate;
	return certificate;
}

var hasRequiredAsn1;

function requireAsn1 () {
	if (hasRequiredAsn1) return asn1$1;
	hasRequiredAsn1 = 1;

	var asn1 = requireAsn1$1();

	asn1$1.certificate = requireCertificate();

	var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
		this.seq().obj(
			this.key('version')['int'](),
			this.key('modulus')['int'](),
			this.key('publicExponent')['int'](),
			this.key('privateExponent')['int'](),
			this.key('prime1')['int'](),
			this.key('prime2')['int'](),
			this.key('exponent1')['int'](),
			this.key('exponent2')['int'](),
			this.key('coefficient')['int']()
		);
	});
	asn1$1.RSAPrivateKey = RSAPrivateKey;

	var RSAPublicKey = asn1.define('RSAPublicKey', function () {
		this.seq().obj(
			this.key('modulus')['int'](),
			this.key('publicExponent')['int']()
		);
	});
	asn1$1.RSAPublicKey = RSAPublicKey;

	var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
		this.seq().obj(
			this.key('algorithm').objid(),
			this.key('none').null_().optional(),
			this.key('curve').objid().optional(),
			this.key('params').seq().obj(
				this.key('p')['int'](),
				this.key('q')['int'](),
				this.key('g')['int']()
			).optional()
		);
	});

	var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
		this.seq().obj(
			this.key('algorithm').use(AlgorithmIdentifier),
			this.key('subjectPublicKey').bitstr()
		);
	});
	asn1$1.PublicKey = PublicKey;

	var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
		this.seq().obj(
			this.key('version')['int'](),
			this.key('algorithm').use(AlgorithmIdentifier),
			this.key('subjectPrivateKey').octstr()
		);
	});
	asn1$1.PrivateKey = PrivateKeyInfo;
	var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
		this.seq().obj(
			this.key('algorithm').seq().obj(
				this.key('id').objid(),
				this.key('decrypt').seq().obj(
					this.key('kde').seq().obj(
						this.key('id').objid(),
						this.key('kdeparams').seq().obj(
							this.key('salt').octstr(),
							this.key('iters')['int']()
						)
					),
					this.key('cipher').seq().obj(
						this.key('algo').objid(),
						this.key('iv').octstr()
					)
				)
			),
			this.key('subjectPrivateKey').octstr()
		);
	});

	asn1$1.EncryptedPrivateKey = EncryptedPrivateKeyInfo;

	var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
		this.seq().obj(
			this.key('version')['int'](),
			this.key('p')['int'](),
			this.key('q')['int'](),
			this.key('g')['int'](),
			this.key('pub_key')['int'](),
			this.key('priv_key')['int']()
		);
	});
	asn1$1.DSAPrivateKey = DSAPrivateKey;

	asn1$1.DSAparam = asn1.define('DSAparam', function () {
		this['int']();
	});

	var ECParameters = asn1.define('ECParameters', function () {
		this.choice({
			namedCurve: this.objid()
		});
	});

	var ECPrivateKey = asn1.define('ECPrivateKey', function () {
		this.seq().obj(
			this.key('version')['int'](),
			this.key('privateKey').octstr(),
			this.key('parameters').optional().explicit(0).use(ECParameters),
			this.key('publicKey').optional().explicit(1).bitstr()
		);
	});
	asn1$1.ECPrivateKey = ECPrivateKey;

	asn1$1.signature = asn1.define('signature', function () {
		this.seq().obj(
			this.key('r')['int'](),
			this.key('s')['int']()
		);
	});
	return asn1$1;
}

var require$$1 = {
	"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
	"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
	"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
	"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
	"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
	"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
	"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
	"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
	"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
	"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
	"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
	"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};

var fixProc;
var hasRequiredFixProc;

function requireFixProc () {
	if (hasRequiredFixProc) return fixProc;
	hasRequiredFixProc = 1;

	// adapted from https://github.com/apatil/pemstrip
	var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
	var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
	var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
	var evp = requireEvp_bytestokey();
	var ciphers = requireBrowser$6();
	var Buffer = requireSafeBuffer$2().Buffer;
	fixProc = function (okey, password) {
		var key = okey.toString();
		var match = key.match(findProc);
		var decrypted;
		if (!match) {
			var match2 = key.match(fullRegex);
			decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
		} else {
			var suite = 'aes' + match[1];
			var iv = Buffer.from(match[2], 'hex');
			var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
			var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
			var out = [];
			var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
			out.push(cipher.update(cipherText));
			out.push(cipher['final']());
			decrypted = Buffer.concat(out);
		}
		var tag = key.match(startRegex)[1];
		return {
			tag: tag,
			data: decrypted
		};
	};
	return fixProc;
}

var parseAsn1;
var hasRequiredParseAsn1;

function requireParseAsn1 () {
	if (hasRequiredParseAsn1) return parseAsn1;
	hasRequiredParseAsn1 = 1;

	var asn1 = requireAsn1();
	var aesid = require$$1;
	var fixProc = requireFixProc();
	var ciphers = requireBrowser$6();
	var compat = requireBrowser$7();
	var Buffer = requireSafeBuffer$2().Buffer;

	function decrypt(data, password) {
		var salt = data.algorithm.decrypt.kde.kdeparams.salt;
		var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
		var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')];
		var iv = data.algorithm.decrypt.cipher.iv;
		var cipherText = data.subjectPrivateKey;
		var keylen = parseInt(algo.split('-')[1], 10) / 8;
		var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
		var cipher = ciphers.createDecipheriv(algo, key, iv);
		var out = [];
		out.push(cipher.update(cipherText));
		out.push(cipher['final']());
		return Buffer.concat(out);
	}

	function parseKeys(buffer) {
		var password;
		if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
			password = buffer.passphrase;
			buffer = buffer.key;
		}
		if (typeof buffer === 'string') {
			buffer = Buffer.from(buffer);
		}

		var stripped = fixProc(buffer, password);

		var type = stripped.tag;
		var data = stripped.data;
		var subtype, ndata;
		switch (type) {
			case 'CERTIFICATE':
				ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
				// falls through
			case 'PUBLIC KEY':
				if (!ndata) {
					ndata = asn1.PublicKey.decode(data, 'der');
				}
				subtype = ndata.algorithm.algorithm.join('.');
				switch (subtype) {
					case '1.2.840.113549.1.1.1':
						return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
					case '1.2.840.10045.2.1':
						ndata.subjectPrivateKey = ndata.subjectPublicKey;
						return {
							type: 'ec',
							data: ndata
						};
					case '1.2.840.10040.4.1':
						ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
						return {
							type: 'dsa',
							data: ndata.algorithm.params
						};
					default: throw new Error('unknown key id ' + subtype);
				}
				// throw new Error('unknown key type ' + type)
			case 'ENCRYPTED PRIVATE KEY':
				data = asn1.EncryptedPrivateKey.decode(data, 'der');
				data = decrypt(data, password);
				// falls through
			case 'PRIVATE KEY':
				ndata = asn1.PrivateKey.decode(data, 'der');
				subtype = ndata.algorithm.algorithm.join('.');
				switch (subtype) {
					case '1.2.840.113549.1.1.1':
						return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
					case '1.2.840.10045.2.1':
						return {
							curve: ndata.algorithm.curve,
							privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
						};
					case '1.2.840.10040.4.1':
						ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der');
						return {
							type: 'dsa',
							params: ndata.algorithm.params
						};
					default: throw new Error('unknown key id ' + subtype);
				}
				// throw new Error('unknown key type ' + type)
			case 'RSA PUBLIC KEY':
				return asn1.RSAPublicKey.decode(data, 'der');
			case 'RSA PRIVATE KEY':
				return asn1.RSAPrivateKey.decode(data, 'der');
			case 'DSA PRIVATE KEY':
				return {
					type: 'dsa',
					params: asn1.DSAPrivateKey.decode(data, 'der')
				};
			case 'EC PRIVATE KEY':
				data = asn1.ECPrivateKey.decode(data, 'der');
				return {
					curve: data.parameters.value,
					privateKey: data.privateKey
				};
			default: throw new Error('unknown key type ' + type);
		}
	}
	parseKeys.signature = asn1.signature;

	parseAsn1 = parseKeys;
	return parseAsn1;
}

var require$$4 = {
	"1.3.132.0.10": "secp256k1",
	"1.3.132.0.33": "p224",
	"1.2.840.10045.3.1.1": "p192",
	"1.2.840.10045.3.1.7": "p256",
	"1.3.132.0.34": "p384",
	"1.3.132.0.35": "p521"
};

var hasRequiredSign;

function requireSign () {
	if (hasRequiredSign) return sign.exports;
	hasRequiredSign = 1;

	// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
	var Buffer = requireSafeBuffer$2().Buffer;
	var createHmac = requireBrowser$8();
	var crt = /*@__PURE__*/ requireBrowserifyRsa();
	var EC = requireElliptic().ec;
	var BN = requireBn();
	var parseKeys = requireParseAsn1();
	var curves = require$$4;

	var RSA_PKCS1_PADDING = 1;

	function sign$1(hash, key, hashType, signType, tag) {
	  var priv = parseKeys(key);
	  if (priv.curve) {
	    // rsa keys can be interpreted as ecdsa ones in openssl
	    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
	    return ecSign(hash, priv);
	  } else if (priv.type === 'dsa') {
	    if (signType !== 'dsa') { throw new Error('wrong private key type'); }
	    return dsaSign(hash, priv, hashType);
	  }
	  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
	  if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) { throw new Error('illegal or unsupported padding mode'); }

	  hash = Buffer.concat([tag, hash]);
	  var len = priv.modulus.byteLength();
	  var pad = [0, 1];
	  while (hash.length + pad.length + 1 < len) { pad.push(0xff); }
	  pad.push(0x00);
	  var i = -1;
	  while (++i < hash.length) { pad.push(hash[i]); }

	  var out = crt(pad, priv);
	  return out;
	}

	function ecSign(hash, priv) {
	  var curveId = curves[priv.curve.join('.')];
	  if (!curveId) { throw new Error('unknown curve ' + priv.curve.join('.')); }

	  var curve = new EC(curveId);
	  var key = curve.keyFromPrivate(priv.privateKey);
	  var out = key.sign(hash);

	  return Buffer.from(out.toDER());
	}

	function dsaSign(hash, priv, algo) {
	  var x = priv.params.priv_key;
	  var p = priv.params.p;
	  var q = priv.params.q;
	  var g = priv.params.g;
	  var r = new BN(0);
	  var k;
	  var H = bits2int(hash, q).mod(q);
	  var s = false;
	  var kv = getKey(x, q, hash, algo);
	  while (s === false) {
	    k = makeKey(q, kv, algo);
	    r = makeR(g, k, p, q);
	    s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
	    if (s.cmpn(0) === 0) {
	      s = false;
	      r = new BN(0);
	    }
	  }
	  return toDER(r, s);
	}

	function toDER(r, s) {
	  r = r.toArray();
	  s = s.toArray();

	  // Pad values
	  if (r[0] & 0x80) { r = [0].concat(r); }
	  if (s[0] & 0x80) { s = [0].concat(s); }

	  var total = r.length + s.length + 4;
	  var res = [
	    0x30, total, 0x02, r.length
	  ];
	  res = res.concat(r, [0x02, s.length], s);
	  return Buffer.from(res);
	}

	function getKey(x, q, hash, algo) {
	  x = Buffer.from(x.toArray());
	  if (x.length < q.byteLength()) {
	    var zeros = Buffer.alloc(q.byteLength() - x.length);
	    x = Buffer.concat([zeros, x]);
	  }
	  var hlen = hash.length;
	  var hbits = bits2octets(hash, q);
	  var v = Buffer.alloc(hlen);
	  v.fill(1);
	  var k = Buffer.alloc(hlen);
	  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest();
	  v = createHmac(algo, k).update(v).digest();
	  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest();
	  v = createHmac(algo, k).update(v).digest();
	  return { k: k, v: v };
	}

	function bits2int(obits, q) {
	  var bits = new BN(obits);
	  var shift = (obits.length << 3) - q.bitLength();
	  if (shift > 0) { bits.ishrn(shift); }
	  return bits;
	}

	function bits2octets(bits, q) {
	  bits = bits2int(bits, q);
	  bits = bits.mod(q);
	  var out = Buffer.from(bits.toArray());
	  if (out.length < q.byteLength()) {
	    var zeros = Buffer.alloc(q.byteLength() - out.length);
	    out = Buffer.concat([zeros, out]);
	  }
	  return out;
	}

	function makeKey(q, kv, algo) {
	  var t;
	  var k;

	  do {
	    t = Buffer.alloc(0);

	    while (t.length * 8 < q.bitLength()) {
	      kv.v = createHmac(algo, kv.k).update(kv.v).digest();
	      t = Buffer.concat([t, kv.v]);
	    }

	    k = bits2int(t, q);
	    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest();
	    kv.v = createHmac(algo, kv.k).update(kv.v).digest();
	  } while (k.cmp(q) !== -1);

	  return k;
	}

	function makeR(g, k, p, q) {
	  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
	}

	sign.exports = sign$1;
	sign.exports.getKey = getKey;
	sign.exports.makeKey = makeKey;
	return sign.exports;
}

var verify_1;
var hasRequiredVerify;

function requireVerify () {
	if (hasRequiredVerify) return verify_1;
	hasRequiredVerify = 1;

	// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
	var Buffer = requireSafeBuffer$2().Buffer;
	var BN = requireBn();
	var EC = requireElliptic().ec;
	var parseKeys = requireParseAsn1();
	var curves = require$$4;

	function verify(sig, hash, key, signType, tag) {
	  var pub = parseKeys(key);
	  if (pub.type === 'ec') {
	    // rsa keys can be interpreted as ecdsa ones in openssl
	    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }
	    return ecVerify(sig, hash, pub);
	  } else if (pub.type === 'dsa') {
	    if (signType !== 'dsa') { throw new Error('wrong public key type'); }
	    return dsaVerify(sig, hash, pub);
	  }
	  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }

	  hash = Buffer.concat([tag, hash]);
	  var len = pub.modulus.byteLength();
	  var pad = [1];
	  var padNum = 0;
	  while (hash.length + pad.length + 2 < len) {
	    pad.push(0xff);
	    padNum += 1;
	  }
	  pad.push(0x00);
	  var i = -1;
	  while (++i < hash.length) {
	    pad.push(hash[i]);
	  }
	  pad = Buffer.from(pad);
	  var red = BN.mont(pub.modulus);
	  sig = new BN(sig).toRed(red);

	  sig = sig.redPow(new BN(pub.publicExponent));
	  sig = Buffer.from(sig.fromRed().toArray());
	  var out = padNum < 8 ? 1 : 0;
	  len = Math.min(sig.length, pad.length);
	  if (sig.length !== pad.length) { out = 1; }

	  i = -1;
	  while (++i < len) { out |= sig[i] ^ pad[i]; }
	  return out === 0;
	}

	function ecVerify(sig, hash, pub) {
	  var curveId = curves[pub.data.algorithm.curve.join('.')];
	  if (!curveId) { throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.')); }

	  var curve = new EC(curveId);
	  var pubkey = pub.data.subjectPrivateKey.data;

	  return curve.verify(hash, sig, pubkey);
	}

	function dsaVerify(sig, hash, pub) {
	  var p = pub.data.p;
	  var q = pub.data.q;
	  var g = pub.data.g;
	  var y = pub.data.pub_key;
	  var unpacked = parseKeys.signature.decode(sig, 'der');
	  var s = unpacked.s;
	  var r = unpacked.r;
	  checkValue(s, q);
	  checkValue(r, q);
	  var montp = BN.mont(p);
	  var w = s.invm(q);
	  var v = g.toRed(montp)
	    .redPow(new BN(hash).mul(w).mod(q))
	    .fromRed()
	    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
	    .mod(p)
	    .mod(q);
	  return v.cmp(r) === 0;
	}

	function checkValue(b, q) {
	  if (b.cmpn(0) <= 0) { throw new Error('invalid sig'); }
	  if (b.cmp(q) >= 0) { throw new Error('invalid sig'); }
	}

	verify_1 = verify;
	return verify_1;
}

var browser$3;
var hasRequiredBrowser$3;

function requireBrowser$3 () {
	if (hasRequiredBrowser$3) return browser$3;
	hasRequiredBrowser$3 = 1;

	var Buffer = requireSafeBuffer$2().Buffer;
	var createHash = requireBrowser$9();
	var stream = requireReadableBrowser();
	var inherits = requireInherits_browser();
	var sign = requireSign();
	var verify = requireVerify();

	var algorithms = require$$6;
	Object.keys(algorithms).forEach(function (key) {
	  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex');
	  algorithms[key.toLowerCase()] = algorithms[key];
	});

	function Sign(algorithm) {
	  stream.Writable.call(this);

	  var data = algorithms[algorithm];
	  if (!data) { throw new Error('Unknown message digest'); }

	  this._hashType = data.hash;
	  this._hash = createHash(data.hash);
	  this._tag = data.id;
	  this._signType = data.sign;
	}
	inherits(Sign, stream.Writable);

	Sign.prototype._write = function _write(data, _, done) {
	  this._hash.update(data);
	  done();
	};

	Sign.prototype.update = function update(data, enc) {
	  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

	  return this;
	};

	Sign.prototype.sign = function signMethod(key, enc) {
	  this.end();
	  var hash = this._hash.digest();
	  var sig = sign(hash, key, this._hashType, this._signType, this._tag);

	  return enc ? sig.toString(enc) : sig;
	};

	function Verify(algorithm) {
	  stream.Writable.call(this);

	  var data = algorithms[algorithm];
	  if (!data) { throw new Error('Unknown message digest'); }

	  this._hash = createHash(data.hash);
	  this._tag = data.id;
	  this._signType = data.sign;
	}
	inherits(Verify, stream.Writable);

	Verify.prototype._write = function _write(data, _, done) {
	  this._hash.update(data);
	  done();
	};

	Verify.prototype.update = function update(data, enc) {
	  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

	  return this;
	};

	Verify.prototype.verify = function verifyMethod(key, sig, enc) {
	  var sigBuffer = typeof sig === 'string' ? Buffer.from(sig, enc) : sig;

	  this.end();
	  var hash = this._hash.digest();
	  return verify(sigBuffer, hash, key, this._signType, this._tag);
	};

	function createSign(algorithm) {
	  return new Sign(algorithm);
	}

	function createVerify(algorithm) {
	  return new Verify(algorithm);
	}

	browser$3 = {
	  Sign: createSign,
	  Verify: createVerify,
	  createSign: createSign,
	  createVerify: createVerify
	};
	return browser$3;
}

var browser$2;
var hasRequiredBrowser$2;

function requireBrowser$2 () {
	if (hasRequiredBrowser$2) return browser$2;
	hasRequiredBrowser$2 = 1;
	var elliptic = requireElliptic();
	var BN = requireBn$2();

	browser$2 = function createECDH (curve) {
	  return new ECDH(curve)
	};

	var aliases = {
	  secp256k1: {
	    name: 'secp256k1',
	    byteLength: 32
	  },
	  secp224r1: {
	    name: 'p224',
	    byteLength: 28
	  },
	  prime256v1: {
	    name: 'p256',
	    byteLength: 32
	  },
	  prime192v1: {
	    name: 'p192',
	    byteLength: 24
	  },
	  ed25519: {
	    name: 'ed25519',
	    byteLength: 32
	  },
	  secp384r1: {
	    name: 'p384',
	    byteLength: 48
	  },
	  secp521r1: {
	    name: 'p521',
	    byteLength: 66
	  }
	};

	aliases.p224 = aliases.secp224r1;
	aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
	aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
	aliases.p384 = aliases.secp384r1;
	aliases.p521 = aliases.secp521r1;

	function ECDH (curve) {
	  this.curveType = aliases[curve];
	  if (!this.curveType) {
	    this.curveType = {
	      name: curve
	    };
	  }
	  this.curve = new elliptic.ec(this.curveType.name); // eslint-disable-line new-cap
	  this.keys = void 0;
	}

	ECDH.prototype.generateKeys = function (enc, format) {
	  this.keys = this.curve.genKeyPair();
	  return this.getPublicKey(enc, format)
	};

	ECDH.prototype.computeSecret = function (other, inenc, enc) {
	  inenc = inenc || 'utf8';
	  if (!Buffer.isBuffer(other)) {
	    other = new Buffer(other, inenc);
	  }
	  var otherPub = this.curve.keyFromPublic(other).getPublic();
	  var out = otherPub.mul(this.keys.getPrivate()).getX();
	  return formatReturnValue(out, enc, this.curveType.byteLength)
	};

	ECDH.prototype.getPublicKey = function (enc, format) {
	  var key = this.keys.getPublic(format === 'compressed', true);
	  if (format === 'hybrid') {
	    if (key[key.length - 1] % 2) {
	      key[0] = 7;
	    } else {
	      key[0] = 6;
	    }
	  }
	  return formatReturnValue(key, enc)
	};

	ECDH.prototype.getPrivateKey = function (enc) {
	  return formatReturnValue(this.keys.getPrivate(), enc)
	};

	ECDH.prototype.setPublicKey = function (pub, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(pub)) {
	    pub = new Buffer(pub, enc);
	  }
	  this.keys._importPublic(pub);
	  return this
	};

	ECDH.prototype.setPrivateKey = function (priv, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(priv)) {
	    priv = new Buffer(priv, enc);
	  }

	  var _priv = new BN(priv);
	  _priv = _priv.toString(16);
	  this.keys = this.curve.genKeyPair();
	  this.keys._importPrivate(_priv);
	  return this
	};

	function formatReturnValue (bn, enc, len) {
	  if (!Array.isArray(bn)) {
	    bn = bn.toArray();
	  }
	  var buf = new Buffer(bn);
	  if (len && buf.length < len) {
	    var zeros = new Buffer(len - buf.length);
	    zeros.fill(0);
	    buf = Buffer.concat([zeros, buf]);
	  }
	  if (!enc) {
	    return buf
	  } else {
	    return buf.toString(enc)
	  }
	}
	return browser$2;
}

var browser$1 = {};

var mgf;
var hasRequiredMgf;

function requireMgf () {
	if (hasRequiredMgf) return mgf;
	hasRequiredMgf = 1;
	var createHash = requireBrowser$9();
	var Buffer = requireSafeBuffer$2().Buffer;

	mgf = function (seed, len) {
	  var t = Buffer.alloc(0);
	  var i = 0;
	  var c;
	  while (t.length < len) {
	    c = i2ops(i++);
	    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()]);
	  }
	  return t.slice(0, len)
	};

	function i2ops (c) {
	  var out = Buffer.allocUnsafe(4);
	  out.writeUInt32BE(c, 0);
	  return out
	}
	return mgf;
}

var xor;
var hasRequiredXor;

function requireXor () {
	if (hasRequiredXor) return xor;
	hasRequiredXor = 1;
	xor = function xor (a, b) {
	  var len = a.length;
	  var i = -1;
	  while (++i < len) {
	    a[i] ^= b[i];
	  }
	  return a
	};
	return xor;
}

var withPublic_1;
var hasRequiredWithPublic;

function requireWithPublic () {
	if (hasRequiredWithPublic) return withPublic_1;
	hasRequiredWithPublic = 1;
	var BN = requireBn$2();
	var Buffer = requireSafeBuffer$2().Buffer;

	function withPublic (paddedMsg, key) {
	  return Buffer.from(paddedMsg
	    .toRed(BN.mont(key.modulus))
	    .redPow(new BN(key.publicExponent))
	    .fromRed()
	    .toArray())
	}

	withPublic_1 = withPublic;
	return withPublic_1;
}

var publicEncrypt;
var hasRequiredPublicEncrypt;

function requirePublicEncrypt () {
	if (hasRequiredPublicEncrypt) return publicEncrypt;
	hasRequiredPublicEncrypt = 1;
	var parseKeys = requireParseAsn1();
	var randomBytes = requireBrowser$b();
	var createHash = requireBrowser$9();
	var mgf = requireMgf();
	var xor = requireXor();
	var BN = requireBn$2();
	var withPublic = requireWithPublic();
	var crt = /*@__PURE__*/ requireBrowserifyRsa();
	var Buffer = requireSafeBuffer$2().Buffer;

	publicEncrypt = function publicEncrypt (publicKey, msg, reverse) {
	  var padding;
	  if (publicKey.padding) {
	    padding = publicKey.padding;
	  } else if (reverse) {
	    padding = 1;
	  } else {
	    padding = 4;
	  }
	  var key = parseKeys(publicKey);
	  var paddedMsg;
	  if (padding === 4) {
	    paddedMsg = oaep(key, msg);
	  } else if (padding === 1) {
	    paddedMsg = pkcs1(key, msg, reverse);
	  } else if (padding === 3) {
	    paddedMsg = new BN(msg);
	    if (paddedMsg.cmp(key.modulus) >= 0) {
	      throw new Error('data too long for modulus')
	    }
	  } else {
	    throw new Error('unknown padding')
	  }
	  if (reverse) {
	    return crt(paddedMsg, key)
	  } else {
	    return withPublic(paddedMsg, key)
	  }
	};

	function oaep (key, msg) {
	  var k = key.modulus.byteLength();
	  var mLen = msg.length;
	  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest();
	  var hLen = iHash.length;
	  var hLen2 = 2 * hLen;
	  if (mLen > k - hLen2 - 2) {
	    throw new Error('message too long')
	  }
	  var ps = Buffer.alloc(k - mLen - hLen2 - 2);
	  var dblen = k - hLen - 1;
	  var seed = randomBytes(hLen);
	  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen));
	  var maskedSeed = xor(seed, mgf(maskedDb, hLen));
	  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
	}
	function pkcs1 (key, msg, reverse) {
	  var mLen = msg.length;
	  var k = key.modulus.byteLength();
	  if (mLen > k - 11) {
	    throw new Error('message too long')
	  }
	  var ps;
	  if (reverse) {
	    ps = Buffer.alloc(k - mLen - 3, 0xff);
	  } else {
	    ps = nonZero(k - mLen - 3);
	  }
	  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
	}
	function nonZero (len) {
	  var out = Buffer.allocUnsafe(len);
	  var i = 0;
	  var cache = randomBytes(len * 2);
	  var cur = 0;
	  var num;
	  while (i < len) {
	    if (cur === cache.length) {
	      cache = randomBytes(len * 2);
	      cur = 0;
	    }
	    num = cache[cur++];
	    if (num) {
	      out[i++] = num;
	    }
	  }
	  return out
	}
	return publicEncrypt;
}

var privateDecrypt;
var hasRequiredPrivateDecrypt;

function requirePrivateDecrypt () {
	if (hasRequiredPrivateDecrypt) return privateDecrypt;
	hasRequiredPrivateDecrypt = 1;
	var parseKeys = requireParseAsn1();
	var mgf = requireMgf();
	var xor = requireXor();
	var BN = requireBn$2();
	var crt = /*@__PURE__*/ requireBrowserifyRsa();
	var createHash = requireBrowser$9();
	var withPublic = requireWithPublic();
	var Buffer = requireSafeBuffer$2().Buffer;

	privateDecrypt = function privateDecrypt (privateKey, enc, reverse) {
	  var padding;
	  if (privateKey.padding) {
	    padding = privateKey.padding;
	  } else if (reverse) {
	    padding = 1;
	  } else {
	    padding = 4;
	  }

	  var key = parseKeys(privateKey);
	  var k = key.modulus.byteLength();
	  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
	    throw new Error('decryption error')
	  }
	  var msg;
	  if (reverse) {
	    msg = withPublic(new BN(enc), key);
	  } else {
	    msg = crt(enc, key);
	  }
	  var zBuffer = Buffer.alloc(k - msg.length);
	  msg = Buffer.concat([zBuffer, msg], k);
	  if (padding === 4) {
	    return oaep(key, msg)
	  } else if (padding === 1) {
	    return pkcs1(key, msg, reverse)
	  } else if (padding === 3) {
	    return msg
	  } else {
	    throw new Error('unknown padding')
	  }
	};

	function oaep (key, msg) {
	  var k = key.modulus.byteLength();
	  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest();
	  var hLen = iHash.length;
	  if (msg[0] !== 0) {
	    throw new Error('decryption error')
	  }
	  var maskedSeed = msg.slice(1, hLen + 1);
	  var maskedDb = msg.slice(hLen + 1);
	  var seed = xor(maskedSeed, mgf(maskedDb, hLen));
	  var db = xor(maskedDb, mgf(seed, k - hLen - 1));
	  if (compare(iHash, db.slice(0, hLen))) {
	    throw new Error('decryption error')
	  }
	  var i = hLen;
	  while (db[i] === 0) {
	    i++;
	  }
	  if (db[i++] !== 1) {
	    throw new Error('decryption error')
	  }
	  return db.slice(i)
	}

	function pkcs1 (key, msg, reverse) {
	  var p1 = msg.slice(0, 2);
	  var i = 2;
	  var status = 0;
	  while (msg[i++] !== 0) {
	    if (i >= msg.length) {
	      status++;
	      break
	    }
	  }
	  var ps = msg.slice(2, i - 1);

	  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
	    status++;
	  }
	  if (ps.length < 8) {
	    status++;
	  }
	  if (status) {
	    throw new Error('decryption error')
	  }
	  return msg.slice(i)
	}
	function compare (a, b) {
	  a = Buffer.from(a);
	  b = Buffer.from(b);
	  var dif = 0;
	  var len = a.length;
	  if (a.length !== b.length) {
	    dif++;
	    len = Math.min(a.length, b.length);
	  }
	  var i = -1;
	  while (++i < len) {
	    dif += (a[i] ^ b[i]);
	  }
	  return dif
	}
	return privateDecrypt;
}

var hasRequiredBrowser$1;

function requireBrowser$1 () {
	if (hasRequiredBrowser$1) return browser$1;
	hasRequiredBrowser$1 = 1;
	(function (exports) {
		exports.publicEncrypt = requirePublicEncrypt();
		exports.privateDecrypt = requirePrivateDecrypt();

		exports.privateEncrypt = function privateEncrypt (key, buf) {
		  return exports.publicEncrypt(key, buf, true)
		};

		exports.publicDecrypt = function publicDecrypt (key, buf) {
		  return exports.privateDecrypt(key, buf, true)
		}; 
	} (browser$1));
	return browser$1;
}

var browser = {};

var hasRequiredBrowser;

function requireBrowser () {
	if (hasRequiredBrowser) return browser;
	hasRequiredBrowser = 1;

	function oldBrowser () {
	  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
	}
	var safeBuffer = requireSafeBuffer$2();
	requireBrowser$b();
	var Buffer = safeBuffer.Buffer;
	var kBufferMaxLength = safeBuffer.kMaxLength;
	var crypto = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
	var kMaxUint32 = Math.pow(2, 32) - 1;
	function assertOffset (offset, length) {
	  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
	    throw new TypeError('offset must be a number')
	  }

	  if (offset > kMaxUint32 || offset < 0) {
	    throw new TypeError('offset must be a uint32')
	  }

	  if (offset > kBufferMaxLength || offset > length) {
	    throw new RangeError('offset out of range')
	  }
	}

	function assertSize (size, offset, length) {
	  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
	    throw new TypeError('size must be a number')
	  }

	  if (size > kMaxUint32 || size < 0) {
	    throw new TypeError('size must be a uint32')
	  }

	  if (size + offset > length || size > kBufferMaxLength) {
	    throw new RangeError('buffer too small')
	  }
	}
	if ((crypto && crypto.getRandomValues) || !true) {
	  browser.randomFill = randomFill;
	  browser.randomFillSync = randomFillSync;
	} else {
	  browser.randomFill = oldBrowser;
	  browser.randomFillSync = oldBrowser;
	}
	function randomFill (buf, offset, size, cb) {
	  if (!Buffer.isBuffer(buf) && !(buf instanceof commonjsGlobal.Uint8Array)) {
	    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
	  }

	  if (typeof offset === 'function') {
	    cb = offset;
	    offset = 0;
	    size = buf.length;
	  } else if (typeof size === 'function') {
	    cb = size;
	    size = buf.length - offset;
	  } else if (typeof cb !== 'function') {
	    throw new TypeError('"cb" argument must be a function')
	  }
	  assertOffset(offset, buf.length);
	  assertSize(size, offset, buf.length);
	  return actualFill(buf, offset, size, cb)
	}

	function actualFill (buf, offset, size, cb) {
	  {
	    var ourBuf = buf.buffer;
	    var uint = new Uint8Array(ourBuf, offset, size);
	    crypto.getRandomValues(uint);
	    if (cb) {
	      process.nextTick(function () {
	        cb(null, buf);
	      });
	      return
	    }
	    return buf
	  }
	}
	function randomFillSync (buf, offset, size) {
	  if (typeof offset === 'undefined') {
	    offset = 0;
	  }
	  if (!Buffer.isBuffer(buf) && !(buf instanceof commonjsGlobal.Uint8Array)) {
	    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
	  }

	  assertOffset(offset, buf.length);

	  if (size === undefined) size = buf.length - offset;

	  assertSize(size, offset, buf.length);

	  return actualFill(buf, offset, size)
	}
	return browser;
}

var hasRequiredCryptoBrowserify;

function requireCryptoBrowserify () {
	if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
	hasRequiredCryptoBrowserify = 1;

	// eslint-disable-next-line no-multi-assign
	cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$b();

	// eslint-disable-next-line no-multi-assign
	cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9();

	// eslint-disable-next-line no-multi-assign
	cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();

	var algos = requireAlgos();
	var algoKeys = Object.keys(algos);
	var hashes = [
		'sha1',
		'sha224',
		'sha256',
		'sha384',
		'sha512',
		'md5',
		'rmd160'
	].concat(algoKeys);

	cryptoBrowserify.getHashes = function () {
		return hashes;
	};

	var p = requireBrowser$7();
	cryptoBrowserify.pbkdf2 = p.pbkdf2;
	cryptoBrowserify.pbkdf2Sync = p.pbkdf2Sync;

	var aes = requireBrowser$5();

	cryptoBrowserify.Cipher = aes.Cipher;
	cryptoBrowserify.createCipher = aes.createCipher;
	cryptoBrowserify.Cipheriv = aes.Cipheriv;
	cryptoBrowserify.createCipheriv = aes.createCipheriv;
	cryptoBrowserify.Decipher = aes.Decipher;
	cryptoBrowserify.createDecipher = aes.createDecipher;
	cryptoBrowserify.Decipheriv = aes.Decipheriv;
	cryptoBrowserify.createDecipheriv = aes.createDecipheriv;
	cryptoBrowserify.getCiphers = aes.getCiphers;
	cryptoBrowserify.listCiphers = aes.listCiphers;

	var dh = requireBrowser$4();

	cryptoBrowserify.DiffieHellmanGroup = dh.DiffieHellmanGroup;
	cryptoBrowserify.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
	cryptoBrowserify.getDiffieHellman = dh.getDiffieHellman;
	cryptoBrowserify.createDiffieHellman = dh.createDiffieHellman;
	cryptoBrowserify.DiffieHellman = dh.DiffieHellman;

	var sign = requireBrowser$3();

	cryptoBrowserify.createSign = sign.createSign;
	cryptoBrowserify.Sign = sign.Sign;
	cryptoBrowserify.createVerify = sign.createVerify;
	cryptoBrowserify.Verify = sign.Verify;

	cryptoBrowserify.createECDH = requireBrowser$2();

	var publicEncrypt = requireBrowser$1();

	cryptoBrowserify.publicEncrypt = publicEncrypt.publicEncrypt;
	cryptoBrowserify.privateEncrypt = publicEncrypt.privateEncrypt;
	cryptoBrowserify.publicDecrypt = publicEncrypt.publicDecrypt;
	cryptoBrowserify.privateDecrypt = publicEncrypt.privateDecrypt;

	// the least I can do is make error messages for the rest of the node.js/crypto api.
	// [
	//   'createCredentials'
	// ].forEach(function (name) {
	//   exports[name] = function () {
	//     throw new Error('sorry, ' + name + ' is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
	//   };
	// });

	var rf = requireBrowser();

	cryptoBrowserify.randomFill = rf.randomFill;
	cryptoBrowserify.randomFillSync = rf.randomFillSync;

	cryptoBrowserify.createCredentials = function () {
		throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
	};

	cryptoBrowserify.constants = {
		DH_CHECK_P_NOT_SAFE_PRIME: 2,
		DH_CHECK_P_NOT_PRIME: 1,
		DH_UNABLE_TO_CHECK_GENERATOR: 4,
		DH_NOT_SUITABLE_GENERATOR: 8,
		NPN_ENABLED: 1,
		ALPN_ENABLED: 1,
		RSA_PKCS1_PADDING: 1,
		RSA_SSLV23_PADDING: 2,
		RSA_NO_PADDING: 3,
		RSA_PKCS1_OAEP_PADDING: 4,
		RSA_X931_PADDING: 5,
		RSA_PKCS1_PSS_PADDING: 6,
		POINT_CONVERSION_COMPRESSED: 2,
		POINT_CONVERSION_UNCOMPRESSED: 4,
		POINT_CONVERSION_HYBRID: 6
	};
	return cryptoBrowserify;
}

var require$$5 = /*@__PURE__*/getAugmentedNamespace(vue);

var hasRequiredController_bc;

function requireController_bc () {
	if (hasRequiredController_bc) return controller_bc$1.exports;
	hasRequiredController_bc = 1;
	(function (module) {
		// Generated by js_of_ocaml
		//# buildInfo:effects=cps, kind=exe, toplevel=false, use-js-string=true, version=6.4.1
		(function
		  (Object){
		   typeof globalThis !== "object"
		   &&
		    (this
		      ? get()
		      : (Object.defineProperty
		         (Object.prototype, "_T_", {configurable: true, get: get}),
		        _T_));
		   function get(){
		    var global = this || self;
		    global.globalThis = global;
		    delete Object.prototype._T_;
		   }
		  }
		  (Object));
		(function(globalThis){
		   var joo_global_object = globalThis;
		   (function(){
		      var DefaultLocale =
		         {days:
		          ["Sunday",
		           "Monday",
		           "Tuesday",
		           "Wednesday",
		           "Thursday",
		           "Friday",
		           "Saturday"],
		          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		          months:
		          ["January",
		           "February",
		           "March",
		           "April",
		           "May",
		           "June",
		           "July",
		           "August",
		           "September",
		           "October",
		           "November",
		           "December"],
		          shortMonths:
		          ["Jan",
		           "Feb",
		           "Mar",
		           "Apr",
		           "May",
		           "Jun",
		           "Jul",
		           "Aug",
		           "Sep",
		           "Oct",
		           "Nov",
		           "Dec"],
		          AM: "AM",
		          PM: "PM",
		          am: "am",
		          pm: "pm",
		          formats:
		          {D: "%m/%d/%y",
		           F: "%Y-%m-%d",
		           R: "%H:%M",
		           T: "%H:%M:%S",
		           X: "%T",
		           c: "%a %b %d %X %Y",
		           r: "%I:%M:%S %p",
		           v: "%e-%b-%Y",
		           x: "%D"}},
		       defaultStrftime = new Strftime(DefaultLocale, 0, false),
		       namespace;
		      {
		       namespace = module.exports = adaptedStrftime;
		       namespace.strftime = deprecatedStrftime;
		       if(joo_global_object) joo_global_object.strftime = adaptedStrftime;
		      }
		      var
		       _require = "require('strftime')" ,
		       _deprecationWarnings = {};
		      function deprecationWarning(name, instead){
		       if(! _deprecationWarnings[name]){
		        if
		         (typeof console !== "undefined" && typeof console.warn == "function")
		         console.warn
		          ("[WARNING] " + name
		           +
		            " is deprecated and will be removed in version 1.0. Instead, use `"
		           + instead
		           + "`.");
		        _deprecationWarnings[name] = true;
		       }
		      }
		      namespace.strftimeTZ = deprecatedStrftimeTZ;
		      namespace.strftimeUTC = deprecatedStrftimeUTC;
		      namespace.localizedStrftime = deprecatedStrftimeLocalized;
		      function adaptForwards(fn){
		       fn.localize = defaultStrftime.localize.bind(defaultStrftime);
		       fn.timezone = defaultStrftime.timezone.bind(defaultStrftime);
		       fn.utc = defaultStrftime.utc.bind(defaultStrftime);
		      }
		      adaptForwards(adaptedStrftime);
		      function adaptedStrftime(fmt, d, locale){
		       if(d && d.days){locale = d; d = undefined;}
		       if(locale)
		        deprecationWarning
		         ("`" + _require + "(format, [date], [locale])`",
		          "var s = " + _require + ".localize(locale); s(format, [date])");
		       var
		        strftime = locale ? defaultStrftime.localize(locale) : defaultStrftime;
		       return strftime(fmt, d);
		      }
		      adaptForwards(deprecatedStrftime);
		      function deprecatedStrftime(fmt, d, locale){
		       if(locale)
		        deprecationWarning
		         ("`" + _require + ".strftime(format, [date], [locale])`",
		          "var s = " + _require + ".localize(locale); s(format, [date])");
		       else
		        deprecationWarning
		         ("`" + _require + ".strftime(format, [date])`",
		          _require + "(format, [date])");
		       var
		        strftime = locale ? defaultStrftime.localize(locale) : defaultStrftime;
		       return strftime(fmt, d);
		      }
		      function deprecatedStrftimeTZ(fmt, d, locale, timezone){
		       if
		        ((typeof locale == "number" || typeof locale == "string")
		         && timezone == null){
		        timezone = locale;
		        locale = undefined;
		       }
		       if(locale)
		        deprecationWarning
		         ("`" + _require + ".strftimeTZ(format, date, locale, tz)`",
		          "var s = " + _require
		          + ".localize(locale).timezone(tz); s(format, [date])` or `var s = "
		          + _require
		          + ".localize(locale); s.timezone(tz)(format, [date])");
		       else
		        deprecationWarning
		         ("`" + _require + ".strftimeTZ(format, date, tz)`",
		          "var s = " + _require + ".timezone(tz); s(format, [date])` or `"
		          + _require
		          + ".timezone(tz)(format, [date])");
		       var
		        strftime =
		          (locale ? defaultStrftime.localize(locale) : defaultStrftime).timezone
		           (timezone);
		       return strftime(fmt, d);
		      }
		      var utcStrftime = defaultStrftime.utc();
		      function deprecatedStrftimeUTC(fmt, d, locale){
		       if(locale)
		        deprecationWarning
		         ("`" + _require + ".strftimeUTC(format, date, locale)`",
		          "var s = " + _require + ".localize(locale).utc(); s(format, [date])");
		       else
		        deprecationWarning
		         ("`" + _require + ".strftimeUTC(format, [date])`",
		          "var s = " + _require + ".utc(); s(format, [date])");
		       var strftime = locale ? utcStrftime.localize(locale) : utcStrftime;
		       return strftime(fmt, d);
		      }
		      function deprecatedStrftimeLocalized(locale){
		       deprecationWarning
		        ("`" + _require + ".localizedStrftime(locale)`",
		         _require + ".localize(locale)");
		       return defaultStrftime.localize(locale);
		      }
		      if(typeof Date.now !== "function")
		       Date.now = function(){return + new Date();};
		      function Strftime(locale, customTimezoneOffset, useUtcTimezone){
		       var
		        _locale = locale || DefaultLocale,
		        _customTimezoneOffset = customTimezoneOffset || 0,
		        _useUtcBasedDate = useUtcTimezone || false,
		        _cachedDateTimestamp = 0,
		        _cachedDate;
		       function _strftime(format, date){
		        var timestamp;
		        if(! date){
		         var currentTimestamp = Date.now();
		         if(currentTimestamp > _cachedDateTimestamp){
		          _cachedDateTimestamp = currentTimestamp;
		          _cachedDate = new Date(_cachedDateTimestamp);
		          timestamp = _cachedDateTimestamp;
		          if(_useUtcBasedDate)
		           _cachedDate =
		            new
		             Date
		             (_cachedDateTimestamp + getTimestampToUtcOffsetFor(_cachedDate)
		              + _customTimezoneOffset);
		         }
		         date = _cachedDate;
		        }
		        else {
		         timestamp = date.getTime();
		         if(_useUtcBasedDate)
		          date =
		           new
		            Date
		            (date.getTime() + getTimestampToUtcOffsetFor(date)
		             + _customTimezoneOffset);
		        }
		        return _processFormat(format, date, _locale, timestamp);
		       }
		       function _processFormat(format, date, locale, timestamp){
		        var
		         resultString = "",
		         padding = null,
		         isInScope = false,
		         length = format.length,
		         extendedTZ = false;
		        for(var i = 0; i < length; i++){
		         var currentCharCode = format.charCodeAt(i);
		         if(isInScope === true){
		          if(currentCharCode === 45){padding = ""; continue;}
		          else if(currentCharCode === 95){padding = " "; continue;}
		          else if(currentCharCode === 48){padding = "0"; continue;}
		          else if(currentCharCode === 58){
		           if(extendedTZ)
		            if
		             (typeof console !== "undefined"
		              && typeof console.warn == "function")
		             console.warn
		              ("[WARNING] detected use of unsupported %:: or %::: modifiers to strftime");
		           extendedTZ = true;
		           continue;
		          }
		          switch(currentCharCode){
		            case 65:
		             resultString += locale.days[date.getDay()]; break;
		            case 66:
		             resultString += locale.months[date.getMonth()]; break;
		            case 67:
		             resultString +=
		              padTill2(Math.floor(date.getFullYear() / 100), padding);
		             break;
		            case 68:
		             resultString +=
		              _processFormat(locale.formats.D, date, locale, timestamp);
		             break;
		            case 70:
		             resultString +=
		              _processFormat(locale.formats.F, date, locale, timestamp);
		             break;
		            case 72:
		             resultString += padTill2(date.getHours(), padding); break;
		            case 73:
		             resultString += padTill2(hours12(date.getHours()), padding);
		             break;
		            case 76:
		             resultString += padTill3(Math.floor(timestamp % 1000)); break;
		            case 77:
		             resultString += padTill2(date.getMinutes(), padding); break;
		            case 80:
		             resultString += date.getHours() < 12 ? locale.am : locale.pm;
		             break;
		            case 82:
		             resultString +=
		              _processFormat(locale.formats.R, date, locale, timestamp);
		             break;
		            case 83:
		             resultString += padTill2(date.getSeconds(), padding); break;
		            case 84:
		             resultString +=
		              _processFormat(locale.formats.T, date, locale, timestamp);
		             break;
		            case 85:
		             resultString += padTill2(weekNumber(date, "sunday"), padding);
		             break;
		            case 87:
		             resultString += padTill2(weekNumber(date, "monday"), padding);
		             break;
		            case 88:
		             resultString +=
		              _processFormat(locale.formats.X, date, locale, timestamp);
		             break;
		            case 89:
		             resultString += date.getFullYear(); break;
		            case 90:
		             if(_useUtcBasedDate && _customTimezoneOffset === 0)
		              resultString += "GMT";
		             else {
		              var tzString = date.toString().match(/\(([\w\s]+)\)/);
		              resultString += tzString && tzString[1] || "";
		             }
		             break;
		            case 97:
		             resultString += locale.shortDays[date.getDay()]; break;
		            case 98:
		             resultString += locale.shortMonths[date.getMonth()]; break;
		            case 99:
		             resultString +=
		              _processFormat(locale.formats.c, date, locale, timestamp);
		             break;
		            case 100:
		             resultString += padTill2(date.getDate(), padding); break;
		            case 101:
		             resultString +=
		              padTill2(date.getDate(), padding == null ? " " : padding);
		             break;
		            case 104:
		             resultString += locale.shortMonths[date.getMonth()]; break;
		            case 106:
		             var
		              y = new Date(date.getFullYear(), 0, 1),
		              day =
		                Math.ceil
		                 ((date.getTime() - y.getTime()) / (1000 * 60 * 60 * 24));
		             resultString += padTill3(day);
		             break;
		            case 107:
		             resultString +=
		              padTill2(date.getHours(), padding == null ? " " : padding);
		             break;
		            case 108:
		             resultString +=
		              padTill2
		               (hours12(date.getHours()), padding == null ? " " : padding);
		             break;
		            case 109:
		             resultString += padTill2(date.getMonth() + 1, padding); break;
		            case 110:
		             resultString += "\n"; break;
		            case 111:
		             resultString += String(date.getDate()) + ordinal(date.getDate());
		             break;
		            case 112:
		             resultString += date.getHours() < 12 ? locale.AM : locale.PM;
		             break;
		            case 114:
		             resultString +=
		              _processFormat(locale.formats.r, date, locale, timestamp);
		             break;
		            case 115:
		             resultString += Math.floor(timestamp / 1000); break;
		            case 116:
		             resultString += "\t"; break;
		            case 117:
		             var day = date.getDay();
		             resultString += day === 0 ? 7 : day;
		             break;
		            case 118:
		             resultString +=
		              _processFormat(locale.formats.v, date, locale, timestamp);
		             break;
		            case 119:
		             resultString += date.getDay(); break;
		            case 120:
		             resultString +=
		              _processFormat(locale.formats.x, date, locale, timestamp);
		             break;
		            case 121:
		             resultString += ("" + date.getFullYear()).slice(2); break;
		            case 122:
		             if(_useUtcBasedDate && _customTimezoneOffset === 0)
		              resultString += extendedTZ ? "+00:00" : "+0000";
		             else {
		              var off;
		              if(_customTimezoneOffset !== 0)
		               off = _customTimezoneOffset / (60 * 1000);
		              else
		               off = - date.getTimezoneOffset();
		              var
		               sign = off < 0 ? "-" : "+",
		               sep = extendedTZ ? ":" : "",
		               hours = Math.floor(Math.abs(off / 60)),
		               mins = Math.abs(off % 60);
		              resultString += sign + padTill2(hours) + sep + padTill2(mins);
		             }
		             break;
		            default: resultString += format[i]; break;
		          }
		          padding = null;
		          isInScope = false;
		          continue;
		         }
		         if(currentCharCode === 37){isInScope = true; continue;}
		         resultString += format[i];
		        }
		        return resultString;
		       }
		       var strftime = _strftime;
		       strftime.localize =
		        function(locale){
		         return new
		                 Strftime
		                 (locale || _locale, _customTimezoneOffset, _useUtcBasedDate);
		        };
		       strftime.timezone =
		        function(timezone){
		         var
		          customTimezoneOffset = _customTimezoneOffset,
		          useUtcBasedDate = _useUtcBasedDate,
		          timezoneType = typeof timezone;
		         if(timezoneType === "number" || timezoneType === "string"){
		          useUtcBasedDate = true;
		          if(timezoneType === "string"){
		           var
		            sign = timezone[0] === "-" ? - 1 : 1,
		            hours = parseInt(timezone.slice(1, 3), 10),
		            minutes = parseInt(timezone.slice(3, 5), 10);
		           customTimezoneOffset = sign * (60 * hours + minutes) * 60 * 1000;
		          }
		          else if(timezoneType === "number")
		           customTimezoneOffset = timezone * 60 * 1000;
		         }
		         return new Strftime(_locale, customTimezoneOffset, useUtcBasedDate);
		        };
		       strftime.utc =
		        function(){return new Strftime(_locale, _customTimezoneOffset, true);};
		       return strftime;
		      }
		      function padTill2(numberToPad, paddingChar){
		       if(paddingChar === "" || numberToPad > 9) return numberToPad;
		       if(paddingChar == null) paddingChar = "0";
		       return paddingChar + numberToPad;
		      }
		      function padTill3(numberToPad){
		       if(numberToPad > 99) return numberToPad;
		       if(numberToPad > 9) return "0" + numberToPad;
		       return "00" + numberToPad;
		      }
		      function hours12(hour){
		       if(hour === 0) return 12; else if(hour > 12) return hour - 12;
		       return hour;
		      }
		      function weekNumber(date, firstWeekday){
		       firstWeekday = firstWeekday || "sunday";
		       var weekday = date.getDay();
		       if(firstWeekday === "monday")
		        if(weekday === 0) weekday = 6; else weekday--;
		       var
		        firstDayOfYearUtc = Date.UTC(date.getFullYear(), 0, 1),
		        dateUtc =
		          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
		        yday = Math.floor((dateUtc - firstDayOfYearUtc) / 86400000),
		        weekNum = (yday + 7 - weekday) / 7;
		       return Math.floor(weekNum);
		      }
		      function ordinal(number){
		       var i = number % 10, ii = number % 100;
		       if(ii >= 11 && ii <= 13 || i === 0 || i >= 4) return "th";
		       switch(i){case 1: return "st";case 2: return "nd";case 3: return "rd";
		       }
		      }
		      function getTimestampToUtcOffsetFor(date){
		       return (date.getTimezoneOffset() || 0) * 60000;
		      }
		     }
		     ());
		  }
		  (globalThis));
		(function(globalThis){
		   function _iterableToArrayLimit(r, l){
		    var
		     t =
		       null == r
		        ? null
		        : "undefined"
		         != typeof Symbol
		         && r[Symbol.iterator]
		         || r["@@iterator"];
		    if(null != t){
		     var e, n, i, u, a = [], f = ! 0, o = ! 1;
		     try{
		      if(i = (t = t.call(r)).next, 0 === l){if(Object(t) !== t) return; f = ! 1;
		      }
		      else
		       for
		       (;
		        ! (f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l);
		        f = ! 0)
		        ;
		     }
		     catch(r){o = ! 0, n = r;}
		     finally{
		      try{
		       if(! f && null != t.return && (u = t.return(), Object(u) !== u))
		        return;
		      }
		      finally{if(o) throw n;}
		     }
		     return a;
		    }
		   }
		   function ownKeys(e, r){
		    var t = Object.keys(e);
		    if(Object.getOwnPropertySymbols){
		     var o = Object.getOwnPropertySymbols(e);
		     r
		     &&
		      (o =
		       o.filter
		        (function(r){return Object.getOwnPropertyDescriptor(e, r).enumerable;})),
		     t.push.apply(t, o);
		    }
		    return t;
		   }
		   function _objectSpread2(e){
		    for(var r = 1; r < arguments.length; r++){
		     var t = null != arguments[r] ? arguments[r] : {};
		     r % 2
		      ? ownKeys
		         (Object(t), ! 0).forEach
		        (function(r){_defineProperty(e, r, t[r]);})
		      : Object.getOwnPropertyDescriptors
		        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
		        : ownKeys
		           (Object(t)).forEach
		          (function(r){
		            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
		           });
		    }
		    return e;
		   }
		   function _toPrimitive(t, r){
		    if("object" != typeof t || ! t) return t;
		    var e = t[Symbol.toPrimitive];
		    if(void 0 !== e){
		     var i = e.call(t, r || "default");
		     if("object" != typeof i) return i;
		     throw new TypeError("@@toPrimitive must return a primitive value.");
		    }
		    return ("string" === r ? String : Number)(t);
		   }
		   function _toPropertyKey(t){
		    var i = _toPrimitive(t, "string");
		    return "symbol" == typeof i ? i : String(i);
		   }
		   function _typeof(o){
		    "@babel/helpers - typeof";
		    return _typeof =
		            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
		             ? function(o){return typeof o;}
		             : function
		              (o){
		               return o && "function" == typeof Symbol
		                       && o.constructor === Symbol
		                       && o !== Symbol.prototype
		                       ? "symbol"
		                       : typeof o;
		              },
		           _typeof(o);
		   }
		   function _classCallCheck(instance, Constructor){
		    if(! (instance instanceof Constructor))
		     throw new TypeError("Cannot call a class as a function");
		   }
		   function _defineProperties(target, props){
		    for(var i = 0; i < props.length; i++){
		     var descriptor = props[i];
		     descriptor.enumerable = descriptor.enumerable || false;
		     descriptor.configurable = true;
		     if("value" in descriptor) descriptor.writable = true;
		     Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
		    }
		   }
		   function _createClass(Constructor, protoProps, staticProps){
		    if(protoProps) _defineProperties(Constructor.prototype, protoProps);
		    if(staticProps) _defineProperties(Constructor, staticProps);
		    Object.defineProperty(Constructor, "prototype", {writable: false});
		    return Constructor;
		   }
		   function _defineProperty(obj, key, value){
		    key = _toPropertyKey(key);
		    if(key in obj)
		     Object.defineProperty
		      (obj,
		       key,
		       {value: value, enumerable: true, configurable: true, writable: true});
		    else
		     obj[key] = value;
		    return obj;
		   }
		   function _inherits(subClass, superClass){
		    if(typeof superClass !== "function" && superClass !== null)
		     throw new TypeError("Super expression must either be null or a function");
		    subClass.prototype =
		     Object.create
		      (superClass && superClass.prototype,
		       {constructor: {value: subClass, writable: true, configurable: true}});
		    Object.defineProperty(subClass, "prototype", {writable: false});
		    if(superClass) _setPrototypeOf(subClass, superClass);
		   }
		   function _getPrototypeOf(o){
		    _getPrototypeOf =
		     Object.setPrototypeOf
		      ? Object.getPrototypeOf.bind()
		      : function(o){return o.__proto__ || Object.getPrototypeOf(o);};
		    return _getPrototypeOf(o);
		   }
		   function _setPrototypeOf(o, p){
		    _setPrototypeOf =
		     Object.setPrototypeOf
		      ? Object.setPrototypeOf.bind()
		      : function(o, p){o.__proto__ = p; return o;};
		    return _setPrototypeOf(o, p);
		   }
		   function _isNativeReflectConstruct(){
		    if(typeof Reflect === "undefined" || ! Reflect.construct) return false;
		    if(Reflect.construct.sham) return false;
		    if(typeof Proxy === "function") return true;
		    try{
		     Boolean.prototype.valueOf.call
		      (Reflect.construct(Boolean, [], function(){}));
		     return true;
		    }
		    catch(e){return false;}
		   }
		   function _assertThisInitialized(self){
		    if(self === void 0)
		     throw new
		            ReferenceError
		            ("this hasn't been initialised - super() hasn't been called");
		    return self;
		   }
		   function _possibleConstructorReturn(self, call){
		    if(call && (typeof call === "object" || typeof call === "function"))
		     return call;
		    else if(call !== void 0)
		     throw new
		            TypeError
		            ("Derived constructors may only return object or undefined");
		    return _assertThisInitialized(self);
		   }
		   function _createSuper(Derived){
		    var hasNativeReflectConstruct = _isNativeReflectConstruct();
		    return function(){
		     var Super = _getPrototypeOf(Derived), result;
		     if(hasNativeReflectConstruct){
		      var NewTarget = _getPrototypeOf(this).constructor;
		      result = Reflect.construct(Super, arguments, NewTarget);
		     }
		     else
		      result = Super.apply(this, arguments);
		     return _possibleConstructorReturn(this, result);};
		   }
		   function _superPropBase(object, property){
		    while(! Object.prototype.hasOwnProperty.call(object, property)){object = _getPrototypeOf(object); if(object === null) break;}
		    return object;
		   }
		   function _get(){
		    if(typeof Reflect !== "undefined" && Reflect.get)
		     _get = Reflect.get.bind();
		    else
		     _get =
		      function(target, property, receiver){
		       var base = _superPropBase(target, property);
		       if(! base) return;
		       var desc = Object.getOwnPropertyDescriptor(base, property);
		       if(desc.get)
		        return desc.get.call(arguments.length < 3 ? target : receiver);
		       return desc.value;
		      };
		    return _get.apply(this, arguments);
		   }
		   function _slicedToArray(arr, i){
		    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i)
		           || _unsupportedIterableToArray(arr, i)
		           || _nonIterableRest();
		   }
		   function _toConsumableArray(arr){
		    return _arrayWithoutHoles(arr) || _iterableToArray(arr)
		           || _unsupportedIterableToArray(arr)
		           || _nonIterableSpread();
		   }
		   function _arrayWithoutHoles(arr){
		    if(Array.isArray(arr)) return _arrayLikeToArray(arr);
		   }
		   function _arrayWithHoles(arr){if(Array.isArray(arr)) return arr;}
		   function _iterableToArray(iter){
		    if
		     (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null
		      || iter["@@iterator"] != null)
		     return Array.from(iter);
		   }
		   function _unsupportedIterableToArray(o, minLen){
		    if(! o) return;
		    if(typeof o === "string") return _arrayLikeToArray(o, minLen);
		    var n = Object.prototype.toString.call(o).slice(8, - 1);
		    if(n === "Object" && o.constructor) n = o.constructor.name;
		    if(n === "Map" || n === "Set") return Array.from(o);
		    if
		     (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
		     return _arrayLikeToArray(o, minLen);
		   }
		   function _arrayLikeToArray(arr, len){
		    if(len == null || len > arr.length) len = arr.length;
		    for(var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
		    return arr2;
		   }
		   function _nonIterableSpread(){
		    throw new
		           TypeError
		           ("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		   }
		   function _nonIterableRest(){
		    throw new
		           TypeError
		           ("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		   }
		   function _createForOfIteratorHelper(o, allowArrayLike){
		    var
		     it =
		       typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
		    if(! it){
		     if
		      (Array.isArray(o) || (it = _unsupportedIterableToArray(o))
		       || allowArrayLike  ){
		      if(it) o = it;
		      var i = 0, F = function(){};
		      return {s: F,
		              n:
		              function(){
		               if(i >= o.length) return {done: true};
		               return {done: false, value: o[i++]};
		              },
		              e: function(e){throw e;},
		              f: F};
		     }
		     throw new
		            TypeError
		            ("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		    }
		    var normalCompletion = true, didErr = false, err;
		    return {s: function(){it = it.call(o);},
		            n:
		            function(){
		             var step = it.next();
		             normalCompletion = step.done;
		             return step;
		            },
		            e: function(e){didErr = true; err = e;},
		            f:
		            function(){
		             try{if(! normalCompletion && it.return != null) it.return();}
		             finally{if(didErr) throw err;}
		            }};
		   }
		   var t = {};
		   function MakeIntrinsicClass(e, t){
		    Object.defineProperty
		     (e.prototype,
		      Symbol.toStringTag,
		      {value: t, writable: ! 1, enumerable: ! 1, configurable: ! 0});
		    var
		     _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(e)),
		     _step;
		    try{
		     for(_iterator.s(); ! (_step = _iterator.n()).done;){
		      var _t = _step.value, _r = Object.getOwnPropertyDescriptor(e, _t);
		      _r.configurable && _r.enumerable
		      && (_r.enumerable = ! 1, Object.defineProperty(e, _t, _r));
		     }
		    }
		    catch(err){_iterator.e(err);}
		    finally{_iterator.f();}
		    var
		     _iterator2 =
		       _createForOfIteratorHelper(Object.getOwnPropertyNames(e.prototype)),
		     _step2;
		    try{
		     for(_iterator2.s(); ! (_step2 = _iterator2.n()).done;){
		      var
		       _t2 = _step2.value,
		       _r2 = Object.getOwnPropertyDescriptor(e.prototype, _t2);
		      _r2.configurable && _r2.enumerable
		      && (_r2.enumerable = ! 1, Object.defineProperty(e.prototype, _t2, _r2));
		     }
		    }
		    catch(err){_iterator2.e(err);}
		    finally{_iterator2.f();}
		    DefineIntrinsic(t, e),
		    DefineIntrinsic("".concat(t, ".prototype"), e.prototype);
		   }
		   function DefineIntrinsic(e, r){
		    var o = "%".concat(e, "%");
		    if(void 0 !== t[o])
		     throw new Error("intrinsic ".concat(e, " already exists"));
		    t[o] = r;
		   }
		   function GetIntrinsic(e){return t[e];}
		   var
		    r,
		    o,
		    n = "slot-epochNanoSeconds",
		    a = "slot-timezone-identifier",
		    i = "slot-year",
		    s = "slot-month",
		    l = "slot-day",
		    d = "slot-hour",
		    m = "slot-minute",
		    c = "slot-second",
		    h = "slot-millisecond",
		    u = "slot-microsecond",
		    T = "slot-nanosecond",
		    p = "slot-calendar",
		    f = "slot-date-brand",
		    y = "slot-year-month-brand",
		    I = "slot-month-day-brand",
		    S = "slot-cached-instant",
		    g = "slot-time-zone",
		    w = "slot-years",
		    D = "slot-months",
		    G = "slot-weeks",
		    v = "slot-days",
		    C = "slot-hours",
		    O = "slot-minutes",
		    b = "slot-seconds",
		    E = "slot-milliseconds",
		    M = "slot-microseconds",
		    R = "slot-nanoseconds",
		    F = "slot-calendar-identifier",
		    Y = new WeakMap(),
		    P = Symbol["for"]("@@Temporal__GetSlots");
		   (r = globalThis)[P] || (r[P] = function(e){return Y.get(e);});
		   var Z = globalThis[P], B = Symbol["for"]("@@Temporal__CreateSlots");
		   (o = globalThis)[B] || (o[B] = function(e){Y.set(e, Object.create(null));});
		   var N = globalThis[B];
		   function HasSlot(e){
		    if(! e || "object" != _typeof(e)) return ! 1;
		    var r = Z(e);
		    for
		    (var
		      _len = arguments.length,
		      t = new Array(_len > 1 ? _len - 1 : 0),
		      _key = 1;
		     _key < _len;
		     _key++)
		     t[_key - 1] = arguments[_key];
		    return ! ! r && t.every(function(e){return e in r;});
		   }
		   function GetSlot(e, t){
		    var _Z, r = (_Z = Z(e)) === null || _Z === void 0 ? void 0 : _Z[t];
		    if(void 0 === r) throw new TypeError("Missing internal slot ".concat(t));
		    return r;
		   }
		   function SetSlot(e, t, r){
		    var o = Z(e);
		    if(void 0 === o)
		     throw new TypeError("Missing slots for the given container");
		    if(o[t]) throw new TypeError("".concat(t, " already has set"));
		    o[t] = r;
		   }
		   var
		    j =
		      /\.[-A-Za-z_]|\.\.[-A-Za-z._]{1,12}|\.[-A-Za-z_][-A-Za-z._]{0,12}|[A-Za-z_][-A-Za-z._]{0,13}/,
		    $ =
		      new
		       RegExp
		       ("(?:"
		        +
		         ["(?:".concat(j.source, ")(?:\\/(?:").concat(j.source, "))*"),
		           "Etc/GMT(?:0|[-+]\\d{1,2})",
		           "GMT[-+]?0",
		           "EST5EDT",
		           "CST6CDT",
		           "MST7MDT",
		           "PST8PDT",
		           /(?:[+\u2212-][0-2][0-9](?::?[0-5][0-9](?::?[0-5][0-9](?:[.,]\d{1,9})?)?)?)/.source].join
		          ("|")
		        + ")"),
		    k = /(?:[+\u2212-]\d{6}|\d{4})/,
		    U = /(?:0[1-9]|1[0-2])/,
		    A = /(?:0[1-9]|[12]\d|3[01])/,
		    L =
		      new
		       RegExp
		       ("(".concat(k.source, ")(?:-(").concat(U.source, ")-(").concat
		           (A.source, ")|(").concat
		          (U.source, ")(").concat
		         (A.source, "))")),
		    x =
		      /(\d{2})(?::(\d{2})(?::(\d{2})(?:[.,](\d{1,9}))?)?|(\d{2})(?:(\d{2})(?:[.,](\d{1,9}))?)?)?/,
		    W =
		      /([+\u2212-])([01][0-9]|2[0-3])(?::?([0-5][0-9])(?::?([0-5][0-9])(?:[.,](\d{1,9}))?)?)?/,
		    q = new RegExp("([zZ])|".concat(W.source, "?")),
		    H = /\[(!)?([a-z_][a-z0-9_-]*)=([A-Za-z0-9]+(?:-[A-Za-z0-9]+)*)\]/g,
		    V =
		      new
		       RegExp
		       (["^".concat(L.source),
		          "(?:(?:T|\\s+)".concat(x.source, "(?:").concat(q.source, ")?)?"),
		          "(?:\\[!?(".concat($.source, ")\\])?"),
		          "((?:".concat(H.source, ")*)$")].join
		         (""),
		        "i"),
		    z =
		      new
		       RegExp
		       (["^T?".concat(x.source),
		          "(?:".concat(q.source, ")?"),
		          "(?:\\[!?".concat($.source, "\\])?"),
		          "((?:".concat(H.source, ")*)$")].join
		         (""),
		        "i"),
		    _ =
		      new
		       RegExp
		       ("^(".concat(k.source, ")-?(").concat(U.source, ")(?:\\[!?").concat
		          ($.source, "\\])?((?:").concat
		         (H.source, ")*)$")),
		    J =
		      new
		       RegExp
		       ("^(?:--)?(".concat(U.source, ")-?(").concat(A.source, ")(?:\\[!?").concat
		          ($.source, "\\])?((?:").concat
		         (H.source, ")*)$")),
		    K = /(\d+)(?:[.,](\d{1,9}))?/,
		    X =
		      new
		       RegExp
		       ("(?:".concat(K.source, "H)?(?:").concat(K.source, "M)?(?:").concat
		         (K.source, "S)?")),
		    Q =
		      new
		       RegExp
		       ("^([+\u2212-])?P".concat
		          (/(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?/.source, "(?:T(?!$)").concat
		         (X.source, ")?$"),
		        "i"),
		    ee = Array.prototype.includes,
		    te = Array.prototype.push,
		    re = globalThis.Intl.DateTimeFormat,
		    oe = Math.min,
		    ne = Math.max,
		    ae = Math.abs,
		    ie = Math.floor,
		    se = Math.sign,
		    le = Math.trunc,
		    de = Number.isNaN,
		    me = Number.isFinite,
		    ce = Number,
		    he = String,
		    ue = Number.MAX_SAFE_INTEGER,
		    Te = Object.create,
		    pe = Object.getOwnPropertyDescriptor,
		    fe = Reflect.apply,
		    ye = Reflect.ownKeys,
		    Ie = 0n,
		    Se = 1n,
		    ge = 60n,
		    we = 24n,
		    De = 1000n,
		    Ge = 1000000n,
		    ve = 1000000000n,
		    Ce = BigInt(- 1),
		    Oe = 3600n * ve,
		    be = ge * ve,
		    Ee = Oe * we,
		    Me = BigInt(- 86400) * 100000000000000000n,
		    Re = 86400n * 100000000000000000n,
		    Fe = - 271821,
		    Ye = 275760,
		    Pe = BigInt(- 388152) * 10000000000000n,
		    Ze = Ee * 3660n,
		    Be = Ee * 366n,
		    Ne = Ee * 14n,
		    je =
		      ["iso8601",
		       "hebrew",
		       "islamic",
		       "islamic-umalqura",
		       "islamic-tbla",
		       "islamic-civil",
		       "islamic-rgsa",
		       "islamicc",
		       "persian",
		       "ethiopic",
		       "ethioaa",
		       "coptic",
		       "chinese",
		       "dangi",
		       "roc",
		       "indian",
		       "buddhist",
		       "japanese",
		       "gregory"];
		   function isZero(t){return t === Ie;}
		   function GetMethod(e, t){var r = e[t]; if(void 0 !== r) return r;}
		   function Call(e, t, r){
		    var o = arguments.length > 2 ? r : [];
		    return fe(e, t, o);
		   }
		   function IsObject(e){
		    return "object" == _typeof(e) && null !== e || "function" == typeof e;
		   }
		   function ToNumber(e){
		    if("bigint" == typeof e)
		     throw new TypeError("Cannot convert BigInt to number");
		    return ce(e);
		   }
		   function ToIntegerOrInfinity(e){
		    var t = ToNumber(e);
		    if(de(t) || 0 === t) return 0;
		    if(! me(t)) return t;
		    var r = ie(ae(t));
		    return 0 === r ? 0 : se(t) * r;
		   }
		   function IsIntegralNumber(e){
		    if("number" != typeof e || de(e) || ! me(e)) return ! 1;
		    var t = ae(e);
		    return ie(t) === t;
		   }
		   function ToString(e){
		    if("symbol" == _typeof(e))
		     throw new TypeError("Cannot convert a Symbol value to a String");
		    return he(e);
		   }
		   function ToIntegerWithTruncation(e){
		    var t = ToNumber(e);
		    if(0 === t) return 0;
		    if(de(t) || ! me(t)) throw new RangeError("invalid number value");
		    var r = le(t);
		    return 0 === r ? 0 : r;
		   }
		   function ToPositiveIntegerWithTruncation(e, t){
		    var r = ToIntegerWithTruncation(e);
		    if(r <= 0){
		     if(void 0 !== t)
		      throw new
		             RangeError
		             ("property '".concat(t, "' cannot be a a number less than one"));
		     throw new
		            RangeError
		            ("Cannot convert a number less than one to a positive integer");
		    }
		    return r;
		   }
		   function ToIntegerIfIntegral(e){
		    var t = ToNumber(e);
		    if(! me(t)) throw new RangeError("infinity is out of range");
		    if(! IsIntegralNumber(t))
		     throw new RangeError("unsupported fractional value ".concat(e));
		    return 0 === t ? 0 : t;
		   }
		   function divmod(t, r){return {quotient: t / r, remainder: t % r};}
		   function isNegativeJSBI(t){return t < Ie;}
		   function signJSBI(e){return isZero(e) ? 0 : isNegativeJSBI(e) ? - 1 : 1;}
		   function abs(t){return t < Ie ? t * Ce : t;}
		   var
		    $e =
		      new
		       Map
		       ([["year", ToIntegerWithTruncation],
		         ["month", ToPositiveIntegerWithTruncation],
		         ["monthCode", ToString],
		         ["day", ToPositiveIntegerWithTruncation],
		         ["hour", ToIntegerWithTruncation],
		         ["minute", ToIntegerWithTruncation],
		         ["second", ToIntegerWithTruncation],
		         ["millisecond", ToIntegerWithTruncation],
		         ["microsecond", ToIntegerWithTruncation],
		         ["nanosecond", ToIntegerWithTruncation],
		         ["years", ToIntegerIfIntegral],
		         ["months", ToIntegerIfIntegral],
		         ["weeks", ToIntegerIfIntegral],
		         ["days", ToIntegerIfIntegral],
		         ["hours", ToIntegerIfIntegral],
		         ["minutes", ToIntegerIfIntegral],
		         ["seconds", ToIntegerIfIntegral],
		         ["milliseconds", ToIntegerIfIntegral],
		         ["microseconds", ToIntegerIfIntegral],
		         ["nanoseconds", ToIntegerIfIntegral],
		         ["era", ToString],
		         ["eraYear", ToIntegerOrInfinity],
		         ["offset", ToString]]),
		    ke =
		      new
		       Map
		       ([["hour", 0],
		         ["minute", 0],
		         ["second", 0],
		         ["millisecond", 0],
		         ["microsecond", 0],
		         ["nanosecond", 0]]),
		    Ue =
		      [["years", "year", "date"],
		       ["months", "month", "date"],
		       ["weeks", "week", "date"],
		       ["days", "day", "date"],
		       ["hours", "hour", "time"],
		       ["minutes", "minute", "time"],
		       ["seconds", "second", "time"],
		       ["milliseconds", "millisecond", "time"],
		       ["microseconds", "microsecond", "time"],
		       ["nanoseconds", "nanosecond", "time"]],
		    Ae = new Map(Ue.map(function(e){return [e[0], e[1]];})),
		    Le =
		      new
		       Map
		       (Ue.map
		         (function(_ref){
		           var _ref2 = _slicedToArray(_ref, 2), e = _ref2[0], t = _ref2[1];
		           return [t, e];
		          })),
		    xe =
		      Ue.map
		       (function(_ref3){
		         var _ref4 = _slicedToArray(_ref3, 2), e = _ref4[1];
		         return e;
		        }),
		    We = Array.from(Ae.keys()).sort(),
		    qe = new Map();
		   function getIntlDateTimeFormatEnUsForTimeZone(e){
		    var t = qe.get(e);
		    return void 0 === t
		           &&
		            (t =
		              new
		               re
		               ("en-us",
		                {timeZone: he(e),
		                 hour12: ! 1,
		                 era: "short",
		                 year: "numeric",
		                 month: "numeric",
		                 day: "numeric",
		                 hour: "numeric",
		                 minute: "numeric",
		                 second: "numeric"}),
		             qe.set(e, t)),
		           t;
		   }
		   function ToObject(e){
		    if(null == e) throw new TypeError("Expected object not ".concat(e));
		    return Object(e);
		   }
		   function CopyDataProperties(e, t, r, o){
		    if(null == t) return;
		    var n = ye(t), _iterator3 = _createForOfIteratorHelper(n), _step3;
		    try{
		     var
		      _loop =
		        function(){
		         var a = _step3.value;
		         if
		          (!
		           r.some(function(e){return Object.is(e, a);})
		           && Object.prototype.propertyIsEnumerable.call(t, a)){
		          var _r3 = t[a];
		          if(o && o.some(function(e){return Object.is(e, _r3);})) return 1;
		          e[a] = _r3;
		         }
		        };
		     for(_iterator3.s(); ! (_step3 = _iterator3.n()).done;)
		      if(_loop()) continue;
		    }
		    catch(err){_iterator3.e(err);}
		    finally{_iterator3.f();}
		   }
		   function IsTemporalInstant(e){return HasSlot(e, n) && ! HasSlot(e, g, p);}
		   function IsTemporalTimeZone(e){return HasSlot(e, a);}
		   function IsTemporalCalendar(e){return HasSlot(e, F);}
		   function IsTemporalDuration(e){
		    return HasSlot(e, w, D, v, C, O, b, E, M, R);
		   }
		   function IsTemporalDate(e){return HasSlot(e, f);}
		   function IsTemporalTime(e){
		    return HasSlot(e, d, m, c, h, u, T) && ! HasSlot(e, i, s, l);
		   }
		   function IsTemporalDateTime(e){
		    return HasSlot(e, i, s, l, d, m, c, h, u, T);
		   }
		   function IsTemporalYearMonth(e){return HasSlot(e, y);}
		   function IsTemporalMonthDay(e){return HasSlot(e, I);}
		   function IsTemporalZonedDateTime(e){return HasSlot(e, n, g, p);}
		   function RejectTemporalLikeObject(e){
		    if(HasSlot(e, p) || HasSlot(e, g))
		     throw new
		            TypeError
		            ("with() does not support a calendar or timeZone property");
		    if(IsTemporalTime(e))
		     throw new
		            TypeError
		            ("with() does not accept Temporal.PlainTime, use withPlainTime() instead");
		    if(void 0 !== e.calendar)
		     throw new TypeError("with() does not support a calendar property");
		    if(void 0 !== e.timeZone)
		     throw new TypeError("with() does not support a timeZone property");
		   }
		   function ParseTemporalTimeZone(e){
		    var
		     _ParseTemporalTimeZon =
		       function(e){
		         if(new RegExp("^".concat($.source, "$"), "i").test(e))
		          return {ianaName: e};
		         try{
		          var _t3 = ParseISODateTime(e);
		          if(_t3.z || _t3.offset || _t3.ianaName) return _t3;
		         }
		         catch(_unused){}
		         throw new RangeError("Invalid time zone: ".concat(e));
		        }
		        (e),
		     t = _ParseTemporalTimeZon.ianaName,
		     r = _ParseTemporalTimeZon.offset,
		     o = _ParseTemporalTimeZon.z;
		    if(t) return GetCanonicalTimeZoneIdentifier(t);
		    if(o) return "UTC";
		    return FormatTimeZoneOffsetString(ParseTimeZoneOffsetString(r));
		   }
		   function MaybeFormatCalendarAnnotation(e, t){
		    return "never" === t
		            ? ""
		            : FormatCalendarAnnotation(ToTemporalCalendarIdentifier(e), t);
		   }
		   function FormatCalendarAnnotation(e, t){
		    if("never" === t) return "";
		    if("auto" === t && "iso8601" === e) return "";
		    return "[".concat("critical" === t ? "!" : "", "u-ca=").concat(e, "]");
		   }
		   function ParseISODateTime(e){
		    var t = V.exec(e);
		    if(! t) throw new RangeError("invalid ISO 8601 string: ".concat(e));
		    var r = t[1];
		    if("−" === r[0] && (r = "-".concat(r.slice(1))), "-000000" === r)
		     throw new RangeError("invalid ISO 8601 string: ".concat(e));
		    var
		     o = ToIntegerOrInfinity(r),
		     n = ToIntegerOrInfinity(t[2] || t[4]),
		     a = ToIntegerOrInfinity(t[3] || t[5]),
		     i = ToIntegerOrInfinity(t[6]),
		     s = void 0 !== t[6],
		     l = ToIntegerOrInfinity(t[7] || t[10]),
		     d = ToIntegerOrInfinity(t[8] || t[11]);
		    60 === d && (d = 59);
		    var
		     m = (t[9] || t[12]) + "000000000",
		     c = ToIntegerOrInfinity(m.slice(0, 3)),
		     h = ToIntegerOrInfinity(m.slice(3, 6)),
		     u = ToIntegerOrInfinity(m.slice(6, 9)),
		     T,
		     p = ! 1;
		    if(t[13])
		     T = void 0, p = ! 0;
		    else if(t[14] && t[15]){
		     var
		      _e2 = "-" === t[14] || "−" === t[14] ? "-" : "+",
		      _r4 = t[15] || "00",
		      _o = t[16] || "00",
		      _n = t[17] || "00",
		      _a = t[18] || "0";
		     if(T = "".concat(_e2).concat(_r4, ":").concat(_o), + _a){
		      for(; _a.endsWith("0");) _a = _a.slice(0, - 1);
		      T += ":".concat(_n, ".").concat(_a);
		     }
		     else
		      + _n && (T += ":".concat(_n));
		     "-00:00" === T && (T = "+00:00");
		    }
		    var
		     f = t[19],
		     y = t[20],
		     I,
		     _iterator4 = _createForOfIteratorHelper(y.matchAll(H)),
		     _step4;
		    try{
		     for(_iterator4.s(); ! (_step4 = _iterator4.n()).done;){
		      var
		       _step4$value = _slicedToArray(_step4.value, 4),
		       _e3 = _step4$value[1],
		       _t4 = _step4$value[2],
		       _r5 = _step4$value[3];
		      if("u-ca" === _t4)
		       void 0 === I && (I = _r5);
		      else if("!" === _e3)
		       throw new
		              RangeError
		              ("Unrecognized annotation: !".concat(_t4, "=").concat(_r5));
		     }
		    }
		    catch(err){_iterator4.e(err);}
		    finally{_iterator4.f();}
		    return RejectDateTime(o, n, a, i, l, d, c, h, u),
		           {year: o,
		            month: n,
		            day: a,
		            hasTime: s,
		            hour: i,
		            minute: l,
		            second: d,
		            millisecond: c,
		            microsecond: h,
		            nanosecond: u,
		            ianaName: f,
		            offset: T,
		            z: p,
		            calendar: I};
		   }
		   function ParseTemporalYearMonthString(e){
		    var t = _.exec(e), r, o, n, a;
		    if(t){
		     var _a2 = t[1];
		     if
		      ("−" === _a2[0] && (_a2 = "-".concat(_a2.slice(1))),
		       "-000000" === _a2)
		      throw new RangeError("invalid ISO 8601 string: ".concat(e));
		     r = ToIntegerOrInfinity(_a2), o = ToIntegerOrInfinity(t[2]);
		     var
		      _i = t[3],
		      _iterator5 = _createForOfIteratorHelper(_i.matchAll(H)),
		      _step5;
		     try{
		      for(_iterator5.s(); ! (_step5 = _iterator5.n()).done;){
		       var
		        _step5$value = _slicedToArray(_step5.value, 4),
		        _e4 = _step5$value[1],
		        _t5 = _step5$value[2],
		        _r6 = _step5$value[3];
		       if("u-ca" === _t5)
		        void 0 === n && (n = _r6);
		       else if("!" === _e4)
		        throw new
		               RangeError
		               ("Unrecognized annotation: !".concat(_t5, "=").concat(_r6));
		      }
		     }
		     catch(err){_iterator5.e(err);}
		     finally{_iterator5.f();}
		     if(void 0 !== n && "iso8601" !== n)
		      throw new
		             RangeError
		             ("YYYY-MM format is only valid with iso8601 calendar");
		    }
		    else {
		     var _ParseISODateTime, _t6;
		     if
		      (_ParseISODateTime = ParseISODateTime(e),
		       r = _ParseISODateTime.year,
		       o = _ParseISODateTime.month,
		       n = _ParseISODateTime.calendar,
		       a = _ParseISODateTime.day,
		       _t6 = _ParseISODateTime.z,
		       _t6)
		      throw new RangeError("Z designator not supported for PlainYearMonth");
		    }
		    return {year: r, month: o, calendar: n, referenceISODay: a};
		   }
		   function ParseTemporalMonthDayString(e){
		    var t = J.exec(e), r, o, n, a;
		    if(t){
		     r = ToIntegerOrInfinity(t[1]), o = ToIntegerOrInfinity(t[2]);
		     var
		      _e5 = t[3],
		      _iterator6 = _createForOfIteratorHelper(_e5.matchAll(H)),
		      _step6;
		     try{
		      for(_iterator6.s(); ! (_step6 = _iterator6.n()).done;){
		       var
		        _step6$value = _slicedToArray(_step6.value, 4),
		        _t7 = _step6$value[1],
		        _r7 = _step6$value[2],
		        _o2 = _step6$value[3];
		       if("u-ca" === _r7)
		        void 0 === n && (n = _o2);
		       else if("!" === _t7)
		        throw new
		               RangeError
		               ("Unrecognized annotation: !".concat(_r7, "=").concat(_o2));
		      }
		     }
		     catch(err){_iterator6.e(err);}
		     finally{_iterator6.f();}
		     if(void 0 !== n && "iso8601" !== n)
		      throw new RangeError("MM-DD format is only valid with iso8601 calendar");
		    }
		    else {
		     var _ParseISODateTime2, _t8;
		     if
		      (_ParseISODateTime2 = ParseISODateTime(e),
		       r = _ParseISODateTime2.month,
		       o = _ParseISODateTime2.day,
		       n = _ParseISODateTime2.calendar,
		       a = _ParseISODateTime2.year,
		       _t8 = _ParseISODateTime2.z,
		       _t8)
		      throw new RangeError("Z designator not supported for PlainMonthDay");
		    }
		    return {month: r, day: o, calendar: n, referenceISOYear: a};
		   }
		   function ParseTemporalInstant(e){
		    var
		     _ParseTemporalInstant =
		       function(e){
		         var t = ParseISODateTime(e);
		         if(! t.z && ! t.offset)
		          throw new RangeError("Temporal.Instant requires a time zone offset");
		         return t;
		        }
		        (e),
		     t = _ParseTemporalInstant.year,
		     r = _ParseTemporalInstant.month,
		     o = _ParseTemporalInstant.day,
		     n = _ParseTemporalInstant.hour,
		     a = _ParseTemporalInstant.minute,
		     i = _ParseTemporalInstant.second,
		     s = _ParseTemporalInstant.millisecond,
		     l = _ParseTemporalInstant.microsecond,
		     d = _ParseTemporalInstant.nanosecond,
		     m = _ParseTemporalInstant.offset,
		     c = _ParseTemporalInstant.z;
		    if(! c && ! m)
		     throw new RangeError("Temporal.Instant requires a time zone offset");
		    var
		     h = c ? 0 : ParseTimeZoneOffsetString(m),
		     _BalanceISODateTime = BalanceISODateTime(t, r, o, n, a, i, s, l, d - h);
		    t = _BalanceISODateTime.year;
		    r = _BalanceISODateTime.month;
		    o = _BalanceISODateTime.day;
		    n = _BalanceISODateTime.hour;
		    a = _BalanceISODateTime.minute;
		    i = _BalanceISODateTime.second;
		    s = _BalanceISODateTime.millisecond;
		    l = _BalanceISODateTime.microsecond;
		    d = _BalanceISODateTime.nanosecond;
		    var u = GetUTCEpochNanoseconds(t, r, o, n, a, i, s, l, d);
		    if(null === u)
		     throw new RangeError("DateTime outside of supported range");
		    return u;
		   }
		   function RegulateISODate(e, t, r, o){
		    var n = e, a = t, i = r;
		    switch(o){
		      case "reject":
		       RejectISODate(n, a, i); break;
		      case "constrain":
		       var _ConstrainISODate = ConstrainISODate(n, a, i);
		       n = _ConstrainISODate.year;
		       a = _ConstrainISODate.month;
		       i = _ConstrainISODate.day;
		    }
		    return {year: n, month: a, day: i};
		   }
		   function RegulateTime(e, t, r, o, n, a, i){
		    var s = e, l = t, d = r, m = o, c = n, h = a;
		    switch(i){
		      case "reject":
		       RejectTime(s, l, d, m, c, h); break;
		      case "constrain":
		       var
		        _ConstrainTime =
		          function(e, t, r, o, n, a){
		            var
		             i = ConstrainToRange(e, 0, 23),
		             s = ConstrainToRange(t, 0, 59),
		             l = ConstrainToRange(r, 0, 59),
		             d = ConstrainToRange(o, 0, 999),
		             m = ConstrainToRange(n, 0, 999),
		             c = ConstrainToRange(a, 0, 999);
		            return {hour: i,
		                    minute: s,
		                    second: l,
		                    millisecond: d,
		                    microsecond: m,
		                    nanosecond: c};
		           }
		           (s, l, d, m, c, h);
		       s = _ConstrainTime.hour;
		       l = _ConstrainTime.minute;
		       d = _ConstrainTime.second;
		       m = _ConstrainTime.millisecond;
		       c = _ConstrainTime.microsecond;
		       h = _ConstrainTime.nanosecond;
		    }
		    return {hour: s,
		            minute: l,
		            second: d,
		            millisecond: m,
		            microsecond: c,
		            nanosecond: h};
		   }
		   function ToTemporalDurationRecord(e){
		    if(! IsObject(e))
		     return function(e){
		              var t = Q.exec(e);
		              if(! t) throw new RangeError("invalid duration: ".concat(e));
		              if(t.slice(2).every(function(e){return void 0 === e;}))
		               throw new RangeError("invalid duration: ".concat(e));
		              var
		               r = "-" === t[1] || "−" === t[1] ? - 1 : 1,
		               o = void 0 === t[2] ? 0 : ToIntegerWithTruncation(t[2]) * r,
		               n = void 0 === t[3] ? 0 : ToIntegerWithTruncation(t[3]) * r,
		               a = void 0 === t[4] ? 0 : ToIntegerWithTruncation(t[4]) * r,
		               i = void 0 === t[5] ? 0 : ToIntegerWithTruncation(t[5]) * r,
		               s = void 0 === t[6] ? 0 : ToIntegerWithTruncation(t[6]) * r,
		               l = t[7],
		               d = t[8],
		               m = t[9],
		               c = t[10],
		               h = t[11],
		               u = 0,
		               T = 0,
		               p = 0;
		              if(void 0 !== l){
		               var _ref5, _ref6;
		               if
		                ((_ref5 =
		                   (_ref6 = d !== null && d !== void 0 ? d : m) !== null
		                    && _ref6 !== void 0
		                    ? _ref6
		                    : c)
		                  !== null
		                  && _ref5 !== void 0
		                  ? _ref5
		                  : h)
		                throw new
		                       RangeError
		                       ("only the smallest unit can be fractional");
		               p =
		                3600 * ToIntegerOrInfinity((l + "000000000").slice(0, 9)) * r;
		              }
		              else if
		               (u = void 0 === d ? 0 : ToIntegerWithTruncation(d) * r,
		                void 0 !== m){
		               if(c !== null && c !== void 0 ? c : h)
		                throw new
		                       RangeError
		                       ("only the smallest unit can be fractional");
		               p = 60 * ToIntegerOrInfinity((m + "000000000").slice(0, 9)) * r;
		              }
		              else
		               T = void 0 === c ? 0 : ToIntegerWithTruncation(c) * r,
		               void 0 !== h
		               && (p = ToIntegerOrInfinity((h + "000000000").slice(0, 9)) * r);
		              var f = p % 1e3, y = le(p / 1e3) % 1e3, I = le(p / 1e6) % 1e3;
		              return T += le(p / 1e9) % 60,
		                     u += le(p / 6e10),
		                     RejectDuration(o, n, a, i, s, u, T, I, y, f),
		                     {years: o,
		                      months: n,
		                      weeks: a,
		                      days: i,
		                      hours: s,
		                      minutes: u,
		                      seconds: T,
		                      milliseconds: I,
		                      microseconds: y,
		                      nanoseconds: f};
		             }
		             (ToString(e));
		    if(IsTemporalDuration(e))
		     return {years: GetSlot(e, w),
		             months: GetSlot(e, D),
		             weeks: GetSlot(e, G),
		             days: GetSlot(e, v),
		             hours: GetSlot(e, C),
		             minutes: GetSlot(e, O),
		             seconds: GetSlot(e, b),
		             milliseconds: GetSlot(e, E),
		             microseconds: GetSlot(e, M),
		             nanoseconds: GetSlot(e, R)};
		    var
		     t =
		       {years: 0,
		        months: 0,
		        weeks: 0,
		        days: 0,
		        hours: 0,
		        minutes: 0,
		        seconds: 0,
		        milliseconds: 0,
		        microseconds: 0,
		        nanoseconds: 0},
		     r =
		       function(e){
		         if(! IsObject(e)) throw new TypeError("invalid duration-like");
		         var
		          t =
		            {years: void 0,
		             months: void 0,
		             weeks: void 0,
		             days: void 0,
		             hours: void 0,
		             minutes: void 0,
		             seconds: void 0,
		             milliseconds: void 0,
		             microseconds: void 0,
		             nanoseconds: void 0},
		          r = ! 1,
		          _iterator7 = _createForOfIteratorHelper(We),
		          _step7;
		         try{
		          for(_iterator7.s(); ! (_step7 = _iterator7.n()).done;){
		           var _o3 = _step7.value, _n2 = e[_o3];
		           void 0 !== _n2 && (r = ! 0, t[_o3] = ToIntegerIfIntegral(_n2));
		          }
		         }
		         catch(err){_iterator7.e(err);}
		         finally{_iterator7.f();}
		         if(! r) throw new TypeError("invalid duration-like");
		         return t;
		        }
		        (e),
		     _iterator8 = _createForOfIteratorHelper(We),
		     _step8;
		    try{
		     for(_iterator8.s(); ! (_step8 = _iterator8.n()).done;){
		      var _e6 = _step8.value, _o4 = r[_e6];
		      void 0 !== _o4 && (t[_e6] = _o4);
		     }
		    }
		    catch(err){_iterator8.e(err);}
		    finally{_iterator8.f();}
		    var
		     o = t.years,
		     n = t.months,
		     a = t.weeks,
		     i = t.days,
		     s = t.hours,
		     l = t.minutes,
		     d = t.seconds,
		     m = t.milliseconds,
		     c = t.microseconds,
		     h = t.nanoseconds;
		    return RejectDuration(o, n, a, i, s, l, d, m, c, h),
		           {years: o,
		            months: n,
		            weeks: a,
		            days: i,
		            hours: s,
		            minutes: l,
		            seconds: d,
		            milliseconds: m,
		            microseconds: c,
		            nanoseconds: h};
		   }
		   function ToTemporalOverflow(e){
		    return void 0 === e
		            ? "constrain"
		            : GetOption(e, "overflow", ["constrain", "reject"], "constrain");
		   }
		   function ToTemporalDisambiguation(e){
		    return void 0 === e
		            ? "compatible"
		            : GetOption
		              (e,
		               "disambiguation",
		               ["compatible", "earlier", "later", "reject"],
		               "compatible");
		   }
		   function ToTemporalRoundingMode(e, t){
		    return GetOption
		            (e,
		             "roundingMode",
		             ["ceil",
		              "floor",
		              "expand",
		              "trunc",
		              "halfCeil",
		              "halfFloor",
		              "halfExpand",
		              "halfTrunc",
		              "halfEven"],
		             t);
		   }
		   function ToTemporalOffset(e, t){
		    return void 0 === e
		            ? t
		            : GetOption(e, "offset", ["prefer", "use", "ignore", "reject"], t);
		   }
		   function ToCalendarNameOption(e){
		    return GetOption
		            (e,
		             "calendarName",
		             ["auto", "always", "never", "critical"],
		             "auto");
		   }
		   function ToTemporalRoundingIncrement(e){
		    var t = e.roundingIncrement;
		    if(void 0 === t) return 1;
		    if(t = ToNumber(t), ! me(t))
		     throw new RangeError("roundingIncrement must be finite");
		    var r = le(t);
		    if(r < 1 || r > 1e9)
		     throw new
		            RangeError
		            ("roundingIncrement must be at least 1 and at most 1e9, not ".concat
		              (t));
		    return r;
		   }
		   function ValidateTemporalRoundingIncrement(e, t, r){
		    var o = r ? t : t - 1;
		    if(e > o)
		     throw new
		            RangeError
		            ("roundingIncrement must be at least 1 and less than ".concat
		               (o, ", not ").concat
		              (e));
		    if(t % e != 0)
		     throw new
		            RangeError
		            ("Rounding increment must divide evenly into ".concat(t));
		   }
		   function ToFractionalSecondDigits(e){
		    var t = e.fractionalSecondDigits;
		    if(void 0 === t) return "auto";
		    if("number" != typeof t){
		     if("auto" !== ToString(t))
		      throw new
		             RangeError
		             ("fractionalSecondDigits must be 'auto' or 0 through 9, not ".concat
		               (t));
		     return "auto";
		    }
		    var r = ie(t);
		    if(! me(r) || r < 0 || r > 9)
		     throw new
		            RangeError
		            ("fractionalSecondDigits must be 'auto' or 0 through 9, not ".concat
		              (t));
		    return r;
		   }
		   function ToSecondsStringPrecisionRecord(e, t){
		    switch(e){
		      case "minute":
		       return {precision: "minute", unit: "minute", increment: 1};
		      case "second":
		       return {precision: 0, unit: "second", increment: 1};
		      case "millisecond":
		       return {precision: 3, unit: "millisecond", increment: 1};
		      case "microsecond":
		       return {precision: 6, unit: "microsecond", increment: 1};
		      case "nanosecond":
		       return {precision: 9, unit: "nanosecond", increment: 1};
		    }
		    switch(t){
		      case "auto":
		       return {precision: t, unit: "nanosecond", increment: 1};
		      case 0:
		       return {precision: t, unit: "second", increment: 1};
		      case 1:
		      case 2:
		      case 3:
		       return {precision: t,
		               unit: "millisecond",
		               increment: Math.pow(10, 3 - t)};
		      case 4:
		      case 5:
		      case 6:
		       return {precision: t,
		               unit: "microsecond",
		               increment: Math.pow(10, 6 - t)};
		      case 7:
		      case 8:
		      case 9:
		       return {precision: t,
		               unit: "nanosecond",
		               increment: Math.pow(10, 9 - t)};
		      default:
		       throw new
		              RangeError
		              ("fractionalSecondDigits must be 'auto' or 0 through 9, not ".concat
		                (t));
		    }
		   }
		   var He = Symbol("~required~");
		   function GetTemporalUnit(e, t, r, o){
		    var
		     n =
		       arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [],
		     a = [];
		    for(var _i2 = 0, _Ue = Ue; _i2 < _Ue.length; _i2++){
		     var
		      _Ue$_i = _slicedToArray(_Ue[_i2], 3),
		      _e7 = _Ue$_i[1],
		      _t9 = _Ue$_i[2];
		     "datetime" !== r && r !== _t9 || a.push(_e7);
		    }
		    a.push.apply(a, _toConsumableArray(n));
		    var i = o;
		    i === He ? i = void 0 : void 0 !== i && a.push(i);
		    var s = [].concat(a);
		    for(var _i3 = 0, _a3 = a; _i3 < _a3.length; _i3++){
		     var _e8 = _a3[_i3], _t10 = Le.get(_e8);
		     void 0 !== _t10 && s.push(_t10);
		    }
		    var l = GetOption(e, t, s, i);
		    if(void 0 === l && o === He)
		     throw new RangeError("".concat(t, " is required"));
		    return Ae.has(l) ? Ae.get(l) : l;
		   }
		   function ToRelativeTemporalObject(e){
		    var t = e.relativeTo;
		    if(void 0 === t) return t;
		    var r, o, n, a, i, s, l, d, m, c, h, u, T = "option", p = ! 1;
		    if(IsObject(t)){
		     var _InterpretTemporalDat;
		     if(IsTemporalZonedDateTime(t) || IsTemporalDate(t)) return t;
		     if(IsTemporalDateTime(t)) return TemporalDateTimeToDate(t);
		     c = GetTemporalCalendarSlotValueWithISODefault(t);
		     var
		      _e9 =
		        CalendarFields
		         (c,
		          ["day",
		           "hour",
		           "microsecond",
		           "millisecond",
		           "minute",
		           "month",
		           "monthCode",
		           "nanosecond",
		           "second",
		           "year"]);
		     _e9.push("timeZone", "offset");
		     var _p = PrepareTemporalFields(t, _e9, []), _f = Te(null);
		     _f.overflow = "constrain",
		     _InterpretTemporalDat = InterpretTemporalDateTimeFields(c, _p, _f),
		     r = _InterpretTemporalDat.year,
		     o = _InterpretTemporalDat.month,
		     n = _InterpretTemporalDat.day,
		     a = _InterpretTemporalDat.hour,
		     i = _InterpretTemporalDat.minute,
		     s = _InterpretTemporalDat.second,
		     l = _InterpretTemporalDat.millisecond,
		     d = _InterpretTemporalDat.microsecond,
		     m = _InterpretTemporalDat.nanosecond,
		     u = _p.offset,
		     void 0 === u && (T = "wall"),
		     h = _p.timeZone,
		     void 0 !== h && (h = ToTemporalTimeZoneSlotValue(h));
		    }
		    else {
		     var _ParseISODateTime3, _e10, _f2;
		     if
		      (_ParseISODateTime3 = ParseISODateTime(ToString(t)),
		       r = _ParseISODateTime3.year,
		       o = _ParseISODateTime3.month,
		       n = _ParseISODateTime3.day,
		       a = _ParseISODateTime3.hour,
		       i = _ParseISODateTime3.minute,
		       s = _ParseISODateTime3.second,
		       l = _ParseISODateTime3.millisecond,
		       d = _ParseISODateTime3.microsecond,
		       m = _ParseISODateTime3.nanosecond,
		       c = _ParseISODateTime3.calendar,
		       _e10 = _ParseISODateTime3.ianaName,
		       u = _ParseISODateTime3.offset,
		       _f2 = _ParseISODateTime3.z,
		       _e10)
		      h = ToTemporalTimeZoneSlotValue(_e10),
		      _f2 ? T = "exact" : u || (T = "wall"),
		      p = ! 0;
		     else if(_f2)
		      throw new
		             RangeError
		             ("Z designator not supported for PlainDate relativeTo; either remove the Z or add a bracketed time zone");
		     if(c || (c = "iso8601"), ! IsBuiltinCalendar(c))
		      throw new RangeError("invalid calendar identifier ".concat(c));
		     c = ASCIILowercase(c);
		    }
		    if(void 0 === h) return CreateTemporalDate(r, o, n, c);
		    return CreateTemporalZonedDateTime
		            (InterpretISODateTimeOffset
		              (r,
		               o,
		               n,
		               a,
		               i,
		               s,
		               l,
		               d,
		               m,
		               T,
		               "option" === T ? ParseTimeZoneOffsetString(u) : 0,
		               h,
		               "compatible",
		               "reject",
		               p),
		             h,
		             c);
		   }
		   function DefaultTemporalLargestUnit(e, t, r, o, n, a, i, s, l, d){
		    for
		    (var
		      _i4 = 0,
		      _arr =
		        [["years", e],
		         ["months", t],
		         ["weeks", r],
		         ["days", o],
		         ["hours", n],
		         ["minutes", a],
		         ["seconds", i],
		         ["milliseconds", s],
		         ["microseconds", l],
		         ["nanoseconds", d]];
		     _i4 < _arr.length;
		     _i4++){
		     var
		      _arr$_i = _slicedToArray(_arr[_i4], 2),
		      _m = _arr$_i[0],
		      _c = _arr$_i[1];
		     if(0 !== _c) return Ae.get(_m);
		    }
		    return "nanosecond";
		   }
		   function LargerOfTwoTemporalUnits(e, t){
		    return xe.indexOf(e) > xe.indexOf(t) ? t : e;
		   }
		   function PrepareTemporalFields(e, t, r){
		    var
		     _ref7 =
		       arguments.length > 3 && arguments[3] !== undefined
		        ? arguments[3]
		        : {emptySourceErrorMessage: "no supported properties found"},
		     o = _ref7.emptySourceErrorMessage,
		     n = Te(null),
		     a = ! 1;
		    t.sort();
		    var _iterator9 = _createForOfIteratorHelper(t), _step9;
		    try{
		     for(_iterator9.s(); ! (_step9 = _iterator9.n()).done;){
		      var _o5 = _step9.value, _t11 = e[_o5];
		      if(void 0 !== _t11)
		       a = ! 0, $e.has(_o5) && (_t11 = $e.get(_o5)(_t11)), n[_o5] = _t11;
		      else if("partial" !== r){
		       if(ee.call(r, _o5))
		        throw new
		               TypeError
		               ("required property '".concat(_o5, "' missing or undefined"));
		       _t11 = ke.get(_o5), n[_o5] = _t11;
		      }
		     }
		    }
		    catch(err){_iterator9.e(err);}
		    finally{_iterator9.f();}
		    if("partial" === r && ! a) throw new TypeError(o);
		    return n;
		   }
		   function ToTemporalTimeRecord(e){
		    var
		     t =
		       arguments.length > 1 && arguments[1] !== undefined
		        ? arguments[1]
		        : "complete",
		     r =
		       ["hour",
		        "microsecond",
		        "millisecond",
		        "minute",
		        "nanosecond",
		        "second"],
		     o =
		       PrepareTemporalFields
		        (e, r, "partial", {emptySourceErrorMessage: "invalid time-like"}),
		     n = {};
		    for(var _i5 = 0, _r8 = r; _i5 < _r8.length; _i5++){
		     var _e11 = _r8[_i5], _r9 = pe(o, _e11);
		     void 0 !== _r9 ? n[_e11] = _r9.value : "complete" === t && (n[_e11] = 0);
		    }
		    return n;
		   }
		   function ToTemporalDate(e, t){
		    var r = e;
		    if(IsObject(r)){
		     if(IsTemporalDate(r)) return r;
		     if
		      (IsTemporalZonedDateTime(r)
		       &&
		        (ToTemporalOverflow(t),
		         r = GetPlainDateTimeFor(GetSlot(r, g), GetSlot(r, S), GetSlot(r, p))),
		       IsTemporalDateTime(r))
		      return ToTemporalOverflow(t),
		             CreateTemporalDate
		              (GetSlot(r, i), GetSlot(r, s), GetSlot(r, l), GetSlot(r, p));
		     var _e12 = GetTemporalCalendarSlotValueWithISODefault(r);
		     return CalendarDateFromFields
		             (_e12,
		              PrepareTemporalFields
		               (r,
		                CalendarFields(_e12, ["day", "month", "monthCode", "year"]),
		                []),
		              t);
		    }
		    ToTemporalOverflow(t);
		    var
		     _ParseTemporalDateStr =
		       function(e){return ParseISODateTime(e);}(ToString(r)),
		     o = _ParseTemporalDateStr.year,
		     n = _ParseTemporalDateStr.month,
		     a = _ParseTemporalDateStr.day,
		     d = _ParseTemporalDateStr.calendar,
		     m = _ParseTemporalDateStr.z;
		    if(m) throw new RangeError("Z designator not supported for PlainDate");
		    if(d || (d = "iso8601"), ! IsBuiltinCalendar(d))
		     throw new RangeError("invalid calendar identifier ".concat(d));
		    return d = ASCIILowercase(d), CreateTemporalDate(o, n, a, d);
		   }
		   function InterpretTemporalDateTimeFields(e, t, r){
		    var
		     _RegulateTime,
		     _ToTemporalTimeRecord = ToTemporalTimeRecord(t),
		     o = _ToTemporalTimeRecord.hour,
		     n = _ToTemporalTimeRecord.minute,
		     a = _ToTemporalTimeRecord.second,
		     d = _ToTemporalTimeRecord.millisecond,
		     m = _ToTemporalTimeRecord.microsecond,
		     c = _ToTemporalTimeRecord.nanosecond,
		     h = ToTemporalOverflow(r),
		     u = CalendarDateFromFields(e, t, r),
		     T = GetSlot(u, i),
		     p = GetSlot(u, s),
		     f = GetSlot(u, l);
		    return _RegulateTime = RegulateTime(o, n, a, d, m, c, h),
		           o = _RegulateTime.hour,
		           n = _RegulateTime.minute,
		           a = _RegulateTime.second,
		           d = _RegulateTime.millisecond,
		           m = _RegulateTime.microsecond,
		           c = _RegulateTime.nanosecond,
		           {year: T,
		            month: p,
		            day: f,
		            hour: o,
		            minute: n,
		            second: a,
		            millisecond: d,
		            microsecond: m,
		            nanosecond: c};
		   }
		   function ToTemporalDateTime(e, t){
		    var r, o, n, a, d, m, c, h, u, T;
		    if(IsObject(e)){
		     if(IsTemporalDateTime(e)) return e;
		     if(IsTemporalZonedDateTime(e))
		      return ToTemporalOverflow(t),
		             GetPlainDateTimeFor(GetSlot(e, g), GetSlot(e, S), GetSlot(e, p));
		     if(IsTemporalDate(e))
		      return ToTemporalOverflow(t),
		             CreateTemporalDateTime
		              (GetSlot(e, i),
		               GetSlot(e, s),
		               GetSlot(e, l),
		               0,
		               0,
		               0,
		               0,
		               0,
		               0,
		               GetSlot(e, p));
		     T = GetTemporalCalendarSlotValueWithISODefault(e);
		     var
		      _f3 =
		        PrepareTemporalFields
		         (e,
		          CalendarFields
		           (T,
		            ["day",
		             "hour",
		             "microsecond",
		             "millisecond",
		             "minute",
		             "month",
		             "monthCode",
		             "nanosecond",
		             "second",
		             "year"]),
		          []),
		      _InterpretTemporalDat2 = InterpretTemporalDateTimeFields(T, _f3, t);
		     r = _InterpretTemporalDat2.year;
		     o = _InterpretTemporalDat2.month;
		     n = _InterpretTemporalDat2.day;
		     a = _InterpretTemporalDat2.hour;
		     d = _InterpretTemporalDat2.minute;
		     m = _InterpretTemporalDat2.second;
		     c = _InterpretTemporalDat2.millisecond;
		     h = _InterpretTemporalDat2.microsecond;
		     u = _InterpretTemporalDat2.nanosecond;
		    }
		    else {
		     var _ParseTemporalDateTim, _i6;
		     if
		      (ToTemporalOverflow(t),
		       _ParseTemporalDateTim =
		        function(e){return ParseISODateTime(e);}(ToString(e)),
		       r = _ParseTemporalDateTim.year,
		       o = _ParseTemporalDateTim.month,
		       n = _ParseTemporalDateTim.day,
		       a = _ParseTemporalDateTim.hour,
		       d = _ParseTemporalDateTim.minute,
		       m = _ParseTemporalDateTim.second,
		       c = _ParseTemporalDateTim.millisecond,
		       h = _ParseTemporalDateTim.microsecond,
		       u = _ParseTemporalDateTim.nanosecond,
		       T = _ParseTemporalDateTim.calendar,
		       _i6 = _ParseTemporalDateTim.z,
		       _i6)
		      throw new RangeError("Z designator not supported for PlainDateTime");
		     if
		      (RejectDateTime(r, o, n, a, d, m, c, h, u),
		       T || (T = "iso8601"),
		       !
		       IsBuiltinCalendar(T))
		      throw new RangeError("invalid calendar identifier ".concat(T));
		     T = ASCIILowercase(T);
		    }
		    return CreateTemporalDateTime(r, o, n, a, d, m, c, h, u, T);
		   }
		   function ToTemporalDuration(e){
		    if(IsTemporalDuration(e)) return e;
		    var
		     _ToTemporalDurationRe = ToTemporalDurationRecord(e),
		     t = _ToTemporalDurationRe.years,
		     r = _ToTemporalDurationRe.months,
		     o = _ToTemporalDurationRe.weeks,
		     n = _ToTemporalDurationRe.days,
		     a = _ToTemporalDurationRe.hours,
		     i = _ToTemporalDurationRe.minutes,
		     s = _ToTemporalDurationRe.seconds,
		     l = _ToTemporalDurationRe.milliseconds,
		     d = _ToTemporalDurationRe.microseconds,
		     m = _ToTemporalDurationRe.nanoseconds;
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (t, r, o, n, a, i, s, l, d, m);
		   }
		   function ToTemporalInstant(e){
		    if(IsTemporalInstant(e)) return e;
		    if(IsTemporalZonedDateTime(e))
		     return new (GetIntrinsic("%Temporal.Instant%"))(GetSlot(e, n));
		    var t = ParseTemporalInstant(ToString(e));
		    return new (GetIntrinsic("%Temporal.Instant%"))(t);
		   }
		   function ToTemporalMonthDay(e, t){
		    var r = e;
		    if(IsObject(r)){
		     if(IsTemporalMonthDay(r)) return r;
		     var _e13, _o6;
		     if(HasSlot(r, p))
		      _e13 = GetSlot(r, p), _o6 = ! 1;
		     else {
		      var _t12 = r.calendar;
		      _o6 = void 0 === _t12,
		      void 0 === _t12 && (_t12 = "iso8601"),
		      _e13 = ToTemporalCalendarSlotValue(_t12);
		     }
		     var
		      _n3 =
		        PrepareTemporalFields
		         (r, CalendarFields(_e13, ["day", "month", "monthCode", "year"]), []);
		     return _o6 && void 0 !== _n3.month && void 0 === _n3.monthCode
		            && void 0 === _n3.year
		            && (_n3.year = 1972),
		            CalendarMonthDayFromFields(_e13, _n3, t);
		    }
		    ToTemporalOverflow(t);
		    var
		     _ParseTemporalMonthDa = ParseTemporalMonthDayString(ToString(r)),
		     o = _ParseTemporalMonthDa.month,
		     n = _ParseTemporalMonthDa.day,
		     a = _ParseTemporalMonthDa.referenceISOYear,
		     i = _ParseTemporalMonthDa.calendar;
		    if(void 0 === i && (i = "iso8601"), ! IsBuiltinCalendar(i))
		     throw new RangeError("invalid calendar identifier ".concat(i));
		    if(i = ASCIILowercase(i), void 0 === a)
		     return RejectISODate(1972, o, n), CreateTemporalMonthDay(o, n, i);
		    return CalendarMonthDayFromFields(i, CreateTemporalMonthDay(o, n, i, a));
		   }
		   function ToTemporalTime(e){
		    var
		     _ParseTemporalTimeStr,
		     t =
		       arguments.length > 1 && arguments[1] !== undefined
		        ? arguments[1]
		        : "constrain",
		     r,
		     o,
		     n,
		     a,
		     i,
		     s,
		     l = e;
		    if(IsObject(l)){
		     var _ToTemporalTimeRecord2, _RegulateTime2;
		     if(IsTemporalTime(l)) return l;
		     if
		      (IsTemporalZonedDateTime(l)
		       &&
		        (l = GetPlainDateTimeFor(GetSlot(l, g), GetSlot(l, S), GetSlot(l, p))),
		       IsTemporalDateTime(l))
		      return new
		              (GetIntrinsic("%Temporal.PlainTime%"))
		              (GetSlot(l, d),
		               GetSlot(l, m),
		               GetSlot(l, c),
		               GetSlot(l, h),
		               GetSlot(l, u),
		               GetSlot(l, T));
		     _ToTemporalTimeRecord2 = ToTemporalTimeRecord(l),
		     r = _ToTemporalTimeRecord2.hour,
		     o = _ToTemporalTimeRecord2.minute,
		     n = _ToTemporalTimeRecord2.second,
		     a = _ToTemporalTimeRecord2.millisecond,
		     i = _ToTemporalTimeRecord2.microsecond,
		     s = _ToTemporalTimeRecord2.nanosecond,
		     _RegulateTime2 = RegulateTime(r, o, n, a, i, s, t),
		     r = _RegulateTime2.hour,
		     o = _RegulateTime2.minute,
		     n = _RegulateTime2.second,
		     a = _RegulateTime2.millisecond,
		     i = _RegulateTime2.microsecond,
		     s = _RegulateTime2.nanosecond;
		    }
		    else
		     _ParseTemporalTimeStr =
		      function(e){
		        var t = z.exec(e), r, o, n, a, i, s, l;
		        if(t){
		         r = ToIntegerOrInfinity(t[1]),
		         o = ToIntegerOrInfinity(t[2] || t[5]),
		         n = ToIntegerOrInfinity(t[3] || t[6]),
		         60 === n && (n = 59);
		         var _e14 = (t[4] || t[7]) + "000000000";
		         a = ToIntegerOrInfinity(_e14.slice(0, 3)),
		         i = ToIntegerOrInfinity(_e14.slice(3, 6)),
		         s = ToIntegerOrInfinity(_e14.slice(6, 9)),
		         l = t[14];
		         var _iterator10 = _createForOfIteratorHelper(l.matchAll(H)), _step10;
		         try{
		          for(_iterator10.s(); ! (_step10 = _iterator10.n()).done;){
		           var
		            _step10$value = _slicedToArray(_step10.value, 4),
		            _e15 = _step10$value[1],
		            _t13 = _step10$value[2],
		            _r10 = _step10$value[3];
		           if("u-ca" !== _t13 && "!" === _e15)
		            throw new
		                   RangeError
		                   ("Unrecognized annotation: !".concat(_t13, "=").concat(_r10));
		          }
		         }
		         catch(err){_iterator10.e(err);}
		         finally{_iterator10.f();}
		         if(t[8])
		          throw new RangeError("Z designator not supported for PlainTime");
		        }
		        else {
		         var _ParseISODateTime4, _t14, _l;
		         if
		          (_ParseISODateTime4 = ParseISODateTime(e),
		           _l = _ParseISODateTime4.hasTime,
		           r = _ParseISODateTime4.hour,
		           o = _ParseISODateTime4.minute,
		           n = _ParseISODateTime4.second,
		           a = _ParseISODateTime4.millisecond,
		           i = _ParseISODateTime4.microsecond,
		           s = _ParseISODateTime4.nanosecond,
		           _t14 = _ParseISODateTime4.z,
		           !
		           _l)
		          throw new RangeError("time is missing in string: ".concat(e));
		         if(_t14)
		          throw new RangeError("Z designator not supported for PlainTime");
		        }
		        if(/[tT ][0-9][0-9]/.test(e))
		         return {hour: r,
		                 minute: o,
		                 second: n,
		                 millisecond: a,
		                 microsecond: i,
		                 nanosecond: s};
		        try{
		         var
		          _ParseTemporalMonthDa2 = ParseTemporalMonthDayString(e),
		          _t15 = _ParseTemporalMonthDa2.month,
		          _r11 = _ParseTemporalMonthDa2.day;
		         RejectISODate(1972, _t15, _r11);
		        }
		        catch(_unused2){
		         try{
		          var
		           _ParseTemporalYearMon = ParseTemporalYearMonthString(e),
		           _t16 = _ParseTemporalYearMon.year,
		           _r12 = _ParseTemporalYearMon.month;
		          RejectISODate(_t16, _r12, 1);
		         }
		         catch(_unused3){
		          return {hour: r,
		                  minute: o,
		                  second: n,
		                  millisecond: a,
		                  microsecond: i,
		                  nanosecond: s};
		         }
		        }
		        throw new
		               RangeError
		               ("invalid ISO 8601 time-only string ".concat
		                 (e, "; may need a T prefix"));
		       }
		       (ToString(l)),
		     r = _ParseTemporalTimeStr.hour,
		     o = _ParseTemporalTimeStr.minute,
		     n = _ParseTemporalTimeStr.second,
		     a = _ParseTemporalTimeStr.millisecond,
		     i = _ParseTemporalTimeStr.microsecond,
		     s = _ParseTemporalTimeStr.nanosecond,
		     RejectTime(r, o, n, a, i, s);
		    return new (GetIntrinsic("%Temporal.PlainTime%"))(r, o, n, a, i, s);
		   }
		   function ToTemporalYearMonth(e, t){
		    if(IsObject(e)){
		     if(IsTemporalYearMonth(e)) return e;
		     var _r13 = GetTemporalCalendarSlotValueWithISODefault(e);
		     return CalendarYearMonthFromFields
		             (_r13,
		              PrepareTemporalFields
		               (e, CalendarFields(_r13, ["month", "monthCode", "year"]), []),
		              t);
		    }
		    ToTemporalOverflow(t);
		    var
		     _ParseTemporalYearMon2 = ParseTemporalYearMonthString(ToString(e)),
		     r = _ParseTemporalYearMon2.year,
		     o = _ParseTemporalYearMon2.month,
		     n = _ParseTemporalYearMon2.referenceISODay,
		     a = _ParseTemporalYearMon2.calendar;
		    if(void 0 === a && (a = "iso8601"), ! IsBuiltinCalendar(a))
		     throw new RangeError("invalid calendar identifier ".concat(a));
		    if(a = ASCIILowercase(a), void 0 === n)
		     return RejectISODate(r, o, 1), CreateTemporalYearMonth(r, o, a);
		    return CalendarYearMonthFromFields(a, CreateTemporalYearMonth(r, o, a, n));
		   }
		   function InterpretISODateTimeOffset
		   (t, r, o, i, s, l, d, m, c, h, u, T, p, f, y){
		    var
		     I =
		       new
		        (GetIntrinsic("%Temporal.PlainDateTime%"))
		        (t, r, o, i, s, l, d, m, c);
		    if("wall" === h || "ignore" === f)
		     return GetSlot(GetInstantFor(T, I, p), n);
		    if("exact" === h || "use" === f){
		     var _n4 = GetUTCEpochNanoseconds(t, r, o, i, s, l, d, m, c);
		     if(null === _n4)
		      throw new RangeError("ZonedDateTime outside of supported range");
		     return _n4 - BigInt(u);
		    }
		    var
		     S = GetPossibleInstantsFor(T, I),
		     _iterator11 = _createForOfIteratorHelper(S),
		     _step11;
		    try{
		     for(_iterator11.s(); ! (_step11 = _iterator11.n()).done;){
		      var
		       _t18 = _step11.value,
		       _r14 = GetOffsetNanosecondsFor(T, _t18),
		       _o7 = Number(RoundNumberToIncrement(BigInt(_r14), be, "halfExpand"));
		      if(_r14 === u || y && _o7 === u) return GetSlot(_t18, n);
		     }
		    }
		    catch(err){_iterator11.e(err);}
		    finally{_iterator11.f();}
		    if("reject" === f){
		     var
		      _e16 = FormatTimeZoneOffsetString(u),
		      _t17 = IsTemporalTimeZone(T) ? GetSlot(T, a) : "time zone";
		     throw new
		            RangeError
		            ("Offset ".concat(_e16, " is invalid for ").concat
		               (I.toString(), " in ").concat
		              (_t17));
		    }
		    return GetSlot(DisambiguatePossibleInstants(S, T, I, p), n);
		   }
		   function ToTemporalZonedDateTime(e, t){
		    var r, o, n, a, i, s, l, d, m, c, h, u, T, p, f = ! 1, y = "option";
		    if(IsObject(e)){
		     var _InterpretTemporalDat3;
		     if(IsTemporalZonedDateTime(e)) return e;
		     u = GetTemporalCalendarSlotValueWithISODefault(e);
		     var
		      _f4 =
		        CalendarFields
		         (u,
		          ["day",
		           "hour",
		           "microsecond",
		           "millisecond",
		           "minute",
		           "month",
		           "monthCode",
		           "nanosecond",
		           "second",
		           "year"]);
		     _f4.push("timeZone", "offset");
		     var _I = PrepareTemporalFields(e, _f4, ["timeZone"]);
		     c = ToTemporalTimeZoneSlotValue(_I.timeZone),
		     h = _I.offset,
		     void 0 === h && (y = "wall"),
		     T = ToTemporalDisambiguation(t),
		     p = ToTemporalOffset(t, "reject"),
		     _InterpretTemporalDat3 = InterpretTemporalDateTimeFields(u, _I, t),
		     r = _InterpretTemporalDat3.year,
		     o = _InterpretTemporalDat3.month,
		     n = _InterpretTemporalDat3.day,
		     a = _InterpretTemporalDat3.hour,
		     i = _InterpretTemporalDat3.minute,
		     s = _InterpretTemporalDat3.second,
		     l = _InterpretTemporalDat3.millisecond,
		     d = _InterpretTemporalDat3.microsecond,
		     m = _InterpretTemporalDat3.nanosecond;
		    }
		    else {
		     var _ParseTemporalZonedDa, _I2, _S;
		     if
		      (_ParseTemporalZonedDa =
		        function(e){
		          var t = ParseISODateTime(e);
		          if(! t.ianaName)
		           throw new
		                  RangeError
		                  ("Temporal.ZonedDateTime requires a time zone ID in brackets");
		          return t;
		         }
		         (ToString(e)),
		       r = _ParseTemporalZonedDa.year,
		       o = _ParseTemporalZonedDa.month,
		       n = _ParseTemporalZonedDa.day,
		       a = _ParseTemporalZonedDa.hour,
		       i = _ParseTemporalZonedDa.minute,
		       s = _ParseTemporalZonedDa.second,
		       l = _ParseTemporalZonedDa.millisecond,
		       d = _ParseTemporalZonedDa.microsecond,
		       m = _ParseTemporalZonedDa.nanosecond,
		       _I2 = _ParseTemporalZonedDa.ianaName,
		       h = _ParseTemporalZonedDa.offset,
		       _S = _ParseTemporalZonedDa.z,
		       u = _ParseTemporalZonedDa.calendar,
		       c = ToTemporalTimeZoneSlotValue(_I2),
		       _S ? y = "exact" : h || (y = "wall"),
		       u || (u = "iso8601"),
		       !
		       IsBuiltinCalendar(u))
		      throw new RangeError("invalid calendar identifier ".concat(u));
		     u = ASCIILowercase(u),
		     f = ! 0,
		     T = ToTemporalDisambiguation(t),
		     p = ToTemporalOffset(t, "reject"),
		     ToTemporalOverflow(t);
		    }
		    var I = 0;
		    "option" === y && (I = ParseTimeZoneOffsetString(h));
		    return CreateTemporalZonedDateTime
		            (InterpretISODateTimeOffset
		              (r, o, n, a, i, s, l, d, m, y, I, c, T, p, f),
		             c,
		             u);
		   }
		   function CreateTemporalDateSlots(e, t, r, o, n){
		    RejectISODate(t, r, o),
		    RejectDateRange(t, r, o),
		    N(e),
		    SetSlot(e, i, t),
		    SetSlot(e, s, r),
		    SetSlot(e, l, o),
		    SetSlot(e, p, n),
		    SetSlot(e, f, ! 0);
		   }
		   function CreateTemporalDate(e, t, r){
		    var
		     o =
		       arguments.length > 3 && arguments[3] !== undefined
		        ? arguments[3]
		        : "iso8601",
		     n = GetIntrinsic("%Temporal.PlainDate%"),
		     a = Te(n.prototype);
		    return CreateTemporalDateSlots(a, e, t, r, o), a;
		   }
		   function CreateTemporalDateTimeSlots(e, t, r, o, n, a, f, y, I, S, g){
		    RejectDateTime(t, r, o, n, a, f, y, I, S),
		    RejectDateTimeRange(t, r, o, n, a, f, y, I, S),
		    N(e),
		    SetSlot(e, i, t),
		    SetSlot(e, s, r),
		    SetSlot(e, l, o),
		    SetSlot(e, d, n),
		    SetSlot(e, m, a),
		    SetSlot(e, c, f),
		    SetSlot(e, h, y),
		    SetSlot(e, u, I),
		    SetSlot(e, T, S),
		    SetSlot(e, p, g);
		   }
		   function CreateTemporalDateTime(e, t, r, o, n, a, i, s, l){
		    var
		     d =
		       arguments.length > 9 && arguments[9] !== undefined
		        ? arguments[9]
		        : "iso8601",
		     m = GetIntrinsic("%Temporal.PlainDateTime%"),
		     c = Te(m.prototype);
		    return CreateTemporalDateTimeSlots(c, e, t, r, o, n, a, i, s, l, d), c;
		   }
		   function CreateTemporalMonthDaySlots(e, t, r, o, n){
		    RejectISODate(n, t, r),
		    RejectDateRange(n, t, r),
		    N(e),
		    SetSlot(e, s, t),
		    SetSlot(e, l, r),
		    SetSlot(e, i, n),
		    SetSlot(e, p, o),
		    SetSlot(e, I, ! 0);
		   }
		   function CreateTemporalMonthDay(e, t){
		    var
		     r =
		       arguments.length > 2 && arguments[2] !== undefined
		        ? arguments[2]
		        : "iso8601",
		     o =
		       arguments.length > 3 && arguments[3] !== undefined
		        ? arguments[3]
		        : 1972,
		     n = GetIntrinsic("%Temporal.PlainMonthDay%"),
		     a = Te(n.prototype);
		    return CreateTemporalMonthDaySlots(a, e, t, r, o), a;
		   }
		   function CreateTemporalYearMonthSlots(e, t, r, o, n){
		    RejectISODate(t, r, n),
		    function(e, t){
		      RejectToRange(e, Fe, Ye),
		      e === Fe ? RejectToRange(t, 4, 12) : e === Ye && RejectToRange(t, 1, 9);
		     }
		     (t, r),
		    N(e),
		    SetSlot(e, i, t),
		    SetSlot(e, s, r),
		    SetSlot(e, l, n),
		    SetSlot(e, p, o),
		    SetSlot(e, y, ! 0);
		   }
		   function CreateTemporalYearMonth(e, t){
		    var
		     r =
		       arguments.length > 2 && arguments[2] !== undefined
		        ? arguments[2]
		        : "iso8601",
		     o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1,
		     n = GetIntrinsic("%Temporal.PlainYearMonth%"),
		     a = Te(n.prototype);
		    return CreateTemporalYearMonthSlots(a, e, t, r, o), a;
		   }
		   function CreateTemporalZonedDateTimeSlots(e, t, r, o){
		    ValidateEpochNanoseconds(t),
		    N(e),
		    SetSlot(e, n, t),
		    SetSlot(e, g, r),
		    SetSlot(e, p, o);
		    var a = new (GetIntrinsic("%Temporal.Instant%"))(GetSlot(e, n));
		    SetSlot(e, S, a);
		   }
		   function CreateTemporalZonedDateTime(e, t){
		    var
		     r =
		       arguments.length > 2 && arguments[2] !== undefined
		        ? arguments[2]
		        : "iso8601",
		     o = GetIntrinsic("%Temporal.ZonedDateTime%"),
		     n = Te(o.prototype);
		    return CreateTemporalZonedDateTimeSlots(n, e, t, r), n;
		   }
		   function CalendarFields(e, t){
		    if("string" == typeof e){
		     var _r15 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.fields%"), _r15, [t]);
		    }
		    var
		     r = Call(GetMethod(e, "fields"), e, [t]),
		     o = [],
		     _iterator12 = _createForOfIteratorHelper(r),
		     _step12;
		    try{
		     for(_iterator12.s(); ! (_step12 = _iterator12.n()).done;){
		      var _e17 = _step12.value;
		      if("string" != typeof _e17)
		       throw new TypeError("bad return from calendar.fields()");
		      te.call(o, _e17);
		     }
		    }
		    catch(err){_iterator12.e(err);}
		    finally{_iterator12.f();}
		    return o;
		   }
		   function CalendarMergeFields(e, t, r){
		    if("string" == typeof e){
		     var _o8 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.mergeFields%"),
		              _o8,
		              [t, r]);
		    }
		    var o = Call(GetMethod(e, "mergeFields"), e, [t, r]);
		    if(! IsObject(o))
		     throw new TypeError("bad return from calendar.mergeFields()");
		    return o;
		   }
		   function CalendarDateAdd(e, t, r, o, n){
		    var a = n;
		    if("string" == typeof e){
		     var _n5 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.dateAdd%"),
		              _n5,
		              [t, r, o]);
		    }
		    void 0 === a && (a = GetMethod(e, "dateAdd"));
		    var i = fe(a, e, [t, r, o]);
		    if(! IsTemporalDate(i)) throw new TypeError("invalid result");
		    return i;
		   }
		   function CalendarDateUntil(e, t, r, o, n){
		    var a = n;
		    if("string" == typeof e){
		     var _n6 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.dateUntil%"),
		              _n6,
		              [t, r, o]);
		    }
		    void 0 === a && (a = GetMethod(e, "dateUntil"));
		    var i = fe(a, e, [t, r, o]);
		    if(! IsTemporalDuration(i)) throw new TypeError("invalid result");
		    return i;
		   }
		   function CalendarYear(e, t){
		    if("string" == typeof e){
		     var _r16 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.year%"), _r16, [t]);
		    }
		    var r = Call(GetMethod(e, "year"), e, [t]);
		    if("number" != typeof r)
		     throw new TypeError("calendar year result must be an integer");
		    if(! IsIntegralNumber(r))
		     throw new RangeError("calendar year result must be an integer");
		    return r;
		   }
		   function CalendarMonth(e, t){
		    if("string" == typeof e){
		     var _r17 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.month%"), _r17, [t]);
		    }
		    var r = Call(GetMethod(e, "month"), e, [t]);
		    if("number" != typeof r)
		     throw new TypeError("calendar month result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new RangeError("calendar month result must be a positive integer");
		    return r;
		   }
		   function CalendarMonthCode(e, t){
		    if("string" == typeof e){
		     var _r18 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.monthCode%"),
		              _r18,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "monthCode"), e, [t]);
		    if("string" != typeof r)
		     throw new TypeError("calendar monthCode result must be a string");
		    return r;
		   }
		   function CalendarDay(e, t){
		    if("string" == typeof e){
		     var _r19 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call(GetIntrinsic("%Temporal.Calendar.prototype.day%"), _r19, [t]);
		    }
		    var r = Call(GetMethod(e, "day"), e, [t]);
		    if("number" != typeof r)
		     throw new TypeError("calendar day result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new RangeError("calendar day result must be a positive integer");
		    return r;
		   }
		   function CalendarEra(e, t){
		    if("string" == typeof e){
		     var _r20 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call(GetIntrinsic("%Temporal.Calendar.prototype.era%"), _r20, [t]);
		    }
		    var r = Call(GetMethod(e, "era"), e, [t]);
		    if(void 0 === r) return r;
		    if("string" != typeof r)
		     throw new TypeError("calendar era result must be a string or undefined");
		    return r;
		   }
		   function CalendarEraYear(e, t){
		    if("string" == typeof e){
		     var _r21 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.eraYear%"),
		              _r21,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "eraYear"), e, [t]);
		    if(void 0 === r) return r;
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar eraYear result must be an integer or undefined");
		    if(! IsIntegralNumber(r))
		     throw new
		            RangeError
		            ("calendar eraYear result must be an integer or undefined");
		    return r;
		   }
		   function CalendarDayOfWeek(e, t){
		    if("string" == typeof e){
		     var _r22 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.dayOfWeek%"),
		              _r22,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "dayOfWeek"), e, [t]);
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar dayOfWeek result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new
		            RangeError
		            ("calendar dayOfWeek result must be a positive integer");
		    return r;
		   }
		   function CalendarDayOfYear(e, t){
		    if("string" == typeof e){
		     var _r23 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.dayOfYear%"),
		              _r23,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "dayOfYear"), e, [t]);
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar dayOfYear result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new
		            RangeError
		            ("calendar dayOfYear result must be a positive integer");
		    return r;
		   }
		   function CalendarWeekOfYear(e, t){
		    if("string" == typeof e){
		     var _r24 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.weekOfYear%"),
		              _r24,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "weekOfYear"), e, [t]);
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar weekOfYear result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new
		            RangeError
		            ("calendar weekOfYear result must be a positive integer");
		    return r;
		   }
		   function CalendarYearOfWeek(e, t){
		    if("string" == typeof e){
		     var _r25 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.yearOfWeek%"),
		              _r25,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "yearOfWeek"), e, [t]);
		    if("number" != typeof r)
		     throw new TypeError("calendar yearOfWeek result must be an integer");
		    if(! IsIntegralNumber(r))
		     throw new RangeError("calendar yearOfWeek result must be an integer");
		    return r;
		   }
		   function CalendarDaysInWeek(e, t){
		    if("string" == typeof e){
		     var _r26 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.daysInWeek%"),
		              _r26,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "daysInWeek"), e, [t]);
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar daysInWeek result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new
		            RangeError
		            ("calendar daysInWeek result must be a positive integer");
		    return r;
		   }
		   function CalendarDaysInMonth(e, t){
		    if("string" == typeof e){
		     var _r27 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.daysInMonth%"),
		              _r27,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "daysInMonth"), e, [t]);
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar daysInMonth result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new
		            RangeError
		            ("calendar daysInMonth result must be a positive integer");
		    return r;
		   }
		   function CalendarDaysInYear(e, t){
		    if("string" == typeof e){
		     var _r28 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.daysInYear%"),
		              _r28,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "daysInYear"), e, [t]);
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar daysInYear result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new
		            RangeError
		            ("calendar daysInYear result must be a positive integer");
		    return r;
		   }
		   function CalendarMonthsInYear(e, t){
		    if("string" == typeof e){
		     var _r29 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.monthsInYear%"),
		              _r29,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "monthsInYear"), e, [t]);
		    if("number" != typeof r)
		     throw new
		            TypeError
		            ("calendar monthsInYear result must be a positive integer");
		    if(! IsIntegralNumber(r) || r < 1)
		     throw new
		            RangeError
		            ("calendar monthsInYear result must be a positive integer");
		    return r;
		   }
		   function CalendarInLeapYear(e, t){
		    if("string" == typeof e){
		     var _r30 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.inLeapYear%"),
		              _r30,
		              [t]);
		    }
		    var r = Call(GetMethod(e, "inLeapYear"), e, [t]);
		    if("boolean" != typeof r)
		     throw new TypeError("calendar inLeapYear result must be a boolean");
		    return r;
		   }
		   function ToTemporalCalendarSlotValue(e){
		    if(IsObject(e)){
		     if(HasSlot(e, p)) return GetSlot(e, p);
		     if
		      (!
		       function(e){
		         return !
		                !
		                IsTemporalCalendar(e)
		                ||
		                 "dateAdd" in e && "dateFromFields" in e && "dateUntil" in e
		                 && "day" in e
		                 && "dayOfWeek" in e
		                 && "dayOfYear" in e
		                 && "daysInMonth" in e
		                 && "daysInWeek" in e
		                 && "daysInYear" in e
		                 && "fields" in e
		                 && "id" in e
		                 && "inLeapYear" in e
		                 && "mergeFields" in e
		                 && "month" in e
		                 && "monthCode" in e
		                 && "monthDayFromFields" in e
		                 && "monthsInYear" in e
		                 && "weekOfYear" in e
		                 && "year" in e
		                 && "yearMonthFromFields" in e
		                 && "yearOfWeek" in e;
		        }
		        (e))
		      throw new
		             TypeError
		             ("expected a Temporal.Calendar or object implementing the Temporal.Calendar protocol");
		     return e;
		    }
		    var t = ToString(e);
		    if(IsBuiltinCalendar(t)) return ASCIILowercase(t);
		    var r;
		    try{
		     var _ParseISODateTime5 = ParseISODateTime(t);
		     r = _ParseISODateTime5.calendar;
		    }
		    catch(_unused4){
		     try{
		      var _ParseTemporalYearMon3 = ParseTemporalYearMonthString(t);
		      r = _ParseTemporalYearMon3.calendar;
		     }
		     catch(_unused5){
		      var _ParseTemporalMonthDa3 = ParseTemporalMonthDayString(t);
		      r = _ParseTemporalMonthDa3.calendar;
		     }
		    }
		    if(r || (r = "iso8601"), ! IsBuiltinCalendar(r))
		     throw new RangeError("invalid calendar identifier ".concat(r));
		    return ASCIILowercase(r);
		   }
		   function GetTemporalCalendarSlotValueWithISODefault(e){
		    if(HasSlot(e, p)) return GetSlot(e, p);
		    var t = e.calendar;
		    return void 0 === t ? "iso8601" : ToTemporalCalendarSlotValue(t);
		   }
		   function ToTemporalCalendarIdentifier(e){
		    if("string" == typeof e) return e;
		    var t = e.id;
		    if("string" != typeof t)
		     throw new TypeError("calendar.id should be a string");
		    return t;
		   }
		   function ToTemporalCalendarObject(e){
		    if(IsObject(e)) return e;
		    return new (GetIntrinsic("%Temporal.Calendar%"))(e);
		   }
		   function CalendarEquals(e, t){
		    if(e === t) return ! 0;
		    return ToTemporalCalendarIdentifier(e) === ToTemporalCalendarIdentifier(t);
		   }
		   function ThrowIfCalendarsNotEqual(e, t, r){
		    if(e === t) return;
		    var
		     o = ToTemporalCalendarIdentifier(e),
		     n = ToTemporalCalendarIdentifier(t);
		    if(o !== n)
		     throw new
		            RangeError
		            ("cannot ".concat(r, " of ").concat(o, " and ").concat
		              (n, " calendars"));
		   }
		   function ConsolidateCalendars(e, t){
		    if(e === t) return t;
		    var
		     r = ToTemporalCalendarIdentifier(e),
		     o = ToTemporalCalendarIdentifier(t);
		    if(r === o || "iso8601" === r) return t;
		    if("iso8601" === o) return e;
		    throw new RangeError("irreconcilable calendars");
		   }
		   function CalendarDateFromFields(e, t, r, o){
		    if("string" == typeof e){
		     var _o9 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.dateFromFields%"),
		              _o9,
		              [t, r]);
		    }
		    var
		     n =
		       Call
		        (GetMethod(e, "dateFromFields"),
		         e,
		         [t, r]);
		    if(! IsTemporalDate(n)) throw new TypeError("invalid result");
		    return n;
		   }
		   function CalendarYearMonthFromFields(e, t, r){
		    if("string" == typeof e){
		     var _o10 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic
		               ("%Temporal.Calendar.prototype.yearMonthFromFields%"),
		              _o10,
		              [t, r]);
		    }
		    var o = Call(GetMethod(e, "yearMonthFromFields"), e, [t, r]);
		    if(! IsTemporalYearMonth(o)) throw new TypeError("invalid result");
		    return o;
		   }
		   function CalendarMonthDayFromFields(e, t, r){
		    if("string" == typeof e){
		     var _o11 = new (GetIntrinsic("%Temporal.Calendar%"))(e);
		     return Call
		             (GetIntrinsic("%Temporal.Calendar.prototype.monthDayFromFields%"),
		              _o11,
		              [t, r]);
		    }
		    var o = Call(GetMethod(e, "monthDayFromFields"), e, [t, r]);
		    if(! IsTemporalMonthDay(o)) throw new TypeError("invalid result");
		    return o;
		   }
		   function ToTemporalTimeZoneSlotValue(e){
		    if(IsObject(e)){
		     if(IsTemporalZonedDateTime(e)) return GetSlot(e, g);
		     if
		      (!
		       function(e){
		         return !
		                !
		                IsTemporalTimeZone(e)
		                ||
		                 "getOffsetNanosecondsFor" in e
		                 && "getPossibleInstantsFor" in e
		                 && "id" in e;
		        }
		        (e))
		      throw new
		             TypeError
		             ("expected a Temporal.TimeZone or object implementing the Temporal.TimeZone protocol");
		     return e;
		    }
		    return ParseTemporalTimeZone(ToString(e));
		   }
		   function ToTemporalTimeZoneIdentifier(e){
		    if("string" == typeof e) return e;
		    var t = e.id;
		    if("string" != typeof t)
		     throw new TypeError("timeZone.id should be a string");
		    return t;
		   }
		   function ToTemporalTimeZoneObject(e){
		    if(IsObject(e)) return e;
		    return new (GetIntrinsic("%Temporal.TimeZone%"))(e);
		   }
		   function TimeZoneEquals(e, t){
		    if(e === t) return ! 0;
		    return ToTemporalTimeZoneIdentifier(e) === ToTemporalTimeZoneIdentifier(t);
		   }
		   function TemporalDateTimeToDate(e){
		    return CreateTemporalDate
		            (GetSlot(e, i), GetSlot(e, s), GetSlot(e, l), GetSlot(e, p));
		   }
		   function TemporalDateTimeToTime(e){
		    return new
		            (GetIntrinsic("%Temporal.PlainTime%"))
		            (GetSlot(e, d),
		             GetSlot(e, m),
		             GetSlot(e, c),
		             GetSlot(e, h),
		             GetSlot(e, u),
		             GetSlot(e, T));
		   }
		   function GetOffsetNanosecondsFor(e, t, r){
		    if("string" == typeof e){
		     var _r31 = new (GetIntrinsic("%Temporal.TimeZone%"))(e);
		     return Call
		             (GetIntrinsic
		               ("%Temporal.TimeZone.prototype.getOffsetNanosecondsFor%"),
		              _r31,
		              [t]);
		    }
		    var
		     o =
		       Call
		        (GetMethod(e, "getOffsetNanosecondsFor"),
		         e,
		         [t]);
		    if("number" != typeof o)
		     throw new TypeError("bad return from getOffsetNanosecondsFor");
		    if(! IsIntegralNumber(o) || ae(o) >= 864e11)
		     throw new RangeError("out-of-range return from getOffsetNanosecondsFor");
		    return o;
		   }
		   function GetOffsetStringFor(e, t){
		    return FormatTimeZoneOffsetString(GetOffsetNanosecondsFor(e, t));
		   }
		   function GetPlainDateTimeFor(e, t, r){
		    var
		     _BalanceISODateTime2,
		     o = GetSlot(t, n),
		     a = GetOffsetNanosecondsFor(e, t),
		     _GetISOPartsFromEpoch = GetISOPartsFromEpoch(o),
		     i = _GetISOPartsFromEpoch.year,
		     s = _GetISOPartsFromEpoch.month,
		     l = _GetISOPartsFromEpoch.day,
		     d = _GetISOPartsFromEpoch.hour,
		     m = _GetISOPartsFromEpoch.minute,
		     c = _GetISOPartsFromEpoch.second,
		     h = _GetISOPartsFromEpoch.millisecond,
		     u = _GetISOPartsFromEpoch.microsecond,
		     T = _GetISOPartsFromEpoch.nanosecond;
		    return _BalanceISODateTime2 =
		            BalanceISODateTime(i, s, l, d, m, c, h, u, T + a),
		           i = _BalanceISODateTime2.year,
		           s = _BalanceISODateTime2.month,
		           l = _BalanceISODateTime2.day,
		           d = _BalanceISODateTime2.hour,
		           m = _BalanceISODateTime2.minute,
		           c = _BalanceISODateTime2.second,
		           h = _BalanceISODateTime2.millisecond,
		           u = _BalanceISODateTime2.microsecond,
		           T = _BalanceISODateTime2.nanosecond,
		           CreateTemporalDateTime(i, s, l, d, m, c, h, u, T, r);
		   }
		   function GetInstantFor(e, t, r){
		    return DisambiguatePossibleInstants(GetPossibleInstantsFor(e, t), e, t, r);
		   }
		   function DisambiguatePossibleInstants(t, r, o, n){
		    var a = GetIntrinsic("%Temporal.Instant%"), f = t.length;
		    if(1 === f) return t[0];
		    if(f)
		     switch(n){
		       case "compatible":
		       case "earlier": return t[0];
		       case "later":
		        return t[f - 1];
		       case "reject":
		        throw new RangeError("multiple instants found");
		     }
		    var
		     y = GetSlot(o, i),
		     I = GetSlot(o, s),
		     S = GetSlot(o, l),
		     g = GetSlot(o, d),
		     w = GetSlot(o, m),
		     D = GetSlot(o, c),
		     G = GetSlot(o, h),
		     v = GetSlot(o, u),
		     C = GetSlot(o, T),
		     O = GetUTCEpochNanoseconds(y, I, S, g, w, D, G, v, C);
		    if(null === O)
		     throw new RangeError("DateTime outside of supported range");
		    var
		     b = new a(O - Ee),
		     E = new a(O + Ee),
		     M = GetOffsetNanosecondsFor(r, b),
		     R = GetOffsetNanosecondsFor(r, E) - M;
		    switch(n){
		      case "earlier":
		       {
		        var
		         _e18 = GetSlot(o, p),
		         _t19 = GetIntrinsic("%Temporal.PlainDateTime%"),
		         _n7 =
		           AddDateTime
		            (y,
		             I,
		             S,
		             g,
		             w,
		             D,
		             G,
		             v,
		             C,
		             _e18,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             - R,
		             void 0);
		        return GetPossibleInstantsFor
		                 (r,
		                  new
		                   _t19
		                   (_n7.year,
		                    _n7.month,
		                    _n7.day,
		                    _n7.hour,
		                    _n7.minute,
		                    _n7.second,
		                    _n7.millisecond,
		                    _n7.microsecond,
		                    _n7.nanosecond,
		                    _e18))
		                [0];
		       }
		      case "compatible":
		      case "later":
		       {
		        var
		         _e19 = GetSlot(o, p),
		         _t20 = GetIntrinsic("%Temporal.PlainDateTime%"),
		         _n8 =
		           AddDateTime
		            (y,
		             I,
		             S,
		             g,
		             w,
		             D,
		             G,
		             v,
		             C,
		             _e19,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             0,
		             R,
		             void 0),
		         _a4 =
		           GetPossibleInstantsFor
		            (r,
		             new
		              _t20
		              (_n8.year,
		               _n8.month,
		               _n8.day,
		               _n8.hour,
		               _n8.minute,
		               _n8.second,
		               _n8.millisecond,
		               _n8.microsecond,
		               _n8.nanosecond,
		               _e19));
		        return _a4[_a4.length - 1];
		       }
		      case "reject":
		       throw new RangeError("no such instant found");
		    }
		   }
		   function GetPossibleInstantsFor(e, t, r){
		    if("string" == typeof e){
		     var _r32 = new (GetIntrinsic("%Temporal.TimeZone%"))(e);
		     return Call
		             (GetIntrinsic
		               ("%Temporal.TimeZone.prototype.getPossibleInstantsFor%"),
		              _r32,
		              [t]);
		    }
		    var
		     o =
		       Call
		        (GetMethod(e, "getPossibleInstantsFor"),
		         e,
		         [t]),
		     n = [],
		     _iterator13 = _createForOfIteratorHelper(o),
		     _step13;
		    try{
		     for(_iterator13.s(); ! (_step13 = _iterator13.n()).done;){
		      var _e20 = _step13.value;
		      if(! IsTemporalInstant(_e20))
		       throw new TypeError("bad return from getPossibleInstantsFor");
		      te.call(n, _e20);
		     }
		    }
		    catch(err){_iterator13.e(err);}
		    finally{_iterator13.f();}
		    return n;
		   }
		   function ISOYearString(e){
		    var t;
		    if(e < 0 || e > 9999)
		     t = (e < 0 ? "-" : "+") + "000000".concat(ae(e)).slice(- 6);
		    else
		     t = "0000".concat(e).slice(- 4);
		    return t;
		   }
		   function ISODateTimePartString(e){return "00".concat(e).slice(- 2);}
		   function FormatSecondsStringPart(e, t, r, o, n){
		    if("minute" === n) return "";
		    var
		     a = ":".concat(ISODateTimePartString(e)),
		     i,
		     s = 1e6 * t + 1e3 * r + o;
		    if("auto" === n){
		     if(0 === s) return a;
		     for(i = "".concat(s).padStart(9, "0"); "0" === i[i.length - 1];)
		      i = i.slice(0, - 1);
		    }
		    else {if(0 === n) return a; i = "".concat(s).padStart(9, "0").slice(0, n);}
		    return "".concat(a, ".").concat(i);
		   }
		   function TemporalInstantToString(e, t, r){
		    var o = t;
		    void 0 === o && (o = "UTC");
		    var
		     n = GetPlainDateTimeFor(o, e, "iso8601"),
		     a = ISOYearString(GetSlot(n, i)),
		     p = ISODateTimePartString(GetSlot(n, s)),
		     f = ISODateTimePartString(GetSlot(n, l)),
		     y = ISODateTimePartString(GetSlot(n, d)),
		     I = ISODateTimePartString(GetSlot(n, m)),
		     S =
		       FormatSecondsStringPart
		        (GetSlot(n, c), GetSlot(n, h), GetSlot(n, u), GetSlot(n, T), r),
		     g = "Z";
		    if(void 0 !== t)
		     g = FormatISOTimeZoneOffsetString(GetOffsetNanosecondsFor(o, e));
		    return "".concat(a, "-").concat(p, "-").concat(f, "T").concat(y, ":").concat
		              (I).concat
		             (S).concat
		            (g);
		   }
		   function TemporalDurationToString(t){
		    var
		     _divmod,
		     _divmod2,
		     _divmod3,
		     r =
		       arguments.length > 1 && arguments[1] !== undefined
		        ? arguments[1]
		        : "auto",
		     o = arguments.length > 2 ? arguments[2] : undefined;
		    function formatNumber(t){
		     return t <= ue ? t.toString(10) : BigInt(t).toString(10);
		    }
		    var
		     n = GetSlot(t, w),
		     a = GetSlot(t, D),
		     i = GetSlot(t, G),
		     s = GetSlot(t, v),
		     l = GetSlot(t, C),
		     d = GetSlot(t, O),
		     m = GetSlot(t, b),
		     c = GetSlot(t, E),
		     h = GetSlot(t, M),
		     u = GetSlot(t, R),
		     T = DurationSign(n, a, i, s, l, d, m, c, h, u);
		    if(o){
		     var
		      _e21 = o.unit,
		      _t21 = o.increment,
		      _r33 = o.roundingMode,
		      _RoundDuration =
		        RoundDuration(0, 0, 0, 0, 0, 0, m, c, h, u, _t21, _e21, _r33);
		     m = _RoundDuration.seconds;
		     c = _RoundDuration.milliseconds;
		     h = _RoundDuration.microseconds;
		     u = _RoundDuration.nanoseconds;
		    }
		    var p = [];
		    n && p.push("".concat(formatNumber(ae(n)), "Y")),
		    a && p.push("".concat(formatNumber(ae(a)), "M")),
		    i && p.push("".concat(formatNumber(ae(i)), "W")),
		    s && p.push("".concat(formatNumber(ae(s)), "D"));
		    var f = [];
		    l && f.push("".concat(formatNumber(ae(l)), "H")),
		    d && f.push("".concat(formatNumber(ae(d)), "M"));
		    var
		     y = [],
		     I,
		     S,
		     g,
		     F,
		     Y = TotalDurationNanoseconds(0, 0, 0, m, c, h, u, 0);
		    _divmod = divmod(Y, De),
		    Y = _divmod.quotient,
		    I = _divmod.remainder,
		    _divmod2 = divmod(Y, De),
		    Y = _divmod2.quotient,
		    S = _divmod2.remainder,
		    _divmod3 = divmod(Y, De),
		    F = _divmod3.quotient,
		    g = _divmod3.remainder;
		    var P = 1e6 * ae(Number(g)) + 1e3 * ae(Number(S)) + ae(Number(I)), Z;
		    if("auto" === r){
		     if(0 !== P)
		      for(Z = "".concat(P).padStart(9, "0"); "0" === Z[Z.length - 1];)
		       Z = Z.slice(0, - 1);
		    }
		    else
		     0 !== r && (Z = "".concat(P).padStart(9, "0").slice(0, r));
		    return Z && y.unshift(".", Z),
		           F === Ie && ! y.length && "auto" === r
		           || y.unshift(abs(F).toString()),
		           y.length && f.push("".concat(y.join(""), "S")),
		           f.length && f.unshift("T"),
		           p.length || f.length
		            ? "".concat
		                (T < 0 ? "-" : "", "P").concat
		               (p.join("")).concat
		              (f.join(""))
		            : "PT0S";
		   }
		   function TemporalDateToString(e){
		    var
		     t =
		       arguments.length > 1 && arguments[1] !== undefined
		        ? arguments[1]
		        : "auto";
		    return "".concat(ISOYearString(GetSlot(e, i)), "-").concat
		              (ISODateTimePartString(GetSlot(e, s)), "-").concat
		             (ISODateTimePartString(GetSlot(e, l))).concat
		            (MaybeFormatCalendarAnnotation(GetSlot(e, p), t));
		   }
		   function TemporalDateTimeToString(e, t){
		    var
		     r =
		       arguments.length > 2 && arguments[2] !== undefined
		        ? arguments[2]
		        : "auto",
		     o = arguments.length > 3 ? arguments[3] : undefined,
		     n = GetSlot(e, i),
		     a = GetSlot(e, s),
		     f = GetSlot(e, l),
		     y = GetSlot(e, d),
		     I = GetSlot(e, m),
		     S = GetSlot(e, c),
		     g = GetSlot(e, h),
		     w = GetSlot(e, u),
		     D = GetSlot(e, T);
		    if(o){
		     var
		      _e22 = o.unit,
		      _t22 = o.increment,
		      _r34 = o.roundingMode,
		      _RoundISODateTime =
		        RoundISODateTime(n, a, f, y, I, S, g, w, D, _t22, _e22, _r34);
		     n = _RoundISODateTime.year;
		     a = _RoundISODateTime.month;
		     f = _RoundISODateTime.day;
		     y = _RoundISODateTime.hour;
		     I = _RoundISODateTime.minute;
		     S = _RoundISODateTime.second;
		     g = _RoundISODateTime.millisecond;
		     w = _RoundISODateTime.microsecond;
		     D = _RoundISODateTime.nanosecond;
		    }
		    return "".concat(ISOYearString(n), "-").concat
		                 (ISODateTimePartString(a), "-").concat
		                (ISODateTimePartString(f), "T").concat
		               (ISODateTimePartString(y), ":").concat
		              (ISODateTimePartString(I)).concat
		             (FormatSecondsStringPart(S, g, w, D, t)).concat
		            (MaybeFormatCalendarAnnotation(GetSlot(e, p), r));
		   }
		   function TemporalMonthDayToString(e){
		    var
		     t =
		       arguments.length > 1 && arguments[1] !== undefined
		        ? arguments[1]
		        : "auto",
		     r =
		       "".concat(ISODateTimePartString(GetSlot(e, s)), "-").concat
		        (ISODateTimePartString(GetSlot(e, l))),
		     o = ToTemporalCalendarIdentifier(GetSlot(e, p));
		    if("always" === t || "critical" === t || "iso8601" !== o)
		     r = "".concat(ISOYearString(GetSlot(e, i)), "-").concat(r);
		    var n = FormatCalendarAnnotation(o, t);
		    return n && (r += n), r;
		   }
		   function TemporalYearMonthToString(e){
		    var
		     t =
		       arguments.length > 1 && arguments[1] !== undefined
		        ? arguments[1]
		        : "auto",
		     r =
		       "".concat(ISOYearString(GetSlot(e, i)), "-").concat
		        (ISODateTimePartString(GetSlot(e, s))),
		     o = ToTemporalCalendarIdentifier(GetSlot(e, p));
		    if("always" === t || "critical" === t || "iso8601" !== o)
		     r += "-".concat(ISODateTimePartString(GetSlot(e, l)));
		    var n = FormatCalendarAnnotation(o, t);
		    return n && (r += n), r;
		   }
		   function TemporalZonedDateTimeToString(e, t){
		    var
		     r =
		       arguments.length > 2 && arguments[2] !== undefined
		        ? arguments[2]
		        : "auto",
		     o =
		       arguments.length > 3 && arguments[3] !== undefined
		        ? arguments[3]
		        : "auto",
		     a =
		       arguments.length > 4 && arguments[4] !== undefined
		        ? arguments[4]
		        : "auto",
		     f = arguments.length > 5 ? arguments[5] : undefined,
		     y = GetSlot(e, S);
		    if(f){
		     var
		      _t23 = f.unit,
		      _r35 = f.increment,
		      _o12 = f.roundingMode,
		      _a5 = RoundInstant(GetSlot(e, n), _r35, _t23, _o12);
		     y = new (GetIntrinsic("%Temporal.Instant%"))(_a5);
		    }
		    var
		     I = GetSlot(e, g),
		     w = GetPlainDateTimeFor(I, y, "iso8601"),
		     D =
		       "".concat(ISOYearString(GetSlot(w, i)), "-").concat
		            (ISODateTimePartString(GetSlot(w, s)), "-").concat
		           (ISODateTimePartString(GetSlot(w, l)), "T").concat
		          (ISODateTimePartString(GetSlot(w, d)), ":").concat
		         (ISODateTimePartString(GetSlot(w, m))).concat
		        (FormatSecondsStringPart
		          (GetSlot(w, c), GetSlot(w, h), GetSlot(w, u), GetSlot(w, T), t));
		    if("never" !== a)
		     D += FormatISOTimeZoneOffsetString(GetOffsetNanosecondsFor(I, y));
		    if("never" !== o)
		     D +=
		      "[".concat("critical" === o ? "!" : "").concat
		       (ToTemporalTimeZoneIdentifier(I), "]");
		    return D += MaybeFormatCalendarAnnotation(GetSlot(e, p), r), D;
		   }
		   function IsTimeZoneOffsetString(e){return ze.test(he(e));}
		   function ParseTimeZoneOffsetString(e){
		    var t = ze.exec(he(e));
		    if(! t) throw new RangeError("invalid time zone offset: ".concat(e));
		    return ("-" === t[1] || "−" === t[1] ? - 1 : 1)
		           *
		            (1e9 * (60 * (60 * + t[2] + + (t[3] || 0)) + + (t[4] || 0))
		            + + ((t[5] || 0) + "000000000").slice(0, 9));
		   }
		   function GetCanonicalTimeZoneIdentifier(e){
		    if(IsTimeZoneOffsetString(e))
		     return FormatTimeZoneOffsetString(ParseTimeZoneOffsetString(e));
		    return getIntlDateTimeFormatEnUsForTimeZone(he(e)).resolvedOptions().timeZone;
		   }
		   function GetNamedTimeZoneOffsetNanoseconds(t, r){
		    var
		     _GetNamedTimeZoneDate = GetNamedTimeZoneDateTimeParts(t, r),
		     o = _GetNamedTimeZoneDate.year,
		     n = _GetNamedTimeZoneDate.month,
		     a = _GetNamedTimeZoneDate.day,
		     i = _GetNamedTimeZoneDate.hour,
		     s = _GetNamedTimeZoneDate.minute,
		     l = _GetNamedTimeZoneDate.second,
		     d = _GetNamedTimeZoneDate.millisecond,
		     m = _GetNamedTimeZoneDate.microsecond,
		     c = _GetNamedTimeZoneDate.nanosecond,
		     h = o % 400,
		     u = (o - h) / 400,
		     T = 146097n * Ee,
		     p = GetUTCEpochNanoseconds(h, n, a, i, s, l, d, m, c),
		     f = p + T * BigInt(u);
		    return Number(f - r);
		   }
		   function FormatTimeZoneOffsetString(e){
		    var
		     t = e < 0 ? "-" : "+",
		     r = ae(e),
		     o = r % 1e9,
		     n = ie(r / 1e9) % 60,
		     a = ie(r / 6e10) % 60,
		     i = ISODateTimePartString(ie(r / 36e11)),
		     s = ISODateTimePartString(a),
		     l = ISODateTimePartString(n),
		     d = "";
		    if(o){
		     var _e23 = "".concat(o).padStart(9, "0");
		     for(; "0" === _e23[_e23.length - 1];) _e23 = _e23.slice(0, - 1);
		     d = ":".concat(l, ".").concat(_e23);
		    }
		    else
		     n && (d = ":".concat(l));
		    return "".concat(t).concat(i, ":").concat(s).concat(d);
		   }
		   function FormatISOTimeZoneOffsetString(t){
		    var
		     r = Number(RoundNumberToIncrement(BigInt(t), be, "halfExpand")),
		     o = r < 0 ? "-" : "+";
		    r = ae(r);
		    var n = r / 6e10 % 60;
		    return "".concat(o).concat(ISODateTimePartString(ie(r / 36e11)), ":").concat
		            (ISODateTimePartString(n));
		   }
		   function GetUTCEpochNanoseconds(t, r, o, n, a, i, s, l, d){
		    var m = new Date();
		    m.setUTCHours(n, a, i, s), m.setUTCFullYear(t, r - 1, o);
		    var c = m.getTime();
		    if(de(c)) return null;
		    var h = BigInt(c) * Ge;
		    return h = h + BigInt(l) * De,
		           h = h + BigInt(d),
		           h < Me || h > Re ? null : h;
		   }
		   function GetISOPartsFromEpoch(t){
		    var
		     _divmod4 = divmod(t, Ge),
		     r = _divmod4.quotient,
		     o = _divmod4.remainder,
		     n = Number(r),
		     a = Number(o);
		    a < 0 && (a += 1e6, n -= 1);
		    var i = ie(a / 1e3) % 1e3, s = a % 1e3, l = new Date(n);
		    return {epochMilliseconds: n,
		            year: l.getUTCFullYear(),
		            month: l.getUTCMonth() + 1,
		            day: l.getUTCDate(),
		            hour: l.getUTCHours(),
		            minute: l.getUTCMinutes(),
		            second: l.getUTCSeconds(),
		            millisecond: l.getUTCMilliseconds(),
		            microsecond: i,
		            nanosecond: s};
		   }
		   function GetNamedTimeZoneDateTimeParts(e, t){
		    var
		     _GetISOPartsFromEpoch2 = GetISOPartsFromEpoch(t),
		     r = _GetISOPartsFromEpoch2.epochMilliseconds,
		     o = _GetISOPartsFromEpoch2.millisecond,
		     n = _GetISOPartsFromEpoch2.microsecond,
		     a = _GetISOPartsFromEpoch2.nanosecond,
		     _GetFormatterParts =
		       function(e, t){
		         var r = getIntlDateTimeFormatEnUsForTimeZone(e).format(new Date(t));
		         return function(e){
		                  var t = e.split(/[^\w]+/);
		                  if(7 !== t.length)
		                   throw new RangeError('expected 7 parts in "'.concat(e));
		                  var
		                   r = + t[0],
		                   o = + t[1],
		                   n = + t[2],
		                   a = t[3].toUpperCase();
		                  if("B" === a || "BC" === a)
		                   n = 1 - n;
		                  else if("A" !== a && "AD" !== a)
		                   throw new
		                          RangeError
		                          ("Unknown era ".concat(a, ' in "').concat(e));
		                  var i = + t[4];
		                  24 === i && (i = 0);
		                  var s = + t[5], l = + t[6];
		                  if(! (me(n) && me(r) && me(o) && me(i) && me(s) && me(l)))
		                   throw new RangeError('Invalid number in "'.concat(e));
		                  return {year: n,
		                          month: r,
		                          day: o,
		                          hour: i,
		                          minute: s,
		                          second: l};
		                 }
		                 (r);
		        }
		        (e, r),
		     i = _GetFormatterParts.year,
		     s = _GetFormatterParts.month,
		     l = _GetFormatterParts.day,
		     d = _GetFormatterParts.hour,
		     m = _GetFormatterParts.minute,
		     c = _GetFormatterParts.second;
		    return BalanceISODateTime(i, s, l, d, m, c, o, n, a);
		   }
		   function maxJSBI(t, r){return t < r ? r : t;}
		   function afterLatestPossibleTzdbRuleChange(){return Ve() + Ze;}
		   function GetNamedTimeZoneNextTransition(t, r){
		    if(r < Pe) return GetNamedTimeZoneNextTransition(t, Pe);
		    var
		     o = r + Be,
		     n = maxJSBI(afterLatestPossibleTzdbRuleChange(), o),
		     a = maxJSBI(Pe, r),
		     i = GetNamedTimeZoneOffsetNanoseconds(t, a),
		     s = a,
		     l = i;
		    for(; i === l && BigInt(a) < n;){
		     if(s = a + Ne, s > Re) return null;
		     l = GetNamedTimeZoneOffsetNanoseconds(t, s), i === l && (a = s);
		    }
		    if(i === l) return null;
		    return bisect
		            (function(e){return GetNamedTimeZoneOffsetNanoseconds(t, e);},
		             a,
		             s,
		             i,
		             l);
		   }
		   function GetNamedTimeZonePreviousTransition(t, r){
		    var
		     o = afterLatestPossibleTzdbRuleChange(),
		     a = r > o,
		     i = a ? r - Be : Pe;
		    if("Africa/Casablanca" === t || "Africa/El_Aaiun" === t){
		     var _o13 = GetSlot(ToTemporalInstant("2088-01-01T00Z"), n);
		     if(_o13 < r) return GetNamedTimeZonePreviousTransition(t, _o13);
		    }
		    var s = r - Se;
		    if(s < Pe) return null;
		    var l = GetNamedTimeZoneOffsetNanoseconds(t, s), d = s, m = l;
		    for(; l === m && s > i;){
		     if(d = s - Ne, d < Pe) return null;
		     m = GetNamedTimeZoneOffsetNanoseconds(t, d), l === m && (s = d);
		    }
		    if(l === m){
		     if(a){
		      var _r36 = o - Ee;
		      return GetNamedTimeZonePreviousTransition(t, _r36);
		     }
		     return null;
		    }
		    return bisect
		            (function(e){return GetNamedTimeZoneOffsetNanoseconds(t, e);},
		             d,
		             s,
		             m,
		             l);
		   }
		   function LeapYear(e){
		    if(void 0 === e) return ! 1;
		    return e % 4 == 0 && (! (e % 100 == 0) || e % 400 == 0);
		   }
		   function ISODaysInMonth(e, t){
		    return {standard: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
		              leapyear: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]}
		             [LeapYear(e) ? "leapyear" : "standard"]
		            [t - 1];
		   }
		   function DayOfWeek(e, t, r){
		    var
		     o = t + (t < 3 ? 10 : - 2),
		     n = e - (t < 3 ? 1 : 0),
		     a = ie(n / 100),
		     i = n - 100 * a,
		     s = (r + ie(2.6 * o - .2) + (i + ie(i / 4)) + (ie(a / 4) - 2 * a)) % 7;
		    return s + (s <= 0 ? 7 : 0);
		   }
		   function DayOfYear(e, t, r){
		    var o = r;
		    for(var _r37 = t - 1; _r37 > 0; _r37--) o += ISODaysInMonth(e, _r37);
		    return o;
		   }
		   function WeekOfYear(e, t, r){
		    var
		     o = DayOfYear(e, t, r),
		     n = DayOfWeek(e, t, r) || 7,
		     a = DayOfWeek(e, 1, 1),
		     i = ie((o - n + 10) / 7);
		    return i < 1
		            ? 5
		              === a
		              || 6 === a && LeapYear(e - 1)
		              ? {week: 53, year: e - 1}
		              : {week: 52, year: e - 1}
		            : 53
		              === i
		              && (LeapYear(e) ? 366 : 365) - o < 4 - n
		              ? {week: 1, year: e + 1}
		              : {week: i, year: e};
		   }
		   function DurationSign(e, t, r, o, n, a, i, s, l, d){
		    for
		    (var _i7 = 0, _arr2 = [e, t, r, o, n, a, i, s, l, d];
		     _i7 < _arr2.length;
		     _i7++){var _m2 = _arr2[_i7]; if(0 !== _m2) return _m2 < 0 ? - 1 : 1;}
		    return 0;
		   }
		   function BalanceISOYearMonth(e, t){
		    var r = e, o = t;
		    if(! me(r) || ! me(o)) throw new RangeError("infinity is out of range");
		    return o -= 1,
		           r += ie(o / 12),
		           o %= 12,
		           o < 0 && (o += 12),
		           o += 1,
		           {year: r, month: o};
		   }
		   function BalanceISODate(e, t, r){
		    var o = e, n = t, a = r;
		    if(! me(a)) throw new RangeError("infinity is out of range");
		    var _BalanceISOYearMonth = BalanceISOYearMonth(o, n);
		    o = _BalanceISOYearMonth.year;
		    n = _BalanceISOYearMonth.month;
		    var i = 146097;
		    if(ae(a) > i){var _e24 = le(a / i); o += 400 * _e24, a -= _e24 * i;}
		    var s = 0, l = n > 2 ? o : o - 1;
		    for(; s = LeapYear(l) ? 366 : 365, a < - s;) o -= 1, l -= 1, a += s;
		    for(l += 1; s = LeapYear(l) ? 366 : 365, a > s;) o += 1, l += 1, a -= s;
		    for(; a < 1;){
		     var _BalanceISOYearMonth2;
		     _BalanceISOYearMonth2 = BalanceISOYearMonth(o, n - 1),
		     o = _BalanceISOYearMonth2.year,
		     n = _BalanceISOYearMonth2.month,
		     a += ISODaysInMonth(o, n);
		    }
		    for(; a > ISODaysInMonth(o, n);){
		     var _BalanceISOYearMonth3;
		     a -= ISODaysInMonth(o, n),
		     _BalanceISOYearMonth3 = BalanceISOYearMonth(o, n + 1),
		     o = _BalanceISOYearMonth3.year,
		     n = _BalanceISOYearMonth3.month;
		    }
		    return {year: o, month: n, day: a};
		   }
		   function BalanceISODateTime(e, t, r, o, n, a, i, s, l){
		    var
		     _BalanceTime = BalanceTime(o, n, a, i, s, l),
		     d = _BalanceTime.deltaDays,
		     m = _BalanceTime.hour,
		     c = _BalanceTime.minute,
		     h = _BalanceTime.second,
		     u = _BalanceTime.millisecond,
		     T = _BalanceTime.microsecond,
		     p = _BalanceTime.nanosecond,
		     _BalanceISODate = BalanceISODate(e, t, r + d),
		     f = _BalanceISODate.year,
		     y = _BalanceISODate.month,
		     I = _BalanceISODate.day;
		    return {year: f,
		            month: y,
		            day: I,
		            hour: m,
		            minute: c,
		            second: h,
		            millisecond: u,
		            microsecond: T,
		            nanosecond: p};
		   }
		   function BalanceTime(t, r, o, n, a, i){
		    var
		     _NonNegativeBigIntDiv,
		     _NonNegativeBigIntDiv2,
		     _NonNegativeBigIntDiv3,
		     _NonNegativeBigIntDiv4,
		     _NonNegativeBigIntDiv5,
		     _NonNegativeBigIntDiv6,
		     s,
		     l = BigInt(t),
		     d = BigInt(r),
		     m = BigInt(o),
		     c = BigInt(n),
		     h = BigInt(a),
		     u = BigInt(i);
		    return _NonNegativeBigIntDiv = NonNegativeBigIntDivmod(u, De),
		           s = _NonNegativeBigIntDiv.quotient,
		           u = _NonNegativeBigIntDiv.remainder,
		           h = h + s,
		           _NonNegativeBigIntDiv2 = NonNegativeBigIntDivmod(h, De),
		           s = _NonNegativeBigIntDiv2.quotient,
		           h = _NonNegativeBigIntDiv2.remainder,
		           c = c + s,
		           _NonNegativeBigIntDiv3 = NonNegativeBigIntDivmod(c, De),
		           s = _NonNegativeBigIntDiv3.quotient,
		           c = _NonNegativeBigIntDiv3.remainder,
		           m = m + s,
		           _NonNegativeBigIntDiv4 = NonNegativeBigIntDivmod(m, ge),
		           s = _NonNegativeBigIntDiv4.quotient,
		           m = _NonNegativeBigIntDiv4.remainder,
		           d = d + s,
		           _NonNegativeBigIntDiv5 = NonNegativeBigIntDivmod(d, ge),
		           s = _NonNegativeBigIntDiv5.quotient,
		           d = _NonNegativeBigIntDiv5.remainder,
		           l = l + s,
		           _NonNegativeBigIntDiv6 = NonNegativeBigIntDivmod(l, we),
		           s = _NonNegativeBigIntDiv6.quotient,
		           l = _NonNegativeBigIntDiv6.remainder,
		           {deltaDays: Number(s),
		            hour: Number(l),
		            minute: Number(d),
		            second: Number(m),
		            millisecond: Number(c),
		            microsecond: Number(h),
		            nanosecond: Number(u)};
		   }
		   function TotalDurationNanoseconds(t, r, o, n, a, i, s, l){
		    var d = BigInt(t), m = BigInt(s);
		    0 !== t && (m = BigInt(s) - BigInt(l));
		    var
		     c = BigInt(r) + d * 24n,
		     h = BigInt(o) + c * ge,
		     u = BigInt(n) + h * ge,
		     T = BigInt(a) + u * De,
		     p = BigInt(i) + T * De;
		    return BigInt(m) + p * De;
		   }
		   function NanosecondsToDays(t, r){
		    var
		     o = GetIntrinsic("%Temporal.Instant%"),
		     a = se(Number(t)),
		     f = BigInt(t),
		     y = 864e11;
		    if(0 === a) return {days: 0, nanoseconds: Ie, dayLengthNs: y};
		    if(! IsTemporalZonedDateTime(r)){
		     var _divmod5, _t24;
		     return _divmod5 = divmod(f, BigInt(y)),
		            _t24 = _divmod5.quotient,
		            f = _divmod5.remainder,
		            {days: Number(_t24), nanoseconds: f, dayLengthNs: y};
		    }
		    var
		     I = GetSlot(r, n),
		     w = GetSlot(r, S),
		     D = I + f,
		     G = new o(D),
		     v = GetSlot(r, g),
		     C = GetSlot(r, p),
		     O = GetPlainDateTimeFor(v, w, C),
		     b = GetPlainDateTimeFor(v, G, C),
		     _DifferenceISODateTim =
		       DifferenceISODateTime
		        (GetSlot(O, i),
		         GetSlot(O, s),
		         GetSlot(O, l),
		         GetSlot(O, d),
		         GetSlot(O, m),
		         GetSlot(O, c),
		         GetSlot(O, h),
		         GetSlot(O, u),
		         GetSlot(O, T),
		         GetSlot(b, i),
		         GetSlot(b, s),
		         GetSlot(b, l),
		         GetSlot(b, d),
		         GetSlot(b, m),
		         GetSlot(b, c),
		         GetSlot(b, h),
		         GetSlot(b, u),
		         GetSlot(b, T),
		         C,
		         "day",
		         Te(null)),
		     E = _DifferenceISODateTim.days,
		     M = AddZonedDateTime(w, v, C, 0, 0, 0, E, 0, 0, 0, 0, 0, 0),
		     R = BigInt(E);
		    if(1 === a)
		     for(; R > Ie && M > D;)
		      R = R - Se,
		      M = AddZonedDateTime(w, v, C, 0, 0, 0, Number(R), 0, 0, 0, 0, 0, 0);
		    f = D - M;
		    var F = ! 1, Y = new o(M);
		    do{
		     var
		      _t25 = AddZonedDateTime(Y, v, C, 0, 0, 0, a, 0, 0, 0, 0, 0, 0),
		      _r38 = GetSlot(Y, n);
		     y = Number(_t25 - _r38),
		     F = (f - BigInt(y)) * BigInt(a) >= Ie,
		     F && (f = f - BigInt(y), Y = new o(_t25), R = R + BigInt(a));
		    }
		    while
		     (F);
		    if(! isZero(R) && signJSBI(R) !== a)
		     throw new
		            RangeError
		            ("Time zone or calendar converted nanoseconds into a number of days with the opposite sign");
		    if(! isZero(f) && signJSBI(f) !== a){
		     if(isNegativeJSBI(f) && 1 === a) throw new Error("assert not reached");
		     throw new
		            RangeError
		            ("Time zone or calendar ended up with a remainder of nanoseconds with the opposite sign");
		    }
		    if(abs(f) >= abs(BigInt(y))) throw new Error("assert not reached");
		    return {days: Number(R), nanoseconds: f, dayLengthNs: ae(y)};
		   }
		   function BalanceDuration(e, t, r, o, n, a, i, s, l){
		    var d = BalancePossiblyInfiniteDuration(e, t, r, o, n, a, i, s, l);
		    if("positive overflow" === d || "negative overflow" === d)
		     throw new RangeError("Duration out of range");
		    return d;
		   }
		   function BalancePossiblyInfiniteDuration(t, r, o, a, i, s, l, d, m){
		    var
		     _NanosecondsToDays,
		     _divmod6,
		     _divmod7,
		     _divmod8,
		     _divmod9,
		     _divmod10,
		     _divmod11,
		     _divmod12,
		     _divmod13,
		     _divmod14,
		     _divmod15,
		     _divmod16,
		     _divmod17,
		     _divmod18,
		     _divmod19,
		     c,
		     h,
		     u,
		     T,
		     f,
		     y,
		     I = t;
		    if(IsTemporalZonedDateTime(m)){
		     var
		      _t26 =
		        AddZonedDateTime
		         (GetSlot(m, S),
		          GetSlot(m, g),
		          GetSlot(m, p),
		          0,
		          0,
		          0,
		          I,
		          r,
		          o,
		          a,
		          i,
		          s,
		          l),
		      _d = GetSlot(m, n);
		     c = _t26 - _d;
		    }
		    else
		     c = TotalDurationNanoseconds(I, r, o, a, i, s, l, 0);
		    "year" === d || "month" === d || "week" === d || "day" === d
		     ? (_NanosecondsToDays
		       = NanosecondsToDays(c, m),
		       I = _NanosecondsToDays.days,
		       c = _NanosecondsToDays.nanoseconds,
		       _NanosecondsToDays)
		     : I = 0;
		    var w = c < Ie ? - 1 : 1;
		    switch(c = abs(c), h = u = T = f = y = Ie, d){
		      case "year":
		      case "month":
		      case "week":
		      case "day":
		      case "hour":
		       _divmod6 = divmod(c, De),
		       h = _divmod6.quotient,
		       c = _divmod6.remainder,
		       _divmod7 = divmod(h, De),
		       u = _divmod7.quotient,
		       h = _divmod7.remainder,
		       _divmod8 = divmod(u, De),
		       T = _divmod8.quotient,
		       u = _divmod8.remainder,
		       _divmod9 = divmod(T, ge),
		       f = _divmod9.quotient,
		       T = _divmod9.remainder,
		       _divmod10 = divmod(f, ge),
		       y = _divmod10.quotient,
		       f = _divmod10.remainder;
		       break;
		      case "minute":
		       _divmod11 = divmod(c, De),
		       h = _divmod11.quotient,
		       c = _divmod11.remainder,
		       _divmod12 = divmod(h, De),
		       u = _divmod12.quotient,
		       h = _divmod12.remainder,
		       _divmod13 = divmod(u, De),
		       T = _divmod13.quotient,
		       u = _divmod13.remainder,
		       _divmod14 = divmod(T, ge),
		       f = _divmod14.quotient,
		       T = _divmod14.remainder;
		       break;
		      case "second":
		       _divmod15 = divmod(c, De),
		       h = _divmod15.quotient,
		       c = _divmod15.remainder,
		       _divmod16 = divmod(h, De),
		       u = _divmod16.quotient,
		       h = _divmod16.remainder,
		       _divmod17 = divmod(u, De),
		       T = _divmod17.quotient,
		       u = _divmod17.remainder;
		       break;
		      case "millisecond":
		       _divmod18 = divmod(c, De),
		       h = _divmod18.quotient,
		       c = _divmod18.remainder,
		       _divmod19 = divmod(h, De),
		       u = _divmod19.quotient,
		       h = _divmod19.remainder;
		       break;
		      case "microsecond":
		       var _divmod20 = divmod(c, De);
		       h = _divmod20.quotient;
		       c = _divmod20.remainder;
		       break;
		      case "nanosecond": break;
		      default: throw new Error("assert not reached");
		    }
		    var
		     D = Number(y) * w,
		     G = Number(f) * w,
		     v = Number(T) * w,
		     C = Number(u) * w,
		     O = Number(h) * w,
		     b = Number(c) * w;
		    for(var _i8 = 0, _arr3 = [I, D, G, v, C, O, b]; _i8 < _arr3.length; _i8++){
		     var _e25 = _arr3[_i8];
		     if(! me(_e25))
		      return 1 === w ? "positive overflow" : "negative overflow";
		    }
		    return {days: I,
		            hours: D,
		            minutes: G,
		            seconds: v,
		            milliseconds: C,
		            microseconds: O,
		            nanoseconds: b};
		   }
		   function UnbalanceDurationRelative(t, r, o, n, a, i){
		    var
		     s = GetIntrinsic("%Temporal.Duration%"),
		     l = DurationSign(t, r, o, n, 0, 0, 0, 0, 0, 0);
		    if(0 === l) return {years: t, months: r, weeks: o, days: n};
		    var
		     d = BigInt(l),
		     m,
		     c,
		     h = BigInt(t),
		     u = BigInt(r),
		     T = BigInt(o),
		     f = BigInt(n);
		    i && (c = ToTemporalDate(i), m = GetSlot(c, p));
		    var y = new s(l), I = new s(0, l), S = new s(0, 0, l);
		    switch(a){
		      case "year": break;
		      case "month":
		       {
		        if(! m)
		         throw new
		                RangeError
		                ("a starting point is required for months balancing");
		        var _t27, _r39;
		        for
		        ("string" != typeof m
		         && (_t27 = GetMethod(m, "dateAdd"), _r39 = GetMethod(m, "dateUntil"));
		         !
		         isZero(h);){
		         var _o14 = CalendarDateAdd(m, c, y, void 0, _t27), _n9 = Te(null);
		         _n9.largestUnit = "month";
		         var
		          _a6 = CalendarDateUntil(m, c, _o14, _n9, _r39),
		          _i9 = BigInt(GetSlot(_a6, D));
		         c = _o14, u = u + _i9, h = h - d;
		        }
		       }
		       break;
		      case "week":
		       {
		        if(! m)
		         throw new
		                RangeError
		                ("a starting point is required for weeks balancing");
		        var _t28 = "string" != typeof m ? GetMethod(m, "dateAdd") : void 0;
		        for(; ! isZero(h);){
		         var _MoveRelativeDate, _r40 = void 0;
		         _MoveRelativeDate = MoveRelativeDate(m, c, y, _t28),
		         c = _MoveRelativeDate.relativeTo,
		         _r40 = _MoveRelativeDate.days,
		         f = f + BigInt(_r40),
		         h = h - d;
		        }
		        for(; ! isZero(u);){
		         var _MoveRelativeDate2, _r41 = void 0;
		         _MoveRelativeDate2 = MoveRelativeDate(m, c, I, _t28),
		         c = _MoveRelativeDate2.relativeTo,
		         _r41 = _MoveRelativeDate2.days,
		         f = f + BigInt(_r41),
		         u = u - d;
		        }
		        break;
		       }
		      default:
		       {
		        if(isZero(h) && isZero(u) && isZero(T)) break;
		        if(! m)
		         throw new
		                RangeError
		                ("a starting point is required for balancing calendar units");
		        var _t29 = "string" != typeof m ? GetMethod(m, "dateAdd") : void 0;
		        for(; ! isZero(h);){
		         var _MoveRelativeDate3, _r42 = void 0;
		         _MoveRelativeDate3 = MoveRelativeDate(m, c, y, _t29),
		         c = _MoveRelativeDate3.relativeTo,
		         _r42 = _MoveRelativeDate3.days,
		         f = f + BigInt(_r42),
		         h = h - d;
		        }
		        for(; ! isZero(u);){
		         var _MoveRelativeDate4, _r43 = void 0;
		         _MoveRelativeDate4 = MoveRelativeDate(m, c, I, _t29),
		         c = _MoveRelativeDate4.relativeTo,
		         _r43 = _MoveRelativeDate4.days,
		         f = f + BigInt(_r43),
		         u = u - d;
		        }
		        for(; ! isZero(T);){
		         var _MoveRelativeDate5, _r44 = void 0;
		         _MoveRelativeDate5 = MoveRelativeDate(m, c, S, _t29),
		         c = _MoveRelativeDate5.relativeTo,
		         _r44 = _MoveRelativeDate5.days,
		         f = f + BigInt(_r44),
		         T = T - d;
		        }
		        break;
		       }
		    }
		    return {years: Number(h),
		            months: Number(u),
		            weeks: Number(T),
		            days: Number(f)};
		   }
		   function CalculateOffsetShift(e, t, r, o, n){
		    if(IsTemporalZonedDateTime(e)){
		     var
		      _a7 = GetSlot(e, S),
		      _i10 = GetSlot(e, g),
		      _s = GetSlot(e, p),
		      _l2 = GetOffsetNanosecondsFor(_i10, _a7),
		      _d2 = AddZonedDateTime(_a7, _i10, _s, t, r, o, n, 0, 0, 0, 0, 0, 0);
		     return GetOffsetNanosecondsFor
		             (_i10, new (GetIntrinsic("%Temporal.Instant%"))(_d2))
		            - _l2;
		    }
		    return 0;
		   }
		   function CreateNegatedTemporalDuration(e){
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (- GetSlot(e, w),
		             - GetSlot(e, D),
		             - GetSlot(e, G),
		             - GetSlot(e, v),
		             - GetSlot(e, C),
		             - GetSlot(e, O),
		             - GetSlot(e, b),
		             - GetSlot(e, E),
		             - GetSlot(e, M),
		             - GetSlot(e, R));
		   }
		   function ConstrainToRange(e, t, r){return oe(r, ne(t, e));}
		   function ConstrainISODate(e, t, r){
		    var o = ConstrainToRange(t, 1, 12);
		    return {year: e,
		            month: o,
		            day: ConstrainToRange(r, 1, ISODaysInMonth(e, o))};
		   }
		   function RejectToRange(e, t, r){
		    if(e < t || e > r)
		     throw new
		            RangeError
		            ("value out of range: ".concat(t, " <= ").concat(e, " <= ").concat
		              (r));
		   }
		   function RejectISODate(e, t, r){
		    RejectToRange(t, 1, 12), RejectToRange(r, 1, ISODaysInMonth(e, t));
		   }
		   function RejectDateRange(e, t, r){
		    RejectDateTimeRange(e, t, r, 12, 0, 0, 0, 0, 0);
		   }
		   function RejectTime(e, t, r, o, n, a){
		    RejectToRange(e, 0, 23),
		    RejectToRange(t, 0, 59),
		    RejectToRange(r, 0, 59),
		    RejectToRange(o, 0, 999),
		    RejectToRange(n, 0, 999),
		    RejectToRange(a, 0, 999);
		   }
		   function RejectDateTime(e, t, r, o, n, a, i, s, l){
		    RejectISODate(e, t, r), RejectTime(o, n, a, i, s, l);
		   }
		   function RejectDateTimeRange(e, t, r, o, n, a, i, s, l){
		    if
		     (RejectToRange(e, Fe, Ye),
		      e === Fe
		      && null == GetUTCEpochNanoseconds(e, t, r + 1, o, n, a, i, s, l - 1)
		      ||
		       e === Ye
		       && null == GetUTCEpochNanoseconds(e, t, r - 1, o, n, a, i, s, l + 1))
		     throw new RangeError("DateTime outside of supported range");
		   }
		   function ValidateEpochNanoseconds(t){
		    if(t < Me || t > Re)
		     throw new RangeError("Instant outside of supported range");
		   }
		   function RejectDuration(e, t, r, o, n, a, i, s, l, d){
		    var m = DurationSign(e, t, r, o, n, a, i, s, l, d);
		    for
		    (var _i11 = 0, _arr4 = [e, t, r, o, n, a, i, s, l, d];
		     _i11 < _arr4.length;
		     _i11++){
		     var _c2 = _arr4[_i11];
		     if(! me(_c2))
		      throw new RangeError("infinite values not allowed as duration fields");
		     var _e26 = se(_c2);
		     if(0 !== _e26 && _e26 !== m)
		      throw new RangeError("mixed-sign values not allowed as duration fields");
		    }
		   }
		   function DifferenceISODate(e, t, r, o, n, a, i){
		    switch(i){
		      case "year":
		      case "month":
		       {
		        var _s2 = - CompareISODate(e, t, r, o, n, a);
		        if(0 === _s2) return {years: 0, months: 0, weeks: 0, days: 0};
		        var
		         _l3 = {year: e, month: t, day: r},
		         _d3 = {year: o, month: n, day: a},
		         _m3 = _d3.year - _l3.year,
		         _c3 = AddISODate(e, t, r, _m3, 0, 0, 0, "constrain"),
		         _h = - CompareISODate(_c3.year, _c3.month, _c3.day, o, n, a);
		        if(0 === _h)
		         return "year" === i
		                 ? {years: _m3, months: 0, weeks: 0, days: 0}
		                 : {years: 0, months: 12 * _m3, weeks: 0, days: 0};
		        var _u = _d3.month - _l3.month;
		        if
		         (_h !== _s2 && (_m3 -= _s2, _u += 12 * _s2),
		          _c3 = AddISODate(e, t, r, _m3, _u, 0, 0, "constrain"),
		          _h = - CompareISODate(_c3.year, _c3.month, _c3.day, o, n, a),
		          0 === _h)
		         return "year" === i
		                 ? {years: _m3, months: _u, weeks: 0, days: 0}
		                 : {years: 0, months: _u + 12 * _m3, weeks: 0, days: 0};
		        _h !== _s2
		        &&
		         (_u -= _s2,
		          _u === - _s2 && (_m3 -= _s2, _u = 11 * _s2),
		          _c3 = AddISODate(e, t, r, _m3, _u, 0, 0, "constrain"));
		        var _T = 0;
		        return _T =
		                _c3.month === _d3.month
		                 ? _d3.day - _c3.day
		                 : _s2
		                   < 0
		                   ? -
		                    _c3.day
		                    - (ISODaysInMonth(_d3.year, _d3.month) - _d3.day)
		                   : _d3.day + (ISODaysInMonth(_c3.year, _c3.month) - _c3.day),
		               "month" === i && (_u += 12 * _m3, _m3 = 0),
		               {years: _m3, months: _u, weeks: 0, days: _T};
		       }
		      case "week":
		      case "day":
		       {
		        var _s3, _l4, _d4;
		        CompareISODate(e, t, r, o, n, a) < 0
		         ? (_l4
		           = {year: e, month: t, day: r},
		           _s3 = {year: o, month: n, day: a},
		           _d4 = 1)
		         : (_l4
		           = {year: o, month: n, day: a},
		           _s3 = {year: e, month: t, day: r},
		           _d4 = - 1);
		        var
		         _m4 =
		           DayOfYear(_s3.year, _s3.month, _s3.day)
		           - DayOfYear(_l4.year, _l4.month, _l4.day);
		        for(var _e27 = _l4.year; _e27 < _s3.year; ++_e27)
		         _m4 += LeapYear(_e27) ? 366 : 365;
		        var _c4 = 0;
		        return "week" === i && (_c4 = ie(_m4 / 7), _m4 %= 7),
		               _c4 *= _d4,
		               _m4 *= _d4,
		               {years: 0, months: 0, weeks: _c4, days: _m4};
		       }
		      default: throw new Error("assert not reached");
		    }
		   }
		   function DifferenceTime(e, t, r, o, n, a, i, s, l, d, m, c){
		    var
		     _BalanceTime2,
		     h = i - e,
		     u = s - t,
		     T = l - r,
		     p = d - o,
		     f = m - n,
		     y = c - a,
		     I = DurationSign(0, 0, 0, 0, h, u, T, p, f, y);
		    h *= I, u *= I, T *= I, p *= I, f *= I, y *= I;
		    var S = 0;
		    if
		     (_BalanceTime2 = BalanceTime(h, u, T, p, f, y),
		      S = _BalanceTime2.deltaDays,
		      h = _BalanceTime2.hour,
		      u = _BalanceTime2.minute,
		      T = _BalanceTime2.second,
		      p = _BalanceTime2.millisecond,
		      f = _BalanceTime2.microsecond,
		      y = _BalanceTime2.nanosecond,
		      0 != S)
		     throw new
		            Error
		            ("assertion failure in DifferenceTime: _bt_.[[Days]] should be 0");
		    return h *= I,
		           u *= I,
		           T *= I,
		           p *= I,
		           f *= I,
		           y *= I,
		           {hours: h,
		            minutes: u,
		            seconds: T,
		            milliseconds: p,
		            microseconds: f,
		            nanoseconds: y};
		   }
		   function DifferenceInstant(t, r, o, n, a, i){
		    var
		     _RoundDuration2,
		     s = r - t,
		     l = 0,
		     d = 0,
		     m = Number(s % De),
		     c = Number(s / De % De),
		     h = Number(s / Ge % De),
		     u = Number(s / ve);
		    return _RoundDuration2 =
		            RoundDuration(0, 0, 0, 0, 0, 0, u, h, c, m, o, n, i),
		           l = _RoundDuration2.hours,
		           d = _RoundDuration2.minutes,
		           u = _RoundDuration2.seconds,
		           h = _RoundDuration2.milliseconds,
		           c = _RoundDuration2.microseconds,
		           m = _RoundDuration2.nanoseconds,
		           BalanceDuration(0, l, d, u, h, c, m, a);
		   }
		   function DifferenceISODateTime
		   (e, t, r, o, n, a, i, s, l, d, m, c, h, u, T, p, f, y, I, S, g){
		    var
		     _BalanceISODate2,
		     _BalanceDuration,
		     _BalanceDuration2,
		     w = e,
		     D = t,
		     G = r,
		     _DifferenceTime = DifferenceTime(o, n, a, i, s, l, h, u, T, p, f, y),
		     v = _DifferenceTime.hours,
		     C = _DifferenceTime.minutes,
		     O = _DifferenceTime.seconds,
		     b = _DifferenceTime.milliseconds,
		     E = _DifferenceTime.microseconds,
		     M = _DifferenceTime.nanoseconds,
		     R = DurationSign(0, 0, 0, 0, v, C, O, b, E, M);
		    CompareISODate(d, m, c, w, D, G) === - R
		    &&
		     (_BalanceISODate2 = BalanceISODate(w, D, G - R),
		      w = _BalanceISODate2.year,
		      D = _BalanceISODate2.month,
		      G = _BalanceISODate2.day,
		      _BalanceDuration = BalanceDuration(- R, v, C, O, b, E, M, S),
		      v = _BalanceDuration.hours,
		      C = _BalanceDuration.minutes,
		      O = _BalanceDuration.seconds,
		      b = _BalanceDuration.milliseconds,
		      E = _BalanceDuration.microseconds,
		      M = _BalanceDuration.nanoseconds);
		    var
		     F = CreateTemporalDate(w, D, G, I),
		     Y = CreateTemporalDate(d, m, c, I),
		     P = LargerOfTwoTemporalUnits("day", S),
		     Z = CopyOptions(g);
		    Z.largestUnit = P;
		    var
		     _CalendarDateUntil = CalendarDateUntil(I, F, Y, Z),
		     B = _CalendarDateUntil.years,
		     N = _CalendarDateUntil.months,
		     j = _CalendarDateUntil.weeks,
		     $ = _CalendarDateUntil.days;
		    return _BalanceDuration2 = BalanceDuration($, v, C, O, b, E, M, S),
		           $ = _BalanceDuration2.days,
		           v = _BalanceDuration2.hours,
		           C = _BalanceDuration2.minutes,
		           O = _BalanceDuration2.seconds,
		           b = _BalanceDuration2.milliseconds,
		           E = _BalanceDuration2.microseconds,
		           M = _BalanceDuration2.nanoseconds,
		           {years: B,
		            months: N,
		            weeks: j,
		            days: $,
		            hours: v,
		            minutes: C,
		            seconds: O,
		            milliseconds: b,
		            microseconds: E,
		            nanoseconds: M};
		   }
		   function DifferenceZonedDateTime(t, r, o, n, a, p){
		    var f = r - t;
		    if(f === Ie)
		     return {years: 0,
		             months: 0,
		             weeks: 0,
		             days: 0,
		             hours: 0,
		             minutes: 0,
		             seconds: 0,
		             milliseconds: 0,
		             microseconds: 0,
		             nanoseconds: 0};
		    var
		     y = GetIntrinsic("%Temporal.Instant%"),
		     I = new y(t),
		     S = new y(r),
		     g = GetPlainDateTimeFor(o, I, n),
		     w = GetPlainDateTimeFor(o, S, n),
		     _DifferenceISODateTim2 =
		       DifferenceISODateTime
		        (GetSlot(g, i),
		         GetSlot(g, s),
		         GetSlot(g, l),
		         GetSlot(g, d),
		         GetSlot(g, m),
		         GetSlot(g, c),
		         GetSlot(g, h),
		         GetSlot(g, u),
		         GetSlot(g, T),
		         GetSlot(w, i),
		         GetSlot(w, s),
		         GetSlot(w, l),
		         GetSlot(w, d),
		         GetSlot(w, m),
		         GetSlot(w, c),
		         GetSlot(w, h),
		         GetSlot(w, u),
		         GetSlot(w, T),
		         n,
		         a,
		         p),
		     D = _DifferenceISODateTim2.years,
		     G = _DifferenceISODateTim2.months,
		     v = _DifferenceISODateTim2.weeks,
		     C = _DifferenceISODateTim2.days,
		     O = AddZonedDateTime(I, o, n, D, G, v, 0, 0, 0, 0, 0, 0, 0),
		     b = r - O,
		     E = CreateTemporalZonedDateTime(O, o, n),
		     _NanosecondsToDays2 = NanosecondsToDays(b, E);
		    b = _NanosecondsToDays2.nanoseconds;
		    C = _NanosecondsToDays2.days;
		    var
		     _BalanceDuration3 = BalanceDuration(0, 0, 0, 0, 0, 0, Number(b), "hour"),
		     M = _BalanceDuration3.hours,
		     R = _BalanceDuration3.minutes,
		     F = _BalanceDuration3.seconds,
		     Y = _BalanceDuration3.milliseconds,
		     P = _BalanceDuration3.microseconds,
		     Z = _BalanceDuration3.nanoseconds;
		    return {years: D,
		            months: G,
		            weeks: v,
		            days: C,
		            hours: M,
		            minutes: R,
		            seconds: F,
		            milliseconds: Y,
		            microseconds: P,
		            nanoseconds: Z};
		   }
		   function GetDifferenceSettings(e, t, r, o, n, a){
		    var
		     i =
		       Ue.reduce
		        (function(e, t){
		          var n = t[0], a = t[1], i = t[2];
		          return "datetime" !== r && i !== r || o.includes(a) || e.push(a, n),
		                 e;
		         },
		         []),
		     s = GetTemporalUnit(t, "largestUnit", r, "auto");
		    if(o.includes(s))
		     throw new
		            RangeError
		            ("largestUnit must be one of ".concat(i.join(", "), ", not ").concat
		              (s));
		    var
		     l = ToTemporalRoundingIncrement(t),
		     d = ToTemporalRoundingMode(t, "trunc");
		    "since" === e
		    &&
		     (d =
		      function(e){
		        switch(e){
		          case "ceil":
		           return "floor";
		          case "floor":
		           return "ceil";
		          case "halfCeil":
		           return "halfFloor";
		          case "halfFloor":
		           return "halfCeil";
		          default: return e;
		        }
		       }
		       (d));
		    var m = GetTemporalUnit(t, "smallestUnit", r, n);
		    if(o.includes(m))
		     throw new
		            RangeError
		            ("smallestUnit must be one of ".concat(i.join(", "), ", not ").concat
		              (m));
		    var c = LargerOfTwoTemporalUnits(a, m);
		    if("auto" === s && (s = c), LargerOfTwoTemporalUnits(s, m) !== s)
		     throw new
		            RangeError
		            ("largestUnit ".concat(s, " cannot be smaller than smallestUnit ").concat
		              (m));
		    var
		     h =
		       {hour: 24,
		         minute: 60,
		         second: 60,
		         millisecond: 1e3,
		         microsecond: 1e3,
		         nanosecond: 1e3}
		        [m];
		    return void 0 !== h && ValidateTemporalRoundingIncrement(l, h, ! 1),
		           {largestUnit: s,
		            roundingIncrement: l,
		            roundingMode: d,
		            smallestUnit: m};
		   }
		   function DifferenceTemporalInstant(e, t, r, o){
		    var
		     a = "since" === e ? - 1 : 1,
		     i = ToTemporalInstant(r),
		     s =
		       GetDifferenceSettings
		        (e, CopyOptions(o), "time", [], "nanosecond", "second"),
		     l = GetSlot(t, n),
		     d = GetSlot(i, n),
		     _DifferenceInstant =
		       DifferenceInstant
		        (l,
		         d,
		         s.roundingIncrement,
		         s.smallestUnit,
		         s.largestUnit,
		         s.roundingMode),
		     m = _DifferenceInstant.hours,
		     c = _DifferenceInstant.minutes,
		     h = _DifferenceInstant.seconds,
		     u = _DifferenceInstant.milliseconds,
		     T = _DifferenceInstant.microseconds,
		     p = _DifferenceInstant.nanoseconds;
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (0, 0, 0, 0, a * m, a * c, a * h, a * u, a * T, a * p);
		   }
		   function DifferenceTemporalPlainDate(e, t, r, o){
		    var
		     _RoundDuration3,
		     n = "since" === e ? - 1 : 1,
		     a = ToTemporalDate(r),
		     i = GetSlot(t, p);
		    ThrowIfCalendarsNotEqual
		     (i, GetSlot(a, p), "compute difference between dates");
		    var
		     s = CopyOptions(o),
		     l = GetDifferenceSettings(e, s, "date", [], "day", "day");
		    s.largestUnit = l.largestUnit;
		    var
		     _CalendarDateUntil2 = CalendarDateUntil(i, t, a, s),
		     d = _CalendarDateUntil2.years,
		     m = _CalendarDateUntil2.months,
		     c = _CalendarDateUntil2.weeks,
		     h = _CalendarDateUntil2.days;
		    "day" === l.smallestUnit && 1 === l.roundingIncrement
		    ||
		     (_RoundDuration3 =
		       RoundDuration
		        (d,
		         m,
		         c,
		         h,
		         0,
		         0,
		         0,
		         0,
		         0,
		         0,
		         l.roundingIncrement,
		         l.smallestUnit,
		         l.roundingMode,
		         t),
		      d = _RoundDuration3.years,
		      m = _RoundDuration3.months,
		      c = _RoundDuration3.weeks,
		      h = _RoundDuration3.days,
		      _RoundDuration3);
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (n * d, n * m, n * c, n * h, 0, 0, 0, 0, 0, 0);
		   }
		   function DifferenceTemporalPlainDateTime(e, t, r, o){
		    var
		     _RoundDuration4,
		     _BalanceDuration4,
		     n = "since" === e ? - 1 : 1,
		     a = ToTemporalDateTime(r),
		     f = GetSlot(t, p);
		    ThrowIfCalendarsNotEqual
		     (f, GetSlot(a, p), "compute difference between dates");
		    var
		     y = CopyOptions(o),
		     I = GetDifferenceSettings(e, y, "datetime", [], "nanosecond", "day"),
		     _DifferenceISODateTim3 =
		       DifferenceISODateTime
		        (GetSlot(t, i),
		         GetSlot(t, s),
		         GetSlot(t, l),
		         GetSlot(t, d),
		         GetSlot(t, m),
		         GetSlot(t, c),
		         GetSlot(t, h),
		         GetSlot(t, u),
		         GetSlot(t, T),
		         GetSlot(a, i),
		         GetSlot(a, s),
		         GetSlot(a, l),
		         GetSlot(a, d),
		         GetSlot(a, m),
		         GetSlot(a, c),
		         GetSlot(a, h),
		         GetSlot(a, u),
		         GetSlot(a, T),
		         f,
		         I.largestUnit,
		         y),
		     S = _DifferenceISODateTim3.years,
		     g = _DifferenceISODateTim3.months,
		     w = _DifferenceISODateTim3.weeks,
		     D = _DifferenceISODateTim3.days,
		     G = _DifferenceISODateTim3.hours,
		     v = _DifferenceISODateTim3.minutes,
		     C = _DifferenceISODateTim3.seconds,
		     O = _DifferenceISODateTim3.milliseconds,
		     b = _DifferenceISODateTim3.microseconds,
		     E = _DifferenceISODateTim3.nanoseconds,
		     M = TemporalDateTimeToDate(t);
		    _RoundDuration4 =
		     RoundDuration
		      (S,
		       g,
		       w,
		       D,
		       G,
		       v,
		       C,
		       O,
		       b,
		       E,
		       I.roundingIncrement,
		       I.smallestUnit,
		       I.roundingMode,
		       M),
		    S = _RoundDuration4.years,
		    g = _RoundDuration4.months,
		    w = _RoundDuration4.weeks,
		    D = _RoundDuration4.days,
		    G = _RoundDuration4.hours,
		    v = _RoundDuration4.minutes,
		    C = _RoundDuration4.seconds,
		    O = _RoundDuration4.milliseconds,
		    b = _RoundDuration4.microseconds,
		    E = _RoundDuration4.nanoseconds,
		    _BalanceDuration4 = BalanceDuration(D, G, v, C, O, b, E, I.largestUnit),
		    D = _BalanceDuration4.days,
		    G = _BalanceDuration4.hours,
		    v = _BalanceDuration4.minutes,
		    C = _BalanceDuration4.seconds,
		    O = _BalanceDuration4.milliseconds,
		    b = _BalanceDuration4.microseconds,
		    E = _BalanceDuration4.nanoseconds;
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (n * S,
		             n * g,
		             n * w,
		             n * D,
		             n * G,
		             n * v,
		             n * C,
		             n * O,
		             n * b,
		             n * E);
		   }
		   function DifferenceTemporalPlainTime(e, t, r, o){
		    var
		     _RoundDuration5,
		     _BalanceDuration5,
		     n = "since" === e ? - 1 : 1,
		     a = ToTemporalTime(r),
		     i =
		       GetDifferenceSettings
		        (e, CopyOptions(o), "time", [], "nanosecond", "hour"),
		     _DifferenceTime2 =
		       DifferenceTime
		        (GetSlot(t, d),
		         GetSlot(t, m),
		         GetSlot(t, c),
		         GetSlot(t, h),
		         GetSlot(t, u),
		         GetSlot(t, T),
		         GetSlot(a, d),
		         GetSlot(a, m),
		         GetSlot(a, c),
		         GetSlot(a, h),
		         GetSlot(a, u),
		         GetSlot(a, T)),
		     s = _DifferenceTime2.hours,
		     l = _DifferenceTime2.minutes,
		     p = _DifferenceTime2.seconds,
		     f = _DifferenceTime2.milliseconds,
		     y = _DifferenceTime2.microseconds,
		     I = _DifferenceTime2.nanoseconds;
		    _RoundDuration5 =
		     RoundDuration
		      (0,
		       0,
		       0,
		       0,
		       s,
		       l,
		       p,
		       f,
		       y,
		       I,
		       i.roundingIncrement,
		       i.smallestUnit,
		       i.roundingMode),
		    s = _RoundDuration5.hours,
		    l = _RoundDuration5.minutes,
		    p = _RoundDuration5.seconds,
		    f = _RoundDuration5.milliseconds,
		    y = _RoundDuration5.microseconds,
		    I = _RoundDuration5.nanoseconds,
		    _BalanceDuration5 = BalanceDuration(0, s, l, p, f, y, I, i.largestUnit),
		    s = _BalanceDuration5.hours,
		    l = _BalanceDuration5.minutes,
		    p = _BalanceDuration5.seconds,
		    f = _BalanceDuration5.milliseconds,
		    y = _BalanceDuration5.microseconds,
		    I = _BalanceDuration5.nanoseconds;
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (0, 0, 0, 0, n * s, n * l, n * p, n * f, n * y, n * I);
		   }
		   function DifferenceTemporalPlainYearMonth(e, t, r, o){
		    var
		     _RoundDuration6,
		     n = "since" === e ? - 1 : 1,
		     a = ToTemporalYearMonth(r),
		     i = GetSlot(t, p);
		    ThrowIfCalendarsNotEqual
		     (i, GetSlot(a, p), "compute difference between months");
		    var
		     s = CopyOptions(o),
		     l = GetDifferenceSettings(e, s, "date", ["week", "day"], "month", "year");
		    s.largestUnit = l.largestUnit;
		    var
		     d = CalendarFields(i, ["monthCode", "year"]),
		     m = PrepareTemporalFields(t, d, []);
		    m.day = 1;
		    var c = CalendarDateFromFields(i, m), h = PrepareTemporalFields(a, d, []);
		    h.day = 1;
		    var
		     u = CalendarDateFromFields(i, h),
		     _CalendarDateUntil3 = CalendarDateUntil(i, c, u, s),
		     T = _CalendarDateUntil3.years,
		     f = _CalendarDateUntil3.months;
		    "month" === l.smallestUnit && 1 === l.roundingIncrement
		    ||
		     (_RoundDuration6 =
		       RoundDuration
		        (T,
		         f,
		         0,
		         0,
		         0,
		         0,
		         0,
		         0,
		         0,
		         0,
		         l.roundingIncrement,
		         l.smallestUnit,
		         l.roundingMode,
		         c),
		      T = _RoundDuration6.years,
		      f = _RoundDuration6.months,
		      _RoundDuration6);
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (n * T, n * f, 0, 0, 0, 0, 0, 0, 0, 0);
		   }
		   function DifferenceTemporalZonedDateTime(e, t, r, o){
		    var
		     _DifferenceInstant2,
		     a = "since" === e ? - 1 : 1,
		     i = ToTemporalZonedDateTime(r),
		     s = GetSlot(t, p);
		    ThrowIfCalendarsNotEqual
		     (s, GetSlot(i, p), "compute difference between dates");
		    var
		     l = CopyOptions(o),
		     d = GetDifferenceSettings(e, l, "datetime", [], "nanosecond", "hour");
		    l.largestUnit = d.largestUnit;
		    var m = GetSlot(t, n), c = GetSlot(i, n), h, u, T, f, y, I, S, w, D, G;
		    if
		     ("year" !== d.largestUnit && "month" !== d.largestUnit
		      && "week" !== d.largestUnit
		      && "day" !== d.largestUnit)
		     h = 0,
		     u = 0,
		     T = 0,
		     f = 0,
		     _DifferenceInstant2 =
		      DifferenceInstant
		       (m,
		        c,
		        d.roundingIncrement,
		        d.smallestUnit,
		        d.largestUnit,
		        d.roundingMode),
		     y = _DifferenceInstant2.hours,
		     I = _DifferenceInstant2.minutes,
		     S = _DifferenceInstant2.seconds,
		     w = _DifferenceInstant2.milliseconds,
		     D = _DifferenceInstant2.microseconds,
		     G = _DifferenceInstant2.nanoseconds;
		    else {
		     var
		      _DifferenceZonedDateT,
		      _RoundDuration7,
		      _AdjustRoundedDuratio,
		      _e28 = GetSlot(t, g);
		     if(! TimeZoneEquals(_e28, GetSlot(i, g)))
		      throw new
		             RangeError
		             ("When calculating difference between time zones, largestUnit must be 'hours' or smaller because day lengths can vary between time zones due to DST or time zone offset changes.");
		     _DifferenceZonedDateT =
		      DifferenceZonedDateTime(m, c, _e28, s, d.largestUnit, l),
		     h = _DifferenceZonedDateT.years,
		     u = _DifferenceZonedDateT.months,
		     T = _DifferenceZonedDateT.weeks,
		     f = _DifferenceZonedDateT.days,
		     y = _DifferenceZonedDateT.hours,
		     I = _DifferenceZonedDateT.minutes,
		     S = _DifferenceZonedDateT.seconds,
		     w = _DifferenceZonedDateT.milliseconds,
		     D = _DifferenceZonedDateT.microseconds,
		     G = _DifferenceZonedDateT.nanoseconds,
		     _RoundDuration7 =
		      RoundDuration
		       (h,
		        u,
		        T,
		        f,
		        y,
		        I,
		        S,
		        w,
		        D,
		        G,
		        d.roundingIncrement,
		        d.smallestUnit,
		        d.roundingMode,
		        t),
		     h = _RoundDuration7.years,
		     u = _RoundDuration7.months,
		     T = _RoundDuration7.weeks,
		     f = _RoundDuration7.days,
		     y = _RoundDuration7.hours,
		     I = _RoundDuration7.minutes,
		     S = _RoundDuration7.seconds,
		     w = _RoundDuration7.milliseconds,
		     D = _RoundDuration7.microseconds,
		     G = _RoundDuration7.nanoseconds,
		     _AdjustRoundedDuratio =
		      AdjustRoundedDurationDays
		       (h,
		        u,
		        T,
		        f,
		        y,
		        I,
		        S,
		        w,
		        D,
		        G,
		        d.roundingIncrement,
		        d.smallestUnit,
		        d.roundingMode,
		        t),
		     h = _AdjustRoundedDuratio.years,
		     u = _AdjustRoundedDuratio.months,
		     T = _AdjustRoundedDuratio.weeks,
		     f = _AdjustRoundedDuratio.days,
		     y = _AdjustRoundedDuratio.hours,
		     I = _AdjustRoundedDuratio.minutes,
		     S = _AdjustRoundedDuratio.seconds,
		     w = _AdjustRoundedDuratio.milliseconds,
		     D = _AdjustRoundedDuratio.microseconds,
		     G = _AdjustRoundedDuratio.nanoseconds;
		    }
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (a * h,
		             a * u,
		             a * T,
		             a * f,
		             a * y,
		             a * I,
		             a * S,
		             a * w,
		             a * D,
		             a * G);
		   }
		   function AddISODate(e, t, r, o, n, a, i, s){
		    var
		     _BalanceISOYearMonth4,
		     _RegulateISODate,
		     _BalanceISODate3,
		     l = e,
		     d = t,
		     m = r,
		     c = a,
		     h = i;
		    return l += o,
		           d += n,
		           _BalanceISOYearMonth4 = BalanceISOYearMonth(l, d),
		           l = _BalanceISOYearMonth4.year,
		           d = _BalanceISOYearMonth4.month,
		           _RegulateISODate = RegulateISODate(l, d, m, s),
		           l = _RegulateISODate.year,
		           d = _RegulateISODate.month,
		           m = _RegulateISODate.day,
		           h += 7 * c,
		           m += h,
		           _BalanceISODate3 = BalanceISODate(l, d, m),
		           l = _BalanceISODate3.year,
		           d = _BalanceISODate3.month,
		           m = _BalanceISODate3.day,
		           {year: l, month: d, day: m};
		   }
		   function AddTime(e, t, r, o, n, a, i, s, l, d, m, c){
		    var _BalanceTime3, h = e, u = t, T = r, p = o, f = n, y = a;
		    h += i, u += s, T += l, p += d, f += m, y += c;
		    var I = 0;
		    return _BalanceTime3 = BalanceTime(h, u, T, p, f, y),
		           I = _BalanceTime3.deltaDays,
		           h = _BalanceTime3.hour,
		           u = _BalanceTime3.minute,
		           T = _BalanceTime3.second,
		           p = _BalanceTime3.millisecond,
		           f = _BalanceTime3.microsecond,
		           y = _BalanceTime3.nanosecond,
		           {deltaDays: I,
		            hour: h,
		            minute: u,
		            second: T,
		            millisecond: p,
		            microsecond: f,
		            nanosecond: y};
		   }
		   function AddDuration
		   (t, r, o, a, i, s, l, d, m, c, h, u, T, f, y, I, w, D, G, v, C){
		    var
		     O =
		       LargerOfTwoTemporalUnits
		        (DefaultTemporalLargestUnit(t, r, o, a, i, s, l, d, m, c),
		         DefaultTemporalLargestUnit(h, u, T, f, y, I, w, D, G, v)),
		     b,
		     E,
		     M,
		     R,
		     F,
		     Y,
		     P,
		     Z,
		     B,
		     N;
		    if(C)
		     if(IsTemporalDate(C)){
		      var
		       _CalendarDateUntil4,
		       _BalanceDuration6,
		       _n10 = GetIntrinsic("%Temporal.Duration%"),
		       _S2 = GetSlot(C, p),
		       _g = new _n10(t, r, o, a, 0, 0, 0, 0, 0, 0),
		       _j = new _n10(h, u, T, f, 0, 0, 0, 0, 0, 0),
		       _$ = "string" != typeof _S2 ? GetMethod(_S2, "dateAdd") : void 0,
		       _k = CalendarDateAdd(_S2, C, _g, void 0, _$),
		       _U = CalendarDateAdd(_S2, _k, _j, void 0, _$),
		       _A = LargerOfTwoTemporalUnits("day", O),
		       _L = Te(null);
		      _L.largestUnit = _A,
		      _CalendarDateUntil4 = CalendarDateUntil(_S2, C, _U, _L),
		      b = _CalendarDateUntil4.years,
		      E = _CalendarDateUntil4.months,
		      M = _CalendarDateUntil4.weeks,
		      R = _CalendarDateUntil4.days,
		      _BalanceDuration6 =
		       BalanceDuration
		        (R,
		         BigInt(i) + BigInt(y),
		         BigInt(s) + BigInt(I),
		         BigInt(l) + BigInt(w),
		         BigInt(d) + BigInt(D),
		         BigInt(m) + BigInt(G),
		         BigInt(c) + BigInt(v),
		         O),
		      R = _BalanceDuration6.days,
		      F = _BalanceDuration6.hours,
		      Y = _BalanceDuration6.minutes,
		      P = _BalanceDuration6.seconds,
		      Z = _BalanceDuration6.milliseconds,
		      B = _BalanceDuration6.microseconds,
		      N = _BalanceDuration6.nanoseconds;
		     }
		     else {
		      var
		       _DifferenceInstant3,
		       _DifferenceZonedDateT2,
		       _e29 = GetIntrinsic("%Temporal.Instant%"),
		       _j2 = GetSlot(C, g),
		       _$2 = GetSlot(C, p),
		       _k2 =
		         AddZonedDateTime
		          (GetSlot(C, S), _j2, _$2, t, r, o, a, i, s, l, d, m, c),
		       _U2 =
		         AddZonedDateTime
		          (new _e29(_k2), _j2, _$2, h, u, T, f, y, I, w, D, G, v);
		      "year" !== O && "month" !== O && "week" !== O && "day" !== O
		       ? (b
		         = 0,
		         E = 0,
		         M = 0,
		         R = 0,
		         _DifferenceInstant3 =
		          DifferenceInstant
		           (GetSlot(C, n), _U2, 1, "nanosecond", O, "halfExpand"),
		         F = _DifferenceInstant3.hours,
		         Y = _DifferenceInstant3.minutes,
		         P = _DifferenceInstant3.seconds,
		         Z = _DifferenceInstant3.milliseconds,
		         B = _DifferenceInstant3.microseconds,
		         N = _DifferenceInstant3.nanoseconds)
		       : (_DifferenceZonedDateT2
		         = DifferenceZonedDateTime(GetSlot(C, n), _U2, _j2, _$2, O, Te(null)),
		         b = _DifferenceZonedDateT2.years,
		         E = _DifferenceZonedDateT2.months,
		         M = _DifferenceZonedDateT2.weeks,
		         R = _DifferenceZonedDateT2.days,
		         F = _DifferenceZonedDateT2.hours,
		         Y = _DifferenceZonedDateT2.minutes,
		         P = _DifferenceZonedDateT2.seconds,
		         Z = _DifferenceZonedDateT2.milliseconds,
		         B = _DifferenceZonedDateT2.microseconds,
		         N = _DifferenceZonedDateT2.nanoseconds,
		         _DifferenceZonedDateT2);
		     }
		    else {
		     var _BalanceDuration7;
		     if("year" === O || "month" === O || "week" === O)
		      throw new
		             RangeError
		             ("relativeTo is required for years, months, or weeks arithmetic");
		     b = E = M = 0,
		     _BalanceDuration7 =
		      BalanceDuration
		       (a + f,
		        BigInt(i) + BigInt(y),
		        BigInt(s) + BigInt(I),
		        BigInt(l) + BigInt(w),
		        BigInt(d) + BigInt(D),
		        BigInt(m) + BigInt(G),
		        BigInt(c) + BigInt(v),
		        O),
		     R = _BalanceDuration7.days,
		     F = _BalanceDuration7.hours,
		     Y = _BalanceDuration7.minutes,
		     P = _BalanceDuration7.seconds,
		     Z = _BalanceDuration7.milliseconds,
		     B = _BalanceDuration7.microseconds,
		     N = _BalanceDuration7.nanoseconds;
		    }
		    return RejectDuration(b, E, M, R, F, Y, P, Z, B, N),
		           {years: b,
		            months: E,
		            weeks: M,
		            days: R,
		            hours: F,
		            minutes: Y,
		            seconds: P,
		            milliseconds: Z,
		            microseconds: B,
		            nanoseconds: N};
		   }
		   function AddInstant(t, r, o, n, a, i, s){
		    var l = Ie;
		    l = l + BigInt(s),
		    l = l + BigInt(i) * De,
		    l = l + BigInt(a) * Ge,
		    l = l + BigInt(n) * ve,
		    l = l + BigInt(o) * 60000000000n,
		    l = l + BigInt(r) * 3600000000000n;
		    var d = t + l;
		    return ValidateEpochNanoseconds(d), d;
		   }
		   function AddDateTime
		   (e, t, r, o, n, a, d, m, c, h, u, T, p, f, y, I, S, g, w, D, G){
		    var
		     v = f,
		     _AddTime = AddTime(o, n, a, d, m, c, y, I, S, g, w, D),
		     C = _AddTime.deltaDays,
		     O = _AddTime.hour,
		     b = _AddTime.minute,
		     E = _AddTime.second,
		     M = _AddTime.millisecond,
		     R = _AddTime.microsecond,
		     F = _AddTime.nanosecond;
		    v += C;
		    var
		     Y = GetIntrinsic("%Temporal.Duration%"),
		     P =
		       CalendarDateAdd
		        (h,
		         CreateTemporalDate(e, t, r, h),
		         new Y(u, T, p, v, 0, 0, 0, 0, 0, 0),
		         G);
		    return {year: GetSlot(P, i),
		            month: GetSlot(P, s),
		            day: GetSlot(P, l),
		            hour: O,
		            minute: b,
		            second: E,
		            millisecond: M,
		            microsecond: R,
		            nanosecond: F};
		   }
		   function AddZonedDateTime(e, t, r, o, a, p, f, y, I, S, g, w, D, G){
		    var v = GetIntrinsic("%Temporal.Duration%");
		    if(0 === DurationSign(o, a, p, f, 0, 0, 0, 0, 0, 0))
		     return AddInstant(GetSlot(e, n), y, I, S, g, w, D);
		    var
		     C = GetPlainDateTimeFor(t, e, r),
		     O =
		       CalendarDateAdd
		        (r,
		         CreateTemporalDate(GetSlot(C, i), GetSlot(C, s), GetSlot(C, l), r),
		         new v(o, a, p, f, 0, 0, 0, 0, 0, 0),
		         G),
		     b =
		       CreateTemporalDateTime
		        (GetSlot(O, i),
		         GetSlot(O, s),
		         GetSlot(O, l),
		         GetSlot(C, d),
		         GetSlot(C, m),
		         GetSlot(C, c),
		         GetSlot(C, h),
		         GetSlot(C, u),
		         GetSlot(C, T),
		         r);
		    return AddInstant
		            (GetSlot(GetInstantFor(t, b, "compatible"), n), y, I, S, g, w, D);
		   }
		   function AddDurationToOrSubtractDurationFromDuration(e, t, r, o){
		    var
		     n = "subtract" === e ? - 1 : 1,
		     _ToTemporalDurationRe2 = ToTemporalDurationRecord(r),
		     a = _ToTemporalDurationRe2.years,
		     i = _ToTemporalDurationRe2.months,
		     s = _ToTemporalDurationRe2.weeks,
		     l = _ToTemporalDurationRe2.days,
		     d = _ToTemporalDurationRe2.hours,
		     m = _ToTemporalDurationRe2.minutes,
		     c = _ToTemporalDurationRe2.seconds,
		     h = _ToTemporalDurationRe2.milliseconds,
		     u = _ToTemporalDurationRe2.microseconds,
		     T = _ToTemporalDurationRe2.nanoseconds,
		     p = ToRelativeTemporalObject(GetOptionsObject(o)),
		     _AddDuration =
		       AddDuration
		        (GetSlot(t, w),
		         GetSlot(t, D),
		         GetSlot(t, G),
		         GetSlot(t, v),
		         GetSlot(t, C),
		         GetSlot(t, O),
		         GetSlot(t, b),
		         GetSlot(t, E),
		         GetSlot(t, M),
		         GetSlot(t, R),
		         n * a,
		         n * i,
		         n * s,
		         n * l,
		         n * d,
		         n * m,
		         n * c,
		         n * h,
		         n * u,
		         n * T,
		         p);
		    a = _AddDuration.years;
		    i = _AddDuration.months;
		    s = _AddDuration.weeks;
		    l = _AddDuration.days;
		    d = _AddDuration.hours;
		    m = _AddDuration.minutes;
		    c = _AddDuration.seconds;
		    h = _AddDuration.milliseconds;
		    u = _AddDuration.microseconds;
		    T = _AddDuration.nanoseconds;
		    return new
		            (GetIntrinsic("%Temporal.Duration%"))
		            (a, i, s, l, d, m, c, h, u, T);
		   }
		   function AddDurationToOrSubtractDurationFromInstant(e, t, r){
		    var
		     o = "subtract" === e ? - 1 : 1,
		     _ToLimitedTemporalDur =
		       function(e, t){
		         var
		          r = ToTemporalDurationRecord(e),
		          _iterator14 = _createForOfIteratorHelper(t),
		          _step14;
		         try{
		          for(_iterator14.s(); ! (_step14 = _iterator14.n()).done;){
		           var _e30 = _step14.value;
		           if(0 !== r[_e30])
		            throw new
		                   RangeError
		                   ("Duration field ".concat
		                     (_e30,
		                      " not supported by Temporal.Instant. Try Temporal.ZonedDateTime instead."));
		          }
		         }
		         catch(err){_iterator14.e(err);}
		         finally{_iterator14.f();}
		         return r;
		        }
		        (r, ["years", "months", "weeks", "days"]),
		     a = _ToLimitedTemporalDur.hours,
		     i = _ToLimitedTemporalDur.minutes,
		     s = _ToLimitedTemporalDur.seconds,
		     l = _ToLimitedTemporalDur.milliseconds,
		     d = _ToLimitedTemporalDur.microseconds,
		     m = _ToLimitedTemporalDur.nanoseconds,
		     c = AddInstant(GetSlot(t, n), o * a, o * i, o * s, o * l, o * d, o * m);
		    return new (GetIntrinsic("%Temporal.Instant%"))(c);
		   }
		   function AddDurationToOrSubtractDurationFromPlainDateTime(e, t, r, o){
		    var
		     n = "subtract" === e ? - 1 : 1,
		     _ToTemporalDurationRe3 = ToTemporalDurationRecord(r),
		     a = _ToTemporalDurationRe3.years,
		     f = _ToTemporalDurationRe3.months,
		     y = _ToTemporalDurationRe3.weeks,
		     I = _ToTemporalDurationRe3.days,
		     S = _ToTemporalDurationRe3.hours,
		     g = _ToTemporalDurationRe3.minutes,
		     w = _ToTemporalDurationRe3.seconds,
		     D = _ToTemporalDurationRe3.milliseconds,
		     G = _ToTemporalDurationRe3.microseconds,
		     v = _ToTemporalDurationRe3.nanoseconds,
		     C = GetOptionsObject(o),
		     O = GetSlot(t, p),
		     _AddDateTime =
		       AddDateTime
		        (GetSlot(t, i),
		         GetSlot(t, s),
		         GetSlot(t, l),
		         GetSlot(t, d),
		         GetSlot(t, m),
		         GetSlot(t, c),
		         GetSlot(t, h),
		         GetSlot(t, u),
		         GetSlot(t, T),
		         O,
		         n * a,
		         n * f,
		         n * y,
		         n * I,
		         n * S,
		         n * g,
		         n * w,
		         n * D,
		         n * G,
		         n * v,
		         C),
		     b = _AddDateTime.year,
		     E = _AddDateTime.month,
		     M = _AddDateTime.day,
		     R = _AddDateTime.hour,
		     F = _AddDateTime.minute,
		     Y = _AddDateTime.second,
		     P = _AddDateTime.millisecond,
		     Z = _AddDateTime.microsecond,
		     B = _AddDateTime.nanosecond;
		    return CreateTemporalDateTime(b, E, M, R, F, Y, P, Z, B, O);
		   }
		   function AddDurationToOrSubtractDurationFromPlainTime(e, t, r){
		    var
		     o = "subtract" === e ? - 1 : 1,
		     _ToTemporalDurationRe4 = ToTemporalDurationRecord(r),
		     n = _ToTemporalDurationRe4.hours,
		     a = _ToTemporalDurationRe4.minutes,
		     i = _ToTemporalDurationRe4.seconds,
		     s = _ToTemporalDurationRe4.milliseconds,
		     l = _ToTemporalDurationRe4.microseconds,
		     p = _ToTemporalDurationRe4.nanoseconds,
		     _AddTime2 =
		       AddTime
		        (GetSlot(t, d),
		         GetSlot(t, m),
		         GetSlot(t, c),
		         GetSlot(t, h),
		         GetSlot(t, u),
		         GetSlot(t, T),
		         o * n,
		         o * a,
		         o * i,
		         o * s,
		         o * l,
		         o * p),
		     f = _AddTime2.hour,
		     y = _AddTime2.minute,
		     I = _AddTime2.second,
		     S = _AddTime2.millisecond,
		     g = _AddTime2.microsecond,
		     w = _AddTime2.nanosecond,
		     _RegulateTime3 = RegulateTime(f, y, I, S, g, w, "reject");
		    f = _RegulateTime3.hour;
		    y = _RegulateTime3.minute;
		    I = _RegulateTime3.second;
		    S = _RegulateTime3.millisecond;
		    g = _RegulateTime3.microsecond;
		    w = _RegulateTime3.nanosecond;
		    return new (GetIntrinsic("%Temporal.PlainTime%"))(f, y, I, S, g, w);
		   }
		   function AddDurationToOrSubtractDurationFromPlainYearMonth(e, t, r, o){
		    var n = ToTemporalDurationRecord(r);
		    "subtract" === e
		    &&
		     (n =
		      {years: - n.years,
		       months: - n.months,
		       weeks: - n.weeks,
		       days: - n.days,
		       hours: - n.hours,
		       minutes: - n.minutes,
		       seconds: - n.seconds,
		       milliseconds: - n.milliseconds,
		       microseconds: - n.microseconds,
		       nanoseconds: - n.nanoseconds});
		    var
		     _n11 = n,
		     a = _n11.years,
		     i = _n11.months,
		     s = _n11.weeks,
		     l = _n11.days,
		     d = _n11.hours,
		     m = _n11.minutes,
		     c = _n11.seconds,
		     h = _n11.milliseconds,
		     u = _n11.microseconds,
		     T = _n11.nanoseconds,
		     _BalanceDuration8 = BalanceDuration(l, d, m, c, h, u, T, "day");
		    l = _BalanceDuration8.days;
		    var
		     f = GetOptionsObject(o),
		     y = GetSlot(t, p),
		     I = CalendarFields(y, ["monthCode", "year"]),
		     S = PrepareTemporalFields(t, I, []),
		     g = Te(null);
		    CopyDataProperties(g, S, []), S.day = 1;
		    var
		     w = CalendarDateFromFields(y, S),
		     D = DurationSign(a, i, s, l, 0, 0, 0, 0, 0, 0),
		     G = GetMethod(y, "dateAdd"),
		     v = GetIntrinsic("%Temporal.Duration%");
		    if(D < 0){
		     var
		      _e31 =
		        CalendarDateAdd(y, w, new v(0, 1, 0, 0, 0, 0, 0, 0, 0, 0), void 0, G),
		      _t30 =
		        CalendarDateAdd
		         (y, _e31, new v(0, 0, 0, - 1, 0, 0, 0, 0, 0, 0), void 0, G);
		     g.day = CalendarDay(y, _t30), w = CalendarDateFromFields(y, g);
		    }
		    var C = new v(a, i, s, l, 0, 0, 0, 0, 0, 0), O = CopyOptions(f);
		    return CalendarYearMonthFromFields
		            (y,
		             PrepareTemporalFields(CalendarDateAdd(y, w, C, f, G), I, []),
		             O);
		   }
		   function AddDurationToOrSubtractDurationFromZonedDateTime(e, t, r, o){
		    var
		     n = "subtract" === e ? - 1 : 1,
		     _ToTemporalDurationRe5 = ToTemporalDurationRecord(r),
		     a = _ToTemporalDurationRe5.years,
		     i = _ToTemporalDurationRe5.months,
		     s = _ToTemporalDurationRe5.weeks,
		     l = _ToTemporalDurationRe5.days,
		     d = _ToTemporalDurationRe5.hours,
		     m = _ToTemporalDurationRe5.minutes,
		     c = _ToTemporalDurationRe5.seconds,
		     h = _ToTemporalDurationRe5.milliseconds,
		     u = _ToTemporalDurationRe5.microseconds,
		     T = _ToTemporalDurationRe5.nanoseconds,
		     f = GetOptionsObject(o),
		     y = GetSlot(t, g),
		     I = GetSlot(t, p);
		    return CreateTemporalZonedDateTime
		            (AddZonedDateTime
		              (GetSlot(t, S),
		               y,
		               I,
		               n * a,
		               n * i,
		               n * s,
		               n * l,
		               n * d,
		               n * m,
		               n * c,
		               n * h,
		               n * u,
		               n * T,
		               f),
		             y,
		             I);
		   }
		   function RoundNumberToIncrement(t, r, o){
		    if(r === Se) return t;
		    var
		     _divmod21 = divmod(t, r),
		     n = _divmod21.quotient,
		     a = _divmod21.remainder;
		    if(a === Ie) return t;
		    var i = a < Ie ? - 1 : 1, s = abs(a * 2n), l = s === r, d = s > r;
		    switch(o){
		      case "ceil":
		       i > 0 && (n = n + BigInt(i)); break;
		      case "floor":
		       i < 0 && (n = n + BigInt(i)); break;
		      case "expand":
		       n = n + BigInt(i); break;
		      case "trunc": break;
		      case "halfCeil":
		       (d || l && i > 0) && (n = n + BigInt(i)); break;
		      case "halfFloor":
		       (d || l && i < 0) && (n = n + BigInt(i)); break;
		      case "halfExpand":
		       (d || l) && (n = n + BigInt(i)); break;
		      case "halfTrunc":
		       d && (n = n + BigInt(i)); break;
		      case "halfEven":
		       (d || l && 1 === Number(abs(n) % 2n)) && (n = n + BigInt(i));
		    }
		    return n * r;
		   }
		   function RoundInstant(t, r, o, n){
		    var
		     _NonNegativeBigIntDiv7 = NonNegativeBigIntDivmod(t, Ee),
		     a = _NonNegativeBigIntDiv7.remainder,
		     i = t - a,
		     s = RoundNumberToIncrement(a, BigInt(_e[o] * r), n);
		    return i + s;
		   }
		   function RoundISODateTime(e, t, r, o, n, a, i, s, l, d, m, c){
		    var
		     h =
		       arguments.length > 12 && arguments[12] !== undefined
		        ? arguments[12]
		        : 864e11,
		     _RoundTime = RoundTime(o, n, a, i, s, l, d, m, c, h),
		     u = _RoundTime.deltaDays,
		     T = _RoundTime.hour,
		     p = _RoundTime.minute,
		     f = _RoundTime.second,
		     y = _RoundTime.millisecond,
		     I = _RoundTime.microsecond,
		     S = _RoundTime.nanosecond,
		     _BalanceISODate4 = BalanceISODate(e, t, r + u),
		     g = _BalanceISODate4.year,
		     w = _BalanceISODate4.month,
		     D = _BalanceISODate4.day;
		    return {year: g,
		            month: w,
		            day: D,
		            hour: T,
		            minute: p,
		            second: f,
		            millisecond: y,
		            microsecond: I,
		            nanosecond: S};
		   }
		   function RoundTime(t, r, o, n, a, i, s, l, d){
		    var
		     m =
		       arguments.length > 9 && arguments[9] !== undefined
		        ? arguments[9]
		        : 864e11,
		     c = Ie;
		    switch(l){
		      case "day":
		      case "hour":
		       c = BigInt(t);
		      case "minute":
		       c = c * ge + BigInt(r);
		      case "second":
		       c = c * ge + BigInt(o);
		      case "millisecond":
		       c = c * De + BigInt(n);
		      case "microsecond":
		       c = c * De + BigInt(a);
		      case "nanosecond":
		       c = c * De + BigInt(i);
		    }
		    var
		     h = "day" === l ? m : _e[l],
		     u = RoundNumberToIncrement(c, BigInt(h * s), d),
		     T = Number(u / BigInt(h));
		    switch(l){
		      case "day":
		       return {deltaDays: T,
		               hour: 0,
		               minute: 0,
		               second: 0,
		               millisecond: 0,
		               microsecond: 0,
		               nanosecond: 0};
		      case "hour":
		       return BalanceTime(T, 0, 0, 0, 0, 0);
		      case "minute":
		       return BalanceTime(t, T, 0, 0, 0, 0);
		      case "second":
		       return BalanceTime(t, r, T, 0, 0, 0);
		      case "millisecond":
		       return BalanceTime(t, r, o, T, 0, 0);
		      case "microsecond":
		       return BalanceTime(t, r, o, n, T, 0);
		      case "nanosecond":
		       return BalanceTime(t, r, o, n, a, T);
		      default: throw new Error("Invalid unit ".concat(l));
		    }
		   }
		   function DaysUntil(e, t){
		    return DifferenceISODate
		            (GetSlot(e, i),
		             GetSlot(e, s),
		             GetSlot(e, l),
		             GetSlot(t, i),
		             GetSlot(t, s),
		             GetSlot(t, l),
		             "day").days;
		   }
		   function MoveRelativeDate(e, t, r, o){
		    var n = CalendarDateAdd(e, t, r, void 0, o);
		    return {relativeTo: n, days: DaysUntil(t, n)};
		   }
		   function MoveRelativeZonedDateTime(e, t, r, o, n){
		    var a = GetSlot(e, g), i = GetSlot(e, p);
		    return CreateTemporalZonedDateTime
		            (AddZonedDateTime
		              (GetSlot(e, S), a, i, t, r, o, n, 0, 0, 0, 0, 0, 0),
		             a,
		             i);
		   }
		   function AdjustRoundedDurationDays
		   (t, r, o, n, a, i, s, l, d, m, c, h, u, T){
		    var
		     _AddDuration2,
		     _BalanceDuration9,
		     f = t,
		     y = r,
		     I = o,
		     w = n,
		     D = a,
		     G = i,
		     v = s,
		     C = l,
		     O = d,
		     b = m;
		    if
		     (! IsTemporalZonedDateTime(T) || "year" === h || "month" === h
		      || "week" === h
		      || "day" === h
		      || "nanosecond" === h && 1 === c)
		     return {years: f,
		             months: y,
		             weeks: I,
		             days: w,
		             hours: D,
		             minutes: G,
		             seconds: v,
		             milliseconds: C,
		             microseconds: O,
		             nanoseconds: b};
		    var
		     E = TotalDurationNanoseconds(0, D, G, v, C, O, b, 0),
		     M = se(Number(E)),
		     R = GetSlot(T, g),
		     F = GetSlot(T, p),
		     Y = AddZonedDateTime(GetSlot(T, S), R, F, f, y, I, w, 0, 0, 0, 0, 0, 0),
		     P =
		       AddZonedDateTime
		        (new (GetIntrinsic("%Temporal.Instant%"))(Y),
		         R,
		         F,
		         0,
		         0,
		         0,
		         M,
		         0,
		         0,
		         0,
		         0,
		         0,
		         0),
		     Z = P - Y;
		    return (E - Z) * BigInt(M) >= Ie
		           &&
		            (_AddDuration2 =
		              AddDuration
		               (f, y, I, w, 0, 0, 0, 0, 0, 0, 0, 0, 0, M, 0, 0, 0, 0, 0, 0, T),
		             f = _AddDuration2.years,
		             y = _AddDuration2.months,
		             I = _AddDuration2.weeks,
		             w = _AddDuration2.days,
		             E = RoundInstant(E - Z, c, h, u),
		             _BalanceDuration9 =
		              BalanceDuration(0, 0, 0, 0, 0, 0, Number(E), "hour"),
		             D = _BalanceDuration9.hours,
		             G = _BalanceDuration9.minutes,
		             v = _BalanceDuration9.seconds,
		             C = _BalanceDuration9.milliseconds,
		             O = _BalanceDuration9.microseconds,
		             b = _BalanceDuration9.nanoseconds),
		           {years: f,
		            months: y,
		            weeks: I,
		            days: w,
		            hours: D,
		            minutes: G,
		            seconds: v,
		            milliseconds: C,
		            microseconds: O,
		            nanoseconds: b};
		   }
		   function RoundDuration(t, r, o, n, a, i, s, l, d, m, c, h, u, T){
		    var
		     f = t,
		     y = r,
		     I = o,
		     S = n,
		     g = a,
		     w = i,
		     D = s,
		     G = l,
		     v = d,
		     C = BigInt(m),
		     O = GetIntrinsic("%Temporal.Duration%"),
		     b,
		     E,
		     M,
		     R,
		     F = T;
		    if(F){
		     if(IsTemporalZonedDateTime(F))
		      E = F, F = ToTemporalDate(F);
		     else if(! IsTemporalDate(F))
		      throw new TypeError("starting point must be PlainDate or ZonedDateTime");
		     b = GetSlot(F, p);
		    }
		    if("year" === h || "month" === h || "week" === h || "day" === h){
		     var _NanosecondsToDays3, _t31, _r45, _o15;
		     C = TotalDurationNanoseconds(0, g, w, D, G, v, m, 0),
		     E && (_t31 = MoveRelativeZonedDateTime(E, f, y, I, S)),
		     _NanosecondsToDays3 = NanosecondsToDays(C, _t31),
		     _r45 = _NanosecondsToDays3.days,
		     C = _NanosecondsToDays3.nanoseconds,
		     _o15 = _NanosecondsToDays3.dayLengthNs,
		     M = BigInt(_o15),
		     S += _r45,
		     g = w = D = G = v = 0;
		    }
		    switch(h){
		      case "year":
		       {
		        if(! b)
		         throw new
		                RangeError
		                ("A starting point is required for years rounding");
		        var
		         _t32 = new O(f),
		         _r46 = "string" != typeof b ? GetMethod(b, "dateAdd") : void 0,
		         _o16 = CalendarDateAdd(b, F, _t32, void 0, _r46),
		         _n12 = CalendarDateAdd(b, F, new O(f, y, I), void 0, _r46);
		        F = _o16, S += DaysUntil(_o16, _n12);
		        var
		         _a8 = CalendarDateAdd(b, F, new O(0, 0, 0, S), void 0, _r46),
		         _i12 = Te(null);
		        _i12.largestUnit = "year";
		        var _s4 = CalendarDateUntil(b, F, _a8, _i12).years;
		        f += _s4;
		        var _l5 = F;
		        F = CalendarDateAdd(b, F, new O(_s4), void 0, _r46);
		        S -= DaysUntil(_l5, F);
		        var
		         _d5 = new O(S < 0 ? - 1 : 1),
		         _MoveRelativeDate6 = MoveRelativeDate(b, F, _d5, _r46),
		         _m5 = _MoveRelativeDate6.days;
		        _m5 = ae(_m5);
		        var _h2 = BigInt(_m5) * M;
		        C = _h2 * BigInt(f) + BigInt(S) * M + C;
		        var _T2 = RoundNumberToIncrement(C, _h2 * BigInt(c), u);
		        R = BigIntDivideToNumber(C, _h2),
		        f = Number(_T2 / _h2),
		        C = Ie,
		        y = I = S = 0;
		        break;
		       }
		      case "month":
		       {
		        if(! b)
		         throw new
		                RangeError
		                ("A starting point is required for months rounding");
		        var
		         _t33 = new O(f, y),
		         _r47 = "string" != typeof b ? GetMethod(b, "dateAdd") : void 0,
		         _o17 = CalendarDateAdd(b, F, _t33, void 0, _r47),
		         _n13 = CalendarDateAdd(b, F, new O(f, y, I), void 0, _r47);
		        F = _o17, S += DaysUntil(_o17, _n13);
		        var _a9 = se(S), _i13 = new O(0, S < 0 ? - 1 : 1), _s5;
		        for
		        (_MoveRelativeDate7 = MoveRelativeDate(b, F, _i13, _r47),
		         F = _MoveRelativeDate7.relativeTo,
		         _s5 = _MoveRelativeDate7.days,
		         _MoveRelativeDate7;
		         ae(S) >= ae(_s5);){
		         var _MoveRelativeDate7, _MoveRelativeDate8;
		         y += _a9,
		         S -= _s5,
		         _MoveRelativeDate8 = MoveRelativeDate(b, F, _i13, _r47),
		         F = _MoveRelativeDate8.relativeTo,
		         _s5 = _MoveRelativeDate8.days;
		        }
		        _s5 = ae(_s5);
		        var _l6 = BigInt(_s5) * M;
		        C = _l6 * BigInt(y) + BigInt(S) * M + C;
		        var _d6 = RoundNumberToIncrement(C, _l6 * BigInt(c), u);
		        R = BigIntDivideToNumber(C, _l6),
		        y = Number(_d6 / _l6),
		        C = Ie,
		        I = S = 0;
		        break;
		       }
		      case "week":
		       {
		        if(! b)
		         throw new
		                RangeError
		                ("A starting point is required for weeks rounding");
		        var
		         _t34 = se(S),
		         _r48 = new O(0, 0, S < 0 ? - 1 : 1),
		         _o18 = "string" != typeof b ? GetMethod(b, "dateAdd") : void 0,
		         _n14;
		        for
		        (_MoveRelativeDate9 = MoveRelativeDate(b, F, _r48, _o18),
		         F = _MoveRelativeDate9.relativeTo,
		         _n14 = _MoveRelativeDate9.days,
		         _MoveRelativeDate9;
		         ae(S) >= ae(_n14);){
		         var _MoveRelativeDate9, _MoveRelativeDate10;
		         I += _t34,
		         S -= _n14,
		         _MoveRelativeDate10 = MoveRelativeDate(b, F, _r48, _o18),
		         F = _MoveRelativeDate10.relativeTo,
		         _n14 = _MoveRelativeDate10.days;
		        }
		        _n14 = ae(_n14);
		        var _a10 = BigInt(_n14) * M;
		        C = _a10 * BigInt(I) + BigInt(S) * M + C;
		        var _i14 = RoundNumberToIncrement(C, _a10 * BigInt(c), u);
		        R = BigIntDivideToNumber(C, _a10),
		        I = Number(_i14 / _a10),
		        C = Ie,
		        S = 0;
		        break;
		       }
		      case "day":
		       {
		        var _t35 = M;
		        C = _t35 * BigInt(S) + C;
		        var _r49 = RoundNumberToIncrement(C, _t35 * BigInt(c), u);
		        R = BigIntDivideToNumber(C, _t35), S = Number(_r49 / _t35), C = Ie;
		        break;
		       }
		      case "hour":
		       {
		        var _t36 = 36e11, _r50 = BigInt(g) * 3600000000000n;
		        _r50 = _r50 + BigInt(w) * 60000000000n,
		        _r50 = _r50 + BigInt(D) * ve,
		        _r50 = _r50 + BigInt(G) * Ge,
		        _r50 = _r50 + BigInt(v) * De,
		        _r50 = _r50 + C,
		        R = BigIntDivideToNumber(_r50, BigInt(_t36));
		        var _o19 = RoundNumberToIncrement(_r50, BigInt(_t36 * c), u);
		        g = Number(_o19 / BigInt(_t36)), C = Ie, w = D = G = v = 0;
		        break;
		       }
		      case "minute":
		       {
		        var _t37 = 6e10, _r51 = BigInt(w) * 60000000000n;
		        _r51 = _r51 + BigInt(D) * ve,
		        _r51 = _r51 + BigInt(G) * Ge,
		        _r51 = _r51 + BigInt(v) * De,
		        _r51 = _r51 + C,
		        R = BigIntDivideToNumber(_r51, BigInt(_t37));
		        var _o20 = RoundNumberToIncrement(_r51, BigInt(_t37 * c), u);
		        w = Number(_o20 / BigInt(_t37)), C = Ie, D = G = v = 0;
		        break;
		       }
		      case "second":
		       {
		        var _t38 = 1e9, _r52 = BigInt(D) * ve;
		        _r52 = _r52 + BigInt(G) * Ge,
		        _r52 = _r52 + BigInt(v) * De,
		        _r52 = _r52 + C,
		        R = BigIntDivideToNumber(_r52, BigInt(_t38));
		        var _o21 = RoundNumberToIncrement(_r52, BigInt(_t38 * c), u);
		        D = Number(_o21 / BigInt(_t38)), C = Ie, G = v = 0;
		        break;
		       }
		      case "millisecond":
		       {
		        var _t39 = 1e6, _r53 = BigInt(G) * Ge;
		        _r53 = _r53 + BigInt(v) * De,
		        _r53 = _r53 + C,
		        R = BigIntDivideToNumber(_r53, BigInt(_t39));
		        var _o22 = RoundNumberToIncrement(_r53, BigInt(_t39 * c), u);
		        G = Number(_o22 / BigInt(_t39)), C = Ie, v = 0;
		        break;
		       }
		      case "microsecond":
		       {
		        var _t40 = 1e3, _r54 = BigInt(v) * De;
		        _r54 = _r54 + C, R = BigIntDivideToNumber(_r54, BigInt(_t40));
		        var _o23 = RoundNumberToIncrement(_r54, BigInt(_t40 * c), u);
		        v = Number(_o23 / BigInt(_t40)), C = Ie;
		        break;
		       }
		      case "nanosecond":
		       R = Number(C), C = RoundNumberToIncrement(BigInt(C), BigInt(c), u);
		    }
		    return {years: f,
		            months: y,
		            weeks: I,
		            days: S,
		            hours: g,
		            minutes: w,
		            seconds: D,
		            milliseconds: G,
		            microseconds: v,
		            nanoseconds: Number(C),
		            total: R};
		   }
		   function CompareISODate(e, t, r, o, n, a){
		    for
		    (var _i15 = 0, _arr5 = [[e, o], [t, n], [r, a]];
		     _i15 < _arr5.length;
		     _i15++){
		     var
		      _arr5$_i = _slicedToArray(_arr5[_i15], 2),
		      _i16 = _arr5$_i[0],
		      _s6 = _arr5$_i[1];
		     if(_i16 !== _s6) return ComparisonResult(_i16 - _s6);
		    }
		    return 0;
		   }
		   function NonNegativeBigIntDivmod(t, r){
		    var
		     _divmod22 = divmod(t, r),
		     o = _divmod22.quotient,
		     n = _divmod22.remainder;
		    return n < Ie && (o = o - Se, n = n + r), {quotient: o, remainder: n};
		   }
		   function BigIntFloorDiv(t, r){
		    var
		     _divmod23 = divmod(t, r),
		     o = _divmod23.quotient,
		     n = _divmod23.remainder;
		    return isZero(n) || ! isNegativeJSBI(t) == ! isNegativeJSBI(r)
		            ? o
		            : o - Se;
		   }
		   function BigIntDivideToNumber(t, r){
		    var
		     _divmod24 = divmod(t, r),
		     o = _divmod24.quotient,
		     n = _divmod24.remainder;
		    return Number(o) + Number(n) / Number(r);
		   }
		   function ToBigIntExternal(e){
		    var t = ToBigInt(e);
		    return void 0 !== globalThis.BigInt
		            ? globalThis.BigInt(t.toString(10))
		            : t;
		   }
		   function ToBigInt(t){
		    var r = t;
		    if("object" == _typeof(t)){
		     var _e32 = t[Symbol.toPrimitive];
		     _e32 && "function" == typeof _e32 && (r = fe(_e32, t, ["number"]));
		    }
		    if("number" == typeof r)
		     throw new TypeError("cannot convert number to bigint");
		    return "bigint" == typeof r ? BigInt(r.toString(10)) : BigInt(r);
		   }
		   var
		    Ve =
		      function(){
		        var t = BigInt(Date.now() % 1e6);
		        return function(){
		         var r = BigInt(Date.now()), o = r * Ge + t;
		         return t = r % Ge, o > Re ? Re : o < Me ? Me : o;};
		       }
		       ();
		   function DefaultTimeZone(){return new re().resolvedOptions().timeZone;}
		   function ComparisonResult(e){return e < 0 ? - 1 : e > 0 ? 1 : e;}
		   function GetOptionsObject(e){
		    if(void 0 === e) return Te(null);
		    if(IsObject(e) && null !== e) return e;
		    throw new
		           TypeError
		           ("Options parameter must be an object, not "
		            + (null === e ? "null" : "" + _typeof(e)));
		   }
		   function CreateOnePropObject(e, t){var r = Te(null); return r[e] = t, r;}
		   function CopyOptions(e){
		    var t = Te(null);
		    return CopyDataProperties(t, GetOptionsObject(e), []), t;
		   }
		   function GetOption(e, t, r, o){
		    var n = e[t];
		    if(void 0 !== n){
		     if(n = ToString(n), ! r.includes(n))
		      throw new
		             RangeError
		             ("".concat(t, " must be one of ").concat(r.join(", "), ", not ").concat
		               (n));
		     return n;
		    }
		    return o;
		   }
		   function IsBuiltinCalendar(e){return je.includes(ASCIILowercase(e));}
		   function ASCIILowercase(e){
		    return e.replace
		            (/[A-Z]/g,
		             function(e){
		              var t = e.charCodeAt(0);
		              return String.fromCharCode(t + 32);
		             });
		   }
		   var ze = new RegExp("^".concat(W.source, "$"));
		   function bisect(t, r, o){
		    var
		     n =
		       arguments.length > 3 && arguments[3] !== undefined
		        ? arguments[3]
		        : t(r),
		     a =
		       arguments.length > 4 && arguments[4] !== undefined
		        ? arguments[4]
		        : t(o),
		     i = BigInt(r),
		     s = BigInt(o),
		     l = n,
		     d = a;
		    for(; s - i > Se;){
		     var _r55 = (i + s) / 2n, _o24 = t(_r55);
		     if(_o24 === l)
		      i = _r55, l = _o24;
		     else {
		      if(_o24 !== d)
		       throw new
		              Error
		              ("invalid state in bisection ".concat(l, " - ").concat
		                 (_o24, " - ").concat
		                (d));
		      s = _r55, d = _o24;
		     }
		    }
		    return s;
		   }
		   var
		    _e =
		      {hour: 36e11,
		       minute: 6e10,
		       second: 1e9,
		       millisecond: 1e6,
		       microsecond: 1e3,
		       nanosecond: 1},
		    Je = Symbol("date"),
		    Ke = Symbol("ym"),
		    Xe = Symbol("md"),
		    Qe = Symbol("time"),
		    et = Symbol("datetime"),
		    tt = Symbol("instant"),
		    rt = Symbol("original"),
		    ot = Symbol("timezone"),
		    nt = Symbol("calendar-id"),
		    at = Symbol("locale"),
		    it = Symbol("options"),
		    descriptor =
		      function(e){
		       return {value: e, enumerable: ! 0, writable: ! 1, configurable: ! 0};
		      },
		    st = globalThis.Intl.DateTimeFormat,
		    lt = Object.assign,
		    dt = Object.prototype.hasOwnProperty,
		    mt = Reflect.apply;
		   function getPropLazy(e, t){
		    var r = e[t];
		    return "function" == typeof r && (r = new st(e[at], r(e[it])), e[t] = r),
		           r;
		   }
		   function DateTimeFormatImpl(e){
		    var
		     t =
		       arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		    if(! (this instanceof DateTimeFormatImpl))
		     return new DateTimeFormatImpl(e, t);
		    var
		     r = void 0 !== t,
		     o = r ? lt({}, t) : {},
		     n = new st(e, o),
		     a = n.resolvedOptions();
		    if(r){
		     var _e33 = lt({}, a);
		     for(var _t41 in _e33) mt(dt, o, [_t41]) || delete _e33[_t41];
		     this[it] = _e33;
		    }
		    else
		     this[it] = o;
		    this[at] = a.locale,
		    this[rt] = n,
		    this[ot] = a.timeZone,
		    this[nt] = a.calendar,
		    this[Je] = dateAmend,
		    this[Ke] = yearMonthAmend,
		    this[Xe] = monthDayAmend,
		    this[Qe] = timeAmend,
		    this[et] = datetimeAmend,
		    this[tt] = instantAmend;
		   }
		   Object.defineProperty
		    (DateTimeFormatImpl, "name", {writable: ! 0, value: "DateTimeFormat"}),
		   DateTimeFormatImpl.supportedLocalesOf =
		    function(e, t){return st.supportedLocalesOf(e, t);};
		   var
		    ct =
		      {resolvedOptions:
		       descriptor(function(){return this[rt].resolvedOptions();}),
		       format:
		       descriptor
		        (function(e){
		          var
		           _this$rt,
		           _extractOverrides = extractOverrides(e, this),
		           r = _extractOverrides.instant,
		           o = _extractOverrides.formatter;
		          if(r && o) return o.format(r.epochMilliseconds);
		          for
		          (var
		            _len2 = arguments.length,
		            t = new Array(_len2 > 1 ? _len2 - 1 : 0),
		            _key2 = 1;
		           _key2 < _len2;
		           _key2++)
		           t[_key2 - 1] = arguments[_key2];
		          return (_this$rt = this[rt]).format.apply(_this$rt, [e].concat(t));
		         }),
		       formatRange:
		       descriptor
		        (function(e, t){
		          if(isTemporalObject(e) || isTemporalObject(t)){
		           if(! sameTemporalType(e, t))
		            throw new
		                   TypeError
		                   ("Intl.DateTimeFormat.formatRange accepts two values of the same type");
		           var
		            _extractOverrides2 = extractOverrides(e, this),
		            _r56 = _extractOverrides2.instant,
		            _o25 = _extractOverrides2.formatter,
		            _extractOverrides3 = extractOverrides(t, this),
		            _n15 = _extractOverrides3.instant,
		            _a11 = _extractOverrides3.formatter;
		           if(_r56 && _n15 && _o25 && _a11 && _o25 === _a11)
		            return _o25.formatRange
		                    (_r56.epochMilliseconds, _n15.epochMilliseconds);
		          }
		          return this[rt].formatRange(e, t);
		         })};
		   "formatToParts" in st.prototype
		   &&
		    (ct.formatToParts =
		     descriptor
		      (function(e){
		        var
		         _this$rt2,
		         _extractOverrides4 = extractOverrides(e, this),
		         r = _extractOverrides4.instant,
		         o = _extractOverrides4.formatter;
		        if(r && o) return o.formatToParts(r.epochMilliseconds);
		        for
		        (var
		          _len3 = arguments.length,
		          t = new Array(_len3 > 1 ? _len3 - 1 : 0),
		          _key3 = 1;
		         _key3 < _len3;
		         _key3++)
		         t[_key3 - 1] = arguments[_key3];
		        return (_this$rt2 = this[rt]).formatToParts.apply
		                (_this$rt2, [e].concat(t));
		       })),
		   "formatRangeToParts" in st.prototype
		   &&
		    (ct.formatRangeToParts =
		     descriptor
		      (function(e, t){
		        if(isTemporalObject(e) || isTemporalObject(t)){
		         if(! sameTemporalType(e, t))
		          throw new
		                 TypeError
		                 ("Intl.DateTimeFormat.formatRangeToParts accepts two values of the same type");
		         var
		          _extractOverrides5 = extractOverrides(e, this),
		          _r57 = _extractOverrides5.instant,
		          _o26 = _extractOverrides5.formatter,
		          _extractOverrides6 = extractOverrides(t, this),
		          _n16 = _extractOverrides6.instant,
		          _a12 = _extractOverrides6.formatter;
		         if(_r57 && _n16 && _o26 && _a12 && _o26 === _a12)
		          return _o26.formatRangeToParts
		                  (_r57.epochMilliseconds, _n16.epochMilliseconds);
		        }
		        return this[rt].formatRangeToParts(e, t);
		       })),
		   DateTimeFormatImpl.prototype = Object.create(st.prototype, ct),
		   Object.defineProperty
		    (DateTimeFormatImpl,
		     "prototype",
		     {writable: ! 1, enumerable: ! 1, configurable: ! 1});
		   var ht = DateTimeFormatImpl;
		   function amend(){
		    var
		     e =
		       arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		     t =
		       arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		     r = lt({}, e);
		    for
		    (var
		      _i17 = 0,
		      _arr6 =
		        ["year",
		         "month",
		         "day",
		         "hour",
		         "minute",
		         "second",
		         "weekday",
		         "dayPeriod",
		         "timeZoneName",
		         "dateStyle",
		         "timeStyle"];
		     _i17 < _arr6.length;
		     _i17++){
		     var _e34 = _arr6[_i17];
		     r[_e34] = _e34 in t ? t[_e34] : r[_e34],
		     ! 1 !== r[_e34] && void 0 !== r[_e34] || delete r[_e34];
		    }
		    return r;
		   }
		   function timeAmend(e){
		    var
		     t =
		       amend
		        (e,
		         {year: ! 1,
		          month: ! 1,
		          day: ! 1,
		          weekday: ! 1,
		          timeZoneName: ! 1,
		          dateStyle: ! 1});
		    return hasTimeOptions(t)
		           ||
		            (t =
		             lt
		              ({}, t, {hour: "numeric", minute: "numeric", second: "numeric"})),
		           t;
		   }
		   function yearMonthAmend(e){
		    var
		     t =
		       amend
		        (e,
		         {day: ! 1,
		          hour: ! 1,
		          minute: ! 1,
		          second: ! 1,
		          weekday: ! 1,
		          dayPeriod: ! 1,
		          timeZoneName: ! 1,
		          dateStyle: ! 1,
		          timeStyle: ! 1});
		    return "year" in t || "month" in t
		           || (t = lt(t, {year: "numeric", month: "numeric"})),
		           t;
		   }
		   function monthDayAmend(e){
		    var
		     t =
		       amend
		        (e,
		         {year: ! 1,
		          hour: ! 1,
		          minute: ! 1,
		          second: ! 1,
		          weekday: ! 1,
		          dayPeriod: ! 1,
		          timeZoneName: ! 1,
		          dateStyle: ! 1,
		          timeStyle: ! 1});
		    return "month" in t || "day" in t
		           || (t = lt({}, t, {month: "numeric", day: "numeric"})),
		           t;
		   }
		   function dateAmend(e){
		    var
		     t =
		       amend
		        (e,
		         {hour: ! 1,
		          minute: ! 1,
		          second: ! 1,
		          dayPeriod: ! 1,
		          timeZoneName: ! 1,
		          timeStyle: ! 1});
		    return hasDateOptions(t)
		           ||
		            (t =
		             lt({}, t, {year: "numeric", month: "numeric", day: "numeric"})),
		           t;
		   }
		   function datetimeAmend(e){
		    var t = amend(e, {timeZoneName: ! 1});
		    return hasTimeOptions(t) || hasDateOptions(t)
		           ||
		            (t =
		             lt
		              ({},
		               t,
		               {year: "numeric",
		                month: "numeric",
		                day: "numeric",
		                hour: "numeric",
		                minute: "numeric",
		                second: "numeric"})),
		           t;
		   }
		   function instantAmend(e){
		    var t = e;
		    return hasTimeOptions(t) || hasDateOptions(t)
		           ||
		            (t =
		             lt
		              ({},
		               t,
		               {year: "numeric",
		                month: "numeric",
		                day: "numeric",
		                hour: "numeric",
		                minute: "numeric",
		                second: "numeric"})),
		           t;
		   }
		   function hasDateOptions(e){
		    return "year" in e || "month" in e || "day" in e || "weekday" in e
		           || "dateStyle" in e;
		   }
		   function hasTimeOptions(e){
		    return "hour" in e || "minute" in e || "second" in e || "timeStyle" in e
		           || "dayPeriod" in e;
		   }
		   function isTemporalObject(e){
		    return IsTemporalDate(e) || IsTemporalTime(e) || IsTemporalDateTime(e)
		           || IsTemporalZonedDateTime(e)
		           || IsTemporalYearMonth(e)
		           || IsTemporalMonthDay(e)
		           || IsTemporalInstant(e);
		   }
		   function sameTemporalType(e, t){
		    return !
		           (! isTemporalObject(e) || ! isTemporalObject(t))
		           && ! (IsTemporalTime(e) && ! IsTemporalTime(t))
		           && ! (IsTemporalDate(e) && ! IsTemporalDate(t))
		           && ! (IsTemporalDateTime(e) && ! IsTemporalDateTime(t))
		           && ! (IsTemporalZonedDateTime(e) && ! IsTemporalZonedDateTime(t))
		           && ! (IsTemporalYearMonth(e) && ! IsTemporalYearMonth(t))
		           && ! (IsTemporalMonthDay(e) && ! IsTemporalMonthDay(t))
		           && ! (IsTemporalInstant(e) && ! IsTemporalInstant(t));
		   }
		   function extractOverrides(e, t){
		    var r = GetIntrinsic("%Temporal.PlainDateTime%");
		    if(IsTemporalTime(e)){
		     var
		      _o27 =
		        new
		         r
		         (1970,
		          1,
		          1,
		          GetSlot(e, d),
		          GetSlot(e, m),
		          GetSlot(e, c),
		          GetSlot(e, h),
		          GetSlot(e, u),
		          GetSlot(e, T),
		          t[nt]);
		     return {instant: GetInstantFor(t[ot], _o27, "compatible"),
		             formatter: getPropLazy(t, Qe)};
		    }
		    if(IsTemporalYearMonth(e)){
		     var
		      _o28 = GetSlot(e, i),
		      _n17 = GetSlot(e, s),
		      _a13 = GetSlot(e, l),
		      _d7 = ToTemporalCalendarIdentifier(GetSlot(e, p));
		     if(_d7 !== t[nt])
		      throw new
		             RangeError
		             ("cannot format PlainYearMonth with calendar ".concat
		                (_d7, " in locale with calendar ").concat
		               (t[nt]));
		     var _m6 = new r(_o28, _n17, _a13, 12, 0, 0, 0, 0, 0, _d7);
		     return {instant: GetInstantFor(t[ot], _m6, "compatible"),
		             formatter: getPropLazy(t, Ke)};
		    }
		    if(IsTemporalMonthDay(e)){
		     var
		      _o29 = GetSlot(e, i),
		      _n18 = GetSlot(e, s),
		      _a14 = GetSlot(e, l),
		      _d8 = ToTemporalCalendarIdentifier(GetSlot(e, p));
		     if(_d8 !== t[nt])
		      throw new
		             RangeError
		             ("cannot format PlainMonthDay with calendar ".concat
		                (_d8, " in locale with calendar ").concat
		               (t[nt]));
		     var _m7 = new r(_o29, _n18, _a14, 12, 0, 0, 0, 0, 0, _d8);
		     return {instant: GetInstantFor(t[ot], _m7, "compatible"),
		             formatter: getPropLazy(t, Xe)};
		    }
		    if(IsTemporalDate(e)){
		     var
		      _o30 = GetSlot(e, i),
		      _n19 = GetSlot(e, s),
		      _a15 = GetSlot(e, l),
		      _d9 = ToTemporalCalendarIdentifier(GetSlot(e, p));
		     if("iso8601" !== _d9 && _d9 !== t[nt])
		      throw new
		             RangeError
		             ("cannot format PlainDate with calendar ".concat
		                (_d9, " in locale with calendar ").concat
		               (t[nt]));
		     var _m8 = new r(_o30, _n19, _a15, 12, 0, 0, 0, 0, 0, t[nt]);
		     return {instant: GetInstantFor(t[ot], _m8, "compatible"),
		             formatter: getPropLazy(t, Je)};
		    }
		    if(IsTemporalDateTime(e)){
		     var
		      _o31 = GetSlot(e, i),
		      _n20 = GetSlot(e, s),
		      _a16 = GetSlot(e, l),
		      _f5 = GetSlot(e, d),
		      _y = GetSlot(e, m),
		      _I3 = GetSlot(e, c),
		      _S3 = GetSlot(e, h),
		      _g2 = GetSlot(e, u),
		      _w = GetSlot(e, T),
		      _D = ToTemporalCalendarIdentifier(GetSlot(e, p));
		     if("iso8601" !== _D && _D !== t[nt])
		      throw new
		             RangeError
		             ("cannot format PlainDateTime with calendar ".concat
		                (_D, " in locale with calendar ").concat
		               (t[nt]));
		     var _G = e;
		     return "iso8601" === _D
		            &&
		             (_G = new r(_o31, _n20, _a16, _f5, _y, _I3, _S3, _g2, _w, t[nt])),
		            {instant: GetInstantFor(t[ot], _G, "compatible"),
		             formatter: getPropLazy(t, et)};
		    }
		    if(IsTemporalZonedDateTime(e))
		     throw new
		            TypeError
		            ("Temporal.ZonedDateTime not supported in DateTimeFormat methods. Use toLocaleString() instead.");
		    return IsTemporalInstant(e)
		            ? {instant: e, formatter: getPropLazy(t, tt)}
		            : {};
		   }
		   var
		    ut = Object.freeze({__proto__: null, DateTimeFormat: ht}),
		    Instant =
		      function(){
		        function Instant(e){
		         _classCallCheck(this, Instant);
		         if(arguments.length < 1)
		          throw new
		                 TypeError
		                 ("missing argument: epochNanoseconds is required");
		         var t = ToBigInt(e);
		         ValidateEpochNanoseconds(t), N(this), SetSlot(this, n, t);
		        }
		        _createClass
		         (Instant,
		          [{key: "epochSeconds",
		            get:
		            function(){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             var t = GetSlot(this, n);
		             return Number(BigIntFloorDiv(t, ve));
		            }},
		           {key: "epochMilliseconds",
		            get:
		            function(){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             var t = BigInt(GetSlot(this, n));
		             return Number(BigIntFloorDiv(t, Ge));
		            }},
		           {key: "epochMicroseconds",
		            get:
		            function(){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return ToBigIntExternal
		                     (BigIntFloorDiv(BigInt(GetSlot(this, n)), De));
		            }},
		           {key: "epochNanoseconds",
		            get:
		            function(){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return ToBigIntExternal(BigInt(GetSlot(this, n)));
		            }},
		           {key: "add",
		            value:
		            function(e){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromInstant("add", this, e);
		            }},
		           {key: "subtract",
		            value:
		            function(e){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromInstant
		                     ("subtract", this, e);
		            }},
		           {key: "until",
		            value:
		            function(e, t){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalInstant("until", this, e, t);
		            }},
		           {key: "since",
		            value:
		            function(e, t){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalInstant("since", this, e, t);
		            }},
		           {key: "round",
		            value:
		            function(e){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             if(void 0 === e)
		              throw new TypeError("options parameter is required");
		             var
		              t =
		                "string" == typeof e
		                 ? CreateOnePropObject("smallestUnit", e)
		                 : GetOptionsObject(e),
		              r = ToTemporalRoundingIncrement(t),
		              o = ToTemporalRoundingMode(t, "halfExpand"),
		              a = GetTemporalUnit(t, "smallestUnit", "time", He);
		             ValidateTemporalRoundingIncrement
		              (r,
		               {hour: 24,
		                 minute: 1440,
		                 second: 86400,
		                 millisecond: 864e5,
		                 microsecond: 864e8,
		                 nanosecond: 864e11}
		                [a],
		               ! 0);
		             var i = RoundInstant(GetSlot(this, n), r, a, o);
		             return new Instant(i);
		            }},
		           {key: "equals",
		            value:
		            function(t){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             var
		              r = ToTemporalInstant(t),
		              o = GetSlot(this, n),
		              a = GetSlot(r, n);
		             return BigInt(o) === BigInt(a);
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetOptionsObject(e),
		              r = ToFractionalSecondDigits(t),
		              o = ToTemporalRoundingMode(t, "trunc"),
		              a = GetTemporalUnit(t, "smallestUnit", "time", void 0);
		             if("hour" === a)
		              throw new
		                     RangeError
		                     ('smallestUnit must be a time unit other than "hour"');
		             var i = t.timeZone;
		             void 0 !== i && (i = ToTemporalTimeZoneSlotValue(i));
		             var
		              _ToSecondsStringPreci = ToSecondsStringPrecisionRecord(a, r),
		              s = _ToSecondsStringPreci.precision,
		              l = _ToSecondsStringPreci.unit,
		              d = _ToSecondsStringPreci.increment,
		              m = RoundInstant(GetSlot(this, n), d, l, o);
		             return TemporalInstantToString(new Instant(m), i, s);
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return TemporalInstantToString(this, void 0, "auto");
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             return new ht(e, t).format(this);
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new
		                    TypeError
		                    ("use compare() or equals() to compare Temporal.Instant");
		            }},
		           {key: "toZonedDateTime",
		            value:
		            function(e){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e))
		              throw new TypeError("invalid argument in toZonedDateTime");
		             var t = e.calendar;
		             if(void 0 === t)
		              throw new
		                     TypeError
		                     ("missing calendar property in toZonedDateTime");
		             var r = ToTemporalCalendarSlotValue(t), o = e.timeZone;
		             if(void 0 === o)
		              throw new
		                     TypeError
		                     ("missing timeZone property in toZonedDateTime");
		             var a = ToTemporalTimeZoneSlotValue(o);
		             return CreateTemporalZonedDateTime(GetSlot(this, n), a, r);
		            }},
		           {key: "toZonedDateTimeISO",
		            value:
		            function(e){
		             if(! IsTemporalInstant(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalTimeZoneSlotValue(e);
		             return CreateTemporalZonedDateTime
		                     (GetSlot(this, n), t, "iso8601");
		            }}],
		          [{key: "fromEpochSeconds",
		            value:
		            function(t){
		             var r = ToNumber(t), o = BigInt(r) * ve;
		             return ValidateEpochNanoseconds(o), new Instant(o);
		            }},
		           {key: "fromEpochMilliseconds",
		            value:
		            function(t){
		             var r = ToNumber(t), o = BigInt(r) * Ge;
		             return ValidateEpochNanoseconds(o), new Instant(o);
		            }},
		           {key: "fromEpochMicroseconds",
		            value:
		            function(t){
		             var r = ToBigInt(t), o = r * De;
		             return ValidateEpochNanoseconds(o), new Instant(o);
		            }},
		           {key: "fromEpochNanoseconds",
		            value:
		            function(e){
		             var t = ToBigInt(e);
		             return ValidateEpochNanoseconds(t), new Instant(t);
		            }},
		           {key: "from",
		            value:
		            function(e){
		             return IsTemporalInstant(e)
		                     ? new Instant(GetSlot(e, n))
		                     : ToTemporalInstant(e);
		            }},
		           {key: "compare",
		            value:
		            function(t, r){
		             var
		              o = ToTemporalInstant(t),
		              a = ToTemporalInstant(r),
		              i = GetSlot(o, n),
		              s = GetSlot(a, n);
		             return i < s ? - 1 : i > s ? 1 : 0;
		            }}]);
		        return Instant;
		       }
		       ();
		   MakeIntrinsicClass(Instant, "Temporal.Instant");
		   var
		    Tt = Array.prototype.includes,
		    pt = Array.prototype.push,
		    ft = globalThis.Intl.DateTimeFormat,
		    yt = Array.prototype.sort,
		    It = Math.abs,
		    St = Math.floor,
		    gt = Object.create,
		    wt = Object.entries,
		    Dt = Set,
		    Gt = Reflect.ownKeys,
		    vt = Set.prototype.add,
		    Ct = Set.prototype.values,
		    Ot = {},
		    Calendar =
		      function(){
		        function Calendar(e){
		         _classCallCheck(this, Calendar);
		         if(arguments.length < 1)
		          throw new RangeError("missing argument: id is required");
		         var t = ToString(e);
		         if(! IsBuiltinCalendar(t))
		          throw new RangeError("invalid calendar identifier ".concat(t));
		         N(this), SetSlot(this, F, ASCIILowercase(t));
		        }
		        _createClass
		         (Calendar,
		          [{key: "id",
		            get:
		            function(){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, F);
		            }},
		           {key: "dateFromFields",
		            value:
		            function(e, t){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid fields");
		             var r = GetOptionsObject(t), o = GetSlot(this, F);
		             return Ot[o].dateFromFields(e, r, o);
		            }},
		           {key: "yearMonthFromFields",
		            value:
		            function(e, t){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid fields");
		             var r = GetOptionsObject(t), o = GetSlot(this, F);
		             return Ot[o].yearMonthFromFields(e, r, o);
		            }},
		           {key: "monthDayFromFields",
		            value:
		            function(e, t){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid fields");
		             var r = GetOptionsObject(t), o = GetSlot(this, F);
		             return Ot[o].monthDayFromFields(e, r, o);
		            }},
		           {key: "fields",
		            value:
		            function(e){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = [],
		              r =
		                new
		                 Set
		                 (["year",
		                   "month",
		                   "monthCode",
		                   "day",
		                   "hour",
		                   "minute",
		                   "second",
		                   "millisecond",
		                   "microsecond",
		                   "nanosecond"]),
		              _iterator15 = _createForOfIteratorHelper(e),
		              _step15;
		             try{
		              for(_iterator15.s(); ! (_step15 = _iterator15.n()).done;){
		               var _o32 = _step15.value;
		               if("string" != typeof _o32)
		                throw new TypeError("invalid fields");
		               if(! r.has(_o32))
		                throw new RangeError("invalid field name ".concat(_o32));
		               r["delete"](_o32), pt.call(t, _o32);
		              }
		             }
		             catch(err){_iterator15.e(err);}
		             finally{_iterator15.f();}
		             return Ot[GetSlot(this, F)].fields(t);
		            }},
		           {key: "mergeFields",
		            value:
		            function(e, t){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var r = ToObject(e), o = gt(null);
		             CopyDataProperties(o, r, [], [void 0]);
		             var n = ToObject(t), a = gt(null);
		             CopyDataProperties(a, n, [], [void 0]);
		             var
		              i = Gt(a),
		              s = Ot[GetSlot(this, F)].fieldKeysToIgnore(i),
		              l = gt(null),
		              d = Gt(o),
		              _iterator16 = _createForOfIteratorHelper(d),
		              _step16;
		             try{
		              for(_iterator16.s(); ! (_step16 = _iterator16.n()).done;){
		               var _e35 = _step16.value, _t42 = void 0;
		               _t42 = Call(Tt, s, [_e35]) ? a[_e35] : o[_e35],
		               void 0 !== _t42 && (l[_e35] = _t42);
		              }
		             }
		             catch(err){_iterator16.e(err);}
		             finally{_iterator16.f();}
		             return CopyDataProperties(l, a, []), l;
		            }},
		           {key: "dateAdd",
		            value:
		            function(e, t, r){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var
		              o = ToTemporalDate(e),
		              n = ToTemporalDuration(t),
		              a = ToTemporalOverflow(GetOptionsObject(r)),
		              _BalanceDuration10 =
		                BalanceDuration
		                 (GetSlot(n, v),
		                  GetSlot(n, C),
		                  GetSlot(n, O),
		                  GetSlot(n, b),
		                  GetSlot(n, E),
		                  GetSlot(n, M),
		                  GetSlot(n, R),
		                  "day"),
		              i = _BalanceDuration10.days,
		              s = GetSlot(this, F);
		             return Ot[s].dateAdd
		                     (o, GetSlot(n, w), GetSlot(n, D), GetSlot(n, G), i, a, s);
		            }},
		           {key: "dateUntil",
		            value:
		            function(e, t, r){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var
		              o = ToTemporalDate(e),
		              n = ToTemporalDate(t),
		              a =
		                GetTemporalUnit
		                 (GetOptionsObject(r), "largestUnit", "date", "auto");
		             "auto" === a && (a = "day");
		             var
		              _Ot$GetSlot$dateUntil = Ot[GetSlot(this, F)].dateUntil(o, n, a),
		              i = _Ot$GetSlot$dateUntil.years,
		              s = _Ot$GetSlot$dateUntil.months,
		              l = _Ot$GetSlot$dateUntil.weeks,
		              d = _Ot$GetSlot$dateUntil.days;
		             return new
		                     (GetIntrinsic("%Temporal.Duration%"))
		                     (i, s, l, d, 0, 0, 0, 0, 0, 0);
		            }},
		           {key: "year",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].year(t);
		            }},
		           {key: "month",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             if(IsTemporalMonthDay(t))
		              throw new TypeError("use monthCode on PlainMonthDay instead");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].month(t);
		            }},
		           {key: "monthCode",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || IsTemporalMonthDay(t)
		                    || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].monthCode(t);
		            }},
		           {key: "day",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalMonthDay(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].day(t);
		            }},
		           {key: "era",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].era(t);
		            }},
		           {key: "eraYear",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].eraYear(t);
		            }},
		           {key: "dayOfWeek",
		            value:
		            function(e){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalDate(e);
		             return Ot[GetSlot(this, F)].dayOfWeek(t);
		            }},
		           {key: "dayOfYear",
		            value:
		            function(e){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalDate(e);
		             return Ot[GetSlot(this, F)].dayOfYear(t);
		            }},
		           {key: "weekOfYear",
		            value:
		            function(e){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalDate(e);
		             return Ot[GetSlot(this, F)].weekOfYear(t);
		            }},
		           {key: "yearOfWeek",
		            value:
		            function(e){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalDate(e);
		             return Ot[GetSlot(this, F)].yearOfWeek(t);
		            }},
		           {key: "daysInWeek",
		            value:
		            function(e){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalDate(e);
		             return Ot[GetSlot(this, F)].daysInWeek(t);
		            }},
		           {key: "daysInMonth",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].daysInMonth(t);
		            }},
		           {key: "daysInYear",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].daysInYear(t);
		            }},
		           {key: "monthsInYear",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].monthsInYear(t);
		            }},
		           {key: "inLeapYear",
		            value:
		            function(e){
		             var t = e;
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return IsTemporalYearMonth(t) || (t = ToTemporalDate(t)),
		                    Ot[GetSlot(this, F)].inLeapYear(t);
		            }},
		           {key: "toString",
		            value:
		            function(){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, F);
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalCalendar(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, F);
		            }}],
		          [{key: "from",
		            value:
		            function(e){
		             return ToTemporalCalendarObject(ToTemporalCalendarSlotValue(e));
		            }}]);
		        return Calendar;
		       }
		       ();
		   function monthCodeNumberPart(e){
		    if(! e.startsWith("M"))
		     throw new
		            RangeError
		            ("Invalid month code: ".concat
		              (e, ".  Month codes must start with M."));
		    var t = + e.slice(1);
		    if(isNaN(t)) throw new RangeError("Invalid month code: ".concat(e));
		    return t;
		   }
		   function buildMonthCode(e){
		    var
		     t =
		       arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ! 1;
		    return "M".concat(e.toString().padStart(2, "0")).concat(t ? "L" : "");
		   }
		   function resolveNonLunisolarMonth(e, t){
		    var
		     r =
		       arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12,
		     o = e.month,
		     n = e.monthCode;
		    if(void 0 === n){
		     if(void 0 === o)
		      throw new TypeError("Either month or monthCode are required");
		     "reject" === t && RejectToRange(o, 1, r),
		     "constrain" === t && (o = ConstrainToRange(o, 1, r)),
		     n = buildMonthCode(o);
		    }
		    else {
		     var _e36 = monthCodeNumberPart(n);
		     if(void 0 !== o && o !== _e36)
		      throw new
		             RangeError
		             ("monthCode ".concat(n, " and month ").concat
		               (o, " must match if both are present"));
		     if(n !== buildMonthCode(_e36))
		      throw new RangeError("Invalid month code: ".concat(n));
		     if(o = _e36, o < 1 || o > r)
		      throw new RangeError("Invalid monthCode: ".concat(n));
		    }
		    return _objectSpread2(_objectSpread2({}, e), {}, {month: o, monthCode: n});
		   }
		   MakeIntrinsicClass(Calendar, "Temporal.Calendar"),
		   DefineIntrinsic("Temporal.Calendar.from", Calendar.from),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.dateAdd", Calendar.prototype.dateAdd),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.dateFromFields",
		     Calendar.prototype.dateFromFields),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.dateUntil", Calendar.prototype.dateUntil),
		   DefineIntrinsic("Temporal.Calendar.prototype.day", Calendar.prototype.day),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.dayOfWeek", Calendar.prototype.dayOfWeek),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.dayOfYear", Calendar.prototype.dayOfYear),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.daysInMonth",
		     Calendar.prototype.daysInMonth),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.daysInWeek", Calendar.prototype.daysInWeek),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.daysInYear", Calendar.prototype.daysInYear),
		   DefineIntrinsic("Temporal.Calendar.prototype.era", Calendar.prototype.era),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.eraYear", Calendar.prototype.eraYear),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.fields", Calendar.prototype.fields),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.inLeapYear", Calendar.prototype.inLeapYear),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.mergeFields",
		     Calendar.prototype.mergeFields),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.month", Calendar.prototype.month),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.monthCode", Calendar.prototype.monthCode),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.monthDayFromFields",
		     Calendar.prototype.monthDayFromFields),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.monthsInYear",
		     Calendar.prototype.monthsInYear),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.weekOfYear", Calendar.prototype.weekOfYear),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.year", Calendar.prototype.year),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.yearMonthFromFields",
		     Calendar.prototype.yearMonthFromFields),
		   DefineIntrinsic
		    ("Temporal.Calendar.prototype.yearOfWeek", Calendar.prototype.yearOfWeek),
		   Ot.iso8601 =
		    {dateFromFields:
		     function(e, t, r){
		      var
		       _RegulateISODate2,
		       o =
		         PrepareTemporalFields
		          (e, ["day", "month", "monthCode", "year"], ["year", "day"]),
		       n = ToTemporalOverflow(t);
		      o = resolveNonLunisolarMonth(o);
		      var _o33 = o, a = _o33.year, i = _o33.month, s = _o33.day;
		      return _RegulateISODate2 = RegulateISODate(a, i, s, n),
		             a = _RegulateISODate2.year,
		             i = _RegulateISODate2.month,
		             s = _RegulateISODate2.day,
		             CreateTemporalDate(a, i, s, r);
		     },
		     yearMonthFromFields:
		     function(e, t, r){
		      var
		       _RegulateISOYearMonth,
		       o = PrepareTemporalFields(e, ["month", "monthCode", "year"], ["year"]),
		       n = ToTemporalOverflow(t);
		      o = resolveNonLunisolarMonth(o);
		      var _o34 = o, a = _o34.year, i = _o34.month;
		      return _RegulateISOYearMonth =
		              function(e, t, r){
		                var o = e, n = t;
		                switch(r){
		                  case "reject":
		                   RejectISODate(o, n, 1); break;
		                  case "constrain":
		                   var _ConstrainISODate2 = ConstrainISODate(o, n);
		                   o = _ConstrainISODate2.year;
		                   n = _ConstrainISODate2.month;
		                }
		                return {year: o, month: n};
		               }
		               (a, i, n),
		             a = _RegulateISOYearMonth.year,
		             i = _RegulateISOYearMonth.month,
		             CreateTemporalYearMonth(a, i, r, 1);
		     },
		     monthDayFromFields:
		     function(e, t, r){
		      var
		       _RegulateISODate3,
		       o =
		         PrepareTemporalFields
		          (e, ["day", "month", "monthCode", "year"], ["day"]),
		       n = ToTemporalOverflow(t);
		      if(void 0 !== o.month && void 0 === o.year && void 0 === o.monthCode)
		       throw new TypeError("either year or monthCode required with month");
		      var a = void 0 === o.monthCode;
		      o = resolveNonLunisolarMonth(o);
		      var _o35 = o, i = _o35.month, s = _o35.day, l = _o35.year;
		      return _RegulateISODate3 = RegulateISODate(a ? l : 1972, i, s, n),
		             i = _RegulateISODate3.month,
		             s = _RegulateISODate3.day,
		             CreateTemporalMonthDay(i, s, r, 1972);
		     },
		     fields: function(e){return e;},
		     fieldKeysToIgnore:
		     function(e){
		      var t = new Dt();
		      for(var _r58 = 0; _r58 < e.length; _r58++){
		       var _o36 = e[_r58];
		       Call(vt, t, [_o36]),
		       "month" === _o36
		        ? Call(vt, t, ["monthCode"])
		        : "monthCode" === _o36 && Call(vt, t, ["month"]);
		      }
		      return _toConsumableArray(Call(Ct, t, []));
		     },
		     dateAdd:
		     function(e, t, r, o, n, a, d){
		      var
		       _AddISODate,
		       m = GetSlot(e, i),
		       c = GetSlot(e, s),
		       h = GetSlot(e, l);
		      return _AddISODate = AddISODate(m, c, h, t, r, o, n, a),
		             m = _AddISODate.year,
		             c = _AddISODate.month,
		             h = _AddISODate.day,
		             CreateTemporalDate(m, c, h, d);
		     },
		     dateUntil:
		     function(e, t, r){
		      return DifferenceISODate
		              (GetSlot(e, i),
		               GetSlot(e, s),
		               GetSlot(e, l),
		               GetSlot(t, i),
		               GetSlot(t, s),
		               GetSlot(t, l),
		               r);
		     },
		     year: function(e){return GetSlot(e, i);},
		     era: function(){},
		     eraYear: function(){},
		     month: function(e){return GetSlot(e, s);},
		     monthCode: function(e){return buildMonthCode(GetSlot(e, s));},
		     day: function(e){return GetSlot(e, l);},
		     dayOfWeek:
		     function(e){
		      return DayOfWeek(GetSlot(e, i), GetSlot(e, s), GetSlot(e, l));
		     },
		     dayOfYear:
		     function(e){
		      return DayOfYear(GetSlot(e, i), GetSlot(e, s), GetSlot(e, l));
		     },
		     weekOfYear:
		     function(e){
		      return WeekOfYear(GetSlot(e, i), GetSlot(e, s), GetSlot(e, l)).week;
		     },
		     yearOfWeek:
		     function(e){
		      return WeekOfYear(GetSlot(e, i), GetSlot(e, s), GetSlot(e, l)).year;
		     },
		     daysInWeek: function(){return 7;},
		     daysInMonth:
		     function(e){return ISODaysInMonth(GetSlot(e, i), GetSlot(e, s));},
		     daysInYear:
		     function(e){
		      var t = e;
		      return HasSlot(t, i) || (t = ToTemporalDate(t)),
		             LeapYear(GetSlot(t, i)) ? 366 : 365;
		     },
		     monthsInYear: function(){return 12;},
		     inLeapYear:
		     function(e){
		      var t = e;
		      return HasSlot(t, i) || (t = ToTemporalDate(t)),
		             LeapYear(GetSlot(t, i));
		     }};
		   var
		    OneObjectCache =
		      function(){
		        function OneObjectCache(e){
		         _classCallCheck(this, OneObjectCache);
		         if
		          (this.map = new Map(),
		           this.calls = 0,
		           this.hits = 0,
		           this.misses = 0,
		           this.now =
		            globalThis.performance ? globalThis.performance.now() : Date.now(),
		           void 0 !== e){
		          var
		           _t43 = 0,
		           _iterator17 = _createForOfIteratorHelper(e.map.entries()),
		           _step17;
		          try{
		           for(_iterator17.s(); ! (_step17 = _iterator17.n()).done;){
		            var _this$map, _r59 = _step17.value;
		            if(++_t43 > OneObjectCache.MAX_CACHE_ENTRIES) break;
		            (_this$map = this.map).set.apply
		             (_this$map, _toConsumableArray(_r59));
		           }
		          }
		          catch(err){_iterator17.e(err);}
		          finally{_iterator17.f();}
		         }
		        }
		        _createClass
		         (OneObjectCache,
		          [{key: "get",
		            value:
		            function(e){
		             var t = this.map.get(e);
		             return t && (this.hits++, this.report()), this.calls++, t;
		            }},
		           {key: "set",
		            value:
		            function(e, t){this.map.set(e, t), this.misses++, this.report();}},
		           {key: "report", value: function(){}},
		           {key: "setObject",
		            value:
		            function(e){
		             if(OneObjectCache.objectMap.get(e))
		              throw new RangeError("object already cached");
		             OneObjectCache.objectMap.set(e, this), this.report();
		            }}],
		          [{key: "getCacheForObject",
		            value:
		            function(e){
		             var t = OneObjectCache.objectMap.get(e);
		             return t
		                    ||
		                     (t = new OneObjectCache(),
		                      OneObjectCache.objectMap.set(e, t)),
		                    t;
		            }}]);
		        return OneObjectCache;
		       }
		       ();
		   function toUtcIsoDateString(_ref8){
		    var e = _ref8.isoYear, t = _ref8.isoMonth, r = _ref8.isoDay;
		    return "".concat(ISOYearString(e), "-").concat
		             (ISODateTimePartString(t), "-").concat
		            (ISODateTimePartString(r), "T00:00Z");
		   }
		   function simpleDateDiff(e, t){
		    return {years: e.year - t.year,
		            months: e.month - t.month,
		            days: e.day - t.day};
		   }
		   OneObjectCache.objectMap = new WeakMap(),
		   OneObjectCache.MAX_CACHE_ENTRIES = 1e3;
		   var
		    HelperBase =
		      function(){
		        function HelperBase(){
		         _classCallCheck(this, HelperBase);
		         this.eraLength = "short",
		         this.hasEra = ! 0,
		         this.erasBeginMidYear = ! 1;
		        }
		        _createClass
		         (HelperBase,
		          [{key: "getFormatter",
		            value:
		            function(){
		             return void 0 === this.formatter
		                    &&
		                     (this.formatter =
		                      new
		                       ft
		                       ("en-US-u-ca-".concat(this.id),
		                        {day: "numeric",
		                         month: "numeric",
		                         year: "numeric",
		                         era: this.eraLength,
		                         timeZone: "UTC"})),
		                    this.formatter;
		            }},
		           {key: "isoToCalendarDate",
		            value:
		            function(e, t){
		             var
		              _this = this,
		              r = e.year,
		              o = e.month,
		              n = e.day,
		              a =
		                JSON.stringify
		                 ({func: "isoToCalendarDate",
		                   isoYear: r,
		                   isoMonth: o,
		                   isoDay: n,
		                   id: this.id}),
		              i = t.get(a);
		             if(i) return i;
		             var s = this.getFormatter(), l, d;
		             try{
		              d = toUtcIsoDateString({isoYear: r, isoMonth: o, isoDay: n}),
		              l = s.formatToParts(new Date(d));
		             }
		             catch(e){
		              throw new
		                     RangeError
		                     ("Invalid ISO date: ".concat
		                       (JSON.stringify({isoYear: r, isoMonth: o, isoDay: n})));
		             }
		             var m = {}, _iterator18 = _createForOfIteratorHelper(l), _step18;
		             try{
		              for(_iterator18.s(); ! (_step18 = _iterator18.n()).done;){
		               var
		                _step18$value = _step18.value,
		                _e37 = _step18$value.type,
		                _t45 = _step18$value.value;
		               if
		                ("year" === _e37 && (m.eraYear = + _t45),
		                 "relatedYear" === _e37 && (m.eraYear = + _t45),
		                 "month" === _e37){
		                var _e38 = /^([0-9]*)(.*?)$/.exec(_t45);
		                if(! _e38 || 3 != _e38.length || ! _e38[1] && ! _e38[2])
		                 throw new RangeError("Unexpected month: ".concat(_t45));
		                if(m.month = _e38[1] ? + _e38[1] : 1, m.month < 1)
		                 throw new
		                        RangeError
		                        ("Invalid month ".concat(_t45, " from ").concat(d, "[u-ca-").concat
		                          (this.id,
		                           "] (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10527)"));
		                if(m.month > 13)
		                 throw new
		                        RangeError
		                        ("Invalid month ".concat(_t45, " from ").concat(d, "[u-ca-").concat
		                          (this.id,
		                           "] (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10529)"));
		                _e38[2] && (m.monthExtra = _e38[2]);
		               }
		               "day" === _e37 && (m.day = + _t45),
		               this.hasEra && "era" === _e37 && null != _t45 && "" !== _t45
		               &&
		                (_t45 = _t45.split(" (")[0],
		                 m.era =
		                  _t45.normalize("NFD").replace
		                     (/(?:[\0-\x1F!-,\.\/:-@\[-`\{-\xA9\xAB-\xB4\xB6-\xB9\xBB-\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u036F\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482-\u0489\u0530\u0557\u0558\u055A-\u055F\u0589-\u05CF\u05EB-\u05EE\u05F3-\u061F\u064B-\u066D\u0670\u06D4\u06D6-\u06E4\u06E7-\u06ED\u06F0-\u06F9\u06FD\u06FE\u0700-\u070F\u0711\u0730-\u074C\u07A6-\u07B0\u07B2-\u07C9\u07EB-\u07F3\u07F6-\u07F9\u07FB-\u07FF\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u083F\u0859-\u085F\u086B-\u086F\u0888\u088F-\u089F\u08CA-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0970\u0981-\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA-\u09BC\u09BE-\u09CD\u09CF-\u09DB\u09DE\u09E2-\u09EF\u09F2-\u09FB\u09FD-\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A-\u0A58\u0A5D\u0A5F-\u0A71\u0A75-\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA-\u0ABC\u0ABE-\u0ACF\u0AD1-\u0ADF\u0AE2-\u0AF8\u0AFA-\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A-\u0B3C\u0B3E-\u0B5B\u0B5E\u0B62-\u0B70\u0B72-\u0B82\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BCF\u0BD1-\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C3E-\u0C57\u0C5B\u0C5C\u0C5E\u0C5F\u0C62-\u0C7F\u0C81-\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA-\u0CBC\u0CBE-\u0CDC\u0CDF\u0CE2-\u0CF0\u0CF3-\u0D03\u0D0D\u0D11\u0D3B\u0D3C\u0D3E-\u0D4D\u0D4F-\u0D53\u0D57-\u0D5E\u0D62-\u0D79\u0D80-\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0E00\u0E31\u0E34-\u0E3F\u0E47-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EB1\u0EB4-\u0EBC\u0EBE\u0EBF\u0EC5\u0EC7-\u0EDB\u0EE0-\u0EFF\u0F01-\u0F3F\u0F48\u0F6D-\u0F87\u0F8D-\u0FFF\u102B-\u103E\u1040-\u104F\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16F0\u16F9-\u16FF\u1712-\u171E\u1732-\u173F\u1752-\u175F\u176D\u1771-\u177F\u17B4-\u17D6\u17D8-\u17DB\u17DD-\u181F\u1879-\u187F\u1885\u1886\u18A9\u18AB-\u18AF\u18F6-\u18FF\u191F-\u194F\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19FF\u1A17-\u1A1F\u1A55-\u1AA6\u1AA8-\u1B04\u1B34-\u1B44\u1B4D-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BFF\u1C24-\u1C4C\u1C50-\u1C59\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1CFB-\u1CFF\u1DC0-\u1DFF\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u2070\u2072-\u207E\u2080-\u208F\u209D-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F-\u2182\u2185-\u2BFF\u2CE5-\u2CEA\u2CEF-\u2CF1\u2CF4-\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7F\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF-\u2E2E\u2E30-\u3004\u3007-\u3030\u3036-\u303A\u303D-\u3040\u3097-\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u319F\u31C0-\u31EF\u3200-\u33FF\u4DC0-\u4DFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA620-\uA629\uA62C-\uA63F\uA66F-\uA67E\uA69E\uA69F\uA6E6-\uA716\uA720\uA721\uA789\uA78A\uA7CB-\uA7CF\uA7D2\uA7D4\uA7DA-\uA7F1\uA802\uA806\uA80B\uA823-\uA83F\uA874-\uA881\uA8B4-\uA8F1\uA8F8-\uA8FA\uA8FC\uA8FF-\uA909\uA926-\uA92F\uA947-\uA95F\uA97D-\uA983\uA9B3-\uA9CE\uA9D0-\uA9DF\uA9E5\uA9F0-\uA9F9\uA9FF\uAA29-\uAA3F\uAA43\uAA4C-\uAA5F\uAA77-\uAA79\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAC3-\uAADA\uAADE\uAADF\uAAEB-\uAAF1\uAAF5-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABE3-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB1E\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFE6F\uFE75\uFEFD-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEFF\uDF20-\uDF2C\uDF41\uDF4A-\uDF4F\uDF76-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0-\uDFFF]|\uD801[\uDC9E-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6F\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56-\uDC5F\uDC77-\uDC7F\uDC9F-\uDCDF\uDCF3\uDCF6-\uDCFF\uDD16-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBD\uDDC0-\uDDFF\uDE01-\uDE0F\uDE14\uDE18\uDE36-\uDE5F\uDE7D-\uDE7F\uDE9D-\uDEBF\uDEC8\uDEE5-\uDEFF\uDF36-\uDF3F\uDF56-\uDF5F\uDF73-\uDF7F\uDF92-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCFF\uDD24-\uDE7F\uDEAA-\uDEAF\uDEB2-\uDEFF\uDF1D-\uDF26\uDF28-\uDF2F\uDF46-\uDF6F\uDF82-\uDFAF\uDFC5-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC00-\uDC02\uDC38-\uDC70\uDC73\uDC74\uDC76-\uDC82\uDCB0-\uDCCF\uDCE9-\uDD02\uDD27-\uDD43\uDD45\uDD46\uDD48-\uDD4F\uDD73-\uDD75\uDD77-\uDD82\uDDB3-\uDDC0\uDDC5-\uDDD9\uDDDB\uDDDD-\uDDFF\uDE12\uDE2C-\uDE3E\uDE41-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEDF-\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A-\uDF3C\uDF3E-\uDF4F\uDF51-\uDF5C\uDF62-\uDFFF]|\uD805[\uDC35-\uDC46\uDC4B-\uDC5E\uDC62-\uDC7F\uDCB0-\uDCC3\uDCC6\uDCC8-\uDD7F\uDDAF-\uDDD7\uDDDC-\uDDFF\uDE30-\uDE43\uDE45-\uDE7F\uDEAB-\uDEB7\uDEB9-\uDEFF\uDF1B-\uDF3F\uDF47-\uDFFF]|\uD806[\uDC2C-\uDC9F\uDCE0-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD30-\uDD3E\uDD40\uDD42-\uDD9F\uDDA8\uDDA9\uDDD1-\uDDE0\uDDE2\uDDE4-\uDDFF\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE4F\uDE51-\uDE5B\uDE8A-\uDE9C\uDE9E-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC2F-\uDC3F\uDC41-\uDC71\uDC90-\uDCFF\uDD07\uDD0A\uDD31-\uDD45\uDD47-\uDD5F\uDD66\uDD69\uDD8A-\uDD97\uDD99-\uDEDF\uDEF3-\uDF01\uDF03\uDF11\uDF34-\uDFAF\uDFB1-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC00-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD834\uD836\uD83C-\uD83F\uD87C\uD87D\uD87F\uD889-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF1-\uDFFF]|\uD80D[\uDC30-\uDC40\uDC47-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F-\uDE6F\uDEBF-\uDECF\uDEEE-\uDEFF\uDF30-\uDF3F\uDF44-\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE80-\uDEFF\uDF4B-\uDF4F\uDF51-\uDF92\uDFA0-\uDFDF\uDFE2\uDFE4-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD31\uDD33-\uDD4F\uDD53\uDD54\uDD56-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDF24\uDF2B-\uDFFF]|\uD838[\uDC00-\uDC2F\uDC6E-\uDCFF\uDD2D-\uDD36\uDD3E-\uDD4D\uDD4F-\uDE8F\uDEAE-\uDEBF\uDEEC-\uDFFF]|\uD839[\uDC00-\uDCCF\uDCEC-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5-\uDCFF\uDD44-\uDD4A\uDD4C-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF3A-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFEF]|\uD87B[\uDE5E-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDF4F]|\uD888[\uDFB0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g,
		                      "").replace
		                    (" ", "-").toLowerCase
		                   ());
		              }
		             }
		             catch(err){_iterator18.e(err);}
		             finally{_iterator18.f();}
		             if(void 0 === m.eraYear)
		              throw new
		                     RangeError
		                     ("Intl.DateTimeFormat.formatToParts lacks relatedYear in ".concat
		                       (this.id, " calendar. Try Node 14+ or modern browsers."));
		             if(this.reviseIntlEra){
		              var
		               _this$reviseIntlEra = this.reviseIntlEra(m, e),
		               _t44 = _this$reviseIntlEra.era,
		               _r60 = _this$reviseIntlEra.eraYear;
		              m.era = _t44, m.eraYear = _r60;
		             }
		             this.checkIcuBugs && this.checkIcuBugs(e);
		             var c = this.adjustCalendarDate(m, t, "constrain", ! 0);
		             if(void 0 === c.year)
		              throw new
		                     RangeError
		                     ("Missing year converting ".concat(JSON.stringify(e)));
		             if(void 0 === c.month)
		              throw new
		                     RangeError
		                     ("Missing month converting ".concat(JSON.stringify(e)));
		             if(void 0 === c.day)
		              throw new
		                     RangeError
		                     ("Missing day converting ".concat(JSON.stringify(e)));
		             return t.set(a, c),
		                    ["constrain", "reject"].forEach
		                     (function(r){
		                       var
		                        o =
		                          JSON.stringify
		                           ({func: "calendarToIsoDate",
		                             year: c.year,
		                             month: c.month,
		                             day: c.day,
		                             overflow: r,
		                             id: _this.id});
		                       t.set(o, e);
		                      }),
		                    c;
		            }},
		           {key: "validateCalendarDate",
		            value:
		            function(e){
		             var
		              t = e.era,
		              r = e.month,
		              o = e.year,
		              n = e.day,
		              a = e.eraYear,
		              i = e.monthCode,
		              s = e.monthExtra;
		             if(void 0 !== s)
		              throw new RangeError("Unexpected `monthExtra` value");
		             if(void 0 === o && void 0 === a)
		              throw new TypeError("year or eraYear is required");
		             if(void 0 === r && void 0 === i)
		              throw new TypeError("month or monthCode is required");
		             if(void 0 === n) throw new RangeError("Missing day");
		             if(void 0 !== i){
		              if("string" != typeof i)
		               throw new
		                      RangeError
		                      ("monthCode must be a string, not " + _typeof(i));
		              if(! /^M([01]?\d)(L?)$/.test(i))
		               throw new RangeError("Invalid monthCode: ".concat(i));
		             }
		             if(this.constantEra){
		              if(void 0 !== t && t !== this.constantEra)
		               throw new
		                      RangeError
		                      ("era must be ".concat(this.constantEra, ", not ").concat(t));
		              if(void 0 !== a && void 0 !== o && a !== o)
		               throw new
		                      RangeError
		                      ("eraYear ".concat(a, " does not match year ").concat(o));
		             }
		             if(this.hasEra && void 0 === e.era != (void 0 === e.eraYear))
		              throw new
		                     RangeError
		                     ("properties 'era' and 'eraYear' must be provided together");
		            }},
		           {key: "adjustCalendarDate",
		            value:
		            function(e, t){
		             var
		              _resolveNonLunisolarM,
		              r =
		                arguments.length > 2 && arguments[2] !== undefined
		                 ? arguments[2]
		                 : "constrain";
		             if("lunisolar" === this.calendarType)
		              throw new
		                     RangeError
		                     ("Override required for lunisolar calendars");
		             var n = e;
		             if(this.validateCalendarDate(n), this.constantEra){
		              var _n21 = n, _e39 = _n21.year, _t46 = _n21.eraYear;
		              n =
		               _objectSpread2
		                (_objectSpread2({}, n),
		                 {},
		                 {era: this.constantEra,
		                  year: void 0 !== _e39 ? _e39 : _t46,
		                  eraYear: void 0 !== _t46 ? _t46 : _e39});
		             }
		             var
		              a = this.monthsInYear(n, t),
		              _n22 = n,
		              i = _n22.month,
		              s = _n22.monthCode;
		             return _resolveNonLunisolarM = resolveNonLunisolarMonth(n, r, a),
		                    i = _resolveNonLunisolarM.month,
		                    s = _resolveNonLunisolarM.monthCode,
		                    _objectSpread2
		                     (_objectSpread2({}, n), {}, {month: i, monthCode: s});
		            }},
		           {key: "regulateMonthDayNaive",
		            value:
		            function(e, t, r){
		             var o = this.monthsInYear(e, r), n = e.month, a = e.day;
		             return "reject" === t
		                     ? (RejectToRange
		                        (n, 1, o),
		                       RejectToRange(a, 1, this.maximumMonthLength(e)))
		                     : (n
		                       = ConstrainToRange(n, 1, o),
		                       a =
		                        ConstrainToRange
		                         (a,
		                          1,
		                          this.maximumMonthLength
		                           (_objectSpread2(_objectSpread2({}, e), {}, {month: n})))),
		                    _objectSpread2
		                     (_objectSpread2({}, e), {}, {month: n, day: a});
		            }},
		           {key: "calendarToIsoDate",
		            value:
		            function(e){
		             var
		              _this2 = this,
		              t =
		                arguments.length > 1 && arguments[1] !== undefined
		                 ? arguments[1]
		                 : "constrain",
		              r = arguments.length > 2 ? arguments[2] : undefined,
		              o = e,
		              n = this.adjustCalendarDate(e, r, t, ! 1);
		             n = this.regulateMonthDayNaive(n, t, r);
		             var
		              _n23 = n,
		              a = _n23.year,
		              i = _n23.month,
		              s = _n23.day,
		              l =
		                JSON.stringify
		                 ({func: "calendarToIsoDate",
		                   year: a,
		                   month: i,
		                   day: s,
		                   overflow: t,
		                   id: this.id}),
		              d,
		              m = r.get(l);
		             if(m) return m;
		             if
		              (void 0 !== o.year && void 0 !== o.month && void 0 !== o.day
		               &&
		                (o.year !== n.year || o.month !== n.month || o.day !== n.day)
		               &&
		                (d =
		                  JSON.stringify
		                   ({func: "calendarToIsoDate",
		                     year: o.year,
		                     month: o.month,
		                     day: o.day,
		                     overflow: t,
		                     id: this.id}),
		                 m = r.get(d),
		                 m))
		              return m;
		             var
		              c = this.estimateIsoDate({year: a, month: i, day: s}),
		              calculateSameMonthResult =
		                function(e){
		                 var o = _this2.addDaysIso(c, e);
		                 if(n.day > _this2.minimumMonthLength(n)){
		                  var _e40 = _this2.isoToCalendarDate(o, r);
		                  for(; _e40.month !== i || _e40.year !== a;){
		                   if("reject" === t)
		                    throw new
		                           RangeError
		                           ("day ".concat(s, " does not exist in month ").concat
		                              (i, " of year ").concat
		                             (a));
		                   o = _this2.addDaysIso(o, - 1),
		                   _e40 = _this2.isoToCalendarDate(o, r);
		                  }
		                 }
		                 return o;
		                },
		              h = 0,
		              u = this.isoToCalendarDate(c, r),
		              T = simpleDateDiff(n, u);
		             if(0 !== T.years || 0 !== T.months || 0 !== T.days){
		              var _e41 = 365 * T.years + 30 * T.months + T.days;
		              c = this.addDaysIso(c, _e41),
		              u = this.isoToCalendarDate(c, r),
		              T = simpleDateDiff(n, u),
		              0 === T.years && 0 === T.months
		               ? c = calculateSameMonthResult(T.days)
		               : h = this.compareCalendarDates(n, u);
		             }
		             var p = 8;
		             for(; h;){
		              c = this.addDaysIso(c, h * p);
		              var _e42 = u;
		              u = this.isoToCalendarDate(c, r);
		              var _a17 = h;
		              if(h = this.compareCalendarDates(n, u), h)
		               if(T = simpleDateDiff(n, u), 0 === T.years && 0 === T.months)
		                c = calculateSameMonthResult(T.days), h = 0;
		               else if(_a17 && h !== _a17)
		                if(p > 1)
		                 p /= 2;
		                else {
		                 if("reject" === t)
		                  throw new
		                         RangeError
		                         ("Can't find ISO date from calendar date: ".concat
		                           (JSON.stringify(_objectSpread2({}, o))));
		                 this.compareCalendarDates(u, _e42) > 0
		                 && (c = this.addDaysIso(c, - 1)),
		                 h = 0;
		                }
		             }
		             if
		              (r.set(l, c),
		               d && r.set(d, c),
		               void 0 === n.year || void 0 === n.month || void 0 === n.day
		               || void 0 === n.monthCode
		               || this.hasEra && (void 0 === n.era || void 0 === n.eraYear))
		              throw new RangeError("Unexpected missing property");
		             return c;
		            }},
		           {key: "temporalToCalendarDate",
		            value:
		            function(e, t){
		             var
		              r =
		                {year: GetSlot(e, i),
		                 month: GetSlot(e, s),
		                 day: GetSlot(e, l)};
		             return this.isoToCalendarDate(r, t);
		            }},
		           {key: "compareCalendarDates",
		            value:
		            function(e, t){
		             var
		              r =
		                PrepareTemporalFields
		                 (e, ["day", "month", "year"], ["day", "month", "year"]),
		              o =
		                PrepareTemporalFields
		                 (t, ["day", "month", "year"], ["day", "month", "year"]);
		             return r.year !== o.year
		                     ? ComparisonResult(r.year - o.year)
		                     : r.month
		                       !== o.month
		                       ? ComparisonResult(r.month - o.month)
		                       : r.day !== o.day ? ComparisonResult(r.day - o.day) : 0;
		            }},
		           {key: "regulateDate",
		            value:
		            function(e){
		             var
		              t =
		                arguments.length > 1 && arguments[1] !== undefined
		                 ? arguments[1]
		                 : "constrain",
		              r = arguments.length > 2 ? arguments[2] : undefined,
		              o = this.calendarToIsoDate(e, t, r);
		             return this.isoToCalendarDate(o, r);
		            }},
		           {key: "addDaysIso",
		            value:
		            function(e, t){
		             return AddISODate
		                     (e.year, e.month, e.day, 0, 0, 0, t, "constrain");
		            }},
		           {key: "addDaysCalendar",
		            value:
		            function(e, t, r){
		             var
		              o = this.calendarToIsoDate(e, "constrain", r),
		              n = this.addDaysIso(o, t);
		             return this.isoToCalendarDate(n, r);
		            }},
		           {key: "addMonthsCalendar",
		            value:
		            function(e, t, r, o){
		             var n = e, _n24 = n, a = _n24.day;
		             for(var _e43 = 0, _r61 = It(t); _e43 < _r61; _e43++){
		              var
		               _n25 = n,
		               _e44 = _n25.month,
		               _r62 = n,
		               _i18 =
		                 t < 0
		                  ? - Math.max(a, this.daysInPreviousMonth(n, o))
		                  : this.daysInMonth(n, o),
		               _s7 = this.calendarToIsoDate(n, "constrain", o),
		               _l7 = this.addDaysIso(_s7, _i18);
		              if(n = this.isoToCalendarDate(_l7, o), t > 0){
		               var _t47 = this.monthsInYear(_r62, o);
		               for(; n.month - 1 != _e44 % _t47;)
		                _l7 = this.addDaysIso(_l7, - 1),
		                n = this.isoToCalendarDate(_l7, o);
		              }
		              n.day !== a
		              &&
		               (n =
		                this.regulateDate
		                 (_objectSpread2(_objectSpread2({}, n), {}, {day: a}),
		                  "constrain",
		                  o));
		             }
		             if("reject" === r && n.day !== a)
		              throw new
		                     RangeError
		                     ("Day ".concat
		                       (a, " does not exist in resulting calendar month"));
		             return n;
		            }},
		           {key: "addCalendar",
		            value:
		            function(e, _ref9, a, i){
		             var
		              _ref9$years = _ref9.years,
		              t = _ref9$years === void 0 ? 0 : _ref9$years,
		              _ref9$months = _ref9.months,
		              r = _ref9$months === void 0 ? 0 : _ref9$months,
		              _ref9$weeks = _ref9.weeks,
		              o = _ref9$weeks === void 0 ? 0 : _ref9$weeks,
		              _ref9$days = _ref9.days,
		              n = _ref9$days === void 0 ? 0 : _ref9$days,
		              s = e.year,
		              l = e.day,
		              d = e.monthCode,
		              m =
		                this.adjustCalendarDate
		                 ({year: s + t, monthCode: d, day: l}, i),
		              c = this.addMonthsCalendar(m, r, a, i),
		              h = n + 7 * o;
		             return this.addDaysCalendar(c, h, i);
		            }},
		           {key: "untilCalendar",
		            value:
		            function(e, t, r, o){
		             var n = 0, a = 0, i = 0, s = 0;
		             switch(r){
		               case "day":
		                n = this.calendarDaysUntil(e, t, o); break;
		               case "week":
		                {
		                 var _r63 = this.calendarDaysUntil(e, t, o);
		                 n = _r63 % 7, a = (_r63 - n) / 7;
		                 break;
		                }
		               case "month":
		               case "year":
		                {
		                 var _a18 = this.compareCalendarDates(t, e);
		                 if(! _a18) return {years: 0, months: 0, weeks: 0, days: 0};
		                 var _l8 = t.year - e.year, _d10 = t.day - e.day;
		                 if("year" === r && _l8){
		                  var _r64 = 0;
		                  t.monthCode > e.monthCode && (_r64 = 1),
		                  t.monthCode < e.monthCode && (_r64 = - 1),
		                  _r64 || (_r64 = Math.sign(_d10));
		                  s = _r64 * _a18 < 0 ? _l8 - _a18 : _l8;
		                 }
		                 var
		                  _m9,
		                  _c5 =
		                    s ? this.addCalendar(e, {years: s}, "constrain", o) : e;
		                 do
		                  i += _a18,
		                  _m9 = _c5,
		                  _c5 = this.addMonthsCalendar(_m9, _a18, "constrain", o),
		                  _c5.day !== e.day
		                  &&
		                   (_c5 =
		                    this.regulateDate
		                     (_objectSpread2(_objectSpread2({}, _c5), {}, {day: e.day}),
		                      "constrain",
		                      o));
		                 while
		                  (this.compareCalendarDates(t, _c5) * _a18 >= 0);
		                 i -= _a18;
		                 n = this.calendarDaysUntil(_m9, t, o);
		                 break;
		                }
		             }
		             return {years: s, months: i, weeks: a, days: n};
		            }},
		           {key: "daysInMonth",
		            value:
		            function(e, t){
		             var
		              r = e.day,
		              o = this.maximumMonthLength(e),
		              n = this.minimumMonthLength(e);
		             if(n === o) return n;
		             var
		              a = r <= o - n ? o : n,
		              i = this.calendarToIsoDate(e, "constrain", t),
		              s = this.addDaysIso(i, a),
		              l = this.isoToCalendarDate(s, t),
		              d = this.addDaysIso(s, - l.day);
		             return this.isoToCalendarDate(d, t).day;
		            }},
		           {key: "daysInPreviousMonth",
		            value:
		            function(e, t){
		             var
		              r = e.day,
		              o = e.month,
		              n = e.year,
		              a = {year: o > 1 ? n : n - 1, month: o, day: 1},
		              i = o > 1 ? o - 1 : this.monthsInYear(a, t);
		             a = _objectSpread2(_objectSpread2({}, a), {}, {month: i});
		             var
		              s = this.minimumMonthLength(a),
		              l = this.maximumMonthLength(a);
		             if(s === l) return l;
		             var
		              d = this.calendarToIsoDate(e, "constrain", t),
		              m = this.addDaysIso(d, - r);
		             return this.isoToCalendarDate(m, t).day;
		            }},
		           {key: "startOfCalendarYear",
		            value:
		            function(e){
		             return {year: e.year, month: 1, monthCode: "M01", day: 1};
		            }},
		           {key: "startOfCalendarMonth",
		            value: function(e){return {year: e.year, month: e.month, day: 1};}},
		           {key: "calendarDaysUntil",
		            value:
		            function(e, t, r){
		             var
		              o = this.calendarToIsoDate(e, "constrain", r),
		              n = this.calendarToIsoDate(t, "constrain", r);
		             return this.isoDaysUntil(o, n);
		            }},
		           {key: "isoDaysUntil",
		            value:
		            function(e, t){
		             return DifferenceISODate
		                     (e.year, e.month, e.day, t.year, t.month, t.day, "day").days;
		            }},
		           {key: "monthDayFromFields",
		            value:
		            function(e, t, r){
		             var o, n, a, i, s, l = e.monthCode, d = e.day;
		             if(void 0 === l){
		              var _o37 = e.year, _n26 = e.era, _a19 = e.eraYear;
		              if(void 0 === _o37 && (void 0 === _n26 || void 0 === _a19))
		               throw new
		                      TypeError
		                      ("when `monthCode` is omitted, `year` (or `era` and `eraYear`) and `month` are required");
		              var
		               _this$isoToCalendarDa =
		                 this.isoToCalendarDate(this.calendarToIsoDate(e, t, r), r);
		              l = _this$isoToCalendarDa.monthCode;
		              d = _this$isoToCalendarDa.day;
		             }
		             var
		              m = this.isoToCalendarDate({year: 1972, month: 12, day: 31}, r),
		              c =
		                m.monthCode > l || m.monthCode === l && m.day >= d
		                 ? m.year
		                 : m.year - 1;
		             for(var _e45 = 0; _e45 < 100; _e45++){
		              var
		               _m10 =
		                 this.adjustCalendarDate
		                  ({day: d, monthCode: l, year: c - _e45}, r),
		               _h3 = this.calendarToIsoDate(_m10, "constrain", r),
		               _u2 = this.isoToCalendarDate(_h3, r);
		              if
		               (o = _h3.year,
		                n = _h3.month,
		                a = _h3.day,
		                _u2.monthCode === l && _u2.day === d)
		               return {month: n, day: a, year: o};
		              "constrain" === t
		              &&
		               (void 0 === i
		               || _u2.monthCode === i.monthCode && _u2.day > i.day)
		              && (i = _u2, s = _h3);
		             }
		             if("constrain" === t && void 0 !== s) return s;
		             throw new
		                    RangeError
		                    ("No recent ".concat(this.id, " year with monthCode ").concat
		                       (l, " and day ").concat
		                      (d));
		            }}]);
		        return HelperBase;
		       }
		       (),
		    HebrewHelper =
		      function(_HelperBase){
		        _inherits(HebrewHelper, _HelperBase);
		        var _super = _createSuper(HebrewHelper);
		        function HebrewHelper(){
		         var _this3;
		         _classCallCheck(this, HebrewHelper);
		         _this3 = _super.apply(this, arguments),
		         _this3.id = "hebrew",
		         _this3.calendarType = "lunisolar",
		         _this3.months =
		          {Tishri: {leap: 1, regular: 1, monthCode: "M01", days: 30},
		           Heshvan:
		           {leap: 2, regular: 2, monthCode: "M02", days: {min: 29, max: 30}},
		           Kislev:
		           {leap: 3, regular: 3, monthCode: "M03", days: {min: 29, max: 30}},
		           Tevet: {leap: 4, regular: 4, monthCode: "M04", days: 29},
		           Shevat: {leap: 5, regular: 5, monthCode: "M05", days: 30},
		           Adar: {leap: void 0, regular: 6, monthCode: "M06", days: 29},
		           "Adar I": {leap: 6, regular: void 0, monthCode: "M05L", days: 30},
		           "Adar II": {leap: 7, regular: void 0, monthCode: "M06", days: 29},
		           Nisan: {leap: 8, regular: 7, monthCode: "M07", days: 30},
		           Iyar: {leap: 9, regular: 8, monthCode: "M08", days: 29},
		           Sivan: {leap: 10, regular: 9, monthCode: "M09", days: 30},
		           Tamuz: {leap: 11, regular: 10, monthCode: "M10", days: 29},
		           Av: {leap: 12, regular: 11, monthCode: "M11", days: 30},
		           Elul: {leap: 13, regular: 12, monthCode: "M12", days: 29}},
		         _this3.hasEra = ! 1;
		         return _this3;
		        }
		        _createClass
		         (HebrewHelper,
		          [{key: "inLeapYear",
		            value: function(e){var t = e.year; return (7 * t + 1) % 19 < 7;}},
		           {key: "monthsInYear",
		            value: function(e){return this.inLeapYear(e) ? 13 : 12;}},
		           {key: "minimumMonthLength",
		            value: function(e){return this.minMaxMonthLength(e, "min");}},
		           {key: "maximumMonthLength",
		            value: function(e){return this.minMaxMonthLength(e, "max");}},
		           {key: "minMaxMonthLength",
		            value:
		            function(e, t){
		             var
		              r = e.month,
		              o = e.year,
		              n = this.getMonthCode(o, r),
		              a =
		                wt(this.months).find
		                 (function(e){return e[1].monthCode === n;});
		             if(void 0 === a)
		              throw new RangeError("unmatched Hebrew month: ".concat(r));
		             var i = a[1].days;
		             return "number" == typeof i ? i : i[t];
		            }},
		           {key: "estimateIsoDate",
		            value:
		            function(e){
		             var t = e.year;
		             return {year: t - 3760, month: 1, day: 1};
		            }},
		           {key: "getMonthCode",
		            value:
		            function(e, t){
		             return this.inLeapYear({year: e})
		                     ? 6
		                       === t
		                       ? buildMonthCode(5, ! 0)
		                       : buildMonthCode(t < 6 ? t : t - 1)
		                     : buildMonthCode(t);
		            }},
		           {key: "adjustCalendarDate",
		            value:
		            function(e, t){
		             var
		              r =
		                arguments.length > 2 && arguments[2] !== undefined
		                 ? arguments[2]
		                 : "constrain",
		              o =
		                arguments.length > 3 && arguments[3] !== undefined
		                 ? arguments[3]
		                 : ! 1,
		              n = e.year,
		              a = e.eraYear,
		              i = e.month,
		              s = e.monthCode,
		              l = e.day,
		              d = e.monthExtra;
		             if
		              (void 0 === n && void 0 !== a && (n = a),
		               void 0 === a && void 0 !== n && (a = n),
		               o){
		              if(d){
		               var _e46 = this.months[d];
		               if(! _e46)
		                throw new
		                       RangeError
		                       ("Unrecognized month from formatToParts: ".concat(d));
		               i = this.inLeapYear({year: n}) ? _e46.leap : _e46.regular;
		              }
		              s = this.getMonthCode(n, i);
		              return {year: n,
		                      month: i,
		                      day: l,
		                      era: void 0,
		                      eraYear: a,
		                      monthCode: s};
		             }
		             if(this.validateCalendarDate(e), void 0 === i)
		              if(s.endsWith("L")){
		               if("M05L" !== s)
		                throw new
		                       RangeError
		                       ("Hebrew leap month must have monthCode M05L, not ".concat
		                         (s));
		               if(i = 6, ! this.inLeapYear({year: n})){
		                if("reject" === r)
		                 throw new
		                        RangeError
		                        ("Hebrew monthCode M05L is invalid in year ".concat
		                          (n, " which is not a leap year"));
		                i = 6, s = "M06";
		               }
		              }
		              else {
		               i = monthCodeNumberPart(s),
		               this.inLeapYear({year: n}) && i >= 6 && i++;
		               var _e47 = this.monthsInYear({year: n});
		               if(i < 1 || i > _e47)
		                throw new RangeError("Invalid monthCode: ".concat(s));
		              }
		             else if
		              ("reject" === r
		                ? (RejectToRange
		                   (i, 1, this.monthsInYear({year: n})),
		                  RejectToRange
		                   (l, 1, this.maximumMonthLength({year: n, month: i})))
		                : (i
		                  = ConstrainToRange(i, 1, this.monthsInYear({year: n})),
		                  l =
		                   ConstrainToRange
		                    (l, 1, this.maximumMonthLength({year: n, month: i}))),
		               void 0 === s)
		              s = this.getMonthCode(n, i);
		             else if(this.getMonthCode(n, i) !== s)
		              throw new
		                     RangeError
		                     ("monthCode ".concat(s, " doesn't correspond to month ").concat
		                        (i, " in Hebrew year ").concat
		                       (n));
		             return _objectSpread2
		                     (_objectSpread2({}, e),
		                      {},
		                      {day: l, month: i, monthCode: s, year: n, eraYear: a});
		            }}]);
		        return HebrewHelper;
		       }
		       (HelperBase),
		    IslamicBaseHelper =
		      function(_HelperBase2){
		        _inherits(IslamicBaseHelper, _HelperBase2);
		        var _super2 = _createSuper(IslamicBaseHelper);
		        function IslamicBaseHelper(){
		         var _this4;
		         _classCallCheck(this, IslamicBaseHelper);
		         _this4 = _super2.apply(this, arguments),
		         _this4.calendarType = "lunar",
		         _this4.DAYS_PER_ISLAMIC_YEAR = 354 + 11 / 30,
		         _this4.DAYS_PER_ISO_YEAR = 365.2425,
		         _this4.constantEra = "ah";
		         return _this4;
		        }
		        _createClass
		         (IslamicBaseHelper,
		          [{key: "inLeapYear",
		            value:
		            function(e, t){
		             return 30
		                    === this.daysInMonth({year: e.year, month: 12, day: 1}, t);
		            }},
		           {key: "monthsInYear", value: function(){return 12;}},
		           {key: "minimumMonthLength", value: function(){return 29;}},
		           {key: "maximumMonthLength", value: function(){return 30;}},
		           {key: "estimateIsoDate",
		            value:
		            function(e){
		             var
		              _this$adjustCalendarD = this.adjustCalendarDate(e),
		              t = _this$adjustCalendarD.year;
		             return {year:
		                     St(t * this.DAYS_PER_ISLAMIC_YEAR / this.DAYS_PER_ISO_YEAR)
		                     + 622,
		                     month: 1,
		                     day: 1};
		            }}]);
		        return IslamicBaseHelper;
		       }
		       (HelperBase),
		    IslamicHelper =
		      function(_IslamicBaseHelper){
		        _inherits(IslamicHelper, _IslamicBaseHelper);
		        var _super3 = _createSuper(IslamicHelper);
		        function IslamicHelper(){
		         var _this5;
		         _classCallCheck(this, IslamicHelper);
		         _this5 = _super3.apply(this, arguments), _this5.id = "islamic";
		         return _this5;
		        }
		        return _createClass(IslamicHelper);
		       }
		       (IslamicBaseHelper),
		    IslamicUmalquraHelper =
		      function(_IslamicBaseHelper2){
		        _inherits(IslamicUmalquraHelper, _IslamicBaseHelper2);
		        var _super4 = _createSuper(IslamicUmalquraHelper);
		        function IslamicUmalquraHelper(){
		         var _this6;
		         _classCallCheck(this, IslamicUmalquraHelper);
		         _this6 = _super4.apply(this, arguments),
		         _this6.id = "islamic-umalqura";
		         return _this6;
		        }
		        return _createClass(IslamicUmalquraHelper);
		       }
		       (IslamicBaseHelper),
		    IslamicTblaHelper =
		      function(_IslamicBaseHelper3){
		        _inherits(IslamicTblaHelper, _IslamicBaseHelper3);
		        var _super5 = _createSuper(IslamicTblaHelper);
		        function IslamicTblaHelper(){
		         var _this7;
		         _classCallCheck(this, IslamicTblaHelper);
		         _this7 = _super5.apply(this, arguments), _this7.id = "islamic-tbla";
		         return _this7;
		        }
		        return _createClass(IslamicTblaHelper);
		       }
		       (IslamicBaseHelper),
		    IslamicCivilHelper =
		      function(_IslamicBaseHelper4){
		        _inherits(IslamicCivilHelper, _IslamicBaseHelper4);
		        var _super6 = _createSuper(IslamicCivilHelper);
		        function IslamicCivilHelper(){
		         var _this8;
		         _classCallCheck(this, IslamicCivilHelper);
		         _this8 = _super6.apply(this, arguments), _this8.id = "islamic-civil";
		         return _this8;
		        }
		        return _createClass(IslamicCivilHelper);
		       }
		       (IslamicBaseHelper),
		    IslamicRgsaHelper =
		      function(_IslamicBaseHelper5){
		        _inherits(IslamicRgsaHelper, _IslamicBaseHelper5);
		        var _super7 = _createSuper(IslamicRgsaHelper);
		        function IslamicRgsaHelper(){
		         var _this9;
		         _classCallCheck(this, IslamicRgsaHelper);
		         _this9 = _super7.apply(this, arguments), _this9.id = "islamic-rgsa";
		         return _this9;
		        }
		        return _createClass(IslamicRgsaHelper);
		       }
		       (IslamicBaseHelper),
		    IslamicCcHelper =
		      function(_IslamicBaseHelper6){
		        _inherits(IslamicCcHelper, _IslamicBaseHelper6);
		        var _super8 = _createSuper(IslamicCcHelper);
		        function IslamicCcHelper(){
		         var _this10;
		         _classCallCheck(this, IslamicCcHelper);
		         _this10 = _super8.apply(this, arguments), _this10.id = "islamicc";
		         return _this10;
		        }
		        return _createClass(IslamicCcHelper);
		       }
		       (IslamicBaseHelper),
		    PersianHelper =
		      function(_HelperBase3){
		        _inherits(PersianHelper, _HelperBase3);
		        var _super9 = _createSuper(PersianHelper);
		        function PersianHelper(){
		         var _this11;
		         _classCallCheck(this, PersianHelper);
		         _this11 = _super9.apply(this, arguments),
		         _this11.id = "persian",
		         _this11.calendarType = "solar",
		         _this11.constantEra = "ap";
		         return _this11;
		        }
		        _createClass
		         (PersianHelper,
		          [{key: "inLeapYear",
		            value:
		            function(e, t){
		             return IslamicHelper.prototype.inLeapYear.call(this, e, t);
		            }},
		           {key: "monthsInYear", value: function(){return 12;}},
		           {key: "minimumMonthLength",
		            value:
		            function(e){
		             var t = e.month;
		             return 12 === t ? 29 : t <= 6 ? 31 : 30;
		            }},
		           {key: "maximumMonthLength",
		            value:
		            function(e){
		             var t = e.month;
		             return 12 === t ? 30 : t <= 6 ? 31 : 30;
		            }},
		           {key: "estimateIsoDate",
		            value:
		            function(e){
		             var
		              _this$adjustCalendarD2 = this.adjustCalendarDate(e),
		              t = _this$adjustCalendarD2.year;
		             return {year: t + 621, month: 1, day: 1};
		            }}]);
		        return PersianHelper;
		       }
		       (HelperBase),
		    IndianHelper =
		      function(_HelperBase4){
		        _inherits(IndianHelper, _HelperBase4);
		        var _super10 = _createSuper(IndianHelper);
		        function IndianHelper(){
		         var _this12;
		         _classCallCheck(this, IndianHelper);
		         _this12 = _super10.apply(this, arguments),
		         _this12.id = "indian",
		         _this12.calendarType = "solar",
		         _this12.constantEra = "saka",
		         _this12.months =
		          {1:
		           {length: 30,
		            month: 3,
		            day: 22,
		            leap: {length: 31, month: 3, day: 21}},
		           2: {length: 31, month: 4, day: 21},
		           3: {length: 31, month: 5, day: 22},
		           4: {length: 31, month: 6, day: 22},
		           5: {length: 31, month: 7, day: 23},
		           6: {length: 31, month: 8, day: 23},
		           7: {length: 30, month: 9, day: 23},
		           8: {length: 30, month: 10, day: 23},
		           9: {length: 30, month: 11, day: 22},
		           10: {length: 30, month: 12, day: 22},
		           11: {length: 30, month: 1, nextYear: ! 0, day: 21},
		           12: {length: 30, month: 2, nextYear: ! 0, day: 20}},
		         _this12.vulnerableToBceBug =
		          "10/11/-79 Saka"
		          !==
		           new Date("0000-01-01T00:00Z").toLocaleDateString
		            ("en-US-u-ca-indian", {timeZone: "UTC"});
		         return _this12;
		        }
		        _createClass
		         (IndianHelper,
		          [{key: "inLeapYear",
		            value: function(e){return isGregorianLeapYear(e.year + 78);}},
		           {key: "monthsInYear", value: function(){return 12;}},
		           {key: "minimumMonthLength",
		            value: function(e){return this.getMonthInfo(e).length;}},
		           {key: "maximumMonthLength",
		            value: function(e){return this.getMonthInfo(e).length;}},
		           {key: "getMonthInfo",
		            value:
		            function(e){
		             var t = e.month, r = this.months[t];
		             if(void 0 === r)
		              throw new RangeError("Invalid month: ".concat(t));
		             return this.inLeapYear(e) && r.leap && (r = r.leap), r;
		            }},
		           {key: "estimateIsoDate",
		            value:
		            function(e){
		             var t = this.adjustCalendarDate(e), r = this.getMonthInfo(t);
		             return AddISODate
		                     (t.year + 78 + (r.nextYear ? 1 : 0),
		                      r.month,
		                      r.day,
		                      0,
		                      0,
		                      0,
		                      t.day - 1,
		                      "constrain");
		            }},
		           {key: "checkIcuBugs",
		            value:
		            function(e){
		             if(this.vulnerableToBceBug && e.year < 1)
		              throw new
		                     RangeError
		                     ("calendar '".concat
		                       (this.id,
		                        "' is broken for ISO dates before 0001-01-01 (see https://bugs.chromium.org/p/v8/issues/detail?id=10529)"));
		            }}]);
		        return IndianHelper;
		       }
		       (HelperBase);
		   function isGregorianLeapYear(e){
		    return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
		   }
		   var
		    GregorianBaseHelper =
		      function(_HelperBase5){
		        _inherits(GregorianBaseHelper, _HelperBase5);
		        var _super11 = _createSuper(GregorianBaseHelper);
		        function GregorianBaseHelper(e, t){
		         var _this13;
		         _classCallCheck(this, GregorianBaseHelper);
		         _this13 = _super11.call(this),
		         _this13.calendarType = "solar",
		         _this13.v8IsVulnerableToJulianBug =
		          new Date("+001001-01-01T00:00Z").toLocaleDateString
		            ("en-US-u-ca-japanese", {timeZone: "UTC"}).startsWith
		           ("12"),
		         _this13.calendarIsVulnerableToJulianBug = ! 1,
		         _this13.id = e;
		         var
		          _adjustEras =
		            function(e){
		              var t, r = e;
		              if(0 === r.length)
		               throw new RangeError("Invalid era data: eras are required");
		              if(1 === r.length && r[0].reverseOf)
		               throw new
		                      RangeError
		                      ("Invalid era data: anchor era cannot count years backwards");
		              if(1 === r.length && ! r[0].name)
		               throw new
		                      RangeError
		                      ("Invalid era data: at least one named era is required");
		              if
		               (r.filter(function(e){return null != e.reverseOf;}).length > 1)
		               throw new
		                      RangeError
		                      ("Invalid era data: only one era can count years backwards");
		              r.forEach
		               (function(e){
		                 if(e.isAnchor || ! e.anchorEpoch && ! e.reverseOf){
		                  if(t)
		                   throw new
		                          RangeError
		                          ("Invalid era data: cannot have multiple anchor eras");
		                  t = e, e.anchorEpoch = {year: e.hasYearZero ? 0 : 1};
		                 }
		                 else if(! e.name)
		                  throw new
		                         RangeError
		                         ("If era name is blank, it must be the anchor era");
		                }),
		              r = r.filter(function(e){return e.name;}),
		              r.forEach
		               (function(e){
		                 var t = e.reverseOf;
		                 if(t){
		                  var _o38 = r.find(function(e){return e.name === t;});
		                  if(void 0 === _o38)
		                   throw new
		                          RangeError
		                          ("Invalid era data: unmatched reverseOf era: ".concat(t));
		                  e.reverseOf = _o38,
		                  e.anchorEpoch = _o38.anchorEpoch,
		                  e.isoEpoch = _o38.isoEpoch;
		                 }
		                 void 0 === e.anchorEpoch.month && (e.anchorEpoch.month = 1),
		                 void 0 === e.anchorEpoch.day && (e.anchorEpoch.day = 1);
		                }),
		              yt.call
		               (r,
		                function(e, t){
		                 if(e.reverseOf) return 1;
		                 if(t.reverseOf) return - 1;
		                 if(! e.isoEpoch || ! t.isoEpoch)
		                  throw new RangeError("Invalid era data: missing ISO epoch");
		                 return t.isoEpoch.year - e.isoEpoch.year;
		                });
		              var o = r[r.length - 1].reverseOf;
		              if(o && o !== r[r.length - 2])
		               throw new
		                      RangeError
		                      ("Invalid era data: invalid reverse-sign era");
		              return r.forEach
		                      (function(e, t){e.genericName = "era" + (r.length - 1 - t);}),
		                     {eras: r, anchorEra: t || r[0]};
		             }
		             (t),
		          r = _adjustEras.eras,
		          o = _adjustEras.anchorEra;
		         _this13.anchorEra = o, _this13.eras = r;
		         return _this13;
		        }
		        _createClass
		         (GregorianBaseHelper,
		          [{key: "inLeapYear",
		            value:
		            function(e){
		             var
		              _this$estimateIsoDate =
		                this.estimateIsoDate({month: 1, day: 1, year: e.year}),
		              t = _this$estimateIsoDate.year;
		             return isGregorianLeapYear(t);
		            }},
		           {key: "monthsInYear", value: function(){return 12;}},
		           {key: "minimumMonthLength",
		            value:
		            function(e){
		             var t = e.month;
		             return 2 === t
		                     ? this.inLeapYear(e) ? 29 : 28
		                     : [4, 6, 9, 11].indexOf(t) >= 0 ? 30 : 31;
		            }},
		           {key: "maximumMonthLength",
		            value: function(e){return this.minimumMonthLength(e);}},
		           {key: "completeEraYear",
		            value:
		            function(e){
		             var
		              _this14 = this,
		              _eraFromYear,
		              checkField =
		                function(t, r){
		                 var o = e[t];
		                 if(null != o && o != r)
		                  throw new
		                         RangeError
		                         ("Input ".concat(t, " ").concat
		                            (o, " doesn't match calculated value ").concat
		                           (r));
		                },
		              eraFromYear =
		                function(t){
		                 var
		                  r,
		                  o = _objectSpread2(_objectSpread2({}, e), {}, {year: t}),
		                  n =
		                    _this14.eras.find
		                     (function(e, n){
		                       if(n === _this14.eras.length - 1){
		                        if(e.reverseOf){
		                         if(t > 0)
		                          throw new
		                                 RangeError
		                                 ("Signed year ".concat(t, " is invalid for era ").concat
		                                   (e.name));
		                         return r = e.anchorEpoch.year - t, ! 0;
		                        }
		                        return r = t - e.anchorEpoch.year + (e.hasYearZero ? 0 : 1),
		                               !
		                               0;
		                       }
		                       return _this14.compareCalendarDates(o, e.anchorEpoch) >= 0
		                              &&
		                               (r = t - e.anchorEpoch.year + (e.hasYearZero ? 0 : 1), ! 0);
		                      });
		                 if(! n)
		                  throw new
		                         RangeError
		                         ("Year ".concat(t, " was not matched by any era"));
		                 return {eraYear: r, era: n.name};
		                },
		              t = e.year,
		              r = e.eraYear,
		              o = e.era;
		             if(null != t)
		              _eraFromYear = eraFromYear(t),
		              r = _eraFromYear.eraYear,
		              o = _eraFromYear.era,
		              checkField("era", o),
		              checkField("eraYear", r);
		             else {
		              if(null == r)
		               throw new
		                      RangeError
		                      ("Either `year` or `eraYear` and `era` are required");
		              {
		               var
		                _eraFromYear2,
		                _e48 =
		                  void 0 === o
		                   ? void 0
		                   : this.eras.find
		                     (function(e){return e.name === o || e.genericName === o;});
		               if(! _e48)
		                throw new
		                       RangeError
		                       ("Era ".concat(o, " (ISO year ").concat
		                         (r, ") was not matched by any era"));
		               if(r < 1 && _e48.reverseOf)
		                throw new
		                       RangeError
		                       ("Years in ".concat(o, " era must be positive, not ").concat
		                         (t));
		               t =
		                _e48.reverseOf
		                 ? _e48.anchorEpoch.year - r
		                 : r + _e48.anchorEpoch.year - (_e48.hasYearZero ? 0 : 1),
		               checkField("year", t),
		               _eraFromYear2 = eraFromYear(t),
		               r = _eraFromYear2.eraYear,
		               o = _eraFromYear2.era;
		              }
		             }
		             return _objectSpread2
		                     (_objectSpread2({}, e), {}, {year: t, eraYear: r, era: o});
		            }},
		           {key: "adjustCalendarDate",
		            value:
		            function(e, t){
		             var
		              r =
		                arguments.length > 2 && arguments[2] !== undefined
		                 ? arguments[2]
		                 : "constrain",
		              o = e,
		              _o39 = o,
		              n = _o39.month,
		              a = _o39.monthCode;
		             return void 0 === n
		                    &&
		                     (o =
		                      _objectSpread2
		                       (_objectSpread2({}, o), {}, {month: monthCodeNumberPart(a)})),
		                    this.validateCalendarDate(o),
		                    o = this.completeEraYear(o),
		                    _get
		                      (_getPrototypeOf(GregorianBaseHelper.prototype),
		                       "adjustCalendarDate",
		                       this).call
		                     (this, o, t, r);
		            }},
		           {key: "estimateIsoDate",
		            value:
		            function(e){
		             var
		              t = this.adjustCalendarDate(e),
		              r = t.year,
		              o = t.month,
		              n = t.day,
		              a = this.anchorEra;
		             return RegulateISODate
		                     (r + a.isoEpoch.year - (a.hasYearZero ? 0 : 1),
		                      o,
		                      n,
		                      "constrain");
		            }},
		           {key: "checkIcuBugs",
		            value:
		            function(e){
		             if
		              (this.calendarIsVulnerableToJulianBug
		               && this.v8IsVulnerableToJulianBug)
		              if(CompareISODate(e.year, e.month, e.day, 1582, 10, 15) < 0)
		               throw new
		                      RangeError
		                      ("calendar '".concat
		                        (this.id,
		                         "' is broken for ISO dates before 1582-10-15 (see https://bugs.chromium.org/p/chromium/issues/detail?id=1173158)"));
		            }}]);
		        return GregorianBaseHelper;
		       }
		       (HelperBase),
		    OrthodoxBaseHelper =
		      function(_GregorianBaseHelper){
		        _inherits(OrthodoxBaseHelper, _GregorianBaseHelper);
		        var _super12 = _createSuper(OrthodoxBaseHelper);
		        function OrthodoxBaseHelper(e, t){
		         _classCallCheck(this, OrthodoxBaseHelper);
		         return _super12.call(this, e, t);
		        }
		        _createClass
		         (OrthodoxBaseHelper,
		          [{key: "inLeapYear",
		            value: function(e){var t = e.year; return (t + 1) % 4 == 0;}},
		           {key: "monthsInYear", value: function(){return 13;}},
		           {key: "minimumMonthLength",
		            value:
		            function(e){
		             var t = e.month;
		             return 13 === t ? this.inLeapYear(e) ? 6 : 5 : 30;
		            }},
		           {key: "maximumMonthLength",
		            value: function(e){return this.minimumMonthLength(e);}}]);
		        return OrthodoxBaseHelper;
		       }
		       (GregorianBaseHelper),
		    EthioaaHelper =
		      function(_OrthodoxBaseHelper){
		        _inherits(EthioaaHelper, _OrthodoxBaseHelper);
		        var _super13 = _createSuper(EthioaaHelper);
		        function EthioaaHelper(){
		         _classCallCheck(this, EthioaaHelper);
		         return _super13.call
		                 (this,
		                  "ethioaa",
		                  [{name: "era0", isoEpoch: {year: - 5492, month: 7, day: 17}}]);
		        }
		        return _createClass(EthioaaHelper);
		       }
		       (OrthodoxBaseHelper),
		    CopticHelper =
		      function(_OrthodoxBaseHelper2){
		        _inherits(CopticHelper, _OrthodoxBaseHelper2);
		        var _super14 = _createSuper(CopticHelper);
		        function CopticHelper(){
		         _classCallCheck(this, CopticHelper);
		         return _super14.call
		                 (this,
		                  "coptic",
		                  [{name: "era1", isoEpoch: {year: 284, month: 8, day: 29}},
		                   {name: "era0", reverseOf: "era1"}]);
		        }
		        return _createClass(CopticHelper);
		       }
		       (OrthodoxBaseHelper),
		    EthiopicHelper =
		      function(_OrthodoxBaseHelper3){
		        _inherits(EthiopicHelper, _OrthodoxBaseHelper3);
		        var _super15 = _createSuper(EthiopicHelper);
		        function EthiopicHelper(){
		         _classCallCheck(this, EthiopicHelper);
		         return _super15.call
		                 (this,
		                  "ethiopic",
		                  [{name: "era0", isoEpoch: {year: - 5492, month: 7, day: 17}},
		                   {name: "era1",
		                    isoEpoch: {year: 8, month: 8, day: 27},
		                    anchorEpoch: {year: 5501}}]);
		        }
		        return _createClass(EthiopicHelper);
		       }
		       (OrthodoxBaseHelper),
		    RocHelper =
		      function(_GregorianBaseHelper2){
		        _inherits(RocHelper, _GregorianBaseHelper2);
		        var _super16 = _createSuper(RocHelper);
		        function RocHelper(){
		         var _this15;
		         _classCallCheck(this, RocHelper);
		         _this15 =
		          _super16.call
		           (this,
		            "roc",
		            [{name: "minguo", isoEpoch: {year: 1912, month: 1, day: 1}},
		             {name: "before-roc", reverseOf: "minguo"}]),
		         _this15.calendarIsVulnerableToJulianBug = ! 0;
		         return _this15;
		        }
		        return _createClass(RocHelper);
		       }
		       (GregorianBaseHelper),
		    BuddhistHelper =
		      function(_GregorianBaseHelper3){
		        _inherits(BuddhistHelper, _GregorianBaseHelper3);
		        var _super17 = _createSuper(BuddhistHelper);
		        function BuddhistHelper(){
		         var _this16;
		         _classCallCheck(this, BuddhistHelper);
		         _this16 =
		          _super17.call
		           (this,
		            "buddhist",
		            [{name: "be",
		              hasYearZero: ! 0,
		              isoEpoch: {year: - 543, month: 1, day: 1}}]),
		         _this16.calendarIsVulnerableToJulianBug = ! 0;
		         return _this16;
		        }
		        return _createClass(BuddhistHelper);
		       }
		       (GregorianBaseHelper),
		    GregoryHelper =
		      function(_GregorianBaseHelper4){
		        _inherits(GregoryHelper, _GregorianBaseHelper4);
		        var _super18 = _createSuper(GregoryHelper);
		        function GregoryHelper(){
		         _classCallCheck(this, GregoryHelper);
		         return _super18.call
		                 (this,
		                  "gregory",
		                  [{name: "ce", isoEpoch: {year: 1, month: 1, day: 1}},
		                   {name: "bce", reverseOf: "ce"}]);
		        }
		        _createClass
		         (GregoryHelper,
		          [{key: "reviseIntlEra",
		            value:
		            function(e){
		             var t = e.era, r = e.eraYear;
		             return "bc" !== t && "b" !== t || (t = "bce"),
		                    "ad" !== t && "a" !== t || (t = "ce"),
		                    {era: t, eraYear: r};
		            }}]);
		        return GregoryHelper;
		       }
		       (GregorianBaseHelper),
		    JapaneseHelper =
		      function(_GregorianBaseHelper5){
		        _inherits(JapaneseHelper, _GregorianBaseHelper5);
		        var _super19 = _createSuper(JapaneseHelper);
		        function JapaneseHelper(){
		         var _this17;
		         _classCallCheck(this, JapaneseHelper);
		         _this17 =
		          _super19.call
		           (this,
		            "japanese",
		            [{name: "reiwa",
		              isoEpoch: {year: 2019, month: 5, day: 1},
		              anchorEpoch: {year: 2019, month: 5, day: 1}},
		             {name: "heisei",
		              isoEpoch: {year: 1989, month: 1, day: 8},
		              anchorEpoch: {year: 1989, month: 1, day: 8}},
		             {name: "showa",
		              isoEpoch: {year: 1926, month: 12, day: 25},
		              anchorEpoch: {year: 1926, month: 12, day: 25}},
		             {name: "taisho",
		              isoEpoch: {year: 1912, month: 7, day: 30},
		              anchorEpoch: {year: 1912, month: 7, day: 30}},
		             {name: "meiji",
		              isoEpoch: {year: 1868, month: 9, day: 8},
		              anchorEpoch: {year: 1868, month: 9, day: 8}},
		             {name: "ce", isoEpoch: {year: 1, month: 1, day: 1}},
		             {name: "bce", reverseOf: "ce"}]),
		         _this17.calendarIsVulnerableToJulianBug = ! 0,
		         _this17.eraLength = "long",
		         _this17.erasBeginMidYear = ! 0;
		         return _this17;
		        }
		        _createClass
		         (JapaneseHelper,
		          [{key: "reviseIntlEra",
		            value:
		            function(e, t){
		             var r = e.era, o = e.eraYear, n = t.year;
		             return this.eras.find(function(e){return e.name === r;})
		                     ? {era: r, eraYear: o}
		                     : n
		                       < 1
		                       ? {era: "bce", eraYear: 1 - n}
		                       : {era: "ce", eraYear: n};
		            }}]);
		        return JapaneseHelper;
		       }
		       (GregorianBaseHelper),
		    ChineseBaseHelper =
		      function(_HelperBase6){
		        _inherits(ChineseBaseHelper, _HelperBase6);
		        var _super20 = _createSuper(ChineseBaseHelper);
		        function ChineseBaseHelper(){
		         var _this18;
		         _classCallCheck(this, ChineseBaseHelper);
		         _this18 = _super20.apply(this, arguments),
		         _this18.calendarType = "lunisolar",
		         _this18.hasEra = ! 1;
		         return _this18;
		        }
		        _createClass
		         (ChineseBaseHelper,
		          [{key: "inLeapYear",
		            value:
		            function(e, t){
		             var r = this.getMonthList(e.year, t);
		             return 13 === wt(r).length;
		            }},
		           {key: "monthsInYear",
		            value: function(e, t){return this.inLeapYear(e, t) ? 13 : 12;}},
		           {key: "minimumMonthLength", value: function(){return 29;}},
		           {key: "maximumMonthLength", value: function(){return 30;}},
		           {key: "getMonthList",
		            value:
		            function(e, t){
		             var _this19 = this, _getCalendarDate2;
		             if(void 0 === e) throw new TypeError("Missing year");
		             var
		              r =
		                JSON.stringify
		                 ({func: "getMonthList", calendarYear: e, id: this.id}),
		              o = t.get(r);
		             if(o) return o;
		             var
		              n = this.getFormatter(),
		              getCalendarDate =
		                function(e, t){
		                 var
		                  r = toUtcIsoDateString({isoYear: e, isoMonth: 2, isoDay: 1}),
		                  o = new Date(r);
		                 o.setUTCDate(t + 1);
		                 var
		                  a = n.formatToParts(o),
		                  i = a.find(function(e){return "month" === e.type;}).value,
		                  s = + a.find(function(e){return "day" === e.type;}).value,
		                  l = a.find(function(e){return "relatedYear" === e.type;});
		                 if(void 0 === l)
		                  throw new
		                         RangeError
		                         ("Intl.DateTimeFormat.formatToParts lacks relatedYear in ".concat
		                           (_this19.id, " calendar. Try Node 14+ or modern browsers."));
		                 return l = + l.value,
		                        {calendarMonthString: i,
		                         calendarDay: s,
		                         calendarYearToVerify: l};
		                },
		              a = 17,
		              _getCalendarDate = getCalendarDate(e, a),
		              i = _getCalendarDate.calendarMonthString,
		              s = _getCalendarDate.calendarDay,
		              l = _getCalendarDate.calendarYearToVerify;
		             "1" !== i
		             &&
		              (a += 29,
		               _getCalendarDate2 = getCalendarDate(e, a),
		               i = _getCalendarDate2.calendarMonthString,
		               s = _getCalendarDate2.calendarDay),
		             a -= s - 5;
		             var d = {}, m, c, h = 1, u = ! 1;
		             do{
		              var _getCalendarDate3;
		              _getCalendarDate3 = getCalendarDate(e, a),
		              i = _getCalendarDate3.calendarMonthString,
		              s = _getCalendarDate3.calendarDay,
		              l = _getCalendarDate3.calendarYearToVerify,
		              m && (d[c].daysInMonth = m + 30 - s),
		              l !== e ? u = ! 0 : (d[i] = {monthIndex: h++}, a += 30),
		              m = s,
		              c = i;
		             }
		             while
		              (! u);
		             return d[c].daysInMonth = m + 30 - s, t.set(r, d), d;
		            }},
		           {key: "estimateIsoDate",
		            value:
		            function(e){
		             var t = e.year, r = e.month;
		             return {year: t, month: r >= 12 ? 12 : r + 1, day: 1};
		            }},
		           {key: "adjustCalendarDate",
		            value:
		            function(e, t){
		             var
		              r =
		                arguments.length > 2 && arguments[2] !== undefined
		                 ? arguments[2]
		                 : "constrain",
		              o =
		                arguments.length > 3 && arguments[3] !== undefined
		                 ? arguments[3]
		                 : ! 1,
		              n = e.year,
		              a = e.month,
		              i = e.monthExtra,
		              s = e.day,
		              l = e.monthCode,
		              d = e.eraYear;
		             if(o){
		              if(n = d, i && "bis" !== i)
		               throw new
		                      RangeError
		                      ("Unexpected leap month suffix: ".concat(i));
		              var
		               _e49 = buildMonthCode(a, void 0 !== i),
		               _r65 = "".concat(a).concat(i || ""),
		               _o40 = this.getMonthList(n, t)[_r65];
		              if(void 0 === _o40)
		               throw new
		                      RangeError
		                      ("Unmatched month ".concat(_r65, " in Chinese year ").concat
		                        (n));
		              return a = _o40.monthIndex,
		                     {year: n,
		                      month: a,
		                      day: s,
		                      era: void 0,
		                      eraYear: d,
		                      monthCode: _e49};
		             }
		             if
		              (this.validateCalendarDate(e),
		               void 0 === n && (n = d),
		               void 0 === d && (d = n),
		               void 0 === a){
		              var
		               _e50 = this.getMonthList(n, t),
		               _o41 = l.replace("L", "bis").slice(1);
		              "0" === _o41[0] && (_o41 = _o41.slice(1));
		              var _i19 = _e50[_o41];
		              if
		               (a = _i19 && _i19.monthIndex,
		                void 0 === a && l.endsWith("L") && "M13L" != l
		                && "constrain" === r){
		               var _t48 = l.slice(1, - 1);
		               "0" === _t48[0] && (_t48 = _t48.slice(1)),
		               _i19 = _e50[_t48],
		               _i19 && (a = _i19.monthIndex, l = buildMonthCode(_t48));
		              }
		              if(void 0 === a)
		               throw new
		                      RangeError
		                      ("Unmatched month ".concat(l, " in Chinese year ").concat(n));
		             }
		             else if(void 0 === l){
		              var
		               _e51 = this.getMonthList(n, t),
		               _o42 = wt(_e51),
		               _i20 = _o42.length;
		              "reject" === r
		               ? (RejectToRange
		                  (a, 1, _i20),
		                 RejectToRange(s, 1, this.maximumMonthLength()))
		               : (a
		                 = ConstrainToRange(a, 1, _i20),
		                 s = ConstrainToRange(s, 1, this.maximumMonthLength()));
		              var
		               _d11 =
		                 _o42.find
		                  (function(_ref10){
		                    var _ref11 = _slicedToArray(_ref10, 2), e = _ref11[1];
		                    return e.monthIndex === a;
		                   });
		              if(void 0 === _d11)
		               throw new
		                      RangeError
		                      ("Invalid month ".concat(a, " in Chinese year ").concat(n));
		              l =
		               buildMonthCode
		                (_d11[0].replace("bis", ""), - 1 !== _d11[0].indexOf("bis"));
		             }
		             else {
		              var
		               _e52 = this.getMonthList(n, t),
		               _r66 = l.replace("L", "bis").slice(1);
		              "0" === _r66[0] && (_r66 = _r66.slice(1));
		              var _o43 = _e52[_r66];
		              if(! _o43)
		               throw new
		                      RangeError
		                      ("Unmatched monthCode ".concat(l, " in Chinese year ").concat
		                        (n));
		              if(a !== _o43.monthIndex)
		               throw new
		                      RangeError
		                      ("monthCode ".concat(l, " doesn't correspond to month ").concat
		                         (a, " in Chinese year ").concat
		                        (n));
		             }
		             return _objectSpread2
		                     (_objectSpread2({}, e),
		                      {},
		                      {year: n, eraYear: d, month: a, monthCode: l, day: s});
		            }}]);
		        return ChineseBaseHelper;
		       }
		       (HelperBase),
		    ChineseHelper =
		      function(_ChineseBaseHelper){
		        _inherits(ChineseHelper, _ChineseBaseHelper);
		        var _super21 = _createSuper(ChineseHelper);
		        function ChineseHelper(){
		         var _this20;
		         _classCallCheck(this, ChineseHelper);
		         _this20 = _super21.apply(this, arguments), _this20.id = "chinese";
		         return _this20;
		        }
		        return _createClass(ChineseHelper);
		       }
		       (ChineseBaseHelper),
		    DangiHelper =
		      function(_ChineseBaseHelper2){
		        _inherits(DangiHelper, _ChineseBaseHelper2);
		        var _super22 = _createSuper(DangiHelper);
		        function DangiHelper(){
		         var _this21;
		         _classCallCheck(this, DangiHelper);
		         _this21 = _super22.apply(this, arguments), _this21.id = "dangi";
		         return _this21;
		        }
		        return _createClass(DangiHelper);
		       }
		       (ChineseBaseHelper),
		    NonIsoCalendar =
		      function(){
		        function NonIsoCalendar(e){
		         _classCallCheck(this, NonIsoCalendar);
		         this.helper = e;
		        }
		        _createClass
		         (NonIsoCalendar,
		          [{key: "dateFromFields",
		            value:
		            function(e, t, r){
		             var
		              o = new OneObjectCache(),
		              n =
		                PrepareTemporalFields
		                 (e, this.fields(["day", "month", "monthCode", "year"]), []),
		              a = ToTemporalOverflow(t),
		              _this$helper$calendar = this.helper.calendarToIsoDate(n, a, o),
		              i = _this$helper$calendar.year,
		              s = _this$helper$calendar.month,
		              l = _this$helper$calendar.day,
		              d = CreateTemporalDate(i, s, l, r);
		             return o.setObject(d), d;
		            }},
		           {key: "yearMonthFromFields",
		            value:
		            function(e, t, r){
		             var
		              o = new OneObjectCache(),
		              n =
		                PrepareTemporalFields
		                 (e, this.fields(["month", "monthCode", "year"]), []),
		              a = ToTemporalOverflow(t),
		              _this$helper$calendar2 =
		                this.helper.calendarToIsoDate
		                 (_objectSpread2(_objectSpread2({}, n), {}, {day: 1}), a, o),
		              i = _this$helper$calendar2.year,
		              s = _this$helper$calendar2.month,
		              l = _this$helper$calendar2.day,
		              d = CreateTemporalYearMonth(i, s, r, l);
		             return o.setObject(d), d;
		            }},
		           {key: "monthDayFromFields",
		            value:
		            function(e, t, r){
		             var
		              o = new OneObjectCache(),
		              n =
		                PrepareTemporalFields
		                 (e, this.fields(["day", "month", "monthCode", "year"]), []),
		              a = ToTemporalOverflow(t),
		              _this$helper$monthDay = this.helper.monthDayFromFields(n, a, o),
		              i = _this$helper$monthDay.year,
		              s = _this$helper$monthDay.month,
		              l = _this$helper$monthDay.day,
		              d = CreateTemporalMonthDay(s, l, r, i);
		             return o.setObject(d), d;
		            }},
		           {key: "fields",
		            value:
		            function(e){
		             var t = e;
		             return Tt.call(t, "year")
		                    &&
		                     (t = [].concat(_toConsumableArray(t), ["era", "eraYear"])),
		                    t;
		            }},
		           {key: "fieldKeysToIgnore",
		            value:
		            function(e){
		             var t = new Dt();
		             for(var _r67 = 0; _r67 < e.length; _r67++){
		              var _o44 = e[_r67];
		              switch(Call(vt, t, [_o44]), _o44){
		                case "era":
		                 Call(vt, t, ["eraYear"]), Call(vt, t, ["year"]); break;
		                case "eraYear":
		                 Call(vt, t, ["era"]), Call(vt, t, ["year"]); break;
		                case "year":
		                 Call(vt, t, ["era"]), Call(vt, t, ["eraYear"]); break;
		                case "month":
		                 Call(vt, t, ["monthCode"]),
		                 this.helper.erasBeginMidYear
		                 && (Call(vt, t, ["era"]), Call(vt, t, ["eraYear"]));
		                 break;
		                case "monthCode":
		                 Call(vt, t, ["month"]),
		                 this.helper.erasBeginMidYear
		                 && (Call(vt, t, ["era"]), Call(vt, t, ["eraYear"]));
		                 break;
		                case "day":
		                 this.helper.erasBeginMidYear
		                 && (Call(vt, t, ["era"]), Call(vt, t, ["eraYear"]));
		              }
		             }
		             return _toConsumableArray(Call(Ct, t, []));
		            }},
		           {key: "dateAdd",
		            value:
		            function(e, t, r, o, n, a, i){
		             var
		              s = OneObjectCache.getCacheForObject(e),
		              l = this.helper.temporalToCalendarDate(e, s),
		              d =
		                this.helper.addCalendar
		                 (l, {years: t, months: r, weeks: o, days: n}, a, s),
		              m = this.helper.calendarToIsoDate(d, "constrain", s),
		              c = m.year,
		              h = m.month,
		              u = m.day,
		              T = CreateTemporalDate(c, h, u, i);
		             return new OneObjectCache(s).setObject(T), T;
		            }},
		           {key: "dateUntil",
		            value:
		            function(e, t, r){
		             var
		              o = OneObjectCache.getCacheForObject(e),
		              n = OneObjectCache.getCacheForObject(t),
		              a = this.helper.temporalToCalendarDate(e, o),
		              i = this.helper.temporalToCalendarDate(t, n);
		             return this.helper.untilCalendar(a, i, r, o);
		            }},
		           {key: "year",
		            value:
		            function(e){
		             var t = OneObjectCache.getCacheForObject(e);
		             return this.helper.temporalToCalendarDate(e, t).year;
		            }},
		           {key: "month",
		            value:
		            function(e){
		             var t = OneObjectCache.getCacheForObject(e);
		             return this.helper.temporalToCalendarDate(e, t).month;
		            }},
		           {key: "day",
		            value:
		            function(e){
		             var t = OneObjectCache.getCacheForObject(e);
		             return this.helper.temporalToCalendarDate(e, t).day;
		            }},
		           {key: "era",
		            value:
		            function(e){
		             if(! this.helper.hasEra) return;
		             var t = OneObjectCache.getCacheForObject(e);
		             return this.helper.temporalToCalendarDate(e, t).era;
		            }},
		           {key: "eraYear",
		            value:
		            function(e){
		             if(! this.helper.hasEra) return;
		             var t = OneObjectCache.getCacheForObject(e);
		             return this.helper.temporalToCalendarDate(e, t).eraYear;
		            }},
		           {key: "monthCode",
		            value:
		            function(e){
		             var t = OneObjectCache.getCacheForObject(e);
		             return this.helper.temporalToCalendarDate(e, t).monthCode;
		            }},
		           {key: "dayOfWeek",
		            value: function(e){return Ot.iso8601.dayOfWeek(e);}},
		           {key: "dayOfYear",
		            value:
		            function(e){
		             var
		              t = OneObjectCache.getCacheForObject(e),
		              r = this.helper.isoToCalendarDate(e, t),
		              o = this.helper.startOfCalendarYear(r);
		             return this.helper.calendarDaysUntil(o, r, t) + 1;
		            }},
		           {key: "weekOfYear",
		            value: function(e){return Ot.iso8601.weekOfYear(e);}},
		           {key: "yearOfWeek",
		            value: function(e){return Ot.iso8601.yearOfWeek(e);}},
		           {key: "daysInWeek",
		            value: function(e){return Ot.iso8601.daysInWeek(e);}},
		           {key: "daysInMonth",
		            value:
		            function(e){
		             var
		              t = OneObjectCache.getCacheForObject(e),
		              r = this.helper.temporalToCalendarDate(e, t),
		              o = this.helper.maximumMonthLength(r);
		             if(o === this.helper.minimumMonthLength(r)) return o;
		             var
		              n = this.helper.startOfCalendarMonth(r),
		              a = this.helper.addMonthsCalendar(n, 1, "constrain", t);
		             return this.helper.calendarDaysUntil(n, a, t);
		            }},
		           {key: "daysInYear",
		            value:
		            function(e){
		             var t = e;
		             HasSlot(t, i) || (t = ToTemporalDate(t));
		             var
		              r = OneObjectCache.getCacheForObject(t),
		              o = this.helper.temporalToCalendarDate(t, r),
		              n = this.helper.startOfCalendarYear(o),
		              a = this.helper.addCalendar(n, {years: 1}, "constrain", r);
		             return this.helper.calendarDaysUntil(n, a, r);
		            }},
		           {key: "monthsInYear",
		            value:
		            function(e){
		             var
		              t = OneObjectCache.getCacheForObject(e),
		              r = this.helper.temporalToCalendarDate(e, t);
		             return this.helper.monthsInYear(r, t);
		            }},
		           {key: "inLeapYear",
		            value:
		            function(e){
		             var t = e;
		             HasSlot(t, i) || (t = ToTemporalDate(t));
		             var
		              r = OneObjectCache.getCacheForObject(t),
		              o = this.helper.temporalToCalendarDate(t, r);
		             return this.helper.inLeapYear(o, r);
		            }}]);
		        return NonIsoCalendar;
		       }
		       ();
		   for
		   (var
		     _i21 = 0,
		     _arr7 =
		       [HebrewHelper,
		        PersianHelper,
		        EthiopicHelper,
		        EthioaaHelper,
		        CopticHelper,
		        ChineseHelper,
		        DangiHelper,
		        RocHelper,
		        IndianHelper,
		        BuddhistHelper,
		        GregoryHelper,
		        JapaneseHelper,
		        IslamicHelper,
		        IslamicUmalquraHelper,
		        IslamicTblaHelper,
		        IslamicCivilHelper,
		        IslamicRgsaHelper,
		        IslamicCcHelper];
		    _i21 < _arr7.length;
		    _i21++){
		    var _e53 = _arr7[_i21], _t49 = new _e53();
		    Ot[_t49.id] = new NonIsoCalendar(_t49);
		   }
		   var
		    PlainDate =
		      function(){
		        function PlainDate(e, t, r){
		         var
		          o =
		            arguments.length > 3 && arguments[3] !== undefined
		             ? arguments[3]
		             : "iso8601";
		         _classCallCheck(this, PlainDate);
		         CreateTemporalDateSlots
		          (this,
		           ToIntegerWithTruncation(e),
		           ToIntegerWithTruncation(t),
		           ToIntegerWithTruncation(r),
		           ToTemporalCalendarSlotValue(o));
		        }
		        _createClass
		         (PlainDate,
		          [{key: "calendarId",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarIdentifier(GetSlot(this, p));
		            }},
		           {key: "era",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEra(GetSlot(this, p), this);
		            }},
		           {key: "eraYear",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEraYear(GetSlot(this, p), this);
		            }},
		           {key: "year",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarYear(GetSlot(this, p), this);
		            }},
		           {key: "month",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonth(GetSlot(this, p), this);
		            }},
		           {key: "monthCode",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthCode(GetSlot(this, p), this);
		            }},
		           {key: "day",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDay(GetSlot(this, p), this);
		            }},
		           {key: "dayOfWeek",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDayOfWeek(GetSlot(this, p), this);
		            }},
		           {key: "dayOfYear",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDayOfYear(GetSlot(this, p), this);
		            }},
		           {key: "weekOfYear",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarWeekOfYear(GetSlot(this, p), this);
		            }},
		           {key: "yearOfWeek",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarYearOfWeek(GetSlot(this, p), this);
		            }},
		           {key: "daysInWeek",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInWeek(GetSlot(this, p), this);
		            }},
		           {key: "daysInMonth",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInMonth(GetSlot(this, p), this);
		            }},
		           {key: "daysInYear",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInYear(GetSlot(this, p), this);
		            }},
		           {key: "monthsInYear",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthsInYear(GetSlot(this, p), this);
		            }},
		           {key: "inLeapYear",
		            get:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return CalendarInLeapYear(GetSlot(this, p), this);
		            }},
		           {key: "with",
		            value:
		            function(e, t){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid argument");
		             RejectTemporalLikeObject(e);
		             var
		              r = GetOptionsObject(t),
		              o = GetSlot(this, p),
		              n = CalendarFields(o, ["day", "month", "monthCode", "year"]),
		              a = PrepareTemporalFields(this, n, []);
		             return a =
		                     CalendarMergeFields
		                      (o, a, PrepareTemporalFields(e, n, "partial")),
		                    a = PrepareTemporalFields(a, n, []),
		                    CalendarDateFromFields(o, a, r);
		            }},
		           {key: "withCalendar",
		            value:
		            function(e){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalCalendarSlotValue(e);
		             return new
		                     PlainDate
		                     (GetSlot(this, i), GetSlot(this, s), GetSlot(this, l), t);
		            }},
		           {key: "add",
		            value:
		            function(e, t){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var r = ToTemporalDuration(e), o = GetOptionsObject(t);
		             return CalendarDateAdd(GetSlot(this, p), this, r, o);
		            }},
		           {key: "subtract",
		            value:
		            function(e, t){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var
		              r = CreateNegatedTemporalDuration(ToTemporalDuration(e)),
		              o = GetOptionsObject(t);
		             return CalendarDateAdd(GetSlot(this, p), this, r, o);
		            }},
		           {key: "until",
		            value:
		            function(e, t){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainDate("until", this, e, t);
		            }},
		           {key: "since",
		            value:
		            function(e, t){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainDate("since", this, e, t);
		            }},
		           {key: "equals",
		            value:
		            function(e){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalDate(e);
		             for(var _i22 = 0, _arr8 = [i, s, l]; _i22 < _arr8.length; _i22++){
		              var _e54 = _arr8[_i22];
		              if(GetSlot(this, _e54) !== GetSlot(t, _e54)) return ! 1;
		             }
		             return CalendarEquals(GetSlot(this, p), GetSlot(t, p));
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDateToString
		                     (this, ToCalendarNameOption(GetOptionsObject(e)));
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDateToString(this);
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return new ht(e, t).format(this);
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new
		                    TypeError
		                    ("use compare() or equals() to compare Temporal.PlainDate");
		            }},
		           {key: "toPlainDateTime",
		            value:
		            function(e){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetSlot(this, i),
		              r = GetSlot(this, s),
		              o = GetSlot(this, l),
		              n = GetSlot(this, p);
		             if(void 0 === e)
		              return CreateTemporalDateTime(t, r, o, 0, 0, 0, 0, 0, 0, n);
		             var a = ToTemporalTime(e);
		             return CreateTemporalDateTime
		                     (t,
		                      r,
		                      o,
		                      GetSlot(a, d),
		                      GetSlot(a, m),
		                      GetSlot(a, c),
		                      GetSlot(a, h),
		                      GetSlot(a, u),
		                      GetSlot(a, T),
		                      n);
		            }},
		           {key: "toZonedDateTime",
		            value:
		            function(e){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var t, r;
		             if(IsObject(e))
		              if(IsTemporalTimeZone(e))
		               t = e;
		              else {
		               var _o45 = e.timeZone;
		               void 0 === _o45
		                ? t = ToTemporalTimeZoneSlotValue(e)
		                : (t = ToTemporalTimeZoneSlotValue(_o45), r = e.plainTime);
		              }
		             else
		              t = ToTemporalTimeZoneSlotValue(e);
		             var
		              o = GetSlot(this, i),
		              a = GetSlot(this, s),
		              f = GetSlot(this, l),
		              y = GetSlot(this, p),
		              I = 0,
		              S = 0,
		              g = 0,
		              w = 0,
		              D = 0,
		              G = 0;
		             void 0 !== r
		             &&
		              (r = ToTemporalTime(r),
		               I = GetSlot(r, d),
		               S = GetSlot(r, m),
		               g = GetSlot(r, c),
		               w = GetSlot(r, h),
		               D = GetSlot(r, u),
		               G = GetSlot(r, T));
		             return CreateTemporalZonedDateTime
		                     (GetSlot
		                       (GetInstantFor
		                         (t,
		                          CreateTemporalDateTime(o, a, f, I, S, g, w, D, G, y),
		                          "compatible"),
		                        n),
		                      t,
		                      y);
		            }},
		           {key: "toPlainYearMonth",
		            value:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var e = GetSlot(this, p);
		             return CalendarYearMonthFromFields
		                     (e,
		                      PrepareTemporalFields
		                       (this, CalendarFields(e, ["monthCode", "year"]), []));
		            }},
		           {key: "toPlainMonthDay",
		            value:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             var e = GetSlot(this, p);
		             return CalendarMonthDayFromFields
		                     (e,
		                      PrepareTemporalFields
		                       (this, CalendarFields(e, ["day", "monthCode"]), []));
		            }},
		           {key: "getISOFields",
		            value:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return {calendar: GetSlot(this, p),
		                     isoDay: GetSlot(this, l),
		                     isoMonth: GetSlot(this, s),
		                     isoYear: GetSlot(this, i)};
		            }},
		           {key: "getCalendar",
		            value:
		            function(){
		             if(! IsTemporalDate(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarObject(GetSlot(this, p));
		            }}],
		          [{key: "from",
		            value:
		            function(e, t){
		             var r = GetOptionsObject(t);
		             return IsTemporalDate(e)
		                     ? (ToTemporalOverflow
		                        (r),
		                       CreateTemporalDate
		                        (GetSlot(e, i), GetSlot(e, s), GetSlot(e, l), GetSlot(e, p)))
		                     : ToTemporalDate(e, r);
		            }},
		           {key: "compare",
		            value:
		            function(e, t){
		             var r = ToTemporalDate(e), o = ToTemporalDate(t);
		             return CompareISODate
		                     (GetSlot(r, i),
		                      GetSlot(r, s),
		                      GetSlot(r, l),
		                      GetSlot(o, i),
		                      GetSlot(o, s),
		                      GetSlot(o, l));
		            }}]);
		        return PlainDate;
		       }
		       ();
		   MakeIntrinsicClass(PlainDate, "Temporal.PlainDate");
		   var
		    PlainDateTime =
		      function(){
		        function PlainDateTime(e, t, r){
		         var
		          o =
		            arguments.length > 3 && arguments[3] !== undefined
		             ? arguments[3]
		             : 0,
		          n =
		            arguments.length > 4 && arguments[4] !== undefined
		             ? arguments[4]
		             : 0,
		          a =
		            arguments.length > 5 && arguments[5] !== undefined
		             ? arguments[5]
		             : 0,
		          i =
		            arguments.length > 6 && arguments[6] !== undefined
		             ? arguments[6]
		             : 0,
		          s =
		            arguments.length > 7 && arguments[7] !== undefined
		             ? arguments[7]
		             : 0,
		          l =
		            arguments.length > 8 && arguments[8] !== undefined
		             ? arguments[8]
		             : 0,
		          d =
		            arguments.length > 9 && arguments[9] !== undefined
		             ? arguments[9]
		             : "iso8601";
		         _classCallCheck(this, PlainDateTime);
		         CreateTemporalDateTimeSlots
		          (this,
		           ToIntegerWithTruncation(e),
		           ToIntegerWithTruncation(t),
		           ToIntegerWithTruncation(r),
		           void 0 === o ? 0 : ToIntegerWithTruncation(o),
		           void 0 === n ? 0 : ToIntegerWithTruncation(n),
		           void 0 === a ? 0 : ToIntegerWithTruncation(a),
		           void 0 === i ? 0 : ToIntegerWithTruncation(i),
		           void 0 === s ? 0 : ToIntegerWithTruncation(s),
		           void 0 === l ? 0 : ToIntegerWithTruncation(l),
		           ToTemporalCalendarSlotValue(d));
		        }
		        _createClass
		         (PlainDateTime,
		          [{key: "calendarId",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarIdentifier(GetSlot(this, p));
		            }},
		           {key: "year",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarYear(GetSlot(this, p), this);
		            }},
		           {key: "month",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonth(GetSlot(this, p), this);
		            }},
		           {key: "monthCode",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthCode(GetSlot(this, p), this);
		            }},
		           {key: "day",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDay(GetSlot(this, p), this);
		            }},
		           {key: "hour",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, d);
		            }},
		           {key: "minute",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, m);
		            }},
		           {key: "second",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, c);
		            }},
		           {key: "millisecond",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, h);
		            }},
		           {key: "microsecond",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, u);
		            }},
		           {key: "nanosecond",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, T);
		            }},
		           {key: "era",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEra(GetSlot(this, p), this);
		            }},
		           {key: "eraYear",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEraYear(GetSlot(this, p), this);
		            }},
		           {key: "dayOfWeek",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDayOfWeek(GetSlot(this, p), this);
		            }},
		           {key: "dayOfYear",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDayOfYear(GetSlot(this, p), this);
		            }},
		           {key: "weekOfYear",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarWeekOfYear(GetSlot(this, p), this);
		            }},
		           {key: "yearOfWeek",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarYearOfWeek(GetSlot(this, p), this);
		            }},
		           {key: "daysInWeek",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInWeek(GetSlot(this, p), this);
		            }},
		           {key: "daysInYear",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInYear(GetSlot(this, p), this);
		            }},
		           {key: "daysInMonth",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInMonth(GetSlot(this, p), this);
		            }},
		           {key: "monthsInYear",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthsInYear(GetSlot(this, p), this);
		            }},
		           {key: "inLeapYear",
		            get:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarInLeapYear(GetSlot(this, p), this);
		            }},
		           {key: "with",
		            value:
		            function(e, t){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid argument");
		             RejectTemporalLikeObject(e);
		             var
		              r = GetOptionsObject(t),
		              o = GetSlot(this, p),
		              n =
		                CalendarFields
		                 (o,
		                  ["day",
		                   "hour",
		                   "microsecond",
		                   "millisecond",
		                   "minute",
		                   "month",
		                   "monthCode",
		                   "nanosecond",
		                   "second",
		                   "year"]),
		              a = PrepareTemporalFields(this, n, []);
		             a =
		              CalendarMergeFields
		               (o, a, PrepareTemporalFields(e, n, "partial")),
		             a = PrepareTemporalFields(a, n, []);
		             var
		              _InterpretTemporalDat4 =
		                InterpretTemporalDateTimeFields(o, a, r),
		              i = _InterpretTemporalDat4.year,
		              s = _InterpretTemporalDat4.month,
		              l = _InterpretTemporalDat4.day,
		              d = _InterpretTemporalDat4.hour,
		              m = _InterpretTemporalDat4.minute,
		              c = _InterpretTemporalDat4.second,
		              h = _InterpretTemporalDat4.millisecond,
		              u = _InterpretTemporalDat4.microsecond,
		              T = _InterpretTemporalDat4.nanosecond;
		             return CreateTemporalDateTime(i, s, l, d, m, c, h, u, T, o);
		            }},
		           {key: "withPlainTime",
		            value:
		            function(e){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetSlot(this, i),
		              r = GetSlot(this, s),
		              o = GetSlot(this, l),
		              n = GetSlot(this, p);
		             if(void 0 === e)
		              return CreateTemporalDateTime(t, r, o, 0, 0, 0, 0, 0, 0, n);
		             var a = ToTemporalTime(e);
		             return CreateTemporalDateTime
		                     (t,
		                      r,
		                      o,
		                      GetSlot(a, d),
		                      GetSlot(a, m),
		                      GetSlot(a, c),
		                      GetSlot(a, h),
		                      GetSlot(a, u),
		                      GetSlot(a, T),
		                      n);
		            }},
		           {key: "withPlainDate",
		            value:
		            function(e){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = ToTemporalDate(e),
		              r = GetSlot(t, i),
		              o = GetSlot(t, s),
		              n = GetSlot(t, l),
		              a = GetSlot(t, p),
		              f = GetSlot(this, d),
		              y = GetSlot(this, m),
		              I = GetSlot(this, c),
		              S = GetSlot(this, h),
		              g = GetSlot(this, u),
		              w = GetSlot(this, T);
		             return a = ConsolidateCalendars(GetSlot(this, p), a),
		                    CreateTemporalDateTime(r, o, n, f, y, I, S, g, w, a);
		            }},
		           {key: "withCalendar",
		            value:
		            function(e){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalCalendarSlotValue(e);
		             return new
		                     PlainDateTime
		                     (GetSlot(this, i),
		                      GetSlot(this, s),
		                      GetSlot(this, l),
		                      GetSlot(this, d),
		                      GetSlot(this, m),
		                      GetSlot(this, c),
		                      GetSlot(this, h),
		                      GetSlot(this, u),
		                      GetSlot(this, T),
		                      t);
		            }},
		           {key: "add",
		            value:
		            function(e, t){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromPlainDateTime
		                     ("add", this, e, t);
		            }},
		           {key: "subtract",
		            value:
		            function(e, t){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromPlainDateTime
		                     ("subtract", this, e, t);
		            }},
		           {key: "until",
		            value:
		            function(e, t){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainDateTime("until", this, e, t);
		            }},
		           {key: "since",
		            value:
		            function(e, t){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainDateTime("since", this, e, t);
		            }},
		           {key: "round",
		            value:
		            function(e){
		             var _RoundISODateTime2;
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             if(void 0 === e)
		              throw new TypeError("options parameter is required");
		             var
		              t =
		                "string" == typeof e
		                 ? CreateOnePropObject("smallestUnit", e)
		                 : GetOptionsObject(e),
		              r = ToTemporalRoundingIncrement(t),
		              o = ToTemporalRoundingMode(t, "halfExpand"),
		              n = GetTemporalUnit(t, "smallestUnit", "time", He, ["day"]),
		              a =
		                {day: 1,
		                  hour: 24,
		                  minute: 60,
		                  second: 60,
		                  millisecond: 1e3,
		                  microsecond: 1e3,
		                  nanosecond: 1e3}
		                 [n];
		             ValidateTemporalRoundingIncrement(r, a, 1 === a);
		             var
		              f = GetSlot(this, i),
		              y = GetSlot(this, s),
		              I = GetSlot(this, l),
		              S = GetSlot(this, d),
		              g = GetSlot(this, m),
		              w = GetSlot(this, c),
		              D = GetSlot(this, h),
		              G = GetSlot(this, u),
		              v = GetSlot(this, T);
		             return _RoundISODateTime2 =
		                     RoundISODateTime(f, y, I, S, g, w, D, G, v, r, n, o),
		                    f = _RoundISODateTime2.year,
		                    y = _RoundISODateTime2.month,
		                    I = _RoundISODateTime2.day,
		                    S = _RoundISODateTime2.hour,
		                    g = _RoundISODateTime2.minute,
		                    w = _RoundISODateTime2.second,
		                    D = _RoundISODateTime2.millisecond,
		                    G = _RoundISODateTime2.microsecond,
		                    v = _RoundISODateTime2.nanosecond,
		                    CreateTemporalDateTime
		                     (f, y, I, S, g, w, D, G, v, GetSlot(this, p));
		            }},
		           {key: "equals",
		            value:
		            function(e){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalDateTime(e);
		             for
		             (var _i23 = 0, _arr9 = [i, s, l, d, m, c, h, u, T];
		              _i23 < _arr9.length;
		              _i23++){
		              var _e55 = _arr9[_i23];
		              if(GetSlot(this, _e55) !== GetSlot(t, _e55)) return ! 1;
		             }
		             return CalendarEquals(GetSlot(this, p), GetSlot(t, p));
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetOptionsObject(e),
		              r = ToCalendarNameOption(t),
		              o = ToFractionalSecondDigits(t),
		              n = ToTemporalRoundingMode(t, "trunc"),
		              a = GetTemporalUnit(t, "smallestUnit", "time", void 0);
		             if("hour" === a)
		              throw new
		                     RangeError
		                     ('smallestUnit must be a time unit other than "hour"');
		             var
		              _ToSecondsStringPreci2 = ToSecondsStringPrecisionRecord(a, o),
		              i = _ToSecondsStringPreci2.precision,
		              s = _ToSecondsStringPreci2.unit,
		              l = _ToSecondsStringPreci2.increment;
		             return TemporalDateTimeToString
		                     (this, i, r, {unit: s, increment: l, roundingMode: n});
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDateTimeToString(this, "auto");
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return new ht(e, t).format(this);
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new
		                    TypeError
		                    ("use compare() or equals() to compare Temporal.PlainDateTime");
		            }},
		           {key: "toZonedDateTime",
		            value:
		            function(e, t){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var r = ToTemporalTimeZoneSlotValue(e);
		             return CreateTemporalZonedDateTime
		                     (GetSlot
		                       (GetInstantFor
		                         (r, this, ToTemporalDisambiguation(GetOptionsObject(t))),
		                        n),
		                      r,
		                      GetSlot(this, p));
		            }},
		           {key: "toPlainDate",
		            value:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDateTimeToDate(this);
		            }},
		           {key: "toPlainYearMonth",
		            value:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var e = GetSlot(this, p);
		             return CalendarYearMonthFromFields
		                     (e,
		                      PrepareTemporalFields
		                       (this, CalendarFields(e, ["monthCode", "year"]), []));
		            }},
		           {key: "toPlainMonthDay",
		            value:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             var e = GetSlot(this, p);
		             return CalendarMonthDayFromFields
		                     (e,
		                      PrepareTemporalFields
		                       (this, CalendarFields(e, ["day", "monthCode"]), []));
		            }},
		           {key: "toPlainTime",
		            value:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDateTimeToTime(this);
		            }},
		           {key: "getISOFields",
		            value:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return {calendar: GetSlot(this, p),
		                     isoDay: GetSlot(this, l),
		                     isoHour: GetSlot(this, d),
		                     isoMicrosecond: GetSlot(this, u),
		                     isoMillisecond: GetSlot(this, h),
		                     isoMinute: GetSlot(this, m),
		                     isoMonth: GetSlot(this, s),
		                     isoNanosecond: GetSlot(this, T),
		                     isoSecond: GetSlot(this, c),
		                     isoYear: GetSlot(this, i)};
		            }},
		           {key: "getCalendar",
		            value:
		            function(){
		             if(! IsTemporalDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarObject(GetSlot(this, p));
		            }}],
		          [{key: "from",
		            value:
		            function(e, t){
		             var r = GetOptionsObject(t);
		             return IsTemporalDateTime(e)
		                     ? (ToTemporalOverflow
		                        (r),
		                       CreateTemporalDateTime
		                        (GetSlot(e, i),
		                         GetSlot(e, s),
		                         GetSlot(e, l),
		                         GetSlot(e, d),
		                         GetSlot(e, m),
		                         GetSlot(e, c),
		                         GetSlot(e, h),
		                         GetSlot(e, u),
		                         GetSlot(e, T),
		                         GetSlot(e, p)))
		                     : ToTemporalDateTime(e, r);
		            }},
		           {key: "compare",
		            value:
		            function(e, t){
		             var r = ToTemporalDateTime(e), o = ToTemporalDateTime(t);
		             for
		             (var _i24 = 0, _arr10 = [i, s, l, d, m, c, h, u, T];
		              _i24 < _arr10.length;
		              _i24++){
		              var
		               _e56 = _arr10[_i24],
		               _t50 = GetSlot(r, _e56),
		               _n27 = GetSlot(o, _e56);
		              if(_t50 !== _n27) return ComparisonResult(_t50 - _n27);
		             }
		             return 0;
		            }}]);
		        return PlainDateTime;
		       }
		       ();
		   MakeIntrinsicClass(PlainDateTime, "Temporal.PlainDateTime");
		   var
		    Duration =
		      function(){
		        function Duration(){
		         var
		          e =
		            arguments.length > 0 && arguments[0] !== undefined
		             ? arguments[0]
		             : 0,
		          t =
		            arguments.length > 1 && arguments[1] !== undefined
		             ? arguments[1]
		             : 0,
		          r =
		            arguments.length > 2 && arguments[2] !== undefined
		             ? arguments[2]
		             : 0,
		          o =
		            arguments.length > 3 && arguments[3] !== undefined
		             ? arguments[3]
		             : 0,
		          n =
		            arguments.length > 4 && arguments[4] !== undefined
		             ? arguments[4]
		             : 0,
		          a =
		            arguments.length > 5 && arguments[5] !== undefined
		             ? arguments[5]
		             : 0,
		          i =
		            arguments.length > 6 && arguments[6] !== undefined
		             ? arguments[6]
		             : 0,
		          s =
		            arguments.length > 7 && arguments[7] !== undefined
		             ? arguments[7]
		             : 0,
		          l =
		            arguments.length > 8 && arguments[8] !== undefined
		             ? arguments[8]
		             : 0,
		          d =
		            arguments.length > 9 && arguments[9] !== undefined
		             ? arguments[9]
		             : 0;
		         _classCallCheck(this, Duration);
		         var
		          m = void 0 === e ? 0 : ToIntegerIfIntegral(e),
		          c = void 0 === t ? 0 : ToIntegerIfIntegral(t),
		          h = void 0 === r ? 0 : ToIntegerIfIntegral(r),
		          u = void 0 === o ? 0 : ToIntegerIfIntegral(o),
		          T = void 0 === n ? 0 : ToIntegerIfIntegral(n),
		          p = void 0 === a ? 0 : ToIntegerIfIntegral(a),
		          f = void 0 === i ? 0 : ToIntegerIfIntegral(i),
		          y = void 0 === s ? 0 : ToIntegerIfIntegral(s),
		          I = void 0 === l ? 0 : ToIntegerIfIntegral(l),
		          S = void 0 === d ? 0 : ToIntegerIfIntegral(d);
		         RejectDuration(m, c, h, u, T, p, f, y, I, S),
		         N(this),
		         SetSlot(this, w, m),
		         SetSlot(this, D, c),
		         SetSlot(this, G, h),
		         SetSlot(this, v, u),
		         SetSlot(this, C, T),
		         SetSlot(this, O, p),
		         SetSlot(this, b, f),
		         SetSlot(this, E, y),
		         SetSlot(this, M, I),
		         SetSlot(this, R, S);
		        }
		        _createClass
		         (Duration,
		          [{key: "years",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, w);
		            }},
		           {key: "months",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, D);
		            }},
		           {key: "weeks",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, G);
		            }},
		           {key: "days",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, v);
		            }},
		           {key: "hours",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, C);
		            }},
		           {key: "minutes",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, O);
		            }},
		           {key: "seconds",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, b);
		            }},
		           {key: "milliseconds",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, E);
		            }},
		           {key: "microseconds",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, M);
		            }},
		           {key: "nanoseconds",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, R);
		            }},
		           {key: "sign",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return DurationSign
		                     (GetSlot(this, w),
		                      GetSlot(this, D),
		                      GetSlot(this, G),
		                      GetSlot(this, v),
		                      GetSlot(this, C),
		                      GetSlot(this, O),
		                      GetSlot(this, b),
		                      GetSlot(this, E),
		                      GetSlot(this, M),
		                      GetSlot(this, R));
		            }},
		           {key: "blank",
		            get:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return 0
		                    ===
		                     DurationSign
		                      (GetSlot(this, w),
		                       GetSlot(this, D),
		                       GetSlot(this, G),
		                       GetSlot(this, v),
		                       GetSlot(this, C),
		                       GetSlot(this, O),
		                       GetSlot(this, b),
		                       GetSlot(this, E),
		                       GetSlot(this, M),
		                       GetSlot(this, R));
		            }},
		           {key: "with",
		            value:
		            function(e){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             var
		              t =
		                PrepareTemporalFields
		                 (e,
		                  ["days",
		                   "hours",
		                   "microseconds",
		                   "milliseconds",
		                   "minutes",
		                   "months",
		                   "nanoseconds",
		                   "seconds",
		                   "weeks",
		                   "years"],
		                  "partial"),
		              _t$years = t.years,
		              r = _t$years === void 0 ? GetSlot(this, w) : _t$years,
		              _t$months = t.months,
		              o = _t$months === void 0 ? GetSlot(this, D) : _t$months,
		              _t$weeks = t.weeks,
		              n = _t$weeks === void 0 ? GetSlot(this, G) : _t$weeks,
		              _t$days = t.days,
		              a = _t$days === void 0 ? GetSlot(this, v) : _t$days,
		              _t$hours = t.hours,
		              i = _t$hours === void 0 ? GetSlot(this, C) : _t$hours,
		              _t$minutes = t.minutes,
		              s = _t$minutes === void 0 ? GetSlot(this, O) : _t$minutes,
		              _t$seconds = t.seconds,
		              l = _t$seconds === void 0 ? GetSlot(this, b) : _t$seconds,
		              _t$milliseconds = t.milliseconds,
		              d =
		                _t$milliseconds === void 0
		                 ? GetSlot(this, E)
		                 : _t$milliseconds,
		              _t$microseconds = t.microseconds,
		              m =
		                _t$microseconds === void 0
		                 ? GetSlot(this, M)
		                 : _t$microseconds,
		              _t$nanoseconds = t.nanoseconds,
		              c =
		                _t$nanoseconds === void 0 ? GetSlot(this, R) : _t$nanoseconds;
		             return new Duration(r, o, n, a, i, s, l, d, m, c);
		            }},
		           {key: "negated",
		            value:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return CreateNegatedTemporalDuration(this);
		            }},
		           {key: "abs",
		            value:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return new
		                     Duration
		                     (Math.abs(GetSlot(this, w)),
		                      Math.abs(GetSlot(this, D)),
		                      Math.abs(GetSlot(this, G)),
		                      Math.abs(GetSlot(this, v)),
		                      Math.abs(GetSlot(this, C)),
		                      Math.abs(GetSlot(this, O)),
		                      Math.abs(GetSlot(this, b)),
		                      Math.abs(GetSlot(this, E)),
		                      Math.abs(GetSlot(this, M)),
		                      Math.abs(GetSlot(this, R)));
		            }},
		           {key: "add",
		            value:
		            function(e, t){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromDuration
		                     ("add", this, e, t);
		            }},
		           {key: "subtract",
		            value:
		            function(e, t){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromDuration
		                     ("subtract", this, e, t);
		            }},
		           {key: "round",
		            value:
		            function(t){
		             var
		              _UnbalanceDurationRel,
		              _RoundDuration8,
		              _AdjustRoundedDuratio2,
		              _BalanceDuration11,
		              _BalanceDurationRelat;
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             if(void 0 === t)
		              throw new TypeError("options parameter is required");
		             var
		              r = GetSlot(this, w),
		              o = GetSlot(this, D),
		              n = GetSlot(this, G),
		              a = GetSlot(this, v),
		              i = GetSlot(this, C),
		              s = GetSlot(this, O),
		              l = GetSlot(this, b),
		              d = GetSlot(this, E),
		              m = GetSlot(this, M),
		              c = GetSlot(this, R),
		              h = DefaultTemporalLargestUnit(r, o, n, a, i, s, l, d, m, c),
		              u =
		                "string" == typeof t
		                 ? CreateOnePropObject("smallestUnit", t)
		                 : GetOptionsObject(t),
		              T =
		                GetTemporalUnit
		                 (u, "largestUnit", "datetime", void 0, ["auto"]),
		              f = ToRelativeTemporalObject(u),
		              y = ToTemporalRoundingIncrement(u),
		              I = ToTemporalRoundingMode(u, "halfExpand"),
		              S = GetTemporalUnit(u, "smallestUnit", "datetime", void 0),
		              g = ! 0;
		             S || (g = ! 1, S = "nanosecond"),
		             h = LargerOfTwoTemporalUnits(h, S);
		             var F = ! 0;
		             if(T || (F = ! 1, T = h), "auto" === T && (T = h), ! g && ! F)
		              throw new
		                     RangeError
		                     ("at least one of smallestUnit or largestUnit is required");
		             if(LargerOfTwoTemporalUnits(T, S) !== T)
		              throw new
		                     RangeError
		                     ("largestUnit ".concat
		                        (T, " cannot be smaller than smallestUnit ").concat
		                       (S));
		             var
		              Y =
		                {hour: 24,
		                  minute: 60,
		                  second: 60,
		                  millisecond: 1e3,
		                  microsecond: 1e3,
		                  nanosecond: 1e3}
		                 [S];
		             return void 0 !== Y
		                    && ValidateTemporalRoundingIncrement(y, Y, ! 1),
		                    _UnbalanceDurationRel =
		                     UnbalanceDurationRelative(r, o, n, a, T, f),
		                    r = _UnbalanceDurationRel.years,
		                    o = _UnbalanceDurationRel.months,
		                    n = _UnbalanceDurationRel.weeks,
		                    a = _UnbalanceDurationRel.days,
		                    _RoundDuration8 =
		                     RoundDuration(r, o, n, a, i, s, l, d, m, c, y, S, I, f),
		                    r = _RoundDuration8.years,
		                    o = _RoundDuration8.months,
		                    n = _RoundDuration8.weeks,
		                    a = _RoundDuration8.days,
		                    i = _RoundDuration8.hours,
		                    s = _RoundDuration8.minutes,
		                    l = _RoundDuration8.seconds,
		                    d = _RoundDuration8.milliseconds,
		                    m = _RoundDuration8.microseconds,
		                    c = _RoundDuration8.nanoseconds,
		                    _AdjustRoundedDuratio2 =
		                     AdjustRoundedDurationDays
		                      (r, o, n, a, i, s, l, d, m, c, y, S, I, f),
		                    r = _AdjustRoundedDuratio2.years,
		                    o = _AdjustRoundedDuratio2.months,
		                    n = _AdjustRoundedDuratio2.weeks,
		                    a = _AdjustRoundedDuratio2.days,
		                    i = _AdjustRoundedDuratio2.hours,
		                    s = _AdjustRoundedDuratio2.minutes,
		                    l = _AdjustRoundedDuratio2.seconds,
		                    d = _AdjustRoundedDuratio2.milliseconds,
		                    m = _AdjustRoundedDuratio2.microseconds,
		                    c = _AdjustRoundedDuratio2.nanoseconds,
		                    _BalanceDuration11 =
		                     BalanceDuration(a, i, s, l, d, m, c, T, f),
		                    a = _BalanceDuration11.days,
		                    i = _BalanceDuration11.hours,
		                    s = _BalanceDuration11.minutes,
		                    l = _BalanceDuration11.seconds,
		                    d = _BalanceDuration11.milliseconds,
		                    m = _BalanceDuration11.microseconds,
		                    c = _BalanceDuration11.nanoseconds,
		                    _BalanceDurationRelat =
		                     function(t, r, o, n, a, i){
		                       var
		                        s = GetIntrinsic("%Temporal.Duration%"),
		                        l = DurationSign(t, r, o, n, 0, 0, 0, 0, 0, 0);
		                       if(0 === l) return {years: t, months: r, weeks: o, days: n};
		                       var
		                        d = BigInt(l),
		                        m,
		                        c,
		                        h = BigInt(t),
		                        u = BigInt(r),
		                        T = BigInt(o),
		                        f = BigInt(n);
		                       i && (c = ToTemporalDate(i), m = GetSlot(c, p));
		                       var y = new s(l), I = new s(0, l), S = new s(0, 0, l);
		                       switch(a){
		                         case "year":
		                          {
		                           if(! m)
		                            throw new
		                                   RangeError
		                                   ("a starting point is required for years balancing");
		                           var
		                            _t51 =
		                              "string" != typeof m ? GetMethod(m, "dateAdd") : void 0,
		                            _r68,
		                            _o46,
		                            _n28;
		                           for
		                           (_MoveRelativeDate11 = MoveRelativeDate(m, c, y, _t51),
		                            _r68 = _MoveRelativeDate11.relativeTo,
		                            _o46 = _MoveRelativeDate11.days,
		                            _MoveRelativeDate11;
		                            abs(f) >= BigInt(ae(_o46));){
		                            var _MoveRelativeDate11, _MoveRelativeDate12;
		                            f = f - BigInt(_o46),
		                            h = h + d,
		                            c = _r68,
		                            _MoveRelativeDate12 = MoveRelativeDate(m, c, y, _t51),
		                            _r68 = _MoveRelativeDate12.relativeTo,
		                            _o46 = _MoveRelativeDate12.days;
		                           }
		                           for
		                           (_MoveRelativeDate13 = MoveRelativeDate(m, c, I, _t51),
		                            _r68 = _MoveRelativeDate13.relativeTo,
		                            _n28 = _MoveRelativeDate13.days,
		                            _MoveRelativeDate13;
		                            abs(f) >= BigInt(ae(_n28));){
		                            var _MoveRelativeDate13, _MoveRelativeDate14;
		                            f = f - BigInt(_n28),
		                            u = u + d,
		                            c = _r68,
		                            _MoveRelativeDate14 = MoveRelativeDate(m, c, I, _t51),
		                            _r68 = _MoveRelativeDate14.relativeTo,
		                            _n28 = _MoveRelativeDate14.days;
		                           }
		                           _r68 = CalendarDateAdd(m, c, y, void 0, _t51);
		                           var
		                            _a20 =
		                              "string" != typeof m ? GetMethod(m, "dateUntil") : void 0,
		                            _i25 = Te(null);
		                           _i25.largestUnit = "month";
		                           var
		                            _s8 = CalendarDateUntil(m, c, _r68, _i25, _a20),
		                            _l9 = GetSlot(_s8, D);
		                           for(; abs(u) >= BigInt(ae(_l9));){
		                            u = u - BigInt(_l9),
		                            h = h + d,
		                            c = _r68,
		                            _r68 = CalendarDateAdd(m, c, y, void 0, _t51);
		                            var _o47 = Te(null);
		                            _o47.largestUnit = "month",
		                            _s8 = CalendarDateUntil(m, c, _r68, _o47, _a20),
		                            _l9 = GetSlot(_s8, D);
		                           }
		                           break;
		                          }
		                         case "month":
		                          {
		                           if(! m)
		                            throw new
		                                   RangeError
		                                   ("a starting point is required for months balancing");
		                           var
		                            _t52 =
		                              "string" != typeof m ? GetMethod(m, "dateAdd") : void 0,
		                            _r69,
		                            _o48;
		                           for
		                           (_MoveRelativeDate15 = MoveRelativeDate(m, c, I, _t52),
		                            _r69 = _MoveRelativeDate15.relativeTo,
		                            _o48 = _MoveRelativeDate15.days,
		                            _MoveRelativeDate15;
		                            abs(f) >= BigInt(ae(_o48));){
		                            var _MoveRelativeDate15, _MoveRelativeDate16;
		                            f = f - BigInt(_o48),
		                            u = u + d,
		                            c = _r69,
		                            _MoveRelativeDate16 = MoveRelativeDate(m, c, I, _t52),
		                            _r69 = _MoveRelativeDate16.relativeTo,
		                            _o48 = _MoveRelativeDate16.days;
		                           }
		                           break;
		                          }
		                         case "week":
		                          {
		                           if(! m)
		                            throw new
		                                   RangeError
		                                   ("a starting point is required for weeks balancing");
		                           var
		                            _t53 =
		                              "string" != typeof m ? GetMethod(m, "dateAdd") : void 0,
		                            _r70,
		                            _o49;
		                           for
		                           (_MoveRelativeDate17 = MoveRelativeDate(m, c, S, _t53),
		                            _r70 = _MoveRelativeDate17.relativeTo,
		                            _o49 = _MoveRelativeDate17.days,
		                            _MoveRelativeDate17;
		                            abs(f) >= BigInt(ae(_o49));){
		                            var _MoveRelativeDate17, _MoveRelativeDate18;
		                            f = f - BigInt(_o49),
		                            T = T + d,
		                            c = _r70,
		                            _MoveRelativeDate18 = MoveRelativeDate(m, c, S, _t53),
		                            _r70 = _MoveRelativeDate18.relativeTo,
		                            _o49 = _MoveRelativeDate18.days;
		                           }
		                           break;
		                          }
		                       }
		                       return {years: Number(h),
		                               months: Number(u),
		                               weeks: Number(T),
		                               days: Number(f)};
		                      }
		                      (r, o, n, a, T, f),
		                    r = _BalanceDurationRelat.years,
		                    o = _BalanceDurationRelat.months,
		                    n = _BalanceDurationRelat.weeks,
		                    a = _BalanceDurationRelat.days,
		                    new Duration(r, o, n, a, i, s, l, d, m, c);
		            }},
		           {key: "total",
		            value:
		            function(e){
		             var _UnbalanceDurationRel2;
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetSlot(this, w),
		              r = GetSlot(this, D),
		              o = GetSlot(this, G),
		              n = GetSlot(this, v),
		              a = GetSlot(this, C),
		              i = GetSlot(this, O),
		              s = GetSlot(this, b),
		              l = GetSlot(this, E),
		              d = GetSlot(this, M),
		              m = GetSlot(this, R);
		             if(void 0 === e)
		              throw new TypeError("options argument is required");
		             var
		              c =
		                "string" == typeof e
		                 ? CreateOnePropObject("unit", e)
		                 : GetOptionsObject(e),
		              h = ToRelativeTemporalObject(c),
		              u = GetTemporalUnit(c, "unit", "datetime", He),
		              T;
		             _UnbalanceDurationRel2 =
		              UnbalanceDurationRelative(t, r, o, n, u, h),
		             t = _UnbalanceDurationRel2.years,
		             r = _UnbalanceDurationRel2.months,
		             o = _UnbalanceDurationRel2.weeks,
		             n = _UnbalanceDurationRel2.days,
		             IsTemporalZonedDateTime(h)
		             && (T = MoveRelativeZonedDateTime(h, t, r, o, 0));
		             var
		              p = BalancePossiblyInfiniteDuration(n, a, i, s, l, d, m, u, T);
		             if("positive overflow" === p) return 1 / 0;
		             if("negative overflow" === p) return - 1 / 0;
		             n = p.days;
		             a = p.hours;
		             i = p.minutes;
		             s = p.seconds;
		             l = p.milliseconds;
		             d = p.microseconds;
		             m = p.nanoseconds;
		             var
		              _RoundDuration9 =
		                RoundDuration(t, r, o, n, a, i, s, l, d, m, 1, u, "trunc", h),
		              f = _RoundDuration9.total;
		             return f;
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetOptionsObject(e),
		              r = ToFractionalSecondDigits(t),
		              o = ToTemporalRoundingMode(t, "trunc"),
		              n = GetTemporalUnit(t, "smallestUnit", "time", void 0);
		             if("hour" === n || "minute" === n)
		              throw new
		                     RangeError
		                     ('smallestUnit must be a time unit other than "hours" or "minutes"');
		             var
		              _ToSecondsStringPreci3 = ToSecondsStringPrecisionRecord(n, r),
		              a = _ToSecondsStringPreci3.precision,
		              i = _ToSecondsStringPreci3.unit,
		              s = _ToSecondsStringPreci3.increment;
		             return TemporalDurationToString
		                     (this, a, {unit: i, increment: s, roundingMode: o});
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDurationToString(this);
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalDuration(this))
		              throw new TypeError("invalid receiver");
		             return "undefined" != typeof Intl
		                     && void 0 !== Intl.DurationFormat
		                     ? new Intl.DurationFormat(e, t).format(this)
		                     : (console.warn
		                        ("Temporal.Duration.prototype.toLocaleString() requires Intl.DurationFormat."),
		                       TemporalDurationToString(this));
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new TypeError("use compare() to compare Temporal.Duration");
		            }}],
		          [{key: "from",
		            value:
		            function(e){
		             return IsTemporalDuration(e)
		                     ? new
		                       Duration
		                       (GetSlot(e, w),
		                        GetSlot(e, D),
		                        GetSlot(e, G),
		                        GetSlot(e, v),
		                        GetSlot(e, C),
		                        GetSlot(e, O),
		                        GetSlot(e, b),
		                        GetSlot(e, E),
		                        GetSlot(e, M),
		                        GetSlot(e, R))
		                     : ToTemporalDuration(e);
		            }},
		           {key: "compare",
		            value:
		            function(t, r, o){
		             var
		              _UnbalanceDurationRel3,
		              _UnbalanceDurationRel4,
		              n = ToTemporalDuration(t),
		              a = ToTemporalDuration(r),
		              i = ToRelativeTemporalObject(GetOptionsObject(o)),
		              s = GetSlot(n, w),
		              l = GetSlot(n, D),
		              d = GetSlot(n, G),
		              m = GetSlot(n, v),
		              c = GetSlot(n, C),
		              h = GetSlot(n, O),
		              u = GetSlot(n, b),
		              T = GetSlot(n, E),
		              p = GetSlot(n, M),
		              f = GetSlot(n, R),
		              y = GetSlot(a, w),
		              I = GetSlot(a, D),
		              S = GetSlot(a, G),
		              g = GetSlot(a, v),
		              F = GetSlot(a, C),
		              Y = GetSlot(a, O),
		              P = GetSlot(a, b),
		              Z = GetSlot(a, E),
		              B = GetSlot(a, M),
		              N = GetSlot(a, R),
		              j = CalculateOffsetShift(i, s, l, d, m),
		              $ = CalculateOffsetShift(i, y, I, S, g);
		             0 === s && 0 === y && 0 === l && 0 === I && 0 === d && 0 === S
		             ||
		              (_UnbalanceDurationRel3 =
		                UnbalanceDurationRelative(s, l, d, m, "day", i),
		               m = _UnbalanceDurationRel3.days,
		               _UnbalanceDurationRel4 =
		                UnbalanceDurationRelative(y, I, S, g, "day", i),
		               g = _UnbalanceDurationRel4.days);
		             var
		              k = TotalDurationNanoseconds(m, c, h, u, T, p, f, j),
		              U = TotalDurationNanoseconds(g, F, Y, P, Z, B, N, $);
		             return ComparisonResult(Number(k - U));
		            }}]);
		        return Duration;
		       }
		       ();
		   MakeIntrinsicClass(Duration, "Temporal.Duration");
		   var
		    bt = Object.create,
		    PlainMonthDay =
		      function(){
		        function PlainMonthDay(e, t){
		         var
		          r =
		            arguments.length > 2 && arguments[2] !== undefined
		             ? arguments[2]
		             : "iso8601",
		          o =
		            arguments.length > 3 && arguments[3] !== undefined
		             ? arguments[3]
		             : 1972;
		         _classCallCheck(this, PlainMonthDay);
		         CreateTemporalMonthDaySlots
		          (this,
		           ToIntegerWithTruncation(e),
		           ToIntegerWithTruncation(t),
		           ToTemporalCalendarSlotValue(r),
		           ToIntegerWithTruncation(o));
		        }
		        _createClass
		         (PlainMonthDay,
		          [{key: "monthCode",
		            get:
		            function(){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthCode(GetSlot(this, p), this);
		            }},
		           {key: "day",
		            get:
		            function(){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDay(GetSlot(this, p), this);
		            }},
		           {key: "calendarId",
		            get:
		            function(){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarIdentifier(GetSlot(this, p));
		            }},
		           {key: "with",
		            value:
		            function(e, t){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid argument");
		             RejectTemporalLikeObject(e);
		             var
		              r = GetOptionsObject(t),
		              o = GetSlot(this, p),
		              n = CalendarFields(o, ["day", "month", "monthCode", "year"]),
		              a = PrepareTemporalFields(this, n, []);
		             return a =
		                     CalendarMergeFields
		                      (o, a, PrepareTemporalFields(e, n, "partial")),
		                    a = PrepareTemporalFields(a, n, []),
		                    CalendarMonthDayFromFields(o, a, r);
		            }},
		           {key: "equals",
		            value:
		            function(e){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalMonthDay(e);
		             for
		             (var _i26 = 0, _arr11 = [s, l, i]; _i26 < _arr11.length; _i26++){
		              var _e57 = _arr11[_i26];
		              if(GetSlot(this, _e57) !== GetSlot(t, _e57)) return ! 1;
		             }
		             return CalendarEquals(GetSlot(this, p), GetSlot(t, p));
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return TemporalMonthDayToString
		                     (this, ToCalendarNameOption(GetOptionsObject(e)));
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return TemporalMonthDayToString(this);
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return new ht(e, t).format(this);
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new
		                    TypeError
		                    ("use equals() to compare Temporal.PlainMonthDay");
		            }},
		           {key: "toPlainDate",
		            value:
		            function(e){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e))
		              throw new TypeError("argument should be an object");
		             var
		              t = GetSlot(this, p),
		              r = CalendarFields(t, ["day", "monthCode"]),
		              o = PrepareTemporalFields(this, r, []),
		              n = CalendarFields(t, ["year"]),
		              a = CalendarMergeFields(t, o, PrepareTemporalFields(e, n, []));
		             a =
		              PrepareTemporalFields
		               (a,
		                _toConsumableArray
		                 (new
		                   Set
		                   ([].concat(_toConsumableArray(r), _toConsumableArray(n)))),
		                []);
		             var i = bt(null);
		             return i.overflow = "reject", CalendarDateFromFields(t, a, i);
		            }},
		           {key: "getISOFields",
		            value:
		            function(){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return {calendar: GetSlot(this, p),
		                     isoDay: GetSlot(this, l),
		                     isoMonth: GetSlot(this, s),
		                     isoYear: GetSlot(this, i)};
		            }},
		           {key: "getCalendar",
		            value:
		            function(){
		             if(! IsTemporalMonthDay(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarObject(GetSlot(this, p));
		            }}],
		          [{key: "from",
		            value:
		            function(e, t){
		             var r = GetOptionsObject(t);
		             return IsTemporalMonthDay(e)
		                     ? (ToTemporalOverflow
		                        (r),
		                       CreateTemporalMonthDay
		                        (GetSlot(e, s), GetSlot(e, l), GetSlot(e, p), GetSlot(e, i)))
		                     : ToTemporalMonthDay(e, r);
		            }}]);
		        return PlainMonthDay;
		       }
		       ();
		   MakeIntrinsicClass(PlainMonthDay, "Temporal.PlainMonthDay");
		   var
		    instant =
		      function(){return new (GetIntrinsic("%Temporal.Instant%"))(Ve());},
		    plainDateTime =
		      function(e){
		       var
		        t =
		          arguments.length > 1 && arguments[1] !== undefined
		           ? arguments[1]
		           : DefaultTimeZone(),
		        r = ToTemporalTimeZoneSlotValue(t),
		        o = ToTemporalCalendarSlotValue(e);
		       return GetPlainDateTimeFor(r, instant(), o);
		      },
		    plainDateTimeISO =
		      function(){
		       var
		        e =
		          arguments.length > 0 && arguments[0] !== undefined
		           ? arguments[0]
		           : DefaultTimeZone();
		       return GetPlainDateTimeFor
		               (ToTemporalTimeZoneSlotValue(e), instant(), "iso8601");
		      },
		    zonedDateTime =
		      function(e){
		       var
		        t =
		          arguments.length > 1 && arguments[1] !== undefined
		           ? arguments[1]
		           : DefaultTimeZone(),
		        r = ToTemporalTimeZoneSlotValue(t),
		        o = ToTemporalCalendarSlotValue(e);
		       return CreateTemporalZonedDateTime(Ve(), r, o);
		      },
		    Et =
		      _defineProperty
		       ({instant: instant,
		         plainDateTime: plainDateTime,
		         plainDateTimeISO: plainDateTimeISO,
		         plainDate:
		         function(e){
		          var
		           t =
		             arguments.length > 1 && arguments[1] !== undefined
		              ? arguments[1]
		              : DefaultTimeZone();
		          return TemporalDateTimeToDate(plainDateTime(e, t));
		         },
		         plainDateISO:
		         function(){
		          var
		           e =
		             arguments.length > 0 && arguments[0] !== undefined
		              ? arguments[0]
		              : DefaultTimeZone();
		          return TemporalDateTimeToDate(plainDateTimeISO(e));
		         },
		         plainTimeISO:
		         function(){
		          var
		           e =
		             arguments.length > 0 && arguments[0] !== undefined
		              ? arguments[0]
		              : DefaultTimeZone();
		          return TemporalDateTimeToTime(plainDateTimeISO(e));
		         },
		         timeZoneId: function(){return DefaultTimeZone();},
		         zonedDateTime: zonedDateTime,
		         zonedDateTimeISO:
		         function(){
		          var
		           e =
		             arguments.length > 0 && arguments[0] !== undefined
		              ? arguments[0]
		              : DefaultTimeZone();
		          return zonedDateTime("iso8601", e);
		         }},
		        Symbol.toStringTag,
		        "Temporal.Now");
		   Object.defineProperty
		    (Et,
		     Symbol.toStringTag,
		     {value: "Temporal.Now",
		      writable: ! 1,
		      enumerable: ! 1,
		      configurable: ! 0});
		   var Mt = Object.assign;
		   function TemporalTimeToString(e, t, r){
		    var
		     o = GetSlot(e, d),
		     n = GetSlot(e, m),
		     a = GetSlot(e, c),
		     i = GetSlot(e, h),
		     s = GetSlot(e, u),
		     l = GetSlot(e, T);
		    if(r){
		     var
		      _e58 = r.unit,
		      _t54 = r.increment,
		      _d12 = r.roundingMode,
		      _RoundTime2 = RoundTime(o, n, a, i, s, l, _t54, _e58, _d12);
		     o = _RoundTime2.hour;
		     n = _RoundTime2.minute;
		     a = _RoundTime2.second;
		     i = _RoundTime2.millisecond;
		     s = _RoundTime2.microsecond;
		     l = _RoundTime2.nanosecond;
		    }
		    return "".concat(ISODateTimePartString(o), ":").concat
		             (ISODateTimePartString(n)).concat
		            (FormatSecondsStringPart(a, i, s, l, t));
		   }
		   var
		    PlainTime =
		      function(){
		        function PlainTime(){
		         var
		          e =
		            arguments.length > 0 && arguments[0] !== undefined
		             ? arguments[0]
		             : 0,
		          t =
		            arguments.length > 1 && arguments[1] !== undefined
		             ? arguments[1]
		             : 0,
		          r =
		            arguments.length > 2 && arguments[2] !== undefined
		             ? arguments[2]
		             : 0,
		          o =
		            arguments.length > 3 && arguments[3] !== undefined
		             ? arguments[3]
		             : 0,
		          n =
		            arguments.length > 4 && arguments[4] !== undefined
		             ? arguments[4]
		             : 0,
		          a =
		            arguments.length > 5 && arguments[5] !== undefined
		             ? arguments[5]
		             : 0;
		         _classCallCheck(this, PlainTime);
		         var
		          i = void 0 === e ? 0 : ToIntegerWithTruncation(e),
		          s = void 0 === t ? 0 : ToIntegerWithTruncation(t),
		          l = void 0 === r ? 0 : ToIntegerWithTruncation(r),
		          p = void 0 === o ? 0 : ToIntegerWithTruncation(o),
		          f = void 0 === n ? 0 : ToIntegerWithTruncation(n),
		          y = void 0 === a ? 0 : ToIntegerWithTruncation(a);
		         RejectTime(i, s, l, p, f, y),
		         N(this),
		         SetSlot(this, d, i),
		         SetSlot(this, m, s),
		         SetSlot(this, c, l),
		         SetSlot(this, h, p),
		         SetSlot(this, u, f),
		         SetSlot(this, T, y);
		        }
		        _createClass
		         (PlainTime,
		          [{key: "hour",
		            get:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, d);
		            }},
		           {key: "minute",
		            get:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, m);
		            }},
		           {key: "second",
		            get:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, c);
		            }},
		           {key: "millisecond",
		            get:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, h);
		            }},
		           {key: "microsecond",
		            get:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, u);
		            }},
		           {key: "nanosecond",
		            get:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, T);
		            }},
		           {key: "with",
		            value:
		            function(e, t){
		             var _RegulateTime4;
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid argument");
		             RejectTemporalLikeObject(e);
		             var
		              r = ToTemporalOverflow(GetOptionsObject(t)),
		              o = ToTemporalTimeRecord(e, "partial"),
		              n = ToTemporalTimeRecord(this),
		              _Mt = Mt(n, o),
		              a = _Mt.hour,
		              i = _Mt.minute,
		              s = _Mt.second,
		              l = _Mt.millisecond,
		              d = _Mt.microsecond,
		              m = _Mt.nanosecond;
		             return _RegulateTime4 = RegulateTime(a, i, s, l, d, m, r),
		                    a = _RegulateTime4.hour,
		                    i = _RegulateTime4.minute,
		                    s = _RegulateTime4.second,
		                    l = _RegulateTime4.millisecond,
		                    d = _RegulateTime4.microsecond,
		                    m = _RegulateTime4.nanosecond,
		                    new PlainTime(a, i, s, l, d, m);
		            }},
		           {key: "add",
		            value:
		            function(e){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromPlainTime
		                     ("add", this, e);
		            }},
		           {key: "subtract",
		            value:
		            function(e){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromPlainTime
		                     ("subtract", this, e);
		            }},
		           {key: "until",
		            value:
		            function(e, t){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainTime("until", this, e, t);
		            }},
		           {key: "since",
		            value:
		            function(e, t){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainTime("since", this, e, t);
		            }},
		           {key: "round",
		            value:
		            function(e){
		             var _RoundTime3;
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             if(void 0 === e)
		              throw new TypeError("options parameter is required");
		             var
		              t =
		                "string" == typeof e
		                 ? CreateOnePropObject("smallestUnit", e)
		                 : GetOptionsObject(e),
		              r = ToTemporalRoundingIncrement(t),
		              o = ToTemporalRoundingMode(t, "halfExpand"),
		              n = GetTemporalUnit(t, "smallestUnit", "time", He);
		             ValidateTemporalRoundingIncrement
		              (r,
		               {hour: 24,
		                 minute: 60,
		                 second: 60,
		                 millisecond: 1e3,
		                 microsecond: 1e3,
		                 nanosecond: 1e3}
		                [n],
		               ! 1);
		             var
		              a = GetSlot(this, d),
		              i = GetSlot(this, m),
		              s = GetSlot(this, c),
		              l = GetSlot(this, h),
		              p = GetSlot(this, u),
		              f = GetSlot(this, T);
		             return _RoundTime3 = RoundTime(a, i, s, l, p, f, r, n, o),
		                    a = _RoundTime3.hour,
		                    i = _RoundTime3.minute,
		                    s = _RoundTime3.second,
		                    l = _RoundTime3.millisecond,
		                    p = _RoundTime3.microsecond,
		                    f = _RoundTime3.nanosecond,
		                    new PlainTime(a, i, s, l, p, f);
		            }},
		           {key: "equals",
		            value:
		            function(e){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalTime(e);
		             for
		             (var _i27 = 0, _arr12 = [d, m, c, h, u, T];
		              _i27 < _arr12.length;
		              _i27++){
		              var _e59 = _arr12[_i27];
		              if(GetSlot(this, _e59) !== GetSlot(t, _e59)) return ! 1;
		             }
		             return ! 0;
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetOptionsObject(e),
		              r = ToFractionalSecondDigits(t),
		              o = ToTemporalRoundingMode(t, "trunc"),
		              n = GetTemporalUnit(t, "smallestUnit", "time", void 0);
		             if("hour" === n)
		              throw new
		                     RangeError
		                     ('smallestUnit must be a time unit other than "hour"');
		             var
		              _ToSecondsStringPreci4 = ToSecondsStringPrecisionRecord(n, r),
		              a = _ToSecondsStringPreci4.precision,
		              i = _ToSecondsStringPreci4.unit,
		              s = _ToSecondsStringPreci4.increment;
		             return TemporalTimeToString
		                     (this, a, {unit: i, increment: s, roundingMode: o});
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return TemporalTimeToString(this, "auto");
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return new ht(e, t).format(this);
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new
		                    TypeError
		                    ("use compare() or equals() to compare Temporal.PlainTime");
		            }},
		           {key: "toPlainDateTime",
		            value:
		            function(e){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = ToTemporalDate(e),
		              r = GetSlot(t, i),
		              o = GetSlot(t, s),
		              n = GetSlot(t, l),
		              a = GetSlot(t, p);
		             return CreateTemporalDateTime
		                     (r,
		                      o,
		                      n,
		                      GetSlot(this, d),
		                      GetSlot(this, m),
		                      GetSlot(this, c),
		                      GetSlot(this, h),
		                      GetSlot(this, u),
		                      GetSlot(this, T),
		                      a);
		            }},
		           {key: "toZonedDateTime",
		            value:
		            function(e){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid argument");
		             var t = e.plainDate;
		             if(void 0 === t) throw new TypeError("missing date property");
		             var r = ToTemporalDate(t), o = e.timeZone;
		             if(void 0 === o)
		              throw new TypeError("missing timeZone property");
		             var
		              a = ToTemporalTimeZoneSlotValue(o),
		              f = GetSlot(r, i),
		              y = GetSlot(r, s),
		              I = GetSlot(r, l),
		              S = GetSlot(r, p),
		              g = GetSlot(this, d),
		              w = GetSlot(this, m),
		              D = GetSlot(this, c),
		              G = GetSlot(this, h),
		              v = GetSlot(this, u),
		              C = GetSlot(this, T);
		             return CreateTemporalZonedDateTime
		                     (GetSlot
		                       (GetInstantFor
		                         (a,
		                          new
		                           (GetIntrinsic("%Temporal.PlainDateTime%"))
		                           (f, y, I, g, w, D, G, v, C, S),
		                          "compatible"),
		                        n),
		                      a,
		                      S);
		            }},
		           {key: "getISOFields",
		            value:
		            function(){
		             if(! IsTemporalTime(this))
		              throw new TypeError("invalid receiver");
		             return {isoHour: GetSlot(this, d),
		                     isoMicrosecond: GetSlot(this, u),
		                     isoMillisecond: GetSlot(this, h),
		                     isoMinute: GetSlot(this, m),
		                     isoNanosecond: GetSlot(this, T),
		                     isoSecond: GetSlot(this, c)};
		            }}],
		          [{key: "from",
		            value:
		            function(e, t){
		             var r = ToTemporalOverflow(GetOptionsObject(t));
		             return IsTemporalTime(e)
		                     ? new
		                       PlainTime
		                       (GetSlot(e, d),
		                        GetSlot(e, m),
		                        GetSlot(e, c),
		                        GetSlot(e, h),
		                        GetSlot(e, u),
		                        GetSlot(e, T))
		                     : ToTemporalTime(e, r);
		            }},
		           {key: "compare",
		            value:
		            function(e, t){
		             var r = ToTemporalTime(e), o = ToTemporalTime(t);
		             for
		             (var _i28 = 0, _arr13 = [d, m, c, h, u, T];
		              _i28 < _arr13.length;
		              _i28++){
		              var
		               _e60 = _arr13[_i28],
		               _t55 = GetSlot(r, _e60),
		               _n29 = GetSlot(o, _e60);
		              if(_t55 !== _n29) return ComparisonResult(_t55 - _n29);
		             }
		             return 0;
		            }}]);
		        return PlainTime;
		       }
		       ();
		   MakeIntrinsicClass(PlainTime, "Temporal.PlainTime");
		   var
		    TimeZone =
		      function(){
		        function TimeZone(e){
		         _classCallCheck(this, TimeZone);
		         if(arguments.length < 1)
		          throw new RangeError("missing argument: identifier is required");
		         var t = GetCanonicalTimeZoneIdentifier(e);
		         N(this), SetSlot(this, a, t);
		        }
		        _createClass
		         (TimeZone,
		          [{key: "id",
		            get:
		            function(){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, a);
		            }},
		           {key: "getOffsetNanosecondsFor",
		            value:
		            function(e){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalInstant(e), r = GetSlot(this, a);
		             return IsTimeZoneOffsetString(r)
		                     ? ParseTimeZoneOffsetString(r)
		                     : GetNamedTimeZoneOffsetNanoseconds(r, GetSlot(t, n));
		            }},
		           {key: "getOffsetStringFor",
		            value:
		            function(e){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             return GetOffsetStringFor(this, ToTemporalInstant(e));
		            }},
		           {key: "getPlainDateTimeFor",
		            value:
		            function(e){
		             var
		              t =
		                arguments.length > 1 && arguments[1] !== undefined
		                 ? arguments[1]
		                 : "iso8601";
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             return GetPlainDateTimeFor
		                     (this, ToTemporalInstant(e), ToTemporalCalendarSlotValue(t));
		            }},
		           {key: "getInstantFor",
		            value:
		            function(e, t){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             return GetInstantFor
		                     (this,
		                      ToTemporalDateTime(e),
		                      ToTemporalDisambiguation(GetOptionsObject(t)));
		            }},
		           {key: "getPossibleInstantsFor",
		            value:
		            function(t){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             var
		              r = ToTemporalDateTime(t),
		              o = GetIntrinsic("%Temporal.Instant%"),
		              n = GetSlot(this, a);
		             if(IsTimeZoneOffsetString(n)){
		              var
		               _t56 =
		                 GetUTCEpochNanoseconds
		                  (GetSlot(r, i),
		                   GetSlot(r, s),
		                   GetSlot(r, l),
		                   GetSlot(r, d),
		                   GetSlot(r, m),
		                   GetSlot(r, c),
		                   GetSlot(r, h),
		                   GetSlot(r, u),
		                   GetSlot(r, T));
		              if(null === _t56)
		               throw new RangeError("DateTime outside of supported range");
		              var _a21 = ParseTimeZoneOffsetString(n);
		              return [new o(_t56 - BigInt(_a21))];
		             }
		             var
		              p =
		                function(t, r, o, n, a, i, s, l, d, m){
		                  var c = GetUTCEpochNanoseconds(r, o, n, a, i, s, l, d, m);
		                  if(null === c)
		                   throw new RangeError("DateTime outside of supported range");
		                  var h = c - Ee;
		                  h < Me && (h = c);
		                  var u = c + Ee;
		                  u > Re && (u = c);
		                  var
		                   T = GetNamedTimeZoneOffsetNanoseconds(t, h),
		                   p = GetNamedTimeZoneOffsetNanoseconds(t, u);
		                  return (T === p ? [T] : [T, p]).map
		                           (function(h){
		                             var
		                              u = c - BigInt(h),
		                              T = GetNamedTimeZoneDateTimeParts(t, u);
		                             if
		                              (r === T.year && o === T.month && n === T.day
		                               && a === T.hour
		                               && i === T.minute
		                               && s === T.second
		                               && l === T.millisecond
		                               && d === T.microsecond
		                               && m === T.nanosecond)
		                              return u;
		                            }).filter
		                          (function(e){return void 0 !== e;});
		                 }
		                 (n,
		                  GetSlot(r, i),
		                  GetSlot(r, s),
		                  GetSlot(r, l),
		                  GetSlot(r, d),
		                  GetSlot(r, m),
		                  GetSlot(r, c),
		                  GetSlot(r, h),
		                  GetSlot(r, u),
		                  GetSlot(r, T));
		             return p.map(function(e){return new o(e);});
		            }},
		           {key: "getNextTransition",
		            value:
		            function(e){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalInstant(e), r = GetSlot(this, a);
		             if(IsTimeZoneOffsetString(r) || "UTC" === r) return null;
		             var o = GetSlot(t, n), i = GetIntrinsic("%Temporal.Instant%");
		             return o = GetNamedTimeZoneNextTransition(r, o),
		                    null === o ? null : new i(o);
		            }},
		           {key: "getPreviousTransition",
		            value:
		            function(e){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalInstant(e), r = GetSlot(this, a);
		             if(IsTimeZoneOffsetString(r) || "UTC" === r) return null;
		             var o = GetSlot(t, n), i = GetIntrinsic("%Temporal.Instant%");
		             return o = GetNamedTimeZonePreviousTransition(r, o),
		                    null === o ? null : new i(o);
		            }},
		           {key: "toString",
		            value:
		            function(){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, a);
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalTimeZone(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(this, a);
		            }}],
		          [{key: "from",
		            value:
		            function(e){
		             return ToTemporalTimeZoneObject(ToTemporalTimeZoneSlotValue(e));
		            }}]);
		        return TimeZone;
		       }
		       ();
		   MakeIntrinsicClass(TimeZone, "Temporal.TimeZone"),
		   DefineIntrinsic
		    ("Temporal.TimeZone.prototype.getOffsetNanosecondsFor",
		     TimeZone.prototype.getOffsetNanosecondsFor),
		   DefineIntrinsic
		    ("Temporal.TimeZone.prototype.getPossibleInstantsFor",
		     TimeZone.prototype.getPossibleInstantsFor);
		   var
		    Rt = Object.create,
		    PlainYearMonth =
		      function(){
		        function PlainYearMonth(e, t){
		         var
		          r =
		            arguments.length > 2 && arguments[2] !== undefined
		             ? arguments[2]
		             : "iso8601",
		          o =
		            arguments.length > 3 && arguments[3] !== undefined
		             ? arguments[3]
		             : 1;
		         _classCallCheck(this, PlainYearMonth);
		         CreateTemporalYearMonthSlots
		          (this,
		           ToIntegerWithTruncation(e),
		           ToIntegerWithTruncation(t),
		           ToTemporalCalendarSlotValue(r),
		           ToIntegerWithTruncation(o));
		        }
		        _createClass
		         (PlainYearMonth,
		          [{key: "year",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarYear(GetSlot(this, p), this);
		            }},
		           {key: "month",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonth(GetSlot(this, p), this);
		            }},
		           {key: "monthCode",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthCode(GetSlot(this, p), this);
		            }},
		           {key: "calendarId",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarIdentifier(GetSlot(this, p));
		            }},
		           {key: "era",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEra(GetSlot(this, p), this);
		            }},
		           {key: "eraYear",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEraYear(GetSlot(this, p), this);
		            }},
		           {key: "daysInMonth",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInMonth(GetSlot(this, p), this);
		            }},
		           {key: "daysInYear",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInYear(GetSlot(this, p), this);
		            }},
		           {key: "monthsInYear",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthsInYear(GetSlot(this, p), this);
		            }},
		           {key: "inLeapYear",
		            get:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return CalendarInLeapYear(GetSlot(this, p), this);
		            }},
		           {key: "with",
		            value:
		            function(e, t){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e)) throw new TypeError("invalid argument");
		             RejectTemporalLikeObject(e);
		             var
		              r = GetOptionsObject(t),
		              o = GetSlot(this, p),
		              n = CalendarFields(o, ["month", "monthCode", "year"]),
		              a = PrepareTemporalFields(this, n, []);
		             return a =
		                     CalendarMergeFields
		                      (o, a, PrepareTemporalFields(e, n, "partial")),
		                    a = PrepareTemporalFields(a, n, []),
		                    CalendarYearMonthFromFields(o, a, r);
		            }},
		           {key: "add",
		            value:
		            function(e, t){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromPlainYearMonth
		                     ("add", this, e, t);
		            }},
		           {key: "subtract",
		            value:
		            function(e, t){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromPlainYearMonth
		                     ("subtract", this, e, t);
		            }},
		           {key: "until",
		            value:
		            function(e, t){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainYearMonth("until", this, e, t);
		            }},
		           {key: "since",
		            value:
		            function(e, t){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalPlainYearMonth("since", this, e, t);
		            }},
		           {key: "equals",
		            value:
		            function(e){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalYearMonth(e);
		             for
		             (var _i29 = 0, _arr14 = [i, s, l]; _i29 < _arr14.length; _i29++){
		              var _e61 = _arr14[_i29];
		              if(GetSlot(this, _e61) !== GetSlot(t, _e61)) return ! 1;
		             }
		             return CalendarEquals(GetSlot(this, p), GetSlot(t, p));
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return TemporalYearMonthToString
		                     (this, ToCalendarNameOption(GetOptionsObject(e)));
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return TemporalYearMonthToString(this);
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return new ht(e, t).format(this);
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new
		                    TypeError
		                    ("use compare() or equals() to compare Temporal.PlainYearMonth");
		            }},
		           {key: "toPlainDate",
		            value:
		            function(e){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e))
		              throw new TypeError("argument should be an object");
		             var
		              t = GetSlot(this, p),
		              r = CalendarFields(t, ["monthCode", "year"]),
		              o = PrepareTemporalFields(this, r, []),
		              n = CalendarFields(t, ["day"]),
		              a = CalendarMergeFields(t, o, PrepareTemporalFields(e, n, []));
		             a =
		              PrepareTemporalFields
		               (a,
		                _toConsumableArray
		                 (new
		                   Set
		                   ([].concat(_toConsumableArray(r), _toConsumableArray(n)))),
		                []);
		             var i = Rt(null);
		             return i.overflow = "reject", CalendarDateFromFields(t, a, i);
		            }},
		           {key: "getISOFields",
		            value:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return {calendar: GetSlot(this, p),
		                     isoDay: GetSlot(this, l),
		                     isoMonth: GetSlot(this, s),
		                     isoYear: GetSlot(this, i)};
		            }},
		           {key: "getCalendar",
		            value:
		            function(){
		             if(! IsTemporalYearMonth(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarObject(GetSlot(this, p));
		            }}],
		          [{key: "from",
		            value:
		            function(e, t){
		             var r = GetOptionsObject(t);
		             return IsTemporalYearMonth(e)
		                     ? (ToTemporalOverflow
		                        (r),
		                       CreateTemporalYearMonth
		                        (GetSlot(e, i), GetSlot(e, s), GetSlot(e, p), GetSlot(e, l)))
		                     : ToTemporalYearMonth(e, r);
		            }},
		           {key: "compare",
		            value:
		            function(e, t){
		             var r = ToTemporalYearMonth(e), o = ToTemporalYearMonth(t);
		             return CompareISODate
		                     (GetSlot(r, i),
		                      GetSlot(r, s),
		                      GetSlot(r, l),
		                      GetSlot(o, i),
		                      GetSlot(o, s),
		                      GetSlot(o, l));
		            }}]);
		        return PlainYearMonth;
		       }
		       ();
		   MakeIntrinsicClass(PlainYearMonth, "Temporal.PlainYearMonth");
		   var
		    Ft = ht.prototype.resolvedOptions,
		    Yt = Object.create,
		    ZonedDateTime =
		      function(){
		        function ZonedDateTime(e, t){
		         var
		          r =
		            arguments.length > 2 && arguments[2] !== undefined
		             ? arguments[2]
		             : "iso8601";
		         _classCallCheck(this, ZonedDateTime);
		         if(arguments.length < 1)
		          throw new
		                 TypeError
		                 ("missing argument: epochNanoseconds is required");
		         CreateTemporalZonedDateTimeSlots
		          (this,
		           ToBigInt(e),
		           ToTemporalTimeZoneSlotValue(t),
		           ToTemporalCalendarSlotValue(r));
		        }
		        _createClass
		         (ZonedDateTime,
		          [{key: "calendarId",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarIdentifier(GetSlot(this, p));
		            }},
		           {key: "timeZoneId",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalTimeZoneIdentifier(GetSlot(this, g));
		            }},
		           {key: "year",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarYear(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "month",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonth(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "monthCode",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthCode(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "day",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDay(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "hour",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(dateTime(this), d);
		            }},
		           {key: "minute",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(dateTime(this), m);
		            }},
		           {key: "second",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(dateTime(this), c);
		            }},
		           {key: "millisecond",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(dateTime(this), h);
		            }},
		           {key: "microsecond",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(dateTime(this), u);
		            }},
		           {key: "nanosecond",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetSlot(dateTime(this), T);
		            }},
		           {key: "era",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEra(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "eraYear",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarEraYear(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "epochSeconds",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var t = GetSlot(this, n);
		             return Number(BigIntFloorDiv(t, ve));
		            }},
		           {key: "epochMilliseconds",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var t = GetSlot(this, n);
		             return Number(BigIntFloorDiv(t, Ge));
		            }},
		           {key: "epochMicroseconds",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToBigIntExternal(BigIntFloorDiv(GetSlot(this, n), De));
		            }},
		           {key: "epochNanoseconds",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToBigIntExternal(GetSlot(this, n));
		            }},
		           {key: "dayOfWeek",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDayOfWeek(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "dayOfYear",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDayOfYear(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "weekOfYear",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarWeekOfYear(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "yearOfWeek",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarYearOfWeek(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "hoursInDay",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = dateTime(this),
		              r = GetIntrinsic("%Temporal.PlainDateTime%"),
		              o = GetSlot(t, i),
		              a = GetSlot(t, s),
		              d = GetSlot(t, l),
		              m = new r(o, a, d, 0, 0, 0, 0, 0, 0),
		              c = AddISODate(o, a, d, 0, 0, 0, 1, "reject"),
		              h = new r(c.year, c.month, c.day, 0, 0, 0, 0, 0, 0),
		              u = GetSlot(this, g),
		              T = GetSlot(GetInstantFor(u, m, "compatible"), n),
		              p = GetSlot(GetInstantFor(u, h, "compatible"), n);
		             return BigIntDivideToNumber(p - T, Oe);
		            }},
		           {key: "daysInWeek",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInWeek(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "daysInMonth",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInMonth(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "daysInYear",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarDaysInYear(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "monthsInYear",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarMonthsInYear(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "inLeapYear",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return CalendarInLeapYear(GetSlot(this, p), dateTime(this));
		            }},
		           {key: "offset",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetOffsetStringFor(GetSlot(this, g), GetSlot(this, S));
		            }},
		           {key: "offsetNanoseconds",
		            get:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return GetOffsetNanosecondsFor
		                     (GetSlot(this, g), GetSlot(this, S));
		            }},
		           {key: "with",
		            value:
		            function(e, t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             if(! IsObject(e))
		              throw new TypeError("invalid zoned-date-time-like");
		             RejectTemporalLikeObject(e);
		             var
		              r = GetOptionsObject(t),
		              o = GetSlot(this, p),
		              n =
		                CalendarFields
		                 (o,
		                  ["day",
		                   "hour",
		                   "microsecond",
		                   "millisecond",
		                   "minute",
		                   "month",
		                   "monthCode",
		                   "nanosecond",
		                   "second",
		                   "year"]);
		             n.push("offset");
		             var a = PrepareTemporalFields(this, n, ["offset"]);
		             a =
		              CalendarMergeFields
		               (o, a, PrepareTemporalFields(e, n, "partial")),
		             a = PrepareTemporalFields(a, n, ["offset"]);
		             var
		              i = ToTemporalDisambiguation(r),
		              s = ToTemporalOffset(r, "prefer"),
		              _InterpretTemporalDat5 =
		                InterpretTemporalDateTimeFields(o, a, r),
		              l = _InterpretTemporalDat5.year,
		              d = _InterpretTemporalDat5.month,
		              m = _InterpretTemporalDat5.day,
		              c = _InterpretTemporalDat5.hour,
		              h = _InterpretTemporalDat5.minute,
		              u = _InterpretTemporalDat5.second,
		              T = _InterpretTemporalDat5.millisecond,
		              f = _InterpretTemporalDat5.microsecond,
		              y = _InterpretTemporalDat5.nanosecond,
		              I = ParseTimeZoneOffsetString(a.offset),
		              S = GetSlot(this, g);
		             return CreateTemporalZonedDateTime
		                     (InterpretISODateTimeOffset
		                       (l, d, m, c, h, u, T, f, y, "option", I, S, i, s, ! 1),
		                      S,
		                      o);
		            }},
		           {key: "withPlainDate",
		            value:
		            function(e){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = ToTemporalDate(e),
		              r = GetSlot(t, i),
		              o = GetSlot(t, s),
		              a = GetSlot(t, l),
		              f = GetSlot(t, p),
		              y = dateTime(this),
		              I = GetSlot(y, d),
		              S = GetSlot(y, m),
		              w = GetSlot(y, c),
		              D = GetSlot(y, h),
		              G = GetSlot(y, u),
		              v = GetSlot(y, T);
		             f = ConsolidateCalendars(GetSlot(this, p), f);
		             var C = GetSlot(this, g);
		             return CreateTemporalZonedDateTime
		                     (GetSlot
		                       (GetInstantFor
		                         (C,
		                          new
		                           (GetIntrinsic("%Temporal.PlainDateTime%"))
		                           (r, o, a, I, S, w, D, G, v, f),
		                          "compatible"),
		                        n),
		                      C,
		                      f);
		            }},
		           {key: "withPlainTime",
		            value:
		            function(e){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetIntrinsic("%Temporal.PlainTime%"),
		              r = void 0 === e ? new t() : ToTemporalTime(e),
		              o = dateTime(this),
		              a = GetSlot(o, i),
		              f = GetSlot(o, s),
		              y = GetSlot(o, l),
		              I = GetSlot(this, p),
		              S = GetSlot(r, d),
		              w = GetSlot(r, m),
		              D = GetSlot(r, c),
		              G = GetSlot(r, h),
		              v = GetSlot(r, u),
		              C = GetSlot(r, T),
		              O = GetSlot(this, g);
		             return CreateTemporalZonedDateTime
		                     (GetSlot
		                       (GetInstantFor
		                         (O,
		                          new
		                           (GetIntrinsic("%Temporal.PlainDateTime%"))
		                           (a, f, y, S, w, D, G, v, C, I),
		                          "compatible"),
		                        n),
		                      O,
		                      I);
		            }},
		           {key: "withTimeZone",
		            value:
		            function(e){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalTimeZoneSlotValue(e);
		             return CreateTemporalZonedDateTime
		                     (GetSlot(this, n), t, GetSlot(this, p));
		            }},
		           {key: "withCalendar",
		            value:
		            function(e){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var t = ToTemporalCalendarSlotValue(e);
		             return CreateTemporalZonedDateTime
		                     (GetSlot(this, n), GetSlot(this, g), t);
		            }},
		           {key: "add",
		            value:
		            function(e, t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromZonedDateTime
		                     ("add", this, e, t);
		            }},
		           {key: "subtract",
		            value:
		            function(e, t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return AddDurationToOrSubtractDurationFromZonedDateTime
		                     ("subtract", this, e, t);
		            }},
		           {key: "until",
		            value:
		            function(e, t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalZonedDateTime("until", this, e, t);
		            }},
		           {key: "since",
		            value:
		            function(e, t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return DifferenceTemporalZonedDateTime("since", this, e, t);
		            }},
		           {key: "round",
		            value:
		            function(t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             if(void 0 === t)
		              throw new TypeError("options parameter is required");
		             var
		              r =
		                "string" == typeof t
		                 ? CreateOnePropObject("smallestUnit", t)
		                 : GetOptionsObject(t),
		              o = ToTemporalRoundingIncrement(r),
		              a = ToTemporalRoundingMode(r, "halfExpand"),
		              f = GetTemporalUnit(r, "smallestUnit", "time", He, ["day"]),
		              y =
		                {day: 1,
		                  hour: 24,
		                  minute: 60,
		                  second: 60,
		                  millisecond: 1e3,
		                  microsecond: 1e3,
		                  nanosecond: 1e3}
		                 [f];
		             ValidateTemporalRoundingIncrement(o, y, 1 === y);
		             var
		              I = dateTime(this),
		              w = GetSlot(I, i),
		              D = GetSlot(I, s),
		              G = GetSlot(I, l),
		              v = GetSlot(I, d),
		              C = GetSlot(I, m),
		              O = GetSlot(I, c),
		              b = GetSlot(I, h),
		              E = GetSlot(I, u),
		              M = GetSlot(I, T),
		              R = GetIntrinsic("%Temporal.PlainDateTime%"),
		              F = GetSlot(this, g),
		              Y = GetSlot(this, p),
		              P =
		                GetInstantFor
		                 (F,
		                  new
		                   R
		                   (GetSlot(I, i),
		                    GetSlot(I, s),
		                    GetSlot(I, l),
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0),
		                  "compatible"),
		              Z = AddZonedDateTime(P, F, Y, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0),
		              B = Z - BigInt(GetSlot(P, n));
		             if(B <= Ie)
		              throw new
		                     RangeError
		                     ("cannot round a ZonedDateTime in a calendar with zero or negative length days");
		             var
		              _RoundISODateTime3 =
		                RoundISODateTime
		                 (w, D, G, v, C, O, b, E, M, o, f, a, Number(B));
		             w = _RoundISODateTime3.year;
		             D = _RoundISODateTime3.month;
		             G = _RoundISODateTime3.day;
		             v = _RoundISODateTime3.hour;
		             C = _RoundISODateTime3.minute;
		             O = _RoundISODateTime3.second;
		             b = _RoundISODateTime3.millisecond;
		             E = _RoundISODateTime3.microsecond;
		             M = _RoundISODateTime3.nanosecond;
		             return CreateTemporalZonedDateTime
		                     (InterpretISODateTimeOffset
		                       (w,
		                        D,
		                        G,
		                        v,
		                        C,
		                        O,
		                        b,
		                        E,
		                        M,
		                        "option",
		                        GetOffsetNanosecondsFor(F, GetSlot(this, S)),
		                        F,
		                        "compatible",
		                        "prefer",
		                        ! 1),
		                      F,
		                      GetSlot(this, p));
		            }},
		           {key: "equals",
		            value:
		            function(t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              r = ToTemporalZonedDateTime(t),
		              o = GetSlot(this, n),
		              a = GetSlot(r, n);
		             return !
		                    !
		                    (BigInt(o) === BigInt(a))
		                    && ! ! TimeZoneEquals(GetSlot(this, g), GetSlot(r, g))
		                    && CalendarEquals(GetSlot(this, p), GetSlot(r, p));
		            }},
		           {key: "toString",
		            value:
		            function(e){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              t = GetOptionsObject(e),
		              r = ToCalendarNameOption(t),
		              o = ToFractionalSecondDigits(t),
		              n =
		                function(e){
		                  return GetOption(e, "offset", ["auto", "never"], "auto");
		                 }
		                 (t),
		              a = ToTemporalRoundingMode(t, "trunc"),
		              i = GetTemporalUnit(t, "smallestUnit", "time", void 0);
		             if("hour" === i)
		              throw new
		                     RangeError
		                     ('smallestUnit must be a time unit other than "hour"');
		             var
		              s =
		                function(e){
		                  return GetOption
		                          (e, "timeZoneName", ["auto", "never", "critical"], "auto");
		                 }
		                 (t),
		              _ToSecondsStringPreci5 = ToSecondsStringPrecisionRecord(i, o),
		              l = _ToSecondsStringPreci5.precision,
		              d = _ToSecondsStringPreci5.unit,
		              m = _ToSecondsStringPreci5.increment;
		             return TemporalZonedDateTimeToString
		                     (this, l, r, s, n, {unit: d, increment: m, roundingMode: a});
		            }},
		           {key: "toLocaleString",
		            value:
		            function(e, t){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var r = GetOptionsObject(t), o = Yt(null);
		             if(CopyDataProperties(o, r, ["timeZone"]), void 0 !== r.timeZone)
		              throw new
		                     TypeError
		                     ("ZonedDateTime toLocaleString does not accept a timeZone option");
		             void 0 === o.year && void 0 === o.month && void 0 === o.day
		             && void 0 === o.weekday
		             && void 0 === o.dateStyle
		             && void 0 === o.hour
		             && void 0 === o.minute
		             && void 0 === o.second
		             && void 0 === o.timeStyle
		             && void 0 === o.dayPeriod
		             && void 0 === o.timeZoneName
		             && (o.timeZoneName = "short");
		             var n = ToTemporalTimeZoneIdentifier(GetSlot(this, g));
		             if(IsTimeZoneOffsetString(n))
		              throw new
		                     RangeError
		                     ("toLocaleString does not support offset string time zones");
		             n = GetCanonicalTimeZoneIdentifier(n), o.timeZone = n;
		             var
		              a = new ht(e, o),
		              i = Call(Ft, a, []).calendar,
		              s = ToTemporalCalendarIdentifier(GetSlot(this, p));
		             if("iso8601" !== s && "iso8601" !== i && i !== s)
		              throw new
		                     RangeError
		                     ("cannot format ZonedDateTime with calendar ".concat
		                        (s, " in locale with calendar ").concat
		                       (i));
		             return a.format(GetSlot(this, S));
		            }},
		           {key: "toJSON",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return TemporalZonedDateTimeToString(this, "auto");
		            }},
		           {key: "valueOf",
		            value:
		            function(){
		             throw new
		                    TypeError
		                    ("use compare() or equals() to compare Temporal.ZonedDateTime");
		            }},
		           {key: "startOfDay",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var
		              e = dateTime(this),
		              t = GetIntrinsic("%Temporal.PlainDateTime%"),
		              r = GetSlot(this, p),
		              o =
		                new
		                 t
		                 (GetSlot(e, i),
		                  GetSlot(e, s),
		                  GetSlot(e, l),
		                  0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  r),
		              a = GetSlot(this, g);
		             return CreateTemporalZonedDateTime
		                     (GetSlot(GetInstantFor(a, o, "compatible"), n), a, r);
		            }},
		           {key: "toInstant",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return new (GetIntrinsic("%Temporal.Instant%"))(GetSlot(this, n));
		            }},
		           {key: "toPlainDate",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDateTimeToDate(dateTime(this));
		            }},
		           {key: "toPlainTime",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return TemporalDateTimeToTime(dateTime(this));
		            }},
		           {key: "toPlainDateTime",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return dateTime(this);
		            }},
		           {key: "toPlainYearMonth",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var e = GetSlot(this, p);
		             return CalendarYearMonthFromFields
		                     (e,
		                      PrepareTemporalFields
		                       (this, CalendarFields(e, ["monthCode", "year"]), []));
		            }},
		           {key: "toPlainMonthDay",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var e = GetSlot(this, p);
		             return CalendarMonthDayFromFields
		                     (e,
		                      PrepareTemporalFields
		                       (this, CalendarFields(e, ["day", "monthCode"]), []));
		            }},
		           {key: "getISOFields",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             var e = dateTime(this), t = GetSlot(this, g);
		             return {calendar: GetSlot(this, p),
		                     isoDay: GetSlot(e, l),
		                     isoHour: GetSlot(e, d),
		                     isoMicrosecond: GetSlot(e, u),
		                     isoMillisecond: GetSlot(e, h),
		                     isoMinute: GetSlot(e, m),
		                     isoMonth: GetSlot(e, s),
		                     isoNanosecond: GetSlot(e, T),
		                     isoSecond: GetSlot(e, c),
		                     isoYear: GetSlot(e, i),
		                     offset: GetOffsetStringFor(t, GetSlot(this, S)),
		                     timeZone: t};
		            }},
		           {key: "getCalendar",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalCalendarObject(GetSlot(this, p));
		            }},
		           {key: "getTimeZone",
		            value:
		            function(){
		             if(! IsTemporalZonedDateTime(this))
		              throw new TypeError("invalid receiver");
		             return ToTemporalTimeZoneObject(GetSlot(this, g));
		            }}],
		          [{key: "from",
		            value:
		            function(e, t){
		             var r = GetOptionsObject(t);
		             return IsTemporalZonedDateTime(e)
		                     ? (ToTemporalDisambiguation
		                        (r),
		                       ToTemporalOffset(r, "reject"),
		                       ToTemporalOverflow(r),
		                       CreateTemporalZonedDateTime
		                        (GetSlot(e, n), GetSlot(e, g), GetSlot(e, p)))
		                     : ToTemporalZonedDateTime(e, r);
		            }},
		           {key: "compare",
		            value:
		            function(t, r){
		             var
		              o = ToTemporalZonedDateTime(t),
		              a = ToTemporalZonedDateTime(r),
		              i = GetSlot(o, n),
		              s = GetSlot(a, n);
		             return BigInt(i) < BigInt(s)
		                     ? - 1
		                     : BigInt(i) > BigInt(s) ? 1 : 0;
		            }}]);
		        return ZonedDateTime;
		       }
		       ();
		   function dateTime(e){
		    return GetPlainDateTimeFor(GetSlot(e, g), GetSlot(e, S), GetSlot(e, p));
		   }
		   MakeIntrinsicClass(ZonedDateTime, "Temporal.ZonedDateTime");
		   var
		    Pt =
		      Object.freeze
		       ({__proto__: null,
		         Calendar: Calendar,
		         Duration: Duration,
		         Instant: Instant,
		         Now: Et,
		         PlainDate: PlainDate,
		         PlainDateTime: PlainDateTime,
		         PlainMonthDay: PlainMonthDay,
		         PlainTime: PlainTime,
		         PlainYearMonth: PlainYearMonth,
		         TimeZone: TimeZone,
		         ZonedDateTime: ZonedDateTime});
		   function toTemporalInstant(){
		    var t = BigInt(+ this) * Ge;
		    return new Instant(t);
		   }
		   var
		    Zt =
		      [Instant,
		       Calendar,
		       PlainDate,
		       PlainDateTime,
		       Duration,
		       PlainMonthDay,
		       PlainTime,
		       TimeZone,
		       PlainYearMonth,
		       ZonedDateTime];
		   for(var _i30 = 0, _Zt = Zt; _i30 < _Zt.length; _i30++){
		    var
		     _e62 = _Zt[_i30],
		     _t57 = Object.getOwnPropertyDescriptor(_e62, "prototype");
		    (_t57.configurable || _t57.enumerable || _t57.writable)
		    &&
		     (_t57.configurable = ! 1,
		      _t57.enumerable = ! 1,
		      _t57.writable = ! 1,
		      Object.defineProperty(_e62, "prototype", _t57));
		   }
		   var
		    TemporalPolyfill =
		      Object.freeze
		       ({__proto__: null,
		         Intl: ut,
		         Temporal: Pt,
		         toTemporalInstant: toTemporalInstant});
		   globalThis.TemporalPolyfill = TemporalPolyfill;
		  }
		  (globalThis));
		(function(globalThis){
		   var
		    jsoo_exports = module.exports || globalThis;
		   function caml_is_continuation_tag(t){return t === 245 ? 1 : 0;}
		   function caml_mul(a, b){return Math.imul(a, b);}
		   function caml_hash_mix_int(h, d){
		    d = caml_mul(d, 0xcc9e2d51 | 0);
		    d = d << 15 | d >>> 32 - 15;
		    d = caml_mul(d, 0x1b873593);
		    h ^= d;
		    h = h << 13 | h >>> 32 - 13;
		    return (h + (h << 2) | 0) + (0xe6546b64 | 0) | 0;
		   }
		   function caml_hash_mix_jsbytes(h, s){
		    var len = s.length, i, w;
		    for(i = 0; i + 4 <= len; i += 4){
		     w =
		      s.charCodeAt(i) | s.charCodeAt(i + 1) << 8 | s.charCodeAt(i + 2) << 16
		      | s.charCodeAt(i + 3) << 24;
		     h = caml_hash_mix_int(h, w);
		    }
		    w = 0;
		    switch(len & 3){
		      case 3:
		       w = s.charCodeAt(i + 2) << 16;
		      case 2:
		       w |= s.charCodeAt(i + 1) << 8;
		      case 1:
		       w |= s.charCodeAt(i); h = caml_hash_mix_int(h, w);
		    }
		    h ^= len;
		    return h;
		   }
		   function caml_jsstring_is_bytes(s){
		    for(var i = 0; i < s.length; i++) if(s.charCodeAt(i) > 0xff) return false;
		    return true;
		   }
		   function caml_hash_mix_jsstring(h, s){
		    if(caml_jsstring_is_bytes(s)) return caml_hash_mix_jsbytes(h, s);
		    var len = s.length, i, w;
		    for(i = 0; i + 2 <= len; i += 2){
		     w = s.charCodeAt(i) | s.charCodeAt(i + 1) << 16;
		     h = caml_hash_mix_int(h, w);
		    }
		    if(len & 1) h = caml_hash_mix_int(h, s.charCodeAt(i));
		    return h ^ len;
		   }
		   function caml_int64_lo32(v){return v.lo32();}
		   function caml_int64_hi32(v){return v.hi32();}
		   var
		    jsoo_dataview = new DataView(new ArrayBuffer(8)),
		    caml_int64_offset = Math.pow(2, - 24);
		   function caml_raise_constant(tag){throw tag;}
		   var caml_global_data = [0];
		   function caml_raise_zero_divide(){
		    caml_raise_constant(caml_global_data["predef:Division_by_zero"]);
		   }
		   class MlInt64{
		     constructor(lo, mi, hi){
		      this.lo = lo & 0xffffff;
		      this.mi = mi & 0xffffff;
		      this.hi = hi & 0xffff;
		      this.caml_custom = "_j";
		     }
		     static UNSIGNED_MAX = new MlInt64(0xffffff, 0xffffff, 0xffff);
		     static SIGNED_MAX = new MlInt64(0xffffff, 0xffffff, 0x7fff);
		     static SIGNED_MIN = new MlInt64(0x000000, 0x000000, 0x8000);
		     slice(){return new MlInt64(this.lo, this.mi, this.hi);}
		     ucompare(x){
		      if(this.hi > x.hi) return 1;
		      if(this.hi < x.hi) return - 1;
		      if(this.mi > x.mi) return 1;
		      if(this.mi < x.mi) return - 1;
		      if(this.lo > x.lo) return 1;
		      if(this.lo < x.lo) return - 1;
		      return 0;
		     }
		     compare(x){
		      var hi = this.hi << 16, xhi = x.hi << 16;
		      if(hi > xhi) return 1;
		      if(hi < xhi) return - 1;
		      if(this.mi > x.mi) return 1;
		      if(this.mi < x.mi) return - 1;
		      if(this.lo > x.lo) return 1;
		      if(this.lo < x.lo) return - 1;
		      return 0;
		     }
		     neg(){
		      var
		       lo = - this.lo,
		       mi = - this.mi + (lo >> 24),
		       hi = - this.hi + (mi >> 24);
		      return new MlInt64(lo, mi, hi);
		     }
		     add(x){
		      var
		       lo = this.lo + x.lo,
		       mi = this.mi + x.mi + (lo >> 24),
		       hi = this.hi + x.hi + (mi >> 24);
		      return new MlInt64(lo, mi, hi);
		     }
		     sub(x){
		      var
		       lo = this.lo - x.lo,
		       mi = this.mi - x.mi + (lo >> 24),
		       hi = this.hi - x.hi + (mi >> 24);
		      return new MlInt64(lo, mi, hi);
		     }
		     mul(x){
		      var
		       lo = this.lo * x.lo,
		       mi = (lo * caml_int64_offset | 0) + this.mi * x.lo + this.lo * x.mi,
		       hi =
		         (mi * caml_int64_offset | 0) + this.hi * x.lo + this.mi * x.mi
		         + this.lo * x.hi;
		      return new MlInt64(lo, mi, hi);
		     }
		     isZero(){return (this.lo | this.mi | this.hi) === 0;}
		     isNeg(){return this.hi << 16 < 0;}
		     and(x){
		      return new MlInt64(this.lo & x.lo, this.mi & x.mi, this.hi & x.hi);
		     }
		     or(x){
		      return new MlInt64(this.lo | x.lo, this.mi | x.mi, this.hi | x.hi);
		     }
		     xor(x){
		      return new MlInt64(this.lo ^ x.lo, this.mi ^ x.mi, this.hi ^ x.hi);
		     }
		     shift_left(s){
		      s = s & 63;
		      if(s === 0) return this;
		      if(s < 24)
		       return new
		               MlInt64
		               (this.lo << s,
		                this.mi << s | this.lo >> 24 - s,
		                this.hi << s | this.mi >> 24 - s);
		      if(s < 48)
		       return new
		               MlInt64
		               (0, this.lo << s - 24, this.mi << s - 24 | this.lo >> 48 - s);
		      return new MlInt64(0, 0, this.lo << s - 48);
		     }
		     shift_right_unsigned(s){
		      s = s & 63;
		      if(s === 0) return this;
		      if(s < 24)
		       return new
		               MlInt64
		               (this.lo >> s | this.mi << 24 - s,
		                this.mi >> s | this.hi << 24 - s,
		                this.hi >> s);
		      if(s < 48)
		       return new
		               MlInt64
		               (this.mi >> s - 24 | this.hi << 48 - s, this.hi >> s - 24, 0);
		      return new MlInt64(this.hi >> s - 48, 0, 0);
		     }
		     shift_right(s){
		      s = s & 63;
		      if(s === 0) return this;
		      var h = this.hi << 16 >> 16;
		      if(s < 24)
		       return new
		               MlInt64
		               (this.lo >> s | this.mi << 24 - s,
		                this.mi >> s | h << 24 - s,
		                this.hi << 16 >> s >>> 16);
		      var sign = this.hi << 16 >> 31;
		      if(s < 48)
		       return new
		               MlInt64
		               (this.mi >> s - 24 | h << 48 - s,
		                this.hi << 16 >> s - 24 >> 16,
		                sign & 0xffff);
		      return new MlInt64(this.hi << 16 >> s - 32, sign, sign);
		     }
		     lsl1(){
		      this.hi = this.hi << 1 | this.mi >> 23;
		      this.mi = (this.mi << 1 | this.lo >> 23) & 0xffffff;
		      this.lo = this.lo << 1 & 0xffffff;
		     }
		     lsr1(){
		      this.lo = (this.lo >>> 1 | this.mi << 23) & 0xffffff;
		      this.mi = (this.mi >>> 1 | this.hi << 23) & 0xffffff;
		      this.hi = this.hi >>> 1;
		     }
		     udivmod(x){
		      var
		       offset = 0,
		       modulus = this.slice(),
		       divisor = x.slice(),
		       quotient = new MlInt64(0, 0, 0);
		      while(modulus.ucompare(divisor) > 0){offset++; divisor.lsl1();}
		      while(offset >= 0){
		       offset--;
		       quotient.lsl1();
		       if(modulus.ucompare(divisor) >= 0){
		        quotient.lo++;
		        modulus = modulus.sub(divisor);
		       }
		       divisor.lsr1();
		      }
		      return {quotient: quotient, modulus: modulus};
		     }
		     div(y){
		      var x = this;
		      if(y.isZero()) caml_raise_zero_divide();
		      var sign = x.hi ^ y.hi;
		      if(x.hi & 0x8000) x = x.neg();
		      if(y.hi & 0x8000) y = y.neg();
		      var q = x.udivmod(y).quotient;
		      if(sign & 0x8000) q = q.neg();
		      return q;
		     }
		     mod(y){
		      var x = this;
		      if(y.isZero()) caml_raise_zero_divide();
		      var sign = x.hi;
		      if(x.hi & 0x8000) x = x.neg();
		      if(y.hi & 0x8000) y = y.neg();
		      var r = x.udivmod(y).modulus;
		      if(sign & 0x8000) r = r.neg();
		      return r;
		     }
		     toInt(){return this.lo | this.mi << 24;}
		     toFloat(){
		      return (this.hi << 16) * Math.pow(2, 32) + this.mi * Math.pow(2, 24)
		             + this.lo;
		     }
		     toArray(){
		      return [this.hi >> 8,
		              this.hi & 0xff,
		              this.mi >> 16,
		              this.mi >> 8 & 0xff,
		              this.mi & 0xff,
		              this.lo >> 16,
		              this.lo >> 8 & 0xff,
		              this.lo & 0xff];
		     }
		     lo32(){return this.lo | (this.mi & 0xff) << 24;}
		     hi32(){return this.mi >>> 8 & 0xffff | this.hi << 16;}
		   }
		   function caml_int64_create_lo_mi_hi(lo, mi, hi){return new MlInt64(lo, mi, hi);
		   }
		   function caml_int64_bits_of_float(x){
		    jsoo_dataview.setFloat64(0, x, true);
		    var
		     lo32 = jsoo_dataview.getUint32(0, true),
		     hi32 = jsoo_dataview.getUint32(4, true),
		     lo = lo32 & 0xffffff,
		     mi = lo32 >>> 24 | hi32 << 8 & 0xffffff,
		     hi = hi32 >>> 16 & 0xffff;
		    if((hi & 0x7ff8) === 0x7ff0 && (mi | lo | hi & 0xf) !== 0) hi |= 8;
		    return caml_int64_create_lo_mi_hi(lo, mi, hi);
		   }
		   function caml_hash_mix_float(hash, v0){
		    var
		     i64 = caml_int64_bits_of_float(v0),
		     l = caml_int64_lo32(i64),
		     h = caml_int64_hi32(i64);
		    if((h & 0x7ff00000) === 0x7ff00000 && (l | h & 0xfffff) !== 0){h = 0x7ff00000; l = 0x00000001;}
		    else if(h === (0x80000000 | 0) && l === 0) h = 0;
		    hash = caml_hash_mix_int(hash, l);
		    hash = caml_hash_mix_int(hash, h);
		    return hash;
		   }
		   function caml_jsbytes_of_string(x){return x;}
		   function caml_hash_mix_string(h, v){
		    return caml_hash_mix_jsbytes(h, caml_jsbytes_of_string(v));
		   }
		   function caml_hash_mix_bytes_arr(h, s){
		    var len = s.length, i, w;
		    for(i = 0; i + 4 <= len; i += 4){
		     w = s[i] | s[i + 1] << 8 | s[i + 2] << 16 | s[i + 3] << 24;
		     h = caml_hash_mix_int(h, w);
		    }
		    w = 0;
		    switch(len & 3){
		      case 3:
		       w = s[i + 2] << 16;
		      case 2:
		       w |= s[i + 1] << 8;
		      case 1:
		       w |= s[i]; h = caml_hash_mix_int(h, w);
		    }
		    h ^= len;
		    return h;
		   }
		   var
		    jsoo_text_decoder_fallback =
		      {decode:
		       a=>{
		        var
		         len = a.length,
		         s = "",
		         i = 0,
		         REPL = 0xfffd,
		         cont = b=>(b & 0xc0) === 0x80;
		        while(i < len){
		         var b1 = a[i++], cp;
		         if(b1 < 0x80)
		          cp = b1;
		         else if(b1 < 0xc2 || b1 > 0xf4)
		          cp = REPL;
		         else if(b1 < 0xe0)
		          if(i < len && cont(a[i]))
		           cp = (b1 & 0x1f) << 6 | a[i++] & 0x3f;
		          else
		           cp = REPL;
		         else if(b1 < 0xf0){
		          var
		           lo = b1 === 0xe0 ? 0xa0 : 0x80,
		           hi = b1 === 0xed ? 0x9f : 0xbf,
		           b2 = i < len ? a[i] : - 1;
		          if(b2 < lo || b2 > hi)
		           cp = REPL;
		          else if(i + 1 < len && cont(a[i + 1])){
		           cp = (b1 & 0x0f) << 12 | (b2 & 0x3f) << 6 | a[i + 1] & 0x3f;
		           i += 2;
		          }
		          else {cp = REPL; i += 1;}
		         }
		         else {
		          var
		           lo = b1 === 0xf0 ? 0x90 : 0x80,
		           hi = b1 === 0xf4 ? 0x8f : 0xbf,
		           b2 = i < len ? a[i] : - 1;
		          if(b2 < lo || b2 > hi)
		           cp = REPL;
		          else if(i + 1 < len && cont(a[i + 1]))
		           if(i + 2 < len && cont(a[i + 2])){
		            cp =
		             (b1 & 0x07) << 18 | (b2 & 0x3f) << 12 | (a[i + 1] & 0x3f) << 6
		             | a[i + 2] & 0x3f;
		            i += 3;
		           }
		           else {cp = REPL; i += 2;}
		          else {cp = REPL; i += 1;}
		         }
		         if(cp <= 0xffff)
		          s += String.fromCharCode(cp);
		         else {
		          cp -= 0x10000;
		          s += String.fromCharCode(0xd800 | cp >> 10, 0xdc00 | cp & 0x3ff);
		         }
		        }
		        return s;}},
		    jsoo_text_decoder =
		      typeof TextDecoder !== "undefined"
		       ? new TextDecoder()
		       : jsoo_text_decoder_fallback;
		   function caml_convert_bytes_to_array(s){
		    var a = new Uint8Array(s.l), b = s.c, l = b.length, i = 0;
		    for(; i < l; i++) a[i] = b.charCodeAt(i);
		    for(l = s.l; i < l; i++) a[i] = 0;
		    s.c = a;
		    s.t = 4;
		    return a;
		   }
		   function caml_uint8_array_of_bytes(s){
		    if(s.t !== 4) caml_convert_bytes_to_array(s);
		    return s.c;
		   }
		   function caml_str_repeat(n, s){return s.repeat(n);}
		   function caml_sub_uint8_array_to_jsbytes(a, i, len){
		    var f = String.fromCharCode;
		    if(i === 0 && len <= 4096 && len === a.length) return f.apply(null, a);
		    var s = "";
		    for(; 0 < len; i += 1024, len -= 1024)
		     s += f.apply(null, a.subarray(i, i + Math.min(len, 1024)));
		    return s;
		   }
		   function caml_convert_string_to_bytes(s){
		    if(s.t === 2)
		     s.c += caml_str_repeat(s.l - s.c.length, "\0");
		    else
		     s.c = caml_sub_uint8_array_to_jsbytes(s.c, 0, s.c.length);
		    s.t = 0;
		   }
		   function jsoo_is_ascii(s){
		    if(s.length < 24){
		     for(var i = 0; i < s.length; i++) if(s.charCodeAt(i) > 127) return false;
		     return true;
		    }
		    else
		     return ! /[^\x00-\x7f]/.test(s);
		   }
		   class MlBytes{
		     constructor(tag, contents, length){
		      this.t = tag;
		      this.c = contents;
		      this.l = length;
		     }
		     toString(){
		      switch(this.t){
		        case 9:
		        case 8:
		         return this.c;
		        case 4:
		        case 2:
		         caml_convert_string_to_bytes(this);
		        case 0:
		         if(jsoo_is_ascii(this.c)) this.t = 9; else this.t = 8; return this.c;
		      }
		     }
		     toUtf16(){
		      if(this.t === 9) return this.c;
		      var a = caml_uint8_array_of_bytes(this);
		      return jsoo_text_decoder.decode(a);
		     }
		     slice(){
		      var content = this.t === 4 ? this.c.slice() : this.c;
		      return new MlBytes(this.t, content, this.l);
		     }
		   }
		   function caml_ml_bytes_content(s){
		    switch(s.t & 6){
		      case 2:
		       caml_convert_string_to_bytes(s); return s.c;
		      default: return s.c;
		    }
		   }
		   function caml_hash_mix_bytes(h, v){
		    var content = caml_ml_bytes_content(v);
		    return typeof content === "string"
		            ? caml_hash_mix_jsbytes(h, content)
		            : caml_hash_mix_bytes_arr(h, content);
		   }
		   var
		    caml_float16_of_double =
		      function(){
		        const
		         buffer = new ArrayBuffer(4),
		         f32 = new Float32Array(buffer),
		         u32 = new Uint32Array(buffer);
		        return function(f){
		         f32[0] = f;
		         let x = u32[0] >>> 0;
		         const sign = x & 0x80000000;
		         x = (x ^ sign) >>> 0;
		         let o;
		         if(x >= 0x47800000)
		          o = x > 0x7f800000 ? 0x7e00 : 0x7c00;
		         else if(x < 0x38800000){
		          u32[0] = x;
		          f32[0] = f32[0] + 0.5;
		          o = u32[0] - 0x3f000000 >>> 0;
		         }
		         else
		          o = x + 0xc8000fff + (x >>> 13 & 1) >>> 13;
		         return (o | sign >>> 16) & 0xffff;};
		       }
		       ();
		   function caml_int32_bits_of_float(x){
		    jsoo_dataview.setFloat32(0, x, true);
		    return jsoo_dataview.getUint32(0, true) | 0;
		   }
		   function caml_int64_to_bytes(x){return x.toArray();}
		   function caml_ba_serialize(writer, ba, sz){
		    writer.write(32, ba.dims.length);
		    writer.write(32, ba.kind | ba.layout << 8);
		    if(ba.caml_custom === "_bigarr02")
		     for(var i = 0; i < ba.dims.length; i++)
		      if(ba.dims[i] < 0xffff)
		       writer.write(16, ba.dims[i]);
		      else {
		       writer.write(16, 0xffff);
		       writer.write(32, 0);
		       writer.write(32, ba.dims[i]);
		      }
		    else
		     for(var i = 0; i < ba.dims.length; i++) writer.write(32, ba.dims[i]);
		    switch(ba.kind){
		      case 2:
		      case 3:
		      case 12:
		       for(var i = 0; i < ba.data.length; i++) writer.write(8, ba.data[i]);
		       break;
		      case 4:
		      case 5:
		       for(var i = 0; i < ba.data.length; i++) writer.write(16, ba.data[i]);
		       break;
		      case 6:
		       for(var i = 0; i < ba.data.length; i++) writer.write(32, ba.data[i]);
		       break;
		      case 8:
		      case 9:
		       writer.write(8, 0);
		       for(var i = 0; i < ba.data.length; i++) writer.write(32, ba.data[i]);
		       break;
		      case 7:
		       for(var i = 0; i < ba.data.length / 2; i++){
		        var b = caml_int64_to_bytes(ba.get(i));
		        for(var j = 0; j < 8; j++) writer.write(8, b[j]);
		       }
		       break;
		      case 1:
		       for(var i = 0; i < ba.data.length; i++){
		        var b = caml_int64_to_bytes(caml_int64_bits_of_float(ba.get(i)));
		        for(var j = 0; j < 8; j++) writer.write(8, b[j]);
		       }
		       break;
		      case 13:
		       for(var i = 0; i < ba.data.length; i++) writer.write(16, ba.data[i]);
		       break;
		      case 0:
		       for(var i = 0; i < ba.data.length; i++){
		        var b = caml_int32_bits_of_float(ba.get(i));
		        writer.write(32, b);
		       }
		       break;
		      case 10:
		       for(var i = 0; i < ba.data.length / 2; i++){
		        var j = ba.get(i);
		        writer.write(32, caml_int32_bits_of_float(j[1]));
		        writer.write(32, caml_int32_bits_of_float(j[2]));
		       }
		       break;
		      case 11:
		       for(var i = 0; i < ba.data.length / 2; i++){
		        var
		         complex = ba.get(i),
		         b = caml_int64_to_bytes(caml_int64_bits_of_float(complex[1]));
		        for(var j = 0; j < 8; j++) writer.write(8, b[j]);
		        var b = caml_int64_to_bytes(caml_int64_bits_of_float(complex[2]));
		        for(var j = 0; j < 8; j++) writer.write(8, b[j]);
		       }
		       break;
		    }
		    sz[0] = (4 + ba.dims.length) * 4;
		    sz[1] = (4 + ba.dims.length) * 8;
		   }
		   var
		    caml_double_of_float16 =
		      function(){
		        var
		         pow = Math.pow,
		         EXP_MASK16 = 31,
		         SIGNIFICAND_MASK16 = 1023,
		         MIN_SUBNORMAL16 = pow(2, - 24),
		         SIGNIFICAND_DENOM16 = 0.0009765625;
		        return function(bytes){
		         var
		          sign = bytes >>> 15,
		          exponent = bytes >>> 10 & EXP_MASK16,
		          significand = bytes & SIGNIFICAND_MASK16;
		         if(exponent === EXP_MASK16)
		          return significand === 0
		                  ? sign
		                    === 0
		                    ? Number.POSITIVE_INFINITY
		                    : Number.NEGATIVE_INFINITY
		                  : Number.NaN;
		         if(exponent === 0)
		          return significand
		                 * (sign === 0 ? MIN_SUBNORMAL16 : - MIN_SUBNORMAL16);
		         var
		          r =
		            pow(2, exponent - 15)
		            *
		             (sign === 0
		               ? 1 + significand * SIGNIFICAND_DENOM16
		               : - 1 - significand * SIGNIFICAND_DENOM16);
		         return r;};
		       }
		       (),
		    jsoo_static_env = {};
		   function jsoo_sys_getenv(n){
		    if(Object.hasOwn(jsoo_static_env, n)) return jsoo_static_env[n];
		    var process = globalThis.process;
		    if(process?.env && Object.hasOwn(process.env, n)) return process.env[n];
		    var std = globalThis.std;
		    if(std && typeof std.getenviron === "function"){
		     var v = std.getenviron()[n];
		     if(v !== undefined) return v;
		    }
		    if(globalThis.jsoo_env && typeof globalThis.jsoo_env[n] === "string")
		     return globalThis.jsoo_env[n];
		   }
		   var caml_record_backtrace_env_flag = 0;
		   (function(){
		      var r = jsoo_sys_getenv("OCAMLRUNPARAM");
		      if(r !== undefined){
		       var l = r.split(",");
		       for(var i = 0; i < l.length; i++)
		        if(l[i] === "b")
		         caml_record_backtrace_env_flag = 1;
		        else if(l[i].startsWith("b="))
		         caml_record_backtrace_env_flag = + l[i].slice(2);
		        else
		         continue;
		      }
		     }
		     ());
		   var caml_record_backtrace_runtime_flag = caml_record_backtrace_env_flag;
		   function caml_exn_with_js_backtrace(exn, force){
		    if(! exn.js_error || force || exn[0] === 248)
		     exn.js_error = new globalThis.Error("Js exception containing backtrace");
		    return exn;
		   }
		   function caml_maybe_attach_backtrace(exn, force){
		    return caml_record_backtrace_env_flag
		            && caml_record_backtrace_runtime_flag
		            ? caml_exn_with_js_backtrace(exn, force)
		            : exn;
		   }
		   function caml_raise_with_arg(tag, arg){
		    throw caml_maybe_attach_backtrace([0, tag, arg]);
		   }
		   function caml_string_of_jsbytes(x){return x;}
		   function caml_raise_with_string(tag, msg){
		    caml_raise_with_arg(tag, caml_string_of_jsbytes(msg));
		   }
		   function caml_invalid_argument(msg){
		    caml_raise_with_string(caml_global_data["predef:Invalid_argument"], msg);
		   }
		   function caml_ba_get_size_per_element(kind){
		    switch(kind){case 7:case 10:case 11: return 2;default: return 1;
		    }
		   }
		   function caml_ba_create_buffer(kind, size){
		    var view;
		    switch(kind){
		      case 0:
		       view = Float32Array; break;
		      case 1:
		       view = Float64Array; break;
		      case 2:
		       view = Int8Array; break;
		      case 3:
		       view = Uint8Array; break;
		      case 4:
		       view = Int16Array; break;
		      case 5:
		       view = Uint16Array; break;
		      case 6:
		       view = Int32Array; break;
		      case 7:
		       view = Int32Array; break;
		      case 8:
		       view = Int32Array; break;
		      case 9:
		       view = Int32Array; break;
		      case 10:
		       view = Float32Array; break;
		      case 11:
		       view = Float64Array; break;
		      case 12:
		       view = Uint8Array; break;
		      case 13:
		       view = Uint16Array; break;
		    }
		    if(! view) caml_invalid_argument("Bigarray.create: unsupported kind");
		    var data = new view(size * caml_ba_get_size_per_element(kind));
		    return data;
		   }
		   function caml_int32_float_of_bits(x){
		    jsoo_dataview.setUint32(0, x, true);
		    return jsoo_dataview.getFloat32(0, true);
		   }
		   function caml_int64_of_bytes(a){
		    return new
		            MlInt64
		            (a[7] << 0 | a[6] << 8 | a[5] << 16,
		             a[4] << 0 | a[3] << 8 | a[2] << 16,
		             a[1] << 0 | a[0] << 8);
		   }
		   function caml_int64_float_of_bits(x){
		    var lo = x.lo, mi = x.mi, hi = x.hi;
		    if((hi & 0x7ff8) === 0x7ff0 && (mi | lo | hi & 0xf) !== 0) hi |= 8;
		    jsoo_dataview.setUint32(0, lo | mi << 24, true);
		    jsoo_dataview.setUint32(4, mi >>> 8 | hi << 16, true);
		    return jsoo_dataview.getFloat64(0, true);
		   }
		   function caml_ba_get_size(dims){
		    var n_dims = dims.length, size = 1;
		    for(var i = 0; i < n_dims; i++){
		     if(dims[i] < 0)
		      caml_invalid_argument("Bigarray.create: negative dimension");
		     size = size * dims[i];
		    }
		    return size;
		   }
		   function caml_int64_create_lo_hi(lo, hi){
		    return new
		            MlInt64
		            (lo & 0xffffff,
		             lo >>> 24 & 0xff | (hi & 0xffff) << 8,
		             hi >>> 16 & 0xffff);
		   }
		   function caml_array_bound_error(){
		    caml_invalid_argument("index out of bounds");
		   }
		   var caml_ba_custom_name = "_bigarr02";
		   class Ml_Bigarray{
		     constructor(kind, layout, dims, buffer){
		      this.kind = kind;
		      this.layout = layout;
		      this.dims = dims;
		      this.data = buffer;
		      this.caml_custom = caml_ba_custom_name;
		     }
		     offset(arg){
		      var ofs = 0;
		      if(typeof arg === "number") arg = [arg];
		      if(! Array.isArray(arg))
		       caml_invalid_argument("bigarray.js: invalid offset");
		      if(this.dims.length !== arg.length)
		       caml_invalid_argument("Bigarray.get/set: bad number of dimensions");
		      if(this.layout === 0)
		       for(var i = 0; i < this.dims.length; i++){
		        if(arg[i] < 0 || arg[i] >= this.dims[i]) caml_array_bound_error();
		        ofs = ofs * this.dims[i] + arg[i];
		       }
		      else
		       for(var i = this.dims.length - 1; i >= 0; i--){
		        if(arg[i] < 1 || arg[i] > this.dims[i]) caml_array_bound_error();
		        ofs = ofs * this.dims[i] + (arg[i] - 1);
		       }
		      return ofs;
		     }
		     get(ofs){
		      switch(this.kind){
		        case 7:
		         var l = this.data[ofs * 2 + 0], h = this.data[ofs * 2 + 1];
		         return caml_int64_create_lo_hi(l, h);
		        case 10:
		        case 11:
		         var r = this.data[ofs * 2 + 0], i = this.data[ofs * 2 + 1];
		         return [254, r, i];
		        case 13:
		         return caml_double_of_float16(this.data[ofs]);
		        default: return this.data[ofs];
		      }
		     }
		     set(ofs, v){
		      switch(this.kind){
		        case 7:
		         this.data[ofs * 2 + 0] = caml_int64_lo32(v);
		         this.data[ofs * 2 + 1] = caml_int64_hi32(v);
		         break;
		        case 10:
		        case 11:
		         this.data[ofs * 2 + 0] = v[1]; this.data[ofs * 2 + 1] = v[2]; break;
		        case 13:
		         this.data[ofs] = caml_float16_of_double(v); break;
		        default: this.data[ofs] = v; break;
		      }
		      return 0;
		     }
		     fill(v){
		      switch(this.kind){
		        case 7:
		         var a = caml_int64_lo32(v), b = caml_int64_hi32(v);
		         if(a === b)
		          this.data.fill(a);
		         else
		          for(var i = 0; i < this.data.length; i++)
		           this.data[i] = i % 2 === 0 ? a : b;
		         break;
		        case 10:
		        case 11:
		         var im = v[1], re = v[2];
		         if(im === re)
		          this.data.fill(im);
		         else
		          for(var i = 0; i < this.data.length; i++)
		           this.data[i] = i % 2 === 0 ? im : re;
		         break;
		        case 13:
		         this.data.fill(caml_float16_of_double(v)); break;
		        default: this.data.fill(v); break;
		      }
		     }
		     compare(b, total){
		      if(this.layout !== b.layout || this.kind !== b.kind){
		       var k1 = this.kind | this.layout << 8, k2 = b.kind | b.layout << 8;
		       return k2 - k1;
		      }
		      if(this.dims.length !== b.dims.length)
		       return b.dims.length - this.dims.length;
		      for(var i = 0; i < this.dims.length; i++)
		       if(this.dims[i] !== b.dims[i])
		        return this.dims[i] < b.dims[i] ? - 1 : 1;
		      switch(this.kind){
		        case 0:
		        case 1:
		        case 10:
		        case 11:
		         var x, y;
		         for(var i = 0; i < this.data.length; i++){
		          x = this.data[i];
		          y = b.data[i];
		          if(x < y) return - 1;
		          if(x > y) return 1;
		          if(x !== y){
		           if(! total) return Number.NaN;
		           if(! Number.isNaN(x)) return 1;
		           if(! Number.isNaN(y)) return - 1;
		          }
		         }
		         break;
		        case 7:
		         for(var i = 0; i < this.data.length; i += 2){
		          if(this.data[i + 1] < b.data[i + 1]) return - 1;
		          if(this.data[i + 1] > b.data[i + 1]) return 1;
		          if(this.data[i] >>> 0 < b.data[i] >>> 0) return - 1;
		          if(this.data[i] >>> 0 > b.data[i] >>> 0) return 1;
		         }
		         break;
		        case 13:
		         for(var i = 0; i < this.data.length; i++){
		          var
		           aa = caml_double_of_float16(this.data[i]),
		           bb = caml_double_of_float16(b.data[i]);
		          if(aa < bb) return - 1;
		          if(aa > bb) return 1;
		          if(aa !== bb){
		           if(! total) return Number.NaN;
		           if(! Number.isNaN(aa)) return 1;
		           if(! Number.isNaN(bb)) return - 1;
		          }
		         }
		         break;
		        case 2:
		        case 3:
		        case 4:
		        case 5:
		        case 6:
		        case 8:
		        case 9:
		        case 12:
		         for(var i = 0; i < this.data.length; i++){
		          if(this.data[i] < b.data[i]) return - 1;
		          if(this.data[i] > b.data[i]) return 1;
		         }
		         break;
		      }
		      return 0;
		     }
		   }
		   class Ml_Bigarray_c_1_1 extends Ml_Bigarray {
		     offset(arg){
		      if(typeof arg !== "number")
		       if(Array.isArray(arg) && arg.length === 1)
		        arg = arg[0];
		       else
		        caml_invalid_argument("Ml_Bigarray_c_1_1.offset");
		      if(arg < 0 || arg >= this.dims[0]) caml_array_bound_error();
		      return arg;
		     }
		     get(ofs){return this.data[ofs];}
		     set(ofs, v){this.data[ofs] = v; return 0;}
		     fill(v){this.data.fill(v); return 0;}
		   }
		   function caml_ba_create_unsafe(kind, layout, dims, data){
		    var size_per_element = caml_ba_get_size_per_element(kind);
		    if(caml_ba_get_size(dims) * size_per_element !== data.length)
		     caml_invalid_argument("length doesn't match dims");
		    if
		     (layout === 0 && dims.length === 1 && size_per_element === 1
		      && kind !== 13)
		     return new Ml_Bigarray_c_1_1(kind, layout, dims, data);
		    return new Ml_Bigarray(kind, layout, dims, data);
		   }
		   function caml_failwith(msg){
		    if(! caml_global_data["predef:Failure"])
		     caml_global_data["predef:Failure"] =
		      [248, caml_string_of_jsbytes("Failure"), - 3];
		    caml_raise_with_string(caml_global_data["predef:Failure"], msg);
		   }
		   function caml_ba_deserialize(reader, sz, name){
		    var num_dims = reader.read32s();
		    if(num_dims < 0 || num_dims > 16)
		     caml_failwith("input_value: wrong number of bigarray dimensions");
		    var
		     tag = reader.read32s(),
		     kind = tag & 0xff,
		     layout = tag >> 8 & 1,
		     dims = [];
		    if(name === "_bigarr02")
		     for(var i = 0; i < num_dims; i++){
		      var size_dim = reader.read16u();
		      if(size_dim === 0xffff){
		       var size_dim_hi = reader.read32u(), size_dim_lo = reader.read32u();
		       if(size_dim_hi !== 0)
		        caml_failwith("input_value: bigarray dimension overflow in 32bit");
		       size_dim = size_dim_lo;
		      }
		      dims.push(size_dim);
		     }
		    else
		     for(var i = 0; i < num_dims; i++) dims.push(reader.read32u());
		    var
		     size = caml_ba_get_size(dims),
		     data = caml_ba_create_buffer(kind, size),
		     ba = caml_ba_create_unsafe(kind, layout, dims, data);
		    switch(kind){
		      case 2:
		       for(var i = 0; i < size; i++) data[i] = reader.read8s(); break;
		      case 3:
		      case 12:
		       for(var i = 0; i < size; i++) data[i] = reader.read8u(); break;
		      case 4:
		       for(var i = 0; i < size; i++) data[i] = reader.read16s(); break;
		      case 5:
		       for(var i = 0; i < size; i++) data[i] = reader.read16u(); break;
		      case 6:
		       for(var i = 0; i < size; i++) data[i] = reader.read32s(); break;
		      case 8:
		      case 9:
		       var sixty = reader.read8u();
		       if(sixty)
		        caml_failwith
		         ("input_value: cannot read bigarray with 64-bit OCaml ints");
		       for(var i = 0; i < size; i++) data[i] = reader.read32s();
		       break;
		      case 7:
		       var t = new Array(8);
		       for(var i = 0; i < size; i++){
		        for(var j = 0; j < 8; j++) t[j] = reader.read8u();
		        var int64 = caml_int64_of_bytes(t);
		        ba.set(i, int64);
		       }
		       break;
		      case 1:
		       var t = new Array(8);
		       for(var i = 0; i < size; i++){
		        for(var j = 0; j < 8; j++) t[j] = reader.read8u();
		        var f = caml_int64_float_of_bits(caml_int64_of_bytes(t));
		        ba.set(i, f);
		       }
		       break;
		      case 13:
		       for(var i = 0; i < size; i++) data[i] = reader.read16u(); break;
		      case 0:
		       for(var i = 0; i < size; i++){
		        var f = caml_int32_float_of_bits(reader.read32s());
		        ba.set(i, f);
		       }
		       break;
		      case 10:
		       for(var i = 0; i < size; i++){
		        var
		         re = caml_int32_float_of_bits(reader.read32s()),
		         im = caml_int32_float_of_bits(reader.read32s());
		        ba.set(i, [254, re, im]);
		       }
		       break;
		      case 11:
		       var t = new Array(8);
		       for(var i = 0; i < size; i++){
		        for(var j = 0; j < 8; j++) t[j] = reader.read8u();
		        var re = caml_int64_float_of_bits(caml_int64_of_bytes(t));
		        for(var j = 0; j < 8; j++) t[j] = reader.read8u();
		        var im = caml_int64_float_of_bits(caml_int64_of_bytes(t));
		        ba.set(i, [254, re, im]);
		       }
		       break;
		    }
		    sz[0] = (4 + num_dims) * 4;
		    return caml_ba_create_unsafe(kind, layout, dims, data);
		   }
		   function caml_ba_compare(a, b, total){return a.compare(b, total);}
		   function caml_hash_mix_float16(hash, d){
		    if((d & 0x7c00) === 0x7c00 && (d & 0x03ff) !== 0)
		     d = 0x7c01;
		    else if(d === 0x8000) d = 0;
		    return caml_hash_mix_int(hash, d);
		   }
		   function caml_hash_mix_float32(hash, v){
		    var i = caml_int32_bits_of_float(v);
		    if((i & 0x7f800000) === 0x7f800000 && (i & 0x7fffff) !== 0)
		     i = 0x7f800001;
		    else if(i === (0x80000000 | 0)) i = 0;
		    hash = caml_hash_mix_int(hash, i);
		    return hash;
		   }
		   function caml_ba_hash(ba){
		    var num_elts = caml_ba_get_size(ba.dims), h = 0;
		    switch(ba.kind){
		      case 2:
		      case 3:
		      case 12:
		       if(num_elts > 256) num_elts = 256;
		       var w = 0, i = 0;
		       for(i = 0; i + 4 <= num_elts; i += 4){
		        w =
		         ba.data[i + 0] & 0xff | (ba.data[i + 1] & 0xff) << 8
		         | (ba.data[i + 2] & 0xff) << 16
		         | ba.data[i + 3] << 24;
		        h = caml_hash_mix_int(h, w);
		       }
		       w = 0;
		       switch(num_elts & 3){
		         case 3:
		          w = (ba.data[i + 2] & 0xff) << 16;
		         case 2:
		          w |= (ba.data[i + 1] & 0xff) << 8;
		         case 1:
		          w |= ba.data[i + 0] & 0xff; h = caml_hash_mix_int(h, w);
		       }
		       break;
		      case 4:
		      case 5:
		       if(num_elts > 128) num_elts = 128;
		       var w = 0, i = 0;
		       for(i = 0; i + 2 <= num_elts; i += 2){
		        w = ba.data[i + 0] & 0xffff | ba.data[i + 1] << 16;
		        h = caml_hash_mix_int(h, w);
		       }
		       if((num_elts & 1) !== 0) h = caml_hash_mix_int(h, ba.data[i] & 0xffff);
		       break;
		      case 6:
		       if(num_elts > 64) num_elts = 64;
		       for(var i = 0; i < num_elts; i++) h = caml_hash_mix_int(h, ba.data[i]);
		       break;
		      case 8:
		      case 9:
		       if(num_elts > 64) num_elts = 64;
		       for(var i = 0; i < num_elts; i++) h = caml_hash_mix_int(h, ba.data[i]);
		       break;
		      case 7:
		       if(num_elts > 32) num_elts = 32;
		       num_elts *= 2;
		       for(var i = 0; i < num_elts; i++) h = caml_hash_mix_int(h, ba.data[i]);
		       break;
		      case 10:
		       num_elts *= 2;
		      case 0:
		       if(num_elts > 64) num_elts = 64;
		       for(var i = 0; i < num_elts; i++)
		        h = caml_hash_mix_float32(h, ba.data[i]);
		       break;
		      case 11:
		       num_elts *= 2;
		      case 1:
		       if(num_elts > 32) num_elts = 32;
		       for(var i = 0; i < num_elts; i++)
		        h = caml_hash_mix_float(h, ba.data[i]);
		       break;
		      case 13:
		       if(num_elts > 128) num_elts = 128;
		       for(var i = 0; i < num_elts; i++)
		        h = caml_hash_mix_float16(h, ba.data[i]);
		       break;
		    }
		    return h;
		   }
		   function caml_int32_unmarshal(reader, size){size[0] = 4; return reader.read32s();
		   }
		   function caml_nativeint_unmarshal(reader, size){
		    switch(reader.read8u()){
		      case 1:
		       size[0] = 4; return reader.read32s();
		      case 2:
		       caml_failwith("input_value: native integer value too large"); break;
		      default: caml_failwith("input_value: ill-formed native integer");
		    }
		   }
		   function caml_int64_unmarshal(reader, size){
		    var t = new Array(8);
		    for(var j = 0; j < 8; j++) t[j] = reader.read8u();
		    size[0] = 8;
		    return caml_int64_of_bytes(t);
		   }
		   function caml_int64_marshal(writer, v, sizes){
		    var b = caml_int64_to_bytes(v);
		    for(var i = 0; i < 8; i++) writer.write(8, b[i]);
		    sizes[0] = 8;
		    sizes[1] = 8;
		   }
		   function caml_int64_compare(x, y, _total){return x.compare(y);}
		   function caml_int64_hash(v){return v.lo32() ^ v.hi32();}
		   var
		    caml_custom_ops =
		      {_j:
		       {deserialize: caml_int64_unmarshal,
		        serialize: caml_int64_marshal,
		        fixed_length: 8,
		        compare: caml_int64_compare,
		        hash: caml_int64_hash},
		       _i: {deserialize: caml_int32_unmarshal, fixed_length: 4},
		       _n: {deserialize: caml_nativeint_unmarshal, fixed_length: 4},
		       _bigarray:
		       {deserialize:
		        function(reader, sz){
		         return caml_ba_deserialize(reader, sz, "_bigarray");
		        },
		        serialize: caml_ba_serialize,
		        compare: caml_ba_compare,
		        hash: caml_ba_hash},
		       _bigarr02:
		       {deserialize:
		        function(reader, sz){
		         return caml_ba_deserialize(reader, sz, "_bigarr02");
		        },
		        serialize: caml_ba_serialize,
		        compare: caml_ba_compare,
		        hash: caml_ba_hash}};
		   function caml_hash_mix_final(h){
		    h ^= h >>> 16;
		    h = caml_mul(h, 0x85ebca6b | 0);
		    h ^= h >>> 13;
		    h = caml_mul(h, 0xc2b2ae35 | 0);
		    h ^= h >>> 16;
		    return h;
		   }
		   function caml_is_ml_string(s){
		    return typeof s === "string" && ! /[^\x00-\xff]/.test(s);
		   }
		   function caml_is_ml_bytes(s){return s instanceof MlBytes;}
		   function caml_hash(count, limit, seed, obj){
		    var queue, rd, wr, sz, num, h, v, i, len;
		    sz = limit;
		    if(sz < 0 || sz > 256) sz = 256;
		    num = count;
		    h = seed;
		    queue = [obj];
		    rd = 0;
		    wr = 1;
		    while(rd < wr && num > 0){
		     v = queue[rd++];
		     if(v?.caml_custom){
		      if
		       (caml_custom_ops[v.caml_custom] && caml_custom_ops[v.caml_custom].hash){
		       var hh = caml_custom_ops[v.caml_custom].hash(v);
		       h = caml_hash_mix_int(h, hh);
		       num--;
		      }
		     }
		     else if(Array.isArray(v) && v[0] === (v[0] | 0))
		      switch(v[0]){
		        case 248:
		         h = caml_hash_mix_int(h, v[2]); num--; break;
		        case 250:
		         queue[--rd] = v[1]; break;
		        case 251: break;
		        case 254:
		         for(i = 1, len = v.length; i < len; i++){
		          h = caml_hash_mix_float(h, v[i]);
		          num--;
		          if(num <= 0) break;
		         }
		         break;
		        default:
		         if(caml_is_continuation_tag(v[0])) break;
		         var tag = v.length - 1 << 10 | v[0];
		         h = caml_hash_mix_int(h, tag);
		         for(i = 1, len = v.length; i < len; i++){if(wr >= sz) break; queue[wr++] = v[i];
		         }
		         break;
		      }
		     else if(caml_is_ml_bytes(v)){
		      h = caml_hash_mix_bytes(h, v);
		      num--;
		     }
		     else if(caml_is_ml_string(v)){
		      h = caml_hash_mix_string(h, v);
		      num--;
		     }
		     else if(typeof v === "string"){
		      h = caml_hash_mix_jsstring(h, v);
		      num--;
		     }
		     else if(v === (v | 0)){
		      h = caml_hash_mix_int(h, v + v + 1);
		      num--;
		     }
		     else if(typeof v === "number"){h = caml_hash_mix_float(h, v); num--;}
		    }
		    h = caml_hash_mix_final(h);
		    return h & 0x3fffffff;
		   }
		   function Base_hash_double(d){return caml_hash(1, 1, 0, d);}
		   function Base_hash_string(s){return caml_hash(1, 1, 0, s);}
		   function Base_int_math_int_pow_stub(base, exponent){
		    var one = 1, mul = [one, base, one, one], res = one;
		    while(! exponent == 0){
		     mul[1] = mul[1] * mul[3] | 0;
		     mul[2] = mul[1] * mul[1] | 0;
		     mul[3] = mul[2] * mul[1] | 0;
		     res = res * mul[exponent & 3] | 0;
		     exponent = exponent >> 2;
		    }
		    return res;
		   }
		   var Base_internalhash_fold_int = caml_hash_mix_int;
		   function caml_hash_mix_int64(h, v){
		    h = caml_hash_mix_int(h, caml_int64_lo32(v));
		    h = caml_hash_mix_int(h, caml_int64_hi32(v));
		    return h;
		   }
		   var
		    Base_internalhash_fold_int64 = caml_hash_mix_int64,
		    Base_internalhash_fold_string = caml_hash_mix_string;
		   function Base_internalhash_get_hash_value(seed){
		    var h = caml_hash_mix_final(seed);
		    return h & 0x3FFFFFFF;
		   }
		   function caml_ml_string_length(s){return s.length;}
		   function caml_string_unsafe_get(s, i){return s.charCodeAt(i);}
		   function caml_uint8_array_of_string(s){
		    var l = caml_ml_string_length(s), a = new Uint8Array(l), i = 0;
		    for(; i < l; i++) a[i] = caml_string_unsafe_get(s, i);
		    return a;
		   }
		   function caml_bigstring_blit_string_to_ba(str1, pos1, ba2, pos2, len){
		    if(12 !== ba2.kind)
		     caml_invalid_argument("caml_bigstring_blit_string_to_ba: kind mismatch");
		    if(len === 0) return 0;
		    if(pos1 < 0 || pos1 + len > caml_ml_string_length(str1))
		     caml_array_bound_error();
		    if(pos2 < 0 || pos2 + len > ba2.data.length) caml_array_bound_error();
		    var slice = caml_uint8_array_of_string(str1).subarray(pos1, pos1 + len);
		    ba2.data.set(slice, pos2);
		    return 0;
		   }
		   function bigstringaf_blit_from_bytes(src, src_off, dst, dst_off, len){
		    return caml_bigstring_blit_string_to_ba(src, src_off, dst, dst_off, len);
		   }
		   function caml_ml_bytes_length(s){return s.l;}
		   function caml_blit_bytes(s1, i1, s2, i2, len){
		    if(len === 0) return 0;
		    if(i2 === 0 && (len >= s2.l || s2.t === 2 && len >= s2.c.length)){
		     s2.c =
		      s1.t === 4
		       ? caml_sub_uint8_array_to_jsbytes(s1.c, i1, len)
		       : i1 === 0 && s1.c.length === len ? s1.c : s1.c.slice(i1, i1 + len);
		     s2.t = s2.c.length === s2.l ? 0 : 2;
		    }
		    else if(s2.t === 2 && i2 === s2.c.length){
		     s2.c +=
		      s1.t === 4
		       ? caml_sub_uint8_array_to_jsbytes(s1.c, i1, len)
		       : i1 === 0 && s1.c.length === len ? s1.c : s1.c.slice(i1, i1 + len);
		     s2.t = s2.c.length === s2.l ? 0 : 2;
		    }
		    else {
		     if(s2.t !== 4) caml_convert_bytes_to_array(s2);
		     var c1 = s1.c, c2 = s2.c;
		     if(s1.t === 4)
		      if(i2 <= i1)
		       for(var i = 0; i < len; i++) c2[i2 + i] = c1[i1 + i];
		      else
		       for(var i = len - 1; i >= 0; i--) c2[i2 + i] = c1[i1 + i];
		     else {
		      var l = Math.min(len, c1.length - i1);
		      for(var i = 0; i < l; i++) c2[i2 + i] = c1.charCodeAt(i1 + i);
		      for(; i < len; i++) c2[i2 + i] = 0;
		     }
		    }
		    return 0;
		   }
		   function caml_bytes_of_uint8_array(a){return new MlBytes(4, a, a.length);}
		   function caml_bigstring_blit_ba_to_bytes(ba1, pos1, bytes2, pos2, len){
		    if(12 !== ba1.kind)
		     caml_invalid_argument("caml_bigstring_blit_ba_to_bytes: kind mismatch");
		    if(len === 0) return 0;
		    if(pos1 < 0 || pos1 + len > ba1.data.length) caml_array_bound_error();
		    if(pos2 + len > caml_ml_bytes_length(bytes2))
		     caml_array_bound_error();
		    var slice = ba1.data.subarray(pos1, pos1 + len);
		    caml_blit_bytes(caml_bytes_of_uint8_array(slice), 0, bytes2, pos2, len);
		    return 0;
		   }
		   function bigstringaf_blit_to_bytes(src, src_off, dst, dst_off, len){
		    return caml_bigstring_blit_ba_to_bytes(src, src_off, dst, dst_off, len);
		   }
		   function caml_call_gen(f, args){
		    var
		     n = f.l >= 0 ? f.l : f.l = f.length,
		     argsLen = args.length,
		     d = n - argsLen;
		    if(d === 0)
		     return f(...args);
		    else if(d < 0){
		     var rest = args.slice(n - 1), k = args[argsLen - 1];
		     args = args.slice(0, n);
		     args[n - 1] =
		      function(g){
		       if(typeof g !== "function") return k(g);
		       var args = rest.slice();
		       args[args.length - 1] = k;
		       return caml_call_gen(g, args);
		      };
		     return f(...args);
		    }
		    else {
		     argsLen--;
		     var k = args[argsLen];
		     switch(d){
		       case 1:
		        {
		         var
		          g =
		            function(x, y){
		             var nargs = new Array(argsLen + 2);
		             for(var i = 0; i < argsLen; i++) nargs[i] = args[i];
		             nargs[argsLen] = x;
		             nargs[argsLen + 1] = y;
		             return f(...nargs);
		            };
		         break;
		        }
		       case 2:
		        {
		         var
		          g =
		            function(x, y, z){
		             var nargs = new Array(argsLen + 3);
		             for(var i = 0; i < argsLen; i++) nargs[i] = args[i];
		             nargs[argsLen] = x;
		             nargs[argsLen + 1] = y;
		             nargs[argsLen + 2] = z;
		             return f(...nargs);
		            };
		         break;
		        }
		       default:
		        {
		         args.length = argsLen;
		         var
		          g =
		            function(...extra_args){
		             if(extra_args.length === 0) extra_args = [undefined];
		             return caml_call_gen(f, args.concat(extra_args));
		            };
		        }
		     }
		     g.l = d + 1;
		     return k(g);
		    }
		   }
		   var
		    caml_call_gen_cps = caml_call_gen,
		    caml_current_stack = {k: 0, x: 0, h: 0, e: 0};
		   function caml_pop_fiber(){
		    var c = caml_current_stack.e;
		    caml_current_stack.e = 0;
		    caml_current_stack = c;
		    return c.k;
		   }
		   var caml_stack_depth = 0;
		   function caml_stack_check_depth(){return --caml_stack_depth > 0;}
		   function caml_trampoline_return(f, args, direct){
		    return {joo_tramp: f, joo_args: args, joo_direct: direct};
		   }
		   function caml_alloc_stack_call(f, x){
		    var args = [x, caml_pop_fiber()];
		    return caml_stack_check_depth()
		            ? caml_call_gen_cps(f, args)
		            : caml_trampoline_return(f, args, 0);
		   }
		   function caml_alloc_stack_hval(x){
		    var f = caml_current_stack.h[1];
		    return caml_alloc_stack_call(f, x);
		   }
		   function caml_alloc_stack_hexn(e){
		    var f = caml_current_stack.h[2];
		    return caml_alloc_stack_call(f, e);
		   }
		   function caml_alloc_stack(hv, hx, hf){
		    var handlers = [0, hv, hx, hf];
		    return {k: caml_alloc_stack_hval,
		            x: {h: caml_alloc_stack_hexn, t: 0},
		            h: handlers,
		            e: 0};
		   }
		   function caml_array_append(a1, a2){
		    var l1 = a1.length, l2 = a2.length, l = l1 + l2 - 1, a = new Array(l);
		    a[0] = 0;
		    var i = 1, j = 1;
		    for(; i < l1; i++) a[i] = a1[i];
		    for(; i < l; i++, j++) a[i] = a2[j];
		    return a;
		   }
		   function caml_array_blit(a1, i1, a2, i2, len){
		    if(i2 <= i1)
		     for(var j = 1; j <= len; j++) a2[i2 + j] = a1[i1 + j];
		    else
		     for(var j = len; j >= 1; j--) a2[i2 + j] = a1[i1 + j];
		    return 0;
		   }
		   function caml_array_concat(l){
		    var a = [0];
		    while(l !== 0){
		     var b = l[1];
		     for(var i = 1; i < b.length; i++) a.push(b[i]);
		     l = l[2];
		    }
		    return a;
		   }
		   function caml_array_sub(a, i, len){
		    var a2 = new Array(len + 1);
		    a2[0] = 0;
		    for(var i2 = 1, i1 = i + 1; i2 <= len; i2++, i1++) a2[i2] = a[i1];
		    return a2;
		   }
		   function caml_atomic_cas(ref, o, n){
		    if(ref[1] === o){ref[1] = n; return 1;}
		    return 0;
		   }
		   function caml_atomic_exchange(ref, v){
		    var r = ref[1];
		    ref[1] = v;
		    return r;
		   }
		   function caml_atomic_fetch_add(ref, i){
		    var old = ref[1];
		    ref[1] += i;
		    return old;
		   }
		   function caml_atomic_load(ref){return ref[1];}
		   function caml_ba_blit(src, dst){
		    if(dst.dims.length !== src.dims.length)
		     caml_invalid_argument("Bigarray.blit: dimension mismatch");
		    for(var i = 0; i < dst.dims.length; i++)
		     if(dst.dims[i] !== src.dims[i])
		      caml_invalid_argument("Bigarray.blit: dimension mismatch");
		    dst.data.set(src.data);
		    return 0;
		   }
		   function caml_js_from_array(a){return a.slice(1);}
		   function caml_ba_create(kind, layout, dims_ml){
		    var
		     dims = caml_js_from_array(dims_ml),
		     data = caml_ba_create_buffer(kind, caml_ba_get_size(dims));
		    return caml_ba_create_unsafe(kind, layout, dims, data);
		   }
		   function caml_ba_dim(ba, i){
		    if(i < 0 || i >= ba.dims.length) caml_invalid_argument("Bigarray.dim");
		    return ba.dims[i];
		   }
		   function caml_ba_dim_1(ba){return caml_ba_dim(ba, 0);}
		   function caml_ba_dim_2(ba){return caml_ba_dim(ba, 1);}
		   function caml_ba_get_1(ba, i0){return ba.get(ba.offset(i0));}
		   function caml_ba_get_2(ba, i0, i1){return ba.get(ba.offset([i0, i1]));}
		   function caml_ba_layout(ba){return ba.layout;}
		   function caml_ba_set_1(ba, i0, v){ba.set(ba.offset(i0), v); return 0;}
		   function caml_ba_set_2(ba, i0, i1, v){
		    ba.set(ba.offset([i0, i1]), v);
		    return 0;
		   }
		   function caml_ba_sub(ba, ofs, len){
		    var changed_dim, mul = 1;
		    if(ba.layout === 0){
		     for(var i = 1; i < ba.dims.length; i++) mul = mul * ba.dims[i];
		     changed_dim = 0;
		    }
		    else {
		     for(var i = 0; i < ba.dims.length - 1; i++) mul = mul * ba.dims[i];
		     changed_dim = ba.dims.length - 1;
		     ofs = ofs - 1;
		    }
		    if(ofs < 0 || len < 0 || ofs + len > ba.dims[changed_dim])
		     caml_invalid_argument("Bigarray.sub: bad sub-array");
		    var new_dims = [];
		    for(var i = 0; i < ba.dims.length; i++) new_dims[i] = ba.dims[i];
		    new_dims[changed_dim] = len;
		    mul *= caml_ba_get_size_per_element(ba.kind);
		    var new_data = ba.data.subarray(ofs * mul, (ofs + len) * mul);
		    return caml_ba_create_unsafe(ba.kind, ba.layout, new_dims, new_data);
		   }
		   function caml_ba_uint8_set64(ba, i0, v){
		    var ofs = ba.offset(i0);
		    if(ofs + 7 >= ba.data.length) caml_array_bound_error();
		    var v = caml_int64_to_bytes(v);
		    for(var i = 0; i < 8; i++) ba.set(ofs + i, v[7 - i]);
		    return 0;
		   }
		   function caml_backtrace_status(_unit){
		    return caml_record_backtrace_runtime_flag ? 1 : 0;
		   }
		   function caml_bytes_of_jsbytes(s){return new MlBytes(0, s, s.length);}
		   function caml_bytes_of_string(s){
		    return caml_bytes_of_jsbytes(caml_jsbytes_of_string(s));
		   }
		   function caml_blit_string(a, b, c, d, e){
		    caml_blit_bytes(caml_bytes_of_string(a), b, c, d, e);
		    return 0;
		   }
		   var caml_blit_string_to_bigstring = caml_bigstring_blit_string_to_ba;
		   function caml_bswap16(x){return (x & 0x00ff) << 8 | (x & 0xff00) >> 8;}
		   function caml_bytes_bound_error(){
		    caml_invalid_argument("index out of bounds");
		   }
		   function caml_bytes_unsafe_get(s, i){
		    switch(s.t & 6){
		      case 0:
		       return s.c.charCodeAt(i);
		      case 2:
		       if(i >= s.c.length) return 0; return s.c.charCodeAt(i);
		      case 4:
		       return s.c[i];
		    }
		   }
		   function caml_bytes_get(s, i){
		    if(i >>> 0 >= s.l) caml_bytes_bound_error();
		    return caml_bytes_unsafe_get(s, i);
		   }
		   function caml_bytes_get16(s, i){
		    if(i >>> 0 >= s.l - 1) caml_bytes_bound_error();
		    var
		     b1 = caml_bytes_unsafe_get(s, i),
		     b2 = caml_bytes_unsafe_get(s, i + 1);
		    return b2 << 8 | b1;
		   }
		   function caml_bytes_get32(s, i){
		    if(i >>> 0 >= s.l - 3) caml_bytes_bound_error();
		    var
		     b1 = caml_bytes_unsafe_get(s, i),
		     b2 = caml_bytes_unsafe_get(s, i + 1),
		     b3 = caml_bytes_unsafe_get(s, i + 2),
		     b4 = caml_bytes_unsafe_get(s, i + 3);
		    return b4 << 24 | b3 << 16 | b2 << 8 | b1;
		   }
		   function caml_bytes_get64(s, i){
		    if(i >>> 0 >= s.l - 7) caml_bytes_bound_error();
		    var a = new Array(8);
		    for(var j = 0; j < 8; j++) a[7 - j] = caml_bytes_unsafe_get(s, i + j);
		    return caml_int64_of_bytes(a);
		   }
		   function caml_bytes_unsafe_set(s, i, c){
		    c &= 0xff;
		    if(s.t !== 4){
		     if(i === s.c.length){
		      s.c += String.fromCharCode(c);
		      if(i + 1 === s.l) s.t = 0;
		      return 0;
		     }
		     caml_convert_bytes_to_array(s);
		    }
		    s.c[i] = c;
		    return 0;
		   }
		   function caml_bytes_set(s, i, c){
		    if(i >>> 0 >= s.l) caml_bytes_bound_error();
		    return caml_bytes_unsafe_set(s, i, c);
		   }
		   function caml_bytes_set16(s, i, i16){
		    if(i >>> 0 >= s.l - 1) caml_bytes_bound_error();
		    var b2 = 0xff & i16 >> 8, b1 = 0xff & i16;
		    caml_bytes_unsafe_set(s, i + 0, b1);
		    caml_bytes_unsafe_set(s, i + 1, b2);
		    return 0;
		   }
		   function caml_bytes_set32(s, i, i32){
		    if(i >>> 0 >= s.l - 3) caml_bytes_bound_error();
		    var
		     b4 = 0xff & i32 >> 24,
		     b3 = 0xff & i32 >> 16,
		     b2 = 0xff & i32 >> 8,
		     b1 = 0xff & i32;
		    caml_bytes_unsafe_set(s, i + 0, b1);
		    caml_bytes_unsafe_set(s, i + 1, b2);
		    caml_bytes_unsafe_set(s, i + 2, b3);
		    caml_bytes_unsafe_set(s, i + 3, b4);
		    return 0;
		   }
		   function caml_bytes_set64(s, i, i64){
		    if(i >>> 0 >= s.l - 7) caml_bytes_bound_error();
		    var a = caml_int64_to_bytes(i64);
		    for(var j = 0; j < 8; j++) caml_bytes_unsafe_set(s, i + 7 - j, a[j]);
		    return 0;
		   }
		   var
		    jsoo_text_encoder_fallback =
		      {encode:
		       s=>{
		        var len = s.length, n = 0;
		        for(var i = 0; i < len; i++){
		         var c = s.charCodeAt(i);
		         if(c < 0x80)
		          n += 1;
		         else if(c < 0x800)
		          n += 2;
		         else if(c < 0xd800 || c >= 0xe000)
		          n += 3;
		         else if(c < 0xdc00 && i + 1 < len){
		          var c2 = s.charCodeAt(i + 1);
		          if(c2 >= 0xdc00 && c2 < 0xe000){n += 4; i++;} else n += 3;
		         }
		         else
		          n += 3;
		        }
		        var bytes = new Uint8Array(n), j = 0;
		        for(var i = 0; i < len; i++){
		         var c = s.charCodeAt(i);
		         if(c < 0x80)
		          bytes[j++] = c;
		         else if(c < 0x800){
		          bytes[j++] = 0xc0 | c >> 6;
		          bytes[j++] = 0x80 | c & 0x3f;
		         }
		         else if(c < 0xd800 || c >= 0xe000){
		          bytes[j++] = 0xe0 | c >> 12;
		          bytes[j++] = 0x80 | c >> 6 & 0x3f;
		          bytes[j++] = 0x80 | c & 0x3f;
		         }
		         else if(c < 0xdc00 && i + 1 < len){
		          var c2 = s.charCodeAt(i + 1);
		          if(c2 >= 0xdc00 && c2 < 0xe000){
		           var cp = 0x10000 + ((c & 0x3ff) << 10) + (c2 & 0x3ff);
		           bytes[j++] = 0xf0 | cp >> 18;
		           bytes[j++] = 0x80 | cp >> 12 & 0x3f;
		           bytes[j++] = 0x80 | cp >> 6 & 0x3f;
		           bytes[j++] = 0x80 | cp & 0x3f;
		           i++;
		          }
		          else {bytes[j++] = 0xef; bytes[j++] = 0xbf; bytes[j++] = 0xbd;}
		         }
		         else {bytes[j++] = 0xef; bytes[j++] = 0xbf; bytes[j++] = 0xbd;}
		        }
		        return bytes;}},
		    jsoo_text_encoder =
		      typeof TextEncoder !== "undefined"
		       ? new TextEncoder()
		       : jsoo_text_encoder_fallback;
		   function caml_subarray_to_jsbytes(a, i, len){
		    var f = String.fromCharCode;
		    if(i === 0 && len <= 4096 && len === a.length) return f.apply(null, a);
		    var s = "";
		    for(; 0 < len; i += 1024, len -= 1024)
		     s += f.apply(null, a.slice(i, i + Math.min(len, 1024)));
		    return s;
		   }
		   function caml_string_of_array(a){
		    return caml_string_of_jsbytes(caml_subarray_to_jsbytes(a, 0, a.length));
		   }
		   function caml_string_of_jsstring(s){
		    if(jsoo_is_ascii(s)) return caml_string_of_jsbytes(s);
		    var a = jsoo_text_encoder.encode(s);
		    return caml_string_of_array(a);
		   }
		   var caml_named_values = {};
		   function caml_named_value(nm){return caml_named_values[nm];}
		   function caml_wrap_exception(e){
		    {
		     if(Array.isArray(e)) return e;
		     var exn;
		     if
		      (globalThis.RangeError && e instanceof globalThis.RangeError
		       && e.message?.match(/maximum call stack/i))
		      exn = caml_global_data["predef:Stack_overflow"];
		     else if
		      (globalThis.InternalError && e instanceof globalThis.InternalError
		       && e.message?.match(/too much recursion/i))
		      exn = caml_global_data["predef:Stack_overflow"];
		     else if(e instanceof globalThis.Error && caml_named_value("jsError"))
		      exn = [0, caml_named_value("jsError"), e];
		     else
		      exn =
		       [0,
		        caml_global_data["predef:Failure"],
		        caml_string_of_jsstring(String(e))];
		     if(e instanceof globalThis.Error) exn.js_error = e;
		     return exn;
		    }
		   }
		   function caml_callback(f, args){
		    var
		     saved_stack_depth = caml_stack_depth,
		     saved_current_stack = caml_current_stack;
		    try{
		     caml_current_stack = {k: 0, x: 0, h: 0, e: 0};
		     var res = {joo_tramp: f, joo_args: args.concat(function(x){return x;})};
		     do{
		      caml_stack_depth = 40;
		      try{res = caml_call_gen(res.joo_tramp, res.joo_args);}
		      catch(e){
		       if(! caml_current_stack.x) throw e;
		       var handler = caml_current_stack.x.h;
		       caml_current_stack.x = caml_current_stack.x.t;
		       res = {joo_tramp: handler, joo_args: [caml_wrap_exception(e)]};
		      }
		     }
		     while
		      (res?.joo_args);
		    }
		    finally{
		     caml_stack_depth = saved_stack_depth;
		     caml_current_stack = saved_current_stack;
		    }
		    return res;
		   }
		   function caml_check_bound(array, index){
		    if(index >>> 0 >= array.length - 1) caml_array_bound_error();
		    return array;
		   }
		   function caml_classify_float(x){
		    if(Number.isFinite(x)){
		     if(Math.abs(x) >= 2.2250738585072014e-308) return 0;
		     if(x !== 0) return 1;
		     return 2;
		    }
		    return Number.isNaN(x) ? 4 : 3;
		   }
		   function caml_compare_val_get_custom(a){
		    return caml_custom_ops[a.caml_custom]
		           && caml_custom_ops[a.caml_custom].compare;
		   }
		   function caml_compare_val_tag(a){
		    if(a === null) return 1010;
		    if(typeof a === "number")
		     return 1000;
		    else if(caml_is_ml_bytes(a))
		     return 252;
		    else if(caml_is_ml_string(a))
		     return 1252;
		    else if(Array.isArray(a) && a[0] === a[0] >>> 0 && a[0] <= 255){var tag = a[0] | 0; return tag === 254 ? 0 : tag;}
		    else if(a instanceof String)
		     return 12520;
		    else if(typeof a === "string")
		     return 12520;
		    else if(a instanceof Number)
		     return 1000;
		    else if(a?.caml_custom)
		     return 1255;
		    else if(a?.compare)
		     return 1256;
		    else if(typeof a === "function")
		     return 1247;
		    else if(typeof a === "symbol") return 1251;
		    return 1001;
		   }
		   function caml_int_compare(a, b){
		    if(a < b) return - 1;
		    if(a === b) return 0;
		    return 1;
		   }
		   function caml_string_compare(s1, s2){
		    return s1 < s2 ? - 1 : s1 > s2 ? 1 : 0;
		   }
		   function caml_bytes_compare(s1, s2){
		    s1.t & 6 && caml_convert_string_to_bytes(s1);
		    s2.t & 6 && caml_convert_string_to_bytes(s2);
		    return s1.c < s2.c ? - 1 : s1.c > s2.c ? 1 : 0;
		   }
		   function caml_compare_val(a, b, total){
		    var stack = [];
		    for(;;){
		     if(! (total && a === b)){
		      var tag_a = caml_compare_val_tag(a);
		      if(tag_a === 250){a = a[1]; continue;}
		      var tag_b = caml_compare_val_tag(b);
		      if(tag_b === 250){b = b[1]; continue;}
		      if(tag_a !== tag_b){
		       if(tag_a === 1010) return - 1;
		       if(tag_b === 1010) return 1;
		       if(tag_a === 1000) return - 1;
		       if(tag_b === 1000) return 1;
		       return tag_a < tag_b ? - 1 : 1;
		      }
		      switch(tag_a){
		        case 247:
		         caml_invalid_argument("compare: functional value"); break;
		        case 248:
		         var x = caml_int_compare(a[2], b[2]) | 0;
		         if(x !== 0) return x;
		         break;
		        case 249:
		         caml_invalid_argument("compare: functional value"); break;
		        case 250:
		         caml_invalid_argument("equal: got Forward_tag, should not happen");
		         break;
		        case 251:
		         caml_invalid_argument("equal: abstract value"); break;
		        case 252:
		         if(a !== b){
		          var x = caml_bytes_compare(a, b) | 0;
		          if(x !== 0) return x;
		         }
		         break;
		        case 253:
		         caml_invalid_argument("equal: got Double_tag, should not happen");
		         break;
		        case 254:
		         caml_invalid_argument
		          ("equal: got Double_array_tag, should not happen");
		         break;
		        case 255:
		         caml_invalid_argument("equal: got Custom_tag, should not happen");
		         break;
		        case 1247:
		         caml_invalid_argument("compare: functional value"); break;
		        case 1255:
		         var comp = caml_compare_val_get_custom(a);
		         if(comp !== caml_compare_val_get_custom(b))
		          return a.caml_custom < b.caml_custom ? - 1 : 1;
		         if(! comp) caml_invalid_argument("compare: abstract value");
		         var x = comp(a, b, total);
		         if(Number.isNaN(x)) return total ? - 1 : x;
		         if(x !== (x | 0)) return - 1;
		         if(x !== 0) return x | 0;
		         break;
		        case 1256:
		         var x = a.compare(b, total);
		         if(Number.isNaN(x)) return total ? - 1 : x;
		         if(x !== (x | 0)) return - 1;
		         if(x !== 0) return x | 0;
		         break;
		        case 1000:
		         a = + a;
		         b = + b;
		         if(a < b) return - 1;
		         if(a > b) return 1;
		         if(a !== b){
		          if(! total) return Number.NaN;
		          if(! Number.isNaN(a)) return 1;
		          if(! Number.isNaN(b)) return - 1;
		         }
		         break;
		        case 1010: return 0;
		        case 1001:
		         if(a < b) return - 1;
		         if(a > b) return 1;
		         if(a !== b) return total ? 1 : Number.NaN;
		         break;
		        case 1251:
		         if(a !== b) return total ? 1 : Number.NaN; break;
		        case 1252:
		         var a = caml_jsbytes_of_string(a), b = caml_jsbytes_of_string(b);
		         if(a !== b){if(a < b) return - 1; if(a > b) return 1;}
		         break;
		        case 12520:
		         var a = a.toString(), b = b.toString();
		         if(a !== b){if(a < b) return - 1; if(a > b) return 1;}
		         break;
		        default:
		         if(caml_is_continuation_tag(tag_a)){
		          caml_invalid_argument("compare: continuation value");
		          break;
		         }
		         if(a.length !== b.length) return a.length < b.length ? - 1 : 1;
		         if(a.length > 1) stack.push(a, b, 1);
		         break;
		      }
		     }
		     if(stack.length === 0) return 0;
		     var i = stack.pop();
		     b = stack.pop();
		     a = stack.pop();
		     if(i + 1 < a.length) stack.push(a, b, i + 1);
		     a = a[i];
		     b = b[i];
		    }
		   }
		   function caml_compare(a, b){return caml_compare_val(a, b, true);}
		   function caml_continuation_use_noexc(cont){
		    var stack = cont[1];
		    cont[1] = 0;
		    return stack;
		   }
		   function caml_continuation_use_and_update_handler_noexc
		   (cont, hval, hexn, heff){
		    var stack = caml_continuation_use_noexc(cont);
		    if(stack === 0) return stack;
		    var last = cont[2];
		    last.h[1] = hval;
		    last.h[2] = hexn;
		    last.h[3] = heff;
		    return stack;
		   }
		   function caml_convert_raw_backtrace(){return [0];}
		   function caml_create_bytes(len){
		    if(len < 0) caml_invalid_argument("Bytes.create");
		    return new MlBytes(len ? 2 : 9, "", len);
		   }
		   function caml_csel_value(v_cond, v_true, v_false){return v_cond ? v_true : v_false;
		   }
		   function caml_div(x, y){
		    if(y === 0) caml_raise_zero_divide();
		    return x / y | 0;
		   }
		   var caml_domain_dls = [0];
		   function caml_domain_dls_compare_and_set(old, n){
		    if(caml_domain_dls !== old) return 0;
		    caml_domain_dls = n;
		    return 1;
		   }
		   function caml_domain_dls_get(_unit){return caml_domain_dls;}
		   function caml_domain_dls_set(a){caml_domain_dls = a; return 0;}
		   var caml_ephe_none = {caml_ephe_none: 0}, caml_ephe_data_offset = 2;
		   function caml_ephe_unset_data(x){
		    x[caml_ephe_data_offset] = caml_ephe_none;
		    return 0;
		   }
		   var caml_ephe_key_offset = 3;
		   function caml_ephe_set_data(x, data){
		    for(var i = x.length - 1; i >= caml_ephe_key_offset; i--){
		     var k = x[i];
		     if(globalThis.WeakRef && k instanceof globalThis.WeakRef){
		      var d = k.deref();
		      if(d === undefined){x[i] = caml_ephe_none; continue;}
		      if(globalThis.WeakMap) data = new globalThis.WeakMap().set(d, data);
		     }
		    }
		    x[caml_ephe_data_offset] = data;
		    return 0;
		   }
		   function caml_ephe_set_data_opt(x, data_opt){
		    if(data_opt === 0)
		     caml_ephe_unset_data(x);
		    else
		     caml_ephe_set_data(x, data_opt[1]);
		    return 0;
		   }
		   function caml_ephe_get_data(x){
		    var data = x[caml_ephe_data_offset];
		    if(data === caml_ephe_none) return 0;
		    for(var i = caml_ephe_key_offset; i < x.length; i++){
		     var k = x[i];
		     if(globalThis.WeakRef && k instanceof globalThis.WeakRef){
		      var d = k.deref();
		      if(d === undefined){
		       x[i] = caml_ephe_none;
		       x[caml_ephe_data_offset] = caml_ephe_none;
		       return 0;
		      }
		      if(globalThis.WeakMap){
		       data = data.get(d);
		       if(data === undefined){
		        x[caml_ephe_data_offset] = caml_ephe_none;
		        return 0;
		       }
		      }
		     }
		    }
		    return [0, data];
		   }
		   function caml_ephe_blit_key(a1, i1, a2, i2, len){
		    var old = caml_ephe_get_data(a2);
		    caml_array_blit
		     (a1,
		      caml_ephe_key_offset + i1 - 1,
		      a2,
		      caml_ephe_key_offset + i2 - 1,
		      len);
		    caml_ephe_set_data_opt(a2, old);
		    return 0;
		   }
		   function caml_ephe_check_key(x, i){
		    var weak = x[caml_ephe_key_offset + i];
		    if(weak === caml_ephe_none) return 0;
		    if(globalThis.WeakRef && weak instanceof globalThis.WeakRef){
		     weak = weak.deref();
		     if(weak === undefined){
		      x[caml_ephe_key_offset + i] = caml_ephe_none;
		      x[caml_ephe_data_offset] = caml_ephe_none;
		      return 0;
		     }
		    }
		    return 1;
		   }
		   function caml_weak_create(n){
		    var alen = caml_ephe_key_offset + n, x = new Array(alen);
		    x[0] = 251;
		    x[1] = "caml_ephe_list_head";
		    for(var i = 2; i < alen; i++) x[i] = caml_ephe_none;
		    return x;
		   }
		   function caml_ephe_create(n){return caml_weak_create(n);}
		   function caml_ephe_get_key(x, i){
		    var weak = x[caml_ephe_key_offset + i];
		    if(weak === caml_ephe_none) return 0;
		    if(globalThis.WeakRef && weak instanceof globalThis.WeakRef){
		     weak = weak.deref();
		     if(weak === undefined){
		      x[caml_ephe_key_offset + i] = caml_ephe_none;
		      x[caml_ephe_data_offset] = caml_ephe_none;
		      return 0;
		     }
		    }
		    return [0, weak];
		   }
		   function caml_ephe_set_key(x, i, v){
		    var old = caml_ephe_get_data(x);
		    if(globalThis.WeakRef && v instanceof Object)
		     v = new globalThis.WeakRef(v);
		    x[caml_ephe_key_offset + i] = v;
		    caml_ephe_set_data_opt(x, old);
		    return 0;
		   }
		   function caml_ephe_unset_key(x, i){
		    var old = caml_ephe_get_data(x);
		    x[caml_ephe_key_offset + i] = caml_ephe_none;
		    caml_ephe_set_data_opt(x, old);
		    return 0;
		   }
		   function caml_equal(x, y){return + (caml_compare_val(x, y, false) === 0);}
		   function caml_fill_bytes(s, i, l, c){
		    if(l > 0)
		     if(i === 0 && (l >= s.l || s.t === 2 && l >= s.c.length))
		      if(c === 0){
		       s.c = "";
		       s.t = 2;
		      }
		      else {
		       s.c = caml_str_repeat(l, String.fromCharCode(c));
		       s.t = l === s.l ? 0 : 2;
		      }
		     else {
		      if(s.t !== 4) caml_convert_bytes_to_array(s);
		      for(l += i; i < l; i++) s.c[i] = c;
		     }
		    return 0;
		   }
		   function caml_float_compare(x, y){
		    if(x === y) return 0;
		    if(x < y) return - 1;
		    if(x > y) return 1;
		    if(! Number.isNaN(x)) return 1;
		    if(! Number.isNaN(y)) return - 1;
		    return 0;
		   }
		   function caml_parse_float(s, err_msg){
		    var
		     res,
		     r_float = /^[ \t\n\v\f\r]*[-+]?(?:\d*\.?\d+|\d+\.?\d*)(?:[eE][-+]?\d+)?$/;
		    s = caml_jsbytes_of_string(s);
		    res = + s;
		    if(! Number.isNaN(res) && r_float.test(s)) return res;
		    s = s.replace(/_/g, "");
		    res = + s;
		    if
		     (! Number.isNaN(res) && r_float.test(s)
		      || /^[ \t\n\v\f\r]*[+-]?nan$/i.test(s))
		     return res;
		    var
		     m =
		       /^[ \t\n\v\f\r]*([+-]?)0x([0-9a-f]*)\.?([0-9a-f]*)(?:p([+-]?[0-9]+))?$/i.exec
		        (s);
		    if(m && m[2].length + m[3].length > 0){
		     var
		      sign = m[1] === "-" ? - 1 : 1,
		      mant = BigInt("0x0" + m[2] + m[3]),
		      e = (+ m[4] || 0) - 4 * m[3].length;
		     if(mant === 0n) return sign * 0;
		     for(;;){
		      var bl = mant.toString(2).length, be = bl - 1 + e;
		      if(be > 1023) return sign * Number.POSITIVE_INFINITY;
		      if(be < - 1075) return sign * 0;
		      var p = be >= - 1022 ? 53 : 53 + 1022 + be, shift = bl - p;
		      if(shift <= 0) return sign * Number(mant) * Math.pow(2, e);
		      var
		       keep = mant >> BigInt(shift),
		       rem = mant & (1n << BigInt(shift)) - 1n,
		       half = 1n << BigInt(shift - 1);
		      if(rem > half || rem === half && keep & 1n) keep += 1n;
		      if(keep < (p > 0 ? 1n << BigInt(p) : 1n))
		       return sign * Number(keep) * Math.pow(2, e + shift);
		      mant = keep;
		      e += shift;
		     }
		    }
		    if(/^[ \t\n\v\f\r]*\+?inf(inity)?$/i.test(s))
		     return Number.POSITIVE_INFINITY;
		    if(/^[ \t\n\v\f\r]*-inf(inity)?$/i.test(s))
		     return Number.NEGATIVE_INFINITY;
		    caml_failwith(err_msg);
		   }
		   function caml_float_of_string(s){
		    return caml_parse_float(s, "float_of_string");
		   }
		   function caml_parse_format(fmt){
		    fmt = caml_jsbytes_of_string(fmt);
		    var len = fmt.length;
		    if(len > 31) caml_invalid_argument("format_int: format too long");
		    var
		     f =
		       {justify: "+",
		        signstyle: "-",
		        filler: " ",
		        alternate: false,
		        base: 0,
		        signedconv: false,
		        width: 0,
		        uppercase: false,
		        sign: 1,
		        prec: - 1,
		        conv: "f"};
		    for(var i = 0; i < len; i++){
		     var c = fmt.charAt(i);
		     switch(c){
		       case "-":
		        f.justify = "-"; break;
		       case "+":
		       case " ":
		        f.signstyle = c; break;
		       case "0":
		        f.filler = "0"; break;
		       case "#":
		        f.alternate = true; break;
		       case "1":
		       case "2":
		       case "3":
		       case "4":
		       case "5":
		       case "6":
		       case "7":
		       case "8":
		       case "9":
		        f.width = 0;
		        while(c = fmt.charCodeAt(i) - 48, c >= 0 && c <= 9){f.width = f.width * 10 + c; i++;}
		        i--;
		        break;
		       case ".":
		        f.prec = 0;
		        i++;
		        while(c = fmt.charCodeAt(i) - 48, c >= 0 && c <= 9){f.prec = f.prec * 10 + c; i++;}
		        i--;
		        break;
		       case "d":
		       case "i":
		        f.signedconv = true; f.base = 10; break;
		       case "u":
		        f.base = 10; break;
		       case "x":
		        f.base = 16; break;
		       case "X":
		        f.base = 16; f.uppercase = true; break;
		       case "o":
		        f.base = 8; break;
		       case "e":
		       case "f":
		       case "g":
		        f.signedconv = true; f.conv = c; break;
		       case "E":
		       case "F":
		       case "G":
		        f.signedconv = true;
		        f.uppercase = true;
		        f.conv = c.toLowerCase();
		        break;
		     }
		    }
		    return f;
		   }
		   function caml_finish_formatting(f, rawbuffer){
		    if(f.uppercase) rawbuffer = rawbuffer.toUpperCase();
		    var len = rawbuffer.length;
		    if(f.signedconv && (f.sign < 0 || f.signstyle !== "-")) len++;
		    var alternate = f.alternate && rawbuffer !== "0";
		    if(alternate){if(f.base === 8) len += 1; if(f.base === 16) len += 2;}
		    var buffer = "";
		    if(f.justify === "+" && f.filler === " ")
		     for(var i = len; i < f.width; i++) buffer += " ";
		    if(f.signedconv)
		     if(f.sign < 0)
		      buffer += "-";
		     else if(f.signstyle !== "-") buffer += f.signstyle;
		    if(alternate && f.base === 8) buffer += "0";
		    if(alternate && f.base === 16) buffer += f.uppercase ? "0X" : "0x";
		    if(f.justify === "+" && f.filler === "0")
		     for(var i = len; i < f.width; i++) buffer += "0";
		    buffer += rawbuffer;
		    if(f.justify === "-") for(var i = len; i < f.width; i++) buffer += " ";
		    return caml_string_of_jsbytes(buffer);
		   }
		   function caml_format_float(fmt, x){
		    function decompose(x){
		     var dv = new DataView(new ArrayBuffer(8));
		     dv.setFloat64(0, x);
		     var
		      hi = dv.getUint32(0),
		      lo = dv.getUint32(4),
		      eb = hi >>> 20 & 0x7ff,
		      m = BigInt(hi & 0xfffff) << 32n | BigInt(lo);
		     if(eb === 0) return [m, - 1074];
		     return [m | 1n << 52n, eb - 1075];
		    }
		    function exact_scaled(x, k){
		     var d = decompose(x), num = d[0], den = 1n;
		     if(k >= 0) num *= 10n ** BigInt(k); else den = 10n ** BigInt(- k);
		     if(d[1] >= 0) num <<= BigInt(d[1]); else den <<= BigInt(- d[1]);
		     var q = num / den, r2 = num % den * 2n;
		     if(r2 > den || r2 === den && q & 1n) q += 1n;
		     return q;
		    }
		    function exact_fixed(x, prec){
		     var q = exact_scaled(x, prec).toString();
		     if(prec === 0) return q;
		     if(q.length <= prec) q = caml_str_repeat(prec + 1 - q.length, "0") + q;
		     return q.slice(0, q.length - prec) + "." + q.slice(q.length - prec);
		    }
		    function exact_exponential(x, prec){
		     if(x === 0)
		      return (prec > 0 ? "0." + caml_str_repeat(prec, "0") : "0") + "e+0";
		     var e10 = Math.floor(Math.log10(x));
		     for(;;){
		      var s = exact_scaled(x, prec - e10).toString();
		      if(s.length === prec + 1){
		       var m = prec > 0 ? s.charAt(0) + "." + s.slice(1) : s;
		       return m + "e" + (e10 < 0 ? "-" : "+") + Math.abs(e10);
		      }
		      e10 += s.length - (prec + 1);
		     }
		    }
		    function toExponential(x, prec){
		     return prec > 100 ? exact_exponential(x, prec) : x.toExponential(prec);
		    }
		    function toFixed(x, dp){
		     if(dp > 100 || x >= 1e21) return exact_fixed(x, dp);
		     return x.toFixed(dp);
		    }
		    var s, f = caml_parse_format(fmt), prec = f.prec < 0 ? 6 : f.prec;
		    if(x < 0 || x === 0 && 1 / x === Number.NEGATIVE_INFINITY){f.sign = - 1; x = - x;}
		    if(Number.isNaN(x)){
		     s = "nan";
		     f.filler = " ";
		    }
		    else if(! Number.isFinite(x)){s = "inf"; f.filler = " ";}
		    else
		     switch(f.conv){
		       case "e":
		        var s = toExponential(x, prec), i = s.length;
		        if(s.charAt(i - 3) === "e")
		         s = s.slice(0, i - 1) + "0" + s.slice(i - 1);
		        break;
		       case "f":
		        s = toFixed(x, prec); break;
		       case "g":
		        prec = prec ? prec : 1;
		        s = toExponential(x, prec - 1);
		        var j = s.indexOf("e"), exp = + s.slice(j + 1);
		        if(exp < - 4 || x >= 1e21 || x.toFixed(0).length > prec){
		         var i = j - 1;
		         while(s.charAt(i) === "0") i--;
		         if(s.charAt(i) === ".") i--;
		         s = s.slice(0, i + 1) + s.slice(j);
		         i = s.length;
		         if(s.charAt(i - 3) === "e")
		          s = s.slice(0, i - 1) + "0" + s.slice(i - 1);
		         break;
		        }
		        else {
		         var p = prec;
		         if(exp < 0){
		          p -= exp + 1;
		          s = toFixed(x, p);
		         }
		         else
		          while(s = toFixed(x, p), s.length > prec + 1) p--;
		         if(p){
		          var i = s.length - 1;
		          while(s.charAt(i) === "0") i--;
		          if(s.charAt(i) === ".") i--;
		          s = s.slice(0, i + 1);
		         }
		        }
		        break;
		     }
		    return caml_finish_formatting(f, s);
		   }
		   function caml_format_int(fmt, i){
		    if(caml_jsbytes_of_string(fmt) === "%d")
		     return caml_string_of_jsbytes("" + i);
		    var f = caml_parse_format(fmt);
		    if(i < 0) if(f.signedconv){f.sign = - 1; i = - i;} else i >>>= 0;
		    var s = i.toString(f.base);
		    if(f.prec >= 0){
		     f.filler = " ";
		     var n = f.prec - s.length;
		     if(n > 0) s = caml_str_repeat(n, "0") + s;
		    }
		    return caml_finish_formatting(f, s);
		   }
		   var caml_oo_last_id = 0;
		   function caml_fresh_oo_id(){return caml_oo_last_id++;}
		   var jsoo_text_decoder_buff = new ArrayBuffer(1024);
		   function caml_jsstring_of_string(s){
		    if(jsoo_is_ascii(s)) return s;
		    var
		     a =
		       s.length <= jsoo_text_decoder_buff.byteLength
		        ? new Uint8Array(jsoo_text_decoder_buff, 0, s.length)
		        : new Uint8Array(s.length);
		    for(var i = 0; i < s.length; i++) a[i] = s.charCodeAt(i);
		    return jsoo_text_decoder.decode(a);
		   }
		   var
		    jsoo_is_win32 =
		      globalThis.Deno?.build?.os === "windows"
		      || globalThis.process?.platform === "win32";
		   function fs_node_supported(){return false;}
		   function make_path_is_absolute(){
		    function posix(path){
		     if(path.charAt(0) === "/") return ["", path.slice(1)];
		     return;
		    }
		    function win32(path){
		     var
		      splitDeviceRe =
		        /^([a-zA-Z]:|[\\/]{2}[^\\/]+[\\/]+[^\\/]+)?([\\/])?([\s\S]*?)$/,
		      result = splitDeviceRe.exec(path),
		      device = result[1] || "",
		      isUnc = device.length > 0 && device.charAt(1) !== ":";
		     if(result[2] || isUnc){
		      var root = result[1] || "", sep = result[2] || "";
		      return [root, path.slice(root.length + sep.length)];
		     }
		     return;
		    }
		    return jsoo_is_win32 ? win32 : posix;
		   }
		   var path_is_absolute = make_path_is_absolute();
		   function caml_raise_sys_error(msg){
		    caml_raise_with_arg
		     (caml_global_data["predef:Sys_error"], caml_string_of_jsstring(msg));
		   }
		   function caml_raise_with_args(tag, args){
		    throw caml_maybe_attach_backtrace([0, tag].concat(args));
		   }
		   var
		    unix_error =
		      ["E2BIG",
		       "EACCES",
		       "EAGAIN",
		       "EBADF",
		       "EBUSY",
		       "ECHILD",
		       "EDEADLK",
		       "EDOM",
		       "EEXIST",
		       "EFAULT",
		       "EFBIG",
		       "EINTR",
		       "EINVAL",
		       "EIO",
		       "EISDIR",
		       "EMFILE",
		       "EMLINK",
		       "ENAMETOOLONG",
		       "ENFILE",
		       "ENODEV",
		       "ENOENT",
		       "ENOEXEC",
		       "ENOLCK",
		       "ENOMEM",
		       "ENOSPC",
		       "ENOSYS",
		       "ENOTDIR",
		       "ENOTEMPTY",
		       "ENOTTY",
		       "ENXIO",
		       "EPERM",
		       "EPIPE",
		       "ERANGE",
		       "EROFS",
		       "ESPIPE",
		       "ESRCH",
		       "EXDEV",
		       "EWOULDBLOCK",
		       "EINPROGRESS",
		       "EALREADY",
		       "ENOTSOCK",
		       "EDESTADDRREQ",
		       "EMSGSIZE",
		       "EPROTOTYPE",
		       "ENOPROTOOPT",
		       "EPROTONOSUPPORT",
		       "ESOCKTNOSUPPORT",
		       "EOPNOTSUPP",
		       "EPFNOSUPPORT",
		       "EAFNOSUPPORT",
		       "EADDRINUSE",
		       "EADDRNOTAVAIL",
		       "ENETDOWN",
		       "ENETUNREACH",
		       "ENETRESET",
		       "ECONNABORTED",
		       "ECONNRESET",
		       "ENOBUFS",
		       "EISCONN",
		       "ENOTCONN",
		       "ESHUTDOWN",
		       "ETOOMANYREFS",
		       "ETIMEDOUT",
		       "ECONNREFUSED",
		       "EHOSTDOWN",
		       "EHOSTUNREACH",
		       "ELOOP",
		       "EOVERFLOW"];
		   function make_unix_err_args(code, syscall, path, errno){
		    var variant = unix_error.indexOf(code);
		    if(variant < 0){if(errno == null) errno = - 9999; variant = [0, - errno];}
		    var
		     args =
		       [variant,
		        caml_string_of_jsstring(syscall || ""),
		        caml_string_of_jsstring(path || "")];
		    return args;
		   }
		   function caml_raise_system_error(raise_unix, code, cmd, msg, path){
		    var unix_error = caml_named_value("Unix.Unix_error");
		    if(raise_unix && unix_error)
		     caml_raise_with_args(unix_error, make_unix_err_args(code, cmd, path));
		    else {
		     var msg = code + ": " + msg + ", " + cmd;
		     if(path !== undefined) msg += " '" + path + "'";
		     caml_raise_sys_error(msg);
		    }
		   }
		   function caml_trailing_slash(name){
		    return name.slice(- 1) !== "/" ? name + "/" : name;
		   }
		   var
		    caml_current_dir =
		      function(){
		        return "/static";
		       }
		       ();
		   caml_current_dir = caml_trailing_slash(caml_current_dir);
		   function caml_make_path(name, raise_unix){
		    name = caml_jsstring_of_string(name);
		    if(name === "")
		     caml_raise_system_error
		      (raise_unix, "ENOENT", "", "No such file or directory", "");
		    if(! path_is_absolute(name)) name = caml_current_dir + name;
		    var
		     comp0 = path_is_absolute(name),
		     comp = comp0[1].split(/[/\\]/),
		     ncomp = [];
		    for(var i = 0; i < comp.length; i++)
		     switch(comp[i]){
		       case "..":
		        ncomp.pop(); break;
		       case ".": break;
		       case "": break;
		       default: ncomp.push(comp[i]); break;
		     }
		    ncomp.unshift(comp0[0]);
		    ncomp.orig = name;
		    return ncomp;
		   }
		   function caml_bytes_of_array(a){
		    if(! (a instanceof Uint8Array)) a = new Uint8Array(a);
		    return new MlBytes(4, a, a.length);
		   }
		   function caml_raise_no_such_file(name, raise_unix, cmd){
		    if(raise_unix)
		     caml_raise_system_error
		      (raise_unix, "ENOENT", cmd || "open", "no such file or directory", name);
		    caml_raise_sys_error(name + ": No such file or directory");
		   }
		   function MlFile(){}
		   class MlFakeFile extends MlFile {
		     constructor(content){super(); this.data = content;}
		     truncate(len){
		      var old = this.data, old_len = caml_ml_bytes_length(old);
		      this.data = caml_create_bytes(len | 0);
		      caml_blit_bytes(old, 0, this.data, 0, Math.min(len, old_len));
		     }
		     length(){return caml_ml_bytes_length(this.data);}
		     write(offset, buf, pos, len){
		      var clen = this.length();
		      if(offset + len >= clen){
		       var new_str = caml_create_bytes(offset + len), old_data = this.data;
		       this.data = new_str;
		       caml_blit_bytes(old_data, 0, this.data, 0, clen);
		      }
		      caml_blit_bytes
		       (caml_bytes_of_uint8_array(buf), pos, this.data, offset, len);
		      return len;
		     }
		     read(offset, buf, pos, len){
		      var clen = this.length();
		      if(offset + len >= clen) len = clen - offset;
		      if(len > 0){
		       var data = caml_create_bytes(len | 0);
		       caml_blit_bytes(this.data, offset, data, 0, len);
		       buf.set(caml_uint8_array_of_bytes(data), pos);
		       return len;
		      }
		      return 0;
		     }
		   }
		   class MlFakeFd{
		     constructor(name, file, flags){
		      this.file = file;
		      this.name = name;
		      this.flags = flags;
		      this.offset = 0;
		      this.seeked = false;
		     }
		     err_closed(cmd, raise_unix){
		      caml_raise_system_error(raise_unix, "EBADF", cmd, "bad file descriptor");
		     }
		     length(raise_unix){
		      if(this.file) return this.file.length();
		      this.err_closed("length", raise_unix);
		     }
		     truncate(len, raise_unix){
		      if(this.file){
		       if(! (this.flags.wronly || this.flags.rdwr))
		        caml_raise_system_error
		         (raise_unix, "EINVAL", "truncate", "invalid argument");
		       return this.file.truncate(len);
		      }
		      this.err_closed("truncate", raise_unix);
		     }
		     write(buf, pos, len, raise_unix){
		      if(this.file && (this.flags.wronly || this.flags.rdwr)){
		       if(this.flags.append) this.offset = this.file.length();
		       var offset = this.offset;
		       len = this.file.write(offset, buf, pos, len);
		       this.offset += len;
		       return len;
		      }
		      this.err_closed("write", raise_unix);
		     }
		     read(buf, pos, len, raise_unix){
		      if(this.file && ! this.flags.wronly){
		       var offset = this.offset;
		       len = this.file.read(offset, buf, pos, len);
		       this.offset += len;
		       return len;
		      }
		      this.err_closed("read", raise_unix);
		     }
		     seek(offset, whence, raise_unix){
		      switch(whence){
		        case 0: break;
		        case 1:
		         offset += this.offset; break;
		        case 2:
		         offset += this.length(); break;
		      }
		      if(offset < 0)
		       caml_raise_system_error
		        (raise_unix, "EINVAL", "lseek", "invalid argument");
		      this.offset = offset;
		      this.seeked = true;
		      return offset;
		     }
		     pos(){return this.offset;}
		     close(raise_unix){
		      if(! this.file) this.err_closed("close", raise_unix);
		      this.file = undefined;
		     }
		     check_stream_semantics(cmd){
		      if(! this.file) return this.err_closed(cmd, 1);
		     }
		   }
		   class MlFakeDevice{
		     constructor(root, f){
		      this.content = {};
		      this.root = root;
		      this.lookupFun = f;
		     }
		     nm(name){return this.root + name;}
		     create_dir_if_needed(name){
		      var comp = name.split("/"), res = "";
		      for(var i = 0; i < comp.length - 1; i++){
		       res += comp[i] + "/";
		       if(this.content[res]) continue;
		       this.content[res] = Symbol("directory");
		      }
		     }
		     slash(name){return /\/$/.test(name) ? name : name + "/";}
		     lookup(name){
		      if(! this.content[name] && this.lookupFun){
		       var
		        res =
		          this.lookupFun
		           (caml_string_of_jsstring(this.root), caml_string_of_jsstring(name));
		       if(res !== 0){
		        this.create_dir_if_needed(name);
		        this.content[name] = new MlFakeFile(caml_bytes_of_string(res[1]));
		       }
		      }
		     }
		     exists(name, do_not_lookup){
		      if(name === "") return 1;
		      var name_slash = this.slash(name);
		      if(this.content[name_slash]) return 1;
		      if(! do_not_lookup) this.lookup(name);
		      return this.content[name] ? 1 : 0;
		     }
		     isFile(name){return this.exists(name) && ! this.is_dir(name) ? 1 : 0;}
		     rename_dir(oldname, newname, raise_unix){
		      var old_slash = this.slash(oldname), new_slash = this.slash(newname);
		      if(newname !== oldname && new_slash.startsWith(old_slash))
		       caml_raise_system_error
		        (raise_unix, "EINVAL", "rename", "invalid argument", this.nm(newname));
		      if(this.exists(newname)){
		       if(! this.is_dir(newname))
		        caml_raise_system_error
		         (raise_unix,
		          "ENOTDIR",
		          "rename",
		          "not a directory",
		          this.nm(newname));
		       if(this.readdir(newname).length > 0)
		        caml_raise_system_error
		         (raise_unix,
		          "ENOTEMPTY",
		          "rename",
		          "directory not empty",
		          this.nm(newname));
		      }
		      this.create_dir_if_needed(new_slash);
		      for(const f of this.readdir(oldname))
		       this.rename(old_slash + f, new_slash + f, raise_unix);
		      delete this.content[old_slash];
		     }
		     rename(oldname, newname, raise_unix){
		      if(! this.exists(oldname))
		       caml_raise_no_such_file(this.nm(oldname), raise_unix, "rename");
		      if(this.is_dir(oldname))
		       this.rename_dir(oldname, newname, raise_unix);
		      else {
		       if(this.exists(newname) && this.is_dir(newname))
		        caml_raise_system_error
		         (raise_unix, "EISDIR", "rename", "is a directory", this.nm(newname));
		       if(newname !== oldname){
		        this.content[newname] = this.content[oldname];
		        delete this.content[oldname];
		       }
		      }
		     }
		     mkdir(name, _mode, raise_unix){
		      if(this.exists(name))
		       caml_raise_system_error
		        (raise_unix, "EEXIST", "mkdir", "file already exists", this.nm(name));
		      var parent = /^(.*)\/[^/]+/.exec(name);
		      parent = parent?.[1] || "";
		      if(! this.exists(parent))
		       caml_raise_system_error
		        (raise_unix,
		         "ENOENT",
		         "mkdir",
		         "no such file or directory",
		         this.nm(name));
		      if(! this.is_dir(parent))
		       caml_raise_system_error
		        (raise_unix, "ENOTDIR", "mkdir", "not a directory", this.nm(name));
		      this.create_dir_if_needed(this.slash(name));
		     }
		     rmdir(name, raise_unix){
		      var name_slash = name === "" ? "" : this.slash(name);
		      if(! this.exists(name))
		       caml_raise_system_error
		        (raise_unix,
		         "ENOENT",
		         "rmdir",
		         "no such file or directory",
		         this.nm(name));
		      if(! this.is_dir(name))
		       caml_raise_system_error
		        (raise_unix, "ENOTDIR", "rmdir", "not a directory", this.nm(name));
		      for(var n in this.content)
		       if(n.startsWith(name_slash) && n !== name_slash)
		        caml_raise_system_error
		         (raise_unix,
		          "ENOTEMPTY",
		          "rmdir",
		          "directory not empty",
		          this.nm(name));
		      delete this.content[name_slash];
		     }
		     readdir(name, raise_unix){
		      var name_slash = name === "" ? "" : this.slash(name);
		      if(! this.exists(name))
		       caml_raise_no_such_file(this.nm(name), raise_unix, "readdir");
		      if(! this.is_dir(name))
		       caml_raise_system_error
		        (raise_unix, "ENOTDIR", "readdir", "not a directory", this.nm(name));
		      var seen = {}, a = [];
		      for(var n in this.content)
		       if(n.startsWith(name_slash) && n !== name_slash){
		        var last = n.indexOf("/", name_slash.length);
		        if(last < 0) last = undefined;
		        var m = n.slice(name_slash.length, last);
		        if(m && ! seen[m]){seen[m] = true; a.push(m);}
		       }
		      return a;
		     }
		     opendir(name, raise_unix){
		      var a = this.readdir(name, raise_unix), c = false, i = 0;
		      return {readSync:
		              function(){
		               if(c)
		                caml_raise_system_error
		                 (raise_unix, "EBADF", "readdir", "bad file descriptor");
		               if(i === a.length) return null;
		               var entry = a[i];
		               i++;
		               return {name: entry};
		              },
		              closeSync:
		              function(){
		               if(c)
		                caml_raise_system_error
		                 (raise_unix, "EBADF", "readdir", "bad file descriptor");
		               c = true;
		               a = [];
		              }};
		     }
		     is_dir(name){
		      if(name === "") return true;
		      var name_slash = this.slash(name);
		      return this.content[name_slash] ? 1 : 0;
		     }
		     unlink(name, raise_unix){
		      if(! this.exists(name, true))
		       caml_raise_system_error
		        (raise_unix, "ENOENT", "unlink", "no such file or directory", name);
		      if(this.is_dir(name))
		       caml_raise_system_error
		        (raise_unix, "EISDIR", "unlink", "is a directory", this.nm(name));
		      delete this.content[name];
		      return 0;
		     }
		     access(name, _flags, raise_unix){
		      this.lookup(name);
		      if(! this.exists(name))
		       caml_raise_no_such_file(this.nm(name), raise_unix, "access");
		      return 0;
		     }
		     open(name, f, _perms, raise_unix){
		      var file;
		      this.lookup(name);
		      if(this.content[name]){
		       if(this.is_dir(name))
		        caml_raise_system_error
		         (raise_unix,
		          "EISDIR",
		          "open",
		          "illegal operation on a directory",
		          this.nm(name));
		       if(f.create && f.excl)
		        caml_raise_system_error
		         (raise_unix, "EEXIST", "open", "file already exists", this.nm(name));
		       file = this.content[name];
		       if(f.truncate) file.truncate(0);
		      }
		      else if(f.create){
		       this.create_dir_if_needed(name);
		       this.content[name] = new MlFakeFile(caml_create_bytes(0));
		       file = this.content[name];
		      }
		      else
		       caml_raise_no_such_file(this.nm(name), raise_unix, "open");
		      return new MlFakeFd(this.nm(name), file, f);
		     }
		     truncate(name, len, raise_unix){
		      var file;
		      this.lookup(name);
		      if(this.content[name]){
		       if(this.is_dir(name))
		        caml_raise_system_error
		         (raise_unix,
		          "EISDIR",
		          "open",
		          "illegal operation on a directory",
		          this.nm(name));
		       file = this.content[name];
		       file.truncate(len);
		      }
		      else
		       caml_raise_no_such_file(this.nm(name), raise_unix, "truncate");
		     }
		     register(name, content){
		      var file;
		      if(this.content[name])
		       caml_raise_sys_error(this.nm(name) + " : file already exists");
		      if(caml_is_ml_bytes(content))
		       file = new MlFakeFile(content);
		      else if(caml_is_ml_string(content))
		       file = new MlFakeFile(caml_bytes_of_string(content));
		      else if(Array.isArray(content))
		       file = new MlFakeFile(caml_bytes_of_array(content));
		      else if(typeof content === "string")
		       file = new MlFakeFile(caml_bytes_of_jsbytes(content));
		      else if(content.toString){
		       var
		        bytes =
		          caml_bytes_of_string(caml_string_of_jsstring(content.toString()));
		       file = new MlFakeFile(bytes);
		      }
		      if(file){
		       this.create_dir_if_needed(name);
		       this.content[name] = file;
		      }
		      else
		       caml_raise_sys_error
		        (this.nm(name) + " : registering file with invalid content type");
		     }
		   }
		   class MlNodeDevice{}
		   function caml_get_root(path){
		    var x = path_is_absolute(path);
		    if(! x) return;
		    return x[0] + "/";
		   }
		   var
		    caml_root =
		      caml_get_root(caml_current_dir)
		      || caml_failwith("unable to compute caml_root"),
		    jsoo_mount_point = [];
		   jsoo_mount_point.push
		     ({path: caml_root, device: new MlFakeDevice(caml_root)});
		   jsoo_mount_point.push
		    ({path: "/static/", device: new MlFakeDevice("/static/")});
		   function resolve_fs_device(name, raise_unix){
		    var
		     path = caml_make_path(name, raise_unix),
		     name = path.join("/"),
		     name_slash = caml_trailing_slash(name),
		     res;
		    for(var i = 0; i < jsoo_mount_point.length; i++){
		     var m = jsoo_mount_point[i];
		     if
		      (name_slash.startsWith(m.path)
		       && (! res || res.path.length < m.path.length))
		      res =
		       {path: m.path,
		        device: m.device,
		        rest: name.slice(m.path.length, name.length)};
		    }
		    if(! res && fs_node_supported()){
		     var root = caml_get_root(name);
		     if(root?.match(/^[a-zA-Z]:\/$/)){
		      var m = {path: root, device: new MlNodeDevice(root)};
		      jsoo_mount_point.push(m);
		      res =
		       {path: m.path,
		        device: m.device,
		        rest: name.slice(m.path.length, name.length)};
		     }
		    }
		    if(res) return res;
		    caml_raise_sys_error("no device found for " + name_slash);
		   }
		   function caml_create_file(name, content){
		    var root = resolve_fs_device(name);
		    if(! root.device.register) caml_failwith("cannot register file");
		    root.device.register(root.rest, content);
		    return 0;
		   }
		   function jsoo_create_file(name, content){
		    var
		     name = caml_string_of_jsstring(name),
		     content = caml_string_of_jsbytes(content);
		    return caml_create_file(name, content);
		   }
		   function caml_fs_init(){
		    var tmp = globalThis.jsoo_fs_tmp;
		    if(tmp)
		     for(var i = 0; i < tmp.length; i++)
		      jsoo_create_file(tmp[i].name, tmp[i].content);
		    globalThis.jsoo_create_file = jsoo_create_file;
		    globalThis.jsoo_fs_tmp = [];
		    return 0;
		   }
		   function caml_gc_quick_stat(_unit){
		    return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		   }
		   function caml_get_current_callstack(){return [0];}
		   function caml_get_exception_raw_backtrace(_unit){return [0];}
		   function caml_get_public_method(obj, tag){
		    var meths = obj[1], li = 3, hi = meths[1] * 2 + 1, mi;
		    while(li < hi){
		     mi = li + hi >> 1 | 1;
		     if(tag < meths[mi + 1]) hi = mi - 2; else li = mi;
		    }
		    return tag === meths[li + 1] ? meths[li] : 0;
		   }
		   function caml_greaterequal(x, y){
		    return + (caml_compare_val(x, y, false) >= 0);
		   }
		   function caml_greaterthan(x, y){
		    return + (caml_compare_val(x, y, false) > 0);
		   }
		   function caml_hexstring_of_float(x, prec, style){
		    if(! Number.isFinite(x)){
		     if(Number.isNaN(x)) return caml_string_of_jsstring("nan");
		     return caml_string_of_jsstring(x > 0 ? "infinity" : "-infinity");
		    }
		    var
		     sign = x === 0 && 1 / x === Number.NEGATIVE_INFINITY ? 1 : x >= 0 ? 0 : 1;
		    if(sign) x = - x;
		    var exp = 0;
		    if(x === 0)
		     ;
		    else if(x < 1)
		     while(x < 1 && exp > - 1022){x *= 2; exp--;}
		    else
		     while(x >= 2){x /= 2; exp++;}
		    var exp_sign = exp < 0 ? "" : "+", sign_str = "";
		    if(sign)
		     sign_str = "-";
		    else
		     switch(style){
		       case 43:
		        sign_str = "+"; break;
		       case 32:
		        sign_str = " "; break;
		     }
		    if(prec >= 0 && prec < 13){
		     var cst = Math.pow(2, prec * 4);
		     x = Math.round(x * cst) / cst;
		    }
		    var x_str = x.toString(16);
		    if(prec >= 0){
		     var idx = x_str.indexOf(".");
		     if(idx < 0)
		      x_str += "." + caml_str_repeat(prec, "0");
		     else {
		      var size = idx + 1 + prec;
		      if(x_str.length < size)
		       x_str += caml_str_repeat(size - x_str.length, "0");
		      else
		       x_str = x_str.slice(0, size);
		     }
		    }
		    return caml_string_of_jsstring
		            (sign_str + "0x" + x_str + "p" + exp_sign + exp.toString(10));
		   }
		   function caml_int32_bswap(x){
		    return (x & 0x000000ff) << 24 | (x & 0x0000ff00) << 8
		           | (x & 0x00ff0000) >>> 8
		           | (x & 0xff000000) >>> 24;
		   }
		   function caml_int64_add(x, y){return x.add(y);}
		   function caml_int64_and(x, y){return x.and(y);}
		   function caml_int64_bswap(x){
		    var y = caml_int64_to_bytes(x);
		    return caml_int64_of_bytes
		            ([y[7], y[6], y[5], y[4], y[3], y[2], y[1], y[0]]);
		   }
		   function caml_int64_div(x, y){return x.div(y);}
		   function caml_int64_is_zero(x){return + x.isZero();}
		   function caml_int64_of_int32(x){
		    return new MlInt64(x & 0xffffff, x >> 24 & 0xffffff, x >> 31 & 0xffff);
		   }
		   function caml_int64_to_int32(x){return x.toInt();}
		   function caml_int64_is_negative(x){return + x.isNeg();}
		   function caml_int64_neg(x){return x.neg();}
		   function caml_int64_format(fmt, x){
		    var f = caml_parse_format(fmt);
		    if(f.signedconv && caml_int64_is_negative(x)){f.sign = - 1; x = caml_int64_neg(x);}
		    var
		     buffer = "",
		     wbase = caml_int64_of_int32(f.base),
		     cvtbl = "0123456789abcdef";
		    do{
		     var p = x.udivmod(wbase);
		     x = p.quotient;
		     buffer = cvtbl.charAt(caml_int64_to_int32(p.modulus)) + buffer;
		    }
		    while
		     (! caml_int64_is_zero(x));
		    if(f.prec >= 0){
		     f.filler = " ";
		     var n = f.prec - buffer.length;
		     if(n > 0) buffer = caml_str_repeat(n, "0") + buffer;
		    }
		    return caml_finish_formatting(f, buffer);
		   }
		   function caml_int64_mod(x, y){return x.mod(y);}
		   function caml_int64_mul(x, y){return x.mul(y);}
		   function caml_int64_of_float(x){
		    if(x < 0) x = Math.ceil(x);
		    return new
		            MlInt64
		            (x & 0xffffff,
		             Math.floor(x * caml_int64_offset) & 0xffffff,
		             Math.floor(x * caml_int64_offset * caml_int64_offset) & 0xffff);
		   }
		   function caml_int64_ult(x, y){return x.ucompare(y) < 0;}
		   function caml_parse_sign_and_base(s){
		    var
		     i = 0,
		     len = caml_ml_string_length(s),
		     base = 10,
		     sign = 1,
		     signedness = 1;
		    if(len > 0)
		     switch(caml_string_unsafe_get(s, i)){
		       case 45:
		        i++; sign = - 1; break;
		       case 43:
		        i++; sign = 1; break;
		     }
		    if(i + 1 < len && caml_string_unsafe_get(s, i) === 48)
		     switch(caml_string_unsafe_get(s, i + 1)){
		       case 120:
		       case 88:
		        signedness = 0; base = 16; i += 2; break;
		       case 111:
		       case 79:
		        signedness = 0; base = 8; i += 2; break;
		       case 98:
		       case 66:
		        signedness = 0; base = 2; i += 2; break;
		       case 117:
		       case 85:
		        signedness = 0; i += 2; break;
		     }
		    return [i, sign, base, signedness];
		   }
		   function caml_parse_digit(c){
		    if(c >= 48 && c <= 57) return c - 48;
		    if(c >= 65 && c <= 90) return c - 55;
		    if(c >= 97 && c <= 122) return c - 87;
		    return - 1;
		   }
		   function caml_int64_of_string(s){
		    var
		     r = caml_parse_sign_and_base(s),
		     i = r[0],
		     sign = r[1],
		     base = r[2],
		     signedness = r[3],
		     base64 = caml_int64_of_int32(base),
		     threshold = MlInt64.UNSIGNED_MAX.udivmod(base64).quotient,
		     c = caml_string_unsafe_get(s, i),
		     d = caml_parse_digit(c);
		    if(d < 0 || d >= base) caml_failwith("Int64.of_string");
		    var res = caml_int64_of_int32(d);
		    for(;;){
		     i++;
		     c = caml_string_unsafe_get(s, i);
		     if(c === 95) continue;
		     d = caml_parse_digit(c);
		     if(d < 0 || d >= base) break;
		     if(caml_int64_ult(threshold, res)) caml_failwith("Int64.of_string");
		     d = caml_int64_of_int32(d);
		     res = caml_int64_add(caml_int64_mul(base64, res), d);
		     if(caml_int64_ult(res, d)) caml_failwith("Int64.of_string");
		    }
		    if(i !== caml_ml_string_length(s)) caml_failwith("Int64.of_string");
		    if
		     (signedness
		      &&
		       caml_int64_ult(sign < 0 ? MlInt64.SIGNED_MIN : MlInt64.SIGNED_MAX, res))
		     caml_failwith("Int64.of_string");
		    if(sign < 0) res = caml_int64_neg(res);
		    return res;
		   }
		   function caml_int64_or(x, y){return x.or(y);}
		   function caml_int64_shift_left(x, s){return x.shift_left(s);}
		   function caml_int64_shift_right(x, s){return x.shift_right(s);}
		   function caml_int64_shift_right_unsigned(x, s){return x.shift_right_unsigned(s);
		   }
		   function caml_int64_sub(x, y){return x.sub(y);}
		   function caml_int64_to_float(x){return x.toFloat();}
		   function caml_int64_xor(x, y){return x.xor(y);}
		   function caml_int_of_string(s){
		    var
		     r = caml_parse_sign_and_base(s),
		     i = r[0],
		     sign = r[1],
		     base = r[2],
		     signedness = r[3],
		     len = caml_ml_string_length(s),
		     threshold = - 1 >>> 0,
		     c = i < len ? caml_string_unsafe_get(s, i) : 0,
		     d = caml_parse_digit(c);
		    if(d < 0 || d >= base) caml_failwith("int_of_string");
		    var res = d;
		    for(i++; i < len; i++){
		     c = caml_string_unsafe_get(s, i);
		     if(c === 95) continue;
		     d = caml_parse_digit(c);
		     if(d < 0 || d >= base) break;
		     res = base * res + d;
		     if(res > threshold) caml_failwith("int_of_string");
		    }
		    if(i !== len) caml_failwith("int_of_string");
		    res = sign * res;
		    if(signedness && (res | 0) !== res) caml_failwith("int_of_string");
		    return res | 0;
		   }
		   function caml_js_fun_call(f, a){
		    switch(a.length){
		      case 1:
		       return f();
		      case 2:
		       return f(a[1]);
		      case 3:
		       return f(a[1], a[2]);
		      case 4:
		       return f(a[1], a[2], a[3]);
		      case 5:
		       return f(a[1], a[2], a[3], a[4]);
		      case 6:
		       return f(a[1], a[2], a[3], a[4], a[5]);
		      case 7:
		       return f(a[1], a[2], a[3], a[4], a[5], a[6]);
		      case 8:
		       return f(a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
		    }
		    return f.apply(null, caml_js_from_array(a));
		   }
		   function caml_js_get_console(){
		    var
		     c = console,
		     m =
		       ["log",
		        "debug",
		        "info",
		        "warn",
		        "error",
		        "assert",
		        "dir",
		        "dirxml",
		        "trace",
		        "group",
		        "groupCollapsed",
		        "groupEnd",
		        "time",
		        "timeEnd"];
		    function f(){}
		    for(var i = 0; i < m.length; i++) if(! c[m[i]]) c[m[i]] = f;
		    return c;
		   }
		   function caml_js_meth_call(o, f, args){
		    return o[caml_jsstring_of_string(f)].apply(o, caml_js_from_array(args));
		   }
		   function caml_js_object(a){
		    var o = {};
		    for(var i = 1; i < a.length; i++){
		     var p = a[i];
		     o[caml_jsstring_of_string(p[1])] = p[2];
		    }
		    return o;
		   }
		   function caml_js_pure_expr(f){return caml_callback(f, [0]);}
		   function caml_js_to_array(a){
		    var len = a.length, b = new Array(len + 1);
		    b[0] = 0;
		    for(var i = 0; i < len; i++) b[i + 1] = a[i];
		    return b;
		   }
		   function caml_js_wrap_callback(f){
		    return function(...args){
		     if(args.length === 0) args = [undefined];
		     var res = caml_callback(f, args);
		     return res instanceof Function ? caml_js_wrap_callback(res) : res;};
		   }
		   function caml_js_wrap_callback_strict(arity, f){
		    return function(...args){
		     args.length = arity;
		     return caml_callback(f, args);};
		   }
		   function caml_js_wrap_meth_callback(f){
		    return function(...args){
		     args.unshift(this);
		     var res = caml_callback(f, args);
		     return res instanceof Function ? caml_js_wrap_callback(res) : res;};
		   }
		   function caml_js_function_arity(f){
		    return (f.l >= 0 ? f.l : f.l = f.length) - 1;
		   }
		   function caml_js_wrap_meth_callback_unsafe(f){
		    return function(...args){
		     var len = caml_js_function_arity(f);
		     args.unshift(this);
		     args.length = len;
		     return caml_callback(f, args);};
		   }
		   function caml_lazy_make_forward(v){return [250, v];}
		   function caml_obj_update_tag(b, o, n){
		    if(b[0] === o){b[0] = n; return 1;}
		    return 0;
		   }
		   function caml_lazy_reset_to_lazy(o){
		    caml_obj_update_tag(o, 244, 246);
		    return 0;
		   }
		   function caml_lazy_update_to_forcing(o){
		    return Array.isArray(o) && o[0] === o[0] >>> 0
		            && caml_obj_update_tag(o, 246, 244)
		            ? 0
		            : 1;
		   }
		   function caml_lazy_update_to_forward(o){
		    caml_obj_update_tag(o, 244, 250);
		    return 0;
		   }
		   function caml_lessequal(x, y){
		    return + (caml_compare_val(x, y, false) <= 0);
		   }
		   function caml_lessthan(x, y){return + (caml_compare_val(x, y, false) < 0);}
		   function caml_lex_array(s){
		    s = caml_jsbytes_of_string(s);
		    var l = s.length / 2, a = new Array(l);
		    for(var i = 0; i < l; i++)
		     a[i] = (s.charCodeAt(2 * i) | s.charCodeAt(2 * i + 1) << 8) << 16 >> 16;
		    return a;
		   }
		   function caml_lex_engine(tbl, start_state, lexbuf){
		    var
		     lex_buffer = 2,
		     lex_buffer_len = 3,
		     lex_start_pos = 5,
		     lex_curr_pos = 6,
		     lex_last_pos = 7,
		     lex_last_action = 8,
		     lex_eof_reached = 9,
		     lex_base = 1,
		     lex_backtrk = 2,
		     lex_default = 3,
		     lex_trans = 4,
		     lex_check = 5;
		    if(! tbl.lex_default){
		     tbl.lex_base = caml_lex_array(tbl[lex_base]);
		     tbl.lex_backtrk = caml_lex_array(tbl[lex_backtrk]);
		     tbl.lex_check = caml_lex_array(tbl[lex_check]);
		     tbl.lex_trans = caml_lex_array(tbl[lex_trans]);
		     tbl.lex_default = caml_lex_array(tbl[lex_default]);
		    }
		    var c, state = start_state, buffer = lexbuf[lex_buffer];
		    if(state >= 0){
		     lexbuf[lex_last_pos] = lexbuf[lex_start_pos] = lexbuf[lex_curr_pos];
		     lexbuf[lex_last_action] = - 1;
		    }
		    else
		     state = - state - 1;
		    for(;;){
		     var base = tbl.lex_base[state];
		     if(base < 0) return - base - 1;
		     var backtrk = tbl.lex_backtrk[state];
		     if(backtrk >= 0){
		      lexbuf[lex_last_pos] = lexbuf[lex_curr_pos];
		      lexbuf[lex_last_action] = backtrk;
		     }
		     if(lexbuf[lex_curr_pos] >= lexbuf[lex_buffer_len])
		      if(lexbuf[lex_eof_reached] === 0) return - state - 1; else c = 256;
		     else {
		      c = caml_bytes_unsafe_get(buffer, lexbuf[lex_curr_pos]);
		      lexbuf[lex_curr_pos]++;
		     }
		     if(tbl.lex_check[base + c] === state)
		      state = tbl.lex_trans[base + c];
		     else
		      state = tbl.lex_default[state];
		     if(state < 0){
		      lexbuf[lex_curr_pos] = lexbuf[lex_last_pos];
		      if(lexbuf[lex_last_action] === - 1)
		       caml_failwith("lexing: empty token");
		      else
		       return lexbuf[lex_last_action];
		     }
		     else if(c === 256) lexbuf[lex_eof_reached] = 0;
		    }
		   }
		   function caml_list_of_js_array(a){
		    var l = 0;
		    for(var i = a.length - 1; i >= 0; i--){var e = a[i]; l = [0, e, l];}
		    return l;
		   }
		   function caml_log10_float(x){return Math.log10(x);}
		   var
		    caml_lxm_daba =
		      caml_int64_of_string(caml_string_of_jsstring("0xdaba0b6eb09322e3")),
		    caml_lxm_M =
		      caml_int64_of_string(caml_string_of_jsstring("0xd1342543de82ef95"));
		   function caml_lxm_next(v){
		    function shift_l(x, k){return caml_int64_shift_left(x, k);}
		    function shift_r(x, k){return caml_int64_shift_right_unsigned(x, k);}
		    function or(a, b){return caml_int64_or(a, b);}
		    function xor(a, b){return caml_int64_xor(a, b);}
		    function add(a, b){return caml_int64_add(a, b);}
		    function mul(a, b){return caml_int64_mul(a, b);}
		    function rotl(x, k){return or(shift_l(x, k), shift_r(x, 64 - k));}
		    function get(a, i){return caml_ba_get_1(a, i);}
		    function set(a, i, x){return caml_ba_set_1(a, i, x);}
		    var
		     M = caml_lxm_M,
		     daba = caml_lxm_daba,
		     z,
		     q0,
		     q1,
		     st = v,
		     a = get(st, 0),
		     s = get(st, 1),
		     x0 = get(st, 2),
		     x1 = get(st, 3);
		    z = add(s, x0);
		    z = mul(xor(z, shift_r(z, 32)), daba);
		    z = mul(xor(z, shift_r(z, 32)), daba);
		    z = xor(z, shift_r(z, 32));
		    set(st, 1, add(mul(s, M), a));
		    var q0 = x0, q1 = x1;
		    q1 = xor(q1, q0);
		    q0 = rotl(q0, 24);
		    q0 = xor(xor(q0, q1), shift_l(q1, 16));
		    q1 = rotl(q1, 37);
		    set(st, 2, q0);
		    set(st, 3, q1);
		    return z;
		   }
		   function caml_array_make(len, init){
		    if(len >>> 0 >= (0x7fffffff / 4 | 0)) caml_invalid_argument("Array.make");
		    var len = len + 1 | 0, b = new Array(len);
		    b[0] = 0;
		    for(var i = 1; i < len; i++) b[i] = init;
		    return b;
		   }
		   function caml_make_vect(len, init){return caml_array_make(len, init);}
		   function caml_MD5Init(){
		    var
		     buffer = new ArrayBuffer(64),
		     b32 = new Uint32Array(buffer),
		     b8 = new Uint8Array(buffer);
		    return {len: 0,
		            w:
		            new Uint32Array([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]),
		            b32: b32,
		            b8: b8};
		   }
		   var
		    caml_MD5Transform =
		      function(){
		        function add(x, y){return x + y | 0;}
		        function xx(q, a, b, x, s, t){
		         a = add(add(a, q), add(x, t));
		         return add(a << s | a >>> 32 - s, b);
		        }
		        function ff(a, b, c, d, x, s, t){
		         return xx(b & c | ~ b & d, a, b, x, s, t);
		        }
		        function gg(a, b, c, d, x, s, t){
		         return xx(b & d | c & ~ d, a, b, x, s, t);
		        }
		        function hh(a, b, c, d, x, s, t){return xx(b ^ c ^ d, a, b, x, s, t);}
		        function ii(a, b, c, d, x, s, t){
		         return xx(c ^ (b | ~ d), a, b, x, s, t);
		        }
		        return function(w, buffer){
		         var a = w[0], b = w[1], c = w[2], d = w[3];
		         a = ff(a, b, c, d, buffer[0], 7, 0xd76aa478);
		         d = ff(d, a, b, c, buffer[1], 12, 0xe8c7b756);
		         c = ff(c, d, a, b, buffer[2], 17, 0x242070db);
		         b = ff(b, c, d, a, buffer[3], 22, 0xc1bdceee);
		         a = ff(a, b, c, d, buffer[4], 7, 0xf57c0faf);
		         d = ff(d, a, b, c, buffer[5], 12, 0x4787c62a);
		         c = ff(c, d, a, b, buffer[6], 17, 0xa8304613);
		         b = ff(b, c, d, a, buffer[7], 22, 0xfd469501);
		         a = ff(a, b, c, d, buffer[8], 7, 0x698098d8);
		         d = ff(d, a, b, c, buffer[9], 12, 0x8b44f7af);
		         c = ff(c, d, a, b, buffer[10], 17, 0xffff5bb1);
		         b = ff(b, c, d, a, buffer[11], 22, 0x895cd7be);
		         a = ff(a, b, c, d, buffer[12], 7, 0x6b901122);
		         d = ff(d, a, b, c, buffer[13], 12, 0xfd987193);
		         c = ff(c, d, a, b, buffer[14], 17, 0xa679438e);
		         b = ff(b, c, d, a, buffer[15], 22, 0x49b40821);
		         a = gg(a, b, c, d, buffer[1], 5, 0xf61e2562);
		         d = gg(d, a, b, c, buffer[6], 9, 0xc040b340);
		         c = gg(c, d, a, b, buffer[11], 14, 0x265e5a51);
		         b = gg(b, c, d, a, buffer[0], 20, 0xe9b6c7aa);
		         a = gg(a, b, c, d, buffer[5], 5, 0xd62f105d);
		         d = gg(d, a, b, c, buffer[10], 9, 0x02441453);
		         c = gg(c, d, a, b, buffer[15], 14, 0xd8a1e681);
		         b = gg(b, c, d, a, buffer[4], 20, 0xe7d3fbc8);
		         a = gg(a, b, c, d, buffer[9], 5, 0x21e1cde6);
		         d = gg(d, a, b, c, buffer[14], 9, 0xc33707d6);
		         c = gg(c, d, a, b, buffer[3], 14, 0xf4d50d87);
		         b = gg(b, c, d, a, buffer[8], 20, 0x455a14ed);
		         a = gg(a, b, c, d, buffer[13], 5, 0xa9e3e905);
		         d = gg(d, a, b, c, buffer[2], 9, 0xfcefa3f8);
		         c = gg(c, d, a, b, buffer[7], 14, 0x676f02d9);
		         b = gg(b, c, d, a, buffer[12], 20, 0x8d2a4c8a);
		         a = hh(a, b, c, d, buffer[5], 4, 0xfffa3942);
		         d = hh(d, a, b, c, buffer[8], 11, 0x8771f681);
		         c = hh(c, d, a, b, buffer[11], 16, 0x6d9d6122);
		         b = hh(b, c, d, a, buffer[14], 23, 0xfde5380c);
		         a = hh(a, b, c, d, buffer[1], 4, 0xa4beea44);
		         d = hh(d, a, b, c, buffer[4], 11, 0x4bdecfa9);
		         c = hh(c, d, a, b, buffer[7], 16, 0xf6bb4b60);
		         b = hh(b, c, d, a, buffer[10], 23, 0xbebfbc70);
		         a = hh(a, b, c, d, buffer[13], 4, 0x289b7ec6);
		         d = hh(d, a, b, c, buffer[0], 11, 0xeaa127fa);
		         c = hh(c, d, a, b, buffer[3], 16, 0xd4ef3085);
		         b = hh(b, c, d, a, buffer[6], 23, 0x04881d05);
		         a = hh(a, b, c, d, buffer[9], 4, 0xd9d4d039);
		         d = hh(d, a, b, c, buffer[12], 11, 0xe6db99e5);
		         c = hh(c, d, a, b, buffer[15], 16, 0x1fa27cf8);
		         b = hh(b, c, d, a, buffer[2], 23, 0xc4ac5665);
		         a = ii(a, b, c, d, buffer[0], 6, 0xf4292244);
		         d = ii(d, a, b, c, buffer[7], 10, 0x432aff97);
		         c = ii(c, d, a, b, buffer[14], 15, 0xab9423a7);
		         b = ii(b, c, d, a, buffer[5], 21, 0xfc93a039);
		         a = ii(a, b, c, d, buffer[12], 6, 0x655b59c3);
		         d = ii(d, a, b, c, buffer[3], 10, 0x8f0ccc92);
		         c = ii(c, d, a, b, buffer[10], 15, 0xffeff47d);
		         b = ii(b, c, d, a, buffer[1], 21, 0x85845dd1);
		         a = ii(a, b, c, d, buffer[8], 6, 0x6fa87e4f);
		         d = ii(d, a, b, c, buffer[15], 10, 0xfe2ce6e0);
		         c = ii(c, d, a, b, buffer[6], 15, 0xa3014314);
		         b = ii(b, c, d, a, buffer[13], 21, 0x4e0811a1);
		         a = ii(a, b, c, d, buffer[4], 6, 0xf7537e82);
		         d = ii(d, a, b, c, buffer[11], 10, 0xbd3af235);
		         c = ii(c, d, a, b, buffer[2], 15, 0x2ad7d2bb);
		         b = ii(b, c, d, a, buffer[9], 21, 0xeb86d391);
		         w[0] = add(a, w[0]);
		         w[1] = add(b, w[1]);
		         w[2] = add(c, w[2]);
		         w[3] = add(d, w[3]);};
		       }
		       ();
		   function caml_MD5Update(ctx, input, input_len){
		    var in_buf = ctx.len & 0x3f, input_pos = 0;
		    ctx.len += input_len;
		    if(in_buf){
		     var missing = 64 - in_buf;
		     if(input_len < missing){
		      ctx.b8.set(input.subarray(0, input_len), in_buf);
		      return;
		     }
		     ctx.b8.set(input.subarray(0, missing), in_buf);
		     caml_MD5Transform(ctx.w, ctx.b32);
		     input_len -= missing;
		     input_pos += missing;
		    }
		    while(input_len >= 64){
		     ctx.b8.set(input.subarray(input_pos, input_pos + 64), 0);
		     caml_MD5Transform(ctx.w, ctx.b32);
		     input_len -= 64;
		     input_pos += 64;
		    }
		    if(input_len)
		     ctx.b8.set(input.subarray(input_pos, input_pos + input_len), 0);
		   }
		   function caml_MD5Final(ctx){
		    var in_buf = ctx.len & 0x3f;
		    ctx.b8[in_buf] = 0x80;
		    in_buf++;
		    if(in_buf > 56){
		     for(var j = in_buf; j < 64; j++) ctx.b8[j] = 0;
		     caml_MD5Transform(ctx.w, ctx.b32);
		     for(var j = 0; j < 56; j++) ctx.b8[j] = 0;
		    }
		    else
		     for(var j = in_buf; j < 56; j++) ctx.b8[j] = 0;
		    ctx.b32[14] = ctx.len << 3;
		    ctx.b32[15] = ctx.len / 0x20000000 | 0;
		    caml_MD5Transform(ctx.w, ctx.b32);
		    var t = new Uint8Array(16);
		    for(var i = 0; i < 4; i++)
		     for(var j = 0; j < 4; j++) t[i * 4 + j] = ctx.w[i] >> 8 * j & 0xff;
		    return t;
		   }
		   function caml_string_of_uint8_array(a){
		    return caml_sub_uint8_array_to_jsbytes(a, 0, a.length);
		   }
		   function caml_md5_bytes(s, ofs, len){
		    var ctx = caml_MD5Init(), a = caml_uint8_array_of_bytes(s);
		    caml_MD5Update(ctx, a.subarray(ofs, ofs + len), len);
		    return caml_string_of_uint8_array(caml_MD5Final(ctx));
		   }
		   function caml_md5_string(s, ofs, len){
		    return caml_md5_bytes(caml_bytes_of_string(s), ofs, len);
		   }
		   function MlChanid(id){this.id = id;}
		   class caml_ml_channels_state{
		     constructor(){
		      this.map = new globalThis.WeakMap();
		      this.opened = new globalThis.Set();
		     }
		     close(chanid){this.opened.delete(chanid);}
		     get(chanid){return this.map.get(chanid);}
		     set(chanid, val){
		      if(val.opened) this.opened.add(chanid);
		      return this.map.set(chanid, val);
		     }
		     all(){return this.opened.values();}
		   }
		   var
		    caml_ml_channels = new caml_ml_channels_state(),
		    caml_sys_fds = new Array(3);
		   function caml_sys_close(fd){
		    var x = caml_sys_fds[fd];
		    if(x){x.file.close(false); delete caml_sys_fds[fd];}
		    return 0;
		   }
		   function caml_ml_channel_get(id){return caml_ml_channels.get(id);}
		   function caml_ml_flush(chanid){
		    var chan = caml_ml_channel_get(chanid);
		    if(! chan.opened) return 0;
		    if(! chan.buffer || chan.buffer_curr === 0) return 0;
		    if(chan.output)
		     chan.output
		      (caml_sub_uint8_array_to_jsbytes(chan.buffer, 0, chan.buffer_curr));
		    else
		     for(var pos = 0; pos < chan.buffer_curr;)
		      pos += chan.file.write(chan.buffer, pos, chan.buffer_curr - pos, false);
		    chan.offset += chan.buffer_curr;
		    chan.buffer_curr = 0;
		    return 0;
		   }
		   function caml_ml_close_channel(chanid){
		    var chan = caml_ml_channel_get(chanid);
		    if(chan.opened){
		     chan.opened = false;
		     caml_ml_channels.close(chanid);
		     caml_sys_close(chan.fd);
		     chan.fd = - 1;
		     chan.buffer = new Uint8Array(0);
		     chan.buffer_curr = 0;
		     chan.buffer_max = 0;
		    }
		    return 0;
		   }
		   function caml_refill(chan){
		    if(chan.refill != null){
		     var str = chan.refill(), str_a = caml_uint8_array_of_string(str);
		     if(str_a.length === 0)
		      chan.refill = null;
		     else {
		      if(chan.buffer.length < chan.buffer_max + str_a.length){
		       var b = new Uint8Array(chan.buffer_max + str_a.length);
		       b.set(chan.buffer);
		       chan.buffer = b;
		      }
		      chan.buffer.set(str_a, chan.buffer_max);
		      chan.offset += str_a.length;
		      chan.buffer_max += str_a.length;
		     }
		    }
		    else {
		     if(chan.fd === - 1) caml_raise_sys_error("Bad file descriptor");
		     var
		      nread =
		        chan.file.read
		         (chan.buffer,
		          chan.buffer_max,
		          chan.buffer.length - chan.buffer_max,
		          false);
		     chan.offset += nread;
		     chan.buffer_max += nread;
		    }
		   }
		   function caml_ml_input_block(chanid, ba, i, l){
		    var
		     chan = caml_ml_channel_get(chanid),
		     n = l,
		     avail = chan.buffer_max - chan.buffer_curr;
		    if(l <= avail){
		     ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + l), i);
		     chan.buffer_curr += l;
		    }
		    else if(avail > 0){
		     ba.set
		      (chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + avail), i);
		     chan.buffer_curr += avail;
		     n = avail;
		    }
		    else {
		     chan.buffer_curr = 0;
		     chan.buffer_max = 0;
		     caml_refill(chan);
		     var avail = chan.buffer_max - chan.buffer_curr;
		     if(n > avail) n = avail;
		     ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + n), i);
		     chan.buffer_curr += n;
		    }
		    return n | 0;
		   }
		   function caml_ml_input(chanid, b, i, l){
		    var ba = caml_uint8_array_of_bytes(b);
		    return caml_ml_input_block(chanid, ba, i, l);
		   }
		   function caml_raise_end_of_file(){
		    caml_raise_constant(caml_global_data["predef:End_of_file"]);
		   }
		   function caml_ml_input_char(chanid){
		    var chan = caml_ml_channel_get(chanid);
		    if(chan.buffer_curr >= chan.buffer_max){
		     chan.buffer_curr = 0;
		     chan.buffer_max = 0;
		     caml_refill(chan);
		    }
		    if(chan.buffer_curr >= chan.buffer_max) caml_raise_end_of_file();
		    var res = chan.buffer[chan.buffer_curr];
		    chan.buffer_curr++;
		    return res;
		   }
		   function caml_ml_input_scan_line(chanid){
		    var chan = caml_ml_channel_get(chanid), p = chan.buffer_curr;
		    do
		     if(p >= chan.buffer_max){
		      if(chan.buffer_curr > 0){
		       chan.buffer.set(chan.buffer.subarray(chan.buffer_curr), 0);
		       p -= chan.buffer_curr;
		       chan.buffer_max -= chan.buffer_curr;
		       chan.buffer_curr = 0;
		      }
		      if(chan.buffer_max >= chan.buffer.length) return - chan.buffer_max | 0;
		      var prev_max = chan.buffer_max;
		      caml_refill(chan);
		      if(prev_max === chan.buffer_max) return - chan.buffer_max | 0;
		     }
		    while
		     (chan.buffer[p++] !== 10);
		    return p - chan.buffer_curr | 0;
		   }
		   function caml_ml_mutex_lock(t){
		    if(t.locked)
		     caml_failwith("Mutex.lock: mutex already locked. Cannot wait.");
		    else
		     t.locked = true;
		    return 0;
		   }
		   class MlMutex{constructor(){this.locked = false;}}
		   function caml_ml_mutex_new(_unit){return new MlMutex();}
		   function caml_ml_mutex_unlock(t){t.locked = false; return 0;}
		   var caml_ml_std_channel_id = [], caml_io_buffer_size = 65536;
		   class MlFakeFd_out extends MlFakeFile {
		     constructor(fd, flags){
		      super(caml_create_bytes(0));
		      var
		       via_console =
		         sink=>
		            s=>
		               sink
		                (s.length > 0 && s.charCodeAt(s.length - 1) === 10
		                  ? s.slice(0, - 1)
		                  : s);
		      if(fd === 1 && typeof console.log === "function")
		       this.log = via_console(console.log);
		      else if(fd === 2 && typeof console.error === "function")
		       this.log = via_console(console.error);
		      else if(typeof console.log === "function")
		       this.log = via_console(console.log);
		      else
		       this.log = _s=>0;
		      this.flags = flags;
		     }
		     length(){return 0;}
		     truncate(_len, raise_unix){
		      caml_raise_system_error
		       (raise_unix, "EINVAL", "ftruncate", "invalid argument");
		     }
		     write(buf, pos, len, raise_unix){
		      if(this.log){
		       var src = caml_create_bytes(len);
		       caml_blit_bytes(caml_bytes_of_uint8_array(buf), pos, src, 0, len);
		       this.log(src.toUtf16());
		       return len;
		      }
		      caml_raise_system_error
		       (raise_unix, "EBADF", "write", "bad file descriptor");
		     }
		     read(_buf, _pos, _len, raise_unix){
		      caml_raise_system_error
		       (raise_unix, "EBADF", "read", "bad file descriptor");
		     }
		     seek(_len, _whence, raise_unix){
		      caml_raise_system_error(raise_unix, "ESPIPE", "lseek", "illegal seek");
		     }
		     pos(){return - 1;}
		     close(){this.log = undefined;}
		     check_stream_semantics(_cmd){}
		   }
		   function caml_sys_open_internal(file, idx){
		    if(idx === undefined) idx = caml_sys_fds.length;
		    caml_sys_fds[idx] = {file: file};
		    return idx | 0;
		   }
		   function caml_sys_open(name, flags, perms){
		    var f = {};
		    while(flags){
		     switch(flags[1]){
		       case 0:
		        f.rdonly = 1; break;
		       case 1:
		        f.wronly = 1; break;
		       case 2:
		        f.append = 1; f.wronly = 1; break;
		       case 3:
		        f.create = 1; break;
		       case 4:
		        f.truncate = 1; break;
		       case 5:
		        f.excl = 1; break;
		       case 6:
		        f.binary = 1; break;
		       case 7:
		        f.text = 1; break;
		       case 8:
		        f.nonblock = 1; break;
		     }
		     flags = flags[2];
		    }
		    var
		     root = resolve_fs_device(name),
		     file = root.device.open(root.rest, f, perms);
		    return caml_sys_open_internal(file, undefined);
		   }
		   (function(){
		      var buffered = 2;
		      function file(fd, flags){
		       return new MlFakeFd_out(fd, flags);
		      }
		      caml_sys_open_internal
		       (file(0, {rdonly: 1, altname: "/dev/stdin", isCharacterDevice: true}),
		        0);
		      caml_sys_open_internal
		       (file(1, {buffered: buffered, wronly: 1, isCharacterDevice: true}), 1);
		      caml_sys_open_internal
		       (file(2, {buffered: buffered, wronly: 1, isCharacterDevice: true}), 2);
		     }
		     ());
		   function caml_ml_open_descriptor_in(fd){
		    var fd_desc = caml_sys_fds[fd];
		    if(fd_desc === undefined)
		     caml_raise_sys_error("fd " + fd + " doesn't exist");
		    var
		     file = fd_desc.file,
		     chanid = new MlChanid(fd),
		     refill = null,
		     channel =
		       {file: file,
		        offset: file.pos(),
		        fd: fd,
		        opened: true,
		        out: false,
		        buffer_curr: 0,
		        buffer_max: 0,
		        buffer: new Uint8Array(caml_io_buffer_size),
		        refill: refill};
		    caml_ml_channels.set(chanid, channel);
		    if(fd <= 2 && ! caml_ml_std_channel_id[fd])
		     caml_ml_std_channel_id[fd] = chanid;
		    return chanid;
		   }
		   function caml_ml_open_descriptor_out(fd){
		    var fd_desc = caml_sys_fds[fd];
		    if(fd_desc === undefined)
		     caml_raise_sys_error("fd " + fd + " doesn't exist");
		    var
		     file = fd_desc.file,
		     chanid = new MlChanid(fd),
		     buffered = file.flags.buffered !== undefined ? file.flags.buffered : 1,
		     channel =
		       {file: file,
		        offset: file.pos(),
		        fd: fd,
		        opened: true,
		        out: true,
		        buffer_curr: 0,
		        buffer: new Uint8Array(caml_io_buffer_size),
		        buffered: buffered};
		    caml_ml_channels.set(chanid, channel);
		    if(fd <= 2 && ! caml_ml_std_channel_id[fd])
		     caml_ml_std_channel_id[fd] = chanid;
		    return chanid;
		   }
		   function caml_ml_out_channels_list(){
		    var l = 0, keys = caml_ml_channels.all();
		    for(var k of keys){
		     var chan = caml_ml_channel_get(k);
		     if(chan.opened && chan.out) l = [0, k, l];
		    }
		    return l;
		   }
		   function caml_ml_output_ta(chanid, buffer, offset, len){
		    var chan = caml_ml_channel_get(chanid);
		    if(! chan.opened)
		     caml_raise_sys_error("Cannot output to a closed channel");
		    buffer = buffer.subarray(offset, offset + len);
		    if(chan.buffer_curr + buffer.length > chan.buffer.length){
		     var b = new Uint8Array(chan.buffer_curr + buffer.length);
		     b.set(chan.buffer);
		     chan.buffer = b;
		    }
		    switch(chan.buffered){
		      case 0:
		       chan.buffer.set(buffer, chan.buffer_curr);
		       chan.buffer_curr += buffer.length;
		       caml_ml_flush(chanid);
		       break;
		      case 1:
		       chan.buffer.set(buffer, chan.buffer_curr);
		       chan.buffer_curr += buffer.length;
		       if(chan.buffer_curr >= chan.buffer.length) caml_ml_flush(chanid);
		       break;
		      case 2:
		       var id = buffer.lastIndexOf(10);
		       if(id < 0){
		        chan.buffer.set(buffer, chan.buffer_curr);
		        chan.buffer_curr += buffer.length;
		        if(chan.buffer_curr >= chan.buffer.length) caml_ml_flush(chanid);
		       }
		       else {
		        chan.buffer.set(buffer.subarray(0, id + 1), chan.buffer_curr);
		        chan.buffer_curr += id + 1;
		        caml_ml_flush(chanid);
		        chan.buffer.set(buffer.subarray(id + 1), chan.buffer_curr);
		        chan.buffer_curr += buffer.length - id - 1;
		       }
		       break;
		    }
		    return 0;
		   }
		   function caml_ml_output_bytes(chanid, buffer, offset, len){
		    var buffer = caml_uint8_array_of_bytes(buffer);
		    return caml_ml_output_ta(chanid, buffer, offset, len);
		   }
		   function caml_ml_output(chanid, buffer, offset, len){
		    return caml_ml_output_bytes
		            (chanid, caml_bytes_of_string(buffer), offset, len);
		   }
		   function caml_ml_output_char(chanid, c){
		    var s = caml_string_of_jsbytes(String.fromCharCode(c));
		    caml_ml_output(chanid, s, 0, 1);
		    return 0;
		   }
		   function caml_ml_set_channel_name(chanid, name){
		    var chan = caml_ml_channel_get(chanid);
		    chan.name = name;
		    return 0;
		   }
		   function caml_mod(x, y){
		    if(y === 0) caml_raise_zero_divide();
		    return x % y;
		   }
		   function caml_modf_float(x){
		    if(Number.isFinite(x)){
		     var neg = 1 / x < 0;
		     x = Math.abs(x);
		     var i = Math.floor(x), f = x - i;
		     if(neg){i = - i; f = - f;}
		     return [0, f, i];
		    }
		    if(Number.isNaN(x)) return [0, Number.NaN, Number.NaN];
		    return [0, 1 / x, x];
		   }
		   function caml_notequal(x, y){
		    return + (caml_compare_val(x, y, false) !== 0);
		   }
		   function caml_obj_block(tag, size){
		    var o = new Array(size + 1);
		    o[0] = tag;
		    for(var i = 1; i <= size; i++) o[i] = 0;
		    return o;
		   }
		   function caml_obj_dup(x){
		    if(x === null) return null;
		    return typeof x === "number" ? x : x.slice();
		   }
		   function caml_obj_tag(x){
		    if(x === null)
		     return 1010;
		    else if(Array.isArray(x) && x[0] === x[0] >>> 0)
		     return x[0];
		    else if(caml_is_ml_bytes(x))
		     return 252;
		    else if(caml_is_ml_string(x))
		     return 252;
		    else if(x instanceof Function || typeof x === "function")
		     return 247;
		    else if(x?.caml_custom) return 255; else return 1000;
		   }
		   function caml_get_cps_fun(f){return f;}
		   function caml_make_unhandled_effect_exn(eff){
		    var exn = caml_named_value("Effect.Unhandled");
		    if(exn)
		     exn = [0, exn, eff];
		    else
		     exn =
		      [248, caml_string_of_jsbytes("Effect.Unhandled"), caml_fresh_oo_id()];
		    return exn;
		   }
		   function caml_perform_effect(eff, k0){
		    if(caml_current_stack.e === 0){
		     var exn = caml_make_unhandled_effect_exn(eff);
		     throw exn;
		    }
		    var handler = caml_current_stack.h[3], last_fiber = caml_current_stack;
		    last_fiber.k = k0;
		    var cont = [245, last_fiber, last_fiber], k1 = caml_pop_fiber();
		    return caml_stack_check_depth()
		            ? caml_get_cps_fun(handler)(eff, cont, last_fiber, k1)
		            : caml_trampoline_return(handler, [eff, cont, last_fiber, k1]);
		   }
		   function caml_pop_trap(){
		    if(! caml_current_stack.x) return function(x){throw x;};
		    var h = caml_current_stack.x.h;
		    caml_current_stack.x = caml_current_stack.x.t;
		    return h;
		   }
		   function caml_push_trap(handler){
		    caml_current_stack.x = {h: handler, t: caml_current_stack.x};
		   }
		   function caml_record_backtrace(b){
		    caml_record_backtrace_runtime_flag = b;
		    return 0;
		   }
		   var caml_link_info = {};
		   function caml_build_symbols(symb){
		    var r = {}, max = - 1;
		    if(symb)
		     for(var i = 1; i < symb.length; i++){
		      var
		       gn = symb[i][1],
		       is_predef = gn[0],
		       name = caml_jsstring_of_string(gn[1]),
		       idx = symb[i][2];
		      max = Math.max(max, idx);
		      r[is_predef ? "predef:" + name : name] = idx;
		     }
		    r.next_idx = max + 1;
		    return r;
		   }
		   function caml_register_global_predef(v, name){
		    var key = "predef:" + name;
		    if(caml_link_info.symbols){
		     if(! caml_link_info.symidx)
		      caml_link_info.symidx = caml_build_symbols(caml_link_info.symbols);
		     var nid = caml_link_info.symidx[key];
		     if(nid === undefined){
		      nid = caml_link_info.symidx.next_idx++;
		      caml_link_info.symidx[key] = nid;
		     }
		     caml_global_data[nid + 1] = v;
		    }
		    caml_global_data[key] = v;
		   }
		   function caml_register_named_value(nm, v){
		    caml_named_values[caml_jsbytes_of_string(nm)] = v;
		    return 0;
		   }
		   function caml_resume_stack(stack, last, k){
		    if(! stack)
		     caml_raise_constant
		      (caml_named_value("Effect.Continuation_already_resumed"));
		    if(last === 0){last = stack; while(last.e !== 0) last = last.e;}
		    caml_current_stack.k = k;
		    last.e = caml_current_stack;
		    caml_current_stack = stack;
		    return stack.k;
		   }
		   function caml_reperform_effect(eff, cont, last, k0){
		    if(caml_current_stack.e === 0){
		     var
		      exn = caml_make_unhandled_effect_exn(eff),
		      stack = caml_continuation_use_noexc(cont);
		     caml_resume_stack(stack, last, k0);
		     throw exn;
		    }
		    var handler = caml_current_stack.h[3], last_fiber = caml_current_stack;
		    last_fiber.k = k0;
		    last.e = last_fiber;
		    cont[2] = last_fiber;
		    var k1 = caml_pop_fiber();
		    return caml_stack_check_depth()
		            ? caml_get_cps_fun(handler)(eff, cont, last_fiber, k1)
		            : caml_trampoline_return(handler, [eff, cont, last_fiber, k1]);
		   }
		   function caml_set_oo_id(b){b[2] = caml_oo_last_id++; return b;}
		   function caml_sse2_float64_max_bytecode(x, y){return x > y ? x : y;}
		   function caml_sse2_float64_min_bytecode(x, y){return x < y ? x : y;}
		   function caml_string_bound_error(){
		    caml_invalid_argument("index out of bounds");
		   }
		   function caml_string_get(s, i){
		    if(i >>> 0 >= caml_ml_string_length(s)) caml_string_bound_error();
		    return caml_string_unsafe_get(s, i);
		   }
		   function caml_string_get16(s, i){
		    if(i >>> 0 >= caml_ml_string_length(s) - 1) caml_string_bound_error();
		    var
		     b1 = caml_string_unsafe_get(s, i),
		     b2 = caml_string_unsafe_get(s, i + 1);
		    return b2 << 8 | b1;
		   }
		   function caml_string_get64(s, i){
		    if(i >>> 0 >= caml_ml_string_length(s) - 7) caml_string_bound_error();
		    var a = new Array(8);
		    for(var j = 0; j < 8; j++) a[7 - j] = caml_string_unsafe_get(s, i + j);
		    return caml_int64_of_bytes(a);
		   }
		   function caml_string_lessequal(s1, s2){return s1 <= s2 ? 1 : 0;}
		   function caml_string_greaterequal(s1, s2){return caml_string_lessequal(s2, s1);
		   }
		   function caml_string_lessthan(s1, s2){return s1 < s2 ? 1 : 0;}
		   function caml_string_greaterthan(s1, s2){return caml_string_lessthan(s2, s1);
		   }
		   function caml_string_hash(h, v){
		    var h = caml_hash_mix_string(h, v), h = caml_hash_mix_final(h);
		    return h & 0x3fffffff;
		   }
		   function caml_string_of_bytes(s){
		    s.t & 6 && caml_convert_string_to_bytes(s);
		    return caml_string_of_jsbytes(s.c);
		   }
		   var
		    caml_argv =
		      function(){
		        var process = globalThis.process, main = "a.out", args = [];
		        if(process?.argv?.length > 1){
		         var argv = process.argv;
		         main = argv[1];
		         args = argv.slice(2);
		        }
		        else if
		         (Array.isArray(globalThis.scriptArgs)
		          && globalThis.scriptArgs.length > 0){
		         main = globalThis.scriptArgs[0];
		         args = globalThis.scriptArgs.slice(1);
		        }
		        var p = caml_string_of_jsstring(main), args2 = [0, p];
		        for(var i = 0; i < args.length; i++)
		         args2.push(caml_string_of_jsstring(args[i]));
		        return args2;
		       }
		       ();
		   function caml_sys_argv(_unit){return caml_argv;}
		   function caml_sys_const_max_wosize(){return 0x7fffffff / 4 | 0;}
		   var caml_executable_name = caml_argv[1];
		   function caml_sys_executable_name(_unit){return caml_executable_name;}
		   function caml_sys_exit(code){
		    if(globalThis.quit) globalThis.quit(code);
		    if(globalThis.process?.exit) globalThis.process.exit(code);
		    if(globalThis.std?.exit) globalThis.std.exit(code);
		    caml_invalid_argument("Function 'exit' not implemented");
		   }
		   function caml_sys_file_exists(name){
		    if(caml_jsstring_of_string(name) === "") return 0;
		    var root = resolve_fs_device(name);
		    return root.device.exists(root.rest);
		   }
		   var os_type = jsoo_is_win32 ? "Win32" : "Unix";
		   function caml_sys_get_config(){
		    return [0, caml_string_of_jsbytes(os_type), 32, 0];
		   }
		   function caml_raise_not_found(){
		    caml_raise_constant(caml_global_data["predef:Not_found"]);
		   }
		   function caml_sys_getenv(name){
		    var r = jsoo_sys_getenv(caml_jsstring_of_string(name));
		    if(r === undefined) caml_raise_not_found();
		    return caml_string_of_jsstring(r);
		   }
		   function caml_sys_random_seed(){
		    if(globalThis.crypto)
		     if(globalThis.crypto.getRandomValues){
		      var a = globalThis.crypto.getRandomValues(new Int32Array(4));
		      return [0, a[0], a[1], a[2], a[3]];
		     }
		     else if(globalThis.crypto.randomBytes){
		      var a = new Int32Array(globalThis.crypto.randomBytes(16).buffer);
		      return [0, a[0], a[1], a[2], a[3]];
		     }
		    var now = Date.now(), x = now ^ 0xffffffff * Math.random();
		    return [0, x];
		   }
		   function caml_throw_js_exception(exn){throw exn;}
		   function caml_trunc_float(x){return Math.trunc(x);}
		   function caml_unix_lookup_file(fd, cmd){
		    var fd_desc = caml_sys_fds[fd];
		    if(fd_desc === undefined) caml_raise_system_error(1, "EBADF", cmd);
		    return fd_desc.file;
		   }
		   function caml_unix_close(fd){
		    var file = caml_unix_lookup_file(fd, "close");
		    file.close(1);
		    delete caml_sys_fds[fd];
		    return 0;
		   }
		   function caml_unix_inchannel_of_filedescr(fd){
		    var file = caml_unix_lookup_file(fd, "in_channel_of_descr");
		    file.check_stream_semantics("in_channel_of_descr");
		    return caml_ml_open_descriptor_in(fd);
		   }
		   function caml_unix_readlink(name){
		    var root = resolve_fs_device(name, 1);
		    if(! root.device.readlink)
		     caml_failwith("caml_unix_readlink: not implemented");
		    return root.device.readlink(root.rest, true);
		   }
		   function caml_update_dummy(x, y){
		    if(y.fun){x.fun = y.fun; return 0;}
		    if(typeof y === "function"){x.fun = y; return 0;}
		    var i = y.length;
		    while(i--) x[i] = y[i];
		    return 0;
		   }
		   function caml_xmlhttprequest_create(_unit){
		    if(typeof XMLHttpRequest === "undefined")
		     caml_failwith("XMLHttpRequest is not available");
		    try{return new XMLHttpRequest();}
		    catch{caml_failwith("Failed to create XMLHttpRequest");}
		   }
		   function find_performance_obj(){
		    function test(o){
		     return o && o.performance && typeof o.performance.now == "function";
		    }
		    if(test(globalThis)) return globalThis.performance;
		    if(test(globalThis.perf_hooks)) return globalThis.perf_hooks.performance;
		    if(typeof commonjsRequire == "function"){
		     var ph = requireDist();
		     if(test(ph)) return ph.performance;
		    }
		    var
		     obj =
		       {now:
		        function(){
		         caml_raise_sys_error("performance.now () is not available");
		        }};
		    return obj;
		   }
		   var performance_obj = find_performance_obj();
		   function mtime_clock_now(){
		    var
		     now_us = performance_obj.now() * 1e3,
		     now_ns =
		       caml_int64_mul(caml_int64_of_float(now_us), caml_int64_of_float(1000));
		    return now_ns;
		   }
		   var mtime_clock_start;
		   function ocaml_mtime_clock_elapsed_ns(_unix){
		    if(! mtime_clock_start) mtime_clock_start = mtime_clock_now();
		    var now = mtime_clock_now();
		    return caml_int64_sub(now, mtime_clock_start);
		   }
		   function ocaml_ptime_clock_now_d_ps(_unit){
		    function err(ms){
		     caml_raise_sys_error
		      ("Ptime_clock: can't represent JavaScript timestamp " + ms);
		    }
		    var dmin = - 719528, dmax = 2932896, ms = Date.now(), ps;
		    if(ms != ms) err(ms);
		    var days = Math.floor(ms / 86400000);
		    if(days < dmin || days > dmax) err(ms);
		    var rem_ms = ms % 86400000;
		    if(rem_ms < 0) rem_ms += 86400000;
		    if(rem_ms >= 86400000){
		     days += 1;
		     if(days > dmax) err(ms);
		     ps = caml_int64_of_int32(0);
		    }
		    else {
		     var
		      modf = caml_modf_float(rem_ms),
		      fract_ps = caml_int64_of_float(modf[1] * 1e9),
		      rem_ps =
		        caml_int64_mul
		         (caml_int64_of_float(modf[2]), caml_int64_of_int32(1000000000));
		     ps = caml_int64_add(rem_ps, fract_ps);
		    }
		    return [0, days, ps];
		   }
		   function ms_float_to_ns_int64(ms){
		    return caml_int64_of_float(ms * (1000.0 * 1000.0));
		   }
		   function time_now_nanosecond_counter_for_timing(){
		    var
		     ms_since_program_started = performance.now(),
		     ns_since_program_started = ms_float_to_ns_int64(ms_since_program_started);
		    return caml_int64_shift_left(ns_since_program_started, 1);
		   }
		   function caml_strerror(errno){
		    const code = unix_error[errno];
		    return code || "Unknown error " + errno;
		   }
		   function unix_error_message(err){
		    const errno = typeof err === "number" ? err : - err[1];
		    return caml_string_of_jsstring(caml_strerror(errno));
		   }
		   function caml_is_special_exception(exn){
		    switch(exn[2]){case - 8:case - 11:case - 12: return 1;default: return 0;
		    }
		   }
		   function caml_format_exception(exn){
		    var r = "";
		    if(exn[0] === 0){
		     r += exn[1][1];
		     if
		      (exn.length === 3 && exn[2][0] === 0
		       && caml_is_special_exception(exn[1]))
		      var bucket = exn[2], start = 1;
		     else
		      var start = 2, bucket = exn;
		     r += "(";
		     for(var i = start; i < bucket.length; i++){
		      if(i > start) r += ", ";
		      var v = bucket[i];
		      if(typeof v === "number")
		       r += v.toString();
		      else if(v instanceof MlBytes)
		       r += '"' + v.toString() + '"';
		      else if(typeof v === "string")
		       r += '"' + v.toString() + '"';
		      else
		       r += "_";
		     }
		     r += ")";
		    }
		    else if(exn[0] === 248) r += exn[1];
		    return r;
		   }
		   function caml_fatal_uncaught_exception(err){
		    if(Array.isArray(err) && (err[0] === 0 || err[0] === 248)){
		     var handler = caml_named_value("Printexc.handle_uncaught_exception");
		     if(handler)
		      caml_callback(handler, [err, false]);
		     else {
		      var
		       msg = caml_format_exception(err),
		       at_exit = caml_named_value("Pervasives.do_at_exit");
		      if(at_exit) caml_callback(at_exit, [0]);
		      console.error("Fatal error: exception " + msg);
		      if(err.js_error) throw err.js_error;
		     }
		    }
		    else
		     throw err;
		   }
		   function caml_setup_uncaught_exception_handler(){
		    var process = globalThis.process;
		    if(process?.on)
		     process.on
		      ("uncaughtException",
		       function(err, origin){
		        caml_fatal_uncaught_exception(err);
		        process.exit(2);
		       });
		    else if(globalThis.addEventListener)
		     globalThis.addEventListener
		      ("error",
		       function(event){
		        if(event.error) caml_fatal_uncaught_exception(event.error);
		       });
		   }
		   caml_setup_uncaught_exception_handler();
		   var
		    caml_unix_spawn =
		      globalThis.caml_unix_spawn !== undefined
		       ? globalThis.caml_unix_spawn
		       : function(){caml_failwith("caml_unix_spawn" + " not implemented");},
		    caml_unix_pipe =
		      globalThis.caml_unix_pipe !== undefined
		       ? globalThis.caml_unix_pipe
		       : function(){caml_failwith("caml_unix_pipe" + " not implemented");},
		    caml_unix_dup =
		      globalThis.caml_unix_dup !== undefined
		       ? globalThis.caml_unix_dup
		       : function(){caml_failwith("caml_unix_dup" + " not implemented");};
		   function caml_exact_trampoline_call0(f){
		    return caml_stack_check_depth() ? f() : caml_trampoline_return(f, [], 1);
		   }
		   function caml_exact_trampoline_call1(f, a0){
		    return caml_stack_check_depth()
		            ? f(a0)
		            : caml_trampoline_return(f, [a0], 1);
		   }
		   function caml_trampoline_cps_call2(f, a0, a1){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 2
		              ? f(a0, a1)
		              : caml_call_gen(f, [a0, a1])
		            : caml_trampoline_return(f, [a0, a1], 0);
		   }
		   function caml_exact_trampoline_call2(f, a0, a1){
		    return caml_stack_check_depth()
		            ? f(a0, a1)
		            : caml_trampoline_return(f, [a0, a1], 1);
		   }
		   function caml_exact_trampoline_cps_call(f, a0, a1){
		    return caml_stack_check_depth()
		            ? f(a0, a1)
		            : caml_trampoline_return(f, [a0, a1], 0);
		   }
		   function caml_trampoline_cps_call3(f, a0, a1, a2){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 3
		              ? f(a0, a1, a2)
		              : caml_call_gen(f, [a0, a1, a2])
		            : caml_trampoline_return(f, [a0, a1, a2], 0);
		   }
		   function caml_exact_trampoline_call3(f, a0, a1, a2){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2)
		            : caml_trampoline_return(f, [a0, a1, a2], 1);
		   }
		   function caml_exact_trampoline_cps_call$1(f, a0, a1, a2){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2)
		            : caml_trampoline_return(f, [a0, a1, a2], 0);
		   }
		   function caml_trampoline_cps_call4(f, a0, a1, a2, a3){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 4
		              ? f(a0, a1, a2, a3)
		              : caml_call_gen(f, [a0, a1, a2, a3])
		            : caml_trampoline_return(f, [a0, a1, a2, a3], 0);
		   }
		   function caml_exact_trampoline_call4(f, a0, a1, a2, a3){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3)
		            : caml_trampoline_return(f, [a0, a1, a2, a3], 1);
		   }
		   function caml_exact_trampoline_cps_call$0(f, a0, a1, a2, a3){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3)
		            : caml_trampoline_return(f, [a0, a1, a2, a3], 0);
		   }
		   function caml_trampoline_cps_call5(f, a0, a1, a2, a3, a4){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 5
		              ? f(a0, a1, a2, a3, a4)
		              : caml_call_gen(f, [a0, a1, a2, a3, a4])
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4], 0);
		   }
		   function caml_exact_trampoline_call5(f, a0, a1, a2, a3, a4){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4)
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4], 1);
		   }
		   function caml_exact_trampoline_cps_call$2(f, a0, a1, a2, a3, a4){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4)
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4], 0);
		   }
		   function caml_trampoline_cps_call6(f, a0, a1, a2, a3, a4, a5){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 6
		              ? f(a0, a1, a2, a3, a4, a5)
		              : caml_call_gen(f, [a0, a1, a2, a3, a4, a5])
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4, a5], 0);
		   }
		   function caml_exact_trampoline_cps_call$3(f, a0, a1, a2, a3, a4, a5){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5)
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4, a5], 0);
		   }
		   function caml_trampoline_cps_call7(f, a0, a1, a2, a3, a4, a5, a6){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 7
		              ? f(a0, a1, a2, a3, a4, a5, a6)
		              : caml_call_gen(f, [a0, a1, a2, a3, a4, a5, a6])
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4, a5, a6], 0);
		   }
		   function caml_exact_trampoline_cps_call$7(f, a0, a1, a2, a3, a4, a5, a6){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5, a6)
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4, a5, a6], 0);
		   }
		   function caml_trampoline_cps_call8(f, a0, a1, a2, a3, a4, a5, a6, a7){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 8
		              ? f(a0, a1, a2, a3, a4, a5, a6, a7)
		              : caml_call_gen(f, [a0, a1, a2, a3, a4, a5, a6, a7])
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4, a5, a6, a7], 0);
		   }
		   function caml_exact_trampoline_cps_call$8
		   (f, a0, a1, a2, a3, a4, a5, a6, a7){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5, a6, a7)
		            : caml_trampoline_return(f, [a0, a1, a2, a3, a4, a5, a6, a7], 0);
		   }
		   function caml_trampoline_cps_call9(f, a0, a1, a2, a3, a4, a5, a6, a7, a8){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 9
		              ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8)
		              : caml_call_gen(f, [a0, a1, a2, a3, a4, a5, a6, a7, a8])
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8], 0);
		   }
		   function caml_exact_trampoline_cps_call$9
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8)
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8], 0);
		   }
		   function caml_trampoline_cps_call10
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 10
		              ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9)
		              : caml_call_gen(f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9])
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9], 0);
		   }
		   function caml_exact_trampoline_cps_call$4
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9)
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9], 0);
		   }
		   function caml_trampoline_cps_call11
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 11
		              ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10)
		              : caml_call_gen
		                (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10])
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10], 0);
		   }
		   function caml_exact_trampoline_cps_call$5
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10)
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10], 0);
		   }
		   function caml_trampoline_cps_call12
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 12
		              ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11)
		              : caml_call_gen
		                (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11])
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11], 0);
		   }
		   function caml_exact_trampoline_cps_call$6
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11)
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11], 0);
		   }
		   function caml_trampoline_cps_call13
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 13
		              ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12)
		              : caml_call_gen
		                (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12])
		            : caml_trampoline_return
		              (f, [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12], 0);
		   }
		   function caml_trampoline_cps_call14
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 14
		              ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13)
		              : caml_call_gen
		                (f,
		                 [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13])
		            : caml_trampoline_return
		              (f,
		               [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13],
		               0);
		   }
		   function caml_exact_trampoline_cps_call$12
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13){
		    return caml_stack_check_depth()
		            ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13)
		            : caml_trampoline_return
		              (f,
		               [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13],
		               0);
		   }
		   function caml_trampoline_cps_call15
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 15
		              ? f
		                (a0,
		                 a1,
		                 a2,
		                 a3,
		                 a4,
		                 a5,
		                 a6,
		                 a7,
		                 a8,
		                 a9,
		                 a10,
		                 a11,
		                 a12,
		                 a13,
		                 a14)
		              : caml_call_gen
		                (f,
		                 [a0,
		                  a1,
		                  a2,
		                  a3,
		                  a4,
		                  a5,
		                  a6,
		                  a7,
		                  a8,
		                  a9,
		                  a10,
		                  a11,
		                  a12,
		                  a13,
		                  a14])
		            : caml_trampoline_return
		              (f,
		               [a0,
		                a1,
		                a2,
		                a3,
		                a4,
		                a5,
		                a6,
		                a7,
		                a8,
		                a9,
		                a10,
		                a11,
		                a12,
		                a13,
		                a14],
		               0);
		   }
		   function caml_exact_trampoline_cps_call$14
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14){
		    return caml_stack_check_depth()
		            ? f
		              (a0,
		               a1,
		               a2,
		               a3,
		               a4,
		               a5,
		               a6,
		               a7,
		               a8,
		               a9,
		               a10,
		               a11,
		               a12,
		               a13,
		               a14)
		            : caml_trampoline_return
		              (f,
		               [a0,
		                a1,
		                a2,
		                a3,
		                a4,
		                a5,
		                a6,
		                a7,
		                a8,
		                a9,
		                a10,
		                a11,
		                a12,
		                a13,
		                a14],
		               0);
		   }
		   function caml_trampoline_cps_call16
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15){
		    return caml_stack_check_depth()
		            ? (f.l
		                >= 0
		                ? f.l
		                : f.l = f.length)
		              === 16
		              ? f
		                (a0,
		                 a1,
		                 a2,
		                 a3,
		                 a4,
		                 a5,
		                 a6,
		                 a7,
		                 a8,
		                 a9,
		                 a10,
		                 a11,
		                 a12,
		                 a13,
		                 a14,
		                 a15)
		              : caml_call_gen
		                (f,
		                 [a0,
		                  a1,
		                  a2,
		                  a3,
		                  a4,
		                  a5,
		                  a6,
		                  a7,
		                  a8,
		                  a9,
		                  a10,
		                  a11,
		                  a12,
		                  a13,
		                  a14,
		                  a15])
		            : caml_trampoline_return
		              (f,
		               [a0,
		                a1,
		                a2,
		                a3,
		                a4,
		                a5,
		                a6,
		                a7,
		                a8,
		                a9,
		                a10,
		                a11,
		                a12,
		                a13,
		                a14,
		                a15],
		               0);
		   }
		   function caml_exact_trampoline_cps_call$13
		   (f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15){
		    return caml_stack_check_depth()
		            ? f
		              (a0,
		               a1,
		               a2,
		               a3,
		               a4,
		               a5,
		               a6,
		               a7,
		               a8,
		               a9,
		               a10,
		               a11,
		               a12,
		               a13,
		               a14,
		               a15)
		            : caml_trampoline_return
		              (f,
		               [a0,
		                a1,
		                a2,
		                a3,
		                a4,
		                a5,
		                a6,
		                a7,
		                a8,
		                a9,
		                a10,
		                a11,
		                a12,
		                a13,
		                a14,
		                a15],
		               0);
		   }
		   function caml_exact_trampoline_cps_call$10
		   (f,
		    a0,
		    a1,
		    a2,
		    a3,
		    a4,
		    a5,
		    a6,
		    a7,
		    a8,
		    a9,
		    a10,
		    a11,
		    a12,
		    a13,
		    a14,
		    a15,
		    a16,
		    a17,
		    a18){
		    return caml_stack_check_depth()
		            ? f
		              (a0,
		               a1,
		               a2,
		               a3,
		               a4,
		               a5,
		               a6,
		               a7,
		               a8,
		               a9,
		               a10,
		               a11,
		               a12,
		               a13,
		               a14,
		               a15,
		               a16,
		               a17,
		               a18)
		            : caml_trampoline_return
		              (f,
		               [a0,
		                a1,
		                a2,
		                a3,
		                a4,
		                a5,
		                a6,
		                a7,
		                a8,
		                a9,
		                a10,
		                a11,
		                a12,
		                a13,
		                a14,
		                a15,
		                a16,
		                a17,
		                a18],
		               0);
		   }
		   function caml_exact_trampoline_cps_call$11
		   (f,
		    a0,
		    a1,
		    a2,
		    a3,
		    a4,
		    a5,
		    a6,
		    a7,
		    a8,
		    a9,
		    a10,
		    a11,
		    a12,
		    a13,
		    a14,
		    a15,
		    a16,
		    a17,
		    a18,
		    a19){
		    return caml_stack_check_depth()
		            ? f
		              (a0,
		               a1,
		               a2,
		               a3,
		               a4,
		               a5,
		               a6,
		               a7,
		               a8,
		               a9,
		               a10,
		               a11,
		               a12,
		               a13,
		               a14,
		               a15,
		               a16,
		               a17,
		               a18,
		               a19)
		            : caml_trampoline_return
		              (f,
		               [a0,
		                a1,
		                a2,
		                a3,
		                a4,
		                a5,
		                a6,
		                a7,
		                a8,
		                a9,
		                a10,
		                a11,
		                a12,
		                a13,
		                a14,
		                a15,
		                a16,
		                a17,
		                a18,
		                a19],
		               0);
		   }
		   return caml_callback
		           (function(h){
		             caml_fs_init();
		             h = "Undefined_recursive_module";
		             var Undefined_recursive_module = [248, h, -12];
		             caml_register_global_predef(Undefined_recursive_module, h);
		             var
		              cst_Assert_failure = "Assert_failure",
		              Assert_failure = [248, cst_Assert_failure, -11];
		             caml_register_global_predef(Assert_failure, cst_Assert_failure);
		             h = "Sys_blocked_io";
		             caml_register_global_predef([248, h, -10], h);
		             h = "Stack_overflow";
		             var Stack_overflow = [248, h, -9];
		             caml_register_global_predef(Stack_overflow, h);
		             var
		              cst_Match_failure = "Match_failure",
		              Match_failure = [248, cst_Match_failure, -8];
		             caml_register_global_predef(Match_failure, cst_Match_failure);
		             h = "Not_found";
		             var Not_found = [248, h, -7];
		             caml_register_global_predef(Not_found, h);
		             var m = "Division_by_zero", Division_by_zero = [248, m, -6];
		             caml_register_global_predef(Division_by_zero, m);
		             m = "End_of_file";
		             var End_of_file = [248, m, -5];
		             caml_register_global_predef(End_of_file, m);
		             var A = "Invalid_argument", Invalid_argument = [248, A, -4];
		             caml_register_global_predef(Invalid_argument, A);
		             var cst_Failure = "Failure", Failure = [248, cst_Failure, -3];
		             caml_register_global_predef(Failure, cst_Failure);
		             var z = "Sys_error", Sys_error = [248, z, -2];
		             caml_register_global_predef(Sys_error, z);
		             var b = "Out_of_memory", Out_of_memory = [248, b, -1];
		             caml_register_global_predef(Out_of_memory, b);
		             function erase_rel(param){
		              if(typeof param === "number") return 0;
		              switch(param[0]){
		                case 0:
		                 var rest = param[1]; return [0, erase_rel(rest)];
		                case 1:
		                 var rest$0 = param[1]; return [1, erase_rel(rest$0)];
		                case 2:
		                 var rest$1 = param[1]; return [2, erase_rel(rest$1)];
		                case 3:
		                 var rest$2 = param[1]; return [3, erase_rel(rest$2)];
		                case 4:
		                 var rest$3 = param[1]; return [4, erase_rel(rest$3)];
		                case 5:
		                 var rest$4 = param[1]; return [5, erase_rel(rest$4)];
		                case 6:
		                 var rest$5 = param[1]; return [6, erase_rel(rest$5)];
		                case 7:
		                 var rest$6 = param[1]; return [7, erase_rel(rest$6)];
		                case 8:
		                 var rest$7 = param[2], ty = param[1];
		                 return [8, ty, erase_rel(rest$7)];
		                case 9:
		                 var rest$8 = param[3], ty1 = param[1];
		                 return [9, ty1, ty1, erase_rel(rest$8)];
		                case 10:
		                 var rest$9 = param[1]; return [10, erase_rel(rest$9)];
		                case 11:
		                 var rest$10 = param[1]; return [11, erase_rel(rest$10)];
		                case 12:
		                 var rest$11 = param[1]; return [12, erase_rel(rest$11)];
		                case 13:
		                 var rest$12 = param[1]; return [13, erase_rel(rest$12)];
		                default:
		                 var rest$13 = param[1]; return [14, erase_rel(rest$13)];
		              }
		             }
		             function concat_fmtty(fmtty1, fmtty2){
		              if(typeof fmtty1 === "number") return fmtty2;
		              switch(fmtty1[0]){
		                case 0:
		                 var rest = fmtty1[1]; return [0, concat_fmtty(rest, fmtty2)];
		                case 1:
		                 var rest$0 = fmtty1[1];
		                 return [1, concat_fmtty(rest$0, fmtty2)];
		                case 2:
		                 var rest$1 = fmtty1[1];
		                 return [2, concat_fmtty(rest$1, fmtty2)];
		                case 3:
		                 var rest$2 = fmtty1[1];
		                 return [3, concat_fmtty(rest$2, fmtty2)];
		                case 4:
		                 var rest$3 = fmtty1[1];
		                 return [4, concat_fmtty(rest$3, fmtty2)];
		                case 5:
		                 var rest$4 = fmtty1[1];
		                 return [5, concat_fmtty(rest$4, fmtty2)];
		                case 6:
		                 var rest$5 = fmtty1[1];
		                 return [6, concat_fmtty(rest$5, fmtty2)];
		                case 7:
		                 var rest$6 = fmtty1[1];
		                 return [7, concat_fmtty(rest$6, fmtty2)];
		                case 8:
		                 var rest$7 = fmtty1[2], ty = fmtty1[1];
		                 return [8, ty, concat_fmtty(rest$7, fmtty2)];
		                case 9:
		                 var rest$8 = fmtty1[3], ty2 = fmtty1[2], ty1 = fmtty1[1];
		                 return [9, ty1, ty2, concat_fmtty(rest$8, fmtty2)];
		                case 10:
		                 var rest$9 = fmtty1[1];
		                 return [10, concat_fmtty(rest$9, fmtty2)];
		                case 11:
		                 var rest$10 = fmtty1[1];
		                 return [11, concat_fmtty(rest$10, fmtty2)];
		                case 12:
		                 var rest$11 = fmtty1[1];
		                 return [12, concat_fmtty(rest$11, fmtty2)];
		                case 13:
		                 var rest$12 = fmtty1[1];
		                 return [13, concat_fmtty(rest$12, fmtty2)];
		                default:
		                 var rest$13 = fmtty1[1];
		                 return [14, concat_fmtty(rest$13, fmtty2)];
		              }
		             }
		             function concat_fmt(fmt1, fmt2){
		              if(typeof fmt1 === "number") return fmt2;
		              switch(fmt1[0]){
		                case 0:
		                 var rest = fmt1[1]; return [0, concat_fmt(rest, fmt2)];
		                case 1:
		                 var rest$0 = fmt1[1]; return [1, concat_fmt(rest$0, fmt2)];
		                case 2:
		                 var rest$1 = fmt1[2], pad = fmt1[1];
		                 return [2, pad, concat_fmt(rest$1, fmt2)];
		                case 3:
		                 var rest$2 = fmt1[2], pad$0 = fmt1[1];
		                 return [3, pad$0, concat_fmt(rest$2, fmt2)];
		                case 4:
		                 var
		                  rest$3 = fmt1[4],
		                  prec = fmt1[3],
		                  pad$1 = fmt1[2],
		                  iconv = fmt1[1];
		                 return [4, iconv, pad$1, prec, concat_fmt(rest$3, fmt2)];
		                case 5:
		                 var
		                  rest$4 = fmt1[4],
		                  prec$0 = fmt1[3],
		                  pad$2 = fmt1[2],
		                  iconv$0 = fmt1[1];
		                 return [5, iconv$0, pad$2, prec$0, concat_fmt(rest$4, fmt2)];
		                case 6:
		                 var
		                  rest$5 = fmt1[4],
		                  prec$1 = fmt1[3],
		                  pad$3 = fmt1[2],
		                  iconv$1 = fmt1[1];
		                 return [6, iconv$1, pad$3, prec$1, concat_fmt(rest$5, fmt2)];
		                case 7:
		                 var
		                  rest$6 = fmt1[4],
		                  prec$2 = fmt1[3],
		                  pad$4 = fmt1[2],
		                  iconv$2 = fmt1[1];
		                 return [7, iconv$2, pad$4, prec$2, concat_fmt(rest$6, fmt2)];
		                case 8:
		                 var
		                  rest$7 = fmt1[4],
		                  prec$3 = fmt1[3],
		                  pad$5 = fmt1[2],
		                  fconv = fmt1[1];
		                 return [8, fconv, pad$5, prec$3, concat_fmt(rest$7, fmt2)];
		                case 9:
		                 var rest$8 = fmt1[2], pad$6 = fmt1[1];
		                 return [9, pad$6, concat_fmt(rest$8, fmt2)];
		                case 10:
		                 var rest$9 = fmt1[1]; return [10, concat_fmt(rest$9, fmt2)];
		                case 11:
		                 var rest$10 = fmt1[2], str = fmt1[1];
		                 return [11, str, concat_fmt(rest$10, fmt2)];
		                case 12:
		                 var rest$11 = fmt1[2], chr = fmt1[1];
		                 return [12, chr, concat_fmt(rest$11, fmt2)];
		                case 13:
		                 var rest$12 = fmt1[3], fmtty = fmt1[2], pad$7 = fmt1[1];
		                 return [13, pad$7, fmtty, concat_fmt(rest$12, fmt2)];
		                case 14:
		                 var rest$13 = fmt1[3], fmtty$0 = fmt1[2], pad$8 = fmt1[1];
		                 return [14, pad$8, fmtty$0, concat_fmt(rest$13, fmt2)];
		                case 15:
		                 var rest$14 = fmt1[1];
		                 return [15, concat_fmt(rest$14, fmt2)];
		                case 16:
		                 var rest$15 = fmt1[1];
		                 return [16, concat_fmt(rest$15, fmt2)];
		                case 17:
		                 var rest$16 = fmt1[2], fmting_lit = fmt1[1];
		                 return [17, fmting_lit, concat_fmt(rest$16, fmt2)];
		                case 18:
		                 var rest$17 = fmt1[2], fmting_gen = fmt1[1];
		                 return [18, fmting_gen, concat_fmt(rest$17, fmt2)];
		                case 19:
		                 var rest$18 = fmt1[1];
		                 return [19, concat_fmt(rest$18, fmt2)];
		                case 20:
		                 var
		                  rest$19 = fmt1[3],
		                  char_set = fmt1[2],
		                  width_opt = fmt1[1];
		                 return [20, width_opt, char_set, concat_fmt(rest$19, fmt2)];
		                case 21:
		                 var rest$20 = fmt1[2], counter = fmt1[1];
		                 return [21, counter, concat_fmt(rest$20, fmt2)];
		                case 22:
		                 var rest$21 = fmt1[1];
		                 return [22, concat_fmt(rest$21, fmt2)];
		                case 23:
		                 var rest$22 = fmt1[2], ign = fmt1[1];
		                 return [23, ign, concat_fmt(rest$22, fmt2)];
		                default:
		                 var rest$23 = fmt1[3], f = fmt1[2], arity = fmt1[1];
		                 return [24, arity, f, concat_fmt(rest$23, fmt2)];
		              }
		             }
		             function failwith(s, a){
		              a = caml_pop_trap();
		              return a(caml_maybe_attach_backtrace([0, Failure, s], 1));
		             }
		             function invalid_arg(s, a){
		              a = caml_pop_trap();
		              return a
		                      (caml_maybe_attach_backtrace([0, Invalid_argument, s], 1));
		             }
		             var Exit = [248, "Stdlib.Exit", caml_fresh_oo_id()];
		             function min(x, y){return caml_lessequal(x, y) ? x : y;}
		             function max(x, y){return caml_greaterequal(x, y) ? x : y;}
		             function stdlib_abs(x){return 0 <= x ? x : - x | 0;}
		             function symbol_concat(s1, s2, cont){return cont(s1 + s2);}
		             function char_of_int(n, cont){
		              if(0 <= n && 255 >= n) return cont(n);
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "char_of_int", cont);
		             }
		             var cst_false = "false", cst_true = "true";
		             function string_of_bool(b, cont){
		              return b ? cont(cst_true) : cont(cst_false);
		             }
		             function string_of_int(n, cont){return cont("" + n);}
		             function int_of_string_opt(s){
		              try{var a = [0, caml_int_of_string(s)]; return a;}
		              catch(exn$0){
		               var exn = caml_wrap_exception(exn$0);
		               if(exn[1] === Failure) return 0;
		               throw caml_maybe_attach_backtrace(exn, 0);
		              }
		             }
		             var cst$14 = ".";
		             function valid_float_lexem(s1){
		              var l = caml_ml_string_length(s1), i = 0;
		              for(;;){
		               if(l <= i) return s1 + cst$14;
		               var match = caml_string_get(s1, i);
		               a:
		               {
		                if(48 <= match){
		                 if(58 <= match) break a;
		                }
		                else if(45 !== match) break a;
		                var i$0 = i + 1 | 0;
		                i = i$0;
		                continue;
		               }
		               return s1;
		              }
		             }
		             function string_of_float(f){
		              return valid_float_lexem(caml_format_float("%.12g", f));
		             }
		             function symbol(l1, l2){
		              if(! l1) return l2;
		              var a = l1[2], h1 = l1[1];
		              if(! a) return [0, h1, l2];
		              var b = a[2], h2 = a[1];
		              if(! b) return [0, h1, [0, h2, l2]];
		              var
		               tl = b[2],
		               h3 = b[1],
		               block = [0, h3, 24029],
		               dst = block,
		               offset = 1,
		               l1$0 = tl;
		              for(;;){
		               if(l1$0){
		                b = l1$0[2];
		                var h1$0 = l1$0[1];
		                if(b){
		                 a = b[2];
		                 var h2$0 = b[1];
		                 if(a){
		                  var tl$0 = a[2], h3$0 = a[1], dst$0 = [0, h3$0, 24029];
		                  dst[offset + 1] = [0, h1$0, [0, h2$0, dst$0]];
		                  dst = dst$0;
		                  offset = 1;
		                  l1$0 = tl$0;
		                  continue;
		                 }
		                 dst[offset + 1] = [0, h1$0, [0, h2$0, l2]];
		                }
		                else
		                 dst[offset + 1] = [0, h1$0, l2];
		               }
		               else
		                dst[offset + 1] = l2;
		               return [0, h1, [0, h2, block]];
		              }
		             }
		             caml_ml_open_descriptor_in(0);
		             var
		              stdout = caml_ml_open_descriptor_out(1),
		              stderr = caml_ml_open_descriptor_out(2);
		             function flush_all(b, c){
		              b = caml_ml_out_channels_list();
		              for(;;){
		               if(! b) return c(0);
		               var l = b[2], a = b[1];
		               try{caml_ml_flush(a); b = l;}
		               catch(exn$1){
		                var exn = caml_wrap_exception(exn$1);
		                if(exn[1] !== Sys_error){
		                 c = caml_pop_trap();
		                 var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                 return c(exn$0);
		                }
		                b = l;
		               }
		              }
		             }
		             function output_string(oc, s){
		              caml_ml_output(oc, s, 0, caml_ml_string_length(s));
		             }
		             var cst_output = "output";
		             function output(oc, s, ofs, len, cont){
		              if
		               (0 <= ofs
		                && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs){caml_ml_output_bytes(oc, s, ofs, len); return cont();}
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, cst_output, cont);
		             }
		             function output_substring(oc, s, ofs, len, cont){
		              if
		               (0 <= ofs
		                && 0 <= len && (caml_ml_string_length(s) - len | 0) >= ofs)
		               return cont(caml_ml_output(oc, s, ofs, len));
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "output_substring", cont);
		             }
		             function open_in_gen(mode, perm, name){
		              var
		               c = caml_ml_open_descriptor_in(caml_sys_open(name, mode, perm));
		              caml_ml_set_channel_name(c, name);
		              return c;
		             }
		             var bV = [0, 0, [0, 6, 0]];
		             function open_in_bin(name){return open_in_gen(bV, 0, name);}
		             var cst_input = "input";
		             function input(ic, s, ofs, len, cont){
		              if
		               (0 <= ofs
		                && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs)
		               return cont(caml_ml_input(ic, s, ofs, len));
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, cst_input, cont);
		             }
		             function input_line(chan){
		              function build_result(buf, pos$1, a){
		               var pos = pos$1;
		               for(;;){
		                if(! a) return buf;
		                var tl = a[2], hd = a[1], len = caml_ml_bytes_length(hd);
		                caml_blit_bytes(hd, 0, buf, pos - len | 0, len);
		                var pos$0 = pos - len | 0;
		                pos = pos$0;
		                a = tl;
		               }
		              }
		              var accu = 0, len = 0;
		              for(;;){
		               var n = caml_ml_input_scan_line(chan);
		               if(0 === n){
		                if(! accu) throw caml_maybe_attach_backtrace(End_of_file, 1);
		                var a = build_result(caml_create_bytes(len), len, accu);
		               }
		               else {
		                if(0 >= n){
		                 var beg = caml_create_bytes(- n | 0);
		                 caml_ml_input(chan, beg, 0, - n | 0);
		                 var len$1 = len - n | 0, accu$0 = [0, beg, accu];
		                 accu = accu$0;
		                 len = len$1;
		                 continue;
		                }
		                var res = caml_create_bytes(n - 1 | 0);
		                caml_ml_input(chan, res, 0, n - 1 | 0);
		                caml_ml_input_char(chan);
		                if(accu)
		                 var
		                  len$0 = (len + n | 0) - 1 | 0,
		                  a =
		                    build_result
		                     (caml_create_bytes(len$0), len$0, [0, res, accu]);
		                else
		                 a = res;
		               }
		               return caml_string_of_bytes(a);
		              }
		             }
		             function print_endline(s){
		              output_string(stdout, s);
		              caml_ml_output_char(stdout, 10);
		              caml_ml_flush(stdout);
		             }
		             function prerr_endline(s){
		              output_string(stderr, s);
		              caml_ml_output_char(stderr, 10);
		              return caml_ml_flush(stderr);
		             }
		             function symbol$0(a, param){
		              var
		               str2 = param[2],
		               fmt2 = param[1],
		               str1 = a[2],
		               fmt1 = a[1],
		               s2 = "%," + str2;
		              return [0, concat_fmt(fmt1, fmt2), str1 + s2];
		             }
		             var dummy = 0, exit_function = [0, flush_all];
		             function at_exit(f){
		              for(;;){
		               var old_exit = caml_atomic_load(exit_function);
		               let f_yet_to_run = [0, 1], old_exit$0 = old_exit;
		               var
		                new_exit =
		                  function(param, cont){
		                   function a(a){
		                    return caml_trampoline_cps_call2(old_exit$0, 0, cont);
		                   }
		                   return caml_atomic_cas(f_yet_to_run, 1, 0)
		                           ? caml_exact_trampoline_cps_call(f, dummy, a)
		                           : a();
		                  },
		                success = caml_atomic_cas(exit_function, old_exit, new_exit),
		                a = 1 - success;
		               if(! a) return a;
		              }
		             }
		             var
		              do_domain_local_at_exit =
		                [0, function(param, cont){return cont();}];
		             function do_at_exit(param, cont){
		              return caml_trampoline_cps_call2
		                      (do_domain_local_at_exit[1],
		                       0,
		                       function(a){
		                        return caml_trampoline_cps_call2
		                                (caml_atomic_load(exit_function), 0, cont);
		                       });
		             }
		             function exit(retcode, cont){
		              return caml_exact_trampoline_cps_call
		                      (do_at_exit,
		                       dummy,
		                       function(a){return cont(caml_sys_exit(retcode));});
		             }
		             caml_register_named_value("Pervasives.do_at_exit", do_at_exit);
		             var
		              executable_name = caml_sys_executable_name(),
		              os_type = caml_sys_get_config()[1],
		              max_array_length = caml_sys_const_max_wosize(),
		              max_string_length = (4 * max_array_length | 0) - 1 | 0;
		             function getenv_opt(s){
		              try{var a = [0, caml_sys_getenv(s)]; return a;}
		              catch(exn$0){
		               var exn = caml_wrap_exception(exn$0);
		               if(exn === Not_found) return 0;
		               throw caml_maybe_attach_backtrace(exn, 0);
		              }
		             }
		             var Break = [248, "Stdlib.Sys.Break", caml_fresh_oo_id()];
		             function is_block(a){return 1 - (typeof a === "number");}
		             function of_val(x, cont){
		              var
		               slot =
		                 is_block(x)
		                  ? caml_obj_tag(x) !== 248 ? 1 <= x.length - 1 ? x[1] : x : x
		                  : x,
		               cst_Obj_extension_constructor = "Obj.extension_constructor";
		              function a(name){
		               return caml_obj_tag(name) === 252
		                       ? cont(slot)
		                       : caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_Obj_extension_constructor, cont);
		              }
		              if(is_block(slot) && caml_obj_tag(slot) === 248)
		               return a(slot[1]);
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, cst_Obj_extension_constructor, a);
		             }
		             function hash(slot){return slot[2];}
		             var max_ephe_length = max_array_length - 2 | 0;
		             function raise_if_invalid_offset(e, o, msg, cont){
		              var a = 0 <= o, a = a ? o < (e.length - 3 | 0) : a, a = 1 - a;
		              return a
		                      ? caml_exact_trampoline_cps_call(invalid_arg, msg, cont)
		                      : cont(a);
		             }
		             function set(r, x){caml_atomic_exchange(r, x); return 0;}
		             function incr(r){caml_atomic_fetch_add(r, 1);}
		             var
		              Undefined =
		                [248, "CamlinternalLazy.Undefined", caml_fresh_oo_id()];
		             function force_lazy_block(blk, cont){
		              if(0 === caml_lazy_update_to_forcing(blk)){
		               var closure = blk[1];
		               blk[1] = 0;
		               caml_push_trap
		                (function(e){
		                  blk[1] =
		                   function(param, a){
		                    a = caml_pop_trap();
		                    var e$0 = caml_maybe_attach_backtrace(e, 0);
		                    return a(e$0);
		                   };
		                  caml_lazy_reset_to_lazy(blk);
		                  var
		                   raise = caml_pop_trap(),
		                   e$0 = caml_maybe_attach_backtrace(e, 0);
		                  return raise(e$0);
		                 });
		               return caml_trampoline_cps_call2
		                       (closure,
		                        0,
		                        function(result){
		                         blk[1] = result;
		                         caml_lazy_update_to_forward(blk);
		                         caml_pop_trap();
		                         return cont(result);
		                        });
		              }
		              var
		               raise = caml_pop_trap(),
		               Undefined$0 = caml_maybe_attach_backtrace(Undefined, 1);
		              return raise(Undefined$0);
		             }
		             function from_fun(f){
		              var x = caml_obj_block(246, 1);
		              x[1] = f;
		              return x;
		             }
		             function from_val(v, cont){
		              var t = caml_obj_tag(v);
		              if(t !== 250 && t !== 246 && t !== 244 && t !== 253)
		               return cont(v);
		              return cont(caml_lazy_make_forward(v));
		             }
		             function map(f, seq, param, cont){
		              return caml_trampoline_cps_call2
		                      (seq,
		                       0,
		                       function(match){
		                        if(! match) return cont(0);
		                        var next = match[2], x = match[1];
		                        function a(a, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (map, f, next, dummy, cont);
		                        }
		                        return caml_trampoline_cps_call2
		                                (f, x, function(b){return cont([0, b, a]);});
		                       });
		             }
		             function iter(f, seq, cont){
		              function a(seq){
		               return caml_trampoline_cps_call2
		                       (seq,
		                        0,
		                        function(match){
		                         if(! match) return cont(0);
		                         var next = match[2], x = match[1];
		                         return caml_exact_trampoline_cps_call
		                                 (f,
		                                  x,
		                                  function(b){return caml_exact_trampoline_call1(a, next);});
		                        });
		              }
		              return a(seq);
		             }
		             function unfold(f, u, a){
		              a = f(u);
		              if(! a) return 0;
		              a = a[1];
		              var u$0 = a[2], x = a[1];
		              return [0, x, function(a, cont){return cont(unfold(f, u$0));}];
		             }
		             function some(v, cont){return cont([0, v]);}
		             function value(o, default$){
		              if(! o) return default$;
		              var v = o[1];
		              return v;
		             }
		             function get(param, cont){
		              if(! param)
		               return caml_exact_trampoline_cps_call
		                       (invalid_arg, "option is None", cont);
		              var v = param[1];
		              return cont(v);
		             }
		             function is_none(param){return param ? 0 : 1;}
		             function chr(n, cont){
		              if(0 <= n && 255 >= n) return cont(n);
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "Char.chr", cont);
		             }
		             var cst$0 = "\\'", cst = "\\\\", cst_n = "\\n";
		             function escaped(c){
		              a:
		              {
		               if(40 <= c){
		                if(92 === c) return cst;
		                if(127 <= c) break a;
		               }
		               else {
		                if(32 > c){
		                 if(14 <= c) break a;
		                 switch(c){
		                   case 8:
		                    return "\\b";
		                   case 9:
		                    return "\\t";
		                   case 10:
		                    return cst_n;
		                   case 13:
		                    return "\\r";
		                   default: break a;
		                 }
		                }
		                if(39 <= c) return cst$0;
		               }
		               var s$0 = caml_create_bytes(1);
		               caml_bytes_unsafe_set(s$0, 0, c);
		               return caml_string_of_bytes(s$0);
		              }
		              var s = caml_create_bytes(4);
		              caml_bytes_unsafe_set(s, 0, 92);
		              caml_bytes_unsafe_set(s, 1, 48 + (c / 100 | 0) | 0);
		              caml_bytes_unsafe_set(s, 2, 48 + ((c / 10 | 0) % 10 | 0) | 0);
		              caml_bytes_unsafe_set(s, 3, 48 + (c % 10 | 0) | 0);
		              return caml_string_of_bytes(s);
		             }
		             function lowercase_ascii(c){
		              return 25 < c - 65 >>> 0 ? c : c + 32 | 0;
		             }
		             function uppercase_ascii(c){
		              return 25 < c - 97 >>> 0 ? c : c - 32 | 0;
		             }
		             function equal(c1, c2){return 0 === (c1 - c2 | 0) ? 1 : 0;}
		             function int_is_scalar(i){
		              var a = 0 <= i ? 1 : 0, a = a ? i <= 55295 ? 1 : 0 : a;
		              if(a)
		               ;
		              else {a = 57344 <= i ? 1 : 0; a = a ? i <= 1114111 ? 1 : 0 : a;}
		              return a;
		             }
		             var cst_X = "%X";
		             function of_int(i, cont){
		              if(int_is_scalar(i)) return cont(i);
		              var s1 = caml_format_int(cst_X, i);
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, s1 + " is not an Unicode scalar value", cont);
		             }
		             function utf_decode_is_valid(d){
		              return 1 === (d >>> 27 | 0) ? 1 : 0;
		             }
		             function utf_decode_length(d){return (d >>> 24 | 0) & 7;}
		             function utf_decode(n, u){return (8 | n) << 24 | u;}
		             function utf_decode_invalid(n){return n << 24 | 65533;}
		             var b = "uchar.ml", bX = [0, b, 85, 7], bY = [0, b, 80, 18];
		             function utf_8_byte_length(u){
		              if(0 > u)
		               throw caml_maybe_attach_backtrace([0, Assert_failure, bY], 1);
		              if(127 >= u) return 1;
		              if(2047 >= u) return 2;
		              if(65535 >= u) return 3;
		              if(1114111 < u)
		               throw caml_maybe_attach_backtrace([0, Assert_failure, bX], 1);
		              return 4;
		             }
		             var bZ = [0, b, 91, 7], b0 = [0, b, 88, 18];
		             function utf_16_byte_length(u){
		              if(0 > u)
		               throw caml_maybe_attach_backtrace([0, Assert_failure, b0], 1);
		              if(65535 >= u) return 2;
		              if(1114111 < u)
		               throw caml_maybe_attach_backtrace([0, Assert_failure, bZ], 1);
		              return 4;
		             }
		             function length(l$0){
		              var len = 0, param = l$0;
		              for(;;){
		               if(! param) return len;
		               var l = param[2], len$0 = len + 1 | 0;
		               len = len$0;
		               param = l;
		              }
		             }
		             var cst_hd = "hd";
		             function hd_exn(param, cont){
		              if(! param)
		               return caml_exact_trampoline_cps_call(failwith, cst_hd, cont);
		              var a = param[1];
		              return cont(a);
		             }
		             var cst_tl = "tl";
		             function tl_exn(param, cont){
		              if(! param)
		               return caml_exact_trampoline_cps_call(failwith, cst_tl, cont);
		              var l = param[2];
		              return cont(l);
		             }
		             function rev_append(l1$1, l2$1){
		              var l1 = l1$1, l2 = l2$1;
		              for(;;){
		               if(! l1) return l2;
		               var l1$0 = l1[2], a = l1[1], l2$0 = [0, a, l2];
		               l1 = l1$0;
		               l2 = l2$0;
		              }
		             }
		             function rev(l){return rev_append(l, 0);}
		             function flatten(param){
		              if(! param) return 0;
		              var r = param[2], l = param[1];
		              return symbol(l, flatten(r));
		             }
		             function map$0(f, param, cont){
		              if(! param) return cont(0);
		              var match = param[2], a1 = param[1];
		              if(! match)
		               return caml_trampoline_cps_call2
		                       (f, a1, function(r1){return cont([0, r1, 0]);});
		              var l = match[2], a2 = match[1];
		              return caml_trampoline_cps_call2
		                      (f,
		                       a1,
		                       function(r1){
		                        return caml_trampoline_cps_call2
		                                (f,
		                                 a2,
		                                 function(r2){
		                                  var block = [0, r2, 24029];
		                                  function a(dst, offset, param){
		                                   function b(){return cont([0, r1, block]);}
		                                   if(! param){dst[offset + 1] = 0; return b();}
		                                   var match = param[2], a1 = param[1];
		                                   if(! match)
		                                    return caml_trampoline_cps_call2
		    (f,
		     a1,
		     function(r1){dst[offset + 1] = [0, r1, 0]; return b();});
		                                   var l = match[2], a2 = match[1];
		                                   return caml_trampoline_cps_call2
		   (f,
		    a1,
		    function(r1){
		     return caml_trampoline_cps_call2
		             (f,
		              a2,
		              function(r2){
		               var dst$0 = [0, r2, 24029];
		               dst[offset + 1] = [0, r1, dst$0];
		               return caml_exact_trampoline_call3(a, dst$0, 1, l);
		              });
		    });
		                                  }
		                                  return a(block, 1, l);
		                                 });
		                       });
		             }
		             function mapi(f, l$0, cont){
		              if(! l$0) return cont(0);
		              var match = l$0[2], a1 = l$0[1], i = 0;
		              if(! match)
		               return caml_exact_trampoline_cps_call$1
		                       (f, i, a1, function(r1){return cont([0, r1, 0]);});
		              var l = match[2], a2 = match[1];
		              return caml_exact_trampoline_cps_call$1
		                      (f,
		                       i,
		                       a1,
		                       function(r1){
		                        return caml_exact_trampoline_cps_call$1
		                                (f,
		                                 1,
		                                 a2,
		                                 function(r2){
		                                  var block = [0, r2, 24029];
		                                  function a(dst, offset, i, param){
		                                   function b(){return cont([0, r1, block]);}
		                                   if(! param){dst[offset + 1] = 0; return b();}
		                                   var match = param[2], a1 = param[1];
		                                   if(! match)
		                                    return caml_exact_trampoline_cps_call$1
		    (f,
		     i,
		     a1,
		     function(r1){dst[offset + 1] = [0, r1, 0]; return b();});
		                                   var l = match[2], a2 = match[1];
		                                   return caml_exact_trampoline_cps_call$1
		   (f,
		    i,
		    a1,
		    function(r1){
		     return caml_exact_trampoline_cps_call$1
		             (f,
		              i + 1 | 0,
		              a2,
		              function(r2){
		               var dst$0 = [0, r2, 24029];
		               dst[offset + 1] = [0, r1, dst$0];
		               var i$0 = i + 2 | 0;
		               return caml_exact_trampoline_call4(a, dst$0, 1, i$0, l);
		              });
		    });
		                                  }
		                                  return a(block, 1, 2, l);
		                                 });
		                       });
		             }
		             function iter$0(f, param, cont){
		              function a(param){
		               if(! param) return cont(0);
		               var l = param[2], a$0 = param[1];
		               return caml_exact_trampoline_cps_call
		                       (f,
		                        a$0,
		                        function(b){return caml_exact_trampoline_call1(a, l);});
		              }
		              return a(param);
		             }
		             function fold_left(f, accu, l, cont){
		              function a(accu, l){
		               if(! l) return cont(accu);
		               var l$0 = l[2], a$0 = l[1];
		               return caml_trampoline_cps_call3
		                       (f,
		                        accu,
		                        a$0,
		                        function(accu){
		                         return caml_exact_trampoline_call2(a, accu, l$0);
		                        });
		              }
		              return a(accu, l);
		             }
		             function fold_right(f, l, accu, cont){
		              if(! l) return cont(accu);
		              var l$0 = l[2], a = l[1];
		              return caml_exact_trampoline_cps_call$0
		                      (fold_right,
		                       f,
		                       l$0,
		                       accu,
		                       function(b){
		                        return caml_exact_trampoline_cps_call$1(f, a, b, cont);
		                       });
		             }
		             function memq(x, b){
		              for(;;){
		               if(! b) return 0;
		               var l = b[2], a = b[1], b = a === x ? 1 : 0;
		               if(b) return b;
		               b = l;
		              }
		             }
		             function assq(x, c){
		              for(;;){
		               if(! c) throw caml_maybe_attach_backtrace(Not_found, 1);
		               var l = c[2], c = c[1], b = c[2], a = c[1];
		               if(a === x) return b;
		               c = l;
		              }
		             }
		             function remove_assq(x, param){
		              if(! param) return 0;
		              var l = param[2], pair = param[1], a = pair[1];
		              return a === x ? l : [0, pair, remove_assq(x, l)];
		             }
		             function find_all(p, a){
		              for(;;){
		               if(! a) return 0;
		               var l = a[2], x = a[1];
		               if(p(x)) break;
		               a = l;
		              }
		              var block = [0, x, 24029], dst = block, offset = 1, a = l;
		              for(;;){
		               if(! a){dst[offset + 1] = 0; return block;}
		               var l$0 = a[2], x$0 = a[1];
		               if(p(x$0)){
		                var dst$0 = [0, x$0, 24029];
		                dst[offset + 1] = dst$0;
		                dst = dst$0;
		                offset = 1;
		                a = l$0;
		               }
		               else
		                a = l$0;
		              }
		             }
		             function filter_map(f, a){
		              for(;;){
		               if(! a) return 0;
		               var l = a[2], x = a[1], a = f(x);
		               if(a) break;
		               a = l;
		              }
		              var
		               v = a[1],
		               block = [0, v, 24029],
		               dst = block,
		               offset = 1,
		               a = l;
		              for(;;){
		               if(! a){dst[offset + 1] = 0; return block;}
		               var l$0 = a[2], x$0 = a[1], a = f(x$0);
		               if(a){
		                var v$0 = a[1], dst$0 = [0, v$0, 24029];
		                dst[offset + 1] = dst$0;
		                dst = dst$0;
		                offset = 1;
		                a = l$0;
		               }
		               else
		                a = l$0;
		              }
		             }
		             function sort_uniq(cmp, l, cont){
		              function sort(n, l, cont){
		               if(2 === n){
		                if(l){
		                 var a = l[2];
		                 if(a){
		                  var tl = a[2], x2 = a[1], x1 = l[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (cmp,
		                           x1,
		                           x2,
		                           function(c){
		                            var
		                             s =
		                               0 === c
		                                ? [0, x1, 0]
		                                : 0 <= c ? [0, x2, [0, x1, 0]] : [0, x1, [0, x2, 0]];
		                            return cont([0, s, tl]);
		                           });
		                 }
		                }
		               }
		               else if(3 === n && l){
		                a = l[2];
		                if(a){
		                 var match = a[2];
		                 if(match){
		                  var
		                   tl$0 = match[2],
		                   x3 = match[1],
		                   x2$0 = a[1],
		                   x1$0 = l[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (cmp,
		                           x1$0,
		                           x2$0,
		                           function(c){
		                            function a(s){return cont([0, s, tl$0]);}
		                            return 0 === c
		                                    ? caml_exact_trampoline_cps_call$1
		                                      (cmp,
		                                       x2$0,
		                                       x3,
		                                       function(c){
		return 0 === c
		        ? a([0, x2$0, 0])
		        : 0
		          <= c
		          ? a([0, x3, [0, x2$0, 0]])
		          : a([0, x2$0, [0, x3, 0]]);
		                                       })
		                                    : 0
		                                      <= c
		                                      ? caml_exact_trampoline_cps_call$1
		(cmp,
		 x1$0,
		 x3,
		 function(c){
		  return 0 === c
		          ? a([0, x2$0, [0, x1$0, 0]])
		          : 0
		            <= c
		            ? caml_exact_trampoline_cps_call$1
		              (cmp,
		               x2$0,
		               x3,
		               function(c){
		                return 0 === c
		                        ? a([0, x2$0, [0, x1$0, 0]])
		                        : 0
		                          <= c
		                          ? a([0, x3, [0, x2$0, [0, x1$0, 0]]])
		                          : a([0, x2$0, [0, x3, [0, x1$0, 0]]]);
		               })
		            : a([0, x2$0, [0, x1$0, [0, x3, 0]]]);
		 })
		                                      : caml_exact_trampoline_cps_call$1
		(cmp,
		 x2$0,
		 x3,
		 function(c){
		  return 0 === c
		          ? a([0, x1$0, [0, x2$0, 0]])
		          : 0
		            <= c
		            ? caml_exact_trampoline_cps_call$1
		              (cmp,
		               x1$0,
		               x3,
		               function(c){
		                return 0 === c
		                        ? a([0, x1$0, [0, x2$0, 0]])
		                        : 0
		                          <= c
		                          ? a([0, x3, [0, x1$0, [0, x2$0, 0]]])
		                          : a([0, x1$0, [0, x3, [0, x2$0, 0]]]);
		               })
		            : a([0, x1$0, [0, x2$0, [0, x3, 0]]]);
		 });
		                           });
		                 }
		                }
		               }
		               var n1 = n >> 1, n2 = n - n1 | 0;
		               return caml_exact_trampoline_cps_call$1
		                       (rev_sort,
		                        n1,
		                        l,
		                        function(match){
		                         var l2 = match[2], s1 = match[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (rev_sort,
		                                  n2,
		                                  l2,
		                                  function(match){
		                                   var tl = match[2], s2 = match[1];
		                                   function a(l1, l2, accu){
		                                    if(l1){
		                                     if(l2){
		                                      var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (cmp,
		       h1,
		       h2,
		       function(c){
		        if(0 === c){
		         var accu$0 = [0, h1, accu];
		         return caml_exact_trampoline_call3(a, t1, t2, accu$0);
		        }
		        if(0 < c){
		         var accu$1 = [0, h1, accu];
		         return caml_exact_trampoline_call3(a, t1, l2, accu$1);
		        }
		        var accu$2 = [0, h2, accu];
		        return caml_exact_trampoline_call3(a, l1, t2, accu$2);
		       });
		                                     }
		                                     var b = rev_append(l1, accu);
		                                    }
		                                    else
		                                     b = rev_append(l2, accu);
		                                    return cont([0, b, tl]);
		                                   }
		                                   return a(s1, s2, 0);
		                                  });
		                        });
		              }
		              function rev_sort(n, l, cont){
		               if(2 === n){
		                if(l){
		                 var a = l[2];
		                 if(a){
		                  var tl = a[2], x2 = a[1], x1 = l[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (cmp,
		                           x1,
		                           x2,
		                           function(c){
		                            var
		                             s =
		                               0 === c
		                                ? [0, x1, 0]
		                                : 0 < c ? [0, x1, [0, x2, 0]] : [0, x2, [0, x1, 0]];
		                            return cont([0, s, tl]);
		                           });
		                 }
		                }
		               }
		               else if(3 === n && l){
		                a = l[2];
		                if(a){
		                 var match = a[2];
		                 if(match){
		                  var
		                   tl$0 = match[2],
		                   x3 = match[1],
		                   x2$0 = a[1],
		                   x1$0 = l[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (cmp,
		                           x1$0,
		                           x2$0,
		                           function(c){
		                            function a(s){return cont([0, s, tl$0]);}
		                            return 0 === c
		                                    ? caml_exact_trampoline_cps_call$1
		                                      (cmp,
		                                       x2$0,
		                                       x3,
		                                       function(c){
		return 0 === c
		        ? a([0, x2$0, 0])
		        : 0
		          < c
		          ? a([0, x2$0, [0, x3, 0]])
		          : a([0, x3, [0, x2$0, 0]]);
		                                       })
		                                    : 0
		                                      < c
		                                      ? caml_exact_trampoline_cps_call$1
		(cmp,
		 x2$0,
		 x3,
		 function(c){
		  return 0 === c
		          ? a([0, x1$0, [0, x2$0, 0]])
		          : 0
		            < c
		            ? a([0, x1$0, [0, x2$0, [0, x3, 0]]])
		            : caml_exact_trampoline_cps_call$1
		              (cmp,
		               x1$0,
		               x3,
		               function(c){
		                return 0 === c
		                        ? a([0, x1$0, [0, x2$0, 0]])
		                        : 0
		                          < c
		                          ? a([0, x1$0, [0, x3, [0, x2$0, 0]]])
		                          : a([0, x3, [0, x1$0, [0, x2$0, 0]]]);
		               });
		 })
		                                      : caml_exact_trampoline_cps_call$1
		(cmp,
		 x1$0,
		 x3,
		 function(c){
		  return 0 === c
		          ? a([0, x2$0, [0, x1$0, 0]])
		          : 0
		            < c
		            ? a([0, x2$0, [0, x1$0, [0, x3, 0]]])
		            : caml_exact_trampoline_cps_call$1
		              (cmp,
		               x2$0,
		               x3,
		               function(c){
		                return 0 === c
		                        ? a([0, x2$0, [0, x1$0, 0]])
		                        : 0
		                          < c
		                          ? a([0, x2$0, [0, x3, [0, x1$0, 0]]])
		                          : a([0, x3, [0, x2$0, [0, x1$0, 0]]]);
		               });
		 });
		                           });
		                 }
		                }
		               }
		               var n1 = n >> 1, n2 = n - n1 | 0;
		               return caml_exact_trampoline_cps_call$1
		                       (sort,
		                        n1,
		                        l,
		                        function(match){
		                         var l2 = match[2], s1 = match[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (sort,
		                                  n2,
		                                  l2,
		                                  function(match){
		                                   var tl = match[2], s2 = match[1];
		                                   function a(l1, l2, accu){
		                                    if(l1){
		                                     if(l2){
		                                      var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (cmp,
		       h1,
		       h2,
		       function(c){
		        if(0 === c){
		         var accu$0 = [0, h1, accu];
		         return caml_exact_trampoline_call3(a, t1, t2, accu$0);
		        }
		        if(0 <= c){
		         var accu$1 = [0, h2, accu];
		         return caml_exact_trampoline_call3(a, l1, t2, accu$1);
		        }
		        var accu$2 = [0, h1, accu];
		        return caml_exact_trampoline_call3(a, t1, l2, accu$2);
		       });
		                                     }
		                                     var b = rev_append(l1, accu);
		                                    }
		                                    else
		                                     b = rev_append(l2, accu);
		                                    return cont([0, b, tl]);
		                                   }
		                                   return a(s1, s2, 0);
		                                  });
		                        });
		              }
		              var len = length(l);
		              return 2 <= len
		                      ? caml_exact_trampoline_cps_call$1
		                        (sort, len, l, function(a){return cont();})
		                      : cont(l);
		             }
		             function to_seq(l){
		              function aux(l, param){
		               if(! l) return 0;
		               var tail = l[2], x = l[1];
		               return [0, x, function(a, cont){return cont(aux(tail));}];
		              }
		              return function(a, cont){return cont(aux(l));};
		             }
		             function of_seq(seq){
		              var a = seq();
		              if(! a) return;
		              var seq$0 = a[2], a = seq$0();
		              if(! a) return;
		              var
		               seq$1 = a[2],
		               x2 = a[1],
		               dst = [0, x2, 24029],
		               offset = 1,
		               seq$2 = seq$1;
		              for(;;){
		               a = seq$2();
		               if(a){
		                var seq$3 = a[2], x1 = a[1], a = seq$3();
		                if(a){
		                 var seq$4 = a[2], x2$0 = a[1], dst$0 = [0, x2$0, 24029];
		                 dst[offset + 1] = [0, x1, dst$0];
		                 dst = dst$0;
		                 offset = 1;
		                 seq$2 = seq$4;
		                 continue;
		                }
		                dst[offset + 1] = [0, x1, 0];
		               }
		               else
		                dst[offset + 1] = 0;
		               return;
		              }
		             }
		             function min$0(x, y){return x <= y ? x : y;}
		             function max$0(x, y){return y <= x ? x : y;}
		             function make(n, c){
		              var s = caml_create_bytes(n);
		              caml_fill_bytes(s, 0, n, c);
		              return s;
		             }
		             var empty_return = caml_create_bytes(0);
		             function copy(s){
		              var len = caml_ml_bytes_length(s), r = caml_create_bytes(len);
		              caml_blit_bytes(s, 0, r, 0, len);
		              return r;
		             }
		             function to_string(b){return caml_string_of_bytes(copy(b));}
		             function of_string(s, cont){
		              return cont(copy(caml_bytes_of_string(s)));
		             }
		             function sub(s, ofs, len, cont){
		              if
		               (0 <= ofs
		                && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs){
		               var r = caml_create_bytes(len);
		               caml_blit_bytes(s, ofs, r, 0, len);
		               return cont(r);
		              }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "String.sub / Bytes.sub", cont);
		             }
		             function sub_string(b, ofs, len, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (sub,
		                       b,
		                       ofs,
		                       len,
		                       function(a){return cont(caml_string_of_bytes(a));});
		             }
		             function fill(s, ofs, len, c, cont){
		              if
		               (0 <= ofs
		                && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs){caml_fill_bytes(s, ofs, len, c); return cont();}
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "String.fill / Bytes.fill", cont);
		             }
		             function blit(s1, ofs1, s2, ofs2, len, cont){
		              if
		               (0 <= len
		                &&
		                 0 <= ofs1
		                 &&
		                  (caml_ml_bytes_length(s1) - len | 0) >= ofs1
		                  && 0 <= ofs2 && (caml_ml_bytes_length(s2) - len | 0) >= ofs2){caml_blit_bytes(s1, ofs1, s2, ofs2, len); return cont();}
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "Bytes.blit", cont);
		             }
		             function blit_string(s1, ofs1, s2, ofs2, len, cont){
		              if
		               (0 <= len
		                &&
		                 0 <= ofs1
		                 &&
		                  (caml_ml_string_length(s1) - len | 0) >= ofs1
		                  && 0 <= ofs2 && (caml_ml_bytes_length(s2) - len | 0) >= ofs2){caml_blit_string(s1, ofs1, s2, ofs2, len); return cont();}
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "String.blit / Bytes.blit_string", cont);
		             }
		             function is_space(a){
		              a = a - 9 | 0;
		              a:
		              {
		               if(4 < a >>> 0){
		                if(23 !== a) break a;
		               }
		               else if(2 === a) break a;
		               return 1;
		              }
		              return 0;
		             }
		             function map$1(f, s){
		              var l = caml_ml_bytes_length(s);
		              if(0 === l) return s;
		              var r = caml_create_bytes(l), a = l - 1 | 0;
		              if(a >= 0){
		               var i = 0;
		               for(;;){
		                caml_bytes_unsafe_set(r, i, f(caml_bytes_unsafe_get(s, i)));
		                var b = i + 1 | 0;
		                if(a === i) break;
		                i = b;
		               }
		              }
		              return r;
		             }
		             function apply1(f, s){
		              if(0 === caml_ml_bytes_length(s)) return s;
		              var r = copy(s);
		              caml_bytes_unsafe_set(r, 0, f(caml_bytes_unsafe_get(s, 0)));
		              return r;
		             }
		             function unsafe_get_uint16_be(b, i){
		              return caml_bswap16(caml_bytes_get16(b, i));
		             }
		             function get_int32_be(b, i){
		              return caml_int32_bswap(caml_bytes_get32(b, i));
		             }
		             function unsafe_set_uint16_be(b, i, x){
		              caml_bytes_set16(b, i, caml_bswap16(x));
		             }
		             function set_int32_le(b, i, x, cont){
		              return cont(caml_bytes_set32(b, i, x));
		             }
		             function set_int32_be(b, i, x, cont){
		              return cont(caml_bytes_set32(b, i, caml_int32_bswap(x)));
		             }
		             function set_int64_be(b, i, x){
		              caml_bytes_set64(b, i, caml_int64_bswap(x));
		             }
		             function not_in_x80_to_xBF(b){
		              return 2 !== (b >>> 6 | 0) ? 1 : 0;
		             }
		             function not_in_xA0_to_xBF(b){
		              return 5 !== (b >>> 5 | 0) ? 1 : 0;
		             }
		             function not_in_x80_to_x9F(b){
		              return 4 !== (b >>> 5 | 0) ? 1 : 0;
		             }
		             function not_in_x90_to_xBF(b){
		              var a = b < 144 ? 1 : 0, a = a || (191 < b ? 1 : 0);
		              return a;
		             }
		             function not_in_x80_to_x8F(b){
		              return 8 !== (b >>> 4 | 0) ? 1 : 0;
		             }
		             function utf_8_uchar_3(b0, b1, b2){
		              return (b0 & 15) << 12 | (b1 & 63) << 6 | b2 & 63;
		             }
		             function utf_8_uchar_4(b0, b1, b2, b3){
		              return (b0 & 7) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6
		                     | b3 & 63;
		             }
		             function get_utf_8_uchar(b, i){
		              var
		               b0 = caml_bytes_get(b, i),
		               max = caml_ml_bytes_length(b) - 1 | 0;
		              a:
		              {
		               if(224 <= b0){
		                if(237 <= b0){
		                 if(245 <= b0) break a;
		                 switch(b0 - 237 | 0){
		                   case 0:
		                    var i$0 = i + 1 | 0;
		                    if(max < i$0) return utf_decode_invalid(1);
		                    var b1$4 = caml_bytes_unsafe_get(b, i$0);
		                    if(not_in_x80_to_x9F(b1$4)) return utf_decode_invalid(1);
		                    var i$1 = i$0 + 1 | 0;
		                    if(max < i$1) return utf_decode_invalid(2);
		                    var b2$3 = caml_bytes_unsafe_get(b, i$1);
		                    if(not_in_x80_to_xBF(b2$3)) return utf_decode_invalid(2);
		                    var u$0 = utf_8_uchar_3(b0, b1$4, b2$3);
		                    return utf_decode(3, u$0);
		                   case 3:
		                    var i$4 = i + 1 | 0;
		                    if(max < i$4) return utf_decode_invalid(1);
		                    var b1$2 = caml_bytes_unsafe_get(b, i$4);
		                    if(not_in_x90_to_xBF(b1$2)) return utf_decode_invalid(1);
		                    var i$5 = i$4 + 1 | 0;
		                    if(max < i$5) return utf_decode_invalid(2);
		                    var b2$1 = caml_bytes_unsafe_get(b, i$5);
		                    if(not_in_x80_to_xBF(b2$1)) return utf_decode_invalid(2);
		                    var i$6 = i$5 + 1 | 0;
		                    if(max < i$6) return utf_decode_invalid(3);
		                    var b3$1 = caml_bytes_unsafe_get(b, i$6);
		                    if(not_in_x80_to_xBF(b3$1)) return utf_decode_invalid(3);
		                    var u$2 = utf_8_uchar_4(b0, b1$2, b2$1, b3$1);
		                    return utf_decode(4, u$2);
		                   case 7:
		                    var i$10 = i + 1 | 0;
		                    if(max < i$10) return utf_decode_invalid(1);
		                    var b1$0 = caml_bytes_unsafe_get(b, i$10);
		                    if(not_in_x80_to_x8F(b1$0)) return utf_decode_invalid(1);
		                    var i$11 = i$10 + 1 | 0;
		                    if(max < i$11) return utf_decode_invalid(2);
		                    var b2 = caml_bytes_unsafe_get(b, i$11);
		                    if(not_in_x80_to_xBF(b2)) return utf_decode_invalid(2);
		                    var i$12 = i$11 + 1 | 0;
		                    if(max < i$12) return utf_decode_invalid(3);
		                    var b3 = caml_bytes_unsafe_get(b, i$12);
		                    if(not_in_x80_to_xBF(b3)) return utf_decode_invalid(3);
		                    var u$4 = utf_8_uchar_4(b0, b1$0, b2, b3);
		                    return utf_decode(4, u$4);
		                   case 1:
		                   case 2: break;
		                   default:
		                    var i$7 = i + 1 | 0;
		                    if(max < i$7) return utf_decode_invalid(1);
		                    var b1$1 = caml_bytes_unsafe_get(b, i$7);
		                    if(not_in_x80_to_xBF(b1$1)) return utf_decode_invalid(1);
		                    var i$8 = i$7 + 1 | 0;
		                    if(max < i$8) return utf_decode_invalid(2);
		                    var b2$0 = caml_bytes_unsafe_get(b, i$8);
		                    if(not_in_x80_to_xBF(b2$0)) return utf_decode_invalid(2);
		                    var i$9 = i$8 + 1 | 0;
		                    if(max < i$9) return utf_decode_invalid(3);
		                    var b3$0 = caml_bytes_unsafe_get(b, i$9);
		                    if(not_in_x80_to_xBF(b3$0)) return utf_decode_invalid(3);
		                    var u$3 = utf_8_uchar_4(b0, b1$1, b2$0, b3$0);
		                    return utf_decode(4, u$3);
		                 }
		                }
		                else if(225 > b0){
		                 var i$13 = i + 1 | 0;
		                 if(max < i$13) return utf_decode_invalid(1);
		                 var b1$5 = caml_bytes_unsafe_get(b, i$13);
		                 if(not_in_xA0_to_xBF(b1$5)) return utf_decode_invalid(1);
		                 var i$14 = i$13 + 1 | 0;
		                 if(max < i$14) return utf_decode_invalid(2);
		                 var b2$4 = caml_bytes_unsafe_get(b, i$14);
		                 if(not_in_x80_to_xBF(b2$4)) return utf_decode_invalid(2);
		                 var u$5 = utf_8_uchar_3(b0, b1$5, b2$4);
		                 return utf_decode(3, u$5);
		                }
		                var i$2 = i + 1 | 0;
		                if(max < i$2) return utf_decode_invalid(1);
		                var b1$3 = caml_bytes_unsafe_get(b, i$2);
		                if(not_in_x80_to_xBF(b1$3)) return utf_decode_invalid(1);
		                var i$3 = i$2 + 1 | 0;
		                if(max < i$3) return utf_decode_invalid(2);
		                var b2$2 = caml_bytes_unsafe_get(b, i$3);
		                if(not_in_x80_to_xBF(b2$2)) return utf_decode_invalid(2);
		                var u$1 = utf_8_uchar_3(b0, b1$3, b2$2);
		                return utf_decode(3, u$1);
		               }
		               if(128 > b0) return utf_decode(1, b0);
		               if(194 <= b0){
		                var i$15 = i + 1 | 0;
		                if(max < i$15) return utf_decode_invalid(1);
		                var b1 = caml_bytes_unsafe_get(b, i$15);
		                if(not_in_x80_to_xBF(b1)) return utf_decode_invalid(1);
		                var u = (b0 & 31) << 6 | b1 & 63;
		                return utf_decode(2, u);
		               }
		              }
		              return utf_decode_invalid(1);
		             }
		             var b = "bytes.ml", b1 = [0, b, 679, 9], b2 = [0, b, 654, 20];
		             function set_utf_8_uchar(b, i, u, a){
		              function set(c, b, a){caml_bytes_unsafe_set(c, b, a);}
		              var max = caml_ml_bytes_length(b) - 1 | 0;
		              if(0 > u){
		               a = caml_pop_trap();
		               return a
		                       (caml_maybe_attach_backtrace([0, Assert_failure, b2], 1));
		              }
		              if(127 >= u){caml_bytes_set(b, i, u); return a(1);}
		              if(2047 >= u){
		               var last$1 = i + 1 | 0;
		               return max < last$1
		                       ? a(0)
		                       : (caml_bytes_set
		                          (b, i, 192 | u >>> 6 | 0),
		                         set(b, last$1, 128 | u & 63),
		                         a(2));
		              }
		              if(65535 >= u){
		               var last$0 = i + 2 | 0;
		               return max < last$0
		                       ? a(0)
		                       : (caml_bytes_set
		                          (b, i, 224 | u >>> 12 | 0),
		                         set(b, i + 1 | 0, 128 | (u >>> 6 | 0) & 63),
		                         set(b, last$0, 128 | u & 63),
		                         a(3));
		              }
		              if(1114111 < u){
		               a = caml_pop_trap();
		               return a
		                       (caml_maybe_attach_backtrace([0, Assert_failure, b1], 1));
		              }
		              var last = i + 3 | 0;
		              return max < last
		                      ? a(0)
		                      : (caml_bytes_set
		                         (b, i, 240 | u >>> 18 | 0),
		                        set(b, i + 1 | 0, 128 | (u >>> 12 | 0) & 63),
		                        set(b, i + 2 | 0, 128 | (u >>> 6 | 0) & 63),
		                        set(b, last, 128 | u & 63),
		                        a(4));
		             }
		             var
		              cst_index_out_of_bounds = "index out of bounds",
		              b3 = [0, b, 777, 9],
		              b4 = [0, b, 766, 20];
		             function set_utf_16be_uchar(b, i, u, a){
		              var max = caml_ml_bytes_length(b) - 1 | 0;
		              if(0 <= i && max >= i){
		               if(0 > u){
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, b4], 1));
		               }
		               if(65535 >= u){
		                var last$0 = i + 1 | 0;
		                return max < last$0
		                        ? a(0)
		                        : (unsafe_set_uint16_be(b, i, u), a(2));
		               }
		               if(1114111 < u){
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, b3], 1));
		               }
		               var last = i + 3 | 0;
		               if(max < last) return a(0);
		               var
		                u$0 = u - 65536 | 0,
		                hi = 55296 | u$0 >>> 10 | 0,
		                lo = 56320 | u$0 & 1023;
		               unsafe_set_uint16_be(b, i, hi);
		               unsafe_set_uint16_be(b, i + 2 | 0, lo);
		               return a(4);
		              }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, cst_index_out_of_bounds, a);
		             }
		             var b5 = [0, b, 831, 9], b6 = [0, b, 820, 20];
		             function set_utf_16le_uchar(b, i, u, a){
		              var max = caml_ml_bytes_length(b) - 1 | 0;
		              if(0 <= i && max >= i){
		               if(0 > u){
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, b6], 1));
		               }
		               if(65535 >= u){
		                var last$0 = i + 1 | 0;
		                return max < last$0 ? a(0) : (caml_bytes_set16(b, i, u), a(2));
		               }
		               if(1114111 < u){
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, b5], 1));
		               }
		               var last = i + 3 | 0;
		               if(max < last) return a(0);
		               var
		                u$0 = u - 65536 | 0,
		                hi = 55296 | u$0 >>> 10 | 0,
		                lo = 56320 | u$0 & 1023;
		               caml_bytes_set16(b, i, hi);
		               var i$0 = i + 2 | 0;
		               caml_bytes_set16(b, i$0, lo);
		               return a(4);
		              }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, cst_index_out_of_bounds, a);
		             }
		             function make$0(n, c){return caml_string_of_bytes(make(n, c));}
		             function get_sub(s, ofs, len, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (sub,
		                       caml_bytes_of_string(s),
		                       ofs,
		                       len,
		                       function(a){return cont(caml_string_of_bytes(a));});
		             }
		             var cst$1 = "";
		             function concat(sep, l, cont){
		              if(! l) return cont(cst$1);
		              var seplen = caml_ml_string_length(sep);
		              function a(acc, b){
		               if(b){
		                var hd = b[1];
		                if(b[2]){
		                 var
		                  tl = b[2],
		                  x = (caml_ml_string_length(hd) + seplen | 0) + acc | 0;
		                 return acc <= x
		                         ? caml_exact_trampoline_call2(a, x, tl)
		                         : caml_exact_trampoline_cps_call
		                           (invalid_arg,
		                            "String.concat",
		                            function(b){return caml_exact_trampoline_call2(a, b, tl);});
		                }
		                b = caml_ml_string_length(hd) + acc | 0;
		               }
		               else
		                b = acc;
		               var dst = caml_create_bytes(b), pos = 0, b = l;
		               for(;;){
		                if(b){
		                 var hd$0 = b[1];
		                 if(b[2]){
		                  var tl$0 = b[2];
		                  caml_blit_string
		                   (hd$0, 0, dst, pos, caml_ml_string_length(hd$0));
		                  caml_blit_string
		                   (sep, 0, dst, pos + caml_ml_string_length(hd$0) | 0, seplen);
		                  var
		                   pos$0 = (pos + caml_ml_string_length(hd$0) | 0) + seplen | 0;
		                  pos = pos$0;
		                  b = tl$0;
		                  continue;
		                 }
		                 caml_blit_string
		                  (hd$0, 0, dst, pos, caml_ml_string_length(hd$0));
		                }
		                return cont(caml_string_of_bytes(dst));
		               }
		              }
		              return a(0, l);
		             }
		             function is_space$0(a){
		              a = a - 9 | 0;
		              a:
		              {
		               if(4 < a >>> 0){
		                if(23 !== a) break a;
		               }
		               else if(2 === a) break a;
		               return 1;
		              }
		              return 0;
		             }
		             function trim(s, cont){
		              if(s === cst$1) return cont(s);
		              if
		               (!
		                is_space$0(caml_string_unsafe_get(s, 0))
		                &&
		                 !
		                 is_space$0
		                  (caml_string_unsafe_get(s, caml_ml_string_length(s) - 1 | 0)))
		               return cont(s);
		              var
		               s$0 = caml_bytes_of_string(s),
		               len = caml_ml_bytes_length(s$0),
		               i = 0;
		              for(;;){
		               if(i >= len) break;
		               if(! is_space(caml_bytes_unsafe_get(s$0, i))) break;
		               var i$0 = i + 1 | 0;
		               i = i$0;
		              }
		              var j = len - 1 | 0;
		              for(;;){
		               if(i > j) break;
		               if(! is_space(caml_bytes_unsafe_get(s$0, j))) break;
		               var j$0 = j - 1 | 0;
		               j = j$0;
		              }
		              function a(a){return cont(caml_string_of_bytes(a));}
		              return i <= j
		                      ? caml_exact_trampoline_cps_call$0
		                        (sub, s$0, i, (j - i | 0) + 1 | 0, a)
		                      : a(empty_return);
		             }
		             function escaped$0(s$0){
		              var
		               s$1 = caml_bytes_of_string(s$0),
		               d = caml_ml_bytes_length(s$1) - 1 | 0,
		               a = 0;
		              if(d < 0)
		               var n$0 = a;
		              else {
		               var n = a, i$0 = 0;
		               for(;;){
		                a = caml_bytes_unsafe_get(s$1, i$0);
		                a:
		                {
		                 b:
		                 {
		                  c:
		                  {
		                   if(32 <= a){
		                    a = a - 34 | 0;
		                    if(58 < a >>> 0){
		                     if(93 <= a) break c;
		                    }
		                    else if(56 < a - 1 >>> 0) break b;
		                    a = 1;
		                    break a;
		                   }
		                   if(11 <= a){if(13 === a) break b;} else if(8 <= a) break b;
		                  }
		                  a = 4;
		                  break a;
		                 }
		                 a = 2;
		                }
		                a = n + a | 0;
		                var b = i$0 + 1 | 0;
		                if(d === i$0){n$0 = a; break;}
		                n = a;
		                i$0 = b;
		               }
		              }
		              if(n$0 === caml_ml_bytes_length(s$1))
		               b = s$1;
		              else {
		               var
		                s = caml_create_bytes(n$0),
		                b = caml_ml_bytes_length(s$1) - 1 | 0;
		               if(b < 0)
		                b = s;
		               else {
		                var n$1 = 0, i = 0;
		                for(;;){
		                 var c = caml_bytes_unsafe_get(s$1, i);
		                 a:
		                 {
		                  b:
		                  {
		                   c:
		                   {
		                    if(35 <= c){
		                     if(92 !== c){if(127 <= c) break b; break c;}
		                    }
		                    else {
		                     if(32 > c){
		                      if(14 <= c) break b;
		                      switch(c){
		                        case 8:
		                         caml_bytes_unsafe_set(s, n$1, 92);
		                         var n$2 = n$1 + 1 | 0;
		                         caml_bytes_unsafe_set(s, n$2, 98);
		                         var n$10 = n$2;
		                         break a;
		                        case 9:
		                         caml_bytes_unsafe_set(s, n$1, 92);
		                         var n$3 = n$1 + 1 | 0;
		                         caml_bytes_unsafe_set(s, n$3, 116);
		                         n$10 = n$3;
		                         break a;
		                        case 10:
		                         caml_bytes_unsafe_set(s, n$1, 92);
		                         var n$4 = n$1 + 1 | 0;
		                         caml_bytes_unsafe_set(s, n$4, 110);
		                         n$10 = n$4;
		                         break a;
		                        case 13:
		                         caml_bytes_unsafe_set(s, n$1, 92);
		                         var n$5 = n$1 + 1 | 0;
		                         caml_bytes_unsafe_set(s, n$5, 114);
		                         n$10 = n$5;
		                         break a;
		                        default: break b;
		                      }
		                     }
		                     if(34 > c) break c;
		                    }
		                    caml_bytes_unsafe_set(s, n$1, 92);
		                    var n$9 = n$1 + 1 | 0;
		                    caml_bytes_unsafe_set(s, n$9, c);
		                    n$10 = n$9;
		                    break a;
		                   }
		                   caml_bytes_unsafe_set(s, n$1, c);
		                   n$10 = n$1;
		                   break a;
		                  }
		                  caml_bytes_unsafe_set(s, n$1, 92);
		                  var n$6 = n$1 + 1 | 0;
		                  caml_bytes_unsafe_set(s, n$6, 48 + (c / 100 | 0) | 0);
		                  var n$7 = n$6 + 1 | 0;
		                  caml_bytes_unsafe_set
		                   (s, n$7, 48 + ((c / 10 | 0) % 10 | 0) | 0);
		                  var n$8 = n$7 + 1 | 0;
		                  caml_bytes_unsafe_set(s, n$8, 48 + (c % 10 | 0) | 0);
		                  n$10 = n$8;
		                 }
		                 var n$11 = n$10 + 1 | 0, d = i + 1 | 0;
		                 if(b === i){b = s; break;}
		                 n$1 = n$11;
		                 i = d;
		                }
		               }
		              }
		              return caml_string_of_bytes(b);
		             }
		             function index_rec(s, lim, i$1, c){
		              var i = i$1;
		              for(;;){
		               if(lim <= i) throw caml_maybe_attach_backtrace(Not_found, 1);
		               if(caml_string_unsafe_get(s, i) === c) return i;
		               var i$0 = i + 1 | 0;
		               i = i$0;
		              }
		             }
		             function index_from(s, i, c, cont){
		              var l = caml_ml_string_length(s);
		              if(0 <= i && l >= i) return cont(index_rec(s, l, i, c));
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "String.index_from / Bytes.index_from", cont);
		             }
		             function rindex_from(s, i$1, c, a){
		              if(-1 <= i$1 && caml_ml_string_length(s) > i$1){
		               var i = i$1;
		               for(;;){
		                if(0 > i){
		                 a = caml_pop_trap();
		                 var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                 return a(Not_found$0);
		                }
		                if(caml_string_unsafe_get(s, i) === c) return a(i);
		                var i$0 = i - 1 | 0;
		                i = i$0;
		               }
		              }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "String.rindex_from / Bytes.rindex_from", a);
		             }
		             function contains(s, c, a){
		              var l = caml_ml_string_length(s);
		              if(l < 0)
		               return caml_exact_trampoline_cps_call
		                       (invalid_arg,
		                        "String.contains_from / Bytes.contains_from",
		                        a);
		              try{index_rec(s, l, 0, c); var b = 1;}
		              catch(exn$1){
		               var exn = caml_wrap_exception(exn$1);
		               if(exn === Not_found) return a(0);
		               a = caml_pop_trap();
		               var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		               return a(exn$0);
		              }
		              return a(b);
		             }
		             function uppercase_ascii$0(s){
		              var s$0 = caml_bytes_of_string(s);
		              return caml_string_of_bytes(map$1(uppercase_ascii, s$0));
		             }
		             function lowercase_ascii$0(s, cont){
		              var s$0 = caml_bytes_of_string(s);
		              return cont(caml_string_of_bytes(map$1(lowercase_ascii, s$0)));
		             }
		             function capitalize_ascii(s, cont){
		              var s$0 = caml_bytes_of_string(s);
		              return cont(caml_string_of_bytes(apply1(uppercase_ascii, s$0)));
		             }
		             function uncapitalize_ascii(s){
		              var s$0 = caml_bytes_of_string(s);
		              return caml_string_of_bytes(apply1(lowercase_ascii, s$0));
		             }
		             function split_on_char(sep, s, cont){
		              var
		               b = caml_ml_string_length(s),
		               c = caml_ml_string_length(s) - 1 | 0;
		              function e(r, j, i){
		               function a(r, j){
		                var a = i - 1 | 0;
		                return 0 !== i
		                        ? caml_exact_trampoline_call3(e, r, j, a)
		                        : d(r, j);
		               }
		               return caml_string_unsafe_get(s, i) === sep
		                       ? caml_exact_trampoline_cps_call$0
		                         (get_sub,
		                          s,
		                          i + 1 | 0,
		                          (j - i | 0) - 1 | 0,
		                          function(b){return a([0, b, r], i);})
		                       : a(r, j);
		              }
		              function d(r, j){
		               return caml_exact_trampoline_cps_call$0
		                       (get_sub, s, 0, j, function(a){return cont([0, a, r]);});
		              }
		              var a = 0;
		              return c < 0 ? d(a, b) : e(a, b, c);
		             }
		             function compare_decoded(x, y, cont){
		              return cont(caml_string_compare(x, y));
		             }
		             function get_utf_8_uchar$0(s, i){
		              return get_utf_8_uchar(caml_bytes_of_string(s), i);
		             }
		             function get_int32_le(s, i){
		              var b = caml_bytes_of_string(s);
		              return caml_bytes_get32(b, i);
		             }
		             function get_int32_be$0(s, i){
		              return get_int32_be(caml_bytes_of_string(s), i);
		             }
		             function get_int64_le(s, i){
		              var b = caml_bytes_of_string(s);
		              return caml_bytes_get64(b, i);
		             }
		             function equal$0(b, a, cont){return cont(b === a ? 1 : 0);}
		             var cst_Array_init = "Array.init";
		             function init(l, f, cont){
		              return 0 === l
		                      ? cont([0])
		                      : 0
		                        <= l
		                        ? caml_exact_trampoline_cps_call
		                          (f,
		                           0,
		                           function(d){
		                            var res = caml_make_vect(l, d), a = l - 1 | 0;
		                            function c(){return cont(res);}
		                            function b(i){
		                             return caml_exact_trampoline_cps_call
		                                     (f,
		                                      i,
		                                      function(d){
		                                       res[i + 1] = d;
		                                       d = i + 1 | 0;
		                                       return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		                                      });
		                            }
		                            return a < 1 ? c() : b(1);
		                           })
		                        : caml_exact_trampoline_cps_call
		                          (invalid_arg, cst_Array_init, cont);
		             }
		             function copy$0(a, cont){
		              var l = a.length - 1;
		              return 0 === l ? cont([0]) : cont(caml_array_sub(a, 0, l));
		             }
		             function append(a1, a2, cont){
		              var l1 = a1.length - 1;
		              return 0 === l1
		                      ? caml_exact_trampoline_cps_call(copy$0, a2, cont)
		                      : 0
		                        === a2.length - 1
		                        ? cont(caml_array_sub(a1, 0, l1))
		                        : cont(caml_array_append(a1, a2));
		             }
		             function sub$0(a, ofs, len, cont){
		              if(0 <= ofs && 0 <= len && (a.length - 1 - len | 0) >= ofs)
		               return cont(caml_array_sub(a, ofs, len));
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "Array.sub", cont);
		             }
		             function blit$0(a1, ofs1, a2, ofs2, len, cont){
		              if
		               (0 <= len
		                &&
		                 0 <= ofs1
		                 &&
		                  (a1.length - 1 - len | 0) >= ofs1
		                  && 0 <= ofs2 && (a2.length - 1 - len | 0) >= ofs2){
		               caml_array_blit(a1, ofs1, a2, ofs2, len);
		               return cont();
		              }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "Array.blit", cont);
		             }
		             function map$2(f, a){
		              var l = a.length - 1;
		              if(0 === l) return [0];
		              var r = caml_make_vect(l, f(a[1])), b = l - 1 | 0;
		              if(b >= 1){
		               var i = 1;
		               for(;;){
		                r[i + 1] = f(a[i + 1]);
		                var c = i + 1 | 0;
		                if(b === i) break;
		                i = c;
		               }
		              }
		              return r;
		             }
		             function concat_of_array(a){
		              var i$1 = a.length - 2 | 0, i = i$1, res = 0;
		              for(;;){
		               if(0 > i) return res;
		               var res$0 = [0, a[i + 1], res], i$0 = i - 1 | 0;
		               i = i$0;
		               res = res$0;
		              }
		             }
		             function list_length(accu$1, a){
		              var accu = accu$1;
		              for(;;){
		               if(! a) return accu;
		               var t = a[2], accu$0 = accu + 1 | 0;
		               accu = accu$0;
		               a = t;
		              }
		             }
		             function to_array(l, cont){
		              if(! l) return cont([0]);
		              var
		               tl = l[2],
		               hd = l[1],
		               a = caml_make_vect(list_length(0, l), hd),
		               i = 1,
		               param = tl;
		              for(;;){
		               if(! param) return cont(a);
		               var tl$0 = param[2], hd$0 = param[1];
		               a[i + 1] = hd$0;
		               var i$0 = i + 1 | 0;
		               i = i$0;
		               param = tl$0;
		              }
		             }
		             function fold_left$0(f, x, a, cont){
		              var b = a.length - 2 | 0;
		              function d(r){return cont(r);}
		              function c(r, i){
		               return caml_trampoline_cps_call3
		                       (f,
		                        r,
		                        a[i + 1],
		                        function(a){
		                         var e = i + 1 | 0;
		                         return b !== i ? caml_exact_trampoline_call2(c, a, e) : d(a);
		                        });
		              }
		              return b < 0 ? d(x) : c(x, 0);
		             }
		             function is_integer(x){
		              var a = x === caml_trunc_float(x) ? 1 : 0;
		              return a ? x - x === 0. ? 1 : 0 : a;
		             }
		             function pred(n){return n - 1 | 0;}
		             function bit_not(n){return n ^ -1;}
		             var cst_d = "%d";
		             function int32_to_string(n, cont){
		              return cont(caml_format_int(cst_d, n));
		             }
		             function compare(x, y, cont){
		              return cont(caml_int_compare(x, y));
		             }
		             var s = caml_int64_create_lo_mi_hi(1, 0, 0);
		             function pred$0(n){return caml_int64_sub(n, s);}
		             var b7 = caml_int64_create_lo_mi_hi(0, 0, 0);
		             function abs(n){
		              return caml_greaterequal(n, b7) ? n : caml_int64_neg(n);
		             }
		             var bm = caml_int64_create_lo_mi_hi(16777215, 16777215, 65535);
		             function bit_not$0(n){return caml_int64_xor(n, bm);}
		             function int64_to_string(n, cont){
		              return cont(caml_int64_format(cst_d, n));
		             }
		             function of_string_opt(s){
		              try{var a = [0, caml_int64_of_string(s)]; return a;}
		              catch(exn$0){
		               var exn = caml_wrap_exception(exn$0);
		               if(exn[1] === Failure) return 0;
		               throw caml_maybe_attach_backtrace(exn, 0);
		              }
		             }
		             function compare$0(x, y, cont){
		              return cont(caml_int64_compare(x, y));
		             }
		             function pred$1(n){return n - 1 | 0;}
		             function bit_not$1(n){return n ^ -1;}
		             function nativeint_to_string(n, cont){
		              return cont(caml_format_int(cst_d, n));
		             }
		             var dummy_pos = [0, cst$1, 0, 0, -1];
		             function engine(tbl, state, buf){
		              var
		               result = caml_lex_engine(tbl, state, buf),
		               a = 0 <= result,
		               a = a ? buf[12] !== dummy_pos : a;
		              if(a){
		               buf[11] = buf[12];
		               a = buf[12];
		               buf[12] = [0, a[1], a[2], a[3], buf[4] + buf[6] | 0];
		              }
		              return result;
		             }
		             var zero_pos = [0, cst$1, 1, 0, 0];
		             function from_string(opt, s, cont){
		              var
		               with_positions = opt ? opt[1] : 1,
		               a = with_positions ? zero_pos : dummy_pos,
		               b = with_positions ? zero_pos : dummy_pos,
		               d = caml_ml_string_length(s),
		               c = [0];
		              return caml_exact_trampoline_cps_call
		                      (of_string,
		                       s,
		                       function(e){
		                        return cont
		                                ([0,
		                                  function(lexbuf, cont){lexbuf[9] = 1; return cont(0);},
		                                  e,
		                                  d,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  1,
		                                  c,
		                                  b,
		                                  a]);
		                       });
		             }
		             function lexeme(lexbuf, cont){
		              var len = lexbuf[6] - lexbuf[5] | 0;
		              return caml_exact_trampoline_cps_call$0
		                      (sub_string, lexbuf[2], lexbuf[5], len, cont);
		             }
		             function sub_lexeme_char(lexbuf, i){
		              return caml_bytes_get(lexbuf[2], i);
		             }
		             function lexeme_char(lexbuf, i){
		              return caml_bytes_get(lexbuf[2], lexbuf[5] + i | 0);
		             }
		             var
		              Parse_error =
		                [248, "Stdlib.Parsing.Parse_error", caml_fresh_oo_id()],
		              b8 = [0, 0, 0, 0];
		             function u(Ord){
		              function height(param){
		               if(! param) return 0;
		               var h = param[4];
		               return h;
		              }
		              function create(l, v, r){
		               if(l) var h = l[4], hl = h; else hl = 0;
		               if(r) var h$0 = r[4], hr = h$0; else hr = 0;
		               var a = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
		               return [0, l, v, r, a];
		              }
		              function bal(l, v, r, cont){
		               if(l) var h = l[4], hl = h; else hl = 0;
		               if(r) var h$0 = r[4], hr = h$0; else hr = 0;
		               var a = "Set.bal";
		               if((hr + 2 | 0) < hl){
		                if(! l)
		                 return caml_exact_trampoline_cps_call(invalid_arg, a, cont);
		                var lr = l[3], lv = l[2], ll = l[1], b = height(lr);
		                if(b <= height(ll))
		                 return cont(create(ll, lv, create(lr, v, r)));
		                if(! lr)
		                 return caml_exact_trampoline_cps_call(invalid_arg, a, cont);
		                var
		                 lrr = lr[3],
		                 lrv = lr[2],
		                 lrl = lr[1],
		                 a = create(lrr, v, r);
		                return cont(create(create(ll, lv, lrl), lrv, a));
		               }
		               if((hl + 2 | 0) >= hr){
		                a = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
		                return cont([0, l, v, r, a]);
		               }
		               if(! r)
		                return caml_exact_trampoline_cps_call(invalid_arg, a, cont);
		               var rr = r[3], rv = r[2], rl = r[1], b = height(rl);
		               if(b <= height(rr))
		                return cont(create(create(l, v, rl), rv, rr));
		               if(! rl)
		                return caml_exact_trampoline_cps_call(invalid_arg, a, cont);
		               var
		                rlr = rl[3],
		                rlv = rl[2],
		                rll = rl[1],
		                a = create(rlr, rv, rr);
		               return cont(create(create(l, v, rll), rlv, a));
		              }
		              function add(x, t, cont){
		               if(! t) return cont([0, 0, x, 0, 1]);
		               var r = t[3], v = t[2], l = t[1];
		               return caml_exact_trampoline_cps_call$1
		                       (Ord[1],
		                        x,
		                        v,
		                        function(c){
		                         return 0 === c
		                                 ? cont(t)
		                                 : 0
		                                   <= c
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (add,
		                                      x,
		                                      r,
		                                      function(rr){
		                                       return r === rr
		       ? cont(t)
		       : caml_exact_trampoline_cps_call$0(bal, l, v, rr, cont);
		                                      })
		                                   : caml_exact_trampoline_cps_call$1
		                                     (add,
		                                      x,
		                                      l,
		                                      function(ll){
		                                       return l === ll
		       ? cont(t)
		       : caml_exact_trampoline_cps_call$0(bal, ll, v, r, cont);
		                                      });
		                        });
		              }
		              function singleton(x){return [0, 0, x, 0, 1];}
		              function add_min_element(x, param, cont){
		               if(! param) return cont(singleton(x));
		               var r = param[3], v = param[2], l = param[1];
		               return caml_exact_trampoline_cps_call$1
		                       (add_min_element,
		                        x,
		                        l,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$0(bal, a, v, r, cont);
		                        });
		              }
		              function add_max_element(x, param, cont){
		               if(! param) return cont(singleton(x));
		               var r = param[3], v = param[2], l = param[1];
		               return caml_exact_trampoline_cps_call$1
		                       (add_max_element,
		                        x,
		                        r,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$0(bal, l, v, a, cont);
		                        });
		              }
		              function join(l, v, r, cont){
		               if(! l)
		                return caml_exact_trampoline_cps_call$1
		                        (add_min_element, v, r, cont);
		               if(! r)
		                return caml_exact_trampoline_cps_call$1
		                        (add_max_element, v, l, cont);
		               var
		                rh = r[4],
		                rr = r[3],
		                rv = r[2],
		                rl = r[1],
		                lh = l[4],
		                lr = l[3],
		                lv = l[2],
		                ll = l[1];
		               return (rh + 2 | 0) < lh
		                       ? caml_exact_trampoline_cps_call$0
		                         (join,
		                          lr,
		                          v,
		                          r,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (bal, ll, lv, a, cont);
		                          })
		                       : (lh
		                         + 2
		                         | 0)
		                         < rh
		                         ? caml_exact_trampoline_cps_call$0
		                           (join,
		                            l,
		                            v,
		                            rl,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (bal, a, rv, rr, cont);
		                            })
		                         : cont(create(l, v, r));
		              }
		              function split(x, param, cont){
		               if(! param) return cont(b8);
		               var r = param[3], v = param[2], l = param[1];
		               return caml_exact_trampoline_cps_call$1
		                       (Ord[1],
		                        x,
		                        v,
		                        function(c){
		                         return 0 === c
		                                 ? cont([0, l, , r])
		                                 : 0
		                                   <= c
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (split,
		                                      x,
		                                      r,
		                                      function(match){
		                                       var rr = match[3], lr = match[1];
		                                       return caml_exact_trampoline_cps_call$0
		       (join, l, v, lr, function(a){return cont([0, a, , rr]);});
		                                      })
		                                   : caml_exact_trampoline_cps_call$1
		                                     (split,
		                                      x,
		                                      l,
		                                      function(match){
		                                       var rl = match[3], ll = match[1];
		                                       return caml_exact_trampoline_cps_call$0
		       (join, rl, v, r, function(a){return cont([0, ll, , a]);});
		                                      });
		                        });
		              }
		              function mem(x, param, cont){
		               function a(param){
		                if(! param) return cont(0);
		                var r = param[3], v = param[2], l = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (Ord[1],
		                         x,
		                         v,
		                         function(c){
		                          var b = 0 === c ? 1 : 0;
		                          return b
		                                  ? cont(b)
		                                  : 0
		                                    <= c
		                                    ? caml_exact_trampoline_call1(a, r)
		                                    : caml_exact_trampoline_call1(a, l);
		                         });
		               }
		               return a(param);
		              }
		              function union(s1, s2, cont){
		               if(! s1) return cont(s2);
		               if(! s2) return cont(s1);
		               var
		                h2 = s2[4],
		                r2 = s2[3],
		                v2 = s2[2],
		                l2 = s2[1],
		                h1 = s1[4],
		                r1 = s1[3],
		                v1 = s1[2],
		                l1 = s1[1];
		               return h2 <= h1
		                       ? 1
		                         === h2
		                         ? caml_exact_trampoline_cps_call$1(add, v2, s1, cont)
		                         : caml_exact_trampoline_cps_call$1
		                           (split,
		                            v1,
		                            s2,
		                            function(match){
		                             var r2 = match[3], l2 = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (union,
		                                      r1,
		                                      r2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (union,
		        l1,
		        l2,
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (join, b, v1, a, cont);
		        });
		                                      });
		                            })
		                       : 1
		                         === h1
		                         ? caml_exact_trampoline_cps_call$1(add, v1, s2, cont)
		                         : caml_exact_trampoline_cps_call$1
		                           (split,
		                            v2,
		                            s1,
		                            function(match){
		                             var r1 = match[3], l1 = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (union,
		                                      r1,
		                                      r2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (union,
		        l1,
		        l2,
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (join, b, v2, a, cont);
		        });
		                                      });
		                            });
		              }
		              function cons_enum(s$0, e$1){
		               var s = s$0, e = e$1;
		               for(;;){
		                if(! s) return e;
		                var r = s[3], v = s[2], l = s[1], e$0 = [0, v, r, e];
		                s = l;
		                e = e$0;
		               }
		              }
		              function compare(s1, s2, cont){
		               var e2 = cons_enum(s2, 0), e1 = cons_enum(s1, 0);
		               function a(e1, e2){
		                if(! e1) return e2 ? cont(-1) : cont(0);
		                if(! e2) return cont(1);
		                var
		                 e2$0 = e2[3],
		                 r2 = e2[2],
		                 v2 = e2[1],
		                 e1$0 = e1[3],
		                 r1 = e1[2],
		                 v1 = e1[1];
		                return caml_exact_trampoline_cps_call$1
		                        (Ord[1],
		                         v1,
		                         v2,
		                         function(c){
		                          if(0 !== c) return cont(c);
		                          var e2 = cons_enum(r2, e2$0), e1 = cons_enum(r1, e1$0);
		                          return caml_exact_trampoline_call2(a, e1, e2);
		                         });
		               }
		               return a(e1, e2);
		              }
		              function equal(s1, s2, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (compare,
		                        s1,
		                        s2,
		                        function(a){return cont(0 === a ? 1 : 0);});
		              }
		              function add_seq(seq, acc, cont){
		               function a(acc, seq){
		                return caml_exact_trampoline_cps_call
		                        (seq,
		                         dummy,
		                         function(match){
		                          if(! match) return cont(acc);
		                          var next = match[2], x = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (add,
		                                   x,
		                                   acc,
		                                   function(acc){
		                                    return caml_exact_trampoline_call2(a, acc, next);
		                                   });
		                         });
		               }
		               return a(acc, seq);
		              }
		              var empty = 0;
		              function of_seq(i, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (add_seq, i, empty, cont);
		              }
		              function seq_of_enum(c, param){
		               if(! c) return 0;
		               var rest = c[3], t = c[2], x = c[1], a = cons_enum(t, rest);
		               return [0, x, function(b){return seq_of_enum(a);}];
		              }
		              function to_seq(c){
		               var a = cons_enum(c, 0);
		               return function(b){return seq_of_enum(a);};
		              }
		              return [0,
		                      empty,
		                      add,
		                      ,
		                      ,
		                      union,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      mem,
		                      equal,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      to_seq,
		                      ,
		                      ,
		                      of_seq];
		             }
		             var cst_Map_bal = "Map.bal";
		             function k(Ord){
		              function height(param){
		               if(! param) return 0;
		               var h = param[5];
		               return h;
		              }
		              function create(l, x, d, r){
		               var
		                hl = height(l),
		                hr = height(r),
		                a = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
		               return [0, l, x, d, r, a];
		              }
		              function bal(l, x, d, r, cont){
		               if(l) var h = l[5], hl = h; else hl = 0;
		               if(r) var h$0 = r[5], hr = h$0; else hr = 0;
		               if((hr + 2 | 0) < hl){
		                if(! l)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_Map_bal, cont);
		                var
		                 lr = l[4],
		                 ld = l[3],
		                 lv = l[2],
		                 ll = l[1],
		                 a = height(lr);
		                if(a <= height(ll))
		                 return cont(create(ll, lv, ld, create(lr, x, d, r)));
		                if(! lr)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_Map_bal, cont);
		                var
		                 lrr = lr[4],
		                 lrd = lr[3],
		                 lrv = lr[2],
		                 lrl = lr[1],
		                 a = create(lrr, x, d, r);
		                return cont(create(create(ll, lv, ld, lrl), lrv, lrd, a));
		               }
		               if((hl + 2 | 0) >= hr){
		                a = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
		                return cont([0, l, x, d, r, a]);
		               }
		               if(! r)
		                return caml_exact_trampoline_cps_call
		                        (invalid_arg, cst_Map_bal, cont);
		               var rr = r[4], rd = r[3], rv = r[2], rl = r[1], a = height(rl);
		               if(a <= height(rr))
		                return cont(create(create(l, x, d, rl), rv, rd, rr));
		               if(! rl)
		                return caml_exact_trampoline_cps_call
		                        (invalid_arg, cst_Map_bal, cont);
		               var
		                rlr = rl[4],
		                rld = rl[3],
		                rlv = rl[2],
		                rll = rl[1],
		                a = create(rlr, rv, rd, rr);
		               return cont(create(create(l, x, d, rll), rlv, rld, a));
		              }
		              function add(x, data, m, cont){
		               if(! m) return cont([0, 0, x, data, 0, 1]);
		               var h = m[5], r = m[4], d = m[3], v = m[2], l = m[1];
		               return caml_exact_trampoline_cps_call$1
		                       (Ord[1],
		                        x,
		                        v,
		                        function(c){
		                         return 0 === c
		                                 ? d === data ? cont(m) : cont([0, l, x, data, r, h])
		                                 : 0
		                                   <= c
		                                   ? caml_exact_trampoline_cps_call$0
		                                     (add,
		                                      x,
		                                      data,
		                                      r,
		                                      function(rr){
		                                       return r === rr
		       ? cont(m)
		       : caml_exact_trampoline_cps_call$2(bal, l, v, d, rr, cont);
		                                      })
		                                   : caml_exact_trampoline_cps_call$0
		                                     (add,
		                                      x,
		                                      data,
		                                      l,
		                                      function(ll){
		                                       return l === ll
		       ? cont(m)
		       : caml_exact_trampoline_cps_call$2(bal, ll, v, d, r, cont);
		                                      });
		                        });
		              }
		              function find(x, param, cont){
		               function a(b){
		                if(b){
		                 var r = b[4], d = b[3], v = b[2], l = b[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (Ord[1],
		                          x,
		                          v,
		                          function(c){
		                           return 0 === c
		                                   ? cont(d)
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_call1(a, r)
		                                     : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                b = caml_pop_trap();
		                var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                return b(Not_found$0);
		               }
		               return a(param);
		              }
		              function find_opt(x, param, cont){
		               function a(param){
		                if(! param) return cont(0);
		                var r = param[4], d = param[3], v = param[2], l = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (Ord[1],
		                         x,
		                         v,
		                         function(c){
		                          return 0 === c
		                                  ? cont([0, d])
		                                  : 0
		                                    <= c
		                                    ? caml_exact_trampoline_call1(a, r)
		                                    : caml_exact_trampoline_call1(a, l);
		                         });
		               }
		               return a(param);
		              }
		              function cons_enum(m$0, e$1){
		               var m = m$0, e = e$1;
		               for(;;){
		                if(! m) return e;
		                var
		                 r = m[4],
		                 d = m[3],
		                 v = m[2],
		                 l = m[1],
		                 e$0 = [0, v, d, r, e];
		                m = l;
		                e = e$0;
		               }
		              }
		              function seq_of_enum(c, param){
		               if(! c) return 0;
		               var
		                rest = c[4],
		                t = c[3],
		                v = c[2],
		                k = c[1],
		                a = cons_enum(t, rest);
		               return [0,
		                       [0, k, v],
		                       function(b, cont){return cont(seq_of_enum(a));}];
		              }
		              function to_seq(m){
		               var a = cons_enum(m, 0);
		               return function(b, cont){return cont(seq_of_enum(a));};
		              }
		              return [0,
		                      0,
		                      add,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      find,
		                      find_opt,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      to_seq];
		             }
		             var Empty = [248, "Stdlib.Stack.Empty", caml_fresh_oo_id()];
		             function create(param){return [0, 0, 0];}
		             function clear(s){s[1] = 0; s[2] = 0;}
		             function push(x, s){
		              s[1] = [0, x, s[1]];
		              s[2] = s[2] + 1 | 0;
		              return 0;
		             }
		             function pop_opt(s){
		              var match = s[1];
		              if(! match) return 0;
		              var tl = match[2], hd = match[1];
		              s[1] = tl;
		              s[2] = s[2] - 1 | 0;
		              return [0, hd];
		             }
		             function top_opt(s){
		              var match = s[1];
		              if(! match) return 0;
		              var hd = match[1];
		              return [0, hd];
		             }
		             var Empty$0 = [248, "Stdlib.Queue.Empty", caml_fresh_oo_id()];
		             function create$0(param){return [0, 0, 0, 0];}
		             function clear$0(q){q[1] = 0; q[2] = 0; q[3] = 0;}
		             function add(x, q){
		              var cell = [0, x, 0], match = q[3];
		              return match
		                      ? (q[1] = q[1] + 1 | 0, match[2] = cell, q[3] = cell, 0)
		                      : (q[1] = 1, q[2] = cell, q[3] = cell, 0);
		             }
		             function take(q){
		              var match = q[2];
		              if(! match) throw caml_maybe_attach_backtrace(Empty$0, 1);
		              var content = match[1];
		              if(match[2]){
		               var next = match[2];
		               q[1] = q[1] - 1 | 0;
		               q[2] = next;
		               return content;
		              }
		              clear$0(q);
		              return content;
		             }
		             function create$1(n){
		              var
		               n$0 = 1 <= n ? n : 1,
		               n$1 = max_string_length < n$0 ? max_string_length : n$0,
		               s = caml_create_bytes(n$1);
		              return [0, [0, s, n$1], 0, s];
		             }
		             function contents(b, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (sub_string, b[1][1], 0, b[2], cont);
		             }
		             function caml_buffer_blit(src, srcoff, dst, dstoff, len, cont){
		              if
		               (0 <= len
		                &&
		                 0 <= srcoff
		                 &&
		                  (src[2] - len | 0) >= srcoff
		                  &&
		                   0 <= dstoff
		                   && (caml_ml_bytes_length(dst) - len | 0) >= dstoff)
		               return caml_exact_trampoline_cps_call$3
		                       (blit, src[1][1], srcoff, dst, dstoff, len, cont);
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "Buffer.blit", cont);
		             }
		             function clear$1(b){b[2] = 0; return 0;}
		             function reset(b){
		              b[2] = 0;
		              var inner = [0, b[3], caml_ml_bytes_length(b[3])];
		              b[1] = inner;
		             }
		             function resize(b, more, cont){
		              var old_pos = b[2], old_len = b[1][2], new_len = old_len;
		              for(;;){
		               if(new_len >= (old_pos + more | 0)) break;
		               new_len = 2 * new_len | 0;
		              }
		              function a(new_len){
		               var new_buffer = caml_create_bytes(new_len);
		               return caml_exact_trampoline_cps_call$3
		                       (blit,
		                        b[1][1],
		                        0,
		                        new_buffer,
		                        0,
		                        b[2],
		                        function(a){b[1] = [0, new_buffer, new_len]; return cont();});
		              }
		              return max_string_length < new_len
		                      ? (old_pos
		                        + more
		                        | 0)
		                        <= max_string_length
		                        ? a(max_string_length)
		                        : caml_exact_trampoline_cps_call
		                          (failwith,
		                           "Buffer.add: cannot grow buffer",
		                           function(b){return a(new_len);})
		                      : a(new_len);
		             }
		             function add_char(b, c, cont){
		              var
		               pos = b[2],
		               match = b[1],
		               length = match[2],
		               buffer = match[1];
		              function a(){b[2] = pos + 1 | 0; return cont();}
		              return length <= pos
		                      ? caml_exact_trampoline_cps_call$1
		                        (resize,
		                         b,
		                         1,
		                         function(d){caml_bytes_set(b[1][1], b[2], c); return a();})
		                      : (caml_bytes_unsafe_set(buffer, pos, c), a());
		             }
		             function add_utf_8_uchar(b, u, cont){
		              function a(d){
		               var pos = b[2], uchar_utf_8_byte_length_max = 4;
		               function c(c){
		                return caml_exact_trampoline_cps_call$0
		                        (set_utf_8_uchar,
		                         b[1][1],
		                         pos,
		                         u,
		                         function(n){
		                          return 0 === n
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (resize, b, uchar_utf_8_byte_length_max, a)
		                                  : (b[2] = pos + n | 0, cont());
		                         });
		               }
		               return b[1][2] <= pos
		                       ? caml_exact_trampoline_cps_call$1
		                         (resize, b, uchar_utf_8_byte_length_max, c)
		                       : c();
		              }
		              return a();
		             }
		             function add_substring(b, s, offset, len, cont){
		              var a = offset < 0;
		              if(a)
		               ;
		              else {
		               a = len < 0;
		               a ||= (caml_ml_string_length(s) - len | 0) < offset;
		              }
		              function c(a){
		               var
		                position = b[2],
		                a = b[1],
		                length = a[2],
		                buffer = a[1],
		                new_position = position + len | 0;
		               function c(a){b[2] = new_position; return cont(0);}
		               return length < new_position
		                       ? caml_exact_trampoline_cps_call$1
		                         (resize,
		                          b,
		                          len,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$3
		                                   (blit_string, s, offset, b[1][1], b[2], len, c);
		                          })
		                       : (caml_blit_string(s, offset, buffer, position, len), c());
		              }
		              return a
		                      ? caml_exact_trampoline_cps_call
		                        (invalid_arg, "Buffer.add_substring/add_subbytes", c)
		                      : c(0);
		             }
		             function write_stringlit(b, s, cont){
		              var
		               len = caml_ml_string_length(s),
		               position = b[2],
		               match = b[1],
		               length = match[2],
		               buffer = match[1],
		               new_position = position + len | 0;
		              function a(a){b[2] = new_position; return cont();}
		              return length < new_position
		                      ? caml_exact_trampoline_cps_call$1
		                        (resize,
		                         b,
		                         len,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$3
		                                  (blit_string, s, 0, b[1][1], b[2], len, a);
		                         })
		                      : (caml_blit_string(s, 0, buffer, position, len), a());
		             }
		             var none = [0, 0], st = caml_make_vect(8, none);
		             caml_domain_dls_set(st);
		             var key_counter = [0, 0], parent_keys = [0, 0];
		             function new_key(split_from_parent, init_orphan){
		              var
		               idx = caml_atomic_fetch_add(key_counter, 1),
		               k = [0, idx, init_orphan];
		              if(split_from_parent){
		               var split = split_from_parent[1], ki = [0, k, split];
		               for(;;){
		                var l = caml_atomic_load(parent_keys);
		                if(! (1 - caml_atomic_cas(parent_keys, l, [0, ki, l]))) break;
		               }
		              }
		              return k;
		             }
		             function maybe_grow(idx, cont){
		              function a(){
		               var st = caml_domain_dls_get(), sz = st.length - 1;
		               if(idx < sz) return cont(st);
		               var new_sz = sz;
		               for(;;){
		                if(idx < new_sz) break;
		                var s = 2 * new_sz | 0;
		                new_sz = s;
		               }
		               var new_st = caml_make_vect(new_sz, none);
		               return caml_exact_trampoline_cps_call$3
		                       (blit$0,
		                        st,
		                        0,
		                        new_st,
		                        0,
		                        sz,
		                        function(b){
		                         return caml_domain_dls_compare_and_set(st, new_st)
		                                 ? cont(new_st)
		                                 : caml_exact_trampoline_call0(a);
		                        });
		              }
		              return a();
		             }
		             function set$0(param, x, cont){
		              var idx = param[1];
		              return caml_exact_trampoline_cps_call
		                      (maybe_grow,
		                       idx,
		                       function(st){
		                        caml_check_bound(st, idx)[idx + 1] = x;
		                        return cont();
		                       });
		             }
		             var b9 = [0, "domain.ml", 184, 13];
		             function get$0(param, cont){
		              var init = param[2], idx = param[1];
		              return caml_exact_trampoline_cps_call
		                      (maybe_grow,
		                       idx,
		                       function(st){
		                        var oldval = caml_check_bound(st, idx)[idx + 1];
		                        return oldval !== none
		                                ? cont(oldval)
		                                : caml_trampoline_cps_call2
		                                  (init,
		                                   0,
		                                   function(new_obj){
		                                    var
		                                     st = caml_domain_dls_get(),
		                                     curval = caml_check_bound(st, idx)[idx + 1],
		                                     a = curval === oldval ? (st[idx + 1] = new_obj, 1) : 0;
		                                    if(a) return cont(new_obj);
		                                    var updated_obj = caml_check_bound(st, idx)[idx + 1];
		                                    if(updated_obj !== none) return cont(updated_obj);
		                                    a = caml_pop_trap();
		                                    return a
		    (caml_maybe_attach_backtrace([0, Assert_failure, b9], 1));
		                                   });
		                       });
		             }
		             var
		              at_exit_key =
		                new_key
		                 (0,
		                  function(param, cont){
		                   return cont(function(param, cont){return cont(0);});
		                  });
		             function at_exit$0(f, cont){
		              return caml_exact_trampoline_cps_call
		                      (get$0,
		                       at_exit_key,
		                       function(old_exit){
		                        function new_exit(param, cont){
		                         return caml_exact_trampoline_cps_call
		                                 (f,
		                                  dummy,
		                                  function(a){
		                                   return caml_trampoline_cps_call2(old_exit, 0, cont);
		                                  });
		                        }
		                        return caml_exact_trampoline_cps_call$1
		                                (set$0, at_exit_key, new_exit, cont);
		                       });
		             }
		             function do_at_exit$0(param, cont){
		              return caml_exact_trampoline_cps_call
		                      (get$0,
		                       at_exit_key,
		                       function(f){return caml_trampoline_cps_call2(f, 0, cont);});
		             }
		             do_domain_local_at_exit[1] = do_at_exit$0;
		             function create_char_set(param){return make(32, 0);}
		             function add_in_char_set(char_set, c, cont){
		              var str_ind = c >>> 3 | 0, mask = 1 << (c & 7);
		              return caml_exact_trampoline_cps_call
		                      (char_of_int,
		                       caml_bytes_get(char_set, str_ind) | mask,
		                       function(a){
		                        caml_bytes_set(char_set, str_ind, a);
		                        return cont();
		                       });
		             }
		             function pad_of_pad_opt(pad_opt){
		              if(! pad_opt) return 0;
		              var width = pad_opt[1];
		              return [0, 1, width];
		             }
		             function default_float_precision(fconv){return 5 === fconv[2] ? 12 : -6;
		             }
		             function buffer_create(init_size){
		              return [0, 0, caml_create_bytes(init_size)];
		             }
		             function buffer_check_size(buf, overhead, cont){
		              var
		               len = caml_ml_bytes_length(buf[2]),
		               min_len = buf[1] + overhead | 0;
		              function a(){return cont();}
		              if(len >= min_len) return a();
		              var
		               new_len = max$0(len * 2 | 0, min_len),
		               new_str = caml_create_bytes(new_len);
		              return caml_exact_trampoline_cps_call$3
		                      (blit,
		                       buf[2],
		                       0,
		                       new_str,
		                       0,
		                       len,
		                       function(b){buf[2] = new_str; return a();});
		             }
		             function buffer_add_char(buf, c, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (buffer_check_size,
		                       buf,
		                       1,
		                       function(a){
		                        caml_bytes_set(buf[2], buf[1], c);
		                        buf[1] = buf[1] + 1 | 0;
		                        return cont();
		                       });
		             }
		             function buffer_add_string(buf, s, cont){
		              var str_len = caml_ml_string_length(s);
		              return caml_exact_trampoline_cps_call$1
		                      (buffer_check_size,
		                       buf,
		                       str_len,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$3
		                                (blit_string,
		                                 s,
		                                 0,
		                                 buf[2],
		                                 buf[1],
		                                 str_len,
		                                 function(a){buf[1] = buf[1] + str_len | 0; return cont();});
		                       });
		             }
		             function buffer_contents(buf, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (sub_string, buf[2], 0, buf[1], cont);
		             }
		             function char_of_iconv(iconv){
		              switch(iconv){
		                case 6:
		                case 7:
		                 return 120;
		                case 8:
		                case 9:
		                 return 88;
		                case 10:
		                case 11:
		                 return 111;
		                case 12:
		                case 15:
		                 return 117;
		                case 0:
		                case 1:
		                case 2:
		                case 13:
		                 return 100;
		                default: return 105;
		              }
		             }
		             var cst$6 = "@]";
		             function string_of_formatting_lit(formatting_lit){
		              if(typeof formatting_lit === "number")
		               switch(formatting_lit){
		                 case 0:
		                  return cst$6;
		                 case 1:
		                  return "@}";
		                 case 2:
		                  return "@?";
		                 case 3:
		                  return "@\n";
		                 case 4:
		                  return "@.";
		                 case 5:
		                  return "@@";
		                 default: return "@%";
		               }
		              if(2 === formatting_lit[0]){
		               var c = formatting_lit[1], s2 = make$0(1, c);
		               return "@" + s2;
		              }
		              var str = formatting_lit[1];
		              return str;
		             }
		             var
		              cst_B = "%B",
		              cst_Li = "%Li",
		              cst_a = "%a",
		              cst_c = "%c",
		              cst_i = "%i",
		              cst_li = "%li",
		              cst_ni = "%ni",
		              cst_s = "%s";
		             function bprint_fmtty(buf, fmtty, cont){
		              function a(fmtty){
		               if(typeof fmtty === "number") return cont();
		               switch(fmtty[0]){
		                 case 0:
		                  var fmtty$0 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_c,
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$0);});
		                 case 1:
		                  var fmtty$1 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_s,
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$1);});
		                 case 2:
		                  var fmtty$2 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_i,
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$2);});
		                 case 3:
		                  var fmtty$3 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_li,
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$3);});
		                 case 4:
		                  var fmtty$4 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_ni,
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$4);});
		                 case 5:
		                  var fmtty$5 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_Li,
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$5);});
		                 case 6:
		                  var fmtty$6 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           "%f",
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$6);});
		                 case 7:
		                  var fmtty$7 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_B,
		                           function(b){return caml_exact_trampoline_call1(a, fmtty$7);});
		                 case 8:
		                  var fmtty$8 = fmtty[2], sub_fmtty = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           "%{",
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (bprint_fmtty,
		                                     buf,
		                                     sub_fmtty,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (buffer_add_string,
		       buf,
		       "%}",
		       function(b){return caml_exact_trampoline_call1(a, fmtty$8);});
		                                     });
		                           });
		                 case 9:
		                  var fmtty$9 = fmtty[3], sub_fmtty$0 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           "%(",
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (bprint_fmtty,
		                                     buf,
		                                     sub_fmtty$0,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (buffer_add_string,
		       buf,
		       "%)",
		       function(b){return caml_exact_trampoline_call1(a, fmtty$9);});
		                                     });
		                           });
		                 case 10:
		                  var fmtty$10 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           cst_a,
		                           function(b){
		                            return caml_exact_trampoline_call1(a, fmtty$10);
		                           });
		                 case 11:
		                  var fmtty$11 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           "%t",
		                           function(b){
		                            return caml_exact_trampoline_call1(a, fmtty$11);
		                           });
		                 case 12:
		                  var fmtty$12 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           "%?",
		                           function(b){
		                            return caml_exact_trampoline_call1(a, fmtty$12);
		                           });
		                 case 13:
		                  var fmtty$13 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           "%r",
		                           function(b){
		                            return caml_exact_trampoline_call1(a, fmtty$13);
		                           });
		                 default:
		                  var fmtty$14 = fmtty[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (buffer_add_string,
		                           buf,
		                           "%_r",
		                           function(b){
		                            return caml_exact_trampoline_call1(a, fmtty$14);
		                           });
		               }
		              }
		              return a(fmtty);
		             }
		             function symm(param){
		              if(typeof param === "number") return 0;
		              switch(param[0]){
		                case 0:
		                 var rest = param[1]; return [0, symm(rest)];
		                case 1:
		                 var rest$0 = param[1]; return [1, symm(rest$0)];
		                case 2:
		                 var rest$1 = param[1]; return [2, symm(rest$1)];
		                case 3:
		                 var rest$2 = param[1]; return [3, symm(rest$2)];
		                case 4:
		                 var rest$3 = param[1]; return [4, symm(rest$3)];
		                case 5:
		                 var rest$4 = param[1]; return [5, symm(rest$4)];
		                case 6:
		                 var rest$5 = param[1]; return [6, symm(rest$5)];
		                case 7:
		                 var rest$6 = param[1]; return [7, symm(rest$6)];
		                case 8:
		                 var rest$7 = param[2], ty = param[1];
		                 return [8, ty, symm(rest$7)];
		                case 9:
		                 var rest$8 = param[3], ty2 = param[2], ty1 = param[1];
		                 return [9, ty2, ty1, symm(rest$8)];
		                case 10:
		                 var rest$9 = param[1]; return [10, symm(rest$9)];
		                case 11:
		                 var rest$10 = param[1]; return [11, symm(rest$10)];
		                case 12:
		                 var rest$11 = param[1]; return [12, symm(rest$11)];
		                case 13:
		                 var rest$12 = param[1]; return [13, symm(rest$12)];
		                default: var rest$13 = param[1]; return [14, symm(rest$13)];
		              }
		             }
		             function fmtty_rel_det(a){
		              if(typeof a === "number")
		               return [0, , function(param){}, , function(param){}];
		              switch(a[0]){
		                case 0:
		                 var
		                  rest = a[1],
		                  a = fmtty_rel_det(rest),
		                  de = a[4],
		                  af = a[2];
		                 return [0, , function(param){af();}, , de];
		                case 1:
		                 var
		                  rest$0 = a[1],
		                  a = fmtty_rel_det(rest$0),
		                  de$0 = a[4],
		                  af$0 = a[2];
		                 return [0, , function(param){af$0();}, , de$0];
		                case 2:
		                 var
		                  rest$1 = a[1],
		                  a = fmtty_rel_det(rest$1),
		                  de$1 = a[4],
		                  af$1 = a[2];
		                 return [0, , function(param){af$1();}, , de$1];
		                case 3:
		                 var
		                  rest$2 = a[1],
		                  a = fmtty_rel_det(rest$2),
		                  de$2 = a[4],
		                  af$2 = a[2];
		                 return [0, , function(param){af$2();}, , de$2];
		                case 4:
		                 var
		                  rest$3 = a[1],
		                  a = fmtty_rel_det(rest$3),
		                  de$3 = a[4],
		                  af$3 = a[2];
		                 return [0, , function(param){af$3();}, , de$3];
		                case 5:
		                 var
		                  rest$4 = a[1],
		                  a = fmtty_rel_det(rest$4),
		                  de$4 = a[4],
		                  af$4 = a[2];
		                 return [0, , function(param){af$4();}, , de$4];
		                case 6:
		                 var
		                  rest$5 = a[1],
		                  a = fmtty_rel_det(rest$5),
		                  de$5 = a[4],
		                  af$5 = a[2];
		                 return [0, , function(param){af$5();}, , de$5];
		                case 7:
		                 var
		                  rest$6 = a[1],
		                  a = fmtty_rel_det(rest$6),
		                  de$6 = a[4],
		                  af$6 = a[2];
		                 return [0, , function(param){af$6();}, , de$6];
		                case 8:
		                 var
		                  rest$7 = a[2],
		                  a = fmtty_rel_det(rest$7),
		                  de$7 = a[4],
		                  af$7 = a[2];
		                 return [0, , function(param){af$7();}, , de$7];
		                case 9:
		                 var
		                  rest$8 = a[3],
		                  ty2 = a[2],
		                  ty1 = a[1],
		                  a = fmtty_rel_det(rest$8),
		                  de$8 = a[4],
		                  af$8 = a[2],
		                  ty = trans(symm(ty1), ty2),
		                  a = fmtty_rel_det(ty),
		                  jd = a[4],
		                  ga = a[2];
		                 return [0,
		                         ,
		                         function(param){ga(); af$8();},
		                         ,
		                         function(param){jd(); de$8();}];
		                case 10:
		                 var
		                  rest$9 = a[1],
		                  a = fmtty_rel_det(rest$9),
		                  de$9 = a[4],
		                  af$9 = a[2];
		                 return [0, , function(param){af$9();}, , de$9];
		                case 11:
		                 var
		                  rest$10 = a[1],
		                  a = fmtty_rel_det(rest$10),
		                  de$10 = a[4],
		                  af$10 = a[2];
		                 return [0, , function(param){af$10();}, , de$10];
		                case 12:
		                 var
		                  rest$11 = a[1],
		                  a = fmtty_rel_det(rest$11),
		                  de$11 = a[4],
		                  af$11 = a[2];
		                 return [0, , function(param){af$11();}, , de$11];
		                case 13:
		                 var
		                  rest$12 = a[1],
		                  a = fmtty_rel_det(rest$12),
		                  de$12 = a[4],
		                  af$12 = a[2];
		                 return [0,
		                         ,
		                         function(param){af$12();},
		                         ,
		                         function(param){de$12();}];
		                default:
		                 var
		                  rest$13 = a[1],
		                  a = fmtty_rel_det(rest$13),
		                  de$13 = a[4],
		                  af$13 = a[2];
		                 return [0,
		                         ,
		                         function(param){af$13();},
		                         ,
		                         function(param){de$13();}];
		              }
		             }
		             var
		              b = "camlinternalFormat.ml",
		              b$ = [0, b, 850, 23],
		              ca = [0, b, 837, 26],
		              cb = [0, b, 847, 28],
		              cc = [0, b, 815, 21],
		              cd = [0, b, 819, 21],
		              ce = [0, b, 823, 19],
		              cf = [0, b, 827, 22],
		              cg = [0, b, 832, 30],
		              ch = [0, b, 851, 23],
		              ci = [0, b, 836, 26],
		              cj = [0, b, 846, 28],
		              ck = [0, b, 814, 21],
		              cl = [0, b, 818, 21],
		              cm = [0, b, 822, 19],
		              cn = [0, b, 826, 22],
		              co = [0, b, 831, 30];
		             function trans(ty1, ty2){
		              a:
		              {
		               b:
		               {
		                c:
		                {
		                 d:
		                 {
		                  e:
		                  {
		                   f:
		                   {
		                    g:
		                    {
		                     if(typeof ty1 !== "number"){
		                      switch(ty1[0]){
		                        case 0:
		                         var rest1 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 0:
		                             var rest2 = ty2[1]; return [0, trans(rest1, rest2)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 1:
		                         var rest1$0 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 1:
		                             var rest2$0 = ty2[1]; return [1, trans(rest1$0, rest2$0)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 2:
		                         var rest1$1 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 2:
		                             var rest2$1 = ty2[1]; return [2, trans(rest1$1, rest2$1)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 3:
		                         var rest1$2 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 3:
		                             var rest2$2 = ty2[1]; return [3, trans(rest1$2, rest2$2)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 4:
		                         var rest1$3 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 4:
		                             var rest2$3 = ty2[1]; return [4, trans(rest1$3, rest2$3)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 5:
		                         var rest1$4 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 5:
		                             var rest2$4 = ty2[1]; return [5, trans(rest1$4, rest2$4)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 6:
		                         var rest1$5 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 6:
		                             var rest2$5 = ty2[1]; return [6, trans(rest1$5, rest2$5)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 7:
		                         var rest1$6 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 7:
		                             var rest2$6 = ty2[1]; return [7, trans(rest1$6, rest2$6)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                            case 9:
		                             break g;
		                          }
		                         break;
		                        case 8:
		                         var rest1$7 = ty1[2], ty1$0 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 8:
		                             var
		                              rest2$7 = ty2[2],
		                              ty2$0 = ty2[1],
		                              a = trans(rest1$7, rest2$7);
		                             return [8, trans(ty1$0, ty2$0), a];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                          }
		                         throw caml_maybe_attach_backtrace
		                                ([0, Assert_failure, ci], 1);
		                        case 9:
		                         var rest1$8 = ty1[3], ty12 = ty1[2], ty11 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 9:
		                             var
		                              rest2$8 = ty2[3],
		                              ty22 = ty2[2],
		                              ty21 = ty2[1],
		                              ty = trans(symm(ty12), ty21),
		                              a = fmtty_rel_det(ty),
		                              f4 = a[4],
		                              f2 = a[2];
		                             f2();
		                             f4();
		                             return [9, ty11, ty22, trans(rest1$8, rest2$8)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                            case 14:
		                             break e;
		                            case 8:
		                             break f;
		                          }
		                         throw caml_maybe_attach_backtrace
		                                ([0, Assert_failure, cj], 1);
		                        case 10:
		                         var rest1$9 = ty1[1];
		                         if(typeof ty2 !== "number" && 10 === ty2[0]){
		                          var rest2$9 = ty2[1];
		                          return [10, trans(rest1$9, rest2$9)];
		                         }
		                         throw caml_maybe_attach_backtrace
		                                ([0, Assert_failure, ck], 1);
		                        case 11:
		                         var rest1$10 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 11:
		                             var rest2$10 = ty2[1];
		                             return [11, trans(rest1$10, rest2$10)];
		                            case 10:
		                             break a;
		                          }
		                         throw caml_maybe_attach_backtrace
		                                ([0, Assert_failure, cl], 1);
		                        case 12:
		                         var rest1$11 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 12:
		                             var rest2$11 = ty2[1];
		                             return [12, trans(rest1$11, rest2$11)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                          }
		                         throw caml_maybe_attach_backtrace
		                                ([0, Assert_failure, cm], 1);
		                        case 13:
		                         var rest1$12 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 13:
		                             var rest2$12 = ty2[1];
		                             return [13, trans(rest1$12, rest2$12)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                          }
		                         throw caml_maybe_attach_backtrace
		                                ([0, Assert_failure, cn], 1);
		                        default:
		                         var rest1$13 = ty1[1];
		                         if(typeof ty2 !== "number")
		                          switch(ty2[0]){
		                            case 14:
		                             var rest2$13 = ty2[1];
		                             return [14, trans(rest1$13, rest2$13)];
		                            case 10:
		                             break a;
		                            case 11:
		                             break b;
		                            case 12:
		                             break c;
		                            case 13:
		                             break d;
		                          }
		                         throw caml_maybe_attach_backtrace
		                                ([0, Assert_failure, co], 1);
		                      }
		                      throw caml_maybe_attach_backtrace
		                             ([0, Assert_failure, ch], 1);
		                     }
		                     if(typeof ty2 === "number") return 0;
		                     switch(ty2[0]){
		                       case 10:
		                        break a;
		                       case 11:
		                        break b;
		                       case 12:
		                        break c;
		                       case 13:
		                        break d;
		                       case 14:
		                        break e;
		                       case 8:
		                        break f;
		                       case 9: break;
		                       default:
		                        throw caml_maybe_attach_backtrace
		                               ([0, Assert_failure, b$], 1);
		                     }
		                    }
		                    throw caml_maybe_attach_backtrace
		                           ([0, Assert_failure, cb], 1);
		                   }
		                   throw caml_maybe_attach_backtrace
		                          ([0, Assert_failure, ca], 1);
		                  }
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, cg], 1);
		                 }
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, cf], 1);
		                }
		                throw caml_maybe_attach_backtrace([0, Assert_failure, ce], 1);
		               }
		               throw caml_maybe_attach_backtrace([0, Assert_failure, cd], 1);
		              }
		              throw caml_maybe_attach_backtrace([0, Assert_failure, cc], 1);
		             }
		             function fmtty_of_fmt(fmtty$4){
		              var fmtty = fmtty$4;
		              for(;;){
		               if(typeof fmtty === "number") return 0;
		               switch(fmtty[0]){
		                 case 4:
		                  var
		                   rest$1 = fmtty[4],
		                   prec = fmtty[3],
		                   pad$0 = fmtty[2],
		                   ty_rest = fmtty_of_fmt(rest$1),
		                   prec_ty = fmtty_of_precision_fmtty(prec, [2, ty_rest]);
		                  return fmtty_of_padding_fmtty(pad$0, prec_ty);
		                 case 5:
		                  var
		                   rest$2 = fmtty[4],
		                   prec$0 = fmtty[3],
		                   pad$1 = fmtty[2],
		                   ty_rest$0 = fmtty_of_fmt(rest$2),
		                   prec_ty$0 = fmtty_of_precision_fmtty(prec$0, [3, ty_rest$0]);
		                  return fmtty_of_padding_fmtty(pad$1, prec_ty$0);
		                 case 6:
		                  var
		                   rest$3 = fmtty[4],
		                   prec$1 = fmtty[3],
		                   pad$2 = fmtty[2],
		                   ty_rest$1 = fmtty_of_fmt(rest$3),
		                   prec_ty$1 = fmtty_of_precision_fmtty(prec$1, [4, ty_rest$1]);
		                  return fmtty_of_padding_fmtty(pad$2, prec_ty$1);
		                 case 7:
		                  var
		                   rest$4 = fmtty[4],
		                   prec$2 = fmtty[3],
		                   pad$3 = fmtty[2],
		                   ty_rest$2 = fmtty_of_fmt(rest$4),
		                   prec_ty$2 = fmtty_of_precision_fmtty(prec$2, [5, ty_rest$2]);
		                  return fmtty_of_padding_fmtty(pad$3, prec_ty$2);
		                 case 8:
		                  var
		                   rest$5 = fmtty[4],
		                   prec$3 = fmtty[3],
		                   pad$4 = fmtty[2],
		                   ty_rest$3 = fmtty_of_fmt(rest$5),
		                   prec_ty$3 = fmtty_of_precision_fmtty(prec$3, [6, ty_rest$3]);
		                  return fmtty_of_padding_fmtty(pad$4, prec_ty$3);
		                 case 9:
		                  var rest$6 = fmtty[2], pad$5 = fmtty[1];
		                  return fmtty_of_padding_fmtty
		                          (pad$5, [7, fmtty_of_fmt(rest$6)]);
		                 case 10:
		                  var fmtty$0 = fmtty[1]; fmtty = fmtty$0; break;
		                 case 13:
		                  var rest$7 = fmtty[3], ty = fmtty[2];
		                  return [8, ty, fmtty_of_fmt(rest$7)];
		                 case 14:
		                  var rest$8 = fmtty[3], ty$0 = fmtty[2];
		                  return [9, ty$0, ty$0, fmtty_of_fmt(rest$8)];
		                 case 15:
		                  var rest$9 = fmtty[1]; return [10, fmtty_of_fmt(rest$9)];
		                 case 16:
		                  var rest$10 = fmtty[1]; return [11, fmtty_of_fmt(rest$10)];
		                 case 18:
		                  var
		                   rest$11 = fmtty[2],
		                   formatting_gen = fmtty[1],
		                   b = fmtty_of_fmt(rest$11);
		                  if(0 === formatting_gen[0])
		                   var fmt = formatting_gen[1][1], a = fmtty_of_fmt(fmt);
		                  else
		                   var fmt$0 = formatting_gen[1][1], a = fmtty_of_fmt(fmt$0);
		                  return concat_fmtty(a, b);
		                 case 19:
		                  var rest$12 = fmtty[1]; return [13, fmtty_of_fmt(rest$12)];
		                 case 20:
		                  var rest$13 = fmtty[3]; return [1, fmtty_of_fmt(rest$13)];
		                 case 21:
		                  var rest$14 = fmtty[2]; return [2, fmtty_of_fmt(rest$14)];
		                 case 23:
		                  var fmtty$2 = fmtty[2], ign = fmtty[1];
		                  if(typeof ign === "number"){
		                   if(2 === ign) return [14, fmtty_of_fmt(fmtty$2)];
		                   fmtty = fmtty$2;
		                  }
		                  else {
		                   if(9 === ign[0]){
		                    var fmtty$3 = ign[2];
		                    return concat_fmtty(fmtty$3, fmtty_of_fmt(fmtty$2));
		                   }
		                   fmtty = fmtty$2;
		                  }
		                  break;
		                 case 24:
		                  var rest$15 = fmtty[3], arity = fmtty[1];
		                  return fmtty_of_custom(arity, fmtty_of_fmt(rest$15));
		                 case 2:
		                 case 3:
		                  var rest$0 = fmtty[2], pad = fmtty[1];
		                  return fmtty_of_padding_fmtty
		                          (pad, [1, fmtty_of_fmt(rest$0)]);
		                 case 0:
		                 case 1:
		                 case 22:
		                  var rest = fmtty[1]; return [0, fmtty_of_fmt(rest)];
		                 default: var fmtty$1 = fmtty[2]; fmtty = fmtty$1;
		               }
		              }
		             }
		             function fmtty_of_custom(arity, fmtty){
		              if(! arity) return fmtty;
		              var arity$0 = arity[1];
		              return [12, fmtty_of_custom(arity$0, fmtty)];
		             }
		             function fmtty_of_padding_fmtty(pad, fmtty){
		              return typeof pad === "number"
		                      ? fmtty
		                      : 0 === pad[0] ? fmtty : [2, fmtty];
		             }
		             function fmtty_of_precision_fmtty(prec, fmtty){
		              return typeof prec === "number"
		                      ? prec ? [2, fmtty] : fmtty
		                      : fmtty;
		             }
		             var
		              Type_mismatch =
		                [248, "CamlinternalFormat.Type_mismatch", caml_fresh_oo_id()];
		             function type_padding(pad, fmtty){
		              if(typeof pad === "number") return [0, 0, fmtty];
		              if(0 === pad[0]){
		               var w = pad[2], padty = pad[1];
		               return [0, [0, padty, w], fmtty];
		              }
		              if(typeof fmtty !== "number" && 2 === fmtty[0]){
		               var rest = fmtty[1], padty$0 = pad[1];
		               return [0, [1, padty$0], rest];
		              }
		              throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		             }
		             function type_padprec(pad, prec, fmtty){
		              var match = type_padding(pad, fmtty);
		              if(typeof prec !== "number"){
		               var rest$1 = match[2], pad$2 = match[1], p = prec[1];
		               return [0, pad$2, [0, p], rest$1];
		              }
		              if(! prec){
		               var rest$0 = match[2], pad$1 = match[1];
		               return [0, pad$1, 0, rest$0];
		              }
		              var match$0 = match[2];
		              if(typeof match$0 !== "number" && 2 === match$0[0]){
		               var rest = match$0[1], pad$0 = match[1];
		               return [0, pad$0, 1, rest];
		              }
		              throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		             }
		             function type_format(fmt, fmtty){
		              var a = type_format_gen(fmt, fmtty);
		              if(typeof a[2] !== "number")
		               throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		              var fmt$0 = a[1];
		              return fmt$0;
		             }
		             function type_format_gen(fmt, fmtty0){
		              if(typeof fmt === "number") return [0, 0, fmtty0];
		              switch(fmt[0]){
		                case 0:
		                 if(typeof fmtty0 !== "number" && 0 === fmtty0[0]){
		                  var
		                   fmtty_rest = fmtty0[1],
		                   fmt_rest = fmt[1],
		                   a = type_format_gen(fmt_rest, fmtty_rest),
		                   fmtty = a[2],
		                   fmt$0 = a[1];
		                  return [0, [0, fmt$0], fmtty];
		                 }
		                 break;
		                case 1:
		                 if(typeof fmtty0 !== "number" && 0 === fmtty0[0]){
		                  var
		                   fmtty_rest$0 = fmtty0[1],
		                   fmt_rest$0 = fmt[1],
		                   a = type_format_gen(fmt_rest$0, fmtty_rest$0),
		                   fmtty$0 = a[2],
		                   fmt$1 = a[1];
		                  return [0, [1, fmt$1], fmtty$0];
		                 }
		                 break;
		                case 2:
		                 var
		                  fmt_rest$1 = fmt[2],
		                  pad = fmt[1],
		                  a = type_padding(pad, fmtty0),
		                  pad$0 = a[1],
		                  a = a[2];
		                 if(typeof a !== "number" && 1 === a[0]){
		                  var
		                   fmtty_rest$1 = a[1],
		                   a = type_format_gen(fmt_rest$1, fmtty_rest$1),
		                   fmtty$1 = a[2],
		                   fmt$2 = a[1];
		                  return [0, [2, pad$0, fmt$2], fmtty$1];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 3:
		                 var
		                  fmt_rest$2 = fmt[2],
		                  pad$1 = fmt[1],
		                  a = type_padding(pad$1, fmtty0),
		                  pad$2 = a[1],
		                  a = a[2];
		                 if(typeof a !== "number" && 1 === a[0]){
		                  var
		                   fmtty_rest$2 = a[1],
		                   a = type_format_gen(fmt_rest$2, fmtty_rest$2),
		                   fmtty$2 = a[2],
		                   fmt$3 = a[1];
		                  return [0, [3, pad$2, fmt$3], fmtty$2];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 4:
		                 var
		                  fmt_rest$3 = fmt[4],
		                  prec = fmt[3],
		                  pad$3 = fmt[2],
		                  iconv = fmt[1],
		                  a = type_padprec(pad$3, prec, fmtty0),
		                  pad$4 = a[1],
		                  b = a[3];
		                 if(typeof b !== "number" && 2 === b[0]){
		                  var
		                   fmtty_rest$3 = b[1],
		                   prec$0 = a[2],
		                   a = type_format_gen(fmt_rest$3, fmtty_rest$3),
		                   fmtty$3 = a[2],
		                   fmt$4 = a[1];
		                  return [0, [4, iconv, pad$4, prec$0, fmt$4], fmtty$3];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 5:
		                 var
		                  fmt_rest$4 = fmt[4],
		                  prec$1 = fmt[3],
		                  pad$5 = fmt[2],
		                  iconv$0 = fmt[1],
		                  a = type_padprec(pad$5, prec$1, fmtty0),
		                  pad$6 = a[1],
		                  b = a[3];
		                 if(typeof b !== "number" && 3 === b[0]){
		                  var
		                   fmtty_rest$4 = b[1],
		                   prec$2 = a[2],
		                   a = type_format_gen(fmt_rest$4, fmtty_rest$4),
		                   fmtty$4 = a[2],
		                   fmt$5 = a[1];
		                  return [0, [5, iconv$0, pad$6, prec$2, fmt$5], fmtty$4];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 6:
		                 var
		                  fmt_rest$5 = fmt[4],
		                  prec$3 = fmt[3],
		                  pad$7 = fmt[2],
		                  iconv$1 = fmt[1],
		                  a = type_padprec(pad$7, prec$3, fmtty0),
		                  pad$8 = a[1],
		                  b = a[3];
		                 if(typeof b !== "number" && 4 === b[0]){
		                  var
		                   fmtty_rest$5 = b[1],
		                   prec$4 = a[2],
		                   a = type_format_gen(fmt_rest$5, fmtty_rest$5),
		                   fmtty$5 = a[2],
		                   fmt$6 = a[1];
		                  return [0, [6, iconv$1, pad$8, prec$4, fmt$6], fmtty$5];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 7:
		                 var
		                  fmt_rest$6 = fmt[4],
		                  prec$5 = fmt[3],
		                  pad$9 = fmt[2],
		                  iconv$2 = fmt[1],
		                  a = type_padprec(pad$9, prec$5, fmtty0),
		                  pad$10 = a[1],
		                  b = a[3];
		                 if(typeof b !== "number" && 5 === b[0]){
		                  var
		                   fmtty_rest$6 = b[1],
		                   prec$6 = a[2],
		                   a = type_format_gen(fmt_rest$6, fmtty_rest$6),
		                   fmtty$6 = a[2],
		                   fmt$7 = a[1];
		                  return [0, [7, iconv$2, pad$10, prec$6, fmt$7], fmtty$6];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 8:
		                 var
		                  fmt_rest$7 = fmt[4],
		                  prec$7 = fmt[3],
		                  pad$11 = fmt[2],
		                  fconv = fmt[1],
		                  a = type_padprec(pad$11, prec$7, fmtty0),
		                  pad$12 = a[1],
		                  b = a[3];
		                 if(typeof b !== "number" && 6 === b[0]){
		                  var
		                   fmtty_rest$7 = b[1],
		                   prec$8 = a[2],
		                   a = type_format_gen(fmt_rest$7, fmtty_rest$7),
		                   fmtty$7 = a[2],
		                   fmt$8 = a[1];
		                  return [0, [8, fconv, pad$12, prec$8, fmt$8], fmtty$7];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 9:
		                 var
		                  fmt_rest$8 = fmt[2],
		                  pad$13 = fmt[1],
		                  a = type_padding(pad$13, fmtty0),
		                  pad$14 = a[1],
		                  a = a[2];
		                 if(typeof a !== "number" && 7 === a[0]){
		                  var
		                   fmtty_rest$8 = a[1],
		                   a = type_format_gen(fmt_rest$8, fmtty_rest$8),
		                   fmtty$8 = a[2],
		                   fmt$9 = a[1];
		                  return [0, [9, pad$14, fmt$9], fmtty$8];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                case 10:
		                 var
		                  fmt_rest$9 = fmt[1],
		                  a = type_format_gen(fmt_rest$9, fmtty0),
		                  fmtty$9 = a[2],
		                  fmt$10 = a[1];
		                 return [0, [10, fmt$10], fmtty$9];
		                case 11:
		                 var
		                  fmt_rest$10 = fmt[2],
		                  str = fmt[1],
		                  a = type_format_gen(fmt_rest$10, fmtty0),
		                  fmtty$10 = a[2],
		                  fmt$11 = a[1];
		                 return [0, [11, str, fmt$11], fmtty$10];
		                case 12:
		                 var
		                  fmt_rest$11 = fmt[2],
		                  chr = fmt[1],
		                  a = type_format_gen(fmt_rest$11, fmtty0),
		                  fmtty$11 = a[2],
		                  fmt$12 = a[1];
		                 return [0, [12, chr, fmt$12], fmtty$11];
		                case 13:
		                 if(typeof fmtty0 !== "number" && 8 === fmtty0[0]){
		                  var
		                   fmtty_rest$9 = fmtty0[2],
		                   sub_fmtty = fmtty0[1],
		                   fmt_rest$12 = fmt[3],
		                   sub_fmtty$0 = fmt[2],
		                   pad_opt = fmt[1];
		                  if(caml_notequal([0, sub_fmtty$0], [0, sub_fmtty]))
		                   throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                  a = type_format_gen(fmt_rest$12, fmtty_rest$9);
		                  var fmtty$12 = a[2], fmt$13 = a[1];
		                  return [0, [13, pad_opt, sub_fmtty, fmt$13], fmtty$12];
		                 }
		                 break;
		                case 14:
		                 if(typeof fmtty0 !== "number" && 9 === fmtty0[0]){
		                  var
		                   fmtty_rest$10 = fmtty0[3],
		                   sub_fmtty1 = fmtty0[1],
		                   fmt_rest$13 = fmt[3],
		                   sub_fmtty$1 = fmt[2],
		                   pad_opt$0 = fmt[1],
		                   a = [0, erase_rel(sub_fmtty1)];
		                  if(caml_notequal([0, erase_rel(sub_fmtty$1)], a))
		                   throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                  a = type_format_gen(fmt_rest$13, erase_rel(fmtty_rest$10));
		                  var fmtty$13 = a[2], fmt$14 = a[1];
		                  return [0, [14, pad_opt$0, sub_fmtty1, fmt$14], fmtty$13];
		                 }
		                 break;
		                case 15:
		                 if(typeof fmtty0 !== "number" && 10 === fmtty0[0]){
		                  var
		                   fmtty_rest$11 = fmtty0[1],
		                   fmt_rest$14 = fmt[1],
		                   a = type_format_gen(fmt_rest$14, fmtty_rest$11),
		                   fmtty$14 = a[2],
		                   fmt$15 = a[1];
		                  return [0, [15, fmt$15], fmtty$14];
		                 }
		                 break;
		                case 16:
		                 if(typeof fmtty0 !== "number" && 11 === fmtty0[0]){
		                  var
		                   fmtty_rest$12 = fmtty0[1],
		                   fmt_rest$15 = fmt[1],
		                   a = type_format_gen(fmt_rest$15, fmtty_rest$12),
		                   fmtty$15 = a[2],
		                   fmt$16 = a[1];
		                  return [0, [16, fmt$16], fmtty$15];
		                 }
		                 break;
		                case 17:
		                 var
		                  fmt_rest$16 = fmt[2],
		                  formatting_lit = fmt[1],
		                  a = type_format_gen(fmt_rest$16, fmtty0),
		                  fmtty$16 = a[2],
		                  fmt$17 = a[1];
		                 return [0, [17, formatting_lit, fmt$17], fmtty$16];
		                case 18:
		                 var fmt_rest$17 = fmt[2], formatting_gen = fmt[1];
		                 if(0 === formatting_gen[0]){
		                  a = formatting_gen[1];
		                  var
		                   str$0 = a[2],
		                   fmt1 = a[1],
		                   a = type_format_gen(fmt1, fmtty0),
		                   fmtty2 = a[2],
		                   fmt2 = a[1],
		                   a = type_format_gen(fmt_rest$17, fmtty2),
		                   fmtty3 = a[2],
		                   fmt3 = a[1];
		                  return [0, [18, [0, [0, fmt2, str$0]], fmt3], fmtty3];
		                 }
		                 a = formatting_gen[1];
		                 var
		                  str$1 = a[2],
		                  fmt1$0 = a[1],
		                  a = type_format_gen(fmt1$0, fmtty0),
		                  fmtty2$0 = a[2],
		                  fmt2$0 = a[1],
		                  a = type_format_gen(fmt_rest$17, fmtty2$0),
		                  fmtty3$0 = a[2],
		                  fmt3$0 = a[1];
		                 return [0, [18, [1, [0, fmt2$0, str$1]], fmt3$0], fmtty3$0];
		                case 19:
		                 if(typeof fmtty0 !== "number" && 13 === fmtty0[0]){
		                  var
		                   fmtty_rest$13 = fmtty0[1],
		                   fmt_rest$18 = fmt[1],
		                   a = type_format_gen(fmt_rest$18, fmtty_rest$13),
		                   fmtty$17 = a[2],
		                   fmt$18 = a[1];
		                  return [0, [19, fmt$18], fmtty$17];
		                 }
		                 break;
		                case 20:
		                 if(typeof fmtty0 !== "number" && 1 === fmtty0[0]){
		                  var
		                   fmtty_rest$14 = fmtty0[1],
		                   fmt_rest$19 = fmt[3],
		                   char_set = fmt[2],
		                   width_opt = fmt[1],
		                   a = type_format_gen(fmt_rest$19, fmtty_rest$14),
		                   fmtty$18 = a[2],
		                   fmt$19 = a[1];
		                  return [0, [20, width_opt, char_set, fmt$19], fmtty$18];
		                 }
		                 break;
		                case 21:
		                 if(typeof fmtty0 !== "number" && 2 === fmtty0[0]){
		                  var
		                   fmtty_rest$15 = fmtty0[1],
		                   fmt_rest$20 = fmt[2],
		                   counter = fmt[1],
		                   a = type_format_gen(fmt_rest$20, fmtty_rest$15),
		                   fmtty$19 = a[2],
		                   fmt$20 = a[1];
		                  return [0, [21, counter, fmt$20], fmtty$19];
		                 }
		                 break;
		                case 23:
		                 var rest = fmt[2], ign = fmt[1];
		                 if(typeof ign !== "number")
		                  switch(ign[0]){
		                    case 8:
		                     var sub_fmtty$2 = ign[2], pad_opt$1 = ign[1];
		                     return type_ignored_param_one
		                             ([8, pad_opt$1, sub_fmtty$2], rest, fmtty0);
		                    case 9:
		                     var
		                      sub_fmtty$3 = ign[2],
		                      pad_opt$2 = ign[1],
		                      a =
		                        type_ignored_format_substituti(sub_fmtty$3, rest, fmtty0),
		                      b = a[2],
		                      fmtty$21 = b[2],
		                      fmt$22 = b[1],
		                      sub_fmtty$4 = a[1];
		                     return [0,
		                             [23, [9, pad_opt$2, sub_fmtty$4], fmt$22],
		                             fmtty$21];
		                    default: return type_ignored_param_one(ign, rest, fmtty0);
		                  }
		                 if(2 !== ign)
		                  return type_ignored_param_one(ign, rest, fmtty0);
		                 if(typeof fmtty0 !== "number" && 14 === fmtty0[0]){
		                  var
		                   fmtty_rest$16 = fmtty0[1],
		                   a = type_format_gen(rest, fmtty_rest$16),
		                   fmtty$20 = a[2],
		                   fmt$21 = a[1];
		                  return [0, [23, 2, fmt$21], fmtty$20];
		                 }
		                 throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		              }
		              throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		             }
		             function type_ignored_param_one(ign, fmt, fmtty){
		              var
		               match = type_format_gen(fmt, fmtty),
		               fmtty$0 = match[2],
		               fmt$0 = match[1];
		              return [0, [23, ign, fmt$0], fmtty$0];
		             }
		             function type_ignored_format_substituti(sub_fmtty, fmt, fmtty){
		              if(typeof sub_fmtty === "number")
		               return [0, 0, type_format_gen(fmt, fmtty)];
		              switch(sub_fmtty[0]){
		                case 0:
		                 if(typeof fmtty !== "number" && 0 === fmtty[0]){
		                  var
		                   fmtty_rest = fmtty[1],
		                   sub_fmtty_rest = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest, fmt, fmtty_rest),
		                   fmt$0 = a[2],
		                   sub_fmtty_rest$0 = a[1];
		                  return [0, [0, sub_fmtty_rest$0], fmt$0];
		                 }
		                 break;
		                case 1:
		                 if(typeof fmtty !== "number" && 1 === fmtty[0]){
		                  var
		                   fmtty_rest$0 = fmtty[1],
		                   sub_fmtty_rest$1 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$1, fmt, fmtty_rest$0),
		                   fmt$1 = a[2],
		                   sub_fmtty_rest$2 = a[1];
		                  return [0, [1, sub_fmtty_rest$2], fmt$1];
		                 }
		                 break;
		                case 2:
		                 if(typeof fmtty !== "number" && 2 === fmtty[0]){
		                  var
		                   fmtty_rest$1 = fmtty[1],
		                   sub_fmtty_rest$3 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$3, fmt, fmtty_rest$1),
		                   fmt$2 = a[2],
		                   sub_fmtty_rest$4 = a[1];
		                  return [0, [2, sub_fmtty_rest$4], fmt$2];
		                 }
		                 break;
		                case 3:
		                 if(typeof fmtty !== "number" && 3 === fmtty[0]){
		                  var
		                   fmtty_rest$2 = fmtty[1],
		                   sub_fmtty_rest$5 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$5, fmt, fmtty_rest$2),
		                   fmt$3 = a[2],
		                   sub_fmtty_rest$6 = a[1];
		                  return [0, [3, sub_fmtty_rest$6], fmt$3];
		                 }
		                 break;
		                case 4:
		                 if(typeof fmtty !== "number" && 4 === fmtty[0]){
		                  var
		                   fmtty_rest$3 = fmtty[1],
		                   sub_fmtty_rest$7 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$7, fmt, fmtty_rest$3),
		                   fmt$4 = a[2],
		                   sub_fmtty_rest$8 = a[1];
		                  return [0, [4, sub_fmtty_rest$8], fmt$4];
		                 }
		                 break;
		                case 5:
		                 if(typeof fmtty !== "number" && 5 === fmtty[0]){
		                  var
		                   fmtty_rest$4 = fmtty[1],
		                   sub_fmtty_rest$9 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$9, fmt, fmtty_rest$4),
		                   fmt$5 = a[2],
		                   sub_fmtty_rest$10 = a[1];
		                  return [0, [5, sub_fmtty_rest$10], fmt$5];
		                 }
		                 break;
		                case 6:
		                 if(typeof fmtty !== "number" && 6 === fmtty[0]){
		                  var
		                   fmtty_rest$5 = fmtty[1],
		                   sub_fmtty_rest$11 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$11, fmt, fmtty_rest$5),
		                   fmt$6 = a[2],
		                   sub_fmtty_rest$12 = a[1];
		                  return [0, [6, sub_fmtty_rest$12], fmt$6];
		                 }
		                 break;
		                case 7:
		                 if(typeof fmtty !== "number" && 7 === fmtty[0]){
		                  var
		                   fmtty_rest$6 = fmtty[1],
		                   sub_fmtty_rest$13 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$13, fmt, fmtty_rest$6),
		                   fmt$7 = a[2],
		                   sub_fmtty_rest$14 = a[1];
		                  return [0, [7, sub_fmtty_rest$14], fmt$7];
		                 }
		                 break;
		                case 8:
		                 if(typeof fmtty !== "number" && 8 === fmtty[0]){
		                  var
		                   fmtty_rest$7 = fmtty[2],
		                   sub2_fmtty = fmtty[1],
		                   sub_fmtty_rest$15 = sub_fmtty[2],
		                   sub2_fmtty$0 = sub_fmtty[1];
		                  if(caml_notequal([0, sub2_fmtty$0], [0, sub2_fmtty]))
		                   throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                  a =
		                   type_ignored_format_substituti
		                    (sub_fmtty_rest$15, fmt, fmtty_rest$7);
		                  var fmt$8 = a[2], sub_fmtty_rest$16 = a[1];
		                  return [0, [8, sub2_fmtty, sub_fmtty_rest$16], fmt$8];
		                 }
		                 break;
		                case 9:
		                 if(typeof fmtty !== "number" && 9 === fmtty[0]){
		                  var
		                   fmtty_rest$8 = fmtty[3],
		                   sub2_fmtty$1 = fmtty[2],
		                   sub1_fmtty = fmtty[1],
		                   sub_fmtty_rest$17 = sub_fmtty[3],
		                   sub2_fmtty$2 = sub_fmtty[2],
		                   sub1_fmtty$0 = sub_fmtty[1],
		                   a = [0, erase_rel(sub1_fmtty)];
		                  if(caml_notequal([0, erase_rel(sub1_fmtty$0)], a))
		                   throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                  a = [0, erase_rel(sub2_fmtty$1)];
		                  if(caml_notequal([0, erase_rel(sub2_fmtty$2)], a))
		                   throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		                  var
		                   sub_fmtty$0 = trans(symm(sub1_fmtty), sub2_fmtty$1),
		                   a = fmtty_rel_det(sub_fmtty$0),
		                   f4 = a[4],
		                   f2 = a[2];
		                  f2();
		                  f4();
		                  a =
		                   type_ignored_format_substituti
		                    (erase_rel(sub_fmtty_rest$17), fmt, fmtty_rest$8);
		                  var fmt$9 = a[2], sub_fmtty_rest$18 = a[1];
		                  return [0,
		                          [9, sub1_fmtty, sub2_fmtty$1, symm(sub_fmtty_rest$18)],
		                          fmt$9];
		                 }
		                 break;
		                case 10:
		                 if(typeof fmtty !== "number" && 10 === fmtty[0]){
		                  var
		                   fmtty_rest$9 = fmtty[1],
		                   sub_fmtty_rest$19 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$19, fmt, fmtty_rest$9),
		                   fmt$10 = a[2],
		                   sub_fmtty_rest$20 = a[1];
		                  return [0, [10, sub_fmtty_rest$20], fmt$10];
		                 }
		                 break;
		                case 11:
		                 if(typeof fmtty !== "number" && 11 === fmtty[0]){
		                  var
		                   fmtty_rest$10 = fmtty[1],
		                   sub_fmtty_rest$21 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$21, fmt, fmtty_rest$10),
		                   fmt$11 = a[2],
		                   sub_fmtty_rest$22 = a[1];
		                  return [0, [11, sub_fmtty_rest$22], fmt$11];
		                 }
		                 break;
		                case 13:
		                 if(typeof fmtty !== "number" && 13 === fmtty[0]){
		                  var
		                   fmtty_rest$11 = fmtty[1],
		                   sub_fmtty_rest$23 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$23, fmt, fmtty_rest$11),
		                   fmt$12 = a[2],
		                   sub_fmtty_rest$24 = a[1];
		                  return [0, [13, sub_fmtty_rest$24], fmt$12];
		                 }
		                 break;
		                case 14:
		                 if(typeof fmtty !== "number" && 14 === fmtty[0]){
		                  var
		                   fmtty_rest$12 = fmtty[1],
		                   sub_fmtty_rest$25 = sub_fmtty[1],
		                   a =
		                     type_ignored_format_substituti
		                      (sub_fmtty_rest$25, fmt, fmtty_rest$12),
		                   fmt$13 = a[2],
		                   sub_fmtty_rest$26 = a[1];
		                  return [0, [14, sub_fmtty_rest$26], fmt$13];
		                 }
		                 break;
		              }
		              throw caml_maybe_attach_backtrace(Type_mismatch, 1);
		             }
		             function recast(fmt, fmtty){
		              return type_format(fmt, erase_rel(symm(fmtty)));
		             }
		             function fix_padding(padty, width, str, cont){
		              var
		               len = caml_ml_string_length(str),
		               padty$0 = 0 <= width ? padty : 0,
		               width$0 = stdlib_abs(width);
		              if(width$0 <= len) return cont(str);
		              var b = 2 === padty$0 ? 48 : 32, res = make(width$0, b);
		              function a(a){return cont(caml_string_of_bytes(res));}
		              switch(padty$0){
		                case 0:
		                 return caml_exact_trampoline_cps_call$3
		                         (blit_string, str, 0, res, 0, len, a);
		                case 1:
		                 return caml_exact_trampoline_cps_call$3
		                         (blit_string, str, 0, res, width$0 - len | 0, len, a);
		                default:
		                 a:
		                 if(0 < len){
		                  if
		                   (43 !== caml_string_get(str, 0)
		                    &&
		                     45 !== caml_string_get(str, 0)
		                     && 32 !== caml_string_get(str, 0))
		                   break a;
		                  caml_bytes_set(res, 0, caml_string_get(str, 0));
		                  return caml_exact_trampoline_cps_call$3
		                          (blit_string,
		                           str,
		                           1,
		                           res,
		                           (width$0 - len | 0) + 1 | 0,
		                           len - 1 | 0,
		                           a);
		                 }
		                 a:
		                 if(1 < len && 48 === caml_string_get(str, 0)){
		                  if
		                   (120 !== caml_string_get(str, 1)
		                    && 88 !== caml_string_get(str, 1))
		                   break a;
		                  caml_bytes_set(res, 1, caml_string_get(str, 1));
		                  return caml_exact_trampoline_cps_call$3
		                          (blit_string,
		                           str,
		                           2,
		                           res,
		                           (width$0 - len | 0) + 2 | 0,
		                           len - 2 | 0,
		                           a);
		                 }
		                 return caml_exact_trampoline_cps_call$3
		                         (blit_string, str, 0, res, width$0 - len | 0, len, a);
		              }
		             }
		             function fix_int_precision(prec, str, cont){
		              var
		               prec$0 = stdlib_abs(prec),
		               len = caml_ml_string_length(str),
		               c = caml_string_get(str, 0);
		              a:
		              {
		               b:
		               {
		                if(58 > c){
		                 if(32 !== c){
		                  if(43 > c) break a;
		                  switch(c - 43 | 0){
		                    case 5:
		                     if(len >= (prec$0 + 2 | 0)) break b;
		                     if(1 >= len) break b;
		                     if
		                      (120 !== caml_string_get(str, 1)
		                       && 88 !== caml_string_get(str, 1))
		                      break b;
		                     var res$1 = make(prec$0 + 2 | 0, 48);
		                     caml_bytes_set(res$1, 1, caml_string_get(str, 1));
		                     return caml_exact_trampoline_cps_call$3
		                             (blit_string,
		                              str,
		                              2,
		                              res$1,
		                              (prec$0 - len | 0) + 4 | 0,
		                              len - 2 | 0,
		                              function(a){return cont(caml_string_of_bytes(res$1));});
		                    case 0:
		                    case 2: break;
		                    case 1:
		                    case 3:
		                    case 4:
		                     break a;
		                    default: break b;
		                  }
		                 }
		                 if(len >= (prec$0 + 1 | 0)) break a;
		                 var res$0 = make(prec$0 + 1 | 0, 48);
		                 caml_bytes_set(res$0, 0, c);
		                 return caml_exact_trampoline_cps_call$3
		                         (blit_string,
		                          str,
		                          1,
		                          res$0,
		                          (prec$0 - len | 0) + 2 | 0,
		                          len - 1 | 0,
		                          function(a){return cont(caml_string_of_bytes(res$0));});
		                }
		                if(71 <= c){
		                 if(5 < c - 97 >>> 0) break a;
		                }
		                else if(65 > c) break a;
		               }
		               if(len < prec$0){
		                var res = make(prec$0, 48);
		                return caml_exact_trampoline_cps_call$3
		                        (blit_string,
		                         str,
		                         0,
		                         res,
		                         prec$0 - len | 0,
		                         len,
		                         function(a){return cont(caml_string_of_bytes(res));});
		               }
		              }
		              return cont(str);
		             }
		             function string_to_caml_string(str, cont){
		              var
		               str$0 = escaped$0(str),
		               l = caml_ml_string_length(str$0),
		               res = make(l + 2 | 0, 34);
		              caml_blit_string(str$0, 0, res, 1, l);
		              return cont(caml_string_of_bytes(res));
		             }
		             var opt = [0, 103];
		             function format_of_fconv(fconv, prec, cont){
		              var prec$0 = stdlib_abs(prec), cF = opt[1];
		              switch(fconv[2]){
		                case 0:
		                 var symb = 102; break;
		                case 1:
		                 symb = 101; break;
		                case 2:
		                 symb = 69; break;
		                case 3:
		                 symb = 103; break;
		                case 4:
		                 symb = 71; break;
		                case 6:
		                 symb = 104; break;
		                case 7:
		                 symb = 72; break;
		                case 8:
		                 symb = 70; break;
		                default: symb = cF;
		              }
		              var buf = buffer_create(16);
		              return caml_exact_trampoline_cps_call$1
		                      (buffer_add_char,
		                       buf,
		                       37,
		                       function(b){
		                        function a(b){
		                         function a(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (buffer_add_char,
		                                   buf,
		                                   46,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (buffer_add_string,
		     buf,
		     "" + prec$0,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (buffer_add_char,
		               buf,
		               symb,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (buffer_contents, buf, cont);
		               });
		     });
		                                   });
		                         }
		                         return 8 <= fconv[2]
		                                 ? caml_exact_trampoline_cps_call$1
		                                   (buffer_add_char, buf, 35, a)
		                                 : a();
		                        }
		                        switch(fconv[1]){
		                          case 1:
		                           return caml_exact_trampoline_cps_call$1
		                                   (buffer_add_char, buf, 43, a);
		                          case 2:
		                           return caml_exact_trampoline_cps_call$1
		                                   (buffer_add_char, buf, 32, a);
		                          default: return a();
		                        }
		                       });
		             }
		             function transform_int_alt(iconv, s){
		              if(13 > iconv) return s;
		              var b = caml_ml_string_length(s) - 1 | 0, a = 0;
		              if(b < 0)
		               var n$2 = a;
		              else {
		               var n = a, i$0 = 0;
		               for(;;){
		                if(9 < caml_string_unsafe_get(s, i$0) - 48 >>> 0)
		                 var n$1 = n;
		                else
		                 var n$0 = n + 1 | 0, n$1 = n$0;
		                a = i$0 + 1 | 0;
		                if(b === i$0){n$2 = n$1; break;}
		                n = n$1;
		                i$0 = a;
		               }
		              }
		              var
		               buf =
		                 caml_create_bytes
		                  (caml_ml_string_length(s) + ((n$2 - 1 | 0) / 3 | 0) | 0),
		               pos = [0, 0];
		              function put(c){caml_bytes_set(buf, pos[1], c); pos[1]++;}
		              var
		               b = caml_ml_string_length(s) - 1 | 0,
		               a = ((n$2 - 1 | 0) % 3 | 0) + 1 | 0;
		              if(b >= 0){
		               var left = a, i = 0;
		               for(;;){
		                var c = caml_string_unsafe_get(s, i);
		                if(9 < c - 48 >>> 0){
		                 put(c);
		                 var left$2 = left;
		                }
		                else {
		                 var
		                  left$0 = 0 === left ? (put(95), 3) : left,
		                  left$1 = left$0 - 1 | 0;
		                 put(c);
		                 left$2 = left$1;
		                }
		                a = i + 1 | 0;
		                if(b === i) break;
		                left = left$2;
		                i = a;
		               }
		              }
		              return caml_string_of_bytes(buf);
		             }
		             var cst_u = "%u";
		             function convert_int(iconv, n){
		              switch(iconv){
		                case 1:
		                 var a = "%+d"; break;
		                case 2:
		                 a = "% d"; break;
		                case 4:
		                 a = "%+i"; break;
		                case 5:
		                 a = "% i"; break;
		                case 6:
		                 a = "%x"; break;
		                case 7:
		                 a = "%#x"; break;
		                case 8:
		                 a = cst_X; break;
		                case 9:
		                 a = "%#X"; break;
		                case 10:
		                 a = "%o"; break;
		                case 11:
		                 a = "%#o"; break;
		                case 0:
		                case 13:
		                 a = cst_d; break;
		                case 3:
		                case 14:
		                 a = cst_i; break;
		                default: a = cst_u;
		              }
		              return transform_int_alt(iconv, caml_format_int(a, n));
		             }
		             function convert_int32(iconv, n){
		              switch(iconv){
		                case 1:
		                 var a = "%+ld"; break;
		                case 2:
		                 a = "% ld"; break;
		                case 4:
		                 a = "%+li"; break;
		                case 5:
		                 a = "% li"; break;
		                case 6:
		                 a = "%lx"; break;
		                case 7:
		                 a = "%#lx"; break;
		                case 8:
		                 a = "%lX"; break;
		                case 9:
		                 a = "%#lX"; break;
		                case 10:
		                 a = "%lo"; break;
		                case 11:
		                 a = "%#lo"; break;
		                case 0:
		                case 13:
		                 a = "%ld"; break;
		                case 3:
		                case 14:
		                 a = cst_li; break;
		                default: a = "%lu";
		              }
		              return transform_int_alt(iconv, caml_format_int(a, n));
		             }
		             function convert_nativeint(iconv, n){
		              switch(iconv){
		                case 1:
		                 var a = "%+nd"; break;
		                case 2:
		                 a = "% nd"; break;
		                case 4:
		                 a = "%+ni"; break;
		                case 5:
		                 a = "% ni"; break;
		                case 6:
		                 a = "%nx"; break;
		                case 7:
		                 a = "%#nx"; break;
		                case 8:
		                 a = "%nX"; break;
		                case 9:
		                 a = "%#nX"; break;
		                case 10:
		                 a = "%no"; break;
		                case 11:
		                 a = "%#no"; break;
		                case 0:
		                case 13:
		                 a = "%nd"; break;
		                case 3:
		                case 14:
		                 a = cst_ni; break;
		                default: a = "%nu";
		              }
		              return transform_int_alt(iconv, caml_format_int(a, n));
		             }
		             var cst_Ld = "%Ld";
		             function convert_int64(iconv, n){
		              switch(iconv){
		                case 1:
		                 var a = "%+Ld"; break;
		                case 2:
		                 a = "% Ld"; break;
		                case 4:
		                 a = "%+Li"; break;
		                case 5:
		                 a = "% Li"; break;
		                case 6:
		                 a = "%Lx"; break;
		                case 7:
		                 a = "%#Lx"; break;
		                case 8:
		                 a = "%LX"; break;
		                case 9:
		                 a = "%#LX"; break;
		                case 10:
		                 a = "%Lo"; break;
		                case 11:
		                 a = "%#Lo"; break;
		                case 0:
		                case 13:
		                 a = cst_Ld; break;
		                case 3:
		                case 14:
		                 a = cst_Li; break;
		                default: a = "%Lu";
		              }
		              return transform_int_alt(iconv, caml_int64_format(a, n));
		             }
		             var cst_nan = "nan";
		             function convert_float(fconv, prec, x, cont){
		              function hex(param){
		               switch(fconv[1]){
		                 case 0:
		                  var sign = 45; break;
		                 case 1:
		                  sign = 43; break;
		                 default: sign = 32;
		               }
		               return caml_hexstring_of_float(x, prec, sign);
		              }
		              function caml_special_val(str){
		               var match = caml_classify_float(x);
		               return 3 === match
		                       ? x < 0. ? "neg_infinity" : "infinity"
		                       : 4 <= match ? cst_nan : str;
		              }
		              switch(fconv[2]){
		                case 5:
		                 return caml_exact_trampoline_cps_call$1
		                         (format_of_fconv,
		                          fconv,
		                          prec,
		                          function(a){
		                           var
		                            str = caml_format_float(a, x),
		                            len = caml_ml_string_length(str),
		                            i = 0;
		                           for(;;){
		                            a:
		                            {
		                             if(i !== len){
		                              a = caml_string_get(str, i) - 46 | 0;
		                              b:
		                              {
		                               if(23 < a >>> 0){
		                                if(55 !== a) break b;
		                               }
		                               else if(21 >= a - 1 >>> 0) break b;
		                               a = 1;
		                               break a;
		                              }
		                              var i$0 = i + 1 | 0;
		                              i = i$0;
		                              continue;
		                             }
		                             a = 0;
		                            }
		                            a = a ? str : str + cst$14;
		                            return cont(caml_special_val(a));
		                           }
		                          });
		                case 6:
		                 return cont(hex());
		                case 7:
		                 return cont(uppercase_ascii$0(hex()));
		                case 8:
		                 return cont(caml_special_val(hex()));
		                default:
		                 return caml_exact_trampoline_cps_call$1
		                         (format_of_fconv,
		                          fconv,
		                          prec,
		                          function(a){return cont(caml_format_float(a, x));});
		              }
		             }
		             function string_of_fmtty(fmtty, cont){
		              var buf = buffer_create(16);
		              return caml_exact_trampoline_cps_call$1
		                      (bprint_fmtty,
		                       buf,
		                       fmtty,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (buffer_contents, buf, cont);
		                       });
		             }
		             var cp = [0, b, 1558, 4];
		             function make_printf(k$2, acc$4, fmt$2, cont){
		              var a = 0;
		              a:
		              for(;;)
		               switch(a){
		                 case 0:
		                  var k = k$2, acc = acc$4, fmt = fmt$2;
		                  b:
		                  for(;;){
		                   if(typeof fmt === "number")
		                    return caml_exact_trampoline_cps_call(k, acc, cont);
		                   switch(fmt[0]){
		                     case 0:
		                      a = 1; continue a;
		                     case 1:
		                      a = 2; continue a;
		                     case 2:
		                      a = 3; continue a;
		                     case 3:
		                      var rest$2 = fmt[2], pad$0 = fmt[1];
		                      return cont
		                              (make_padding(k, acc, rest$2, pad$0, string_to_caml_string));
		                     case 4:
		                      var
		                       rest$3 = fmt[4],
		                       prec = fmt[3],
		                       pad$1 = fmt[2],
		                       iconv = fmt[1];
		                      return cont
		                              (make_int_padding_precision
		                                (k, acc, rest$3, pad$1, prec, convert_int, iconv));
		                     case 5:
		                      var
		                       rest$4 = fmt[4],
		                       prec$0 = fmt[3],
		                       pad$2 = fmt[2],
		                       iconv$0 = fmt[1];
		                      return cont
		                              (make_int_padding_precision
		                                (k, acc, rest$4, pad$2, prec$0, convert_int32, iconv$0));
		                     case 6:
		                      var
		                       rest$5 = fmt[4],
		                       prec$1 = fmt[3],
		                       pad$3 = fmt[2],
		                       iconv$1 = fmt[1];
		                      return cont
		                              (make_int_padding_precision
		                                (k, acc, rest$5, pad$3, prec$1, convert_nativeint, iconv$1));
		                     case 7:
		                      var
		                       rest$6 = fmt[4],
		                       prec$2 = fmt[3],
		                       pad$4 = fmt[2],
		                       iconv$2 = fmt[1];
		                      return cont
		                              (make_int_padding_precision
		                                (k, acc, rest$6, pad$4, prec$2, convert_int64, iconv$2));
		                     case 8:
		                      a = 4; continue a;
		                     case 9:
		                      var rest$8 = fmt[2], pad$6 = fmt[1];
		                      return cont
		                              (make_padding(k, acc, rest$8, pad$6, string_of_bool));
		                     case 10:
		                      var rest$9 = fmt[1], acc$0 = [7, acc];
		                      acc = acc$0;
		                      fmt = rest$9;
		                      break;
		                     case 11:
		                      var rest$10 = fmt[2], str = fmt[1], acc$1 = [2, acc, str];
		                      acc = acc$1;
		                      fmt = rest$10;
		                      break;
		                     case 12:
		                      var rest$11 = fmt[2], chr = fmt[1], acc$2 = [3, acc, chr];
		                      acc = acc$2;
		                      fmt = rest$11;
		                      break;
		                     case 13:
		                      a = 5; continue a;
		                     case 14:
		                      a = 6; continue a;
		                     case 15:
		                      a = 7; continue a;
		                     case 16:
		                      a = 8; continue a;
		                     case 17:
		                      var
		                       rest$16 = fmt[2],
		                       fmting_lit = fmt[1],
		                       acc$3 = [0, acc, fmting_lit];
		                      acc = acc$3;
		                      fmt = rest$16;
		                      break;
		                     case 18:
		                      a = fmt[1];
		                      if(0 === a[0]){
		                       var rest$17 = fmt[2], fmt$0 = a[1][1];
		                       let acc$0 = acc, k$1 = k, rest = rest$17;
		                       var
		                        k$0 =
		                          function(kacc, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (make_printf, k$1, [1, acc$0, [0, kacc]], rest, cont);
		                          };
		                       k = k$0;
		                       acc = 0;
		                       fmt = fmt$0;
		                      }
		                      else {
		                       var rest$18 = fmt[2], fmt$1 = a[1][1];
		                       let acc$0 = acc, k$0 = k, rest = rest$18;
		                       var
		                        k$1 =
		                          function(kacc, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (make_printf, k$0, [1, acc$0, [1, kacc]], rest, cont);
		                          };
		                       k = k$1;
		                       acc = 0;
		                       fmt = fmt$1;
		                      }
		                      break;
		                     case 19:
		                      a = caml_pop_trap();
		                      return a
		                              (caml_maybe_attach_backtrace([0, Assert_failure, cp], 1));
		                     case 20:
		                      a = 9; continue a;
		                     case 21:
		                      a = 10; continue a;
		                     case 22:
		                      a = 11; continue a;
		                     case 23:
		                      var rest$22 = fmt[2], ign = fmt[1];
		                      return caml_exact_trampoline_cps_call$2
		                              (make_ignored_param, k, acc, ign, rest$22, cont);
		                     default: break b;
		                   }
		                  }
		                 case 12:
		                  var rest$23 = fmt[3], f = fmt[2], arity = fmt[1];
		                  return caml_trampoline_cps_call2
		                          (f,
		                           0,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$3
		                                    (make_custom, k, acc, rest$23, arity, a, cont);
		                           });
		                 case 11:
		                  var rest$21 = fmt[1];
		                  return cont
		                          (function(c, cont){
		                            var new_acc = [5, acc, c];
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf, k, new_acc, rest$21, cont);
		                           });
		                 case 10:
		                  var rest$20 = fmt[2];
		                  return cont
		                          (function(n, cont){
		                            var new_acc = [4, acc, caml_format_int(cst_u, n)];
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf, k, new_acc, rest$20, cont);
		                           });
		                 case 9:
		                  var
		                   rest$19 = fmt[3],
		                   new_acc = [8, acc, "Printf: bad conversion %["];
		                  return cont
		                          (function(param, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf, k, new_acc, rest$19, cont);
		                           });
		                 case 8:
		                  var rest$15 = fmt[1];
		                  return cont
		                          (function(f, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf, k, [6, acc, f], rest$15, cont);
		                           });
		                 case 7:
		                  var rest$14 = fmt[1];
		                  return cont
		                          (function(f, x, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf,
		                                     k,
		                                     [6,
		                                      acc,
		                                      function(o, cont){
		                                       return caml_trampoline_cps_call3(f, o, x, cont);
		                                      }],
		                                     rest$14,
		                                     cont);
		                           });
		                 case 6:
		                  var rest$13 = fmt[3], fmtty = fmt[2];
		                  return cont
		                          (function(param, cont){
		                            var fmt = param[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf,
		                                     k,
		                                     acc,
		                                     concat_fmt(recast(fmt, fmtty), rest$13),
		                                     cont);
		                           });
		                 case 5:
		                  var rest$12 = fmt[3], sub_fmtty = fmt[2];
		                  return caml_exact_trampoline_cps_call
		                          (string_of_fmtty,
		                           sub_fmtty,
		                           function(ty){
		                            return cont
		                                    (function(str, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (make_printf, k, [4, acc, ty], rest$12, cont);
		                                     });
		                           });
		                 case 4:
		                  var
		                   rest$7 = fmt[4],
		                   prec$3 = fmt[3],
		                   pad$5 = fmt[2],
		                   fconv = fmt[1];
		                  if(typeof pad$5 === "number"){
		                   if(typeof prec$3 === "number")
		                    return prec$3
		                            ? cont
		                              (function(p, x, cont){
		                                return caml_exact_trampoline_cps_call$0
		(convert_float,
		 fconv,
		 p,
		 x,
		 function(str){
		  return caml_exact_trampoline_cps_call$0
		          (make_printf, k, [4, acc, str], rest$7, cont);
		 });
		                               })
		                            : cont
		                              (function(x, cont){
		                                return caml_exact_trampoline_cps_call$0
		(convert_float,
		 fconv,
		 default_float_precision(fconv),
		 x,
		 function(str){
		  return caml_exact_trampoline_cps_call$0
		          (make_printf, k, [4, acc, str], rest$7, cont);
		 });
		                               });
		                   var p = prec$3[1];
		                   return cont
		                           (function(x, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (convert_float,
		                                      fconv,
		                                      p,
		                                      x,
		                                      function(str){
		                                       return caml_exact_trampoline_cps_call$0
		       (make_printf, k, [4, acc, str], rest$7, cont);
		                                      });
		                            });
		                  }
		                  if(0 === pad$5[0]){
		                   var w = pad$5[2], padty = pad$5[1];
		                   if(typeof prec$3 === "number")
		                    return prec$3
		                            ? cont
		                              (function(p, x, cont){
		                                return caml_exact_trampoline_cps_call$0
		(convert_float,
		 fconv,
		 p,
		 x,
		 function(a){
		  return caml_exact_trampoline_cps_call$0
		          (fix_padding,
		           padty,
		           w,
		           a,
		           function(str){
		            return caml_exact_trampoline_cps_call$0
		                    (make_printf, k, [4, acc, str], rest$7, cont);
		           });
		 });
		                               })
		                            : cont
		                              (function(x, cont){
		                                return caml_exact_trampoline_cps_call$0
		(convert_float,
		 fconv,
		 default_float_precision(fconv),
		 x,
		 function(str){
		  return caml_exact_trampoline_cps_call$0
		          (fix_padding,
		           padty,
		           w,
		           str,
		           function(str){
		            return caml_exact_trampoline_cps_call$0
		                    (make_printf, k, [4, acc, str], rest$7, cont);
		           });
		 });
		                               });
		                   var p$0 = prec$3[1];
		                   return cont
		                           (function(x, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (convert_float,
		                                      fconv,
		                                      p$0,
		                                      x,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (fix_padding,
		        padty,
		        w,
		        a,
		        function(str){
		         return caml_exact_trampoline_cps_call$0
		                 (make_printf, k, [4, acc, str], rest$7, cont);
		        });
		                                      });
		                            });
		                  }
		                  var padty$0 = pad$5[1];
		                  if(typeof prec$3 === "number")
		                   return prec$3
		                           ? cont
		                             (function(w, p, x, cont){
		                               return caml_exact_trampoline_cps_call$0
		                                       (convert_float,
		fconv,
		p,
		x,
		function(a){
		 return caml_exact_trampoline_cps_call$0
		         (fix_padding,
		          padty$0,
		          w,
		          a,
		          function(str){
		           return caml_exact_trampoline_cps_call$0
		                   (make_printf, k, [4, acc, str], rest$7, cont);
		          });
		});
		                              })
		                           : cont
		                             (function(w, x, cont){
		                               return caml_exact_trampoline_cps_call$0
		                                       (convert_float,
		fconv,
		default_float_precision(fconv),
		x,
		function(str){
		 return caml_exact_trampoline_cps_call$0
		         (fix_padding,
		          padty$0,
		          w,
		          str,
		          function(str){
		           return caml_exact_trampoline_cps_call$0
		                   (make_printf, k, [4, acc, str], rest$7, cont);
		          });
		});
		                              });
		                  var p$1 = prec$3[1];
		                  return cont
		                          (function(w, x, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (convert_float,
		                                     fconv,
		                                     p$1,
		                                     x,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$0
		      (fix_padding,
		       padty$0,
		       w,
		       a,
		       function(str){
		        return caml_exact_trampoline_cps_call$0
		                (make_printf, k, [4, acc, str], rest$7, cont);
		       });
		                                     });
		                           });
		                 case 3:
		                  var rest$1 = fmt[2], pad = fmt[1];
		                  return cont
		                          (make_padding
		                            (k,
		                             acc,
		                             rest$1,
		                             pad,
		                             function(str, cont){return cont(str);}));
		                 case 2:
		                  var rest$0 = fmt[1];
		                  return cont
		                          (function(c, cont){
		                            var
		                             str = escaped(c),
		                             l = caml_ml_string_length(str),
		                             res = make(l + 2 | 0, 39);
		                            caml_blit_string(str, 0, res, 1, l);
		                            var new_acc = [4, acc, caml_string_of_bytes(res)];
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf, k, new_acc, rest$0, cont);
		                           });
		                 case 1:
		                  var rest = fmt[1];
		                  return cont
		                          (function(c, cont){
		                            var new_acc = [5, acc, c];
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_printf, k, new_acc, rest, cont);
		                           });
		               }
		             }
		             var cq = [0, b, 1626, 39];
		             function make_ignored_param(k, acc, ign, fmt, a){
		              if(typeof ign === "number"){
		               if(2 !== ign)
		                return caml_exact_trampoline_cps_call$0
		                        (make_invalid_arg, k, acc, fmt, a);
		               a = caml_pop_trap();
		               return a
		                       (caml_maybe_attach_backtrace([0, Assert_failure, cq], 1));
		              }
		              if(9 !== ign[0])
		               return caml_exact_trampoline_cps_call$0
		                       (make_invalid_arg, k, acc, fmt, a);
		              var fmtty = ign[2];
		              return caml_exact_trampoline_cps_call$2
		                      (make_from_fmtty, k, acc, fmtty, fmt, a);
		             }
		             var cr = [0, b, 1649, 31], cs = [0, b, 1650, 31];
		             function make_from_fmtty(k, acc, fmtty, fmt, a){
		              if(typeof fmtty === "number")
		               return caml_exact_trampoline_cps_call$0
		                       (make_invalid_arg, k, acc, fmt, a);
		              switch(fmtty[0]){
		                case 0:
		                 var rest = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest, fmt, cont);
		                          });
		                case 1:
		                 var rest$0 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$0, fmt, cont);
		                          });
		                case 2:
		                 var rest$1 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$1, fmt, cont);
		                          });
		                case 3:
		                 var rest$2 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$2, fmt, cont);
		                          });
		                case 4:
		                 var rest$3 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$3, fmt, cont);
		                          });
		                case 5:
		                 var rest$4 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$4, fmt, cont);
		                          });
		                case 6:
		                 var rest$5 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$5, fmt, cont);
		                          });
		                case 7:
		                 var rest$6 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$6, fmt, cont);
		                          });
		                case 8:
		                 var rest$7 = fmtty[2];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$7, fmt, cont);
		                          });
		                case 9:
		                 var
		                  rest$8 = fmtty[3],
		                  ty2 = fmtty[2],
		                  ty1 = fmtty[1],
		                  ty = trans(symm(ty1), ty2);
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty,
		                                    k,
		                                    acc,
		                                    concat_fmtty(ty, rest$8),
		                                    fmt,
		                                    cont);
		                          });
		                case 10:
		                 var rest$9 = fmtty[1];
		                 return a
		                         (function(a, param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$9, fmt, cont);
		                          });
		                case 11:
		                 var rest$10 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$10, fmt, cont);
		                          });
		                case 12:
		                 var rest$11 = fmtty[1];
		                 return a
		                         (function(param, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_from_fmtty, k, acc, rest$11, fmt, cont);
		                          });
		                case 13:
		                 a = caml_pop_trap();
		                 return a
		                         (caml_maybe_attach_backtrace([0, Assert_failure, cr], 1));
		                default:
		                 a = caml_pop_trap();
		                 return a
		                         (caml_maybe_attach_backtrace([0, Assert_failure, cs], 1));
		              }
		             }
		             function make_invalid_arg(k, acc, fmt, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf,
		                       k,
		                       [8, acc, "Printf: bad conversion %_"],
		                       fmt,
		                       cont);
		             }
		             function make_padding(k, acc, fmt, pad, trans){
		              if(typeof pad === "number")
		               return function(x, cont){
		                return caml_exact_trampoline_cps_call
		                        (trans,
		                         x,
		                         function(a){
		                          var new_acc = [4, acc, a];
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_printf, k, new_acc, fmt, cont);
		                         });};
		              if(0 === pad[0]){
		               var width = pad[2], padty = pad[1];
		               return function(x, cont){
		                return caml_exact_trampoline_cps_call
		                        (trans,
		                         x,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fix_padding,
		                                   padty,
		                                   width,
		                                   a,
		                                   function(a){
		                                    var new_acc = [4, acc, a];
		                                    return caml_exact_trampoline_cps_call$0
		    (make_printf, k, new_acc, fmt, cont);
		                                   });
		                         });};
		              }
		              var padty$0 = pad[1];
		              return function(w, x, cont){
		               return caml_exact_trampoline_cps_call
		                       (trans,
		                        x,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$0
		                                 (fix_padding,
		                                  padty$0,
		                                  w,
		                                  a,
		                                  function(a){
		                                   var new_acc = [4, acc, a];
		                                   return caml_exact_trampoline_cps_call$0
		   (make_printf, k, new_acc, fmt, cont);
		                                  });
		                        });};
		             }
		             function make_int_padding_precision
		             (k, acc, fmt, pad, prec, trans, iconv){
		              if(typeof pad === "number"){
		               if(typeof prec === "number")
		                return prec
		                        ? function
		                         (p, x, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (fix_int_precision,
		                                   p,
		                                   trans(iconv, x),
		                                   function(str){
		                                    return caml_exact_trampoline_cps_call$0
		    (make_printf, k, [4, acc, str], fmt, cont);
		                                   });
		                         }
		                        : function
		                         (x, cont){
		                          var str = trans(iconv, x);
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_printf, k, [4, acc, str], fmt, cont);
		                         };
		               var p = prec[1];
		               return function(x, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (fix_int_precision,
		                         p,
		                         trans(iconv, x),
		                         function(str){
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_printf, k, [4, acc, str], fmt, cont);
		                         });};
		              }
		              if(0 === pad[0]){
		               var w = pad[2], padty = pad[1];
		               if(typeof prec === "number")
		                return prec
		                        ? function
		                         (p, x, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (fix_int_precision,
		                                   p,
		                                   trans(iconv, x),
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (fix_padding,
		     padty,
		     w,
		     a,
		     function(str){
		      return caml_exact_trampoline_cps_call$0
		              (make_printf, k, [4, acc, str], fmt, cont);
		     });
		                                   });
		                         }
		                        : function
		                         (x, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fix_padding,
		                                   padty,
		                                   w,
		                                   trans(iconv, x),
		                                   function(str){
		                                    return caml_exact_trampoline_cps_call$0
		    (make_printf, k, [4, acc, str], fmt, cont);
		                                   });
		                         };
		               var p$0 = prec[1];
		               return function(x, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (fix_int_precision,
		                         p$0,
		                         trans(iconv, x),
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fix_padding,
		                                   padty,
		                                   w,
		                                   a,
		                                   function(str){
		                                    return caml_exact_trampoline_cps_call$0
		    (make_printf, k, [4, acc, str], fmt, cont);
		                                   });
		                         });};
		              }
		              var padty$0 = pad[1];
		              if(typeof prec === "number")
		               return prec
		                       ? function
		                        (w, p, x, cont){
		                         return caml_exact_trampoline_cps_call$1
		                                 (fix_int_precision,
		                                  p,
		                                  trans(iconv, x),
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$0
		   (fix_padding,
		    padty$0,
		    w,
		    a,
		    function(str){
		     return caml_exact_trampoline_cps_call$0
		             (make_printf, k, [4, acc, str], fmt, cont);
		    });
		                                  });
		                        }
		                       : function
		                        (w, x, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (fix_padding,
		                                  padty$0,
		                                  w,
		                                  trans(iconv, x),
		                                  function(str){
		                                   return caml_exact_trampoline_cps_call$0
		   (make_printf, k, [4, acc, str], fmt, cont);
		                                  });
		                        };
		              var p$1 = prec[1];
		              return function(w, x, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (fix_int_precision,
		                        p$1,
		                        trans(iconv, x),
		                        function(a){
		                         return caml_exact_trampoline_cps_call$0
		                                 (fix_padding,
		                                  padty$0,
		                                  w,
		                                  a,
		                                  function(str){
		                                   return caml_exact_trampoline_cps_call$0
		   (make_printf, k, [4, acc, str], fmt, cont);
		                                  });
		                        });};
		             }
		             function make_custom(k, acc, rest, arity, f, cont){
		              if(! arity)
		               return caml_exact_trampoline_cps_call$0
		                       (make_printf, k, [4, acc, f], rest, cont);
		              var arity$0 = arity[1];
		              return cont
		                      (function(x, cont){
		                        return caml_trampoline_cps_call2
		                                (f,
		                                 x,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$3
		  (make_custom, k, acc, rest, arity$0, a, cont);
		                                 });
		                       });
		             }
		             var cst$3 = "@[", cst$2 = "@{";
		             function output_acc(o, acc, cont){
		              function a(acc){
		               if(typeof acc === "number") return cont();
		               switch(acc[0]){
		                 case 0:
		                  var
		                   fmting_lit = acc[2],
		                   p = acc[1],
		                   s = string_of_formatting_lit(fmting_lit);
		                  return caml_exact_trampoline_cps_call$1
		                          (output_acc,
		                           o,
		                           p,
		                           function(a){return cont(output_string(o, s));});
		                 case 1:
		                  var match = acc[2], p$0 = acc[1];
		                  if(0 === match[0]){
		                   var acc$0 = match[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (output_acc,
		                            o,
		                            p$0,
		                            function(b){
		                             output_string(o, cst$2);
		                             return caml_exact_trampoline_call1(a, acc$0);
		                            });
		                  }
		                  var acc$1 = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (output_acc,
		                           o,
		                           p$0,
		                           function(b){
		                            output_string(o, cst$3);
		                            return caml_exact_trampoline_call1(a, acc$1);
		                           });
		                 case 6:
		                  var f = acc[2], p$3 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (output_acc,
		                           o,
		                           p$3,
		                           function(a){return caml_trampoline_cps_call2(f, o, cont);});
		                 case 7:
		                  var p$4 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (output_acc,
		                           o,
		                           p$4,
		                           function(a){caml_ml_flush(o); return cont();});
		                 case 8:
		                  var msg = acc[2], p$5 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (output_acc,
		                           o,
		                           p$5,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (invalid_arg, msg, cont);
		                           });
		                 case 2:
		                 case 4:
		                  var s$0 = acc[2], p$1 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (output_acc,
		                           o,
		                           p$1,
		                           function(a){return cont(output_string(o, s$0));});
		                 default:
		                  var c = acc[2], p$2 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (output_acc,
		                           o,
		                           p$2,
		                           function(a){caml_ml_output_char(o, c); return cont();});
		               }
		              }
		              return a(acc);
		             }
		             function bufput_acc(b, acc, cont){
		              function a(acc){
		               if(typeof acc === "number") return cont();
		               switch(acc[0]){
		                 case 0:
		                  var
		                   fmting_lit = acc[2],
		                   p = acc[1],
		                   s = string_of_formatting_lit(fmting_lit);
		                  return caml_exact_trampoline_cps_call$1
		                          (bufput_acc,
		                           b,
		                           p,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (write_stringlit, b, s, cont);
		                           });
		                 case 1:
		                  var match = acc[2], p$0 = acc[1];
		                  if(0 === match[0]){
		                   var acc$0 = match[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (bufput_acc,
		                            b,
		                            p$0,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$1
		                                     (write_stringlit,
		                                      b,
		                                      cst$2,
		                                      function(b){return caml_exact_trampoline_call1(a, acc$0);});
		                            });
		                  }
		                  var acc$1 = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (bufput_acc,
		                           b,
		                           p$0,
		                           function(c){
		                            return caml_exact_trampoline_cps_call$1
		                                    (write_stringlit,
		                                     b,
		                                     cst$3,
		                                     function(b){return caml_exact_trampoline_call1(a, acc$1);});
		                           });
		                 case 6:
		                  var f = acc[2], p$3 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (bufput_acc,
		                           b,
		                           p$3,
		                           function(a){return caml_trampoline_cps_call2(f, b, cont);});
		                 case 7:
		                  var acc$2 = acc[1];
		                  return caml_exact_trampoline_call1(a, acc$2);
		                 case 8:
		                  var msg = acc[2], p$4 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (bufput_acc,
		                           b,
		                           p$4,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (invalid_arg, msg, cont);
		                           });
		                 case 2:
		                 case 4:
		                  var s$0 = acc[2], p$1 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (bufput_acc,
		                           b,
		                           p$1,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (write_stringlit, b, s$0, cont);
		                           });
		                 default:
		                  var c = acc[2], p$2 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (bufput_acc,
		                           b,
		                           p$2,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (add_char, b, c, cont);
		                           });
		               }
		              }
		              return a(acc);
		             }
		             function strput_acc(b, acc, cont){
		              function a(acc){
		               if(typeof acc === "number") return cont();
		               switch(acc[0]){
		                 case 0:
		                  var
		                   fmting_lit = acc[2],
		                   p = acc[1],
		                   s = string_of_formatting_lit(fmting_lit);
		                  return caml_exact_trampoline_cps_call$1
		                          (strput_acc,
		                           b,
		                           p,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (write_stringlit, b, s, cont);
		                           });
		                 case 1:
		                  var match = acc[2], p$0 = acc[1];
		                  if(0 === match[0]){
		                   var acc$0 = match[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (strput_acc,
		                            b,
		                            p$0,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$1
		                                     (write_stringlit,
		                                      b,
		                                      cst$2,
		                                      function(b){return caml_exact_trampoline_call1(a, acc$0);});
		                            });
		                  }
		                  var acc$1 = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (strput_acc,
		                           b,
		                           p$0,
		                           function(c){
		                            return caml_exact_trampoline_cps_call$1
		                                    (write_stringlit,
		                                     b,
		                                     cst$3,
		                                     function(b){return caml_exact_trampoline_call1(a, acc$1);});
		                           });
		                 case 6:
		                  var f = acc[2], p$3 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (strput_acc,
		                           b,
		                           p$3,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (f,
		                                     0,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (write_stringlit, b, a, cont);
		                                     });
		                           });
		                 case 7:
		                  var acc$2 = acc[1];
		                  return caml_exact_trampoline_call1(a, acc$2);
		                 case 8:
		                  var msg = acc[2], p$4 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (strput_acc,
		                           b,
		                           p$4,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (invalid_arg, msg, cont);
		                           });
		                 case 2:
		                 case 4:
		                  var s$0 = acc[2], p$1 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (strput_acc,
		                           b,
		                           p$1,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (write_stringlit, b, s$0, cont);
		                           });
		                 default:
		                  var c = acc[2], p$2 = acc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (strput_acc,
		                           b,
		                           p$2,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (add_char, b, c, cont);
		                           });
		               }
		              }
		              return a(acc);
		             }
		             function failwith_message(param, cont){
		              var fmt = param[1], buf = create$1(256);
		              function k(acc, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (strput_acc,
		                        buf,
		                        acc,
		                        function(a){
		                         return caml_exact_trampoline_cps_call
		                                 (contents,
		                                  buf,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call(failwith, a, cont);
		                                  });
		                        });
		              }
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf, k, 0, fmt, cont);
		             }
		             var
		              cst_b = "b",
		              cst_h$0 = "h",
		              cst_v = "v",
		              ct = [0, 0, 4],
		              cu =
		                [0,
		                 [11, "invalid box description ", [3, 0, 0]],
		                 "invalid box description %S"];
		             function open_box_of_string(str, cont){
		              if(str === cst$1) return cont(ct);
		              var len = caml_ml_string_length(str);
		              function invalid_box(param, cont){
		               return caml_exact_trampoline_cps_call
		                       (failwith_message,
		                        cu,
		                        function(a){return caml_trampoline_cps_call2(a, str, cont);});
		              }
		              function parse_spaces(i$1){
		               var i = i$1;
		               for(;;){
		                if(i === len) return i;
		                var match = caml_string_get(str, i);
		                if(9 !== match && 32 !== match) return i;
		                var i$0 = i + 1 | 0;
		                i = i$0;
		               }
		              }
		              var wstart = parse_spaces(0), wend = wstart;
		              for(;;){
		               if(wend === len) break;
		               if(25 < caml_string_get(str, wend) - 97 >>> 0) break;
		               var j = wend + 1 | 0;
		               wend = j;
		              }
		              return caml_exact_trampoline_cps_call$0
		                      (get_sub,
		                       str,
		                       wstart,
		                       wend - wstart | 0,
		                       function(box_name){
		                        var nstart = parse_spaces(wend), nend = nstart;
		                        for(;;){
		                         if(nend === len) break;
		                         var match = caml_string_get(str, nend);
		                         if(48 <= match){
		                          if(58 <= match) break;
		                         }
		                         else if(45 !== match) break;
		                         var j = nend + 1 | 0;
		                         nend = j;
		                        }
		                        function a(indent){
		                         var exp_end = parse_spaces(nend);
		                         function a(b){
		                          function a(box_type){return cont([0, indent, box_type]);}
		                          if(box_name !== cst$1 && box_name !== cst_b)
		                           return box_name !== cst_h$0
		                                   ? box_name
		                                     !== "hov"
		                                     ? box_name
		                                       !== "hv"
		                                       ? box_name
		 !== cst_v
		 ? caml_exact_trampoline_cps_call(invalid_box, dummy, a)
		 : a(1)
		                                       : a(2)
		                                     : a(3)
		                                   : a(0);
		                          return a(4);
		                         }
		                         return exp_end !== len
		                                 ? caml_exact_trampoline_cps_call(invalid_box, dummy, a)
		                                 : a();
		                        }
		                        return nstart === nend
		                                ? a(0)
		                                : (caml_push_trap
		                                   (function(exn){
		                                     if(exn[1] === Failure)
		                                      return caml_exact_trampoline_cps_call(invalid_box, dummy, a);
		                                     var
		                                      raise = caml_pop_trap(),
		                                      exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                                     return raise(exn$0);
		                                    }),
		                                  caml_exact_trampoline_cps_call$0
		                                   (get_sub,
		                                    str,
		                                    nstart,
		                                    nend - nstart | 0,
		                                    function(b){
		                                     b = caml_int_of_string(b);
		                                     caml_pop_trap();
		                                     return a(b);
		                                    }));
		                       });
		             }
		             function make_padding_fmt_ebb(pad, fmt){
		              if(typeof pad === "number") return [0, 0, fmt];
		              if(0 === pad[0]){
		               var w = pad[2], s = pad[1];
		               return [0, [0, s, w], fmt];
		              }
		              var s$0 = pad[1];
		              return [0, [1, s$0], fmt];
		             }
		             function make_padprec_fmt_ebb(pad, prec, fmt){
		              if(typeof prec === "number")
		               var match = prec ? [0, 1] : [0, 0];
		              else
		               var p = prec[1], match = [0, [0, p]];
		              var prec$0 = match[1];
		              if(typeof pad === "number") return [0, 0, prec$0, fmt];
		              if(0 === pad[0]){
		               var w = pad[2], s = pad[1];
		               return [0, [0, s, w], prec$0, fmt];
		              }
		              var s$0 = pad[1];
		              return [0, [1, s$0], prec$0, fmt];
		             }
		             var
		              c = ", ",
		              cst_0 = "0",
		              g = ": at character number ",
		              cst$4 = "@ ",
		              cst$5 = "@,",
		              r = "@;",
		              cst_digit = "digit",
		              a = "invalid format ",
		              sub_format = [0, 0, cst$1],
		              formatting_lit = [0, r, 1, 0],
		              cv =
		                [0,
		                 [11, a, [3, 0, [11, g, [4, 0, 0, 0, [11, c, [2, 0, 0]]]]]],
		                 "invalid format %S: at character number %d, %s"],
		              cw =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    g,
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11, ", '", [0, [11, "' without ", [2, 0, 0]]]]]]]],
		                 "invalid format %S: at character number %d, '%c' without %s"],
		              cx =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    g,
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11, c, [2, 0, [11, " expected, read ", [1, 0]]]]]]]],
		                 "invalid format %S: at character number %d, %s expected, read %C"],
		              cy =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11, g, [4, 0, 0, 0, [11, ", duplicate flag ", [1, 0]]]]]],
		                 "invalid format %S: at character number %d, duplicate flag %C"],
		              cz = [0, 1, 0],
		              cA = [0, 0],
		              cB = [1, 0],
		              cC = [1, 1],
		              cD = [1, 1],
		              cE = [1, 1],
		              cF =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    g,
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11, ', invalid conversion "', [12, 37, [0, [12, 34, 0]]]]]]]],
		                 'invalid format %S: at character number %d, invalid conversion "%%%c"'],
		              cG = [0, 0],
		              cH = [0, 0],
		              cI =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    g,
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11,
		                      ", flag ",
		                      [1,
		                       [11,
		                        " is only allowed after the '",
		                        [12, 37, [11, "', before padding and precision", 0]]]]]]]]],
		                 "invalid format %S: at character number %d, flag %C is only allowed after the '%%', before padding and precision"],
		              cJ = [0, [12, 64, 0]],
		              cK = [0, cst$4, 1, 0],
		              cL = [0, cst$5, 0, 0],
		              cM = [2, 60],
		              cN =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    ": '",
		                    [12,
		                     37,
		                     [11,
		                      "' alone is not accepted in character sets, use ",
		                      [12,
		                       37,
		                       [12,
		                        37,
		                        [11, " instead at position ", [4, 0, 0, 0, [12, 46, 0]]]]]]]]]],
		                 "invalid format %S: '%%' alone is not accepted in character sets, use %%%% instead at position %d."],
		              cO =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    ": integer ",
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11, " is greater than the limit ", [4, 0, 0, 0, 0]]]]]],
		                 "invalid format %S: integer %d is greater than the limit %d"],
		              cP = [0, b, 2837, 11],
		              cQ =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    ': unclosed sub-format, expected "',
		                    [12,
		                     37,
		                     [0, [11, '" at character number ', [4, 0, 0, 0, 0]]]]]]],
		                 'invalid format %S: unclosed sub-format, expected "%%%c" at character number %d'],
		              cR = [0, b, 2899, 34],
		              cS = [0, b, 2935, 28],
		              cT = [0, b, 2957, 11],
		              cU =
		                [0,
		                 [11,
		                  a,
		                  [3,
		                   0,
		                   [11,
		                    g,
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11,
		                      c,
		                      [2,
		                       0,
		                       [11,
		                        " is incompatible with '",
		                        [0, [11, "' in sub-format ", [3, 0, 0]]]]]]]]]],
		                 "invalid format %S: at character number %d, %s is incompatible with '%c' in sub-format %S"];
		             function fmt_ebb_of_string(legacy_behavior, str, cont){
		              if(legacy_behavior)
		               var flag = legacy_behavior[1], legacy_behavior$0 = flag;
		              else
		               legacy_behavior$0 = 1;
		              function invalid_format_message(str_ind, msg, cont){
		               return caml_exact_trampoline_cps_call
		                       (failwith_message,
		                        cv,
		                        function(a){
		                         return caml_trampoline_cps_call4(a, str, str_ind, msg, cont);
		                        });
		              }
		              function invalid_format_without(str_ind, c, s, cont){
		               return caml_exact_trampoline_cps_call
		                       (failwith_message,
		                        cw,
		                        function(a){
		                         return caml_trampoline_cps_call5
		                                 (a, str, str_ind, c, s, cont);
		                        });
		              }
		              function expected_character(str_ind, expected, read, cont){
		               return caml_exact_trampoline_cps_call
		                       (failwith_message,
		                        cx,
		                        function(a){
		                         return caml_trampoline_cps_call5
		                                 (a, str, str_ind, expected, read, cont);
		                        });
		              }
		              var a = "unexpected end of format";
		              function parse(lit_start, end_ind, cont){
		               a:
		               {
		                var str_ind = lit_start;
		                for(;;){
		                 if(str_ind === end_ind)
		                  return caml_exact_trampoline_cps_call$0
		                          (add_literal, lit_start, str_ind, 0, cont);
		                 var match = caml_string_get(str, str_ind);
		                 if(37 === match) break;
		                 if(64 === match) break a;
		                 var str_ind$0 = str_ind + 1 | 0;
		                 str_ind = str_ind$0;
		                }
		                var
		                 str_ind$1 = str_ind + 1 | 0,
		                 b =
		                   function(b){
		                    function a(match){
		                     var fmt_rest = match[1];
		                     return caml_exact_trampoline_cps_call$0
		                             (add_literal, lit_start, str_ind, fmt_rest, cont);
		                    }
		                    return 95 === caml_string_get(str, str_ind$1)
		                            ? caml_exact_trampoline_cps_call$2
		                              (parse_flags, str_ind, str_ind$1 + 1 | 0, end_ind, 1, a)
		                            : caml_exact_trampoline_cps_call$2
		                              (parse_flags, str_ind, str_ind$1, end_ind, 0, a);
		                   };
		                return str_ind$1 === end_ind
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_format_message, end_ind, a, b)
		                        : b(0);
		               }
		               return caml_exact_trampoline_cps_call$1
		                       (parse_after_at,
		                        str_ind + 1 | 0,
		                        end_ind,
		                        function(match){
		                         var fmt_rest = match[1];
		                         return caml_exact_trampoline_cps_call$0
		                                 (add_literal, lit_start, str_ind, fmt_rest, cont);
		                        });
		              }
		              function parse_flags(pct_ind, str_ind, end_ind, ign, cont){
		               function set_flag(str_ind, flag, cont){
		                var a = flag[1], a = a ? 1 - legacy_behavior$0 : a;
		                function b(a){flag[1] = 1; return cont();}
		                if(! a) return b();
		                var c = caml_string_get(str, str_ind);
		                return caml_exact_trampoline_cps_call
		                        (failwith_message,
		                         cy,
		                         function(a){
		                          return caml_trampoline_cps_call4(a, str, str_ind, c, b);
		                         });
		               }
		               var
		                zero = [0, 0],
		                minus = [0, 0],
		                plus = [0, 0],
		                space = [0, 0],
		                hash = [0, 0];
		               function b(str_ind){
		                function c(c){
		                 c = caml_string_get(str, str_ind) - 32 | 0;
		                 if(16 >= c >>> 0)
		                  switch(c){
		                    case 0:
		                     return caml_exact_trampoline_cps_call$1
		                             (set_flag,
		                              str_ind,
		                              space,
		                              function(a){
		                               var str_ind$0 = str_ind + 1 | 0;
		                               return caml_exact_trampoline_call1(b, str_ind$0);
		                              });
		                    case 3:
		                     return caml_exact_trampoline_cps_call$1
		                             (set_flag,
		                              str_ind,
		                              hash,
		                              function(a){
		                               var str_ind$0 = str_ind + 1 | 0;
		                               return caml_exact_trampoline_call1(b, str_ind$0);
		                              });
		                    case 11:
		                     return caml_exact_trampoline_cps_call$1
		                             (set_flag,
		                              str_ind,
		                              plus,
		                              function(a){
		                               var str_ind$0 = str_ind + 1 | 0;
		                               return caml_exact_trampoline_call1(b, str_ind$0);
		                              });
		                    case 13:
		                     return caml_exact_trampoline_cps_call$1
		                             (set_flag,
		                              str_ind,
		                              minus,
		                              function(a){
		                               var str_ind$0 = str_ind + 1 | 0;
		                               return caml_exact_trampoline_call1(b, str_ind$0);
		                              });
		                    case 16:
		                     return caml_exact_trampoline_cps_call$1
		                             (set_flag,
		                              str_ind,
		                              zero,
		                              function(a){
		                               var str_ind$0 = str_ind + 1 | 0;
		                               return caml_exact_trampoline_call1(b, str_ind$0);
		                              });
		                  }
		                 var
		                  space$0 = space[1],
		                  hash$0 = hash[1],
		                  plus$0 = plus[1],
		                  minus$0 = minus[1],
		                  zero$0 = zero[1];
		                 function d(b){
		                  function a(padty){
		                   var match = caml_string_get(str, str_ind);
		                   if(48 <= match){
		                    if(58 > match)
		                     return caml_exact_trampoline_cps_call$0
		                             (parse_positive,
		                              str_ind,
		                              end_ind,
		                              0,
		                              function(match){
		                               var width = match[2], new_ind = match[1];
		                               return caml_exact_trampoline_cps_call$4
		                                       (parse_after_padding,
		pct_ind,
		new_ind,
		end_ind,
		minus$0,
		plus$0,
		hash$0,
		space$0,
		ign,
		[0, padty, width],
		cont);
		                              });
		                   }
		                   else if(42 === match)
		                    return caml_exact_trampoline_cps_call$4
		                            (parse_after_padding,
		                             pct_ind,
		                             str_ind + 1 | 0,
		                             end_ind,
		                             minus$0,
		                             plus$0,
		                             hash$0,
		                             space$0,
		                             ign,
		                             [1, padty],
		                             cont);
		                   switch(padty){
		                     case 0:
		                      var
		                       a =
		                         function(a){
		                          return caml_exact_trampoline_cps_call$4
		                                  (parse_after_padding,
		                                   pct_ind,
		                                   str_ind,
		                                   end_ind,
		                                   minus$0,
		                                   plus$0,
		                                   hash$0,
		                                   space$0,
		                                   ign,
		                                   0,
		                                   cont);
		                         };
		                      return 1 - legacy_behavior$0
		                              ? caml_exact_trampoline_cps_call$0
		                                (invalid_format_without, str_ind - 1 | 0, 45, "padding", a)
		                              : a(0);
		                     case 1:
		                      return caml_exact_trampoline_cps_call$4
		                              (parse_after_padding,
		                               pct_ind,
		                               str_ind,
		                               end_ind,
		                               minus$0,
		                               plus$0,
		                               hash$0,
		                               space$0,
		                               ign,
		                               0,
		                               cont);
		                     default:
		                      return caml_exact_trampoline_cps_call$4
		                              (parse_after_padding,
		                               pct_ind,
		                               str_ind,
		                               end_ind,
		                               minus$0,
		                               plus$0,
		                               hash$0,
		                               space$0,
		                               ign,
		                               cz,
		                               cont);
		                   }
		                  }
		                  return zero$0
		                          ? minus$0
		                            ? legacy_behavior$0
		                              ? a(0)
		                              : caml_exact_trampoline_cps_call$2
		                                (incompatible_flag, pct_ind, str_ind, 45, cst_0, a)
		                            : a(2)
		                          : minus$0 ? a(0) : a(1);
		                 }
		                 return str_ind === end_ind
		                         ? caml_exact_trampoline_cps_call$1
		                           (invalid_format_message, end_ind, a, d)
		                         : d();
		                }
		                return str_ind === end_ind
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_format_message, end_ind, a, c)
		                        : c(0);
		               }
		               return b(str_ind);
		              }
		              var cst_precision = "precision";
		              function parse_after_padding
		              (pct_ind,
		               str_ind,
		               end_ind,
		               minus,
		               plus,
		               hash,
		               space,
		               ign,
		               pad,
		               cont){
		               function b(c){
		                var symb = caml_string_get(str, str_ind);
		                if(46 !== symb)
		                 return caml_exact_trampoline_cps_call$6
		                         (parse_conversion,
		                          pct_ind,
		                          str_ind + 1 | 0,
		                          end_ind,
		                          plus,
		                          hash,
		                          space,
		                          ign,
		                          pad,
		                          0,
		                          pad,
		                          symb,
		                          cont);
		                var str_ind$0 = str_ind + 1 | 0;
		                function b(a){
		                 function parse_literal(minus, str_ind, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (parse_positive,
		                           str_ind,
		                           end_ind,
		                           0,
		                           function(match){
		                            var prec = match[2], new_ind = match[1];
		                            return caml_exact_trampoline_cps_call$5
		                                    (parse_after_precision,
		                                     pct_ind,
		                                     new_ind,
		                                     end_ind,
		                                     minus,
		                                     plus,
		                                     hash,
		                                     space,
		                                     ign,
		                                     pad,
		                                     [0, prec],
		                                     cont);
		                           });
		                 }
		                 var symb = caml_string_get(str, str_ind$0);
		                 if(48 <= symb){
		                  if(58 > symb)
		                   return caml_exact_trampoline_cps_call$1
		                           (parse_literal, minus, str_ind$0, cont);
		                 }
		                 else if(42 <= symb)
		                  switch(symb - 42 | 0){
		                    case 0:
		                     return caml_exact_trampoline_cps_call$5
		                             (parse_after_precision,
		                              pct_ind,
		                              str_ind$0 + 1 | 0,
		                              end_ind,
		                              minus,
		                              plus,
		                              hash,
		                              space,
		                              ign,
		                              pad,
		                              1,
		                              cont);
		                    case 1:
		                    case 3:
		                     if(legacy_behavior$0){
		                      a = str_ind$0 + 1 | 0;
		                      var minus$0 = minus || (45 === symb ? 1 : 0);
		                      return caml_exact_trampoline_cps_call$1
		                              (parse_literal, minus$0, a, cont);
		                     }
		                     break;
		                  }
		                 return legacy_behavior$0
		                         ? caml_exact_trampoline_cps_call$5
		                           (parse_after_precision,
		                            pct_ind,
		                            str_ind$0,
		                            end_ind,
		                            minus,
		                            plus,
		                            hash,
		                            space,
		                            ign,
		                            pad,
		                            cA,
		                            cont)
		                         : caml_exact_trampoline_cps_call$0
		                           (invalid_format_without,
		                            str_ind$0 - 1 | 0,
		                            46,
		                            cst_precision,
		                            cont);
		                }
		                return str_ind$0 === end_ind
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_format_message, end_ind, a, b)
		                        : b(0);
		               }
		               return str_ind === end_ind
		                       ? caml_exact_trampoline_cps_call$1
		                         (invalid_format_message, end_ind, a, b)
		                       : b();
		              }
		              function parse_after_precision
		              (pct_ind,
		               str_ind,
		               end_ind,
		               minus,
		               plus,
		               hash,
		               space,
		               ign,
		               pad,
		               prec,
		               cont){
		               function b(a){
		                function parse_conv(padprec, cont){
		                 return caml_exact_trampoline_cps_call$6
		                         (parse_conversion,
		                          pct_ind,
		                          str_ind + 1 | 0,
		                          end_ind,
		                          plus,
		                          hash,
		                          space,
		                          ign,
		                          pad,
		                          prec,
		                          padprec,
		                          caml_string_get(str, str_ind),
		                          cont);
		                }
		                if(typeof pad !== "number")
		                 return caml_exact_trampoline_cps_call(parse_conv, pad, cont);
		                if(typeof prec === "number" && ! prec)
		                 return caml_exact_trampoline_cps_call(parse_conv, 0, cont);
		                if(minus){
		                 if(typeof prec === "number")
		                  return caml_exact_trampoline_cps_call(parse_conv, cB, cont);
		                 var n = prec[1];
		                 return caml_exact_trampoline_cps_call
		                         (parse_conv, [0, 0, n], cont);
		                }
		                if(typeof prec === "number")
		                 return caml_exact_trampoline_cps_call(parse_conv, cC, cont);
		                var n$0 = prec[1];
		                return caml_exact_trampoline_cps_call
		                        (parse_conv, [0, 1, n$0], cont);
		               }
		               return str_ind === end_ind
		                       ? caml_exact_trampoline_cps_call$1
		                         (invalid_format_message, end_ind, a, b)
		                       : b();
		              }
		              var cst$1 = "' '", cst$0 = "'#'", cst = "'+'";
		              function parse_conversion
		              (pct_ind,
		               str_ind,
		               end_ind,
		               plus,
		               hash,
		               space,
		               ign,
		               pad,
		               prec,
		               padprec,
		               symb,
		               cont){
		               var plus_used = [0, 0];
		               function get_plus(param){plus_used[1] = 1; return plus;}
		               var hash_used = [0, 0];
		               function get_hash(param){hash_used[1] = 1; return hash;}
		               var space_used = [0, 0];
		               function get_space(param){space_used[1] = 1; return space;}
		               var ign_used = [0, 0];
		               function get_ign(param){ign_used[1] = 1; return ign;}
		               var pad_used = [0, 0];
		               function get_pad(param){pad_used[1] = 1; return pad;}
		               var prec_used = [0, 0];
		               function get_prec(param){prec_used[1] = 1; return prec;}
		               function get_padprec(param){pad_used[1] = 1; return padprec;}
		               function get_int_pad(a, cont){
		                var pad = get_pad(), a = get_prec();
		                if(typeof a === "number" && ! a) return cont(pad);
		                if(typeof pad === "number") return cont(0);
		                if(0 !== pad[0])
		                 return 2 <= pad[1]
		                         ? legacy_behavior$0
		                           ? cont(cD)
		                           : caml_exact_trampoline_cps_call$2
		                             (incompatible_flag,
		                              pct_ind,
		                              str_ind,
		                              48,
		                              cst_precision,
		                              cont)
		                         : cont(pad);
		                if(2 > pad[1]) return cont(pad);
		                var n = pad[2];
		                return legacy_behavior$0
		                        ? cont([0, 1, n])
		                        : caml_exact_trampoline_cps_call$2
		                          (incompatible_flag,
		                           pct_ind,
		                           str_ind,
		                           48,
		                           cst_precision,
		                           cont);
		               }
		               function check_no_0(symb, pad, cont){
		                if(typeof pad === "number") return cont(pad);
		                if(0 !== pad[0])
		                 return 2 <= pad[1]
		                         ? legacy_behavior$0
		                           ? cont(cE)
		                           : caml_exact_trampoline_cps_call$2
		                             (incompatible_flag, pct_ind, str_ind, symb, cst_0, cont)
		                         : cont(pad);
		                if(2 > pad[1]) return cont(pad);
		                var width = pad[2];
		                return legacy_behavior$0
		                        ? cont([0, 1, width])
		                        : caml_exact_trampoline_cps_call$2
		                          (incompatible_flag, pct_ind, str_ind, symb, cst_0, cont);
		               }
		               var cst$2 = "'*'";
		               function opt_of_pad(c, pad, cont){
		                if(typeof pad === "number") return cont(0);
		                if(0 === pad[0])
		                 switch(pad[1]){
		                   case 0:
		                    var width = pad[2];
		                    return legacy_behavior$0
		                            ? cont([0, width])
		                            : caml_exact_trampoline_cps_call$2
		                              (incompatible_flag, pct_ind, str_ind, c, "'-'", cont);
		                   case 1:
		                    var width$0 = pad[2]; return cont([0, width$0]);
		                   default:
		                    var width$1 = pad[2];
		                    return legacy_behavior$0
		                            ? cont([0, width$1])
		                            : caml_exact_trampoline_cps_call$2
		                              (incompatible_flag, pct_ind, str_ind, c, "'0'", cont);
		                 }
		                return caml_exact_trampoline_cps_call$2
		                        (incompatible_flag, pct_ind, str_ind, c, cst$2, cont);
		               }
		               function get_pad_opt(c, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (opt_of_pad, c, get_pad(), cont);
		               }
		               function get_padprec_opt(c, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (opt_of_pad, c, get_padprec(), cont);
		               }
		               function a(fmt_result){
		                function a(b){
		                 b = 1 - ign_used[1];
		                 var ign$0 = b ? ign : b;
		                 function a(a){return cont(fmt_result);}
		                 if(! ign$0) return a();
		                 a:
		                 {
		                  if(38 <= symb){
		                   if(44 !== symb && 64 !== symb) break a;
		                  }
		                  else if(33 !== symb && 37 > symb) break a;
		                  if(legacy_behavior$0) return a();
		                 }
		                 return caml_exact_trampoline_cps_call$2
		                         (incompatible_flag, pct_ind, str_ind, symb, "'_'", a);
		                }
		                if(! (1 - legacy_behavior$0)) return a(0);
		                var b = 1 - plus_used[1], plus$0 = b ? plus : b;
		                function c(b){
		                 b = 1 - hash_used[1];
		                 var hash$0 = b ? hash : b;
		                 function c(b){
		                  b = 1 - space_used[1];
		                  var space$0 = b ? space : b;
		                  function c(b){
		                   b = 1 - pad_used[1];
		                   b = b ? caml_notequal([0, pad], cG) : b;
		                   function c(b){
		                    b = 1 - prec_used[1];
		                    b = b ? caml_notequal([0, prec], cH) : b;
		                    function c(b){
		                     var plus$0 = ign ? plus : ign;
		                     return plus$0
		                             ? caml_exact_trampoline_cps_call$2
		                               (incompatible_flag, pct_ind, str_ind, 95, cst, a)
		                             : a(0);
		                    }
		                    if(! b) return c();
		                    b = ign ? 95 : symb;
		                    return caml_exact_trampoline_cps_call$2
		                            (incompatible_flag, pct_ind, str_ind, b, "`precision'", c);
		                   }
		                   return b
		                           ? caml_exact_trampoline_cps_call$2
		                             (incompatible_flag, pct_ind, str_ind, symb, "`padding'", c)
		                           : c(0);
		                  }
		                  return space$0
		                          ? caml_exact_trampoline_cps_call$2
		                            (incompatible_flag, pct_ind, str_ind, symb, cst$1, c)
		                          : c(0);
		                 }
		                 return hash$0
		                         ? caml_exact_trampoline_cps_call$2
		                           (incompatible_flag, pct_ind, str_ind, symb, cst$0, c)
		                         : c(0);
		                }
		                return plus$0
		                        ? caml_exact_trampoline_cps_call$2
		                          (incompatible_flag, pct_ind, str_ind, symb, cst, c)
		                        : c(0);
		               }
		               if(124 > symb)
		                switch(symb){
		                  case 33:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1];
		                             return a([0, [10, fmt_rest]]);
		                            });
		                  case 40:
		                   return caml_exact_trampoline_cps_call$0
		                           (search_subformat_end,
		                            str_ind,
		                            end_ind,
		                            41,
		                            function(sub_end){
		                             return caml_exact_trampoline_cps_call$1
		                                     (parse,
		                                      sub_end + 2 | 0,
		                                      end_ind,
		                                      function(match){
		                                       var fmt_rest = match[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (parse,
		        str_ind,
		        sub_end,
		        function(match){
		         var sub_fmt = match[1], sub_fmtty = fmtty_of_fmt(sub_fmt);
		         return get_ign()
		                 ? caml_exact_trampoline_cps_call
		                   (get_pad_opt,
		                    95,
		                    function(b){
		                     var ignored = [9, b, sub_fmtty];
		                     return a([0, [23, ignored, fmt_rest]]);
		                    })
		                 : caml_exact_trampoline_cps_call
		                   (get_pad_opt,
		                    40,
		                    function(b){return a([0, [14, b, sub_fmtty, fmt_rest]]);});
		        });
		                                      });
		                            });
		                  case 44:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse, str_ind, end_ind, a);
		                  case 67:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1];
		                             return get_ign()
		                                     ? a([0, [23, 1, fmt_rest]])
		                                     : a([0, [1, fmt_rest]]);
		                            });
		                  case 78:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1], counter = 2;
		                             if(! get_ign()) return a([0, [21, counter, fmt_rest]]);
		                             return a([0, [23, [11, counter], fmt_rest]]);
		                            });
		                  case 83:
		                   return caml_exact_trampoline_cps_call$1
		                           (check_no_0,
		                            symb,
		                            get_padprec(),
		                            function(pad){
		                             return caml_exact_trampoline_cps_call$1
		                                     (parse,
		                                      str_ind,
		                                      end_ind,
		                                      function(b){
		                                       var fmt_rest = b[1];
		                                       if(get_ign())
		return caml_exact_trampoline_cps_call
		        (get_padprec_opt,
		         95,
		         function(b){
		          var ignored = [1, b];
		          return a([0, [23, ignored, fmt_rest]]);
		         });
		                                       b = make_padding_fmt_ebb(pad, fmt_rest);
		                                       var fmt_rest$0 = b[2], pad$0 = b[1];
		                                       return a([0, [3, pad$0, fmt_rest$0]]);
		                                      });
		                            });
		                  case 91:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse_char_set,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var char_set = match[2], next_ind = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (parse,
		                                      next_ind,
		                                      end_ind,
		                                      function(match){
		                                       var fmt_rest = match[1];
		                                       return get_ign()
		       ? caml_exact_trampoline_cps_call
		         (get_pad_opt,
		          95,
		          function(b){
		           var ignored = [10, b, char_set];
		           return a([0, [23, ignored, fmt_rest]]);
		          })
		       : caml_exact_trampoline_cps_call
		         (get_pad_opt,
		          91,
		          function(b){return a([0, [20, b, char_set, fmt_rest]]);});
		                                      });
		                            });
		                  case 97:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1];
		                             return a([0, [15, fmt_rest]]);
		                            });
		                  case 99:
		                   var
		                    char_format =
		                      function(fmt_rest){
		                       return get_ign()
		                               ? [0, [23, 0, fmt_rest]]
		                               : [0, [0, fmt_rest]];
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1];
		                             return caml_exact_trampoline_cps_call
		                                     (get_pad_opt,
		                                      99,
		                                      function(match){
		                                       if(! match) return a(char_format(fmt_rest));
		                                       var n = match[1];
		                                       return 0 === n
		       ? get_ign
		          ()
		         ? a([0, [23, 3, fmt_rest]])
		         : a([0, [22, fmt_rest]])
		       : legacy_behavior$0
		         ? a(char_format(fmt_rest))
		         : caml_exact_trampoline_cps_call$1
		           (invalid_format_message,
		            str_ind,
		            "non-zero widths are unsupported for %c conversions",
		            a);
		                                      });
		                            });
		                  case 114:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1];
		                             return get_ign()
		                                     ? a([0, [23, 2, fmt_rest]])
		                                     : a([0, [19, fmt_rest]]);
		                            });
		                  case 115:
		                   return caml_exact_trampoline_cps_call$1
		                           (check_no_0,
		                            symb,
		                            get_padprec(),
		                            function(pad){
		                             return caml_exact_trampoline_cps_call$1
		                                     (parse,
		                                      str_ind,
		                                      end_ind,
		                                      function(b){
		                                       var fmt_rest = b[1];
		                                       if(get_ign())
		return caml_exact_trampoline_cps_call
		        (get_padprec_opt,
		         95,
		         function(b){
		          var ignored = [0, b];
		          return a([0, [23, ignored, fmt_rest]]);
		         });
		                                       b = make_padding_fmt_ebb(pad, fmt_rest);
		                                       var fmt_rest$0 = b[2], pad$0 = b[1];
		                                       return a([0, [2, pad$0, fmt_rest$0]]);
		                                      });
		                            });
		                  case 116:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1];
		                             return a([0, [16, fmt_rest]]);
		                            });
		                  case 123:
		                   return caml_exact_trampoline_cps_call$0
		                           (search_subformat_end,
		                            str_ind,
		                            end_ind,
		                            125,
		                            function(sub_end){
		                             return caml_exact_trampoline_cps_call$1
		                                     (parse,
		                                      str_ind,
		                                      sub_end,
		                                      function(match){
		                                       var sub_fmt = match[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (parse,
		        sub_end + 2 | 0,
		        end_ind,
		        function(match){
		         var fmt_rest = match[1], sub_fmtty = fmtty_of_fmt(sub_fmt);
		         return get_ign()
		                 ? caml_exact_trampoline_cps_call
		                   (get_pad_opt,
		                    95,
		                    function(b){
		                     var ignored = [8, b, sub_fmtty];
		                     return a([0, [23, ignored, fmt_rest]]);
		                    })
		                 : caml_exact_trampoline_cps_call
		                   (get_pad_opt,
		                    123,
		                    function(b){return a([0, [13, b, sub_fmtty, fmt_rest]]);});
		        });
		                                      });
		                            });
		                  case 66:
		                  case 98:
		                   return caml_exact_trampoline_cps_call$1
		                           (check_no_0,
		                            symb,
		                            get_padprec(),
		                            function(pad){
		                             return caml_exact_trampoline_cps_call$1
		                                     (parse,
		                                      str_ind,
		                                      end_ind,
		                                      function(b){
		                                       var fmt_rest = b[1];
		                                       if(get_ign())
		return caml_exact_trampoline_cps_call
		        (get_padprec_opt,
		         95,
		         function(b){
		          var ignored = [7, b];
		          return a([0, [23, ignored, fmt_rest]]);
		         });
		                                       b = make_padding_fmt_ebb(pad, fmt_rest);
		                                       var fmt_rest$0 = b[2], pad$0 = b[1];
		                                       return a([0, [9, pad$0, fmt_rest$0]]);
		                                      });
		                            });
		                  case 37:
		                  case 64:
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var fmt_rest = match[1];
		                             return a([0, [12, symb, fmt_rest]]);
		                            });
		                  case 76:
		                  case 108:
		                  case 110:
		                   if(str_ind !== end_ind){
		                    var
		                     symb$0 = caml_string_get(str, str_ind),
		                     b = symb$0 - 88 | 0;
		                    a:
		                    {
		                     if(32 >= b >>> 0)
		                      switch(b){
		                        case 0:
		                        case 12:
		                        case 17:
		                        case 23:
		                        case 29:
		                        case 32:
		                         b = 1; break a;
		                      }
		                     b = 0;
		                    }
		                    if(b) break;
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(b){
		                             var fmt_rest = b[1];
		                             a:
		                             {
		                              if(108 <= symb){
		                               if(111 > symb)
		                                switch(symb - 108 | 0){
		                                  case 0:
		                                   var counter = 0; break a;
		                                  case 2:
		                                   counter = 1; break a;
		                                }
		                              }
		                              else if(76 === symb){counter = 2; break a;}
		                              b = caml_pop_trap();
		                              return b
		                                      (caml_maybe_attach_backtrace([0, Assert_failure, cR], 1));
		                             }
		                             if(! get_ign()) return a([0, [21, counter, fmt_rest]]);
		                             var ignored = [11, counter];
		                             return a([0, [23, ignored, fmt_rest]]);
		                            });
		                  case 32:
		                  case 35:
		                  case 43:
		                  case 45:
		                  case 95:
		                   return caml_exact_trampoline_cps_call
		                           (failwith_message,
		                            cI,
		                            function(b){
		                             return caml_trampoline_cps_call4(b, str, pct_ind, symb, a);
		                            });
		                  case 88:
		                  case 100:
		                  case 105:
		                  case 111:
		                  case 117:
		                  case 120:
		                   b = get_space();
		                   var c = get_hash();
		                   return caml_exact_trampoline_cps_call$7
		                           (compute_int_conv,
		                            pct_ind,
		                            str_ind,
		                            get_plus(),
		                            c,
		                            b,
		                            symb,
		                            function(iconv){
		                             return caml_exact_trampoline_cps_call$1
		                                     (parse,
		                                      str_ind,
		                                      end_ind,
		                                      function(match){
		                                       var fmt_rest = match[1];
		                                       if(get_ign())
		return caml_exact_trampoline_cps_call
		        (get_pad_opt,
		         95,
		         function(b){
		          var ignored = [2, iconv, b];
		          return a([0, [23, ignored, fmt_rest]]);
		         });
		                                       var b = get_prec();
		                                       return caml_exact_trampoline_cps_call
		       (get_int_pad,
		        dummy,
		        function(c){
		         c = make_padprec_fmt_ebb(c, b, fmt_rest);
		         var fmt_rest$0 = c[3], prec = c[2], pad = c[1];
		         return a([0, [4, iconv, pad, prec, fmt_rest$0]]);
		        });
		                                      });
		                            });
		                  case 69:
		                  case 70:
		                  case 71:
		                  case 72:
		                  case 101:
		                  case 102:
		                  case 103:
		                  case 104:
		                   var
		                    space$0 = get_space(),
		                    hash$0 = get_hash(),
		                    plus$0 = get_plus(),
		                    e =
		                      function(flag){
		                       a:
		                       {
		                        if(73 <= symb){
		                         var b = symb - 101 | 0;
		                         if(3 >= b >>> 0)
		                          switch(b){
		                            case 0:
		                             var kind = 1; break a;
		                            case 1:
		                             kind = 0; break a;
		                            case 2:
		                             kind = 3; break a;
		                            default: kind = 6; break a;
		                          }
		                        }
		                        else if(69 <= symb)
		                         switch(symb - 69 | 0){
		                           case 0:
		                            kind = 2; break a;
		                           case 2:
		                            kind = 4; break a;
		                           case 3:
		                            kind = 7; break a;
		                         }
		                        if(hash$0){
		                         if(70 === symb){kind = 8; break a;}
		                        }
		                        else if(70 === symb){kind = 5; break a;}
		                        b = caml_pop_trap();
		                        return b
		                                (caml_maybe_attach_backtrace([0, Assert_failure, cT], 1));
		                       }
		                       var fconv = [0, flag, kind];
		                       return caml_exact_trampoline_cps_call$1
		                               (parse,
		                                str_ind,
		                                end_ind,
		                                function(b){
		                                 var fmt_rest = b[1];
		                                 if(! get_ign()){
		                                  b = get_prec();
		                                  b = make_padprec_fmt_ebb(get_pad(), b, fmt_rest);
		                                  var fmt_rest$0 = b[3], prec = b[2], pad = b[1];
		                                  return a([0, [8, fconv, pad, prec, fmt_rest$0]]);
		                                 }
		                                 b = get_prec();
		                                 function c(b){
		                                  return caml_exact_trampoline_cps_call
		  (get_pad_opt,
		   95,
		   function(c){
		    var ignored = [6, c, b];
		    return a([0, [23, ignored, fmt_rest]]);
		   });
		                                 }
		                                 if(typeof b === "number")
		                                  return b
		  ? caml_exact_trampoline_cps_call$2
		    (incompatible_flag, pct_ind, str_ind, 95, cst$2, c)
		  : c(0);
		                                 var ndec = b[1];
		                                 return c([0, ndec]);
		                                });
		                      };
		                   return plus$0
		                           ? space$0
		                             ? legacy_behavior$0
		                               ? e(1)
		                               : caml_exact_trampoline_cps_call$2
		                                 (incompatible_flag, pct_ind, str_ind, 32, cst, e)
		                             : e(1)
		                           : space$0 ? e(2) : e(0);
		                }
		               if(108 <= symb){
		                if(111 > symb)
		                 switch(symb - 108 | 0){
		                   case 0:
		                    b = caml_string_get(str, str_ind);
		                    c = get_space();
		                    var d = get_hash();
		                    return caml_exact_trampoline_cps_call$7
		                            (compute_int_conv,
		                             pct_ind,
		                             str_ind + 1 | 0,
		                             get_plus(),
		                             d,
		                             c,
		                             b,
		                             function(iconv){
		                              return caml_exact_trampoline_cps_call$1
		                                      (parse,
		                                       str_ind + 1 | 0,
		                                       end_ind,
		                                       function(match){
		var fmt_rest = match[1];
		if(get_ign())
		 return caml_exact_trampoline_cps_call
		         (get_pad_opt,
		          95,
		          function(b){
		           var ignored = [3, iconv, b];
		           return a([0, [23, ignored, fmt_rest]]);
		          });
		var b = get_prec();
		return caml_exact_trampoline_cps_call
		        (get_int_pad,
		         dummy,
		         function(c){
		          c = make_padprec_fmt_ebb(c, b, fmt_rest);
		          var fmt_rest$0 = c[3], prec = c[2], pad = c[1];
		          return a([0, [5, iconv, pad, prec, fmt_rest$0]]);
		         });
		                                       });
		                             });
		                   case 2:
		                    d = caml_string_get(str, str_ind);
		                    b = get_space();
		                    c = get_hash();
		                    return caml_exact_trampoline_cps_call$7
		                            (compute_int_conv,
		                             pct_ind,
		                             str_ind + 1 | 0,
		                             get_plus(),
		                             c,
		                             b,
		                             d,
		                             function(iconv){
		                              return caml_exact_trampoline_cps_call$1
		                                      (parse,
		                                       str_ind + 1 | 0,
		                                       end_ind,
		                                       function(match){
		var fmt_rest = match[1];
		if(get_ign())
		 return caml_exact_trampoline_cps_call
		         (get_pad_opt,
		          95,
		          function(b){
		           var ignored = [4, iconv, b];
		           return a([0, [23, ignored, fmt_rest]]);
		          });
		var b = get_prec();
		return caml_exact_trampoline_cps_call
		        (get_int_pad,
		         dummy,
		         function(c){
		          c = make_padprec_fmt_ebb(c, b, fmt_rest);
		          var fmt_rest$0 = c[3], prec = c[2], pad = c[1];
		          return a([0, [6, iconv, pad, prec, fmt_rest$0]]);
		         });
		                                       });
		                             });
		                 }
		               }
		               else if(76 === symb){
		                c = caml_string_get(str, str_ind);
		                d = get_space();
		                b = get_hash();
		                return caml_exact_trampoline_cps_call$7
		                        (compute_int_conv,
		                         pct_ind,
		                         str_ind + 1 | 0,
		                         get_plus(),
		                         b,
		                         d,
		                         c,
		                         function(iconv){
		                          return caml_exact_trampoline_cps_call$1
		                                  (parse,
		                                   str_ind + 1 | 0,
		                                   end_ind,
		                                   function(match){
		                                    var fmt_rest = match[1];
		                                    if(get_ign())
		                                     return caml_exact_trampoline_cps_call
		     (get_pad_opt,
		      95,
		      function(b){
		       var ignored = [5, iconv, b];
		       return a([0, [23, ignored, fmt_rest]]);
		      });
		                                    var b = get_prec();
		                                    return caml_exact_trampoline_cps_call
		    (get_int_pad,
		     dummy,
		     function(c){
		      c = make_padprec_fmt_ebb(c, b, fmt_rest);
		      var fmt_rest$0 = c[3], prec = c[2], pad = c[1];
		      return a([0, [7, iconv, pad, prec, fmt_rest$0]]);
		     });
		                                   });
		                         });
		               }
		               var f = str_ind - 1 | 0;
		               return caml_exact_trampoline_cps_call
		                       (failwith_message,
		                        cF,
		                        function(b){
		                         return caml_trampoline_cps_call4(b, str, f, symb, a);
		                        });
		              }
		              function parse_after_at(str_ind, end_ind, cont){
		               if(str_ind === end_ind) return cont(cJ);
		               var c = caml_string_get(str, str_ind);
		               if(65 <= c){
		                if(94 <= c){
		                 var a = c - 123 | 0;
		                 if(2 >= a >>> 0)
		                  switch(a){
		                    case 0:
		                     return caml_exact_trampoline_cps_call$0
		                             (parse_tag, 1, str_ind + 1 | 0, end_ind, cont);
		                    case 2:
		                     return caml_exact_trampoline_cps_call$1
		                             (parse,
		                              str_ind + 1 | 0,
		                              end_ind,
		                              function(match){
		                               var fmt_rest = match[1];
		                               return cont([0, [17, 1, fmt_rest]]);
		                              });
		                  }
		                }
		                else if(91 <= c)
		                 switch(c - 91 | 0){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$0
		                            (parse_tag, 0, str_ind + 1 | 0, end_ind, cont);
		                   case 2:
		                    return caml_exact_trampoline_cps_call$1
		                            (parse,
		                             str_ind + 1 | 0,
		                             end_ind,
		                             function(match){
		                              var fmt_rest = match[1];
		                              return cont([0, [17, 0, fmt_rest]]);
		                             });
		                 }
		               }
		               else {
		                if(10 === c)
		                 return caml_exact_trampoline_cps_call$1
		                         (parse,
		                          str_ind + 1 | 0,
		                          end_ind,
		                          function(match){
		                           var fmt_rest = match[1];
		                           return cont([0, [17, 3, fmt_rest]]);
		                          });
		                if(32 <= c)
		                 switch(c - 32 | 0){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (parse,
		                             str_ind + 1 | 0,
		                             end_ind,
		                             function(match){
		                              var fmt_rest = match[1];
		                              return cont([0, [17, cK, fmt_rest]]);
		                             });
		                   case 5:
		                    if
		                     ((str_ind + 1 | 0) < end_ind
		                      && 37 === caml_string_get(str, str_ind + 1 | 0))
		                     return caml_exact_trampoline_cps_call$1
		                             (parse,
		                              str_ind + 2 | 0,
		                              end_ind,
		                              function(match){
		                               var fmt_rest = match[1];
		                               return cont([0, [17, 6, fmt_rest]]);
		                              });
		                    return caml_exact_trampoline_cps_call$1
		                            (parse,
		                             str_ind,
		                             end_ind,
		                             function(match){
		                              var fmt_rest = match[1];
		                              return cont([0, [12, 64, fmt_rest]]);
		                             });
		                   case 12:
		                    return caml_exact_trampoline_cps_call$1
		                            (parse,
		                             str_ind + 1 | 0,
		                             end_ind,
		                             function(match){
		                              var fmt_rest = match[1];
		                              return cont([0, [17, cL, fmt_rest]]);
		                             });
		                   case 14:
		                    return caml_exact_trampoline_cps_call$1
		                            (parse,
		                             str_ind + 1 | 0,
		                             end_ind,
		                             function(match){
		                              var fmt_rest = match[1];
		                              return cont([0, [17, 4, fmt_rest]]);
		                             });
		                   case 27:
		                    var
		                     str_ind$0 = str_ind + 1 | 0,
		                     b =
		                       function(next_ind, formatting_lit){
		                        return caml_exact_trampoline_cps_call$1
		                                (parse,
		                                 next_ind,
		                                 end_ind,
		                                 function(match){
		                                  var fmt_rest = match[1];
		                                  return cont([0, [17, formatting_lit, fmt_rest]]);
		                                 });
		                       };
		                    caml_push_trap
		                     (function(exn){
		                       if(exn === Not_found) return b(str_ind$0, formatting_lit);
		                       if(exn[1] === Failure) return b(str_ind$0, formatting_lit);
		                       var
		                        raise = caml_pop_trap(),
		                        exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                       return raise(exn$0);
		                      });
		                    a = str_ind$0 === end_ind;
		                    a ||= 60 !== caml_string_get(str, str_ind$0);
		                    if(! a)
		                     return caml_exact_trampoline_cps_call$1
		                             (parse_spaces,
		                              str_ind$0 + 1 | 0,
		                              end_ind,
		                              function(str_ind_1){
		                               var a = caml_string_get(str, str_ind_1);
		                               a:
		                               {
		                                if(48 <= a){if(58 <= a) break a;} else if(45 !== a) break a;
		                                return caml_exact_trampoline_cps_call$1
		(parse_integer,
		 str_ind_1,
		 end_ind,
		 function(match){
		  var width = match[2], str_ind_2 = match[1];
		  return caml_exact_trampoline_cps_call$1
		          (parse_spaces,
		           str_ind_2,
		           end_ind,
		           function(str_ind_3){
		            var a = caml_string_get(str, str_ind_3) - 45 | 0;
		            if(12 < a >>> 0){
		             if(17 === a)
		              return caml_exact_trampoline_cps_call$0
		                      (get_sub,
		                       str,
		                       str_ind$0 - 2 | 0,
		                       (str_ind_3 - str_ind$0 | 0) + 3 | 0,
		                       function(s){
		                        caml_pop_trap();
		                        return b(str_ind_3 + 1 | 0, [0, s, width, 0]);
		                       });
		            }
		            else if(1 < a - 1 >>> 0)
		             return caml_exact_trampoline_cps_call$1
		                     (parse_integer,
		                      str_ind_3,
		                      end_ind,
		                      function(match){
		                       var offset = match[2], str_ind_4 = match[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (parse_spaces,
		                                str_ind_4,
		                                end_ind,
		                                function(str_ind_5){
		                                 if(62 === caml_string_get(str, str_ind_5))
		                                  return caml_exact_trampoline_cps_call$0
		  (get_sub,
		   str,
		   str_ind$0 - 2 | 0,
		   (str_ind_5 - str_ind$0 | 0) + 3 | 0,
		   function(s){
		    caml_pop_trap();
		    return b(str_ind_5 + 1 | 0, [0, s, width, offset]);
		   });
		                                 var
		                                  raise = caml_pop_trap(),
		                                  Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                                 return raise(Not_found$0);
		                                });
		                      });
		            a = caml_pop_trap();
		            var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		            return a(Not_found$0);
		           });
		 });
		                               }
		                               a = caml_pop_trap();
		                               var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                               return a(Not_found$0);
		                              });
		                    a = caml_pop_trap();
		                    var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                    return a(Not_found$0);
		                   case 28:
		                    var
		                     str_ind$1 = str_ind + 1 | 0,
		                     d =
		                       function(a){
		                        if(! a)
		                         return caml_exact_trampoline_cps_call$1
		                                 (parse,
		                                  str_ind$1,
		                                  end_ind,
		                                  function(match){
		                                   var fmt_rest = match[1];
		                                   return cont([0, [17, cM, fmt_rest]]);
		                                  });
		                        a = a[1];
		                        var formatting_lit = a[2], next_ind = a[1];
		                        return caml_exact_trampoline_cps_call$1
		                                (parse,
		                                 next_ind,
		                                 end_ind,
		                                 function(match){
		                                  var fmt_rest = match[1];
		                                  return cont([0, [17, formatting_lit, fmt_rest]]);
		                                 });
		                       };
		                    caml_push_trap
		                     (function(exn){
		                       if(exn !== Not_found && exn[1] !== Failure){
		                        var
		                         raise = caml_pop_trap(),
		                         exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                        return raise(exn$0);
		                       }
		                       return d(0);
		                      });
		                    return caml_exact_trampoline_cps_call$1
		                            (parse_spaces,
		                             str_ind$1,
		                             end_ind,
		                             function(str_ind_1){
		                              var match = caml_string_get(str, str_ind_1);
		                              function a(a){caml_pop_trap(); return d(a);}
		                              a:
		                              {
		                               if(48 <= match){
		                                if(58 <= match) break a;
		                               }
		                               else if(45 !== match) break a;
		                               return caml_exact_trampoline_cps_call$1
		                                       (parse_integer,
		str_ind_1,
		end_ind,
		function(match){
		 var size = match[2], str_ind_2 = match[1];
		 return caml_exact_trampoline_cps_call$1
		         (parse_spaces,
		          str_ind_2,
		          end_ind,
		          function(str_ind_3){
		           if(62 === caml_string_get(str, str_ind_3))
		            return caml_exact_trampoline_cps_call$0
		                    (get_sub,
		                     str,
		                     str_ind$1 - 2 | 0,
		                     (str_ind_3 - str_ind$1 | 0) + 3 | 0,
		                     function(s){
		                      return a([0, [0, str_ind_3 + 1 | 0, [1, s, size]]]);
		                     });
		           var
		            raise = caml_pop_trap(),
		            Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		           return raise(Not_found$0);
		          });
		});
		                              }
		                              return a(0);
		                             });
		                   case 31:
		                    return caml_exact_trampoline_cps_call$1
		                            (parse,
		                             str_ind + 1 | 0,
		                             end_ind,
		                             function(match){
		                              var fmt_rest = match[1];
		                              return cont([0, [17, 2, fmt_rest]]);
		                             });
		                   case 32:
		                    return caml_exact_trampoline_cps_call$1
		                            (parse,
		                             str_ind + 1 | 0,
		                             end_ind,
		                             function(match){
		                              var fmt_rest = match[1];
		                              return cont([0, [17, 5, fmt_rest]]);
		                             });
		                 }
		               }
		               return caml_exact_trampoline_cps_call$1
		                       (parse,
		                        str_ind + 1 | 0,
		                        end_ind,
		                        function(match){
		                         var fmt_rest = match[1];
		                         return cont([0, [17, [2, c], fmt_rest]]);
		                        });
		              }
		              function parse_tag(is_open_tag, str_ind, end_ind, cont){
		               caml_push_trap
		                (function(exn){
		                  if(exn === Not_found)
		                   return caml_exact_trampoline_cps_call$1
		                           (parse,
		                            str_ind,
		                            end_ind,
		                            function(match){
		                             var
		                              fmt_rest = match[1],
		                              formatting = is_open_tag ? [0, sub_format] : [1, sub_format];
		                             return cont([0, [18, formatting, fmt_rest]]);
		                            });
		                  var
		                   raise = caml_pop_trap(),
		                   exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                  return raise(exn$0);
		                 });
		               if(str_ind === end_ind){
		                var
		                 a = caml_pop_trap(),
		                 Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                return a(Not_found$0);
		               }
		               if(60 === caml_string_get(str, str_ind))
		                return caml_exact_trampoline_cps_call$0
		                        (index_from,
		                         str,
		                         str_ind + 1 | 0,
		                         62,
		                         function(ind){
		                          if(end_ind > ind)
		                           return caml_exact_trampoline_cps_call$0
		                                   (get_sub,
		                                    str,
		                                    str_ind,
		                                    (ind - str_ind | 0) + 1 | 0,
		                                    function(sub_str){
		                                     return caml_exact_trampoline_cps_call$1
		     (parse,
		      ind + 1 | 0,
		      end_ind,
		      function(match){
		       var fmt_rest = match[1];
		       return caml_exact_trampoline_cps_call$1
		               (parse,
		                str_ind,
		                ind + 1 | 0,
		                function(match){
		                 var
		                  sub_fmt = match[1],
		                  sub_format = [0, sub_fmt, sub_str],
		                  formatting = is_open_tag ? [0, sub_format] : [1, sub_format];
		                 caml_pop_trap();
		                 return cont([0, [18, formatting, fmt_rest]]);
		                });
		      });
		                                    });
		                          var
		                           raise = caml_pop_trap(),
		                           Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                          return raise(Not_found$0);
		                         });
		               a = caml_pop_trap();
		               var Not_found$1 = caml_maybe_attach_backtrace(Not_found, 1);
		               return a(Not_found$1);
		              }
		              function parse_char_set(str_ind, end_ind, cont){
		               function b(c){
		                var char_set = create_char_set();
		                function add_range(c$0, c, cont){
		                 function b(i){
		                  return caml_exact_trampoline_cps_call
		                          (char_of_int,
		                           i,
		                           function(d){
		                            return caml_exact_trampoline_cps_call$1
		                                    (add_in_char_set,
		                                     char_set,
		                                     d,
		                                     function(d){
		                                      d = i + 1 | 0;
		                                      return c !== i ? caml_exact_trampoline_call1(b, d) : a();
		                                     });
		                           });
		                 }
		                 function a(){return cont();}
		                 return c < c$0 ? a() : b(c$0);
		                }
		                function fail_single_percent(str_ind, cont){
		                 return caml_exact_trampoline_cps_call
		                         (failwith_message,
		                          cN,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, str, str_ind, cont);
		                          });
		                }
		                function parse_char_set_content(str_ind, end_ind, cont){
		                 function b(str_ind){
		                  function c(a){
		                   var c = caml_string_get(str, str_ind);
		                   return 45 === c
		                           ? caml_exact_trampoline_cps_call$1
		                             (add_in_char_set,
		                              char_set,
		                              45,
		                              function(a){
		                               var str_ind$0 = str_ind + 1 | 0;
		                               return caml_exact_trampoline_call1(b, str_ind$0);
		                              })
		                           : 93
		                             === c
		                             ? cont(str_ind + 1 | 0)
		                             : caml_exact_trampoline_cps_call$0
		                               (parse_char_set_after_char,
		                                str_ind + 1 | 0,
		                                end_ind,
		                                c,
		                                cont);
		                  }
		                  return str_ind === end_ind
		                          ? caml_exact_trampoline_cps_call$1
		                            (invalid_format_message, end_ind, a, c)
		                          : c();
		                 }
		                 return b(str_ind);
		                }
		                function parse_char_set_after_char(str_ind, end_ind, c, cont){
		                 function b(str_ind, c){
		                  function d(f){
		                   var c$0 = caml_string_get(str, str_ind);
		                   a:
		                   {
		                    if(46 <= c$0){
		                     if(64 !== c$0){
		                      if(93 === c$0)
		                       return caml_exact_trampoline_cps_call$1
		                               (add_in_char_set,
		                                char_set,
		                                c,
		                                function(a){return cont(str_ind + 1 | 0);});
		                      break a;
		                     }
		                    }
		                    else if(37 !== c$0){
		                     if(45 > c$0) break a;
		                     var
		                      str_ind$0 = str_ind + 1 | 0,
		                      e =
		                        function(d){
		                         var c$0 = caml_string_get(str, str_ind$0);
		                         if(37 !== c$0)
		                          return 93 === c$0
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (add_in_char_set,
		                                     char_set,
		                                     c,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (add_in_char_set,
		       char_set,
		       45,
		       function(a){return cont(str_ind$0 + 1 | 0);});
		                                     })
		                                  : caml_exact_trampoline_cps_call$1
		                                    (add_range,
		                                     c,
		                                     c$0,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (parse_char_set_content, str_ind$0 + 1 | 0, end_ind, cont);
		                                     });
		                         function b(a){
		                          var c$0 = caml_string_get(str, str_ind$0 + 1 | 0);
		                          if(37 !== c$0 && 64 !== c$0)
		                           return caml_exact_trampoline_cps_call
		                                   (fail_single_percent, str_ind$0, cont);
		                          return caml_exact_trampoline_cps_call$1
		                                  (add_range,
		                                   c,
		                                   c$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (parse_char_set_content, str_ind$0 + 2 | 0, end_ind, cont);
		                                   });
		                         }
		                         return (str_ind$0 + 1 | 0) === end_ind
		                                 ? caml_exact_trampoline_cps_call$1
		                                   (invalid_format_message, end_ind, a, b)
		                                 : b();
		                        };
		                     return str_ind$0 === end_ind
		                             ? caml_exact_trampoline_cps_call$1
		                               (invalid_format_message, end_ind, a, e)
		                             : e(0);
		                    }
		                    if(37 === c)
		                     return caml_exact_trampoline_cps_call$1
		                             (add_in_char_set,
		                              char_set,
		                              c$0,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (parse_char_set_content, str_ind + 1 | 0, end_ind, cont);
		                              });
		                   }
		                   function d(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (add_in_char_set,
		                             char_set,
		                             c,
		                             function(a){
		                              var str_ind$0 = str_ind + 1 | 0;
		                              return caml_exact_trampoline_call2(b, str_ind$0, c$0);
		                             });
		                   }
		                   return 37 === c
		                           ? caml_exact_trampoline_cps_call
		                             (fail_single_percent, str_ind, d)
		                           : d();
		                  }
		                  return str_ind === end_ind
		                          ? caml_exact_trampoline_cps_call$1
		                            (invalid_format_message, end_ind, a, d)
		                          : d();
		                 }
		                 return b(str_ind, c);
		                }
		                function b(c){
		                 if(94 === caml_string_get(str, str_ind))
		                  var
		                   str_ind$0 = str_ind + 1 | 0,
		                   reverse = 1,
		                   str_ind$1 = str_ind$0;
		                 else {reverse = 0; str_ind$1 = str_ind;}
		                 function b(a){
		                  var c = caml_string_get(str, str_ind$1);
		                  return caml_exact_trampoline_cps_call$0
		                          (parse_char_set_after_char,
		                           str_ind$1 + 1 | 0,
		                           end_ind,
		                           c,
		                           function(next_ind){
		                            var char_set$0 = to_string(char_set);
		                            function a(a){return cont([0, next_ind, a]);}
		                            if(! reverse) return a(char_set$0);
		                            var char_set$1 = create_char_set();
		                            function b(i){
		                             return caml_exact_trampoline_cps_call
		                                     (char_of_int,
		                                      caml_string_get(char_set$0, i) ^ 255,
		                                      function(c){
		                                       caml_bytes_set(char_set$1, i, c);
		                                       c = i + 1 | 0;
		                                       return 31 !== i
		       ? caml_exact_trampoline_call1(b, c)
		       : a(caml_string_of_bytes(char_set$1));
		                                      });
		                            }
		                            return b(0);
		                           });
		                 }
		                 return str_ind$1 === end_ind
		                         ? caml_exact_trampoline_cps_call$1
		                           (invalid_format_message, end_ind, a, b)
		                         : b();
		                }
		                return str_ind === end_ind
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_format_message, end_ind, a, b)
		                        : b();
		               }
		               return str_ind === end_ind
		                       ? caml_exact_trampoline_cps_call$1
		                         (invalid_format_message, end_ind, a, b)
		                       : b();
		              }
		              function parse_spaces(str_ind, end_ind, cont){
		               function b(str_ind){
		                function c(a){
		                 if(32 !== caml_string_get(str, str_ind))
		                  return cont(str_ind);
		                 var str_ind$0 = str_ind + 1 | 0;
		                 return caml_exact_trampoline_call1(b, str_ind$0);
		                }
		                return str_ind === end_ind
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_format_message, end_ind, a, c)
		                        : c();
		               }
		               return b(str_ind);
		              }
		              function parse_positive(str_ind, end_ind, acc, cont){
		               function b(str_ind, acc){
		                function c(a){
		                 var c = caml_string_get(str, str_ind);
		                 if(9 < c - 48 >>> 0) return cont([0, str_ind, acc]);
		                 var new_acc = (acc * 10 | 0) + (c - 48 | 0) | 0;
		                 if(max_string_length < new_acc)
		                  return caml_exact_trampoline_cps_call
		                          (failwith_message,
		                           cO,
		                           function(a){
		                            return caml_trampoline_cps_call4
		                                    (a, str, new_acc, max_string_length, cont);
		                           });
		                 var str_ind$0 = str_ind + 1 | 0;
		                 return caml_exact_trampoline_call2(b, str_ind$0, new_acc);
		                }
		                return str_ind === end_ind
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_format_message, end_ind, a, c)
		                        : c();
		               }
		               return b(str_ind, acc);
		              }
		              function parse_integer(str_ind, end_ind, cont){
		               function b(b){
		                b = caml_string_get(str, str_ind);
		                if(48 <= b){
		                 if(58 > b)
		                  return caml_exact_trampoline_cps_call$0
		                          (parse_positive, str_ind, end_ind, 0, cont);
		                }
		                else if(45 === b){
		                 var
		                  c =
		                    function(a){
		                     var c = caml_string_get(str, str_ind + 1 | 0);
		                     return 9 < c - 48 >>> 0
		                             ? caml_exact_trampoline_cps_call$0
		                               (expected_character, str_ind + 1 | 0, cst_digit, c, cont)
		                             : caml_exact_trampoline_cps_call$0
		                               (parse_positive,
		                                str_ind + 1 | 0,
		                                end_ind,
		                                0,
		                                function(match){
		                                 var n = match[2], next_ind = match[1];
		                                 return cont([0, next_ind, - n | 0]);
		                                });
		                    };
		                 return (str_ind + 1 | 0) === end_ind
		                         ? caml_exact_trampoline_cps_call$1
		                           (invalid_format_message, end_ind, a, c)
		                         : c(0);
		                }
		                b = caml_pop_trap();
		                return b
		                        (caml_maybe_attach_backtrace([0, Assert_failure, cP], 1));
		               }
		               return str_ind === end_ind
		                       ? caml_exact_trampoline_cps_call$1
		                         (invalid_format_message, end_ind, a, b)
		                       : b(0);
		              }
		              function add_literal(lit_start, str_ind, fmt, cont){
		               var size = str_ind - lit_start | 0;
		               return 0 === size
		                       ? cont([0, fmt])
		                       : 1
		                         === size
		                         ? cont([0, [12, caml_string_get(str, lit_start), fmt]])
		                         : caml_exact_trampoline_cps_call$0
		                           (get_sub,
		                            str,
		                            lit_start,
		                            size,
		                            function(a){return cont([0, [11, a, fmt]]);});
		              }
		              function search_subformat_end(str_ind, end_ind, c, cont){
		               function b(str_ind){
		                function d(e){
		                 if(37 === caml_string_get(str, str_ind)){
		                  var
		                   d =
		                     function(d){
		                      if(caml_string_get(str, str_ind + 1 | 0) === c)
		                       return cont(str_ind);
		                      d = caml_string_get(str, str_ind + 1 | 0);
		                      if(95 <= d){
		                       if(123 <= d){
		                        if(126 > d)
		                         switch(d - 123 | 0){
		                           case 0:
		                            return caml_exact_trampoline_cps_call$0
		                                    (search_subformat_end,
		                                     str_ind + 2 | 0,
		                                     end_ind,
		                                     125,
		                                     function(sub_end){
		                                      var str_ind = sub_end + 2 | 0;
		                                      return caml_exact_trampoline_call1(b, str_ind);
		                                     });
		                           case 2:
		                            return caml_exact_trampoline_cps_call$0
		                                    (expected_character,
		                                     str_ind + 1 | 0,
		                                     "character ')'",
		                                     125,
		                                     cont);
		                         }
		                       }
		                       else if(96 > d){
		                        var
		                         e =
		                           function(a){
		                            a = caml_string_get(str, str_ind + 2 | 0);
		                            if(40 === a)
		                             return caml_exact_trampoline_cps_call$0
		                                     (search_subformat_end,
		                                      str_ind + 3 | 0,
		                                      end_ind,
		                                      41,
		                                      function(sub_end){
		                                       var str_ind = sub_end + 2 | 0;
		                                       return caml_exact_trampoline_call1(b, str_ind);
		                                      });
		                            if(123 === a)
		                             return caml_exact_trampoline_cps_call$0
		                                     (search_subformat_end,
		                                      str_ind + 3 | 0,
		                                      end_ind,
		                                      125,
		                                      function(sub_end){
		                                       var str_ind = sub_end + 2 | 0;
		                                       return caml_exact_trampoline_call1(b, str_ind);
		                                      });
		                            var str_ind$0 = str_ind + 3 | 0;
		                            return caml_exact_trampoline_call1(b, str_ind$0);
		                           };
		                        return (str_ind + 2 | 0) === end_ind
		                                ? caml_exact_trampoline_cps_call$1
		                                  (invalid_format_message, end_ind, a, e)
		                                : e(0);
		                       }
		                      }
		                      else {
		                       if(40 === d)
		                        return caml_exact_trampoline_cps_call$0
		                                (search_subformat_end,
		                                 str_ind + 2 | 0,
		                                 end_ind,
		                                 41,
		                                 function(sub_end){
		                                  var str_ind = sub_end + 2 | 0;
		                                  return caml_exact_trampoline_call1(b, str_ind);
		                                 });
		                       if(41 === d)
		                        return caml_exact_trampoline_cps_call$0
		                                (expected_character,
		                                 str_ind + 1 | 0,
		                                 "character '}'",
		                                 41,
		                                 cont);
		                      }
		                      var str_ind$0 = str_ind + 2 | 0;
		                      return caml_exact_trampoline_call1(b, str_ind$0);
		                     };
		                  return (str_ind + 1 | 0) === end_ind
		                          ? caml_exact_trampoline_cps_call$1
		                            (invalid_format_message, end_ind, a, d)
		                          : d(0);
		                 }
		                 var str_ind$0 = str_ind + 1 | 0;
		                 return caml_exact_trampoline_call1(b, str_ind$0);
		                }
		                return str_ind === end_ind
		                        ? caml_exact_trampoline_cps_call
		                          (failwith_message,
		                           cQ,
		                           function(a){
		                            return caml_trampoline_cps_call4(a, str, c, end_ind, d);
		                           })
		                        : d();
		               }
		               return b(str_ind);
		              }
		              function compute_int_conv
		              (pct_ind, str_ind, plus$0, hash$0, space$0, symb, a){
		               var plus = plus$0, hash = hash$0, space = space$0;
		               for(;;){
		                a:
		                {
		                 if(plus){
		                  if(! hash){
		                   if(space) break a;
		                   if(100 === symb) return a(1);
		                   if(105 === symb) return a(4);
		                   break a;
		                  }
		                 }
		                 else {
		                  if(! hash){
		                   if(space){
		                    if(100 === symb) return a(2);
		                    if(105 === symb) return a(5);
		                    break a;
		                   }
		                   var b = symb - 88 | 0;
		                   if(32 < b >>> 0) break a;
		                   switch(b){
		                     case 0:
		                      return a(8);
		                     case 12:
		                      return a(0);
		                     case 17:
		                      return a(3);
		                     case 23:
		                      return a(10);
		                     case 29:
		                      return a(12);
		                     case 32:
		                      return a(6);
		                     default: break a;
		                   }
		                  }
		                  if(! space){
		                   b = symb - 88 | 0;
		                   if(32 >= b >>> 0)
		                    switch(b){
		                      case 0:
		                       return a(9);
		                      case 12:
		                       return a(13);
		                      case 17:
		                       return a(14);
		                      case 23:
		                       return a(11);
		                      case 29:
		                       return a(15);
		                      case 32:
		                       return a(7);
		                    }
		                  }
		                 }
		                 b = symb - 88 | 0;
		                 if(32 >= b >>> 0)
		                  switch(b){
		                    case 0:
		                     if(legacy_behavior$0) return a(9); break;
		                    case 23:
		                     if(legacy_behavior$0) return a(11); break;
		                    case 32:
		                     if(legacy_behavior$0) return a(7); break;
		                    case 12:
		                    case 17:
		                    case 29:
		                     if(! legacy_behavior$0)
		                      return caml_exact_trampoline_cps_call$2
		                              (incompatible_flag, pct_ind, str_ind, symb, cst$0, a);
		                     hash = 0;
		                     continue;
		                  }
		                }
		                if(plus)
		                 if(space){
		                  if(! legacy_behavior$0)
		                   return caml_exact_trampoline_cps_call$2
		                           (incompatible_flag, pct_ind, str_ind, 32, cst, a);
		                  space = 0;
		                 }
		                 else {
		                  if(! legacy_behavior$0)
		                   return caml_exact_trampoline_cps_call$2
		                           (incompatible_flag, pct_ind, str_ind, symb, cst, a);
		                  plus = 0;
		                 }
		                else {
		                 if(! space){
		                  a = caml_pop_trap();
		                  return a
		                          (caml_maybe_attach_backtrace([0, Assert_failure, cS], 1));
		                 }
		                 if(! legacy_behavior$0)
		                  return caml_exact_trampoline_cps_call$2
		                          (incompatible_flag, pct_ind, str_ind, symb, cst$1, a);
		                 space = 0;
		                }
		               }
		              }
		              function incompatible_flag(pct_ind, str_ind, symb, option, cont){
		               return caml_exact_trampoline_cps_call$0
		                       (get_sub,
		                        str,
		                        pct_ind,
		                        str_ind - pct_ind | 0,
		                        function(subfmt){
		                         return caml_exact_trampoline_cps_call
		                                 (failwith_message,
		                                  cU,
		                                  function(a){
		                                   return caml_trampoline_cps_call6
		   (a, str, pct_ind, option, symb, subfmt, cont);
		                                  });
		                        });
		              }
		              return caml_exact_trampoline_cps_call$1
		                      (parse, 0, caml_ml_string_length(str), cont);
		             }
		             function fprintf(oc, fmt$0, cont){
		              var fmt = fmt$0[1];
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf,
		                       function(acc, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (output_acc, oc, acc, function(a){return cont(0);});
		                       },
		                       0,
		                       fmt,
		                       cont);
		             }
		             function bprintf(b, fmt$0, cont){
		              var fmt = fmt$0[1];
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf,
		                       function(acc, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (bufput_acc, b, acc, function(a){return cont(0);});
		                       },
		                       0,
		                       fmt,
		                       cont);
		             }
		             function ksprintf(k, param, cont){
		              var fmt = param[1];
		              function k$0(acc, cont){
		               var buf = create$1(64);
		               return caml_exact_trampoline_cps_call$1
		                       (strput_acc,
		                        buf,
		                        acc,
		                        function(a){
		                         return caml_exact_trampoline_cps_call
		                                 (contents,
		                                  buf,
		                                  function(a){return caml_trampoline_cps_call2(k, a, cont);});
		                        });
		              }
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf, k$0, 0, fmt, cont);
		             }
		             function sprintf(fmt, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (ksprintf, function(s, cont){return cont(s);}, fmt, cont);
		             }
		             var Bad = [248, "Stdlib.Arg.Bad", caml_fresh_oo_id()],
		              Help = [248, "Stdlib.Arg.Help", caml_fresh_oo_id()];
		              [248, "Stdlib.Arg.Stop", caml_fresh_oo_id()];
		             var
		              a = "%S",
		              cst$13 = "_",
		              c6 = [0, [3, 0, 0], a],
		              c7 = [0, [4, 0, 0, 0, 0], cst_d];
		             function field(x, i, cont){
		              var f = x[i + 1];
		              return is_block(f)
		                      ? caml_obj_tag
		                         (f)
		                        === 252
		                        ? caml_exact_trampoline_cps_call
		                          (sprintf,
		                           c6,
		                           function(a){return caml_trampoline_cps_call2(a, f, cont);})
		                        : caml_obj_tag
		                           (f)
		                          === 253
		                          ? cont(string_of_float(f))
		                          : cont(cst$13)
		                      : caml_exact_trampoline_cps_call
		                        (sprintf,
		                         c7,
		                         function(a){return caml_trampoline_cps_call2(a, f, cont);});
		             }
		             var c8 = [0, [11, c, [2, 0, [2, 0, 0]]], ", %s%s"];
		             function other_fields(x, i, cont){
		              return x.length - 1 <= i
		                      ? cont(cst$1)
		                      : caml_exact_trampoline_cps_call$1
		                        (other_fields,
		                         x,
		                         i + 1 | 0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (field,
		                                   x,
		                                   i,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (sprintf,
		     c8,
		     function(c){
		      return caml_trampoline_cps_call3(c, b, a, cont);
		     });
		                                   });
		                         });
		             }
		             var
		              c9 = [0, [12, 40, [2, 0, [2, 0, [12, 41, 0]]]], "(%s%s)"],
		              c_ = [0, [12, 40, [2, 0, [12, 41, 0]]], "(%s)"];
		             function string_of_extension_constructo(t, cont){
		              function b(match){
		               var fields_opt = match[2], constructor = match[1];
		               if(! fields_opt) return cont(constructor);
		               var s2 = fields_opt[1];
		               return cont(constructor + s2);
		              }
		              if(0 !== caml_obj_tag(t)) return b([0, t[1], 0]);
		              var constructor = t[1][1], match = t.length - 1;
		              function a(a){return b([0, constructor, [0, a]]);}
		              if(2 < match >>> 0)
		               return caml_exact_trampoline_cps_call$1
		                       (other_fields,
		                        t,
		                        2,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1
		                                 (field,
		                                  t,
		                                  1,
		                                  function(c){
		                                   return caml_exact_trampoline_cps_call
		   (sprintf,
		    c9,
		    function(d){return caml_trampoline_cps_call3(d, c, b, a);});
		                                  });
		                        });
		              switch(match){
		                case 2:
		                 return caml_exact_trampoline_cps_call$1
		                         (field,
		                          t,
		                          1,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (sprintf,
		                                    c_,
		                                    function(c){return caml_trampoline_cps_call2(c, b, a);});
		                          });
		                case 0:
		                 return a(cst$1);
		                default: return a(cst$1);
		              }
		             }
		             var
		              g = ", characters ",
		              cst$9 = ": ",
		              locfmt =
		                [0,
		                 [11,
		                  'File "',
		                  [2,
		                   0,
		                   [11,
		                    '", line ',
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11,
		                      g,
		                      [4, 0, 0, 0, [12, 45, [4, 0, 0, 0, [11, cst$9, [2, 0, 0]]]]]]]]]],
		                 'File "%s", line %d, characters %d-%d: %s'],
		              printers = [0, 0];
		             function to_string$0(e, cont){
		              function a(param){
		               function b(a){
		                if(a){var s = a[1]; return cont(s);}
		                if(e === Out_of_memory) return cont("Out of memory");
		                if(e === Stack_overflow) return cont("Stack overflow");
		                if(e[1] === Match_failure){
		                 a = e[2];
		                 var char = a[3], line = a[2], file = a[1], b = char + 5 | 0;
		                 return caml_exact_trampoline_cps_call
		                         (sprintf,
		                          locfmt,
		                          function(a){
		                           return caml_trampoline_cps_call6
		                                   (a, file, line, char, b, "Pattern matching failed", cont);
		                          });
		                }
		                if(e[1] === Assert_failure){
		                 a = e[2];
		                 var
		                  char$0 = a[3],
		                  line$0 = a[2],
		                  file$0 = a[1],
		                  c = char$0 + 6 | 0;
		                 return caml_exact_trampoline_cps_call
		                         (sprintf,
		                          locfmt,
		                          function(a){
		                           return caml_trampoline_cps_call6
		                                   (a, file$0, line$0, char$0, c, "Assertion failed", cont);
		                          });
		                }
		                if(e[1] !== Undefined_recursive_module)
		                 return caml_exact_trampoline_cps_call
		                         (string_of_extension_constructo, e, cont);
		                a = e[2];
		                var
		                 char$1 = a[3],
		                 line$1 = a[2],
		                 file$1 = a[1],
		                 d = char$1 + 6 | 0;
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         locfmt,
		                         function(a){
		                          return caml_trampoline_cps_call6
		                                  (a,
		                                   file$1,
		                                   line$1,
		                                   char$1,
		                                   d,
		                                   "Undefined recursive module",
		                                   cont);
		                         });
		               }
		               if(! param) return b(0);
		               var tl = param[2], hd = param[1];
		               caml_push_trap
		                (function(b){return caml_exact_trampoline_call1(a, tl);});
		               return caml_trampoline_cps_call2
		                       (hd,
		                        e,
		                        function(val){
		                         caml_pop_trap();
		                         if(! val) return caml_exact_trampoline_call1(a, tl);
		                         var s = val[1];
		                         return b([0, s]);
		                        });
		              }
		              return a(caml_atomic_load(printers));
		             }
		             function convert_raw_backtrace(bt){
		              return [0, caml_convert_raw_backtrace()];
		             }
		             var
		              c$ = [0, [12, 32, [4, 0, 0, 0, 0]], " %d"],
		              da =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   32,
		                   [2,
		                    0,
		                    [11,
		                     ' in file "',
		                     [2,
		                      0,
		                      [12,
		                       34,
		                       [2,
		                        0,
		                        [11,
		                         ", line",
		                         [2, 0, [11, g, [4, 0, 0, 0, [12, 45, [4, 0, 0, 0, 0]]]]]]]]]]]]],
		                 '%s %s in file "%s"%s, line%s, characters %d-%d'],
		              db =
		                [0,
		                 [11, "s ", [4, 0, 0, 0, [12, 45, [4, 0, 0, 0, 0]]]],
		                 "s %d-%d"],
		              dc =
		                [0,
		                 [2, 0, [11, " unknown location", 0]],
		                 "%s unknown location"];
		             function format_backtrace_slot(pos, slot, cont){
		              function info(is_raise){
		               return is_raise
		                       ? 0 === pos ? "Raised at" : "Re-raised at"
		                       : 0
		                         === pos
		                         ? "Raised by primitive operation at"
		                         : "Called from";
		              }
		              if(0 !== slot[0]){
		               if(slot[1]) return cont(0);
		               var e = info(0);
		               return caml_exact_trampoline_cps_call
		                       (sprintf,
		                        dc,
		                        function(a){
		                         return caml_trampoline_cps_call2
		                                 (a, e, function(a){return cont([0, a]);});
		                        });
		              }
		              function a(lines){
		               var
		                a = slot[7],
		                b = slot[4],
		                c = slot[8] ? " (inlined)" : cst$1,
		                d = slot[2],
		                e = slot[9],
		                f = info(slot[1]);
		               return caml_exact_trampoline_cps_call
		                       (sprintf,
		                        da,
		                        function(g){
		                         return caml_trampoline_cps_call8
		                                 (g,
		                                  f,
		                                  e,
		                                  d,
		                                  c,
		                                  lines,
		                                  b,
		                                  a,
		                                  function(a){return cont([0, a]);});
		                        });
		              }
		              if(slot[3] === slot[6]){
		               var b = slot[3];
		               return caml_exact_trampoline_cps_call
		                       (sprintf,
		                        c$,
		                        function(c){return caml_trampoline_cps_call2(c, b, a);});
		              }
		              var c = slot[6], d = slot[3];
		              return caml_exact_trampoline_cps_call
		                      (sprintf,
		                       db,
		                       function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		             }
		             var
		              g = "%s\n",
		              cst_Program_not_linked_with_g_ =
		                "(Program not linked with -g, cannot print stack backtrace)\n",
		              dd = [0, [2, 0, [12, 10, 0]], g],
		              de =
		                [0,
		                 [11, cst_Program_not_linked_with_g_, 0],
		                 cst_Program_not_linked_with_g_];
		             function print_raw_backtrace(outchan, raw_backtrace, cont){
		              var backtrace = convert_raw_backtrace();
		              if(! backtrace)
		               return caml_exact_trampoline_cps_call$1
		                       (fprintf, outchan, de, cont);
		              var a = backtrace[1], b = a.length - 2 | 0;
		              function d(){return cont(0);}
		              function c(i){
		               return caml_exact_trampoline_cps_call$1
		                       (format_backtrace_slot,
		                        i,
		                        caml_check_bound(a, i)[i + 1],
		                        function(match){
		                         function a(a){
		                          a = i + 1 | 0;
		                          return b !== i ? caml_exact_trampoline_call1(c, a) : d();
		                         }
		                         if(! match) return a(0);
		                         var str = match[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (fprintf,
		                                  outchan,
		                                  dd,
		                                  function(b){return caml_trampoline_cps_call2(b, str, a);});
		                        });
		              }
		              return b < 0 ? d() : c(0);
		             }
		             function print_backtrace(outchan, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (print_raw_backtrace,
		                       outchan,
		                       caml_get_exception_raw_backtrace(),
		                       cont);
		             }
		             var df = [0, [2, 0, [12, 10, 0]], g];
		             function raw_backtrace_to_string(raw_backtrace, cont){
		              var backtrace = convert_raw_backtrace();
		              if(! backtrace) return cont(cst_Program_not_linked_with_g_);
		              var a = backtrace[1], b = create$1(1024), c = a.length - 2 | 0;
		              function e(i){
		               return caml_exact_trampoline_cps_call$1
		                       (format_backtrace_slot,
		                        i,
		                        caml_check_bound(a, i)[i + 1],
		                        function(match){
		                         function a(a){
		                          a = i + 1 | 0;
		                          return c !== i ? caml_exact_trampoline_call1(e, a) : d();
		                         }
		                         if(! match) return a(0);
		                         var str = match[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (bprintf,
		                                  b,
		                                  df,
		                                  function(b){return caml_trampoline_cps_call2(b, str, a);});
		                        });
		              }
		              function d(){
		               return caml_exact_trampoline_cps_call(contents, b, cont);
		              }
		              return c < 0 ? d() : e(0);
		             }
		             function register_printer(fn){
		              for(;;){
		               var
		                old_printers = caml_atomic_load(printers),
		                new_printers = [0, fn, old_printers],
		                success =
		                  caml_atomic_cas(printers, old_printers, new_printers),
		                a = 1 - success;
		               if(! a) return a;
		              }
		             }
		             caml_obj_dup
		                 ([0,
		                   cst$1,
		                   "(Cannot print locations:\n bytecode executable program file not found)",
		                   "(Cannot print locations:\n bytecode executable program file appears to be corrupt)",
		                   "(Cannot print locations:\n bytecode executable program file has wrong magic number)",
		                   "(Cannot print locations:\n bytecode executable program file cannot be opened;\n -- too many open files. Try running with OCAMLRUNPARAM=b=2)"]);
		              var cst_Fatal_error_exception = "Fatal error: exception ",
		              b = "Fatal error: exception %s\n",
		              fmt =
		                [0, [11, cst_Fatal_error_exception, [2, 0, [12, 10, 0]]], b];
		             function default_uncaught_exception_han(exn, raw_backtrace, cont){
		              return caml_exact_trampoline_cps_call
		                      (to_string$0,
		                       exn,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (fprintf,
		                                 stderr,
		                                 fmt,
		                                 function(b){
		                                  return caml_trampoline_cps_call2
		  (b,
		   a,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (print_raw_backtrace,
		             stderr,
		             raw_backtrace,
		             function(a){
		              return cont(caml_ml_flush(stderr));
		             });
		   });
		                                 });
		                       });
		             }
		             var
		              fmt$0 =
		                [0, [11, cst_Fatal_error_exception, [2, 0, [12, 10, 0]]], b],
		              fmt$1 =
		                [0,
		                 [11,
		                  "Fatal error in uncaught exception handler: exception ",
		                  [2, 0, [12, 10, 0]]],
		                 "Fatal error in uncaught exception handler: exception %s\n"],
		              uncaught_exception_handler = [0, default_uncaught_exception_han],
		              empty_backtrace = [0];
		             function handle_uncaught_exception(exn, debugger_in_use, cont){
		              caml_push_trap(function(exn){return cont(0);});
		              function b(a){caml_pop_trap(); return cont(a);}
		              caml_push_trap
		               (function(exn){
		                 if(exn === Out_of_memory)
		                  return b
		                          (prerr_endline
		                            ("Fatal error: out of memory in uncaught exception handler"));
		                 var
		                  raise = caml_pop_trap(),
		                  exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                 return raise(exn$0);
		                });
		              var
		               raw_backtrace =
		                 debugger_in_use
		                  ? empty_backtrace
		                  : caml_get_exception_raw_backtrace();
		              function a(exn$0){
		               function a(a){caml_pop_trap(); return b(a);}
		               caml_push_trap
		                (function(exn$0){
		                  var raw_backtrace$0 = caml_get_exception_raw_backtrace();
		                  return caml_exact_trampoline_cps_call
		                          (to_string$0,
		                           exn,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (fprintf,
		                                     stderr,
		                                     fmt$0,
		                                     function(c){
		                                      return caml_trampoline_cps_call2
		      (c,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (print_raw_backtrace,
		                 stderr,
		                 raw_backtrace,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (to_string$0,
		                           exn$0,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (fprintf,
		                                     stderr,
		                                     fmt$1,
		                                     function(c){
		                                      return caml_trampoline_cps_call2
		      (c,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (print_raw_backtrace,
		                 stderr,
		                 raw_backtrace$0,
		                 function(b){return a(caml_ml_flush(stderr));});
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		               return caml_trampoline_cps_call3
		                       (uncaught_exception_handler[1],
		                        exn,
		                        raw_backtrace,
		                        function(b){caml_pop_trap(); return a(b);});
		              }
		              caml_push_trap(a);
		              return caml_exact_trampoline_cps_call
		                      (do_at_exit,
		                       dummy,
		                       function(b){caml_pop_trap(); return a();});
		             }
		             caml_register_named_value
		              ("Printexc.handle_uncaught_exception",
		               handle_uncaught_exception);
		             var
		              Finally_raised =
		                [248, "Stdlib.Fun.Finally_raised", caml_fresh_oo_id()];
		             register_printer
		              (function(param, cont){
		                if(param[1] !== Finally_raised) return cont(0);
		                var exn = param[2];
		                return caml_exact_trampoline_cps_call
		                        (to_string$0,
		                         exn,
		                         function(s2){return cont([0, "Fun.Finally_raised: " + s2]);});
		               });
		             function protect(finally$, work, cont){
		              function finally_no_exn(param){
		               try{finally$(); return;}
		               catch(e$0){
		                var e = caml_wrap_exception(e$0),
		                 exn = [0, Finally_raised, e];
		                throw caml_maybe_attach_backtrace(exn, 0);
		               }
		              }
		              caml_push_trap
		               (function(work_exn){
		                 finally_no_exn();
		                 var
		                  raise = caml_pop_trap(),
		                  work_exn$0 = caml_maybe_attach_backtrace(work_exn, 0);
		                 return raise(work_exn$0);
		                });
		              return caml_exact_trampoline_cps_call
		                      (work,
		                       dummy,
		                       function(result){
		                        caml_pop_trap();
		                        finally_no_exn();
		                        return cont(result);
		                       });
		             }
		             function hex_of_string(d, cont){
		              function char_hex(n, cont){
		               var a = 10 <= n ? (97 + n | 0) - 10 | 0 : 48 + n | 0;
		               return caml_exact_trampoline_cps_call(chr, a, cont);
		              }
		              var
		               len = caml_ml_string_length(d),
		               result = caml_create_bytes(len * 2 | 0),
		               a = len - 1 | 0;
		              function c(){return cont(caml_string_of_bytes(result));}
		              function b(i){
		               var x = caml_string_get(d, i);
		               return caml_exact_trampoline_cps_call
		                       (char_hex,
		                        x >>> 4 | 0,
		                        function(d){
		                         caml_bytes_unsafe_set(result, i * 2 | 0, d);
		                         return caml_exact_trampoline_cps_call
		                                 (char_hex,
		                                  x & 15,
		                                  function(d){
		                                   caml_bytes_unsafe_set(result, (i * 2 | 0) + 1 | 0, d);
		                                   d = i + 1 | 0;
		                                   return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		                                  });
		                        });
		              }
		              return a < 0 ? c() : b(0);
		             }
		             function BLAKE2(X, cont){
		              var a = X[1] < 1, a = a || 64 < X[1];
		              function b(a){return cont();}
		              return a
		                      ? caml_exact_trampoline_cps_call
		                        (invalid_arg, "Digest.BLAKE2: wrong hash size", b)
		                      : b();
		             }
		             caml_callback(BLAKE2, [[0, 16]]);
		             caml_callback(BLAKE2, [[0, 32]]);
		             caml_callback(BLAKE2, [[0, 64]]);
		             function string(str){
		              return caml_md5_string(str, 0, caml_ml_string_length(str));
		             }
		             function bytes(b){return string(caml_string_of_bytes(b));}
		             function to_hex(d, cont){
		              function a(a){
		               return caml_exact_trampoline_cps_call(hex_of_string, d, cont);
		              }
		              return 16 !== caml_ml_string_length(d)
		                      ? caml_exact_trampoline_cps_call
		                        (invalid_arg, "Digest.to_hex", a)
		                      : a();
		             }
		             function create$2(kind, layout, dim){
		              return caml_ba_create(kind, layout, [0, dim]);
		             }
		             function create$3(kind, layout, dim1, dim2){
		              return caml_ba_create(kind, layout, [0, dim1, dim2]);
		             }
		             function create$4(param){return create$2(7, 0, 4);}
		             var
		              dg = caml_int64_create_lo_mi_hi(1, 0, 0),
		              dh = caml_int64_create_lo_mi_hi(0, 0, 0),
		              di = caml_int64_create_lo_mi_hi(0, 0, 0),
		              dj = caml_int64_create_lo_mi_hi(2, 0, 0),
		              dk = caml_int64_create_lo_mi_hi(1, 0, 0);
		             function set$1(s, i1, i2, i3, i4){
		              caml_ba_set_1(s, 0, caml_int64_or(i1, dg));
		              caml_ba_set_1(s, 1, i2);
		              var i3$0 = caml_notequal(i3, dh) ? i3 : dk;
		              caml_ba_set_1(s, 2, i3$0);
		              var i4$0 = caml_notequal(i4, di) ? i4 : dj;
		              caml_ba_set_1(s, 3, i4$0);
		             }
		             function mk(i1, i2, i3, i4){
		              var s = create$4();
		              set$1(s, i1, i2, i3, i4);
		              return s;
		             }
		             function reinit(s, seed){
		              var
		               n = seed.length - 1,
		               b = caml_create_bytes((n * 8 | 0) + 1 | 0),
		               a = n - 1 | 0;
		              if(a >= 0){
		               var i = 0;
		               for(;;){
		                var
		                 x = caml_int64_of_int32(caml_check_bound(seed, i)[i + 1]),
		                 i$0 = i * 8 | 0;
		                caml_bytes_set64(b, i$0, x);
		                var c = i + 1 | 0;
		                if(a === i) break;
		                i = c;
		               }
		              }
		              caml_bytes_set(b, n * 8 | 0, 1);
		              var d1 = bytes(b);
		              caml_bytes_set(b, n * 8 | 0, 2);
		              var
		               d2 = bytes(b),
		               a = get_int64_le(d2, 8),
		               c = get_int64_le(d2, 0),
		               d = get_int64_le(d1, 8);
		              return set$1(s, get_int64_le(d1, 0), d, c, a);
		             }
		             function make$1(seed){
		              var s = create$4();
		              reinit(s, seed);
		              return s;
		             }
		             function make_self_init(param, cont){
		              return cont(make$1(caml_sys_random_seed()));
		             }
		             function bits(s){
		              return caml_int64_to_int32(caml_lxm_next(s)) & 1073741823;
		             }
		             function int(s, bound, cont){
		              if(1073741823 >= bound && 0 < bound)
		               for(;;){
		                var
		                 r = caml_int64_to_int32(caml_lxm_next(s)) & 1073741823,
		                 v = caml_mod(r, bound);
		                if(((1073741823 - bound | 0) + 1 | 0) >= (r - v | 0))
		                 return cont(v);
		               }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "Random.int", cont);
		             }
		             function split(s, cont){
		              var
		               i1 = caml_lxm_next(s),
		               i2 = caml_lxm_next(s),
		               i3 = caml_lxm_next(s),
		               i4 = caml_lxm_next(s);
		              return cont(mk(i1, i2, i3, i4));
		             }
		             var
		              dl = caml_int64_create_lo_mi_hi(14371852, 15349651, 22696),
		              dm = caml_int64_create_lo_mi_hi(12230193, 11438743, 35013),
		              dn = caml_int64_create_lo_mi_hi(1424933, 15549263, 2083),
		              dp = caml_int64_create_lo_mi_hi(9492471, 4696708, 43520);
		             function mk_default(param, cont){
		              return cont(mk(dp, dn, dm, dl));
		             }
		             new_key([0, split], mk_default);
		             function ongoing_traversal(h){
		              var a = h.length - 1 < 4 ? 1 : 0, a = a || (h[4] < 0 ? 1 : 0);
		              return a;
		             }
		             var cst_OCAMLRUNPARAM = "OCAMLRUNPARAM";
		             try{b = caml_sys_getenv(cst_OCAMLRUNPARAM); var params = b;}
		             catch(exn$1){
		              var exn = caml_wrap_exception(exn$1);
		              if(exn !== Not_found){
		               A = caml_pop_trap();
		               var exn$6 = caml_maybe_attach_backtrace(exn, 0);
		               return A(exn$6);
		              }
		              try{b = caml_sys_getenv("CAMLRUNPARAM"); params = b;}
		              catch(exn){
		               var exn$0 = caml_wrap_exception(exn);
		               if(exn$0 !== Not_found){
		                m = caml_pop_trap();
		                var exn$5 = caml_maybe_attach_backtrace(exn$0, 0);
		                return m(exn$5);
		               }
		               params = cst$1;
		              }
		             }
		             var
		              randomized_default = caml_callback(contains, [params, 82]),
		              prng_key = new_key(0, make_self_init),
		              randomized = [0, randomized_default];
		             function create$5(opt, initial_size, cont){
		              var
		               random = opt ? opt[1] : caml_atomic_load(randomized),
		               x = 16;
		              for(;;){
		               if(initial_size <= x) break;
		               if(max_array_length < (x * 2 | 0)) break;
		               var x$0 = x * 2 | 0;
		               x = x$0;
		              }
		              function a(seed){
		               return cont([0, 0, caml_make_vect(x, 0), seed, x]);
		              }
		              return random
		                      ? caml_exact_trampoline_cps_call
		                        (get$0, prng_key, function(b){return a(bits(b));})
		                      : a(0);
		             }
		             function resize$0(indexfun, h, cont){
		              var
		               odata = h[2],
		               osize = odata.length - 1,
		               nsize = osize * 2 | 0,
		               a = nsize < max_array_length ? 1 : 0;
		              if(! a) return cont(a);
		              var
		               ndata = caml_make_vect(nsize, 0),
		               inplace = 1 - ongoing_traversal(h);
		              h[2] = ndata;
		              return caml_trampoline_cps_call2
		                      (indexfun,
		                       h,
		                       function(indexfun){
		                        var
		                         nsize = ndata.length - 1,
		                         ndata_tail = caml_make_vect(nsize, 0),
		                         a = odata.length - 2 | 0;
		                        function c(){
		                         if(inplace){
		                          var b = nsize - 1 | 0;
		                          if(b >= 0){
		                           var i = 0;
		                           for(;;){
		                            var a = caml_check_bound(ndata_tail, i)[i + 1];
		                            if(a) a[3] = 0;
		                            a = i + 1 | 0;
		                            if(b === i) break;
		                            i = a;
		                           }
		                          }
		                         }
		                         return cont();
		                        }
		                        function b(i){
		                         var cell = caml_check_bound(odata, i)[i + 1];
		                         function d(cell){
		                          if(cell){
		                           var
		                            key = cell[1],
		                            data = cell[2],
		                            next = cell[3],
		                            cell$0 = inplace ? cell : [0, key, data, 0];
		                           return caml_trampoline_cps_call2
		                                   (indexfun,
		                                    key,
		                                    function(nidx){
		                                     var match = caml_check_bound(ndata_tail, nidx)[nidx + 1];
		                                     if(match)
		                                      match[3] = cell$0;
		                                     else
		                                      caml_check_bound(ndata, nidx)[nidx + 1] = cell$0;
		                                     caml_check_bound(ndata_tail, nidx)[nidx + 1] = cell$0;
		                                     return caml_exact_trampoline_call1(d, next);
		                                    });
		                          }
		                          var e = i + 1 | 0;
		                          return a !== i ? caml_exact_trampoline_call1(b, e) : c();
		                         }
		                         return d(cell);
		                        }
		                        return a < 0 ? c() : b(0);
		                       });
		             }
		             function key_index(h, key, cont){
		              return 4 <= h.length - 1
		                      ? cont
		                        (caml_hash(10, 100, h[3], key) & (h[2].length - 2 | 0))
		                      : caml_exact_trampoline_cps_call
		                        (invalid_arg,
		                         "Hashtbl: unsupported hash table format",
		                         cont);
		             }
		             function add$0(h, key, data, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (key_index,
		                       h,
		                       key,
		                       function(i){
		                        var
		                         bucket = [0, key, data, caml_check_bound(h[2], i)[i + 1]];
		                        caml_check_bound(h[2], i)[i + 1] = bucket;
		                        h[1] = h[1] + 1 | 0;
		                        var a = h[2].length - 1 << 1 < h[1] ? 1 : 0;
		                        return a
		                                ? caml_exact_trampoline_cps_call$1
		                                  (resize$0, key_index, h, cont)
		                                : cont(a);
		                       });
		             }
		             function find(h, key, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (key_index,
		                       h,
		                       key,
		                       function(a){
		                        a = caml_check_bound(h[2], a)[a + 1];
		                        if(! a){
		                         a = caml_pop_trap();
		                         var Not_found$3 = caml_maybe_attach_backtrace(Not_found, 1);
		                         return a(Not_found$3);
		                        }
		                        var k1 = a[1], d1 = a[2], next1 = a[3];
		                        if(0 === caml_compare(key, k1)) return cont(d1);
		                        if(! next1){
		                         a = caml_pop_trap();
		                         var Not_found$2 = caml_maybe_attach_backtrace(Not_found, 1);
		                         return a(Not_found$2);
		                        }
		                        var k2 = next1[1], d2 = next1[2], next2 = next1[3];
		                        if(0 === caml_compare(key, k2)) return cont(d2);
		                        if(! next2){
		                         a = caml_pop_trap();
		                         var Not_found$1 = caml_maybe_attach_backtrace(Not_found, 1);
		                         return a(Not_found$1);
		                        }
		                        var k3 = next2[1], d3 = next2[2], next3 = next2[3];
		                        if(0 === caml_compare(key, k3)) return cont(d3);
		                        a = next3;
		                        for(;;){
		                         if(! a){
		                          a = caml_pop_trap();
		                          var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                          return a(Not_found$0);
		                         }
		                         var k = a[1], data = a[2], next = a[3];
		                         if(0 === caml_compare(key, k)) return cont(data);
		                         a = next;
		                        }
		                       });
		             }
		             function create$6(l, cont){
		              var a = 0 <= l, a = a ? l <= max_ephe_length : a;
		              function b(a){return cont(caml_weak_create(l));}
		              return 1 - a
		                      ? caml_exact_trampoline_cps_call
		                        (invalid_arg, "Weak.create", b)
		                      : b();
		             }
		             function length$0(x){return x.length - 3 | 0;}
		             function raise_if_invalid_offset$0(e, o, msg, cont){
		              var a = 0 <= o, a = a ? o < length$0(e) : a, a = 1 - a;
		              return a
		                      ? caml_exact_trampoline_cps_call(invalid_arg, msg, cont)
		                      : cont(a);
		             }
		             function set$2(e, o, x, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (raise_if_invalid_offset$0,
		                       e,
		                       o,
		                       "Weak.set",
		                       function(a){
		                        if(! x) return cont(caml_ephe_unset_key(e, o));
		                        var x$0 = x[1];
		                        return cont(caml_ephe_set_key(e, o, x$0));
		                       });
		             }
		             function get$1(e, o, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (raise_if_invalid_offset$0,
		                       e,
		                       o,
		                       "Weak.get",
		                       function(a){return cont(caml_ephe_get_key(e, o));});
		             }
		             function check(e, o, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (raise_if_invalid_offset$0,
		                       e,
		                       o,
		                       "Weak.check",
		                       function(a){return cont(caml_ephe_check_key(e, o));});
		             }
		             function blit$1(e1, o1, e2, o2, l, cont){
		              if
		               (0 <= l
		                &&
		                 0 <= o1
		                 &&
		                  (length$0(e1) - l | 0) >= o1
		                  && 0 <= o2 && (length$0(e2) - l | 0) >= o2){
		               if(0 !== l) caml_ephe_blit_key(e1, o1, e2, o2, l);
		               return cont();
		              }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg, "Weak.blit", cont);
		             }
		             function id(x, cont){return cont(x);}
		             var
		              String_tag =
		                [248, "Stdlib.Format.String_tag", caml_fresh_oo_id()];
		             function pp_enqueue(state, token){
		              state[13] = state[13] + token[3] | 0;
		              return add(token, state[28]);
		             }
		             function pp_output_string(state, s, cont){
		              return caml_trampoline_cps_call4
		                      (state[17], s, 0, caml_ml_string_length(s), cont);
		             }
		             function pp_output_newline(state, cont){
		              return caml_trampoline_cps_call2(state[19], 0, cont);
		             }
		             function format_pp_text(state, size, text, cont){
		              state[9] = state[9] - size | 0;
		              return caml_exact_trampoline_cps_call$1
		                      (pp_output_string,
		                       state,
		                       text,
		                       function(a){state[11] = 0; return cont();});
		             }
		             function format_string(state, s, cont){
		              var a = s !== cst$1 ? 1 : 0;
		              return a
		                      ? caml_exact_trampoline_cps_call$0
		                        (format_pp_text, state, caml_ml_string_length(s), s, cont)
		                      : cont(a);
		             }
		             function break_new_line(state, param, width, cont){
		              var after = param[3], offset = param[2], before = param[1];
		              return caml_exact_trampoline_cps_call$1
		                      (format_string,
		                       state,
		                       before,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (pp_output_newline,
		                                 state,
		                                 function(a){
		                                  state[11] = 1;
		                                  var
		                                   indent = (state[6] - width | 0) + offset | 0,
		                                   real_indent = min$0(state[8], indent);
		                                  state[10] = real_indent;
		                                  state[9] = state[6] - state[10] | 0;
		                                  var n = state[10];
		                                  return caml_trampoline_cps_call2
		  (state[21],
		   n,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (format_string, state, after, cont);
		   });
		                                 });
		                       });
		             }
		             function break_same_line(state, param, cont){
		              var after = param[3], width = param[2], before = param[1];
		              return caml_exact_trampoline_cps_call$1
		                      (format_string,
		                       state,
		                       before,
		                       function(a){
		                        state[9] = state[9] - width | 0;
		                        return caml_trampoline_cps_call2
		                                (state[20],
		                                 width,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$1
		  (format_string, state, after, cont);
		                                 });
		                       });
		             }
		             var bn = [0, cst$1, 0, cst$1];
		             function format_pp_token(state, size$0, a, cont){
		              if(typeof a === "number")
		               switch(a){
		                 case 0:
		                  a = top_opt(state[3]);
		                  if(! a) return cont();
		                  var
		                   tabs = a[1][1],
		                   add_tab =
		                     function(n, ls){
		                      if(! ls) return [0, n, 0];
		                      var l = ls[2], x = ls[1];
		                      return caml_lessthan(n, x)
		                              ? [0, n, ls]
		                              : [0, x, add_tab(n, l)];
		                     };
		                  tabs[1] = add_tab(state[6] - state[9] | 0, tabs[1]);
		                  return cont();
		                 case 1:
		                  pop_opt(state[2]); return cont();
		                 case 2:
		                  pop_opt(state[3]); return cont();
		                 case 3:
		                  a = top_opt(state[2]);
		                  if(! a)
		                   return caml_exact_trampoline_cps_call
		                           (pp_output_newline, state, cont);
		                  var width$0 = a[1][2];
		                  return caml_exact_trampoline_cps_call$0
		                          (break_new_line, state, bn, width$0, cont);
		                 case 4:
		                  a = state[10] !== (state[6] - state[9] | 0) ? 1 : 0;
		                  if(! a) return cont(a);
		                  var q = state[28], a = q[2];
		                  if(a){
		                   var content = a[1];
		                   if(a[2]){
		                    var next = a[2];
		                    q[1] = q[1] - 1 | 0;
		                    q[2] = next;
		                    a = [0, content];
		                   }
		                   else {clear$0(q); a = [0, content];}
		                  }
		                  else
		                   a = 0;
		                  if(! a) return cont();
		                  a = a[1];
		                  var size = a[1], length = a[3];
		                  state[12] = state[12] - length | 0;
		                  state[9] = state[9] + size | 0;
		                  return cont();
		                 default:
		                  a = pop_opt(state[5]);
		                  if(! a) return cont();
		                  var tag_name = a[1];
		                  return caml_trampoline_cps_call2
		                          (state[25],
		                           tag_name,
		                           function(marker){
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_output_string, state, marker, cont);
		                           });
		               }
		              switch(a[0]){
		                case 0:
		                 var s = a[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (format_pp_text, state, size$0, s, cont);
		                case 1:
		                 var
		                  breaks = a[2],
		                  fits = a[1],
		                  off = breaks[2],
		                  before = breaks[1],
		                  a = top_opt(state[2]);
		                 if(! a) return cont();
		                 a = a[1];
		                 var width$1 = a[2], box_type$0 = a[1];
		                 switch(box_type$0){
		                   case 3:
		                    return state[9]
		                            < (size$0 + caml_ml_string_length(before) | 0)
		                            ? caml_exact_trampoline_cps_call$0
		                              (break_new_line, state, breaks, width$1, cont)
		                            : caml_exact_trampoline_cps_call$1
		                              (break_same_line, state, fits, cont);
		                   case 4:
		                    return state[11]
		                            ? caml_exact_trampoline_cps_call$1
		                              (break_same_line, state, fits, cont)
		                            : state
		                               [9]
		                              < (size$0 + caml_ml_string_length(before) | 0)
		                              ? caml_exact_trampoline_cps_call$0
		                                (break_new_line, state, breaks, width$1, cont)
		                              : ((state
		                                 [6]
		                                - width$1
		                                | 0)
		                                + off
		                                | 0)
		                                < state[10]
		                                ? caml_exact_trampoline_cps_call$0
		                                  (break_new_line, state, breaks, width$1, cont)
		                                : caml_exact_trampoline_cps_call$1
		                                  (break_same_line, state, fits, cont);
		                   case 0:
		                   case 5:
		                    return caml_exact_trampoline_cps_call$1
		                            (break_same_line, state, fits, cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$0
		                            (break_new_line, state, breaks, width$1, cont);
		                 }
		                case 2:
		                 var
		                  off$0 = a[2],
		                  n = a[1],
		                  insertion_point = state[6] - state[9] | 0,
		                  a = top_opt(state[3]);
		                 if(! a) return cont();
		                 var tabs$0 = a[1][1], a = tabs$0[1];
		                 if(a){
		                  var first = a[1], a = tabs$0[1];
		                  for(;;){
		                   if(! a){var tab = first; break;}
		                   var tail = a[2], head = a[1];
		                   if(insertion_point <= head){tab = head; break;}
		                   a = tail;
		                  }
		                 }
		                 else
		                  tab = insertion_point;
		                 var offset = tab - insertion_point | 0;
		                 return 0 <= offset
		                         ? caml_exact_trampoline_cps_call$1
		                           (break_same_line,
		                            state,
		                            [0, cst$1, offset + n | 0, cst$1],
		                            cont)
		                         : caml_exact_trampoline_cps_call$0
		                           (break_new_line,
		                            state,
		                            [0, cst$1, tab + off$0 | 0, cst$1],
		                            state[6],
		                            cont);
		                case 3:
		                 var
		                  ty = a[2],
		                  off$1 = a[1],
		                  insertion_point$0 = state[6] - state[9] | 0,
		                  b =
		                    function(a){
		                     var
		                      width = state[9] - off$1 | 0,
		                      box_type = 1 === ty ? 1 : state[9] < size$0 ? ty : 5;
		                     return cont(push([0, box_type, width], state[2]));
		                    };
		                 if(state[8] >= insertion_point$0) return b(0);
		                 a = top_opt(state[2]);
		                 if(! a)
		                  return caml_exact_trampoline_cps_call
		                          (pp_output_newline, state, b);
		                 a = a[1];
		                 var width = a[2], box_type = a[1];
		                 return state[9] < width
		                         ? 3
		                           < box_type - 1 >>> 0
		                           ? b(0)
		                           : caml_exact_trampoline_cps_call$0
		                             (break_new_line, state, bn, width, b)
		                         : b(0);
		                case 4:
		                 var tbox = a[1]; return cont(push(tbox, state[3]));
		                default:
		                 var tag_name$0 = a[1];
		                 return caml_trampoline_cps_call2
		                         (state[24],
		                          tag_name$0,
		                          function(marker){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_output_string,
		                                    state,
		                                    marker,
		                                    function(a){return cont(push(tag_name$0, state[5]));});
		                          });
		              }
		             }
		             var pp_infinity = 1000000010;
		             function advance_left(state, cont){
		              function a(){
		               var q = state[28], b = q[2];
		               if(b) var content = b[1], b = [0, content]; else b = 0;
		               if(! b) return cont(0);
		               b = b[1];
		               var
		                size = b[1],
		                length = b[3],
		                token = b[2],
		                pending_count = state[13] - state[12] | 0,
		                b = 0 <= size ? 1 : 0,
		                b = b || (state[9] <= pending_count ? 1 : 0);
		               if(! b) return cont(b);
		               take(state[28]);
		               var size$0 = 0 <= size ? size : pp_infinity;
		               return caml_exact_trampoline_cps_call$0
		                       (format_pp_token,
		                        state,
		                        size$0,
		                        token,
		                        function(b){
		                         state[12] = length + state[12] | 0;
		                         return caml_exact_trampoline_call0(a);
		                        });
		              }
		              return a();
		             }
		             function enqueue_advance(state, tok, cont){
		              pp_enqueue(state, tok);
		              return caml_exact_trampoline_cps_call(advance_left, state, cont);
		             }
		             function enqueue_string_as(state, size, s, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (enqueue_advance, state, [0, size, [0, s], size], cont);
		             }
		             var dr = [0, cst$1], unknown = -1;
		             function initialize_scan_stack(stack){
		              clear(stack);
		              return push([0, -1, [0, unknown, dr, 0]], stack);
		             }
		             function set_size(state, ty){
		              var a = top_opt(state[1]);
		              if(! a) return;
		              a = a[1];
		              var queue_elem = a[2], left_total = a[1], size = queue_elem[1];
		              if(left_total < state[12])
		               return initialize_scan_stack(state[1]);
		              a = queue_elem[2];
		              if(typeof a !== "number")
		               switch(a[0]){
		                 case 3:
		                  if(1 - ty){
		                   var x$0 = state[13] + size | 0;
		                   queue_elem[1] = x$0;
		                   pop_opt(state[1]);
		                  }
		                  return;
		                 case 1:
		                 case 2:
		                  if(ty){
		                   var x = state[13] + size | 0;
		                   queue_elem[1] = x;
		                   pop_opt(state[1]);
		                  }
		                  return;
		               }
		             }
		             function scan_push(state, b, token){
		              pp_enqueue(state, token);
		              if(b) set_size(state, 1);
		              var elem = [0, state[13], token];
		              return push(elem, state[1]);
		             }
		             function pp_open_box_gen(state, indent, br_ty, cont){
		              state[14] = state[14] + 1 | 0;
		              if(state[14] < state[15]){
		               var
		                size = - state[13] | 0,
		                elem = [0, size, [3, indent, br_ty], 0];
		               return cont(scan_push(state, 0, elem));
		              }
		              var a = state[14] === state[15] ? 1 : 0;
		              if(! a) return cont(a);
		              var s = state[16], x = caml_ml_string_length(s);
		              return caml_exact_trampoline_cps_call$0
		                      (enqueue_string_as, state, x, s, cont);
		             }
		             var zero = 0;
		             function pp_close_box(state, a){
		              a = 1 < state[14] ? 1 : 0;
		              if(a){
		               if(state[14] < state[15]){
		                pp_enqueue(state, [0, zero, 1, 0]);
		                set_size(state, 1);
		                set_size(state, 0);
		               }
		               state[14] = state[14] - 1 | 0;
		               a = 0;
		              }
		              return a;
		             }
		             function pp_open_stag(state, tag_name, cont){
		              function a(a){
		               a = state[23];
		               if(! a) return cont(a);
		               var token = [5, tag_name];
		               return cont(pp_enqueue(state, [0, zero, token, 0]));
		              }
		              return state[22]
		                      ? (push
		                         (tag_name, state[4]),
		                        caml_trampoline_cps_call2(state[26], tag_name, a))
		                      : a(0);
		             }
		             function pp_close_stag(state, a, cont){
		              if(state[23]) pp_enqueue(state, [0, zero, 5, 0]);
		              a = state[22];
		              if(a){
		               a = pop_opt(state[4]);
		               if(a){
		                var tag_name = a[1];
		                return caml_trampoline_cps_call2(state[27], tag_name, cont);
		               }
		               a = 0;
		              }
		              return cont(a);
		             }
		             function pp_rinit(state, cont){
		              state[12] = 1;
		              state[13] = 1;
		              clear$0(state[28]);
		              initialize_scan_stack(state[1]);
		              clear(state[2]);
		              clear(state[3]);
		              clear(state[4]);
		              clear(state[5]);
		              state[10] = 0;
		              state[14] = 0;
		              state[9] = state[6];
		              return caml_exact_trampoline_cps_call$0
		                      (pp_open_box_gen, state, 0, 3, cont);
		             }
		             function pp_flush_queue(state, end_with_newline, cont){
		              var s = state[4];
		              function a(param){
		               if(param){
		                var l = param[2];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_close_stag,
		                         state,
		                         dummy,
		                         function(b){return caml_exact_trampoline_call1(a, l);});
		               }
		               for(;;){if(1 >= state[14]) break; pp_close_box(state);}
		               state[13] = pp_infinity;
		               return caml_exact_trampoline_cps_call
		                       (advance_left,
		                        state,
		                        function(b){
		                         function a(a){
		                          return caml_exact_trampoline_cps_call(pp_rinit, state, cont);
		                         }
		                         return end_with_newline
		                                 ? caml_exact_trampoline_cps_call
		                                   (pp_output_newline, state, a)
		                                 : a();
		                        });
		              }
		              return a(s[1]);
		             }
		             function pp_print_as_size(state, size, s, cont){
		              var a = state[14] < state[15] ? 1 : 0;
		              return a
		                      ? caml_exact_trampoline_cps_call$0
		                        (enqueue_string_as, state, size, s, cont)
		                      : cont(a);
		             }
		             function pp_print_string(state, s, cont){
		              var isize = caml_ml_string_length(s);
		              return caml_exact_trampoline_cps_call$0
		                      (pp_print_as_size, state, isize, s, cont);
		             }
		             function pp_print_int(state, i, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (pp_print_string, state, "" + i, cont);
		             }
		             function pp_print_bool(state, b, cont){
		              return caml_exact_trampoline_cps_call
		                      (string_of_bool,
		                       b,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (pp_print_string, state, a, cont);
		                       });
		             }
		             function pp_print_char(state, c, cont){
		              var s = make$0(1, c);
		              return caml_exact_trampoline_cps_call$0
		                      (pp_print_as_size, state, 1, s, cont);
		             }
		             function pp_open_box(state, indent, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (pp_open_box_gen, state, indent, 4, cont);
		             }
		             function pp_print_newline(state, param, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (pp_flush_queue,
		                       state,
		                       1,
		                       function(a){
		                        return caml_trampoline_cps_call2(state[18], 0, cont);
		                       });
		             }
		             function pp_print_flush(state, param, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (pp_flush_queue,
		                       state,
		                       0,
		                       function(a){
		                        return caml_trampoline_cps_call2(state[18], 0, cont);
		                       });
		             }
		             function pp_force_newline(state, a, cont){
		              a = state[14] < state[15] ? 1 : 0;
		              return a
		                      ? caml_exact_trampoline_cps_call$1
		                        (enqueue_advance, state, [0, zero, 3, 0], cont)
		                      : cont(a);
		             }
		             function pp_print_custom_break(state, fits, breaks){
		              var
		               after = fits[3],
		               width = fits[2],
		               before = fits[1],
		               a = state[14] < state[15] ? 1 : 0;
		              if(! a) return a;
		              var
		               size = - state[13] | 0,
		               token = [1, fits, breaks],
		               length =
		                 (caml_ml_string_length(before) + width | 0)
		                 + caml_ml_string_length(after)
		                 | 0;
		              return scan_push(state, 1, [0, size, token, length]);
		             }
		             function pp_print_break(state, width, offset){
		              return pp_print_custom_break
		                      (state, [0, cst$1, width, cst$1], [0, cst$1, offset, cst$1]);
		             }
		             function pp_print_space(state, param){return pp_print_break(state, 1, 0);
		             }
		             function pp_print_cut(state, param){
		              return pp_print_break(state, 0, 0);
		             }
		             function pp_limit(n){return n < 1000000010 ? n : 1000000009;}
		             function pp_set_margin(state, n$1, cont){
		              var a = 1 <= n$1 ? 1 : 0;
		              if(! a) return cont(a);
		              var n$2 = pp_limit(n$1);
		              state[6] = n$2;
		              var
		               new_max_indent =
		                 state[8] <= state[6]
		                  ? state[8]
		                  : max$0(max$0(state[6] - state[7] | 0, state[6] / 2 | 0), 1),
		               a = 1 < new_max_indent ? 1 : 0;
		              if(! a) return cont(a);
		              var n$0 = state[6] - new_max_indent | 0, a = 1 <= n$0 ? 1 : 0;
		              if(! a) return cont(a);
		              var n = pp_limit(n$0);
		              state[7] = n;
		              state[8] = state[6] - state[7] | 0;
		              return caml_exact_trampoline_cps_call(pp_rinit, state, cont);
		             }
		             var cst$15 = "\n";
		             function display_newline(state, param, cont){
		              return caml_trampoline_cps_call4(state[17], cst$15, 0, 1, cont);
		             }
		             var blank_line = make$0(80, 32);
		             function display_blanks(state, n, cont){
		              function a(n){
		               var b = 0 < n ? 1 : 0;
		               return b
		                       ? 80
		                         < n
		                         ? caml_trampoline_cps_call4
		                           (state[17],
		                            blank_line,
		                            0,
		                            80,
		                            function(b){
		                             var n$0 = n - 80 | 0;
		                             return caml_exact_trampoline_call1(a, n$0);
		                            })
		                         : caml_trampoline_cps_call4
		                           (state[17], blank_line, 0, n, cont)
		                       : cont(b);
		              }
		              return a(n);
		             }
		             var cst$51 = "<", cst$41 = ">";
		             function default_pp_mark_open_tag(param, cont){
		              if(param[1] !== String_tag) return cont(cst$1);
		              var s1 = param[2], s2 = s1 + cst$41;
		              return cont(cst$51 + s2);
		             }
		             var cst$57 = "<\/";
		             function default_pp_mark_close_tag(param, cont){
		              if(param[1] !== String_tag) return cont(cst$1);
		              var s1 = param[2], s2 = s1 + cst$41;
		              return cont(cst$57 + s2);
		             }
		             function default_pp_print_open_tag(a, cont){return cont(0);}
		             function default_pp_print_close_tag(a, cont){return cont(0);}
		             var max_value = 2147483647, ds = [3, 0, 3];
		             function pp_make_formatter(f, g, h, i, j){
		              var pp_queue = create$0(), sys_tok = [0, unknown, ds, 0];
		              add(sys_tok, pp_queue);
		              var scan_stack = create();
		              initialize_scan_stack(scan_stack);
		              push([0, 1, sys_tok], scan_stack);
		              var a = create(), b = create(), c = create(), pp_margin = 78;
		              return [0,
		                      scan_stack,
		                      create(),
		                      c,
		                      b,
		                      a,
		                      pp_margin,
		                      10,
		                      68,
		                      pp_margin,
		                      0,
		                      1,
		                      1,
		                      1,
		                      1,
		                      max_value,
		                      cst$14,
		                      f,
		                      g,
		                      h,
		                      i,
		                      j,
		                      0,
		                      0,
		                      default_pp_mark_open_tag,
		                      default_pp_mark_close_tag,
		                      default_pp_print_open_tag,
		                      default_pp_print_close_tag,
		                      pp_queue];
		             }
		             function make_formatter(output, flush){
		              var
		               ppf =
		                 pp_make_formatter
		                  (output,
		                   flush,
		                   function(a, cont){return cont(0);},
		                   function(a, cont){return cont(0);},
		                   function(a, cont){return cont(0);});
		              ppf[19] =
		               function(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (display_newline, ppf, dummy, cont);
		               };
		              ppf[20] =
		               function(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (display_blanks, ppf, a, cont);
		               };
		              ppf[21] =
		               function(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (display_blanks, ppf, a, cont);
		               };
		              return ppf;
		             }
		             function formatter_of_out_channel(oc){
		              return make_formatter
		                      (function(a, b, c, cont){
		                        return caml_exact_trampoline_cps_call$2
		                                (output_substring, oc, a, b, c, cont);
		                       },
		                       function(param, cont){return cont(caml_ml_flush(oc));});
		             }
		             function formatter_of_buffer(b){
		              return make_formatter
		                      (function(a, c, d, cont){
		                        return caml_exact_trampoline_cps_call$2
		                                (add_substring, b, a, c, d, cont);
		                       },
		                       function(a, cont){return cont(0);});
		             }
		             var pp_buffer_size = 512;
		             function pp_make_buffer(param, cont){
		              return cont(create$1(pp_buffer_size));
		             }
		             var
		              stdbuf = create$1(pp_buffer_size),
		              std_formatter = formatter_of_out_channel(stdout),
		              err_formatter = formatter_of_out_channel(stderr),
		              str_formatter = formatter_of_buffer(stdbuf),
		              stdbuf_key = new_key(0, pp_make_buffer);
		             caml_callback(set$0, [stdbuf_key, stdbuf]);
		             var
		              str_formatter_key =
		                new_key
		                 (0,
		                  function(param, cont){
		                   return caml_exact_trampoline_cps_call
		                           (get$0,
		                            stdbuf_key,
		                            function(a){return cont(formatter_of_buffer(a));});
		                  });
		             caml_callback(set$0, [str_formatter_key, str_formatter]);
		             function buffered_out_string(key, str, ofs, len, cont){
		              return caml_exact_trampoline_cps_call
		                      (get$0,
		                       key,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$2
		                                (add_substring, a, str, ofs, len, cont);
		                       });
		             }
		             function buffered_out_flush(oc, key, param, cont){
		              return caml_exact_trampoline_cps_call
		                      (get$0,
		                       key,
		                       function(buf){
		                        var len = buf[2];
		                        return caml_exact_trampoline_cps_call
		                                (contents,
		                                 buf,
		                                 function(str){
		                                  return caml_exact_trampoline_cps_call$2
		  (output_substring,
		   oc,
		   str,
		   0,
		   len,
		   function(a){caml_ml_flush(oc); return cont(clear$1(buf));});
		                                 });
		                       });
		             }
		             var
		              std_buf_key =
		                new_key
		                 (0,
		                  function(param, cont){
		                   return cont(create$1(pp_buffer_size));
		                  }),
		              err_buf_key =
		                new_key
		                 (0,
		                  function(param, cont){
		                   return cont(create$1(pp_buffer_size));
		                  }),
		              std_formatter_key =
		                new_key
		                 (0,
		                  function(param, cont){
		                   var
		                    ppf =
		                      pp_make_formatter
		                       (function(a, b, c, cont){
		                         return caml_exact_trampoline_cps_call$2
		                                 (buffered_out_string, std_buf_key, a, b, c, cont);
		                        },
		                        function(a, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (buffered_out_flush, stdout, std_buf_key, dummy, cont);
		                        },
		                        function(a, cont){return cont(0);},
		                        function(a, cont){return cont(0);},
		                        function(a, cont){return cont(0);});
		                   ppf[19] =
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (display_newline, ppf, dummy, cont);
		                    };
		                   ppf[20] =
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (display_blanks, ppf, a, cont);
		                    };
		                   ppf[21] =
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (display_blanks, ppf, a, cont);
		                    };
		                   return caml_exact_trampoline_cps_call
		                           (at_exit$0,
		                            function(a, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_flush, ppf, dummy, cont);
		                            },
		                            function(a){return cont(ppf);});
		                  });
		             caml_callback(set$0, [std_formatter_key, std_formatter]);
		             var
		              err_formatter_key =
		                new_key
		                 (0,
		                  function(param, cont){
		                   var
		                    ppf =
		                      pp_make_formatter
		                       (function(a, b, c, cont){
		                         return caml_exact_trampoline_cps_call$2
		                                 (buffered_out_string, err_buf_key, a, b, c, cont);
		                        },
		                        function(a, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (buffered_out_flush, stderr, err_buf_key, dummy, cont);
		                        },
		                        function(a, cont){return cont(0);},
		                        function(a, cont){return cont(0);},
		                        function(a, cont){return cont(0);});
		                   ppf[19] =
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (display_newline, ppf, dummy, cont);
		                    };
		                   ppf[20] =
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (display_blanks, ppf, a, cont);
		                    };
		                   ppf[21] =
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (display_blanks, ppf, a, cont);
		                    };
		                   return caml_exact_trampoline_cps_call
		                           (at_exit$0,
		                            function(a, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_flush, ppf, dummy, cont);
		                            },
		                            function(a){return cont(ppf);});
		                  });
		             caml_callback(set$0, [err_formatter_key, err_formatter]);
		             function flush_buffer_formatter(buf, ppf, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (pp_flush_queue,
		                       ppf,
		                       0,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (contents, buf, function(s){reset(buf); return cont(s);});
		                       });
		             }
		             function compute_tag(output, tag_acc, cont){
		              var buf = create$1(16), ppf = formatter_of_buffer(buf);
		              return caml_exact_trampoline_cps_call$1
		                      (output,
		                       ppf,
		                       tag_acc,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (pp_print_flush,
		                                 ppf,
		                                 dummy,
		                                 function(a){
		                                  var len$0 = buf[2];
		                                  if(2 > len$0)
		                                   return caml_exact_trampoline_cps_call(contents, buf, cont);
		                                  var len = len$0 - 2 | 0;
		                                  if(0 <= len && (buf[2] - len | 0) >= 1)
		                                   return caml_exact_trampoline_cps_call$0
		   (sub_string, buf[1][1], 1, len, cont);
		                                  return caml_exact_trampoline_cps_call
		  (invalid_arg, "Buffer.sub", cont);
		                                 });
		                       });
		             }
		             function output_formatting_lit(ppf, fmting_lit, cont){
		              if(typeof fmting_lit === "number")
		               switch(fmting_lit){
		                 case 0:
		                  return cont(pp_close_box(ppf));
		                 case 1:
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_close_stag, ppf, dummy, cont);
		                 case 2:
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_flush, ppf, dummy, cont);
		                 case 3:
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_force_newline, ppf, dummy, cont);
		                 case 4:
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_newline, ppf, dummy, cont);
		                 case 5:
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_char, ppf, 64, cont);
		                 default:
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_char, ppf, 37, cont);
		               }
		              switch(fmting_lit[0]){
		                case 0:
		                 var offset = fmting_lit[3], width = fmting_lit[2];
		                 return cont(pp_print_break(ppf, width, offset));
		                case 1:
		                 return cont(0);
		                default:
		                 var c = fmting_lit[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_char,
		                          ppf,
		                          64,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_char, ppf, c, cont);
		                          });
		              }
		             }
		             function output_acc$0(ppf, acc, cont){
		              if(typeof acc === "number") return cont(0);
		              a:
		              {
		               b:
		               {
		                c:
		                {
		                 switch(acc[0]){
		                   case 0:
		                    var f = acc[2], p = acc[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (output_acc$0,
		                             ppf,
		                             p,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (output_formatting_lit, ppf, f, cont);
		                             });
		                   case 1:
		                    var a = acc[2], p$0 = acc[1];
		                    if(0 === a[0]){
		                     var acc$0 = a[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (output_acc$0,
		                              ppf,
		                              p$0,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (compute_tag,
		output_acc$0,
		acc$0,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (pp_open_stag, ppf, [0, String_tag, a], cont);
		});
		                              });
		                    }
		                    var acc$1 = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (output_acc$0,
		                             ppf,
		                             p$0,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (compute_tag,
		                                       output_acc$0,
		                                       acc$1,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (open_box_of_string,
		         a,
		         function(match){
		          var bty = match[2], indent = match[1];
		          return caml_exact_trampoline_cps_call$0
		                  (pp_open_box_gen, ppf, indent, bty, cont);
		         });
		                                       });
		                             });
		                   case 2:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     var b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      var s$0 = acc[2], size = b[2], p$2 = a[1];
		                      break a;
		                     }
		                    }
		                    var s = acc[2], p$1 = a;
		                    break b;
		                   case 3:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      var c$0 = acc[2], size$0 = b[2], p$4 = a[1];
		                      break c;
		                     }
		                    }
		                    var c = acc[2], p$3 = a;
		                    break;
		                   case 4:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      s$0 = acc[2];
		                      size = b[2];
		                      p$2 = a[1];
		                      break a;
		                     }
		                    }
		                    s = acc[2];
		                    p$1 = a;
		                    break b;
		                   case 5:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      c$0 = acc[2];
		                      size$0 = b[2];
		                      p$4 = a[1];
		                      break c;
		                     }
		                    }
		                    c = acc[2];
		                    p$3 = a;
		                    break;
		                   case 6:
		                    var f$0 = acc[2], p$5 = acc[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (output_acc$0,
		                             ppf,
		                             p$5,
		                             function(a){
		                              return caml_trampoline_cps_call2(f$0, ppf, cont);
		                             });
		                   case 7:
		                    var p$6 = acc[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (output_acc$0,
		                             ppf,
		                             p$6,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_flush, ppf, dummy, cont);
		                             });
		                   default:
		                    var msg = acc[2], p$7 = acc[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (output_acc$0,
		                             ppf,
		                             p$7,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (invalid_arg, msg, cont);
		                             });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (output_acc$0,
		                          ppf,
		                          p$3,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_char, ppf, c, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (output_acc$0,
		                         ppf,
		                         p$4,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (pp_print_as_size, ppf, size$0, make$0(1, c$0), cont);
		                         });
		               }
		               return caml_exact_trampoline_cps_call$1
		                       (output_acc$0,
		                        ppf,
		                        p$1,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (pp_print_string, ppf, s, cont);
		                        });
		              }
		              return caml_exact_trampoline_cps_call$1
		                      (output_acc$0,
		                       ppf,
		                       p$2,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$0
		                                (pp_print_as_size, ppf, size, s$0, cont);
		                       });
		             }
		             function strput_acc$0(ppf, acc, cont){
		              if(typeof acc === "number") return cont();
		              a:
		              {
		               b:
		               {
		                c:
		                {
		                 switch(acc[0]){
		                   case 0:
		                    var f = acc[2], p = acc[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (strput_acc$0,
		                             ppf,
		                             p,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (output_formatting_lit, ppf, f, cont);
		                             });
		                   case 1:
		                    var a = acc[2], p$0 = acc[1];
		                    if(0 === a[0]){
		                     var acc$0 = a[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (strput_acc$0,
		                              ppf,
		                              p$0,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (compute_tag,
		strput_acc$0,
		acc$0,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (pp_open_stag, ppf, [0, String_tag, a], cont);
		});
		                              });
		                    }
		                    var acc$1 = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (strput_acc$0,
		                             ppf,
		                             p$0,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (compute_tag,
		                                       strput_acc$0,
		                                       acc$1,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (open_box_of_string,
		         a,
		         function(match){
		          var bty = match[2], indent = match[1];
		          return caml_exact_trampoline_cps_call$0
		                  (pp_open_box_gen, ppf, indent, bty, cont);
		         });
		                                       });
		                             });
		                   case 2:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     var b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      var s$0 = acc[2], size = b[2], p$2 = a[1];
		                      break a;
		                     }
		                    }
		                    var s = acc[2], p$1 = a;
		                    break b;
		                   case 3:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      var c$0 = acc[2], size$0 = b[2], p$4 = a[1];
		                      break c;
		                     }
		                    }
		                    var c = acc[2], p$3 = a;
		                    break;
		                   case 4:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      s$0 = acc[2];
		                      size = b[2];
		                      p$2 = a[1];
		                      break a;
		                     }
		                    }
		                    s = acc[2];
		                    p$1 = a;
		                    break b;
		                   case 5:
		                    a = acc[1];
		                    if(typeof a !== "number" && 0 === a[0]){
		                     b = a[2];
		                     if(typeof b !== "number" && 1 === b[0]){
		                      c$0 = acc[2];
		                      size$0 = b[2];
		                      p$4 = a[1];
		                      break c;
		                     }
		                    }
		                    c = acc[2];
		                    p$3 = a;
		                    break;
		                   case 6:
		                    var p$5 = acc[1];
		                    if(typeof p$5 !== "number" && 0 === p$5[0]){
		                     a = p$5[2];
		                     if(typeof a !== "number" && 1 === a[0]){
		                      var f$1 = acc[2], size$1 = a[2], p$6 = p$5[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (strput_acc$0,
		                               ppf,
		                               p$6,
		                               function(a){
		                                return caml_trampoline_cps_call2
		(f$1,
		 0,
		 function(a){
		  return caml_exact_trampoline_cps_call$0
		          (pp_print_as_size, ppf, size$1, a, cont);
		 });
		                               });
		                     }
		                    }
		                    var f$0 = acc[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (strput_acc$0,
		                             ppf,
		                             p$5,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (f$0,
		                                       0,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (pp_print_string, ppf, a, cont);
		                                       });
		                             });
		                   case 7:
		                    var p$7 = acc[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (strput_acc$0,
		                             ppf,
		                             p$7,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_flush, ppf, dummy, cont);
		                             });
		                   default:
		                    var msg = acc[2], p$8 = acc[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (strput_acc$0,
		                             ppf,
		                             p$8,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (invalid_arg, msg, cont);
		                             });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (strput_acc$0,
		                          ppf,
		                          p$3,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_char, ppf, c, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (strput_acc$0,
		                         ppf,
		                         p$4,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (pp_print_as_size, ppf, size$0, make$0(1, c$0), cont);
		                         });
		               }
		               return caml_exact_trampoline_cps_call$1
		                       (strput_acc$0,
		                        ppf,
		                        p$1,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (pp_print_string, ppf, s, cont);
		                        });
		              }
		              return caml_exact_trampoline_cps_call$1
		                      (strput_acc$0,
		                       ppf,
		                       p$2,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$0
		                                (pp_print_as_size, ppf, size, s$0, cont);
		                       });
		             }
		             function kfprintf(k, ppf, param, cont){
		              var fmt = param[1];
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf,
		                       function(acc, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (output_acc$0,
		                                 ppf,
		                                 acc,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call(k, ppf, cont);
		                                 });
		                       },
		                       0,
		                       fmt,
		                       cont);
		             }
		             function fprintf$0(ppf){
		              function a(a, cont){return cont(0);}
		              return function(b, cont){
		               return caml_exact_trampoline_cps_call$0
		                       (kfprintf, a, ppf, b, cont);};
		             }
		             function ksprintf$0(k, param, cont){
		              var
		               fmt = param[1],
		               b = create$1(pp_buffer_size),
		               ppf = formatter_of_buffer(b);
		              function k$0(acc, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (strput_acc$0,
		                        ppf,
		                        acc,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (flush_buffer_formatter,
		                                  b,
		                                  ppf,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call(k, a, cont);
		                                  });
		                        });
		              }
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf, k$0, 0, fmt, cont);
		             }
		             function kasprintf(k, param, cont){
		              var
		               fmt = param[1],
		               b = create$1(pp_buffer_size),
		               ppf = formatter_of_buffer(b);
		              function k$0(acc, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (output_acc$0,
		                        ppf,
		                        acc,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (flush_buffer_formatter,
		                                  b,
		                                  ppf,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call(k, a, cont);
		                                  });
		                        });
		              }
		              return caml_exact_trampoline_cps_call$0
		                      (make_printf, k$0, 0, fmt, cont);
		             }
		             function asprintf(fmt, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (kasprintf, id, fmt, cont);
		             }
		             function flush_standard_formatters(param, cont){
		              return caml_exact_trampoline_cps_call
		                      (get$0,
		                       std_formatter_key,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (pp_print_flush,
		                                 a,
		                                 dummy,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (get$0,
		   err_formatter_key,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (pp_print_flush, a, dummy, cont);
		   });
		                                 });
		                       });
		             }
		             at_exit(flush_standard_formatters);
		             if(caml_atomic_load([0, 0])){
		              c = caml_pop_trap();
		              return c
		                      (caml_maybe_attach_backtrace
		                        ([0, Invalid_argument, "first domain already spawned"], 1));
		             }
		             var null_char = 0;
		             function next_char(ib, cont){
		              caml_push_trap
		               (function(exn){
		                 if(exn === End_of_file){
		                  ib[2] = null_char;
		                  ib[3] = 0;
		                  ib[1] = 1;
		                  return cont(null_char);
		                 }
		                 var
		                  raise = caml_pop_trap(),
		                  exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                 return raise(exn$0);
		                });
		              return caml_trampoline_cps_call2
		                      (ib[7],
		                       0,
		                       function(c){
		                        ib[2] = c;
		                        ib[3] = 1;
		                        ib[4] = ib[4] + 1 | 0;
		                        if(10 === c) ib[5] = ib[5] + 1 | 0;
		                        caml_pop_trap();
		                        return cont(c);
		                       });
		             }
		             function peek_char(ib, cont){
		              return ib[3]
		                      ? cont(ib[2])
		                      : caml_exact_trampoline_cps_call(next_char, ib, cont);
		             }
		             function checked_peek_char(ib, cont){
		              return caml_exact_trampoline_cps_call
		                      (peek_char,
		                       ib,
		                       function(c){
		                        if(! ib[1]) return cont(c);
		                        var
		                         raise = caml_pop_trap(),
		                         End_of_file$0 = caml_maybe_attach_backtrace(End_of_file, 1);
		                        return raise(End_of_file$0);
		                       });
		             }
		             function end_of_input(ib, cont){
		              return caml_exact_trampoline_cps_call
		                      (peek_char, ib, function(a){return cont(ib[1]);});
		             }
		             function char_count(ib){return ib[3] ? ib[4] - 1 | 0 : ib[4];}
		             function invalidate_current_char(ib){ib[3] = 0;}
		             function token_string(ib, cont){
		              var token_buffer = ib[8];
		              return caml_exact_trampoline_cps_call
		                      (contents,
		                       token_buffer,
		                       function(tok){
		                        clear$1(token_buffer);
		                        ib[6] = ib[6] + 1 | 0;
		                        return cont(tok);
		                       });
		             }
		             function ignore_char(width, ib){
		              var width$0 = width - 1 | 0;
		              invalidate_current_char(ib);
		              return width$0;
		             }
		             function store_char(width, ib, c, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (add_char,
		                       ib[8],
		                       c,
		                       function(a){return cont(ignore_char(width, ib));});
		             }
		             var
		              Scan_failure =
		                [248, "Stdlib.Scanf.Scan_failure", caml_fresh_oo_id()];
		             function bad_input(s){
		              throw caml_maybe_attach_backtrace([0, Scan_failure, s], 1);
		             }
		             var
		              dt =
		                [0,
		                 [11, "illegal escape character ", [1, 0]],
		                 "illegal escape character %C"];
		             function bad_input_escape(c, cont){
		              return caml_exact_trampoline_cps_call
		                      (sprintf,
		                       dt,
		                       function(a){
		                        return caml_trampoline_cps_call2
		                                (a, c, function(a){return cont(bad_input(a));});
		                       });
		             }
		             var
		              b = "scanning of ",
		              du =
		                [0,
		                 [11,
		                  b,
		                  [2,
		                   0,
		                   [11,
		                    " failed: the specified length was too short for token",
		                    0]]],
		                 "scanning of %s failed: the specified length was too short for token"];
		             function bad_token_length(message, cont){
		              return caml_exact_trampoline_cps_call
		                      (sprintf,
		                       du,
		                       function(a){
		                        return caml_trampoline_cps_call2
		                                (a, message, function(a){return cont(bad_input(a));});
		                       });
		             }
		             var j = "not a valid float in hexadecimal notation";
		             function bad_hex_float(param){return bad_input(j);}
		             var
		              dw =
		                [0,
		                 [11, "looking for ", [1, [11, ", found ", [1, 0]]]],
		                 "looking for %C, found %C"];
		             function character_mismatch(c, ci, cont){
		              return caml_exact_trampoline_cps_call
		                      (sprintf,
		                       dw,
		                       function(a){
		                        return caml_trampoline_cps_call3
		                                (a, c, ci, function(a){return cont(bad_input(a));});
		                       });
		             }
		             function check_char(ib, c, cont){
		              if(10 === c)
		               return caml_exact_trampoline_cps_call
		                       (checked_peek_char,
		                        ib,
		                        function(ci){
		                         return 10 === ci
		                                 ? cont(invalidate_current_char(ib))
		                                 : 13
		                                   === ci
		                                   ? (invalidate_current_char
		                                      (ib),
		                                     caml_exact_trampoline_cps_call$1
		                                      (check_this_char, ib, 10, cont))
		                                   : caml_exact_trampoline_cps_call$1
		                                     (character_mismatch, 10, ci, cont);
		                        });
		              function a(){
		               return caml_exact_trampoline_cps_call
		                       (peek_char,
		                        ib,
		                        function(c){
		                         var b = 1 - ib[1];
		                         if(! b) return cont(b);
		                         b = c - 9 | 0;
		                         a:
		                         {
		                          if(4 < b >>> 0){
		                           if(23 !== b) break a;
		                          }
		                          else if(1 >= b - 2 >>> 0) break a;
		                          invalidate_current_char(ib);
		                          return caml_exact_trampoline_call0(a);
		                         }
		                         return cont();
		                        });
		              }
		              return 32 === c
		                      ? a()
		                      : caml_exact_trampoline_cps_call$1
		                        (check_this_char, ib, c, cont);
		             }
		             function check_this_char(ib, c, cont){
		              return caml_exact_trampoline_cps_call
		                      (checked_peek_char,
		                       ib,
		                       function(ci){
		                        return ci === c
		                                ? cont(invalidate_current_char(ib))
		                                : caml_exact_trampoline_cps_call$1
		                                  (character_mismatch, c, ci, cont);
		                       });
		             }
		             function token_char(ib, cont){
		              return caml_exact_trampoline_cps_call
		                      (token_string,
		                       ib,
		                       function(a){return cont(caml_string_get(a, 0));});
		             }
		             var
		              dx =
		                [0,
		                 [11, "invalid boolean '", [2, 0, [12, 39, 0]]],
		                 "invalid boolean '%s'"];
		             function token_bool(ib, cont){
		              return caml_exact_trampoline_cps_call
		                      (token_string,
		                       ib,
		                       function(s){
		                        return s !== cst_false
		                                ? s
		                                  !== cst_true
		                                  ? caml_exact_trampoline_cps_call
		                                    (sprintf,
		                                     dx,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a, s, function(a){return cont(bad_input(a));});
		                                     })
		                                  : cont(1)
		                                : cont(0);
		                       });
		             }
		             var f = "scanf.ml", dy = [0, f, 516, 9];
		             function integer_conversion_of_char(a){
		              a = a - 88 | 0;
		              if(32 >= a >>> 0)
		               switch(a){
		                 case 10:
		                  return 0;
		                 case 12:
		                  return 1;
		                 case 17:
		                  return 2;
		                 case 23:
		                  return 3;
		                 case 29:
		                  return 4;
		                 case 0:
		                 case 32:
		                  return 5;
		               }
		              throw caml_maybe_attach_backtrace([0, Assert_failure, dy], 1);
		             }
		             var cst_0x = "0x";
		             function token_int_literal(conv, ib, cont){
		              function a(tok){
		               var l = caml_ml_string_length(tok);
		               if(0 !== l && 43 === caml_string_get(tok, 0))
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub, tok, 1, l - 1 | 0, cont);
		               return cont(tok);
		              }
		              switch(conv){
		                case 0:
		                 return caml_exact_trampoline_cps_call
		                         (token_string, ib, function(s2){return a("0b" + s2);});
		                case 3:
		                 return caml_exact_trampoline_cps_call
		                         (token_string, ib, function(s2){return a("0o" + s2);});
		                case 4:
		                 return caml_exact_trampoline_cps_call
		                         (token_string, ib, function(s2){return a("0u" + s2);});
		                case 5:
		                 return caml_exact_trampoline_cps_call
		                         (token_string, ib, function(s2){return a(cst_0x + s2);});
		                default:
		                 return caml_exact_trampoline_cps_call(token_string, ib, a);
		              }
		             }
		             function token_float(ib, cont){
		              return caml_exact_trampoline_cps_call
		                      (token_string,
		                       ib,
		                       function(a){return cont(caml_float_of_string(a));});
		             }
		             function scan_decimal_digit_star(width, ib, cont){
		              function a(width){
		               return 0 === width
		                       ? cont(width)
		                       : caml_exact_trampoline_cps_call
		                         (peek_char,
		                          ib,
		                          function(c){
		                           if(ib[1]) return cont(width);
		                           if(58 <= c){
		                            if(95 === c){
		                             var width$0 = ignore_char(width, ib);
		                             return caml_exact_trampoline_call1(a, width$0);
		                            }
		                           }
		                           else if(48 <= c)
		                            return caml_exact_trampoline_cps_call$0
		                                    (store_char, width, ib, c, a);
		                           return cont(width);
		                          });
		              }
		              return a(width);
		             }
		             var
		              d = "character ",
		              dz =
		                [0,
		                 [11, d, [1, [11, " is not a decimal digit", 0]]],
		                 "character %C is not a decimal digit"];
		             function scan_decimal_digit_plus(width, ib, cont){
		              return 0 === width
		                      ? caml_exact_trampoline_cps_call
		                        (bad_token_length, "decimal digits", cont)
		                      : caml_exact_trampoline_cps_call
		                        (checked_peek_char,
		                         ib,
		                         function(c){
		                          return 9 < c - 48 >>> 0
		                                  ? caml_exact_trampoline_cps_call
		                                    (sprintf,
		                                     dz,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a, c, function(a){return cont(bad_input(a));});
		                                     })
		                                  : caml_exact_trampoline_cps_call$0
		                                    (store_char,
		                                     width,
		                                     ib,
		                                     c,
		                                     function(width){
		                                      return caml_exact_trampoline_cps_call$1
		      (scan_decimal_digit_star, width, ib, cont);
		                                     });
		                         });
		             }
		             var
		              cst_is_not_a_valid = " is not a valid ",
		              dA =
		                [0,
		                 [11,
		                  d,
		                  [1, [11, cst_is_not_a_valid, [2, 0, [11, " digit", 0]]]]],
		                 "character %C is not a valid %s digit"];
		             function scan_digit_plus(basis, digitp, width, ib, cont){
		              return 0 === width
		                      ? caml_exact_trampoline_cps_call
		                        (bad_token_length, "digits", cont)
		                      : caml_exact_trampoline_cps_call
		                        (checked_peek_char,
		                         ib,
		                         function(c){
		                          if(! digitp(c))
		                           return caml_exact_trampoline_cps_call
		                                   (sprintf,
		                                    dA,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (a, c, basis, function(a){return cont(bad_input(a));});
		                                    });
		                          function a(width){
		                           return 0 === width
		                                   ? cont(width)
		                                   : caml_exact_trampoline_cps_call
		                                     (peek_char,
		                                      ib,
		                                      function(c){
		                                       if(ib[1]) return cont(width);
		                                       if(digitp(c))
		return caml_exact_trampoline_cps_call$0
		        (store_char, width, ib, c, a);
		                                       if(95 !== c) return cont(width);
		                                       var width$0 = ignore_char(width, ib);
		                                       return caml_exact_trampoline_call1(a, width$0);
		                                      });
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (store_char, width, ib, c, a);
		                         });
		             }
		             function is_binary_digit(param){
		              return 1 < param - 48 >>> 0 ? 0 : 1;
		             }
		             function is_octal_digit(param){
		              return 7 < param - 48 >>> 0 ? 0 : 1;
		             }
		             function is_hexa_digit(a){
		              a = a - 48 | 0;
		              a:
		              {
		               if(22 < a >>> 0){
		                if(5 < a - 49 >>> 0) break a;
		               }
		               else if(6 >= a - 10 >>> 0) break a;
		               return 1;
		              }
		              return 0;
		             }
		             function scan_sign(width, ib, cont){
		              return caml_exact_trampoline_cps_call
		                      (checked_peek_char,
		                       ib,
		                       function(c){
		                        var switcher = c - 43 | 0;
		                        if(2 >= switcher >>> 0 && 1 !== switcher)
		                         return caml_exact_trampoline_cps_call$0
		                                 (store_char, width, ib, c, cont);
		                        return cont(width);
		                       });
		             }
		             function scan_optionally_signed_decimal(width, ib, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (scan_sign,
		                       width,
		                       ib,
		                       function(width){
		                        return caml_exact_trampoline_cps_call$1
		                                (scan_decimal_digit_plus, width, ib, cont);
		                       });
		             }
		             var o = "hexadecimal";
		             function scan_int_conversion(conv, width, ib, cont){
		              var a = "binary", b = "octal";
		              switch(conv){
		                case 0:
		                 return caml_exact_trampoline_cps_call$2
		                         (scan_digit_plus, a, is_binary_digit, width, ib, cont);
		                case 1:
		                 return caml_exact_trampoline_cps_call$1
		                         (scan_optionally_signed_decimal, width, ib, cont);
		                case 2:
		                 return caml_exact_trampoline_cps_call$1
		                         (scan_sign,
		                          width,
		                          ib,
		                          function(width){
		                           return caml_exact_trampoline_cps_call
		                                   (checked_peek_char,
		                                    ib,
		                                    function(c){
		                                     return 48 === c
		     ? caml_exact_trampoline_cps_call$0
		       (store_char,
		        width,
		        ib,
		        c,
		        function(width){
		         return 0 === width
		                 ? cont(width)
		                 : caml_exact_trampoline_cps_call
		                   (peek_char,
		                    ib,
		                    function(c){
		                     if(ib[1]) return cont(width);
		                     a:
		                     {
		                      if(99 <= c){
		                       if(111 === c)
		                        return caml_exact_trampoline_cps_call$0
		                                (store_char,
		                                 width,
		                                 ib,
		                                 c,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$2
		  (scan_digit_plus, b, is_octal_digit, a, ib, cont);
		                                 });
		                       if(120 !== c) break a;
		                      }
		                      else if(88 !== c){
		                       if(98 <= c)
		                        return caml_exact_trampoline_cps_call$0
		                                (store_char,
		                                 width,
		                                 ib,
		                                 c,
		                                 function(b){
		                                  return caml_exact_trampoline_cps_call$2
		  (scan_digit_plus, a, is_binary_digit, b, ib, cont);
		                                 });
		                       break a;
		                      }
		                      return caml_exact_trampoline_cps_call$0
		                              (store_char,
		                               width,
		                               ib,
		                               c,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$2
		(scan_digit_plus, o, is_hexa_digit, a, ib, cont);
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$1
		                             (scan_decimal_digit_star, width, ib, cont);
		                    });
		        })
		     : caml_exact_trampoline_cps_call$1
		       (scan_decimal_digit_plus, width, ib, cont);
		                                    });
		                          });
		                case 3:
		                 return caml_exact_trampoline_cps_call$2
		                         (scan_digit_plus, b, is_octal_digit, width, ib, cont);
		                case 4:
		                 return caml_exact_trampoline_cps_call$1
		                         (scan_decimal_digit_plus, width, ib, cont);
		                default:
		                 return caml_exact_trampoline_cps_call$2
		                         (scan_digit_plus, o, is_hexa_digit, width, ib, cont);
		              }
		             }
		             function scan_fractional_part(width, ib, cont){
		              return 0 === width
		                      ? cont(width)
		                      : caml_exact_trampoline_cps_call
		                        (peek_char,
		                         ib,
		                         function(c){
		                          return ib[1]
		                                  ? cont(width)
		                                  : 9
		                                    < c - 48 >>> 0
		                                    ? cont(width)
		                                    : caml_exact_trampoline_cps_call$0
		                                      (store_char,
		                                       width,
		                                       ib,
		                                       c,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (scan_decimal_digit_star, a, ib, cont);
		                                       });
		                         });
		             }
		             function scan_exponent_part(width, ib, cont){
		              return 0 === width
		                      ? cont(width)
		                      : caml_exact_trampoline_cps_call
		                        (peek_char,
		                         ib,
		                         function(c){
		                          if(ib[1]) return cont(width);
		                          if(69 !== c && 101 !== c) return cont(width);
		                          return caml_exact_trampoline_cps_call$0
		                                  (store_char,
		                                   width,
		                                   ib,
		                                   c,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (scan_optionally_signed_decimal, a, ib, cont);
		                                   });
		                         });
		             }
		             function scan_float(width, precision, ib, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (scan_sign,
		                       width,
		                       ib,
		                       function(width){
		                        return caml_exact_trampoline_cps_call$1
		                                (scan_decimal_digit_star,
		                                 width,
		                                 ib,
		                                 function(width){
		                                  return 0 === width
		  ? cont()
		  : caml_exact_trampoline_cps_call
		    (peek_char,
		     ib,
		     function(c){
		      return ib[1]
		              ? cont()
		              : 46
		                === c
		                ? caml_exact_trampoline_cps_call$0
		                  (store_char,
		                   width,
		                   ib,
		                   c,
		                   function(width){
		                    var precision$0 = min$0(width, precision);
		                    return caml_exact_trampoline_cps_call$1
		                            (scan_fractional_part,
		                             precision$0,
		                             ib,
		                             function(a){
		                              var width$0 = width - (precision$0 - a | 0) | 0;
		                              return caml_exact_trampoline_cps_call$1
		                                      (scan_exponent_part,
		                                       width$0,
		                                       ib,
		                                       function(a){return cont();});
		                             });
		                   })
		                : caml_exact_trampoline_cps_call$1
		                  (scan_exponent_part, width, ib, function(a){return cont();});
		     });
		                                 });
		                       });
		             }
		             function check_case_insensitive_string
		             (width, ib, error, str, cont){
		              function lowercase(c, cont){
		               return 25 < c - 65 >>> 0
		                       ? cont(c)
		                       : caml_exact_trampoline_cps_call
		                         (char_of_int, (c - 65 | 0) + 97 | 0, cont);
		              }
		              var len = caml_ml_string_length(str), a = len - 1 | 0;
		              function c(width){return cont(width);}
		              function b(width, i){
		               return caml_exact_trampoline_cps_call
		                       (peek_char,
		                        ib,
		                        function(c$0){
		                         return caml_exact_trampoline_cps_call
		                                 (lowercase,
		                                  caml_string_get(str, i),
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call
		   (lowercase,
		    c$0,
		    function(e){
		     if(e !== d) error();
		     if(0 === width) error();
		     return caml_exact_trampoline_cps_call$0
		             (store_char,
		              width,
		              ib,
		              c$0,
		              function(d){
		               var e = i + 1 | 0;
		               return a !== i ? caml_exact_trampoline_call2(b, d, e) : c(d);
		              });
		    });
		                                  });
		                        });
		              }
		              return a < 0 ? c(width) : b(width, 0);
		             }
		             var cst_an = "an", cst_x = "x";
		             function scan_hex_float(width, precision, ib, cont){
		              var a = 0 === width ? 1 : 0;
		              function b(a){
		               if(a) bad_input(j);
		               return caml_exact_trampoline_cps_call$1
		                       (scan_sign,
		                        width,
		                        ib,
		                        function(width){
		                         var a = 0 === width ? 1 : 0;
		                         function b(a){
		                          if(a) bad_input(j);
		                          return caml_exact_trampoline_cps_call
		                                  (peek_char,
		                                   ib,
		                                   function(c){
		                                    a:
		                                    {
		                                     if(78 <= c){
		                                      var switcher = c - 79 | 0;
		                                      if(30 < switcher >>> 0){
		                                       if(32 <= switcher) break a;
		                                       return caml_exact_trampoline_cps_call$0
		       (store_char,
		        width,
		        ib,
		        c,
		        function(width){
		         var a = 0 === width ? 1 : 0;
		         function b(a){
		          if(a) bad_input(j);
		          return caml_exact_trampoline_cps_call$2
		                  (check_case_insensitive_string,
		                   width,
		                   ib,
		                   bad_hex_float,
		                   cst_an,
		                   cont);
		         }
		         return a
		                 ? b(a)
		                 : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		        });
		                                      }
		                                      if(26 !== switcher) break a;
		                                     }
		                                     else {
		                                      if(48 === c)
		                                       return caml_exact_trampoline_cps_call$0
		       (store_char,
		        width,
		        ib,
		        c,
		        function(width){
		         var a = 0 === width ? 1 : 0;
		         function b(a){
		          if(a) bad_input(j);
		          return caml_exact_trampoline_cps_call$2
		                  (check_case_insensitive_string,
		                   width,
		                   ib,
		                   bad_hex_float,
		                   cst_x,
		                   function(width){
		                    function a(){return cont(width);}
		                    return 0 === width
		                            ? a()
		                            : caml_exact_trampoline_cps_call
		                              (end_of_input,
		                               ib,
		                               function(b){
		                                return b
		? a()
		: caml_exact_trampoline_cps_call
		  (peek_char,
		   ib,
		   function(a){
		    a = a - 46 | 0;
		    function b(width){
		     function a(){return cont(width);}
		     return 0 === width
		             ? a()
		             : caml_exact_trampoline_cps_call
		               (end_of_input,
		                ib,
		                function(b){
		                 return b
		                         ? a()
		                         : caml_exact_trampoline_cps_call
		                           (peek_char,
		                            ib,
		                            function(c){
		                             function a(width){
		                              function a(){return cont(width);}
		                              return 0 === width
		                                      ? a()
		                                      : caml_exact_trampoline_cps_call
		(end_of_input,
		 ib,
		 function(b){
		  return b
		          ? a()
		          : caml_exact_trampoline_cps_call
		            (peek_char,
		             ib,
		             function(c){
		              if(80 !== c && 112 !== c) return cont(width);
		              return caml_exact_trampoline_cps_call$0
		                      (store_char,
		                       width,
		                       ib,
		                       c,
		                       function(width){
		                        var a = 0 === width ? 1 : 0;
		                        function b(a){
		                         if(a) bad_input(j);
		                         return caml_exact_trampoline_cps_call$1
		                                 (scan_optionally_signed_decimal, width, ib, cont);
		                        }
		                        return a
		                                ? b(a)
		                                : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		                       });
		             });
		 });
		                             }
		                             return 46 === c
		                                     ? caml_exact_trampoline_cps_call$0
		                                       (store_char,
		width,
		ib,
		c,
		function(width){
		 return 0 === width
		         ? a(width)
		         : caml_exact_trampoline_cps_call
		           (end_of_input,
		            ib,
		            function(b){
		             return b
		                     ? a(width)
		                     : caml_exact_trampoline_cps_call
		                       (peek_char,
		                        ib,
		                        function(match){
		                         if(80 === match) return a(width);
		                         if(112 === match) return a(width);
		                         var precision$0 = min$0(width, precision);
		                         return caml_exact_trampoline_cps_call$2
		                                 (scan_digit_plus,
		                                  o,
		                                  is_hexa_digit,
		                                  precision$0,
		                                  ib,
		                                  function(b){return a(width - (precision$0 - b | 0) | 0);});
		                        });
		            });
		})
		                                     : a(width);
		                            });
		                });
		    }
		    if(34 < a >>> 0){
		     if(66 === a) return b(width);
		    }
		    else if(32 < a - 1 >>> 0) return b(width);
		    return caml_exact_trampoline_cps_call$2
		            (scan_digit_plus, o, is_hexa_digit, width, ib, b);
		   });
		                               });
		                   });
		         }
		         return a
		                 ? b(a)
		                 : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		        });
		                                      if(73 !== c) break a;
		                                     }
		                                     return caml_exact_trampoline_cps_call$0
		     (store_char,
		      width,
		      ib,
		      c,
		      function(width){
		       var a = 0 === width ? 1 : 0;
		       function b(a){
		        if(a) bad_input(j);
		        return caml_exact_trampoline_cps_call$2
		                (check_case_insensitive_string,
		                 width,
		                 ib,
		                 bad_hex_float,
		                 "nfinity",
		                 cont);
		       }
		       return a
		               ? b(a)
		               : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		      });
		                                    }
		                                    return cont(bad_input(j));
		                                   });
		                         }
		                         return a
		                                 ? b(a)
		                                 : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		                        });
		              }
		              return a
		                      ? b(a)
		                      : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		             }
		             var i = "no dot or exponent part found in float token";
		             function scan_caml_float_rest(width, precision, ib, cont){
		              var a = 0 === width ? 1 : 0;
		              function b(a){
		               if(a) bad_input(i);
		               return caml_exact_trampoline_cps_call$1
		                       (scan_decimal_digit_star,
		                        width,
		                        ib,
		                        function(width){
		                         var a = 0 === width ? 1 : 0;
		                         function b(a){
		                          if(a) bad_input(i);
		                          return caml_exact_trampoline_cps_call
		                                  (peek_char,
		                                   ib,
		                                   function(c){
		                                    var switcher = c - 69 | 0;
		                                    if(32 < switcher >>> 0){
		                                     if(-23 === switcher)
		                                      return caml_exact_trampoline_cps_call$0
		      (store_char,
		       width,
		       ib,
		       c,
		       function(width){
		        var precision$0 = min$0(width, precision);
		        return caml_exact_trampoline_cps_call$1
		                (scan_fractional_part,
		                 precision$0,
		                 ib,
		                 function(width_precision){
		                  var
		                   frac_width = precision$0 - width_precision | 0,
		                   width$0 = width - frac_width | 0;
		                  return caml_exact_trampoline_cps_call$1
		                          (scan_exponent_part, width$0, ib, cont);
		                 });
		       });
		                                    }
		                                    else if(30 < switcher - 1 >>> 0)
		                                     return caml_exact_trampoline_cps_call$1
		     (scan_exponent_part, width, ib, cont);
		                                    return cont(bad_input(i));
		                                   });
		                         }
		                         return a
		                                 ? b(a)
		                                 : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		                        });
		              }
		              return a
		                      ? b(a)
		                      : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		             }
		             function scan_caml_float(width, precision, ib, cont){
		              var a = 0 === width ? 1 : 0;
		              function b(a){
		               if(a) bad_input(i);
		               return caml_exact_trampoline_cps_call$1
		                       (scan_sign,
		                        width,
		                        ib,
		                        function(width){
		                         var a = 0 === width ? 1 : 0;
		                         function b(a){
		                          if(a) bad_input(i);
		                          return caml_exact_trampoline_cps_call
		                                  (peek_char,
		                                   ib,
		                                   function(c){
		                                    if(49 <= c){
		                                     if(58 > c)
		                                      return caml_exact_trampoline_cps_call$0
		      (store_char,
		       width,
		       ib,
		       c,
		       function(width){
		        var a = 0 === width ? 1 : 0;
		        function b(a){
		         if(a) bad_input(i);
		         return caml_exact_trampoline_cps_call$0
		                 (scan_caml_float_rest, width, precision, ib, cont);
		        }
		        return a
		                ? b(a)
		                : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		       });
		                                    }
		                                    else if(48 <= c)
		                                     return caml_exact_trampoline_cps_call$0
		     (store_char,
		      width,
		      ib,
		      c,
		      function(width){
		       var a = 0 === width ? 1 : 0;
		       function b(a){
		        if(a) bad_input(i);
		        return caml_exact_trampoline_cps_call
		                (peek_char,
		                 ib,
		                 function(c){
		                  if(88 !== c && 120 !== c)
		                   return caml_exact_trampoline_cps_call$0
		                           (scan_caml_float_rest, width, precision, ib, cont);
		                  return caml_exact_trampoline_cps_call$0
		                          (store_char,
		                           width,
		                           ib,
		                           c,
		                           function(width){
		                            var a = 0 === width ? 1 : 0;
		                            function b(a){
		                             if(a) bad_input(i);
		                             return caml_exact_trampoline_cps_call$2
		                                     (scan_digit_plus,
		                                      o,
		                                      is_hexa_digit,
		                                      width,
		                                      ib,
		                                      function(width){
		                                       var a = 0 === width ? 1 : 0;
		                                       function b(a){
		if(a) bad_input(i);
		return caml_exact_trampoline_cps_call
		        (peek_char,
		         ib,
		         function(c){
		          var switcher = c - 80 | 0;
		          function a(width){
		           function a(){return cont(width);}
		           return 0 === width
		                   ? a()
		                   : caml_exact_trampoline_cps_call
		                     (end_of_input,
		                      ib,
		                      function(b){
		                       return b
		                               ? a()
		                               : caml_exact_trampoline_cps_call
		                                 (peek_char,
		                                  ib,
		                                  function(c){
		                                   if(80 !== c && 112 !== c) return cont(width);
		                                   return caml_exact_trampoline_cps_call$0
		   (store_char,
		    width,
		    ib,
		    c,
		    function(width){
		     var a = 0 === width ? 1 : 0;
		     function b(a){
		      if(a) bad_input(j);
		      return caml_exact_trampoline_cps_call$1
		              (scan_optionally_signed_decimal, width, ib, cont);
		     }
		     return a
		             ? b(a)
		             : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		    });
		                                  });
		                      });
		          }
		          if(32 < switcher >>> 0){
		           if(-34 === switcher)
		            return caml_exact_trampoline_cps_call$0
		                    (store_char,
		                     width,
		                     ib,
		                     c,
		                     function(width){
		                      return 0 === width
		                              ? a(width)
		                              : caml_exact_trampoline_cps_call
		                                (end_of_input,
		                                 ib,
		                                 function(b){
		                                  return b
		  ? a(width)
		  : caml_exact_trampoline_cps_call
		    (peek_char,
		     ib,
		     function(match){
		      if(80 === match) return a(width);
		      if(112 === match) return a(width);
		      var precision$0 = min$0(width, precision);
		      return caml_exact_trampoline_cps_call$2
		              (scan_digit_plus,
		               o,
		               is_hexa_digit,
		               precision$0,
		               ib,
		               function(b){return a(width - (precision$0 - b | 0) | 0);});
		     });
		                                 });
		                     });
		          }
		          else if(30 < switcher - 1 >>> 0) return a(width);
		          return a(bad_input(i));
		         });
		                                       }
		                                       return a
		       ? b(a)
		       : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		                                      });
		                            }
		                            return a
		                                    ? b(a)
		                                    : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		                           });
		                 });
		       }
		       return a
		               ? b(a)
		               : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		      });
		                                    return cont(bad_input(i));
		                                   });
		                         }
		                         return a
		                                 ? b(a)
		                                 : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		                        });
		              }
		              return a
		                      ? b(a)
		                      : caml_exact_trampoline_cps_call(end_of_input, ib, b);
		             }
		             function scan_string(stp, width, ib, cont){
		              function a(width){
		               return 0 === width
		                       ? cont(width)
		                       : caml_exact_trampoline_cps_call
		                         (peek_char,
		                          ib,
		                          function(c){
		                           if(ib[1]) return cont(width);
		                           if(stp){
		                            var c$0 = stp[1];
		                            return c === c$0
		                                    ? (invalidate_current_char(ib), cont(width))
		                                    : caml_exact_trampoline_cps_call$0
		                                      (store_char, width, ib, c, a);
		                           }
		                           var b = c - 9 | 0;
		                           a:
		                           {
		                            if(4 < b >>> 0){
		                             if(23 !== b) break a;
		                            }
		                            else if(1 >= b - 2 >>> 0) break a;
		                            return cont(width);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (store_char, width, ib, c, a);
		                          });
		              }
		              return a(width);
		             }
		             function hexadecimal_value_of_char(c){
		              return 97 <= c ? c - 87 | 0 : 65 <= c ? c - 55 | 0 : c - 48 | 0;
		             }
		             var
		              dv =
		                [0,
		                 [11,
		                  b,
		                  [2,
		                   0,
		                   [11,
		                    " failed: premature end of file occurred before end of token",
		                    0]]],
		                 "scanning of %s failed: premature end of file occurred before end of token"];
		             function check_next_char(message, width, ib, cont){
		              return 0 === width
		                      ? caml_exact_trampoline_cps_call
		                        (bad_token_length, message, cont)
		                      : caml_exact_trampoline_cps_call
		                        (peek_char,
		                         ib,
		                         function(c){
		                          return ib[1]
		                                  ? caml_exact_trampoline_cps_call
		                                    (sprintf,
		                                     dv,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a, message, function(a){return cont(bad_input(a));});
		                                     })
		                                  : cont(c);
		                         });
		             }
		             var
		              C = "a Char",
		              dC =
		                [0,
		                 [11, "bad character hexadecimal encoding \\", [0, [0, 0]]],
		                 "bad character hexadecimal encoding \\%c%c"],
		              dB =
		                [0,
		                 [11, "bad character decimal encoding \\", [0, [0, [0, 0]]]],
		                 "bad character decimal encoding \\%c%c%c"];
		             function scan_backslash_char(width, ib, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (check_next_char,
		                       C,
		                       width,
		                       ib,
		                       function(c0){
		                        a:
		                        {
		                         if(40 <= c0){
		                          if(58 > c0){
		                           if(48 > c0) break a;
		                           var
		                            get_digit$0 =
		                              function(param, cont){
		                               return caml_exact_trampoline_cps_call
		                                       (next_char,
		ib,
		function(c){
		 return 9 < c - 48 >>> 0
		         ? caml_exact_trampoline_cps_call(bad_input_escape, c, cont)
		         : cont(c);
		});
		                              };
		                           return caml_exact_trampoline_cps_call
		                                   (get_digit$0,
		                                    dummy,
		                                    function(c1){
		                                     return caml_exact_trampoline_cps_call
		     (get_digit$0,
		      dummy,
		      function(c2){
		       var
		        c =
		          ((100 * (c0 - 48 | 0) | 0) + (10 * (c1 - 48 | 0) | 0) | 0)
		          + (c2 - 48 | 0)
		          | 0;
		       function a(a){
		        return caml_exact_trampoline_cps_call$0
		                (store_char, width - 2 | 0, ib, a, cont);
		       }
		       if(0 <= c && 255 >= c)
		        return caml_exact_trampoline_cps_call(char_of_int, c, a);
		       return caml_exact_trampoline_cps_call
		               (sprintf,
		                dB,
		                function(b){
		                 return caml_trampoline_cps_call4
		                         (b, c0, c1, c2, function(b){return a(bad_input(b));});
		                });
		      });
		                                    });
		                          }
		                          var a = c0 - 92 | 0;
		                          if(28 < a >>> 0) break a;
		                          switch(a){
		                            case 28:
		                             var
		                              get_digit =
		                                function(param, cont){
		                                 return caml_exact_trampoline_cps_call
		 (next_char,
		  ib,
		  function(c){
		   var a = c - 48 | 0;
		   a:
		   {
		    if(22 < a >>> 0){
		     if(5 < a - 49 >>> 0) break a;
		    }
		    else if(6 >= a - 10 >>> 0) break a;
		    return cont(c);
		   }
		   return caml_exact_trampoline_cps_call
		           (bad_input_escape, c, cont);
		  });
		                                };
		                             return caml_exact_trampoline_cps_call
		                                     (get_digit,
		                                      dummy,
		                                      function(c1){
		                                       return caml_exact_trampoline_cps_call
		       (get_digit,
		        dummy,
		        function(c2){
		         var
		          b = hexadecimal_value_of_char(c2),
		          c = (16 * hexadecimal_value_of_char(c1) | 0) + b | 0;
		         function a(a){
		          return caml_exact_trampoline_cps_call$0
		                  (store_char, width - 2 | 0, ib, a, cont);
		         }
		         if(0 <= c && 255 >= c)
		          return caml_exact_trampoline_cps_call(char_of_int, c, a);
		         return caml_exact_trampoline_cps_call
		                 (sprintf,
		                  dC,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (b, c1, c2, function(b){return a(bad_input(b));});
		                  });
		        });
		                                      });
		                            case 0:
		                            case 6:
		                            case 18:
		                            case 22:
		                            case 24: break;
		                            default: break a;
		                          }
		                         }
		                         else if(34 !== c0 && 39 > c0) break a;
		                         if(110 <= c0)
		                          if(117 <= c0)
		                           a = c0;
		                          else
		                           switch(c0 - 110 | 0){
		                             case 0:
		                              a = 10; break;
		                             case 4:
		                              a = 13; break;
		                             case 6:
		                              a = 9; break;
		                             default: a = c0;
		                           }
		                         else
		                          a = 98 === c0 ? 8 : c0;
		                         return caml_exact_trampoline_cps_call$0
		                                 (store_char, width, ib, a, cont);
		                        }
		                        return caml_exact_trampoline_cps_call
		                                (bad_input_escape, c0, cont);
		                       });
		             }
		             function scan_caml_string(width, ib, cont){
		              var a = "a String";
		              function find_stop(width, cont){
		               function b(width){
		                return caml_exact_trampoline_cps_call$0
		                        (check_next_char,
		                         a,
		                         width,
		                         ib,
		                         function(c){
		                          if(34 === c) return cont(ignore_char(width, ib));
		                          if(92 !== c)
		                           return caml_exact_trampoline_cps_call$0
		                                   (store_char, width, ib, c, b);
		                          var width$0 = ignore_char(width, ib);
		                          return caml_exact_trampoline_cps_call$0
		                                  (check_next_char,
		                                   a,
		                                   width$0,
		                                   ib,
		                                   function(match){
		                                    if(10 === match)
		                                     return caml_exact_trampoline_cps_call
		     (skip_spaces, ignore_char(width$0, ib), cont);
		                                    if(13 !== match)
		                                     return caml_exact_trampoline_cps_call$1
		     (scan_backslash_char, width$0, ib, b);
		                                    var width = ignore_char(width$0, ib);
		                                    return caml_exact_trampoline_cps_call$0
		    (check_next_char,
		     a,
		     width,
		     ib,
		     function(match){
		      return 10 === match
		              ? caml_exact_trampoline_cps_call
		                (skip_spaces, ignore_char(width, ib), cont)
		              : caml_exact_trampoline_cps_call$0
		                (store_char, width, ib, 13, b);
		     });
		                                   });
		                         });
		               }
		               return b(width);
		              }
		              function skip_spaces(width, cont){
		               function b(width){
		                return caml_exact_trampoline_cps_call$0
		                        (check_next_char,
		                         a,
		                         width,
		                         ib,
		                         function(match){
		                          if(32 !== match)
		                           return caml_exact_trampoline_cps_call
		                                   (find_stop, width, cont);
		                          var width$0 = ignore_char(width, ib);
		                          return caml_exact_trampoline_call1(b, width$0);
		                         });
		               }
		               return b(width);
		              }
		              return caml_exact_trampoline_cps_call
		                      (checked_peek_char,
		                       ib,
		                       function(c){
		                        return 34 === c
		                                ? caml_exact_trampoline_cps_call
		                                  (find_stop, ignore_char(width, ib), cont)
		                                : caml_exact_trampoline_cps_call$1
		                                  (character_mismatch, 34, c, cont);
		                       });
		             }
		             function scan_chars_in_char_set
		             (char_set, scan_indic, width, ib, cont){
		              function scan_chars(i, stp, cont){
		               function a(i){
		                return caml_exact_trampoline_cps_call
		                        (peek_char,
		                         ib,
		                         function(c){
		                          var b = 0 < i ? 1 : 0;
		                          if(b){
		                           b = 1 - ib[1];
		                           if(b)
		                            var
		                             str_ind = c >>> 3 | 0,
		                             mask = 1 << (c & 7),
		                             b =
		                               0 !== (caml_string_get(char_set, str_ind) & mask) ? 1 : 0,
		                             b = b ? c !== stp ? 1 : 0 : b;
		                          }
		                          return b
		                                  ? caml_exact_trampoline_cps_call$0
		                                    (store_char,
		                                     max_value,
		                                     ib,
		                                     c,
		                                     function(b){
		                                      var i$0 = i - 1 | 0;
		                                      return caml_exact_trampoline_call1(a, i$0);
		                                     })
		                                  : cont(b);
		                         });
		               }
		               return a(i);
		              }
		              if(! scan_indic)
		               return caml_exact_trampoline_cps_call$1
		                       (scan_chars, width, -1, cont);
		              var c = scan_indic[1];
		              return caml_exact_trampoline_cps_call$1
		                      (scan_chars,
		                       width,
		                       c,
		                       function(a){
		                        a = 1 - ib[1];
		                        return a
		                                ? caml_exact_trampoline_cps_call
		                                  (peek_char,
		                                   ib,
		                                   function(ci){
		                                    return c === ci
		    ? cont(invalidate_current_char(ib))
		    : caml_exact_trampoline_cps_call$1
		      (character_mismatch, c, ci, cont);
		                                   })
		                                : cont(a);
		                       });
		             }
		             function width_of_pad_opt(pad_opt){
		              if(! pad_opt) return max_value;
		              var width = pad_opt[1];
		              return width;
		             }
		             var dF = [0, 37, cst$1];
		             function stopper_of_formatting_lit(fmting, cont){
		              if(6 === fmting) return cont(dF);
		              var
		               str = string_of_formatting_lit(fmting),
		               stp = caml_string_get(str, 1);
		              return caml_exact_trampoline_cps_call$0
		                      (get_sub,
		                       str,
		                       2,
		                       caml_ml_string_length(str) - 2 | 0,
		                       function(sub_str){return cont([0, stp, sub_str]);});
		             }
		             function take_format_readers(k, fmt$4, cont){
		              a:
		              {
		               var fmt = fmt$4;
		               b:
		               for(;;){
		                if(typeof fmt === "number")
		                 return caml_trampoline_cps_call2(k, 0, cont);
		                switch(fmt[0]){
		                  case 14:
		                   var rest$3 = fmt[3], fmtty = fmt[2];
		                   return caml_exact_trampoline_cps_call$0
		                           (take_fmtty_format_readers,
		                            k,
		                            erase_rel(symm(fmtty)),
		                            rest$3,
		                            cont);
		                  case 18:
		                   var a = fmt[1];
		                   if(0 === a[0]){
		                    var
		                     rest$4 = fmt[2],
		                     fmt$0 = a[1][1],
		                     fmt$1 = concat_fmt(fmt$0, rest$4);
		                    fmt = fmt$1;
		                   }
		                   else {
		                    var
		                     rest$5 = fmt[2],
		                     fmt$2 = a[1][1],
		                     fmt$3 = concat_fmt(fmt$2, rest$5);
		                    fmt = fmt$3;
		                   }
		                   break;
		                  case 19:
		                   break a;
		                  case 23:
		                   var rest$6 = fmt[2], ign = fmt[1];
		                   if(typeof ign === "number"){
		                    if(2 === ign) break b;
		                    fmt = rest$6;
		                   }
		                   else {
		                    if(9 === ign[0]){
		                     var fmtty$0 = ign[2];
		                     return caml_exact_trampoline_cps_call$0
		                             (take_fmtty_format_readers, k, fmtty$0, rest$6, cont);
		                    }
		                    fmt = rest$6;
		                   }
		                   break;
		                  case 13:
		                  case 20:
		                  case 24:
		                   var rest$2 = fmt[3]; fmt = rest$2; break;
		                  case 4:
		                  case 5:
		                  case 6:
		                  case 7:
		                  case 8:
		                   var rest$1 = fmt[4]; fmt = rest$1; break;
		                  case 0:
		                  case 1:
		                  case 10:
		                  case 15:
		                  case 16:
		                  case 22:
		                   var rest = fmt[1]; fmt = rest; break;
		                  default: var rest$0 = fmt[2]; fmt = rest$0;
		                }
		               }
		               return cont
		                       (function(reader, cont){
		                         function new_k(readers_rest, cont){
		                          return caml_trampoline_cps_call2
		                                  (k, [0, reader, readers_rest], cont);
		                         }
		                         return caml_exact_trampoline_cps_call$1
		                                 (take_format_readers, new_k, rest$6, cont);
		                        });
		              }
		              var fmt_rest = fmt[1];
		              return cont
		                      (function(reader, cont){
		                        function new_k(readers_rest, cont){
		                         return caml_trampoline_cps_call2
		                                 (k, [0, reader, readers_rest], cont);
		                        }
		                        return caml_exact_trampoline_cps_call$1
		                                (take_format_readers, new_k, fmt_rest, cont);
		                       });
		             }
		             function take_fmtty_format_readers(k, fmtty$3, fmt, cont){
		              a:
		              {
		               var fmtty = fmtty$3;
		               b:
		               for(;;){
		                if(typeof fmtty === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (take_format_readers, k, fmt, cont);
		                switch(fmtty[0]){
		                  case 8:
		                   var fmtty$1 = fmtty[2]; fmtty = fmtty$1; break;
		                  case 9:
		                   var
		                    rest = fmtty[3],
		                    ty2 = fmtty[2],
		                    ty1 = fmtty[1],
		                    ty = trans(symm(ty1), ty2),
		                    fmtty$2 = concat_fmtty(ty, rest);
		                   fmtty = fmtty$2;
		                   break;
		                  case 13:
		                   break a;
		                  case 14:
		                   break b;
		                  default: var fmtty$0 = fmtty[1]; fmtty = fmtty$0;
		                }
		               }
		               var fmt_rest$0 = fmtty[1];
		               return cont
		                       (function(reader, cont){
		                         function new_k(readers_rest, cont){
		                          return caml_trampoline_cps_call2
		                                  (k, [0, reader, readers_rest], cont);
		                         }
		                         return caml_exact_trampoline_cps_call$0
		                                 (take_fmtty_format_readers, new_k, fmt_rest$0, fmt, cont);
		                        });
		              }
		              var fmt_rest = fmtty[1];
		              return cont
		                      (function(reader, cont){
		                        function new_k(readers_rest, cont){
		                         return caml_trampoline_cps_call2
		                                 (k, [0, reader, readers_rest], cont);
		                        }
		                        return caml_exact_trampoline_cps_call$0
		                                (take_fmtty_format_readers, new_k, fmt_rest, fmt, cont);
		                       });
		             }
		             var
		              b = " and ",
		              cV =
		                [0,
		                 [11,
		                  "bad input: format type mismatch between ",
		                  [3, 0, [11, b, [3, 0, 0]]]],
		                 "bad input: format type mismatch between %S and %S"],
		              b_ = [0, 0, 0],
		              dH = [0, 91],
		              dG = [0, 123],
		              dI = [0, f, 1414, 13],
		              dD =
		                [0,
		                 [11,
		                  "the character ",
		                  [1, [11, " cannot start a boolean", 0]]],
		                 "the character %C cannot start a boolean"];
		             function make_scanf(ib, fmt, readers, cont){
		              function a(fmt){
		               if(typeof fmt === "number") return cont(0);
		               switch(fmt[0]){
		                 case 0:
		                  var rest = fmt[1];
		                  return caml_exact_trampoline_cps_call
		                          (checked_peek_char,
		                           ib,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$0
		                                    (store_char,
		                                     0,
		                                     ib,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (token_char,
		       ib,
		       function(c){
		        return caml_exact_trampoline_cps_call$0
		                (make_scanf,
		                 ib,
		                 rest,
		                 readers,
		                 function(a){return cont([0, c, a]);});
		       });
		                                     });
		                           });
		                 case 1:
		                  var
		                   rest$0 = fmt[1],
		                   find_stop =
		                     function(width, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (check_next_char,
		                               C,
		                               width,
		                               ib,
		                               function(c){
		                                return 39 === c
		? cont(ignore_char(width, ib))
		: caml_exact_trampoline_cps_call$1
		  (character_mismatch, 39, c, cont);
		                               });
		                     };
		                  return caml_exact_trampoline_cps_call
		                          (checked_peek_char,
		                           ib,
		                           function(c){
		                            function a(a){
		                             return caml_exact_trampoline_cps_call
		                                     (token_char,
		                                      ib,
		                                      function(c){
		                                       return caml_exact_trampoline_cps_call$0
		       (make_scanf,
		        ib,
		        rest$0,
		        readers,
		        function(a){return cont([0, c, a]);});
		                                      });
		                            }
		                            if(39 !== c)
		                             return caml_exact_trampoline_cps_call$1
		                                     (character_mismatch, 39, c, a);
		                            var width = ignore_char(0, ib);
		                            return caml_exact_trampoline_cps_call$0
		                                    (check_next_char,
		                                     C,
		                                     width,
		                                     ib,
		                                     function(c){
		                                      return 92 === c
		      ? caml_exact_trampoline_cps_call$1
		        (scan_backslash_char,
		         ignore_char(width, ib),
		         ib,
		         function(b){
		          return caml_exact_trampoline_cps_call(find_stop, b, a);
		         })
		      : caml_exact_trampoline_cps_call$0
		        (store_char,
		         width,
		         ib,
		         c,
		         function(b){
		          return caml_exact_trampoline_cps_call(find_stop, b, a);
		         });
		                                     });
		                           });
		                 case 2:
		                  var pad = fmt[1], match = fmt[2];
		                  if(typeof match !== "number")
		                   switch(match[0]){
		                     case 17:
		                      var rest$2 = match[2], fmting_lit = match[1];
		                      return caml_exact_trampoline_cps_call
		                              (stopper_of_formatting_lit,
		                               fmting_lit,
		                               function(match){
		                                var str = match[2], stp = match[1];
		                                function scan(width, param, ib, cont){
		                                 return caml_exact_trampoline_cps_call$0
		 (scan_string, [0, stp], width, ib, cont);
		                                }
		                                return caml_exact_trampoline_cps_call$8
		(pad_prec_scanf,
		 ib,
		 [11, str, rest$2],
		 readers,
		 pad,
		 0,
		 scan,
		 token_string,
		 cont);
		                               });
		                     case 18:
		                      var b = match[1];
		                      if(0 === b[0]){
		                       var
		                        rest$3 = match[2],
		                        fmt$0 = b[1][1],
		                        scan$0 =
		                          function(width, param, ib, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (scan_string, dG, width, ib, cont);
		                          };
		                       return caml_exact_trampoline_cps_call$8
		                               (pad_prec_scanf,
		                                ib,
		                                concat_fmt(fmt$0, rest$3),
		                                readers,
		                                pad,
		                                0,
		                                scan$0,
		                                token_string,
		                                cont);
		                      }
		                      var
		                       rest$4 = match[2],
		                       fmt$1 = b[1][1],
		                       scan$1 =
		                         function(width, param, ib, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (scan_string, dH, width, ib, cont);
		                         };
		                      return caml_exact_trampoline_cps_call$8
		                              (pad_prec_scanf,
		                               ib,
		                               concat_fmt(fmt$1, rest$4),
		                               readers,
		                               pad,
		                               0,
		                               scan$1,
		                               token_string,
		                               cont);
		                   }
		                  var
		                   rest$1 = fmt[2],
		                   scan =
		                     function(width, param, ib, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (scan_string, 0, width, ib, cont);
		                     };
		                  return caml_exact_trampoline_cps_call$8
		                          (pad_prec_scanf,
		                           ib,
		                           rest$1,
		                           readers,
		                           pad,
		                           0,
		                           scan,
		                           token_string,
		                           cont);
		                 case 3:
		                  var
		                   rest$5 = fmt[2],
		                   pad$0 = fmt[1],
		                   scan$2 =
		                     function(width, param, ib, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (scan_caml_string, width, ib, cont);
		                     };
		                  return caml_exact_trampoline_cps_call$8
		                          (pad_prec_scanf,
		                           ib,
		                           rest$5,
		                           readers,
		                           pad$0,
		                           0,
		                           scan$2,
		                           token_string,
		                           cont);
		                 case 4:
		                  var
		                   rest$6 = fmt[4],
		                   prec = fmt[3],
		                   pad$1 = fmt[2],
		                   iconv$3 = fmt[1],
		                   conv = integer_conversion_of_char(char_of_iconv(iconv$3)),
		                   scan$3 =
		                     function(width, param, ib, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (scan_int_conversion, conv, width, ib, cont);
		                     };
		                  return caml_exact_trampoline_cps_call$8
		                          (pad_prec_scanf,
		                           ib,
		                           rest$6,
		                           readers,
		                           pad$1,
		                           prec,
		                           scan$3,
		                           function(ib, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (token_int_literal,
		                                     conv,
		                                     ib,
		                                     function(a){return cont(caml_int_of_string(a));});
		                           },
		                           cont);
		                 case 5:
		                  var
		                   rest$7 = fmt[4],
		                   prec$0 = fmt[3],
		                   pad$2 = fmt[2],
		                   iconv$4 = fmt[1],
		                   conv$0 = integer_conversion_of_char(char_of_iconv(iconv$4)),
		                   scan$4 =
		                     function(width, param, ib, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (scan_int_conversion, conv$0, width, ib, cont);
		                     };
		                  return caml_exact_trampoline_cps_call$8
		                          (pad_prec_scanf,
		                           ib,
		                           rest$7,
		                           readers,
		                           pad$2,
		                           prec$0,
		                           scan$4,
		                           function(ib, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (token_int_literal,
		                                     conv$0,
		                                     ib,
		                                     function(a){return cont(caml_int_of_string(a));});
		                           },
		                           cont);
		                 case 6:
		                  var
		                   rest$8 = fmt[4],
		                   prec$1 = fmt[3],
		                   pad$3 = fmt[2],
		                   iconv$5 = fmt[1],
		                   conv$1 = integer_conversion_of_char(char_of_iconv(iconv$5)),
		                   scan$5 =
		                     function(width, param, ib, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (scan_int_conversion, conv$1, width, ib, cont);
		                     };
		                  return caml_exact_trampoline_cps_call$8
		                          (pad_prec_scanf,
		                           ib,
		                           rest$8,
		                           readers,
		                           pad$3,
		                           prec$1,
		                           scan$5,
		                           function(ib, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (token_int_literal,
		                                     conv$1,
		                                     ib,
		                                     function(a){return cont(caml_int_of_string(a));});
		                           },
		                           cont);
		                 case 7:
		                  var
		                   rest$9 = fmt[4],
		                   prec$2 = fmt[3],
		                   pad$4 = fmt[2],
		                   iconv$6 = fmt[1],
		                   conv$2 = integer_conversion_of_char(char_of_iconv(iconv$6)),
		                   scan$6 =
		                     function(width, param, ib, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (scan_int_conversion, conv$2, width, ib, cont);
		                     };
		                  return caml_exact_trampoline_cps_call$8
		                          (pad_prec_scanf,
		                           ib,
		                           rest$9,
		                           readers,
		                           pad$4,
		                           prec$2,
		                           scan$6,
		                           function(ib, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (token_int_literal,
		                                     conv$2,
		                                     ib,
		                                     function(a){return cont(caml_int64_of_string(a));});
		                           },
		                           cont);
		                 case 8:
		                  switch(fmt[1][2]){
		                    case 5:
		                    case 8:
		                     var rest$11 = fmt[4], prec$4 = fmt[3], pad$6 = fmt[2];
		                     return caml_exact_trampoline_cps_call$8
		                             (pad_prec_scanf,
		                              ib,
		                              rest$11,
		                              readers,
		                              pad$6,
		                              prec$4,
		                              scan_caml_float,
		                              token_float,
		                              cont);
		                    case 6:
		                    case 7:
		                     var rest$12 = fmt[4], prec$5 = fmt[3], pad$7 = fmt[2];
		                     return caml_exact_trampoline_cps_call$8
		                             (pad_prec_scanf,
		                              ib,
		                              rest$12,
		                              readers,
		                              pad$7,
		                              prec$5,
		                              scan_hex_float,
		                              token_float,
		                              cont);
		                    default:
		                     var rest$10 = fmt[4], prec$3 = fmt[3], pad$5 = fmt[2];
		                     return caml_exact_trampoline_cps_call$8
		                             (pad_prec_scanf,
		                              ib,
		                              rest$10,
		                              readers,
		                              pad$5,
		                              prec$3,
		                              scan_float,
		                              token_float,
		                              cont);
		                  }
		                 case 9:
		                  var
		                   rest$13 = fmt[2],
		                   pad$8 = fmt[1],
		                   scan$7 =
		                     function(a, param, ib, cont){
		                      return caml_exact_trampoline_cps_call
		                              (checked_peek_char,
		                               ib,
		                               function(c){
		                                function a(m){
		                                 return caml_exact_trampoline_cps_call$0
		 (scan_string, 0, m, ib, cont);
		                                }
		                                return 102 === c
		? a(5)
		: 116
		  === c
		  ? a(4)
		  : caml_exact_trampoline_cps_call
		    (sprintf,
		     dD,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b, c, function(b){return a(bad_input(b));});
		     });
		                               });
		                     };
		                  return caml_exact_trampoline_cps_call$8
		                          (pad_prec_scanf,
		                           ib,
		                           rest$13,
		                           readers,
		                           pad$8,
		                           0,
		                           scan$7,
		                           token_bool,
		                           cont);
		                 case 10:
		                  var rest$14 = fmt[1];
		                  return caml_exact_trampoline_cps_call
		                          (end_of_input,
		                           ib,
		                           function(b){
		                            return b
		                                    ? caml_exact_trampoline_call1(a, rest$14)
		                                    : cont(bad_input("end of input not found"));
		                           });
		                 case 11:
		                  var
		                   rest$15 = fmt[2],
		                   str = fmt[1],
		                   c = caml_ml_string_length(str) - 1 | 0,
		                   f =
		                     function(i){
		                      return caml_exact_trampoline_cps_call$1
		                              (check_char,
		                               ib,
		                               caml_string_unsafe_get(str, i),
		                               function(b){
		                                b = i + 1 | 0;
		                                return c !== i
		? caml_exact_trampoline_call1(f, b)
		: caml_exact_trampoline_call1(a, rest$15);
		                               });
		                     };
		                  return c < 0
		                          ? caml_exact_trampoline_call1(a, rest$15)
		                          : f(0);
		                 case 12:
		                  var rest$16 = fmt[2], chr = fmt[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (check_char,
		                           ib,
		                           chr,
		                           function(b){return caml_exact_trampoline_call1(a, rest$16);});
		                 case 13:
		                  var rest$17 = fmt[3], fmtty$1 = fmt[2], pad_opt$9 = fmt[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (scan_caml_string,
		                           width_of_pad_opt(pad_opt$9),
		                           ib,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (token_string,
		                                     ib,
		                                     function(str){
		                                      function a(fmt){
		                                       return caml_exact_trampoline_cps_call$0
		       (make_scanf,
		        ib,
		        rest$17,
		        readers,
		        function(a){return cont([0, fmt, a]);});
		                                      }
		                                      caml_push_trap
		                                       (function(exn){
		 if(exn[1] === Failure){
		  var msg = exn[2];
		  return a(bad_input(msg));
		 }
		 var
		  raise = caml_pop_trap(),
		  exn$0 = caml_maybe_attach_backtrace(exn, 0);
		 return raise(exn$0);
		});
		                                      return caml_exact_trampoline_cps_call$1
		      (fmt_ebb_of_string,
		       0,
		       str,
		       function(match){
		        var fmt = match[1];
		        function c(b){caml_pop_trap(); return a(b);}
		        try{var b = [0, type_format(fmt, fmtty$1), str];}
		        catch(exn$1){
		         var exn = caml_wrap_exception(exn$1);
		         if(exn === Type_mismatch)
		          return caml_exact_trampoline_cps_call
		                  (string_of_fmtty,
		                   fmtty$1,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (failwith_message,
		                             cV,
		                             function(b){return caml_trampoline_cps_call3(b, str, a, c);});
		                   });
		         b = caml_pop_trap();
		         var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		         return b(exn$0);
		        }
		        return c(b);
		       });
		                                     });
		                           });
		                 case 14:
		                  var rest$18 = fmt[3], fmtty$2 = fmt[2], pad_opt$10 = fmt[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (scan_caml_string,
		                           width_of_pad_opt(pad_opt$10),
		                           ib,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (token_string,
		                                     ib,
		                                     function(s){
		                                      function a(fmt, fmt$0){
		                                       return caml_exact_trampoline_cps_call$0
		       (make_scanf,
		        ib,
		        concat_fmt(fmt$0, rest$18),
		        readers,
		        function(a){return cont([0, [0, fmt, s], a]);});
		                                      }
		                                      caml_push_trap
		                                       (function(exn){
		 if(exn[1] === Failure){
		  var msg = exn[2], b = bad_input(msg);
		  return a(b[1], b[2]);
		 }
		 b = caml_pop_trap();
		 var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		 return b(exn$0);
		});
		                                      return caml_exact_trampoline_cps_call$1
		      (fmt_ebb_of_string,
		       0,
		       s,
		       function(match){
		        var fmt = match[1];
		        return caml_exact_trampoline_cps_call$1
		                (fmt_ebb_of_string,
		                 0,
		                 s,
		                 function(b){
		                  var
		                   fmt$0 = b[1],
		                   fmt$1 = type_format(fmt$0, erase_rel(symm(fmtty$2))),
		                   b = type_format(fmt, erase_rel(fmtty$2));
		                  caml_pop_trap();
		                  return a(b, fmt$1);
		                 });
		       });
		                                     });
		                           });
		                 case 15:
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg, 'scanf: bad conversion "%a"', cont);
		                 case 16:
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg, 'scanf: bad conversion "%t"', cont);
		                 case 17:
		                  var
		                   rest$19 = fmt[2],
		                   formatting_lit = fmt[1],
		                   s = string_of_formatting_lit(formatting_lit),
		                   d = caml_ml_string_length(s) - 1 | 0,
		                   e =
		                     function(i){
		                      return caml_exact_trampoline_cps_call$1
		                              (check_char,
		                               ib,
		                               caml_string_unsafe_get(s, i),
		                               function(b){
		                                b = i + 1 | 0;
		                                return d !== i
		? caml_exact_trampoline_call1(e, b)
		: caml_exact_trampoline_call1(a, rest$19);
		                               });
		                     };
		                  return d < 0
		                          ? caml_exact_trampoline_call1(a, rest$19)
		                          : e(0);
		                 case 18:
		                  b = fmt[1];
		                  if(0 === b[0]){
		                   var rest$20 = fmt[2], fmt$2 = b[1][1];
		                   return caml_exact_trampoline_cps_call$1
		                           (check_char,
		                            ib,
		                            64,
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (check_char,
		                                      ib,
		                                      123,
		                                      function(b){
		                                       var fmt = concat_fmt(fmt$2, rest$20);
		                                       return caml_exact_trampoline_call1(a, fmt);
		                                      });
		                            });
		                  }
		                  var rest$21 = fmt[2], fmt$3 = b[1][1];
		                  return caml_exact_trampoline_cps_call$1
		                          (check_char,
		                           ib,
		                           64,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (check_char,
		                                     ib,
		                                     91,
		                                     function(b){
		                                      var fmt = concat_fmt(fmt$3, rest$21);
		                                      return caml_exact_trampoline_call1(a, fmt);
		                                     });
		                           });
		                 case 19:
		                  var fmt_rest = fmt[1];
		                  if(! readers)
		                   return caml_exact_trampoline_cps_call
		                           (invalid_arg, "scanf: missing reader", cont);
		                  var readers_rest = readers[2], reader = readers[1];
		                  return caml_trampoline_cps_call2
		                          (reader,
		                           ib,
		                           function(x){
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_scanf,
		                                     ib,
		                                     fmt_rest,
		                                     readers_rest,
		                                     function(a){return cont([0, x, a]);});
		                           });
		                 case 20:
		                  var width_opt$0 = fmt[1], b = fmt[3];
		                  if(typeof b !== "number" && 17 === b[0]){
		                   var
		                    rest$23 = b[2],
		                    fmting_lit$0 = b[1],
		                    char_set$1 = fmt[2];
		                   return caml_exact_trampoline_cps_call
		                           (stopper_of_formatting_lit,
		                            fmting_lit$0,
		                            function(match){
		                             var
		                              str = match[2],
		                              stp = match[1],
		                              width = width_of_pad_opt(width_opt$0);
		                             return caml_exact_trampoline_cps_call$2
		                                     (scan_chars_in_char_set,
		                                      char_set$1,
		                                      [0, stp],
		                                      width,
		                                      ib,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (token_string,
		        ib,
		        function(s){
		         return caml_exact_trampoline_cps_call$0
		                 (make_scanf,
		                  ib,
		                  [11, str, rest$23],
		                  readers,
		                  function(a){return cont([0, s, a]);});
		        });
		                                      });
		                            });
		                  }
		                  var
		                   rest$22 = fmt[3],
		                   char_set$0 = fmt[2],
		                   width = width_of_pad_opt(width_opt$0);
		                  return caml_exact_trampoline_cps_call$2
		                          (scan_chars_in_char_set,
		                           char_set$0,
		                           0,
		                           width,
		                           ib,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (token_string,
		                                     ib,
		                                     function(s){
		                                      return caml_exact_trampoline_cps_call$0
		      (make_scanf,
		       ib,
		       rest$22,
		       readers,
		       function(a){return cont([0, s, a]);});
		                                     });
		                           });
		                 case 21:
		                  var rest$24 = fmt[2], counter$0 = fmt[1];
		                  switch(counter$0){
		                    case 0:
		                     var count = ib[5]; break;
		                    case 1:
		                     count = char_count(ib); break;
		                    default: count = ib[6];
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (make_scanf,
		                           ib,
		                           rest$24,
		                           readers,
		                           function(a){return cont([0, count, a]);});
		                 case 22:
		                  var rest$25 = fmt[1];
		                  return caml_exact_trampoline_cps_call
		                          (checked_peek_char,
		                           ib,
		                           function(c){
		                            return caml_exact_trampoline_cps_call$0
		                                    (make_scanf,
		                                     ib,
		                                     rest$25,
		                                     readers,
		                                     function(a){return cont([0, c, a]);});
		                           });
		                 case 23:
		                  var rest$26 = fmt[2], ign = fmt[1];
		                  if(typeof ign === "number")
		                   switch(ign){
		                     case 0:
		                      b = [0, [0, rest$26]]; break;
		                     case 1:
		                      b = [0, [1, rest$26]]; break;
		                     case 2:
		                      b = [0, [19, rest$26]]; break;
		                     default: b = [0, [22, rest$26]];
		                   }
		                  else
		                   switch(ign[0]){
		                     case 0:
		                      var
		                       pad_opt = ign[1],
		                       b = [0, [2, pad_of_pad_opt(pad_opt), rest$26]];
		                      break;
		                     case 1:
		                      var
		                       pad_opt$0 = ign[1],
		                       b = [0, [3, pad_of_pad_opt(pad_opt$0), rest$26]];
		                      break;
		                     case 2:
		                      var
		                       pad_opt$1 = ign[2],
		                       iconv = ign[1],
		                       b = [0, [4, iconv, pad_of_pad_opt(pad_opt$1), 0, rest$26]];
		                      break;
		                     case 3:
		                      var
		                       pad_opt$2 = ign[2],
		                       iconv$0 = ign[1],
		                       b = [0, [5, iconv$0, pad_of_pad_opt(pad_opt$2), 0, rest$26]];
		                      break;
		                     case 4:
		                      var
		                       pad_opt$3 = ign[2],
		                       iconv$1 = ign[1],
		                       b = [0, [6, iconv$1, pad_of_pad_opt(pad_opt$3), 0, rest$26]];
		                      break;
		                     case 5:
		                      var
		                       pad_opt$4 = ign[2],
		                       iconv$2 = ign[1],
		                       b = [0, [7, iconv$2, pad_of_pad_opt(pad_opt$4), 0, rest$26]];
		                      break;
		                     case 6:
		                      var prec_opt = ign[2], pad_opt$5 = ign[1];
		                      if(prec_opt)
		                       var ndec = prec_opt[1], b = [0, ndec];
		                      else
		                       b = 0;
		                      b = [0, [8, b_, pad_of_pad_opt(pad_opt$5), b, rest$26]];
		                      break;
		                     case 7:
		                      var
		                       pad_opt$6 = ign[1],
		                       b = [0, [9, pad_of_pad_opt(pad_opt$6), rest$26]];
		                      break;
		                     case 8:
		                      var
		                       fmtty = ign[2],
		                       pad_opt$7 = ign[1],
		                       b = [0, [13, pad_opt$7, fmtty, rest$26]];
		                      break;
		                     case 9:
		                      var
		                       fmtty$0 = ign[2],
		                       pad_opt$8 = ign[1],
		                       b = [0, [14, pad_opt$8, fmtty$0, rest$26]];
		                      break;
		                     case 10:
		                      var
		                       char_set = ign[2],
		                       width_opt = ign[1],
		                       b = [0, [20, width_opt, char_set, rest$26]];
		                      break;
		                     default:
		                      var counter = ign[1], b = [0, [21, counter, rest$26]];
		                   }
		                  var fmt$4 = b[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (make_scanf,
		                           ib,
		                           fmt$4,
		                           readers,
		                           function(a){
		                            if(a){var arg_rest = a[2]; return cont(arg_rest);}
		                            a = caml_pop_trap();
		                            return a
		                                    (caml_maybe_attach_backtrace([0, Assert_failure, dI], 1));
		                           });
		                 default:
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg,
		                           'scanf: bad conversion "%?" (custom converter)',
		                           cont);
		               }
		              }
		              return a(fmt);
		             }
		             function pad_prec_scanf
		             (ib, fmt, readers, pad, prec, scan, token, cont){
		              var cst_scanf_bad_conversion = 'scanf: bad conversion "%*"';
		              if(typeof pad === "number"){
		               if(typeof prec === "number")
		                return prec
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg, cst_scanf_bad_conversion, cont)
		                        : caml_exact_trampoline_cps_call$0
		                          (scan,
		                           max_value,
		                           max_value,
		                           ib,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (token,
		                                     ib,
		                                     function(x){
		                                      return caml_exact_trampoline_cps_call$0
		      (make_scanf,
		       ib,
		       fmt,
		       readers,
		       function(a){return cont([0, x, a]);});
		                                     });
		                           });
		               var p = prec[1];
		               return caml_exact_trampoline_cps_call$0
		                       (scan,
		                        max_value,
		                        p,
		                        ib,
		                        function(a){
		                         return caml_exact_trampoline_cps_call
		                                 (token,
		                                  ib,
		                                  function(x){
		                                   return caml_exact_trampoline_cps_call$0
		   (make_scanf,
		    ib,
		    fmt,
		    readers,
		    function(a){return cont([0, x, a]);});
		                                  });
		                        });
		              }
		              if(0 !== pad[0])
		               return caml_exact_trampoline_cps_call
		                       (invalid_arg, cst_scanf_bad_conversion, cont);
		              if(! pad[1])
		               return caml_exact_trampoline_cps_call
		                       (invalid_arg, 'scanf: bad conversion "%-"', cont);
		              var w = pad[2];
		              if(typeof prec === "number")
		               return prec
		                       ? caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_scanf_bad_conversion, cont)
		                       : caml_exact_trampoline_cps_call$0
		                         (scan,
		                          w,
		                          max_value,
		                          ib,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (token,
		                                    ib,
		                                    function(x){
		                                     return caml_exact_trampoline_cps_call$0
		     (make_scanf,
		      ib,
		      fmt,
		      readers,
		      function(a){return cont([0, x, a]);});
		                                    });
		                          });
		              var p$0 = prec[1];
		              return caml_exact_trampoline_cps_call$0
		                      (scan,
		                       w,
		                       p$0,
		                       ib,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (token,
		                                 ib,
		                                 function(x){
		                                  return caml_exact_trampoline_cps_call$0
		  (make_scanf,
		   ib,
		   fmt,
		   readers,
		   function(a){return cont([0, x, a]);});
		                                 });
		                       });
		             }
		             var
		              cst$20 = '"',
		              dE =
		                [0,
		                 [11,
		                  "scanf: bad input at char number ",
		                  [4, 3, 0, 0, [11, cst$9, [2, 0, 0]]]],
		                 "scanf: bad input at char number %i: %s"];
		             function sscanf(s, fmt$0, cont){
		              var len = caml_ml_string_length(s), i = [0, 0];
		              function next(param, a){
		               if(len <= i[1]){
		                a = caml_pop_trap();
		                var
		                 End_of_file$0 = caml_maybe_attach_backtrace(End_of_file, 1);
		                return a(End_of_file$0);
		               }
		               var c = caml_string_get(s, i[1]);
		               i[1]++;
		               return a(c);
		              }
		              var
		               ib = [0, 0, null_char, 0, 0, 0, 0, next, create$1(1024), 1],
		               str = fmt$0[2],
		               fmt = fmt$0[1];
		              function k(readers, f, cont){
		               reset(ib[8]);
		               caml_push_trap
		                (function(exc){
		                  if
		                   (exc[1] !== Scan_failure
		                    && exc[1] !== Failure && exc !== End_of_file){
		                   if(exc[1] === Invalid_argument){
		                    var
		                     msg = exc[2],
		                     s1 = escaped$0(str),
		                     s2$0 = s1 + cst$20,
		                     s2 = ' in format "' + s2$0;
		                    return caml_exact_trampoline_cps_call
		                            (invalid_arg, msg + s2, cont);
		                   }
		                   var
		                    a = caml_pop_trap(),
		                    exc$1 = caml_maybe_attach_backtrace(exc, 0);
		                   return a(exc$1);
		                  }
		                  if(exc[1] === Scan_failure)
		                   var s = exc[2];
		                  else {
		                   if(exc[1] !== Failure){
		                    a = caml_pop_trap();
		                    var exc$0 = caml_maybe_attach_backtrace(exc, 1);
		                    return a(exc$0);
		                   }
		                   s = exc[2];
		                  }
		                  var i = char_count(ib);
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           dE,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (a, i, s, function(a){return cont(bad_input(a));});
		                           });
		                 });
		               return caml_exact_trampoline_cps_call$0
		                       (make_scanf,
		                        ib,
		                        fmt,
		                        readers,
		                        function(args){
		                         function a(f, args){
		                          if(! args) return cont(f);
		                          var args$0 = args[2], x = args[1];
		                          return caml_trampoline_cps_call2
		                                  (f,
		                                   x,
		                                   function(f){
		                                    return caml_exact_trampoline_call2(a, f, args$0);
		                                   });
		                         }
		                         caml_pop_trap();
		                         return a(f, args);
		                        });
		              }
		              return caml_exact_trampoline_cps_call$1
		                      (take_format_readers, k, fmt, cont);
		             }
		             function register_exception(name, exn){
		              var slot = caml_obj_tag(exn) === 248 ? exn : exn[1];
		              caml_register_named_value(name, slot);
		             }
		             function public_method_label(s){
		              var c = caml_ml_string_length(s) - 1 | 0, a = 0;
		              if(c < 0)
		               var accu$1 = a;
		              else {
		               var accu$0 = a, i = 0;
		               for(;;){
		                a = (223 * accu$0 | 0) + caml_string_get(s, i) | 0;
		                var b = i + 1 | 0;
		                if(c === i){accu$1 = a; break;}
		                accu$0 = a;
		                i = b;
		               }
		              }
		              var
		               accu = accu$1 & 2147483647,
		               b = 1073741823 < accu ? accu + 2147483648 | 0 : accu;
		              return b;
		             }
		             function compare$1(x, y, cont){
		              return cont(caml_string_compare(x, y));
		             }
		             var Vars = k([0, compare$1]);
		             function compare$2(x, y, cont){
		              return cont(caml_string_compare(x, y));
		             }
		             var Meths = k([0, compare$2]);
		             function compare$3(x, y, cont){
		              return cont(caml_int_compare(x, y));
		             }
		             var Labs = k([0, compare$3]), dummy_met = caml_obj_block(0, 0);
		             function fit_size(n){
		              return 2 < n ? fit_size((n + 1 | 0) / 2 | 0) * 2 | 0 : n;
		             }
		             function new_table(pub_labels){
		              var
		               len = pub_labels.length - 1,
		               methods = caml_make_vect((len * 2 | 0) + 2 | 0, dummy_met);
		              caml_check_bound(methods, 0)[1] = len;
		              var a = ((fit_size(len) * 32 | 0) / 8 | 0) - 1 | 0;
		              caml_check_bound(methods, 1)[2] = a;
		              a = len - 1 | 0;
		              if(a >= 0){
		               var i = 0;
		               for(;;){
		                var
		                 c = (i * 2 | 0) + 3 | 0,
		                 b = caml_check_bound(pub_labels, i)[i + 1];
		                caml_check_bound(methods, c)[c + 1] = b;
		                b = i + 1 | 0;
		                if(a === i) break;
		                i = b;
		               }
		              }
		              return [0, 2, methods, Meths[1], Labs[1], , 0, Vars[1], 0];
		             }
		             function resize$1(array, new_size, cont){
		              var old_size = array[2].length - 1;
		              function a(){return cont();}
		              if(old_size >= new_size) return a();
		              var new_buck = caml_make_vect(new_size, dummy_met);
		              return caml_exact_trampoline_cps_call$3
		                      (blit$0,
		                       array[2],
		                       0,
		                       new_buck,
		                       0,
		                       old_size,
		                       function(b){array[2] = new_buck; return a();});
		             }
		             function new_method(table, cont){
		              var index = table[2].length - 1;
		              return caml_exact_trampoline_cps_call$1
		                      (resize$1,
		                       table,
		                       index + 1 | 0,
		                       function(a){return cont(index);});
		             }
		             function new_variable(table, name, cont){
		              caml_push_trap
		               (function(exn){
		                 if(exn === Not_found){
		                  var index = table[1];
		                  table[1] = index + 1 | 0;
		                  var a = function(){return cont(index);};
		                  return name !== cst$1
		                          ? caml_exact_trampoline_cps_call$0
		                            (Vars[2],
		                             name,
		                             index,
		                             table[7],
		                             function(b){table[7] = b; return a();})
		                          : a();
		                 }
		                 var
		                  raise = caml_pop_trap(),
		                  exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                 return raise(exn$0);
		                });
		              return caml_exact_trampoline_cps_call$1
		                      (Vars[17],
		                       name,
		                       table[7],
		                       function(a){caml_pop_trap(); return cont(a);});
		             }
		             function create_table(public_methods, cont){
		              if(0 === public_methods) return cont(new_table([0]));
		              var
		               tags = map$2(public_method_label, public_methods),
		               table = new_table(tags),
		               a = public_methods.length - 2 | 0;
		              function c(){return cont(table);}
		              function b(i){
		               var met = public_methods[i + 1], lab = (i * 2 | 0) + 2 | 0;
		               return caml_exact_trampoline_cps_call$0
		                       (Meths[2],
		                        met,
		                        lab,
		                        table[3],
		                        function(d){
		                         table[3] = d;
		                         return caml_exact_trampoline_cps_call$0
		                                 (Labs[2],
		                                  lab,
		                                  1,
		                                  table[4],
		                                  function(d){
		                                   table[4] = d;
		                                   d = i + 1 | 0;
		                                   return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		                                  });
		                        });
		              }
		              return a < 0 ? c() : b(0);
		             }
		             function init_class(table, cont){
		              table[8] = rev(table[8]);
		              return caml_exact_trampoline_cps_call$1
		                      (resize$1,
		                       table,
		                       3 + ((caml_check_bound(table[2], 1)[2] * 16 | 0) / 32 | 0)
		                       | 0,
		                       cont);
		             }
		             function create_object_opt(obj_0, table){
		              var obj = caml_obj_block(248, table[1]);
		              obj[1] = table[2];
		              return caml_set_oo_id(obj);
		             }
		             function new_cache(table, cont){
		              return caml_exact_trampoline_cps_call
		                      (new_method,
		                       table,
		                       function(n){
		                        function a(n){
		                         caml_check_bound(table[2], n)[n + 1] = 0;
		                         return cont(n);
		                        }
		                        return 0 === (n % 2 | 0)
		                                ? a(n)
		                                : (2
		                                  + ((caml_check_bound(table[2], 1)[2] * 16 | 0) / 32 | 0)
		                                  | 0)
		                                  < n
		                                  ? a(n)
		                                  : caml_exact_trampoline_cps_call(new_method, table, a);
		                       });
		             }
		             function method_impl(table, i, arr, cont){
		              function next(a){
		               i[1]++;
		               a = i[1];
		               return caml_check_bound(arr, a)[a + 1];
		              }
		              var clo = next();
		              if(typeof clo === "number")
		               switch(clo){
		                 case 0:
		                  var x = next();
		                  return cont(function(obj, cont){return cont(x);});
		                 case 1:
		                  var n = next();
		                  return cont(function(obj, cont){return cont(obj[n + 1]);});
		                 case 2:
		                  var e = next(), n$0 = next();
		                  return cont
		                          (function(obj, cont){return cont(obj[e + 1][n$0 + 1]);});
		                 case 3:
		                  var n$1 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2(obj[1][n$1 + 1], obj, cont);
		                           });
		                 case 4:
		                  var n$2 = next();
		                  return cont
		                          (function(obj, x, cont){obj[n$2 + 1] = x; return cont(0);});
		                 case 5:
		                  var f = next(), x$0 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2(f, x$0, cont);
		                           });
		                 case 6:
		                  var f$0 = next(), n$3 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2(f$0, obj[n$3 + 1], cont);
		                           });
		                 case 7:
		                  var f$1 = next(), e$0 = next(), n$4 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2
		                                    (f$1, obj[e$0 + 1][n$4 + 1], cont);
		                           });
		                 case 8:
		                  var f$2 = next(), n$5 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2
		                                    (obj[1][n$5 + 1],
		                                     obj,
		                                     function(a){return caml_trampoline_cps_call2(f$2, a, cont);});
		                           });
		                 case 9:
		                  var f$3 = next(), x$1 = next(), y = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3(f$3, x$1, y, cont);
		                           });
		                 case 10:
		                  var f$4 = next(), x$2 = next(), n$6 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3
		                                    (f$4, x$2, obj[n$6 + 1], cont);
		                           });
		                 case 11:
		                  var f$5 = next(), x$3 = next(), e$1 = next(), n$7 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3
		                                    (f$5, x$3, obj[e$1 + 1][n$7 + 1], cont);
		                           });
		                 case 12:
		                  var f$6 = next(), x$4 = next(), n$8 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2
		                                    (obj[1][n$8 + 1],
		                                     obj,
		                                     function(a){
		                                      return caml_trampoline_cps_call3(f$6, x$4, a, cont);
		                                     });
		                           });
		                 case 13:
		                  var f$7 = next(), n$9 = next(), x$5 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3
		                                    (f$7, obj[n$9 + 1], x$5, cont);
		                           });
		                 case 14:
		                  var f$8 = next(), e$2 = next(), n$10 = next(), x$6 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3
		                                    (f$8, obj[e$2 + 1][n$10 + 1], x$6, cont);
		                           });
		                 case 15:
		                  var f$9 = next(), n$11 = next(), x$7 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2
		                                    (obj[1][n$11 + 1],
		                                     obj,
		                                     function(a){
		                                      return caml_trampoline_cps_call3(f$9, a, x$7, cont);
		                                     });
		                           });
		                 case 16:
		                  var n$12 = next(), x$8 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3
		                                    (obj[1][n$12 + 1], obj, x$8, cont);
		                           });
		                 case 17:
		                  var n$13 = next(), m = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3
		                                    (obj[1][n$13 + 1], obj, obj[m + 1], cont);
		                           });
		                 case 18:
		                  var n$14 = next(), e$3 = next(), m$0 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call3
		                                    (obj[1][n$14 + 1], obj, obj[e$3 + 1][m$0 + 1], cont);
		                           });
		                 case 19:
		                  var n$15 = next(), m$1 = next();
		                  return cont
		                          (function(obj, cont){
		                            return caml_trampoline_cps_call2
		                                    (obj[1][m$1 + 1],
		                                     obj,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (obj[1][n$15 + 1], obj, a, cont);
		                                     });
		                           });
		                 case 20:
		                  var m$2 = next(), x$9 = next();
		                  return caml_exact_trampoline_cps_call
		                          (new_cache,
		                           table,
		                           function(c){
		                            return cont
		                                    (function(obj, cont){
		                                      return caml_trampoline_cps_call2
		      (caml_get_public_method(x$9, m$2), x$9, cont);
		                                     });
		                           });
		                 case 21:
		                  var m$3 = next(), n$16 = next();
		                  return caml_exact_trampoline_cps_call
		                          (new_cache,
		                           table,
		                           function(c){
		                            return cont
		                                    (function(obj, cont){
		                                      var a = obj[n$16 + 1];
		                                      return caml_trampoline_cps_call2
		      (caml_get_public_method(a, m$3), a, cont);
		                                     });
		                           });
		                 case 22:
		                  var m$4 = next(), e$4 = next(), n$17 = next();
		                  return caml_exact_trampoline_cps_call
		                          (new_cache,
		                           table,
		                           function(c){
		                            return cont
		                                    (function(obj, cont){
		                                      var a = obj[e$4 + 1][n$17 + 1];
		                                      return caml_trampoline_cps_call2
		      (caml_get_public_method(a, m$4), a, cont);
		                                     });
		                           });
		                 default:
		                  var m$5 = next(), n$18 = next();
		                  return caml_exact_trampoline_cps_call
		                          (new_cache,
		                           table,
		                           function(c){
		                            return cont
		                                    (function(obj, cont){
		                                      return caml_trampoline_cps_call2
		      (obj[1][n$18 + 1],
		       obj,
		       function(a){
		        return caml_trampoline_cps_call2
		                (caml_get_public_method(a, m$5), a, cont);
		       });
		                                     });
		                           });
		               }
		              return cont(clo);
		             }
		             function init_mod_block(loc, comps$0){
		              var
		               length = comps$0.length - 1,
		               modu = caml_obj_block(0, length),
		               a = length - 1 | 0;
		              if(a >= 0){
		               var i = 0;
		               for(;;){
		                var shape = caml_check_bound(comps$0, i)[i + 1];
		                if(typeof shape === "number")
		                 switch(shape){
		                   case 0:
		                    let i$1 = i;
		                    var
		                     fn =
		                       function(x, a){
		                        var fn = modu[i$1 + 1];
		                        if(fn$0 !== fn) return caml_trampoline_cps_call2(fn, x, a);
		                        a = caml_pop_trap();
		                        return a
		                                (caml_maybe_attach_backtrace
		                                  ([0, Undefined_recursive_module, loc], 1));
		                       };
		                    let fn$0 = fn;
		                    var init = fn;
		                    break;
		                   case 1:
		                    var l = [];
		                    let l$0 = l, i$0 = i;
		                    caml_update_dummy
		                     (l,
		                      [246,
		                       function(b, a){
		                        var l = modu[i$0 + 1];
		                        if(l$0 === l){
		                         a = caml_pop_trap();
		                         return a
		                                 (caml_maybe_attach_backtrace
		                                   ([0, Undefined_recursive_module, loc], 1));
		                        }
		                        b = caml_obj_tag(l);
		                        if(250 === b) return a(l[1]);
		                        if(246 !== b && 244 !== b) return a(l);
		                        return caml_exact_trampoline_cps_call
		                                (force_lazy_block, l, a);
		                       }]);
		                    init = l;
		                    break;
		                   default:
		                    var
		                     undef =
		                       function(a, cont){
		                        a = caml_pop_trap();
		                        return a
		                                (caml_maybe_attach_backtrace
		                                  ([0, Undefined_recursive_module, loc], 1));
		                       },
		                     init = [0, undef, undef, undef, 0];
		                 }
		                else if(0 === shape[0])
		                 var comps = shape[1], init = init_mod_block(loc, comps);
		                else
		                 var v = shape[1], init = v;
		                modu[i + 1] = init;
		                var b = i + 1 | 0;
		                if(a === i) break;
		                i = b;
		               }
		              }
		              return modu;
		             }
		             function init_mod(loc, shape, cont){
		              if(typeof shape !== "number" && 0 === shape[0]){
		               var comps = shape[1];
		               return cont(init_mod_block(loc, comps));
		              }
		              return caml_exact_trampoline_cps_call
		                      (failwith, "CamlinternalMod.init_mod: not a module", cont);
		             }
		             var
		              f = "camlinternalMod.ml",
		              dJ = [0, f, 72, 5],
		              dK = [0, f, 81, 2];
		             function update_mod_block(comps$0, modu, n){
		              if(0 === caml_obj_tag(n) && comps$0.length - 1 <= n.length - 1){
		               var b = comps$0.length - 2 | 0;
		               if(b >= 0){
		                var i = 0;
		                for(;;){
		                 var
		                  n$0 = n[i + 1],
		                  shape = caml_check_bound(comps$0, i)[i + 1];
		                 a:
		                 if(typeof shape === "number"){
		                  if(2 === shape){
		                   if(0 === caml_obj_tag(n$0) && 4 === n$0.length - 1){
		                    var cl = modu[i + 1], j = 0;
		                    for(;;){
		                     cl[j + 1] = n$0[j + 1];
		                     var a = j + 1 | 0;
		                     if(3 === j) break a;
		                     j = a;
		                    }
		                   }
		                   throw caml_maybe_attach_backtrace
		                          ([0, Assert_failure, dJ], 1);
		                  }
		                  modu[i + 1] = n$0;
		                 }
		                 else if(0 === shape[0]){
		                  var comps = shape[1];
		                  update_mod_block(comps, modu[i + 1], n$0);
		                 }
		                 a = i + 1 | 0;
		                 if(b === i) break;
		                 i = a;
		                }
		               }
		               return;
		              }
		              throw caml_maybe_attach_backtrace([0, Assert_failure, dK], 1);
		             }
		             function update_mod(shape, o, n, cont){
		              if(typeof shape !== "number" && 0 === shape[0]){
		               var comps = shape[1];
		               return cont(update_mod_block(comps, o, n));
		              }
		              return caml_exact_trampoline_cps_call
		                      (failwith, "CamlinternalMod.update_mod: not a module", cont);
		             }
		             function generic_basename
		             (is_dir_sep, current_dir_name, name, cont){
		              if(name === cst$1) return cont(current_dir_name);
		              var n$3 = caml_ml_string_length(name) - 1 | 0, n = n$3;
		              for(;;){
		               if(0 > n)
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub, name, 0, 1, cont);
		               if(! is_dir_sep(name, n)) break;
		               var n$0 = n - 1 | 0;
		               n = n$0;
		              }
		              var p = n + 1 | 0, n$1 = n;
		              for(;;){
		               if(0 > n$1)
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub, name, 0, p, cont);
		               if(is_dir_sep(name, n$1))
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub, name, n$1 + 1 | 0, (p - n$1 | 0) - 1 | 0, cont);
		               var n$2 = n$1 - 1 | 0;
		               n$1 = n$2;
		              }
		             }
		             function is_dir_sep(s, i){
		              return 47 === caml_string_get(s, i) ? 1 : 0;
		             }
		             try{f = caml_sys_getenv("TMPDIR"); var temp_dir_name = f;}
		             catch(exn){
		              var exn$1 = caml_wrap_exception(exn);
		              if(exn$1 !== Not_found){
		               z = caml_pop_trap();
		               var exn$4 = caml_maybe_attach_backtrace(exn$1, 0);
		               return z(exn$4);
		              }
		              temp_dir_name = "/tmp";
		             }
		             function basename(a, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (generic_basename, is_dir_sep, cst$14, a, cont);
		             }
		             var Unix = [0, , , , , , , , , , temp_dir_name, , , basename];
		             function is_dir_sep$0(s, i){
		              var c = caml_string_get(s, i), a = 47 === c ? 1 : 0;
		              if(a) ; else {a = 92 === c ? 1 : 0; a ||= 58 === c ? 1 : 0;}
		              return a;
		             }
		             try{f = caml_sys_getenv("TEMP"); var temp_dir_name$0 = f;}
		             catch(exn){
		              var exn$2 = caml_wrap_exception(exn);
		              if(exn$2 !== Not_found){
		               r = caml_pop_trap();
		               var exn$3 = caml_maybe_attach_backtrace(exn$2, 0);
		               return r(exn$3);
		              }
		              temp_dir_name$0 = cst$14;
		             }
		             function drive_and_path(s, cont){
		              var a = 2 <= caml_ml_string_length(s);
		              if(a){
		               a = caml_string_get(s, 0);
		               a:
		               {
		                b:
		                {
		                 if(91 <= a){
		                  if(25 < a - 97 >>> 0) break b;
		                 }
		                 else if(65 > a) break b;
		                 a = 1;
		                 break a;
		                }
		                a = 0;
		               }
		               a = a ? 58 === caml_string_get(s, 1) : a;
		              }
		              return a
		                      ? caml_exact_trampoline_cps_call$0
		                        (get_sub,
		                         s,
		                         2,
		                         caml_ml_string_length(s) - 2 | 0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (get_sub, s, 0, 2, function(b){return cont([0, , a]);});
		                         })
		                      : cont([0, , s]);
		             }
		             function basename$0(s, cont){
		              return caml_exact_trampoline_cps_call
		                      (drive_and_path,
		                       s,
		                       function(match){
		                        var path = match[2];
		                        return caml_exact_trampoline_cps_call$0
		                                (generic_basename, is_dir_sep$0, cst$14, path, cont);
		                       });
		             }
		             var
		              Win32 = [0, , , , , , , , , , temp_dir_name$0, , , basename$0];
		             function basename$1(a, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (generic_basename, is_dir_sep$0, cst$14, a, cont);
		             }
		             var
		              Cygwin = [0, , , , , , , , , , temp_dir_name, , , basename$1],
		              Sysdeps =
		                os_type !== "Cygwin"
		                 ? os_type !== "Win32" ? Unix : Win32
		                 : Cygwin,
		              temp_dir_name$1 = Sysdeps[10],
		              basename$2 = Sysdeps[13];
		             new_key(0, make_self_init);
		             var
		              current_temp_dir_name =
		                new_key
		                 ([0, function(a, cont){return cont(a);}],
		                  function(param, cont){return cont(temp_dir_name$1);}),
		              Unhandled =
		                [248, "Stdlib.Effect.Unhandled", caml_fresh_oo_id()],
		              Continuation_already_resumed =
		                [248,
		                 "Stdlib.Effect.Continuation_already_resumed",
		                 caml_fresh_oo_id()],
		              dL =
		                [0,
		                 [11, "Stdlib.Effect.Unhandled(", [2, 0, [12, 41, 0]]],
		                 "Stdlib.Effect.Unhandled(%s)"];
		             function printer(param, cont){
		              if(param[1] !== Unhandled) return cont(0);
		              var x = param[2];
		              return caml_exact_trampoline_cps_call
		                      (string_of_extension_constructo,
		                       x,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (sprintf,
		                                 dL,
		                                 function(b){
		                                  return caml_trampoline_cps_call2
		  (b, a, function(msg){return cont([0, msg]);});
		                                 });
		                       });
		             }
		             register_printer(printer);
		             var
		              Should_not_see_this =
		                [248,
		                 "Stdlib.Effect.Should_not_see_this__",
		                 caml_fresh_oo_id()];
		             register_exception
		              ("Effect.Unhandled", [0, Unhandled, Should_not_see_this]);
		             register_exception
		              ("Effect.Continuation_already_resumed",
		               Continuation_already_resumed);
		             function continue$(k, v, cont){
		              var a = k[2];
		              return caml_exact_trampoline_cps_call
		                      (function(x, cont){return cont(x);},
		                       v,
		                       caml_resume_stack(caml_continuation_use_noexc(k), a, cont));
		             }
		             function try_with(comp, arg, handler, cont){
		              function effc(eff, k, last_fiber, cont){
		               return caml_exact_trampoline_cps_call
		                       (handler[1],
		                        eff,
		                        function(match){
		                         if(! match)
		                          return caml_reperform_effect(eff, k, last_fiber, cont);
		                         var f = match[1];
		                         k[2] = last_fiber;
		                         return caml_exact_trampoline_cps_call(f, k, cont);
		                        });
		              }
		              var
		               s =
		                 caml_alloc_stack
		                  (function(x, cont){return cont(x);},
		                   function(e, a){
		                    a = caml_pop_trap();
		                    var e$0 = caml_maybe_attach_backtrace(e, 1);
		                    return a(e$0);
		                   },
		                   effc);
		              return caml_exact_trampoline_cps_call
		                      (comp, arg, caml_resume_stack(s, 0, cont));
		             }
		             var cst_E = "E";
		             function fiber(f, cont){
		              var
		               Initial_setup = [248, "Initial_setup__", caml_fresh_oo_id()],
		               E = [248, cst_E, caml_fresh_oo_id()];
		              function f$0(param, cont){
		               return caml_perform_effect
		                       (Initial_setup,
		                        function(a){return caml_trampoline_cps_call2(f, a, cont);});
		              }
		              var a = "impossible";
		              function error(param, cont){
		               return caml_exact_trampoline_cps_call(failwith, a, cont);
		              }
		              function effc(eff, k, last_fiber, cont){
		               return eff === Initial_setup
		                       ? (k[2] = last_fiber, caml_pop_trap()([0, E, k]))
		                       : caml_exact_trampoline_cps_call(failwith, a, cont);
		              }
		              var s = caml_alloc_stack(error, error, effc);
		              caml_push_trap
		               (function(exn){
		                 if(exn[1] === E){var k = exn[2]; return cont(k);}
		                 var
		                  raise = caml_pop_trap(),
		                  exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                 return raise(exn$0);
		                });
		              return caml_exact_trampoline_cps_call
		                      (f$0,
		                       0,
		                       caml_resume_stack
		                        (s,
		                         0,
		                         function(val){
		                          caml_pop_trap();
		                          return caml_exact_trampoline_cps_call(failwith, a, cont);
		                         }));
		             }
		             function continue_with(k, v, handler, cont){
		              function resume_fun(x, cont){return cont(x);}
		              function effc(eff, k, last_fiber, cont){
		               return caml_exact_trampoline_cps_call
		                       (handler[3],
		                        eff,
		                        function(match){
		                         if(! match)
		                          return caml_reperform_effect(eff, k, last_fiber, cont);
		                         var f = match[1];
		                         k[2] = last_fiber;
		                         return caml_exact_trampoline_cps_call(f, k, cont);
		                        });
		              }
		              var
		               last_fiber = k[2],
		               stack =
		                 caml_continuation_use_and_update_handler_noexc
		                  (k, handler[1], handler[2], effc);
		              return caml_exact_trampoline_cps_call
		                      (resume_fun, v, caml_resume_stack(stack, last_fiber, cont));
		             }
		             function sexp_of_t(t, cont){return cont(t);}
		             var
		              Not_found_s =
		                [248, "Sexplib0__Sexp.Not_found_s", caml_fresh_oo_id()],
		              Of_sexp_error =
		                [248, "Sexplib0__Sexp.Of_sexp_error", caml_fresh_oo_id()];
		             function must_escape(str){
		              var len = caml_ml_string_length(str), a = 0 === len ? 1 : 0;
		              if(a) return a;
		              var ix$1 = len - 1 | 0, ix = ix$1;
		              for(;;){
		               a = caml_string_get(str, ix);
		               a:
		               {
		                b:
		                {
		                 if(92 <= a){
		                  a = a - 93 | 0;
		                  if(33 < a >>> 0){if(0 <= a) break b; break a;}
		                  if(31 === a){
		                   a = 0 < ix ? 1 : 0;
		                   if(a){
		                    var
		                     next = ix - 1 | 0,
		                     a = equal(caml_string_get(str, next), 35);
		                    if(! a){ix = next; continue;}
		                   }
		                   return a;
		                  }
		                 }
		                 else
		                  if(42 <= a){
		                   if(59 === a) break a;
		                  }
		                  else {
		                   if(33 > a) break b;
		                   switch(a - 33 | 0){
		                     case 2:
		                      a = 0 < ix ? 1 : 0;
		                      if(a){
		                       var
		                        next$0 = ix - 1 | 0,
		                        a = equal(caml_string_get(str, next$0), 124);
		                       if(! a){ix = next$0; continue;}
		                      }
		                      return a;
		                     case 1:
		                     case 7:
		                     case 8:
		                      break a;
		                   }
		                  }
		                 a = 0 < ix ? 1 : 0;
		                 if(! a) return a;
		                 var ix$0 = ix - 1 | 0;
		                 ix = ix$0;
		                 continue;
		                }
		                return 1;
		               }
		               return 1;
		              }
		             }
		             function escaped$1(s, cont){
		              var b = caml_ml_string_length(s) - 1 | 0, a = 0;
		              if(b < 0)
		               var n$0 = a;
		              else {
		               var n = a, i = 0;
		               for(;;){
		                a = caml_string_unsafe_get(s, i);
		                a:
		                {
		                 b:
		                 {
		                  c:
		                  {
		                   if(32 <= a){
		                    a = a - 34 | 0;
		                    if(58 < a >>> 0){
		                     if(93 <= a) break c;
		                    }
		                    else if(56 < a - 1 >>> 0) break b;
		                    a = 1;
		                    break a;
		                   }
		                   if(11 <= a){if(13 === a) break b;} else if(8 <= a) break b;
		                  }
		                  a = 4;
		                  break a;
		                 }
		                 a = 2;
		                }
		                a = n + a | 0;
		                var f = i + 1 | 0;
		                if(b === i){n$0 = a; break;}
		                n = a;
		                i = f;
		               }
		              }
		              if(n$0 === caml_ml_string_length(s)) return cont(s);
		              var
		               s$0 = caml_create_bytes(n$0),
		               c = caml_ml_string_length(s) - 1 | 0;
		              function e(){return cont(caml_string_of_bytes(s$0));}
		              function d(n, i){
		               var c$0 = caml_string_unsafe_get(s, i);
		               function a(n){
		                var n$0 = n + 1 | 0, a = i + 1 | 0;
		                return c !== i ? caml_exact_trampoline_call2(d, n$0, a) : e();
		               }
		               a:
		               {
		                b:
		                {
		                 if(35 <= c$0){
		                  if(92 !== c$0){if(127 <= c$0) break a; break b;}
		                 }
		                 else {
		                  if(32 > c$0){
		                   if(14 <= c$0) break a;
		                   switch(c$0){
		                     case 8:
		                      caml_bytes_unsafe_set(s$0, n, 92);
		                      var n$0 = n + 1 | 0;
		                      caml_bytes_unsafe_set(s$0, n$0, 98);
		                      return a(n$0);
		                     case 9:
		                      caml_bytes_unsafe_set(s$0, n, 92);
		                      var n$1 = n + 1 | 0;
		                      caml_bytes_unsafe_set(s$0, n$1, 116);
		                      return a(n$1);
		                     case 10:
		                      caml_bytes_unsafe_set(s$0, n, 92);
		                      var n$2 = n + 1 | 0;
		                      caml_bytes_unsafe_set(s$0, n$2, 110);
		                      return a(n$2);
		                     case 13:
		                      caml_bytes_unsafe_set(s$0, n, 92);
		                      var n$3 = n + 1 | 0;
		                      caml_bytes_unsafe_set(s$0, n$3, 114);
		                      return a(n$3);
		                     default: break a;
		                   }
		                  }
		                  if(34 > c$0) break b;
		                 }
		                 caml_bytes_unsafe_set(s$0, n, 92);
		                 var n$5 = n + 1 | 0;
		                 caml_bytes_unsafe_set(s$0, n$5, c$0);
		                 return a(n$5);
		                }
		                caml_bytes_unsafe_set(s$0, n, c$0);
		                return a(n);
		               }
		               caml_bytes_unsafe_set(s$0, n, 92);
		               var n$4 = n + 1 | 0;
		               return caml_exact_trampoline_cps_call
		                       (chr,
		                        48 + (c$0 / 100 | 0) | 0,
		                        function(b){
		                         caml_bytes_unsafe_set(s$0, n$4, b);
		                         var n = n$4 + 1 | 0;
		                         return caml_exact_trampoline_cps_call
		                                 (chr,
		                                  48 + ((c$0 / 10 | 0) % 10 | 0) | 0,
		                                  function(b){
		                                   caml_bytes_unsafe_set(s$0, n, b);
		                                   var n$0 = n + 1 | 0;
		                                   return caml_exact_trampoline_cps_call
		   (chr,
		    48 + (c$0 % 10 | 0) | 0,
		    function(b){
		     caml_bytes_unsafe_set(s$0, n$0, b);
		     return a(n$0);
		    });
		                                  });
		                        });
		              }
		              return c < 0 ? e() : d(0, 0);
		             }
		             function esc_str(str, cont){
		              return caml_exact_trampoline_cps_call
		                      (escaped$1,
		                       str,
		                       function(estr){
		                        var
		                         elen = caml_ml_string_length(estr),
		                         res = caml_create_bytes(elen + 2 | 0);
		                        return caml_exact_trampoline_cps_call$3
		                                (blit_string,
		                                 estr,
		                                 0,
		                                 res,
		                                 1,
		                                 elen,
		                                 function(a){
		                                  caml_bytes_unsafe_set(res, 0, 34);
		                                  caml_bytes_unsafe_set(res, elen + 1 | 0, 34);
		                                  return cont(caml_string_of_bytes(res));
		                                 });
		                       });
		             }
		             function index_of_newline(str, start, cont){
		              var lim = caml_ml_string_length(str);
		              if(0 <= start && lim >= start){
		               var i = start;
		               for(;;){
		                if(lim <= i) return cont(0);
		                if(caml_string_unsafe_get(str, i) === 10) return cont([0, i]);
		                var i$0 = i + 1 | 0;
		                i = i$0;
		               }
		              }
		              return caml_exact_trampoline_cps_call
		                      (invalid_arg,
		                       "String.index_from_opt / Bytes.index_from_opt",
		                       cont);
		             }
		             function mach_maybe_esc_str(str, cont){
		              return must_escape(str)
		                      ? caml_exact_trampoline_cps_call(esc_str, str, cont)
		                      : cont(str);
		             }
		             var cst$16 = "(", cst$17 = "()", cst$18 = ")", cst$19 = "\\";
		             function pp_hum_indent(indent, ppf, a, cont){
		              if(0 === a[0]){
		               var str = a[1];
		               return must_escape(str)
		                       ? caml_exact_trampoline_cps_call$1
		                         (index_of_newline,
		                          str,
		                          0,
		                          function(a){
		                           if(a)
		                            var
		                             index = a[1],
		                             a = (index + 1 | 0) === caml_ml_string_length(str);
		                           else
		                            a = 1;
		                           return a
		                                   ? caml_exact_trampoline_cps_call
		                                     (esc_str,
		                                      str,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_print_string, ppf, a, cont);
		                                      })
		                                   : caml_exact_trampoline_cps_call$1
		                                     (pp_open_box,
		                                      ppf,
		                                      0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_print_string,
		        ppf,
		        ' "',
		        function(b){
		         function a(index){
		          return caml_exact_trampoline_cps_call$1
		                  (index_of_newline,
		                   str,
		                   index,
		                   function(next_newline){
		                    if(next_newline)
		                     var end_pos = next_newline[1], end_pos$0 = end_pos;
		                    else
		                     end_pos$0 = caml_ml_string_length(str);
		                    return caml_exact_trampoline_cps_call$0
		                            (get_sub,
		                             str,
		                             index,
		                             end_pos$0 - index | 0,
		                             function(next_line){
		                              return caml_exact_trampoline_cps_call
		                                      (escaped$1,
		                                       next_line,
		                                       function(b){
		return caml_exact_trampoline_cps_call$1
		        (pp_print_string,
		         ppf,
		         b,
		         function(b){
		          if(! next_newline)
		           return caml_exact_trampoline_cps_call$1
		                   (pp_print_string,
		                    ppf,
		                    cst$20,
		                    function(a){return cont(pp_close_box(ppf));});
		          var newline_index = next_newline[1];
		          return caml_exact_trampoline_cps_call$1
		                  (pp_print_string,
		                   ppf,
		                   cst$19,
		                   function(b){
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_force_newline,
		                             ppf,
		                             dummy,
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string,
		                                       ppf,
		                                       cst_n,
		                                       function(b){
		var index = newline_index + 1 | 0;
		return caml_exact_trampoline_call1(a, index);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         }
		         return a(0);
		        });
		                                      });
		                          })
		                       : caml_exact_trampoline_cps_call$1
		                         (pp_print_string, ppf, str, cont);
		              }
		              a = a[1];
		              if(! a)
		               return caml_exact_trampoline_cps_call$1
		                       (pp_print_string, ppf, cst$17, cont);
		              var t = a[2], h = a[1];
		              return caml_exact_trampoline_cps_call$1
		                      (pp_open_box,
		                       ppf,
		                       indent,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (pp_print_string,
		                                 ppf,
		                                 cst$16,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$0
		  (pp_hum_indent,
		   indent,
		   ppf,
		   h,
		   function(b){
		    function a(param){
		     if(! param)
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               ppf,
		               cst$18,
		               function(a){return cont(pp_close_box(ppf));});
		     var t = param[2], h = param[1];
		     pp_print_space(ppf);
		     return caml_exact_trampoline_cps_call$0
		             (pp_hum_indent,
		              indent,
		              ppf,
		              h,
		              function(b){return caml_exact_trampoline_call1(a, t);});
		    }
		    return a(t);
		   });
		                                 });
		                       });
		             }
		             var cst$7 = " ";
		             function pp_mach_internal(may_need_space, ppf, a, cont){
		              if(0 === a[0]){
		               var str = a[1];
		               return caml_exact_trampoline_cps_call
		                       (mach_maybe_esc_str,
		                        str,
		                        function(str$0){
		                         var
		                          new_may_need_space = str$0 === str ? 1 : 0,
		                          new_may_need_space$0 =
		                            may_need_space ? new_may_need_space : may_need_space;
		                         function a(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   ppf,
		                                   str$0,
		                                   function(a){return cont(new_may_need_space);});
		                         }
		                         return new_may_need_space$0
		                                 ? caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, ppf, cst$7, a)
		                                 : a();
		                        });
		              }
		              a = a[1];
		              if(! a)
		               return caml_exact_trampoline_cps_call$1
		                       (pp_print_string, ppf, cst$17, function(a){return cont(0);});
		              var t = a[2], h = a[1];
		              return caml_exact_trampoline_cps_call$1
		                      (pp_print_string,
		                       ppf,
		                       cst$16,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$0
		                                (pp_mach_internal,
		                                 0,
		                                 ppf,
		                                 h,
		                                 function(may_need_space){
		                                  function a(may_need_space, param){
		                                   if(! param)
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, ppf, cst$18, function(a){return cont(0);});
		                                   var t = param[2], h = param[1];
		                                   return caml_exact_trampoline_cps_call$0
		   (pp_mach_internal,
		    may_need_space,
		    ppf,
		    h,
		    function(may_need_space){
		     return caml_exact_trampoline_call2(a, may_need_space, t);
		    });
		                                  }
		                                  return a(may_need_space, t);
		                                 });
		                       });
		             }
		             function pp_mach(ppf, sexp, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (pp_mach_internal,
		                       0,
		                       ppf,
		                       sexp,
		                       function(a){return cont(0);});
		             }
		             function buffer(param){return create$1(1024);}
		             var dM = [0, [15, [17, 2, 0]], "%a@?"], bo = 1;
		             function to_string_hum(indent, sexp, cont){
		              function a(){
		               var
		                buf = buffer(),
		                indent$0 = indent ? indent[1] : bo,
		                ppf = formatter_of_buffer(buf);
		               function a(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (pp_hum_indent, indent$0, a, b, cont);
		               }
		               return caml_exact_trampoline_cps_call
		                       (fprintf$0(ppf),
		                        dM,
		                        function(b){
		                         return caml_trampoline_cps_call3
		                                 (b,
		                                  a,
		                                  sexp,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call(contents, buf, cont);
		                                  });
		                        });
		              }
		              if(0 !== sexp[0]) return a();
		              var str = sexp[1];
		              return caml_exact_trampoline_cps_call$1
		                      (index_of_newline,
		                       str,
		                       0,
		                       function(b){
		                        b = b ? 0 : 1;
		                        return b
		                                ? caml_exact_trampoline_cps_call
		                                  (mach_maybe_esc_str, str, cont)
		                                : a();
		                       });
		             }
		             function to_string_mach(sexp, cont){
		              if(0 === sexp[0]){
		               var str = sexp[1];
		               return caml_exact_trampoline_cps_call
		                       (mach_maybe_esc_str, str, cont);
		              }
		              var buf = buffer();
		              function loop(may_need_space, a, cont){
		               if(0 === a[0]){
		                var str = a[1];
		                return caml_exact_trampoline_cps_call
		                        (mach_maybe_esc_str,
		                         str,
		                         function(str$0){
		                          var
		                           new_may_need_space = str$0 === str ? 1 : 0,
		                           new_may_need_space$0 =
		                             may_need_space ? new_may_need_space : may_need_space;
		                          function a(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (write_stringlit,
		                                    buf,
		                                    str$0,
		                                    function(a){return cont(new_may_need_space);});
		                          }
		                          return new_may_need_space$0
		                                  ? caml_exact_trampoline_cps_call$1(add_char, buf, 32, a)
		                                  : a();
		                         });
		               }
		               a = a[1];
		               if(! a)
		                return caml_exact_trampoline_cps_call$1
		                        (write_stringlit, buf, cst$17, function(a){return cont(0);});
		               var t = a[2], h = a[1];
		               return caml_exact_trampoline_cps_call$1
		                       (add_char,
		                        buf,
		                        40,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (loop,
		                                  0,
		                                  h,
		                                  function(may_need_space){
		                                   function a(may_need_space, param){
		                                    if(! param)
		                                     return caml_exact_trampoline_cps_call$1
		     (add_char, buf, 41, function(a){return cont(0);});
		                                    var t = param[2], h = param[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (loop,
		     may_need_space,
		     h,
		     function(may_need_space){
		      return caml_exact_trampoline_call2(a, may_need_space, t);
		     });
		                                   }
		                                   return a(may_need_space, t);
		                                  });
		                        });
		              }
		              return caml_exact_trampoline_cps_call$1
		                      (loop,
		                       0,
		                       sexp,
		                       function(a){
		                        return caml_exact_trampoline_cps_call(contents, buf, cont);
		                       });
		             }
		             function message(name, fields){
		              function conv_fields(a){
		               if(! a) return 0;
		               var rest = a[2], a = a[1], fsexp = a[2], fname = a[1];
		               return fname !== cst$1
		                       ? [0,
		                         [1, [0, [0, fname], [0, fsexp, 0]]],
		                         conv_fields(rest)]
		                       : [0, fsexp, conv_fields(rest)];
		              }
		              return [1, [0, [0, name], conv_fields(fields)]];
		             }
		             var cst_15G = "%.15G", cst_17G = "%.17G";
		             function dN(x){
		              var y = caml_format_float(cst_15G, x);
		              return caml_float_of_string(y) === x
		                      ? y
		                      : caml_format_float(cst_17G, x);
		             }
		             var dO = [1, 0];
		             function sexp_of_unit(param, cont){return cont(dO);}
		             function sexp_of_bool(b, cont){
		              return caml_exact_trampoline_cps_call
		                      (string_of_bool, b, function(a){return cont([0, a]);});
		             }
		             function sexp_of_string(str, cont){return cont([0, str]);}
		             function sexp_of_char(c, cont){return cont([0, make$0(1, c)]);}
		             function sexp_of_int(n, cont){return cont([0, "" + n]);}
		             function sexp_of_float(n, cont){return cont([0, dN(n)]);}
		             function sexp_of_int32(n, cont){
		              return cont([0, caml_format_int(cst_d, n)]);
		             }
		             function sexp_of_int64(n, cont){
		              return cont([0, caml_int64_format(cst_d, n)]);
		             }
		             function sexp_of_nativeint(n, cont){
		              return cont([0, caml_format_int(cst_d, n)]);
		             }
		             var D = [1, 0];
		             function sexp_of_option(sexp_of_a, param, cont){
		              if(! param) return cont(D);
		              var x = param[1];
		              return caml_trampoline_cps_call2
		                      (sexp_of_a, x, function(a){return cont([1, [0, a, 0]]);});
		             }
		             function sexp_of_pair(sexp_of_a, sexp_of_b, param, cont){
		              var b = param[2], a = param[1];
		              return caml_exact_trampoline_cps_call
		                      (sexp_of_b,
		                       b,
		                       function(c){
		                        var b = [0, c, 0];
		                        return caml_exact_trampoline_cps_call
		                                (sexp_of_a, a, function(a){return cont([1, [0, a, b]]);});
		                       });
		             }
		             function sexp_of_list(sexp_of_a, lst, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (map$0, sexp_of_a, lst, function(a){return cont([1, a]);});
		             }
		             function sexp_of_array(sexp_of_a, ar, cont){
		              var b = ar.length - 2 | 0;
		              function d(lst_ref){return cont([1, lst_ref]);}
		              function c(lst_ref, i){
		               return caml_trampoline_cps_call2
		                       (sexp_of_a,
		                        caml_check_bound(ar, i)[i + 1],
		                        function(a){
		                         a = [0, a, lst_ref];
		                         var b = i - 1 | 0;
		                         return 0 !== i ? caml_exact_trampoline_call2(c, a, b) : d(a);
		                        });
		              }
		              var a = 0;
		              return b < 0 ? d(a) : c(a, b);
		             }
		             var arg_006 = [0, "<opaque>"];
		             function sexp_of_opaque(param, cont){return cont(arg_006);}
		             function key_index$0(h, hkey){
		              return hkey & (h[2].length - 2 | 0);
		             }
		             function create$7(initial_size, cont){
		              var x = 16;
		              for(;;){
		               if(initial_size <= x) break;
		               if(max_array_length < (x * 2 | 0)) break;
		               var x$0 = x * 2 | 0;
		               x = x$0;
		              }
		              function a(a){return cont([0, 0, caml_make_vect(x, 0)]);}
		              return a();
		             }
		             var the_exn_table = caml_callback(create$7, [17]);
		             function add$1
		             (opt, param, extension_constructor, sexp_of_exn, cont){
		              var
		               printexc = opt ? opt[1] : 1,
		               info = [0, sexp_of_exn, printexc],
		               hkey = hash(extension_constructor),
		               i = key_index$0(the_exn_table, hkey);
		              function a(a){
		               var container = caml_ephe_create(1);
		               caml_ephe_set_data(container, info);
		               return caml_exact_trampoline_cps_call$0
		                       (raise_if_invalid_offset,
		                        container,
		                        0,
		                        "Obj.Ephemeron.set_key",
		                        function(a){
		                         caml_ephe_set_key(container, 0, extension_constructor);
		                         var
		                          bucket =
		                            [0,
		                             hkey,
		                             container,
		                             caml_check_bound(the_exn_table[2], i)[i + 1]];
		                         caml_check_bound(the_exn_table[2], i)[i + 1] = bucket;
		                         the_exn_table[1] = the_exn_table[1] + 1 | 0;
		                         a =
		                          the_exn_table[2].length - 1 << 1 < the_exn_table[1] ? 1 : 0;
		                         if(! a) return cont(a);
		                         var
		                          odata = the_exn_table[2],
		                          osize = odata.length - 1,
		                          nsize = osize * 2 | 0;
		                         function do_bucket(param, cont){
		                          function a(param){
		                           if(! param) return cont(0);
		                           var hkey = param[1], rest = param[3], c = param[2];
		                           return caml_exact_trampoline_cps_call$0
		                                   (raise_if_invalid_offset,
		                                    c,
		                                    0,
		                                    "Obj.Ephemeron.check_key",
		                                    function(b){
		                                     if(caml_ephe_check_key(c, 0)){
		                                      var rest$0 = param[3], c$0 = param[2];
		                                      return caml_exact_trampoline_cps_call
		      (do_bucket,
		       rest$0,
		       function(a){return cont([0, hkey, c$0, a]);});
		                                     }
		                                     the_exn_table[1] = the_exn_table[1] - 1 | 0;
		                                     return caml_exact_trampoline_call1(a, rest);
		                                    });
		                          }
		                          return a(param);
		                         }
		                         var d = the_exn_table[2], b = d.length - 2 | 0;
		                         function e(){
		                          var
		                           a = nsize < max_array_length,
		                           a = a ? (osize >>> 1 | 0) <= the_exn_table[1] : a;
		                          if(a){
		                           var ndata = caml_make_vect(nsize, 0);
		                           the_exn_table[2] = ndata;
		                           var
		                            insert_bucket =
		                              function(param){
		                               if(! param) return;
		                               var rest = param[3], data = param[2], hkey = param[1];
		                               insert_bucket(rest);
		                               var nidx = key_index$0(the_exn_table, hkey);
		                               ndata[nidx + 1] =
		                                [0, hkey, data, caml_check_bound(ndata, nidx)[nidx + 1]];
		                              },
		                            a = osize - 1 | 0;
		                           if(a >= 0){
		                            var i = 0;
		                            for(;;){
		                             insert_bucket(caml_check_bound(odata, i)[i + 1]);
		                             var b = i + 1 | 0;
		                             if(a === i) break;
		                             i = b;
		                            }
		                           }
		                          }
		                          return cont();
		                         }
		                         function c(i){
		                          return caml_exact_trampoline_cps_call
		                                  (do_bucket,
		                                   caml_check_bound(d, i)[i + 1],
		                                   function(a){
		                                    d[i + 1] = a;
		                                    a = i + 1 | 0;
		                                    return b !== i ? caml_exact_trampoline_call1(c, a) : e();
		                                   });
		                         }
		                         return b < 0 ? e() : c(0);
		                        });
		              }
		              return a();
		             }
		             function find_auto(for_printexc, exn, cont){
		              return caml_exact_trampoline_cps_call
		                      (of_val,
		                       exn,
		                       function(extension_constructor){
		                        var
		                         hkey = hash(extension_constructor),
		                         b = key_index$0(the_exn_table, hkey);
		                        function a(param){
		                         function b(a){
		                          if(! a) return cont(0);
		                          a = a[1];
		                          var printexc = a[2], sexp_of_exn = a[1];
		                          if(for_printexc && ! printexc) return cont(0);
		                          return caml_trampoline_cps_call2
		                                  (sexp_of_exn, exn, function(a){return cont([0, a]);});
		                         }
		                         if(! param) return b(0);
		                         var hk = param[1], rest = param[3], c = param[2];
		                         if(hkey === hk)
		                          return caml_exact_trampoline_cps_call$0
		                                  (raise_if_invalid_offset,
		                                   c,
		                                   0,
		                                   "Obj.Ephemeron.get_key",
		                                   function(d){
		                                    var x = caml_ephe_get_key(c, 0);
		                                    if(x)
		                                     var k = x[1], d = extension_constructor === k ? 0 : 1;
		                                    else
		                                     d = 2;
		                                    if(0 !== d) return caml_exact_trampoline_call1(a, rest);
		                                    var x$0 = caml_ephe_get_data(c);
		                                    return x$0 ? b(x$0) : caml_exact_trampoline_call1(a, rest);
		                                   });
		                         var rest$0 = param[3];
		                         return caml_exact_trampoline_call1(a, rest$0);
		                        }
		                        return a(caml_check_bound(the_exn_table[2], b)[b + 1]);
		                       });
		             }
		             function sexp_of_exn_opt(exn, cont){
		              return caml_exact_trampoline_cps_call$1(find_auto, 0, exn, cont);
		             }
		             function sexp_of_exn(exn, cont){
		              return caml_exact_trampoline_cps_call
		                      (sexp_of_exn_opt,
		                       exn,
		                       function(match){
		                        if(match){var sexp = match[1]; return cont(sexp);}
		                        return caml_exact_trampoline_cps_call
		                                (to_string$0,
		                                 exn,
		                                 function(a){return cont([1, [0, [0, a], 0]]);});
		                       });
		             }
		             var dP = [0, 2];
		             register_printer
		              (function(exn, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_auto,
		                         1,
		                         exn,
		                         function(match){
		                          if(! match) return cont(0);
		                          var sexp = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_string_hum, dP, sexp, function(a){return cont([0, a]);});
		                         });
		               });
		             function of_sexp_error(what, sexp){
		              throw caml_maybe_attach_backtrace
		                     ([0, Of_sexp_error, [0, Failure, what], sexp], 1);
		             }
		             function string_of_sexp(sexp, cont){
		              if(0 !== sexp[0])
		               return cont(of_sexp_error("string_of_sexp: atom needed", sexp));
		              var str = sexp[1];
		              return cont(str);
		             }
		             function pair_of_sexp(a_of_sexp, b_of_sexp, sexp, cont){
		              if(0 === sexp[0])
		               return cont(of_sexp_error("pair_of_sexp: list needed", sexp));
		              var match = sexp[1];
		              if(match){
		               var a = match[2];
		               if(a && ! a[2]){
		                var b_sexp = a[1], a_sexp = match[1];
		                return caml_trampoline_cps_call2
		                        (a_of_sexp,
		                         a_sexp,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (b_of_sexp, b_sexp, function(b){return cont([0, a, b]);});
		                         });
		               }
		              }
		              return cont
		                      (of_sexp_error
		                        ("pair_of_sexp: list must contain exactly two elements only",
		                         sexp));
		             }
		             function list_of_sexp(a_of_sexp, sexp, cont){
		              if(0 === sexp[0])
		               return cont(of_sexp_error("list_of_sexp: list needed", sexp));
		              var lst = sexp[1];
		              return caml_exact_trampoline_cps_call$1
		                      (map$0, a_of_sexp, lst, cont);
		             }
		             var
		              dQ =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   32,
		                   [2, 0, [12, 58, [4, 0, 0, 0, [12, 58, [4, 0, 0, 0, 0]]]]]]],
		                 "%s %s:%d:%d"];
		             function get_flc_error(name, param, cont){
		              var chr = param[3], line = param[2], file = param[1];
		              return caml_exact_trampoline_cps_call
		                      (sprintf,
		                       dQ,
		                       function(a){
		                        return caml_trampoline_cps_call5
		                                (a,
		                                 name,
		                                 file,
		                                 line,
		                                 chr,
		                                 function(a){return cont([0, a]);});
		                       });
		             }
		             var
		              f = "api/controller/lib/controller_ai/tools/routine/contact.ml",
		              d = "api/controller/lib/controller_ai/tools/routine/event.ml",
		              n =
		                "api/controller/lib/controller_ai/tools/routine/menu_item.ml",
		              e = "api/controller/lib/controller_ai/tools/routine/page.ml",
		              cst_calendars = "calendars",
		              cst_contacts = "contacts",
		              cst_createEvent = "createEvent",
		              cst_events = "events",
		              cst_findAvailableTimeSlots = "findAvailableTimeSlots",
		              cst_listCalendars = "listCalendars",
		              cst_listEventsForDateRange = "listEventsForDateRange",
		              cst_menu_items = "menu_items",
		              cst_pages = "pages",
		              cst_personal = "personal",
		              bgs = [0, [0, f, 137, 4015, 4049]],
		              bgt = [0, [0, f, 147, 4383, 4417]],
		              bgu = [0, [0, f, 157, 4817, 4851]],
		              bhv = [0, [0, d, 528, 18476, 18510]],
		              bhw = [0, [0, d, 540, 18954, 18988]],
		              bhx = [0, [0, d, 552, 19350, 19384]],
		              bhy = [0, [0, d, 562, 19723, 19757]],
		              bhz = [0, [0, d, 573, 20144, 20178]],
		              bhA = [0, [0, d, 584, 20576, 20605]],
		              bhK = [0, [0, n, 46, 1496, 1530]],
		              bhL = [0, [0, n, 55, 1836, 1870]],
		              bin = [0, [0, e, 157, 5000, 5034]],
		              bio = [0, [0, e, 167, 5386, 5420]],
		              bip = [0, [0, e, 180, 5979, 6013]];
		             function bNN
		             (return$,
		              return$0,
		              schema_versioned,
		              get,
		              all_schema_versioned,
		              all,
		              all$0,
		              hierarchy_schema_versioned,
		              hierarchy,
		              capped_list_schema_versioned,
		              null$,
		              object_schema,
		              read,
		              write,
		              tool,
		              namespace,
		              contact_summary_schema_version,
		              get_contact_input_schema_versi,
		              get_contact_output_schema_vers,
		              list_contacts_input_schema_ver,
		              search_contacts_input_schema_v,
		              make_get_contact,
		              make_list_contacts,
		              make_search_contacts,
		              create_event_input_schema_vers,
		              create_event_output_schema_ver,
		              update_event_input_schema_vers,
		              set_attendance_input_schema_ve,
		              complete_event_input_schema_ve,
		              delete_event_input_schema_vers,
		              find_available_time_slots_inpu,
		              find_available_time_slots_outp,
		              make_create_event,
		              make_update_event,
		              make_set_attendance,
		              make_complete_event,
		              make_delete_event,
		              make_find_available_time_slots,
		              get_event,
		              a,
		              b,
		              pin_menu_item_input_schema_ver,
		              unpin_menu_item_input_schema_v,
		              make_pin_menu_item,
		              make_unpin_menu_item,
		              get_page_input_schema_versione,
		              get_page_output_schema_version,
		              create_page_input_schema_versi,
		              create_page_output_schema_vers,
		              update_page_input_schema_versi,
		              make_get_page,
		              make_create_page,
		              make_update_page,
		              ctrl,
		              graph,
		              schematic_param_a_schema_versi,
		              c){
		              return function(d){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        cst_listEventsForDateRange,
		                        0,
		                        0,
		                        "\nList events for a date range.\nUse same start and end date for a single day.\nReturns a compact summary (id, title, time) for each, plus the total count.\n",
		                        read(0),
		                        d,
		                        b,
		                        a,
		                        function(list_events_for_date_range){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_create_event, ctrl, a, cont);
		                         }
		                         function schematic_version(param){return 0;}
		                         return caml_exact_trampoline_cps_call
		                                 (create_event_output_schema_ver,
		                                  schematic_version,
		                                  function(b){
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (create_event_input_schema_vers,
		    schematic_version,
		    function(d){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bhv,
		              0,
		              d,
		              function(d){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        cst_createEvent,
		                        0,
		                        0,
		                        "\nCreate a new calendar event.\n",
		                        write(0, 0, 0),
		                        d,
		                        b,
		                        a,
		                        function(create_event){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_update_event, graph, ctrl, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (update_event_input_schema_vers,
		                                  schematic_version,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bhw,
		    0,
		    b,
		    function(b){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "updateEvent",
		              0,
		              0,
		              '\nUpdate event fields.\nFor each field, pass null to leave it unchanged or {"update": value} to set it.\nUse {"update": null} to clear location or description.\n',
		              write(1, 0, 0),
		              b,
		              schematic_param_a_schema_versi,
		              a,
		              function(update_event){
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_set_attendance, ctrl, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (set_attendance_input_schema_ve,
		                        schematic_version,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$0
		                                 (object_schema,
		                                  bhx,
		                                  0,
		                                  b,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$9
		   (tool,
		    "setAttendance",
		    0,
		    0,
		    "\nSet RSVP status for an event.\nUse 'yes', 'no', 'maybe', or null to clear.\n",
		    write(1, 1, 0),
		    b,
		    schematic_param_a_schema_versi,
		    a,
		    function(set_attendance){
		     function a(a, cont){
		      return caml_exact_trampoline_cps_call$1
		              (make_complete_event, ctrl, a, cont);
		     }
		     function schematic_version(param){return 0;}
		     return caml_exact_trampoline_cps_call
		             (complete_event_input_schema_ve,
		              schematic_version,
		              function(b){
		               return caml_exact_trampoline_cps_call$0
		                       (object_schema,
		                        bhy,
		                        0,
		                        b,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "completeEvent",
		                                  0,
		                                  0,
		                                  "\nMark an event as completed (useful for task allocations).\n",
		                                  write(1, 0, 0),
		                                  b,
		                                  schematic_param_a_schema_versi,
		                                  a,
		                                  function(complete_event){
		                                   function a(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (make_delete_event, ctrl, a, cont);
		                                   }
		                                   function schematic_version(param){return 0;}
		                                   return caml_exact_trampoline_cps_call
		   (delete_event_input_schema_vers,
		    schematic_version,
		    function(b){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bhz,
		              0,
		              b,
		              function(b){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        "deleteEvent",
		                        0,
		                        0,
		                        "\nPermanently delete an event.\nOnly use it if the user explicitly wants you to delete it, as it is irreversible.\n",
		                        write(1, 1, 0),
		                        b,
		                        schematic_param_a_schema_versi,
		                        a,
		                        function(delete_event){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_find_available_time_slots, ctrl, a, cont);
		                         }
		                         function schematic_version(param){return 0;}
		                         return caml_exact_trampoline_cps_call
		                                 (find_available_time_slots_outp,
		                                  schematic_version,
		                                  function(b){
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (find_available_time_slots_inpu,
		    schematic_version,
		    function(d){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bhA,
		              0,
		              d,
		              function(d){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        cst_findAvailableTimeSlots,
		                        0,
		                        0,
		                        "\nFind open time windows for scheduling. Never returns times in the past.\nOnly Busy events ever block time - Free-marked events never do.\n",
		                        read(0),
		                        d,
		                        b,
		                        a,
		                        function(find_available_time_slots){
		                         var
		                          event_tools =
		                            [0,
		                             get_event,
		                             [0,
		                              list_events_for_date_range,
		                              [0,
		                               create_event,
		                               [0,
		                                update_event,
		                                [0,
		                                 set_attendance,
		                                 [0,
		                                  complete_event,
		                                  [0, delete_event, [0, find_available_time_slots, 0]]]]]]]];
		                         function schematic_version(param, cont){return cont(0);}
		                         function a(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (all$0,
		                                   ctrl,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (get,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2(return$, [0, a], cont);
		     });
		                                   });
		                         }
		                         return caml_exact_trampoline_cps_call
		                                 (schema_versioned,
		                                  schematic_version,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$9
		   (tool,
		    cst_listCalendars,
		    0,
		    0,
		    "\nList all calendars.\n",
		    read(0),
		    null$,
		    [0, 0, 0, [3, b], 0],
		    a,
		    function(b){
		     var calendar_tools = [0, b, 0];
		     function schematic_version(param, cont){return cont(0);}
		     function a(param, cont){
		      return caml_exact_trampoline_cps_call$1
		              (hierarchy,
		               ctrl,
		               0,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (get,
		                         a,
		                         function(hierarchies){
		                          return caml_trampoline_cps_call2
		                                  (return$, [0, hierarchies], cont);
		                         });
		               });
		     }
		     return caml_exact_trampoline_cps_call
		             (hierarchy_schema_versioned,
		              schematic_version,
		              function(b){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        "listPages",
		                        0,
		                        0,
		                        "\nList all pages with their title, parent, and children.\nUse this to discover existing pages before creating or updating.\n",
		                        read(0),
		                        null$,
		                        [0, 0, 0, [3, b], 0],
		                        a,
		                        function(list_pages){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_get_page, graph, ctrl, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (get_page_output_schema_version,
		                                  schematic_version,
		                                  function(b){
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (get_page_input_schema_versione,
		    schematic_version,
		    function(d){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bin,
		              0,
		              d,
		              function(d){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        "getPage",
		                        0,
		                        0,
		                        "\nGet detailed information about a page including its full content (document blocks).\n",
		                        read(0),
		                        d,
		                        b,
		                        a,
		                        function(get_page){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_create_page, ctrl, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (create_page_output_schema_vers,
		                                  schematic_version,
		                                  function(b){
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (create_page_input_schema_versi,
		    schematic_version,
		    function(d){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bio,
		              0,
		              d,
		              function(d){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        "createPage",
		                        0,
		                        0,
		                        "\nCreate a new page with a title, optionally nested under a parent page.\n",
		                        write(0, 0, 0),
		                        d,
		                        b,
		                        a,
		                        function(create_page){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_update_page, graph, ctrl, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (update_page_input_schema_versi,
		                                  schematic_version,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bip,
		    0,
		    b,
		    function(b){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "updatePage",
		              0,
		              0,
		              '\nUpdate a page\'s title, content, and/or parent.\nContent is a document made of typed blocks (headings, paragraphs, todos, etc.).\nFor each field, pass null to leave it unchanged or {"update": value} to set it.\nPass existing block IDs to update in place; omit IDs for new blocks.\n',
		              write(1, 0, 0),
		              b,
		              schematic_param_a_schema_versi,
		              a,
		              function(update_page){
		               var
		                page_tools =
		                  [0,
		                   list_pages,
		                   [0, get_page, [0, create_page, [0, update_page, 0]]]];
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_get_contact, graph, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (get_contact_output_schema_vers,
		                        schematic_version,
		                        function(b){
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (get_contact_input_schema_versi,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bgs,
		    0,
		    d,
		    function(d){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "getContact",
		              0,
		              0,
		              "\nGet full details of a contact by ID.\n",
		              read(0),
		              d,
		              b,
		              a,
		              function(get_contact){
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_list_contacts, ctrl, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (contact_summary_schema_version,
		                        schematic_version,
		                        function(b){
		                         return caml_exact_trampoline_cps_call
		                                 (capped_list_schema_versioned,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call
		   (d,
		    b,
		    function(b){
		     function schematic_version(param){return 0;}
		     return caml_exact_trampoline_cps_call
		             (list_contacts_input_schema_ver,
		              schematic_version,
		              function(d){
		               return caml_exact_trampoline_cps_call$0
		                       (object_schema,
		                        bgt,
		                        0,
		                        d,
		                        function(d){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "listContacts",
		                                  0,
		                                  0,
		                                  "\nList all contacts.\nReturns a compact summary (id, name, email) for each, plus the total count.\n",
		                                  read(0),
		                                  d,
		                                  b,
		                                  a,
		                                  function(list_contacts){
		                                   function a(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (make_search_contacts, ctrl, a, cont);
		                                   }
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (contact_summary_schema_version,
		    schematic_version,
		    function(b){
		     return caml_exact_trampoline_cps_call
		             (capped_list_schema_versioned,
		              schematic_version,
		              function(d){
		               return caml_exact_trampoline_cps_call
		                       (d,
		                        b,
		                        function(b){
		                         function schematic_version(param){return 0;}
		                         return caml_exact_trampoline_cps_call
		                                 (search_contacts_input_schema_v,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bgu,
		    0,
		    d,
		    function(d){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "searchContacts",
		              0,
		              0,
		              "\nSearch contacts by name or email (case-insensitive substring match).\nReturns a compact summary (id, name, email) for each, plus the total count.\n",
		              read(0),
		              d,
		              b,
		              a,
		              function(search_contacts){
		               var
		                contact_tools =
		                  [0,
		                   get_contact,
		                   [0, list_contacts, [0, search_contacts, 0]]];
		               function a(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (all,
		                         ctrl,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get,
		                                   a,
		                                   function(menu_items){
		                                    return caml_trampoline_cps_call2(return$0, menu_items, cont);
		                                   });
		                         });
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (all_schema_versioned,
		                        schematic_version,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "listMenuItems",
		                                  0,
		                                  0,
		                                  "\nList all pinned and hidden menu items for the current user.\n",
		                                  read(0),
		                                  null$,
		                                  b,
		                                  a,
		                                  function(list_menu_items){
		                                   function a(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (make_pin_menu_item, ctrl, a, cont);
		                                   }
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (pin_menu_item_input_schema_ver,
		    schematic_version,
		    function(b){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bhK,
		              0,
		              b,
		              function(b){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        "pinMenuItem",
		                        0,
		                        0,
		                        "\nPin an item to the user's menu.\n",
		                        write(0, 0, 0),
		                        b,
		                        schematic_param_a_schema_versi,
		                        a,
		                        function(pin_menu_item){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_unpin_menu_item, ctrl, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (unpin_menu_item_input_schema_v,
		                                  schematic_version,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bhL,
		    0,
		    b,
		    function(b){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "unpinMenuItem",
		              0,
		              0,
		              "\nUnpin an item from the user's menu.\n",
		              write(1, 1, 0),
		              b,
		              schematic_param_a_schema_versi,
		              a,
		              function(unpin_menu_item){
		               var
		                menu_item_tools =
		                  [0,
		                   list_menu_items,
		                   [0, pin_menu_item, [0, unpin_menu_item, 0]]];
		               return caml_exact_trampoline_cps_call$0
		                       (namespace,
		                        cst_menu_items,
		                        "\nList, pin and unpin items in the app menu.\n",
		                        menu_item_tools,
		                        function(b){
		                         var a = [0, b, 0];
		                         return caml_exact_trampoline_cps_call$0
		                                 (namespace,
		                                  cst_contacts,
		                                  "\nSearch and view contacts\n",
		                                  contact_tools,
		                                  function(d){
		                                   var b = [0, d, a];
		                                   return caml_exact_trampoline_cps_call$0
		   (namespace,
		    cst_pages,
		    "\nRead and write pages.\n",
		    page_tools,
		    function(d){
		     var a = [0, d, b];
		     return caml_exact_trampoline_cps_call$0
		             (namespace,
		              cst_calendars,
		              "\nList and manage calendars\n",
		              calendar_tools,
		              function(d){
		               var b = [0, d, a];
		               return caml_exact_trampoline_cps_call$0
		                       (namespace,
		                        cst_events,
		                        "Manage calendar events.\nAlways use the user's timezone (provided in the ENVIRONMENT section) for event times unless the user or event explicitly specifies a different timezone.\nFormat times as ISO 8601 with timezone offset.",
		                        event_tools,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$0
		                                 (namespace,
		                                  cst_personal,
		                                  "\nPersonal workspace data\n",
		                                  [0, a, b],
		                                  function(a){return c([0, a]);});
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });};
		             }
		             var
		              e = "api/controller/lib/controller_ai/tools/routine/task.ml",
		              cst_getEvent = "getEvent",
		              cst_routine = "routine",
		              cst_tables = "tables",
		              cst_tasks = "tasks",
		              cst_workspaces = "workspaces",
		              bht = [0, [0, d, 507, 17676, 17710]],
		              bhu = [0, [0, d, 519, 18129, 18163]],
		              bjZ = [0, [0, e, 740, 28662, 28696]],
		              bj0 = [0, [0, e, 751, 29108, 29142]],
		              bj1 = [0, [0, e, 762, 29583, 29617]],
		              bj2 = [0, [0, e, 771, 29892, 29926]],
		              bj3 = [0, [0, e, 784, 30604, 30638]],
		              bj4 = [0, [0, e, 799, 31370, 31404]],
		              bj5 = [0, [0, e, 810, 31810, 31844]],
		              bj6 = [0, [0, e, 819, 32151, 32185]];
		             function bNO
		             (append,
		              to_list,
		              return$,
		              return$0,
		              schema_versioned,
		              get,
		              all_schema_versioned,
		              all,
		              all$0,
		              hierarchy_schema_versioned,
		              hierarchy,
		              capped_list_schema_versioned,
		              null$,
		              object_schema,
		              read,
		              write,
		              tool,
		              ask_user_tool,
		              namespace,
		              workspace_tools,
		              table_read_tools,
		              table_write_tools,
		              table_alter_tools,
		              contact_summary_schema_version,
		              get_contact_input_schema_versi,
		              get_contact_output_schema_vers,
		              list_contacts_input_schema_ver,
		              search_contacts_input_schema_v,
		              make_get_contact,
		              make_list_contacts,
		              make_search_contacts,
		              get_event_input_schema_version,
		              get_event_output_schema_versio,
		              list_events_input_schema_versi,
		              event_summary_schema_versioned,
		              create_event_input_schema_vers,
		              create_event_output_schema_ver,
		              update_event_input_schema_vers,
		              set_attendance_input_schema_ve,
		              complete_event_input_schema_ve,
		              delete_event_input_schema_vers,
		              find_available_time_slots_inpu,
		              find_available_time_slots_outp,
		              make_get_event,
		              make_list_events,
		              make_create_event,
		              make_update_event,
		              make_set_attendance,
		              make_complete_event,
		              make_delete_event,
		              make_find_available_time_slots,
		              build_reference_tool,
		              build_link_tool,
		              pin_menu_item_input_schema_ver,
		              unpin_menu_item_input_schema_v,
		              make_pin_menu_item,
		              make_unpin_menu_item,
		              get_page_input_schema_versione,
		              get_page_output_schema_version,
		              create_page_input_schema_versi,
		              create_page_output_schema_vers,
		              update_page_input_schema_versi,
		              make_get_page,
		              make_create_page,
		              make_update_page,
		              get_task_input_schema_versione,
		              get_task_output_schema_version,
		              create_task_input_schema_versi,
		              create_task_output_schema_vers,
		              update_task_input_schema_versi,
		              list_unplanned_tasks_input_sch,
		              list_todays_tasks_input_schema,
		              list_tasks_input_schema_versio,
		              generalized_task_summary_schem,
		              list_tasks_output_schema_versi,
		              allocate_task_input_schema_ver,
		              allocate_task_output_schema_ve,
		              delete_task_input_schema_versi,
		              make_list_unplanned,
		              make_list_todays,
		              make_list_tasks,
		              make_get_task,
		              make_create_task,
		              make_update_task,
		              make_allocate_task,
		              make_delete_task,
		              ctrl,
		              graph,
		              include_personal,
		              include_ask_user,
		              extra,
		              a,
		              schematic_param_a_schema_versi,
		              cont){
		              return function(d){
		               var c = [0, d, a];
		               function b(a, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (make_list_tasks, graph, ctrl, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (generalized_task_summary_schem,
		                        schematic_version,
		                        function(a){
		                         return caml_exact_trampoline_cps_call
		                                 (capped_list_schema_versioned,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call
		   (d,
		    a,
		    function(a){
		     function schematic_version(param, cont){return cont(0);}
		     return caml_exact_trampoline_cps_call
		             (list_tasks_input_schema_versio,
		              schematic_version,
		              function(d){
		               return caml_exact_trampoline_cps_call$0
		                       (object_schema,
		                        bjZ,
		                        0,
		                        d,
		                        function(d){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "listTasks",
		                                  0,
		                                  0,
		                                  "\nList all tasks of the given workspace, whatever their schedule or status.\nReturns a compact summary (id, title) for each, plus the total count.\nUse listUnplannedTasks or listTodaysTasks for the unscheduled or today's subsets.\n",
		                                  read(0),
		                                  d,
		                                  a,
		                                  b,
		                                  function(list_tasks){
		                                   function a(a, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (make_list_unplanned, graph, ctrl, a, cont);
		                                   }
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (generalized_task_summary_schem,
		    schematic_version,
		    function(b){
		     return caml_exact_trampoline_cps_call
		             (capped_list_schema_versioned,
		              schematic_version,
		              function(d){
		               return caml_exact_trampoline_cps_call
		                       (d,
		                        b,
		                        function(b){
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (list_unplanned_tasks_input_sch,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bj0,
		    0,
		    d,
		    function(d){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "listUnplannedTasks",
		              0,
		              0,
		              "\nList all unplanned (unscheduled) tasks of the given workspace.\nReturns a compact summary (id, title) for each, plus the total count.\n",
		              read(0),
		              d,
		              b,
		              a,
		              function(list_unplanned_tasks){
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (make_list_todays, graph, ctrl, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (list_tasks_output_schema_versi,
		                        schematic_version,
		                        function(b){
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (list_todays_tasks_input_schema,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bj1,
		    0,
		    d,
		    function(d){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "listTodaysTasks",
		              0,
		              0,
		              "\nList today's tasks of the given workspace, separated into todo and other.\nReturns a compact summary (id, title) for each, plus the total count per group.\n",
		              read(0),
		              d,
		              b,
		              a,
		              function(list_todays_tasks){
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_get_task, graph, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (get_task_output_schema_version,
		                        schematic_version,
		                        function(b){
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (get_task_input_schema_versione,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bj2,
		    0,
		    d,
		    function(d){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "getTask",
		              0,
		              0,
		              "\nGet detailed information about a task.\n",
		              read(0),
		              d,
		              b,
		              a,
		              function(get_task){
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (make_create_task, graph, ctrl, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (create_task_output_schema_vers,
		                        schematic_version,
		                        function(b){
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (create_task_input_schema_versi,
		                                  schematic_version,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bj3,
		    0,
		    d,
		    function(d){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "createTask",
		              0,
		              0,
		              "\nCreate a new task in the given workspace.\nSet 'parent' only if needed to add as a todo block to an existing task/event/page (personal tasks only).\nFor organization workspaces, only day scheduling is supported, and 'parent' and notes are ignored.\nSet 'assignee' to assign the task to a member by account id (from listMembers), or to yourself (organization workspaces only; rejected for personal tasks).\n",
		              write(0, 0, 0),
		              d,
		              b,
		              a,
		              function(create_task){
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_update_task, graph, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (update_task_input_schema_versi,
		                        schematic_version,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$0
		                                 (object_schema,
		                                  bj4,
		                                  0,
		                                  b,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$9
		   (tool,
		    "updateTask",
		    0,
		    0,
		    '\nUpdate task fields, including title, status, scheduling, and notes.\nNotes are a document made of typed blocks (headings, paragraphs, todos, etc.).\nFor each field, pass null to leave it unchanged or {"update": value} to set it.\nUse {"update": null} to clear scheduling or parent.\nSet \'assignee\' to reassign (by account id from listMembers, or to yourself) or unassign the task (organization workspaces only; rejected for personal tasks).\n',
		    write(1, 0, 0),
		    b,
		    schematic_param_a_schema_versi,
		    a,
		    function(update_task){
		     function a(a, cont){
		      return caml_exact_trampoline_cps_call$1
		              (make_allocate_task, ctrl, a, cont);
		     }
		     function schematic_version(param){return 0;}
		     return caml_exact_trampoline_cps_call
		             (allocate_task_output_schema_ve,
		              schematic_version,
		              function(b){
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (allocate_task_input_schema_ver,
		                        schematic_version,
		                        function(d){
		                         return caml_exact_trampoline_cps_call$0
		                                 (object_schema,
		                                  bj5,
		                                  0,
		                                  d,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$9
		   (tool,
		    "allocateTask",
		    0,
		    0,
		    "\nBlock time for the given task as a calendar event, which then appears in the task's allocations.\nOnly supported for personal tasks.\n",
		    write(1, 0, 0),
		    d,
		    b,
		    a,
		    function(allocate_task){
		     function a(a, cont){
		      return caml_exact_trampoline_cps_call$0
		              (make_delete_task, graph, ctrl, a, cont);
		     }
		     function schematic_version(param, cont){return cont(0);}
		     return caml_exact_trampoline_cps_call
		             (delete_task_input_schema_versi,
		              schematic_version,
		              function(b){
		               return caml_exact_trampoline_cps_call$0
		                       (object_schema,
		                        bj6,
		                        0,
		                        b,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "deleteTask",
		                                  0,
		                                  0,
		                                  "\nDelete a task permanently.\n",
		                                  write(1, 0, 0),
		                                  b,
		                                  schematic_param_a_schema_versi,
		                                  a,
		                                  function(delete_task){
		                                   return caml_exact_trampoline_cps_call$0
		   (namespace,
		    cst_tasks,
		    '\nManage tasks and scheduling, across personal and organization workspaces.\nEvery tool takes a `workspace` (see the ENVIRONMENT section), or a task id that already identifies its workspace.\nA "reminder" ("remind me to\xe2\x80\xa6", "I need to\xe2\x80\xa6", "don\'t let me forget\xe2\x80\xa6") is a task with a scheduled date, and potential event allocation \xe2\x80\x94 Routine has no separate reminder object.\nCalendar allocation (allocateTask) is only available for personal tasks.\n',
		    [0,
		     list_tasks,
		     [0,
		      list_unplanned_tasks,
		      [0,
		       list_todays_tasks,
		       [0,
		        get_task,
		        [0,
		         create_task,
		         [0, update_task, [0, allocate_task, [0, delete_task, 0]]]]]]]],
		    function(b){
		     var a = [0, b, c];
		     return caml_exact_trampoline_cps_call$0
		             (namespace,
		              "tables_alter",
		              "\nCreate custom type tables (also called 'databases' in Routine) and change their column schema.\nOnly needed when changing a table's structure, not when reading or writing rows.\n",
		              table_alter_tools,
		              function(c){
		               var b = [0, c, a];
		               return caml_exact_trampoline_cps_call$0
		                       (namespace,
		                        "tables_write",
		                        "\nAdd and update rows (objects) in custom type tables (also called 'databases' in Routine).\nYou must know the table schema before writing; read it with `getTableSchema` in the `tables` namespace.\n",
		                        table_write_tools,
		                        function(c){
		                         var a = [0, c, b];
		                         return caml_exact_trampoline_cps_call$0
		                                 (namespace,
		                                  cst_tables,
		                                  "\nRead and find data in custom type tables (also called 'databases' in Routine): list tables, read a table's schema, and read or search rows.\n",
		                                  table_read_tools,
		                                  function(c){
		                                   var b = [0, c, a];
		                                   return caml_exact_trampoline_cps_call$0
		   (namespace,
		    cst_workspaces,
		    "\nAccess organizations and workspaces.\nNOTE: In Routine, a 'workspace' is a collaboration space (like a team or personal area), NOT a database.\n",
		    workspace_tools,
		    function(a){
		     a = [0, a, b];
		     var c = include_ask_user ? [0, ask_user_tool, 0] : 0;
		     return caml_exact_trampoline_cps_call$1
		             (append,
		              c,
		              a,
		              function(a){
		               return caml_exact_trampoline_cps_call$1
		                       (append,
		                        [0, build_reference_tool, [0, build_link_tool, 0]],
		                        a,
		                        function(shared_tools){
		                         function a(personal_namespace_opt){
		                          return caml_exact_trampoline_cps_call$1
		                                  (append,
		                                   shared_tools,
		                                   to_list(personal_namespace_opt),
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (namespace,
		     cst_routine,
		     "\nRoutine app data\n",
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (append, [0, a, 0], extra, cont);
		     });
		                                   });
		                         }
		                         if(! include_personal) return a(0);
		                         function b(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_get_event, graph, ctrl, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (get_event_output_schema_versio,
		                                  schematic_version,
		                                  function(c){
		                                   function schematic_version(param){return 0;}
		                                   return caml_exact_trampoline_cps_call
		   (get_event_input_schema_version,
		    schematic_version,
		    function(d){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bht,
		              0,
		              d,
		              function(d){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        cst_getEvent,
		                        0,
		                        0,
		                        "\nGet detailed information about an event.\n",
		                        read(0),
		                        d,
		                        c,
		                        b,
		                        function(get_event){
		                         function b(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_list_events, ctrl, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (event_summary_schema_versioned,
		                                  schematic_version,
		                                  function(c){
		                                   return caml_exact_trampoline_cps_call
		   (capped_list_schema_versioned,
		    schematic_version,
		    function(d){
		     return caml_exact_trampoline_cps_call
		             (d,
		              c,
		              function(c){
		               function schematic_version(param){return 0;}
		               return caml_exact_trampoline_cps_call
		                       (list_events_input_schema_versi,
		                        schematic_version,
		                        function(d){
		                         return caml_exact_trampoline_cps_call$0
		                                 (object_schema,
		                                  bhu,
		                                  0,
		                                  d,
		                                  bNN
		                                   (return$,
		                                    return$0,
		                                    schema_versioned,
		                                    get,
		                                    all_schema_versioned,
		                                    all,
		                                    all$0,
		                                    hierarchy_schema_versioned,
		                                    hierarchy,
		                                    capped_list_schema_versioned,
		                                    null$,
		                                    object_schema,
		                                    read,
		                                    write,
		                                    tool,
		                                    namespace,
		                                    contact_summary_schema_version,
		                                    get_contact_input_schema_versi,
		                                    get_contact_output_schema_vers,
		                                    list_contacts_input_schema_ver,
		                                    search_contacts_input_schema_v,
		                                    make_get_contact,
		                                    make_list_contacts,
		                                    make_search_contacts,
		                                    create_event_input_schema_vers,
		                                    create_event_output_schema_ver,
		                                    update_event_input_schema_vers,
		                                    set_attendance_input_schema_ve,
		                                    complete_event_input_schema_ve,
		                                    delete_event_input_schema_vers,
		                                    find_available_time_slots_inpu,
		                                    find_available_time_slots_outp,
		                                    make_create_event,
		                                    make_update_event,
		                                    make_set_attendance,
		                                    make_complete_event,
		                                    make_delete_event,
		                                    make_find_available_time_slots,
		                                    get_event,
		                                    b,
		                                    c,
		                                    pin_menu_item_input_schema_ver,
		                                    unpin_menu_item_input_schema_v,
		                                    make_pin_menu_item,
		                                    make_unpin_menu_item,
		                                    get_page_input_schema_versione,
		                                    get_page_output_schema_version,
		                                    create_page_input_schema_versi,
		                                    create_page_output_schema_vers,
		                                    update_page_input_schema_versi,
		                                    make_get_page,
		                                    make_create_page,
		                                    make_update_page,
		                                    ctrl,
		                                    graph,
		                                    schematic_param_a_schema_versi,
		                                    a));
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });};
		             }
		             var
		              cst_addTableRow = "addTableRow",
		              e = "api/controller/lib/controller_ai/tools/routine/notice.ml",
		              d = "api/controller/lib/controller_ai/tools/routine/table.ml",
		              cst_ask_user = "ask_user",
		              cst_getTableSchema = "getTableSchema",
		              cst_listTables = "listTables",
		              cst_notices = "notices",
		              cst_search = "search",
		              cst_searchTableRows = "searchTableRows",
		              cst_updateObjectField = "updateObjectField",
		              bge = [0, [0, d, 867, 31956, 31990]],
		              bgf = [0, [0, d, 879, 32630, 32664]],
		              bga = [0, [0, d, 813, 29705, 29739]],
		              bgb = [0, [0, d, 824, 30168, 30202]],
		              bgc = [0, [0, d, 836, 30692, 30726]],
		              bgd = [0, [0, d, 848, 31115, 31149]],
		              bf8 = [0, [0, d, 764, 27511, 27545]],
		              bf9 = [0, [0, d, 773, 27885, 27919]],
		              bf_ = [0, [0, d, 782, 28207, 28241]],
		              bf$ = [0, [0, d, 790, 28532, 28566]],
		              bh8 = [0, [0, e, 205, 6955, 6989]],
		              bh9 = [0, 1],
		              biR =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_ai/tools/routine/search.ml",
		                  88,
		                  3365,
		                  3399]],
		              bkd =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_ai/tools/routine/routine.ml",
		                  85,
		                  2964,
		                  2998]],
		              opt$13 = [0, 0];
		             function bNP
		             (append,
		              to_list,
		              to_to_string,
		              return$,
		              return$0,
		              pp,
		              schema_versioned,
		              schema_versioned$0,
		              schema_versioned$1,
		              get,
		              all_schema_versioned,
		              all,
		              all$0,
		              hierarchy_schema_versioned,
		              hierarchy,
		              get$0,
		              capped_list_schema_versioned,
		              null$,
		              object_schema,
		              read,
		              write,
		              tool,
		              namespace,
		              workspace_tools,
		              get_object_input_schema_versio,
		              list_tables_input_schema_versi,
		              table_summary_schema_versioned,
		              get_table_schema_input_schema_,
		              search_rows_input_schema_versi,
		              ai_field_schema_versioned,
		              add_row_input_schema_versioned,
		              add_row_output_schema_versione,
		              update_object_field_input_sche,
		              create_table_input_schema_vers,
		              create_table_output_schema_ver,
		              update_table_schema_input_sche,
		              update_note_column_input_schem,
		              delete_object_input_schema_ver,
		              make_list_tables,
		              make_get_table_schema,
		              graph_row_id_schema_versioned,
		              make_search_table_rows,
		              make_add_table_row,
		              make_update_object_field,
		              make_create_table,
		              make_update_table_schema,
		              make_update_note_column,
		              make_delete_object,
		              contact_summary_schema_version,
		              get_contact_input_schema_versi,
		              get_contact_output_schema_vers,
		              list_contacts_input_schema_ver,
		              search_contacts_input_schema_v,
		              make_get_contact,
		              make_list_contacts,
		              make_search_contacts,
		              get_event_input_schema_version,
		              get_event_output_schema_versio,
		              list_events_input_schema_versi,
		              event_summary_schema_versioned,
		              create_event_input_schema_vers,
		              create_event_output_schema_ver,
		              update_event_input_schema_vers,
		              set_attendance_input_schema_ve,
		              complete_event_input_schema_ve,
		              delete_event_input_schema_vers,
		              find_available_time_slots_inpu,
		              find_available_time_slots_outp,
		              make_get_event,
		              make_list_events,
		              make_create_event,
		              make_update_event,
		              make_set_attendance,
		              make_complete_event,
		              make_delete_event,
		              make_find_available_time_slots,
		              build_reference_tool,
		              build_link_tool,
		              pin_menu_item_input_schema_ver,
		              unpin_menu_item_input_schema_v,
		              make_pin_menu_item,
		              make_unpin_menu_item,
		              list_notices,
		              get_notice,
		              create_notice,
		              mark_notice_viewed,
		              archive_notice,
		              a,
		              get_page_input_schema_versione,
		              get_page_output_schema_version,
		              create_page_input_schema_versi,
		              create_page_output_schema_vers,
		              update_page_input_schema_versi,
		              make_get_page,
		              make_create_page,
		              make_update_page,
		              search_input_schema_versioned,
		              search_result_schema_versioned,
		              make_search,
		              get_task_input_schema_versione,
		              get_task_output_schema_version,
		              create_task_input_schema_versi,
		              create_task_output_schema_vers,
		              update_task_input_schema_versi,
		              list_unplanned_tasks_input_sch,
		              list_todays_tasks_input_schema,
		              list_tasks_input_schema_versio,
		              generalized_task_summary_schem,
		              list_tasks_output_schema_versi,
		              allocate_task_input_schema_ver,
		              allocate_task_output_schema_ve,
		              delete_task_input_schema_versi,
		              make_list_unplanned,
		              make_list_todays,
		              make_list_tasks,
		              make_get_task,
		              make_create_task,
		              make_update_task,
		              make_allocate_task,
		              make_delete_task,
		              ask_user_input_schema_versione,
		              make_ask_user,
		              ctrl,
		              graph,
		              workspace,
		              include_personal,
		              include_ask_user,
		              extra,
		              schematic_param_a_schema_versi,
		              schematic_param_name_schema_ve,
		              cont){
		              return function(b){
		               return caml_exact_trampoline_cps_call$0
		                       (object_schema,
		                        bh8,
		                        0,
		                        b,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "deleteNotice",
		                                  0,
		                                  bh9,
		                                  "\nPermanently delete a notice.\nOnly use it if the user explicitly wants you to delete it, as it is irreversible.\n",
		                                  write(1, 1, 0),
		                                  b,
		                                  schematic_param_a_schema_versi,
		                                  a,
		                                  function(delete_notice){
		                                   var
		                                    notices_tools =
		                                      [0,
		                                       list_notices,
		                                       [0,
		get_notice,
		[0,
		 create_notice,
		 [0,
		  mark_notice_viewed,
		  [0, archive_notice, [0, delete_notice, 0]]]]]];
		                                   function a(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (make_list_tables, graph, a, cont);
		                                   }
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (table_summary_schema_versioned,
		    schematic_version,
		    function(b){
		     return caml_exact_trampoline_cps_call
		             (capped_list_schema_versioned,
		              schematic_version,
		              function(c){
		               return caml_exact_trampoline_cps_call
		                       (c,
		                        b,
		                        function(b){
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (list_tables_input_schema_versi,
		                                  schematic_version,
		                                  function(c){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bf8,
		    0,
		    c,
		    function(c){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              cst_listTables,
		              0,
		              0,
		              "\nList the tables in a workspace: user-defined tables, integration-app tables, and the built-in Routine types.\nBuilt-in types (Task, Event, Page, People, \xe2\x80\xa6) are listed without a table id \xe2\x80\x94 use their dedicated tools, and relate to them via the named relation-target variants.\nReturns a compact summary for each, plus the total count.\n",
		              read(0),
		              c,
		              b,
		              a,
		              function(list_tables){
		               function schematic_version(param, cont){return cont(0);}
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_get_table_schema, graph, a, cont);
		               }
		               return caml_exact_trampoline_cps_call
		                       (ai_field_schema_versioned,
		                        schematic_version,
		                        function(c){
		                         var b = [0, 0, 0, [3, c], 0];
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (get_table_schema_input_schema_,
		                                  schematic_version,
		                                  function(c){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bf9,
		    0,
		    c,
		    function(c){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              cst_getTableSchema,
		              0,
		              0,
		              "\nGet the schema of a custom table, including for each column its name, ID and value type.\n",
		              read(0),
		              c,
		              b,
		              a,
		              function(get_table_schema){
		               function a(input, cont){
		                var object_id = input[1];
		                return caml_exact_trampoline_cps_call$1
		                        (get$0,
		                         graph,
		                         object_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get,
		                                   a,
		                                   function(match){
		                                    function a(a){
		                                     return caml_trampoline_cps_call2(return$, a, cont);
		                                    }
		                                    if(0 === match[0]){var obj = match[1]; return a([0, obj]);}
		                                    var err = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (to_to_string, pp, err, function(b){return a([1, b]);});
		                                   });
		                         });
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (schema_versioned$1,
		                        schematic_version,
		                        function(b){
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (get_object_input_schema_versio,
		                                  schematic_version,
		                                  function(c){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bf_,
		    0,
		    c,
		    function(c){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              "getObject",
		              0,
		              0,
		              "\nGet the fields of a custom object (table row) by ID.\n",
		              read(0),
		              c,
		              b,
		              a,
		              function(get_object){
		               function schematic_version(param, cont){return cont(0);}
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_search_table_rows, graph, a, cont);
		               }
		               return caml_trampoline_cps_call2
		                       (schema_versioned,
		                        schematic_version,
		                        function(c){
		                         var b = [0, c, 0];
		                         return caml_exact_trampoline_cps_call
		                                 (graph_row_id_schema_versioned,
		                                  schematic_version,
		                                  function(d){
		                                   var
		                                    c =
		                                      [0,
		                                       0,
		                                       0,
		                                       [3,
		[0,
		 0,
		 0,
		 [10,
		  function(param, cont){
		   var e1 = param[2][1], e0 = param[1];
		   return cont([0, e0, e1]);
		  },
		  function(param, cont){
		   var e1 = param[2], e0 = param[1];
		   return cont([0, e0, [0, e1, 0]]);
		  },
		  [0, d, b]],
		 0]],
		                                       0];
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (search_rows_input_schema_versi,
		    schematic_version,
		    function(b){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bf$,
		              0,
		              b,
		              function(b){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        cst_searchTableRows,
		                        0,
		                        0,
		                        "\nSearch rows in a custom table, optionally filtered.\n",
		                        read(0),
		                        b,
		                        c,
		                        a,
		                        function(search_table_rows){
		                         var
		                          table_read_tools =
		                            [0,
		                             list_tables,
		                             [0,
		                              get_table_schema,
		                              [0, get_object, [0, search_table_rows, 0]]]];
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_add_table_row, graph, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (add_row_output_schema_versione,
		                                  schematic_version,
		                                  function(b){
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (add_row_input_schema_versioned,
		    schematic_version,
		    function(c){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bga,
		              0,
		              c,
		              function(c){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        cst_addTableRow,
		                        0,
		                        0,
		                        "\nAdd a new row (object) to a custom table.\nReturns the created object's id.\nYou **must** know the table schema before calling this tool; if you don't have the table schema, load it with `getTableSchema`.\nUse the field name (the `name` field from `getTableSchema`) to identify each column, **not** the `columnId`.\n**Do no send columns of type `Note`**.\nInstead, create the object with this tool, and then call `updateNotesColumn` to populate fields of type `Note`.\n",
		                        write(0, 0, 0),
		                        c,
		                        b,
		                        a,
		                        function(add_table_row){
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_update_object_field, graph, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (update_object_field_input_sche,
		                                  schematic_version,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bgb,
		    0,
		    b,
		    function(b){
		     return caml_exact_trampoline_cps_call$9
		             (tool,
		              cst_updateObjectField,
		              0,
		              0,
		              "\nUpdate a single field of a custom object (table row).\nUse the field name (the `name` field from getTableSchema) to identify the column.\n",
		              write(1, 0, 0),
		              b,
		              schematic_param_a_schema_versi,
		              a,
		              function(update_object_field){
		               function a(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (make_update_note_column, graph, a, cont);
		               }
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (update_note_column_input_schem,
		                        schematic_version,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$0
		                                 (object_schema,
		                                  bgc,
		                                  0,
		                                  b,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$9
		   (tool,
		    "updateNotesColumn",
		    0,
		    0,
		    "\nUpdate the content of a column of type `Note` in a custom type table row.\nUse the column name (the `name` field from `getTableSchema`) to identify the column, **not** the `columnId`.\n",
		    write(1, 0, 0),
		    b,
		    schematic_param_a_schema_versi,
		    a,
		    function(update_notes_column){
		     function a(a, cont){
		      return caml_exact_trampoline_cps_call$1
		              (make_delete_object, graph, a, cont);
		     }
		     function schematic_version(param, cont){return cont(0);}
		     return caml_exact_trampoline_cps_call
		             (delete_object_input_schema_ver,
		              schematic_version,
		              function(b){
		               return caml_exact_trampoline_cps_call$0
		                       (object_schema,
		                        bgd,
		                        0,
		                        b,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "deleteObject",
		                                  0,
		                                  0,
		                                  "\nDelete a custom object (table row) by its id.\nThis permanently removes the row from the table.\n",
		                                  write(1, 0, 0),
		                                  b,
		                                  schematic_param_a_schema_versi,
		                                  a,
		                                  function(delete_object){
		                                   var
		                                    table_write_tools =
		                                      [0,
		                                       add_table_row,
		                                       [0,
		update_object_field,
		[0, update_notes_column, [0, delete_object, 0]]]];
		                                   function a(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (make_create_table, graph, a, cont);
		                                   }
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (create_table_output_schema_ver,
		    schematic_version,
		    function(b){
		     function schematic_version(param, cont){return cont(0);}
		     return caml_exact_trampoline_cps_call
		             (create_table_input_schema_vers,
		              schematic_version,
		              function(c){
		               return caml_exact_trampoline_cps_call$0
		                       (object_schema,
		                        bge,
		                        0,
		                        c,
		                        function(c){
		                         return caml_exact_trampoline_cps_call$9
		                                 (tool,
		                                  "createTable",
		                                  0,
		                                  0,
		                                  "\nCreate a new custom table (type) with a given data name, description and initial list of fields.\nThe display name is derived automatically from the data name.\nReturns the created table's id.\n",
		                                  write(0, 0, 0),
		                                  c,
		                                  b,
		                                  a,
		                                  function(create_table){
		                                   function a(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (make_update_table_schema, graph, a, cont);
		                                   }
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (update_table_schema_input_sche,
		    schematic_version,
		    function(b){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              bgf,
		              0,
		              b,
		              function(b){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        "updateTableSchema",
		                        0,
		                        0,
		                        "\nReplace the schema of an existing custom table.\nProvide the complete new list of fields \xe2\x80\x94 this replaces the previous schema entirely, which allows adding, removing, or renaming columns.\nTo keep an existing column's data while renaming or reordering it, reuse its `columnId` (from getTableSchema); omit `columnId` for brand-new columns.\n",
		                        write(1, 0, 0),
		                        b,
		                        schematic_param_a_schema_versi,
		                        a,
		                        function(update_table_schema){
		                         var
		                          table_alter_tools =
		                            [0, create_table, [0, update_table_schema, 0]];
		                         function schematic_version(param, cont){return cont(0);}
		                         function a(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make_search, ctrl, a, cont);
		                         }
		                         return caml_exact_trampoline_cps_call
		                                 (search_result_schema_versioned,
		                                  schematic_version,
		                                  function(c){
		                                   var b = [0, 0, 0, [3, c], 0];
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (search_input_schema_versioned,
		    schematic_version,
		    function(c){
		     return caml_exact_trampoline_cps_call$0
		             (object_schema,
		              biR,
		              0,
		              c,
		              function(c){
		               return caml_exact_trampoline_cps_call$9
		                       (tool,
		                        cst_search,
		                        0,
		                        0,
		                        "\nFull-text search across all content: events, tasks, pages, contacts, custom objects, and workspaces by name.\nReturns ranked results with a typed ID you can pass to domain-specific tools (getEvent, getTask, getContact, etc.).\nPass 'kind' to restrict results to one kind of object.\n",
		                        read(0),
		                        c,
		                        b,
		                        a,
		                        function(a){
		                         var search_tools = [0, a, 0];
		                         function handler(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (make_ask_user, graph, workspace, a, cont);
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (ask_user_input_schema_versione,
		                                  schematic_version,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$0
		   (object_schema,
		    bkd,
		    0,
		    a,
		    function(input){
		     var behavior = write(0, 0, 0), defer_loading = opt$13[1];
		     return caml_exact_trampoline_cps_call
		             (trim,
		              "\nAsk the user for input or clarification. Use this when you need information from the user to proceed.\nCan only be called alone, with no parallel tool calls. If called alongside other tools, it will result in an error.\n\nIf you need more than one piece of information, submit them as\nseparate entries in `questions`, each with its own appropriate `answer_count`, so that the user answers them independently.\n",
		              function(a){
		               var
		                ask_user_tool =
		                  [0,
		                   [0,
		                    cst_ask_user,
		                    defer_loading,
		                    0,
		                    a,
		                    behavior,
		                    handler,
		                    input,
		                    schematic_param_name_schema_ve]];
		               return caml_exact_trampoline_cps_call$0
		                       (namespace,
		                        cst_search,
		                        "\nFull-text search across all content\n",
		                        search_tools,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$0
		                                 (namespace,
		                                  cst_notices,
		                                  "\nNotices and notifications\n",
		                                  notices_tools,
		                                  bNO
		                                   (append,
		                                    to_list,
		                                    return$,
		                                    return$0,
		                                    schema_versioned$0,
		                                    get,
		                                    all_schema_versioned,
		                                    all,
		                                    all$0,
		                                    hierarchy_schema_versioned,
		                                    hierarchy,
		                                    capped_list_schema_versioned,
		                                    null$,
		                                    object_schema,
		                                    read,
		                                    write,
		                                    tool,
		                                    ask_user_tool,
		                                    namespace,
		                                    workspace_tools,
		                                    table_read_tools,
		                                    table_write_tools,
		                                    table_alter_tools,
		                                    contact_summary_schema_version,
		                                    get_contact_input_schema_versi,
		                                    get_contact_output_schema_vers,
		                                    list_contacts_input_schema_ver,
		                                    search_contacts_input_schema_v,
		                                    make_get_contact,
		                                    make_list_contacts,
		                                    make_search_contacts,
		                                    get_event_input_schema_version,
		                                    get_event_output_schema_versio,
		                                    list_events_input_schema_versi,
		                                    event_summary_schema_versioned,
		                                    create_event_input_schema_vers,
		                                    create_event_output_schema_ver,
		                                    update_event_input_schema_vers,
		                                    set_attendance_input_schema_ve,
		                                    complete_event_input_schema_ve,
		                                    delete_event_input_schema_vers,
		                                    find_available_time_slots_inpu,
		                                    find_available_time_slots_outp,
		                                    make_get_event,
		                                    make_list_events,
		                                    make_create_event,
		                                    make_update_event,
		                                    make_set_attendance,
		                                    make_complete_event,
		                                    make_delete_event,
		                                    make_find_available_time_slots,
		                                    build_reference_tool,
		                                    build_link_tool,
		                                    pin_menu_item_input_schema_ver,
		                                    unpin_menu_item_input_schema_v,
		                                    make_pin_menu_item,
		                                    make_unpin_menu_item,
		                                    get_page_input_schema_versione,
		                                    get_page_output_schema_version,
		                                    create_page_input_schema_versi,
		                                    create_page_output_schema_vers,
		                                    update_page_input_schema_versi,
		                                    make_get_page,
		                                    make_create_page,
		                                    make_update_page,
		                                    get_task_input_schema_versione,
		                                    get_task_output_schema_version,
		                                    create_task_input_schema_versi,
		                                    create_task_output_schema_vers,
		                                    update_task_input_schema_versi,
		                                    list_unplanned_tasks_input_sch,
		                                    list_todays_tasks_input_schema,
		                                    list_tasks_input_schema_versio,
		                                    generalized_task_summary_schem,
		                                    list_tasks_output_schema_versi,
		                                    allocate_task_input_schema_ver,
		                                    allocate_task_output_schema_ve,
		                                    delete_task_input_schema_versi,
		                                    make_list_unplanned,
		                                    make_list_todays,
		                                    make_list_tasks,
		                                    make_get_task,
		                                    make_create_task,
		                                    make_update_task,
		                                    make_allocate_task,
		                                    make_delete_task,
		                                    ctrl,
		                                    graph,
		                                    include_personal,
		                                    include_ask_user,
		                                    extra,
		                                    [0, a, 0],
		                                    schematic_param_a_schema_versi,
		                                    cont));
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });};
		             }
		             var
		              cst_A_recurrent_task = "A recurrent task.",
		              cst_account = "account",
		              cst_accounts = "accounts",
		              cst_action = "action",
		              cst_add = "add",
		              cst_ai = "ai",
		              cst_all = "all",
		              cst_append = "append",
		              cst_archived = "archived",
		              cst_arguments = "arguments",
		              cst_attributes = "attributes",
		              cst_auth = "auth",
		              cst_authorization_servers = "authorization_servers",
		              cst_base = "base",
		              cst_block = "block",
		              cst_blocks = "blocks",
		              cst_calendar = "calendar",
		              cst_call = "call",
		              cst_chat = "chat",
		              cst_client_data = "client_data",
		              cst_code = "code",
		              cst_complete = "complete",
		              cst_completions = "completions",
		              cst_config = "config",
		              cst_console = "console",
		              cst_create = "create",
		              cst_date = "date",
		              cst_daytime = "daytime",
		              cst_delete = "delete",
		              cst_destination = "destination",
		              cst_device = "device",
		              cst_document = "document",
		              cst_email = "email",
		              cst_emails = "emails",
		              cst_enabled = "enabled",
		              cst_err = "err",
		              cst_event = "event",
		              cst_every = "every",
		              cst_external_mcp = "external_mcp",
		              cst_features = "features",
		              cst_filter = "filter",
		              cst_get$0 = "get",
		              cst_graph = "graph",
		              cst_hours = "hours",
		              cst_http = "http",
		              cst_id = "id",
		              cst_identity = "identity",
		              cst_index = "index",
		              cst_integration = "integration",
		              cst_integration_app = "integration_app",
		              cst_integrations = "integrations",
		              cst_key = "key",
		              cst_kind = "kind",
		              cst_level = "level",
		              cst_limit = "limit",
		              cst_list = "list",
		              cst_local = "local",
		              cst_locale = "locale",
		              cst_locked = "locked",
		              cst_login = "login",
		              cst_mandate = "mandate",
		              cst_mcp = "mcp",
		              cst_mention = "mention",
		              cst_message = "message",
		              cst_move = "move",
		              cst_name = "name",
		              cst_notice = "notice",
		              cst_notifications = "notifications",
		              cst_notify = "notify",
		              cst_notion = "notion",
		              cst_oauth = "oauth",
		              cst_obtaining_OAuth_authorizat =
		                "obtaining OAuth authorization code",
		              cst_options = "options",
		              cst_organization = "organization",
		              cst_organization_id = "organization_id",
		              cst_origin = "origin",
		              cst_page = "page",
		              cst_parent = "parent",
		              cst_parse = "parse",
		              cst_participant = "participant",
		              cst_patch = "patch",
		              cst_people = "people",
		              cst_profile = "profile",
		              cst_recipient = "recipient",
		              cst_recurrence = "recurrence",
		              cst_redirect_uri = "redirect_uri",
		              cst_remote = "remote",
		              cst_remove = "remove",
		              cst_request = "request",
		              cst_response_type = "response_type",
		              cst_root = "root",
		              cst_scopes = "scopes",
		              cst_select = "select",
		              cst_self = "self",
		              cst_send = "send",
		              cst_set = "set",
		              cst_set_enabled = "set_enabled",
		              cst_settings = "settings",
		              cst_source = "source",
		              cst_state = "state",
		              cst_stdio = "stdio",
		              cst_task = "task",
		              cst_task_recurrent = "task_recurrent",
		              cst_test = "test",
		              n = "this MCP server is no longer configured",
		              cst_title = "title",
		              cst_token = "token",
		              cst_tools = "tools",
		              cst_transport = "transport",
		              cst_trust = "trust",
		              cst_uid = "uid",
		              cst_upcoming = "upcoming",
		              cst_update = "update",
		              cst_value = "value",
		              cst_viewed = "viewed",
		              cst_warn = "warn",
		              cst_workspace = "workspace",
		              cst_workspace_id = "workspace_id",
		              bP = cst_archived,
		              bO = cst_viewed,
		              fmt$301 =
		                [0,
		                 [11, "Complete a ", [2, 0, [12, 46, 0]]],
		                 "Complete a %s."],
		              default$4 = [0, 0],
		              default$5 = [0, 0],
		              a9r =
		                [0,
		                 [11, "email profile does not support features: ", [15, 0]],
		                 "email profile does not support features: %a"],
		              a9s = [0, 0],
		              a9t =
		                [0, [11, "no such profile: ", [15, 0]], "no such profile: %a"],
		              bbJ = [0, "pages-hierarchies"],
		              bLU = [0, 2],
		              bLT = [0, 0],
		              bL0 = [0, "mandate-parser-wrapper"],
		              bMh = [1, n],
		              bMg = [0, n],
		              bMD =
		                [0,
		                 [11, "invalid console action: ", [2, 0, 0]],
		                 "invalid console action: %s"];
		             function bNQ
		             (of_string,
		              stable_sort,
		              take,
		              is_some,
		              value,
		              some_if,
		              find_packed_by_id,
		              encode,
		              bool_schema,
		              object_wrap,
		              list_schema,
		              mapping_schema,
		              option_schema,
		              timezone_local,
		              of_time,
		              of_string$0,
		              return$,
		              to_option,
		              map,
		              schema_versioned,
		              attach,
		              detach,
		              trigger,
		              return$0,
		              return$1,
		              schema,
		              schema$0,
		              of_string$1,
		              Device,
		              include,
		              schema_versioned$0,
		              schema$1,
		              schema$2,
		              pp,
		              schema_versioned$1,
		              schema$3,
		              schema$4,
		              schema_versioned$2,
		              schema_versioned$3,
		              schema$5,
		              to_string,
		              schema_versioned$4,
		              schema$6,
		              schema_versioned$5,
		              schema$7,
		              By_id,
		              schema_versioned$6,
		              schema$8,
		              client_grant_schema,
		              schema$9,
		              schema$10,
		              schema$11,
		              schema_versioned$7,
		              schema$12,
		              compare,
		              schema$13,
		              personal_organization_of_user_,
		              schema$14,
		              schema$15,
		              schema$16,
		              schema$17,
		              schema$18,
		              schema$19,
		              impersonation_schema,
		              schema$20,
		              schema$21,
		              schema$22,
		              base_client_schema,
		              schema$23,
		              Id,
		              of_google_email,
		              Patch,
		              schema$24,
		              access_token_response_schema,
		              Id$0,
		              schema_versioned$8,
		              schema$25,
		              source_schema,
		              action_schema,
		              event_schema,
		              object,
		              ai_mcp_server,
		              schema$26,
		              schema$27,
		              schema_versioned$9,
		              schema$28,
		              schema_versioned$10,
		              schema$29,
		              mention_origin_schema,
		              view_schema,
		              remove,
		              set,
		              Synchronization_state,
		              v,
		              calendars_state,
		              google,
		              element,
		              ignore_m,
		              Enabled_data_collections,
		              enabled_data_collections,
		              mru_people,
		              Email,
		              v$0,
		              connections,
		              integration_app,
		              notices_personal_archived,
		              notices_personal_viewed,
		              settings,
		              update_mru_people_from_diff,
		              features_schema,
		              document_schema,
		              frequency_bucket_schema,
		              schema$30,
		              ById,
		              schema$31,
		              schema$32,
		              schema$33,
		              schema$34,
		              schema$35,
		              schema$36,
		              schema$37,
		              connected,
		              schema$38,
		              augmented_schema,
		              schema$39,
		              augmented_schema_versioned,
		              chunk_schema_versioned,
		              type_schema_versioned,
		              schema$40,
		              login_schema_versioned,
		              profile_schema_versioned,
		              profile_schema,
		              missing_scope_info_schema_vers,
		              map$0,
		              fail_result,
		              merge,
		              effect_schema,
		              default$,
		              set_f,
		              push_lwt,
		              push_dont_wait,
		              device,
		              api,
		              user_id,
		              state_personal,
		              writable,
		              apply,
		              apply_personal,
		              state_writable_personal,
		              parser,
		              mandate_parse_result_schema_ve,
		              parse,
		              completion_item_schema_version,
		              complete_participant,
		              complete_destination,
		              complete_destination_in_worksp,
		              complete_daytime,
		              complete_date,
		              profile_feature_schema_version,
		              notify_f,
		              notify,
		              offline,
		              user_id$0,
		              claim_account,
		              logout,
		              delete_account,
		              refresh,
		              request_scopes,
		              unlink_account,
		              add_account,
		              handle_login_intent,
		              get,
		              client_data,
		              client_data_all,
		              main,
		              all,
		              feature_has,
		              feature_has$0,
		              patch,
		              value$0,
		              hours_config,
		              locale,
		              create,
		              delete$,
		              update,
		              move,
		              all$0,
		              get$0,
		              default$0,
		              all$1,
		              refresh$0,
		              select,
		              set_default,
		              upcoming_notifications,
		              filter_schema_versioned,
		              all$2,
		              get$1,
		              create_mention,
		              delete_mention,
		              mark,
		              mark_unviewed,
		              get$2,
		              hierarchy_schema,
		              archived,
		              archive,
		              create$0,
		              delete$0,
		              hierarchy,
		              without_title,
		              move$0,
		              unarchive,
		              update$0,
		              a,
		              get$3,
		              by_email,
		              refresh$1,
		              update$1,
		              local_only,
		              call_reactive,
		              call,
		              call_async,
		              call_hook,
		              map_context,
		              creation_option_default,
		              creation_option_schema_version,
		              rpcs,
		              let$,
		              let$0,
		              let$1,
		              let$2,
		              rpcs$0,
		              list,
		              find,
		              upsert,
		              remove$0,
		              discover_authorization_servers,
		              probe_and_store,
		              authorize,
		              ai_with_limit_result_schema,
		              rpcs$1,
		              symbol_map,
		              b,
		              c,
		              let$3,
		              symbol_map$0,
		              let$4,
		              registry,
		              mcp_functions,
		              descriptor,
		              call_tool,
		              generate_access_token,
		              get$4,
		              let$5,
		              add,
		              get$5,
		              list$0,
		              refresh$2,
		              remove$1,
		              update$2,
		              exchange_token,
		              generate_import_id,
		              let$6,
		              rpcs$2,
		              let$7,
		              let$8,
		              let$9,
		              rpcs$3,
		              append,
		              remove_metadata,
		              let$10,
		              get$6,
		              patch$0,
		              perform_action,
		              let$11,
		              let$12,
		              controller_supported_actions_s,
		              let$13,
		              let$14,
		              let$15,
		              let$16,
		              accounts,
		              impersonate,
		              side,
		              config,
		              namespace_ctrl,
		              d,
		              Read,
		              Patch$0,
		              schema$41,
		              schema$42,
		              schema$43,
		              id$0,
		              no_input_schema,
		              schematic_param_a_schema_versi,
		              schematic_param_name_schema_ve,
		              json_schema,
		              int_schema,
		              cont){
		              return function(schema$44){
		               var
		                cst_authorize = "authorize",
		                authorize$0 =
		                  call_async
		                   (cst_authorize,
		                    "Obtain OAuth authorization code.",
		                    [0,
		                     id$0,
		                     [0,
		                      [0, cst_redirect_uri, schema$41, 0],
		                      [0,
		                       [0, cst_response_type, schematic_param_name_schema_ve, 0],
		                       [0, [0, cst_state, schema$44, 0], c]]]],
		                    schema$41,
		                    b);
		               function v$1(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline(cst_obtaining_OAuth_authorizat, ctrl),
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (api,
		                                   ctrl[1],
		                                   function(match){
		                                    var api = match[2], Api = match[1];
		                                    return caml_trampoline_cps_call3(Api[9][2], api, id, cont);
		                                   });
		                         },
		                         cont);
		               }
		               var
		                get_client =
		                  call_async
		                   ("get_client",
		                    "Fetch OAuth client from the API.",
		                    [0, id$0, 0],
		                    client_grant_schema,
		                    local_only(side, v$1));
		               return caml_exact_trampoline_cps_call$1
		                       (namespace_ctrl,
		                        cst_oauth,
		                        [0, authorize$0, [0, get_client, 0]],
		                        function(f){
		                         var
		                          id$0 = [0, cst_id, schema$11, 0],
		                          source = [0, cst_source, source_schema, 0],
		                          b = local_only(side, all$0),
		                          all$3 =
		                            call_reactive
		                             (cst_all,
		                              "All recurrent task sorted by decreasing order of frequency.",
		                              0,
		                              list_schema(frequency_bucket_schema),
		                              b);
		                         function v$1(ctrl, task, options, cont){
		                          var
		                           match = value(options, creation_option_default),
		                           source = match[3],
		                           notify = match[2],
		                           document = match[1];
		                          function a(crdt, cont){
		                           return caml_exact_trampoline_cps_call$7
		                                   (create,
		                                    ctrl,
		                                    crdt,
		                                    document,
		                                    [0, notify],
		                                    source,
		                                    task,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(of_string, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         }
		                         var c = [0, f, d], e = local_only(side, v$1);
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (creation_option_schema_version,
		                                  schematic_version,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call
		   (option_schema,
		    b,
		    function(schema$44){
		     var
		      schema$45 = Read[6],
		      create =
		        call_async
		         (cst_create,
		          "Create a recurrent task.",
		          [0,
		           [0, cst_task, schema$45, 0],
		           [0, [0, cst_options, schema$44, 0], 0]],
		          schema$11,
		          e);
		     function v$1(ctrl, id, cont){
		      function a(crdt, cont){
		       return caml_exact_trampoline_cps_call$0
		               (delete$,
		                ctrl,
		                crdt,
		                id,
		                function(a){
		                 return caml_exact_trampoline_cps_call(of_string, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (writable,
		               ctrl[2],
		               function(b){
		                return caml_trampoline_cps_call3(let$, b, a, cont);
		               });
		     }
		     var
		      delete$1 =
		        call_async
		         (cst_delete,
		          "Delete a recurrent task.",
		          [0, id$0, 0],
		          schematic_param_a_schema_versi,
		          local_only(side, v$1)),
		      b = local_only(side, get);
		     function schematic_version(param, cont){return cont(0);}
		     return caml_exact_trampoline_cps_call
		             (schema_versioned$7,
		              schematic_version,
		              function(d){
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        d,
		                        function(d){
		                         var
		                          get =
		                            call_reactive
		                             (cst_get$0, cst_A_recurrent_task, [0, id$0, 0], d, b);
		                         function v$1(ctrl, id, patch, source, cont){
		                          function a(crdt, cont){
		                           return caml_exact_trampoline_cps_call$3
		                                   (update, ctrl, crdt, id, patch, source, cont);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         }
		                         var
		                          update$3 =
		                            call_async
		                             (cst_update,
		                              "Patch a recurrent task.",
		                              [0, id$0, [0, [0, cst_patch, schema$10, 0], [0, source, 0]]],
		                              schema$12,
		                              local_only(side, v$1));
		                         function v$2(ctrl, recurrence, every, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_string, [0, every], recurrence, cont);
		                         }
		                         var
		                          to_string$0 =
		                            call
		                             ("to_string",
		                              "Convert a recurrence into a string",
		                              [0,
		                               [0, cst_recurrence, schema, 0],
		                               [0, [0, cst_every, bool_schema, 0], 0]],
		                              schematic_param_name_schema_ve,
		                              local_only(side, v$2));
		                         function v$3(ctrl, id, destination, source, cont){
		                          function a(crdt, cont){
		                           return caml_exact_trampoline_cps_call$3
		                                   (move, ctrl, crdt, id, destination, source, cont);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         }
		                         var
		                          move$1 =
		                            call_async
		                             (cst_move,
		                              "Move a recurrent task.",
		                              [0,
		                               id$0,
		                               [0,
		                                [0, cst_destination, document_schema, 0],
		                                [0, source, 0]]],
		                              schematic_param_a_schema_versi,
		                              local_only(side, v$3));
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  cst_task_recurrent,
		                                  [0,
		                                   all$3,
		                                   [0,
		                                    create,
		                                    [0,
		                                     delete$1,
		                                     [0, get, [0, update$3, [0, to_string$0, [0, move$1, 0]]]]]]],
		                                  function(d){
		                                   var b = [0, d, c];
		                                   return caml_exact_trampoline_cps_call$1
		   (rpcs,
		    config,
		    side,
		    function(space){
		     var
		      id$0 = [0, cst_id, schema$26, 0],
		      source = [0, cst_source, source_schema, 0];
		     function v$1(ctrl, emails, cont){
		      function a(crdt, cont){
		       return caml_exact_trampoline_cps_call
		               (state_personal,
		                ctrl[2],
		                function(state){
		                 return caml_exact_trampoline_cps_call$1
		                         (Email[17],
		                          emails,
		                          state[11][2],
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (Email[24],
		                                    a,
		                                    function(mru_people$0){
		                                     return caml_exact_trampoline_cps_call$1
		     (update_mru_people_from_diff,
		      state[21][6],
		      mru_people$0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (mru_people,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (settings,
		                          a,
		                          function(crdt_op){
		                           return caml_exact_trampoline_cps_call$0
		                                   (apply_personal,
		                                    ctrl[1],
		                                    crdt,
		                                    crdt_op,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(of_string$0, a, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (writable,
		               ctrl[2],
		               function(b){
		                return caml_trampoline_cps_call3(let$1, b, a, cont);
		               });
		     }
		     var
		      c = local_only(side, v$1),
		      schema = list_schema(schematic_param_name_schema_ve),
		      c =
		        [0,
		         call_async
		          ("use_emails",
		           "Prioritize emails as recently used for future completions.",
		           [0, [0, cst_emails, schema, 0], 0],
		           schematic_param_a_schema_versi,
		           c),
		         0];
		     function v$2(ctrl, id, patch, source, cont){
		      function a(crdt, cont){
		       return caml_exact_trampoline_cps_call$3
		               (update$1,
		                ctrl,
		                crdt,
		                id,
		                patch,
		                source,
		                function(a){
		                 return caml_trampoline_cps_call2(of_string$0, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (writable,
		               ctrl[2],
		               function(b){
		                return caml_trampoline_cps_call3(let$1, b, a, cont);
		               });
		     }
		     var
		      cst_refresh = "refresh",
		      c =
		        [0,
		         call_async
		          (cst_refresh,
		           "Reload contact.",
		           [0, id$0, 0],
		           schematic_param_a_schema_versi,
		           local_only(side, refresh$1)),
		         c],
		      d =
		        [0,
		         call_async
		          (cst_patch,
		           "Modify a contact.",
		           [0, id$0, [0, [0, cst_patch, schema$27, 0], [0, source, 0]]],
		           schematic_param_a_schema_versi,
		           local_only(side, v$2)),
		         c],
		      e = [0, [0, cst_task, space], b],
		      f = local_only(side, get$3);
		     function schematic_version(param, cont){return cont(0);}
		     return caml_exact_trampoline_cps_call
		             (schema_versioned$9,
		              schematic_version,
		              function(b){
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        b,
		                        function(g){
		                         var
		                          b =
		                            [0,
		                             call_reactive
		                              (cst_get$0,
		                               "The contact with the given id.",
		                               [0, id$0, 0],
		                               g,
		                               f),
		                             d],
		                          c = local_only(side, by_email);
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  schema$28,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call$1
		   (namespace_ctrl,
		    cst_people,
		    [0,
		     call_reactive
		      ("by_email",
		       "The potential contact owning this email address.",
		       [0, [0, cst_email, schematic_param_name_schema_ve, 0], 0],
		       d,
		       c),
		     b],
		    function(g){
		     var
		      id$0 = [0, cst_id, schema$1, 0],
		      source = [0, cst_source, source_schema, 0],
		      c = local_only(side, hierarchy),
		      b = list_schema(hierarchy_schema),
		      d = [0, bbJ, b[2], b[3], b[4]],
		      f = [0, g, e];
		     return caml_exact_trampoline_cps_call
		             (option_schema,
		              schema$5,
		              function(schema){
		               var
		                all$0 =
		                  call_reactive
		                   (cst_all,
		                    "All pages of specified workspace.",
		                    [0, [0, cst_workspace, schema, 0], 0],
		                    d,
		                    c);
		               function v$1(ctrl, id, source, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (archive, ctrl, crdt, id, source, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$2, b, a, cont);
		                         });
		               }
		               var
		                archive$0 =
		                  call_async
		                   ("archive",
		                    "Archive page.",
		                    [0, id$0, [0, source, 0]],
		                    schematic_param_a_schema_versi,
		                    local_only(side, v$1)),
		                b = local_only(side, archived);
		               return caml_exact_trampoline_cps_call
		                       (a,
		                        list_schema(schema$1),
		                        function(d){
		                         var
		                          archived =
		                            call_reactive(cst_archived, "All archived pages.", 0, d, b);
		                         function v$1(ctrl, title, parent, source, cont){
		                          function a(crdt, cont){
		                           return caml_exact_trampoline_cps_call$3
		                                   (create$0,
		                                    ctrl,
		                                    crdt,
		                                    title,
		                                    parent,
		                                    source,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(of_string, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$2, b, a, cont);
		                                   });
		                         }
		                         var c = local_only(side, v$1), a = [0, source, 0];
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  schema$39,
		                                  function(schema){
		                                   var
		                                    create =
		                                      call_async
		                                       (cst_create,
		"Create a pages.",
		[0,
		 [0, cst_title, schematic_param_name_schema_ve, 0],
		 [0, [0, cst_root, schema, 0], a]],
		schema$1,
		c);
		                                   function v$1(ctrl, id, source, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (delete$0,
		      ctrl,
		      crdt,
		      id,
		      source,
		      function(a){
		       return caml_exact_trampoline_cps_call(of_string, a, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$2, b, a, cont);
		     });
		                                   }
		                                   var
		                                    delete$ =
		                                      call_async
		                                       (cst_delete,
		"Delete page.",
		[0, id$0, [0, source, 0]],
		schematic_param_a_schema_versi,
		local_only(side, v$1)),
		                                    b = local_only(side, get$2);
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (augmented_schema_versioned,
		    schematic_version,
		    function(a){
		     return caml_exact_trampoline_cps_call
		             (option_schema,
		              a,
		              function(d){
		               var
		                get =
		                  call_reactive(cst_get$0, "Get a page.", [0, id$0, 0], d, b);
		               function v$1(ctrl, id, parent, index, source, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (move$0, ctrl, crdt, parent, dummy, source, id, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$2, b, a, cont);
		                         });
		               }
		               var
		                a = [0, [0, cst_index, int_schema, 0], [0, source, 0]],
		                c = local_only(side, v$1);
		               return caml_exact_trampoline_cps_call
		                       (schema_versioned$0,
		                        dummy,
		                        function(b){
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  b,
		                                  function(schema){
		                                   var
		                                    move =
		                                      call_async
		                                       (cst_move,
		"Change a page parent.",
		[0, id$0, [0, [0, cst_parent, schema, 0], a]],
		schematic_param_a_schema_versi,
		c);
		                                   function v$1(ctrl, id, source, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (unarchive, ctrl, crdt, id, source, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$2, b, a, cont);
		     });
		                                   }
		                                   var
		                                    unarchive$0 =
		                                      call_async
		                                       ("unarchive",
		"Unarchive page.",
		[0, id$0, [0, source, 0]],
		schematic_param_a_schema_versi,
		local_only(side, v$1));
		                                   function v$2(ctrl, id, patch, source, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call$3
		     (update$0, ctrl, crdt, id, patch, source, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$2, b, a, cont);
		     });
		                                   }
		                                   var
		                                    b = local_only(side, v$2),
		                                    schema$10 = Patch$0[5],
		                                    update =
		                                      call_async
		                                       (cst_update,
		"Update a page.",
		[0, id$0, [0, [0, cst_patch, schema$10, 0], [0, source, 0]]],
		schematic_param_a_schema_versi,
		b),
		                                    b = local_only(side, without_title),
		                                    without_title$0 =
		                                      call_reactive
		                                       ("without_title",
		"Pages without title.",
		0,
		list_schema(schema$1),
		b);
		                                   return caml_exact_trampoline_cps_call$1
		   (namespace_ctrl,
		    cst_page,
		    [0,
		     all$0,
		     [0,
		      archive$0,
		      [0,
		       archived,
		       [0,
		        create,
		        [0,
		         delete$,
		         [0,
		          get,
		          [0,
		           move,
		           [0, unarchive$0, [0, update, [0, without_title$0, 0]]]]]]]]]],
		    function(c){
		     function v$1(ctrl, patch$0, cont){
		      function a(crdt, cont){
		       return caml_exact_trampoline_cps_call$0
		               (patch,
		                ctrl,
		                crdt,
		                patch$0,
		                function(a){
		                 return caml_trampoline_cps_call2(of_string$0, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (writable,
		               ctrl[2],
		               function(b){
		                return caml_trampoline_cps_call3(let$0, b, a, cont);
		               });
		     }
		     var
		      a =
		        [0,
		         call_reactive
		          (cst_settings,
		           "Settings.",
		           0,
		           schema$18,
		           local_only(side, value$0)),
		         0],
		      a =
		        [0,
		         call_async
		          (cst_patch,
		           "Edit settings.",
		           [0, [0, cst_patch, schema$19, 0], 0],
		           schematic_param_a_schema_versi,
		           local_only(side, v$1)),
		         a],
		      a =
		        [0,
		         call_reactive
		          (cst_locale,
		           "Locale.",
		           0,
		           schema$15,
		           local_only(side, locale)),
		         a],
		      b = [0, c, f];
		     return caml_exact_trampoline_cps_call$1
		             (namespace_ctrl,
		              cst_settings,
		              [0,
		               call_reactive
		                (cst_hours,
		                 "Hours format.",
		                 0,
		                 schema$17,
		                 local_only(side, hours_config)),
		               a],
		              function(c){
		               var a = [0, c, b];
		               return caml_exact_trampoline_cps_call$1
		                       (rpcs$0,
		                        config,
		                        side,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  cst_organization,
		                                  b,
		                                  function(d){
		                                   function v$1(ctrl, message, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (notify(ctrl), 0, bLT, [0, [9, message], 0], cont);
		                                   }
		                                   var
		                                    err =
		                                      call
		                                       (cst_err,
		"Send error notification message.",
		[0, [0, cst_message, schematic_param_name_schema_ve, 0], 0],
		schematic_param_a_schema_versi,
		local_only(side, v$1));
		                                   function v$2(ctrl, cont){
		                                    var hook = ctrl[15][1];
		                                    return cont
		    (function(cb, cont){
		      return caml_exact_trampoline_cps_call$1
		              (attach,
		               hook[1],
		               cb,
		               function(match){
		                var subscription = match[2], new_hook = match[1];
		                hook[1] = new_hook;
		                return cont
		                        (function(param, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (detach,
		                                   hook[1],
		                                   subscription,
		                                   function(a){hook[1] = a; return cont(0);});
		                         });
		               });
		     });
		                                   }
		                                   var
		                                    notifications =
		                                      call_hook
		                                       (cst_notifications,
		"System notifications.",
		0,
		schema$40,
		local_only(side, v$2));
		                                   function v$3(ctrl, message, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (notify(ctrl), 0, 0, [0, [9, message], 0], cont);
		                                   }
		                                   var
		                                    notify$0 =
		                                      call
		                                       (cst_notify,
		"Send informational notification message.",
		[0, [0, cst_message, schematic_param_name_schema_ve, 0], 0],
		schematic_param_a_schema_versi,
		local_only(side, v$3));
		                                   function v$4(ctrl, message, type, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (notify(ctrl), 0, [0, type], message, cont);
		                                   }
		                                   var b = [0, d, a], c = local_only(side, v$4);
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (type_schema_versioned,
		    schematic_version,
		    function(schema){
		     var a = [0, [0, cst_level, schema, 0], 0];
		     function schematic_version(param, cont){return cont(0);}
		     return caml_exact_trampoline_cps_call
		             (chunk_schema_versioned,
		              schematic_version,
		              function(d){
		               var
		                schema = schema_versioned(schematic_version, d),
		                notify_rich =
		                  call
		                   ("notify_rich",
		                    "Send notification.",
		                    [0, [0, cst_message, schema, 0], a],
		                    schematic_param_a_schema_versi,
		                    c);
		               function v$1(ctrl, limit, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (upcoming_notifications,
		                         ctrl,
		                         limit,
		                         function(a){
		                          return caml_trampoline_cps_call2(return$1, a, cont);
		                         });
		               }
		               var
		                d = local_only(side, v$1),
		                upcoming =
		                  call_async
		                   (cst_upcoming,
		                    "Get the next N upcoming notifications.",
		                    [0, [0, cst_limit, int_schema, 0], 0],
		                    list_schema(schema$40),
		                    d);
		               function v$2(ctrl, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (attach,
		                         ctrl[7][1],
		                         f,
		                         function(match){
		                          var
		                           subscription = match[2],
		                           events_upcoming_hook = match[1];
		                          ctrl[7][1] = events_upcoming_hook;
		                          return cont
		                                  (function(param, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (detach,
		     ctrl[7][1],
		     subscription,
		     function(a){ctrl[7][1] = a; return cont(0);});
		                                   });
		                         });
		               }
		               var
		                upcoming_events =
		                  call_hook
		                   ("upcoming_events",
		                    "Upcoming events notifications",
		                    0,
		                    schema$42,
		                    local_only(side, v$2));
		               function v$3(ctrl, message, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (notify(ctrl), 0, bLU, [0, [9, message], 0], cont);
		               }
		               var
		                warn =
		                  call
		                   (cst_warn,
		                    "Send warning notification message.",
		                    [0, [0, cst_message, schematic_param_name_schema_ve, 0], 0],
		                    schematic_param_a_schema_versi,
		                    local_only(side, v$3));
		               return caml_exact_trampoline_cps_call$1
		                       (namespace_ctrl,
		                        cst_notifications,
		                        [0,
		                         err,
		                         [0,
		                          notifications,
		                          [0,
		                           notify$0,
		                           [0,
		                            notify_rich,
		                            [0, upcoming, [0, upcoming_events, [0, warn, 0]]]]]]],
		                        function(d){
		                         function v$1(ctrl, event, extra_attrs, cont){
		                          return caml_trampoline_cps_call3
		                                  (map,
		                                   extra_attrs,
		                                   function(param, cont){
		                                    var v = param[2], k = param[1];
		                                    return cont([0, k, [0, -976970511, v]]);
		                                   },
		                                   function(extra_attrs){
		                                    return caml_exact_trampoline_cps_call$0
		    (push_lwt,
		     ctrl[11],
		     [0, extra_attrs],
		     event,
		     function(a){
		      return caml_trampoline_cps_call3
		              (symbol_map$0, a, of_string$0, cont);
		     });
		                                   });
		                         }
		                         var
		                          a = local_only(side, v$1),
		                          schema =
		                            [0,
		                             0,
		                             0,
		                             mapping_schema(schematic_param_name_schema_ve)[3],
		                             0],
		                          send =
		                            call_async
		                             (cst_send,
		                              "Send metric. Note that there is a bug in the Schematic -> Typescript generator (probably caused by `inline_try` in `object_metrics`), so you will need to type the `kind` parameter as `any` for the time being. See https://open.routine.co?path=/objects/workspace:121JWTM-FSgGW90epLxqV/table:kYTuKSD2WuHsTxWm1V0WS/row:y8WgNyOYq3FdMINMw7SGu",
		                              [0,
		                               [0, cst_kind, event_schema, 0],
		                               [0, [0, cst_attributes, schema, 0], 0]],
		                              schematic_param_a_schema_versi,
		                              a);
		                         function v$2(ctrl, id, workspace_id, source, action, cont){
		                          var a = object(id, workspace_id, source, action);
		                          return caml_exact_trampoline_cps_call$0
		                                  (push_lwt,
		                                   ctrl[11],
		                                   0,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (symbol_map$0, a, of_string$0, cont);
		                                   });
		                         }
		                         var
		                          send_object =
		                            call_async
		                             ("send_object",
		                              "Same as `send` but specialized for `Object` type of metrics, to simplify call sites, and to work around the aforementioned Schematic Typescript bug.",
		                              [0,
		                               [0, cst_id, schema$6, 0],
		                               [0,
		                                [0, cst_workspace_id, schema$5, 0],
		                                [0,
		                                 [0, cst_source, source_schema, 0],
		                                 [0, [0, cst_action, action_schema, 0], 0]]]],
		                              schematic_param_a_schema_versi,
		                              local_only(side, v$2)),
		                          c = [0, d, b];
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  "metric",
		                                  [0, send, [0, send_object, 0]],
		                                  function(e){
		                                   function v$1(ctrl, filter, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (all$2, filter, ctrl, cont);
		                                   }
		                                   var
		                                    a = local_only(side, v$1),
		                                    b = list_schema(schema$29),
		                                    d = [0, e, c];
		                                   function schematic_version(param){return 0;}
		                                   return caml_exact_trampoline_cps_call
		   (filter_schema_versioned,
		    schematic_version,
		    function(c){
		     return caml_exact_trampoline_cps_call
		             (option_schema,
		              c,
		              function(schema){
		               var
		                all$0 =
		                  call_reactive
		                   (cst_all,
		                    "List all notice IDs for current user, optionally filtered by viewed status.",
		                    [0, [0, cst_filter, schema, 0], 0],
		                    b,
		                    a);
		               function v$1(ctrl, notice_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$1, ctrl, notice_id, cont);
		               }
		               var c = local_only(side, v$1);
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        augmented_schema,
		                        function(b){
		                         var
		                          get =
		                            call_reactive
		                             (cst_get$0,
		                              "Get a specific notice.",
		                              [0, [0, cst_id, schema$29, 0], 0],
		                              b,
		                              c);
		                         function v$1(ctrl, notice, cont){
		                          var crdt = ctrl[2];
		                          function a(param, cont){
		                           return caml_exact_trampoline_cps_call(of_string, 0, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$3
		                                  (mark,
		                                   notices_personal_viewed,
		                                   bO,
		                                   ctrl,
		                                   crdt,
		                                   notice,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$3, b, a, cont);
		                                   });
		                         }
		                         var
		                          mark_viewed =
		                            call_async
		                             ("mark_viewed",
		                              "Mark notice as viewed.",
		                              [0, [0, cst_notice, augmented_schema, 0], 0],
		                              schematic_param_a_schema_versi,
		                              local_only(side, v$1));
		                         function v$2(ctrl, notice, cont){
		                          function a(param, cont){
		                           return caml_exact_trampoline_cps_call(of_string, 0, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (mark_unviewed,
		                                   ctrl,
		                                   ctrl[2],
		                                   notice,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$3, b, a, cont);
		                                   });
		                         }
		                         var
		                          mark_unviewed$0 =
		                            call_async
		                             ("mark_unviewed",
		                              "Mark notice as unviewed.",
		                              [0, [0, cst_notice, augmented_schema, 0], 0],
		                              schematic_param_a_schema_versi,
		                              local_only(side, v$2));
		                         function v$3(ctrl, notice, cont){
		                          var crdt = ctrl[2];
		                          function a(param, cont){
		                           return caml_exact_trampoline_cps_call(of_string, 0, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$3
		                                  (mark,
		                                   notices_personal_archived,
		                                   bP,
		                                   ctrl,
		                                   crdt,
		                                   notice,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$3, b, a, cont);
		                                   });
		                         }
		                         var
		                          mark_archived =
		                            call_async
		                             ("mark_archived",
		                              "Archive notice (remove from inbox).",
		                              [0, [0, cst_notice, augmented_schema, 0], 0],
		                              schematic_param_a_schema_versi,
		                              local_only(side, v$3));
		                         function v$4(ctrl, recipient, origin, cont){
		                          function a(id, cont){
		                           return caml_exact_trampoline_cps_call(of_string, id, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$2
		                                  (create_mention,
		                                   ctrl,
		                                   ctrl[2],
		                                   recipient,
		                                   origin,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$3, b, a, cont);
		                                   });
		                         }
		                         var a = local_only(side, v$4);
		                         return caml_exact_trampoline_cps_call
		                                 (schema_versioned$10,
		                                  dummy,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call
		   (option_schema,
		    b,
		    function(b){
		     var
		      mention =
		        call_async
		         (cst_mention,
		          "Create a new mention notice.",
		          [0,
		           [0, cst_recipient, schema$4, 0],
		           [0, [0, cst_origin, mention_origin_schema, 0], 0]],
		          b,
		          a);
		     function v$1(ctrl, id, recipient, workspace, cont){
		      function a(param, cont){
		       return caml_exact_trampoline_cps_call(of_string, 0, cont);
		      }
		      return caml_exact_trampoline_cps_call$3
		              (delete_mention,
		               ctrl,
		               ctrl[2],
		               id,
		               recipient,
		               workspace,
		               function(b){
		                return caml_trampoline_cps_call3(let$3, b, a, cont);
		               });
		     }
		     var
		      unmention =
		        call_async
		         ("unmention",
		          "Remove notice.",
		          [0,
		           [0, cst_id, schema$29, 0],
		           [0,
		            [0, cst_recipient, schema$4, 0],
		            [0, [0, cst_workspace, schema$5, 0], 0]]],
		          schematic_param_a_schema_versi,
		          local_only(side, v$1));
		     return caml_exact_trampoline_cps_call$1
		             (namespace_ctrl,
		              cst_notice,
		              [0,
		               all$0,
		               [0,
		                get,
		                [0,
		                 mark_viewed,
		                 [0,
		                  mark_unviewed$0,
		                  [0, mark_archived, [0, mention, [0, unmention, 0]]]]]]],
		              function(c){
		               var
		                remote_value_schema = config[3],
		                cst_parser = "parser",
		                schema =
		                  object_wrap
		                   (cst_parser, remote_value_schema("mandate-parser", side)),
		                parser_schema = [0, bL0, schema[2], schema[3], schema[4]];
		               function complete(name, completer, cont){
		                var
		                 a =
		                   side
		                    ? 0
		                    : [0,
		                      function(ctrl, parser, phrase, limit, cont){
		                       var value = parser[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (completer,
		                                value,
		                                phrase,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (take, a, limit, cont);
		                                });
		                      }];
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (completion_item_schema_version,
		                         schematic_version,
		                         function(d){
		                          var
		                           b = [0, 0, 0, [3, d], 0],
		                           c =
		                             [0,
		                              [0, cst_parser, parser_schema, 0],
		                              [0,
		                               [0, cst_input, schematic_param_name_schema_ve, 0],
		                               [0, [0, cst_limit, int_schema, 0], 0]]];
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$301,
		                                   function(d){
		                                    return caml_trampoline_cps_call2
		    (d, name, function(d){return cont(call(name, d, c, b, a));});
		                                   });
		                         });
		               }
		               var
		                b = [0, c, d],
		                a =
		                  side
		                   ? 0
		                   : [0,
		                     function(ctrl, parser, phrase, limit, workspace_id, cont){
		                      if(workspace_id)
		                       var
		                        workspace_id$0 = workspace_id[1],
		                        completer = complete_destination_in_worksp(workspace_id$0);
		                      else
		                       completer = complete_destination;
		                      var value = parser[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (completer,
		                               value,
		                               phrase,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(take, a, limit, cont);
		                               });
		                     }];
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (completion_item_schema_version,
		                        schematic_version,
		                        function(d){
		                         var c = [0, 0, 0, [3, d], 0];
		                         return caml_exact_trampoline_cps_call
		                                 (schema_versioned$3,
		                                  dummy,
		                                  function(d){
		                                   return caml_exact_trampoline_cps_call
		   (option_schema,
		    d,
		    function(schema){
		     var
		      complete_destination =
		        call
		         (cst_destination,
		          "Complete a destination.",
		          [0,
		           [0, cst_parser, parser_schema, 0],
		           [0,
		            [0, cst_input, schematic_param_name_schema_ve, 0],
		            [0,
		             [0, cst_limit, int_schema, 0],
		             [0, [0, cst_workspace_id, schema, 0], 0]]]],
		          c,
		          a);
		     return caml_exact_trampoline_cps_call$1
		             (complete,
		              cst_daytime,
		              complete_daytime,
		              function(c){
		               var a = [0, c, 0];
		               return caml_exact_trampoline_cps_call$1
		                       (complete,
		                        cst_date,
		                        complete_date,
		                        function(d){
		                         var c = [0, complete_destination, [0, d, a]];
		                         return caml_exact_trampoline_cps_call$1
		                                 (complete,
		                                  cst_participant,
		                                  complete_participant,
		                                  function(e){
		                                   var
		                                    space = [0, e, c],
		                                    d =
		                                      side
		                                       ? 0
		                                       : [0,
		 function(ctrl, parser, locked, phrase, cont){
		  var value = parser[1];
		  return caml_exact_trampoline_cps_call$0
		          (parse, value, locked, phrase, cont);
		 }];
		                                   function schematic_version(param, cont){return cont(0);}
		                                   var a = [0, [0, cst_complete, space], 0];
		                                   return caml_exact_trampoline_cps_call
		   (mandate_parse_result_schema_ve,
		    schematic_version,
		    function(c){
		     return caml_exact_trampoline_cps_call
		             (option_schema,
		              c,
		              function(c){
		               c =
		                [0,
		                 call
		                  (cst_parse,
		                   "Analyze a phrase with Mandate.",
		                   [0,
		                    [0, cst_parser, parser_schema, 0],
		                    [0,
		                     [0, cst_locked, int_schema, 0],
		                     [0, [0, "phrase", schematic_param_name_schema_ve, 0], 0]]],
		                   c,
		                   d),
		                 a];
		               var
		                e =
		                  side
		                   ? 0
		                   : [0,
		                     function(ctrl, features, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (parser,
		                               ctrl[10],
		                               features,
		                               function(value){return cont([1, value]);});
		                     }];
		               return caml_exact_trampoline_cps_call$1
		                       (namespace_ctrl,
		                        cst_mandate,
		                        [0,
		                         call
		                          ("make_parser",
		                           "Create a parser for the given feature set.",
		                           [0, [0, cst_features, features_schema, 0], 0],
		                           parser_schema,
		                           e),
		                         c],
		                        function(d){
		                         function v$1(ctrl, request, organization_id, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (offline("calling OpenAI", ctrl),
		                                   function(param, cont){
		                                    return caml_exact_trampoline_cps_call
		    (api,
		     ctrl[1],
		     function(match){
		      var api = match[2], Api = match[1];
		      return caml_exact_trampoline_cps_call
		              (user_id,
		               ctrl[1],
		               function(user_id){
		                return caml_exact_trampoline_cps_call
		                        (personal_organization_of_user_,
		                         user_id,
		                         function(b){
		                          var organization_id$0 = value(organization_id, b);
		                          function a(param, cont){
		                           if(0 === param[0]){
		                            var response = param[1];
		                            return cont([0, [0, response]]);
		                           }
		                           var e = param[1];
		                           if(typeof e !== "number"){
		                            var variant = e[1];
		                            if(-867418942 > variant){
		                             var reset_time = e[2];
		                             return caml_exact_trampoline_cps_call$1
		                                     (of_time,
		                                      timezone_local,
		                                      reset_time,
		                                      function(reset_date){
		                                       return cont([0, [1, [0, reset_date]]]);
		                                      });
		                            }
		                           }
		                           return cont([1, e]);
		                          }
		                          return caml_trampoline_cps_call4
		                                  (Api[4][3][1][1][1],
		                                   api,
		                                   organization_id$0,
		                                   request,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   },
		                                   cont);
		                         }
		                         var a = local_only(side, v$1), c = [0, d, b];
		                         return caml_exact_trampoline_cps_call
		                                 (ai_with_limit_result_schema,
		                                  no_input_schema,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call
		   (option_schema,
		    schema$2,
		    function(schema){
		     var
		      space =
		        [0,
		         call_async
		          (cst_create,
		           "Create OpenAI chat completion.",
		           [0,
		            [0, cst_request, base_client_schema, 0],
		            [0, [0, cst_organization_id, schema, 0], 0]],
		           b,
		           a),
		         0];
		     return caml_exact_trampoline_cps_call$1
		             (namespace_ctrl,
		              "openai",
		              [0, [0, cst_chat, [0, [0, cst_completions, space], 0]], 0],
		              function(f){
		               function v$1(graph, organization_id, integrations, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (registry,
		                         graph,
		                         organization_id,
		                         integrations,
		                         function(registry){
		                          return caml_exact_trampoline_cps_call
		                                  (mcp_functions,
		                                   registry,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (encode,
		     a,
		     function(a){
		      return caml_trampoline_cps_call3
		              (map,
		               a,
		               descriptor,
		               function(a){
		                return caml_trampoline_cps_call2(return$1, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                a = local_only(side, v$1),
		                b = list_schema(schema$31),
		                schema = list_schema(schema$23),
		                e = [0, f, c],
		                d = [0, [0, cst_integrations, schema, 0], 0];
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        schema$2,
		                        function(schema){
		                         var
		                          list$1 =
		                            call_async
		                             (cst_list,
		                              "List MCP tools available for an optional organization and the given integrations. When the organization is absent, all local organizations are in scope.",
		                              [0, [0, cst_organization_id, schema, 0], d],
		                              b,
		                              a);
		                         function v$1
		                         (graph,
		                          organization_id,
		                          integrations,
		                          name,
		                          arguments$,
		                          cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (registry,
		                                   graph,
		                                   organization_id,
		                                   integrations,
		                                   function(registry){
		                                    function a(result, cont){return cont([0, result]);}
		                                    return caml_exact_trampoline_cps_call$0
		    (call_tool,
		     registry,
		     name,
		     arguments$,
		     function(b){
		      return caml_trampoline_cps_call3(let$4, b, a, cont);
		     });
		                                   });
		                         }
		                         var
		                          f = local_only(side, v$1),
		                          schema$1 = list_schema(schema$23),
		                          c =
		                            [0,
		                             [0, cst_integrations, schema$1, 0],
		                             [0,
		                              [0, cst_name, schematic_param_name_schema_ve, 0],
		                              [0, [0, cst_arguments, json_schema, 0], 0]]];
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  schema$2,
		                                  function(schema){
		                                   var
		                                    call$0 =
		                                      call_async
		                                       (cst_call,
		"Execute an MCP tool by name with JSON arguments for an optional organization and the given integrations. When the organization is absent, all local organizations are in scope.",
		[0, [0, cst_organization_id, schema, 0], c],
		schema$32,
		f);
		                                   return caml_exact_trampoline_cps_call$1
		   (map_context,
		    [0,
		     cst_mcp,
		     [0, [0, cst_tools, [0, list$1, [0, call$0, 0]]], 0]],
		    function(param){var graph = param[2]; return graph;},
		    function(b){
		     function v$1(ctrl, cont){
		      return caml_exact_trampoline_cps_call
		              (offline("getting the marketplace submission url", ctrl),
		               function(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (api,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          return caml_trampoline_cps_call2(Api[8][1], api, cont);
		                         });
		               },
		               cont);
		     }
		     var a = [0, b, e];
		     return caml_exact_trampoline_cps_call$1
		             (namespace_ctrl,
		              "marketplace",
		              [0,
		               call_async
		                ("submit_url",
		                 'URL to POST a marketplace submission to, as a multipart/form-data \\\n       body with a required "package" file, optional "title" and "description" text fields and optional "screenshot" file.',
		                 0,
		                 schema$41,
		                 local_only(side, v$1)),
		               0],
		              function(d){
		               var
		                enabled_data_collection_id =
		                  [0, "enabled_data_collection_id", schema$21, 0],
		                enabled_data_collection =
		                  [0, "enabled_data_collection", schema$20, 0],
		                workspace_id = [0, cst_workspace_id, schema$5, 0],
		                organization_id = [0, cst_organization_id, schema$2, 0],
		                generate_access_token$0 =
		                  call_async
		                   ("generate_access_token",
		                    "Generate an Integration App access token (JWT) to be able to interact with Integration App from the front. You must provide an organization ID because Integration App connections are per organization (while data is per workspace).",
		                    [0, organization_id, 0],
		                    schematic_param_name_schema_ve,
		                    local_only(side, generate_access_token)),
		                b = [0, d, a],
		                c = local_only(side, get$4);
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        schema$22,
		                        function(a){
		                         var
		                          get =
		                            call_reactive
		                             (cst_get$0,
		                              "Get the Integration App workspace configuration.",
		                              [0, workspace_id, 0],
		                              a,
		                              c);
		                         function v$1(ctrl, workspace_id, id, data_collection, cont){
		                          function a(crdt, cont){
		                           return caml_trampoline_cps_call3
		                                   (Enabled_data_collections[14],
		                                    id,
		                                    data_collection,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (enabled_data_collections,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (ignore_m,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (integration_app,
		                          a,
		                          function(op){
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply, ctrl[1], crdt, workspace_id, op, cont);
		                          });
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$5, b, a, cont);
		                                   });
		                         }
		                         var
		                          enable_data_collection =
		                            call_async
		                             ("enable_data_collection",
		                              "Enable a data collection in the workspace.",
		                              [0,
		                               workspace_id,
		                               [0,
		                                enabled_data_collection_id,
		                                [0, enabled_data_collection, 0]]],
		                              schematic_param_a_schema_versi,
		                              local_only(side, v$1));
		                         function v$2(ctrl, workspace_id, id, cont){
		                          function a(crdt, cont){
		                           return caml_trampoline_cps_call2
		                                   (Enabled_data_collections[18],
		                                    id,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (enabled_data_collections,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (ignore_m,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (integration_app,
		                          a,
		                          function(op){
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply, ctrl[1], crdt, workspace_id, op, cont);
		                          });
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$5, b, a, cont);
		                                   });
		                         }
		                         var
		                          disable_data_collection =
		                            call_async
		                             ("disable_data_collection",
		                              "Disable a data collection in the workspace.",
		                              [0, workspace_id, [0, enabled_data_collection_id, 0]],
		                              schematic_param_a_schema_versi,
		                              local_only(side, v$2));
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  cst_integration_app,
		                                  [0,
		                                   generate_access_token$0,
		                                   [0,
		                                    get,
		                                    [0, enable_data_collection, [0, disable_data_collection, 0]]]],
		                                  function(f){
		                                   var
		                                    integration_id = [0, cst_id, schema$43, 0],
		                                    a = local_only(side, generate_import_id),
		                                    a =
		                                      [0,
		                                       call
		("generate_import_id",
		 "Generate an integration import ID.",
		 0,
		 Id$0[5],
		 a),
		                                       0],
		                                    space =
		                                      [0,
		                                       call_async
		("exchange_token",
		 "Create Notion integration from retrieved token.",
		 [0, [0, cst_code, schematic_param_name_schema_ve, 0], 0],
		 access_token_response_schema,
		 local_only(side, exchange_token)),
		                                       a];
		                                   function v$1(ctrl, id, config, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (update$2,
		      ctrl,
		      crdt,
		      id,
		      config,
		      function(a){
		       return caml_trampoline_cps_call2(of_string$0, a, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$6, b, a, cont);
		     });
		                                   }
		                                   var
		                                    d = [0, f, b],
		                                    e = local_only(side, v$1),
		                                    c = [0, [0, cst_notion, space], 0];
		                                   return caml_exact_trampoline_cps_call
		   (schema$25,
		    schema$8,
		    function(schema){
		     function v$1(ctrl, id, cont){
		      function a(crdt, cont){
		       return caml_exact_trampoline_cps_call$0
		               (remove$1,
		                ctrl,
		                crdt,
		                id,
		                function(a){
		                 return caml_trampoline_cps_call2(of_string$0, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (writable,
		               ctrl[2],
		               function(b){
		                return caml_trampoline_cps_call3(let$6, b, a, cont);
		               });
		     }
		     var
		      a =
		        [0,
		         call_async
		          (cst_update,
		           "Update integration.",
		           [0, integration_id, [0, [0, cst_config, schema, 0], 0]],
		           schematic_param_a_schema_versi,
		           e),
		         c];
		     function v$2(ctrl, id, cont){
		      function a(crdt, cont){
		       return caml_exact_trampoline_cps_call$0
		               (refresh$2,
		                ctrl,
		                crdt,
		                id,
		                function(a){
		                 return caml_trampoline_cps_call2(of_string$0, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (writable,
		               ctrl[2],
		               function(b){
		                return caml_trampoline_cps_call3(let$6, b, a, cont);
		               });
		     }
		     var
		      a =
		        [0,
		         call_async
		          (cst_remove,
		           "Remove integration.",
		           [0, integration_id, 0],
		           schematic_param_a_schema_versi,
		           local_only(side, v$1)),
		         a],
		      b =
		        [0,
		         call_async
		          (cst_refresh,
		           "Refresh integration.",
		           [0, integration_id, 0],
		           schematic_param_a_schema_versi,
		           local_only(side, v$2)),
		         a],
		      f = local_only(side, list$0);
		     return caml_exact_trampoline_cps_call
		             (schema$25,
		              schema$8,
		              function(a){
		               return caml_exact_trampoline_cps_call
		                       (By_id[110],
		                        a,
		                        function(e){
		                         var
		                          a =
		                            [0,
		                             call_reactive(cst_list, "All integrations.", 0, e, f),
		                             b],
		                          c = local_only(side, get$5);
		                         function schematic_version(param, cont){return cont(0);}
		                         return caml_exact_trampoline_cps_call
		                                 (schema_versioned$6,
		                                  schematic_version,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call
		   (schema_versioned$8,
		    schematic_version,
		    function(e){
		     return caml_exact_trampoline_cps_call
		             (e,
		              b,
		              function(b){
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        b,
		                        function(f){
		                         function v$1(ctrl, config, cont){
		                          function a(crdt, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (add,
		                                    ctrl,
		                                    crdt,
		                                    config,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(of_string$0, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$6, b, a, cont);
		                                   });
		                         }
		                         var
		                          b =
		                            [0,
		                             call_reactive
		                              (cst_get$0, "An integration.", [0, integration_id, 0], f, c),
		                             a],
		                          e = local_only(side, v$1);
		                         return caml_exact_trampoline_cps_call
		                                 (schema$25,
		                                  schema$8,
		                                  function(schema){
		                                   return caml_exact_trampoline_cps_call$1
		   (namespace_ctrl,
		    cst_integration,
		    [0,
		     call_async
		      (cst_add,
		       "Add integration.",
		       [0, [0, cst_config, schema, 0], 0],
		       schema$43,
		       e),
		     b],
		    function(b){
		     var a = [0, b, d];
		     return caml_exact_trampoline_cps_call$1
		             (rpcs$2,
		              config,
		              side,
		              function(space){
		               return caml_exact_trampoline_cps_call$1
		                       (map_context,
		                        [0, cst_graph, space],
		                        function(param){var graph = param[2]; return graph;},
		                        function(d){
		                         var result_schema = config[4];
		                         function v$1(ctrl, id, cont){
		                          function a(existing, cont){
		                           if(! existing)
		                            return caml_trampoline_cps_call2(return$1, 0, cont);
		                           var server = existing[1];
		                           function a(status, cont){
		                            var a = ai_mcp_server(id, [2, connected(status)]);
		                            return caml_exact_trampoline_cps_call$0
		                                    (push_dont_wait,
		                                     ctrl[11],
		                                     0,
		                                     a,
		                                     function(match){
		                                      return caml_trampoline_cps_call2
		      (return$1, [0, status], cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$3
		                                   (probe_and_store,
		                                    0,
		                                    0,
		                                    0,
		                                    ctrl,
		                                    server,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$9, b, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (find,
		                                   ctrl,
		                                   id,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$7, b, a, cont);
		                                   });
		                         }
		                         var b = local_only(side, v$1), c = [0, d, a];
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  schema$37,
		                                  function(e){
		                                   var schema = Id[5];
		                                   function v$1(ctrl, id, cont){
		                                    function a(existing, cont){
		                                     if(! existing)
		                                      return caml_trampoline_cps_call2(return$1, bMg, cont);
		                                     var server = existing[1];
		                                     function open_url(url, cont){
		                                      return caml_exact_trampoline_cps_call
		      (of_string$1,
		       url,
		       function(uri){
		        return caml_exact_trampoline_cps_call$0
		                (trigger, ctrl[13][1], uri, 0, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$0
		     (authorize, ctrl, server, open_url, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (find,
		     ctrl,
		     id,
		     function(b){
		      return caml_trampoline_cps_call3(let$7, b, a, cont);
		     });
		                                   }
		                                   var
		                                    a =
		                                      [0,
		                                       call_async
		(cst_test,
		 "Re-probe an existing external MCP server's connection and refresh its cached tools.",
		 [0, [0, cst_id, schema, 0], 0],
		 e,
		 b),
		                                       0],
		                                    d = local_only(side, v$1);
		                                   return caml_exact_trampoline_cps_call
		   (option_schema,
		    schematic_param_name_schema_ve,
		    function(f){
		     var schema = Id[5];
		     function v$1(ctrl, id, cont){
		      function a(existing, cont){
		       if(! existing)
		        return caml_trampoline_cps_call2(return$1, bMh, cont);
		       var server = existing[1];
		       function a(discovered, cont){
		        if(0 === discovered[0])
		         var a = discovered;
		        else
		         var x = discovered[1], message = x[1], a = [1, message];
		        return caml_trampoline_cps_call2(return$1, a, cont);
		       }
		       return caml_exact_trampoline_cps_call
		               (discover_authorization_servers,
		                server,
		                function(b){
		                 return caml_trampoline_cps_call3(let$7, b, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$1
		              (find,
		               ctrl,
		               id,
		               function(b){
		                return caml_trampoline_cps_call3(let$7, b, a, cont);
		               });
		     }
		     var
		      b =
		        [0,
		         call_async
		          (cst_authorize,
		           "Authorize with an OAuth-protected external MCP server. Discovers its authorization server, asks the frontend to open the authorization page through the external URI hook, and receives the redirect on a loopback port. Answers with the reason authorization did not complete, or null when it did.",
		           [0, [0, cst_id, schema, 0], 0],
		           f,
		           d),
		         a],
		      e = local_only(side, v$1);
		     return caml_exact_trampoline_cps_call$1
		             (result_schema,
		              list_schema(schematic_param_name_schema_ve),
		              schematic_param_name_schema_ve,
		              function(a){
		               var schema = Id[5];
		               function v$1(ctrl, id, cont){
		                function a(a, cont){
		                 a = ai_mcp_server(id, 2);
		                 return caml_exact_trampoline_cps_call$0
		                         (push_dont_wait,
		                          ctrl[11],
		                          0,
		                          a,
		                          function(match){
		                           return caml_trampoline_cps_call2(return$1, 0, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (remove$0,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$9, b, a, cont);
		                         });
		               }
		               var
		                a =
		                  [0,
		                   call_async
		                    (cst_authorization_servers,
		                     "Discover the authorization servers advertised by an OAuth-protected external MCP server.",
		                     [0, [0, cst_id, schema, 0], 0],
		                     a,
		                     e),
		                   b],
		                d = local_only(side, v$1),
		                schema$1 = Id[5];
		               function v$2(ctrl, id, enabled, cont){
		                function a(existing, cont){
		                 if(! existing)
		                  return caml_trampoline_cps_call2(return$1, 0, cont);
		                 var server = existing[1];
		                 function a(a, cont){
		                  a = enabled ? 0 : 1;
		                  a = ai_mcp_server(id, a);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait,
		                           ctrl[11],
		                           0,
		                           a,
		                           function(match){
		                            return caml_trampoline_cps_call2(return$1, 0, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (upsert,
		                          ctrl,
		                          [0,
		                           server[1],
		                           server[2],
		                           server[3],
		                           server[4],
		                           enabled,
		                           server[6],
		                           server[7]],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$9, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$7, b, a, cont);
		                         });
		               }
		               var
		                a =
		                  [0,
		                   call_async
		                    (cst_remove,
		                     "Remove an external MCP server.",
		                     [0, [0, cst_id, schema$1, 0], 0],
		                     schematic_param_a_schema_versi,
		                     d),
		                   a],
		                d = local_only(side, v$2),
		                schema$2 = Id[5];
		               function v$3(ctrl, id, name, transport, auth, trust, cont){
		                function a(existing, cont){
		                 if(! existing)
		                  return caml_trampoline_cps_call2(return$1, 0, cont);
		                 var
		                  existing$0 = existing[1],
		                  server =
		                    [0, id, name, transport, auth, existing$0[5], trust, 0];
		                 function a(status, cont){
		                  var a = ai_mcp_server(id, [1, connected(status)]);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait,
		                           ctrl[11],
		                           0,
		                           a,
		                           function(match){
		                            return caml_trampoline_cps_call2
		                                    (return$1, [0, status], cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$3
		                         (probe_and_store,
		                          0,
		                          0,
		                          0,
		                          ctrl,
		                          server,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$9, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$7, b, a, cont);
		                         });
		               }
		               var
		                f =
		                  [0,
		                   call_async
		                    (cst_set_enabled,
		                     "Enable or disable an external MCP server without re-probing it.",
		                     [0,
		                      [0, cst_id, schema$2, 0],
		                      [0, [0, cst_enabled, bool_schema, 0], 0]],
		                     schematic_param_a_schema_versi,
		                     d),
		                   a],
		                g = local_only(side, v$3);
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        schema$37,
		                        function(a){
		                         var schema = Id[5];
		                         function v$1(ctrl, name, transport, auth, trust, cont){
		                          var
		                           server =
		                             [0, Id[29].call(null), name, transport, auth, 1, trust, 0];
		                          function a(status, cont){
		                           var
		                            a = connected(status),
		                            b = 0 === transport[0] ? cst_http : cst_stdio,
		                            a = ai_mcp_server(server[1], [0, b, a]);
		                           return caml_exact_trampoline_cps_call$0
		                                   (push_dont_wait,
		                                    ctrl[11],
		                                    0,
		                                    a,
		                                    function(match){
		                                     return caml_trampoline_cps_call2(return$1, status, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$3
		                                  (probe_and_store,
		                                   0,
		                                   0,
		                                   0,
		                                   ctrl,
		                                   server,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$9, b, a, cont);
		                                   });
		                         }
		                         var
		                          a =
		                            [0,
		                             call_async
		                              (cst_update,
		                               "Update an existing external MCP server's configuration and re-probe its tools. Its enabled state is preserved.",
		                               [0,
		                                [0, cst_id, schema, 0],
		                                [0,
		                                 [0, cst_name, schematic_param_name_schema_ve, 0],
		                                 [0,
		                                  [0, cst_transport, schema$33, 0],
		                                  [0,
		                                   [0, cst_auth, schema$34, 0],
		                                   [0, [0, cst_trust, schema$35, 0], 0]]]]],
		                               a,
		                               g),
		                             f];
		                         function v$2(ctrl, cont){
		                          function a(servers, cont){return cont([0, servers]);}
		                          return caml_exact_trampoline_cps_call
		                                  (list,
		                                   ctrl,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$8, b, a, cont);
		                                   });
		                         }
		                         var
		                          a =
		                            [0,
		                             call_async
		                              (cst_add,
		                               "Add an external MCP server, probe it for its tools, and store it enabled.",
		                               [0,
		                                [0, cst_name, schematic_param_name_schema_ve, 0],
		                                [0,
		                                 [0, cst_transport, schema$33, 0],
		                                 [0,
		                                  [0, cst_auth, schema$34, 0],
		                                  [0, [0, cst_trust, schema$35, 0], 0]]]],
		                               schema$37,
		                               local_only(side, v$1)),
		                             a],
		                          b = local_only(side, v$2);
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  cst_external_mcp,
		                                  [0,
		                                   call_async
		                                    (cst_list,
		                                     "List all configured external MCP servers.",
		                                     0,
		                                     list_schema(schema$36),
		                                     b),
		                                   a],
		                                  function(b){
		                                   var a = [0, b, c];
		                                   return caml_exact_trampoline_cps_call$1
		   (rpcs$3,
		    config,
		    side,
		    function(b){
		     return caml_exact_trampoline_cps_call$1
		             (namespace_ctrl,
		              cst_event,
		              b,
		              function(e){
		               function v$1(ctrl, cont){
		                return cont(include[29].call(null));
		               }
		               var b = local_only(side, v$1);
		               function schematic_version(param, cont){return cont(0);}
		               var
		                c =
		                  [0,
		                   call
		                    ("generate_block_id",
		                     "Generate a block ID",
		                     0,
		                     include[5],
		                     b),
		                   0],
		                d = [0, e, a];
		               return caml_exact_trampoline_cps_call
		                       (schema_versioned$5,
		                        schematic_version,
		                        function(a){
		                         var blocks_schema = [0, 0, 0, [3, a], 0];
		                         function v$1(ctrl, blocks, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (remove_metadata, blocks, cont);
		                         }
		                         function v$2(param, base, remote, local, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (merge, base, remote, local, cont);
		                         }
		                         var
		                          a =
		                            [0,
		                             call
		                              ("remove_metadata",
		                               "Remove metadata from blocks to eg. duplicate them.",
		                               [0, [0, cst_blocks, blocks_schema, 0], 0],
		                               blocks_schema,
		                               local_only(side, v$1)),
		                             c];
		                         function v$3(ctrl, document, block, cont){
		                          function a(crdt, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (append,
		                                    ctrl,
		                                    crdt,
		                                    document,
		                                    block,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(of_string$0, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   ctrl[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$10, b, a, cont);
		                                   });
		                         }
		                         var
		                          b =
		                            [0,
		                             call
		                              ("merge",
		                               "Three-way merge a document",
		                               [0,
		                                [0, cst_base, schema$30, 0],
		                                [0,
		                                 [0, cst_remote, schema$30, 0],
		                                 [0, [0, cst_local, schema$30, 0], 0]]],
		                               schema$30,
		                               local_only(side, v$2)),
		                             a],
		                          e = local_only(side, v$3);
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  schema$9,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$1
		   (namespace_ctrl,
		    cst_document,
		    [0,
		     call_async
		      (cst_append,
		       "Append a block to object notes.",
		       [0,
		        [0, cst_document, document_schema, 0],
		        [0, [0, cst_block, schema$7, 0], 0]],
		       a,
		       e),
		     b],
		    function(c){
		     function v$1(ctrl, cont){
		      return caml_exact_trampoline_cps_call
		              (device, ctrl[1], function(a){return cont(to_option(a));});
		     }
		     var a = local_only(side, v$1), b = [0, c, d];
		     return caml_exact_trampoline_cps_call
		             (option_schema,
		              Device[5],
		              function(c){
		               c =
		                [0,
		                 call
		                  (cst_self,
		                   "The id of the device the user is currently logged on.",
		                   0,
		                   c,
		                   a),
		                 0];
		               var
		                f = local_only(side, patch$0),
		                schema = Patch[3],
		                schema$1 = Device[5],
		                d =
		                  [0,
		                   call
		                    (cst_patch,
		                     "Modify a device.",
		                     [0,
		                      [0, cst_id, schema$1, 0],
		                      [0, [0, cst_patch, schema, 0], 0]],
		                     schematic_param_a_schema_versi,
		                     f),
		                   c],
		                e = local_only(side, get$6);
		               return caml_exact_trampoline_cps_call
		                       (ById[110],
		                        schema$24,
		                        function(a){
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  a,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$1
		   (namespace_ctrl,
		    cst_device,
		    [0,
		     call_reactive
		      (cst_get$0, "The user's list of devices.", 0, a, e),
		     d],
		    function(d){
		     function v$1(ctrl, title, action, cont){
		      function a(operation, cont){
		       if(0 === operation[0]){
		        var
		         operation$0 = operation[1],
		         a =
		           function(crdt, cont){
		            return caml_exact_trampoline_cps_call$0
		                    (apply_personal,
		                     ctrl[1],
		                     crdt,
		                     operation$0,
		                     function(a){
		                      return caml_trampoline_cps_call2
		                              (return$,
		                               a,
		                               function(a){
		                                return caml_trampoline_cps_call2(of_string$0, a, cont);
		                               });
		                     });
		           };
		        return caml_exact_trampoline_cps_call
		                (writable,
		                 ctrl[2],
		                 function(b){
		                  return caml_trampoline_cps_call3(let$12, b, a, cont);
		                 });
		       }
		       var match = operation[1], variant = match[1];
		       if(144245463 !== variant)
		        return caml_trampoline_cps_call2(return$0, operation, cont);
		       var reason = match[2];
		       return caml_exact_trampoline_cps_call
		               (notify_f(ctrl)(0),
		                bMD,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          reason,
		                          function(match){
		                           return caml_trampoline_cps_call2(return$1, 0, cont);
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (perform_action(ctrl[2], title),
		               action,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (return$0,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$11, b, a, cont);
		                         });
		               });
		     }
		     var a = local_only(side, v$1), c = [0, d, b];
		     return caml_exact_trampoline_cps_call
		             (schema_versioned$4,
		              dummy,
		              function(b){
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        b,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  cst_console,
		                                  [0,
		                                   call_async
		                                    ("perform_action",
		                                     "Perform a console action.",
		                                     [0,
		                                      [0, cst_title, schematic_param_name_schema_ve, 0],
		                                      [0, [0, cst_action, controller_supported_actions_s, 0], 0]],
		                                     b,
		                                     a),
		                                   0],
		                                  function(f){
		                                   var
		                                    workspace_id = [0, cst_workspace_id, schema$5, 0],
		                                    key = [0, cst_key, schematic_param_name_schema_ve, 0];
		                                   function apply$0(ctrl, workspace_id, operation, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call
		     (v$0,
		      [3, operation],
		      function(a){
		       return caml_exact_trampoline_cps_call$2
		               (apply, ctrl[1], crdt, workspace_id, a, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$13, b, a, cont);
		     });
		                                   }
		                                   function v$1(ctrl, workspace_id, key, cont){
		                                    return caml_trampoline_cps_call2
		    (remove,
		     key,
		     function(a){
		      return caml_exact_trampoline_cps_call$0
		              (apply$0, ctrl, workspace_id, a, cont);
		     });
		                                   }
		                                   function v$2(ctrl, workspace_id, key, value, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (set,
		     key,
		     value,
		     function(a){
		      return caml_exact_trampoline_cps_call$0
		              (apply$0, ctrl, workspace_id, a, cont);
		     });
		                                   }
		                                   var
		                                    a =
		                                      [0,
		                                       call_async
		("unset",
		 "Remove the client data value at [key] in a workspace.",
		 [0, workspace_id, [0, key, 0]],
		 schematic_param_a_schema_versi,
		 local_only(side, v$1)),
		                                       0],
		                                    b =
		                                      [0,
		                                       call_async
		(cst_set,
		 "Set the client data value at [key] in a workspace.",
		 [0,
		  workspace_id,
		  [0, key, [0, [0, cst_value, no_input_schema, 0], 0]]],
		 schematic_param_a_schema_versi,
		 local_only(side, v$2)),
		                                       a],
		                                    d = [0, f, c],
		                                    e = local_only(side, client_data);
		                                   return caml_exact_trampoline_cps_call
		   (option_schema,
		    no_input_schema,
		    function(a){
		     a =
		      [0,
		       call_reactive
		        (cst_get$0,
		         "The client data value at [key] in a workspace.",
		         [0, workspace_id, [0, key, 0]],
		         a,
		         e),
		       b];
		     return caml_exact_trampoline_cps_call$1
		             (namespace_ctrl,
		              cst_client_data,
		              [0,
		               call_reactive
		                (cst_all,
		                 "All client data of a workspace.",
		                 [0, workspace_id, 0],
		                 view_schema,
		                 local_only(side, client_data_all)),
		               a],
		              function(e){
		               var
		                a = local_only(side, all$1),
		                all$0 =
		                  call_reactive
		                   (cst_all, "All calendars.", 0, list_schema(schema$14), a),
		                b = [0, e, d],
		                c = local_only(side, default$0);
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        schema$14,
		                        function(d){
		                         var
		                          default$0 =
		                            call_reactive("default_cal", "Default calendar.", 0, d, c),
		                          a = local_only(side, get$0);
		                         return caml_exact_trampoline_cps_call
		                                 (option_schema,
		                                  schema$14,
		                                  function(c){
		                                   var
		                                    get =
		                                      call_reactive
		                                       (cst_get$0,
		"A calendar.",
		[0, [0, cst_id, schema$0, 0], 0],
		c,
		a);
		                                   function v$0(ctrl, account, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (refresh$0,
		      ctrl,
		      crdt,
		      account,
		      function(a){
		       return caml_exact_trampoline_cps_call(of_string, a, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$15, b, a, cont);
		     });
		                                   }
		                                   var
		                                    refresh$1 =
		                                      call_async
		                                       (cst_refresh,
		"Manually refresh calendars for an account.",
		[0, [0, cst_account, schema$3, 0], 0],
		schematic_param_a_schema_versi,
		local_only(side, v$0));
		                                   function v$1(ctrl, id, patch, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (select, ctrl, crdt, id, patch, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$14, b, a, cont);
		     });
		                                   }
		                                   var
		                                    select$0 =
		                                      call_async
		                                       (cst_select,
		"Change calendar configuration.",
		[0,
		 [0, cst_id, schema$0, 0],
		 [0, [0, cst_patch, schema$16, 0], 0]],
		schematic_param_a_schema_versi,
		local_only(side, v$1));
		                                   function v$2(ctrl, id, cont){
		                                    function a(crdt, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (set_default, ctrl, crdt, id, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     ctrl[2],
		     function(b){
		      return caml_trampoline_cps_call3(let$15, b, a, cont);
		     });
		                                   }
		                                   var
		                                    select_default =
		                                      call_async
		                                       ("select_default",
		"Select default calendar.",
		[0, [0, cst_id, schema$0, 0], 0],
		schematic_param_a_schema_versi,
		local_only(side, v$2));
		                                   return caml_exact_trampoline_cps_call$1
		   (namespace_ctrl,
		    cst_calendar,
		    [0,
		     all$0,
		     [0,
		      default$0,
		      [0,
		       get,
		       [0, refresh$1, [0, select$0, [0, select_default, 0]]]]]],
		    function(d){
		     var a = local_only(side, add_account), c = [0, d, b];
		     return caml_exact_trampoline_cps_call
		             (option_schema,
		              schema$41,
		              function(schema){
		               var
		                attach_account =
		                  call_async
		                   ("attach_account",
		                    "Add a new Google account.",
		                    [0, [0, cst_redirect_uri, schema, default$4], 0],
		                    schema$41,
		                    a),
		                claim_account$0 =
		                  call_async
		                   ("claim_account",
		                    "Claim a Google account.",
		                    [0, [0, cst_token, schematic_param_name_schema_ve, 0], 0],
		                    schematic_param_a_schema_versi,
		                    local_only(side, claim_account)),
		                delete_account$0 =
		                  call_async
		                   ("delete_account",
		                    "Delete Routine account.",
		                    0,
		                    schematic_param_a_schema_versi,
		                    local_only(side, delete_account));
		               function v$0(ctrl, login, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (handle_login_intent, ctrl, login, cont);
		               }
		               var b = local_only(side, v$0);
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (login_schema_versioned,
		                        schematic_version,
		                        function(schema){
		                         var
		                          handle_login_intent =
		                            call_async
		                             ("handle_login_intent",
		                              "Handle the intent of a login callback after the controller has already started.",
		                              [0, [0, cst_login, schema, 0], 0],
		                              schematic_param_a_schema_versi,
		                              b),
		                          a = local_only(side, feature_has$0);
		                         function schematic_version(param){return 0;}
		                         return caml_exact_trampoline_cps_call
		                                 (profile_feature_schema_version,
		                                  schematic_version,
		                                  function(schema){
		                                   var
		                                    cst_feature = "feature",
		                                    has_feature =
		                                      call_reactive
		                                       ("has_feature",
		"Whether any profile has a feature.",
		[0, [0, cst_feature, schema, 0], 0],
		bool_schema,
		a),
		                                    id =
		                                      call
		                                       (cst_id,
		"The user unique id.",
		0,
		schema$4,
		local_only(side, user_id$0)),
		                                    logout$0 =
		                                      call_async
		                                       ("logout",
		"Logout from current account.",
		0,
		schematic_param_a_schema_versi,
		local_only(side, logout)),
		                                    profile =
		                                      call_reactive
		                                       (cst_profile,
		"Main user identity.",
		0,
		profile_schema,
		local_only(side, main)),
		                                    b = local_only(side, feature_has);
		                                   function schematic_version(param){return 0;}
		                                   return caml_exact_trampoline_cps_call
		   (profile_feature_schema_version,
		    schematic_version,
		    function(schema){
		     var
		      profile_has_feature =
		        call_reactive
		         ("profile_has_feature",
		          "Whether a profile has a feature.",
		          [0,
		           [0, cst_profile, schema$13, 0],
		           [0, [0, cst_feature, schema, 0], 0]],
		          bool_schema,
		          b);
		     function v$0(ctrl, profile, feature, enabled, cont){
		      function a(crdt, cont){
		       var connection = of_google_email(profile);
		       return caml_exact_trampoline_cps_call
		               (state_writable_personal,
		                crdt,
		                function(state){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id,
		                          state[3],
		                          connection,
		                          function(a){
		                           if(! a)
		                            return caml_exact_trampoline_cps_call
		                                    (fail_result,
		                                     a9t,
		                                     function(a){
		                                      return caml_trampoline_cps_call3(a, pp, profile, cont);
		                                     });
		                           a = a[1];
		                           if(0 === a[0])
		                            return caml_exact_trampoline_cps_call
		                                    (fail_result,
		                                     a9r,
		                                     function(a){
		                                      return caml_trampoline_cps_call3(a, pp, profile, cont);
		                                     });
		                           var google$0 = a[1];
		                           function b(currently_enabled, op){
		                            return enabled === currently_enabled
		                                    ? cont(a9s)
		                                    : caml_exact_trampoline_cps_call
		                                      (google,
		                                       op,
		                                       function(a){
		return caml_trampoline_cps_call2
		        (element,
		         connection,
		         function(b){
		          return caml_trampoline_cps_call2
		                  (b,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (connections,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$0
		                                      (apply_personal,
		                                       ctrl[1],
		                                       crdt,
		                                       a,
		                                       function(a){
		return caml_trampoline_cps_call2(of_string$0, a, cont);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                           }
		                           if(! feature)
		                            return caml_exact_trampoline_cps_call
		                                    (calendars_state,
		                                     some_if(enabled, 0),
		                                     function(op){
		                                      var currently_enabled = is_some(google$0[1]);
		                                      return b(currently_enabled, op);
		                                     });
		                           var value = some_if(enabled, 0);
		                           return caml_exact_trampoline_cps_call
		                                   (Synchronization_state[13],
		                                    value,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (v,
		      [1, a],
		      function(op){return b(is_some(google$0[2]), op);});
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (writable,
		               ctrl[2],
		               function(b){
		                return caml_trampoline_cps_call3(let$16, b, a, cont);
		               });
		     }
		     var
		      a = [0, [0, cst_enabled, bool_schema, 0], 0],
		      d = local_only(side, v$0);
		     function schematic_version(param){return 0;}
		     return caml_exact_trampoline_cps_call
		             (profile_feature_schema_version,
		              schematic_version,
		              function(schema){
		               var b = [0, [0, cst_feature, schema, 0], a];
		               function schematic_version(param, cont){return cont(0);}
		               return caml_exact_trampoline_cps_call
		                       (schema_versioned$1,
		                        schematic_version,
		                        function(schema){
		                         var
		                          profile_set_feature =
		                            call_async
		                             ("profile_set_feature",
		                              "Toggle a profile feature. Only available for profile that can potentially enable features, iow. only Google for now.",
		                              [0, [0, cst_profile, schema, 0], b],
		                              schematic_param_a_schema_versi,
		                              d);
		                         function f(map, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   map,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (stable_sort,
		     a,
		     function(left, right, cont){
		      return left[2]
		              ? cont(-1)
		              : right
		                 [2]
		                ? cont(1)
		                : caml_trampoline_cps_call3
		                  (compare, left[1], right[1], cont);
		     },
		     cont);
		                                   });
		                         }
		                         function v(ctrl, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (all, ctrl, function(a){return cont(map$0(a, f));});
		                         }
		                         function schematic_version(param, cont){return cont(0);}
		                         var a = local_only(side, v);
		                         return caml_exact_trampoline_cps_call
		                                 (profile_schema_versioned,
		                                  schematic_version,
		                                  function(d){
		                                   var
		                                    profiles =
		                                      call_reactive
		                                       ("profiles", "User identities.", 0, [0, 0, 0, [3, d], 0], a),
		                                    b = local_only(side, request_scopes);
		                                   function schematic_version(param, cont){return cont(0);}
		                                   return caml_exact_trampoline_cps_call
		   (missing_scope_info_schema_vers,
		    schematic_version,
		    function(a){
		     return caml_exact_trampoline_cps_call
		             (option_schema,
		              a,
		              function(a){
		               return caml_exact_trampoline_cps_call
		                       (option_schema,
		                        schema$41,
		                        function(schema){
		                         var
		                          request_scopes =
		                            call_async
		                             ("request_scopes",
		                              "Request additional Google scopes.",
		                              [0,
		                               [0, cst_account, schema$3, 0],
		                               [0,
		                                [0, cst_scopes, schema$38, 0],
		                                [0, [0, cst_redirect_uri, schema, default$5], 0]]],
		                              a,
		                              b),
		                          refresh$0 =
		                            call_async
		                             (cst_refresh,
		                              "Reload the available Google ressource, eg. in case of scope grant.",
		                              0,
		                              schematic_param_a_schema_versi,
		                              local_only(side, refresh)),
		                          uid =
		                            call
		                             (cst_uid,
		                              "User unique id.",
		                              0,
		                              schema$4,
		                              local_only(side, user_id$0)),
		                          unlink_account$0 =
		                            call_async
		                             ("unlink_account",
		                              "Unlink a Google account.",
		                              [0, [0, cst_identity, schema$3, 0], 0],
		                              schematic_param_a_schema_versi,
		                              local_only(side, unlink_account));
		                         function v(ctrl, f, cont){
		                          var V = ctrl[1];
		                          return caml_trampoline_cps_call2
		                                  (V[1][7],
		                                   V[2],
		                                   function(auth_handlers){
		                                    return caml_exact_trampoline_cps_call$1
		    (set_f,
		     auth_handlers,
		     f,
		     function(match){
		      return cont
		              (function(param, cont){
		                auth_handlers[1] = default$;
		                return cont(0);
		               });
		     });
		                                   });
		                         }
		                         var
		                          register_handler =
		                            call_hook
		                             ("register_handler",
		                              "Register the handler for the authentication effects",
		                              0,
		                              effect_schema,
		                              local_only(side, v));
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  cst_auth,
		                                  [0,
		                                   attach_account,
		                                   [0,
		                                    claim_account$0,
		                                    [0,
		                                     delete_account$0,
		                                     [0,
		                                      has_feature,
		                                      [0,
		                                       handle_login_intent,
		                                       [0,
		id,
		[0,
		 logout$0,
		 [0,
		  profile,
		  [0,
		   profiles,
		   [0,
		    profile_has_feature,
		    [0,
		     profile_set_feature,
		     [0,
		      refresh$0,
		      [0,
		       request_scopes,
		       [0, uid, [0, unlink_account$0, [0, register_handler, 0]]]]]]]]]]]]]]]],
		                                  function(b){
		                                   var a = [0, b, c];
		                                   return caml_exact_trampoline_cps_call$1
		   (rpcs$1,
		    config,
		    side,
		    function(space){
		     return caml_exact_trampoline_cps_call$1
		             (map_context,
		              [0, cst_ai, space],
		              function(param){var graph = param[2]; return graph;},
		              function(d){
		               function schematic_version(param, cont){return cont(0);}
		               var b = local_only(side, accounts), c = [0, d, a];
		               return caml_exact_trampoline_cps_call
		                       (schema_versioned$2,
		                        schematic_version,
		                        function(a){
		                         var
		                          accounts =
		                            call_async
		                             (cst_accounts,
		                              "Accounts whose email ressemble the given fragment.",
		                              [0, [0, cst_email, schematic_param_name_schema_ve, 0], 0],
		                              [0, 0, 0, [3, a], 0],
		                              b),
		                          impersonate$0 =
		                            call_async
		                             ("impersonate",
		                              "A bearer token for this account.",
		                              [0, [0, cst_account, schematic_param_name_schema_ve, 0], 0],
		                              impersonation_schema,
		                              local_only(side, impersonate));
		                         return caml_exact_trampoline_cps_call$1
		                                 (namespace_ctrl,
		                                  "admin",
		                                  [0, accounts, [0, impersonate$0, 0]],
		                                  function(a){return cont([0, a, c]);});
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });
		              });
		    });
		                                  });
		                        });};
		             }
		             var n =
		                "\xff\xff\xff\xff\xfb\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",
		              cst$61 = "\n\n",
		              f = "\n```",
		              cst$31 = "\r\n",
		              cst$62 = "\r\n--",
		              cst$10 = "  ",
		              cst$35 = " (",
		              cst_pos = " (pos ",
		              cst$55 = " - ",
		              cst$24 = " /",
		              cst$40 = " / ",
		              cst$56 = " < ",
		              cst$23 = " <> ",
		              cst$44 = " =",
		              cst$38 = " = ",
		              cst$22 = " > ",
		              cst_MCP_server = " MCP server.",
		              cst_answer_lists_one_per_quest =
		                " answer lists (one per question), got ",
		              cst_archived$0 = " archived",
		              cst_as_a_date = " as a date: ",
		              cst_as_a_week = " as a week: ",
		              cst_at$0 = " at ",
		              cst_calling = " calling ",
		              cst_completed$0 = " completed",
		              cst_created_and_postponed_to = " created and postponed to ",
		              cst_created_and_scheduled_for = " created and scheduled for ",
		              cst_days = " days",
		              cst_deleted$0 = " deleted",
		              cst_does_not_exist_or_was_dele =
		                " does not exist or was deleted.",
		              cst_edited = " edited",
		              cst_edited_to_recur = " edited to recur ",
		              cst_error_on_channel = " error on channel ",
		              cst_for$0 = " for ",
		              cst_found_in_multiple_organiza =
		                " found in multiple organizations ",
		              cst_from_new_block_not_found_r =
		                " from new block not found, recreating it",
		              cst_id$0 = " id: ",
		              cst_ignored$0 = " ignored",
		              cst_in$0 = " in ",
		              cst_in_core_int_ml_divisor_sho =
		                " in core_int.ml: divisor should be positive",
		              cst_in_core_int_ml_modulus_sho =
		                " in core_int.ml: modulus should be positive",
		              cst_instead_of = " instead of ",
		              cst_into = " into ",
		              cst_is_now_enabled_Use_tool_se =
		                " is now enabled. Use tool search to discover and call its tools.",
		              cst_is_out_of_range = " is out of range",
		              cst_months_on_the = " months on the ",
		              cst_moved_to = " moved to ",
		              cst_must_be_an_array_of_string = " must be an array of strings",
		              cst_not_found = " not found",
		              cst_not_found_ignoring = " not found, ignoring ",
		              cst_of$0 = " of ",
		              cst_on_channel = " on channel ",
		              cst_on_the = " on the ",
		              cst_out_of_range_0 = " out of range [0, ",
		              cst_postponed_to = " postponed to ",
		              cst_querying = " querying ",
		              cst_restored = " restored",
		              cst_saved = " saved",
		              cst_scheduled_for = " scheduled for ",
		              cst_to = " to ",
		              cst_unarchived = " unarchived",
		              cst_unignored = " unignored",
		              cst_unpostponed = " unpostponed ",
		              cst_unscheduled = " unscheduled ",
		              cst_will_recur = " will recur ",
		              cst$30 = " }",
		              cst_ascending_or_descending = '"ascending" or "descending".',
		              cst_s_d$0 = "#%s.%d",
		              cst_04i = "%04i",
		              cst_04i$0 = "%04i ",
		              cst_F = "%F",
		              cst_LdL = "%LdL",
		              cst_S_must_be_an_array_of_stri =
		                "%S must be an array of strings",
		              cst_a_a_04i = "%a %a %04i",
		              cst_a_i_i = "%a %i - %i",
		              cst_a_at_a = "%a at %a",
		              cst_a_a = "%a%a",
		              cst_a_amap = "%a%amap",
		              cst_d_s = "%d%s",
		              cst_d_03ds = "%d.%03ds",
		              cst_dd = "%dd",
		              cst_dh = "%dh",
		              cst_dmin = "%dmin",
		              cst_ds = "%ds",
		              cst_dth = "%dth",
		              cst_dy = "%dy",
		              cst_s$5 = "%s ",
		              cst_s_s_in_core_int_ml_modulus =
		                "%s %% %s in core_int.ml: modulus should be positive",
		              cst_s_s$0 = "%s %s",
		              cst_s_s_in_core_int_ml_divisor =
		                "%s /%% %s in core_int.ml: divisor should be positive",
		              cst_s_templatable = "%s-templatable",
		              cst_s_s$1 = "%s: %s",
		              cst_s_d = "%s:%d",
		              cst_s_s = "%s@%s",
		              cst_s$4 = "'%s",
		              cst$28 = "']')",
		              cst_s_recurrence_was_stopped = "'s recurrence was stopped",
		              cst$26 = "'}')",
		              cst$27 = "(','",
		              cst$47 = "(@[",
		              cst_2_Ast_Unlocated_Float = "(@[<2>Ast.Unlocated.Float@ ",
		              cst_2_Ast_Unlocated_Int = "(@[<2>Ast.Unlocated.Int@ ",
		              cst_2_Ast_Unlocated_List = "(@[<2>Ast.Unlocated.List@ ",
		              cst_2_Ast_Unlocated_String = "(@[<2>Ast.Unlocated.String@ ",
		              cst$54 = ") ->",
		              cst_is_out_of_range_or_NaN = ") is out of range or NaN",
		              cst_is_too_large = ") is too large",
		              cst_is_too_small_or_NaN = ") is too small or NaN",
		              cst$52 = "*",
		              cst$58 = "**",
		              cst$32 = "+",
		              cst$25 = ",",
		              cst_got = ", got ",
		              cst_not$0 = ", not ",
		              cst$48 = ",@ ",
		              cst$33 = "-",
		              cst_content$0 = "-content",
		              cst_id$1 = "-id",
		              cst_templatable$0 = "-templatable",
		              cst_0_Ld = ".%0*Ld",
		              cst_role$0 = ".role",
		              cst$34 = "/",
		              cst_agents$0 = "/agents/",
		              cst_agents_a = "/agents/%a",
		              cst_automations$0 = "/automations/",
		              cst_events$0 = "/events/",
		              cst_events_a = "/events/%a",
		              cst_settings_organizations = "/settings/organizations/",
		              cst_settings_organizations_a_a =
		                "/settings/organizations/%a/automations/%a",
		              cst_0_google_contacts_other_en =
		                "0-google-contacts-other-enabled",
		              cst_1 = "1",
		              cst_1_month = "1 month",
		              cst_1_week = "1 week",
		              cst_1_year = "1 year",
		              cst_2$2 = "2",
		              cst_2_weeks = "2 weeks",
		              cst_2_0 = "2.0",
		              cst_3 = "3",
		              cst_4 = "4",
		              cst_5 = "5",
		              cst_6 = "6",
		              cst_7 = "7",
		              cst_8 = "8",
		              cst_9 = "9",
		              cst$21 = ":",
		              cst_invalid_argument = ": invalid argument ",
		              cst_a$1 = ":a",
		              cst_b$0 = ":b",
		              cst_f = ":f",
		              cst_null$0 = ":null",
		              cst_o = ":o",
		              cst_s$3 = ":s",
		              cst$45 = ";@ ",
		              cst_s$1 = "<%s>",
		              cst_span$0 = "<\/span>",
		              cst_0$0 = "<0>",
		              cst_2 = "<2>",
		              cst_b_0 = "<b 0>",
		              cst_h = "<h>",
		              cst_hov = "<hov>",
		              cst_hv_2 = "<hv 2>",
		              cst_organizationId = "?organizationId=",
		              cst$46 = "@ }@]",
		              cst$49 = "@,]@]",
		              cst_s$2 = "@[%s =@ ",
		              cst_2_s_a = "@[<2>%s:@ %a@]",
		              cst_2_a_a = "@[<2>(@[%a@]) ->@ @[%a@]@]",
		              cst_2$1 = "@[<2>[",
		              cst_2$0 = "@[<2>{ ",
		              cst$39 = "@])",
		              cst$63 = "@]@?",
		              cst$50 = "@]}",
		              cst_A_calendar_event_e_g_a_mee =
		                "A calendar event (e.g. a meeting or appointment), as a\n          'event:<nanoid>' id.",
		              cst_A_calendar_event = "A calendar event.",
		              cst_A_page_document_or_note = "A page (document or note).",
		              cst_A_person_in_the_contacts_d =
		                "A person in the contacts database, as a 'people:<nanoid>' id.",
		              cst_A_relation_to_another_tabl =
		                "A relation to another table or entity. For relations to built-in\n          default types, use the named `relation_schema_target` variant.",
		              cst_A_task_as_a_task_nanoid_id =
		                "A task, as a 'task:<nanoid>' id.",
		              cst_A_task = "A task.",
		              cst_A_workspace_member_a_user_ =
		                "A workspace member (a user account in the current workspace), as an\n          'account:<nanoid>' id.",
		              cst_AI_state_not_found = "AI state not found",
		              cst_API_refused_conflicting_co =
		                "API refused conflicting commit",
		              cst_Admin_ID_to_assign_this_po =
		                "Admin ID to assign this post to.",
		              cst_Agent_not_found = "Agent not found",
		              cst_Agent_not_found$0 = "Agent not found: ",
		              cst_Agent_not_found_a = "Agent not found: %a",
		              cst_An_ISO_8601_date_string_e_ =
		                'An ISO 8601 date string, e.g. "2024-06-25".',
		              cst_An_optional_name_for_the_p =
		                "An optional name for the participant. Provides the model\n                  information to differentiate between participants of the same\n                  role.",
		              cst_Apollo_account_ID_to_link_ =
		                "Apollo account ID to link this contact to.",
		              cst_April = "April",
		              cst_Ast_Unlocated_Float = "Ast.Unlocated.Float",
		              cst_Ast_Unlocated_Int = "Ast.Unlocated.Int",
		              cst_Ast_Unlocated_List = "Ast.Unlocated.List",
		              cst_Ast_Unlocated_String = "Ast.Unlocated.String",
		              cst_August = "August",
		              cst_Automation_not_found = "Automation not found",
		              cst_Automation_run_is_not_wait =
		                "Automation run is not waiting for input",
		              cst_Automation_run_not_found = "Automation run not found",
		              cst_Block_absent_in_previous_p =
		                "Block absent in previous, present in current",
		              cst_Block_present_in_previous_ =
		                "Block present in previous, absent in current",
		              cst_Blockquote = "Blockquote",
		              cst_Bullet = "Bullet",
		              cst_Calendar_is_readonly = "Calendar is readonly",
		              cst_Callout = "Callout",
		              cst_Cannot_remove_the_last_ste =
		                "Cannot remove the last step from an automation",
		              cst_Cell = "Cell",
		              cst_Cell_value_simplified_to_s =
		                "Cell value simplified to simplify the agent's life for now",
		              cst_Changed = "Changed",
		              cst_Channel_where_the_message_ =
		                "Channel where the message was posted.",
		              cst_Check = "Check",
		              cst_Checkbox = "Checkbox",
		              cst_Code = "Code",
		              cst_Column_to_map_the_task_sch =
		                "Column to map the task scheduling to.",
		              cst_Column_to_map_the_task_url =
		                "Column to map the task url to.",
		              cst_Comma_separated_expand_opt =
		                'Comma-separated expand options: "description", "issueTypes", "lead",\n            "projectKeys", "issueTypeHierarchy".',
		              cst_Comma_separated_label_name$0 =
		                "Comma-separated label names to apply.",
		              cst_Comma_separated_label_name =
		                'Comma-separated label names to filter by (e.g. "bug,ui").',
		              cst_Comma_separated_list_of_pr =
		                "Comma-separated list of project properties to return.",
		              cst_Comment_content_in_HTML_fo =
		                "Comment content in HTML format.",
		              cst_Comment_unique_identifier = "Comment unique identifier.",
		              cst_Comparing_JSONs_isn_t_supp =
		                "Comparing JSONs isn't supported",
		              cst_Comparing_functions_isn_t_ =
		                "Comparing functions isn't supported",
		              cst_Comparing_parameters_isn_t =
		                "Comparing parameters isn't supported",
		              cst_Comparing_tuples_isn_t_sup =
		                "Comparing tuples isn't supported",
		              cst_Completed = "Completed",
		              cst_Configuration_of_the_mappi =
		                "Configuration of the mapping of the task status.",
		              cst_Const = "Const",
		              cst_Contact = "Contact ",
		              cst_Contact_s_email_address = "Contact's email address.",
		              cst_Contact_s_first_name = "Contact's first name.",
		              cst_Contact_s_job_title = "Contact's job title.",
		              cst_Contact_s_last_name = "Contact's last name.",
		              cst_Conversation_not_found = "Conversation not found",
		              cst_Could_not_construct = "Could_not_construct",
		              cst_Created = "Created",
		              cst_DIRECTORY_MERGE_SOURCE_TYP =
		                "DIRECTORY_MERGE_SOURCE_TYPE_CONTACT",
		              cst_DIRECTORY_MERGE_SOURCE_TYP$0 =
		                "DIRECTORY_MERGE_SOURCE_TYPE_UNSPECIFIED",
		              cst_DIRECTORY_SOURCE_TYPE_DOMA$0 =
		                "DIRECTORY_SOURCE_TYPE_DOMAIN_CONTACT",
		              cst_DIRECTORY_SOURCE_TYPE_DOMA =
		                "DIRECTORY_SOURCE_TYPE_DOMAIN_PROFILE",
		              cst_DIRECTORY_SOURCE_TYPE_UNSP =
		                "DIRECTORY_SOURCE_TYPE_UNSPECIFIED",
		              cst_December = "December",
		              cst_Delete_the_source_branch_a =
		                "Delete the source branch after merging.",
		              cst_Demo_Act_on_decision = "Demo Act on decision",
		              cst_Demo_Close_ticket = "Demo Close ticket",
		              cst_Demo_Create_ticket = "Demo Create ticket",
		              cst_Demo_Handle_complaint = "Demo Handle complaint",
		              cst_Demo_Notify_customers = "Demo Notify customers",
		              cst_Demo_Post_meeting_summary = "Demo Post-meeting summary",
		              cst_Demo_Summon_cursor = "Demo Summon cursor",
		              cst_Display_name = "Display name",
		              cst_Due_date_as_Unix_timestamp =
		                "Due date as Unix timestamp in milliseconds.",
		              cst_Due_date_in_YYYY_MM_DD_for =
		                "Due date in YYYY-MM-DD format.",
		              cst_Embed = "Embed",
		              cst_Equal = "Equal",
		              cst_Event_not_found = "Event not found",
		              cst_Exn = "Exn",
		              cst_Expand_options_groups_appl =
		                'Expand options: "groups", "applicationRoles".',
		              cst_External_user_ID_from_your =
		                "External user ID from your system (matched via SSO).",
		              cst_Ezjsonm_get_string = "Ezjsonm.get_string",
		              cst_Ezjsonm_to_sexp = "Ezjsonm.to_sexp",
		              cst_F$0 = "F",
		              cst_Failed_to_parse = "Failed to parse ",
		              cst_Failed_to_parse_s_as_a_dat =
		                "Failed to parse %s as a date: %s",
		              cst_Failed_to_parse_s_as_a_wee =
		                "Failed to parse %s as a week: %s",
		              cst_February = "February",
		              cst_Field_to_sort_by = "Field to sort by.",
		              cst_Filter_by_assignee_user_ID = "Filter by assignee user ID.",
		              cst_Filter_by_author_user_ID = "Filter by author user ID.",
		              cst_Filter_by_company_location = "Filter by company locations.",
		              cst_Filter_by_company_size_ran =
		                'Filter by company size ranges (e.g., "1,10", "11,50", "51,200").',
		              cst_Filter_by_state_open_defau =
		                'Filter by state: "open" (default), "closed", or "all".',
		              cst_Filter_by_team_Example_id_ =
		                'Filter by team. Example: [{id: {eq: "TEAM_ID"}}].',
		              cst_Filter_to_exclude_rows_fro =
		                "Filter to exclude rows from the mapping.",
		              cst_Float_int63_round_nearest_ =
		                "Float.int63_round_nearest_portable_alloc_exn: argument (",
		              cst_Float_iround_down_exn_argu =
		                "Float.iround_down_exn: argument (",
		              cst_Float_iround_up_exn_argume =
		                "Float.iround_up_exn: argument (",
		              cst_Forward_pagination_cursor_ =
		                "Forward pagination cursor from the previous response's\n            [next_starting_after].",
		              cst_Free = "Free",
		              cst_Friday = "Friday",
		              cst_GROUP_TYPE_UNSPECIFIED = "GROUP_TYPE_UNSPECIFIED",
		              cst_Get_all_issue_priorities = "Get all issue priorities.",
		              cst_Get_all_issue_statuses = "Get all issue statuses.",
		              cst_Get_all_issue_types_availa =
		                "Get all issue types available to the user.",
		              cst_Get_details_of_the_current =
		                "Get details of the currently authenticated user.",
		              cst_Globally_unique_identifier =
		                "Globally unique identifier for the task.",
		              cst_HEADING_1 = "HEADING_1",
		              cst_HEADING_2 = "HEADING_2",
		              cst_HEADING_3 = "HEADING_3",
		              cst_HEADING_4 = "HEADING_4",
		              cst_HEADING_5 = "HEADING_5",
		              cst_HEADING_6 = "HEADING_6",
		              cst_Heading = "Heading",
		              cst_Hex_conversion_Hex_string_ =
		                "Hex conversion: Hex string cannot have an odd number of characters.",
		              cst_Human_defined_task_due_dat =
		                'Human-defined task due date (e.g. "next Monday", "Tomorrow").',
		              cst_ID_of_the_task_should_be_n =
		                "ID of the task - should be null for a new todo block. Old documents\n            hold a plain google task id in this field so we need to accept\n            broader values",
		              cst_ID_of_the_user_who_owns_th =
		                "ID of the user who owns this contact.",
		              cst_ISO_8601_date_e_g_2026_03_ =
		                'ISO 8601 date, e.g. "2026-03-17"',
		              cst_ISO_8601_datetime_with_tim =
		                "ISO 8601 datetime with timezone offset",
		              cst_ISO_8601_e_g_2025_01_31 = 'ISO 8601, e.g. "2025-01-31"',
		              cst_Icon = "Icon",
		              cst_Id_of_the_table_which_rows =
		                "Id of the table which rows to map as tasks.",
		              cst_In_Progress = "In Progress",
		              cst_Include_archived_lists_def =
		                "Include archived lists (default false).",
		              cst_Include_subtasks_in_the_re =
		                "Include subtasks in the response.",
		              cst_Index_of_the_first_result_ =
		                "Index of the first result to return (for pagination).",
		              cst_Info = "Info",
		              cst_Invalid = "Invalid ",
		              cst_Invalid_s_id_s = "Invalid %s id: %s",
		              cst_Invalid_bounds = "Invalid bounds",
		              cst_Invalid_date_format = "Invalid date format",
		              cst_Invalid_time = "Invalid time: ",
		              cst_Invalid_time_s = "Invalid time: %s",
		              cst_Invalid_timezone = "Invalid timezone ",
		              cst_Invalid_timezone_s = "Invalid timezone %s",
		              cst_Invalidated = "Invalidated",
		              cst_Issue_UUID_or_shorthand_id =
		                'Issue UUID or shorthand identifier (e.g. "ENG-123").',
		              cst_Issue_or_PR_number = "Issue or PR number.",
		              cst_JSON = "JSON",
		              cst_January = "January",
		              cst_July = "July",
		              cst_June = "June",
		              cst_Keywords_to_search_for = "Keywords to search for.",
		              cst_Label_order = "Label order.",
		              cst_Labels_to_apply_to_the_con =
		                "Labels to apply to the contact.",
		              cst_Linked_organization_ID = "Linked organization ID.",
		              cst_Linked_person_ID = "Linked person ID.",
		              cst_List = "List(",
		              cst_List_a = "List(%a)",
		              cst_Login_is_stalled_waiting_f =
		                "Login is stalled waiting for connectivity: it resumes, on the step\n          last reported, once the connection is back.",
		              cst_Lwt = "Lwt.",
		              cst_Lwt_s = "Lwt.%s",
		              cst_MCP_server$0 = "MCP server ",
		              cst_MCP_server_s_is_now_enable =
		                "MCP server %s is now enabled. Use tool search to discover and call its tools.",
		              cst_MUST_be_Atlassian_Document =
		                'MUST be Atlassian Document Format (ADF). Example:\n              [ {"type": "doc", "version": 1, "content": [{"type": "paragraph",\n               "content": [{"type": "text", "text": "Your description"}]}]} ]',
		              cst_Malformed_input = "Malformed input",
		              cst_Map = "Map",
		              cst_Map_a_set_of_values_to_eac =
		                "Map a set of values to each task status",
		              cst_Mapping_of_a_column_as_tas =
		                "Mapping of a column as task status.",
		              cst_Mapping_of_a_set_of_values =
		                "Mapping of a set of values as a specific task status.",
		              cst_March = "March",
		              cst_Max = "Max",
		              cst_Max_contacts_to_return_def =
		                "Max contacts to return (default 50).",
		              cst_Max_tasks_to_return_defaul =
		                "Max tasks to return (default 50).",
		              cst_Maximum_number_of_results_ =
		                "Maximum number of results to return (1-25, default 25).",
		              cst_May = "May",
		              cst_Milestone_title_to_filter_ = "Milestone title to filter by.",
		              cst_Monday = "Monday",
		              cst_NAMED_STYLE_TYPE_UNSPECIFI = "NAMED_STYLE_TYPE_UNSPECIFIED",
		              cst_NORMAL_TEXT = "NORMAL_TEXT",
		              cst_Name_of_the_contact_s_orga =
		                "Name of the contact's organization.",
		              cst_Name_of_the_task = "Name of the task.",
		              cst_Necessary = "Necessary",
		              cst_Neg = "Neg",
		              cst_Never = "Never",
		              cst_New_owner_user_ID = "New owner user ID.",
		              cst_New_title = "New title.",
		              cst_No_local_data_could_be_reu =
		                "No local data could be reused: clone workspace state from the server.",
		              cst_November = "November",
		              cst_Number_of_results_to_retur =
		                "Number of results to return (max 100).",
		              cst_Object = "Object",
		              cst_Object_in_which_the_mentio =
		                "Object in which the mention occurred",
		              cst_October = "October",
		              cst_Of_list = "Of_list",
		              cst_Ok = "Ok",
		              cst_Operator = "Operator ",
		              cst_Optional_longer_rich_conte = "Optional longer rich context.",
		              cst_Ordering_lists_isn_t_suppo =
		                "Ordering lists isn't supported",
		              cst_Organization_not_found = "Organization not found",
		              cst_Owner_user_ID_Defaults_to_ =
		                "Owner user ID. Defaults to the authenticated user.",
		              cst_Page_cover_external_file_o =
		                "Page cover (external file object).",
		              cst_Page_icon_emoji_or_externa =
		                "Page icon (emoji or external file object).",
		              cst_Page_not_found = "Page not found",
		              cst_Page_number_1_based = "Page number (1-based).",
		              cst_Page_number_for_pagination = "Page number for pagination.",
		              cst_Page_size_default_100_max_ =
		                "Page size (default 100, max 500).",
		              cst_Pagination_cursor_from_a_p =
		                "Pagination cursor from a previous response's [nextCursor].",
		              cst_Pagination_cursor_from_a_p$0 =
		                "Pagination cursor from a previous response.",
		              cst_Pagination_cursor_from_pre =
		                "Pagination cursor from previous [pageInfo.endCursor].",
		              cst_Pagination_offset_0_based = "Pagination offset (0-based).",
		              cst_Paragraph = "Paragraph",
		              cst_Path_to_the_field_where_th =
		                "Path to the field where the mention occurred",
		              cst_Pos = "Pos",
		              cst_Post_content_in_HTML_forma = "Post content in HTML format.",
		              cst_Post_title_minimum_2_chara =
		                "Post title (minimum 2 characters).",
		              cst_Post_unique_identifier = "Post unique identifier.",
		              cst_Query = "Query",
		              cst_READ_SOURCE_TYPE_CONTACT = "READ_SOURCE_TYPE_CONTACT",
		              cst_READ_SOURCE_TYPE_DOMAIN_CO =
		                "READ_SOURCE_TYPE_DOMAIN_CONTACT",
		              cst_READ_SOURCE_TYPE_PROFILE = "READ_SOURCE_TYPE_PROFILE",
		              cst_READ_SOURCE_TYPE_UNSPECIFI = "READ_SOURCE_TYPE_UNSPECIFIED",
		              cst_RPC = "RPC ",
		              cst_RPC_s_error_on_channel_a_s =
		                "RPC %s error on channel %a: %s",
		              cst_RPC_decoding_response_to = "RPC: decoding response to ",
		              cst_Record = "Record",
		              cst_Recurrent_task = "Recurrent_task",
		              cst_Reference_get_on_Agent_Aut =
		                "Reference.get' on Agent / Automation / Conversation / Automation_run is not implemented",
		              cst_Reference_get_on_Table_ref =
		                "Reference.get' on Table_ref / Workspace_ref is not implemented",
		              cst_Repository_name = "Repository name.",
		              cst_Repository_owner_username_ =
		                "Repository owner (username or organization).",
		              cst_Require_an_exact_match_ins =
		                "Require an exact match instead of substring.",
		              cst_Restrict_visibility_of_the =
		                "Restrict visibility of the comment to a group or role.",
		              cst_Results_per_page_default_3 =
		                "Results per page (default 30, max 100).",
		              cst_Results_per_page_max_100 = "Results per page (max 100).",
		              cst_Results_per_page_max_100_d =
		                "Results per page (max 100, default 20).",
		              cst_Results_per_page = "Results per page.",
		              cst_Routine = "Routine",
		              cst_Routine_s_rich_document_ty = "Routine's rich document type.",
		              cst_SUBTITLE = "SUBTITLE",
		              cst_SYSTEM_CONTACT_GROUP = "SYSTEM_CONTACT_GROUP",
		              cst_Saturday = "Saturday",
		              cst_September = "September",
		              cst_Set_to_true_to_include_tim$0 =
		                "Set to true to include time in the due date.",
		              cst_Set_to_true_to_include_tim =
		                "Set to true to include time in the start date.",
		              cst_Sexp = "Sexp",
		              cst_Sort_direction_asc_or_desc =
		                'Sort direction: "asc" or "desc" (default).',
		              cst_Sort_direction_asc_or_desc$0 =
		                'Sort direction: "asc" or "desc".',
		              cst_Sort_in_ascending_order = "Sort in ascending order.",
		              cst_Specific_date_and_time_in_ =
		                "Specific date and time in RFC3339 format in UTC.",
		              cst_Start_date_as_Unix_timesta =
		                "Start date as Unix timestamp in milliseconds.",
		              cst_State_of_the_post_One_of_P =
		                'State of the post. One of "PUBLISHED" or "DRAFT". Defaults to\n            "PUBLISHED".',
		              cst_Step_name_cannot_be_empty = "Step name cannot be empty",
		              cst_Step_not_found = "Step not found",
		              cst_Step_prompt_cannot_be_empt = "Step prompt cannot be empty",
		              cst_String = "String",
		              cst_Sunday = "Sunday",
		              cst_T = "T",
		              cst_TITLE = "TITLE",
		              cst_Table = "Table ",
		              cst_Table_a_does_not_exist_or_ =
		                "Table %a does not exist or was deleted.",
		              cst_Table_not_found = "Table not found",
		              cst_Tag_arg = "Tag_arg",
		              cst_Tag_sexp = "Tag_sexp",
		              cst_Tag_t = "Tag_t",
		              cst_Task_content_May_contain_m =
		                "Task content. May contain markdown-formatted text and hyperlinks.",
		              cst_Task_description_in_plain_ =
		                "Task description in plain text.",
		              cst_Task_not_found = "Task not found",
		              cst_Task_priority_from_1_norma =
		                "Task priority from 1 (normal) to 4 (urgent).",
		              cst_Task_priority_1_Urgent_2_H =
		                "Task priority: 1 = Urgent, 2 = High, 3 = Normal, 4 = Low.",
		              cst_Task_renamed_to = "Task renamed to ",
		              cst_Tasks_recurrent_all = "Tasks_recurrent.all",
		              cst_The_ID_or_key_of_the_issue = "The ID or key of the issue.",
		              cst_The_account_is_being_migra =
		                "The account is being migrated server-side.",
		              cst_The_capacities_granted_to_ =
		                "The capacities granted to this client",
		              cst_The_channel_we_login_to = "The channel we login to",
		              cst_The_column_to_map_tha_stat =
		                "The column to map tha status to and from.",
		              cst_The_column_values_to_map_t =
		                "The column values to map to a task status.",
		              cst_The_column_s_internal_id_a =
		                "The column's internal id, as returned by getTableSchema. Only useful\n          to update a table's schema, should be null to create a new column.",
		              cst_The_contents_of_the_assist =
		                "The contents of the assistant message.",
		              cst_The_external_API = "The external API",
		              cst_The_field_holding_the_coll =
		                "The field holding the collection.",
		              cst_The_granted_capacities = "The granted capacities.",
		              cst_The_internal_API_used_by_t =
		                "The internal API used by the app",
		              cst_The_origin_scheme_host_por =
		                "The origin (scheme + host + port) to return to, used to override the\n          default frontend URL when the client is running on localhost.",
		              cst_The_path_to_return_to = "The path to return to",
		              cst_The_potential_capture_cont =
		                "The potential capture context.",
		              cst_The_project_ID_integer_or_ =
		                "The project ID (integer) or URL-encoded path.",
		              cst_The_query_params_to_includ = "The query params to include",
		              cst_The_question_in_short_form = "The question, in short form.",
		              cst_The_raw_URN_of_the_post_e_ =
		                'The raw URN of the post (e.g., "urn:li:ugcPost:12345" or\n            "urn:li:share:12345"). Do NOT URL-encode it.',
		              cst_The_raw_organization_URN_o =
		                'The raw organization URN of the author (e.g.,\n            "urn:li:organization:12345"). Personal member URNs\n            ("urn:li:person:...") are NOT supported.',
		              cst_The_recipient_s_phone_numb =
		                "The recipient's phone number with country code (e.g., 16505551234).",
		              cst_The_request_sent_to_OpenAI = "The request sent to OpenAI.",
		              cst_The_target_of_a_relation_s =
		                "The target of a relation schema",
		              cst_The_text_content_of_the_po =
		                "The text content of the post (up to 3000 characters).",
		              cst_The_time_at_which_this_gra =
		                "The time at which this grant was issued.",
		              cst_The_triggering_object_is_a = "The triggering object is a `",
		              cst_The_triggering_object_is_a$0 =
		                "The triggering object is a `%s` row. Get it. If it does not exist, do nothing and finish.",
		              cst_The_unit_of_time_for_durat =
		                'The unit of time for duration: "minute" or "day".',
		              cst_The_user_s_email_address_U =
		                'The user\'s email address. Use "me" for authenticated user.',
		              cst_The_user_facing_name_for_t =
		                "The user-facing name for this column.",
		              cst_The_value_to_set_the_colum =
		                "The value to set the column to when the task status changes.",
		              cst_The_values_to_map_with_the =
		                "The values to map with the discarded state.",
		              cst_The_values_to_map_with_the$0 =
		                "The values to map with the done state.",
		              cst_The_values_to_map_with_the$1 =
		                "The values to map with the todo state.",
		              cst_The_workspace_the_table_is =
		                "The workspace the table is in.",
		              cst_The_workspace_to_list_task =
		                "The workspace to list tasks from (the personal workspace, or an\n          organization workspace from the ENVIRONMENT section).",
		              cst_There_is_already_a_Routine =
		                "There is already a Routine account associated with this email address. You need to delete it first before you can connect it to this account.",
		              cst_This_is_a_byte_array = "This is a byte array",
		              cst_This_workspace_s_task_tabl =
		                "This workspace's task table has no assignee column.",
		              cst_Thursday = "Thursday",
		              cst_TickTick_project_ID = "TickTick project ID.",
		              cst_TickTick_task_ID = "TickTick task ID.",
		              cst_Time_estimate_in_milliseco =
		                "Time estimate in milliseconds.",
		              cst_Todo = "Todo",
		              cst_Too_much_input = "Too much input",
		              cst_Tool_not_found = "Tool not found: ",
		              cst_Tool_not_found_s = "Tool not found: %s",
		              cst_Tuesday = "Tuesday",
		              cst_Tuple = "Tuple",
		              cst_U = "U+",
		              cst_U_04X = "U+%04X",
		              cst_USER_CONTACT_GROUP = "USER_CONTACT_GROUP",
		              cst_UTC = "UTC",
		              cst_UTC_c_02d_02d = "UTC%c%02d:%02d",
		              cst_Unbounded = "Unbounded",
		              cst_Unique_account_id_of_the_m =
		                "Unique account id of the member.",
		              cst_Unnecessary = "Unnecessary",
		              cst_User_addresses_read = "User_addresses_read",
		              cst_Var = "Var",
		              cst_Variant = "Variant",
		              cst_View_your_email_address = "View your email address",
		              cst_Wednesday = "Wednesday",
		              cst_Whether_the_column_admits_ =
		                'Whether the column admits a presence test, i.e. "is set" / "is\n                unset".',
		              cst_Whether_the_label_is_a_fav =
		                "Whether the label is a favorite.",
		              cst_Whether_the_task_is_comple =
		                "Whether the task is completed.",
		              cst_Whether_the_task_is_starre = "Whether the task is starred.",
		              cst_Who_can_see_the_post_One_o =
		                'Who can see the post. One of "PUBLIC" or "CONNECTIONS". Defaults to\n            "PUBLIC".',
		              cst_With_backtrace = "With_backtrace",
		              cst_Workspace_not_found = "Workspace not found",
		              cst_Wrong_padding = "Wrong padding",
		              cst_XHR_Response_is_not_an_arr =
		                "XHR Response is not an arrayBuffer; using responseText",
		              cst_XHR_Response_is_null_using =
		                "XHR Response is null; using empty string",
		              cst_Z = "Z",
		              cst_Zero = "Zero",
		              cst$37 = "[",
		              cst_a$2 = "[%a]",
		              cst$36 = "]",
		              cst$42 = "] ",
		              cst$29 = "](",
		              cst_none$0 = "_none_",
		              cst$59 = "`",
		              cst_row_Get_it_If_it_does_not_ =
		                "` row. Get it. If it does not exist, do nothing and finish.",
		              cst_table$0 = "` table.",
		              cst_Ae = "`Ae",
		              cst_As = "`As",
		              cst_Await = "`Await",
		              cst_End = "`End",
		              cst_M = "`M",
		              cst_Null = "`Null",
		              cst_Oe = "`Oe",
		              cst_Os = "`Os",
		              cst_S = "`S",
		              cst_a$0 = "a",
		              cst_a_contact = "a contact",
		              cst_a_conversation = "a conversation",
		              cst_a_page = "a page",
		              cst_a_recurrent_task = "a recurrent task",
		              cst_a_table = "a table",
		              cst_a_task = "a task",
		              cst_a_workspace = "a workspace",
		              cst_accept = "accept",
		              cst_accepted = "accepted",
		              cst_access_restriction = "access_restriction",
		              cst_access_role = "access_role",
		              cst_access_type = "access_type",
		              cst_account_missing = "account_missing",
		              cst_active = "active",
		              cst_actor = "actor",
		              cst_addOn = "addOn",
		              cst_additionalProperties = "additionalProperties",
		              cst_address = "address",
		              cst_agenda = "agenda",
		              cst_agenda_tasks = "agenda_tasks",
		              cst_agent = "agent",
		              cst_agent_id = "agent_id",
		              cst_agent_instructions = "agent_instructions",
		              cst_agents = "agents",
		              cst_ai_assistant = "ai-assistant",
		              cst_ai_automation = "ai-automation",
		              cst_ai_automation_suspend = "ai-automation-suspend",
		              cst_ai_automation_trigger = "ai-automation-trigger",
		              cst_ai_built_in = "ai-built-in",
		              cst_ai_conversation_agent_id = "ai-conversation-agent-id",
		              cst_ai_conversation_tool_call = "ai-conversation-tool-call",
		              cst_ai_field_type = "ai-field-type",
		              cst_ai_human_in_the_loop = "ai-human-in-the-loop",
		              cst_ai_references = "ai-references",
		              cst_ai_value = "ai-value",
		              cst_ai_agent = "ai_agent",
		              cst_ai_automation$0 = "ai_automation",
		              cst_ai_automation_run = "ai_automation_run",
		              cst_ai_conversation = "ai_conversation",
		              cst_ai_field = "ai_field",
		              cst_ai_step = "ai_step",
		              cst_alarm = "alarm",
		              cst_all_recurrent_tasks = "all recurrent tasks",
		              cst_all_day = "all_day",
		              cst_all_not_deleted = "all_not_deleted",
		              cst_all_of = "all_of",
		              cst_allocate = "allocate ",
		              cst_allocation_failed = "allocation failed: ",
		              cst_allocation_failed_s = "allocation failed: %s",
		              cst_allocation_policy = "allocation_policy",
		              cst_allocations = "allocations",
		              cst_allow_calendar_access = "allow_calendar_access",
		              cst_allow_contact_access = "allow_contact_access",
		              cst_allow_incomplete = "allow_incomplete",
		              cst_alnum = "alnum",
		              cst_alpha = "alpha",
		              cst_already_pushing = "already pushing",
		              cst_an_agent = "an agent",
		              cst_an_automation = "an automation",
		              cst_an_automation_run = "an automation run",
		              cst_an_event = "an event",
		              cst_an_object = "an object",
		              cst_an_organization = "an organization",
		              cst_and = "and",
		              cst_android = "android",
		              cst_annotations = "annotations",
		              cst_any = "any",
		              cst_api = "api",
		              cst_api_controller_lib_control$3 =
		                "api/controller/lib/controller_ai/demo.ml",
		              cst_api_controller_lib_control$2 =
		                "api/controller/lib/controller_ai/tools/agent.ml",
		              cst_api_controller_lib_control$1 =
		                "api/controller/lib/controller_ai/tools/routine/link.ml",
		              cst_api_controller_lib_control$0 =
		                "api/controller/lib/controller_ai/tools/routine/workspace.ml",
		              cst_api_controller_lib_control =
		                "api/controller/lib/controller_crdt.ml",
		              cst_api_controller_lib_documen =
		                "api/controller/lib/document.ml",
		              cst_api_controller_lib_events_ = "api/controller/lib/events.ml",
		              cst_api_controller_lib_graph_c =
		                "api/controller/lib/graph/compare.ml",
		              cst_api_controller_lib_graph_g$0 =
		                "api/controller/lib/graph/graph.ml",
		              cst_api_controller_lib_graph_g =
		                "api/controller/lib/graph/graph_type_bootstrap.ml",
		              cst_api_controller_lib_pages_m = "api/controller/lib/pages.ml",
		              cst_api_controller_lib_rpc_ml = "api/controller/lib/rpc.ml",
		              cst_api_controller_lib_workspa =
		                "api/controller/lib/workspaces.ml",
		              cst_api_vendor_crdt_src_crdt_c =
		                "api/vendor/crdt/src/crdt_const.ml",
		              cst_api_vendor_crdt_src_crdt_f =
		                "api/vendor/crdt/src/crdt_fugue.ml",
		              cst_api_server = "api_server",
		              cst_apolloio = "apolloio",
		              cst_app = "app",
		              cst_app_api = "app/api",
		              cst_app_controller = "app/controller",
		              cst_app_ui = "app/ui",
		              cst_append_on_object_does_noth = "append on object does nothing",
		              cst_application_json = "application/json",
		              cst_applicator = "applicator",
		              cst_architecture = "architecture",
		              cst_argument_must_be_strictly_ =
		                "argument must be strictly positive",
		              cst_arm64 = "arm64",
		              cst_array = "array",
		              cst_as = "as",
		              cst_asana = "asana",
		              cst_asc = "asc",
		              cst_ascending = "ascending",
		              cst_ascii = "ascii",
		              cst_ask_freely = "ask-freely",
		              cst_ask_if_necessary = "ask-if-necessary",
		              cst_assignee_ref = "assignee_ref",
		              cst_assistant = "assistant",
		              cst_at = "at",
		              cst_attachment = "attachment",
		              cst_attend = "attend",
		              cst_attendance = "attendance",
		              cst_attendee = "attendee",
		              cst_attendees = "attendees",
		              cst_attio = "attio",
		              cst_authentication = "authentication",
		              cst_author = "author",
		              cst_auto = "auto",
		              cst_automation = "automation",
		              cst_automation_runs$0 = "automation-runs",
		              cst_automation_id = "automation_id",
		              cst_automation_name = "automation_name",
		              cst_automation_run = "automation_run",
		              cst_automation_runs = "automation_runs",
		              cst_automations = "automations",
		              cst_availability_override = "availability_override",
		              cst_average = "average",
		              cst_backend = "backend",
		              cst_background_stop_polling = "background, stop polling",
		              cst_base_and_local_document_ar =
		                "base and local document are identical",
		              cst_base_and_remote_document_a =
		                "base and remote document are identical",
		              cst_batch = "batch",
		              cst_batch$0 = "batch ",
		              cst_batch_a = "batch %a",
		              cst_before = "before",
		              cst_beta = "beta",
		              cst_bind_hotkeys = "bind hotkeys",
		              cst_birthday = "birthday",
		              cst_blank = "blank",
		              cst_bleeding = "bleeding",
		              cst_block_id = "block_id",
		              cst_blocked = "blocked",
		              cst_blue = "blue",
		              cst_blue_background = "blue_background",
		              cst_body = "body",
		              cst_bool = "bool",
		              cst_boolean = "boolean",
		              cst_bot = "bot",
		              cst_boundaries = "boundaries",
		              cst_br = "br",
		              cst_brown = "brown",
		              cst_brown_background = "brown_background",
		              cst_builtin_type = "builtin_type",
		              cst_bullet = "bullet",
		              cst_bullet_ordered = "bullet-ordered",
		              cst_business_hours = "business_hours",
		              cst_busy = "busy",
		              cst_by = "by",
		              cst_bytes = "bytes",
		              cst_c$0 = "c",
		              cst_calendar_status = "calendar_status",
		              cst_calendar_tasks = "calendar_tasks",
		              cst_calendars_state = "calendars-state",
		              cst_calendars$0 = "calendars.",
		              cst_calendars_a_role = "calendars.%a.role",
		              cst_calendars_state$0 = "calendars_state",
		              cst_callbacks_from_remote_to_l =
		                "callbacks from remote to local not supported",
		              cst_caller = "caller",
		              cst_cancel = "cancel",
		              cst_canceled = "canceled",
		              cst_cancelled = "cancelled",
		              cst_cannot = "cannot ",
		              cst_cannot_encode_callback_to_ = "cannot encode callback to Vue",
		              cst_cannot_encode_input_variab =
		                "cannot encode input variable to Vue",
		              cst_capabilities = "capabilities",
		              cst_capacity = "capacity",
		              cst_case = "case",
		              cst_cc = "cc",
		              cst_cell_path = "cell_path",
		              cst_changing_task_parent_is_no =
		                "changing task parent is not supported in update_subtasks",
		              cst_channel = "channel",
		              cst_character = "character",
		              cst_checkbox = "checkbox",
		              cst_checked = "checked",
		              cst_checkout_session = "checkout.session",
		              cst_child = "child",
		              cst_children = "children",
		              cst_city = "city",
		              cst_class = "class",
		              cst_clickup = "clickup",
		              cst_client_data$0 = "client-data",
		              cst_client_id = "client_id",
		              cst_clock = "clock",
		              cst_close = "close",
		              cst_closed = "closed",
		              cst_cntrl = "cntrl",
		              cst_col = "col",
		              cst_color = "color",
		              cst_columns_customization = "columns-customization",
		              cst_comment = "comment",
		              cst_comments = "comments",
		              cst_commit = "commit",
		              cst_commit_pattern = "commit_pattern",
		              cst_common = "common",
		              cst_compactions = "compactions",
		              cst_company = "company",
		              cst_completed = "completed",
		              cst_completion_tokens_details = "completion_tokens_details",
		              cst_computed = "computed",
		              cst_conference_properties = "conference_properties",
		              cst_configuration = "configuration",
		              cst_confirmed = "confirmed",
		              cst_conflict_error = "conflict_error",
		              cst_connection = "connection",
		              cst_connection_not_found = "connection not found: ",
		              cst_connection_not_found_a = "connection not found: %a",
		              cst_connections = "connections",
		              cst_contact = "contact",
		              cst_contacts_state = "contacts-state",
		              cst_contacts_state$0 = "contacts_state",
		              cst_contains = "contains",
		              cst_content = "content",
		              cst_content_type = "content-type",
		              cst_content_filter = "content_filter",
		              cst_content_item = "content_item",
		              cst_context = "context",
		              cst_contexts = "contexts",
		              cst_controller_Auth_deleteAccc =
		                "controller.Auth.deleteAcccount",
		              cst_controller_controller_clie =
		                "controller/controller-client/controller_client.ml",
		              cst_conversation = "conversation",
		              cst_conversation_context = "conversation-context",
		              cst_conversation_in_progress = "conversation-in-progress",
		              cst_conversations = "conversations",
		              cst_core = "core",
		              cst_core_src_span_ns_ml = "core/src/span_ns.ml",
		              cst_could_not = "could not ",
		              cst_could_not_push_commits_to_ =
		                "could not push commits to the API: conflict",
		              cst_count = "count",
		              cst_count_all = "count_all",
		              cst_count_empty = "count_empty",
		              cst_count_not_empty = "count_not_empty",
		              cst_count_unique_values = "count_unique_values",
		              cst_count_values = "count_values",
		              cst_country = "country",
		              cst_coupon = "coupon",
		              cst_crdt_read_write = "crdt_read_write",
		              cst_crdt_write = "crdt_write",
		              cst_create_event = "create event",
		              cst_createAutomation = "createAutomation",
		              cst_create_invoice = "create_invoice",
		              cst_create_record_failed = "create_record_failed",
		              cst_created = "created",
		              cst_created_time = "created_time",
		              cst_creation = "creation",
		              cst_creator = "creator",
		              cst_custom = "custom",
		              cst_custom_major_ratio = "custom_major_ratio",
		              cst_custom_minor_max_size = "custom_minor_max_size",
		              cst_custom_minor_ratio = "custom_minor_ratio",
		              cst_d$0 = "d",
		              cst_daily = "daily",
		              cst_data = "data",
		              cst_data_name = "data_name",
		              cst_data_record_change = "data_record_change",
		              cst_database_and_agent_menu_ta =
		                "database-and-agent-menu-target",
		              cst_databases = "databases",
		              cst_dateHeader = "dateHeader",
		              cst_date_range = "date_range",
		              cst_datetime = "datetime",
		              cst_day = "day",
		              cst_day$0 = "day ",
		              cst_day_a = "day %a",
		              cst_days$0 = "days",
		              cst_deals = "deals",
		              cst_debug = "debug",
		              cst_declined = "declined",
		              cst_default = "default",
		              cst_default_organization_is_mi =
		                "default organization is missing",
		              cst_default_types_relations = "default-types-relations",
		              cst_default_incomplete = "default_incomplete",
		              cst_defer_profile = "defer_profile",
		              cst_delete$0 = "delete ",
		              cst_delete_a = "delete %a",
		              cst_delete_record_failed = "delete_record_failed",
		              cst_deleted = "deleted",
		              cst_deletion = "deletion",
		              cst_delta = "delta",
		              cst_desc = "desc",
		              cst_descending = "descending",
		              cst_description = "description",
		              cst_dev = "dev",
		              cst_developer = "developer",
		              cst_development = "development",
		              cst_direct = "direct",
		              cst_direction = "direction",
		              cst_directory = "directory",
		              cst_directory_enabled$0 = "directory-enabled",
		              cst_directory_enabled = "directory_enabled",
		              cst_disabled = "disabled",
		              cst_discarded = "discarded",
		              cst_discord = "discord",
		              cst_dist = "dist",
		              cst_distribution = "distribution",
		              cst_dollar = "dollar",
		              cst_domains = "domains",
		              cst_done_pushing_operations = "done pushing operations",
		              cst_download = "download",
		              cst_draft = "draft",
		              cst_drive = "drive",
		              cst_duplicate_key$0 = "duplicate key",
		              cst_duplicate_key = "duplicate key: ",
		              cst_duplicate_key_a = "duplicate key: %a",
		              cst_e = "e",
		              cst_earliest_date = "earliest_date",
		              cst_effort = "effort",
		              cst_either = "either",
		              cst_element = "element",
		              cst_else = "else",
		              cst_else$0 = "else_",
		              cst_emoji = "emoji",
		              cst_enabled_data_collections = "enabled_data_collections",
		              cst_end = "end",
		              cst_ended = "ended",
		              cst_ends_with = "ends_with",
		              cst_enterprise = "enterprise",
		              cst_environment = "environment",
		              cst_eq = "eq",
		              cst_equals = "equals",
		              cst_equation = "equation",
		              cst_error = "error",
		              cst_error_if_incomplete = "error_if_incomplete",
		              cst_euro = "euro",
		              cst_evening = "evening",
		              cst_event_occurrence_not_found = "event occurrence not found: ",
		              cst_event_occurrence_not_found$0 = "event occurrence not found: %a",
		              cst_event$0 = "event-",
		              cst_event_s_content = "event-%s-content",
		              cst_event_creation = "event-creation",
		              cst_event_rec = "event-rec",
		              cst_event_recurrent$0 = "event-recurrent",
		              cst_event_recurrent_attendance = "event-recurrent-attendance",
		              cst_event_recurrent_daytime = "event-recurrent-daytime",
		              cst_eventType = "eventType",
		              cst_event_recurrent = "event_recurrent",
		              cst_events_rec = "events-rec",
		              cst_every$0 = "every ",
		              cst_every_workday = "every workday",
		              cst_exceptions = "exceptions",
		              cst_exclude = "exclude",
		              cst_executive_assistant = "executive-assistant",
		              cst_exepected_document_redirec =
		                "exepected document redirection on an event",
		              cst_exn = "exn",
		              cst_expected = "expected",
		              cst_expected$0 = "expected ",
		              cst_expected_s_got_s = "expected %s, got %s",
		              cst_expected_a_boolean_got = "expected a boolean, got ",
		              cst_expected_a_boolean_got_a = "expected a boolean, got %a",
		              cst_expected_one_of = "expected one of ",
		              cst_expected_one_of_a = "expected one of @[%a@]",
		              cst_exponent_can_not_be_negati = "exponent can not be negative",
		              cst_extension_row = "extension_row",
		              cst_extras_custom = "extras_custom",
		              cst_f$0 = "f",
		              cst_failed = "failed",
		              cst_failed_to_set_demo_event_n =
		                "failed to set demo event notes",
		              cst_failed_to_update_demo_even = "failed to update demo event",
		              cst_failure = "failure",
		              cst_family = "family",
		              cst_fast = "fast",
		              cst_fatal = "fatal",
		              cst_fatal_error$0 = "fatal error ",
		              cst_fatal_error = "fatal error: ",
		              cst_fatal_error_a = "fatal error: %a",
		              cst_featurebase = "featurebase",
		              cst_field_value = "field_value",
		              cst_file = "file",
		              cst_finish_reason = "finish_reason",
		              cst_first = "first",
		              cst_float = "float",
		              cst_focus = "focus",
		              cst_focusTime = "focusTime",
		              cst_for = "for ",
		              cst_forced_major_collections = "forced_major_collections",
		              cst_foreground_resume_polling = "foreground, resume polling",
		              cst_forks = "forks",
		              cst_format = "format",
		              cst_formula = "formula",
		              cst_fragments = "fragments",
		              cst_frame = "frame",
		              cst_free = "free",
		              cst_freeBusyReader = "freeBusyReader",
		              cst_free_blocks = "free_blocks",
		              cst_free_words = "free_words",
		              cst_frequency = "frequency",
		              cst_fromGmail = "fromGmail",
		              cst_from_scratch = "from_scratch",
		              cst_frontend = "frontend",
		              cst_full = "full",
		              cst_full_name = "full_name",
		              cst_function = "function",
		              cst_g = "g",
		              cst_gadget = "gadget",
		              cst_generic = "generic",
		              cst_get = "get ",
		              cst_get_a = "get %a",
		              cst_get_default = "get default",
		              cst_github = "github",
		              cst_gitlab = "gitlab",
		              cst_gmail = "gmail",
		              cst_gmail_tasks = "gmail-tasks",
		              cst_gnu_linux = "gnu_linux",
		              cst_google = "google",
		              cst_google_calendar_id = "google_calendar_id",
		              cst_google_event_id = "google_event_id",
		              cst_got$0 = "got",
		              cst_gpt_4_1 = "gpt-4.1",
		              cst_gpt_4_1_mini = "gpt-4.1-mini",
		              cst_gpt_4_1_nano = "gpt-4.1-nano",
		              cst_gpt_4o = "gpt-4o",
		              cst_gpt_4o_mini = "gpt-4o-mini",
		              cst_gpt_5_4 = "gpt-5.4",
		              cst_gpt_5_4_mini = "gpt-5.4-mini",
		              cst_gpt_5_4_nano = "gpt-5.4-nano",
		              cst_gpt_5_4_pro = "gpt-5.4-pro",
		              cst_gpt_5_5 = "gpt-5.5",
		              cst_gpt_5_5_pro = "gpt-5.5-pro",
		              cst_gpt_5_6_luna = "gpt-5.6-luna",
		              cst_gpt_5_6_terra = "gpt-5.6-terra",
		              cst_grant = "grant",
		              cst_grant_type = "grant_type",
		              cst_graph_custom_string_format = "graph-custom-string-formats",
		              cst_graph_field = "graph-field",
		              cst_graph_type = "graph-type",
		              cst_graph_database = "graph_database",
		              cst_gray = "gray",
		              cst_gray_background = "gray_background",
		              cst_green = "green",
		              cst_green_background = "green_background",
		              cst_group = "group",
		              cst_gt = "gt",
		              cst_gte = "gte",
		              cst_head = "head",
		              cst_header = "header",
		              cst_heap_chunks = "heap_chunks",
		              cst_heap_words = "heap_words",
		              cst_height = "height",
		              cst_height_lower_bound = "height_lower_bound",
		              cst_help$1 = "help",
		              cst_hex = "hex",
		              cst_hi = "hi",
		              cst_hidden = "hidden",
		              cst_hidden_columns = "hidden_columns",
		              cst_hide = "hide",
		              cst_hierarchy = "hierarchy",
		              cst_high = "high",
		              cst_history = "history",
		              cst_home = "home",
		              cst_hour = "hour",
		              cst_hr = "hr",
		              cst_html = "html",
		              cst_https = "https",
		              cst_https_mail_google_com = "https://mail.google.com",
		              cst_https_www_googleapis_com_a =
		                "https://www.googleapis.com/auth/calendar",
		              cst_https_www_googleapis_com_a$0 =
		                "https://www.googleapis.com/auth/calendar.events",
		              cst_https_www_googleapis_com_a$1 =
		                "https://www.googleapis.com/auth/calendar.events.readonly",
		              cst_https_www_googleapis_com_a$2 =
		                "https://www.googleapis.com/auth/calendar.readonly",
		              cst_https_www_googleapis_com_a$3 =
		                "https://www.googleapis.com/auth/calendar.settings.readonly",
		              cst_https_www_googleapis_com_a$4 =
		                "https://www.googleapis.com/auth/contacts",
		              cst_https_www_googleapis_com_a$5 =
		                "https://www.googleapis.com/auth/contacts.other.readonly",
		              cst_https_www_googleapis_com_a$6 =
		                "https://www.googleapis.com/auth/contacts.readonly",
		              cst_https_www_googleapis_com_a$7 =
		                "https://www.googleapis.com/auth/directory.readonly",
		              cst_https_www_googleapis_com_a$16 =
		                "https://www.googleapis.com/auth/documents",
		              cst_https_www_googleapis_com_a$17 =
		                "https://www.googleapis.com/auth/documents.readonly",
		              cst_https_www_googleapis_com_a$8 =
		                "https://www.googleapis.com/auth/drive",
		              cst_https_www_googleapis_com_a$9 =
		                "https://www.googleapis.com/auth/drive.appdata",
		              cst_https_www_googleapis_com_a$10 =
		                "https://www.googleapis.com/auth/drive.file",
		              cst_https_www_googleapis_com_a$11 =
		                "https://www.googleapis.com/auth/drive.metadata",
		              cst_https_www_googleapis_com_a$12 =
		                "https://www.googleapis.com/auth/drive.metadata.readonly",
		              cst_https_www_googleapis_com_a$13 =
		                "https://www.googleapis.com/auth/drive.photos.readonly",
		              cst_https_www_googleapis_com_a$14 =
		                "https://www.googleapis.com/auth/drive.readonly",
		              cst_https_www_googleapis_com_a$15 =
		                "https://www.googleapis.com/auth/drive.scripts",
		              cst_https_www_googleapis_com_a$18 =
		                "https://www.googleapis.com/auth/gmail.insert",
		              cst_https_www_googleapis_com_a$19 =
		                "https://www.googleapis.com/auth/gmail.labels",
		              cst_https_www_googleapis_com_a$21 =
		                "https://www.googleapis.com/auth/gmail.metadata",
		              cst_https_www_googleapis_com_a$20 =
		                "https://www.googleapis.com/auth/gmail.modify",
		              cst_https_www_googleapis_com_a$22 =
		                "https://www.googleapis.com/auth/gmail.readonly",
		              cst_https_www_googleapis_com_a$30 =
		                "https://www.googleapis.com/auth/tasks",
		              cst_https_www_googleapis_com_a$31 =
		                "https://www.googleapis.com/auth/tasks.readonly",
		              cst_https_www_googleapis_com_a$23 =
		                "https://www.googleapis.com/auth/user.birthday.read",
		              cst_https_www_googleapis_com_a$24 =
		                "https://www.googleapis.com/auth/user.emails.read",
		              cst_https_www_googleapis_com_a$25 =
		                "https://www.googleapis.com/auth/user.gender.read",
		              cst_https_www_googleapis_com_a$26 =
		                "https://www.googleapis.com/auth/user.organization.read",
		              cst_https_www_googleapis_com_a$27 =
		                "https://www.googleapis.com/auth/user.phonenumbers.read",
		              cst_https_www_googleapis_com_a$28 =
		                "https://www.googleapis.com/auth/userinfo.email",
		              cst_https_www_googleapis_com_a$29 =
		                "https://www.googleapis.com/auth/userinfo.profile",
		              cst_i$0 = "i",
		              cst_icon = "icon",
		              cst_if = "if",
		              cst_ignore = "ignore",
		              cst_ignored = "ignored",
		              cst_illegal = "illegal",
		              cst_imports = "imports",
		              cst_impossible_unbreakable_loo = "impossible unbreakable loop",
		              cst_in = "in",
		              cst_in_progress = "in_progress",
		              cst_inbox = "inbox",
		              cst_include = "include",
		              cst_incomplete = "incomplete",
		              cst_incomplete_expired = "incomplete_expired",
		              cst_index_out_of_bounds_not_de =
		                "index out of bounds, not deleted",
		              cst_info = "info",
		              cst_init = "init",
		              cst_initializing = "initializing",
		              cst_input_tokens_details = "input_tokens_details",
		              cst_insert = "insert",
		              cst_insert$0 = "insert ",
		              cst_inside = "inside",
		              cst_instantly = "instantly",
		              cst_int = "int",
		              cst_int64 = "int64",
		              cst_integer = "integer",
		              cst_integer_overflow_in_pow = "integer overflow in pow",
		              cst_integration_app$0 = "integration-app",
		              cst_integration_app_force_refr = "integration-app-force-refresh",
		              cst_integration_config = "integration-config",
		              cst_integration_app_error = "integration_app_error",
		              cst_integration_key = "integration_key",
		              cst_intention = "intention",
		              cst_interactions = "interactions",
		              cst_interactivity = "interactivity",
		              cst_internal_builtin_custom_ty = "internal_builtin_custom_type",
		              cst_internal_builtin_type_exte =
		                "internal_builtin_type_extensions",
		              cst_internal_server_error = "internal_server_error",
		              cst_interval = "interval",
		              cst_invalid = "invalid ",
		              cst_invalid_s_id_S = "invalid %s id: %S",
		              cst_invalid_connection_delta_s =
		                "invalid connection delta/state combination",
		              cst_invalid_connection_operati =
		                "invalid connection operation/state combination",
		              cst_invalid_date$0 = "invalid date",
		              cst_invalid_date$1 = "invalid date ",
		              cst_invalid_date = "invalid date: ",
		              cst_invalid_date_a = "invalid date: %a",
		              cst_invalid_date_s = "invalid date: %s",
		              cst_invalid_delta_state_combin =
		                "invalid delta-state combination",
		              cst_invalid_duration_unit = "invalid duration unit",
		              cst_invalid_identifier_wrong_p =
		                "invalid identifier, wrong prefix",
		              cst_invalid_month$0 = "invalid month",
		              cst_invalid_month = "invalid month: ",
		              cst_invalid_operation_state_co =
		                "invalid operation-state combination",
		              cst_invalid_replica_timestamp = "invalid replica timestamp: ",
		              cst_invalid_replica_timestamp_ = "invalid replica timestamp: %s",
		              cst_invalid_semantic_version$0 = "invalid semantic version",
		              cst_invalid_semantic_version = "invalid semantic version: ",
		              cst_invalid_json = "invalid_json",
		              cst_invalid_request = "invalid_request",
		              cst_invalid_request_url = "invalid_request_url",
		              cst_inverse_relations = "inverse_relations",
		              cst_ios = "ios",
		              cst_is_empty = "is_empty",
		              cst_is_not_empty = "is_not_empty",
		              cst_item = "item",
		              cst_jira = "jira",
		              cst_journal = "journal",
		              cst_json = "json",
		              cst_jsonrpc = "jsonrpc",
		              cst_keyword = "keyword",
		              cst_label = "label",
		              cst_labelAdded = "labelAdded",
		              cst_labelRemoved = "labelRemoved",
		              cst_label_hide = "label_hide",
		              cst_label_show = "label_show",
		              cst_label_show_if_unread = "label_show_if_unread",
		              cst_labels = "labels",
		              cst_largest_free = "largest_free",
		              cst_last = "last",
		              cst_last_edited_time = "last_edited_time",
		              cst_last_prompt_hash = "last_prompt_hash",
		              cst_last_response_id = "last_response_id",
		              cst_latest = "latest",
		              cst_latest_date = "latest_date",
		              cst_length = "length",
		              cst_let = "let",
		              cst_lhs = "lhs",
		              cst_lhs_change = "lhs_change",
		              cst_li$0 = "li",
		              cst_lib_std_internal_ml = "lib/std_internal.ml",
		              cst_lib_typerep_obj_ml = "lib/typerep_obj.ml",
		              cst_library = "library",
		              cst_line = "line",
		              cst_linear = "linear",
		              cst_link = "link",
		              cst_linkedin = "linkedin",
		              cst_listMembers = "listMembers",
		              cst_list_elt = "list_elt",
		              cst_live_blocks = "live_blocks",
		              cst_live_words = "live_words",
		              cst_lo = "lo",
		              cst_local_side_of_RPC_never_su =
		                "local side of RPC never supposed to call close",
		              cst_localhost = "localhost",
		              cst_location = "location",
		              cst_login_progress_step = "login_progress_step",
		              cst_login_status_detail = "login_status_detail",
		              cst_lone = "lone",
		              cst_long_running = "long-running",
		              cst_lost = "lost",
		              cst_low = "low",
		              cst_lower = "lower",
		              cst_lower_bound = "lower_bound",
		              cst_lt = "lt",
		              cst_lte = "lte",
		              cst_lww = "lww",
		              cst_ly = "ly",
		              cst_m = "m",
		              cst_macos = "macos",
		              cst_main = "main",
		              cst_major_collections = "major_collections",
		              cst_major_heap_increment = "major_heap_increment",
		              cst_major_words = "major_words",
		              cst_make = "make",
		              cst_make_parser = "make parser",
		              cst_mandate_destination = "mandate-destination",
		              cst_manual = "manual",
		              cst_map = "map",
		              cst_mark = "mark ",
		              cst_mark_s = "mark %s",
		              cst_markdown = "markdown",
		              cst_markup = "markup",
		              cst_matchable = "matchable",
		              cst_max = "max",
		              cst_max_allowed_key = "max_allowed_key",
		              cst_max_overhead = "max_overhead",
		              cst_maybe = "maybe",
		              cst_me = "me",
		              cst_mechanism = "mechanism",
		              cst_median = "median",
		              cst_medium = "medium",
		              cst_meet = "meet",
		              cst_meetings = "meetings",
		              cst_member = "member",
		              cst_member_add = "member-add",
		              cst_member_invite = "member-invite",
		              cst_member_remove = "member-remove",
		              cst_member_uninvite = "member-uninvite",
		              cst_members = "members",
		              cst_members_pending = "members-pending",
		              cst_mentions = "mentions",
		              cst_menu_items$0 = "menu-items",
		              cst_menu_label_and_org_homepag = "menu-label-and-org-homepage",
		              cst_merge_remote_and_local_doc =
		                "merge remote and local documents",
		              cst_messageAdded = "messageAdded",
		              cst_messageDeleted = "messageDeleted",
		              cst_meta = "meta",
		              cst_metadata = "metadata",
		              cst_migrating_account = "migrating_account",
		              cst_min = "min",
		              cst_min_allowed_key = "min_allowed_key",
		              cst_minimal = "minimal",
		              cst_minor_collections = "minor_collections",
		              cst_minor_heap_size = "minor_heap_size",
		              cst_minor_words = "minor_words",
		              cst_minute = "minute",
		              cst_minutes = "minutes",
		              cst_missing_node_to_delete = "missing node to delete: ",
		              cst_missing_node_to_delete_a = "missing node to delete: %a",
		              cst_missing_timezone = "missing timezone",
		              cst_missing_version = "missing_version",
		              cst_mobile_demo = "mobile-demo",
		              cst_model = "model",
		              cst_month = "month",
		              cst_month_day = "month_day",
		              cst_monthly = "monthly",
		              cst_monthly_on_the = "monthly on the ",
		              cst_months = "months",
		              cst_more = "more",
		              cst_morning = "morning",
		              cst_move$0 = "move ",
		              cst_move_a = "move %a",
		              cst_mru_destinations = "mru_destinations",
		              cst_mru_people = "mru_people",
		              cst_mrus = "mrus",
		              cst_ms = "ms",
		              cst_name$0 = "name ",
		              cst_namespace = "namespace",
		              cst_native = "native",
		              cst_nd = "nd",
		              cst_needsAction = "needsAction",
		              cst_neq = "neq",
		              cst_never = "never",
		              cst_never_ask = "never-ask",
		              cst_new = "new",
		              cst_next = "next",
		              cst_no = "no",
		              cst_no_case_matched = "no case matched",
		              cst_no_context = "no context",
		              cst_no_element_with_key = "no element with key ",
		              cst_no_event_with_this_id_to_a =
		                "no event with this id to append block to: ",
		              cst_no_event_with_this_id_to_a$0 =
		                "no event with this id to append block to: %a",
		              cst_no_home_setting_the_first_ =
		                "no home, setting the first item as home",
		              cst_no_overload_matches = "no overload matches",
		              cst_no_such_event = "no such event",
		              cst_no_such_page = "no such page: ",
		              cst_no_such_page_a = "no such page: %a",
		              cst_no_such_task = "no such task: ",
		              cst_no_such_task_a = "no such task: %a",
		              cst_no_crdt = "no_crdt",
		              cst_no_list_method = "no_list_method",
		              cst_node = "node",
		              cst_nodes_by_height = "nodes_by_height",
		              cst_none = "none",
		              cst_noop = "noop",
		              cst_not = "not",
		              cst_not_an_event_occurrence_id = "not an event occurrence id: ",
		              cst_not_an_event_occurrence_id$0 = "not an event occurrence id: %a",
		              cst_not_unifiable = "not unifiable",
		              cst_not_contains = "not_contains",
		              cst_not_ends_with = "not_ends_with",
		              cst_not_inside = "not_inside",
		              cst_not_planned = "not_planned",
		              cst_not_starts_with = "not_starts_with",
		              cst_note = "note",
		              cst_notes = "notes",
		              cst_notes_field = "notes_field",
		              cst_notices_personal_archived = "notices-personal-archived",
		              cst_notices_personal_viewed = "notices-personal-viewed",
		              cst_notification = "notification",
		              cst_notion_config = "notion-config",
		              cst_notion_integration = "notion-integration",
		              cst_notion_status_group = "notion-status-group",
		              cst_now = "now",
		              cst_null = "null",
		              cst_number = "number",
		              cst_number_with_commas = "number_with_commas",
		              cst_object = "object",
		              cst_object_hierarchy = "object-hierarchy",
		              cst_object_id = "object-id",
		              cst_object_context = "object_context",
		              cst_object_id$0 = "object_id",
		              cst_object_not_found = "object_not_found",
		              cst_occurrence = "occurrence",
		              cst_of = "of",
		              cst_offline = "offline",
		              cst_on_change = "on_change",
		              cst_on_update_handlers = "on_update_handlers",
		              cst_one = "one",
		              cst_one_of = "one_of",
		              cst_online = "online",
		              cst_only_all_day = "only-all-day",
		              cst_op = "op",
		              cst_opaque = "opaque",
		              cst_open = "open",
		              cst_openai_output_item = "openai-output-item",
		              cst_opened = "opened",
		              cst_openid = "openid",
		              cst_operation = "operation",
		              cst_option = "option",
		              cst_or = "or",
		              cst_orange = "orange",
		              cst_orange_background = "orange_background",
		              cst_ordered = "ordered",
		              cst_org = "org",
		              cst_org_poly = "org-poly",
		              cst_organization_summary = "organization_summary",
		              cst_organizations = "organizations",
		              cst_organizations_references = "organizations-references",
		              cst_os = "os",
		              cst_other = "other",
		              cst_other_enabled$0 = "other-enabled",
		              cst_other_emails = "other_emails",
		              cst_other_enabled = "other_enabled",
		              cst_outOfOffice = "outOfOffice",
		              cst_output_tokens_details = "output_tokens_details",
		              cst_owner = "owner",
		              cst_p = "p",
		              cst_page$0 = "page ",
		              cst_paid = "paid",
		              cst_paragraph = "paragraph",
		              cst_parse_error = "parse error",
		              cst_parts = "parts",
		              cst_passive = "passive",
		              cst_past_due = "past_due",
		              cst_patch$0 = "patch ",
		              cst_patch_a = "patch %a",
		              cst_path = "path",
		              cst_pause = "pause",
		              cst_paused = "paused",
		              cst_paused_for_user_input = "paused_for_user_input",
		              cst_pending = "pending",
		              cst_percent = "percent",
		              cst_percent_checked = "percent_checked",
		              cst_percent_empty = "percent_empty",
		              cst_percent_not_empty = "percent_not_empty",
		              cst_percent_unchecked = "percent_unchecked",
		              cst_permissions = "permissions",
		              cst_person = "person",
		              cst_person_name = "person_name",
		              cst_persona = "persona",
		              cst_personal_workspace_not_fou = "personal workspace not found",
		              cst_phone = "phone",
		              cst_phone_number = "phone_number",
		              cst_phones = "phones",
		              cst_photo = "photo",
		              cst_photos = "photos",
		              cst_pick = "pick",
		              cst_pick_applies_to_collection = "pick applies to collection",
		              cst_pin = "pin",
		              cst_ping = "ping",
		              cst_pink = "pink",
		              cst_pink_background = "pink_background",
		              cst_pipedrive = "pipedrive",
		              cst_plain = "plain",
		              cst_plaintext = "plaintext",
		              cst_plan = "plan",
		              cst_planned = "planned",
		              cst_platform = "platform",
		              cst_popularity = "popularity",
		              cst_position = "position",
		              cst_postpone = "postpone",
		              cst_pound = "pound",
		              cst_premium = "premium",
		              cst_previous_and_current_block =
		                "previous and current blocks are unequal",
		              cst_primary = "primary",
		              cst_print = "print",
		              cst_priority = "priority",
		              cst_private = "private",
		              cst_pro = "pro",
		              cst_processing = "processing",
		              cst_prod = "prod",
		              cst_production = "production",
		              cst_programmatic_tool_calling = "programmatic_tool_calling",
		              cst_projects = "projects",
		              cst_promoted_words = "promoted_words",
		              cst_prompt_tokens_details = "prompt_tokens_details",
		              cst_properties = "properties",
		              cst_property = "property",
		              cst_provider = "provider",
		              cst_ps = "ps",
		              cst_public = "public",
		              cst_punct = "punct",
		              cst_purple = "purple",
		              cst_purple_background = "purple_background",
		              cst_push = "push",
		              cst_push_operation = "push operation",
		              cst_pushed = "pushed",
		              cst_quarter = "quarter",
		              cst_query = "query",
		              cst_question = "question",
		              cst_range = "range",
		              cst_raw = "raw",
		              cst_rc = "rc",
		              cst_rd = "rd",
		              cst_reactions = "reactions",
		              cst_read = "read",
		              cst_read_write_per_field = "read-write-per-field",
		              cst_readOnly = "readOnly",
		              cst_read_only = "read_only",
		              cst_read_write = "read_write",
		              cst_reader = "reader",
		              cst_reader_writer = "reader-writer",
		              cst_reason = "reason",
		              cst_reasoning = "reasoning",
		              cst_rebind_hotkeys = "rebind hotkeys",
		              cst_receive_RPC = "receive RPC",
		              cst_receivedTime = "receivedTime",
		              cst_record = "record",
		              cst_recurrences = "recurrences",
		              cst_recurrent = "recurrent",
		              cst_recurrent_event_not_found = "recurrent event not found: ",
		              cst_recurrent_event_not_found_ = "recurrent event not found: %a",
		              cst_recurrent_task_occurrences =
		                "recurrent task occurrences not correctly updated",
		              cst_red = "red",
		              cst_red_background = "red_background",
		              cst_reference = "reference",
		              cst_references = "references",
		              cst_refusing_to_delete_integra =
		                "refusing to delete integration task",
		              cst_rejected = "rejected",
		              cst_relation = "relation",
		              cst_reminders = "reminders",
		              cst_rename = "rename",
		              cst_reopened = "reopened",
		              cst_replace = "replace",
		              cst_replica = "replica",
		              cst_resize = "resize",
		              cst_resolved = "resolved",
		              cst_response_status = "response_status",
		              cst_restricted_resource = "restricted_resource",
		              cst_resume_expected = "resume: expected ",
		              cst_resume_expected_d_answer_l =
		                "resume: expected %d answer lists (one per question), got %d",
		              cst_rhs = "rhs",
		              cst_rich = "rich",
		              cst_rich_text_parse_error = "rich text parse error: ",
		              cst_rich_text_parse_error_s = "rich text parse error: %s",
		              cst_role = "role",
		              cst_rollup = "rollup",
		              cst_routine_co = "routine.co",
		              cst_row = "row",
		              cst_row_schema = "row_schema",
		              cst_rows = "rows",
		              cst_rpc = "rpc ",
		              cst_rpc_S_invalid_argument_S_a =
		                "rpc %S: invalid argument %S: %a",
		              cst_ruble = "ruble",
		              cst_rule = "rule",
		              cst_run = "run",
		              cst_runtime = "runtime",
		              cst_runtime_ppx_module_timer_r =
		                "runtime/ppx_module_timer_runtime.ml",
		              cst_rupee = "rupee",
		              cst_s$0 = "s",
		              cst_satisfy = "satisfy: ",
		              cst_satisfy_C = "satisfy: %C",
		              cst_schedule = "schedule",
		              cst_scheduled = "scheduled",
		              cst_scheduling = "scheduling",
		              cst_schema$0 = "schema",
		              cst_schema = "schema:",
		              cst_search_input = "search_input",
		              cst_search_result = "search_result",
		              cst_second = "second",
		              cst_secondary = "secondary",
		              cst_seconds = "seconds",
		              cst_secret = "secret",
		              cst_send_RPC = "send RPC",
		              cst_separator = "separator",
		              cst_server = "server",
		              cst_set_home = "set_home",
		              cst_set_reference = "set_reference",
		              cst_set_role = "set_role",
		              cst_set_will_attend = "set_will_attend",
		              cst_show = "show",
		              cst_show_original = "show_original",
		              cst_show_unique = "show_unique",
		              cst_si = "si",
		              cst_sip = "sip",
		              cst_size = "size",
		              cst_slack = "slack",
		              cst_slots = "slots",
		              cst_sort = "sort",
		              cst_sources = "sources",
		              cst_space = "space",
		              cst_space_overhead = "space_overhead",
		              cst_span = "span",
		              cst_src_adjust_heights_heap_ml = "src/adjust_heights_heap.ml",
		              cst_src_array_ml = "src/array.ml",
		              cst_src_automaton_state_intf_m = "src/automaton_state_intf.ml",
		              cst_src_avltree_ml = "src/avltree.ml",
		              cst_src_core_lwt_ml = "src/core/lwt.ml",
		              cst_src_exn_ml = "src/exn.ml",
		              cst_src_expert_ml = "src/expert.ml",
		              cst_src_float0_ml = "src/float0.ml",
		              cst_src_generator_ml = "src/generator.ml",
		              cst_src_internal_observer_ml = "src/internal_observer.ml",
		              cst_src_list_ml = "src/list.ml",
		              cst_src_map_ml = "src/map.ml",
		              cst_src_node_ml = "src/node.ml",
		              cst_src_pre_sexp_ml = "src/pre_sexp.ml",
		              cst_src_set_ml = "src/set.ml",
		              cst_src_sexp_conv_ml = "src/sexp_conv.ml",
		              cst_src_splittable_random_ml = "src/splittable_random.ml",
		              cst_src_state_ml = "src/state.ml",
		              cst_src_string_ml = "src/string.ml",
		              cst_src_types_ml = "src/types.ml",
		              cst_src_uutf_ml = "src/uutf.ml",
		              cst_st = "st",
		              cst_stable = "stable",
		              cst_stack_limit = "stack_limit",
		              cst_stack_size = "stack_size",
		              cst_stacktrace = "stacktrace",
		              cst_standard = "standard",
		              cst_starred = "starred",
		              cst_start_pushing_operations = "start pushing operations",
		              cst_started_at = "started_at",
		              cst_starts_with = "starts_with",
		              cst_state_reason = "state_reason",
		              cst_static = "static",
		              cst_status = "status",
		              cst_status_changed_at = "status_changed_at",
		              cst_step_results = "step_results",
		              cst_steps = "steps",
		              cst_stop = "stop",
		              cst_stored = "stored",
		              cst_stream = "stream",
		              cst_string = "string",
		              cst_style = "style",
		              cst_submitted = "submitted",
		              cst_subscription = "subscription",
		              cst_success = "success",
		              cst_sum = "sum",
		              cst_summary = "summary",
		              cst_surrogate = "surrogate",
		              cst_synchronized = "synchronized",
		              cst_synchronizing = "synchronizing",
		              cst_system = "system",
		              cst_t = "t",
		              cst_tab = "tab",
		              cst_table = "table",
		              cst_table_not_found_while_clea =
		                "table not found while clearing rows",
		              cst_table_cell_permission = "table-cell-permission",
		              cst_table_workspace_id = "table-workspace-id",
		              cst_table_id = "table_id",
		              cst_table_ref = "table_ref",
		              cst_target = "target",
		              cst_task_id_already_present_in =
		                "task id already present in block, updating instead of appending block",
		              cst_task_binding = "task-binding",
		              cst_task_binding_settings = "task-binding-settings",
		              cst_task_binding_status_mappin = "task-binding-status-mapping",
		              cst_task_binding_status_values = "task-binding-status-values",
		              cst_task_bindings = "task-bindings",
		              cst_task_rec = "task-rec",
		              cst_task_add = "task_add",
		              cst_task_archive = "task_archive",
		              cst_td = "td",
		              cst_team = "team",
		              cst_teams = "teams",
		              cst_templatable = "templatable",
		              cst_tentative = "tentative",
		              cst_text = "text",
		              cst_th = "th",
		              cst_the = "the ",
		              cst_then = "then",
		              cst_then$0 = "then_",
		              cst_thumbnail = "thumbnail",
		              cst_ticktick = "ticktick",
		              cst_time = "time",
		              cst_timed = "timed",
		              cst_timedesc_date_time_utils_m = "timedesc/date_time_utils.ml",
		              cst_timedesc_time_zone_ml = "timedesc/time_zone.ml",
		              cst_timeline = "timeline ",
		              cst_timeline_a = "timeline %a",
		              cst_timestamp = "timestamp",
		              cst_timestamp_out_of_bounds = "timestamp out of bounds",
		              cst_timing_wheel_src_timing_wh =
		                "timing_wheel/src/timing_wheel.ml",
		              cst_timmy_lib_src_date_ml = "timmy/lib/src/date.ml",
		              cst_title_of_the_task = "title of the task",
		              cst_title_field = "title_field",
		              cst_to$0 = "to",
		              cst_today = "today",
		              cst_todo = "todo",
		              cst_todo_block = "todo-block",
		              cst_todoist = "todoist",
		              cst_toggle = "toggle",
		              cst_toggle_append = "toggle: append",
		              cst_toggle_remove = "toggle: remove",
		              cst_token_revoked = "token_revoked",
		              cst_token_type = "token_type",
		              cst_tokeninfo = "tokeninfo",
		              cst_tomorrow = "tomorrow",
		              cst_too_few_arguments = "too few arguments",
		              cst_too_many_arguments = "too many arguments",
		              cst_tool_calls = "tool_calls",
		              cst_tool_search = "tool_search",
		              cst_top_heap_words = "top_heap_words",
		              cst_total = "total",
		              cst_touched_last = "touched_last",
		              cst_tr = "tr",
		              cst_transfer_encoding = "transfer-encoding",
		              cst_transparency = "transparency",
		              cst_transparent = "transparent",
		              cst_trello = "trello",
		              cst_trialing = "trialing",
		              cst_trigger = "trigger",
		              cst_true_if_the_task_has_been_ =
		                "true if the task has been completed",
		              cst_tuple_have_different_sizes = "tuple have different sizes",
		              cst_tuple_pool_src_tuple_pool_ = "tuple_pool/src/tuple_pool.ml",
		              cst_type = "type",
		              cst_u$0 = "u",
		              cst_unable_to_fetch = "unable to fetch ",
		              cst_unable_to_fetch_a_a = "unable to fetch %a: %a",
		              cst_unarchive = "unarchive ",
		              cst_unarchive_a = "unarchive %a",
		              cst_unarchived$0 = "unarchived",
		              cst_unassigned = "unassigned",
		              cst_unauthorized = "unauthorized",
		              cst_unbind_hotkeys = "unbind hotkeys",
		              cst_unchecked = "unchecked",
		              cst_uncollectible = "uncollectible",
		              cst_unexpected = "unexpected ",
		              cst_unexpected_a = "unexpected %a",
		              cst_unexpected_status = "unexpected status ",
		              cst_unexpected_status_s_queryi =
		                "unexpected status %s querying %a",
		              cst_unexpected_status$0 = "unexpected_status",
		              cst_unify_case = "unify case",
		              cst_unify_case_a_a = "unify case%a %a",
		              cst_uninvite = "uninvite",
		              cst_unknown = "unknown",
		              cst_unordered = "unordered",
		              cst_unpaid = "unpaid",
		              cst_unrecognized_symbol = "unrecognized symbol",
		              cst_unviewed = "unviewed",
		              cst_update$0 = "update ",
		              cst_update_a = "update %a",
		              cst_update_record_failed = "update_record_failed",
		              cst_updated = "updated",
		              cst_upper = "upper",
		              cst_upper_bound = "upper_bound",
		              cst_upsert = "upsert",
		              cst_uri = "uri",
		              cst_url = "url",
		              cst_url_citation = "url_citation",
		              cst_us = "us",
		              cst_usage = "usage",
		              cst_user = "user",
		              cst_user_cancelled_the_action = "user cancelled the action",
		              cst_user_defined = "user_defined",
		              cst_user_preferences = "user_preferences",
		              cst_userinfo = "userinfo",
		              cst_v_hotkey_handler_returned_ =
		                "v-hotkey handler returned an unrecognized value",
		              cst_val = "val_",
		              cst_val_d = "val_%d",
		              cst_validation = "validation",
		              cst_validation_error = "validation_error",
		              cst_values = "values",
		              cst_verbose = "verbose",
		              cst_version = "version",
		              cst_video = "video",
		              cst_view = "view",
		              cst_view_filter_atom_collectio =
		                "view-filter-atom-collection-match-kind",
		              cst_virtual = "virtual",
		              cst_visibility = "visibility",
		              cst_visible = "visible",
		              cst_void = "void",
		              cst_waiting_for_CRDT_replica_t =
		                "waiting for CRDT replica to be writable",
		              cst_warning = "warning",
		              cst_watch = "watch",
		              cst_web = "web",
		              cst_web_search = "web_search",
		              cst_website = "website",
		              cst_week = "week",
		              cst_week$0 = "week ",
		              cst_week_start = "week_start",
		              cst_weekday = "weekday",
		              cst_weekdays = "weekdays",
		              cst_weekly = "weekly",
		              cst_weeks = "weeks",
		              cst_weight = "weight",
		              cst_whatsapp = "whatsapp",
		              cst_where = "where",
		              cst_whereby = "whereby",
		              cst_win = "win",
		              cst_window_size = "window_size",
		              cst_windows = "windows",
		              cst_with_all_day = "with-all-day",
		              cst_with_optional_union_key = "with_optional_union_key",
		              cst_without_all_day = "without-all-day",
		              cst_won = "won",
		              cst_word = "word",
		              cst_workday = "workday",
		              cst_workingLocation = "workingLocation",
		              cst_working_memory = "working_memory",
		              cst_workspace$0 = "workspace ",
		              cst_workspace_a_found_in_multi =
		                "workspace %a found in multiple organizations %a and %a",
		              cst_workspace_a_not_found_igno =
		                "workspace %a not found, ignoring %s",
		              cst_workspace_cookie_mismatch = "workspace cookie mismatch",
		              cst_workspace_cookie_mismatch_ =
		                "workspace cookie mismatch, cloning from scratch",
		              cst_workspace_create = "workspace-create",
		              cst_workspace_homepage_menu_ta =
		                "workspace-homepage-menu-target",
		              cst_workspace_member = "workspace-member",
		              cst_workspace_member_add = "workspace-member-add",
		              cst_workspace_member_remove = "workspace-member-remove",
		              cst_workspace_member_role = "workspace-member-role",
		              cst_workspace_member_set_role = "workspace-member-set-role",
		              cst_workspace_remove = "workspace-remove",
		              cst_workspace_rename = "workspace-rename",
		              cst_workspace_ref = "workspace_ref",
		              cst_writable = "writable",
		              cst_write = "write",
		              cst_writer = "writer",
		              cst_wrong_binding_type = "wrong binding type: ",
		              cst_wrong_binding_type_a_inste =
		                "wrong binding type: %a instead of %a",
		              cst_ws = "ws",
		              cst_wss = "wss",
		              cst_www_authenticate = "www-authenticate",
		              cst_x64 = "x64",
		              cst_xdigit = "xdigit",
		              cst_xhigh = "xhigh",
		              cst_year = "year",
		              cst_yearly = "yearly",
		              cst_years = "years",
		              cst_yellow = "yellow",
		              cst_yellow_background = "yellow_background",
		              cst_yen = "yen",
		              cst_yes = "yes",
		              cst_yesterday = "yesterday",
		              cst_yuan = "yuan",
		              cst_zapier = "zapier",
		              cst_zero = "zero",
		              cst_zoom = "zoom",
		              cst$12 = "{",
		              cst$43 = "{ ",
		              cst$11 = "}",
		              cst$53 = "~",
		              cst$60 = "~~",
		              bl = caml_int64_create_lo_mi_hi(1, 0, 0),
		              min_value = caml_int64_create_lo_mi_hi(0, 0, 0),
		              one = caml_int64_create_lo_mi_hi(1, 0, 0),
		              minus_one =
		                caml_int64_create_lo_mi_hi(16777215, 16777215, 65535),
		              min_int64 = caml_int64_create_lo_mi_hi(0, 0, 32768),
		              draw_maximum =
		                caml_int64_create_lo_mi_hi(16777215, 16777215, 32767),
		              res0_003 = [0, "<fun>"],
		              bp =
		                [0,
		                 [11,
		                  "conversion from ",
		                  [2,
		                   0,
		                   [11,
		                    cst_to,
		                    [2,
		                     0,
		                     [11, " failed: ", [2, 0, [11, cst_is_out_of_range, 0]]]]]]],
		                 "conversion from %s to %s failed: %s is out of range"],
		              all = [0, 0, [0, 1, 0]],
		              init$0 = [0, 0, 0],
		              w = caml_int64_create_lo_mi_hi(2, 0, 0),
		              mask = caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
		              all$0 = [0, 0, [0, 1, [0, 2, [0, 3, [0, 4, 0]]]]],
		              fmt$2 = [0, [15, 0], cst_a],
		              acc = caml_int64_create_lo_mi_hi(0, 0, 0),
		              bq =
		                caml_list_of_js_array
		                 ([498443355, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57]),
		              ps_count_in_ps = caml_int64_create_lo_mi_hi(1, 0, 0),
		              ps_count_in_ns = caml_int64_create_lo_mi_hi(1000, 0, 0),
		              ps_count_in_100ns = caml_int64_create_lo_mi_hi(100000, 0, 0),
		              ps_count_in_us = caml_int64_create_lo_mi_hi(1000000, 0, 0),
		              ps_count_in_100us = caml_int64_create_lo_mi_hi(16113920, 5, 0),
		              ps_count_in_ms = caml_int64_create_lo_mi_hi(10144256, 59, 0),
		              ps_count_in_100ms = caml_int64_create_lo_mi_hi(7792640, 5960, 0),
		              ps_count_in_s = caml_int64_create_lo_mi_hi(10817536, 59604, 0),
		              ps_count_in_min =
		                caml_int64_create_lo_mi_hi(11517952, 3576278, 0),
		              ps_count_in_hour =
		                caml_int64_create_lo_mi_hi(3211264, 13250129, 12),
		              ps_count_in_day =
		                caml_int64_create_lo_mi_hi(9961472, 16013212, 306),
		              ps_day_max = caml_int64_create_lo_mi_hi(9961471, 16013212, 306),
		              epoch = [0, 0, caml_int64_create_lo_mi_hi(0, 0, 0)],
		              fmt$3 =
		                [0,
		                 [15, [11, " encoded but expected ", [2, 0, 0]]],
		                 "%a encoded but expected %s"],
		              br = [0, cst$1],
		              fmt$5 =
		                [0,
		                 [11,
		                  "inline field ",
		                  [3, 0, [11, " is not an object: ", [15, 0]]]],
		                 "inline field %S is not an object: %a"],
		              fmt$4 =
		                [0,
		                 [11, "inline field is not an object: ", [15, 0]],
		                 "inline field is not an object: %a"],
		              fmt$6 =
		                [0,
		                 [2, 0, [12, 45, [2, 0, [11, "-result", 0]]]],
		                 "%s-%s-result"],
		              id$0 = [0, cst_either],
		              id$1 = [0, cst_uri],
		              fmt$8 =
		                [0,
		                 [11, cst_invalid_semantic_version, [2, 0, 0]],
		                 "invalid semantic version: %s"],
		              fmt$7 =
		                [0,
		                 [11, cst_invalid_semantic_version, [3, 0, 0]],
		                 "invalid semantic version: %S"],
		              fmt$11 =
		                [0,
		                 [11, "unmatched variant case in schema ", [15, 0]],
		                 "unmatched variant case in schema %a"],
		              fmt$10 =
		                [0,
		                 [2, 0, [11, " encoder cannot encode ", [2, 0, 0]]],
		                 "%s encoder cannot encode %s"],
		              fmt$9 =
		                [0,
		                 [11, cst_expected$0, [2, 0, [11, cst_got, [2, 0, 0]]]],
		                 cst_expected_s_got_s],
		              fmt$13 = [0, [11, cst_unexpected, [15, 0]], cst_unexpected_a],
		              fmt$14 = [0, [11, cst_unexpected, [15, 0]], cst_unexpected_a],
		              fmt$15 = [0, [11, cst_unexpected, [15, 0]], cst_unexpected_a],
		              fmt$16 = [0, [15, 0], cst_a],
		              x = [0, cst_missing_timezone],
		              fmt$12 = [0, [15, 0], cst_a],
		              type = [0, 1, 0],
		              type$0 = [0, 4, 0],
		              type$2 = [0, 6, 0],
		              type$3 = [0, 6, 0],
		              type$4 = [0, 6, 0],
		              type$5 = [0, 5, 0],
		              type$6 = [0, 5, 0],
		              type$7 = [0, 6, 0],
		              type$8 = [0, 0, 0],
		              type$1 = [0, 2, 0],
		              type$9 = [0, 0, 0],
		              format$0 =
		                [0,
		                 [11, "invalid seconds: ", [4, 3, 0, 0, 0]],
		                 "invalid seconds: %i"],
		              format$1 =
		                [0,
		                 [11, "invalid minutes: ", [4, 3, 0, 0, 0]],
		                 "invalid minutes: %i"],
		              format$2 =
		                [0,
		                 [11, "invalid hours: ", [4, 3, 0, 0, 0]],
		                 "invalid hours: %i"],
		              fmt$17 =
		                [0, [11, cst_invalid_date, [15, 0]], cst_invalid_date_a],
		              format =
		                [0,
		                 [11, cst_invalid_month, [4, 3, 0, 0, 0]],
		                 "invalid month: %i"],
		              id$7 = [0, cst_weekday],
		              id$6 = [0, cst_week],
		              fmt$19 =
		                [0,
		                 [11, cst_timestamp_out_of_bounds, 0],
		                 cst_timestamp_out_of_bounds],
		              fmt$18 =
		                [0,
		                 [11, "timestamp out of bounds: ", [4, 0, 0, 0, 0]],
		                 "timestamp out of bounds: %d"],
		              id$5 = [0, cst_timestamp],
		              q = [0, cst_span],
		              id$4 = [0, cst_month],
		              id$3 = [0, cst_daytime],
		              id$2 = [0, cst_date],
		              fmt$20 = [0, [15, 0], cst_a],
		              pico = caml_int64_create_lo_mi_hi(10817536, 59604, 0),
		              fmt$21 =
		                [0,
		                 [11,
		                  cst_UTC,
		                  [0, [4, 0, [0, 2, 2], 0, [12, 58, [4, 0, [0, 2, 2], 0, 0]]]]],
		                 cst_UTC_c_02d_02d],
		              fmt$22 =
		                [0, [11, cst_invalid_date, [15, 0]], cst_invalid_date_a],
		              fmt$23 =
		                [0, [11, cst_invalid_date, [2, 0, 0]], cst_invalid_date_s],
		              format$3 =
		                [0,
		                 [11, cst_invalid, [2, 0, [11, cst$9, [2, 0, 0]]]],
		                 "invalid %s: %s"],
		              format$8 =
		                [0,
		                 [11, "invalid number in date: ", [3, 0, 0]],
		                 "invalid number in date: %S"],
		              format$7 =
		                [0,
		                 [11, "invalid date format: ", [3, 0, 0]],
		                 "invalid date format: %S"],
		              format$6 =
		                [0,
		                 [11, cst_week$0, [4, 3, 0, 0, [11, " is less than 1", 0]]],
		                 "week %i is less than 1"],
		              format$4 =
		                [0,
		                 [11,
		                  cst_week$0,
		                  [4, 3, 0, 0, [11, " is greater than 53", 0]]],
		                 "week %i is greater than 53"],
		              format$5 =
		                [0,
		                 [11, "year ", [4, 3, 0, 0, [11, " has no week 53", 0]]],
		                 "year %i has no week 53"],
		              fmt$24 =
		                [0,
		                 [11,
		                  "invalid datetime / timezone offset: ",
		                  [15, [12, 32, [15, [11, cst$40, [4, 0, 0, 0, 0]]]]]],
		                 "invalid datetime / timezone offset: %a %a / %d"],
		              fmt$25 =
		                [0,
		                 [11,
		                  "invalid datetime in timezone ",
		                  [15, [11, cst$9, [15, [12, 32, [15, 0]]]]]],
		                 "invalid datetime in timezone %a: %a %a"],
		              latest = [0, 23, 59, 59],
		              midnight = [0, 0, 0, 0],
		              noon = [0, 12, 0, 0],
		              dummy_int64 = caml_int64_create_lo_mi_hi(1, 0, 0),
		              init$1 = [0, 0],
		              fmt$29 = [0, [15, [11, cst_set, 0]], "%aset"],
		              fmt$28 =
		                [0,
		                 [11, "duplicate key in map: ", [15, 0]],
		                 "duplicate key in map: %a"],
		              fmt$27 = [0, [15, [11, "dictionary", 0]], "%adictionary"],
		              format$10 =
		                [0, [11, cst_duplicate_key, [15, 0]], cst_duplicate_key_a],
		              fmt$26 = [0, [15, [15, [11, cst_map, 0]]], cst_a_amap],
		              format$9 =
		                [0, [11, cst_duplicate_key, [15, 0]], cst_duplicate_key_a],
		              pub_meths =
		                [0,
		                 cst_blocked,
		                 cst_close,
		                 cst_push,
		                 cst_count,
		                 cst_size,
		                 cst_set_reference,
		                 cst_resize,
		                 cst_closed],
		              vals = [0, cst_closed],
		              shared =
		                [0,
		                 cst_size,
		                 cst_set_reference,
		                 cst_resize,
		                 cst_push,
		                 cst_count,
		                 cst_closed,
		                 cst_close,
		                 cst_blocked],
		              empty = [0, 0],
		              max$1 = [0, 31],
		              min$1 = [0, 1],
		              fmt$32 =
		                [0,
		                 [11,
		                  "Invalid unicode character at position ",
		                  [4, 0, 0, 0, [11, " in '", [2, 0, [12, 39, 0]]]]],
		                 "Invalid unicode character at position %d in '%s'"],
		              fmt$31 =
		                [0,
		                 [11,
		                  cst_expected_one_of,
		                  [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]],
		                 cst_expected_one_of_a],
		              init$2 = [0, 0, 0],
		              fmt$30 =
		                [0,
		                 [11,
		                  cst_expected_one_of,
		                  [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]],
		                 cst_expected_one_of_a],
		              fmt$33 = [0, [2, 0, [12, 64, [2, 0, 0]]], cst_s_s],
		              common_domains =
		                [0,
		                 "gmail.com",
		                 [0,
		                  "outlook.com",
		                  [0, "yahoo.com", [0, "icloud.com", [0, "hotmail.com", 0]]]]],
		              fmt$47 =
		                [0,
		                 [11,
		                  "this parser cannot fail at ",
		                  [4, 3, 0, 0, [11, cst$9, [15, [11, cst$9, [2, 0, 0]]]]]],
		                 "this parser cannot fail at %i: %a: %s"],
		              fmt$46 = [0, [4, 3, [0, 2, 4], 0, 0], cst_04i],
		              fmt$43 = [0, [15, 0], cst_a],
		              fmt$44 =
		                [0,
		                 [15, [11, " 1st ", [4, 3, [0, 2, 4], 0, 0]]],
		                 "%a 1st %04i"],
		              fmt$45 =
		                [0,
		                 [11, "January 1st ", [4, 3, [0, 2, 4], 0, 0]],
		                 "January 1st %04i"],
		              fmt$42 = [0, [15, 0], cst_a],
		              fmt$40 = [0, [12, 32, [15, 0]], " %a"],
		              fmt$41 =
		                [0, [11, cst_of$0, [15, [12, 32, [15, 0]]]], " of %a %a"],
		              fmt$39 = [0, [15, 0], cst_a],
		              fmt$38 =
		                [0,
		                 [11,
		                  cst_invalid_date$1,
		                  [4,
		                   0,
		                   [0, 2, 4],
		                   0,
		                   [12,
		                    45,
		                    [4,
		                     0,
		                     [0, 2, 2],
		                     0,
		                     [12, 45, [4, 0, [0, 2, 2], 0, [11, cst$9, [2, 0, 0]]]]]]]],
		                 "invalid date %04d-%02d-%02d: %s"],
		              fmt$37 = [0, [15, 0], cst_a],
		              fmt$36 = [0, [15, 0], cst_a],
		              fmt$35 = [0, [15, 0], cst_a],
		              fmt$34 =
		                [0,
		                 [11, "invalid daytime: ", [2, 0, 0]],
		                 "invalid daytime: %s"],
		              format$11 =
		                [0,
		                 [11, "multiple ", [2, 0, [11, " specified", 0]]],
		                 "multiple %s specified"],
		              id$8 = [0, cst_mandate_destination],
		              day_names =
		                [0,
		                 [0, cst_Monday, [0, -229282104, 0]],
		                 [0,
		                  [0, cst_Tuesday, [0, -229282104, 1]],
		                  [0,
		                   [0, cst_Wednesday, [0, -229282104, 2]],
		                   [0,
		                    [0, cst_Thursday, [0, -229282104, 3]],
		                    [0,
		                     [0, cst_Friday, [0, -229282104, 4]],
		                     [0,
		                      [0, cst_Saturday, [0, -229282104, 5]],
		                      [0, [0, cst_Sunday, [0, -229282104, 6]], 0]]]]]]],
		              cany = [0, [0, 0, 255], 0],
		              bs = [1, 0],
		              empty_alternative = [0, 0],
		              names =
		                caml_list_of_js_array
		                 ([cst_alpha,
		                   cst_alnum,
		                   cst_ascii,
		                   cst_blank,
		                   cst_cntrl,
		                   cst_digit,
		                   cst_lower,
		                   cst_print,
		                   cst_space,
		                   cst_upper,
		                   cst_word,
		                   cst_punct,
		                   cst_graph,
		                   cst_xdigit]),
		              char_b = [0, 8],
		              char_newline = [0, 10],
		              char_cr = [0, 13],
		              char_tab = [0, 9],
		              fmt$48 =
		                [0,
		                 [11,
		                  "Given date and time ",
		                  [4,
		                   3,
		                   [0, 2, 4],
		                   0,
		                   [12,
		                    45,
		                    [4,
		                     3,
		                     [0, 2, 2],
		                     0,
		                     [12,
		                      45,
		                      [4,
		                       3,
		                       [0, 2, 2],
		                       0,
		                       [11,
		                        cst_at$0,
		                        [4,
		                         3,
		                         [0, 2, 2],
		                         0,
		                         [12,
		                          58,
		                          [4,
		                           3,
		                           [0, 2, 2],
		                           0,
		                           [12, 58, [4, 3, [0, 2, 2], 0, [11, " are not valid", 0]]]]]]]]]]]]],
		                 "Given date and time %04i-%02i-%02i at %02i:%02i:%02i are not valid"],
		              fmt$51 =
		                [0,
		                 [11, "while decoding error body: ", [2, 0, 0]],
		                 "while decoding error body: %s"],
		              fmt$50 = [0, [3, 0, 0], a],
		              status = [0, [0, 748543309, 0]],
		              fmt$49 =
		                [0,
		                 [11, "fatal error in ", [15, [11, " body: ", [15, 0]]]],
		                 "fatal error in %a body: %a"],
		              id$9 = [0, "http-stream"],
		              format$12 =
		                [0,
		                 [11, "invalid empty ", [2, 0, [11, " id", 0]]],
		                 "invalid empty %s id"],
		              bt = [0, cst_datetime],
		              id$10 = [0, "google-date"],
		              id$11 = [0, "person-date"],
		              id$12 = [0, cst_datetime],
		              fmt$52 =
		                [0,
		                 [11, "cannot decode `", [2, 0, [11, "` ", [2, 0, 0]]]],
		                 "cannot decode `%s` %s"],
		              id$13 = [0, "google-oauth-scope"],
		              format$13 =
		                [0,
		                 [11, "invalid Google scope: ", [2, 0, 0]],
		                 "invalid Google scope: %s"],
		              E = [0, 0, 0, [9, cst_https_www_googleapis_com_a$31], 0],
		              F = [0, 0, 0, [9, cst_https_www_googleapis_com_a$30], 0],
		              G = [0, 0, 0, [9, cst_https_www_googleapis_com_a$29], 0],
		              H = [0, 0, 0, [9, cst_https_www_googleapis_com_a$28], 0],
		              I = [0, 0, 0, [9, cst_https_www_googleapis_com_a$27], 0],
		              J = [0, 0, 0, [9, cst_https_www_googleapis_com_a$26], 0],
		              K = [0, 0, 0, [9, cst_https_www_googleapis_com_a$25], 0],
		              L = [0, 0, 0, [9, cst_https_www_googleapis_com_a$24], 0],
		              M = [0, 0, 0, [9, cst_https_www_googleapis_com_a$23], 0],
		              N = [0, 0, 0, [9, cst_User_addresses_read], 0],
		              O = [0, 0, 0, [9, cst_profile], 0],
		              P = [0, 0, 0, [9, cst_openid], 0],
		              Q = [0, 0, 0, [9, cst_email], 0],
		              R = [0, 0, 0, [9, cst_https_www_googleapis_com_a$17], 0],
		              S = [0, 0, 0, [9, cst_https_www_googleapis_com_a$16], 0],
		              T = [0, 0, 0, [9, cst_https_www_googleapis_com_a$15], 0],
		              U = [0, 0, 0, [9, cst_https_www_googleapis_com_a$14], 0],
		              V = [0, 0, 0, [9, cst_https_www_googleapis_com_a$13], 0],
		              W = [0, 0, 0, [9, cst_https_www_googleapis_com_a$12], 0],
		              X = [0, 0, 0, [9, cst_https_www_googleapis_com_a$11], 0],
		              Y = [0, 0, 0, [9, cst_https_www_googleapis_com_a$10], 0],
		              Z = [0, 0, 0, [9, cst_https_www_googleapis_com_a$9], 0],
		              _ = [0, 0, 0, [9, cst_https_www_googleapis_com_a$8], 0],
		              $ = [0, 0, 0, [9, cst_https_www_googleapis_com_a$7], 0],
		              aa = [0, 0, 0, [9, cst_https_www_googleapis_com_a$6], 0],
		              ab = [0, 0, 0, [9, cst_https_www_googleapis_com_a$5], 0],
		              ac = [0, 0, 0, [9, cst_https_www_googleapis_com_a$4], 0],
		              ad = [0, 0, 0, [9, cst_https_www_googleapis_com_a$3], 0],
		              ae = [0, 0, 0, [9, cst_https_www_googleapis_com_a$2], 0],
		              af = [0, 0, 0, [9, cst_https_www_googleapis_com_a$1], 0],
		              ag = [0, 0, 0, [9, cst_https_www_googleapis_com_a$0], 0],
		              ah = [0, 0, 0, [9, cst_https_www_googleapis_com_a], 0],
		              id$14 = [0, cst_uri],
		              fmt$53 =
		                [0, [11, "invalid uuid: ", [3, 0, 0]], "invalid uuid: %S"],
		              id$15 = [0, "uuid"],
		              id$16 = [0, "DateOrTime"],
		              id$17 = [0, "property_id"],
		              id$18 = [0, "notion-user"],
		              bu = [0, cst_checkbox],
		              bv = [0, cst_email],
		              bw = [0, cst_number],
		              bx = [0, cst_phone],
		              B = [1, "contains filter has multiple fields"],
		              by = [0, 0],
		              bz = [0, 1],
		              bA = [0, 0, 0, [0, 1], 0],
		              ai = [0, "openai-response-id"],
		              all$1 =
		                caml_list_of_js_array
		                 ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
		              unit = [1, 0],
		              x$0 = [0, cst_missing_timezone],
		              fmt$54 = [0, [15, 0], cst_a],
		              none$0 = [0, 0, -1],
		              fmt$55 =
		                [0,
		                 [11, "Object ", [15, [11, " can't be compared", 0]]],
		                 "Object %a can't be compared"],
		              name = [0, cst_none],
		              name$0 = [0, "some"],
		              name$1 = [0, cst_second],
		              name$2 = [0, cst_first],
		              string$0 = [8, 0],
		              false$ = [0, 0, 0],
		              true$ = [0, 0, 1],
		              fmt$58 =
		                [0,
		                 [15, [11, " has no literal syntax", 0]],
		                 "%a has no literal syntax"],
		              fmt$57 = [0, [15, 0], cst_a],
		              format$14 =
		                [0, [11, cst_duplicate_key$0, 0], cst_duplicate_key$0],
		              fmt$56 = [0, [15, [15, [11, cst_map, 0]]], cst_a_amap],
		              fmt$60 =
		                [0,
		                 [11,
		                  "wrong field type for ",
		                  [3, 0, [11, cst$9, [15, [11, cst_instead_of, [15, 0]]]]]],
		                 "wrong field type for %S: %a instead of %a"],
		              fmt$59 =
		                [0,
		                 [11,
		                  "Unable to compare record fields of type ",
		                  [15, [11, cst$9, [2, 0, 0]]]],
		                 "Unable to compare record fields of type %a: %s"],
		              fmt$61 =
		                [0,
		                 [11,
		                  cst_wrong_binding_type,
		                  [15, [11, cst_instead_of, [15, 0]]]],
		                 cst_wrong_binding_type_a_inste],
		              fmt$62 =
		                [0,
		                 [11, "missing pure binding ", [15, 0]],
		                 "missing pure binding %a"],
		              fmt$63 =
		                [0,
		                 [11,
		                  cst_wrong_binding_type,
		                  [15, [11, cst_instead_of, [15, 0]]]],
		                 cst_wrong_binding_type_a_inste],
		              fmt$64 =
		                [0,
		                 [11, "missing monadic binding ", [15, 0]],
		                 "missing monadic binding %a"],
		              v$0 = [0, 0],
		              v = [1, 0],
		              ocaml_lex_tables =
		                [0,
		                 '\0\0\xba\xff\xbb\xff\x01\0\x03\0R\0\xbe\xff\xbf\xff\x9f\0\xc2\xff\xc3\xff\xc4\xff\xc5\xff\xc6\xff\xc7\xff\xc8\xff\xc9\xff\xca\xff\x02\0\x03\0\xd0\xff\xa9\0\xb9\0\xd4\xff\xd5\xff\xd6\xff\xd7\xff\x1f\0\xc6\0\x14\x01b\x01\xb0\x01\xfe\x01L\x02\x9a\x02\xe8\x026\x03\x84\x03\xd2\x03 \x04n\x04\xbc\x04\n\x05X\x05\xa6\x05\xf4\x05B\x06\x90\x06\xde\x06,\x07z\x07\xc8\x07\x16\bd\b\xb2\b\0\tN\t\x9c\t\xea\t8\n\x86\n\xd4\n"\vp\v\xbe\v\f\fZ\f\xa8\f\xf6\fD\r\x92\r\xe0\r.\x0e|\x0e\xca\x0e\x18\x0ff\x0f\xb4\x0f\x02\x10P\x10\x9e\x10\xec\x10:\x11\x88\x11\xd6\x11$\x12r\x12\xc0\x12\x0e\x13\\\x13\xaa\x13\xf8\x13F\x14\x94\x14\xe2\x140\x15~\x15\xcc\x15\x1a\x16h\x16\xb6\x16\x04\x17R\x17\xa0\x17\xee\x17<\x18\x8a\x18\xd8\x18&\x19t\x19\xc2\x19\x10\x1a^\x1a\xac\x1a\xfa\x1aH\x1b\x96\x1b\xe4\x1b2\x1c\x80\x1c\xce\x1c\x1c\x1dj\x1d\xb8\x1d\x06\x1eT\x1e\xa2\x1e\xf0\x1e>\x1f\x8c\x1f\xda\x1f( v \xc4 \x12!`!\xcb\xff\xab!\xb7!\xc1!\xd2\xff\xce\xff\xcc\xff\xcb!\xbf!\xfd\xff\x01\0\xff\xff\xfe\xff\x02\0\xfc\xff!\0\xff\xff\xfd\xff\xfe\xff',
		                 "\xff\xff\xff\xff\xff\xffD\0C\0B\0\xff\xff\xff\xff>\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff2\x000\0\xff\xff.\0,\0\xff\xff\xff\xff\xff\xff\xff\xff'\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0\0\0\x17\0\x01\0\x02\0\x03\0B\0B\0\x04\0\x06\0\x05\0B\0B\0B\0B\0\x07\0B\0\b\0B\0B\0B\0B\0\t\0\n\0B\0B\0B\0\v\0\f\0B\0B\0\x1d\0\x1e\0B\0B\0\x1f\0 \0B\0B\0\r\0\x0e\0B\0B\0\x0f\0B\0B\0B\0B\0\x10\0B\0B\0B\0\x12\0B\0B\0B\0\x11\0B\0B\0!\0\"\0B\0\x16\0B\0B\0B\0\x13\0B\0\x14\0B\0B\0B\0B\0\x15\0B\0#\0$\0B\0B\0B\0\x18\0\x19\0\x1a\0B\0B\0\x1b\0\x1c\0B\0B\0%\0&\0\xff\xff\xff\xff>\0?\0\xff\xff\xff\xff\xff\xff?\0\xff\xff\xff\xff\x02\0\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\xff\xff\xff\xff",
		                 "\xff\xff\0\0\0\0\xff\xff\xff\xff\xff\xff\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\0\0\0\0\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\0\0\0\0\0\0\xff\xff\x91\0\0\0\x94\0\0\0\0\0\x96\0\0\0\x99\0\0\0\0\0\0\0",
		                 "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x04\0\x02\0\x02\0\x04\0\x03\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x04\0\x1b\0\x07\0\x04\0\x98\0\0\0\0\0\x06\0\x11\0\x10\0\n\0\x0e\0\x19\0\x16\0\x15\0\r\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\x1a\0\0\0\x12\0\x14\0\x13\0\x8e\0\x8d\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\f\0\x88\0\v\0\x97\0\x05\0\0\0+\0*\0\x05\0\x1e\0)\0\x05\0\x05\0\x1d\0(\0\x05\0\x05\0'\0&\0%\0$\0#\0\x05\0\"\0!\0 \0\x05\0\x05\0\x1f\0\x05\0\x1c\0\x05\0\x18\0\x0f\0\x17\0\t\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x9a\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x8f\0\0\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\0\0\0\0\0\0\0\0\x89\0\x8c\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x01\0\xff\xff\xff\xff\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x84\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x80\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0z\0\x05\0\x05\0\x05\0{\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0r\0\x05\0\x05\0s\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0m\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0l\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0_\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0^\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0Y\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0V\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0U\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0R\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0G\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0F\0\x05\0\x05\0\x05\0\x05\0\x05\0E\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0?\0\x05\0\x05\0\x05\0@\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\x007\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\x006\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\x003\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\x002\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0-\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0,\0\x05\0\x05\0\x05\0\x05\0.\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\x001\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\x000\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0/\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\x004\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\x005\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\x008\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\x009\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0=\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0:\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0;\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0<\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0>\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0D\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0A\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0B\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0C\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0N\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0I\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0H\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0J\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0K\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0L\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0M\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0O\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0P\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0Q\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0S\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0T\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0W\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0X\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0Z\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0[\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\\\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0]\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0j\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0`\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0b\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0a\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0f\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0c\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0d\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0e\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0g\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0h\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0i\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0k\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0p\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0n\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0o\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0q\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0w\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0t\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0u\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0v\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0x\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0y\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0~\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0|\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0}\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x7f\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x81\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x82\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x83\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x85\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x86\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x87\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x89\0\x93\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x92\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",
		                 "\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\x03\0\x04\0\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\0\0\x04\0\x95\0\xff\xff\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\x12\0\x13\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x1b\0\0\0\x95\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\xff\xff\x97\0\xff\xff\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\xff\xff\xff\xff\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\b\0\xff\xff\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\b\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\xff\xff\xff\xff\xff\xff\xff\xff\x16\0\x15\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x1c\0\xff\xff\xff\xff\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\0\0\x92\0\x95\0\xff\xff\xff\xff\xff\xff\xff\xff\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x97\0\xff\xff\xff\xff\xff\xff\x1c\0\xff\xff\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1d\0\xff\xff\xff\xff\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\xff\xff\xff\xff\xff\xff\xff\xff\x1d\0\xff\xff\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1e\0\xff\xff\xff\xff\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\xff\xff\xff\xff\xff\xff\xff\xff\x1e\0\xff\xff\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1f\0\xff\xff\xff\xff\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\xff\xff\xff\xff\xff\xff\xff\xff\x1f\0\xff\xff\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0 \0\xff\xff\xff\xff \0 \0 \0 \0 \0 \0 \0 \0 \0 \0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0\xff\xff\xff\xff\xff\xff\xff\xff \0\xff\xff \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0!\0\xff\xff\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0\xff\xff\xff\xff\xff\xff\xff\xff!\0\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0\"\0\xff\xff\xff\xff\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\xff\xff\xff\xff\xff\xff\xff\xff\"\0\xff\xff\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0\"\0#\0\xff\xff\xff\xff#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0\xff\xff\xff\xff\xff\xff\xff\xff#\0\xff\xff#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0$\0\xff\xff\xff\xff$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0\xff\xff\xff\xff\xff\xff\xff\xff$\0\xff\xff$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0$\0%\0\xff\xff\xff\xff%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0\xff\xff\xff\xff\xff\xff\xff\xff%\0\xff\xff%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0&\0\xff\xff\xff\xff&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0\xff\xff\xff\xff\xff\xff\xff\xff&\0\xff\xff&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0'\0\xff\xff\xff\xff'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\xff\xff\xff\xff\xff\xff\xff\xff'\0\xff\xff'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0(\0\xff\xff\xff\xff(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0\xff\xff\xff\xff\xff\xff\xff\xff(\0\xff\xff(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0)\0\xff\xff\xff\xff)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0\xff\xff\xff\xff\xff\xff\xff\xff)\0\xff\xff)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0*\0\xff\xff\xff\xff*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0\xff\xff\xff\xff\xff\xff\xff\xff*\0\xff\xff*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0+\0\xff\xff\xff\xff+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0\xff\xff\xff\xff\xff\xff\xff\xff+\0\xff\xff+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0,\0\xff\xff\xff\xff,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0\xff\xff\xff\xff\xff\xff\xff\xff,\0\xff\xff,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0-\0\xff\xff\xff\xff-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0\xff\xff\xff\xff\xff\xff\xff\xff-\0\xff\xff-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0.\0\xff\xff\xff\xff.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0\xff\xff\xff\xff\xff\xff\xff\xff.\0\xff\xff.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\0/\0\xff\xff\xff\xff/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0\xff\xff\xff\xff\xff\xff\xff\xff/\0\xff\xff/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\0/\x000\0\xff\xff\xff\xff0\x000\x000\x000\x000\x000\x000\x000\x000\x000\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff0\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\0\xff\xff\xff\xff\xff\xff\xff\xff0\0\xff\xff0\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x001\0\xff\xff\xff\xff1\x001\x001\x001\x001\x001\x001\x001\x001\x001\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff1\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\0\xff\xff\xff\xff\xff\xff\xff\xff1\0\xff\xff1\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x002\0\xff\xff\xff\xff2\x002\x002\x002\x002\x002\x002\x002\x002\x002\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff2\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\0\xff\xff\xff\xff\xff\xff\xff\xff2\0\xff\xff2\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x003\0\xff\xff\xff\xff3\x003\x003\x003\x003\x003\x003\x003\x003\x003\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff3\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\0\xff\xff\xff\xff\xff\xff\xff\xff3\0\xff\xff3\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x004\0\xff\xff\xff\xff4\x004\x004\x004\x004\x004\x004\x004\x004\x004\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff4\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\0\xff\xff\xff\xff\xff\xff\xff\xff4\0\xff\xff4\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x005\0\xff\xff\xff\xff5\x005\x005\x005\x005\x005\x005\x005\x005\x005\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff5\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\0\xff\xff\xff\xff\xff\xff\xff\xff5\0\xff\xff5\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x006\0\xff\xff\xff\xff6\x006\x006\x006\x006\x006\x006\x006\x006\x006\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff6\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\0\xff\xff\xff\xff\xff\xff\xff\xff6\0\xff\xff6\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x007\0\xff\xff\xff\xff7\x007\x007\x007\x007\x007\x007\x007\x007\x007\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff7\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\0\xff\xff\xff\xff\xff\xff\xff\xff7\0\xff\xff7\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x008\0\xff\xff\xff\xff8\x008\x008\x008\x008\x008\x008\x008\x008\x008\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff8\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\0\xff\xff\xff\xff\xff\xff\xff\xff8\0\xff\xff8\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x008\x009\0\xff\xff\xff\xff9\x009\x009\x009\x009\x009\x009\x009\x009\x009\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff9\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\0\xff\xff\xff\xff\xff\xff\xff\xff9\0\xff\xff9\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\0:\0\xff\xff\xff\xff:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0\xff\xff\xff\xff\xff\xff\xff\xff:\0\xff\xff:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0;\0\xff\xff\xff\xff;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0\xff\xff\xff\xff\xff\xff\xff\xff;\0\xff\xff;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0<\0\xff\xff\xff\xff<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0\xff\xff\xff\xff\xff\xff\xff\xff<\0\xff\xff<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0=\0\xff\xff\xff\xff=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0\xff\xff\xff\xff\xff\xff\xff\xff=\0\xff\xff=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0>\0\xff\xff\xff\xff>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0\xff\xff\xff\xff\xff\xff\xff\xff>\0\xff\xff>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0?\0\xff\xff\xff\xff?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0\xff\xff\xff\xff\xff\xff\xff\xff?\0\xff\xff?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\0@\0\xff\xff\xff\xff@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0\xff\xff\xff\xff\xff\xff\xff\xff@\0\xff\xff@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0@\0A\0\xff\xff\xff\xffA\0A\0A\0A\0A\0A\0A\0A\0A\0A\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffA\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0\xff\xff\xff\xff\xff\xff\xff\xffA\0\xff\xffA\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0A\0B\0\xff\xff\xff\xffB\0B\0B\0B\0B\0B\0B\0B\0B\0B\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffB\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0\xff\xff\xff\xff\xff\xff\xff\xffB\0\xff\xffB\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0C\0\xff\xff\xff\xffC\0C\0C\0C\0C\0C\0C\0C\0C\0C\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffC\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0\xff\xff\xff\xff\xff\xff\xff\xffC\0\xff\xffC\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0D\0\xff\xff\xff\xffD\0D\0D\0D\0D\0D\0D\0D\0D\0D\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffD\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0\xff\xff\xff\xff\xff\xff\xff\xffD\0\xff\xffD\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0E\0\xff\xff\xff\xffE\0E\0E\0E\0E\0E\0E\0E\0E\0E\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffE\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0\xff\xff\xff\xff\xff\xff\xff\xffE\0\xff\xffE\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0F\0\xff\xff\xff\xffF\0F\0F\0F\0F\0F\0F\0F\0F\0F\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffF\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0\xff\xff\xff\xff\xff\xff\xff\xffF\0\xff\xffF\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0G\0\xff\xff\xff\xffG\0G\0G\0G\0G\0G\0G\0G\0G\0G\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffG\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0\xff\xff\xff\xff\xff\xff\xff\xffG\0\xff\xffG\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0H\0\xff\xff\xff\xffH\0H\0H\0H\0H\0H\0H\0H\0H\0H\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffH\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0\xff\xff\xff\xff\xff\xff\xff\xffH\0\xff\xffH\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0H\0I\0\xff\xff\xff\xffI\0I\0I\0I\0I\0I\0I\0I\0I\0I\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffI\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0\xff\xff\xff\xff\xff\xff\xff\xffI\0\xff\xffI\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0I\0J\0\xff\xff\xff\xffJ\0J\0J\0J\0J\0J\0J\0J\0J\0J\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffJ\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0\xff\xff\xff\xff\xff\xff\xff\xffJ\0\xff\xffJ\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0J\0K\0\xff\xff\xff\xffK\0K\0K\0K\0K\0K\0K\0K\0K\0K\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffK\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0\xff\xff\xff\xff\xff\xff\xff\xffK\0\xff\xffK\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0L\0\xff\xff\xff\xffL\0L\0L\0L\0L\0L\0L\0L\0L\0L\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffL\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0\xff\xff\xff\xff\xff\xff\xff\xffL\0\xff\xffL\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0M\0\xff\xff\xff\xffM\0M\0M\0M\0M\0M\0M\0M\0M\0M\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffM\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0\xff\xff\xff\xff\xff\xff\xff\xffM\0\xff\xffM\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0N\0\xff\xff\xff\xffN\0N\0N\0N\0N\0N\0N\0N\0N\0N\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffN\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0\xff\xff\xff\xff\xff\xff\xff\xffN\0\xff\xffN\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0O\0\xff\xff\xff\xffO\0O\0O\0O\0O\0O\0O\0O\0O\0O\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffO\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0\xff\xff\xff\xff\xff\xff\xff\xffO\0\xff\xffO\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0P\0\xff\xff\xff\xffP\0P\0P\0P\0P\0P\0P\0P\0P\0P\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffP\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0\xff\xff\xff\xff\xff\xff\xff\xffP\0\xff\xffP\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0Q\0\xff\xff\xff\xffQ\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffQ\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0\xff\xff\xff\xff\xff\xff\xff\xffQ\0\xff\xffQ\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0R\0\xff\xff\xff\xffR\0R\0R\0R\0R\0R\0R\0R\0R\0R\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffR\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0\xff\xff\xff\xff\xff\xff\xff\xffR\0\xff\xffR\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0R\0S\0\xff\xff\xff\xffS\0S\0S\0S\0S\0S\0S\0S\0S\0S\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffS\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0\xff\xff\xff\xff\xff\xff\xff\xffS\0\xff\xffS\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0S\0T\0\xff\xff\xff\xffT\0T\0T\0T\0T\0T\0T\0T\0T\0T\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffT\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0\xff\xff\xff\xff\xff\xff\xff\xffT\0\xff\xffT\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0T\0U\0\xff\xff\xff\xffU\0U\0U\0U\0U\0U\0U\0U\0U\0U\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffU\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0\xff\xff\xff\xff\xff\xff\xff\xffU\0\xff\xffU\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0U\0V\0\xff\xff\xff\xffV\0V\0V\0V\0V\0V\0V\0V\0V\0V\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffV\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0\xff\xff\xff\xff\xff\xff\xff\xffV\0\xff\xffV\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0W\0\xff\xff\xff\xffW\0W\0W\0W\0W\0W\0W\0W\0W\0W\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffW\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0\xff\xff\xff\xff\xff\xff\xff\xffW\0\xff\xffW\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0X\0\xff\xff\xff\xffX\0X\0X\0X\0X\0X\0X\0X\0X\0X\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffX\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0\xff\xff\xff\xff\xff\xff\xff\xffX\0\xff\xffX\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0Y\0\xff\xff\xff\xffY\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffY\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0\xff\xff\xff\xff\xff\xff\xff\xffY\0\xff\xffY\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Z\0\xff\xff\xff\xffZ\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffZ\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0\xff\xff\xff\xff\xff\xff\xff\xffZ\0\xff\xffZ\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0[\0\xff\xff\xff\xff[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0\xff\xff\xff\xff\xff\xff\xff\xff[\0\xff\xff[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0[\0\\\0\xff\xff\xff\xff\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\xff\xff\xff\xff\xff\xff\xff\xff\\\0\xff\xff\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0\\\0]\0\xff\xff\xff\xff]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0\xff\xff\xff\xff\xff\xff\xff\xff]\0\xff\xff]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0]\0^\0\xff\xff\xff\xff^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0\xff\xff\xff\xff\xff\xff\xff\xff^\0\xff\xff^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0^\0_\0\xff\xff\xff\xff_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0\xff\xff\xff\xff\xff\xff\xff\xff_\0\xff\xff_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0_\0`\0\xff\xff\xff\xff`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0\xff\xff\xff\xff\xff\xff\xff\xff`\0\xff\xff`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0a\0\xff\xff\xff\xffa\0a\0a\0a\0a\0a\0a\0a\0a\0a\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffa\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0\xff\xff\xff\xff\xff\xff\xff\xffa\0\xff\xffa\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0b\0\xff\xff\xff\xffb\0b\0b\0b\0b\0b\0b\0b\0b\0b\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffb\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0\xff\xff\xff\xff\xff\xff\xff\xffb\0\xff\xffb\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0b\0c\0\xff\xff\xff\xffc\0c\0c\0c\0c\0c\0c\0c\0c\0c\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffc\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0\xff\xff\xff\xff\xff\xff\xff\xffc\0\xff\xffc\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0d\0\xff\xff\xff\xffd\0d\0d\0d\0d\0d\0d\0d\0d\0d\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffd\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0\xff\xff\xff\xff\xff\xff\xff\xffd\0\xff\xffd\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0e\0\xff\xff\xff\xffe\0e\0e\0e\0e\0e\0e\0e\0e\0e\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffe\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0\xff\xff\xff\xff\xff\xff\xff\xffe\0\xff\xffe\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0f\0\xff\xff\xff\xfff\0f\0f\0f\0f\0f\0f\0f\0f\0f\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xfff\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0\xff\xff\xff\xff\xff\xff\xff\xfff\0\xff\xfff\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0f\0g\0\xff\xff\xff\xffg\0g\0g\0g\0g\0g\0g\0g\0g\0g\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffg\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0\xff\xff\xff\xff\xff\xff\xff\xffg\0\xff\xffg\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0h\0\xff\xff\xff\xffh\0h\0h\0h\0h\0h\0h\0h\0h\0h\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffh\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0\xff\xff\xff\xff\xff\xff\xff\xffh\0\xff\xffh\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0h\0i\0\xff\xff\xff\xffi\0i\0i\0i\0i\0i\0i\0i\0i\0i\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffi\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0\xff\xff\xff\xff\xff\xff\xff\xffi\0\xff\xffi\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0i\0j\0\xff\xff\xff\xffj\0j\0j\0j\0j\0j\0j\0j\0j\0j\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffj\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0\xff\xff\xff\xff\xff\xff\xff\xffj\0\xff\xffj\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0j\0k\0\xff\xff\xff\xffk\0k\0k\0k\0k\0k\0k\0k\0k\0k\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffk\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0\xff\xff\xff\xff\xff\xff\xff\xffk\0\xff\xffk\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0k\0l\0\xff\xff\xff\xffl\0l\0l\0l\0l\0l\0l\0l\0l\0l\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffl\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0\xff\xff\xff\xff\xff\xff\xff\xffl\0\xff\xffl\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0l\0m\0\xff\xff\xff\xffm\0m\0m\0m\0m\0m\0m\0m\0m\0m\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffm\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0\xff\xff\xff\xff\xff\xff\xff\xffm\0\xff\xffm\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0m\0n\0\xff\xff\xff\xffn\0n\0n\0n\0n\0n\0n\0n\0n\0n\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffn\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0\xff\xff\xff\xff\xff\xff\xff\xffn\0\xff\xffn\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0o\0\xff\xff\xff\xffo\0o\0o\0o\0o\0o\0o\0o\0o\0o\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffo\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0\xff\xff\xff\xff\xff\xff\xff\xffo\0\xff\xffo\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0o\0p\0\xff\xff\xff\xffp\0p\0p\0p\0p\0p\0p\0p\0p\0p\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffp\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0\xff\xff\xff\xff\xff\xff\xff\xffp\0\xff\xffp\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0p\0q\0\xff\xff\xff\xffq\0q\0q\0q\0q\0q\0q\0q\0q\0q\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffq\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0\xff\xff\xff\xff\xff\xff\xff\xffq\0\xff\xffq\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0q\0r\0\xff\xff\xff\xffr\0r\0r\0r\0r\0r\0r\0r\0r\0r\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffr\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0\xff\xff\xff\xff\xff\xff\xff\xffr\0\xff\xffr\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0r\0s\0\xff\xff\xff\xffs\0s\0s\0s\0s\0s\0s\0s\0s\0s\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffs\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0\xff\xff\xff\xff\xff\xff\xff\xffs\0\xff\xffs\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0s\0t\0\xff\xff\xff\xfft\0t\0t\0t\0t\0t\0t\0t\0t\0t\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xfft\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0\xff\xff\xff\xff\xff\xff\xff\xfft\0\xff\xfft\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0t\0u\0\xff\xff\xff\xffu\0u\0u\0u\0u\0u\0u\0u\0u\0u\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffu\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0\xff\xff\xff\xff\xff\xff\xff\xffu\0\xff\xffu\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0u\0v\0\xff\xff\xff\xffv\0v\0v\0v\0v\0v\0v\0v\0v\0v\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffv\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0\xff\xff\xff\xff\xff\xff\xff\xffv\0\xff\xffv\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0v\0w\0\xff\xff\xff\xffw\0w\0w\0w\0w\0w\0w\0w\0w\0w\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffw\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0\xff\xff\xff\xff\xff\xff\xff\xffw\0\xff\xffw\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0w\0x\0\xff\xff\xff\xffx\0x\0x\0x\0x\0x\0x\0x\0x\0x\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffx\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0\xff\xff\xff\xff\xff\xff\xff\xffx\0\xff\xffx\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0x\0y\0\xff\xff\xff\xffy\0y\0y\0y\0y\0y\0y\0y\0y\0y\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffy\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0\xff\xff\xff\xff\xff\xff\xff\xffy\0\xff\xffy\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0y\0z\0\xff\xff\xff\xffz\0z\0z\0z\0z\0z\0z\0z\0z\0z\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffz\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0\xff\xff\xff\xff\xff\xff\xff\xffz\0\xff\xffz\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0{\0\xff\xff\xff\xff{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0\xff\xff\xff\xff\xff\xff\xff\xff{\0\xff\xff{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0{\0|\0\xff\xff\xff\xff|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0\xff\xff\xff\xff\xff\xff\xff\xff|\0\xff\xff|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0|\0}\0\xff\xff\xff\xff}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0\xff\xff\xff\xff\xff\xff\xff\xff}\0\xff\xff}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0}\0~\0\xff\xff\xff\xff~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0\xff\xff\xff\xff\xff\xff\xff\xff~\0\xff\xff~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0~\0\x7f\0\xff\xff\xff\xff\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\xff\xff\xff\xff\xff\xff\xff\xff\x7f\0\xff\xff\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x7f\0\x80\0\xff\xff\xff\xff\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\xff\xff\xff\xff\xff\xff\xff\xff\x80\0\xff\xff\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x80\0\x81\0\xff\xff\xff\xff\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\xff\xff\xff\xff\xff\xff\xff\xff\x81\0\xff\xff\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x81\0\x82\0\xff\xff\xff\xff\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\xff\xff\xff\xff\xff\xff\xff\xff\x82\0\xff\xff\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x83\0\xff\xff\xff\xff\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\xff\xff\xff\xff\xff\xff\xff\xff\x83\0\xff\xff\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x83\0\x84\0\xff\xff\xff\xff\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\xff\xff\xff\xff\xff\xff\xff\xff\x84\0\xff\xff\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x84\0\x85\0\xff\xff\xff\xff\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\xff\xff\xff\xff\xff\xff\xff\xff\x85\0\xff\xff\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x85\0\x86\0\xff\xff\xff\xff\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\xff\xff\xff\xff\xff\xff\xff\xff\x86\0\xff\xff\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x86\0\x87\0\xff\xff\xff\xff\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\xff\xff\xff\xff\xff\xff\xff\xff\x87\0\xff\xff\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x87\0\x89\0\x89\0\x89\0\x89\0\x89\0\x89\0\x89\0\x89\0\x89\0\x89\0\x8a\0\x90\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8a\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8b\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\x8f\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x90\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x90\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",
		                 cst$1,
		                 cst$1,
		                 cst$1,
		                 cst$1,
		                 cst$1,
		                 cst$1],
		              fmt$68 = [0, [11, "Binding ", [15, 0]], "Binding %a"],
		              fmt$67 =
		                [0, [11, "no case matched ", [15, 0]], "no case matched %a"],
		              fmt$66 =
		                [0,
		                 [11, "wrong case type ", [15, [12, 32, [15, 0]]]],
		                 "wrong case type %a %a"],
		              fmt$65 =
		                [0,
		                 [11,
		                  "cannot create a map with key ",
		                  [15, [11, " as it isn't comparable", [17, 4, [2, 0, 0]]]]],
		                 "cannot create a map with key %a as it isn't comparable@.%s"],
		              l = [0, "/etc/timezone", [0, "/var/db/zoneinfo", 0]],
		              l$0 = [0, "/etc/sysconfig/clock", [0, "/etc/conf.d/clock", 0]],
		              zero$0 = [0, caml_int64_create_lo_mi_hi(0, 0, 0), 0],
		              minute_to_seconds = caml_int64_create_lo_mi_hi(60, 0, 0),
		              s_to_ps_mult = caml_int64_create_lo_mi_hi(10817536, 59604, 0),
		              fmt$76 =
		                [0, [11, "event:", [2, 0, [12, 58, [15, 0]]]], "event:%s:%a"],
		              format$16 =
		                [0,
		                 [11,
		                  "invalid occurrence date in event id: ",
		                  [3, 0, [11, cst$9, [2, 0, 0]]]],
		                 "invalid occurrence date in event id: %S: %s"],
		              format$15 =
		                [0,
		                 [11, "invalid event id: ", [3, 0, 0]],
		                 "invalid event id: %S"],
		              fmt$75 =
		                [0,
		                 [11, cst_invalid, [2, 0, [11, cst_id$0, [3, 0, 0]]]],
		                 cst_invalid_s_id_S],
		              fmt$74 =
		                [0,
		                 [11, cst_invalid_identifier_wrong_p, 0],
		                 cst_invalid_identifier_wrong_p],
		              fmt$73 = [0, [2, 0, [2, 0, 0]], "%s%s"],
		              fmt$72 =
		                [0,
		                 [11, cst_invalid, [2, 0, [11, cst_id$0, [3, 0, 0]]]],
		                 cst_invalid_s_id_S],
		              fmt$71 =
		                [0,
		                 [11, "invalid identifier byte: 0x", [4, 6, 0, 0, 0]],
		                 "invalid identifier byte: 0x%x"],
		              fmt$70 =
		                [0,
		                 [11, "invalid identifier char: ", [0, 0]],
		                 "invalid identifier char: %c"],
		              fmt$69 = [0, [2, 0, [11, cst_id$1, 0]], "%s-id"],
		              id$19 = [0, "event-id"],
		              fmt$77 = [0, [11, cst_invalid, [2, 0, 0]], "invalid %s"],
		              id$20 = [0, cst_version],
		              aj = [0, 0, 0, [9, cst_reader_writer], 0],
		              ak = [0, 0, 0, [9, cst_reader], 0],
		              name$3 = [0, "workspace-read"],
		              name$4 = [0, "workspace-patch"],
		              fmt$78 =
		                [0,
		                 [11, "Unknown time zone ", [2, 0, 0]],
		                 "Unknown time zone %s"],
		              fmt$88 = [0, [2, 0, [11, " (stopped)", 0]], "%s (stopped)"],
		              fmt$79 = [0, [15, 0], cst_a],
		              fmt$81 = [0, [15, [11, cst_on_the, [15, 0]]], "%a on the %a"],
		              fmt$80 = [0, [15, 0], cst_a],
		              fmt$82 = [0, [15, [11, " on ", [15, 0]]], "%a on %a"],
		              fmt$83 = [0, [15, 0], cst_a],
		              fmt$84 = [0, [15, 0], cst_a],
		              fmt$87 =
		                [0,
		                 [15, [11, cst_on_the, [15, [11, cst_of$0, [15, 0]]]]],
		                 "%a on the %a of %a"],
		              fmt$85 = [0, [15, [11, cst_in$0, [15, 0]]], "%a in %a"],
		              fmt$86 = [0, [15, 0], cst_a],
		              id$21 = [0, "reference-id"],
		              format$17 =
		                [0, [11, "invalid id: ", [3, 0, 0]], "invalid id: %S"],
		              empty$0 = [0, 0],
		              al = [0, 0, 0, [9, cst_list_elt], 0],
		              fmt$89 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   " integration backend returned an unexpected status ",
		                   [3, 0, [11, cst_calling, [15, 0]]]]],
		                 "%s integration backend returned an unexpected status %S calling %a"],
		              fmt$90 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   " returned an error. Do not worry, it has been logged, we\xe2\x80\x99re on it!",
		                   0]],
		                 "%s returned an error. Do not worry, it has been logged, we\xe2\x80\x99re on it!"],
		              fmt$91 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   " decoding could not parse ",
		                   [2, 0, [11, cst_calling, [15, 0]]]]],
		                 "%s decoding could not parse %s calling %a"],
		              fmt$92 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   " returned data that cannot be understood (",
		                   [2,
		                    0,
		                    [11,
		                     "). It has been logged. But do not hesitate to ping us as this should never occur!",
		                     0]]]],
		                 "%s returned data that cannot be understood (%s). It has been logged. But do not hesitate to ping us as this should never occur!"],
		              fmt$93 =
		                [0,
		                 [2, 0, [11, " integration configuration error: ", [2, 0, 0]]],
		                 "%s integration configuration error: %s"],
		              bB = [0, "oauth-client-id"],
		              id$22 = [0, "parent-id"],
		              fmt$94 =
		                [0, [2, 0, [11, cst_templatable$0, 0]], cst_s_templatable],
		              fmt$95 =
		                [0, [2, 0, [11, cst_templatable$0, 0]], cst_s_templatable],
		              id$23 = [0, cst_scheduling],
		              am = [0, 0, 0, [9, cst_synchronized], 0],
		              an = [0, 0, 0, [9, cst_synchronizing], 0],
		              ao = [0, 0, 0, [9, cst_initializing], 0],
		              fmt$96 = [0, [2, 0, [12, 64, [2, 0, 0]]], cst_s_s],
		              format$18 =
		                [0,
		                 [11, "not a valid email: ", [3, 0, 0]],
		                 "not a valid email: %S"],
		              aA = [0, 0, 0, [9, cst_owner], 0],
		              aB = [0, 0, 0, [9, cst_member], 0],
		              ap = [0, 0, 0, [9, cst_workspace_rename], 0],
		              aq = [0, 0, 0, [9, cst_workspace_remove], 0],
		              ar = [0, 0, 0, [9, cst_workspace_member_set_role], 0],
		              as = [0, 0, 0, [9, cst_workspace_member_remove], 0],
		              at = [0, 0, 0, [9, cst_workspace_member_add], 0],
		              au = [0, 0, 0, [9, cst_workspace_create], 0],
		              av = [0, 0, 0, [9, cst_rename], 0],
		              aw = [0, 0, 0, [9, cst_member_uninvite], 0],
		              ax = [0, 0, 0, [9, cst_member_remove], 0],
		              ay = [0, 0, 0, [9, cst_member_invite], 0],
		              az = [0, 0, 0, [9, cst_delete], 0],
		              fmt$97 = [0, [15, 0], cst_a],
		              all$2 =
		                caml_list_of_js_array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
		              name$5 = [0, "org-read"],
		              name$6 = [0, "org-patch"],
		              fmt$98 = [0, [15, 0], cst_a],
		              format$19 =
		                [0,
		                 [11, "invalid hour format: ", [4, 0, 0, 0, 0]],
		                 "invalid hour format: %d"],
		              id$24 = [0, "hours-format"],
		              empty$1 = [0, 0],
		              empty$2 = [0, 0],
		              empty$3 = [0, 1, 1],
		              empty$4 = [0, 0, 0, 0, 0, 0],
		              empty$5 = [0, 0, 0, 0, 0, 0],
		              aG = [0, 0, 0, [9, cst_passive], 0],
		              aH = [0, 0, 0, [9, cst_active], 0],
		              aE = [0, 0, 0, [9, cst_free], 0],
		              aF = [0, 0, 0, [9, cst_busy], 0],
		              aC = [0, 0, 0, [9, cst_ignore], 0],
		              aD = [0, 0, 0, [9, cst_attend], 0],
		              fmt$99 =
		                [0,
		                 [11, cst_event$0, [2, 0, [11, cst_content$0, 0]]],
		                 cst_event_s_content],
		              fmt$100 =
		                [0,
		                 [11, cst_event$0, [2, 0, [11, cst_content$0, 0]]],
		                 cst_event_s_content],
		              fmt$102 =
		                [0,
		                 [11,
		                  "invalid origin date: not an occurrence date: ",
		                  [15, 0]],
		                 "invalid origin date: not an occurrence date: %a"],
		              fmt$103 =
		                [0,
		                 [11,
		                  "invalid origin date: later than recurrence end date: ",
		                  [15, 0]],
		                 "invalid origin date: later than recurrence end date: %a"],
		              bC =
		                [1,
		                 "invalid patch: no archived / task fields in recurrent events"],
		              fmt$101 =
		                [0,
		                 [11, "first occurence does not exist: ", [2, 0, 0]],
		                 "first occurence does not exist: %s"],
		              bD = [0, "integration-app-connection-id"],
		              id$25 = [0, "integration-app-data-record-id"],
		              fmt$104 = [0, [15, 0], cst_a],
		              default$ = [0, 0, 0, 0],
		              all$3 = [0, 0, [0, 1, [0, 2, 0]]],
		              aI = [0, 0, 0, [9, cst_token_revoked], 0],
		              aJ = [0, 0, 0, [9, cst_account_missing], 0],
		              fmt$105 =
		                [0, [2, 0, [12, 58, [15, [12, 58, [2, 0, 0]]]]], "%s:%a:%s"],
		              format$20 =
		                [0,
		                 [11, "unrecognized architecture: ", [2, 0, 0]],
		                 "unrecognized architecture: %s"],
		              id$26 = [0, cst_distribution],
		              fmt$106 = [0, [15, [12, 45, [15, 0]]], "%a-%a"],
		              format$21 =
		                [0,
		                 [11, "unrecognized distribution: ", [2, 0, 0]],
		                 "unrecognized distribution: %s"],
		              fmt$107 =
		                [0,
		                 [2, 0, [11, " list contains duplicate ID ", [15, 0]]],
		                 "%s list contains duplicate ID %a"],
		              id$28 = [0, "notion-status-column-mapping"],
		              id$27 = [0, "notion-status-column"],
		              redirect_ports = [0, 52700, [0, 52701, [0, 52702, 0]]],
		              all$4 =
		                caml_list_of_js_array([1, 3, 0, 2, 10, 7, 9, 8, 4, 6, 5]),
		              all_organization_specific = [0, 7, [0, 9, [0, 10, 0]]],
		              aQ = [0, 0, 0, [9, cst_api], 0],
		              aR = [0, 0, 0, [9, cst_app_api], 0],
		              aS = [0, 0, 0, [9, cst_api], 0],
		              aT = [0, 0, 0, [9, cst_app_api], 0],
		              aK = [0, 0, 0, [9, cst_integration], 0],
		              aL = [0, 0, 0, [9, cst_api], 0],
		              aM = [0, 0, 0, [9, cst_view], 0],
		              aN = [0, 0, 0, [9, cst_app], 0],
		              aO = [0, 0, 0, [9, cst_block], 0],
		              aP = [0, 0, 0, [9, cst_console], 0],
		              fmt$109 = [0, [2, 0, [12, 32, [2, 0, 0]]], cst_s_s$0],
		              fmt$108 =
		                [0,
		                 [11,
		                  "Can only get the field name out of a union type, got ",
		                  [15, 0]],
		                 "Can only get the field name out of a union type, got %a"],
		              fmt$110 =
		                [0,
		                 [11,
		                  "https://open.routine.co?path=/objects/",
		                  [15, [12, 47, [15, [12, 47, [15, 0]]]]]],
		                 "https://open.routine.co?path=/objects/%a/%a/%a"],
		              extras$1 = [0, 0],
		              extras$0 = [0, 0],
		              extras = [0, 0],
		              name$7 = [0, "api-person-read"],
		              name$8 = [0, "api-person-patch"],
		              fmt$112 =
		                [0,
		                 [2, 0, [11, " (+", [4, 0, 0, 0, [11, " more)", 0]]]],
		                 "%s (+%d more)"],
		              fmt$111 =
		                [0, [2, 0, [11, " mentioned you", 0]], "%s mentioned you"],
		              name$9 = [0, "page-read"],
		              name$10 = [0, "page-patch"],
		              fmt$118 = [0, [15, 0], cst_a],
		              fmt$117 = [0, [15, 0], cst_a],
		              fmt$116 = [0, [15, 0], cst_a],
		              fmt$115 = [0, [15, 0], cst_a],
		              fmt$114 = [0, [15, 0], cst_a],
		              fmt$113 = [0, [15, 0], cst_a],
		              all$5 = [0, 0, [0, 1, [0, 2, [0, 3, 0]]]],
		              all$6 = [0, 0, 0],
		              all$7 = [0, 0, [0, 1, [0, 2, 0]]],
		              all$8 = [0, 0, [0, 1, 0]],
		              fmt$119 =
		                [0,
		                 [11, cst_invalid_semantic_version$0, 0],
		                 cst_invalid_semantic_version$0],
		              fmt$120 =
		                [0,
		                 [11, "invalid git version ", [3, 0, [11, cst$9, [2, 0, 0]]]],
		                 "invalid git version %S: %s"],
		              fmt$121 =
		                [0,
		                 [11, cst_invalid, [2, 0, [11, cst$9, [15, 0]]]],
		                 "invalid %s: %a"],
		              fmt$122 =
		                [0,
		                 [11, "invalid time: ", [8, [0, 0, 0], 0, 0, 0]],
		                 "invalid time: %f"],
		              bE = [1, "no logs files in the browser"],
		              int64 = caml_int64_create_lo_mi_hi(1, 0, 0),
		              v0 =
		                [0,
		                 [0,
		                  "Dummy_type_because_we_cannot_digest_type_constructors_only_concrete_types",
		                  0],
		                 0],
		              enumerate_474 = [0, 0, [0, 1, 0]],
		              enumerate_475 = [0, 0, [0, 1, 0]],
		              enumerate_008 = [0, 0, [0, 1, 0]],
		              enumerate_009 = [0, 0, [0, 1, 0]],
		              v0$0 =
		                [0,
		                 [0, cst_Neg, 0],
		                 [0, [0, cst_Zero, 0], [0, [0, cst_Pos, 0], 0]]],
		              one_byte_utf8 = [0, 0, 127],
		              two_bytes_utf8 = [0, 128, 2047],
		              three_bytes_utf8_part1 = [0, 2048, 55295],
		              three_bytes_utf8_part2 = [0, 57344, 65535],
		              four_bytes_utf8 = [0, 65536, 1114111],
		              v0$1 =
		                [0,
		                 [0, "Less", 0],
		                 [0, [0, cst_Equal, 0], [0, [0, "Greater", 0], 0]]],
		              v0$2 =
		                [0,
		                 [0, "Sun", 0],
		                 [0,
		                  [0, "Mon", 0],
		                  [0,
		                   [0, "Tue", 0],
		                   [0,
		                    [0, "Wed", 0],
		                    [0,
		                     [0, "Thu", 0],
		                     [0, [0, "Fri", 0], [0, [0, "Sat", 0], 0]]]]]]],
		              all$9 =
		                caml_list_of_js_array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
		              v0$3 =
		                [0,
		                 [0, "Next_fit", 0],
		                 [0, [0, "First_fit", 0], [0, [0, "Best_fit", 0], 0]]],
		              level_bits = [0, 14, [0, 13, [0, 5, 0]]],
		              fmt$125 =
		                [0,
		                 [11, cst_invalid_replica_timestamp, [2, 0, 0]],
		                 cst_invalid_replica_timestamp_],
		              fmt$126 =
		                [0,
		                 [11, cst_invalid_replica_timestamp, [2, 0, 0]],
		                 cst_invalid_replica_timestamp_],
		              fmt$124 = [0, [2, 0, [12, 58, [4, 0, 0, 0, 0]]], cst_s_d],
		              fmt$127 =
		                [0, [11, "no such element: ", [15, 0]], "no such element: %a"],
		              id$29 = [0, cst$1, 0],
		              res = [11, 0, 0, 0],
		              format$22 =
		                [0,
		                 [11, "invalid unicode scalar: U+", [4, 6, [0, 2, 4], 0, 0]],
		                 "invalid unicode scalar: U+%04x"],
		              bF = [0, cst_text],
		              fmt$128 =
		                [0,
		                 [11, "duplicate timestamp in log: ", [15, 0]],
		                 "duplicate timestamp in log: %a"],
		              fmt$129 =
		                [0,
		                 [11, "union-", [2, 0, [12, 45, [2, 0, 0]]]],
		                 "union-%s-%s"],
		              x$1 = [0, 0, 0],
		              bG = [0, cst_bool],
		              content = [8, [0, cst$1]],
		              bH = [0, cst_google_event_id],
		              bI = [0, cst_google_event_id],
		              bK = [0, cst_other_enabled],
		              bJ = [0, cst_directory_enabled],
		              bL = [0, cst_starred],
		              fmt$130 = [0, [15, 0], cst_a],
		              aU = [0, 0, 0, [9, cst_virtual], 0],
		              aV = [0, 0, 0, [9, cst_table], 0],
		              bN = [0, [0, 1]],
		              bM = [0, [0, 0]],
		              aZ = [0, 0, 0, [9, cst_mobile_demo], 0],
		              a0 = [0, 0, 0, [9, cst_standard], 0],
		              aW = [0, 0, 0, [9, cst_never_ask], 0],
		              aX = [0, 0, 0, [9, cst_ask_if_necessary], 0],
		              aY = [0, 0, 0, [9, cst_ask_freely], 0],
		              default$0 = [0, 0, 0],
		              a1 = [0, 0, 0, [9, cst_all], 0],
		              a2 = [0, 0, 0, [9, cst_readOnly], 0],
		              a3 = [0, 0, 0, [9, cst_migrating_account], 0],
		              a4 = [0, 0, 0, [9, cst_from_scratch], 0],
		              a5 = [0, 0, 0, [9, cst_migrating_account], 0],
		              a6 = [0, 0, 0, [9, cst_from_scratch], 0],
		              v$1 =
		                caml_list_of_js_array
		                 (["aaa",
		                   "aarp",
		                   "abarth",
		                   "abb",
		                   "abbott",
		                   "abbvie",
		                   "abc",
		                   "able",
		                   "abogado",
		                   "abudhabi",
		                   "ac",
		                   "academy",
		                   "accenture",
		                   "accountant",
		                   "accountants",
		                   "aco",
		                   cst_actor,
		                   "ad",
		                   "adac",
		                   "ads",
		                   "adult",
		                   "ae",
		                   "aeg",
		                   "aero",
		                   "aetna",
		                   "af",
		                   "afamilycompany",
		                   "afl",
		                   "africa",
		                   "ag",
		                   "agakhan",
		                   "agency",
		                   cst_ai,
		                   "aig",
		                   "airbus",
		                   "airforce",
		                   "airtel",
		                   "akdn",
		                   "al",
		                   "alfaromeo",
		                   "alibaba",
		                   "alipay",
		                   "allfinanz",
		                   "allstate",
		                   "ally",
		                   "alsace",
		                   "alstom",
		                   "am",
		                   "amazon",
		                   "americanexpress",
		                   "americanfamily",
		                   "amex",
		                   "amfam",
		                   "amica",
		                   "amsterdam",
		                   "analytics",
		                   cst_android,
		                   "anquan",
		                   "anz",
		                   "ao",
		                   "aol",
		                   "apartments",
		                   cst_app,
		                   "apple",
		                   "aq",
		                   "aquarelle",
		                   "ar",
		                   "arab",
		                   "aramco",
		                   "archi",
		                   "army",
		                   "arpa",
		                   "art",
		                   "arte",
		                   cst_as,
		                   "asda",
		                   "asia",
		                   "associates",
		                   cst_at,
		                   "athleta",
		                   "attorney",
		                   "au",
		                   "auction",
		                   "audi",
		                   "audible",
		                   "audio",
		                   "auspost",
		                   cst_author,
		                   cst_auto,
		                   "autos",
		                   "avianca",
		                   "aw",
		                   "aws",
		                   "ax",
		                   "axa",
		                   "az",
		                   "azure",
		                   "ba",
		                   "baby",
		                   "baidu",
		                   "banamex",
		                   "bananarepublic",
		                   "band",
		                   "bank",
		                   "bar",
		                   "barcelona",
		                   "barclaycard",
		                   "barclays",
		                   "barefoot",
		                   "bargains",
		                   "baseball",
		                   "basketball",
		                   "bauhaus",
		                   "bayern",
		                   "bb",
		                   "bbc",
		                   "bbt",
		                   "bbva",
		                   "bcg",
		                   "bcn",
		                   "bd",
		                   "be",
		                   "beats",
		                   "beauty",
		                   "beer",
		                   "bentley",
		                   "berlin",
		                   "best",
		                   "bestbuy",
		                   "bet",
		                   "bf",
		                   "bg",
		                   "bh",
		                   "bharti",
		                   "bi",
		                   "bible",
		                   "bid",
		                   "bike",
		                   "bing",
		                   "bingo",
		                   "bio",
		                   "biz",
		                   "bj",
		                   "black",
		                   "blackfriday",
		                   "blockbuster",
		                   "blog",
		                   "bloomberg",
		                   cst_blue,
		                   "bm",
		                   "bms",
		                   "bmw",
		                   "bn",
		                   "bnpparibas",
		                   "bo",
		                   "boats",
		                   "boehringer",
		                   "bofa",
		                   "bom",
		                   "bond",
		                   "boo",
		                   "book",
		                   "booking",
		                   "bosch",
		                   "bostik",
		                   "boston",
		                   cst_bot,
		                   "boutique",
		                   "box",
		                   cst_br,
		                   "bradesco",
		                   "bridgestone",
		                   "broadway",
		                   "broker",
		                   "brother",
		                   "brussels",
		                   "bs",
		                   "bt",
		                   "budapest",
		                   "bugatti",
		                   "build",
		                   "builders",
		                   "business",
		                   "buy",
		                   "buzz",
		                   "bv",
		                   "bw",
		                   cst_by,
		                   "bz",
		                   "bzh",
		                   "ca",
		                   "cab",
		                   "cafe",
		                   "cal",
		                   cst_call,
		                   "calvinklein",
		                   "cam",
		                   "camera",
		                   "camp",
		                   "cancerresearch",
		                   "canon",
		                   "capetown",
		                   "capital",
		                   "capitalone",
		                   "car",
		                   "caravan",
		                   "cards",
		                   "care",
		                   "career",
		                   "careers",
		                   "cars",
		                   "casa",
		                   cst_case,
		                   "cash",
		                   "casino",
		                   "cat",
		                   "catering",
		                   "catholic",
		                   "cba",
		                   "cbn",
		                   "cbre",
		                   "cbs",
		                   cst_cc,
		                   "cd",
		                   "center",
		                   "ceo",
		                   "cern",
		                   "cf",
		                   "cfa",
		                   "cfd",
		                   "cg",
		                   "ch",
		                   "chanel",
		                   cst_channel,
		                   "charity",
		                   "chase",
		                   cst_chat,
		                   "cheap",
		                   "chintai",
		                   "christmas",
		                   "chrome",
		                   "church",
		                   "ci",
		                   "cipriani",
		                   "circle",
		                   "cisco",
		                   "citadel",
		                   "citi",
		                   "citic",
		                   cst_city,
		                   "cityeats",
		                   "ck",
		                   "cl",
		                   "claims",
		                   "cleaning",
		                   "click",
		                   "clinic",
		                   "clinique",
		                   "clothing",
		                   "cloud",
		                   "club",
		                   "clubmed",
		                   "cm",
		                   "cn",
		                   "co",
		                   "coach",
		                   "codes",
		                   "coffee",
		                   "college",
		                   "cologne",
		                   "com",
		                   "comcast",
		                   "commbank",
		                   "community",
		                   cst_company,
		                   "compare",
		                   "computer",
		                   "comsec",
		                   "condos",
		                   "construction",
		                   "consulting",
		                   cst_contact,
		                   "contractors",
		                   "cooking",
		                   "cookingchannel",
		                   "cool",
		                   "coop",
		                   "corsica",
		                   cst_country,
		                   cst_coupon,
		                   "coupons",
		                   "courses",
		                   "cpa",
		                   "cr",
		                   "credit",
		                   "creditcard",
		                   "creditunion",
		                   "cricket",
		                   "crown",
		                   "crs",
		                   "cruise",
		                   "cruises",
		                   "csc",
		                   "cu",
		                   "cuisinella",
		                   "cv",
		                   "cw",
		                   "cx",
		                   "cy",
		                   "cymru",
		                   "cyou",
		                   "cz",
		                   "dabur",
		                   "dad",
		                   "dance",
		                   cst_data,
		                   cst_date,
		                   "dating",
		                   "datsun",
		                   cst_day,
		                   "dclk",
		                   "dds",
		                   "de",
		                   "deal",
		                   "dealer",
		                   cst_deals,
		                   "degree",
		                   "delivery",
		                   "dell",
		                   "deloitte",
		                   cst_delta,
		                   "democrat",
		                   "dental",
		                   "dentist",
		                   "desi",
		                   "design",
		                   cst_dev,
		                   "dhl",
		                   "diamonds",
		                   "diet",
		                   "digital",
		                   cst_direct,
		                   cst_directory,
		                   "discount",
		                   "discover",
		                   "dish",
		                   "diy",
		                   "dj",
		                   "dk",
		                   "dm",
		                   "dnp",
		                   "do",
		                   "docs",
		                   "doctor",
		                   "dog",
		                   cst_domains,
		                   "dot",
		                   cst_download,
		                   cst_drive,
		                   "dtv",
		                   "dubai",
		                   "duck",
		                   "dunlop",
		                   "dupont",
		                   "durban",
		                   "dvag",
		                   "dvr",
		                   "dz",
		                   "earth",
		                   "eat",
		                   "ec",
		                   "eco",
		                   "edeka",
		                   "edu",
		                   "education",
		                   "ee",
		                   "eg",
		                   cst_email,
		                   "emerck",
		                   "energy",
		                   "engineer",
		                   "engineering",
		                   "enterprises",
		                   "epson",
		                   "equipment",
		                   "er",
		                   "ericsson",
		                   "erni",
		                   "es",
		                   "esq",
		                   "estate",
		                   "et",
		                   "etisalat",
		                   "eu",
		                   "eurovision",
		                   "eus",
		                   cst_events,
		                   "exchange",
		                   "expert",
		                   "exposed",
		                   "express",
		                   "extraspace",
		                   "fage",
		                   "fail",
		                   "fairwinds",
		                   "faith",
		                   cst_family,
		                   "fan",
		                   "fans",
		                   "farm",
		                   "farmers",
		                   "fashion",
		                   cst_fast,
		                   "fedex",
		                   "feedback",
		                   "ferrari",
		                   "ferrero",
		                   "fi",
		                   "fiat",
		                   "fidelity",
		                   "fido",
		                   "film",
		                   "final",
		                   "finance",
		                   "financial",
		                   "fire",
		                   "firestone",
		                   "firmdale",
		                   "fish",
		                   "fishing",
		                   "fit",
		                   "fitness",
		                   "fj",
		                   "fk",
		                   "flickr",
		                   "flights",
		                   "flir",
		                   "florist",
		                   "flowers",
		                   "fly",
		                   "fm",
		                   "fo",
		                   "foo",
		                   "food",
		                   "foodnetwork",
		                   "football",
		                   "ford",
		                   "forex",
		                   "forsale",
		                   "forum",
		                   "foundation",
		                   "fox",
		                   "fr",
		                   cst_free,
		                   "fresenius",
		                   "frl",
		                   "frogans",
		                   "frontdoor",
		                   "frontier",
		                   "ftr",
		                   "fujitsu",
		                   "fun",
		                   "fund",
		                   "furniture",
		                   "futbol",
		                   "fyi",
		                   "ga",
		                   "gal",
		                   "gallery",
		                   "gallo",
		                   "gallup",
		                   "game",
		                   "games",
		                   "gap",
		                   "garden",
		                   "gay",
		                   "gb",
		                   "gbiz",
		                   "gd",
		                   "gdn",
		                   "ge",
		                   "gea",
		                   "gent",
		                   "genting",
		                   "george",
		                   "gf",
		                   "gg",
		                   "ggee",
		                   "gh",
		                   "gi",
		                   "gift",
		                   "gifts",
		                   "gives",
		                   "giving",
		                   "gl",
		                   "glade",
		                   "glass",
		                   "gle",
		                   "global",
		                   "globo",
		                   "gm",
		                   cst_gmail,
		                   "gmbh",
		                   "gmo",
		                   "gmx",
		                   "gn",
		                   "godaddy",
		                   "gold",
		                   "goldpoint",
		                   "golf",
		                   "goo",
		                   "goodyear",
		                   "goog",
		                   cst_google,
		                   "gop",
		                   cst_got$0,
		                   "gov",
		                   "gp",
		                   "gq",
		                   "gr",
		                   "grainger",
		                   "graphics",
		                   "gratis",
		                   cst_green,
		                   "gripe",
		                   "grocery",
		                   cst_group,
		                   "gs",
		                   cst_gt,
		                   "gu",
		                   "guardian",
		                   "gucci",
		                   "guge",
		                   "guide",
		                   "guitars",
		                   "guru",
		                   "gw",
		                   "gy",
		                   "hair",
		                   "hamburg",
		                   "hangout",
		                   "haus",
		                   "hbo",
		                   "hdfc",
		                   "hdfcbank",
		                   "health",
		                   "healthcare",
		                   cst_help$1,
		                   "helsinki",
		                   "here",
		                   "hermes",
		                   "hgtv",
		                   "hiphop",
		                   "hisamitsu",
		                   "hitachi",
		                   "hiv",
		                   "hk",
		                   "hkt",
		                   "hm",
		                   "hn",
		                   "hockey",
		                   "holdings",
		                   "holiday",
		                   "homedepot",
		                   "homegoods",
		                   "homes",
		                   "homesense",
		                   "honda",
		                   "horse",
		                   "hospital",
		                   "host",
		                   "hosting",
		                   "hot",
		                   "hoteles",
		                   "hotels",
		                   "hotmail",
		                   "house",
		                   "how",
		                   cst_hr,
		                   "hsbc",
		                   "ht",
		                   "hu",
		                   "hughes",
		                   "hyatt",
		                   "hyundai",
		                   "ibm",
		                   "icbc",
		                   "ice",
		                   "icu",
		                   cst_id,
		                   "ie",
		                   "ieee",
		                   "ifm",
		                   "ikano",
		                   "il",
		                   "im",
		                   "imamat",
		                   "imdb",
		                   "immo",
		                   "immobilien",
		                   cst_in,
		                   "inc",
		                   "industries",
		                   "infiniti",
		                   cst_info,
		                   "ing",
		                   "ink",
		                   "institute",
		                   "insurance",
		                   "insure",
		                   cst_int,
		                   "international",
		                   "intuit",
		                   "investments",
		                   "io",
		                   "ipiranga",
		                   "iq",
		                   "ir",
		                   "irish",
		                   "is",
		                   "ismaili",
		                   "ist",
		                   "istanbul",
		                   "it",
		                   "itau",
		                   "itv",
		                   "jaguar",
		                   "java",
		                   "jcb",
		                   "je",
		                   "jeep",
		                   "jetzt",
		                   "jewelry",
		                   "jio",
		                   "jll",
		                   "jm",
		                   "jmp",
		                   "jnj",
		                   "jo",
		                   "jobs",
		                   "joburg",
		                   "jot",
		                   "joy",
		                   "jp",
		                   "jpmorgan",
		                   "jprs",
		                   "juegos",
		                   "juniper",
		                   "kaufen",
		                   "kddi",
		                   "ke",
		                   "kerryhotels",
		                   "kerrylogistics",
		                   "kerryproperties",
		                   "kfh",
		                   "kg",
		                   "kh",
		                   "ki",
		                   "kia",
		                   "kim",
		                   "kinder",
		                   "kindle",
		                   "kitchen",
		                   "kiwi",
		                   "km",
		                   "kn",
		                   "koeln",
		                   "komatsu",
		                   "kosher",
		                   "kp",
		                   "kpmg",
		                   "kpn",
		                   "kr",
		                   "krd",
		                   "kred",
		                   "kuokgroup",
		                   "kw",
		                   "ky",
		                   "kyoto",
		                   "kz",
		                   "la",
		                   "lacaixa",
		                   "lamborghini",
		                   "lamer",
		                   "lancaster",
		                   "lancia",
		                   "land",
		                   "landrover",
		                   "lanxess",
		                   "lasalle",
		                   "lat",
		                   "latino",
		                   "latrobe",
		                   "law",
		                   "lawyer",
		                   "lb",
		                   "lc",
		                   "lds",
		                   "lease",
		                   "leclerc",
		                   "lefrak",
		                   "legal",
		                   "lego",
		                   "lexus",
		                   "lgbt",
		                   cst_li$0,
		                   "lidl",
		                   "life",
		                   "lifeinsurance",
		                   "lifestyle",
		                   "lighting",
		                   "like",
		                   "lilly",
		                   "limited",
		                   "limo",
		                   "lincoln",
		                   "linde",
		                   cst_link,
		                   "lipsy",
		                   "live",
		                   "living",
		                   "lixil",
		                   "lk",
		                   "llc",
		                   "llp",
		                   "loan",
		                   "loans",
		                   "locker",
		                   "locus",
		                   "loft",
		                   "lol",
		                   "london",
		                   "lotte",
		                   "lotto",
		                   "love",
		                   "lpl",
		                   "lplfinancial",
		                   "lr",
		                   "ls",
		                   cst_lt,
		                   "ltd",
		                   "ltda",
		                   "lu",
		                   "lundbeck",
		                   "luxe",
		                   "luxury",
		                   "lv",
		                   cst_ly,
		                   "ma",
		                   "macys",
		                   "madrid",
		                   "maif",
		                   "maison",
		                   "makeup",
		                   "man",
		                   "management",
		                   "mango",
		                   cst_map,
		                   "market",
		                   "marketing",
		                   "markets",
		                   "marriott",
		                   "marshalls",
		                   "maserati",
		                   "mattel",
		                   "mba",
		                   "mc",
		                   "mckinsey",
		                   "md",
		                   cst_me,
		                   "med",
		                   "media",
		                   cst_meet,
		                   "melbourne",
		                   "meme",
		                   "memorial",
		                   "men",
		                   "menu",
		                   "merckmsd",
		                   "mg",
		                   "mh",
		                   "miami",
		                   "microsoft",
		                   "mil",
		                   "mini",
		                   "mint",
		                   "mit",
		                   "mitsubishi",
		                   "mk",
		                   "ml",
		                   "mlb",
		                   "mls",
		                   "mm",
		                   "mma",
		                   "mn",
		                   "mo",
		                   "mobi",
		                   "mobile",
		                   "moda",
		                   "moe",
		                   "moi",
		                   "mom",
		                   "monash",
		                   "money",
		                   "monster",
		                   "mormon",
		                   "mortgage",
		                   "moscow",
		                   "moto",
		                   "motorcycles",
		                   "mov",
		                   "movie",
		                   "mp",
		                   "mq",
		                   "mr",
		                   cst_ms,
		                   "msd",
		                   "mt",
		                   "mtn",
		                   "mtr",
		                   "mu",
		                   "museum",
		                   "mutual",
		                   "mv",
		                   "mw",
		                   "mx",
		                   "my",
		                   "mz",
		                   "na",
		                   "nab",
		                   "nagoya",
		                   cst_name,
		                   "natura",
		                   "navy",
		                   "nba",
		                   "nc",
		                   "ne",
		                   "nec",
		                   "net",
		                   "netbank",
		                   "netflix",
		                   "network",
		                   "neustar",
		                   cst_new,
		                   "news",
		                   cst_next,
		                   "nextdirect",
		                   "nexus",
		                   "nf",
		                   "nfl",
		                   "ng",
		                   "ngo",
		                   "nhk",
		                   "ni",
		                   "nico",
		                   "nike",
		                   "nikon",
		                   "ninja",
		                   "nissan",
		                   "nissay",
		                   "nl",
		                   cst_no,
		                   "nokia",
		                   "northwesternmutual",
		                   "norton",
		                   cst_now,
		                   "nowruz",
		                   "nowtv",
		                   "np",
		                   "nr",
		                   "nra",
		                   "nrw",
		                   "ntt",
		                   "nu",
		                   "nyc",
		                   "nz",
		                   "obi",
		                   "observer",
		                   "off",
		                   "office",
		                   "okinawa",
		                   "olayan",
		                   "olayangroup",
		                   "oldnavy",
		                   "ollo",
		                   "om",
		                   "omega",
		                   cst_one,
		                   "ong",
		                   "onl",
		                   cst_online,
		                   "ooo",
		                   cst_open,
		                   "oracle",
		                   cst_orange,
		                   cst_org,
		                   "organic",
		                   "origins",
		                   "osaka",
		                   "otsuka",
		                   "ott",
		                   "ovh",
		                   "pa",
		                   cst_page,
		                   "panasonic",
		                   "paris",
		                   "pars",
		                   "partners",
		                   cst_parts,
		                   "party",
		                   "passagens",
		                   "pay",
		                   "pccw",
		                   "pe",
		                   "pet",
		                   "pf",
		                   "pfizer",
		                   "pg",
		                   "ph",
		                   "pharmacy",
		                   "phd",
		                   "philips",
		                   cst_phone,
		                   cst_photo,
		                   "photography",
		                   cst_photos,
		                   "physio",
		                   "pics",
		                   "pictet",
		                   "pictures",
		                   "pid",
		                   cst_pin,
		                   cst_ping,
		                   cst_pink,
		                   "pioneer",
		                   "pizza",
		                   "pk",
		                   "pl",
		                   "place",
		                   "play",
		                   "playstation",
		                   "plumbing",
		                   "plus",
		                   "pm",
		                   "pn",
		                   "pnc",
		                   "pohl",
		                   "poker",
		                   "politie",
		                   "porn",
		                   "post",
		                   "pr",
		                   "pramerica",
		                   "praxi",
		                   "press",
		                   "prime",
		                   cst_pro,
		                   cst_prod,
		                   "productions",
		                   "prof",
		                   "progressive",
		                   "promo",
		                   cst_properties,
		                   cst_property,
		                   "protection",
		                   "pru",
		                   "prudential",
		                   cst_ps,
		                   "pt",
		                   "pub",
		                   "pw",
		                   "pwc",
		                   "py",
		                   "qa",
		                   "qpon",
		                   "quebec",
		                   "quest",
		                   "qvc",
		                   "racing",
		                   "radio",
		                   "raid",
		                   "re",
		                   cst_read,
		                   "realestate",
		                   "realtor",
		                   "realty",
		                   "recipes",
		                   cst_red,
		                   "redstone",
		                   "redumbrella",
		                   "rehab",
		                   "reise",
		                   "reisen",
		                   "reit",
		                   "reliance",
		                   "ren",
		                   "rent",
		                   "rentals",
		                   "repair",
		                   "report",
		                   "republican",
		                   "rest",
		                   "restaurant",
		                   "review",
		                   "reviews",
		                   "rexroth",
		                   cst_rich,
		                   "richardli",
		                   "ricoh",
		                   "ril",
		                   "rio",
		                   "rip",
		                   "rmit",
		                   "ro",
		                   "rocher",
		                   "rocks",
		                   "rodeo",
		                   "rogers",
		                   "room",
		                   "rs",
		                   "rsvp",
		                   "ru",
		                   "rugby",
		                   "ruhr",
		                   cst_run,
		                   "rw",
		                   "rwe",
		                   "ryukyu",
		                   "sa",
		                   "saarland",
		                   "safe",
		                   "safety",
		                   "sakura",
		                   "sale",
		                   "salon",
		                   "samsclub",
		                   "samsung",
		                   "sandvik",
		                   "sandvikcoromant",
		                   "sanofi",
		                   "sap",
		                   "sarl",
		                   "sas",
		                   "save",
		                   "saxo",
		                   "sb",
		                   "sbi",
		                   "sbs",
		                   "sc",
		                   "sca",
		                   "scb",
		                   "schaeffler",
		                   "schmidt",
		                   "scholarships",
		                   "school",
		                   "schule",
		                   "schwarz",
		                   "science",
		                   "scjohnson",
		                   "scot",
		                   "sd",
		                   "se",
		                   cst_search,
		                   "seat",
		                   "secure",
		                   "security",
		                   "seek",
		                   cst_select,
		                   "sener",
		                   "services",
		                   "ses",
		                   "seven",
		                   "sew",
		                   "sex",
		                   "sexy",
		                   "sfr",
		                   "sg",
		                   "sh",
		                   "shangrila",
		                   "sharp",
		                   "shaw",
		                   "shell",
		                   "shia",
		                   "shiksha",
		                   "shoes",
		                   "shop",
		                   "shopping",
		                   "shouji",
		                   cst_show,
		                   "showtime",
		                   cst_si,
		                   "silk",
		                   "sina",
		                   "singles",
		                   "site",
		                   "sj",
		                   "sk",
		                   "ski",
		                   "skin",
		                   "sky",
		                   "skype",
		                   "sl",
		                   "sling",
		                   "sm",
		                   "smart",
		                   "smile",
		                   "sn",
		                   "sncf",
		                   "so",
		                   "soccer",
		                   "social",
		                   "softbank",
		                   "software",
		                   "sohu",
		                   "solar",
		                   "solutions",
		                   "song",
		                   "sony",
		                   "soy",
		                   "spa",
		                   cst_space,
		                   "sport",
		                   "spot",
		                   "sr",
		                   "srl",
		                   "ss",
		                   cst_st,
		                   "stada",
		                   "staples",
		                   "star",
		                   "statebank",
		                   "statefarm",
		                   "stc",
		                   "stcgroup",
		                   "stockholm",
		                   "storage",
		                   "store",
		                   cst_stream,
		                   "studio",
		                   "study",
		                   cst_style,
		                   "su",
		                   "sucks",
		                   "supplies",
		                   "supply",
		                   "support",
		                   "surf",
		                   "surgery",
		                   "suzuki",
		                   "sv",
		                   "swatch",
		                   "swiftcover",
		                   "swiss",
		                   "sx",
		                   "sy",
		                   "sydney",
		                   "systems",
		                   "sz",
		                   cst_tab,
		                   "taipei",
		                   "talk",
		                   "taobao",
		                   cst_target,
		                   "tatamotors",
		                   "tatar",
		                   "tattoo",
		                   "tax",
		                   "taxi",
		                   "tc",
		                   "tci",
		                   cst_td,
		                   "tdk",
		                   cst_team,
		                   "tech",
		                   "technology",
		                   "tel",
		                   "temasek",
		                   "tennis",
		                   "teva",
		                   "tf",
		                   "tg",
		                   cst_th,
		                   "thd",
		                   "theater",
		                   "theatre",
		                   "tiaa",
		                   "tickets",
		                   "tienda",
		                   "tiffany",
		                   "tips",
		                   "tires",
		                   "tirol",
		                   "tj",
		                   "tjmaxx",
		                   "tjx",
		                   "tk",
		                   "tkmaxx",
		                   cst_tl,
		                   "tm",
		                   "tmall",
		                   "tn",
		                   cst_to$0,
		                   cst_today,
		                   "tokyo",
		                   cst_tools,
		                   "top",
		                   "toray",
		                   "toshiba",
		                   cst_total,
		                   "tours",
		                   "town",
		                   "toyota",
		                   "toys",
		                   cst_tr,
		                   "trade",
		                   "trading",
		                   "training",
		                   "travel",
		                   "travelchannel",
		                   "travelers",
		                   "travelersinsurance",
		                   cst_trust,
		                   "trv",
		                   "tt",
		                   "tube",
		                   "tui",
		                   "tunes",
		                   "tushu",
		                   "tv",
		                   "tvs",
		                   "tw",
		                   "tz",
		                   "ua",
		                   "ubank",
		                   "ubs",
		                   "ug",
		                   "uk",
		                   "unicom",
		                   "university",
		                   "uno",
		                   "uol",
		                   "ups",
		                   cst_us,
		                   "uy",
		                   "uz",
		                   "va",
		                   "vacations",
		                   "vana",
		                   "vanguard",
		                   "vc",
		                   "ve",
		                   "vegas",
		                   "ventures",
		                   "verisign",
		                   "versicherung",
		                   "vet",
		                   "vg",
		                   "vi",
		                   "viajes",
		                   cst_video,
		                   "vig",
		                   "viking",
		                   "villas",
		                   "vin",
		                   "vip",
		                   "virgin",
		                   "visa",
		                   "vision",
		                   "viva",
		                   "vivo",
		                   "vlaanderen",
		                   "vn",
		                   "vodka",
		                   "volkswagen",
		                   "volvo",
		                   "vote",
		                   "voting",
		                   "voto",
		                   "voyage",
		                   "vu",
		                   "vuelos",
		                   "wales",
		                   "walmart",
		                   "walter",
		                   "wang",
		                   "wanggou",
		                   cst_watch,
		                   "watches",
		                   "weather",
		                   "weatherchannel",
		                   "webcam",
		                   "weber",
		                   cst_website,
		                   "wed",
		                   "wedding",
		                   "weibo",
		                   "weir",
		                   "wf",
		                   "whoswho",
		                   "wien",
		                   "wiki",
		                   "williamhill",
		                   cst_win,
		                   cst_windows,
		                   "wine",
		                   "winners",
		                   "wme",
		                   "wolterskluwer",
		                   "woodside",
		                   "work",
		                   "works",
		                   "world",
		                   "wow",
		                   cst_ws,
		                   "wtc",
		                   "wtf",
		                   "xbox",
		                   "xerox",
		                   "xfinity",
		                   "xihuan",
		                   "xin",
		                   "xxx",
		                   "xyz",
		                   "yachts",
		                   "yahoo",
		                   "yamaxun",
		                   "yandex",
		                   "ye",
		                   "yodobashi",
		                   "yoga",
		                   "yokohama",
		                   "you",
		                   "youtube",
		                   "yt",
		                   "yun",
		                   "za",
		                   "zappos",
		                   "zara",
		                   cst_zero,
		                   "zip",
		                   "zm",
		                   "zone",
		                   "zuerich",
		                   "zw"]),
		              fmt$137 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_h, 0], cst_h]],
		                  [12,
		                   60,
		                   [2,
		                    0,
		                    [15,
		                     [12, 62, [15, [11, cst$57, [2, 0, [12, 62, [17, 0, 0]]]]]]]]]],
		                 "@[<h><%s%a>%a<\/%s>@]"],
		              fmt$134 =
		                [0,
		                 [11, cst_invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 "invalid %s id: %s"],
		              fmt$135 =
		                [0,
		                 [11, "invalid block id: ", [2, 0, 0]],
		                 "invalid block id: %s"],
		              fmt$136 =
		                [0,
		                 [11, "invalid object id: ", [2, 0, 0]],
		                 "invalid object id: %s"],
		              fmt$133 = [0, [12, 35, [15, [15, 0]]], "#%a%a"],
		              fmt$131 = [0, [11, "tag-close ", [3, 0, 0]], "tag-close %S"],
		              fmt$132 = [0, [12, 60, [2, 0, [12, 62, 0]]], cst_s$1],
		              closing_forbidden =
		                caml_list_of_js_array
		                 (["area",
		                   cst_base,
		                   cst_br,
		                   cst_col,
		                   cst_frame,
		                   cst_hr,
		                   "img",
		                   cst_input,
		                   cst_link,
		                   cst_meta,
		                   "param"]),
		              closing_optional =
		                caml_list_of_js_array
		                 ([cst_body,
		                   "dd",
		                   "dt",
		                   cst_head,
		                   cst_html,
		                   cst_li$0,
		                   cst_option,
		                   cst_p,
		                   "tbody",
		                   cst_td,
		                   "tfoot",
		                   cst_th,
		                   "thead",
		                   cst_tr]),
		              value$0 = [6, caml_int64_create_lo_mi_hi(0, 0, 0)],
		              value$1 = [6, caml_int64_create_lo_mi_hi(0, 0, 0)],
		              value$2 = [6, caml_int64_create_lo_mi_hi(0, 0, 0)],
		              fmt$138 =
		                [0,
		                 [15,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    "from Lwt.async at",
		                    [17, [0, cst$4, 1, 0], [12, 39, [2, 0, [12, 39, 0]]]]]]],
		                 "%a@ from Lwt.async at@ '%s'"],
		              fmt$139 = [0, [15, [2, 0, 0]], "%a%s"],
		              t = [0, cst_http],
		              p = [0, 8000],
		              here = [0, [0, "api/controller/lib/event.ml", 32, 1154, 1198]],
		              fmt$140 =
		                [0, [11, "no such identity ", [15, 0]], "no such identity %a"],
		              fmt$141 =
		                [0,
		                 [15, [11, cst_fatal_error$0, [2, 0, [11, cst$9, [15, 0]]]]],
		                 "%afatal error %s: %a"],
		              fmt$142 = [0, [15, 0], cst_a],
		              fmt$144 =
		                [0,
		                 [11, "initializing workspace ", [15, 0]],
		                 "initializing workspace %a"],
		              fmt$143 =
		                [0, [11, "save workspace ", [15, 0]], "save workspace %a"],
		              fmt$145 =
		                [0,
		                 [11,
		                  "nested mutation: ",
		                  [15, [11, " while was ", [15, [11, " being applied", 0]]]]],
		                 "nested mutation: %a while was %a being applied"],
		              fmt$149 = [0, [11, cst_timeline, [15, 0]], cst_timeline_a],
		              fmt$148 = [0, [11, cst_day$0, [15, 0]], cst_day_a],
		              fmt$147 = [0, [11, "event ", [15, 0]], "event %a"],
		              fmt$146 = [0, [11, "calendar ", [15, 0]], "calendar %a"],
		              fmt$150 = [0, [2, 0, [12, 32, [2, 0, 0]]], cst_s_s$0],
		              fmt$151 = [0, [11, cst_events$0, [15, 0]], cst_events_a],
		              fmt$152 = [0, [15, 0], cst_a],
		              fmt$154 = [0, [11, cst_batch$0, [15, 0]], cst_batch_a],
		              fmt$153 =
		                [0, [11, "day entries of ", [15, 0]], "day entries of %a"],
		              a7 = [0, 0, 0, [9, cst_contacts], 0],
		              a8 = [0, 0, 0, [9, cst_calendar], 0],
		              init$3 = [0, 0, 0],
		              fmt$155 = [0, [15, 0], cst_a],
		              fmt$156 =
		                [0,
		                 [11, "synchronized notes for ", [15, 0]],
		                 "synchronized notes for %a"],
		              fmt$157 =
		                [0,
		                 [15, [11, " with synchronized notes", 0]],
		                 "%a with synchronized notes"],
		              fmt$158 = [0, [2, 0, [12, 32, [15, 0]]], "%s %a"],
		              fmt$161 = [0, [15, 0], cst_a],
		              fmt$162 = [0, [15, 0], cst_a],
		              fmt$159 = [0, [15, 0], cst_a],
		              fmt$160 = [0, [15, 0], cst_a],
		              msg = [0, [11, cst_a_contact, 0], cst_a_contact],
		              fmt$163 =
		                [0,
		                 [11, "defaut calendar must be writable ", [15, 0]],
		                 "defaut calendar must be writable %a"],
		              fmt$164 =
		                [0,
		                 [11, "cannot find calendar ", [15, 0]],
		                 "cannot find calendar %a"],
		              fmt$167 =
		                [0,
		                 [11, "no ", [15, [11, " slot found", 0]]],
		                 "no %a slot found"],
		              fmt$166 =
		                [0,
		                 [11,
		                  "could not find a ",
		                  [15, [11, " free spot between ", [15, [11, b, [15, 0]]]]]],
		                 "could not find a %a free spot between %a and %a"],
		              fmt$165 =
		                [0,
		                 [11,
		                  "not enough free time to allocate ",
		                  [15, [11, " after ", [15, 0]]]],
		                 "not enough free time to allocate %a after %a"],
		              fmt$168 =
		                [0,
		                 [11, "Calendar ", [15, [11, cst_not_found, 0]]],
		                 "Calendar %a not found"],
		              x$2 = [0, 479410653, "cannot move task into itself"],
		              x$3 =
		                [0, 479410653, "cannot move task into one of its descendants"],
		              fmt$169 =
		                [0, [11, cst_all_recurrent_tasks, 0], cst_all_recurrent_tasks],
		              fmt$172 =
		                [0,
		                 [11, cst_calendars$0, [15, [11, cst_role$0, 0]]],
		                 cst_calendars_a_role],
		              fmt$170 =
		                [0,
		                 [11, cst_calendars$0, [15, [11, cst_role$0, 0]]],
		                 cst_calendars_a_role],
		              fmt$171 =
		                [0,
		                 [11, cst_calendars$0, [15, [11, ".disabled", 0]]],
		                 "calendars.%a.disabled"],
		              x$4 =
		                [0,
		                 9943782,
		                 "invalid settings: the default calendar must be enabled"],
		              x$6 =
		                [0,
		                 9943782,
		                 "invalid settings: more than one default calendar found"],
		              x$5 =
		                [0,
		                 9943782,
		                 "invalid settings: a default calendar must be defined"],
		              x$7 = [0, 9943782, "newly created event is missing"],
		              fmt$175 = [0, [11, "unmark ", [2, 0, 0]], "unmark %s"],
		              fmt$174 = [0, [11, cst_mark, [2, 0, 0]], cst_mark_s],
		              fmt$173 = [0, [11, cst_mark, [2, 0, 0]], cst_mark_s],
		              filter_archived = [0, 1],
		              fmt$179 = [0, [11, cst_update$0, [15, 0]], cst_update_a],
		              fmt$178 = [0, [11, cst_unarchive, [15, 0]], cst_unarchive_a],
		              fmt$177 = [0, [11, cst_move$0, [15, 0]], cst_move_a],
		              fmt$176 = [0, [11, cst_delete$0, [15, 0]], cst_delete_a],
		              fmt$180 = [0, [15, 0], cst_a],
		              bQ = [0, 0],
		              bR = [0, 0],
		              fmt$187 =
		                [0,
		                 [11, "no such database: ", [15, [12, 47, [15, 0]]]],
		                 "no such database: %a/%a"],
		              fmt$188 =
		                [0,
		                 [11, "no task binding for ", [15, 0]],
		                 "no task binding for %a"],
		              fmt$185 =
		                [0,
		                 [11, "Failed to compile update command: ", [15, 0]],
		                 "Failed to compile update command: %a"],
		              fmt$186 =
		                [0,
		                 [11,
		                  cst_Table,
		                  [15, [11, cst_does_not_exist_or_was_dele, 0]]],
		                 cst_Table_a_does_not_exist_or_],
		              fmt$182 = [0, [11, cst_val, [4, 0, 0, 0, 0]], cst_val_d],
		              fmt$181 = [0, [11, cst_val, [4, 0, 0, 0, 0]], cst_val_d],
		              fmt$183 =
		                [0,
		                 [11, "Failed to compile create command: ", [15, 0]],
		                 "Failed to compile create command: %a"],
		              fmt$184 =
		                [0,
		                 [11,
		                  cst_Table,
		                  [15, [11, cst_does_not_exist_or_was_dele, 0]]],
		                 cst_Table_a_does_not_exist_or_],
		              fmt$189 =
		                [0, [11, "fatal RPC error: ", [15, 0]], "fatal RPC error: %a"],
		              format$23 =
		                [0,
		                 [11,
		                  "no such RPC persistent ",
		                  [2, 0, [11, cst$9, [4, 0, 0, 0, 0]]]],
		                 "no such RPC persistent %s: %d"],
		              fmt$190 =
		                [0,
		                 [11,
		                  cst_resume_expected,
		                  [4,
		                   0,
		                   0,
		                   0,
		                   [11, cst_answer_lists_one_per_quest, [4, 0, 0, 0, 0]]]],
		                 cst_resume_expected_d_answer_l],
		              a9 = [1, "MCP server did not return a tools list"],
		              base =
		                [0,
		                 [0, cst_content_type, cst_application_json],
		                 [0,
		                  [0, cst_accept, "application/json, text/event-stream"],
		                  0]],
		              fmt$198 =
		                [0,
		                 [11, "could not reach MCP server at ", [2, 0, 0]],
		                 "could not reach MCP server at %s"],
		              fmt$197 = [0, [11, "Bearer ", [2, 0, 0]], "Bearer %s"],
		              fmt$196 =
		                [0,
		                 [11,
		                  "server requires protocol version ",
		                  [2, 0, [11, ", we support ", [2, 0, 0]]]],
		                 "server requires protocol version %s, we support %s"],
		              fmt$195 =
		                [0,
		                 [11, "MCP server error: ", [2, 0, 0]],
		                 "MCP server error: %s"],
		              fmt$194 = [0, [2, 0, [11, cst$9, [2, 0, 0]]], cst_s_s$1],
		              fmt$193 =
		                [0,
		                 [2, 0, [11, " returned HTTP ", [4, 0, 0, 0, [2, 0, 0]]]],
		                 "%s returned HTTP %d%s"],
		              fmt$192 = [0, [11, cst$9, [2, 0, 0]], ": %s"],
		              fmt$191 = [0, [11, cst$9, [2, 0, [11, "...", 0]]], ": %s..."],
		              default_annotations = [0, 0, 1, 0, 1],
		              fmt$201 = [0, [11, "Error: ", [2, 0, 0]], "Error: %s"],
		              fmt$199 =
		                [0,
		                 [11, "Error executing tool ", [2, 0, [11, cst$9, [2, 0, 0]]]],
		                 "Error executing tool %s: %s"],
		              fmt$200 =
		                [0, [11, cst_Tool_not_found, [2, 0, 0]], cst_Tool_not_found_s],
		              fmt$211 =
		                [0, [11, "Unknown block id ", [15, 0]], "Unknown block id %a"],
		              fmt$210 =
		                [0,
		                 [11, "Table not found: ", [2, 0, 0]],
		                 "Table not found: %s"],
		              fmt$208 =
		                [0,
		                 [11, "Failed to parse relation target: ", [2, 0, 0]],
		                 "Failed to parse relation target: %s"],
		              fmt$207 =
		                [0,
		                 [11,
		                  cst_Operator,
		                  [2, 0, [11, " not supported on relation field", 0]]],
		                 "Operator %s not supported on relation field"],
		              fmt$206 =
		                [0,
		                 [11,
		                  cst_Operator,
		                  [2, 0, [11, " does not take values, got ", [4, 0, 0, 0, 0]]]],
		                 "Operator %s does not take values, got %d"],
		              fmt$209 =
		                [0,
		                 [11,
		                  cst_Operator,
		                  [2,
		                   0,
		                   [11, " requires exactly one value, got ", [4, 0, 0, 0, 0]]]],
		                 "Operator %s requires exactly one value, got %d"],
		              fmt$204 =
		                [0,
		                 [11, "Invalid boolean value: ", [3, 0, 0]],
		                 "Invalid boolean value: %S"],
		              fmt$205 =
		                [0,
		                 [11, "Invalid integer value: ", [3, 0, 0]],
		                 "Invalid integer value: %S"],
		              fmt$203 =
		                [0, [11, "Unknown field: ", [2, 0, 0]], "Unknown field: %s"],
		              fmt$202 =
		                [0, [11, "Unknown fields: ", [2, 0, 0]], "Unknown fields: %s"],
		              a_ = [0, 0, 0, [9, cst_any], 0],
		              a$ = [0, 0, 0, [9, cst_all], 0],
		              documentation =
		                [0,
		                 "An optional task ID. Any invalid task ID is treated as None."],
		              id$30 = [0, "very-lenient-task-id"],
		              fmt$214 =
		                [0,
		                 [11, cst_invalid_date$1, [3, 0, [11, cst$9, [2, 0, 0]]]],
		                 "invalid date %S: %s"],
		              fmt$215 =
		                [0,
		                 [11, "Column not found: ", [2, 0, 0]],
		                 "Column not found: %s"],
		              fmt$212 =
		                [0,
		                 [11, "failed to run extension row read: ", [15, 0]],
		                 "failed to run extension row read: %a"],
		              fmt$213 =
		                [0,
		                 [11, "Failed to compile extension row read: ", [15, 0]],
		                 "Failed to compile extension row read: %a"],
		              fmt$220 =
		                [0, [11, cst_Invalid_time, [2, 0, 0]], cst_Invalid_time_s],
		              fmt$221 =
		                [0, [11, cst_Invalid_time, [2, 0, 0]], cst_Invalid_time_s],
		              fmt$219 = [0, [15, 0], cst_a],
		              fmt$218 = [0, [15, 0], cst_a],
		              fmt$217 = [0, [15, 0], cst_a],
		              fmt$216 = [0, [15, 0], cst_a],
		              bd = [0, 0, 0, [9, cst_business_hours], 0],
		              ba = [0, 0, 0, [9, cst_timed], 0],
		              bb = [0, 0, 0, [9, cst_all_day], 0],
		              bc = [0, 0, 0, [9, cst_all], 0],
		              fmt$236 = [0, [12, 35, [15, 0]], "#%a"],
		              fmt$224 = [0, [11, "/pages/", [15, 0]], "/pages/%a"],
		              fmt$225 = [0, [11, "/people/", [15, 0]], "/people/%a"],
		              fmt$226 = [0, [11, "/tasks/", [15, 0]], "/tasks/%a"],
		              fmt$227 =
		                [0, [11, "/recurrent-tasks/", [15, 0]], "/recurrent-tasks/%a"],
		              fmt$228 =
		                [0,
		                 [11, "/objects/", [15, [12, 47, [15, [12, 47, [15, 0]]]]]],
		                 "/objects/%a/%a/%a"],
		              fmt$229 =
		                [0, [11, "/organizations/", [15, 0]], "/organizations/%a"],
		              fmt$230 =
		                [0,
		                 [11, "/databases/", [15, [12, 47, [15, 0]]]],
		                 "/databases/%a/%a"],
		              fmt$231 =
		                [0,
		                 [11, "/workspaces/", [15, [12, 47, [15, 0]]]],
		                 "/workspaces/%a/%a"],
		              fmt$232 = [0, [11, cst_agents$0, [15, 0]], cst_agents_a],
		              fmt$233 =
		                [0,
		                 [11,
		                  cst_settings_organizations,
		                  [15, [11, cst_automations$0, [15, 0]]]],
		                 cst_settings_organizations_a_a],
		              fmt$234 = [0, [11, cst_agents$0, [15, 0]], cst_agents_a],
		              fmt$235 =
		                [0,
		                 [11,
		                  cst_settings_organizations,
		                  [15, [11, cst_automations$0, [15, 0]]]],
		                 cst_settings_organizations_a_a],
		              fmt$223 = [0, [11, cst_events$0, [15, 0]], cst_events_a],
		              fmt$222 = [0, [2, 0, [11, "?path=", [2, 0, 0]]], "%s?path=%s"],
		              be = [0, 0, 0, [9, cst_unviewed], 0],
		              bf = [0, 0, 0, [9, cst_viewed], 0],
		              fmt$242 = [0, [15, 0], cst_a],
		              completed = [0, 0],
		              fmt$240 =
		                [0,
		                 [11,
		                  cst_Failed_to_parse,
		                  [2, 0, [11, cst_as_a_date, [2, 0, 0]]]],
		                 cst_Failed_to_parse_s_as_a_dat],
		              fmt$241 =
		                [0,
		                 [11,
		                  cst_Failed_to_parse,
		                  [2, 0, [11, cst_as_a_week, [2, 0, 0]]]],
		                 cst_Failed_to_parse_s_as_a_wee],
		              bS = [0, 0],
		              fmt$239 =
		                [0,
		                 [11,
		                  "No member with id ",
		                  [2, 0, [11, " in this workspace.", 0]]],
		                 "No member with id %s in this workspace."],
		              fmt$237 =
		                [0,
		                 [11,
		                  cst_Failed_to_parse,
		                  [2, 0, [11, cst_as_a_date, [2, 0, 0]]]],
		                 cst_Failed_to_parse_s_as_a_dat],
		              fmt$238 =
		                [0,
		                 [11,
		                  cst_Failed_to_parse,
		                  [2, 0, [11, cst_as_a_week, [2, 0, 0]]]],
		                 cst_Failed_to_parse_s_as_a_wee],
		              bj = [0, 0, 0, [9, cst_unassigned], 0],
		              bk = [0, 0, 0, [9, cst_me], 0],
		              bg = [0, 0, 0, [9, cst_discarded], 0],
		              bh = [0, 0, 0, [9, cst_completed], 0],
		              bi = [0, 0, 0, [9, cst_todo], 0],
		              fmt$250 =
		                [0,
		                 [11,
		                  cst_resume_expected,
		                  [4,
		                   0,
		                   0,
		                   0,
		                   [11, cst_answer_lists_one_per_quest, [4, 0, 0, 0, 0]]]],
		                 cst_resume_expected_d_answer_l],
		              fmt$249 = [0, [15, 0], cst_a],
		              fmt$248 = [0, [15, 0], cst_a],
		              fmt$247 = [0, [15, 0], cst_a],
		              fmt$246 = [0, [15, 0], cst_a],
		              fmt$244 =
		                [0,
		                 [11, cst_Agent_not_found$0, [15, 0]],
		                 cst_Agent_not_found_a],
		              fmt$243 = [0, [15, 0], cst_a],
		              fmt$245 =
		                [0,
		                 [11, cst_Agent_not_found$0, [15, 0]],
		                 cst_Agent_not_found_a],
		              fmt$251 =
		                [0,
		                 [11,
		                  "Tool ",
		                  [3, 0, [11, " from the ", [3, 0, [11, cst_MCP_server, 0]]]]],
		                 "Tool %S from the %S MCP server."],
		              fmt$252 =
		                [0,
		                 [11,
		                  "Tools provided by the ",
		                  [3, 0, [11, cst_MCP_server, 0]]],
		                 "Tools provided by the %S MCP server."],
		              fmt$253 =
		                [0,
		                 [11, "Failed to run integration action: ", [2, 0, 0]],
		                 "Failed to run integration action: %s"],
		              fmt$260 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   'Content-Type: multipart/alternative; boundary="',
		                   [2,
		                    0,
		                    [11,
		                     '"\r\n\r\n--',
		                     [2,
		                      0,
		                      [11,
		                       "\r\nContent-Type: text/plain; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n",
		                       [2,
		                        0,
		                        [11,
		                         cst$62,
		                         [2,
		                          0,
		                          [11,
		                           "\r\nContent-Type: text/html; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n",
		                           [2, 0, [11, cst$62, [2, 0, [11, "--\r\n", 0]]]]]]]]]]]]]],
		                 '%sContent-Type: multipart/alternative; boundary="%s"\r\n\r\n--%s\r\nContent-Type: text/plain; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n%s\r\n--%s\r\nContent-Type: text/html; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n%s\r\n--%s--\r\n'],
		              fmt$259 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   "Content-Type: text/html; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n",
		                   [2, 0, [11, cst$31, 0]]]],
		                 "%sContent-Type: text/html; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n%s\r\n"],
		              fmt$258 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   "Content-Type: text/plain; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n",
		                   [2, 0, [11, cst$31, 0]]]],
		                 "%sContent-Type: text/plain; charset=UTF-8\r\nContent-Transfer-Encoding: base64\r\n\r\n%s\r\n"],
		              fmt$256 =
		                [0,
		                 [2, 0, [11, cst$9, [2, 0, [11, cst$31, 0]]]],
		                 "%s: %s\r\n"],
		              fmt$257 =
		                [0,
		                 [11,
		                  "From: ",
		                  [2,
		                   0,
		                   [11,
		                    "\r\nTo: ",
		                    [2,
		                     0,
		                     [11,
		                      cst$31,
		                      [2,
		                       0,
		                       [2,
		                        0,
		                        [11,
		                         "Subject: =?UTF-8?B?",
		                         [2, 0, [11, "?=\r\nMIME-Version: 1.0\r\n", 0]]]]]]]]]],
		                 "From: %s\r\nTo: %s\r\n%s%sSubject: =?UTF-8?B?%s?=\r\nMIME-Version: 1.0\r\n"],
		              default$1 = [0, 0],
		              default$2 = [0, 0],
		              fmt$255 =
		                [0,
		                 [2, 0, [11, " must not be empty", 0]],
		                 "%s must not be empty"],
		              fmt$254 =
		                [0,
		                 [2,
		                  0,
		                  [11, " must not contain a carriage return or newline", 0]],
		                 "%s must not contain a carriage return or newline"],
		              fmt$261 =
		                [0,
		                 [11,
		                  "MCP server cannot be enabled: generated tool name ",
		                  [3, 0, [11, " conflicts with another enabled server", 0]]],
		                 "MCP server cannot be enabled: generated tool name %S conflicts with another enabled server"],
		              fmt$263 = [0, [11, "HTTP error: ", [15, 0]], "HTTP error: %a"],
		              fmt$262 =
		                [0,
		                 [11,
		                  "Scheme '",
		                  [2, 0, [11, "' is not allowed; use http or https", 0]]],
		                 "Scheme '%s' is not allowed; use http or https"],
		              tool_choice$0 = [0, cst_auto],
		              tool_choice = [0, cst_auto],
		              init$4 = [0, 0],
		              agent_reasoning = [0, 3],
		              pause_message =
		                [0,
		                 948354667,
		                 "You have reached the maximum number of steps allowed in a single turn. Please summarize what you have accomplished so far, and ask the user whether they would like you to continue with the remaining work."],
		              fmt$264 =
		                [0,
		                 [11,
		                  "Give a short title (5 words max, no quotes) for a conversation that starts with this message: ",
		                  [2, 0, 0]],
		                 "Give a short title (5 words max, no quotes) for a conversation that starts with this message: %s"],
		              t$0 = [0, cst_executive_assistant],
		              trigger = [0, 0],
		              fmt$266 =
		                [0,
		                 [11,
		                  "[Demo Inject transcript](https://open.routine.co/automations/",
		                  [2, 0, [11, cst_organizationId, [2, 0, [12, 41, 0]]]]],
		                 "[Demo Inject transcript](https://open.routine.co/automations/%s?organizationId=%s)"],
		              fmt$267 =
		                [0,
		                 [11,
		                  "[Demo Prepare meeting](https://open.routine.co/automations/",
		                  [2, 0, [11, cst_organizationId, [2, 0, [12, 41, 0]]]]],
		                 "[Demo Prepare meeting](https://open.routine.co/automations/%s?organizationId=%s)"],
		              fmt$268 =
		                [0,
		                 [11,
		                  cst_The_triggering_object_is_a,
		                  [2, 0, [11, cst_row_Get_it_If_it_does_not_, 0]]],
		                 cst_The_triggering_object_is_a$0],
		              fmt$269 =
		                [0,
		                 [11,
		                  "Create a row in the `",
		                  [2,
		                   0,
		                   [11,
		                    "` table with Title 'Offer discount to customer?' with a Notes field containing 4 blocks:",
		                    0]]],
		                 "Create a row in the `%s` table with Title 'Offer discount to customer?' with a Notes field containing 4 blocks:"],
		              fmt$270 =
		                [0,
		                 [11,
		                  "Then try to find if there is a relevant bug report in the `",
		                  [2, 0, [11, cst_table$0, 0]]],
		                 "Then try to find if there is a relevant bug report in the `%s` table."],
		              fmt$271 =
		                [0,
		                 [11,
		                  "If it is a complaint, try to identify the customer and to find their record in the `",
		                  [2, 0, [11, cst_table$0, 0]]],
		                 "If it is a complaint, try to identify the customer and to find their record in the `%s` table."],
		              fmt$272 =
		                [0,
		                 [11,
		                  cst_The_triggering_object_is_a,
		                  [2,
		                   0,
		                   [11,
		                    "` Gmail inbox email, marking the arrival of a new email.",
		                    0]]],
		                 "The triggering object is a `%s` Gmail inbox email, marking the arrival of a new email."],
		              fmt$273 =
		                [0,
		                 [11,
		                  "Then if you sent the emails, set the 'Customers notified' field on the triggering `",
		                  [2, 0, [11, "` row to true.", 0]]],
		                 "Then if you sent the emails, set the 'Customers notified' field on the triggering `%s` row to true."],
		              fmt$274 =
		                [0,
		                 [11,
		                  "Else, if its 'Status' field is 'Completed' and its 'Customers notified' field is false, proceed to notify the affected customers: read the 'Affected customers' field from the linked bug report row in its 'Bug report' field, in `",
		                  [2,
		                   0,
		                   [11,
		                    "`. Send a >Gmail email to each customer letting them know the fix is live.",
		                    0]]],
		                 "Else, if its 'Status' field is 'Completed' and its 'Customers notified' field is false, proceed to notify the affected customers: read the 'Affected customers' field from the linked bug report row in its 'Bug report' field, in `%s`. Send a >Gmail email to each customer letting them know the fix is live."],
		              fmt$275 =
		                [0,
		                 [11,
		                  cst_The_triggering_object_is_a,
		                  [2, 0, [11, cst_row_Get_it_If_it_does_not_, 0]]],
		                 cst_The_triggering_object_is_a$0],
		              fmt$276 =
		                [0,
		                 [11,
		                  "If state is 'closed', read the issue URL from the row, then call `searchTableRows` on `",
		                  [2,
		                   0,
		                   [11,
		                    "` to find the row whose 'GitHub issue URL' matches, and set its Status to 'Completed'.",
		                    0]]],
		                 "If state is 'closed', read the issue URL from the row, then call `searchTableRows` on `%s` to find the row whose 'GitHub issue URL' matches, and set its Status to 'Completed'."],
		              fmt$277 =
		                [0,
		                 [11,
		                  cst_The_triggering_object_is_a,
		                  [2,
		                   0,
		                   [11,
		                    "` GitHub issue. Get it. If it does not exist, do nothing and finish.",
		                    0]]],
		                 "The triggering object is a `%s` GitHub issue. Get it. If it does not exist, do nothing and finish."],
		              fmt$278 =
		                [0,
		                 [11,
		                  cst_The_triggering_object_is_a,
		                  [2, 0, [11, cst_row_Get_it_If_it_does_not_, 0]]],
		                 cst_The_triggering_object_is_a$0],
		              fmt$279 =
		                [0,
		                 [11,
		                  "Otherwise, if its 'Status' field is 'in-progress' and its 'Ticket created' field is false, create a row in the `",
		                  [2,
		                   0,
		                   [11,
		                    "` table with: Title matching the bug report Title, Status = 'Launchpad', Automate = true, and link the 'Bug report' relation to the triggering bug report, using its compound object id - use it directly, do not construct it manually. Then set the 'Ticket created' field on the triggering object to true.",
		                    0]]],
		                 "Otherwise, if its 'Status' field is 'in-progress' and its 'Ticket created' field is false, create a row in the `%s` table with: Title matching the bug report Title, Status = 'Launchpad', Automate = true, and link the 'Bug report' relation to the triggering bug report, using its compound object id - use it directly, do not construct it manually. Then set the 'Ticket created' field on the triggering object to true."],
		              fmt$280 =
		                [0,
		                 [11,
		                  cst_The_triggering_object_is_a,
		                  [2, 0, [11, cst_row_Get_it_If_it_does_not_, 0]]],
		                 cst_The_triggering_object_is_a$0],
		              fmt$281 =
		                [0,
		                 [11,
		                  "Update bug reports description and status following what is indicated in the transcript. To update a bug report: call `searchTableRows` on the `",
		                  [2,
		                   0,
		                   [11,
		                    "` table, find the row whose title matches the bug discussed, and update its Status column to e.g. 'in-progress'.",
		                    0]]],
		                 "Update bug reports description and status following what is indicated in the transcript. To update a bug report: call `searchTableRows` on the `%s` table, find the row whose title matches the bug discussed, and update its Status column to e.g. 'in-progress'."],
		              fmt$282 =
		                [0,
		                 [11,
		                  "Scan the 'Demo Product Meeting' events from 1 and 2 weeks ago, and the `",
		                  [2,
		                   0,
		                   [11,
		                    "` table. Identify high-severity bugs with enterprise customers affected. Generate a meeting agenda for today's 'Demo Product Meeting', send it to event attendees with an email address via >Gmail, and also post it to >Slack #test-integration-app-bot.",
		                    0]]],
		                 "Scan the 'Demo Product Meeting' events from 1 and 2 weeks ago, and the `%s` table. Identify high-severity bugs with enterprise customers affected. Generate a meeting agenda for today's 'Demo Product Meeting', send it to event attendees with an email address via >Gmail, and also post it to >Slack #test-integration-app-bot."],
		              value$3 = [4, 0],
		              triggered_automation_names =
		                [0,
		                 cst_Demo_Post_meeting_summary,
		                 [0,
		                  cst_Demo_Create_ticket,
		                  [0,
		                   cst_Demo_Summon_cursor,
		                   [0,
		                    cst_Demo_Close_ticket,
		                    [0,
		                     cst_Demo_Notify_customers,
		                     [0,
		                      cst_Demo_Handle_complaint,
		                      [0, cst_Demo_Act_on_decision, 0]]]]]]],
		              fmt$265 =
		                [0,
		                 [11,
		                  "Before starting with your main instructions, create a single new row in the `",
		                  [2,
		                   0,
		                   [11,
		                    "` table with: Name = '",
		                    [2,
		                     0,
		                     [11,
		                      "', Status = 'In Progress'. Then proceed with your main instructions. Once finished processing your main instructions, update this `",
		                      [2,
		                       0,
		                       [11,
		                        "` row you created. Update the 'Notes' field of this row with a paragraph block (no id) with the current timestamp and a short summary of what you did, and then two additional blocks (no id) for each failed tool call ; one code block with the error message, and a paragraph block with your reasoning for the tool call and its input. Finally, set the Status field of this row to 'Completed', and its 'Success' field to true if the automation run succeeded, or false if you could not complete your main instructions.",
		                        0]]]]]]],
		                 "Before starting with your main instructions, create a single new row in the `%s` table with: Name = '%s', Status = 'In Progress'. Then proceed with your main instructions. Once finished processing your main instructions, update this `%s` row you created. Update the 'Notes' field of this row with a paragraph block (no id) with the current timestamp and a short summary of what you did, and then two additional blocks (no id) for each failed tool call ; one code block with the error message, and a paragraph block with your reasoning for the tool call and its input. Finally, set the Status field of this row to 'Completed', and its 'Success' field to true if the automation run succeeded, or false if you could not complete your main instructions."],
		              y = [4, 0],
		              fmt$291 =
		                [0,
		                 [11,
		                  "token endpoint returned unsupported token type ",
		                  [2, 0, 0]],
		                 "token endpoint returned unsupported token type %s"],
		              fmt$290 =
		                [0,
		                 [11, "could not reach token endpoint at ", [2, 0, 0]],
		                 "could not reach token endpoint at %s"],
		              fmt$289 =
		                [0,
		                 [2, 0, [11, " answered without asking for authorization", 0]],
		                 "%s answered without asking for authorization"],
		              t$1 = [0, 401, [0, 403, 0]],
		              fmt$288 =
		                [0,
		                 [11, "the OAuth redirect never arrived: ", [2, 0, 0]],
		                 "the OAuth redirect never arrived: %s"],
		              fmt$287 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   " names several authorization servers (",
		                   [2,
		                    0,
		                    [11, "); which one to authorize with has to be chosen", 0]]]],
		                 "%s names several authorization servers (%s); which one to authorize with has to be chosen"],
		              fmt$286 =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   " is not an authorization server advertised by ",
		                   [2, 0, 0]]],
		                 "%s is not an authorization server advertised by %s"],
		              fmt$285 =
		                [0,
		                 [11, "no metadata URL to try for ", [2, 0, 0]],
		                 "no metadata URL to try for %s"],
		              fmt$284 = [0, [2, 0, [11, cst$9, [2, 0, 0]]], cst_s_s$1],
		              fmt$283 =
		                [0, [11, "could not reach ", [2, 0, 0]], "could not reach %s"],
		              fmt$292 =
		                [0,
		                 [11,
		                  "MCP server cannot be saved: generated tool name ",
		                  [3, 0, [11, " conflicts with another configured server", 0]]],
		                 "MCP server cannot be saved: generated tool name %S conflicts with another configured server"],
		              fmt$298 =
		                [0,
		                 [11, "Automation run failed: ", [2, 0, 0]],
		                 "Automation run failed: %s"],
		              fmt$297 = [0, [11, "Step ", [4, 0, 0, 0, 0]], "Step %d"],
		              fmt$296 =
		                [0,
		                 [11, cst_automations$0, [15, [11, "/runs/", [15, 0]]]],
		                 "/automations/%a/runs/%a"],
		              initial_acc = [0, [0, 0, 0]],
		              fmt$295 =
		                [0,
		                 [11, "Q: ", [2, 0, [11, "\nA: ", [2, 0, 0]]]],
		                 "Q: %s\nA: %s"],
		              fmt$294 =
		                [0,
		                 [11, "Rich response JSON parse error: ", [2, 0, 0]],
		                 "Rich response JSON parse error: %s"],
		              fmt$293 =
		                [0,
		                 [11, "Rich response decode error: ", [2, 0, 0]],
		                 "Rich response decode error: %s"],
		              default$3 = [0, 0, 0, 0],
		              fmt$300 =
		                [0, [11, cst_Tool_not_found, [2, 0, 0]], cst_Tool_not_found_s],
		              fmt$299 = [0, [2, 0, [11, cst$9, [2, 0, 0]]], cst_s_s$1],
		              fmt$302 =
		                [0,
		                 [11, cst_Invalid_timezone, [2, 0, 0]],
		                 cst_Invalid_timezone_s],
		              fmt$303 =
		                [0,
		                 [11, cst_Invalid_timezone, [2, 0, 0]],
		                 cst_Invalid_timezone_s],
		              fmt$304 =
		                [0,
		                 [11, cst_unable_to_fetch, [15, [11, cst$9, [15, 0]]]],
		                 cst_unable_to_fetch_a_a],
		              fmt$305 = [0, [11, "downloading ", [15, 0]], "downloading %a"],
		              fmt$307 =
		                [0,
		                 [2, 0, [4, 0, 0, 0, [12, 58, [4, 0, 0, 0, 0]]]],
		                 "%s%d:%d"],
		              fmt$306 = [0, [2, 0, [4, 0, 0, 0, 0]], "%s%d"],
		              fmt$308 = [0, [11, cst_fatal_error, [15, 0]], cst_fatal_error_a],
		              fmt$309 =
		                [0,
		                 [11, "upgrade required: ", [15, 0]],
		                 "upgrade required: %a"],
		              fmt$310 = [0, [2, 0, [11, cst$9, [2, 0, 0]]], cst_s_s$1],
		              fmt$311 = [0, [11, cst_fatal_error, [15, 0]], cst_fatal_error_a],
		              format$26 =
		                [0,
		                 [11, "no key in hotkey: ", [15, 0]],
		                 "no key in hotkey: %a"],
		              format$25 =
		                [0,
		                 [11, "extra key in hotkey: ", [15, 0]],
		                 "extra key in hotkey: %a"],
		              init$5 = [0, 0, [0, 0, 0, 0, 0]],
		              format$24 =
		                [0, [11, "invalid key: ", [2, 0, 0]], "invalid key: %s"],
		              fmt$318 = [0, [15, 0], cst_a],
		              fmt$317 = [0, [15, 0], cst_a],
		              fmt$316 = [0, [15, 0], cst_a],
		              fmt$315 = [0, [15, 0], cst_a],
		              fmt$314 = [0, [15, 0], cst_a],
		              fmt$313 = [0, [15, 0], cst_a],
		              fmt$312 = [0, [15, 0], cst_a],
		              fmt$319 =
		                [0,
		                 [11, cst_rich_text_parse_error, [2, 0, 0]],
		                 cst_rich_text_parse_error_s],
		              bW = [0, 0],
		              dq = [0, 0],
		              eo = [0, 1],
		              em = [0, "Sexplib.Conv.Of_sexp_error"],
		              en = [0, cst_src_sexp_conv_ml, 406, 15],
		              el = [0, 0],
		              ep =
		                [0,
		                 [11,
		                  "Char.of_int_exn got integer out of range: ",
		                  [4, 0, 0, 0, 0]],
		                 "Char.of_int_exn got integer out of range: %d"],
		              param =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Uncaught exception:",
		                   [17,
		                    3,
		                    [17,
		                     3,
		                     [18,
		                      [1, [0, 0, cst$1]],
		                      [15, [17, 0, [17, 0, [17, 3, [17, 4, 0]]]]]]]]]],
		                 "@[<2>Uncaught exception:@\n@\n@[%a@]@]@\n@."],
		              ev = [0, 2],
		              eu = [0, cst_src_exn_ml, 53, 6],
		              es = [0, "exn.ml.Reraised"],
		              et = [0, cst_src_exn_ml, 32, 11],
		              eq = [0, "exn.ml.Finally"],
		              er = [0, cst_src_exn_ml, 19, 11],
		              ew = caml_int64_create_lo_mi_hi(0, 0, 0),
		              ex =
		                [0,
		                 [11, "Negative position: ", [4, 0, 0, 0, 0]],
		                 "Negative position: %d"],
		              ey =
		                [0,
		                 [11, "Negative length: ", [4, 0, 0, 0, 0]],
		                 "Negative length: %d"],
		              ez =
		                [0,
		                 [11,
		                  "pos + len past end: ",
		                  [4,
		                   0,
		                   0,
		                   0,
		                   [11, " + ", [4, 0, 0, 0, [11, cst$22, [4, 0, 0, 0, 0]]]]]],
		                 "pos + len past end: %d + %d > %d"],
		              eE = [0, "list.ml.Transpose_got_lists_of_different_lengths"],
		              eF = [0, cst_src_list_ml, 1588, 11],
		              eD = [0, cst_src_list_ml, 1111, 4],
		              eC = [0, [11, "List.init ", [4, 0, 0, 0, 0]], "List.init %d"],
		              eB =
		                [0,
		                 [11,
		                  "length mismatch in ",
		                  [2,
		                   0,
		                   [11, cst$9, [4, 0, 0, 0, [11, cst$23, [4, 0, 0, 0, 0]]]]]],
		                 "length mismatch in %s: %d <> %d"],
		              eA =
		                [0,
		                 [11,
		                  "List.nth_exn ",
		                  [4,
		                   0,
		                   0,
		                   0,
		                   [11, " called on list of length ", [4, 0, 0, 0, 0]]]],
		                 "List.nth_exn %d called on list of length %d"],
		              eQ = [0, "src/info.ml", 261, 6],
		              eP = [0, [0, "cycle while computing message"]],
		              eG = [0, cst_Could_not_construct],
		              eH = [0, cst_String],
		              eI = [0, cst_Exn],
		              eJ = [0, cst_Sexp],
		              eK = [0, cst_Tag_sexp],
		              eL = [0, cst_Tag_t],
		              eM = [0, cst_Tag_arg],
		              eN = [0, cst_Of_list],
		              eO = [0, cst_With_backtrace],
		              eR = [0, cst_Neg],
		              eS = [0, cst_Zero],
		              eT = [0, cst_Pos],
		              eU = [0, "src/comparable.ml", 135, 4],
		              eW = [0, "src/bool.ml", 59, 2],
		              eV =
		                [0,
		                 [11,
		                  "Bool.of_string: expected true or false but got ",
		                  [2, 0, 0]],
		                 "Bool.of_string: expected true or false but got %s"],
		              eX = [0, "src/sequence.ml", 304, 14],
		              eZ = [0, cst_src_array_ml, 917, 6],
		              eY = [0, cst_src_array_ml, 486, 14],
		              e5 = [0, cst_src_float0_ml, 186, 4],
		              e4 = [0, cst_src_float0_ml, 190, 4],
		              e2 = caml_int64_create_lo_mi_hi(16777215, 16777215, 65535),
		              e3 = caml_int64_create_lo_mi_hi(1, 0, 0),
		              e1 = caml_int64_create_lo_mi_hi(0, 0, 0),
		              e0 = [0, caml_int64_create_lo_mi_hi(0, 0, 0)],
		              e6 =
		                [0,
		                 2147483647,
		                 2147483647,
		                 46340,
		                 1290,
		                 215,
		                 73,
		                 35,
		                 21,
		                 14,
		                 10,
		                 8,
		                 7,
		                 5,
		                 5,
		                 4,
		                 4,
		                 3,
		                 3,
		                 3,
		                 3,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1],
		              e_ =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   cst$24,
		                   [12,
		                    37,
		                    [12, 32, [2, 0, [11, cst_in_core_int_ml_divisor_sho, 0]]]]]],
		                 cst_s_s_in_core_int_ml_divisor],
		              e9 =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   32,
		                   [12,
		                    37,
		                    [12, 32, [2, 0, [11, cst_in_core_int_ml_modulus_sho, 0]]]]]],
		                 cst_s_s_in_core_int_ml_modulus],
		              e8 =
		                [0,
		                 [11, cst_integer_overflow_in_pow, 0],
		                 cst_integer_overflow_in_pow],
		              e7 =
		                [0,
		                 [11, cst_exponent_can_not_be_negati, 0],
		                 cst_exponent_can_not_be_negati],
		              e$ =
		                [0,
		                 [11, "Char.get_digit_exn ", [1, [11, ": not a digit", 0]]],
		                 "Char.get_digit_exn %C: not a digit"],
		              fi = [0, cst_src_string_ml, 2006, 4],
		              fh = [0, cst_src_string_ml, 1872, 2],
		              fg = [0, [3, 0, 0], a],
		              ff =
		                [0,
		                 [11, "String.chop_suffix_exn ", [3, 0, [12, 32, [3, 0, 0]]]],
		                 "String.chop_suffix_exn %S %S"],
		              fe = [0, cst_src_string_ml, 925, 4],
		              fd = [0, cst_src_string_ml, 761, 17],
		              fc = [0, "String.rsplit2_exn: not found"],
		              fb = [0, "String.lsplit2_exn: not found"],
		              fa =
		                [0,
		                 [11,
		                  "String.is_substring_at: invalid index ",
		                  [4,
		                   0,
		                   0,
		                   0,
		                   [11, " for string of length ", [4, 0, 0, 0, 0]]]],
		                 "String.is_substring_at: invalid index %d for string of length %d"],
		              fn =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   cst$24,
		                   [12,
		                    37,
		                    [12, 32, [2, 0, [11, cst_in_core_int_ml_divisor_sho, 0]]]]]],
		                 cst_s_s_in_core_int_ml_divisor],
		              fm =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   32,
		                   [12,
		                    37,
		                    [12, 32, [2, 0, [11, cst_in_core_int_ml_modulus_sho, 0]]]]]],
		                 cst_s_s_in_core_int_ml_modulus],
		              fl =
		                [0,
		                 [11, cst_argument_must_be_strictly_, 0],
		                 cst_argument_must_be_strictly_],
		              fk =
		                [0,
		                 [11,
		                  "Int.of_float: argument (",
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_out_of_range_or_NaN, 0]]],
		                 "Int.of_float: argument (%f) is out of range or NaN"],
		              fj =
		                [0, [11, "Int.of_string: ", [3, 0, 0]], "Int.of_string: %S"],
		              fo = [0, "src/uniform_array.ml", 347, 6],
		              fq =
		                [0,
		                 [11,
		                  "Uchar.of_int_exn got a invalid Unicode scalar value: ",
		                  [4, 8, [0, 2, 4], 0, 0]],
		                 "Uchar.of_int_exn got a invalid Unicode scalar value: %04X"],
		              fp = [0, [11, cst_U, [4, 8, [0, 2, 4], 0, 0]], cst_U_04X],
		              fs = [0, 0],
		              fr = [0, cst_T],
		              fG = [0, 0, 0],
		              fF = [0, 0, 0, 0],
		              fD = [0, "set.ml.Tree0.Set_max_elt_exn_of_empty_set"],
		              fE = [0, cst_src_set_ml, 289, 13],
		              fB = [0, "set.ml.Tree0.Set_min_elt_exn_of_empty_set"],
		              fC = [0, cst_src_set_ml, 276, 13],
		              ft = [0, cst_src_set_ml, 169, 17],
		              fu = [0, cst_src_set_ml, 170, 28],
		              fv = [0, cst_src_set_ml, 176, 21],
		              fw = [0, cst_src_set_ml, 178, 12],
		              fx = [0, cst_src_set_ml, 185, 17],
		              fy = [0, cst_src_set_ml, 186, 28],
		              fz = [0, cst_src_set_ml, 192, 21],
		              fA = [0, cst_src_set_ml, 194, 12],
		              fH = [0, "src/nothing.ml", 6, 31],
		              f0 = [1, 0],
		              f1 = [1, 0],
		              f2 = [1, 0],
		              fO = [0, 0, 0, 0],
		              fX = [0, 0],
		              fZ = [0, cst_src_map_ml, 1967, 6],
		              fY = [0, 0],
		              fW = [0, cst_src_map_ml, 1145, 17],
		              fV = [0, 0, 0],
		              fT = [0, "map.ml.Tree0.Map_max_elt_exn_of_empty_map"],
		              fU = [0, cst_src_map_ml, 677, 13],
		              fR = [0, "map.ml.Tree0.Map_min_elt_exn_of_empty_map"],
		              fS = [0, cst_src_map_ml, 664, 13],
		              fQ = [0, "Map.find_exn: not found"],
		              fP = [0, cst_src_map_ml, 578, 4],
		              fN = [0, cst_src_map_ml, 480, 21],
		              fM = [1, 0],
		              fK = [0, cst_src_map_ml, 248, 18],
		              fL = [0, cst_src_map_ml, 263, 18],
		              fI = [0, "map.ml.Duplicate"],
		              fJ = [0, cst_src_map_ml, 67, 11],
		              f4 = [0, "src/int64.ml", 115, 2],
		              f3 =
		                [0,
		                 [11,
		                  "Int64.of_float: argument (",
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_out_of_range_or_NaN, 0]]],
		                 "Int64.of_float: argument (%f) is out of range or NaN"],
		              f9 =
		                [0,
		                 [11,
		                  "Int63.of_float: argument (",
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_out_of_range_or_NaN, 0]]],
		                 "Int63.of_float: argument (%f) is out of range or NaN"],
		              f8 = caml_int64_create_lo_mi_hi(0, 0, 0),
		              f7 =
		                [0,
		                 [11, "Int63.of_string: invalid input ", [3, 0, 0]],
		                 "Int63.of_string: invalid input %S"],
		              f5 = caml_int64_create_lo_mi_hi(2, 0, 0),
		              f6 = caml_int64_create_lo_mi_hi(1, 0, 0),
		              gd = [0, cst_src_avltree_ml, 389, 15],
		              ge = [0, cst_src_avltree_ml, 406, 20],
		              ga = [0, cst_src_avltree_ml, 129, 30],
		              f$ = [0, cst_src_avltree_ml, 110, 26],
		              gc = [0, cst_src_avltree_ml, 163, 30],
		              gb = [0, cst_src_avltree_ml, 145, 26],
		              f_ = [0, cst_src_avltree_ml, 87, 22],
		              gq =
		                [0,
		                 [11,
		                  "exponent ",
		                  [4,
		                   0,
		                   0,
		                   0,
		                   [11, cst_out_of_range_0, [4, 0, 0, 0, [12, 93, 0]]]]],
		                 "exponent %d out of range [0, %d]"],
		              gr =
		                [0,
		                 [11,
		                  "mantissa ",
		                  [2, 0, [11, cst_out_of_range_0, [2, 0, [12, 93, 0]]]]],
		                 "mantissa %s out of range [0, %s]"],
		              gp = [0, "src/float.ml", 865, 2],
		              gm =
		                [0,
		                 [11,
		                  "to_string_hum: invalid argument ~decimals=",
		                  [4, 0, 0, 0, 0]],
		                 "to_string_hum: invalid argument ~decimals=%d"],
		              gn = [0, [8, [0, 1, 0], 0, 1, 0], "%+.*f"],
		              go = [0, [8, [0, 0, 0], 0, 1, 0], "%.*f"],
		              gk =
		                [0,
		                 [11,
		                  cst_Float_int63_round_nearest_,
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_too_large, 0]]],
		                 "Float.int63_round_nearest_portable_alloc_exn: argument (%f) is too large"],
		              gl =
		                [0,
		                 [11,
		                  cst_Float_int63_round_nearest_,
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_too_small_or_NaN, 0]]],
		                 "Float.int63_round_nearest_portable_alloc_exn: argument (%f) is too small or NaN"],
		              gi =
		                [0,
		                 [11,
		                  cst_Float_iround_down_exn_argu,
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_too_large, 0]]],
		                 "Float.iround_down_exn: argument (%f) is too large"],
		              gj =
		                [0,
		                 [11,
		                  cst_Float_iround_down_exn_argu,
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_too_small_or_NaN, 0]]],
		                 "Float.iround_down_exn: argument (%f) is too small or NaN"],
		              gg =
		                [0,
		                 [11,
		                  cst_Float_iround_up_exn_argume,
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_too_large, 0]]],
		                 "Float.iround_up_exn: argument (%f) is too large"],
		              gh =
		                [0,
		                 [11,
		                  cst_Float_iround_up_exn_argume,
		                  [8, [0, 0, 0], 0, 0, [11, cst_is_too_small_or_NaN, 0]]],
		                 "Float.iround_up_exn: argument (%f) is too small or NaN"],
		              gf =
		                [0, [11, "Float.of_string ", [2, 0, 0]], "Float.of_string %s"],
		              gu = [0, [3, 0, 0], a],
		              gt = [0, [8, [0, 0, 3], 0, 0, 0], "%g"],
		              gs = [0, [7, 0, 0, 0, 0], cst_Ld],
		              opt$1 = [0, 1],
		              gx = [0, [0, 2]],
		              gy = [0, 0],
		              gz = [0, [0, 3]],
		              gA = [0, [0, 1]],
		              gB = [0, [0, 4]],
		              gC = [0, [0, 0]],
		              gw =
		                [0,
		                 [3, 0, [11, ": unknown log level", 0]],
		                 "%S: unknown log level"],
		              gv = [0, 2],
		              gD = [0, "The application log"],
		              hr =
		                [0,
		                 [4,
		                  0,
		                  [0, 2, 4],
		                  0,
		                  [12,
		                   45,
		                   [4,
		                    0,
		                    [0, 2, 2],
		                    0,
		                    [12,
		                     45,
		                     [4,
		                      0,
		                      [0, 2, 2],
		                      0,
		                      [12,
		                       32,
		                       [4,
		                        0,
		                        [0, 2, 2],
		                        0,
		                        [12,
		                         58,
		                         [4, 0, [0, 2, 2], 0, [12, 58, [4, 0, [0, 2, 2], 0, 0]]]]]]]]]]],
		                 "%04d-%02d-%02d %02d:%02d:%02d"],
		              hs = [0, [12, 46, [7, 0, [1, 2], 0, 0]], cst_0_Ld],
		              ht =
		                [0,
		                 [12,
		                  32,
		                  [0, [4, 0, [0, 2, 2], 0, [12, 58, [4, 0, [0, 2, 2], 0, 0]]]]],
		                 " %c%02d:%02d"],
		              hn =
		                [0,
		                 [4,
		                  0,
		                  [0, 2, 4],
		                  0,
		                  [12,
		                   45,
		                   [4,
		                    0,
		                    [0, 2, 2],
		                    0,
		                    [12,
		                     45,
		                     [4,
		                      0,
		                      [0, 2, 2],
		                      0,
		                      [0,
		                       [4,
		                        0,
		                        [0, 2, 2],
		                        0,
		                        [12,
		                         58,
		                         [4, 0, [0, 2, 2], 0, [12, 58, [4, 0, [0, 2, 2], 0, 0]]]]]]]]]]],
		                 "%04d-%02d-%02d%c%02d:%02d:%02d"],
		              ho = [0, [12, 46, [7, 0, [1, 2], 0, 0]], cst_0_Ld],
		              hq = [0, [12, 90, 0], cst_Z],
		              hp =
		                [0,
		                 [0, [4, 0, [0, 2, 2], 0, [12, 58, [4, 0, [0, 2, 2], 0, 0]]]],
		                 "%c%02d:%02d"],
		              hm = [0, 0, 1],
		              hl = caml_int64_create_lo_mi_hi(0, 0, 0),
		              hk = [0, 0],
		              hh = [0, 0],
		              hj = [0, 122, 0],
		              hi = [0, 43, [0, 45, [0, 90, 0]]],
		              hg = caml_int64_create_lo_mi_hi(10, 0, 0),
		              hf = [0, 122, 0],
		              he = [0, 46, [0, 43, [0, 45, [0, 90, 0]]]],
		              hd = [0, 116, [0, 32, 0]],
		              hc = [0, 84, 0],
		              ha = [0, [17, [0, cst$4, 1, 0], [1, 0]], "@ %C"],
		              g_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   "invalid",
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     cst_time,
		                     [17, [0, cst$4, 1, 0], [11, "stamp", [17, 0, 0]]]]]]],
		                 "@[invalid@ time@ stamp@]"],
		              g$ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   "trailing",
		                   [17, [0, cst$4, 1, 0], [11, cst_input, [17, 0, 0]]]]],
		                 "@[trailing@ input@]"],
		              g9 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   "unexpected",
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     cst_end,
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [11,
		                       cst_of,
		                       [17, [0, cst$4, 1, 0], [11, cst_input, [17, 0, 0]]]]]]]]],
		                 "@[unexpected@ end@ of@ input@]"],
		              hb =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   cst_expected,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [12,
		                     97,
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [11,
		                       cst_character,
		                       [17, [0, cst$4, 1, 0], [11, "in:", [15, [17, 0, 0]]]]]]]]]],
		                 "@[expected@ a@ character@ in:%a@]"],
		              g7 = [0, 0, 0, 0],
		              g5 = [0, [4, 0, 0, 0, [11, cst_ps, 0]], "%dps"],
		              g2 = [0, [4, 0, 0, 0, [2, 0, 0]], cst_d_s],
		              g3 = [0, [4, 0, 0, 0, [2, 0, 0]], cst_d_s],
		              g4 =
		                [0,
		                 [4, 0, 0, 0, [12, 46, [4, 0, [0, 2, 3], 0, [2, 0, 0]]]],
		                 "%d.%03d%s"],
		              gZ = [0, [4, 0, 0, 0, [11, cst_min, 0]], cst_dmin],
		              g1 =
		                [0,
		                 [4, 0, 0, 0, [12, 46, [4, 0, [0, 2, 3], 0, [12, 115, 0]]]],
		                 cst_d_03ds],
		              g0 = [0, [4, 0, 0, 0, [12, 115, 0]], cst_ds],
		              gW = [0, [4, 0, 0, 0, [12, 104, 0]], cst_dh],
		              gX = [0, [4, 0, 0, 0, [11, cst_min, 0]], cst_dmin],
		              gY = [0, [4, 0, 0, 0, [12, 115, 0]], cst_ds],
		              gT = [0, [4, 0, 0, 0, [12, 100, 0]], cst_dd],
		              gU = [0, [4, 0, 0, 0, [12, 104, 0]], cst_dh],
		              gV = [0, [4, 0, 0, 0, [11, cst_min, 0]], cst_dmin],
		              gP = [0, [4, 0, 0, 0, [11, "y1d", 0]], "%dy1d"],
		              gQ = [0, [4, 0, 0, 0, [12, 121, 0]], cst_dy],
		              gR = [0, [4, 0, 0, 0, [12, 100, 0]], cst_dd],
		              gS = [0, [4, 0, 0, 0, [12, 104, 0]], cst_dh],
		              gN = [0, [4, 0, 0, 0, [12, 121, 0]], cst_dy],
		              gO = [0, [4, 0, 0, 0, [12, 100, 0]], cst_dd],
		              gJ = caml_int64_create_lo_mi_hi(0, 0, 0),
		              gK = caml_int64_create_lo_mi_hi(0, 0, 0),
		              gL = caml_int64_create_lo_mi_hi(2, 0, 0),
		              gI = caml_int64_create_lo_mi_hi(0, 0, 0),
		              gH = caml_int64_create_lo_mi_hi(0, 0, 0),
		              gF = caml_int64_create_lo_mi_hi(0, 0, 0),
		              gG = caml_int64_create_lo_mi_hi(0, 0, 0),
		              gE = caml_int64_create_lo_mi_hi(0, 0, 0),
		              gM =
		                [0,
		                 caml_int64_create_lo_mi_hi(10817536, 59604, 0),
		                 caml_int64_create_lo_mi_hi(7792640, 5960, 0),
		                 caml_int64_create_lo_mi_hi(779264, 596, 0),
		                 caml_int64_create_lo_mi_hi(10144256, 59, 0),
		                 caml_int64_create_lo_mi_hi(16113920, 5, 0),
		                 caml_int64_create_lo_mi_hi(10000000, 0, 0),
		                 caml_int64_create_lo_mi_hi(1000000, 0, 0),
		                 caml_int64_create_lo_mi_hi(100000, 0, 0),
		                 caml_int64_create_lo_mi_hi(10000, 0, 0),
		                 caml_int64_create_lo_mi_hi(1000, 0, 0),
		                 caml_int64_create_lo_mi_hi(100, 0, 0),
		                 caml_int64_create_lo_mi_hi(10, 0, 0),
		                 caml_int64_create_lo_mi_hi(1, 0, 0)],
		              g6 = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
		              g8 =
		                [0,
		                 4153708,
		                 3853996,
		                 4203428,
		                 4349046,
		                 4200545,
		                 3506557,
		                 4149254],
		              hu = [0, 0],
		              hx = [0, [11, cst_Invalid_bounds, 0], cst_Invalid_bounds],
		              hy = [0, [11, cst_Wrong_padding, 0], cst_Wrong_padding],
		              hz = [0, [11, cst_Malformed_input, 0], cst_Malformed_input],
		              hA = [0, [11, cst_Too_much_input, 0], cst_Too_much_input],
		              hw = [0, "src/base64.ml", 158, 15],
		              hv = [0, [11, cst_Invalid_bounds, 0], cst_Invalid_bounds],
		              hD =
		                [0,
		                 [11, "Bytes.Stream.Error <", [2, 0, [12, 62, 0]]],
		                 "Bytes.Stream.Error <%s>"],
		              hB = [0, [4, 0, 0, 0, [12, 58, 0]], "%d:"],
		              hC =
		                [0, [2, 0, [12, 58, [2, 0, [12, 32, [2, 0, 0]]]]], "%s:%s %s"],
		              hR = [0, cst_src_uutf_ml, 363, 9],
		              hM = [0, -211555818, 3299808],
		              hH = [0, -211558048, 3299808],
		              hN = [0, 684370880, 3299808],
		              hL = [0, 684370880, 427938126],
		              hI = [0, -211558048, 427938126],
		              hJ = [0, cst_src_uutf_ml, 153, 55],
		              hK = [0, 684370880, 427938126],
		              hO = [0, cst_src_uutf_ml, 152, 55],
		              hP = [0, cst_src_uutf_ml, 154, 55],
		              hQ = [0, 684370880, 3455931],
		              hG = [0, cst_src_uutf_ml, 120, 9],
		              hE =
		                [0,
		                 [11,
		                  "invalid bounds (index ",
		                  [4, 0, 0, 0, [11, ", length ", [4, 0, 0, 0, [12, 41, 0]]]]],
		                 "invalid bounds (index %d, length %d)"],
		              hF =
		                [0,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 1,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 2,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 3,
		                 4,
		                 4,
		                 4,
		                 4,
		                 4,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 0],
		              iG = [0, [8, [0, 0, 3], 0, [0, 16], 0], "%.16g"],
		              iD = [0, [11, cst_S, 0], cst_S],
		              iE = [0, [11, cst_M, 0], cst_M],
		              iy = [0, [11, cst_Await, 0], cst_Await],
		              iz = [0, [11, cst_End, 0], cst_End],
		              iA =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   "`Error ",
		                   [18,
		                    [1, [0, 0, cst$1]],
		                    [12, 40, [15, [12, 41, [17, 0, [17, 0, 0]]]]]]]],
		                 "@[`Error @[(%a)@]@]"],
		              iB =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   "`White ",
		                   [18, [1, [0, 0, cst$1]], [3, 0, [17, 0, [17, 0, 0]]]]]],
		                 "@[`White @[%S@]@]"],
		              iC =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   "`Lexeme ",
		                   [18,
		                    [1, [0, 0, cst$1]],
		                    [12, 40, [15, [12, 41, [17, 0, [17, 0, 0]]]]]]]],
		                 "@[`Lexeme @[(%a)@]@]"],
		              iF =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   "`Comment ",
		                   [18,
		                    [1, [0, 0, cst$1]],
		                    [12,
		                     40,
		                     [15, [11, c, [3, 0, [12, 41, [17, 0, [17, 0, 0]]]]]]]]]],
		                 "@[`Comment @[(%a, %S)@]@]"],
		              h3 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   cst_illegal,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     "initial",
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [11,
		                       "BOM",
		                       [17,
		                        [0, cst$4, 1, 0],
		                        [11,
		                         cst_in,
		                         [17,
		                          [0, cst$4, 1, 0],
		                          [11,
		                           cst_character,
		                           [17, [0, cst$4, 1, 0], [11, cst_stream, [17, 0, 0]]]]]]]]]]]]],
		                 "@[illegal@ initial@ BOM@ in@ character@ stream@]"],
		              h4 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   cst_illegal,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11, "escape,", [17, [0, cst$4, 1, 0], 0]]]]],
		                 "@[illegal@ escape,@ "],
		              h6 =
		                [0,
		                 [15,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_not,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [11,
		                      cst_an,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11,
		                        "escaped",
		                        [17, [0, cst$4, 1, 0], [11, cst_character, [17, 0, 0]]]]]]]]]],
		                 "%a@ not@ an@ escaped@ character@]"],
		              h7 =
		                [0,
		                 [15,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_lone,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [11,
		                      cst_low,
		                      [17, [0, cst$4, 1, 0], [11, cst_surrogate, [17, 0, 0]]]]]]]],
		                 "%a@ lone@ low@ surrogate@]"],
		              h8 =
		                [0,
		                 [15,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_lone,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [11,
		                      cst_high,
		                      [17, [0, cst$4, 1, 0], [11, cst_surrogate, [17, 0, 0]]]]]]]],
		                 "%a@ lone@ high@ surrogate@]"],
		              h9 =
		                [0,
		                 [15,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_not,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [12,
		                      97,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11,
		                        cst_hex,
		                        [17, [0, cst$4, 1, 0], [11, cst_digit, [17, 0, 0]]]]]]]]]],
		                 "%a@ not@ a@ hex@ digit@]"],
		              h5 =
		                [0,
		                 [15,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_not,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [12,
		                      97,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11,
		                        cst_low,
		                        [17, [0, cst$4, 1, 0], [11, cst_surrogate, [17, 0, 0]]]]]]]]]],
		                 "%a@ not@ a@ low@ surrogate@]"],
		              h_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   cst_illegal,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     cst_bytes,
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [11,
		                       cst_in,
		                       [17,
		                        [0, cst$4, 1, 0],
		                        [11,
		                         cst_character,
		                         [17,
		                          [0, cst$4, 1, 0],
		                          [11, cst_stream, [17, [0, cst$4, 1, 0], [12, 40, 0]]]]]]]]]]]],
		                 "@[illegal@ bytes@ in@ character@ stream@ ("],
		              h$ = [0, [4, 8, [0, 2, 2], 0, 0], "%02X"],
		              ib = [0, [12, 32, [4, 8, [0, 2, 2], 0, 0]], " %02X"],
		              ia = [0, [12, 41, [17, 0, 0]], ")@]"],
		              ic =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11, cst_expected, [17, [0, cst$4, 1, 0], 0]]],
		                 "@[expected@ "],
		              ie =
		                [0,
		                 [11,
		                  cst_member,
		                  [17, [0, cst$4, 1, 0], [11, cst_name, [17, 0, 0]]]],
		                 "member@ name@]"],
		              ig =
		                [0,
		                 [11,
		                  cst_JSON,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11, "text (JSON value)", [17, 0, 0]]]],
		                 "JSON@ text (JSON value)@]"],
		              ih =
		                [0,
		                 [11,
		                  cst_name,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_separator,
		                    [17, [0, cst$4, 1, 0], [11, "(':')", [17, 0, 0]]]]]],
		                 "name@ separator@ (':')@]"],
		              ii =
		                [0,
		                 [11,
		                  cst_end,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_of,
		                    [17, [0, cst$4, 1, 0], [11, cst_input, [17, 0, 0]]]]]],
		                 "end@ of@ input@]"],
		              ij =
		                [0,
		                 [11,
		                  "JavaScript",
		                  [17, [0, cst$4, 1, 0], [11, cst_comment, [17, 0, 0]]]],
		                 "JavaScript@ comment@]"],
		              ik =
		                [0,
		                 [11,
		                  cst_JSON,
		                  [17, [0, cst$4, 1, 0], [11, cst_value, [17, 0, 0]]]],
		                 "JSON@ value@]"],
		              il =
		                [0,
		                 [11,
		                  cst_member,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_name,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [11,
		                      cst_or,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11,
		                        cst_object,
		                        [17,
		                         [0, cst$4, 1, 0],
		                         [11,
		                          cst_end,
		                          [17,
		                           [0, cst$4, 1, 0],
		                           [11,
		                            "('\"'",
		                            [17,
		                             [0, cst$4, 1, 0],
		                             [11,
		                              cst_or,
		                              [17, [0, cst$4, 1, 0], [11, cst$26, [17, 0, 0]]]]]]]]]]]]]]]],
		                 "member@ name@ or@ object@ end@ ('\"'@ or@ '}')@]"],
		              im =
		                [0,
		                 [11,
		                  cst_value,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_separator,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [11,
		                      cst_or,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11,
		                        cst_object,
		                        [17,
		                         [0, cst$4, 1, 0],
		                         [11,
		                          cst_end,
		                          [17,
		                           [0, cst$4, 1, 0],
		                           [11,
		                            cst$27,
		                            [17,
		                             [0, cst$4, 1, 0],
		                             [11,
		                              cst_or,
		                              [17, [0, cst$4, 1, 0], [11, cst$26, [17, 0, 0]]]]]]]]]]]]]]]],
		                 "value@ separator@ or@ object@ end@ (','@ or@ '}')@]"],
		              io =
		                [0,
		                 [11,
		                  cst_value,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_or,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [11,
		                      cst_array,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11,
		                        cst_end,
		                        [17,
		                         [0, cst$4, 1, 0],
		                         [11,
		                          "(value",
		                          [17,
		                           [0, cst$4, 1, 0],
		                           [11,
		                            cst_or,
		                            [17, [0, cst$4, 1, 0], [11, cst$28, [17, 0, 0]]]]]]]]]]]]]],
		                 "value@ or@ array@ end@ (value@ or@ ']')@]"],
		              ip =
		                [0,
		                 [11,
		                  cst_value,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [11,
		                    cst_separator,
		                    [17,
		                     [0, cst$4, 1, 0],
		                     [11,
		                      cst_or,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11,
		                        cst_array,
		                        [17,
		                         [0, cst$4, 1, 0],
		                         [11,
		                          cst_end,
		                          [17,
		                           [0, cst$4, 1, 0],
		                           [11,
		                            cst$27,
		                            [17,
		                             [0, cst$4, 1, 0],
		                             [11,
		                              cst_or,
		                              [17, [0, cst$4, 1, 0], [11, cst$28, [17, 0, 0]]]]]]]]]]]]]]]],
		                 "value@ separator@ or@ array@ end@ (','@ or@ ']')@]"],
		              iq =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   cst_illegal,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     cst_number,
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [12, 40, [2, 0, [12, 41, [17, 0, 0]]]]]]]]],
		                 "@[illegal@ number@ (%s)@]"],
		              iw =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   cst_illegal,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     "literal",
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [12, 40, [2, 0, [12, 41, [17, 0, 0]]]]]]]]],
		                 "@[illegal@ literal@ (%s)@]"],
		              ix =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11,
		                   cst_illegal,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     cst_character,
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [11,
		                       cst_in,
		                       [17,
		                        [0, cst$4, 1, 0],
		                        [11,
		                         cst_JSON,
		                         [17,
		                          [0, cst$4, 1, 0],
		                          [11,
		                           cst_string,
		                           [17, [0, cst$4, 1, 0], [12, 40, [15, [12, 41, [17, 0, 0]]]]]]]]]]]]]]],
		                 "@[illegal@ character@ in@ JSON@ string@ (%a)@]"],
		              ir =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11, "unclosed", [17, [0, cst$4, 1, 0], 0]]],
		                 "@[unclosed@ "],
		              is = [0, [11, cst_object, [17, 0, 0]], "object@]"],
		              it = [0, [11, cst_array, [17, 0, 0]], "array@]"],
		              iu = [0, [11, cst_comment, [17, 0, 0]], "comment@]"],
		              iv = [0, [11, cst_string, [17, 0, 0]], "string@]"],
		              h2 =
		                [0,
		                 [12, 39, [2, 0, [11, "' (", [15, [12, 41, 0]]]]],
		                 "'%s' (%a)"],
		              h1 = [0, [11, cst_U, [4, 8, [0, 2, 4], 0, 0]], cst_U_04X],
		              hT = [0, [11, cst_Null, 0], cst_Null],
		              hU = [0, [11, cst_Os, 0], cst_Os],
		              hV = [0, [11, cst_Oe, 0], cst_Oe],
		              hW = [0, [11, cst_Ae, 0], cst_Ae],
		              hS = [0, [11, cst_As, 0], cst_As],
		              hX =
		                [0,
		                 [18, [1, [0, 0, cst$1]], [11, "`Name ", [3, 0, [17, 0, 0]]]],
		                 "@[`Name %S@]"],
		              hY =
		                [0,
		                 [18, [1, [0, 0, cst$1]], [11, "`Bool ", [9, 0, [17, 0, 0]]]],
		                 "@[`Bool %b@]"],
		              hZ =
		                [0,
		                 [18, [1, [0, 0, cst$1]], [11, "`Float ", [2, 0, [17, 0, 0]]]],
		                 "@[`Float %s@]"],
		              h0 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [11, "`String ", [3, 0, [17, 0, 0]]]],
		                 "@[`String %S@]"],
		              iM = [0, [17, [0, r, 1, 0], 0], r],
		              iL = [0, [12, 32, 0], cst$7],
		              iK = [0, [11, cst$10, 0], cst$10],
		              iN = [0, [15, [4, 6, 0, [0, 2], [15, 0]]], "%a%.2x%a"],
		              param$0 = [0, [17, 3, [15, [17, 4, 0]]], "@\n%a@."],
		              iP =
		                [0,
		                 [11, cst_Hex_conversion_Hex_string_, 0],
		                 cst_Hex_conversion_Hex_string_],
		              iO =
		                [0,
		                 [11,
		                  "Hex.to_char: ",
		                  [4, 0, 0, 0, [11, " is an invalid char", 0]]],
		                 "Hex.to_char: %d is an invalid char"],
		              iR = [0, [11, cst_Ezjsonm_to_sexp, 0], cst_Ezjsonm_to_sexp],
		              iQ =
		                [0, [11, cst_Ezjsonm_get_string, 0], cst_Ezjsonm_get_string],
		              iS =
		                [0,
		                 [11,
		                  "Bigstringaf.",
		                  [2,
		                   0,
		                   [11,
		                    " invalid range: { buffer_len: ",
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11,
		                      ", off: ",
		                      [4, 0, 0, 0, [11, ", len: ", [4, 0, 0, 0, [11, cst$30, 0]]]]]]]]],
		                 "Bigstringaf.%s invalid range: { buffer_len: %d, off: %d, len: %d }"],
		              iT = [1, "incomplete input"],
		              iY = [1, cst_string],
		              iX = [0, [11, "not char ", [1, 0]], "not char %C"],
		              iW = [0, [11, "char ", [1, 0]], "char %C"],
		              iV = [0, [11, cst_satisfy, [1, 0]], cst_satisfy_C],
		              iU = [0, [11, cst_satisfy, [1, 0]], cst_satisfy_C],
		              i9 = [0, 0],
		              i7 = [0, 0, 0],
		              i6 = [0, cst$1, 0],
		              i2 = [0, cst$1, 0],
		              i3 = [0, cst$1, 0],
		              i4 = [0, 2],
		              i5 = [0, [0, cst$1, 0], 0],
		              i0 = [0, 2],
		              i1 = [0, cst$1, 0],
		              iZ = [0, [12, 37, [4, 8, [0, 2, 2], 0, 0]], "%%%02X"],
		              i8 = [0, 0, 0, 0],
		              i_ = [0, [15, [15, [2, 0, 0]]], "%a%a%s"],
		              i$ = [1, 0],
		              jc =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   cst$35,
		                   [15, [11, "):", [17, [0, cst$4, 1, 0], [15, 0]]]]]],
		                 "%s (%a):@ %a"],
		              jd = [0, [0, "Union {", cst$11]],
		              je = [0, [12, 60, [2, 0, [12, 62, 0]]], cst_s$1],
		              jf =
		                [0,
		                 [12,
		                  60,
		                  [2, 0, [11, "> =", [17, [0, cst$4, 1, 0], [15, 0]]]]],
		                 "<%s> =@ %a"],
		              jn = [0, [0, cst_bool]],
		              jo = [0, [0, cst_date]],
		              jp = [0, [0, cst_float]],
		              jq = [0, [0, cst_ignore]],
		              jr = [0, [0, cst_int]],
		              js = [0, [0, cst_int64]],
		              jt = [0, [0, cst_json]],
		              ju = [0, [0, cst_null]],
		              jv = [0, [0, cst_string]],
		              jw = [0, [0, cst_time]],
		              jx = [0, [0, "time_local"]],
		              jy = [0, [0, cst_any]],
		              jz = [0, cst$33],
		              jm = [0, 0, 0],
		              jk = [0, 0, 0],
		              jl = [0, 0, 0],
		              jj = [0, 0, 0],
		              jg = [0, 1],
		              jh = [0, -1],
		              ji = [0, 1],
		              ja = [0, cst$1, 1, cst$1],
		              jb = [0, cst$12, cst$11],
		              jA = [0, [0, "schematic/src/schemas.ml", 240, 6779, 6828]],
		              jC = [1, 0],
		              jB = [0, [0, "schematic/src/version.ml", 21, 577, 607]],
		              jH = [0, 0],
		              jI = [0, 0],
		              jJ =
		                [0,
		                 [11, "missing required field ", [3, 0, 0]],
		                 "missing required field %S"],
		              jO =
		                [0,
		                 [11,
		                  "no union case was matched for ",
		                  [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]],
		                 "no union case was matched for @[%a@]"],
		              jM =
		                [0,
		                 [11, "invalid key field ", [3, 0, [11, cst$38, [3, 0, 0]]]],
		                 "invalid key field %S = %S"],
		              jK = [0, 0],
		              jL =
		                [0,
		                 [11, cst_expected$0, [3, 0, [11, cst_got, [3, 0, 0]]]],
		                 "expected %S, got %S"],
		              jN =
		                [0,
		                 [11, "missing key field ", [3, 0, 0]],
		                 "missing key field %S"],
		              jG = [0, 0, 0],
		              jE =
		                [0,
		                 [11, cst_expected$0, [2, 0, [11, cst_got, [3, 0, 0]]]],
		                 "expected %s, got %S"],
		              jF =
		                [0,
		                 [11, cst_expected$0, [2, 0, [11, cst_got, [2, 0, 0]]]],
		                 cst_expected_s_got_s],
		              jD = [0, "date_tuple"],
		              jP =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Json_scanner_intf.Bool", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Json_scanner_intf.Bool@ "],
		              jQ = [0, [9, 0, 0], cst_B],
		              jR = [0, [17, 0, [12, 41, 0]], cst$39],
		              jS =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Json_scanner_intf.String", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Json_scanner_intf.String@ "],
		              jT = [0, [3, 0, 0], a],
		              jU = [0, [17, 0, [12, 41, 0]], cst$39],
		              jV =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Json_scanner_intf.Float", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Json_scanner_intf.Float@ "],
		              jW = [0, [8, [0, 0, 5], 0, 0, 0], cst_F],
		              jX = [0, [17, 0, [12, 41, 0]], cst$39],
		              jY =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Json_scanner_intf.Name", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Json_scanner_intf.Name@ "],
		              jZ = [0, [3, 0, 0], a],
		              j0 = [0, [17, 0, [12, 41, 0]], cst$39],
		              kb = [5, 2],
		              kc = [5, 2],
		              ks = [0, 2],
		              kp = [0, 4],
		              kq = [5, 1],
		              kr = [0, 4],
		              ko = [0, 1],
		              km = [5, 0],
		              kn = [0, 3],
		              kl = [0, "schematic/src/json/json_scanner.ml", 341, 10],
		              kj = [0, 0],
		              kk = [0, 0],
		              kh = [0, 1],
		              ki = [0, 0],
		              kd = [5, 2],
		              ke = [5, 2],
		              kf = [5, 2],
		              kg = [5, 2],
		              j1 = [0, [11, cst_expected$0, [15, 0]], "expected %a"],
		              j2 =
		                [0, [11, "illegal escape: ", [15, 0]], "illegal escape: %a"],
		              j3 =
		                [0,
		                 [11, "illegal character in JSON string: ", [0, 0]],
		                 "illegal character in JSON string: %c"],
		              j4 =
		                [0,
		                 [11, "illegal literal (", [2, 0, [12, 41, 0]]],
		                 "illegal literal (%s)"],
		              j5 =
		                [0,
		                 [11, "illegal number (", [2, 0, [12, 41, 0]]],
		                 "illegal number (%s)"],
		              j6 = [0, [11, "unclosed ", [15, 0]], "unclosed %a"],
		              j8 = [0, [0, [11, " not a hex digit", 0]], "%c not a hex digit"],
		              j9 =
		                [0,
		                 [0, [11, " not an escaped character", 0]],
		                 "%c not an escaped character"],
		              j_ =
		                [0,
		                 [15, [11, " not a low surrogate", 0]],
		                 "%a not a low surrogate"],
		              j$ =
		                [0,
		                 [15, [11, " lone low surrogate", 0]],
		                 "%a lone low surrogate"],
		              ka =
		                [0,
		                 [15, [11, " lone high surrogate", 0]],
		                 "%a lone high surrogate"],
		              j7 = [0, [11, cst_U, [4, 8, [0, 2, 4], 0, 0]], cst_U_04X],
		              kv = [0, 1],
		              ku = [0, 1],
		              kt = [0, 0],
		              match$0 = [0, 0],
		              match$1 = [0, 0],
		              kO = [0, cst_core],
		              match$2 = [0, 0],
		              match$3 = [0, 0],
		              match$4 = [0, 0],
		              match$5 = [0, 0],
		              match$6 = [0, 0],
		              match$7 = [0, 0],
		              match$8 = [0, [1, 1]],
		              match$9 = [0, 0],
		              kP = [0, cst_applicator],
		              match$10 = [0, 0],
		              match$11 = [0, 0],
		              match$12 = [0, 0],
		              match$13 = [0, 0],
		              kR = [0, 0],
		              kS = [0, 0],
		              kT = [0, 1],
		              kU = [0, 0],
		              match$14 = [0, 0],
		              kV = [0, 0],
		              kW = [0, 0],
		              kX = [0, 0],
		              kY = [0, 0],
		              kZ = [0, 1],
		              kQ = [0, cst_validation],
		              match$15 = [0, 0],
		              match$16 = [0, 0],
		              match$17 = [0, 0],
		              match$18 = [0, 0],
		              k0 = [0, cst_metadata],
		              k1 = [0, "json_schema_intf"],
		              kN = [1, 1],
		              kw = [0, "uri_reference"],
		              kx = [0, cst_uri],
		              kM = [0, 0],
		              kK = [0, 0],
		              kI = [0, 0],
		              kG = [0, 0],
		              kE = [0, 0],
		              kC = [0, 0],
		              kA = [0, 0],
		              kz = [0, 0, 0, [9, cst_string], 0],
		              kB = [0, 0, 0, [9, cst_object], 0],
		              kD = [0, 0, 0, [9, cst_number], 0],
		              kF = [0, 0, 0, [9, cst_null], 0],
		              kH = [0, 0, 0, [9, cst_integer], 0],
		              kJ = [0, 0, 0, [9, cst_boolean], 0],
		              kL = [0, 0, 0, [9, cst_array], 0],
		              ky = [0, cst_type],
		              match = [0, "additional_properties"],
		              k6 = [0, [1, 0]],
		              k5 = [0, 3, 0],
		              k4 = [0, "https://json-schema.org/draft/2020-12/schema"],
		              k2 = [0, [0, 6, 0]],
		              k3 = [0, [0, 3, 0]],
		              opt$5 = [0, 2],
		              k7 =
		                [0,
		                 [4,
		                  0,
		                  [0, 2, 4],
		                  0,
		                  [12,
		                   45,
		                   [4, 0, [0, 2, 2], 0, [12, 45, [4, 0, [0, 2, 2], 0, 0]]]]],
		                 "%04d-%02d-%02d"],
		              opt$4 = [0, 1],
		              opt$2 = [0, 2],
		              opt$3 = [0, 0],
		              lj = [0, 0],
		              lk = [0, 0],
		              ll = [0, 0],
		              li =
		                [0,
		                 [4,
		                  3,
		                  [0, 2, 4],
		                  0,
		                  [12,
		                   45,
		                   [4, 3, [0, 2, 2], 0, [12, 45, [4, 3, [0, 2, 2], 0, 0]]]]],
		                 "%04i-%02i-%02i"],
		              k8 = [0, 0],
		              k9 = [0, 1],
		              k_ = [0, 2],
		              k$ = [0, 3],
		              la = [0, 4],
		              lb = [0, 5],
		              lc = [0, 6],
		              ld = [0, 7],
		              le = [0, 8],
		              lf = [0, 9],
		              lg = [0, 10],
		              lh = [0, 11],
		              lN = [0, 0],
		              lM = [0, 0],
		              lL = [0, 0],
		              lK = [0, 0],
		              lJ = [0, 0],
		              lI = [0, 0],
		              lH = [0, 0],
		              lG = [0, cst_time],
		              lF = [0, 0],
		              lE = [0, 0],
		              lD = [0, 0],
		              lC = [0, 0],
		              lB = [0, 0],
		              lA = [0, 0],
		              lz = [0, 0],
		              ly = [0, 0],
		              lx = [0, 0],
		              lw = [0, 0],
		              lv = [0, 0],
		              lu = [0, 0],
		              lm = [0, 0],
		              ln = [0, 0],
		              lo = [0, 60],
		              lp = [0, 0],
		              lq = [0, 0],
		              lr = [0, 60],
		              ls = [0, 0],
		              lt = [0, 24],
		              lV = [0, [0, "timmy/lib/src/weekday.ml", 45, 889, 914]],
		              lO = [0, 0],
		              lP = [0, 1],
		              lQ = [0, 2],
		              lR = [0, 3],
		              lS = [0, 4],
		              lT = [0, 5],
		              lU = [0, 6],
		              l7 =
		                [0,
		                 [4, 0, 0, 0, [12, 46, [4, 0, [0, 2, 3], 0, [12, 115, 0]]]],
		                 cst_d_03ds],
		              l6 = [0, [4, 3, 0, 0, [12, 115, 0]], "%is"],
		              l5 = [0, [4, 3, 0, 0, [12, 109, 0]], "%im"],
		              l4 = [0, [4, 3, 0, 0, [12, 104, 0]], "%ih"],
		              l3 = [0, [4, 3, 0, 0, [11, cst_days, 0]], "%i days"],
		              l8 = caml_int64_create_lo_mi_hi(0, 0, 0),
		              l9 = caml_int64_create_lo_mi_hi(0, 0, 0),
		              lX = caml_int64_create_lo_mi_hi(10144256, 59, 0),
		              lY = caml_int64_create_lo_mi_hi(24, 0, 0),
		              lZ = caml_int64_create_lo_mi_hi(60, 0, 0),
		              l0 = caml_int64_create_lo_mi_hi(60, 0, 0),
		              l1 = caml_int64_create_lo_mi_hi(1000, 0, 0),
		              l2 = caml_int64_create_lo_mi_hi(10144256, 59, 0),
		              lW = [0, [0, "timmy/lib/src/span.ml", 17, 417, 459]],
		              l$ = [0, 1],
		              l_ = [0, [0, "timmy/lib/src/time.ml", 14, 217, 244]],
		              mi = [0, [11, "last ", [15, 0]], "last %a"],
		              mh =
		                [0,
		                 [15, [12, 32, [15, [12, 32, [4, 3, [0, 2, 4], 0, 0]]]]],
		                 cst_a_a_04i],
		              me = [0, 0, 0, 0],
		              mf = [0, 0, 0, 0],
		              mg = [0, [0, cst_timmy_lib_src_date_ml, 141, 3788, 3813]],
		              md = [0, [0, cst_timmy_lib_src_date_ml, 131, 3546, 3567]],
		              mb = caml_int64_create_lo_mi_hi(0, 0, 0),
		              mc = [0, [0, cst_timmy_lib_src_date_ml, 91, 2375, 2402]],
		              ma = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
		              ml =
		                [0,
		                 [4, 3, [0, 2, 4], 0, [12, 45, [4, 3, [0, 2, 2], 0, 0]]],
		                 "%04i-%02i"],
		              mj = [0, 4],
		              mt = [0, [4, 3, 0, 0, 0], cst_i],
		              mq = [0, [4, 3, [0, 2, 2], 0, 0], "%02i"],
		              ms =
		                [0,
		                 [12,
		                  58,
		                  [4, 3, [0, 2, 2], 0, [12, 58, [4, 3, [0, 2, 2], 0, 0]]]],
		                 ":%02i:%02i"],
		              mr = [0, [12, 58, [4, 3, [0, 2, 2], 0, 0]], ":%02i"],
		              mp =
		                [0,
		                 [4,
		                  3,
		                  [0, 2, 2],
		                  0,
		                  [12,
		                   58,
		                   [4, 3, [0, 2, 2], 0, [12, 58, [4, 3, [0, 2, 2], 0, 0]]]]],
		                 "%02i:%02i:%02i"],
		              mm = [0, cst_seconds],
		              mn = [0, cst_minutes],
		              mo = [0, cst_hours],
		              mu = [0, "Acid"],
		              mv = [0, 0],
		              mz =
		                [0,
		                 [11, "bench ", [2, 0, [11, cst$9, [15, 0]]]],
		                 "bench %s: %a"],
		              mx = [0, [2, 0, [12, 58, [4, 0, 0, 0, 0]]], cst_s_d],
		              mw = caml_int64_create_lo_mi_hi(1000000, 0, 0),
		              my = [0, "The position at which the log was sent"],
		              mA = [0, [0, "acid/src/map.ml", 25, 555, 581]],
		              mB = [0, 0],
		              m2 = [0, cst_src_core_lwt_ml, 2727, 6],
		              m3 = [0, cst_src_core_lwt_ml, 2747, 6],
		              m5 = [0, 0],
		              m4 = [0, 0],
		              m1 = [0, cst_src_core_lwt_ml, 2669, 13],
		              m0 = [0, 0],
		              mZ = [0, 0],
		              mX = [0, 0],
		              mY = [0, 1],
		              mV = [0, 1],
		              mW = [0, 1],
		              mT = [0, 0],
		              mU = [0, 1],
		              mQ = [0, 0],
		              mR = [0, 0],
		              mS = [0, 1],
		              mO = [0, 0],
		              mP = [0, 1],
		              mM = [0, 0],
		              mN = [0, 0],
		              mL = [0, 0],
		              mK = [0, 0],
		              mH = [0, [11, cst_Lwt, [2, 0, 0]], cst_Lwt_s],
		              mI = [0, [11, cst_Lwt, [2, 0, 0]], cst_Lwt_s],
		              mJ = [0, 1],
		              mE = [0, [11, cst_Lwt, [2, 0, 0]], cst_Lwt_s],
		              mF = [0, [11, cst_Lwt, [2, 0, 0]], cst_Lwt_s],
		              mG = [0, 0],
		              mC = [0, cst_src_core_lwt_ml, 984, 23],
		              mD = [0, cst_src_core_lwt_ml, 985, 22],
		              m_ =
		                [0,
		                 [2, 0, [11, ": release  for reading", [15, 0]]],
		                 "%s: release  for reading%a"],
		              m$ =
		                [0,
		                 [2, 0, [11, ": release partially for reading", [15, 0]]],
		                 "%s: release partially for reading%a"],
		              m9 =
		                [0,
		                 [2, 0, [11, ": acquire additionally for reading", [15, 0]]],
		                 "%s: acquire additionally for reading%a"],
		              m7 =
		                [0,
		                 [2, 0, [11, ": acquire for reading", [15, 0]]],
		                 "%s: acquire for reading%a"],
		              m6 =
		                [0,
		                 [2, 0, [11, ": block acquiring for reading", [15, 0]]],
		                 "%s: block acquiring for reading%a"],
		              m8 = [0, 1],
		              n3 = [0, [15, [11, b, [15, 0]]], "%a and %a"],
		              match$19 = [0, 0],
		              match$20 = [0, 0],
		              match$21 = [0, 0],
		              match$22 = [0, 0],
		              match$23 = [0, 0],
		              match$24 = [0, 0],
		              match$25 = [0, 0],
		              na = [0, cst_weekdays],
		              nb = [0, 1],
		              nc = [0, 1],
		              nd = [0, 1],
		              ne = [0, 1],
		              nf = [0, 1],
		              ng = [0, 1],
		              nh = [0, 1],
		              ni = [0, 1],
		              nj = [0, 1],
		              nk = [0, 1],
		              nl = [0, 1],
		              nm = [0, 1],
		              nn = [0, 1],
		              no = [0, 1],
		              np = [0, 1],
		              nq = [0, 1],
		              nr = [0, 1],
		              ns = [0, 1],
		              nt = [0, 1],
		              nu = [0, 1],
		              nv = [0, 1],
		              nw = [0, 1],
		              nx = [0, 1],
		              ny = [0, 1],
		              nz = [0, 1],
		              nA = [0, 1],
		              nB = [0, 1],
		              nC = [0, 1],
		              nD = [0, 1],
		              nE = [0, 1],
		              nF = [0, 1],
		              nG = [0, 1],
		              nH = [0, 1],
		              nI = [0, 1],
		              nJ = [0, 1],
		              nK = [0, 1],
		              nL = [0, 1],
		              nM = [0, 1],
		              nN = [0, 1],
		              nO = [0, 1],
		              nP = [0, 1],
		              nQ = [0, 1],
		              nR = [0, 1],
		              nS = [0, 1],
		              nT = [0, 1],
		              nU = [0, 1],
		              nV = [0, 1],
		              nW = [0, 1],
		              nX = [0, 1],
		              nY = [0, 1],
		              nZ = [0, 1],
		              n0 = [0, 1],
		              n1 = [0, 1],
		              n2 = [0, 1],
		              n_ = [0, [4, 3, [0, 2, 4], 0, 0], cst_04i],
		              n8 = [0, [4, 0, 0, 0, [11, cst_th, 0]], cst_dth],
		              n9 = [0, [11, cst_last, 0], cst_last],
		              n4 = [0, [4, 0, 0, 0, [11, cst_th, 0]], cst_dth],
		              n5 = [0, [4, 0, 0, 0, [11, cst_st, 0]], "%dst"],
		              n6 = [0, [4, 0, 0, 0, [11, cst_nd, 0]], "%dnd"],
		              n7 = [0, [4, 0, 0, 0, [11, cst_rd, 0]], "%drd"],
		              match$26 = [0, 1],
		              match$27 = [0, 1],
		              match$28 = [0, 0],
		              match$29 = [0, 1],
		              match$30 = [0, 1],
		              match$31 = [0, 1],
		              ob = [0, cst_every],
		              oa = [0, cst_rule],
		              n$ = [0, cst_month_day],
		              od = [0, cst_type],
		              oc = [0, "mandate-dates"],
		              oL = [0, 0],
		              oM = [0, 0],
		              oN = [0, 1],
		              oP = [0, 1],
		              oO = [0, 1],
		              oJ = [0, 1],
		              oI = [0, 1],
		              oK = [0, 1],
		              oH = [0, 1],
		              oB =
		                [0,
		                 [18, [1, [0, [11, cst_h, 0], cst_h]], [15, [15, [17, 0, 0]]]],
		                 "@[<h>%a%a@]"],
		              oz =
		                [0,
		                 [4, 3, 0, 0, [11, " times starting ", [15, 0]]],
		                 "%i times starting %a"],
		              oA = [0, [15, [15, 0]], cst_a_a],
		              match$32 = [0, [1, 0, 0]],
		              oy = [0, cst_recurrence],
		              ox = [0, cst_boundaries],
		              of =
		                [0,
		                 [11, cst_every$0, [4, 3, 0, 0, [11, cst_days, 0]]],
		                 "every %i days"],
		              oe = [0, [11, cst_daily, 0], cst_daily],
		              oj =
		                [0,
		                 [11,
		                  cst_every$0,
		                  [4, 3, 0, 0, [11, cst_months_on_the, [15, 0]]]],
		                 "every %i months on the %a"],
		              ok =
		                [0,
		                 [11,
		                  cst_every$0,
		                  [4,
		                   3,
		                   0,
		                   0,
		                   [11, cst_months_on_the, [15, [12, 32, [15, 0]]]]]],
		                 "every %i months on the %a %a"],
		              ol =
		                [0,
		                 [11, cst_every$0, [4, 3, 0, 0, [11, " months", 0]]],
		                 "every %i months"],
		              og = [0, [11, cst_monthly_on_the, [15, 0]], "monthly on the %a"],
		              oh =
		                [0,
		                 [11, cst_monthly_on_the, [15, [12, 32, [15, 0]]]],
		                 "monthly on the %a %a"],
		              oi = [0, [11, cst_monthly, 0], cst_monthly],
		              oo =
		                [0,
		                 [11,
		                  cst_every$0,
		                  [4,
		                   3,
		                   0,
		                   0,
		                   [12, 32, [15, [11, "-starting-weeks on ", [15, 0]]]]]],
		                 "every %i %a-starting-weeks on %a"],
		              op =
		                [0,
		                 [11, cst_every$0, [4, 3, 0, 0, [11, " weeks on ", [15, 0]]]],
		                 "every %i weeks on %a"],
		              oq =
		                [0,
		                 [11, cst_every$0, [4, 3, 0, 0, [11, " week", 0]]],
		                 "every %i week"],
		              om = [0, [11, cst_every$0, [15, 0]], "every %a"],
		              on = [0, [11, cst_weekly, 0], cst_weekly],
		              os =
		                [0,
		                 [11, cst_every$0, [4, 3, 0, 0, [11, " workday", 0]]],
		                 "every %i workday"],
		              or = [0, [11, cst_every_workday, 0], cst_every_workday],
		              ow =
		                [0,
		                 [11, cst_every$0, [4, 3, 0, 0, [11, " years", 0]]],
		                 "every %i years"],
		              ou = [0, [11, cst_yearly, 0], cst_yearly],
		              ot =
		                [0,
		                 [11, "yearly on ", [15, [12, 32, [15, 0]]]],
		                 "yearly on %a %a"],
		              ov =
		                [0,
		                 [11,
		                  cst_every$0,
		                  [4, 3, 0, 0, [11, " years on ", [15, [12, 32, [15, 0]]]]]],
		                 "every %i years on %a %a"],
		              oC = [0, 1],
		              oD = [0, 1],
		              oE = [0, 1],
		              oF = [0, 1],
		              oG = [0, 1],
		              match$44 = [0, "mandate-completions"],
		              match$45 = [0, "mandate-completion"],
		              oW = [0, cst_type],
		              match$46 = [0, "mandate-completion-value"],
		              oV = [0, 0],
		              oT = [0, 0],
		              oS = [0, 0, 0, [9, cst_value], 0],
		              oU = [0, 0, 0, [9, cst_keyword], 0],
		              oQ = [0, "Used for syntax highlighting."],
		              oR = [0, cst_token_type],
		              match$41 = [0, 0],
		              match$42 = [0, 0],
		              match$43 = [0, cst_mandate],
		              match$40 = [0, "mandate-participant-lenient"],
		              match$39 = [0, cst_matchable],
		              match$33 = [0, 1],
		              match$34 = [0, 1],
		              match$35 = [0, 1],
		              match$36 = [0, 1],
		              match$37 = [0, 1],
		              match$38 = [0, 1],
		              o7 = [0, cst_invalid_month$0],
		              o5 = [0, 684370880],
		              o4 = [0, [0, cst$1, 0]],
		              o2 = [0, [0, cst$7, 0]],
		              o3 = [1, [0, [0, cst$7, 0], 0]],
		              o1 = [0, [0, cst$1, 0]],
		              o0 = [0, [0, cst$1, 0]],
		              oZ = [0, [0, cst$7, 0]],
		              oX = [0, 0, 0],
		              oY = [0, 1, 0, [0, [0, cst$1, 0]]],
		              o6 =
		                [0,
		                 [0, cst_January, 0],
		                 [0, cst_February, 1],
		                 [0, cst_March, 2],
		                 [0, cst_April, 3],
		                 [0, cst_May, 4],
		                 [0, cst_June, 5],
		                 [0, cst_July, 6],
		                 [0, cst_August, 7],
		                 [0, cst_September, 8],
		                 [0, cst_October, 9],
		                 [0, cst_November, 10],
		                 [0, cst_December, 11]],
		              o8 = [0, 1],
		              o9 = [0, cst$1, 0],
		              pc = [0, cst$1, 0],
		              pa = [0, [0, ".com", 0], 0],
		              o_ = [0, cst$14],
		              o$ = [0, cst$14],
		              pb = [0, [0, cst$1, 0]],
		              ql = [0, 0],
		              qg = [0, "invalid timespan"],
		              p9 = [0, [0, 0, 0], [0, 0, 0]],
		              p8 = [0, cst$1, 0],
		              p6 = [0, 1],
		              p5 = [0, 1],
		              p4 = [0, 1],
		              p3 = [0, 1],
		              p2 = [0, 1],
		              p1 = [0, 1],
		              p0 = [0, cst$1, 0],
		              pW =
		                [0,
		                 [0, "7 days", [0, 758941367, 7]],
		                 [0,
		                  [0, cst_1_week, [0, -622066209, 1]],
		                  [0,
		                   [0, cst_2_weeks, [0, -622066209, 2]],
		                   [0,
		                    [0, cst_1_month, [0, -66910893, 1]],
		                    [0, [0, cst_1_year, [0, 28716022, 1]], 0]]]]],
		              pX = [0, 1],
		              pY = [0, 870530776],
		              pZ = [0, cst$1, 0],
		              pV =
		                [0,
		                 [0, cst_1_week, [0, -622066209, 1]],
		                 [0,
		                  [0, cst_2_weeks, [0, -622066209, 2]],
		                  [0,
		                   [0, "3 weeks", [0, -622066209, 3]],
		                   [0,
		                    [0, cst_1_month, [0, -66910893, 1]],
		                    [0, [0, cst_1_year, [0, 28716022, 1]], 0]]]]],
		              pR = [0, 870035731],
		              pP = [0, 1],
		              pQ = [0, "of ", 0],
		              pS = [0, 1],
		              pM = [0, cst$1, 0],
		              pN = [0, 1],
		              pL = [0, 1],
		              pK = [0, 1],
		              pO = [0, 1],
		              pT = [0, cst_the, 0],
		              pU = [0, 870035731],
		              pJ = [0, 0],
		              pE =
		                [0,
		                 [0, cst_month, 529348384],
		                 [0,
		                  [0, cst_quarter, 362594316],
		                  [0, [0, cst_year, 992015837], 0]]],
		              pF = [0, cst_week, 969837588],
		              pG =
		                [0,
		                 [0, cst_week, 969837588],
		                 [0,
		                  [0, cst_month, 529348384],
		                  [0,
		                   [0, cst_quarter, 362594316],
		                   [0, [0, cst_year, 992015837], 0]]]],
		              pH = [0, "invalid time span"],
		              pD = [0, 1],
		              px = [0, 0],
		              py = [0, cst$1, [0, 0, 1]],
		              pw = [0, cst$1, 0],
		              pB = [0, cst$1, 0],
		              pz = [0, cst$1, 0],
		              pA = [0, 1],
		              pC = [0, cst_hr],
		              pm = [0, [0, cst_hours, 60], [0, [0, cst_minutes, 1], 0]],
		              pt = [0, [0, cst_minutes, 1], 0],
		              pu = [0, [0, cst_hour, 60], [0, [0, cst_minute, 1], 0]],
		              pv = [0, [0, cst_minute, 1], 0],
		              pn = [0, 1],
		              po = [0, cst_invalid_duration_unit],
		              pp = [0, cst_m, 1],
		              pr = [0, [0, cst_m, 1], 0],
		              ps = [0, [0, cst_m, 1], 0],
		              pq = [0, cst_invalid_duration_unit],
		              pk = [0, 556777215],
		              pl = [0, 30, [0, 15, [0, 45, 0]]],
		              pg = [0, "invalid period"],
		              ph = [0, cst$1, 0],
		              pi = [0, 1],
		              pj = [0, "invalid time of day shorthand"],
		              pd = [0, "invalid weekday name"],
		              pe =
		                [0,
		                 [0, cst_today, 659791777],
		                 [0,
		                  [0, cst_tomorrow, 376298789],
		                  [0, [0, cst_yesterday, -377627806], 0]]],
		              pf = [0, "invalid day shorthand"],
		              pI = [0, cst$1, [0, cst_s$0, 0]],
		              p7 = [0, [0, cst$1, 0], 0],
		              p_ =
		                [0,
		                 [0, cst_workday, [3, 1]],
		                 [0, [0, cst_month, [1, 1, 0]], 0]],
		              p$ = [0, cst_day, [0, 1]],
		              qa = [0, cst_year, [4, 1, 0, 0]],
		              qb = [0, cst_workday, [3, 1]],
		              qc = [0, cst_quarter, [1, 3, 0]],
		              qd = [0, cst_month, [1, 1, 0]],
		              qe = [0, cst_day, [0, 1]],
		              qf = [0, "invalid recurrence"],
		              qh = [0, 1],
		              qi = [0, 1],
		              qj = [0, cst$7, 0],
		              qk = [0, 1],
		              qp = [0, 1],
		              qo = [0, 1],
		              qn =
		                [0, [11, "EUNKNOWNERR ", [4, 0, 0, 0, 0]], "EUNKNOWNERR %d"],
		              qm =
		                [0,
		                 [11,
		                  "Unix.Unix_error(Unix.",
		                  [2, 0, [11, c, [3, 0, [11, c, [3, 0, [12, 41, 0]]]]]]],
		                 "Unix.Unix_error(Unix.%s, %S, %S)"],
		              opt$6 = [0, 1],
		              qs = caml_int64_create_lo_mi_hi(0, 0, 0),
		              qt = caml_int64_create_lo_mi_hi(0, 0, 0),
		              qu = caml_int64_create_lo_mi_hi(1, 0, 0),
		              qr =
		                [0,
		                 [11,
		                  "bytes ",
		                  [7,
		                   0,
		                   0,
		                   0,
		                   [12, 45, [7, 0, 0, 0, [12, 47, [7, 0, 0, 0, 0]]]]]],
		                 "bytes %Ld-%Ld/%Ld"],
		              qq =
		                [0,
		                 cst_accept,
		                 "accept-charset",
		                 "accept-encoding",
		                 "accept-language",
		                 "accept-ranges",
		                 "allow",
		                 "cache-control",
		                 cst_connection,
		                 "content-encoding",
		                 "content-language",
		                 "expect",
		                 "if-match",
		                 "if-none-match",
		                 cst_link,
		                 "pragma",
		                 "proxy-authenticate",
		                 "te",
		                 "trailer",
		                 cst_transfer_encoding,
		                 "upgrade",
		                 "vary",
		                 "via",
		                 cst_warning,
		                 cst_www_authenticate],
		              qv = [0, 170, [0, 181, [0, 186, [0, 223, [0, 255, 0]]]]],
		              bNI = [0, "lib/hash_set.ml", 60, 2],
		              qw = [0, "lib/automata.ml", 528, 14],
		              qx = [0, 1],
		              qy = [0, [11, "ocaml-cohttp/", [2, 0, 0]], "ocaml-cohttp/%s"],
		              qz = [0, 2],
		              qA = [0, caml_int64_create_lo_mi_hi(0, 0, 0)],
		              qB = [1, 0],
		              opt$8 = [0, 2],
		              qC =
		                [0, [11, "decoding error: ", [15, 0]], "decoding error: %a"],
		              q1 =
		                [0,
		                 [11,
		                  cst_unexpected_status,
		                  [2, 0, [11, cst_querying, [15, 0]]]],
		                 cst_unexpected_status_s_queryi],
		              q0 =
		                [0,
		                 [11,
		                  cst_unexpected_status,
		                  [2, 0, [11, cst_querying, [15, 0]]]],
		                 cst_unexpected_status_s_queryi],
		              qZ =
		                [0,
		                 [11,
		                  cst_unexpected_status,
		                  [2, 0, [11, cst_querying, [15, 0]]]],
		                 cst_unexpected_status_s_queryi],
		              qX =
		                [0,
		                 [11,
		                  "unrecognized ",
		                  [3, 0, [11, " header value ", [3, 0, 0]]]],
		                 "unrecognized %S header value %S"],
		              qW =
		                [0,
		                 [11, cst_for, [4, 3, 0, 0, [11, " seconds", 0]]],
		                 "for %i seconds"],
		              qV =
		                [0,
		                 [11,
		                  "429 Too Many Requests querying ",
		                  [15, [15, [11, ", backing off ", [15, 0]]]]],
		                 "429 Too Many Requests querying %a%a, backing off %a"],
		              qY =
		                [0,
		                 [11, cst_for, [4, 3, 0, 0, [11, " seconds (from ", 0]]],
		                 "for %i seconds (from "],
		              qT =
		                [0,
		                 [12,
		                  91,
		                  [4, 6, 0, 0, [11, cst$42, [2, 0, [12, 32, [15, 0]]]]]],
		                 "[%x] %s %a"],
		              qS =
		                [0,
		                 [12, 91, [4, 6, 0, 0, [11, "]   request body: ", [15, 0]]]],
		                 "[%x]   request body: %a"],
		              qR =
		                [0,
		                 [12,
		                  91,
		                  [4, 6, 0, 0, [11, "]   ", [2, 0, [11, cst$9, [2, 0, 0]]]]]],
		                 "[%x]   %s: %s"],
		              qP =
		                [0,
		                 [12, 91, [4, 6, 0, 0, [11, cst$42, [2, 0, 0]]]],
		                 "[%x] %s"],
		              qQ =
		                [0,
		                 [12,
		                  91,
		                  [4, 6, 0, 0, [11, "] CORS or connectivity issue", 0]]],
		                 "[%x] CORS or connectivity issue"],
		              qN =
		                [0,
		                 [15, [11, "  done streaming body", 0]],
		                 "%a  done streaming body"],
		              qM =
		                [0,
		                 [15, [11, "  networking error reading body", 0]],
		                 "%a  networking error reading body"],
		              qL =
		                [0,
		                 [15,
		                  [11,
		                   "  response body chunk:",
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]]]],
		                 "%a  response body chunk:@ @[%a@]"],
		              qO = [0, 1],
		              qJ =
		                [0,
		                 [15,
		                  [11,
		                   "  response body:",
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]]]],
		                 "%a  response body:@ @[%a@]"],
		              qK = [0, 1],
		              qI =
		                [0,
		                 [11,
		                  "retryable IO error ",
		                  [2, 0, [12, 32, [15, [11, cst$9, [15, 0]]]]]],
		                 "retryable IO error %s %a: %a"],
		              qH =
		                [0,
		                 [11,
		                  "unexpected exception ",
		                  [2, 0, [12, 32, [15, [11, cst$9, [15, 0]]]]]],
		                 "unexpected exception %s %a: %a"],
		              qG =
		                [0,
		                 [11,
		                  "retryable unix exception ",
		                  [2, 0, [12, 32, [15, [11, cst$9, [2, 0, 0]]]]]],
		                 "retryable unix exception %s %a: %s"],
		              qF =
		                [0,
		                 [15,
		                  [11,
		                   "timeout ",
		                   [2, 0, [11, cst$9, [2, 0, [12, 32, [15, 0]]]]]]],
		                 "%atimeout %s: %s %a"],
		              qD = [0, "schematic HTTP client"],
		              qE = [0, [12, 91, [4, 6, 0, 0, [11, cst$42, 0]]], "[%x] "],
		              qU =
		                [0,
		                 [11, cst$35, [4, 3, 0, 0, [11, " retries)", 0]]],
		                 " (%i retries)"],
		              q2 = [0, cst_meta],
		              match$47 = [0, 0],
		              q_ = [0, cst_task],
		              q8 = [0, 0],
		              q6 = [0, 0],
		              q5 = [0, 0, 0, [9, cst_completed], 0],
		              q7 = [0, 0, 0, [9, cst_needsAction], 0],
		              q4 = [0, cst_status],
		              q9 = [0, cst_link],
		              q3 = [0, cst_invalid_date$0],
		              q$ = [0, cst_status],
		              ra = [0, "person_address"],
		              rb = [0, "person_calendar_url"],
		              match$48 = [0, 0],
		              match$49 = [0, 0],
		              match$50 = [0, 0],
		              rc = [0, "person_field_metadata"],
		              rd = [0, "person_email"],
		              re = [0, "person_event"],
		              rf = [0, "person_gender"],
		              rg =
		                [0,
		                 "The `Name` resource.\n\n    A person's name. If the name is a mononym, the family name is empty.\n\n    Reference:\n    https://developers.google.com/people/api/rest/v1/people#Person.Name"],
		              rh = [0, cst_person_name],
		              ri = [0, "person_organization"],
		              rj = [0, "person_phone_number"],
		              rk = [0, "person_photo"],
		              match$51 = [0, 0],
		              match$52 = [0, 0],
		              match$53 = [0, 0],
		              match$54 = [0, 0],
		              match$55 = [0, 0],
		              match$56 = [0, 0],
		              rm = [0, "Custom events, NOT Google Calendar events."],
		              match$57 = [0, 0],
		              match$58 = [0, 0],
		              match$59 = [0, 0],
		              rl = [0, cst_person],
		              match$60 = [0, 0],
		              rn = [0, cst_metadata],
		              ro = [0, cst_search_result],
		              match$61 = [0, 0],
		              rq = [0, cst_insert],
		              rp = [0, cst_conference_properties],
		              rr = [0, "google-notification"],
		              rs = [0, "reminder"],
		              rH = [1, "not deleted"],
		              rG = [0, "raw_deleted"],
		              rF = [0, cst_calendar],
		              match$62 = [0, 0],
		              match$63 = [0, 0],
		              match$64 = [0, 0],
		              match$65 = [0, 0],
		              rD = [0, cst_notifications],
		              rE = [0, cst_conference_properties],
		              rC = [0, 0],
		              rA = [0, 0],
		              ry = [0, 0],
		              rw = [0, 0],
		              rv = [0, 0, 0, [9, cst_freeBusyReader], 0],
		              rx = [0, 0, 0, [9, cst_reader], 0],
		              rz = [0, 0, 0, [9, cst_writer], 0],
		              rB = [0, 0, 0, [9, cst_owner], 0],
		              rt = [0, "level of access, from most access to least access"],
		              ru = [0, cst_access_role],
		              match$66 = [0, 0],
		              match$67 = [0, 0],
		              rR = [0, "contact_group"],
		              rQ = [0, cst_client_data],
		              rP = [0, 0],
		              rN = [0, 0],
		              rL = [0, 0],
		              rK = [0, 0, 0, [9, cst_SYSTEM_CONTACT_GROUP], 0],
		              rM = [0, 0, 0, [9, cst_USER_CONTACT_GROUP], 0],
		              rO = [0, 0, 0, [9, cst_GROUP_TYPE_UNSPECIFIED], 0],
		              rJ = [0, "group_type"],
		              rI = [0, cst_metadata],
		              rS = [0, "contact_group_response"],
		              match$68 = [0, 0],
		              rW = [0, 0],
		              rU = [0, 0],
		              rT = [0, 0, 0, [9, cst_DIRECTORY_MERGE_SOURCE_TYP], 0],
		              rV = [0, 0, 0, [9, cst_DIRECTORY_MERGE_SOURCE_TYP$0], 0],
		              r2 = [0, 0],
		              r0 = [0, 0],
		              rY = [0, 0],
		              rX = [0, 0, 0, [9, cst_DIRECTORY_SOURCE_TYPE_DOMA], 0],
		              rZ = [0, 0, 0, [9, cst_DIRECTORY_SOURCE_TYPE_DOMA$0], 0],
		              r1 = [0, 0, 0, [9, cst_DIRECTORY_SOURCE_TYPE_UNSP], 0],
		              sy = [0, cst_body],
		              match$69 = [0, 1],
		              sz = [0, "structural_element"],
		              sr = [0, cst_request],
		              ss = [0, "insert_text"],
		              su = [0, "update_paragraph_style"],
		              sv = [0, "range_request"],
		              sw = [0, cst_location],
		              sx = [0, "write_control"],
		              r4 = [0, cst_paragraph],
		              r5 = [0, cst_element],
		              r6 = [0, "text_run"],
		              r7 = [0, cst_style],
		              sq = [0, 0],
		              so = [0, 0],
		              sm = [0, 0],
		              sk = [0, 0],
		              si = [0, 0],
		              sg = [0, 0],
		              se = [0, 0],
		              sc = [0, 0],
		              sa = [0, 0],
		              r_ = [0, 0],
		              r9 = [0, 0, 0, [9, cst_HEADING_6], 0],
		              r$ = [0, 0, 0, [9, cst_HEADING_5], 0],
		              sb = [0, 0, 0, [9, cst_HEADING_4], 0],
		              sd = [0, 0, 0, [9, cst_HEADING_3], 0],
		              sf = [0, 0, 0, [9, cst_HEADING_2], 0],
		              sh = [0, 0, 0, [9, cst_HEADING_1], 0],
		              sj = [0, 0, 0, [9, cst_SUBTITLE], 0],
		              sl = [0, 0, 0, [9, cst_TITLE], 0],
		              sn = [0, 0, 0, [9, cst_NORMAL_TEXT], 0],
		              sp = [0, 0, 0, [9, cst_NAMED_STYLE_TYPE_UNSPECIFI], 0],
		              r8 = [0, "named_style"],
		              r3 = [0, cst_range],
		              uc = [0, cst_common],
		              match$82 = [0, 0],
		              match$83 = [0, 0],
		              match$84 = [0, 0],
		              ud = [0, "google-event"],
		              ua = [0, 0, 0],
		              ub = [0, 0, 0],
		              match$81 = [0, 0],
		              t$ = [0, "moded"],
		              t8 = [0, cst_reminders],
		              t9 = [0, cst_source],
		              t_ = [0, "attachement"],
		              match$79 = [0, 0],
		              match$80 = [0, 0],
		              t7 = [0, "extended_properties_patch"],
		              match$77 = [0, 0],
		              match$78 = [0, 0],
		              t6 = [0, "extended_properties"],
		              t5 = [0, [0, 0], 0],
		              t4 = [0, [0, 0], 0],
		              t3 = [0, cst_time],
		              match$76 = [0, 0],
		              tW = [0, "conference"],
		              tX = [0, "create_request"],
		              tY = [0, cst_type],
		              tZ = [0, "entrypoint"],
		              t0 = [0, cst_status],
		              t1 = [0, "solution"],
		              t2 = [0, cst_gadget],
		              tI = [0, 0],
		              tG = [0, 0],
		              tE = [0, 0],
		              tC = [0, 0],
		              tB = [0, 0, 0, [9, cst_video], 0],
		              tD = [0, 0, 0, [9, cst_sip], 0],
		              tF = [0, 0, 0, [9, cst_phone], 0],
		              tH = [0, 0, 0, [9, cst_more], 0],
		              tA = [0, "entrypoint_type"],
		              tP = [0, 0],
		              tN = [0, 0],
		              tL = [0, 0],
		              tK = [0, 0, 0, [9, cst_success], 0],
		              tM = [0, 0, 0, [9, cst_pending], 0],
		              tO = [0, 0, 0, [9, cst_failure], 0],
		              tJ = [0, "status_code"],
		              tV = [0, 0],
		              tT = [0, 0],
		              tS = [0, 0],
		              tR = [0, 0, 0, [9, cst_addOn], 0],
		              tU = [0, "eventHangout", [0, "eventNamedHangout", 0]],
		              tQ = [0, "conference_type"],
		              match$71 = [0, 0],
		              match$72 = [0, 0],
		              match$73 = [0, 0],
		              match$74 = [0, 0],
		              match$75 = [0, cst_attendee],
		              match$70 = [0, 0],
		              ti = [0, cst_persona],
		              tt = [0, [3, 0, 0], a],
		              tl = [0, [3, 0, 0], a],
		              tj =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              tk =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              tm = [0, [17, 0, 0], cst$6],
		              tn = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              to =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              tp = [0, [3, 0, 0], a],
		              tq = [0, [17, 0, 0], cst$6],
		              tr = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ts =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              tu = [0, [17, 0, 0], cst$6],
		              tv = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              tw =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              tx = [0, [9, 0, 0], cst_B],
		              ty = [0, [17, 0, 0], cst$6],
		              tz = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              s_ = [0, "insert_persona"],
		              tf = [0, [3, 0, 0], a],
		              s$ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              ta =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              tb = [0, [3, 0, 0], a],
		              tc = [0, [17, 0, 0], cst$6],
		              td = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              te =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              tg = [0, [17, 0, 0], cst$6],
		              th = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              s9 = [0, 0],
		              s7 = [0, 0],
		              s5 = [0, 0],
		              s3 = [0, 0],
		              s1 = [0, 0],
		              sZ = [0, 0],
		              sY = [0, 0, 0, [9, cst_birthday], 0],
		              s0 = [0, 0, 0, [9, cst_workingLocation], 0],
		              s2 = [0, 0, 0, [9, cst_outOfOffice], 0],
		              s4 = [0, 0, 0, [9, cst_fromGmail], 0],
		              s6 = [0, 0, 0, [9, cst_focusTime], 0],
		              s8 = [0, 0, 0, [9, cst_default], 0],
		              sX = [0, "event_type"],
		              sK = [0, 0],
		              sI = [0, 0],
		              sG = [0, 0],
		              sE = [0, 0],
		              sD = [0, 0, 0, [9, cst_accepted], 0],
		              sF = [0, 0, 0, [9, cst_tentative], 0],
		              sH = [0, 0, 0, [9, cst_declined], 0],
		              sJ = [0, 0, 0, [9, cst_needsAction], 0],
		              sC = [0, cst_response_status],
		              sR = [0, 0],
		              sP = [0, 0],
		              sN = [0, 0],
		              sM = [0, 0, 0, [9, cst_cancelled], 0],
		              sO = [0, 0, 0, [9, cst_tentative], 0],
		              sQ = [0, 0, 0, [9, cst_confirmed], 0],
		              sL = [0, cst_status],
		              sW = [0, 0],
		              sU = [0, 0],
		              sT = [0, 0, 0, [9, cst_transparent], 0],
		              sV = [0, 0, 0, [9, cst_opaque], 0],
		              sS = [0, cst_transparency],
		              sA = [0, 1, 0, 0],
		              sB = [0, 1970, 1, 1],
		              match$85 = [0, 0],
		              ul = [0, cst_capabilities],
		              um = [0, "image_media_metadata"],
		              un = [0, cst_location],
		              uo = [0, "video_media_metadata"],
		              uk = [0, cst_read],
		              uj = [0, cst_common],
		              ue = [0, "content_hints"],
		              uf = [0, cst_thumbnail],
		              ug = [0, "content_restriction"],
		              uh = [0, cst_user],
		              ui = [0, "shortcut_details"],
		              match$86 = [0, 0],
		              uI = [0, "google-message-label"],
		              ut = [0, 0],
		              ur = [0, 0],
		              uq = [0, 0, 0, [9, cst_user], 0],
		              us = [0, 0, 0, [9, cst_system], 0],
		              up = [0, "label_type"],
		              uy = [0, 0],
		              uw = [0, 0],
		              uv = [0, 0, 0, [9, cst_hide], 0],
		              ux = [0, 0, 0, [9, cst_show], 0],
		              uu = [0, "message_list_visibility"],
		              uF = [0, 0],
		              uD = [0, 0],
		              uB = [0, 0],
		              uA = [0, 0, 0, [9, cst_label_show_if_unread], 0],
		              uC = [0, 0, 0, [9, cst_label_hide], 0],
		              uE = [0, 0, 0, [9, cst_label_show], 0],
		              uz = [0, "label_list_visibility"],
		              uG = [0, "label_color"],
		              uH = [0, "google-message-label-w"],
		              uL = [0, 1],
		              uJ = [0, cst$1],
		              uK = [0, 1],
		              match$87 = [0, 0],
		              match$88 = [0, 0],
		              uM = [0, "message_part"],
		              uN = [0, cst_header],
		              match$89 = [0, cst$1],
		              uO = [0, "message_part_body"],
		              match$92 = [0, 0],
		              match$93 = [0, 0],
		              match$90 = [0, 0],
		              match$91 = [0, 0],
		              uP = [0, cst_This_is_a_byte_array],
		              uQ = [0, cst_This_is_a_byte_array],
		              uR = [0, cst_This_is_a_byte_array],
		              uZ = [0, 0],
		              uX = [0, 0],
		              uV = [0, 0],
		              uT = [0, 0],
		              uS = [0, 0, 0, [9, cst_labelRemoved], 0],
		              uU = [0, 0, 0, [9, cst_labelAdded], 0],
		              uW = [0, 0, 0, [9, cst_messageDeleted], 0],
		              uY = [0, 0, 0, [9, cst_messageAdded], 0],
		              u7 = [0, 0],
		              u5 = [0, 0],
		              u3 = [0, 0],
		              u1 = [0, 0],
		              u0 = [0, 0, 0, [9, cst_metadata], 0],
		              u2 = [0, 0, 0, [9, cst_raw], 0],
		              u4 = [0, 0, 0, [9, cst_full], 0],
		              u6 = [0, 0, 0, [9, cst_minimal], 0],
		              u$ = [0, 0],
		              u9 = [0, 0],
		              u8 = [0, 0, 0, [9, cst_dateHeader], 0],
		              u_ = [0, 0, 0, [9, cst_receivedTime], 0],
		              xd = [0, "refresh_response"],
		              w2 =
		                [0,
		                 "Boolean flag which is true if the email address is verified. Present\n            only if the email scope is present in the request."],
		              w3 = [0, "The obfuscated user id."],
		              w4 =
		                [0,
		                 "The space separated list of scopes granted to this token."],
		              w5 =
		                [0,
		                 "To whom was the token issued to. In general the same as audience."],
		              w6 =
		                [0,
		                 "The expiry time of the token, as number of seconds left until\n            expiry."],
		              w7 =
		                [0,
		                 "The email address of the user. Present only if the email scope is\n            present in the request."],
		              w8 =
		                [0,
		                 "Who is the intended audience for this token. In general the same as\n            issued_to."],
		              w9 = [0, "The access type granted with this token."],
		              w1 = [0, "token_info"],
		              xc = [0, 0],
		              xa = [0, 0],
		              w$ = [0, 0, 0, [9, cst_online], 0],
		              xb = [0, 0, 0, [9, cst_offline], 0],
		              w_ = [0, cst_access_type],
		              w0 = [0, cst$7],
		              wZ = [0, 0],
		              wQ = [0, 5],
		              wR = [0, 4],
		              wS = [0, 3],
		              wT = [0, 2],
		              wU = [0, 1],
		              wV = [0, 0],
		              wW = [0, 20],
		              wX = [0, 19],
		              wY = [0, 28],
		              wG = [0, 13],
		              wH = [0, 12],
		              wI = [0, 11],
		              wJ = [0, 10],
		              wK = [0, 9],
		              wL = [0, 18],
		              wM = [0, 17],
		              wN = [0, 8],
		              wO = [0, 7],
		              wP = [0, 6],
		              ww = [0, 37],
		              wx = [0, 36],
		              wy = [0, 25],
		              wz = [0, 23],
		              wA = [0, 24],
		              wB = [0, 22],
		              wC = [0, 21],
		              wD = [0, 16],
		              wE = [0, 15],
		              wn = [0, 27],
		              wo = [0, 26],
		              wp = [0, 35],
		              wq = [0, 34],
		              wr = [0, 33],
		              ws = [0, 32],
		              wt = [0, 31],
		              wu = [0, 30],
		              wv = [0, 29],
		              wF = [0, 14],
		              wm = [0, 0],
		              wk = [0, 0],
		              wi = [0, 0],
		              wg = [0, 0],
		              we = [0, 0],
		              wc = [0, 0],
		              wa = [0, 0],
		              v_ = [0, 0],
		              v8 = [0, 0],
		              v6 = [0, 0],
		              v4 = [0, 0],
		              v2 = [0, 0],
		              vZ = [0, 0],
		              vX = [0, 0],
		              vV = [0, 0],
		              vT = [0, 0],
		              vR = [0, 0],
		              vP = [0, 0],
		              vN = [0, 0],
		              vL = [0, 0],
		              vJ = [0, 0],
		              vH = [0, 0],
		              vF = [0, 0],
		              vD = [0, 0],
		              vB = [0, 0],
		              vz = [0, 0],
		              vx = [0, 0],
		              vv = [0, 0],
		              vt = [0, 0],
		              vr = [0, 0],
		              vp = [0, 0],
		              vn = [0, 0],
		              vl = [0, 0],
		              vj = [0, 0],
		              vh = [0, 0],
		              vf = [0, 0],
		              vd = [0, 0],
		              vb = [0, 0],
		              va = [0, "View your tasks"],
		              vc = [0, "Create, edit, organize, and delete all your tasks"],
		              ve =
		                [0,
		                 "See your personal info, including any personal info you've made\n              publicly available"],
		              vg = [0, cst_View_your_email_address],
		              vi = [0, "See and download your personal phone numbers"],
		              vk = [0, "See your education, work history and org info"],
		              vm = [0, "See your gender"],
		              vo = [0, "View your email addresses"],
		              vq = [0, "See and download your exact date of birth"],
		              vs = [0, "View your street addresses"],
		              vu = [0, "View your basic profile info"],
		              vw = [0, "Associate you with your personal info on Google"],
		              vy = [0, 0, 0, [9, cst_https_www_googleapis_com_a$22], 0],
		              vA = [0, 0, 0, [9, cst_https_www_googleapis_com_a$21], 0],
		              vC = [0, 0, 0, [9, cst_https_www_googleapis_com_a$20], 0],
		              vE = [0, 0, 0, [9, cst_https_www_googleapis_com_a$19], 0],
		              vG = [0, 0, 0, [9, cst_https_www_googleapis_com_a$18], 0],
		              vI = [0, 0, 0, [9, cst_https_mail_google_com], 0],
		              vK = [0, cst_View_your_email_address],
		              vM = [0, "View your Google Docs documents"],
		              vO = [0, "View and manage your Google Docs documents"],
		              vQ = [0, "Modify your Google Apps Script scripts' behavior"],
		              vS = [0, "See and download all your Google Drive files"],
		              vU =
		                [0,
		                 "View the photos, videos and albums in your Google Photos"],
		              vW = [0, "View metadata for files in your Google Drive"],
		              vY =
		                [0, "View and manage metadata of files in your Google Drive"],
		              v1 =
		                [0,
		                 "View and manage Google Drive files and folders that you have\n              opened or created with this app"],
		              v3 =
		                [0,
		                 "View and manage its own configuration data in your Google Drive"],
		              v5 =
		                [0,
		                 "See, edit, create, and delete all of your Google Drive files"],
		              v7 =
		                [0, "See and download your organization's GSuite directory"],
		              v9 = [0, "See and download your contacts"],
		              v$ =
		                [0,
		                 'See and download contact info automatically saved in your "Other\n              contacts"'],
		              wb =
		                [0,
		                 "See, edit, download, and permanently delete your contacts"],
		              wd = [0, "View your Calendar settings"],
		              wf =
		                [0,
		                 "See and download any calendar you can access using your Google\n              Calendar"],
		              wh = [0, "View events on all your calendars"],
		              wj = [0, "View and edit events on all your calendars"],
		              wl =
		                [0,
		                 "See, edit, share, and permanently delete all the calendars you can\n              access using Google Calendar"],
		              xe = [0, "person_response"],
		              match$94 = [0, 0],
		              xm = [0, 0],
		              xk = [0, 0],
		              xi = [0, 0],
		              xg = [0, 0],
		              xf = [0, 0, 0, [9, cst_READ_SOURCE_TYPE_DOMAIN_CO], 0],
		              xh = [0, 0, 0, [9, cst_READ_SOURCE_TYPE_CONTACT], 0],
		              xj = [0, 0, 0, [9, cst_READ_SOURCE_TYPE_PROFILE], 0],
		              xl = [0, 0, 0, [9, cst_READ_SOURCE_TYPE_UNSPECIFI], 0],
		              xn = [0, "Google API client"],
		              match$95 = [0, 0],
		              match$96 = [0, 0],
		              xo = [0, "google_error_payload"],
		              xp = [0, "google_error_details"],
		              match$97 = [0, 0],
		              xq = [0, cst_userinfo],
		              x3 = [0, 0],
		              x1 = [0, 0],
		              xZ = [0, 0],
		              xX = [0, 0],
		              xV = [0, 0],
		              xT = [0, 0],
		              xR = [0, 0],
		              xP = [0, 0],
		              xN = [0, 0],
		              xL = [0, 0],
		              xJ = [0, 0],
		              xH = [0, 0],
		              xF = [0, 0],
		              xD = [0, 0],
		              xB = [0, 0],
		              xz = [0, 0],
		              xx = [0, 0],
		              xv = [0, 0],
		              xt = [0, 0],
		              xs = [0, 0, 0, [9, cst_red_background], 0],
		              xu = [0, 0, 0, [9, cst_pink_background], 0],
		              xw = [0, 0, 0, [9, cst_purple_background], 0],
		              xy = [0, 0, 0, [9, cst_blue_background], 0],
		              xA = [0, 0, 0, [9, cst_green_background], 0],
		              xC = [0, 0, 0, [9, cst_yellow_background], 0],
		              xE = [0, 0, 0, [9, cst_orange_background], 0],
		              xG = [0, 0, 0, [9, cst_brown_background], 0],
		              xI = [0, 0, 0, [9, cst_gray_background], 0],
		              xK = [0, 0, 0, [9, cst_red], 0],
		              xM = [0, 0, 0, [9, cst_pink], 0],
		              xO = [0, 0, 0, [9, cst_purple], 0],
		              xQ = [0, 0, 0, [9, cst_blue], 0],
		              xS = [0, 0, 0, [9, cst_green], 0],
		              xU = [0, 0, 0, [9, cst_yellow], 0],
		              xW = [0, 0, 0, [9, cst_orange], 0],
		              xY = [0, 0, 0, [9, cst_brown], 0],
		              x0 = [0, 0, 0, [9, cst_gray], 0],
		              x2 = [0, 0, 0, [9, cst_default], 0],
		              xr = [0, cst_color],
		              x4 = [0, cst_date],
		              x5 = [0, -911188600],
		              x6 = [0, cst_person],
		              x7 = [0, cst_people],
		              x_ = [0, cst_common],
		              x$ = [0, cst_annotations],
		              ya = [0, cst_text],
		              yb = [0, cst_equation],
		              yc = [0, cst_link],
		              yd = [0, cst_mention],
		              ye = [0, "rich_text_intf"],
		              x9 = [0, "page_reference"],
		              x8 = [0, "database_reference"],
		              match$99 = [0, "property_intf"],
		              yf = [0, 0],
		              yg = [0, cst_type],
		              match$98 = [0, cst_content],
		              yh = [0, cst_unknown],
		              yn = [0, "notion-number"],
		              yK = [0, 0],
		              yI = [0, 0],
		              yG = [0, 0],
		              yE = [0, 0],
		              yC = [0, 0],
		              yA = [0, 0],
		              yy = [0, 0],
		              yw = [0, 0],
		              yu = [0, 0],
		              ys = [0, 0],
		              yq = [0, 0],
		              yp = [0, 0, 0, [9, cst_yuan], 0],
		              yr = [0, 0, 0, [9, cst_won], 0],
		              yt = [0, 0, 0, [9, cst_rupee], 0],
		              yv = [0, 0, 0, [9, cst_ruble], 0],
		              yx = [0, 0, 0, [9, cst_yen], 0],
		              yz = [0, 0, 0, [9, cst_pound], 0],
		              yB = [0, 0, 0, [9, cst_euro], 0],
		              yD = [0, 0, 0, [9, cst_dollar], 0],
		              yF = [0, 0, 0, [9, cst_percent], 0],
		              yH = [0, 0, 0, [9, cst_number_with_commas], 0],
		              yJ = [0, 0, 0, [9, cst_number], 0],
		              yo = [0, "notion-number-format"],
		              yL = [0, "notion-relation"],
		              yM = [0, "notion-rollup"],
		              zv = [0, 0],
		              zt = [0, 0],
		              zr = [0, 0],
		              zp = [0, 0],
		              zn = [0, 0],
		              zl = [0, 0],
		              zj = [0, 0],
		              zh = [0, 0],
		              zf = [0, 0],
		              zd = [0, 0],
		              zb = [0, 0],
		              y$ = [0, 0],
		              y9 = [0, 0],
		              y7 = [0, 0],
		              y5 = [0, 0],
		              y3 = [0, 0],
		              y1 = [0, 0],
		              yZ = [0, 0],
		              yX = [0, 0],
		              yV = [0, 0],
		              yT = [0, 0],
		              yR = [0, 0],
		              yP = [0, 0],
		              yO = [0, 0, 0, [9, cst_unchecked], 0],
		              yQ = [0, 0, 0, [9, cst_sum], 0],
		              yS = [0, 0, 0, [9, cst_show_unique], 0],
		              yU = [0, 0, 0, [9, cst_show_original], 0],
		              yW = [0, 0, 0, [9, cst_range], 0],
		              yY = [0, 0, 0, [9, cst_percent_unchecked], 0],
		              y0 = [0, 0, 0, [9, cst_percent_not_empty], 0],
		              y2 = [0, 0, 0, [9, cst_percent_empty], 0],
		              y4 = [0, 0, 0, [9, cst_percent_checked], 0],
		              y6 = [0, 0, 0, [9, cst_min], 0],
		              y8 = [0, 0, 0, [9, cst_median], 0],
		              y_ = [0, 0, 0, [9, cst_max], 0],
		              za = [0, 0, 0, [9, cst_latest_date], 0],
		              zc = [0, 0, 0, [9, cst_earliest_date], 0],
		              ze = [0, 0, 0, [9, cst_date_range], 0],
		              zg = [0, 0, 0, [9, cst_count_values], 0],
		              zi = [0, 0, 0, [9, cst_count_unique_values], 0],
		              zk = [0, 0, 0, [9, cst_count_not_empty], 0],
		              zm = [0, 0, 0, [9, cst_count_empty], 0],
		              zo = [0, 0, 0, [9, cst_count_all], 0],
		              zq = [0, 0, 0, [9, cst_count], 0],
		              zs = [0, 0, 0, [9, cst_checked], 0],
		              zu = [0, 0, 0, [9, cst_average], 0],
		              yN = [0, "notion-rollup-function"],
		              zw = [0, "notion-property"],
		              yl = [0, cst_notion_status_group],
		              ym = [0, "notion-status"],
		              yk = [0, "notion-select"],
		              yj = [0, "notion-option"],
		              yi = [0, cst_patch],
		              zP = [0, 0],
		              zQ = [0, cst_type],
		              zO = [0, cst_parent],
		              zR = [0, cst_property],
		              zx = [0, cst_file],
		              zz = [0, cst_type],
		              zy = [0, cst_formula],
		              zA = [0, cst_people],
		              zB = [0, cst_relation],
		              zC = [0, cst_rollup],
		              zJ = [0, 0],
		              zH = [0, 0],
		              zF = [0, 0],
		              zE = [0, 0, 0, [9, cst_number], 0],
		              zG = [0, 0, 0, [9, cst_date], 0],
		              zI = [0, 0, 0, [9, cst_array], 0],
		              zD = [0, "rollup_type"],
		              zK = [0, cst_select],
		              zL = [0, cst_text],
		              zM = [0, cst_time],
		              zN = [0, cst_title],
		              zS =
		                [0,
		                 'The "redirect_uri" that was provided in the Authorization step'],
		              zT = [0, 'Always use "authorization_code"'],
		              zU =
		                [0,
		                 "The temporary authorization code received in the incoming request"],
		              zV = [0, "response_success"],
		              zW = [0, "response_failure"],
		              Af = [0, 0],
		              Ad = [0, 0],
		              Ab = [0, 0],
		              z$ = [0, 0],
		              z9 = [0, 0],
		              z7 = [0, 0],
		              z5 = [0, 0],
		              z3 = [0, 0],
		              z1 = [0, 0],
		              zZ = [0, 0],
		              zY = [0, 0, 0, [9, cst_internal_server_error], 0],
		              z0 = [0, 0, 0, [9, cst_conflict_error], 0],
		              z2 = [0, 0, 0, [9, cst_object_not_found], 0],
		              z4 = [0, 0, 0, [9, cst_restricted_resource], 0],
		              z6 = [0, 0, 0, [9, cst_unauthorized], 0],
		              z8 = [0, 0, 0, [9, cst_missing_version], 0],
		              z_ = [0, 0, 0, [9, cst_validation_error], 0],
		              Aa = [0, 0, 0, [9, cst_invalid_request], 0],
		              Ac = [0, 0, 0, [9, cst_invalid_request_url], 0],
		              Ae = [0, 0, 0, [9, cst_invalid_json], 0],
		              zX = [0, "notion_code"],
		              Ak = [1, "contains filter is empty"],
		              Ao = [1, "equals filter is empty"],
		              Al = [1, "equals filter has multiple fields"],
		              Am = [0, 0],
		              An = [0, 1],
		              Ar = [1, "timestamp filter is empty"],
		              Ap = [1, "timestamp filter has multiple fields"],
		              Aq = [1, "timestamp cannot be empty"],
		              As = [0, 0, 0, 0, [0, 1]],
		              At = [0, 0, 0, [0, 1], 0],
		              Au = [0, 0, 0, 0, [0, 1]],
		              Aj = [0, [0, cst_created_time], 0],
		              Ai = [0, [0, cst_last_edited_time], 0],
		              Ah = [0, "serialization"],
		              match$101 = [0, cst_equals],
		              Ag = [0, cst_date],
		              match$100 = [0, cst_contains],
		              Av = [0, "v1/"],
		              Aw = [0, "api.notion.com"],
		              Ax = [0, cst_https],
		              AU = [0, cst_An_optional_name_for_the_p],
		              AV = [0, "The contents of the user message."],
		              AW = [0, "Tool call that this message is responding to."],
		              AX = [0, cst_The_contents_of_the_assist],
		              AY = [0, cst_An_optional_name_for_the_p],
		              AZ = [0, "The contents of the system message."],
		              A0 = [0, cst_An_optional_name_for_the_p],
		              A1 = [0, "The contents of the developer message."],
		              A2 = [0, "The refusal message by the assistant."],
		              A3 = [0, cst_An_optional_name_for_the_p],
		              A4 = [0, cst_The_contents_of_the_assist],
		              A5 = [0, cst_role],
		              AT = [0, "openai-chat-completions-message"],
		              Az = [0, cst_type],
		              Ay = [0, "annotation"],
		              AA = [0, "choice"],
		              AB = [0, cst_completion_tokens_details],
		              AK = [0, 0],
		              AI = [0, 0],
		              AG = [0, 0],
		              AE = [0, 0],
		              AD = [0, 0, 0, [9, cst_tool_calls], 0],
		              AF = [0, 0, 0, [9, cst_stop], 0],
		              AH = [0, 0, 0, [9, cst_length], 0],
		              AJ = [0, 0, 0, [9, cst_content_filter], 0],
		              AC = [0, cst_finish_reason],
		              AL = [0, cst_message],
		              AN = [0, "The URL of the web resource."],
		              AO = [0, "The title of the web resource."],
		              AP =
		                [0,
		                 "The index of the first character of the URL citation in the message."],
		              AQ =
		                [0,
		                 "The index of the last character of the URL citation in the message."],
		              AM = [0, cst_url_citation],
		              AR = [0, cst_usage],
		              AS = [0, cst_prompt_tokens_details],
		              A8 = [0, cst_type],
		              A6 = [0, "A citation returned by the OpenAI Responses API."],
		              A7 = [0, "openai-url-citation"],
		              A9 = [0, "string_or_json"],
		              Bh = [0, 0],
		              Bf = [0, 0],
		              Bd = [0, 0],
		              Bb = [0, 0],
		              Ba = [0, 0, 0, [9, cst_developer], 0],
		              Bc = [0, 0, 0, [9, cst_system], 0],
		              Be = [0, 0, 0, [9, cst_assistant], 0],
		              Bg = [0, 0, 0, [9, cst_user], 0],
		              A_ = [0, "Role of the message writer"],
		              A$ = [0, "openai-message-role"],
		              match$106 = [0, 0],
		              match$107 = [0, 0],
		              BZ = [0, cst_type],
		              BY = [0, cst_openai_output_item],
		              match$108 = [0, 0],
		              B1 = [0, cst_type],
		              B0 = [0, cst_content_item],
		              match$109 = [0, 0],
		              match$110 = [0, 0],
		              B3 = [0, cst_type],
		              B2 = [0, cst_openai_output_item],
		              match$111 = [0, 0],
		              B5 = [0, cst_type],
		              B4 = [0, cst_content_item],
		              match$104 = [0, [0, 0]],
		              match$105 = [0, [0, 0]],
		              BX = [0, cst_usage],
		              BW = [0, cst_output_tokens_details],
		              BV = [0, cst_input_tokens_details],
		              match$102 = [0, 0],
		              BQ =
		                [0,
		                 "Whether the model may emit independent tool calls in parallel."],
		              BP = [0, "openai-creation-client"],
		              match$103 = [0, 0],
		              BT =
		                [0,
		                 "Multi-part message: text plus one or more image/file parts."],
		              BU = [0, "Plain-text message with no file attachments."],
		              BR =
		                [0,
		                 "An item in the [input] array sent to the OpenAI Responses API."],
		              BS = [0, "openai-input-item"],
		              BN = [0, 0],
		              BO = [0, cst_type],
		              BM = [0, cst_caller],
		              BL = [0, cst_type],
		              BK = [0, "tool"],
		              BJ = [0, cst_programmatic_tool_calling],
		              BI =
		                [0,
		                 'Controls the amount of context retrieved from the web. ["low"],\n                ["medium"] (default), or ["high"]. Higher values improve\n                accuracy at increased cost and latency.'],
		              BH = [0, cst_web_search],
		              BG = [0, cst_tool_search],
		              BF = [0, cst_namespace],
		              BE = [0, cst_type],
		              BD = [0, "fn"],
		              BC = [0, cst_function],
		              BB = [0, cst_reasoning],
		              BA = [0, 0],
		              By = [0, 0],
		              Bw = [0, 0],
		              Bu = [0, 0],
		              Bs = [0, 0],
		              Bq = [0, 0],
		              Bp = [0, 0, 0, [9, cst_max], 0],
		              Br = [0, 0, 0, [9, cst_xhigh], 0],
		              Bt = [0, 0, 0, [9, cst_high], 0],
		              Bv = [0, 0, 0, [9, cst_medium], 0],
		              Bx = [0, 0, 0, [9, cst_low], 0],
		              Bz = [0, 0, 0, [9, cst_none], 0],
		              Bo = [0, cst_effort],
		              Bn = [0, cst_text],
		              Bm = [0, cst_format],
		              Bj =
		                [0,
		                 "Direct URL to a non-image file (PDF, DOCX, spreadsheet, \xe2\x80\xa6)."],
		              Bk = [0, "Direct URL to an image file (PNG, JPEG, GIF, WebP)."],
		              Bl = [0, cst_type],
		              Bi = [0, "content_part"],
		              Cy = [0, 0],
		              Cw = [0, 0],
		              Cu = [0, 0],
		              Cs = [0, 0],
		              Cq = [0, 0],
		              Co = [0, 0],
		              Cm = [0, 0],
		              Ck = [0, 0],
		              Ci = [0, 0],
		              Cg = [0, 0],
		              Ce = [0, 0],
		              Cc = [0, 0],
		              Ca = [0, 0],
		              B$ = [0, 0, 0, [9, cst_gpt_5_4_pro], 0],
		              Cb = [0, 0, 0, [9, cst_gpt_5_4_nano], 0],
		              Cd = [0, 0, 0, [9, cst_gpt_5_4_mini], 0],
		              Cf = [0, 0, 0, [9, cst_gpt_5_4], 0],
		              Ch = [0, 0, 0, [9, cst_gpt_5_6_terra], 0],
		              Cj = [0, 0, 0, [9, cst_gpt_5_6_luna], 0],
		              Cl = [0, 0, 0, [9, cst_gpt_5_5_pro], 0],
		              Cn = [0, 0, 0, [9, cst_gpt_5_5], 0],
		              Cp = [0, 0, 0, [9, cst_gpt_4_1_nano], 0],
		              Cr = [0, 0, 0, [9, cst_gpt_4_1_mini], 0],
		              Ct = [0, 0, 0, [9, cst_gpt_4_1], 0],
		              Cv = [0, 0, 0, [9, cst_gpt_4o_mini], 0],
		              Cx = [0, 0, 0, [9, cst_gpt_4o], 0],
		              B_ = [0, cst_model],
		              B9 = [0, 0],
		              B7 = [0, 0],
		              B6 = [0, 0, 0, [9, cst_fast], 0],
		              B8 = [0, 0, 0, [9, cst_standard], 0],
		              CC = [0, "end_pos"],
		              CD = [0, "start_pos"],
		              Cz = [0, "offset"],
		              CA = [0, cst_col],
		              CB = [0, cst_line],
		              CE = [0, [0]],
		              CF = [0, cst_src_automaton_state_intf_m, 46, 2],
		              CG = [0, [0]],
		              CH = [0, cst_src_automaton_state_intf_m, 58, 2],
		              CI = [0, [0]],
		              CJ = [0, [0]],
		              CM = [0, "parse_error.ml.Parse_error"],
		              CN = [0, "src/parse_error.ml", 40, 11],
		              CK = [0, cst_message],
		              CL = [0, cst_position],
		              CR = [0, "of_sexp_error.ml.Of_sexp_error"],
		              CS = [0, "src/of_sexp_error.ml", 65, 11],
		              CO = [0, cst_location],
		              CP = [0, "sub_sexp"],
		              CQ = [0, "user_exn"],
		              C5 = [0, cst_src_pre_sexp_ml, 889, 13],
		              CY = [0, "buf_pos"],
		              CZ = [0, "global_offset"],
		              C0 = [0, "text_char"],
		              C1 = [0, "text_line"],
		              C2 = [0, "err_msg"],
		              C3 = [0, "Sexplib.Sexp.Parse_error"],
		              C4 = [0, cst_src_pre_sexp_ml, 307, 11],
		              CX = [0, cst_src_pre_sexp_ml, 246, 6],
		              CW = [0, cst_src_pre_sexp_ml, 198, 13],
		              CT = [0, "containing_sexp"],
		              CU = [0, "invalid_sexp"],
		              CV = [0, [0, "Of_sexp_error"], 0],
		              Dc = [0, 1],
		              Db = [0, 0],
		              Da = [1, 0],
		              C6 = [0, cst_null$0],
		              C8 = [0, cst_b$0],
		              C9 = [0, cst_f],
		              C_ = [0, cst_o],
		              C$ = [0, cst_s$3],
		              C7 = [0, cst_a$1],
		              Dh = [0, [12, 35, [2, 0, [12, 46, [4, 0, 0, 0, 0]]]], cst_s_d$0],
		              Dg = [0, [12, 35, [2, 0, [12, 46, [4, 0, 0, 0, 0]]]], cst_s_d$0],
		              De = [0, [12, 39, [2, 0, [12, 39, 0]]], "'%s'"],
		              Df = [0, [12, 35, [2, 0, [12, 46, [4, 0, 0, 0, 0]]]], cst_s_d$0],
		              Dd =
		                caml_list_of_js_array
		                 ([cst_as,
		                   cst_add,
		                   cst_and,
		                   cst_by,
		                   cst_else,
		                   cst_if,
		                   cst_in,
		                   cst_inside,
		                   cst_index,
		                   cst_limit,
		                   cst_let,
		                   cst_max,
		                   cst_min,
		                   cst_null,
		                   cst_or,
		                   cst_pick,
		                   cst_remove,
		                   cst_select,
		                   cst_set,
		                   cst_then,
		                   cst_type,
		                   cst_where,
		                   cst_sort,
		                   cst_asc,
		                   cst_desc,
		                   cst_day,
		                   cst_days$0,
		                   cst_hour,
		                   cst_hours,
		                   cst_minute,
		                   cst_minutes,
		                   cst_month,
		                   cst_months,
		                   cst_second,
		                   cst_seconds,
		                   cst_week,
		                   cst_weeks,
		                   cst_year,
		                   cst_years]),
		              GH = [0, [15, [12, 32, [2, 0, [12, 32, [15, 0]]]]], "%a %s %a"],
		              GJ =
		                [0,
		                 [15,
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [15, [17, [0, cst$4, 1, 0], [15, 0]]]]],
		                 "%a@ %a@ %a"],
		              GI =
		                [0,
		                 [15,
		                  [12,
		                   40,
		                   [18,
		                    [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                    [15, [17, 0, [12, 41, 0]]]]]],
		                 "%a(@[<0>%a@])"],
		              GK = [0, [15, [12, 46, [2, 0, [15, 0]]]], "%a.%s%a"],
		              GL = [0, [15, [11, " as ", [15, 0]]], "%a as %a"],
		              GM =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                  [15,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11, "index ", [15, [11, "by ", [15, [17, 0, 0]]]]]]]],
		                 "@[<0>%a@ index %aby %a@]"],
		              GN =
		                [0,
		                 [11,
		                  "if ",
		                  [15,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11,
		                     "then ",
		                     [15,
		                      [17,
		                       [0, cst$4, 1, 0],
		                       [11, cst_else, [17, [0, cst$4, 1, 0], [15, 0]]]]]]]]],
		                 "if %a@ then %a@ else@ %a"],
		              GO = [0, [15, 0], cst_a],
		              GP =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                  [11,
		                   "let ",
		                   [15, [11, " in", [17, [0, cst$4, 1, 0], [15, [17, 0, 0]]]]]]],
		                 "@[<0>let %a in@ %a@]"],
		              GQ =
		                [0,
		                 [12,
		                  91,
		                  [18,
		                   [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                   [15, [17, 0, [12, 93, 0]]]]],
		                 "[@[<0>%a@]]"],
		              GR =
		                [0,
		                 [12,
		                  123,
		                  [18,
		                   [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                   [15, [17, 0, [12, 125, 0]]]]],
		                 "{@[<0>%a@]}"],
		              GS =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                  [15,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11, "select (", [15, [12, 41, [17, 0, 0]]]]]]],
		                 "@[<0>%a@ select (%a)@]"],
		              GT = [0, [12, 34, [2, 0, [12, 34, 0]]], '"%s"'],
		              GU = [0, [15, [12, 91, [15, [12, 93, 0]]]], "%a[%a]"],
		              GV =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                  [15, [11, cst$35, [15, [12, 41, [17, 0, 0]]]]]],
		                 "@[<0>%a (%a)@]"],
		              GW =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                  [15,
		                   [17, [0, cst$4, 1, 0], [11, "where ", [15, [17, 0, 0]]]]]],
		                 "@[<0>%a@ where %a@]"],
		              GX =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                  [15,
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [11, "sort ", [15, [11, " by ", [15, [17, 0, 0]]]]]]]],
		                 "@[<0>%a@ sort %a by %a@]"],
		              GY =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_0$0, 0], cst_0$0]],
		                  [15,
		                   [17, [0, cst$4, 1, 0], [11, "limit ", [15, [17, 0, 0]]]]]],
		                 "@[<0>%a@ limit %a@]"],
		              GZ = [0, [12, 91, [15, [12, 93, 0]]], cst_a$2],
		              Dn =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Do =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Dp = [0, [17, 0, 0], cst$6],
		              Dq = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Dr =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ds = [0, [17, 0, 0], cst$6],
		              Dt = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              E1 = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              E2 = [0, [3, 0, 0], a],
		              E3 = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              E4 = [0, [17, 0, [12, 41, 0]], cst$39],
		              E0 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              EZ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              E5 = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              EP = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              EQ = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              ER = [0, [17, 0, [12, 41, 0]], cst$39],
		              EO = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              EN =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              ES = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              EJ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              EI =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              EK = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              Ey = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              Ez = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              EA = [0, [17, 0, [12, 41, 0]], cst$39],
		              Ex = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Ew =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              EB = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              DK = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              DJ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              DL = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              Du =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Bin {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Bin {@,"],
		              Dv =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Dw = [0, [17, 0, 0], cst$6],
		              Dx = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Dy =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Dz = [0, [17, 0, 0], cst$6],
		              DA = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              DB =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              DC = [0, [17, 0, 0], cst$6],
		              DD = [0, [17, 0, [12, 125, 0]], cst$50],
		              DE =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Call {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Call {@,"],
		              DF =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              DG = [0, [17, 0, 0], cst$6],
		              DH = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              DI =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              DM = [0, [17, 0, 0], cst$6],
		              DN = [0, [17, 0, [12, 125, 0]], cst$50],
		              DO =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Field {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Field {@,"],
		              DP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              DQ = [0, [17, 0, 0], cst$6],
		              DR = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              DS =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              DT = [0, [17, 0, 0], cst$6],
		              DU = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              DV =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              DW = [0, [9, 0, 0], cst_B],
		              DX = [0, [17, 0, 0], cst$6],
		              DY = [0, [17, 0, [12, 125, 0]], cst$50],
		              DZ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.From {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.From {@,"],
		              D0 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              D1 = [0, [17, 0, 0], cst$6],
		              D2 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              D3 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              D4 = [0, [17, 0, 0], cst$6],
		              D5 = [0, [17, 0, [12, 125, 0]], cst$50],
		              D6 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Index {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Index {@,"],
		              D7 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              D8 = [0, [17, 0, 0], cst$6],
		              D9 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              D_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              D$ = [0, [17, 0, 0], cst$6],
		              Ea = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Eb =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ec = [0, [17, 0, 0], cst$6],
		              Ed = [0, [17, 0, [12, 125, 0]], cst$50],
		              Ee =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.If {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.If {@,"],
		              Ef =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Eg = [0, [17, 0, 0], cst$6],
		              Eh = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Ei =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ej = [0, [17, 0, 0], cst$6],
		              Ek = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              El =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Em = [0, [17, 0, 0], cst$6],
		              En = [0, [17, 0, [12, 125, 0]], cst$50],
		              Eo =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_Int, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_Int],
		              Ep = [0, [7, 0, 0, 0, [12, 76, 0]], cst_LdL],
		              Eq = [0, [17, 0, [12, 41, 0]], cst$39],
		              Er =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_Float, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_Float],
		              Es = [0, [8, [0, 0, 5], 0, 0, 0], cst_F],
		              Et = [0, [17, 0, [12, 41, 0]], cst$39],
		              Eu =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Let {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Let {@,"],
		              Ev =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              EC = [0, [17, 0, 0], cst$6],
		              ED = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              EE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              EF = [0, [17, 0, 0], cst$6],
		              EG = [0, [17, 0, [12, 125, 0]], cst$50],
		              EH =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_List, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_List],
		              EL = [0, [17, 0, [12, 41, 0]], cst$39],
		              EM =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Map", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Map@ "],
		              ET = [0, [17, 0, [12, 41, 0]], cst$39],
		              EU =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Map_empty", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Map_empty@ "],
		              EV = [0, [17, 0, [12, 41, 0]], cst$39],
		              EW =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Name", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Name@ "],
		              EX = [0, [17, 0, [12, 41, 0]], cst$39],
		              EY =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Object", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Object@ "],
		              E6 = [0, [17, 0, [12, 41, 0]], cst$39],
		              E7 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Pick {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Pick {@,"],
		              E8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              E9 = [0, [17, 0, 0], cst$6],
		              E_ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              E$ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Fa = [0, [17, 0, 0], cst$6],
		              Fb = [0, [17, 0, [12, 125, 0]], cst$50],
		              Fc =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Select {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Select {@,"],
		              Fd =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Fe = [0, [17, 0, 0], cst$6],
		              Ff = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Fg =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Fh = [0, [17, 0, 0], cst$6],
		              Fi = [0, [17, 0, [12, 125, 0]], cst$50],
		              Fj =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_String, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_String],
		              Fk = [0, [3, 0, 0], a],
		              Fl = [0, [17, 0, [12, 41, 0]], cst$39],
		              Fm =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Subscript {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Subscript {@,"],
		              Fn =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Fo = [0, [17, 0, 0], cst$6],
		              Fp = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Fq =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Fr = [0, [17, 0, 0], cst$6],
		              Fs = [0, [17, 0, [12, 125, 0]], cst$50],
		              Ft =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Type {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Type {@,"],
		              Fu =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Fv = [0, [17, 0, 0], cst$6],
		              Fw = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Fx =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Fy = [0, [17, 0, 0], cst$6],
		              Fz = [0, [17, 0, [12, 125, 0]], cst$50],
		              FA =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Unary {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Unary {@,"],
		              FB =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              FC = [0, [17, 0, 0], cst$6],
		              FD = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              FE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              FF = [0, [17, 0, 0], cst$6],
		              FG = [0, [17, 0, [12, 125, 0]], cst$50],
		              FH =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Where {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Where {@,"],
		              FI =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              FJ = [0, [17, 0, 0], cst$6],
		              FK = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              FL =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              FM = [0, [17, 0, 0], cst$6],
		              FN = [0, [17, 0, [12, 125, 0]], cst$50],
		              FO =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Sort {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Sort {@,"],
		              FP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              FQ = [0, [17, 0, 0], cst$6],
		              FR = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              FS =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              FT = [0, [17, 0, 0], cst$6],
		              FU = [0, [17, 0, [12, 125, 0]], cst$50],
		              FV =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Limit {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Limit {@,"],
		              FW =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              FX = [0, [17, 0, 0], cst$6],
		              FY = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              FZ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              F0 = [0, [17, 0, 0], cst$6],
		              F1 = [0, [17, 0, [12, 125, 0]], cst$50],
		              F2 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Static", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Static@ "],
		              F3 = [0, [17, 0, [12, 41, 0]], cst$39],
		              F4 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Dynamic", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Dynamic@ "],
		              F5 = [0, [17, 0, [12, 41, 0]], cst$39],
		              F6 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Max", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Max@ "],
		              F7 = [0, [17, 0, [12, 41, 0]], cst$39],
		              F8 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Min", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Min@ "],
		              F9 = [0, [17, 0, [12, 41, 0]], cst$39],
		              GD = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              GC =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              GE = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              Gt = [0, [3, 0, 0], a],
		              Gs = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              Gu = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              Gv = [0, [17, 0, [12, 41, 0]], cst$39],
		              Gr = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Gq =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              Gw = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              F_ =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Id", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Id@ "],
		              F$ = [0, [17, 0, [12, 41, 0]], cst$39],
		              Ga =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_Int, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_Int],
		              Gb = [0, [7, 0, 0, 0, [12, 76, 0]], cst_LdL],
		              Gc = [0, [17, 0, [12, 41, 0]], cst$39],
		              Gd =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_Float, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_Float],
		              Ge = [0, [8, [0, 0, 5], 0, 0, 0], cst_F],
		              Gf = [0, [17, 0, [12, 41, 0]], cst$39],
		              Gg =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_List, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_List],
		              Gh = [0, [17, 0, [12, 41, 0]], cst$39],
		              Gi =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Ast.Unlocated.Map {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Ast.Unlocated.Map {@,"],
		              Gj =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Gk = [0, [17, 0, 0], cst$6],
		              Gl = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Gm =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Gn = [0, [17, 0, 0], cst$6],
		              Go = [0, [17, 0, [12, 125, 0]], cst$50],
		              Gp =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Record", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Record@ "],
		              Gx = [0, [17, 0, [12, 41, 0]], cst$39],
		              Gy =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Ast_Unlocated_String, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_2_Ast_Unlocated_String],
		              Gz = [0, [3, 0, 0], a],
		              GA = [0, [17, 0, [12, 41, 0]], cst$39],
		              GB =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Ast.Unlocated.Variant", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Ast.Unlocated.Variant@ "],
		              GF = [0, [17, 0, [12, 41, 0]], cst$39],
		              Dk = [0, [4, 0, 0, 0, [12, 46, [4, 0, 0, 0, 0]]], "%d.%d"],
		              Dl =
		                [0,
		                 [4,
		                  0,
		                  0,
		                  0,
		                  [12, 46, [4, 0, 0, 0, [12, 45, [4, 0, 0, 0, 0]]]]],
		                 "%d.%d-%d"],
		              Dm =
		                [0,
		                 [4,
		                  0,
		                  0,
		                  0,
		                  [12,
		                   46,
		                   [4,
		                    0,
		                    0,
		                    0,
		                    [12, 45, [4, 0, 0, 0, [12, 46, [4, 0, 0, 0, 0]]]]]]],
		                 "%d.%d-%d.%d"],
		              Dj = [0, cst_location],
		              Di = [0, cst_position],
		              GG =
		                [0,
		                 cst$32,
		                 [0, cst$33, [0, cst$52, [0, cst$34, [0, cst$53, 0]]]]],
		              G7 = [0, [2, 0, 0], cst_s],
		              G6 = [0, [15, [11, cst$9, [2, 0, 0]]], "%a: %s"],
		              G0 = [0, "graph-error"],
		              G4 = [0, 0],
		              G3 = [0, 0],
		              G2 = [0, 0],
		              G1 = [0, 0],
		              G5 = [0, cst_kind],
		              G8 = [0, [2, 0, 0], cst_s],
		              He = [0, 0],
		              Hc = [0, 0],
		              Ha = [0, 0],
		              G$ = [0, 0, 0, [9, cst_uri], 0],
		              Hb = [0, 0, 0, [9, cst_phone], 0],
		              Hd = [0, 0, 0, [9, cst_email], 0],
		              G9 =
		                [0,
		                 "A format specifier for the strings.\n\n    This doesn't have any incidence on type checking, but is passed through, so\n    that the frontend can use it to get more information about the shape of the\n    data"],
		              G_ = [0, "graph_string_format"],
		              Hf = [0, 0],
		              Hg = [0, 0],
		              Hh = [0, 0],
		              HT = [1, 0],
		              HR = [0, 1],
		              HS = [0, -1],
		              HQ = [1, 0],
		              HP = [0, [0, cst_api_controller_lib_graph_g, 584, 20534, 20572]],
		              HM = [0, cst_Map],
		              HK = [1, 0],
		              HJ = [0, cst_api_controller_lib_graph_g, 524, 28],
		              HI = [0, cst_api_controller_lib_graph_g, 523, 28],
		              HL = [1, "Can't compare functions"],
		              HN = [1, "Cannot compare the `parameter` type"],
		              HO = [1, "fixme compare tuple"],
		              HW = [0, 0],
		              HV = [0, 0],
		              HU = [0, 0],
		              In =
		                [0,
		                 [11, "cast ", [15, [11, cst_into, [15, 0]]]],
		                 "cast %a into %a"],
		              If =
		                [0,
		                 [11, "> incompatible types ", [15, [12, 32, [15, 0]]]],
		                 "> incompatible types %a %a"],
		              Ih = [0, cst_api_controller_lib_graph_g, 1109, 45],
		              Ii =
		                [0,
		                 [11, "try casting ", [15, [11, cst_into, [15, 0]]]],
		                 "try casting %a into %a"],
		              Ik = [0, [11, "case ", [15, 0]], "case %a"],
		              Im =
		                [0,
		                 [11, cst_tuple_have_different_sizes, 0],
		                 cst_tuple_have_different_sizes],
		              Il = [0, [11, "missing field ", [2, 0, 0]], "missing field %s"],
		              Ij = [0, [11, cst_no_case_matched, 0], cst_no_case_matched],
		              Ig =
		                [0,
		                 [11,
		                  "cannot cast from ",
		                  [18,
		                   [1, [0, 0, cst$1]],
		                   [15,
		                    [17,
		                     0,
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [11, "to ", [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]]]]]]],
		                 "cannot cast from @[%a@]@ to @[%a@]"],
		              Ia = [0, 0],
		              Ib = [0, 0],
		              H4 = [0, 0],
		              H5 = [0, 0],
		              H6 = [0, 0],
		              H7 = [0, 0],
		              H3 =
		                [0,
		                 [11,
		                  "Trying to compare the constant types ",
		                  [15,
		                   [11,
		                    b,
		                    [15,
		                     [11,
		                      ", but their values can't be compared:",
		                      [17, 4, [2, 0, 0]]]]]]],
		                 "Trying to compare the constant types %a and %a, but their values can't be compared:@.%s"],
		              HX = [0, 0],
		              HY = [0, 0],
		              HZ = [0, 0],
		              H0 = [0, 0],
		              H1 = [0, 0],
		              H2 = [0, 0],
		              H8 = [0, 0],
		              H9 = [0, 0],
		              H_ = [0, 0],
		              H$ = [0, 0],
		              Ic = [0, 0],
		              Ie = [0, [11, "equal ", [15, [12, 32, [15, 0]]]], "equal %a %a"],
		              Id = [0, [11, "> ", [9, 0, 0]], "> %b"],
		              Hw = [0, [11, "Const(", [15, [12, 41, 0]]], "Const(%a)"],
		              Hx = [0, [11, "Fixpoint(", [15, [12, 41, 0]]], "Fixpoint(%a)"],
		              Hy = [0, [11, cst_List, [15, [12, 41, 0]]], cst_List_a],
		              Hz =
		                [0,
		                 [11, "Map(", [15, [11, c, [15, [12, 41, 0]]]]],
		                 "Map(%a, %a)"],
		              HB =
		                [0,
		                 [11,
		                  "Object(",
		                  [18,
		                   [1, [0, [11, cst_hv_2, 0], cst_hv_2]],
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [15, [17, 0, [17, [0, cst$4, 1, 0], [12, 41, 0]]]]]]],
		                 "Object(@[<hv 2>@ %a@]@ )"],
		              HC = [0, [12, 39, [2, 0, 0]], cst_s$4],
		              HD = [0, [11, "String(", [15, [12, 41, 0]]], "String(%a)"],
		              HE = [0, [11, cst_List, [15, [12, 41, 0]]], cst_List_a],
		              HF =
		                [0,
		                 [11, "View(", [15, [11, c, [2, 0, [12, 41, 0]]]]],
		                 "View(%a, %s)"],
		              HA =
		                [0,
		                 [11, "Named(", [3, 0, [11, ", ...)", 0]]],
		                 "Named(%S, ...)"],
		              HG =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [12,
		                   40,
		                   [18,
		                    [1, [0, 0, cst$1]],
		                    [15,
		                     [17,
		                      0,
		                      [11,
		                       cst$54,
		                       [17,
		                        [0, cst$4, 1, 0],
		                        [18, [1, [0, 0, cst$1]], [15, [17, 0, [17, 0, 0]]]]]]]]]]],
		                 cst_2_a_a],
		              HH =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [2, 0, [12, 58, [17, [0, cst$4, 1, 0], [15, [17, 0, 0]]]]]],
		                 cst_2_s_a],
		              Hl = [0, [12, 91, [15, [12, 93, 0]]], cst_a$2],
		              Hm =
		                [0,
		                 [12,
		                  91,
		                  [15, [12, 58, [17, [0, cst$4, 1, 0], [15, [12, 93, 0]]]]]],
		                 "[%a:@ %a]"],
		              Hn =
		                [0,
		                 [12,
		                  123,
		                  [18,
		                   [1, [0, [11, cst_hv_2, 0], cst_hv_2]],
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [15, [17, 0, [17, [0, cst$4, 1, 0], [12, 125, 0]]]]]]],
		                 "{@[<hv 2>@ %a@]@ }"],
		              Ho = [0, [12, 39, [2, 0, 0]], cst_s$4],
		              Hp = [0, [12, 91, [15, [12, 93, 0]]], cst_a$2],
		              Hq =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [12,
		                   40,
		                   [18,
		                    [1, [0, 0, cst$1]],
		                    [15,
		                     [17,
		                      0,
		                      [11,
		                       cst$54,
		                       [17,
		                        [0, cst$4, 1, 0],
		                        [18, [1, [0, 0, cst$1]], [15, [17, 0, [17, 0, 0]]]]]]]]]]],
		                 cst_2_a_a],
		              Hr =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [2, 0, [12, 58, [17, [0, cst$4, 1, 0], [15, [17, 0, 0]]]]]],
		                 cst_2_s_a],
		              Hv =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_b_0, 0], cst_b_0]],
		                  [18,
		                   [1, [0, [11, cst_hv_2, 0], cst_hv_2]],
		                   [12,
		                    123,
		                    [17,
		                     [0, cst$5, 0, 0],
		                     [15, [17, 0, [15, [12, 125, [17, 0, 0]]]]]]]]],
		                 "@[<b 0>@[<hv 2>{@,%a@]%a}@]"],
		              opt$9 = [0, 2],
		              opt$10 = [0, 2],
		              Ht = [0, cst$25, 0, cst$1],
		              Hu = [0, cst$1, 0, cst$1],
		              Hs = [0, cst_api_controller_lib_graph_g, 227, 29],
		              Hi = [0, [0]],
		              Hj = [0, cst_api_controller_lib_graph_g, 15, 44],
		              Hk = [0, [0]],
		              Je = [0, 0],
		              Jd = [0, 0],
		              Jc = [0, 0],
		              Jb = [0, 0],
		              Ja = [0, 0],
		              Jf = [0, cst_type],
		              I$ = [0, cst_graph_type],
		              match$112 = [0, 0],
		              Jg = [0, cst_graph_field],
		              Iu = [0, 0],
		              Iv = [0, cst_type],
		              It = [0, "graph-result"],
		              IS = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              IR =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              IT = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              Iw =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Bool {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Bool {@,"],
		              Ix =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Iy = [0, [9, 0, 0], cst_B],
		              Iz = [0, [17, 0, 0], cst$6],
		              IA = [0, [17, 0, [12, 125, 0]], cst$50],
		              IB =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Int {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Int {@,"],
		              IC =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ID = [0, [7, 0, 0, 0, [12, 76, 0]], cst_LdL],
		              IE = [0, [17, 0, 0], cst$6],
		              IF = [0, [17, 0, [12, 125, 0]], cst$50],
		              IG =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Float {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Float {@,"],
		              IH =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              II = [0, [8, [0, 0, 5], 0, 0, 0], cst_F],
		              IJ = [0, [17, 0, 0], cst$6],
		              IK = [0, [17, 0, [12, 125, 0]], cst$50],
		              IL =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Json {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Json {@,"],
		              IM =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              IN = [0, [17, 0, 0], cst$6],
		              IO = [0, [17, 0, [12, 125, 0]], cst$50],
		              IP =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "List {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>List {@,"],
		              IQ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              IU = [0, [17, 0, 0], cst$6],
		              IV = [0, [17, 0, [12, 125, 0]], cst$50],
		              IW =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Map {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Map {@,"],
		              IX =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              IY = [0, [17, 0, 0], cst$6],
		              IZ = [0, [17, 0, [12, 125, 0]], cst$50],
		              I0 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Object {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Object {@,"],
		              I1 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              I2 = [0, [17, 0, 0], cst$6],
		              I3 = [0, [17, 0, [12, 125, 0]], cst$50],
		              I4 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "String {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>String {@,"],
		              I5 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              I6 = [0, [3, 0, 0], a],
		              I7 = [0, [17, 0, 0], cst$6],
		              I8 = [0, [17, 0, [12, 125, 0]], cst$50],
		              I9 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [12,
		                   123,
		                   [18,
		                    [1, [0, 0, cst$1]],
		                    [17,
		                     [0, cst$5, 0, 0],
		                     [15, [17, 0, [17, [0, cst$5, 0, 0], [12, 125, [17, 0, 0]]]]]]]]],
		                 "@[{@[@,%a@]@,}@]"],
		              Is = [1, 0],
		              Io =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2,
		                   0,
		                   [12,
		                    58,
		                    [17, [0, cst$4, 1, 0], [15, [17, [0, r, 1, 0], [17, 0, 0]]]]]]],
		                 "@[%s:@ %a@;@]"],
		              Ip =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [12, 123, [15, [12, 125, [17, 0, 0]]]]],
		                 "@[{%a}@]"],
		              Iq = [0, [0, 0, 0, 0, 0, 0]],
		              Ir = [0, "api/controller/lib/graph/graph_result.ml", 81, 6],
		              I_ = [0, [0, 0, 0, 0, 0, 0]],
		              Jl =
		                [0, [11, "unify ", [15, [11, b, [15, 0]]]], "unify %a and %a"],
		              Jk = [0, [11, cst_not_unifiable, 0], cst_not_unifiable],
		              Jj = [0, [11, "unified as ", [15, 0]], "unified as %a"],
		              Ji =
		                [0,
		                 [11, cst_unify_case, [15, [12, 32, [15, 0]]]],
		                 cst_unify_case_a_a],
		              Jh =
		                [0,
		                 [11, cst_unify_case, [15, [12, 32, [15, 0]]]],
		                 cst_unify_case_a_a],
		              Jm = [0, "<any array>"],
		              Jn = [0, 0],
		              Jp = [0, [11, cst_rejected, 0], cst_rejected],
		              Jq =
		                [0, [11, cst_unrecognized_symbol, 0], cst_unrecognized_symbol],
		              Jr = [0, [11, "parse error on ", [15, 0]], "parse error on %a"],
		              Js = [0, [11, cst_parse_error, 0], cst_parse_error],
		              Jo = [0, [11, "identifier ", [2, 0, 0]], "identifier %s"],
		              JN = [0, 5, 0],
		              Jt = [0, [8, 0]],
		              Ju = [0, 2],
		              Jv = [0, 1],
		              Jw = [0, 0],
		              Jx = [0, 0],
		              Jy = [0, 0],
		              Jz = [8, 0],
		              JA = [8, 0],
		              JB = [8, 0],
		              JC = [8, 0],
		              JD = [0, [8, 0], [0, [8, 0], 0]],
		              JE = [0, 2, [0, 2, 0]],
		              JF = [0, 1, [0, 1, 0]],
		              JG = [0, 0],
		              JH = [0, 0, 0],
		              JI = [0, 0],
		              JJ = [0, 2, 0],
		              JK = [0, 0],
		              JL = [0, [7, cst_key], [0, [7, cst_data], 0]],
		              JM = [0, [7, cst_a$0], 0],
		              JO = [0, [7, cst_a$0], 0],
		              JP = [0, 0],
		              JQ = [0, [7, cst_a$0], 0],
		              JR = [0, 0],
		              JV = [0, cst_api_controller_lib_graph_c, 64, 21],
		              JU = [0, cst_api_controller_lib_graph_c, 66, 15],
		              JT =
		                [0,
		                 [11, cst_Comparing_JSONs_isn_t_supp, 0],
		                 cst_Comparing_JSONs_isn_t_supp],
		              JW =
		                [0,
		                 [11, cst_Comparing_functions_isn_t_, 0],
		                 cst_Comparing_functions_isn_t_],
		              JX =
		                [0,
		                 [11, "Comparing objects ", [15, [11, " isn't supported", 0]]],
		                 "Comparing objects %a isn't supported"],
		              JY =
		                [0,
		                 [11, cst_Comparing_parameters_isn_t, 0],
		                 cst_Comparing_parameters_isn_t],
		              JZ =
		                [0,
		                 [11, cst_Comparing_tuples_isn_t_sup, 0],
		                 cst_Comparing_tuples_isn_t_sup],
		              J0 =
		                [0,
		                 [11, cst_Ordering_lists_isn_t_suppo, 0],
		                 cst_Ordering_lists_isn_t_suppo],
		              J1 =
		                [0,
		                 [11, cst_Ordering_lists_isn_t_suppo, 0],
		                 cst_Ordering_lists_isn_t_suppo],
		              JS =
		                [0,
		                 [11,
		                  "Comparing ",
		                  [2, 0, [11, " requires a total ordering, got ", [15, 0]]]],
		                 "Comparing %s requires a total ordering, got %a"],
		              K8 =
		                [0,
		                 [11, "subscript applies to collections, not ", [15, 0]],
		                 "subscript applies to collections, not %a"],
		              K5 =
		                [0,
		                 [11, "limit applies to collections, not ", [15, 0]],
		                 "limit applies to collections, not %a"],
		              K6 =
		                [0,
		                 [11, "Limit count must be an integer, got ", [15, 0]],
		                 "Limit count must be an integer, got %a"],
		              K3 =
		                [0,
		                 [11, "select applies to collections, not ", [15, 0]],
		                 "select applies to collections, not %a"],
		              K1 =
		                [0,
		                 [11, "where applies to collection, not ", [15, 0]],
		                 "where applies to collection, not %a"],
		              KZ =
		                [0,
		                 [11,
		                  "While sorting: 'to_list' returned ",
		                  [15, [11, " which isn't a list. This is a bug", 0]]],
		                 "While sorting: 'to_list' returned %a which isn't a list. This is a bug"],
		              KY = [0, [2, 0, 0], cst_s],
		              KV = [0, 0],
		              KU =
		                [0,
		                 [11,
		                  "incomptabile type in else branch: expected ",
		                  [15, [11, " got ", [15, 0]]]],
		                 "incomptabile type in else branch: expected %a got %a"],
		              KS = [0, [2, 0, 0], cst_s],
		              KR =
		                [0,
		                 [11, "index applies to collection, not ", [15, 0]],
		                 "index applies to collection, not %a"],
		              KP =
		                [0, [11, cst_no_overload_matches, 0], cst_no_overload_matches],
		              KO = [0, 0],
		              KN =
		                [0,
		                 [11, "bind '", [2, 0, [11, cst_to, [15, 0]]]],
		                 "bind '%s to %a"],
		              KM =
		                [0,
		                 [11, "expected function, got ", [15, 0]],
		                 "expected function, got %a"],
		              KK =
		                [0,
		                 [11, "expected a const string, got ", [15, 0]],
		                 "expected a const string, got %a"],
		              Kv =
		                [0,
		                 [11, cst_name$0, [15, [11, " not found in ", [15, 0]]]],
		                 "name %a not found in %a"],
		              Ku =
		                [0,
		                 [11, cst_name$0, [15, [11, " not found on ", [15, 0]]]],
		                 "name %a not found on %a"],
		              KG = [0, [2, 0, 0], cst_s],
		              KH = [0, cst_api_controller_lib_graph_g$0, 635, 25587, 25651],
		              KI = [0, cst_api_controller_lib_graph_g$0, 635, 25587, 25643],
		              KF =
		                [0,
		                 [11, cst_pick_applies_to_collection, 0],
		                 cst_pick_applies_to_collection],
		              KC =
		                [0,
		                 [15, [11, " is not a valid map type", 0]],
		                 "%a is not a valid map type"],
		              KA =
		                [0,
		                 [11, "`as` applies to collections, not ", [15, 0]],
		                 "`as` applies to collections, not %a"],
		              KB =
		                [0,
		                 [11, "collection was already named ", [15, 0]],
		                 "collection was already named %a"],
		              Ky =
		                [0,
		                 [11,
		                  "element type ",
		                  [15, [11, " doesn't match ", [2, 0, [12, 32, [15, 0]]]]]],
		                 "element type %a doesn't match %s %a"],
		              Kw =
		                [0,
		                 [11, "expected booleans, not ", [15, [11, b, [15, 0]]]],
		                 "expected booleans, not %a and %a"],
		              Kz =
		                [0,
		                 [11,
		                  "inside operator requires a collection (list or map), got ",
		                  [15, 0]],
		                 "inside operator requires a collection (list or map), got %a"],
		              Kx =
		                [0,
		                 [11, "invalid comparison: ", [15, [11, b, [15, 0]]]],
		                 "invalid comparison: %a and %a"],
		              KD = [0, [11, cst_no_context, 0], cst_no_context],
		              KE =
		                [0, [11, "Name not found: ", [15, 0]], "Name not found: %a"],
		              J8 = [0, 0],
		              J9 =
		                [0,
		                 [11, cst_expected_a_boolean_got, [15, 0]],
		                 cst_expected_a_boolean_got_a],
		              J7 = [0, cst_api_controller_lib_graph_g$0, 222, 46],
		              J6 =
		                [0,
		                 [11, cst_expected_a_boolean_got, [15, 0]],
		                 cst_expected_a_boolean_got_a],
		              J3 = [0, 5],
		              J4 = [0, [11, "no such type ", [15, 0]], "no such type %a"],
		              J5 = [8, 0],
		              J2 = [0, [2, 0, 0], cst_s],
		              J_ = [0, [0, 0]],
		              J$ = [0, cst_api_controller_lib_graph_g$0, 267, 10],
		              Ka = [0, [0, 0]],
		              Kb = [0, cst_api_controller_lib_graph_g$0, 705, 10],
		              Kc = [0, [0, 0]],
		              Kd = [0, cst_api_controller_lib_graph_g$0, 729, 10],
		              Ke = [0, [0, 0]],
		              Kf = [0, cst_api_controller_lib_graph_g$0, 861, 10],
		              Kg = [0, [0, 0]],
		              Kh = [0, cst_api_controller_lib_graph_g$0, 955, 10],
		              Ki = [0, [0, 0]],
		              Kj = [0, cst_api_controller_lib_graph_g$0, 1136, 10],
		              Kk = [0, [0, 0]],
		              Kl = [0, cst_api_controller_lib_graph_g$0, 1164, 10],
		              Km = [0, [0, 0, 0]],
		              Kn = [0, cst_api_controller_lib_graph_g$0, 1261, 10],
		              Ko = [0, [0, 0]],
		              Kp = [0, cst_api_controller_lib_graph_g$0, 1362, 10],
		              Kq = [0, [0, 0]],
		              Kr = [0, cst_api_controller_lib_graph_g$0, 1478, 10],
		              Ks = [0, [0, 0]],
		              Kt = [0, cst_api_controller_lib_graph_g$0, 1525, 10],
		              KJ = [0, [0, 0]],
		              KL = [0, [0, 0]],
		              KQ = [0, [0, 0]],
		              KT = [0, [0, 0]],
		              KW = [0, [0, 0]],
		              KX = [0, [0, 0]],
		              K0 = [0, [0, 0]],
		              K2 = [0, [0, 0, 0]],
		              K4 = [0, [0, 0]],
		              K7 = [0, [0, 0]],
		              K9 = [0, [0, 0]],
		              L3 = [0, 0],
		              L2 = [0, 0, 0, [9, cst_subscription], 0],
		              L5 = [0, 0],
		              L4 = [0, 0, 0, [9, cst_subscription], 0],
		              L9 = [0, 0],
		              L7 = [0, 0],
		              L6 = [0, 0, 0, [9, cst_never], 0],
		              L8 = [0, 0, 0, [9, cst_auto], 0],
		              Ma = [0, 0],
		              L$ = [0, 0, 0, [9, cst_checkout_session], 0],
		              L_ = [0, "A tag indicating the type of the object"],
		              LX = [0, 0],
		              LY = [0, cst_type],
		              LZ = [0, cst_type],
		              L0 = [0, 0],
		              L1 = [0, cst_type],
		              LW = [0, 0],
		              LU = [0, 0],
		              LS = [0, 0],
		              LR = [0, 0, 0, [9, cst_all], 0],
		              LT = [0, 0, 0, [9, cst_ended], 0],
		              LV = [0, 0, 0, [9, cst_canceled], 0],
		              LK = [0, 0],
		              LI = [0, 0],
		              LG = [0, 0],
		              LF = [0, 0, 0, [9, cst_error_if_incomplete], 0],
		              LH = [0, 0, 0, [9, cst_default_incomplete], 0],
		              LJ = [0, 0, 0, [9, cst_allow_incomplete], 0],
		              LQ = [0, 0],
		              LO = [0, 0],
		              LM = [0, 0],
		              LL = [0, 0, 0, [9, cst_create_invoice], 0],
		              LN = [0, 0, 0, [9, cst_pause], 0],
		              LP = [0, 0, 0, [9, cst_cancel], 0],
		              LE = [0, 'Only set if expand contains ["latest_invoice"]'],
		              LD = [0, 0],
		              LB = [0, 0],
		              Lz = [0, 0],
		              Lx = [0, 0],
		              Lv = [0, 0],
		              Lt = [0, 0],
		              Lr = [0, 0],
		              Lp = [0, 0],
		              Lo = [0, 0, 0, [9, cst_paused], 0],
		              Lq = [0, 0, 0, [9, cst_unpaid], 0],
		              Ls = [0, 0, 0, [9, cst_canceled], 0],
		              Lu = [0, 0, 0, [9, cst_past_due], 0],
		              Lw = [0, 0, 0, [9, cst_active], 0],
		              Ly = [0, 0, 0, [9, cst_trialing], 0],
		              LA = [0, 0, 0, [9, cst_incomplete_expired], 0],
		              LC = [0, 0, 0, [9, cst_incomplete], 0],
		              Ln = [0, 0],
		              Lm = [0, 0, 0, [9, cst_list], 0],
		              Lk = [0, 0],
		              Li = [0, 0],
		              Lg = [0, 0],
		              Le = [0, 0],
		              Lc = [0, 0],
		              Lb = [0, 0, 0, [9, cst_void], 0],
		              Ld = [0, 0, 0, [9, cst_uncollectible], 0],
		              Lf = [0, 0, 0, [9, cst_paid], 0],
		              Lh = [0, 0, 0, [9, cst_open], 0],
		              Lj = [0, 0, 0, [9, cst_draft], 0],
		              Ll = [0, "Total price, after discount and taxes"],
		              match$113 = [0, 0],
		              La = [0, 0],
		              K$ = [0, 0, 0, [9, cst_list], 0],
		              K_ =
		                [0,
		                 "Expandables are fields that can either be a reference to another object, or\n    the object itself, inlined in the API response (depending on the value of\n    the [expand] parameter)"],
		              Mc =
		                [0,
		                 [11, ' ZONE = "', [20, 0, n, [12, 34, 0]]],
		                 ' ZONE = "%[^"]"'],
		              Mb =
		                [0,
		                 [11, ' TIMEZONE = "', [20, 0, n, [12, 34, 0]]],
		                 ' TIMEZONE = "%[^"]"'],
		              Md = [0, cst_UTC, 0],
		              Mi = caml_int64_create_lo_mi_hi(60, 0, 0),
		              Mj = caml_int64_create_lo_mi_hi(60, 0, 0),
		              Mk = caml_int64_create_lo_mi_hi(60, 0, 0),
		              Ml = caml_int64_create_lo_mi_hi(24, 0, 0),
		              Mm = caml_int64_create_lo_mi_hi(24, 0, 0),
		              Mn = caml_int64_create_lo_mi_hi(60, 0, 0),
		              Mh = [0, "timedesc/span.ml", 94, 2],
		              Mg = caml_int64_create_lo_mi_hi(0, 0, 0),
		              Me = caml_int64_create_lo_mi_hi(0, 0, 0),
		              Mf = caml_int64_create_lo_mi_hi(0, 0, 0),
		              Mo = [0, 1],
		              Mp = [0, 1],
		              My = [0, cst_timedesc_date_time_utils_m, 175, 2],
		              Mx = [0, cst_timedesc_date_time_utils_m, 176, 2],
		              Mq = [0, 3853996],
		              Mr = [0, 4203428],
		              Ms = [0, 4349046],
		              Mt = [0, 4200545],
		              Mu = [0, 3506557],
		              Mv = [0, 4149254],
		              Mw = [0, 4153708],
		              Mz = [0, "timedesc/ISO_week.ml", 39, 2],
		              MA = [0, 4003188],
		              MC = [0, "timedesc/direct_parser_components.ml", 29, 2],
		              MB = caml_int64_create_lo_mi_hi(16777215, 255, 0),
		              MG = [0, [0, 0], cst_c],
		              MF = [0, [0, [0, 0]], "%c%c"],
		              ME = [0, [0, 0], cst_c],
		              MD =
		                [0,
		                 [11, "integer ", [2, 0, [11, cst_is_out_of_range, 0]]],
		                 "integer %s is out of range"],
		              MR = [0, cst_timedesc_time_zone_ml, 686, 4],
		              MS = [0, cst_timedesc_time_zone_ml, 694, 6],
		              MQ = [0, cst_timedesc_time_zone_ml, 647, 8],
		              MP = [0, cst_timedesc_time_zone_ml, 531, 6],
		              MO = [0, 0, 0],
		              MN = caml_int64_create_lo_mi_hi(16777215, 255, 0),
		              MM = [0, 0],
		              MK =
		                [0,
		                 [11,
		                  cst_UTC,
		                  [0, [4, 0, [0, 2, 2], 0, [12, 58, [4, 0, [0, 2, 2], 0, 0]]]]],
		                 cst_UTC_c_02d_02d],
		              MJ = [0, cst_timedesc_time_zone_ml, 58, 2],
		              MI = [0, cst_timedesc_time_zone_ml, 84, 4],
		              MH = [0, cst_timedesc_time_zone_ml, 29, 2],
		              ML = [0, 1],
		              M6 =
		                [0,
		                 [11, "invalid iso week year: ", [4, 0, 0, 0, 0]],
		                 "invalid iso week year: %d"],
		              M5 =
		                [0,
		                 [11, "invalid iso week: ", [4, 0, 0, 0, 0]],
		                 "invalid iso week: %d"],
		              M4 =
		                [0,
		                 [11, "invalid day of year: ", [4, 0, 0, 0, 0]],
		                 "invalid day of year: %d"],
		              MW =
		                [0,
		                 [11,
		                  "invalid tz info: ",
		                  [2,
		                   0,
		                   [11, c, [0, [4, 0, 0, 0, [12, 58, [4, 0, 0, 0, 0]]]]]]],
		                 "invalid tz info: %s, %c%d:%d"],
		              MX =
		                [0,
		                 [11, cst_invalid_month, [4, 0, 0, 0, 0]],
		                 "invalid month: %d"],
		              MY =
		                [0, [11, "invalid day: ", [4, 0, 0, 0, 0]], "invalid day: %d"],
		              MZ =
		                [0,
		                 [11, "invalid frac: ", [8, [0, 0, 0], 0, 0, 0]],
		                 "invalid frac: %f"],
		              MV =
		                [0, [11, "invalid ns: ", [4, 0, 0, 0, 0]], "invalid ns: %d"],
		              M0 =
		                [0,
		                 [11, "invalid second: ", [4, 0, 0, 0, 0]],
		                 "invalid second: %d"],
		              M1 =
		                [0,
		                 [11, "invalid year: ", [4, 0, 0, 0, 0]],
		                 "invalid year: %d"],
		              M2 =
		                [0,
		                 [11, "invalid minute: ", [4, 0, 0, 0, 0]],
		                 "invalid minute: %d"],
		              M3 =
		                [0,
		                 [11, "invalid hour: ", [4, 0, 0, 0, 0]],
		                 "invalid hour: %d"],
		              MU = [1, -538350299],
		              MT = [0, 1],
		              M$ = [0, [11, cst_invalid_date, [2, 0, 0]], cst_invalid_date_s],
		              M_ = [0, [11, cst_invalid_date, [2, 0, 0]], cst_invalid_date_s],
		              M9 = [0, [11, cst_invalid_date, [2, 0, 0]], cst_invalid_date_s],
		              M8 = [0, [11, cst_invalid_date, [2, 0, 0]], cst_invalid_date_s],
		              M7 = [0, [11, cst_invalid_date, [2, 0, 0]], cst_invalid_date_s],
		              Nc =
		                [0,
		                 [11, "unknown timezone: ", [3, 0, 0]],
		                 "unknown timezone: %S"],
		              Nb =
		                [0,
		                 [11,
		                  "Error converting calendar time (",
		                  [4,
		                   0,
		                   0,
		                   0,
		                   [11,
		                    c,
		                    [4,
		                     0,
		                     0,
		                     0,
		                     [11,
		                      c,
		                      [4,
		                       0,
		                       0,
		                       0,
		                       [11,
		                        ") (",
		                        [4,
		                         0,
		                         0,
		                         0,
		                         [11,
		                          c,
		                          [4, 0, 0, 0, [11, c, [4, 0, 0, 0, [11, ") to timere", 0]]]]]]]]]]]]],
		                 "Error converting calendar time (%d, %d, %d) (%d, %d, %d) to timere"],
		              Na =
		                [0,
		                 [11,
		                  "Error converting timestamp ",
		                  [7, 0, 0, 0, [11, " to timere", 0]]],
		                 "Error converting timestamp %Ld to timere"],
		              Nx =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Nw = [0, "automation-run-ref-raw"],
		              Nv =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Nu =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Nt = [0, "conversation-ref-raw"],
		              Ns =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Nr = [0, "automation-ref-raw"],
		              Nq =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Np =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              No = [0, "agent-ref-raw"],
		              Nn = [0, "any-agent-id"],
		              Nl = [0, 0],
		              Nm = [0, [0, cst_beta, [0, cst_8, [0, cst_ai_assistant, 0]]]],
		              Nk =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Nj =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Ni = [0, "workspace-ref-raw"],
		              Nh =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Ng = [0, "table-ref-raw"],
		              Nf =
		                [0,
		                 [11, cst_Invalid, [2, 0, [11, cst_id$0, [2, 0, 0]]]],
		                 cst_Invalid_s_id_s],
		              Nd = [0, "api/schemas/src/ids.ml", 239, 4],
		              Ne = [0, cst$33],
		              NI = [0, cst_account],
		              NH = [0, 0],
		              NF = [0, 0],
		              ND = [0, 0],
		              NC = [0, 0, 0, [9, cst_crdt_read_write], 0],
		              NE = [0, 0, 0, [9, cst_crdt_write], 0],
		              NG = [0, 0, 0, [9, cst_no_crdt], 0],
		              NB = [0, 0],
		              Nz = [0, 0],
		              Ny = [0, 0, 0, [9, cst_premium], 0],
		              NA = [0, 0, 0, [9, cst_standard], 0],
		              match$114 = [0, "cached_replica"],
		              NU = [0, cst_members],
		              NS = [0, cst_Unique_account_id_of_the_m],
		              NT = [0, "Level of permission of the member on the workspace."],
		              NR = [0, cst_workspace_member],
		              NQ = [0, 0],
		              NO = [0, 0],
		              NN = [0, "The member has read-write access to the workspace."],
		              NP = [0, "The member has read-only access to the workspace."],
		              NL = [0, "Level of permission of members of the workspace."],
		              NM = [0, "workspace-access-role"],
		              NK = [0, cst_workspace],
		              NJ = [0, "workspace-raw"],
		              bNH = [0, "api/schemas/src/timezone.ml", 28, 66],
		              NV = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              NW = [0, [4, 0, 0, 0, 0], cst_d],
		              NX = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              NY = [0, [4, 0, 0, 0, 0], cst_d],
		              NZ = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              N0 = [0, [4, 0, 0, 0, 0], cst_d],
		              N1 = [0, [17, 0, [12, 41, 0]], cst$39],
		              N2 = [0, cst_color],
		              N3 = [0, [3, 0, 0], a],
		              N4 =
		                [0,
		                 "A generalized task id: either a native task or a custom object bound as a\n    task (see {!Graph.Task_binding}). Both are presented as tasks throughout the\n    system. Lives in its own module (depending only on {!Ids}) so that\n    {!Reference_id} can use it without creating a dependency cycle through\n    {!Task}/{!Parent_id}."],
		              N5 = [0, "generalized-task-id"],
		              Oh = [0, [15, [12, 32, [15, 0]]], "%a %a"],
		              Og =
		                [0,
		                 [2, 0, [4, 3, 0, 0, [12, 32, [15, [12, 115, 0]]]]],
		                 "%s%i %as"],
		              Of = [0, [2, 0, [11, "other ", [15, 0]]], "%sother %a"],
		              Oc = [0, [11, cst_daily, 0], cst_daily],
		              Ob = [0, [11, cst_workday, 0], cst_workday],
		              Oe = [0, [11, cst_weekly, 0], cst_weekly],
		              Od = [0, [11, cst_ly, 0], cst_ly],
		              N7 = [0, [11, cst_year, 0], cst_year],
		              N8 = [0, [11, cst_month, 0], cst_month],
		              N9 = [0, [11, cst_day, 0], cst_day],
		              N_ = [0, [11, cst_workday, 0], cst_workday],
		              N$ = [0, [15, [11, "-starting week", 0]], "%a-starting week"],
		              Oa = [0, [11, cst_week, 0], cst_week],
		              N6 = [0, 0, cst$1],
		              Oi = [0, [11, cst_every$0, 0], cst_every$0],
		              Oj = [0, 0],
		              Ok = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              Ol = [0, 0],
		              Om = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              On = [0, 0],
		              Oo = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              Op = [0, 0],
		              Oq = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              Or = [0, 0],
		              Os =
		                [0, [0, cst_beta, [0, cst_1, [0, cst_table_workspace_id, 0]]]],
		              Ot = [0, 0],
		              Ou =
		                [0, [0, cst_beta, [0, cst_1, [0, cst_table_workspace_id, 0]]]],
		              Ov = [0, 0],
		              Ow =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_2$2, [0, cst_organizations_references, 0]]]],
		              Ox = [0, 0],
		              Oy = [0, [0, cst_beta, [0, cst_1, [0, cst_object_id, 0]]]],
		              Oz =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Reference_id_intf.Event", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Event@ "],
		              OA = [0, [17, 0, [12, 41, 0]], cst$39],
		              OB =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Event_recurrent",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Event_recurrent@ "],
		              OC = [0, [17, 0, [12, 41, 0]], cst$39],
		              OD =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Reference_id_intf.Page", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Page@ "],
		              OE = [0, [17, 0, [12, 41, 0]], cst$39],
		              OF =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Reference_id_intf.People", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.People@ "],
		              OG = [0, [17, 0, [12, 41, 0]], cst$39],
		              OH =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Reference_id_intf.Task", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Task@ "],
		              OI = [0, [17, 0, [12, 41, 0]], cst$39],
		              OJ =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Task_recurrent",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Task_recurrent@ "],
		              OK = [0, [17, 0, [12, 41, 0]], cst$39],
		              OL =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Reference_id_intf.Object", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Object@ "],
		              OM = [0, [17, 0, [12, 41, 0]], cst$39],
		              ON =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Organization",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Organization@ "],
		              OO = [0, [17, 0, [12, 41, 0]], cst$39],
		              OP =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Table_ref",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Table_ref@ "],
		              OQ = [0, [17, 0, [12, 41, 0]], cst$39],
		              OR =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Workspace_ref",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Workspace_ref@ "],
		              OS = [0, [17, 0, [12, 41, 0]], cst$39],
		              OT =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Reference_id_intf.Agent", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Agent@ "],
		              OU = [0, [17, 0, [12, 41, 0]], cst$39],
		              OV =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Automation",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Automation@ "],
		              OW = [0, [17, 0, [12, 41, 0]], cst$39],
		              OX =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Conversation",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Conversation@ "],
		              OY = [0, [17, 0, [12, 41, 0]], cst$39],
		              OZ =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Reference_id_intf.Automation_run",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Reference_id_intf.Automation_run@ "],
		              O0 = [0, [17, 0, [12, 41, 0]], cst$39],
		              PJ = [0, cst_set],
		              PI = [0, cst_by],
		              PH = [0, 0],
		              PF = [0, 0],
		              PD = [0, 0],
		              PB = [0, 0],
		              Pz = [0, 0],
		              Px = [0, 0],
		              Pv = [0, 0],
		              Pr = [0, 0],
		              Pn = [0, 0],
		              Pj = [0, 0],
		              Pf = [0, 0],
		              Pb = [0, 0],
		              O9 = [0, 0],
		              O5 = [0, 0],
		              O2 = [0, 0],
		              O3 = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              O4 = [0, 0, 0, [9, cst_automation_run], 0],
		              O6 = [0, 0],
		              O7 = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              O8 = [0, 0, 0, [9, cst_conversation], 0],
		              O_ = [0, 0],
		              O$ = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              Pa = [0, 0, 0, [9, cst_automation], 0],
		              Pc = [0, 0],
		              Pd = [0, [0, cst_beta, [0, cst_3, [0, cst_ai_references, 0]]]],
		              Pe = [0, 0, 0, [9, cst_agent], 0],
		              Pg = [0, 0],
		              Ph =
		                [0, [0, cst_beta, [0, cst_1, [0, cst_table_workspace_id, 0]]]],
		              Pi = [0, 0, 0, [9, cst_workspace_ref], 0],
		              Pk = [0, 0],
		              Pl =
		                [0, [0, cst_beta, [0, cst_1, [0, cst_table_workspace_id, 0]]]],
		              Pm = [0, 0, 0, [9, cst_table_ref], 0],
		              Po = [0, 0],
		              Pp =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_2$2, [0, cst_organizations_references, 0]]]],
		              Pq = [0, 0, 0, [9, cst_organization], 0],
		              Ps = [0, 0],
		              Pt = [0, [0, cst_beta, [0, cst_1, [0, cst_object_id, 0]]]],
		              Pu = [0, 0, 0, [9, cst_object], 0],
		              Pw = [0, 0, 0, [9, cst_task_rec], 0],
		              Py = [0, 0, 0, [9, cst_task], 0],
		              PA = [0, 0, 0, [9, cst_people], 0],
		              PC = [0, 0, 0, [9, cst_page], 0],
		              PE = [0, 0, 0, [9, cst_event_rec], 0],
		              PG = [0, 0, 0, [9, cst_event], 0],
		              O1 = [0, "reference-kind"],
		              R2 = [0, "Content"],
		              R3 = [0, "Unique id"],
		              R4 =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              R5 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              R6 = [0, [17, 0, 0], cst$6],
		              R7 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              R8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              R9 = [0, [17, 0, 0], cst$6],
		              R_ = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              match$118 = [0, cst_kind],
		              RC = [0, 0],
		              RA = [0, 0],
		              RB = [0, 0],
		              RD = [0, cst_type],
		              RE =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Blockquote, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Blockquote@ "],
		              RF = [0, [17, 0, [12, 41, 0]], cst$39],
		              RG =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Bullet, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Bullet@ "],
		              RH = [0, [17, 0, [12, 41, 0]], cst$39],
		              RI =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Check, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Check@ "],
		              RJ = [0, [17, 0, [12, 41, 0]], cst$39],
		              RK =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Code, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Code@ "],
		              RL = [0, [17, 0, [12, 41, 0]], cst$39],
		              RM =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Callout, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Callout@ "],
		              RN = [0, [17, 0, [12, 41, 0]], cst$39],
		              RO =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Embed, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Embed@ "],
		              RP = [0, [17, 0, [12, 41, 0]], cst$39],
		              RQ =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Heading, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Heading@ "],
		              RR = [0, [17, 0, [12, 41, 0]], cst$39],
		              RS =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Object, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Object@ "],
		              RT = [0, [17, 0, [12, 41, 0]], cst$39],
		              RU =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Paragraph, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Paragraph@ "],
		              RV = [0, [17, 0, [12, 41, 0]], cst$39],
		              RW =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Query, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Query@ "],
		              RX = [0, [17, 0, [12, 41, 0]], cst$39],
		              RY =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Recurrent_task, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Recurrent_task@ "],
		              RZ = [0, [17, 0, [12, 41, 0]], cst$39],
		              R0 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, cst_Todo, [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Todo@ "],
		              R1 = [0, [17, 0, [12, 41, 0]], cst$39],
		              match$115 = [0, 0],
		              PX = [0, "bullet-block"],
		              PY = [0, "callout-block"],
		              P0 = [0, 0],
		              P1 = [0, [0, cst_beta, [0, cst_0, [0, "block-check-depth", 0]]]],
		              match$116 = [0, 0],
		              PZ = [0, "check-block"],
		              P2 = [0, "code-block"],
		              match$117 = [0, 0],
		              P3 = [0, "heading-block"],
		              P8 = [0, 0],
		              P6 = [0, 0],
		              P5 = [0, 0, 0, [9, cst_unordered], 0],
		              P7 = [0, 0, 0, [9, cst_ordered], 0],
		              P4 = [0, "block-list-type"],
		              P9 = [0, "object-block"],
		              P_ = [0, "paragraph-block"],
		              P$ = [0, "recurrent-task-block"],
		              Qb = [0, cst_ID_of_the_task_should_be_n],
		              Qc = [0, cst_title_of_the_task],
		              Qd = [0, cst_true_if_the_task_has_been_],
		              Qa = [0, cst_todo_block],
		              Qe =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Qf =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Qg = [0, [17, 0, 0], cst$6],
		              Qh = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Qi =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Qj = [0, [3, 0, 0], a],
		              Qk = [0, [17, 0, 0], cst$6],
		              Ql = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Qm =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Qn = [0, [4, 0, 0, 0, 0], cst_d],
		              Qo = [0, [17, 0, 0], cst$6],
		              Qp = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              Qq =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Qr =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Qs = [0, [17, 0, 0], cst$6],
		              Qt = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Qu =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Qv = [0, [3, 0, 0], a],
		              Qw = [0, [17, 0, 0], cst$6],
		              Qx = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Qy =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Qz = [0, [17, 0, 0], cst$6],
		              QA = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              QB =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              QC =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              QD = [0, [9, 0, 0], cst_B],
		              QE = [0, [17, 0, 0], cst$6],
		              QF = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              QG =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              QH = [0, [3, 0, 0], a],
		              QI = [0, [17, 0, 0], cst$6],
		              QJ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              QK =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              QL = [0, [4, 0, 0, 0, 0], cst_d],
		              QM = [0, [17, 0, 0], cst$6],
		              QN = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              QO =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              QP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              QQ = [0, [3, 0, 0], a],
		              QR = [0, [17, 0, 0], cst$6],
		              QS = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              QT =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              QU = [0, [3, 0, 0], a],
		              QV = [0, [17, 0, 0], cst$6],
		              QW = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              QX =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              QY =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              QZ = [0, [3, 0, 0], a],
		              Q0 = [0, [17, 0, 0], cst$6],
		              Q1 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Q2 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Q3 = [0, [4, 0, 0, 0, 0], cst_d],
		              Q4 = [0, [17, 0, 0], cst$6],
		              Q5 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Q6 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Q7 = [0, [9, 0, 0], cst_B],
		              Q8 = [0, [17, 0, 0], cst$6],
		              Q9 = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              Q_ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Q$ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ra = [0, [3, 0, 0], a],
		              Rb = [0, [17, 0, 0], cst$6],
		              Rc = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              Rd =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Re =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Rf = [0, [17, 0, 0], cst$6],
		              Rg = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Rh =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ri = [0, [3, 0, 0], a],
		              Rj = [0, [17, 0, 0], cst$6],
		              Rk = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Rl =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Rm = [0, [17, 0, 0], cst$6],
		              Rn = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              Ro =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Rp =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Rq = [0, [9, 0, 0], cst_B],
		              Rr = [0, [17, 0, 0], cst$6],
		              Rs = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Rt =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ru = [0, [3, 0, 0], a],
		              Rv = [0, [17, 0, 0], cst$6],
		              Rw = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Rx =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ry = [0, [17, 0, 0], cst$6],
		              Rz = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              PV = [0, 0],
		              PW =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, "object-blocks-any-reference", 0]]]],
		              PU = [0, cst_either],
		              PT = [0, "object-block-legacy"],
		              PS = [0, "object-block-modern"],
		              PL = [0, 0],
		              PM =
		                [0, [0, cst_beta, [0, cst_6, [0, "callout-block-emoji", 0]]]],
		              PN = [0, cst_kind],
		              PK = [0, cst_icon],
		              PO =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Document_intf.Icon.Emoji {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Document_intf.Icon.Emoji {@,"],
		              PP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              PQ = [0, [17, 0, 0], cst$6],
		              PR = [0, [17, 0, [12, 125, 0]], cst$50],
		              Sa = [0, cst_document],
		              Se = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Sd =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              Sf = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              Sb =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Sc =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Sg = [0, [17, 0, 0], cst$6],
		              Sh = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              R$ = [0, cst_block],
		              Si = [0, "etag_intf"],
		              Sj = [0, [4, 0, 0, 0, [12, 64, [15, 0]]], "%d@%a"],
		              TD = [1, 0],
		              TC = [0, cst_Cell],
		              TB = [0, cst_with_optional_union_key],
		              TA = [0, 0],
		              Tz = [0, 0, 0, [9, cst_null], 0],
		              Ty = [0, "cell-without-union-key"],
		              S2 = [0, 0],
		              SZ = [0, 0],
		              S0 = [0, 0],
		              S1 =
		                [0,
		                 'Any JSON data structure.\n\n          {b This variant must be last} because it acts as a "catch-all" when\n          decoding and there is no union key (see\n          {!Schema_shenanigans.t_without_union_key})'],
		              S3 = [0, cst_type],
		              SX =
		                [0,
		                 'The atomic piece of data stored in a table (the intersection of a row and a\n    column).\n\n    Note that all variants {b must} be wrapped in a record (hence\n    [Wrapped_serial.t]) since we use [union_key], otherwise Schematic happily\n    generates invalid Typescript/JSON schema, e.g.\n    [boolean & { "type" : "boolean"}].'],
		              SY = [0, "cell-with-union-key"],
		              Tt = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Ts =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              Tu = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              Tp = [0, [3, 0, 0], a],
		              Tf = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Te =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              Tg = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              Tb = [0, [7, 0, 0, 0, [12, 76, 0]], cst_LdL],
		              S_ = [0, [8, [0, 0, 5], 0, 0, 0], cst_F],
		              S5 = [0, [9, 0, 0], cst_B],
		              S4 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Bool", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Bool@ "],
		              S6 = [0, [17, 0, [12, 41, 0]], cst$39],
		              S7 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Date", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Date@ "],
		              S8 = [0, [17, 0, [12, 41, 0]], cst$39],
		              S9 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Float", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Float@ "],
		              S$ = [0, [17, 0, [12, 41, 0]], cst$39],
		              Ta =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Int", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Int@ "],
		              Tc = [0, [17, 0, [12, 41, 0]], cst$39],
		              Td =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.List", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.List@ "],
		              Th = [0, [17, 0, [12, 41, 0]], cst$39],
		              Ti =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Note", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Note@ "],
		              Tj = [0, [17, 0, [12, 41, 0]], cst$39],
		              Tk =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Record", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Record@ "],
		              Tl = [0, [17, 0, [12, 41, 0]], cst$39],
		              Tm =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Relation", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Relation@ "],
		              Tn = [0, [17, 0, [12, 41, 0]], cst$39],
		              To =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.String", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.String@ "],
		              Tq = [0, [17, 0, [12, 41, 0]], cst$39],
		              Tr =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Tuple", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Tuple@ "],
		              Tv = [0, [17, 0, [12, 41, 0]], cst$39],
		              Tw =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Json", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Json@ "],
		              Tx = [0, [17, 0, [12, 41, 0]], cst$39],
		              SR = [0, 0],
		              SS =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_7, [0, cst_default_types_relations, 0]]]],
		              SP = [0, cst_The_target_of_a_relation_s],
		              SQ = [0, "cell-relation-target"],
		              ST =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Relation.Table", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Relation.Table@ "],
		              SU = [0, [17, 0, [12, 41, 0]], cst$39],
		              SV =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Cell.Relation.Default", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Cell.Relation.Default@ "],
		              SW = [0, [17, 0, [12, 41, 0]], cst$39],
		              Su = [0, cst_table],
		              Ss = [0, "A relation to a builtin Routine type"],
		              St = [0, "cell-relation-target-default"],
		              Sv =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Cell.Relation.Default.Member {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Cell.Relation.Default.Member {@,"],
		              Sw =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Sx = [0, [17, 0, 0], cst$6],
		              Sy = [0, [17, 0, [12, 125, 0]], cst$50],
		              Sz =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Cell.Relation.Default.Page {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Cell.Relation.Default.Page {@,"],
		              SA =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              SB = [0, [17, 0, 0], cst$6],
		              SC = [0, [17, 0, [12, 125, 0]], cst$50],
		              SD =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Cell.Relation.Default.Task {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Cell.Relation.Default.Task {@,"],
		              SE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              SF = [0, [17, 0, 0], cst$6],
		              SG = [0, [17, 0, [12, 125, 0]], cst$50],
		              SH =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Cell.Relation.Default.Event {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Cell.Relation.Default.Event {@,"],
		              SI =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              SJ = [0, [17, 0, 0], cst$6],
		              SK = [0, [17, 0, [12, 125, 0]], cst$50],
		              SL =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Cell.Relation.Default.People {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Cell.Relation.Default.People {@,"],
		              SM =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              SN = [0, [17, 0, 0], cst$6],
		              SO = [0, [17, 0, [12, 125, 0]], cst$50],
		              Sk = [0, "cell-relation-target-table"],
		              Sl =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Sm =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Sn = [0, [17, 0, 0], cst$6],
		              So = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Sp =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Sq = [0, [17, 0, 0], cst$6],
		              Sr = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              TK =
		                [0,
		                 "A path from a cell to one or several of its descendants."],
		              TL = [0, cst_cell_path],
		              TH = [0, 0],
		              TG = [0, "Access all the children of a list cell"],
		              TI = [0, "Access a specific field of a tuple cell"],
		              TJ = [0, "Access a specific field of a record cell"],
		              TE = [0, "An accessor for the child of a cell"],
		              TF = [0, "path_item"],
		              UT = [0, 0],
		              UQ = [0, 0],
		              UP = [0, 0],
		              UO = [0, 0],
		              UN = [0, 0],
		              UM = [0, 0],
		              UK = [0, 0],
		              UH = [0, 0],
		              UI = [0, 0],
		              UJ = [0, "Any JSON data structure."],
		              UL = [0, "Deprecated, use {!Const} instead."],
		              match$123 = [0, 0],
		              UR = [0, 0],
		              US = [0, [0, cst_beta, [0, cst_3, [0, "cell-const", 0]]]],
		              UU = [0, cst_type],
		              UF = [0, "The representation for the type of a single cell"],
		              UG = [0, "graph-custom-type"],
		              UW = [0, "A human-readable description of the field"],
		              UX =
		                [0, "The expression to evaluate if this is a computed field."],
		              UV = [0, "graph-custom-type-field"],
		              UD =
		                [0,
		                 "If [Some], indicates that the relation should be mirrored on the\n            target as a toplevel field (whose name and id are given by the\n            payload."],
		              UE = [0, "The target for this relation"],
		              UC = [0, "cell-schema-relation"],
		              Uy = [0, 0],
		              Uz =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_7, [0, cst_default_types_relations, 0]]]],
		              UA =
		                [0,
		                 "Relation pointing to an default type. These are handled specially\n              in the front"],
		              UB =
		                [0,
		                 "Relation pointing to another table in the custom database"],
		              Uw = [0, cst_The_target_of_a_relation_s],
		              Ux = [0, "cell-schema-relation-target"],
		              Uv = [0, 0],
		              Ut = [0, 0],
		              Ur = [0, 0],
		              Up = [0, 0],
		              Un = [0, 0],
		              Um = [0, 0, 0, [9, cst_people], 0],
		              Uo = [0, 0, 0, [9, cst_event], 0],
		              Uq = [0, 0, 0, [9, cst_task], 0],
		              Us = [0, 0, 0, [9, cst_page], 0],
		              Uu = [0, 0, 0, [9, cst_member], 0],
		              Uk = [0, "A relation to a default Routine type"],
		              Ul = [0, "cell-schema-relation-target-default"],
		              Ug = [0, 0],
		              Uh =
		                [0,
		                 [0, cst_beta, [0, cst_7, [0, cst_read_write_per_field, 0]]]],
		              Ui = [0, "Whether the cell data value can be read/written"],
		              match$122 = [0, 1],
		              Uj =
		                [0,
		                 "Whether the user is allowed to update the schema of the cell"],
		              Ue = [0, "The permissions on a single cell"],
		              Uf = [0, cst_table_cell_permission],
		              match$119 = [0, 1],
		              match$120 = [0, 1],
		              match$121 = [0, 1],
		              Ud =
		                [0,
		                 "Some fields (backed by Membrane) only make sense when writing\n              (creation or update), e.g. the [addLabelIds] field for Gmail\n              messages."],
		              Ub = [0, "Permissions on the cell data value"],
		              Uc = [0, "table-cell-permission-data"],
		              Ua = [0, 0],
		              T8 = [0, 0],
		              T5 = [0, 0],
		              T6 =
		                [0,
		                 [0, cst_beta, [0, cst_7, [0, cst_table_cell_permission, 0]]]],
		              T7 = [0, 0, 0, [9, cst_read_write], 0],
		              T9 = [0, 0],
		              T_ =
		                [0,
		                 [0, cst_beta, [0, cst_7, [0, cst_table_cell_permission, 0]]]],
		              T$ = [0, 0, 0, [9, cst_read_only], 0],
		              T3 = [0, "Permissions on the cell schema"],
		              T4 = [0, "table-cell-permission-schema"],
		              T1 =
		                [0,
		                 "Name of the field corresponding to the reverse relation.\n\n            It is assumed that the table to which this field is attached doesn't\n            have a field of the same name as bad things\xe2\x84\xa2 will happen otherwise"],
		              T2 =
		                [0,
		                 "Identifier of the field corresponding to the reverse relation."],
		              TZ =
		                [0,
		                 "A \xe2\x80\x9cvirtual\xe2\x80\x9d toplevel field corresponding to the inverse of a relation.\n\n      Such a field isn't backed by a column in the table, but it is defined as\n      the reverse of a [Relation] field defined elsewhere."],
		              T0 = [0, "graph-custom-type-reverse-relation"],
		              TY = [0, 0],
		              TU = [0, 0],
		              TQ = [0, 0],
		              TN = [0, 0],
		              TO =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_graph_custom_string_format, 0]]]],
		              TP = [0, 0, 0, [9, cst_uri], 0],
		              TR = [0, 0],
		              TS =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_graph_custom_string_format, 0]]]],
		              TT = [0, 0, 0, [9, cst_phone], 0],
		              TV = [0, 0],
		              TW =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_graph_custom_string_format, 0]]]],
		              TX = [0, 0, 0, [9, cst_email], 0],
		              TM = [0, "string_format"],
		              UZ = [0, "Column to display as the main notes."],
		              U0 =
		                [0,
		                 "An URL pointing to an image to display as the table icon. Should take\n          precedence over [emoji] if specified"],
		              U1 =
		                [0,
		                 "Columns that should not be displayed by default in views of this\n          table."],
		              U2 = [0, "An emoji to use as the icon for the table"],
		              UY = [0, "database-metadata"],
		              U3 =
		                [0,
		                 "The type for a database row.\n\n    Because individual cells contain themselves structured data, this is\n    isomorphic to a [Record] cell"],
		              U4 = [0, cst_row],
		              U5 = [0, "The schema for a database table (or for a row)"],
		              U6 = [0, cst_row_schema],
		              match$129 = [0, 0],
		              Vt =
		                [0,
		                 "Some tables are read-only, both their schema and data. This is\n          typically the case for Integration App tables, which are a read-only\n          view of a third party resource."],
		              Vu =
		                [0,
		                 "Metadata about that table, that is exposed verbatim in the language"],
		              match$130 = [0, cst$1],
		              Vv =
		                [0,
		                 'User-friendly description of the table, e.g.,\n          ["A type that does amazing things"]'],
		              Vw =
		                [0,
		                 'Fancy, user-friendly, singular name, e.g., ["My amazing type"]'],
		              Vx = [0, 'Technical, plural name, e.g., ["my-amazing-types"]'],
		              Vs = [0, cst_table],
		              Vr = [0, 0],
		              Vp = [0, 0],
		              Vn = [0, 0],
		              Vj = [0, 0],
		              Vg = [0, 0],
		              Vh =
		                [0,
		                 [0, cst_beta, [0, cst_2$2, [0, "builtin-custom-types", 0]]]],
		              Vi = [0, 0, 0, [9, cst_internal_builtin_custom_ty], 0],
		              Vk = [0, 0],
		              Vl =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_4, [0, "builtin-types-extensions-impl", 0]]]],
		              Vm = [0, 0, 0, [9, cst_internal_builtin_type_exte], 0],
		              Vo = [0, 0, 0, [9, cst_integration_app], 0],
		              Vq = [0, 0, 0, [9, cst_user_defined], 0],
		              Ve =
		                [0,
		                 "Keep track of where this table originates from. This is useful both:\n      - in API, e.g., to detect Integration App-backed CRDT commits and push\n        them to Integration App\n      - in Front, e.g., to display differently custom types created by the user\n        from ones created by Integration App"],
		              Vf = [0, cst_origin],
		              match$124 = [0, 1],
		              U9 =
		                [0,
		                 "Whether the user is allowed to delete existing objects of that type"],
		              match$125 = [0, 1],
		              U_ =
		                [0,
		                 "Whether the user is allowed to update existing objects of that type"],
		              match$126 = [0, 1],
		              U$ =
		                [0,
		                 "Whether the user is allowed to create new objects of that type"],
		              match$127 = [0, 1],
		              Va =
		                [0,
		                 "Whether the user is allowed to update the schema of the type.\n\n            Note that even if this is set to [true], some rows might be\n            individualy locked"],
		              Vb = [0, 0],
		              Vc =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_2$2, [0, "read-only-default-types", 0]]]],
		              match$128 = [0, 1],
		              Vd =
		                [0,
		                 "Whether the user is allowed to update (rename/remove) the type"],
		              U8 = [0, cst_permissions],
		              U7 = [0, cst_rows],
		              VC = [0, "db"],
		              VB = [0, cst_hierarchy],
		              VA = [0, 0],
		              Vz = [0, 0, 0, [9, cst_root], 0],
		              Vy = [0, cst_parent],
		              VF = [0, 0],
		              VG =
		                [0,
		                 [0, cst_beta, [0, cst_3, [0, "builtin-types-extensions", 0]]]],
		              VD =
		                [0,
		                 "The type for an extension row.\n\n    This is isomorphic to `Table.Row_id.t`, however its schema is different\n    (with a [@since] annotation) since old clients can't handle this being non\n    optional"],
		              VE = [0, cst_extension_row],
		              VH =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Extension_row.Extension_row",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Extension_row.Extension_row@ "],
		              VI = [0, [17, 0, [12, 41, 0]], cst$39],
		              WA = [0, 0],
		              Wz = [0, 0],
		              WB = [0, cst_status],
		              match$131 = [0, "integration-status"],
		              WC =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Integration.Status.Broken", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Integration.Status.Broken@ "],
		              WD = [0, [17, 0, [12, 41, 0]], cst$39],
		              Wl = [0, "The equivalent of [Error.t] for the UI."],
		              Wm = [0, "integration-report"],
		              Wn =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Wo =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Wp = [0, [17, 0, 0], cst$6],
		              Wq = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Wr =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ws = [0, [3, 0, 0], a],
		              Wt = [0, [17, 0, 0], cst$6],
		              Wu = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Wv =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Ww = [0, [3, 0, 0], a],
		              Wx = [0, [17, 0, 0], cst$6],
		              Wy = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              Wk = [0, 0],
		              Wi = [0, 0],
		              Wh = [0, 0, 0, [9, cst_configuration], 0],
		              Wj = [0, 0, 0, [9, cst_backend], 0],
		              Wg = [0, "integration-report-broken-cause"],
		              V7 =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              V8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              V9 = [0, [3, 0, 0], a],
		              V_ = [0, [17, 0, 0], cst$6],
		              V$ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Wa =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Wb = [0, [17, 0, 0], cst$6],
		              Wc = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              We = [0, "The error."],
		              Wf =
		                [0,
		                 "The type of the error'd integration - eg. Notion, Gmail ..."],
		              Wd = [0, "integration-error"],
		              V0 =
		                [0,
		                 [11,
		                  "`Integration_api (",
		                  [18, [1, [0, [11, cst_hov, 0], cst_hov]], 0]],
		                 "`Integration_api (@[<hov>"],
		              V1 = [0, [17, 0, [12, 41, 0]], cst$39],
		              V2 =
		                [0,
		                 [11,
		                  "`Integration_config (",
		                  [18, [1, [0, [11, cst_hov, 0], cst_hov]], 0]],
		                 "`Integration_config (@[<hov>"],
		              V3 = [0, [3, 0, 0], a],
		              V4 = [0, [17, 0, [12, 41, 0]], cst$39],
		              V5 = [0, "Integration specific errors"],
		              V6 = [0, "integration-error-error"],
		              VL =
		                [0,
		                 [11,
		                  "`Unexpected_content (",
		                  [18, [1, [0, [11, cst_hov, 0], cst_hov]], 0]],
		                 "`Unexpected_content (@[<hov>"],
		              VM = [0, [3, 0, 0], a],
		              VN = [0, [17, 0, [12, 41, 0]], cst$39],
		              VJ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              VK =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              VO = [0, [17, 0, 0], cst$6],
		              VP = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              VQ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              VR = [0, [3, 0, 0], a],
		              VS = [0, [17, 0, 0], cst$6],
		              VT = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              VU =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              VV = [0, [17, 0, 0], cst$6],
		              VW = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              VZ = [0, 0],
		              VY = [0, 0, 0, [9, cst_unexpected_status$0], 0],
		              VX = [0, "integration-error-http-error"],
		              WL = [0, 0],
		              WK = [0, 0, 0, [9, cst_development], 0],
		              WJ = [0, cst_environment],
		              WI = [0, 0],
		              WG = [0, 0],
		              WF = [0, 0, 0, [9, cst_stable], 0],
		              WH = [0, 0, 0, [9, cst_bleeding], 0],
		              WE = [0, "release_channel"],
		              Xr = [0, [0, cst$1], 0],
		              Xl = [0, "Personal workspace of the user"],
		              Xm = [0, "The potential premium key"],
		              Xn = [0, "The internal (opaque) account id"],
		              Xo = [0, "Account id, i.e. the main google account"],
		              match$135 = [0, 1],
		              Xp = [0, "The user's release channel."],
		              Xq = [0, "Routine token"],
		              W0 = [0, cst_The_time_at_which_this_gra],
		              W1 = [0, cst_The_granted_capacities],
		              WZ = [0, cst_grant],
		              W2 = [0, cst_The_capacities_granted_to_],
		              W3 = [0, cst_The_origin_scheme_host_por],
		              match$132 = [0, 0],
		              W4 = [0, cst_The_query_params_to_includ],
		              W5 = [0, cst_The_path_to_return_to],
		              W7 = [0, cst_The_time_at_which_this_gra],
		              W8 = [0, cst_The_granted_capacities],
		              W6 = [0, cst_grant],
		              W9 = [0, cst_The_capacities_granted_to_],
		              W_ = [0, cst_The_origin_scheme_host_por],
		              match$133 = [0, 0],
		              W$ = [0, cst_The_query_params_to_includ],
		              Xa = [0, cst_The_path_to_return_to],
		              Xb = [0, cst_userinfo],
		              Xd = [0, cst_The_time_at_which_this_gra],
		              Xe = [0, cst_The_granted_capacities],
		              Xc = [0, cst_grant],
		              Xg = [0, cst_The_capacities_granted_to_],
		              Xf = [0, "client_grant"],
		              Xi = [0, cst_The_origin_scheme_host_por],
		              match$134 = [0, 0],
		              Xj = [0, cst_The_query_params_to_includ],
		              Xk = [0, cst_The_path_to_return_to],
		              Xh = [0, "return_info"],
		              WS = [0, "Terms of use uri"],
		              WT = [0, "Privacy policy uri"],
		              WU = [0, "Homepage uri"],
		              WV = [0, cst_Icon],
		              WW = [0, "Support email"],
		              WX = [0, "One-liner tagline"],
		              WY = [0, "Short name"],
		              WR = [0, "oauth-client"],
		              WQ = [0, 0],
		              WO = [0, 0],
		              WN = [0, 0, 0, [9, cst_task_archive], 0],
		              WP = [0, 0, 0, [9, cst_task_add], 0],
		              WM = [0, cst_capacity],
		              Xs = [0, 0],
		              Xt = [0, [0, cst_beta, [0, cst_1, [0, cst_object_id, 0]]]],
		              Xu =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Parent_id_intf.Event", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Parent_id_intf.Event@ "],
		              Xv = [0, [17, 0, [12, 41, 0]], cst$39],
		              Xw =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Parent_id_intf.Event_recurrent",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Parent_id_intf.Event_recurrent@ "],
		              Xx = [0, [17, 0, [12, 41, 0]], cst$39],
		              Xy =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Parent_id_intf.Page", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Parent_id_intf.Page@ "],
		              Xz = [0, [17, 0, [12, 41, 0]], cst$39],
		              XA =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Parent_id_intf.People", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Parent_id_intf.People@ "],
		              XB = [0, [17, 0, [12, 41, 0]], cst$39],
		              XC =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Parent_id_intf.Task", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Parent_id_intf.Task@ "],
		              XD = [0, [17, 0, [12, 41, 0]], cst$39],
		              XE =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Parent_id_intf.Task_recurrent",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Parent_id_intf.Task_recurrent@ "],
		              XF = [0, [17, 0, [12, 41, 0]], cst$39],
		              XG =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Parent_id_intf.Object", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Parent_id_intf.Object@ "],
		              XH = [0, [17, 0, [12, 41, 0]], cst$39],
		              X0 = [0, cst_set],
		              XZ = [0, cst_by],
		              XY = [0, 0],
		              XW = [0, 0],
		              XU = [0, 0],
		              XS = [0, 0],
		              XQ = [0, 0],
		              XO = [0, 0],
		              XM = [0, 0],
		              XJ = [0, 0],
		              XK = [0, [0, cst_beta, [0, cst_1, [0, cst_object_id, 0]]]],
		              XL = [0, 0, 0, [9, cst_object], 0],
		              XN = [0, 0, 0, [9, cst_task_rec], 0],
		              XP = [0, 0, 0, [9, cst_task], 0],
		              XR = [0, 0, 0, [9, cst_people], 0],
		              XT = [0, 0, 0, [9, cst_page], 0],
		              XV = [0, 0, 0, [9, cst_event_rec], 0],
		              XX = [0, 0, 0, [9, cst_event], 0],
		              XI = [0, "parent-kind"],
		              Zr =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Task.Id_any.Task", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Task.Id_any.Task@ "],
		              Zs = [0, [17, 0, [12, 41, 0]], cst$39],
		              Zt =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Task.Id_any.Task_recurrent",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Task.Id_any.Task_recurrent@ "],
		              Zu = [0, [17, 0, [12, 41, 0]], cst$39],
		              Zp = [0, cst_A_task],
		              Zq = [0, cst_task],
		              match$137 = [0, 0],
		              match$138 = [0, 0],
		              match$139 = [0, "task-with-id"],
		              Zo = [0, "A task, with parametric id."],
		              YM = [0, "Fields that can be cloned from a template."],
		              YN = [0, cst_Whether_the_task_is_starre],
		              YO = [0, 0],
		              YP = [0, 0],
		              YQ =
		                [0,
		                 "The date at which the task is scheduled, if it is scheduled."],
		              YR = [0, "The potential parent object."],
		              YS =
		                [0, "Recurrence information if this task is an occurrence."],
		              YT =
		                [0, "Identification of the distant counterpart of this task."],
		              YU =
		                [0,
		                 "Optional reference to a row in the task extensions table for\n              custom user-defined fields."],
		              YV =
		                [0,
		                 "The time at which the task was completed, if it is completed."],
		              YW =
		                [0,
		                 "The time at which the task was archived/ignored, if it is."],
		              YL = [0, "Task editable fields."],
		              Zi = [0, [9, 0, 0], cst_B],
		              YX =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              YY =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              YZ = [0, [17, 0, 0], cst$6],
		              Y0 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Y1 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Y2 = [0, [17, 0, 0], cst$6],
		              Y3 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Y4 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Y5 = [0, [17, 0, 0], cst$6],
		              Y6 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Y7 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Y8 = [0, [17, 0, 0], cst$6],
		              Y9 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Y_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Y$ = [0, [17, 0, 0], cst$6],
		              Za = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Zb =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Zc = [0, [17, 0, 0], cst$6],
		              Zd = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Ze =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Zf = [0, [17, 0, 0], cst$6],
		              Zg = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Zh =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Zj = [0, [17, 0, 0], cst$6],
		              Zk = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Zl =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Zm = [0, [17, 0, 0], cst$6],
		              Zn = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              match$136 = [0, 0],
		              Yz = [0, "task-integration"],
		              YA =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              YB =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              YC = [0, [17, 0, 0], cst$6],
		              YD = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              YE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              YF = [0, [3, 0, 0], a],
		              YG = [0, [17, 0, 0], cst$6],
		              YH = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              YI =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              YJ = [0, [17, 0, 0], cst$6],
		              YK = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              Yk = [0, cst_The_potential_capture_cont],
		              Yl = [0, "The task title."],
		              Ym = [0, 0],
		              Yn = [0, "The task notes."],
		              Yj = [0, "Task fields that can be cloned from a template."],
		              Yt = [0, [3, 0, 0], a],
		              Yo =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Yp =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Yq = [0, [17, 0, 0], cst$6],
		              Yr = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Ys =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Yu = [0, [17, 0, 0], cst$6],
		              Yv = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Yw =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Yx = [0, [17, 0, 0], cst$6],
		              Yy = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              Yi = [0, 0],
		              Yh = [0, 0, 0],
		              Yb = [0, "The task is scheduled for a day"],
		              Yc = [0, "The task is postponed to a batch"],
		              Ya = [0, cst_scheduling],
		              Yd =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Task.Scheduling.Batch", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Task.Scheduling.Batch@ "],
		              Ye = [0, [17, 0, [12, 41, 0]], cst$39],
		              Yf =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11, "Task.Scheduling.Date", [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Task.Scheduling.Date@ "],
		              Yg = [0, [17, 0, [12, 41, 0]], cst$39],
		              X3 = [0, "The parent task that spawned this occurrence."],
		              X4 = [0, "The date this occurrence was spawned for."],
		              X1 = [0, "Occurence information."],
		              X2 = [0, cst_occurrence],
		              X5 =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              X6 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              X7 = [0, [17, 0, 0], cst$6],
		              X8 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              X9 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              X_ = [0, [17, 0, 0], cst$6],
		              X$ = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ZF = [0, cst_A_recurrent_task],
		              ZG = [0, "recurrent-task"],
		              Zv =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              Zw =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              Zx = [0, [17, 0, 0], cst$6],
		              Zy = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              Zz =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ZA = [0, [17, 0, 0], cst$6],
		              ZB = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ZC =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ZD = [0, [17, 0, 0], cst$6],
		              ZE = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ZN = [0, 0],
		              ZL = [0, 0],
		              ZJ = [0, 0],
		              ZI =
		                [0,
		                 'The ressource is, to our knowledge, as up to date as possible (in the\n          "eventual consistency" sense of the term).'],
		              ZK = [0, "The ressource is currently being brought up to date."],
		              ZM =
		                [0,
		                 "The ressource was just created and is yet to load its initial state."],
		              ZH = [0, "synchronization_state"],
		              ZO = [0, cst_email],
		              _p = [0, "organization-full"],
		              match$141 = [0, cst_org_poly],
		              match$140 = [0, cst_org_poly],
		              _o = [0, "An organization"],
		              _m = [0, "The user-facing name for the organization."],
		              _n =
		                [0,
		                 "An organization has one owner, who has all permissions on the\n            organization."],
		              _l = [0, cst_members],
		              _h = [0, "User-facing name displayed for this member."],
		              _i = [0, cst_Unique_account_id_of_the_m],
		              _j = [0, "Main Routine account email of the member."],
		              _k =
		                [0, "Level of permission of the member on the organization."],
		              _g = [0, cst_member],
		              _f = [0, 0],
		              _d = [0, 0],
		              _c =
		                [0, "read-write access to everything in this organization."],
		              _e =
		                [0,
		                 "read-access to the list of members of the organization, read-write\n            access to the workspaces that the member has been added to"],
		              _a =
		                [0,
		                 "Level of permission of members of the organization.\n\n      For now the only levels are [Member], that has no rights on the\n      organization, and [Owner], that has all rights on the organization, and we\n      assume that there is only one owner."],
		              _b = [0, cst_access_role],
		              Z$ = [0, 0],
		              Z9 = [0, 0],
		              Z7 = [0, 0],
		              Z5 = [0, 0],
		              Z3 = [0, 0],
		              Z1 = [0, 0],
		              ZZ = [0, 0],
		              ZX = [0, 0],
		              ZV = [0, 0],
		              ZT = [0, 0],
		              ZR = [0, 0],
		              ZQ =
		                [0,
		                 "The member has the right to rename workspaces in the organization."],
		              ZS =
		                [0,
		                 "The member has the right to delete a workspace from the\n              organization."],
		              ZU =
		                [0,
		                 "The member has the right to set the workspace access role of\n              members."],
		              ZW =
		                [0,
		                 "The member has the right to remove members from workspaces."],
		              ZY =
		                [0,
		                 "The member has the right to add organization members to\n              workspaces."],
		              Z0 =
		                [0,
		                 "The member has the right to create new workspaces in the\n              organization."],
		              Z2 = [0, "The member has the right to rename the organization."],
		              Z4 =
		                [0,
		                 "The member has the right to revoke an invitation to the\n              organization."],
		              Z6 =
		                [0,
		                 "The member has the right to remove members from the organization."],
		              Z8 =
		                [0,
		                 "The member has the right to invite members to the organization."],
		              Z_ = [0, "The member has the right to delete the organization."],
		              ZP = [0, "user-permission"],
		              _r = [0, "The expiration date of the subscription."],
		              match$142 = [0, 3],
		              _s =
		                [0,
		                 "The number of seats. Only makes sense for some subscriptions"],
		              match$143 = [0, 0],
		              _q = [0, cst_subscription],
		              _A = [0, "slot-type"],
		              _z = [0, 0],
		              _x = [0, 0],
		              _v = [0, 0],
		              _u = [0, 0, 0, [9, cst_processing], 0],
		              _w = [0, 0, 0, [9, cst_meetings], 0],
		              _y = [0, 0, 0, [9, cst_focus], 0],
		              _t = [0, "slot-kind"],
		              match$144 = [0, 0],
		              _1 = [0, cst_calendar],
		              _0 = [0, 0],
		              _Y = [0, 0],
		              _W = [0, 0],
		              _U = [0, 0],
		              _S = [0, 0],
		              _Q = [0, 0],
		              _O = [0, 0],
		              _M = [0, 0],
		              _K = [0, 0],
		              _J = [0, 0, 0, [9, cst_i$0], 0],
		              _L = [0, 0, 0, [9, cst_h$0], 0],
		              _N = [0, 0, 0, [9, cst_g], 0],
		              _P = [0, 0, 0, [9, cst_f$0], 0],
		              _R = [0, 0, 0, [9, cst_e], 0],
		              _T = [0, 0, 0, [9, cst_d$0], 0],
		              _V = [0, 0, 0, [9, cst_c$0], 0],
		              _X = [0, 0, 0, [9, cst_b], 0],
		              _Z = [0, 0, 0, [9, cst_a$0], 0],
		              _I = [0, "calendar-color"],
		              _H = [0, 0],
		              _F = [0, 0],
		              _D = [0, 0],
		              _C = [0, 0, 0, [9, cst_secondary], 0],
		              _E = [0, 0, 0, [9, cst_primary], 0],
		              _G = [0, 0, 0, [9, cst_default], 0],
		              _B = [0, "calendar-role"],
		              _4 = [0, "locale-settings-patch"],
		              _3 = [0, "locale-settings"],
		              _2 = [0, "locale-config"],
		              $G =
		                [0,
		                 [11, "refusing to unset default calendar: ", [15, 0]],
		                 "refusing to unset default calendar: %a"],
		              $H = [0, 0, 0, 2],
		              $F =
		                [0,
		                 [11,
		                  "ignoring duplicate default calendar in settings patch: ",
		                  [15, [11, b, [15, 0]]]],
		                 "ignoring duplicate default calendar in settings patch: %a and %a"],
		              $p =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              $q =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $r = [0, [17, 0, 0], cst$6],
		              $s = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              $t =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $u = [0, [17, 0, 0], cst$6],
		              $v = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              $w =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $x = [0, [17, 0, 0], cst$6],
		              $y = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              $z =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $A = [0, [17, 0, 0], cst$6],
		              $B = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              $C =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $D = [0, [17, 0, 0], cst$6],
		              $E = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              $c = [0, 0],
		              $d = [0, [0, cst_rc, [0, cst_1, 0]]],
		              $j = [0, [9, 0, 0], cst_B],
		              $e =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              $f =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $g = [0, [17, 0, 0], cst$6],
		              $h = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              $i =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $k = [0, [17, 0, 0], cst$6],
		              $l = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              $m =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $n = [0, [17, 0, 0], cst$6],
		              $o = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              _$ = [0, [9, 0, 0], cst_B],
		              _7 = [0, [9, 0, 0], cst_B],
		              _5 =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              _6 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              _8 = [0, [17, 0, 0], cst$6],
		              _9 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              __ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $a = [0, [17, 0, 0], cst$6],
		              $b = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              $K =
		                [0,
		                 "An account token granting permissions on the behalf of [account]."],
		              $L = [0, "The impersonated account."],
		              $I = [0, "The outcome of an admin impersonating an account."],
		              $J = [0, "impersonation"],
		              $M = [0, cst_attachment],
		              $O =
		                [0,
		                 "Like Mandate.Recurrence.t with different boundaries + timezone.\n\n    FIXME: For now [tag:recurrence first occurrence can be invalid], but we\n    should enforce at the typing level that it never happens, for instance by\n    computing and storing the actual [Time.t] boundaries."],
		              $P = [0, "event_recurrence"],
		              $N = [0, cst_boundaries],
		              $S = [0, "The time at which the event ends"],
		              $T = [0, "The time at which the event starts"],
		              $U = [0, "A span with exact daytime delimitation"],
		              $V = [0, "The inclusive date at which the event ends"],
		              $W = [0, "The inclusive date at which the event starts"],
		              $X = [0, "Multiple whole days"],
		              $Y = [0, "The date of the event"],
		              $Z = [0, "A whole day"],
		              $Q = [0, "Time period an event spans."],
		              $R = [0, "event-time"],
		              $0 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Time_intf.Date {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Time_intf.Date {@,"],
		              $1 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $2 = [0, [17, 0, 0], cst$6],
		              $3 = [0, [17, 0, [12, 125, 0]], cst$50],
		              $4 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Time_intf.Dates {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Time_intf.Dates {@,"],
		              $5 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $6 = [0, [17, 0, 0], cst$6],
		              $7 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              $8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              $9 = [0, [17, 0, 0], cst$6],
		              $_ = [0, [17, 0, [12, 125, 0]], cst$50],
		              $$ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Time_intf.Times {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Time_intf.Times {@,"],
		              aaa =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aab = [0, [17, 0, 0], cst$6],
		              aac = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aad =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aae = [0, [17, 0, 0], cst$6],
		              aaf = [0, [17, 0, [12, 125, 0]], cst$50],
		              abh = [0, cst_link],
		              aa7 = [0, 0],
		              aa5 = [0, 0],
		              aa3 = [0, 0],
		              aa2 = [0, 0, 0, [9, cst_cancelled], 0],
		              aa4 = [0, 0, 0, [9, cst_tentative], 0],
		              aa6 = [0, 0, 0, [9, cst_confirmed], 0],
		              aa1 = [0, cst_calendar_status],
		              abg = [0, 0],
		              abe = [0, 0],
		              abc = [0, 0],
		              aba = [0, 0],
		              aa_ = [0, 0],
		              aa9 = [0, 0, 0, [9, cst_zoom], 0],
		              aa$ = [0, 0, 0, [9, cst_whereby], 0],
		              abb = [0, 0, 0, [9, cst_teams], 0],
		              abd = [0, 0, 0, [9, cst_meet], 0],
		              abf = [0, 0, 0, [9, cst_discord], 0],
		              aa8 = [0, "link_type"],
		              aa0 =
		                [0,
		                 [11,
		                  "merging two attendees with incompatible statuses: ",
		                  [15,
		                   [11,
		                    b,
		                    [15,
		                     [11,
		                      ". Arbitrarily picking the second status (hopefully more up-to-date).",
		                      0]]]]],
		                 "merging two attendees with incompatible statuses: %a and %a. Arbitrarily picking the second status (hopefully more up-to-date)."],
		              match$145 = [0, 0],
		              aaI = [0, cst_attendee],
		              aaJ = [0, "event-creator"],
		              aaQ = [0, [3, 0, 0], a],
		              aaK =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              aaL =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aaM = [0, [3, 0, 0], a],
		              aaN = [0, [17, 0, 0], cst$6],
		              aaO = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aaP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aaR = [0, [17, 0, 0], cst$6],
		              aaS = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aaT =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aaU = [0, [9, 0, 0], cst_B],
		              aaV = [0, [17, 0, 0], cst$6],
		              aaW = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aaX =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aaY = [0, [17, 0, 0], cst$6],
		              aaZ = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              aaH = [0, 0],
		              aaF = [0, 0],
		              aaD = [0, 0],
		              aaC = [0, 0, 0, [9, cst_maybe], 0],
		              aaE = [0, 0, 0, [9, cst_no], 0],
		              aaG = [0, 0, 0, [9, cst_yes], 0],
		              aaB = [0, "yes_no_maybe"],
		              aaA = [0, 0],
		              aay = [0, 0],
		              aax = [0, "This event is hidden in the agenda."],
		              aaz = [0, "This event is shown in the agenda."],
		              aaw = [0, "event-role"],
		              aav = [0, 0],
		              aar = [0, 0],
		              aao = [0, 0],
		              aap = [0, 0],
		              aaq = [0, "Mark the owner as free for this time slot."],
		              aas = [0, 0],
		              aat = [0, 0],
		              aau = [0, "Mark the owner as busy for this time slot."],
		              aam = [0, "Free / Busy status."],
		              aan = [0, "event-availability"],
		              aal = [0, 0],
		              aaj = [0, 0],
		              aai = [0, "Hide this event in the agenda."],
		              aak = [0, "Show this event in the agenda."],
		              aag =
		                [0,
		                 "Agenda visibility override - the name is historical.\n\n    If set, it takes precedence over the calendar role except if the event is\n    archived. [role_override] would be a better name."],
		              aah = [0, cst_attendance],
		              acq = [0, 1],
		              acp = [0, 2],
		              aco = [0, cst_event],
		              acn = [0, cst_event_creation],
		              acm = [0, 0],
		              abL = [0, 0],
		              acj = [0, [3, 0, 0], a],
		              ab7 = [0, [3, 0, 0], a],
		              ab0 = [0, [3, 0, 0], a],
		              abM =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              abN =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abO = [0, [17, 0, 0], cst$6],
		              abP = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abQ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abR = [0, [17, 0, 0], cst$6],
		              abS = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abT =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abU = [0, [17, 0, 0], cst$6],
		              abV = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abW =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abX = [0, [17, 0, 0], cst$6],
		              abY = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abZ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ab1 = [0, [17, 0, 0], cst$6],
		              ab2 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ab3 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ab4 = [0, [17, 0, 0], cst$6],
		              ab5 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ab6 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ab8 = [0, [17, 0, 0], cst$6],
		              ab9 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ab_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ab$ = [0, [17, 0, 0], cst$6],
		              aca = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              acb =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              acd = [0, [17, 0, 0], cst$6],
		              ace = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              acf =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              acg = [0, [17, 0, 0], cst$6],
		              ach = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aci =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ack = [0, [17, 0, 0], cst$6],
		              acl = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              abI = [0, 1],
		              abJ = [0, 1],
		              abK = [0, 0],
		              abH = [0, "Latest modification tag"],
		              abi = [0, 0],
		              match$146 = [0, 0],
		              match$147 = [0, 0],
		              aby = [0, [9, 0, 0], cst_B],
		              abj =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              abk =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abl = [0, [17, 0, 0], cst$6],
		              abm = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abn =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abo = [0, [17, 0, 0], cst$6],
		              abp = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abq =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abr = [0, [17, 0, 0], cst$6],
		              abt = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abu =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abv = [0, [17, 0, 0], cst$6],
		              abw = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abx =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abz = [0, [17, 0, 0], cst$6],
		              abA = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abB =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abC = [0, [17, 0, 0], cst$6],
		              abD = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              abE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              abF = [0, [17, 0, 0], cst$6],
		              abG = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              acQ = [0, "recurrence must have a start date"],
		              acR =
		                [0,
		                 [0, "api/schemas/src/event/recurrent.ml", 502, 15566, 15595]],
		              acS = [0, 0],
		              acP = [0, cst_event_recurrent$0],
		              acO = [0, "event-recurrent-creation"],
		              acN = [0, "event-recurrent-patch"],
		              acM = [0, 0],
		              acL = [0, 0],
		              acK = [0, 0],
		              acI = [0, 0],
		              acJ =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, "10", [0, cst_event_recurrent_attendance, 0]]]],
		              acG = [0, "Wrapping only to accomodate [@schematic.since]."],
		              acH = [0, cst_event_recurrent_attendance],
		              acF = [0, cst_exceptions],
		              acE = [0, "event-recurrent-daytime-creation"],
		              acD = [0, "event-recurrent-daytime-read"],
		              acC = [0, cst_event_recurrent_daytime],
		              acr = [0, cst_event_recurrent_daytime],
		              acs =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              act =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              acu = [0, [17, 0, 0], cst$6],
		              acv = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              acw =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              acx = [0, [17, 0, 0], cst$6],
		              acy = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              acz =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              acA = [0, [17, 0, 0], cst$6],
		              acB = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              adX = [0, 0],
		              adY = [0, cst_eventType],
		              adV =
		                [0,
		                 "[record] is in practice of type\n      {!Integration_app_api.Data_collection_find_by_id_response_dto_record.t}\n      but this type does not have an Ezjsonm decoding (used by\n      Schematic/Mellifera), only Yojson (used by OpenApi Generator), so we have\n      to keep [Schematic.Json.t] and parse ourselves..."],
		              adW = [0, cst_data_record_change],
		              adT = [0, "Per-workspace Integration App configuration"],
		              adU = [0, "integration-app-workspace-configuration"],
		              adI =
		                [0,
		                 "The applied parameters {b must} be part of the identifier of an\n                enabled data collection.\n\n                Quoting\n                https://console.integration.app/docs/membrane/building-blocks/data-collections#parameters\n                > For most purposes, you can treat two collection with the same\n                key but different parameters as two different collections."],
		              adH = [0, "integration-app-enabled-data-collection-id"],
		              adJ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              adK =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              adL = [0, [17, 0, 0], cst$6],
		              adM = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              adN =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              adO = [0, [17, 0, 0], cst$6],
		              adP = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              adQ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              adR = [0, [17, 0, 0], cst$6],
		              adS = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              adx = [0, 0],
		              ady =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_integration_app_force_refr, 0]]]],
		              adz =
		                [0,
		                 "A user requested an immediate re-synchronization of this (currently\n            {!Ready}) data collection. The API's commit inspector picks this up\n            and schedules a refresh, which resets the state back to {!Ready}\n            with a fresh [last_synced]. Carries the previous {!Ready.t} so the\n            underlying database/flow instance is preserved."],
		              adA = [0, 0],
		              adB =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, "integration-app-error-status", 0]]]],
		              adC = [0, 0],
		              adD = [0, 0],
		              adE = [0, 0],
		              adF = [0, 0],
		              adG = [0, cst_status],
		              adv =
		                [0, "A data collection with all parameters (if any) applied."],
		              adw = [0, "integration-app-enabled-data-collection"],
		              adq =
		                [0,
		                 "Something went wrong while enabling the data collection."],
		              adr = [0, "integration-app-enabled-data-collection-error"],
		              adu = [0, cst_status],
		              ads =
		                [0,
		                 "The previous state of the enabled data collection when it broke. This is\n        useful to not lose information, e.g. the database ID or Integration App\n        flow instance ID, if it breaks after an update."],
		              adt =
		                [0,
		                 "integration-app-enabled-data-collection-error-last-known-state"],
		              adl = [0, 0],
		              adm =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_5, [0, "no-menu-item-for-task-bindings", 0]]]],
		              match$149 = [0, 1],
		              adn =
		                [0,
		                 "Whether to automatically pin this data collection to the creator's\n              personal workspace menu upon creation."],
		              ado = [0, 'The membrane integration key (e.g. ["gmail"]).'],
		              adp = [0, "The requested database display name"],
		              adj = [0, "The enabled data collection is not yet created."],
		              adk =
		                [0,
		                 "integration-app-enabled-data-collection-creation-pending"],
		              adc = [0, 0],
		              ade =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_integration_app_force_refr, 0]]]],
		              match$148 = [0, 0],
		              adf =
		                [0,
		                 "When this data collection was last successfully synchronized with\n              the third party. [None] for collections synchronized before this\n              field existed (their [last_synced] is unknown). Refreshed on every\n              successful sync, even when no records changed."],
		              adg =
		                [0,
		                 "Whether all records have been fetched or not. Not all records are\n              fetched when there are too many (to avoid making our database and\n              the CRDT state too big)."],
		              adh =
		                [0,
		                 "The Integration App flow instance that will send data record\n              changes (creations/updates/deletions) to Routine. When disabling\n              (deleting) an enabled data collection, we should also delete this\n              flow instance to avoid receiving record changes we no longer care\n              about."],
		              adi =
		                [0,
		                 "The CRDT database containing data records coming from the third\n              party integration."],
		              adb = [0, "integration-app-enabled-data-collection-ready"],
		              ac$ = [1, 1],
		              ada = [1, 0],
		              ac_ =
		                [0,
		                 "integration-app-enabled-data-collection-ready-status-with-optional-union-key"],
		              ac9 = [0, 0],
		              ac7 = [0, 0],
		              ac6 = [0, 0, 0, [9, cst_no_list_method], 0],
		              ac8 = [0, 0, 0, [9, cst_success], 0],
		              ac5 =
		                [0,
		                 "integration-app-enabled-data-collection-ready-status-old"],
		              ac3 = [0, 0],
		              ac0 = [0, 0],
		              acZ =
		                [0,
		                 "Enabled data collection does not have a [list] method, so we can't\n              fetch records. Creating/updating/deleting a record may still work\n              (grey area)."],
		              ac1 =
		                [0,
		                 "Enabled data collection is partially synchronized: not all records\n              were fetched."],
		              ac2 = [0, "Enabled data collection is fully synchronized."],
		              ac4 = [0, "status-kind"],
		              acY =
		                [0, "integration-app-enabled-data-collection-ready-status"],
		              acX = [0, "pagination-stopped-reason-kind"],
		              acW =
		                [0,
		                 "integration-app-enabled-data-collection-ready-status-pagination-stopped-reason"],
		              acU = [0, "integration-app-data-collection-key"],
		              acV = [0, [3, 0, 0], a],
		              acT = [0, [3, 0, 0], a],
		              aeg = [0, 0],
		              aeh =
		                [0, [0, cst_beta, [0, cst_5, [0, "ai-message-citations", 0]]]],
		              match$154 = [0, 0],
		              aei = [0, "Routine-only: inline citations surfaced in the UI."],
		              aee = [0, "A message for OpenAI in Routine."],
		              aef = [0, "openai-message"],
		              ad8 = [0, 0],
		              ad7 = [0, 0],
		              ad9 = [0, 0],
		              ad_ =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_0, [0, cst_ai_conversation_tool_call, 0]]]],
		              match$152 = [0, 0],
		              ad$ =
		                [0,
		                 "Routine-only: tool calls executed to produce this assistant\n                turn."],
		              aea = [0, 0],
		              aeb =
		                [0,
		                 [0, cst_beta, [0, cst_8, [0, "conversation-attachment", 0]]]],
		              match$153 = [0, 0],
		              aec = [0, "Routine-only: files attached to this turn."],
		              aed = [0, cst_role],
		              ad6 = [0, "routine-openai-message-role"],
		              ad5 = [0, "openai-tool-call"],
		              match$151 = [0, 0],
		              ad3 =
		                [0,
		                 "Routine-only: The organization that the request comes from.\n              Optional for backward compatibility."],
		              ad4 = [0, cst_The_request_sent_to_OpenAI],
		              ad2 = [0, "base_client"],
		              match$150 = [0, 0],
		              ad0 =
		                [0,
		                 "Routine-only: The organization that the request comes from.\n                Optional for backward compatibility."],
		              ad1 = [0, cst_The_request_sent_to_OpenAI],
		              adZ = [0, "openai-chat-completions-creation"],
		              ag3 = [0, 0],
		              ag4 =
		                [0,
		                 [0, cst_beta, [0, cst_6, [0, cst_ai_automation_suspend, 0]]]],
		              ag5 = [0, 0],
		              ag6 = [0, [0, cst_beta, [0, cst_8, [0, cst_ai_assistant, 0]]]],
		              match$173 = [0, 0],
		              ag2 = [0, cst_ai],
		              match$172 = [0, 0],
		              ag1 = [0, "ai-automation-run"],
		              agZ = [0, 0],
		              ag0 =
		                [0, [0, cst_beta, [0, cst_1, [0, cst_automation_runs$0, 0]]]],
		              match$171 = [0, 0],
		              agY = [0, "ai-automation-run-step-result"],
		              agW = [0, 0],
		              agQ = [0, 0],
		              agR =
		                [0,
		                 [0, cst_beta, [0, cst_0, [0, cst_ai_human_in_the_loop, 0]]]],
		              match$170 = [0, 0],
		              agS = [0, "The user's response to [breakpoint.request]."],
		              agT = [0, 0],
		              agU =
		                [0,
		                 [0, cst_beta, [0, cst_0, [0, cst_ai_human_in_the_loop, 0]]]],
		              agV =
		                [0, "Conversation connected to this pause if there is one."],
		              agX = [0, cst_status],
		              agP = [0, "ai-automation-run-status"],
		              match$169 = [0, 0],
		              agL =
		                [0,
		                 "Previous tool calls in this step, before execution stopped."],
		              agM = [0, "Request made by the model to the user."],
		              agN = [0, "Tool call id waiting for output."],
		              agO = [0, "Step that execution stopped at"],
		              agK = [0, "ai-automation-run-breakpoint"],
		              agJ = [0, "AiAutomationRunToolCall"],
		              agI = [0, cst_with_optional_union_key],
		              agH = [0, "ai-automation-run-tool-call-without-union-key"],
		              agE = [0, 0],
		              agF =
		                [0,
		                 [0, cst_beta, [0, cst_0, [0, cst_ai_human_in_the_loop, 0]]]],
		              match$167 = [0, 0],
		              match$168 = [0, [0, 0]],
		              agG = [0, cst_kind],
		              agD = [0, "ai-automation-run-tool-call-with-union-key"],
		              agC = [0, cst_kind],
		              agB = [0, "ai-automation-run-response"],
		              agA = [0, "User responses to [question]. Empty if unanswered."],
		              agz = [0, "ai-automation-run-answered-question"],
		              agy = [0, cst_kind],
		              agx = [0, "ai-automation-run-request"],
		              match$165 = [0, 0],
		              agu =
		                [0,
		                 'Fixed choices to guide the user - an open "Other" choice will be\n                appended in the client.'],
		              match$166 = [0, 0],
		              agv = [0, cst_Optional_longer_rich_conte],
		              agw = [0, cst_The_question_in_short_form],
		              agt = [0, "ai-automation-run-question"],
		              agr = [0, 0],
		              agp = [0, 0],
		              agn = [0, 0],
		              agm = [0, "0, 1, or more answers."],
		              ago = [0, "More than one answer possible."],
		              agq = [0, "One mandatory answer."],
		              ags = [0, cst_kind],
		              agl = [0, "ai-automation-run-answer-count"],
		              agg = [0, 0],
		              agh =
		                [0,
		                 [0, cst_beta, [0, cst_3, [0, cst_ai_automation_trigger, 0]]]],
		              match$163 = [0, 0],
		              agi = [0, 0],
		              agj =
		                [0,
		                 [0, cst_beta, [0, cst_6, [0, cst_ai_automation_suspend, 0]]]],
		              match$164 = [0, 1],
		              agk = [0, cst_Display_name],
		              agf = [0, cst_ai_automation],
		              agd = [0, 0],
		              agb = [0, 0],
		              agc =
		                [0,
		                 [0, cst_beta, [0, cst_6, [0, "ai-automation-pattern", 0]]]],
		              age = [0, cst_trigger],
		              aga = [0, cst_ai_automation_trigger],
		              af_ = [0, 0],
		              af$ =
		                [0,
		                 [0, cst_beta, [0, cst_2$2, [0, "trigger-event-kinds", 0]]]],
		              af9 = [0, "ai-automation-trigger-pattern"],
		              af8 = [0, 0],
		              af6 = [0, 0],
		              af4 = [0, 0],
		              af3 = [0, 0, 0, [9, cst_deletion], 0],
		              af5 = [0, 0, 0, [9, cst_update], 0],
		              af7 = [0, 0, 0, [9, cst_creation], 0],
		              af2 = [0, "ai-automation-trigger-event-kind"],
		              af0 = [0, 0],
		              afZ = [0, 0],
		              afY = [0, 0],
		              afX = [0, 0],
		              afW = [0, 0],
		              afV = [0, 0],
		              af1 = [0, cst_kind],
		              afU = [0, "ai-automation-trigger-object-kind"],
		              afT = [0, cst_Display_name],
		              afS = [0, "ai-step"],
		              afQ =
		                [0,
		                 "Action to be performed by the agent, described by prompt"],
		              afR = [0, cst_action],
		              afP = [0, "ai-step-action"],
		              match$162 = [0, 0],
		              afO = [0, "ai-agent"],
		              afN = [0, "ai-agent-patch"],
		              afH = [0, 0],
		              afI =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_conversation_in_progress, 0]]]],
		              match$160 = [0, 0],
		              afJ = [0, 0],
		              afK =
		                [0,
		                 [0, cst_beta, [0, cst_7, [0, cst_conversation_context, 0]]]],
		              afL = [0, 0],
		              afM =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_ai_conversation_agent_id, 0]]]],
		              match$161 = [0, 0],
		              afG = [0, "ai-conversation"],
		              afF =
		                [0,
		                 "Tool calls executed so far in this turn, accumulated across\n              rounds, before the agent produces its final assistant message."],
		              afE = [0, "ai-conversation-in-progress"],
		              match$159 = [0, 0],
		              afD = [0, "ai-conversation-response"],
		              afB = [0, 0],
		              afC =
		                [0,
		                 [0, cst_beta, [0, cst_3, [0, cst_ai_automation_trigger, 0]]]],
		              afA = [0, "ai-prompt"],
		              match$156 = [0, 0],
		              match$157 = [0, 0],
		              match$158 = [0, 0],
		              afz = [0, "ai-prompt-context"],
		              afy = [0, "ai-prompt-context-reference"],
		              afx = [0, "ai-prompt-context-mention"],
		              match$155 = [0, 0],
		              afw =
		                [0,
		                 "The organization that owns this connection. [None] for records\n                stored before this field was added; in that case the controller\n                falls back to the owner org, which may be incorrect."],
		              afv = [0, "ai-prompt-context-integration"],
		              aft = [0, 0],
		              afu =
		                [0,
		                 [0, cst_beta, [0, cst_0, [0, "mcp-assistant-context", 0]]]],
		              afs = [0, cst_integration_key],
		              afr = [0, 0],
		              afn = [0, 0],
		              afj = [0, 0],
		              aff = [0, 0],
		              afb = [0, 0],
		              ae$ = [0, 0],
		              ae9 = [0, 0],
		              ae5 = [0, 0],
		              ae1 = [0, 0],
		              aeX = [0, 0],
		              aeT = [0, 0],
		              aeP = [0, 0],
		              aeL = [0, 0],
		              aeH = [0, 0],
		              aeD = [0, 0],
		              aez = [0, 0],
		              aev = [0, 0],
		              aer = [0, 0],
		              aen = [0, 0],
		              aek = [0, 0],
		              ael =
		                [0, [0, cst_beta, [0, cst_0, [0, cst_notion_integration, 0]]]],
		              aem = [0, 0, 0, [9, cst_notion], 0],
		              aeo = [0, 0],
		              aep =
		                [0,
		                 [0, cst_beta, [0, cst_4, [0, "instantly-integration", 0]]]],
		              aeq = [0, 0, 0, [9, cst_instantly], 0],
		              aes = [0, 0],
		              aet =
		                [0, [0, cst_beta, [0, cst_3, [0, "linkedin-integration", 0]]]],
		              aeu = [0, 0, 0, [9, cst_linkedin], 0],
		              aew = [0, 0],
		              aex =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_2$2, [0, "featurebase-integration", 0]]]],
		              aey = [0, 0, 0, [9, cst_featurebase], 0],
		              aeA = [0, 0],
		              aeB =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_0, [0, cst_ai_conversation_tool_call, 0]]]],
		              aeC = [0, 0, 0, [9, cst_todoist], 0],
		              aeE = [0, 0],
		              aeF =
		                [0, [0, cst_beta, [0, cst_3, [0, "ticktick-integration", 0]]]],
		              aeG = [0, 0, 0, [9, cst_ticktick], 0],
		              aeI = [0, 0],
		              aeJ =
		                [0, [0, cst_beta, [0, cst_3, [0, "whatsapp-integration", 0]]]],
		              aeK = [0, 0, 0, [9, cst_whatsapp], 0],
		              aeM = [0, 0],
		              aeN = [0, [0, cst_beta, [0, cst_1, [0, "jira-integration", 0]]]],
		              aeO = [0, 0, 0, [9, cst_jira], 0],
		              aeQ = [0, 0],
		              aeR =
		                [0, [0, cst_beta, [0, cst_9, [0, "trello-integration", 0]]]],
		              aeS = [0, 0, 0, [9, cst_trello], 0],
		              aeU = [0, 0],
		              aeV =
		                [0, [0, cst_beta, [0, cst_8, [0, "gitlab-integration", 0]]]],
		              aeW = [0, 0, 0, [9, cst_gitlab], 0],
		              aeY = [0, 0],
		              aeZ =
		                [0, [0, cst_beta, [0, cst_7, [0, "linear-integration", 0]]]],
		              ae0 = [0, 0, 0, [9, cst_linear], 0],
		              ae2 = [0, 0],
		              ae3 =
		                [0,
		                 [0, cst_beta, [0, cst_5, [0, "pipedrive-integration", 0]]]],
		              ae4 = [0, 0, 0, [9, cst_pipedrive], 0],
		              ae6 = [0, 0],
		              ae7 =
		                [0, [0, cst_beta, [0, cst_3, [0, "attio-integration", 0]]]],
		              ae8 = [0, 0, 0, [9, cst_attio], 0],
		              ae_ = [0, 0, 0, [9, cst_slack], 0],
		              afa = [0, 0, 0, [9, cst_gmail], 0],
		              afc = [0, 0],
		              afd =
		                [0, [0, cst_beta, [0, cst_4, [0, "github-integration", 0]]]],
		              afe = [0, 0, 0, [9, cst_github], 0],
		              afg = [0, 0],
		              afh =
		                [0, [0, cst_beta, [0, cst_2$2, [0, "more-integrations", 0]]]],
		              afi = [0, 0, 0, [9, cst_clickup], 0],
		              afk = [0, 0],
		              afl =
		                [0, [0, cst_beta, [0, cst_1, [0, "asana-integration", 0]]]],
		              afm = [0, 0, 0, [9, cst_asana], 0],
		              afo = [0, 0],
		              afp =
		                [0, [0, cst_beta, [0, cst_4, [0, "appolo-integration", 0]]]],
		              afq = [0, 0, 0, [9, cst_apolloio], 0],
		              aej = [0, "membrane-integration-key"],
		              ahm = [0, 0],
		              ahn =
		                [0, [0, cst_beta, [0, cst_2$2, [0, "email-connections", 0]]]],
		              aho = [0, cst_provider],
		              ahl = [0, cst_connection],
		              ahh = [0, 0],
		              ahi =
		                [0, [0, cst_beta, [0, cst_2$2, [0, cst_contacts_state, 0]]]],
		              ahj = [0, 0],
		              ahk =
		                [0, [0, cst_beta, [0, cst_5, [0, cst_calendars_state, 0]]]],
		              ahg = [0, "google-connection"],
		              ahf = [0, 0],
		              ahd = [0, 0],
		              ahc = [0, "The token for this Google account has been revoked."],
		              ahe =
		                [0, "This Routine account does not own this Google account."],
		              ahb = [0, "google-connection-error"],
		              aha = [0, "email-connection"],
		              ag$ = [0, 0],
		              ag9 = [0, 0],
		              ag8 = [0, 0, 0, [9, cst_google], 0],
		              ag_ = [0, 0, 0, [9, cst_email], 0],
		              ag7 = [0, cst_provider],
		              ahp = [0, "connection-id"],
		              ahq = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              ahr = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              ahs = [0, [3, 0, 0], a],
		              aht = [0, [17, 0, [12, 41, 0]], cst$39],
		              aij = [0, cst_platform],
		              aih = [0, 0],
		              aig = [0, 0],
		              aif = [0, 0],
		              aie = [0, 0],
		              aid = [0, 0],
		              aii = [0, cst_kind],
		              aic = [0, cst_distribution],
		              aib = [0, cst_runtime],
		              ah9 = [0, "The version of iOs"],
		              ah_ = [0, "The version of Android"],
		              ah$ = [0, cst_kind],
		              ah7 =
		                [0,
		                 "The interface the the frontend uses.\n\n      Part of it is obviously already decided at build-time, but part is also\n      pure runtime information."],
		              ah8 = [0, cst_frontend],
		              aia = [0, cst_os],
		              ah2 = [0, 0],
		              ah3 = [0, 1],
		              ah4 = [0, 2],
		              ah5 = [0, 3],
		              ah6 = [0, 4],
		              ah1 = [0, 0],
		              ahZ = [0, 0],
		              ahX = [0, 0],
		              ahV = [0, 0],
		              ahT = [0, 0],
		              ahS = [0, 0, 0, [9, cst_ios], 0],
		              ahU = [0, 0, 0, [9, cst_android], 0],
		              ahW = [0, 0, 0, [9, cst_win], 0],
		              ahY = [0, 0, 0, [9, cst_gnu_linux], 0],
		              ah0 = [0, 0, 0, [9, cst_macos], 0],
		              ahR = [0, cst_any],
		              ahM = [0, 0],
		              ahK = [0, 0],
		              ahI = [0, 0],
		              ahH = [0, 0, 0, [9, cst_win], 0],
		              ahJ = [0, 0, 0, [9, cst_gnu_linux], 0],
		              ahL = [0, 0, 0, [9, cst_macos], 0],
		              match$175 = [0, cst_os],
		              ahQ = [0, 0],
		              ahO = [0, 0],
		              ahN = [0, 0, 0, [9, cst_ios], 0],
		              ahP = [0, 0, 0, [9, cst_android], 0],
		              match$176 = [0, cst_os],
		              ahF = [0, 1],
		              ahG = [0, 0],
		              ahE = [0, 0],
		              ahC = [0, 0],
		              ahB = [0, 0, 0, [9, cst_x64], 0],
		              ahD = [0, 0, 0, [9, cst_arm64], 0],
		              ahA = [0, cst_any],
		              ahy = [0, 1],
		              ahz = [0, 0],
		              ahx = [0, 0],
		              ahv = [0, 0],
		              ahu = [0, 0, 0, [9, cst_x64], 0],
		              ahw = [0, 0, 0, [9, cst_arm64], 0],
		              match$174 = [0, cst_architecture],
		              aik = [0, cst_device],
		              aiv = [0, 0],
		              ait = [0, 0],
		              air = [0, 0],
		              aip = [0, 0],
		              ain = [0, 0],
		              aim = [0, 0, 0, [9, cst_api_server], 0],
		              aio = [0, 0, 0, [9, cst_routine_co], 0],
		              aiq = [0, 0, 0, [9, cst_web], 0],
		              ais = [0, 0, 0, [9, cst_ios], 0],
		              aiu = [0, 0, 0, [9, cst_android], 0],
		              ail = [0, cst_dist],
		              aiw = [0, cst_kind],
		              aiW = [0, 0],
		              aiU = [0, 0],
		              aiS = [0, 0],
		              aiQ = [0, 0],
		              aiO = [0, 0],
		              aiM = [0, 0],
		              aiK = [0, 0],
		              aiI = [0, 0],
		              aiG = [0, 0],
		              aiE = [0, 0],
		              aiC = [0, 0],
		              aiA = [0, 0],
		              aiz = [0, 0, 0, [9, cst_not_ends_with], 0],
		              aiB = [0, 0, 0, [9, cst_ends_with], 0],
		              aiD = [0, 0, 0, [9, cst_not_starts_with], 0],
		              aiF = [0, 0, 0, [9, cst_starts_with], 0],
		              aiH = [0, 0, 0, [9, cst_not_contains], 0],
		              aiJ = [0, 0, 0, [9, cst_contains], 0],
		              aiL = [0, 0, 0, [9, cst_gte], 0],
		              aiN = [0, 0, 0, [9, cst_gt], 0],
		              aiP = [0, 0, 0, [9, cst_lte], 0],
		              aiR = [0, 0, 0, [9, cst_lt], 0],
		              aiT = [0, 0, 0, [9, cst_neq], 0],
		              aiV = [0, 0, 0, [9, cst_eq], 0],
		              aix =
		                [0,
		                 "Comparison operators. Different atom kinds will support different subsets of\n    these."],
		              aiy = [0, "view-filter-op"],
		              aiY = [0, "Comparison on an atomic type"],
		              aiZ = [0, "view-filter-atomic"],
		              ai1 = [0, 0],
		              ai2 = [0, 0],
		              ai3 = [0, [0, cst_beta, [0, "2-date-filters", 0]]],
		              ai4 = [0, cst_type],
		              ai0 = [0, "view-filter-value"],
		              aiX = [0, "view-filter-field-name"],
		              ai5 =
		                [0,
		                 "Membership test: checking if a field's value is inside a collection"],
		              ai6 = [0, "view-filter-atom-membership"],
		              ai$ = [0, 0],
		              ai9 = [0, 0],
		              ai8 = [0, 0, 0, [9, cst_not_inside], 0],
		              ai_ = [0, 0, 0, [9, cst_inside], 0],
		              ai7 = [0, "view-filter-atom-membership-op"],
		              ajb = [0, "A comparison on a relation field."],
		              ajc = [0, "view-filter-relation"],
		              ajh = [0, 0],
		              ajf = [0, 0],
		              aje = [0, 0, 0, [9, cst_neq], 0],
		              ajg = [0, 0, 0, [9, cst_eq], 0],
		              ajd = [0, "view-filter-relation-op"],
		              aja = [0, 0],
		              ajj = [0, cst_type],
		              aji = [0, "atom_filter"],
		              ajl = [0, cst_The_field_holding_the_coll],
		              ajk = [0, "view-filter-atom-collection"],
		              ajq = [0, 0],
		              ajo = [0, 0],
		              ajn = [0, 0, 0, [9, cst_all_of], 0],
		              ajp = [0, 0, 0, [9, cst_one_of], 0],
		              ajm = [0, cst_view_filter_atom_collectio],
		              ajv = [0, 0],
		              ajt = [0, 0],
		              ajs = [0, 0, 0, [9, cst_all_of], 0],
		              aju = [0, 0, 0, [9, cst_one_of], 0],
		              ajr = [0, cst_view_filter_atom_collectio],
		              ajz = [0, "view-filter-atom"],
		              ajy = [0, cst_type],
		              ajw =
		                [0,
		                 'An atom filter discriminant. The [type] field must be one of:\n    - ["comparison"] \xe2\x80\x94 compare a field value with a literal (e.g. eq, neq,\n      contains, lt, gt)\n    - ["relation"] \xe2\x80\x94 compare a relation field to an object id\n    - ["collection"] \xe2\x80\x94 test a list/collection field for emptiness or membership\n    - ["membership"] \xe2\x80\x94 test whether a field value is in a set\n\n    Example \xe2\x80\x94 filter rows where title contains "foo":\n    {[\n      {\n        "lhs": "title",\n        "type": "comparison",\n        "op": "contains",\n        "rhs": { "type": "string", "value": "foo" }\n      }\n    ]}'],
		              ajx = [0, cst_filter],
		              ajC = [0, cst_type],
		              ajA =
		                [0, "The type of a filter. A boolean formal over {!Atom}s"],
		              ajB = [0, "view-filter-formula"],
		              akJ = [0, "Per-row task data not derived from the row itself."],
		              akK = [0, "Static configuration of the binding."],
		              akH = [0, "Map of rows of a specific table as tasks."],
		              akI = [0, cst_task_binding],
		              match$181 = [0, 0],
		              akD = [0, cst_Whether_the_task_is_starre],
		              match$182 = [0, 0],
		              akE =
		                [0,
		                 "Whether the task was last marked as discarded rather than completed.\n            Only meaningful when [status_changed_at] is [Some _]; see it for how\n            the two combine into a status. Disambiguates the displayed status\n            when the mapping's discarded and done values are indistinguishable\n            in the underlying cell (e.g. boolean status columns), and carries\n            the distinction outright when there is no mapping."],
		              akF =
		                [0,
		                 "Time at which the row's task status last transitioned to\n            done/discarded, or [None] when the row is in the todo state.\n\n            Together with [discarded], this encodes the task status: [None] is\n            todo, [Some t] is done or discarded at [t] depending on [discarded].\n            When [Config.status_mapping] is [None] the row has no status cell to\n            read from, so the pair *is* the status. When there is a mapping the\n            cell remains the source of truth and the pair only supplements it,\n            carrying the transition time the cell cannot hold and disambiguating\n            done from discarded."],
		              akG =
		                [0,
		                 "Task scheduling when [Config.scheduled_mapping] is [None]."],
		              akB =
		                [0,
		                 "Task-related attributes that are not stored in the custom object."],
		              akC = [0, "task-binding-row"],
		              ajJ = [0, cst_Column_to_map_the_task_url],
		              ajK = [0, cst_Column_to_map_the_task_sch],
		              ajL = [0, cst_Configuration_of_the_mappi],
		              ajM = [0, cst_Filter_to_exclude_rows_fro],
		              ajN = [0, cst_Id_of_the_table_which_rows],
		              ajO = [0, cst_The_workspace_the_table_is],
		              ajR = [0, cst_The_value_to_set_the_colum],
		              match$178 = [0, 0],
		              ajS = [0, cst_The_column_values_to_map_t],
		              ajP = [0, cst_Mapping_of_a_set_of_values],
		              ajQ = [0, cst_task_binding_status_values],
		              ajV = [0, cst_The_values_to_map_with_the],
		              ajW = [0, cst_The_values_to_map_with_the$0],
		              ajX = [0, cst_The_values_to_map_with_the$1],
		              ajY = [0, cst_The_column_to_map_tha_stat],
		              ajZ = [0, cst_Map_a_set_of_values_to_eac],
		              aj0 = [0, cst_kind],
		              ajT = [0, cst_Mapping_of_a_column_as_tas],
		              ajU = [0, cst_task_binding_status_mappin],
		              aj1 = [0, cst_Column_to_map_the_task_url],
		              aj2 = [0, cst_Column_to_map_the_task_sch],
		              aj3 = [0, cst_Configuration_of_the_mappi],
		              aj4 = [0, cst_Filter_to_exclude_rows_fro],
		              aj5 = [0, cst_Id_of_the_table_which_rows],
		              aj6 = [0, cst_The_workspace_the_table_is],
		              aj9 = [0, cst_The_value_to_set_the_colum],
		              match$179 = [0, 0],
		              aj_ = [0, cst_The_column_values_to_map_t],
		              aj7 = [0, cst_Mapping_of_a_set_of_values],
		              aj8 = [0, cst_task_binding_status_values],
		              akb = [0, cst_The_values_to_map_with_the],
		              akc = [0, cst_The_values_to_map_with_the$0],
		              akd = [0, cst_The_values_to_map_with_the$1],
		              ake = [0, cst_The_column_to_map_tha_stat],
		              akf = [0, cst_Map_a_set_of_values_to_eac],
		              akg = [0, cst_kind],
		              aj$ = [0, cst_Mapping_of_a_column_as_tas],
		              aka = [0, cst_task_binding_status_mappin],
		              akj = [0, cst_Column_to_map_the_task_url],
		              akk = [0, cst_Column_to_map_the_task_sch],
		              akl = [0, cst_Configuration_of_the_mappi],
		              akm = [0, cst_Filter_to_exclude_rows_fro],
		              akn = [0, cst_Id_of_the_table_which_rows],
		              ako = [0, cst_The_workspace_the_table_is],
		              akh = [0, "Task binding static configuration."],
		              aki = [0, "task-binding-config"],
		              akr = [0, cst_The_value_to_set_the_colum],
		              match$180 = [0, 0],
		              aks = [0, cst_The_column_values_to_map_t],
		              akp = [0, cst_Mapping_of_a_set_of_values],
		              akq = [0, cst_task_binding_status_values],
		              akv = [0, cst_The_values_to_map_with_the],
		              akw = [0, cst_The_values_to_map_with_the$0],
		              akx = [0, cst_The_values_to_map_with_the$1],
		              aky = [0, cst_The_column_to_map_tha_stat],
		              akz = [0, cst_Map_a_set_of_values_to_eac],
		              akA = [0, cst_kind],
		              akt = [0, cst_Mapping_of_a_column_as_tas],
		              aku = [0, cst_task_binding_status_mappin],
		              ajI = [0, 0],
		              ajH =
		                [0,
		                 "For a sad moment, we encoded status mapping values as const string\n              cell schema."],
		              ajG = [0, "task-binding-status-legacy"],
		              match$177 = [0, 1],
		              ajF =
		                [0, "Whether this task binding should contribute to tasks."],
		              ajD = [0, "Personal settings override for a task binding."],
		              ajE = [0, cst_task_binding_settings],
		              akX =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              akY =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              akZ = [0, [17, 0, 0], cst$6],
		              ak0 = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ak1 = [0, "google-config"],
		              akL =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              akM =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              akN = [0, [9, 0, 0], cst_B],
		              akO = [0, [17, 0, 0], cst$6],
		              akP = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              akQ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              akR = [0, [9, 0, 0], cst_B],
		              akS = [0, [17, 0, 0], cst$6],
		              akT = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              akV = [0, 0],
		              akW = [0, [0, cst_beta, [0, cst_0_google_contacts_other_en, 0]]],
		              match$183 = [0, 1],
		              akU = [0, "google-config-account"],
		              match$191 = [0, cst_notion_config],
		              anO =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              anP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anQ = [0, [17, 0, 0], cst$6],
		              anR = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anS =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anT = [0, [3, 0, 0], a],
		              anU = [0, [17, 0, 0], cst$6],
		              anV = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anW =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anX = [0, [17, 0, 0], cst$6],
		              anY = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anZ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              an0 = [0, [17, 0, 0], cst$6],
		              an1 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              an2 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              an3 = [0, [17, 0, 0], cst$6],
		              an4 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              an5 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              an6 = [0, [17, 0, 0], cst$6],
		              an7 = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ant = [0, "notion-database"],
		              anK = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anJ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              anL = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              anE = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anD =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              anF = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              anu =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              anv =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anw = [0, [17, 0, 0], cst$6],
		              anx = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              any =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anz = [0, [3, 0, 0], a],
		              anA = [0, [17, 0, 0], cst$6],
		              anB = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anC =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anG = [0, [17, 0, 0], cst$6],
		              anH = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anI =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anM = [0, [17, 0, 0], cst$6],
		              anN = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              and = [0, "notion-people"],
		              ane =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              anf =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ang = [0, [17, 0, 0], cst$6],
		              anh = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ani =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anj = [0, [17, 0, 0], cst$6],
		              ank = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anl =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anm = [0, [3, 0, 0], a],
		              ann = [0, [17, 0, 0], cst$6],
		              ano = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              anp =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anq = [0, [3, 0, 0], a],
		              anr = [0, [17, 0, 0], cst$6],
		              ans = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              match$190 = [0, cst$1],
		              amQ = [0, "notion-import"],
		              ana = [0, [3, 0, 0], a],
		              amR =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              amS =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amT = [0, [17, 0, 0], cst$6],
		              amU = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amV =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amW = [0, [17, 0, 0], cst$6],
		              amX = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amY =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amZ = [0, [17, 0, 0], cst$6],
		              am0 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              am1 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              am2 = [0, [17, 0, 0], cst$6],
		              am3 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              am4 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              am5 = [0, [3, 0, 0], a],
		              am6 = [0, [17, 0, 0], cst$6],
		              am7 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              am8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              am9 = [0, [17, 0, 0], cst$6],
		              am_ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              am$ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              anb = [0, [17, 0, 0], cst$6],
		              anc = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              match$189 = [0, cst$1],
		              amP = [0, [3, 0, 0], a],
		              amO = [0, [3, 0, 0], a],
		              amM = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amL =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              amN = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              amJ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amI =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              amK = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              amG = [0, "notion-column"],
		              amH = [0, [3, 0, 0], a],
		              amw =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              amx =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amy = [0, [17, 0, 0], cst$6],
		              amz = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amA =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amB = [0, [17, 0, 0], cst$6],
		              amC = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amD =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amE = [0, [17, 0, 0], cst$6],
		              amF = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ak9 = [0, "notion-select-option"],
		              ale = [0, 0],
		              alc = [0, 0],
		              ala = [0, 0],
		              ak$ = [0, 0, 0, [9, cst_completed], 0],
		              alb = [0, 0, 0, [9, cst_in_progress], 0],
		              ald = [0, 0, 0, [9, cst_todo], 0],
		              ak_ = [0, cst_notion_status_group],
		              alf = [0, "notion-status-option"],
		              match$184 = [0, 0],
		              alh =
		                [0,
		                 "the select values that will be ignored. Notion pages with these\n            values will not be imported."],
		              match$185 = [0, 0],
		              ali =
		                [0,
		                 "the select values that will be considered as completed. Notion pages\n            with these values (or the [completed_id]) will be imported as\n            completed."],
		              match$186 = [0, 0],
		              alj =
		                [0,
		                 "the select value that will be pushed when a task is active. [None]\n            unsets the column value"],
		              alk =
		                [0,
		                 "the select value that will be pushed when a task is\n            archived/completed"],
		              alg = [0, "notion-select-option-mapping"],
		              match$187 = [0, 0],
		              aln =
		                [0,
		                 "the status values that will be ignored. Notion pages with these\n            values will not be imported."],
		              match$188 = [0, 0],
		              alo =
		                [0,
		                 "the status values that will be considered as completed. Notion pages\n            with these values (or the [status_completed_id]) will be imported as\n            completed."],
		              alp =
		                [0,
		                 "the status value that will be pushed when a task is active"],
		              alq =
		                [0,
		                 "the status value that will be pushed when a task is\n            archived/completed"],
		              alm = [0, "notion-status-option-mapping"],
		              alr =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Integrations_notion.Column.Select {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Integrations_notion.Column.Select {@,"],
		              als =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alt = [0, [17, 0, 0], cst$6],
		              alu = [0, [17, 0, [12, 125, 0]], cst$50],
		              alv =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Integrations_notion.Column.Status {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Integrations_notion.Column.Status {@,"],
		              alw =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alx = [0, [17, 0, 0], cst$6],
		              aly = [0, [17, 0, [12, 125, 0]], cst$50],
		              alz =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Integrations_notion.Column.Checkbox {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Integrations_notion.Column.Checkbox {@,"],
		              alA =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alB = [0, [17, 0, 0], cst$6],
		              alC = [0, [17, 0, [12, 125, 0]], cst$50],
		              alD =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              alE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alF = [0, [17, 0, 0], cst$6],
		              alG = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              alH =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alI = [0, [3, 0, 0], a],
		              alJ = [0, [17, 0, 0], cst$6],
		              alK = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              alL =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              alM =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alN = [0, [17, 0, 0], cst$6],
		              alO = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              alP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alQ = [0, [17, 0, 0], cst$6],
		              alR = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              alS =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alT = [0, [3, 0, 0], a],
		              alU = [0, [17, 0, 0], cst$6],
		              alV = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              al$ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              al_ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              ama = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              al5 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              al4 =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              al6 = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              alW =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              alX =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              alY = [0, [17, 0, 0], cst$6],
		              alZ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              al0 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              al1 = [0, [17, 0, 0], cst$6],
		              al2 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              al3 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              al7 = [0, [17, 0, 0], cst$6],
		              al8 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              al9 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amb = [0, [17, 0, 0], cst$6],
		              amc = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ams = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amr =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              amt = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              amm = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aml =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              amn = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              amd =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              ame =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amf = [0, [17, 0, 0], cst$6],
		              amg = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amh =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ami = [0, [17, 0, 0], cst$6],
		              amj = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amk =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amo = [0, [17, 0, 0], cst$6],
		              amp = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              amq =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              amu = [0, [17, 0, 0], cst$6],
		              amv = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ak4 =
		                [0,
		                 "A URL to an image which can be used to display this authorization in\n          UI."],
		              ak5 =
		                [0,
		                 "A human-readable name which can be used to display this authorization\n          in UI."],
		              ak6 =
		                [0,
		                 "The ID of the workspace where this authorization took place."],
		              ak7 =
		                [0,
		                 "An object containing information about who can view and share this\n          integration."],
		              ak8 =
		                [0,
		                 "An access token used to authorize requests to the Notion API."],
		              ak2 =
		                [0,
		                 "The subset of {!Notion.Oauth.response_success} that we send back to the\n    clients."],
		              ak3 = [0, cst_notion_integration],
		              aob =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Integrations_common.Config.Google",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Integrations_common.Config.Google@ "],
		              aoc = [0, [17, 0, [12, 41, 0]], cst$39],
		              aod =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Integrations_common.Config.Notion",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Integrations_common.Config.Notion@ "],
		              aoe = [0, [17, 0, [12, 41, 0]], cst$39],
		              aof = [0, cst_type],
		              match$192 = [0, cst_integration_config],
		              aoa = [0, 0],
		              an_ = [0, 0],
		              an9 = [0, 0, 0, [9, cst_notion], 0],
		              an$ = [0, 0, 0, [9, cst_google], 0],
		              an8 = [0, "integration-kind"],
		              aog =
		                [0,
		                 [11, "http://127.0.0.1:", [4, 0, 0, 0, [2, 0, 0]]],
		                 "http://127.0.0.1:%d%s"],
		              ao7 =
		                [0,
		                 "Whether the item is the first one to open at startup. Only one item\n          can be the home item.\n\n          As this isn't guaranteed by the CRDT operations, only the first one\n          will be taken into account if several items are defined as [home]. If\n          no item is defined as [home], the homepage is decided by the client."],
		              ao8 = [0, "The page at which this item points"],
		              ao5 = [0, "A single menu item"],
		              ao6 = [0, "menu-item"],
		              aoP = [0, 0],
		              aoQ = [0, [0, cst_beta, [0, cst_1, [0, cst_ai_built_in, 0]]]],
		              aoR = [0, "A menu item pointing to an AI Agent"],
		              aoS = [0, 0],
		              aoT =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_workspace_homepage_menu_ta, 0]]]],
		              aoU = [0, "A menu item pointing to a Workspace homepage"],
		              aoV = [0, 0],
		              aoW =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_database_and_agent_menu_ta, 0]]]],
		              aoX = [0, "A menu item pointing to a Database view"],
		              aoY = [0, 0],
		              aoZ =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_menu_label_and_org_homepag, 0]]]],
		              ao0 = [0, "A menu item pointing to an Organization homepage"],
		              ao1 =
		                [0,
		                 "The organization this screen targets. Unspecified is\n                interchangeable with the personal organization for backward\n                compatibility."],
		              ao2 = [0, "A specific screen in the app"],
		              ao3 = [0, "A menu item pointing to a Routine object"],
		              ao4 = [0, cst_kind],
		              aoN = [0, "The target of a menu item"],
		              aoO = [0, "menu-item-target"],
		              aoM = [0, 0],
		              aoK = [0, 0],
		              aoG = [0, 0],
		              aoE = [0, 0],
		              aoC = [0, 0],
		              aoA = [0, 0],
		              aow = [0, 0],
		              aos = [0, 0],
		              aoq = [0, 0],
		              aoo = [0, 0],
		              aok = [0, 0],
		              aoj = [0, 0, 0, [9, cst_task], 0],
		              aol = [0, 0],
		              aom = [0, [0, cst_rc, [0, cst_2$2, 0]]],
		              aon = [0, 0, 0, [9, cst_projects], 0],
		              aop = [0, 0, 0, [9, cst_people], 0],
		              aor = [0, 0, 0, [9, cst_page], 0],
		              aot = [0, 0],
		              aou = [0, [0, cst_beta, [0, "1-meetings-menu-item", 0]]],
		              aov = [0, 0, 0, [9, cst_meetings], 0],
		              aox = [0, 0],
		              aoy =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_menu_label_and_org_homepag, 0]]]],
		              aoz = [0, 0, 0, [9, cst_labels], 0],
		              aoB = [0, 0, 0, [9, cst_journal], 0],
		              aoD = [0, 0, 0, [9, cst_inbox], 0],
		              aoF = [0, 0, 0, [9, cst_calendar], 0],
		              aoH = [0, 0],
		              aoI =
		                [0,
		                 [0, cst_beta, [0, cst_2$2, [0, "assistant-app-screen", 0]]]],
		              aoJ = [0, 0, 0, [9, cst_assistant], 0],
		              aoL = [0, 0, 0, [9, cst_agenda], 0],
		              aoh = [0, "A specific page in the app."],
		              aoi = [0, "menu-item-app-screen"],
		              azh =
		                [0,
		                 "Freeform extra attributes to be added to the sent metric"],
		              azi = [0, "The emitted event"],
		              azj = [0, "The time at which the event was emitted"],
		              azu = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              azv = [0, [3, 0, 0], a],
		              azw = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              azx = [0, [17, 0, [12, 41, 0]], cst$39],
		              azt = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              azs =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              azy = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              azk =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              azl =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azm = [0, [17, 0, 0], cst$6],
		              azn = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              azo =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azp = [0, [17, 0, 0], cst$6],
		              azq = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              azr =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azz = [0, [17, 0, 0], cst$6],
		              azA = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              axI = [0, cst_object],
		              axS = [0, 0],
		              axQ = [0, 0],
		              axO = [0, 0],
		              axM = [0, 0],
		              axK = [0, 0],
		              axJ = [0, 0, 0, [9, cst_other], 0],
		              axL = [0, cst_The_external_API],
		              axN = [0, 0, 0, [9, cst_app_ui], 0],
		              axP = [0, 0, 0, [9, cst_app_controller], 0],
		              axR = [0, cst_The_internal_API_used_by_t],
		              axU = [0, cst_object],
		              axT = [0, "metrics-event"],
		              axV = [0, "attr"],
		              ax6 = [0, 0],
		              ax4 = [0, 0],
		              ax2 = [0, 0],
		              ax0 = [0, 0],
		              axY = [0, 0],
		              axX = [0, 0, 0, [9, cst_other], 0],
		              axZ = [0, cst_The_external_API],
		              ax1 = [0, 0, 0, [9, cst_app_ui], 0],
		              ax3 = [0, 0, 0, [9, cst_app_controller], 0],
		              ax5 = [0, cst_The_internal_API_used_by_t],
		              axW = [0, cst_source],
		              ax7 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Ai_agent {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_agent {@,"],
		              ax8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ax9 = [0, [17, 0, 0], cst$6],
		              ax_ = [0, [17, 0, [12, 125, 0]], cst$50],
		              ax$ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_automation {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_automation {@,"],
		              aya =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayb = [0, [17, 0, 0], cst$6],
		              ayc = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayd =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_automation_run {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_automation_run {@,"],
		              aye =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayf = [0, [17, 0, 0], cst$6],
		              ayg = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayh =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_conversation {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_conversation {@,"],
		              ayi =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayj = [0, [17, 0, 0], cst$6],
		              ayk = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayl =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_mcp_server {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_mcp_server {@,"],
		              aym =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayn = [0, [17, 0, 0], cst$6],
		              ayo = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayp =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_recording {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_recording {@,"],
		              ayq =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayr = [0, [17, 0, 0], cst$6],
		              ays = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayt =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Ai_voice {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_voice {@,"],
		              ayu =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayv = [0, [17, 0, 0], cst$6],
		              ayw = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayx =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Console {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Console {@,"],
		              ayy =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayz = [0, [17, 0, 0], cst$6],
		              ayA = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayB =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Dashboard {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Dashboard {@,"],
		              ayC =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayD = [0, [17, 0, 0], cst$6],
		              ayE = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayF =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Database {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Database {@,"],
		              ayG =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayH = [0, [17, 0, 0], cst$6],
		              ayI = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayJ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Hotkey {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Hotkey {@,"],
		              ayK =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayL = [0, [17, 0, 0], cst$6],
		              ayM = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayN =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Integration {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Integration {@,"],
		              ayO =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayP = [0, [17, 0, 0], cst$6],
		              ayQ = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayR =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Object {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Object {@,"],
		              ayS =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayT = [0, [17, 0, 0], cst$6],
		              ayU = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayV =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Organization {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Organization {@,"],
		              ayW =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ayX = [0, [17, 0, 0], cst$6],
		              ayY = [0, [17, 0, [12, 125, 0]], cst$50],
		              ayZ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Settings {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Settings {@,"],
		              ay0 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ay1 = [0, [17, 0, 0], cst$6],
		              ay2 = [0, [17, 0, [12, 125, 0]], cst$50],
		              ay3 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Type {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Type {@,"],
		              ay4 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ay5 = [0, [17, 0, 0], cst$6],
		              ay6 = [0, [17, 0, [12, 125, 0]], cst$50],
		              ay7 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.User {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User {@,"],
		              ay8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ay9 = [0, [17, 0, 0], cst$6],
		              ay_ = [0, [17, 0, [12, 125, 0]], cst$50],
		              ay$ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.View {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.View {@,"],
		              aza =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azb = [0, [17, 0, 0], cst$6],
		              azc = [0, [17, 0, [12, 125, 0]], cst$50],
		              azd =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Metrics_intf.Workspace {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Workspace {@,"],
		              aze =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azf = [0, [17, 0, 0], cst$6],
		              azg = [0, [17, 0, [12, 125, 0]], cst$50],
		              axB = [0, 0],
		              axz = [0, 0],
		              axy = [0, 0],
		              axA =
		                [0, '"manual", "scheduled", "silence", "error"\xe2\x80\xa6'],
		              axC = [0, cst_action],
		              axx = [0, "metrics-ai-recording"],
		              axD =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_recording.Stopped {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_recording.Stopped {@,"],
		              axE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              axF = [0, [3, 0, 0], a],
		              axG = [0, [17, 0, 0], cst$6],
		              axH = [0, [17, 0, [12, 125, 0]], cst$50],
		              axv = [0, 0],
		              axu = [0, 0],
		              axs = [0, 0],
		              axt = [0, "Transcript accepted into the composer."],
		              axw = [0, cst_action],
		              axr = [0, "metrics-ai-voice"],
		              aw5 = [0, cst_id],
		              aw8 = [0, 0],
		              aw7 = [0, 0],
		              aw6 = [0, 0],
		              aw9 = [0, cst_action],
		              aw_ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_mcp_server.M.Added {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_mcp_server.M.Added {@,"],
		              aw$ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              axa = [0, [3, 0, 0], a],
		              axb = [0, [17, 0, 0], cst$6],
		              axc = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              axd =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              axe = [0, [9, 0, 0], cst_B],
		              axf = [0, [17, 0, 0], cst$6],
		              axg = [0, [17, 0, [12, 125, 0]], cst$50],
		              axh =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_mcp_server.M.Updated {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_mcp_server.M.Updated {@,"],
		              axi =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              axj = [0, [9, 0, 0], cst_B],
		              axk = [0, [17, 0, 0], cst$6],
		              axl = [0, [17, 0, [12, 125, 0]], cst$50],
		              axm =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_mcp_server.M.Tested {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_mcp_server.M.Tested {@,"],
		              axn =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              axo = [0, [9, 0, 0], cst_B],
		              axp = [0, [17, 0, 0], cst$6],
		              axq = [0, [17, 0, [12, 125, 0]], cst$50],
		              awt = [0, cst_id],
		              awA = [0, 0],
		              awy = [0, 0],
		              aww = [0, 0],
		              awv = [0, 0, 0, [9, cst_commit_pattern], 0],
		              awx = [0, 0, 0, [9, cst_recurrent], 0],
		              awz = [0, 0, 0, [9, cst_manual], 0],
		              awu = [0, "metrics-ai-automation-run-trigger"],
		              awH = [0, 0],
		              awF = [0, 0],
		              awD = [0, 0],
		              awC = [0, 0, 0, [9, cst_paused_for_user_input], 0],
		              awE = [0, 0, 0, [9, cst_failed], 0],
		              awG = [0, 0, 0, [9, cst_completed], 0],
		              awB = [0, "metrics-ai-automation-run-status"],
		              awI = [0, cst_action],
		              awJ =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              awK =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awL = [0, [17, 0, 0], cst$6],
		              awM = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              awN =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awO = [0, [17, 0, 0], cst$6],
		              awP = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              awQ =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_automation_run.M.Finished {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_automation_run.M.Finished {@,"],
		              awR =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awS = [0, [17, 0, 0], cst$6],
		              awT = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              awU =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awV = [0, [17, 0, 0], cst$6],
		              awW = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              awX =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awY = [0, [4, 0, 0, 0, 0], cst_d],
		              awZ = [0, [17, 0, 0], cst$6],
		              aw0 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aw1 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aw2 = [0, [9, 0, 0], cst_B],
		              aw3 = [0, [17, 0, 0], cst$6],
		              aw4 = [0, [17, 0, [12, 125, 0]], cst$50],
		              av3 = [0, cst_id],
		              av6 = [0, 0],
		              av5 = [0, 0],
		              av4 = [0, 0],
		              av7 = [0, "New value of [enabled] when this edit toggled it."],
		              av8 = [0, cst_action],
		              av9 =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              av_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              av$ = [0, [17, 0, 0], cst$6],
		              awa = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              awq = [0, [9, 0, 0], cst_B],
		              awb =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_automation.M.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_automation.M.Created {@,"],
		              awc =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awd = [0, [4, 0, 0, 0, 0], cst_d],
		              awe = [0, [17, 0, 0], cst$6],
		              awf = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              awg =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awh = [0, [9, 0, 0], cst_B],
		              awi = [0, [17, 0, 0], cst$6],
		              awj = [0, [17, 0, [12, 125, 0]], cst$50],
		              awk =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_automation.M.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_automation.M.Edited {@,"],
		              awl =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awm = [0, [3, 0, 0], a],
		              awn = [0, [17, 0, 0], cst$6],
		              awo = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              awp =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              awr = [0, [17, 0, 0], cst$6],
		              aws = [0, [17, 0, [12, 125, 0]], cst$50],
		              avl = [0, cst_id],
		              avq = [0, 0],
		              avo = [0, 0],
		              avn = [0, 0, 0, [9, cst_rich], 0],
		              avp = [0, 0, 0, [9, cst_plain], 0],
		              avm = [0, "metrics-ai-conversation-message-kind"],
		              avr = [0, 0],
		              avs = [0, cst_action],
		              avt =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              avu =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avv = [0, [17, 0, 0], cst$6],
		              avw = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              avx =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_conversation.M.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_conversation.M.Created {@,"],
		              avy =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avz = [0, [17, 0, 0], cst$6],
		              avA = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              avB =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avC = [0, [9, 0, 0], cst_B],
		              avD = [0, [17, 0, 0], cst$6],
		              avE = [0, [17, 0, [12, 125, 0]], cst$50],
		              avF =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_conversation.M.Message_sent {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_conversation.M.Message_sent {@,"],
		              avG =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avH = [0, [17, 0, 0], cst$6],
		              avI = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              avJ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avK = [0, [9, 0, 0], cst_B],
		              avL = [0, [17, 0, 0], cst$6],
		              avM = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              avN =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avO = [0, [4, 0, 0, 0, 0], cst_d],
		              avP = [0, [17, 0, 0], cst$6],
		              avQ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              avR =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avS = [0, [4, 0, 0, 0, 0], cst_d],
		              avT = [0, [17, 0, 0], cst$6],
		              avU = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              avV =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avW = [0, [4, 0, 0, 0, 0], cst_d],
		              avX = [0, [17, 0, 0], cst$6],
		              avY = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              avZ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              av0 = [0, [9, 0, 0], cst_B],
		              av1 = [0, [17, 0, 0], cst$6],
		              av2 = [0, [17, 0, [12, 125, 0]], cst$50],
		              au1 = [0, cst_id],
		              au2 = [0, 0],
		              au3 =
		                [0,
		                 'Catalog key the agent was created from, or "" for a blank\n                  agent.'],
		              au4 = [0, cst_action],
		              au5 =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              au6 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              au7 = [0, [17, 0, 0], cst$6],
		              au8 = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              au9 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_agent.M.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_agent.M.Created {@,"],
		              au_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              au$ = [0, [3, 0, 0], a],
		              ava = [0, [17, 0, 0], cst$6],
		              avb = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              avc =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avd = [0, [9, 0, 0], cst_B],
		              ave = [0, [17, 0, 0], cst$6],
		              avf = [0, [17, 0, [12, 125, 0]], cst$50],
		              avg =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Ai_agent.M.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Ai_agent.M.Edited {@,"],
		              avh =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              avi = [0, [3, 0, 0], a],
		              avj = [0, [17, 0, 0], cst$6],
		              avk = [0, [17, 0, [12, 125, 0]], cst$50],
		              auD =
		                [0,
		                 "\"Upserted\" because we currently don't differentiate a creation from\n            an update (and we currently don't need the distinction)."],
		              auE = [0, cst_action],
		              auC = [0, "metrics-view"],
		              auF = [0, "metrics-view-params"],
		              auG =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.View.Upserted {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.View.Upserted {@,"],
		              auH =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auI = [0, [17, 0, 0], cst$6],
		              auJ = [0, [17, 0, [12, 125, 0]], cst$50],
		              auK =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              auL =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auM = [0, [9, 0, 0], cst_B],
		              auN = [0, [17, 0, 0], cst$6],
		              auO = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              auP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auQ = [0, [9, 0, 0], cst_B],
		              auR = [0, [17, 0, 0], cst$6],
		              auS = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              auT =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auU = [0, [9, 0, 0], cst_B],
		              auV = [0, [17, 0, 0], cst$6],
		              auW = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              auX =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auY = [0, [9, 0, 0], cst_B],
		              auZ = [0, [17, 0, 0], cst$6],
		              au0 = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              auz = [0, cst_action],
		              auy = [0, "metrics-settings"],
		              auA =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Metrics_intf.Settings.Edited",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Metrics_intf.Settings.Edited@ "],
		              auB = [0, [17, 0, [12, 41, 0]], cst$39],
		              atD = [0, 0],
		              atC = [0, 0],
		              atB =
		                [0,
		                 "[change] is the previous and new ID of the parent. Currently only\n              used for default type objects because it is not yet possible to\n              move custom type objects, but this will change in the future."],
		              atE = [0, cst_action],
		              atU = [0, 0],
		              atS = [0, 0],
		              atQ = [0, 0],
		              atO = [0, 0],
		              atM = [0, 0],
		              atK = [0, 0],
		              atI = [0, 0],
		              atH = [0, 0, 0, [9, cst_other], 0],
		              atJ = [0, "Created by an integration"],
		              atL =
		                [0,
		                 "Created via our public API (currently only used by Zapier)"],
		              atN =
		                [0,
		                 "Created directly from a view (e.g. an [Add row] button we want to\n              add soon to views, or an [Add task] button we also want to add to\n              task lists in the future)."],
		              atP =
		                [0,
		                 "Created through a button or input field in the interface"],
		              atR =
		                [0,
		                 "Created inline in the notes of an object through [/task], [[]],\n              [/object], etc.\n\n              Currently only for tasks, but in the future should apply to any\n              object created in notes."],
		              atT = [0, "Console/dashboard"],
		              atF = [0, "What created the object"],
		              atG = [0, "metrics-object-source"],
		              at0 = [0, 0],
		              atY = [0, 0],
		              atX = [0, 0, 0, [9, cst_custom], 0],
		              atZ = [0, 0, 0, [9, cst_default], 0],
		              atV =
		                [0,
		                 "Whether the object is from a default type, or a custom type. This is\n        derived from the [id] but it is more convenient for Segment/Metabase to\n        push it explicitely."],
		              atW = [0, "metrics-object-nature"],
		              match$195 = [0, 0],
		              at2 =
		                [0, "[workspace_id] + [table_id] but in a different format."],
		              at1 = [0, cst_extras_custom],
		              at3 = [0, cst_id],
		              at4 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Object.M.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Object.M.Edited {@,"],
		              at5 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              at6 = [0, [3, 0, 0], a],
		              at7 = [0, [17, 0, 0], cst$6],
		              at8 = [0, [17, 0, [12, 125, 0]], cst$50],
		              at9 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Object.M.Moved {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Object.M.Moved {@,"],
		              at_ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              at$ = [0, [17, 0, 0], cst$6],
		              aua = [0, [17, 0, [12, 125, 0]], cst$50],
		              aub =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              auc =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aud = [0, [17, 0, 0], cst$6],
		              aue = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              auf =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aug = [0, [17, 0, 0], cst$6],
		              auh = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aui =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auj = [0, [17, 0, 0], cst$6],
		              auk = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aul =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aum = [0, [17, 0, 0], cst$6],
		              aun = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              auo =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              aup =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auq = [0, [17, 0, 0], cst$6],
		              aur = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aus =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aut = [0, [17, 0, 0], cst$6],
		              auu = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              auv =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              auw = [0, [17, 0, 0], cst$6],
		              aux = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              as3 = [0, cst_action],
		              as2 = [0, "metrics-hotkey"],
		              as4 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Hotkey.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Hotkey.Created {@,"],
		              as5 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              as6 = [0, [3, 0, 0], a],
		              as7 = [0, [17, 0, 0], cst$6],
		              as8 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              as9 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              as_ = [0, [3, 0, 0], a],
		              as$ = [0, [17, 0, 0], cst$6],
		              ata = [0, [17, 0, [12, 125, 0]], cst$50],
		              atb =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Hotkey.Deleted {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Hotkey.Deleted {@,"],
		              atc =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              atd = [0, [3, 0, 0], a],
		              ate = [0, [17, 0, 0], cst$6],
		              atf = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              atg =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ath = [0, [3, 0, 0], a],
		              ati = [0, [17, 0, 0], cst$6],
		              atj = [0, [17, 0, [12, 125, 0]], cst$50],
		              atk =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Hotkey.Pressed {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Hotkey.Pressed {@,"],
		              atl =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              atm = [0, [3, 0, 0], a],
		              atn = [0, [17, 0, 0], cst$6],
		              ato = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              atp =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              atq = [0, [3, 0, 0], a],
		              atr = [0, [17, 0, 0], cst$6],
		              ats = [0, [17, 0, [12, 125, 0]], cst$50],
		              att =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Hotkey.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Hotkey.Edited {@,"],
		              atu =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              atv = [0, [3, 0, 0], a],
		              atw = [0, [17, 0, 0], cst$6],
		              atx = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aty =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              atz = [0, [17, 0, 0], cst$6],
		              atA = [0, [17, 0, [12, 125, 0]], cst$50],
		              asz = [0, 0],
		              asA = [0, cst_action],
		              asB = [0, 0],
		              asC = [0, cst_action],
		              asD =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              asE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              asF = [0, [17, 0, 0], cst$6],
		              asG = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              asH =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              asI = [0, [17, 0, 0], cst$6],
		              asJ = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              asK =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Database.M.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Database.M.Created {@,"],
		              asL =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              asM = [0, [3, 0, 0], a],
		              asN = [0, [17, 0, 0], cst$6],
		              asO = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              asP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              asQ = [0, [9, 0, 0], cst_B],
		              asR = [0, [17, 0, 0], cst$6],
		              asS = [0, [17, 0, [12, 125, 0]], cst$50],
		              asT =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Database.M.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Database.M.Edited {@,"],
		              asU =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              asV = [0, [9, 0, 0], cst_B],
		              asW = [0, [17, 0, 0], cst$6],
		              asX = [0, [17, 0, [12, 125, 0]], cst$50],
		              asY = [0, 0],
		              asZ = [0, cst_action],
		              as0 =
		                [0,
		                 "Coincidentally same as [extras] but encoded in a single string, so that\n        Segment metrics are easier to consume and join with other metrics. Later\n        we will add more fields to [extras] that will not be part of the ID\n        (like the Integration App data source ID)."],
		              as1 = [0, cst_id],
		              asy = [0, 0],
		              asw = [0, 0],
		              asu = [0, 0],
		              ast = [0, 0, 0, [9, cst_closed], 0],
		              asv = [0, 0, 0, [9, cst_hidden], 0],
		              asx = [0, 0, 0, [9, cst_opened], 0],
		              ass = [0, "metrics-dashboard"],
		              asr = [0, 0],
		              asq = [0, 0, 0, [9, cst_submitted], 0],
		              asp = [0, "metrics-console"],
		              asb = [0, 0],
		              asc = [0, cst_action],
		              asd = [0, cst_id],
		              ase =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Type.M.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Type.M.Created {@,"],
		              asf =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              asg = [0, [17, 0, 0], cst$6],
		              ash = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              asi =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              asj = [0, [3, 0, 0], a],
		              ask = [0, [17, 0, 0], cst$6],
		              asl = [0, [17, 0, [12, 125, 0]], cst$50],
		              asm =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Metrics_intf.Type.M.Edited",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Metrics_intf.Type.M.Edited@ "],
		              asn = [0, [17, 0, [12, 41, 0]], cst$39],
		              aso = [0, [3, 0, 0], a],
		              ar2 = [0, 0],
		              ar1 = [0, 0],
		              ar0 = [0, 0],
		              ar3 = [0, cst_action],
		              ar4 = [0, cst_id],
		              ar5 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Integration.M.Installed {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Integration.M.Installed {@,"],
		              ar6 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ar7 = [0, [3, 0, 0], a],
		              ar8 = [0, [17, 0, 0], cst$6],
		              ar9 = [0, [17, 0, [12, 125, 0]], cst$50],
		              ar_ =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Metrics_intf.Integration.M.Edited",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Metrics_intf.Integration.M.Edited@ "],
		              ar$ = [0, [17, 0, [12, 41, 0]], cst$39],
		              asa = [0, [3, 0, 0], a],
		              arz = [0, 0],
		              ary = [0, 0],
		              arx =
		                [0,
		                 "Currently unused because there is nothing modifiable about a\n              workspace user. Maybe in the future, permissions, etc.?"],
		              arA = [0, cst_action],
		              arB = [0, cst_id],
		              arC =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Workspace.M.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Workspace.M.Edited {@,"],
		              arD =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arE = [0, [3, 0, 0], a],
		              arF = [0, [17, 0, 0], cst$6],
		              arG = [0, [17, 0, [12, 125, 0]], cst$50],
		              arH =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Workspace.M.Added_user {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Workspace.M.Added_user {@,"],
		              arI =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arJ = [0, [17, 0, 0], cst$6],
		              arK = [0, [17, 0, [12, 125, 0]], cst$50],
		              arL =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Workspace.M.Edited_user {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Workspace.M.Edited_user {@,"],
		              arM =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arN = [0, [17, 0, 0], cst$6],
		              arO = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              arP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arQ = [0, [17, 0, 0], cst$6],
		              arR = [0, [17, 0, [12, 125, 0]], cst$50],
		              arS =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Workspace.M.Removed_user {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Workspace.M.Removed_user {@,"],
		              arT =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arU = [0, [17, 0, 0], cst$6],
		              arV = [0, [17, 0, [12, 125, 0]], cst$50],
		              arW =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              arX =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arY = [0, [17, 0, 0], cst$6],
		              arZ = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              aqH = [0, cst_id],
		              aqK = [0, 0],
		              aqI =
		                [0,
		                 "Currently unused because there is nothing modifiable about an\n              organization user. Maybe in the future, permissions, etc.?"],
		              aqJ = [0, "When an invited user accepts the invitation."],
		              aqL = [0, "Email of the organization creator."],
		              aqM =
		                [0,
		                 "Used for Intercom email sending, not for metrics per se. In an\n                  ideal world, we don't use metrics for email automations, but\n                  we have to be pragmatic."],
		              aqN = [0, cst_action],
		              aqO =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Organization.M.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Organization.M.Created {@,"],
		              aqP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqQ = [0, [3, 0, 0], a],
		              aqR = [0, [17, 0, 0], cst$6],
		              aqS = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aqT =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqU = [0, [17, 0, 0], cst$6],
		              aqV = [0, [17, 0, [12, 125, 0]], cst$50],
		              aqW =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Organization.M.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Organization.M.Edited {@,"],
		              aqX =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqY = [0, [3, 0, 0], a],
		              aqZ = [0, [17, 0, 0], cst$6],
		              aq0 = [0, [17, 0, [12, 125, 0]], cst$50],
		              aq1 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Organization.M.Invited_user {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Organization.M.Invited_user {@,"],
		              aq2 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aq3 = [0, [17, 0, 0], cst$6],
		              aq4 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aq5 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aq6 = [0, [17, 0, 0], cst$6],
		              aq7 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aq8 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aq9 = [0, [3, 0, 0], a],
		              aq_ = [0, [17, 0, 0], cst$6],
		              aq$ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ara =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arb = [0, [3, 0, 0], a],
		              arc = [0, [17, 0, 0], cst$6],
		              ard = [0, [17, 0, [12, 125, 0]], cst$50],
		              are =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Organization.M.Added_user {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Organization.M.Added_user {@,"],
		              arf =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arg = [0, [17, 0, 0], cst$6],
		              arh = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ari =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arj = [0, [3, 0, 0], a],
		              ark = [0, [17, 0, 0], cst$6],
		              arl = [0, [17, 0, [12, 125, 0]], cst$50],
		              arm =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Organization.M.Edited_user {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Organization.M.Edited_user {@,"],
		              arn =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aro = [0, [17, 0, 0], cst$6],
		              arp = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              arq =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arr = [0, [17, 0, 0], cst$6],
		              ars = [0, [17, 0, [12, 125, 0]], cst$50],
		              art =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.Organization.M.Removed_user {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.Organization.M.Removed_user {@,"],
		              aru =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              arv = [0, [17, 0, 0], cst$6],
		              arw = [0, [17, 0, [12, 125, 0]], cst$50],
		              apM = [0, cst_id],
		              apO = [0, 0],
		              apN = [0, "The invitee email"],
		              apP = [0, cst_action],
		              apR = [0, 0],
		              apS = [0, cst_kind],
		              apQ = [0, "metrics-authentication"],
		              apT =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Metrics_intf.User.M.Authenticating",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Metrics_intf.User.M.Authenticating@ "],
		              apU = [0, [17, 0, [12, 41, 0]], cst$39],
		              apV =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.Created {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.Created {@,"],
		              apW =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apX = [0, [3, 0, 0], a],
		              apY = [0, [17, 0, 0], cst$6],
		              apZ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ap0 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ap1 = [0, [3, 0, 0], a],
		              ap2 = [0, [17, 0, 0], cst$6],
		              ap3 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              ap4 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ap5 = [0, [3, 0, 0], a],
		              ap6 = [0, [17, 0, 0], cst$6],
		              ap7 = [0, [17, 0, [12, 125, 0]], cst$50],
		              ap8 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.Edited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.Edited {@,"],
		              ap9 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              ap_ = [0, [17, 0, 0], cst$6],
		              ap$ = [0, [17, 0, [12, 125, 0]], cst$50],
		              aqa =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.Logged_in {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.Logged_in {@,"],
		              aqb =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqc = [0, [3, 0, 0], a],
		              aqd = [0, [17, 0, 0], cst$6],
		              aqe = [0, [17, 0, [12, 125, 0]], cst$50],
		              aqf =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.Logged_out {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.Logged_out {@,"],
		              aqg =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqh = [0, [3, 0, 0], a],
		              aqi = [0, [17, 0, 0], cst$6],
		              aqj = [0, [17, 0, [12, 125, 0]], cst$50],
		              aqk =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.Invited {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.Invited {@,"],
		              aql =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqm = [0, [3, 0, 0], a],
		              aqn = [0, [17, 0, 0], cst$6],
		              aqo = [0, [17, 0, [12, 125, 0]], cst$50],
		              aqp =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.NPS_answered {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.NPS_answered {@,"],
		              aqq =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqr = [0, [4, 0, 0, 0, 0], cst_d],
		              aqs = [0, [17, 0, 0], cst$6],
		              aqt = [0, [17, 0, [12, 125, 0]], cst$50],
		              aqu =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.PMF_answered {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.PMF_answered {@,"],
		              aqv =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqw = [0, [3, 0, 0], a],
		              aqx = [0, [17, 0, 0], cst$6],
		              aqy = [0, [17, 0, [12, 125, 0]], cst$50],
		              aqC = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aqD = [0, [3, 0, 0], a],
		              aqB =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [12, 91, 0]],
		                 cst_2$1],
		              aqE = [0, [17, [0, cst$5, 0, 0], [12, 93, [17, 0, 0]]], cst$49],
		              aqz =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Metrics_intf.User.M.Google {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Metrics_intf.User.M.Google {@,"],
		              aqA =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aqF = [0, [17, 0, 0], cst$6],
		              aqG = [0, [17, 0, [12, 125, 0]], cst$50],
		              apI =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              apJ =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apK = [0, [17, 0, 0], cst$6],
		              apL = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              match$194 = [0, 0],
		              apx =
		                [0,
		                 "Extra fields that should be present in all actions of this metric."],
		              match$193 = [0, "object_metrics"],
		              apy =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              apz =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apA = [0, [17, 0, 0], cst$6],
		              apB = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              apC =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apD = [0, [17, 0, 0], cst$6],
		              apE = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              apF =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apG = [0, [17, 0, 0], cst$6],
		              apH = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              aps = [0, "extras_workspace_id"],
		              apt =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              apu =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apv = [0, [17, 0, 0], cst$6],
		              apw = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              ao9 =
		                [0,
		                 "An event fragment representing the change of _something_"],
		              ao_ = [0, "metrics-change"],
		              ao$ =
		                [0,
		                 "An event fragment representing the change of a specific property"],
		              apa = [0, "metrics-edit"],
		              apb =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              apc =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apd = [0, [3, 0, 0], a],
		              ape = [0, [17, 0, 0], cst$6],
		              apf = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              apg =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aph = [0, [3, 0, 0], a],
		              api = [0, [17, 0, 0], cst$6],
		              apj = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              apk =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              apl =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              apm = [0, [17, 0, 0], cst$6],
		              apn = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              apo =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              app = [0, [3, 0, 0], a],
		              apq = [0, [17, 0, 0], cst$6],
		              apr = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              az2 = [0, cst_people],
		              azY = [0, cst_contacts],
		              azZ = [0, cst_directory],
		              az0 = [0, cst_other],
		              az1 = [0, cst_self],
		              azX = [0, 0],
		              azV = [0, 0],
		              azT = [0, 0],
		              azR = [0, 0],
		              azQ = [0, 0, 0, [9, cst_self], 0],
		              azS = [0, 0, 0, [9, cst_other], 0],
		              azU = [0, 0, 0, [9, cst_directory], 0],
		              azW = [0, 0, 0, [9, cst_connections], 0],
		              azP = [0, "people-source"],
		              azO = [0, "people-organization"],
		              azN = [0, "people-name"],
		              azB = [0, 0],
		              azC = [0, "The people notes."],
		              azD =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              azE =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azF = [0, [17, 0, 0], cst$6],
		              azG = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              azH =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azI = [0, [17, 0, 0], cst$6],
		              azJ = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              azK =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              azL = [0, [17, 0, 0], cst$6],
		              azM = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              aAF = [0, "When the mention was viewed, if ever."],
		              aAG =
		                [0,
		                 "When the notice was archived (removed from the inbox), if ever."],
		              aAH = [0, "The user that may need to review the notice."],
		              aAI = [0, "Message to display to the recipient."],
		              aAJ = [0, "URI to lead to where the notice occurred."],
		              aAK = [0, "More specific data about the notice, if available."],
		              aAL = [0, "When the notice was created."],
		              aAD = [0, "A notice for some user."],
		              aAE = [0, cst_notice],
		              aAt = [0, 0],
		              aAu =
		                [0,
		                 [0, cst_beta, [0, cst_0, [0, cst_ai_human_in_the_loop, 0]]]],
		              aAv = [0, "Summary of the request, for display."],
		              aAw = [0, "Name of the automation."],
		              aAx = [0, "The automation run ID."],
		              aAy = [0, "The user who set the relation value."],
		              aAz = [0, "the relation field that was set."],
		              aAA = [0, "The user who mentioned the recipient."],
		              aAB = [0, "Where the mention occurred."],
		              aAC = [0, cst_event],
		              aAr = [0, "Specific notice data"],
		              aAs = [0, "notice-item"],
		              aAq = [0, cst_kind],
		              aAo =
		                [0,
		                 "Summary of the request shown in the notice. Kept as a variant so other\n      kinds of requests (e.g. a draft to review) can be summarized differently\n      later."],
		              aAp = [0, "notice-automation-ask-user-summary"],
		              aAn = [0, cst_source],
		              aAm = [0, cst_error],
		              aAb = [0, "notice-error-integration-app"],
		              aAd = [0, "Object for which the push to Integration App failed"],
		              aAe = [0, cst_type],
		              aAc = [0, "notice-error-integration-app-origin"],
		              aAl = [0, 0],
		              aAj = [0, 0],
		              aAh = [0, 0],
		              aAg = [0, 0, 0, [9, cst_delete_record_failed], 0],
		              aAi = [0, 0, 0, [9, cst_update_record_failed], 0],
		              aAk = [0, 0, 0, [9, cst_create_record_failed], 0],
		              aAf = [0, "notice-error-integration-app-error"],
		              az$ = [0, "notice-error-google"],
		              aAa = [0, "notice-error-google-origin"],
		              az9 = [0, cst_Path_to_the_field_where_th],
		              az_ = [0, cst_Object_in_which_the_mentio],
		              az8 = [0, "relation_origin"],
		              az5 = [0, "Specific block where the mention occurred."],
		              az6 = [0, cst_Path_to_the_field_where_th],
		              az7 = [0, cst_Object_in_which_the_mentio],
		              az3 =
		                [0,
		                 "Origin/context of where a mention occurred. References a table cell, with\n    optional specific block."],
		              az4 = [0, "mention_origin"],
		              aA5 = [0, "A page."],
		              aA6 = [0, cst_page],
		              aAN = [0, 0],
		              aAZ = [0, [3, 0, 0], a],
		              aAO =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              aAP =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aAQ = [0, [17, 0, 0], cst$6],
		              aAR = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aAS =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aAT = [0, [17, 0, 0], cst$6],
		              aAU = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aAV =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aAW = [0, [17, 0, 0], cst$6],
		              aAX = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aAY =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aA0 = [0, [17, 0, 0], cst$6],
		              aA1 = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aA2 =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aA3 = [0, [17, 0, 0], cst$6],
		              aA4 = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              aAM = [0, 0],
		              aBG = [0, 0],
		              aBE = [0, 0],
		              aBD = [0, 0, 0, [9, cst_set_role], 0],
		              aBF = [0, 0, 0, [9, cst_remove], 0],
		              aBC = [0, "workspace-member-action"],
		              aBB = [0, 0],
		              aBz = [0, 0],
		              aBy = [0, 0, 0, [9, cst_write], 0],
		              aBA = [0, 0, 0, [9, cst_read], 0],
		              aBx = [0, "workspace-data-action"],
		              aBw = [0, 0],
		              aBu = [0, 0],
		              aBs = [0, 0],
		              aBr = [0, 0, 0, [9, cst_rename], 0],
		              aBt = [0, 0, 0, [9, cst_remove], 0],
		              aBv = [0, 0, 0, [9, cst_member_add], 0],
		              aBq = [0, "workspace-action"],
		              aBp = [0, 0],
		              aBo = [0, 0, 0, [9, cst_uninvite], 0],
		              aBn = [0, "invitation-action"],
		              aBm = [0, 0],
		              aBl = [0, 0],
		              aBk = [0, 0, 0, [9, cst_remove], 0],
		              aBj = [0, "member-action"],
		              aBi = [0, 0],
		              aBh = [0, 0],
		              aBf = [0, 0],
		              aBd = [0, 0],
		              aBb = [0, 0],
		              aBa = [0, 0, 0, [9, cst_workspace_create], 0],
		              aBc = [0, 0, 0, [9, cst_rename], 0],
		              aBe = [0, 0, 0, [9, cst_member_invite], 0],
		              aBg = [0, 0, 0, [9, cst_delete], 0],
		              aA$ = [0, "organization-action"],
		              aA8 = [0, 0],
		              aA9 = [1, "insufficient permissions"],
		              aA_ = [1, "not a member of the organization"],
		              aA7 = [0, 0],
		              aBJ = [0, "The stripe price to subscribe to"],
		              aBH = [0, "A request for a new subscription"],
		              aBI = [0, "subscription_creation"],
		              aBK =
		                [0,
		                 "A secret sent back to the client for the payment, if needed"],
		              aBL = [0, "The Id of the new subscription object"],
		              aBM = [0, "The status of the subscription"],
		              aBN =
		                [0,
		                 "The (stripe) price to which this subscription is attached"],
		              aBO = [0, "The (stripe) subscription object"],
		              aBP = [0, "The plan attached to the subscription"],
		              aBR =
		                [0,
		                 "Whether that price is publicly available.\n\n          We usually only send the publicly available plans, but users can be\n          subscribed to legacy plans that are no longer available (either\n          because the whole plan is retired or because the price has changed)."],
		              aBS =
		                [0,
		                 "The status of the user's subscription to that price, if there is one"],
		              aBT = [0, "The stripe price"],
		              aBQ = [0, "available_price"],
		              aBW = [0, "The public prices attached to that plan"],
		              aBX = [0, "Stripe information about the plan"],
		              aBY =
		                [0,
		                 "The kind of plan. Morally we'd like this to be an [Account.Plan.t],\n          but that would require the frontend to be aware of the list of\n          available plans, making backwards compatibility a nightmare. Since the\n          frontend doesn't need to do anything with it except display it, just\n          make it an opaque string so that we can add new entries without having\n          to touch it."],
		              aBU = [0, "A plan that the users can subscribe to"],
		              aBV = [0, "available_plan"],
		              aBZ = [0, "The list of all the plans available to the users"],
		              aB0 =
		                [0,
		                 "The\n          {{:https://docs.stripe.com/keys#obtain-api-keys} stripe publishable\n           key} that the client can use for making payments"],
		              aB1 = [0, 0],
		              aB2 = [0, cst_kind],
		              aB3 = [0, "customer_portal"],
		              aB4 = [0, 0],
		              aB5 =
		                [0,
		                 "FIXME: This payload is ignored but still expected by clients up to\n              0.24.0."],
		              aB6 = [0, cst_notification],
		              match$199 = [0, 0],
		              match$198 = [0, 0],
		              match$196 = [0, 0],
		              match$197 = [0, 0],
		              aB8 = [0, cst_common],
		              aB9 = [0, cst_context],
		              aB_ = [0, cst_library],
		              aB$ = [0, "versioned"],
		              aB7 = [0, cst_id],
		              aCc =
		                [0,
		                 [11, "exception pushing metrics: ", [15, 0]],
		                 "exception pushing metrics: %a"],
		              aCb =
		                [0,
		                 [11, "http error pushing metrics: ", [15, 0]],
		                 "http error pushing metrics: %a"],
		              aCa = [0, [11, "send metric: ", [15, 0]], "send metric: %a"],
		              aCq = [0, [0, [0, 0]], [0, [0, cst_other], 0]],
		              match$200 = [0, 1],
		              match$201 = [0, 0],
		              match$202 = [0, 0],
		              match$203 = [0, [0, 0]],
		              match$204 = [0, cst_production],
		              aCp = [0, cst_event],
		              aCr = [0, "breadcrumb"],
		              aCs = [0, cst_contexts],
		              aCt = [0, cst_exn],
		              aCu = [0, cst_frame],
		              match$205 = [0, 1],
		              aCv = [0, cst_mechanism],
		              aCw = [0, cst_message],
		              match$206 = [0, 0],
		              match$207 = [0, 0],
		              aCx = [0, cst_request],
		              aCy = [0, cst_stacktrace],
		              aCz = [0, cst_user],
		              match$208 = [0, cst_values],
		              aCo = [0, 0],
		              aCn = [0, 0],
		              aCl = [0, 0],
		              aCj = [0, 0],
		              aCh = [0, 0],
		              aCf = [0, 0],
		              aCe = [0, 0, 0, [9, cst_warning], 0],
		              aCg = [0, 0, 0, [9, cst_info], 0],
		              aCi = [0, 0, 0, [9, cst_fatal], 0],
		              aCk = [0, 0, 0, [9, cst_error], 0],
		              aCm = [0, 0, 0, [9, cst_debug], 0],
		              aCd = [0, cst_level],
		              aCE = [0, 540315116],
		              aCD =
		                [0,
		                 [11, cst_XHR_Response_is_not_an_arr, 0],
		                 cst_XHR_Response_is_not_an_arr],
		              aCC =
		                [0,
		                 [11, cst_XHR_Response_is_null_using, 0],
		                 cst_XHR_Response_is_null_using],
		              aCB = [0, "Cohttp Lwt JSOO module"],
		              aCA = [0, "cohttp-lwt-jsoo/src/cohttp_lwt_jsoo.ml", 58, 31],
		              aCG = [0, "dirty"],
		              aCH = [0, cst_dev],
		              aCF = [0, cst_alpha, 0],
		              aCI = [0, [0, "timmy-jsoo/lib/src/date.ml", 7, 173, 205]],
		              aCJ = [0, "process", [0, "versions", [0, cst_node, 0]]],
		              aCK = [0, "runtime-lib/runtime.ml.E"],
		              aCL = [0, cst_none$0, 0, -1],
		              aC0 = [0, "shape/src/bin_shape.ml.For_typerep.Not_a_tuple"],
		              aC1 = [0, cst_none$0, 0, -1],
		              aCR = [0, "Annotate"],
		              aCS = [0, "Base"],
		              aCT = [0, cst_Record],
		              aCU = [0, cst_Variant],
		              aCV = [0, cst_Tuple],
		              aCW = [0, "Poly_variant"],
		              aCX = [0, cst_Var],
		              aCY = [0, "Rec_app"],
		              aCZ = [0, "Top_app"],
		              aCO = [0, cst_members],
		              aCP = [0, "loc"],
		              aCQ = [0, "gid"],
		              aCM = [0, "Constr"],
		              aCN = [0, "Inherit"],
		              aC3 = [0, "src/common.ml.Read_error"],
		              aC4 = [0, cst_none$0, 0, -1],
		              aC2 =
		                [0,
		                 [11,
		                  "List_too_long / ",
		                  [4, 0, 0, 0, [11, " (max ", [4, 0, 0, 0, [12, 41, 0]]]]],
		                 "List_too_long / %d (max %d)"],
		              aC5 =
		                [0,
		                 [2,
		                  0,
		                  [11, ": tried to read more elements than available", 0]],
		                 "%s: tried to read more elements than available"],
		              aC6 =
		                [0,
		                 [2, 0, [11, ": didn't read all elements", 0]],
		                 "%s: didn't read all elements"],
		              aDg = [0, [11, "Line ", [4, 0, 0, 0, 0]], "Line %d"],
		              aDh =
		                [0,
		                 [11, "Fake__Dependency_", [4, 0, 0, 0, 0]],
		                 "Fake__Dependency_%d"],
		              aDf = [0, [2, [1, 1], [12, 32, [2, 0, 0]]], "%*s %s"],
		              aDe = [0, c],
		              aDd = [0, cst_runtime_ppx_module_timer_r, 110, 6],
		              aDc = [0, cst_runtime_ppx_module_timer_r, 94, 6],
		              aDk = [0, 0],
		              aDl = [0, 0],
		              aDm = [0, 0],
		              aDn = [0, 0],
		              aDo = [0, 0],
		              aDp = [0, 0],
		              aDq = [0, 0],
		              aDr = [0, 0],
		              aDs = [0, 0],
		              aDt = [0, 0],
		              aDu = [0, 0],
		              aDv = [0, 0],
		              aDw = [0, 0],
		              aDx = [0, 0],
		              aDy = [0, 0],
		              aDz = [0, cst_lib_std_internal_ml, 802, 14],
		              aDi =
		                [0,
		                 [0,
		                  [0, [0, 0, 0, 0]],
		                  [0, [0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0]],
		                  0,
		                  0,
		                  0,
		                  0,
		                  0]],
		              aDj = [0, cst_lib_std_internal_ml, 401, 6],
		              aDA =
		                [0,
		                 [0,
		                  [0, [0, 0, 0, 0]],
		                  [0, [0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0]],
		                  [0, [0]],
		                  [0, [0, 0, 0, 0, 0, 0, 0, 0]],
		                  0,
		                  0,
		                  0,
		                  0,
		                  0]],
		              aDC = [0, cst_lib_typerep_obj_ml, 9, 4],
		              aDB = [0, cst_lib_typerep_obj_ml, 11, 4],
		              bNG = [0, cst_lib_typerep_obj_ml, 28, 9],
		              bNF = [0, cst_lib_typerep_obj_ml, 29, 9],
		              bNE = [0, cst_lib_typerep_obj_ml, 49, 2],
		              aDD = [0, cst_lib_typerep_obj_ml, 50, 2],
		              aDO = [0, cst_src_splittable_random_ml, 279, 6],
		              aDM = [0, cst_hi],
		              aDN = [0, cst_lo],
		              aDK = [0, cst_hi],
		              aDL = [0, cst_lo],
		              aDH = [0, cst_hi],
		              aDI = [0, cst_lo],
		              aDJ = caml_int64_create_lo_mi_hi(0, 0, 0),
		              aDF = caml_int64_create_lo_mi_hi(5606605, 11524077, 65361),
		              aDG = caml_int64_create_lo_mi_hi(8776787, 12189210, 50382),
		              aDE = caml_int64_create_lo_mi_hi(1, 0, 0),
		              aDZ = [0, 0, 0],
		              aDX = [0, cst_upper_bound],
		              aDY = [0, cst_lower_bound],
		              aDV = [0, cst_upper_bound],
		              aDW = [0, cst_lower_bound],
		              aDU = [0, cst_src_generator_ml, 198, 4],
		              aDT = [0, cst_src_generator_ml, 225, 6],
		              aDS = [0, cst_src_generator_ml, 160, 14],
		              aDR = [0, cst_weight],
		              aDQ = [0, cst_weight],
		              aDP = [0, cst_size],
		              aD0 = [0, 104758188],
		              aD1 = [0, 104758188],
		              aD2 = caml_int64_create_lo_mi_hi(16777215, 16777215, 32767),
		              aD3 = [0, "base_for_tests/src/test_blit.ml", 69, 11],
		              aD_ =
		                [0,
		                 [11, "Univ_map.find_exn on unknown key ", [2, 0, 0]],
		                 "Univ_map.find_exn on unknown key %s"],
		              aD7 = [0, "type_id2"],
		              aD8 = [0, "type_id1"],
		              aD9 = [0, cst_key],
		              aD4 = [0, "<uid>"],
		              aD5 = [0, cst_uid],
		              aD6 = [0, cst_name],
		              aD$ = [0, "COMMAND_OUTPUT_HELP_SEXP"],
		              aEd = [0, "duplicate_keys"],
		              aEa = [0, cst_status],
		              aEb = [0, "command/src/command.ml.Exit_called"],
		              aEc = [0, cst_none$0, 0, -1],
		              aEe = [0, "Done", 0],
		              aEf = [0, 104758188],
		              aEg = [0, [0, cst_Unbounded, 0], 0],
		              aEh = [0, [0, cst_Unbounded, 0], 0],
		              aEi = [0, "core/src/list.ml.Duplicate_found"],
		              aEj = [0, cst_none$0, 0, -1],
		              aEn = [0, [11, cst_UTC, [2, 0, [4, 0, 0, 0, 0]]], "UTC%s%d"],
		              aEm = [0, "core/src/zone.ml", 372, 8],
		              aEk = [0, "core/src/zone.ml.Invalid_file_format"],
		              aEl = [0, cst_none$0, 0, -1],
		              aEv = [12, 93, 0],
		              aEw = [0, 0],
		              aEx = [0, 0],
		              aEu =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   46,
		                   [2,
		                    0,
		                    [11,
		                     cst$9,
		                     [4,
		                      0,
		                      0,
		                      0,
		                      [11, cst_out_of_range_0, [4, 0, 0, 0, [12, 93, 0]]]]]]]],
		                 "%s.%s: %d out of range [0, %d]"],
		              aEs =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   46,
		                   [2,
		                    0,
		                    [11,
		                     ": pos=",
		                     [4,
		                      0,
		                      0,
		                      0,
		                      [11, " out of range for string of length ", [4, 0, 0, 0, 0]]]]]]],
		                 "%s.%s: pos=%d out of range for string of length %d"],
		              aEt =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   46,
		                   [2,
		                    0,
		                    [11,
		                     cst$9,
		                     [4,
		                      0,
		                      0,
		                      0,
		                      [11,
		                       " digits do not fit at pos ",
		                       [4, 0, 0, 0, [11, " in string of length ", [4, 0, 0, 0, 0]]]]]]]]],
		                 "%s.%s: %d digits do not fit at pos %d in string of length %d"],
		              aEr =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   46,
		                   [2,
		                    0,
		                    [11,
		                     ": scale=",
		                     [7,
		                      0,
		                      0,
		                      0,
		                      [11,
		                       " out of range [",
		                       [7, 0, 0, 0, [11, c, [7, 0, 0, 0, [12, 93, 0]]]]]]]]]],
		                 "%s.%s: scale=%Ld out of range [%Ld, %Ld]"],
		              aEq =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   46,
		                   [2,
		                    0,
		                    [11,
		                     ": digits=",
		                     [4, 0, 0, 0, [11, " is not a positive number", 0]]]]]],
		                 "%s.%s: digits=%d is not a positive number"],
		              aEp =
		                [0,
		                 [2,
		                  0,
		                  [12,
		                   46,
		                   [2,
		                    0,
		                    [11, ": decimals=", [4, 0, 0, 0, [11, " is negative", 0]]]]]],
		                 "%s.%s: decimals=%d is negative"],
		              aEo =
		                [0,
		                 [2,
		                  0,
		                  [12, 46, [2, 0, [11, ": invalid decimal character", 0]]]],
		                 "%s.%s: invalid decimal character"],
		              aEL =
		                [0, [11, "Invalid month: ", [2, 0, 0]], "Invalid month: %s"],
		              aEK =
		                [0,
		                 [11, "Month.of_int_exn ", [4, 0, 0, 0, 0]],
		                 "Month.of_int_exn %d"],
		              aEy = [0, "Jan"],
		              aEz = [0, "Feb"],
		              aEA = [0, "Mar"],
		              aEB = [0, "Apr"],
		              aEC = [0, cst_May],
		              aED = [0, "Jun"],
		              aEE = [0, "Jul"],
		              aEF = [0, "Aug"],
		              aEG = [0, "Sep"],
		              aEH = [0, "Oct"],
		              aEI = [0, "Nov"],
		              aEJ = [0, "Dec"],
		              aEQ = [0, cst_upper_bound],
		              aER = [0, cst_lower_bound],
		              aEP =
		                [0,
		                 [11, "Date.of_string (", [2, 0, [11, "): ", [2, 0, 0]]]],
		                 "Date.of_string (%s): %s"],
		              aEM = [11, " ~d:", [4, 0, 0, 0, [11, " error: ", [2, 0, 0]]]],
		              aEN = [0, 0],
		              aEO =
		                [0,
		                 [4, 0, 0, 0, [11, " day month violation", 0]],
		                 "%d day month violation"],
		              aES =
		                [0,
		                 "core/src/float_with_finite_only_serialization.ml.Stable.V1.Nan_or_inf"],
		              aET = [0, cst_none$0, 0, -1],
		              aEX = [0, [8, [0, 0, 4], 0, [0, 6], 0], "%.6G"],
		              aEW =
		                [0,
		                 [11,
		                  "Error parsing Percent.t: too many decimal points in '",
		                  [2, 0, [12, 39, 0]]],
		                 "Error parsing Percent.t: too many decimal points in '%s'"],
		              aEV =
		                [0,
		                 [11,
		                  "Unexpected character when parsing Percent.t: '",
		                  [0, [11, "' in '", [2, 0, [12, 39, 0]]]]],
		                 "Unexpected character when parsing Percent.t: '%c' in '%s'"],
		              aEU =
		                [0,
		                 [11,
		                  "Error parsing Percent.t: too many Es in '",
		                  [2, 0, [12, 39, 0]]],
		                 "Error parsing Percent.t: too many Es in '%s'"],
		              aE3 = [0, [8, [0, 0, 3], 0, 1, 0], "%.*g"],
		              aE2 = [0, [8, [0, 0, 3], 0, [0, 1], 0], "%.1g"],
		              aE0 =
		                [0,
		                 "core/src/span_float.ml.Stable.V1.T_of_sexp_expected_atom_but_got"],
		              aE1 = [0, cst_none$0, 0, -1],
		              aEY = [0, "core/src/span_float.ml.Stable.V1.T_of_sexp"],
		              aEZ = [0, cst_none$0, 0, -1],
		              aE5 = [0, "core/src/ofday_float.ml", 155, 6],
		              aE4 = [0, 0],
		              aE7 = [0, "core/src/time.ml.Make.Time_of_string"],
		              aE8 = [0, cst_none$0, 0, -1],
		              aE6 = [0, [0, "core/src/time.ml", 212, 7320, 7400]],
		              aFb = [0, cst_reason],
		              aFc = [0, cst_string],
		              aFa = [0, cst_core_src_span_ns_ml, 466, 14],
		              aE$ = [0, cst_core_src_span_ns_ml, 483, 14],
		              aE_ = [0, cst_core_src_span_ns_ml, 275, 12],
		              aE9 = [0, cst_core_src_span_ns_ml, 268, 17],
		              aFq = [0, 1],
		              aFo =
		                [0, "core/src/time_ns.ml.To_and_of_string.Time_ns_of_string"],
		              aFp = [0, cst_none$0, 0, -1],
		              aFn = [0, "core/src/time_ns.ml", 342, 8],
		              aFe = [0, [12, 46, [4, 0, [0, 2, 1], 0, 0]], ".%01d"],
		              aFf = [0, [12, 46, [4, 0, [0, 2, 2], 0, 0]], ".%02d"],
		              aFg = [0, [12, 46, [4, 0, [0, 2, 3], 0, 0]], ".%03d"],
		              aFh = [0, [12, 46, [4, 0, [0, 2, 4], 0, 0]], ".%04d"],
		              aFi = [0, [12, 46, [4, 0, [0, 2, 5], 0, 0]], ".%05d"],
		              aFj = [0, [12, 46, [4, 0, [0, 2, 6], 0, 0]], ".%06d"],
		              aFk = [0, [12, 46, [4, 0, [0, 2, 7], 0, 0]], ".%07d"],
		              aFl = [0, [12, 46, [4, 0, [0, 2, 8], 0, 0]], ".%08d"],
		              aFm = [0, [12, 46, [4, 0, [0, 2, 9], 0, 0]], ".%09d"],
		              aFd =
		                [0,
		                 [4,
		                  0,
		                  [0, 2, 2],
		                  0,
		                  [12,
		                   58,
		                   [4, 0, [0, 2, 2], 0, [12, 58, [4, 0, [0, 2, 2], 0, 0]]]]],
		                 "%02d:%02d:%02d"],
		              aFI = [0, cst_custom_minor_max_size],
		              aFJ = [0, cst_custom_minor_ratio],
		              aFK = [0, cst_custom_major_ratio],
		              aFL = [0, cst_window_size],
		              aFM = [0, cst_allocation_policy],
		              aFN = [0, cst_stack_limit],
		              aFO = [0, cst_max_overhead],
		              aFP = [0, cst_verbose],
		              aFQ = [0, cst_space_overhead],
		              aFR = [0, cst_major_heap_increment],
		              aFS = [0, cst_minor_heap_size],
		              aFr = [0, cst_forced_major_collections],
		              aFs = [0, cst_stack_size],
		              aFt = [0, cst_top_heap_words],
		              aFu = [0, cst_compactions],
		              aFv = [0, cst_fragments],
		              aFw = [0, cst_largest_free],
		              aFx = [0, cst_free_blocks],
		              aFy = [0, cst_free_words],
		              aFz = [0, cst_live_blocks],
		              aFA = [0, cst_live_words],
		              aFB = [0, cst_heap_chunks],
		              aFC = [0, cst_heap_words],
		              aFD = [0, cst_major_collections],
		              aFE = [0, cst_minor_collections],
		              aFF = [0, cst_major_words],
		              aFG = [0, cst_promoted_words],
		              aFH = [0, cst_minor_words],
		              aFT = [0, cst_steps],
		              aFU = [0, cst_init],
		              aF1 = [0, cst$13],
		              aF2 =
		                [0,
		                 "thread_safe_queue/src/thread_safe_queue.ml",
		                 108,
		                 3926,
		                 3944],
		              aFX = [0, "unused_elts"],
		              aFY = [0, "back"],
		              aFZ = [0, "front"],
		              aF0 = [0, cst_length],
		              aFV = [0, cst_next],
		              aFW = [0, cst_value],
		              aGe = [0, cst_tuple_pool_src_tuple_pool_, 694, 23065, 23079],
		              aGd = [0, cst_tuple_pool_src_tuple_pool_, 651, 21432, 21452],
		              aGc = [0, cst_tuple_pool_src_tuple_pool_, 619, 20496, 20510],
		              aF8 = [0, "dummy"],
		              aF9 = [0, "first_free"],
		              aF_ = [0, "next_id"],
		              aF$ = [0, cst_length],
		              aGa = [0, cst_capacity],
		              aGb = [0, "slots_per_tuple"],
		              aF5 = [0, cst_null],
		              aF6 = [0, cst_Free],
		              aF7 = [0, "Used"],
		              aF4 =
		                [0,
		                 [11,
		                  "<Pool.Pointer.t: 0x",
		                  [4, 6, [0, 2, 8], 0, [12, 62, 0]]],
		                 "<Pool.Pointer.t: 0x%08x>"],
		              aF3 = [0, cst_tuple_pool_src_tuple_pool_, 142, 4422, 4449],
		              aGM = [0, "now_interval_num_start"],
		              aGN = [0, cst_at],
		              aGK = [0, "max_allowed_alarm_time"],
		              aGL = [0, cst_at],
		              aGH = [0, "max_allowed_alarm_interval_num"],
		              aGI = [0, "min_allowed_alarm_interval_num"],
		              aGJ = [0, "interval_num"],
		              aGF = [0, cst_level],
		              aGG = [0, cst_key],
		              aGA = [0, cst$13],
		              aGB = [0, "priority_queue"],
		              aGC = [0, "max_allowed_key t"],
		              aGD = [0, "min_allowed_key t"],
		              aGE = [0, cst_key],
		              aGx = [0, "elts"],
		              aGy = [0, cst_max_allowed_key],
		              aGz = [0, cst_min_allowed_key],
		              aGv = [0, cst_value],
		              aGw = [0, cst_key],
		              aGk = [0, cst_slots],
		              aGl = [0, cst_max_allowed_key],
		              aGm = [0, cst_min_allowed_key],
		              aGn = [0, cst_length],
		              aGo = [0, "diff_max_min_allowed_key"],
		              aGp = [0, "min_key_in_same_slot_mask"],
		              aGq = [0, "keys_per_slot"],
		              aGr = [0, "bits_per_slot"],
		              aGs = [0, "slots_mask"],
		              aGt = [0, "bits"],
		              aGu = [0, cst_index],
		              aGh = [0, "max_num_bits"],
		              aGi = [0, cst_got$0],
		              aGg = [0, cst_timing_wheel_src_timing_wh, 82, 4],
		              aGf = [0, cst_timing_wheel_src_timing_wh, 83, 4],
		              aGj =
		                [0,
		                 11,
		                 [0, 10, [0, 10, [0, 10, [0, 10, [0, 10, [0, 1, 0]]]]]]],
		              aGO = [0, "thread_safe_run_when_unused_data"],
		              aGP = [0, "keys_with_unused_data"],
		              aGQ = [0, "entry_by_key"],
		              aGR = [0, "After"],
		              aGS = [0, "Before"],
		              aGT = [0, "Always"],
		              aGU = [0, cst_Never],
		              aGV = [0, "Phys_equal"],
		              aGW = [0, "Compare"],
		              aGX = [0, cst_Equal],
		              aGY = [0, cst_F$0],
		              aG1 = [0, "Dot"],
		              aG2 = [0, cst_Info],
		              aG3 = [0, "new_"],
		              aG4 = [0, "prior"],
		              aG5 = [0, "Append"],
		              aGZ = [0, cst_attributes],
		              aG0 = [0, cst_label],
		              aHd = [0, "created_at"],
		              aHe = [0, "previous_update_kind"],
		              aHf = [0, cst_f$0],
		              aG$ = [0, cst_Invalidated],
		              aHa = [0, cst_Unnecessary],
		              aHb = [0, cst_Necessary],
		              aHc = [0, cst_Changed],
		              aG6 = [0, "Never_been_updated"],
		              aG7 = [0, cst_Necessary],
		              aG8 = [0, cst_Changed],
		              aG9 = [0, cst_Invalidated],
		              aG_ = [0, cst_Unnecessary],
		              aHg = [0, "backtrace"],
		              aHh = [0, cst_exn],
		              aIs = [0, cst$13],
		              aHi = [0, [0]],
		              aHj = [0, cst_src_types_ml, 22, 2],
		              aHk = [0, [0]],
		              aHl = [0, cst_src_types_ml, 27, 2],
		              aHm = [0, [0, [0, [0]]]],
		              aHn = [0, cst_src_types_ml, 43, 2],
		              aHo = [0, [0]],
		              aHp = [0, cst_src_types_ml, 52, 2],
		              aHq = [0, [0]],
		              aHr = [0, cst_src_types_ml, 62, 2],
		              aHs = [0, [0]],
		              aHt = [0, cst_src_types_ml, 73, 2],
		              aHu = [0, [0]],
		              aHv = [0, cst_src_types_ml, 86, 2],
		              aHw = [0, [0]],
		              aHx = [0, cst_src_types_ml, 96, 2],
		              aHy = [0, [0]],
		              aHz = [0, cst_src_types_ml, 117, 2],
		              aHA = [0, [0]],
		              aHB = [0, cst_src_types_ml, 126, 2],
		              aHC = [0, [0]],
		              aHD = [0, cst_src_types_ml, 138, 2],
		              aHE = [0, [0, [0, [0]], [0, [0]]]],
		              aHF = [0, cst_src_types_ml, 165, 2],
		              aHG = [0, [0]],
		              aHH = [0, cst_src_types_ml, 175, 2],
		              aHI = [0, [0]],
		              aHJ = [0, cst_src_types_ml, 416, 2],
		              aHK = [0, [0, 0, [0, [0, 0]], 0, 0, 0]],
		              aHL = [0, cst_src_types_ml, 459, 6],
		              aHM = [0, [0]],
		              aHN = [0, cst_src_types_ml, 518, 2],
		              aHO = [0, [0]],
		              aHP = [0, cst_src_types_ml, 526, 2],
		              aHQ = [0, [0]],
		              aHR = [0, cst_src_types_ml, 531, 2],
		              aHS = [0, [0]],
		              aHT = [0, cst_src_types_ml, 540, 2],
		              aHU = [0, [0]],
		              aHV = [0, cst_src_types_ml, 545, 2],
		              aHW = [0, [0, 0]],
		              aHX = [0, cst_src_types_ml, 552, 6],
		              aHY = [0, [0]],
		              aHZ = [0, cst_src_types_ml, 572, 2],
		              aH0 = [0, [0]],
		              aH1 = [0, cst_src_types_ml, 605, 2],
		              aH2 = [0, [0]],
		              aH3 = [0, cst_src_types_ml, 614, 2],
		              aH4 = [0, [0]],
		              aH5 = [0, cst_src_types_ml, 628, 2],
		              aH6 = [0, [0]],
		              aH7 = [0, cst_src_types_ml, 642, 2],
		              aH8 = [0, [0, [0, [0]]]],
		              aH9 = [0, cst_src_types_ml, 658, 2],
		              aH_ = [0, [0]],
		              aH$ = [0, [0]],
		              aIa = [0, [0, [0, [0]]]],
		              aIb = [0, [0]],
		              aIc = [0, [0]],
		              aId = [0, [0]],
		              aIe = [0, [0]],
		              aIf = [0, [0]],
		              aIg = [0, [0]],
		              aIh = [0, [0]],
		              aIi = [0, [0]],
		              aIj = [0, [0, [0, [0]], [0, [0]]]],
		              aIk = [0, [0]],
		              aIl = [0, [0]],
		              aIm = [0, [0, 0, [0, [0, 0]], 0, 0, 0]],
		              aIn = [0, [0]],
		              aIo = [0, [0]],
		              aIp = [0, [0]],
		              aIq = [0, [0]],
		              aIr = [0, [0]],
		              aIt = [0, [0, 0]],
		              aIu = [0, [0]],
		              aIv = [0, [0]],
		              aIw = [0, [0]],
		              aIx = [0, [0]],
		              aIy = [0, [0]],
		              aIz = [0, [0, [0, [0]]]],
		              aIE = [0, cst$13],
		              aIF = [0, cst_T],
		              aIA = [0, cst_watch],
		              aIB = [0, "set_at"],
		              aIC = [0, "value_set_during_stabilization"],
		              aID = [0, cst_value],
		              aIS = [0, cst$13],
		              aIR = [0, cst$13],
		              aIO = [0, cst$13],
		              aIP = [0, cst_child],
		              aIQ = [0, "child_index"],
		              aIT = [0, "unordered_array_fold"],
		              aIG = [0, "num_changes_since_last_full_compute"],
		              aIH = [0, "fold_value"],
		              aII = [0, cst_children],
		              aIJ = [0, "full_compute_every_n_changes"],
		              aIK = [0, cst_update],
		              aIL = [0, cst_f$0],
		              aIM = [0, cst_init],
		              aIN = [0, cst_main],
		              aIU = [0, cst_clock],
		              aIV = [0, "alarm_value"],
		              aIW = [0, cst_alarm],
		              aIX = [0, "upcoming_steps"],
		              aIY = [0, cst_value],
		              aIZ = [0, "extracted_step_function_from_child_at"],
		              aI0 = [0, cst_child],
		              aI1 = [0, cst_main],
		              aI2 = [0, cst_children],
		              aI3 = [0, cst_f$0],
		              aI4 = [0, cst_init],
		              aI5 = [0, cst_clock],
		              aI6 = [0, cst_alarm],
		              aI7 = [0, cst_at],
		              aI8 = [0, cst_main],
		              aI9 = [0, cst_clock],
		              aI_ = [0, cst_alarm],
		              aI$ = [0, cst_interval],
		              aJa = [0, cst_base],
		              aJb = [0, cst_main],
		              aJc = [0, "all_nodes_created_on_rhs"],
		              aJd = [0, "rhs_scope"],
		              aJe = [0, cst_rhs],
		              aJf = [0, cst_lhs_change],
		              aJg = [0, cst_lhs],
		              aJh = [0, cst_f$0],
		              aJi = [0, cst_main],
		              aJw = [0, cst_src_expert_ml, 140, 2],
		              aJv = [0, cst_src_expert_ml, 109, 2],
		              aJo = [0, "will_fire_all_callbacks"],
		              aJp = [0, "num_invalid_children"],
		              aJq = [0, "force_stale"],
		              aJr = [0, "num_children"],
		              aJs = [0, cst_children],
		              aJt = [0, "on_observability_change"],
		              aJu = [0, cst_f$0],
		              aJm = [0, cst$13],
		              aJn = [0, cst_E],
		              aJj = [0, cst_index],
		              aJk = [0, cst_on_change],
		              aJl = [0, cst_child],
		              aJx = [0, "src/scope.ml", 37, 2],
		              aJy = [0, "only_freeze_when"],
		              aJz = [0, cst_child],
		              aJA = [0, cst_main],
		              aJB = [0, cst_else$0],
		              aJC = [0, cst_then$0],
		              aJD = [0, "current_branch"],
		              aJE = [0, "test_change"],
		              aJF = [0, cst_test],
		              aJG = [0, cst_main],
		              aJH = [0, cst_rhs],
		              aJI = [0, cst_lhs_change],
		              aJJ = [0, cst_lhs],
		              aJK = [0, cst_main],
		              aJL = [0, cst_clock],
		              aJM = [0, "value_at"],
		              aJN = [0, cst_before],
		              aJO = [0, cst_at],
		              aJP = [0, cst_main],
		              aMi = [0, cst$13],
		              aMh = [0, cst$13],
		              aMg = [0, cst$13],
		              aMf = [0, cst$13],
		              aMe = [0, cst$13],
		              aMd = [0, cst$13],
		              aMc = [0, cst$13],
		              aMb = [0, cst$13],
		              aMa = [0, cst$13],
		              aL$ = [0, cst$13],
		              aL_ = [0, cst$13],
		              aL9 = [0, cst$13],
		              aL8 = [0, cst$13],
		              aL7 = [0, cst$13],
		              aL6 = [0, cst$13],
		              aL4 = [0, cst$13],
		              aL3 = [0, cst$13],
		              aL2 = [0, cst$13],
		              aL1 = [0, cst$13],
		              aL0 = [0, cst$13],
		              aLZ = [0, cst$13],
		              aLY = [0, cst$13],
		              aLX = [0, cst$13],
		              aLW = [0, cst$13],
		              aLV = [0, cst$13],
		              aLU = [0, cst$13],
		              aLT = [0, cst$13],
		              aLS = [0, cst$13],
		              aLR = [0, cst$13],
		              aLP = [0, cst$13],
		              aLO = [0, cst$13],
		              aLN = [0, cst$13],
		              aLM = [0, cst$13],
		              aLL = [0, cst$13],
		              aLK = [0, cst$13],
		              aLJ = [0, cst$13],
		              aLI = [0, cst$13],
		              aLH = [0, cst$13],
		              aLG = [0, cst$13],
		              aLF = [0, cst$13],
		              aLE = [0, cst$13],
		              aLD = [0, cst$13],
		              aLB = [0, cst$13],
		              aLA = [0, cst$13],
		              aLz = [0, cst$13],
		              aLy = [0, cst$13],
		              aLx = [0, cst$13],
		              aLw = [0, cst$13],
		              aLv = [0, cst$13],
		              aLu = [0, cst$13],
		              aLt = [0, cst$13],
		              aLs = [0, cst$13],
		              aLr = [0, cst$13],
		              aLq = [0, cst$13],
		              aLo = [0, cst$13],
		              aLn = [0, cst$13],
		              aLm = [0, cst$13],
		              aLl = [0, cst$13],
		              aLk = [0, cst$13],
		              aLj = [0, cst$13],
		              aLi = [0, cst$13],
		              aLh = [0, cst$13],
		              aLg = [0, cst$13],
		              aLf = [0, cst$13],
		              aLe = [0, cst$13],
		              aLc = [0, cst$13],
		              aLb = [0, cst$13],
		              aLa = [0, cst$13],
		              aK$ = [0, cst$13],
		              aK_ = [0, cst$13],
		              aK9 = [0, cst$13],
		              aK8 = [0, cst$13],
		              aK7 = [0, cst$13],
		              aK6 = [0, cst$13],
		              aK5 = [0, cst$13],
		              aK3 = [0, cst$13],
		              aK2 = [0, cst$13],
		              aK1 = [0, cst$13],
		              aK0 = [0, cst$13],
		              aKZ = [0, cst$13],
		              aKY = [0, cst$13],
		              aKX = [0, cst$13],
		              aKW = [0, cst$13],
		              aKV = [0, cst$13],
		              aKT = [0, cst$13],
		              aKS = [0, cst$13],
		              aKR = [0, cst$13],
		              aKQ = [0, cst$13],
		              aKP = [0, cst$13],
		              aKO = [0, cst$13],
		              aKN = [0, cst$13],
		              aKM = [0, cst$13],
		              aKK = [0, cst$13],
		              aKJ = [0, cst$13],
		              aKI = [0, cst$13],
		              aKH = [0, cst$13],
		              aKG = [0, cst$13],
		              aKF = [0, cst$13],
		              aKE = [0, cst$13],
		              aKC = [0, cst$13],
		              aKB = [0, cst$13],
		              aKA = [0, cst$13],
		              aKz = [0, cst$13],
		              aKy = [0, cst$13],
		              aKx = [0, cst$13],
		              aKv = [0, cst$13],
		              aKu = [0, cst$13],
		              aKt = [0, cst$13],
		              aKs = [0, cst$13],
		              aKr = [0, cst$13],
		              aKp = [0, cst$13],
		              aKo = [0, cst$13],
		              aKn = [0, cst$13],
		              aKm = [0, cst$13],
		              aKk = [0, cst$13],
		              aKj = [0, cst$13],
		              aKi = [0, cst$13],
		              aKg = [0, cst$13],
		              aKf = [0, cst$13],
		              aKc = [0, cst$13],
		              aJ_ = [0, cst$13],
		              aJ7 = [0, cst$13],
		              aJ4 = [0, cst$13],
		              aJZ = [0, cst$13],
		              aJX = [0, cst$13],
		              aJW = [0, cst$13],
		              aJS = [0, cst$13],
		              aJQ = [0, "Invalid"],
		              aJR = [0, "Uninitialized"],
		              aJT = [0, "Array_fold"],
		              aJU = [0, "At"],
		              aJV = [0, "At_intervals"],
		              aJY = [0, "Bind_lhs_change"],
		              aJ0 = [0, "Bind_main"],
		              aJ1 = [0, cst_Const],
		              aJ2 = [0, "Expert"],
		              aJ3 = [0, "Freeze"],
		              aJ5 = [0, "If_test_change"],
		              aJ6 = [0, "If_then_else"],
		              aJ8 = [0, "Join_lhs_change"],
		              aJ9 = [0, "Join_main"],
		              aJ$ = [0, cst_Map],
		              aKa = [0, "Snapshot"],
		              aKb = [0, "Step_function"],
		              aKd = [0, "Unordered_array_fold"],
		              aKe = [0, cst_Var],
		              aKh = [0, "Map2"],
		              aKl = [0, "Map3"],
		              aKq = [0, "Map4"],
		              aKw = [0, "Map5"],
		              aKD = [0, "Map6"],
		              aKL = [0, "Map7"],
		              aKU = [0, "Map8"],
		              aK4 = [0, "Map9"],
		              aLd = [0, "Map10"],
		              aLp = [0, "Map11"],
		              aLC = [0, "Map12"],
		              aLQ = [0, "Map13"],
		              aL5 = [0, "Map14"],
		              aMj = [0, "Map15"],
		              aMT = [0, cst$13],
		              aMS = [0, cst_src_node_ml, 465, 12],
		              aMQ = [0, cst_src_node_ml, 484, 33],
		              aMR = [0, cst_src_node_ml, 477, 14],
		              aMO = [0, cst$13],
		              aMP = [0, cst_src_node_ml, 444, 18705, 18728],
		              aMN = [0, cst_src_node_ml, 235, 21],
		              aMM = [0, cst_src_node_ml, 145, 21],
		              aMk = [0, "creation_backtrace"],
		              aMl = [0, "user_info"],
		              aMm = [0, "force_necessary"],
		              aMn = [0, "my_child_index_in_parent_at_index"],
		              aMo = [0, "my_parent_index_in_child_at_index"],
		              aMp = [0, cst_on_update_handlers],
		              aMq = [0, "is_in_handle_after_stabilization"],
		              aMr = [0, "observers"],
		              aMs = [0, "old_value_opt"],
		              aMt = [0, "next_in_adjust_heights_heap"],
		              aMu = [0, "height_in_adjust_heights_heap"],
		              aMv = [0, "next_in_recompute_heap"],
		              aMw = [0, "prev_in_recompute_heap"],
		              aMx = [0, "height_in_recompute_heap"],
		              aMy = [0, cst_height],
		              aMz = [0, "next_node_in_same_scope"],
		              aMA = [0, "created_in"],
		              aMB = [0, "parent0"],
		              aMC = [0, "parent1_and_beyond"],
		              aMD = [0, "num_parents"],
		              aME = [0, "num_on_update_handlers"],
		              aMF = [0, "changed_at"],
		              aMG = [0, "cutoff"],
		              aMH = [0, cst_kind],
		              aMI = [0, "value_opt"],
		              aMJ = [0, "recomputed_at"],
		              aMK = [0, cst_state],
		              aML = [0, cst_id],
		              aMU = [0, cst_nodes_by_height],
		              aMV = [0, cst_height_lower_bound],
		              aMW = [0, cst_length],
		              aM6 = [0, cst$13],
		              aM4 = [0, cst$13],
		              aM5 = [0, cst_child],
		              aM7 = [0, cst_parent],
		              aM8 = [0, cst_src_adjust_heights_heap_ml, 144, 5086, 5098],
		              aM1 = [0, "Height"],
		              aM2 = [0, cst_Max],
		              aM3 = [0, cst_src_adjust_heights_heap_ml, 131, 4645, 4659],
		              aMX = [0, cst_nodes_by_height],
		              aMY = [0, "max_height_seen"],
		              aMZ = [0, cst_height_lower_bound],
		              aM0 = [0, cst_length],
		              aNs = [0, cst$13],
		              aNp = [0, cst$13],
		              aNq = [0, cst_src_internal_observer_ml, 142, 4451, 4471],
		              aNr = [0, cst_src_internal_observer_ml, 146, 32],
		              aNj = [0, cst$13],
		              aNn = [0, cst$13],
		              aNl = [0, cst$13],
		              aNm = [0, cst_src_internal_observer_ml, 127, 4041, 4053],
		              aNo = [0, cst_src_internal_observer_ml, 121, 3894, 3906],
		              aNk = [0, cst_src_internal_observer_ml, 135, 4239, 4261],
		              aNc = [0, "next_in_observing"],
		              aNd = [0, "prev_in_observing"],
		              aNe = [0, "next_in_all"],
		              aNf = [0, "prev_in_all"],
		              aNg = [0, cst_on_update_handlers],
		              aNh = [0, "observing"],
		              aNi = [0, cst_state],
		              aM_ = [0, cst_Created],
		              aM$ = [0, "In_use"],
		              aNa = [0, "Disallowed"],
		              aNb = [0, "Unlinked"],
		              aM9 = [0, cst$13],
		              aN$ = [0, cst$13],
		              aOa = [0, cst_src_state_ml, 560, 25819, 25831],
		              aOc = [0, cst_src_state_ml, 758, 4],
		              aOd = [0, cst_src_state_ml, 807, 21],
		              aOf = [0, cst_src_state_ml, 1062, 29],
		              aOg = [0, cst_src_state_ml, 1064, 20],
		              aOh = [0, cst_src_state_ml, 1065, 30],
		              aOe = [0, cst_src_state_ml, 1066, 54],
		              aOl = [0, cst$13],
		              aOj = [0, cst$13],
		              aOk = [0, cst_src_state_ml, 1251, 52155, 52167],
		              aOi = [0, cst_src_state_ml, 1211, 29],
		              aOb = [0, cst_src_state_ml, 636, 28770, 28793],
		              aN6 =
		                [0,
		                 [11, cst_cannot, [2, 0, [11, " during stabilization", 0]]],
		                 "cannot %s during stabilization"],
		              aN7 = [0, cst_src_state_ml, 337, 15160, 15172],
		              aN8 =
		                [0,
		                 [11,
		                  cst_cannot,
		                  [2, 0, [11, " during on-update handlers", 0]]],
		                 "cannot %s during on-update handlers"],
		              aN9 = [0, cst_src_state_ml, 326, 14790, 14804],
		              aN_ =
		                [0,
		                 [11,
		                  cst_cannot,
		                  [2, 0, [11, " -- stabilize previously raised", 0]]],
		                 "cannot %s -- stabilize previously raised"],
		              aNF = [0, "num_var_sets"],
		              aNG = [0, "num_nodes_recomputed_directly_because_min_height"],
		              aNH = [0, "num_nodes_recomputed_directly_because_one_child"],
		              aNI = [0, "num_nodes_recomputed"],
		              aNJ = [0, "num_nodes_invalidated"],
		              aNK = [0, "num_nodes_created"],
		              aNL = [0, "num_nodes_changed"],
		              aNM = [0, "num_nodes_became_unnecessary"],
		              aNN = [0, "num_nodes_became_necessary"],
		              aNO = [0, "keep_node_creation_backtrace"],
		              aNP = [0, "weak_hashtbls"],
		              aNQ = [0, "only_in_debug"],
		              aNR = [0, "run_on_update_handlers"],
		              aNS = [0, "handle_after_stabilization"],
		              aNT = [0, "set_during_stabilization"],
		              aNU = [0, "disallowed_observers"],
		              aNV = [0, "new_observers"],
		              aNW = [0, "finalized_observers"],
		              aNX = [0, "all_observers"],
		              aNY = [0, "num_active_observers"],
		              aNZ = [0, "propagate_invalidity"],
		              aN0 = [0, "adjust_heights_heap"],
		              aN1 = [0, "recompute_heap"],
		              aN2 = [0, "current_scope"],
		              aN3 = [0, "stabilization_num"],
		              aN4 = [0, "bind_lhs_change_should_invalidate_rhs"],
		              aN5 = [0, cst_status],
		              aND = [0, cst$13],
		              aNC = [0, cst$13],
		              aNE = [0, cst_T],
		              aNA = [0, "expert_nodes_created_by_current_node"],
		              aNB = [0, "currently_running_node"],
		              aNy = [0, cst$13],
		              aNx = [0, cst$13],
		              aNz = [0, cst_T],
		              aNt = [0, "Stabilizing"],
		              aNu = [0, "Running_on_update_handlers"],
		              aNv = [0, "Not_stabilizing"],
		              aNw = [0, "Stabilize_previously_raised"],
		              aOm = [0, cst$13],
		              aOn = [0, "src/incremental.ml", 152, 3857, 3875],
		              aOo = [0, 1],
		              aOs = [0, 1],
		              aOr = [0, 1],
		              aOq = [0, 1],
		              aOp = [0, 1],
		              aOt = [0, 0],
		              aOA = [0, 0],
		              aOy = [0, [17, 0, 0], cst$6],
		              aOz =
		                [0, [15, [18, [1, [0, [11, cst_2, 0], cst_2]], 0]], "%a@[<2>"],
		              aOv = [0, [11, "start ", [15, 0]], "start %a"],
		              aOw = [0, [11, "end ", [15, 0]], "end %a"],
		              aOu = [0, "The component the log originates from."],
		              aOx = [0, "span lifecycle event"],
		              aOB = [0, "replica-id"],
		              match$209 = [0, "timestamped"],
		              aOD = [0, [2, 0, [12, 58, [4, 0, 0, 0, 0]]], cst_s_d],
		              aOC = [0, "replica-timestamp"],
		              aOE = [0, [2, 0, [12, 58, [4, 0, 0, 0, 0]]], cst_s_d],
		              aOG = [1, 0],
		              aOF = [1, 0],
		              aO9 =
		                [0,
		                 [11, cst_insert$0, [2, 0, [12, 32, [15, 0]]]],
		                 "insert %s %a"],
		              aO8 =
		                [0,
		                 [11,
		                  "insert at ",
		                  [4, 3, 0, 0, [11, cst_pos, [4, 3, 0, 0, [12, 41, 0]]]]],
		                 "insert at %i (pos %i)"],
		              aO7 =
		                [0,
		                 [11,
		                  "index out of bounds, ignore element operation: ",
		                  [4, 3, 0, 0, [11, cst_pos, [4, 3, 0, 0, [12, 41, 0]]]]],
		                 "index out of bounds, ignore element operation: %i (pos %i)"],
		              aO6 =
		                [0,
		                 [11,
		                  "operate on element at ",
		                  [4, 3, 0, 0, [11, cst_pos, [4, 3, 0, 0, [12, 41, 0]]]]],
		                 "operate on element at %i (pos %i)"],
		              aO5 =
		                [0,
		                 [11, cst_index_out_of_bounds_not_de, 0],
		                 cst_index_out_of_bounds_not_de],
		              aO4 =
		                [0,
		                 [11,
		                  cst_delete$0,
		                  [4,
		                   3,
		                   0,
		                   0,
		                   [11,
		                    cst_at$0,
		                    [4, 3, 0, 0, [11, cst_pos, [4, 3, 0, 0, [12, 41, 0]]]]]]],
		                 "delete %i at %i (pos %i)"],
		              aO3 =
		                [0,
		                 [11, "apply delta:", [17, [0, cst$4, 1, 0], [15, 0]]],
		                 "apply delta:@ %a"],
		              aO1 =
		                [0,
		                 [11, "Delete { ids = ", [15, [11, cst$30, 0]]],
		                 "Delete { ids = %a }"],
		              aO2 =
		                [0,
		                 [11,
		                  cst_insert$0,
		                  [15, [11, " with at ", [2, 0, [11, cst_of$0, [15, 0]]]]]],
		                 "insert %a with at %s of %a"],
		              aO0 = [0, 0],
		              aOZ = [0, cst_state],
		              aOT =
		                [0,
		                 [11, cst_missing_node_to_delete, [15, 0]],
		                 cst_missing_node_to_delete_a],
		              aOV =
		                [0,
		                 [11, cst_missing_node_to_delete, [15, 0]],
		                 cst_missing_node_to_delete_a],
		              aOU =
		                [0,
		                 [11, cst_missing_node_to_delete, [15, 0]],
		                 cst_missing_node_to_delete_a],
		              aOY = [0, cst_api_vendor_crdt_src_crdt_f, 374, 13],
		              aOX =
		                [0,
		                 [11, "operation attaches text to unknown node ", [15, 0]],
		                 "operation attaches text to unknown node %a"],
		              aOW = [0, cst_api_vendor_crdt_src_crdt_f, 358, 13],
		              aOR =
		                [0,
		                 [11, "missing child node: ", [15, 0]],
		                 "missing child node: %a"],
		              aOS =
		                [0,
		                 [11, "missing root node ", [15, 0]],
		                 "missing root node %a"],
		              aOP = [0, cst_node],
		              aOQ = [0, "tree"],
		              aOO =
		                [0,
		                 [11,
		                  "intersecting id ranges: (",
		                  [15,
		                   [11,
		                    c,
		                    [15, [11, ") and (", [15, [11, c, [15, [12, 41, 0]]]]]]]]],
		                 "intersecting id ranges: (%a, %a) and (%a, %a)"],
		              aOK = [0, cst_t],
		              aOL = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              aOM = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              aON = [0, [17, 0, [12, 41, 0]], cst$39],
		              match$210 = [0, 0],
		              aOH = [0, cst_insert],
		              aOI = [0, cst_element],
		              aOJ = [0, cst_delete],
		              match$211 = [0, "fugue-delta"],
		              aPa = [0, cst_api_vendor_crdt_src_crdt_c, 27, 39],
		              aO$ = [0, cst_api_vendor_crdt_src_crdt_c, 24, 71],
		              aO_ = [0, cst_state],
		              aPe = [0, 16],
		              aPd = [0, cst$1, 0],
		              aPc = [0, cst_text],
		              aPb =
		                [0, [11, "invalid UTF-8: ", [2, 0, 0]], "invalid UTF-8: %s"],
		              aPf = [0, 0, 0],
		              aPg = [0, cst_remove],
		              aPh = [0, cst_element],
		              aPi = [0, cst_add],
		              match$212 = [0, "map-delta"],
		              aPt =
		                [0,
		                 [11,
		                  cst_no_element_with_key,
		                  [15, [11, ": ignoring remove operation", 0]]],
		                 "no element with key %a: ignoring remove operation"],
		              aPs =
		                [0,
		                 [11,
		                  cst_no_element_with_key,
		                  [15, [11, ": ignoring element operation", 0]]],
		                 "no element with key %a: ignoring element operation"],
		              aPr =
		                [0,
		                 [11,
		                  "ignore obsolete removal of ",
		                  [15, [11, cst$9, [15, [11, cst$56, [15, 0]]]]]],
		                 "ignore obsolete removal of %a: %a < %a"],
		              aPq = [0, [11, "remove element ", [15, 0]], "remove element %a"],
		              aPp =
		                [0,
		                 [11,
		                  "ignore delta on element ",
		                  [15,
		                   [11, " as timestamps differ: ", [15, [11, cst$23, [15, 0]]]]]],
		                 "ignore delta on element %a as timestamps differ: %a <> %a"],
		              aPo =
		                [0,
		                 [11, "ignore delta on non-existent element ", [15, 0]],
		                 "ignore delta on non-existent element %a"],
		              aPn =
		                [0,
		                 [11, "apply delta to element ", [15, 0]],
		                 "apply delta to element %a"],
		              aPm = [0, [11, "add element ", [15, 0]], "add element %a"],
		              aPl =
		                [0,
		                 [11,
		                  "ignore obsolete addition of ",
		                  [15, [11, cst$9, [15, [11, cst$56, [15, 0]]]]]],
		                 "ignore obsolete addition of %a: %a < %a"],
		              aPk =
		                [0,
		                 [11, "overwrite element ", [15, 0]],
		                 "overwrite element %a"],
		              aPj = [0, cst_delta],
		              match$213 = [0, "crdt-map-element"],
		              aPu = [0, 0, cst$1],
		              match$214 = [0, cst_commit],
		              aPv = [0, "crdt_clocks"],
		              aPE = [0, cst_commit],
		              aPD =
		                [0,
		                 [2, 0, [11, ": apply operation ", [15, 0]]],
		                 "%s: apply operation %a"],
		              aPx = [0, "state of the data for this replica"],
		              aPy = [0, "history of fetched commits"],
		              aPz = [0, "id of this replica"],
		              aPA = [0, "commit timestamps with no descendants"],
		              aPB = [0, "last timestamps seen for all known replicas"],
		              aPC = [0, "timestamp for this replica"],
		              aPw = [0, "crdt-replica"],
		              match$216 = [0, "lww-delta"],
		              match$215 = [0, cst_state],
		              aPF = [0, cst_state],
		              aPG = [0, cst_set],
		              match$217 = [0, "crdt-delta-var"],
		              aPH = [0, cst_state],
		              match$218 = [0, "tree-delta"],
		              aPI = [0, 0, cst$1],
		              aPP = [0, "elem"],
		              aPQ = [0, cst_delta],
		              aPN =
		                [0,
		                 "[tag:crdt_tree_canonical_nodes]\n\n      The base tree guarantees the uniqueness of the nodes, but not the\n      uniqueness of the values in the nodes, so we keep a map from values to\n      node ids to ensure that each object has (at most) one canonical node\n      attached to it.\n\n      Any relation where the child is not canonical will be ignored in order to\n      prevent issues caused by a concurrent insertion of the same element at two\n      different places in the tree.\n\n      This is _slighly_ hacky and wasteful (we might end-up with garbage in the\n      tree), but it ensures the correct semantics, and the odds of having a\n      duplicated node are low-enough that we can afford it.\n\n      Invariant: forall [(v, id)] in [by_elem], [id] is in [base] with value\n      [v]."],
		              aPO = [0, cst_state],
		              aPM =
		                [0,
		                 [11, cst_impossible_unbreakable_loo, 0],
		                 cst_impossible_unbreakable_loo],
		              aPL = [0, cst_state],
		              aPK = [1, 0],
		              aPJ = [0, cst_node],
		              aPS = [0, cst_state],
		              aPR = [0, "crdt-pair-delta"],
		              match$219 = [0, "crdt-pair-init"],
		              match$220 = [0, cst_make],
		              param$1 = [0, 0, 0],
		              aPZ = [0, cst_parent],
		              aPY = [0, cst_latest],
		              aPX = [0, "earliest"],
		              aPV = [0, cst_delta],
		              aPU = [0, cst_state],
		              aPW = [0, 0],
		              aPT = [0, cst_operation],
		              match$221 = [0, "lww-option-delta"],
		              aP6 =
		                [0,
		                 [11, cst_Block_present_in_previous_, 0],
		                 cst_Block_present_in_previous_],
		              aP8 =
		                [0,
		                 [11, cst_Block_absent_in_previous_p, 0],
		                 cst_Block_absent_in_previous_p],
		              aP7 =
		                [0,
		                 [11, cst_previous_and_current_block, 0],
		                 cst_previous_and_current_block],
		              aP5 =
		                [0,
		                 [11,
		                  "Duplicate block id in document, ignoring the first one:",
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [15, [11, " and", [17, [0, cst$4, 1, 0], [15, 0]]]]]],
		                 "Duplicate block id in document, ignoring the first one:@ %a and@ %a"],
		              aP3 = [0, cst_state],
		              aP1 = [0, cst_kind],
		              aP2 = [0, cst_text],
		              aP0 = [0, "document-block-delta"],
		              aP4 = [0, 0],
		              aQf = [0, cst_state],
		              aQd = [0, cst_document],
		              aQe = [0, cst_context],
		              aQc = [0, "PromptPrompt_crdt-delta"],
		              aQb = [0, cst_state],
		              aP_ = [0, cst_references],
		              aP$ = [0, cst_mentions],
		              aQa = [0, cst_integrations],
		              aP9 = [0, "PromptContext-delta"],
		              aQp = [0, cst_state],
		              aQh = [0, cst_working_memory],
		              aQi = [0, cst_user_preferences],
		              aQj = [0, cst_name],
		              aQk = [0, cst_key],
		              aQl = [0, cst_id],
		              aQm = [0, cst_conversations],
		              aQn = [0, cst_automations],
		              aQo = [0, cst_agent_instructions],
		              aQg = [0, "AgentAgent_crdt-delta"],
		              aQA = [0, cst_state],
		              aQr = [0, 0],
		              aQs =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_ai_automation, [0, cst_trigger, 0]]]]],
		              aQt = [0, cst_trigger],
		              aQu = [0, 0],
		              aQv =
		                [0,
		                 [0, cst_beta, [0, cst_6, [0, cst_ai_automation_suspend, 0]]]],
		              aQw = [0, cst_enabled],
		              aQx = [0, cst_steps],
		              aQy = [0, cst_name],
		              aQz = [0, cst_id],
		              aQq = [0, "AutomationAutomation_crdt-delta"],
		              aQN = [0, cst_state],
		              aQE = [0, cst_trigger],
		              aQF = [0, cst_step_results],
		              aQG = [0, cst_status],
		              aQH = [0, cst_started_at],
		              aQI = [0, cst_object_context],
		              aQJ = [0, cst_object_id$0],
		              aQK = [0, cst_id],
		              aQL = [0, cst_automation_name],
		              aQM = [0, cst_automation_id],
		              aQD = [0, "Automation_runAutomation_run_crdt-delta"],
		              aQC = [0, "ai-automation-run-backward"],
		              aQB = [0, "ai-automation-run-compat"],
		              aQ4 = [0, cst_state],
		              aQP = [0, cst_touched_last],
		              aQQ = [0, cst_title],
		              aQR = [0, cst_last_response_id],
		              aQS = [0, cst_last_prompt_hash],
		              aQT = [0, 0],
		              aQU =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_conversation_in_progress, 0]]]],
		              aQV = [0, cst_in_progress],
		              aQW = [0, cst_id],
		              aQX = [0, cst_history],
		              aQY = [0, 0],
		              aQZ =
		                [0,
		                 [0, cst_beta, [0, cst_7, [0, cst_conversation_context, 0]]]],
		              aQ0 = [0, cst_context],
		              aQ1 = [0, 0],
		              aQ2 =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_ai_conversation_agent_id, 0]]]],
		              aQ3 = [0, cst_agent_id],
		              aQO = [0, "ConversationConversation_crdt-delta"],
		              aQ9 = [0, cst_state],
		              aQ6 = [0, cst_name],
		              aQ7 = [0, cst_id],
		              aQ8 = [0, cst_action],
		              aQ5 = [0, "StepStep_crdt-delta"],
		              aRj = [0, cst_state],
		              aQ$ = [0, cst_conversations],
		              aRa = [0, cst_automations],
		              aRb = [0, cst_steps],
		              aRc = [0, 0],
		              aRd =
		                [0, [0, cst_beta, [0, cst_1, [0, cst_automation_runs$0, 0]]]],
		              aRe = [0, cst_automation_runs],
		              aRf = [0, 0],
		              aRg = [0, [0, cst_beta, [0, cst_8, [0, cst_ai_assistant, 0]]]],
		              aRh = [0, cst_assistant],
		              aRi = [0, cst_agents],
		              aQ_ = [0, "ai-delta"],
		              aRs = [0, cst_state],
		              aRl = [0, cst_writable],
		              aRm = [0, cst_summary],
		              aRn = [0, cst_role],
		              aRo = [0, cst_extension_row],
		              aRp = [0, cst_disabled],
		              aRq = [0, cst_connection],
		              aRr = [0, cst_color],
		              aRk = [0, "calendar-delta"],
		              aRt = [0, cst_view],
		              aRL =
		                [0,
		                 [11, cst_invalid_connection_delta_s, 0],
		                 cst_invalid_connection_delta_s],
		              aRK =
		                [0,
		                 [11, cst_invalid_connection_operati, 0],
		                 cst_invalid_connection_operati],
		              aRJ = [0, cst_state],
		              aRH = [0, cst_google],
		              aRI = [0, cst_email],
		              aRE = [0, 0],
		              aRF =
		                [0, [0, cst_beta, [0, cst_5, [0, cst_calendars_state, 0]]]],
		              aRG = [0, cst_google],
		              aRD = [0, "connection-delta"],
		              aRC = [0, cst_state],
		              aRv = [0, cst_userinfo],
		              aRw = [0, cst_tokeninfo],
		              aRx = [0, cst_error],
		              aRy = [0, 0],
		              aRz =
		                [0, [0, cst_beta, [0, cst_2$2, [0, cst_contacts_state, 0]]]],
		              aRA = [0, cst_contacts_state$0],
		              aRB = [0, cst_calendars_state$0],
		              aRu = [0, "ConnectionGoogle-delta"],
		              aRM = [0, cst_attendance],
		              aRN = [0, cst_response_status],
		              aRR = [0, cst_operation],
		              aRQ = [0, "attendee-delta"],
		              aRP = [0, cst_state],
		              aRO = [0, cst_t],
		              aRS = [0, cst_availability_override],
		              aRT = [0, cst_google_calendar_id],
		              aRU = [0, cst_daytime],
		              aSf = [0, cst_state],
		              aR$ = [0, cst_writable],
		              aSa = [0, cst_link],
		              aSb = [0, cst_google_event_id],
		              aSc = [0, cst_google_calendar_id],
		              aSd = [0, cst_draft],
		              aSe = [0, cst_creator],
		              aR_ = [0, "event-recurrent-delta"],
		              aR9 = [0, cst_link],
		              aR8 = [0, cst_creator],
		              aR7 = [0, cst_state],
		              aRX = [0, cst_title],
		              aRY = [0, cst_recurrence],
		              aRZ = [0, cst_notes],
		              aR0 = [0, cst_location],
		              aR1 = [0, cst_exceptions],
		              aR2 = [0, cst_description],
		              aR3 = [0, cst_daytime],
		              aR4 = [0, cst_availability_override],
		              aR5 = [0, cst_attendees],
		              aR6 = [0, cst_attendance],
		              aRW = [0, "event-recurrent-writable-delta"],
		              aRV = [0, "date_option"],
		              aSC = [0, cst_writable],
		              aSD = [0, cst_type],
		              aSE = [0, cst_link],
		              aSF = [0, cst_google_event_id],
		              aSG = [0, cst_google_calendar_id],
		              aSH = [0, cst_draft],
		              aSI = [0, cst_creator],
		              aSJ = [0, cst_calendar_status],
		              aSB = [0, "event-delta"],
		              aSA = [0, cst_state],
		              aSz = [0, "slot_type"],
		              aSy = [0, cst_link],
		              aSx = [0, cst_google_calendar_id],
		              aSw = [0, cst_creator],
		              aSv = [0, cst_calendar_status],
		              aSu = [0, cst_state],
		              aSj = [0, cst_title],
		              aSk = [0, cst_time],
		              aSl = [0, cst_task],
		              aSm = [0, cst_notes],
		              aSn = [0, cst_location],
		              aSo = [0, cst_extension_row],
		              aSp = [0, cst_description],
		              aSq = [0, cst_availability_override],
		              aSr = [0, cst_attendees],
		              aSs = [0, cst_attendance],
		              aSt = [0, cst_archived],
		              aSi = [0, "EventRead_for_crdt-delta"],
		              aSh = [0, cst_time],
		              aSg = [0, "task_id_opt"],
		              aSP = [0, cst_state],
		              aSL = [0, 0],
		              aSM = [0, [0, cst_beta, [0, cst_0_google_contacts_other_en, 0]]],
		              aSN = [0, cst_other_enabled$0],
		              aSO = [0, cst_directory_enabled$0],
		              aSK = [0, "Integration_googleAccount-delta"],
		              aSX = [0, cst_status],
		              aSY = [0, cst_databases],
		              aSZ = [0, cst_people],
		              aS0 = [0, cst_imports],
		              aS1 = [0, cst_secret],
		              aS2 = [0, cst_self],
		              aSW = [0, "integration-notion-delta"],
		              aSV = [0, cst_state],
		              aSU = [0, cst_status],
		              aST = [0, "database_element"],
		              aSS = [0, "people_element"],
		              aSR = [0, "import_element"],
		              aSQ = [0, cst_self],
		              aS6 = [0, cst_state],
		              aS5 =
		                [0,
		                 'This field is "hot": it changes regularly as data changes in the\n              third-party integration.'],
		              aS4 = [0, cst_enabled_data_collections],
		              aS3 = [0, "integration-app-delta"],
		              aTi =
		                [0,
		                 [11,
		                  "updated integration configurations are of different type:",
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [18,
		                    [1, [0, [11, cst_2, 0], cst_2]],
		                    [11,
		                     "previous: ",
		                     [15,
		                      [17,
		                       0,
		                       [17,
		                        [0, cst$4, 1, 0],
		                        [18,
		                         [1, [0, [11, cst_2, 0], cst_2]],
		                         [11, "config: ", [15, [17, 0, 0]]]]]]]]]]],
		                 "updated integration configurations are of different type:@ @[<2>previous: %a@]@ @[<2>config: %a@]"],
		              aTh = [0, 0],
		              aTg =
		                [0,
		                 [11, cst_invalid_delta_state_combin, 0],
		                 cst_invalid_delta_state_combin],
		              aTf =
		                [0,
		                 [11, cst_invalid_operation_state_co, 0],
		                 cst_invalid_operation_state_co],
		              aTe =
		                [0,
		                 [11, cst_invalid_operation_state_co, 0],
		                 cst_invalid_operation_state_co],
		              aTd = [0, cst_state],
		              aTb =
		                [0,
		                 "Ignored but it must be a record, otherwise the generated\n            schemas/types are weird and unusable in the front."],
		              aTc = [0, cst_type],
		              aTa = [0, cst_integration_config],
		              match$222 = [0, cst_state],
		              aS8 =
		                [0,
		                 "@deprecated\n                  Integration App now resides at the top-level of the CRDT."],
		              aS9 = [0, cst_integration_app$0],
		              aS_ = [0, cst_notion],
		              aS$ = [0, cst_google],
		              aS7 = [0, "integration-config-delta"],
		              aTv = [0, cst_state],
		              aTt = [0, cst_home],
		              aTu = [0, cst_target],
		              aTs = [0, "Menu_itemMenu_item_crdt-delta"],
		              aTr = [0, "menu-item-compat"],
		              aTk = [0, 0],
		              aTl =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_database_and_agent_menu_ta, 0]]]],
		              aTm = [0, 0],
		              aTn =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_database_and_agent_menu_ta, 0]]]],
		              aTo = [0, 0],
		              aTp =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_3, [0, cst_menu_label_and_org_homepag, 0]]]],
		              aTq = [0, cst_kind],
		              aTj = [0, "menu-item-target-old"],
		              aTC = [0, cst_viewed],
		              aTD = [0, 0],
		              aTE = [0, [0, cst_beta, [0, cst_1, [0, "notice-archived", 0]]]],
		              aTF = [0, cst_archived],
		              aTB = [0, "notice-delta"],
		              aTA = [0, cst_state],
		              aTz = [0, cst_notice],
		              aTy = [0, "notice-item-backward"],
		              aTx = [0, 0],
		              aTw = [0, 0, 0, [9, cst_integration_app_error], 0],
		              aTK = [0, cst_state],
		              aTJ = [0, cst_state],
		              aTH = [0, cst_name],
		              aTI = [0, cst_owner],
		              aTG = [0, "WorkspaceWorkspace_read_crdt-delta"],
		              aTS = [0, cst_state],
		              match$223 = [0, cst_state],
		              aTM = [0, cst_workspaces],
		              aTN = [0, cst_subscription],
		              aTO = [0, cst_owner],
		              aTP = [0, cst_name],
		              aTQ = [0, cst_members_pending],
		              aTR = [0, cst_members],
		              aTL = [0, "organization-delta"],
		              aTY = [0, cst_state],
		              aTU = [0, cst_title],
		              aTV = [0, cst_notes],
		              aTW = [0, cst_extension_row],
		              aTX = [0, cst_archived],
		              aTT = [0, "page-delta"],
		              aTZ = [0, 0],
		              aUe = [0, cst_state],
		              aT8 = [0, cst_stored],
		              aT9 = [0, cst_photo],
		              aT_ = [0, cst_phones],
		              aT$ = [0, cst_other_emails],
		              aUa = [0, cst_organizations],
		              aUb = [0, cst_name],
		              aUc = [0, cst_email],
		              aUd = [0, cst_address],
		              aT7 = [0, "person-delta"],
		              aT6 = [0, "organization_for_fugue"],
		              aT5 = [0, cst_name],
		              aT4 = [0, cst_state],
		              aT1 = [0, cst_extension_row],
		              aT2 = [0, cst_archived],
		              aT3 = [0, cst_notes],
		              aT0 = [0, "person-writable-delta"],
		              aUj = [0, 0, 0],
		              aUi = [0, 0],
		              aUf = [0, cst_archived],
		              aUg = [0, cst_completed],
		              aUh = [0, 0, 0, [9, cst_todo], 0],
		              aUu = [0, cst_templatable],
		              aUv = [0, cst_status],
		              aUw = [0, cst_starred],
		              aUx = [0, cst_scheduled],
		              aUy = [0, cst_parent],
		              aUz = [0, cst_occurrence],
		              aUA = [0, cst_extension_row],
		              aUt = [0, "task-writable-delta"],
		              aUs = [0, cst_state],
		              aUp = [0, cst_url],
		              aUq = [0, cst_title],
		              aUr = [0, cst_notes],
		              aUo = [0, "task-templatable-delta"],
		              aUn = [0, cst_state],
		              aUm = [0, cst_occurrence],
		              aUl = [0, cst_scheduled],
		              aUk = [0, cst_status],
		              aUG = [0, cst_state],
		              aUD = [0, cst_writable],
		              aUE = [0, cst_deleted],
		              aUF = [0, cst_allocations],
		              aUC = [0, "task-delta"],
		              aUB = [0, cst_client_id],
		              aUP = [0, cst_state],
		              aUN = [0, cst_writable],
		              aUO = [0, cst_deleted],
		              aUM = [0, "task-recurrent-delta"],
		              aUL = [0, cst_state],
		              aUI = [0, cst_templatable],
		              aUJ = [0, cst_recurrence],
		              aUK = [0, cst_parent],
		              aUH = [0, "task-recurrent-writable-delta"],
		              aU2 = [0, 0],
		              aU1 = [0, cst_state],
		              aUV = [0, cst_week_start],
		              aUW = [0, cst_mru_people],
		              aUX = [0, cst_mru_destinations],
		              aUY = [0, cst_hours],
		              aUZ = [0, cst_locale],
		              aU0 = [0, cst_access_restriction],
		              aUU = [0, "settings-delta"],
		              aUT = [0, cst_state],
		              aUR = [0, cst_allow_contact_access],
		              aUS = [0, cst_allow_calendar_access],
		              aUQ = [0, "settings-access-delta"],
		              bND = [0, "api/crdt/lib/expert/settings.ml", 337, 9],
		              aU$ = [0, "cell-delta"],
		              aU9 = [0, cst_note],
		              aU_ = [0, cst_record],
		              aU8 = [0, "cell-inner-state"],
		              aU7 = [0, "cell-init"],
		              aU6 =
		                [0,
		                 "Backwards-compatibiliy: The delta schema used to have one less layer of\n        `Array`, so still allow that"],
		              aU5 = [0, cst_state],
		              aU4 = [0, cst_lww],
		              aU3 = [0, "CellCell0Wrapped-delta"],
		              aVf = [0, cst_state],
		              aVb = [0, 0],
		              aVc =
		                [0,
		                 [0, cst_beta, [0, cst_7, [0, cst_read_write_per_field, 0]]]],
		              aVd = [0, cst_data],
		              aVe = [0, cst_schema$0],
		              aVa = [0, "Cell_schema_permission-delta"],
		              aVp = [0, cst_state],
		              aVi = [0, cst_value],
		              aVj = [0, cst_permissions],
		              aVk = [0, cst_name],
		              aVl = [0, cst_description],
		              aVm = [0, 0],
		              aVn = [0, [0, cst_beta, [0, cst_6, [0, cst_gmail_tasks, 0]]]],
		              aVo = [0, cst_computed],
		              aVh = [0, "Cell_schema_fieldCell_schema_field_crdt-delta"],
		              aVg = [0, "cell_schema_field"],
		              aVF = [0, cst_state],
		              aVr = [0, 0],
		              aVs =
		                [0, [0, cst_beta, [0, cst_1, [0, "tables-title-field", 0]]]],
		              aVt = [0, cst_title_field],
		              aVu = [0, 0],
		              aVv =
		                [0,
		                 [0, cst_beta, [0, cst_9, [0, cst_columns_customization, 0]]]],
		              aVw = [0, cst_notes_field],
		              aVx = [0, 0],
		              aVy =
		                [0, [0, cst_beta, [0, cst_2$2, [0, "tables-image-url", 0]]]],
		              aVz = [0, cst_icon],
		              aVA = [0, 0],
		              aVB =
		                [0,
		                 [0, cst_beta, [0, cst_9, [0, cst_columns_customization, 0]]]],
		              aVC = [0, cst_hidden_columns],
		              aVD = [0, cst_emoji],
		              aVE = [0, cst_color],
		              aVq = [0, "MetaMeta_crdt-delta"],
		              aVP = [0, cst_state],
		              aVH = [0, cst_origin],
		              aVI = [0, cst_permissions],
		              aVJ = [0, cst_rows],
		              aVK = [0, cst_schema$0],
		              aVL = [0, cst_meta],
		              aVM = [0, cst_description],
		              aVN = [0, cst_data_name],
		              aVO = [0, cst_name],
		              aVG = [0, "TableTable_crdt-delta"],
		              aV6 = [0, cst_task_binding],
		              aVZ = [0, "Legacy for LWW"],
		              aV0 = [0, 0],
		              aV1 = [0, [0, cst_beta, [0, cst_6, [0, cst_gmail_tasks, 0]]]],
		              aV2 = [0, cst_rows],
		              aV3 = [0, 0],
		              aV4 = [0, [0, cst_beta, [0, cst_6, [0, cst_gmail_tasks, 0]]]],
		              aV5 = [0, cst_config],
		              aVY = [0, "task-binding-delta"],
		              aVX = [0, cst_state],
		              aVR = [0, 0],
		              aVS =
		                [0, [0, cst_beta, [0, cst_4, [0, "task-bindings-stars", 0]]]],
		              aVT = [0, cst_starred],
		              aVU = [0, cst_discarded],
		              aVV = [0, cst_status_changed_at],
		              aVW = [0, cst_scheduling],
		              aVQ = [0, "Task_bindingRow-delta"],
		              aV9 = [0, cst_state],
		              aV8 = [0, cst_enabled],
		              aV7 = [0, "Task_binding_settingsSetting-delta"],
		              aV_ =
		                [0, [11, "add task with id ", [15, 0]], "add task with id %a"],
		              aWb = [0, 0],
		              aWc =
		                [0,
		                 [0, cst_beta, [0, cst_1, [0, cst_workspace_member_role, 0]]]],
		              aWa = [0, "workspace-member-role-delta"],
		              aV$ = [0, cst_delta],
		              aXv = [0, cst_state],
		              aWD = [0, 0],
		              aWE =
		                [0, [0, cst_beta, [0, cst_3, [0, cst_object_hierarchy, 0]]]],
		              aWF = [0, cst_object_hierarchy],
		              aWG = [0, 0],
		              aWH = [0, 0],
		              aWI = [0, cst_tables],
		              aWJ = [0, cst_tasks],
		              aWK = [0, 0],
		              aWL =
		                [0,
		                 [0, cst_beta, [0, cst_1, [0, cst_task_binding_settings, 0]]]],
		              aWM = [0, cst_task_binding_settings],
		              aWN = [0, 0],
		              aWO = [0, [0, cst_beta, [0, cst_0, [0, cst_task_bindings, 0]]]],
		              aWP = [0, cst_task_bindings],
		              aWQ = [0, 0],
		              aWR =
		                [0, [0, cst_beta, [0, cst_1, [0, "subscription-token", 0]]]],
		              aWS = [0, cst_subscription],
		              aWT = [0, cst_settings],
		              aWU = [0, cst_recurrences],
		              aWV = [0, 0],
		              aWW = [0, [0, cst_beta, [0, cst_4, [0, cst_menu_items$0, 0]]]],
		              aWX = [0, cst_menu_items$0],
		              aWY = [0, cst_people],
		              aWZ = [0, cst_pages],
		              aW0 = [0, 0],
		              aW1 = [0, 0],
		              aW2 = [0, cst_organizations],
		              aW3 = [0, 0],
		              aW4 =
		                [0,
		                 [0, cst_beta, [0, cst_1, [0, cst_workspace_member_role, 0]]]],
		              aW5 = [0, cst_notices_personal_viewed],
		              aW6 = [0, 0],
		              aW7 =
		                [0,
		                 [0, cst_beta, [0, cst_1, [0, cst_workspace_member_role, 0]]]],
		              aW8 = [0, cst_notices_personal_archived],
		              aW9 = [0, 0],
		              aW_ = [0, [0, cst_beta, [0, cst_2$2, [0, cst_notices, 0]]]],
		              aW$ = [0, cst_notices],
		              aXa = [0, 0],
		              aXb = [0, 0],
		              aXc = [0, cst_members],
		              aXd = [0, 0],
		              aXe =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, cst_1, [0, cst_workspace_homepage_menu_ta, 0]]]],
		              aXf = [0, cst_home],
		              aXg = [0, cst_hierarchy],
		              aXh = [0, cst_integrations],
		              aXi = [0, 0],
		              aXj =
		                [0,
		                 [0,
		                  cst_beta,
		                  [0, "11", [0, "collaboration-integration-app", 0]]]],
		              aXk = [0, cst_integration_app$0],
		              aXl = [0, cst_events_rec],
		              aXm = [0, cst_events],
		              aXn = [0, 0],
		              aXo = [0, [0, cst_beta, [0, cst_0, [0, cst_client_data$0, 0]]]],
		              aXp = [0, cst_client_data$0],
		              aXq = [0, cst_connections],
		              aXr = [0, cst_calendars],
		              aXs = [0, 0],
		              aXt = [0, [0, cst_beta, [0, cst_1, [0, cst_ai_built_in, 0]]]],
		              aXu = [0, cst_ai],
		              aWC = [0, "crdt-routine-delta"],
		              aWd = [0, 'All the data associated to the "custom-types"'],
		              aWe = [0, "All tasks in this workspace, indexed by id."],
		              aWf =
		                [0,
		                 "Personal settings overrides for task bindings, indexed by id."],
		              aWg = [0, "Task bindings, indexed by id."],
		              aWh = [0, "The settings for this workspace."],
		              aWi =
		                [0, "All recurrent tasks in this workspace, indexed by id."],
		              aWj = [0, "The home object for this workspace"],
		              aWk = [0, "Items menu in the menu"],
		              aWl = [0, "All contacts in this workspace, indexed by id."],
		              aWm = [0, "All pages in this workspace, indexed by id."],
		              aWn =
		                [0,
		                 "The organizations that this account belongs to if this is the user's\n          main workspace"],
		              aWo =
		                [0,
		                 "In a personal workspace, the notices for this user that have been\n          viewed."],
		              aWp =
		                [0,
		                 "In a personal workspace, the notices for this user that have been\n          archived."],
		              aWq = [0, "User notices, indexed by user and notice ID."],
		              aWr = [0, "Most recently used emails and ids."],
		              aWs = [0, "All members of this workspace"],
		              aWt =
		                [0,
		                 "All integration configurations visible in this workspace"],
		              aWu =
		                [0,
		                 "Integration App workspace-level data: data collection templates and\n          enabled data collections"],
		              aWv =
		                [0,
		                 "All recurrent events visible in this workspace, from all calendars."],
		              aWw =
		                [0,
		                 "All events visible in this workspace, from all calendars."],
		              aWx =
		                [0, "Arbitrary JSON values owned by frontend applications."],
		              aWy = [0, "External accounts connections."],
		              aWz = [0, "All calendars visible in this workspace."],
		              aWA = [0, "All AI things."],
		              aWB = [0, cst_mrus],
		              aXA = [0, [11, "remove task ", [15, 0]], "remove task %a"],
		              aXD =
		                [0,
		                 [11, "Todo block already has a task id: ", [15, 0]],
		                 "Todo block already has a task id: %a"],
		              aXC =
		                [0,
		                 [11,
		                  "Recurrent task block already has a recurrent task id: ",
		                  [15, 0]],
		                 "Recurrent task block already has a recurrent task id: %a"],
		              aXB =
		                [0,
		                 [11, cst_recurrent_task_occurrences, 0],
		                 cst_recurrent_task_occurrences],
		              aXz = [0, 1],
		              aXx =
		                [0,
		                 [11,
		                  "patch task ",
		                  [15, [11, " that was edited in document", 0]]],
		                 "patch task %a that was edited in document"],
		              aXy = [0, 0],
		              aXw = [0, "state_utils"],
		              aXN = [0, 0, 0],
		              aXM = [0, 0, 0],
		              aXK = [0, 0, 0, 0],
		              aXL = [0, 0, 0, 0],
		              aXJ =
		                [0,
		                 [11,
		                  "Recurrent task id ",
		                  [15, [11, cst_from_new_block_not_found_r, 0]]],
		                 "Recurrent task id %a from new block not found, recreating it"],
		              aXI = [0, 0, 0, 0],
		              aXH =
		                [0,
		                 [11, cst_changing_task_parent_is_no, 0],
		                 cst_changing_task_parent_is_no],
		              aXG =
		                [0,
		                 [11,
		                  "Task id ",
		                  [15, [11, cst_from_new_block_not_found_r, 0]]],
		                 "Task id %a from new block not found, recreating it"],
		              aXF = [0, 0, 0, 0],
		              aXE =
		                [0,
		                 [11, cst_changing_task_parent_is_no, 0],
		                 cst_changing_task_parent_is_no],
		              aXQ = [0, 0],
		              aXP = [0, 0],
		              aXO =
		                [0,
		                 [11, cst_task_id_already_present_in, 0],
		                 cst_task_id_already_present_in],
		              aXR = [1, -624975627],
		              aXT =
		                [0, "api/crdt/lib/state/events/events_singular.ml", 239, 10],
		              aXS = [0, 0, 0],
		              aXX =
		                [0,
		                 [11, "no such event to update: ", [15, 0]],
		                 "no such event to update: %a"],
		              aXW =
		                [0,
		                 [11, "remove occurrence with date id ", [15, 0]],
		                 "remove occurrence with date id %a"],
		              aXV = [0, 0],
		              aXU =
		                [0,
		                 [11, "recurrent event patch: ", [15, 0]],
		                 "recurrent event patch: %a"],
		              aXY =
		                [0,
		                 [11,
		                  "using potentially incorrect local timezone to update exceptions of ",
		                  [15, 0]],
		                 "using potentially incorrect local timezone to update exceptions of %a"],
		              aXZ = [0, 0],
		              aX1 = [0, 0],
		              aX0 =
		                [0,
		                 [11, cst_task_id_already_present_in, 0],
		                 cst_task_id_already_present_in],
		              aX3 = [0, [11, cst_already_pushing, 0], cst_already_pushing],
		              aX2 = [0, 0, 0],
		              aX5 = [0, "organization-member-full"],
		              aX4 = [0, "full-organization"],
		              match$224 = [0, "for_member"],
		              aYc =
		                [0,
		                 "[true] iff the workspace is some account's personal workspace."],
		              aYb = [0, "full-workspace"],
		              aX8 = [0, "full-workspace-action"],
		              aX9 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Workspace.Action.T.Workspace",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Workspace.Action.T.Workspace@ "],
		              aX_ = [0, [17, 0, [12, 41, 0]], cst$39],
		              aX$ =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Workspace.Action.T.Workspace_data",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Workspace.Action.T.Workspace_data@ "],
		              aYa = [0, [17, 0, [12, 41, 0]], cst$39],
		              aX7 = [0, "workspace-members"],
		              aX6 = [0, cst_workspace_member],
		              aYA = [0, cst_graph_database],
		              aYz = [0, [0, 847309489], 0],
		              aYy = [0, 0],
		              aYx = [0, 0, 0, [9, cst_record], 0],
		              aYv =
		                [0,
		                 "The type of a database. This is isomorphic to {!Row_schema.t}, except for\n    the addition of the [origin] information on fields"],
		              aYw = [0, "database_type"],
		              aYu = [0, "field_with_origin"],
		              aYt = [0, 0],
		              aYr = [0, 0],
		              aYq =
		                [0,
		                 "Field that doesn't exist in the tables, but is added by the\n          controller. It doesn't exist in the schema (so should be filtered out\n          by the front when updating the tables)"],
		              aYs =
		                [0,
		                 "Field backed by an actual column in the table, and an entry in the\n          corresponding row schema"],
		              aYo = [0, "The provenance of a field in a custom type"],
		              aYp = [0, "field_origin"],
		              aYn = [0, 0],
		              aYl = [0, 0],
		              aYj = [0, 0],
		              aYh = [0, 0],
		              aYf = [0, 0],
		              aYe = [0, 0, 0, [9, cst_builtin_type], 0],
		              aYg = [0, 0, 0, [9, cst_internal_builtin_custom_ty], 0],
		              aYi = [0, 0, 0, [9, cst_internal_builtin_type_exte], 0],
		              aYk = [0, 0, 0, [9, cst_integration_app], 0],
		              aYm = [0, 0, 0, [9, cst_user_defined], 0],
		              aYd = [0, cst_origin],
		              match$227 = [0, cst_table],
		              aYT =
		                [0,
		                 "A standalone representation of a table. See {!Row_schema.t} for the\n      meaning of the ['rel] parameter"],
		              match$226 = [0, cst_static],
		              match$225 = [0, cst_row_schema],
		              aYS =
		                [0,
		                 "The schema needed to interpret a [Row.t].\n\n      The parameter ['rel] is eventually supposed to be instantiated with an\n      [Inverse_relations.t], but computing these requires a fixpoint across all\n      the tables, so we first fill it with [()] and only later fill in the field\n      with a meaningful value"],
		              aYR = [0, cst_rows],
		              aYO =
		                [0,
		                 "An inferred parent for organizing the rows as a hierarcy (this is\n            unrelated to the hierarchy of the tables, it's purely user-defined,\n            and any row can be the child of any other row)"],
		              aYP = [0, "The items stored for the row"],
		              aYQ = [0, "The address of the row in the tables"],
		              aYM =
		                [0,
		                 "A row in a table. Contains both the raw content stored in the CRDT and\n      meta-information gathered from the database as a whole"],
		              aYN = [0, cst_row],
		              aYK =
		                [0,
		                 "A element in a [Row.t]. This has more information than a plain [Cell.t] as\n      it also knows its own path"],
		              aYL = [0, cst_item],
		              aYJ = [0, cst_path],
		              aYI = [0, cst_inverse_relations],
		              aYF =
		                [0,
		                 "The desired id and name of the field for the reverse relation"],
		              aYG = [0, "The schema of the original row"],
		              aYH =
		                [0,
		                 "The path to the original [Relation] cell, for getting its value"],
		              aYD =
		                [0, "The representation of the symmetric of a relation cell"],
		              aYE = [0, "inverse_relation"],
		              aYB = [0, "A pointer to a cell anywhere in the database"],
		              aYC = [0, "cell_ref"],
		              aZk = [0, 0],
		              aZi = [0, 0],
		              aZg = [0, 0],
		              aZe = [0, 0],
		              aZc = [0, 0],
		              aZa = [0, 0],
		              aY_ = [0, 0],
		              aY8 = [0, 0],
		              aY6 = [0, 0],
		              aY4 = [0, 0],
		              aY2 = [0, 0],
		              aY1 = [0, 0, 0, [9, cst_ai_automation_run], 0],
		              aY3 = [0, 0, 0, [9, cst_ai_conversation], 0],
		              aY5 = [0, 0, 0, [9, cst_ai_automation$0], 0],
		              aY7 = [0, 0, 0, [9, cst_ai_step], 0],
		              aY9 = [0, 0, 0, [9, cst_ai_agent], 0],
		              aY$ = [0, 0, 0, [9, cst_member], 0],
		              aZb = [0, 0, 0, [9, cst_calendar], 0],
		              aZd = [0, 0, 0, [9, cst_people], 0],
		              aZf = [0, 0, 0, [9, cst_page], 0],
		              aZh = [0, 0, 0, [9, cst_event], 0],
		              aZj = [0, 0, 0, [9, cst_task], 0],
		              aY0 = [0, "table-default-extensions-kind"],
		              aYZ = [0, cst_kind],
		              aYY = [0, "graph-relation-target"],
		              match$228 = [0, "table-object"],
		              aYW =
		                [0,
		                 "The full representation of a table object, _i.e._ a row in a table \xe2\x80\x93 as\n      exported in the graph language \xe2\x80\x93 along with its id (with a schema that\n      keeps the id as a usable record rather than coercing it into a string)"],
		              aYX = [0, cst_object],
		              aYU =
		                [0,
		                 "Similar to [Id.t], but with a schema that keeps the expanded record\n      representation rather than coercing it into a string"],
		              aYV = [0, "table-expanded-object-id"],
		              a0h = [0, 0],
		              a0f = [0, 0],
		              a0d = [0, 0],
		              a0b = [0, 0],
		              aZ$ = [0, 0],
		              aZ9 = [0, 0],
		              aZ7 = [0, 0],
		              aZ5 = [0, 0],
		              aZ3 = [0, 0],
		              aZ2 = [0, 0, 0, [9, cst_recurrence], 0],
		              aZ4 = [0, 0, 0, [9, cst_daytime], 0],
		              aZ6 = [0, 0, 0, [9, cst_date], 0],
		              aZ8 = [0, 0, 0, [9, cst_destination], 0],
		              aZ_ = [0, 0, 0, [9, cst_person], 0],
		              a0a = [0, 0, 0, [9, cst_plan], 0],
		              a0c = [0, 0, 0, [9, cst_postpone], 0],
		              a0e = [0, 0, 0, [9, cst_schedule], 0],
		              a0g = [0, 0, 0, [9, cst_generic], 0],
		              aZZ = [0, 0],
		              aZY = [0, 0],
		              aZ0 = [0, cst_type],
		              aZX = [0, "console-action"],
		              aZ1 = [0, cst_type],
		              match$229 = [0, 0],
		              aZJ = [0, "action_allocation"],
		              match$230 = [0, 0],
		              aZK = [0, "action_time"],
		              match$231 = [0, 2],
		              aZL = [0, "console-action-document"],
		              aZS = [0, 0],
		              aZQ = [0, 0],
		              aZO = [0, 0],
		              aZN = [0, 0, 0, [9, cst_paragraph], 0],
		              aZP = [0, 0, 0, [9, cst_bullet_ordered], 0],
		              aZR = [0, 0, 0, [9, cst_bullet], 0],
		              aZM = [0, "block_type"],
		              aZT = [0, "console-action-task-postponing"],
		              aZU = [0, "console-action-task-recurrence"],
		              aZV = [0, "console-action-task-scheduling"],
		              aZW = [0, "console-action-task-document"],
		              match$232 = [0, 0],
		              match$233 = [0, "console-action-capturable"],
		              aZI = [0, cst_mandate],
		              aZH = [0, "routine-mandate-completions"],
		              aZG = [0, "routine-mandate-priority"],
		              aZD = [0, "A sensible completion helper"],
		              aZE = [0, "The contact main email"],
		              aZF = [0, "The email to invite the contact on"],
		              aZC = [0, "mandate-participant"],
		              aZB = [0, "routine-mandate-label"],
		              aZA = [0, cst_type],
		              aZz = [0, cst_mandate_destination],
		              aZm = [0, "mandate-document"],
		              aZs = [0, [12, 40, [18, [1, [0, 0, cst$1]], 0]], cst$47],
		              aZt = [0, [3, 0, 0], a],
		              aZu = [0, [12, 44, [17, [0, cst$4, 1, 0], 0]], cst$48],
		              aZv = [0, [4, 0, 0, 0, 0], cst_d],
		              aZw = [0, [17, 0, [12, 41, 0]], cst$39],
		              aZn =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              aZo =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aZp = [0, [17, 0, 0], cst$6],
		              aZq = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              aZr =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              aZx = [0, [17, 0, 0], cst$6],
		              aZy = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              aZl = [0, cst_features],
		              a0i = [0, "frequency_bucket"],
		              a0m = [0, cst_document],
		              a0k = [0, 0],
		              a0l = [0, cst_type],
		              a0j = [0, cst_content],
		              a0L = [0, 0],
		              a0G = [0, "Whether the task can be made recurrent."],
		              a0H =
		                [0,
		                 "Whether the task can be moved within the object hierarchy."],
		              a0I = [0, "Whether the task's title can be edited."],
		              a0J = [0, "Whether the task can be deleted by the user."],
		              a0K =
		                [0, "Whether the task can be allocated to a calendar slot."],
		              a0F = [0, "generalized-task"],
		              a0z = [0, 0],
		              a0A = [0, 1],
		              a0B = [0, 1],
		              a0C = [0, 1],
		              a0D = [0, 1],
		              a0E = [0, 1],
		              a0y = [0, "full-task"],
		              a0x = [0, 0, 0],
		              a0w = [0, cst_batch],
		              a0u = [0, "Completed or archived tasks for this day"],
		              a0v = [0, "Uncompleted tasks for this day"],
		              a0t = [0, cst_day],
		              a0s = [0, 0],
		              a0r = [0, 0, 0, [9, cst_native], 0],
		              a0q = [0, "task-context"],
		              a0p = [0, 0],
		              a0o = [0, 0, 0, [9, cst_zapier], 0],
		              a0n = [0, "task-client"],
		              a0Y = [0, 2],
		              a0X = [0, "event-patch"],
		              a0W = [0, cst_type],
		              a0V = [0, "event_or_pause"],
		              a0U = [0, cst_pause],
		              a0T = [0, 0],
		              a0R = [0, 0],
		              a0P = [0, 0],
		              a0O = [0, 0, 0, [9, cst_pause], 0],
		              a0Q = [0, 0, 0, [9, cst_morning], 0],
		              a0S = [0, 0, 0, [9, cst_evening], 0],
		              a0N = [0, "pause_kind"],
		              a0M = [0, "full-event"],
		              a1w = [0, "ai-automation-runs-by-status"],
		              a1v = [0, "ai-automation-patch"],
		              a1t =
		                [0,
		                 "Information about a currently running automation with progress tracking"],
		              a1u = [0, "ai-automation-running"],
		              a1r =
		                [0, "Information about a currently executing automation step"],
		              a1s = [0, "ai-automation-running-step"],
		              a1q = [0, "ai-automation-simple"],
		              a1o = [0, 0],
		              a1p = [0, cst_trigger],
		              a1n = [0, "ai-automation-simple-trigger"],
		              a1m = [0, "ai-automation-simple-pattern"],
		              a1l = [0, "ai-conversation-summary"],
		              match$244 = [0, 0],
		              a1k = [0, "ai-conversation-rich-response"],
		              a1j = [0, "ai-rich-citation"],
		              match$242 = [0, 0],
		              match$243 = [0, 0],
		              a1i = [0, "ai-prompt-options"],
		              a1h = [0, 0],
		              a1f = [0, 0],
		              a1e =
		                [0,
		                 "Eagerly load the small set of tools needed for the mobile demo."],
		              a1g =
		                [0, "Defer tool loading according to each tool's default."],
		              a1d = [0, cst_defer_profile],
		              a1c = [0, 0],
		              a1a = [0, 0],
		              a0_ = [0, 0],
		              a09 =
		                [0,
		                 "The agent never asks; it always makes a best-effort choice and\n            proceeds."],
		              a0$ =
		                [0,
		                 "The agent proceeds on its best interpretation, asking only when it\n            is genuinely blocked."],
		              a1b =
		                [0,
		                 "The agent asks for clarification whenever it would help."],
		              a08 = [0, cst_interactivity],
		              a07 = [0, cst_kind],
		              a06 = [0, "ai-available-integration"],
		              a05 = [0, "ai-available-mcp-server"],
		              match$241 = [0, 0],
		              match$237 = [0, 0],
		              match$238 = [0, 0],
		              match$239 = [0, 0],
		              match$240 = [0, 0],
		              a04 = [0, cst_item],
		              match$235 = [0, 0],
		              match$236 = [0, 0],
		              a03 = [0, cst_integration],
		              match$234 = [0, 0],
		              a02 =
		                [0,
		                 "Configured connections for this integration; empty when none is\n              set up yet."],
		              a01 = [0, "ai-membrane-available-integration"],
		              a00 =
		                [0, 'Membrane connection lifecycle state, e.g. ["READY"].'],
		              a0Z = [0, "ai-membrane-integration-connection"],
		              a1x = [0, 0],
		              a1y = [0, 0],
		              a1z = [0, cst_environment],
		              a1A = [0, "build-channel"],
		              a1C =
		                [0,
		                 [11, cst_API_refused_conflicting_co, 0],
		                 cst_API_refused_conflicting_co],
		              a1D =
		                [0,
		                 [11, cst_workspace_cookie_mismatch, 0],
		                 cst_workspace_cookie_mismatch],
		              a1E =
		                [0,
		                 [11, "Workspace ", [15, [11, cst_not_found, 0]]],
		                 "Workspace %a not found"],
		              a1F =
		                [0,
		                 [11,
		                  "storage write error to ",
		                  [2, 0, [11, cst$9, [2, 0, 0]]]],
		                 "storage write error to %s: %s"],
		              a1G =
		                [0,
		                 [11,
		                  "storage read error to ",
		                  [2, 0, [11, cst$9, [2, 0, 0]]]],
		                 "storage read error to %s: %s"],
		              a1H = [0, [11, "sign in via ", [15, 0]], "sign in via %a"],
		              a1I = [0, [11, cst_fatal_error, [2, 0, 0]], "fatal error: %s"],
		              a1J = [0, [11, "API error: ", [15, 0]], "API error: %a"],
		              a1K =
		                [0,
		                 [11, "IPC ", [3, 0, [11, " payload error: ", [15, 0]]]],
		                 "IPC %S payload error: %a"],
		              a1L =
		                [0,
		                 [11, "Writing to workspace ", [15, [11, " is forbidden", 0]]],
		                 "Writing to workspace %a is forbidden"],
		              a1M = [0, [11, "Forbidden: ", [2, 0, 0]], "Forbidden: %s"],
		              a1N =
		                [0,
		                 [11, "calendar is readonly: ", [15, 0]],
		                 "calendar is readonly: %a"],
		              a1O =
		                [0,
		                 [11, "client must be upgraded to at least version ", [15, 0]],
		                 "client must be upgraded to at least version %a"],
		              a1P =
		                [0,
		                 [11, "AI limits exceeded, will reset at ", [15, 0]],
		                 "AI limits exceeded, will reset at %a"],
		              a1B = [0, [15, [11, " at: ", [2, 0, 0]]], "%a at: %s"],
		              match$245 = [0, 0],
		              match$246 = [0, 0],
		              a1S = [0, "mcp-tool-call-result"],
		              a1R = [0, "mcp-tool-descriptor"],
		              a1Q = [0, "mcp-tool-annotations"],
		              a2g =
		                [0,
		                 "Runtime view of a server for the settings UI: the stored config plus\n      [connection]."],
		              a2h = [0, "external-mcp-status"],
		              a2e = [0, 0],
		              a2f = [0, cst_kind],
		              a2c =
		                [0,
		                 "Outcome of the last connection attempt.\n\n      [Oauth_available] is an anonymous HTTP 401 or 403 whose OAuth discovery\n      succeeded and which this platform can authorize. [Authentication_required]\n      is that same challenge when the flow is not usable. The settings UI offers\n      authorization only for [Oauth_available]."],
		              a2d = [0, "external-mcp-connection"],
		              match$249 = [0, 0],
		              a1$ = [0, "Tools discovered at the last successful connection."],
		              a2a =
		                [0, "Human label, also used to namespace the server's tools."],
		              a2b = [0, "Stable local identifier."],
		              a19 = [0, "A user-configured external MCP server."],
		              a1_ = [0, "external-mcp-server"],
		              a17 =
		                [0,
		                 "A tool discovered on an external MCP server, cached at configuration time\n      so the agent's tool registry can be assembled synchronously (tool\n      execution still contacts the server live)."],
		              a18 = [0, "external-mcp-tool"],
		              a16 = [0, 0],
		              a14 = [0, 0],
		              a13 =
		                [0,
		                 "Expose every tool, including ones that can modify data or act on the\n            open internet."],
		              a15 =
		                [0, "Expose only tools the server annotates as read-only."],
		              a11 =
		                [0,
		                 "Which of a server's tools the agent is allowed to use.\n\n      Arbitrary MCP servers can take destructive, open-world actions on the\n      user's behalf. Rather than a click-through prompt, consent is an enforced\n      boundary: [Read_only] withholds every tool the server does not mark as\n      non-modifying, so the agent {e cannot} invoke it at all. The default is\n      the safe one, [Read_only]; the user opts into [All] per server."],
		              a12 = [0, "external-mcp-trust"],
		              a10 = [0, 0],
		              a1Z = [0, 0, 0, [9, cst_none], 0],
		              a1X =
		                [0,
		                 "Credentials sent when connecting to an external MCP server.\n\n      Secrets are stored locally alongside the rest of the server config; they\n      never leave the machine except in requests to the server itself."],
		              a1Y = [0, "external-mcp-auth"],
		              match$247 = [0, 0],
		              match$248 = [0, 0],
		              a1V =
		                [0,
		                 "How to reach an external MCP server.\n\n      [Http] is the Streamable HTTP transport; [Stdio] spawns a local subprocess\n      and speaks JSON-RPC over its stdin/stdout (desktop-only)."],
		              a1W = [0, "external-mcp-transport"],
		              a1T =
		                [0,
		                 "An environment variable passed to a spawned (stdio) MCP server \xe2\x80\x94 typically\n      how such servers receive their credentials."],
		              a1U = [0, "external-mcp-env-var"],
		              match$250 = [0, 0],
		              match$251 = [0, 0],
		              match$252 = [0, 0],
		              match$253 = [0, 0],
		              match$254 = [0, 0],
		              match$255 = [0, 0],
		              match$256 = [0, 0],
		              a2i = [0, "google_scope"],
		              a2j = [0, "issue"],
		              a2k = [0, "issue-details"],
		              a2m = [0, "The workspace this notice belongs to"],
		              a2l = [0, "full-notice"],
		              a2p = [0, "full-page"],
		              match$257 = [0, 0],
		              a2o = [0, "workspaced-page"],
		              a2n = [0, "page-parent-or-workspace"],
		              match$258 = [0, 1],
		              a2C = [0, "Importance level."],
		              a2D = [0, "Time at which the notification must occur."],
		              a2E = [0, "Plain text message"],
		              a2F = [0, "Structured message."],
		              a2G = [0, "Backlink to the relevant app screen."],
		              a2H = [0, "Unique id."],
		              a2B = [0, cst_notification],
		              a2z = [0, "Generic notification"],
		              a2A = [0, "Event notification"],
		              a2y = [0, "notification-id"],
		              a2x = [0, 0],
		              a2v = [0, 0],
		              a2t = [0, 0],
		              a2s = [0, 0, 0, [9, cst_warning], 0],
		              a2u = [0, 0, 0, [9, cst_info], 0],
		              a2w = [0, 0, 0, [9, cst_error], 0],
		              a2r = [0, "notification-type"],
		              a2q = [0, "notification-chunk"],
		              a3k = [0, "missing_scope_info"],
		              a2_ = [0, "Whether this is the user main profile"],
		              a2$ = [0, "The user email for that identity."],
		              a29 = [0, cst_profile],
		              a3b = [0, 0],
		              a3c = [0, cst_provider],
		              a3a = [0, "profile_kind"],
		              a3e = [0, "Basic user details."],
		              a3f =
		                [0,
		                 "Access scopes to apply when accessing data. May be less permissive\n          than [granted_scopes]."],
		              a3g =
		                [0, "The user login for that identity. Same as the email."],
		              a3h = [0, "Access Scopes granted by the Google token."],
		              a3i = [0, "Contacts synchronization state, if it is enabled."],
		              a3j = [0, "Calendars synchronization state, if it is enabled."],
		              a3d = [0, "profile_google"],
		              a2S = [0, 0],
		              a2Q = [0, 0],
		              a2P = [0, cst_The_account_is_being_migra],
		              a2R = [0, cst_No_local_data_could_be_reu],
		              a2O = [0, cst_login_progress_step],
		              a2W = [0, 0],
		              a2U = [0, cst_The_channel_we_login_to],
		              a2V = [0, cst_Login_is_stalled_waiting_f],
		              a2X = [0, cst_status],
		              a2T = [0, cst_login_status_detail],
		              a2Y = [0, "login_status"],
		              a23 = [0, 0],
		              a21 = [0, 0],
		              a20 = [0, cst_The_account_is_being_migra],
		              a22 = [0, cst_No_local_data_could_be_reu],
		              a2Z = [0, cst_login_progress_step],
		              a27 = [0, 0],
		              a25 = [0, cst_The_channel_we_login_to],
		              a26 = [0, cst_Login_is_stalled_waiting_f],
		              a28 = [0, cst_status],
		              a24 = [0, cst_login_status_detail],
		              a2I = [0, cst_authentication],
		              a2L = [0, 0],
		              a2K = [0, 0],
		              a2M = [0, cst_intention],
		              a2J = [0, "login-intention"],
		              a2N = [0, cst_login],
		              a3l =
		                [0,
		                 "A resolved reference: the actual entity a [Reference_id.t] points at."],
		              a3m = [0, "reference-object"],
		              a3E = [0, 0, 0],
		              a3z = [0, "Tasks with no scheduling"],
		              a3A =
		                [0,
		                 "Tasks scheduled (day or week) for the next 2 months, starting from\n            next week start"],
		              a3B =
		                [0,
		                 "Tasks scheduled for a past day (including earlier this week) or past\n            week"],
		              a3C =
		                [0,
		                 "Tasks scheduled for the week (but {b not} for a specific day)"],
		              a3D =
		                [0,
		                 "Tasks scheduled for today and remaining days of the current week\n            (7-element list, one per weekday, starting at the week start)"],
		              a3x =
		                [0,
		                 "A structured list of tasks for display in the Calendar view.\n\n      A task must not appear in more than 1 field"],
		              a3y = [0, cst_calendar_tasks],
		              a3q =
		                [0, "Upcoming scheduled tasks without a non-past allocation."],
		              a3r = [0, "Tasks without a schedule or non-past allocation."],
		              a3s =
		                [0, "Incomplete tasks scheduled before the requested day."],
		              a3t =
		                [0,
		                 "Tasks scheduled for the requested day with a non-past allocation."],
		              a3u =
		                [0,
		                 "Tasks scheduled for the requested day without a non-past allocation."],
		              a3v = [0, "Tasks completed on the requested day."],
		              a3w = [0, "Tasks archived or ignored on the requested day."],
		              a3p = [0, cst_agenda_tasks],
		              a3n = [0, "inbox-element"],
		              a3o = [0, cst_inbox],
		              a3F =
		                [0,
		                 [0,
		                  "api/controller/lib/http_client/http_client.ml",
		                  15,
		                  301,
		                  333]],
		              a37 = [0, cst_grant_type, "authorization_code"],
		              a34 =
		                [1,
		                 "the authorization response carries neither a code nor an error"],
		              a32 = [0, [11, cst$35, [2, 0, [12, 41, 0]]], " (%s)"],
		              a33 =
		                [0,
		                 [11, "the authorization server refused: ", [2, 0, [2, 0, 0]]],
		                 "the authorization server refused: %s%s"],
		              a35 =
		                [1, "the authorization response answers a different request"],
		              a36 = [1, "the authorization response carries no state"],
		              a30 =
		                [0,
		                 [11,
		                  "the redirect repeats the ",
		                  [3, 0, [11, " parameter", 0]]],
		                 "the redirect repeats the %S parameter"],
		              a31 = [0, 0],
		              a3Z = [0, cst_response_type, cst_code],
		              a3Y = [0, 0],
		              a3X = [0, cst$7],
		              a3T =
		                [1,
		                 "authorization server does not support the S256 code challenge method"],
		              a3U =
		                [1,
		                 'authorization server publishes no "code_challenge_methods_supported"'],
		              a3V = [1, 'authorization server publishes no "token_endpoint"'],
		              a3W =
		                [1,
		                 'authorization server publishes no "authorization_endpoint"'],
		              a3S =
		                [0,
		                 [11,
		                  "the authorization server metadata declares issuer ",
		                  [2, 0, [11, cst_not$0, [2, 0, 0]]]],
		                 "the authorization server metadata declares issuer %s, not %s"],
		              a3R = [0, 0],
		              a3Q =
		                [0,
		                 [11,
		                  "the protected resource metadata describes ",
		                  [2, 0, [11, cst_not$0, [2, 0, 0]]]],
		                 "the protected resource metadata describes %s, not %s"],
		              a3O =
		                [0,
		                 [3, 0, [11, cst_must_be_an_array_of_string, 0]],
		                 cst_S_must_be_an_array_of_stri],
		              a3N =
		                [0,
		                 [3, 0, [11, cst_must_be_an_array_of_string, 0]],
		                 cst_S_must_be_an_array_of_stri],
		              a3P = [0, 0],
		              a3L =
		                [0,
		                 [3, 0, [11, " must be a boolean", 0]],
		                 "%S must be a boolean"],
		              a3M = [0, 0],
		              a3J =
		                [0,
		                 [3, 0, [11, " must be a string", 0]],
		                 "%S must be a string"],
		              a3K = [0, 0],
		              a3I = [0, 0],
		              a3H =
		                [0,
		                 [11, cst_the, [2, 0, [11, " scheme is not https", 0]]],
		                 "the %s scheme is not https"],
		              a3G =
		                [0,
		                 [2,
		                  0,
		                  [11, cst_is_not_a_valid, [2, 0, [11, cst$9, [2, 0, 0]]]]],
		                 "%s is not a valid %s: %s"],
		              a4o = [0, [0, [0, cst_class, cst_markup], 0]],
		              a4p = [0, [0, [0, cst_class, cst_markup], 0]],
		              a4k = [0, [0, [0, cst_class, cst_markup], 0]],
		              a4l = [0, [0, [0, cst_class, "editable-markup"], 0]],
		              a4m = [0, [0, [0, cst_class, cst_markup], 0]],
		              a4n = [0, [0, [0, cst_class, cst_markup], 0]],
		              a4q = [0, [0, [0, cst_class, cst_markup], 0]],
		              a4r = [0, [0, [0, cst_class, cst_markup], 0]],
		              a4f = [0, cst$58, cst_b],
		              a4g = [0, cst$59, cst_code],
		              a4h = [0, cst$52, "em"],
		              a4i = [0, cst$60, cst_s$0],
		              a4j = [0, cst$13, cst_u$0],
		              a4e = [0, [2, cst$36], 0],
		              a4d = [0, [2, cst$37], 0],
		              a4c = [2, cst$18],
		              a4b = [2, cst$16],
		              a3$ = [0, cst$34],
		              a4a = [0, cst_http],
		              a39 = [8, [0, cst$1]],
		              a3_ = [8, [0, cst$1]],
		              a38 = [0, 0],
		              a4s = [0, cst_request],
		              a4t = [0, "graph-view-config-grouping"],
		              a4u = [0, "graph-view-config-sorting"],
		              a4y = [0, 0],
		              a4w = [0, 0],
		              a4v = [0, 0, 0, [9, cst_descending], 0],
		              a4x = [0, 0, 0, [9, cst_ascending], 0],
		              a4A = [0, "view-visible-fields"],
		              a4z = [0, "view-visible-field"],
		              a4D =
		                [0,
		                 "Limit the number of results. If [None], all results are returned"],
		              a4E =
		                [0, "How to sort the data. If [None], the data is not sorted"],
		              match$259 = [0, 0],
		              a4F =
		                [0,
		                 "The groupings applied to the data. Several nestings means nested\n          groupings, the first being the outermost grouping.\n\n          Note that since this happens after the visible fields selection in\n          that language pipeline, only the visible fields can be used for\n          grouping"],
		              a4G =
		                [0,
		                 "The fields that should be returned by the query. If [None], all the\n          fields are returned."],
		              a4H =
		                [0, "Filtering operation applied to the rows of the table"],
		              a4I = [0, "The table from which the data originates"],
		              a4B =
		                [0,
		                 "The configuration for a view, _i.e._ the data required to extract the\n    content of the view from the controller"],
		              a4C = [0, "graph-view-config"],
		              a5c =
		                [0,
		                 "The set of all the columns available in the source table, so that the\n          front can filter based on it"],
		              a5a =
		                [0,
		                 "A view configuration, with some controller hints as to how to expand it"],
		              a5b = [0, "graph-view-with-hints"],
		              a4_ = [0, "graph-view-with-hints-column"],
		              a4$ = [0, "graph-view-with-hints-column-filter"],
		              a45 =
		                [0,
		                 'Whether the column admits a presence test, i.e. "is set" / "is\n                  unset". Note that being unset (null) is different from being\n                  the empty collection.'],
		              a46 =
		                [0, "The available filters on individual elements, if any."],
		              a47 = [0, cst_The_field_holding_the_coll],
		              a48 = [0, "A scalar value."],
		              a49 = [0, cst_kind],
		              a43 =
		                [0,
		                 "Symbolic description of the possible filters that can be applied to a\n        given column"],
		              a44 = [0, "graph-view-with-hints-operation"],
		              a41 = [0, cst_Whether_the_column_admits_],
		              a42 =
		                [0,
		                 "Operators comparing the column against a single value, on top of\n                the set tests."],
		              a4Z =
		                [0,
		                 "A membership test operation - checking if a value is in a list.\n          Currently restricted to checking if a value is in a list of strings."],
		              a40 = [0, "graph-view-with-hints-operation-membership"],
		              a4W =
		                [0,
		                 'Whether the relation admits a presence test, i.e. "is set" / "is\n                unset".'],
		              a4X =
		                [0,
		                 "The table targetted by this relation. Contrary to the\n                {!Atomic.t} case, this doesn't explicitely list the set of\n                possible values so that it can be done lazily by the frontend\n                (as it can be fairly big)"],
		              a4Y = [0, "The set of available operators for that relation"],
		              a4U =
		                [0,
		                 "A filtering on a relation type. This is different from an {!Atomic.t}\n          because the RHS is more specific, and it is treated separately by the\n          backend"],
		              a4V = [0, "graph-view-with-hints-operation-relation"],
		              a4S = [0, cst_Whether_the_column_admits_],
		              a4R = [0, "graph-view-with-hints-operation-atomic"],
		              a4T = [0, "graph-view-with-hints-operation-atomic-comparison"],
		              a4P = [0, 0],
		              a4O = [0, 0],
		              a4N = [0, 0],
		              a4M = [0, 0],
		              a4Q = [0, cst_kind],
		              a4K =
		                [0,
		                 "A representation of a set of values that can be used in a filter"],
		              a4L = [0, "graph-view-with-hints-operation-values"],
		              a4J = [0, cst_error],
		              a5d = [0, cst_Routine],
		              a5e = [0, "The controller component the log originates from"],
		              a5f = [0, "Arbitrary named attributes attached to this log"],
		              a5g = [0, 0, cst$1],
		              a5h = [0, "Do not report this line"],
		              a5j = [0, [15, 0], cst_a],
		              a5i = [0, [11, "exception: ", [15, 0]], "exception: %a"],
		              a5D = [0, 0],
		              a5E = [0, 0],
		              a5F = [0, 0],
		              a5G = [0, 0],
		              a5H = [0, 0],
		              a5I = [0, 0],
		              a5k = [0, 0],
		              a5l = [0, "websocket.notifications.bleeding.routine.co"],
		              a5m = [0, cst_wss],
		              a5n = [0, "bleeding.routine.co"],
		              a5o = [0, cst_https],
		              a5p = [0, 1],
		              a5q = [0, "websocket.notifications.routine.co"],
		              a5r = [0, cst_wss],
		              a5s = [0, "app.routine.co"],
		              a5t = [0, cst_https],
		              a5u = [0, 8081],
		              a5v = [0, "127.0.0.1"],
		              a5w = [0, cst_ws],
		              a5x = [0, 8080],
		              a5y = [0, cst_localhost],
		              a5z = [0, cst_http],
		              a5A = [0, 8000],
		              a5B = [0, cst_localhost],
		              a5C = [0, cst_http],
		              a5J = [0, cst_reason],
		              a5O = [0, cst_api_controller_lib_documen, 397, 8],
		              a5Q = [0, cst_api_controller_lib_documen, 402, 17],
		              a5P = [0, cst_api_controller_lib_documen, 408, 17],
		              a5N =
		                [0,
		                 [11, cst_merge_remote_and_local_doc, 0],
		                 cst_merge_remote_and_local_doc],
		              a5M =
		                [0,
		                 [11, cst_base_and_local_document_ar, 0],
		                 cst_base_and_local_document_ar],
		              a5L =
		                [0,
		                 [11, cst_base_and_remote_document_a, 0],
		                 cst_base_and_remote_document_a],
		              a5K =
		                [0,
		                 [11, "no section '", [2, 0, [11, "' in document", 0]]],
		                 "no section '%s' in document"],
		              a5U = [0, cst_operation],
		              a5T = [0, cst_operation],
		              a5S = [0, cst_op],
		              match$260 = [0, cst_operation],
		              a5R =
		                [0,
		                 "Whether this edition if from a live editor and task instrumentation\n          should be applied"],
		              a5Y =
		                [0,
		                 [15, [12, 32, [15, [12, 32, [4, 3, [0, 2, 4], 0, 0]]]]],
		                 cst_a_a_04i],
		              a5Z = [0, [4, 3, [0, 2, 4], 0, [12, 32, 0]], cst_04i$0],
		              a50 =
		                [0,
		                 [15,
		                  [12,
		                   32,
		                   [4, 3, 0, 0, [11, cst$55, [15, [12, 32, [4, 3, 0, 0, 0]]]]]]],
		                 "%a %i - %a %i"],
		              a51 = [0, [4, 3, [0, 2, 4], 0, [12, 32, 0]], cst_04i$0],
		              a52 =
		                [0,
		                 [15, [12, 32, [4, 3, 0, 0, [11, cst$55, [4, 3, 0, 0, 0]]]]],
		                 cst_a_i_i],
		              a53 =
		                [0,
		                 [15, [12, 32, [4, 3, 0, 0, [11, cst$55, [4, 3, 0, 0, 0]]]]],
		                 cst_a_i_i],
		              a54 = [0, [15, [11, cst_at$0, [15, 0]]], cst_a_at_a],
		              a55 = [0, [15, [11, cst_at$0, [15, 0]]], cst_a_at_a],
		              a5V = [0, 848351644],
		              a5W = [0, 556777215],
		              a5X = [0, 4735457],
		              a56 = [0, 556777215],
		              a57 = [0, 4735232],
		              a58 =
		                [0,
		                 [11, "profile is not Google: ", [15, 0]],
		                 "profile is not Google: %a"],
		              a5_ = [0, 0],
		              a5$ = [0, cst_type],
		              a59 = [0, "effect"],
		              a6a = [0, [0]],
		              a6b = [0, "api/controller/lib/auth_intf.ml", 32, 8],
		              a6c = [0, [0]],
		              a6e = [0, "api/controller/lib/metrics.ml", 82, 2784, 2802],
		              a6d =
		                [0,
		                 [11,
		                  "http error pushing metrics ",
		                  [2, 0, [11, cst$9, [15, 0]]]],
		                 "http error pushing metrics %s: %a"],
		              a6f =
		                [0, [11, "invalid token: ", [2, 0, 0]], "invalid token: %s"],
		              a6m =
		                [0,
		                 [11, cst_fatal_error$0, [2, 0, [11, cst$9, [15, 0]]]],
		                 "fatal error %s: %a"],
		              a6l = [0, 2],
		              opt$11 = [0, 0],
		              a6k =
		                [0,
		                 [11, "shutting down, drop background operation: ", [2, 0, 0]],
		                 "shutting down, drop background operation: %s"],
		              a6n =
		                [0,
		                 "api/controller/lib/controller_offline.ml",
		                 183,
		                 6241,
		                 6284],
		              a6h =
		                [0,
		                 [11, "account error, reauthenticate: ", [15, 0]],
		                 "account error, reauthenticate: %a"],
		              a6j =
		                [0,
		                 [11,
		                  "networking error ",
		                  [2, 0, [11, ", switching to offline mode", 0]]],
		                 "networking error %s, switching to offline mode"],
		              a6i =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   ": waiting for connectivity to come back, will retry in ",
		                   [15, 0]]],
		                 "%s: waiting for connectivity to come back, will retry in %a"],
		              a6g =
		                [0,
		                 [11,
		                  "network operation went through, switching to online mode: ",
		                  [2, 0, 0]],
		                 "network operation went through, switching to online mode: %s"],
		              a6M = [0, 0],
		              a6N =
		                [0, [0, cst_api_controller_lib_control, 459, 15954, 16006]],
		              a6O = [0, 1],
		              a6Q =
		                [0,
		                 [11,
		                  "fetch CRDT updates from server for workspace ",
		                  [15, 0]],
		                 "fetch CRDT updates from server for workspace %a"],
		              a6P =
		                [0,
		                 [11, cst_workspace_cookie_mismatch_, 0],
		                 cst_workspace_cookie_mismatch_],
		              a6R = [0, cst_api_controller_lib_control, 532, 18866, 18894],
		              a6K =
		                [0,
		                 [11,
		                  "exception saving CRDT replica:",
		                  [17, [0, cst$4, 1, 0], [15, 0]]],
		                 "exception saving CRDT replica:@ %a"],
		              a6L = [0, cst_api_controller_lib_control, 380, 13275, 13310],
		              a6I =
		                [0,
		                 [11,
		                  "fatal error saving CRDT replica:",
		                  [17, [0, cst$4, 1, 0], [15, 0]]],
		                 "fatal error saving CRDT replica:@ %a"],
		              a6J =
		                [0, [0, cst_api_controller_lib_control, 369, 12894, 12923]],
		              a6G = [0, cst_api_controller_lib_control, 316, 11017, 11083],
		              a6D = [0, 0],
		              a6E =
		                [0,
		                 [11, cst_could_not_push_commits_to_, 0],
		                 cst_could_not_push_commits_to_],
		              a6F =
		                [0, [0, cst_api_controller_lib_control, 311, 10764, 10797]],
		              a6H = [0, [0, cst_api_controller_lib_control, 271, 8898, 8952]],
		              a6C =
		                [0,
		                 [11,
		                  "ignore sync that would drop commits [",
		                  [4, 3, 0, 0, [12, 45, [4, 3, 0, 0, [12, 93, 0]]]]],
		                 "ignore sync that would drop commits [%i-%i]"],
		              a6B = [0, cst$21],
		              a6A =
		                [0,
		                 [11, cst_waiting_for_CRDT_replica_t, 0],
		                 cst_waiting_for_CRDT_replica_t],
		              a6z = [0, cst_api_controller_lib_control, 204, 6694, 6739],
		              a6x =
		                [0,
		                 [11, cst_personal_workspace_not_fou, 0],
		                 cst_personal_workspace_not_fou],
		              a6y = [0, [0, cst_api_controller_lib_control, 161, 5020, 5051]],
		              a6v = [0, cst_personal_workspace_not_fou],
		              a6w = [0, [0, cst_api_controller_lib_control, 121, 3630, 3658]],
		              a6u = [0, 9943782, "workspace was reset, restart needed"],
		              a6t = [0, cst_replica],
		              a6s = [0, "saved_view"],
		              a6r = [0, 0],
		              a6p = [0, 0],
		              a6o = [0, 0, 0, [9, cst_push], 0],
		              a6q = [0, 0, 0, [9, cst_noop], 0],
		              a6S = [0, 0, 0],
		              a6V =
		                [0,
		                 [11, cst_done_pushing_operations, 0],
		                 cst_done_pushing_operations],
		              a6U = [0, [11, cst_push_operation, 0], cst_push_operation],
		              a6T =
		                [0,
		                 [11, "fatal error pushing operation: ", [15, 0]],
		                 "fatal error pushing operation: %a"],
		              a6W =
		                [0,
		                 [11, cst_start_pushing_operations, 0],
		                 cst_start_pushing_operations],
		              a6X =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_store.ml",
		                  162,
		                  5068,
		                  5106]],
		              a6Y =
		                [0,
		                 [0, "api/controller/lib/controller_devices.ml", 12, 214, 262]],
		              a65 = [0, 0],
		              a63 = [0, 0],
		              a61 = [0, 0],
		              a60 = [0, 0, 0, [9, cst_without_all_day], 0],
		              a62 = [0, 0, 0, [9, cst_with_all_day], 0],
		              a64 = [0, 0, 0, [9, cst_only_all_day], 0],
		              a6Z = [0, "all_day_filter"],
		              a66 =
		                [0,
		                 [11, cst_no_event_with_this_id_to_a, [15, 0]],
		                 cst_no_event_with_this_id_to_a$0],
		              a67 = [0, "api/controller/lib/day.ml", 173, 10],
		              a7h = [1, 0, 0],
		              a7g = [0, 0],
		              a7e = [0, 0],
		              a7d = [0, 0, 0, [9, cst_exclude], 0],
		              a7f = [0, 0, 0, [9, cst_include], 0],
		              a7c = [0, "constraint_kind"],
		              a7b = [0, [11, cst_timeline, [15, 0]], cst_timeline_a],
		              a7a = [0, [11, "days ", [15, 0]], "days %a"],
		              a6$ = [0, [11, cst_day$0, [15, 0]], cst_day_a],
		              a6_ = [0, 0],
		              a69 =
		                [0,
		                 [11,
		                  "drop operation on ",
		                  [15, [11, " as event or calendar disappeared", 0]]],
		                 "drop operation on %a as event or calendar disappeared"],
		              a68 =
		                [0,
		                 [11, cst_no_event_with_this_id_to_a, [15, 0]],
		                 cst_no_event_with_this_id_to_a$0],
		              a7t = [0, "completion_item"],
		              a7q = [0, cst_span$0, 0],
		              a7r = [0, cst_span$0, 0],
		              a7p = [0, [11, "parse ", [3, 0, 0]], "parse %S"],
		              a7s = [0, cst$7],
		              a7o = [0, "mandate_parse_result"],
		              a7n = [1, 0],
		              a7m = [0, 0],
		              a7l = [0, [11, cst_make_parser, 0], cst_make_parser],
		              a7k = [0, 0, 0],
		              a7j = [0, 0],
		              a7i = [0, cst_destination],
		              a7w = [0, cst_routine],
		              a7x = [0, [9, " starts in 10 minutes"], 0],
		              a7v = [0, 0],
		              a7u = [0, 2],
		              a7y =
		                [0,
		                 [11, "no page with this id to append block to: ", [15, 0]],
		                 "no page with this id to append block to: %a"],
		              a7Z = [0, "The text that matched against the query"],
		              a70 = [0, "The title of the object containing the element"],
		              a71 = [0, "The Id of the matching element"],
		              a7X = [0, "An element of the result of a search"],
		              a7Y = [0, "search-result"],
		              a7M =
		                [0,
		                 [18, [1, [0, [11, cst_2, 0], cst_2]], [11, cst$43, 0]],
		                 cst_2$0],
		              a7N =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a7O = [0, [17, 0, 0], cst$6],
		              a7P = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              a7Q =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a7R = [0, [17, 0, 0], cst$6],
		              a7S = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              a7T =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a7U = [0, [17, 0, 0], cst$6],
		              a7V = [0, [17, [0, cst$4, 1, 0], [12, 125, [17, 0, 0]]], cst$46],
		              match$261 = [0, 0],
		              a7W = [0, "search-result-id"],
		              a7z =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Notes {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Notes {@,"],
		              a7A =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a7B = [0, [17, 0, 0], cst$6],
		              a7C = [0, [17, 0, [12, 125, 0]], cst$50],
		              a7D =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11, "Other {", [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Other {@,"],
		              a7E =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a7F = [0, [3, 0, 0], a],
		              a7G = [0, [17, 0, 0], cst$6],
		              a7H = [0, [17, 0, [12, 125, 0]], cst$50],
		              a7K = [0, 0],
		              a7J = [0, 0],
		              a7L = [0, cst_location],
		              a7I = [0, "search-result-location"],
		              a8G = [0, -542431297],
		              a8H = [0, 511974747],
		              a8i = [0, 0],
		              a8g = [0, 0],
		              a8e = [0, 0],
		              a8c = [0, 0],
		              a8a = [0, 0],
		              a7_ = [0, 0],
		              a78 = [0, 0],
		              a76 = [0, 0],
		              a74 = [0, 0],
		              a73 = [0, 0, 0, [9, cst_workspace], 0],
		              a75 = [0, 0, 0, [9, cst_table], 0],
		              a77 = [0, 0, 0, [9, cst_organization], 0],
		              a79 = [0, 0, 0, [9, cst_task_recurrent], 0],
		              a7$ = [0, 0, 0, [9, cst_task], 0],
		              a8b = [0, 0, 0, [9, cst_people], 0],
		              a8d = [0, 0, 0, [9, cst_page], 0],
		              a8f = [0, 0, 0, [9, cst_event_recurrent], 0],
		              a8h = [0, 0, 0, [9, cst_event], 0],
		              a72 = [0, cst_t],
		              a8j =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Controller_search.Document_map.Kind.T.Object {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Controller_search.Document_map.Kind.T.Object {@,"],
		              a8k =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a8l = [0, [17, 0, 0], cst$6],
		              a8m = [0, [12, 59, [17, [0, cst$4, 1, 0], 0]], cst$45],
		              a8n =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a8o = [0, [17, 0, 0], cst$6],
		              a8p = [0, [17, 0, [12, 125, 0]], cst$50],
		              a8q =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Controller_search.Document_map.Kind.T.Agent {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Controller_search.Document_map.Kind.T.Agent {@,"],
		              a8r =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a8s = [0, [17, 0, 0], cst$6],
		              a8t = [0, [17, 0, [12, 125, 0]], cst$50],
		              a8u =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Controller_search.Document_map.Kind.T.Automation {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Controller_search.Document_map.Kind.T.Automation {@,"],
		              a8v =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a8w = [0, [17, 0, 0], cst$6],
		              a8x = [0, [17, 0, [12, 125, 0]], cst$50],
		              a8y =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Controller_search.Document_map.Kind.T.Conversation {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Controller_search.Document_map.Kind.T.Conversation {@,"],
		              a8z =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a8A = [0, [17, 0, 0], cst$6],
		              a8B = [0, [17, 0, [12, 125, 0]], cst$50],
		              a8C =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Controller_search.Document_map.Kind.T.Automation_run {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Controller_search.Document_map.Kind.T.Automation_run {@,"],
		              a8D =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              a8E = [0, [17, 0, 0], cst$6],
		              a8F = [0, [17, 0, [12, 125, 0]], cst$50],
		              a8J =
		                [0,
		                 [11, "no task with this id to append block to: ", [15, 0]],
		                 "no task with this id to append block to: %a"],
		              a8I = [0, 0, 0],
		              a8K =
		                [0,
		                 [11,
		                  "no recurrent task with this id to append block to: ",
		                  [15, 0]],
		                 "no recurrent task with this id to append block to: %a"],
		              a8Q = [0, 0],
		              a8O = [0, 0],
		              a8N = [0, "Contact list."],
		              a8P = [0, "Calendaring and events."],
		              a8L = [0, "A feature that can be provided by a profile."],
		              a8M = [0, "profile_feature"],
		              a8V =
		                [0,
		                 [11, cst_There_is_already_a_Routine, 0],
		                 cst_There_is_already_a_Routine],
		              a8T =
		                [0,
		                 [11, "unlinked account does not exist: ", [15, 0]],
		                 "unlinked account does not exist: %a"],
		              a8U = [0, 9943782, "Main Google account cannot be unlinked"],
		              a8S =
		                [0,
		                 [11, "Controller.requestScopes ", [15, [12, 32, [15, 0]]]],
		                 "Controller.requestScopes %a %a"],
		              a8R =
		                [0,
		                 [11, cst_controller_Auth_deleteAccc, 0],
		                 cst_controller_Auth_deleteAccc],
		              a87 = [0, [11, cst_set_home, 0], cst_set_home],
		              a84 = [0, [11, cst_toggle_remove, 0], cst_toggle_remove],
		              a85 = [0, [11, cst_toggle_append, 0], cst_toggle_append],
		              a86 = [0, cst_toggle],
		              a83 = [0, cst_remove],
		              a82 = [0, cst_append],
		              a81 = [0, cst_replace],
		              a80 = [0, [2, 0, 0], cst_s],
		              a8Z =
		                [0,
		                 [11, cst_no_home_setting_the_first_, 0],
		                 cst_no_home_setting_the_first_],
		              a8Y = [0, [11, cst_list, 0], cst_list],
		              a8X = [0, [11, cst_set, 0], cst_set],
		              a8W = [0, "all-menu-items"],
		              a9h = [0, cst_home],
		              a9i = [0, 0],
		              a9g = [0, 0],
		              a9e = [0, cst_name],
		              a9f = [0, 0],
		              a9d = [0, [0, cst_api_controller_lib_workspa, 187, 6319, 6347]],
		              a9c = [0, "member_role"],
		              a9a =
		                [0,
		                 [11, "missing personal workspace ", [15, 0]],
		                 "missing personal workspace %a"],
		              a9b = [0, [0, cst_api_controller_lib_workspa, 120, 4266, 4295]],
		              a8_ =
		                [0,
		                 [11,
		                  cst_workspace$0,
		                  [15,
		                   [11, cst_found_in_multiple_organiza, [15, [11, b, [15, 0]]]]]],
		                 cst_workspace_a_found_in_multi],
		              a8$ = [0, [0, cst_api_controller_lib_workspa, 99, 3517, 3540]],
		              a88 =
		                [0,
		                 [11,
		                  cst_workspace$0,
		                  [15,
		                   [11, cst_found_in_multiple_organiza, [15, [11, b, [15, 0]]]]]],
		                 cst_workspace_a_found_in_multi],
		              a89 = [0, [0, cst_api_controller_lib_workspa, 12, 314, 337]],
		              a9n = [0, cst_t],
		              a9m =
		                [1, [0, 9943782, "Cannot remove todo from object documents"]],
		              a9k =
		                [0,
		                 [11,
		                  "found more than one matching block task ",
		                  [15, [11, cst_in$0, [15, 0]]]],
		                 "found more than one matching block task %a in %a"],
		              a9l =
		                [0,
		                 [11,
		                  "could not find block corresponding to ",
		                  [15, [11, cst_in$0, [15, [11, "'s document", 0]]]]],
		                 "could not find block corresponding to %a in %a's document"],
		              a9j =
		                [0,
		                 [11, cst_append_on_object_does_noth, 0],
		                 cst_append_on_object_does_noth],
		              a9o = [0, [11, cst_get, [15, 0]], cst_get_a],
		              a9u = [0, [11, cst_inbox, 0], cst_inbox],
		              a9q =
		                [0,
		                 [11, cst_background_stop_polling, 0],
		                 cst_background_stop_polling],
		              a9p =
		                [0,
		                 [11, cst_foreground_resume_polling, 0],
		                 cst_foreground_resume_polling],
		              a_T = [0, [11, cst_archived$0, 0], cst_archived$0],
		              a_U = [0, [2, 0, 0], cst_s],
		              a_V = [0, [11, cst_Contact, 0], cst_Contact],
		              a_W = [0, [11, cst_unarchived, 0], cst_unarchived],
		              a_X = [0, [2, 0, 0], cst_s],
		              a_Y = [0, [11, cst_Contact, 0], cst_Contact],
		              a_Z = [0, [11, cst_saved, 0], cst_saved],
		              a_0 = [0, [2, 0, 0], cst_s],
		              a_1 = [0, [11, cst_Contact, 0], cst_Contact],
		              a_S = [0, [11, cst_moved_to, 0], cst_moved_to],
		              a_Q = [0, cst_recurrence],
		              a_R =
		                [0,
		                 [11, cst_s_recurrence_was_stopped, 0],
		                 cst_s_recurrence_was_stopped],
		              a_N = [0, cst_recurrence],
		              a_O = [0, [2, 0, 0], cst_s],
		              a_P = [0, [11, cst_edited_to_recur, 0], cst_edited_to_recur],
		              a_L = [0, [11, cst_deleted$0, 0], cst_deleted$0],
		              a_M = [0, [2, 0, 0], cst_s],
		              a_J = [0, cst_archived],
		              a_K = [0, [9, cst_restored], 0],
		              a_H = [0, cst_archived],
		              a_I = [0, [9, cst_archived$0], 0],
		              a_G = [0, cst_title],
		              a_E = [0, [9, "New page created"], 0],
		              a_F = [0, [9, " created"], 0],
		              a_p = [0, cst_archived],
		              a_q = [0, [9, cst_archived$0], 0],
		              a_r = [0, cst_archived],
		              a_s = [0, [9, cst_restored], 0],
		              a_t = [0, cst_ignored],
		              a_u = [0, [9, cst_ignored$0], 0],
		              a_v = [0, cst_ignored],
		              a_w = [0, [9, cst_unignored], 0],
		              a_x = [0, cst_time],
		              a_y = [0, [15, 0], cst_a],
		              a_z = [9, cst_moved_to],
		              a_A = [0, [15, 0], cst_a],
		              a_B = [9, " resized to "],
		              a_C = [0, cst_unknown],
		              a_D = [0, [9, cst_edited], 0],
		              a_l = [0, cst_attendance],
		              a_m = [9, cst_to],
		              a_n = [0, [15, 0], cst_a],
		              a_o = [9, "Responded "],
		              a_k = [0, [9, " moved"], 0],
		              a_i = [0, "completion"],
		              a_j = [0, [9, cst_completed$0], 0],
		              a_g = [0, [15, 0], cst_a],
		              a_h = [9, " created on "],
		              a_e = [0, [9, " renamed "], 0],
		              a_f = [0, [9, cst_edited], 0],
		              a_d = [0, [9, " stopped"], 0],
		              a_c = [0, [9, cst_deleted$0], 0],
		              a_b = [0, cst_content],
		              a9$ = [0, [11, cst_deleted$0, 0], cst_deleted$0],
		              a_a = [0, [2, 0, 0], cst_s],
		              a9X = [0, [11, cst_completed$0, 0], cst_completed$0],
		              a9Y = [0, [11, cst_restored, 0], cst_restored],
		              a9Z = [0, [11, cst_ignored$0, 0], cst_ignored$0],
		              a90 = [0, [11, cst_unignored, 0], cst_unignored],
		              a91 = [0, cst_planned],
		              a92 = [0, [15, 0], cst_a],
		              a93 = [0, [11, cst_postponed_to, 0], cst_postponed_to],
		              a94 = [0, [15, 0], cst_a],
		              a95 = [0, [12, 32, [2, 0, [11, cst_for$0, 0]]], " %s for "],
		              a96 = [0, [11, cst_unpostponed, 0], cst_unpostponed],
		              a97 = [0, [11, cst_unscheduled, 0], cst_unscheduled],
		              a98 = [0, [12, 32, [2, 0, 0]], " %s"],
		              a99 = [0, [11, cst_Task_renamed_to, 0], cst_Task_renamed_to],
		              a9_ = [0, [11, cst_saved, 0], cst_saved],
		              a9W = [0, [11, cst_moved_to, 0], cst_moved_to],
		              a9T = [0, cst_planned],
		              a9U = [0, [15, 0], cst_a],
		              a9V = [0, [11, cst_scheduled_for, 0], cst_scheduled_for],
		              a9R = [0, [2, 0, 0], cst_s],
		              a9S = [0, [11, cst_will_recur, 0], cst_will_recur],
		              a9J = [0, [15, 0], cst_a],
		              a9K =
		                [0,
		                 [11, cst_created_and_scheduled_for, 0],
		                 cst_created_and_scheduled_for],
		              a9L = [0, [15, 0], cst_a],
		              a9M =
		                [0,
		                 [11, cst_created_and_postponed_to, 0],
		                 cst_created_and_postponed_to],
		              a9N = [0, [15, 0], cst_a],
		              a9O =
		                [0,
		                 [11, cst_created_and_scheduled_for, 0],
		                 cst_created_and_scheduled_for],
		              a9P = [9, " created in "],
		              a9Q = [9, " saved in "],
		              a9v = [0, [11, cst_an_event, 0], cst_an_event],
		              a9w = [0, [11, cst_an_event, 0], cst_an_event],
		              a9x = [0, [11, cst_a_page, 0], cst_a_page],
		              a9y = [0, [11, cst_a_task, 0], cst_a_task],
		              a9z = [0, [11, cst_a_task, 0], cst_a_task],
		              a9A = [0, [11, cst_a_recurrent_task, 0], cst_a_recurrent_task],
		              a9B = [0, [11, cst_an_object, 0], cst_an_object],
		              a9C = [0, [11, cst_an_organization, 0], cst_an_organization],
		              a9D = [0, [11, cst_a_table, 0], cst_a_table],
		              a9E = [0, [11, cst_a_workspace, 0], cst_a_workspace],
		              a9F = [0, [11, cst_an_agent, 0], cst_an_agent],
		              a9G = [0, [11, cst_an_automation, 0], cst_an_automation],
		              a9H = [0, [11, cst_a_conversation, 0], cst_a_conversation],
		              a9I = [0, [11, cst_an_automation_run, 0], cst_an_automation_run],
		              a_2 = [1, [0, 9943782, "no primary active calendar found."]],
		              a_3 = [0, [11, cst_patch, 0], cst_patch],
		              a__ =
		                [0,
		                 [11, cst_allocation_failed, [2, 0, 0]],
		                 cst_allocation_failed_s],
		              a_$ = [0, 2],
		              a_9 =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_allocations.ml",
		                  177,
		                  6566,
		                  6605]],
		              a_8 = [0, 0],
		              a_6 = [0, 0],
		              a_7 = [0, 1],
		              a_5 =
		                [0,
		                 [11, "ignoring Google event: ", [15, 0]],
		                 "ignoring Google event: %a"],
		              a_4 =
		                [0,
		                 [11,
		                  "ignoring calendar constraints for Google event: ",
		                  [2, 0, 0]],
		                 "ignoring calendar constraints for Google event: %s"],
		              a$x =
		                [0,
		                 [11, cst_user_cancelled_the_action, 0],
		                 cst_user_cancelled_the_action],
		              a$v = [0, [11, cst_update$0, [15, 0]], cst_update_a],
		              a$w = [0, [11, cst_no_such_task, [15, 0]], cst_no_such_task_a],
		              a$u = [0, [11, cst_upcoming, 0], cst_upcoming],
		              a$t =
		                [0,
		                 [11, cst_refusing_to_delete_integra, 0],
		                 cst_refusing_to_delete_integra],
		              a$s = [0, [11, cst_delete$0, [15, 0]], cst_delete_a],
		              a$r = [0, [11, "orphan task ", [15, 0]], "orphan task %a"],
		              a$l = [0, 9943782, "failed to load previous parent's content"],
		              a$k =
		                [0,
		                 [11, "could not append block to ", [15, 0]],
		                 "could not append block to %a"],
		              a$m = [0, [11, cst_no_such_task, [15, 0]], cst_no_such_task_a],
		              a$j = [0, [11, cst_move, 0], cst_move],
		              a$n = [0, 0],
		              a$o = [0, [2, 0, 0], cst_s],
		              a$p = [0, 2],
		              a$q = [0, 0],
		              a$f =
		                [0,
		                 [11, cst_allocation_failed, [2, 0, 0]],
		                 cst_allocation_failed_s],
		              a$g = [0, 2],
		              a$h = [0, [15, 0], cst_a],
		              a$i = [0, [0, "api/controller/lib/tasks.ml", 255, 8470, 8495]],
		              a$e = [0, [11, cst_create, 0], cst_create],
		              a$d = [0, [11, cst_batch$0, [15, 0]], cst_batch_a],
		              a$c = [0, [11, cst_day$0, [15, 0]], cst_day_a],
		              a$a = [0, [11, cst_allocate, [15, 0]], "allocate %a"],
		              a$b = [0, [11, cst_no_such_task, [15, 0]], cst_no_such_task_a],
		              a$D =
		                [0, [11, cst_Tasks_recurrent_all, 0], cst_Tasks_recurrent_all],
		              a$B =
		                [0,
		                 [0, "api/controller/lib/tasks_recurrent.ml", 90, 2911, 2939]],
		              a$A = [0, [11, cst_update$0, [15, 0]], cst_update_a],
		              a$C =
		                [0,
		                 [11, "no such recurrent task: ", [15, 0]],
		                 "no such recurrent task: %a"],
		              a$z = [0, [11, cst_delete$0, [15, 0]], cst_delete_a],
		              a$y = [0, [11, cst_create, 0], cst_create],
		              a$O = [0, 1],
		              a$P = [0, 0],
		              a$Q = [0, 0],
		              a$N = [0, [11, "set default: ", [15, 0]], "set default: %a"],
		              a$M = [0, [11, cst_patch$0, [15, 0]], cst_patch_a],
		              a$K =
		                [0,
		                 [11, "force refresh of calendars for ", [15, 0]],
		                 "force refresh of calendars for %a"],
		              a$L = [0, 1],
		              a$J = [0, 0],
		              a$I = [0, [11, cst_get_default, 0], cst_get_default],
		              a$H = [0, [11, cst_get_default, 0], cst_get_default],
		              a$G = [0, [11, cst_get, [15, 0]], cst_get_a],
		              a$E =
		                [0,
		                 [11, "calendar or connection not found: ", [15, 0]],
		                 "calendar or connection not found: %a"],
		              a$F = [0, [0, "api/controller/lib/calendars.ml", 17, 498, 521]],
		              a$U = [0, 9943782, cst_Workspace_not_found],
		              a$T = [0, 9943782, cst_Conversation_not_found],
		              a$S = [0, 9943782, cst_Workspace_not_found],
		              a$R = [0, 9943782, cst_Agent_not_found],
		              opt$12 = [0, 0],
		              baa =
		                [0,
		                 [11, "future_notifications limit=", [4, 0, 0, 0, 0]],
		                 "future_notifications limit=%d"],
		              a$$ = [0, [11, "publish ", [15, 0]], "publish %a"],
		              a$5 =
		                [0,
		                 [11,
		                  "Trying to move the event to a non-existing calendar ",
		                  [15, 0]],
		                 "Trying to move the event to a non-existing calendar %a"],
		              a$6 =
		                [0, [0, cst_api_controller_lib_events_, 316, 10702, 10733]],
		              a$9 =
		                [0,
		                 [11, cst_connection_not_found, [15, 0]],
		                 cst_connection_not_found_a],
		              a$_ =
		                [0, [0, cst_api_controller_lib_events_, 328, 11176, 11205]],
		              a$7 =
		                [0,
		                 [11, cst_connection_not_found, [15, 0]],
		                 cst_connection_not_found_a],
		              a$8 =
		                [0, [0, cst_api_controller_lib_events_, 337, 11529, 11558]],
		              a$4 = [0, [11, cst_move$0, [15, 0]], cst_move_a],
		              a$1 = [0, [11, cst_create_event, 0], cst_create_event],
		              a$2 =
		                [0,
		                 [11, "calendar not found: ", [15, 0]],
		                 "calendar not found: %a"],
		              a$3 = [0, [0, cst_api_controller_lib_events_, 245, 8166, 8191]],
		              a$0 = [0, [11, cst_update, 0], cst_update],
		              a$Z = [0, [11, cst_set_will_attend, 0], cst_set_will_attend],
		              a$Y = [0, [11, cst_delete$0, [15, 0]], cst_delete_a],
		              a$X = [0, [11, cst_allocate, [3, 0, 0]], "allocate %S"],
		              a$W = [0, [11, "with_attendees ", [15, 0]], "with_attendees %a"],
		              a$V = [0, [11, "complete ", [15, 0]], "complete %a"],
		              bar = [0, 0],
		              bas = [1, -964225672],
		              baq = [0, [2, 0, 0], cst_s],
		              ban =
		                [0,
		                 [11, cst_could_not, [2, 0, [11, ", missing workspace", 0]]],
		                 "could not %s, missing workspace"],
		              bao =
		                [0,
		                 [11,
		                  cst_could_not,
		                  [2, 0, [11, ", insufficient permissions", 0]]],
		                 "could not %s, insufficient permissions"],
		              bam =
		                [0,
		                 [11,
		                  cst_could_not,
		                  [2, 0, [11, ", name for self not found", 0]]],
		                 "could not %s, name for self not found"],
		              bap =
		                [0,
		                 [11, cst_could_not, [2, 0, [11, c, [15, 0]]]],
		                 "could not %s, %a"],
		              bal = [0, "notice-filter"],
		              bak = [0, 0],
		              bai = [0, 0],
		              bah = [0, 0, 0, [9, cst_unarchived$0], 0],
		              baj = [0, 0, 0, [9, cst_archived], 0],
		              bag = [0, "archived_filter"],
		              baf = [0, 0],
		              bad = [0, 0],
		              bac = [0, 0, 0, [9, cst_unviewed], 0],
		              bae = [0, 0, 0, [9, cst_viewed], 0],
		              bab = [0, "viewed_filter"],
		              bat = [0, "page-hierarchy"],
		              baN = [0, [11, cst_no_such_page, [15, 0]], cst_no_such_page_a],
		              baM = [0, [11, cst_update$0, [15, 0]], cst_update_a],
		              baO = [0, 0],
		              baK = [0, cst_api_controller_lib_pages_m, 279, 9431, 9466],
		              baL =
		                [0,
		                 [11,
		                  "unable to unarchive ",
		                  [15, [11, ": page does not exist", 0]]],
		                 "unable to unarchive %a: page does not exist"],
		              baJ = [0, [11, cst_unarchive, [15, 0]], cst_unarchive_a],
		              baH = [0, [11, cst_no_such_page, [15, 0]], cst_no_such_page_a],
		              baG = [0, [11, cst_move$0, [15, 0]], cst_move_a],
		              baI = [0, 0],
		              baE =
		                [0,
		                 [11,
		                  cst_page$0,
		                  [15, [11, " not found, cannot delete it", 0]]],
		                 "page %a not found, cannot delete it"],
		              baD = [0, cst_api_controller_lib_pages_m, 179, 5764, 5799],
		              baF =
		                [0,
		                 [11, cst_page$0, [15, [11, cst_not_found, 0]]],
		                 "page %a not found"],
		              baC = [0, [11, cst_delete$0, [15, 0]], cst_delete_a],
		              baz =
		                [0,
		                 [11, "create page in ", [15, [11, " under ", [15, 0]]]],
		                 "create page in %a under %a"],
		              baA = [0, [0, cst_api_controller_lib_pages_m, 122, 4057, 4087]],
		              baB = [0, cst_api_controller_lib_pages_m, 143, 4664, 4697],
		              baw = [0, [11, "archive ", [15, 0]], "archive %a"],
		              bax = [0, cst_api_controller_lib_pages_m, 100, 3292, 3327],
		              bay = [0, [11, cst_no_such_page, [15, 0]], cst_no_such_page_a],
		              bau =
		                [0,
		                 [11,
		                  cst_workspace$0,
		                  [15, [11, cst_not_found_ignoring, [2, 0, 0]]]],
		                 cst_workspace_a_not_found_igno],
		              bav =
		                [0,
		                 [11,
		                  cst_workspace$0,
		                  [15, [11, cst_not_found_ignoring, [2, 0, 0]]]],
		                 cst_workspace_a_not_found_igno],
		              baP = [0, [11, cst_update$0, [15, 0]], cst_update_a],
		              baR = [0, 0],
		              baS = [0, "error_kind"],
		              baQ = [0, "upsert_database_error"],
		              baT =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "Controller_graph_intf.Duplicate_data_name {",
		                   [17, [0, cst$5, 0, 0], 0]]],
		                 "@[<2>Controller_graph_intf.Duplicate_data_name {@,"],
		              baU =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [2, 0, [11, cst$44, [17, [0, cst$4, 1, 0], 0]]]],
		                 cst_s$2],
		              baV = [0, [3, 0, 0], a],
		              baW = [0, [17, 0, 0], cst$6],
		              baX = [0, [17, 0, [12, 125, 0]], cst$50],
		              baY =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Controller_graph_intf.Workspace_not_found",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Controller_graph_intf.Workspace_not_found@ "],
		              baZ = [0, [17, 0, [12, 41, 0]], cst$39],
		              ba0 =
		                [0,
		                 [12,
		                  40,
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    "Controller_graph_intf.Workspace_write_forbidden",
		                    [17, [0, cst$4, 1, 0], 0]]]],
		                 "(@[<2>Controller_graph_intf.Workspace_write_forbidden@ "],
		              ba1 = [0, [17, 0, [12, 41, 0]], cst$39],
		              ba_ = [0, 0],
		              ba8 = [0, 0],
		              ba7 = [0, 0],
		              ba6 = [0, 0],
		              ba5 = [0, 0],
		              ba4 = [0, 0],
		              ba9 = [0, 0],
		              ba$ = [0, 1],
		              bba = [0, 9943782, "missing workspace id"],
		              ba3 =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_graph/controller_graph.ml",
		                  1934,
		                  75418,
		                  75466]],
		              ba2 = [0, [11, "Query ", [15, [10, 0]]], "Query %a%!"],
		              bbe = [0, 0],
		              bbb =
		                [0,
		                 [11,
		                  cst_RPC,
		                  [2,
		                   0,
		                   [11,
		                    " called with invalid argument for ",
		                    [2, 0, [11, cst$9, [15, 0]]]]]],
		                 "RPC %s called with invalid argument for %s: %a"],
		              bbc =
		                [0,
		                 [11,
		                  cst_RPC,
		                  [2,
		                   0,
		                   [11,
		                    " called with missing argument ",
		                    [2, 0, [11, " with schema ", [15, 0]]]]]],
		                 "RPC %s called with missing argument %s with schema %a"],
		              bbd =
		                [0,
		                 [11,
		                  cst_RPC,
		                  [2, 0, [11, " called with too many arguments", 0]]],
		                 "RPC %s called with too many arguments"],
		              bbF =
		                [0,
		                 [11,
		                  "receive:",
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]]],
		                 "receive:@ @[%a@]"],
		              bbE =
		                [0,
		                 [11,
		                  "send:",
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [18, [1, [0, 0, cst$1]], [15, [17, 0, 0]]]]],
		                 "send:@ @[%a@]"],
		              bbC = [0, 95, [0, 45, [0, 46, [0, 39, [0, 36, 0]]]]],
		              bbD = [0, cst$1],
		              bbA =
		                [0,
		                 [11,
		                  cst_RPC,
		                  [2,
		                   0,
		                   [11, cst_error_on_channel, [15, [11, cst$9, [2, 0, 0]]]]]],
		                 cst_RPC_s_error_on_channel_a_s],
		              bbB =
		                [0, [0, cst_api_controller_lib_rpc_ml, 1091, 39065, 39090]],
		              bby =
		                [0,
		                 [11,
		                  cst_RPC,
		                  [2,
		                   0,
		                   [11, cst_error_on_channel, [15, [11, cst$9, [2, 0, 0]]]]]],
		                 cst_RPC_s_error_on_channel_a_s],
		              bbz =
		                [0, [0, cst_api_controller_lib_rpc_ml, 1069, 38273, 38298]],
		              bbx =
		                [0,
		                 [11,
		                  "discard var ",
		                  [2,
		                   0,
		                   [11, " update on channel ", [15, [11, cst$9, [2, 0, 0]]]]]],
		                 "discard var %s update on channel %a: %s"],
		              bbw =
		                [0,
		                 [11,
		                  "discard hook ",
		                  [2,
		                   0,
		                   [11, " trigger on channel ", [15, [11, cst$9, [2, 0, 0]]]]]],
		                 "discard hook %s trigger on channel %a: %s"],
		              bbt =
		                [0,
		                 [18,
		                  [1, [0, 0, cst$1]],
		                  [18,
		                   [1, [0, [11, cst_2, 0], cst_2]],
		                   [11,
		                    cst_RPC_decoding_response_to,
		                    [2,
		                     0,
		                     [11,
		                      cst_on_channel,
		                      [15,
		                       [12,
		                        58,
		                        [17,
		                         [0, cst$4, 1, 0],
		                         [15,
		                          [17,
		                           0,
		                           [17,
		                            [0, cst$4, 1, 0],
		                            [18,
		                             [1, [0, [11, cst_2, 0], cst_2]],
		                             [11,
		                              cst_schema,
		                              [17,
		                               [0, cst$4, 1, 0],
		                               [15,
		                                [17,
		                                 0,
		                                 [17,
		                                  [0, cst$4, 1, 0],
		                                  [18,
		                                   [1, [0, [11, cst_2, 0], cst_2]],
		                                   [11,
		                                    "value:",
		                                    [17,
		                                     [0, cst$4, 1, 0],
		                                     [18, [1, [0, 0, cst$1]], [15, [17, 0, [17, 0, [17, 0, 0]]]]]]]]]]]]]]]]]]]]]]]]],
		                 "@[@[<2>RPC: decoding response to %s on channel %a:@ %a@]@ @[<2>schema:@ %a@]@ @[<2>value:@ @[%a@]@]@]"],
		              bbu =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   cst_RPC_decoding_response_to,
		                   [2,
		                    0,
		                    [11,
		                     cst_on_channel,
		                     [15, [12, 58, [17, [0, cst$4, 1, 0], [15, [17, 0, 0]]]]]]]]],
		                 "@[<2>RPC: decoding response to %s on channel %a:@ %a@]"],
		              bbv = [0, [0, cst_api_controller_lib_rpc_ml, 913, 32322, 32359]],
		              bbp =
		                [0,
		                 [11, "no handler found for channel ", [15, 0]],
		                 "no handler found for channel %a"],
		              bbn =
		                [0,
		                 [11,
		                  "no such callback on channel ",
		                  [15, [11, cst$9, [2, 0, 0]]]],
		                 "no such callback on channel %a: %s"],
		              bbo = [0, [0, cst_api_controller_lib_rpc_ml, 803, 27738, 27767]],
		              bbq =
		                [0,
		                 [11, cst_local_side_of_RPC_never_su, 0],
		                 cst_local_side_of_RPC_never_su],
		              bbr = [0, [0, cst_api_controller_lib_rpc_ml, 813, 28144, 28171]],
		              bbs = [0, cst_api_controller_lib_rpc_ml, 846, 20],
		              bbm = [0, "var"],
		              bbk =
		                [0,
		                 [11, cst_callbacks_from_remote_to_l, 0],
		                 cst_callbacks_from_remote_to_l],
		              bbl = [0, [0, cst_api_controller_lib_rpc_ml, 216, 6179, 6206]],
		              bbi =
		                [0,
		                 [11, cst_callbacks_from_remote_to_l, 0],
		                 cst_callbacks_from_remote_to_l],
		              bbj = [0, [0, cst_api_controller_lib_rpc_ml, 222, 6359, 6386]],
		              match$262 = [0, 0],
		              match$263 = [0, cst_call],
		              bbh = [0, "remote_value_handle"],
		              bbg = [0, [4, 0, 0, 0, [12, 58, [15, 0]]], "%d:%a"],
		              bbf = [0, "channel_id"],
		              bbI = [0, 0],
		              bbH = [0, 0],
		              match$264 = [0, 2],
		              match$265 = [0, 0],
		              bbG = [0, "task-creation-option"],
		              bbP = [1, cst_name],
		              bbQ = [0, 0],
		              bbR = [0, 0],
		              bbS = [1, [0, 9943782, "organization not found"]],
		              bbM = [0, [11, cst_Ok, 0], cst_Ok],
		              bbN =
		                [0,
		                 [11,
		                  "action:",
		                  [17,
		                   [0, cst$4, 1, 0],
		                   [15,
		                    [12,
		                     44,
		                     [17,
		                      [0, cst$4, 1, 0],
		                      [11, "reason:", [17, [0, cst$4, 1, 0], [15, 0]]]]]]]],
		                 "action:@ %a,@ reason:@ %a"],
		              bbO =
		                [0,
		                 [11,
		                  "Organizations.get_member:",
		                  [17, [0, cst$4, 1, 0], [15, 0]]],
		                 "Organizations.get_member:@ %a"],
		              bbK =
		                [0,
		                 [11, cst_default_organization_is_mi, 0],
		                 cst_default_organization_is_mi],
		              bbL =
		                [0,
		                 [0, "api/controller/lib/organizations.ml", 43, 1222, 1253]],
		              bb4 = [0, 9943782, cst_Workspace_not_found],
		              bb3 = [0, 9943782, cst_Cannot_remove_the_last_ste],
		              bb2 = [0, 9943782, cst_Workspace_not_found],
		              bb1 = [0, 9943782, cst_Automation_not_found],
		              bb0 = [0, 9943782, cst_Workspace_not_found],
		              bbZ = [0, 9943782, cst_Step_not_found],
		              bbY = [0, 9943782, cst_Workspace_not_found],
		              bbX = [0, 9943782, "Agent not found when linking automation"],
		              bbW = [0, 9943782, cst_Workspace_not_found],
		              bbV = [0, 9943782, cst_Automation_not_found],
		              bbU =
		                [0,
		                 [11, "Automation run ", [15, [11, cst_not_found, 0]]],
		                 "Automation run %a not found"],
		              bbT = [0, 9943782, cst_Automation_run_is_not_wait],
		              bcd = [0, cst$15],
		              bcc = [0, 79, 0],
		              bcb =
		                [0, 79, [0, [0, cst_type, [0, -976970511, cst_object]], 0]],
		              bca = [0, 79, 0],
		              bb9 = [0, c],
		              bb8 = [1, "no JSON-RPC response received from MCP server"],
		              bb7 = [1, "malformed JSON-RPC response: no result"],
		              bb6 = [0, cst_jsonrpc, [0, -976970511, cst_2_0]],
		              bb5 = [0, cst_jsonrpc, [0, -976970511, cst_2_0]],
		              bb_ = [0, cst_name, [0, -976970511, cst_Routine]],
		              bb$ = [0, cst_capabilities, [0, 79, 0]],
		              bce = [0, [4, 0, 0, 0, [11, ". ", [2, 0, 0]]], "%d. %s"],
		              bcf =
		                [0,
		                 [11,
		                  "You are responding to a human-in-the-loop pause in an automation run. Your goal is to answer the user's question and then resume the automation run once you have gathered the necessary information.\n\nAutomation ID: ",
		                  [2,
		                   0,
		                   [11,
		                    "\nAutomation run ID: ",
		                    [2, 0, [11, "\nQuestions asked to the user:\n", [2, 0, 0]]]]]],
		                 "You are responding to a human-in-the-loop pause in an automation run. Your goal is to answer the user's question and then resume the automation run once you have gathered the necessary information.\n\nAutomation ID: %s\nAutomation run ID: %s\nQuestions asked to the user:\n%s"],
		              match$266 = [0, 0],
		              match$267 = [0, 0],
		              match$268 = [0, 0],
		              match$269 = [0, 0],
		              bcj = [0, cst_frequency],
		              bci = [0, cst_rule],
		              bch = [0, cst_kind],
		              bcg = [0, cst_month_day],
		              bcB = [0, [0, cst_additionalProperties, [0, 737456202, 0]], 0],
		              bcA = [0, [0, cst_properties, [0, 79, 0]], 0],
		              bcN = [0, [0, 0, 0]],
		              bcH = [0, [0, cst_direct, [0, "programmatic", 0]]],
		              bcI = [0, 0],
		              bcJ = [0, 1],
		              bcK = [0, [4, [0, 0]], 0],
		              bcL = [3, [0, 0]],
		              bcM = [2, [0, [0, cst_server], 0]],
		              bcF = [0, 1],
		              bcG = [0, 0],
		              bcE = [0, 759136046],
		              bcD =
		                [0,
		                 79,
		                 [0,
		                  [0, cst_type, [0, -976970511, cst_object]],
		                  [0,
		                   [0, cst_properties, [0, 79, 0]],
		                   [0, [0, cst_additionalProperties, [0, 737456202, 0]], 0]]]],
		              bcC = [0, 759136046],
		              bcz = [0, 5, 0],
		              match$271 = [0, cst_update],
		              bcy =
		                [0,
		                 'A settable field of an `update` tool. Used at type [_ update option], it\n    gives three choices (like [\'a option option], and staying OpenAI-strict):\n    the field [null] leaves the value unchanged, [{ "update": v }] sets it, and\n    \xe2\x80\x94 when [\'a] is itself optional \xe2\x80\x94 [{ "update": null }] clears it.'],
		              bcv =
		                [0,
		                 "True if [items] doesn't hold every matching item, i.e. [limit] was\n          hit."],
		              bcw = [0, "Total matching items, regardless of [limit]."],
		              match$270 = [0, "capped_list"],
		              bcx =
		                [0,
		                 "Wraps a list-tool result with the info needed to tell whether it was\n    truncated, so the model never mistakes a partial result for the full list."],
		              bcu = [0, cst_kind],
		              bct = [0, "reference_input"],
		              bcs = [0, "automation_run_ref_id"],
		              bcr = [0, "conversation_ref_id"],
		              bcq = [0, "automation_ref_id"],
		              bcp = [0, "agent_ref_id"],
		              bco = [0, "workspace_ref_id"],
		              bcn = [0, "table_ref_id"],
		              bcm = [0, "task_kind"],
		              bcl = [0, "generalized_task_id"],
		              bck = [0, cst_object_id$0],
		              bdY =
		                [0,
		                 "Top-level wrapper returned by OpenAI when the rich response format is used"],
		              bdZ = [0, "rich_response"],
		              bdX = [0, "response_citation"],
		              bdW = [0, 0],
		              bdV =
		                [0,
		                 "Use [Todo] blocks for tasks. Use [Embed] for URLs (so the UI shows a\n          preview). Use [Query] blocks for database views."],
		              bdT = [0, "A Routine document, made up of blocks"],
		              bdU = [0, "supported"],
		              bdH =
		                [0,
		                 "A block kept unchanged from the current version of the document."],
		              match$276 = [0, 0],
		              bdI =
		                [0,
		                 'Todo block. The "task" field, if not null, MUST be a valid task ID\n          (e.g. retrieved with `listUnplannedTasks`). Never invent or guess a\n          task ID \xe2\x80\x94 an invalid one is silently treated as null.'],
		              match$277 = [0, 0],
		              bdJ =
		                [0,
		                 "A table query. The controller generates and validates its graph query\n          source; never write graph-query syntax directly."],
		              match$278 = [0, 0],
		              bdK = [0, "Normal paragraph"],
		              match$279 = [0, 0],
		              bdL = [0, "Headings, subheadings."],
		              match$280 = [0, 0],
		              bdM = [0, "URL to embed"],
		              match$281 = [0, 0],
		              bdN = [0, "Separator"],
		              match$282 = [0, 0],
		              bdO = [0, "Programming language formatting"],
		              match$283 = [0, 0],
		              bdP = [0, cst_Checkbox],
		              match$284 = [0, 0],
		              bdQ = [0, "Bullet points, numbered or not."],
		              match$285 = [0, 0],
		              bdR = [0, "Quote block"],
		              bdS = [0, cst_type],
		              bdF =
		                [0,
		                 'A block in a Routine document. The field "content" contains the displayed\n    text for the block types where it is present. The ID *must* be null for\n    blocks you create; only provide an existing block ID when updating a block\n    you previously read.'],
		              bdG = [0, "supported_block"],
		              bdD =
		                [0,
		                 "Id of the block in the format 'block:<nanoid>' where <nanoid> is a\n    21-character nanoid."],
		              bdE = [0, cst_block_id],
		              bdC = [0, 0],
		              bdA =
		                [1,
		                 "The myself relation target is not supported in query blocks"],
		              bdB = [0, 0],
		              bdt = [0, 15500],
		              bdu = [0, 3901498],
		              bdv = [0, 17064],
		              bdw = [0, 3805373],
		              bdx = [0, 15949],
		              bdy = [0, 3556728],
		              bdz = [0, 103618111],
		              bdr = [0, c],
		              bds = [0, 0],
		              match$273 = [0, 0],
		              bdo = [0, "Maximum number of rows. Omit to show all rows."],
		              match$274 = [0, 0],
		              match$275 = [0, 0],
		              bdp =
		                [0,
		                 "Fields shown in the query. Pass an empty list to show all fields."],
		              bdq =
		                [0,
		                 'Technical plural table name, as returned by listTables, e.g.\n            "tasks".'],
		              bdn = [0, cst_query],
		              bdm = [0, cst_filter],
		              bdl = [0, 0],
		              bdj = [0, 0],
		              bdi = [0, "At least one condition must match."],
		              bdk = [0, "Every condition must match."],
		              bdh = [0, "filter_match"],
		              match$272 = [0, 0],
		              bdf =
		                [0,
		                 "One value for comparisons, one or more for membership, and none for\n            empty/not-empty."],
		              bdg = [0, "Field name, as returned by getTableSchema."],
		              bde = [0, "filter_condition"],
		              bdd = [0, 0],
		              bdb = [0, 0],
		              bc$ = [0, 0],
		              bc9 = [0, 0],
		              bc7 = [0, 0],
		              bc5 = [0, 0],
		              bc3 = [0, 0],
		              bc1 = [0, 0],
		              bcZ = [0, 0],
		              bcX = [0, 0],
		              bcV = [0, 0],
		              bcU = [0, 0, 0, [9, cst_is_not_empty], 0],
		              bcW = [0, 0, 0, [9, cst_is_empty], 0],
		              bcY = [0, 0, 0, [9, cst_not_inside], 0],
		              bc0 = [0, 0, 0, [9, cst_inside], 0],
		              bc2 = [0, 0, 0, [9, cst_contains], 0],
		              bc4 = [0, 0, 0, [9, cst_gte], 0],
		              bc6 = [0, 0, 0, [9, cst_gt], 0],
		              bc8 = [0, 0, 0, [9, cst_lte], 0],
		              bc_ = [0, 0, 0, [9, cst_lt], 0],
		              bda = [0, 0, 0, [9, cst_neq], 0],
		              bdc = [0, 0, 0, [9, cst_eq], 0],
		              bcT = [0, "filter_op"],
		              bcQ = [0, cst_ID_of_the_task_should_be_n],
		              bcR = [0, cst_title_of_the_task],
		              bcS = [0, cst_true_if_the_task_has_been_],
		              bcO =
		                [0,
		                 "Duplicate of {!Schemas.Document.Block.todo} because we change the schema\n      of [task] to be even more lenient (accept any string), as the AI sometimes\n      hallucinates a task ID. Non-determinism is fun."],
		              bcP = [0, cst_todo_block],
		              bel =
		                [0, [0, cst_api_controller_lib_control$0, 166, 5549, 5583]],
		              bem =
		                [0, [0, cst_api_controller_lib_control$0, 177, 5955, 5989]],
		              ben =
		                [0, [0, cst_api_controller_lib_control$0, 187, 6309, 6343]],
		              beo =
		                [0, [0, cst_api_controller_lib_control$0, 198, 6721, 6755]],
		              bep =
		                [0, [0, cst_api_controller_lib_control$0, 208, 7089, 7123]],
		              beq =
		                [0, [0, cst_api_controller_lib_control$0, 220, 7559, 7593]],
		              bek = [1, "This workspace is not part of an organization."],
		              bei = [0, 0],
		              bej = [1, cst_Workspace_not_found],
		              beh = [1, cst_Workspace_not_found],
		              beg = [1, cst_Organization_not_found],
		              bef = [1, cst_Organization_not_found],
		              bee =
		                [0,
		                 "The member's account id ('account:<nanoid>'), used to assign tasks\n          (see createTask / updateTask)."],
		              bed = [0, "member_output"],
		              match$287 = [0, 0],
		              bec = [0, "Max members to return (default 50)."],
		              beb = [0, "list_members_input"],
		              bea = [0, "rename_workspace_input"],
		              match$286 = [0, 0],
		              bd$ = [0, "Max workspaces to return (default 50)."],
		              bd_ = [0, "list_workspaces_input"],
		              bd9 = [0, "create_workspace_output"],
		              bd8 = [0, "create_workspace_input"],
		              bd7 = [0, "workspace_summary"],
		              bd6 = [0, "org_output"],
		              bd5 = [0, "get_workspace_input"],
		              bd4 = [0, "get_organization_input"],
		              bd2 =
		                [0,
		                 "Unique identifier for a Routine workspace, in the format\n    'workspace:<nanoid>', to be found using listWorkspaces"],
		              bd3 = [0, cst_workspace_id],
		              bd0 =
		                [0,
		                 "Unique identifier for a Routine organization, in the format 'org:<nanoid>',\n    given in the ENVIRONMENT section."],
		              bd1 = [0, cst_organization_id],
		              bf7 = [1, cst_Table_not_found],
		              bf5 = [0, [0, d, 604, 21436, 21480]],
		              bf6 = [1, cst_Table_not_found],
		              bf3 = [1, "unexpected result shape from table query"],
		              bf4 = [1, cst_Table_not_found],
		              bfX = [0, "A row in this table, as a 'row:<nanoid>' id."],
		              bfY = [0, cst_A_workspace_member_a_user_],
		              bfZ = [0, cst_A_person_in_the_contacts_d],
		              bf0 = [0, "A page (document or note), as a 'page:<nanoid>' id."],
		              bf1 = [0, cst_A_task_as_a_task_nanoid_id],
		              bf2 = [0, cst_A_calendar_event_e_g_a_mee],
		              bfV = [0, "The ids of objects in the graph."],
		              bfW = [0, "graph_row_id"],
		              bfU = [1, cst_Table_not_found],
		              bfP = [1, 3],
		              bfQ = [1, 0],
		              bfR = [1, 1],
		              bfS = [1, 4],
		              bfT = [1, 2],
		              bfO = [0, "delete_object_input"],
		              bfN = [0, "update_note_column_input"],
		              bfM = [0, "update_table_schema_input"],
		              bfL = [0, "create_table_output"],
		              bfK = [0, "create_table_input"],
		              bfJ = [0, "update_object_field_input"],
		              bfI = [0, "add_row_output"],
		              bfH = [0, "add_row_input"],
		              bfx = [0, 0],
		              bfy = [0, cst_An_ISO_8601_date_string_e_],
		              bfz = [0, cst_type],
		              bfv = [0, cst_Cell_value_simplified_to_s],
		              bfw = [0, cst_ai_value],
		              bfA = [0, cst_field_value],
		              bfD = [0, 0],
		              bfE = [0, cst_An_ISO_8601_date_string_e_],
		              bfF = [0, cst_type],
		              bfB = [0, cst_Cell_value_simplified_to_s],
		              bfC = [0, cst_ai_value],
		              bfG = [0, cst_field_value],
		              bfc = [0, 0],
		              bfb = [0, 0],
		              bfa = [0, 0],
		              be$ = [0, 0],
		              be_ = [0, 0],
		              be9 = [0, 0],
		              be8 = [0, 0],
		              be6 = [0, cst_A_relation_to_another_tabl],
		              be7 = [0, cst_Routine_s_rich_document_ty],
		              match$290 = [0, 0],
		              bfd = [0, cst_type],
		              be5 = [0, cst_ai_field_type],
		              match$291 = [0, 0],
		              bff = [0, cst_The_user_facing_name_for_t],
		              match$292 = [0, 0],
		              bfg = [0, cst_The_column_s_internal_id_a],
		              bfe = [0, cst_ai_field],
		              bfq = [0, 0],
		              bfp = [0, 0],
		              bfo = [0, 0],
		              bfn = [0, 0],
		              bfm = [0, 0],
		              bfl = [0, 0],
		              bfk = [0, 0],
		              bfi = [0, cst_A_relation_to_another_tabl],
		              bfj = [0, cst_Routine_s_rich_document_ty],
		              match$293 = [0, 0],
		              bfr = [0, cst_type],
		              bfh = [0, cst_ai_field_type],
		              match$294 = [0, 0],
		              bft = [0, cst_The_user_facing_name_for_t],
		              match$295 = [0, 0],
		              bfu = [0, cst_The_column_s_internal_id_a],
		              bfs = [0, cst_ai_field],
		              be2 = [0, 0],
		              be0 = [0, 0],
		              beY = [0, 0],
		              beW = [0, 0],
		              beU = [0, 0],
		              beT = [0, cst_A_task],
		              beV = [0, "An external contact (e.g. from Google Contacts)."],
		              beX = [0, cst_A_page_document_or_note],
		              beZ = [0, "A Routine workspace/org member."],
		              be1 = [0, cst_A_calendar_event],
		              be3 =
		                [0,
		                 "A relation to a user-defined or integration-app table (origin\n          `user_defined` or `integration_app`). Do not use this for built-in\n          Routine types \xe2\x80\x94 use the named variants below instead."],
		              be4 = [0, cst_type],
		              beS = [0, "ai-relation-schema-target"],
		              beL = [0, cst_A_task_as_a_task_nanoid_id],
		              beM =
		                [0,
		                 "A row in a custom table, referenced by its full object id. Use this\n          when you have an object id returned by searchTableRows or addTableRow."],
		              beN = [0, "A row in a custom table, as a 'row:<nanoid>' id."],
		              beO = [0, cst_A_person_in_the_contacts_d],
		              beP = [0, "A page (document or note), as 'page:<nanoid>' id."],
		              beQ = [0, cst_A_workspace_member_a_user_],
		              beR = [0, cst_A_calendar_event_e_g_a_mee],
		              beK = [0, "relation_target"],
		              match$289 = [0, 0],
		              beJ = [0, "search_rows_input"],
		              beI = [0, "get_table_schema_input"],
		              beG = [0, 'User-facing singular name, e.g. "Movie".'],
		              beH =
		                [0,
		                 'Technical plural name used to query the table, e.g. "movies".'],
		              beF = [0, "table_summary"],
		              beB = [0, 0],
		              beA =
		                [0,
		                 "A built-in Routine type (Task, Event, Page, People, \xe2\x80\xa6). It has no\n          addressable table id: read its data with the dedicated tools, and\n          relate to it via the named relation-target variants."],
		              beC =
		                [0,
		                 "Backed by a third-party integration (e.g. GitHub issues, Gmail\n          messages)."],
		              beD = [0, "Created by the user."],
		              beE = [0, cst_origin],
		              bey = [0, "Where a table comes from."],
		              bez = [0, "ai-table-origin"],
		              match$288 = [0, 0],
		              bex = [0, "Max tables to return (default 50)."],
		              bew = [0, "list_tables_input"],
		              bev = [0, "get_object_input"],
		              bet =
		                [0,
		                 "A table id as returned by listTables, in the format 'table:<nanoid>' where\n    <nanoid> is a 21-character nanoid. Always use the id field, never the table\n    name."],
		              beu = [0, cst_table_id],
		              ber =
		                [0,
		                 "A table row object id, in the compound format\n    'object:<workspace_nanoid>:<table_nanoid>:<row_nanoid>' where each component\n    is a 21-character nanoid. E.g. for object `row:<nanoid3>` of table\n    `table:<nanoid2>` in workspace `workspace:<nanoid1>`, its ID is\n    `object:<nanoid1>:<nanoid2>:<nanoid3>`."],
		              bes = [0, cst_object_id$0],
		              bgq = [0, 0],
		              bgr = [1, "Contact not found"],
		              match$301 = [0, 0],
		              bgp = [0, cst_Max_contacts_to_return_def],
		              bgo = [0, "search_contacts_input"],
		              match$300 = [0, 0],
		              bgn = [0, cst_Max_contacts_to_return_def],
		              bgm = [0, "list_contacts_input"],
		              bgk =
		                [0, "Custom user-defined fields for this contact, if any."],
		              bgl =
		                [0,
		                 'Where this contact comes from: a synced connection ("Connections"), a\n          workspace/organization directory ("Directory"), an unspecified other\n          source ("Other"), or the current user\'s own profile ("Self").'],
		              match$298 = [0, 0],
		              match$299 = [0, 0],
		              bgj = [0, "get_contact_output"],
		              bgi = [0, "get_contact_input"],
		              match$297 = [0, 0],
		              bgh = [0, "contact_organization"],
		              match$296 = [0, 0],
		              bgg = [0, "contact_summary"],
		              bhs = [0, 1],
		              bhq = [0, 0],
		              bhr = [1, cst_Calendar_is_readonly],
		              bho = [0, 0],
		              bhp = [1, cst_Calendar_is_readonly],
		              bhm = [0, 0],
		              bhn = [1, cst_Calendar_is_readonly],
		              bhl = [0, 0],
		              bhk = [1, cst_Invalid_date_format],
		              bhi = [0, 0],
		              bhj = [1, cst_Event_not_found],
		              bhf = [1, cst_Invalid_date_format],
		              bhg = [1, cst_Invalid_date_format],
		              bhh = [1, "Invalid time format"],
		              bhe = [0, "find_available_time_slots_output"],
		              bhc = [0, cst_ISO_8601_datetime_with_tim],
		              bhd = [0, cst_ISO_8601_datetime_with_tim],
		              bhb = [0, "time_slot"],
		              match$316 = [0, 0],
		              bg9 =
		                [0,
		                 'ISO 8601 date to search from; omit to start from now, e.g. for "this\n          week".'],
		              match$317 = [0, 0],
		              bg_ =
		                [0,
		                 "Cap on the number of slots returned; defaults to 20 if omitted."],
		              bg$ = [0, "ISO 8601 date, inclusive"],
		              match$318 = [0, [0, 0, 0]],
		              bha =
		                [0,
		                 "Defaults to business hours only; pass [] to search the whole day\n          unrestricted, or add [Rule] entries for extra constraints, e.g. to\n          skip lunch."],
		              bg8 = [0, "find_available_time_slots_input"],
		              bg7 = [0, 0],
		              bg5 =
		                [0,
		                 "A custom recurring include/exclude range, e.g. an [Exclude] with a\n          daily rule and a 12:00:00-13:00:00 daytime range to skip lunch."],
		              bg6 =
		                [0, "The account's configured business hours, applied daily."],
		              bg4 = [0, "slot_constraint"],
		              bg1 = [0, "Time-of-day range the constraint covers."],
		              bg2 =
		                [0,
		                 "Which days this applies to, e.g. daily or a set of weekdays. Has no\n          start/end date of its own - the tool's own date range governs that."],
		              bg3 =
		                [0,
		                 "[Include]: only the times covered by this constraint are available.\n          [Exclude]: the times covered by this constraint are never available."],
		              bg0 = [0, "custom_constraint"],
		              bgY = [0, 'ISO 8601 time, no timezone, e.g. "13:00:00"'],
		              bgZ = [0, 'ISO 8601 time, no timezone, e.g. "12:00:00"'],
		              bgX = [0, "daytime_range"],
		              bgW = [0, "delete_event_input"],
		              bgV = [0, "complete_event_input"],
		              match$315 = [0, 0],
		              bgU = [0, "set_attendance_input"],
		              match$309 = [0, 0],
		              match$310 = [0, 0],
		              match$311 = [0, 0],
		              bgT =
		                [0,
		                 "The event's notes in Routine. Construct each block using the supported\n          block types."],
		              match$312 = [0, 0],
		              match$313 = [0, 0],
		              match$314 = [0, 0],
		              bgS = [0, "update_event_input"],
		              bgR = [0, "create_event_output"],
		              match$306 = [0, 0],
		              match$307 = [0, 0],
		              match$308 = [0, 0],
		              bgQ = [0, "create_event_input"],
		              bgP = [0, "event_summary"],
		              match$304 = [0, 0],
		              bgL = [0, "Max events to return (default 50)."],
		              match$305 = [0, 0],
		              bgM = [0, "Omit (or All) for all events."],
		              bgN = [0, cst_ISO_8601_date_e_g_2026_03_],
		              bgO = [0, cst_ISO_8601_date_e_g_2026_03_],
		              bgK = [0, "list_events_input"],
		              bgJ = [0, 0],
		              bgH = [0, 0],
		              bgF = [0, 0],
		              bgE = [0, "Only events with specific start/end times."],
		              bgG = [0, "Only all-day events."],
		              bgI = [0, "All events (default)."],
		              bgD = [0, "event_time_filter"],
		              bgC = [0, "Custom user-defined fields for this event, if any."],
		              bgB = [0, "get_event_output"],
		              bgA = [0, "get_event_input"],
		              match$302 = [0, 0],
		              match$303 = [0, 0],
		              bgz = [0, cst_attendee],
		              bgw =
		                [0,
		                 'Event with specific times - ISO 8601 datetime with timezone offset,\n          e.g. "2026-03-17T14:30:00+02:00"'],
		              bgx = [0, "Multi-day whole day event"],
		              bgy =
		                [0,
		                 'Single whole day event - ISO 8601 date, e.g. "2026-03-17"'],
		              bgv = [0, "event_time"],
		              bhD = [0, "build_reference_input"],
		              bhC = [0, "build_link_input"],
		              bhB = [1, "Cannot build link for object without workspace_id"],
		              bhE = [0, [0, cst_api_controller_lib_control$1, 72, 3134, 3166]],
		              bhF = [0, [0, cst_api_controller_lib_control$1, 83, 3551, 3583]],
		              bhJ = [0, 0],
		              bhI = [0, 0],
		              bhH = [0, "unpin_menu_item_input"],
		              bhG = [0, "pin_menu_item_input"],
		              bh1 = [0, [0, e, 156, 5086, 5120]],
		              bh2 = [0, 1],
		              bh3 = [0, [0, e, 164, 5377, 5411]],
		              bh4 = [0, [0, e, 174, 5770, 5804]],
		              bh5 = [0, [0, e, 183, 6122, 6156]],
		              bh6 = [0, [0, e, 193, 6506, 6540]],
		              bh7 = [0, 1],
		              bhZ = [0, 1],
		              bh0 = [0, 0],
		              bhY = [0, "create_notice_output"],
		              bhX = [0, "notice_output"],
		              bhW = [0, "create_notice_input"],
		              bhV = [0, "notice_id_input"],
		              bhU = [0, "notice_summary"],
		              match$319 = [0, 0],
		              bhS = [0, "Max notices to return (default 50)."],
		              match$320 = [0, 0],
		              bhT = [0, "Omit to list all notices."],
		              bhR = [0, "list_notices_input"],
		              bhQ = [0, 0],
		              bhO = [0, 0],
		              bhN = [0, "Only notices the recipient has not viewed yet."],
		              bhP = [0, "Only notices the recipient has already viewed."],
		              bhM = [0, "notice_filter"],
		              bil = [0, 0],
		              bim = [1, cst_Page_not_found],
		              match$322 = [0, 0],
		              bij =
		                [0,
		                 "The page's content document. Construct each block using the supported block types."],
		              match$323 = [0, 0],
		              bik =
		                [0,
		                 "Move the page: null leaves it unchanged, Root moves it to the top\n          level, and Page nests it under a specific page."],
		              match$324 = [0, 0],
		              bii = [0, "update_page_input"],
		              big = [0, 0],
		              bie = [0, "Move under this parent page"],
		              bif = [0, "Move the page to the top level (no parent)"],
		              bih = [0, cst_type],
		              bid = [0, "parent_input"],
		              bic = [0, "create_page_output"],
		              match$321 = [0, 0],
		              bib = [0, "create_page_input"],
		              bia = [0, "Custom user-defined fields for this page, if any."],
		              bh$ = [0, "get_page_output"],
		              bh_ = [0, "get_page_input"],
		              biO = [0, "The text fragment that matched the query."],
		              biP = [0, "Title of the matching object."],
		              biQ =
		                [0,
		                 "Typed object ID. Use it to call domain-specific tools (e.g. getEvent,\n          getTask, getContact)."],
		              biN = [0, cst_search_result],
		              match$325 = [0, 0],
		              biL =
		                [0, "Maximum number of results to return. Defaults to 20."],
		              match$326 = [0, 0],
		              biM =
		                [0,
		                 "Restrict results to this kind of object. Omit to search everything."],
		              biK = [0, cst_search_input],
		              biH = [0, 0],
		              biF = [0, 0],
		              biD = [0, 0],
		              biB = [0, 0],
		              biz = [0, 0],
		              bix = [0, 0],
		              biv = [0, 0],
		              bit = [0, 0],
		              bis = [0, "A workspace."],
		              biu =
		                [0,
		                 "The recurring series a repeating task belongs to, as opposed to one of\n          its individual occurrences."],
		              biw = [0, cst_A_task],
		              biy =
		                [0,
		                 "A custom table (database) definition itself, not one of its rows."],
		              biA = [0, "A contact."],
		              biC = [0, cst_A_page_document_or_note],
		              biE =
		                [0,
		                 "The recurring series a repeating event belongs to, as opposed to one\n          of its individual occurrences."],
		              biG = [0, cst_A_calendar_event],
		              biI =
		                [0,
		                 "A row in the given user-defined or integration-app table. Do not use\n          this for built-in Routine types \xe2\x80\x94 use the named variants below\n          instead."],
		              biJ = [0, cst_type],
		              biq =
		                [0,
		                 "The kind of object a search result refers to, for restricting search results\n    to a specific type."],
		              bir = [0, "ai-search-object-kind"],
		              bjY = [0, 0],
		              bjW =
		                [1,
		                 "Allocating time on the calendar is only supported for personal tasks."],
		              bjX = [1, cst_Invalid_date_format],
		              bjU = [1, "Task is missing workspace information"],
		              bjS = [0, 0],
		              bjQ = [0, 0],
		              bjR = [0, 0],
		              bjT = [0, 0],
		              bjV = [0, 0],
		              bjM = [0, 0],
		              bjN = [0, 0],
		              bjO = [1, cst_This_workspace_s_task_tabl],
		              bjL =
		                [1,
		                 "Setting a parent is not supported for tasks in this workspace."],
		              bjP = [1, "This workspace has no table configured as tasks."],
		              bjJ = [0, 0],
		              bjK = [1, cst_Task_not_found],
		              bjH = [1, cst_This_workspace_s_task_tabl],
		              bjI = [1, "The task's table was not found."],
		              bjG = [0, 0],
		              bjF = [0, 0],
		              bjE = [0, "delete_task_input"],
		              bjD = [0, "allocate_task_output"],
		              match$344 = [0, 0],
		              bjC = [0, "allocate_task_input"],
		              bjB = [0, "list_tasks_output"],
		              match$343 = [0, 0],
		              bjA = [0, "generalized_task_summary"],
		              match$342 = [0, 0],
		              bjy = [0, cst_Max_tasks_to_return_defaul],
		              bjz = [0, cst_The_workspace_to_list_task],
		              bjx = [0, "list_tasks_input"],
		              match$341 = [0, 0],
		              bjv = [0, "Max tasks to return per group (default 50)."],
		              bjw = [0, cst_The_workspace_to_list_task],
		              bju = [0, "list_todays_tasks_input"],
		              match$340 = [0, 0],
		              bjs = [0, cst_Max_tasks_to_return_defaul],
		              bjt = [0, cst_The_workspace_to_list_task],
		              bjr = [0, "list_unplanned_tasks_input"],
		              match$333 = [0, 0],
		              bjp =
		                [0,
		                 "The task's notes document. Construct each block using the supported block types."],
		              match$334 = [0, 0],
		              bjq =
		                [0,
		                 "Reassign or unassign the task. Only supported for organization\n          workspaces; rejected for personal (native) tasks."],
		              match$335 = [0, 0],
		              match$336 = [0, 0],
		              match$337 = [0, 0],
		              match$338 = [0, 0],
		              match$339 = [0, 0],
		              bjo = [0, "update_task_input"],
		              bjn = [0, "create_task_output"],
		              match$329 = [0, 0],
		              bjk =
		                [0,
		                 "Assign the created task to a member. Only supported for organization\n          workspaces; rejected for personal tasks."],
		              match$330 = [0, 0],
		              bjl =
		                [0,
		                 "Add as a todo block under an existing task/event/page. Only supported\n          for personal tasks."],
		              match$331 = [0, 0],
		              match$332 = [0, 0],
		              bjm =
		                [0,
		                 "The workspace to create the task in: the personal workspace for a\n          personal task, or an organization workspace (see the ENVIRONMENT\n          section) for an organization task."],
		              bjj = [0, "create_task_input"],
		              bje = [0, "Custom user-defined fields for this task, if any."],
		              match$327 = [0, 0],
		              bjf =
		                [0,
		                 "The account id of the member this task is assigned to, if any\n          (organization workspaces only). Resolve it to a name/email with\n          listMembers."],
		              match$328 = [0, 0],
		              bjg =
		                [0, "The parent task or event, if this task is a sub-task."],
		              bjh = [0, "The task's notes document."],
		              bji = [0, cst_The_potential_capture_cont],
		              bjd = [0, "get_task_output"],
		              bjc = [0, "get_task_input"],
		              bjb = [0, 0],
		              bi_ = [0, 0],
		              bi9 = [0, "Remove the current assignee."],
		              bi$ =
		                [0,
		                 "Assign to a workspace member, by their account id\n          ('account:<nanoid>'), as returned by listMembers."],
		              bja = [0, "Assign to yourself, the requesting account."],
		              bi7 =
		                [0,
		                 "Who an organization task is assigned to. Assignment only exists in\n    organization workspaces (it is meaningless in the personal workspace)."],
		              bi8 = [0, "assignee_input"],
		              bi6 = [0, 0],
		              bi4 = [0, 0],
		              bi2 = [0, 0],
		              bi1 = [0, "Task is discarded/ignored, will not be worked on."],
		              bi3 = [0, "Task is done"],
		              bi5 = [0, "Active, to be worked on in the future."],
		              bi0 = [0, "task_status"],
		              biY = [0, "Batch to a week"],
		              biZ = [0, "Schedule for a specific day"],
		              biW =
		                [0,
		                 "Plans the task for a day or week, without blocking time on the calendar."],
		              biX = [0, "scheduled_input"],
		              biV = [0, 'YYYY-WW, e.g. "2026-12"'],
		              biU = [0, "scheduled_week"],
		              biT = [0, cst_ISO_8601_date_e_g_2026_03_],
		              biS = [0, "scheduled_date"],
		              bkc = [0, "ask_user_input"],
		              bkb = [0, 0],
		              bj9 = [0, "Number of choices allowed."],
		              match$345 = [0, 0],
		              bj_ =
		                [0,
		                 'Fixed choices to guide the user - an open "Other" choice will be\n            appended in the client.'],
		              match$346 = [0, 0],
		              bj$ = [0, cst_Optional_longer_rich_conte],
		              bka = [0, cst_The_question_in_short_form],
		              bj7 = [0, "An independent question to the user."],
		              bj8 = [0, cst_question],
		              bkR =
		                [0, [0, cst_api_controller_lib_control$2, 480, 16785, 16814]],
		              bkS =
		                [0, [0, cst_api_controller_lib_control$2, 496, 17582, 17616]],
		              bkT =
		                [0, [0, cst_api_controller_lib_control$2, 506, 18091, 18125]],
		              bkU =
		                [0, [0, cst_api_controller_lib_control$2, 514, 18475, 18509]],
		              bkV =
		                [0, [0, cst_api_controller_lib_control$2, 523, 18877, 18906]],
		              bkW =
		                [0, [0, cst_api_controller_lib_control$2, 534, 19394, 19428]],
		              bkX =
		                [0, [0, cst_api_controller_lib_control$2, 542, 19759, 19793]],
		              bkY =
		                [0, [0, cst_api_controller_lib_control$2, 549, 20072, 20106]],
		              bkZ =
		                [0, [0, cst_api_controller_lib_control$2, 557, 20463, 20497]],
		              bk0 =
		                [0, [0, cst_api_controller_lib_control$2, 568, 20969, 20998]],
		              bkO = [0, cst_api_controller_lib_control$2, 464, 16138, 16177],
		              bkP = [0, [0, 79, 0]],
		              bkN = [1, cst_Automation_run_is_not_wait],
		              bkQ = [1, cst_Automation_run_not_found],
		              bkL = [1, cst_Automation_run_not_found],
		              bkM = [1, cst_AI_state_not_found],
		              bkJ = [1, cst_Automation_not_found],
		              bkK = [1, cst_AI_state_not_found],
		              bkH = [0, cst_api_controller_lib_control$2, 407, 13898, 13931],
		              bkI = [0, [0, 79, 0]],
		              bkF = [0, cst_api_controller_lib_control$2, 385, 13144, 13177],
		              bkG = [0, [0, 79, 0]],
		              bkE = [0, cst_api_controller_lib_control$2, 354, 12158, 12191],
		              bkD = [0, "step_delete_input"],
		              match$352 = [0, 0],
		              match$353 = [0, 0],
		              bkC = [0, "step_update_input"],
		              bkB = [0, "step_create_output"],
		              bkA = [0, "step_create_for_automation_input"],
		              bkz =
		                [0,
		                 "One answer-list per question in the breakpoint, same order."],
		              bky = [0, "automation_run_resume_input"],
		              bkx = [0, "automation_run_get_input"],
		              bkw = [0, "automation_get_input"],
		              bkv = [0, "automation_delete_input"],
		              match$350 = [0, 0],
		              match$351 = [0, 0],
		              bku =
		                [0,
		                 'Use null to leave unchanged, {"update": "name"} to set, or {"update": null} to clear.'],
		              bkt = [0, "automation_update_input"],
		              bks = [0, "automation_create_output"],
		              match$349 = [0, 0],
		              bkr = [0, "automation_create_input"],
		              bkq = [0, "step_create_input"],
		              bkp = [0, "update_working_memory_input"],
		              bko = [0, "Failed to convert to Event.Recurrence"],
		              bkn = [0, [11, "Invalid date: ", [2, 0, 0]], "Invalid date: %s"],
		              bkl = [0, 0],
		              bkm = [0, cst_trigger],
		              bkk = [0, cst_trigger],
		              bkj = [0, cst_recurrence],
		              match$347 = [0, 0],
		              bkf = [0, cst_ISO_8601_e_g_2025_01_31],
		              match$348 = [0, 0],
		              bkg = [0, cst_ISO_8601_e_g_2025_01_31],
		              bkh = [0, cst_ISO_8601_e_g_2025_01_31],
		              bki = [0, cst_kind],
		              bke = [0, cst_boundaries],
		              bk3 =
		                [0,
		                 [11,
		                  "integration action error: action_id=",
		                  [2,
		                   0,
		                   [11, " connection_id=", [2, 0, [11, " error=", [2, 0, 0]]]]]],
		                 "integration action error: action_id=%s connection_id=%s error=%s"],
		              bk1 = [0, c],
		              bk2 =
		                [0,
		                 [11,
		                  "integration action ",
		                  [2,
		                   0,
		                   [11,
		                    ": input encoded to a non-object, cannot pin ",
		                    [2, 0, [11, "; sending the model's input unchanged", 0]]]]],
		                 "integration action %s: input encoded to a non-object, cannot pin %s; sending the model's input unchanged"],
		              match$354 = [0, "integration_call_input"],
		              match$421 = [0, 0],
		              bmq = [0, cst_Results_per_page],
		              match$422 = [0, 0],
		              bmr = [0, cst_Page_number_for_pagination],
		              bmp = [0, cst_input],
		              match$418 = [0, 0],
		              bmm = [0, cst_Results_per_page],
		              match$419 = [0, 0],
		              bmn = [0, cst_Page_number_for_pagination],
		              match$420 = [0, 0],
		              bmo = [0, cst_Keywords_to_search_for],
		              bml = [0, cst_input],
		              match$414 = [0, 0],
		              bmg = [0, "ID of the user who owns this account."],
		              match$415 = [0, 0],
		              bmh = [0, "Address of the account."],
		              match$416 = [0, 0],
		              bmi = [0, "Phone number of the account."],
		              match$417 = [0, 0],
		              bmj = [0, "Website domain of the account."],
		              bmk = [0, "Name of the account/company."],
		              bmf = [0, cst_input],
		              bme = [0, "The ID of the account to retrieve."],
		              bmd = [0, cst_input],
		              match$408 = [0, 0],
		              bl9 = [0, cst_Results_per_page_max_100],
		              match$409 = [0, 0],
		              bl_ = [0, cst_Page_number_for_pagination],
		              match$410 = [0, 0],
		              bl$ = [0, cst_Sort_in_ascending_order],
		              match$411 = [0, 0],
		              bma = [0, cst_Field_to_sort_by],
		              match$412 = [0, 0],
		              bmb = [0, "Filter by account stage IDs."],
		              match$413 = [0, 0],
		              bmc = [0, cst_Keywords_to_search_for],
		              bl8 = [0, cst_input],
		              bl7 = [0, "Apollo organization ID."],
		              bl6 = [0, cst_input],
		              match$401 = [0, 0],
		              blZ = [0, cst_Results_per_page_max_100],
		              match$402 = [0, 0],
		              bl0 = [0, cst_Page_number_for_pagination],
		              match$403 = [0, 0],
		              bl1 = [0, "Filter by industry tag IDs."],
		              match$404 = [0, 0],
		              bl2 = [0, cst_Filter_by_company_size_ran],
		              match$405 = [0, 0],
		              bl3 = [0, cst_Filter_by_company_location],
		              match$406 = [0, 0],
		              bl4 = [0, "Filter by keyword tags."],
		              match$407 = [0, 0],
		              bl5 = [0, "Search by organization name."],
		              blY = [0, cst_input],
		              match$393 = [0, 0],
		              blP = [0, cst_Labels_to_apply_to_the_con],
		              match$394 = [0, 0],
		              blQ = [0, cst_ID_of_the_user_who_owns_th],
		              match$395 = [0, 0],
		              blR = [0, cst_Apollo_account_ID_to_link_],
		              match$396 = [0, 0],
		              blS = [0, cst_Name_of_the_contact_s_orga],
		              match$397 = [0, 0],
		              blT = [0, cst_Contact_s_job_title],
		              match$398 = [0, 0],
		              blU = [0, cst_Contact_s_email_address],
		              match$399 = [0, 0],
		              blV = [0, cst_Contact_s_last_name],
		              match$400 = [0, 0],
		              blW = [0, cst_Contact_s_first_name],
		              blX = [0, "The ID of the contact to update."],
		              blO = [0, cst_input],
		              match$380 = [0, 0],
		              blB =
		                [0,
		                 "Set to true to enable deduplication and prevent duplicate contacts."],
		              match$381 = [0, 0],
		              blC = [0, cst_ID_of_the_user_who_owns_th],
		              match$382 = [0, 0],
		              blD = [0, cst_Labels_to_apply_to_the_con],
		              match$383 = [0, 0],
		              blE = [0, "Contact's address."],
		              match$384 = [0, 0],
		              blF = [0, "List of phone numbers."],
		              match$385 = [0, 0],
		              blG = [0, "Contact's LinkedIn profile URL."],
		              match$386 = [0, 0],
		              blH = [0, "Contact's website URL."],
		              match$387 = [0, 0],
		              blI = [0, cst_Apollo_account_ID_to_link_],
		              match$388 = [0, 0],
		              blJ = [0, cst_Name_of_the_contact_s_orga],
		              match$389 = [0, 0],
		              blK = [0, cst_Contact_s_job_title],
		              match$390 = [0, 0],
		              blL = [0, cst_Contact_s_email_address],
		              match$391 = [0, 0],
		              blM = [0, cst_Contact_s_last_name],
		              match$392 = [0, 0],
		              blN = [0, cst_Contact_s_first_name],
		              blA = [0, cst_input],
		              match$379 = [0, 0],
		              bly = [0, 'Phone type (e.g., "work", "mobile").'],
		              blz = [0, "Phone number string."],
		              blx = [0, cst_phone_number],
		              blw = [0, "The ID of the contact to retrieve."],
		              blv = [0, cst_input],
		              match$373 = [0, 0],
		              blp = [0, cst_Results_per_page_max_100],
		              match$374 = [0, 0],
		              blq = [0, cst_Page_number_for_pagination],
		              match$375 = [0, 0],
		              blr = [0, cst_Sort_in_ascending_order],
		              match$376 = [0, 0],
		              bls = [0, cst_Field_to_sort_by],
		              match$377 = [0, 0],
		              blt = [0, "Filter by contact stage IDs."],
		              match$378 = [0, 0],
		              blu = [0, cst_Keywords_to_search_for],
		              blo = [0, cst_input],
		              match$364 = [0, 0],
		              blf = [0, cst_Results_per_page_max_100],
		              match$365 = [0, 0],
		              blg = [0, "Page number for pagination (1\xe2\x80\x93500)."],
		              match$366 = [0, 0],
		              blh = [0, cst_Filter_by_company_size_ran],
		              match$367 = [0, 0],
		              bli = [0, "Filter by person locations."],
		              match$368 = [0, 0],
		              blj = [0, cst_Filter_by_company_location],
		              match$369 = [0, 0],
		              blk =
		                [0,
		                 'Filter by company domains (e.g., ["apollo.io", "hubspot.com"]).'],
		              match$370 = [0, 0],
		              bll =
		                [0,
		                 'Filter by seniority levels (e.g., "senior", "manager", "director",\n            "vp", "c_suite").'],
		              match$371 = [0, 0],
		              blm =
		                [0,
		                 'Filter by job titles (e.g., ["VP of Sales", "Head of Marketing"]).'],
		              match$372 = [0, 0],
		              bln = [0, cst_Keywords_to_search_for],
		              ble = [0, cst_input],
		              bld = [0, 'The company\'s website domain (e.g., "apollo.io").'],
		              blc = [0, cst_input],
		              match$355 = [0, 0],
		              bk5 = [0, "Set to true to retrieve phone numbers."],
		              match$356 = [0, 0],
		              bk6 = [0, "Set to true to retrieve personal email addresses."],
		              match$357 = [0, 0],
		              bk7 = [0, "The person's LinkedIn profile URL."],
		              match$358 = [0, 0],
		              bk8 = [0, "The name of the person's employer."],
		              match$359 = [0, 0],
		              bk9 =
		                [0,
		                 'The domain of the person\'s employer (e.g., "apollo.io").'],
		              match$360 = [0, 0],
		              bk_ = [0, "The person's email address."],
		              match$361 = [0, 0],
		              bk$ =
		                [0,
		                 "The person's full name (alternative to first/last name)."],
		              match$362 = [0, 0],
		              bla = [0, "The person's last name."],
		              match$363 = [0, 0],
		              blb = [0, "The person's first name."],
		              bk4 = [0, cst_input],
		              bne = [0, "Globally unique identifier for the task to delete."],
		              bnd = [0, cst_input],
		              match$456 = [0, 1],
		              bnb =
		                [0,
		                 "Set to true to complete the task, or false to reopen it."],
		              bnc = [0, cst_Globally_unique_identifier],
		              bna = [0, cst_input],
		              match$446 = [0, 0],
		              bm1 = [0, "Whether the authenticated user likes the task."],
		              match$447 = [0, 0],
		              bm2 = [0, cst_Whether_the_task_is_comple],
		              match$448 = [0, 0],
		              bm3 = [0, "New start date and time in ISO 8601 UTC."],
		              match$449 = [0, 0],
		              bm4 = [0, "New start date in YYYY-MM-DD format."],
		              match$450 = [0, 0],
		              bm5 = [0, "New due date and time in ISO 8601 UTC."],
		              match$451 = [0, 0],
		              bm6 = [0, "New due date in YYYY-MM-DD format."],
		              match$452 = [0, 0],
		              bm7 = [0, 'New assignee GID, email, or ["me"].'],
		              match$453 = [0, 0],
		              bm8 =
		                [0, "New HTML description. Mutually exclusive with notes."],
		              match$454 = [0, 0],
		              bm9 =
		                [0,
		                 "New plain-text description. Mutually exclusive with html_notes."],
		              match$455 = [0, 0],
		              bm_ = [0, "New task name."],
		              bm$ = [0, cst_Globally_unique_identifier],
		              bm0 = [0, cst_input],
		              match$433 = [0, 0],
		              bmM = [0, "Parent task GID when creating a subtask."],
		              match$434 = [0, 0],
		              bmN = [0, "User GIDs to add as followers."],
		              match$435 = [0, 0],
		              bmO = [0, "Tag GIDs to add to the task."],
		              match$436 = [0, 0],
		              bmP = [0, cst_Whether_the_task_is_comple],
		              match$437 = [0, 0],
		              bmQ =
		                [0,
		                 "Start date and time in ISO 8601 UTC. Mutually exclusive with\n            start_on."],
		              match$438 = [0, 0],
		              bmR =
		                [0,
		                 "Start date in YYYY-MM-DD format. Mutually exclusive with start_at."],
		              match$439 = [0, 0],
		              bmS =
		                [0,
		                 "Due date and time in ISO 8601 UTC. Mutually exclusive with due_on."],
		              match$440 = [0, 0],
		              bmT =
		                [0,
		                 "Due date in YYYY-MM-DD format. Mutually exclusive with due_at."],
		              match$441 = [0, 0],
		              bmU = [0, 'Assignee GID, email, or ["me"].'],
		              match$442 = [0, 0],
		              bmV = [0, "Project GIDs to add the task to."],
		              match$443 = [0, 0],
		              bmW =
		                [0, "Workspace GID. Required when no project is supplied."],
		              match$444 = [0, 0],
		              bmX =
		                [0, "HTML task description. Mutually exclusive with notes."],
		              match$445 = [0, 0],
		              bmY =
		                [0,
		                 "Plain-text task description. Mutually exclusive with html_notes."],
		              bmZ = [0, cst_Name_of_the_task],
		              bmL = [0, cst_input],
		              bmK = [0, cst_Globally_unique_identifier],
		              bmJ = [0, cst_input],
		              match$427 = [0, 0],
		              bmC = [0, "Maximum number of tasks to return, from 1 to 100."],
		              match$428 = [0, 0],
		              bmD =
		                [0, "Return tasks modified since this ISO 8601 timestamp."],
		              match$429 = [0, 0],
		              bmE =
		                [0,
		                 'Return tasks completed since this ISO 8601 timestamp. Use ["now"]\n            for incomplete tasks only.'],
		              match$430 = [0, 0],
		              bmF =
		                [0,
		                 'Assignee GID, email, ["me"], or ["null"] for unassigned tasks.\n            Required when listing by workspace without a project or section.'],
		              match$431 = [0, 0],
		              bmG = [0, "Optional section GID to filter tasks."],
		              match$432 = [0, 0],
		              bmH = [0, "Optional project GID to filter tasks."],
		              bmI =
		                [0,
		                 "Workspace GID. Required by this action even when filtering by\n            project or section."],
		              bmB = [0, cst_input],
		              bmA = [0, "Globally unique identifier for the project."],
		              bmz = [0, cst_input],
		              match$424 = [0, 0],
		              bmv =
		                [0, "Maximum number of projects to return, from 1 to 100."],
		              match$425 = [0, 0],
		              bmw =
		                [0, "Whether to return archived projects. Defaults to false."],
		              match$426 = [0, 0],
		              bmx = [0, "Optional team GID to further filter projects."],
		              bmy = [0, "Workspace GID whose projects should be returned."],
		              bmu = [0, cst_input],
		              match$423 = [0, 0],
		              bmt =
		                [0, "Maximum number of workspaces to return, from 1 to 100."],
		              bms = [0, cst_input],
		              bog =
		                [0,
		                 [11,
		                  "Create and update tasks and notes\n\n# Notes\nNotes are always attached to a parent record. Specify the parent via its object slug (e.g. 'people') and record UUID.\n\n# Actor references\nTask assignees take ",
		                  [2, 0, [11, ". Never invent UUIDs.", 0]]],
		                 "Create and update tasks and notes\n\n# Notes\nNotes are always attached to a parent record. Specify the parent via its object slug (e.g. 'people') and record UUID.\n\n# Actor references\nTask assignees take %s. Never invent UUIDs."],
		              boh =
		                [0,
		                 [11,
		                  "Search, retrieve, and create companies\n\n# Attribute values\nCreate actions accept a 'values' object. ",
		                  [2, 0, 0]],
		                 "Search, retrieve, and create companies\n\n# Attribute values\nCreate actions accept a 'values' object. %s"],
		              boi =
		                [0,
		                 [11,
		                  "Search, retrieve, create, and update people\n\n# Attribute values\nCreate/Update actions accept a 'values' object. ",
		                  [2,
		                   0,
		                   [11,
		                    " Record references (e.g. company) take a record reference object.",
		                    0]]],
		                 "Search, retrieve, create, and update people\n\n# Attribute values\nCreate/Update actions accept a 'values' object. %s Record references (e.g. company) take a record reference object."],
		              boj =
		                [0,
		                 [11,
		                  "Search, retrieve, create, and update deals\n\n# Attribute values\nCreate/Update actions accept a 'values' object. ",
		                  [2,
		                   0,
		                   [11,
		                    " Record references (e.g. deal owner) take ",
		                    [2, 0, [11, " or a record reference object.", 0]]]]],
		                 "Search, retrieve, create, and update deals\n\n# Attribute values\nCreate/Update actions accept a 'values' object. %s Record references (e.g. deal owner) take %s or a record reference object."],
		              boc = [0, "The main content of the note."],
		              bod = [0, "The note title (plaintext only)."],
		              boe = [0, "The UUID of the parent record the note belongs to."],
		              bof =
		                [0,
		                 'The ID or slug of the parent object the note belongs to (e.g.\n            "people", "companies", "deals").'],
		              boa =
		                [0,
		                 "Create a note attached to a parent record (e.g. a person, company, or\n      deal)."],
		              bob = [0, cst_input],
		              bn$ = [0, 0],
		              bn9 = [0, 0],
		              bn8 = [0, 0, 0, [9, cst_markdown], 0],
		              bn_ = [0, 0, 0, [9, cst_plaintext], 0],
		              bn6 = [0, "Format of the note content."],
		              bn7 = [0, cst_format],
		              match$478 = [0, 0],
		              match$479 = [0, 0],
		              match$480 = [0, 0],
		              bn3 = [0, cst_Whether_the_task_is_comple],
		              match$481 = [0, 0],
		              bn4 =
		                [0, "New deadline in ISO 8601 format. Pass null to clear."],
		              bn5 = [0, "The UUID of the task to update."],
		              bn1 =
		                [0,
		                 "Update an existing task by its UUID. Only included fields are changed."],
		              bn2 = [0, cst_input],
		              match$474 = [0, 0],
		              match$475 = [0, 0],
		              match$476 = [0, 0],
		              bnY =
		                [0,
		                 "Whether the task is created in a completed state (default false)."],
		              match$477 = [0, 0],
		              bnZ =
		                [0,
		                 'Deadline in ISO 8601 format (e.g. "2026-01-01T15:00:00.000Z").'],
		              bn0 = [0, "The text content of the task (max 2000 characters)."],
		              bnW =
		                [0,
		                 "Create a new task. Tasks can be linked to records and assigned to\n      workspace members."],
		              bnX = [0, cst_input],
		              bnV = [0, cst_input],
		              bnT =
		                [0,
		                 "Create a new company record. The [values] object holds common attribute\n      slugs (name, domains, etc.)."],
		              bnU = [0, "create_company_values"],
		              bnS = [0, "The UUID of the company record to retrieve."],
		              bnQ = [0, "Fetch a single company record by its UUID."],
		              bnR = [0, cst_input],
		              match$473 = [0, 0],
		              bnO = [0, cst_Maximum_number_of_results_],
		              bnP =
		                [0,
		                 "Query string to search for (max 256 characters). Matches across\n            company attributes such as name and domains."],
		              bnM =
		                [0,
		                 "Search company records using full-text search across company attributes."],
		              bnN = [0, cst_input],
		              bnL = [0, cst_input],
		              match$469 = [0, 0],
		              match$470 = [0, 0],
		              match$471 = [0, 0],
		              match$472 = [0, 0],
		              bnK = [0, "update_person_values"],
		              bnJ = [0, cst_input],
		              match$465 = [0, 0],
		              match$466 = [0, 0],
		              match$467 = [0, 0],
		              match$468 = [0, 0],
		              bnI = [0, "create_person_values"],
		              bnH = [0, "The UUID of the person record to retrieve."],
		              bnF = [0, "Fetch a single person record by its UUID."],
		              bnG = [0, cst_input],
		              match$464 = [0, 0],
		              bnD = [0, cst_Maximum_number_of_results_],
		              bnE =
		                [0,
		                 "Query string to search for (max 256 characters). Matches across\n            person attributes such as name and email."],
		              bnB =
		                [0,
		                 "Search person records using full-text search across person attributes."],
		              bnC = [0, cst_input],
		              bnA = [0, cst_input],
		              match$461 = [0, 0],
		              match$462 = [0, 0],
		              match$463 = [0, 0],
		              bnz = [0, "update_deal_values"],
		              bny = [0, cst_input],
		              match$458 = [0, 0],
		              match$459 = [0, 0],
		              match$460 = [0, 0],
		              bnx = [0, "create_deal_values"],
		              bnw = [0, "The UUID of the deal record to retrieve."],
		              bnu = [0, "Fetch a single deal record by its UUID."],
		              bnv = [0, cst_input],
		              match$457 = [0, 0],
		              bns = [0, cst_Maximum_number_of_results_],
		              bnt =
		                [0,
		                 "Query string to search for (max 256 characters). Matches across deal\n            attributes such as name and stage."],
		              bnq =
		                [0,
		                 "Search deal records using full-text search across deal attributes."],
		              bnr = [0, cst_input],
		              bnp =
		                [0,
		                 "Concatenation of first_name and last_name (Attio requires it)."],
		              bnn =
		                [0,
		                 "Person name attribute value. Attio expects [name] on a person to be an array\n    containing one such object, and requires [full_name]."],
		              bno = [0, cst_person_name],
		              bnl = [0, "UUID of the workspace member."],
		              bnm =
		                [0,
		                 'Actor type \xe2\x80\x94 always "workspace-member" for current Attio actors.'],
		              bnj =
		                [0,
		                 "Reference to a workspace member, used as an actor for owners and assignees."],
		              bnk = [0, "actor_reference"],
		              bnh = [0, "UUID of the target record."],
		              bni =
		                [0,
		                 'Object slug or ID of the target (e.g. "people", "companies", "deals").'],
		              bnf =
		                [0,
		                 "Reference to another record, used to link records to tasks."],
		              bng = [0, "linked_record"],
		              bpg = [0, "ID of the task to delete."],
		              bpf = [0, cst_input],
		              match$507 = [0, 0],
		              bo5 = [0, "Set to true to archive the task."],
		              match$508 = [0, 0],
		              bo6 = [0, cst_Time_estimate_in_milliseco],
		              match$509 = [0, 0],
		              bo7 = [0, cst_Set_to_true_to_include_tim],
		              match$510 = [0, 0],
		              bo8 = [0, cst_Start_date_as_Unix_timesta],
		              match$511 = [0, 0],
		              bo9 = [0, cst_Set_to_true_to_include_tim$0],
		              match$512 = [0, 0],
		              bo_ = [0, cst_Due_date_as_Unix_timestamp],
		              match$513 = [0, 0],
		              bo$ = [0, cst_Task_priority_1_Urgent_2_H],
		              match$514 = [0, 0],
		              bpa = [0, "Status of the task."],
		              match$515 = [0, 0],
		              bpb = [0, "Markdown formatted description."],
		              match$516 = [0, 0],
		              bpc = [0, cst_Task_description_in_plain_],
		              match$517 = [0, 0],
		              bpd = [0, "New name for the task."],
		              bpe = [0, "ID of the task to update."],
		              bo4 = [0, cst_input],
		              match$494 = [0, 0],
		              boP = [0, "If true, send notifications to everyone."],
		              match$495 = [0, 0],
		              boQ = [0, "Task ID to create this task as a subtask of."],
		              match$496 = [0, 0],
		              boR = [0, "Array of tag names to add to the task."],
		              match$497 = [0, 0],
		              boS = [0, "Array of user IDs to assign to the task."],
		              match$498 = [0, 0],
		              boT = [0, cst_Time_estimate_in_milliseco],
		              match$499 = [0, 0],
		              boU = [0, cst_Set_to_true_to_include_tim],
		              match$500 = [0, 0],
		              boV = [0, cst_Start_date_as_Unix_timesta],
		              match$501 = [0, 0],
		              boW = [0, cst_Set_to_true_to_include_tim$0],
		              match$502 = [0, 0],
		              boX = [0, cst_Due_date_as_Unix_timestamp],
		              match$503 = [0, 0],
		              boY = [0, cst_Task_priority_1_Urgent_2_H],
		              match$504 = [0, 0],
		              boZ =
		                [0,
		                 "Status of the task (must match a status defined in the list)."],
		              match$505 = [0, 0],
		              bo0 =
		                [0,
		                 "Markdown formatted description (overrides description if provided)."],
		              match$506 = [0, 0],
		              bo1 = [0, cst_Task_description_in_plain_],
		              bo2 = [0, cst_Name_of_the_task],
		              bo3 = [0, "ID of the list to create the task in."],
		              boO = [0, cst_input],
		              match$492 = [0, 0],
		              boL = [0, "Return task description in Markdown format."],
		              match$493 = [0, 0],
		              boM = [0, cst_Include_subtasks_in_the_re],
		              boN = [0, "ID of the task to retrieve."],
		              boK = [0, cst_input],
		              match$486 = [0, 0],
		              boD = [0, cst_Include_subtasks_in_the_re],
		              match$487 = [0, 0],
		              boE = [0, "Reverse the sort order."],
		              match$488 = [0, 0],
		              boF = [0, "Field to order by: id, created, updated, due_date."],
		              match$489 = [0, 0],
		              boG = [0, "Page number for pagination (starts at 0)."],
		              match$490 = [0, 0],
		              boH = [0, "Include closed tasks (default false)."],
		              match$491 = [0, 0],
		              boI = [0, "Include archived tasks (default false)."],
		              boJ = [0, "ID of the list to get tasks from."],
		              boC = [0, cst_input],
		              boB = [0, "ID of the list to retrieve."],
		              boA = [0, cst_input],
		              match$485 = [0, 0],
		              boy = [0, cst_Include_archived_lists_def],
		              boz = [0, "ID of the space to list folderless lists from."],
		              box = [0, cst_input],
		              match$484 = [0, 0],
		              bov = [0, cst_Include_archived_lists_def],
		              bow = [0, "ID of the folder to list lists from."],
		              bou = [0, cst_input],
		              bot = [0, "ID of the folder to retrieve."],
		              bos = [0, cst_input],
		              match$483 = [0, 0],
		              boq = [0, "Include archived folders (default false)."],
		              bor = [0, "ID of the space to list folders from."],
		              bop = [0, cst_input],
		              boo = [0, "ID of the space to retrieve."],
		              bon = [0, cst_input],
		              match$482 = [0, 0],
		              bol = [0, "Include archived spaces (default false)."],
		              bom = [0, "Workspace (team) ID. Get it from Get Workspaces."],
		              bok = [0, cst_input],
		              bqS =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   ' an optional "author" object to attribute the action to a specific user (by id, userId, or email). Omit it to use the authenticated account.',
		                   0]],
		                 '%s an optional "author" object to attribute the action to a specific user (by id, userId, or email). Omit it to use the authenticated account.'],
		              bqT =
		                [0,
		                 [11,
		                  "List, retrieve, create, update, and delete comments.\n\n# Comments\nComments are threaded discussions on a post or changelog. Comment content is HTML. Replies reference their parent via parentCommentId.\n\n# Acting on behalf of users\n",
		                  [2, 0, 0]],
		                 "List, retrieve, create, update, and delete comments.\n\n# Comments\nComments are threaded discussions on a post or changelog. Comment content is HTML. Replies reference their parent via parentCommentId.\n\n# Acting on behalf of users\n%s"],
		              bqU =
		                [0,
		                 [11,
		                  'List, retrieve, create, update, and delete posts and boards.\n\n# Boards\nBoards are the categories that contain posts. Use "List Boards" to discover board IDs before creating a post.\n\n# Posts\nPosts are user-submitted feedback items that belong to a board. Each post has a status, tags, votes, and comments. Use "List Posts" to find post IDs, then "Get Post" for full details.\n\n# Acting on behalf of users\n',
		                  [2, 0, 0]],
		                 'List, retrieve, create, update, and delete posts and boards.\n\n# Boards\nBoards are the categories that contain posts. Use "List Boards" to discover board IDs before creating a post.\n\n# Posts\nPosts are user-submitted feedback items that belong to a board. Each post has a status, tags, votes, and comments. Use "List Posts" to find post IDs, then "Get Post" for full details.\n\n# Acting on behalf of users\n%s'],
		              bqR = [0, cst_Comment_unique_identifier],
		              bqP =
		                [0,
		                 "Delete a comment. Comments with replies are soft-deleted; others are\n      removed permanently."],
		              bqQ = [0, cst_input],
		              match$572 = [0, 0],
		              bqK = [0, "Whether the comment is pending moderation review."],
		              match$573 = [0, 0],
		              bqL = [0, "Whether the comment is pinned at the top."],
		              match$574 = [0, 0],
		              bqM = [0, "Whether the comment is visible only to admins."],
		              match$575 = [0, 0],
		              bqN = [0, cst_Comment_content_in_HTML_fo],
		              bqO = [0, cst_Comment_unique_identifier],
		              bqI =
		                [0,
		                 "Update an existing comment. Only provided fields are modified."],
		              bqJ = [0, cst_input],
		              match$566 = [0, 0],
		              bqB = [0, "Post the comment on behalf of a specific user."],
		              match$567 = [0, 0],
		              bqC =
		                [0,
		                 "Whether to notify voters about the comment (default true)."],
		              match$568 = [0, 0],
		              bqD =
		                [0,
		                 "Whether the comment is visible only to admins (default false)."],
		              match$569 = [0, 0],
		              bqE = [0, "Parent comment ID when this is a reply."],
		              match$570 = [0, 0],
		              bqF =
		                [0,
		                 "Changelog ID to comment on (required unless postId is set)."],
		              match$571 = [0, 0],
		              bqG =
		                [0,
		                 "Post ID to comment on (required unless changelogId is set)."],
		              bqH = [0, cst_Comment_content_in_HTML_fo],
		              bqz =
		                [0,
		                 "Create a comment on a post or changelog, or a reply to a comment."],
		              bqA = [0, cst_input],
		              bqy = [0, cst_Comment_unique_identifier],
		              bqw = [0, "Get a single comment by ID."],
		              bqx = [0, cst_input],
		              match$559 = [0, 0],
		              bqp =
		                [0, 'Sort order: "best" (default), "top", "new", or "old".'],
		              match$560 = [0, 0],
		              bqq = [0, cst_Pagination_cursor_from_a_p],
		              match$561 = [0, 0],
		              bqr = [0, "Max comments to return (1-100, default 10)."],
		              match$562 = [0, 0],
		              bqs = [0, "Filter by moderation status."],
		              match$563 = [0, 0],
		              bqt = [0, 'Filter by privacy: "public", "private", or "all".'],
		              match$564 = [0, 0],
		              bqu = [0, "Filter comments by changelog ID."],
		              match$565 = [0, 0],
		              bqv = [0, "Filter comments by post ID."],
		              bqn =
		                [0,
		                 "List comments for the organization, with optional filtering and sorting."],
		              bqo = [0, cst_input],
		              bqm = [0, "Board unique identifier."],
		              bqk = [0, "Get a single board by ID."],
		              bql = [0, cst_input],
		              match$557 = [0, 0],
		              bqh = [0, "Voter email to identify the user."],
		              match$558 = [0, 0],
		              bqi = [0, cst_External_user_ID_from_your],
		              bqj = [0, cst_Post_unique_identifier],
		              bqf =
		                [0,
		                 "Remove an upvote from a post, optionally on behalf of a user."],
		              bqg = [0, cst_input],
		              match$553 = [0, 0],
		              bqa =
		                [0,
		                 "Voter profile picture URL (used when creating a new user)."],
		              match$554 = [0, 0],
		              bqb = [0, "Voter display name (used when creating a new user)."],
		              match$555 = [0, 0],
		              bqc = [0, "Voter email (finds or creates the user)."],
		              match$556 = [0, 0],
		              bqd = [0, cst_External_user_ID_from_your],
		              bqe = [0, cst_Post_unique_identifier],
		              bp_ =
		                [0,
		                 "Add an upvote to a post, optionally on behalf of a user."],
		              bp$ = [0, cst_input],
		              match$551 = [0, 0],
		              bp7 = [0, cst_Pagination_cursor_from_a_p],
		              match$552 = [0, 0],
		              bp8 = [0, "Max voters to return (1-100, default 10)."],
		              bp9 = [0, cst_Post_unique_identifier],
		              bp5 = [0, "List the users who have upvoted a post."],
		              bp6 = [0, cst_input],
		              bp4 = [0, cst_Post_unique_identifier],
		              bp2 =
		                [0,
		                 "Permanently delete a post and all its comments and votes. Cannot be\n      undone."],
		              bp3 = [0, cst_input],
		              match$540 = [0, 0],
		              bpQ = [0, "Change the post's attribution."],
		              match$541 = [0, 0],
		              bpR =
		                [0,
		                 "When changing status, email voters about the update (default false)."],
		              match$542 = [0, 0],
		              bpS =
		                [0, 'Visibility: "public", "authorOnly", or "companyOnly".'],
		              match$543 = [0, 0],
		              bpT = [0, cst_Admin_ID_to_assign_this_po],
		              match$544 = [0, 0],
		              bpU = [0, "Whether the post is pending moderation."],
		              match$545 = [0, 0],
		              bpV = [0, "Whether comments are enabled."],
		              match$546 = [0, 0],
		              bpW = [0, "Tag names to set (replaces existing tags)."],
		              match$547 = [0, 0],
		              bpX = [0, "Status ID to set."],
		              match$548 = [0, 0],
		              bpY = [0, "Board ID to move the post to."],
		              match$549 = [0, 0],
		              bpZ = [0, cst_Post_content_in_HTML_forma],
		              match$550 = [0, 0],
		              bp0 = [0, cst_Post_title_minimum_2_chara],
		              bp1 = [0, cst_Post_unique_identifier],
		              bpO =
		                [0,
		                 "Update an existing post. Only provided fields are modified."],
		              bpP = [0, cst_input],
		              match$532 = [0, 0],
		              bpE =
		                [0,
		                 "Attribute the post to a specific user (defaults to the authenticated\n            user)."],
		              match$533 = [0, 0],
		              bpF =
		                [0,
		                 'Visibility: "public" (default), "authorOnly", or "companyOnly".'],
		              match$534 = [0, 0],
		              bpG = [0, cst_Admin_ID_to_assign_this_po],
		              match$535 = [0, 0],
		              bpH =
		                [0, "Whether the post is pending moderation (default false)."],
		              match$536 = [0, 0],
		              bpI = [0, "Whether comments are allowed (default true)."],
		              match$537 = [0, 0],
		              bpJ =
		                [0,
		                 "Status ID to set (defaults to the board's default status)."],
		              match$538 = [0, 0],
		              bpK = [0, "Tag names to attach."],
		              match$539 = [0, 0],
		              bpL = [0, cst_Post_content_in_HTML_forma],
		              bpM = [0, "Board ID to create the post in."],
		              bpN = [0, cst_Post_title_minimum_2_chara],
		              bpC = [0, "Create a new feedback post in a board."],
		              bpD = [0, cst_input],
		              bpB = [0, "Post unique identifier (ObjectId or slug)."],
		              bpz = [0, "Get a single post by ID with full details."],
		              bpA = [0, cst_input],
		              match$523 = [0, 0],
		              bpq = [0, 'Sort direction: "desc" (default) or "asc".'],
		              match$524 = [0, 0],
		              bpr =
		                [0,
		                 'Sort order: "createdAt" (default), "upvotes", "trending", or\n            "recent".'],
		              match$525 = [0, 0],
		              bps = [0, "Include posts pending moderation."],
		              match$526 = [0, 0],
		              bpt = [0, "Search query matching post title and content."],
		              match$527 = [0, 0],
		              bpu = [0, "Filter by tag names."],
		              match$528 = [0, 0],
		              bpv = [0, "Filter by status ID."],
		              match$529 = [0, 0],
		              bpw = [0, "Filter by board (category) ID."],
		              match$530 = [0, 0],
		              bpx =
		                [0,
		                 "Pagination cursor from a previous response's [nextCursor]. Empty for\n            first page."],
		              match$531 = [0, 0],
		              bpy = [0, "Max posts to return (1-100, default 10)."],
		              bpo =
		                [0,
		                 "List feedback posts for the organization, with optional filtering and\n      sorting."],
		              bpp = [0, cst_input],
		              match$518 = [0, 0],
		              bpj =
		                [0, "Profile picture URL (used when creating a new user)."],
		              match$519 = [0, 0],
		              bpk = [0, "Display name (used when creating a new user)."],
		              match$520 = [0, 0],
		              bpl =
		                [0,
		                 "User email (finds an existing user or creates a new one)."],
		              match$521 = [0, 0],
		              bpm = [0, cst_External_user_ID_from_your],
		              match$522 = [0, 0],
		              bpn = [0, "Featurebase user ID (direct reference)."],
		              bph =
		                [0,
		                 "Attribution for a post, comment, or vote created on behalf of a user. Pass\n    only the fields you have a real value for."],
		              bpi = [0, cst_author],
		              btI = [0, "Pull request number."],
		              btJ = [0, cst_Repository_name],
		              btK = [0, cst_Repository_owner_username_],
		              btG = [0, "Get a specific pull request."],
		              btH = [0, cst_input],
		              match$612 = [0, 0],
		              btx = [0, cst_Page_number_1_based],
		              match$613 = [0, 0],
		              bty = [0, cst_Results_per_page_default_3],
		              match$614 = [0, 0],
		              btz = [0, cst_Sort_direction_asc_or_desc],
		              match$615 = [0, 0],
		              btA =
		                [0,
		                 'Sort by: "created" (default), "updated", "popularity",\n            "long-running".'],
		              match$616 = [0, 0],
		              btB = [0, "Filter by base branch name."],
		              match$617 = [0, 0],
		              btC = [0, 'Filter by head branch (format: "user:ref-name").'],
		              match$618 = [0, 0],
		              btD = [0, cst_Filter_by_state_open_defau],
		              btE = [0, cst_Repository_name],
		              btF = [0, cst_Repository_owner_username_],
		              btw = [0, cst_input],
		              btv = [0, 0],
		              btt = [0, 0],
		              btr = [0, 0],
		              btp = [0, 0],
		              bto = [0, 0, 0, [9, cst_long_running], 0],
		              btq = [0, 0, 0, [9, cst_popularity], 0],
		              bts = [0, 0, 0, [9, cst_updated], 0],
		              btu = [0, 0, 0, [9, cst_created], 0],
		              btn = [0, cst_sort],
		              btl = [0, cst_Repository_name],
		              btm = [0, cst_Repository_owner_username_],
		              btj = [0, "Get a GitHub repository by owner and name."],
		              btk = [0, cst_input],
		              match$607 = [0, 0],
		              btd = [0, cst_Page_number_1_based],
		              match$608 = [0, 0],
		              bte = [0, cst_Results_per_page_default_3],
		              match$609 = [0, 0],
		              btf = [0, cst_Sort_direction_asc_or_desc$0],
		              match$610 = [0, 0],
		              btg =
		                [0,
		                 'Sort by: "created", "updated", "pushed", "full_name" (default).'],
		              match$611 = [0, 0],
		              bth =
		                [0,
		                 'Filter by repo type: "all", "owner" (default), "member".'],
		              bti = [0, "GitHub username."],
		              btc = [0, cst_input],
		              btb = [0, 0],
		              bs$ = [0, 0],
		              bs9 = [0, 0],
		              bs7 = [0, 0],
		              bs6 = [0, 0, 0, [9, cst_full_name], 0],
		              bs8 = [0, 0, 0, [9, cst_pushed], 0],
		              bs_ = [0, 0, 0, [9, cst_updated], 0],
		              bta = [0, 0, 0, [9, cst_created], 0],
		              bs5 = [0, cst_sort],
		              bs4 = [0, 0],
		              bs2 = [0, 0],
		              bs0 = [0, 0],
		              bsZ = [0, 0, 0, [9, cst_member], 0],
		              bs1 = [0, 0, 0, [9, cst_owner], 0],
		              bs3 = [0, 0, 0, [9, cst_all], 0],
		              bsY = [0, cst_type],
		              match$602 = [0, 0],
		              bsS = [0, cst_Page_number_1_based],
		              match$603 = [0, 0],
		              bsT = [0, cst_Results_per_page_default_3],
		              match$604 = [0, 0],
		              bsU = [0, cst_Sort_direction_asc_or_desc$0],
		              match$605 = [0, 0],
		              bsV =
		                [0,
		                 'Sort by: "created" (default), "updated", "pushed", "full_name".'],
		              match$606 = [0, 0],
		              bsW =
		                [0,
		                 'Filter by repo type: "all" (default), "public", "private", "forks",\n            "sources", "member".'],
		              bsX = [0, "Organization name (case-insensitive)."],
		              bsR = [0, cst_input],
		              bsQ = [0, 0],
		              bsO = [0, 0],
		              bsM = [0, 0],
		              bsK = [0, 0],
		              bsJ = [0, 0, 0, [9, cst_full_name], 0],
		              bsL = [0, 0, 0, [9, cst_pushed], 0],
		              bsN = [0, 0, 0, [9, cst_updated], 0],
		              bsP = [0, 0, 0, [9, cst_created], 0],
		              bsI = [0, cst_sort],
		              bsH = [0, 0],
		              bsF = [0, 0],
		              bsD = [0, 0],
		              bsB = [0, 0],
		              bsz = [0, 0],
		              bsx = [0, 0],
		              bsw = [0, 0, 0, [9, cst_member], 0],
		              bsy = [0, 0, 0, [9, cst_sources], 0],
		              bsA = [0, 0, 0, [9, cst_forks], 0],
		              bsC = [0, 0, 0, [9, cst_private], 0],
		              bsE = [0, 0, 0, [9, cst_public], 0],
		              bsG = [0, 0, 0, [9, cst_all], 0],
		              bsv = [0, cst_type],
		              match$598 = [0, 0],
		              bsq = [0, cst_Page_number_1_based],
		              match$599 = [0, 0],
		              bsr = [0, cst_Results_per_page_default_3],
		              match$600 = [0, 0],
		              bss = [0, 'Sort order: "asc" or "desc" (default).'],
		              match$601 = [0, 0],
		              bst =
		                [0,
		                 'Sort by: "comments", "reactions", "created" (default best match),\n            "updated", "interactions".'],
		              bsu =
		                [0,
		                 'Search query with qualifiers. Examples: "repo:owner/repo is:issue\n            is:open label:bug" (open bugs in a specific repo), "is:issue is:open\n            assignee:username" (issues assigned to someone). Common qualifiers:\n            [repo:owner/repo], [is:issue] (exclude PRs), [is:open] or\n            [is:closed], [label:name], [assignee:login], [author:login],\n            [milestone:name], [in:title], [in:body].'],
		              bsp = [0, cst_input],
		              bso = [0, 0],
		              bsm = [0, 0],
		              bsk = [0, 0],
		              bsi = [0, 0],
		              bsg = [0, 0],
		              bsf = [0, 0, 0, [9, cst_interactions], 0],
		              bsh = [0, 0, 0, [9, cst_updated], 0],
		              bsj = [0, 0, 0, [9, cst_created], 0],
		              bsl = [0, 0, 0, [9, cst_reactions], 0],
		              bsn = [0, 0, 0, [9, cst_comments], 0],
		              bse = [0, cst_sort],
		              match$595 = [0, 0],
		              br_ = [0, cst_Page_number_1_based],
		              match$596 = [0, 0],
		              br$ = [0, cst_Results_per_page_default_3],
		              match$597 = [0, 0],
		              bsa =
		                [0,
		                 "ISO 8601 timestamp \xe2\x80\x94 only comments updated at or after this time."],
		              bsb = [0, cst_Issue_or_PR_number],
		              bsc = [0, cst_Repository_name],
		              bsd = [0, cst_Repository_owner_username_],
		              br8 = [0, "List comments on an issue or pull request."],
		              br9 = [0, cst_input],
		              br4 = [0, "Comment body (markdown supported)."],
		              br5 = [0, cst_Issue_or_PR_number],
		              br6 = [0, cst_Repository_name],
		              br7 = [0, cst_Repository_owner_username_],
		              br2 = [0, "Create a comment on an issue or pull request."],
		              br3 = [0, cst_input],
		              match$588 = [0, 0],
		              brS = [0, "Milestone number to associate, or 0 to remove."],
		              match$589 = [0, 0],
		              brT =
		                [0,
		                 "Replacement list of label names (empty list clears all)."],
		              match$590 = [0, 0],
		              brU =
		                [0,
		                 "Replacement list of assignee logins (empty list clears all)."],
		              match$591 = [0, 0],
		              brV =
		                [0,
		                 'Reason when closing: "completed", "not_planned", or "reopened".'],
		              match$592 = [0, 0],
		              brW = [0, 'Set to "closed" to close or "open" to reopen.'],
		              match$593 = [0, 0],
		              brX = [0, "New body content (replaces existing)."],
		              match$594 = [0, 0],
		              brY = [0, cst_New_title],
		              brZ = [0, "Issue number to update."],
		              br0 = [0, cst_Repository_name],
		              br1 = [0, cst_Repository_owner_username_],
		              brR = [0, cst_input],
		              brQ = [0, 0],
		              brO = [0, 0],
		              brM = [0, 0],
		              brL = [0, 0, 0, [9, cst_reopened], 0],
		              brN = [0, 0, 0, [9, cst_not_planned], 0],
		              brP = [0, 0, 0, [9, cst_completed], 0],
		              brK = [0, cst_state_reason],
		              brJ = [0, 0],
		              brH = [0, 0],
		              brG = [0, 0, 0, [9, cst_closed], 0],
		              brI = [0, 0, 0, [9, cst_open], 0],
		              brF = [0, cst_state],
		              match$584 = [0, 0],
		              bry = [0, "Milestone number to associate."],
		              match$585 = [0, 0],
		              brz = [0, "Label names to add."],
		              match$586 = [0, 0],
		              brA = [0, "Logins of users to assign."],
		              match$587 = [0, 0],
		              brB = [0, "Issue body (markdown supported)."],
		              brC = [0, "Issue title."],
		              brD = [0, cst_Repository_name],
		              brE = [0, cst_Repository_owner_username_],
		              brw = [0, "Create a new issue in a GitHub repository."],
		              brx = [0, cst_input],
		              brt = [0, "Issue number."],
		              bru = [0, cst_Repository_name],
		              brv = [0, cst_Repository_owner_username_],
		              brr = [0, "Get a specific issue by number."],
		              brs = [0, cst_input],
		              match$576 = [0, 0],
		              brh = [0, cst_Page_number_1_based],
		              match$577 = [0, 0],
		              bri = [0, cst_Results_per_page_default_3],
		              match$578 = [0, 0],
		              brj = [0, cst_Sort_direction_asc_or_desc],
		              match$579 = [0, 0],
		              brk =
		                [0, 'Sort by: "created" (default), "updated", or "comments".'],
		              match$580 = [0, 0],
		              brl = [0, cst_Comma_separated_label_name],
		              match$581 = [0, 0],
		              brm = [0, "Filter by creator login."],
		              match$582 = [0, 0],
		              brn =
		                [0,
		                 'Filter by assignee login. Use "none" for unassigned, "*" for any.'],
		              match$583 = [0, 0],
		              bro = [0, cst_Filter_by_state_open_defau],
		              brp = [0, cst_Repository_name],
		              brq = [0, cst_Repository_owner_username_],
		              brg = [0, cst_input],
		              brf = [0, 0],
		              brd = [0, 0],
		              brb = [0, 0],
		              bra = [0, 0, 0, [9, cst_comments], 0],
		              brc = [0, 0, 0, [9, cst_updated], 0],
		              bre = [0, 0, 0, [9, cst_created], 0],
		              bq$ = [0, cst_sort],
		              bq_ = [0, 0],
		              bq8 = [0, 0],
		              bq6 = [0, 0],
		              bq5 = [0, 0, 0, [9, cst_all], 0],
		              bq7 = [0, 0, 0, [9, cst_closed], 0],
		              bq9 = [0, 0, 0, [9, cst_open], 0],
		              bq3 = [0, "Issue or PR state filter."],
		              bq4 = [0, cst_state],
		              bq2 = [0, 0],
		              bq0 = [0, 0],
		              bqZ = [0, 0, 0, [9, cst_desc], 0],
		              bq1 = [0, 0, 0, [9, cst_asc], 0],
		              bqX = [0, "Sort direction."],
		              bqY = [0, cst_direction],
		              bqV = [0, 'ISO 8601 timestamp (e.g. "2024-01-15T10:30:00Z").'],
		              bqW = [0, cst_timestamp],
		              match$691 = [0, 0],
		              bvj =
		                [0,
		                 "Expected HEAD SHA of the source branch \xe2\x80\x94 prevents merging if the\n            branch has received new commits since this SHA was read."],
		              match$692 = [0, 0],
		              bvk = [0, "Merge automatically when the pipeline succeeds."],
		              match$693 = [0, 0],
		              bvl = [0, cst_Delete_the_source_branch_a],
		              match$694 = [0, 0],
		              bvm = [0, "Squash all commits into one before merging."],
		              match$695 = [0, 0],
		              bvn =
		                [0,
		                 "Custom squash commit message (used when squash is true)."],
		              match$696 = [0, 0],
		              bvo =
		                [0, "Custom merge commit message. Defaults to the MR title."],
		              bvp = [0, "The internal IID of the merge request to merge."],
		              bvq = [0, cst_The_project_ID_integer_or_],
		              bvi = [0, cst_input],
		              match$680 = [0, 0],
		              bu7 = [0, "Squash commits when merging."],
		              match$681 = [0, 0],
		              bu8 = [0, cst_Delete_the_source_branch_a],
		              match$682 = [0, 0],
		              bu9 = [0, 'Transition: "close" to close, "reopen" to reopen.'],
		              match$683 = [0, 0],
		              bu_ = [0, "Milestone ID, or 0 to remove."],
		              match$684 = [0, 0],
		              bu$ =
		                [0, "Comma-separated label names (replaces all existing)."],
		              match$685 = [0, 0],
		              bva = [0, "Replacement list of reviewer IDs."],
		              match$686 = [0, 0],
		              bvb =
		                [0,
		                 "Replacement list of assignee IDs (empty list clears all)."],
		              match$687 = [0, 0],
		              bvc = [0, "User ID to assign; use 0 to unassign."],
		              match$688 = [0, 0],
		              bvd = [0, "New target branch."],
		              match$689 = [0, 0],
		              bve = [0, "New description (replaces existing)."],
		              match$690 = [0, 0],
		              bvf = [0, cst_New_title],
		              bvg = [0, "The internal IID of the merge request to update."],
		              bvh = [0, cst_The_project_ID_integer_or_],
		              bu6 = [0, cst_input],
		              match$672 = [0, 0],
		              buU = [0, "Squash all commits into one when merging."],
		              match$673 = [0, 0],
		              buV = [0, cst_Delete_the_source_branch_a],
		              match$674 = [0, 0],
		              buW = [0, "Milestone ID to associate."],
		              match$675 = [0, 0],
		              buX = [0, cst_Comma_separated_label_name$0],
		              match$676 = [0, 0],
		              buY = [0, "User IDs to request a review from."],
		              match$677 = [0, 0],
		              buZ = [0, "User IDs to assign (GitLab EE)."],
		              match$678 = [0, 0],
		              bu0 = [0, "User ID to assign the merge request to."],
		              match$679 = [0, 0],
		              bu1 = [0, "Description (Markdown supported)."],
		              bu2 = [0, "Title of the merge request."],
		              bu3 = [0, 'Branch to merge into (e.g. "main").'],
		              bu4 = [0, "Branch to merge from."],
		              bu5 = [0, cst_The_project_ID_integer_or_],
		              buT = [0, cst_input],
		              match$670 = [0, 0],
		              buP =
		                [0,
		                 "Include the number of commits that diverge from the target branch."],
		              match$671 = [0, 0],
		              buQ = [0, "Return description and title rendered as HTML."],
		              buR = [0, "The internal IID of the merge request."],
		              buS = [0, cst_The_project_ID_integer_or_],
		              buO = [0, cst_input],
		              match$657 = [0, 0],
		              buA = [0, cst_Page_number_1_based],
		              match$658 = [0, 0],
		              buB = [0, cst_Results_per_page_max_100_d],
		              match$659 = [0, 0],
		              buC = [0, cst_Sort_direction_asc_or_desc],
		              match$660 = [0, 0],
		              buD = [0, 'Order by: "created_at" (default), "updated_at".'],
		              match$661 = [0, 0],
		              buE = [0, "Search against title and description."],
		              match$662 = [0, 0],
		              buF = [0, "Filter by target branch name."],
		              match$663 = [0, 0],
		              buG = [0, "Filter by source branch name."],
		              match$664 = [0, 0],
		              buH = [0, "Filter by reviewer user ID."],
		              match$665 = [0, 0],
		              buI = [0, cst_Filter_by_assignee_user_ID],
		              match$666 = [0, 0],
		              buJ = [0, cst_Filter_by_author_user_ID],
		              match$667 = [0, 0],
		              buK = [0, cst_Milestone_title_to_filter_],
		              match$668 = [0, 0],
		              buL = [0, "Comma-separated label names to filter by."],
		              match$669 = [0, 0],
		              buM =
		                [0,
		                 'Filter by state: "opened" (default), "closed", "merged", or "all".'],
		              buN = [0, cst_The_project_ID_integer_or_],
		              buz = [0, cst_input],
		              match$648 = [0, 0],
		              buo = [0, "New weight (0\xe2\x80\x939, EE only)."],
		              match$649 = [0, 0],
		              bup = [0, "Change confidential status."],
		              match$650 = [0, 0],
		              buq = [0, cst_Due_date_in_YYYY_MM_DD_for],
		              match$651 = [0, 0],
		              bur =
		                [0,
		                 'Transition the issue: "close" to close, "reopen" to reopen.'],
		              match$652 = [0, 0],
		              bus =
		                [0,
		                 "Comma-separated label names (replaces all existing labels)."],
		              match$653 = [0, 0],
		              but = [0, "Milestone ID to associate, or 0 to remove."],
		              match$654 = [0, 0],
		              buu =
		                [0,
		                 "Replacement list of assignee user IDs (empty list clears all)."],
		              match$655 = [0, 0],
		              buv =
		                [0,
		                 "New description (Markdown supported, replaces existing)."],
		              match$656 = [0, 0],
		              buw = [0, cst_New_title],
		              bux = [0, "The internal ID of the issue to update."],
		              buy = [0, cst_The_project_ID_integer_or_],
		              bun = [0, cst_input],
		              match$641 = [0, 0],
		              bue = [0, "Weight of the issue (0\xe2\x80\x939, EE only)."],
		              match$642 = [0, 0],
		              buf = [0, "Mark the issue as confidential."],
		              match$643 = [0, 0],
		              bug = [0, cst_Due_date_in_YYYY_MM_DD_for],
		              match$644 = [0, 0],
		              buh = [0, cst_Comma_separated_label_name$0],
		              match$645 = [0, 0],
		              bui = [0, "Milestone ID to associate the issue with."],
		              match$646 = [0, 0],
		              buj = [0, "User IDs to assign the issue to."],
		              match$647 = [0, 0],
		              buk = [0, "Description of the issue (Markdown supported)."],
		              bul = [0, "Title of the issue."],
		              bum = [0, cst_The_project_ID_integer_or_],
		              bud = [0, cst_input],
		              bub =
		                [0,
		                 "The internal ID of the issue (project-scoped, not global)."],
		              buc = [0, cst_The_project_ID_integer_or_],
		              bua = [0, cst_input],
		              match$631 = [0, 0],
		              bt1 = [0, cst_Page_number_1_based],
		              match$632 = [0, 0],
		              bt2 = [0, cst_Results_per_page_max_100_d],
		              match$633 = [0, 0],
		              bt3 = [0, cst_Sort_direction_asc_or_desc],
		              match$634 = [0, 0],
		              bt4 =
		                [0,
		                 'Order by: "created_at" (default), "updated_at", "priority",\n            "due_date", "relative_position".'],
		              match$635 = [0, 0],
		              bt5 = [0, "Search issues against their title and description."],
		              match$636 = [0, 0],
		              bt6 = [0, cst_Filter_by_author_user_ID],
		              match$637 = [0, 0],
		              bt7 = [0, cst_Filter_by_assignee_user_ID],
		              match$638 = [0, 0],
		              bt8 = [0, cst_Milestone_title_to_filter_],
		              match$639 = [0, 0],
		              bt9 = [0, cst_Comma_separated_label_name],
		              match$640 = [0, 0],
		              bt_ =
		                [0,
		                 'Filter by state: "opened" (default), "closed", or "all".'],
		              bt$ = [0, cst_The_project_ID_integer_or_],
		              bt0 = [0, cst_input],
		              match$629 = [0, 0],
		              btX = [0, "Include project license data."],
		              match$630 = [0, 0],
		              btY =
		                [0, "Include repository size and commit count statistics."],
		              btZ =
		                [0,
		                 'The project ID (integer) or URL-encoded path (e.g.\n            "namespace%2Fproject").'],
		              btW = [0, cst_input],
		              match$619 = [0, 0],
		              btM = [0, cst_Page_number_1_based],
		              match$620 = [0, 0],
		              btN = [0, cst_Results_per_page_max_100_d],
		              match$621 = [0, 0],
		              btO = [0, 'Sort direction: "asc" or "desc". Default "desc".'],
		              match$622 = [0, 0],
		              btP =
		                [0,
		                 'Order by: "id", "name", "path", "created_at", "updated_at",\n            "last_activity_at", "similarity". Default "created_at".'],
		              match$623 = [0, 0],
		              btQ = [0, "Filter by archived status (true = only archived)."],
		              match$624 = [0, 0],
		              btR =
		                [0,
		                 'Filter by visibility: "public", "internal", or "private".'],
		              match$625 = [0, 0],
		              btS = [0, "Limit to projects starred by the current user."],
		              match$626 = [0, 0],
		              btT = [0, "Limit to projects the current user is a member of."],
		              match$627 = [0, 0],
		              btU = [0, "Limit to projects owned by the current user."],
		              match$628 = [0, 0],
		              btV = [0, "Search for projects by name or path."],
		              btL = [0, cst_input],
		              bv5 = [0, "Draft ID to send immediately."],
		              bv6 = [0, cst_The_user_s_email_address_U],
		              bv3 =
		                [0,
		                 'Send existing draft as-is. Draft is deleted after sending; message appears\n      in SENT. To modify first, use "Update Draft".'],
		              bv4 = [0, cst_input],
		              match$709 = [0, 0],
		              bv0 =
		                [0,
		                 "Thread ID for replies (from original message's threadId). Empty for\n            new conversation."],
		              bv1 =
		                [0,
		                 "Email in RFC 2822 format, base64url encoded (see namespace docs for\n            format and encoding). Must include To, From, Subject headers and\n            body."],
		              bv2 = [0, cst_The_user_s_email_address_U],
		              bvY =
		                [0,
		                 "Send email. Use RFC 2822 format and base64url encoding (see namespace\n      docs). Include threadId for replies."],
		              bvZ = [0, cst_input],
		              match$708 = [0, 0],
		              bvU =
		                [0,
		                 "Thread ID to associate with. Empty keeps existing or starts new\n            conversation."],
		              bvV =
		                [0,
		                 "New email in RFC 2822 format, base64url encoded (see namespace\n            docs). Replaces ALL content."],
		              bvW = [0, "Draft ID from previous creation or listing."],
		              bvX = [0, cst_The_user_s_email_address_U],
		              bvS =
		                [0,
		                 'Replace draft content completely. To send without editing, use "Send\n      Draft".'],
		              bvT = [0, cst_input],
		              bvR =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_ai/tools/integration_app/gmail.ml",
		                  275,
		                  9786,
		                  9820]],
		              bvP = [0, c],
		              bvQ = [0, c],
		              bvO = [0, cst$31],
		              bvN = [0, 0],
		              match$705 = [0, 0],
		              match$706 = [0, 0],
		              match$707 = [0, 0],
		              bvM = [0, cst_input],
		              bvL = [0, cst_kind],
		              bvK = [0, cst_body],
		              match$704 = [0, 0],
		              bvH =
		                [0,
		                 "Thread ID for draft replies. Empty for new conversation."],
		              bvI =
		                [0,
		                 "Email in RFC 2822 format, base64url encoded (see namespace docs for\n            format). Must include To, From, Subject headers and body."],
		              bvJ = [0, cst_The_user_s_email_address_U],
		              bvF =
		                [0,
		                 "Create draft (unsent message). Gets DRAFT label automatically."],
		              bvG = [0, cst_input],
		              match$702 = [0, 0],
		              bvB =
		                [0,
		                 'With format "metadata", return only these headers (e.g.,\n            ["From", "To", "Subject"]).'],
		              match$703 = [0, 0],
		              bvC =
		                [0,
		                 'Response format: "full" (default, full message), "minimal" (ID and\n            labels only), "raw" (MIME for forwarding), "metadata" (headers only,\n            use with metadataHeaders).'],
		              bvD = [0, 'Message ID from "List Messages".'],
		              bvE = [0, cst_The_user_s_email_address_U],
		              bvz =
		                [0,
		                 'Get specific message by ID. Use after "List Messages" to get full content.'],
		              bvA = [0, cst_input],
		              match$697 = [0, 0],
		              bvt = [0, "Include SPAM and TRASH (default false)."],
		              match$698 = [0, 0],
		              bvu =
		                [0,
		                 'Filter by label IDs (must have ALL). Common: ["INBOX"], ["SENT"],\n            ["UNREAD"], ["STARRED"].'],
		              match$699 = [0, 0],
		              bvv =
		                [0,
		                 "Pagination token from previous [nextPageToken]. Empty for first\n            page."],
		              match$700 = [0, 0],
		              bvw = [0, "Max messages per page (default 100, max 500)."],
		              match$701 = [0, 0],
		              bvx =
		                [0,
		                 "Gmail search query. Examples: [from:sender@example.com] (from\n            someone), [to:recipient@example.com] (to someone), [subject:meeting]\n            (subject line), [is:unread] or [is:starred] (status),\n            [has:attachment] (with files), [after:2024/01/01] or\n            [before:2024/12/31] (date range), [newer_than:2d] (relative date).\n            Combine with spaces (AND logic). Leave empty for all messages."],
		              bvy = [0, cst_The_user_s_email_address_U],
		              bvr =
		                [0,
		                 'List messages in the user\'s mailbox with optional filtering. Returns\n      message IDs - use "Get Message" to fetch full content.'],
		              bvs = [0, cst_input],
		              bxl = [0, "The ID of the thread to mark as read."],
		              bxj = [0, "Mark every email in a thread as read."],
		              bxk = [0, cst_input],
		              match$752 = [0, 0],
		              bxd = [0, "Comma-separated list of BCC email addresses."],
		              match$753 = [0, 0],
		              bxe = [0, "Comma-separated list of CC email addresses."],
		              bxf = [0, "Reply body; set 'html', 'text', or both."],
		              bxg = [0, "Subject line of the reply."],
		              bxh = [0, "ID of the email being replied to."],
		              bxi =
		                [0,
		                 "The connected email account that will send the reply. Must be an\n            account connected to the workspace."],
		              bxb = [0, "Reply to an existing email in a thread."],
		              bxc = [0, cst_input],
		              match$750 = [0, 0],
		              bw$ = [0, "Plain-text body of the reply."],
		              match$751 = [0, 0],
		              bxa = [0, "HTML body of the reply."],
		              bw9 = [0, "Body of the reply: provide [html], [text], or both."],
		              bw_ = [0, cst_body],
		              match$742 = [0, 0],
		              bw1 = [0, cst_Forward_pagination_cursor_],
		              match$743 = [0, 0],
		              bw2 = [0, "Number of emails to return per page (1-100)."],
		              match$744 = [0, 0],
		              bw3 = [0, "Only return unread emails when true."],
		              match$745 = [0, 0],
		              bw4 =
		                [0, 'Type of email: ["received"], ["sent"], or ["manual"].'],
		              match$746 = [0, 0],
		              bw5 = [0, "Email address of the lead to filter by."],
		              match$747 = [0, 0],
		              bw6 =
		                [0,
		                 "The connected email account that sent the email. Comma-separate to\n            filter by multiple accounts."],
		              match$748 = [0, 0],
		              bw7 = [0, "Campaign ID (UUID) to filter emails by."],
		              match$749 = [0, 0],
		              bw8 =
		                [0,
		                 'Search query. A lead email address, or a thread search using the\n            ["thread:<thread_id>"] prefix.'],
		              bwZ =
		                [0,
		                 "List emails from the Unibox with optional filtering and pagination."],
		              bw0 = [0, cst_input],
		              bwY = [0, "The ID (UUID) of the campaign to pause."],
		              bwW = [0, "Stop or pause a campaign."],
		              bwX = [0, cst_input],
		              bwV = [0, "The ID (UUID) of the campaign to activate."],
		              bwT = [0, "Activate (start) or resume a campaign."],
		              bwU = [0, cst_input],
		              bwS = [0, "The ID (UUID) of the campaign to retrieve."],
		              bwQ = [0, "Retrieve a single campaign by its ID."],
		              bwR = [0, cst_input],
		              match$738 = [0, 0],
		              bwM = [0, cst_Forward_pagination_cursor_],
		              match$739 = [0, 0],
		              bwN = [0, "Number of campaigns to return per page (1-100)."],
		              match$740 = [0, 0],
		              bwO =
		                [0,
		                 "Filter by campaign status: 0 Draft, 1 Active, 2 Paused, 3 Completed,\n            4 Running Subsequences."],
		              match$741 = [0, 0],
		              bwP = [0, "Search by campaign name."],
		              bwK =
		                [0,
		                 "List campaigns with optional search, status filter, and pagination."],
		              bwL = [0, cst_input],
		              match$729 = [0, 0],
		              bwB = [0, "When true, copy the leads instead of moving them."],
		              match$730 = [0, 0],
		              bwC = [0, "Maximum number of leads to move."],
		              match$731 = [0, 0],
		              bwD =
		                [0,
		                 "Predefined filter to select leads (see 'List Leads' filter values)."],
		              match$732 = [0, 0],
		              bwE =
		                [0,
		                 "Free-text search to select leads (first name, last name, email)."],
		              match$733 = [0, 0],
		              bwF = [0, "Source lead-list ID (UUID) to select leads from."],
		              match$734 = [0, 0],
		              bwG = [0, "Source campaign ID (UUID) to select leads from."],
		              match$735 = [0, 0],
		              bwH =
		                [0,
		                 "Explicit lead IDs (UUIDs) to move. When used, you must also pass the\n            source 'campaign' or 'list_id' the leads currently belong to."],
		              match$736 = [0, 0],
		              bwI =
		                [0, "Destination lead-list ID (UUID) to move the leads to."],
		              match$737 = [0, 0],
		              bwJ =
		                [0, "Destination campaign ID (UUID) to move the leads to."],
		              bwz =
		                [0,
		                 "Move (or copy) leads matching a filter into a target campaign or list."],
		              bwA = [0, cst_input],
		              match$727 = [0, 0],
		              bwv = [0, "Lead-list ID (UUID) the lead belongs to."],
		              match$728 = [0, 0],
		              bww = [0, "Campaign ID (UUID) the lead belongs to."],
		              bwx =
		                [0,
		                 'Interest status to set. Values: 1 Interested, 2 Meeting Booked, 3\n            Meeting Completed, 4 Won, 0 Out of Office, -1 Not Interested, -2\n            Wrong Person, -3 Lost, -4 No Show. Pass null to reset the lead back\n            to "Lead".'],
		              bwy = [0, "Email of the lead whose status to update."],
		              bwt =
		                [0, "Update the interest status of a lead within a campaign."],
		              bwu = [0, cst_input],
		              bws = [0, "The ID (UUID) of the lead to retrieve."],
		              bwq = [0, "Retrieve a single lead by its ID."],
		              bwr = [0, cst_input],
		              match$717 = [0, 0],
		              bwg = [0, "Lead-list ID (UUID) to add the lead to on creation."],
		              match$718 = [0, 0],
		              bwh = [0, "Campaign ID (UUID) to add the lead to on creation."],
		              match$719 = [0, 0],
		              bwi = [0, "Personalization snippet used in campaign messages."],
		              match$720 = [0, 0],
		              bwj = [0, "Website of the lead."],
		              match$721 = [0, 0],
		              bwk = [0, "Phone number of the lead."],
		              match$722 = [0, 0],
		              bwl = [0, "Job title of the lead."],
		              match$723 = [0, 0],
		              bwm = [0, "Company name of the lead."],
		              match$724 = [0, 0],
		              bwn = [0, "Last name of the lead."],
		              match$725 = [0, 0],
		              bwo = [0, "First name of the lead."],
		              match$726 = [0, 0],
		              bwp = [0, "Email address of the lead."],
		              bwe =
		                [0,
		                 "Create a single lead, optionally adding it directly to a campaign or list."],
		              bwf = [0, cst_input],
		              match$710 = [0, 0],
		              bv9 =
		                [0,
		                 "Forward pagination cursor: the [id] of the last lead from the\n            previous page."],
		              match$711 = [0, 0],
		              bv_ = [0, "Number of leads to return per page (1-100)."],
		              match$712 = [0, 0],
		              bv$ =
		                [0,
		                 "Restrict the result to this explicit set of lead IDs (UUIDs)."],
		              match$713 = [0, 0],
		              bwa =
		                [0,
		                 "Lead-list ID (UUID) to only return leads belonging to that list."],
		              match$714 = [0, 0],
		              bwb =
		                [0,
		                 "Campaign ID (UUID) to only return leads belonging to that campaign."],
		              match$715 = [0, 0],
		              bwc =
		                [0,
		                 "Predefined filter. Common values: [FILTER_VAL_CONTACTED],\n            [FILTER_VAL_NOT_CONTACTED], [FILTER_VAL_COMPLETED],\n            [FILTER_VAL_UNSUBSCRIBED], [FILTER_VAL_ACTIVE],\n            [FILTER_LEAD_INTERESTED], [FILTER_LEAD_NOT_INTERESTED],\n            [FILTER_VAL_BOUNCED], [FILTER_VAL_REPLIED]."],
		              match$716 = [0, 0],
		              bwd =
		                [0,
		                 "Free-text search matched against the lead's first name, last name,\n            or email."],
		              bv7 =
		                [0,
		                 "List leads in the workspace with optional filtering and pagination."],
		              bv8 = [0, cst_input],
		              bzi =
		                [0,
		                 [11,
		                  "Transition issues and get available transitions\n\n",
		                  [2,
		                   0,
		                   [11,
		                    "\n\n# Comment bodies and rich text\nThe optional transition `comment.body` uses ",
		                    [2,
		                     0,
		                     [11,
		                      '\n\n# Workflow transitions\nStatus changes go through workflow transitions. Call "Get Issue Transitions" to discover available transition IDs for an issue, then pass one to "Transition Issue".',
		                      0]]]]],
		                 'Transition issues and get available transitions\n\n%s\n\n# Comment bodies and rich text\nThe optional transition `comment.body` uses %s\n\n# Workflow transitions\nStatus changes go through workflow transitions. Call "Get Issue Transitions" to discover available transition IDs for an issue, then pass one to "Transition Issue".'],
		              bzj =
		                [0,
		                 [11,
		                  "Get, add, update, and delete comments\n\n",
		                  [2,
		                   0,
		                   [11,
		                    "\n\n# Comment bodies and rich text\nComment bodies use ",
		                    [2, 0, 0]]]],
		                 "Get, add, update, and delete comments\n\n%s\n\n# Comment bodies and rich text\nComment bodies use %s"],
		              bzk =
		                [0,
		                 [11,
		                  "Get, create, search, delete, update, and assign issues\n\n",
		                  [2,
		                   0,
		                   [11,
		                    "\n\n# Comment bodies and rich text\nThe issue `description` field uses ",
		                    [2,
		                     0,
		                     [11,
		                      '\n\n# Issue fields\nWhen creating or updating issues, the `fields` object follows Jira\'s REST API field model: `project` and `issuetype` reference objects, `summary` is a string, `assignee` uses `{accountId: "..."}`, and so on. See https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/ for the field reference.\n\n# JQL\n"Search Issues (JQL)" accepts Jira Query Language. See https://support.atlassian.com/jira-software-cloud/docs/what-is-advanced-search-in-jira-cloud/ for syntax.',
		                      0]]]]],
		                 'Get, create, search, delete, update, and assign issues\n\n%s\n\n# Comment bodies and rich text\nThe issue `description` field uses %s\n\n# Issue fields\nWhen creating or updating issues, the `fields` object follows Jira\'s REST API field model: `project` and `issuetype` reference objects, `summary` is a string, `assignee` uses `{accountId: "..."}`, and so on. See https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/ for the field reference.\n\n# JQL\n"Search Issues (JQL)" accepts Jira Query Language. See https://support.atlassian.com/jira-software-cloud/docs/what-is-advanced-search-in-jira-cloud/ for syntax.'],
		              bzh =
		                [0,
		                 "Required fields for issue creation. Must include at least [project],\n            [summary], and [issuetype]. See\n            https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/#api-rest-api-3-issue-post\n            for field reference."],
		              bzg = [0, cst_input],
		              match$805 = [0, 0],
		              bzf = [0, cst_MUST_be_Atlassian_Document],
		              bze = [0, "issue_fields"],
		              match$803 = [0, 0],
		              match$804 = [0, 0],
		              bzd = [0, "issuetype_ref"],
		              match$801 = [0, 0],
		              match$802 = [0, 0],
		              bzc = [0, "project_ref"],
		              match$799 = [0, 0],
		              by$ =
		                [0,
		                 'Comma-separated expand options: "renderedFields", "names", "schema",\n            "transitions", "operations", "editmeta", "changelog",\n            "versionedRepresentations".'],
		              match$800 = [0, 0],
		              bza =
		                [0,
		                 'Comma-separated list of fields to return. Use "*all" for all fields,\n            "*navigable" for navigable fields, or specific field names.'],
		              bzb =
		                [0,
		                 'The ID or key of the issue (e.g. "PROJ-123" or "10001").'],
		              by9 = [0, "Get details of a specific issue by its ID or key."],
		              by_ = [0, cst_input],
		              match$796 = [0, 0],
		              by5 =
		                [0,
		                 "Whether to notify users about the update (default true)."],
		              match$797 = [0, 0],
		              by6 =
		                [0,
		                 "Map of field name to a list of operations for complex updates."],
		              match$798 = [0, 0],
		              by7 =
		                [0,
		                 "Issue fields to update. See\n            https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/#api-rest-api-3-issue-issueidorkey-put."],
		              by8 = [0, "The ID or key of the issue to update."],
		              by3 = [0, "Represents the issue fields"],
		              by4 = [0, cst_input],
		              match$791 = [0, 0],
		              by1 =
		                [0,
		                 'List of labels to set on the issue. This replaces all existing\n              labels. To add or remove specific labels without replacing the\n              entire list, use the [update] field with "add" or "remove"\n              operations instead.'],
		              match$792 = [0, 0],
		              match$793 = [0, 0],
		              match$794 = [0, 0],
		              by2 = [0, cst_MUST_be_Atlassian_Document],
		              match$795 = [0, 0],
		              by0 = [0, "update_fields"],
		              match$789 = [0, 0],
		              match$790 = [0, 0],
		              byZ = [0, cst_assignee_ref],
		              match$787 = [0, 0],
		              match$788 = [0, 0],
		              byY = [0, "priotity_ref"],
		              match$786 = [0, 0],
		              byW =
		                [0,
		                 'Whether to delete subtasks. Set to "true" to delete subtasks; if\n            "false" or omitted the request fails when the issue has subtasks.'],
		              byX = [0, "The ID or key of the issue to delete."],
		              byV = [0, cst_input],
		              byU = [0, 0],
		              byS = [0, 0],
		              byR = [0, 0, 0, [9, cst_false], 0],
		              byT = [0, 0, 0, [9, cst_true], 0],
		              byQ = [0, "delete_subtasks"],
		              match$782 = [0, 0],
		              byL =
		                [0,
		                 'Comma-separated expand options: "renderedFields", "names", "schema",\n            "transitions", "operations", "editmeta", "changelog".'],
		              match$783 = [0, 0],
		              byM =
		                [0, "Token for pagination to fetch the next page of results."],
		              match$784 = [0, 0],
		              byN =
		                [0,
		                 "Maximum number of results to return (max 5000, default 50)."],
		              match$785 = [0, 0],
		              byO =
		                [0,
		                 'Fields to return. Use ["*all"] for all fields, ["*navigable"] for\n            navigable fields. Default returns only IDs.'],
		              byP =
		                [0,
		                 'JQL query string. Examples: "project = PROJ" (all issues in\n            project), "assignee = currentUser()" (issues assigned to current\n            user), "status = \\"In Progress\\"" (issues in progress), "created >=\n            -7d" (created in last 7 days). See JQL docs at\n            https://support.atlassian.com/jira-software-cloud/docs/what-is-advanced-search-in-jira-cloud/.'],
		              byJ = [0, "Search for issues using JQL (Jira Query Language)."],
		              byK = [0, cst_input],
		              match$781 = [0, 0],
		              byH =
		                [0,
		                 'Expand options: "transitions.fields" to include fields required by\n            each transition.'],
		              byI = [0, cst_The_ID_or_key_of_the_issue],
		              byF = [0, "Get available workflow transitions for an issue."],
		              byG = [0, cst_input],
		              match$778 = [0, 0],
		              byA =
		                [0,
		                 "Comment to add during transition. Should include [body] with\n            Atlassian Document Format content."],
		              match$779 = [0, 0],
		              byB = [0, "Additional field updates to perform."],
		              match$780 = [0, 0],
		              byC =
		                [0,
		                 "Fields to set during the transition (if required by the transition\n            screen)."],
		              byD =
		                [0,
		                 'The ID of the transition to perform. Get available IDs from "Get\n            Issue Transitions".'],
		              byE = [0, "The ID or key of the issue to transition."],
		              byz = [0, cst_input],
		              byy =
		                [0,
		                 "Comment body in Atlassian Document Format (ADF). See ADF docs at\n              https://developer.atlassian.com/cloud/jira/platform/apis/document/structure/."],
		              byx = [0, "transition_comment"],
		              match$776 = [0, 0],
		              match$777 = [0, 0],
		              byw = [0, "transition_fields"],
		              match$775 = [0, 0],
		              byv = [0, cst_assignee_ref],
		              match$773 = [0, 0],
		              match$774 = [0, 0],
		              byu = [0, "resolution_ref"],
		              match$772 = [0, 0],
		              bys =
		                [0,
		                 'Account ID of the user to assign. Use "-1" to unassign or omit to\n            leave unchanged.'],
		              byt = [0, "The ID or key of the issue to assign."],
		              byq = [0, "Assign an issue to a user."],
		              byr = [0, cst_input],
		              match$771 = [0, 0],
		              byn = [0, cst_Restrict_visibility_of_the],
		              byo =
		                [0,
		                 "Comment body in Atlassian Document Format (ADF). See ADF docs at\n            https://developer.atlassian.com/cloud/jira/platform/apis/document/structure/."],
		              byp = [0, cst_The_ID_or_key_of_the_issue],
		              byl = [0, "Add a comment to an issue."],
		              bym = [0, cst_input],
		              match$767 = [0, 0],
		              byg =
		                [0,
		                 'Expand options: "renderedBody" to include rendered HTML.'],
		              match$768 = [0, 0],
		              byh =
		                [0,
		                 'Order results by. Use "-created" for newest first, "created" for\n            oldest first.'],
		              match$769 = [0, 0],
		              byi =
		                [0,
		                 "Maximum number of comments to return (default 50, max 100)."],
		              match$770 = [0, 0],
		              byj = [0, "Index of the first comment to return (0-based)."],
		              byk = [0, cst_The_ID_or_key_of_the_issue],
		              bye = [0, "Get all comments on an issue."],
		              byf = [0, cst_input],
		              match$766 = [0, 0],
		              bya = [0, cst_Restrict_visibility_of_the],
		              byb =
		                [0,
		                 "Updated comment body in Atlassian Document Format (ADF). See ADF\n            docs at\n            https://developer.atlassian.com/cloud/jira/platform/apis/document/structure/."],
		              byc = [0, "The ID of the comment to update."],
		              byd = [0, cst_The_ID_or_key_of_the_issue],
		              bx_ = [0, "Update an existing comment on an issue."],
		              bx$ = [0, cst_input],
		              bx8 = [0, "The ID of the comment to delete."],
		              bx9 = [0, cst_The_ID_or_key_of_the_issue],
		              bx6 = [0, "Delete a comment from an issue."],
		              bx7 = [0, cst_input],
		              match$763 = [0, 0],
		              bx3 = [0, cst_Comma_separated_list_of_pr],
		              match$764 = [0, 0],
		              bx4 =
		                [0,
		                 "Return only the user's most recently accessed projects (up to 20)."],
		              match$765 = [0, 0],
		              bx5 = [0, cst_Comma_separated_expand_opt],
		              bx1 = [0, "Get a list of all projects visible to the user."],
		              bx2 = [0, cst_input],
		              match$761 = [0, 0],
		              bxY = [0, cst_Comma_separated_list_of_pr],
		              match$762 = [0, 0],
		              bxZ = [0, cst_Comma_separated_expand_opt],
		              bx0 = [0, 'The project ID or key (e.g. "PROJ").'],
		              bxW = [0, "Get details of a specific project."],
		              bxX = [0, cst_input],
		              match$758 = [0, 0],
		              bxS = [0, "Maximum number of results to return (default 50)."],
		              match$759 = [0, 0],
		              bxT = [0, "Index of the first result to return (0-based)."],
		              match$760 = [0, 0],
		              bxU = [0, "Exact account ID to search for."],
		              bxV =
		                [0,
		                 "Search query matched against [displayName] and [emailAddress]."],
		              bxQ = [0, "Search for users by name, email, or account ID."],
		              bxR = [0, cst_input],
		              match$757 = [0, 0],
		              bxO = [0, cst_Expand_options_groups_appl],
		              bxP = [0, "The account ID of the user."],
		              bxM = [0, "Get details of a specific user by account ID."],
		              bxN = [0, cst_input],
		              bxK = [0, cst_Get_all_issue_types_availa],
		              bxL = [0, cst_input],
		              bxI = [0, cst_Get_all_issue_priorities],
		              bxJ = [0, cst_input],
		              bxG = [0, cst_Get_all_issue_statuses],
		              bxH = [0, cst_input],
		              match$756 = [0, 0],
		              bxF = [0, cst_Expand_options_groups_appl],
		              bxD = [0, cst_Get_details_of_the_current],
		              bxE = [0, cst_input],
		              bxB = [0, 'Always pass "doc"'],
		              bxC = [0, "Always pass 1"],
		              bxA = [0, "adf_doc"],
		              bxz = [0, 'Always pass "paragraph"'],
		              bxy = [0, "adf_paragraph"],
		              bxw = [0, "The actual text content"],
		              bxx = [0, 'Always pass "text"'],
		              bxv = [0, "adf_text"],
		              match$754 = [0, 0],
		              bxs =
		                [0, "The ID of the group or role (alternative to [value])."],
		              match$755 = [0, 0],
		              bxt = [0, "The name of the group or role."],
		              bxu =
		                [0, "Whether visibility is restricted to a group or role."],
		              bxr = [0, cst_visibility],
		              bxq = [0, 0],
		              bxo = [0, 0],
		              bxn = [0, 0, 0, [9, cst_role], 0],
		              bxp = [0, 0, 0, [9, cst_group], 0],
		              bxm = [0, cst_type],
		              match$868 = [0, 0],
		              bAV = [0, "Label description."],
		              match$869 = [0, 0],
		              bAW = [0, 'Label color in hex format (e.g. "#FF0000").'],
		              match$870 = [0, 0],
		              bAX =
		                [0,
		                 "Team ID for team-level label. Omit for workspace-level label."],
		              bAY = [0, "Label name."],
		              bAT = [0, "Create a new issue label."],
		              bAU = [0, cst_input],
		              match$866 = [0, 0],
		              bAR =
		                [0,
		                 "Optional filter object for cycles. Top-level fields are AND'd."],
		              match$867 = [0, 0],
		              bAS = [0, "Number of cycles to return (default 50)."],
		              bAQ = [0, cst_input],
		              match$863 = [0, 0],
		              bAN = [0, "Filter by cycle number. Example: [{gte: 5}]."],
		              match$864 = [0, 0],
		              bAO =
		                [0, 'Filter by cycle name. Example: [{contains: "Sprint"}].'],
		              match$865 = [0, 0],
		              bAP = [0, cst_Filter_by_team_Example_id_],
		              bAL = [0, "List all cycles (sprints) in the organization."],
		              bAM = [0, "cycle_filter"],
		              match$862 = [0, 0],
		              bAK = [0, "Number of states to return (default 100)."],
		              bAI = [0, "List all workflow states in the organization."],
		              bAJ = [0, cst_input],
		              match$861 = [0, 0],
		              bAH = [0, "Number of labels to return (default 100)."],
		              bAF = [0, "List all issue labels in the organization."],
		              bAG = [0, cst_input],
		              match$860 = [0, 0],
		              bAE = [0, "Number of users to return (default 50)."],
		              bAC = [0, "List all users in the Linear organization."],
		              bAD = [0, cst_input],
		              match$854 = [0, 0],
		              bAu = [0, 'Project color in hex format (e.g. "#FF0000").'],
		              match$855 = [0, 0],
		              bAv = [0, "User ID of the project lead."],
		              match$856 = [0, 0],
		              bAw = [0, "Project start date in ISO 8601 format."],
		              match$857 = [0, 0],
		              bAx =
		                [0,
		                 'Target completion date in ISO 8601 format (e.g. "2024-06-30").'],
		              match$858 = [0, 0],
		              bAy =
		                [0,
		                 'Project state: "planned", "started", "paused", "completed", or\n            "canceled".'],
		              match$859 = [0, 0],
		              bAz = [0, "Project description (supports markdown)."],
		              bAA = [0, "IDs of teams associated with the project."],
		              bAB = [0, "Project name."],
		              bAs = [0, "Create a new project in Linear."],
		              bAt = [0, cst_input],
		              match$852 = [0, 0],
		              bAq = [0, cst_Pagination_cursor_from_pre],
		              match$853 = [0, 0],
		              bAr = [0, "Number of projects to return (default 50)."],
		              bAo = [0, "List all projects in the organization."],
		              bAp = [0, cst_input],
		              bAn = [0, "The team UUID."],
		              bAl =
		                [0,
		                 "Get a single team by ID, including members and workflow states."],
		              bAm = [0, cst_input],
		              match$851 = [0, 0],
		              bAk = [0, "Number of teams to return (default 50)."],
		              bAi = [0, "List all teams in the Linear organization."],
		              bAj = [0, cst_input],
		              match$850 = [0, 0],
		              bAg = [0, "Number of comments to return (default 50)."],
		              bAh = [0, "The ID of the issue to list comments for."],
		              bAe = [0, "List comments on a Linear issue."],
		              bAf = [0, cst_input],
		              bAc = [0, "Comment body (supports markdown)."],
		              bAd = [0, "The ID of the issue to comment on."],
		              bAa = [0, "Add a comment to a Linear issue."],
		              bAb = [0, cst_input],
		              match$849 = [0, 0],
		              bz_ = [0, "Number of results to return (default 50)."],
		              bz$ = [0, "Full-text search query string."],
		              bz8 = [0, "Search issues by text query."],
		              bz9 = [0, cst_input],
		              match$846 = [0, 0],
		              bz5 =
		                [0,
		                 'Filter object. Top-level fields are combined with AND. Examples: by\n            assignee [{"assignee":{"id":{"eq":"USER_ID"}}}], by team\n            [{"team":{"id":{"eq":"TEAM_ID"}}}], by state\n            [{"state":{"name":{"eq":"In Progress"}}}], by priority\n            [{"priority":{"gte":1}}].'],
		              match$847 = [0, 0],
		              bz6 = [0, cst_Pagination_cursor_from_pre],
		              match$848 = [0, 0],
		              bz7 = [0, "Number of issues to return (default 50, max 250)."],
		              bz4 = [0, cst_input],
		              match$840 = [0, 0],
		              bzY = [0, "Filter by priority value. Example: [{gte: 1}]."],
		              match$841 = [0, 0],
		              bzZ =
		                [0,
		                 'Filter by workflow state name. Example:\n            [{name: {eq: "In Progress"}}].'],
		              match$842 = [0, 0],
		              bz0 = [0, 'Filter by cycle. Example: [{id: {eq: "CYCLE_ID"}}].'],
		              match$843 = [0, 0],
		              bz1 =
		                [0, 'Filter by project. Example: [{id: {eq: "PROJECT_ID"}}].'],
		              match$844 = [0, 0],
		              bz2 = [0, cst_Filter_by_team_Example_id_],
		              match$845 = [0, 0],
		              bz3 =
		                [0,
		                 'Filter by assignee user. Example: [{id: {eq: "USER_ID"}}].'],
		              bzW = [0, "List issues with optional filtering and pagination."],
		              bzX = [0, "issue_filter"],
		              bzV = [0, "Issue UUID to delete."],
		              bzT = [0, "Delete (move to trash) a Linear issue."],
		              bzU = [0, cst_input],
		              match$830 = [0, 0],
		              bzI = [0, "New due date in ISO 8601 format."],
		              match$831 = [0, 0],
		              bzJ = [0, "New complexity estimate."],
		              match$832 = [0, 0],
		              bzK = [0, "New cycle (sprint) ID."],
		              match$833 = [0, 0],
		              bzL = [0, "New project ID."],
		              match$834 = [0, 0],
		              bzM = [0, "New label IDs (replaces all existing labels)."],
		              match$835 = [0, 0],
		              bzN = [0, "New workflow state ID."],
		              match$836 = [0, 0],
		              bzO =
		                [0, "Priority: 0=None, 1=Urgent, 2=High, 3=Medium, 4=Low."],
		              match$837 = [0, 0],
		              bzP = [0, "New assignee user ID."],
		              match$838 = [0, 0],
		              bzQ = [0, "New description (supports markdown)."],
		              match$839 = [0, 0],
		              bzR = [0, cst_New_title],
		              bzS = [0, cst_Issue_UUID_or_shorthand_id],
		              bzG =
		                [0,
		                 "Update an existing issue. Only provided fields are changed."],
		              bzH = [0, cst_input],
		              bzF = [0, cst_Issue_UUID_or_shorthand_id],
		              bzD = [0, "Get a single issue by ID or shorthand identifier."],
		              bzE = [0, cst_input],
		              match$821 = [0, 0],
		              bzs = [0, 'Due date in ISO 8601 format (e.g. "2024-12-31").'],
		              match$822 = [0, 0],
		              bzt = [0, "Estimated complexity points."],
		              match$823 = [0, 0],
		              bzu = [0, "Cycle (sprint) ID to add to."],
		              match$824 = [0, 0],
		              bzv = [0, "Project ID to associate with."],
		              match$825 = [0, 0],
		              bzw = [0, "Array of label IDs to attach."],
		              match$826 = [0, 0],
		              bzx =
		                [0,
		                 'Workflow state ID. Use "List Workflow States" to get IDs.'],
		              match$827 = [0, 0],
		              bzy =
		                [0,
		                 "Priority: 0=No priority, 1=Urgent, 2=High, 3=Medium, 4=Low."],
		              match$828 = [0, 0],
		              bzz = [0, "User ID to assign the issue to."],
		              match$829 = [0, 0],
		              bzA = [0, "Description (supports markdown)."],
		              bzB = [0, "The title of the issue."],
		              bzC = [0, "The ID of the team to create the issue in."],
		              bzq = [0, "Create a new issue in Linear."],
		              bzr = [0, cst_input],
		              match$820 = [0, 0],
		              bzp = [0, "name_relation_filter"],
		              match$819 = [0, 0],
		              bzo = [0, "id_relation_filter"],
		              match$813 = [0, 0],
		              match$814 = [0, 0],
		              match$815 = [0, 0],
		              match$816 = [0, 0],
		              match$817 = [0, 0],
		              match$818 = [0, 0],
		              bzn = [0, "number_filter"],
		              match$809 = [0, 0],
		              match$810 = [0, 0],
		              match$811 = [0, 0],
		              match$812 = [0, 0],
		              bzm = [0, "string_filter"],
		              match$806 = [0, 0],
		              match$807 = [0, 0],
		              match$808 = [0, 0],
		              bzl = [0, "id_filter"],
		              match$885 = [0, 0],
		              bBN = [0, "Number of reactions to return."],
		              match$886 = [0, 0],
		              bBO = [0, cst_Index_of_the_first_result_],
		              bBP =
		                [0,
		                 'The raw URN of the entity to get reactions for (e.g.,\n            "urn:li:ugcPost:12345"). Do NOT URL-encode it.'],
		              bBL = [0, "List reactions on a LinkedIn post or comment."],
		              bBM = [0, cst_input],
		              bBI =
		                [0,
		                 'Type of reaction. One of "LIKE", "PRAISE", "APPRECIATION",\n            "EMPATHY", "INTEREST", or "ENTERTAINMENT". LIKE is equivalent to the\n            traditional like button.'],
		              bBJ =
		                [0,
		                 'The raw organization URN of the actor creating the reaction (e.g.,\n            "urn:li:organization:12345"). Personal member URNs\n            ("urn:li:person:...") are NOT supported.'],
		              bBK =
		                [0,
		                 'The raw URN of the post or comment to react to (e.g.,\n            "urn:li:ugcPost:12345" or\n            "urn:li:comment:(urn:li:activity:12345,67890)"). Do NOT URL-encode\n            it.'],
		              bBG =
		                [0,
		                 "Add a reaction (like, praise, etc.) to a post or comment, on behalf of an\n      organization."],
		              bBH = [0, cst_input],
		              match$883 = [0, 0],
		              bBD = [0, "Number of comments to return (max 100)."],
		              match$884 = [0, 0],
		              bBE = [0, cst_Index_of_the_first_result_],
		              bBF = [0, cst_The_raw_URN_of_the_post_e_],
		              bBB = [0, "List comments on a LinkedIn post."],
		              bBC = [0, cst_input],
		              match$882 = [0, 0],
		              bBx =
		                [0,
		                 'Optional URN of the parent comment if this is a reply (e.g.,\n            "urn:li:comment:(urn:li:activity:12345,67890)").'],
		              bBy = [0, "The text content of the comment."],
		              bBz =
		                [0,
		                 'The raw organization URN of the actor creating the comment (e.g.,\n            "urn:li:organization:12345"). Personal member URNs\n            ("urn:li:person:...") are NOT supported.'],
		              bBA =
		                [0,
		                 'The raw URN of the post to comment on (e.g., "urn:li:ugcPost:12345"\n            or "urn:li:share:12345"). Do NOT URL-encode it.'],
		              bBv =
		                [0,
		                 "Create a comment on a post, or a reply to another comment, on behalf of an\n      organization."],
		              bBw = [0, cst_input],
		              match$880 = [0, 0],
		              bBs = [0, cst_Index_of_the_first_result_],
		              match$881 = [0, 0],
		              bBt = [0, "Number of posts to return (default 10, max 100)."],
		              bBu = [0, cst_The_raw_organization_URN_o],
		              bBq = [0, "List posts authored by an organization."],
		              bBr = [0, cst_input],
		              match$879 = [0, 0],
		              bBo =
		                [0,
		                 'View context. "AUTHOR" for the latest version including drafts, or\n            "READER" for the published version.'],
		              bBp = [0, cst_The_raw_URN_of_the_post_e_],
		              bBm = [0, "Get a specific LinkedIn post by its URN."],
		              bBn = [0, cst_input],
		              bBl =
		                [0,
		                 'The raw organization URN of the owner (e.g.,\n            "urn:li:organization:12345"). The image is associated with this\n            organization. Personal member URNs ("urn:li:person:...") are NOT\n            supported.'],
		              bBj =
		                [0,
		                 "Initialize an image upload. Returns an upload URL and image URN."],
		              bBk = [0, cst_input],
		              match$877 = [0, 0],
		              bBe = [0, cst_State_of_the_post_One_of_P],
		              match$878 = [0, 0],
		              bBf = [0, cst_Who_can_see_the_post_One_o],
		              bBg =
		                [0,
		                 "The URN of the uploaded image (e.g., \"urn:li:image:C49klciosC89\").\n            Obtain this from 'Initialize Image Upload'."],
		              bBh = [0, cst_The_text_content_of_the_po],
		              bBi = [0, cst_The_raw_organization_URN_o],
		              bBc =
		                [0,
		                 "Create a post with an image on behalf of an organization. The image must\n      first be uploaded."],
		              bBd = [0, cst_input],
		              match$875 = [0, 0],
		              bA_ = [0, cst_State_of_the_post_One_of_P],
		              match$876 = [0, 0],
		              bA$ = [0, cst_Who_can_see_the_post_One_o],
		              bBa = [0, cst_The_text_content_of_the_po],
		              bBb = [0, cst_The_raw_organization_URN_o],
		              bA8 =
		                [0, "Create a text-only post on behalf of an organization."],
		              bA9 = [0, cst_input],
		              bA7 =
		                [0,
		                 'The numeric ID of the organization (e.g., "12345"). This is the\n            ["{id}"] part of the organization URN ["urn:li:organization:{id}"].'],
		              bA5 =
		                [0,
		                 "Get details about a LinkedIn organization (company page) by ID."],
		              bA6 = [0, cst_input],
		              match$871 = [0, 0],
		              bA1 = [0, cst_Number_of_results_to_retur],
		              match$872 = [0, 0],
		              bA2 = [0, cst_Index_of_the_first_result_],
		              match$873 = [0, 0],
		              bA3 =
		                [0,
		                 'Filter by state. One of "APPROVED" or "REQUESTED". Empty for any\n            state.'],
		              match$874 = [0, 0],
		              bA4 =
		                [0,
		                 'Filter by role. One of "ADMINISTRATOR" or\n            "DIRECT_SPONSORED_CONTENT_POSTER". Empty for any role.'],
		              bAZ =
		                [0,
		                 "List organizations the authenticated member can administer."],
		              bA0 = [0, cst_input],
		              match$911 = [0, 0],
		              bCE =
		                [0,
		                 "ID of an existing child block to insert the new blocks after."],
		              bCF =
		                [0,
		                 "Block objects to append. See the Notion namespace docs for the block\n            JSON shape."],
		              bCG =
		                [0,
		                 "ID of the block or page to append to. Use a page ID to add content\n            to a page."],
		              bCC = [0, "Append new children blocks to a page or block."],
		              bCD = [0, cst_input],
		              match$909 = [0, 0],
		              bCz = [0, cst_Number_of_results_to_retur],
		              match$910 = [0, 0],
		              bCA = [0, cst_Pagination_cursor_from_a_p$0],
		              bCB =
		                [0,
		                 "ID of the block or page to read children from. Use a page ID to read\n            page content."],
		              bCx =
		                [0,
		                 "Retrieve the children blocks of a page or block (i.e. its content)."],
		              bCy = [0, cst_input],
		              match$905 = [0, 0],
		              bCs = [0, cst_Number_of_results_to_retur],
		              match$906 = [0, 0],
		              bCt = [0, cst_Pagination_cursor_from_a_p$0],
		              match$907 = [0, 0],
		              bCu = [0, "Sort criteria applied in order."],
		              match$908 = [0, 0],
		              bCv =
		                [0,
		                 "Notion filter object. See\n            https://developers.notion.com/reference/post-database-query for the\n            filter syntax."],
		              bCw = [0, "ID of the database to query."],
		              bCr = [0, cst_input],
		              match$902 = [0, 0],
		              bCo = [0, cst_ascending_or_descending],
		              match$903 = [0, 0],
		              bCp =
		                [0,
		                 'Timestamp to sort by: "created_time" or "last_edited_time".'],
		              match$904 = [0, 0],
		              bCq = [0, "Property name to sort by."],
		              bCn = [0, cst_sort],
		              bCm = [0, "ID of the database to retrieve."],
		              bCk = [0, "Retrieve a database's schema and metadata by ID."],
		              bCl = [0, cst_input],
		              match$898 = [0, 0],
		              bCf =
		                [0,
		                 "Set to true to archive (trash) the page, false to restore it."],
		              match$899 = [0, 0],
		              bCg = [0, cst_Page_cover_external_file_o],
		              match$900 = [0, 0],
		              bCh = [0, cst_Page_icon_emoji_or_externa],
		              match$901 = [0, 0],
		              bCi =
		                [0,
		                 "Properties to update, as a Notion properties object. Keys must match\n            the parent database schema."],
		              bCj = [0, "ID of the page to update."],
		              bCd =
		                [0,
		                 "Update a page's properties, icon, cover, or archived status."],
		              bCe = [0, cst_input],
		              match$895 = [0, 0],
		              bB_ = [0, cst_Page_cover_external_file_o],
		              match$896 = [0, 0],
		              bB$ = [0, cst_Page_icon_emoji_or_externa],
		              match$897 = [0, 0],
		              bCa = [0, "Block objects to add as the page's initial content."],
		              bCb =
		                [0,
		                 'Page properties, as a Notion properties object. For a database\n            parent, keys must match the database schema. For a page parent, only\n            "title" is valid.'],
		              bCc =
		                [0,
		                 "Parent for the new page. Set exactly one of [page_id] or\n            [database_id]."],
		              bB9 = [0, cst_input],
		              match$893 = [0, 0],
		              bB7 = [0, "ID of the parent database (to create a row)."],
		              match$894 = [0, 0],
		              bB8 = [0, "ID of the parent page (to create a sub-page)."],
		              bB6 = [0, cst_parent],
		              match$892 = [0, 0],
		              bB4 =
		                [0, "Optional list of property IDs to limit the response to."],
		              bB5 = [0, "ID of the page to retrieve."],
		              bB2 =
		                [0, "Retrieve a page's properties by ID (not its content)."],
		              bB3 = [0, cst_input],
		              match$887 = [0, 0],
		              bBX = [0, cst_Number_of_results_to_retur],
		              match$888 = [0, 0],
		              bBY = [0, cst_Pagination_cursor_from_a_p$0],
		              match$889 = [0, 0],
		              bBZ = [0, "Sort criterion for the results."],
		              match$890 = [0, 0],
		              bB0 = [0, "Limit results to a single object type."],
		              match$891 = [0, 0],
		              bB1 =
		                [0,
		                 "Text to search for in page and database titles. Leave empty to list\n            everything shared with the integration."],
		              bBW = [0, cst_input],
		              bBU = [0, 'Currently only "last_edited_time" is supported.'],
		              bBV = [0, cst_ascending_or_descending],
		              bBT = [0, cst_sort],
		              bBR = [0, 'Must be "object".'],
		              bBS = [0, 'Type of object to filter by: "page" or "database".'],
		              bBQ = [0, cst_filter],
		              bEV =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   " can be linked to ",
		                   [2, 0, [11, " via the\ncorresponding ID fields.", 0]]]],
		                 "%s can be linked to %s via the\ncorresponding ID fields."],
		              bEW =
		                [0,
		                 [11,
		                  "Search and retrieve organizations, and create and list notes.\n\n# Linking\n",
		                  [2,
		                   0,
		                   [11,
		                    "\nProvide at least one link when creating a note. Leads use string UUIDs\n(lead_id), unlike other entities which use integer IDs.",
		                    0]]],
		                 "Search and retrieve organizations, and create and list notes.\n\n# Linking\n%s\nProvide at least one link when creating a note. Leads use string UUIDs\n(lead_id), unlike other entities which use integer IDs."],
		              bEX =
		                [0,
		                 [11,
		                  "List, retrieve, create, and update activities (calls, meetings, tasks).\n\n# Linking\n",
		                  [2,
		                   0,
		                   [11,
		                    '\n\n# Activity types\nActivity types are workspace-specific keys such as "call", "meeting",\n"task", "deadline", "email", or "lunch". Check the workspace\'s configured\ntypes if unsure.',
		                    0]]],
		                 'List, retrieve, create, and update activities (calls, meetings, tasks).\n\n# Linking\n%s\n\n# Activity types\nActivity types are workspace-specific keys such as "call", "meeting",\n"task", "deadline", "email", or "lunch". Check the workspace\'s configured\ntypes if unsure.'],
		              match$983 = [0, 0],
		              bEL = [0, cst_Pagination_offset_0_based],
		              match$984 = [0, 0],
		              bEM = [0, cst_Page_size_default_100_max_],
		              match$985 = [0, 0],
		              bEN =
		                [0,
		                 'Comma-separated "field direction" pairs (e.g. "update_time DESC").'],
		              match$986 = [0, 0],
		              bEO = [0, "Upper bound for add date (YYYY-MM-DD)."],
		              match$987 = [0, 0],
		              bEP = [0, "Lower bound for add date (YYYY-MM-DD)."],
		              match$988 = [0, 0],
		              bEQ = [0, "Restrict to notes on this lead UUID."],
		              match$989 = [0, 0],
		              bER = [0, "Restrict to notes on this organization."],
		              match$990 = [0, 0],
		              bES = [0, "Restrict to notes on this person."],
		              match$991 = [0, 0],
		              bET = [0, "Restrict to notes on this deal."],
		              match$992 = [0, 0],
		              bEU = [0, cst_Filter_by_author_user_ID],
		              bEJ =
		                [0, "List notes with optional filtering by linked entity."],
		              bEK = [0, cst_input],
		              match$978 = [0, 0],
		              bED = [0, "Author user ID. Defaults to the authenticated user."],
		              match$979 = [0, 0],
		              bEE =
		                [0,
		                 "Linked lead UUID (leads have string IDs, unlike other entities)."],
		              match$980 = [0, 0],
		              bEF = [0, cst_Linked_organization_ID],
		              match$981 = [0, 0],
		              bEG = [0, cst_Linked_person_ID],
		              match$982 = [0, 0],
		              bEH =
		                [0,
		                 "Linked deal ID. At least one of deal_id, person_id, org_id, or\n            lead_id must be provided."],
		              bEI =
		                [0,
		                 "Note content. HTML is supported (e.g. <b>, <i>, <a href>, lists)."],
		              bEB =
		                [0,
		                 "Create a note attached to a deal, person, organization, or lead."],
		              bEC = [0, cst_input],
		              bEA = [0, "Pipedrive organization ID."],
		              bEy = [0, "Get a specific organization by ID."],
		              bEz = [0, cst_input],
		              match$974 = [0, 0],
		              bEt = [0, cst_Pagination_offset_0_based],
		              match$975 = [0, 0],
		              bEu = [0, cst_Page_size_default_100_max_],
		              match$976 = [0, 0],
		              bEv = [0, cst_Require_an_exact_match_ins],
		              match$977 = [0, 0],
		              bEw =
		                [0,
		                 'Comma-separated fields to search in (e.g. "name,address").'],
		              bEx =
		                [0,
		                 "Search term (minimum 2 characters; 1 character if exact_match is\n            true). Matches name, address, and custom fields by default."],
		              bEr = [0, "Full-text search across organizations."],
		              bEs = [0, cst_input],
		              match$969 = [0, 0],
		              bEl =
		                [0,
		                 'Label ID (e.g. "customer", "hot lead"). Must match a configured\n            person label.'],
		              match$970 = [0, 0],
		              bEm =
		                [0,
		                 "Phone numbers. The first entry becomes the primary phone."],
		              match$971 = [0, 0],
		              bEn =
		                [0,
		                 "Email addresses. The first entry becomes the primary email."],
		              match$972 = [0, 0],
		              bEo = [0, cst_Linked_organization_ID],
		              match$973 = [0, 0],
		              bEp = [0, cst_Owner_user_ID_Defaults_to_],
		              bEq = [0, "Full name of the person."],
		              bEj = [0, "Create a new person (contact)."],
		              bEk = [0, cst_input],
		              bEi = [0, "Pipedrive person ID."],
		              bEg = [0, "Get a specific person by ID."],
		              bEh = [0, cst_input],
		              match$964 = [0, 0],
		              bEa = [0, cst_Pagination_offset_0_based],
		              match$965 = [0, 0],
		              bEb = [0, cst_Page_size_default_100_max_],
		              match$966 = [0, 0],
		              bEc = [0, "Restrict to persons in this organization."],
		              match$967 = [0, 0],
		              bEd = [0, cst_Require_an_exact_match_ins],
		              match$968 = [0, 0],
		              bEe =
		                [0,
		                 'Comma-separated fields to search in (e.g. "name,email,phone").'],
		              bEf =
		                [0,
		                 "Search term (minimum 2 characters; 1 character if exact_match is\n            true). Matches name, email, phone, and custom fields by default."],
		              bD_ = [0, "Full-text search across persons."],
		              bD$ = [0, cst_input],
		              match$954 = [0, 0],
		              bDZ = [0, "New win probability (0-100)."],
		              match$955 = [0, 0],
		              bD0 = [0, "New expected close date (YYYY-MM-DD)."],
		              match$956 = [0, 0],
		              bD1 =
		                [0,
		                 'New status. Use "won" to close-win, "lost" to close-lost.'],
		              match$957 = [0, 0],
		              bD2 = [0, "New pipeline stage ID."],
		              match$958 = [0, 0],
		              bD3 = [0, "New primary organization ID."],
		              match$959 = [0, 0],
		              bD4 = [0, "New primary person ID."],
		              match$960 = [0, 0],
		              bD5 = [0, cst_New_owner_user_ID],
		              match$961 = [0, 0],
		              bD6 = [0, 'ISO 4217 currency code (e.g. "USD", "EUR").'],
		              match$962 = [0, 0],
		              bD7 = [0, "New deal value (monetary amount)."],
		              match$963 = [0, 0],
		              bD8 = [0, "New deal title."],
		              bD9 = [0, "Pipedrive deal ID to update."],
		              bDX = [0, "Update an existing deal."],
		              bDY = [0, cst_input],
		              bDW = [0, "Pipedrive deal ID."],
		              bDU = [0, "Get a specific deal by ID."],
		              bDV = [0, cst_input],
		              match$947 = [0, 0],
		              bDN = [0, cst_Pagination_offset_0_based],
		              match$948 = [0, 0],
		              bDO = [0, cst_Page_size_default_100_max_],
		              match$949 = [0, 0],
		              bDP =
		                [0,
		                 'Comma-separated "field direction" pairs (e.g. "update_time\n            DESC,title ASC").'],
		              match$950 = [0, 0],
		              bDQ =
		                [0, 'Filter by deal status. Defaults to "all_not_deleted".'],
		              match$951 = [0, 0],
		              bDR = [0, "Restrict to deals at this pipeline stage."],
		              match$952 = [0, 0],
		              bDS = [0, "Pipedrive filter ID to apply."],
		              match$953 = [0, 0],
		              bDT = [0, "Filter by owner's user ID."],
		              bDL = [0, "List deals with optional filtering and pagination."],
		              bDM = [0, cst_input],
		              match$940 = [0, 0],
		              bDD = [0, cst_Pagination_offset_0_based],
		              match$941 = [0, 0],
		              bDE = [0, cst_Page_size_default_100_max_],
		              match$942 = [0, 0],
		              bDF = [0, "Filter by deal status."],
		              match$943 = [0, 0],
		              bDG = [0, "Restrict to deals linked to this organization."],
		              match$944 = [0, 0],
		              bDH = [0, "Restrict to deals linked to this person."],
		              match$945 = [0, 0],
		              bDI = [0, cst_Require_an_exact_match_ins],
		              match$946 = [0, 0],
		              bDJ =
		                [0,
		                 'Comma-separated fields to search in (e.g. "title,notes"). Defaults\n            to all searchable fields.'],
		              bDK =
		                [0,
		                 "Search term (minimum 2 characters; 1 character if exact_match is\n            true). Matches title, custom fields, and notes by default."],
		              bDB = [0, "Full-text search across deals."],
		              bDC = [0, cst_input],
		              match$929 = [0, 0],
		              bDp = [0, "Set to true to mark complete, false to reopen."],
		              match$930 = [0, 0],
		              bDq = [0, "New free-text note."],
		              match$931 = [0, 0],
		              bDr = [0, cst_New_owner_user_ID],
		              match$932 = [0, 0],
		              bDs = [0, "New linked organization ID."],
		              match$933 = [0, 0],
		              bDt = [0, "New linked person ID."],
		              match$934 = [0, 0],
		              bDu = [0, "New linked deal ID."],
		              match$935 = [0, 0],
		              bDv = [0, "New duration (HH:MM)."],
		              match$936 = [0, 0],
		              bDw = [0, "New due time (HH:MM)."],
		              match$937 = [0, 0],
		              bDx = [0, "New due date (YYYY-MM-DD)."],
		              match$938 = [0, 0],
		              bDy = [0, "New activity type key."],
		              match$939 = [0, 0],
		              bDz = [0, "New subject."],
		              bDA = [0, "Pipedrive activity ID to update."],
		              bDn =
		                [0,
		                 "Update an existing activity. Also used to mark activities as done."],
		              bDo = [0, cst_input],
		              match$920 = [0, 0],
		              bDc = [0, "Whether the activity is already completed."],
		              match$921 = [0, 0],
		              bDd = [0, "Free-text note attached to the activity."],
		              match$922 = [0, 0],
		              bDe = [0, cst_Owner_user_ID_Defaults_to_],
		              match$923 = [0, 0],
		              bDf = [0, cst_Linked_organization_ID],
		              match$924 = [0, 0],
		              bDg = [0, cst_Linked_person_ID],
		              match$925 = [0, 0],
		              bDh = [0, "Linked deal ID."],
		              match$926 = [0, 0],
		              bDi =
		                [0,
		                 'Duration in HH:MM format (e.g. "01:30" for 1 hour 30 minutes).'],
		              match$927 = [0, 0],
		              bDj =
		                [0,
		                 "Due time in 24-hour HH:MM format. Requires due_date to be set."],
		              match$928 = [0, 0],
		              bDk = [0, "Due date (YYYY-MM-DD)."],
		              bDl =
		                [0,
		                 'Activity type key (e.g. "call", "meeting", "task", "deadline",\n            "email", "lunch"). Use a key from the workspace\'s activity types.'],
		              bDm = [0, "Activity title shown in the UI."],
		              bDa = [0, "Create a new activity (call, meeting, task, etc.)."],
		              bDb = [0, cst_input],
		              bC$ = [0, "Pipedrive activity ID."],
		              bC9 = [0, "Get a specific activity by ID."],
		              bC_ = [0, cst_input],
		              match$912 = [0, 0],
		              bC1 = [0, cst_Pagination_offset_0_based],
		              match$913 = [0, 0],
		              bC2 = [0, cst_Page_size_default_100_max_],
		              match$914 = [0, 0],
		              bC3 = [0, "Upper bound for due date (YYYY-MM-DD)."],
		              match$915 = [0, 0],
		              bC4 = [0, "Lower bound for due date (YYYY-MM-DD)."],
		              match$916 = [0, 0],
		              bC5 =
		                [0,
		                 "Filter by completion state. True for done, false for open."],
		              match$917 = [0, 0],
		              bC6 =
		                [0,
		                 'Comma-separated activity type keys (e.g. "call,meeting,task").'],
		              match$918 = [0, 0],
		              bC7 = [0, "Pipedrive filter ID to narrow results."],
		              match$919 = [0, 0],
		              bC8 =
		                [0,
		                 "Filter by owner's Pipedrive user ID. Omit to include all owners."],
		              bCZ =
		                [0,
		                 "List activities (calls, meetings, tasks, etc.) with optional filters."],
		              bC0 = [0, cst_input],
		              bCY = [0, 0],
		              bCW = [0, 0],
		              bCU = [0, 0],
		              bCS = [0, 0],
		              bCQ = [0, 0],
		              bCP = [0, 0, 0, [9, cst_all_not_deleted], 0],
		              bCR = [0, 0, 0, [9, cst_deleted], 0],
		              bCT = [0, 0, 0, [9, cst_lost], 0],
		              bCV = [0, 0, 0, [9, cst_won], 0],
		              bCX = [0, 0, 0, [9, cst_open], 0],
		              bCN = [0, "Deal status filter."],
		              bCO = [0, "deal_status"],
		              bCM = [0, 0],
		              bCK = [0, 0],
		              bCJ = [0, 0, 0, [9, cst_desc], 0],
		              bCL = [0, 0, 0, [9, cst_asc], 0],
		              bCH = [0, "ISO 8601 date (YYYY-MM-DD)."],
		              bCI = [0, "iso_date"],
		              match$997 = [0, 0],
		              bE6 = [0, cst_Pagination_cursor_from_a_p$0],
		              match$998 = [0, 0],
		              bE7 = [0, "Max messages to return (default 100, max 999)."],
		              match$999 = [0, 0],
		              bE8 =
		                [0,
		                 "Include messages with timestamps matching [oldest] or [latest]."],
		              match$1000 = [0, 0],
		              bE9 = [0, "Start of time range as Unix timestamp."],
		              match$1001 = [0, 0],
		              bE_ =
		                [0, "End of time range as Unix timestamp; defaults to now."],
		              bE$ = [0, 'Channel ID (e.g. "C1234567890").'],
		              bE4 = [0, "Fetch message history for a channel."],
		              bE5 = [0, cst_input],
		              match$993 = [0, 0],
		              bE0 = [0, "Pagination cursor for next page of results"],
		              match$994 = [0, 0],
		              bE1 = [0, "Maximum number of items to return (max 1000)"],
		              match$995 = [0, 0],
		              bE2 = [0, "Set to true to exclude archived channels"],
		              match$996 = [0, 0],
		              bE3 =
		                [0,
		                 "Mix and match channel types by providing a comma-separated list:\n            public_channel, private_channel, mpim, im"],
		              bEY = [0, "List channels in a workspace."],
		              bEZ = [0, cst_input],
		              bFu =
		                [0, "The timestamp of the message to get a permalink for."],
		              bFv = [0, "The ID of the channel containing the message."],
		              bFs =
		                [0, "Retrieve a permanent link URL for a specific message."],
		              bFt = [0, cst_input],
		              match$1010 = [0, 0],
		              bFn =
		                [0,
		                 "New structured attachments (JSON array). Omit to keep previous\n            attachments."],
		              match$1011 = [0, 0],
		              bFo =
		                [0,
		                 "New rich layout blocks (JSON array). Omit to keep previous blocks."],
		              match$1012 = [0, 0],
		              bFp = [0, "New message text."],
		              bFq = [0, "Timestamp of the message to update."],
		              bFr = [0, "Channel containing the message."],
		              bFl = [0, "Update an existing message."],
		              bFm = [0, cst_input],
		              match$1002 = [0, 0],
		              bFc = [0, "Disable Slack markdown parsing if false."],
		              match$1003 = [0, 0],
		              bFd = [0, "Enable unfurling of media URLs."],
		              match$1004 = [0, 0],
		              bFe = [0, "Enable unfurling of text-based URLs."],
		              match$1005 = [0, 0],
		              bFf = [0, "If true, also post the thread reply to the channel."],
		              match$1006 = [0, 0],
		              bFg = [0, "Parent message timestamp to reply in a thread."],
		              match$1007 = [0, 0],
		              bFh = [0, "Structured attachments (JSON array)."],
		              match$1008 = [0, 0],
		              bFi = [0, "Rich layout blocks (JSON array)."],
		              match$1009 = [0, 0],
		              bFj =
		                [0,
		                 "Plain-text message content. Required unless [blocks] is provided."],
		              bFk =
		                [0, 'Channel ID or name (e.g. "C1234567890" or "#general").'],
		              bFa =
		                [0,
		                 "Post a message to a public channel, private channel, or direct message."],
		              bFb = [0, cst_input],
		              match$1013 = [0, 0],
		              bFG = [0, "If true, always return the full reaction list."],
		              match$1014 = [0, 0],
		              bFH = [0, "File comment ID to get reactions for."],
		              match$1015 = [0, 0],
		              bFI = [0, "File ID to get reactions for."],
		              match$1016 = [0, 0],
		              bFJ = [0, "Message timestamp."],
		              match$1017 = [0, 0],
		              bFK = [0, cst_Channel_where_the_message_],
		              bFD = [0, "Reaction (emoji) name to remove, without colons."],
		              bFE =
		                [0, "Timestamp of the message to remove the reaction from."],
		              bFF =
		                [0,
		                 "Channel where the message to remove the reaction from was posted."],
		              bFB = [0, "Remove an emoji reaction from a message."],
		              bFC = [0, cst_input],
		              bFy =
		                [0, "Message timestamp (the [ts] field from the message)."],
		              bFz = [0, cst_Channel_where_the_message_],
		              bFA = [0, 'Emoji name without colons (e.g. "thumbsup").'],
		              bFw = [0, "Add an emoji reaction to a message."],
		              bFx = [0, cst_input],
		              match$1019 = [0, 0],
		              bFR = [0, "Include locale info per user (default false)."],
		              match$1020 = [0, 0],
		              bFS = [0, cst_Pagination_cursor_from_a_p$0],
		              match$1021 = [0, 0],
		              bFT = [0, "Max users per page."],
		              bFP = [0, "List all users in a workspace."],
		              bFQ = [0, cst_input],
		              match$1018 = [0, 0],
		              bFN = [0, "Include the user's locale (default false)."],
		              bFO = [0, 'User ID (e.g. "U1234567890").'],
		              bFL = [0, "Retrieve information about a user."],
		              bFM = [0, cst_input],
		              bGm = [0, cst_TickTick_task_ID],
		              bGn = [0, cst_TickTick_project_ID],
		              bGk = [0, "Mark a task as complete."],
		              bGl = [0, cst_input],
		              match$1031 = [0, 0],
		              bGg = [0, "New task description/content."],
		              match$1032 = [0, 0],
		              bGh = [0, "New task title."],
		              bGi = [0, "TickTick project ID where the task resides."],
		              bGj = [0, cst_TickTick_task_ID],
		              bGe = [0, "Update an existing task."],
		              bGf = [0, cst_input],
		              match$1026 = [0, 0],
		              bF_ = [0, "Due date and time in ISO 8601 format."],
		              match$1027 = [0, 0],
		              bF$ = [0, "Start date and time in ISO 8601 format."],
		              match$1028 = [0, 0],
		              bGa = [0, "Whether the task is an all-day event."],
		              match$1029 = [0, 0],
		              bGb =
		                [0,
		                 "Project ID where the task will be created. Defaults to Inbox if\n            omitted."],
		              match$1030 = [0, 0],
		              bGc = [0, "Task description/content."],
		              bGd = [0, "Task title."],
		              bF8 = [0, "Create a new task."],
		              bF9 = [0, cst_input],
		              bF7 = [0, cst_TickTick_project_ID],
		              bF5 = [0, "List undone tasks in a specific project."],
		              bF6 = [0, cst_input],
		              match$1022 = [0, 0],
		              bF0 = [0, 'Project kind: "TASK", "NOTE".'],
		              match$1023 = [0, 0],
		              bF1 = [0, 'View mode: "list", "kanban", "timeline".'],
		              match$1024 = [0, 0],
		              bF2 = [0, "Sort order value of the project."],
		              match$1025 = [0, 0],
		              bF3 = [0, 'Color of the project, e.g., "#F18181".'],
		              bF4 = [0, "Name of the project."],
		              bFY = [0, "Create a new project."],
		              bFZ = [0, cst_input],
		              bFW = [0, "Get all user projects (lists)."],
		              bFX = [0, cst_input],
		              bFU = [0, "ISO 8601 datetime."],
		              bFV = [0, cst_datetime],
		              bHr = [0, "The ID of the label to delete."],
		              bHq = [0, cst_input],
		              match$1068 = [0, 0],
		              bHl = [0, cst_Whether_the_label_is_a_fav],
		              match$1069 = [0, 0],
		              bHm = [0, cst_Label_order],
		              match$1070 = [0, 0],
		              bHn = [0, "The color of the label icon."],
		              match$1071 = [0, 0],
		              bHo = [0, "New name for the label."],
		              bHp = [0, "The ID of the label to update."],
		              bHk = [0, cst_input],
		              match$1065 = [0, 0],
		              bHg = [0, cst_Whether_the_label_is_a_fav],
		              match$1066 = [0, 0],
		              bHh = [0, cst_Label_order],
		              match$1067 = [0, 0],
		              bHi = [0, 'The color of the label icon (e.g. "red", "blue").'],
		              bHj = [0, "Name of the label."],
		              bHf = [0, cst_input],
		              bHe = [0, "The ID of the label to retrieve."],
		              bHd = [0, cst_input],
		              bHc = [0, "The ID of the comment to retrieve."],
		              bHb = [0, cst_input],
		              match$1061 = [0, 0],
		              bG9 = [0, cst_Pagination_cursor_from_a_p$0],
		              match$1062 = [0, 0],
		              bG_ = [0, "Max comments to return (default 50)."],
		              match$1063 = [0, 0],
		              bG$ =
		                [0,
		                 "Project ID to list comments for. Mutually exclusive with task_id.\n            One of task_id or project_id is required."],
		              match$1064 = [0, 0],
		              bHa =
		                [0,
		                 "Task ID to list comments for. Mutually exclusive with project_id.\n            One of task_id or project_id is required."],
		              bG8 = [0, cst_input],
		              match$1060 = [0, 0],
		              bG7 = [0, "Filter sections by project ID."],
		              bG6 = [0, cst_input],
		              bG5 = [0, "The ID of the project."],
		              bG4 = [0, cst_input],
		              bG3 = [0, "The ID of the project to retrieve."],
		              bG2 = [0, cst_input],
		              bG1 = [0, "The ID of the task to delete."],
		              bG0 = [0, cst_input],
		              bGZ = [0, "The ID of the task to reopen."],
		              bGY = [0, cst_input],
		              bGX = [0, "The ID of the task to close/complete."],
		              bGW = [0, cst_input],
		              match$1050 = [0, 0],
		              bGL = [0, cst_The_unit_of_time_for_durat],
		              match$1051 = [0, 0],
		              bGM =
		                [0, "A positive integer for task duration, or null to unset."],
		              match$1052 = [0, 0],
		              bGN = [0, "The responsible user ID or null to unset."],
		              match$1053 = [0, 0],
		              bGO = [0, cst_Specific_date_and_time_in_],
		              match$1054 = [0, 0],
		              bGP = [0, "Specific date in YYYY-MM-DD format."],
		              match$1055 = [0, 0],
		              bGQ = [0, cst_Human_defined_task_due_dat],
		              match$1056 = [0, 0],
		              bGR = [0, cst_Task_priority_from_1_norma],
		              match$1057 = [0, 0],
		              bGS =
		                [0,
		                 "The task's labels (list of label names). Replaces existing labels."],
		              match$1058 = [0, 0],
		              bGT = [0, "A description for the task."],
		              match$1059 = [0, 0],
		              bGU = [0, cst_Task_content_May_contain_m],
		              bGV = [0, "The ID of the task to update."],
		              bGK = [0, cst_input],
		              match$1038 = [0, 0],
		              bGx = [0, cst_The_unit_of_time_for_durat],
		              match$1039 = [0, 0],
		              bGy =
		                [0,
		                 "A positive integer for the amount of duration_unit the task will\n            take."],
		              match$1040 = [0, 0],
		              bGz = [0, "The responsible user ID (only for shared tasks)."],
		              match$1041 = [0, 0],
		              bGA = [0, cst_Specific_date_and_time_in_],
		              match$1042 = [0, 0],
		              bGB =
		                [0,
		                 "Specific date in YYYY-MM-DD format relative to user's timezone."],
		              match$1043 = [0, 0],
		              bGC = [0, cst_Human_defined_task_due_dat],
		              match$1044 = [0, 0],
		              bGD = [0, cst_Task_priority_from_1_norma],
		              match$1045 = [0, 0],
		              bGE = [0, "The task's labels (list of label names)."],
		              match$1046 = [0, 0],
		              bGF = [0, "Parent task ID for creating subtasks."],
		              match$1047 = [0, 0],
		              bGG = [0, "ID of the section to put the task into."],
		              match$1048 = [0, 0],
		              bGH =
		                [0,
		                 "Task project ID. If not set, the task is put in the user's Inbox."],
		              match$1049 = [0, 0],
		              bGI =
		                [0,
		                 "A description for the task. May contain markdown-formatted text."],
		              bGJ = [0, cst_Task_content_May_contain_m],
		              bGw = [0, cst_input],
		              bGv = [0, "The ID of the task to retrieve."],
		              bGu = [0, cst_input],
		              match$1033 = [0, 0],
		              bGp = [0, "Comma-separated list of task IDs to retrieve."],
		              match$1034 = [0, 0],
		              bGq =
		                [0,
		                 'Filter by any supported Todoist filter query (e.g. "today",\n            "overdue", "priority 1").'],
		              match$1035 = [0, 0],
		              bGr = [0, "Filter tasks by label name."],
		              match$1036 = [0, 0],
		              bGs = [0, "Filter tasks by section ID."],
		              match$1037 = [0, 0],
		              bGt = [0, "Filter tasks by project ID."],
		              bGo = [0, cst_input],
		              match$1094 = [0, 0],
		              bIO = [0, 'Which cards to return. Defaults to "visible".'],
		              bIN = [0, cst_input],
		              bIM = [0, 0],
		              bIK = [0, 0],
		              bII = [0, 0],
		              bIG = [0, 0],
		              bIE = [0, 0],
		              bID = [0, 0, 0, [9, cst_visible], 0],
		              bIF = [0, 0, 0, [9, cst_open], 0],
		              bIH = [0, 0, 0, [9, cst_none], 0],
		              bIJ = [0, 0, 0, [9, cst_closed], 0],
		              bIL = [0, 0, 0, [9, cst_all], 0],
		              bIC = [0, cst_filter],
		              match$1092 = [0, 0],
		              bIz =
		                [0,
		                 "Maximum number of cards to return (1-1000). Defaults to 10."],
		              match$1093 = [0, 0],
		              bIA =
		                [0,
		                 'Restrict search to these boards. Use "mine" for the user\'s boards or\n            a comma-separated list of board IDs.'],
		              bIB =
		                [0,
		                 "Search query (1-16384 chars). Supports Trello operators such as\n            [board:foo], [list:bar], [member:@me], [due:overdue]."],
		              bIx = [0, "Search Trello for cards matching a query."],
		              bIy = [0, cst_input],
		              bIv = [0, "Sends request to \\@mentions endpoint"],
		              bIw = [0, "Card ID to comment on."],
		              bIt = [0, "Post a comment on a Trello card."],
		              bIu = [0, cst_input],
		              match$1082 = [0, 0],
		              bIi =
		                [0,
		                 "Whether the authenticated user is subscribed to the card."],
		              match$1083 = [0, 0],
		              bIj = [0, "Whether the due date is marked complete."],
		              match$1084 = [0, 0],
		              bIk = [0, "Start date in ISO 8601."],
		              match$1085 = [0, 0],
		              bIl = [0, "Due date in ISO 8601."],
		              match$1086 = [0, 0],
		              bIm =
		                [0,
		                 'New position. Use "top", "bottom", or a positive number as a string.'],
		              match$1087 = [0, 0],
		              bIn =
		                [0,
		                 "Move the card to this board (requires also setting idList)."],
		              match$1088 = [0, 0],
		              bIo = [0, "Move the card to this list."],
		              match$1089 = [0, 0],
		              bIp =
		                [0, "Whether the card is archived. Set to true to archive."],
		              match$1090 = [0, 0],
		              bIq = [0, "New description. Supports Markdown."],
		              match$1091 = [0, 0],
		              bIr = [0, "New card name."],
		              bIs = [0, "Card ID to update."],
		              bIg =
		                [0,
		                 "Update a Trello card. Rename, edit, move, set dates, archive, or mark\n      complete."],
		              bIh = [0, cst_input],
		              match$1074 = [0, 0],
		              bH9 = [0, "A URL to attach to the card on creation."],
		              match$1075 = [0, 0],
		              bH_ = [0, "Label IDs to apply to the card."],
		              match$1076 = [0, 0],
		              bH$ = [0, "Member IDs to assign to the card."],
		              match$1077 = [0, 0],
		              bIa = [0, "Start date in ISO 8601 format."],
		              match$1078 = [0, 0],
		              bIb = [0, "Due date in ISO 8601 format."],
		              match$1079 = [0, 0],
		              bIc =
		                [0,
		                 'Position in the list. Use "top", "bottom", or a positive number as a\n            string.'],
		              match$1080 = [0, 0],
		              bId = [0, "Description / body of the card. Supports Markdown."],
		              match$1081 = [0, 0],
		              bIe = [0, "Name (title) of the card."],
		              bIf = [0, "ID of the list to create the card in."],
		              bH7 = [0, "Create a new card on a Trello list."],
		              bH8 = [0, cst_input],
		              bH6 = [0, "Card ID."],
		              bH4 = [0, "Get a single Trello card by ID."],
		              bH5 = [0, cst_input],
		              bH3 = [0, "Board ID whose cards to fetch."],
		              bH1 = [0, "List all cards on a Trello board."],
		              bH2 = [0, cst_input],
		              bH0 = [0, "List ID whose cards to fetch."],
		              bHY = [0, "List cards in a Trello list."],
		              bHZ = [0, cst_input],
		              match$1073 = [0, 0],
		              bHW = [0, 'Which lists to return. Defaults to "open".'],
		              bHX = [0, "Board ID whose lists to fetch."],
		              bHV = [0, cst_input],
		              bHU = [0, 0],
		              bHS = [0, 0],
		              bHQ = [0, 0],
		              bHO = [0, 0],
		              bHN = [0, 0, 0, [9, cst_open], 0],
		              bHP = [0, 0, 0, [9, cst_none], 0],
		              bHR = [0, 0, 0, [9, cst_closed], 0],
		              bHT = [0, 0, 0, [9, cst_all], 0],
		              bHM = [0, cst_filter],
		              bHL = [0, "Board ID."],
		              bHJ = [0, "Get a single Trello board by ID."],
		              bHK = [0, cst_input],
		              match$1072 = [0, 0],
		              bHI =
		                [0,
		                 'Which boards to return. Defaults to "all" (open + closed). Common\n            values: "open", "closed", "starred", "members".'],
		              bHH = [0, cst_input],
		              bHG = [0, 0],
		              bHE = [0, 0],
		              bHC = [0, 0],
		              bHA = [0, 0],
		              bHy = [0, 0],
		              bHw = [0, 0],
		              bHu = [0, 0],
		              bHt = [0, 0, 0, [9, cst_starred], 0],
		              bHv = [0, 0, 0, [9, cst_public], 0],
		              bHx = [0, 0, 0, [9, cst_organization], 0],
		              bHz = [0, 0, 0, [9, cst_open], 0],
		              bHB = [0, 0, 0, [9, cst_members], 0],
		              bHD = [0, 0, 0, [9, cst_closed], 0],
		              bHF = [0, 0, 0, [9, cst_all], 0],
		              bHs = [0, cst_filter],
		              bJM =
		                [0, "The ID of the message to mark as read (wamid format)."],
		              bJK =
		                [0,
		                 "Mark a received message as read. Displays the blue checkmarks to the\n      sender."],
		              bJL = [0, cst_input],
		              bJH =
		                [0,
		                 "The reaction emoji (e.g., \xf0\x9f\x91\x8d, \xe2\x9d\xa4\xef\xb8\x8f, \xf0\x9f\x98\x82). Leave empty to remove the\n            reaction."],
		              bJI = [0, "The ID of the message to react to (wamid format)."],
		              bJJ = [0, cst_The_recipient_s_phone_numb],
		              bJF =
		                [0,
		                 "Send a reaction emoji to a specific message. Send an empty emoji to remove\n      a reaction."],
		              bJG = [0, cst_input],
		              bJD =
		                [0,
		                 'Array of contact objects. Each contact requires at least a name.\n            Example:\n            [[{"name": {"formatted_name": "John Doe", "first_name": "John",\n             "last_name": "Doe"}, "phones": [{"phone": "+1650555123", "type":\n             "WORK"}]}]].'],
		              bJE = [0, cst_The_recipient_s_phone_numb],
		              bJB =
		                [0,
		                 "Send one or more contact cards (vCards) to a WhatsApp user."],
		              bJC = [0, cst_input],
		              match$1114 = [0, 0],
		              bJw = [0, "Optional address of the location."],
		              match$1115 = [0, 0],
		              bJx =
		                [0, "Optional name of the location (e.g., 'Main Office')."],
		              bJy = [0, "Longitude coordinate of the location."],
		              bJz = [0, "Latitude coordinate of the location."],
		              bJA = [0, cst_The_recipient_s_phone_numb],
		              bJu =
		                [0,
		                 "Send a location message with coordinates and optional name/address."],
		              bJv = [0, cst_input],
		              match$1112 = [0, 0],
		              bJr =
		                [0,
		                 "ID of a previously uploaded audio file (use this OR audio_url)."],
		              match$1113 = [0, 0],
		              bJs =
		                [0,
		                 "Public URL of the audio file to send (use this OR media_id)."],
		              bJt = [0, cst_The_recipient_s_phone_numb],
		              bJp =
		                [0,
		                 "Send an audio message. Supports AAC, MP4, MPEG, AMR, and OGG up to 16MB."],
		              bJq = [0, cst_input],
		              match$1109 = [0, 0],
		              bJl = [0, "Optional caption for the video."],
		              match$1110 = [0, 0],
		              bJm =
		                [0,
		                 "ID of a previously uploaded video (use this OR video_url)."],
		              match$1111 = [0, 0],
		              bJn =
		                [0, "Public URL of the video to send (use this OR media_id)."],
		              bJo = [0, cst_The_recipient_s_phone_numb],
		              bJj =
		                [0, "Send a video message. Supports MP4 and 3GP up to 16MB."],
		              bJk = [0, cst_input],
		              match$1105 = [0, 0],
		              bJe = [0, "Optional caption for the document."],
		              match$1106 = [0, 0],
		              bJf = [0, "The filename to display for the document."],
		              match$1107 = [0, 0],
		              bJg =
		                [0,
		                 "ID of a previously uploaded document (use this OR document_url)."],
		              match$1108 = [0, 0],
		              bJh =
		                [0,
		                 "Public URL of the document to send (use this OR media_id)."],
		              bJi = [0, cst_The_recipient_s_phone_numb],
		              bJc =
		                [0,
		                 "Send a document file. Supports PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, and\n      more up to 100MB."],
		              bJd = [0, cst_input],
		              match$1102 = [0, 0],
		              bI_ = [0, "Optional caption for the image."],
		              match$1103 = [0, 0],
		              bI$ =
		                [0,
		                 "ID of a previously uploaded image (use this OR image_url)."],
		              match$1104 = [0, 0],
		              bJa =
		                [0, "Public URL of the image to send (use this OR media_id)."],
		              bJb = [0, cst_The_recipient_s_phone_numb],
		              bI8 =
		                [0, "Send an image message. Supports JPEG and PNG up to 5MB."],
		              bI9 = [0, cst_input],
		              match$1101 = [0, 0],
		              bI4 =
		                [0,
		                 'Array of component objects to fill in template variables. Each\n            component has a "type" (header, body, button) and a "parameters"\n            array. Example:\n            [[{"type": "body", "parameters": [{"type": "text", "text":\n             "John"}]}]].'],
		              bI5 =
		                [0,
		                 "The language code for the template (e.g., en_US, es, pt_BR).\n            Defaults to en_US."],
		              bI6 = [0, "The name of the approved message template to use."],
		              bI7 = [0, cst_The_recipient_s_phone_numb],
		              bI2 =
		                [0,
		                 "Send a pre-approved template message. Required for business-initiated\n      conversations outside the 24-hour session window."],
		              bI3 = [0, cst_input],
		              match$1100 = [0, 0],
		              bIZ =
		                [0,
		                 "Set to true to enable link previews for URLs in the message body.\n            Defaults to false."],
		              bI0 = [0, "The text content of the message."],
		              bI1 = [0, cst_The_recipient_s_phone_numb],
		              bIX = [0, "Send a text message to a WhatsApp user."],
		              bIY = [0, cst_input],
		              bIW = [0, cst_contact],
		              match$1098 = [0, 0],
		              bIV = [0, 'e.g., "WORK", "CELL"'],
		              match$1099 = [0, 0],
		              bIU = [0, "contact_phone"],
		              match$1096 = [0, 0],
		              match$1097 = [0, 0],
		              bIT = [0, "contact_name"],
		              bIS = [0, 'e.g., "header", "body", "button"'],
		              bIR = [0, "template_component"],
		              match$1095 = [0, 0],
		              bIQ = [0, 'e.g., "text"'],
		              bIP = [0, "template_parameter"],
		              bJR =
		                [0,
		                 [11,
		                  "Connection ",
		                  [2,
		                   0,
		                   [11,
		                    cst_for$0,
		                    [2, 0, [11, cst_is_now_enabled_Use_tool_se, 0]]]]],
		                 "Connection %s for %s is now enabled. Use tool search to discover and call its tools."],
		              bJS =
		                [0,
		                 [11,
		                  cst_MCP_server$0,
		                  [2, 0, [11, cst_is_now_enabled_Use_tool_se, 0]]],
		                 cst_MCP_server_s_is_now_enable],
		              bJT =
		                [0,
		                 [11,
		                  cst_MCP_server$0,
		                  [2, 0, [11, cst_is_now_enabled_Use_tool_se, 0]]],
		                 cst_MCP_server_s_is_now_enable],
		              bJQ = [0, 0],
		              bJU =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_ai/tools/connections.ml",
		                  75,
		                  3389,
		                  3423]],
		              bJV = [0, 0],
		              bJP = [0, "enable_integration_input"],
		              bJO = [0, cst_kind],
		              bJN = [0, "integration_choice"],
		              bJ0 =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_ai/tools/help.ml",
		                  43,
		                  1336,
		                  1374]],
		              bJZ =
		                [0,
		                 [11, "help.searchArticles: failed: ", [2, 0, 0]],
		                 "help.searchArticles: failed: %s"],
		              bJY = [0, "search_output"],
		              bJX = [0, "article_output"],
		              bJW = [0, cst_search_input],
		              bJ3 =
		                [1,
		                 "Fetching private or internal network addresses is not allowed"],
		              bJ4 = [0, 0],
		              bJ5 = [1, "URL must have a host"],
		              bJ6 = [1, "URL must have a scheme (http or https)"],
		              bJ2 = [0, "fetch_url_output"],
		              bJ1 = [0, "fetch_url_input"],
		              bJ7 =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_ai/tools/web.ml",
		                  85,
		                  3169,
		                  3203]],
		              bKr =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   "\n- Automation name: ",
		                   [2, 0, [11, "\n- Automation ID: ", [2, 0, 0]]]]],
		                 "%s\n- Automation name: %s\n- Automation ID: %s"],
		              bKs =
		                [0,
		                 [2,
		                  0,
		                  [11,
		                   "\n\nThe automation is triggered from the following object context:\n```json\n",
		                   [2, 0, [11, f, 0]]]],
		                 "%s\n\nThe automation is triggered from the following object context:\n```json\n%s\n```"],
		              bKt = [0, [2, 0, [11, cst$61, [2, 0, 0]]], "%s\n\n%s"],
		              bKu = [0, 1],
		              bKq = [1, cst_Step_prompt_cannot_be_empt],
		              bKo = [0, 1],
		              bKn = [0, [4, 0, 0, 0, 0], cst_d],
		              bKp = [0, 1],
		              bKm = [1, "Message text cannot be empty"],
		              bKk =
		                [0, [11, "```json\n", [2, 0, [11, f, 0]]], "```json\n%s\n```"],
		              bKl = [0, cst$61],
		              bKi =
		                [0,
		                 [2, 0, [11, "\n```json\n", [2, 0, [11, f, 0]]]],
		                 "%s\n```json\n%s\n```"],
		              bKj = [0, [2, 0, [12, 10, [2, 0, 0]]], "%s\n%s"],
		              bKh = [0, "env_context"],
		              bKg = [0, cst_organization_summary],
		              bKf = [0, "env_user"],
		              bKe = [0, "env_connection"],
		              bKc = [0, cst$1],
		              bKd = [0, cst$1],
		              bKb =
		                [0,
		                 [12, 91, [2, 0, [11, " integration]", 0]]],
		                 "[%s integration]"],
		              bKa =
		                [0,
		                 [12, 91, [2, 0, [11, " connection: ", [2, 0, [12, 93, 0]]]]],
		                 "[%s connection: %s]"],
		              bJ$ = [0, "prompt_context"],
		              bJ_ = [0, cst_reference],
		              bJ9 = [0, "reference_data"],
		              bJ8 =
		                caml_list_of_js_array
		                 ([cst_listEventsForDateRange,
		                   cst_getEvent,
		                   "slack_post_message",
		                   cst_listTables,
		                   cst_getTableSchema,
		                   cst_searchTableRows,
		                   cst_addTableRow,
		                   cst_updateObjectField,
		                   cst_createAutomation,
		                   cst_listMembers,
		                   cst_listCalendars,
		                   cst_findAvailableTimeSlots,
		                   cst_createEvent]),
		              bKx = [0, cst_none],
		              bKv = [0, cst$1],
		              bKw = [0, cst$1],
		              bKy = [0, [0, 0]],
		              bKz = [0, 1],
		              bLk = [0, 9943782, "Agent not found after creation or lookup"],
		              bLh =
		                [0,
		                 [11, cst_failed_to_set_demo_event_n, 0],
		                 cst_failed_to_set_demo_event_n],
		              bLi =
		                [0, [0, cst_api_controller_lib_control$3, 647, 23372, 23412]],
		              bLd = [0, "event end time addition overflowed"],
		              bLe =
		                [0, [0, cst_api_controller_lib_control$3, 603, 21812, 21850]],
		              bLb = [0, "event time subtraction overflowed"],
		              bLc =
		                [0, [0, cst_api_controller_lib_control$3, 596, 21544, 21582]],
		              bLf =
		                [0,
		                 [11, cst_failed_to_update_demo_even, 0],
		                 cst_failed_to_update_demo_even],
		              bLg =
		                [0, [0, cst_api_controller_lib_control$3, 634, 22875, 22917]],
		              bKG = [0, 9943782, "No workspace state for page creation"],
		              bKH = [0, 0],
		              bKI = [8, cst_low],
		              bKJ = [8, cst_open],
		              bKK = [8, "Page fails to load on Safari 16"],
		              bKL = [8, cst_medium],
		              bKM = [8, cst_open],
		              bKN = [8, "Mobile layout broken on small screens"],
		              bKO = [8, cst_medium],
		              bKP = [8, cst_resolved],
		              bKQ = [8, "Confetti animation broken on Firefox"],
		              bKR = [8, cst_high],
		              bKS = [8, cst_open],
		              bKT = [8, "Waitlist sign-up rejecting valid emails"],
		              bKU = [8, "starter"],
		              bKV = [8, "drift.team@routine.co"],
		              bKW = [8, "Drift"],
		              bKX = [8, cst_enterprise],
		              bKY = [8, "helix.partners@routine.co"],
		              bKZ = [8, "Helix"],
		              bK0 = [8, cst_pro],
		              bK1 = [8, "nova.chen@routine.co"],
		              bK2 = [8, "Nova"],
		              bK3 = [8, cst_pro],
		              bK4 = [8, "gavin.harrison@routine.co"],
		              bK5 = [8, "Gavin"],
		              bK6 = [8, cst_enterprise],
		              bK7 = [8, "candide.thovex@routine.co"],
		              bK8 = [8, "Candide"],
		              bK9 = [0, cst_In_Progress, [0, cst_Completed, 0]],
		              bK_ =
		                [0, "Launchpad", [0, cst_In_Progress, [0, cst_Completed, 0]]],
		              bK$ =
		                [0,
		                 cst_low,
		                 [0, cst_medium, [0, cst_high, [0, "critical", 0]]]],
		              bLa = [0, cst_open, [0, "in-progress", [0, cst_resolved, 0]]],
		              bLj = [0, 9943782, "No workspace state"],
		              bKF =
		                [8,
		                 [0,
		                  "In case of basic errors due to you calling tools wrong, please reflect on the error, and then retry another way (other tools or other input)."]],
		              bKD =
		                [0,
		                 [11, cst_table_not_found_while_clea, 0],
		                 cst_table_not_found_while_clea],
		              bKE =
		                [0, [0, cst_api_controller_lib_control$3, 226, 8056, 8089]],
		              bKC = [4, [0, 2]],
		              bKB = [4, [0, 0]],
		              bKA = [0, 0],
		              bLo = [0, [0, [0, cst_accept, cst_application_json], 0]],
		              bLm = [0, c],
		              bLn = [0, 0],
		              bLl = [0, [0, [0, cst_accept, cst_application_json], 0]],
		              bLC = [0, 9943782, "automation run in unexpected resume state"],
		              bLA =
		                [0,
		                 [11, cst_Reference_get_on_Table_ref, 0],
		                 cst_Reference_get_on_Table_ref],
		              bLB =
		                [0,
		                 [11, cst_Reference_get_on_Agent_Aut, 0],
		                 cst_Reference_get_on_Agent_Aut],
		              bLz = [0, 9943782, cst_Automation_not_found],
		              bLy = [0, 9943782, "Automation has no steps"],
		              bLw = [0, c],
		              bLx = [0, cst$61],
		              bLu =
		                [0,
		                 [0,
		                  "api/controller/lib/controller_ai/controller_ai.ml",
		                  347,
		                  13132,
		                  13185]],
		              bLv = [0, 1],
		              bLt = [0, 9943782, cst_Conversation_not_found],
		              bLr =
		                [0,
		                 [11, "Failed to generate title: ", [15, 0]],
		                 "Failed to generate title: %a"],
		              bLs = [0, 9943782, "User input requested during conversation"],
		              bLq = [0, cst_priority],
		              bLp = [0, "ai-model-options"],
		              bLR = [0, 0],
		              bLS = [1, [0, 9943782, "demo object not found"]],
		              bLP = [0, 9943782, cst_Step_name_cannot_be_empty],
		              bLQ = [0, 9943782, cst_Step_prompt_cannot_be_empt],
		              bLN = [0, 9943782, cst_Step_name_cannot_be_empty],
		              bLO = [0, 9943782, cst_Step_prompt_cannot_be_empt],
		              bLM = [0, cst$25],
		              bLL = [0, 9943782, "Automation must have at least one step"],
		              bLJ = [0, 9943782, "Automation run already has a conversation"],
		              bLI = [0, 9943782, cst_Automation_run_is_not_wait],
		              bLK = [0, 9943782, cst_Automation_run_not_found],
		              bLH = [0, 9943782, cst_Agent_not_found],
		              bLG = [0, cst$25],
		              bLF =
		                [0, [0, "api/controller/lib/rpcs/rpcs_ai.ml", 63, 2404, 2444]],
		              match$1116 = [0, "ai-with-limit-result"],
		              bLD =
		                [0,
		                 "Payload for when an organization's AI usage limit has been reached."],
		              bLE = [0, "ai-limit-exceeded"],
		              bLZ = [0, 0, [0, "User input requested"]],
		              bLY = [0, cst$40],
		              bLX = [0, cst$13],
		              bLW = [0, "list_organizations_output"],
		              bLV = [0, cst_organization_summary],
		              bL5 =
		                [0,
		                 [11,
		                  "Integration configuration ",
		                  [15,
		                   [11,
		                    " does not exist in current state, ignoring update.",
		                    0]]],
		                 "Integration configuration %a does not exist in current state, ignoring update."],
		              bL4 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "update integration configuration from",
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [18,
		                     [1, [0, 0, cst$1]],
		                     [15,
		                      [17,
		                       0,
		                       [17,
		                        [0, cst$4, 1, 0],
		                        [11,
		                         cst_to$0,
		                         [17,
		                          [0, cst$4, 1, 0],
		                          [18, [1, [0, 0, cst$1]], [15, [17, 0, [17, 0, 0]]]]]]]]]]]]],
		                 "@[<2>update integration configuration from@ @[%a@]@ to@ @[%a@]@]"],
		              bL3 =
		                [0,
		                 [11, "remove integration ", [15, 0]],
		                 "remove integration %a"],
		              bL2 =
		                [0,
		                 [11, "refresh integration ", [15, 0]],
		                 "refresh integration %a"],
		              bL1 =
		                [0,
		                 [18,
		                  [1, [0, [11, cst_2, 0], cst_2]],
		                  [11,
		                   "add integration",
		                   [17,
		                    [0, cst$4, 1, 0],
		                    [18, [1, [0, 0, cst$1]], [15, [17, 0, [17, 0, 0]]]]]]],
		                 "@[<2>add integration@ @[%a@]@]"],
		              bMd = [0, 0],
		              bMc = [0, 0],
		              bMb = [0, 0],
		              bMa = [0, 0],
		              bL$ = [0, 0],
		              bMe = [0, cst_type],
		              bL_ = [0, cst_graph_type],
		              match$1117 = [0, 0],
		              bMf = [0, cst_graph_field],
		              bL9 = [0, cst_type],
		              bL8 = [0, "graph-variable"],
		              bL6 =
		                [0,
		                 "Redefinition of [object_id], but with the standard autoderived schema rather\n    than the custom stringified one"],
		              bL7 = [0, "object_id_raw"],
		              bMx =
		                [0,
		                 [11, cst_not_an_event_occurrence_id, [15, 0]],
		                 cst_not_an_event_occurrence_id$0],
		              bMu = [0, [11, cst_upsert, 0], cst_upsert],
		              bMv =
		                [0,
		                 [11, cst_event_occurrence_not_found, [15, 0]],
		                 cst_event_occurrence_not_found$0],
		              bMt = [0, [11, "update_all ", [15, 0]], "update_all %a"],
		              bMs = [0, 0],
		              bMw =
		                [0,
		                 [11, cst_recurrent_event_not_found, [15, 0]],
		                 cst_recurrent_event_not_found_],
		              bMr =
		                [0,
		                 [11, cst_not_an_event_occurrence_id, [15, 0]],
		                 cst_not_an_event_occurrence_id$0],
		              bMo = [0, [11, cst_add, 0], cst_add],
		              bMp =
		                [0,
		                 [11, cst_recurrent_event_not_found, [15, 0]],
		                 cst_recurrent_event_not_found_],
		              bMn =
		                [0,
		                 [11, "update_this_and_following ", [15, 0]],
		                 "update_this_and_following %a"],
		              bMq =
		                [0,
		                 [11, cst_event_occurrence_not_found, [15, 0]],
		                 cst_event_occurrence_not_found$0],
		              bMm = [0, [11, cst_stop, 0], cst_stop],
		              bMl = [0, [11, cst_patch$0, [15, 0]], cst_patch_a],
		              bMk = [0, [11, cst_delete$0, [15, 0]], cst_delete_a],
		              bMj = [0, [11, cst_no_such_event, 0], cst_no_such_event],
		              bMi = [0, [11, "create ", [15, 0]], "create %a"],
		              bMz =
		                [0,
		                 [2, 0, [11, " event: calendar is readonly", 0]],
		                 "%s event: calendar is readonly"],
		              bMy =
		                [0,
		                 [11,
		                  "unable to ",
		                  [2,
		                   0,
		                   [11, " event: calendar ", [15, [11, " is readonly", 0]]]]],
		                 "unable to %s event: calendar %a is readonly"],
		              bMA =
		                [0,
		                 [11, cst_exepected_document_redirec, 0],
		                 cst_exepected_document_redirec],
		              bMC = [0, cst_type],
		              bMB = [0, "controller_supported_actions"],
		              bMH =
		                [0,
		                 [11, cst_unable_to_fetch, [15, [11, cst$9, [15, 0]]]],
		                 cst_unable_to_fetch_a_a],
		              bMG = [0, [15, 0], cst_a],
		              bMF = [0, [15, 0], cst_a],
		              bME = [0, [15, 0], cst_a],
		              bMJ =
		                [0,
		                 [11, "triggering fatal error via RPC: ", [2, 0, 0]],
		                 "triggering fatal error via RPC: %s"],
		              bMK = [0, [2, 0, 0], cst_s],
		              bMI = [0, cst_platform],
		              bML = [0, -971241045, 0],
		              bMM =
		                [0,
		                 [11, "garbage collecting leaked releasable ref ", [3, 0, 0]],
		                 "garbage collecting leaked releasable ref %S"],
		              bMN =
		                [0,
		                 [11,
		                  cst_rpc,
		                  [3,
		                   0,
		                   [11, cst_invalid_argument, [3, 0, [11, cst$9, [15, 0]]]]]],
		                 cst_rpc_S_invalid_argument_S_a],
		              bMO = [0, [0, cst_controller_controller_clie, 127, 4474, 4518]],
		              bMP = [0, [11, cst_too_few_arguments, 0], cst_too_few_arguments],
		              bMQ = [0, [0, cst_controller_controller_clie, 131, 4709, 4760]],
		              bMR =
		                [0, [11, cst_too_many_arguments, 0], cst_too_many_arguments],
		              bMS = [0, [0, cst_controller_controller_clie, 130, 4629, 4680]],
		              bMT = [0, 0, 0],
		              bMU =
		                [0,
		                 [11,
		                  cst_rpc,
		                  [3,
		                   0,
		                   [11, cst_invalid_argument, [3, 0, [11, cst$9, [15, 0]]]]]],
		                 cst_rpc_S_invalid_argument_S_a],
		              bMV = [0, [0, cst_controller_controller_clie, 148, 5467, 5511]],
		              bMW = [0, [11, cst_too_few_arguments, 0], cst_too_few_arguments],
		              bMX = [0, [0, cst_controller_controller_clie, 152, 5702, 5753]],
		              bMY =
		                [0, [11, cst_too_many_arguments, 0], cst_too_many_arguments],
		              bMZ = [0, [0, cst_controller_controller_clie, 151, 5622, 5673]],
		              bM0 = [0, 0, 0],
		              bM1 = [0, cst_controller_controller_clie, 184, 6996, 7060],
		              bM6 =
		                [0,
		                 [11, cst_cannot_encode_input_variab, 0],
		                 cst_cannot_encode_input_variab],
		              bM7 =
		                [0, [0, cst_controller_controller_clie, 396, 15596, 15650]],
		              bM4 =
		                [0,
		                 [11, "duplicate key in graph_result_of_js: ", [3, 0, 0]],
		                 "duplicate key in graph_result_of_js: %S"],
		              bM5 =
		                [0, [0, cst_controller_controller_clie, 347, 13634, 13684]],
		              bM2 =
		                [0,
		                 [11, cst_cannot_encode_callback_to_, 0],
		                 cst_cannot_encode_callback_to_],
		              bM3 = [0, [0, cst_controller_controller_clie, 246, 9595, 9651]],
		              bM$ =
		                [0,
		                 [11,
		                  "controller client ",
		                  [3,
		                   0,
		                   [11,
		                    " was garbage collected without being released. Call release () on disposal.",
		                    0]]],
		                 "controller client %S was garbage collected without being released. Call release () on disposal."],
		              bM_ =
		                [0,
		                 "controller/controller-electron-ipc-client/controller_electron_ipc_client.ml",
		                 78,
		                 2228,
		                 2285],
		              bM9 = [0, [11, cst_receive_RPC, 0], cst_receive_RPC],
		              bM8 = [0, [11, cst_send_RPC, 0], cst_send_RPC],
		              bNa =
		                [0,
		                 "controller/controller-webworker-client/controller_webworker_client.ml",
		                 93,
		                 3013,
		                 3070],
		              bNg = [0, [17, 0, [17, 2, 0]], cst$63],
		              bNh =
		                [0,
		                 [15,
		                  [15,
		                   [12,
		                    91,
		                    [2,
		                     0,
		                     [11, cst$42, [18, [1, [0, [11, cst_h, 0], cst_h]], [15, 0]]]]]]],
		                 "%a%a[%s] @[<h>%a"],
		              bNi = [0, [17, 0, [17, 2, 0]], cst$63],
		              bNj =
		                [0,
		                 [15, [15, [18, [1, [0, [11, cst_h, 0], cst_h]], [15, 0]]]],
		                 "%a%a@[<h>%a"],
		              bNf =
		                [0,
		                 [4,
		                  0,
		                  [0, 2, 4],
		                  0,
		                  [12,
		                   45,
		                   [4,
		                    0,
		                    [0, 2, 2],
		                    0,
		                    [12,
		                     45,
		                     [4,
		                      0,
		                      [0, 2, 2],
		                      0,
		                      [12,
		                       32,
		                       [4,
		                        0,
		                        [0, 2, 2],
		                        0,
		                        [12,
		                         58,
		                         [4,
		                          0,
		                          [0, 2, 2],
		                          0,
		                          [12, 58, [4, 0, [0, 2, 2], 0, [12, 32, 0]]]]]]]]]]]],
		                 "%04d-%02d-%02d %02d:%02d:%02d "],
		              bNb = [0, [2, 0, [12, 32, 0]], cst_s$5],
		              bNc = [0, [2, 0, [12, 32, 0]], cst_s$5],
		              bNd = [0, [2, 0, [12, 32, 0]], cst_s$5],
		              bNe = [0, [2, 0, [12, 32, 0]], cst_s$5],
		              bNt = [0, [11, cst_unbind_hotkeys, 0], cst_unbind_hotkeys],
		              bNs = [0, [11, cst_rebind_hotkeys, 0], cst_rebind_hotkeys],
		              bNr = [0, [11, cst_bind_hotkeys, 0], cst_bind_hotkeys],
		              bNq =
		                [0,
		                 [11, "invalid hotkey: ", [2, 0, [11, cst$9, [2, 0, 0]]]],
		                 "invalid hotkey: %s: %s"],
		              bNp = [0, [11, "trigger hotkey ", [15, 0]], "trigger hotkey %a"],
		              bNo =
		                [0,
		                 [11,
		                  "unexpected modifierrs for v-hotkey directive: ",
		                  [15, 0]],
		                 "unexpected modifierrs for v-hotkey directive: %a"],
		              bNn =
		                [0,
		                 [11,
		                  "unexpected argument for v-hotkey directive: ",
		                  [3, 0, 0]],
		                 "unexpected argument for v-hotkey directive: %S"],
		              bNm =
		                [0,
		                 [11, cst_v_hotkey_handler_returned_, 0],
		                 cst_v_hotkey_handler_returned_],
		              bNl = [0, [15, [15, 0]], cst_a_a],
		              bNk = [0, "Vue hotkeys"],
		              bNC =
		                [0,
		                 [11, "HTML parse error on ", [3, 0, [11, cst$9, [2, 0, 0]]]],
		                 "HTML parse error on %S: %s"],
		              bNB =
		                [0,
		                 [11, cst_rich_text_parse_error, [2, 0, 0]],
		                 cst_rich_text_parse_error_s],
		              bNA =
		                [0,
		                 [11, cst_rich_text_parse_error, [2, 0, 0]],
		                 cst_rich_text_parse_error_s],
		              bNu = [0, 4],
		              bNv = [0, 3],
		              bNy = [0, 3],
		              bNz = [0, 4],
		              bNw = [0, 2],
		              bNx = [0, 2];
		             function bT(param$2){
		              if(param$2){
		               var
		                l$1 = param$2[2],
		                a = param$2[1],
		                handler = a[2],
		                extension_constructor = a[1];
		               return caml_exact_trampoline_cps_call$2
		                       (add$1,
		                        el,
		                        dummy,
		                        extension_constructor,
		                        handler,
		                        function(a){return caml_exact_trampoline_call1(bT, l$1);});
		              }
		              function b(e){
		               if(e){
		                var
		                 l$1 = e[2],
		                 a$14 = e[1],
		                 handler = a$14[2],
		                 extension_constructor = a$14[1];
		                return caml_exact_trampoline_cps_call$2
		                        (add$1,
		                         eo,
		                         dummy,
		                         extension_constructor,
		                         handler,
		                         function(a){return caml_exact_trampoline_call1(b, l$1);});
		               }
		               function max$2(x, y, cont){
		                return cont(caml_csel_value(y <= x ? 1 : 0, x, y));
		               }
		               function min$2(x, y, cont){
		                return cont(caml_csel_value(x <= y ? 1 : 0, x, y));
		               }
		               function ascending(x, y, cont){
		                return cont(caml_compare(x, y));
		               }
		               function descending(x, y, cont){
		                return cont(caml_compare(y, x));
		               }
		               function max$3(x, y, cont){
		                return cont(caml_csel_value(caml_greaterequal(x, y), x, y));
		               }
		               function min$3(x, y, cont){
		                return cont(caml_csel_value(caml_lessequal(x, y), x, y));
		               }
		               function symbol$1(x, y){return caml_lessthan(x, y);}
		               function symbol$2(x, y){return caml_lessequal(x, y);}
		               function symbol$3(x, y){return caml_greaterthan(x, y);}
		               function symbol$4(x, y){return caml_greaterequal(x, y);}
		               function compare$1(x, y, cont){
		                return cont(caml_int_compare(x, y));
		               }
		               function max$4(x, y, cont){
		                return cont(caml_csel_value(caml_greaterequal(x, y), x, y));
		               }
		               function min$4(x, y, cont){
		                return cont(caml_csel_value(caml_lessequal(x, y), x, y));
		               }
		               function symbol$5(x, y, cont){return cont(x < y ? 1 : 0);}
		               function symbol$6(x, y, cont){return cont(x <= y ? 1 : 0);}
		               function symbol$7(x, y, cont){return cont(x !== y ? 1 : 0);}
		               function symbol$8(x, y, cont){return cont(x === y ? 1 : 0);}
		               function symbol$9(x, y, cont){return cont(y < x ? 1 : 0);}
		               function symbol$10(x, y, cont){return cont(y <= x ? 1 : 0);}
		               function ascending$0(x, y, cont){
		                return cont(caml_compare(x, y));
		               }
		               function descending$0(x, y, cont){return cont(caml_compare(y, x));
		               }
		               function compare$2(x, y, cont){
		                return cont(caml_int_compare(x, y));
		               }
		               function equal$1(x, y, cont){return cont(x === y ? 1 : 0);}
		               function max$5(x, y, cont){
		                return cont(caml_csel_value(y <= x ? 1 : 0, x, y));
		               }
		               function min$5(x, y, cont){
		                return cont(caml_csel_value(x <= y ? 1 : 0, x, y));
		               }
		               function equal$2(x, y, cont){return cont(x === y ? 1 : 0);}
		               function compare$3(x, y, cont){
		                return cont(caml_int_compare(x, y));
		               }
		               function equal$3(x, y, cont){return cont(x === y ? 1 : 0);}
		               function ascending$1(x, y, cont){
		                return cont(caml_compare(x, y));
		               }
		               function descending$1(x, y, cont){return cont(caml_compare(y, x));
		               }
		               function symbol$11(x, y, cont){
		                return cont(caml_string_lessthan(x, y));
		               }
		               function symbol$12(x, y, cont){
		                return cont(caml_string_lessequal(x, y));
		               }
		               function symbol$13(x, y, cont){return cont(x !== y ? 1 : 0);}
		               function symbol$14(x, y, cont){return cont(x === y ? 1 : 0);}
		               function symbol$15(x, y, cont){
		                return cont(caml_string_greaterthan(x, y));
		               }
		               function symbol$16(x, y, cont){
		                return cont(caml_string_greaterequal(x, y));
		               }
		               function ascending$2(x, y, cont){
		                return cont(caml_compare(x, y));
		               }
		               function descending$2(x, y, cont){return cont(caml_compare(y, x));
		               }
		               function compare$4(x, y, cont){
		                return cont(caml_string_compare(x, y));
		               }
		               function equal$4(x, y, cont){return cont(x === y ? 1 : 0);}
		               function max$6(x, y, cont){
		                return cont
		                        (caml_csel_value(caml_string_greaterequal(x, y), x, y));
		               }
		               function min$6(x, y, cont){
		                return cont
		                        (caml_csel_value(caml_string_lessequal(x, y), x, y));
		               }
		               function calendar(a, cont){return cont(a[1]);}
		               function get_data(a, cont){return cont(a[2]);}
		               function failwithf(fmt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ksprintf,
		                         function(s, param, cont){
		                          return caml_exact_trampoline_cps_call(failwith, s, cont);
		                         },
		                         fmt,
		                         cont);
		               }
		               function invalid_argf(fmt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ksprintf,
		                         function(s, param, cont){
		                          return caml_exact_trampoline_cps_call(invalid_arg, s, cont);
		                         },
		                         fmt,
		                         cont);
		               }
		               function getenv(var$){
		                try{var x = caml_sys_getenv(var$);}
		                catch(exn$0){
		                 var exn = caml_wrap_exception(exn$0);
		                 if(exn === Not_found) return 0;
		                 throw caml_maybe_attach_backtrace(exn, 0);
		                }
		                return [0, x];
		               }
		               function init$6(len, f, cont){
		                if(0 === len) return cont([0]);
		                if(0 > len)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_Array_init, cont);
		                var x = f(0), res = caml_make_vect(len, x), a = len - 1 | 0;
		                if(a >= 1){
		                 var i = 1;
		                 for(;;){
		                  res[i + 1] = f(i);
		                  var b = i + 1 | 0;
		                  if(a === i) break;
		                  i = b;
		                 }
		                }
		                return cont(res);
		               }
		               function fold(t, init, f, cont){
		                var a = t.length - 2 | 0;
		                function c(r){return cont(r);}
		                function b(r, i){
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          r,
		                          t[i + 1],
		                          function(d){
		                           var e = i + 1 | 0;
		                           return a !== i ? caml_exact_trampoline_call2(b, d, e) : c(d);
		                          });
		                }
		                return a < 0 ? c(init) : b(init, 0);
		               }
		               function map$1(t, f, cont){
		                var len = t.length - 1;
		                return 0 === len
		                        ? cont([0])
		                        : caml_exact_trampoline_cps_call
		                          (f,
		                           t[1],
		                           function(x){
		                            var r = caml_make_vect(len, x), a = len - 1 | 0;
		                            function c(){return cont(r);}
		                            function b(i){
		                             return caml_exact_trampoline_cps_call
		                                     (f,
		                                      t[i + 1],
		                                      function(d){
		                                       r[i + 1] = d;
		                                       d = i + 1 | 0;
		                                       return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		                                      });
		                            }
		                            return a < 1 ? c() : b(1);
		                           });
		               }
		               function swap(t, i, j){
		                var
		                 elt_i = caml_check_bound(t, i)[i + 1],
		                 elt_j = caml_check_bound(t, j)[j + 1];
		                t[i + 1] = elt_j;
		                t[j + 1] = elt_i;
		               }
		               function unsafe_of_int(a){return a;}
		               function int_is_ok(i){
		                var a = 0 <= i ? 1 : 0, a = a ? i <= 255 ? 1 : 0 : a;
		                return a;
		               }
		               function of_int$0(i){return int_is_ok(i) ? [0, i] : 0;}
		               function of_int_exn(i, cont){
		                if(int_is_ok(i)) return cont(i);
		                return caml_exact_trampoline_cps_call
		                        (failwithf,
		                         ep,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, i, 0, cont);
		                         });
		               }
		               function length$1(l$0, cont){
		                var len = 0, param = l$0;
		                for(;;){
		                 if(! param) return cont(len);
		                 var l = param[2], len$0 = len + 1 | 0;
		                 len = len$0;
		                 param = l;
		                }
		               }
		               function fold_left$1(t, init, f, cont){
		                function a(t, init){
		                 if(! t) return cont(init);
		                 var l = t[2], a$0 = t[1];
		                 return caml_trampoline_cps_call3
		                         (f,
		                          init,
		                          a$0,
		                          function(init){
		                           return caml_exact_trampoline_call2(a, l, init);
		                          });
		                }
		                return a(t, init);
		               }
		               function iter$1(t$0, f){
		                var t = t$0;
		                for(;;){if(! t) return; var l = t[2], a = t[1]; f(a); t = l;}
		               }
		               function rev_map(l, f, cont){
		                function a(accu, param){
		                 if(! param) return cont(accu);
		                 var l = param[2], a$0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          a$0,
		                          function(b){
		                           var accu$0 = [0, b, accu];
		                           return caml_exact_trampoline_call2(a, accu$0, l);
		                          });
		                }
		                return a(0, l);
		               }
		               function of_rev_keys(res, cont){
		                if(res){
		                 var match = res[2];
		                 if(match){
		                  var rest = match[2], y = match[1], x = res[1];
		                  return cont(rev_append(rest, [0, y, [0, x, 0]]));
		                 }
		                }
		                return cont(res);
		               }
		               function fold_right$0(l, f, init, cont){
		                return l
		                        ? caml_exact_trampoline_cps_call
		                          (of_rev_keys,
		                           l,
		                           function(t){
		                            function a(t, init){
		                             if(! t) return cont(init);
		                             var l = t[2], a$0 = t[1];
		                             return caml_trampoline_cps_call3
		                                     (f,
		                                      a$0,
		                                      init,
		                                      function(init){
		                                       return caml_exact_trampoline_call2(a, l, init);
		                                      });
		                            }
		                            return a(t, init);
		                           })
		                        : cont(init);
		               }
		               function reset(opt, t){
		                var seed = 0;
		                return seed;
		               }
		               function create$8(seed, param){return reset();}
		               function run(seed, folder, x){
		                return Base_internalhash_get_hash_value
		                        (folder(reset(), x));
		               }
		               function hash_fold_int32(s, x){
		                return Base_internalhash_fold_int(s, x);
		               }
		               function hash_fold_nativeint(s, x){
		                return Base_internalhash_fold_int64(s, caml_int64_of_int32(x));
		               }
		               function hash_nativeint(x){
		                return Base_internalhash_get_hash_value
		                        (hash_fold_nativeint(reset(), x));
		               }
		               function hash_int64(x){
		                return Base_internalhash_get_hash_value
		                        (Base_internalhash_fold_int64(reset(), x));
		               }
		               function hash_int32(x){
		                return Base_internalhash_get_hash_value
		                        (hash_fold_int32(reset(), x));
		               }
		               function hash_int(t){
		                var
		                 t$5 = (t ^ -1) + (t << 21) | 0,
		                 t$4 = t$5 ^ (t$5 >>> 24 | 0),
		                 t$3 = (t$4 + (t$4 << 3) | 0) + (t$4 << 8) | 0,
		                 t$2 = t$3 ^ (t$3 >>> 14 | 0),
		                 t$1 = (t$2 + (t$2 << 2) | 0) + (t$2 << 4) | 0,
		                 t$0 = t$1 ^ (t$1 >>> 28 | 0);
		                return t$0 + (t$0 << 31) | 0;
		               }
		               function hash_bool(x){return x ? 1 : 0;}
		               function compare_bool(b, a, cont){
		                return cont(caml_int_compare(b, a));
		               }
		               function compare_char(b, a, cont){
		                return cont(caml_int_compare(b, a));
		               }
		               function compare_array_local(compare_elt, a, b, cont){
		                if(a === b) return cont(0);
		                var
		                 len_a = a.length - 1,
		                 len_b = b.length - 1,
		                 ret = caml_int_compare(len_a, len_b);
		                if(0 !== ret) return cont(ret);
		                function c(i){
		                 if(i === len_a) return cont(0);
		                 var l = a[i + 1], r = b[i + 1];
		                 return caml_exact_trampoline_cps_call$1
		                         (compare_elt,
		                          l,
		                          r,
		                          function(res){
		                           if(0 !== res) return cont(res);
		                           var i$0 = i + 1 | 0;
		                           return caml_exact_trampoline_call1(c, i$0);
		                          });
		                }
		                return c(0);
		               }
		               function compare_option(compare_elt, a, b, cont){
		                if(! a) return b ? cont(-1) : cont(0);
		                var a$0 = a[1];
		                if(! b) return cont(1);
		                var b$0 = b[1];
		                return caml_trampoline_cps_call3(compare_elt, a$0, b$0, cont);
		               }
		               function compare_elt_local(a_001, b_002){
		                if(a_001 === b_002) return 0;
		                if(0 === a_001[0]){
		                 var a_003 = a_001[1];
		                 if(0 !== b_002[0]) return -1;
		                 var b_004 = b_002[1];
		                 return caml_string_compare(a_003, b_004);
		                }
		                var a_005 = a_001[1];
		                if(0 === b_002[0]) return 1;
		                var b_006 = b_002[1], a = a_005, b = b_006;
		                for(;;){
		                 if(! a) return b ? -1 : 0;
		                 if(! b) return 1;
		                 var
		                  ys = b[2],
		                  y = b[1],
		                  xs = a[2],
		                  x = a[1],
		                  res = compare_elt_local(x, y);
		                 if(0 !== res) return res;
		                 a = xs;
		                 b = ys;
		                }
		               }
		               function num_bits(param){return 32;}
		               function Register_pp(M){var pp = M[1]; return [0, pp];}
		               function bPU(M){
		                function pp(formatter, t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (M[2],
		                          t,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, formatter, a, cont);
		                          });
		                }
		                return [0, Register_pp([0, pp])[1]];
		               }
		               var Finally = [248, "Base__Exn.Finally", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Finally,
		                  function(a, cont){
		                   if(a[1] === Finally){
		                    var arg1_002 = a[3], arg0_001 = a[2];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_exn,
		                             arg0_001,
		                             function(res0_003){
		                              return caml_exact_trampoline_cps_call
		                                      (sexp_of_exn,
		                                       arg1_002,
		                                       function(res1_004){
		return cont([1, [0, eq, [0, res0_003, [0, res1_004, 0]]]]);
		                                       });
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, er], 1));
		                  }]);
		               var
		                Reraised = [248, "Base__Exn.Reraised", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Reraised,
		                  function(a, cont){
		                   if(a[1] === Reraised){
		                    var
		                     arg1_006 = a[3],
		                     arg0_005 = a[2],
		                     res0_007 = [0, arg0_005];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_exn,
		                             arg1_006,
		                             function(res1_008){
		                              return cont([1, [0, es, [0, res0_007, [0, res1_008, 0]]]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, et], 1));
		                  }]);
		               var Sexp = [248, "Base__Exn.Sexp", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Sexp,
		                  function(param, a){
		                   if(param[1] === Sexp){var t = param[2]; return a(t);}
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, eu], 1));
		                  }]);
		               function raise_with_original_backtrace(t, backtrace){
		                throw caml_maybe_attach_backtrace(t, 0);
		               }
		               function reraise(exn, str){
		                var exn$0 = [0, Reraised, str, exn];
		                return raise_with_original_backtrace(exn$0);
		               }
		               function reraisef(exc, format, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ksprintf,
		                         function(str, param, cont){return cont(reraise(exc, str));},
		                         format,
		                         cont);
		               }
		               function to_string$1(exc, cont){
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_exn,
		                         exc,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_string_hum, ev, a, cont);
		                         });
		               }
		               function pp$0(ppf, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_exn_opt,
		                         t,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$0,
		                                    t,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, ppf, a, cont);
		                                    });
		                          var sexp = match[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (pp_hum_indent, bo, ppf, sexp, cont);
		                         });
		               }
		               var
		                include =
		                  function(a){return [0, Register_pp(a)[1]];}([0, pp$0]),
		                pp$1 = include[1];
		               function print_with_backtrace(exc, raw_backtrace, cont){
		                var fmt = param[1];
		                return caml_exact_trampoline_cps_call$0
		                        (make_printf,
		                         function(acc, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (get$0,
		                                   err_formatter_key,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (output_acc$0, a, acc, cont);
		                                   });
		                         },
		                         0,
		                         fmt,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   pp$1,
		                                   exc,
		                                   function(b){
		                                    function a(a){return cont(caml_ml_flush(stderr));}
		                                    return caml_backtrace_status()
		    ? caml_exact_trampoline_cps_call$1
		      (print_raw_backtrace, stderr, raw_backtrace, a)
		    : a();
		                                   });
		                         });
		               }
		               function raise_without_backtrace(e){throw e;}
		               function with_return(f, cont){
		                var
		                 Return = [248, "Return", caml_fresh_oo_id()],
		                 is_alive = [0, 1];
		                function return$(a, cont){
		                 function b(b){
		                  return cont(raise_without_backtrace([0, Return, a]));
		                 }
		                 return 1 - is_alive[1]
		                         ? caml_exact_trampoline_cps_call
		                           (failwith,
		                            "use of [return] from a [with_return] that already returned",
		                            b)
		                         : b();
		                }
		                caml_push_trap
		                 (function(exn){
		                   is_alive[1] = 0;
		                   if(exn[1] === Return){var a = exn[2]; return cont(a);}
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         return$,
		                         function(a){
		                          is_alive[1] = 0;
		                          caml_pop_trap();
		                          return cont(a);
		                         });
		               }
		               function non(f, x, cont){
		                return caml_trampoline_cps_call2
		                        (f, x, function(a){return cont(1 - a);});
		               }
		               function compose(f, g, x, cont){
		                return caml_trampoline_cps_call2
		                        (g,
		                         x,
		                         function(a){return caml_trampoline_cps_call2(f, a, cont);});
		               }
		               function Make_general(M){
		                var bind = M[1], return$ = M[3];
		                function map_via_bind(ma, f, cont){
		                 return caml_trampoline_cps_call3
		                         (M[1],
		                          ma,
		                          function(a, cont){
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(M[3], a, cont);
		                                    });
		                          },
		                          cont);
		                }
		                var match = M[2];
		                if(typeof match === "number")
		                 var map = map_via_bind;
		                else
		                 var x = match[2], map = x;
		                function symbol_bind(t, f, cont){
		                 return caml_trampoline_cps_call3(bind, t, f, cont);
		                }
		                function symbol_map(t, f, cont){
		                 return caml_trampoline_cps_call3(map, t, f, cont);
		                }
		                function both(a, b, cont){
		                 function f(a, cont){
		                  function f(b, cont){return cont([0, a, b]);}
		                  return caml_trampoline_cps_call3(map, b, f, cont);
		                 }
		                 return caml_trampoline_cps_call3(bind, a, f, cont);
		                }
		                var Let_syntax = [0, return$, bind, map, both, [0]];
		                function join(t, cont){
		                 function f(t, cont){return cont(t);}
		                 return caml_trampoline_cps_call3(bind, t, f, cont);
		                }
		                function ignore_m(t, cont){
		                 return caml_trampoline_cps_call3
		                         (map, t, function(param, cont){return cont(0);}, cont);
		                }
		                function loop(vs, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call
		                          (of_rev_keys,
		                           vs,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$, a, cont);
		                           });
		                 var ts = param[2], t = param[1];
		                 function f(v, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (loop, [0, v, vs], ts, cont);
		                 }
		                 return caml_trampoline_cps_call3(bind, t, f, cont);
		                }
		                function all(ts, cont){
		                 return caml_exact_trampoline_cps_call$1(loop, 0, ts, cont);
		                }
		                function all_unit(param, cont){
		                 if(! param)
		                  return caml_trampoline_cps_call2(return$, 0, cont);
		                 var ts = param[2], t = param[1];
		                 function f(param, cont){
		                  return caml_exact_trampoline_cps_call(all_unit, ts, cont);
		                 }
		                 return caml_trampoline_cps_call3(bind, t, f, cont);
		                }
		                return [0,
		                        bind,
		                        return$,
		                        ,
		                        map,
		                        [0, symbol_bind, symbol_map],
		                        symbol_bind,
		                        symbol_map,
		                        [0, return$, symbol_bind, symbol_map, Let_syntax],
		                        join,
		                        ignore_m,
		                        all,
		                        all_unit];
		               }
		               function Make2(M){
		                var
		                 bind = M[1],
		                 map = M[2],
		                 return$ = M[3],
		                 a = Make_general([0, bind, map, return$]);
		                return [0,
		                        a[6],
		                        a[7],
		                        a[8],
		                        ,
		                        a[1],
		                        a[2],
		                        a[4],
		                        a[9],
		                        ,
		                        a[11]];
		               }
		               function Make(M){
		                var
		                 bind = M[1],
		                 return$ = M[2],
		                 map = M[3],
		                 a = Make_general([0, bind, map, return$]);
		                return [0,
		                        a[6],
		                        a[7],
		                        a[5],
		                        a[1],
		                        a[2],
		                        a[4],
		                        a[9],
		                        a[10],
		                        a[11],
		                        a[12],
		                        a[8]];
		               }
		               function Make2_local(M){
		                var bind = M[1], return$ = M[3];
		                function map_via_bind(ma, f, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (M[1],
		                          ma,
		                          function(a, cont){
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(M[3], a, cont);
		                                    });
		                          },
		                          cont);
		                }
		                var match = M[2];
		                if(typeof match === "number")
		                 var map = map_via_bind;
		                else
		                 var x = match[2], map = x;
		                function symbol_bind(t, f, cont){
		                 return caml_exact_trampoline_cps_call$1(bind, t, f, cont);
		                }
		                function symbol_map(t, f, cont){
		                 return caml_exact_trampoline_cps_call$1(map, t, f, cont);
		                }
		                function both(a, b, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (bind,
		                          a,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map, b, function(b, cont){return cont([0, a, b]);}, cont);
		                          },
		                          cont);
		                }
		                function join(t, cont){
		                 function f(a, cont){return cont(a);}
		                 return caml_exact_trampoline_cps_call$1(bind, t, f, cont);
		                }
		                function loop(vs, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call
		                          (of_rev_keys,
		                           vs,
		                           function(a){
		                            return caml_exact_trampoline_cps_call(return$, a, cont);
		                           });
		                 var ts = param[2], t = param[1];
		                 function f(v, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (loop, [0, v, vs], ts, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1(bind, t, f, cont);
		                }
		                function all(ts, cont){
		                 return caml_exact_trampoline_cps_call$1(loop, 0, ts, cont);
		                }
		                function all_unit(param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call(return$, 0, cont);
		                 var ts = param[2], t = param[1];
		                 function f(param, cont){
		                  return caml_exact_trampoline_cps_call(all_unit, ts, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1(bind, t, f, cont);
		                }
		                return [0,
		                        bind,
		                        return$,
		                        ,
		                        map,
		                        ,
		                        symbol_bind,
		                        symbol_map,
		                        [0, , , , [0, , , , both]],
		                        join,
		                        ,
		                        all,
		                        all_unit];
		               }
		               function bind$0(a, f, cont){
		                return caml_trampoline_cps_call2(f, a, cont);
		               }
		               function map$4(a, f, cont){
		                return caml_trampoline_cps_call2(f, a, cont);
		               }
		               function symbol_map(a, f, cont){
		                return caml_trampoline_cps_call2(f, a, cont);
		               }
		               function symbol_bind$0(a, f, cont){
		                return caml_trampoline_cps_call2(f, a, cont);
		               }
		               function return$(a, cont){return cont(a);}
		               function both(a, b, cont){return cont([0, a, b]);}
		               var
		                include$0 =
		                  [0,
		                   symbol_bind$0,
		                   symbol_map,
		                   [0, symbol_bind$0, symbol_map],
		                   bind$0,
		                   function(a, cont){return cont(a);},
		                   map$4,
		                   function(a, cont){return cont(a);},
		                   function(a, cont){return cont(0);},
		                   function(a, cont){return cont(a);},
		                   function(a, cont){return cont(0);},
		                   [0,
		                    return$,
		                    symbol_bind$0,
		                    symbol_map,
		                    [0, return$, bind$0, map$4, both, [0]]]];
		               function Make$0(X){
		                var return$ = X[1], symbol = X[2], map$0 = X[3];
		                function derived_map(t, f, cont){
		                 return caml_exact_trampoline_cps_call
		                         (return$, f, function(a){return cont(symbol(a, t));});
		                }
		                if(typeof map$0 === "number")
		                 var map = derived_map;
		                else
		                 var x = map$0[2], map = x;
		                return [0, return$, map, , , , , , symbol];
		               }
		               function make$2(compare, sexp_of_t){
		                var comparator = [0, compare, sexp_of_t];
		                return [0, comparator];
		               }
		               function Make$1(M){
		                var comparator = [0, M[1], M[2]];
		                return [0, comparator];
		               }
		               function int_to_int32_exn(x, cont){return cont(x);}
		               var
		                min$31 = caml_int64_create_lo_mi_hi(0, 16777088, 65535),
		                max$33 = caml_int64_create_lo_mi_hi(16777215, 127, 0);
		               function int64_is_representable_as_int(x){
		                var
		                 a = caml_int64_compare(min$31, x) <= 0 ? 1 : 0,
		                 a = a ? caml_int64_compare(x, max$33) <= 0 ? 1 : 0 : a;
		                return a;
		               }
		               function int64_to_int_exn(x$0, cont){
		                if(int64_is_representable_as_int(x$0))
		                 return cont(caml_int64_to_int32(x$0));
		                var
		                 x = caml_int64_add(x$0, ew),
		                 a = caml_int64_format(cst_d, x);
		                return caml_exact_trampoline_cps_call
		                        (failwithf,
		                         bp,
		                         function(b){
		                          return caml_trampoline_cps_call5
		                                  (b, cst_int64, cst_int, a, 0, cont);
		                         });
		               }
		               var d; 
		               function int_to_nativeint(a, cont){return cont(a);}
		               var
		                min$7 = caml_int64_create_lo_mi_hi(0, 0, 49152),
		                max$7 = caml_int64_create_lo_mi_hi(16777215, 16777215, 16383);
		               function int64_is_representable_as_int6(x){
		                var
		                 a = caml_int64_compare(min$7, x) <= 0 ? 1 : 0,
		                 a = a ? caml_int64_compare(x, max$7) <= 0 ? 1 : 0 : a;
		                return a;
		               }
		               function get_decode_result(t, byte_pos){return get_utf_8_uchar$0(t, byte_pos);
		               }
		               function get_utf_16le_uchar(t, byte_pos, cont){
		                var
		                 b = caml_bytes_of_string(t),
		                 max = caml_ml_bytes_length(b) - 1 | 0;
		                if(0 <= byte_pos && max >= byte_pos){
		                 if(byte_pos === max) return cont(utf_decode_invalid(1));
		                 var hi = caml_bytes_get16(b, byte_pos);
		                 if(55296 <= hi && 57343 >= hi){
		                  if(56319 < hi) return cont(utf_decode_invalid(2));
		                  var last = byte_pos + 3 | 0;
		                  if(max < last)
		                   return cont
		                           (utf_decode_invalid((max - byte_pos | 0) + 1 | 0));
		                  var i = byte_pos + 2 | 0, lo = caml_bytes_get16(b, i);
		                  if(56320 <= lo && 57343 >= lo){
		                   var u = ((hi & 1023) << 10 | lo & 1023) + 65536 | 0;
		                   return cont(utf_decode(4, u));
		                  }
		                  return cont(utf_decode_invalid(2));
		                 }
		                 return cont(utf_decode(2, hi));
		                }
		                return caml_exact_trampoline_cps_call
		                        (invalid_arg, cst_index_out_of_bounds, cont);
		               }
		               function get_utf_16be_uchar(t, byte_pos, cont){
		                var
		                 b = caml_bytes_of_string(t),
		                 max = caml_ml_bytes_length(b) - 1 | 0;
		                if(0 <= byte_pos && max >= byte_pos){
		                 if(byte_pos === max) return cont(utf_decode_invalid(1));
		                 var hi = unsafe_get_uint16_be(b, byte_pos);
		                 if(55296 <= hi && 57343 >= hi){
		                  if(56319 < hi) return cont(utf_decode_invalid(2));
		                  var last = byte_pos + 3 | 0;
		                  if(max < last)
		                   return cont
		                           (utf_decode_invalid((max - byte_pos | 0) + 1 | 0));
		                  var lo = unsafe_get_uint16_be(b, byte_pos + 2 | 0);
		                  if(56320 <= lo && 57343 >= lo){
		                   var u = ((hi & 1023) << 10 | lo & 1023) + 65536 | 0;
		                   return cont(utf_decode(4, u));
		                  }
		                  return cont(utf_decode_invalid(2));
		                 }
		                 return cont(utf_decode(2, hi));
		                }
		                return caml_exact_trampoline_cps_call
		                        (invalid_arg, cst_index_out_of_bounds, cont);
		               }
		               function get_utf_32_uchar(get_int32, t, byte_pos){
		                var
		                 len = caml_ml_string_length(t),
		                 a = 0 <= byte_pos,
		                 a = a ? byte_pos < len : a;
		                if(! a)
		                 throw caml_maybe_attach_backtrace
		                        ([0, Invalid_argument, cst_index_out_of_bounds], 1);
		                var bytes_read = len - byte_pos | 0;
		                if(2 >= bytes_read - 1 >>> 0)
		                 return utf_decode_invalid(bytes_read);
		                var int32 = get_int32(t, byte_pos), int = int32;
		                return int_is_scalar(int)
		                        ? utf_decode(4, int)
		                        : utf_decode_invalid(4);
		               }
		               function get_utf_32le_uchar(t, byte_pos){
		                return get_utf_32_uchar(get_int32_le, t, byte_pos);
		               }
		               function get_utf_32be_uchar(t, byte_pos){
		                return get_utf_32_uchar(get_int32_be$0, t, byte_pos);
		               }
		               function concat$0(opt, l, cont){
		                var sep = opt ? opt[1] : cst$1;
		                if(! l) return cont(cst$1);
		                if(l[2])
		                 return caml_exact_trampoline_cps_call$1(concat, sep, l, cont);
		                var x = l[1];
		                return cont(x);
		               }
		               function back_up_at_newline(t, pos, eol){
		                a:
		                {
		                 if(0 < pos[1]){
		                  var t1 = caml_string_get(t, pos[1] - 1 | 0);
		                  if(t1 === 13){var a = 2; break a;}
		                 }
		                 a = 1;
		                }
		                pos[1] = pos[1] - a | 0;
		                eol[1] = pos[1] + 1 | 0;
		               }
		               function split_lines(t, cont){
		                var n = caml_ml_string_length(t);
		                if(0 === n) return cont(0);
		                var
		                 pos = [0, n - 1 | 0],
		                 t1 = caml_string_get(t, pos[1]),
		                 eol = [0, n];
		                function a(ac){
		                 if(0 > pos[1])
		                  return caml_exact_trampoline_cps_call$0
		                          (get_sub,
		                           t,
		                           0,
		                           eol[1],
		                           function(a){return cont([0, a, ac]);});
		                 var t1 = caml_string_get(t, pos[1]);
		                 if(t1 === 10){
		                  var start = pos[1] + 1 | 0;
		                  return caml_exact_trampoline_cps_call$0
		                          (get_sub,
		                           t,
		                           start,
		                           eol[1] - start | 0,
		                           function(b){
		                            back_up_at_newline(t, pos, eol);
		                            return caml_exact_trampoline_call1(a, [0, b, ac]);
		                           });
		                 }
		                 pos[1]--;
		                 return caml_exact_trampoline_call1(a, ac);
		                }
		                var ac = 0;
		                return t1 === 10
		                        ? (back_up_at_newline(t, pos, eol), a(ac))
		                        : a(ac);
		               }
		               function to_string$2(param, cont){
		                var
		                 pos_cnum = param[4],
		                 pos_bol = param[3],
		                 pos_lnum = param[2],
		                 pos_fname = param[1],
		                 n = pos_cnum - pos_bol | 0;
		                return caml_exact_trampoline_cps_call$1
		                        (concat$0,
		                         0,
		                         [0,
		                          pos_fname,
		                          [0, cst$21, [0, "" + pos_lnum, [0, cst$21, [0, "" + n, 0]]]]],
		                         cont);
		               }
		               function sexp_of_t$0(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$2, t, function(a){return cont([0, a]);});
		               }
		               function is_empty(param){return param ? 0 : 1;}
		               function partition_map(t, f, cont){
		                function a(t, fst, snd){
		                 if(! t)
		                  return caml_exact_trampoline_cps_call
		                          (of_rev_keys,
		                           snd,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (of_rev_keys, fst, function(b){return cont([0, b, a]);});
		                           });
		                 var t$0 = t[2], x = t[1];
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          x,
		                          function(match){
		                           if(0 === match[0]){
		                            var y = match[1], fst$0 = [0, y, fst];
		                            return caml_exact_trampoline_call3(a, t$0, fst$0, snd);
		                           }
		                           var y$0 = match[1], snd$0 = [0, y$0, snd];
		                           return caml_exact_trampoline_call3(a, t$0, fst, snd$0);
		                          });
		                }
		                return a(t, 0, 0);
		               }
		               function bind$2(x, f, cont){
		                if(0 !== x[0]) return cont(x);
		                var x$0 = x[1];
		                return caml_trampoline_cps_call2(f, x$0, cont);
		               }
		               var
		                map$6 =
		                  [0,
		                   ,
		                   function(x, f, cont){
		                    if(0 !== x[0]) return cont(x);
		                    var x$0 = x[1];
		                    return caml_trampoline_cps_call2
		                            (f, x$0, function(a){return cont([0, a]);});
		                   }];
		               function return$0(x, cont){return cont([0, x]);}
		               var
		                e = Make2_local([0, bind$2, map$6, return$0]),
		                all_unit = e[12],
		                all$10 = e[11],
		                join = e[9],
		                map$5 = e[4],
		                of_string$0 = e[2],
		                bind$1 = e[1],
		                Let_syntax$0 = e[8],
		                symbol_map$0 = e[7],
		                symbol_bind$1 = e[6];
		               function fail(x, cont){return cont([1, x]);}
		               function map_error(t, f, cont){
		                if(0 === t[0]) return cont(t);
		                var x = t[1];
		                return caml_trampoline_cps_call2
		                        (f, x, function(a){return cont([1, a]);});
		               }
		               function is_ok(param){return 0 === param[0] ? 1 : 0;}
		               function ok$0(param){
		                if(0 !== param[0]) return 0;
		                var x = param[1];
		                return [0, x];
		               }
		               function of_option(opt, error){
		                if(! opt) return [1, error];
		                var x = opt[1];
		                return [0, x];
		               }
		               function to_either(param, cont){
		                if(0 === param[0]){var x = param[1]; return cont([0, x]);}
		                var x$0 = param[1];
		                return cont([1, x$0]);
		               }
		               function ok_or_failwith(param, cont){
		                if(0 === param[0]){var x = param[1]; return cont(x);}
		                var str = param[1];
		                return caml_exact_trampoline_cps_call(failwith, str, cont);
		               }
		               function sum(fold, M, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold,
		                         t,
		                         M[1],
		                         function(n, a, cont){
		                          var b = f(a);
		                          return cont(M[2].call(null, n, b));
		                         },
		                         cont);
		               }
		               function fold_result(fold, init, f, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fold,
		                                   t,
		                                   init,
		                                   function(acc, item, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (f,
		     acc,
		     item,
		     function(e){
		      if(0 !== e[0])
		       return caml_exact_trampoline_cps_call(param, e, cont);
		      var x = e[1];
		      return cont(x);
		     });
		                                   },
		                                   function(a){return cont([0, a]);});
		                         },
		                         cont);
		               }
		               function fold_until(fold, init, f, finish, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fold,
		                                   t,
		                                   init,
		                                   function(acc, item, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (f,
		     acc,
		     item,
		     function(match){
		      if(0 === match[0]){var x = match[1]; return cont(x);}
		      var x$0 = match[1];
		      return caml_exact_trampoline_cps_call(param, x$0, cont);
		     });
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(finish, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function min_elt(fold, t, compare, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold,
		                         t,
		                         0,
		                         function(acc, elt, cont){
		                          if(! acc) return cont([0, elt]);
		                          var min = acc[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (compare,
		                                   min,
		                                   elt,
		                                   function(a){return 0 < a ? cont([0, elt]) : cont(acc);});
		                         },
		                         cont);
		               }
		               function max_elt(fold, t, compare, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold,
		                         t,
		                         0,
		                         function(acc, elt, cont){
		                          if(! acc) return cont([0, elt]);
		                          var max = acc[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (compare,
		                                   max,
		                                   elt,
		                                   function(a){return 0 <= a ? cont(acc) : cont([0, elt]);});
		                         },
		                         cont);
		               }
		               function to_list(fold, c, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold,
		                         c,
		                         0,
		                         function(acc, x, cont){return cont([0, x, acc]);},
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_rev_keys, a, cont);
		                         });
		               }
		               function Make_gen(T){
		                var fold = T[1];
		                function to_list$0(t, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (to_list, fold, t, cont);
		                }
		                return [0, , , , , , , , , , , , , , to_list$0];
		               }
		               function findi(iteri, c, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(r, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (iteri,
		                                   c,
		                                   function(i, x, cont){
		                                    var a = f(i, x);
		                                    return a
		    ? caml_exact_trampoline_cps_call(r, [0, [0, i, x]], cont)
		    : cont(a);
		                                   },
		                                   function(a){return cont(0);});
		                         },
		                         cont);
		               }
		               function check_pos_len_exn(pos, len, total_length, cont){
		                var
		                 stop = pos + len | 0,
		                 a = (pos | len | stop | total_length - stop | 0) < 0 ? 1 : 0;
		                if(! a) return cont(a);
		                function b(b){
		                 function a(a){
		                  a = (total_length - len | 0) < pos ? 1 : 0;
		                  if(! a) return cont(a);
		                  return caml_exact_trampoline_cps_call
		                          (invalid_argf,
		                           ez,
		                           function(a){
		                            return caml_trampoline_cps_call5
		                                    (a, pos, len, total_length, 0, cont);
		                           });
		                 }
		                 if(len >= 0) return a(0);
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          ey,
		                          function(b){return caml_trampoline_cps_call3(b, len, 0, a);});
		                }
		                if(pos >= 0) return b();
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         ex,
		                         function(a){return caml_trampoline_cps_call3(a, pos, 0, b);});
		               }
		               function get_pos_len_exn(opt, len, param, total_length, cont){
		                var pos = opt ? opt[1] : 0;
		                if(len)
		                 var i = len[1], len$0 = i;
		                else
		                 len$0 = total_length - pos | 0;
		                return caml_exact_trampoline_cps_call$0
		                        (check_pos_len_exn,
		                         pos,
		                         len$0,
		                         total_length,
		                         function(a){return cont([0, pos, len$0]);});
		               }
		               function bQN(T){
		                var
		                 fold = T[1],
		                 iter = T[2],
		                 length = T[3],
		                 include = Make_gen([0, fold, iter, length]),
		                 to_list = include[14];
		                return [0, , , , , , , , , , , , , , to_list];
		               }
		               {
		                var
		                 split_from_parent$0 =
		                   function(v, cont){
		                    return caml_exact_trampoline_cps_call(split, v, cont);
		                   };
		                new_key([0, split_from_parent$0], make_self_init);
		               }
		               function singleton(x, cont){return cont([0, x, 0]);}
		               function range(c, b, opt, start_i, stop_i, cont){
		                var
		                 stride = c ? c[1] : 1,
		                 start = b ? b[1] : 104758188,
		                 stop = opt ? opt[1] : -160346914;
		                function a(c){
		                 function stride$0(x){return x + stride | 0;}
		                 function compare(b, a){return caml_int_compare(b, a);}
		                 var next_i = stride$0(start_i);
		                 function order(x, y){
		                  var n = compare(x, y);
		                  return 0 <= n ? 0 === n ? 1 : 2 : 0;
		                 }
		                 var
		                  a =
		                    "List.range': stride function cannot return the same value";
		                 function b(initial_stride_order){
		                  var
		                   start_i$0 = 104758188 <= start ? start_i : next_i,
		                   i_to_stop_order = order(start_i$0, stop_i),
		                   stop$0 = stop;
		                  a:
		                  {
		                   switch(i_to_stop_order){
		                     case 0:
		                      if(847855481 <= initial_stride_order) break a; break;
		                     case 1:
		                      return 104758188 <= stop$0
		                              ? cont([0, start_i$0, 0])
		                              : cont(0);
		                     default: if(847855481 > initial_stride_order) break a;
		                   }
		                   return cont(0);
		                  }
		                  var
		                   next_i$0 = stride$0(start_i$0),
		                   cst_List_range_stride_function =
		                     "List.range': stride function cannot change direction";
		                  a:
		                  {
		                   switch(order(start_i$0, next_i$0)){
		                     case 0:
		                      if(847855481 > initial_stride_order) break a; break;
		                     case 1:
		                      return caml_exact_trampoline_cps_call(invalid_arg, a, cont);
		                     default: if(847855481 <= initial_stride_order) break a;
		                   }
		                   b:
		                   {
		                    var
		                     block = [0, start_i$0, 24029],
		                     dst = block,
		                     offset = 1,
		                     i = next_i$0;
		                    c:
		                    for(;;){
		                     var
		                      i_to_stop_order$0 = order(i, stop_i),
		                      b = function(){return cont(block);};
		                     d:
		                     {
		                      switch(i_to_stop_order$0){
		                        case 0:
		                         if(847855481 <= initial_stride_order) break d; break;
		                        case 1:
		                         return 104758188 <= stop$0
		                                 ? (dst[offset + 1] = [0, i, 0], b())
		                                 : (dst[offset + 1] = 0, b());
		                        default: if(847855481 > initial_stride_order) break d;
		                      }
		                      dst[offset + 1] = 0;
		                      return b();
		                     }
		                     var next_i$1 = stride$0(i);
		                     switch(order(i, next_i$1)){
		                       case 0:
		                        if(847855481 > initial_stride_order) break b; break;
		                       case 1:
		                        break c;
		                       default: if(847855481 <= initial_stride_order) break b;
		                     }
		                     var dst$0 = [0, i, 24029];
		                     dst[offset + 1] = dst$0;
		                     dst = dst$0;
		                     offset = 1;
		                     i = next_i$1;
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (invalid_arg,
		                             a,
		                             function(a){dst[offset + 1] = a; return b();});
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (invalid_arg,
		                            cst_List_range_stride_function,
		                            function(a){dst[offset + 1] = a; return b();});
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg, cst_List_range_stride_function, cont);
		                 }
		                 switch(order(start_i, next_i)){
		                   case 0:
		                    return b(847855481);
		                   case 1:
		                    return caml_exact_trampoline_cps_call(invalid_arg, a, b);
		                   default: return b(85047514);
		                 }
		                }
		                return 0 === stride
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg, "List.range: stride must be non-zero", a)
		                        : a();
		               }
		               function hd$0(t, cont){
		                if(! t) return cont(0);
		                var x = t[1];
		                return cont([0, x]);
		               }
		               function of_lists(l1, l2){
		                var a = l1, b = l2, shared_length = 0;
		                for(;;){
		                 if(a){
		                  if(b){
		                   var
		                    b$0 = b[2],
		                    a$0 = a[2],
		                    shared_length$0 = shared_length + 1 | 0;
		                   a = a$0;
		                   b = b$0;
		                   shared_length = shared_length$0;
		                   continue;
		                  }
		                 }
		                 else if(! b) return [0, shared_length];
		                 return [1, shared_length, a, b];
		                }
		               }
		               function check_length2_exn(name, l1, l2, cont){
		                var match = of_lists(l1, l2);
		                if(0 === match[0]) return cont();
		                var
		                 tail_of_b = match[3],
		                 tail_of_a = match[2],
		                 shared_length = match[1];
		                return caml_exact_trampoline_cps_call
		                        (length$1,
		                         tail_of_b,
		                         function(b){
		                          var a = shared_length + b | 0;
		                          return caml_exact_trampoline_cps_call
		                                  (length$1,
		                                   tail_of_a,
		                                   function(c){
		                                    var b = shared_length + c | 0;
		                                    return caml_exact_trampoline_cps_call
		    (invalid_argf,
		     eB,
		     function(c){
		      return caml_trampoline_cps_call5(c, name, b, a, 0, cont);
		     });
		                                   });
		                         });
		               }
		               function mem(t, a, equal, cont){
		                function b(param){
		                 if(! param) return cont(0);
		                 var bs = param[2], b$0 = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (equal,
		                          a,
		                          b$0,
		                          function(a){
		                           return a ? cont(a) : caml_exact_trampoline_call1(b, bs);
		                          });
		                }
		                return b(t);
		               }
		               function filter(l, f, cont){
		                function a(l){
		                 if(! l) return cont(0);
		                 var tl = l[2], hd = l[1];
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          hd,
		                          function(c){
		                           if(! c) return caml_exact_trampoline_call1(a, tl);
		                           var block = [0, hd, 24029];
		                           function b(dst, offset, l){
		                            if(l){
		                             var tl = l[2], hd = l[1];
		                             return caml_exact_trampoline_cps_call
		                                     (f,
		                                      hd,
		                                      function(a){
		                                       if(! a)
		return caml_exact_trampoline_call3(b, dst, offset, tl);
		                                       var dst$0 = [0, hd, 24029];
		                                       dst[offset + 1] = dst$0;
		                                       return caml_exact_trampoline_call3(b, dst$0, 1, tl);
		                                      });
		                            }
		                            dst[offset + 1] = 0;
		                            return cont(block);
		                           }
		                           return b(block, 1, tl);
		                          });
		                }
		                return a(l);
		               }
		               function append$0(l1$0, l2, cont){
		                if(! l2) return cont(l1$0);
		                if(! l1$0) return cont(l2);
		                var a = l1$0[2], x1 = l1$0[1];
		                if(! a) return cont([0, x1, l2]);
		                var b = a[2], x2 = a[1];
		                if(! b) return cont([0, x1, [0, x2, l2]]);
		                a = b[2];
		                var x3 = b[1];
		                if(! a) return cont([0, x1, [0, x2, [0, x3, l2]]]);
		                b = a[2];
		                var x4 = a[1];
		                if(! b) return cont([0, x1, [0, x2, [0, x3, [0, x4, l2]]]]);
		                var
		                 tl = b[2],
		                 x5 = b[1],
		                 block = [0, x5, 24029],
		                 dst = block,
		                 offset = 1,
		                 l1 = tl;
		                for(;;){
		                 if(l1){
		                  b = l1[2];
		                  var x1$0 = l1[1];
		                  if(b){
		                   a = b[2];
		                   var x2$0 = b[1];
		                   if(a){
		                    b = a[2];
		                    var x3$0 = a[1];
		                    if(b){
		                     a = b[2];
		                     var x4$0 = b[1];
		                     if(a){
		                      var tl$0 = a[2], x5$0 = a[1], dst$0 = [0, x5$0, 24029];
		                      dst[offset + 1] =
		                       [0, x1$0, [0, x2$0, [0, x3$0, [0, x4$0, dst$0]]]];
		                      dst = dst$0;
		                      offset = 1;
		                      l1 = tl$0;
		                      continue;
		                     }
		                     dst[offset + 1] =
		                      [0, x1$0, [0, x2$0, [0, x3$0, [0, x4$0, l2]]]];
		                    }
		                    else
		                     dst[offset + 1] = [0, x1$0, [0, x2$0, [0, x3$0, l2]]];
		                   }
		                   else
		                    dst[offset + 1] = [0, x1$0, [0, x2$0, l2]];
		                  }
		                  else
		                   dst[offset + 1] = [0, x1$0, l2];
		                 }
		                 else
		                  dst[offset + 1] = l2;
		                 return cont([0, x1, [0, x2, [0, x3, [0, x4, block]]]]);
		                }
		               }
		               function map$7(l, f, cont){
		                if(! l) return cont(0);
		                var tl = l[2], x = l[1];
		                return caml_trampoline_cps_call2
		                        (f,
		                         x,
		                         function(b){
		                          var block = [0, b, 24029];
		                          function a(dst, offset, l){
		                           if(l){
		                            var tl = l[2], x = l[1];
		                            return caml_trampoline_cps_call2
		                                    (f,
		                                     x,
		                                     function(b){
		                                      var dst$0 = [0, b, 24029];
		                                      dst[offset + 1] = dst$0;
		                                      return caml_exact_trampoline_call3(a, dst$0, 1, tl);
		                                     });
		                           }
		                           dst[offset + 1] = 0;
		                           return cont(block);
		                          }
		                          return a(block, 1, tl);
		                         });
		               }
		               function folding_map(t, init, f, cont){
		                var acc = [0, init];
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         t,
		                         function(x, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (f,
		                                   acc[1],
		                                   x,
		                                   function(match){
		                                    var y = match[2], new_acc = match[1];
		                                    acc[1] = new_acc;
		                                    return cont(y);
		                                   });
		                         },
		                         cont);
		               }
		               function fold_map(t, init, f, cont){
		                var acc = [0, init];
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         t,
		                         function(x, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (f,
		                                   acc[1],
		                                   x,
		                                   function(match){
		                                    var y = match[2], new_acc = match[1];
		                                    acc[1] = new_acc;
		                                    return cont(y);
		                                   });
		                         },
		                         function(result){return cont([0, acc[1], result]);});
		               }
		               function map2_ok(l1, l2, f, cont){
		                var cst_List_map2 = "List.map2";
		                if(l1){
		                 if(l2){
		                  var l2$0 = l2[2], x2 = l2[1], l1$0 = l1[2], x1 = l1[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (f,
		                           x1,
		                           x2,
		                           function(b){
		                            var block = [0, b, 24029];
		                            function a(dst, offset, l1, l2){
		                             function b(){return cont(block);}
		                             if(l1){
		                              if(l2){
		                               var l2$0 = l2[2], x2 = l2[1], l1$0 = l1[2], x1 = l1[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (f,
		x1,
		x2,
		function(b){
		 var dst$0 = [0, b, 24029];
		 dst[offset + 1] = dst$0;
		 return caml_exact_trampoline_call4(a, dst$0, 1, l1$0, l2$0);
		});
		                              }
		                             }
		                             else if(! l2){dst[offset + 1] = 0; return b();}
		                             return caml_exact_trampoline_cps_call
		                                     (invalid_arg,
		                                      cst_List_map2,
		                                      function(a){dst[offset + 1] = a; return b();});
		                            }
		                            return a(block, 1, l1$0, l2$0);
		                           });
		                 }
		                }
		                else if(! l2) return cont(0);
		                return caml_exact_trampoline_cps_call
		                        (invalid_arg, cst_List_map2, cont);
		               }
		               function map2_exn(l1, l2, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (check_length2_exn,
		                         "map2_exn",
		                         l1,
		                         l2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (map2_ok, l1, l2, f, cont);
		                         });
		               }
		               function unzip(list, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys,
		                         list,
		                         function(list){
		                          function a(list, l1, l2){
		                           if(! list) return cont([0, l1, l2]);
		                           var
		                            list$0 = list[2],
		                            match = list[1],
		                            y = match[2],
		                            x = match[1],
		                            l2$0 = [0, y, l2],
		                            l1$0 = [0, x, l1];
		                           return caml_exact_trampoline_call3(a, list$0, l1$0, l2$0);
		                          }
		                          return a(list, 0, 0);
		                         });
		               }
		               function mapi$0(l, f, cont){
		                if(! l) return cont(0);
		                var t = l[2], h = l[1];
		                return caml_exact_trampoline_cps_call$1
		                        (f,
		                         0,
		                         h,
		                         function(b){
		                          var block = [0, b, 24029];
		                          function a(dst, offset, i, param){
		                           if(param){
		                            var t = param[2], h = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (f,
		                                     i,
		                                     h,
		                                     function(block0_arg0){
		                                      var block = [0, block0_arg0, 24029];
		                                      dst[offset + 1] = block;
		                                      var i$0 = i + 1 | 0;
		                                      return caml_exact_trampoline_call4(a, block, 1, i$0, t);
		                                     });
		                           }
		                           dst[offset + 1] = 0;
		                           return cont(block);
		                          }
		                          return a(block, 1, 1, t);
		                         });
		               }
		               function reduce(l, f, cont){
		                if(! l) return cont(0);
		                var tl = l[2], hd = l[1];
		                return caml_exact_trampoline_cps_call$0
		                        (fold_left$1, tl, hd, f, function(a){return cont([0, a]);});
		               }
		               function merge_dps(dst, offset, l1, l2, compare, cont){
		                function a(dst, offset, l1, l2){
		                 if(! l1){dst[offset + 1] = l2; return cont();}
		                 if(l2){
		                  var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (compare,
		                           h1,
		                           h2,
		                           function(b){
		                            if(0 < b){
		                             var dst$0 = [0, h2, 24029];
		                             dst[offset + 1] = dst$0;
		                             return caml_exact_trampoline_call4(a, dst$0, 1, l1, t2);
		                            }
		                            var dst$1 = [0, h1, 24029];
		                            dst[offset + 1] = dst$1;
		                            return caml_exact_trampoline_call4(a, dst$1, 1, t1, l2);
		                           });
		                 }
		                 dst[offset + 1] = l1;
		                 return cont();
		                }
		                return a(dst, offset, l1, l2);
		               }
		               function stable_sort(l, cmp, cont){
		                function sort(n, l, cont){
		                 if(2 === n){
		                  if(l){
		                   var a = l[2];
		                   if(a){
		                    var tl = a[2], x2 = a[1], x1 = l[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (cmp,
		                             x1,
		                             x2,
		                             function(a){
		                              var s = 0 < a ? [0, x2, [0, x1, 0]] : [0, x1, [0, x2, 0]];
		                              return cont([0, s, tl]);
		                             });
		                   }
		                  }
		                 }
		                 else if(3 === n && l){
		                  a = l[2];
		                  if(a){
		                   var match = a[2];
		                   if(match){
		                    var
		                     tl$0 = match[2],
		                     x3 = match[1],
		                     x2$0 = a[1],
		                     x1$0 = l[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (cmp,
		                             x1$0,
		                             x2$0,
		                             function(b){
		                              function a(s){return cont([0, s, tl$0]);}
		                              return 0 < b
		                                      ? caml_exact_trampoline_cps_call$1
		(cmp,
		 x1$0,
		 x3,
		 function(b){
		  return 0 < b
		          ? caml_exact_trampoline_cps_call$1
		            (cmp,
		             x2$0,
		             x3,
		             function(b){
		              return 0 < b
		                      ? a([0, x3, [0, x2$0, [0, x1$0, 0]]])
		                      : a([0, x2$0, [0, x3, [0, x1$0, 0]]]);
		             })
		          : a([0, x2$0, [0, x1$0, [0, x3, 0]]]);
		 })
		                                      : caml_exact_trampoline_cps_call$1
		(cmp,
		 x2$0,
		 x3,
		 function(b){
		  return 0 < b
		          ? caml_exact_trampoline_cps_call$1
		            (cmp,
		             x1$0,
		             x3,
		             function(b){
		              return 0 < b
		                      ? a([0, x3, [0, x1$0, [0, x2$0, 0]]])
		                      : a([0, x1$0, [0, x3, [0, x2$0, 0]]]);
		             })
		          : a([0, x1$0, [0, x2$0, [0, x3, 0]]]);
		 });
		                             });
		                   }
		                  }
		                 }
		                 var n1 = n >> 1, n2 = n - n1 | 0;
		                 return caml_exact_trampoline_cps_call$1
		                         (rev_sort,
		                          n1,
		                          l,
		                          function(match){
		                           var l2 = match[2], s1 = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (rev_sort,
		                                    n2,
		                                    l2,
		                                    function(match){
		                                     var tl = match[2], s2 = match[1];
		                                     function a(l1, l2, accu){
		                                      if(l1){
		                                       if(l2){
		var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
		return caml_exact_trampoline_cps_call$1
		        (cmp,
		         h1,
		         h2,
		         function(b){
		          if(0 < b){
		           var accu$0 = [0, h1, accu];
		           return caml_exact_trampoline_call3(a, t1, l2, accu$0);
		          }
		          var accu$1 = [0, h2, accu];
		          return caml_exact_trampoline_call3(a, l1, t2, accu$1);
		         });
		                                       }
		                                       var b = rev_append(l1, accu);
		                                      }
		                                      else
		                                       b = rev_append(l2, accu);
		                                      return cont([0, b, tl]);
		                                     }
		                                     return a(s1, s2, 0);
		                                    });
		                          });
		                }
		                function rev_sort(n, l, cont){
		                 if(2 === n){
		                  if(l){
		                   var a = l[2];
		                   if(a){
		                    var tl = a[2], x2 = a[1], x1 = l[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (cmp,
		                             x1,
		                             x2,
		                             function(a){
		                              var s = 0 < a ? [0, x1, [0, x2, 0]] : [0, x2, [0, x1, 0]];
		                              return cont([0, s, tl]);
		                             });
		                   }
		                  }
		                 }
		                 else if(3 === n && l){
		                  a = l[2];
		                  if(a){
		                   var match = a[2];
		                   if(match){
		                    var
		                     tl$0 = match[2],
		                     x3 = match[1],
		                     x2$0 = a[1],
		                     x1$0 = l[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (cmp,
		                             x1$0,
		                             x2$0,
		                             function(b){
		                              function a(s){return cont([0, s, tl$0]);}
		                              return 0 < b
		                                      ? caml_exact_trampoline_cps_call$1
		(cmp,
		 x2$0,
		 x3,
		 function(b){
		  return 0 < b
		          ? a([0, x1$0, [0, x2$0, [0, x3, 0]]])
		          : caml_exact_trampoline_cps_call$1
		            (cmp,
		             x1$0,
		             x3,
		             function(b){
		              return 0 < b
		                      ? a([0, x1$0, [0, x3, [0, x2$0, 0]]])
		                      : a([0, x3, [0, x1$0, [0, x2$0, 0]]]);
		             });
		 })
		                                      : caml_exact_trampoline_cps_call$1
		(cmp,
		 x1$0,
		 x3,
		 function(b){
		  return 0 < b
		          ? a([0, x2$0, [0, x1$0, [0, x3, 0]]])
		          : caml_exact_trampoline_cps_call$1
		            (cmp,
		             x2$0,
		             x3,
		             function(b){
		              return 0 < b
		                      ? a([0, x2$0, [0, x3, [0, x1$0, 0]]])
		                      : a([0, x3, [0, x2$0, [0, x1$0, 0]]]);
		             });
		 });
		                             });
		                   }
		                  }
		                 }
		                 var n1 = n >> 1, n2 = n - n1 | 0;
		                 return caml_exact_trampoline_cps_call$1
		                         (sort,
		                          n1,
		                          l,
		                          function(match){
		                           var l2 = match[2], s1 = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (sort,
		                                    n2,
		                                    l2,
		                                    function(match){
		                                     var tl = match[2], s2 = match[1];
		                                     function a(l1, l2, accu){
		                                      if(l1){
		                                       if(l2){
		var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
		return caml_exact_trampoline_cps_call$1
		        (cmp,
		         h1,
		         h2,
		         function(b){
		          if(0 < b){
		           var accu$0 = [0, h2, accu];
		           return caml_exact_trampoline_call3(a, l1, t2, accu$0);
		          }
		          var accu$1 = [0, h1, accu];
		          return caml_exact_trampoline_call3(a, t1, l2, accu$1);
		         });
		                                       }
		                                       var b = rev_append(l1, accu);
		                                      }
		                                      else
		                                       b = rev_append(l2, accu);
		                                      return cont([0, b, tl]);
		                                     }
		                                     return a(s1, s2, 0);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (length$1,
		                         l,
		                         function(len){
		                          return 2 <= len
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (sort, len, l, function(a){return cont(a[1]);})
		                                  : cont(l);
		                         });
		               }
		               function dedup_and_sort(l, cmp, cont){
		                function sort(n, l, cont){
		                 if(2 === n){
		                  if(l){
		                   var a = l[2];
		                   if(a){
		                    var tl = a[2], x2 = a[1], x1 = l[1];
		                    return caml_trampoline_cps_call3
		                            (cmp,
		                             x1,
		                             x2,
		                             function(c){
		                              var
		                               s =
		                                 0 <= c
		                                  ? 0 < c ? [0, x2, [0, x1, 0]] : [0, x2, 0]
		                                  : [0, x1, [0, x2, 0]];
		                              return cont([0, s, tl]);
		                             });
		                   }
		                  }
		                 }
		                 else if(3 === n && l){
		                  a = l[2];
		                  if(a){
		                   var match = a[2];
		                   if(match){
		                    var
		                     tl$0 = match[2],
		                     x3 = match[1],
		                     x2$0 = a[1],
		                     x1$0 = l[1];
		                    return caml_trampoline_cps_call3
		                            (cmp,
		                             x1$0,
		                             x2$0,
		                             function(c){
		                              function a(s){return cont([0, s, tl$0]);}
		                              return 0 <= c
		                                      ? 0
		< c
		? caml_trampoline_cps_call3
		  (cmp,
		   x1$0,
		   x3,
		   function(c){
		    return 0 <= c
		            ? 0
		              < c
		              ? caml_trampoline_cps_call3
		                (cmp,
		                 x2$0,
		                 x3,
		                 function(c){
		                  return 0 <= c
		                          ? 0
		                            < c
		                            ? a([0, x3, [0, x2$0, [0, x1$0, 0]]])
		                            : a([0, x3, [0, x1$0, 0]])
		                          : a([0, x2$0, [0, x3, [0, x1$0, 0]]]);
		                 })
		              : a([0, x2$0, [0, x3, 0]])
		            : a([0, x2$0, [0, x1$0, [0, x3, 0]]]);
		   })
		: caml_trampoline_cps_call3
		  (cmp,
		   x2$0,
		   x3,
		   function(c){
		    return 0 <= c
		            ? 0 < c ? a([0, x3, [0, x2$0, 0]]) : a([0, x3, 0])
		            : a([0, x2$0, [0, x3, 0]]);
		   })
		                                      : caml_trampoline_cps_call3
		(cmp,
		 x2$0,
		 x3,
		 function(c){
		  return 0 <= c
		          ? 0
		            < c
		            ? caml_trampoline_cps_call3
		              (cmp,
		               x1$0,
		               x3,
		               function(c){
		                return 0 <= c
		                        ? 0
		                          < c
		                          ? a([0, x3, [0, x1$0, [0, x2$0, 0]]])
		                          : a([0, x3, [0, x2$0, 0]])
		                        : a([0, x1$0, [0, x3, [0, x2$0, 0]]]);
		               })
		            : a([0, x1$0, [0, x3, 0]])
		          : a([0, x1$0, [0, x2$0, [0, x3, 0]]]);
		 });
		                             });
		                   }
		                  }
		                 }
		                 var n1 = n >> 1, n2 = n - n1 | 0;
		                 return caml_exact_trampoline_cps_call$1
		                         (rev_sort,
		                          n1,
		                          l,
		                          function(match){
		                           var l2 = match[2], s1 = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (rev_sort,
		                                    n2,
		                                    l2,
		                                    function(match){
		                                     var tl = match[2], s2 = match[1];
		                                     function a(l1, l2, accu){
		                                      if(l1){
		                                       if(l2){
		var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
		return caml_trampoline_cps_call3
		        (cmp,
		         h1,
		         h2,
		         function(c){
		          if(0 < c){
		           var accu$0 = [0, h1, accu];
		           return caml_exact_trampoline_call3(a, t1, l2, accu$0);
		          }
		          if(0 <= c)
		           return caml_exact_trampoline_call3(a, t1, l2, accu);
		          var accu$1 = [0, h2, accu];
		          return caml_exact_trampoline_call3(a, l1, t2, accu$1);
		         });
		                                       }
		                                       var b = rev_append(l1, accu);
		                                      }
		                                      else
		                                       b = rev_append(l2, accu);
		                                      return cont([0, b, tl]);
		                                     }
		                                     return a(s1, s2, 0);
		                                    });
		                          });
		                }
		                function rev_sort(n, l, cont){
		                 if(2 === n){
		                  if(l){
		                   var a = l[2];
		                   if(a){
		                    var tl = a[2], x2 = a[1], x1 = l[1];
		                    return caml_trampoline_cps_call3
		                            (cmp,
		                             x1,
		                             x2,
		                             function(c){
		                              var
		                               s =
		                                 0 < c
		                                  ? [0, x1, [0, x2, 0]]
		                                  : 0 <= c ? [0, x2, 0] : [0, x2, [0, x1, 0]];
		                              return cont([0, s, tl]);
		                             });
		                   }
		                  }
		                 }
		                 else if(3 === n && l){
		                  a = l[2];
		                  if(a){
		                   var match = a[2];
		                   if(match){
		                    var
		                     tl$0 = match[2],
		                     x3 = match[1],
		                     x2$0 = a[1],
		                     x1$0 = l[1];
		                    return caml_trampoline_cps_call3
		                            (cmp,
		                             x1$0,
		                             x2$0,
		                             function(c){
		                              function a(s){return cont([0, s, tl$0]);}
		                              return 0 < c
		                                      ? caml_trampoline_cps_call3
		(cmp,
		 x2$0,
		 x3,
		 function(c){
		  return 0 < c
		          ? a([0, x1$0, [0, x2$0, [0, x3, 0]]])
		          : 0
		            <= c
		            ? a([0, x1$0, [0, x3, 0]])
		            : caml_trampoline_cps_call3
		              (cmp,
		               x1$0,
		               x3,
		               function(c){
		                return 0 < c
		                        ? a([0, x1$0, [0, x3, [0, x2$0, 0]]])
		                        : 0
		                          <= c
		                          ? a([0, x3, [0, x2$0, 0]])
		                          : a([0, x3, [0, x1$0, [0, x2$0, 0]]]);
		               });
		 })
		                                      : 0
		<= c
		? caml_trampoline_cps_call3
		  (cmp,
		   x2$0,
		   x3,
		   function(c){
		    return 0 < c
		            ? a([0, x2$0, [0, x3, 0]])
		            : 0 <= c ? a([0, x3, 0]) : a([0, x3, [0, x2$0, 0]]);
		   })
		: caml_trampoline_cps_call3
		  (cmp,
		   x1$0,
		   x3,
		   function(c){
		    return 0 < c
		            ? a([0, x2$0, [0, x1$0, [0, x3, 0]]])
		            : 0
		              <= c
		              ? a([0, x2$0, [0, x3, 0]])
		              : caml_trampoline_cps_call3
		                (cmp,
		                 x2$0,
		                 x3,
		                 function(c){
		                  return 0 < c
		                          ? a([0, x2$0, [0, x3, [0, x1$0, 0]]])
		                          : 0
		                            <= c
		                            ? a([0, x3, [0, x1$0, 0]])
		                            : a([0, x3, [0, x2$0, [0, x1$0, 0]]]);
		                 });
		   });
		                             });
		                   }
		                  }
		                 }
		                 var n1 = n >> 1, n2 = n - n1 | 0;
		                 return caml_exact_trampoline_cps_call$1
		                         (sort,
		                          n1,
		                          l,
		                          function(match){
		                           var l2 = match[2], s1 = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (sort,
		                                    n2,
		                                    l2,
		                                    function(match){
		                                     var tl = match[2], s2 = match[1];
		                                     function a(l1, l2, accu){
		                                      if(l1){
		                                       if(l2){
		var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
		return caml_trampoline_cps_call3
		        (cmp,
		         h1,
		         h2,
		         function(c){
		          if(0 > c){
		           var accu$1 = [0, h1, accu];
		           return caml_exact_trampoline_call3(a, t1, l2, accu$1);
		          }
		          if(0 >= c)
		           return caml_exact_trampoline_call3(a, t1, l2, accu);
		          var accu$0 = [0, h2, accu];
		          return caml_exact_trampoline_call3(a, l1, t2, accu$0);
		         });
		                                       }
		                                       var b = rev_append(l1, accu);
		                                      }
		                                      else
		                                       b = rev_append(l2, accu);
		                                      return cont([0, b, tl]);
		                                     }
		                                     return a(s1, s2, 0);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (length$1,
		                         l,
		                         function(len){
		                          return 2 <= len
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (sort, len, l, function(a){return cont(a[1]);})
		                                  : cont(l);
		                         });
		               }
		               function concat_map(l, f, cont){
		                function f$0(param, x, cont){
		                 return caml_trampoline_cps_call2(f, x, cont);
		                }
		                function outer_loop_dps(dst, offset, pos, param, cont){
		                 if(param){
		                  var tl = param[2], hd = param[1];
		                  return tl
		                          ? caml_exact_trampoline_cps_call$1
		                            (f$0,
		                             pos,
		                             hd,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$3
		                                      (inner_loop_dps, dst, offset, pos + 1 | 0, a, tl, cont);
		                             })
		                          : caml_exact_trampoline_cps_call$1
		                            (f$0,
		                             pos,
		                             hd,
		                             function(a){dst[offset + 1] = a; return cont();});
		                 }
		                 dst[offset + 1] = 0;
		                 return cont();
		                }
		                function inner_loop_dps(dst$1, offset$0, pos, l1$0, l2, cont){
		                 var dst = dst$1, offset = offset$0, l1 = l1$0;
		                 for(;;){
		                  if(! l1)
		                   return caml_exact_trampoline_cps_call$2
		                           (outer_loop_dps, dst, offset, pos, l2, cont);
		                  var a = l1[2], x1 = l1[1];
		                  if(! a){
		                   a = [0, x1, 24029];
		                   dst[offset + 1] = a;
		                   return caml_exact_trampoline_cps_call$2
		                           (outer_loop_dps, a, 1, pos, l2, cont);
		                  }
		                  var b = a[2], x2 = a[1];
		                  if(! b){
		                   b = [0, x2, 24029];
		                   dst[offset + 1] = [0, x1, b];
		                   return caml_exact_trampoline_cps_call$2
		                           (outer_loop_dps, b, 1, pos, l2, cont);
		                  }
		                  a = b[2];
		                  var x3 = b[1];
		                  if(! a){
		                   a = [0, x3, 24029];
		                   dst[offset + 1] = [0, x1, [0, x2, a]];
		                   return caml_exact_trampoline_cps_call$2
		                           (outer_loop_dps, a, 1, pos, l2, cont);
		                  }
		                  b = a[2];
		                  var x4 = a[1];
		                  if(! b){
		                   b = [0, x4, 24029];
		                   dst[offset + 1] = [0, x1, [0, x2, [0, x3, b]]];
		                   return caml_exact_trampoline_cps_call$2
		                           (outer_loop_dps, b, 1, pos, l2, cont);
		                  }
		                  var tl = b[2], x5 = b[1], dst$0 = [0, x5, 24029];
		                  dst[offset + 1] = [0, x1, [0, x2, [0, x3, [0, x4, dst$0]]]];
		                  dst = dst$0;
		                  offset = 1;
		                  l1 = tl;
		                 }
		                }
		                function a(pos, param){
		                 if(! param) return cont(0);
		                 var tl = param[2], hd = param[1];
		                 return tl
		                         ? caml_exact_trampoline_cps_call$1
		                           (f$0,
		                            pos,
		                            hd,
		                            function(l1){
		                             var pos$0 = pos + 1 | 0;
		                             if(! l1) return caml_exact_trampoline_call2(a, pos$0, tl);
		                             var b = l1[2], x1 = l1[1];
		                             if(! b){
		                              var block$3 = [0, x1, 24029];
		                              return caml_exact_trampoline_cps_call$2
		                                      (outer_loop_dps,
		                                       block$3,
		                                       1,
		                                       pos$0,
		                                       tl,
		                                       function(a){return cont(block$3);});
		                             }
		                             var c = b[2], x2 = b[1];
		                             if(! c){
		                              var block$2 = [0, x2, 24029];
		                              return caml_exact_trampoline_cps_call$2
		                                      (outer_loop_dps,
		                                       block$2,
		                                       1,
		                                       pos$0,
		                                       tl,
		                                       function(a){return cont([0, x1, block$2]);});
		                             }
		                             b = c[2];
		                             var x3 = c[1];
		                             if(! b){
		                              var block$1 = [0, x3, 24029];
		                              return caml_exact_trampoline_cps_call$2
		                                      (outer_loop_dps,
		                                       block$1,
		                                       1,
		                                       pos$0,
		                                       tl,
		                                       function(a){return cont([0, x1, [0, x2, block$1]]);});
		                             }
		                             c = b[2];
		                             var x4 = b[1];
		                             if(c){
		                              var tl$0 = c[2], x5 = c[1], block = [0, x5, 24029];
		                              return caml_exact_trampoline_cps_call$3
		                                      (inner_loop_dps,
		                                       block,
		                                       1,
		                                       pos$0,
		                                       tl$0,
		                                       tl,
		                                       function(a){
		return cont([0, x1, [0, x2, [0, x3, [0, x4, block]]]]);
		                                       });
		                             }
		                             var block$0 = [0, x4, 24029];
		                             return caml_exact_trampoline_cps_call$2
		                                     (outer_loop_dps,
		                                      block$0,
		                                      1,
		                                      pos$0,
		                                      tl,
		                                      function(a){
		                                       return cont([0, x1, [0, x2, [0, x3, block$0]]]);
		                                      });
		                            })
		                         : caml_exact_trampoline_cps_call$1(f$0, pos, hd, cont);
		                }
		                return a(0, l);
		               }
		               function last_exn(list$1, cont){
		                var list = list$1;
		                for(;;){
		                 if(! list)
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg, "List.last", cont);
		                 var x = list[1];
		                 if(! list[2]) return cont(x);
		                 var list$0 = list[2];
		                 list = list$0;
		                }
		               }
		               function init$7(n, f, cont){
		                function a(b){
		                 function a(i, accum){
		                  if(0 <= i)
		                   return 0 === i
		                           ? cont(accum)
		                           : caml_exact_trampoline_cps_call
		                             (f,
		                              i - 1 | 0,
		                              function(b){
		                               var accum$0 = [0, b, accum], i$0 = i - 1 | 0;
		                               return caml_exact_trampoline_call2(a, i$0, accum$0);
		                              });
		                  var raise = caml_pop_trap();
		                  return raise
		                          (caml_maybe_attach_backtrace([0, Assert_failure, eD], 1));
		                 }
		                 return a(n, 0);
		                }
		                if(n >= 0) return a();
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         eC,
		                         function(b){return caml_trampoline_cps_call3(b, n, 0, a);});
		               }
		               function filter_map$0(l, f, cont){
		                function a(l){
		                 if(! l) return cont(0);
		                 var tl = l[2], hd = l[1];
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          hd,
		                          function(match){
		                           if(! match) return caml_exact_trampoline_call1(a, tl);
		                           var x = match[1], block = [0, x, 24029];
		                           function b(dst, offset, l){
		                            if(l){
		                             var tl = l[2], hd = l[1];
		                             return caml_exact_trampoline_cps_call
		                                     (f,
		                                      hd,
		                                      function(match){
		                                       if(! match)
		return caml_exact_trampoline_call3(b, dst, offset, tl);
		                                       var x = match[1], dst$0 = [0, x, 24029];
		                                       dst[offset + 1] = dst$0;
		                                       return caml_exact_trampoline_call3(b, dst$0, 1, tl);
		                                      });
		                            }
		                            dst[offset + 1] = 0;
		                            return cont(block);
		                           }
		                           return b(block, 1, tl);
		                          });
		                }
		                return a(l);
		               }
		               function filter_mapi(l, f, cont){
		                function a(pos, l){
		                 if(! l) return cont(0);
		                 var tl = l[2], hd = l[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          pos,
		                          hd,
		                          function(match){
		                           if(match){
		                            var
		                             x = match[1],
		                             pos$0 = pos + 1 | 0,
		                             block = [0, x, 24029],
		                             b =
		                               function(dst, offset, pos, l){
		                                if(l){
		                                 var tl = l[2], hd = l[1];
		                                 return caml_exact_trampoline_cps_call$1
		 (f,
		  pos,
		  hd,
		  function(match){
		   if(match){
		    var x = match[1], block = [0, x, 24029];
		    dst[offset + 1] = block;
		    var pos$0 = pos + 1 | 0;
		    return caml_exact_trampoline_call4(b, block, 1, pos$0, tl);
		   }
		   var pos$1 = pos + 1 | 0;
		   return caml_exact_trampoline_call4
		           (b, dst, offset, pos$1, tl);
		  });
		                                }
		                                dst[offset + 1] = 0;
		                                return cont(block);
		                               };
		                            return b(block, 1, pos$0, tl);
		                           }
		                           var pos$1 = pos + 1 | 0;
		                           return caml_exact_trampoline_call2(a, pos$1, tl);
		                          });
		                }
		                return a(0, l);
		               }
		               function filter_opt(l, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0, l, function(a, cont){return cont(a);}, cont);
		               }
		               function find$1(t, equal, key, cont){
		                function a(param){
		                 function b(match){
		                  if(! match) return cont(0);
		                  var x = match[1];
		                  return cont([0, x[2]]);
		                 }
		                 if(! param) return b(0);
		                 var l = param[2], x = param[1], key$0 = x[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (equal,
		                          key,
		                          key$0,
		                          function(c){
		                           return c ? b([0, x]) : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                return a(t);
		               }
		               function mem$0(t, equal, key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (find$1,
		                         t,
		                         equal,
		                         key,
		                         function(match){return match ? cont(1) : cont(0);});
		               }
		               function split_n(t_orig, n, cont){
		                if(0 >= n) return cont([0, 0, t_orig]);
		                var n$0 = n, t = t_orig, accum = 0;
		                for(;;){
		                 if(! t) return cont([0, t_orig, 0]);
		                 var tl = t[2], hd = t[1];
		                 if(0 === n$0) break;
		                 var accum$0 = [0, hd, accum], n$1 = n$0 - 1 | 0;
		                 n$0 = n$1;
		                 t = tl;
		                 accum = accum$0;
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys, accum, function(a){return cont([0, a, t]);});
		               }
		               function take$0(t_orig, n, cont){
		                if(0 >= n) return cont(0);
		                var n$0 = n, t = t_orig, accum = 0;
		                for(;;){
		                 if(! t) return cont(t_orig);
		                 var tl = t[2], hd = t[1];
		                 if(0 === n$0)
		                  return caml_exact_trampoline_cps_call
		                          (of_rev_keys, accum, cont);
		                 var accum$0 = [0, hd, accum], n$1 = n$0 - 1 | 0;
		                 n$0 = n$1;
		                 t = tl;
		                 accum = accum$0;
		                }
		               }
		               function of_list(l, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$0, l, append$0, 0, cont);
		               }
		               function cons(x, l, cont){return cont([0, x, l]);}
		               function compare_list(cmp, a, b, cont){
		                function c(a, b){
		                 if(! a) return b ? cont(-1) : cont(0);
		                 if(! b) return cont(1);
		                 var ys = b[2], y = b[1], xs = a[2], x = a[1];
		                 return caml_trampoline_cps_call3
		                         (cmp,
		                          x,
		                          y,
		                          function(n){
		                           return 0 === n
		                                   ? caml_exact_trampoline_call2(c, xs, ys)
		                                   : cont(n);
		                          });
		                }
		                return c(a, b);
		               }
		               function equal_with_local_closure(equal, t1, t2, cont){
		                function a(t1, t2){
		                 if(t1){
		                  if(t2){
		                   var t2$0 = t2[2], x2 = t2[1], t1$0 = t1[2], x1 = t1[1];
		                   return caml_trampoline_cps_call3
		                           (equal,
		                            x1,
		                            x2,
		                            function(b){
		                             return b
		                                     ? caml_exact_trampoline_call2(a, t1$0, t2$0)
		                                     : cont(b);
		                            });
		                  }
		                 }
		                 else if(! t2) return cont(1);
		                 return cont(0);
		                }
		                return a(t1, t2);
		               }
		               var
		                Transpose_got_lists_of_differe =
		                  [248,
		                   "Base__List.Transpose_got_lists_of_different_lengths",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Transpose_got_lists_of_differe,
		                  function(a, cont){
		                   if(a[1] === Transpose_got_lists_of_differe){
		                    var arg0_045 = a[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (sexp_of_list,
		                             sexp_of_int,
		                             arg0_045,
		                             function(res0_046){
		                              return cont([1, [0, eE, [0, res0_046, 0]]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, eF], 1));
		                  }]);
		               function sexp_of_t$1(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var arg0_001 = param[1];
		                   return cont([1, [0, eG, [0, arg0_001, 0]]]);
		                  case 1:
		                   var arg0_003 = param[1];
		                   return cont([1, [0, eH, [0, [0, arg0_003], 0]]]);
		                  case 2:
		                   var arg0_005 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_exn,
		                            arg0_005,
		                            function(res0_006){
		                             return cont([1, [0, eI, [0, res0_006, 0]]]);
		                            });
		                  case 3:
		                   var arg0_007 = param[1];
		                   return cont([1, [0, eJ, [0, arg0_007, 0]]]);
		                  case 4:
		                   var
		                    arg2_011 = param[3],
		                    arg1_010 = param[2],
		                    arg0_009 = param[1],
		                    res0_012 = [0, arg0_009];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_option,
		                            sexp_of_t$0,
		                            arg2_011,
		                            function(res2_014){
		                             return cont
		                                     ([1,
		                                       [0, eK, [0, res0_012, [0, arg1_010, [0, res2_014, 0]]]]]);
		                            });
		                  case 5:
		                   var
		                    arg1_016 = param[2],
		                    arg0_015 = param[1],
		                    res0_017 = [0, arg0_015];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$1,
		                            arg1_016,
		                            function(res1_018){
		                             return cont([1, [0, eL, [0, res0_017, [0, res1_018, 0]]]]);
		                            });
		                  case 6:
		                   var
		                    arg2_021 = param[3],
		                    arg1_020 = param[2],
		                    arg0_019 = param[1],
		                    res0_022 = [0, arg0_019];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$1,
		                            arg2_021,
		                            function(res2_024){
		                             return cont
		                                     ([1,
		                                       [0, eM, [0, res0_022, [0, arg1_020, [0, res2_024, 0]]]]]);
		                            });
		                  case 7:
		                   var arg1_026 = param[2], arg0_025 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_option,
		                            sexp_of_int,
		                            arg0_025,
		                            function(res0_027){
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_list,
		                                      sexp_of_t$1,
		                                      arg1_026,
		                                      function(res1_028){
		                                       return cont([1, [0, eN, [0, res0_027, [0, res1_028, 0]]]]);
		                                      });
		                            });
		                  default:
		                   var arg1_030 = param[2], arg0_029 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$1,
		                            arg0_029,
		                            function(res0_031){
		                             return cont
		                                     ([1, [0, eO, [0, res0_031, [0, [0, arg1_030], 0]]]]);
		                            });
		                }
		               }
		               function to_sexps_hum(t, init, cont){
		                switch(t[0]){
		                  case 0:
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$1, t, function(a){return cont([0, a, init]);});
		                  case 1:
		                   var string = t[1]; return cont([0, [0, string], init]);
		                  case 2:
		                   var exn = t[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_exn, exn, function(a){return cont([0, a, init]);});
		                  case 3:
		                   var sexp = t[1]; return cont([0, sexp, init]);
		                  case 4:
		                   var
		                    here = t[3],
		                    sexp$0 = t[2],
		                    tag = t[1],
		                    a =
		                      function(a){
		                       return cont([0, [1, [0, [0, tag], [0, sexp$0, a]]], init]);
		                      };
		                   if(! here) return a(0);
		                   var here$0 = here[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$0, here$0, function(b){return a([0, b, 0]);});
		                  case 5:
		                   var t$0 = t[2], tag$0 = t[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (to_sexps_hum,
		                            t$0,
		                            0,
		                            function(a){
		                             return cont([0, [1, [0, [0, tag$0], a]], init]);
		                            });
		                  case 6:
		                   var t$1 = t[3], sexp$1 = t[2], tag$1 = t[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (to_sexps_hum,
		                            t$1,
		                            0,
		                            function(a){
		                             var body = [0, sexp$1, a];
		                             return 0 === caml_ml_string_length(tag$1)
		                                     ? cont([0, [1, body], init])
		                                     : cont([0, [1, [0, [0, tag$1], body]], init]);
		                            });
		                  case 7:
		                   var ts = t[2];
		                   return caml_exact_trampoline_cps_call
		                           (of_rev_keys,
		                            ts,
		                            function(t){
		                             function a(t, init){
		                              if(! t) return cont(init);
		                              var l = t[2], a$0 = t[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (to_sexps_hum,
		                                       a$0,
		                                       init,
		                                       function(init){
		return caml_exact_trampoline_call2(a, l, init);
		                                       });
		                             }
		                             return a(t, init);
		                            });
		                  default:
		                   var backtrace = t[2], t$2 = t[1];
		                   return caml_exact_trampoline_cps_call
		                           (split_lines,
		                            backtrace,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_list,
		                                      sexp_of_string,
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call
		       (to_sexp_hum,
		        t$2,
		        function(b){return cont([0, [1, [0, b, a]], init]);});
		                                      });
		                            });
		                }
		               }
		               function to_sexp_hum(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_sexps_hum,
		                         t,
		                         0,
		                         function(sexps){
		                          if(sexps && ! sexps[2]){
		                           var sexp = sexps[1];
		                           return cont(sexp);
		                          }
		                          return cont([1, sexps]);
		                         });
		               }
		               function compute_info(info, stack, cont){
		                function a(info, stack){
		                 var b = info[1];
		                 if(typeof b === "number")
		                  return caml_exact_trampoline_cps_call$1
		                          (compute_message, eP, stack, cont);
		                 if(0 !== b[0]){
		                  var message = b[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (compute_message, message, stack, cont);
		                 }
		                 var cons = b[1];
		                 info[1] = 0;
		                 var stack$0 = [0, [0, info], stack];
		                 switch(cons[0]){
		                   case 0:
		                    var lazy_info = cons[1];
		                    caml_push_trap
		                     (function(exn){
		                       return caml_exact_trampoline_cps_call
		                               (sexp_of_exn,
		                                exn,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (compute_message, [0, a], stack$0, cont);
		                                });
		                      });
		                    b = caml_obj_tag(lazy_info);
		                    var
		                     c =
		                       function(info){
		                        caml_pop_trap();
		                        return caml_exact_trampoline_call2(a, info, stack$0);
		                       };
		                    if(250 === b) return c(lazy_info[1]);
		                    if(246 !== b && 244 !== b) return c(lazy_info);
		                    return caml_exact_trampoline_cps_call
		                            (force_lazy_block, lazy_info, c);
		                   case 1:
		                    var infos = cons[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (compute_info_list, infos, 0, stack$0, cont);
		                   case 2:
		                    var
		                     info$0 = cons[3],
		                     arg = cons[2],
		                     stack$1 = [0, [1, cons[1], arg], stack$0];
		                    return caml_exact_trampoline_call2(a, info$0, stack$1);
		                   default:
		                    var info$1 = cons[2], stack$2 = [0, [2, cons[1]], stack$0];
		                    return caml_exact_trampoline_call2(a, info$1, stack$2);
		                 }
		                }
		                return a(info, stack);
		               }
		               function compute_info_list(fwd_prefix, rev_suffix, stack, cont){
		                if(fwd_prefix){
		                 var fwd_prefix$0 = fwd_prefix[2], info = fwd_prefix[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (compute_info,
		                          info,
		                          [0, [3, fwd_prefix$0, rev_suffix], stack],
		                          cont);
		                }
		                var infos = 0, t = rev_suffix;
		                for(;;){
		                 if(! t)
		                  return caml_exact_trampoline_cps_call$1
		                          (compute_message, [7, 0, infos], stack, cont);
		                 var l = t[2], message = t[1];
		                 if(7 === message[0]){
		                  var messages = message[2];
		                  infos = symbol(messages, infos);
		                  t = l;
		                 }
		                 else {infos = [0, message, infos]; t = l;}
		                }
		               }
		               function compute_message(message$2, stack$4, cont){
		                var message = message$2, stack = stack$4;
		                for(;;){
		                 if(! stack) return cont(message);
		                 var match = stack[1];
		                 switch(match[0]){
		                   case 0:
		                    var stack$0 = stack[2], info = match[1];
		                    info[1] = [1, message];
		                    stack = stack$0;
		                    break;
		                   case 1:
		                    var
		                     stack$1 = stack[2],
		                     arg = match[2],
		                     message$0 = [6, match[1], arg, message];
		                    message = message$0;
		                    stack = stack$1;
		                    break;
		                   case 2:
		                    var stack$2 = stack[2], message$1 = [5, match[1], message];
		                    message = message$1;
		                    stack = stack$2;
		                    break;
		                   default:
		                    var
		                     stack$3 = stack[2],
		                     rev_suffix = match[2],
		                     fwd_prefix = match[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (compute_info_list,
		                             fwd_prefix,
		                             [0, message, rev_suffix],
		                             stack$3,
		                             cont);
		                 }
		                }
		               }
		               function to_message(info, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (compute_info, info, 0, cont);
		               }
		               function of_message(message){return [0, [1, message]];}
		               function of_cons(cons){return [0, [0, cons]];}
		               function of_lazy_message(lazy_message){
		                return of_cons
		                        ([0,
		                          [246,
		                           function(a, cont){
		                            a = caml_obj_tag(lazy_message);
		                            function b(a){return cont(of_message(a));}
		                            if(250 === a) return b(lazy_message[1]);
		                            if(246 !== a && 244 !== a) return b(lazy_message);
		                            return caml_exact_trampoline_cps_call
		                                    (force_lazy_block, lazy_message, b);
		                           }]]);
		               }
		               function sexp_of_t$2(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_message,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(to_sexp_hum, a, cont);
		                         });
		               }
		               function compare$5(t1, t2, cont){
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$2,
		                         t2,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$2,
		                                   t1,
		                                   function(a){return cont(compare_elt_local(a, b));});
		                         });
		               }
		               function of_string$1(message, cont){
		                return cont(of_message([1, message]));
		               }
		               function create$9(here, strict, tag, x, sexp_of_x, cont){
		                return strict
		                        ? caml_trampoline_cps_call2
		                          (sexp_of_x,
		                           x,
		                           function(a){return cont(of_message([4, tag, a, here]));})
		                        : cont
		                          (of_lazy_message
		                            ([246,
		                              function(param, cont){
		                               return caml_trampoline_cps_call2
		                                       (sexp_of_x, x, function(a){return cont([4, tag, a, here]);});
		                              }]));
		               }
		               function create_s(sexp){return of_message([3, sexp]);}
		               var Exn = [248, "Base__Info.Exn", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Exn,
		                  function(param, a){
		                   if(param[1] === Exn){
		                    var t = param[2];
		                    return caml_exact_trampoline_cps_call(sexp_of_t$2, t, a);
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, eQ], 1));
		                  }]);
		               function to_exn(info, cont){
		                var a = info[1];
		                a:
		                {
		                 if(typeof a !== "number" && 0 !== a[0]){a = 1; break a;}
		                 a = 0;
		                }
		                return a
		                        ? caml_exact_trampoline_cps_call
		                          (to_message,
		                           info,
		                           function(match){
		                            if(2 !== match[0]) return cont([0, Exn, info]);
		                            var exn = match[1];
		                            return cont(exn);
		                           })
		                        : cont([0, Exn, info]);
		               }
		               function raise(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_exn,
		                         t,
		                         function(a){
		                          var raise = caml_pop_trap();
		                          return raise(caml_maybe_attach_backtrace(a, 1));
		                         });
		               }
		               function raise_s(sexp, cont){
		                return caml_exact_trampoline_cps_call
		                        (raise, create_s(sexp), cont);
		               }
		               function error(here, strict, message, a, sexp_of_a, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (create$9,
		                         here,
		                         strict,
		                         message,
		                         a,
		                         sexp_of_a,
		                         function(a){return cont([1, a]);});
		               }
		               function error_s(sexp){return [1, create_s(sexp)];}
		               function error_string(message, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$1, message, function(a){return cont([1, a]);});
		               }
		               function sexp_of_t$3(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(eR);
		                  case 1:
		                   return cont(eS);
		                  default: return cont(eT);
		                }
		               }
		               function compare$6(a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function to_string$3(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$3,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (string_of_sexp, a, cont);
		                         });
		               }
		               function to_int(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(-1);
		                  case 1:
		                   return cont(0);
		                  default: return cont(1);
		                }
		               }
		               function geq(cmp, a, b, cont){
		                return caml_trampoline_cps_call3
		                        (cmp, a, b, function(a){return cont(0 <= a ? 1 : 0);});
		               }
		               function leq(cmp, a, b, cont){
		                return caml_trampoline_cps_call3
		                        (cmp, a, b, function(a){return cont(a <= 0 ? 1 : 0);});
		               }
		               var cst_clamp_requires_min_max = "clamp requires [min <= max]";
		               function Make_using_comparator(T){
		                var
		                 sexp_of_t = T[1],
		                 comparator = T[2],
		                 compare = comparator[1];
		                function symbol(a, b, cont){
		                 return caml_trampoline_cps_call3
		                         (compare, a, b, function(a){return cont(0 < a ? 1 : 0);});
		                }
		                function symbol$0(a, b, cont){
		                 return caml_trampoline_cps_call3
		                         (compare, a, b, function(a){return cont(a < 0 ? 1 : 0);});
		                }
		                function symbol$1(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (geq, compare, a, b, cont);
		                }
		                function symbol$2(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (leq, compare, a, b, cont);
		                }
		                function symbol$3(a, b, cont){
		                 return caml_trampoline_cps_call3
		                         (compare, a, b, function(a){return cont(0 === a ? 1 : 0);});
		                }
		                function symbol$4(a, b, cont){
		                 return caml_trampoline_cps_call3
		                         (compare, a, b, function(a){return cont(0 !== a ? 1 : 0);});
		                }
		                function min(t$0, t, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (leq,
		                          compare,
		                          t$0,
		                          t,
		                          function(a){return a ? cont(t$0) : cont(t);});
		                }
		                function max(t$0, t, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (geq,
		                          compare,
		                          t$0,
		                          t,
		                          function(a){return a ? cont(t$0) : cont(t);});
		                }
		                function descending(t$0, t, cont){
		                 return caml_trampoline_cps_call3(compare, t, t$0, cont);
		                }
		                function between(t, low, high, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (leq,
		                          compare,
		                          low,
		                          t,
		                          function(a){
		                           return a
		                                   ? caml_exact_trampoline_cps_call$0
		                                     (leq, compare, t, high, cont)
		                                   : cont(a);
		                          });
		                }
		                function clamp_unchecked(t, min, max, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$0,
		                          t,
		                          min,
		                          function(a){
		                           return a
		                                   ? cont(min)
		                                   : caml_exact_trampoline_cps_call$0
		                                     (leq,
		                                      compare,
		                                      t,
		                                      max,
		                                      function(a){return a ? cont(t) : cont(max);});
		                          });
		                }
		                function clamp_exn(t, min, max, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (leq,
		                          compare,
		                          min,
		                          max,
		                          function(a){
		                           if(a)
		                            return caml_exact_trampoline_cps_call$0
		                                    (clamp_unchecked, t, min, max, cont);
		                           a = caml_pop_trap();
		                           return a
		                                   (caml_maybe_attach_backtrace([0, Assert_failure, eU], 1));
		                          });
		                }
		                function clamp(t, min, max, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol,
		                          min,
		                          max,
		                          function(a){
		                           if(! a)
		                            return caml_exact_trampoline_cps_call$0
		                                    (clamp_unchecked,
		                                     t,
		                                     min,
		                                     max,
		                                     function(a){return cont([0, a]);});
		                           return caml_trampoline_cps_call2
		                                   (sexp_of_t,
		                                    max,
		                                    function(b){
		                                     var a = [0, [0, cst_max, b], 0];
		                                     return caml_trampoline_cps_call2
		     (sexp_of_t,
		      min,
		      function(b){
		       return cont
		               (error_s
		                 (message
		                   (cst_clamp_requires_min_max, [0, [0, cst_min, b], a])));
		      });
		                                    });
		                          });
		                }
		                return [0,
		                        symbol$1,
		                        symbol$2,
		                        symbol$3,
		                        symbol,
		                        symbol$0,
		                        symbol$4,
		                        symbol$3,
		                        compare,
		                        min,
		                        max,
		                        compare,
		                        descending,
		                        between,
		                        clamp_exn,
		                        clamp,
		                        comparator];
		               }
		               function Make$2(T){
		                var
		                 sexp_of_t = T[2],
		                 include = Make$1(T),
		                 comparator = include[1];
		                return Make_using_comparator([0, sexp_of_t, comparator]);
		               }
		               function bO_(T){
		                var
		                 hash = T[3],
		                 sexp_of_t = T[5],
		                 to_string = T[7],
		                 a = Make$2([0, T[1], T[5]]),
		                 symbol = a[1],
		                 symbol$0 = a[2],
		                 symbol$1 = a[3],
		                 symbol$2 = a[4],
		                 symbol$3 = a[5],
		                 symbol$4 = a[6],
		                 equal = a[7],
		                 compare = a[8],
		                 min = a[9],
		                 max = a[10],
		                 ascending = a[11],
		                 descending = a[12],
		                 between = a[13],
		                 clamp_exn = a[14],
		                 clamp = a[15],
		                 comparator = a[16],
		                 include = bPU([0, , T[7]]),
		                 pp = include[1];
		                return [0,
		                        ,
		                        hash,
		                        ,
		                        sexp_of_t,
		                        ,
		                        to_string,
		                        symbol,
		                        symbol$0,
		                        symbol$1,
		                        symbol$2,
		                        symbol$3,
		                        symbol$4,
		                        equal,
		                        compare,
		                        min,
		                        max,
		                        ascending,
		                        descending,
		                        between,
		                        clamp_exn,
		                        clamp,
		                        comparator,
		                        pp,
		                        [0, hash, compare, sexp_of_t]];
		               }
		               function hash$0(x, cont){return cont(0);}
		               function compare$7(a, param, cont){return cont(0);}
		               function to_string$4(param, cont){return cont(cst$17);}
		               var
		                include$1 =
		                  bO_([0, compare$7, , hash$0, , sexp_of_unit, , to_string$4]),
		                hash$1 = include$1[2],
		                sexp_of_unit$0 = include$1[4],
		                symbol$17 = include$1[7],
		                symbol$18 = include$1[8],
		                symbol$19 = include$1[9],
		                symbol$20 = include$1[10],
		                symbol$21 = include$1[11],
		                symbol$22 = include$1[12],
		                equal$5 = include$1[13],
		                compare$8 = include$1[14],
		                min$8 = include$1[15],
		                max$8 = include$1[16],
		                ascending$3 = include$1[17],
		                descending$3 = include$1[18],
		                between = include$1[19],
		                clamp_exn = include$1[20],
		                clamp = include$1[21],
		                comparator = include$1[22],
		                hashable = include$1[24];
		               function find_first_satisfying
		               (pos, len, t, get, length, pred, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (get_pos_len_exn,
		                         pos,
		                         len,
		                         dummy,
		                         length(t),
		                         function(match){
		                          var
		                           len = match[2],
		                           pos = match[1],
		                           hi$0 = (pos + len | 0) - 1 | 0,
		                           lo$0 = pos,
		                           hi = hi$0;
		                          for(;;){
		                           if(8 >= (hi - lo$0 | 0)){var lo = lo$0; break;}
		                           var mid = lo$0 + ((hi - lo$0 | 0) / 2 | 0) | 0;
		                           if(pred(get(t, mid)))
		                            hi = mid;
		                           else {var lo$2 = mid + 1 | 0; lo$0 = lo$2;}
		                          }
		                          for(;;){
		                           if(hi < lo) return cont(0);
		                           if(pred(get(t, lo))) return cont([0, lo]);
		                           var lo$1 = lo + 1 | 0;
		                           lo = lo$1;
		                          }
		                         });
		               }
		               function find_last_satisfying
		               (pos, len, t, pred, get, length, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (get_pos_len_exn,
		                         pos,
		                         len,
		                         dummy,
		                         length(t),
		                         function(match){
		                          var len = match[2], pos = match[1];
		                          return 0 === len
		                                  ? cont(0)
		                                  : caml_exact_trampoline_cps_call$7
		                                    (find_first_satisfying,
		                                     [0, pos],
		                                     [0, len],
		                                     t,
		                                     get,
		                                     length,
		                                     function(x){return 1 - pred(x);},
		                                     function(match){
		                                      if(! match) return cont([0, (pos + len | 0) - 1 | 0]);
		                                      var i = match[1];
		                                      return i === pos ? cont(0) : cont([0, i - 1 | 0]);
		                                     });
		                         });
		               }
		               function binary_search
		               (pos, len, t, length, get, compare, how, v, cont){
		                return -839473056 <= how
		                        ? 200870407
		                          <= how
		                          ? 926943384
		                            <= how
		                            ? caml_exact_trampoline_cps_call$7
		                              (find_first_satisfying,
		                               pos,
		                               len,
		                               t,
		                               get,
		                               length,
		                               function(x){return 0 <= compare(x, v) ? 1 : 0;},
		                               cont)
		                            : caml_exact_trampoline_cps_call$7
		                              (find_last_satisfying,
		                               pos,
		                               len,
		                               t,
		                               function(x){return compare(x, v) < 0 ? 1 : 0;},
		                               get,
		                               length,
		                               cont)
		                          : -253007807
		                            <= how
		                            ? caml_exact_trampoline_cps_call$7
		                              (find_last_satisfying,
		                               pos,
		                               len,
		                               t,
		                               function(x){return compare(x, v) <= 0 ? 1 : 0;},
		                               get,
		                               length,
		                               cont)
		                            : caml_exact_trampoline_cps_call$7
		                              (find_first_satisfying,
		                               pos,
		                               len,
		                               t,
		                               get,
		                               length,
		                               function(x){return 0 < compare(x, v) ? 1 : 0;},
		                               cont)
		                        : -1055410545
		                          <= how
		                          ? caml_exact_trampoline_cps_call$7
		                            (find_last_satisfying,
		                             pos,
		                             len,
		                             t,
		                             function(x){return compare(x, v) <= 0 ? 1 : 0;},
		                             get,
		                             length,
		                             function(match){
		                              if(match){
		                               var x = match[1];
		                               if(0 === compare(get(t, x), v)) return cont([0, x]);
		                              }
		                              return cont(0);
		                             })
		                          : caml_exact_trampoline_cps_call$7
		                            (find_first_satisfying,
		                             pos,
		                             len,
		                             t,
		                             get,
		                             length,
		                             function(x){return 0 <= compare(x, v) ? 1 : 0;},
		                             function(match){
		                              if(match){
		                               var x = match[1];
		                               if(0 === compare(get(t, x), v)) return cont([0, x]);
		                              }
		                              return cont(0);
		                             });
		               }
		               function set_utf_32_uchar(set_int32, bytes, idx, uchar, cont){
		                var a = uchar;
		                return caml_trampoline_cps_call3
		                        (set_int32,
		                         bytes,
		                         idx,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (b, a, function(a){return cont(4);});
		                         });
		               }
		               function set_uchar_utf_32le(a, b, c, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (set_utf_32_uchar, set_int32_le, a, b, c, cont);
		               }
		               function set_uchar_utf_32be(a, b, c, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (set_utf_32_uchar, set_int32_be, a, b, c, cont);
		               }
		               function Make_gen$0(Src, Dst){
		                var unsafe_blit = Dst[3];
		                function blit(src, src_pos, dst, dst_pos, len, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (check_pos_len_exn,
		                          src_pos,
		                          len,
		                          Src[1].call(null, src),
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (check_pos_len_exn,
		                                    dst_pos,
		                                    len,
		                                    Dst[1].call(null, dst),
		                                    function(a){
		                                     a = 0 < len ? 1 : 0;
		                                     return a
		     ? cont(unsafe_blit(src, src_pos, dst, dst_pos, len))
		     : cont(a);
		                                    });
		                          });
		                }
		                function sub(src, pos, len, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (check_pos_len_exn,
		                          pos,
		                          len,
		                          Src[1].call(null, src),
		                          function(a){
		                           var dst = Dst[2].call(null, len, src);
		                           if(0 < len) unsafe_blit(src, pos, dst, 0, len);
		                           return cont(dst);
		                          });
		                }
		                return [0, unsafe_blit, blit, , sub];
		               }
		               function bPV(a){
		                a = [0, a[2], a[1], a[3]];
		                a = Make_gen$0([0, a[1]], a);
		                return [0, a[2], , a[1], a[4]];
		               }
		               function hash$2(x, cont){return cont(hash_bool(x));}
		               function of_string$2(s, cont){
		                if(s === cst_false) return cont(0);
		                if(s === cst_true) return cont(1);
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         eV,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, s, 0, cont);
		                         });
		               }
		               var
		                include$2 = Make$1([0, compare_bool, sexp_of_bool]),
		                comparator$0 = include$2[1];
		               function tag(t, tag){return of_cons([3, tag, t]);}
		               function between$0(t, low, high, cont){
		                var a = low <= t ? 1 : 0;
		                return a ? cont(t <= high ? 1 : 0) : cont(a);
		               }
		               function clamp_unchecked(t, min, max){
		                return t < min ? min : t <= max ? t : max;
		               }
		               function clamp_exn$0(t, min, max, a){
		                if(min <= max) return a(clamp_unchecked(t, min, max));
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, eW], 1));
		               }
		               function clamp$0(t, min, max, cont){
		                if(max >= min) return cont([0, clamp_unchecked(t, min, max)]);
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_bool,
		                         max,
		                         function(b){
		                          var a = [0, [0, cst_max, b], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_bool,
		                                   min,
		                                   function(b){
		                                    return cont
		    (error_s
		      (message
		        (cst_clamp_requires_min_max, [0, [0, cst_min, b], a])));
		                                   });
		                         });
		               }
		               function return$1(x, cont){return cont([0, x]);}
		               function return$2(x, cont){return cont([1, x]);}
		               function Of_sexpable1(Sexpable, M){
		                function sexp_of_t(sexp_of_a, t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (M[1],
		                          t,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Sexpable[2], sexp_of_a, a, cont);
		                          });
		                }
		                return [0, , sexp_of_t];
		               }
		               function Of_stringable(M){
		                function sexp_of_t(t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (M[2], t, function(a){return cont([0, a]);});
		                }
		                return [0, , , sexp_of_t];
		               }
		               function is_none$0(param){return param ? 0 : 1;}
		               function is_some(param){return param ? 1 : 0;}
		               function value_map(o, default$, f, cont){
		                if(! o) return cont(default$);
		                var x = o[1];
		                return caml_trampoline_cps_call2(f, x, cont);
		               }
		               function value$4(t, default$){
		                if(! t) return default$;
		                var x = t[1];
		                return x;
		               }
		               function value_exn(here, error, message, t, cont){
		                if(t){var x = t[1]; return cont(x);}
		                function a(error){
		                 return caml_exact_trampoline_cps_call(raise, error, cont);
		                }
		                if(here){
		                 var p = here[1];
		                 if(error){
		                  var e = error[1];
		                  return caml_exact_trampoline_cps_call$3
		                          (create$9,
		                           0,
		                           0,
		                           value$4(message, cst$1),
		                           [0, e, p],
		                           function(a, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (sexp_of_pair, sexp_of_t$2, sexp_of_t$0, a, cont);
		                           },
		                           a);
		                 }
		                 if(! message)
		                  return caml_exact_trampoline_cps_call$3
		                          (create$9, 0, 0, "Option.value_exn", p, sexp_of_t$0, a);
		                 var m = message[1];
		                 return caml_exact_trampoline_cps_call$3
		                         (create$9, 0, 0, m, p, sexp_of_t$0, a);
		                }
		                if(error){
		                 var e$0 = error[1];
		                 if(! message) return a(e$0);
		                 var m$0 = message[1];
		                 return a(tag(e$0, m$0));
		                }
		                if(! message)
		                 return caml_exact_trampoline_cps_call
		                         (of_string$1, "Option.value_exn None", a);
		                var m$1 = message[1];
		                return caml_exact_trampoline_cps_call(of_string$1, m$1, a);
		               }
		               function value_or_thunk(o, default$, cont){
		                if(! o) return caml_trampoline_cps_call2(default$, 0, cont);
		                var x = o[1];
		                return cont(x);
		               }
		               function to_list$0(t){
		                if(! t) return 0;
		                var x = t[1];
		                return [0, x, 0];
		               }
		               function equal_option(f, t$0, t, cont){
		                if(t$0){
		                 if(t){
		                  var x = t[1], x$0 = t$0[1];
		                  return caml_trampoline_cps_call3(f, x$0, x, cont);
		                 }
		                }
		                else if(! t) return cont(1);
		                return cont(0);
		               }
		               function found(x, cont){return cont([0, x]);}
		               function first_some(x, y){return x ? x : y;}
		               function some_if(cond, x){return cond ? [0, x] : 0;}
		               function return$3(x, cont){return cont([0, x]);}
		               var
		                map$8 =
		                  [0,
		                   ,
		                   function(t, f, cont){
		                    if(! t) return cont(0);
		                    var a = t[1];
		                    return caml_trampoline_cps_call2
		                            (f, a, function(a){return cont([0, a]);});
		                   }];
		               function bind$3(o, f, cont){
		                if(! o) return cont(0);
		                var x = o[1];
		                return caml_trampoline_cps_call2(f, x, cont);
		               }
		               var
		                e = Make2_local([0, bind$3, map$8, return$3]),
		                Let_syntax = e[8],
		                map$3 = e[4],
		                bind = e[1],
		                symbol_bind = e[6],
		                map$9 = [0, , , , , , map$3][6];
		               function return$4(x, cont){return cont([0, x]);}
		               function map2(x, y, f){
		                if(x && y){
		                 var y$0 = y[1], x$0 = x[1];
		                 return [0, f(x$0, y$0)];
		                }
		                return 0;
		               }
		               function symbol_map$1(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(map$3, t, f, cont);
		               }
		               function all$11(ts, cont){
		                function a(x, xs){return [0, x, xs];}
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$0,
		                         ts,
		                         function(b, cont){
		                          return cont(function(c, cont){return cont(map2(b, c, a));});
		                         },
		                         [0, 0],
		                         cont);
		               }
		               function unfold$0(init, f){
		                function f$0(s, cont){
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          s,
		                          function(b){
		                           if(! b) return cont(0);
		                           b = b[1];
		                           var s = b[2], a = b[1];
		                           return cont([1, a, s]);
		                          });
		                }
		                return [0, init, f$0];
		               }
		               function deconstruct(init, cont){
		                function f(param, cont){
		                 if(! param) return cont(0);
		                 var l = param[2], x = param[1];
		                 return cont([1, x, l]);
		                }
		                return cont([0, init, f]);
		               }
		               function fold$0(t, init, f, cont){
		                var next = t[2], seed = t[1];
		                function a(seed, v){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          seed,
		                          function(match){
		                           if(typeof match === "number") return cont(v);
		                           if(0 === match[0]){
		                            var seed = match[1];
		                            return caml_exact_trampoline_call2(a, seed, v);
		                           }
		                           var seed$0 = match[2], a$0 = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    v,
		                                    a$0,
		                                    function(v){
		                                     return caml_exact_trampoline_call2(a, seed$0, v);
		                                    });
		                          });
		                }
		                return a(seed, init);
		               }
		               function to_list_rev(t, cont){
		                var next = t[2], seed = t[1];
		                function a(seed, v){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          seed,
		                          function(match){
		                           if(typeof match === "number") return cont(v);
		                           if(0 === match[0]){
		                            var seed = match[1];
		                            return caml_exact_trampoline_call2(a, seed, v);
		                           }
		                           var seed$0 = match[2], a$0 = match[1], v$0 = [0, a$0, v];
		                           return caml_exact_trampoline_call2(a, seed$0, v$0);
		                          });
		                }
		                return a(seed, 0);
		               }
		               function to_binable(param, cont){
		                var next = param[2], s = param[1];
		                function a(s){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(match){
		                           if(typeof match === "number") return cont(0);
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return caml_exact_trampoline_call1(a, s);
		                           }
		                           var s$0 = match[2], a$0 = match[1], block = [0, a$0, 24029];
		                           function b(dst, offset, s){
		                            return caml_trampoline_cps_call2
		                                    (next,
		                                     s,
		                                     function(match){
		                                      if(typeof match === "number"){
		                                       dst[offset + 1] = 0;
		                                       return cont(block);
		                                      }
		                                      if(0 === match[0]){
		                                       var s = match[1];
		                                       return caml_exact_trampoline_call3(b, dst, offset, s);
		                                      }
		                                      var s$0 = match[2], a = match[1], dst$0 = [0, a, 24029];
		                                      dst[offset + 1] = dst$0;
		                                      return caml_exact_trampoline_call3(b, dst$0, 1, s$0);
		                                     });
		                           }
		                           return b(block, 1, s$0);
		                          });
		                }
		                return a(s);
		               }
		               function sexp_of_t$4(sexp_of_a, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_binable,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_list, sexp_of_a, a, cont);
		                         });
		               }
		               function range$0(b, a, opt, start_v, stop_v){
		                var stride = 1,
		                 step =
		                   function
		                       (i, cont){
		                        return stop_v <= i ? cont(0) : cont([1, i, i + stride | 0]);
		                       }
		                      ,
		                 init = start_v ;
		                return [0, init, step];
		               }
		               function of_lazy(t_lazy){
		                function f(t_lazy, cont){
		                 var a = caml_obj_tag(t_lazy);
		                 function b(match){
		                  var next = match[2], s = match[1];
		                  return caml_trampoline_cps_call2
		                          (next,
		                           s,
		                           function(match){
		                            if(typeof match === "number") return cont(0);
		                            if(0 === match[0]){
		                             var s = match[1];
		                             return cont([0, [0, s, next]]);
		                            }
		                            var s$0 = match[2], x = match[1];
		                            return cont([1, x, [0, s$0, next]]);
		                           });
		                 }
		                 if(250 === a) return b(t_lazy[1]);
		                 if(246 !== a && 244 !== a) return b(t_lazy);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, t_lazy, b);
		                }
		                return [0, t_lazy, f];
		               }
		               function mapi$1(t, f){
		                var next = t[2], s = t[1];
		                return [0,
		                        [0, 0, s],
		                        function(param, cont){
		                         var s = param[2], i = param[1];
		                         return caml_trampoline_cps_call2
		                                 (next,
		                                  s,
		                                  function(match){
		                                   if(typeof match === "number") return cont(0);
		                                   if(0 === match[0]){
		                                    var s = match[1];
		                                    return cont([0, [0, i, s]]);
		                                   }
		                                   var s$0 = match[2], a = match[1], b = [0, i + 1 | 0, s$0];
		                                   return caml_exact_trampoline_cps_call$1
		   (f, i, a, function(a){return cont([1, a, b]);});
		                                  });
		                        }];
		               }
		               function filter$0(t, f){
		                var next = t[2], seed = t[1];
		                return [0,
		                        seed,
		                        function(seed, cont){
		                         return caml_trampoline_cps_call2
		                                 (next,
		                                  seed,
		                                  function(match){
		                                   if(typeof match === "number") return cont(0);
		                                   if(0 === match[0]){var s = match[1]; return cont([0, s]);}
		                                   var a = match[1], s$0 = match[2];
		                                   return caml_exact_trampoline_cps_call
		   (f,
		    a,
		    function(b){
		     if(b) return cont([1, a, s$0]);
		     var s = match[2];
		     return cont([0, s]);
		    });
		                                  });
		                        }];
		               }
		               function length$2(t, cont){
		                var next = t[2], seed = t[1];
		                function a(i, s){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(match){
		                           if(typeof match === "number") return cont(i);
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return caml_exact_trampoline_call2(a, i, s);
		                           }
		                           var s$0 = match[2], i$0 = i + 1 | 0;
		                           return caml_exact_trampoline_call2(a, i$0, s$0);
		                          });
		                }
		                return a(0, seed);
		               }
		               function to_array$0(t, cont){
		                var next = t[2], seed = t[1];
		                function a(seed, v){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          seed,
		                          function(b){
		                           if(typeof b !== "number"){
		                            if(0 === b[0]){
		                             var seed = b[1];
		                             return caml_exact_trampoline_call2(a, seed, v);
		                            }
		                            var
		                             seed$0 = b[2],
		                             a$1 = b[1],
		                             i$2 = v[2],
		                             l$3 = v[1],
		                             v$0 = [0, [0, a$1, l$3], i$2 + 1 | 0];
		                            return caml_exact_trampoline_call2(a, seed$0, v$0);
		                           }
		                           var len = v[2], l = v[1];
		                           if(! l) return cont([0]);
		                           var
		                            l$0 = l[2],
		                            x = l[1],
		                            a$0 = caml_make_vect(len, x),
		                            i$1 = len - 2 | 0,
		                            i = i$1,
		                            l$1 = l$0;
		                           for(;;){
		                            if(! l$1){
		                             if(-1 === i) return cont(a$0);
		                             b = caml_pop_trap();
		                             return b
		                                     (caml_maybe_attach_backtrace([0, Assert_failure, eX], 1));
		                            }
		                            var l$2 = l$1[2], x$0 = l$1[1];
		                            caml_check_bound(a$0, i)[i + 1] = x$0;
		                            var i$0 = i - 1 | 0;
		                            i = i$0;
		                            l$1 = l$2;
		                           }
		                          });
		                }
		                return a(seed, init$0);
		               }
		               function find_map(t, f, cont){
		                var next = t[2], seed = t[1];
		                function a(s){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(match){
		                           if(typeof match === "number") return cont(0);
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return caml_exact_trampoline_call1(a, s);
		                           }
		                           var s$0 = match[2], a$0 = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    a$0,
		                                    function(some_b){
		                                     return some_b
		     ? cont(some_b)
		     : caml_exact_trampoline_call1(a, s$0);
		                                    });
		                          });
		                }
		                return a(seed);
		               }
		               var empty$6 = [0, 0, function(param, cont){return cont(0);}];
		               function bind$4(t, f, cont){
		                function f$0(a, cont){
		                 var rest = a[2], a = a[1], next = a[2], seed = a[1];
		                 return caml_trampoline_cps_call2
		                         (next,
		                          seed,
		                          function(match){
		                           if(typeof match === "number"){
		                            var next$0 = rest[2], seed = rest[1];
		                            return caml_trampoline_cps_call2
		                                    (next$0,
		                                     seed,
		                                     function(match){
		                                      if(typeof match === "number") return cont(0);
		                                      if(0 === match[0]){
		                                       var s = match[1];
		                                       return cont([0, [0, empty$6, [0, s, next$0]]]);
		                                      }
		                                      var s$0 = match[2], a = match[1], b = [0, s$0, next$0];
		                                      return caml_trampoline_cps_call2
		      (f, a, function(a){return cont([0, [0, a, b]]);});
		                                     });
		                           }
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return cont([0, [0, [0, s, next], rest]]);
		                           }
		                           var s$0 = match[2], a = match[1];
		                           return cont([1, a, [0, [0, s$0, next], rest]]);
		                          });
		                }
		                var init = [0, empty$6, t];
		                return cont([0, init, f$0]);
		               }
		               function return$5(x, cont){
		                function f(param, cont){
		                 if(! param) return cont(0);
		                 var x = param[1];
		                 return cont([1, x, 0]);
		                }
		                var init = [0, x];
		                return cont([0, init, f]);
		               }
		               var
		                map$10 =
		                  [0,
		                   ,
		                   function(t, f, cont){
		                    var next = t[2], seed = t[1];
		                    return cont
		                            ([0,
		                              seed,
		                              function(seed, cont){
		                               return caml_trampoline_cps_call2
		                                       (next,
		seed,
		function(match){
		 if(typeof match === "number") return cont(0);
		 if(0 === match[0]){var s = match[1]; return cont([0, s]);}
		 var s$0 = match[2], a = match[1];
		 return caml_trampoline_cps_call2
		         (f, a, function(a){return cont([1, a, s$0]);});
		});
		                              }]);
		                   }],
		                include$3 = Make([0, bind$4, return$5, map$10]),
		                symbol_bind$2 = include$3[1],
		                symbol_map$2 = include$3[2],
		                bind$5 = include$3[4],
		                return$6 = include$3[5],
		                map$11 = include$3[6],
		                Let_syntax$1 = include$3[11];
		               function nth(s, n, cont){
		                if(0 > n) return cont(0);
		                var next = s[2], s$0 = s[1];
		                function a(i, s){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(match){
		                           if(typeof match === "number") return cont(0);
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return caml_exact_trampoline_call2(a, i, s);
		                           }
		                           var s$0 = match[2], a$0 = match[1];
		                           if(0 === i) return cont([0, a$0]);
		                           var i$0 = i - 1 | 0;
		                           return caml_exact_trampoline_call2(a, i$0, s$0);
		                          });
		                }
		                return a(n, s$0);
		               }
		               function hd$1(s, cont){
		                var next = s[2], s$0 = s[1];
		                function a(s){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(match){
		                           if(typeof match === "number") return cont(0);
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return caml_exact_trampoline_call1(a, s);
		                           }
		                           var a$0 = match[1];
		                           return cont([0, a$0]);
		                          });
		                }
		                return a(s$0);
		               }
		               function next(s, cont){
		                var next = s[2], s$0 = s[1];
		                function a(s){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(match){
		                           if(typeof match === "number") return cont(0);
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return caml_exact_trampoline_call1(a, s);
		                           }
		                           var s$0 = match[2], a$0 = match[1];
		                           return cont([0, [0, a$0, [0, s$0, next]]]);
		                          });
		                }
		                return a(s$0);
		               }
		               function filter_map$1(s, f, cont){
		                return caml_trampoline_cps_call3
		                        (map$11,
		                         s,
		                         f,
		                         function(s$0){
		                          var next = s$0[2], s = s$0[1];
		                          return cont
		                                  ([0,
		                                    s,
		                                    function(s, cont){
		                                     return caml_trampoline_cps_call2
		     (next,
		      s,
		      function(match){
		       if(typeof match === "number") return cont(0);
		       if(0 === match[0]){var s = match[1]; return cont([0, s]);}
		       var match$0 = match[1];
		       if(match$0){
		        var s$0 = match[2], a = match$0[1];
		        return cont([1, a, s$0]);
		       }
		       var s$1 = match[2];
		       return cont([0, s$1]);
		      });
		                                    }]);
		                         });
		               }
		               function append$1(s1, s2){
		                var next2 = s2[2], s2$0 = s2[1], next1 = s1[2], s1$0 = s1[1];
		                return [0,
		                        [0, 472258093, s1$0],
		                        function(param, cont){
		                         var variant = param[1];
		                         if(472258093 <= variant){
		                          var s1 = param[2];
		                          return caml_trampoline_cps_call2
		                                  (next1,
		                                   s1,
		                                   function(match){
		                                    if(typeof match === "number")
		                                     return cont([0, [0, -630817751, s2$0]]);
		                                    if(0 === match[0]){
		                                     var s1 = match[1];
		                                     return cont([0, [0, 472258093, s1]]);
		                                    }
		                                    var s1$0 = match[2], a = match[1];
		                                    return cont([1, a, [0, 472258093, s1$0]]);
		                                   });
		                         }
		                         var s2 = param[2];
		                         return caml_trampoline_cps_call2
		                                 (next2,
		                                  s2,
		                                  function(match){
		                                   if(typeof match === "number") return cont(0);
		                                   if(0 === match[0]){
		                                    var s2 = match[1];
		                                    return cont([0, [0, -630817751, s2]]);
		                                   }
		                                   var s2$0 = match[2], a = match[1];
		                                   return cont([1, a, [0, -630817751, s2$0]]);
		                                  });
		                        }];
		               }
		               function concat$1(s, cont){
		                function f(a, cont){return cont(a);}
		                return caml_trampoline_cps_call3(bind$5, s, f, cont);
		               }
		               function zip(a, param){
		                var next2 = param[2], s2 = param[1], next1 = a[2], s1 = a[1];
		                function next(param, cont){
		                 var c = param[1];
		                 if(typeof c !== "number"){
		                  if(0 !== c[0]){
		                   var match = param[2], s1$0 = c[2], a = c[1];
		                   if(typeof match !== "number"){
		                    if(0 === match[0]){
		                     var s2$0 = param[2][1];
		                     return caml_trampoline_cps_call2
		                             (next2, s2$0, function(a){return cont([0, [0, c, a]]);});
		                    }
		                    var s2$1 = match[2], b = match[1];
		                    return cont([1, [0, a, b], [0, [0, s1$0], [0, s2$1]]]);
		                   }
		                  }
		                  if(typeof param[2] !== "number"){
		                   var s2 = param[2], s1 = c[1];
		                   return caml_trampoline_cps_call2
		                           (next1, s1, function(a){return cont([0, [0, a, s2]]);});
		                  }
		                 }
		                 return cont(0);
		                }
		                return [0, [0, [0, s1], [0, s2]], next];
		               }
		               function take$1(s, len, cont){
		                function a(a){
		                 var next = s[2], s$0 = s[1];
		                 return cont
		                         ([0,
		                           [0, 0, s$0],
		                           function(param, cont){
		                            var s = param[2], i = param[1];
		                            return len <= i
		                                    ? cont(0)
		                                    : caml_trampoline_cps_call2
		                                      (next,
		                                       s,
		                                       function(match){
		if(typeof match === "number") return cont(0);
		if(0 === match[0]){
		 var s = match[1];
		 return cont([0, [0, i, s]]);
		}
		var s$0 = match[2], a = match[1];
		return cont([1, a, [0, i + 1 | 0, s$0]]);
		                                       });
		                           }]);
		                }
		                return len < 0
		                        ? caml_exact_trampoline_cps_call
		                          (failwith, "Sequence.take", a)
		                        : a();
		               }
		               function shift_right(s, x){
		                var next = s[2], seed = s[1];
		                return [0,
		                        [0, -433944719, [0, seed, x]],
		                        function(a, cont){
		                         var variant = a[1];
		                         if(316735838 <= variant){
		                          var s = a[2];
		                          return caml_trampoline_cps_call2
		                                  (next,
		                                   s,
		                                   function(match){
		                                    if(typeof match === "number") return cont(0);
		                                    if(0 === match[0]){
		                                     var s = match[1];
		                                     return cont([0, [0, 316735838, s]]);
		                                    }
		                                    var s$0 = match[2], a = match[1];
		                                    return cont([1, a, [0, 316735838, s$0]]);
		                                   });
		                         }
		                         a = a[2];
		                         var x = a[2], seed = a[1];
		                         return cont([1, x, [0, 316735838, seed]]);
		                        }];
		               }
		               function repeat(init){
		                function f(x, cont){return cont([1, x, x]);}
		                return [0, init, f];
		               }
		               function cycle_list_exn(xs, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (deconstruct,
		                          xs,
		                          function(s){
		                           function f(param, cont){return cont(s);}
		                           var s$0 = repeat(0);
		                           return caml_trampoline_cps_call3(bind$5, s$0, f, cont);
		                          });
		                }
		                return is_empty(xs)
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg, "Sequence.cycle_list_exn", a)
		                        : a();
		               }
		               function cartesian_product(sa, sb, cont){
		                function f(a, cont){return cont(zip(repeat(a), sb));}
		                return caml_trampoline_cps_call3(bind$5, sa, f, cont);
		               }
		               function fold_m(bind, return$, t, init, f, cont){
		                function f$0(acc, option, k, cont){
		                 if(! option)
		                  return caml_trampoline_cps_call2
		                          (return$,
		                           acc,
		                           function(a){
		                            return caml_trampoline_cps_call3(bind, a, k, cont);
		                           });
		                 var a = option[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          acc,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3(bind, a, k, cont);
		                          });
		                }
		                function loop(s, next, finish, f, acc, cont){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(match){
		                           if(typeof match === "number")
		                            return caml_trampoline_cps_call2(finish, acc, cont);
		                           if(0 === match[0]){
		                            var s = match[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (f,
		                                     acc,
		                                     0,
		                                     function(a, cont){
		                                      return caml_exact_trampoline_cps_call$3
		      (loop, s, next, finish, f, a, cont);
		                                     },
		                                     cont);
		                           }
		                           var s$0 = match[2], a = match[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (f,
		                                    acc,
		                                    [0, a],
		                                    function(a, cont){
		                                     return caml_exact_trampoline_cps_call$3
		     (loop, s$0, next, finish, f, a, cont);
		                                    },
		                                    cont);
		                          });
		                }
		                var next = t[2], s = t[1];
		                return caml_exact_trampoline_cps_call$3
		                        (loop, s, next, return$, f$0, init, cont);
		               }
		               function memoize(param){
		                var next = param[2], s = param[1];
		                function memoize(s){
		                 return [0,
		                         [246,
		                          function(b, cont){
		                           function a(s){
		                            return caml_trampoline_cps_call2
		                                    (next,
		                                     s,
		                                     function(match){
		                                      if(typeof match === "number") return cont(0);
		                                      if(0 === match[0]){
		                                       var s = match[1];
		                                       return caml_exact_trampoline_call1(a, s);
		                                      }
		                                      var s$0 = match[2], a$0 = match[1];
		                                      return cont([1, a$0, memoize(s$0)]);
		                                     });
		                           }
		                           return a(s);
		                          }]];
		                }
		                return [0,
		                        memoize(s),
		                        function(a, cont){
		                         var l = a[1], a = caml_obj_tag(l);
		                         if(250 === a) return cont(l[1]);
		                         if(246 !== a && 244 !== a) return cont(l);
		                         return caml_exact_trampoline_cps_call
		                                 (force_lazy_block, l, cont);
		                        }];
		               }
		               function skip_loop(s, next, cont){
		                function a(s){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          s,
		                          function(next){
		                           if(typeof next !== "number" && 0 === next[0]){
		                            var state = next[1];
		                            return caml_exact_trampoline_call1(a, state);
		                           }
		                           return cont(next);
		                          });
		                }
		                return a(s);
		               }
		               function compare$9(compare_a, l, param, cont){
		                var
		                 next_r = param[2],
		                 s_r = param[1],
		                 next_l = l[2],
		                 s_l = l[1];
		                function a(s_l, s_r){
		                 return caml_exact_trampoline_cps_call$1
		                         (skip_loop,
		                          s_l,
		                          next_l,
		                          function(l){
		                           return caml_exact_trampoline_cps_call$1
		                                   (skip_loop,
		                                    s_r,
		                                    next_r,
		                                    function(match){
		                                     if(typeof l === "number"){
		                                      if(typeof match === "number") return cont(0);
		                                      if(0 !== match[0]) return cont(-1);
		                                     }
		                                     else if(0 !== l[0]){
		                                      if(typeof match === "number") return cont(1);
		                                      if(0 !== match[0])
		                                       return caml_trampoline_cps_call3
		       (compare_a,
		        l[1],
		        match[1],
		        function(c){
		         if(0 !== c) return cont(c);
		         var s_r = match[2], s_l = l[2];
		         return caml_exact_trampoline_call2(a, s_l, s_r);
		        });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (failwith, "Bug: This branch should be unreachable", cont);
		                                    });
		                          });
		                }
		                return a(s_l, s_r);
		               }
		               function round_robin(list){
		                function next(a, cont){
		                 var done_stack = a[2], todo_stack = a[1];
		                 if(todo_stack){
		                  var
		                   todo_stack$0 = todo_stack[2],
		                   a = todo_stack[1],
		                   f = a[2],
		                   s = a[1];
		                  return caml_trampoline_cps_call2
		                          (f,
		                           s,
		                           function(match){
		                            if(typeof match === "number")
		                             return cont([0, [0, todo_stack$0, done_stack]]);
		                            if(0 === match[0]){
		                             var s = match[1];
		                             return cont
		                                     ([0, [0, [0, [0, s, f], todo_stack$0], done_stack]]);
		                            }
		                            var s$0 = match[2], x = match[1];
		                            return cont
		                                    ([1, x, [0, todo_stack$0, [0, [0, s$0, f], done_stack]]]);
		                           });
		                 }
		                 if(is_empty(done_stack)) return cont(0);
		                 return caml_exact_trampoline_cps_call
		                         (of_rev_keys,
		                          done_stack,
		                          function(a){return cont([0, [0, a, 0]]);});
		                }
		                var state = [0, list, 0];
		                return [0, state, next];
		               }
		               function to_seq$0(param, cont){
		                var next = param[2], state = param[1];
		                function loop(state, cont){
		                 function a(state){
		                  return caml_trampoline_cps_call2
		                          (next,
		                           state,
		                           function(match){
		                            if(typeof match === "number") return cont(0);
		                            if(0 === match[0]){
		                             var state = match[1];
		                             return caml_exact_trampoline_call1(a, state);
		                            }
		                            var state$0 = match[2], hd = match[1];
		                            return cont
		                                    ([0,
		                                      hd,
		                                      function(param, cont){
		                                       return caml_exact_trampoline_cps_call(loop, state$0, cont);
		                                      }]);
		                           });
		                 }
		                 return a(state);
		                }
		                return cont
		                        (function(param, cont){
		                          return caml_exact_trampoline_cps_call(loop, state, cont);
		                         });
		               }
		               function of_list_rev(l, cont){
		                if(! l) return cont([0]);
		                var l$0 = l[2], a = l[1];
		                return caml_exact_trampoline_cps_call
		                        (length$1,
		                         l$0,
		                         function(b){
		                          var
		                           len = 1 + b | 0,
		                           t = caml_make_vect(len, a),
		                           b = len - 2 | 0;
		                          if(b >= 0){
		                           var r = l$0, i = b;
		                           for(;;){
		                            if(! r){
		                             b = caml_pop_trap();
		                             return b
		                                     (caml_maybe_attach_backtrace([0, Assert_failure, eY], 1));
		                            }
		                            var l = r[2], a$0 = r[1];
		                            caml_check_bound(t, i)[i + 1] = a$0;
		                            b = i - 1 | 0;
		                            if(0 === i) break;
		                            r = l;
		                            i = b;
		                           }
		                          }
		                          return cont(t);
		                         });
		               }
		               function of_list_map(xs, f, cont){
		                if(! xs) return cont([0]);
		                var tl = xs[2], hd = xs[1];
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         hd,
		                         function(x){
		                          return caml_exact_trampoline_cps_call
		                                  (length$1,
		                                   tl,
		                                   function(c){
		                                    var len = 1 + c | 0, a = caml_make_vect(len, x);
		                                    function b(i, param){
		                                     if(! param) return cont(a);
		                                     var tl = param[2], hd = param[1];
		                                     return caml_exact_trampoline_cps_call
		     (f,
		      hd,
		      function(c){
		       a[i + 1] = c;
		       var i$0 = i + 1 | 0;
		       return caml_exact_trampoline_call2(b, i$0, tl);
		      });
		                                    }
		                                    return b(1, tl);
		                                   });
		                         });
		               }
		               function get$2(b, a){return caml_check_bound(b, a)[a + 1];}
		               function length$3(a){return a.length - 1;}
		               function binary_search$0(pos, len, t, compare, how, v, cont){
		                return caml_exact_trampoline_cps_call$9
		                        (binary_search,
		                         pos,
		                         len,
		                         t,
		                         length$3,
		                         get$2,
		                         compare,
		                         how,
		                         v,
		                         cont);
		               }
		               function length$4(a){return a.length - 1;}
		               function create_like(len, t){
		                if(0 === len) return [0];
		                if(0 >= t.length - 1)
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, eZ], 1);
		                var x = caml_check_bound(t, 0)[1];
		                return caml_make_vect(len, x);
		               }
		               function unsafe_blit(e, d, c, b, a){caml_array_blit(e, d, c, b, a);
		               }
		               var
		                include$4 = bPV([0, create_like, length$4, unsafe_blit]),
		                blit$2 = include$4[1];
		               function to_int64_preserve_order(t){
		                return t !== t
		                        ? 0
		                        : t
		                          === 0.
		                          ? e0
		                          : 0.
		                            < t
		                            ? [0, caml_int64_bits_of_float(t)]
		                            : [0, caml_int64_neg(caml_int64_bits_of_float(- t))];
		               }
		               function of_int64_preserve_order(x){
		                return caml_greaterequal(x, e1)
		                        ? caml_int64_float_of_bits(x)
		                        : - caml_int64_float_of_bits(caml_int64_neg(x));
		               }
		               var none = NaN;
		               function one_ulp(dir, t){
		                var a = to_int64_preserve_order(t);
		                if(! a) return none;
		                var x = a[1], a = 759637122 <= dir ? e2 : e3;
		                return of_int64_preserve_order(caml_int64_add(x, a));
		               }
		               function upper_bound_for_int(num_bits){
		                var exp = num_bits - 1 | 0;
		                return one_ulp(759637122, Math.pow(2., exp));
		               }
		               function is_x_minus_one_exact(x){
		                return 1
		                       -
		                        caml_equal
		                         (caml_int64_bits_of_float(x),
		                          caml_int64_bits_of_float(x - 1.));
		               }
		               function lower_bound_for_int(num_bits){
		                var
		                 exp = num_bits - 1 | 0,
		                 min_int_as_float = - Math.pow(2., exp);
		                if(53 <= (num_bits - 1 | 0)){
		                 if(is_x_minus_one_exact(min_int_as_float))
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, e4], 1);
		                 return min_int_as_float;
		                }
		                if(is_x_minus_one_exact(min_int_as_float))
		                 return one_ulp(19067, min_int_as_float - 1.);
		                throw caml_maybe_attach_backtrace([0, Assert_failure, e5], 1);
		               }
		               function clamp_unchecked$0
		               (to_clamp_maybe_nan,
		                min_which_is_not_nan,
		                max_which_is_not_nan){
		                var
		                 t_maybe_nan =
		                   caml_sse2_float64_max_bytecode
		                    (min_which_is_not_nan, to_clamp_maybe_nan);
		                return caml_sse2_float64_min_bytecode
		                        (max_which_is_not_nan, t_maybe_nan);
		               }
		               var
		                int32_positive_overflow_bounds = caml_obj_dup(e6),
		                int_positive_overflow_bounds =
		                  caml_callback
		                   (map$1,
		                    [int32_positive_overflow_bounds,
		                     function(a, cont){return cont(a);}]);
		               function negative_exponent(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         e7,
		                         function(a){return caml_trampoline_cps_call2(a, 0, cont);});
		               }
		               function overflow(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         e8,
		                         function(a){return caml_trampoline_cps_call2(a, 0, cont);});
		               }
		               function int_pow(base, exponent, cont){
		                function a(a){
		                 a = 1 < stdlib_abs(base);
		                 if(a){
		                  a = 63 < exponent;
		                  if(a)
		                   ;
		                  else {
		                   a =
		                    caml_check_bound(int_positive_overflow_bounds, exponent)
		                     [exponent + 1];
		                   a = a < stdlib_abs(base);
		                  }
		                 }
		                 function b(a){
		                  return cont(Base_int_math_int_pow_stub(base, exponent));
		                 }
		                 return a
		                         ? caml_exact_trampoline_cps_call(overflow, dummy, b)
		                         : b();
		                }
		                return exponent < 0
		                        ? caml_exact_trampoline_cps_call
		                          (negative_exponent, dummy, a)
		                        : a(0);
		               }
		               function bO$(X, cont){
		                function symbol(x, y, cont){
		                 function a(a){
		                  var rval = X[20].call(null, x, y);
		                  return X[14].call(null, rval, X[18])
		                          ? cont(X[5].call(null, rval, y))
		                          : cont(rval);
		                 }
		                 if(! X[11].call(null, y, X[18])) return a();
		                 return caml_exact_trampoline_cps_call
		                         (X[4],
		                          y,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (X[4],
		                                    x,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call
		     (invalid_argf,
		      e9,
		      function(d){
		       return caml_trampoline_cps_call4(d, c, b, 0, a);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (X[19],
		                         1,
		                         function(one){
		                          function symbol$0(x, y, cont){
		                           function a(a){
		                            if(! X[14].call(null, x, X[18]))
		                             return cont(X[8].call(null, x, y));
		                            a = X[5].call(null, x, one);
		                            a = X[8].call(null, a, y);
		                            return cont(X[6].call(null, a, one));
		                           }
		                           if(! X[11].call(null, y, X[18])) return a(0);
		                           return caml_exact_trampoline_cps_call
		                                   (X[4],
		                                    y,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (X[4],
		      x,
		      function(c){
		       return caml_exact_trampoline_cps_call
		               (invalid_argf,
		                e_,
		                function(d){
		                 return caml_trampoline_cps_call4(d, c, b, 0, a);
		                });
		      });
		                                    });
		                          }
		                          return cont([0, symbol, symbol$0]);
		                         });
		               }
		               function hash$3(x, cont){return cont(x);}
		               function to_string$5(t, cont){return cont(make$0(1, t));}
		               var
		                include$5 =
		                  bO_
		                   ([0, compare_char, , hash$3, , sexp_of_char, , to_string$5]),
		                hash$4 = include$5[2],
		                sexp_of_char$0 = include$5[4],
		                to_string$6 = include$5[6],
		                between$1 = include$5[19],
		                hashable$0 = include$5[24],
		                all$12 =
		                  concat_of_array(caml_callback(init$6, [256, unsafe_of_int]));
		               function is_whitespace(param, cont){
		                a:
		                {
		                 if(14 <= param){
		                  if(32 !== param) break a;
		                 }
		                 else if(9 > param) break a;
		                 return cont(1);
		                }
		                return cont(0);
		               }
		               function is_digit(param){return 9 < param - 48 >>> 0 ? 0 : 1;}
		               function is_alpha(param){
		                a:
		                {
		                 if(91 <= param){
		                  if(25 < param - 97 >>> 0) break a;
		                 }
		                 else if(65 > param) break a;
		                 return 1;
		                }
		                return 0;
		               }
		               function is_alphanum(a){
		                a = a - 48 | 0;
		                a:
		                {
		                 if(42 < a >>> 0){
		                  if(25 < a - 49 >>> 0) break a;
		                 }
		                 else if(6 >= a - 10 >>> 0) break a;
		                 return 1;
		                }
		                return 0;
		               }
		               function get_digit_exn(t, cont){
		                if(is_digit(t)) return cont(t - 48 | 0);
		                return caml_exact_trampoline_cps_call
		                        (failwithf,
		                         e$,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, t, 0, cont);
		                         });
		               }
		               function compare$10(c1, c2, cont){
		                var y = lowercase_ascii(c2), x = lowercase_ascii(c1);
		                return cont(caml_int_compare(x, y));
		               }
		               function hash_fold_t(state, t){
		                var x = lowercase_ascii(t);
		                return Base_internalhash_fold_int(state, x);
		               }
		               function hash$5(t, cont){return cont(run(0, hash_fold_t, t));}
		               var
		                include$6 = Make$2([0, compare$10, sexp_of_char]),
		                equal$6 = include$6[7],
		                compare$11 = include$6[8],
		                comparator$1 = include$6[16],
		                include$7 = Make$1([0, compare_decoded, sexp_of_string]),
		                comparator$2 = include$7[1];
		               function unsafe_sub(src, pos, len){
		                if(0 === len) return cst$1;
		                var dst = caml_create_bytes(len);
		                caml_blit_string(src, pos, dst, 0, len);
		                return caml_string_of_bytes(dst);
		               }
		               function sub_fun(src, pos, len, cont){
		                if(0 === pos && len === caml_ml_string_length(src))
		                 return cont(src);
		                return caml_exact_trampoline_cps_call$0
		                        (check_pos_len_exn,
		                         pos,
		                         len,
		                         caml_ml_string_length(src),
		                         function(a){return cont(unsafe_sub(src, pos, len));});
		               }
		               function subo(opt, len, src, cont){
		                var pos = opt ? opt[1] : 0;
		                if(len)
		                 var i = len[1], i$0 = i;
		                else
		                 i$0 = caml_ml_string_length(src) - pos | 0;
		                return caml_exact_trampoline_cps_call$0
		                        (sub_fun, src, pos, i$0, cont);
		               }
		               function contains$0(opt, len, t, char, cont){
		                var
		                 pos = opt ? opt[1] : 0,
		                 total_length = caml_ml_string_length(t),
		                 len$0 = value$4(len, total_length - pos | 0);
		                return caml_exact_trampoline_cps_call$0
		                        (check_pos_len_exn,
		                         pos,
		                         len$0,
		                         total_length,
		                         function(a){
		                          var end = pos + len$0 | 0, pos$0 = pos;
		                          for(;;){
		                           a = pos$0 < end ? 1 : 0;
		                           if(a){
		                            var
		                             x = caml_string_unsafe_get(t, pos$0),
		                             a = x === char ? 1 : 0;
		                            if(! a){var pos$1 = pos$0 + 1 | 0; pos$0 = pos$1; continue;}
		                           }
		                           return cont(a);
		                          }
		                         });
		               }
		               function is_empty$0(t){
		                return 0 === caml_ml_string_length(t) ? 1 : 0;
		               }
		               function kmp_internal_loop
		               (matched_chars,
		                next_text_char,
		                pattern,
		                kmp_array,
		                char_equal,
		                cont){
		                function a(matched_chars){
		                 function b(){
		                  return caml_exact_trampoline_cps_call$1
		                          (char_equal,
		                           next_text_char,
		                           caml_string_unsafe_get(pattern, matched_chars),
		                           function(a){
		                            var
		                             matched_chars$0 = a ? matched_chars + 1 | 0 : matched_chars;
		                            return cont(matched_chars$0);
		                           });
		                 }
		                 return 0 < matched_chars
		                         ? caml_exact_trampoline_cps_call$1
		                           (char_equal,
		                            next_text_char,
		                            caml_string_unsafe_get(pattern, matched_chars),
		                            function(c){
		                             return c
		                                     ? b()
		                                     : caml_exact_trampoline_call1
		                                       (a, kmp_array[(matched_chars - 1 | 0) + 1]);
		                            })
		                         : b();
		                }
		                return a(matched_chars);
		               }
		               function get_char_equal(case_sensitive){
		                return case_sensitive ? equal$2 : equal$6;
		               }
		               function create$10(pattern, case_sensitive, cont){
		                var
		                 len = caml_ml_string_length(pattern),
		                 kmp_array = caml_make_vect(len, -1);
		                function a(){
		                 return cont([0, pattern, case_sensitive, kmp_array]);
		                }
		                if(0 >= len) return a();
		                var char_equal = get_char_equal(case_sensitive);
		                kmp_array[1] = 0;
		                var b = len - 1 | 0;
		                function c(matched_chars, i){
		                 return caml_exact_trampoline_cps_call$3
		                         (kmp_internal_loop,
		                          matched_chars,
		                          caml_string_unsafe_get(pattern, i),
		                          pattern,
		                          kmp_array,
		                          char_equal,
		                          function(d){
		                           kmp_array[i + 1] = d;
		                           var e = i + 1 | 0;
		                           return b !== i ? caml_exact_trampoline_call2(c, d, e) : a();
		                          });
		                }
		                return b < 1 ? a() : c(0, 1);
		               }
		               function index_internal(opt, param, text, cont){
		                var
		                 pos = opt ? opt[1] : 0,
		                 kmp_array = param[3],
		                 case_sensitive = param[2],
		                 pattern = param[1];
		                if
		                 (0 <= pos
		                  &&
		                   (caml_ml_string_length(text)
		                   - caml_ml_string_length(pattern)
		                   | 0)
		                   >= pos){
		                 var
		                  char_equal = get_char_equal(case_sensitive),
		                  k = caml_ml_string_length(pattern),
		                  n = caml_ml_string_length(text),
		                  a =
		                    function(j, matched_chars){
		                     if(j < n && matched_chars < k){
		                      var next_text_char = caml_string_unsafe_get(text, j);
		                      return caml_exact_trampoline_cps_call$3
		                              (kmp_internal_loop,
		                               matched_chars,
		                               next_text_char,
		                               pattern,
		                               kmp_array,
		                               char_equal,
		                               function(b){
		                                return caml_exact_trampoline_call2(a, j + 1 | 0, b);
		                               });
		                     }
		                     return matched_chars === k ? cont(j - k | 0) : cont(-1);
		                    };
		                 return a(pos, 0);
		                }
		                return cont(-1);
		               }
		               function index$0(pos, t, in$, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (index_internal,
		                         pos,
		                         t,
		                         in$,
		                         function(p){return 0 <= p ? cont([0, p]) : cont(0);});
		               }
		               function index_all(a, may_overlap, text, cont){
		                var kmp_array = a[3], case_sensitive = a[2], pattern = a[1];
		                if(0 === caml_ml_string_length(pattern))
		                 return caml_exact_trampoline_cps_call$1
		                         (init$7,
		                          1 + caml_ml_string_length(text) | 0,
		                          function(a, cont){return cont(a);},
		                          cont);
		                var
		                 char_equal = get_char_equal(case_sensitive),
		                 k = caml_ml_string_length(pattern),
		                 n = caml_ml_string_length(text);
		                function c(matched_chars, found$0, j){
		                 if(matched_chars === k){
		                  var found = [0, j - k | 0, found$0];
		                  if(may_overlap)
		                   var
		                    found$1 = found,
		                    matched_chars$0 = kmp_array[(k - 1 | 0) + 1];
		                  else {found$1 = found; matched_chars$0 = 0;}
		                 }
		                 else {found$1 = found$0; matched_chars$0 = matched_chars;}
		                 function a(matched_chars){
		                  var a = j + 1 | 0;
		                  return n !== j
		                          ? caml_exact_trampoline_call3(c, matched_chars, found$1, a)
		                          : b(found$1);
		                 }
		                 if(j >= n) return a(matched_chars$0);
		                 var next_text_char = caml_string_unsafe_get(text, j);
		                 return caml_exact_trampoline_cps_call$3
		                         (kmp_internal_loop,
		                          matched_chars$0,
		                          next_text_char,
		                          pattern,
		                          kmp_array,
		                          char_equal,
		                          a);
		                }
		                function b(found){
		                 return caml_exact_trampoline_cps_call
		                         (of_rev_keys, found, cont);
		                }
		                var a = 0;
		                return n < 0 ? b(a) : c(0, a, 0);
		               }
		               function replace_all(t, s, with$, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (index_all,
		                         t,
		                         0,
		                         s,
		                         function(matches){
		                          if(! matches) return cont(s);
		                          var
		                           len_s = caml_ml_string_length(s),
		                           len_t = caml_ml_string_length(t[1]),
		                           len_with = caml_ml_string_length(with$);
		                          return caml_exact_trampoline_cps_call
		                                  (length$1,
		                                   matches,
		                                   function(num_matches){
		                                    var
		                                     dst =
		                                       caml_create_bytes
		(len_s + caml_mul(len_with - len_t | 0, num_matches) | 0);
		                                    function a(next_dst_pos, next_src_pos, t){
		                                     if(! t)
		                                      return caml_exact_trampoline_cps_call$3
		      (blit_string,
		       s,
		       next_src_pos,
		       dst,
		       next_dst_pos,
		       len_s - next_src_pos | 0,
		       function(a){return cont(caml_string_of_bytes(dst));});
		                                     var l = t[2], a$0 = t[1], len = a$0 - next_src_pos | 0;
		                                     return caml_exact_trampoline_cps_call$3
		     (blit_string,
		      s,
		      next_src_pos,
		      dst,
		      next_dst_pos,
		      len,
		      function(b){
		       return caml_exact_trampoline_cps_call$3
		               (blit_string,
		                with$,
		                0,
		                dst,
		                next_dst_pos + len | 0,
		                len_with,
		                function(b){
		                 return caml_exact_trampoline_call3
		                         (a,
		                          (next_dst_pos + len | 0) + len_with | 0,
		                          (next_src_pos + len | 0) + len_t | 0,
		                          l);
		                });
		      });
		                                    }
		                                    return a(0, 0, matches);
		                                   });
		                         });
		               }
		               function substr_index_gen
		               (case_sensitive, pos, t, pattern, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create$10,
		                         pattern,
		                         case_sensitive,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (index$0, pos, a, t, cont);
		                         });
		               }
		               function substr_replace_all_gen
		               (case_sensitive, t, pattern, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create$10,
		                         pattern,
		                         case_sensitive,
		                         function(a){
		                          return cont
		                                  (function(b, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (replace_all, a, t, b, cont);
		                                   });
		                         });
		               }
		               function is_substring_gen(case_sensitive, t, substring, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (substr_index_gen,
		                         case_sensitive,
		                         0,
		                         t,
		                         substring,
		                         function(a){return cont(is_some(a));});
		               }
		               function is_substring_at_gen
		               (str, str_pos, sub, char_equal, cont){
		                var
		                 str_len = caml_ml_string_length(str),
		                 sub_len = caml_ml_string_length(sub),
		                 a = str_pos < 0,
		                 a = a || str_len < str_pos;
		                function b(a){
		                 a = (str_pos + sub_len | 0) <= str_len ? 1 : 0;
		                 if(! a) return cont(a);
		                 function b(str_pos, sub_pos){
		                  return sub_pos === sub_len
		                          ? cont(1)
		                          : caml_exact_trampoline_cps_call$1
		                            (char_equal,
		                             caml_string_unsafe_get(str, str_pos),
		                             caml_string_unsafe_get(sub, sub_pos),
		                             function(a){
		                              if(! a) return cont(0);
		                              var
		                               sub_pos$0 = sub_pos + 1 | 0,
		                               str_pos$0 = str_pos + 1 | 0;
		                              return caml_exact_trampoline_call2(b, str_pos$0, sub_pos$0);
		                             });
		                 }
		                 return b(str_pos, 0);
		                }
		                if(! a) return b(0);
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         fa,
		                         function(a){
		                          return caml_trampoline_cps_call4(a, str_pos, str_len, 0, b);
		                         });
		               }
		               function is_suffix_gen(string, suffix, char_equal, cont){
		                var
		                 string_len = caml_ml_string_length(string),
		                 suffix_len = caml_ml_string_length(suffix),
		                 a = suffix_len <= string_len ? 1 : 0;
		                return a
		                        ? caml_exact_trampoline_cps_call$2
		                          (is_substring_at_gen,
		                           string,
		                           string_len - suffix_len | 0,
		                           suffix,
		                           char_equal,
		                           cont)
		                        : cont(a);
		               }
		               function is_prefix_gen(string, prefix, char_equal, cont){
		                var
		                 string_len = caml_ml_string_length(string),
		                 prefix_len = caml_ml_string_length(prefix),
		                 a = prefix_len <= string_len ? 1 : 0;
		                return a
		                        ? caml_exact_trampoline_cps_call$2
		                          (is_substring_at_gen, string, 0, prefix, char_equal, cont)
		                        : cont(a);
		               }
		               function compare_local(string1, string2){
		                if(string1 === string2) return 0;
		                var
		                 len2 = caml_ml_string_length(string2),
		                 len1 = caml_ml_string_length(string1),
		                 pos = 0;
		                for(;;){
		                 if(pos === len1) return pos === len2 ? 0 : -1;
		                 if(pos === len2) return 1;
		                 var
		                  c2 = caml_string_unsafe_get(string2, pos),
		                  c1 = caml_string_unsafe_get(string1, pos),
		                  y = lowercase_ascii(c2),
		                  x = lowercase_ascii(c1),
		                  c = caml_int_compare(x, y);
		                 if(0 !== c) return c;
		                 var pos$0 = pos + 1 | 0;
		                 pos = pos$0;
		                }
		               }
		               function compare$12(a, b, cont){
		                return cont(compare_local(a, b));
		               }
		               function hash_fold_t$0(state, t){
		                var
		                 len = caml_ml_string_length(t),
		                 a = Base_internalhash_fold_int(state, len),
		                 b = len - 1 | 0;
		                if(b < 0)
		                 var state$1 = a;
		                else {
		                 var state$0 = a, pos = 0;
		                 for(;;){
		                  var
		                   x = lowercase_ascii(caml_string_unsafe_get(t, pos)),
		                   a = Base_internalhash_fold_int(state$0, x),
		                   c = pos + 1 | 0;
		                  if(b === pos){state$1 = a; break;}
		                  state$0 = a;
		                  pos = c;
		                 }
		                }
		                return state$1;
		               }
		               function hash$6(t, cont){
		                return cont(run(0, hash_fold_t$0, t));
		               }
		               var
		                include$8 = Make$2([0, compare$12, sexp_of_string]),
		                equal$7 = include$8[7],
		                compare$13 = include$8[8],
		                comparator$3 = include$8[16];
		               function to_string$7(a){return a;}
		               function to_list$1(s){
		                var i$1 = caml_ml_string_length(s) - 1 | 0, acc = 0, i = i$1;
		                for(;;){
		                 if(0 > i) return acc;
		                 var i$0 = i - 1 | 0, acc$0 = [0, caml_string_get(s, i), acc];
		                 acc = acc$0;
		                 i = i$0;
		                }
		               }
		               function rev$0(t){
		                var
		                 len = caml_ml_string_length(t),
		                 res = caml_create_bytes(len),
		                 a = len - 1 | 0;
		                if(a >= 0){
		                 var i = 0;
		                 for(;;){
		                  caml_bytes_unsafe_set
		                   (res, i, caml_string_unsafe_get(t, (len - 1 | 0) - i | 0));
		                  var b = i + 1 | 0;
		                  if(a === i) break;
		                  i = b;
		                 }
		                }
		                return caml_string_of_bytes(res);
		               }
		               function lsplit2_exn(string, delim, cont){
		                var len = caml_ml_string_length(string), pos = 0;
		                for(;;){
		                 if(len <= pos){
		                  var raise = caml_pop_trap();
		                  return raise
		                          (caml_maybe_attach_backtrace([0, Not_found_s, fb], 1));
		                 }
		                 var x = caml_string_unsafe_get(string, pos);
		                 if(x === delim) break;
		                 var pos$0 = pos + 1 | 0;
		                 pos = pos$0;
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (sub_fun,
		                         string,
		                         pos + 1 | 0,
		                         (len - pos | 0) - 1 | 0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (sub_fun,
		                                   string,
		                                   0,
		                                   pos,
		                                   function(b){return cont([0, b, a]);});
		                         });
		               }
		               function rsplit2_exn(string, delim, cont){
		                var
		                 len = caml_ml_string_length(string),
		                 pos$1 = len - 1 | 0,
		                 pos = pos$1;
		                for(;;){
		                 if(0 > pos){
		                  var raise = caml_pop_trap();
		                  return raise
		                          (caml_maybe_attach_backtrace([0, Not_found_s, fc], 1));
		                 }
		                 var x = caml_string_unsafe_get(string, pos);
		                 if(x === delim) break;
		                 var pos$0 = pos - 1 | 0;
		                 pos = pos$0;
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (sub_fun,
		                         string,
		                         pos + 1 | 0,
		                         (len - pos | 0) - 1 | 0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (sub_fun,
		                                   string,
		                                   0,
		                                   pos,
		                                   function(b){return cont([0, b, a]);});
		                         });
		               }
		               function lsplit2(line, on, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(exn[1] !== Not_found_s && exn !== Not_found){
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   }
		                   return cont(0);
		                  });
		                return caml_exact_trampoline_cps_call$1
		                        (lsplit2_exn,
		                         line,
		                         on,
		                         function(a){caml_pop_trap(); return cont([0, a]);});
		               }
		               function rsplit2(line, on, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(exn[1] !== Not_found_s && exn !== Not_found){
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   }
		                   return cont(0);
		                  });
		                return caml_exact_trampoline_cps_call$1
		                        (rsplit2_exn,
		                         line,
		                         on,
		                         function(a){caml_pop_trap(); return cont([0, a]);});
		               }
		               function char_list_mem(l$0, c){
		                var l = l$0;
		                for(;;){
		                 if(! l) return 0;
		                 var tl = l[2], hd = l[1], a = hd === c ? 1 : 0;
		                 if(a) return a;
		                 l = tl;
		                }
		               }
		               function split_gen(str, on, cont){
		                var variant = on[1];
		                if(552554919 <= variant)
		                 var
		                  l = on[2],
		                  is_delim = function(c){return char_list_mem(l, c);};
		                else
		                 var
		                  c = on[2],
		                  is_delim = function(c$0){return c$0 === c ? 1 : 0;};
		                var
		                 last_pos = caml_ml_string_length(str),
		                 last_pos$0 = last_pos - 1 | 0;
		                function a(acc, last_pos$0, last_pos){
		                 if(-1 === last_pos)
		                  return caml_exact_trampoline_cps_call$0
		                          (sub_fun,
		                           str,
		                           0,
		                           last_pos$0,
		                           function(a){return cont([0, a, acc]);});
		                 if(is_delim(caml_string_get(str, last_pos))){
		                  var pos1 = last_pos + 1 | 0;
		                  return caml_exact_trampoline_cps_call$0
		                          (sub_fun,
		                           str,
		                           pos1,
		                           last_pos$0 - pos1 | 0,
		                           function(sub_str){
		                            var
		                             last_pos$0 = last_pos - 1 | 0,
		                             acc$0 = [0, sub_str, acc];
		                            return caml_exact_trampoline_call3
		                                    (a, acc$0, last_pos, last_pos$0);
		                           });
		                 }
		                 var last_pos$1 = last_pos - 1 | 0;
		                 return caml_exact_trampoline_call3
		                         (a, acc, last_pos$0, last_pos$1);
		                }
		                return a(0, last_pos, last_pos$0);
		               }
		               function split$0(str, on, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split_gen, str, [0, -1044422954, on], cont);
		               }
		               function split_on_chars(str, chars, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split_gen, str, [0, 552554919, chars], cont);
		               }
		               function wrap_sub_n(t, n, name, pos, len, on_error, cont){
		                return 0 <= n
		                        ? (caml_push_trap
		                           (function(exn){return cont(on_error);}),
		                          caml_exact_trampoline_cps_call$0
		                           (sub_fun,
		                            t,
		                            pos,
		                            len,
		                            function(a){caml_pop_trap(); return cont(a);}))
		                        : caml_exact_trampoline_cps_call
		                          (invalid_arg,
		                           name + " expecting nonnegative argument",
		                           cont);
		               }
		               function drop_prefix(t, n, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (wrap_sub_n,
		                         t,
		                         n,
		                         "drop_prefix",
		                         n,
		                         caml_ml_string_length(t) - n | 0,
		                         cst$1,
		                         cont);
		               }
		               function drop_suffix(t, n, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (wrap_sub_n,
		                         t,
		                         n,
		                         "drop_suffix",
		                         0,
		                         caml_ml_string_length(t) - n | 0,
		                         cst$1,
		                         cont);
		               }
		               function prefix(t, n, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (wrap_sub_n, t, n, "prefix", 0, n, t, cont);
		               }
		               function suffix(t, n, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (wrap_sub_n,
		                         t,
		                         n,
		                         "suffix",
		                         caml_ml_string_length(t) - n | 0,
		                         n,
		                         t,
		                         cont);
		               }
		               function last_non_drop(drop, t, cont){
		                function a(i){
		                 if(0 > i) return cont(0);
		                 var c = caml_string_get(t, i);
		                 return caml_exact_trampoline_cps_call
		                         (drop,
		                          c,
		                          function(b){
		                           if(1 - b) return cont([0, i]);
		                           var i$0 = i - 1 | 0;
		                           return caml_exact_trampoline_call1(a, i$0);
		                          });
		                }
		                return a(caml_ml_string_length(t) - 1 | 0);
		               }
		               function rstrip(opt, t, cont){
		                var drop = opt ? opt[1] : is_whitespace;
		                return caml_exact_trampoline_cps_call$1
		                        (last_non_drop,
		                         drop,
		                         t,
		                         function(match){
		                          if(! match) return cont(cst$1);
		                          var i = match[1];
		                          return i === (caml_ml_string_length(t) - 1 | 0)
		                                  ? cont(t)
		                                  : caml_exact_trampoline_cps_call$1
		                                    (prefix, t, i + 1 | 0, cont);
		                         });
		               }
		               function first_non_drop(drop, t, cont){
		                var n = caml_ml_string_length(t);
		                function a(i){
		                 if(i === n) return cont(0);
		                 var c = caml_string_get(t, i);
		                 return caml_exact_trampoline_cps_call
		                         (drop,
		                          c,
		                          function(b){
		                           if(1 - b) return cont([0, i]);
		                           var i$0 = i + 1 | 0;
		                           return caml_exact_trampoline_call1(a, i$0);
		                          });
		                }
		                return a(0);
		               }
		               function lstrip(opt, t, cont){
		                var drop = opt ? opt[1] : is_whitespace;
		                return caml_exact_trampoline_cps_call$1
		                        (first_non_drop,
		                         drop,
		                         t,
		                         function(match){
		                          if(! match) return cont(cst$1);
		                          var n = match[1];
		                          return 0 === n
		                                  ? cont(t)
		                                  : caml_exact_trampoline_cps_call$1(drop_prefix, t, n, cont);
		                         });
		               }
		               function strip(opt, t, cont){
		                var
		                 drop = opt ? opt[1] : is_whitespace,
		                 length = caml_ml_string_length(t);
		                function a(){return cont(t);}
		                return 0 === length
		                        ? a()
		                        : caml_exact_trampoline_cps_call
		                          (drop,
		                           caml_string_get(t, 0),
		                           function(c){
		                            function b(){
		                             return caml_exact_trampoline_cps_call$1
		                                     (first_non_drop,
		                                      drop,
		                                      t,
		                                      function(match){
		                                       if(! match) return cont(cst$1);
		                                       var first = match[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (last_non_drop,
		        drop,
		        t,
		        function(a){
		         if(a){
		          var last = a[1];
		          return caml_exact_trampoline_cps_call$0
		                  (sub_fun, t, first, (last - first | 0) + 1 | 0, cont);
		         }
		         a = caml_pop_trap();
		         return a
		                 (caml_maybe_attach_backtrace([0, Assert_failure, fd], 1));
		        });
		                                      });
		                            }
		                            return c
		                                    ? b()
		                                    : caml_exact_trampoline_cps_call
		                                      (drop,
		                                       caml_string_get(t, length - 1 | 0),
		                                       function(c){return c ? b() : a();});
		                           });
		               }
		               function to_array$1(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (init$6,
		                         caml_ml_string_length(s),
		                         function(i){return caml_string_get(s, i);},
		                         cont);
		               }
		               function iteri(t, f, cont){
		                var a = caml_ml_string_length(t) - 1 | 0;
		                function c(){return cont();}
		                function b(i){
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          i,
		                          caml_string_unsafe_get(t, i),
		                          function(d){
		                           d = i + 1 | 0;
		                           return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		                          });
		                }
		                return a < 0 ? c() : b(0);
		               }
		               function mem$1(t, c){
		                var len = caml_ml_string_length(t), i = 0;
		                for(;;){
		                 var a = i < len ? 1 : 0;
		                 if(a){
		                  var y = caml_string_unsafe_get(t, i), a = c === y ? 1 : 0;
		                  if(! a){var i$0 = i + 1 | 0; i = i$0; continue;}
		                 }
		                 return a;
		                }
		               }
		               function tr$0(target, replacement, s){
		                if(! mem$1(s, target)) return s;
		                var
		                 l = caml_ml_string_length(s),
		                 t = caml_create_bytes(l),
		                 b = l - 1 | 0;
		                if(b >= 0){
		                 var i = 0;
		                 for(;;){
		                  var
		                   c = caml_string_get(s, i),
		                   a = c === target ? replacement : c;
		                  caml_bytes_unsafe_set(t, i, a);
		                  a = i + 1 | 0;
		                  if(b === i) break;
		                  i = a;
		                 }
		                }
		                return caml_string_of_bytes(t);
		               }
		               function concat_array(sep, ar, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (concat$0, sep, concat_of_array(ar), cont);
		               }
		               function concat_map$0(sep, s, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_array$1,
		                         s,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$1,
		                                   a,
		                                   f,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (concat_array, sep, a, cont);
		                                   });
		                         });
		               }
		               function concat_lines(opt, lines$3){
		                var newline_len = 1,
		                 lines = lines$3,
		                 sum = 0;
		                for(;;){
		                 if(! lines) break;
		                 var
		                  lines$0 = lines[2],
		                  line = lines[1],
		                  sum$0 =
		                    (sum + caml_ml_string_length(line) | 0) + newline_len | 0;
		                 lines = lines$0;
		                 sum = sum$0;
		                }
		                var
		                 buf = caml_create_bytes(sum),
		                 lines$1 = lines$3,
		                 written = 0;
		                for(;;){
		                 if(! lines$1){
		                  if(written === sum) return caml_string_of_bytes(buf);
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, fe], 1);
		                 }
		                 var lines$2 = lines$1[2], line$0 = lines$1[1];
		                 caml_blit_string
		                  (line$0, 0, buf, written, caml_ml_string_length(line$0));
		                 var
		                  pos$1 = written + caml_ml_string_length(line$0) | 0,
		                  pos =
		                    pos$1;
		                 caml_bytes_unsafe_set(buf, pos, 10);
		                 var pos$0 = pos + 1 | 0;
		                 lines$1 = lines$2;
		                 written = pos$0;
		                }
		               }
		               function filter$1(t, f, cont){
		                var n = caml_ml_string_length(t), i = 0;
		                for(;;){
		                 if(i >= n) break;
		                 if(! f(caml_string_get(t, i))) break;
		                 var i$0 = i + 1 | 0;
		                 i = i$0;
		                }
		                if(i === n) return cont(t);
		                var out = caml_create_bytes(n - 1 | 0);
		                return caml_exact_trampoline_cps_call$3
		                        (blit_string,
		                         t,
		                         0,
		                         out,
		                         0,
		                         i,
		                         function(a){
		                          var i$0 = i + 1 | 0, out_pos = i, i$1 = i$0;
		                          for(;;){
		                           if(i$1 >= n){
		                            var out$0 = caml_string_of_bytes(out);
		                            return out_pos === (n - 1 | 0)
		                                    ? cont(out$0)
		                                    : caml_exact_trampoline_cps_call$0
		                                      (sub_fun, out$0, 0, out_pos, cont);
		                           }
		                           var c = caml_string_get(t, i$1);
		                           if(f(c)){
		                            caml_bytes_set(out, out_pos, c);
		                            var out_pos$0 = out_pos + 1 | 0, out_pos$1 = out_pos$0;
		                           }
		                           else
		                            out_pos$1 = out_pos;
		                           var i$2 = i$1 + 1 | 0;
		                           out_pos = out_pos$1;
		                           i$1 = i$2;
		                          }
		                         });
		               }
		               function chop_prefix(s, prefix, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (is_prefix_gen,
		                         s,
		                         prefix,
		                         equal$2,
		                         function(a){
		                          return a
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (drop_prefix,
		                                     s,
		                                     caml_ml_string_length(prefix),
		                                     function(a){return cont([0, a]);})
		                                  : cont(0);
		                         });
		               }
		               function chop_suffix(s, suffix, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (is_suffix_gen,
		                         s,
		                         suffix,
		                         equal$2,
		                         function(a){
		                          return a
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (drop_suffix,
		                                     s,
		                                     caml_ml_string_length(suffix),
		                                     function(a){return cont([0, a]);})
		                                  : cont(0);
		                         });
		               }
		               function chop_suffix_exn(s, suffix, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (chop_suffix,
		                         s,
		                         suffix,
		                         function(match){
		                          if(match){var str = match[1]; return cont(str);}
		                          return caml_exact_trampoline_cps_call
		                                  (invalid_argf,
		                                   ff,
		                                   function(a){
		                                    return caml_trampoline_cps_call4(a, s, suffix, 0, cont);
		                                   });
		                         });
		               }
		               function pp$2(ppf, string, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         fg,
		                         function(a){
		                          return caml_trampoline_cps_call2(a, string, cont);
		                         });
		               }
		               function of_char(c){return make$0(1, c);}
		               function of_char_list(l, cont){
		                return caml_exact_trampoline_cps_call
		                        (length$1,
		                         l,
		                         function(b){
		                          var t = caml_create_bytes(b), init$0 = 0, t$0 = l;
		                          for(;;){
		                           if(! t$0) return cont(caml_string_of_bytes(t));
		                           var l$0 = t$0[2], a = t$0[1];
		                           caml_bytes_set(t, init$0, a);
		                           var init = init$0 + 1 | 0;
		                           init$0 = init;
		                           t$0 = l$0;
		                          }
		                         });
		               }
		               function edit_distance(s2, s1, cont){
		                if(caml_ml_string_length(s2) <= caml_ml_string_length(s1))
		                 var s2$0 = s1, s1$0 = s2;
		                else {s2$0 = s2; s1$0 = s1;}
		                var
		                 len = 2 * (1 + caml_ml_string_length(s1$0) | 0) | 0,
		                 table = caml_make_vect(len, 0);
		                function at(i, j){return (i * 2 | 0) + (j % 2 | 0) | 0;}
		                var b = caml_ml_string_length(s1$0);
		                if(b >= 1){
		                 var i = 1;
		                 for(;;){
		                  var a = at(i, 0);
		                  caml_check_bound(table, a)[a + 1] = i;
		                  a = i + 1 | 0;
		                  if(b === i) break;
		                  i = a;
		                 }
		                }
		                var c = caml_ml_string_length(s2$0);
		                function e(){
		                 var
		                  a =
		                    at(caml_ml_string_length(s1$0), caml_ml_string_length(s2$0));
		                 return cont(caml_check_bound(table, a)[a + 1]);
		                }
		                function d(j){
		                 var a = at(0, j);
		                 caml_check_bound(table, a)[a + 1] = j;
		                 var b = caml_ml_string_length(s1$0);
		                 function g(){
		                  var a = j + 1 | 0;
		                  return c !== j ? caml_exact_trampoline_call1(d, a) : e();
		                 }
		                 function f(i){
		                  var
		                   y = caml_string_get(s2$0, j - 1 | 0),
		                   x = caml_string_get(s1$0, i - 1 | 0);
		                  function d(){
		                   var a = i + 1 | 0;
		                   return b !== i ? caml_exact_trampoline_call1(f, a) : g();
		                  }
		                  if(x === y){
		                   var
		                    a = at(i - 1 | 0, j - 1 | 0),
		                    a = caml_check_bound(table, a)[a + 1],
		                    c = at(i, j);
		                   caml_check_bound(table, c)[c + 1] = a;
		                   return d();
		                  }
		                  a = at(i - 1 | 0, j - 1 | 0);
		                  var
		                   sub = caml_check_bound(table, a)[a + 1],
		                   a = at(i - 1 | 0, j),
		                   add = caml_check_bound(table, a)[a + 1],
		                   a = at(i, j - 1 | 0),
		                   del = caml_check_bound(table, a)[a + 1];
		                  return caml_exact_trampoline_cps_call$1
		                          (min$2,
		                           add,
		                           del,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (min$2,
		                                     sub,
		                                     a,
		                                     function(b){
		                                      var a = at(i, j);
		                                      caml_check_bound(table, a)[a + 1] = 1 + b | 0;
		                                      return d();
		                                     });
		                           });
		                 }
		                 return b < 1 ? g() : f(1);
		                }
		                return c < 1 ? e() : d(1);
		               }
		               function between$2(t, low, high, cont){
		                var a = caml_string_lessequal(low, t);
		                return a ? cont(caml_string_lessequal(t, high)) : cont(a);
		               }
		               function clamp_unchecked$1(t, min, max){
		                return caml_string_lessthan(t, min)
		                        ? min
		                        : caml_string_lessequal(t, max) ? t : max;
		               }
		               function clamp_exn$1(t, min, max, a){
		                if(caml_string_lessequal(min, max))
		                 return a(clamp_unchecked$1(t, min, max));
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, fh], 1));
		               }
		               function clamp$1(t, min, max, cont){
		                return caml_string_greaterthan(min, max)
		                        ? cont
		                          (error_s
		                            (message
		                              (cst_clamp_requires_min_max,
		                               [0, [0, cst_min, [0, min]], [0, [0, cst_max, [0, max]], 0]])))
		                        : cont([0, clamp_unchecked$1(t, min, max)]);
		               }
		               function create$11(opt, pattern, cont){
		                var case_sensitive = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call$1
		                        (create$10, pattern, case_sensitive, cont);
		               }
		               function Make_utf(Format, cont){
		                var codec_name = Format[1];
		                function to_string(a, cont){return cont(a);}
		                return caml_exact_trampoline_cps_call$1
		                        (concat$0,
		                         0,
		                         [0,
		                          Format[2],
		                          [0, ".of_string: invalid ", [0, codec_name, 0]]],
		                         function(raise_of_string_message){
		                          var
		                           include = Of_stringable([0, , to_string]),
		                           sexp_of_t = include[3];
		                          function hash(a, cont){return cont(Base_hash_string(a));}
		                          var
		                           include$0 =
		                             bO_([0, compare$4, , hash, , sexp_of_t, , to_string]),
		                           hash$0 = include$0[2],
		                           sexp_of_t$0 = include$0[4],
		                           compare = include$0[14],
		                           hashable = include$0[24];
		                          function of_list(uchars, cont){
		                           var init = 0, t = uchars;
		                           for(;;){
		                            if(! t) break;
		                            var
		                             l = t[2],
		                             a = t[1],
		                             init$0 = init + Format[4].call(null, a) | 0;
		                            init = init$0;
		                            t = l;
		                           }
		                           var bytes = caml_create_bytes(init);
		                           function b(t, init$0){
		                            if(t){
		                             var l = t[2], uchar = t[1];
		                             return caml_exact_trampoline_cps_call$0
		                                     (Format[6],
		                                      bytes,
		                                      init$0,
		                                      uchar,
		                                      function(a){
		                                       var init = init$0 + a | 0;
		                                       return caml_exact_trampoline_call2(b, l, init);
		                                      });
		                            }
		                            if(init$0 === init)
		                             return cont(caml_string_of_bytes(bytes));
		                            var raise = caml_pop_trap();
		                            return raise
		                                    (caml_maybe_attach_backtrace([0, Assert_failure, fi], 1));
		                           }
		                           return b(uchars, 0);
		                          }
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    hash$0,
		                                    ,
		                                    sexp_of_t$0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    compare,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    hashable,
		                                    ,
		                                    ,
		                                    ,
		                                    of_list]);
		                         });
		               }
		               var
		                Utf8 =
		                  caml_callback
		                   (Make_utf,
		                    [[0,
		                      "UTF-8",
		                      "Base.String.Utf8",
		                      ,
		                      utf_8_byte_length,
		                      get_decode_result,
		                      set_utf_8_uchar]]),
		                Utf16le =
		                  caml_callback
		                   (Make_utf,
		                    [[0,
		                      "UTF-16LE",
		                      "Base.String.Utf16le",
		                      ,
		                      utf_16_byte_length,
		                      get_utf_16le_uchar,
		                      set_utf_16le_uchar]]),
		                Utf16be =
		                  caml_callback
		                   (Make_utf,
		                    [[0,
		                      "UTF-16BE",
		                      "Base.String.Utf16be",
		                      ,
		                      utf_16_byte_length,
		                      get_utf_16be_uchar,
		                      set_utf_16be_uchar]]);
		               function Make_utf32(Format, cont){
		                function byte_length(param){return 4;}
		                var
		                 codec_name = Format[1],
		                 module_name = Format[2],
		                 set = Format[4],
		                 get_decode_result = Format[3];
		                return caml_exact_trampoline_cps_call
		                        (Make_utf,
		                         [0,
		                          codec_name,
		                          module_name,
		                          ,
		                          byte_length,
		                          get_decode_result,
		                          set],
		                         cont);
		               }
		               var
		                Utf32le =
		                  caml_callback
		                   (Make_utf32,
		                    [[0,
		                      "UTF-32LE",
		                      "Base.String.Utf32le",
		                      get_utf_32le_uchar,
		                      set_uchar_utf_32le]]),
		                Utf32be =
		                  caml_callback
		                   (Make_utf32,
		                    [[0,
		                      "UTF-32BE",
		                      "Base.String.Utf32be",
		                      get_utf_32be_uchar,
		                      set_uchar_utf_32be]]),
		                Utf32be$0 =
		                  [0,
		                   ,
		                   ,
		                   Utf32be[11],
		                   ,
		                   Utf32be[13],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf32be[23],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf32be[33],
		                   Utf32be[37]],
		                Utf32le$0 =
		                  [0,
		                   ,
		                   ,
		                   Utf32le[11],
		                   ,
		                   Utf32le[13],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf32le[23],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf32le[33],
		                   Utf32le[37]],
		                Utf16be$0 =
		                  [0,
		                   ,
		                   ,
		                   Utf16be[11],
		                   ,
		                   Utf16be[13],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf16be[23],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf16be[33],
		                   Utf16be[37]],
		                Utf16le$0 =
		                  [0,
		                   ,
		                   ,
		                   Utf16le[11],
		                   ,
		                   Utf16le[13],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf16le[23],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf16le[33],
		                   Utf16le[37]],
		                Utf8$0 =
		                  [0,
		                   ,
		                   ,
		                   Utf8[11],
		                   ,
		                   Utf8[13],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf8[23],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Utf8[33],
		                   Utf8[37]];
		               function insert_delimiter_every
		               (input, delimiter, num_chars_until_delimiter){
		                var input_length = caml_ml_string_length(input);
		                if(input_length <= num_chars_until_delimiter) return input;
		                var match = caml_string_get(input, 0);
		                a:
		                {
		                 if(43 !== match && 45 !== match){var has_sign = 0; break a;}
		                 has_sign = 1;
		                }
		                var
		                 num_digits = has_sign ? input_length - 1 | 0 : input_length,
		                 num_delimiters =
		                   caml_div(num_digits - 1 | 0, num_chars_until_delimiter),
		                 output_length = input_length + num_delimiters | 0,
		                 output = caml_create_bytes(output_length),
		                 input_pos = input_length - 1 | 0,
		                 output_pos = output_length - 1 | 0;
		                if(has_sign)
		                 var
		                  num_chars_until_delimiter$0 = num_chars_until_delimiter,
		                  output_pos$0 = output_pos,
		                  input_pos$0 = input_pos,
		                  first_digit_pos = 1;
		                else {
		                 num_chars_until_delimiter$0 = num_chars_until_delimiter;
		                 output_pos$0 = output_pos;
		                 input_pos$0 = input_pos;
		                 first_digit_pos = 0;
		                }
		                for(;;){
		                 if(first_digit_pos > input_pos$0){
		                  if(has_sign)
		                   caml_bytes_set(output, 0, caml_string_get(input, 0));
		                  return caml_string_of_bytes(output);
		                 }
		                 if(0 === num_chars_until_delimiter$0){
		                  caml_bytes_set(output, output_pos$0, delimiter);
		                  var
		                   output_pos$1 = output_pos$0 - 1 | 0,
		                   num_chars_until_delimiter$1 = num_chars_until_delimiter,
		                   output_pos$2 = output_pos$1;
		                 }
		                 else {
		                  num_chars_until_delimiter$1 = num_chars_until_delimiter$0;
		                  output_pos$2 = output_pos$0;
		                 }
		                 caml_bytes_set
		                  (output, output_pos$2, caml_string_get(input, input_pos$0));
		                 var
		                  input_pos$1 = input_pos$0 - 1 | 0,
		                  output_pos$3 = output_pos$2 - 1 | 0,
		                  num_chars_until_delimiter$2 =
		                    num_chars_until_delimiter$1 - 1 | 0;
		                 num_chars_until_delimiter$0 = num_chars_until_delimiter$2;
		                 output_pos$0 = output_pos$3;
		                 input_pos$0 = input_pos$1;
		                }
		               }
		               function insert_delimiter(input, delimiter){
		                return insert_delimiter_every(input, delimiter, 3);
		               }
		               function Make$3(I){
		                function sexp_of_t(t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (I[1], t, function(s){return cont([0, s]);});
		                }
		                return [0, , sexp_of_t];
		               }
		               var
		                e =
		                  bO_([0, compare$6, , to_int, , sexp_of_t$3, , to_string$3]),
		                hash$7 = e[2],
		                sexp_of_t$5 = e[4],
		                hashable$1 = e[24];
		               function hash$8(x, cont){return cont(hash_int(x));}
		               var
		                hashable$2 =
		                  [0,
		                   hash$8,
		                   function(b, a, cont){return cont(caml_int_compare(b, a));},
		                   sexp_of_int];
		               function compare$14(x, y, cont){
		                return cont(caml_int_compare(x, y));
		               }
		               function of_string$3(s, cont){
		                try{var a = caml_int_of_string(s);}
		                catch(exn){
		                 return caml_exact_trampoline_cps_call
		                         (failwithf,
		                          fj,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, s, 0, cont);
		                          });
		                }
		                return cont(a);
		               }
		               var
		                int_size_in_bits = 32,
		                float_lower_bound = lower_bound_for_int(int_size_in_bits),
		                float_upper_bound = upper_bound_for_int(int_size_in_bits);
		               function of_float(f, cont){
		                if(float_lower_bound <= f && f <= float_upper_bound)
		                 return cont(f | 0);
		                var a = f + 0.;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         fk,
		                         function(b){
		                          return caml_trampoline_cps_call3(b, a, 0, cont);
		                         });
		               }
		               var
		                comparator$4 = Make$1([0, compare$14, sexp_of_int])[1],
		                include$9 = Make$3([0, string_of_int]),
		                sexp_of_int$0 = include$9[2];
		               function pred$2(i){return i - 1 | 0;}
		               function of_int_exn$0(i, cont){return cont(i);}
		               function rem(a, b){return caml_mod(a, b);}
		               function incr$0(a){a[1]++;}
		               function shift_right$0(a, b){return a >> b;}
		               function shift_left(a, b){return a << b;}
		               function bit_not$2(a){return a ^ -1;}
		               function non_positive_argument(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         fl,
		                         function(a){return caml_trampoline_cps_call2(a, 0, cont);});
		               }
		               function ceil_pow2(x, cont){
		                function a(a){
		                 var
		                  x$6 = x - 1 | 0,
		                  x$5 = x$6 | x$6 >>> 1 | 0,
		                  x$4 = x$5 | x$5 >>> 2 | 0,
		                  x$3 = x$4 | x$4 >>> 4 | 0,
		                  x$2 = x$3 | x$3 >>> 8 | 0,
		                  x$1 = x$2 | x$2 >>> 16 | 0,
		                  x$0 = x$1 | x$1 >>> 32 | 0;
		                 return cont(x$0 + 1 | 0);
		                }
		                return x <= 0
		                        ? caml_exact_trampoline_cps_call
		                          (non_positive_argument, dummy, a)
		                        : a();
		               }
		               function floor_pow2(x, cont){
		                function a(a){
		                 var
		                  x$5 = x | x >>> 1 | 0,
		                  x$4 = x$5 | x$5 >>> 2 | 0,
		                  x$3 = x$4 | x$4 >>> 4 | 0,
		                  x$2 = x$3 | x$3 >>> 8 | 0,
		                  x$1 = x$2 | x$2 >>> 16 | 0,
		                  x$0 = x$1 | x$1 >>> 32 | 0;
		                 return cont(x$0 - (x$0 >>> 1 | 0) | 0);
		                }
		                return x <= 0
		                        ? caml_exact_trampoline_cps_call
		                          (non_positive_argument, dummy, a)
		                        : a();
		               }
		               var min_value$3 = 0;
		               caml_callback
		                (bO$,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   string_of_int,
		                   function(b, a){return b + a | 0;},
		                   function(b, a){return b - a | 0;},
		                   ,
		                   function(b, a){return caml_div(b, a);},
		                   ,
		                   ,
		                   function(b, a){return b <= a ? 1 : 0;},
		                   ,
		                   ,
		                   function(b, a){return b < a ? 1 : 0;},
		                   ,
		                   ,
		                   ,
		                   min_value$3,
		                   of_int_exn$0,
		                   rem]]);
		               function symbol$23(x, y, cont){
		                function a(a){
		                 var rval = caml_mod(x, y);
		                 return rval < 0 ? cont(rval + y | 0) : cont(rval);
		                }
		                if(y > 0) return a();
		                var b = "" + x, c = "" + y;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         fm,
		                         function(d){
		                          return caml_trampoline_cps_call4(d, b, c, 0, a);
		                         });
		               }
		               function symbol$24(x, y, cont){
		                function a(a){
		                 return x < 0
		                         ? cont(caml_div(x + 1 | 0, y) - 1 | 0)
		                         : cont(caml_div(x, y));
		                }
		                if(y > 0) return a();
		                var b = "" + x, c = "" + y;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         fn,
		                         function(d){
		                          return caml_trampoline_cps_call4(d, b, c, 0, a);
		                         });
		               }
		               function phys_compare(b, a, cont){
		                return cont(caml_int_compare(b, a));
		               }
		               function length$5(a){return a.length - 1;}
		               function create_zero(len){return caml_make_vect(len, 0);}
		               function get$3(t, i){return caml_check_bound(t, i)[i + 1];}
		               function unsafe_set_with_caml_modify(t, i, obj){t[i + 1] = obj;
		               }
		               function set_with_caml_modify(t, i, obj){caml_check_bound(t, i)[i + 1] = obj;
		               }
		               function unsafe_set_int_assuming_curren(t, i, int){t[i + 1] = int;
		               }
		               function set$0(t, i, obj){
		                var old_obj = get$3(t, i);
		                if(typeof old_obj === "number" && typeof obj === "number")
		                 return unsafe_set_int_assuming_curren(t, i, obj);
		                var a = 1 - (old_obj === obj);
		                return a ? unsafe_set_with_caml_modify(t, i, obj) : a;
		               }
		               function unsafe_set(t, i, obj){
		                var old_obj = t[i + 1];
		                if(typeof old_obj === "number" && typeof obj === "number")
		                 return unsafe_set_int_assuming_curren(t, i, obj);
		                var a = 1 - (old_obj === obj);
		                return a ? unsafe_set_with_caml_modify(t, i, obj) : a;
		               }
		               function create$12(len, x){
		                if(typeof x !== "number" && caml_obj_tag(x) === 253){
		                 var t = caml_make_vect(len, 0), a = len - 1 | 0;
		                 if(a >= 0){
		                  var i = 0;
		                  for(;;){
		                   unsafe_set_with_caml_modify(t, i, x);
		                   var b = i + 1 | 0;
		                   if(a === i) break;
		                   i = b;
		                  }
		                 }
		                 return t;
		                }
		                return caml_make_vect(len, x);
		               }
		               function unsafe_blit$0(src, src_pos, dst, dst_pos, len){
		                if(dst_pos < src_pos){
		                 var a = len - 1 | 0;
		                 if(a >= 0){
		                  var i = 0;
		                  for(;;){
		                   var i$1 = src_pos + i | 0;
		                   unsafe_set(dst, dst_pos + i | 0, src[i$1 + 1]);
		                   var b = i + 1 | 0;
		                   if(a === i) break;
		                   i = b;
		                  }
		                 }
		                 return;
		                }
		                a = len - 1 | 0;
		                if(a >= 0){
		                 var i$0 = a;
		                 for(;;){
		                  var i$2 = src_pos + i$0 | 0;
		                  unsafe_set(dst, dst_pos + i$0 | 0, src[i$2 + 1]);
		                  a = i$0 - 1 | 0;
		                  if(0 === i$0) break;
		                  i$0 = a;
		                 }
		                }
		               }
		               var
		                include$10 =
		                  function(Sequence){
		                    function create_like(len, param){
		                     return Sequence[2].call(null, len);
		                    }
		                    var
		                     length = Sequence[1],
		                     unsafe_blit = Sequence[3],
		                     include =
		                       Make_gen$0
		                        ([0, length], [0, length, create_like, unsafe_blit]),
		                     unsafe_blit$0 = include[1];
		                    return [0, , , unsafe_blit$0];
		                   }
		                   ([0, length$5, create_zero, unsafe_blit$0]),
		                unsafe_blit$1 = include$10[3];
		               function to_array$2(arr, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (init$6,
		                         arr.length - 1,
		                         function(i){return arr[i + 1];},
		                         cont);
		               }
		               var
		                include$292 =
		                  Of_sexpable1([0, , sexp_of_array], [0, to_array$2]),
		                sexp_of_t$6 = include$292[2],
		                empty$7 = [0];
		               function create_like$0(len, arr){
		                if(0 === len) return empty$7;
		                if(0 >= arr.length - 1)
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, fo], 1);
		                var x = get$3(arr, 0);
		                return create$12(len, x);
		               }
		               var
		                include$11 = bPV([0, create_like$0, length$5, unsafe_blit$1]),
		                blit$3 = include$11[1],
		                unsafe_blit$2 = include$11[3],
		                sub$1 = include$11[4];
		               function hash$9(t, cont){
		                var state = reset();
		                return cont
		                        (Base_internalhash_get_hash_value
		                          (Base_internalhash_fold_int(state, t)));
		               }
		               function sexp_of_t$7(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         fp,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a, t, function(a){return cont([0, a]);});
		                         });
		               }
		               function of_scalar_exn(i, cont){
		                if(int_is_scalar(i)) return cont(i);
		                return caml_exact_trampoline_cps_call
		                        (failwithf,
		                         fq,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, i, 0, cont);
		                         });
		               }
		               function to_binable$0(t, cont){return cont(t);}
		               function sexp_of_t$8(param, cont){
		                var arg1_014 = param[2], arg0_013 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int,
		                         arg0_013,
		                         function(res0_015){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_list,
		                                   sexp_of_t$8,
		                                   arg1_014,
		                                   function(res1_016){
		                                    return cont([1, [0, fr, [0, res0_015, [0, res1_016, 0]]]]);
		                                   });
		                         });
		               }
		               function sexp_of_t$9(param, A){return A[4];}
		               function same_witness(A, B, cont){
		                return caml_trampoline_cps_call2(A[6], B[5], cont);
		               }
		               function create$13(id_name, sexp_of_t, cont){
		                var
		                 key =
		                   [248,
		                    "Base__Type_equal.Id.Create0(T).T0",
		                    caml_fresh_oo_id()],
		                 id_sexp = [0, id_name];
		                return caml_exact_trampoline_cps_call
		                        (of_val,
		                         key,
		                         function(a){
		                          var uid = [0, hash(a), 0];
		                          function type_equal(otherkey, cont){
		                           return otherkey === key ? cont(fs) : cont(0);
		                          }
		                          var
		                           type_equal_id =
		                             [0, , uid, id_name, id_sexp, key, type_equal];
		                          return cont(type_equal_id);
		                         });
		               }
		               var none_substitute = caml_obj_block(251, 1);
		               function is_some$0(x){return 1 - (x === 24791911);}
		               function some$0(x){
		                return x === 24791911 ? none_substitute : x;
		               }
		               var none$1 = 24791911;
		               function value_unsafe(x){
		                return x === none_substitute ? none$1 : x;
		               }
		               function value_exn$0(x, cont){
		                return is_some$0(x)
		                        ? cont(value_unsafe(x))
		                        : caml_exact_trampoline_cps_call
		                          (failwith,
		                           "Option_array.get_some_exn: the element is [None]",
		                           cont);
		               }
		               function get_some_exn(arr, i, cont){
		                return caml_exact_trampoline_cps_call
		                        (value_exn$0, get$3(arr, i), cont);
		               }
		               function set_some(arr, i, x){
		                var x$0 = some$0(x);
		                return set$0(arr, i, x$0);
		               }
		               function create_like$1(len, param){return create$12(len, none$1);
		               }
		               var
		                blit =
		                  Make_gen$0
		                    ([0, length$5], [0, length$5, create_like$1, unsafe_blit$2])
		                   [2];
		               function create$14(param){return [0, 0, empty$7];}
		               function is_empty$1(t){return 0 === t[1] ? 1 : 0;}
		               function fold$1(t, init, f, cont){
		                var a = t[1] - 1 | 0;
		                function c(r){return cont(r);}
		                function b(r, i){
		                 return caml_exact_trampoline_cps_call$1
		                         (get_some_exn,
		                          t[2],
		                          i,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    r,
		                                    a,
		                                    function(a){
		                                     var d = i - 1 | 0;
		                                     return 0 !== i ? caml_exact_trampoline_call2(b, a, d) : c(a);
		                                    });
		                          });
		                }
		                return a < 0 ? c(init) : b(init, a);
		               }
		               var C = bQN([0, fold$1, [0], [0]]), to_list$2 = C[14];
		               function sexp_of_t$10(sexp_of_a, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_list$2,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_list, sexp_of_a, a, cont);
		                         });
		               }
		               function push(t, a, cont){
		                function b(){
		                 set_some(t[2], t[1], a);
		                 t[1] = t[1] + 1 | 0;
		                 return cont(0);
		                }
		                if(t[1] !== t[2].length - 1) return b();
		                var
		                 size = 2 * (t[1] + 1 | 0) | 0,
		                 arr = create$12(size, none$1);
		                return caml_exact_trampoline_cps_call$3
		                        (blit,
		                         t[2],
		                         0,
		                         arr,
		                         0,
		                         t[1],
		                         function(a){t[2] = arr; return b();});
		               }
		               var
		                pop_error =
		                  caml_callback(of_string$1, ["Stack.pop of empty stack"]);
		               function pop_exn(t, cont){
		                if(is_empty$1(t))
		                 return caml_exact_trampoline_cps_call(raise, pop_error, cont);
		                var i = t[1] - 1 | 0;
		                return caml_exact_trampoline_cps_call$1
		                        (get_some_exn,
		                         t[2],
		                         i,
		                         function(result){
		                          var arr = t[2];
		                          set$0(arr, i, none$1);
		                          t[1] = i;
		                          return cont(result);
		                         });
		               }
		               function bounds_crossed(lower, upper, compare, cont){
		                if(typeof lower === "number") return cont(0);
		                var lower$0 = lower[1];
		                if(typeof upper === "number") return cont(0);
		                var upper$0 = upper[1];
		                return caml_trampoline_cps_call3
		                        (compare,
		                         lower$0,
		                         upper$0,
		                         function(a){return cont(0 < a ? 1 : 0);});
		               }
		               function height(param){
		                if(typeof param === "number") return 0;
		                if(0 === param[0]) return 1;
		                var h = param[4];
		                return h;
		               }
		               function length$6(param){
		                if(typeof param === "number") return 0;
		                if(0 === param[0]) return 1;
		                var s = param[5];
		                return s;
		               }
		               function is_empty$2(param){
		                return typeof param === "number" ? 1 : 0;
		               }
		               function create$15(l, v, r){
		                var
		                 hl = height(l),
		                 hr = height(r),
		                 h = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
		                if(1 === h) return [0, v];
		                var sl = length$6(l), sr = length$6(r);
		                return [1, l, v, r, h, (sl + sr | 0) + 1 | 0];
		               }
		               function bal$0(l, v, r){
		                var hl = height(l), hr = height(r);
		                if((hr + 2 | 0) < hl){
		                 if(typeof l === "number")
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, ft], 1);
		                 if(0 === l[0])
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, fu], 1);
		                 var lr = l[3], lv = l[2], ll = l[1], a = height(lr);
		                 if(a <= height(ll))
		                  return create$15(ll, lv, create$15(lr, v, r));
		                 if(typeof lr === "number")
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, fv], 1);
		                 if(0 !== lr[0]){
		                  var
		                   lrr = lr[3],
		                   lrv$0 = lr[2],
		                   lrl = lr[1],
		                   a = create$15(lrr, v, r);
		                  return create$15(create$15(ll, lv, lrl), lrv$0, a);
		                 }
		                 var lrv = lr[1];
		                 if(! is_empty$2(ll))
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, fw], 1);
		                 a = create$15(0, v, r);
		                 return create$15(create$15(ll, lv, 0), lrv, a);
		                }
		                if((hl + 2 | 0) >= hr) return create$15(l, v, r);
		                if(typeof r === "number")
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, fx], 1);
		                if(0 === r[0])
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, fy], 1);
		                var rr = r[3], rv = r[2], rl = r[1], a = height(rl);
		                if(a <= height(rr))
		                 return create$15(create$15(l, v, rl), rv, rr);
		                if(typeof rl === "number")
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, fz], 1);
		                if(0 !== rl[0]){
		                 var
		                  rlr = rl[3],
		                  rlv$0 = rl[2],
		                  rll = rl[1],
		                  a = create$15(rlr, rv, rr);
		                 return create$15(create$15(l, v, rll), rlv$0, a);
		                }
		                var rlv = rl[1];
		                if(! is_empty$2(rr))
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, fA], 1);
		                a = create$15(0, rv, rr);
		                return create$15(create$15(l, v, 0), rlv, a);
		               }
		               var Same = [248, "Base__Set.Tree0.Same", caml_fresh_oo_id()];
		               function add$3(t, x, compare_elt, cont){
		                function aux(param, cont){
		                 if(typeof param === "number") return cont([0, x]);
		                 if(0 === param[0]){
		                  var v = param[1];
		                  return caml_trampoline_cps_call3
		                          (compare_elt,
		                           x,
		                           v,
		                           function(c){
		                            return 0 === c
		                                    ? cont(raise_without_backtrace(Same))
		                                    : 0
		                                      <= c
		                                      ? cont(create$15(0, v, [0, x]))
		                                      : cont(create$15([0, x], v, 0));
		                           });
		                 }
		                 var r = param[3], v$0 = param[2], l = param[1];
		                 return caml_trampoline_cps_call3
		                         (compare_elt,
		                          x,
		                          v$0,
		                          function(c){
		                           return 0 === c
		                                   ? cont(raise_without_backtrace(Same))
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_cps_call
		                                       (aux, r, function(a){return cont(bal$0(l, v$0, a));})
		                                     : caml_exact_trampoline_cps_call
		                                       (aux, l, function(a){return cont(bal$0(a, v$0, r));});
		                          });
		                }
		                caml_push_trap
		                 (function(exn){
		                   if(exn === Same) return cont(t);
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (aux, t, function(a){caml_pop_trap(); return cont(a);});
		               }
		               function add_min(x, t){
		                if(typeof t === "number") return [0, x];
		                if(0 === t[0]) return [1, 0, x, t, 2, 2];
		                var r = t[3], v = t[2], l = t[1];
		                return bal$0(add_min(x, l), v, r);
		               }
		               function add_max(t, x){
		                if(typeof t === "number") return [0, x];
		                if(0 === t[0]) return [1, t, x, 0, 2, 2];
		                var r = t[3], v = t[2], l = t[1];
		                return bal$0(l, v, add_max(r, x));
		               }
		               function join$0(l, v, r){
		                if(typeof l === "number") return add_min(v, r);
		                if(0 !== l[0]){
		                 var lh = l[4], lr = l[3], lv$0 = l[2], ll = l[1];
		                 if(typeof r !== "number"){
		                  if(0 === r[0]){
		                   var rv = r[1];
		                   return add_max(add_max(l, v), rv);
		                  }
		                  var rh = r[4], rr = r[3], rv$0 = r[2], rl = r[1];
		                  return (rh + 2 | 0) < lh
		                          ? bal$0(ll, lv$0, join$0(lr, v, r))
		                          : (lh
		                            + 2
		                            | 0)
		                            < rh
		                            ? bal$0(join$0(l, v, rl), rv$0, rr)
		                            : create$15(l, v, r);
		                 }
		                }
		                if(typeof r === "number") return add_max(l, v);
		                var lv = l[1];
		                return add_min(lv, add_min(v, r));
		               }
		               function min_elt$0(a){
		                for(;;){
		                 if(typeof a === "number") return 0;
		                 if(0 === a[0])
		                  var v = a[1];
		                 else {
		                  var l = a[1];
		                  if(typeof l !== "number"){a = l; continue;}
		                  v = a[2];
		                 }
		                 return [0, v];
		                }
		               }
		               var
		                Set_min_elt_exn_of_empty_set =
		                  [248,
		                   "Base__Set.Tree0.Set_min_elt_exn_of_empty_set",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Set_min_elt_exn_of_empty_set,
		                  function(param, a){
		                   if(param === Set_min_elt_exn_of_empty_set) return a(fB);
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, fC], 1));
		                  }]);
		               var
		                Set_max_elt_exn_of_empty_set =
		                  [248,
		                   "Base__Set.Tree0.Set_max_elt_exn_of_empty_set",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Set_max_elt_exn_of_empty_set,
		                  function(param, a){
		                   if(param === Set_max_elt_exn_of_empty_set) return a(fD);
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, fE], 1));
		                  }]);
		               function min_elt_exn(t){
		                var match = min_elt$0(t);
		                if(! match)
		                 throw caml_maybe_attach_backtrace
		                        (Set_min_elt_exn_of_empty_set, 1);
		                var v = match[1];
		                return v;
		               }
		               function max_elt$0(a){
		                for(;;){
		                 if(typeof a === "number") return 0;
		                 if(0 === a[0])
		                  var v = a[1];
		                 else {
		                  if(typeof a[3] !== "number"){var r = a[3]; a = r; continue;}
		                  v = a[2];
		                 }
		                 return [0, v];
		                }
		               }
		               function remove_min_elt(param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, "Set.remove_min_elt", cont);
		                if(0 === param[0]) return cont(0);
		                var l = param[1];
		                if(typeof l === "number"){var r = param[3]; return cont(r);}
		                var r$0 = param[3], v = param[2];
		                return caml_exact_trampoline_cps_call
		                        (remove_min_elt,
		                         l,
		                         function(a){return cont(bal$0(a, v, r$0));});
		               }
		               function merge(t1, t2, cont){
		                return typeof t1 === "number"
		                        ? cont(t2)
		                        : typeof
		                          t2
		                          === "number"
		                          ? cont(t1)
		                          : caml_exact_trampoline_cps_call
		                            (remove_min_elt,
		                             t2,
		                             function(a){return cont(bal$0(t1, min_elt_exn(t2), a));});
		               }
		               function concat$2(t1, t2, cont){
		                if(typeof t1 === "number")
		                 var t = t2;
		                else {
		                 if(typeof t2 !== "number")
		                  return caml_exact_trampoline_cps_call
		                          (remove_min_elt,
		                           t2,
		                           function(a){return cont(join$0(t1, min_elt_exn(t2), a));});
		                 t = t1;
		                }
		                return cont(t);
		               }
		               function split$1(t, x, compare_elt, cont){
		                function split(t, cont){
		                 if(typeof t === "number") return cont(fF);
		                 if(0 === t[0]){
		                  var v = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_elt,
		                           x,
		                           v,
		                           function(c){
		                            return 0 === c
		                                    ? cont([0, 0, [0, v], 0])
		                                    : 0 <= c ? cont([0, [0, v], 0, 0]) : cont([0, 0, 0, [0, v]]);
		                           });
		                 }
		                 var r = t[3], v$0 = t[2], l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_elt,
		                          x,
		                          v$0,
		                          function(c){
		                           return 0 === c
		                                   ? cont([0, l, [0, v$0], r])
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_cps_call
		                                       (split,
		r,
		function(match){
		 var rr = match[3], maybe_elt = match[2], lr = match[1];
		 return cont([0, join$0(l, v$0, lr), maybe_elt, rr]);
		})
		                                     : caml_exact_trampoline_cps_call
		                                       (split,
		l,
		function(match){
		 var rl = match[3], maybe_elt = match[2], ll = match[1];
		 return cont([0, ll, maybe_elt, join$0(rl, v$0, r)]);
		});
		                          });
		                }
		                return caml_exact_trampoline_cps_call(split, t, cont);
		               }
		               function mem$2(t, x, compare_elt, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var v = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_elt,
		                           x,
		                           v,
		                           function(c){return cont(0 === c ? 1 : 0);});
		                 }
		                 var r = t[3], v$0 = t[2], l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_elt,
		                          x,
		                          v$0,
		                          function(c){
		                           var b = 0 === c ? 1 : 0;
		                           return b
		                                   ? cont(b)
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_call1(a, r)
		                                     : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                return a(t);
		               }
		               function remove(t, x, compare_elt, cont){
		                function aux(t, cont){
		                 if(typeof t === "number")
		                  return cont(raise_without_backtrace(Same));
		                 if(0 === t[0]){
		                  var v = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_elt,
		                           x,
		                           v,
		                           function(a){
		                            return 0 === a
		                                    ? cont(0)
		                                    : cont(raise_without_backtrace(Same));
		                           });
		                 }
		                 var r = t[3], v$0 = t[2], l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_elt,
		                          x,
		                          v$0,
		                          function(c){
		                           return 0 === c
		                                   ? caml_exact_trampoline_cps_call$1(merge, l, r, cont)
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_cps_call
		                                       (aux, r, function(a){return cont(bal$0(l, v$0, a));})
		                                     : caml_exact_trampoline_cps_call
		                                       (aux, l, function(a){return cont(bal$0(a, v$0, r));});
		                          });
		                }
		                caml_push_trap
		                 (function(exn){
		                   if(exn === Same) return cont(t);
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (aux, t, function(a){caml_pop_trap(); return cont(a);});
		               }
		               function union(s1, s2, compare_elt, cont){
		                function union(s1$0, s2$0, cont){
		                 var s1 = s1$0, s2 = s2$0;
		                 for(;;){
		                  if(s1 === s2) return cont(s1);
		                  if(typeof s1 === "number")
		                   var t = s2;
		                  else {
		                   if(0 !== s1[0]){
		                    var h1 = s1[4], r1 = s1[3], v1$0 = s1[2], l1 = s1[1];
		                    if(typeof s2 !== "number"){
		                     if(0 !== s2[0]) break;
		                     var v2 = s2[1];
		                     s2 = [1, 0, v2, 0, 1, 1];
		                     continue;
		                    }
		                   }
		                   if(typeof s2 !== "number"){
		                    var v1 = s1[1];
		                    s1 = [1, 0, v1, 0, 1, 1];
		                    continue;
		                   }
		                   t = s1;
		                  }
		                  return cont(t);
		                 }
		                 var h2 = s2[4], r2 = s2[3], v2$0 = s2[2], l2 = s2[1];
		                 return h2 <= h1
		                         ? 1
		                           === h2
		                           ? caml_exact_trampoline_cps_call$0
		                             (add$3, s1, v2$0, compare_elt, cont)
		                           : caml_exact_trampoline_cps_call$0
		                             (split$1,
		                              s2,
		                              v1$0,
		                              compare_elt,
		                              function(match){
		                               var r2 = match[3], l2 = match[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (union,
		r1,
		r2,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (union,
		          l1,
		          l2,
		          function(b){return cont(join$0(b, v1$0, a));});
		});
		                              })
		                         : 1
		                           === h1
		                           ? caml_exact_trampoline_cps_call$0
		                             (add$3, s2, v1$0, compare_elt, cont)
		                           : caml_exact_trampoline_cps_call$0
		                             (split$1,
		                              s1,
		                              v2$0,
		                              compare_elt,
		                              function(match){
		                               var r1 = match[3], l1 = match[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (union,
		r1,
		r2,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (union,
		          l1,
		          l2,
		          function(b){return cont(join$0(b, v2$0, a));});
		});
		                              });
		                }
		                return caml_exact_trampoline_cps_call$1(union, s1, s2, cont);
		               }
		               function cons$0(s$0, e$1){
		                var s = s$0, e = e$1;
		                for(;;){
		                 if(typeof s === "number") return e;
		                 if(0 === s[0]){var v = s[1]; return [0, v, 0, e];}
		                 var r = s[3], v$0 = s[2], l = s[1], e$0 = [0, v$0, r, e];
		                 s = l;
		                 e = e$0;
		                }
		               }
		               function cons_right(s$0, e$1){
		                var s = s$0, e = e$1;
		                for(;;){
		                 if(typeof s === "number") return e;
		                 if(0 === s[0]){var v = s[1]; return [0, v, 0, e];}
		                 var r = s[3], v$0 = s[2], l = s[1], e$0 = [0, v$0, l, e];
		                 s = r;
		                 e = e$0;
		                }
		               }
		               function of_set(s){return cons$0(s, 0);}
		               function symmetric_diff(t1, t2, compare_elt){
		                function step(state, cont){
		                 var left = state[1];
		                 if(left){
		                  var
		                   right = state[2],
		                   enum$ = left[3],
		                   tree = left[2],
		                   elt = left[1];
		                  if(! right)
		                   return cont([1, [0, elt], [0, cons$0(tree, enum$), 0]]);
		                  var enum2 = right[3], tree2 = right[2], a2 = right[1];
		                  return caml_trampoline_cps_call3
		                          (compare_elt,
		                           elt,
		                           a2,
		                           function(compare_result){
		                            if(0 !== compare_result)
		                             return 0 <= compare_result
		                                     ? cont([1, [1, a2], [0, left, cons$0(tree2, enum2)]])
		                                     : cont([1, [0, elt], [0, cons$0(tree, enum$), right]]);
		                            if(tree === tree2)
		                             var next_state = [0, enum$, enum2];
		                            else
		                             var
		                              a = cons$0(tree2, enum2),
		                              next_state = [0, cons$0(tree, enum$), a];
		                            return cont([0, next_state]);
		                           });
		                 }
		                 var match = state[2];
		                 if(! match) return cont(0);
		                 var enum$0 = match[3], tree$0 = match[2], elt$0 = match[1];
		                 return cont([1, [1, elt$0], [0, 0, cons$0(tree$0, enum$0)]]);
		                }
		                var a = of_set(t2), init = [0, of_set(t1), a];
		                return [0, init, step];
		               }
		               function to_sequence
		               (comparator,
		                opt,
		                greater_or_equal_to,
		                less_or_equal_to,
		                init,
		                cont){
		                var order = opt ? opt[1] : 608542111;
		                if(608542111 <= order){
		                 var
		                  a =
		                    function(t){
		                     function next(enum$, cont){
		                      if(! enum$) return cont(0);
		                      var e = enum$[3], t = enum$[2], k = enum$[1];
		                      return cont([1, k, cons$0(t, e)]);
		                     }
		                     function b(init){return cont([0, init, next]);}
		                     if(! greater_or_equal_to) return b(of_set(t));
		                     var key = greater_or_equal_to[1], compare = comparator[1];
		                     function a(t, e){
		                      if(typeof t === "number") return b(e);
		                      if(0 === t[0]){
		                       var v = t[1];
		                       return caml_exact_trampoline_call2(a, [1, 0, v, 0, 1, 1], e);
		                      }
		                      var l = t[1], r = t[3], v$0 = t[2];
		                      return caml_trampoline_cps_call3
		                              (compare,
		                               v$0,
		                               key,
		                               function(b){
		                                if(0 > b) return caml_exact_trampoline_call2(a, r, e);
		                                var r$0 = t[3], v = t[2], e$0 = [0, v, r$0, e];
		                                return caml_exact_trampoline_call2(a, l, e$0);
		                               });
		                     }
		                     return a(t, 0);
		                    };
		                 if(! less_or_equal_to) return a(init);
		                 var bound = less_or_equal_to[1], compare_elt = comparator[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (split$1,
		                          init,
		                          bound,
		                          compare_elt,
		                          function(match){
		                           var maybe = match[2], l = match[1];
		                           if(! maybe) return a(l);
		                           var elt = maybe[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (add$3, l, elt, compare_elt, a);
		                          });
		                }
		                function b(t){
		                 function next(enum$, cont){
		                  if(! enum$) return cont(0);
		                  var e = enum$[3], t = enum$[2], k = enum$[1];
		                  return cont([1, k, cons_right(t, e)]);
		                 }
		                 function b(init){return cont([0, init, next]);}
		                 if(! less_or_equal_to) return b(cons_right(t, 0));
		                 var key = less_or_equal_to[1], compare = comparator[1];
		                 function a(t, e){
		                  if(typeof t === "number") return b(e);
		                  if(0 === t[0]){
		                   var v = t[1];
		                   return caml_exact_trampoline_call2(a, [1, 0, v, 0, 1, 1], e);
		                  }
		                  var l = t[1], v$0 = t[2];
		                  return caml_trampoline_cps_call3
		                          (compare,
		                           v$0,
		                           key,
		                           function(b){
		                            if(0 < b) return caml_exact_trampoline_call2(a, l, e);
		                            var r = t[3], v = t[2], e$0 = [0, v, l, e];
		                            return caml_exact_trampoline_call2(a, r, e$0);
		                           });
		                 }
		                 return a(t, 0);
		                }
		                if(! greater_or_equal_to) return b(init);
		                var
		                 bound$0 = greater_or_equal_to[1],
		                 compare_elt$0 = comparator[1];
		                return caml_exact_trampoline_cps_call$0
		                        (split$1,
		                         init,
		                         bound$0,
		                         compare_elt$0,
		                         function(match){
		                          var r = match[3], maybe = match[2];
		                          if(! maybe) return b(r);
		                          var elt = maybe[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (add$3, r, elt, compare_elt$0, b);
		                         });
		               }
		               function compare$15(compare_elt, s1, s2, cont){
		                var e2 = of_set(s2), e1 = of_set(s1);
		                function a(e1, e2){
		                 if(! e1) return e2 ? cont(-1) : cont(0);
		                 if(! e2) return cont(1);
		                 var
		                  e2$0 = e2[3],
		                  r2 = e2[2],
		                  v2 = e2[1],
		                  e1$0 = e1[3],
		                  r1 = e1[2],
		                  v1 = e1[1];
		                 return caml_trampoline_cps_call3
		                         (compare_elt,
		                          v1,
		                          v2,
		                          function(c){
		                           if(0 !== c) return cont(c);
		                           if(r1 === r2)
		                            return caml_exact_trampoline_call2(a, e1$0, e2$0);
		                           var e2 = cons$0(r2, e2$0), e1 = cons$0(r1, e1$0);
		                           return caml_exact_trampoline_call2(a, e1, e2);
		                          });
		                }
		                return a(e1, e2);
		               }
		               function equal$8(s1, s2, compare_elt, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (compare$15,
		                         compare_elt,
		                         s1,
		                         s2,
		                         function(a){return cont(0 === a ? 1 : 0);});
		               }
		               function iter$2(t, f, cont){
		                function iter(param, cont){
		                 function a(param){
		                  if(typeof param === "number") return cont(0);
		                  if(0 === param[0]){
		                   var v = param[1];
		                   return caml_exact_trampoline_cps_call(f, v, cont);
		                  }
		                  var r = param[3], v$0 = param[2], l = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (iter,
		                           l,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (f,
		                                     v$0,
		                                     function(b){return caml_exact_trampoline_call1(a, r);});
		                           });
		                 }
		                 return a(param);
		                }
		                return caml_exact_trampoline_cps_call(iter, t, cont);
		               }
		               function fold$2(s, accu, f, cont){
		                function a(s, accu){
		                 if(typeof s === "number") return cont(accu);
		                 if(0 === s[0]){
		                  var v = s[1];
		                  return caml_exact_trampoline_cps_call$1(f, accu, v, cont);
		                 }
		                 var r = s[3], v$0 = s[2], l = s[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (fold$2,
		                          l,
		                          accu,
		                          f,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    b,
		                                    v$0,
		                                    function(accu){
		                                     return caml_exact_trampoline_call2(a, r, accu);
		                                    });
		                          });
		                }
		                return a(s, accu);
		               }
		               function fold_right$1(s, accu, f, cont){
		                function a(s, accu){
		                 if(typeof s === "number") return cont(accu);
		                 if(0 === s[0]){
		                  var v = s[1];
		                  return caml_exact_trampoline_cps_call$1(f, v, accu, cont);
		                 }
		                 var r = s[3], v$0 = s[2], l = s[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (fold_right$1,
		                          r,
		                          accu,
		                          f,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    v$0,
		                                    b,
		                                    function(accu){
		                                     return caml_exact_trampoline_call2(a, l, accu);
		                                    });
		                          });
		                }
		                return a(s, accu);
		               }
		               function filter$2(s, p, cont){
		                function filt(t, cont){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var v = t[1];
		                  return caml_trampoline_cps_call2
		                          (p, v, function(a){return a ? cont(t) : cont(0);});
		                 }
		                 var r = t[3], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call
		                         (filt,
		                          l,
		                          function(l$0){
		                           return caml_trampoline_cps_call2
		                                   (p,
		                                    v$0,
		                                    function(keep_v){
		                                     return caml_exact_trampoline_cps_call
		     (filt,
		      r,
		      function(r$0){
		       if(keep_v && l === l$0 && r === r$0) return cont(t);
		       return keep_v
		               ? cont(join$0(l$0, v$0, r$0))
		               : caml_exact_trampoline_cps_call$1(concat$2, l$0, r$0, cont);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call(filt, s, cont);
		               }
		               function partition_tf(s, p, cont){
		                function loop(t, cont){
		                 if(typeof t === "number") return cont(fG);
		                 if(0 === t[0]){
		                  var v = t[1];
		                  return caml_exact_trampoline_cps_call
		                          (p,
		                           v,
		                           function(a){return a ? cont([0, t, 0]) : cont([0, 0, t]);});
		                 }
		                 var r = t[3], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call
		                         (loop,
		                          l,
		                          function(match){
		                           var l_f = match[2], l_t = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (p,
		                                    v$0,
		                                    function(keep_v_t){
		                                     return caml_exact_trampoline_cps_call
		     (loop,
		      r,
		      function(match){
		       var r_f = match[2], r_t = match[1];
		       function mk(keep_v, l$0, r$0, cont){
		        if(keep_v && l === l$0 && r === r$0) return cont(t);
		        return keep_v
		                ? cont(join$0(l$0, v$0, r$0))
		                : caml_exact_trampoline_cps_call$1(concat$2, l$0, r$0, cont);
		       }
		       return caml_exact_trampoline_cps_call$0
		               (mk,
		                1 - keep_v_t,
		                l_f,
		                r_f,
		                function(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (mk,
		                          keep_v_t,
		                          l_t,
		                          r_t,
		                          function(b){return cont([0, b, a]);});
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call(loop, s, cont);
		               }
		               function elements_aux(accu$1, a){
		                var accu = accu$1;
		                for(;;){
		                 if(typeof a === "number") return accu;
		                 if(0 === a[0]){var v = a[1]; return [0, v, accu];}
		                 var
		                  r = a[3],
		                  v$0 = a[2],
		                  l = a[1],
		                  accu$0 = [0, v$0, elements_aux(accu, r)];
		                 accu = accu$0;
		                 a = l;
		                }
		               }
		               function elements(s){return elements_aux(0, s);}
		               var empty_without_value_restrictio = 0;
		               function of_list$0(lst, compare_elt, cont){
		                function a(t, init){
		                 if(! t) return cont(init);
		                 var l = t[2], a$0 = t[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (add$3,
		                          init,
		                          a$0,
		                          compare_elt,
		                          function(init){
		                           return caml_exact_trampoline_call2(a, l, init);
		                          });
		                }
		                return a(lst, empty_without_value_restrictio);
		               }
		               function of_sequence(sequence, compare_elt, cont){
		                var next = sequence[2], seed = sequence[1];
		                function a(seed, v){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          seed,
		                          function(match){
		                           if(typeof match === "number") return cont(v);
		                           if(0 === match[0]){
		                            var seed = match[1];
		                            return caml_exact_trampoline_call2(a, seed, v);
		                           }
		                           var seed$0 = match[2], a$0 = match[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (add$3,
		                                    v,
		                                    a$0,
		                                    compare_elt,
		                                    function(v){
		                                     return caml_exact_trampoline_call2(a, seed$0, v);
		                                    });
		                          });
		                }
		                return a(seed, empty_without_value_restrictio);
		               }
		               function sexp_of_t$11(sexp_of_a, t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$1,
		                         t,
		                         0,
		                         function(el, acc, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_a, el, function(a){return cont([0, a, acc]);});
		                         },
		                         function(a){return cont([1, a]);});
		               }
		               function like(param, tree){
		                var comparator = param[1];
		                return [0, comparator, tree];
		               }
		               function like_maybe_no_op(old_t, tree){
		                var old_tree = old_t[2], comparator = old_t[1];
		                return old_tree === tree ? old_t : [0, comparator, tree];
		               }
		               function compare_elt(t){return t[1][1];}
		               function length$7(t){return length$6(t[2]);}
		               function is_empty$3(t){return is_empty$2(t[2]);}
		               function min_elt$1(t){return min_elt$0(t[2]);}
		               function max_elt$1(t){return max_elt$0(t[2]);}
		               function to_list$3(t, cont){
		                var s = t[2];
		                return cont(elements(s));
		               }
		               function fold$3(t, init, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$2, t[2], init, f, cont);
		               }
		               function iter$3(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(iter$2, t[2], f, cont);
		               }
		               function mem$3(t, a, cont){
		                var b = compare_elt(t);
		                return caml_exact_trampoline_cps_call$0
		                        (mem$2, t[2], a, b, cont);
		               }
		               function filter$3(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter$2,
		                         t[2],
		                         f,
		                         function(a){return cont(like_maybe_no_op(t, a));});
		               }
		               function add$4(t, a, cont){
		                var b = compare_elt(t);
		                return caml_exact_trampoline_cps_call$0
		                        (add$3, t[2], a, b, function(a){return cont(like(t, a));});
		               }
		               function remove$0(t, a, cont){
		                var b = compare_elt(t);
		                return caml_exact_trampoline_cps_call$0
		                        (remove, t[2], a, b, function(a){return cont(like(t, a));});
		               }
		               function union$0(t1, t2, cont){
		                var a = compare_elt(t1);
		                return caml_exact_trampoline_cps_call$0
		                        (union,
		                         t1[2],
		                         t2[2],
		                         a,
		                         function(a){return cont(like(t1, a));});
		               }
		               function symmetric_diff$0(t1, t2){
		                var a = compare_elt(t1);
		                return symmetric_diff(t1[2], t2[2], a);
		               }
		               function equal$9(t1, t2, cont){
		                var a = compare_elt(t1);
		                return caml_exact_trampoline_cps_call$0
		                        (equal$8, t1[2], t2[2], a, cont);
		               }
		               function partition_tf$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partition_tf,
		                         t[2],
		                         f,
		                         function(a){
		                          var
		                           tree_f = a[2],
		                           tree_t = a[1],
		                           a = like_maybe_no_op(t, tree_f);
		                          return cont([0, like_maybe_no_op(t, tree_t), a]);
		                         });
		               }
		               function sexp_of_t$12(sexp_of_a, param, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$11, sexp_of_a, t[2], cont);
		               }
		               function to_sequence$0
		               (order, greater_or_equal_to, less_or_equal_to, t, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (to_sequence,
		                         t[1],
		                         order,
		                         greater_or_equal_to,
		                         less_or_equal_to,
		                         t[2],
		                         cont);
		               }
		               function Empty_without_value_restrictio(Elt){}
		               function singleton$0(comparator, e){return [0, comparator, [0, e]];
		               }
		               function of_list$1(comparator, l, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_list$0,
		                         l,
		                         comparator[1],
		                         function(a){return cont([0, comparator, a]);});
		               }
		               function of_sequence$0(comparator, s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence,
		                         s,
		                         comparator[1],
		                         function(a){return cont([0, comparator, a]);});
		               }
		               function empty$8(m){
		                var comparator = m[1];
		                return [0, comparator, empty_without_value_restrictio];
		               }
		               function singleton$1(m, a){return singleton$0(m[1], a);}
		               function of_list$2(m, a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_list$1, m[1], a, cont);
		               }
		               function sexp_of_m_t(Elt, t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (sexp_of_t$12, Elt[1], dummy, t, cont);
		               }
		               function unreachable_code(x, a){
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Match_failure, fH], 1));
		               }
		               function compare$16(a, param, cont){
		                return caml_exact_trampoline_cps_call
		                        (unreachable_code, dummy, cont);
		               }
		               var
		                include$12 =
		                  bO_
		                   ([0,
		                     compare$16,
		                     ,
		                     unreachable_code,
		                     ,
		                     unreachable_code,
		                     ,
		                     unreachable_code]),
		                hash$10 = include$12[2],
		                sexp_of_t$13 = include$12[4],
		                hashable$3 = include$12[24];
		               function hash$11(x, cont){return cont(hash_nativeint(x));}
		               var
		                include$13 = Make$3([0, nativeint_to_string]),
		                sexp_of_nativeint$0 = include$13[2],
		                num_bits$0 = num_bits();
		               lower_bound_for_int(num_bits$0);
		               upper_bound_for_int(num_bits$0);
		               function shift_right$1(b, a){return b >> a;}
		               function shift_left$0(b, a){return b << a;}
		               function rem$0(b, a){return caml_mod(b, a);}
		               function symbol$25(b, a){return caml_div(b, a);}
		               function symbol$26(b, a){return b - a | 0;}
		               function symbol$27(b, a){return b + a | 0;}
		               var zero = 0;
		               caml_callback
		                (bO$,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   nativeint_to_string,
		                   symbol$27,
		                   symbol$26,
		                   ,
		                   symbol$25,
		                   ,
		                   ,
		                   symbol$2,
		                   ,
		                   ,
		                   symbol$1,
		                   ,
		                   ,
		                   ,
		                   zero,
		                   int_to_nativeint,
		                   rem$0]]);
		               var
		                Duplicate = [248, "Base__Map.Duplicate", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Duplicate,
		                  function(param, a){
		                   if(param === Duplicate) return a(fI);
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, fJ], 1));
		                  }]);
		               function globalize(param){
		                var length = param[2], tree = param[1];
		                return [0, tree, length];
		               }
		               function height$0(param){
		                if(typeof param === "number") return 0;
		                if(0 === param[0]) return 1;
		                var h = param[5];
		                return h;
		               }
		               function in_range(lower, upper, compare_key, k, cont){
		                function a(a){
		                 if(a){
		                  if(upper){
		                   var upper$0 = upper[1];
		                   return caml_trampoline_cps_call3
		                           (compare_key,
		                            k,
		                            upper$0,
		                            function(a){return cont(a < 0 ? 1 : 0);});
		                  }
		                  a = 1;
		                 }
		                 return cont(a);
		                }
		                if(! lower) return a(1);
		                var lower$0 = lower[1];
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         lower$0,
		                         k,
		                         function(b){return a(b < 0 ? 1 : 0);});
		               }
		               function loop(lower, upper, compare_key, t, cont){
		                function a(lower, t){
		                 if(typeof t === "number") return cont(1);
		                 if(0 === t[0]){
		                  var k = t[1];
		                  return caml_exact_trampoline_cps_call$2
		                          (in_range, lower, upper, compare_key, k, cont);
		                 }
		                 var
		                  h = t[5],
		                  r = t[4],
		                  k$0 = t[2],
		                  l = t[1],
		                  hl = height$0(l),
		                  hr = height$0(r),
		                  c = stdlib_abs(hl - hr | 0) <= 2 ? 1 : 0;
		                 function b(a){return cont(a);}
		                 return c
		                         ? caml_exact_trampoline_cps_call$1
		                           (max$2,
		                            hl,
		                            hr,
		                            function(c){
		                             c = h === (c + 1 | 0) ? 1 : 0;
		                             return c
		                                     ? caml_exact_trampoline_cps_call$2
		                                       (in_range,
		lower,
		upper,
		compare_key,
		k$0,
		function(c){
		 return c
		         ? caml_exact_trampoline_cps_call$2
		           (loop,
		            lower,
		            [0, k$0],
		            compare_key,
		            l,
		            function(c){
		             if(! c) return b(c);
		             return caml_exact_trampoline_call2(a, [0, k$0], r);
		            })
		         : b(c);
		})
		                                     : b(c);
		                            })
		                         : b(c);
		                }
		                return a(lower, t);
		               }
		               function invariants(t, compare_key, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (loop, 0, 0, compare_key, t, cont);
		               }
		               function create_with_heights(hl, hr, l, x, d, r){
		                if(0 === hl && 0 === hr) return [0, x, d];
		                var a = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
		                return [1, l, x, d, r, a];
		               }
		               function create$16(l, x, d, r){
		                var a = height$0(r);
		                return create_with_heights(height$0(l), a, l, x, d, r);
		               }
		               function of_increasing_iterator_uncheck(len, f, cont){
		                function loop(n, f, i, cont){
		                 if(3 >= n >>> 0)
		                  switch(n){
		                    case 0:
		                     return cont(0);
		                    case 1:
		                     return caml_trampoline_cps_call2
		                             (f,
		                              i,
		                              function(match){
		                               var v = match[2], k = match[1];
		                               return cont([0, k, v]);
		                              });
		                    case 2:
		                     return caml_trampoline_cps_call2
		                             (f,
		                              i,
		                              function(match){
		                               var vl = match[2], kl = match[1];
		                               return caml_trampoline_cps_call2
		                                       (f,
		i + 1 | 0,
		function(match){
		 var v = match[2], k = match[1];
		 return cont([1, [0, kl, vl], k, v, 0, 2]);
		});
		                              });
		                    default:
		                     return caml_trampoline_cps_call2
		                             (f,
		                              i,
		                              function(match){
		                               var vl = match[2], kl = match[1];
		                               return caml_trampoline_cps_call2
		                                       (f,
		i + 1 | 0,
		function(match){
		 var v = match[2], k = match[1];
		 return caml_trampoline_cps_call2
		         (f,
		          i + 2 | 0,
		          function(match){
		           var vr = match[2], kr = match[1];
		           return cont([1, [0, kl, vl], k, v, [0, kr, vr], 2]);
		          });
		});
		                              });
		                  }
		                 var
		                  left_length = n >>> 1 | 0,
		                  right_length = (n - left_length | 0) - 1 | 0;
		                 return caml_exact_trampoline_cps_call$0
		                         (loop,
		                          left_length,
		                          f,
		                          i,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    i + left_length | 0,
		                                    function(match){
		                                     var v = match[2], k = match[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (loop,
		      right_length,
		      f,
		      (i + left_length | 0) + 1 | 0,
		      function(right){return cont(create$16(left, k, v, right));});
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0(loop, len, f, 0, cont);
		               }
		               function of_sorted_array_unchecked(array, compare_key, cont){
		                var array_length = array.length - 1;
		                function b(next){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_increasing_iterator_uncheck,
		                          array_length,
		                          next,
		                          function(tree){return cont([0, tree, array_length]);});
		                }
		                function a(){
		                 return b
		                         (function(i, cont){
		                           return cont(caml_check_bound(array, i)[i + 1]);
		                          });
		                }
		                if(2 > array_length) return a();
		                var
		                 k0 = caml_check_bound(array, 0)[1][1],
		                 k1 = caml_check_bound(array, 1)[2][1];
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         k0,
		                         k1,
		                         function(c){
		                          return c < 0
		                                  ? a()
		                                  : b
		                                    (function(i, cont){
		                                      var a = (array_length - 1 | 0) - i | 0;
		                                      return cont(caml_check_bound(array, a)[a + 1]);
		                                     });
		                         });
		               }
		               function of_sorted_array(array, compare_key, cont){
		                var len = array.length - 1;
		                if(1 !== len && len)
		                 return caml_exact_trampoline_cps_call
		                         (with_return,
		                          function(r, cont){
		                           var a = caml_check_bound(array, 1)[2][1];
		                           return caml_trampoline_cps_call3
		                                   (compare_key,
		                                    caml_check_bound(array, 0)[1][1],
		                                    a,
		                                    function(i){
		                                     var
		                                      cst_of_sorted_array_duplicated =
		"of_sorted_array: duplicated elements";
		                                     function a(increasing){
		                                      var a = array.length - 3 | 0;
		                                      function c(){
		                                       return caml_exact_trampoline_cps_call$1
		       (of_sorted_array_unchecked,
		        array,
		        compare_key,
		        function(a){return cont([0, globalize(a)]);});
		                                      }
		                                      function b(i){
		                                       var d = i + 1 | 0, d = caml_check_bound(array, d)[d + 1][1];
		                                       return caml_trampoline_cps_call3
		       (compare_key,
		        caml_check_bound(array, i)[i + 1][1],
		        d,
		        function(i$0){
		         function d(d){
		          d = i + 1 | 0;
		          return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		         }
		         return 0 === i$0
		                 ? caml_exact_trampoline_cps_call
		                   (error_string,
		                    cst_of_sorted_array_duplicated,
		                    function(a){return caml_exact_trampoline_cps_call(r, a, d);})
		                 : (i$0
		                     < 0
		                     ? 1
		                     : 0)
		                   !== increasing
		                   ? caml_exact_trampoline_cps_call
		                     (error_string,
		                      "of_sorted_array: elements are not ordered",
		                      function(a){return caml_exact_trampoline_cps_call(r, a, d);})
		                   : d(0);
		        });
		                                      }
		                                      return a < 1 ? c() : b(1);
		                                     }
		                                     return 0 === i
		     ? caml_exact_trampoline_cps_call
		       (error_string,
		        cst_of_sorted_array_duplicated,
		        function(b){return caml_exact_trampoline_cps_call(r, b, a);})
		     : a(i < 0 ? 1 : 0);
		                                    });
		                          },
		                          cont);
		                return caml_exact_trampoline_cps_call$1
		                        (of_sorted_array_unchecked,
		                         array,
		                         compare_key,
		                         function(a){return cont([0, globalize(a)]);});
		               }
		               function bal$1(l, x, d, r, a){
		                var hl = height$0(l), hr = height$0(r);
		                if((hr + 2 | 0) < hl){
		                 if(typeof l === "number")
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg, cst_Map_bal, a);
		                 if(0 === l[0]){
		                  a = caml_pop_trap();
		                  return a
		                          (caml_maybe_attach_backtrace([0, Assert_failure, fK], 1));
		                 }
		                 var
		                  lr = l[4],
		                  ld = l[3],
		                  lv = l[2],
		                  ll = l[1],
		                  b = height$0(lr);
		                 if(b <= height$0(ll))
		                  return a(create$16(ll, lv, ld, create$16(lr, x, d, r)));
		                 if(typeof lr === "number")
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg, cst_Map_bal, a);
		                 if(0 === lr[0]){
		                  var lrd = lr[2], lrv = lr[1], b = create$16(0, x, d, r);
		                  return a(create$16(create$16(ll, lv, ld, 0), lrv, lrd, b));
		                 }
		                 var
		                  lrr = lr[4],
		                  lrd$0 = lr[3],
		                  lrv$0 = lr[2],
		                  lrl = lr[1],
		                  b = create$16(lrr, x, d, r);
		                 return a
		                         (create$16(create$16(ll, lv, ld, lrl), lrv$0, lrd$0, b));
		                }
		                if((hl + 2 | 0) >= hr)
		                 return a(create_with_heights(hl, hr, l, x, d, r));
		                if(typeof r === "number")
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_Map_bal, a);
		                if(0 === r[0]){
		                 a = caml_pop_trap();
		                 return a
		                         (caml_maybe_attach_backtrace([0, Assert_failure, fL], 1));
		                }
		                var
		                 rr = r[4],
		                 rd = r[3],
		                 rv = r[2],
		                 rl = r[1],
		                 b = height$0(rl);
		                if(b <= height$0(rr))
		                 return a(create$16(create$16(l, x, d, rl), rv, rd, rr));
		                if(typeof rl === "number")
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_Map_bal, a);
		                if(0 === rl[0]){
		                 var rld = rl[2], rlv = rl[1], b = create$16(0, rv, rd, rr);
		                 return a(create$16(create$16(l, x, d, 0), rlv, rld, b));
		                }
		                var
		                 rlr = rl[4],
		                 rld$0 = rl[3],
		                 rlv$0 = rl[2],
		                 rll = rl[1],
		                 b = create$16(rlr, rv, rd, rr);
		                return a(create$16(create$16(l, x, d, rll), rlv$0, rld$0, b));
		               }
		               function is_empty$4(param){
		                return typeof param === "number" ? 1 : 0;
		               }
		               function raise_key_already_present(key, sexp_of_key, cont){
		                return caml_trampoline_cps_call2
		                        (sexp_of_key,
		                         key,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (raise_s,
		                                   message
		                                    ("[Map.add_exn] got key already present",
		                                     [0, [0, cst_key, a], 0]),
		                                   cont);
		                         });
		               }
		               function find_and_add_or_set
		               (t,
		                length,
		                x,
		                data,
		                compare_key,
		                sexp_of_key,
		                add_or_set,
		                cont){
		                if(typeof t === "number"){
		                 var length$0 = length + 1 | 0, tree = [0, x, data];
		                 return cont([0, tree, length$0]);
		                }
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          x,
		                          v,
		                          function(c){
		                           if(0 === c)
		                            switch(add_or_set){
		                              case 0:
		                               return cont(raise_without_backtrace(Duplicate));
		                              case 1:
		                               return caml_exact_trampoline_cps_call$1
		                                       (raise_key_already_present, x, sexp_of_key, cont);
		                              default:
		                               var tree = [0, x, data]; return cont([0, tree, length]);
		                            }
		                           if(0 <= c){
		                            var
		                             length$0 = length + 1 | 0,
		                             tree$0 = [1, 0, v, d, [0, x, data], 2];
		                            return cont([0, tree$0, length$0]);
		                           }
		                           var
		                            length$1 = length + 1 | 0,
		                            tree$1 = [1, [0, x, data], v, d, 0, 2];
		                           return cont([0, tree$1, length$1]);
		                          });
		                }
		                var h = t[5], r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         x,
		                         v$0,
		                         function(c){
		                          if(0 === c)
		                           switch(add_or_set){
		                             case 0:
		                              return cont(raise_without_backtrace(Duplicate));
		                             case 1:
		                              return caml_exact_trampoline_cps_call$1
		                                      (raise_key_already_present, x, sexp_of_key, cont);
		                             default:
		                              var tree = [1, l, x, data, r, h];
		                              return cont([0, tree, length]);
		                           }
		                          function a(l, r, length){
		                           return caml_exact_trampoline_cps_call$2
		                                   (bal$1,
		                                    l,
		                                    v$0,
		                                    d$0,
		                                    r,
		                                    function(tree){return cont([0, tree, length]);});
		                          }
		                          return 0 <= c
		                                  ? caml_exact_trampoline_cps_call$8
		                                    (find_and_add_or_set,
		                                     r,
		                                     length,
		                                     x,
		                                     data,
		                                     compare_key,
		                                     sexp_of_key,
		                                     add_or_set,
		                                     function(match){
		                                      var length = match[2], r = match[1];
		                                      return a(l, r, length);
		                                     })
		                                  : caml_exact_trampoline_cps_call$8
		                                    (find_and_add_or_set,
		                                     l,
		                                     length,
		                                     x,
		                                     data,
		                                     compare_key,
		                                     sexp_of_key,
		                                     add_or_set,
		                                     function(match){
		                                      var length = match[2], l = match[1];
		                                      return a(l, r, length);
		                                     });
		                         });
		               }
		               function set_min(key, data, t, cont){
		                if(typeof t === "number") return cont([0, key, data]);
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return cont([1, [0, key, data], v, d, 0, 2]);
		                }
		                var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_exact_trampoline_cps_call$0
		                        (set_min,
		                         key,
		                         data,
		                         l,
		                         function(l){
		                          return caml_exact_trampoline_cps_call$2
		                                  (bal$1, l, v$0, d$0, r, cont);
		                         });
		               }
		               function set_max(t, key, data, cont){
		                if(typeof t === "number") return cont([0, key, data]);
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return cont([1, 0, v, d, [0, key, data], 2]);
		                }
		                var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_exact_trampoline_cps_call$0
		                        (set_max,
		                         r,
		                         key,
		                         data,
		                         function(r){
		                          return caml_exact_trampoline_cps_call$2
		                                  (bal$1, l, v$0, d$0, r, cont);
		                         });
		               }
		               function add_exn
		               (t, length, key, data, compare_key, sexp_of_key, cont){
		                return caml_exact_trampoline_cps_call$8
		                        (find_and_add_or_set,
		                         t,
		                         length,
		                         key,
		                         data,
		                         compare_key,
		                         sexp_of_key,
		                         1,
		                         cont);
		               }
		               function add_exn_internal
		               (t, length, key, data, compare_key, sexp_of_key, cont){
		                return caml_exact_trampoline_cps_call$8
		                        (find_and_add_or_set,
		                         t,
		                         length,
		                         key,
		                         data,
		                         compare_key,
		                         sexp_of_key,
		                         0,
		                         cont);
		               }
		               function set$1(t, length, key, data, compare_key, cont){
		                return caml_exact_trampoline_cps_call$8
		                        (find_and_add_or_set,
		                         t,
		                         length,
		                         key,
		                         data,
		                         compare_key,
		                         function(param, cont){return cont(fM);},
		                         2,
		                         cont);
		               }
		               function max_key(param){
		                if(! param) return 0;
		                var key = param[1][1];
		                return [0, key];
		               }
		               function add_unchecked(t, key, data){return [0, [0, key, data], t];
		               }
		               function to_tree_unchecked(list, cont){
		                if(! list) return cont(0);
		                if(list[2])
		                 return caml_exact_trampoline_cps_call
		                         (length$1,
		                          list,
		                          function(len){
		                           var list$0 = [0, list];
		                           function loop(len){
		                            var a = list$0[1], b = len - 1 | 0;
		                            if(2 >= b >>> 0)
		                             switch(b){
		                               case 0:
		                                if(a){
		                                 var tail$0 = a[2], a = a[1], data = a[2], key = a[1];
		                                 list$0[1] = tail$0;
		                                 return [0, key, data];
		                                }
		                                break;
		                               case 1:
		                                if(a){
		                                 b = a[2];
		                                 if(b){
		                                  var
		                                   tail$1 = b[2],
		                                   b = b[1],
		                                   d1 = b[2],
		                                   k1 = b[1],
		                                   a = a[1],
		                                   d2 = a[2],
		                                   k2 = a[1];
		                                  list$0[1] = tail$1;
		                                  return [1, 0, k1, d1, [0, k2, d2], 2];
		                                 }
		                                }
		                                break;
		                               default:
		                                if(a){
		                                 b = a[2];
		                                 if(b){
		                                  var c = b[2];
		                                  if(c){
		                                   var
		                                    tail$2 = c[2],
		                                    c = c[1],
		                                    d1$0 = c[2],
		                                    k1$0 = c[1],
		                                    b = b[1],
		                                    d2$0 = b[2],
		                                    k2$0 = b[1],
		                                    a = a[1],
		                                    d3 = a[2],
		                                    k3 = a[1];
		                                   list$0[1] = tail$2;
		                                   return [1, [0, k1$0, d1$0], k2$0, d2$0, [0, k3, d3], 2];
		                                  }
		                                 }
		                                }
		                             }
		                            var
		                             nr = len / 2 | 0,
		                             nl = (len - nr | 0) - 1 | 0,
		                             r = loop(nr),
		                             a = list$0[1];
		                            if(! a)
		                             throw caml_maybe_attach_backtrace
		                                    ([0, Assert_failure, fN], 1);
		                            var tail = a[2], a = a[1], d = a[2], k = a[1];
		                            list$0[1] = tail;
		                            var l = loop(nl);
		                            return create$16(l, k, d, r);
		                           }
		                           return cont(loop(len));
		                          });
		                var match = list[1], data = match[2], key = match[1];
		                return cont([0, key, data]);
		               }
		               var empty$9 = 0;
		               function of_increasing_sequence(seq, compare_key, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(param, cont){
		                          var next = seq[2], seed = seq[1];
		                          function a(seed, v){
		                           return caml_trampoline_cps_call2
		                                   (next,
		                                    seed,
		                                    function(b){
		                                     if(typeof b === "number"){
		                                      var length = v[2], builder = v[1];
		                                      return caml_exact_trampoline_cps_call
		      (to_tree_unchecked,
		       builder,
		       function(tree){return cont([0, [0, tree, length]]);});
		                                     }
		                                     if(0 === b[0]){
		                                      var seed = b[1];
		                                      return caml_exact_trampoline_call2(a, seed, v);
		                                     }
		                                     var
		                                      seed$0 = b[2],
		                                      a$0 = b[1],
		                                      data = a$0[2],
		                                      key = a$0[1],
		                                      length$0 = v[2],
		                                      builder$0 = v[1],
		                                      b = max_key(builder$0);
		                                     function c(){
		                                      var
		                                       length = length$0 + 1 | 0,
		                                       tree = add_unchecked(builder$0, key, data);
		                                      return caml_exact_trampoline_call2
		      (a, seed$0, [0, tree, length]);
		                                     }
		                                     if(! b) return c();
		                                     var prev_key = b[1];
		                                     return caml_trampoline_cps_call3
		     (compare_key,
		      prev_key,
		      key,
		      function(b){
		       return 0 <= b
		               ? caml_exact_trampoline_cps_call
		                 (error_string,
		                  "of_increasing_sequence: non-increasing key",
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (param,
		                            b,
		                            function(b){
		                             return caml_exact_trampoline_call2(a, seed$0, b);
		                            });
		                  })
		               : c();
		      });
		                                    });
		                          }
		                          return a(seed, [0, empty$9, 0]);
		                         },
		                         cont);
		               }
		               function join$1(l, k, d, r, cont){
		                if(typeof l === "number")
		                 return caml_exact_trampoline_cps_call$0
		                         (set_min, k, d, r, cont);
		                if(0 !== l[0]){
		                 var
		                  lh = l[5],
		                  lr = l[4],
		                  ld$0 = l[3],
		                  lk$0 = l[2],
		                  ll = l[1];
		                 if(typeof r !== "number"){
		                  if(0 === r[0]){
		                   var rd = r[2], rk = r[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (set_max,
		                            l,
		                            k,
		                            d,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (set_max, a, rk, rd, cont);
		                            });
		                  }
		                  var
		                   rh = r[5],
		                   rr = r[4],
		                   rd$0 = r[3],
		                   rk$0 = r[2],
		                   rl = r[1],
		                   a =
		                     function(l, k, d, r){
		                      return caml_exact_trampoline_cps_call$2
		                              (bal$1, l, k, d, r, cont);
		                     };
		                  return (rh + 3 | 0) < lh
		                          ? caml_exact_trampoline_cps_call$2
		                            (join$1,
		                             lr,
		                             k,
		                             d,
		                             r,
		                             function(b){return a(ll, lk$0, ld$0, b);})
		                          : (lh
		                            + 3
		                            | 0)
		                            < rh
		                            ? caml_exact_trampoline_cps_call$2
		                              (join$1,
		                               l,
		                               k,
		                               d,
		                               rl,
		                               function(b){return a(b, rk$0, rd$0, rr);})
		                            : a(l, k, d, r);
		                 }
		                }
		                if(typeof r === "number")
		                 return caml_exact_trampoline_cps_call$0
		                         (set_max, l, k, d, cont);
		                var ld = l[2], lk = l[1];
		                return caml_exact_trampoline_cps_call$0
		                        (set_min,
		                         k,
		                         d,
		                         r,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (set_min, lk, ld, a, cont);
		                         });
		               }
		               function split_gen$0(t, x, compare_key, cont){
		                if(typeof t === "number") return cont(fO);
		                if(0 === t[0]){
		                 var d = t[2], k = t[1];
		                 return caml_exact_trampoline_cps_call
		                         (compare_key,
		                          k,
		                          function(cmp){
		                           return 0 === cmp
		                                   ? cont([0, 0, [0, [0, k, d]], 0])
		                                   : 0 <= cmp ? cont([0, t, 0, 0]) : cont([0, 0, 0, t]);
		                          });
		                }
		                var r = t[4], d$0 = t[3], k$0 = t[2], l = t[1];
		                return caml_exact_trampoline_cps_call
		                        (compare_key,
		                         k$0,
		                         function(cmp){
		                          return 0 === cmp
		                                  ? cont([0, l, [0, [0, k$0, d$0]], r])
		                                  : 0
		                                    <= cmp
		                                    ? caml_exact_trampoline_cps_call$0
		                                      (split_gen$0,
		                                       r,
		                                       dummy,
		                                       compare_key,
		                                       function(match){
		var rr = match[3], maybe = match[2], rl = match[1];
		return caml_exact_trampoline_cps_call$2
		        (join$1,
		         l,
		         k$0,
		         d$0,
		         rl,
		         function(a){return cont([0, a, maybe, rr]);});
		                                       })
		                                    : caml_exact_trampoline_cps_call$0
		                                      (split_gen$0,
		                                       l,
		                                       dummy,
		                                       compare_key,
		                                       function(match){
		var lr = match[3], maybe = match[2], ll = match[1];
		return caml_exact_trampoline_cps_call$2
		        (join$1,
		         lr,
		         k$0,
		         d$0,
		         r,
		         function(a){return cont([0, ll, maybe, a]);});
		                                       });
		                         });
		               }
		               function split$2(t, x, compare_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (split_gen$0,
		                         t,
		                         x,
		                         function(y, cont){
		                          return caml_trampoline_cps_call3(compare_key, x, y, cont);
		                         },
		                         cont);
		               }
		               function split_and_reinsert_boundary
		               (t, into, x, compare_key, cont){
		                var
		                 a =
		                   847852583 <= into
		                    ? function
		                     (y, cont){
		                      return caml_trampoline_cps_call3
		                              (compare_key,
		                               x,
		                               y,
		                               function(res){return 0 === res ? cont(1) : cont(res);});
		                     }
		                    : function
		                     (y, cont){
		                      return caml_trampoline_cps_call3
		                              (compare_key,
		                               x,
		                               y,
		                               function(res){return 0 === res ? cont(-1) : cont(res);});
		                     };
		                return caml_exact_trampoline_cps_call$0
		                        (split_gen$0,
		                         t,
		                         x,
		                         a,
		                         function(a){
		                          var right = a[3], boundary_opt = a[2], left = a[1];
		                          if(is_none$0(boundary_opt)) return cont([0, left, right]);
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Assert_failure, fP], 1));
		                         });
		               }
		               var empty_without_value_restrictio$0 = 0;
		               function split_range
		               (t, lower_bound, upper_bound, compare_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (bounds_crossed,
		                         lower_bound,
		                         upper_bound,
		                         compare_key,
		                         function(b){
		                          if(b)
		                           return cont
		                                   ([0,
		                                     empty_without_value_restrictio$0,
		                                     empty_without_value_restrictio$0,
		                                     empty_without_value_restrictio$0]);
		                          function a(left, mid_and_right){
		                           function a(mid, right){return cont([0, left, mid, right]);}
		                           if(typeof upper_bound === "number")
		                            return a(mid_and_right, empty_without_value_restrictio$0);
		                           if(0 === upper_bound[0]){
		                            var lb = upper_bound[1];
		                            return caml_exact_trampoline_cps_call$2
		                                    (split_and_reinsert_boundary,
		                                     mid_and_right,
		                                     847852583,
		                                     lb,
		                                     compare_key,
		                                     function(b){return a(b[1], b[2]);});
		                           }
		                           var lb$0 = upper_bound[1];
		                           return caml_exact_trampoline_cps_call$2
		                                   (split_and_reinsert_boundary,
		                                    mid_and_right,
		                                    -57574468,
		                                    lb$0,
		                                    compare_key,
		                                    function(b){
		                                     var right = b[2], mid = b[1];
		                                     return a(mid, right);
		                                    });
		                          }
		                          if(typeof lower_bound === "number")
		                           return a(empty_without_value_restrictio$0, t);
		                          if(0 === lower_bound[0]){
		                           var lb = lower_bound[1];
		                           return caml_exact_trampoline_cps_call$2
		                                   (split_and_reinsert_boundary,
		                                    t,
		                                    -57574468,
		                                    lb,
		                                    compare_key,
		                                    function(b){return a(b[1], b[2]);});
		                          }
		                          var lb$0 = lower_bound[1];
		                          return caml_exact_trampoline_cps_call$2
		                                  (split_and_reinsert_boundary,
		                                   t,
		                                   847852583,
		                                   lb$0,
		                                   compare_key,
		                                   function(b){
		                                    var mid_and_right = b[2], left = b[1];
		                                    return a(left, mid_and_right);
		                                   });
		                         });
		               }
		               function find$2(t, x, compare_key, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_key,
		                           x,
		                           v,
		                           function(a){return 0 === a ? cont([0, d]) : cont(0);});
		                 }
		                 var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          x,
		                          v$0,
		                          function(c){
		                           return 0 === c
		                                   ? cont([0, d$0])
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_call1(a, r)
		                                     : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                return a(t);
		               }
		               function add_multi(t, length, key, data, compare_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (find$2,
		                         t,
		                         key,
		                         compare_key,
		                         function(a){
		                          var data$0 = [0, data, value$4(a, 0)];
		                          return caml_exact_trampoline_cps_call$3
		                                  (set$1, t, length, key, data$0, compare_key, cont);
		                         });
		               }
		               function find_multi(t, x, compare_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (find$2,
		                         t,
		                         x,
		                         compare_key,
		                         function(match){
		                          if(! match) return cont(0);
		                          var l = match[1];
		                          return cont(l);
		                         });
		               }
		               function if_not_found(key, sexp_of_key, cont){
		                return caml_trampoline_cps_call2
		                        (sexp_of_key,
		                         key,
		                         function(a){
		                          var raise = caml_pop_trap();
		                          return raise
		                                  (caml_maybe_attach_backtrace
		                                    ([0, Not_found_s, [1, [0, fQ, [0, a, 0]]]], 1));
		                         });
		               }
		               function find_exn(t, x, compare_key, sexp_of_key, cont){
		                function a(t){
		                 if(typeof t === "number")
		                  return caml_exact_trampoline_cps_call$1
		                          (if_not_found, x, sexp_of_key, cont);
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_key,
		                           x,
		                           v,
		                           function(a){
		                            return 0 === a
		                                    ? cont(d)
		                                    : caml_exact_trampoline_cps_call$1
		                                      (if_not_found, x, sexp_of_key, cont);
		                           });
		                 }
		                 var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          x,
		                          v$0,
		                          function(c){
		                           return 0 === c
		                                   ? cont(d$0)
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_call1(a, r)
		                                     : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                return a(t);
		               }
		               function mem$4(t, x, compare_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (find$2,
		                         t,
		                         x,
		                         compare_key,
		                         function(a){return cont(is_some(a));});
		               }
		               function min_elt$2(a){
		                for(;;){
		                 if(typeof a === "number") return 0;
		                 if(0 === a[0]){
		                  var d = a[2], k = a[1];
		                  return [0, [0, k, d]];
		                 }
		                 var l = a[1];
		                 if(typeof l === "number"){
		                  var d$0 = a[3], k$0 = a[2];
		                  return [0, [0, k$0, d$0]];
		                 }
		                 a = l;
		                }
		               }
		               var
		                Map_min_elt_exn_of_empty_map =
		                  [248,
		                   "Base__Map.Tree0.Map_min_elt_exn_of_empty_map",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Map_min_elt_exn_of_empty_map,
		                  function(param, a){
		                   if(param === Map_min_elt_exn_of_empty_map) return a(fR);
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, fS], 1));
		                  }]);
		               var
		                Map_max_elt_exn_of_empty_map =
		                  [248,
		                   "Base__Map.Tree0.Map_max_elt_exn_of_empty_map",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Map_max_elt_exn_of_empty_map,
		                  function(param, a){
		                   if(param === Map_max_elt_exn_of_empty_map) return a(fT);
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, fU], 1));
		                  }]);
		               function min_elt_exn$0(t){
		                var match = min_elt$2(t);
		                if(! match)
		                 throw caml_maybe_attach_backtrace
		                        (Map_min_elt_exn_of_empty_map, 1);
		                var v = match[1];
		                return v;
		               }
		               function max_elt$2(a){
		                for(;;){
		                 if(typeof a === "number") return 0;
		                 if(0 === a[0]){
		                  var d = a[2], k = a[1];
		                  return [0, [0, k, d]];
		                 }
		                 if(typeof a[4] === "number"){
		                  var d$0 = a[3], k$0 = a[2];
		                  return [0, [0, k$0, d$0]];
		                 }
		                 var r = a[4];
		                 a = r;
		                }
		               }
		               function max_elt_exn(t){
		                var match = max_elt$2(t);
		                if(! match)
		                 throw caml_maybe_attach_backtrace
		                        (Map_max_elt_exn_of_empty_map, 1);
		                var v = match[1];
		                return v;
		               }
		               function remove_min_elt$0(t, cont){
		                if(typeof t === "number")
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, "Map.remove_min_elt", cont);
		                if(0 === t[0]) return cont(0);
		                var l = t[1];
		                if(typeof l === "number"){var r = t[4]; return cont(r);}
		                var r$0 = t[4], d = t[3], x = t[2];
		                return caml_exact_trampoline_cps_call
		                        (remove_min_elt$0,
		                         l,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (bal$1, a, x, d, r$0, cont);
		                         });
		               }
		               function append$2(lower_part, upper_part, compare_key, cont){
		                var match = max_elt$2(lower_part), a = min_elt$2(upper_part);
		                if(! match) return cont([0, , upper_part]);
		                if(! a) return cont([0, , lower_part]);
		                a = a[1];
		                var v = a[2], min_upper = a[1], max_lower = match[1][1];
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         max_lower,
		                         min_upper,
		                         function(a){
		                          return 0 <= a
		                                  ? cont(838882908)
		                                  : caml_exact_trampoline_cps_call
		                                    (remove_min_elt$0,
		                                     upper_part,
		                                     function(upper_part_without_min){
		                                      return caml_exact_trampoline_cps_call$2
		      (join$1,
		       lower_part,
		       min_upper,
		       v,
		       upper_part_without_min,
		       function(a){return cont([0, , a]);});
		                                     });
		                         });
		               }
		               function go$0(t, min, max, init, f, compare_key, cont){
		                function a(t, init){
		                 if(typeof t === "number") return cont(init);
		                 if(0 === t[0]){
		                  var d = t[2], k = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_key,
		                           k,
		                           min,
		                           function(b){
		                            function a(){return cont(init);}
		                            return 0 <= b
		                                    ? caml_trampoline_cps_call3
		                                      (compare_key,
		                                       k,
		                                       max,
		                                       function(b){
		return 0 < b
		        ? a()
		        : caml_trampoline_cps_call4(f, k, d, init, cont);
		                                       })
		                                    : a();
		                           });
		                 }
		                 var r = t[4], d$0 = t[3], k$0 = t[2], l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          k$0,
		                          min,
		                          function(c_min){
		                           return 0 <= c_min
		                                   ? 0
		                                     === c_min
		                                     ? caml_trampoline_cps_call4
		                                       (f,
		k$0,
		d$0,
		init,
		function(init){
		 return caml_exact_trampoline_call2(a, r, init);
		})
		                                     : caml_exact_trampoline_cps_call$7
		                                       (go$0,
		l,
		min,
		max,
		init,
		f,
		compare_key,
		function(z){
		 return caml_trampoline_cps_call3
		         (compare_key,
		          k$0,
		          max,
		          function(c_max){
		           return 0 < c_max
		                   ? cont(z)
		                   : caml_trampoline_cps_call4
		                     (f,
		                      k$0,
		                      d$0,
		                      z,
		                      function(init){
		                       return 0 === c_max
		                               ? cont(init)
		                               : caml_exact_trampoline_call2(a, r, init);
		                      });
		          });
		})
		                                   : caml_exact_trampoline_call2(a, r, init);
		                          });
		                }
		                return a(t, init);
		               }
		               function fold_range_inclusive
		               (t, min, max, init, f, compare_key, cont){
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         min,
		                         max,
		                         function(a){
		                          return 0 < a
		                                  ? cont(init)
		                                  : caml_exact_trampoline_cps_call$7
		                                    (go$0, t, min, max, init, f, compare_key, cont);
		                         });
		               }
		               function range_to_alist(t, min, max, compare_key, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (fold_range_inclusive,
		                         t,
		                         min,
		                         max,
		                         0,
		                         function(key, data, l, cont){
		                          return cont([0, [0, key, data], l]);
		                         },
		                         compare_key,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_rev_keys, a, cont);
		                         });
		               }
		               function concat_unchecked(t1, t2, cont){
		                if(typeof t1 === "number") return cont(t2);
		                if(typeof t2 === "number") return cont(t1);
		                var match = min_elt_exn$0(t2), d = match[2], x = match[1];
		                return caml_exact_trampoline_cps_call
		                        (remove_min_elt$0,
		                         t2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (bal$1, t1, x, d, a, cont);
		                         });
		               }
		               function concat_and_balance_unchecked(t1, t2, cont){
		                if(typeof t1 === "number") return cont(t2);
		                if(typeof t2 === "number") return cont(t1);
		                var match = min_elt_exn$0(t2), d = match[2], x = match[1];
		                return caml_exact_trampoline_cps_call
		                        (remove_min_elt$0,
		                         t2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (join$1, t1, x, d, a, cont);
		                         });
		               }
		               function remove$1(tree, x, length, compare_key, cont){
		                if(typeof tree === "number") return cont([0, tree, length]);
		                if(0 === tree[0]){
		                 var v = tree[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          x,
		                          v,
		                          function(a){
		                           if(0 !== a) return cont([0, tree, length]);
		                           var length$0 = length - 1 | 0;
		                           return cont([0, 0, length$0]);
		                          });
		                }
		                var r = tree[4], d = tree[3], v$0 = tree[2], l = tree[1];
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         x,
		                         v$0,
		                         function(c){
		                          if(0 === c){
		                           var length$0 = length - 1 | 0;
		                           return caml_exact_trampoline_cps_call$1
		                                   (concat_unchecked,
		                                    l,
		                                    r,
		                                    function(tree){return cont([0, tree, length$0]);});
		                          }
		                          function a(l, r, length$0){
		                           return length === length$0
		                                   ? cont([0, tree, length])
		                                   : caml_exact_trampoline_cps_call$2
		                                     (bal$1,
		                                      l,
		                                      v$0,
		                                      d,
		                                      r,
		                                      function(tree){return cont([0, tree, length$0]);});
		                          }
		                          return 0 <= c
		                                  ? caml_exact_trampoline_cps_call$2
		                                    (remove$1,
		                                     r,
		                                     x,
		                                     length,
		                                     compare_key,
		                                     function(match){
		                                      var length = match[2], r = match[1];
		                                      return a(l, r, length);
		                                     })
		                                  : caml_exact_trampoline_cps_call$2
		                                    (remove$1,
		                                     l,
		                                     x,
		                                     length,
		                                     compare_key,
		                                     function(match){
		                                      var length = match[2], l = match[1];
		                                      return a(l, r, length);
		                                     });
		                         });
		               }
		               function change(tree, key, f, length, compare_key, cont){
		                if(typeof tree === "number")
		                 return caml_trampoline_cps_call2
		                         (f,
		                          0,
		                          function(match){
		                           if(! match) return cont([0, 0, length]);
		                           var
		                            data = match[1],
		                            length$0 = length + 1 | 0,
		                            tree = [0, key, data];
		                           return cont([0, tree, length$0]);
		                          });
		                if(0 === tree[0]){
		                 var d = tree[2], v = tree[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          key,
		                          v,
		                          function(c){
		                           return 0 === c
		                                   ? caml_trampoline_cps_call2
		                                     (f,
		                                      [0, d],
		                                      function(match){
		                                       if(match){
		var d = match[1];
		return cont([0, [0, v, d], length]);
		                                       }
		                                       var length$0 = length - 1 | 0;
		                                       return cont([0, 0, length$0]);
		                                      })
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_cps_call$3
		                                       (change,
		0,
		key,
		f,
		length,
		compare_key,
		function(match){
		 var length = match[2], r = match[1];
		 return r === tree
		         ? cont([0, tree, length])
		         : caml_exact_trampoline_cps_call$2
		           (bal$1,
		            0,
		            v,
		            d,
		            r,
		            function(tree){return cont([0, tree, length]);});
		})
		                                     : caml_exact_trampoline_cps_call$3
		                                       (change,
		0,
		key,
		f,
		length,
		compare_key,
		function(match){
		 var length = match[2], l = match[1];
		 return l === tree
		         ? cont([0, tree, length])
		         : caml_exact_trampoline_cps_call$2
		           (bal$1,
		            l,
		            v,
		            d,
		            0,
		            function(tree){return cont([0, tree, length]);});
		});
		                          });
		                }
		                var
		                 h = tree[5],
		                 r = tree[4],
		                 d$0 = tree[3],
		                 v$0 = tree[2],
		                 l = tree[1];
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         key,
		                         v$0,
		                         function(c){
		                          return 0 === c
		                                  ? caml_trampoline_cps_call2
		                                    (f,
		                                     [0, d$0],
		                                     function(match){
		                                      if(match){
		                                       var data = match[1], tree = [1, l, key, data, r, h];
		                                       return cont([0, tree, length]);
		                                      }
		                                      var length$0 = length - 1 | 0;
		                                      return caml_exact_trampoline_cps_call$1
		      (concat_unchecked,
		       l,
		       r,
		       function(tree){return cont([0, tree, length$0]);});
		                                     })
		                                  : 0
		                                    <= c
		                                    ? caml_exact_trampoline_cps_call$3
		                                      (change,
		                                       r,
		                                       key,
		                                       f,
		                                       length,
		                                       compare_key,
		                                       function(match){
		var length = match[2], r$0 = match[1];
		return r$0 === r
		        ? cont([0, tree, length])
		        : caml_exact_trampoline_cps_call$2
		          (bal$1,
		           l,
		           v$0,
		           d$0,
		           r$0,
		           function(tree){return cont([0, tree, length]);});
		                                       })
		                                    : caml_exact_trampoline_cps_call$3
		                                      (change,
		                                       l,
		                                       key,
		                                       f,
		                                       length,
		                                       compare_key,
		                                       function(match){
		var length = match[2], l$0 = match[1];
		return l$0 === l
		        ? cont([0, tree, length])
		        : caml_exact_trampoline_cps_call$2
		          (bal$1,
		           l$0,
		           v$0,
		           d$0,
		           r,
		           function(tree){return cont([0, tree, length]);});
		                                       });
		                         });
		               }
		               function update(t, key, f, length, compare_key, cont){
		                if(typeof t === "number")
		                 return caml_trampoline_cps_call2
		                         (f,
		                          0,
		                          function(data){
		                           var length$0 = length + 1 | 0, tree = [0, key, data];
		                           return cont([0, tree, length$0]);
		                          });
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          key,
		                          v,
		                          function(c){
		                           return 0 === c
		                                   ? caml_trampoline_cps_call2
		                                     (f,
		                                      [0, d],
		                                      function(d){
		                                       var tree = [0, v, d];
		                                       return cont([0, tree, length]);
		                                      })
		                                   : 0
		                                     <= c
		                                     ? caml_exact_trampoline_cps_call$3
		                                       (update,
		0,
		key,
		f,
		length,
		compare_key,
		function(match){
		 var length = match[2], r = match[1];
		 return caml_exact_trampoline_cps_call$2
		         (bal$1,
		          0,
		          v,
		          d,
		          r,
		          function(tree){return cont([0, tree, length]);});
		})
		                                     : caml_exact_trampoline_cps_call$3
		                                       (update,
		0,
		key,
		f,
		length,
		compare_key,
		function(match){
		 var length = match[2], l = match[1];
		 return caml_exact_trampoline_cps_call$2
		         (bal$1,
		          l,
		          v,
		          d,
		          0,
		          function(tree){return cont([0, tree, length]);});
		});
		                          });
		                }
		                var h = t[5], r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_trampoline_cps_call3
		                        (compare_key,
		                         key,
		                         v$0,
		                         function(c){
		                          return 0 === c
		                                  ? caml_trampoline_cps_call2
		                                    (f,
		                                     [0, d$0],
		                                     function(data){
		                                      var tree = [1, l, key, data, r, h];
		                                      return cont([0, tree, length]);
		                                     })
		                                  : 0
		                                    <= c
		                                    ? caml_exact_trampoline_cps_call$3
		                                      (update,
		                                       r,
		                                       key,
		                                       f,
		                                       length,
		                                       compare_key,
		                                       function(match){
		var length = match[2], r = match[1];
		return caml_exact_trampoline_cps_call$2
		        (bal$1,
		         l,
		         v$0,
		         d$0,
		         r,
		         function(tree){return cont([0, tree, length]);});
		                                       })
		                                    : caml_exact_trampoline_cps_call$3
		                                      (update,
		                                       l,
		                                       key,
		                                       f,
		                                       length,
		                                       compare_key,
		                                       function(match){
		var length = match[2], l = match[1];
		return caml_exact_trampoline_cps_call$2
		        (bal$1,
		         l,
		         v$0,
		         d$0,
		         r,
		         function(tree){return cont([0, tree, length]);});
		                                       });
		                         });
		               }
		               function remove_multi(t, key, length, compare_key, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (change,
		                         t,
		                         key,
		                         function(a, cont){
		                          if(a){
		                           a = a[1];
		                           if(a){
		                            var non_empty_tail = a[2];
		                            if(non_empty_tail) return cont([0, non_empty_tail]);
		                           }
		                          }
		                          return cont(0);
		                         },
		                         length,
		                         compare_key,
		                         cont);
		               }
		               function iter_keys(t, f, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var v = t[1];
		                  return caml_trampoline_cps_call2(f, v, cont);
		                 }
		                 var r = t[4], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (iter_keys,
		                          l,
		                          f,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    v$0,
		                                    function(b){return caml_exact_trampoline_call1(a, r);});
		                          });
		                }
		                return a(t);
		               }
		               function iter$4(t, f, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var d = t[2];
		                  return caml_trampoline_cps_call2(f, d, cont);
		                 }
		                 var r = t[4], d$0 = t[3], l = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (iter$4,
		                          l,
		                          f,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    d$0,
		                                    function(b){return caml_exact_trampoline_call1(a, r);});
		                          });
		                }
		                return a(t);
		               }
		               function iteri$0(t, f, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return caml_trampoline_cps_call3(f, v, d, cont);
		                 }
		                 var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (iteri$0,
		                          l,
		                          f,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (f,
		                                    v$0,
		                                    d$0,
		                                    function(b){return caml_exact_trampoline_call1(a, r);});
		                          });
		                }
		                return a(t);
		               }
		               function iteri_until_loop(t, f, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return caml_trampoline_cps_call3(f, v, d, cont);
		                 }
		                 var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (iteri_until_loop,
		                          l,
		                          f,
		                          function(match){
		                           return match
		                                   ? cont(1)
		                                   : caml_trampoline_cps_call3
		                                     (f,
		                                      v$0,
		                                      d$0,
		                                      function(match){
		                                       return match ? cont(1) : caml_exact_trampoline_call1(a, r);
		                                      });
		                          });
		                }
		                return a(t);
		               }
		               function map$12(t, f, cont){
		                if(typeof t === "number") return cont(0);
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return caml_trampoline_cps_call2
		                         (f, d, function(a){return cont([0, v, a]);});
		                }
		                var h = t[5], r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$12,
		                         l,
		                         f,
		                         function(l){
		                          return caml_trampoline_cps_call2
		                                  (f,
		                                   d$0,
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$12,
		     r,
		     f,
		     function(r){return cont([1, l, v$0, d, r, h]);});
		                                   });
		                         });
		               }
		               function mapi$2(t, f, cont){
		                if(typeof t === "number") return cont(0);
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return caml_trampoline_cps_call3
		                         (f, v, d, function(a){return cont([0, v, a]);});
		                }
		                var h = t[5], r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_exact_trampoline_cps_call$1
		                        (mapi$2,
		                         l,
		                         f,
		                         function(l){
		                          return caml_trampoline_cps_call3
		                                  (f,
		                                   v$0,
		                                   d$0,
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call$1
		    (mapi$2,
		     r,
		     f,
		     function(r){return cont([1, l, v$0, d, r, h]);});
		                                   });
		                         });
		               }
		               function fold$4(t, accu, f, cont){
		                function a(t, accu){
		                 if(typeof t === "number") return cont(accu);
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return caml_trampoline_cps_call4(f, v, d, accu, cont);
		                 }
		                 var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (fold$4,
		                          l,
		                          accu,
		                          f,
		                          function(b){
		                           return caml_trampoline_cps_call4
		                                   (f,
		                                    v$0,
		                                    d$0,
		                                    b,
		                                    function(accu){
		                                     return caml_exact_trampoline_call2(a, r, accu);
		                                    });
		                          });
		                }
		                return a(t, accu);
		               }
		               function fold_until$0(t, init, f, finish, cont){
		                function fold_until_loop(t, acc, f, cont){
		                 function a(t, acc){
		                  if(typeof t === "number") return cont([0, acc]);
		                  if(0 === t[0]){
		                   var d = t[2], v = t[1];
		                   return caml_trampoline_cps_call4(f, v, d, acc, cont);
		                  }
		                  var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (fold_until_loop,
		                           l,
		                           acc,
		                           f,
		                           function(match){
		                            if(0 === match[0]){
		                             var acc = match[1];
		                             return caml_trampoline_cps_call4
		                                     (f,
		                                      v$0,
		                                      d$0,
		                                      acc,
		                                      function(match){
		                                       if(0 === match[0]){
		var acc = match[1];
		return caml_exact_trampoline_call2(a, r, acc);
		                                       }
		                                       var final = match[1];
		                                       return cont([1, final]);
		                                      });
		                            }
		                            var final = match[1];
		                            return cont([1, final]);
		                           });
		                 }
		                 return a(t, acc);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (fold_until_loop,
		                         t,
		                         init,
		                         f,
		                         function(match){
		                          if(0 === match[0]){
		                           var acc = match[1];
		                           return caml_trampoline_cps_call2(finish, acc, cont);
		                          }
		                          var stop = match[1];
		                          return cont(stop);
		                         });
		               }
		               function fold_right$2(t, accu, f, cont){
		                function a(t, accu){
		                 if(typeof t === "number") return cont(accu);
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return caml_trampoline_cps_call4(f, v, d, accu, cont);
		                 }
		                 var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (fold_right$2,
		                          r,
		                          accu,
		                          f,
		                          function(b){
		                           return caml_trampoline_cps_call4
		                                   (f,
		                                    v$0,
		                                    d$0,
		                                    b,
		                                    function(accu){
		                                     return caml_exact_trampoline_call2(a, l, accu);
		                                    });
		                          });
		                }
		                return a(t, accu);
		               }
		               function filter_mapi$0(t, f, len, cont){
		                if(typeof t === "number") return cont(0);
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return caml_trampoline_cps_call3
		                         (f,
		                          v,
		                          d,
		                          function(match){
		                           if(match){
		                            var new_data = match[1];
		                            return cont([0, v, new_data]);
		                           }
		                           len[1]--;
		                           return cont(0);
		                          });
		                }
		                var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_exact_trampoline_cps_call$0
		                        (filter_mapi$0,
		                         l,
		                         f,
		                         len,
		                         function(l){
		                          return caml_trampoline_cps_call3
		                                  (f,
		                                   v$0,
		                                   d$0,
		                                   function(new_data){
		                                    return caml_exact_trampoline_cps_call$0
		    (filter_mapi$0,
		     r,
		     f,
		     len,
		     function(r){
		      if(new_data){
		       var new_data$0 = new_data[1];
		       return caml_exact_trampoline_cps_call$2
		               (join$1, l, v$0, new_data$0, r, cont);
		      }
		      len[1]--;
		      return caml_exact_trampoline_cps_call$1
		              (concat_and_balance_unchecked, l, r, cont);
		     });
		                                   });
		                         });
		               }
		               function filteri(t, f, len, cont){
		                if(typeof t === "number") return cont(0);
		                if(0 === t[0]){
		                 var d = t[2], v = t[1];
		                 return caml_trampoline_cps_call3
		                         (f,
		                          v,
		                          d,
		                          function(match){
		                           return match ? cont(t) : (len[1]--, cont(0));
		                          });
		                }
		                var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                return caml_exact_trampoline_cps_call$0
		                        (filteri,
		                         l,
		                         f,
		                         len,
		                         function(l$0){
		                          return caml_trampoline_cps_call3
		                                  (f,
		                                   v$0,
		                                   d$0,
		                                   function(keep_data){
		                                    return caml_exact_trampoline_cps_call$0
		    (filteri,
		     r,
		     f,
		     len,
		     function(r$0){
		      if(l === l$0 && keep_data && r === r$0) return cont(t);
		      return keep_data
		              ? caml_exact_trampoline_cps_call$2
		                (join$1, l$0, v$0, d$0, r$0, cont)
		              : (len
		                 [1]--,
		                caml_exact_trampoline_cps_call$1
		                 (concat_and_balance_unchecked, l$0, r$0, cont));
		     });
		                                   });
		                         });
		               }
		               function filter$4(t, f, len, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (filteri,
		                         t,
		                         function(param, data, cont){
		                          return caml_trampoline_cps_call2(f, data, cont);
		                         },
		                         len,
		                         cont);
		               }
		               function filter_keys(t, f, len, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (filteri,
		                         t,
		                         function(key, param, cont){
		                          return caml_trampoline_cps_call2(f, key, cont);
		                         },
		                         len,
		                         cont);
		               }
		               function filter_map$2(t, f, len, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (filter_mapi$0,
		                         t,
		                         function(param, data, cont){
		                          return caml_trampoline_cps_call2(f, data, cont);
		                         },
		                         len,
		                         cont);
		               }
		               function partition_mapi(t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         t,
		                         [0, empty$9, empty$9],
		                         function(key, data, param, cont){
		                          var t2 = param[2], t1 = param[1];
		                          return caml_trampoline_cps_call3
		                                  (f,
		                                   key,
		                                   data,
		                                   function(match){
		                                    if(0 === match[0]){
		                                     var x = match[1];
		                                     return cont([0, add_unchecked(t1, key, x), t2]);
		                                    }
		                                    var y = match[1];
		                                    return cont([0, t1, add_unchecked(t2, key, y)]);
		                                   });
		                         },
		                         function(match){
		                          var t2 = match[2], t1 = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (to_tree_unchecked,
		                                   t2,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (to_tree_unchecked,
		     t1,
		     function(b){return cont([0, b, a]);});
		                                   });
		                         });
		               }
		               function partition_map$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partition_mapi,
		                         t,
		                         function(param, data, cont){
		                          return caml_trampoline_cps_call2(f, data, cont);
		                         },
		                         cont);
		               }
		               function partitioni_tf(t, f, cont){
		                function loop(t, f, cont){
		                 if(typeof t === "number") return cont(fV);
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return caml_trampoline_cps_call3
		                          (f,
		                           v,
		                           d,
		                           function(match){
		                            return match ? cont([0, t, 0]) : cont([0, 0, t]);
		                           });
		                 }
		                 var r = t[4], d$0 = t[3], v$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (loop,
		                          l,
		                          f,
		                          function(match){
		                           var l_f = match[2], l_t = match[1];
		                           return caml_trampoline_cps_call3
		                                   (f,
		                                    v$0,
		                                    d$0,
		                                    function(keep_data_t){
		                                     return caml_exact_trampoline_cps_call$1
		     (loop,
		      r,
		      f,
		      function(match){
		       var r_f = match[2], r_t = match[1];
		       function mk(l$0, keep_data, r$0, cont){
		        if(l === l$0 && keep_data && r === r$0) return cont(t);
		        return keep_data
		                ? caml_exact_trampoline_cps_call$2
		                  (join$1, l$0, v$0, d$0, r$0, cont)
		                : caml_exact_trampoline_cps_call$1
		                  (concat_and_balance_unchecked, l$0, r$0, cont);
		       }
		       return caml_exact_trampoline_cps_call$0
		               (mk,
		                l_f,
		                1 - keep_data_t,
		                r_f,
		                function(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (mk,
		                          l_t,
		                          keep_data_t,
		                          r_t,
		                          function(b){return cont([0, b, a]);});
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1(loop, t, f, cont);
		               }
		               function partition_tf$1(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partitioni_tf,
		                         t,
		                         function(param, data, cont){
		                          return caml_trampoline_cps_call2(f, data, cont);
		                         },
		                         cont);
		               }
		               function cons$1(t$0, e$1){
		                var t = t$0, e = e$1;
		                for(;;){
		                 if(typeof t === "number") return e;
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return [0, v, d, 0, e];
		                 }
		                 var
		                  r = t[4],
		                  d$0 = t[3],
		                  v$0 = t[2],
		                  l = t[1],
		                  e$0 = [0, v$0, d$0, r, e];
		                 t = l;
		                 e = e$0;
		                }
		               }
		               function cons_right$0(t$0, e$1){
		                var t = t$0, e = e$1;
		                for(;;){
		                 if(typeof t === "number") return e;
		                 if(0 === t[0]){
		                  var d = t[2], v = t[1];
		                  return [0, v, d, 0, e];
		                 }
		                 var
		                  r = t[4],
		                  d$0 = t[3],
		                  v$0 = t[2],
		                  l = t[1],
		                  e$0 = [0, v$0, d$0, l, e];
		                 t = r;
		                 e = e$0;
		                }
		               }
		               function of_tree(tree){return cons$1(tree, 0);}
		               function step_deeper_exn(tree, e){
		                if(typeof tree === "number")
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, fW], 1);
		                if(0 === tree[0]){
		                 var d = tree[2], v = tree[1];
		                 return [0, 0, [0, v, d, 0, e]];
		                }
		                var r = tree[4], d$0 = tree[3], v$0 = tree[2], l = tree[1];
		                return [0, l, [0, v$0, d$0, r, e]];
		               }
		               function drop_phys_equal_prefix
		               (tree1$2, acc1$2, tree2$2, acc2$2){
		                var
		                 tree1 = tree1$2,
		                 acc1 = acc1$2,
		                 tree2 = tree2$2,
		                 acc2 = acc2$2;
		                for(;;){
		                 if(tree1 === tree2) return [0, acc1, acc2];
		                 var h2 = height$0(tree2), h1 = height$0(tree1);
		                 if(h2 === h1){
		                  var
		                   a = step_deeper_exn(tree1, acc1),
		                   acc1$0 = a[2],
		                   tree1$0 = a[1],
		                   a = step_deeper_exn(tree2, acc2),
		                   acc2$0 = a[2],
		                   tree2$0 = a[1];
		                  tree1 = tree1$0;
		                  acc1 = acc1$0;
		                  tree2 = tree2$0;
		                  acc2 = acc2$0;
		                 }
		                 else if(h1 < h2){
		                  a = step_deeper_exn(tree2, acc2);
		                  var acc2$1 = a[2], tree2$1 = a[1];
		                  tree2 = tree2$1;
		                  acc2 = acc2$1;
		                 }
		                 else {
		                  a = step_deeper_exn(tree1, acc1);
		                  var acc1$1 = a[2], tree1$1 = a[1];
		                  tree1 = tree1$1;
		                  acc1 = acc1$1;
		                 }
		                }
		               }
		               function fold2(compare_key, t1, t2, init, f, cont){
		                function a(t1, t2, curr){
		                 if(! t1){
		                  var
		                   c =
		                     function(init, param){
		                      if(! param) return cont(init);
		                      var
		                       enum$ = param[4],
		                       tree = param[3],
		                       data = param[2],
		                       key = param[1];
		                      return caml_trampoline_cps_call4
		                              (f,
		                               key,
		                               [0, -57574468, data],
		                               init,
		                               function(next){
		                                return caml_exact_trampoline_call2
		(c, next, cons$1(tree, enum$));
		                               });
		                     };
		                  return t2 ? c(curr, t2) : cont(curr);
		                 }
		                 function b(init, param){
		                  if(! param) return cont(init);
		                  var
		                   enum$ = param[4],
		                   tree = param[3],
		                   data = param[2],
		                   key = param[1];
		                  return caml_trampoline_cps_call4
		                          (f,
		                           key,
		                           [0, 847852583, data],
		                           init,
		                           function(next){
		                            return caml_exact_trampoline_call2
		                                    (b, next, cons$1(tree, enum$));
		                           });
		                 }
		                 if(! t2) return b(curr, t1);
		                 var
		                  enum2 = t2[4],
		                  tree2 = t2[3],
		                  v2 = t2[2],
		                  k2 = t2[1],
		                  enum1 = t1[4],
		                  tree1 = t1[3],
		                  v1 = t1[2],
		                  k1 = t1[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          k1,
		                          k2,
		                          function(compare_result){
		                           return 0 === compare_result
		                                   ? caml_trampoline_cps_call4
		                                     (f,
		                                      k1,
		                                      [0, 737457313, [0, v1, v2]],
		                                      curr,
		                                      function(next){
		                                       var t2 = cons$1(tree2, enum2), t1 = cons$1(tree1, enum1);
		                                       return caml_exact_trampoline_call3(a, t1, t2, next);
		                                      })
		                                   : 0
		                                     <= compare_result
		                                     ? caml_trampoline_cps_call4
		                                       (f,
		k2,
		[0, -57574468, v2],
		curr,
		function(next){
		 var t2 = cons$1(tree2, enum2);
		 return caml_exact_trampoline_call3(a, t1, t2, next);
		})
		                                     : caml_trampoline_cps_call4
		                                       (f,
		k1,
		[0, 847852583, v1],
		curr,
		function(next){
		 var t1 = cons$1(tree1, enum1);
		 return caml_exact_trampoline_call3(a, t1, t2, next);
		});
		                          });
		                }
		                return a(t1, t2, init);
		               }
		               function symmetric_diff$1(t1, t2, compare_key, data_equal){
		                function step(state, cont){
		                 var left = state[1];
		                 if(left){
		                  var
		                   right = state[2],
		                   enum$ = left[4],
		                   tree = left[3],
		                   data = left[2],
		                   key = left[1];
		                  if(! right)
		                   return cont
		                           ([1,
		                             [0, key, [0, 847852583, data]],
		                             [0, cons$1(tree, enum$), 0]]);
		                  var
		                   enum2 = right[4],
		                   tree2 = right[3],
		                   v2 = right[2],
		                   k2 = right[1];
		                  return caml_trampoline_cps_call3
		                          (compare_key,
		                           key,
		                           k2,
		                           function(compare_result){
		                            if(0 !== compare_result)
		                             return 0 <= compare_result
		                                     ? cont
		                                       ([1,
		 [0, k2, [0, -57574468, v2]],
		 [0, left, cons$1(tree2, enum2)]])
		                                     : cont
		                                       ([1,
		 [0, key, [0, 847852583, data]],
		 [0, cons$1(tree, enum$), right]]);
		                            var
		                             next_state =
		                               drop_phys_equal_prefix(tree, enum$, tree2, enum2);
		                            return caml_trampoline_cps_call3
		                                    (data_equal,
		                                     data,
		                                     v2,
		                                     function(a){
		                                      return a
		      ? cont([0, next_state])
		      : cont
		        ([1, [0, key, [0, 1013247643, [0, data, v2]]], next_state]);
		                                     });
		                           });
		                 }
		                 var match = state[2];
		                 if(! match) return cont(0);
		                 var
		                  enum$0 = match[4],
		                  tree$0 = match[3],
		                  data$0 = match[2],
		                  key$0 = match[1];
		                 return cont
		                         ([1,
		                           [0, key$0, [0, -57574468, data$0]],
		                           [0, 0, cons$1(tree$0, enum$0)]]);
		                }
		                var init = drop_phys_equal_prefix(t1, 0, t2, 0);
		                return [0, init, step];
		               }
		               function fold_symmetric_diff
		               (t1, t2, compare_key, data_equal, init, f, cont){
		                function add(acc, k, v, cont){
		                 return caml_trampoline_cps_call3
		                         (f, acc, [0, k, [0, -57574468, v]], cont);
		                }
		                function remove(acc, k, v, cont){
		                 return caml_trampoline_cps_call3
		                         (f, acc, [0, k, [0, 847852583, v]], cont);
		                }
		                var
		                 match = drop_phys_equal_prefix(t1, 0, t2, 0),
		                 right = match[2],
		                 left = match[1];
		                function a(left, right, init){
		                 function b(init, param){
		                  if(! param) return cont(init);
		                  var
		                   enum$ = param[4],
		                   tree = param[3],
		                   data = param[2],
		                   key = param[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (add,
		                           init,
		                           key,
		                           data,
		                           function(next){
		                            return caml_exact_trampoline_call2
		                                    (b, next, cons$1(tree, enum$));
		                           });
		                 }
		                 if(! left) return b(init, right);
		                 function c(init, param){
		                  if(! param) return cont(init);
		                  var
		                   enum$ = param[4],
		                   tree = param[3],
		                   data = param[2],
		                   key = param[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (remove,
		                           init,
		                           key,
		                           data,
		                           function(next){
		                            return caml_exact_trampoline_call2
		                                    (c, next, cons$1(tree, enum$));
		                           });
		                 }
		                 if(! right) return c(init, left);
		                 var
		                  enum2 = right[4],
		                  tree2 = right[3],
		                  v2 = right[2],
		                  k2 = right[1],
		                  enum1 = left[4],
		                  tree1 = left[3],
		                  v1 = left[2],
		                  k1 = left[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          k1,
		                          k2,
		                          function(compare_result){
		                           return 0 === compare_result
		                                   ? caml_trampoline_cps_call3
		                                     (data_equal,
		                                      v1,
		                                      v2,
		                                      function(c){
		                                       function b(acc){
		var
		 match = drop_phys_equal_prefix(tree1, enum1, tree2, enum2),
		 enum2$0 = match[2],
		 enum1$0 = match[1];
		return caml_exact_trampoline_call3(a, enum1$0, enum2$0, acc);
		                                       }
		                                       return c
		       ? b(init)
		       : caml_trampoline_cps_call3
		         (f, init, [0, k1, [0, 1013247643, [0, v1, v2]]], b);
		                                      })
		                                   : 0
		                                     <= compare_result
		                                     ? caml_exact_trampoline_cps_call$0
		                                       (add,
		init,
		k2,
		v2,
		function(acc){
		 var right = cons$1(tree2, enum2);
		 return caml_exact_trampoline_call3(a, left, right, acc);
		})
		                                     : caml_exact_trampoline_cps_call$0
		                                       (remove,
		init,
		k1,
		v1,
		function(acc){
		 var left = cons$1(tree1, enum1);
		 return caml_exact_trampoline_call3(a, left, right, acc);
		});
		                          });
		                }
		                return a(left, right, init);
		               }
		               function to_sequence$1
		               (comparator,
		                opt,
		                keys_greater_or_equal_to,
		                keys_less_or_equal_to,
		                init,
		                cont){
		                var order = opt ? opt[1] : -542431297;
		                if(511974747 <= order){
		                 var
		                  b =
		                    function(tree){
		                     function next(enum$, cont){
		                      if(! enum$) return cont(0);
		                      var e = enum$[4], t = enum$[3], v = enum$[2], k = enum$[1];
		                      return cont([1, [0, k, v], cons_right$0(t, e)]);
		                     }
		                     function b(init){return cont([0, init, next]);}
		                     if(! keys_less_or_equal_to) return b(cons_right$0(tree, 0));
		                     var key = keys_less_or_equal_to[1], compare = comparator[1];
		                     function a(t, e){
		                      if(typeof t === "number") return b(e);
		                      if(0 === t[0]){
		                       var d = t[2], v = t[1];
		                       return caml_exact_trampoline_call2(a, [1, 0, v, d, 0, 1], e);
		                      }
		                      var l = t[1], v$0 = t[2];
		                      return caml_trampoline_cps_call3
		                              (compare,
		                               v$0,
		                               key,
		                               function(b){
		                                if(0 < b) return caml_exact_trampoline_call2(a, l, e);
		                                var r = t[4], d = t[3], v = t[2], e$0 = [0, v, d, l, e];
		                                return caml_exact_trampoline_call2(a, r, e$0);
		                               });
		                     }
		                     return a(tree, 0);
		                    };
		                 if(! keys_greater_or_equal_to) return b(init);
		                 var
		                  bound = keys_greater_or_equal_to[1],
		                  compare_key = comparator[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (split$2,
		                          init,
		                          bound,
		                          compare_key,
		                          function(a){
		                           var r = a[3], maybe = a[2];
		                           if(! maybe) return b(r);
		                           a = maybe[1];
		                           var data = a[2], key = a[1];
		                           return caml_exact_trampoline_cps_call$3
		                                   (set$1,
		                                    r,
		                                    0,
		                                    key,
		                                    data,
		                                    compare_key,
		                                    function(a){return b(a[1]);});
		                          });
		                }
		                function a(t){
		                 function next(enum$, cont){
		                  if(! enum$) return cont(0);
		                  var e = enum$[4], t = enum$[3], v = enum$[2], k = enum$[1];
		                  return cont([1, [0, k, v], cons$1(t, e)]);
		                 }
		                 function b(init){return cont([0, init, next]);}
		                 if(! keys_greater_or_equal_to) return b(of_tree(t));
		                 var
		                  key = keys_greater_or_equal_to[1],
		                  compare = comparator[1];
		                 function a(t, e){
		                  if(typeof t === "number") return b(e);
		                  if(0 === t[0]){
		                   var d = t[2], v = t[1];
		                   return caml_exact_trampoline_call2(a, [1, 0, v, d, 0, 1], e);
		                  }
		                  var l = t[1], r = t[4], v$0 = t[2];
		                  return caml_trampoline_cps_call3
		                          (compare,
		                           v$0,
		                           key,
		                           function(b){
		                            if(0 > b) return caml_exact_trampoline_call2(a, r, e);
		                            var r$0 = t[4], d = t[3], v = t[2], e$0 = [0, v, d, r$0, e];
		                            return caml_exact_trampoline_call2(a, l, e$0);
		                           });
		                 }
		                 return a(t, 0);
		                }
		                if(! keys_less_or_equal_to) return a(init);
		                var
		                 bound$0 = keys_less_or_equal_to[1],
		                 compare_key$0 = comparator[1];
		                return caml_exact_trampoline_cps_call$0
		                        (split$2,
		                         init,
		                         bound$0,
		                         compare_key$0,
		                         function(b){
		                          var maybe = b[2], l = b[1];
		                          if(! maybe) return a(l);
		                          b = maybe[1];
		                          var data = b[2], key = b[1];
		                          return caml_exact_trampoline_cps_call$3
		                                  (set$1,
		                                   l,
		                                   0,
		                                   key,
		                                   data,
		                                   compare_key$0,
		                                   function(b){return a(b[1]);});
		                         });
		               }
		               function compare$17(compare_key, compare_data, t1, t2, cont){
		                var
		                 match = drop_phys_equal_prefix(t1, 0, t2, 0),
		                 e2 = match[2],
		                 e1 = match[1];
		                function a(t1, t2){
		                 if(! t1) return t2 ? cont(-1) : cont(0);
		                 if(! t2) return cont(1);
		                 var
		                  e2 = t2[4],
		                  r2 = t2[3],
		                  d2 = t2[2],
		                  v2 = t2[1],
		                  e1 = t1[4],
		                  r1 = t1[3],
		                  d1 = t1[2],
		                  v1 = t1[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          v1,
		                          v2,
		                          function(c){
		                           return 0 === c
		                                   ? caml_trampoline_cps_call3
		                                     (compare_data,
		                                      d1,
		                                      d2,
		                                      function(c){
		                                       if(0 !== c) return cont(c);
		                                       var
		match = drop_phys_equal_prefix(r1, e1, r2, e2),
		e2$0 = match[2],
		e1$0 = match[1];
		                                       return caml_exact_trampoline_call2(a, e1$0, e2$0);
		                                      })
		                                   : cont(c);
		                          });
		                }
		                return a(e1, e2);
		               }
		               function equal$10(compare_key, compare_data, t1, t2, cont){
		                var
		                 match = drop_phys_equal_prefix(t1, 0, t2, 0),
		                 e2 = match[2],
		                 e1 = match[1];
		                function a(t1, t2){
		                 if(t1){
		                  if(t2){
		                   var
		                    e2 = t2[4],
		                    r2 = t2[3],
		                    d2 = t2[2],
		                    v2 = t2[1],
		                    e1 = t1[4],
		                    r1 = t1[3],
		                    d1 = t1[2],
		                    v1 = t1[1];
		                   return caml_trampoline_cps_call3
		                           (compare_key,
		                            v1,
		                            v2,
		                            function(b){
		                             b = 0 === b ? 1 : 0;
		                             function c(a){return cont(a);}
		                             return b
		                                     ? caml_trampoline_cps_call3
		                                       (compare_data,
		d1,
		d2,
		function(b){
		 if(! b) return c(b);
		 b = drop_phys_equal_prefix(r1, e1, r2, e2);
		 var e2$0 = b[2], e1$0 = b[1];
		 return caml_exact_trampoline_call2(a, e1$0, e2$0);
		})
		                                     : c(b);
		                            });
		                  }
		                 }
		                 else if(! t2) return cont(1);
		                 return cont(0);
		                }
		                return a(e1, e2);
		               }
		               function iter2(t1, t2, f, compare_key, cont){
		                var a = of_tree(t2);
		                return caml_exact_trampoline_cps_call$3
		                        (fold2,
		                         compare_key,
		                         of_tree(t1),
		                         a,
		                         0,
		                         function(key, data, param, cont){
		                          return caml_trampoline_cps_call3(f, key, data, cont);
		                         },
		                         cont);
		               }
		               function fold2$0(t1, t2, init, f, compare_key, cont){
		                var a = of_tree(t2);
		                return caml_exact_trampoline_cps_call$3
		                        (fold2, compare_key, of_tree(t1), a, init, f, cont);
		               }
		               function fold_symmetric_diff$0
		               (t1, t2, compare_key, data_equal, init, f, cont){
		                function add(acc, k, v, cont){
		                 return caml_trampoline_cps_call3
		                         (f, acc, [0, k, [0, -57574468, v]], cont);
		                }
		                function remove(acc, k, v, cont){
		                 return caml_trampoline_cps_call3
		                         (f, acc, [0, k, [0, 847852583, v]], cont);
		                }
		                function delta(acc, k, v$0, v, cont){
		                 return caml_trampoline_cps_call3
		                         (data_equal,
		                          v$0,
		                          v,
		                          function(a){
		                           return a
		                                   ? cont(acc)
		                                   : caml_trampoline_cps_call3
		                                     (f, acc, [0, k, [0, 1013247643, [0, v$0, v]]], cont);
		                          });
		                }
		                function loop(t, t$0, acc, cont){
		                 function a(t$0, t, init){
		                  if(t$0 === t) return cont(init);
		                  if(typeof t$0 === "number")
		                   return caml_exact_trampoline_cps_call$0
		                           (fold$4,
		                            t,
		                            init,
		                            function(key, data, acc, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (add, acc, key, data, cont);
		                            },
		                            cont);
		                  function b(){
		                   return caml_exact_trampoline_cps_call$7
		                           (fold_symmetric_diff,
		                            t$0,
		                            t,
		                            compare_key,
		                            data_equal,
		                            init,
		                            f,
		                            cont);
		                  }
		                  if(0 === t$0[0]){
		                   var v = t$0[2], k = t$0[1];
		                   if(typeof t !== "number"){
		                    if(0 !== t[0]) return b();
		                    var v$0 = t[2], k$0 = t[1];
		                    return caml_trampoline_cps_call3
		                            (compare_key,
		                             k,
		                             k$0,
		                             function(x){
		                              return 0 === x
		                                      ? caml_exact_trampoline_cps_call$2
		(delta, init, k, v, v$0, cont)
		                                      : 0
		<= x
		? caml_exact_trampoline_cps_call$0
		  (add,
		   init,
		   k$0,
		   v$0,
		   function(acc){
		    return caml_exact_trampoline_cps_call$0
		            (remove, acc, k, v, cont);
		   })
		: caml_exact_trampoline_cps_call$0
		  (remove,
		   init,
		   k,
		   v,
		   function(acc){
		    return caml_exact_trampoline_cps_call$0
		            (add, acc, k$0, v$0, cont);
		   });
		                             });
		                   }
		                  }
		                  else {
		                   var r = t$0[4], v$1 = t$0[3], k$1 = t$0[2], l = t$0[1];
		                   if(typeof t !== "number"){
		                    if(0 === t[0]) return b();
		                    var r$0 = t[4], v$2 = t[3], k$2 = t[2], l$0 = t[1];
		                    return caml_trampoline_cps_call3
		                            (compare_key,
		                             k$1,
		                             k$2,
		                             function(c){
		                              return 0 === c
		                                      ? caml_exact_trampoline_cps_call$0
		(loop,
		 l,
		 l$0,
		 init,
		 function(acc){
		  return caml_exact_trampoline_cps_call$2
		          (delta,
		           acc,
		           k$1,
		           v$1,
		           v$2,
		           function(acc){
		            return caml_exact_trampoline_call3(a, r, r$0, acc);
		           });
		 })
		                                      : b();
		                             });
		                   }
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (fold$4,
		                           t$0,
		                           init,
		                           function(key, data, acc, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (remove, acc, key, data, cont);
		                           },
		                           cont);
		                 }
		                 return a(t, t$0, acc);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (loop, t1, t2, init, cont);
		               }
		               function length$8(a){
		                if(typeof a === "number") return 0;
		                if(0 === a[0]) return 1;
		                var r = a[4], l = a[1], a = length$8(r);
		                return (length$8(l) + a | 0) + 1 | 0;
		               }
		               function keys(t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$2,
		                         t,
		                         0,
		                         function(key, param, list, cont){return cont([0, key, list]);
		                         },
		                         cont);
		               }
		               function data(t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$2,
		                         t,
		                         0,
		                         function(param, data, list, cont){return cont([0, data, list]);
		                         },
		                         cont);
		               }
		               function of_foldable
		               (fold, foldable, init, f, compare_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold,
		                         foldable,
		                         [0, empty_without_value_restrictio$0, 0],
		                         function(a, param, cont){
		                          var
		                           data = param[2],
		                           key = param[1],
		                           length = a[2],
		                           accum = a[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (find$2,
		                                   accum,
		                                   key,
		                                   compare_key,
		                                   function(match){
		                                    if(match)
		                                     var prev = match[1], prev_data = prev;
		                                    else
		                                     prev_data = init;
		                                    return caml_trampoline_cps_call3
		    (f,
		     prev_data,
		     data,
		     function(data){
		      return caml_exact_trampoline_cps_call$3
		              (set$1,
		               accum,
		               length,
		               key,
		               data,
		               compare_key,
		               function(a){return cont(globalize(a));});
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function Of_foldable(M){
		                function of_foldable_fold
		                (foldable, init, f, compare_key, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (of_foldable, M[2], foldable, init, f, compare_key, cont);
		                }
		                function of_foldable_reduce(foldable, f, compare_key, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (M[2],
		                          foldable,
		                          [0, empty_without_value_restrictio$0, 0],
		                          function(a, param, cont){
		                           var
		                            data = param[2],
		                            key = param[1],
		                            length = a[2],
		                            accum = a[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (find$2,
		                                    accum,
		                                    key,
		                                    compare_key,
		                                    function(match){
		                                     function a(new_data){
		                                      return caml_exact_trampoline_cps_call$3
		      (set$1,
		       accum,
		       length,
		       key,
		       new_data,
		       compare_key,
		       function(a){return cont(globalize(a));});
		                                     }
		                                     if(! match) return a(data);
		                                     var prev = match[1];
		                                     return caml_trampoline_cps_call3(f, prev, data, a);
		                                    });
		                          },
		                          cont);
		                }
		                function of_foldable$0(foldable, compare_key, cont){
		                 return caml_exact_trampoline_cps_call
		                         (with_return,
		                          function(r, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (M[2],
		                                    foldable,
		                                    [0, empty_without_value_restrictio$0, 0],
		                                    function(a, param, cont){
		                                     var
		                                      data = param[2],
		                                      key = param[1],
		                                      length = a[2],
		                                      t = a[1];
		                                     return caml_exact_trampoline_cps_call$3
		     (set$1,
		      t,
		      length,
		      key,
		      data,
		      compare_key,
		      function(acc){
		       var length$0 = acc[2];
		       return length === length$0
		               ? caml_exact_trampoline_cps_call
		                 (r, [0, -1048878709, key], cont)
		               : cont(globalize(acc));
		      });
		                                    },
		                                    function(map){return cont([0, 17724, map]);});
		                          },
		                          cont);
		                }
		                var cst_Map_of = "Map.of_";
		                function of_foldable_or_error(foldable, comparator, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_foldable$0,
		                          foldable,
		                          comparator[1],
		                          function(match){
		                           var variant = match[1];
		                           if(17724 <= variant){var x = match[2]; return cont([0, x]);}
		                           var
		                            key = match[2],
		                            s1 = M[1],
		                            s2 = s1 + "_or_error: duplicate key";
		                           return caml_exact_trampoline_cps_call$3
		                                   (error, 0, 0, cst_Map_of + s2, key, comparator[2], cont);
		                          });
		                }
		                function of_foldable_exn(foldable, comparator, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_foldable$0,
		                          foldable,
		                          comparator[1],
		                          function(match){
		                           var variant = match[1];
		                           if(17724 <= variant){var x = match[2]; return cont(x);}
		                           var
		                            key = match[2],
		                            s1 = M[1],
		                            s2 = s1 + "_exn: duplicate key";
		                           return caml_exact_trampoline_cps_call$3
		                                   (create$9,
		                                    0,
		                                    0,
		                                    cst_Map_of + s2,
		                                    key,
		                                    comparator[2],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(raise, a, cont);
		                                    });
		                          });
		                }
		                function of_foldable_multi(foldable, compare_key, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (M[2],
		                          foldable,
		                          0,
		                          function(l, x, cont){return cont([0, x, l]);},
		                          function(alist){
		                           return caml_exact_trampoline_cps_call$3
		                                   (of_foldable,
		                                    fold_left$1,
		                                    alist,
		                                    0,
		                                    function(l, x, cont){return cont([0, x, l]);},
		                                    compare_key,
		                                    cont);
		                          });
		                }
		                return [0,
		                        of_foldable_fold,
		                        of_foldable_reduce,
		                        of_foldable$0,
		                        of_foldable_or_error,
		                        of_foldable_exn,
		                        of_foldable_multi];
		               }
		               var
		                Of_alist = Of_foldable([0, "alist", fold_left$1]),
		                of_alist_fold = Of_alist[1],
		                of_alist_reduce = Of_alist[2],
		                of_alist = Of_alist[3],
		                of_alist_or_error = Of_alist[4],
		                of_alist_exn = Of_alist[5],
		                of_alist_multi = Of_alist[6],
		                cst_sequence = "sequence",
		                Of_sequence = Of_foldable([0, cst_sequence, fold$0]),
		                of_sequence_fold = Of_sequence[1],
		                of_sequence_reduce = Of_sequence[2],
		                of_sequence$1 = Of_sequence[3],
		                of_sequence_or_error = Of_sequence[4],
		                of_sequence_exn = Of_sequence[5],
		                of_sequence_multi = Of_sequence[6];
		               function of_list_with_key(list, get_key, compare_key, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(r, cont){
		                          function a(t, init){
		                           if(! t) return cont([0, 17724, init]);
		                           var l = t[2], data = t[1], length = init[2], t$0 = init[1];
		                           return caml_trampoline_cps_call2
		                                   (get_key,
		                                    data,
		                                    function(key){
		                                     return caml_exact_trampoline_cps_call$3
		     (set$1,
		      t$0,
		      length,
		      key,
		      data,
		      compare_key,
		      function(acc){
		       var new_length = acc[2];
		       return length === new_length
		               ? caml_exact_trampoline_cps_call
		                 (r,
		                  [0, -1048878709, key],
		                  function(b){return caml_exact_trampoline_call2(a, l, b);})
		               : caml_exact_trampoline_call2(a, l, globalize(acc));
		      });
		                                    });
		                          }
		                          return a(list, [0, empty_without_value_restrictio$0, 0]);
		                         },
		                         cont);
		               }
		               function of_list_with_key_or_error
		               (list, get_key, comparator, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key,
		                         list,
		                         get_key,
		                         comparator[1],
		                         function(match){
		                          var variant = match[1];
		                          if(17724 <= variant){var x = match[2]; return cont([0, x]);}
		                          var key = match[2];
		                          return caml_exact_trampoline_cps_call$3
		                                  (error,
		                                   0,
		                                   0,
		                                   "Map.of_list_with_key_or_error: duplicate key",
		                                   key,
		                                   comparator[2],
		                                   cont);
		                         });
		               }
		               function of_list_with_key_exn(list, get_key, comparator, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key,
		                         list,
		                         get_key,
		                         comparator[1],
		                         function(match){
		                          var variant = match[1];
		                          if(17724 <= variant){var x = match[2]; return cont(x);}
		                          var key = match[2];
		                          return caml_exact_trampoline_cps_call$3
		                                  (create$9,
		                                   0,
		                                   0,
		                                   "Map.of_list_with_key_exn: duplicate key",
		                                   key,
		                                   comparator[2],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(raise, a, cont);
		                                   });
		                         });
		               }
		               function of_list_with_key_multi
		               (list, get_key, compare_key, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys,
		                         list,
		                         function(list){
		                          function a(t, init){
		                           if(! t) return cont(init);
		                           var l = t[2], data = t[1], length = init[2], t$0 = init[1];
		                           return caml_trampoline_cps_call2
		                                   (get_key,
		                                    data,
		                                    function(key){
		                                     return caml_exact_trampoline_cps_call$3
		     (update,
		      t$0,
		      key,
		      function(option, cont){
		       var list = value$4(option, 0);
		       return cont([0, data, list]);
		      },
		      length,
		      compare_key,
		      function(b){
		       var init = globalize(b);
		       return caml_exact_trampoline_call2(a, l, init);
		      });
		                                    });
		                          }
		                          return a(list, [0, empty_without_value_restrictio$0, 0]);
		                         });
		               }
		               function of_list_with_key_fold
		               (list, get_key, init, f, compare_key, cont){
		                function a(t, init$0){
		                 if(! t) return cont(init$0);
		                 var
		                  l = t[2],
		                  data = t[1],
		                  length = init$0[2],
		                  t$0 = init$0[1];
		                 return caml_trampoline_cps_call2
		                         (get_key,
		                          data,
		                          function(key){
		                           return caml_exact_trampoline_cps_call$3
		                                   (update,
		                                    t$0,
		                                    key,
		                                    function(param, cont){
		                                     if(! param)
		                                      return caml_trampoline_cps_call3(f, init, data, cont);
		                                     var prev = param[1];
		                                     return caml_trampoline_cps_call3(f, prev, data, cont);
		                                    },
		                                    length,
		                                    compare_key,
		                                    function(b){
		                                     var init = globalize(b);
		                                     return caml_exact_trampoline_call2(a, l, init);
		                                    });
		                          });
		                }
		                return a(list, [0, empty_without_value_restrictio$0, 0]);
		               }
		               function of_list_with_key_reduce
		               (list, get_key, f, compare_key, cont){
		                function a(t, init){
		                 if(! t) return cont(init);
		                 var l = t[2], data = t[1], length = init[2], t$0 = init[1];
		                 return caml_trampoline_cps_call2
		                         (get_key,
		                          data,
		                          function(key){
		                           return caml_exact_trampoline_cps_call$3
		                                   (update,
		                                    t$0,
		                                    key,
		                                    function(param, cont){
		                                     if(! param) return cont(data);
		                                     var prev = param[1];
		                                     return caml_trampoline_cps_call3(f, prev, data, cont);
		                                    },
		                                    length,
		                                    compare_key,
		                                    function(b){
		                                     var init = globalize(b);
		                                     return caml_exact_trampoline_call2(a, l, init);
		                                    });
		                          });
		                }
		                return a(list, [0, empty_without_value_restrictio$0, 0]);
		               }
		               function for_all(t, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(r, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (iter$4,
		                                   t,
		                                   function(data, cont){
		                                    return caml_trampoline_cps_call2
		    (f,
		     data,
		     function(a){
		      a = 1 - a;
		      return a
		              ? caml_exact_trampoline_cps_call(r, 0, cont)
		              : cont(a);
		     });
		                                   },
		                                   function(a){return cont(1);});
		                         },
		                         cont);
		               }
		               function for_alli(t, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(r, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (iteri$0,
		                                   t,
		                                   function(key, data, cont){
		                                    return caml_trampoline_cps_call3
		    (f,
		     key,
		     data,
		     function(a){
		      a = 1 - a;
		      return a
		              ? caml_exact_trampoline_cps_call(r, 0, cont)
		              : cont(a);
		     });
		                                   },
		                                   function(a){return cont(1);});
		                         },
		                         cont);
		               }
		               function exists(t, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(r, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (iter$4,
		                                   t,
		                                   function(data, cont){
		                                    return caml_trampoline_cps_call2
		    (f,
		     data,
		     function(a){
		      return a
		              ? caml_exact_trampoline_cps_call(r, 1, cont)
		              : cont(a);
		     });
		                                   },
		                                   function(a){return cont(0);});
		                         },
		                         cont);
		               }
		               function existsi(t, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(r, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (iteri$0,
		                                   t,
		                                   function(key, data, cont){
		                                    return caml_trampoline_cps_call3
		    (f,
		     key,
		     data,
		     function(a){
		      return a
		              ? caml_exact_trampoline_cps_call(r, 1, cont)
		              : cont(a);
		     });
		                                   },
		                                   function(a){return cont(0);});
		                         },
		                         cont);
		               }
		               function count(t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         t,
		                         0,
		                         function(param, data, acc, cont){
		                          return caml_trampoline_cps_call2
		                                  (f,
		                                   data,
		                                   function(a){return a ? cont(acc + 1 | 0) : cont(acc);});
		                         },
		                         cont);
		               }
		               function counti(t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         t,
		                         0,
		                         function(key, data, acc, cont){
		                          return caml_trampoline_cps_call3
		                                  (f,
		                                   key,
		                                   data,
		                                   function(a){return a ? cont(acc + 1 | 0) : cont(acc);});
		                         },
		                         cont);
		               }
		               function sum$0(M, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         t,
		                         M[1],
		                         function(param, data, acc, cont){
		                          return caml_trampoline_cps_call2
		                                  (f,
		                                   data,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(M[2], a, acc, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function sumi(M, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         t,
		                         M[1],
		                         function(key, data, acc, cont){
		                          return caml_trampoline_cps_call3
		                                  (f,
		                                   key,
		                                   data,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(M[2], a, acc, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function to_alist(opt, t, cont){
		                var key_order = opt ? opt[1] : 608542111;
		                return 608542111 <= key_order
		                        ? caml_exact_trampoline_cps_call$0
		                          (fold_right$2,
		                           t,
		                           0,
		                           function(key, data, x, cont){
		                            return cont([0, [0, key, data], x]);
		                           },
		                           cont)
		                        : caml_exact_trampoline_cps_call$0
		                          (fold$4,
		                           t,
		                           0,
		                           function(key, data, x, cont){
		                            return cont([0, [0, key, data], x]);
		                           },
		                           cont);
		               }
		               function merge$0(t1, t2, f, compare_key, cont){
		                var
		                 a = length$8(t2),
		                 len = length$8(t1) + a | 0,
		                 elts = caml_make_vect(len, 0),
		                 i = [0, 0];
		                return caml_exact_trampoline_cps_call$2
		                        (iter2,
		                         t1,
		                         t2,
		                         function(key, values, cont){
		                          return caml_trampoline_cps_call3
		                                  (f,
		                                   key,
		                                   values,
		                                   function(match){
		                                    if(! match) return cont(0);
		                                    var value = match[1], x = [0, key, value], i$0 = i[1];
		                                    set$0(elts, i$0, x);
		                                    i[1]++;
		                                    return cont(0);
		                                   });
		                         },
		                         compare_key,
		                         function(a){
		                          var length = i[1];
		                          function get(i, cont){return cont(get$3(elts, i));}
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_increasing_iterator_uncheck,
		                                   length,
		                                   get,
		                                   function(tree){return cont([0, tree, length]);});
		                         });
		               }
		               function merge_large_first
		               (length_large,
		                t_large,
		                t_small,
		                call,
		                combine,
		                compare_key,
		                cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         t_small,
		                         [0, t_large, length_large],
		                         function(key, data, param, cont){
		                          var length = param[2], t = param[1];
		                          return caml_exact_trampoline_cps_call$3
		                                  (update,
		                                   t,
		                                   key,
		                                   function(param, cont){
		                                    if(! param) return cont(data);
		                                    var data$0 = param[1];
		                                    return caml_exact_trampoline_cps_call$2
		    (call, combine, key, data$0, data, cont);
		                                   },
		                                   length,
		                                   compare_key,
		                                   function(a){return cont(globalize(a));});
		                         },
		                         cont);
		               }
		               function call(f, key, x, y, cont){
		                return caml_trampoline_cps_call4(f, key, x, y, cont);
		               }
		               function swap$0(f, key, x, y, cont){
		                return caml_trampoline_cps_call4(f, key, y, x, cont);
		               }
		               function merge_skewed
		               (t1, t2, length1, length2, combine, compare_key, cont){
		                return length2 <= length1
		                        ? caml_exact_trampoline_cps_call$7
		                          (merge_large_first,
		                           length1,
		                           t1,
		                           t2,
		                           call,
		                           combine,
		                           compare_key,
		                           cont)
		                        : caml_exact_trampoline_cps_call$7
		                          (merge_large_first,
		                           length2,
		                           t2,
		                           t1,
		                           swap$0,
		                           combine,
		                           compare_key,
		                           cont);
		               }
		               function merge_disjoint_exn
		               (t1, t2, length1, length2, comparator, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (merge_skewed,
		                         t1,
		                         t2,
		                         length1,
		                         length2,
		                         function(key, a, param, cont){
		                          return caml_exact_trampoline_cps_call$3
		                                  (create$9,
		                                   0,
		                                   0,
		                                   "Map.merge_disjoint_exn: duplicate key",
		                                   key,
		                                   comparator[2],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(raise, a, cont);
		                                   });
		                         },
		                         comparator[1],
		                         cont);
		               }
		               function repackage(marker, k, v){
		                return marker ? [0, [0, k, v]] : 0;
		               }
		               function closest_key(t, dir, k, compare_key, cont){
		                function a(t, found_marker, found_key, found_value){
		                 if(typeof t === "number")
		                  return cont(repackage(found_marker, found_key, found_value));
		                 if(0 === t[0]){
		                  var v = t[2], k$0 = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_key,
		                           k$0,
		                           k,
		                           function(c){
		                            var
		                             a =
		                               521507869 <= dir
		                                ? 927731004 <= dir ? c <= 0 : 0 <= c
		                                : -640801497 <= dir ? c < 0 : 0 < c;
		                            return a
		                                    ? cont([0, [0, k$0, v]])
		                                    : cont(repackage(found_marker, found_key, found_value));
		                           });
		                 }
		                 var
		                  r = t[4],
		                  found_value$0 = t[3],
		                  found_key$0 = t[2],
		                  l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          found_key$0,
		                          k,
		                          function(c){
		                           if(0 === c)
		                            return -640801497 === dir
		                                    ? is_empty$4
		                                       (l)
		                                      ? cont(repackage(found_marker, found_key, found_value))
		                                      : cont(max_elt$2(l))
		                                    : -779285465
		                                      <= dir
		                                      ? cont([0, [0, found_key$0, found_value$0]])
		                                      : is_empty$4
		 (r)
		? cont(repackage(found_marker, found_key, found_value))
		: cont(min_elt$2(r));
		                           if(-640801497 !== dir && 927731004 > dir)
		                            return 0 < c
		                                    ? caml_exact_trampoline_call4
		                                      (a, l, 1, found_key$0, found_value$0)
		                                    : caml_exact_trampoline_call4
		                                      (a, r, found_marker, found_key, found_value);
		                           return 0 <= c
		                                   ? caml_exact_trampoline_call4
		                                     (a, l, found_marker, found_key, found_value)
		                                   : caml_exact_trampoline_call4
		                                     (a, r, 1, found_key$0, found_value$0);
		                          });
		                }
		                return a(t, 0, 0, 0);
		               }
		               function rank(t, k, compare_key, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var k$0 = t[1];
		                  return caml_trampoline_cps_call3
		                          (compare_key,
		                           k$0,
		                           k,
		                           function(a){return 0 === a ? cont(fX) : cont(0);});
		                 }
		                 var r = t[4], k$1 = t[2], l = t[1];
		                 return caml_trampoline_cps_call3
		                         (compare_key,
		                          k$1,
		                          k,
		                          function(c){
		                           if(0 === c) return cont([0, length$8(l)]);
		                           if(0 < c) return caml_exact_trampoline_call1(a, l);
		                           function b(rank, cont){
		                            return cont((rank + 1 | 0) + length$8(l) | 0);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (rank,
		                                    r,
		                                    k,
		                                    compare_key,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1(map$3, a, b, cont);
		                                    });
		                          });
		                }
		                return a(t);
		               }
		               function nth$0(num_to_search, a){
		                for(;;){
		                 if(typeof a === "number") return 0;
		                 if(0 === a[0]){
		                  var v = a[2], k = a[1];
		                  return 0 === num_to_search[1]
		                          ? [0, [0, k, v]]
		                          : (num_to_search[1]--, 0);
		                 }
		                 var
		                  r = a[4],
		                  v$0 = a[3],
		                  k$0 = a[2],
		                  l = a[1],
		                  some = nth$0(num_to_search, l);
		                 if(some) return some;
		                 if(0 === num_to_search[1]) return [0, [0, k$0, v$0]];
		                 num_to_search[1]--;
		                 a = r;
		                }
		               }
		               function nth$1(t, n){return nth$0([0, n], t);}
		               function find_first_satisfying$0(t, f, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var v = t[2], k = t[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (f,
		                           k,
		                           v,
		                           function(a){return a ? cont([0, [0, k, v]]) : cont(0);});
		                 }
		                 var r = t[4], v$0 = t[3], k$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          k$0,
		                          v$0,
		                          function(b){
		                           return b
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (find_first_satisfying$0,
		                                      l,
		                                      f,
		                                      function(x){return x ? cont(x) : cont([0, [0, k$0, v$0]]);})
		                                   : caml_exact_trampoline_call1(a, r);
		                          });
		                }
		                return a(t);
		               }
		               function find_last_satisfying$0(t, f, cont){
		                function a(t){
		                 if(typeof t === "number") return cont(0);
		                 if(0 === t[0]){
		                  var v = t[2], k = t[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (f,
		                           k,
		                           v,
		                           function(a){return a ? cont([0, [0, k, v]]) : cont(0);});
		                 }
		                 var r = t[4], v$0 = t[3], k$0 = t[2], l = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          k$0,
		                          v$0,
		                          function(b){
		                           return b
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (find_last_satisfying$0,
		                                      r,
		                                      f,
		                                      function(x){return x ? cont(x) : cont([0, [0, k$0, v$0]]);})
		                                   : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                return a(t);
		               }
		               function binary_search$1(t, compare, how, v, cont){
		                return -839473056 <= how
		                        ? 200870407
		                          <= how
		                          ? 926943384
		                            <= how
		                            ? caml_exact_trampoline_cps_call$1
		                              (find_first_satisfying$0,
		                               t,
		                               function(key, data, cont){
		                                return caml_trampoline_cps_call4
		(compare,
		 key,
		 data,
		 v,
		 function(a){return cont(0 <= a ? 1 : 0);});
		                               },
		                               cont)
		                            : caml_exact_trampoline_cps_call$1
		                              (find_last_satisfying$0,
		                               t,
		                               function(key, data, cont){
		                                return caml_trampoline_cps_call4
		(compare,
		 key,
		 data,
		 v,
		 function(a){return cont(a < 0 ? 1 : 0);});
		                               },
		                               cont)
		                          : -253007807
		                            <= how
		                            ? caml_exact_trampoline_cps_call$1
		                              (find_last_satisfying$0,
		                               t,
		                               function(key, data, cont){
		                                return caml_trampoline_cps_call4
		(compare,
		 key,
		 data,
		 v,
		 function(a){return cont(a <= 0 ? 1 : 0);});
		                               },
		                               cont)
		                            : caml_exact_trampoline_cps_call$1
		                              (find_first_satisfying$0,
		                               t,
		                               function(key, data, cont){
		                                return caml_trampoline_cps_call4
		(compare,
		 key,
		 data,
		 v,
		 function(a){return cont(0 < a ? 1 : 0);});
		                               },
		                               cont)
		                        : -1055410545
		                          <= how
		                          ? caml_exact_trampoline_cps_call$1
		                            (find_last_satisfying$0,
		                             t,
		                             function(key, data, cont){
		                              return caml_trampoline_cps_call4
		                                      (compare,
		                                       key,
		                                       data,
		                                       v,
		                                       function(a){return cont(a <= 0 ? 1 : 0);});
		                             },
		                             function(pair){
		                              function a(){return cont(0);}
		                              if(! pair) return a();
		                              var match = pair[1], data = match[2], key = match[1];
		                              return caml_trampoline_cps_call4
		                                      (compare,
		                                       key,
		                                       data,
		                                       v,
		                                       function(b){return 0 === b ? cont(pair) : a();});
		                             })
		                          : caml_exact_trampoline_cps_call$1
		                            (find_first_satisfying$0,
		                             t,
		                             function(key, data, cont){
		                              return caml_trampoline_cps_call4
		                                      (compare,
		                                       key,
		                                       data,
		                                       v,
		                                       function(a){return cont(0 <= a ? 1 : 0);});
		                             },
		                             function(pair){
		                              function a(){return cont(0);}
		                              if(! pair) return a();
		                              var match = pair[1], data = match[2], key = match[1];
		                              return caml_trampoline_cps_call4
		                                      (compare,
		                                       key,
		                                       data,
		                                       v,
		                                       function(b){return 0 === b ? cont(pair) : a();});
		                             });
		               }
		               function binary_search_segmented(t, segment_of, how, cont){
		                function is_left(key, data, cont){
		                 return caml_trampoline_cps_call3
		                         (segment_of,
		                          key,
		                          data,
		                          function(match){
		                           return 847852583 <= match ? cont(1) : cont(0);
		                          });
		                }
		                function is_right(key, data, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (is_left, key, data, function(a){return cont(1 - a);});
		                }
		                return 125585502 <= how
		                        ? caml_exact_trampoline_cps_call$1
		                          (find_last_satisfying$0, t, is_left, cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (find_first_satisfying$0, t, is_right, cont);
		               }
		               function binary_search_one_sided_bound
		               (t, maybe_bound, compare, if_exclusive, if_inclusive, cont){
		                function find_bound(t, how, bound, compare, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (binary_search$1,
		                          t,
		                          compare,
		                          how,
		                          bound,
		                          function(match){
		                           if(! match) return cont(0);
		                           var bound = match[1][1];
		                           return cont([0, [0, bound]]);
		                          });
		                }
		                if(typeof maybe_bound === "number") return cont(fY);
		                if(0 === maybe_bound[0]){
		                 var bound = maybe_bound[1];
		                 return caml_exact_trampoline_cps_call$2
		                         (find_bound, t, if_inclusive, bound, compare, cont);
		                }
		                var bound$0 = maybe_bound[1];
		                return caml_exact_trampoline_cps_call$2
		                        (find_bound, t, if_exclusive, bound$0, compare, cont);
		               }
		               function binary_search_two_sided_bounds
		               (t, compare, lower_bound, upper_bound, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (binary_search_one_sided_bound,
		                         t,
		                         lower_bound,
		                         compare,
		                         -839473056,
		                         926943384,
		                         function(match){
		                          if(! match) return cont(0);
		                          var lower_bound = match[1];
		                          return caml_exact_trampoline_cps_call$3
		                                  (binary_search_one_sided_bound,
		                                   t,
		                                   upper_bound,
		                                   compare,
		                                   200870407,
		                                   -253007807,
		                                   function(match){
		                                    if(! match) return cont(0);
		                                    var upper_bound = match[1];
		                                    return cont([0, [0, lower_bound, upper_bound]]);
		                                   });
		                         });
		               }
		               function of_iteri(iteri, compare_key, cont){
		                var acc = [0, 0, [0, empty_without_value_restrictio$0, 0]];
		                return caml_trampoline_cps_call2
		                        (iteri,
		                         function(key, data, cont){
		                          var match = acc[2], length = match[2], map = match[1];
		                          return caml_exact_trampoline_cps_call$3
		                                  (set$1,
		                                   map,
		                                   length,
		                                   key,
		                                   data,
		                                   compare_key,
		                                   function(pair){
		                                    var length$0 = pair[2];
		                                    if(length === length$0 && is_none$0(acc[1])){acc[1] = [0, key]; return cont(0);}
		                                    acc[2] = globalize(pair);
		                                    return cont(0);
		                                   });
		                         },
		                         function(a){
		                          a = acc[1];
		                          if(! a) return cont([0, 17724, acc[2]]);
		                          var key = a[1];
		                          return cont([0, -1048878709, key]);
		                         });
		               }
		               function of_iteri_exn(iteri, comparator, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_iteri,
		                         iteri,
		                         comparator[1],
		                         function(match){
		                          var variant = match[1];
		                          if(17724 <= variant){var v = match[2]; return cont(v);}
		                          var key = match[2];
		                          return caml_exact_trampoline_cps_call$3
		                                  (create$9,
		                                   0,
		                                   0,
		                                   "Map.of_iteri_exn: duplicate key",
		                                   key,
		                                   comparator[2],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(raise, a, cont);
		                                   });
		                         });
		               }
		               function t_of_sexp_direct
		               (key_of_sexp, value_of_sexp, sexp, comparator, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (list_of_sexp,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (pair_of_sexp, key_of_sexp, value_of_sexp, a, cont);
		                         },
		                         sexp,
		                         function(alist){
		                          var compare_key = comparator[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_alist,
		                                   alist,
		                                   compare_key,
		                                   function(match){
		                                    var variant = match[1];
		                                    if(17724 <= variant){var v = match[2]; return cont(v);}
		                                    var k = match[2];
		                                    function a(a, cont){return cont(a);}
		                                    function b(a, cont){return cont(a);}
		                                    return caml_exact_trampoline_cps_call$1
		    (list_of_sexp,
		     function(c, cont){
		      return caml_exact_trampoline_cps_call$0
		              (pair_of_sexp, b, a, c, cont);
		     },
		     sexp,
		     function(alist_sexps){
		      function a(found_first_k, l1$0, l2$0){
		       function b(a){
		        a = caml_pop_trap();
		        return a
		                (caml_maybe_attach_backtrace([0, Assert_failure, fZ], 1));
		       }
		       if(l1$0){
		        if(l2$0){
		         var
		          l2 = l2$0[2],
		          a2 = l2$0[1],
		          l1 = l1$0[2],
		          a1 = l1$0[1],
		          k2_sexp = a2[1],
		          k2 = a1[1];
		         return caml_trampoline_cps_call3
		                 (compare_key,
		                  k,
		                  k2,
		                  function(b){
		                   return 0 === b
		                           ? found_first_k
		                             ? (of_sexp_error
		                                ("Map.t_of_sexp_direct: duplicate key", k2_sexp),
		                               caml_exact_trampoline_call3(a, found_first_k, l1, l2))
		                             : caml_exact_trampoline_call3(a, 1, l1, l2)
		                           : caml_exact_trampoline_call3(a, found_first_k, l1, l2);
		                  });
		        }
		       }
		       else if(! l2$0) return b(0);
		       return caml_exact_trampoline_cps_call
		               (invalid_arg, "List.iter2", b);
		      }
		      return a(0, alist, alist_sexps);
		     });
		                                   });
		                         });
		               }
		               function sexp_of_t$14(sexp_of_key, sexp_of_value, t, cont){
		                function f(key, data, acc, cont){
		                 return caml_trampoline_cps_call2
		                         (sexp_of_value,
		                          data,
		                          function(b){
		                           var a = [0, b, 0];
		                           return caml_trampoline_cps_call2
		                                   (sexp_of_key,
		                                    key,
		                                    function(b){return cont([0, [1, [0, b, a]], acc]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$2, t, 0, f, function(a){return cont([1, a]);});
		               }
		               function combine_errors(t, sexp_of_key, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partition_map$0,
		                         t,
		                         to_either,
		                         function(match){
		                          var errors = match[2], oks = match[1];
		                          return is_empty$4(errors)
		                                  ? cont([0, oks])
		                                  : caml_exact_trampoline_cps_call$0
		                                    (sexp_of_t$14,
		                                     sexp_of_key,
		                                     sexp_of_t$2,
		                                     errors,
		                                     function(a){return cont(error_s(a));});
		                         });
		               }
		               function unzip$0(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$12,
		                         t,
		                         get_data,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$12, t, calendar, function(b){return cont([0, b, a]);});
		                         });
		               }
		               function map_keys(t1, f, param, cont){
		                var sexp_of_key = param[2], compare_key = param[1];
		                return caml_exact_trampoline_cps_call
		                        (with_return,
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fold$4,
		                                   t1,
		                                   [0, empty_without_value_restrictio$0, 0],
		                                   function(key, data, param$0, cont){
		                                    var length = param$0[2], t2 = param$0[1];
		                                    return caml_trampoline_cps_call2
		    (f,
		     key,
		     function(key){
		      caml_push_trap
		       (function(exn){
		         if(exn === Duplicate)
		          return caml_exact_trampoline_cps_call
		                  (param, [0, -1048878709, key], cont);
		         var
		          raise = caml_pop_trap(),
		          exn$0 = caml_maybe_attach_backtrace(exn, 0);
		         return raise(exn$0);
		        });
		      return caml_exact_trampoline_cps_call$7
		              (add_exn_internal,
		               t2,
		               length,
		               key,
		               data,
		               compare_key,
		               sexp_of_key,
		               function(a){
		                a = globalize(a);
		                caml_pop_trap();
		                return cont(a);
		               });
		     });
		                                   },
		                                   function(a){return cont([0, 17724, a]);});
		                         },
		                         cont);
		               }
		               function map_keys_exn(t, f, comparator, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (map_keys,
		                         t,
		                         f,
		                         comparator,
		                         function(match){
		                          var variant = match[1];
		                          if(17724 <= variant){
		                           var result = match[2];
		                           return cont(result);
		                          }
		                          var key = match[2], sexp_of_key = comparator[2];
		                          return caml_trampoline_cps_call2
		                                  (sexp_of_key,
		                                   key,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (raise_s,
		     message
		      ("Map.map_keys_exn: duplicate key", [0, [0, cst_key, a], 0]),
		     cont);
		                                   });
		                         });
		               }
		               function transpose_keys
		               (outer_comparator, inner_comparator, outer_t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         outer_t,
		                         [0, empty_without_value_restrictio$0, 0],
		                         function(outer_key, inner_t, acc, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fold$4,
		                                   inner_t,
		                                   acc,
		                                   function(inner_key, data, param, cont){
		                                    var acc_len = param[2], acc = param[1];
		                                    return caml_exact_trampoline_cps_call$3
		    (update,
		     acc,
		     inner_key,
		     function(a, cont){
		      if(a){
		       a = a[1];
		       var elt_len = a[2], elt = a[1];
		       return caml_exact_trampoline_cps_call$3
		               (set$1,
		                elt,
		                elt_len,
		                outer_key,
		                data,
		                outer_comparator[1],
		                function(a){return cont(globalize(a));});
		      }
		      var tree = [0, outer_key, data];
		      return cont([0, tree, 1]);
		     },
		     acc_len,
		     inner_comparator[1],
		     function(a){return cont(globalize(a));});
		                                   },
		                                   cont);
		                         },
		                         cont);
		               }
		               function compare_key(t){return t[1][1];}
		               function like$0(a, param){
		                var length = param[2], tree = param[1], comparator = a[1];
		                return [0, comparator, tree, length];
		               }
		               function like_maybe_no_op$0(old_t, param){
		                var
		                 length = param[2],
		                 tree = param[1],
		                 old_tree = old_t[2],
		                 comparator = old_t[1];
		                return old_tree === tree
		                        ? old_t
		                        : [0, comparator, tree, length];
		               }
		               function with_same_length(param, tree){
		                var length = param[3], comparator = param[1];
		                return [0, comparator, tree, length];
		               }
		               function of_like_tree(t, tree){
		                var a = length$8(tree);
		                return [0, t[1], tree, a];
		               }
		               function of_like_tree_maybe_no_op(t, tree){
		                if(t[2] === tree) return t;
		                var a = length$8(tree);
		                return [0, t[1], tree, a];
		               }
		               function of_tree$0(comparator, tree){
		                return [0, comparator, tree, length$8(tree)];
		               }
		               function comparator$5(t, cont){return cont(t[1]);}
		               function to_tree(t, cont){return cont(t[2]);}
		               function invariants$0(t, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$1
		                        (invariants,
		                         t[2],
		                         a,
		                         function(a){
		                          if(a){a = t[3]; a = length$8(t[2]) === a ? 1 : 0;}
		                          return cont(a);
		                         });
		               }
		               function is_empty$5(t, cont){return cont(is_empty$4(t[2]));}
		               function length$9(t, cont){return cont(t[3]);}
		               function set$3(t, key, data, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$3
		                        (set$1,
		                         t[2],
		                         t[3],
		                         key,
		                         data,
		                         a,
		                         function(a){return cont(like$0(t, a));});
		               }
		               function add_exn$0(t, key, data, cont){
		                var a = t[1][2], b = compare_key(t);
		                return caml_exact_trampoline_cps_call$7
		                        (add_exn,
		                         t[2],
		                         t[3],
		                         key,
		                         data,
		                         b,
		                         a,
		                         function(a){return cont(like$0(t, a));});
		               }
		               function add$5(t, key, data, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(exn === Duplicate) return cont(-1024851605);
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                var a = t[1][2], b = compare_key(t);
		                return caml_exact_trampoline_cps_call$7
		                        (add_exn_internal,
		                         t[2],
		                         t[3],
		                         key,
		                         data,
		                         b,
		                         a,
		                         function(a){
		                          var result = like$0(t, a);
		                          caml_pop_trap();
		                          return cont([0, 17724, result]);
		                         });
		               }
		               function add_multi$0(t, key, data, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$3
		                        (add_multi,
		                         t[2],
		                         t[3],
		                         key,
		                         data,
		                         a,
		                         function(a){return cont(like$0(t, a));});
		               }
		               function remove_multi$0(t, key, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$2
		                        (remove_multi,
		                         t[2],
		                         key,
		                         t[3],
		                         a,
		                         function(a){return cont(like$0(t, a));});
		               }
		               function find_multi$0(t, key, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$0
		                        (find_multi, t[2], key, a, cont);
		               }
		               function change$0(t, key, f, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$3
		                        (change,
		                         t[2],
		                         key,
		                         f,
		                         t[3],
		                         a,
		                         function(a){return cont(like$0(t, a));});
		               }
		               function update$0(t, key, f, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$3
		                        (update,
		                         t[2],
		                         key,
		                         f,
		                         t[3],
		                         a,
		                         function(a){return cont(like$0(t, a));});
		               }
		               function find_packed_by_id_exn(t, key, cont){
		                var a = t[1][2], b = compare_key(t);
		                return caml_exact_trampoline_cps_call$2
		                        (find_exn, t[2], key, b, a, cont);
		               }
		               function find_packed_by_id(t, key, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$0
		                        (find$2, t[2], key, a, cont);
		               }
		               function remove$2(t, key, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$2
		                        (remove$1,
		                         t[2],
		                         key,
		                         t[3],
		                         a,
		                         function(a){return cont(like_maybe_no_op$0(t, a));});
		               }
		               function mem$5(t, key, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$0
		                        (mem$4, t[2], key, a, cont);
		               }
		               function iter_keys$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (iter_keys, t[2], f, cont);
		               }
		               function iter$5(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(iter$4, t[2], f, cont);
		               }
		               function iteri$1(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (iteri$0, t[2], f, cont);
		               }
		               function iteri_until(t, f, cont){
		                var t$0 = t[2];
		                return caml_exact_trampoline_cps_call$1
		                        (iteri_until_loop, t$0, f, cont);
		               }
		               function iter2$0(t1, t2, f, cont){
		                var a = compare_key(t1);
		                return caml_exact_trampoline_cps_call$2
		                        (iter2, t1[2], t2[2], f, a, cont);
		               }
		               function map$13(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$12,
		                         t[2],
		                         f,
		                         function(a){return cont(with_same_length(t, a));});
		               }
		               function mapi$3(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (mapi$2,
		                         t[2],
		                         f,
		                         function(a){return cont(with_same_length(t, a));});
		               }
		               function fold$5(t, init, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4, t[2], init, f, cont);
		               }
		               function fold_until$1(t, init, f, finish, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (fold_until$0, t[2], init, f, finish, cont);
		               }
		               function fold_right$3(t, init, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$2, t[2], init, f, cont);
		               }
		               function fold2$1(t1, t2, init, f, cont){
		                var a = compare_key(t1);
		                return caml_exact_trampoline_cps_call$3
		                        (fold2$0, t1[2], t2[2], init, f, a, cont);
		               }
		               function filter_keys$0(t, f, cont){
		                var len = [0, t[3]];
		                return caml_exact_trampoline_cps_call$0
		                        (filter_keys,
		                         t[2],
		                         f,
		                         len,
		                         function(tree){
		                          var length = len[1];
		                          return cont(like_maybe_no_op$0(t, [0, tree, length]));
		                         });
		               }
		               function filter$5(t, f, cont){
		                var len = [0, t[3]];
		                return caml_exact_trampoline_cps_call$0
		                        (filter$4,
		                         t[2],
		                         f,
		                         len,
		                         function(tree){
		                          var length = len[1];
		                          return cont(like_maybe_no_op$0(t, [0, tree, length]));
		                         });
		               }
		               function filteri$0(t, f, cont){
		                var len = [0, t[3]];
		                return caml_exact_trampoline_cps_call$0
		                        (filteri,
		                         t[2],
		                         f,
		                         len,
		                         function(tree){
		                          var length = len[1];
		                          return cont(like_maybe_no_op$0(t, [0, tree, length]));
		                         });
		               }
		               function filter_map$3(t, f, cont){
		                var len = [0, t[3]];
		                return caml_exact_trampoline_cps_call$0
		                        (filter_map$2,
		                         t[2],
		                         f,
		                         len,
		                         function(tree){
		                          var length = len[1];
		                          return cont(like$0(t, [0, tree, length]));
		                         });
		               }
		               function filter_mapi$1(t, f, cont){
		                var len = [0, t[3]];
		                return caml_exact_trampoline_cps_call$0
		                        (filter_mapi$0,
		                         t[2],
		                         f,
		                         len,
		                         function(tree){
		                          var length = len[1];
		                          return cont(like$0(t, [0, tree, length]));
		                         });
		               }
		               function of_like_tree2(t, a){
		                var t2 = a[2], t1 = a[1], a = of_like_tree(t, t2);
		                return [0, of_like_tree(t, t1), a];
		               }
		               function of_like_tree2_maybe_no_op(t, a){
		                var t2 = a[2], t1 = a[1], a = of_like_tree_maybe_no_op(t, t2);
		                return [0, of_like_tree_maybe_no_op(t, t1), a];
		               }
		               function partition_mapi$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partition_mapi,
		                         t[2],
		                         f,
		                         function(a){return cont(of_like_tree2(t, a));});
		               }
		               function partition_map$1(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partition_map$0,
		                         t[2],
		                         f,
		                         function(a){return cont(of_like_tree2(t, a));});
		               }
		               function partitioni_tf$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partitioni_tf,
		                         t[2],
		                         f,
		                         function(a){return cont(of_like_tree2_maybe_no_op(t, a));});
		               }
		               function partition_tf$2(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partition_tf$1,
		                         t[2],
		                         f,
		                         function(a){return cont(of_like_tree2_maybe_no_op(t, a));});
		               }
		               function combine_errors$0(t, cont){
		                function a(a, cont){return cont(of_like_tree(t, a));}
		                return caml_exact_trampoline_cps_call$1
		                        (combine_errors,
		                         t[2],
		                         t[1][2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                         });
		               }
		               function unzip$1(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (unzip$0,
		                         t[2],
		                         function(a){return cont(of_like_tree2(t, a));});
		               }
		               function compare_direct(compare_data, t1, t2, cont){
		                var a = t2[2], b = t1[2];
		                return caml_exact_trampoline_cps_call$2
		                        (compare$17, compare_key(t1), compare_data, b, a, cont);
		               }
		               function equal$11(compare_data, t1, t2, cont){
		                var a = t2[2], b = t1[2];
		                return caml_exact_trampoline_cps_call$2
		                        (equal$10, compare_key(t1), compare_data, b, a, cont);
		               }
		               function keys$0(t, cont){
		                return caml_exact_trampoline_cps_call(keys, t[2], cont);
		               }
		               function encode(t, cont){
		                return caml_exact_trampoline_cps_call(data, t[2], cont);
		               }
		               function to_alist$0(key_order, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_alist, key_order, t[2], cont);
		               }
		               function symmetric_diff$2(t1, t2, data_equal, cont){
		                var a = compare_key(t1);
		                return cont(symmetric_diff$1(t1[2], t2[2], a, data_equal));
		               }
		               function fold_symmetric_diff$1
		               (t1, t2, data_equal, init, f, cont){
		                var a = compare_key(t1);
		                return caml_exact_trampoline_cps_call$7
		                        (fold_symmetric_diff$0,
		                         t1[2],
		                         t2[2],
		                         a,
		                         data_equal,
		                         init,
		                         f,
		                         cont);
		               }
		               function merge$1(t1, t2, f, cont){
		                var a = compare_key(t1);
		                return caml_exact_trampoline_cps_call$2
		                        (merge$0,
		                         t1[2],
		                         t2[2],
		                         f,
		                         a,
		                         function(a){return cont(like$0(t1, a));});
		               }
		               function merge_disjoint_exn$0(t1, t2, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (merge_disjoint_exn,
		                         t1[2],
		                         t2[2],
		                         t1[3],
		                         t2[3],
		                         t1[1],
		                         function(a){return cont(like$0(t1, a));});
		               }
		               function merge_skewed$0(t1, t2, combine, cont){
		                var a = compare_key(t1);
		                return caml_exact_trampoline_cps_call$7
		                        (merge_skewed,
		                         t1[2],
		                         t2[2],
		                         t1[3],
		                         t2[3],
		                         combine,
		                         a,
		                         function(a){
		                          var t1$0 = t2[3] <= t1[3] ? t1 : t2;
		                          return cont(like_maybe_no_op$0(t1$0, a));
		                         });
		               }
		               function min_elt$3(t, cont){return cont(min_elt$2(t[2]));}
		               function min_elt_exn$1(t, cont){
		                return cont(min_elt_exn$0(t[2]));
		               }
		               function max_elt$3(t, cont){return cont(max_elt$2(t[2]));}
		               function max_elt_exn$0(t, cont){
		                return cont(max_elt_exn(t[2]));
		               }
		               function for_all$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (for_all, t[2], f, cont);
		               }
		               function for_alli$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (for_alli, t[2], f, cont);
		               }
		               function exists$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(exists, t[2], f, cont);
		               }
		               function existsi$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (existsi, t[2], f, cont);
		               }
		               function count$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(count, t[2], f, cont);
		               }
		               function counti$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(counti, t[2], f, cont);
		               }
		               function sum$1(m, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (sum$0, m, t[2], f, cont);
		               }
		               function sumi$0(m, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (sumi, m, t[2], f, cont);
		               }
		               function split$3(t, k, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$0
		                        (split$2,
		                         t[2],
		                         k,
		                         a,
		                         function(a){
		                          var
		                           tree = a[3],
		                           maybe = a[2],
		                           tree$0 = a[1],
		                           comparator = t[1],
		                           both_len = is_some(maybe) ? t[3] - 1 | 0 : t[3],
		                           a = height$0(tree);
		                          if(height$0(tree$0) < a){
		                           var
		                            l = of_tree$0(comparator, tree$0),
		                            length = both_len - l[3] | 0;
		                           return cont([0, l, maybe, [0, comparator, tree, length]]);
		                          }
		                          var
		                           r = of_tree$0(comparator, tree),
		                           length$0 = both_len - r[3] | 0;
		                          return cont
		                                  ([0, [0, comparator, tree$0, length$0], maybe, r]);
		                         });
		               }
		               function split_and_reinsert_boundary$0(t, into, k, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$2
		                        (split_and_reinsert_boundary,
		                         t[2],
		                         into,
		                         k,
		                         a,
		                         function(a){
		                          var
		                           tree = a[2],
		                           tree$0 = a[1],
		                           comparator = t[1],
		                           a = height$0(tree);
		                          if(height$0(tree$0) < a){
		                           var
		                            l = of_tree$0(comparator, tree$0),
		                            length = t[3] - l[3] | 0;
		                           return cont([0, l, [0, comparator, tree, length]]);
		                          }
		                          var
		                           r = of_tree$0(comparator, tree),
		                           length$0 = t[3] - r[3] | 0;
		                          return cont([0, [0, comparator, tree$0, length$0], r]);
		                         });
		               }
		               function split_le_gt(t, k, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (split_and_reinsert_boundary$0, t, 847852583, k, cont);
		               }
		               function split_lt_ge(t, k, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (split_and_reinsert_boundary$0, t, -57574468, k, cont);
		               }
		               function subrange(t, lower_bound, upper_bound, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$2
		                        (split_range,
		                         t[2],
		                         lower_bound,
		                         upper_bound,
		                         a,
		                         function(match){
		                          var
		                           right = match[3],
		                           tree = match[2],
		                           left = match[1],
		                           h_l = height$0(left),
		                           h_r = height$0(right);
		                          function a(outer_joined_height){
		                           if(outer_joined_height >= height$0(tree))
		                            return cont(of_tree$0(t[1], tree));
		                           var
		                            a = length$8(right),
		                            a = length$8(left) + a | 0,
		                            mid_length = t[3] - a | 0,
		                            comparator = t[1];
		                           return cont([0, comparator, tree, mid_length]);
		                          }
		                          return h_l === h_r
		                                  ? a(h_l + 1 | 0)
		                                  : caml_exact_trampoline_cps_call$1(max$2, h_l, h_r, a);
		                         });
		               }
		               function append$3(lower_part, upper_part, cont){
		                var a = compare_key(lower_part);
		                return caml_exact_trampoline_cps_call$0
		                        (append$2,
		                         lower_part[2],
		                         upper_part[2],
		                         a,
		                         function(match){
		                          if(typeof match === "number") return cont(838882908);
		                          var
		                           tree = match[2],
		                           length = lower_part[3] + upper_part[3] | 0,
		                           comparator = lower_part[1];
		                          return cont([0, 17724, [0, comparator, tree, length]]);
		                         });
		               }
		               function fold_range_inclusive$0(t, min, max, init, f, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$7
		                        (fold_range_inclusive, t[2], min, max, init, f, a, cont);
		               }
		               function range_to_alist$0(t, min, max, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$2
		                        (range_to_alist, t[2], min, max, a, cont);
		               }
		               function closest_key$0(t, dir, key, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$2
		                        (closest_key, t[2], dir, key, a, cont);
		               }
		               function nth$2(t, n, cont){return cont(nth$1(t[2], n));}
		               function nth_exn(t, n, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (nth$2,
		                         t,
		                         n,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (value_exn, 0, 0, 0, a, cont);
		                         });
		               }
		               function rank$0(t, key, cont){
		                var a = compare_key(t);
		                return caml_exact_trampoline_cps_call$0
		                        (rank, t[2], key, a, cont);
		               }
		               function sexp_of_t$15(sexp_of_k, sexp_of_v, param, t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (sexp_of_t$14, sexp_of_k, sexp_of_v, t[2], cont);
		               }
		               function to_sequence$2
		               (order,
		                keys_greater_or_equal_to,
		                keys_less_or_equal_to,
		                t,
		                cont){
		                return caml_exact_trampoline_cps_call$3
		                        (to_sequence$1,
		                         t[1],
		                         order,
		                         keys_greater_or_equal_to,
		                         keys_less_or_equal_to,
		                         t[2],
		                         cont);
		               }
		               function binary_search$2(t, compare, how, v, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (binary_search$1, t[2], compare, how, v, cont);
		               }
		               function binary_search_segmented$0(t, segment_of, how, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (binary_search_segmented, t[2], segment_of, how, cont);
		               }
		               function hash_fold_direct
		               (hash_fold_key, hash_fold_data, state, t, cont){
		                var t$0 = t[2];
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4,
		                         t$0,
		                         Base_internalhash_fold_int(state, length$8(t$0)),
		                         function(key, data, state, cont){
		                          return caml_trampoline_cps_call3
		                                  (hash_fold_key,
		                                   state,
		                                   key,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (hash_fold_data, a, data, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function binary_search_subrange
		               (t, compare, lower_bound, upper_bound, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (binary_search_two_sided_bounds,
		                         t[2],
		                         compare,
		                         lower_bound,
		                         upper_bound,
		                         function(a){
		                          if(! a) return cont(like_maybe_no_op$0(t, [0, 0, 0]));
		                          a = a[1];
		                          var upper_bound = a[2], lower_bound = a[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (subrange, t, lower_bound, upper_bound, cont);
		                         });
		               }
		               function is_empty$6(t){return is_empty$4(t);}
		               function find$3(comparator, t, key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (find$2, t, key, comparator[1], cont);
		               }
		               function fold$6(t, init, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$4, t, init, f, cont);
		               }
		               function empty$10(comparator){
		                return [0, comparator, empty_without_value_restrictio$0, 0];
		               }
		               function singleton$2(comparator, key, data){return [0, comparator, [0, key, data], 1];
		               }
		               function of_tree0(comparator, param){
		                var length = param[2], tree = param[1];
		                return [0, comparator, tree, length];
		               }
		               function of_sorted_array_unchecked$0(comparator, array, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sorted_array_unchecked,
		                         array,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_sorted_array$0(comparator, array, cont){
		                function a(tree, cont){
		                 return cont(of_tree0(comparator, tree));
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (of_sorted_array,
		                         array,
		                         comparator[1],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                         });
		               }
		               function of_alist$0(comparator, alist, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist,
		                         alist,
		                         comparator[1],
		                         function(z){
		                          var variant = z[1];
		                          if(17724 > variant) return cont(z);
		                          var match = z[2], length = match[2], tree = match[1];
		                          return cont([0, 17724, [0, comparator, tree, length]]);
		                         });
		               }
		               function of_alist_or_error$0(comparator, alist, cont){
		                function a(tree, cont){
		                 return cont(of_tree0(comparator, tree));
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist_or_error,
		                         alist,
		                         comparator,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                         });
		               }
		               function of_alist_exn$0(comparator, alist, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist_exn,
		                         alist,
		                         comparator,
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_alist_multi$0(comparator, alist, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist_multi,
		                         alist,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_alist_fold$0(comparator, alist, init, f, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (of_alist_fold,
		                         alist,
		                         init,
		                         f,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_alist_reduce$0(comparator, alist, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_alist_reduce,
		                         alist,
		                         f,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_iteri$0(comparator, iteri, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_iteri,
		                         iteri,
		                         comparator[1],
		                         function(z){
		                          var variant = z[1];
		                          if(17724 > variant) return cont(z);
		                          var tree_length = z[2];
		                          return cont([0, 17724, of_tree0(comparator, tree_length)]);
		                         });
		               }
		               function of_iteri_exn$0(comparator, iteri, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_iteri_exn,
		                         iteri,
		                         comparator,
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_increasing_iterator_uncheck$0
		               (comparator, length, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_increasing_iterator_uncheck,
		                         length,
		                         f,
		                         function(tree){
		                          return cont(of_tree0(comparator, [0, tree, length]));
		                         });
		               }
		               function of_increasing_sequence$0(comparator, seq, cont){
		                function a(x, cont){return cont(of_tree0(comparator, x));}
		                return caml_exact_trampoline_cps_call$1
		                        (of_increasing_sequence,
		                         seq,
		                         comparator[1],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                         });
		               }
		               function of_sequence$2(comparator, seq, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence$1,
		                         seq,
		                         comparator[1],
		                         function(z){
		                          var variant = z[1];
		                          if(17724 > variant) return cont(z);
		                          var match = z[2], length = match[2], tree = match[1];
		                          return cont([0, 17724, [0, comparator, tree, length]]);
		                         });
		               }
		               function of_sequence_or_error$0(comparator, seq, cont){
		                function a(tree, cont){
		                 return cont(of_tree0(comparator, tree));
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence_or_error,
		                         seq,
		                         comparator,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                         });
		               }
		               function of_sequence_exn$0(comparator, seq, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence_exn,
		                         seq,
		                         comparator,
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_sequence_multi$0(comparator, seq, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence_multi,
		                         seq,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_sequence_fold$0(comparator, seq, init, f, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (of_sequence_fold,
		                         seq,
		                         init,
		                         f,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_sequence_reduce$0(comparator, seq, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_sequence_reduce,
		                         seq,
		                         f,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_list_with_key$0(comparator, list, get_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key,
		                         list,
		                         get_key,
		                         comparator[1],
		                         function(z){
		                          var variant = z[1];
		                          if(17724 > variant) return cont(z);
		                          var match = z[2], length = match[2], tree = match[1];
		                          return cont([0, 17724, [0, comparator, tree, length]]);
		                         });
		               }
		               function of_list_with_key_or_error$0
		               (comparator, list, get_key, cont){
		                function a(tree, cont){
		                 return cont(of_tree0(comparator, tree));
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key_or_error,
		                         list,
		                         get_key,
		                         comparator,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                         });
		               }
		               function of_list_with_key_exn$0
		               (comparator, list, get_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key_exn,
		                         list,
		                         get_key,
		                         comparator,
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_list_with_key_multi$0
		               (comparator, list, get_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key_multi,
		                         list,
		                         get_key,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_list_with_key_fold$0
		               (comparator, list, get_key, init, f, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (of_list_with_key_fold,
		                         list,
		                         get_key,
		                         init,
		                         f,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function of_list_with_key_reduce$0
		               (comparator, list, get_key, f, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (of_list_with_key_reduce,
		                         list,
		                         get_key,
		                         f,
		                         comparator[1],
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function t_of_sexp_direct$0
		               (comparator, k_of_sexp, v_of_sexp, sexp, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (t_of_sexp_direct,
		                         k_of_sexp,
		                         v_of_sexp,
		                         sexp,
		                         comparator,
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function map_keys$0(comparator, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (map_keys,
		                         t[2],
		                         f,
		                         comparator,
		                         function(dup){
		                          var variant = dup[1];
		                          if(17724 > variant) return cont(dup);
		                          var pair = dup[2];
		                          return cont([0, 17724, of_tree0(comparator, pair)]);
		                         });
		               }
		               function map_keys_exn$0(comparator, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (map_keys_exn,
		                         t[2],
		                         f,
		                         comparator,
		                         function(a){return cont(of_tree0(comparator, a));});
		               }
		               function transpose_keys$0(inner_comparator, t, cont){
		                var outer_comparator = t[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$12,
		                         t[2],
		                         to_tree,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (transpose_keys,
		                                   outer_comparator,
		                                   inner_comparator,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$13,
		     of_tree0(inner_comparator, a),
		     function(x, cont){
		      return cont(of_tree0(outer_comparator, x));
		     },
		     cont);
		                                   });
		                         });
		               }
		               function Empty_without_value_restrictio$0(K){}
		               function get_comparator(t, cont){
		                var t$0 = t[1];
		                return cont([0, t$0]);
		               }
		               function of_tree$1(m, tree, cont){
		                return cont(of_tree$0(m[1], tree));
		               }
		               function empty$11(m){return empty$10(m[1]);}
		               function singleton$3(m, a){
		                var b = m[1];
		                return function(c){return singleton$2(b, a, c);};
		               }
		               function of_alist$1(m, a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist$0, m[1], a, cont);
		               }
		               function of_alist_exn$1(m, a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist_exn$0, m[1], a, cont);
		               }
		               function of_alist_multi$1(m, a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist_multi$0, m[1], a, cont);
		               }
		               function of_alist_reduce$1(m, a, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_alist_reduce$0, m[1], a, f, cont);
		               }
		               function of_iteri_exn$1(m, iteri, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_iteri_exn$0, m[1], iteri, cont);
		               }
		               function of_increasing_sequence$1(m, seq, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_increasing_sequence$0, m[1], seq, cont);
		               }
		               function of_sequence$3(m, s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence$2, m[1], s, cont);
		               }
		               function of_sequence_exn$1(m, s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence_exn$0, m[1], s, cont);
		               }
		               function of_sequence_multi$1(m, s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_sequence_multi$0, m[1], s, cont);
		               }
		               function of_sequence_reduce$1(m, s, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_sequence_reduce$0, m[1], s, f, cont);
		               }
		               function of_list_with_key$1(m, l, get_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key$0, m[1], l, get_key, cont);
		               }
		               function of_list_with_key_or_error$1(m, l, get_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key_or_error$0, m[1], l, get_key, cont);
		               }
		               function of_list_with_key_exn$1(m, l, get_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key_exn$0, m[1], l, get_key, cont);
		               }
		               function of_list_with_key_multi$1(m, l, get_key, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_list_with_key_multi$0, m[1], l, get_key, cont);
		               }
		               function of_list_with_key_fold$1(m, l, get_key, init, f, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (of_list_with_key_fold$0, m[1], l, get_key, init, f, cont);
		               }
		               function of_list_with_key_reduce$1(m, l, get_key, f, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (of_list_with_key_reduce$0, m[1], l, get_key, f, cont);
		               }
		               function map_keys$1(m, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (map_keys$0, m[1], t, f, cont);
		               }
		               function map_keys_exn$1(m, t, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (map_keys_exn$0, m[1], t, f, cont);
		               }
		               function transpose_keys$1(m, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (transpose_keys$0, m[1], t, cont);
		               }
		               function sexp_of_m_t$0(K, sexp_of_v, t, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (sexp_of_t$15, K[1], sexp_of_v, dummy, t, cont);
		               }
		               function m_t_of_sexp(K, v_of_sexp, sexp, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (t_of_sexp_direct$0, K[2], K[1], v_of_sexp, sexp, cont);
		               }
		               function m_t_sexp_grammar(K, v_grammar, cont){
		                return cont
		                        ([5,
		                          [0,
		                           "sexp_grammar.assoc",
		                           f2,
		                           [2,
		                            [1,
		                             [2,
		                              [0,
		                               [5, [0, "sexp_grammar.assoc.key", f1, K[1]]],
		                               [0, [5, [0, "sexp_grammar.assoc.value", f0, v_grammar]], 0]]]]]]]);
		               }
		               function compare_m_t(param, compare_v, t1, t2, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (compare_direct, compare_v, t1, t2, cont);
		               }
		               function equal_m_t(param, equal_v, t1, t2, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (equal$11, equal_v, t1, t2, cont);
		               }
		               function hash_fold_m_t(K, hash_fold_v, state, cont){
		                var a = K[1];
		                return cont
		                        (function(b, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (hash_fold_direct, a, hash_fold_v, state, b, cont);
		                         });
		               }
		               function hash$12(x, cont){return cont(hash_int64(x));}
		               function compare$18(b, a, cont){
		                return cont(caml_int64_compare(b, a));
		               }
		               var
		                include$14 = Make$1([0, compare$18, sexp_of_int64]),
		                comparator$6 = include$14[1],
		                num_bits$1 = 64,
		                float_lower_bound$0 = lower_bound_for_int(num_bits$1),
		                float_upper_bound$0 = upper_bound_for_int(num_bits$1);
		               function shift_right$2(b, a){
		                return caml_int64_shift_right(b, a);
		               }
		               function shift_left$1(b, a){
		                return caml_int64_shift_left(b, a);
		               }
		               function rem$1(b, a){return caml_int64_mod(b, a);}
		               function to_float(a, cont){
		                return cont(caml_int64_to_float(a));
		               }
		               function of_float$0(f, cont){
		                if(float_lower_bound$0 <= f && f <= float_upper_bound$0)
		                 return cont(caml_int64_of_float(f));
		                var a = f + 0.;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         f3,
		                         function(b){
		                          return caml_trampoline_cps_call3(b, a, 0, cont);
		                         });
		               }
		               function between$3(t, low, high, cont){
		                var
		                 a = caml_lessequal(low, t),
		                 a = a ? caml_lessequal(t, high) : a;
		                return cont(a);
		               }
		               function clamp_unchecked$2(t, min, max, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (min$3,
		                         t,
		                         max,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1(max$3, min, a, cont);
		                         });
		               }
		               function clamp_exn$2(t, min, max, a){
		                if(caml_lessequal(min, max))
		                 return caml_exact_trampoline_cps_call$0
		                         (clamp_unchecked$2, t, min, max, a);
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, f4], 1));
		               }
		               function clamp$2(t, min, max, cont){
		                if(! caml_greaterthan(min, max))
		                 return caml_exact_trampoline_cps_call$0
		                         (clamp_unchecked$2,
		                          t,
		                          min,
		                          max,
		                          function(a){return cont([0, a]);});
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int64,
		                         max,
		                         function(b){
		                          var a = [0, [0, cst_max, b], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int64,
		                                   min,
		                                   function(b){
		                                    return cont
		    (error_s
		      (message
		        (cst_clamp_requires_min_max, [0, [0, cst_min, b], a])));
		                                   });
		                         });
		               }
		               function of_int_exn$1(a, cont){
		                return cont(caml_int64_of_int32(a));
		               }
		               var
		                include$15 = Make$3([0, int64_to_string]),
		                sexp_of_int64$0 = include$15[2],
		                pp$3 = bPU([0, , int64_to_string])[1],
		                include$16 =
		                  caml_callback
		                   (bO$,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      int64_to_string,
		                      function(b, a){return caml_int64_add(b, a);},
		                      function(b, a){return caml_int64_sub(b, a);},
		                      ,
		                      function(b, a){return caml_int64_div(b, a);},
		                      ,
		                      ,
		                      function(b, a){return caml_lessequal(b, a);},
		                      ,
		                      ,
		                      function(b, a){return caml_lessthan(b, a);},
		                      ,
		                      ,
		                      ,
		                      min_value,
		                      of_int_exn$1,
		                      rem$1]]),
		                symbol$28 = include$16[1];
		               function compare$19(b, a, cont){
		                return cont(caml_int64_compare(b, a));
		               }
		               function equal64(b, a, cont){return cont(caml_equal(b, a));}
		               function hash$13(x, cont){return cont(hash_int32(x));}
		               var num_bits$2 = 32;
		               lower_bound_for_int(num_bits$2);
		               upper_bound_for_int(num_bits$2);
		               function shift_right$3(b, a){return b >> a;}
		               function shift_left$2(b, a){return b << a;}
		               function rem$2(b, a){return caml_mod(b, a);}
		               function greater_equal(x, y){return caml_greaterequal(x, y);}
		               function symbol$29(x, y){return caml_lessequal(x, y);}
		               function symbol$30(x, y){return caml_greaterthan(x, y);}
		               function symbol$31(x, y){return caml_lessthan(x, y);}
		               function min$9(x, y, cont){
		                return cont(caml_csel_value(caml_lessequal(x, y), x, y));
		               }
		               function max$9(x, y, cont){
		                return cont(caml_csel_value(caml_greaterequal(x, y), x, y));
		               }
		               function symbol$32(b, a){return caml_div(b, a);}
		               function symbol$33(b, a){return b - a | 0;}
		               function symbol$34(b, a){return b + a | 0;}
		               var
		                include$17 = Make$3([0, int32_to_string]),
		                sexp_of_int32$0 = include$17[2],
		                min_value$1 = 0;
		               caml_callback
		                (bO$,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   int32_to_string,
		                   symbol$34,
		                   symbol$33,
		                   ,
		                   symbol$32,
		                   ,
		                   ,
		                   symbol$29,
		                   ,
		                   ,
		                   symbol$31,
		                   ,
		                   ,
		                   ,
		                   min_value$1,
		                   int_to_int32_exn,
		                   rem$2]]);
		               var cst_int63 = "int63";
		               function of_binable(x, cont){
		                function a(a){return cont(caml_int64_mul(x, f5));}
		                if(int64_is_representable_as_int6(x)) return a();
		                var b = caml_int64_format(cst_d, x);
		                return caml_exact_trampoline_cps_call
		                        (failwithf,
		                         bp,
		                         function(c){
		                          return caml_trampoline_cps_call5
		                                  (c, cst_int64, cst_int63, b, 0, a);
		                         });
		               }
		               function symbol$35(x, y){return caml_int64_add(x, y);}
		               function symbol$36(x, y){return caml_int64_sub(x, y);}
		               function symbol$37(x){return caml_int64_neg(x);}
		               function abs$0(x){return abs(x);}
		               var one$0 = caml_callback(of_binable, [f6]);
		               function succ(a){return caml_int64_add(a, one$0);}
		               function pred$3(a){return caml_int64_sub(a, one$0);}
		               function bit_not$3(x){
		                var x$0 = caml_int64_xor(x, bm);
		                return caml_int64_and(x$0, mask);
		               }
		               function bit_and(b, a){return caml_int64_and(b, a);}
		               function shift_left$3(x, i){
		                return caml_int64_shift_left(x, i);
		               }
		               function shift_right$4(x, i){
		                var x$0 = caml_int64_shift_right(x, i);
		                return caml_int64_and(x$0, mask);
		               }
		               function symbol$38(a, b){
		                return caml_int64_mul(a, caml_int64_shift_right(b, 1));
		               }
		               function symbol$39(a, b){
		                var x = caml_int64_div(a, b);
		                return caml_int64_mul(x, w);
		               }
		               function rem$3(a, b){return caml_int64_mod(a, b);}
		               function to_int64(t){return caml_int64_shift_right(t, 1);}
		               function of_int64_trunc(t){return caml_int64_mul(t, w);}
		               function sexp_of_t$16(x, cont){
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int64, caml_int64_shift_right(x, 1), cont);
		               }
		               function compare$20(x, y, cont){
		                return cont(caml_int64_compare(x, y));
		               }
		               function hash$14(x, cont){
		                return cont(caml_hash(10, 100, 0, x));
		               }
		               function invalid_str(x, cont){
		                return caml_exact_trampoline_cps_call
		                        (failwithf,
		                         f7,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, x, 0, cont);
		                         });
		               }
		               function to_string$8(x, cont){
		                var n = caml_int64_shift_right(x, 1);
		                return cont(caml_int64_format(cst_d, n));
		               }
		               function of_string_raw(str, cont){
		                var len = caml_ml_string_length(str);
		                a:
		                if(0 < len){
		                 var a = caml_string_get(str, 0) - 43 | 0;
		                 if(2 >= a >>> 0)
		                  switch(a){
		                    case 0:
		                     var sign = 4003188, pos = 1; break a;
		                    case 2:
		                     sign = 3901488; pos = 1; break a;
		                  }
		                 sign = 4003188;
		                 pos = 0;
		                }
		                else {sign = 4003188; pos = 0;}
		                if((pos + 2 | 0) < len)
		                 var
		                  c1 = caml_string_get(str, pos),
		                  c2 = caml_string_get(str, pos + 1 | 0),
		                  a =
		                    48 === c1
		                     ? 9 < c2 - 48 >>> 0 ? [0, , 0] : [0, , 1]
		                     : [0, , 1];
		                else
		                 a = [0, , 1];
		                var signedness = a[2];
		                if(signedness){
		                 var t = caml_int64_of_string(str);
		                 return caml_exact_trampoline_cps_call(of_binable, t, cont);
		                }
		                function b(pos_str){
		                 var int64 = caml_int64_of_string(pos_str);
		                 function a(a){
		                  var int63 = caml_int64_mul(int64, w);
		                  return 4003188 <= sign
		                          ? cont(int63)
		                          : cont(caml_int64_neg(int63));
		                 }
		                 return caml_lessthan(int64, f8)
		                         ? caml_exact_trampoline_cps_call(invalid_str, str, a)
		                         : a();
		                }
		                return 4003188 <= sign
		                        ? b(str)
		                        : caml_exact_trampoline_cps_call$0
		                          (sub_fun, str, 1, caml_ml_string_length(str) - 1 | 0, b);
		               }
		               function of_string$4(str, cont){
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call
		                           (invalid_str, str, cont);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (of_string_raw,
		                         str,
		                         function(a){caml_pop_trap(); return cont(a);});
		               }
		               var
		                num_bits$3 = 63,
		                float_lower_bound$1 = lower_bound_for_int(num_bits$3),
		                float_upper_bound$1 = upper_bound_for_int(num_bits$3);
		               caml_callback(of_binable, [minus_one]);
		               var
		                one$1 = caml_callback(of_binable, [one]),
		                zero$1 = caml_callback(of_binable, [min_value]);
		               function to_float$0(x){
		                return caml_int64_to_float(caml_int64_shift_right(x, 1));
		               }
		               function of_float_unchecked(x){
		                var x$0 = caml_int64_of_float(x);
		                return caml_int64_mul(x$0, w);
		               }
		               function of_float$1(t, cont){
		                if(float_lower_bound$1 <= t && t <= float_upper_bound$1){
		                 var x = caml_int64_of_float(t);
		                 return cont(caml_int64_mul(x, w));
		                }
		                var a = t + 0.;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         f9,
		                         function(b){
		                          return caml_trampoline_cps_call3(b, a, 0, cont);
		                         });
		               }
		               function of_int$1(x, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_binable, caml_int64_of_int32(x), cont);
		               }
		               function of_int_exn$2(x, cont){
		                return caml_exact_trampoline_cps_call(of_int$1, x, cont);
		               }
		               function to_int_exn(x, cont){
		                return caml_exact_trampoline_cps_call
		                        (int64_to_int_exn, caml_int64_shift_right(x, 1), cont);
		               }
		               var
		                include$18 = Make$3([0, to_string$8]),
		                sexp_of_t$17 = include$18[2];
		               function symbol$40(b, a){return caml_notequal(b, a);}
		               function symbol$41(b, a){return caml_lessthan(b, a);}
		               function symbol$42(b, a){return caml_greaterthan(b, a);}
		               function symbol$43(b, a){return caml_equal(b, a);}
		               function symbol$44(b, a){return caml_lessequal(b, a);}
		               var
		                include$19 =
		                  caml_callback
		                   (bO$,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      to_string$8,
		                      symbol$35,
		                      symbol$36,
		                      ,
		                      symbol$39,
		                      ,
		                      ,
		                      symbol$44,
		                      ,
		                      ,
		                      symbol$41,
		                      ,
		                      ,
		                      ,
		                      zero$1,
		                      of_int_exn$2,
		                      rem$3]]),
		                symbol$45 = include$19[2],
		                include$20 =
		                  [0,
		                   ,
		                   of_float$1,
		                   to_float$0,
		                   of_int_exn$2,
		                   to_int_exn,
		                   ,
		                   hash$14,
		                   ,
		                   sexp_of_t$17,
		                   of_string$4,
		                   to_string$8,
		                   function(b, a){return caml_greaterequal(b, a);},
		                   function(b, a){return caml_lessequal(b, a);},
		                   function(b, a){return caml_equal(b, a);},
		                   function(b, a){return caml_greaterthan(b, a);},
		                   function(b, a){return caml_lessthan(b, a);},
		                   function(b, a){return caml_notequal(b, a);},
		                   function(b, a){return caml_equal(b, a);},
		                   function(b, a, cont){return cont(caml_int64_compare(b, a));},
		                   min$3,
		                   max$3,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [0, hash$14, compare$20, sexp_of_t$16],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   zero$1,
		                   one$1,
		                   ,
		                   symbol$35,
		                   symbol$36,
		                   symbol$38,
		                   ,
		                   symbol$37,
		                   symbol$37,
		                   ,
		                   ,
		                   symbol$39,
		                   rem$3,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   abs$0,
		                   succ,
		                   pred$3,
		                   ,
		                   bit_and,
		                   ,
		                   ,
		                   bit_not$3,
		                   ,
		                   shift_left$3,
		                   shift_right$4,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   to_int64,
		                   ,
		                   ,
		                   num_bits$3,
		                   caml_int64_create_lo_mi_hi(16777214, 16777215, 32767),
		                   caml_int64_create_lo_mi_hi(0, 0, 32768),
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [0,
		                    symbol$35,
		                    symbol$36,
		                    symbol$38,
		                    symbol$39,
		                    symbol$37,
		                    ,
		                    ,
		                    ,
		                    symbol$43,
		                    symbol$42,
		                    symbol$41,
		                    symbol$40,
		                    ,
		                    ,
		                    zero$1,
		                    ,
		                    symbol$45],
		                   of_int$1,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   of_int64_trunc,
		                   ,
		                   ,
		                   ,
		                   ,
		                   of_float_unchecked,
		                   1],
		                of_float$2 = include$20[2],
		                to_float$1 = include$20[3],
		                of_int_exn$3 = include$20[4],
		                to_int_exn$0 = include$20[5],
		                hash$15 = include$20[7],
		                sexp_of_t$18 = include$20[9],
		                of_string$5 = include$20[10],
		                to_string$9 = include$20[11],
		                greater_equal$0 = include$20[12],
		                symbol$46 = include$20[13],
		                symbol$47 = include$20[14],
		                symbol$48 = include$20[15],
		                symbol$49 = include$20[16],
		                symbol$50 = include$20[17],
		                equal$12 = include$20[18],
		                compare_time = include$20[19],
		                min$10 = include$20[20],
		                max$10 = include$20[21],
		                hashable$4 = include$20[29],
		                min_interval_num = include$20[42],
		                min_scale = include$20[43],
		                symbol$51 = include$20[45],
		                symbol$52 = include$20[46],
		                symbol$53 = include$20[47],
		                neg = include$20[49],
		                symbol$54 = include$20[50],
		                symbol$55 = include$20[53],
		                rem$4 = include$20[54],
		                abs$1 = include$20[67],
		                succ$0 = include$20[68],
		                pred$4 = include$20[69],
		                bit_and$0 = include$20[71],
		                bit_not$4 = include$20[74],
		                shift_left$4 = include$20[76],
		                shift_right$5 = include$20[77],
		                to_int64$0 = include$20[83],
		                num_bits$4 = include$20[86],
		                max_value_representable = include$20[87],
		                min_value_representable = include$20[88],
		                O$0 = include$20[98],
		                of_int$2 = include$20[99],
		                of_int64_trunc$0 = include$20[106],
		                of_float_unchecked$0 = include$20[111];
		               caml_callback(of_int$2, [-1]);
		               function max$11(x, y){return y < x ? x : y;}
		               function height$1(param){
		                if(typeof param === "number") return 0;
		                if(0 !== param[0]) return 1;
		                var height = param[4];
		                return height;
		               }
		               function update_height(param){
		                if(typeof param !== "number" && 0 === param[0]){
		                 var
		                  left = param[1],
		                  old_height = param[4],
		                  right = param[5],
		                  a = height$1(right),
		                  new_height = max$11(height$1(left), a) + 1 | 0;
		                 if(new_height !== old_height) param[4] = new_height;
		                 return;
		                }
		                throw caml_maybe_attach_backtrace([0, Assert_failure, f_], 1);
		               }
		               function balance(root_node){
		                if(typeof root_node !== "number" && 0 === root_node[0]){
		                 var
		                  left = root_node[1],
		                  right = root_node[5],
		                  hl = height$1(left),
		                  hr = height$1(right);
		                 if((hr + 2 | 0) < hl){
		                  if(typeof left !== "number" && 0 === left[0]){
		                   var
		                    left_node_left = left[1],
		                    left_node_right = left[5],
		                    a = height$1(left_node_right);
		                   if(a <= height$1(left_node_left)){
		                    root_node[1] = left_node_right;
		                    left[5] = root_node;
		                    update_height(root_node);
		                    update_height(left);
		                    return left;
		                   }
		                   if
		                    (typeof left_node_right !== "number"
		                     && 0 === left_node_right[0]){
		                    var
		                     lr_left = left_node_right[1],
		                     lr_right = left_node_right[5];
		                    left[5] = lr_left;
		                    root_node[1] = lr_right;
		                    left_node_right[5] = root_node;
		                    left_node_right[1] = left;
		                    update_height(left);
		                    update_height(root_node);
		                    update_height(left_node_right);
		                    return left_node_right;
		                   }
		                   throw caml_maybe_attach_backtrace
		                          ([0, Assert_failure, ga], 1);
		                  }
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, f$], 1);
		                 }
		                 if((hl + 2 | 0) >= hr){
		                  update_height(root_node);
		                  return root_node;
		                 }
		                 if(typeof right !== "number" && 0 === right[0]){
		                  var
		                   right_node_left = right[1],
		                   right_node_right = right[5],
		                   a = height$1(right_node_left);
		                  if(a <= height$1(right_node_right)){
		                   root_node[5] = right_node_left;
		                   right[1] = root_node;
		                   update_height(root_node);
		                   update_height(right);
		                   return right;
		                  }
		                  if
		                   (typeof right_node_left !== "number"
		                    && 0 === right_node_left[0]){
		                   var
		                    rl_left = right_node_left[1],
		                    rl_right = right_node_left[5];
		                   right[1] = rl_right;
		                   root_node[5] = rl_left;
		                   right_node_left[1] = root_node;
		                   right_node_left[5] = right;
		                   update_height(right);
		                   update_height(root_node);
		                   update_height(right_node_left);
		                   return right_node_left;
		                  }
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, gc], 1);
		                 }
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, gb], 1);
		                }
		                return root_node;
		               }
		               function add$6(t, replace, compare, added, k, v, cont){
		                if(typeof t === "number"){
		                 added[1] = 1;
		                 return cont([1, k, v]);
		                }
		                if(0 === t[0]){
		                 var left = t[1], k$0 = t[2], right = t[5];
		                 return caml_trampoline_cps_call3
		                         (compare,
		                          k,
		                          k$0,
		                          function(c){
		                           if(0 !== c){
		                            var
		                             a =
		                               function(){return added[1] ? cont(balance(t)) : cont(t);};
		                            return 0 <= c
		                                    ? caml_exact_trampoline_cps_call$7
		                                      (add$6,
		                                       right,
		                                       replace,
		                                       compare,
		                                       added,
		                                       k,
		                                       v,
		                                       function(right$0){
		return 1 - (right$0 === right) ? (t[5] = right$0, a()) : a();
		                                       })
		                                    : caml_exact_trampoline_cps_call$7
		                                      (add$6,
		                                       left,
		                                       replace,
		                                       compare,
		                                       added,
		                                       k,
		                                       v,
		                                       function(left$0){
		return 1 - (left$0 === left) ? (t[1] = left$0, a()) : a();
		                                       });
		                           }
		                           added[1] = 0;
		                           if(replace) t[3] = v;
		                           return cont(t);
		                          });
		                }
		                var k$1 = t[1];
		                return caml_trampoline_cps_call3
		                        (compare,
		                         k$1,
		                         k,
		                         function(c){
		                          if(0 !== c){
		                           added[1] = 1;
		                           return 0 <= c
		                                   ? cont([0, 0, k, v, 2, t])
		                                   : cont([0, t, k, v, 2, 0]);
		                          }
		                          added[1] = 0;
		                          if(replace) t[2] = v;
		                          return cont(t);
		                         });
		               }
		               function findi_and_call_impl
		               (t,
		                compare,
		                k,
		                arg1,
		                arg2,
		                call_if_found,
		                call_if_not_found,
		                if_found,
		                if_not_found,
		                cont){
		                function a(t){
		                 if(typeof t === "number")
		                  return caml_exact_trampoline_cps_call$2
		                          (call_if_not_found, if_not_found, k, dummy, dummy, cont);
		                 if(0 === t[0]){
		                  var left = t[1], k$0 = t[2], v = t[3], right = t[5];
		                  return caml_trampoline_cps_call3
		                          (compare,
		                           k,
		                           k$0,
		                           function(c){
		                            return 0 === c
		                                    ? caml_exact_trampoline_cps_call$3
		                                      (call_if_found, if_found, k$0, v, dummy, dummy, cont)
		                                    : 0
		                                      <= c
		                                      ? caml_exact_trampoline_call1(a, right)
		                                      : caml_exact_trampoline_call1(a, left);
		                           });
		                 }
		                 var k$1 = t[1], v$0 = t[2];
		                 return caml_trampoline_cps_call3
		                         (compare,
		                          k,
		                          k$1,
		                          function(a){
		                           return 0 === a
		                                   ? caml_exact_trampoline_cps_call$3
		                                     (call_if_found, if_found, k$1, v$0, dummy, dummy, cont)
		                                   : caml_exact_trampoline_cps_call$2
		                                     (call_if_not_found, if_not_found, k, dummy, dummy, cont);
		                          });
		                }
		                return a(t);
		               }
		               function call_if_found(if_found, b, data, a, param, cont){return caml_trampoline_cps_call2(if_found, data, cont);
		               }
		               function call_if_not_found(if_not_found, key, a, param, cont){return caml_trampoline_cps_call2(if_not_found, key, cont);
		               }
		               function find_and_call
		               (t, compare, k, if_found, if_not_found, cont){
		                return caml_exact_trampoline_cps_call$4
		                        (findi_and_call_impl,
		                         t,
		                         compare,
		                         k,
		                         dummy,
		                         dummy,
		                         call_if_found,
		                         call_if_not_found,
		                         if_found,
		                         if_not_found,
		                         cont);
		               }
		               var letrec_function_context = [];
		               function remove$3(t, removed, compare, k, cont){
		                if(typeof t === "number"){removed[1] = 0; return cont(0);}
		                if(0 === t[0]){
		                 var left = t[1], k$0 = t[2], right = t[5];
		                 return caml_trampoline_cps_call3
		                         (compare,
		                          k,
		                          k$0,
		                          function(c){
		                           if(0 === c){
		                            removed[1] = 1;
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context[1], left, right, cont);
		                           }
		                           function a(){
		                            return removed[1] ? cont(balance(t)) : cont(t);
		                           }
		                           return 0 <= c
		                                   ? caml_exact_trampoline_cps_call$2
		                                     (remove$3,
		                                      right,
		                                      removed,
		                                      compare,
		                                      k,
		                                      function(right$0){
		                                       return 1 - (right$0 === right) ? (t[5] = right$0, a()) : a();
		                                      })
		                                   : caml_exact_trampoline_cps_call$2
		                                     (remove$3,
		                                      left,
		                                      removed,
		                                      compare,
		                                      k,
		                                      function(left$0){
		                                       return 1 - (left$0 === left) ? (t[1] = left$0, a()) : a();
		                                      });
		                          });
		                }
		                var k$1 = t[1];
		                return caml_trampoline_cps_call3
		                        (compare,
		                         k,
		                         k$1,
		                         function(a){
		                          return 0 === a
		                                  ? (removed[1] = 1, cont(0))
		                                  : (removed[1] = 0, cont(t));
		                         });
		               }
		               function remove_min_elt$1(tree){
		                if(typeof tree === "number")
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, gd], 1);
		                if(0 !== tree[0]) return 0;
		                var left = tree[1];
		                if(typeof left === "number"){
		                 var right = tree[5];
		                 return right;
		                }
		                if(0 !== left[0]){
		                 var k = tree[2], v = tree[3];
		                 if(typeof tree[5] === "number") return [1, k, v];
		                }
		                tree[1] = remove_min_elt$1(left);
		                return balance(tree);
		               }
		               function merge$2(t1, tree$0, a){
		                if(typeof t1 === "number") return a(tree$0);
		                a:
		                {
		                 if(typeof tree$0 === "number") return a(t1);
		                 var tree = tree$0;
		                 for(;;){
		                  if(typeof tree === "number") break;
		                  if(0 !== tree[0]){var tree$1 = tree; break a;}
		                  var left = tree[1];
		                  if(typeof left === "number"){tree$1 = tree; break a;}
		                  tree = left;
		                 }
		                 tree$1 = 0;
		                }
		                if(typeof tree$1 === "number"){
		                 a = caml_pop_trap();
		                 return a
		                         (caml_maybe_attach_backtrace([0, Assert_failure, ge], 1));
		                }
		                if(0 === tree$1[0]){
		                 tree$1[5] = remove_min_elt$1(tree$0);
		                 tree$1[1] = t1;
		                 var tree$2 = tree$1;
		                }
		                else
		                 var
		                  k = tree$1[1],
		                  v = tree$1[2],
		                  t2 = remove_min_elt$1(tree$0),
		                  b = height$1(t2),
		                  tree$2 = [0, t1, k, v, max$11(height$1(t1), b) + 1 | 0, t2];
		                return a(balance(tree$2));
		               }
		               caml_update_dummy(letrec_function_context, [0, merge$2]);
		               function fold$7(t$0, init$2, f){
		                var t = t$0, init = init$2;
		                for(;;){
		                 if(typeof t === "number") return init;
		                 if(0 !== t[0]){
		                  var key$4 = t[1], data$4 = t[2];
		                  return f(key$4, data$4, init);
		                 }
		                 var left = t[1];
		                 if(typeof left === "number"){
		                  var key = t[2], data = t[3], a = t[5];
		                  if(typeof a !== "number" && 0 !== a[0]){
		                   var rkey = a[1], rdata = a[2];
		                   return f(rkey, rdata, f(key, data, init));
		                  }
		                 }
		                 else {
		                  if(0 === left[0]){
		                   var key$1 = t[2], data$1 = t[3], a = t[5];
		                   if(typeof a !== "number" && 0 !== a[0]){
		                    var rkey$0 = a[1], rdata$0 = a[2];
		                    return f
		                            (rkey$0, rdata$0, f(key$1, data$1, fold$7(left, init, f)));
		                   }
		                  }
		                  else {
		                   var
		                    lkey$0 = left[1],
		                    ldata$0 = left[2],
		                    key$3 = t[2],
		                    data$3 = t[3],
		                    a = t[5];
		                   if(typeof a === "number")
		                    return f(key$3, data$3, f(lkey$0, ldata$0, init));
		                   if(0 !== a[0]){
		                    var rkey$1 = a[1], rdata$1 = a[2];
		                    return f
		                            (rkey$1,
		                             rdata$1,
		                             f(key$3, data$3, f(lkey$0, ldata$0, init)));
		                   }
		                  }
		                  if(typeof left !== "number" && 0 !== left[0]){
		                   var
		                    lkey = left[1],
		                    ldata = left[2],
		                    key$2 = t[2],
		                    data$2 = t[3],
		                    right$0 = t[5],
		                    init$1 = f(key$2, data$2, f(lkey, ldata, init));
		                   t = right$0;
		                   init = init$1;
		                   continue;
		                  }
		                 }
		                 var
		                  key$0 = t[2],
		                  data$0 = t[3],
		                  right = t[5],
		                  init$0 = f(key$0, data$0, fold$7(left, init, f));
		                 t = right;
		                 init = init$0;
		                }
		               }
		               function iter$6(t, f, cont){
		                function a(t){
		                 if(typeof t === "number") return cont();
		                 if(0 === t[0]){
		                  var left = t[1], key = t[2], data = t[3], right = t[5];
		                  return caml_exact_trampoline_cps_call$1
		                          (iter$6,
		                           left,
		                           f,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (f,
		                                     key,
		                                     data,
		                                     function(b){return caml_exact_trampoline_call1(a, right);});
		                           });
		                 }
		                 var key$0 = t[1], data$0 = t[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (f, key$0, data$0, cont);
		                }
		                return a(t);
		               }
		               function compare_key$0(t){return t[4][2];}
		               function ensure_mutation_allowed(t, cont){
		                var a = 1 - t[5];
		                return a
		                        ? caml_exact_trampoline_cps_call
		                          (failwith,
		                           "Hashtbl: mutation not allowed during iteration",
		                           cont)
		                        : cont(a);
		               }
		               var
		                max_table_length =
		                  caml_callback(floor_pow2, [max_array_length]);
		               function create$17(a, opt, hashable, param, cont){
		                var growth_allowed = a ? a[1] : 1, size = opt ? opt[1] : 0;
		                return caml_exact_trampoline_cps_call$1
		                        (max$2,
		                         1,
		                         size,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (min$2,
		                                   a,
		                                   max_table_length,
		                                   function(size){
		                                    return caml_exact_trampoline_cps_call
		    (ceil_pow2,
		     size,
		     function(size){
		      return cont
		              ([0,
		                caml_make_vect(size, 0),
		                0,
		                growth_allowed,
		                hashable,
		                1]);
		     });
		                                   });
		                         });
		               }
		               function slot(t, key, cont){
		                return caml_trampoline_cps_call2
		                        (t[4][1],
		                         key,
		                         function(hash){return cont(hash & (t[1].length - 2 | 0));});
		               }
		               function add_worker(t, replace, key, data, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (slot,
		                         t,
		                         key,
		                         function(i){
		                          var root = caml_check_bound(t[1], i)[i + 1], added = [0, 0];
		                          return caml_exact_trampoline_cps_call$7
		                                  (add$6,
		                                   root,
		                                   replace,
		                                   compare_key$0(t),
		                                   added,
		                                   key,
		                                   data,
		                                   function(new_root){
		                                    if(added[1]) t[2] = t[2] + 1 | 0;
		                                    if(1 - (new_root === root))
		                                     caml_check_bound(t[1], i)[i + 1] = new_root;
		                                    return cont();
		                                   });
		                         });
		               }
		               function maybe_resize_table(t, cont){
		                var
		                 len = t[1].length - 1,
		                 should_grow = len < t[2],
		                 b = should_grow ? t[3] : should_grow;
		                function a(){return cont();}
		                return b
		                        ? caml_exact_trampoline_cps_call$1
		                          (min$2,
		                           len * 2 | 0,
		                           max_table_length,
		                           function(new_array_length){
		                            if(len >= new_array_length) return a();
		                            var
		                             new_table = caml_make_vect(new_array_length, 0),
		                             old_table = t[1];
		                            t[1] = new_table;
		                            t[2] = 0;
		                            function f(key, data, cont){
		                             return caml_exact_trampoline_cps_call$2
		                                     (add_worker, t, 1, key, data, function(a){return cont();});
		                            }
		                            var b = old_table.length - 2 | 0;
		                            function c(i){
		                             return caml_exact_trampoline_cps_call$1
		                                     (iter$6,
		                                      caml_check_bound(old_table, i)[i + 1],
		                                      f,
		                                      function(d){
		                                       d = i + 1 | 0;
		                                       return b !== i ? caml_exact_trampoline_call1(c, d) : a();
		                                      });
		                            }
		                            return b < 0 ? a() : c(0);
		                           })
		                        : a();
		               }
		               function set$4(t, key, data, cont){
		                return caml_exact_trampoline_cps_call
		                        (ensure_mutation_allowed,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (add_worker,
		                                   t,
		                                   1,
		                                   key,
		                                   data,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (maybe_resize_table, t, cont);
		                                   });
		                         });
		               }
		               function find_and_call$0(t, key, if_found, if_not_found, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (slot,
		                         t,
		                         key,
		                         function(a){
		                          var tree = caml_check_bound(t[1], a)[a + 1];
		                          if(typeof tree === "number")
		                           return caml_exact_trampoline_cps_call
		                                   (if_not_found, key, cont);
		                          if(0 === tree[0])
		                           return caml_exact_trampoline_cps_call$3
		                                   (find_and_call,
		                                    tree,
		                                    compare_key$0(t),
		                                    key,
		                                    if_found,
		                                    if_not_found,
		                                    cont);
		                          var k = tree[1], v = tree[2];
		                          return caml_trampoline_cps_call3
		                                  (compare_key$0(t),
		                                   k,
		                                   key,
		                                   function(a){
		                                    return 0 === a
		    ? caml_exact_trampoline_cps_call(if_found, v, cont)
		    : caml_exact_trampoline_cps_call(if_not_found, key, cont);
		                                   });
		                         });
		               }
		               function if_found(v, cont){return cont([0, v]);}
		               function if_not_found$0(param, cont){return cont(0);}
		               function remove$4(t, key, cont){
		                return caml_exact_trampoline_cps_call
		                        (ensure_mutation_allowed,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (slot,
		                                   t,
		                                   key,
		                                   function(i){
		                                    var
		                                     root = caml_check_bound(t[1], i)[i + 1],
		                                     removed = [0, 0];
		                                    return caml_exact_trampoline_cps_call$2
		    (remove$3,
		     root,
		     removed,
		     compare_key$0(t),
		     key,
		     function(new_root){
		      if(1 - (root === new_root))
		       caml_check_bound(t[1], i)[i + 1] = new_root;
		      if(removed[1]) t[2] = t[2] - 1 | 0;
		      return cont();
		     });
		                                   });
		                         });
		               }
		               function fold$8(t, init, f){
		                if(0 === t[2]) return init;
		                var n = t[1].length - 1, acc = [0, init], m = t[5];
		                try{
		                 t[5] = 0;
		                 var a = n - 1 | 0;
		                 if(a >= 0){
		                  var i = 0;
		                  for(;;){
		                   var bucket = t[1][i + 1];
		                   if(typeof bucket !== "number")
		                    if(0 === bucket[0])
		                     acc[1] = fold$7(bucket, acc[1], f);
		                    else {
		                     var key = bucket[1], data = bucket[2];
		                     acc[1] = f(key, data, acc[1]);
		                    }
		                   var b = i + 1 | 0;
		                   if(a === i) break;
		                   i = b;
		                  }
		                 }
		                }
		                catch(exn$0){
		                 var exn = caml_wrap_exception(exn$0);
		                 t[5] = m;
		                 throw caml_maybe_attach_backtrace(exn, 0);
		                }
		                t[5] = m;
		                return acc[1];
		               }
		               function sexp_of_t$19(sexp_of_key, sexp_of_data, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (stable_sort,
		                         fold$8
		                          (t,
		                           0,
		                           function(key, data, list){return [0, [0, key, data], list];}),
		                         function(a, param, cont){
		                          var k2 = param[1], k1 = a[1];
		                          return caml_trampoline_cps_call3(t[4][2], k1, k2, cont);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_list,
		                                   function(a, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (sexp_of_pair, sexp_of_key, sexp_of_data, a, cont);
		                                   },
		                                   a,
		                                   cont);
		                         });
		               }
		               function compare$21(b, a, cont){
		                return cont(caml_float_compare(b, a));
		               }
		               var
		                include$21 = Make$1([0, compare$21, sexp_of_float]),
		                comparator$7 = include$21[1];
		               function of_string$6(s, cont){
		                try{var a = caml_float_of_string(s);}
		                catch(exn){
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          gf,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, s, 0, cont);
		                          });
		                }
		                return cont(a);
		               }
		               function to_string$10(x, cont){
		                var
		                 y = caml_format_float("%.15g", x),
		                 s1 =
		                   caml_float_of_string(y) === x
		                    ? y
		                    : caml_format_float("%.17g", x),
		                 l = caml_ml_string_length(s1),
		                 i = 0;
		                for(;;){
		                 if(l <= i) return cont(s1 + cst$14);
		                 var match = caml_string_get(s1, i);
		                 a:
		                 {
		                  if(48 <= match){
		                   if(58 <= match) break a;
		                  }
		                  else if(45 !== match) break a;
		                  var i$0 = i + 1 | 0;
		                  i = i$0;
		                  continue;
		                 }
		                 return cont(s1);
		                }
		               }
		               var
		                iround_lbound = lower_bound_for_int(int_size_in_bits),
		                iround_ubound = upper_bound_for_int(int_size_in_bits);
		               function iround_up_exn(t, cont){
		                if(0. < t){
		                 var t$0 = Math.ceil(t);
		                 if(t$0 <= iround_ubound) return cont(t$0 | 0);
		                 var a = t + 0.;
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          gg,
		                          function(b){
		                           return caml_trampoline_cps_call3(b, a, 0, cont);
		                          });
		                }
		                if(iround_lbound <= t) return cont(t | 0);
		                var b = t + 0.;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         gh,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, b, 0, cont);
		                         });
		               }
		               function iround_down_exn(t, cont){
		                if(0. <= t){
		                 if(t <= iround_ubound) return cont(t | 0);
		                 var a = t + 0.;
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          gi,
		                          function(b){
		                           return caml_trampoline_cps_call3(b, a, 0, cont);
		                          });
		                }
		                var t$0 = Math.floor(t);
		                if(iround_lbound <= t$0) return cont(t$0 | 0);
		                var b = t + 0.;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         gj,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, b, 0, cont);
		                         });
		               }
		               var one_ulp_less_than_half = one_ulp(759637122, 0.5);
		               function add_half_for_round_nearest(t){
		                var
		                 a =
		                   t === one_ulp_less_than_half ? one_ulp_less_than_half : 0.5;
		                return t + a;
		               }
		               function is_inf(t){return 1. / t === 0. ? 1 : 0;}
		               function is_finite(t){return t - t === 0. ? 1 : 0;}
		               function round_nearest_inline(t){
		                if(-4503599627370496. < t && t < 4503599627370496.)
		                 return Math.floor(add_half_for_round_nearest(t));
		                return t + 0.;
		               }
		               var
		                int63_round_lbound = lower_bound_for_int(num_bits$4),
		                int63_round_ubound = upper_bound_for_int(num_bits$4);
		               function int63_round_nearest_portable_a(t0, cont){
		                var t = round_nearest_inline(t0);
		                if(0. < t){
		                 if(t <= int63_round_ubound)
		                  return cont(of_float_unchecked$0(t));
		                 var a = t0 + 0.;
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          gk,
		                          function(b){
		                           return caml_trampoline_cps_call3(b, a, 0, cont);
		                          });
		                }
		                if(int63_round_lbound <= t)
		                 return cont(of_float_unchecked$0(t));
		                var b = t0 + 0.;
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         gl,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, b, 0, cont);
		                         });
		               }
		               function classify(t){
		                switch(caml_classify_float(t)){
		                  case 0:
		                   return 2;
		                  case 1:
		                   return 3;
		                  case 2:
		                   return 4;
		                  case 3:
		                   return 0;
		                  default: return 1;
		                }
		               }
		               function to_string_hum$0
		               (delimiter, b, strip_zero, opt, f, cont){
		                var decimals = b ? b[1] : 3, explicit_plus = opt ? opt[1] : 0;
		                function a(a){
		                 a = classify(f);
		                 if(1 === a) return cont(cst_nan);
		                 if(! a) return 0. < f ? cont("inf") : cont("-inf");
		                 function b(string){
		                  var
		                   delimiter$0 = delimiter ? delimiter[1] : 95,
		                   strip_zero$0 = strip_zero ? strip_zero[1] : 0;
		                  return caml_exact_trampoline_cps_call$1
		                          (lsplit2,
		                           string,
		                           46,
		                           function(a){
		                            if(! a) return cont(insert_delimiter(string, delimiter$0));
		                            a = a[1];
		                            var
		                             right = a[2],
		                             left = a[1],
		                             left$0 = insert_delimiter(left, delimiter$0);
		                            function b(right){
		                             if(right === cst$1) return cont(left$0);
		                             var s2 = cst$14 + right;
		                             return cont(left$0 + s2);
		                            }
		                            return strip_zero$0
		                                    ? caml_exact_trampoline_cps_call$1
		                                      (rstrip,
		                                       [0, function(c, cont){return cont(c === 48 ? 1 : 0);}],
		                                       right,
		                                       b)
		                                    : b(right);
		                           });
		                 }
		                 return explicit_plus
		                         ? caml_exact_trampoline_cps_call
		                           (sprintf,
		                            gn,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, decimals, f, b);
		                            })
		                         : caml_exact_trampoline_cps_call
		                           (sprintf,
		                            go,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, decimals, f, b);
		                            });
		                }
		                if(decimals >= 0) return a(0);
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         gm,
		                         function(b){
		                          return caml_trampoline_cps_call3(b, decimals, 0, a);
		                         });
		               }
		               function sexp_of_float$0(t, cont){
		                return caml_exact_trampoline_cps_call(sexp_of_float, t, cont);
		               }
		               function between$4(t, low, high, cont){
		                var a = low <= t ? 1 : 0, a = a ? t <= high ? 1 : 0 : a;
		                return cont(a);
		               }
		               function clamp_exn$3(t, min, max, a){
		                if(min <= max) return a(clamp_unchecked$0(t, min, max));
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, gp], 1));
		               }
		               function clamp$3(t, min, max, cont){
		                if(min <= max)
		                 return cont([0, clamp_unchecked$0(t, min, max)]);
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_float,
		                         max,
		                         function(b){
		                          var a = [0, [0, cst_max, b], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_float,
		                                   min,
		                                   function(b){
		                                    return cont
		    (error_s
		      (message
		        (cst_clamp_requires_min_max, [0, [0, cst_min, b], a])));
		                                   });
		                         });
		               }
		               var
		                exponent_mask64 = caml_int64_create_lo_mi_hi(2047, 0, 0),
		                exponent_mask =
		                  caml_callback(int64_to_int_exn, [exponent_mask64]),
		                mantissa_mask =
		                  symbol$52(shift_left$4(min_scale, 52), min_scale),
		                mantissa_mask64 = to_int64$0(mantissa_mask);
		               function ieee_exponent(t){
		                var bits = caml_int64_bits_of_float(t);
		                return caml_int64_to_int32
		                        (caml_int64_and
		                          (caml_int64_shift_right_unsigned(bits, 52), exponent_mask64));
		               }
		               function ieee_mantissa(t){
		                var bits = caml_int64_bits_of_float(t);
		                return of_int64_trunc$0(caml_int64_and(bits, mantissa_mask64));
		               }
		               function create_ieee_exn(negative, exponent, mantissa, cont){
		                if((exponent & exponent_mask) !== exponent)
		                 return caml_exact_trampoline_cps_call
		                         (failwithf,
		                          gq,
		                          function(a){
		                           return caml_trampoline_cps_call4
		                                   (a, exponent, exponent_mask, 0, cont);
		                          });
		                if(symbol$50(bit_and$0(mantissa, mantissa_mask), mantissa))
		                 return caml_exact_trampoline_cps_call
		                         (to_string$9,
		                          mantissa_mask,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$9,
		                                    mantissa,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (failwithf,
		      gr,
		      function(c){
		       return caml_trampoline_cps_call4(c, b, a, 0, cont);
		      });
		                                    });
		                          });
		                var
		                 sign_bits = negative ? min_int64 : min_value,
		                 expt_bits =
		                   caml_int64_shift_left(caml_int64_of_int32(exponent), 52),
		                 mant_bits = to_int64$0(mantissa),
		                 bits =
		                   caml_int64_or
		                    (sign_bits, caml_int64_or(expt_bits, mant_bits));
		                return cont(caml_int64_float_of_bits(bits));
		               }
		               function min$11(x, y, cont){
		                if(! (x < y) && x === x) return cont(y);
		                return cont(x);
		               }
		               function max$12(x, y, cont){
		                if(! (y < x) && x === x) return cont(y);
		                return cont(x);
		               }
		               function get$4(opt, param){
		                return caml_get_current_callstack();
		               }
		               function sexp_of_t$20(t, cont){
		                function a(x, cont){return cont([0, x]);}
		                return caml_exact_trampoline_cps_call
		                        (raw_backtrace_to_string,
		                         t,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (split_lines,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$7, b, a, function(a){return cont([1, a]);});
		                                   });
		                         });
		               }
		               function initialize_module(b, cont){
		                b = getenv(cst_OCAMLRUNPARAM);
		                function a(ocamlrunparam_mentions_backtra){
		                 var a = 1 - ocamlrunparam_mentions_backtra;
		                 return a ? (caml_record_backtrace(1), cont()) : cont(a);
		                }
		                if(! b) return a(0);
		                var x = b[1];
		                function c(t){
		                 if(! t) return a(0);
		                 var xs = t[2], x = t[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (is_prefix_gen,
		                          x,
		                          cst_b,
		                          equal$2,
		                          function(b){
		                           return b ? a(1) : caml_exact_trampoline_call1(c, xs);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1(split$0, x, 44, c);
		               }
		               caml_callback(initialize_module, [dummy]);
		               function error$0(fmt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         function(s, cont){return cont([1, s]);},
		                         fmt,
		                         cont);
		               }
		               function pp_none(fmt, ppf, cont){return cont(0);}
		               function always(fmt, ppf, param, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf), fmt, cont);
		               }
		               function using(f, pp, ppf, v, cont){
		                return caml_trampoline_cps_call2
		                        (f,
		                         v,
		                         function(a){
		                          return caml_trampoline_cps_call3(pp, ppf, a, cont);
		                         });
		               }
		               function fmt$0(fmt, ppf, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf), fmt, cont);
		               }
		               function pp_v0(ppf, param, cont){return cont(pp_print_cut(ppf));
		               }
		               function pp_v1(ppf, param){return pp_print_space(ppf);}
		               function comma(ppf, param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         ppf,
		                         cst$25,
		                         function(a){return cont(pp_v1(ppf));});
		               }
		               var cst$2 = ";";
		               function semi(ppf, param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         ppf,
		                         cst$2,
		                         function(a){return cont(pp_v1(ppf));});
		               }
		               function iter$7(opt, iter, pp_elt, ppf, v, cont){
		                var pp_sep = opt ? opt[1] : pp_v0, is_first = [0, 1];
		                function pp_elt$0(v, cont){
		                 function a(a){
		                  return caml_trampoline_cps_call3(pp_elt, ppf, v, cont);
		                 }
		                 return is_first[1]
		                         ? (is_first[1] = 0, a())
		                         : caml_exact_trampoline_cps_call$1(pp_sep, ppf, dummy, a);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (iter, pp_elt$0, v, cont);
		               }
		               function append$4(pp_v0, pp_v1, ppf, v, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_v0,
		                         ppf,
		                         v,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1(pp_v1, ppf, v, cont);
		                         });
		               }
		               function box$0(opt, pp_v, ppf, v, cont){
		                var indent = opt ? opt[1] : 0;
		                return caml_exact_trampoline_cps_call$1
		                        (pp_open_box,
		                         ppf,
		                         indent,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (pp_v, ppf, v, function(a){return cont(pp_close_box(ppf));});
		                         });
		               }
		               function hvbox(opt, pp_v, state, v, cont){
		                var indent = opt ? opt[1] : 0;
		                return caml_exact_trampoline_cps_call$0
		                        (pp_open_box_gen,
		                         state,
		                         indent,
		                         2,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (pp_v,
		                                   state,
		                                   v,
		                                   function(a){return cont(pp_close_box(state));});
		                         });
		               }
		               function parens(pp_v){
		                return function(ppf, v, cont){
		                 var indent = opt$1[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_open_box,
		                          ppf,
		                          indent,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    ppf,
		                                    cst$16,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_v,
		      ppf,
		      v,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                ppf,
		                cst$18,
		                function(a){return cont(pp_close_box(ppf));});
		      });
		                                    });
		                          });};
		               }
		               function int64$0(ppf, v, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         gs,
		                         function(a){return caml_trampoline_cps_call2(a, v, cont);});
		               }
		               function exn(ppf, e, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$0,
		                         e,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, ppf, a, cont);
		                         });
		               }
		               function float(ppf, v, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         gt,
		                         function(a){return caml_trampoline_cps_call2(a, v, cont);});
		               }
		               function pair(opt, pp_fst, pp_snd, ppf, param, cont){
		                var
		                 pp_sep = opt ? opt[1] : pp_v0,
		                 snd = param[2],
		                 fst = param[1];
		                return caml_trampoline_cps_call3
		                        (pp_fst,
		                         ppf,
		                         fst,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_sep,
		                                   ppf,
		                                   dummy,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(pp_snd, ppf, snd, cont);
		                                   });
		                         });
		               }
		               function option(opt, pp_v, ppf, param, cont){
		                var pp_none$0 = opt ? opt[1] : pp_none;
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_none$0, ppf, dummy, cont);
		                var v = param[1];
		                return caml_trampoline_cps_call3(pp_v, ppf, v, cont);
		               }
		               function list(sep, pp_elt){
		                return function(a, b, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (iter$7, sep, iter$0, pp_elt, a, b, cont);};
		               }
		               function seq(sep, pp_elt){
		                return function(a, b, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (iter$7, sep, iter, pp_elt, a, b, cont);};
		               }
		               function string$1(ppf, s, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         gu,
		                         function(a){return caml_trampoline_cps_call2(a, s, cont);});
		               }
		               function sub$2(s, start, stop, max, cont){
		                if(start === stop) return cont(cst$1);
		                if(0 === start && max < stop) return cont(s);
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub, s, start, stop - start | 0, cont);
		               }
		               function lines(ppf, s, cont){
		                var max = caml_ml_string_length(s) - 1 | 0;
		                function a(start$1){
		                 var start = start$1;
		                 for(;;){
		                  if(max < start) break;
		                  var c = caml_string_get(s, start);
		                  if(10 === c) break;
		                  var start$0 = start + 1 | 0;
		                  start = start$0;
		                 }
		                 return max < start
		                         ? caml_exact_trampoline_cps_call$2
		                           (sub$2,
		                            s,
		                            start$1,
		                            start,
		                            max,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string, ppf, a, cont);
		                            })
		                         : caml_exact_trampoline_cps_call$2
		                           (sub$2,
		                            s,
		                            start$1,
		                            start,
		                            max,
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string,
		                                      ppf,
		                                      b,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_force_newline,
		        ppf,
		        dummy,
		        function(b){
		         var start$0 = start + 1 | 0;
		         return caml_exact_trampoline_call1(a, start$0);
		        });
		                                      });
		                            });
		                }
		                return a(0);
		               }
		               function of_to_string(f, ppf, v, cont){
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         v,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, ppf, a, cont);
		                         });
		               }
		               function to_to_string(pp_v, v, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$2,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, pp_v, v, cont);
		                         });
		               }
		               function Make$4(T){
		                function pp(printer, opt, fmt, param, cont){
		                 function a(opt, param){
		                  var
		                   sep =
		                     opt ? opt[1] : function(a, param, cont){return cont();};
		                  if(! param) return cont(0);
		                  var hd = param[1];
		                  if(! param[2])
		                   return caml_trampoline_cps_call3(printer[1], fmt, hd, cont);
		                  var tl = param[2];
		                  return caml_trampoline_cps_call3
		                          (printer[1],
		                           fmt,
		                           hd,
		                           function(b){
		                            return caml_trampoline_cps_call3
		                                    (sep,
		                                     fmt,
		                                     0,
		                                     function(b){
		                                      return caml_exact_trampoline_call2(a, [0, sep], tl);
		                                     });
		                           });
		                 }
		                 return a(opt, param);
		                }
		                function find_mapi(l, f, cont){
		                 function a(i, param){
		                  if(! param) return cont(0);
		                  var tl = param[2], hd = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (f[1],
		                           i,
		                           hd,
		                           function(match){
		                            if(match){var value = match[1]; return cont([0, value]);}
		                            var i$0 = i + 1 | 0;
		                            return caml_exact_trampoline_call2(a, i$0, tl);
		                           });
		                 }
		                 return a(0, l);
		                }
		                function find_map(l, f, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_mapi,
		                          l,
		                          [0,
		                           function(param, v, cont){
		                            return caml_exact_trampoline_cps_call(f[1], v, cont);
		                           }],
		                          cont);
		                }
		                return [0, , pp, , , , find_map];
		               }
		               function atomic_list_cons(v, atomic){
		                for(;;){
		                 var l = caml_atomic_load(atomic);
		                 if(caml_atomic_cas(atomic, l, [0, v, l])) return;
		                }
		               }
		               var
		                cst_undocumented = "undocumented",
		                level$0 = [0, gv],
		                id$45 = [0, 0],
		                bQM = [0, 0];
		               function create$18(opt, name){
		                var
		                 doc = opt ? opt[1] : cst_undocumented,
		                 level = [0, caml_atomic_load(level$0)],
		                 src = [0, caml_atomic_fetch_add(id$45, 1), name, doc, level];
		                atomic_list_cons(src, bQM);
		                return src;
		               }
		               function level(s){return caml_atomic_load(s[4]);}
		               var
		                default$4 = create$18(gD, "application"),
		                list$4 = [0, 0],
		                id$44 = [0, 0];
		               function def(a, name, pp){
		                var
		                 doc = a ? a[1] : cst_undocumented,
		                 E = [248, cst_E, caml_fresh_oo_id()];
		                function of_univ(param, cont){
		                 if(param[1] !== E) return cont(0);
		                 var x = param[2];
		                 return cont(x);
		                }
		                function to_univ(x, cont){return cont([0, E, [0, x]]);}
		                var
		                 a =
		                   [0,
		                    caml_atomic_fetch_add(id$44, 1),
		                    to_univ,
		                    of_univ,
		                    name,
		                    doc,
		                    pp];
		                atomic_list_cons([0, a], list$4);
		                return a;
		               }
		               function compare$22(a, param, cont){
		                var k1 = param[1], k0 = a[1];
		                return cont(caml_int_compare(k0[1], k1[1]));
		               }
		               var M$0 = k([0, compare$22]), empty$12 = M$0[1];
		               function add$7(k, v, s, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (M$0[2], [0, k], [0, k, v], s, cont);
		               }
		               function find$4(k, s, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(exn === Not_found) return cont(0);
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call$1
		                        (M$0[17],
		                         [0, k],
		                         s,
		                         function(match){
		                          var v = match[2], k$0 = match[1];
		                          return caml_trampoline_cps_call2
		                                  (k$0[2],
		                                   v,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (k[3], a, function(a){caml_pop_trap(); return cont(a);});
		                                   });
		                         });
		               }
		               var
		                reporter_mutex =
		                  [0,
		                   [0,
		                    function(param, cont){return cont(0);},
		                    function(param, cont){return cont(0);}]],
		                nop_reporter =
		                  [0,
		                   function(b, a, over, k, param, cont){
		                    return caml_trampoline_cps_call2
		                            (over,
		                             0,
		                             function(a){return caml_trampoline_cps_call2(k, 0, cont);});
		                   }],
		                reporter = [0, nop_reporter];
		               function report(src, level, over, k, msgf, cont){
		                var mutex = caml_atomic_load(reporter_mutex);
		                function over$0(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (over,
		                          dummy,
		                          function(a){
		                           return caml_trampoline_cps_call2(mutex[2], 0, cont);
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (mutex[1],
		                         0,
		                         function(a){
		                          caml_push_trap
		                           (function(exn){
		                             return caml_exact_trampoline_cps_call
		                                     (over$0,
		                                      dummy,
		                                      function(a){
		                                       a = caml_pop_trap();
		                                       var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                                       return a(exn$0);
		                                      });
		                            });
		                          return caml_trampoline_cps_call6
		                                  (caml_atomic_load(reporter)[1],
		                                   src,
		                                   level,
		                                   over$0,
		                                   k,
		                                   msgf,
		                                   function(a){caml_pop_trap(); return cont(a);});
		                         });
		               }
		               var n = caml_sys_argv().length - 1;
		               if(0 === n)
		                caml_callback(basename$2, [executable_name]);
		               else
		                caml_callback
		                 (basename$2, [caml_check_bound(caml_sys_argv(), 0)[1]]);
		               function over(param, cont){return cont();}
		               var err_count = [0, 0], warn_count = [0, 0];
		               function kmsg(k, a, level$0, msgf, cont){
		                var src = a ? a[1] : default$4;
		                if(3 > level$0)
		                 switch(level$0){
		                   case 1:
		                    incr(err_count); break;
		                   case 2:
		                    incr(warn_count); break;
		                 }
		                a = level(src);
		                if(! a) return caml_trampoline_cps_call2(k, 0, cont);
		                var current_level = a[1];
		                return current_level < level$0
		                        ? caml_trampoline_cps_call2(k, 0, cont)
		                        : caml_exact_trampoline_cps_call$3
		                          (report, src, level$0, over, k, msgf, cont);
		               }
		               function kunit(param, cont){return cont(0);}
		               function warn(src, msgf, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (kmsg, kunit, src, 2, msgf, cont);
		               }
		               function info(src, msgf, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (kmsg, kunit, src, 3, msgf, cont);
		               }
		               function src_log(src){
		                function msg(level, msgf, cont){
		                 var src$0 = [0, src];
		                 return caml_exact_trampoline_cps_call$2
		                         (kmsg, kunit, src$0, level, msgf, cont);
		                }
		                function err(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 1, msgf, cont);
		                }
		                function warn(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 2, msgf, cont);
		                }
		                function info(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 3, msgf, cont);
		                }
		                function debug(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 4, msgf, cont);
		                }
		                return [0, msg, , err, warn, info, debug];
		               }
		               function symbol$56(param){
		                var d = param[1];
		                if(! caml_notequal(param[2], gF)) return [0, - d | 0, gG];
		                var ps = param[2];
		                return [0,
		                        - (d + 1 | 0) | 0,
		                        caml_int64_sub(ps_count_in_day, ps)];
		               }
		               function symbol$57(a, param){
		                var
		                 ps1 = param[2],
		                 d1 = param[1],
		                 ps0 = a[2],
		                 d0 = a[1],
		                 d = d0 + d1 | 0,
		                 ps = caml_int64_add(ps0, ps1),
		                 ps_clamp = caml_int64_mod(ps, ps_count_in_day),
		                 d$0 = d + caml_int64_compare(ps, ps_clamp) | 0;
		                return [0, d$0, ps_clamp];
		               }
		               function symbol$58(s0, s1){
		                return symbol$57(s0, symbol$56(s1));
		               }
		               function of_int_s(secs){
		                var
		                 d = stdlib_abs(secs),
		                 s =
		                   [0,
		                    d / 86400 | 0,
		                    caml_int64_mul
		                     (caml_int64_of_int32(d % 86400 | 0), ps_count_in_s)];
		                return 0 <= secs ? s : symbol$56(s);
		               }
		               function to_int_s(param){
		                var ps = param[2], d = param[1];
		                if(d >= -24855 && 24855 >= d){
		                 var
		                  days_s = d * 86400 | 0,
		                  day_s =
		                    caml_int64_to_int32(caml_int64_div(ps, ps_count_in_s)),
		                  secs = days_s + day_s | 0;
		                 return secs < days_s ? 0 : [0, secs];
		                }
		                return 0;
		               }
		               function of_float_s(secs){
		                if(secs !== secs) return 0;
		                var days = Math.floor(secs / 86400.);
		                if(! (days < -2147483648.) && ! (2147483647. < days)){
		                 var
		                  rem_s = secs % 86400.,
		                  rem_s$0 = rem_s < 0. ? 86400. + rem_s : rem_s;
		                 if(86400. <= rem_s$0){
		                  var days$0 = days + 1.;
		                  return 2147483647. < days$0 ? 0 : [0, [0, days$0 | 0, gI]];
		                 }
		                 var
		                  match = caml_modf_float(rem_s$0),
		                  rem_s$1 = match[2],
		                  frac_s = match[1],
		                  rem_ps =
		                    caml_int64_mul(caml_int64_of_float(rem_s$1), ps_count_in_s),
		                  frac_ps = caml_int64_of_float(frac_s * 1000000000000.);
		                 return [0, [0, days | 0, caml_int64_add(rem_ps, frac_ps)]];
		                }
		                return 0;
		               }
		               function to_float_s(param){
		                var
		                 ps = param[2],
		                 d = param[1],
		                 days_s = d * 86400.,
		                 day_s =
		                   caml_int64_to_float(caml_int64_div(ps, ps_count_in_s)),
		                 day_rem_ps =
		                   caml_int64_to_float(caml_int64_mod(ps, ps_count_in_s));
		                return days_s + day_s + day_rem_ps * 1e-12;
		               }
		               function compare$23(a, param, cont){
		                var
		                 ps1 = param[2],
		                 d1 = param[1],
		                 ps0 = a[2],
		                 d0 = a[1],
		                 c = caml_int_compare(d0, d1);
		                return 0 === c ? cont(caml_int64_compare(ps0, ps1)) : cont(c);
		               }
		               function round_div(a, b){
		                return caml_equal(a, gJ)
		                        ? gK
		                        : caml_int64_div
		                          (caml_int64_add(a, caml_int64_div(b, gL)), b);
		               }
		               var frac_div = caml_obj_dup(gM);
		               function divide_ps(carry, ps, hi, lo){
		                var
		                 hi_d = caml_int64_to_int32(caml_int64_div(ps, hi)),
		                 rem_ps = caml_int64_mod(ps, hi),
		                 lo_d = caml_int64_to_int32(round_div(rem_ps, lo));
		                return lo_d === carry ? [0, hi_d + 1 | 0, 0] : [0, hi_d, lo_d];
		               }
		               function pp_unit
		               (higher_str, hi, hi_str, frac_limit, lo, ppf, neg, ps, cont){
		                function pp_unit_integral(ppf, neg, h, cont){
		                 if(1000 === h){
		                  var a = neg ? -1 : 1;
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           g2,
		                           function(b){
		                            return caml_trampoline_cps_call3(b, a, higher_str, cont);
		                           });
		                 }
		                 var b = neg ? - h | 0 : h;
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          g3,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, b, hi_str, cont);
		                          });
		                }
		                if(! caml_lessthan(ps, frac_limit)){
		                 var ms = divide_ps(1, ps, hi, hi)[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (pp_unit_integral, ppf, neg, ms, cont);
		                }
		                var
		                 match = divide_ps(1000, ps, hi, lo),
		                 l = match[2],
		                 h = match[1];
		                if(100 > h && 0 !== l){
		                 var h$0 = neg ? - h | 0 : h;
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          g4,
		                          function(a){
		                           return caml_trampoline_cps_call4(a, h$0, l, hi_str, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (pp_unit_integral, ppf, neg, h, cont);
		               }
		               var cst_ns = "ns";
		               function pp$4(ppf, s$2, cont){
		                var
		                 sign = s$2[1],
		                 neg = sign < 0 ? 1 : 0,
		                 d = s$2[1],
		                 a = 0 <= d ? s$2 : symbol$56(s$2),
		                 d$2 = a[1];
		                if(0 === d$2){
		                 var ps$0 = a[2];
		                 if(caml_greaterequal(ps$0, ps_count_in_hour)){
		                  a = divide_ps(60, ps$0, ps_count_in_hour, ps_count_in_min);
		                  var m = a[2], h$1 = a[1];
		                  if(24 === h$1){
		                   var e = neg ? -1 : 1;
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            gT,
		                            function(a){return caml_trampoline_cps_call2(a, e, cont);});
		                  }
		                  var h$2 = neg ? - h$1 | 0 : h$1;
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           gU,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     h$2,
		                                     function(b){
		                                      function a(a){return cont(0);}
		                                      return 0 !== m
		      ? caml_exact_trampoline_cps_call
		        (fprintf$0(ppf),
		         gV,
		         function(b){return caml_trampoline_cps_call2(b, m, a);})
		      : a();
		                                     });
		                           });
		                 }
		                 if(caml_greaterequal(ps$0, ps_count_in_min)){
		                  a = divide_ps(60, ps$0, ps_count_in_min, ps_count_in_s);
		                  var s = a[2], m$0 = a[1];
		                  if(60 === m$0){
		                   var f = neg ? -1 : 1;
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            gW,
		                            function(a){return caml_trampoline_cps_call2(a, f, cont);});
		                  }
		                  var m$1 = neg ? - m$0 | 0 : m$0;
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           gX,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     m$1,
		                                     function(b){
		                                      function a(a){return cont(0);}
		                                      return 0 !== s
		      ? caml_exact_trampoline_cps_call
		        (fprintf$0(ppf),
		         gY,
		         function(b){return caml_trampoline_cps_call2(b, s, a);})
		      : a();
		                                     });
		                           });
		                 }
		                 if(! caml_greaterequal(ps$0, ps_count_in_s)){
		                  if(caml_greaterequal(ps$0, ps_count_in_ms))
		                   return caml_exact_trampoline_cps_call$9
		                           (pp_unit,
		                            cst_s$0,
		                            ps_count_in_ms,
		                            cst_ms,
		                            ps_count_in_100ms,
		                            ps_count_in_us,
		                            ppf,
		                            neg,
		                            ps$0,
		                            cont);
		                  if(caml_greaterequal(ps$0, ps_count_in_us))
		                   return caml_exact_trampoline_cps_call$9
		                           (pp_unit,
		                            cst_ms,
		                            ps_count_in_us,
		                            cst_us,
		                            ps_count_in_100us,
		                            ps_count_in_ns,
		                            ppf,
		                            neg,
		                            ps$0,
		                            cont);
		                  if(caml_greaterequal(ps$0, ps_count_in_ns))
		                   return caml_exact_trampoline_cps_call$9
		                           (pp_unit,
		                            cst_us,
		                            ps_count_in_ns,
		                            cst_ns,
		                            ps_count_in_100ns,
		                            ps_count_in_ps,
		                            ppf,
		                            neg,
		                            ps$0,
		                            cont);
		                  var ps = caml_int64_to_int32(ps$0), i = neg ? - ps | 0 : ps;
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           g5,
		                           function(a){return caml_trampoline_cps_call2(a, i, cont);});
		                 }
		                 a = divide_ps(1000, ps$0, ps_count_in_s, ps_count_in_ms);
		                 var ms = a[2], s$0 = a[1];
		                 if(60 === s$0){
		                  var g = neg ? -1 : 1;
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           gZ,
		                           function(a){return caml_trampoline_cps_call2(a, g, cont);});
		                 }
		                 var s$1 = neg ? - s$0 | 0 : s$0;
		                 return 0 === ms
		                         ? caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            g0,
		                            function(a){return caml_trampoline_cps_call2(a, s$1, cont);})
		                         : caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            g1,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, s$1, ms, cont);
		                            });
		                }
		                var ps$1 = a[2];
		                if(365 < d$2){
		                 if(536870911 < d$2)
		                  var rem_d = d$2 % 365 | 0, y = d$2 / 365 | 0;
		                 else
		                  var
		                   y$2 = (d$2 * 4 | 0) / 1461 | 0,
		                   rem_d$0 = d$2 - ((y$2 * 1461 | 0) / 4 | 0) | 0,
		                   rem_d = rem_d$0,
		                   y = y$2;
		                 var
		                  days =
		                    rem_d
		                    + caml_int64_to_int32(round_div(ps$1, ps_count_in_day))
		                    | 0;
		                 if(366 === days)
		                  var days$0 = 1, y$0 = y + 1 | 0;
		                 else {days$0 = days; y$0 = y;}
		                 var y$1 = neg ? - y$0 | 0 : y$0;
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          gN,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    y$1,
		                                    function(b){
		                                     function a(a){return cont(0);}
		                                     return 0 !== days$0
		     ? caml_exact_trampoline_cps_call
		       (fprintf$0(ppf),
		        gO,
		        function(b){return caml_trampoline_cps_call2(b, days$0, a);})
		     : a();
		                                    });
		                          });
		                }
		                var
		                 h = divide_ps(1, ps$1, ps_count_in_hour, ps_count_in_hour)[1];
		                if(24 === h)
		                 var h$0 = 0, d$0 = d$2 + 1 | 0;
		                else {h$0 = h; d$0 = d$2;}
		                if(366 === d$0){
		                 var b = neg ? -1 : 1;
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          gP,
		                          function(a){return caml_trampoline_cps_call2(a, b, cont);});
		                }
		                if(365 === d$0 && 6 <= h$0){
		                 var c = neg ? -1 : 1;
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          gQ,
		                          function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                }
		                var d$1 = neg ? - d$0 | 0 : d$0;
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         gR,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d$1,
		                                   function(b){
		                                    function a(a){return cont(0);}
		                                    return 0 !== h$0
		    ? caml_exact_trampoline_cps_call
		      (fprintf$0(ppf),
		       gS,
		       function(b){return caml_trampoline_cps_call2(b, h$0, a);})
		    : a();
		                                   });
		                         });
		               }
		               function of_span(span){
		                var d = span[1];
		                if(d >= -719528 && 2932896 >= d) return [0, span];
		                return 0;
		               }
		               function of_float_s$0(secs){
		                var match = of_float_s(secs);
		                if(! match) return 0;
		                var d = match[1];
		                return of_span(d);
		               }
		               function add_span(t, d){return of_span(symbol$57(t, d));}
		               function sub_span(t, d){return of_span(symbol$58(t, d));}
		               var mlen = caml_obj_dup(g6);
		               function of_date_time(b){
		                var
		                 t = b[2],
		                 tz_offset_s = t[2],
		                 match = t[1],
		                 ss$0 = match[3],
		                 mm$0 = match[2],
		                 hh$0 = match[1],
		                 date = b[1],
		                 d = date[3],
		                 m$0 = date[2],
		                 y$0 = date[1],
		                 b = 0 <= y$0;
		                if(b){
		                 b = y$0 <= 9999;
		                 if(b){
		                  b = 1 <= m$0;
		                  if(b){
		                   b = m$0 <= 12;
		                   if(b){
		                    b = 1 <= d;
		                    if(b){
		                     a:
		                     {
		                      if(2 === m$0){
		                       b = 0 === (y$0 % 4 | 0);
		                       if(b){
		                        b = 0 !== (y$0 % 100 | 0);
		                        b ||= 0 === (y$0 % 400 | 0);
		                       }
		                       if(b){b = 29; break a;}
		                      }
		                      b = m$0 - 1 | 0;
		                      b = caml_check_bound(mlen, b)[b + 1];
		                     }
		                     b = d <= b;
		                    }
		                   }
		                  }
		                 }
		                }
		                if(b){
		                 b = t[1];
		                 var ss = b[3], mm = b[2], hh = b[1], b = 0 <= hh;
		                 if(b){
		                  b = hh <= 23;
		                  if(b){
		                   b = 0 <= mm;
		                   if(b){
		                    b = mm <= 59;
		                    if(b){b = 0 <= ss; b = b ? ss <= 60 : b;}
		                   }
		                  }
		                 }
		                 if(b){
		                  var
		                   day = date[3],
		                   month = date[2],
		                   year = date[1],
		                   a = (14 - month | 0) / 12 | 0,
		                   y = (year + 4800 | 0) - a | 0,
		                   m = (month + (12 * a | 0) | 0) - 3 | 0,
		                   d$0 =
		                     ((((((day + (((153 * m | 0) + 2 | 0) / 5 | 0) | 0)
		                     + (365 * y | 0)
		                     | 0)
		                     + (y / 4 | 0)
		                     | 0)
		                     - (y / 100 | 0)
		                     | 0)
		                     + (y / 400 | 0)
		                     | 0)
		                     - 32045
		                     | 0)
		                     - 2440588
		                     | 0,
		                   hh_ps =
		                     caml_int64_mul(caml_int64_of_int32(hh$0), ps_count_in_hour),
		                   mm_ps =
		                     caml_int64_mul(caml_int64_of_int32(mm$0), ps_count_in_min),
		                   ss_ps =
		                     caml_int64_mul(caml_int64_of_int32(ss$0), ps_count_in_s),
		                   ps = caml_int64_add(hh_ps, caml_int64_add(mm_ps, ss_ps));
		                  return sub_span([0, d$0, ps], of_int_s(tz_offset_s));
		                 }
		                }
		                return 0;
		               }
		               function to_date_time(f, t){
		                var
		                 tz_offset_s = f ? f[1] : 0,
		                 f = add_span(t, of_int_s(tz_offset_s));
		                if(f)
		                 var
		                  local = f[1],
		                  tz_offset_s$0 = tz_offset_s,
		                  ps = local[2],
		                  d$0 = local[1];
		                else
		                 var
		                  ps$0 = t[2],
		                  d$1 = t[1],
		                  tz_offset_s$0 = 0,
		                  ps = ps$0,
		                  d$0 = d$1;
		                var
		                 jd = d$0 + 2440588 | 0,
		                 a = jd + 32044 | 0,
		                 b = ((4 * a | 0) + 3 | 0) / 146097 | 0,
		                 c = a - ((146097 * b | 0) / 4 | 0) | 0,
		                 d = ((4 * c | 0) + 3 | 0) / 1461 | 0,
		                 e = c - ((1461 * d | 0) / 4 | 0) | 0,
		                 m = ((5 * e | 0) + 2 | 0) / 153 | 0,
		                 day = (e - (((153 * m | 0) + 2 | 0) / 5 | 0) | 0) + 1 | 0,
		                 month = (m + 3 | 0) - (12 * (m / 10 | 0) | 0) | 0,
		                 year =
		                   (((100 * b | 0) + d | 0) - 4800 | 0) + (m / 10 | 0) | 0,
		                 hh =
		                   caml_int64_to_int32(caml_int64_div(ps, ps_count_in_hour)),
		                 hh_rem = caml_int64_mod(ps, ps_count_in_hour),
		                 mm =
		                   caml_int64_to_int32(caml_int64_div(hh_rem, ps_count_in_min)),
		                 mm_rem = caml_int64_mod(hh_rem, ps_count_in_min),
		                 ss =
		                   caml_int64_to_int32(caml_int64_div(mm_rem, ps_count_in_s));
		                return [0,
		                        [0, year, month, day],
		                        [0, [0, hh, mm, ss], tz_offset_s$0]];
		               }
		               function of_date(opt, date){
		                var tz = 0;
		                return of_date_time([0, date, [0, g7, tz]]);
		               }
		               var wday = caml_obj_dup(g8);
		               function pp_rfc3339_error(ppf, param, cont){
		                if(typeof param === "number")
		                 return 3456159 === param
		                         ? caml_exact_trampoline_cps_call(fprintf$0(ppf), g9, cont)
		                         : 415233371
		                           <= param
		                           ? caml_exact_trampoline_cps_call(fprintf$0(ppf), g_, cont)
		                           : caml_exact_trampoline_cps_call(fprintf$0(ppf), g$, cont);
		                var cs = param[2];
		                function pp_chars(ppf, param, cont){
		                 function a(param){
		                  if(! param) return cont(0);
		                  var cs = param[2], c = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           ha,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     c,
		                                     function(b){return caml_exact_trampoline_call1(a, cs);});
		                           });
		                 }
		                 return a(param);
		                }
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         hb,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, pp_chars, cs, cont);
		                         });
		               }
		               var RFC3339 = [248, "Ptime.RFC3339", caml_fresh_oo_id()];
		               function error$1(r, e){
		                throw caml_maybe_attach_backtrace([0, RFC3339, r, e], 1);
		               }
		               function error_pos(p, e){return error$1([0, p, p], e);}
		               function is_digit$0(param){
		                return 9 < param - 48 >>> 0 ? 0 : 1;
		               }
		               function parse_digits(count, pos, max, s){
		                var stop = (pos + count | 0) - 1 | 0;
		                if(max < stop) return error_pos(max, 3456159);
		                var k = pos, acc = 0;
		                for(;;){
		                 if(stop < k) return acc;
		                 if(! is_digit$0(caml_string_get(s, k)))
		                  return error_pos(k, bq);
		                 var
		                  acc$0 =
		                    ((acc * 10 | 0) + caml_string_get(s, k) | 0) - 48 | 0,
		                  k$0 = k + 1 | 0;
		                 k = k$0;
		                 acc = acc$0;
		                }
		               }
		               function parse_char(c, pos, max, s){
		                if(max < pos) return error_pos(max, 3456159);
		                if(caml_string_get(s, pos) === c) return;
		                return error_pos(pos, [0, 498443355, [0, c, 0]]);
		               }
		               function of_rfc3339(f, b, a, s){
		                var
		                 strict = f ? f[1] : 0,
		                 sub = 0,
		                 start = a ? a[1] : 0;
		                try{
		                 var s_len = caml_ml_string_length(s), max = s_len - 1 | 0;
		                 a:
		                 {
		                  if(0 !== s_len && 0 <= start && max >= start){
		                   var
		                    m_pos = start + 5 | 0,
		                    d_pos = m_pos + 3 | 0,
		                    hh_pos = d_pos + 3 | 0,
		                    mm_pos = hh_pos + 3 | 0,
		                    ss_pos = mm_pos + 3 | 0,
		                    decide_pos = ss_pos + 2 | 0,
		                    y = parse_digits(4, start, max, s);
		                   parse_char(45, m_pos - 1 | 0, max, s);
		                   var m = parse_digits(2, m_pos, max, s);
		                   parse_char(45, d_pos - 1 | 0, max, s);
		                   var
		                    d = parse_digits(2, d_pos, max, s),
		                    pos = hh_pos - 1 | 0;
		                   if(max < pos)
		                    error_pos(max, 3456159);
		                   else {
		                    a = caml_string_get(s, pos) - 33 | 0;
		                    b:
		                    {
		                     if(82 < a >>> 0){
		                      if(84 >= a + 1 >>> 0 && ! strict){a = 1; break b;}
		                     }
		                     else if(51 === a){a = 1; break b;}
		                     a = 0;
		                    }
		                    if(! a){
		                     a = strict ? 0 : hd;
		                     error_pos(pos, [0, 498443355, symbol(hc, a)]);
		                    }
		                   }
		                   var hh$0 = parse_digits(2, hh_pos, max, s);
		                   parse_char(58, mm_pos - 1 | 0, max, s);
		                   var mm = parse_digits(2, mm_pos, max, s);
		                   parse_char(58, ss_pos - 1 | 0, max, s);
		                   var ss = parse_digits(2, ss_pos, max, s);
		                   b:
		                   if(max < decide_pos)
		                    a = error_pos(max, 3456159);
		                   else {
		                    var c = caml_string_get(s, decide_pos);
		                    c:
		                    {
		                     if(90 <= c){
		                      if(122 === c){if(strict) break c; a = 18854; break b;}
		                      if(91 <= c) break c;
		                     }
		                     else if(44 <= c){
		                      if(47 <= c) break c;
		                      switch(c - 44 | 0){
		                        case 2:
		                         a = 781960526; break b;
		                        case 0:
		                         break c;
		                      }
		                     }
		                     else if(43 > c) break c;
		                     a = 18854;
		                     break b;
		                    }
		                    a = strict ? 0 : hf;
		                    var
		                     chars = symbol(he, a),
		                     a = error_pos(decide_pos, [0, 498443355, chars]);
		                   }
		                   if(781960526 <= a){
		                    var pos$0 = decide_pos + 1 | 0;
		                    if(max < pos$0)
		                     a = error_pos(max, 3456159);
		                    else if(is_digit$0(caml_string_get(s, pos$0))){
		                     var k = pos$0, acc$0 = acc, pow = ps_count_in_s;
		                     for(;;){
		                      if(max < k){a = error_pos(max, 3456159); break;}
		                      if(! is_digit$0(caml_string_get(s, k))){a = [0, [0, acc$0], k]; break;}
		                      var count = (k - pos$0 | 0) + 1 | 0;
		                      if(12 < count){
		                       var k$0 = k + 1 | 0;
		                       k = k$0;
		                      }
		                      else {
		                       var
		                        pow$0 = caml_int64_div(pow, hg),
		                        acc$1 =
		                          caml_int64_add
		                           (acc$0,
		                            caml_int64_mul
		                             (caml_int64_of_int32(caml_string_get(s, k) - 48 | 0), pow$0)),
		                        k$1 = k + 1 | 0;
		                       k = k$1;
		                       acc$0 = acc$1;
		                       pow = pow$0;
		                      }
		                     }
		                    }
		                    else
		                     a = error_pos(pos$0, bq);
		                    var tz_pos = a[2], frac = a[1];
		                   }
		                   else {tz_pos = decide_pos; frac = 0;}
		                   var
		                    parse_tz_mag =
		                      function(sign, hh_pos){
		                       var hh = parse_digits(2, hh_pos, max, s);
		                       a:
		                       if(strict){
		                        var mm_pos = hh_pos + 3 | 0;
		                        parse_char(58, mm_pos - 1 | 0, max, s);
		                        var mm_pos$0 = mm_pos, mm = parse_digits(2, mm_pos, max, s);
		                       }
		                       else {
		                        var next = hh_pos + 2 | 0;
		                        b:
		                        if(max >= next){
		                         if
		                          (58 !== caml_string_get(s, next)
		                           && ! is_digit$0(caml_string_get(s, next)))
		                          break b;
		                         var
		                          mm_pos$1 =
		                            58 === caml_string_get(s, next)
		                             ? hh_pos + 3 | 0
		                             : hh_pos + 2 | 0,
		                          mm$0 = parse_digits(2, mm_pos$1, max, s),
		                          mm_pos$0 = mm_pos$1,
		                          mm = mm$0;
		                         break a;
		                        }
		                        mm_pos$0 = hh_pos;
		                        mm = 0;
		                       }
		                       if(23 < hh)
		                        return error$1([0, hh_pos, hh_pos + 1 | 0], 415233371);
		                       if(59 < mm)
		                        return error$1([0, mm_pos$0, mm_pos$0 + 1 | 0], 415233371);
		                       var
		                        secs = (hh * 3600 | 0) + (mm * 60 | 0) | 0,
		                        a = 0 === secs,
		                        a = a ? -1 === sign : a,
		                        tz_s = a ? 0 : [0, caml_mul(sign, secs)];
		                       return [0, tz_s, mm_pos$0 + 1 | 0];
		                      };
		                   b:
		                   if(max < tz_pos)
		                    a = error_pos(max, 3456159);
		                   else {
		                    var c$0 = caml_string_get(s, tz_pos);
		                    if(90 === c$0)
		                     a = [0, hh, tz_pos];
		                    else {
		                     if(46 <= c$0){
		                      if(122 === c$0 && ! strict){a = [0, hk, tz_pos]; break b;}
		                     }
		                     else if(43 <= c$0)
		                      switch(c$0 - 43 | 0){
		                        case 0:
		                         a = parse_tz_mag(1, tz_pos + 1 | 0); break b;
		                        case 2:
		                         a = parse_tz_mag(-1, tz_pos + 1 | 0); break b;
		                      }
		                     a = strict ? 0 : hj;
		                     var
		                      chars$0 = symbol(hi, a),
		                      a = error_pos(tz_pos, [0, 498443355, chars$0]);
		                    }
		                   }
		                   var last_pos = a[2], tz_s_opt = a[1];
		                   if(tz_s_opt)
		                    var s$0 = tz_s_opt[1], tz_s = s$0;
		                   else
		                    tz_s = 0;
		                   a =
		                    of_date_time
		                     ([0, [0, y, m, d], [0, [0, hh$0, mm, ss], tz_s]]);
		                   if(! a){
		                    a = error$1([0, start, last_pos], 415233371);
		                    break a;
		                   }
		                   var t = a[1];
		                   if(frac){
		                    var frac$0 = frac[1];
		                    if(caml_notequal(frac$0, hl)){
		                     a = add_span(t, [0, 0, frac$0]);
		                     if(a)
		                      var t$0 = a[1], t$1 = t$0;
		                     else
		                      t$1 = error$1([0, start, last_pos], 415233371)[1];
		                    }
		                    else
		                     t$1 = t;
		                   }
		                   else
		                    t$1 = t;
		                   if(! sub && last_pos !== max){
		                    a = error_pos(last_pos + 1 | 0, -493009593);
		                    break a;
		                   }
		                   a = [0, [0, t$1, tz_s_opt, (last_pos - start | 0) + 1 | 0]];
		                   break a;
		                  }
		                  a = error_pos(start, 3456159);
		                 }
		                 return a;
		                }
		                catch(exn$0){
		                 var exn = caml_wrap_exception(exn$0);
		                 if(exn[1] !== RFC3339)
		                  throw caml_maybe_attach_backtrace(exn, 0);
		                 var e = exn[3], r = exn[2];
		                 return [1, [0, 76606165, [0, r, e]]];
		                }
		               }
		               function rfc3339_adjust_tz_offset(tz_offset_s){
		                if
		                 (-86340 <= tz_offset_s
		                  && tz_offset_s <= 86340 && 0 === (tz_offset_s % 60 | 0))
		                 return [0, tz_offset_s, 0];
		                return hm;
		               }
		               function s_frac_of_ps(frac, ps){
		                var a = caml_check_bound(frac_div, frac)[frac + 1];
		                return caml_int64_div(caml_int64_mod(ps, ps_count_in_s), a);
		               }
		               function to_rfc3339(b, a, tz_offset_s, t, cont){
		                var
		                 space = b ? b[1] : 0,
		                 frac = a ? a[1] : 0,
		                 ps = t[2],
		                 buf = create$1(255);
		                if(tz_offset_s)
		                 var
		                  tz = tz_offset_s[1],
		                  a = rfc3339_adjust_tz_offset(tz),
		                  tz_unknown = a[2],
		                  tz_offset_s$0 = a[1];
		                else {tz_unknown = 1; tz_offset_s$0 = 0;}
		                a = to_date_time([0, tz_offset_s$0], t);
		                b = a[2];
		                var
		                 tz_offset_s$1 = b[2],
		                 b = b[1],
		                 mm = b[3],
		                 ss = b[2],
		                 hh = b[1],
		                 a = a[1],
		                 d = a[3],
		                 m = a[2],
		                 y = a[1],
		                 dt_sep = space ? 32 : 84;
		                return caml_exact_trampoline_cps_call$1
		                        (bprintf,
		                         buf,
		                         hn,
		                         function(a){
		                          return caml_trampoline_cps_call8
		                                  (a,
		                                   y,
		                                   m,
		                                   d,
		                                   dt_sep,
		                                   hh,
		                                   ss,
		                                   mm,
		                                   function(c){
		                                    var frac$0 = 0 <= frac ? 12 < frac ? 12 : frac : 0;
		                                    function a(b){
		                                     function a(a){
		                                      return caml_exact_trampoline_cps_call(contents, buf, cont);
		                                     }
		                                     if(0 === tz_offset_s$1 && ! tz_unknown)
		                                      return caml_exact_trampoline_cps_call$1(bprintf, buf, hq, a);
		                                     a:
		                                     {
		                                      if(0 <= tz_offset_s$1 && ! tz_unknown){var tz_sign = 43; break a;}
		                                      tz_sign = 45;
		                                     }
		                                     var
		                                      tz_min = stdlib_abs(tz_offset_s$1 / 60 | 0),
		                                      tz_hh = tz_min / 60 | 0,
		                                      tz_mm = tz_min % 60 | 0;
		                                     return caml_exact_trampoline_cps_call$1
		     (bprintf,
		      buf,
		      hp,
		      function(b){
		       return caml_trampoline_cps_call4
		               (b, tz_sign, tz_hh, tz_mm, a);
		      });
		                                    }
		                                    if(0 === frac$0) return a();
		                                    var b = s_frac_of_ps(frac$0, ps);
		                                    return caml_exact_trampoline_cps_call$1
		    (bprintf,
		     buf,
		     ho,
		     function(c){
		      return caml_trampoline_cps_call3(c, frac$0, b, a);
		     });
		                                   });
		                         });
		               }
		               function pp_human(a, tz_offset_s, b, ppf, t, cont){
		                var frac = a ? a[1] : 0, ps = t[2];
		                if(tz_offset_s)
		                 var
		                  tz = tz_offset_s[1],
		                  a = rfc3339_adjust_tz_offset(tz),
		                  tz_unknown = a[2],
		                  tz_offset_s$0 = a[1];
		                else {tz_unknown = 1; tz_offset_s$0 = 0;}
		                a = to_date_time([0, tz_offset_s$0], t);
		                b = a[2];
		                var
		                 tz_offset_s$1 = b[2],
		                 b = b[1],
		                 mm = b[3],
		                 ss = b[2],
		                 hh = b[1],
		                 a = a[1],
		                 d = a[3],
		                 m = a[2],
		                 y = a[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         hr,
		                         function(a){
		                          return caml_trampoline_cps_call7
		                                  (a,
		                                   y,
		                                   m,
		                                   d,
		                                   hh,
		                                   ss,
		                                   mm,
		                                   function(c){
		                                    var frac$0 = 0 <= frac ? 12 < frac ? 12 : frac : 0;
		                                    function a(a){
		                                     a:
		                                     {
		                                      if(0 <= tz_offset_s$1 && ! tz_unknown){var tz_sign = 43; break a;}
		                                      tz_sign = 45;
		                                     }
		                                     var
		                                      tz_min = stdlib_abs(tz_offset_s$1 / 60 | 0),
		                                      tz_hh = tz_min / 60 | 0,
		                                      tz_mm = tz_min % 60 | 0;
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(ppf),
		      ht,
		      function(a){
		       return caml_trampoline_cps_call4
		               (a, tz_sign, tz_hh, tz_mm, function(a){return cont(0);});
		      });
		                                    }
		                                    if(0 === frac$0) return a();
		                                    var b = s_frac_of_ps(frac$0, ps);
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(ppf),
		     hs,
		     function(c){
		      return caml_trampoline_cps_call3(c, frac$0, b, a);
		     });
		                                   });
		                         });
		               }
		               function _12(a, b, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (pp_human, 0, hu, dummy, a, b, cont);
		               }
		               function symbol$59(x, y){
		                if(y < 1)
		                 throw caml_maybe_attach_backtrace(Division_by_zero, 1);
		                return 0 < x ? 1 + caml_div(x - 1 | 0, y) | 0 : 0;
		               }
		               function unsafe_set_uint8(t, off, v, cont){
		                return caml_exact_trampoline_cps_call
		                        (chr,
		                         v,
		                         function(a){
		                          caml_bytes_unsafe_set(t, off, a);
		                          return cont();
		                         });
		               }
		               function make_alphabet(alphabet, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (contains,
		                          alphabet,
		                          61,
		                          function(b){
		                           function a(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (init,
		                                     caml_ml_string_length(alphabet),
		                                     function(i, cont){
		                                      return cont(caml_string_get(alphabet, i));
		                                     },
		                                     function(emap){
		                                      var
		                                       dmap = caml_make_vect(256, -1),
		                                       a = caml_ml_string_length(alphabet) - 1 | 0;
		                                      if(a >= 0){
		                                       var idx = 0;
		                                       for(;;){
		var chr = caml_string_unsafe_get(alphabet, idx);
		caml_check_bound(dmap, chr)[chr + 1] = idx;
		var b = idx + 1 | 0;
		if(a === idx) break;
		idx = b;
		                                       }
		                                      }
		                                      return cont([0, emap, dmap]);
		                                     });
		                           }
		                           return b
		                                   ? caml_exact_trampoline_cps_call
		                                     (invalid_arg,
		                                      "Alphabet can not contain padding character",
		                                      a)
		                                   : a();
		                          });
		                }
		                return 64 !== caml_ml_string_length(alphabet)
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg, "Length of alphabet must be 64", a)
		                        : a();
		               }
		               var
		                default_alphabet =
		                  caml_callback
		                   (make_alphabet,
		                    ["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"]),
		                uri_safe_alphabet =
		                  caml_callback
		                   (make_alphabet,
		                    ["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"]);
		               function unsafe_set_be_uint16(t, off, v){
		                caml_bytes_set16(t, off, caml_bswap16(v));
		               }
		               var
		                Out_of_bounds =
		                  [248, "Base64.Out_of_bounds", caml_fresh_oo_id()],
		                Too_much_input =
		                  [248, "Base64.Too_much_input", caml_fresh_oo_id()];
		               function get_uint8(t, off){
		                var a = off < 0, a = a || caml_ml_string_length(t) <= off;
		                if(a) throw caml_maybe_attach_backtrace(Out_of_bounds, 1);
		                return caml_string_unsafe_get(t, off);
		               }
		               function error_msgf(fmt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ksprintf$0,
		                         function(err, cont){return cont([1, [0, 3854881, err]]);},
		                         fmt,
		                         cont);
		               }
		               var padding = 61;
		               function encode$0(c, opt, off$6, len$1, input, cont){
		                var
		                 pad = c ? c[1] : 1,
		                 alphabet = opt ? opt[1] : default_alphabet,
		                 emap = alphabet[1],
		                 off = off$6 ? off$6[1] : 0;
		                if(len$1)
		                 var len = len$1[1], len$0 = len;
		                else
		                 len$0 = caml_ml_string_length(input) - off | 0;
		                function a(err){
		                 if(0 !== err[0]) return cont(err);
		                 var
		                  match = err[1],
		                  len = match[3],
		                  off = match[2],
		                  res = match[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (get_sub, res, off, len, function(a){return cont([0, a]);});
		                }
		                if
		                 (0 <= len$0
		                  &&
		                   0 <= off
		                   && (caml_ml_string_length(input) - len$0 | 0) >= off){
		                 var
		                  n = symbol$59(len$0, 3) * 4 | 0,
		                  res = caml_create_bytes(n),
		                  emit =
		                    function(b1, b2, b3, i){
		                     var
		                      i$0 = (b1 << 4 | b2 >>> 4 | 0) & 63,
		                      i$1 = (b1 >>> 2 | 0) & 63;
		                     unsafe_set_be_uint16
		                      (res, i, emap[i$1 + 1] << 8 | emap[i$0 + 1]);
		                     var i$2 = b3 & 63, i$3 = (b2 << 2 | b3 >>> 6 | 0) & 63;
		                     return unsafe_set_be_uint16
		                             (res, i + 2 | 0, emap[i$3 + 1] << 8 | emap[i$2 + 1]);
		                    };
		                 a:
		                 {
		                  b:
		                  {
		                   var j = 0, i = 0;
		                   for(;;){
		                    if(i === len$0) break a;
		                    if(i === (len$0 - 1 | 0)) break b;
		                    if(i === (len$0 - 2 | 0)) break;
		                    var
		                     off$3 = (off + i | 0) + 2 | 0,
		                     off$4 = (off + i | 0) + 1 | 0,
		                     off$5 = off + i | 0;
		                    emit
		                     (caml_string_unsafe_get(input, off$5),
		                      caml_string_unsafe_get(input, off$4),
		                      caml_string_unsafe_get(input, off$3),
		                      j);
		                    var i$0 = i + 3 | 0, j$0 = j + 4 | 0;
		                    j = j$0;
		                    i = i$0;
		                   }
		                   var off$1 = (off + i | 0) + 1 | 0, off$2 = off + i | 0;
		                   emit
		                    (caml_string_unsafe_get(input, off$2),
		                     caml_string_unsafe_get(input, off$1),
		                     0,
		                     j);
		                   break a;
		                  }
		                  var off$0 = off + i | 0;
		                  emit(caml_string_unsafe_get(input, off$0), 0, 0, j);
		                 }
		                 var
		                  pad_to_write = (3 - (len$0 % 3 | 0) | 0) % 3 | 0,
		                  b =
		                    function(i){
		                     return 0 === i
		                             ? a([0, [0, caml_string_of_bytes(res), 0, n]])
		                             : caml_exact_trampoline_cps_call$0
		                               (unsafe_set_uint8,
		                                res,
		                                n - i | 0,
		                                padding,
		                                function(a){
		                                 var i$0 = i - 1 | 0;
		                                 return caml_exact_trampoline_call1(b, i$0);
		                                });
		                    };
		                 return pad
		                         ? b(pad_to_write)
		                         : a
		                           ([0,
		                             [0, caml_string_of_bytes(res), 0, n - pad_to_write | 0]]);
		                }
		                return caml_exact_trampoline_cps_call(error_msgf, hv, a);
		               }
		               function encode_string(pad, alphabet, input, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (encode$0,
		                         pad,
		                         alphabet,
		                         0,
		                         0,
		                         input,
		                         function(a){
		                          if(0 === a[0]){var res = a[1]; return cont(res);}
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Assert_failure, hw], 1));
		                         });
		               }
		               function bQO(b, param, opt, len, input, cont){
		                var
		                 invalid_pad_overflow = b ? b[1] : 1,
		                 dmap = param[2],
		                 off = opt ? opt[1] : 0;
		                if(len)
		                 var len$0 = len[1], len$1 = len$0;
		                else
		                 len$1 = caml_ml_string_length(input) - off | 0;
		                if
		                 (0 <= len$1
		                  &&
		                   0 <= off
		                   && (caml_ml_string_length(input) - len$1 | 0) >= off){
		                 var
		                  n = symbol$59(len$1, 4) * 4 | 0,
		                  n$0 = symbol$59(n, 4) * 3 | 0,
		                  res = caml_create_bytes(n$0),
		                  get_uint8_or_padding =
		                    invalid_pad_overflow
		                     ? function
		                      (t, i){
		                       if(len$1 <= i)
		                        throw caml_maybe_attach_backtrace(Out_of_bounds, 1);
		                       return get_uint8(t, off + i | 0);
		                      }
		                     : function
		                      (t, i){
		                       try{
		                        var a = i < len$1 ? get_uint8(t, off + i | 0) : padding;
		                        return a;
		                       }
		                       catch(exn$0){
		                        var exn = caml_wrap_exception(exn$0);
		                        if(exn === Out_of_bounds) return padding;
		                        throw caml_maybe_attach_backtrace(exn, 0);
		                       }
		                      },
		                  dmap$0 =
		                    function(i){
		                     var x = dmap[i + 1];
		                     if(x === -1)
		                      throw caml_maybe_attach_backtrace(Not_found, 1);
		                     return x;
		                    },
		                  only_padding =
		                    function(pad, idx){
		                     var idx$0 = idx, pad$0 = pad + 3 | 0;
		                     for(;;){
		                      if((idx$0 + 4 | 0) >= len$1){var idx$1 = idx$0; break;}
		                      var
		                       a = 15677 !== caml_string_get16(input, off + idx$0 | 0),
		                       a =
		                         a
		                         ||
		                          15677
		                          !== caml_string_get16(input, (off + idx$0 | 0) + 2 | 0);
		                      if(a) throw caml_maybe_attach_backtrace(Not_found, 1);
		                      idx$0 = idx$0 + 4 | 0;
		                      pad$0 = pad$0 + 3 | 0;
		                     }
		                     for(;;){
		                      if(idx$1 >= len$1) return pad$0;
		                      var off$0 = off + idx$1 | 0;
		                      if(caml_string_unsafe_get(input, off$0) !== 61)
		                       throw caml_maybe_attach_backtrace(Not_found, 1);
		                      var idx$2 = idx$1 + 1 | 0;
		                      idx$1 = idx$2;
		                     }
		                    };
		                 caml_push_trap
		                  (function(exn){
		                    if(exn === Out_of_bounds)
		                     return caml_exact_trampoline_cps_call(error_msgf, hy, cont);
		                    if(exn === Not_found)
		                     return caml_exact_trampoline_cps_call(error_msgf, hz, cont);
		                    if(exn === Too_much_input)
		                     return caml_exact_trampoline_cps_call(error_msgf, hA, cont);
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   });
		                 var
		                  a =
		                    function(off, i){
		                     function f(pad){
		                      caml_pop_trap();
		                      return 0 === pad
		                              ? cont([0, [0, caml_string_of_bytes(res), 0, n$0]])
		                              : cont
		                                ([0, [0, caml_string_of_bytes(res), 0, n$0 - pad | 0]]);
		                     }
		                     if(i === n) return f(0);
		                     var x$0 = get_uint8_or_padding(input, i + 3 | 0);
		                     a:
		                     try{var e = dmap$0(x$0), pad = 0, d = e;}
		                     catch(exn$0){
		                      var exn = caml_wrap_exception(exn$0);
		                      if(exn === Not_found && x$0 === 61){pad = 1; d = 0; break a;}
		                      e = caml_pop_trap();
		                      var exn$6 = caml_maybe_attach_backtrace(exn, 0);
		                      return e(exn$6);
		                     }
		                     var x$1 = get_uint8_or_padding(input, i + 2 | 0);
		                     a:
		                     try{e = dmap$0(x$1); var pad$0 = pad, c = e;}
		                     catch(exn){
		                      var exn$0 = caml_wrap_exception(exn);
		                      if(exn$0 === Not_found && x$1 === 61 && 1 === pad){pad$0 = 2; c = 0; break a;}
		                      e = caml_pop_trap();
		                      var exn$5 = caml_maybe_attach_backtrace(exn$0, 0);
		                      return e(exn$5);
		                     }
		                     var x$2 = get_uint8_or_padding(input, i + 1 | 0);
		                     a:
		                     try{e = dmap$0(x$2); var pad$1 = pad$0, b = e;}
		                     catch(exn){
		                      var exn$1 = caml_wrap_exception(exn);
		                      if(exn$1 === Not_found && x$2 === 61 && 2 === pad$0){pad$1 = 3; b = 0; break a;}
		                      e = caml_pop_trap();
		                      var exn$4 = caml_maybe_attach_backtrace(exn$1, 0);
		                      return e(exn$4);
		                     }
		                     var x$3 = get_uint8_or_padding(input, i);
		                     a:
		                     try{e = dmap$0(x$3); var pad$2 = pad$1, a$0 = e;}
		                     catch(exn){
		                      var exn$2 = caml_wrap_exception(exn);
		                      if(exn$2 === Not_found && x$3 === 61 && 3 === pad$1){pad$2 = 4; a$0 = 0; break a;}
		                      e = caml_pop_trap();
		                      var exn$3 = caml_maybe_attach_backtrace(exn$2, 0);
		                      return e(exn$3);
		                     }
		                     var x = a$0 << 18 | b << 12 | c << 6 | d, v = x >>> 8 | 0;
		                     function g(c){
		                      var v = x & 255, off$0 = off + 2 | 0;
		                      function b(b){
		                       if((i + 4 | 0) === n)
		                        return 0 === pad$2 ? f(0) : 4 === pad$2 ? f(3) : f(pad$2);
		                       if(0 === pad$2){
		                        var i$0 = i + 4 | 0, j = off + 3 | 0;
		                        return caml_exact_trampoline_call2(a, j, i$0);
		                       }
		                       if(4 === pad$2) return f(only_padding(3, i + 4 | 0));
		                       if(1 !== invalid_pad_overflow)
		                        return f(only_padding(pad$2, i + 4 | 0));
		                       b = caml_pop_trap();
		                       var
		                        Too_much_input$0 =
		                          caml_maybe_attach_backtrace(Too_much_input, 1);
		                       return b(Too_much_input$0);
		                      }
		                      return 0 <= off$0
		                              ? caml_ml_bytes_length
		                                 (res)
		                                <= off$0
		                                ? b(0)
		                                : caml_exact_trampoline_cps_call$0
		                                  (unsafe_set_uint8, res, off$0, v, b)
		                              : b(0);
		                     }
		                     if(0 > off) return g();
		                     if(caml_ml_bytes_length(res) < (off + 1 | 0)) return g();
		                     if(0 <= off && caml_ml_bytes_length(res) >= (off + 2 | 0)){unsafe_set_be_uint16(res, off, v); return g();}
		                     return caml_exact_trampoline_cps_call$0
		                             (unsafe_set_uint8, res, off, v >>> 8 | 0, g);
		                    };
		                 return a(0, 0);
		                }
		                return caml_exact_trampoline_cps_call(error_msgf, hx, cont);
		               }
		               function decode(pad, opt, off, len, input, cont){
		                var alphabet = opt ? opt[1] : default_alphabet;
		                return caml_exact_trampoline_cps_call$3
		                        (bQO,
		                         pad,
		                         alphabet,
		                         off,
		                         len,
		                         input,
		                         function(err){
		                          if(0 !== err[0]) return cont(err);
		                          var
		                           match = err[1],
		                           len = match[3],
		                           off = match[2],
		                           res = match[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (get_sub, res, off, len, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                Error =
		                  [248, "Bytesrw.Bytes.Stream.Error", caml_fresh_oo_id()];
		               function printer(a, cont){
		                if(a[1] !== Error) return cont(0);
		                var
		                 e = a[2],
		                 m = e[2],
		                 error = e[1],
		                 a = m[1],
		                 context = a ? 87 <= a[1] ? cst_writer : cst_reader : cst$1,
		                 a = m[2];
		                function b(header){
		                 return caml_trampoline_cps_call2
		                         (m[3],
		                          error,
		                          function(message){
		                           var match = m[4];
		                           function a(pos){
		                            return caml_exact_trampoline_cps_call
		                                    (sprintf,
		                                     hC,
		                                     function(a){
		                                      return caml_trampoline_cps_call4
		      (a,
		       header,
		       pos,
		       message,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (sprintf,
		                 hD,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (b, a, function(a){return cont([0, a]);});
		                 });
		       });
		                                     });
		                           }
		                           if(! match) return a(cst$1);
		                           var p = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (sprintf,
		                                    hB,
		                                    function(b){return caml_trampoline_cps_call2(b, p, a);});
		                          });
		                }
		                return a !== cst$1
		                        ? context
		                          !== cst$1
		                          ? caml_exact_trampoline_cps_call$1
		                            (concat, cst$7, [0, a, [0, context, 0]], b)
		                          : b(a)
		                        : b(context);
		               }
		               register_printer(printer);
		               function unsafe_set_byte(s, j, byte){caml_bytes_unsafe_set(s, j, byte);
		               }
		               function malformed(s, j, l, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (sub_string,
		                         s,
		                         j,
		                         l,
		                         function(a){return cont([0, 659980059, a]);});
		               }
		               function malformed_pair(be, hi, s, j, l, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (sub,
		                         s,
		                         j,
		                         l,
		                         function(bs1){
		                          var bs0 = caml_create_bytes(2);
		                          if(be) var j1 = 1, j0 = 0; else {j1 = 0; j0 = 1;}
		                          unsafe_set_byte(bs0, j0, hi >>> 8 | 0);
		                          unsafe_set_byte(bs0, j1, hi & 255);
		                          var
		                           l1 = caml_ml_bytes_length(bs0),
		                           l2 = caml_ml_bytes_length(bs1),
		                           r = caml_create_bytes(l1 + l2 | 0);
		                          caml_blit_bytes(bs0, 0, r, 0, l1);
		                          caml_blit_bytes(bs1, 0, r, l1, l2);
		                          return cont([0, 659980059, caml_string_of_bytes(r)]);
		                         });
		               }
		               var utf_8_len = caml_obj_dup(hF);
		               function r_utf_8(s, j, l, a){
		                function uchar(c){return [0, 852405675, c];}
		                var switcher = l - 1 | 0;
		                if(3 < switcher >>> 0){
		                 a = caml_pop_trap();
		                 return a
		                         (caml_maybe_attach_backtrace([0, Assert_failure, hG], 1));
		                }
		                switch(switcher){
		                  case 0:
		                   return a(uchar(caml_bytes_unsafe_get(s, j)));
		                  case 1:
		                   var
		                    b0$1 = caml_bytes_unsafe_get(s, j),
		                    j$0 = j + 1 | 0,
		                    b1$1 = caml_bytes_unsafe_get(s, j$0);
		                   return 2 === (b1$1 >>> 6 | 0)
		                           ? a(uchar((b0$1 & 31) << 6 | b1$1 & 63))
		                           : caml_exact_trampoline_cps_call$0(malformed, s, j, l, a);
		                  case 2:
		                   var
		                    b0$0 = caml_bytes_unsafe_get(s, j),
		                    j$1 = j + 1 | 0,
		                    b1$0 = caml_bytes_unsafe_get(s, j$1),
		                    j$2 = j + 2 | 0,
		                    b2$0 = caml_bytes_unsafe_get(s, j$2),
		                    c = (b0$0 & 15) << 12 | (b1$0 & 63) << 6 | b2$0 & 63;
		                   if(2 !== (b2$0 >>> 6 | 0))
		                    return caml_exact_trampoline_cps_call$0
		                            (malformed, s, j, l, a);
		                   if(224 === b0$0){
		                    if(160 <= b1$0 && 191 >= b1$0) return a(uchar(c));
		                    return caml_exact_trampoline_cps_call$0
		                            (malformed, s, j, l, a);
		                   }
		                   if(237 !== b0$0)
		                    return 2 === (b1$0 >>> 6 | 0)
		                            ? a(uchar(c))
		                            : caml_exact_trampoline_cps_call$0(malformed, s, j, l, a);
		                   if(128 <= b1$0 && 159 >= b1$0) return a(uchar(c));
		                   return caml_exact_trampoline_cps_call$0
		                           (malformed, s, j, l, a);
		                  default:
		                   var
		                    b0 = caml_bytes_unsafe_get(s, j),
		                    j$3 = j + 1 | 0,
		                    b1 = caml_bytes_unsafe_get(s, j$3),
		                    j$4 = j + 2 | 0,
		                    b2 = caml_bytes_unsafe_get(s, j$4),
		                    j$5 = j + 3 | 0,
		                    b3 = caml_bytes_unsafe_get(s, j$5),
		                    c$0 =
		                      (b0 & 7) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
		                   if(2 === (b3 >>> 6 | 0) && 2 === (b2 >>> 6 | 0)){
		                    if(240 === b0){
		                     if(144 <= b1 && 191 >= b1) return a(uchar(c$0));
		                     return caml_exact_trampoline_cps_call$0
		                             (malformed, s, j, l, a);
		                    }
		                    if(244 !== b0)
		                     return 2 === (b1 >>> 6 | 0)
		                             ? a(uchar(c$0))
		                             : caml_exact_trampoline_cps_call$0(malformed, s, j, l, a);
		                    if(128 <= b1 && 143 >= b1) return a(uchar(c$0));
		                    return caml_exact_trampoline_cps_call$0
		                            (malformed, s, j, l, a);
		                   }
		                   return caml_exact_trampoline_cps_call$0
		                           (malformed, s, j, l, a);
		                }
		               }
		               function r_utf_16(s, j0, j1, cont){
		                var
		                 b0 = caml_bytes_unsafe_get(s, j0),
		                 b1 = caml_bytes_unsafe_get(s, j1),
		                 u = b0 << 8 | b1;
		                if(55296 <= u && 57343 >= u)
		                 return 56319 < u
		                         ? caml_exact_trampoline_cps_call$0
		                           (malformed, s, min(j0, j1), 2, cont)
		                         : cont([0, 16161, u]);
		                return cont([0, 852405675, u]);
		               }
		               function r_utf_16_lo(hi, s, j0, j1, cont){
		                var
		                 b0 = caml_bytes_unsafe_get(s, j0),
		                 b1 = caml_bytes_unsafe_get(s, j1),
		                 lo = b0 << 8 | b1;
		                if(56320 <= lo && 57343 >= lo)
		                 return cont
		                         ([0, 852405675, ((hi & 1023) << 10 | lo & 1023) + 65536 | 0]);
		                return caml_exact_trampoline_cps_call$3
		                        (malformed_pair,
		                         j0 < j1 ? 1 : 0,
		                         hi,
		                         s,
		                         min(j0, j1),
		                         2,
		                         cont);
		               }
		               function r_encoding(s, j, l){
		                function some(i){
		                 if(i >= l) return 0;
		                 var j$0 = j + i | 0;
		                 return [0, caml_bytes_unsafe_get(s, j$0)];
		                }
		                var match = some(0), match$0 = some(1), match$1 = some(2);
		                if(! match){
		                 if(match$0)
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, hO], 1);
		                 if(match$1)
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, hP], 1);
		                 return hQ;
		                }
		                var p = match[1];
		                a:
		                {
		                 if(240 <= p){
		                  if(254 === p){
		                   if(! match$0) break a;
		                   if(255 === match$0[1]) return hH;
		                  }
		                  else if(255 === p){
		                   if(! match$0) break a;
		                   if(254 === match$0[1]) return hM;
		                  }
		                 }
		                 else if(0 === p){
		                  if(! match$0) break a;
		                  var p$0 = match$0[1];
		                  if(0 < p$0) return [0, -211558048, [0, 605782321, p$0]];
		                 }
		                 else if(239 <= p){
		                  if(! match$0) break a;
		                  if(187 === match$0[1]){
		                   if(! match$1) break a;
		                   if(191 === match$1[1]) return hN;
		                   break a;
		                  }
		                 }
		                 if(match$0 && 0 === match$0[1] && 0 < p)
		                  return [0, -211555818, [0, 605782321, p]];
		                }
		                if(0 !== caml_check_bound(utf_8_len, p)[p + 1]) return hL;
		                if(match$0) return hI;
		                if(match$1)
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, hJ], 1);
		                return hK;
		               }
		               function i_rem(d){return (d[7] - d[6] | 0) + 1 | 0;}
		               var min_value$0 = -2147483648;
		               function eoi(d){
		                d[5] = empty_return;
		                d[6] = 0;
		                d[7] = min_value$0;
		               }
		               function src$0(d, s, j, l, cont){
		                if(0 <= j && 0 <= l && caml_ml_bytes_length(s) >= (j + l | 0))
		                 return 0 === l
		                         ? cont(eoi(d))
		                         : (d[5] = s, d[6] = j, d[7] = (j + l | 0) - 1 | 0, cont());
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         hE,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   j,
		                                   l,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(invalid_arg, a, cont);
		                                   });
		                         });
		               }
		               function refill(k, d, cont){
		                var match = d[1];
		                if(typeof match === "number"){
		                 d[18] = k;
		                 return cont(1006505782);
		                }
		                var variant = match[1];
		                if(438511779 <= variant){
		                 var ic = match[2];
		                 return caml_exact_trampoline_cps_call$2
		                         (input,
		                          ic,
		                          d[5],
		                          0,
		                          caml_ml_bytes_length(d[5]),
		                          function(rc){
		                           return caml_exact_trampoline_cps_call$2
		                                   (src$0,
		                                    d,
		                                    d[5],
		                                    0,
		                                    rc,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(k, d, cont);
		                                    });
		                          });
		                }
		                eoi(d);
		                return caml_exact_trampoline_cps_call(k, d, cont);
		               }
		               function t_need(d, need){d[9] = 0; d[10] = need;}
		               function t_fill(k, d, cont){
		                function blit(d, l){
		                 caml_blit_bytes(d[5], d[6], d[8], d[9], l);
		                 d[6] = d[6] + l | 0;
		                 d[9] = d[9] + l | 0;
		                }
		                var rem = i_rem(d);
		                if(0 > rem) return caml_exact_trampoline_cps_call(k, d, cont);
		                var need = d[10] - d[9] | 0;
		                return rem < need
		                        ? (blit
		                           (d, rem),
		                          caml_exact_trampoline_cps_call$1
		                           (refill,
		                            function(a, cont){
		                             return caml_exact_trampoline_cps_call$1(t_fill, k, a, cont);
		                            },
		                            d,
		                            cont))
		                        : (blit
		                           (d, need),
		                          caml_exact_trampoline_cps_call(k, d, cont));
		               }
		               function ret(k, v, byte_count, d, cont){
		                d[18] = k;
		                d[15] = d[15] + byte_count | 0;
		                return caml_trampoline_cps_call3(d[17], d, v, cont);
		               }
		               function decode_us_ascii(d, cont){
		                var rem = i_rem(d);
		                if(0 >= rem)
		                 return 0 <= rem
		                         ? caml_exact_trampoline_cps_call$1
		                           (refill, decode_us_ascii, d, cont)
		                         : cont(3455931);
		                var j = d[6];
		                d[6] = d[6] + 1 | 0;
		                var s = d[5], b0 = caml_bytes_unsafe_get(s, j);
		                function a(a){
		                 return caml_exact_trampoline_cps_call$2
		                         (ret, decode_us_ascii, a, 1, d, cont);
		                }
		                return 127 < b0
		                        ? caml_exact_trampoline_cps_call$0(malformed, s, j, 1, a)
		                        : a([0, 852405675, b0]);
		               }
		               function decode_iso_8859_1(d, cont){
		                var rem = i_rem(d);
		                if(0 >= rem)
		                 return 0 <= rem
		                         ? caml_exact_trampoline_cps_call$1
		                           (refill, decode_iso_8859_1, d, cont)
		                         : cont(3455931);
		                var j = d[6];
		                d[6] = d[6] + 1 | 0;
		                var s = d[5];
		                return caml_exact_trampoline_cps_call$2
		                        (ret,
		                         decode_iso_8859_1,
		                         [0, 852405675, caml_bytes_unsafe_get(s, j)],
		                         1,
		                         d,
		                         cont);
		               }
		               function t_decode_utf_8(d, cont){
		                if(d[9] < d[10]){
		                 var a = d[9];
		                 return caml_exact_trampoline_cps_call$0
		                         (malformed,
		                          d[8],
		                          0,
		                          d[9],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$2
		                                   (ret, decode_utf_8, b, a, d, cont);
		                          });
		                }
		                var b = d[9];
		                return caml_exact_trampoline_cps_call$0
		                        (r_utf_8,
		                         d[8],
		                         0,
		                         d[9],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (ret, decode_utf_8, a, b, d, cont);
		                         });
		               }
		               function decode_utf_8(d, cont){
		                var rem = i_rem(d);
		                if(0 >= rem)
		                 return 0 <= rem
		                         ? caml_exact_trampoline_cps_call$1
		                           (refill, decode_utf_8, d, cont)
		                         : cont(3455931);
		                var
		                 j = d[6],
		                 s = d[5],
		                 need = utf_8_len[caml_bytes_unsafe_get(s, j) + 1];
		                if(rem < need){
		                 t_need(d, need);
		                 return caml_exact_trampoline_cps_call$1
		                         (t_fill, t_decode_utf_8, d, cont);
		                }
		                var j$0 = d[6];
		                if(0 === need){
		                 d[6] = d[6] + 1 | 0;
		                 return caml_exact_trampoline_cps_call$0
		                         (malformed,
		                          d[5],
		                          j$0,
		                          1,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$2
		                                   (ret, decode_utf_8, a, 1, d, cont);
		                          });
		                }
		                d[6] = d[6] + need | 0;
		                return caml_exact_trampoline_cps_call$0
		                        (r_utf_8,
		                         d[5],
		                         j$0,
		                         need,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (ret, decode_utf_8, a, need, d, cont);
		                         });
		               }
		               function t_decode_utf_16be_lo(hi, d, cont){
		                var bcount = d[9] + 2 | 0;
		                return d[9] < d[10]
		                        ? caml_exact_trampoline_cps_call$3
		                          (malformed_pair,
		                           1,
		                           hi,
		                           d[8],
		                           0,
		                           d[9],
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (ret, decode_utf_16be, a, bcount, d, cont);
		                           })
		                        : caml_exact_trampoline_cps_call$2
		                          (r_utf_16_lo,
		                           hi,
		                           d[8],
		                           0,
		                           1,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (ret, decode_utf_16be, a, bcount, d, cont);
		                           });
		               }
		               function t_decode_utf_16be(d, cont){
		                if(d[9] >= d[10])
		                 return caml_exact_trampoline_cps_call$0
		                         (r_utf_16,
		                          d[8],
		                          0,
		                          1,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (decode_utf_16be_lo, a, d, cont);
		                          });
		                var a = d[9];
		                return caml_exact_trampoline_cps_call$0
		                        (malformed,
		                         d[8],
		                         0,
		                         d[9],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$2
		                                  (ret, decode_utf_16be, b, a, d, cont);
		                         });
		               }
		               function decode_utf_16be_lo(v, d, cont){
		                var variant = v[1];
		                if(659980059 <= variant)
		                 return caml_exact_trampoline_cps_call$2
		                         (ret, decode_utf_16be, v, 2, d, cont);
		                var hi = v[2], rem = i_rem(d);
		                if(2 <= rem){
		                 var j = d[6];
		                 d[6] = d[6] + 2 | 0;
		                 return caml_exact_trampoline_cps_call$2
		                         (r_utf_16_lo,
		                          hi,
		                          d[5],
		                          j,
		                          j + 1 | 0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$2
		                                   (ret, decode_utf_16be, a, 4, d, cont);
		                          });
		                }
		                t_need(d, 2);
		                return caml_exact_trampoline_cps_call$1
		                        (t_fill,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (t_decode_utf_16be_lo, hi, a, cont);
		                         },
		                         d,
		                         cont);
		               }
		               function decode_utf_16be(d, cont){
		                var rem = i_rem(d);
		                if(0 >= rem)
		                 return 0 <= rem
		                         ? caml_exact_trampoline_cps_call$1
		                           (refill, decode_utf_16be, d, cont)
		                         : cont(3455931);
		                if(2 <= rem){
		                 var j = d[6];
		                 d[6] = d[6] + 2 | 0;
		                 return caml_exact_trampoline_cps_call$0
		                         (r_utf_16,
		                          d[5],
		                          j,
		                          j + 1 | 0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (decode_utf_16be_lo, a, d, cont);
		                          });
		                }
		                t_need(d, 2);
		                return caml_exact_trampoline_cps_call$1
		                        (t_fill, t_decode_utf_16be, d, cont);
		               }
		               function t_decode_utf_16le_lo(hi, d, cont){
		                var bcount = d[9] + 2 | 0;
		                return d[9] < d[10]
		                        ? caml_exact_trampoline_cps_call$3
		                          (malformed_pair,
		                           0,
		                           hi,
		                           d[8],
		                           0,
		                           d[9],
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (ret, decode_utf_16le, a, bcount, d, cont);
		                           })
		                        : caml_exact_trampoline_cps_call$2
		                          (r_utf_16_lo,
		                           hi,
		                           d[8],
		                           1,
		                           0,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (ret, decode_utf_16le, a, bcount, d, cont);
		                           });
		               }
		               function t_decode_utf_16le(d, cont){
		                if(d[9] >= d[10])
		                 return caml_exact_trampoline_cps_call$0
		                         (r_utf_16,
		                          d[8],
		                          1,
		                          0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (decode_utf_16le_lo, a, d, cont);
		                          });
		                var a = d[9];
		                return caml_exact_trampoline_cps_call$0
		                        (malformed,
		                         d[8],
		                         0,
		                         d[9],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$2
		                                  (ret, decode_utf_16le, b, a, d, cont);
		                         });
		               }
		               function decode_utf_16le_lo(v, d, cont){
		                var variant = v[1];
		                if(659980059 <= variant)
		                 return caml_exact_trampoline_cps_call$2
		                         (ret, decode_utf_16le, v, 2, d, cont);
		                var hi = v[2], rem = i_rem(d);
		                if(2 <= rem){
		                 var j = d[6];
		                 d[6] = d[6] + 2 | 0;
		                 return caml_exact_trampoline_cps_call$2
		                         (r_utf_16_lo,
		                          hi,
		                          d[5],
		                          j + 1 | 0,
		                          j,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$2
		                                   (ret, decode_utf_16le, a, 4, d, cont);
		                          });
		                }
		                t_need(d, 2);
		                return caml_exact_trampoline_cps_call$1
		                        (t_fill,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (t_decode_utf_16le_lo, hi, a, cont);
		                         },
		                         d,
		                         cont);
		               }
		               function decode_utf_16le(d, cont){
		                var rem = i_rem(d);
		                if(0 >= rem)
		                 return 0 <= rem
		                         ? caml_exact_trampoline_cps_call$1
		                           (refill, decode_utf_16le, d, cont)
		                         : cont(3455931);
		                if(2 <= rem){
		                 var j = d[6];
		                 d[6] = d[6] + 2 | 0;
		                 return caml_exact_trampoline_cps_call$0
		                         (r_utf_16,
		                          d[5],
		                          j + 1 | 0,
		                          j,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (decode_utf_16le_lo, a, d, cont);
		                          });
		                }
		                t_need(d, 2);
		                return caml_exact_trampoline_cps_call$1
		                        (t_fill, t_decode_utf_16le, d, cont);
		               }
		               function guessed_utf_8(d, cont){
		                function b3(d, cont){
		                 var
		                  s = d[8],
		                  b3 = caml_bytes_unsafe_get(s, 2),
		                  n = caml_check_bound(utf_8_len, b3)[b3 + 1];
		                 if(0 === n)
		                  return caml_exact_trampoline_cps_call$0
		                          (malformed,
		                           d[8],
		                           2,
		                           1,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (ret, decode_utf_8, a, 1, d, cont);
		                           });
		                 d[10] = n;
		                 d[9] = 1;
		                 unsafe_set_byte(d[8], 0, b3);
		                 return caml_exact_trampoline_cps_call$1
		                         (t_fill, t_decode_utf_8, d, cont);
		                }
		                function b2(d, cont){
		                 var
		                  s = d[8],
		                  b2 = caml_bytes_unsafe_get(s, 1),
		                  b3$0 = 2 < d[9] ? b3 : decode_utf_8,
		                  n = caml_check_bound(utf_8_len, b2)[b2 + 1];
		                 if(0 === n)
		                  return caml_exact_trampoline_cps_call$0
		                          (malformed,
		                           d[8],
		                           1,
		                           1,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (ret, b3$0, a, 1, d, cont);
		                           });
		                 if(1 === n)
		                  return caml_exact_trampoline_cps_call$0
		                          (r_utf_8,
		                           d[8],
		                           1,
		                           1,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (ret, b3$0, a, 1, d, cont);
		                           });
		                 d[10] = n;
		                 unsafe_set_byte(d[8], 0, b2);
		                 if(3 <= d[9]){
		                  d[9] = 2;
		                  var s$0 = d[8];
		                  unsafe_set_byte(d[8], 1, caml_bytes_unsafe_get(s$0, 2));
		                 }
		                 else
		                  d[9] = 1;
		                 return caml_exact_trampoline_cps_call$1
		                         (t_fill, t_decode_utf_8, d, cont);
		                }
		                var
		                 s = d[8],
		                 b1 = caml_bytes_unsafe_get(s, 0),
		                 b2$0 = 1 < d[9] ? b2 : decode_utf_8,
		                 n = caml_check_bound(utf_8_len, b1)[b1 + 1];
		                if(4 < n >>> 0){
		                 var raise = caml_pop_trap();
		                 return raise
		                         (caml_maybe_attach_backtrace([0, Assert_failure, hR], 1));
		                }
		                switch(n){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$0
		                           (malformed,
		                            d[8],
		                            0,
		                            1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$2
		                                     (ret, b2$0, a, 1, d, cont);
		                            });
		                  case 1:
		                   return caml_exact_trampoline_cps_call$0
		                           (r_utf_8,
		                            d[8],
		                            0,
		                            1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$2
		                                     (ret, b2$0, a, 1, d, cont);
		                            });
		                  case 2:
		                   if(2 > d[9])
		                    return caml_exact_trampoline_cps_call$0
		                            (malformed,
		                             d[8],
		                             0,
		                             1,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$2
		                                      (ret, decode_utf_8, a, 1, d, cont);
		                             });
		                   if(3 <= d[9])
		                    return caml_exact_trampoline_cps_call$0
		                            (r_utf_8,
		                             d[8],
		                             0,
		                             2,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$2
		                                      (ret, b3, a, 2, d, cont);
		                             });
		                   return caml_exact_trampoline_cps_call$0
		                           (r_utf_8,
		                            d[8],
		                            0,
		                            2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$2
		                                     (ret, decode_utf_8, a, 2, d, cont);
		                            });
		                  case 3:
		                   if(3 <= d[9])
		                    return caml_exact_trampoline_cps_call$0
		                            (r_utf_8,
		                             d[8],
		                             0,
		                             3,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$2
		                                      (ret, decode_utf_8, a, 3, d, cont);
		                             });
		                   var a = d[9];
		                   return caml_exact_trampoline_cps_call$0
		                           (malformed,
		                            d[8],
		                            0,
		                            d[9],
		                            function(b){
		                             return caml_exact_trampoline_cps_call$2
		                                     (ret, decode_utf_8, b, a, d, cont);
		                            });
		                  default:
		                   if(3 <= d[9]){
		                    d[10] = 4;
		                    return caml_exact_trampoline_cps_call$1
		                            (t_fill, t_decode_utf_8, d, cont);
		                   }
		                   var b = d[9];
		                   return caml_exact_trampoline_cps_call$0
		                           (malformed,
		                            d[8],
		                            0,
		                            d[9],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$2
		                                     (ret, decode_utf_8, a, b, d, cont);
		                            });
		                }
		               }
		               var u_bom = 65279;
		               function guessed_utf_16(d, be, v, cont){
		                if(be)
		                 var
		                  j1 = 1,
		                  j0 = 0,
		                  t_decode_utf_16_lo = t_decode_utf_16be_lo,
		                  t_decode_utf_16 = t_decode_utf_16be,
		                  decode_utf_16 = decode_utf_16be;
		                else {
		                 j1 = 0;
		                 j0 = 1;
		                 t_decode_utf_16_lo = t_decode_utf_16le_lo;
		                 t_decode_utf_16 = t_decode_utf_16le;
		                 decode_utf_16 = decode_utf_16le;
		                }
		                function b3(k, d, cont){
		                 if(3 > d[9])
		                  return caml_exact_trampoline_cps_call
		                          (decode_utf_16, d, cont);
		                 d[10] = 2;
		                 d[9] = 1;
		                 var s = d[8];
		                 unsafe_set_byte(d[8], 0, caml_bytes_unsafe_get(s, 2));
		                 return caml_exact_trampoline_cps_call$1(t_fill, k, d, cont);
		                }
		                if(typeof v === "number")
		                 return 427938126 <= v
		                         ? caml_exact_trampoline_cps_call$0
		                           (r_utf_16,
		                            d[8],
		                            j0,
		                            j1,
		                            function(v){
		                             var variant = v[1];
		                             if(659980059 <= variant)
		                              return caml_exact_trampoline_cps_call$2
		                                      (ret,
		                                       function(a, cont){
		return caml_exact_trampoline_cps_call$1
		        (b3, t_decode_utf_16, a, cont);
		                                       },
		                                       v,
		                                       2,
		                                       d,
		                                       cont);
		                             var hi = v[2];
		                             if(3 <= d[9])
		                              return caml_exact_trampoline_cps_call$1
		                                      (b3,
		                                       function(a, cont){
		return caml_exact_trampoline_cps_call$1
		        (t_decode_utf_16_lo, hi, a, cont);
		                                       },
		                                       d,
		                                       cont);
		                             var a = d[9];
		                             return caml_exact_trampoline_cps_call$3
		                                     (malformed_pair,
		                                      be,
		                                      hi,
		                                      empty_return,
		                                      0,
		                                      0,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$2
		       (ret, decode_utf_16, b, a, d, cont);
		                                      });
		                            })
		                         : caml_exact_trampoline_cps_call$2
		                           (ret,
		                            function(a, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (b3, t_decode_utf_16, a, cont);
		                            },
		                            [0, 852405675, u_bom],
		                            2,
		                            d,
		                            cont);
		                var u = v[2];
		                return caml_exact_trampoline_cps_call$2
		                        (ret,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (b3, t_decode_utf_16, a, cont);
		                         },
		                         [0, 852405675, u],
		                         2,
		                         d,
		                         cont);
		               }
		               function guess_encoding(d, cont){
		                function setup(d, cont){
		                 var match = r_encoding(d[8], 0, d[9]), variant = match[1];
		                 if(-211555818 === variant){
		                  var r = match[2];
		                  d[2] = -211555818;
		                  d[18] = decode_utf_16le;
		                  return caml_exact_trampoline_cps_call$0
		                          (guessed_utf_16, d, 0, r, cont);
		                 }
		                 if(684370880 <= variant){
		                  var r$0 = match[2];
		                  d[2] = 684370880;
		                  d[18] = decode_utf_8;
		                  return 3455931 === r$0
		                          ? cont(3455931)
		                          : 427938126
		                            <= r$0
		                            ? caml_exact_trampoline_cps_call(guessed_utf_8, d, cont)
		                            : caml_exact_trampoline_cps_call$2
		                              (ret, decode_utf_8, [0, 852405675, u_bom], 3, d, cont);
		                 }
		                 var r$1 = match[2];
		                 d[2] = -211558048;
		                 d[18] = decode_utf_16be;
		                 return caml_exact_trampoline_cps_call$0
		                         (guessed_utf_16, d, 1, r$1, cont);
		                }
		                t_need(d, 3);
		                return caml_exact_trampoline_cps_call$1
		                        (t_fill, setup, d, cont);
		               }
		               function nline(d){d[14] = 0; d[13] = d[13] + 1 | 0;}
		               function ncol(d){d[14] = d[14] + 1 | 0;}
		               function ncount(d){d[16] = d[16] + 1 | 0;}
		               function cr(d, b){d[12] = b;}
		               function pp_nln_none(d, v, cont){
		                var variant = v[1];
		                if(852405675 > variant){
		                 cr(d, 0);
		                 ncount(d);
		                 ncol(d);
		                 return cont(v);
		                }
		                var u = v[2], a = u - 133 | 0;
		                a:
		                {
		                 if(8100 < a >>> 0){
		                  a = a + 123 | 0;
		                  if(3 < a >>> 0) break a;
		                  switch(a){
		                    case 0:
		                     var last_cr = d[12];
		                     cr(d, 0);
		                     ncount(d);
		                     return last_cr ? cont(v) : (nline(d), cont(v));
		                    case 3:
		                     cr(d, 1); ncount(d); nline(d); return cont(v);
		                    case 1:
		                     break a;
		                  }
		                 }
		                 else if(8097 >= a - 1 >>> 0) break a;
		                 cr(d, 0);
		                 ncount(d);
		                 nline(d);
		                 return cont(v);
		                }
		                cr(d, 0);
		                ncount(d);
		                ncol(d);
		                return cont(v);
		               }
		               function decoder(nln, encoding, src){
		                var nl$0, pp; {nl$0 = 10; pp = pp_nln_none;}
		                if(encoding){
		                 var e = encoding[1];
		                 if(143365725 <= e)
		                  if(423112016 <= e)
		                   if(684370880 <= e)
		                    var k = decode_utf_8, encoding$0 = e;
		                   else {k = decode_us_ascii; encoding$0 = e;}
		                  else if(338302576 <= e){
		                   k = decode_iso_8859_1;
		                   encoding$0 = e;
		                  }
		                  else {k = decode_utf_16be; encoding$0 = e;}
		                 else if(-211555818 <= e){
		                  k = decode_utf_16le;
		                  encoding$0 = e;
		                 }
		                 else {k = decode_utf_16be; encoding$0 = e;}
		                }
		                else {k = guess_encoding; encoding$0 = 684370880;}
		                var i_max, i_pos, i$0; var i_max = 0, i_pos = 1, i$0 = empty_return;
		                var utf16 = 143365725 === encoding$0;
		                return [0,
		                        src,
		                        encoding$0,
		                        nln,
		                        nl$0,
		                        i$0,
		                        i_pos,
		                        i_max,
		                        caml_create_bytes(4),
		                        0,
		                        0,
		                        0,
		                        0,
		                        1,
		                        0,
		                        0,
		                        0,
		                        function(d, v, cont){
		                         var variant = v[1];
		                         if(852405675 > variant){
		                          d[11] = 0;
		                          d[17] = pp;
		                          return caml_trampoline_cps_call3(d[17], d, v, cont);
		                         }
		                         var u = v[2];
		                         if(65279 === u){
		                          if(utf16){d[2] = -211558048; d[18] = decode_utf_16be;}
		                          d[11] = 1;
		                          d[17] = pp;
		                          return caml_trampoline_cps_call2(d[18], d, cont);
		                         }
		                         if(65534 === u && utf16){
		                          d[2] = -211555818;
		                          d[18] = decode_utf_16le;
		                          d[11] = 1;
		                          d[17] = pp;
		                          return caml_trampoline_cps_call2(d[18], d, cont);
		                         }
		                         d[11] = 0;
		                         d[17] = pp;
		                         return caml_trampoline_cps_call3(d[17], d, v, cont);
		                        },
		                        k];
		               }
		               function unsafe_blit$3(s, soff, d, doff){
		                var a = caml_bytes_of_string(s);
		                return function(b){caml_blit_bytes(a, soff, d, doff, b);};
		               }
		               function unsafe_set_byte$0(s, j, byte){caml_bytes_unsafe_set(s, j, byte);
		               }
		               function pp_lexeme(ppf, param, cont){
		                if(typeof param === "number")
		                 return 14610 === param
		                         ? caml_exact_trampoline_cps_call(fprintf$0(ppf), hS, cont)
		                         : 17732
		                           <= param
		                           ? 870828711
		                             <= param
		                             ? caml_exact_trampoline_cps_call(fprintf$0(ppf), hT, cont)
		                             : caml_exact_trampoline_cps_call(fprintf$0(ppf), hU, cont)
		                           : 17718
		                             <= param
		                             ? caml_exact_trampoline_cps_call(fprintf$0(ppf), hV, cont)
		                             : caml_exact_trampoline_cps_call(fprintf$0(ppf), hW, cont);
		                var variant = param[1];
		                if(737456202 <= variant){
		                 if(869834347 <= variant){
		                  var s = param[2];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           hX,
		                           function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                 }
		                 var b = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          hY,
		                          function(a){return caml_trampoline_cps_call2(a, b, cont);});
		                }
		                if(365180284 <= variant){
		                 var f = param[2], a = string_of_float(f);
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          hZ,
		                          function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                }
		                var s$0 = param[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         h0,
		                         function(a){return caml_trampoline_cps_call2(a, s$0, cont);});
		               }
		               function pp_cp(ppf, u, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         h1,
		                         function(a){return caml_trampoline_cps_call2(a, u, cont);});
		               }
		               function pp_uchar(ppf, u, cont){
		                if(31 >= u)
		                 return caml_exact_trampoline_cps_call$1(pp_cp, ppf, u, cont);
		                var b = create$1(4);
		                return caml_exact_trampoline_cps_call$1
		                        (add_utf_8_uchar,
		                         b,
		                         u,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (contents,
		                                   b,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(ppf),
		     h2,
		     function(b){
		      return caml_trampoline_cps_call4(b, a, pp_cp, u, cont);
		     });
		                                   });
		                         });
		               }
		               function pp_error(ppf, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf), h3, cont);
		                var variant = param[1];
		                if(30214610 > variant){
		                 if(-364210971 === variant){
		                  var r$1 = param[2];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           ir,
		                           function(a){
		                            return 14610 <= r$1
		                                    ? 17732
		                                      <= r$1
		                                      ? caml_exact_trampoline_cps_call(fprintf$0(ppf), is, cont)
		                                      : caml_exact_trampoline_cps_call(fprintf$0(ppf), it, cont)
		                                    : -826170817
		                                      <= r$1
		                                      ? caml_exact_trampoline_cps_call(fprintf$0(ppf), iu, cont)
		                                      : caml_exact_trampoline_cps_call(fprintf$0(ppf), iv, cont);
		                           });
		                 }
		                 if(-67383738 <= variant){
		                  var l$0 = param[2];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           iw,
		                           function(a){return caml_trampoline_cps_call2(a, l$0, cont);});
		                 }
		                 var u = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          ix,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, pp_uchar, u, cont);
		                          });
		                }
		                if(732461442 <= variant){
		                 if(992790154 <= variant){
		                  var r = param[2];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           h4,
		                           function(a){
		                            var variant = r[1];
		                            if(153884648 === variant){
		                             var p = r[2];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(ppf),
		                                      h5,
		                                      function(a){
		                                       return caml_trampoline_cps_call3(a, pp_cp, p, cont);
		                                      });
		                            }
		                            if(429931233 <= variant){
		                             if(508493173 <= variant){
		                              var u = r[2];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(ppf),
		                                       h6,
		                                       function(a){
		return caml_trampoline_cps_call3(a, pp_uchar, u, cont);
		                                       });
		                             }
		                             var p$0 = r[2];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(ppf),
		                                      h7,
		                                      function(a){
		                                       return caml_trampoline_cps_call3(a, pp_cp, p$0, cont);
		                                      });
		                            }
		                            if(225181919 <= variant){
		                             var p$1 = r[2];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(ppf),
		                                      h8,
		                                      function(a){
		                                       return caml_trampoline_cps_call3(a, pp_cp, p$1, cont);
		                                      });
		                            }
		                            var u$0 = r[2];
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(ppf),
		                                     h9,
		                                     function(a){
		                                      return caml_trampoline_cps_call3(a, pp_uchar, u$0, cont);
		                                     });
		                           });
		                 }
		                 var bs = param[2], l = caml_ml_string_length(bs);
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          h_,
		                          function(c){
		                           function a(d){
		                            var a = l - 1 | 0;
		                            function c(){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(ppf), ia, cont);
		                            }
		                            function b(i){
		                             var d = caml_string_get(bs, i);
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(ppf),
		                                      ib,
		                                      function(e){
		                                       return caml_trampoline_cps_call2
		       (e,
		        d,
		        function(d){
		         d = i + 1 | 0;
		         return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		        });
		                                      });
		                            }
		                            return a < 1 ? c() : b(1);
		                           }
		                           if(0 >= l) return a();
		                           var b = caml_string_get(bs, 0);
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(ppf),
		                                    h$,
		                                    function(c){return caml_trampoline_cps_call2(c, b, a);});
		                          });
		                }
		                if(434236056 <= variant){
		                 var r$0 = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          ic,
		                          function(a){
		                           if(typeof r$0 === "number")
		                            return 3456159 <= r$0
		                                    ? 826371656
		                                      <= r$0
		                                      ? 869834347
		<= r$0
		? caml_exact_trampoline_cps_call(fprintf$0(ppf), ie, cont)
		: caml_exact_trampoline_cps_call(fprintf$0(ppf), ig, cont)
		                                      : 713199754
		<= r$0
		? caml_exact_trampoline_cps_call(fprintf$0(ppf), ih, cont)
		: caml_exact_trampoline_cps_call(fprintf$0(ppf), ii, cont)
		                                    : -826170817
		                                      <= r$0
		                                      ? caml_exact_trampoline_cps_call(fprintf$0(ppf), ij, cont)
		                                      : caml_exact_trampoline_cps_call(fprintf$0(ppf), ik, cont);
		                           var variant = r$0[1];
		                           return 881518886 <= variant
		                                   ? r$0
		                                      [2]
		                                     ? caml_exact_trampoline_cps_call(fprintf$0(ppf), il, cont)
		                                     : caml_exact_trampoline_cps_call(fprintf$0(ppf), im, cont)
		                                   : r$0
		                                      [2]
		                                     ? caml_exact_trampoline_cps_call(fprintf$0(ppf), io, cont)
		                                     : caml_exact_trampoline_cps_call(fprintf$0(ppf), ip, cont);
		                          });
		                }
		                var n = param[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         iq,
		                         function(a){return caml_trampoline_cps_call2(a, n, cont);});
		               }
		               function pp_decode(ppf, a, cont){
		                if(typeof a === "number")
		                 return 1006505782 <= a
		                         ? caml_exact_trampoline_cps_call(fprintf$0(ppf), iy, cont)
		                         : caml_exact_trampoline_cps_call(fprintf$0(ppf), iz, cont);
		                var variant = a[1];
		                if(-588596599 <= variant){
		                 if(106380200 <= variant){
		                  var e = a[2];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(ppf),
		                           iA,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, pp_error, e, cont);
		                           });
		                 }
		                 var s = a[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          iB,
		                          function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                }
		                if(-633954146 <= variant){
		                 var l = a[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(ppf),
		                          iC,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, pp_lexeme, l, cont);
		                          });
		                }
		                a = a[2];
		                var s$0 = a[2], style = a[1];
		                function pr_style(ppf, param, cont){
		                 return 83 <= param
		                         ? caml_exact_trampoline_cps_call(fprintf$0(ppf), iD, cont)
		                         : caml_exact_trampoline_cps_call(fprintf$0(ppf), iE, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         iF,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (a, pr_style, style, s$0, cont);
		                         });
		               }
		               function expect(e, v, cont){
		                var b = create$1(20), ppf = formatter_of_buffer(b);
		                function k(ppf, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_flush,
		                          ppf,
		                          dummy,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (contents,
		                                    b,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(invalid_arg, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (kfprintf,
		                         k,
		                         ppf,
		                         fmt$3,
		                         function(a){
		                          return caml_trampoline_cps_call4(a, pp_decode, v, e, cont);
		                         });
		               }
		               function o_rem(e){return (e[5] - e[4] | 0) + 1 | 0;}
		               function flush(k, e, cont){
		                var match = e[1];
		                if(typeof match === "number"){
		                 e[11] =
		                  function(e, v, cont){
		                   if(typeof v === "number" && 1006505782 === v)
		                    return caml_exact_trampoline_cps_call(k, e, cont);
		                   return caml_exact_trampoline_cps_call$1
		                           (expect, cst_Await, v, cont);
		                  };
		                 return cont(939392865);
		                }
		                var variant = match[1];
		                if(438511779 <= variant){
		                 var oc = match[2];
		                 return caml_exact_trampoline_cps_call$2
		                         (output,
		                          oc,
		                          e[3],
		                          0,
		                          e[4],
		                          function(a){
		                           e[4] = 0;
		                           return caml_exact_trampoline_cps_call(k, e, cont);
		                          });
		                }
		                var b = match[2], o = caml_string_of_bytes(e[3]);
		                return caml_exact_trampoline_cps_call$2
		                        (add_substring,
		                         b,
		                         o,
		                         0,
		                         e[4],
		                         function(a){
		                          e[4] = 0;
		                          return caml_exact_trampoline_cps_call(k, e, cont);
		                         });
		               }
		               function writeb(b, k, e, cont){
		                return e[5] < e[4]
		                        ? caml_exact_trampoline_cps_call$1
		                          (flush,
		                           function(a, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (writeb, b, k, a, cont);
		                           },
		                           e,
		                           cont)
		                        : (unsafe_set_byte$0
		                           (e[3], e[4], b),
		                          e[4] = e[4] + 1 | 0,
		                          caml_exact_trampoline_cps_call(k, e, cont));
		               }
		               function writes(s, j, l, k, e, cont){
		                var rem = o_rem(e);
		                if(l <= rem){
		                 unsafe_blit$3(s, j, e[3], e[4])(l);
		                 e[4] = e[4] + l | 0;
		                 return caml_exact_trampoline_cps_call(k, e, cont);
		                }
		                unsafe_blit$3(s, j, e[3], e[4])(rem);
		                e[4] = e[4] + rem | 0;
		                var a = l - rem | 0, b = j + rem | 0;
		                return caml_exact_trampoline_cps_call$1
		                        (flush,
		                         function(c, cont){
		                          return caml_exact_trampoline_cps_call$3
		                                  (writes, s, b, a, k, c, cont);
		                         },
		                         e,
		                         cont);
		               }
		               function writebuf(j, l, k, e, cont){
		                var rem = o_rem(e);
		                return l <= rem
		                        ? caml_exact_trampoline_cps_call$3
		                          (caml_buffer_blit,
		                           e[6],
		                           j,
		                           e[3],
		                           e[4],
		                           l,
		                           function(a){
		                            e[4] = e[4] + l | 0;
		                            return caml_exact_trampoline_cps_call(k, e, cont);
		                           })
		                        : caml_exact_trampoline_cps_call$3
		                          (caml_buffer_blit,
		                           e[6],
		                           j,
		                           e[3],
		                           e[4],
		                           rem,
		                           function(c){
		                            e[4] = e[4] + rem | 0;
		                            var a = l - rem | 0, b = j + rem | 0;
		                            return caml_exact_trampoline_cps_call$1
		                                    (flush,
		                                     function(c, cont){
		                                      return caml_exact_trampoline_cps_call$2
		      (writebuf, b, a, k, c, cont);
		                                     },
		                                     e,
		                                     cont);
		                           });
		               }
		               var u_sp = 32;
		               function w_indent(k, e, cont){
		                function loop(indent, k, e, cont){
		                 function spaces(e, indent){
		                  var max = (e[4] + indent | 0) - 1 | 0, a = e[4];
		                  if(max >= a){
		                   var j = a;
		                   for(;;){
		                    unsafe_set_byte$0(e[3], j, u_sp);
		                    a = j + 1 | 0;
		                    if(max === j) break;
		                    j = a;
		                   }
		                  }
		                  e[4] = max + 1 | 0;
		                 }
		                 var rem = o_rem(e);
		                 if(rem < indent){
		                  spaces(e, rem);
		                  var a = indent - rem | 0;
		                  return caml_exact_trampoline_cps_call$1
		                          (flush,
		                           function(b, cont){
		                            return caml_exact_trampoline_cps_call$0(loop, a, k, b, cont);
		                           },
		                           e,
		                           cont);
		                 }
		                 spaces(e, indent);
		                 return caml_exact_trampoline_cps_call(k, e, cont);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (loop, e[8] * 2 | 0, k, e, cont);
		               }
		               var cst$3 = '\\"';
		               function w_json_string(s, k, e, cont){
		                function loop(s, j, pos$0, max, k, e, cont){
		                 var pos = pos$0;
		                 for(;;){
		                  if(max < pos)
		                   return max < j
		                           ? caml_exact_trampoline_cps_call(k, e, cont)
		                           : caml_exact_trampoline_cps_call$3
		                             (writes, s, j, pos - j | 0, k, e, cont);
		                  var next = pos + 1 | 0;
		                  let pos$0 = pos, next$0 = next;
		                  var
		                   escape =
		                     function(esc, cont){
		                      function a(a, cont){
		                       return caml_exact_trampoline_cps_call$7
		                               (loop, s, next$0, next$0, max, k, a, cont);
		                      }
		                      return caml_exact_trampoline_cps_call$3
		                              (writes,
		                               s,
		                               j,
		                               pos$0 - j | 0,
		                               function(b, cont){
		                                return caml_exact_trampoline_cps_call$3
		(writes, esc, 0, 2, a, b, cont);
		                               },
		                               e,
		                               cont);
		                     },
		                   c = caml_string_unsafe_get(s, pos);
		                  if(10 === c)
		                   return caml_exact_trampoline_cps_call(escape, cst_n, cont);
		                  if(34 === c)
		                   return caml_exact_trampoline_cps_call(escape, cst$3, cont);
		                  if(92 === c)
		                   return caml_exact_trampoline_cps_call(escape, cst, cont);
		                  if(31 >= c) break;
		                  pos = next;
		                 }
		                 function hex(d){
		                  return 10 <= d ? 65 + (d - 10 | 0) | 0 : 48 + d | 0;
		                 }
		                 function a(a, cont){
		                  return caml_exact_trampoline_cps_call$7
		                          (loop, s, next, next, max, k, a, cont);
		                 }
		                 var b = hex(c & 15);
		                 function d(c, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (writeb, b, a, c, cont);
		                 }
		                 var f = hex(c >>> 4 | 0);
		                 function g(a, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (writeb, f, d, a, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$3
		                         (writes,
		                          s,
		                          j,
		                          pos - j | 0,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$3
		                                   (writes, "\\u00", 0, 4, g, a, cont);
		                          },
		                          e,
		                          cont);
		                }
		                var u_quot = 34;
		                function a(a, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (writeb, u_quot, k, a, cont);
		                }
		                var b = caml_ml_string_length(s) - 1 | 0;
		                return caml_exact_trampoline_cps_call$0
		                        (writeb,
		                         u_quot,
		                         function(c, cont){
		                          return caml_exact_trampoline_cps_call$7
		                                  (loop, s, 0, 0, b, a, c, cont);
		                         },
		                         e,
		                         cont);
		               }
		               function w_name(n, k, e, cont){
		                e[10] = 0;
		                e[9] = 0;
		                return caml_exact_trampoline_cps_call$0
		                        (w_json_string,
		                         n,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (writeb, 58, k, a, cont);
		                         },
		                         e,
		                         cont);
		               }
		               function w_value(in_obj, l, k, e, cont){
		                if(typeof l === "number"){
		                 if(17732 <= l)
		                  return 870828711 <= l
		                          ? (e
		                             [10]
		                            = 0,
		                            e[9] = in_obj,
		                            caml_exact_trampoline_cps_call$3
		                             (writes, cst_null, 0, 4, k, e, cont))
		                          : (e
		                             [10]
		                            = 1,
		                            e[9] = 1,
		                            e[8] = e[8] + 1 | 0,
		                            e[7] = [0, 17732, e[7]],
		                            caml_exact_trampoline_cps_call$0(writeb, 123, k, e, cont));
		                 if(14610 === l){
		                  e[10] = 1;
		                  e[9] = 0;
		                  e[8] = e[8] + 1 | 0;
		                  e[7] = [0, 14610, e[7]];
		                  return caml_exact_trampoline_cps_call$0
		                          (writeb, 91, k, e, cont);
		                 }
		                }
		                else {
		                 var variant = l[1];
		                 if(737456202 > variant){
		                  if(365180284 <= variant){
		                   var f = l[2];
		                   e[10] = 0;
		                   e[9] = in_obj;
		                   clear$1(e[6]);
		                   return caml_exact_trampoline_cps_call$1
		                           (bprintf,
		                            e[6],
		                            iG,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a,
		                                      f,
		                                      function(a){
		                                       var b = e[6];
		                                       return caml_exact_trampoline_cps_call$2
		       (writebuf, 0, b[2], k, e, cont);
		                                      });
		                            });
		                  }
		                  var s = l[2];
		                  e[10] = 0;
		                  e[9] = in_obj;
		                  return caml_exact_trampoline_cps_call$0
		                          (w_json_string, s, k, e, cont);
		                 }
		                 if(869834347 > variant){
		                  var b = l[2];
		                  e[10] = 0;
		                  e[9] = in_obj;
		                  return b
		                          ? caml_exact_trampoline_cps_call$3
		                            (writes, cst_true, 0, 4, k, e, cont)
		                          : caml_exact_trampoline_cps_call$3
		                            (writes, cst_false, 0, 5, k, e, cont);
		                 }
		                }
		                return in_obj
		                        ? caml_exact_trampoline_cps_call$1
		                          (expect,
		                           "any `Lexeme but `Name, `Oe or `Ae",
		                           [0, -633954146, l],
		                           cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (expect,
		                           "any `Lexeme but `Name or `Oe",
		                           [0, -633954146, l],
		                           cont);
		               }
		               var cst$4 = "//";
		               function encode$1(k, e, v, cont){
		                if(typeof v === "number")
		                 return 1006505782 <= v
		                         ? cont(17724)
		                         : 0
		                           === e[7]
		                           ? caml_exact_trampoline_cps_call$1(flush, k, e, cont)
		                           : caml_exact_trampoline_cps_call
		                             (hd_exn,
		                              e[7],
		                              function(lstart){
		                               var a = 14610 === lstart ? "`Lexeme `Ae" : "`Lexeme `Oe";
		                               return caml_exact_trampoline_cps_call$1(expect, a, v, cont);
		                              });
		                var variant = v[1], u_nl = 10;
		                if(-633954146 === variant){
		                 var l = v[2];
		                 if(0 === e[7])
		                  return caml_exact_trampoline_cps_call$1
		                          (expect, cst_End, [0, -633954146, l], cont);
		                 var
		                  epop =
		                    function(e, cont){
		                     e[10] = 0;
		                     e[8] = e[8] - 1 | 0;
		                     return caml_exact_trampoline_cps_call
		                             (tl_exn,
		                              e[7],
		                              function(a){
		                               e[7] = a;
		                               a = e[7];
		                               if(a){
		                                a = a[1];
		                                if(typeof a === "number" && 17732 === a){e[9] = 1; return cont();}
		                               }
		                               e[9] = 0;
		                               return cont();
		                              });
		                    };
		                 return caml_exact_trampoline_cps_call
		                         (hd_exn,
		                          e[7],
		                          function(match){
		                           var u_comma = 44;
		                           if(17732 > match){
		                            if(typeof l === "number" && 14596 === l){
		                             var u_rbrack = 93;
		                             if(! e[2] && ! e[10])
		                              return caml_exact_trampoline_cps_call
		                                      (epop,
		                                       e,
		                                       function(b){
		function a(a, cont){
		 return caml_exact_trampoline_cps_call$0
		         (writeb, u_rbrack, k, a, cont);
		}
		return caml_exact_trampoline_cps_call$0
		        (writeb,
		         u_nl,
		         function(b, cont){
		          return caml_exact_trampoline_cps_call$1
		                  (w_indent, a, b, cont);
		         },
		         e,
		         cont);
		                                       });
		                             return caml_exact_trampoline_cps_call
		                                     (epop,
		                                      e,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (writeb, u_rbrack, k, e, cont);
		                                      });
		                            }
		                            var
		                             value =
		                               function(l, k, e, cont){
		                                if(e[2])
		                                 return caml_exact_trampoline_cps_call$2
		 (w_value, 0, l, k, e, cont);
		                                function a(a, cont){
		                                 return caml_exact_trampoline_cps_call$2
		 (w_value, 0, l, k, a, cont);
		                                }
		                                return caml_exact_trampoline_cps_call$0
		(writeb,
		 u_nl,
		 function(b, cont){
		  return caml_exact_trampoline_cps_call$1
		          (w_indent, a, b, cont);
		 },
		 e,
		 cont);
		                               };
		                            return e[10]
		                                    ? caml_exact_trampoline_cps_call$0(value, l, k, e, cont)
		                                    : caml_exact_trampoline_cps_call$0
		                                      (writeb,
		                                       u_comma,
		                                       function(a, cont){
		return caml_exact_trampoline_cps_call$0
		        (value, l, k, a, cont);
		                                       },
		                                       e,
		                                       cont);
		                           }
		                           if(! e[9])
		                            return caml_exact_trampoline_cps_call$2
		                                    (w_value, 1, l, k, e, cont);
		                           if(typeof l === "number"){
		                            if(17718 === l){
		                             var u_rbrace = 125;
		                             if(! e[2] && ! e[10])
		                              return caml_exact_trampoline_cps_call
		                                      (epop,
		                                       e,
		                                       function(b){
		function a(a, cont){
		 return caml_exact_trampoline_cps_call$0
		         (writeb, u_rbrace, k, a, cont);
		}
		return caml_exact_trampoline_cps_call$0
		        (writeb,
		         u_nl,
		         function(b, cont){
		          return caml_exact_trampoline_cps_call$1
		                  (w_indent, a, b, cont);
		         },
		         e,
		         cont);
		                                       });
		                             return caml_exact_trampoline_cps_call
		                                     (epop,
		                                      e,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (writeb, u_rbrace, k, e, cont);
		                                      });
		                            }
		                           }
		                           else {
		                            var variant = l[1];
		                            if(869834347 === variant){
		                             var
		                              n = l[2],
		                              name =
		                                function(n, k, e, cont){
		                                 if(e[2])
		                                  return caml_exact_trampoline_cps_call$0
		  (w_name, n, k, e, cont);
		                                 function a(a, cont){
		                                  return caml_exact_trampoline_cps_call$0
		  (writeb, u_sp, k, a, cont);
		                                 }
		                                 function b(b, cont){
		                                  return caml_exact_trampoline_cps_call$0
		  (w_name, n, a, b, cont);
		                                 }
		                                 return caml_exact_trampoline_cps_call$0
		 (writeb,
		  u_nl,
		  function(a, cont){
		   return caml_exact_trampoline_cps_call$1
		           (w_indent, b, a, cont);
		  },
		  e,
		  cont);
		                                };
		                             return e[10]
		                                     ? caml_exact_trampoline_cps_call$0(name, n, k, e, cont)
		                                     : caml_exact_trampoline_cps_call$0
		                                       (writeb,
		u_comma,
		function(a, cont){
		 return caml_exact_trampoline_cps_call$0(name, n, k, a, cont);
		},
		e,
		cont);
		                            }
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (expect,
		                                    "`Lexeme (`Name _ | `Oe)",
		                                    [0, -633954146, l],
		                                    cont);
		                          });
		                }
		                if(-588596599 <= variant){
		                 var w = v[2];
		                 return caml_exact_trampoline_cps_call$3
		                         (writes, w, 0, caml_ml_string_length(w), k, e, cont);
		                }
		                var a = v[2];
		                if(83 <= a[1]){
		                 var
		                  c = a[2],
		                  b =
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$0
		                             (writeb, u_nl, k, a, cont);
		                    },
		                  d = caml_ml_string_length(c);
		                 return caml_exact_trampoline_cps_call$3
		                         (writes,
		                          cst$4,
		                          0,
		                          2,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$3
		                                   (writes, c, 0, d, b, a, cont);
		                          },
		                          e,
		                          cont);
		                }
		                var c$0 = a[2];
		                function f(a, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (writes, "*/", 0, 2, k, a, cont);
		                }
		                var g = caml_ml_string_length(c$0);
		                return caml_exact_trampoline_cps_call$3
		                        (writes,
		                         "/*",
		                         0,
		                         2,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$3
		                                  (writes, c$0, 0, g, f, a, cont);
		                         },
		                         e,
		                         cont);
		               }
		               function encode_loop(e, cont){
		                e[11] =
		                 function(a, b, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (encode$1, encode_loop, a, b, cont);
		                 };
		                return cont(17724);
		               }
		               function encode_json(e, v, cont){
		                a:
		                {
		                 if(typeof v !== "number"){
		                  var variant = v[1];
		                  if(-633954146 !== variant)
		                   return caml_exact_trampoline_cps_call$0
		                           (encode$1,
		                            function(e, cont){e[11] = encode_json; return cont(17724);},
		                            e,
		                            v,
		                            cont);
		                  var l = v[2];
		                  if(typeof l === "number"){
		                   if(14610 !== l && 17732 !== l && 870828711 !== l) break a;
		                  }
		                  else {
		                   var a = l[1];
		                   if(-976970511 !== a && 365180284 !== a && 737456202 !== a)
		                    break a;
		                  }
		                  return caml_exact_trampoline_cps_call$2
		                          (w_value, 0, l, encode_loop, e, cont);
		                 }
		                 if(1006505782 <= v) return cont(17724);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (expect,
		                         "`Lexeme (`Null | `Bool _ | `Float _ | `String _ | `As | `Os)",
		                         v,
		                         cont);
		               }
		               function encode$2(e, v, cont){
		                return caml_trampoline_cps_call3(e[11], e, v, cont);
		               }
		               var char = 12, c_layout = 0;
		               function create_unsafe(len){
		                var buffer = create$2(char, c_layout, len);
		                return [0, buffer, 0, len];
		               }
		               create_unsafe(0);
		               function hexdump_pp(state, t, cont){
		                function before(fmt, param, cont){
		                 return 0 === param
		                         ? cont(0)
		                         : 8
		                           === param
		                           ? caml_exact_trampoline_cps_call(fprintf$0(fmt), iK, cont)
		                           : caml_exact_trampoline_cps_call(fprintf$0(fmt), iL, cont);
		                }
		                function after(fmt, param, cont){
		                 return 15 === param
		                         ? caml_exact_trampoline_cps_call(fprintf$0(fmt), iM, cont)
		                         : cont(0);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (pp_open_box_gen,
		                         state,
		                         0,
		                         1,
		                         function(d){
		                          var len = t[3], a = len - 1 | 0;
		                          function c(){return cont(pp_close_box(state));}
		                          function b(i){
		                           var
		                            column = i % 16 | 0,
		                            c$0 = caml_ba_get_1(t[1], t[2] + i | 0);
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(state),
		                                    iN,
		                                    function(d){
		                                     return caml_trampoline_cps_call6
		     (d,
		      before,
		      column,
		      c$0,
		      after,
		      column,
		      function(d){
		       d = i + 1 | 0;
		       return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		      });
		                                    });
		                          }
		                          return a < 0 ? c() : b(0);
		                         });
		               }
		               var fmt = param$0[1];
		               caml_callback
		                (caml_callback
		                  (make_printf,
		                   [function(acc, cont){
		                     return caml_exact_trampoline_cps_call
		                             (get$0,
		                              std_formatter_key,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (output_acc$0, a, acc, cont);
		                              });
		                    },
		                    0,
		                    fmt]),
		                 [hexdump_pp]);
		               function invalid_arg$0(fmt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ksprintf,
		                         function(str, a){
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Invalid_argument, str], 1));
		                         },
		                         fmt,
		                         cont);
		               }
		               var buflen = 0, dst = create_unsafe(buflen);
		               caml_blit_string_to_bigstring(cst$1, 0, dst[1], dst[2] | 0, 0);
		               function value_to_dst(opt, dst, json, cont){
		                var minify = opt ? opt[1] : 1;
		                function enc(e, l, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (encode$2,
		                          e,
		                          [0, -633954146, l],
		                          function(a){return cont();});
		                }
		                function value(v, e, stack, cont){
		                 if(typeof v !== "number"){
		                  var variant$0 = v[1];
		                  if(65 <= variant$0 && 365180284 > variant$0){
		                   var variant = v[1];
		                   if(79 <= variant){
		                    var ms = v[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (enc,
		                             e,
		                             17732,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$0
		                                      (obj, ms, e, stack, cont);
		                             });
		                   }
		                   var vs = v[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (enc,
		                            e,
		                            14610,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (arr, vs, e, stack, cont);
		                            });
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (enc,
		                          e,
		                          v,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (continue$, e, stack, cont);
		                          });
		                }
		                function arr(vs, e, stack, cont){
		                 if(! vs)
		                  return caml_exact_trampoline_cps_call$1
		                          (enc,
		                           e,
		                           14596,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (continue$, e, stack, cont);
		                           });
		                 var vs$0 = vs[2], v = vs[1], stack$0 = [0, vs$0, stack];
		                 return caml_exact_trampoline_cps_call$0
		                         (value, v, e, stack$0, cont);
		                }
		                function obj(ms, e, stack, cont){
		                 if(! ms)
		                  return caml_exact_trampoline_cps_call$1
		                          (enc,
		                           e,
		                           17718,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (continue$, e, stack, cont);
		                           });
		                 var ms$0 = ms[2], match = ms[1], v = match[2], n = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (enc,
		                          e,
		                          [0, 869834347, n],
		                          function(a){
		                           var stack$0 = [1, ms$0, stack];
		                           return caml_exact_trampoline_cps_call$0
		                                   (value, v, e, stack$0, cont);
		                          });
		                }
		                function continue$(e, stack, cont){
		                 if(typeof stack === "number") return cont();
		                 if(0 === stack[0]){
		                  var stack$0 = stack[2], vs = stack[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (arr, vs, e, stack$0, cont);
		                 }
		                 var stack$1 = stack[2], ms = stack[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (obj, ms, e, stack$1, cont);
		                }
		                if(typeof dst === "number")
		                 var o_max = 0, o_pos = 1, o = empty_return;
		                else
		                 var
		                  o$0 = caml_create_bytes(65536),
		                  o_max = 65535,
		                  o_pos = 0,
		                  o = o$0;
		                var
		                 e =
		                   [0,
		                    dst,
		                    minify,
		                    o,
		                    o_pos,
		                    o_max,
		                    create$1(30),
		                    0,
		                    0,
		                    0,
		                    0,
		                    encode_json];
		                return caml_exact_trampoline_cps_call$0
		                        (value,
		                         json,
		                         e,
		                         0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (encode$2, e, 3455931, function(a){return cont();});
		                         });
		               }
		               function value_to_string(minify, json, cont){
		                var buf = create$1(1024);
		                return caml_exact_trampoline_cps_call$0
		                        (value_to_dst,
		                         minify,
		                         [0, 86585632, buf],
		                         json,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(contents, buf, cont);
		                         });
		               }
		               var
		                Parse_error =
		                  [248, "Ezjsonm.Parse_error", caml_fresh_oo_id()];
		               function parse_error(t, fmt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ksprintf,
		                         function(msg, a){
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Parse_error, t, msg], 1));
		                         },
		                         fmt,
		                         cont);
		               }
		               function sexp_of_t$21(json, cont){
		                function d(match){
		                 if(match){var s = match[1]; return cont([0, s]);}
		                 if(typeof json !== "number"){
		                  var variant = json[1];
		                  if(65 === variant){
		                   var
		                    l = json[2],
		                    a =
		                      function(accu, param){
		                       if(! param) return cont([1, rev(accu)]);
		                       var l = param[2], a$0 = param[1];
		                       return caml_exact_trampoline_cps_call
		                               (sexp_of_t$21,
		                                a$0,
		                                function(b){
		                                 var accu$0 = [0, b, accu];
		                                 return caml_exact_trampoline_call2(a, accu$0, l);
		                                });
		                      };
		                   return a(0, l);
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (parse_error, json, iR, cont);
		                }
		                if(typeof json !== "number"){
		                 var variant = json[1];
		                 if(-976970511 === variant){
		                  var str = json[2];
		                  return d([0, str]);
		                 }
		                 if(79 === variant){
		                  var b = json[2];
		                  if(b){
		                   var a = b[1];
		                   if(a[1] === cst_hex){
		                    a = a[2];
		                    if(typeof a !== "number"){
		                     var variant$0 = a[1];
		                     if(-976970511 === variant$0 && ! b[2]){
		                      var
		                       str$0 = a[2],
		                       c = function(a){return d([0, to_string(a)]);};
		                      if(str$0 === cst$1) return c(empty_return);
		                      var
		                       n = caml_ml_string_length(str$0),
		                       buf = caml_create_bytes(n / 2 | 0),
		                       e =
		                         function(i, j){
		                          if(n <= i) return c(buf);
		                          if(n <= j)
		                           return caml_exact_trampoline_cps_call
		                                   (invalid_arg$0, iP, function(a){return c(buf);});
		                          var
		                           y = caml_string_get(str$0, j),
		                           x = caml_string_get(str$0, i);
		                          function code(c, cont){
		                           if(65 <= c){
		                            if(97 <= c){
		                             if(103 > c) return cont(c - 87 | 0);
		                            }
		                            else if(71 > c) return cont(c - 55 | 0);
		                           }
		                           else if(9 >= c - 48 >>> 0) return cont(c - 48 | 0);
		                           return caml_exact_trampoline_cps_call
		                                   (invalid_arg$0,
		                                    iO,
		                                    function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (code,
		                                   y,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (code,
		     x,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (chr,
		               (b << 4) + a | 0,
		               function(a){
		                caml_bytes_set(buf, i / 2 | 0, a);
		                var j$0 = j + 2 | 0, i$0 = j + 1 | 0;
		                return caml_exact_trampoline_call2(e, i$0, j$0);
		               });
		     });
		                                   });
		                         };
		                      return e(0, 1);
		                     }
		                    }
		                   }
		                  }
		                 }
		                }
		                return d(0);
		               }
		               var buffer = create$2(char, c_layout, 0);
		               function substring(t, off, len, cont){
		                var buffer_len = caml_ba_dim_1(t), a = len < 0;
		                if(a) ; else {a = off < 0; a ||= (buffer_len - off | 0) < len;}
		                if(a)
		                 return caml_exact_trampoline_cps_call
		                         (sprintf,
		                          iS,
		                          function(a){
		                           return caml_trampoline_cps_call5
		                                   (a,
		                                    "substring",
		                                    buffer_len,
		                                    off,
		                                    len,
		                                    function(message){
		                                     var raise = caml_pop_trap();
		                                     return raise
		     (caml_maybe_attach_backtrace
		       ([0, Invalid_argument, message], 1));
		                                    });
		                          });
		                var b = caml_create_bytes(len);
		                bigstringaf_blit_to_bytes(t, off, b, 0, len);
		                return cont(caml_string_of_bytes(b));
		               }
		               function length$10(t){return t[2] + t[4] | 0;}
		               function bytes_for_client_to_commit(t){return t[1] - t[2] | 0;}
		               function offset_in_buffer(t, pos){
		                return (t[3] + pos | 0) - t[2] | 0;
		               }
		               function apply(t, pos, len, f, cont){
		                var off = offset_in_buffer(t, pos);
		                return caml_exact_trampoline_cps_call$0
		                        (f, t[5], off, len, cont);
		               }
		               function unsafe_get_char(t, pos){
		                var off = offset_in_buffer(t, pos);
		                return caml_ba_get_1(t[5], off);
		               }
		               function count_while(t, pos, f, cont){
		                var
		                 buffer = t[5],
		                 off = offset_in_buffer(t, pos),
		                 limit = t[3] + t[4] | 0;
		                function a(i){
		                 function b(){return cont(i - off | 0);}
		                 return i < limit
		                         ? caml_exact_trampoline_cps_call
		                           (f,
		                            caml_ba_get_1(buffer, i),
		                            function(c){
		                             if(! c) return b();
		                             var i$0 = i + 1 | 0;
		                             return caml_exact_trampoline_call1(a, i$0);
		                            })
		                         : b();
		                }
		                return a(off);
		               }
		               function fail_k(input, pos, param, marks, msg, cont){return cont([3, pos - input[2] | 0, marks, msg]);
		               }
		               function succeed_k(input, pos, param, v, cont){return cont([2, pos - input[2] | 0, v]);
		               }
		               function to_exported_state(param, cont){
		                function a(b){
		                 switch(b[0]){
		                   case 0:
		                    b = b[1];
		                    var continue$ = b[2], committed = b[1];
		                    return cont
		                            ([0,
		                              [0,
		                               committed,
		                               function(bs, off, len, more, cont){
		                                return caml_trampoline_cps_call5
		(continue$,
		 bs,
		 off,
		 len,
		 more,
		 function(a){
		  return caml_exact_trampoline_cps_call
		          (to_exported_state, a, cont);
		 });
		                               }]]);
		                   case 1:
		                    var x = b[1], b = caml_obj_tag(x);
		                    if(250 === b) return caml_exact_trampoline_call1(a, x[1]);
		                    if(246 !== b && 244 !== b)
		                     return caml_exact_trampoline_call1(a, x);
		                    return caml_exact_trampoline_cps_call
		                            (force_lazy_block, x, a);
		                   case 2:
		                    var x$0 = b[2], i = b[1]; return cont([1, i, x$0]);
		                   default:
		                    var s = b[3], sl = b[2], i$0 = b[1];
		                    return cont([2, i$0, sl, s]);
		                 }
		                }
		                return a(param);
		               }
		               function return$7(v, cont){
		                return cont
		                        ([0,
		                          function(input, pos, more, fail, succ, cont){
		                           return caml_trampoline_cps_call5
		                                   (succ, input, pos, more, v, cont);
		                          }]);
		               }
		               function fail$0(msg){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         return caml_trampoline_cps_call6
		                                 (fail, input, pos, more, 0, msg, cont);
		                        }];
		               }
		               function symbol_bind$3(p, f){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ$0(input, pos, more, v, cont){
		                          return cont
		                                  ([1,
		                                    [246,
		                                     function(param, cont){
		                                      return caml_trampoline_cps_call2
		      (f,
		       v,
		       function(a){
		        return caml_trampoline_cps_call6
		                (a[1], input, pos, more, fail, succ, cont);
		       });
		                                     }]]);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (p[1], input, pos, more, fail, succ$0, cont);
		                        }];
		               }
		               function symbol_map$3(p, f){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ$0(input, pos, more, v, cont){
		                          return cont
		                                  ([1,
		                                    [246,
		                                     function(param, cont){
		                                      return caml_trampoline_cps_call2
		      (f,
		       v,
		       function(a){
		        return caml_trampoline_cps_call5
		                (succ, input, pos, more, a, cont);
		       });
		                                     }]]);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (p[1], input, pos, more, fail, succ$0, cont);
		                        }];
		               }
		               function symbol$60(f, m){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ0(input0, pos0, more0, f, cont){
		                          function succ1(input1, pos1, more1, m, cont){
		                           return cont
		                                   ([1,
		                                     [246,
		                                      function(param, cont){
		                                       return caml_trampoline_cps_call2
		       (f,
		        m,
		        function(a){
		         return caml_trampoline_cps_call5
		                 (succ, input1, pos1, more1, a, cont);
		        });
		                                      }]]);
		                          }
		                          return caml_trampoline_cps_call6
		                                  (m[1], input0, pos0, more0, fail, succ1, cont);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (f[1], input, pos, more, fail, succ0, cont);
		                        }];
		               }
		               function lift2(f, m1, m2){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ1(input1, pos1, more1, m1, cont){
		                          function succ2(input2, pos2, more2, m2, cont){
		                           return cont
		                                   ([1,
		                                     [246,
		                                      function(param, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        m1,
		        m2,
		        function(a){
		         return caml_trampoline_cps_call5
		                 (succ, input2, pos2, more2, a, cont);
		        });
		                                      }]]);
		                          }
		                          return caml_trampoline_cps_call6
		                                  (m2[1], input1, pos1, more1, fail, succ2, cont);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (m1[1], input, pos, more, fail, succ1, cont);
		                        }];
		               }
		               function lift4(f, m1, m2, m3, m4){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ1(input1, pos1, more1, m1, cont){
		                          function succ2(input2, pos2, more2, m2, cont){
		                           function succ3(input3, pos3, more3, m3, cont){
		                            function succ4(input4, pos4, more4, m4, cont){
		                             return cont
		                                     ([1,
		                                       [246,
		function(param, cont){
		 return caml_trampoline_cps_call5
		         (f,
		          m1,
		          m2,
		          m3,
		          m4,
		          function(a){
		           return caml_exact_trampoline_cps_call$2
		                   (succ, input4, pos4, more4, a, cont);
		          });
		}]]);
		                            }
		                            return caml_trampoline_cps_call6
		                                    (m4[1], input3, pos3, more3, fail, succ4, cont);
		                           }
		                           return caml_trampoline_cps_call6
		                                   (m3[1], input2, pos2, more2, fail, succ3, cont);
		                          }
		                          return caml_trampoline_cps_call6
		                                  (m2[1], input1, pos1, more1, fail, succ2, cont);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (m1[1], input, pos, more, fail, succ1, cont);
		                        }];
		               }
		               function symbol$61(a, b){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ$0(input, pos, more, param, cont){
		                          return cont
		                                  ([1,
		                                    [246,
		                                     function(a, cont){
		                                      return caml_trampoline_cps_call6
		      (b[1], input, pos, more, fail, succ, cont);
		                                     }]]);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (a[1], input, pos, more, fail, succ$0, cont);
		                        }];
		               }
		               function symbol$62(a, b){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ0(input0, pos0, more0, x, cont){
		                          function succ1(input1, pos1, more1, param, cont){
		                           return cont
		                                   ([1,
		                                     [246,
		                                      function(a, cont){
		                                       return caml_trampoline_cps_call5
		       (succ, input1, pos1, more1, x, cont);
		                                      }]]);
		                          }
		                          return caml_trampoline_cps_call6
		                                  (b[1], input0, pos0, more0, fail, succ1, cont);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (a[1], input, pos, more, fail, succ0, cont);
		                        }];
		               }
		               function symbol$63(p, mark){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function fail$0(input, pos, more, marks, msg, cont){
		                          return cont
		                                  ([1,
		                                    [246,
		                                     function(a, cont){
		                                      return caml_trampoline_cps_call6
		      (fail, input, pos, more, [0, mark, marks], msg, cont);
		                                     }]]);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (p[1], input, pos, more, fail$0, succ, cont);
		                        }];
		               }
		               function symbol$64(p, q, cont){
		                return cont
		                        ([0,
		                          function(input, pos, more, fail, succ, cont){
		                           function fail$0(input, pos$0, more$0, marks, msg, cont){
		                            return pos < input[1]
		                                    ? cont
		                                      ([1,
		[246,
		 function(a, cont){
		  return caml_trampoline_cps_call6
		          (fail, input, pos$0, more, marks, msg, cont);
		 }]])
		                                    : caml_trampoline_cps_call6
		                                      (q[1], input, pos, more$0, fail, succ, cont);
		                           }
		                           return caml_trampoline_cps_call6
		                                   (p[1], input, pos, more, fail$0, succ, cont);
		                          }]);
		               }
		               function prompt(input, pos, fail, succ){
		                var
		                 a = bytes_for_client_to_commit(input),
		                 parser_uncommitted_bytes = input[4] - a | 0,
		                 parser_committed_bytes = input[1];
		                function continue$(buffer, off, len, more, cont){
		                 function a(a){
		                  var
		                   input =
		                     [0,
		                      parser_committed_bytes,
		                      parser_committed_bytes,
		                      off,
		                      len,
		                      buffer];
		                  return len === parser_uncommitted_bytes
		                          ? more
		                            ? cont(prompt(input, pos, fail, succ))
		                            : caml_exact_trampoline_cps_call$0
		                              (fail, input, pos, 0, cont)
		                          : caml_exact_trampoline_cps_call$0
		                            (succ, input, pos, more, cont);
		                 }
		                 return len < parser_uncommitted_bytes
		                         ? caml_exact_trampoline_cps_call
		                           (failwith, "prompt: input shrunk!", a)
		                         : a();
		                }
		                return [0, [0, bytes_for_client_to_commit(input), continue$]];
		               }
		               var
		                demand_input =
		                  [0,
		                   function(input, pos, more, fail, succ, cont){
		                    var cst_not_enough_input = "not enough input";
		                    if(! more)
		                     return caml_trampoline_cps_call6
		                             (fail, input, pos, more, 0, cst_not_enough_input, cont);
		                    function succ$0(input, pos, more, cont){
		                     return caml_trampoline_cps_call5
		                             (succ, input, pos, more, 0, cont);
		                    }
		                    function fail$0(input, pos, more, cont){
		                     return caml_trampoline_cps_call6
		                             (fail, input, pos, more, 0, cst_not_enough_input, cont);
		                    }
		                    return cont(prompt(input, pos, fail$0, succ$0));
		                   }];
		               function ensure_suspended
		               (n, input, pos, more, fail, succ, cont){
		                var go = [];
		                caml_update_dummy
		                 (go,
		                  [0,
		                   function(input, pos, more, fail, succ, cont){
		                    return (pos + n | 0) <= length$10(input)
		                            ? caml_trampoline_cps_call5(succ, input, pos, more, 0, cont)
		                            : caml_trampoline_cps_call6
		                              (symbol$61(demand_input, go)[1],
		                               input,
		                               pos,
		                               more,
		                               fail,
		                               succ,
		                               cont);
		                   }]);
		                return caml_trampoline_cps_call6
		                        (symbol$61(demand_input, go)[1],
		                         input,
		                         pos,
		                         more,
		                         fail,
		                         succ,
		                         cont);
		               }
		               function ensure(n, p){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         if((pos + n | 0) <= length$10(input))
		                          return caml_exact_trampoline_cps_call$3
		                                  (p[1], input, pos, more, fail, succ, cont);
		                         function succ$0(input, pos, more, param, cont){
		                          return caml_exact_trampoline_cps_call$3
		                                  (p[1], input, pos, more, fail, succ, cont);
		                         }
		                         return caml_exact_trampoline_cps_call$7
		                                 (ensure_suspended, n, input, pos, more, fail, succ$0, cont);
		                        }];
		               }
		               var
		                at_end_of_input =
		                  [0,
		                   function(input, pos, more, param, succ, cont){
		                    if(pos < length$10(input))
		                     return caml_trampoline_cps_call5
		                             (succ, input, pos, more, 0, cont);
		                    if(! more)
		                     return caml_trampoline_cps_call5
		                             (succ, input, pos, more, 1, cont);
		                    function succ$0(input, pos, more, cont){
		                     return caml_trampoline_cps_call5
		                             (succ, input, pos, more, 0, cont);
		                    }
		                    function fail(input, pos, more, cont){
		                     return caml_trampoline_cps_call5
		                             (succ, input, pos, more, 1, cont);
		                    }
		                    return cont(prompt(input, pos, fail, succ$0));
		                   }],
		                end_of_input =
		                  symbol_bind$3
		                   (at_end_of_input,
		                    function(param, cont){
		                     return param
		                             ? caml_exact_trampoline_cps_call(return$7, 0, cont)
		                             : cont(fail$0("end_of_input"));
		                    }),
		                pos =
		                  [0,
		                   function(input, pos, more, fail, succ, cont){
		                    return caml_trampoline_cps_call5
		                            (succ, input, pos, more, pos, cont);
		                   }],
		                commit =
		                  [0,
		                   function(input, pos, more, fail, succ, cont){
		                    input[1] = pos;
		                    return caml_trampoline_cps_call5
		                            (succ, input, pos, more, 0, cont);
		                   }],
		                peek_char =
		                  [0,
		                   function(input, pos, more, fail, succ, cont){
		                    if(pos < length$10(input))
		                     return caml_trampoline_cps_call5
		                             (succ,
		                              input,
		                              pos,
		                              more,
		                              [0, unsafe_get_char(input, pos)],
		                              cont);
		                    if(0 === more)
		                     return caml_trampoline_cps_call5
		                             (succ, input, pos, more, 0, cont);
		                    function succ$0(input, pos, more, cont){
		                     return caml_trampoline_cps_call5
		                             (succ,
		                              input,
		                              pos,
		                              more,
		                              [0, unsafe_get_char(input, pos)],
		                              cont);
		                    }
		                    function fail$0(input, pos, more, cont){
		                     return caml_trampoline_cps_call5
		                             (succ, input, pos, more, 0, cont);
		                    }
		                    return cont(prompt(input, pos, fail$0, succ$0));
		                   }];
		               function satisfy(f){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         if(pos < length$10(input)){
		                          var c = unsafe_get_char(input, pos);
		                          return caml_exact_trampoline_cps_call
		                                  (f,
		                                   c,
		                                   function(a){
		                                    return a
		    ? caml_trampoline_cps_call5
		      (succ, input, pos + 1 | 0, more, c, cont)
		    : caml_trampoline_cps_call5
		      (fail,
		       input,
		       pos,
		       more,
		       0,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (ksprintf,
		                 a,
		                 iU,
		                 function(a){return caml_trampoline_cps_call2(a, c, cont);});
		       });
		                                   });
		                         }
		                         function succ$0(input, pos, more, param, cont){
		                          var c = unsafe_get_char(input, pos);
		                          return caml_exact_trampoline_cps_call
		                                  (f,
		                                   c,
		                                   function(a){
		                                    return a
		    ? caml_trampoline_cps_call5
		      (succ, input, pos + 1 | 0, more, c, cont)
		    : caml_trampoline_cps_call5
		      (fail,
		       input,
		       pos,
		       more,
		       0,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (ksprintf,
		                 a,
		                 iV,
		                 function(a){return caml_trampoline_cps_call2(a, c, cont);});
		       });
		                                   });
		                         }
		                         return caml_exact_trampoline_cps_call$7
		                                 (ensure_suspended, 1, input, pos, more, fail, succ$0, cont);
		                        }];
		               }
		               function char$0(c){
		                var
		                 p =
		                   [0,
		                    function(input, pos, more, fail, succ, cont){
		                     return unsafe_get_char(input, pos) === c
		                             ? caml_trampoline_cps_call5
		                               (succ, input, pos + 1 | 0, more, c, cont)
		                             : caml_exact_trampoline_cps_call
		                               (sprintf,
		                                iW,
		                                function(a){
		                                 return caml_trampoline_cps_call2
		 (a,
		  c,
		  function(a){
		   return caml_trampoline_cps_call6
		           (fail, input, pos, more, 0, a, cont);
		  });
		                                });
		                    }];
		                return ensure(1, p);
		               }
		               var
		                p$0 =
		                  [0,
		                   function(input, pos, more, fail, succ, cont){
		                    return caml_trampoline_cps_call5
		                            (succ,
		                             input,
		                             pos + 1 | 0,
		                             more,
		                             unsafe_get_char(input, pos),
		                             cont);
		                   }],
		                any_char = ensure(1, p$0);
		               function count_while$0(init, f, with_buffer){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (count_while,
		                                  input,
		                                  pos + init | 0,
		                                  f,
		                                  function(len){
		                                   var input_len = length$10(input), init$0 = init + len | 0;
		                                   if((pos + init$0 | 0) >= input_len && 0 !== more){
		                                    var
		                                     succ$0 =
		                                       function(input, pos, more, cont){
		return caml_trampoline_cps_call6
		        (count_while$0(init$0, f, with_buffer)[1],
		         input,
		         pos,
		         more,
		         fail,
		         succ,
		         cont);
		                                       },
		                                     fail$0 =
		                                       function(input, pos, more, cont){
		return caml_exact_trampoline_cps_call$2
		        (apply,
		         input,
		         pos,
		         init$0,
		         with_buffer,
		         function(a){
		          return caml_trampoline_cps_call5
		                  (succ, input, pos + init$0 | 0, more, a, cont);
		         });
		                                       };
		                                    return cont(prompt(input, pos, fail$0, succ$0));
		                                   }
		                                   return caml_exact_trampoline_cps_call$2
		   (apply,
		    input,
		    pos,
		    init$0,
		    with_buffer,
		    function(a){
		     return caml_trampoline_cps_call5
		             (succ, input, pos + init$0 | 0, more, a, cont);
		    });
		                                  });
		                        }];
		               }
		               function count_while1(f, with_buffer){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (count_while,
		                                  input,
		                                  pos,
		                                  f,
		                                  function(len){
		                                   var input_len = length$10(input);
		                                   if(1 <= len){
		                                    if((pos + len | 0) >= input_len && 0 !== more){
		                                     var
		                                      succ$0 =
		function(input, pos, more, cont){
		 return caml_trampoline_cps_call6
		         (count_while$0(len, f, with_buffer)[1],
		          input,
		          pos,
		          more,
		          fail,
		          succ,
		          cont);
		},
		                                      fail$0 =
		function(input, pos, more, cont){
		 return caml_exact_trampoline_cps_call$2
		         (apply,
		          input,
		          pos,
		          len,
		          with_buffer,
		          function(a){
		           return caml_trampoline_cps_call5
		                   (succ, input, pos + len | 0, more, a, cont);
		          });
		};
		                                     return cont(prompt(input, pos, fail$0, succ$0));
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (apply,
		     input,
		     pos,
		     len,
		     with_buffer,
		     function(a){
		      return caml_trampoline_cps_call5
		              (succ, input, pos + len | 0, more, a, cont);
		     });
		                                   }
		                                   var cst_count_while1 = "count_while1";
		                                   if(pos >= input_len && 0 !== more){
		                                    var
		                                     succ$1 =
		                                       function(input, pos, more, cont){
		return caml_trampoline_cps_call6
		        (count_while1(f, with_buffer)[1],
		         input,
		         pos,
		         more,
		         fail,
		         succ,
		         cont);
		                                       },
		                                     fail$1 =
		                                       function(input, pos, more, cont){
		return caml_trampoline_cps_call6
		        (fail, input, pos, more, 0, cst_count_while1, cont);
		                                       };
		                                    return cont(prompt(input, pos, fail$1, succ$1));
		                                   }
		                                   return caml_trampoline_cps_call6
		   (fail, input, pos, more, 0, cst_count_while1, cont);
		                                  });
		                        }];
		               }
		               function string$2(f, s){
		                var len = caml_ml_string_length(s);
		                return ensure
		                        (len,
		                         [0,
		                          function(input, pos, more, fail, succ, cont){
		                           var
		                            off = offset_in_buffer(input, pos),
		                            buffer = input[5],
		                            i$0 = 0;
		                           for(;;){
		                            if(i$0 >= len) break;
		                            var b = f(caml_string_unsafe_get(s, i$0));
		                            if(! equal(f(caml_ba_get_1(buffer, off + i$0 | 0)), b))
		                             break;
		                            var i = i$0 + 1 | 0;
		                            i$0 = i;
		                           }
		                           function a(match){
		                            if(0 === match[0]){
		                             var x = match[1];
		                             return caml_trampoline_cps_call5
		                                     (succ, input, pos + len | 0, more, x, cont);
		                            }
		                            var e = match[1];
		                            return caml_trampoline_cps_call6
		                                    (fail, input, pos, more, 0, e, cont);
		                           }
		                           return len === i$0
		                                   ? caml_exact_trampoline_cps_call$0
		                                     (substring,
		                                      buffer,
		                                      off,
		                                      len,
		                                      function(b){return a([0, b]);})
		                                   : a(iY);
		                          }]);
		               }
		               function string$3(s){
		                return string$2(function(x){return x;}, s);
		               }
		               function skip_while(f){
		                return count_while$0
		                        (0, f, function(b, a, param, cont){return cont(0);});
		               }
		               function take$2(n){
		                if(0 > n) return fail$0("take: n < 0");
		                var len = max(n, 0);
		                return ensure
		                        (len,
		                         [0,
		                          function(input, pos, more, fail, succ, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply,
		                                    input,
		                                    pos,
		                                    len,
		                                    substring,
		                                    function(a){
		                                     return caml_trampoline_cps_call5
		     (succ, input, pos + len | 0, more, a, cont);
		                                    });
		                          }]);
		               }
		               function take_while(f){return count_while$0(0, f, substring);}
		               function take_till(f){
		                return take_while(function(c, cont){return cont(1 - f(c));});
		               }
		               function choice(opt, ps, cont){
		                var failure_msg = opt ? opt[1] : "no more choices";
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right, symbol$64, ps, fail$0(failure_msg), cont);
		               }
		               function fix(f){
		                var p = [], r = [];
		                caml_update_dummy
		                 (p,
		                  [246,
		                   function(a, cont){
		                    return caml_exact_trampoline_cps_call(f, r, cont);
		                   }]);
		                var max_steps = 20, steps = [0, max_steps];
		                caml_update_dummy
		                 (r,
		                  [0,
		                   function(buf, pos, more, fail, succ, cont){
		                    steps[1]--;
		                    if(0 > steps[1]){
		                     steps[1] = max_steps;
		                     return cont
		                             ([1,
		                               [246,
		                                function(a, cont){
		                                 a = caml_obj_tag(p);
		                                 function b(a){
		                                  return caml_trampoline_cps_call6
		  (a[1], buf, pos, more, fail, succ, cont);
		                                 }
		                                 if(250 === a) return b(p[1]);
		                                 if(246 !== a && 244 !== a) return b(p);
		                                 return caml_exact_trampoline_cps_call
		 (force_lazy_block, p, b);
		                                }]]);
		                    }
		                    var a = caml_obj_tag(p);
		                    function b(a){
		                     return caml_trampoline_cps_call6
		                             (a[1], buf, pos, more, fail, succ, cont);
		                    }
		                    if(250 === a) return b(p[1]);
		                    if(246 !== a && 244 !== a) return b(p);
		                    return caml_exact_trampoline_cps_call
		                            (force_lazy_block, p, b);
		                   }]);
		                return r;
		               }
		               function option$0(x, p, cont){
		                return caml_exact_trampoline_cps_call
		                        (return$7,
		                         x,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$64, p, a, cont);
		                         });
		               }
		               function cons$2(x, xs, cont){return cont([0, x, xs]);}
		               function list$0(ps, cont){
		                if(! ps)
		                 return caml_exact_trampoline_cps_call(return$7, 0, cont);
		                var ps$0 = ps[2], p = ps[1];
		                return caml_exact_trampoline_cps_call
		                        (list$0,
		                         ps$0,
		                         function(a){return cont(lift2(cons$2, p, a));});
		               }
		               function count$1(n, p, cont){
		                if(0 > n) return cont(fail$0("count: n < 0"));
		                function loop(n, cont){
		                 return 0 === n
		                         ? caml_exact_trampoline_cps_call(return$7, 0, cont)
		                         : caml_exact_trampoline_cps_call
		                           (loop,
		                            n - 1 | 0,
		                            function(a){return cont(lift2(cons$2, p, a));});
		                }
		                return caml_exact_trampoline_cps_call(loop, n, cont);
		               }
		               function many(p){
		                return fix
		                        (function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (return$7,
		                                   0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$64, lift2(cons$2, p, m), a, cont);
		                                   });
		                         });
		               }
		               function many1(p){return lift2(cons$2, p, many(p));}
		               function many_till(p, t){
		                return fix
		                        (function(m, cont){
		                          var a = lift2(cons$2, p, m);
		                          return caml_exact_trampoline_cps_call
		                                  (return$7,
		                                   0,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$64, symbol$61(t, b), a, cont);
		                                   });
		                         });
		               }
		               function sep_by1(s, p){
		                return fix
		                        (function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (return$7,
		                                   0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$64,
		     symbol$61(s, m),
		     a,
		     function(a){return cont(lift2(cons$2, p, a));});
		                                   });
		                         });
		               }
		               function sep_by(s, p, cont){
		                return caml_exact_trampoline_cps_call
		                        (return$7,
		                         0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (return$7,
		                                   0,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$64,
		     symbol$61(s, sep_by1(s, p)),
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$64, lift2(cons$2, p, b), a, cont);
		     });
		                                   });
		                         });
		               }
		               var
		                e = caml_callback(return$7, [0]),
		                e = symbol$61(string$3(cst$31), e),
		                b2 = caml_callback(return$7, [0]),
		                end_of_line =
		                  symbol$63
		                   (caml_callback(symbol$64, [symbol$61(char$0(10), b2), e]),
		                    "end_of_line");
		               function scan(state, f, with_buffer){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         var
		                          state$0 = [0, state],
		                          parser =
		                            symbol_map$3
		                             (count_while$0
		                               (0,
		                                function(c, cont){
		                                 return caml_exact_trampoline_cps_call$1
		 (f,
		  state$0[1],
		  c,
		  function(match){
		   if(! match) return cont(0);
		   var state = match[1];
		   state$0[1] = state;
		   return cont(1);
		  });
		                                },
		                                with_buffer),
		                              function(x, cont){return cont([0, x, state$0[1]]);});
		                         return caml_trampoline_cps_call6
		                                 (parser[1], input, pos, more, fail, succ, cont);
		                        }];
		               }
		               function symbol$65(a, b){
		                return lift2
		                        (function(a, b, cont){return cont([0, a, b]);}, a, b);
		               }
		               function parse_string(consume, p$0, s, cont){
		                var
		                 size = caml_ml_string_length(s),
		                 buffer = create$2(char, c_layout, size);
		                bigstringaf_blit_from_bytes(s, 0, buffer, 0, size);
		                var
		                 p = consume ? symbol$62(p$0, end_of_input) : p$0,
		                 len = caml_ba_dim_1(buffer),
		                 committed_bytes = 0;
		                return caml_trampoline_cps_call6
		                        (p[1],
		                         [0, committed_bytes, committed_bytes, 0, len, buffer],
		                         0,
		                         0,
		                         fail_k,
		                         succeed_k,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_exported_state,
		                                   a,
		                                   function(x){
		                                    switch(x[0]){
		                                      case 0:
		                                       return cont(iT);
		                                      case 1:
		                                       var v = x[2]; return cont([0, v]);
		                                      default:
		                                       var err = x[3], marks = x[2], s2 = cst$9 + err;
		                                       return caml_exact_trampoline_cps_call$1
		       (concat,
		        cst$22,
		        marks,
		        function(s1){return cont([1, s1 + s2]);});
		                                    }
		                                   });
		                         });
		               }
		               function backtrack(n){
		                return [0,
		                        function(input, pos, more, fail, succ, cont){
		                         return (pos - n | 0) < input[1]
		                                 ? caml_trampoline_cps_call6
		                                   (fail,
		                                    input,
		                                    pos,
		                                    more,
		                                    0,
		                                    "not enough uncommited bytes to backtrack",
		                                    cont)
		                                 : caml_trampoline_cps_call5
		                                   (succ, input, pos - n | 0, more, 0, cont);
		                        }];
		               }
		               function mk_version
		               (major, minor, patch, prerelease, build, cont){
		                return cont([0, major, minor, patch, prerelease, build]);
		               }
		               function to_string$11(v, cont){
		                function print_series(mark, identifiers, cont){
		                 return identifiers
		                         ? caml_exact_trampoline_cps_call$1
		                           (concat,
		                            cst$14,
		                            identifiers,
		                            function(s2){return cont(mark + s2);})
		                         : cont(cst$1);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (print_series,
		                         cst$32,
		                         v[5],
		                         function(s2){
		                          return caml_exact_trampoline_cps_call$1
		                                  (print_series,
		                                   cst$33,
		                                   v[4],
		                                   function(s1){
		                                    var
		                                     s2$4 = s1 + s2,
		                                     n = v[3],
		                                     s1$2 = "" + n,
		                                     s2$3 = s1$2 + s2$4,
		                                     s2$2 = cst$14 + s2$3,
		                                     n$0 = v[2],
		                                     s1$1 = "" + n$0,
		                                     s2$1 = s1$1 + s2$2,
		                                     s2$0 = cst$14 + s2$1,
		                                     n$1 = v[1],
		                                     s1$0 = "" + n$1;
		                                    return cont(s1$0 + s2$0);
		                                   });
		                         });
		               }
		               function pp$5(fmt, version, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$11,
		                         version,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, fmt, a, cont);
		                         });
		               }
		               function is_digit$1(param, cont){
		                return 9 < param - 48 >>> 0 ? cont(0) : cont(1);
		               }
		               function no_leading_zero(str){
		                var
		                 a = caml_ml_string_length(str) <= 1 ? 1 : 0,
		                 a = a || (48 !== caml_string_get(str, 0) ? 1 : 0);
		                return a;
		               }
		               var
		                nat =
		                  symbol_bind$3
		                   (count_while1(is_digit$1, substring),
		                    function(str, cont){
		                     return no_leading_zero(str)
		                             ? (caml_push_trap
		                                (function(exn){
		                                  return cont(fail$0("invalid version number: " + str));
		                                 }),
		                               caml_exact_trampoline_cps_call
		                                (return$7,
		                                 caml_int_of_string(str),
		                                 function(a){caml_pop_trap(); return cont(a);}))
		                             : cont(fail$0("leading 0 in version number: " + str));
		                    });
		               function isOk(param){return 0 === param[0] ? 1 : 0;}
		               var dot = char$0(46);
		               function f(param, cont){
		                a:
		                {
		                 if(58 <= param){
		                  if(91 <= param){
		                   if(25 < param - 97 >>> 0) break a;
		                  }
		                  else if(65 > param) break a;
		                 }
		                 else if(45 !== param && 48 > param) break a;
		                 return cont(1);
		                }
		                return cont(0);
		               }
		               var base_identifier = count_while1(f, substring);
		               function verify_numeric(str, cont){
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call(return$7, str, cont);
		                  });
		                caml_int_of_string(str);
		                function a(a){caml_pop_trap(); return cont(a);}
		                return no_leading_zero(str)
		                        ? caml_exact_trampoline_cps_call(return$7, str, a)
		                        : a
		                          (fail$0
		                            ("leading 0 in prerelease numeric identifier: " + str));
		               }
		               var
		                prerelease_identifier =
		                  symbol_bind$3(base_identifier, verify_numeric);
		               function identifier_list(id_parser, sep, cont){
		                return caml_exact_trampoline_cps_call
		                        (return$7,
		                         0,
		                         function(b){
		                          var a = sep_by1(dot, id_parser);
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$64, symbol$61(char$0(sep), a), b, cont);
		                         });
		               }
		               var
		                b2 = caml_callback(identifier_list, [base_identifier, 43]),
		                e =
		                  caml_callback(identifier_list, [prerelease_identifier, 45]),
		                bU = symbol$61(dot, nat),
		                version_parser =
		                  symbol$60
		                   (lift4(mk_version, nat, symbol$61(dot, nat), bU, e), b2);
		               function from_parts
		               (major, minor, patch, prerelease, build, cont){
		                function a(){return cont(0);}
		                if(0 > major) return a();
		                if(0 > minor) return a();
		                function b(param){
		                 function c(c){
		                  function b(param){
		                   function c(b){
		                    return b
		                            ? cont([0, [0, major, minor, patch, prerelease, build]])
		                            : a();
		                   }
		                   if(! param) return c(1);
		                   var l = param[2], a$0 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (parse_string,
		                            1,
		                            base_identifier,
		                            a$0,
		                            function(a){
		                             a = isOk(a);
		                             return a ? caml_exact_trampoline_call1(b, l) : c(a);
		                            });
		                  }
		                  return c ? b(build) : a();
		                 }
		                 if(! param) return c(1);
		                 var l = param[2], a$0 = param[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (parse_string,
		                          1,
		                          prerelease_identifier,
		                          a$0,
		                          function(a){
		                           a = isOk(a);
		                           return a ? caml_exact_trampoline_call1(b, l) : c(a);
		                          });
		                }
		                return 0 <= patch ? b(prerelease) : a();
		               }
		               function of_string$7(str, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         version_parser,
		                         str,
		                         function(match){
		                          if(0 !== match[0]) return cont(0);
		                          var v = match[1];
		                          return cont([0, v]);
		                         });
		               }
		               function compare$24(a, b, cont){
		                if(a[1] !== b[1]) return cont(caml_int_compare(a[1], b[1]));
		                if(a[2] !== b[2]) return cont(caml_int_compare(a[2], b[2]));
		                if(a[3] !== b[3]) return cont(caml_int_compare(a[3], b[3]));
		                var
		                 prb$1 = b[4],
		                 pra$1 = a[4],
		                 is_first = 1,
		                 pra = pra$1,
		                 prb = prb$1;
		                for(;;){
		                 if(! pra)
		                  return prb ? is_first ? cont(1) : cont(-1) : cont(0);
		                 if(! prb) return is_first ? cont(-1) : cont(1);
		                 var prb$0 = prb[2], ib = prb[1], pra$0 = pra[2], ia = pra[1];
		                 if(0 !== caml_string_compare(ia, ib)) break;
		                 is_first = 0;
		                 pra = pra$0;
		                 prb = prb$0;
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         nat,
		                         ia,
		                         function(match){
		                          return caml_exact_trampoline_cps_call$0
		                                  (parse_string,
		                                   1,
		                                   nat,
		                                   ib,
		                                   function(match$0){
		                                    if(0 !== match[0])
		                                     return 0 === match$0[0]
		     ? cont(1)
		     : cont(caml_string_compare(ia, ib));
		                                    var na = match[1];
		                                    if(0 !== match$0[0]) return cont(-1);
		                                    var nb = match$0[1];
		                                    return cont(caml_int_compare(na, nb));
		                                   });
		                         });
		               }
		               function less_than(a, b, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (compare$24, a, b, function(a){return cont(a < 0 ? 1 : 0);});
		               }
		               function split$4(max, str, on, cont){
		                if(max){
		                 var max$0 = max[1];
		                 if(str === cst$1) return cont(0);
		                 if(1 === max$0) return cont([0, str, 0]);
		                 var
		                  loop =
		                    function(offset, tokens, cont){
		                     if(tokens === (max$0 - 1 | 0))
		                      return caml_exact_trampoline_cps_call$0
		                              (get_sub,
		                               str,
		                               offset,
		                               caml_ml_string_length(str) - offset | 0,
		                               function(a){return cont([0, a, 0]);});
		                     caml_push_trap
		                      (function(exn){
		                        if(exn === Not_found)
		                         return caml_exact_trampoline_cps_call$0
		                                 (get_sub,
		                                  str,
		                                  offset,
		                                  caml_ml_string_length(str) - offset | 0,
		                                  function(a){return cont([0, a, 0]);});
		                        var
		                         raise = caml_pop_trap(),
		                         exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                        return raise(exn$0);
		                       });
		                     return caml_exact_trampoline_cps_call$0
		                             (index_from,
		                              str,
		                              offset,
		                              on,
		                              function(index){
		                               function a(a){caml_pop_trap(); return cont(a);}
		                               return index === offset
		                                       ? caml_exact_trampoline_cps_call$1
		 (loop,
		  offset + 1 | 0,
		  tokens + 1 | 0,
		  function(b){return a([0, cst$1, b]);})
		                                       : caml_exact_trampoline_cps_call$0
		 (get_sub,
		  str,
		  offset,
		  index - offset | 0,
		  function(token){
		   return caml_exact_trampoline_cps_call$1
		           (loop,
		            index + 1 | 0,
		            tokens + 1 | 0,
		            function(b){return a([0, token, b]);});
		  });
		                              });
		                    };
		                 return caml_exact_trampoline_cps_call$1(loop, 0, 0, cont);
		                }
		                if(str === cst$1) return cont(0);
		                function loop$0(acc, offset, cont){
		                 caml_push_trap
		                  (function(exn){
		                    if(exn === Not_found)
		                     return caml_exact_trampoline_cps_call$0
		                             (get_sub,
		                              str,
		                              0,
		                              offset + 1 | 0,
		                              function(a){return cont([0, a, acc]);});
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   });
		                 return caml_exact_trampoline_cps_call$0
		                         (rindex_from,
		                          str,
		                          offset,
		                          on,
		                          function(index){
		                           function a(a){caml_pop_trap(); return cont(a);}
		                           return index === offset
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (loop$0, [0, cst$1, acc], index - 1 | 0, a)
		                                   : caml_exact_trampoline_cps_call$0
		                                     (get_sub,
		                                      str,
		                                      index + 1 | 0,
		                                      offset - index | 0,
		                                      function(token){
		                                       return caml_exact_trampoline_cps_call$1
		       (loop$0, [0, token, acc], index - 1 | 0, a);
		                                      });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (loop$0, 0, caml_ml_string_length(str) - 1 | 0, cont);
		               }
		               var
		                Found_int = [248, "Stringext.Found_int", caml_fresh_oo_id()];
		               function iter_concat(fn, sep, buf, param, cont){
		                function a(param){
		                 if(! param) return cont();
		                 var last = param[1];
		                 if(! param[2])
		                  return caml_exact_trampoline_cps_call$1(fn, buf, last, cont);
		                 var rest = param[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (fn,
		                          buf,
		                          last,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (write_stringlit,
		                                    buf,
		                                    sep,
		                                    function(b){return caml_exact_trampoline_call1(a, rest);});
		                          });
		                }
		                return a(param);
		               }
		               function compare_list$0(f, t, t$0, cont){
		                function a(t$0, t){
		                 if(! t$0) return t ? cont(-1) : cont(0);
		                 var xs = t$0[2], x = t$0[1];
		                 if(! t) return cont(1);
		                 var ys = t[2], y = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          x,
		                          y,
		                          function(c){
		                           return 0 === c
		                                   ? caml_exact_trampoline_call2(a, xs, ys)
		                                   : cont(c);
		                          });
		                }
		                return a(t, t$0);
		               }
		               function sub_delims(a){
		                var i = 0;
		                for(;;){
		                 var c = caml_string_get("!$&'()*+,;=", i);
		                 caml_check_bound(a, c)[c + 1] = 1;
		                 var b = i + 1 | 0;
		                 if(10 === i) return a;
		                 i = b;
		                }
		               }
		               var safe_chars = caml_make_vect(256, 0), i = 0;
		               for(;;){
		                var
		                 c =
		                   caml_string_get
		                    ("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_.-~",
		                     i);
		                caml_check_bound(safe_chars, c)[c + 1] = 1;
		                e = i + 1 | 0;
		                if(65 === i) break;
		                i = e;
		               }
		               var pchar = sub_delims(caml_callback(copy$0, [safe_chars]));
		               caml_check_bound(pchar, 58)[59] = 1;
		               caml_check_bound(pchar, 64)[65] = 1;
		               var
		                safe_chars_for_scheme = caml_callback(copy$0, [safe_chars]);
		               caml_check_bound(safe_chars_for_scheme, 43)[44] = 1;
		               var
		                safe_chars_for_path =
		                  sub_delims(caml_callback(copy$0, [pchar]));
		               caml_check_bound(safe_chars_for_path, 47)[48] = 0;
		               var safe_chars_for_query = caml_callback(copy$0, [pchar]);
		               caml_check_bound(safe_chars_for_query, 47)[48] = 1;
		               caml_check_bound(safe_chars_for_query, 63)[64] = 1;
		               caml_check_bound(safe_chars_for_query, 38)[39] = 0;
		               caml_check_bound(safe_chars_for_query, 59)[60] = 0;
		               caml_check_bound(safe_chars_for_query, 43)[44] = 0;
		               var
		                safe_chars_for_query_key =
		                  caml_callback(copy$0, [safe_chars_for_query]);
		               caml_check_bound(safe_chars_for_query_key, 61)[62] = 0;
		               var
		                safe_chars_for_query_value =
		                  caml_callback(copy$0, [safe_chars_for_query]);
		               caml_check_bound(safe_chars_for_query_value, 44)[45] = 0;
		               var
		                safe_chars_for_userinfo = caml_callback(copy$0, [safe_chars]);
		               caml_check_bound(safe_chars_for_userinfo, 58)[59] = 0;
		               function safe_chars_for_component(a, cont){
		                if(typeof a === "number")
		                 if(-145160102 <= a){
		                  if(127343601 <= a){
		                   if(795008922 === a) return cont(safe_chars_for_query_value);
		                   if(892015045 === a) return cont(safe_chars_for_path);
		                  }
		                  else if(61643255 !== a && 127343600 <= a)
		                   return cont(safe_chars_for_query);
		                 }
		                 else if(-250086679 <= a){
		                  if(-178940859 === a) return cont(safe_chars_for_scheme);
		                  if(-145160103 <= a) return cont(safe_chars_for_userinfo);
		                 }
		                 else {
		                  if(-911188600 === a) return cont(safe_chars_for_query_key);
		                  if(-250086680 <= a) return cont(safe_chars_for_query);
		                 }
		                else {
		                 var variant = a[1];
		                 if(-198771759 === variant){
		                  a = a[2];
		                  var unsafe = a[3], safe = a[2], component = a[1];
		                  return caml_exact_trampoline_cps_call
		                          (safe_chars_for_component,
		                           component,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (copy$0,
		                                     a,
		                                     function(safe_chars){
		                                      var a = caml_ml_string_length(safe) - 1 | 0;
		                                      if(a >= 0){
		                                       var i$0 = 0;
		                                       for(;;){
		var c$0 = caml_string_get(safe, i$0);
		caml_check_bound(safe_chars, c$0)[c$0 + 1] = 1;
		var b = i$0 + 1 | 0;
		if(a === i$0) break;
		i$0 = b;
		                                       }
		                                      }
		                                      a = caml_ml_string_length(unsafe) - 1 | 0;
		                                      if(a >= 0){
		                                       var i = 0;
		                                       for(;;){
		var c = caml_string_get(unsafe, i);
		caml_check_bound(safe_chars, c)[c + 1] = 0;
		b = i + 1 | 0;
		if(a === i) break;
		i = b;
		                                       }
		                                      }
		                                      return cont(safe_chars);
		                                     });
		                           });
		                 }
		                }
		                return cont(safe_chars);
		               }
		               function normalize_host(hso, cont){return cont(hso);}
		               function normalize_host$0(hs, cont){
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0, hs, cont);
		               }
		               function normalize_host$1(hs, cont){
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         hs,
		                         function(hs){
		                          return hs === cst_localhost ? cont(cst$1) : cont(hs);
		                         });
		               }
		               var
		                Generic = [0, safe_chars_for_component, normalize_host],
		                Http = [0, safe_chars_for_component, normalize_host$0],
		                Https = [0, safe_chars_for_component, normalize_host$0],
		                File = [0, safe_chars_for_component, normalize_host$1],
		                Urn = [0, safe_chars_for_component, normalize_host];
		               function module_of_scheme(param, cont){
		                if(! param) return cont(Generic);
		                var s = param[1];
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         s,
		                         function(match){
		                          return match !== cst_file
		                                  ? match
		                                    !== cst_http
		                                    ? match
		                                      !== cst_https
		                                      ? match !== "urn" ? cont(Generic) : cont(Urn)
		                                      : cont(Https)
		                                    : cont(Http)
		                                  : cont(File);
		                         });
		               }
		               function encode$3(scheme, opt, b, cont){
		                var component = opt ? opt[1] : 892015045;
		                return caml_exact_trampoline_cps_call
		                        (module_of_scheme,
		                         scheme,
		                         function(Scheme){
		                          return caml_exact_trampoline_cps_call
		                                  (Scheme[1],
		                                   component,
		                                   function(safe_chars){
		                                    var len = caml_ml_string_length(b), buf = create$1(len);
		                                    function a(start, cur){
		                                     if(len <= cur)
		                                      return caml_exact_trampoline_cps_call$2
		      (add_substring,
		       buf,
		       b,
		       start,
		       cur - start | 0,
		       function(a){
		        return caml_exact_trampoline_cps_call(contents, buf, cont);
		       });
		                                     var c = caml_string_get(b, cur);
		                                     if(caml_check_bound(safe_chars, c)[c + 1]){
		                                      var cur$0 = cur + 1 | 0;
		                                      return caml_exact_trampoline_call2(a, start, cur$0);
		                                     }
		                                     function d(b){
		                                      return caml_exact_trampoline_cps_call
		      (sprintf,
		       iZ,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 c,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1
		                          (write_stringlit,
		                           buf,
		                           b,
		                           function(b){
		                            var cur$0 = cur + 1 | 0, start = cur + 1 | 0;
		                            return caml_exact_trampoline_call2(a, start, cur$0);
		                           });
		                 });
		       });
		                                     }
		                                     return start < cur
		     ? caml_exact_trampoline_cps_call$2
		       (add_substring, buf, b, start, cur - start | 0, d)
		     : d();
		                                    }
		                                    return a(0, 0);
		                                   });
		                         });
		               }
		               function int_of_hex_char(c, cont){
		                var
		                 c$0 = uppercase_ascii(c) - 48 | 0,
		                 cst_int_of_hex_char = "int_of_hex_char";
		                if(9 >= c$0)
		                 return 0 <= c$0
		                         ? cont(c$0)
		                         : caml_exact_trampoline_cps_call
		                           (failwith, cst_int_of_hex_char, cont);
		                if(16 < c$0 && 23 > c$0) return cont(c$0 - 7 | 0);
		                return caml_exact_trampoline_cps_call
		                        (failwith, cst_int_of_hex_char, cont);
		               }
		               function decode$0(b, cont){
		                var len = caml_ml_string_length(b), buf = create$1(len);
		                function a(start, cur){
		                 function c(a){
		                  return caml_exact_trampoline_cps_call(contents, buf, cont);
		                 }
		                 if(len <= cur)
		                  return caml_exact_trampoline_cps_call$2
		                          (add_substring, buf, b, start, cur - start | 0, c);
		                 if(37 === caml_string_get(b, cur))
		                  return caml_exact_trampoline_cps_call$2
		                          (add_substring,
		                           buf,
		                           b,
		                           start,
		                           cur - start | 0,
		                           function(d){
		                            var start = cur + 1 | 0;
		                            return len <= start
		                                    ? caml_exact_trampoline_cps_call$1(add_char, buf, 37, c)
		                                    : (caml_push_trap
		                                       (function(exn){
		 return caml_exact_trampoline_cps_call$1
		         (add_char,
		          buf,
		          37,
		          function(b){
		           return caml_exact_trampoline_call2(a, start, start);
		          });
		}),
		                                      caml_exact_trampoline_cps_call
		                                       (int_of_hex_char,
		caml_string_get(b, start),
		function(highbits){
		 caml_pop_trap();
		 var cur = start + 1 | 0;
		 if(len <= cur)
		  return caml_exact_trampoline_cps_call$1
		          (add_char,
		           buf,
		           37,
		           function(a){
		            return caml_exact_trampoline_cps_call$1
		                    (add_char, buf, caml_string_get(b, cur - 1 | 0), c);
		           });
		 function d(start_at){
		  return caml_exact_trampoline_call2(a, start_at, start_at);
		 }
		 caml_push_trap
		  (function(exn){
		    return caml_exact_trampoline_cps_call$1
		            (add_char,
		             buf,
		             37,
		             function(a){
		              return caml_exact_trampoline_cps_call$1
		                      (add_char,
		                       buf,
		                       caml_string_get(b, cur - 1 | 0),
		                       function(a){return d(cur);});
		             });
		   });
		 return caml_exact_trampoline_cps_call
		         (int_of_hex_char,
		          caml_string_get(b, cur),
		          function(lowbits){
		           caml_pop_trap();
		           return caml_exact_trampoline_cps_call
		                   (chr,
		                    (highbits << 4) + lowbits | 0,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1
		                             (add_char, buf, a, function(a){return d(cur + 1 | 0);});
		                    });
		          });
		}));
		                           });
		                 var cur$0 = cur + 1 | 0;
		                 return caml_exact_trampoline_call2(a, start, cur$0);
		                }
		                return a(0, 0);
		               }
		               function pct_encode(scheme, opt, s, cont){
		                var component = opt ? opt[1] : 892015045;
		                return caml_exact_trampoline_cps_call$0
		                        (encode$3, scheme, [0, component], s, cont);
		               }
		               function pct_encoder(f, e, d, c, b, a, opt, param){
		                var
		                 scheme = -178940859,
		                 userinfo = -145160103,
		                 host = 803994504,
		                 path = 892015045,
		                 query_key = -911188600,
		                 query_value = 795008922,
		                 fragment = 127343600;
		                return [0,
		                        scheme,
		                        userinfo,
		                        host,
		                        path,
		                        query_key,
		                        query_value,
		                        fragment];
		               }
		               function pct_decode(s, cont){
		                return caml_exact_trampoline_cps_call(decode$0, s, cont);
		               }
		               function userinfo_of_encoded(us, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (split$4,
		                         i0,
		                         us,
		                         58,
		                         function(match){
		                          if(! match) return cont(i1);
		                          var match$0 = match[2], u = match[1];
		                          if(match$0){
		                           var p = match$0[1];
		                           return caml_exact_trampoline_cps_call
		                                   (decode$0,
		                                    p,
		                                    function(x){
		                                     var a = [0, x];
		                                     return caml_exact_trampoline_cps_call
		     (decode$0, u, function(x){return cont([0, x, a]);});
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (decode$0, u, function(x){return cont([0, x, 0]);});
		                         });
		               }
		               function encoded_of_userinfo(scheme, component){
		                return function(a, cont){
		                 var po = a[2], u = a[1];
		                 if(po)
		                  var p = po[1], a = caml_ml_string_length(p);
		                 else
		                  a = 0;
		                 var
		                  len = (1 + caml_ml_string_length(u) | 0) + a | 0,
		                  buf = create$1(len);
		                 return caml_exact_trampoline_cps_call$0
		                         (pct_encode,
		                          scheme,
		                          [0, component],
		                          u,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (write_stringlit,
		                                    buf,
		                                    a,
		                                    function(b){
		                                     function a(a){
		                                      return caml_exact_trampoline_cps_call(contents, buf, cont);
		                                     }
		                                     if(! po) return a();
		                                     var p = po[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (add_char,
		      buf,
		      58,
		      function(b){
		       return caml_exact_trampoline_cps_call$0
		               (pct_encode,
		                scheme,
		                [0, component],
		                p,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (write_stringlit, buf, b, a);
		                });
		      });
		                                    });
		                          });};
		               }
		               function path_of_encoded(str, cont){
		                function a(tokl){
		                 return caml_exact_trampoline_cps_call$1
		                         (map$0, pct_decode, tokl, cont);
		                }
		                if(str === cst$1) return a(0);
		                var on = 47, sep = make$0(1, on);
		                function loop(acc, offset, cont){
		                 caml_push_trap
		                  (function(exn){
		                    if(exn === Not_found)
		                     return 0 <= offset
		                             ? caml_exact_trampoline_cps_call$0
		                               (get_sub,
		                                str,
		                                0,
		                                offset + 1 | 0,
		                                function(a){return cont([0, a, acc]);})
		                             : cont(acc);
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   });
		                 return caml_exact_trampoline_cps_call$0
		                         (rindex_from,
		                          str,
		                          offset,
		                          on,
		                          function(index){
		                           function a(a){caml_pop_trap(); return cont(a);}
		                           return index === offset
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (loop, [0, sep, acc], index - 1 | 0, a)
		                                   : caml_exact_trampoline_cps_call$0
		                                     (get_sub,
		                                      str,
		                                      index + 1 | 0,
		                                      offset - index | 0,
		                                      function(token){
		                                       return caml_exact_trampoline_cps_call$1
		       (loop, [0, sep, [0, token, acc]], index - 1 | 0, a);
		                                      });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (loop, 0, caml_ml_string_length(str) - 1 | 0, a);
		               }
		               function encoded_of_path(scheme, component, p, cont){
		                var l$0 = p, accu = 0;
		                for(;;){
		                 if(! l$0) break;
		                 var
		                  l = l$0[2],
		                  tok = l$0[1],
		                  accu$0 = caml_ml_string_length(tok) + accu | 0;
		                 l$0 = l;
		                 accu = accu$0;
		                }
		                var buf = create$1(accu);
		                return caml_exact_trampoline_cps_call$2
		                        (iter_concat,
		                         function(buf, seg, cont){
		                          return seg !== cst$34
		                                  ? caml_exact_trampoline_cps_call$0
		                                    (pct_encode,
		                                     scheme,
		                                     [0, component],
		                                     seg,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (write_stringlit, buf, a, cont);
		                                     })
		                                  : caml_exact_trampoline_cps_call$1(add_char, buf, 47, cont);
		                         },
		                         cst$1,
		                         buf,
		                         p,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(contents, buf, cont);
		                         });
		               }
		               function encoded_of_path$0(scheme, component){
		                return function(a, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (encoded_of_path, scheme, component, a, cont);};
		               }
		               function query_of_encoded(qs, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (split$4,
		                         0,
		                         qs,
		                         38,
		                         function(els){
		                          function plus_to_space(s){
		                           var
		                            s$0 = caml_bytes_of_string(s),
		                            a = caml_ml_bytes_length(s$0) - 1 | 0;
		                           if(a >= 0){
		                            var i = 0;
		                            for(;;){
		                             if(43 === caml_bytes_get(s$0, i))
		                              caml_bytes_set(s$0, i, 32);
		                             var b = i + 1 | 0;
		                             if(a === i) break;
		                             i = b;
		                            }
		                           }
		                           return caml_string_of_bytes(s$0);
		                          }
		                          function b(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$0,
		                                    function(param, cont){
		                                     var v = param[2], k = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (map$0,
		      pct_decode,
		      v,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (decode$0, k, function(x){return cont([0, x, a]);});
		      });
		                                    },
		                                    a,
		                                    cont);
		                          }
		                          if(! els) return b(i5);
		                          function a(accu, param){
		                           if(param){
		                            var l = param[2], el = param[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (split$4,
		                                     i4,
		                                     el,
		                                     61,
		                                     function(b){
		                                      var accu$0 = [0, b, accu];
		                                      return caml_exact_trampoline_call2(a, accu$0, l);
		                                     });
		                           }
		                           function c(acc, param){
		                            if(! param) return b(acc);
		                            var match = param[1];
		                            if(! match){
		                             var tl$1 = param[2], acc$1 = [0, i3, acc];
		                             return caml_exact_trampoline_call2(c, acc$1, tl$1);
		                            }
		                            var match$0 = match[2], k = match[1];
		                            if(match$0){
		                             var tl = param[2], v = match$0[1];
		                             return caml_exact_trampoline_cps_call$0
		                                     (split$4,
		                                      0,
		                                      plus_to_space(v),
		                                      44,
		                                      function(l){
		                                       var
		l$0 = l || i2,
		n = [0, plus_to_space(k), l$0],
		acc$0 = [0, n, acc];
		                                       return caml_exact_trampoline_call2(c, acc$0, tl);
		                                      });
		                            }
		                            var
		                             tl$0 = param[2],
		                             n = [0, plus_to_space(k), 0],
		                             acc$0 = [0, n, acc];
		                            return caml_exact_trampoline_call2(c, acc$0, tl$0);
		                           }
		                           return c(0, accu);
		                          }
		                          return a(0, els);
		                         });
		               }
		               var cst$5 = "&";
		               function encoded_of_query(scheme, opt, l, cont){
		                var
		                 pct_encoder$0 =
		                   opt ? opt[1] : pct_encoder(),
		                 l$1 = l,
		                 accu = -1;
		                for(;;){
		                 if(! l$1) break;
		                 var
		                  l$0 = l$1[2],
		                  a = l$1[1],
		                  v = a[2],
		                  k = a[1],
		                  l$3 = v,
		                  accu$2 = 0;
		                 for(;;){
		                  if(! l$3){
		                   var
		                    accu$1 =
		                      ((accu + caml_ml_string_length(k) | 0) + accu$2 | 0) + 2 | 0;
		                   l$1 = l$0;
		                   accu = accu$1;
		                   break;
		                  }
		                  var
		                   l$2 = l$3[2],
		                   a$0 = l$3[1],
		                   accu$0 = (accu$2 + caml_ml_string_length(a$0) | 0) + 1 | 0;
		                  l$3 = l$2;
		                  accu$2 = accu$0;
		                 }
		                }
		                var buf = create$1(accu);
		                return caml_exact_trampoline_cps_call$2
		                        (iter_concat,
		                         function(buf, param, cont){
		                          var v = param[2], k = param[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (pct_encode,
		                                   scheme,
		                                   [0, pct_encoder$0[5]],
		                                   k,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (write_stringlit,
		     buf,
		     a,
		     function(a){
		      a = 0 !== v ? 1 : 0;
		      return a
		              ? caml_exact_trampoline_cps_call$1
		                (add_char,
		                 buf,
		                 61,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$2
		                          (iter_concat,
		                           function(buf, s, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (pct_encode,
		                                     scheme,
		                                     [0, pct_encoder$0[6]],
		                                     s,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (write_stringlit, buf, a, cont);
		                                     });
		                           },
		                           cst$25,
		                           buf,
		                           v,
		                           cont);
		                 })
		              : cont(a);
		     });
		                                   });
		                         },
		                         cst$5,
		                         buf,
		                         l,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(contents, buf, cont);
		                         });
		               }
		               function of_raw(qs, cont){
		                var
		                 lazy_query =
		                   from_fun
		                    (function(param, cont){
		                      return caml_exact_trampoline_cps_call
		                              (query_of_encoded, qs, cont);
		                     });
		                return cont([1, [0, qs], lazy_query]);
		               }
		               function kv$0(a, cont){
		                function b(kv){return cont(kv);}
		                if(0 === a[0]) return b(a[1]);
		                a = a[2];
		                var c = caml_obj_tag(a);
		                if(250 === c) return b(a[1]);
		                if(246 !== c && 244 !== c) return b(a);
		                return caml_exact_trampoline_cps_call(force_lazy_block, a, b);
		               }
		               function encoded_of_query$0(scheme){
		                return function(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (encoded_of_query, scheme, a, b, cont);};
		               }
		               var
		                empty$13 =
		                  [0, 0, 0, 0, 0, 0, [1, 0, caml_callback(from_val, [0])], 0];
		               function compare$25(t$0, t, cont){
		                var t$1 = t[3], t$2 = t$0[3];
		                a:
		                if(t$2){
		                 var h1 = t$2[1];
		                 if(t$1){
		                  var h2 = t$1[1];
		                  if(typeof h1 !== "number"){
		                   var d = h1[1];
		                   if(-367671627 === d){
		                    if(typeof h2 !== "number"){
		                     var variant = h2[1];
		                     if(-367671627 === variant){
		                      var
		                       ip2 = h2[2],
		                       ip1 = h1[2],
		                       c = caml_string_compare(ip1, ip2);
		                      break a;
		                     }
		                    }
		                   }
		                   else
		                    if(267950263 === d){
		                     if(typeof h2 !== "number"){
		                      var variant$0 = h2[1];
		                      if(267950263 === variant$0){
		                       var
		                        ip2$0 = h2[2],
		                        ip1$0 = h1[2],
		                        c = caml_string_compare(ip1$0, ip2$0);
		                       break a;
		                      }
		                     }
		                    }
		                    else if(803994504 === d && typeof h2 !== "number"){
		                     var variant$1 = h2[1];
		                     if(803994504 === variant$1){
		                      var
		                       h2$0 = h2[2],
		                       h1$0 = h1[2],
		                       c = caml_string_compare(h1$0, h2$0);
		                      break a;
		                     }
		                    }
		                  }
		                  c = -1;
		                 }
		                 else
		                  c = 1;
		                }
		                else
		                 c = t$1 ? -1 : 0;
		                if(0 !== c) return cont(c);
		                var t$3 = t[1], t$4 = t$0[1];
		                if(t$4){
		                 var a = t$4[1];
		                 if(t$3)
		                  var b = t$3[1], c$2 = caml_string_compare(a, b);
		                 else
		                  c$2 = 1;
		                }
		                else
		                 c$2 = t$3 ? -1 : 0;
		                if(0 !== c$2) return cont(c$2);
		                var t$5 = t[4], t$6 = t$0[4];
		                if(t$6){
		                 var a$2 = t$6[1];
		                 if(t$5)
		                  var b$2 = t$5[1], c$0 = a$2 < b$2 ? -1 : b$2 < a$2 ? 1 : 0;
		                 else
		                  c$0 = 1;
		                }
		                else
		                 c$0 = t$5 ? -1 : 0;
		                if(0 !== c$0) return cont(c$0);
		                var t$7 = t[2], t$8 = t$0[2];
		                if(t$8){
		                 var a$0 = t$8[1];
		                 if(t$7){
		                  var
		                   b$0 = t$7[1],
		                   p = b$0[2],
		                   u = b$0[1],
		                   p$0 = a$0[2],
		                   u$0 = a$0[1],
		                   c$3 = caml_string_compare(u$0, u);
		                  if(0 === c$3)
		                   if(p$0){
		                    var a$1 = p$0[1];
		                    if(p)
		                     var b$1 = p[1], c$1 = caml_string_compare(a$1, b$1);
		                    else
		                     c$1 = 1;
		                   }
		                   else
		                    c$1 = p ? -1 : 0;
		                  else
		                   c$1 = c$3;
		                 }
		                 else
		                  c$1 = 1;
		                }
		                else
		                 c$1 = t$7 ? -1 : 0;
		                return 0 === c$1
		                        ? caml_exact_trampoline_cps_call$0
		                          (compare_list$0,
		                           compare_decoded,
		                           t$0[5],
		                           t[5],
		                           function(c){
		                            if(0 !== c) return cont(c);
		                            var y = t[6], x = t$0[6];
		                            function g(c){
		                             if(0 !== c) return cont(c);
		                             var t$1 = t[7], t$2 = t$0[7];
		                             if(! t$2) return t$1 ? cont(-1) : cont(0);
		                             var a = t$2[1];
		                             if(! t$1) return cont(1);
		                             var b = t$1[1];
		                             return cont(caml_string_compare(a, b));
		                            }
		                            function f(kvl, kvl$0){
		                             return caml_exact_trampoline_cps_call$0
		                                     (compare_list$0,
		                                      function(a, param, cont){
		                                       var
		vl = param[2],
		k = param[1],
		vl$0 = a[2],
		k$0 = a[1],
		c = caml_string_compare(k$0, k);
		                                       return 0 === c
		       ? caml_exact_trampoline_cps_call$0
		         (compare_list$0, compare_decoded, vl$0, vl, cont)
		       : cont(c);
		                                      },
		                                      kvl,
		                                      kvl$0,
		                                      g);
		                            }
		                            if(0 === x[0]){
		                             var h = x[1];
		                             if(0 === y[0]) return f(h, y[1]);
		                             var d = y[2], e = caml_obj_tag(d);
		                             if(250 === e) return f(h, d[1]);
		                             if(246 !== e && 244 !== e) return f(h, d);
		                             return caml_exact_trampoline_cps_call
		                                     (force_lazy_block, d, function(a){return f(h, a);});
		                            }
		                            d = x[2];
		                            var raw = x[1];
		                            if(0 === y[0]){
		                             e = caml_obj_tag(d);
		                             var i = function(a){return f(a, y[1]);};
		                             if(250 === e) return i(d[1]);
		                             if(246 !== e && 244 !== e) return i(d);
		                             return caml_exact_trampoline_cps_call
		                                     (force_lazy_block, d, i);
		                            }
		                            var raw$0 = y[1];
		                            if(! raw) return raw$0 ? g(-1) : g(0);
		                            var a = raw[1];
		                            if(! raw$0) return g(1);
		                            var b = raw$0[1];
		                            return g(caml_string_compare(a, b));
		                           })
		                        : cont(c$1);
		               }
		               function equal$13(t$0, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (compare$25,
		                         t$0,
		                         t,
		                         function(a){return cont(0 === a ? 1 : 0);});
		               }
		               function uncast_opt(param){
		                if(! param) return 0;
		                var h = param[1];
		                return [0, h];
		               }
		               function normalize(schem, init, cont){
		                return caml_exact_trampoline_cps_call
		                        (module_of_scheme,
		                         uncast_opt(schem),
		                         function(Scheme){
		                          var
		                           a = init[3],
		                           c = init[7],
		                           d = init[6],
		                           e = init[5],
		                           f = init[4];
		                          function b(g){
		                           var param = init[1], b = init[2];
		                           function a(a){return cont([0, a, b, g, f, e, d, c]);}
		                           if(! param) return a(0);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (lowercase_ascii$0, x, function(b){return a([0, b]);});
		                          }
		                          if(! a) return b(0);
		                          a = a[1];
		                          var variant = a[1];
		                          if(267950263 === variant){
		                           var host = a[2];
		                           return caml_exact_trampoline_cps_call
		                                   (Scheme[2],
		                                    host,
		                                    function(a){return b([0, [0, 267950263, a]]);});
		                          }
		                          if(803994504 <= variant){
		                           var host$0 = a[2];
		                           return caml_exact_trampoline_cps_call
		                                   (Scheme[2],
		                                    host$0,
		                                    function(x){return b([0, [0, 803994504, x]]);});
		                          }
		                          var host$1 = a[2];
		                          return caml_exact_trampoline_cps_call
		                                  (Scheme[2],
		                                   host$1,
		                                   function(a){return b([0, [0, -367671627, a]]);});
		                         });
		               }
		               function to_string$12(a, uri, cont){
		                var
		                 pct_encoder$0 = a ? a[1] : pct_encoder(),
		                 a = uri[1];
		                if(a) var s = a[1], scheme = [0, s]; else scheme = 0;
		                var buf = create$1(128);
		                function add_pct_string(opt, x, cont){
		                 var component = opt ? opt[1] : 892015045;
		                 return caml_exact_trampoline_cps_call$0
		                         (encode$3,
		                          scheme,
		                          [0, component],
		                          x,
		                          function(x){
		                           return caml_exact_trampoline_cps_call$1
		                                   (write_stringlit, buf, x, cont);
		                          });
		                }
		                var a = uri[1];
		                function b(a){
		                 a:
		                 {
		                  a = uri[3];
		                  var match = uri[4];
		                  if(! uri[2] && ! a && ! match){a = 0; break a;}
		                  a = 1;
		                 }
		                 function b(a){
		                  a = uri[2];
		                  function b(a){
		                   a = uri[3];
		                   function b(a){
		                    a = uri[4];
		                    function b(c){
		                     c = uri[5];
		                     function e(a){
		                      a = uri[6];
		                      function d(a){
		                       a = uri[7];
		                       function b(a){
		                        return caml_exact_trampoline_cps_call(contents, buf, cont);
		                       }
		                       if(! a) return b();
		                       var f = a[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (add_char,
		                                buf,
		                                35,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (add_pct_string, [0, pct_encoder$0[7]], f, b);
		                                });
		                      }
		                      function b(q){
		                       return caml_exact_trampoline_cps_call$1
		                               (add_char,
		                                buf,
		                                63,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$0
		 (encoded_of_query,
		  scheme,
		  [0, pct_encoder$0],
		  q,
		  function(a){
		   return caml_exact_trampoline_cps_call$1
		           (write_stringlit, buf, a, d);
		  });
		                                });
		                      }
		                      if(0 === a[0]){a = a[1]; return a ? b(a) : d(0);}
		                      if(! a[1]) return d(0);
		                      a = a[2];
		                      var c = caml_obj_tag(a);
		                      if(250 === c) return b(a[1]);
		                      if(246 !== c && 244 !== c) return b(a);
		                      return caml_exact_trampoline_cps_call
		                              (force_lazy_block, a, b);
		                     }
		                     if(! c) return e(0);
		                     var first_segment = c[1];
		                     if(first_segment === cst$34){
		                      var a = uri[5];
		                      return caml_exact_trampoline_cps_call
		                              (encoded_of_path$0(scheme, pct_encoder$0[4]),
		                               a,
		                               function(x){
		                                return caml_exact_trampoline_cps_call$1
		(write_stringlit, buf, x, e);
		                               });
		                     }
		                     function d(a){
		                      a = uri[5];
		                      return caml_exact_trampoline_cps_call
		                              (encoded_of_path$0(scheme, pct_encoder$0[4]),
		                               a,
		                               function(x){
		                                return caml_exact_trampoline_cps_call$1
		(write_stringlit, buf, x, e);
		                               });
		                     }
		                     if(uri[3])
		                      return caml_exact_trampoline_cps_call$1
		                              (add_char, buf, 47, d);
		                     try{
		                      a = caml_ml_string_length(first_segment) - 1 | 0;
		                      if(a >= 0){
		                       var start = 0;
		                       for(;;){
		                        try{
		                         var i = 0;
		                         for(;;){
		                          var b = caml_string_get(cst$21, i);
		                          if(caml_string_get(first_segment, i + start | 0) !== b)
		                           throw caml_maybe_attach_backtrace(Exit, 1);
		                          b = i + 1 | 0;
		                          if(0 === i){b = 1; break;}
		                          i = b;
		                         }
		                        }
		                        catch(exn){b = 0;}
		                        if(b)
		                         throw caml_maybe_attach_backtrace([0, Found_int, start], 1);
		                        c = start + 1 | 0;
		                        if(a === start) break;
		                        start = c;
		                       }
		                      }
		                      a = 0;
		                     }
		                     catch(exn$0){
		                      var exn = caml_wrap_exception(exn$0);
		                      if(exn[1] === Found_int)
		                       var i$0 = exn[2], a = [0, i$0];
		                      else
		                       a = 0;
		                     }
		                     return a
		                             ? scheme
		                               ? d(0)
		                               : caml_exact_trampoline_cps_call$1
		                                 (write_stringlit, buf, "./", d)
		                             : d(0);
		                    }
		                    if(! a) return b(0);
		                    var port = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (add_char,
		                             buf,
		                             58,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (write_stringlit, buf, "" + port, b);
		                             });
		                   }
		                   if(! a) return b(0);
		                   a = a[1];
		                   var variant = a[1];
		                   if(267950263 === variant){
		                    var host = a[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (add_char,
		                             buf,
		                             91,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (write_stringlit,
		                                       buf,
		                                       host,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (add_char, buf, 93, b);
		                                       });
		                             });
		                   }
		                   if(803994504 <= variant){
		                    var host$0 = a[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (add_pct_string, [0, pct_encoder$0[3]], host$0, b);
		                   }
		                   var host$1 = a[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (write_stringlit, buf, host$1, b);
		                  }
		                  if(! a) return b(0);
		                  var userinfo = a[1];
		                  return caml_exact_trampoline_cps_call
		                          (encoded_of_userinfo(scheme, pct_encoder$0[2]),
		                           userinfo,
		                           function(x){
		                            return caml_exact_trampoline_cps_call$1
		                                    (write_stringlit,
		                                     buf,
		                                     x,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (add_char, buf, 64, b);
		                                     });
		                           });
		                 }
		                 return a
		                         ? caml_exact_trampoline_cps_call$1
		                           (write_stringlit, buf, cst$4, b)
		                         : b(0);
		                }
		                if(! a) return b(0);
		                var x = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (add_pct_string,
		                         [0, pct_encoder$0[1]],
		                         x,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (add_char, buf, 58, b);
		                         });
		               }
		               function get_decoded_opt(param){
		                if(! param) return 0;
		                var x = param[1];
		                return [0, x];
		               }
		               function scheme(uri){return get_decoded_opt(uri[1]);}
		               function with_scheme(uri, param, cont){
		                if(! param)
		                 return cont
		                         ([0, 0, uri[2], uri[3], uri[4], uri[5], uri[6], uri[7]]);
		                var scheme = param[1];
		                return cont
		                        ([0,
		                          [0, scheme],
		                          uri[2],
		                          uri[3],
		                          uri[4],
		                          uri[5],
		                          uri[6],
		                          uri[7]]);
		               }
		               function host(uri){
		                var a = uri[3];
		                if(! a) return 0;
		                a = a[1];
		                var variant = a[1];
		                if(803994504 <= variant){var h = a[2]; return [0, h];}
		                var h$0 = a[2];
		                return [0, h$0];
		               }
		               function with_port(uri, port, cont){
		                return host(uri)
		                        ? cont
		                          ([0, uri[1], uri[2], uri[3], port, uri[5], uri[6], uri[7]])
		                        : port
		                          ? cont
		                            ([0,
		                              uri[1],
		                              uri[2],
		                              [0, [0, 803994504, cst$1]],
		                              port,
		                              uri[5],
		                              uri[6],
		                              uri[7]])
		                          : cont([0, uri[1], uri[2], 0, 0, uri[5], uri[6], uri[7]]);
		               }
		               function path(a, uri, cont){
		                var
		                 pct_encoder$0 = a ? a[1] : pct_encoder(),
		                 a = uri[1];
		                function b(x){return cont(x);}
		                if(a){
		                 var s = a[1], a = uri[5];
		                 return caml_exact_trampoline_cps_call
		                         (encoded_of_path$0([0, s], pct_encoder$0[4]), a, b);
		                }
		                a = uri[5];
		                return caml_exact_trampoline_cps_call
		                        (encoded_of_path$0(0, pct_encoder$0[4]), a, b);
		               }
		               function with_path(uri, path, cont){
		                return caml_exact_trampoline_cps_call
		                        (path_of_encoded,
		                         path,
		                         function(path){
		                          if(host(uri) && path && path[1] !== cst$34)
		                           return cont
		                                   ([0,
		                                     uri[1],
		                                     uri[2],
		                                     uri[3],
		                                     uri[4],
		                                     [0, cst$34, path],
		                                     uri[6],
		                                     uri[7]]);
		                          return cont
		                                  ([0, uri[1], uri[2], uri[3], uri[4], path, uri[6], uri[7]]);
		                         });
		               }
		               function query(uri, cont){
		                return caml_exact_trampoline_cps_call(kv$0, uri[6], cont);
		               }
		               function with_query(uri, query){
		                return [0,
		                        uri[1],
		                        uri[2],
		                        uri[3],
		                        uri[4],
		                        uri[5],
		                        [0, query],
		                        uri[7]];
		               }
		               function pp_v(ppf, uri, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_string$12,
		                         0,
		                         uri,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, ppf, a, cont);
		                         });
		               }
		               function string_of_char(a, cont){return cont(make$0(1, a));}
		               function string_of_char_list(chars, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$0,
		                         string_of_char,
		                         chars,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat, cst$1, a, cont);
		                         });
		               }
		               var
		                e = caml_callback(return$7, [0]),
		                b2 = char$0(58),
		                m =
		                  symbol$62
		                   (take_while
		                     (function(c, cont){
		                       var a = 58 !== c ? 1 : 0;
		                       if(a){
		                        a = 47 !== c ? 1 : 0;
		                        if(a){a = 63 !== c ? 1 : 0; a = a ? 35 !== c ? 1 : 0 : a;}
		                       }
		                       return cont(a);
		                      }),
		                    b2);
		               function f$0(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (decode$0, s, function(a){return cont([0, a]);});
		               }
		               var
		                scheme$0 = caml_callback(symbol$64, [symbol_map$3(m, f$0), e]);
		               function is_digit$2(param, cont){
		                return 9 < param - 48 >>> 0 ? cont(0) : cont(1);
		               }
		               var
		                hex_digit =
		                  satisfy
		                   (function(a, cont){
		                     a = a - 48 | 0;
		                     a:
		                     {
		                      if(22 < a >>> 0){
		                       if(5 < a - 49 >>> 0) break a;
		                      }
		                      else if(6 >= a - 10 >>> 0) break a;
		                      return cont(1);
		                     }
		                     return cont(0);
		                    }),
		                m$0 = many(hex_digit),
		                hexadecimal = symbol_map$3(m$0, string_of_char_list),
		                c_dot = char$0(46),
		                c_at = char$0(64),
		                c_colon = char$0(58);
		               function f$1(param, cont){
		                return 9 < param - 48 >>> 0 ? cont(0) : cont(1);
		               }
		               var
		                dec_octet =
		                  symbol_bind$3
		                   (count_while1(f$1, substring),
		                    function(num, cont){
		                     return 256 <= caml_int_of_string(num)
		                             ? cont(fail$0("invalid octect"))
		                             : caml_exact_trampoline_cps_call(return$7, num, cont);
		                    }),
		                ipv4_address =
		                  lift2
		                   (function(three, one, cont){
		                     var s2 = cst$14 + one;
		                     return caml_exact_trampoline_cps_call$1
		                             (concat, cst$14, three, function(s1){return cont(s1 + s2);});
		                    },
		                    caml_callback(count$1, [3, symbol$62(dec_octet, c_dot)]),
		                    dec_octet),
		                after_double_colon =
		                  fix
		                   (function(f, cont){
		                     return caml_exact_trampoline_cps_call
		                             (return$7,
		                              0,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (symbol$64,
		symbol$61(c_colon, f),
		a,
		function(b){
		 var
		  a =
		    lift2
		     (function(x, y, cont){return cont([0, x, y]);},
		      hexadecimal,
		      b);
		 return caml_exact_trampoline_cps_call
		         (list$0,
		          [0, ipv4_address, 0],
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (symbol$64, b, a, cont);
		          });
		});
		                              });
		                    });
		               function double_colon(count, cont){
		                return caml_exact_trampoline_cps_call
		                        (return$7,
		                         i6,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$64,
		                                   symbol_bind$3
		                                    (after_double_colon,
		                                     function(rest, cont){
		                                      var filler_length = (8 - count | 0) - length(rest) | 0;
		                                      return 0 < filler_length
		      ? caml_exact_trampoline_cps_call
		        (return$7, [0, cst$1, rest], cont)
		      : cont(fail$0("too many parts in IPv6 address"));
		                                     }),
		                                   a,
		                                   cont);
		                         });
		               }
		               function part(n, cont){
		                if(6 === n)
		                 return caml_exact_trampoline_cps_call
		                         (hex_part,
		                          6,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (list$0,
		                                    [0, ipv4_address, 0],
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$64, b, a, cont);
		                                    });
		                          });
		                if(7 !== n)
		                 return caml_exact_trampoline_cps_call(hex_part, n, cont);
		                function f(x, cont){return cont([0, x, 0]);}
		                return cont(symbol_map$3(hexadecimal, f));
		               }
		               function hex_part(n, cont){
		                return caml_exact_trampoline_cps_call
		                        (part,
		                         n + 1 | 0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (double_colon,
		                                   n + 1 | 0,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$64,
		     symbol$61(c_colon, b),
		     a,
		     function(a){
		      return cont
		              (lift2
		                (function(x, y, cont){return cont([0, x, y]);},
		                 hexadecimal,
		                 symbol$61(c_colon, a)));
		     });
		                                   });
		                         });
		               }
		               function split_with(f, xs){
		                if(! xs) return i7;
		                var ys = xs[2], y = xs[1];
		                if(! f(y)) return [0, 0, xs];
		                var match = split_with(f, ys), ts = match[2], zs = match[1];
		                return [0, [0, y, zs], ts];
		               }
		               function format_addr(segments, cont){
		                var
		                 match =
		                   split_with
		                    (function(segment){return segment !== cst$1 ? 1 : 0;},
		                     segments),
		                 after_double_colon = match[2],
		                 before_double_colon = match[1];
		                return caml_exact_trampoline_cps_call$1
		                        (concat,
		                         cst$21,
		                         before_double_colon,
		                         function(before){
		                          function a(res){return cont(res);}
		                          if(! after_double_colon) return a(before);
		                          if(after_double_colon[1] !== cst$1) return a(before);
		                          var xs = after_double_colon[2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat,
		                                   cst$21,
		                                   xs,
		                                   function(s2){var s2$0 = "::" + s2; return a(before + s2$0);});
		                         });
		               }
		               var
		                e = caml_callback(part, [0]),
		                b2 = caml_callback(double_colon, [0]),
		                m$1 =
		                  caml_callback
		                   (symbol$64, [symbol$61(symbol$61(c_colon, c_colon), b2), e]),
		                ipv6 = symbol_map$3(m$1, format_addr),
		                e = char$0(93),
		                ipv6_address = symbol$62(symbol$61(char$0(91), ipv6), e),
		                e = caml_callback(count$1, [2, hex_digit]),
		                pct_encoded =
		                  lift2
		                   (function(pct, digits, cont){
		                     return caml_exact_trampoline_cps_call
		                             (string_of_char_list, [0, pct, digits], cont);
		                    },
		                    char$0(37),
		                    e),
		                sub_delims$0 =
		                  satisfy
		                   (function(a, cont){
		                     a = a - 59 | 0;
		                     a:
		                     {
		                      if(2 < a >>> 0){
		                       a = a + 26 | 0;
		                       if(11 < a >>> 0) break a;
		                       switch(a){case 1:case 2:case 4: break a;
		                       }
		                      }
		                      else if(1 === a) break a;
		                      return cont(1);
		                     }
		                     return cont(0);
		                    }),
		                unreserved =
		                  satisfy
		                   (function(a, cont){
		                     a:
		                     {
		                      if(91 <= a){
		                       a = a - 95 | 0;
		                       if(27 < a >>> 0){
		                        if(31 !== a) break a;
		                       }
		                       else if(1 === a) break a;
		                      }
		                      else {
		                       a = a - 45 | 0;
		                       if(12 < a >>> 0){
		                        if(20 > a) break a;
		                       }
		                       else if(2 === a) break a;
		                      }
		                      return cont(1);
		                     }
		                     return cont(0);
		                    }),
		                e =
		                  [0,
		                   pct_encoded,
		                   [0, symbol_map$3(sub_delims$0, string_of_char), 0]],
		                m$2 =
		                  many
		                   (caml_callback
		                     (choice,
		                      [0, [0, symbol_map$3(unreserved, string_of_char), e]]));
		               function f$2(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (concat, cst$1, a, cont);
		               }
		               var
		                reg_name = symbol_map$3(m$2, f$2),
		                e =
		                  [0,
		                   symbol_map$3
		                    (reg_name,
		                     function(s, cont){
		                      return caml_exact_trampoline_cps_call
		                              (decode$0, s, function(a){return cont([0, 803994504, a]);});
		                     }),
		                   0],
		                e =
		                  [0,
		                   symbol_map$3
		                    (ipv6_address,
		                     function(h, cont){return cont([0, 267950263, h]);}),
		                   e],
		                host$0 =
		                  caml_callback
		                   (choice,
		                    [0,
		                     [0,
		                      symbol_map$3
		                       (ipv4_address,
		                        function(h, cont){return cont([0, -367671627, h]);}),
		                      e]]),
		                e = caml_callback(return$7, [0]),
		                b2 = [0, symbol_map$3(c_colon, string_of_char), 0],
		                b2 =
		                  [0,
		                   pct_encoded,
		                   [0, symbol_map$3(sub_delims$0, string_of_char), b2]],
		                m$3 =
		                  symbol$62
		                   (many
		                     (caml_callback
		                       (choice,
		                        [0, [0, symbol_map$3(unreserved, string_of_char), b2]])),
		                    c_at);
		               function f$3(x, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (concat,
		                         cst$1,
		                         x,
		                         function(s){
		                          return caml_exact_trampoline_cps_call
		                                  (userinfo_of_encoded, s, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                userinfo =
		                  caml_callback(symbol$64, [symbol_map$3(m$3, f$3), e]),
		                port =
		                  symbol_bind$3
		                   (peek_char,
		                    function(param, cont){
		                     if(param && 58 === param[1])
		                      return cont
		                              (symbol_map$3
		                                (symbol$61(c_colon, take_while(is_digit$2)),
		                                 function(port, cont){
		                                  return caml_exact_trampoline_cps_call
		  (decode$0,
		   port,
		   function(decoded){
		    try{var a = [0, caml_int_of_string(decoded)];}
		    catch(exn){return cont(0);}
		    return cont(a);
		   });
		                                 }));
		                     return caml_exact_trampoline_cps_call(return$7, 0, cont);
		                    }),
		                e = caml_callback(return$7, [i8]),
		                authority =
		                  caml_callback
		                   (symbol$64,
		                    [symbol$61
		                      (string$3(cst$4),
		                       [0,
		                        function(input, pos, more, fail, succ, cont){
		                         function succ1(input1, pos1, more1, userinfo, cont){
		                          function succ2(input2, pos2, more2, host, cont){
		                           function succ3(input3, pos3, more3, port, cont){
		                            return cont
		                                    ([1,
		                                      [246,
		                                       function(param, cont){
		return caml_trampoline_cps_call5
		        (succ,
		         input3,
		         pos3,
		         more3,
		         [0, userinfo, [0, host], port],
		         cont);
		                                       }]]);
		                           }
		                           return caml_trampoline_cps_call6
		                                   (port[1], input2, pos2, more2, fail, succ3, cont);
		                          }
		                          return caml_trampoline_cps_call6
		                                  (host$0[1], input1, pos1, more1, fail, succ2, cont);
		                         }
		                         return caml_trampoline_cps_call6
		                                 (userinfo[1], input, pos, more, fail, succ1, cont);
		                        }]),
		                     e]),
		                m$4 =
		                  take_while
		                   (function(param, cont){
		                     if(35 !== param && 63 !== param) return cont(1);
		                     return cont(0);
		                    }),
		                path$2 = symbol_map$3(m$4, path_of_encoded),
		                e =
		                  caml_callback
		                   (return$7, [[1, 0, caml_callback(from_val, [0])]]),
		                b2 = take_till(function(param){return 35 === param ? 1 : 0;}),
		                m$5 = symbol$61(char$0(63), b2),
		                query$0 =
		                  caml_callback(symbol$64, [symbol_map$3(m$5, of_raw), e]),
		                e = caml_callback(return$7, [0]),
		                b2 = take_while(function(param, cont){return cont(1);}),
		                m$6 = symbol$61(char$0(35), b2);
		               function f$4(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (decode$0, s, function(a){return cont([0, a]);});
		               }
		               var
		                fragment =
		                  caml_callback(symbol$64, [symbol_map$3(m$6, f$4), e]),
		                uri_reference =
		                  symbol$60
		                   (lift4
		                     (function(scheme, param, path, query, fragment, cont){
		                       var port = param[3], host = param[2], userinfo = param[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (normalize,
		                                scheme,
		                                [0, scheme, userinfo, host, port, path, query, fragment],
		                                cont);
		                      },
		                      scheme$0,
		                      authority,
		                      path$2,
		                      query$0),
		                    fragment),
		                uri_reference$0 =
		                  symbol_map$3
		                   (take_while
		                     (function(param, cont){
		                       return 10 === param ? cont(0) : cont(1);
		                      }),
		                    function(s, cont){
		                     return caml_exact_trampoline_cps_call$0
		                             (parse_string,
		                              1,
		                              uri_reference,
		                              s,
		                              function(match){
		                               if(0 !== match[0]) return cont(empty$13);
		                               var t = match[1];
		                               return cont(t);
		                              });
		                    });
		               function decode_host(host, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         host$0,
		                         host,
		                         function(match){
		                          if(0 !== match[0])
		                           return caml_exact_trampoline_cps_call$0
		                                   (parse_string,
		                                    1,
		                                    ipv6,
		                                    host,
		                                    function(match){
		                                     if(0 !== match[0]) return cont([0, 803994504, host]);
		                                     var parsed = match[1];
		                                     return cont([0, 267950263, parsed]);
		                                    });
		                          var parsed = match[1];
		                          return cont(parsed);
		                         });
		               }
		               function make$3
		               (scheme,
		                userinfo,
		                host,
		                port,
		                path,
		                query,
		                fragment,
		                param,
		                cont){
		                function decode(param){
		                 if(! param) return 0;
		                 var x = param[1];
		                 return [0, x];
		                }
		                var host$0 = host || (port ? br : userinfo ? br : host);
		                function a(userinfo){
		                 function a(path){
		                  if(query)
		                   var p = query[1], query$0 = [0, p];
		                  else
		                   query$0 = i9;
		                  var scheme$0 = decode(scheme), b = decode(fragment);
		                  function a(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (normalize,
		                            scheme$0,
		                            [0, scheme$0, userinfo, a, port, path, query$0, b],
		                            cont);
		                  }
		                  if(! host$0) return a(0);
		                  var host = host$0[1];
		                  return caml_exact_trampoline_cps_call
		                          (decode_host, host, function(b){return a([0, b]);});
		                 }
		                 if(! path) return a(0);
		                 var p = path[1];
		                 return caml_exact_trampoline_cps_call
		                         (path_of_encoded,
		                          p,
		                          function(path){
		                           return host$0
		                                   ? path
		                                     ? path[1] !== cst$34 ? a([0, cst$34, path]) : a(path)
		                                     : a(path)
		                                   : a(path);
		                          });
		                }
		                if(! userinfo) return a(0);
		                var u = userinfo[1];
		                return caml_exact_trampoline_cps_call
		                        (userinfo_of_encoded, u, function(b){return a([0, b]);});
		               }
		               function with_host(uri, host, cont){
		                var b = uri[7], c = uri[6], d = uri[5], e = uri[4];
		                function a(a){
		                 return cont([0, uri[1], uri[2], a, e, d, c, b]);
		                }
		                if(! host) return a(0);
		                var host$0 = host[1];
		                return caml_exact_trampoline_cps_call
		                        (decode_host, host$0, function(b){return a([0, b]);});
		               }
		               function of_string$8(s, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         0,
		                         uri_reference$0,
		                         s,
		                         function(match){
		                          if(0 !== match[0]) return cont(empty$13);
		                          var t = match[1];
		                          return cont(t);
		                         });
		               }
		               function pp_decoding(formatter, param, cont){
		                var
		                 reason = param[3],
		                 schema = param[2],
		                 path = param[1],
		                 path$0 = path ? [0, rev(path)] : 0,
		                 pp_v1 =
		                   list
		                    ([0,
		                      function(ppf, param, cont){
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_print_char, ppf, 46, cont);
		                      }],
		                     pp_print_string);
		                function a(ppf, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_none, ppf, dummy, cont);
		                 var v = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          ppf,
		                          "schema ",
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    ppf,
		                                    v,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, ppf, cst$9, cont);
		                                    });
		                          });
		                }
		                function b(ppf, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_none, ppf, dummy, cont);
		                 var v = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          ppf,
		                          "path ",
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_v1,
		                                    ppf,
		                                    v,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, ppf, cst$9, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(formatter),
		                         i_,
		                         function(c){
		                          return caml_trampoline_cps_call6
		                                  (c, b, path$0, a, schema, reason, cont);
		                         });
		               }
		               function compare$26(b, a, cont){
		                return cont(caml_compare(b, a));
		               }
		               function sexp_of_t$22(param, cont){return cont(i$);}
		               var
		                include$22 = Make$2([0, compare$26, sexp_of_t$22]),
		                comparator$8 = include$22[16],
		                empty$14 = empty$11([0, comparator$8]);
		               function singleton$4(key, value){
		                return singleton$3([0, comparator$8], key)(value);
		               }
		               function union$1(l, r, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (merge_skewed$0,
		                         l,
		                         r,
		                         function(param, left, right, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (less_than,
		                                   left,
		                                   right,
		                                   function(a){return a ? cont(right) : cont(left);});
		                         },
		                         cont);
		               }
		               function with_version(library, version, versions, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (update$0,
		                         versions,
		                         library,
		                         function(param, cont){
		                          function a(){return cont(version);}
		                          if(! param) return a();
		                          var previous_version = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (less_than,
		                                   previous_version,
		                                   version,
		                                   function(b){return b ? a() : cont(previous_version);});
		                         },
		                         cont);
		               }
		               var and$0 = Let_syntax$0[4][4];
		               function is_optional(param){
		                if(typeof param === "number" && 3 <= param) return 1;
		                return 0;
		               }
		               function map$14(decode, encode, param){
		                var
		                 descriptor = param[3],
		                 documentation = param[2],
		                 id = param[1];
		                return [0,
		                        id,
		                        documentation,
		                        [4, decode, encode, descriptor],
		                        0];
		               }
		               var Marks = u([0, compare$4]);
		               function pp_container(opt, indent, pp_content){
		                var
		                 delimiters = opt ? opt[1] : jb,
		                 outro = delimiters[2],
		                 intro = delimiters[1];
		                return function(state, v, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (pp_open_box_gen,
		                          state,
		                          0,
		                          2,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    state,
		                                    intro,
		                                    function(a){
		                                     pp_print_custom_break(state, ja, [0, cst$1, indent, cst$1]);
		                                     return caml_exact_trampoline_cps_call$2
		     (hvbox,
		      0,
		      pp_content,
		      state,
		      v,
		      function(a){
		       pp_v1(state);
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                state,
		                outro,
		                function(a){return cont(pp_close_box(state));});
		      });
		                                    });
		                          });};
		               }
		               function pp_container$0(delimiters, opt, indent, pp_item){
		                var sep = comma, a = [0, indent];
		                return pp_container
		                        (delimiters,
		                         indent,
		                         seq
		                          ([0, sep],
		                           function(b, c, cont){
		                            return caml_exact_trampoline_cps_call$2
		                                    (box$0, a, pp_item, b, c, cont);
		                           }));
		               }
		               var
		                cst_Any = "Any",
		                cst_Bool = "Bool",
		                cst_Date = "Date",
		                cst_Float = "Float",
		                cst_Ignore = "Ignore",
		                cst_Int = "Int",
		                cst_Json = "Json",
		                cst_Null = "Null",
		                cst_Time = "Time",
		                letrec_function_context$0 = [];
		               function pp_descriptor(marks, f, d, cont){
		                function a(fmt){
		                 return caml_exact_trampoline_cps_call$1(fmt, f, dummy, cont);
		                }
		                if(typeof d === "number")
		                 switch(d){
		                   case 0:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Bool, cont);
		                             });
		                   case 1:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Date, cont);
		                             });
		                   case 2:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Float, cont);
		                             });
		                   case 3:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Ignore, cont);
		                             });
		                   case 4:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Int, cont);
		                             });
		                   case 5:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, "Int64", cont);
		                             });
		                   case 6:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Json, cont);
		                             });
		                   case 7:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Null, cont);
		                             });
		                   case 8:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_String, cont);
		                             });
		                   case 9:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, cst_Time, cont);
		                             });
		                   default:
		                    return a
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, ppf, "Time_local", cont);
		                             });
		                 }
		                switch(d[0]){
		                  case 0:
		                   return a
		                           (function(ppf, param, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string, ppf, cst_Any, cont);
		                            });
		                  case 1:
		                   var f$0 = d[1];
		                   return caml_trampoline_cps_call2
		                           (f$0,
		                            0,
		                            function(v){
		                             return a
		                                     (function(ppf, param, cont){
		                                       return caml_exact_trampoline_cps_call$0
		       (pp_descriptor, marks, ppf, v, cont);
		                                      });
		                            });
		                  case 2:
		                   var
		                    s = d[1],
		                    b = caml_obj_tag(s),
		                    c =
		                      function(v){
		                       return a
		                               (function(ppf, param, cont){
		                                 return caml_exact_trampoline_cps_call$0
		 (pp_descriptor, marks, ppf, v, cont);
		                                });
		                      };
		                   if(250 === b) return c(s[1]);
		                   if(246 !== b && 244 !== b) return c(s);
		                   return caml_exact_trampoline_cps_call
		                           (force_lazy_block, s, c);
		                  case 3:
		                   var schema = d[1], e = letrec_function_context$0[1];
		                   return a
		                           (function(ppf, v, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_open_box,
		                                      ppf,
		                                      e,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_print_string,
		        ppf,
		        cst$37,
		        function(a){
		         pp_v1(ppf);
		         return caml_exact_trampoline_cps_call$1
		                 (pp_open_box,
		                  ppf,
		                  0,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (pp$6,
		                            marks,
		                            ppf,
		                            schema,
		                            function(a){
		                             pp_close_box(ppf);
		                             pp_v1(ppf);
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string,
		                                      ppf,
		                                      cst$36,
		                                      function(a){return cont(pp_close_box(ppf));});
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 4:
		                   var descriptor = d[3];
		                   return a
		                           (function(ppf, param, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (pp_descriptor, marks, ppf, descriptor, cont);
		                            });
		                  case 5:
		                   var item = d[3];
		                   return a
		                           (function(ppf, param, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (pp$6, marks, ppf, item, cont);
		                            });
		                  case 6:
		                   var s$0 = d[1];
		                   return a
		                           (function(ppf, v, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string,
		                                      ppf,
		                                      "Nullable (",
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (pp$6,
		        marks,
		        ppf,
		        s$0,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string, ppf, cst$18, cont);
		        });
		                                      });
		                            });
		                  case 7:
		                   var
		                    fields = d[3],
		                    pp_field =
		                      function(fmt, a, cont){
		                       a = a[1];
		                       var
		                        schema = a[8],
		                        requirement = a[7],
		                        name = a[5],
		                        schema$0 = schema[1];
		                       function b(a, b, cont){
		                        return caml_exact_trampoline_cps_call$0
		                                (pp$6, marks, a, b, cont);
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (fprintf$0(fmt),
		                                jc,
		                                function(a){
		                                 return caml_trampoline_cps_call6
		 (a, name, pp_requirement, requirement, b, schema$0, cont);
		                                });
		                      },
		                    unfold$0 =
		                      function(a){
		                       a = a[1];
		                       if(! a) return 0;
		                       var rest = a[2], field = a[1];
		                       return [0, [0, [0, field], [0, rest]]];
		                      },
		                    g = [0, fields],
		                    fields$0 =
		                      function(a, cont){return cont(unfold(unfold$0, g));},
		                    pp_v =
		                      pp_container$0(0, 0, letrec_function_context$0[1], pp_field);
		                   return a
		                           (function(ppf, param, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_v, ppf, fields$0, cont);
		                            });
		                  case 8:
		                   var item$0 = d[3], h = letrec_function_context$0[1];
		                   return a
		                           (function(ppf, v, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_open_box,
		                                      ppf,
		                                      h,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_print_string,
		        ppf,
		        cst$37,
		        function(a){
		         pp_v1(ppf);
		         return caml_exact_trampoline_cps_call$1
		                 (pp_open_box,
		                  ppf,
		                  0,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (pp$6,
		                            marks,
		                            ppf,
		                            item$0,
		                            function(a){
		                             pp_close_box(ppf);
		                             pp_v1(ppf);
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string,
		                                      ppf,
		                                      cst$36,
		                                      function(a){return cont(pp_close_box(ppf));});
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 9:
		                   var v = d[1];
		                   return a
		                           (function(ppf, param, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (string$1, ppf, v, cont);
		                            });
		                  case 10:
		                   var items = d[3], i = letrec_function_context$0[1];
		                   return a
		                           (function(state, v, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_open_box,
		                                      state,
		                                      0,
		                                      function(a){
		                                       return function(indent){
		        return caml_exact_trampoline_cps_call$0
		                (pp_open_box_gen,
		                 state,
		                 indent,
		                 2,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           state,
		                           cst$37,
		                           function(a){
		                            pp_v1(state);
		                            return caml_exact_trampoline_cps_call$0
		                                    (pp_open_box_gen,
		                                     state,
		                                     0,
		                                     2,
		                                     function(b){
		                                      function a(param){
		                                       if(param){
		var rest = param[2], schema = param[1];
		return caml_exact_trampoline_cps_call$0
		        (pp$6,
		         marks,
		         state,
		         schema,
		         function(b){
		          return caml_exact_trampoline_cps_call$1
		                  (comma,
		                   state,
		                   dummy,
		                   function(b){return caml_exact_trampoline_call1(a, rest);});
		         });
		                                       }
		                                       pp_close_box(state);
		                                       pp_close_box(state);
		                                       pp_v1(state);
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_print_string,
		        state,
		        cst$36,
		        function(a){return cont(pp_close_box(state));});
		                                      }
		                                      return a(items);
		                                     });
		                           });
		                 });
		       }
		       (i);
		                                      });
		                            });
		                  case 11:
		                   var cases = d[2], v$0 = to_seq(cases);
		                   return caml_trampoline_cps_call2
		                           (letrec_function_context$0[2],
		                            marks,
		                            function(b){
		                             var
		                              pp_v =
		                                pp_container$0(jd, 0, letrec_function_context$0[1], b);
		                             return a
		                                     (function(ppf, param, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_v, ppf, v$0, cont);
		                                      });
		                            });
		                  default:
		                   var descriptor$0 = d[1];
		                   return a
		                           (function(ppf, param, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (pp_descriptor, marks, ppf, descriptor$0, cont);
		                            });
		                }
		               }
		               var cst_Computed = "Computed", cst_Default = "Default";
		               function pp_requirement(f, param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, f, cst_Computed, cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, f, "Computed_optional", cont);
		                   case 2:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, f, "Required", cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, f, "Optional", cont);
		                 }
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, f, cst_Default, cont);
		               }
		               function pp$6(marks, f, param, cont){
		                var descriptor = param[3], id = param[1];
		                if(! id)
		                 return caml_exact_trampoline_cps_call$0
		                         (pp_descriptor, marks, f, descriptor, cont);
		                var id$0 = id[1];
		                return caml_exact_trampoline_cps_call$1
		                        (Marks[31],
		                         id$0,
		                         marks,
		                         function(a){
		                          return a
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (fmt$0,
		                                     je,
		                                     f,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(a, id$0, cont);
		                                     })
		                                  : caml_exact_trampoline_cps_call$1
		                                    (Marks[2],
		                                     id$0,
		                                     marks,
		                                     function(marks){
		                                      function a(a, b, cont){
		                                       return caml_exact_trampoline_cps_call$0
		       (pp_descriptor, marks, a, b, cont);
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (fmt$0,
		       jf,
		       f,
		       function(b){
		        return caml_trampoline_cps_call4
		                (b, id$0, a, descriptor, cont);
		       });
		                                     });
		                         });
		               }
		               var indent = 2;
		               function pp_case(marks, ppf, param, cont){
		                var
		                 since = param[8],
		                 schema = param[7],
		                 name = param[5],
		                 pp_v =
		                   pp_container
		                    (0,
		                     indent,
		                     function(ppf, v, cont){
		                      var param = v[1];
		                      function a(a){
		                       var v$0 = v[2];
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_open_box,
		                                ppf,
		                                indent,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (pp_print_string,
		  ppf,
		  cst_schema,
		  function(a){
		   pp_v1(ppf);
		   return caml_exact_trampoline_cps_call$0
		           (pp$6,
		            marks,
		            ppf,
		            v$0,
		            function(a){return cont(pp_close_box(ppf));});
		  });
		                                });
		                      }
		                      if(! param) return a();
		                      var v$0 = param[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (pp_print_string,
		                               ppf,
		                               "since: ",
		                               function(b){
		                                return caml_exact_trampoline_cps_call$1
		(pp$5,
		 ppf,
		 v$0[1],
		 function(b){
		  return caml_exact_trampoline_cps_call$1(comma, ppf, v$0, a);
		 });
		                               });
		                     }),
		                 v = [0, since, schema];
		                return caml_exact_trampoline_cps_call$1
		                        (string$1,
		                         ppf,
		                         name,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_char,
		                                   ppf,
		                                   58,
		                                   function(a){
		                                    pp_v1(ppf);
		                                    return caml_exact_trampoline_cps_call$1(pp_v, ppf, v, cont);
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$0, [0, indent, pp_case]);
		               function pp$7(schema, cont){
		                var a = Marks[1];
		                return cont
		                        (function(b, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (pp$6, a, schema, b, cont);
		                         });
		               }
		               function pp_descriptor$0(descriptor, cont){
		                var a = Marks[1];
		                return cont
		                        (function(b, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (pp_descriptor, a, descriptor, b, cont);
		                         });
		               }
		               function field_ignored(param){
		                var a = param[8];
		                switch(a[0]){
		                  case 0:
		                   a = a[1][3];
		                   if(typeof a === "number" && 3 === a) return 1;
		                   break;
		                  case 1:
		                   a = a[1][3];
		                   if(typeof a === "number" && 3 === a) return 1;
		                   break;
		                  default:
		                   a = a[1][3]; if(typeof a === "number" && 3 === a) return 1;
		                }
		                var omit = param[6];
		                return omit;
		               }
		               function flatten$0(descriptor, cont){
		                function a(descriptor){
		                 if(typeof descriptor !== "number")
		                  switch(descriptor[0]){
		                    case 2:
		                     var
		                      descriptor$0 = descriptor[1],
		                      b = caml_obj_tag(descriptor$0);
		                     if(250 === b)
		                      return caml_exact_trampoline_call1(a, descriptor$0[1]);
		                     if(246 !== b && 244 !== b)
		                      return caml_exact_trampoline_call1(a, descriptor$0);
		                     return caml_exact_trampoline_cps_call
		                             (force_lazy_block, descriptor$0, a);
		                    case 4:
		                     var
		                      descriptor$1 = descriptor[3],
		                      encode = descriptor[2],
		                      decode = descriptor[1];
		                     return caml_exact_trampoline_cps_call
		                             (flatten$0,
		                              descriptor$1,
		                              function(match){
		                               var
		                                d_encode = match[3],
		                                d_decode = match[2],
		                                descriptor = match[1];
		                               function decode$0(v, cont){
		                                return caml_exact_trampoline_cps_call
		(d_decode,
		 v,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (symbol_bind$1, a, decode, cont);
		 });
		                               }
		                               function encode$0(v, cont){
		                                return caml_trampoline_cps_call2
		(encode,
		 v,
		 function(a){
		  return caml_exact_trampoline_cps_call(d_encode, a, cont);
		 });
		                               }
		                               return cont([0, descriptor, decode$0, encode$0]);
		                              });
		                    case 12:
		                     var descriptor$2 = descriptor[1];
		                     return caml_exact_trampoline_call1(a, descriptor$2);
		                  }
		                 return cont
		                         ([0,
		                           descriptor,
		                           of_string$0,
		                           function(a, cont){return cont(a);}]);
		                }
		                return a(descriptor);
		               }
		               function compare$27(schema, cont){
		                function compare_json(l, r, cont){
		                 if(typeof l === "number"){
		                  if(typeof r === "number" && 870828711 === r) return cont(0);
		                  return cont(-1);
		                 }
		                 var a = l[1];
		                 if(65 === a){
		                  if(typeof r !== "number"){
		                   var variant$6 = r[1];
		                   if(65 === variant$6){
		                    var r$0 = r[2], l$0 = l[2];
		                    return caml_exact_trampoline_cps_call$0
		                            (compare_list, compare_json, l$0, r$0, cont);
		                   }
		                  }
		                 }
		                 else
		                  if(365180284 <= a){
		                   if(737456202 <= a){
		                    if(typeof r !== "number"){
		                     var variant$7 = r[1];
		                     if(737456202 === variant$7){
		                      var r$1 = r[2], l$1 = l[2];
		                      return cont(caml_int_compare(l$1, r$1));
		                     }
		                    }
		                   }
		                   else if(typeof r !== "number"){
		                    var variant$8 = r[1];
		                    if(365180284 === variant$8){
		                     var r$2 = r[2], l$2 = l[2];
		                     return cont(caml_float_compare(l$2, r$2));
		                    }
		                   }
		                  }
		                  else
		                   if(79 <= a){
		                    if(typeof r !== "number"){
		                     var variant$9 = r[1];
		                     if(79 === variant$9){
		                      var
		                       r$3 = r[2],
		                       l$3 = l[2],
		                       b =
		                         function(param){
		                          function a(a){return cont(value$4(a, 0));}
		                          if(! param) return a(0);
		                          var l = param[2], x = param[1], l$0 = x[2], key = x[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (find$1,
		                                   r$3,
		                                   equal$4,
		                                   key,
		                                   function(match){
		                                    function c(r){
		                                     return r ? a(r) : caml_exact_trampoline_call1(b, l);
		                                    }
		                                    if(! match) return c(jg);
		                                    var r = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (compare_json,
		     l$0,
		     r,
		     function(v){return 0 === v ? c(0) : c([0, v]);});
		                                   });
		                         };
		                      return b(l$3);
		                     }
		                    }
		                   }
		                   else if(typeof r !== "number"){
		                    var variant$10 = r[1];
		                    if(-976970511 === variant$10){
		                     var r$4 = r[2], l$4 = l[2];
		                     return cont(caml_string_compare(l$4, r$4));
		                    }
		                   }
		                 if(typeof r === "number" && 870828711 === r) return cont(1);
		                 if(typeof l !== "number"){
		                  var variant$5 = l[1];
		                  if(737456202 === variant$5) return cont(-1);
		                 }
		                 if(typeof r !== "number"){
		                  var variant$4 = r[1];
		                  if(737456202 === variant$4) return cont(1);
		                 }
		                 if(typeof l !== "number"){
		                  var variant$3 = l[1];
		                  if(365180284 === variant$3) return cont(-1);
		                 }
		                 if(typeof r !== "number"){
		                  var variant$2 = r[1];
		                  if(365180284 === variant$2) return cont(1);
		                 }
		                 if(typeof l !== "number"){
		                  var variant$1 = l[1];
		                  if(-976970511 === variant$1) return cont(-1);
		                 }
		                 if(typeof r !== "number"){
		                  var variant$0 = r[1];
		                  if(-976970511 === variant$0) return cont(1);
		                 }
		                 if(typeof l !== "number"){
		                  var variant = l[1];
		                  if(65 === variant) return cont(-1);
		                 }
		                 return cont(1);
		                }
		                function compare(param, cont){
		                 function a(b){
		                  if(typeof b === "number")
		                   switch(b){
		                     case 0:
		                      return cont(compare$2);
		                     case 1:
		                      return cont
		                              (function(b, a, cont){return cont(caml_compare(b, a));});
		                     case 2:
		                      return cont
		                              (function(b, a, cont){
		                                return cont(caml_float_compare(b, a));
		                               });
		                     case 3:
		                      return cont
		                              (function(b, a, cont){return cont(caml_int_compare(b, a));});
		                     case 6:
		                      return cont(compare_json);
		                     case 7:
		                      return cont(function(a, param, cont){return cont(0);});
		                     case 8:
		                      return cont(compare$4);
		                     case 9:
		                      return cont(compare$23);
		                     case 10:
		                      return cont
		                              (function(a, param, cont){
		                                var
		                                 rz = param[2],
		                                 r = param[1],
		                                 lz = a[2],
		                                 l = a[1],
		                                 v = caml_int_compare(lz, rz);
		                                return 0 === v
		? caml_exact_trampoline_cps_call$1(compare$23, l, r, cont)
		: cont(v);
		                               });
		                     default:
		                      return cont
		                              (function(b, a, cont){return cont(caml_compare(b, a));});
		                   }
		                  switch(b[0]){
		                    case 0:
		                     var Coding = b[1]; return cont(Coding[3]);
		                    case 1:
		                     var f = b[1]; return caml_trampoline_cps_call2(f, 0, a);
		                    case 2:
		                     var s = b[1], b = caml_obj_tag(s);
		                     if(250 === b) return caml_exact_trampoline_call1(a, s[1]);
		                     if(246 !== b && 244 !== b)
		                      return caml_exact_trampoline_call1(a, s);
		                     return caml_exact_trampoline_cps_call
		                             (force_lazy_block, s, a);
		                    case 3:
		                     var schema = b[1];
		                     return caml_exact_trampoline_cps_call
		                             (compare,
		                              schema[3],
		                              function(a){
		                               return cont
		                                       (function(b, c, cont){
		 return caml_exact_trampoline_cps_call$0
		         (compare_list, a, b, c, cont);
		});
		                              });
		                    case 4:
		                     var descriptor = b[3], encode = b[2];
		                     return cont
		                             (function(l, r, cont){
		                               return caml_trampoline_cps_call2
		                                       (encode,
		r,
		function(a){
		 return caml_trampoline_cps_call2
		         (encode,
		          l,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (compare,
		                    descriptor,
		                    function(c){
		                     return caml_trampoline_cps_call3(c, b, a, cont);
		                    });
		          });
		});
		                              });
		                    case 5:
		                     var item = b[3], deconstruct = b[2];
		                     return cont
		                             (function(l, r, cont){
		                               function compare_field(a, param, cont){
		                                var
		                                 value_r = param[2],
		                                 key_r = param[1],
		                                 value_l = a[2],
		                                 key_l = a[1],
		                                 n = caml_string_compare(key_l, key_r);
		                                return 0 === n
		? caml_exact_trampoline_cps_call
		  (compare,
		   item[3],
		   function(a){
		    return caml_trampoline_cps_call3(a, value_l, value_r, cont);
		   })
		: cont(n);
		                               }
		                               return caml_trampoline_cps_call2
		                                       (deconstruct,
		r,
		function(a){
		 return caml_trampoline_cps_call2
		         (deconstruct,
		          l,
		          function(b){
		           return caml_exact_trampoline_cps_call$0
		                   (compare$9, compare_field, b, a, cont);
		          });
		});
		                              });
		                    case 6:
		                     var s$0 = b[1];
		                     return cont
		                             (function(l, r, cont){
		                               return caml_exact_trampoline_cps_call
		                                       (compare,
		s$0[3],
		function(a){
		 return caml_exact_trampoline_cps_call$0
		         (compare_option, a, l, r, cont);
		});
		                              });
		                    case 7:
		                     var
		                      fields = b[3],
		                      encode$0 = b[2],
		                      compare_fields =
		                        function(a){
		                         if(! a) return function(a, param, cont){return cont(0);};
		                         var
		                          rest = a[2],
		                          a = a[1],
		                          schema = a[8],
		                          requirement = a[7],
		                          schema$0 = schema[1];
		                         return function(b, param, cont){
		                          var rr = param[2], r = param[1], lr = b[2], l = b[1];
		                          function a(c){
		                           return 0 === c
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (compare_fields(rest), lr, rr, cont)
		                                   : cont(c);
		                          }
		                          if(typeof requirement === "number")
		                           switch(requirement){
		                             case 0:
		                              return caml_exact_trampoline_cps_call
		                                      (compare,
		                                       schema$0[3],
		                                       function(b){
		return caml_exact_trampoline_cps_call$0
		        (compare_option, b, l, r, a);
		                                       });
		                             case 1:
		                              return caml_exact_trampoline_cps_call
		                                      (compare,
		                                       schema$0[3],
		                                       function(c){
		if(! l) return r ? a(-1) : a(0);
		var a$0 = l[1];
		if(! r) return a(1);
		var b = r[1];
		return caml_exact_trampoline_cps_call$0
		        (compare_option, c, a$0, b, a);
		                                       });
		                             case 2:
		                              return caml_exact_trampoline_cps_call
		                                      (compare,
		                                       schema$0[3],
		                                       function(b){return caml_trampoline_cps_call3(b, l, r, a);});
		                             default:
		                              return caml_exact_trampoline_cps_call
		                                      (compare,
		                                       schema$0[3],
		                                       function(b){
		return caml_exact_trampoline_cps_call$0
		        (compare_option, b, l, r, a);
		                                       });
		                           }
		                          return caml_exact_trampoline_cps_call
		                                  (compare,
		                                   schema$0[3],
		                                   function(b){return caml_trampoline_cps_call3(b, l, r, a);});};
		                        },
		                      compare_items = compare_fields(fields);
		                     return cont
		                             (function(l, r, cont){
		                               return caml_trampoline_cps_call2
		                                       (encode$0,
		r,
		function(a){
		 return caml_trampoline_cps_call2
		         (encode$0,
		          l,
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (compare_items, b, a, cont);
		          });
		});
		                              });
		                    case 8:
		                     var item$0 = b[3], deconstruct$0 = b[2];
		                     return cont
		                             (function(l, r, cont){
		                               return caml_trampoline_cps_call2
		                                       (deconstruct$0,
		r,
		function(a){
		 return caml_trampoline_cps_call2
		         (deconstruct$0,
		          l,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (compare,
		                    item$0[3],
		                    function(c){
		                     return caml_exact_trampoline_cps_call$0
		                             (compare$9, c, b, a, cont);
		                    });
		          });
		});
		                              });
		                    case 9:
		                     return cont(function(a, param, cont){return cont(0);});
		                    case 10:
		                     var
		                      items = b[3],
		                      encode$1 = b[2],
		                      compare_items$0 =
		                        function(param){
		                         if(! param)
		                          return function(a, param, cont){return cont(0);};
		                         var rest = param[2], schema = param[1];
		                         return function(a, param, cont){
		                          var rr = param[2], r = param[1], lr = a[2], l = a[1];
		                          return caml_exact_trampoline_cps_call
		                                  (compare,
		                                   schema[3],
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (a,
		     l,
		     r,
		     function(v){
		      return 0 === v
		              ? caml_exact_trampoline_cps_call$1
		                (compare_items$0(rest), lr, rr, cont)
		              : cont(v);
		     });
		                                   });};
		                        },
		                      compare_items$1 = compare_items$0(items);
		                     return cont
		                             (function(l, r, cont){
		                               return caml_trampoline_cps_call2
		                                       (encode$1,
		r,
		function(a){
		 return caml_trampoline_cps_call2
		         (encode$1,
		          l,
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (compare_items$1, b, a, cont);
		          });
		});
		                              });
		                    case 11:
		                     var cases = b[2];
		                     return cont
		                             (function(l, r, cont){
		                               function a(param){
		                                function b(a){return cont(value$4(a, 0));}
		                                if(! param) return b(0);
		                                var
		                                 l$0 = param[2],
		                                 x = param[1],
		                                 schema = x[7],
		                                 encoder = x[2];
		                                return caml_trampoline_cps_call2
		(encoder,
		 l,
		 function(match){
		  return caml_trampoline_cps_call2
		          (encoder,
		           r,
		           function(match$0){
		            function c(r){
		             return r ? b(r) : caml_exact_trampoline_call1(a, l$0);
		            }
		            if(! match) return match$0 ? c(ji) : c(0);
		            var l = match[1];
		            if(! match$0) return c(jh);
		            var r = match$0[1];
		            return caml_exact_trampoline_cps_call
		                    (compare,
		                     schema[3],
		                     function(a){
		                      return caml_trampoline_cps_call3
		                              (a, l, r, function(a){return c([0, a]);});
		                     });
		           });
		 });
		                               }
		                               return a(cases);
		                              });
		                    default:
		                     var descriptor$0 = b[1];
		                     return caml_exact_trampoline_call1(a, descriptor$0);
		                  }
		                 }
		                 return a(param);
		                }
		                return caml_exact_trampoline_cps_call
		                        (compare, schema[3], cont);
		               }
		               function Make_inline(M){
		                var let$ = M[11][3], and = M[11][4][4];
		                function inline_try(inline, outline, param, cont){
		                 switch(param[0]){
		                   case 0:
		                    return caml_exact_trampoline_cps_call(outline, dummy, cont);
		                   case 1:
		                    var schema = param[1];
		                    return caml_exact_trampoline_cps_call(inline, schema, cont);
		                   default:
		                    var schema$0 = param[1];
		                    return caml_exact_trampoline_cps_call
		                            (inline,
		                             schema$0,
		                             function(ok){
		                              return 0 === ok[0]
		                                      ? cont(ok)
		                                      : caml_exact_trampoline_cps_call(outline, schema$0, cont);
		                             });
		                 }
		                }
		                function schema(desc, f, cont){
		                 function inline(d, req, f, cont){
		                  function a(d, req){
		                   if(typeof d === "number"){
		                    if(3 === d)
		                     return caml_trampoline_cps_call2
		                             (M[5],
		                              jj,
		                              function(a){
		                               return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                              });
		                   }
		                   else
		                    switch(d[0]){
		                      case 2:
		                       var d$0 = d[1], b = caml_obj_tag(d$0);
		                       if(250 === b)
		                        return caml_exact_trampoline_call2(a, d$0[1], req);
		                       if(246 !== b && 244 !== b)
		                        return caml_exact_trampoline_call2(a, d$0, req);
		                       return caml_exact_trampoline_cps_call
		                               (force_lazy_block,
		                                d$0,
		                                function(b){return caml_exact_trampoline_call2(a, b, req);});
		                      case 4:
		                       var descriptor = d[3], encode = d[2];
		                       if(typeof req === "number")
		                        switch(req){
		                          case 0:
		                           return caml_exact_trampoline_call2(a, descriptor, 0);
		                          case 1:
		                           return caml_exact_trampoline_call2(a, descriptor, 1);
		                          case 2:
		                           return caml_exact_trampoline_call2(a, descriptor, 2);
		                          default:
		                           return caml_exact_trampoline_call2(a, descriptor, 3);
		                        }
		                       var d$1 = req[1];
		                       return caml_trampoline_cps_call2
		                               (encode,
		                                d$1,
		                                function(b){
		                                 var req = [0, b];
		                                 return caml_exact_trampoline_call2(a, descriptor, req);
		                                });
		                      case 6:
		                       var d$2 = d[1], d$3 = d$2[3];
		                       return caml_exact_trampoline_call2(a, d$3, 3);
		                      case 7:
		                       var
		                        fields = d[3],
		                        encode$0 = d[2],
		                        inline_fields =
		                          function(req$0, a, cont){
		                           a:
		                           {
		                            var req = req$0;
		                            for(;;){
		                             if(! a) break;
		                             var field = a[1], rest = a[2];
		                             if(! field_ignored(field)) break a;
		                             if(typeof req === "number")
		                              switch(req){
		                                case 0:
		                                 req = 0; a = rest; break;
		                                case 1:
		                                 req = 1; a = rest; break;
		                                case 2:
		                                 req = 2; a = rest; break;
		                                default: req = 3; a = rest;
		                              }
		                             else {var tail = req[1][2]; req = [0, tail]; a = rest;}
		                            }
		                            return caml_trampoline_cps_call2
		                                    (M[5],
		                                     jl,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                                     });
		                           }
		                           var rest$0 = a[2];
		                           function outline(schema, cont){
		                            var match = field[7];
		                            function b(head, cont){return cont([0, [0, head, 0], 0]);}
		                            function a(a){
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      a,
		                                      b,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                                      });
		                            }
		                            a:
		                            if(typeof match === "number" && 2 === match){
		                             if(typeof req !== "number"){
		                              var head = req[1][1];
		                              return caml_trampoline_cps_call2
		                                      (f[1],
		                                       [0,
		field[1],
		field[2],
		field[3],
		field[4],
		field[5],
		field[6],
		[0, head],
		field[8],
		field[9],
		field[10]],
		                                       a);
		                             }
		                             if(req)
		                              switch(req - 1 | 0){
		                                case 0:
		                                 return caml_trampoline_cps_call2
		 (f[1],
		  [0,
		   field[1],
		   field[2],
		   field[3],
		   field[4],
		   field[5],
		   field[6],
		   req,
		   field[8],
		   field[9],
		   field[10]],
		  a);
		                                case 2: break;
		                                default: break a;
		                              }
		                             return caml_trampoline_cps_call2
		                                     (f[1],
		                                      [0,
		                                       field[1],
		                                       field[2],
		                                       field[3],
		                                       field[4],
		                                       field[5],
		                                       field[6],
		                                       req,
		                                       field[8],
		                                       field[9],
		                                       field[10]],
		                                      a);
		                            }
		                            return caml_trampoline_cps_call2(f[1], field, a);
		                           }
		                           function inline$0(schema, cont){
		                            function next(a, cont){
		                             a = field[7];
		                             a:
		                             if(typeof a === "number" && 2 === a){
		                              if(typeof req !== "number"){
		                               var head = req[1][1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (inline, schema[3], [0, head], f, cont);
		                              }
		                              if(req)
		                               switch(req - 1 | 0){
		                                 case 0:
		                                  return caml_exact_trampoline_cps_call$0
		  (inline, schema[3], 1, f, cont);
		                                 case 2: break;
		                                 default: break a;
		                               }
		                              return caml_exact_trampoline_cps_call$0
		                                      (inline, schema[3], req, f, cont);
		                             }
		                             return caml_exact_trampoline_cps_call$0
		                                     (inline, schema[3], field[7], f, cont);
		                            }
		                            var a = f[2];
		                            if(! a)
		                             return caml_exact_trampoline_cps_call(next, dummy, cont);
		                            var filter = a[1], a = filter(field);
		                            if(! a)
		                             return caml_exact_trampoline_cps_call(next, dummy, cont);
		                            var res = a[1];
		                            return caml_trampoline_cps_call3
		                                    (let$,
		                                     res,
		                                     function(res, cont){
		                                      return is_optional(field[7])
		      ? cont([0, [0, res, 0], jk])
		      : cont([0, [0, res, 0], 0]);
		                                     },
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (inline_try,
		                                    inline$0,
		                                    outline,
		                                    field[8],
		                                    function(left){
		                                     function a(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (and$0,
		       left,
		       a,
		       function(v){
		        if(0 !== v[0]) return cont(v);
		        var v$0 = v[1], tail = v$0[2], head = v$0[1];
		        function a(param, cont){
		         var tail = param[2], head = param[1];
		         return caml_exact_trampoline_cps_call
		                 (deconstruct,
		                  tail,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (deconstruct,
		                            head,
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (cartesian_product,
		                                      b,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (map$11,
		        a,
		        function(param, cont){
		         var t = param[2], h = param[1];
		         return caml_exact_trampoline_cps_call$1
		                 (append$0, h, t, cont);
		        },
		        function(a){
		         return caml_exact_trampoline_cps_call(to_binable, a, cont);
		        });
		                                      });
		                            });
		                  });
		        }
		        return caml_trampoline_cps_call3
		                (and,
		                 head,
		                 tail,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (let$, b, a, function(a){return cont([0, a]);});
		                 });
		       });
		                                     }
		                                     if(typeof req === "number")
		                                      switch(req){
		case 0:
		 return caml_exact_trampoline_cps_call$1
		         (inline_fields, 0, rest$0, a);
		case 1:
		 return caml_exact_trampoline_cps_call$1
		         (inline_fields, 1, rest$0, a);
		case 2:
		 return caml_exact_trampoline_cps_call$1
		         (inline_fields, 2, rest$0, a);
		default:
		 return caml_exact_trampoline_cps_call$1
		         (inline_fields, 3, rest$0, a);
		                                      }
		                                     var tail = req[1][2];
		                                     return caml_exact_trampoline_cps_call$1
		     (inline_fields, [0, tail], rest$0, a);
		                                    });
		                          };
		                       if(typeof req === "number")
		                        switch(req){
		                          case 0:
		                           return caml_exact_trampoline_cps_call$1
		                                   (inline_fields, 0, fields, cont);
		                          case 1:
		                           return caml_exact_trampoline_cps_call$1
		                                   (inline_fields, 1, fields, cont);
		                          case 2:
		                           return caml_exact_trampoline_cps_call$1
		                                   (inline_fields, 2, fields, cont);
		                          default:
		                           return caml_exact_trampoline_cps_call$1
		                                   (inline_fields, 3, fields, cont);
		                        }
		                       var v = req[1];
		                       return caml_trampoline_cps_call2
		                               (encode$0,
		                                v,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (inline_fields, [0, a], fields, cont);
		                                });
		                      case 11:
		                       var
		                        cases = d[2],
		                        key = d[1],
		                        f$0 =
		                          function(param, cont){
		                           var schema = param[7], name = param[5];
		                           function a(key){
		                            return caml_exact_trampoline_cps_call$0
		                                    (inline,
		                                     schema[3],
		                                     2,
		                                     f,
		                                     function(v){
		                                      if(0 !== v[0]) return cont(v);
		                                      var res = v[1];
		                                      function a(param, cont){
		                                       var res = param[2], key$0 = param[1];
		                                       if(! key$0) return cont(res);
		                                       var key = key$0[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (map$7,
		        res,
		        function(l, cont){return cont([0, key, l]);},
		        cont);
		                                      }
		                                      return caml_trampoline_cps_call3
		      (and,
		       key,
		       res,
		       function(b){
		        return caml_trampoline_cps_call3
		                (let$, b, a, function(a){return cont([0, a]);});
		       });
		                                     });
		                           }
		                           if(! key) return caml_trampoline_cps_call2(M[5], 0, a);
		                           var key$0 = key[1];
		                           return caml_trampoline_cps_call2
		                                   (f[1],
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     key$0,
		                                     0,
		                                     2,
		                                     [0, [0, 0, 0, [9, name], 0]],
		                                     0,
		                                     0],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(M[6], b, return$4, a);
		                                    });
		                          };
		                       return caml_exact_trampoline_cps_call$1
		                               (map$7,
		                                cases,
		                                f$0,
		                                function(res){
		                                 return caml_exact_trampoline_cps_call
		 (all$10,
		  res,
		  function(v){
		   if(0 !== v[0]) return cont(v);
		   var res = v[1];
		   function a(res, cont){
		    return caml_exact_trampoline_cps_call
		            (of_list,
		             res,
		             function(res){
		              return is_optional(req)
		                      ? caml_exact_trampoline_cps_call$1(append$0, res, jm, cont)
		                      : cont(res);
		             });
		   }
		   return caml_trampoline_cps_call2
		           (M[9],
		            res,
		            function(b){
		             return caml_trampoline_cps_call3
		                     (let$, b, a, function(a){return cont([0, a]);});
		            });
		  });
		                                });
		                      case 12:
		                       var descriptor$0 = d[1];
		                       return caml_exact_trampoline_call2(a, descriptor$0, req);
		                    }
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$4,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a, pp_descriptor$0, d, function(x){return cont([1, x]);});
		                            });
		                  }
		                  return a(d, req);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (inline, desc, 2, f, cont);
		                }
		                function value_versioned(f, fields, cont){
		                 function inline_field(field, cont){
		                  function outline(schema, cont){
		                   return caml_trampoline_cps_call2
		                           (f[1],
		                            field,
		                            function(f){
		                             var a = field[9];
		                             if(a){
		                              a = a[1];
		                              var
		                               library = a[2],
		                               version = a[1],
		                               version$0 = singleton$4(library, version);
		                             }
		                             else
		                              version$0 = empty$14;
		                             function with_version(f, v, version, cont){
		                              function a(res, cont){
		                               return cont([0, [0, res, 0], version]);
		                              }
		                              return caml_trampoline_cps_call2
		                                      (f,
		                                       v,
		                                       function(b){
		return caml_trampoline_cps_call3(let$, b, a, cont);
		                                       });
		                             }
		                             var a = field[7];
		                             if(typeof a === "number")
		                              switch(a){
		                                case 0:
		                                 var
		                                  b =
		                                    function(v, cont){
		                                     return v
		     ? caml_exact_trampoline_cps_call$0
		       (with_version, f, v, version$0, cont)
		     : caml_exact_trampoline_cps_call$0
		       (with_version, f, v, empty$14, cont);
		                                    };
		                                 break;
		                                case 1:
		                                 b =
		                                  function(v, cont){
		                                   if(v && v[1])
		                                    return caml_exact_trampoline_cps_call$0
		    (with_version, f, v, version$0, cont);
		                                   return caml_exact_trampoline_cps_call$0
		   (with_version, f, v, empty$14, cont);
		                                  };
		                                 break;
		                                case 2:
		                                 b =
		                                  function(v, cont){
		                                   return caml_exact_trampoline_cps_call$0
		   (with_version, f, v, version$0, cont);
		                                  };
		                                 break;
		                                default:
		                                 b =
		                                  function(v, cont){
		                                   return v
		   ? caml_exact_trampoline_cps_call$0
		     (with_version, f, v, version$0, cont)
		   : caml_exact_trampoline_cps_call$0
		     (with_version, f, v, empty$14, cont);
		                                  };
		                              }
		                             else
		                              var
		                               default$ = a[1],
		                               schema = field[8][1],
		                               b =
		                                 function(v, cont){
		                                  return caml_exact_trampoline_cps_call
		  (compare$27,
		   schema,
		   function(a){
		    return caml_trampoline_cps_call3
		            (a,
		             v,
		             default$,
		             function(a){
		              a = 0 === a ? empty$14 : version$0;
		              return caml_exact_trampoline_cps_call$0
		                      (with_version, f, v, a, cont);
		             });
		   });
		                                 };
		                             return caml_exact_trampoline_cps_call(of_string$0, b, cont);
		                            });
		                  }
		                  function inline(schema, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (inline_descriptor,
		                            field[5],
		                            schema[3],
		                            function(v){
		                             if(0 !== v[0]) return cont(v);
		                             var v$0 = v[1], a = field[7];
		                             if(typeof a === "number")
		                              switch(a){
		                                case 0:
		                                 a =
		                                  function(param, cont){
		                                   if(! param)
		                                    return caml_trampoline_cps_call2
		    (M[5], [0, 0, empty$14], cont);
		                                   var v = param[1];
		                                   return caml_trampoline_cps_call2(v$0, v, cont);
		                                  };
		                                 break;
		                                case 1:
		                                 a =
		                                  function(a, cont){
		                                   if(a){
		                                    a = a[1];
		                                    if(a){
		                                     var v = a[1];
		                                     return caml_trampoline_cps_call2(v$0, v, cont);
		                                    }
		                                   }
		                                   return caml_trampoline_cps_call2
		   (M[5], [0, 0, empty$14], cont);
		                                  };
		                                 break;
		                                case 3:
		                                 a =
		                                  function(param, cont){
		                                   if(! param)
		                                    return caml_trampoline_cps_call2
		    (M[5], [0, 0, empty$14], cont);
		                                   var v = param[1];
		                                   return caml_trampoline_cps_call2(v$0, v, cont);
		                                  };
		                                 break;
		                                default: a = v$0;
		                              }
		                             else
		                              a = v$0;
		                             return cont([0, a]);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (inline_try, inline, outline, field[8], cont);
		                 }
		                 function inline_fields(param, cont){
		                  if(! param)
		                   return caml_exact_trampoline_cps_call
		                           (of_string$0,
		                            function(param, cont){
		                             return caml_trampoline_cps_call2
		                                     (M[5], [0, 0, empty$14], cont);
		                            },
		                            cont);
		                  var rest = param[2], field = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (inline_fields,
		                           rest,
		                           function(r){
		                            if(0 !== r[0]) return cont(r);
		                            var tail = r[1];
		                            return field_ignored(field)
		                                    ? caml_exact_trampoline_cps_call
		                                      (of_string$0,
		                                       function(param, cont){
		var tl = param[2];
		return caml_trampoline_cps_call2(tail, tl, cont);
		                                       },
		                                       cont)
		                                    : caml_exact_trampoline_cps_call
		                                      (inline_field,
		                                       field,
		                                       function(v){
		if(0 !== v[0]) return cont(v);
		var head = v[1];
		return cont
		        ([0,
		          function(param, cont){
		           var tl = param[2], hd = param[1];
		           function a(a, cont){
		            var
		             b = a[2],
		             tail_version = b[2],
		             tail = b[1],
		             a = a[1],
		             head_version = a[2],
		             head = a[1];
		            return caml_exact_trampoline_cps_call$1
		                    (union$1,
		                     tail_version,
		                     head_version,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (append$0, head, tail, function(b){return cont([0, b, a]);});
		                     });
		           }
		           return caml_trampoline_cps_call2
		                   (head,
		                    hd,
		                    function(left){
		                     return caml_trampoline_cps_call2
		                             (tail,
		                              tl,
		                              function(b){
		                               return caml_trampoline_cps_call3
		                                       (and,
		left,
		b,
		function(b){
		 return caml_trampoline_cps_call3(let$, b, a, cont);
		});
		                              });
		                    });
		          }]);
		                                       });
		                           });
		                 }
		                 function inline_descriptor(field_name, s$0, cont){
		                  a:
		                  {
		                   b:
		                   {
		                    c:
		                    {
		                     d:
		                     {
		                      e:
		                      {
		                       f:
		                       {
		                        var s = s$0;
		                        g:
		                        for(;;){
		                         if(typeof s === "number") break b;
		                         switch(s[0]){
		                           case 2:
		                            break c;
		                           case 4:
		                            break d;
		                           case 6:
		                            break e;
		                           case 7:
		                            break f;
		                           case 11:
		                            break g;
		                           case 12:
		                            var descriptor$0 = s[1]; s = descriptor$0; break;
		                           default: break a;
		                         }
		                        }
		                        var
		                         cases = s[2],
		                         key = s[1],
		                         f$0 =
		                           function(param, cont){
		                            var
		                             since = param[8],
		                             schema = param[7],
		                             name = param[5],
		                             encoder = param[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (inline_descriptor,
		                                     field_name,
		                                     schema[3],
		                                     function(v){
		                                      if(0 !== v[0]) return cont(v);
		                                      var res = v[1];
		                                      function a(key){
		                                       return cont
		       ([0,
		         function(v, cont){
		          return caml_trampoline_cps_call2
		                  (encoder,
		                   v,
		                   function(match){
		                    if(! match) return cont(0);
		                    var v = match[1];
		                    function a(result){
		                     if(! since) return cont([0, result]);
		                     var
		                      match = since[1],
		                      library = match[2],
		                      version = match[1];
		                     return caml_trampoline_cps_call3
		                             (let$,
		                              result,
		                              function(param, cont){
		                               var versions = param[2], res = param[1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (with_version,
		library,
		version,
		versions,
		function(a){return cont([0, res, a]);});
		                              },
		                              function(a){return cont([0, a]);});
		                    }
		                    if(! key) return caml_trampoline_cps_call2(res, v, a);
		                    var key$0 = key[1];
		                    function b(param, cont){
		                     var
		                      match = param[2],
		                      versions = match[2],
		                      res = match[1],
		                      key = param[1];
		                     return cont([0, [0, key, res], versions]);
		                    }
		                    return caml_trampoline_cps_call2
		                            (key$0,
		                             0,
		                             function(left){
		                              return caml_trampoline_cps_call2
		                                      (res,
		                                       v,
		                                       function(c){
		return caml_trampoline_cps_call3
		        (and,
		         left,
		         c,
		         function(c){
		          return caml_trampoline_cps_call3(let$, c, b, a);
		         });
		                                       });
		                             });
		                   });
		         }]);
		                                      }
		                                      if(! key) return a(0);
		                                      var key$0 = key[1];
		                                      return caml_trampoline_cps_call2
		      (f[1],
		       [0,
		        0,
		        0,
		        0,
		        0,
		        key$0,
		        0,
		        2,
		        [0, [0, 0, 0, [9, name], 0]],
		        0,
		        0],
		       function(b){return a([0, b]);});
		                                     });
		                           };
		                        return caml_exact_trampoline_cps_call$1
		                                (map$7,
		                                 cases,
		                                 f$0,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (all$10,
		   a,
		   function(v){
		    if(0 !== v[0]) return cont(v);
		    var cases = v[1];
		    return cont
		            ([0,
		              function(v, cont){
		               function a(param){
		                function b(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (failwith, "no union cased matched in inline_f", cont);
		                 var case$ = match[1];
		                 return cont(case$);
		                }
		                if(! param) return b(0);
		                var l = param[2], case$ = param[1];
		                return caml_trampoline_cps_call2
		                        (case$,
		                         v,
		                         function(r){
		                          return r ? b(r) : caml_exact_trampoline_call1(a, l);
		                         });
		               }
		               return a(cases);
		              }]);
		   });
		                                 });
		                       }
		                       var fields = s[3], encode$0 = s[2];
		                       return caml_exact_trampoline_cps_call
		                               (inline_fields,
		                                fields,
		                                function(v){
		                                 if(0 !== v[0]) return cont(v);
		                                 var v$0 = v[1];
		                                 return cont
		 ([0,
		   function(v, cont){
		    return caml_trampoline_cps_call2
		            (encode$0,
		             v,
		             function(a){return caml_trampoline_cps_call2(v$0, a, cont);});
		   }]);
		                                });
		                      }
		                      var schema = s[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (inline_descriptor,
		                               field_name,
		                               schema[3],
		                               function(v){
		                                if(0 !== v[0]) return cont(v);
		                                var v$0 = v[1];
		                                return cont
		([0,
		  function(param, cont){
		   if(! param)
		    return caml_trampoline_cps_call2
		            (M[5], [0, 0, empty$14], cont);
		   var v = param[1];
		   return caml_trampoline_cps_call2(v$0, v, cont);
		  }]);
		                               });
		                     }
		                     var descriptor = s[3], encode = s[2];
		                     return caml_exact_trampoline_cps_call$1
		                             (inline_descriptor,
		                              field_name,
		                              descriptor,
		                              function(v){
		                               if(0 !== v[0]) return cont(v);
		                               var v$0 = v[1];
		                               return cont
		                                       ([0,
		 function(v, cont){
		  return caml_trampoline_cps_call2
		          (encode,
		           v,
		           function(a){return caml_trampoline_cps_call2(v$0, a, cont);});
		 }]);
		                              });
		                    }
		                    var d = s[1];
		                    return caml_exact_trampoline_cps_call
		                            (of_string$0,
		                             function(v, cont){
		                              var a = caml_obj_tag(d);
		                              function b(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (inline_descriptor,
		field_name,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (ok_or_failwith,
		          a,
		          function(a){return caml_trampoline_cps_call2(a, v, cont);});
		});
		                              }
		                              if(250 === a) return b(d[1]);
		                              if(246 !== a && 244 !== a) return b(d);
		                              return caml_exact_trampoline_cps_call
		                                      (force_lazy_block, d, b);
		                             },
		                             cont);
		                   }
		                   if(3 === s)
		                    return caml_exact_trampoline_cps_call
		                            (of_string$0,
		                             function(param, cont){
		                              return caml_trampoline_cps_call2
		                                      (M[5], [0, 0, empty$14], cont);
		                             },
		                             cont);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$5,
		                           function(a){
		                            return caml_trampoline_cps_call4
		                                    (a,
		                                     field_name,
		                                     pp_descriptor$0,
		                                     s,
		                                     function(x){return cont([1, x]);});
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (inline_fields, fields, cont);
		                }
		                function value(f, fields, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (value_versioned,
		                          f,
		                          fields,
		                          function(v){
		                           if(0 !== v[0]) return cont(v);
		                           var result = v[1];
		                           return cont
		                                   ([0,
		                                     function(fields, cont){
		                                      function a(param, cont){
		                                       var result = param[1];
		                                       return cont(result);
		                                      }
		                                      return caml_trampoline_cps_call2
		      (result,
		       fields,
		       function(b){
		        return caml_trampoline_cps_call3(let$, b, a, cont);
		       });
		                                     }]);
		                          });
		                }
		                return [0, , , , schema, value_versioned, value];
		               }
		               var Inline = Make_inline(include$0);
		               function object_fields(descriptor, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Inline[4],
		                         descriptor,
		                         [0,
		                          function(a, cont){
		                           var requirement = a[7], name = a[5];
		                           a:
		                           {
		                            if
		                             (typeof requirement === "number"
		                              && 1 !== requirement && 3 > requirement){a = 1; break a;}
		                            a = 0;
		                           }
		                           return cont(some_if(a, name));
		                          },
		                          0],
		                         function(v){
		                          if(0 !== v[0]) return cont(v);
		                          var names = v[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   names,
		                                   filter_opt,
		                                   function(a){return cont([0, a]);});
		                         });
		               }
		               var cst_mapping = "mapping";
		               function of_schema(schema, cont){
		                function a(schema){
		                 var b = schema[1];
		                 if(b){var id = b[1]; return cont([0, [0, id]]);}
		                 b = schema[3];
		                 var match = schema[4];
		                 if(match){
		                  var parametric = match[1];
		                  return caml_exact_trampoline_cps_call
		                          (of_parametric, parametric, cont);
		                 }
		                 if(typeof b === "number")
		                  switch(b){
		                    case 0:
		                     return cont(jn);
		                    case 1:
		                     return cont(jo);
		                    case 2:
		                     return cont(jp);
		                    case 3:
		                     return cont(jq);
		                    case 4:
		                     return cont(jr);
		                    case 5:
		                     return cont(js);
		                    case 6:
		                     return cont(jt);
		                    case 7:
		                     return cont(ju);
		                    case 8:
		                     return cont(jv);
		                    case 9:
		                     return cont(jw);
		                    default: return cont(jx);
		                  }
		                 switch(b[0]){
		                   case 0:
		                    return cont(jy);
		                   case 1:
		                    var f = b[1], d = schema[4];
		                    return caml_trampoline_cps_call2
		                            (f,
		                             0,
		                             function(b){
		                              var schema$0 = [0, schema[1], , b, d];
		                              return caml_exact_trampoline_call1(a, schema$0);
		                             });
		                   case 2:
		                    var
		                     f$0 = b[1],
		                     e = schema[4],
		                     b = caml_obj_tag(f$0),
		                     c =
		                       function(b){
		                        var schema$0 = [0, schema[1], , b, e];
		                        return caml_exact_trampoline_call1(a, schema$0);
		                       };
		                    if(250 === b) return c(f$0[1]);
		                    if(246 !== b && 244 !== b) return c(f$0);
		                    return caml_exact_trampoline_cps_call
		                            (force_lazy_block, f$0, c);
		                   case 3:
		                    var
		                     p = b[1],
		                     f$1 =
		                       function(p, cont){return cont([1, cst_list, [0, p, 0]]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_schema,
		                             p,
		                             function(t){
		                              return caml_exact_trampoline_cps_call$1(map$3, t, f$1, cont);
		                             });
		                   case 5:
		                    var
		                     item = b[3],
		                     f$2 =
		                       function(p, cont){return cont([1, cst_mapping, [0, p, 0]]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_schema,
		                             item,
		                             function(t){
		                              return caml_exact_trampoline_cps_call$1(map$3, t, f$2, cont);
		                             });
		                   case 6:
		                    var
		                     p$0 = b[1],
		                     f$3 =
		                       function(p, cont){return cont([1, cst_option, [0, p, 0]]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_schema,
		                             p$0,
		                             function(t){
		                              return caml_exact_trampoline_cps_call$1(map$3, t, f$3, cont);
		                             });
		                   case 8:
		                    var
		                     item$0 = b[3],
		                     f$4 =
		                       function(p, cont){return cont([1, cst_list, [0, p, 0]]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_schema,
		                             item$0,
		                             function(t){
		                              return caml_exact_trampoline_cps_call$1(map$3, t, f$4, cont);
		                             });
		                   case 12:
		                    var
		                     descriptor = b[1],
		                     schema$0 = [0, schema[1], , descriptor, schema[4]];
		                    return caml_exact_trampoline_call1(a, schema$0);
		                   default: return cont(0);
		                 }
		                }
		                return a(schema);
		               }
		               function of_parametric(parametric, cont){
		                function f(param, cont){
		                 if(0 === param[0]){
		                  var name = param[1];
		                  return cont([0, [0, name, 0]]);
		                 }
		                 var next = param[3], parameter = param[2];
		                 function a(param, cont){
		                  var parameters = param[2], parametric = param[1];
		                  function f(parameter, cont){
		                   return cont([0, parametric, [0, parameter, parameters]]);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (of_schema,
		                           parameter,
		                           function(t){
		                            return caml_exact_trampoline_cps_call$1(map$3, t, f, cont);
		                           });
		                 }
		                 return caml_trampoline_cps_call2
		                         (next,
		                          parameter,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_bind, b, a, cont);
		                                    });
		                          });
		                }
		                function f$0(param, cont){
		                 var parameters = param[2], name = param[1];
		                 return cont([1, name, parameters]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         parametric,
		                         function(t){
		                          return caml_exact_trampoline_cps_call$1(map$3, t, f$0, cont);
		                         });
		               }
		               function to_id(param, cont){
		                if(0 === param[0]){var s = param[1]; return cont(s);}
		                var ps = param[2], name = param[1], s2 = cst$33 + name;
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         ps,
		                         to_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0, jz, a, function(s1){return cont(s1 + s2);});
		                         });
		               }
		               function combine(schema, id, cont){
		                function f(name, cont){
		                 var s2 = cst$33 + id;
		                 return caml_exact_trampoline_cps_call
		                         (to_id, name, function(s1){return cont(s1 + s2);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_schema,
		                         schema,
		                         function(t){
		                          return caml_exact_trampoline_cps_call$1(map$3, t, f, cont);
		                         });
		               }
		               function fixpoint(f, cont){
		                var self = [];
		                caml_update_dummy
		                 (self,
		                  [2,
		                   [246,
		                    function(a, cont){
		                     return caml_trampoline_cps_call2(f, self, cont);
		                    }]]);
		                return caml_trampoline_cps_call2(f, self, cont);
		               }
		               function object_wrap(name, schema){
		                return [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){var ok = param[1]; return cont(ok);},
		                         function(ok, cont){return cont([0, ok, 0]);},
		                         [0, [0, 0, 0, 0, 0, name, 0, 2, [0, schema], 0, 0], 0]],
		                        0];
		               }
		               function Make_inline$0(a){
		                a = Make_inline(a);
		                return [0, a[4], , a[6]];
		               }
		               function pp_ignore(a, param, cont){return cont(0);}
		               function equal_ignore(a, param, cont){return cont(1);}
		               function list_schema(schema){
		                var descriptor = [3, schema];
		                return [0, 0, 0, descriptor, 0];
		               }
		               function mapping_schema(item){
		                function construct(a, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (compose, of_string$0, to_binable, a, cont);
		                }
		                var descriptor = [5, construct, deconstruct, item, length$1];
		                return [0, 0, 0, descriptor, 0];
		               }
		               function option_schema(s, cont){
		                var descriptor = [6, s];
		                return cont([0, 0, 0, descriptor, 0]);
		               }
		               function option_schema_versioned(param, cont){return cont(option_schema);
		               }
		               var schematic_param_name_schema_ve = [0, 0, 0, 8, 0];
		               function string_schema_versioned(param, cont){return cont(schematic_param_name_schema_ve);
		               }
		               var cst_First = "First", cst_Second = "Second";
		               function schema(first, second){
		                function descriptor(first, second){
		                 return [11,
		                         0,
		                         [0,
		                          [0,
		                           return$1,
		                           function(param, cont){
		                            if(0 !== param[0]) return cont(0);
		                            var x = param[1];
		                            return cont([0, x]);
		                           },
		                           0,
		                           0,
		                           cst_first,
		                           cst_First,
		                           first,
		                           0],
		                          [0,
		                           [0,
		                            return$2,
		                            function(param, cont){
		                             if(0 === param[0]) return cont(0);
		                             var x = param[1];
		                             return cont([0, x]);
		                            },
		                            0,
		                            0,
		                            cst_second,
		                            cst_Second,
		                            second,
		                            0],
		                           0]],
		                         0];
		                }
		                var
		                 parametric =
		                   [1,
		                    cst_first,
		                    first,
		                    function(first, cont){
		                     return cont
		                             ([1,
		                               cst_second,
		                               second,
		                               function(second, cont){
		                                return cont([0, cst_either, descriptor(first, second)]);
		                               }]);
		                    }],
		                 descriptor$0 = descriptor(first, second);
		                return [0, id$0, 0, descriptor$0, [0, parametric]];
		               }
		               var cst_Error = "Error", cst_result = "result";
		               function schema$0(t, error, cont){
		                function descriptor(t, error){
		                 var
		                  a =
		                    [0,
		                     [0,
		                      fail,
		                      function(param, cont){
		                       if(0 === param[0]) return cont(0);
		                       var x = param[1];
		                       return cont([0, x]);
		                      },
		                      0,
		                      0,
		                      cst_error,
		                      cst_Error,
		                      object_wrap(cst_error, error),
		                      0],
		                     0];
		                 return [11,
		                         0,
		                         [0,
		                          [0,
		                           of_string$0,
		                           function(param, cont){
		                            if(0 !== param[0]) return cont(0);
		                            var x = param[1];
		                            return cont([0, x]);
		                           },
		                           0,
		                           0,
		                           cst_t,
		                           cst_Ok,
		                           object_wrap(cst_value, t),
		                           0],
		                          a],
		                         0];
		                }
		                var
		                 parametric =
		                   [1,
		                    cst_t,
		                    t,
		                    function(t, cont){
		                     return cont
		                             ([1,
		                               cst_error,
		                               error,
		                               function(error, cont){
		                                return cont([0, cst_result, descriptor(t, error)]);
		                               }]);
		                    }],
		                 a = t[1],
		                 match = error[1];
		                function b(id){
		                 var descriptor$0 = descriptor(t, error);
		                 return cont([0, id, 0, descriptor$0, [0, parametric]]);
		                }
		                if(a && match){
		                 var error$0 = match[1], t$0 = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$6,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a, t$0, error$0, function(a){return b([0, a]);});
		                          });
		                }
		                return b(0);
		               }
		               var
		                descriptor =
		                  [4,
		                   function(s, cont){
		                    return caml_exact_trampoline_cps_call
		                            (of_string$0, of_int_s(s), cont);
		                   },
		                   function(span, cont){
		                    return caml_exact_trampoline_cps_call$2
		                            (value_exn, jA, 0, 0, to_int_s(span), cont);
		                   },
		                   4];
		               function M$1(T, cont){
		                function schema_versioned(version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (T[1],
		                          version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (option_schema, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         T[2],
		                         function(schema){
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    schema_versioned,
		                                    schema]);
		                         });
		               }
		               var
		                descriptor$0 =
		                  [4,
		                   function(s, cont){
		                    return caml_exact_trampoline_cps_call
		                            (of_string$8,
		                             s,
		                             function(a){
		                              return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                             });
		                   },
		                   function(eta, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (to_string$12, 0, eta, cont);
		                   },
		                   8];
		               function one_or_many_versioned(schema$0, param){
		                var either = schema(schema$0, list_schema(schema$0));
		                function decode(param, cont){
		                 if(0 === param[0]){
		                  var v = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (of_string$0, [0, v, 0], cont);
		                 }
		                 var l = param[1];
		                 return caml_exact_trampoline_cps_call(of_string$0, l, cont);
		                }
		                function encode(l, cont){
		                 if(l && ! l[2]){var v = l[1]; return cont([0, v]);}
		                 return cont([1, l]);
		                }
		                return map$14(decode, encode, either);
		               }
		               function of_string_exn(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$7,
		                         s,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    failwith,
		                                    fmt$7,
		                                    function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                          var version = match[1];
		                          return cont(version);
		                         });
		               }
		               function sexp_of_t$23(param, cont){
		                var
		                 build = param[5],
		                 prerelease = param[4],
		                 patch = param[3],
		                 minor = param[2],
		                 major = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$0,
		                         function(v, cont){return cont([0, v]);},
		                         build,
		                         function(b){
		                          var a = [0, [1, b], 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$0,
		                                   function(v, cont){return cont([0, v]);},
		                                   prerelease,
		                                   function(b){
		                                    return cont
		    ([1,
		      [0,
		       [0, "" + major],
		       [0, [0, "" + minor], [0, [0, "" + patch], [0, [1, b], a]]]]]);
		                                   });
		                         });
		               }
		               function make$4(a, opt, major, minor, patch, cont){
		                var prerelease = a ? a[1] : 0, build = opt ? opt[1] : 0;
		                return caml_exact_trampoline_cps_call$3
		                        (from_parts,
		                         major,
		                         minor,
		                         patch,
		                         prerelease,
		                         build,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (value_exn, jB, 0, 0, a, cont);
		                         });
		               }
		               var
		                bQP = Inline[5],
		                bQQ = Inline[4],
		                include$23 = Make$2([0, compare$24, sexp_of_t$23]),
		                symbol$66 = include$23[5],
		                equal$14 = include$23[7],
		                letrec_function_context$1 = [];
		               function compare$28(x, y, cont){
		                if(! x) return y ? cont(-1) : cont(0);
		                var a = x[1];
		                if(! y) return cont(1);
		                var b = y[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$1[1], a, b, cont);
		               }
		               caml_update_dummy(letrec_function_context$1, [0, compare$24]);
		               function sexp_of_t$24(param, cont){
		                if(! param) return cont(jC);
		                var version = param[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$23, version, cont);
		               }
		               var
		                include$24 = Make$2([0, compare$28, sexp_of_t$24]),
		                comparator$9 = include$24[16];
		               function decode$1(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$7,
		                         s,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$8,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a, s, function(a){return cont([1, a]);});
		                                    });
		                          var version = match[1];
		                          return cont([0, version]);
		                         });
		               }
		               var
		                schema$261 =
		                  map$14
		                   (decode$1, to_string$11, schematic_param_name_schema_ve);
		               function map_results(f, l, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (rev_map,
		                         l,
		                         f,
		                         function(a){
		                          var res = 0;
		                          for(;;){
		                           if(! a)
		                            return caml_exact_trampoline_cps_call
		                                    (of_string$0, res, cont);
		                           var error = a[1];
		                           if(0 !== error[0]) return cont(error);
		                           var tl = a[2], hd = error[1], res$0 = [0, hd, res];
		                           res = res$0;
		                           a = tl;
		                          }
		                         });
		               }
		               function make$5(context, string){
		                return [0, context[1], context[2], [2, string]];
		               }
		               function fmt$1(context, fmt, args){
		                return [1, [0, context[1], context[2], [0, fmt, args]]];
		               }
		               function type_error(expected, effective, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$9,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, expected, effective, cont);
		                         });
		               }
		               var int_schema = [0, 0, 0, 4, 0];
		               function Make$5(Coding, cont){
		                var
		                 schematic_cache = [0, empty$11([0, comparator$9])],
		                 letrec_function_context = [];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                var schematic_schema_version = 0;
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           var date_tuple_schema = [0, jD, , descriptor];
		                           function type_error(context, expected, v, param, cont){
		                            if(! param)
		                             return caml_exact_trampoline_cps_call
		                                     (Coding[30],
		                                      v,
		                                      function(match){
		                                       if(match){
		var string = match[1];
		return cont
		        (fmt$1(context, jE, [0, [0, expected, [0, [0, string, 0]]]]));
		                                       }
		                                       return caml_exact_trampoline_cps_call
		       (Coding[33],
		        v,
		        function(a){
		         return cont
		                 (fmt$1(context, jF, [0, [0, expected, [0, [0, a, 0]]]]));
		        });
		                                      });
		                            var v$0 = param[1];
		                            return caml_exact_trampoline_cps_call
		                                    (of_string$0, v$0, cont);
		                           }
		                           function key_get(context, o, f, cont){
		                            var match = Coding[5];
		                            if(typeof match === "number"){
		                             var
		                              a =
		                                function(fields, cont){
		                                 return caml_exact_trampoline_cps_call$0
		 (find$1,
		  fields,
		  equal$4,
		  f,
		  function(a){
		   return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		  });
		                                };
		                             return caml_exact_trampoline_cps_call
		                                     (Coding[23],
		                                      o,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$2
		       (type_error,
		        context,
		        cst_object,
		        o,
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol_bind$1, b, a, cont);
		        });
		                                      });
		                            }
		                            var impl = match[2];
		                            return caml_trampoline_cps_call3
		                                    (impl,
		                                     o,
		                                     f,
		                                     function(t){
		                                      if(0 === t[0]) return cont(t);
		                                      var x = t[1];
		                                      return cont([1, make$5(context, x)]);
		                                     });
		                           }
		                           function key_set(context, o, f, v, cont){
		                            var match = Coding[6];
		                            if(typeof match === "number"){
		                             var
		                              a =
		                                function(fields, cont){
		                                 return caml_exact_trampoline_cps_call
		 (Coding[11],
		  [0, [0, f, v], fields],
		  function(a){
		   return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		  });
		                                };
		                             return caml_exact_trampoline_cps_call
		                                     (Coding[23],
		                                      o,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$2
		       (type_error,
		        context,
		        cst_object,
		        v,
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol_bind$1, b, a, cont);
		        });
		                                      });
		                            }
		                            var impl = match[2];
		                            return caml_trampoline_cps_call4
		                                    (impl,
		                                     o,
		                                     f,
		                                     v,
		                                     function(t){
		                                      if(0 === t[0]) return cont(t);
		                                      var x = t[1];
		                                      return cont([1, make$5(context, x)]);
		                                     });
		                           }
		                           function decode(schema, cont){
		                            function decode_descriptor(context, schema, v, cont){
		                             function a(schema){
		                              if(typeof schema === "number")
		                               switch(schema){
		                                 case 0:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[21],
		   v,
		   function(a){
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_boolean, v, a, cont);
		   });
		                                 case 1:
		                                  var b = Coding[22];
		                                  if(typeof b === "number")
		                                   return caml_exact_trampoline_cps_call$0
		   (decode_schema, context, date_tuple_schema, v, cont);
		                                  var f = b[2];
		                                  return caml_trampoline_cps_call2
		  (f,
		   v,
		   function(a){
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_date, v, a, cont);
		   });
		                                 case 2:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[24],
		   v,
		   function(a){
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_float, v, a, cont);
		   });
		                                 case 3:
		                                  return caml_exact_trampoline_cps_call(of_string$0, 0, cont);
		                                 case 4:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[25],
		   v,
		   function(a){
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_integer, v, a, cont);
		   });
		                                 case 5:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[26],
		   v,
		   function(a){
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_integer, v, a, cont);
		   });
		                                 case 6:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[27],
		   v,
		   function(a){
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_JSON, v, a, cont);
		   });
		                                 case 7:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[29],
		   v,
		   function(match){
		    a:
		    {if(match && ! match[1]){var res = jK; break a;} res = 0;}
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_null, v, res, cont);
		   });
		                                 case 8:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[30],
		   v,
		   function(a){
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_string, v, a, cont);
		   });
		                                 case 9:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[31],
		   v,
		   function(ok){
		    if(0 === ok[0]) return cont(ok);
		    var match = ok[1];
		    if(! match)
		     return caml_exact_trampoline_cps_call$2
		             (type_error, context, cst_time, v, 0, cont);
		    var e = match[1], x = make$5(context, e);
		    return cont([1, x]);
		   });
		                                 default:
		                                  return caml_exact_trampoline_cps_call
		  (Coding[32],
		   v,
		   function(ok){
		    if(0 === ok[0]) return cont(ok);
		    var match = ok[1];
		    if(! match)
		     return caml_exact_trampoline_cps_call$2
		             (type_error, context, "localtime", v, 0, cont);
		    var e = match[1], x = make$5(context, e);
		    return cont([1, x]);
		   });
		                               }
		                              switch(schema[0]){
		                                case 0:
		                                 var Any = schema[1];
		                                 return caml_trampoline_cps_call3
		 (Any[8],
		  Coding[1],
		  v,
		  function(a){
		   return caml_exact_trampoline_cps_call$2
		           (type_error, context, Any[2], v, a, cont);
		  });
		                                case 1:
		                                 var f$0 = schema[1];
		                                 return caml_trampoline_cps_call2(f$0, [0, Coding[1]], a);
		                                case 2:
		                                 var s = schema[1], b = caml_obj_tag(s);
		                                 if(250 === b) return caml_exact_trampoline_call1(a, s[1]);
		                                 if(246 !== b && 244 !== b)
		                                  return caml_exact_trampoline_call1(a, s);
		                                 return caml_exact_trampoline_cps_call
		 (force_lazy_block, s, a);
		                                case 3:
		                                 var
		                                  items_schema = schema[1],
		                                  d =
		                                    function(v, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (map_results,
		      function(a, cont){
		       return caml_exact_trampoline_cps_call$0
		               (decode_schema, context, items_schema, a, cont);
		      },
		      v,
		      cont);
		                                    };
		                                 return caml_exact_trampoline_cps_call
		 (Coding[28],
		  v,
		  function(a){
		   return caml_exact_trampoline_cps_call$2
		           (type_error,
		            context,
		            cst_array,
		            v,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (symbol_bind$1, a, d, cont);
		            });
		  });
		                                case 4:
		                                 var
		                                  descriptor = schema[3],
		                                  cons = schema[1],
		                                  e =
		                                    function(value, cont){
		                                     return caml_trampoline_cps_call2
		     (cons,
		      value,
		      function(t){
		       if(0 === t[0]) return cont(t);
		       var x = t[1];
		       return cont([1, make$5(context, x)]);
		      });
		                                    };
		                                 return caml_exact_trampoline_cps_call$0
		 (decode_descriptor,
		  context,
		  descriptor,
		  v,
		  function(a){
		   return caml_exact_trampoline_cps_call$1
		           (symbol_bind$1, a, e, cont);
		  });
		                                case 5:
		                                 var
		                                  item = schema[3],
		                                  construct = schema[1],
		                                  f$1 =
		                                    function(param, cont){
		                                     var value = param[2], name = param[1];
		                                     function a(value, cont){
		                                      return caml_exact_trampoline_cps_call
		      (of_string$0, [0, name, value], cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call$0
		     (decode_schema,
		      context,
		      item,
		      value,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (symbol_bind$1, b, a, cont);
		      });
		                                    },
		                                  g =
		                                    function(fields, cont){
		                                     return caml_exact_trampoline_cps_call
		     (deconstruct,
		      fields,
		      function(a){
		       return caml_trampoline_cps_call2
		               (construct,
		                a,
		                function(t){
		                 if(0 === t[0]) return cont(t);
		                 var x = t[1];
		                 return cont([1, make$5(context, x)]);
		                });
		      });
		                                    },
		                                  h =
		                                    function(a, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (map_results, f$1, a, cont);
		                                    };
		                                 return caml_exact_trampoline_cps_call
		 (Coding[23],
		  v,
		  function(a){
		   return caml_exact_trampoline_cps_call$2
		           (type_error,
		            context,
		            cst_mapping,
		            v,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (symbol_bind$1,
		                      a,
		                      h,
		                      function(a){
		                       return caml_exact_trampoline_cps_call$1
		                               (symbol_bind$1, a, g, cont);
		                      });
		            });
		  });
		                                case 6:
		                                 var s$0 = schema[1];
		                                 return caml_exact_trampoline_cps_call
		 (Coding[29],
		  v,
		  function(a){
		   if(! a)
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_option, v, 0, cont);
		   a = a[1];
		   if(! a)
		    return caml_exact_trampoline_cps_call(of_string$0, 0, cont);
		   var v$0 = a[1];
		   return caml_exact_trampoline_cps_call$0
		           (decode_schema,
		            context,
		            s$0,
		            v$0,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (map$5, a, return$4, cont);
		            });
		  });
		                                case 7:
		                                 var
		                                  fields_schema = schema[3],
		                                  o_decode = schema[1],
		                                  i =
		                                    function(fields, cont){
		                                     function decode_object(a, cont){
		                                      if(! a)
		                                       return caml_exact_trampoline_cps_call(of_string$0, 0, cont);
		                                      var
		                                       rest = a[2],
		                                       a = a[1],
		                                       field_schema = a[8],
		                                       requirement = a[7],
		                                       omit = a[6],
		                                       field_name = a[5],
		                                       schema$1 = field_schema[1],
		                                       a = schema$1[3];
		                                      if(typeof a === "number" && 3 === a){
		                                       var
		c =
		  function(rest, cont){
		   var v = 0;
		   if(typeof requirement === "number")
		    switch(requirement){
		      case 1:
		       var a = [0, [0, v]]; break;
		      case 2:
		       a = v; break;
		      default: a = [0, v];
		    }
		   else
		    a = v;
		   return cont([0, [0, a, rest]]);
		  };
		                                       return caml_exact_trampoline_cps_call
		       (decode_object,
		        rest,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol_bind$1, a, c, cont);
		        });
		                                      }
		                                      function inline(param, cont){
		                                       var descriptor = param[3];
		                                       function a(descriptor$0){
		if(typeof descriptor$0 !== "number")
		 switch(descriptor$0[0]){
		   case 2:
		    var
		     descriptor$1 = descriptor$0[1],
		     b = caml_obj_tag(descriptor$1);
		    if(250 === b)
		     return caml_exact_trampoline_call1(a, descriptor$1[1]);
		    if(246 !== b && 244 !== b)
		     return caml_exact_trampoline_call1(a, descriptor$1);
		    return caml_exact_trampoline_cps_call
		            (force_lazy_block, descriptor$1, a);
		   case 4:
		    var descriptor$2 = descriptor$0[3];
		    return caml_exact_trampoline_call1(a, descriptor$2);
		   case 6:
		    var schema = descriptor$0[1], descriptor$3 = schema[3];
		    return caml_exact_trampoline_call1(a, descriptor$3);
		 }
		return caml_exact_trampoline_cps_call
		        (object_fields,
		         descriptor$0,
		         function(match){
		          function a(param){
		           function c(a){
		            var missing = is_none$0(a);
		            return caml_exact_trampoline_cps_call$1
		                    (bQQ,
		                     descriptor,
		                     [0, function(param, cont){return cont(0);}, 0],
		                     function(a){
		                      var inlinable = is_ok(a);
		                      return cont([0, missing, inlinable]);
		                     });
		           }
		           if(! param) return c(0);
		           var l = param[2], expected = param[1];
		           function b(param){
		            function d(b){
		             return is_none$0(b)
		                     ? c([0, expected])
		                     : caml_exact_trampoline_call1(a, l);
		            }
		            if(! param) return d(0);
		            var l$0 = param[2], x = param[1];
		            return caml_exact_trampoline_cps_call$0
		                    (mem$0,
		                     fields,
		                     equal$4,
		                     x,
		                     function(a){
		                      return 1 - a
		                              ? d([0, x])
		                              : caml_exact_trampoline_call1(b, l$0);
		                     });
		           }
		           return b(expected);
		          }
		          if(0 !== match[0]) return a(jG);
		          var v = match[1];
		          return a(v);
		         });
		                                       }
		                                       return a(descriptor);
		                                      }
		                                      function b(value){
		                                       var
		context_field = [0, [0, field_name, context[1]], context[2]];
		                                       function a(field){
		return caml_exact_trampoline_cps_call$1
		        (symbol_bind$1,
		         field,
		         function(field, cont){
		          function a(tail, cont){return cont([0, [0, field, tail]]);}
		          return caml_exact_trampoline_cps_call
		                  (decode_object,
		                   rest,
		                   function(b){
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol_bind$1, b, a, cont);
		                   });
		         },
		         cont);
		                                       }
		                                       if(typeof requirement === "number")
		switch(requirement){
		  case 2:
		   if(! value)
		    return a(fmt$1(context, jJ, [0, [0, field_name, 0]]));
		   var v = value[1];
		   return caml_exact_trampoline_cps_call$0
		           (decode_schema, context_field, schema$1, v, a);
		  case 3:
		   if(! value)
		    return caml_exact_trampoline_cps_call(of_string$0, 0, a);
		   var v$0 = value[1];
		   return caml_exact_trampoline_cps_call
		           (Coding[29],
		            v$0,
		            function(b){
		             if(! b)
		              return caml_exact_trampoline_cps_call$2
		                      (type_error, context_field, cst_option, v$0, 0, a);
		             b = b[1];
		             if(! b)
		              return caml_exact_trampoline_cps_call$0
		                      (decode_schema,
		                       context_field,
		                       schema$1,
		                       v$0,
		                       function(match){
		                        if(0 !== match[0])
		                         return caml_exact_trampoline_cps_call(of_string$0, 0, a);
		                        var v = match[1];
		                        return caml_exact_trampoline_cps_call
		                                (of_string$0, [0, v], a);
		                       });
		             var v = b[1];
		             return caml_exact_trampoline_cps_call$0
		                     (decode_schema,
		                      context_field,
		                      schema$1,
		                      v,
		                      function(b){
		                       return caml_exact_trampoline_cps_call$1
		                               (map$5, b, return$4, a);
		                      });
		            });
		  case 0:
		   return a(jH);
		  default: return a(jI);
		}
		                                       var default$ = requirement[1];
		                                       if(! value)
		return caml_exact_trampoline_cps_call
		        (of_string$0, default$, a);
		                                       var v$1 = value[1];
		                                       return omit
		       ? caml_exact_trampoline_cps_call(of_string$0, default$, a)
		       : caml_exact_trampoline_cps_call
		         (Coding[29],
		          v$1,
		          function(b){
		           var match = schema$1[3];
		           if(! b)
		            return caml_exact_trampoline_cps_call$2
		                    (type_error, context_field, cst_option, v$1, 0, a);
		           b = b[1];
		           if(b){
		            var v = b[1];
		            return caml_exact_trampoline_cps_call$0
		                    (decode_schema, context_field, schema$1, v, a);
		           }
		           if(typeof match !== "number" && 6 === match[0]){
		            var nullable = match[1];
		            return caml_exact_trampoline_cps_call$0
		                    (decode_schema,
		                     context_field,
		                     nullable,
		                     v$1,
		                     function(match){
		                      if(0 !== match[0])
		                       return caml_exact_trampoline_cps_call$0
		                               (decode_schema, context_field, schema$1, v$1, a);
		                      var v = match[1];
		                      return caml_exact_trampoline_cps_call
		                              (of_string$0, [0, v], a);
		                     });
		           }
		           return caml_exact_trampoline_cps_call$0
		                   (decode_schema, context_field, schema$1, v$1, a);
		          });
		                                      }
		                                      switch(field_schema[0]){
		case 0:
		 return caml_exact_trampoline_cps_call$0
		         (find$1, fields, equal$4, field_name, b);
		case 1:
		 var schema = field_schema[1];
		 return caml_exact_trampoline_cps_call
		         (inline,
		          schema,
		          function(match){
		           var missing = match[1];
		           return missing ? b(0) : b([0, v]);
		          });
		default:
		 var schema$0 = field_schema[1];
		 return caml_exact_trampoline_cps_call
		         (inline,
		          schema$0,
		          function(match){
		           var inlinable = match[2], missing = match[1];
		           return missing
		                   ? b(0)
		                   : inlinable
		                     ? b([0, v])
		                     : caml_exact_trampoline_cps_call$0
		                       (find$1, fields, equal$4, field_name, b);
		          });
		                                      }
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (decode_object,
		      fields_schema,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (map$5, a, o_decode, cont);
		      });
		                                    };
		                                 return caml_exact_trampoline_cps_call
		 (Coding[23],
		  v,
		  function(a){
		   return caml_exact_trampoline_cps_call$2
		           (type_error,
		            context,
		            cst_object,
		            v,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (symbol_bind$1, a, i, cont);
		            });
		  });
		                                case 8:
		                                 var
		                                  item$0 = schema[3],
		                                  construct$0 = schema[1],
		                                  k =
		                                    function(a, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (decode_schema, context, item$0, a, cont);
		                                    },
		                                  j =
		                                    function(items, cont){
		                                     return caml_exact_trampoline_cps_call
		     (deconstruct,
		      items,
		      function(a){
		       return caml_trampoline_cps_call2
		               (construct$0,
		                a,
		                function(t){
		                 if(0 === t[0]) return cont(t);
		                 var x = t[1];
		                 return cont([1, make$5(context, x)]);
		                });
		      });
		                                    },
		                                  l =
		                                    function(a, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (map_results, k, a, cont);
		                                    };
		                                 return caml_exact_trampoline_cps_call
		 (Coding[28],
		  v,
		  function(a){
		   return caml_exact_trampoline_cps_call$2
		           (type_error,
		            context,
		            cst_array,
		            v,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (symbol_bind$1,
		                      a,
		                      l,
		                      function(a){
		                       return caml_exact_trampoline_cps_call$1
		                               (symbol_bind$1, a, j, cont);
		                      });
		            });
		  });
		                                case 9:
		                                 var expected = schema[1];
		                                 return caml_exact_trampoline_cps_call
		 (Coding[30],
		  v,
		  function(match){
		   if(! match)
		    return caml_exact_trampoline_cps_call$2
		            (type_error, context, cst_string, v, 0, cont);
		   var s = match[1];
		   return s === expected
		           ? caml_exact_trampoline_cps_call(of_string$0, 0, cont)
		           : cont
		             (fmt$1(context, jL, [0, [0, expected, [0, [0, s, 0]]]]));
		  });
		                                case 10:
		                                 var
		                                  items = schema[3],
		                                  t_decode = schema[1],
		                                  m =
		                                    function(v, cont){
		                                     function decode_tuple(t, v, cont){
		                                      if(! t)
		                                       return v
		       ? cont([1, make$5(context, "too many tuple elements")])
		       : caml_exact_trampoline_cps_call(of_string$0, 0, cont);
		                                      var rest = t[2], schema = t[1];
		                                      if(! v)
		                                       return cont
		       ([1, make$5(context, "not enough tuple elements")]);
		                                      var tl = v[2], hd = v[1];
		                                      function a(hd, cont){
		                                       function a(tl, cont){
		return caml_exact_trampoline_cps_call
		        (of_string$0, [0, hd, tl], cont);
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (decode_tuple,
		        rest,
		        tl,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol_bind$1, b, a, cont);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$0
		      (decode_schema,
		       context,
		       schema,
		       hd,
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (symbol_bind$1, b, a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (decode_tuple,
		      items,
		      v,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (map$5, a, t_decode, cont);
		      });
		                                    };
		                                 return caml_exact_trampoline_cps_call
		 (Coding[28],
		  v,
		  function(a){
		   return caml_exact_trampoline_cps_call$2
		           (type_error,
		            context,
		            cst_list,
		            v,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (symbol_bind$1, a, m, cont);
		            });
		  });
		                                case 11:
		                                 var cases = schema[2], key = schema[1];
		                                 if(key){
		                                  var
		                                   key$0 = key[1],
		                                   n =
		                                     function(key_value, cont){
		                                      function a(b){
		                                       function d(match){
		if(! match)
		 return cont
		         (fmt$1(context, jM, [0, [0, key$0, [0, [0, key_value, 0]]]]));
		var res = match[1];
		return cont(res);
		                                       }
		                                       if(! b) return d(0);
		                                       var
		l = b[2],
		x = b[1],
		schema = x[7],
		name = x[5],
		decoder = x[1];
		                                       function c(r){
		return r ? d(r) : caml_exact_trampoline_call1(a, l);
		                                       }
		                                       if(name !== key_value) return c(0);
		                                       b = schema[3];
		                                       var f = first_some(schema[1], context[2]);
		                                       function e(v, cont){
		return caml_trampoline_cps_call2
		        (decoder,
		         v,
		         function(a){
		          return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call$0
		       (decode_descriptor,
		        [0, context[1], f],
		        b,
		        v,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol_bind$1, a, e, function(x){return c([0, x]);});
		        });
		                                      }
		                                      return a(cases);
		                                     },
		                                   o =
		                                     function(v, cont){
		                                      return caml_exact_trampoline_cps_call
		      (Coding[30],
		       v,
		       function(a){
		        return caml_exact_trampoline_cps_call$2
		                (type_error, context, cst_string, v, a, cont);
		       });
		                                     };
		                                  return caml_exact_trampoline_cps_call$0
		  (key_get,
		   context,
		   v,
		   key$0,
		   function(error){
		    function a(a){
		     return caml_exact_trampoline_cps_call$1
		             (symbol_bind$1,
		              a,
		              o,
		              function(a){
		               return caml_exact_trampoline_cps_call$1
		                       (symbol_bind$1, a, n, cont);
		              });
		    }
		    if(0 !== error[0]) return a(error);
		    var match = error[1];
		    if(! match)
		     return a(fmt$1(context, jN, [0, [0, key$0, 0]]));
		    var v = match[1];
		    return caml_exact_trampoline_cps_call(of_string$0, v, a);
		   });
		                                 }
		                                 var
		                                  decode_case =
		                                    function(a, cont){
		                                     var
		                                      schema = a[7],
		                                      decoder = a[1],
		                                      a = schema[3],
		                                      b = first_some(schema[1], context[2]);
		                                     return caml_exact_trampoline_cps_call$0
		     (decode_descriptor,
		      [0, context[1], b],
		      a,
		      v,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (map$5, a, decoder, cont);
		      });
		                                    },
		                                  c =
		                                    function(param){
		                                     if(! param)
		                                      return cont
		      (fmt$1(context, jO, [0, [0, Coding[4], [0, [0, v, 0]]]]));
		                                     var case$ = param[1], match = case$[4];
		                                     if(match){
		                                      var rest = param[2], key = match[1];
		                                      return caml_exact_trampoline_cps_call$0
		      (key_get,
		       context,
		       v,
		       key,
		       function(a){
		        a:
		        {if(0 === a[0] && a[1]){a = 1; break a;} a = 0;}
		        return a
		                ? caml_exact_trampoline_cps_call(decode_case, case$, cont)
		                : caml_exact_trampoline_call1(c, rest);
		       });
		                                     }
		                                     var rest$0 = param[2];
		                                     return caml_exact_trampoline_cps_call
		     (decode_case,
		      case$,
		      function(res){
		       return 0 === res[0]
		               ? cont(res)
		               : caml_exact_trampoline_call1(c, rest$0);
		      });
		                                    };
		                                 return c(cases);
		                                default:
		                                 var descriptor$0 = schema[1];
		                                 return caml_exact_trampoline_call1(a, descriptor$0);
		                              }
		                             }
		                             return a(schema);
		                            }
		                            function decode_schema(context, schema, v, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (decode_descriptor,
		                                      [0, context[1], schema[1]],
		                                      schema[3],
		                                      v,
		                                      cont);
		                            }
		                            var a = [0, 0];
		                            function res(v, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (decode_schema,
		                                      a,
		                                      schema,
		                                      v,
		                                      function(t){
		                                       if(0 === t[0]) return cont(t);
		                                       var x = t[1], reason = x[3], schema = x[2], path = x[1];
		                                       function a(a){return cont([1, [0, path, schema, a]]);}
		                                       switch(reason[0]){
		 case 0:
		  var args = reason[2], fmt = reason[1];
		  return caml_exact_trampoline_cps_call$1
		          (kasprintf,
		           id,
		           fmt,
		           function(f){
		            function b(f, args){
		             if(! args) return a(f);
		             var match = args[1], tail = match[2], head = match[1];
		             return caml_trampoline_cps_call2
		                     (f,
		                      head,
		                      function(f){return caml_exact_trampoline_call2(b, f, tail);});
		            }
		            return b(f, args);
		           });
		 case 1:
		  var l = reason[1], b = caml_obj_tag(l);
		  if(250 === b) return a(l[1]);
		  if(246 !== b && 244 !== b) return a(l);
		  return caml_exact_trampoline_cps_call
		          (force_lazy_block, l, a);
		 default: var s = reason[1]; return a(s);
		                                       }
		                                      });
		                            }
		                            return cont(res);
		                           }
		                           var
		                            Require_minimal_version =
		                              [248,
		                               "Schematic__Coding.Make(Coding).Require_minimal_version",
		                               caml_fresh_oo_id()];
		                           function encode_versioned(schema, cont){
		                            function encode_field(context, param, cont){
		                             var
		                              schema = param[8],
		                              requirement = param[7],
		                              name = param[5],
		                              context$0 = [0, [0, name, context[1]]],
		                              schema$1 = schema[1];
		                             function encode(a, cont){
		                              return caml_exact_trampoline_cps_call$0
		                                      (encode_schema, context$0, schema$1, a, cont);
		                             }
		                             function optional(v, cont){
		                              if(! v) return cont(0);
		                              var v$0 = v[1];
		                              return caml_exact_trampoline_cps_call
		                                      (encode, v$0, function(a){return cont([0, [0, name, a]]);});
		                             }
		                             if(typeof requirement === "number")
		                              switch(requirement){
		                                case 1:
		                                 return cont
		 (function(v, cont){
		   if(! v) return cont(0);
		   var v$0 = v[1];
		   return caml_exact_trampoline_cps_call(optional, v$0, cont);
		  });
		                                case 2:
		                                 return cont
		 (function(v, cont){
		   return caml_exact_trampoline_cps_call
		           (encode, v, function(a){return cont([0, [0, name, a]]);});
		  });
		                                default: return cont(optional);
		                              }
		                             var default$ = requirement[1], schema$0 = schema[1];
		                             return caml_exact_trampoline_cps_call
		                                     (compare$27,
		                                      schema$0,
		                                      function(compare){
		                                       return cont
		       (function(v, cont){
		         return caml_trampoline_cps_call3
		                 (compare,
		                  v,
		                  default$,
		                  function(a){
		                   return 0 === a
		                           ? cont(0)
		                           : caml_exact_trampoline_cps_call
		                             (encode, v, function(a){return cont([0, [0, name, a]]);});
		                  });
		        });
		                                      });
		                            }
		                            function encode_descriptor(context, schema, cont){
		                             function a(schema){
		                              if(typeof schema !== "number")
		                               switch(schema[0]){
		                                 case 0:
		                                  var Any = schema[1];
		                                  return cont
		  (function(v, cont){
		    return caml_exact_trampoline_cps_call$1
		            (Coding[8],
		             Any[1],
		             v,
		             function(match){
		              if(match){var v = match[1]; return cont(v);}
		              var a = Any[2], b = Coding[2];
		              return caml_exact_trampoline_cps_call$1
		                      (kasprintf,
		                       failwith,
		                       fmt$10,
		                       function(c){
		                        return caml_trampoline_cps_call3(c, b, a, cont);
		                       });
		             });
		   });
		                                 case 1:
		                                  var f$0 = schema[1];
		                                  return caml_trampoline_cps_call2(f$0, [0, Coding[1]], a);
		                                 case 2:
		                                  var s = schema[1];
		                                  return cont
		  (function(v, cont){
		    var a = caml_obj_tag(s);
		    function b(a){
		     return caml_exact_trampoline_cps_call$1
		             (encode_descriptor,
		              context,
		              a,
		              function(a){return caml_trampoline_cps_call2(a, v, cont);});
		    }
		    if(250 === a) return b(s[1]);
		    if(246 !== a && 244 !== a) return b(s);
		    return caml_exact_trampoline_cps_call
		            (force_lazy_block, s, b);
		   });
		                                 case 3:
		                                  var
		                                   items_schema = schema[1],
		                                   f$1 =
		                                     function(a, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (encode_schema, context, items_schema, a, cont);
		                                     };
		                                  return cont
		  (function(v, cont){
		    return caml_exact_trampoline_cps_call$1
		            (map$7,
		             v,
		             f$1,
		             function(a){
		              return caml_exact_trampoline_cps_call(Coding[16], a, cont);
		             });
		   });
		                                 case 4:
		                                  var descriptor = schema[3], decons = schema[2];
		                                  return caml_exact_trampoline_cps_call$1
		  (encode_descriptor,
		   context,
		   descriptor,
		   function(encode){
		    return cont
		            (function(v, cont){
		              return caml_trampoline_cps_call2
		                      (decons,
		                       v,
		                       function(a){
		                        return caml_trampoline_cps_call2(encode, a, cont);
		                       });
		             });
		   });
		                                 case 5:
		                                  var item = schema[3], deconstruct = schema[2];
		                                  return cont
		  (function(v, cont){
		    return caml_trampoline_cps_call2
		            (deconstruct,
		             v,
		             function(a){
		              return caml_trampoline_cps_call3
		                      (map$11,
		                       a,
		                       function(param, cont){
		                        var v = param[2], name = param[1];
		                        return caml_exact_trampoline_cps_call$0
		                                (encode_schema,
		                                 context,
		                                 item,
		                                 v,
		                                 function(a){return cont([0, name, a]);});
		                       },
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (to_binable,
		                                 a,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call(Coding[11], a, cont);
		                                 });
		                       });
		             });
		   });
		                                 case 6:
		                                  var
		                                   s$0 = schema[1],
		                                   encode =
		                                     function(a, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (encode_schema, context, s$0, a, cont);
		                                     };
		                                  return cont
		  (function(v, cont){
		    return caml_exact_trampoline_cps_call$1
		            (map$3,
		             v,
		             encode,
		             function(a){
		              return caml_exact_trampoline_cps_call(Coding[17], a, cont);
		             });
		   });
		                                 case 7:
		                                  var fields = schema[3], encode$0 = schema[2];
		                                  return caml_exact_trampoline_cps_call$1
		  (bQP,
		   [0,
		    function(field, req, cont){
		     return caml_exact_trampoline_cps_call$1
		             (encode_field,
		              context,
		              field,
		              function(a){
		               return caml_exact_trampoline_cps_call(a, req, cont);
		              });
		    }],
		   fields,
		   function(a){
		    return caml_exact_trampoline_cps_call
		            (ok_or_failwith,
		             a,
		             function(f){
		              return cont
		                      (function(v, cont){
		                        return caml_trampoline_cps_call2
		                                (encode$0,
		                                 v,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (f,
		   a,
		   function(match){
		    var versions = match[2], fields = match[1];
		    return caml_exact_trampoline_cps_call
		            (is_empty$5,
		             versions,
		             function(b){
		              function a(a){
		               return caml_exact_trampoline_cps_call$1
		                       (filter_map$0,
		                        fields,
		                        function(a, cont){return cont(a);},
		                        function(fields){
		                         return caml_exact_trampoline_cps_call
		                                 (Coding[11], fields, cont);
		                        });
		              }
		              return 1 - b
		                      ? caml_perform_effect
		                        ([0, Require_minimal_version, versions], a)
		                      : a();
		             });
		   });
		                                 });
		                       });
		             });
		   });
		                                 case 8:
		                                  var
		                                   item$0 = schema[3],
		                                   deconstruct$0 = schema[2],
		                                   f$2 =
		                                     function(a, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (encode_schema, context, item$0, a, cont);
		                                     };
		                                  return cont
		  (function(v, cont){
		    return caml_trampoline_cps_call2
		            (deconstruct$0,
		             v,
		             function(a){
		              return caml_trampoline_cps_call3
		                      (map$11,
		                       a,
		                       f$2,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (to_binable,
		                                 a,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call(Coding[16], a, cont);
		                                 });
		                       });
		             });
		   });
		                                 case 9:
		                                  var v = schema[1];
		                                  return cont
		  (function(param, cont){
		    return caml_exact_trampoline_cps_call(Coding[18], v, cont);
		   });
		                                 case 10:
		                                  var
		                                   items = schema[3],
		                                   t_encode = schema[2],
		                                   encode_tuple =
		                                     function(param){
		                                      if(! param) return function(param, cont){return cont(0);};
		                                      var
		                                       rest = param[2],
		                                       schema = param[1],
		                                       encode_rest = encode_tuple(rest);
		                                      return function(v, cont){
		                                       var tl = v[2], hd = v[1];
		                                       return caml_exact_trampoline_cps_call$0
		       (encode_schema,
		        context,
		        schema,
		        hd,
		        function(hd){
		         return caml_exact_trampoline_cps_call
		                 (encode_rest, tl, function(a){return cont([0, hd, a]);});
		        });};
		                                     },
		                                   encode$1 = encode_tuple(items);
		                                  return cont
		  (function(v, cont){
		    return caml_trampoline_cps_call2
		            (t_encode,
		             v,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (encode$1,
		                       a,
		                       function(a){
		                        return caml_exact_trampoline_cps_call(Coding[16], a, cont);
		                       });
		             });
		   });
		                                 case 11:
		                                  var
		                                   cases = schema[2],
		                                   key = schema[1],
		                                   f$3 =
		                                     function(param, cont){
		                                      var
		                                       since = param[8],
		                                       schema = param[7],
		                                       name = param[5],
		                                       encoder = param[2];
		                                      return cont
		      (function(v, cont){
		        return caml_trampoline_cps_call2
		                (encoder,
		                 v,
		                 function(a){
		                  if(! a) return cont(0);
		                  var v = a[1];
		                  function b(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (encode_schema,
		                            context,
		                            schema,
		                            v,
		                            function(v){
		                             if(! key) return cont([0, v]);
		                             var key$0 = key[1];
		                             return caml_exact_trampoline_cps_call
		                                     (Coding[18],
		                                      name,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$2
		       (key_set,
		        context,
		        v,
		        key$0,
		        a,
		        function(match){
		         if(0 !== match[0]) return cont([0, v]);
		         var v$0 = match[1];
		         return cont([0, v$0]);
		        });
		                                      });
		                            });
		                  }
		                  if(! since) return b();
		                  a = since[1];
		                  var library = a[2], version = a[1];
		                  return caml_perform_effect
		                          ([0, Require_minimal_version, singleton$4(library, version)],
		                           b);
		                 });
		       });
		                                     };
		                                  return caml_exact_trampoline_cps_call$1
		  (map$7,
		   cases,
		   f$3,
		   function(cases){
		    return cont
		            (function(v, cont){
		              function a(param){
		               function b(match){
		                if(match){var res = match[1]; return cont(res);}
		                var a = context[2];
		                function b(a, b, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (option, 0, pp_print_string, a, b, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         failwith,
		                         fmt$11,
		                         function(c){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               }
		               if(! param) return b(0);
		               var l = param[2], case$ = param[1];
		               return caml_trampoline_cps_call2
		                       (case$,
		                        v,
		                        function(r){
		                         return r ? b(r) : caml_exact_trampoline_call1(a, l);
		                        });
		              }
		              return a(cases);
		             });
		   });
		                                 default:
		                                  var descriptor$0 = schema[1];
		                                  return caml_exact_trampoline_call1(a, descriptor$0);
		                               }
		                              switch(schema){
		                                case 0:
		                                 return cont(Coding[9]);
		                                case 1:
		                                 var match = Coding[10];
		                                 if(typeof match === "number")
		                                  return cont
		  (function(a, cont){
		    return caml_exact_trampoline_cps_call$0
		            (encode_schema, context, date_tuple_schema, a, cont);
		   });
		                                 var f = match[2];
		                                 return cont(f);
		                                case 2:
		                                 return cont(Coding[12]);
		                                case 4:
		                                 return cont(Coding[13]);
		                                case 5:
		                                 return cont(Coding[14]);
		                                case 6:
		                                 return cont(Coding[15]);
		                                case 8:
		                                 return cont(Coding[18]);
		                                case 9:
		                                 return cont(Coding[19]);
		                                case 10:
		                                 return cont(Coding[20]);
		                                default: return cont(Coding[7]);
		                              }
		                             }
		                             return a(schema);
		                            }
		                            function encode_schema(context, schema, v, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (encode_descriptor,
		                                      [0, context[1], schema[1]],
		                                      schema[3],
		                                      function(a){return caml_trampoline_cps_call2(a, v, cont);});
		                            }
		                            var a = [0, 0];
		                            function encode(b, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (encode_schema, a, schema, b, cont);
		                            }
		                            function res(v, cont){
		                             function handle(versions, k, arg, cont){
		                              return caml_exact_trampoline_cps_call$0
		                                      (continue_with,
		                                       k,
		                                       arg,
		                                       [0,
		function(res, cont){return cont([0, res, versions]);},
		function(b, a){
		 a = caml_pop_trap();
		 return a(caml_maybe_attach_backtrace(b, 1));
		},
		function(eff, cont){
		 if(eff[1] !== Require_minimal_version) return cont(0);
		 var v = eff[2];
		 return caml_exact_trampoline_cps_call$1
		         (union$1,
		          versions,
		          v,
		          function(version){
		           return cont
		                   ([0,
		                     function(k, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (handle, version, k, 0, cont);
		                     }]);
		          });
		}],
		                                       cont);
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (fiber,
		                                      encode,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (handle, empty$14, a, v, cont);
		                                      });
		                            }
		                            return cont(res);
		                           }
		                           function encode(schema, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (encode_versioned,
		                                     schema,
		                                     function(encode){
		                                      return cont
		      (function(v, cont){
		        return caml_exact_trampoline_cps_call
		                (encode, v, function(a){return cont(a[1]);});
		       });
		                                     });
		                           }
		                           return cont([0, , encode, encode_versioned, decode]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context[1][1] = a;
		                  var
		                   res =
		                     [10,
		                      function(param, cont){
		                       var a = param[2], e2 = a[2][1], e1 = a[1], e0 = param[1];
		                       return cont([0, e0, e1, e2]);
		                      },
		                      function(param, cont){
		                       var e2 = param[3], e1 = param[2], e0 = param[1];
		                       return cont([0, e0, [0, e1, [0, e2, 0]]]);
		                      },
		                      [0, int_schema, [0, int_schema, [0, int_schema, 0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               function Make_string(C){
		                function encode_versioned(schema, t, cont){
		                 return caml_trampoline_cps_call3
		                         (C[3],
		                          schema,
		                          t,
		                          function(match){
		                           var res = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (C[7], res, function(a){return cont([0, a]);});
		                          });
		                }
		                function encode(schema, t, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (encode_versioned,
		                          schema,
		                          t,
		                          function(a){return cont(a[1]);});
		                }
		                function decode(schema, s, cont){
		                 return caml_exact_trampoline_cps_call
		                         (C[6],
		                          s,
		                          function(match){
		                           if(0 === match[0]){
		                            var t = match[1];
		                            return caml_trampoline_cps_call3(C[4], schema, t, cont);
		                           }
		                           var msg = match[1];
		                           return cont([1, [0, 0, 0, msg]]);
		                          });
		                }
		                var content_type = C[5];
		                return [0, , encode, , decode, content_type];
		               }
		               function case$(decoder, encoder, opt, key, since, name, schema){
		                var inline = opt ? opt[1] : 0;
		                return [0,
		                        decoder,
		                        encoder,
		                        inline,
		                        key,
		                        name,
		                        name,
		                        schema,
		                        since];
		               }
		               function field
		               (description,
		                a,
		                maximum,
		                minimum,
		                opt,
		                requirement,
		                since,
		                title,
		                name,
		                schema){
		                var examples = a ? a[1] : 0, omit = opt ? opt[1] : 0;
		                return [0,
		                        description,
		                        examples,
		                        maximum,
		                        minimum,
		                        name,
		                        omit,
		                        requirement,
		                        schema,
		                        since,
		                        title];
		               }
		               function object(decode, encode, fields){
		                function fields$0(fields){
		                 if(! fields) return 0;
		                 var tail = fields[2], field = fields[1];
		                 return [0, field, fields$0(tail)];
		                }
		                return [7, decode, encode, fields$0(fields)];
		               }
		               function tuple(decode, encode, items){
		                function items$0(fields){
		                 if(! fields) return 0;
		                 var rest = fields[2], schema = fields[1];
		                 return [0, schema, items$0(rest)];
		                }
		                return [10, decode, encode, items$0(items)];
		               }
		               function union$2(key, cases){return [11, key, cases, 0];}
		               var
		                Coding =
		                  [248,
		                   "Schematic__Json__Json_coding_intf.Coding",
		                   caml_fresh_oo_id()];
		               function pp_token(fmt, param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, "Json_scanner_intf.End", cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, "Json_scanner_intf.Null", cont);
		                   case 2:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Json_scanner_intf.Array_start",
		                             cont);
		                   case 3:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, "Json_scanner_intf.Array_end", cont);
		                   case 4:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Json_scanner_intf.Object_start",
		                             cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, "Json_scanner_intf.Object_end", cont);
		                 }
		                switch(param[0]){
		                  case 0:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            jP,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      jQ,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), jR, cont);
		        });
		                                      });
		                            });
		                  case 1:
		                   var a0$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            jS,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      jT,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), jU, cont);
		        });
		                                      });
		                            });
		                  case 2:
		                   var a0$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            jV,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      jW,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$1,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), jX, cont);
		        });
		                                      });
		                            });
		                  default:
		                   var a0$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            jY,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      jZ,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$2,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), j0, cont);
		        });
		                                      });
		                            });
		                }
		               }
		               var
		                Parse_error$0 =
		                  [248,
		                   "Schematic__Json__Json_scanner.Error.Parse_error",
		                   caml_fresh_oo_id()];
		               function raise$0(error){
		                throw caml_maybe_attach_backtrace
		                       ([0, Parse_error$0, error], 1);
		               }
		               function pp$8(f, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var expected = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            j1,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a, pp_expected, expected, cont);
		                            });
		                  case 1:
		                   var illegal_escape = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            j2,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a, pp_illegal_escape, illegal_escape, cont);
		                            });
		                  case 2:
		                   var c = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            j3,
		                            function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                  case 3:
		                   var l = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            j4,
		                            function(a){return caml_trampoline_cps_call2(a, l, cont);});
		                  case 4:
		                   var n = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            j5,
		                            function(a){return caml_trampoline_cps_call2(a, n, cont);});
		                  default:
		                   var unclosed = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            j6,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a, pp_unclosed, unclosed, cont);
		                            });
		                }
		               }
		               var cst_end_of_input = "end of input";
		               function pp_expected(f, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, "JSON value", cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, "':'", cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, cst_end_of_input, cont);
		                  case 3:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, "',' or ']'", cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, "object member or '}'", cont);
		                }
		               }
		               function pp_illegal_escape(f, cont){
		                function pp_cp(f, u, cont){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          j7,
		                          function(a){return caml_trampoline_cps_call2(a, u, cont);});
		                }
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var c = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      j8,
		                                      function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                            case 1:
		                             var c$0 = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      j9,
		                                      function(a){return caml_trampoline_cps_call2(a, c$0, cont);});
		                            case 2:
		                             var p = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      j_,
		                                      function(a){
		                                       return caml_trampoline_cps_call3(a, pp_cp, p, cont);
		                                      });
		                            case 3:
		                             var p$0 = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      j$,
		                                      function(a){
		                                       return caml_trampoline_cps_call3(a, pp_cp, p$0, cont);
		                                      });
		                            default:
		                             var p$1 = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      ka,
		                                      function(a){
		                                       return caml_trampoline_cps_call3(a, pp_cp, p$1, cont);
		                                      });
		                          }
		                         });
		               }
		               function pp_unclosed(f, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, cst_array, cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, cst_object, cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, cst_string, cont);
		                }
		               }
		               function eoi$0(param){
		                var pos = param[5], length = param[6];
		                return length <= pos ? 1 : 0;
		               }
		               function peekc(param){
		                var pos = param[5], src = param[8];
		                return caml_string_unsafe_get(src, pos);
		               }
		               function skip_ws(scanner){
		                for(;;){
		                 if(scanner[5] < scanner[6]){
		                  var a = peekc(scanner);
		                  a:
		                  {
		                   b:
		                   {
		                    if(11 <= a){if(32 !== a) break b;} else if(9 > a) break b;
		                    a = 1;
		                    break a;
		                   }
		                   a = 0;
		                  }
		                  if(a){scanner[5] = scanner[5] + 1 | 0; continue;}
		                 }
		                 return;
		                }
		               }
		               function read_escape(buffer, scanner, cont){
		                if(eoi$0(scanner)) raise$0(kc);
		                var c$0 = peekc(scanner);
		                scanner[5] = scanner[5] + 1 | 0;
		                if(34 === c$0)
		                 return caml_exact_trampoline_cps_call$1
		                         (add_char, buffer, 34, cont);
		                if(92 <= c$0){
		                 if(118 > c$0)
		                  switch(c$0 - 92 | 0){
		                    case 0:
		                     return caml_exact_trampoline_cps_call$1
		                             (add_char, buffer, 92, cont);
		                    case 6:
		                     return caml_exact_trampoline_cps_call$1
		                             (add_char, buffer, 8, cont);
		                    case 10:
		                     return caml_exact_trampoline_cps_call$1
		                             (add_char, buffer, 12, cont);
		                    case 18:
		                     return caml_exact_trampoline_cps_call$1
		                             (add_char, buffer, 10, cont);
		                    case 22:
		                     return caml_exact_trampoline_cps_call$1
		                             (add_char, buffer, 13, cont);
		                    case 24:
		                     return caml_exact_trampoline_cps_call$1
		                             (add_char, buffer, 9, cont);
		                    case 25:
		                     var hi = 0, u = 0, count = 4;
		                     for(;;){
		                      var
		                       baddc =
		                         function(cp, cont){
		                          return 127 < cp
		                                  ? 2047
		                                    < cp
		                                    ? 65535
		                                      < cp
		                                      ? caml_exact_trampoline_cps_call
		(chr,
		 240 | cp >>> 18 | 0,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (add_char,
		           buffer,
		           a,
		           function(a){
		            return caml_exact_trampoline_cps_call
		                    (chr,
		                     128 | (cp >>> 12 | 0) & 63,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (add_char,
		                               buffer,
		                               a,
		                               function(a){
		                                return caml_exact_trampoline_cps_call
		(chr,
		 128 | (cp >>> 6 | 0) & 63,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (add_char,
		           buffer,
		           a,
		           function(a){
		            return caml_exact_trampoline_cps_call
		                    (chr,
		                     128 | cp & 63,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (add_char, buffer, a, cont);
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 })
		                                      : caml_exact_trampoline_cps_call
		(chr,
		 224 | cp >>> 12 | 0,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (add_char,
		           buffer,
		           a,
		           function(a){
		            return caml_exact_trampoline_cps_call
		                    (chr,
		                     128 | (cp >>> 6 | 0) & 63,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (add_char,
		                               buffer,
		                               a,
		                               function(a){
		                                return caml_exact_trampoline_cps_call
		(chr,
		 128 | cp & 63,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (add_char, buffer, a, cont);
		 });
		                               });
		                     });
		           });
		 })
		                                    : caml_exact_trampoline_cps_call
		                                      (chr,
		                                       192 | cp >>> 6 | 0,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (add_char,
		         buffer,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (chr,
		                   128 | cp & 63,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (add_char, buffer, a, cont);
		                   });
		         });
		                                       })
		                                  : caml_exact_trampoline_cps_call
		                                    (chr,
		                                     cp,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (add_char, buffer, a, cont);
		                                     });
		                         },
		                       err_lone_hi = function(p){return raise$0([1, [4, p]]);};
		                      if(0 < count){
		                       if(eoi$0(scanner)) return cont(raise$0(kb));
		                       var c = peekc(scanner), a = c - 48 | 0;
		                       a:
		                       {
		                        if(22 < a >>> 0){
		                         if(5 < a - 49 >>> 0) break a;
		                        }
		                        else if(6 >= a - 10 >>> 0) break a;
		                        a = 57 < c ? 70 < c ? c - 87 | 0 : c - 55 | 0 : c - 48 | 0;
		                        var u$0 = (u * 16 | 0) + a | 0;
		                        scanner[5] = scanner[5] + 1 | 0;
		                        var count$0 = count - 1 | 0;
		                        u = u$0;
		                        count = count$0;
		                        continue;
		                       }
		                       return cont(raise$0([1, [0, c]]));
		                      }
		                      if(hi){
		                       var hi$0 = hi[1];
		                       if(56320 <= u && 57343 >= u){
		                        var u$1 = ((hi$0 & 1023) << 10 | u & 1023) + 65536 | 0;
		                        return caml_exact_trampoline_cps_call(baddc, u$1, cont);
		                       }
		                       return cont(raise$0([1, [2, u]]));
		                      }
		                      if(55296 <= u && 57343 >= u){
		                       if(56319 < u) return cont(raise$0([1, [3, u]]));
		                       if(! eoi$0(scanner) && 92 === peekc(scanner)){
		                        scanner[5] = scanner[5] + 1 | 0;
		                        if(! eoi$0(scanner) && 117 === peekc(scanner)){
		                         scanner[5] = scanner[5] + 1 | 0;
		                         var hi$1 = [0, u];
		                         hi = hi$1;
		                         u = 0;
		                         count = 4;
		                         continue;
		                        }
		                        return cont(err_lone_hi(u));
		                       }
		                       return cont(err_lone_hi(u));
		                      }
		                      return caml_exact_trampoline_cps_call(baddc, u, cont);
		                     }
		                  }
		                }
		                else if(47 === c$0)
		                 return caml_exact_trampoline_cps_call$1
		                         (add_char, buffer, 47, cont);
		                return cont(raise$0([1, [1, c$0]]));
		               }
		               function read_string(scanner, cont){
		                function err_str_char(c){return raise$0([2, c]);}
		                function read_chunk(buffer, cont){
		                 function a(buffer$2){
		                  var
		                   s = scanner[8],
		                   start = scanner[5],
		                   n = scanner[6],
		                   b = 0;
		                  a:
		                  for(;;)
		                   switch(b){
		                     case 0:
		                      var i = start;
		                      for(;;){
		                       if(n <= i){var i$4 = i; b = 1; continue a;}
		                       var b0 = caml_string_unsafe_get(s, i);
		                       if(32 <= b0 && 34 !== b0 && 92 !== b0 && 128 > b0){var i$3 = i + 1 | 0; i = i$3; continue;}
		                       if(192 > b0) break;
		                       if(240 <= b0){
		                        if(248 <= b0){b = 7; continue a;}
		                        if(n <= (i + 3 | 0)){b = 2; continue a;}
		                        var
		                         j = i + 1 | 0,
		                         b1 = caml_string_unsafe_get(s, j),
		                         j$0 = i + 2 | 0,
		                         b2 = caml_string_unsafe_get(s, j$0),
		                         j$1 = i + 3 | 0,
		                         b3 = caml_string_unsafe_get(s, j$1);
		                        if(128 !== (b1 & 192)){b = 3; continue a;}
		                        if(128 !== (b2 & 192)){b = 4; continue a;}
		                        if(128 !== (b3 & 192)){b = 5; continue a;}
		                        var
		                         cp =
		                           (b0 & 7) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
		                        if(65536 > cp){b = 6; continue a;}
		                        if(1114111 < cp){b = 6; continue a;}
		                        var i$0 = i + 4 | 0;
		                        i = i$0;
		                       }
		                       else if(224 <= b0){
		                        if(n <= (i + 2 | 0)) raise$0(ke);
		                        var
		                         j$2 = i + 1 | 0,
		                         b1$0 = caml_string_unsafe_get(s, j$2),
		                         j$3 = i + 2 | 0,
		                         b2$0 = caml_string_unsafe_get(s, j$3);
		                        if(128 !== (b1$0 & 192)){b = 8; continue a;}
		                        if(128 !== (b2$0 & 192)){b = 9; continue a;}
		                        var cp$0 = (b0 & 15) << 12 | (b1$0 & 63) << 6 | b2$0 & 63;
		                        if(2048 > cp$0){b = 10; continue a;}
		                        if(55296 <= cp$0 && 57343 >= cp$0){b = 11; continue a;}
		                        var i$1 = i + 3 | 0;
		                        i = i$1;
		                       }
		                       else {
		                        if(n <= (i + 1 | 0)) raise$0(kf);
		                        var j$4 = i + 1 | 0, b1$1 = caml_string_unsafe_get(s, j$4);
		                        if(128 !== (b1$1 & 192)) err_str_char(b1$1);
		                        var cp$1 = (b0 & 31) << 6 | b1$1 & 63;
		                        if(128 > cp$1){b = 12; continue a;}
		                        var i$2 = i + 2 | 0;
		                        i = i$2;
		                       }
		                      }
		                     case 13:
		                      if(128 <= b0){b = 7; continue;} i$4 = i; b = 1; continue;
		                     case 12:
		                      i$4 = err_str_char(b0); b = 1; continue;
		                     case 11:
		                      i$4 = err_str_char(b0); b = 1; continue;
		                     case 10:
		                      i$4 = err_str_char(b0); b = 1; continue;
		                     case 9:
		                      i$4 = err_str_char(b2$0); b = 1; continue;
		                     case 8:
		                      i$4 = err_str_char(b1$0); b = 1; continue;
		                     case 7:
		                      i$4 = err_str_char(b0); b = 1; continue;
		                     case 6:
		                      i$4 = err_str_char(b0); b = 1; continue;
		                     case 5:
		                      i$4 = err_str_char(b3); b = 1; continue;
		                     case 4:
		                      i$4 = err_str_char(b2); b = 1; continue;
		                     case 3:
		                      i$4 = err_str_char(b1); b = 1; continue;
		                     case 2:
		                      i$4 = raise$0(kd);
		                     case 1:
		                      if(n <= i$4) return cont(raise$0(kg));
		                      var c = caml_string_unsafe_get(s, i$4);
		                      if(34 === c){
		                       scanner[5] = i$4 + 1 | 0;
		                       if(! buffer$2)
		                        return caml_exact_trampoline_cps_call$0
		                                (get_sub, s, start, i$4 - start | 0, cont);
		                       var buffer$3 = buffer$2[1];
		                       return caml_exact_trampoline_cps_call$2
		                               (add_substring,
		                                buffer$3,
		                                s,
		                                start,
		                                i$4 - start | 0,
		                                function(match){
		                                 return caml_exact_trampoline_cps_call
		 (contents, buffer$3, cont);
		                                });
		                      }
		                      if(buffer$2)
		                       var buffer = buffer$2[1], buffer$4 = buffer;
		                      else {
		                       b = scanner[3];
		                       if(b){
		                        var buffer$0 = b[1];
		                        clear$1(buffer$0);
		                        buffer$4 = buffer$0;
		                       }
		                       else {
		                        var buffer$1 = create$1(4096);
		                        scanner[3] = [0, buffer$1];
		                        buffer$4 = buffer$1;
		                       }
		                      }
		                      return caml_exact_trampoline_cps_call$2
		                              (add_substring,
		                               buffer$4,
		                               s,
		                               start,
		                               i$4 - start | 0,
		                               function(match){
		                                return 92 === c
		? (scanner
		   [5]
		  = i$4 + 1 | 0,
		  caml_exact_trampoline_cps_call$1
		   (read_escape,
		    buffer$4,
		    scanner,
		    function(match){
		     var buffer = [0, buffer$4];
		     return caml_exact_trampoline_call1(a, buffer);
		    }))
		: cont(err_str_char(c));
		                               });
		                   }
		                 }
		                 return a(buffer);
		                }
		                return caml_exact_trampoline_cps_call(read_chunk, 0, cont);
		               }
		               function is_val_sep(a){
		                a:
		                {
		                 if(44 <= a){
		                  a = a - 45 | 0;
		                  if(79 < a >>> 0){
		                   if(81 <= a) break a;
		                  }
		                  else if(48 !== a) break a;
		                 }
		                 else
		                  if(11 <= a){if(32 !== a) break a;} else if(9 > a) break a;
		                 return 1;
		                }
		                return 0;
		               }
		               function read_value(scanner, cont){
		                if(eoi$0(scanner)) return cont(raise$0(kj));
		                var match = peekc(scanner);
		                a:
		                {
		                 if(92 <= match){
		                  if(111 <= match){
		                   if(116 !== match){
		                    if(123 !== match) break a;
		                    scanner[2] = 1;
		                    scanner[1] = 1;
		                    scanner[7] = [0, 1, scanner[7]];
		                    scanner[5] = scanner[5] + 1 | 0;
		                    return cont(4);
		                   }
		                  }
		                  else if(102 !== match && 110 > match) break a;
		                  var start$0 = scanner[5], i$1 = start$0;
		                  for(;;){
		                   if(i$1 >= scanner[6]) break;
		                   var s$0 = scanner[8];
		                   if(is_val_sep(caml_string_unsafe_get(s$0, i$1))) break;
		                   var i$2 = i$1 + 1 | 0;
		                   i$1 = i$2;
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (get_sub,
		                           scanner[8],
		                           start$0,
		                           i$1 - start$0 | 0,
		                           function(repr){
		                            scanner[5] = i$1;
		                            return repr !== cst_false
		                                    ? repr
		                                      !== cst_null
		                                      ? repr !== cst_true ? cont(raise$0([3, repr])) : cont(kh)
		                                      : cont(1)
		                                    : cont(ki);
		                           });
		                 }
		                 if(46 <= match){
		                  if(58 <= match){
		                   if(91 > match) break a;
		                   scanner[2] = 1;
		                   scanner[7] = [0, 0, scanner[7]];
		                   scanner[5] = scanner[5] + 1 | 0;
		                   return cont(2);
		                  }
		                  if(48 > match) break a;
		                 }
		                 else {
		                  if(34 === match){
		                   scanner[5] = scanner[5] + 1 | 0;
		                   return caml_exact_trampoline_cps_call
		                           (read_string, scanner, function(a){return cont([1, a]);});
		                  }
		                  if(45 > match) break a;
		                 }
		                 var start = scanner[5], i = start;
		                 for(;;){
		                  if(i >= scanner[6]) break;
		                  var s = scanner[8];
		                  if(is_val_sep(caml_string_unsafe_get(s, i))) break;
		                  var i$0 = i + 1 | 0;
		                  i = i$0;
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (get_sub,
		                          scanner[8],
		                          start,
		                          i - start | 0,
		                          function(repr){
		                           scanner[5] = i;
		                           try{var a = [2, caml_float_of_string(repr)];}
		                           catch(exn$1){
		                            var exn = caml_wrap_exception(exn$1);
		                            if(exn[1] === Failure) return cont(raise$0([4, repr]));
		                            a = caml_pop_trap();
		                            var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                            return a(exn$0);
		                           }
		                           return cont(a);
		                          });
		                }
		                return cont(raise$0(kk));
		               }
		               function pop(scanner){
		                var match = scanner[7];
		                if(! match)
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, kl], 1);
		                var ss = match[2];
		                if(ss && ss[1]){scanner[1] = 1; scanner[7] = ss; return;}
		                var ss$0 = match[2];
		                scanner[1] = 0;
		                scanner[7] = ss$0;
		               }
		               function scan$0(scanner, cont){
		                skip_ws(scanner);
		                var a = scanner[7];
		                if(! a)
		                 return scanner[4]
		                         ? (scanner
		                            [4]
		                           = 0,
		                           caml_exact_trampoline_cps_call(read_value, scanner, cont))
		                         : eoi$0(scanner) ? cont(0) : cont(raise$0(ks));
		                if(a[1]){
		                 if(scanner[1]){
		                  var
		                   r_name =
		                     function(scanner, cont){
		                      if(! eoi$0(scanner) && 34 === peekc(scanner)){
		                       scanner[5] = scanner[5] + 1 | 0;
		                       return caml_exact_trampoline_cps_call
		                               (read_string, scanner, function(a){return cont([3, a]);});
		                      }
		                      return cont(raise$0(kp));
		                     },
		                   at_array_start$0 = scanner[2];
		                  scanner[2] = 0;
		                  scanner[1] = 0;
		                  if(eoi$0(scanner)) raise$0(kq);
		                  var c = peekc(scanner);
		                  return 125 === c
		                          ? (pop(scanner), scanner[5] = scanner[5] + 1 | 0, cont(5))
		                          : at_array_start$0
		                            ? caml_exact_trampoline_cps_call(r_name, scanner, cont)
		                            : 44
		                              === c
		                              ? (scanner
		                                 [5]
		                                = scanner[5] + 1 | 0,
		                                skip_ws(scanner),
		                                caml_exact_trampoline_cps_call(r_name, scanner, cont))
		                              : cont(raise$0(kr));
		                 }
		                 scanner[1] = 1;
		                 if(! eoi$0(scanner) && 58 === peekc(scanner)){
		                  scanner[5] = scanner[5] + 1 | 0;
		                  skip_ws(scanner);
		                  return caml_exact_trampoline_cps_call
		                          (read_value, scanner, cont);
		                 }
		                 return cont(raise$0(ko));
		                }
		                var at_array_start = scanner[2];
		                scanner[2] = 0;
		                if(eoi$0(scanner)) raise$0(km);
		                a = peekc(scanner);
		                if(44 === a){
		                 if(! at_array_start){
		                  scanner[5] = scanner[5] + 1 | 0;
		                  skip_ws(scanner);
		                  return caml_exact_trampoline_cps_call
		                          (read_value, scanner, cont);
		                 }
		                }
		                else if(93 === a){
		                 pop(scanner);
		                 scanner[5] = scanner[5] + 1 | 0;
		                 return cont(3);
		                }
		                return at_array_start
		                        ? caml_exact_trampoline_cps_call(read_value, scanner, cont)
		                        : cont(raise$0(kn));
		               }
		               var
		                schematic_cache = [0, empty$11([0, comparator$9])],
		                letrec_function_context$2 = [];
		               caml_update_dummy
		                (letrec_function_context$2, [0, schematic_cache]);
		               var schematic_schema_version = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$2[1][1], schematic_schema_version]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$2[1][1],
		                             schematic_schema_version,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$2[1][1],
		schematic_schema_version,
		schematic_self,
		function(a){
		 letrec_function_context$2[1][1] = a;
		 var
		  res =
		    [10,
		     function(param, cont){
		      var a = param[2], e2 = a[2][1], e1 = a[1], e0 = param[1];
		      return cont([0, e0, e1, e2]);
		     },
		     function(param, cont){
		      var e2 = param[3], e1 = param[2], e0 = param[1];
		      return cont([0, e0, [0, e1, [0, e2, 0]]]);
		     },
		     [0, int_schema, [0, int_schema, [0, int_schema, 0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$2[1][1],
		          schematic_schema_version,
		          res,
		          function(a){
		           letrec_function_context$2[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$0 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$3 = [];
		               caml_update_dummy
		                (letrec_function_context$3, [0, schematic_cache$0]);
		               var
		                schema$269 = [0, 0, 0, 9, 0],
		                schematic_schema_version$0 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$3[1][1],
		                    schematic_schema_version$0]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$3[1][1],
		                             schematic_schema_version$0,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$3[1][1],
		schematic_schema_version$0,
		schematic_self,
		function(a){
		 letrec_function_context$3[1][1] = a;
		 var
		  res =
		    [10,
		     function(param, cont){
		      var e1 = param[2][1], e0 = param[1];
		      return cont([0, e0, e1]);
		     },
		     function(param, cont){
		      var e1 = param[2], e0 = param[1];
		      return cont([0, e0, [0, e1, 0]]);
		     },
		     [0, schema$269, [0, int_schema, 0]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$3[1][1],
		          schematic_schema_version$0,
		          res,
		          function(a){
		           letrec_function_context$3[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var no_input_schema = [0, 0, 0, 6, 0];
		               function schema_versioned(param){return no_input_schema;}
		               function pp$9(f, json, cont){
		                function a(pp){
		                 return caml_exact_trampoline_cps_call$1(pp, f, dummy, cont);
		                }
		                if(typeof json === "number")
		                 return a
		                         (function(ppf, param, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, ppf, cst_null, cont);
		                          });
		                var variant = json[1], indent = 2;
		                if(65 === variant){
		                 var elements = json[2], pp_v = list([0, comma], pp$9);
		                 return a
		                         (function(state, v, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_open_box,
		                                    state,
		                                    0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string,
		      state,
		      cst$37,
		      function(a){
		       return function(indent){
		                return caml_exact_trampoline_cps_call$0
		                        (pp_open_box_gen,
		                         state,
		                         indent,
		                         2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_v0,
		                                   state,
		                                   dummy,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_v,
		     state,
		     elements,
		     function(a){
		      pp_close_box(state);
		      return caml_exact_trampoline_cps_call$1
		              (pp_v0,
		               state,
		               dummy,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         state,
		                         cst$36,
		                         function(a){return cont(pp_close_box(state));});
		               });
		     });
		                                   });
		                         });
		               }
		               (indent);
		      });
		                                    });
		                          });
		                }
		                if(365180284 > variant){
		                 if(79 > variant)
		                  return caml_exact_trampoline_cps_call$1
		                          (value_to_string,
		                           0,
		                           json,
		                           function(v){
		                            return a
		                                    (function(ppf, param, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, ppf, v, cont);
		                                     });
		                           });
		                 var
		                  elements$0 = json[2],
		                  c =
		                    [0,
		                     function(ppf, v, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (pp_print_string,
		                               ppf,
		                               cst$21,
		                               function(a){return cont(pp_v1(ppf));});
		                     }],
		                  pp_v$0 =
		                    list
		                     ([0, comma],
		                      function(ppf, v, cont){
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_open_box,
		                                ppf,
		                                indent,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$3
		 (pair,
		  c,
		  string$1,
		  pp$9,
		  ppf,
		  v,
		  function(a){return cont(pp_close_box(ppf));});
		                                });
		                      });
		                 return a
		                         (function(state, v, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_open_box,
		                                    state,
		                                    0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string,
		      state,
		      cst$12,
		      function(a){
		       return function(indent){
		                return caml_exact_trampoline_cps_call$0
		                        (pp_open_box_gen,
		                         state,
		                         indent,
		                         2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_v0,
		                                   state,
		                                   dummy,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_v$0,
		     state,
		     elements$0,
		     function(a){
		      pp_close_box(state);
		      return caml_exact_trampoline_cps_call$1
		              (pp_v0,
		               state,
		               dummy,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         state,
		                         cst$11,
		                         function(a){return cont(pp_close_box(state));});
		               });
		     });
		                                   });
		                         });
		               }
		               (indent);
		      });
		                                    });
		                          });
		                }
		                if(737456202 <= variant){
		                 var b = json[2];
		                 return a
		                         (function(ppf, param, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_bool, ppf, b, cont);
		                          });
		                }
		                var f$0 = json[2];
		                return a
		                        (function(ppf, param, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (float, ppf, f$0, cont);
		                         });
		               }
		               caml_callback(compare$27, [no_input_schema]);
		               function type_name(param, cont){
		                if(typeof param === "number") return cont(cst_null);
		                var variant = param[1];
		                return 65 === variant
		                        ? cont(cst_array)
		                        : 365180284
		                          <= variant
		                          ? 737456202 <= variant ? cont(cst_bool) : cont(cst_float)
		                          : 79 <= variant ? cont(cst_object) : cont(cst_string);
		               }
		               function null$(param, cont){return cont(870828711);}
		               function of_any(coding, v, cont){
		                return coding === Coding ? cont([0, v]) : cont(0);
		               }
		               function of_bool(b, cont){return cont([0, 737456202, b]);}
		               function of_fields(f, cont){return cont([0, 79, f]);}
		               function of_float$3(f, cont){return cont([0, 365180284, f]);}
		               function of_int$3(i, cont){return cont([0, 365180284, i]);}
		               function of_int64(i, cont){
		                return cont([0, 365180284, caml_int64_to_float(i)]);
		               }
		               function of_json(v, cont){return cont(v);}
		               function of_list$3(l, cont){return cont([0, 65, l]);}
		               function of_option$0(param, cont){
		                if(! param) return cont(870828711);
		                var v = param[1];
		                return cont(v);
		               }
		               function of_string$9(s, cont){return cont([0, -976970511, s]);}
		               function of_time(t, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (to_rfc3339,
		                         0,
		                         0,
		                         0,
		                         t,
		                         function(a){return cont([0, -976970511, a]);});
		               }
		               function of_time_local(param, cont){
		                var tz_offset_s = param[2], t = param[1];
		                return caml_exact_trampoline_cps_call$2
		                        (to_rfc3339,
		                         0,
		                         0,
		                         [0, tz_offset_s],
		                         t,
		                         function(a){return cont([0, -976970511, a]);});
		               }
		               function to_bool(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(737456202 === variant){
		                  var v = param[2];
		                  return cont([0, v]);
		                 }
		                }
		                return cont(0);
		               }
		               function to_fields(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(79 === variant){
		                  var fields = param[2];
		                  return cont([0, fields]);
		                 }
		                }
		                return cont(0);
		               }
		               function to_float$2(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(365180284 === variant){
		                  var v = param[2];
		                  return cont([0, v]);
		                 }
		                }
		                return cont(0);
		               }
		               function to_int$0(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(365180284 === variant){
		                  var v = param[2];
		                  return caml_exact_trampoline_cps_call
		                          (of_float, v, function(a){return cont([0, a]);});
		                 }
		                }
		                return cont(0);
		               }
		               function to_int64$1(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(365180284 === variant){
		                  var v = param[2];
		                  return cont([0, caml_int64_of_float(v)]);
		                 }
		                }
		                return cont(0);
		               }
		               function to_json(v, cont){return cont([0, v]);}
		               function to_list$4(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(65 === variant){var l = param[2]; return cont([0, l]);}
		                }
		                return cont(0);
		               }
		               function to_option(v, cont){
		                if(typeof v === "number" && 870828711 === v) return cont(kt);
		                return cont([0, [0, v]]);
		               }
		               function to_string$13(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(-976970511 === variant){
		                  var v = param[2];
		                  return cont([0, v]);
		                 }
		                }
		                return cont(0);
		               }
		               function to_time(param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(-976970511 === variant){
		                  var s = param[2], t = of_rfc3339(ku, 0, 0, s);
		                  if(0 === t[0]) return cont(t);
		                  var x = t[1], e = x[2][2];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$12,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (a,
		                                     pp_rfc3339_error,
		                                     e,
		                                     function(a){return cont([1, [0, a]]);});
		                           });
		                 }
		                }
		                return cont([1, 0]);
		               }
		               function to_time$0(v, cont){
		                function a(param, cont){var t = param[1]; return cont(t);}
		                return caml_exact_trampoline_cps_call
		                        (to_time,
		                         v,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_map$0, b, a, cont);
		                         });
		               }
		               function to_time_local(v, cont){
		                function a(param, cont){
		                 var match = param[2], t = param[1];
		                 if(! match) return cont([1, x]);
		                 var tz = match[1];
		                 return caml_exact_trampoline_cps_call
		                         (of_string$0, [0, t, tz], cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (to_time,
		                         v,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$1, b, a, cont);
		                         });
		               }
		               var
		                key_get = 61643255,
		                key_set = 61643255,
		                of_date$0 = 61643255,
		                to_date = 61643255,
		                Impl =
		                  [0,
		                   Coding,
		                   cst_JSON,
		                   ,
		                   pp$9,
		                   key_get,
		                   key_set,
		                   null$,
		                   of_any,
		                   of_bool,
		                   of_date$0,
		                   of_fields,
		                   of_float$3,
		                   of_int$3,
		                   of_int64,
		                   of_json,
		                   of_list$3,
		                   of_option$0,
		                   of_string$9,
		                   of_time,
		                   of_time_local,
		                   to_bool,
		                   to_date,
		                   to_fields,
		                   to_float$2,
		                   to_int$0,
		                   to_int64$1,
		                   to_json,
		                   to_list$4,
		                   to_option,
		                   to_string$13,
		                   to_time$0,
		                   to_time_local,
		                   type_name];
		               function Make$6(Json_impl, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make$5,
		                         Impl,
		                         function(include){
		                          var
		                           encode = include[2],
		                           encode_versioned = include[3],
		                           decode = include[4];
		                          function of_string(s, cont){
		                           return caml_exact_trampoline_cps_call(Json_impl[1], s, cont);
		                          }
		                          function to_string(t, cont){
		                           return caml_exact_trampoline_cps_call(Json_impl[2], t, cont);
		                          }
		                          function to_ezjsonm(v){return v;}
		                          function compare(l, r, cont){
		                           if(typeof l === "number"){
		                            if(typeof r === "number" && 870828711 === r) return cont(0);
		                            return cont(-1);
		                           }
		                           var a = l[1];
		                           if(65 === a){
		                            if(typeof r !== "number"){
		                             var variant$6 = r[1];
		                             if(65 === variant$6){
		                              var r$0 = r[2], l$0 = l[2];
		                              return caml_exact_trampoline_cps_call$0
		                                      (compare_list, compare, l$0, r$0, cont);
		                             }
		                            }
		                           }
		                           else
		                            if(365180284 <= a){
		                             if(737456202 <= a){
		                              if(typeof r !== "number"){
		                               var variant$7 = r[1];
		                               if(737456202 === variant$7){
		                                var r$1 = r[2], l$1 = l[2];
		                                return cont(caml_int_compare(l$1, r$1));
		                               }
		                              }
		                             }
		                             else if(typeof r !== "number"){
		                              var variant$8 = r[1];
		                              if(365180284 === variant$8){
		                               var r$2 = r[2], l$2 = l[2];
		                               return cont(caml_float_compare(l$2, r$2));
		                              }
		                             }
		                            }
		                            else
		                             if(79 <= a){
		                              if(typeof r !== "number"){
		                               var variant$9 = r[1];
		                               if(79 === variant$9){
		                                var
		                                 r$3 = r[2],
		                                 l$3 = l[2],
		                                 compare$0 =
		                                   function(a, param, cont){
		                                    var r = param[1], l = a[1];
		                                    return cont(caml_string_compare(l, r));
		                                   },
		                                 compare_field =
		                                   function(a, param, cont){
		                                    var
		                                     rv = param[2],
		                                     rk = param[1],
		                                     lv = a[2],
		                                     lk = a[1],
		                                     n = caml_string_compare(lk, rk);
		                                    return 0 === n
		    ? caml_exact_trampoline_cps_call$1(compare, lv, rv, cont)
		    : cont(n);
		                                   };
		                                return caml_exact_trampoline_cps_call$1
		(stable_sort,
		 l$3,
		 compare$0,
		 function(l){
		  return caml_exact_trampoline_cps_call$1
		          (stable_sort,
		           r$3,
		           compare$0,
		           function(r){
		            return caml_exact_trampoline_cps_call$0
		                    (compare_list, compare_field, l, r, cont);
		           });
		 });
		                               }
		                              }
		                             }
		                             else if(typeof r !== "number"){
		                              var variant$10 = r[1];
		                              if(-976970511 === variant$10){
		                               var r$4 = r[2], l$4 = l[2];
		                               return cont(caml_string_compare(l$4, r$4));
		                              }
		                             }
		                           if(typeof r === "number" && 870828711 === r) return cont(1);
		                           if(typeof l !== "number"){
		                            var variant$5 = l[1];
		                            if(737456202 === variant$5) return cont(-1);
		                           }
		                           if(typeof r !== "number"){
		                            var variant$4 = r[1];
		                            if(737456202 === variant$4) return cont(1);
		                           }
		                           if(typeof l !== "number"){
		                            var variant$3 = l[1];
		                            if(365180284 === variant$3) return cont(-1);
		                           }
		                           if(typeof r !== "number"){
		                            var variant$2 = r[1];
		                            if(365180284 === variant$2) return cont(1);
		                           }
		                           if(typeof l !== "number"){
		                            var variant$1 = l[1];
		                            if(-976970511 === variant$1) return cont(-1);
		                           }
		                           if(typeof r !== "number"){
		                            var variant$0 = r[1];
		                            if(-976970511 === variant$0) return cont(1);
		                           }
		                           if(typeof l !== "number"){
		                            var variant = l[1];
		                            if(65 === variant) return cont(-1);
		                           }
		                           return cont(1);
		                          }
		                          var
		                           include$0 = Make$2([0, compare, sexp_of_t$21]),
		                           equal = include$0[7],
		                           compare$0 = include$0[8];
		                          return cont
		                                  ([0,
		                                    ,
		                                    encode,
		                                    encode_versioned,
		                                    decode,
		                                    cst_application_json,
		                                    of_string,
		                                    ,
		                                    ,
		                                    to_string,
		                                    pp$9,
		                                    to_ezjsonm,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    equal,
		                                    compare$0]);
		                         });
		               }
		               function of_string$10(src, cont){
		                var
		                 decoder =
		                   [0, 0, 0, 0, 1, 0, caml_ml_string_length(src), 0, src],
		                 Abort = [248, "Abort", caml_fresh_oo_id()];
		                function value(l, stack, cont){
		                 if(typeof l === "number")
		                  switch(l){
		                    case 1:
		                     return caml_exact_trampoline_cps_call$1
		                             (continue$, 870828711, stack, cont);
		                    case 2:
		                     return caml_exact_trampoline_cps_call$1(arr, 0, stack, cont);
		                    case 4:
		                     return caml_exact_trampoline_cps_call$1(obj, 0, stack, cont);
		                  }
		                 else
		                  switch(l[0]){
		                    case 0:
		                     var b = l[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (continue$, [0, 737456202, b], stack, cont);
		                    case 1:
		                     var s = l[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (continue$, [0, -976970511, s], stack, cont);
		                    case 2:
		                     var f = l[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (continue$, [0, 365180284, f], stack, cont);
		                  }
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$13,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a,
		                                    pp_token,
		                                    l,
		                                    function(a){
		                                     var raise = caml_pop_trap();
		                                     return raise(caml_maybe_attach_backtrace([0, Abort, a], 1));
		                                    });
		                          });
		                }
		                function arr(so_far, stack, cont){
		                 return caml_exact_trampoline_cps_call
		                         (scan$0,
		                          decoder,
		                          function(l){
		                           if(typeof l === "number" && 3 === l)
		                            return caml_exact_trampoline_cps_call
		                                    (of_rev_keys,
		                                     so_far,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (continue$, [0, 65, a], stack, cont);
		                                     });
		                           var stack$0 = [0, so_far, stack];
		                           return caml_exact_trampoline_cps_call$1
		                                   (value, l, stack$0, cont);
		                          });
		                }
		                function obj(so_far, stack, cont){
		                 return caml_exact_trampoline_cps_call
		                         (scan$0,
		                          decoder,
		                          function(token){
		                           if(typeof token === "number"){
		                            if(5 === token)
		                             return caml_exact_trampoline_cps_call
		                                     (of_rev_keys,
		                                      so_far,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (continue$, [0, 79, a], stack, cont);
		                                      });
		                           }
		                           else if(3 === token[0]){
		                            var n = token[1], stack$0 = [1, n, so_far, stack];
		                            return caml_exact_trampoline_cps_call
		                                    (scan$0,
		                                     decoder,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (value, a, stack$0, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$14,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (a,
		      pp_token,
		      token,
		      function(a){
		       var raise = caml_pop_trap();
		       return raise(caml_maybe_attach_backtrace([0, Abort, a], 1));
		      });
		                                    });
		                          });
		                }
		                function continue$(v, stack, cont){
		                 if(typeof stack === "number")
		                  return caml_exact_trampoline_cps_call
		                          (scan$0,
		                           decoder,
		                           function(token){
		                            if(typeof token === "number" && ! token) return cont(v);
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$15,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (a,
		       pp_token,
		       token,
		       function(a){
		        var raise = caml_pop_trap();
		        return raise(caml_maybe_attach_backtrace([0, Abort, a], 1));
		       });
		                                     });
		                           });
		                 if(0 === stack[0]){
		                  var stack$0 = stack[2], vs = stack[1], so_far = [0, v, vs];
		                  return caml_exact_trampoline_cps_call$1
		                          (arr, so_far, stack$0, cont);
		                 }
		                 var
		                  stack$1 = stack[3],
		                  ms = stack[2],
		                  n = stack[1],
		                  so_far$0 = [0, [0, n, v], ms];
		                 return caml_exact_trampoline_cps_call$1
		                         (obj, so_far$0, stack$1, cont);
		                }
		                caml_push_trap
		                 (function(exn){
		                   if(exn[1] === Abort){
		                    var error = exn[2];
		                    return cont([1, error]);
		                   }
		                   if(exn[1] === Parse_error$0){
		                    var error$0 = exn[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             fmt$16,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (a, pp$8, error$0, function(a){return cont([1, a]);});
		                             });
		                   }
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (scan$0,
		                         decoder,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (value,
		                                   a,
		                                   0,
		                                   function(value){caml_pop_trap(); return cont([0, value]);});
		                         });
		               }
		               function to_string$14(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (value_to_string, kv, t, cont);
		               }
		               var
		                T$0 = caml_callback(Make$6, [[0, of_string$10, to_string$14]]),
		                encode$4 = T$0[2],
		                encode_versioned = T$0[3],
		                decode$2 = T$0[4],
		                of_string$11 = T$0[6],
		                to_string$15 = T$0[9],
		                _16 = T$0[10],
		                to_ezjsonm = T$0[11],
		                equal$15 = T$0[18],
		                compare$29 = T$0[19],
		                String =
		                  Make_string([0, , , T$0[3], T$0[4], T$0[5], T$0[6], T$0[9]]);
		               function uri_reference_schema_versioned(schematic_version){
		                schematic_version();
		                return [0,
		                        kw,
		                        0,
		                        schematic_param_name_schema_ve[3],
		                        schematic_param_name_schema_ve[4]];
		               }
		               function uri_schema_versioned(schematic_version){
		                schematic_version();
		                return [0,
		                        kx,
		                        0,
		                        schematic_param_name_schema_ve[3],
		                        schematic_param_name_schema_ve[4]];
		               }
		               var bool_schema = [0, 0, 0, 0, 0];
		               function additional_properties_schema_v(schematic_version){
		                schematic_version();
		                return function(schematic_param_schema_version, cont){
		                 function descriptor(schematic_param_schema_version){
		                  return [11,
		                          0,
		                          [0,
		                           [0,
		                            function(f0, cont){return cont([0, f0]);},
		                            function(param, cont){
		                             if(0 !== param[0]) return cont(0);
		                             var f0 = param[1];
		                             return cont([0, f0]);
		                            },
		                            0,
		                            0,
		                            "properties_schema",
		                            "Properties_schema",
		                            schematic_param_schema_version,
		                            0],
		                           [0,
		                            [0,
		                             function(f0, cont){return cont([1, f0]);},
		                             function(param, cont){
		                              if(0 === param[0]) return cont(0);
		                              var f0 = param[1];
		                              return cont([0, f0]);
		                             },
		                             0,
		                             0,
		                             "allowed",
		                             "Allowed",
		                             bool_schema,
		                             0],
		                            0]],
		                          0];
		                 }
		                 var
		                  schematic_schema_id = match[1],
		                  schematic_parametric =
		                    [0,
		                     [1,
		                      cst_t,
		                      schematic_param_schema_version,
		                      function(schematic_param_schema_version, cont){
		                       return cont
		                               ([0,
		                                 schematic_schema_id,
		                                 descriptor(schematic_param_schema_version)]);
		                      }]],
		                  a = descriptor(schematic_param_schema_version),
		                  parametric = schematic_parametric[1];
		                 return caml_exact_trampoline_cps_call
		                         (of_parametric,
		                          parametric,
		                          function(match){
		                           function b(b){
		                            return cont([0, b, 0, a, schematic_parametric]);
		                           }
		                           if(! match) return b(0);
		                           var name = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (to_id, name, function(a){return b([0, a]);});
		                          });};
		               }
		               var
		                schematic_cache$1 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$4 = [];
		               caml_update_dummy
		                (letrec_function_context$4, [0, schematic_cache$1]);
		               var
		                schematic_schema_version$52 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$4[1][1],
		                     schematic_schema_version$52]),
		                cst_Array = "Array",
		                cst_Number = "Number";
		               if(e)
		                var schema$2 = e[1], descriptor$2 = schema$2;
		               else
		                descriptor$2 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$4[1][1],
		                              schematic_schema_version$52,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$4[1][1],
		 schematic_schema_version$52,
		 schematic_self,
		 function(a){
		  letrec_function_context$4[1][1] = a;
		  var
		   res =
		     [11,
		      0,
		      [0,
		       [0,
		        function(param, cont){return cont(0);},
		        function(param, cont){return param ? cont(0) : cont(kM);},
		        0,
		        0,
		        cst_array,
		        cst_Array,
		        kL,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(1);},
		         function(param, cont){
		          return 1 === param ? cont(kK) : cont(0);
		         },
		         0,
		         0,
		         cst_boolean,
		         "Boolean",
		         kJ,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(2);},
		          function(param, cont){
		           return 2 === param ? cont(kI) : cont(0);
		          },
		          0,
		          0,
		          cst_integer,
		          "Integer",
		          kH,
		          0],
		         [0,
		          [0,
		           function(param, cont){return cont(3);},
		           function(param, cont){
		            return 3 === param ? cont(kG) : cont(0);
		           },
		           0,
		           0,
		           cst_null,
		           cst_Null,
		           kF,
		           0],
		          [0,
		           [0,
		            function(param, cont){return cont(4);},
		            function(param, cont){
		             return 4 === param ? cont(kE) : cont(0);
		            },
		            0,
		            0,
		            cst_number,
		            cst_Number,
		            kD,
		            0],
		           [0,
		            [0,
		             function(param, cont){return cont(5);},
		             function(param, cont){
		              return 5 === param ? cont(kC) : cont(0);
		             },
		             0,
		             0,
		             cst_object,
		             cst_Object,
		             kB,
		             0],
		            [0,
		             [0,
		              function(param, cont){return cont(6);},
		              function(param, cont){
		               return 6 <= param ? cont(kA) : cont(0);
		              },
		              0,
		              0,
		              cst_string,
		              cst_String,
		              kz,
		              0],
		             0]]]]]]],
		      0];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$4[1][1],
		           schematic_schema_version$52,
		           res,
		           function(a){
		            letrec_function_context$4[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var type_schema = [0, ky, 0, descriptor$2, 0];
		               function make_core
		               (id,
		                schema,
		                anchor,
		                ref,
		                dynamic_ref,
		                dynamic_anchor,
		                a,
		                comment,
		                opt,
		                param){
		                var vocabulary = 0, defs = 0;
		                return [0,
		                        id,
		                        schema,
		                        anchor,
		                        ref,
		                        dynamic_ref,
		                        dynamic_anchor,
		                        vocabulary,
		                        comment,
		                        defs];
		               }
		               function make_applicator
		               (unevaluatedItems,
		                g,
		                items,
		                contains,
		                f,
		                unevaluatedProperties,
		                e,
		                d,
		                c,
		                propertyNames,
		                if$,
		                then,
		                else$,
		                not,
		                b,
		                a,
		                opt,
		                param){
		                var
		                 prefixItems = g ? g[1] : 0,
		                 additionalProperties = f ? f[1] : kN,
		                 properties = e ? e[1] : 0,
		                 patternProperties = 0,
		                 dependentSchemas = 0,
		                 all_of = 0,
		                 any_of = a ? a[1] : 0,
		                 one_of = 0;
		                return [0,
		                        unevaluatedItems,
		                        prefixItems,
		                        items,
		                        contains,
		                        additionalProperties,
		                        unevaluatedProperties,
		                        properties,
		                        patternProperties,
		                        dependentSchemas,
		                        propertyNames,
		                        if$,
		                        then,
		                        else$,
		                        not,
		                        all_of,
		                        any_of,
		                        one_of];
		               }
		               function make_validation
		               (multipleOf,
		                maximum,
		                exclusiveMaximum,
		                minimum,
		                exclusiveMinimum,
		                maxLength,
		                minLength,
		                pattern,
		                maxItems,
		                minItems,
		                d,
		                maxContains,
		                minContains,
		                maxProperties,
		                minProperties,
		                c,
		                b,
		                const$,
		                a,
		                opt,
		                param){
		                var
		                 uniqueItems = 0,
		                 required = 0,
		                 dependentRequired = 0,
		                 enum$ = 0,
		                 type = opt ? opt[1] : 0;
		                return [0,
		                        multipleOf,
		                        maximum,
		                        exclusiveMaximum,
		                        minimum,
		                        exclusiveMinimum,
		                        maxLength,
		                        minLength,
		                        pattern,
		                        maxItems,
		                        minItems,
		                        uniqueItems,
		                        maxContains,
		                        minContains,
		                        maxProperties,
		                        minProperties,
		                        required,
		                        dependentRequired,
		                        const$,
		                        enum$,
		                        type];
		               }
		               function make_metadata
		               (title, description, default$, c, b, a, opt, param){
		                var
		                 deprecated = 0,
		                 readOnly = 0,
		                 writeOnly = 0,
		                 examples = 0;
		                return [0,
		                        title,
		                        description,
		                        default$,
		                        deprecated,
		                        readOnly,
		                        writeOnly,
		                        examples];
		               }
		               var cn = [];
		               function core_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cn[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, kO, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cn[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cn[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cn[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$0,
		                           schematic_version,
		                           function(a){
		                            a = [0, [0, 0, 0, mapping_schema(a)[3], 0]];
		                            var
		                             default$ = match$0[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 [3,
		                                  [0,
		                                   0,
		                                   0,
		                                   [10,
		                                    function(param, cont){
		                                     var e1 = param[2][1], e0 = param[1];
		                                     return cont([0, e0, e1]);
		                                    },
		                                    function(param, cont){
		                                     var e1 = param[2], e0 = param[1];
		                                     return cont([0, e0, [0, e1, 0]]);
		                                    },
		                                    [0,
		                                     uri_schema_versioned(schematic_version),
		                                     [0, bool_schema, 0]]],
		                                   0]],
		                                 0]],
		                             default$0 = match$1[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "$dynamicRef",
		                                 0,
		                                 3,
		                                 [0, uri_reference_schema_versioned(schematic_version)],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "$dynamicAnchor",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, "$vocabulary", 0, [0, default$0], b, 0, 0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "$comment",
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0, [0, 0, 0, 0, 0, "$defs", 0, [0, default$], a, 0, 0], 0]]]]],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "$anchor",
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "$ref",
		                                  0,
		                                  3,
		                                  [0, uri_reference_schema_versioned(schematic_version)],
		                                  0,
		                                  0],
		                                 a]],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "$schema",
		                                 0,
		                                 3,
		                                 [0, uri_schema_versioned(schematic_version)],
		                                 0,
		                                 0],
		                                a],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  defs = g[2][1],
		                                  comment = g[1],
		                                  vocabulary = f[1],
		                                  dynamic_anchor = e[1],
		                                  dynamic_ref = d[1],
		                                  ref = c[1],
		                                  anchor = b[1],
		                                  schema = a[1],
		                                  id = param[1];
		                                 return cont
		 ([0,
		   id,
		   schema,
		   anchor,
		   ref,
		   dynamic_ref,
		   dynamic_anchor,
		   vocabulary,
		   comment,
		   defs]);
		                                },
		                                function(param, cont){
		                                 var
		                                  defs = param[9],
		                                  comment = param[8],
		                                  vocabulary = param[7],
		                                  dynamic_anchor = param[6],
		                                  dynamic_ref = param[5],
		                                  ref = param[4],
		                                  anchor = param[3],
		                                  schema = param[2],
		                                  id = param[1];
		                                 return cont
		 ([0,
		   id,
		   [0,
		    schema,
		    [0,
		     anchor,
		     [0,
		      ref,
		      [0,
		       dynamic_ref,
		       [0,
		        dynamic_anchor,
		        [0, vocabulary, [0, comment, [0, defs, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "$id",
		                                  0,
		                                  3,
		                                  [0, uri_reference_schema_versioned(schematic_version)],
		                                  0,
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cn[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cn[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cst_anyOf = "anyOf", cst_items = "items", co = [];
		               function applicator_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         co[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, kP, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      co[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 co[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  co[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$0,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$2[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "oneOf",
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$0,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$3[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_anyOf,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, c], 0]],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$4[1],
		         a =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             "allOf",
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$0,
		                 schematic_version,
		                 function(c){
		                  var
		                   b = [0, [0, 0, 0, 0, 0, cst_not, 0, 3, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$0,
		                           schematic_version,
		                           function(c){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, cst_else, 0, 3, [0, c], 0, 0], b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$0,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_then, 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$0,
		       schematic_version,
		       function(c){
		        var a = [0, [0, 0, 0, 0, 0, cst_if, 0, 3, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$0,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0, [0, 0, 0, 0, 0, "propertyNames", 0, 3, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$0,
		                           schematic_version,
		                           function(a){
		                            a = [0, [0, 0, 0, mapping_schema(a)[3], 0]];
		                            var
		                             default$ = match$5[1],
		                             c =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "dependentSchemas",
		                                 0,
		                                 [0, default$],
		                                 a,
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      a = [0, [0, 0, 0, mapping_schema(a)[3], 0]];
		                                      var
		                                       default$ = match$6[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "patternProperties",
		   0,
		   [0, default$],
		   a,
		   0,
		   0],
		  c];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$0,
		       schematic_version,
		       function(a){
		        a = [0, [0, 0, 0, mapping_schema(a)[3], 0]];
		        var
		         default$ = match$7[1],
		         c =
		           [0,
		            [0, 0, 0, 0, 0, cst_properties, 0, [0, default$], a, 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$0,
		                 schematic_version,
		                 function(b){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, "unevaluatedProperties", 0, 3, [0, b], 0, 0],
		                      c];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$0,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (additional_properties_schema_v(schematic_version),
		                                     b,
		                                     function(c){
		                                      var
		                                       default$ = match$8[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_additionalProperties,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0, [0, 0, 0, 0, 0, cst_contains, 0, 3, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$0,
		                 schematic_version,
		                 function(c){
		                  var
		                   b = [0, [0, 0, 0, 0, 0, cst_items, 0, 3, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$0,
		                           schematic_version,
		                           function(c){
		                            var
		                             default$ = match$9[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "prefixItems",
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, c], 0]],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    j = i[2],
		    k = j[2],
		    l = k[2],
		    m = l[2],
		    n = m[2],
		    o = n[2],
		    one_of = o[2][1],
		    any_of = o[1],
		    all_of = n[1],
		    not = m[1],
		    else$ = l[1],
		    then = k[1],
		    if$ = j[1],
		    propertyNames = i[1],
		    dependentSchemas = h[1],
		    patternProperties = g[1],
		    properties = f[1],
		    unevaluatedProperties = e[1],
		    additionalProperties = d[1],
		    contains = c[1],
		    items = b[1],
		    prefixItems = a[1],
		    unevaluatedItems = param[1];
		   return cont
		           ([0,
		             unevaluatedItems,
		             prefixItems,
		             items,
		             contains,
		             additionalProperties,
		             unevaluatedProperties,
		             properties,
		             patternProperties,
		             dependentSchemas,
		             propertyNames,
		             if$,
		             then,
		             else$,
		             not,
		             all_of,
		             any_of,
		             one_of]);
		  },
		  function(param, cont){
		   var
		    one_of = param[17],
		    any_of = param[16],
		    all_of = param[15],
		    not = param[14],
		    else$ = param[13],
		    then = param[12],
		    if$ = param[11],
		    propertyNames = param[10],
		    dependentSchemas = param[9],
		    patternProperties = param[8],
		    properties = param[7],
		    unevaluatedProperties = param[6],
		    additionalProperties = param[5],
		    contains = param[4],
		    items = param[3],
		    prefixItems = param[2],
		    unevaluatedItems = param[1];
		   return cont
		           ([0,
		             unevaluatedItems,
		             [0,
		              prefixItems,
		              [0,
		               items,
		               [0,
		                contains,
		                [0,
		                 additionalProperties,
		                 [0,
		                  unevaluatedProperties,
		                  [0,
		                   properties,
		                   [0,
		                    patternProperties,
		                    [0,
		                     dependentSchemas,
		                     [0,
		                      propertyNames,
		                      [0,
		                       if$,
		                       [0,
		                        then,
		                        [0,
		                         else$,
		                         [0, not, [0, all_of, [0, any_of, [0, one_of, 0]]]]]]]]]]]]]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, "unevaluatedItems", 0, 3, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       co[1][1],
		       schematic_schema_version,
		       res,
		       function(a){co[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                cst_const = "const",
		                cst_enum = "enum",
		                json_schema = [0, 0, 0, 6, 0],
		                cp = [];
		               function validation_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cp[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, kQ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cp[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cp[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cp[1][1] = a;
		                  a =
		                   [0, one_or_many_versioned(type_schema)];
		                  var
		                   default$ = match$10[1],
		                   default$0 = match$11[1],
		                   b =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       mapping_schema
		                         ([0, 0, 0, [3, schematic_param_name_schema_ve], 0])
		                        [3],
		                       0]],
		                   default$1 = match$12[1],
		                   default$2 = match$13[1],
		                   default$3 = match$14[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        j = i[2],
		                        k = j[2],
		                        l = k[2],
		                        m = l[2],
		                        n = m[2],
		                        o = n[2],
		                        p = o[2],
		                        q = p[2],
		                        r = q[2],
		                        type = r[2][1],
		                        enum$ = r[1],
		                        const$ = q[1],
		                        dependentRequired = p[1],
		                        required = o[1],
		                        minProperties = n[1],
		                        maxProperties = m[1],
		                        minContains = l[1],
		                        maxContains = k[1],
		                        uniqueItems = j[1],
		                        minItems = i[1],
		                        maxItems = h[1],
		                        pattern = g[1],
		                        minLength = f[1],
		                        maxLength = e[1],
		                        exclusiveMinimum = d[1],
		                        minimum = c[1],
		                        exclusiveMaximum = b[1],
		                        maximum = a[1],
		                        multipleOf = param[1];
		                       return cont
		                               ([0,
		                                 multipleOf,
		                                 maximum,
		                                 exclusiveMaximum,
		                                 minimum,
		                                 exclusiveMinimum,
		                                 maxLength,
		                                 minLength,
		                                 pattern,
		                                 maxItems,
		                                 minItems,
		                                 uniqueItems,
		                                 maxContains,
		                                 minContains,
		                                 maxProperties,
		                                 minProperties,
		                                 required,
		                                 dependentRequired,
		                                 const$,
		                                 enum$,
		                                 type]);
		                      },
		                      function(param, cont){
		                       var
		                        type = param[20],
		                        enum$ = param[19],
		                        const$ = param[18],
		                        dependentRequired = param[17],
		                        required = param[16],
		                        minProperties = param[15],
		                        maxProperties = param[14],
		                        minContains = param[13],
		                        maxContains = param[12],
		                        uniqueItems = param[11],
		                        minItems = param[10],
		                        maxItems = param[9],
		                        pattern = param[8],
		                        minLength = param[7],
		                        maxLength = param[6],
		                        exclusiveMinimum = param[5],
		                        minimum = param[4],
		                        exclusiveMaximum = param[3],
		                        maximum = param[2],
		                        multipleOf = param[1];
		                       return cont
		                               ([0,
		                                 multipleOf,
		                                 [0,
		                                  maximum,
		                                  [0,
		                                   exclusiveMaximum,
		                                   [0,
		                                    minimum,
		                                    [0,
		                                     exclusiveMinimum,
		                                     [0,
		                                      maxLength,
		                                      [0,
		                                       minLength,
		                                       [0,
		pattern,
		[0,
		 maxItems,
		 [0,
		  minItems,
		  [0,
		   uniqueItems,
		   [0,
		    maxContains,
		    [0,
		     minContains,
		     [0,
		      maxProperties,
		      [0,
		       minProperties,
		       [0,
		        required,
		        [0,
		         dependentRequired,
		         [0, const$, [0, enum$, [0, type, 0]]]]]]]]]]]]]]]]]]]]);
		                      },
		                      [0,
		                       [0, 0, 0, kZ, 0, "multipleOf", 0, 3, [0, int_schema], 0, 0],
		                       [0,
		                        [0, 0, 0, 0, 0, "maximum", 0, 3, [0, int_schema], 0, 0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "exclusiveMaximum",
		                          0,
		                          3,
		                          [0, int_schema],
		                          0,
		                          0],
		                         [0,
		                          [0, 0, 0, 0, 0, "minimum", 0, 3, [0, int_schema], 0, 0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            "exclusiveMinimum",
		                            0,
		                            3,
		                            [0, int_schema],
		                            0,
		                            0],
		                           [0,
		                            [0, 0, 0, kY, 0, "maxLength", 0, 3, [0, int_schema], 0, 0],
		                            [0,
		                             [0, 0, 0, kX, 0, "minLength", 0, 3, [0, int_schema], 0, 0],
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "pattern",
		                               0,
		                               3,
		                               [0, schematic_param_name_schema_ve],
		                               0,
		                               0],
		                              [0,
		                               [0, 0, 0, kW, 0, "maxItems", 0, 3, [0, int_schema], 0, 0],
		                               [0,
		                                [0, 0, 0, kV, 0, "minItems", 0, 3, [0, int_schema], 0, 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "uniqueItems",
		                                  0,
		                                  [0, default$3],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, kU, 0, "maxContains", 0, 3, [0, int_schema], 0, 0],
		                                  [0,
		                                   [0, 0, 0, kT, 0, "minContains", 0, 3, [0, int_schema], 0, 0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     kS,
		                                     0,
		                                     "maxProperties",
		                                     0,
		                                     3,
		                                     [0, int_schema],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      kR,
		                                      0,
		                                      "minProperties",
		                                      0,
		                                      3,
		                                      [0, int_schema],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       "required",
		                                       0,
		                                       [0, default$2],
		                                       [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		"dependentRequired",
		0,
		[0, default$1],
		b,
		0,
		0],
		                                       [0,
		[0, 0, 0, 0, 0, cst_const, 0, 3, [0, json_schema], 0, 0],
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_enum,
		  0,
		  [0, default$0],
		  [0, [0, 0, 0, [3, json_schema], 0]],
		  0,
		  0],
		 [0, [0, 0, 0, 0, 0, cst_type, 0, [0, default$], a, 0, 0], 0]]]]]]]]]]]]]]]]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cp[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){cp[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cq = [];
		               function metadata_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cq[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, k0, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cq[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cq[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cq[1][1] = a;
		                  var
		                   default$ = match$15[1],
		                   default$0 = match$16[1],
		                   default$1 = match$17[1],
		                   default$2 = match$18[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        examples = e[2][1],
		                        writeOnly = e[1],
		                        readOnly = d[1],
		                        deprecated = c[1],
		                        default$ = b[1],
		                        description = a[1],
		                        title = param[1];
		                       return cont
		                               ([0,
		                                 title,
		                                 description,
		                                 default$,
		                                 deprecated,
		                                 readOnly,
		                                 writeOnly,
		                                 examples]);
		                      },
		                      function(param, cont){
		                       var
		                        examples = param[7],
		                        writeOnly = param[6],
		                        readOnly = param[5],
		                        deprecated = param[4],
		                        default$ = param[3],
		                        description = param[2],
		                        title = param[1];
		                       return cont
		                               ([0,
		                                 title,
		                                 [0,
		                                  description,
		                                  [0,
		                                   default$,
		                                   [0,
		                                    deprecated,
		                                    [0, readOnly, [0, writeOnly, [0, examples, 0]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_title,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_description,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0, 0, 0, 0, 0, cst_default, 0, 3, [0, json_schema], 0, 0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "deprecated",
		                           0,
		                           [0, default$2],
		                           [0, bool_schema],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_readOnly,
		                            0,
		                            [0, default$1],
		                            [0, bool_schema],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             "writeOnly",
		                             0,
		                             [0, default$0],
		                             [0, bool_schema],
		                             0,
		                             0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              "examples",
		                              0,
		                              [0, default$],
		                              [0, [0, 0, 0, [3, json_schema], 0]],
		                              0,
		                              0],
		                             0]]]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cq[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){cq[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var letrec_function_context$5 = [];
		               function schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$5[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, k1, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$5[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$5[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$5[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (validation_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0, [0, 0, 0, 0, 0, cst_validation, 0, 2, [1, b], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (metadata_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0, [0, 0, 0, 0, 0, cst_metadata, 0, 2, [1, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (core_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, 0, 0, 0, 0, cst_core, 0, 2, [1, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (applicator_schema_versioned,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        validation = b[2][1],
		                        metadata = b[1],
		                        core = a[1],
		                        applicator = param[1];
		                       return cont([0, applicator, core, metadata, validation]);
		                      },
		                      function(param, cont){
		                       var
		                        validation = param[4],
		                        metadata = param[3],
		                        core = param[2],
		                        applicator = param[1];
		                       return cont
		                               ([0,
		                                 applicator,
		                                 [0, core, [0, metadata, [0, validation, 0]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_applicator, 0, 2, [1, b], 0, 0], a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$5[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$5[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$2 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cn, [0, schematic_cache$2]);
		               var schematic_cache$3 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(co, [0, schematic_cache$3]);
		               var schematic_cache$4 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cp, [0, schematic_cache$4]);
		               var schematic_cache$5 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cq, [0, schematic_cache$5]);
		               var schematic_cache$6 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$5, [0, schematic_cache$6]);
		               caml_callback
		                (core_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (applicator_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (validation_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (metadata_schema_versioned, [function(param){return 0;}]);
		               var
		                schema$3 =
		                  caml_callback
		                   (schema_versioned$0, [function(param){return 0;}]);
		               function Make$7(State){
		                function return$(v, marks, cont){return cont([0, v, marks]);}
		                function bind(v, f, marks, cont){
		                 return caml_trampoline_cps_call2
		                         (v,
		                          marks,
		                          function(match){
		                           var marks = match[2], v = match[1];
		                           return caml_trampoline_cps_call3(f, v, marks, cont);
		                          });
		                }
		                function map(v, f, marks, cont){
		                 return caml_trampoline_cps_call2
		                         (v,
		                          marks,
		                          function(match){
		                           var marks = match[2], v = match[1];
		                           return caml_trampoline_cps_call2
		                                   (f, v, function(a){return cont([0, a, marks]);});
		                          });
		                }
		                var
		                 include = Make([0, bind, return$, [0, , map]]),
		                 return$0 = include[5],
		                 map$0 = include[6],
		                 all = include[9],
		                 Let_syntax = include[11];
		                return [0, , , , , return$0, map$0, , , all, , Let_syntax];
		               }
		               function string_const_validation(v){
		                return make_validation
		                        (0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         [0, [0, -976970511, v]],
		                         0,
		                         k2);
		               }
		               var
		                schematic_cache$7 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$6 = [];
		               caml_update_dummy
		                (letrec_function_context$6, [0, schematic_cache$7]);
		               var
		                schematic_schema_version$1 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$6[1][1],
		                     schematic_schema_version$1]);
		               if(e)
		                var schema$4 = e[1], descriptor$3 = schema$4;
		               else
		                descriptor$3 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$6[1][1],
		                              schematic_schema_version$1,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$6[1][1],
		 schematic_schema_version$1,
		 schematic_self,
		 function(a){
		  letrec_function_context$6[1][1] = a;
		  var
		   res =
		     [10,
		      function(param, cont){
		       var a = param[2], e2 = a[2][1], e1 = a[1], e0 = param[1];
		       return cont([0, e0, e1, e2]);
		      },
		      function(param, cont){
		       var e2 = param[3], e1 = param[2], e0 = param[1];
		       return cont([0, e0, [0, e1, [0, e2, 0]]]);
		      },
		      [0, int_schema, [0, int_schema, [0, int_schema, 0]]]];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$6[1][1],
		           schematic_schema_version$1,
		           res,
		           function(a){
		            letrec_function_context$6[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               function make$6(c, b, a, opt, param){
		                var
		                 applicator =
		                   c
		                    ? c[1]
		                    : make_applicator
		                      (0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0),
		                 core = b ? b[1] : make_core(0, 0, 0, 0, 0, 0, 0, 0),
		                 metadata = make_metadata(0, 0, 0),
		                 validation =
		                   opt
		                    ? opt[1]
		                    : make_validation
		                      (0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
		                return [0, applicator, core, metadata, validation];
		               }
		               var
		                validation =
		                  make_validation
		                   (0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    k3),
		                null$0 = make$6(0, 0, 0, [0, validation]),
		                cst$8 = "#";
		               function of_schema$0(opt, schema, cont){
		                var
		                 reference = opt ? opt[1] : 3652632,
		                 empty_state = [0, empty$8([0, comparator$2]), 0],
		                 Inline_marks = Make_inline$0(Make$7());
		                function with_schema(t){
		                 var a = t[2];
		                 return [0,
		                         t[1],
		                         [0, a[1], k4, a[3], a[4], a[5], a[6], a[7], a[8], a[9]],
		                         t[3],
		                         t[4]];
		                }
		                function with_documentation(documentation, schema){
		                 if(! documentation) return schema;
		                 var doc = documentation[1], a = schema[3];
		                 return [0,
		                         schema[1],
		                         schema[2],
		                         [0, a[1], [0, doc], a[3], a[4], a[5], a[6], a[7]],
		                         schema[4]];
		                }
		                function of_schema(state, param, cont){
		                 var match = param[1];
		                 if(match){
		                  var id = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (mem$3,
		                           state[1],
		                           id,
		                           function(b){
		                            var cst_defs = "#/$defs/";
		                            if(b){
		                             var
		                              ref_str =
		                                759136046 <= reference ? cst_defs + id : cst$8 + id;
		                             return cont
		                                     ([0,
		                                       make$6
		(0,
		 [0, make_core(0, 0, 0, [0, ref_str], 0, 0, 0, 0)],
		 0,
		 0),
		                                       0,
		                                       state]);
		                            }
		                            var
		                             descriptor = param[3],
		                             documentation = param[2],
		                             a = state[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (add$4,
		                                     state[1],
		                                     id,
		                                     function(b){
		                                      var state = [0, b, a];
		                                      return caml_exact_trampoline_cps_call$1
		      (of_descriptor,
		       state,
		       descriptor,
		       function(a){
		        var
		         state = a[3],
		         types = a[2],
		         schema = a[1],
		         schema$0 = with_documentation(documentation, schema);
		        if(759136046 <= reference){
		         var
		          state$0 = [0, state[1], [0, [0, id, schema$0], state[2]]],
		          schema$1 =
		            make$6
		             (0,
		              [0, make_core(0, 0, 0, [0, cst_defs + id], 0, 0, 0, 0)],
		              0,
		              0);
		         return cont([0, schema$1, types, state$0]);
		        }
		        a = schema$0[2];
		        var
		         schema$2 =
		           [0,
		            schema$0[1],
		            [0, a[1], a[2], [0, id], a[4], a[5], a[6], a[7], a[8], a[9]],
		            schema$0[3],
		            schema$0[4]];
		        return cont([0, schema$2, types, state]);
		       });
		                                     });
		                           });
		                 }
		                 var descriptor = param[3], documentation = param[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (of_descriptor,
		                          state,
		                          descriptor,
		                          function(match){
		                           var state = match[3], types = match[2], schema = match[1];
		                           return cont
		                                   ([0,
		                                     with_documentation(documentation, schema),
		                                     types,
		                                     state]);
		                          });
		                }
		                function of_descriptor(state, o, cont){
		                 function a(o){
		                  if(typeof o === "number")
		                   switch(o){
		                     case 0:
		                      var
		                       validation =
		                         make_validation
		                          (0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           [0, type]);
		                      return cont
		                              ([0, make$6(0, 0, 0, [0, validation]), type, state]);
		                     case 2:
		                      var
		                       validation$0 =
		                         make_validation
		                          (0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           [0, type$0]);
		                      return cont
		                              ([0, make$6(0, 0, 0, [0, validation$0]), type$0, state]);
		                     case 3:
		                      return cont([0, make$6(0, 0, 0, 0), 0, state]);
		                     case 6:
		                      return cont([0, make$6(0, 0, 0, 0), 0, state]);
		                     case 7:
		                      return cont([0, null$0, k5, state]);
		                     case 8:
		                      var
		                       validation$2 =
		                         make_validation
		                          (0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           [0, type$2]);
		                      return cont
		                              ([0, make$6(0, 0, 0, [0, validation$2]), type$2, state]);
		                     case 9:
		                      var
		                       validation$3 =
		                         make_validation
		                          (0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           [0, type$3]);
		                      return cont
		                              ([0, make$6(0, 0, 0, [0, validation$3]), type$3, state]);
		                     case 10:
		                      var
		                       validation$4 =
		                         make_validation
		                          (0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           [0, type$4]);
		                      return cont
		                              ([0, make$6(0, 0, 0, [0, validation$4]), type$4, state]);
		                     case 1:
		                      return caml_exact_trampoline_call1(a, descriptor$3);
		                     default:
		                      var
		                       validation$1 =
		                         make_validation
		                          (0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           [0, type$1]);
		                      return cont
		                              ([0, make$6(0, 0, 0, [0, validation$1]), type$1, state]);
		                   }
		                  switch(o[0]){
		                    case 0:
		                     return cont([0, make$6(0, 0, 0, 0), 0, state]);
		                    case 1:
		                     var f = o[1]; return caml_trampoline_cps_call2(f, 0, a);
		                    case 2:
		                     var s = o[1], b = caml_obj_tag(s);
		                     if(250 === b) return caml_exact_trampoline_call1(a, s[1]);
		                     if(246 !== b && 244 !== b)
		                      return caml_exact_trampoline_call1(a, s);
		                     return caml_exact_trampoline_cps_call
		                             (force_lazy_block, s, a);
		                    case 3:
		                     var schema = o[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (of_schema,
		                              state,
		                              schema,
		                              function(match){
		                               var state = match[3], item = match[1];
		                               return cont(list_schema(state, item));
		                              });
		                    case 4:
		                     var descriptor = o[3];
		                     return caml_exact_trampoline_call1(a, descriptor);
		                    case 5:
		                     var item = o[3];
		                     return caml_exact_trampoline_cps_call$1
		                             (of_schema,
		                              state,
		                              item,
		                              function(match){
		                               var
		                                state = match[3],
		                                schema = match[1],
		                                applicator =
		                                  make_applicator
		                                   (0,
		                                    0,
		                                    0,
		                                    0,
		                                    [0, [0, schema]],
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0),
		                                validation =
		                                  make_validation
		                                   (0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    [0, type$5]);
		                               return cont
		                                       ([0,
		 make$6([0, applicator], 0, 0, [0, validation]),
		 type$5,
		 state]);
		                              });
		                    case 6:
		                     var s$0 = o[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (of_descriptor,
		                              state,
		                              s$0[3],
		                              function(match){
		                               var
		                                state = match[3],
		                                inner_types = match[2],
		                                t = match[1],
		                                cases = t[1][16],
		                                any_of = cases ? [0, null$0, cases] : 0;
		                               return caml_exact_trampoline_cps_call$1
		                                       (dedup_and_sort,
		[0, 3, inner_types],
		function(b, a, cont){return cont(caml_int_compare(b, a));},
		function(type){
		 var a = t[4], b = t[1];
		 return cont
		         ([0,
		           [0,
		            [0,
		             b[1],
		             b[2],
		             b[3],
		             b[4],
		             b[5],
		             b[6],
		             b[7],
		             b[8],
		             b[9],
		             b[10],
		             b[11],
		             b[12],
		             b[13],
		             b[14],
		             b[15],
		             any_of,
		             b[17]],
		            t[2],
		            t[3],
		            [0,
		             a[1],
		             a[2],
		             a[3],
		             a[4],
		             a[5],
		             a[6],
		             a[7],
		             a[8],
		             a[9],
		             a[10],
		             a[11],
		             a[12],
		             a[13],
		             a[14],
		             a[15],
		             a[16],
		             a[17],
		             a[18],
		             a[19],
		             type]],
		           type,
		           state]);
		});
		                              });
		                    case 7:
		                     return caml_exact_trampoline_cps_call$1
		                             (Inline_marks[1],
		                              o,
		                              [0,
		                               function(param, state, cont){
		                                var
		                                 title = param[10],
		                                 schema = param[8],
		                                 requirement = param[7],
		                                 name = param[5],
		                                 minimum = param[4],
		                                 maximum = param[3],
		                                 examples = param[2],
		                                 description = param[1],
		                                 schema$0 = schema[1];
		                                return caml_exact_trampoline_cps_call$1
		(of_schema,
		 state,
		 schema$0,
		 function(a){
		  var state = a[3], t = a[1];
		  function to_json(v, cont){
		   return caml_trampoline_cps_call3
		           (encode$4,
		            schema$0,
		            v,
		            function(a){return cont(to_ezjsonm(a));});
		  }
		  var
		   a = t[4],
		   init = t[3],
		   b =
		     [0,
		      a[1],
		      maximum,
		      a[3],
		      minimum,
		      a[5],
		      a[6],
		      a[7],
		      a[8],
		      a[9],
		      a[10],
		      a[11],
		      a[12],
		      a[13],
		      a[14],
		      a[15],
		      a[16],
		      a[17],
		      a[18],
		      a[19],
		      a[20]];
		  return caml_exact_trampoline_cps_call$1
		          (map$7,
		           examples,
		           to_json,
		           function(f){
		            var c = init[6], d = init[5], e = init[4];
		            function a(a){
		             return caml_exact_trampoline_cps_call
		                     (capitalize_ascii,
		                      name,
		                      function(g){
		                       var x = value$4(title, g);
		                       return cont
		                               ([0,
		                                 [0,
		                                  name,
		                                  [0, t[1], t[2], [0, [0, x], description, a, e, d, c, f], b]],
		                                 state]);
		                      });
		            }
		            if(typeof requirement === "number") return a(0);
		            var v = requirement[1];
		            return caml_exact_trampoline_cps_call
		                    (to_json, v, function(b){return a([0, b]);});
		           });
		 });
		                               },
		                               0],
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (ok_or_failwith,
		a,
		function(f){
		 return caml_trampoline_cps_call2
		         (f,
		          state,
		          function(match){
		           var
		            state = match[2],
		            properties = match[1],
		            validation =
		              make_validation
		               (0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                [0, type$6]);
		           return caml_exact_trampoline_cps_call$1
		                   (map$7,
		                    properties,
		                    function(properties, cont){
		                     return cont
		                             (make_applicator
		                               (0,
		                                0,
		                                0,
		                                0,
		                                k6,
		                                0,
		                                [0, properties],
		                                0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                0));
		                    },
		                    function(l){
		                     if(l && ! l[2]){
		                      var applicator = l[1];
		                      return cont
		                              ([0,
		                                make$6([0, applicator], 0, 0, [0, validation]),
		                                type$6,
		                                state]);
		                     }
		                     return caml_exact_trampoline_cps_call$1
		                             (map$7,
		                              l,
		                              function(applicator, cont){
		                               return cont(make$6([0, applicator], 0, 0, 0));
		                              },
		                              function(any_of){
		                               return cont
		                                       ([0,
		 make$6
		  ([0,
		    make_applicator
		     (0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      [0, any_of])],
		   0,
		   0,
		   [0, validation]),
		 type$6,
		 state]);
		                              });
		                    });
		          });
		});
		                              });
		                    case 8:
		                     var item$0 = o[3];
		                     return caml_exact_trampoline_cps_call$1
		                             (of_schema,
		                              state,
		                              item$0,
		                              function(match){
		                               var state = match[3], item = match[1];
		                               return cont(list_schema(state, item));
		                              });
		                    case 9:
		                     var v = o[1], validation$5 = string_const_validation(v);
		                     return cont
		                             ([0, make$6(0, 0, 0, [0, validation$5]), type$7, state]);
		                    case 10:
		                     var
		                      items = o[3],
		                      tuple_applicator =
		                        function(state, param, cont){
		                         if(! param) return cont([0, 0, state]);
		                         var rest = param[2], schema = param[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (of_schema,
		                                  state,
		                                  schema,
		                                  function(match){
		                                   var state = match[3], head = match[1];
		                                   return caml_exact_trampoline_cps_call$1
		   (tuple_applicator,
		    state,
		    rest,
		    function(match){
		     var state = match[2], tail = match[1];
		     return cont([0, [0, head, tail], state]);
		    });
		                                  });
		                        };
		                     return caml_exact_trampoline_cps_call$1
		                             (tuple_applicator,
		                              state,
		                              items,
		                              function(match){
		                               var
		                                state = match[2],
		                                fields = match[1],
		                                validation =
		                                  make_validation
		                                   (0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    [0, type$8]);
		                               return cont
		                                       ([0,
		 make$6
		  ([0,
		    make_applicator
		     (0,
		      [0, fields],
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0)],
		   0,
		   0,
		   [0, validation]),
		 type$8,
		 state]);
		                              });
		                    case 11:
		                     var
		                      cases = o[2],
		                      key = o[1],
		                      f$0 =
		                        function(state, param, cont){
		                         var schema = param[7], name = param[5];
		                         return caml_exact_trampoline_cps_call$1
		                                 (of_schema,
		                                  state,
		                                  schema,
		                                  function(a){
		                                   var state = a[3], types = a[2], schema = a[1];
		                                   function b(schema){
		                                    return cont([0, state, [0, schema, types]]);
		                                   }
		                                   if(! key) return b(schema);
		                                   a = schema[4][20];
		                                   if(! a) return b(schema);
		                                   if(5 !== a[1]) return b(schema);
		                                   if(a[2]) return b(schema);
		                                   a = schema[1];
		                                   var
		                                    any_of = a[16],
		                                    properties = a[7],
		                                    key$0 = key[1],
		                                    a = string_const_validation(name),
		                                    c = make_metadata(0, 0, 0),
		                                    d = make_core(0, 0, 0, 0, 0, 0, 0, 0),
		                                    key_schema =
		                                      [0,
		                                       make_applicator
		(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0),
		                                       d,
		                                       c,
		                                       a];
		                                   return caml_exact_trampoline_cps_call$1
		   (map$7,
		    any_of,
		    function(item, cont){
		     var a = item[1][5];
		     if(0 !== a[0] && ! a[1]){
		      a = item[1];
		      return cont
		              ([0,
		                [0,
		                 a[1],
		                 a[2],
		                 a[3],
		                 a[4],
		                 a[5],
		                 a[6],
		                 [0, [0, key$0, key_schema], item[1][7]],
		                 a[8],
		                 a[9],
		                 a[10],
		                 a[11],
		                 a[12],
		                 a[13],
		                 a[14],
		                 a[15],
		                 a[16],
		                 a[17]],
		                item[2],
		                item[3],
		                item[4]]);
		     }
		     return cont(item);
		    },
		    function(any_of){
		     var a = schema[1];
		     return b
		             ([0,
		               [0,
		                a[1],
		                a[2],
		                a[3],
		                a[4],
		                a[5],
		                a[6],
		                [0, [0, key$0, key_schema], properties],
		                a[8],
		                a[9],
		                a[10],
		                a[11],
		                a[12],
		                a[13],
		                a[14],
		                a[15],
		                any_of,
		                a[17]],
		               schema[2],
		               schema[3],
		               schema[4]]);
		    });
		                                  });
		                        };
		                     return caml_exact_trampoline_cps_call$0
		                             (fold_map,
		                              cases,
		                              state,
		                              f$0,
		                              function(match){
		                               var schemas_with_types = match[2], state = match[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (map$7,
		schemas_with_types,
		calendar,
		function(schemas){
		 var
		  applicator =
		    make_applicator
		     (0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      0,
		      [0, schemas]);
		 return caml_exact_trampoline_cps_call$1
		         (concat_map,
		          schemas_with_types,
		          get_data,
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (dedup_and_sort,
		                    a,
		                    function(b, a, cont){return cont(caml_int_compare(b, a));},
		                    function(a){
		                     var
		                      validation =
		                        make_validation
		                         (0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          [0, a]),
		                      a = validation[20];
		                     return cont
		                             ([0,
		                               make$6([0, applicator], 0, 0, [0, validation]),
		                               a,
		                               state]);
		                    });
		          });
		});
		                              });
		                    default:
		                     var descriptor$0 = o[1];
		                     return caml_exact_trampoline_call1(a, descriptor$0);
		                  }
		                 }
		                 return a(o);
		                }
		                function list_schema(state, item){
		                 var
		                  applicator =
		                    make_applicator
		                     (0, 0, [0, item], 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0),
		                  validation =
		                    make_validation
		                     (0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      [0, type$9]);
		                 return [0,
		                         make$6([0, applicator], 0, 0, [0, validation]),
		                         type$9,
		                         state];
		                }
		                return 759136046 <= reference
		                        ? caml_exact_trampoline_cps_call$1
		                          (of_descriptor,
		                           empty_state,
		                           schema[3],
		                           function(param){
		                            var
		                             state = param[3],
		                             s = param[1],
		                             result = with_documentation(schema[2], s),
		                             init = result[2],
		                             a = result[4],
		                             b = result[3];
		                            return caml_exact_trampoline_cps_call
		                                    (of_rev_keys,
		                                     state[2],
		                                     function(c){
		                                      return cont
		      (with_schema
		        ([0,
		          result[1],
		          [0,
		           init[1],
		           ,
		           init[3],
		           init[4],
		           init[5],
		           init[6],
		           init[7],
		           init[8],
		           c],
		          b,
		          a]));
		                                     });
		                           })
		                        : caml_exact_trampoline_cps_call$1
		                          (of_schema,
		                           empty_state,
		                           schema,
		                           function(param){
		                            var s = param[1];
		                            return cont(with_schema(s));
		                           });
		               }
		               function composite_object(open, pp, close){
		                return function(state, v, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_open_box,
		                          state,
		                          0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_char,
		                                    state,
		                                    open,
		                                    function(a){
		                                     var indent = opt$4[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (pp_open_box_gen,
		      state,
		      indent,
		      2,
		      function(a){
		       return caml_exact_trampoline_cps_call$2
		               (append$4,
		                pp_v0,
		                pp,
		                state,
		                v,
		                function(a){
		                 pp_close_box(state);
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_v0,
		                          state,
		                          v,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_char,
		                                    state,
		                                    close,
		                                    function(a){return cont(pp_close_box(state));});
		                          });
		                });
		      });
		                                    });
		                          });};
		               }
		               function colon(fmt, x, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_char,
		                         fmt,
		                         58,
		                         function(a){return cont(pp_v1(fmt));});
		               }
		               var Inline_fmt = Make_inline$0(Make$7());
		               function of_schema$1(param, cont){
		                var descriptor = param[3];
		                return caml_exact_trampoline_cps_call
		                        (of_descriptor, descriptor, cont);
		               }
		               var cst_None = "None";
		               function of_descriptor(param, cont){
		                function a(param){
		                 if(typeof param === "number")
		                  switch(param){
		                    case 0:
		                     return cont(pp_print_bool);
		                    case 1:
		                     return cont
		                             (function(f, param, cont){
		                               var day = param[3], month = param[2], year = param[1];
		                               return caml_exact_trampoline_cps_call
		                                       (fprintf$0(f),
		k7,
		function(a){
		 return caml_trampoline_cps_call4(a, year, month, day, cont);
		});
		                              });
		                    case 2:
		                     return cont(float);
		                    case 3:
		                     return cont(pp_none);
		                    case 4:
		                     return cont(pp_print_int);
		                    case 5:
		                     return cont(int64$0);
		                    case 6:
		                     return cont
		                             (function(f, json, cont){
		                               return caml_exact_trampoline_cps_call$1(_16, f, json, cont);
		                              });
		                    case 7:
		                     return cont
		                             (function(ppf, param, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (pp_print_string, ppf, cst$17, cont);
		                              });
		                    case 8:
		                     return cont(string$1);
		                    case 9:
		                     return cont(_12);
		                    default:
		                     return cont
		                             (function(f, param, cont){
		                               var tz_offset_s = param[2], t = param[1];
		                               return caml_exact_trampoline_cps_call$3
		                                       (pp_human, 0, [0, tz_offset_s], dummy, f, t, cont);
		                              });
		                  }
		                 switch(param[0]){
		                   case 0:
		                    var Coding = param[1]; return cont(Coding[4]);
		                   case 1:
		                    var f = param[1]; return caml_trampoline_cps_call2(f, 0, a);
		                   case 2:
		                    var d = param[1];
		                    return cont
		                            (function(fmt, v, cont){
		                              var a = caml_obj_tag(d);
		                              function b(a){
		                               return caml_exact_trampoline_cps_call
		                                       (of_descriptor,
		a,
		function(a){
		 return caml_trampoline_cps_call3(a, fmt, v, cont);
		});
		                              }
		                              if(250 === a) return b(d[1]);
		                              if(246 !== a && 244 !== a) return b(d);
		                              return caml_exact_trampoline_cps_call
		                                      (force_lazy_block, d, b);
		                             });
		                   case 3:
		                    var schema = param[1];
		                    return caml_exact_trampoline_cps_call
		                            (of_schema$1,
		                             schema,
		                             function(a){
		                              return cont(composite_object(91, list([0, semi], a), 93));
		                             });
		                   case 4:
		                    var descriptor = param[3], encode = param[2];
		                    return caml_exact_trampoline_cps_call
		                            (of_descriptor,
		                             descriptor,
		                             function(a){
		                              return cont
		                                      (function(b, c, cont){
		return caml_exact_trampoline_cps_call$2
		        (using, encode, a, b, c, cont);
		                                       });
		                             });
		                   case 5:
		                    var item = param[3], deconstruct = param[2];
		                    return caml_exact_trampoline_cps_call
		                            (of_schema$1,
		                             item,
		                             function(c){
		                              var
		                               a = [0, colon],
		                               b =
		                                 seq
		                                  ([0, semi],
		                                   function(b, d, cont){
		                                    return caml_exact_trampoline_cps_call$3
		    (pair, a, string$1, c, b, d, cont);
		                                   });
		                              return cont
		                                      (composite_object
		(123,
		 function(ppf, v, cont){
		  return caml_trampoline_cps_call2
		          (deconstruct,
		           v,
		           function(a){
		            return caml_exact_trampoline_cps_call$2
		                    (using, to_seq$0, b, ppf, a, cont);
		           });
		 },
		 125));
		                             });
		                   case 6:
		                    var schema$0 = param[1];
		                    return caml_exact_trampoline_cps_call
		                            (of_schema$1,
		                             schema$0,
		                             function(b){
		                              var
		                               a =
		                                 [0,
		                                  function(ppf, param, cont){
		                                   return caml_exact_trampoline_cps_call$1
		   (pp_print_string, ppf, cst_None, cont);
		                                  }];
		                              return cont
		                                      (function(c, d, cont){
		return caml_exact_trampoline_cps_call$2
		        (option, a, b, c, d, cont);
		                                       });
		                             });
		                   case 7:
		                    var
		                     fields = param[3],
		                     encode$0 = param[2],
		                     f$0 =
		                       function(field, cont){
		                        var schema = field[8][1];
		                        return caml_exact_trampoline_cps_call
		                                (of_schema$1,
		                                 schema,
		                                 function(pp){
		                                  var match = field[7];
		                                  if(typeof match === "number")
		                                   switch(match){
		                                     case 1:
		                                      var
		                                       pp_value =
		 function(ppf, param, cont){
		  if(! param)
		   return caml_exact_trampoline_cps_call$1
		           (pp_none, ppf, dummy, cont);
		  var v = param[1];
		  return caml_exact_trampoline_cps_call$2
		          (option, 0, pp, ppf, v, cont);
		 };
		                                      break;
		                                     case 2:
		                                      pp_value = pp; break;
		                                     default:
		                                      pp_value =
		                                       function(a, b, cont){
		return caml_exact_trampoline_cps_call$2
		        (option, 0, pp, a, b, cont);
		                                       };
		                                   }
		                                  else
		                                   pp_value = pp;
		                                  return cont
		  (function(v, param, cont){
		    var
		     fmt = param[2],
		     first = param[1],
		     v$0 = field[5],
		     pp_v0 = first ? pp_none : semi;
		    return caml_exact_trampoline_cps_call$1
		            (pp_v0,
		             fmt,
		             v,
		             function(a){
		              var indent = opt$5[1];
		              return caml_exact_trampoline_cps_call$1
		                      (pp_open_box,
		                       fmt,
		                       indent,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (pp_print_string,
		                                 fmt,
		                                 v$0,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$1
		  (pp_print_string,
		   fmt,
		   cst$21,
		   function(a){
		    pp_v1(fmt);
		    return caml_trampoline_cps_call3
		            (pp_value,
		             fmt,
		             v,
		             function(a){
		              pp_close_box(fmt);
		              return cont([0, 0, [0, 0, fmt]]);
		             });
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       };
		                    return caml_exact_trampoline_cps_call$1
		                            (Inline_fmt[3],
		                             [0, f$0],
		                             fields,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (ok_or_failwith,
		                                       a,
		                                       function(pp){
		var
		 printer =
		   composite_object
		    (123,
		     function(fmt, v, cont){
		      return caml_trampoline_cps_call3
		              (pp,
		               v,
		               [0, 1, fmt],
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_char, fmt, 59, cont);
		               });
		     },
		     125);
		return cont
		        (function(fmt, v, cont){
		          return caml_trampoline_cps_call2
		                  (encode$0,
		                   v,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (printer, fmt, a, cont);
		                   });
		         });
		                                       });
		                             });
		                   case 8:
		                    var item$0 = param[3], deconstruct$0 = param[2];
		                    return caml_exact_trampoline_cps_call
		                            (of_schema$1,
		                             item$0,
		                             function(b){
		                              var a = seq([0, semi], b);
		                              return cont
		                                      (composite_object
		(91,
		 function(ppf, v, cont){
		  return caml_trampoline_cps_call2
		          (deconstruct$0,
		           v,
		           function(b){
		            return caml_exact_trampoline_cps_call$2
		                    (using, to_seq$0, a, ppf, b, cont);
		           });
		 },
		 93));
		                             });
		                   case 9:
		                    var s = param[1];
		                    return cont
		                            (function(ppf, param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (string$1, ppf, s, cont);
		                             });
		                   case 10:
		                    var
		                     items = param[3],
		                     t_encode = param[2],
		                     pp_v1$0 = of_tuple(items);
		                    return cont
		                            (function(state, v, cont){
		                              return caml_trampoline_cps_call2
		                                      (t_encode,
		                                       v,
		                                       function(v){
		var indent = opt$3[1];
		return caml_exact_trampoline_cps_call$1
		        (pp_open_box,
		         state,
		         indent,
		         function(a){
		          var indent = opt$2[1];
		          return caml_exact_trampoline_cps_call$0
		                  (pp_open_box_gen,
		                   state,
		                   indent,
		                   2,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_char,
		                             state,
		                             40,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_v0,
		                                       state,
		                                       v,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (pp_v1$0,
		         state,
		         v,
		         function(a){
		          pp_close_box(state);
		          return caml_exact_trampoline_cps_call$1
		                  (pp_v0,
		                   state,
		                   v,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_char,
		                             state,
		                             41,
		                             function(a){return cont(pp_close_box(state));});
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 11:
		                    var
		                     cases = param[2],
		                     f$1 =
		                       function(param, cont){
		                        var schema = param[7], encoder = param[2];
		                        return caml_exact_trampoline_cps_call
		                                (of_schema$1,
		                                 schema,
		                                 function(pp){
		                                  return cont
		  (function(fmt, v, cont){
		    return caml_trampoline_cps_call2
		            (encoder,
		             v,
		             function(match){
		              if(! match) return cont(0);
		              var v = match[1];
		              return caml_trampoline_cps_call3
		                      (pp, fmt, v, function(a){return cont([0, a]);});
		             });
		   });
		                                 });
		                       };
		                    return caml_exact_trampoline_cps_call$1
		                            (map$7,
		                             cases,
		                             f$1,
		                             function(cases){
		                              return cont
		                                      (function(fmt, v, cont){
		function a(param){
		 function b(match){return match ? cont(0) : cont(0);}
		 if(! param) return b(0);
		 var l = param[2], x = param[1];
		 return caml_trampoline_cps_call3
		         (x,
		          fmt,
		          v,
		          function(r){
		           return r ? b(r) : caml_exact_trampoline_call1(a, l);
		          });
		}
		return a(cases);
		                                       });
		                             });
		                   default:
		                    var descriptor$0 = param[1];
		                    return caml_exact_trampoline_call1(a, descriptor$0);
		                 }
		                }
		                return a(param);
		               }
		               function of_tuple(param){
		                if(! param) return pp_none;
		                var schema = param[1];
		                if(! param[2])
		                 return function(f, param, cont){
		                  var v = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (of_schema$1,
		                           schema,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, f, v, cont);
		                           });};
		                var rest = param[2];
		                return function(f, param, cont){
		                 var tl = param[2], hd = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (of_schema$1,
		                          schema,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a,
		                                    f,
		                                    hd,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (comma,
		      f,
		      dummy,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (of_tuple(rest), f, tl, cont);
		      });
		                                    });
		                          });};
		               }
		               function compare$30(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  case 2:
		                   if(2 === rhs) return cont(0); break;
		                  case 3:
		                   if(3 === rhs) return cont(0); break;
		                  case 4:
		                   if(4 === rhs) return cont(0); break;
		                  case 5:
		                   if(5 === rhs) return cont(0); break;
		                  case 6:
		                   if(6 === rhs) return cont(0); break;
		                  case 7:
		                   if(7 === rhs) return cont(0); break;
		                  case 8:
		                   if(8 === rhs) return cont(0); break;
		                  case 9:
		                   if(9 === rhs) return cont(0); break;
		                  case 10:
		                   if(10 === rhs) return cont(0); break;
		                  default: if(11 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   case 6:
		                    return 6;
		                   case 7:
		                    return 7;
		                   case 8:
		                    return 8;
		                   case 9:
		                    return 9;
		                   case 10:
		                    return 10;
		                   default: return 11;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               function of_int$4(d, cont){
		                var switcher = d - 1 | 0;
		                if(11 < switcher >>> 0)
		                 return caml_exact_trampoline_cps_call$1
		                         (ksprintf,
		                          fail,
		                          format,
		                          function(a){return caml_trampoline_cps_call2(a, d, cont);});
		                switch(switcher){
		                  case 0:
		                   return cont(k8);
		                  case 1:
		                   return cont(k9);
		                  case 2:
		                   return cont(k_);
		                  case 3:
		                   return cont(k$);
		                  case 4:
		                   return cont(la);
		                  case 5:
		                   return cont(lb);
		                  case 6:
		                   return cont(lc);
		                  case 7:
		                   return cont(ld);
		                  case 8:
		                   return cont(le);
		                  case 9:
		                   return cont(lf);
		                  case 10:
		                   return cont(lg);
		                  default: return cont(lh);
		                }
		               }
		               function to_int$1(param){
		                switch(param){
		                  case 0:
		                   return 1;
		                  case 1:
		                   return 2;
		                  case 2:
		                   return 3;
		                  case 3:
		                   return 4;
		                  case 4:
		                   return 5;
		                  case 5:
		                   return 6;
		                  case 6:
		                   return 7;
		                  case 7:
		                   return 8;
		                  case 8:
		                   return 9;
		                  case 9:
		                   return 10;
		                  case 10:
		                   return 11;
		                  default: return 12;
		                }
		               }
		               function pp_v1$0(fmt, param, cont){
		                var
		                 year = param[3],
		                 month = param[2],
		                 day = param[1],
		                 a = to_int$1(month);
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         li,
		                         function(b){
		                          return caml_trampoline_cps_call4(b, year, a, day, cont);
		                         });
		               }
		               function to_tuple(param, cont){
		                var year = param[3], month = param[2], day = param[1];
		                return cont([0, year, to_int$1(month), day]);
		               }
		               function of_tuple$0(date, cont){
		                var day = date[3], month = date[2], year = date[1];
		                function a(month, cont){
		                 if(of_date(0, date)) return cont([0, [0, day, month, year]]);
		                 var a = [0, day, month, year];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$17,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (b, pp_v1$0, a, function(a){return cont([1, a]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_int$4,
		                         month,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$1, b, a, cont);
		                         });
		               }
		               var letrec_function_context$7 = [];
		               function compare$31(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$7[3],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$7[2],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(x){
		                if(0 !== x) return cont(x);
		                var a = rhs[3], b = lhs[3];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$7[1],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function _2$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$7, [0, _2$0, _1$0, _0$0]);
		               function make$7(hours, minutes, seconds, cont){
		                function b(param, cont){
		                 function b(param, cont){
		                  function b(param, cont){
		                   return cont([0, [0, hours, minutes, seconds]]);
		                  }
		                  function a(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (symbol_bind$1, a, b, cont);
		                  }
		                  if(0 <= seconds && 60 > seconds) return a(lj);
		                  return caml_exact_trampoline_cps_call$1
		                          (ksprintf,
		                           fail,
		                           format$0,
		                           function(b){return caml_trampoline_cps_call2(b, hours, a);});
		                 }
		                 function a(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol_bind$1, a, b, cont);
		                 }
		                 if(0 <= minutes && 60 > minutes) return a(lk);
		                 return caml_exact_trampoline_cps_call$1
		                         (ksprintf,
		                          fail,
		                          format$1,
		                          function(b){return caml_trampoline_cps_call2(b, hours, a);});
		                }
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol_bind$1, a, b, cont);
		                }
		                if(0 <= hours && 24 > hours) return a(ll);
		                return caml_exact_trampoline_cps_call$1
		                        (ksprintf,
		                         fail,
		                         format$2,
		                         function(b){return caml_trampoline_cps_call2(b, hours, a);});
		               }
		               function to_tuple$0(param){
		                var seconds = param[3], minutes = param[2], hours = param[1];
		                return [0, hours, minutes, seconds];
		               }
		               var letrec_function_context$8 = [];
		               function compare$32(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$8[2],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$8[1],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3(c, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function _1$1(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$1(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy(letrec_function_context$8, [0, _1$1, _0$1]);
		               function compare$33(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  case 2:
		                   if(2 === rhs) return cont(0); break;
		                  case 3:
		                   if(3 === rhs) return cont(0); break;
		                  case 4:
		                   if(4 === rhs) return cont(0); break;
		                  case 5:
		                   if(5 === rhs) return cont(0); break;
		                  default: if(6 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   default: return 6;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               function schema_versioned$1(param, cont){
		                return cont([0, id$2, 0, [4, of_tuple$0, to_tuple, 1], 0]);
		               }
		               var schema$5 = caml_callback(schema_versioned$1, [dummy]);
		               function schema_versioned$2(a){
		                function decode(param, cont){
		                 var
		                  a = param[2],
		                  seconds = a[2][1],
		                  minutes = a[1],
		                  hours = param[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (make$7, hours, minutes, seconds, cont);
		                }
		                function encode(param, cont){
		                 var seconds = param[3], minutes = param[2], hours = param[1];
		                 return cont([0, hours, [0, minutes, [0, seconds, 0]]]);
		                }
		                var
		                 a =
		                   [0,
		                    field
		                     (0, 0, lo, ln, 0, lm, 0, 0, cst_seconds, [0, int_schema]),
		                    0],
		                 a =
		                   [0,
		                    field
		                     (0, 0, lr, lq, 0, lp, 0, 0, cst_minutes, [0, int_schema]),
		                    a],
		                 descriptor =
		                   object
		                    (function(a, cont){return cont(a);},
		                     function(a, cont){return cont(a);},
		                     [0,
		                      field(0, 0, lt, ls, 0, 2, 0, 0, cst_hours, [0, int_schema]),
		                      a]);
		                return [0, id$3, 0, [4, decode, encode, descriptor], 0];
		               }
		               var schema$6 = schema_versioned$2();
		               function make_case(name, encoder, decoder){
		                var descriptor = [9, name];
		                return case$
		                        (decoder, encoder, 0, 0, 0, name, [0, 0, 0, descriptor, 0]);
		               }
		               function schema_versioned$3(a){
		                a =
		                 [0,
		                  make_case
		                   ("december",
		                    function(param, cont){
		                     return 11 <= param ? cont(lu) : cont(0);
		                    },
		                    function(param, cont){return cont(11);}),
		                  0];
		                a =
		                 [0,
		                  make_case
		                   ("november",
		                    function(param, cont){
		                     return 10 === param ? cont(lv) : cont(0);
		                    },
		                    function(param, cont){return cont(10);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("october",
		                    function(param, cont){
		                     return 9 === param ? cont(lw) : cont(0);
		                    },
		                    function(param, cont){return cont(9);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("september",
		                    function(param, cont){
		                     return 8 === param ? cont(lx) : cont(0);
		                    },
		                    function(param, cont){return cont(8);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("august",
		                    function(param, cont){
		                     return 7 === param ? cont(ly) : cont(0);
		                    },
		                    function(param, cont){return cont(7);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("july",
		                    function(param, cont){
		                     return 6 === param ? cont(lz) : cont(0);
		                    },
		                    function(param, cont){return cont(6);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("june",
		                    function(param, cont){
		                     return 5 === param ? cont(lA) : cont(0);
		                    },
		                    function(param, cont){return cont(5);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("may",
		                    function(param, cont){
		                     return 4 === param ? cont(lB) : cont(0);
		                    },
		                    function(param, cont){return cont(4);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("april",
		                    function(param, cont){
		                     return 3 === param ? cont(lC) : cont(0);
		                    },
		                    function(param, cont){return cont(3);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("march",
		                    function(param, cont){
		                     return 2 === param ? cont(lD) : cont(0);
		                    },
		                    function(param, cont){return cont(2);}),
		                  a];
		                a =
		                 [0,
		                  make_case
		                   ("february",
		                    function(param, cont){
		                     return 1 === param ? cont(lE) : cont(0);
		                    },
		                    function(param, cont){return cont(1);}),
		                  a];
		                var
		                 descriptor =
		                   union$2
		                    (0,
		                     [0,
		                      make_case
		                       ("january",
		                        function(param, cont){return param ? cont(0) : cont(lF);},
		                        function(param, cont){return cont(0);}),
		                      a]);
		                return [0, id$4, 0, descriptor, 0];
		               }
		               function schema_versioned$4(param, cont){
		                return cont
		                        ([0, lG, schema$269[2], schema$269[3], schema$269[4]]);
		               }
		               var schema$7 = caml_callback(schema_versioned$4, [dummy]);
		               function timestamp_schema_versioned(param){
		                function decode(timestamp, cont){
		                 var match = of_span(of_int_s(timestamp));
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$18,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a, timestamp, function(a){return cont([1, a]);});
		                           });
		                 var ptime = match[1];
		                 return cont([0, ptime]);
		                }
		                function encode(time, cont){
		                 var match = to_int_s(time);
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf, failwith, fmt$19, cont);
		                 var timestamp = match[1];
		                 return cont(timestamp);
		                }
		                return [0, id$5, 0, [4, decode, encode, 4], 0];
		               }
		               var
		                cst_friday = "friday",
		                cst_monday = "monday",
		                cst_saturday = "saturday",
		                cst_sunday = "sunday",
		                cst_thursday = "thursday",
		                cst_tuesday = "tuesday",
		                cst_wednesday = "wednesday";
		               function schema_versioned$6(a, cont){
		                function case$0(name, encoder, decoder){
		                 var descriptor = [9, name];
		                 return case$
		                         (decoder, encoder, 0, 0, 0, name, [0, 0, 0, descriptor, 0]);
		                }
		                var
		                 a =
		                   [0,
		                    case$0
		                     (cst_sunday,
		                      function(param, cont){
		                       return 6 <= param ? cont(lH) : cont(0);
		                      },
		                      function(param, cont){return cont(6);}),
		                    0],
		                 a =
		                   [0,
		                    case$0
		                     (cst_saturday,
		                      function(param, cont){
		                       return 5 === param ? cont(lI) : cont(0);
		                      },
		                      function(param, cont){return cont(5);}),
		                    a],
		                 a =
		                   [0,
		                    case$0
		                     (cst_friday,
		                      function(param, cont){
		                       return 4 === param ? cont(lJ) : cont(0);
		                      },
		                      function(param, cont){return cont(4);}),
		                    a],
		                 a =
		                   [0,
		                    case$0
		                     (cst_thursday,
		                      function(param, cont){
		                       return 3 === param ? cont(lK) : cont(0);
		                      },
		                      function(param, cont){return cont(3);}),
		                    a],
		                 a =
		                   [0,
		                    case$0
		                     (cst_wednesday,
		                      function(param, cont){
		                       return 2 === param ? cont(lL) : cont(0);
		                      },
		                      function(param, cont){return cont(2);}),
		                    a],
		                 a =
		                   [0,
		                    case$0
		                     (cst_tuesday,
		                      function(param, cont){
		                       return 1 === param ? cont(lM) : cont(0);
		                      },
		                      function(param, cont){return cont(1);}),
		                    a],
		                 descriptor =
		                   union$2
		                    (0,
		                     [0,
		                      case$0
		                       (cst_monday,
		                        function(param, cont){return param ? cont(0) : cont(lN);},
		                        function(param, cont){return cont(0);}),
		                      a]);
		                return cont([0, id$7, 0, descriptor, 0]);
		               }
		               var schema_string = caml_callback(schema_versioned$6, [dummy]);
		               function to_string$17(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(cst_Monday);
		                  case 1:
		                   return cont(cst_Tuesday);
		                  case 2:
		                   return cont(cst_Wednesday);
		                  case 3:
		                   return cont(cst_Thursday);
		                  case 4:
		                   return cont(cst_Friday);
		                  case 5:
		                   return cont(cst_Saturday);
		                  default: return cont(cst_Sunday);
		                }
		               }
		               function sexp_of_t$25(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$17, t, function(a){return cont([0, a]);});
		               }
		               function to_int$2(b, weekday){
		                var base = b ? b[1] : 0;
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   default: return 6;
		                 }
		                }
		                var b = to_int(base), a = (to_int(weekday) - b | 0) + 7 | 0;
		                return a % 7 | 0;
		               }
		               function _11(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, to_string$17, a, b, cont);
		               }
		               var
		                include$25 = Make$2([0, compare$33, sexp_of_t$25]),
		                equal$16 = include$25[7],
		                compare$34 = include$25[8];
		               function to_string$18(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(cst_January);
		                  case 1:
		                   return cont(cst_February);
		                  case 2:
		                   return cont(cst_March);
		                  case 3:
		                   return cont(cst_April);
		                  case 4:
		                   return cont(cst_May);
		                  case 5:
		                   return cont(cst_June);
		                  case 6:
		                   return cont(cst_July);
		                  case 7:
		                   return cont(cst_August);
		                  case 8:
		                   return cont(cst_September);
		                  case 9:
		                   return cont(cst_October);
		                  case 10:
		                   return cont(cst_November);
		                  default: return cont(cst_December);
		                }
		               }
		               function sexp_of_t$26(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$18, t, function(a){return cont([0, a]);});
		               }
		               function to_date$0(year, month, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_tuple$0,
		                         [0, year, to_int$1(month), 1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (ok_or_failwith, a, cont);
		                         });
		               }
		               function days(year, month){
		                var month$0 = to_int$1(month);
		                function f(i, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_tuple$0,
		                          [0, year, month$0, i],
		                          function(match){
		                           if(0 !== match[0]) return cont(0);
		                           var date = match[1];
		                           return cont([0, [0, date, i + 1 | 0]]);
		                          });
		                }
		                return unfold$0(1, f);
		               }
		               function pp$11(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, to_string$18, a, b, cont);
		               }
		               var
		                include$26 = Make$2([0, compare$30, sexp_of_t$26]),
		                symbol$67 = include$26[3],
		                symbol$68 = include$26[4],
		                symbol$69 = include$26[6],
		                equal$17 = include$26[7],
		                compare$35 = include$26[8];
		               function sexp_of_t$27(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$20,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$4, s, function(a){return cont([0, a]);});
		                         });
		               }
		               function hours(s){return of_int_s((s * 60 | 0) * 60 | 0);}
		               function minutes(s){return of_int_s(s * 60 | 0);}
		               function to_seconds(s, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (value_exn, lW, 0, 0, to_int_s(s), cont);
		               }
		               var
		                include$27 = Make$2([0, compare$23, sexp_of_t$27]),
		                symbol$70 = include$27[1],
		                symbol$71 = include$27[4],
		                symbol$72 = include$27[5],
		                equal$18 = include$27[7],
		                cst_0s = "0s";
		               function pp$12(ppf, span, cont){
		                var ps = span[2], days = span[1];
		                if(0 <= days)
		                 var ps$0 = ps, days$0 = days, negative = 0;
		                else if(caml_equal(ps, l8)){
		                 ps$0 = l9;
		                 days$0 = - days | 0;
		                 negative = 1;
		                }
		                else
		                 var
		                  ps$1 =
		                    caml_int64_neg
		                     (caml_int64_sub
		                       (ps, caml_int64_create_lo_mi_hi(9961472, 16013212, 306))),
		                  days$1 = - (days + 1 | 0) | 0,
		                  ps$0 = ps$1,
		                  days$0 = days$1,
		                  negative = 1;
		                if(0 === days$0 && caml_lessthan(ps$0, lX))
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, ppf, cst_0s, cont);
		                var d = stdlib_abs(days$0);
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$28,
		                         caml_int64_div
		                          (ps$0, caml_int64_create_lo_mi_hi(3211264, 13250129, 12)),
		                         lY,
		                         function(a){
		                          var h = caml_int64_to_int32(a);
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$28,
		                                   caml_int64_div
		                                    (ps$0, caml_int64_create_lo_mi_hi(11517952, 3576278, 0)),
		                                   lZ,
		                                   function(a){
		                                    var m = caml_int64_to_int32(a);
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$28,
		     caml_int64_div(ps$0, pico),
		     l0,
		     function(a){
		      var s = caml_int64_to_int32(a);
		      return caml_exact_trampoline_cps_call$1
		              (symbol$28,
		               caml_int64_div(ps$0, l2),
		               l1,
		               function(a){
		                var ms = caml_int64_to_int32(a);
		                function sp(c, l, r){
		                 if(0 < l && 0 < r)
		                  return function(ppf, param, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_char, ppf, c, cont);};
		                 return pp_none;
		                }
		                var
		                 a =
		                   [0,
		                    function(ppf, param, cont){
		                     return 0 === m
		                             ? cont(0)
		                             : caml_exact_trampoline_cps_call
		                               (fprintf$0(ppf),
		                                l5,
		                                function(a){return caml_trampoline_cps_call2(a, m, cont);});
		                    },
		                    [0,
		                     sp(32, m, s),
		                     [0,
		                      function(ppf, param, cont){
		                       if(0 === s && 0 === ms) return cont(0);
		                       return 0 === ms
		                               ? caml_exact_trampoline_cps_call
		                                 (fprintf$0(ppf),
		                                  l6,
		                                  function(a){return caml_trampoline_cps_call2(a, s, cont);})
		                               : caml_exact_trampoline_cps_call
		                                 (fprintf$0(ppf),
		                                  l7,
		                                  function(a){
		                                   return caml_trampoline_cps_call3(a, s, ms, cont);
		                                  });
		                      },
		                      0]]],
		                 a =
		                   [0,
		                    function(ppf, param, cont){
		                     return 0 === h
		                             ? cont(0)
		                             : caml_exact_trampoline_cps_call
		                               (fprintf$0(ppf),
		                                l4,
		                                function(a){return caml_trampoline_cps_call2(a, h, cont);});
		                    },
		                    [0, sp(32, h, m), a]],
		                 a =
		                   [0,
		                    function(ppf, param, cont){
		                     return 0 === d
		                             ? cont(0)
		                             : 1
		                               === d
		                               ? caml_exact_trampoline_cps_call$1
		                                 (pp_print_string, ppf, "1 day", cont)
		                               : caml_exact_trampoline_cps_call
		                                 (fprintf$0(ppf),
		                                  l3,
		                                  function(a){return caml_trampoline_cps_call2(a, d, cont);});
		                    },
		                    [0, sp(32, d, h), a]];
		                if(negative)
		                 var
		                  b =
		                    function(ppf, param, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (pp_print_char, ppf, 45, cont);
		                    };
		                else
		                 b = pp_none;
		                var pps = [0, b, a];
		                return caml_exact_trampoline_cps_call$3
		                        (iter$7,
		                         [0, pp_none],
		                         iter$0,
		                         function(ppf, pp, cont){
		                          return caml_trampoline_cps_call3(pp, ppf, 0, cont);
		                         },
		                         ppf,
		                         pps,
		                         cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function of_gmt_offset_seconds(s, cont){
		                function a(name){
		                 return cont
		                         ([0,
		                           name,
		                           function(a, param, cont){return cont(s);},
		                           function(param, cont){return cont(s);}]);
		                }
		                if(0 === s) return a(cst_UTC);
		                var
		                 minutes = stdlib_abs(s / 60 | 0),
		                 hours = minutes / 60 | 0,
		                 minutes$0 = minutes % 60 | 0,
		                 b = 0 < s ? 43 : 45;
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$21,
		                         function(c){
		                          return caml_trampoline_cps_call4(c, b, hours, minutes$0, a);
		                         });
		               }
		               var
		                timezone =
		                  [0,
		                   cst_UTC,
		                   function(a, param, cont){return cont(0);},
		                   function(param, cont){return cont(0);}];
		               function gmt_offset_seconds_at_datetime(tz, date, time, cont){return caml_trampoline_cps_call3(tz[2], date, time, cont);
		               }
		               function gmt_offset_seconds_at_time(tz, ptime, cont){
		                var unix_timestamp = caml_int64_of_float(to_float_s(ptime));
		                return caml_trampoline_cps_call2(tz[3], unix_timestamp, cont);
		               }
		               function to_string$19(param, cont){
		                var name = param[1];
		                return name !== cst$1
		                        ? cont(name)
		                        : caml_exact_trampoline_cps_call
		                          (failwith,
		                           "it appears you mixed a pre 1.0 Clock implementation with a post 1.1 Timmy interface",
		                           cont);
		               }
		               function compare$36(t1, t2, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$19,
		                         t2,
		                         function(y){
		                          return caml_exact_trampoline_cps_call
		                                  (to_string$19,
		                                   t1,
		                                   function(x){return cont(caml_string_compare(x, y));});
		                         });
		               }
		               function sexp_of_t$28(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$19, t, function(a){return cont([0, a]);});
		               }
		               var
		                include$28 = Make$2([0, compare$36, sexp_of_t$28]),
		                equal$19 = include$28[7];
		               function pp$13(fmt, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$19,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, fmt, a, cont);
		                         });
		               }
		               function sexp_of_t$29(t, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (to_rfc3339, 0, 0, 0, t, function(a){return cont([0, a]);});
		               }
		               var
		                include$29 = Make$2([0, compare$23, sexp_of_t$29]),
		                symbol$73 = include$29[1],
		                symbol$74 = include$29[2],
		                symbol$75 = include$29[4],
		                symbol$76 = include$29[5],
		                symbol$77 = include$29[6],
		                equal$20 = include$29[7],
		                compare$37 = include$29[8],
		                min$12 = include$29[9],
		                max$13 = include$29[10],
		                comparator$10 = include$29[16];
		               function symbol$78(t, span, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (value_exn, l_, 0, 0, add_span(t, span), cont);
		               }
		               function of_rfc3339$0(s, cont){
		                var a = of_rfc3339(l$, 0, 0, s);
		                if(0 === a[0]){var time = a[1][1]; return cont([0, time]);}
		                var e = a[1][2][2];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$22,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp_rfc3339_error, e, function(x){return cont([1, x]);});
		                         });
		               }
		               function to_rfc3339$0(timezone, t, cont){
		                function f(tz, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (gmt_offset_seconds_at_time, tz, t, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (map$3,
		                         timezone,
		                         f,
		                         function(tz_offset_s){
		                          return caml_exact_trampoline_cps_call$2
		                                  (to_rfc3339, 0, 0, tz_offset_s, t, cont);
		                         });
		               }
		               function to_sexp_tuple(param, cont){
		                var d = param[3], m = param[2], y = param[1];
		                return cont
		                        ([1,
		                          [0, [0, "" + y], [0, [0, "" + m], [0, [0, "" + d], 0]]]]);
		               }
		               function int_of_string(msg, s, cont){
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call$1
		                           (ksprintf,
		                            fail,
		                            format$3,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, msg, s, cont);
		                            });
		                  });
		                return caml_exact_trampoline_cps_call
		                        (of_string$3,
		                         s,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$0,
		                                   a,
		                                   function(a){caml_pop_trap(); return cont(a);});
		                         });
		               }
		               function of_string$12(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         45,
		                         function(match){
		                          if(match){
		                           var a = match[2];
		                           if(a){
		                            var b = a[2];
		                            if(b && ! b[2]){
		                             var
		                              d = b[1],
		                              m = a[1],
		                              y = match[1],
		                              c =
		                                function(y, cont){
		                                 function a(m, cont){
		                                  function a(d, cont){
		                                   return caml_exact_trampoline_cps_call
		   (of_tuple$0, [0, y, m, d], cont);
		                                  }
		                                  return caml_exact_trampoline_cps_call$1
		  (int_of_string,
		   cst_day,
		   d,
		   function(b){
		    return caml_exact_trampoline_cps_call$1
		            (symbol_bind$1, b, a, cont);
		   });
		                                 }
		                                 return caml_exact_trampoline_cps_call$1
		 (int_of_string,
		  cst_month,
		  m,
		  function(b){
		   return caml_exact_trampoline_cps_call$1
		           (symbol_bind$1, b, a, cont);
		  });
		                                };
		                             return caml_exact_trampoline_cps_call$1
		                                     (int_of_string,
		                                      cst_year,
		                                      y,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (symbol_bind$1, a, c, cont);
		                                      });
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$23,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a, s, function(x){return cont([1, x]);});
		                                   });
		                         });
		               }
		               function of_tuple_exn(here, date, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_tuple$0,
		                         date,
		                         function(match){
		                          if(0 !== match[0])
		                           return caml_exact_trampoline_cps_call$3
		                                   (create$9,
		                                    here,
		                                    0,
		                                    cst_invalid_date$0,
		                                    date,
		                                    to_sexp_tuple,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(raise, a, cont);
		                                    });
		                          var d = match[1];
		                          return cont(d);
		                         });
		               }
		               function to_sexp(date, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_tuple,
		                         date,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_sexp_tuple, a, cont);
		                         });
		               }
		               function compare$38(l, r, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_tuple,
		                         r,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_tuple, l, function(b){return cont(caml_compare(b, a));});
		                         });
		               }
		               function month_of_int(m, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int$4,
		                         m,
		                         function(match){
		                          if(0 === match[0]){var m = match[1]; return cont(m);}
		                          var e = match[1];
		                          return caml_exact_trampoline_cps_call(failwith, e, cont);
		                         });
		               }
		               function of_int$5(jd, cont){
		                var
		                 a = jd + 32044 | 0,
		                 b = ((4 * a | 0) + 3 | 0) / 146097 | 0,
		                 c = a - ((146097 * b | 0) / 4 | 0) | 0,
		                 d = ((4 * c | 0) + 3 | 0) / 1461 | 0,
		                 e = c - ((1461 * d | 0) / 4 | 0) | 0,
		                 m = ((5 * e | 0) + 2 | 0) / 153 | 0,
		                 day = (e - (((153 * m | 0) + 2 | 0) / 5 | 0) | 0) + 1 | 0;
		                return caml_exact_trampoline_cps_call
		                        (month_of_int,
		                         (m + 3 | 0) - (12 * (m / 10 | 0) | 0) | 0,
		                         function(month){
		                          var
		                           year =
		                             (((100 * b | 0) + d | 0) - 4800 | 0) + (m / 10 | 0) | 0;
		                          return cont([0, day, month, year]);
		                         });
		               }
		               function to_int$3(param){
		                var
		                 year = param[3],
		                 month = param[2],
		                 day = param[1],
		                 month$0 = to_int$1(month),
		                 a = (14 - month$0 | 0) / 12 | 0,
		                 y = (year + 4800 | 0) - a | 0,
		                 m = (month$0 + (12 * a | 0) | 0) - 3 | 0;
		                return (((((day + (((153 * m | 0) + 2 | 0) / 5 | 0) | 0)
		                       + (365 * y | 0)
		                       | 0)
		                       + (y / 4 | 0)
		                       | 0)
		                       - (y / 100 | 0)
		                       | 0)
		                       + (y / 400 | 0)
		                       | 0)
		                       - 32045
		                       | 0;
		               }
		               function add_days(date, days, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int$5, to_int$3(date) + days | 0, cont);
		               }
		               var mlen$0 = caml_obj_dup(ma);
		               function max_month_day(y, m){
		                if(2 === m){
		                 var a = 0 === (y % 4 | 0);
		                 if(a){a = 0 !== (y % 100 | 0); a ||= 0 === (y % 400 | 0);}
		                 if(a) return 29;
		                }
		                a = m - 1 | 0;
		                return caml_check_bound(mlen$0, a)[a + 1];
		               }
		               var
		                include$30 = Make$2([0, compare$38, to_sexp]),
		                symbol$79 = include$30[1],
		                symbol$80 = include$30[2],
		                symbol$81 = include$30[3],
		                symbol$82 = include$30[4],
		                symbol$83 = include$30[5],
		                symbol$84 = include$30[6],
		                equal$21 = include$30[7],
		                compare$39 = include$30[8],
		                comparator$11 = include$30[16];
		               function symbol$85(l, r, cont){
		                var
		                 a = to_int$3(r),
		                 s = [0, to_int$3(l) - a | 0, mb],
		                 ps = s[2];
		                a:
		                {
		                 if
		                  (!
		                   caml_lessthan(ps, gH)
		                   && ! caml_greaterthan(ps, ps_day_max)){a = [0, s]; break a;}
		                 a = 0;
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (value_exn, mc, 0, 0, a, cont);
		               }
		               function make$8(year, month, day, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_tuple$0, [0, year, to_int$1(month), day], cont);
		               }
		               function make_overflow(opt, year, month, day, param, cont){
		                var day_truncate = opt ? opt[1] : 0;
		                function adjust_month(year, month, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$23,
		                          month - 1 | 0,
		                          12,
		                          function(b){
		                           var a = b + 1 | 0;
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$24,
		                                    month - 1 | 0,
		                                    12,
		                                    function(b){return cont([0, year + b | 0, a]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (adjust_month,
		                         year,
		                         month,
		                         function(match){
		                          var month = match[2], year = match[1];
		                          function a(year, month, day){
		                           if(0 >= day)
		                            return caml_exact_trampoline_cps_call$1
		                                    (adjust_month,
		                                     year,
		                                     month - 1 | 0,
		                                     function(match){
		                                      var
		                                       month = match[2],
		                                       year = match[1],
		                                       offset = max_month_day(year, month),
		                                       day$0 = day + offset | 0;
		                                      return caml_exact_trampoline_call3(a, year, month, day$0);
		                                     });
		                           var max = max_month_day(year, month);
		                           return day <= max
		                                   ? caml_exact_trampoline_cps_call
		                                     (month_of_int,
		                                      month,
		                                      function(a){return cont([0, day, a, year]);})
		                                   : caml_exact_trampoline_cps_call$1
		                                     (adjust_month,
		                                      year,
		                                      month + 1 | 0,
		                                      function(match){
		                                       var
		month = match[2],
		year = match[1],
		day$0 = day - max | 0;
		                                       return caml_exact_trampoline_call3(a, year, month, day$0);
		                                      });
		                          }
		                          return day_truncate
		                                  ? caml_exact_trampoline_cps_call
		                                    (month_of_int,
		                                     month,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (min$2,
		       day,
		       max_month_day(year, month),
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (max$2, 1, b, function(b){return cont([0, b, a, year]);});
		       });
		                                     })
		                                  : a(year, month, day);
		                         });
		               }
		               function of_time$0(timezone, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (gmt_offset_seconds_at_time,
		                         timezone,
		                         t,
		                         function(tz_offset_s){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_tuple_exn,
		                                   md,
		                                   to_date_time([0, tz_offset_s], t)[1],
		                                   cont);
		                         });
		               }
		               function to_time$1(timezone, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_tuple,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (gmt_offset_seconds_at_datetime,
		                                   timezone,
		                                   a,
		                                   me,
		                                   function(tz_offset_s){
		                                    var a = [0, mf, tz_offset_s];
		                                    return caml_exact_trampoline_cps_call
		    (to_tuple,
		     t,
		     function(b){
		      return caml_exact_trampoline_cps_call$2
		              (value_exn, mg, 0, 0, of_date_time([0, b, a]), cont);
		     });
		                                   });
		                         });
		               }
		               function to_string$20(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_to_string, pp_v1$0, a, cont);
		               }
		               function pp_human$0(f, param, cont){
		                var year = param[3], month = param[2], day = param[1];
		                function nth(f, i, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_int,
		                          f,
		                          i,
		                          function(match){
		                           if(11 !== i && 12 !== i && 13 !== i)
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$23,
		                                     i,
		                                     10,
		                                     function(a){
		                                      return 1 === a
		      ? caml_exact_trampoline_cps_call$1
		        (pp_print_string, f, cst_st, cont)
		      : caml_exact_trampoline_cps_call$1
		        (symbol$23,
		         i,
		         10,
		         function(a){
		          return 2 === a
		                  ? caml_exact_trampoline_cps_call$1
		                    (pp_print_string, f, cst_nd, cont)
		                  : caml_exact_trampoline_cps_call$1
		                    (symbol$23,
		                     i,
		                     10,
		                     function(a){
		                      return 3 === a
		                              ? caml_exact_trampoline_cps_call$1
		                                (pp_print_string, f, cst_rd, cont)
		                              : caml_exact_trampoline_cps_call$1
		                                (pp_print_string, f, cst_th, cont);
		                     });
		         });
		                                     });
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, f, cst_th, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         mh,
		                         function(a){
		                          return caml_trampoline_cps_call6
		                                  (a, pp$11, month, nth, day, year, cont);
		                         });
		               }
		               function weekday(d, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_time$1,
		                         timezone,
		                         d,
		                         function(t){
		                          var
		                           d = symbol$57(t, of_int_s(0))[1],
		                           i = (d + 4 | 0) % 7 | 0,
		                           a = 0 <= i ? i : 7 + i | 0,
		                           a = caml_check_bound(wday, a)[a + 1];
		                          return 4153708 <= a
		                                  ? 4203428
		                                    <= a
		                                    ? 4349046 <= a ? cont(2) : cont(1)
		                                    : 4200545 <= a ? cont(3) : cont(6)
		                                  : 3853996 === a ? cont(0) : 4149254 <= a ? cont(5) : cont(4);
		                         });
		               }
		               function to_date$1(param, cont){
		                var n = param[2], year = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (to_date$0,
		                         year,
		                         0,
		                         function(first){
		                          return caml_exact_trampoline_cps_call
		                                  (weekday,
		                                   first,
		                                   function(a){
		                                    var offset = (- to_int$2(mj, a) | 0) - 4 | 0;
		                                    return cont
		    ((to_int$3(first) + offset | 0) + (n * 7 | 0) | 0);
		                                   });
		                         });
		               }
		               function make$9(year, n, cont){
		                var week = [0, year, n];
		                return 1 <= n
		                        ? 53
		                          < n
		                          ? caml_exact_trampoline_cps_call$1
		                            (ksprintf,
		                             fail,
		                             format$4,
		                             function(a){return caml_trampoline_cps_call2(a, n, cont);})
		                          : caml_exact_trampoline_cps_call
		                            (to_date$1,
		                             week,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (of_int$5,
		                                       a,
		                                       function(a){
		var
		 year$0 = a[3],
		 month = a[2],
		 day = a[1],
		 a =
		   11 <= month ? 29 <= day ? year$0 + 1 | 0 : year$0 : year$0;
		return a !== year
		        ? caml_exact_trampoline_cps_call$1
		          (ksprintf,
		           fail,
		           format$5,
		           function(a){
		            return caml_trampoline_cps_call2(a, year, cont);
		           })
		        : caml_exact_trampoline_cps_call(of_string$0, week, cont);
		                                       });
		                             })
		                        : caml_exact_trampoline_cps_call$1
		                          (ksprintf,
		                           fail,
		                           format$6,
		                           function(a){return caml_trampoline_cps_call2(a, n, cont);});
		               }
		               var cst_n$0 = "n";
		               function schema_versioned$5(a, cont){
		                function decode(param, cont){
		                 var n = param[2][1], year = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (make$9, year, n, cont);
		                }
		                function encode(param, cont){
		                 var n = param[2], year = param[1];
		                 return cont([0, year, [0, n, 0]]);
		                }
		                var
		                 a =
		                   [0,
		                    field(0, 0, 0, 0, 0, 2, 0, 0, cst_n$0, [0, int_schema]),
		                    0],
		                 descriptor =
		                   object
		                    (function(a, cont){return cont(a);},
		                     function(a, cont){return cont(a);},
		                     [0,
		                      field(0, 0, 0, 0, 0, 2, 0, 0, cst_year, [0, int_schema]),
		                      a]);
		                return cont([0, id$6, 0, [4, decode, encode, descriptor], 0]);
		               }
		               var schema$8 = caml_callback(schema_versioned$5, [dummy]);
		               function sexp_of_t$30(param, cont){
		                var n = param[2], year = param[1];
		                return cont([1, [0, [0, "" + year], [0, [0, "" + n], 0]]]);
		               }
		               function of_monday(jd, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int$5,
		                         jd,
		                         function(match){
		                          var year = match[3], month = match[2], day = match[1];
		                          if(11 <= month && 29 <= day)
		                           return cont([0, year + 1 | 0, 1]);
		                          return caml_exact_trampoline_cps_call
		                                  (to_date$1,
		                                   [0, year, 1],
		                                   function(a){
		                                    return cont([0, year, ((jd - a | 0) / 7 | 0) + 1 | 0]);
		                                   });
		                         });
		               }
		               function of_date$1(d, cont){
		                return caml_exact_trampoline_cps_call
		                        (weekday,
		                         d,
		                         function(a){
		                          a = to_int$2(0, a);
		                          return caml_exact_trampoline_cps_call
		                                  (of_monday, to_int$3(d) - a | 0, cont);
		                         });
		               }
		               function to_date$2(week, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_date$1,
		                         week,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_int$5, a, cont);
		                         });
		               }
		               function days$0(week, cont){
		                function a(param, cont){
		                 var date = param[1];
		                 if(7 === param[2]) return cont(0);
		                 var n = param[2], a = [0, date, n + 1 | 0];
		                 return caml_exact_trampoline_cps_call$1
		                         (add_days,
		                          date,
		                          n,
		                          function(b){return cont([0, [0, b, a]]);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (to_date$2,
		                         week,
		                         function(b){return cont(unfold$0([0, b, 0], a));});
		               }
		               function pp$14(f, param, cont){
		                var n = param[2], year = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         ml,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, year, n, cont);
		                         });
		               }
		               var
		                include$31 = Make$2([0, compare$32, sexp_of_t$30]),
		                symbol$86 = include$31[2],
		                symbol$87 = include$31[5],
		                equal$22 = include$31[7],
		                compare$40 = include$31[8],
		                comparator$12 = include$31[16];
		               function symbol$88(week, count, cont){
		                var a = count * 7 | 0;
		                return caml_exact_trampoline_cps_call
		                        (to_date$2,
		                         week,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (of_monday, to_int$3(b) + a | 0, cont);
		                         });
		               }
		               function of_string$13(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         45,
		                         function(match){
		                          if(match){
		                           var a = match[2];
		                           if(a && ! a[2]){
		                            var week = a[1], year = match[1];
		                            caml_push_trap
		                             (function(exn){
		                               return caml_exact_trampoline_cps_call$1
		                                       (ksprintf,
		fail,
		format$8,
		function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                              });
		                            return caml_exact_trampoline_cps_call
		                                    (of_string$3,
		                                     week,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (of_string$3,
		       year,
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (make$9,
		                 b,
		                 a,
		                 function(a){caml_pop_trap(); return cont(a);});
		       });
		                                     });
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (ksprintf,
		                                   fail,
		                                   format$7,
		                                   function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                         });
		               }
		               function sexp_of_tuple(param, cont){
		                var seconds = param[3], minutes = param[2], hours = param[1];
		                return cont
		                        ([1,
		                          [0,
		                           [1, [0, mo, [0, [0, "" + hours], 0]]],
		                           [0,
		                            [1, [0, mn, [0, [0, "" + minutes], 0]]],
		                            [0, [1, [0, mm, [0, [0, "" + seconds], 0]]], 0]]]]);
		               }
		               function sexp_of_t$31(param, cont){
		                var seconds = param[3], minutes = param[2], hours = param[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_tuple, [0, hours, minutes, seconds], cont);
		               }
		               var
		                include$32 = Make$2([0, compare$31, sexp_of_t$31]),
		                equal$23 = include$32[7],
		                compare$41 = include$32[8];
		               function symbol$89(time, span, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_seconds,
		                         span,
		                         function(a){
		                          var
		                           seconds = time[3],
		                           minutes = time[2],
		                           hours = time[1],
		                           s =
		                             ((((hours * 60 | 0) * 60 | 0) + (minutes * 60 | 0) | 0)
		                             + seconds
		                             | 0)
		                             + a
		                             | 0,
		                           minutes$0 = s / 60 | 0,
		                           seconds$0 = s % 60 | 0,
		                           hours$0 = minutes$0 / 60 | 0,
		                           minutes$1 = minutes$0 % 60 | 0;
		                          return caml_exact_trampoline_cps_call$0
		                                  (make$7, hours$0, minutes$1, seconds$0, cont);
		                         });
		               }
		               function of_time$1(timezone, time, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (gmt_offset_seconds_at_time,
		                         timezone,
		                         time,
		                         function(tz_offset_s){
		                          var
		                           match = to_date_time([0, tz_offset_s], time)[2][1],
		                           seconds = match[3],
		                           minutes = match[2],
		                           hours = match[1];
		                          return cont([0, hours, minutes, seconds]);
		                         });
		               }
		               function _12$0(f, param, cont){
		                var seconds = param[3], minutes = param[2], hours = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         mp,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (a, hours, minutes, seconds, cont);
		                         });
		               }
		               var cst_AM = "AM", cst_PM = "PM";
		               function pp_opt(d, c, opt, e, f, a, cont){
		                var
		                 format = d ? d[1] : 4735457,
		                 precision = c ? c[1] : 668917343,
		                 size = opt ? opt[1] : 257225820,
		                 seconds = a[3],
		                 minutes = a[2],
		                 hours = a[1],
		                 hours_format =
		                   4735457 <= format
		                    ? function(param){return mq;}
		                    : function(param){return mt;};
		                a:
		                if(4735457 <= format)
		                 var hours_formatted = hours;
		                else {
		                 if(0 !== hours && 12 !== hours){
		                  hours_formatted = hours % 12 | 0;
		                  break a;
		                 }
		                 hours_formatted = 12;
		                }
		                function b(a){
		                 return 4735457 <= format
		                         ? cont(0)
		                         : 12
		                           <= hours
		                           ? caml_exact_trampoline_cps_call$1
		                             (pp_print_string, f, cst_PM, cont)
		                           : caml_exact_trampoline_cps_call$1
		                             (pp_print_string, f, cst_AM, cont);
		                }
		                a:
		                {
		                 b:
		                 {
		                  if(668917343 === precision){
		                   if(typeof size === "number" && 257225820 === size){
		                    if(0 === minutes && 0 === seconds) break a;
		                    if(0 === seconds) break b;
		                   }
		                   a = symbol$0(hours_format(), ms);
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            a,
		                            function(a){
		                             return caml_trampoline_cps_call4
		                                     (a, hours_formatted, minutes, seconds, b);
		                            });
		                  }
		                  if
		                   (1049730735 <= precision
		                    ||
		                     typeof size === "number"
		                     && 257225820 === size && 0 === minutes)
		                   break a;
		                 }
		                 a = symbol$0(hours_format(), mr);
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a, hours_formatted, minutes, b);
		                          });
		                }
		                a = hours_format();
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2(a, hours_formatted, b);
		                         });
		               }
		               function to_time$2(timezone, date, t, cont){
		                var time_tuple = to_tuple$0(t);
		                return caml_exact_trampoline_cps_call
		                        (to_tuple,
		                         date,
		                         function(date_tuple){
		                          function b(tz_offset_s, cont){
		                           var
		                            match =
		                              of_date_time([0, date_tuple, [0, time_tuple, tz_offset_s]]);
		                           if(! match)
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$24,
		                                     function(a){
		                                      return caml_trampoline_cps_call6
		      (a,
		       pp_v1$0,
		       date,
		       _12$0,
		       t,
		       tz_offset_s,
		       function(x){return cont([1, x]);});
		                                     });
		                           var time = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (of_string$0, time, cont);
		                          }
		                          function a(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol_bind$1, a, b, cont);
		                          }
		                          caml_push_trap
		                           (function(exn){
		                             return caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$25,
		                                      function(b){
		                                       return caml_trampoline_cps_call7
		       (b,
		        pp$13,
		        timezone,
		        pp_v1$0,
		        date,
		        _12$0,
		        t,
		        function(x){return a([1, x]);});
		                                      });
		                            });
		                          return caml_exact_trampoline_cps_call$0
		                                  (gmt_offset_seconds_at_datetime,
		                                   timezone,
		                                   date_tuple,
		                                   time_tuple,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (of_string$0, b, function(b){caml_pop_trap(); return a(b);});
		                                   });
		                         });
		               }
		               function of_tuple$1(param, cont){
		                var seconds = param[3], minutes = param[2], hours = param[1];
		                return caml_exact_trampoline_cps_call$0
		                        (make$7, hours, minutes, seconds, cont);
		               }
		               function to_time$3(timezone, date, t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (to_time$2,
		                         timezone,
		                         date,
		                         t,
		                         function(match){
		                          if(0 === match[0]){var time = match[1]; return cont(time);}
		                          var error = match[1];
		                          return caml_exact_trampoline_cps_call(failwith, error, cont);
		                         });
		               }
		               var
		                Error$0 = [248, "Jsoo_runtime.Error.Exn", caml_fresh_oo_id()];
		               register_exception("jsError", [0, Error$0, [0]]);
		               var
		                global = globalThis,
		                no_handler = null,
		                undefined$ = undefined;
		               function option$1(x){
		                if(! x) return no_handler;
		                var x$0 = x[1];
		                return x$0;
		               }
		               function to_option$0(x){return x == no_handler ? 0 : [0, x];}
		               function test(x){return 1 - (x === undefined$);}
		               function to_option$1(x){return x === undefined$ ? 0 : [0, x];}
		               var
		                object_constructor = global.Object,
		                array_constructor = global.Array,
		                date_fromTimeValue = global.Date;
		               var error_constr = global.Error;
		               function to_string$21(t14){
		                return caml_string_of_jsstring(t14.toString());
		               }
		               var JSON = global.JSON;
		               register_printer
		                (function(e, cont){
		                  if(e instanceof error_constr)
		                   return cont([0, to_string$21(e)]);
		                  if(e[1] !== Error$0) return cont(0);
		                  var e$0 = e[2];
		                  return cont([0, to_string$21(e$0)]);
		                 });
		               function export_js(field, x){
		                var
		                 x$0 = caml_string_of_jsstring(typeof x),
		                 a =
		                   x$0 === cst_function
		                    ? 0 < x.length ? caml_js_wrap_callback(x) : x
		                    : x;
		                return jsoo_exports[field] = a;
		               }
		               function export$(field, x){
		                return export_js(caml_jsstring_of_string(field), x);
		               }
		               var arrayBuffer = global.ArrayBuffer;
		               var uint8Array = global.Uint8Array;
		               var document = global.document;
		               var
		                cst_Delete = "Delete",
		                cst_Home = "Home",
		                cst_Insert = "Insert",
		                cst_Pause = "Pause";
		               function try_code(v){
		                var
		                 match = caml_string_of_jsstring(v),
		                 switch$ = caml_string_compare(match, "KeyH");
		                if(0 <= switch$){
		                 if(0 >= switch$) return 8;
		                 var switch$0 = caml_string_compare(match, "Numpad4");
		                 if(0 <= switch$0){
		                  if(0 >= switch$0) return 72;
		                  var switch$1 = caml_string_compare(match, "PageUp");
		                  if(0 <= switch$1){
		                   if(0 >= switch$1) return 98;
		                   var switch$2 = caml_string_compare(match, "ShiftRight");
		                   if(0 <= switch$2){
		                    if(0 >= switch$2) return 91;
		                    if(match === "Slash") return 55;
		                    if(match === "Space") return 41;
		                    if(match === "Tab") return 39;
		                    if(match === "VolumeDown") return 103;
		                    if(match === "VolumeMute") return 102;
		                    if(match === "VolumeUp") return 104;
		                   }
		                   else {
		                    if(match === cst_Pause) return 123;
		                    if(match === "Period") return 54;
		                    if(match === "PrintScreen") return 120;
		                    if(match === "Quote") return 50;
		                    if(match === "ScrollLock") return 119;
		                    if(match === "Semicolon") return 49;
		                    if(match === "ShiftLeft") return 90;
		                   }
		                  }
		                  else {
		                   var switch$3 = caml_string_compare(match, "NumpadDivide");
		                   if(0 <= switch$3){
		                    if(0 >= switch$3) return 84;
		                    if(match === "NumpadEnter") return 83;
		                    if(match === "NumpadEqual") return 82;
		                    if(match === "NumpadMultiply") return 78;
		                    if(match === "NumpadSubtract") return 79;
		                    if(match === "OSLeft") return 117;
		                    if(match === "OSRight") return 118;
		                    if(match === "PageDown") return 99;
		                   }
		                   else {
		                    if(match === "Numpad5") return 73;
		                    if(match === "Numpad6") return 74;
		                    if(match === "Numpad7") return 75;
		                    if(match === "Numpad8") return 76;
		                    if(match === "Numpad9") return 77;
		                    if(match === "NumpadAdd") return 80;
		                    if(match === "NumpadDecimal") return 81;
		                   }
		                  }
		                 }
		                 else {
		                  var switch$4 = caml_string_compare(match, "KeyX");
		                  if(0 <= switch$4){
		                   if(0 >= switch$4) return 24;
		                   var switch$5 = caml_string_compare(match, "MetaRight");
		                   if(0 <= switch$5){
		                    if(0 >= switch$5) return 89;
		                    if(match === "Minus") return 37;
		                    if(match === "NumLock") return 85;
		                    if(match === "Numpad0") return 68;
		                    if(match === "Numpad1") return 69;
		                    if(match === "Numpad2") return 70;
		                    if(match === "Numpad3") return 71;
		                   }
		                   else {
		                    if(match === "KeyY") return 25;
		                    if(match === "KeyZ") return 26;
		                    if(match === "MediaPlayPause") return 107;
		                    if(match === "MediaStop") return 108;
		                    if(match === "MediaTrackNext") return 106;
		                    if(match === "MediaTrackPrevious") return 105;
		                    if(match === "MetaLeft") return 88;
		                   }
		                  }
		                  else {
		                   var switch$6 = caml_string_compare(match, "KeyP");
		                   if(0 <= switch$6){
		                    if(0 >= switch$6) return 16;
		                    if(match === "KeyQ") return 17;
		                    if(match === "KeyR") return 18;
		                    if(match === "KeyS") return 19;
		                    if(match === "KeyT") return 20;
		                    if(match === "KeyU") return 21;
		                    if(match === "KeyV") return 22;
		                    if(match === "KeyW") return 23;
		                   }
		                   else {
		                    if(match === "KeyI") return 9;
		                    if(match === "KeyJ") return 10;
		                    if(match === "KeyK") return 11;
		                    if(match === "KeyL") return 12;
		                    if(match === "KeyM") return 13;
		                    if(match === "KeyN") return 14;
		                    if(match === "KeyO") return 15;
		                   }
		                  }
		                 }
		                }
		                else {
		                 var switch$7 = caml_string_compare(match, "Digit6");
		                 if(0 <= switch$7){
		                  if(0 >= switch$7) return 33;
		                  var switch$8 = caml_string_compare(match, "F6");
		                  if(0 <= switch$8){
		                   if(0 >= switch$8) return 61;
		                   var switch$9 = caml_string_compare(match, "KeyA");
		                   if(0 <= switch$9){
		                    if(0 >= switch$9) return 1;
		                    if(match === "KeyB") return 2;
		                    if(match === "KeyC") return 3;
		                    if(match === "KeyD") return 4;
		                    if(match === "KeyE") return 5;
		                    if(match === "KeyF") return 6;
		                    if(match === "KeyG") return 7;
		                   }
		                   else {
		                    if(match === "F7") return 62;
		                    if(match === "F8") return 63;
		                    if(match === "F9") return 64;
		                    if(match === cst_Home) return 100;
		                    if(match === cst_Insert) return 44;
		                    if(match === "IntlBackslash") return 121;
		                    if(match === "IntlYen") return 122;
		                   }
		                  }
		                  else {
		                   var switch$10 = caml_string_compare(match, "F1");
		                   if(0 <= switch$10){
		                    if(0 >= switch$10) return 56;
		                    if(match === "F10") return 65;
		                    if(match === "F11") return 66;
		                    if(match === "F12") return 67;
		                    if(match === "F2") return 57;
		                    if(match === "F3") return 58;
		                    if(match === "F4") return 59;
		                    if(match === "F5") return 60;
		                   }
		                   else {
		                    if(match === "Digit7") return 34;
		                    if(match === "Digit8") return 35;
		                    if(match === "Digit9") return 36;
		                    if(match === "End") return 101;
		                    if(match === "Enter") return 40;
		                    if(match === cst_Equal) return 38;
		                    if(match === "Escape") return 42;
		                   }
		                  }
		                 }
		                 else {
		                  var
		                   switch$11 = caml_string_compare(match, "BrowserRefresh");
		                  if(0 <= switch$11){
		                   if(0 >= switch$11) return 113;
		                   var switch$12 = caml_string_compare(match, cst_Delete);
		                   if(0 <= switch$12){
		                    if(0 >= switch$12) return 45;
		                    if(match === "Digit0") return 27;
		                    if(match === "Digit1") return 28;
		                    if(match === "Digit2") return 29;
		                    if(match === "Digit3") return 30;
		                    if(match === "Digit4") return 31;
		                    if(match === "Digit5") return 32;
		                   }
		                   else {
		                    if(match === "BrowserSearch") return 110;
		                    if(match === "BrowserStop") return 114;
		                    if(match === "CapsLock") return 46;
		                    if(match === "Comma") return 53;
		                    if(match === "ContextMenu") return 109;
		                    if(match === "ControlLeft") return 86;
		                    if(match === "ControlRight") return 87;
		                   }
		                  }
		                  else {
		                   var switch$13 = caml_string_compare(match, "Backslash");
		                   if(0 <= switch$13){
		                    if(0 >= switch$13) return 52;
		                    if(match === "Backspace") return 43;
		                    if(match === "BracketLeft") return 47;
		                    if(match === "BracketRight") return 48;
		                    if(match === "BrowserBack") return 116;
		                    if(match === "BrowserFavorites") return 112;
		                    if(match === "BrowserForward") return 115;
		                    if(match === "BrowserHome") return 111;
		                   }
		                   else {
		                    if(match === "AltLeft") return 92;
		                    if(match === "AltRight") return 93;
		                    if(match === "ArrowDown") return 97;
		                    if(match === "ArrowLeft") return 94;
		                    if(match === "ArrowRight") return 95;
		                    if(match === "ArrowUp") return 96;
		                    if(match === "Backquote") return 51;
		                   }
		                  }
		                 }
		                }
		                return 0;
		               }
		               function try_key_code_normal(a){
		                a = a - 8 | 0;
		                if(214 >= a >>> 0)
		                 if(67 <= a)
		                  switch(a){
		                    case 67:
		                     return 11;
		                    case 68:
		                     return 12;
		                    case 69:
		                     return 13;
		                    case 70:
		                     return 14;
		                    case 71:
		                     return 15;
		                    case 72:
		                     return 16;
		                    case 73:
		                     return 17;
		                    case 74:
		                     return 18;
		                    case 75:
		                     return 19;
		                    case 76:
		                     return 20;
		                    case 77:
		                     return 21;
		                    case 78:
		                     return 22;
		                    case 79:
		                     return 23;
		                    case 80:
		                     return 24;
		                    case 81:
		                     return 25;
		                    case 82:
		                     return 26;
		                    case 85:
		                     return 109;
		                    case 104:
		                     return 56;
		                    case 105:
		                     return 57;
		                    case 106:
		                     return 58;
		                    case 107:
		                     return 59;
		                    case 108:
		                     return 60;
		                    case 109:
		                     return 61;
		                    case 110:
		                     return 62;
		                    case 111:
		                     return 63;
		                    case 112:
		                     return 64;
		                    case 113:
		                     return 65;
		                    case 114:
		                     return 66;
		                    case 115:
		                     return 67;
		                    case 137:
		                     return 119;
		                    case 178:
		                     return 49;
		                    case 179:
		                     return 38;
		                    case 180:
		                     return 53;
		                    case 181:
		                     return 37;
		                    case 182:
		                     return 54;
		                    case 183:
		                     return 55;
		                    case 184:
		                     return 51;
		                    case 211:
		                     return 47;
		                    case 212:
		                     return 52;
		                    case 213:
		                     return 48;
		                    case 214:
		                     return 50;
		                  }
		                 else
		                  switch(a){
		                    case 0:
		                     return 43;
		                    case 1:
		                     return 39;
		                    case 5:
		                     return 40;
		                    case 11:
		                     return 123;
		                    case 12:
		                     return 46;
		                    case 19:
		                     return 42;
		                    case 24:
		                     return 41;
		                    case 25:
		                     return 98;
		                    case 26:
		                     return 99;
		                    case 27:
		                     return 101;
		                    case 28:
		                     return 100;
		                    case 29:
		                     return 94;
		                    case 30:
		                     return 96;
		                    case 31:
		                     return 95;
		                    case 32:
		                     return 97;
		                    case 34:
		                     return 120;
		                    case 37:
		                     return 44;
		                    case 38:
		                     return 45;
		                    case 40:
		                     return 27;
		                    case 41:
		                     return 28;
		                    case 42:
		                     return 29;
		                    case 43:
		                     return 30;
		                    case 44:
		                     return 31;
		                    case 45:
		                     return 32;
		                    case 46:
		                     return 33;
		                    case 47:
		                     return 34;
		                    case 48:
		                     return 35;
		                    case 49:
		                     return 36;
		                    case 57:
		                     return 1;
		                    case 58:
		                     return 2;
		                    case 59:
		                     return 3;
		                    case 60:
		                     return 4;
		                    case 61:
		                     return 5;
		                    case 62:
		                     return 6;
		                    case 63:
		                     return 7;
		                    case 64:
		                     return 8;
		                    case 65:
		                     return 9;
		                    case 66:
		                     return 10;
		                  }
		                return 0;
		               }
		               var
		                json = global.JSON,
		                mlInt64_constr =
		                  caml_js_pure_expr
		                   (function(param, cont){
		                     return cont(dummy_int64.constructor);
		                    });
		               function output_reviver(key, value, cont){
		                return caml_obj_tag(value) === 252
		                        ? cont(caml_jsbytes_of_string(value))
		                        : value
		                          instanceof
		                          mlInt64_constr
		                          ? cont
		                            (caml_js_from_array([0, 255, value.lo, value.mi, value.hi]))
		                          : cont(value);
		               }
		               var console = caml_js_get_console(), false$0 = false;
		               function listen(opt, target, typ, cb){
		                var
		                 capture = 0,
		                 capt = ! ! capture,
		                 t37 =
		                   caml_js_wrap_meth_callback_unsafe
		                    (function(this$, t24, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (cb,
		                               dummy,
		                               t24,
		                               function(a){
		                                var res = ! ! a;
		                                return res | 0
		? cont(undefined$)
		: (t24.preventDefault(), cont(false$0));
		                               });
		                     }),
		                 opts = {};
		                opts.capture = capt;
		                target.addEventListener(typ, t37, opts);
		                return function(param, cont){
		                 return cont(target.removeEventListener(typ, t37, opts));};
		               }
		               function intl_get(prop){
		                var x = global.Intl;
		                return x === undefined$
		                        ? undefined
		                        : x[caml_jsstring_of_string(prop)];
		               }
		               intl_get("Collator");
		               var dateTimeFormat_constr = intl_get("DateTimeFormat");
		               intl_get("NumberFormat");
		               intl_get("PluralRules");
		               intl_get("RelativeTimeFormat");
		               function nth$3(f, i, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_int,
		                         f,
		                         i,
		                         function(match){
		                          if(11 !== i && 12 !== i && 13 !== i)
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$23,
		                                    i,
		                                    10,
		                                    function(a){
		                                     return 1 === a
		     ? caml_exact_trampoline_cps_call$1
		       (pp_print_string, f, cst_st, cont)
		     : caml_exact_trampoline_cps_call$1
		       (symbol$23,
		        i,
		        10,
		        function(a){
		         return 2 === a
		                 ? caml_exact_trampoline_cps_call$1
		                   (pp_print_string, f, cst_nd, cont)
		                 : caml_exact_trampoline_cps_call$1
		                   (symbol$23,
		                    i,
		                    10,
		                    function(a){
		                     return 3 === a
		                             ? caml_exact_trampoline_cps_call$1
		                               (pp_print_string, f, cst_rd, cont)
		                             : caml_exact_trampoline_cps_call$1
		                               (pp_print_string, f, cst_th, cont);
		                    });
		        });
		                                    });
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, f, cst_th, cont);
		                         });
		               }
		               var logs_src = create$18(mu, "acid");
		               function Syntax2(Monad){
		                var
		                 symbol = Monad[1],
		                 symbol$0 = Monad[2],
		                 and = Monad[3][4][4];
		                return [0, symbol, symbol$0, symbol, symbol$0, and];
		               }
		               function S_to_S2(X){
		                var
		                 symbol_bind = X[1],
		                 symbol_map = X[2],
		                 bind = X[4],
		                 return$ = X[5],
		                 map = X[6],
		                 Let_syntax = X[11];
		                return [0,
		                        symbol_bind,
		                        symbol_map,
		                        Let_syntax,
		                        ,
		                        bind,
		                        return$,
		                        map];
		               }
		               var Ident2 = S_to_S2(include$0);
		               function MakeNestable2(M){
		                var
		                 include = Make2([0, M[1], M[2], M[3]]),
		                 symbol_bind = include[1],
		                 symbol_map = include[2],
		                 Let_syntax = include[3],
		                 bind = include[5],
		                 return$ = include[6],
		                 map = include[7],
		                 join = include[8],
		                 all = include[10];
		                function Nest2(N){
		                 function return$0(v, cont){
		                  return caml_trampoline_cps_call2
		                          (return$,
		                           v,
		                           function(a){
		                            return caml_trampoline_cps_call2(N[6], a, cont);
		                           });
		                 }
		                 function bind(v, f, cont){
		                  var
		                   symbol_bind = N[1],
		                   symbol_map = N[2],
		                   Let_syntax = N[3],
		                   bind = N[5],
		                   return$ = N[6],
		                   map = N[7];
		                  return caml_exact_trampoline_cps_call$1
		                          (M[4].call
		                             (null,
		                              [0,
		                               symbol_bind,
		                               symbol_map,
		                               Let_syntax,
		                               ,
		                               bind,
		                               return$,
		                               map])
		                            [1],
		                           v,
		                           f,
		                           cont);
		                 }
		                 var
		                  include = Make2([0, bind, -349054340, return$0]),
		                  symbol_bind = include[1],
		                  symbol_map = include[2],
		                  Let_syntax = include[3],
		                  bind$0 = include[5],
		                  return$1 = include[6],
		                  map = include[7];
		                 return [0,
		                         symbol_bind,
		                         symbol_map,
		                         Let_syntax,
		                         ,
		                         bind$0,
		                         return$1,
		                         map];
		                }
		                return [0,
		                        symbol_bind,
		                        symbol_map,
		                        Let_syntax,
		                        ,
		                        bind,
		                        return$,
		                        map,
		                        join,
		                        ,
		                        all,
		                        ,
		                        Nest2];
		               }
		               function bPW(M){
		                var
		                 bind = M[1],
		                 return$ = M[2],
		                 map = M[3],
		                 Nest2 = M[4],
		                 include = MakeNestable2([0, bind, map, return$, Nest2]),
		                 symbol_bind = include[1],
		                 symbol_map = include[2],
		                 Let_syntax = include[3],
		                 bind$0 = include[5],
		                 return$0 = include[6],
		                 map$0 = include[7],
		                 join = include[8],
		                 all = include[10],
		                 Nest2$0 = include[12];
		                return [0,
		                        symbol_bind,
		                        symbol_map,
		                        ,
		                        bind$0,
		                        return$0,
		                        map$0,
		                        join,
		                        ,
		                        all,
		                        ,
		                        Let_syntax,
		                        ,
		                        Nest2$0];
		               }
		               function return$8(x, cont){return cont([0, x]);}
		               var
		                map$16 =
		                  [0,
		                   ,
		                   function(t, f, cont){
		                    if(! t) return cont(0);
		                    var a = t[1];
		                    return caml_trampoline_cps_call2
		                            (f, a, function(a){return cont([0, a]);});
		                   }];
		               function bind$7(o, f, cont){
		                if(! o) return cont(0);
		                var x = o[1];
		                return caml_trampoline_cps_call2(f, x, cont);
		               }
		               function Nest2$0(M){
		                function bind(v, f, cont){
		                 return caml_trampoline_cps_call3
		                         (M[5],
		                          v,
		                          function(param, cont){
		                           if(! param) return caml_trampoline_cps_call2(M[6], 0, cont);
		                           var v = param[1];
		                           return caml_trampoline_cps_call2(f, v, cont);
		                          },
		                          cont);
		                }
		                return [0, bind];
		               }
		               var
		                include$33 = bPW([0, bind$7, return$8, map$16, Nest2$0]),
		                symbol_bind$5 = include$33[1],
		                symbol_map$5 = include$33[2],
		                bind$8 = include$33[4],
		                return$9 = include$33[5],
		                map$17 = include$33[6],
		                join$2 = include$33[7],
		                all$13 = include$33[9],
		                Let_syntax$3 = include$33[11],
		                Nest2$1 = include$33[13];
		               function to_option$2(param){
		                if(0 !== param[0]) return 0;
		                var v = param[1];
		                return [0, v];
		               }
		               function Nest2$2(M){
		                function bind(v, f, cont){
		                 function f$0(e, cont){
		                  if(0 !== e[0])
		                   return caml_trampoline_cps_call2(M[6], e, cont);
		                  var v = e[1];
		                  return caml_trampoline_cps_call2(f, v, cont);
		                 }
		                 return caml_trampoline_cps_call3(M[5], v, f$0, cont);
		                }
		                return [0, bind];
		               }
		               var
		                e =
		                  MakeNestable2([0, bind$1, -349054340, of_string$0, Nest2$2]),
		                Nest2 = e[12],
		                map$15 = e[7],
		                of_string$14 = e[6],
		                bind$6 = e[5],
		                Let_syntax$2 = e[3],
		                symbol_map$4 = e[2],
		                symbol_bind$4 = e[1];
		               function all$14(l, cont){
		                function finish(a, cont){
		                 return caml_trampoline_cps_call3
		                         (map$15, a, of_rev_keys, cont);
		                }
		                function f(acc, param, cont){
		                 if(0 === param[0]){
		                  var x = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$5,
		                           acc,
		                           function(l, cont){return cont([0, x, l]);},
		                           function(a){return cont([0, a]);});
		                 }
		                 var e = param[1];
		                 return cont([1, [1, e]]);
		                }
		                return caml_exact_trampoline_cps_call$3
		                        (fold_until, fold_left$1, init$1, f, finish, l, cont);
		               }
		               function Syntax2$0(M){
		                var
		                 symbol_bind = M[1],
		                 symbol_map = M[2],
		                 and = M[3][4][4],
		                 and$0 = M[3][4][4],
		                 Option_result = Nest2$1(Nest2(M)),
		                 let$ = Option_result[1],
		                 let$0 = Option_result[2],
		                 Option = Nest2$1(M),
		                 let$1 = Option[1],
		                 and$1 = Option[3][4][4],
		                 symbol = Option[2],
		                 let$2 = Option[2],
		                 Result = Nest2(M),
		                 symbol$0 = Result[1],
		                 let$3 = Result[1],
		                 and$2 = Result[3][4][4],
		                 symbol$1 = Result[2],
		                 let$4 = Result[2],
		                 and$3 = Result[3][4][4];
		                return [0,
		                        symbol_bind,
		                        symbol_map,
		                        symbol_bind,
		                        symbol_map,
		                        and,
		                        and$0,
		                        ,
		                        ,
		                        let$,
		                        ,
		                        ,
		                        let$0,
		                        ,
		                        ,
		                        ,
		                        let$1,
		                        and$1,
		                        symbol,
		                        let$2,
		                        ,
		                        ,
		                        symbol$0,
		                        let$3,
		                        and$2,
		                        symbol$1,
		                        let$4,
		                        and$3];
		               }
		               function g(Monad){
		                var
		                 symbol_bind = Monad[1],
		                 symbol_map = Monad[2],
		                 bind = Monad[4],
		                 return$ = Monad[5],
		                 map = Monad[6],
		                 Let_syntax = Monad[11],
		                 a =
		                   Syntax2$0
		                    ([0,
		                      symbol_bind,
		                      symbol_map,
		                      Let_syntax,
		                      ,
		                      bind,
		                      return$,
		                      map]);
		                return [0,
		                        a[1],
		                        a[2],
		                        a[3],
		                        a[4],
		                        a[5],
		                        a[6],
		                        ,
		                        a[16],
		                        a[17],
		                        a[18],
		                        a[19],
		                        ,
		                        a[22],
		                        a[23],
		                        a[24],
		                        a[25],
		                        a[26],
		                        a[27],
		                        ,
		                        a[9],
		                        ,
		                        ,
		                        a[12]];
		               }
		               function o(a){
		                a = Syntax2$0(a);
		                return [0,
		                        a[1],
		                        a[2],
		                        a[3],
		                        a[4],
		                        a[5],
		                        a[6],
		                        ,
		                        a[16],
		                        ,
		                        ,
		                        a[19]];
		               }
		               function Nest2$3(M){
		                function bind(v, f, cont){
		                 var open = o(M), and = open[6], let$ = open[4];
		                 function fold(param, cont){
		                  if(! param) return caml_trampoline_cps_call2(M[6], 0, cont);
		                  var tail = param[2], head = param[1];
		                  function a(param, cont){
		                   var tail = param[2], head = param[1];
		                   return cont([0, head, tail]);
		                  }
		                  return caml_trampoline_cps_call2
		                          (f,
		                           head,
		                           function(left){
		                            return caml_exact_trampoline_cps_call
		                                    (fold,
		                                     tail,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (and,
		       left,
		       b,
		       function(b){
		        return caml_trampoline_cps_call3(let$, b, a, cont);
		       });
		                                     });
		                           });
		                 }
		                 return caml_trampoline_cps_call3
		                         (M[5],
		                          v,
		                          fold,
		                          function(a){
		                           return caml_trampoline_cps_call3(M[7], a, of_list, cont);
		                          });
		                }
		                return [0, bind];
		               }
		               var
		                include$34 =
		                  bPW([0, concat_map, singleton, -349054340, Nest2$3]),
		                map$18 = include$34[6];
		               function thread_id_schema_versioned(param, cont){return cont(schematic_param_name_schema_ve);
		               }
		               var cst_empty_list = "empty list";
		               function schema_versioned$7(a, parameter){
		                function descriptor(parameter){
		                 function decode(param, cont){
		                  if(! param) return cont([1, cst_empty_list]);
		                  var tl = param[2], hd = param[1];
		                  return caml_trampoline_cps_call2
		                          (of_string$14, [0, hd, tl], cont);
		                 }
		                 function encode(param, cont){
		                  var tl = param[2], hd = param[1];
		                  return cont([0, hd, tl]);
		                 }
		                 var descriptor = [3, parameter];
		                 return [4, decode, encode, descriptor];
		                }
		                var
		                 descriptor$0 = descriptor(parameter),
		                 cst_list_nonempty = "list-nonempty",
		                 parametric =
		                   [0,
		                    [1,
		                     cst_a$0,
		                     parameter,
		                     function(a, cont){
		                      return cont([0, cst_list_nonempty, descriptor(a)]);
		                     }]],
		                 a = parameter[1];
		                if(a)
		                 var id = a[1], s2 = cst$33 + cst_list_nonempty, a = id + s2;
		                else
		                 a = cst_list_nonempty;
		                var id$0 = [0, a];
		                return [0, id$0, 0, descriptor$0, parametric];
		               }
		               var
		                logs_src$0 = create$18(0, "Acid_bench"),
		                Log = src_log(logs_src$0),
		                program_start = ocaml_ptime_clock_now_d_ps();
		               function span_to_us(span){
		                var ps = span[2];
		                caml_int64_div(ps, mw);
		               }
		               function pp_position(fmt, param, cont){
		                var pos_lnum = param[2], pos_fname = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         mx,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pos_fname, pos_lnum, cont);
		                         });
		               }
		               var pos_tag = def(my, cst_position, pp_position);
		               function end(param, cont){
		                var start = param[3], pos = param[2], name = param[1];
		                function a(tags){
		                 var
		                  now = ocaml_ptime_clock_now_d_ps(),
		                  s$0 = symbol$58(now, start);
		                 span_to_us(s$0);
		                 var s = symbol$58(start, program_start);
		                 span_to_us(s);
		                 return caml_exact_trampoline_cps_call
		                         (Log[5],
		                          function(m, cont){
		                           var s = symbol$58(now, start);
		                           return caml_trampoline_cps_call7
		                                   (m, 0, [0, tags], mz, name, pp$12, s, cont);
		                          },
		                          cont);
		                }
		                if(! pos) return a(empty$12);
		                var pos$0 = pos[1];
		                return caml_exact_trampoline_cps_call$0
		                        (add$7, pos_tag, pos$0, empty$12, a);
		               }
		               function Monadic(M){
		                function runf(here, name, f, arg, cont){
		                 var
		                  open = g(M),
		                  let$ = open[4],
		                  t = ocaml_ptime_clock_now_d_ps(),
		                  bench = [0, name, here, t];
		                 function a(res, cont){
		                  return caml_exact_trampoline_cps_call
		                          (end, bench, function(match){return cont(res);});
		                 }
		                 return caml_trampoline_cps_call2
		                         (f,
		                          arg,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                }
		                function run(here, name, f, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (runf, here, name, f, 0, cont);
		                }
		                return [0, , run];
		               }
		               var include$35 = Monadic(include$0), run$0 = include$35[2];
		               function pp$15(pp_key, pp_data){
		                var
		                 a =
		                   [0,
		                    function(ppf, v, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (pp_print_string,
		                              ppf,
		                              cst$21,
		                              function(a){return cont(pp_v1(ppf));});
		                    }],
		                 b =
		                   seq
		                    ([0, comma],
		                     function(ppf, v, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (pp_open_box,
		                               ppf,
		                               2,
		                               function(b){
		                                return caml_exact_trampoline_cps_call$3
		(pair,
		 a,
		 pp_key,
		 pp_data,
		 ppf,
		 v,
		 function(a){return cont(pp_close_box(ppf));});
		                               });
		                     });
		                return function(state, map, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (to_sequence$2,
		                          0,
		                          0,
		                          0,
		                          map,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_seq$0,
		                                    a,
		                                    function(v){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_open_box,
		      state,
		      0,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                state,
		                cst$12,
		                function(a){
		                 return function(indent){
		                          return caml_exact_trampoline_cps_call$0
		                                  (pp_open_box_gen,
		                                   state,
		                                   indent,
		                                   2,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$2
		    (append$4,
		     pp_v0,
		     b,
		     state,
		     v,
		     function(a){
		      pp_close_box(state);
		      return caml_exact_trampoline_cps_call$1
		              (pp_v0,
		               state,
		               v,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         state,
		                         cst$11,
		                         function(a){return cont(pp_close_box(state));});
		               });
		     });
		                                   });
		                         }
		                         (1);
		                });
		      });
		                                    });
		                          });};
		               }
		               function M$2(K, cont){
		                return caml_trampoline_cps_call2
		                        (K[2],
		                         function(param, cont){return cont(0);},
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_schema$1,
		                                   a,
		                                   function(pp_key){
		                                    function of_sequence(sequence, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_sequence$3,
		      [0, K[1]],
		      sequence,
		      function(match){
		       var variant = match[1];
		       if(17724 <= variant){
		        var map = match[2];
		        return caml_trampoline_cps_call2(of_string$14, map, cont);
		       }
		       var k = match[2];
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                fail,
		                format$9,
		                function(a){
		                 return caml_trampoline_cps_call3(a, pp_key, k, cont);
		                });
		      });
		                                    }
		                                    function assoc_schema_versioned(version, cont){
		                                     return caml_trampoline_cps_call2
		     (K[2],
		      version,
		      function(key_schema){
		       return caml_exact_trampoline_cps_call
		               (of_schema$1,
		                key_schema,
		                function(pp_key){
		                 function res(data_schema, cont){
		                  var a = data_schema[1];
		                  function b(ppf, param, cont){
		                   if(! param)
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_none, ppf, dummy, cont);
		                   var v = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            ppf,
		                            v,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_char, ppf, 45, cont);
		                            });
		                  }
		                  var c = key_schema[1];
		                  function d(ppf, param, cont){
		                   if(! param)
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_none, ppf, dummy, cont);
		                   var v = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            ppf,
		                            v,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_char, ppf, 45, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$26,
		                           function(e){
		                            return caml_trampoline_cps_call5
		                                    (e,
		                                     d,
		                                     c,
		                                     b,
		                                     a,
		                                     function(id){
		                                      var
		                                       descriptor =
		 tuple
		  (function(a, cont){return cont(a);},
		   function(a, cont){return cont(a);},
		   [0, key_schema, [0, data_schema, 0]]);
		                                      function construct(items, cont){
		                                       return caml_trampoline_cps_call3
		       (map$11,
		        items,
		        function(param, cont){
		         var value = param[2][1], name = param[1];
		         return cont([0, name, value]);
		        },
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (of_sequence$3,
		                  [0, K[1]],
		                  a,
		                  function(param){
		                   var variant = param[1];
		                   if(17724 <= variant){
		                    var map = param[2];
		                    return caml_trampoline_cps_call2(of_string$14, map, cont);
		                   }
		                   var k = param[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            fail,
		                            format$10,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, pp_key, k, cont);
		                            });
		                  });
		        });
		                                      }
		                                      function deconstruct(map, cont){
		                                       return caml_exact_trampoline_cps_call$2
		       (to_sequence$2,
		        0,
		        0,
		        0,
		        map,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (map$11,
		                  a,
		                  function(param, cont){
		                   var d = param[2], k = param[1];
		                   return cont([0, k, [0, d, 0]]);
		                  },
		                  cont);
		        });
		                                      }
		                                      var id$0 = [0, id];
		                                      return cont
		      ([0,
		        id$0,
		        0,
		        [8,
		         construct,
		         deconstruct,
		         [0, 0, 0, descriptor, 0],
		         length$9],
		        0]);
		                                     });
		                           });
		                 }
		                 return cont(res);
		                });
		      });
		                                    }
		                                    function descriptor_is_string(param, cont){
		                                     function a(b){
		                                      if(typeof b === "number"){
		                                       if(8 === b) return cont(mv);
		                                      }
		                                      else if(2 === b[0]){
		                                       var t = b[1], b = caml_obj_tag(t);
		                                       if(250 === b) return caml_exact_trampoline_call1(a, t[1]);
		                                       if(246 !== b && 244 !== b)
		return caml_exact_trampoline_call1(a, t);
		                                       return caml_exact_trampoline_cps_call
		       (force_lazy_block, t, a);
		                                      }
		                                      return cont(0);
		                                     }
		                                     return a(param);
		                                    }
		                                    function schema_versioned(version, cont){
		                                     return caml_trampoline_cps_call2
		     (K[2],
		      version,
		      function(key_schema){
		       function dictionary_id(data_schema, cont){
		        var a = data_schema[1];
		        function b(ppf, param, cont){
		         if(! param)
		          return caml_exact_trampoline_cps_call$1
		                  (pp_none, ppf, dummy, cont);
		         var v = param[1];
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string,
		                  ppf,
		                  v,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_char, ppf, 45, cont);
		                  });
		        }
		        return caml_exact_trampoline_cps_call$1
		                (kasprintf,
		                 id,
		                 fmt$27,
		                 function(c){
		                  return caml_trampoline_cps_call3(c, b, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (descriptor_is_string,
		                key_schema[3],
		                function(match){
		                 function a(res){return cont(res);}
		                 return match
		                         ? a
		                           (function(data_schema, cont){
		                             function deconstruct(eta, cont){
		                              return caml_exact_trampoline_cps_call$2
		                                      (to_sequence$2, 0, 0, 0, eta, cont);
		                             }
		                             var
		                              descriptor =
		                                [5, of_sequence, deconstruct, data_schema, length$9];
		                             return caml_exact_trampoline_cps_call
		                                     (dictionary_id,
		                                      data_schema,
		                                      function(a){
		                                       var id = [0, a];
		                                       return cont([0, id, 0, descriptor, 0]);
		                                      });
		                            })
		                         : caml_exact_trampoline_cps_call
		                           (flatten$0,
		                            key_schema[3],
		                            function(match){
		                             var
		                              encode = match[3],
		                              decode = match[2],
		                              descriptor = match[1];
		                             if(typeof descriptor === "number" && 8 === descriptor)
		                              return a
		                                      (function(data_schema, cont){
		function deconstruct(map, cont){
		 return caml_exact_trampoline_cps_call$2
		         (to_sequence$2,
		          0,
		          0,
		          0,
		          map,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (map$11,
		                    a,
		                    function(param, cont){
		                     var data = param[2], key = param[1];
		                     return caml_exact_trampoline_cps_call
		                             (encode, key, function(a){return cont([0, a, data]);});
		                    },
		                    cont);
		          });
		}
		function construct(sequence, cont){
		 function arg(map, param, cont){
		  var
		   data = param[2],
		   key = param[1],
		   open =
		     o
		      ([0,
		        symbol_bind$4,
		        symbol_map$4,
		        Let_syntax$2,
		        ,
		        bind$6,
		        of_string$14,
		        map$15]),
		   let$ = open[3];
		  function a(key, cont){
		   caml_push_trap
		    (function(exn){
		      if(exn[1] === Failure){
		       var reason = exn[2];
		       return cont([1, reason]);
		      }
		      var
		       raise = caml_pop_trap(),
		       exn$0 = caml_maybe_attach_backtrace(exn, 0);
		      return raise(exn$0);
		     });
		   return caml_exact_trampoline_cps_call$0
		           (update$0,
		            map,
		            key,
		            function(param, cont){
		             return param
		                     ? caml_exact_trampoline_cps_call$1
		                       (kasprintf,
		                        failwith,
		                        fmt$28,
		                        function(a){
		                         return caml_trampoline_cps_call3(a, pp_key, key, cont);
		                        })
		                     : cont(data);
		            },
		            function(a){
		             return caml_trampoline_cps_call2
		                     (of_string$14,
		                      a,
		                      function(a){caml_pop_trap(); return cont(a);});
		            });
		  }
		  return caml_exact_trampoline_cps_call
		          (decode,
		           key,
		           function(b){
		            return caml_trampoline_cps_call3(let$, b, a, cont);
		           });
		 }
		 return caml_exact_trampoline_cps_call$3
		         (fold_m,
		          bind$6,
		          of_string$14,
		          sequence,
		          empty$11([0, K[1]]),
		          arg,
		          cont);
		}
		var
		 descriptor =
		   [5, construct, deconstruct, data_schema, length$9];
		return caml_exact_trampoline_cps_call
		        (dictionary_id,
		         data_schema,
		         function(a){
		          var id = [0, a];
		          return cont([0, id, 0, descriptor, 0]);
		         });
		                                       });
		                             return a
		                                     (function(schema, cont){
		                                       return caml_exact_trampoline_cps_call
		       (assoc_schema_versioned,
		        version,
		        function(a){
		         return caml_exact_trampoline_cps_call(a, schema, cont);
		        });
		                                      });
		                            });
		                });
		      });
		                                    }
		                                    function schema(data_schema, cont){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned,
		      function(param, cont){return cont(0);},
		      function(a){
		       return caml_exact_trampoline_cps_call(a, data_schema, cont);
		      });
		                                    }
		                                    var empty = empty$11([0, K[1]]);
		                                    function singleton(k, v, cont){
		                                     return cont(singleton$3([0, K[1]], k)(v));
		                                    }
		                                    function of_alist(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_alist$1, [0, K[1]], l, cont);
		                                    }
		                                    function of_alist_exn(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_alist_exn$1, [0, K[1]], l, cont);
		                                    }
		                                    function of_alist_multi(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_alist_multi$1, [0, K[1]], l, cont);
		                                    }
		                                    function of_alist_or_error(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_alist_or_error$0, K[1], l, cont);
		                                    }
		                                    function of_alist_fold(l, init, f, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (of_alist_fold$0, K[1], l, init, f, cont);
		                                    }
		                                    function of_alist_reduce(l, f, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (of_alist_reduce$1, [0, K[1]], l, f, cont);
		                                    }
		                                    function of_iteri(iteri, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_iteri$0, K[1], iteri, cont);
		                                    }
		                                    function of_sorted_array(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_sorted_array$0, K[1], l, cont);
		                                    }
		                                    function of_sorted_array_unchecked(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_sorted_array_unchecked$0, K[1], l, cont);
		                                    }
		                                    function of_increasing_iterator_uncheck(len, f, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (of_increasing_iterator_uncheck$0, K[1], len, f, cont);
		                                    }
		                                    function of_sequence_or_error(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_sequence_or_error$0, K[1], l, cont);
		                                    }
		                                    function of_sequence_exn(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_sequence_exn$1, [0, K[1]], l, cont);
		                                    }
		                                    function of_sequence_multi(l, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_sequence_multi$1, [0, K[1]], l, cont);
		                                    }
		                                    function of_sequence_fold(l, init, f, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (of_sequence_fold$0, K[1], l, init, f, cont);
		                                    }
		                                    function of_sequence_reduce(l, f, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (of_sequence_reduce$1, [0, K[1]], l, f, cont);
		                                    }
		                                    return cont
		    ([0,
		      ,
		      ,
		      invariants$0,
		      get_comparator,
		      comparator$5,
		      of_iteri_exn$1,
		      of_increasing_sequence$1,
		      of_sequence$3,
		      of_list_with_key$1,
		      of_list_with_key_or_error$1,
		      of_list_with_key_exn$1,
		      of_list_with_key_multi$1,
		      of_list_with_key_fold$1,
		      of_list_with_key_reduce$1,
		      is_empty$5,
		      length$9,
		      set$3,
		      add$5,
		      add_exn$0,
		      add_multi$0,
		      remove_multi$0,
		      find_multi$0,
		      change$0,
		      update$0,
		      find_packed_by_id,
		      find_packed_by_id_exn,
		      remove$2,
		      mem$5,
		      iter_keys$0,
		      iter$5,
		      iteri$1,
		      iteri_until,
		      iter2$0,
		      map$13,
		      mapi$3,
		      map_keys$1,
		      map_keys_exn$1,
		      fold$5,
		      fold_until$1,
		      fold_right$3,
		      fold2$1,
		      filter_keys$0,
		      filter$5,
		      filteri$0,
		      filter_map$3,
		      filter_mapi$1,
		      partition_mapi$0,
		      partition_map$1,
		      partitioni_tf$0,
		      partition_tf$2,
		      combine_errors$0,
		      unzip$1,
		      compare_direct,
		      hash_fold_direct,
		      equal$11,
		      keys$0,
		      encode,
		      to_alist$0,
		      merge$1,
		      merge_disjoint_exn$0,
		      merge_skewed$0,
		      ,
		      symmetric_diff$2,
		      fold_symmetric_diff$1,
		      min_elt$3,
		      min_elt_exn$1,
		      max_elt$3,
		      max_elt_exn$0,
		      transpose_keys$1,
		      for_all$0,
		      for_alli$0,
		      exists$0,
		      existsi$0,
		      count$0,
		      counti$0,
		      sum$1,
		      sumi$0,
		      split$3,
		      split_le_gt,
		      split_lt_ge,
		      append$3,
		      subrange,
		      fold_range_inclusive$0,
		      range_to_alist$0,
		      closest_key$0,
		      nth$2,
		      nth_exn,
		      rank$0,
		      to_sequence$2,
		      binary_search$2,
		      binary_search_segmented$0,
		      binary_search_subrange,
		      ,
		      ,
		      sexp_of_m_t$0,
		      m_t_of_sexp,
		      m_t_sexp_grammar,
		      compare_m_t,
		      equal_m_t,
		      hash_fold_m_t,
		      ,
		      ,
		      of_tree$1,
		      to_tree,
		      pp_key,
		      of_sequence,
		      assoc_schema_versioned,
		      descriptor_is_string,
		      schema_versioned,
		      schema,
		      empty,
		      singleton,
		      of_alist,
		      of_alist_exn,
		      of_alist_multi,
		      of_alist_or_error,
		      of_alist_fold,
		      of_alist_reduce,
		      of_iteri,
		      of_sorted_array,
		      of_sorted_array_unchecked,
		      of_increasing_iterator_uncheck,
		      of_sequence_or_error,
		      of_sequence_exn,
		      of_sequence_multi,
		      of_sequence_fold,
		      of_sequence_reduce]);
		                                   });
		                         });
		               }
		               function M_printable(K, cont){
		                return caml_exact_trampoline_cps_call
		                        (M$2,
		                         [0, K[2], K[3]],
		                         function(include){
		                          var
		                           of_list_with_key_reduce = include[14],
		                           find = include[25],
		                           filter_map = include[45],
		                           compare_direct = include[53],
		                           equal = include[55],
		                           to_alist = include[58],
		                           merge_disjoint_exn = include[60],
		                           to_sequence = include[89],
		                           schema_versioned = include[109],
		                           schema = include[110],
		                           empty = include[111],
		                           singleton = include[112],
		                           of_alist_exn = include[114],
		                           of_sequence_reduce = include[127];
		                          function pp(pp_data, cont){
		                           return cont(pp$15(K[1], pp_data));
		                          }
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    of_list_with_key_reduce,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    find,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    filter_map,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    compare_direct,
		                                    ,
		                                    equal,
		                                    ,
		                                    ,
		                                    to_alist,
		                                    ,
		                                    merge_disjoint_exn,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    to_sequence,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    schema_versioned,
		                                    schema,
		                                    empty,
		                                    singleton,
		                                    ,
		                                    of_alist_exn,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    of_sequence_reduce,
		                                    pp]);
		                         });
		               }
		               function attach(t, data, cont){
		                var
		                 witness_to_int = t[6],
		                 make_witness = t[2],
		                 callbacks = t[1];
		                return caml_trampoline_cps_call2
		                        (make_witness,
		                         0,
		                         function(sub){
		                          var a = t[6], b = t[5], c = t[4], d = t[3], e = t[2];
		                          return caml_trampoline_cps_call2
		                                  (witness_to_int,
		                                   sub,
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call$0
		    (set$3,
		     callbacks,
		     f,
		     data,
		     function(f){return cont([0, [0, f, e, d, c, b, a], sub]);});
		                                   });
		                         });
		               }
		               function detach(t, sub, cont){
		                var
		                 witness_to_int = t[6],
		                 callbacks = t[1],
		                 a = t[6],
		                 b = t[5],
		                 c = t[4],
		                 d = t[3],
		                 e = t[2];
		                return caml_trampoline_cps_call2
		                        (witness_to_int,
		                         sub,
		                         function(f){
		                          return caml_exact_trampoline_cps_call$1
		                                  (remove$2,
		                                   callbacks,
		                                   f,
		                                   function(f){return cont([0, f, e, d, c, b, a]);});
		                         });
		               }
		               function trigger$0(param, v, init, cont){
		                var
		                 reduce = param[5],
		                 monad_return = param[4],
		                 monad_bind = param[3],
		                 callbacks = param[1];
		                function a(param, data, acc, cont){
		                 return caml_trampoline_cps_call2
		                         (reduce,
		                          acc,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (data,
		                                    v,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(monad_bind, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (monad_return,
		                         init,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fold$5, callbacks, b, a, cont);
		                         });
		               }
		               function elements_of_list(param, cont){
		                var tl = param[2], hd = param[1];
		                return cont([0, hd, tl]);
		               }
		               function of_list$4(param){
		                if(! param) return 0;
		                var tl = param[2], h = param[1];
		                return [0, [0, h, tl]];
		               }
		               function of_list_exn(l, cont){
		                var match = of_list$4(l);
		                if(! match)
		                 return caml_exact_trampoline_cps_call
		                         (failwith, "converted empty list to List_nonempty.t", cont);
		                var l$0 = match[1];
		                return cont(l$0);
		               }
		               function cons$3(e, param){
		                var tl = param[2], hd = param[1];
		                return [0, e, [0, hd, tl]];
		               }
		               function length$11(param, cont){
		                var tl = param[2];
		                return caml_exact_trampoline_cps_call
		                        (length$1, tl, function(a){return cont(a + 1 | 0);});
		               }
		               function map$19(param, f, cont){
		                var tl = param[2], hd = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         tl,
		                         f,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (f, hd, function(b){return cont([0, b, a]);});
		                         });
		               }
		               var bPX = "List_nonempty lifted into []";
		               function rev_map$0(l, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (elements_of_list,
		                         l,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (rev_map,
		                                   a,
		                                   f,
		                                   function(a){
		                                    a = of_list$4(a);
		                                    if(! a)
		                                     return caml_exact_trampoline_cps_call(failwith, bPX, cont);
		                                    var l = a[1];
		                                    return cont(l);
		                                   });
		                         });
		               }
		               function mapi$4(param, f, cont){
		                var tl = param[2], hd = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (mapi$0,
		                         [0, hd, tl],
		                         f,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_list_exn, a, cont);
		                         });
		               }
		               function rev$1(a, cont){
		                var tl = a[2], hd = a[1], hd$0 = hd, acc = 0, a = tl;
		                for(;;){
		                 if(! a) return cont([0, hd$0, acc]);
		                 var tl$0 = a[2], lhd = a[1], acc$0 = [0, hd$0, acc];
		                 hd$0 = lhd;
		                 acc = acc$0;
		                 a = tl$0;
		                }
		               }
		               function filter$6(param){
		                var tl = param[2], hd = param[1], a = [0, hd, tl];
		                return function(b, cont){
		                 return caml_exact_trampoline_cps_call$1(filter, a, b, cont);};
		               }
		               function fold$9(param){
		                var tl = param[2], hd = param[1], a = [0, hd, tl];
		                return function(b, c, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (fold_left$1, a, b, c, cont);};
		               }
		               function schema_versioned$8(param, s, cont){return cont(s);}
		               function default$5(v){return v;}
		               function some_if_optional(param){return 0;}
		               function some_if_required(v){return v;}
		               function pp$16(pp, cont){return cont(pp);}
		               function equal$24(equal, cont){return cont(equal);}
		               function compare$42(compare, cont){return cont(compare);}
		               function schema_versioned$9(a, r, param){return r;}
		               function equal$25(r_eq, param, cont){return cont(r_eq);}
		               function pp$17(pp_r, param, cont){return cont(pp_r);}
		               function switch$(r, param){return r;}
		               function default$6(param){return 0;}
		               function some_if_optional$0(v){return [0, v];}
		               function some_if_required$0(param){return 0;}
		               function pp$18(pp_v1, cont){
		                function pp_none(ppf, param, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, ppf, cst_None, cont);
		                }
		                return cont
		                        (function(ppf, param, cont){
		                          if(! param)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_none, ppf, dummy, cont);
		                          var v = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   ppf,
		                                   "Some ",
		                                   function(a){
		                                    return caml_trampoline_cps_call3(pp_v1, ppf, v, cont);
		                                   });
		                         });
		               }
		               function equal$26(equal, cont){
		                return cont
		                        (function(a, b, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (equal_option, equal, a, b, cont);
		                         });
		               }
		               function compare$43(compare, cont){
		                return cont
		                        (function(a, b, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (compare_option, compare, a, b, cont);
		                         });
		               }
		               function schema_versioned$10(a, param, w){return w;}
		               function equal$27(param, w_eq, cont){return cont(w_eq);}
		               function pp$19(param, pp_w, cont){return cont(pp_w);}
		               function switch$0(param, w){return w;}
		               function pp$20(pp, cont){
		                var
		                 a = [0, 2],
		                 b =
		                   seq
		                    ([0, comma],
		                     function(b, c, cont){
		                      return caml_exact_trampoline_cps_call$2
		                              (box$0, a, pp, b, c, cont);
		                     });
		                return cont
		                        (function(state, map, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (to_sequence$0,
		                                   0,
		                                   0,
		                                   0,
		                                   map,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (to_seq$0,
		     a,
		     function(v){
		      return caml_exact_trampoline_cps_call$1
		              (pp_open_box,
		               state,
		               0,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         state,
		                         cst$12,
		                         function(a){
		                          return function(indent){
		                                   return caml_exact_trampoline_cps_call$0
		   (pp_open_box_gen,
		    state,
		    indent,
		    2,
		    function(a){
		     return caml_exact_trampoline_cps_call$2
		             (append$4,
		              pp_v0,
		              b,
		              state,
		              v,
		              function(a){
		               pp_close_box(state);
		               return caml_exact_trampoline_cps_call$1
		                       (pp_v0,
		                        state,
		                        v,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (pp_print_string,
		                                  state,
		                                  cst$11,
		                                  function(a){return cont(pp_close_box(state));});
		                        });
		              });
		    });
		                                  }
		                                  (1);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function M$3(Elt, cont){
		                function schema_versioned(version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Elt[2],
		                          version,
		                          function(elt_schema){
		                           var a = elt_schema[1];
		                           function b(ppf, param, cont){
		                            if(! param)
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_none, ppf, dummy, cont);
		                            var v = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string,
		                                     ppf,
		                                     v,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_char, ppf, 45, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$29,
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (c,
		      b,
		      a,
		      function(id){
		       var descriptor = [3, elt_schema];
		       function decode(l, cont){
		        return caml_exact_trampoline_cps_call$1
		                (of_list$2,
		                 [0, Elt[1]],
		                 l,
		                 function(a){
		                  return caml_trampoline_cps_call2(of_string$14, a, cont);
		                 });
		       }
		       function encode(set, cont){
		        return caml_exact_trampoline_cps_call(to_list$3, set, cont);
		       }
		       var id$0 = [0, id];
		       return cont
		               ([0, id$0, 0, [4, decode, encode, descriptor], 0]);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var empty = empty$8([0, Elt[1]]);
		                          function singleton(v){return singleton$1([0, Elt[1]], v);}
		                          function of_list(l, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_list$2, [0, Elt[1]], l, cont);
		                          }
		                          function of_sequence(s, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_sequence$0, Elt[1], s, cont);
		                          }
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    length$7,
		                                    ,
		                                    mem$3,
		                                    ,
		                                    remove$0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    equal$9,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    to_list$3,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    fold$3,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    to_sequence$0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    schema_versioned,
		                                    schema,
		                                    pp$20,
		                                    empty,
		                                    singleton,
		                                    ,
		                                    of_list,
		                                    ,
		                                    of_sequence]);
		                         });
		               }
		               function M_printable$0(Element, cont){
		                return caml_exact_trampoline_cps_call
		                        (M$3,
		                         [0, Element[2], Element[3]],
		                         function(include){
		                          var
		                           length = include[5],
		                           remove = include[9],
		                           equal = include[16],
		                           schema_versioned = include[70],
		                           empty = include[73],
		                           singleton = include[74],
		                           of_list = include[76],
		                           of_sequence = include[78],
		                           a = include[72];
		                          function pp(set, cont){
		                           return caml_trampoline_cps_call3(a, Element[1], set, cont);
		                          }
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    length,
		                                    ,
		                                    ,
		                                    ,
		                                    remove,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    equal,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    schema_versioned,
		                                    ,
		                                    empty,
		                                    singleton,
		                                    ,
		                                    of_list,
		                                    ,
		                                    of_sequence,
		                                    ,
		                                    ,
		                                    ,
		                                    pp]);
		                         });
		               }
		               function Make2$0(M){
		                function unfold(init, f){return [0, init, f];}
		                function unfold_step(init, f){
		                 function f$0(s, cont){
		                  function a(a, cont){
		                   if(! a) return cont(0);
		                   a = a[1];
		                   var state = a[2], s = a[1];
		                   return cont([1, s, state]);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (f,
		                           s,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(M[2], b, a, cont);
		                           });
		                 }
		                 return [0, init, f$0];
		                }
		                function of_base(init){
		                 function f(s$0, cont){
		                  var f = s$0[2], s = s$0[1];
		                  return caml_trampoline_cps_call2
		                          (f,
		                           s,
		                           function(b){
		                            if(typeof b === "number")
		                             b = 0;
		                            else if(0 === b[0])
		                             var s = b[1], b = [0, [0, s, f]];
		                            else
		                             var s$0 = b[2], a = b[1], b = [1, a, [0, s$0, f]];
		                            if(typeof b === "number")
		                             b = 0;
		                            else if(0 === b[0])
		                             var state = b[1], b = [0, state];
		                            else
		                             var state$0 = b[2], value = b[1], b = [1, value, state$0];
		                            return caml_trampoline_cps_call2(M[6], b, cont);
		                           });
		                 }
		                 return [0, init, f];
		                }
		                function of_list(init){
		                 function f(l, cont){
		                  return l
		                          ? caml_trampoline_cps_call2(M[6], [2, l, 0], cont)
		                          : caml_trampoline_cps_call2(M[6], 0, cont);
		                 }
		                 return [0, init, f];
		                }
		                function concat(seq){
		                 function f(a, cont){
		                  var b = a[1];
		                  if(b){
		                   var
		                    next = a[2],
		                    tail = b[2],
		                    a = b[1],
		                    f = a[2],
		                    state = a[1],
		                    c =
		                      function(param, cont){
		                       if(typeof param === "number")
		                        return caml_trampoline_cps_call2
		                                (M[6], [0, [0, tail, next]], cont);
		                       switch(param[0]){
		                         case 0:
		                          var state = param[1];
		                          return caml_trampoline_cps_call2
		                                  (M[6], [0, [0, [0, [0, state, f], tail], next]], cont);
		                         case 1:
		                          var state$0 = param[2], elt = param[1];
		                          return caml_trampoline_cps_call2
		                                  (M[6],
		                                   [1, elt, [0, [0, [0, state$0, f], tail], next]],
		                                   cont);
		                         default:
		                          var state$1 = param[2], elts = param[1];
		                          return caml_trampoline_cps_call2
		                                  (M[6],
		                                   [2, elts, [0, [0, [0, state$1, f], tail], next]],
		                                   cont);
		                       }
		                      };
		                   return caml_trampoline_cps_call2
		                           (f,
		                            state,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1(M[1], a, c, cont);
		                            });
		                  }
		                  a = a[2];
		                  var f$0 = a[2], state$0 = a[1];
		                  function d(param, cont){
		                   if(typeof param === "number")
		                    return caml_trampoline_cps_call2(M[6], 0, cont);
		                   switch(param[0]){
		                     case 0:
		                      var state = param[1];
		                      return caml_trampoline_cps_call2
		                              (M[6], [0, [0, 0, [0, state, f$0]]], cont);
		                     case 1:
		                      var state$0 = param[2], sub = param[1];
		                      return caml_trampoline_cps_call2
		                              (M[6], [0, [0, [0, sub, 0], [0, state$0, f$0]]], cont);
		                     default:
		                      var state$1 = param[2], subs = param[1];
		                      return caml_trampoline_cps_call2
		                              (M[6], [0, [0, subs, [0, state$1, f$0]]], cont);
		                   }
		                  }
		                  return caml_trampoline_cps_call2
		                          (f$0,
		                           state$0,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1(M[1], a, d, cont);
		                           });
		                 }
		                 var init = [0, 0, seq];
		                 return [0, init, f];
		                }
		                function step(seq, cont){
		                 var f = seq[2], state = seq[1];
		                 function a(param, cont){
		                  if(typeof param === "number")
		                   return caml_trampoline_cps_call2(M[6], [0, 0, seq], cont);
		                  switch(param[0]){
		                    case 0:
		                     var state = param[1]; break;
		                    case 1:
		                     var state$0 = param[2], value = param[1];
		                     return caml_trampoline_cps_call2
		                             (M[6], [0, [0, value, 0], [0, state$0, f]], cont);
		                    default:
		                     var values = param[1];
		                     if(values){
		                      var state$1 = param[2];
		                      return caml_trampoline_cps_call2
		                              (M[6], [0, values, [0, state$1, f]], cont);
		                     }
		                     state = param[2];
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (step, [0, state, f], cont);
		                 }
		                 return caml_trampoline_cps_call2
		                         (f,
		                          state,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(M[1], b, a, cont);
		                          });
		                }
		                function fold_until(param, init, f, finish, cont){
		                 var step = param[2], state = param[1];
		                 function a(param, cont){
		                  if(typeof param === "number")
		                   return caml_exact_trampoline_cps_call
		                           (finish,
		                            init,
		                            function(a){
		                             return caml_trampoline_cps_call2(M[6], a, cont);
		                            });
		                  switch(param[0]){
		                    case 0:
		                     var state = param[1];
		                     return caml_exact_trampoline_cps_call$2
		                             (fold_until, [0, state, step], init, f, finish, cont);
		                    case 1:
		                     var state$0 = param[2], v = param[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (f,
		                              init,
		                              v,
		                              function(match){
		                               if(0 === match[0]){
		                                var init = match[1];
		                                return caml_exact_trampoline_cps_call$2
		(fold_until, [0, state$0, step], init, f, finish, cont);
		                               }
		                               var v = match[1];
		                               return caml_trampoline_cps_call2(M[6], v, cont);
		                              });
		                    default:
		                     var
		                      state$1 = param[2],
		                      v$0 = param[1],
		                      b =
		                        function(param, cont){
		                         if(0 === param[0]){
		                          var init = param[1];
		                          return caml_exact_trampoline_cps_call$2
		                                  (fold_until, [0, state$1, step], init, f, finish, cont);
		                         }
		                         var v = param[1];
		                         return caml_trampoline_cps_call2(M[6], v, cont);
		                        },
		                      a =
		                        function(init, param){
		                         function c(a){
		                          return caml_exact_trampoline_cps_call$1(M[1], a, b, cont);
		                         }
		                         if(! param)
		                          return caml_trampoline_cps_call2(M[6], [0, init], c);
		                         var tl = param[2], hd = param[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (f,
		                                  init,
		                                  hd,
		                                  function(match){
		                                   if(0 === match[0]){
		                                    var init = match[1];
		                                    return caml_exact_trampoline_call2(a, init, tl);
		                                   }
		                                   var v = match[1];
		                                   return caml_trampoline_cps_call2(M[6], [1, v], c);
		                                  });
		                        };
		                     return a(init, v$0);
		                  }
		                 }
		                 return caml_trampoline_cps_call2
		                         (step,
		                          state,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(M[1], b, a, cont);
		                          });
		                }
		                function folding_filter_map(param, init, f){
		                 var step = param[2], state = param[1];
		                 function f$0(param, cont){
		                  var state = param[2], acc = param[1];
		                  function a(param, cont){
		                   if(typeof param === "number")
		                    return caml_trampoline_cps_call2(M[6], 0, cont);
		                   switch(param[0]){
		                     case 0:
		                      var state = param[1];
		                      return caml_trampoline_cps_call2
		                              (M[6], [0, [0, acc, state]], cont);
		                     case 1:
		                      var state$0 = param[2], v = param[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (f,
		                               acc,
		                               v,
		                               function(a){
		                                var match = a[2], acc = a[1];
		                                if(! match)
		                                 return caml_trampoline_cps_call2
		 (M[6], [0, [0, acc, state$0]], cont);
		                                var v = match[1];
		                                return caml_trampoline_cps_call2
		(M[6], [1, v, [0, acc, state$0]], cont);
		                               });
		                     default:
		                      var
		                       state$1 = param[2],
		                       v$0 = param[1],
		                       a =
		                         function(acc, l, param){
		                          if(param){
		                           var tl = param[2], hd = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    acc,
		                                    hd,
		                                    function(b){
		                                     var match = b[2], acc = b[1];
		                                     if(! match)
		                                      return caml_exact_trampoline_call3(a, acc, l, tl);
		                                     var v = match[1], l$0 = [0, v, l];
		                                     return caml_exact_trampoline_call3(a, acc, l$0, tl);
		                                    });
		                          }
		                          if(! l)
		                           return caml_trampoline_cps_call2
		                                   (M[6], [0, [0, acc, state$1]], cont);
		                          var b = [0, acc, state$1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_rev_keys,
		                                   l,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(M[6], [2, a, b], cont);
		                                   });
		                         };
		                      return a(acc, 0, v$0);
		                   }
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (step,
		                           state,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(M[1], b, a, cont);
		                           });
		                 }
		                 return [0, [0, init, state], f$0];
		                }
		                function filter_map(seq, f){
		                 function f$0(param, v, cont){
		                  return caml_exact_trampoline_cps_call
		                          (f, v, function(a){return cont([0, 0, a]);});
		                 }
		                 return folding_filter_map(seq, 0, f$0);
		                }
		                function filter(s, f){
		                 return filter_map
		                         (s,
		                          function(e, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (f, e, function(a){return cont(some_if(a, e));});
		                          });
		                }
		                function find_map(seq, f, cont){
		                 function f$0(param, v, cont){
		                  return caml_exact_trampoline_cps_call
		                          (f,
		                           v,
		                           function(match){
		                            if(! match) return cont(mB);
		                            var v = match[1];
		                            return cont([1, [0, v]]);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$2
		                         (fold_until,
		                          seq,
		                          0,
		                          f$0,
		                          function(param, cont){return cont(0);},
		                          cont);
		                }
		                function find(seq, f, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_map,
		                          seq,
		                          function(v, cont){
		                           return caml_trampoline_cps_call2
		                                   (f, v, function(a){return cont(some_if(a, v));});
		                          },
		                          cont);
		                }
		                function folding_filter_map$0(param, init, f){
		                 var step = param[2], state = param[1];
		                 function f$0(param, cont){
		                  var state = param[2], acc = param[1];
		                  function a(param, cont){
		                   if(typeof param === "number")
		                    return caml_trampoline_cps_call2(M[6], 0, cont);
		                   switch(param[0]){
		                     case 0:
		                      var state = param[1];
		                      return caml_trampoline_cps_call2
		                              (M[6], [0, [0, acc, state]], cont);
		                     case 1:
		                      var
		                       state$0 = param[2],
		                       v = param[1],
		                       a =
		                         function(param, cont){
		                          var match = param[2], acc = param[1];
		                          if(! match)
		                           return caml_trampoline_cps_call2
		                                   (M[6], [0, [0, acc, state$0]], cont);
		                          var v = match[1];
		                          return caml_trampoline_cps_call2
		                                  (M[6], [1, v, [0, acc, state$0]], cont);
		                         };
		                      return caml_exact_trampoline_cps_call$1
		                              (f,
		                               acc,
		                               v,
		                               function(b){
		                                return caml_exact_trampoline_cps_call$1(M[1], b, a, cont);
		                               });
		                     default:
		                      var
		                       state$1 = param[2],
		                       v$0 = param[1],
		                       filter =
		                         function(acc, l, param, cont){
		                          if(param){
		                           var
		                            tl = param[2],
		                            hd = param[1],
		                            a =
		                              function(param, cont){
		                               var match = param[2], acc = param[1];
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(filter, acc, l, tl, cont);
		                               var v = match[1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (filter, acc, [0, v, l], tl, cont);
		                              };
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    acc,
		                                    hd,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(M[1], b, a, cont);
		                                    });
		                          }
		                          if(! l)
		                           return caml_trampoline_cps_call2
		                                   (M[6], [0, [0, acc, state$1]], cont);
		                          var b = [0, acc, state$1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_rev_keys,
		                                   l,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(M[6], [2, a, b], cont);
		                                   });
		                         };
		                      return caml_exact_trampoline_cps_call$0
		                              (filter, acc, 0, v$0, cont);
		                   }
		                  }
		                  return caml_trampoline_cps_call2
		                          (step,
		                           state,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(M[1], b, a, cont);
		                           });
		                 }
		                 return [0, [0, init, state], f$0];
		                }
		                function filter_map$0(seq, f){
		                 function f$0(param, v, cont){
		                  function a(v, cont){return cont([0, 0, v]);}
		                  return caml_exact_trampoline_cps_call
		                          (f,
		                           v,
		                           function(b){
		                            return caml_trampoline_cps_call3(M[7], b, a, cont);
		                           });
		                 }
		                 return folding_filter_map$0(seq, 0, f$0);
		                }
		                function map(s, f){
		                 return filter_map$0
		                         (s,
		                          function(v, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    v,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (M[2], a, return$4, cont);
		                                    });
		                          });
		                }
		                function take(seq, n){
		                 function f(param, cont){
		                  var seq = param[2], n = param[1];
		                  if(0 >= n) return caml_trampoline_cps_call2(M[6], 0, cont);
		                  function a(param, cont){
		                   var l = param[1];
		                   if(! l) return cont(0);
		                   var seq = param[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (take$0,
		                            l,
		                            n,
		                            function(l){
		                             return caml_exact_trampoline_cps_call
		                                     (length$1,
		                                      l,
		                                      function(a){return cont([2, l, [0, n - a | 0, seq]]);});
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (step,
		                           seq,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(M[2], b, a, cont);
		                           });
		                 }
		                 var init = [0, n, seq];
		                 return [0, init, f];
		                }
		                function to_list_rev(seq, cont){
		                 function to_list_rev(acc, seq, cont){
		                  function a(param, cont){
		                   var l = param[1];
		                   if(! l) return caml_trampoline_cps_call2(M[6], acc, cont);
		                   var seq = param[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (to_list_rev, rev_append(l, acc), seq, cont);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (step,
		                           seq,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(M[1], b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (to_list_rev, 0, seq, cont);
		                }
		                function to_list(seq, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_list_rev,
		                          seq,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (M[2], a, of_rev_keys, cont);
		                          });
		                }
		                return [0,
		                        ,
		                        ,
		                        unfold,
		                        unfold_step,
		                        of_base,
		                        of_list,
		                        ,
		                        concat,
		                        ,
		                        ,
		                        ,
		                        fold_until,
		                        ,
		                        ,
		                        ,
		                        filter,
		                        ,
		                        ,
		                        ,
		                        ,
		                        find,
		                        ,
		                        ,
		                        [0, , , , , , , map],
		                        take,
		                        ,
		                        to_list];
		               }
		               function Make_multi_index(Types){
		                var Indexes = Types[2];
		                function add(value, param, cont){
		                 var indexes = param[2], elements = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (Types[2][1],
		                          value,
		                          indexes,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (add$4,
		                                    elements,
		                                    value,
		                                    function(b){return cont([0, b, a]);});
		                          });
		                }
		                function all(param, cont){
		                 var elements = param[1];
		                 return caml_exact_trampoline_cps_call$2
		                         (to_sequence$0, 0, 0, 0, elements, cont);
		                }
		                function update(old, value, param, cont){
		                 var indexes = param[2], elements = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (remove$0,
		                          elements,
		                          old,
		                          function(elements){
		                           return caml_exact_trampoline_cps_call$1
		                                   (add$4,
		                                    elements,
		                                    value,
		                                    function(elements){
		                                     return caml_exact_trampoline_cps_call$0
		     (Types[2][2],
		      old,
		      value,
		      indexes,
		      function(indexes){return cont([0, elements, indexes]);});
		                                    });
		                          });
		                }
		                var a = Types[2][3], empty = [0, empty$8(Types[1]), a];
		                function length(param){
		                 var elements = param[1];
		                 return length$7(elements);
		                }
		                function remove(value, t, cont){
		                 var indexes = t[2], elements = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (mem$3,
		                          elements,
		                          value,
		                          function(a){
		                           return a
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (Types[2][4],
		                                      value,
		                                      indexes,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (remove$0,
		        elements,
		        value,
		        function(b){return cont([0, b, a]);});
		                                      })
		                                   : cont(t);
		                          });
		                }
		                return [0,
		                        ,
		                        Indexes,
		                        add,
		                        all,
		                        ,
		                        update,
		                        empty,
		                        length,
		                        remove];
		               }
		               function schema_versioned$11(a, l, param){return l;}
		               function make$10(l, param, cont){return cont(l);}
		               function Make$8(S){
		                var
		                 Change =
		                   [248,
		                    "Acid__State_effect.Make(S).Change",
		                    caml_fresh_oo_id()];
		                function put(v, cont){
		                 return caml_perform_effect
		                         ([0, Change, function(param, cont){return cont(v);}],
		                          function(a){return cont();});
		                }
		                var
		                 Get =
		                   [248, "Acid__State_effect.Make(S).Get", caml_fresh_oo_id()];
		                function run_state(init, f, cont){
		                 function handle(state, k, arg, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (continue_with,
		                           k,
		                           arg,
		                           [0,
		                            function(v, cont){return cont([0, v, state]);},
		                            function(b, a){
		                             a = caml_pop_trap();
		                             return a(caml_maybe_attach_backtrace(b, 1));
		                            },
		                            function(eff, cont){
		                             if(eff === Get)
		                              return cont
		                                      ([0,
		function(k, cont){
		 return caml_exact_trampoline_cps_call$0
		         (handle, state, k, state, cont);
		}]);
		                             if(eff[1] !== Change) return cont(0);
		                             var f = eff[2];
		                             return cont
		                                     ([0,
		                                       function(k, cont){
		return caml_trampoline_cps_call2
		        (f,
		         state,
		         function(a){
		          return caml_exact_trampoline_cps_call$0
		                  (handle, a, k, state, cont);
		         });
		                                       }]);
		                            }],
		                           cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (fiber,
		                          f,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (handle, init, a, 0, cont);
		                          });
		                }
		                return [0, , , , put, , , run_state];
		               }
		               var Empty = [248, "Lwt_sequence.Empty", caml_fresh_oo_id()];
		               function remove$5(node){
		                var
		                 a = node[4],
		                 a =
		                   a
		                    ? (node
		                       [4]
		                      = 0,
		                      node[1][2] = node[2],
		                      node[2][1] = node[1],
		                      0)
		                    : a;
		                return a;
		               }
		               function create$19(param){
		                var seq = [];
		                caml_update_dummy(seq, [0, seq, seq]);
		                return seq;
		               }
		               function is_empty$7(seq){return seq[2] === seq ? 1 : 0;}
		               function add_r(data, seq){
		                var node = [0, seq[1], seq, data, 1];
		                seq[1][2] = node;
		                seq[1] = node;
		                return node;
		               }
		               function take_opt_l(seq){
		                if(is_empty$7(seq)) return 0;
		                var node = seq[2];
		                remove$5(node);
		                return [0, node[3]];
		               }
		               function compare$44(b, a, cont){
		                return cont(caml_compare(b, a));
		               }
		               var Storage_map = k([0, compare$44]);
		               function state_of_result(param){
		                if(0 === param[0]){var x = param[1]; return [0, x];}
		                var exn = param[1];
		                return [1, exn];
		               }
		               function underlying(p){
		                var match = p[1];
		                if(3 !== match[0]) return p;
		                var p2 = match[1], p1 = underlying(p2);
		                if(1 - (p1 === p2)) p[1] = [3, p1];
		                return p1;
		               }
		               function handle_all_except_runtime(param){
		                return param === Out_of_memory
		                        ? 0
		                        : param === Stack_overflow ? 0 : 1;
		               }
		               function run$1(e){return handle_all_except_runtime(e);}
		               var current_storage = [0, Storage_map[1]];
		               function concat_regular_callbacks(l1, l2){
		                return typeof l1 === "number"
		                        ? l2
		                        : typeof l2 === "number" ? l1 : [0, l1, l2];
		               }
		               function clean_up_callback_cells(callbacks){
		                if(typeof callbacks !== "number")
		                 switch(callbacks[0]){
		                   case 0:
		                    var
		                     l2 = callbacks[2],
		                     l1 = callbacks[1],
		                     l1$0 = clean_up_callback_cells(l1),
		                     l2$0 = clean_up_callback_cells(l2);
		                    return concat_regular_callbacks(l1$0, l2$0);
		                   case 2:
		                    if(! callbacks[1][1]) return 0; break;
		                 }
		                return callbacks;
		               }
		               function clear_explicitly_removable_cal(cell, ps){
		                cell[1] = 0;
		                var b = ps;
		                for(;;){
		                 if(! b) return 0;
		                 var l = b[2], a = b[1], b = underlying(a)[1];
		                 if(2 === b[0]){
		                  var callbacks = b[1], b = callbacks[1];
		                  if(typeof b !== "number" && 2 === b[0]){callbacks[1] = 0; b = l; continue;}
		                  var cleanups_deferred = callbacks[4] + 1 | 0;
		                  if(42 < cleanups_deferred){
		                   callbacks[4] = 0;
		                   callbacks[1] = clean_up_callback_cells(callbacks[1]);
		                   b = l;
		                  }
		                  else {callbacks[4] = cleanups_deferred; b = l;}
		                 }
		                 else
		                  b = l;
		                }
		               }
		               function add_regular_callback_list_node(callbacks, node){
		                var
		                 existing = callbacks[1],
		                 node$0 =
		                   typeof existing === "number" ? node : [0, node, existing];
		                callbacks[1] = node$0;
		                return 0;
		               }
		               function add_implicitly_removed_callbac(callbacks, f){
		                return add_regular_callback_list_node(callbacks, [1, f]);
		               }
		               function add_explicitly_removable_callb(ps, f){
		                var cell = [];
		                function self_removing_callback_wrapper(result, cont){
		                 clear_explicitly_removable_cal(cell, ps);
		                 return caml_exact_trampoline_cps_call(f, result, cont);
		                }
		                caml_update_dummy
		                 (cell, [0, [0, self_removing_callback_wrapper]]);
		                var b = ps, node = [2, cell];
		                for(;;){
		                 if(! b) return cell;
		                 var l = b[2], a = b[1], b = underlying(a)[1];
		                 switch(b[0]){
		                   case 1:
		                    throw caml_maybe_attach_backtrace
		                           ([0, Assert_failure, mD], 1);
		                   case 2:
		                    var callbacks = b[1];
		                    add_regular_callback_list_node(callbacks, node);
		                    b = l;
		                    break;
		                   default:
		                    throw caml_maybe_attach_backtrace
		                           ([0, Assert_failure, mC], 1);
		                 }
		                }
		               }
		               function add_explicitly_removable_callb$0(ps, f){add_explicitly_removable_callb(ps, f);
		               }
		               function add_cancel_callback(callbacks, f){
		                var
		                 node = [1, current_storage[1], f],
		                 node$0 =
		                   typeof callbacks[2] === "number"
		                    ? node
		                    : [0, node, callbacks[2]];
		                callbacks[2] = node$0;
		               }
		               var
		                async_exception_hook =
		                  [0,
		                   function(exn, cont){
		                    output_string(stderr, cst_Fatal_error_exception);
		                    return caml_exact_trampoline_cps_call
		                            (to_string$0,
		                             exn,
		                             function(s){
		                              output_string(stderr, s);
		                              caml_ml_output_char(stderr, 10);
		                              return caml_exact_trampoline_cps_call
		                                      (print_backtrace,
		                                       stderr,
		                                       function(a){
		caml_ml_flush(stderr);
		return caml_exact_trampoline_cps_call(exit, 2, cont);
		                                       });
		                             });
		                   }];
		               function handle_with_async_exception_ho(f, v, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(run$1(exn))
		                    return caml_trampoline_cps_call2
		                            (async_exception_hook[1], exn, cont);
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_trampoline_cps_call2
		                        (f, v, function(a){caml_pop_trap(); return cont(a);});
		               }
		               var
		                Canceled =
		                  [248, "Lwt.Resolution_loop.Canceled", caml_fresh_oo_id()];
		               function run_callbacks(callbacks, result, cont){
		                var
		                 is_canceled =
		                   1 === result[0] ? result[1] === Canceled ? 1 : 0 : 0;
		                function a(a){
		                 var fs = callbacks[1];
		                 function iter_callback_list(fs$2, rest$1, cont){
		                  a:
		                  {
		                   var fs = fs$2, rest = rest$1;
		                   b:
		                   for(;;){
		                    if(typeof fs === "number")
		                     return caml_exact_trampoline_cps_call(iter_list, rest, cont);
		                    switch(fs[0]){
		                      case 0:
		                       var fs$0 = fs[2], fs$1 = fs[1], rest$0 = [0, fs$0, rest];
		                       fs = fs$1;
		                       rest = rest$0;
		                       break;
		                      case 1:
		                       break a;
		                      default: break b;
		                    }
		                   }
		                   var match = fs[1][1];
		                   if(! match)
		                    return caml_exact_trampoline_cps_call(iter_list, rest, cont);
		                   var f$0 = match[1];
		                   return caml_trampoline_cps_call2
		                           (f$0,
		                            result,
		                            function(a){
		                             return caml_exact_trampoline_cps_call(iter_list, rest, cont);
		                            });
		                  }
		                  var f = fs[1];
		                  return caml_trampoline_cps_call2
		                          (f,
		                           result,
		                           function(a){
		                            return caml_exact_trampoline_cps_call(iter_list, rest, cont);
		                           });
		                 }
		                 function iter_list(rest, cont){
		                  if(! rest) return cont();
		                  var rest$0 = rest[2], fs = rest[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (iter_callback_list, fs, rest$0, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (iter_callback_list, fs, 0, cont);
		                }
		                if(! is_canceled) return a();
		                var fs = callbacks[2];
		                function iter_callback_list(fs$2, rest$1, cont){
		                 var fs = fs$2, rest = rest$1;
		                 a:
		                 for(;;){
		                  if(typeof fs === "number")
		                   return caml_exact_trampoline_cps_call(iter_list, rest, cont);
		                  switch(fs[0]){
		                    case 0:
		                     var fs$0 = fs[2], fs$1 = fs[1], rest$0 = [0, fs$0, rest];
		                     fs = fs$1;
		                     rest = rest$0;
		                     break;
		                    case 1:
		                     break a;
		                    default:
		                     var node = fs[1];
		                     remove$5(node);
		                     return caml_exact_trampoline_cps_call(iter_list, rest, cont);
		                  }
		                 }
		                 var f = fs[2], storage = fs[1];
		                 current_storage[1] = storage;
		                 return caml_exact_trampoline_cps_call$1
		                         (handle_with_async_exception_ho,
		                          f,
		                          0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(iter_list, rest, cont);
		                          });
		                }
		                function iter_list(rest, cont){
		                 if(! rest) return cont();
		                 var rest$0 = rest[2], fs = rest[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (iter_callback_list, fs, rest$0, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (iter_callback_list, fs, 0, a);
		               }
		               var
		                deferred_callbacks = create$0(),
		                current_callback_nesting_depth = [0, 0];
		               function leave_resolution_loop(storage_snapshot, cont){
		                function b(){
		                 current_callback_nesting_depth[1] =
		                  current_callback_nesting_depth[1] - 1 | 0;
		                 current_storage[1] = storage_snapshot;
		                 return cont();
		                }
		                function a(c){
		                 if(0 === deferred_callbacks[1]) return b();
		                 c = take(deferred_callbacks);
		                 var result = c[2], callbacks = c[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (run_callbacks, callbacks, result, a);
		                }
		                return 1 === current_callback_nesting_depth[1] ? a(0) : b();
		               }
		               function run_callbacks_or_defer_them
		               (a, opt, callbacks, result, cont){
		                var
		                 allow_deferring = a ? a[1] : 1,
		                 maximum_callback_nesting_depth = opt ? opt[1] : 42,
		                 should_defer =
		                   allow_deferring
		                    ? maximum_callback_nesting_depth
		                     <= current_callback_nesting_depth[1]
		                    : allow_deferring;
		                if(should_defer)
		                 return cont(add([0, callbacks, result], deferred_callbacks));
		                current_callback_nesting_depth[1] =
		                 current_callback_nesting_depth[1] + 1 | 0;
		                var storage_snapshot = current_storage[1];
		                return caml_exact_trampoline_cps_call$1
		                        (run_callbacks,
		                         callbacks,
		                         result,
		                         function(result){
		                          return caml_exact_trampoline_cps_call
		                                  (leave_resolution_loop,
		                                   storage_snapshot,
		                                   function(a){return cont();});
		                         });
		               }
		               function resolve
		               (allow_deferring,
		                maximum_callback_nesting_depth,
		                p,
		                result,
		                cont){
		                var callbacks = p[1][1];
		                p[1] = result;
		                return caml_exact_trampoline_cps_call$2
		                        (run_callbacks_or_defer_them,
		                         allow_deferring,
		                         maximum_callback_nesting_depth,
		                         callbacks,
		                         result,
		                         function(a){return cont(p);});
		               }
		               function run_callback_or_defer_it(a, f, if_deferred, cont){
		                var run_immediately_and_ensure_tai = a ? a[1] : 0;
		                if(run_immediately_and_ensure_tai)
		                 return caml_exact_trampoline_cps_call(f, dummy, cont);
		                var should_defer = 42 <= current_callback_nesting_depth[1];
		                if(should_defer){
		                 a = if_deferred();
		                 var
		                  deferred_result = a[3],
		                  deferred_callback = a[2],
		                  immediate_result = a[1];
		                 add
		                  ([0, [0, [1, deferred_callback], 0, 0, 0], deferred_result],
		                   deferred_callbacks);
		                 return cont(immediate_result);
		                }
		                current_callback_nesting_depth[1] =
		                 current_callback_nesting_depth[1] + 1 | 0;
		                var storage_snapshot = current_storage[1];
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         dummy,
		                         function(result){
		                          return caml_exact_trampoline_cps_call
		                                  (leave_resolution_loop,
		                                   storage_snapshot,
		                                   function(a){return cont(result);});
		                         });
		               }
		               function wakeup_general(api_function_name, r, result, cont){
		                var p = underlying(r), match = p[1];
		                switch(match[0]){
		                  case 1:
		                   return match[1] === Canceled
		                           ? cont(0)
		                           : caml_exact_trampoline_cps_call$1
		                             (ksprintf,
		                              invalid_arg,
		                              mF,
		                              function(a){
		                               return caml_trampoline_cps_call2(a, api_function_name, cont);
		                              });
		                  case 2:
		                   var result$0 = state_of_result(result);
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve,
		                            mG,
		                            0,
		                            p,
		                            result$0,
		                            function(match){return cont(0);});
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (ksprintf,
		                            invalid_arg,
		                            mE,
		                            function(a){
		                             return caml_trampoline_cps_call2(a, api_function_name, cont);
		                            });
		                }
		               }
		               function wakeup(r, v, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (wakeup_general, "wakeup", r, [0, v], cont);
		               }
		               function wakeup_exn(r, exn, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (wakeup_general, "wakeup_exn", r, [1, exn], cont);
		               }
		               function wakeup_later_general
		               (api_function_name, r, result, cont){
		                var p = underlying(r), match = p[1];
		                switch(match[0]){
		                  case 1:
		                   return match[1] === Canceled
		                           ? cont(0)
		                           : caml_exact_trampoline_cps_call$1
		                             (ksprintf,
		                              invalid_arg,
		                              mI,
		                              function(a){
		                               return caml_trampoline_cps_call2(a, api_function_name, cont);
		                              });
		                  case 2:
		                   var result$0 = state_of_result(result);
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve,
		                            0,
		                            mJ,
		                            p,
		                            result$0,
		                            function(match){return cont(0);});
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (ksprintf,
		                            invalid_arg,
		                            mH,
		                            function(a){
		                             return caml_trampoline_cps_call2(a, api_function_name, cont);
		                            });
		                }
		               }
		               function wakeup_later(r, v, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (wakeup_later_general, "wakeup_later", r, [0, v], cont);
		               }
		               function cancel(p, cont){
		                var canceled_result = [1, Canceled];
		                function cancel_and_collect_callbacks
		                (callbacks_accumulator, p$2, cont){
		                 var p = p$2;
		                 for(;;){
		                  var p$0 = underlying(p), a = p$0[1];
		                  switch(a[0]){
		                    case 1:
		                     return cont(callbacks_accumulator);
		                    case 2:
		                     var callbacks = a[1], a = callbacks[3];
		                     if(typeof a === "number")
		                      return 0 === a
		                              ? cont(callbacks_accumulator)
		                              : (p$0
		                                 [1]
		                                = canceled_result,
		                                cont([0, callbacks, callbacks_accumulator]));
		                     if(0 !== a[0]){
		                      var ps = a[1];
		                      return caml_exact_trampoline_cps_call$0
		                              (fold_left,
		                               cancel_and_collect_callbacks,
		                               callbacks_accumulator,
		                               ps,
		                               cont);
		                     }
		                     var p$1 = a[1];
		                     p = p$1;
		                     break;
		                    default: return cont(callbacks_accumulator);
		                  }
		                 }
		                }
		                function a(param){
		                 if(! param) return cont();
		                 var l = param[2], a$0 = param[1];
		                 return caml_exact_trampoline_cps_call$2
		                         (run_callbacks_or_defer_them,
		                          mK,
		                          0,
		                          a$0,
		                          canceled_result,
		                          function(b){return caml_exact_trampoline_call1(a, l);});
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (cancel_and_collect_callbacks, 0, p, a);
		               }
		               function return$10(v, cont){return cont([0, [0, v]]);}
		               function fail$1(exn){return [0, [1, exn]];}
		               var
		                return_unit = caml_callback(return$10, [0]),
		                return_none = caml_callback(return$10, [0]);
		               function return_ok(x, cont){
		                return caml_exact_trampoline_cps_call(return$10, [0, x], cont);
		               }
		               function return_error(x, cont){
		                return caml_exact_trampoline_cps_call(return$10, [1, x], cont);
		               }
		               function new_pending(how_to_cancel){
		                var state = [2, [0, 0, 0, how_to_cancel, 0]];
		                return [0, state];
		               }
		               function wait(param){var p = new_pending(0); return [0, p, p];}
		               function task(param){var p = new_pending(1); return [0, p, p];}
		               function add_task_r(sequence){
		                var
		                 actual_content = new_pending(1),
		                 node = add_r(actual_content, sequence),
		                 callbacks = actual_content[1][1];
		                callbacks[2] = [2, node];
		                return actual_content;
		               }
		               function protected$(p_internal){
		                switch(underlying(p_internal)[1][0]){
		                  case 1:
		                   return p_internal;
		                  case 2:
		                   var
		                    p = new_pending(1),
		                    callback =
		                      function(p_result, cont){
		                       var p$0 = underlying(p);
		                       return caml_exact_trampoline_cps_call$2
		                               (resolve,
		                                mL,
		                                0,
		                                p$0,
		                                p_result,
		                                function(match){return cont(0);});
		                      },
		                    ps = [0, p_internal, 0],
		                    cell = add_explicitly_removable_callb(ps, callback),
		                    remove_the_callback =
		                      function(param, cont){
		                       return cont(clear_explicitly_removable_cal(cell, ps));
		                      },
		                    p_callbacks = p[1][1];
		                   add_cancel_callback(p_callbacks, remove_the_callback);
		                   return p;
		                  default: return p_internal;
		                }
		               }
		               function make_into_proxy
		               (outer_promise, user_provided_promise, cont){
		                var p1 = underlying(user_provided_promise);
		                if(p1 === outer_promise) return cont(p1);
		                var match = p1[1];
		                switch(match[0]){
		                  case 1:
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve, mN, 0, outer_promise, p1[1], cont);
		                  case 2:
		                   var
		                    p_callbacks = match[1],
		                    outer_callbacks = outer_promise[1][1],
		                    regular_callbacks =
		                      concat_regular_callbacks(outer_callbacks[1], p_callbacks[1]),
		                    cleanups_deferred = outer_callbacks[4] + p_callbacks[4] | 0;
		                   if(42 < cleanups_deferred)
		                    var
		                     cleanups_deferred$0 = 0,
		                     regular_callbacks$0 =
		                       clean_up_callback_cells(regular_callbacks);
		                   else {
		                    cleanups_deferred$0 = cleanups_deferred;
		                    regular_callbacks$0 = regular_callbacks;
		                   }
		                   var
		                    l2 = p_callbacks[2],
		                    l1 = outer_callbacks[2],
		                    cancel_callbacks =
		                      typeof l1 === "number"
		                       ? l2
		                       : typeof l2 === "number" ? l1 : [0, l1, l2];
		                   outer_callbacks[1] = regular_callbacks$0;
		                   outer_callbacks[2] = cancel_callbacks;
		                   outer_callbacks[4] = cleanups_deferred$0;
		                   outer_callbacks[3] = p_callbacks[3];
		                   var state = [3, outer_promise];
		                   p1[1] = state;
		                   return cont(outer_promise);
		                  default:
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve, mM, 0, outer_promise, p1[1], cont);
		                }
		               }
		               function symbol_bind$6(p, f, cont){
		                var p$0 = underlying(p);
		                function create_result_promise_and_call(param){
		                 var
		                  p = new_pending([0, p$0]),
		                  saved_storage = current_storage[1];
		                 function callback(p_result, cont){
		                  if(1 === p_result[0]){
		                   var p$0 = underlying(p);
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve,
		                            mO,
		                            0,
		                            p$0,
		                            p_result,
		                            function(match){return cont(0);});
		                  }
		                  var v = p_result[1];
		                  current_storage[1] = saved_storage;
		                  function a(p$0){
		                   var p$1 = underlying(p);
		                   return caml_exact_trampoline_cps_call$1
		                           (make_into_proxy,
		                            p$1,
		                            p$0,
		                            function(match){return cont(0);});
		                  }
		                  caml_push_trap
		                   (function(exn){
		                     if(run$1(exn)) return a(fail$1(exn));
		                     var
		                      raise = caml_pop_trap(),
		                      exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                     return raise(exn$0);
		                    });
		                  return caml_trampoline_cps_call2
		                          (f, v, function(b){caml_pop_trap(); return a(b);});
		                 }
		                 return [0, p, callback];
		                }
		                var result = p$0[1];
		                switch(result[0]){
		                  case 1:
		                   return cont([0, result]);
		                  case 2:
		                   var
		                    p_callbacks = result[1],
		                    match = create_result_promise_and_call(),
		                    callback = match[2],
		                    p$1 = match[1];
		                   add_implicitly_removed_callbac(p_callbacks, callback);
		                   return cont(p$1);
		                  default:
		                   var v = result[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (run_callback_or_defer_it,
		                            mP,
		                            function(param, cont){
		                             return caml_trampoline_cps_call2(f, v, cont);
		                            },
		                            function(a){
		                             a = create_result_promise_and_call();
		                             var callback = a[2], p = a[1];
		                             return [0, p, callback, p$0[1]];
		                            },
		                            cont);
		                }
		               }
		               function symbol$90(f, p, cont){
		                var p$0 = underlying(p);
		                function create_result_promise_and_call(param){
		                 var
		                  p = new_pending([0, p$0]),
		                  saved_storage = current_storage[1];
		                 function callback(p_result, cont){
		                  if(1 === p_result[0]){
		                   var p$0 = underlying(p);
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve,
		                            mR,
		                            0,
		                            p$0,
		                            p_result,
		                            function(match){return cont(0);});
		                  }
		                  var v = p_result[1];
		                  current_storage[1] = saved_storage;
		                  function a(p_result){
		                   var p$0 = underlying(p);
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve,
		                            mQ,
		                            0,
		                            p$0,
		                            p_result,
		                            function(match){return cont(0);});
		                  }
		                  caml_push_trap
		                   (function(exn){
		                     if(run$1(exn)) return a([1, exn]);
		                     var
		                      raise = caml_pop_trap(),
		                      exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                     return raise(exn$0);
		                    });
		                  return caml_trampoline_cps_call2
		                          (f, v, function(b){caml_pop_trap(); return a([0, b]);});
		                 }
		                 return [0, p, callback];
		                }
		                var result = p$0[1];
		                switch(result[0]){
		                  case 1:
		                   return cont([0, result]);
		                  case 2:
		                   var
		                    p_callbacks = result[1],
		                    match = create_result_promise_and_call(),
		                    callback = match[2],
		                    p$1 = match[1];
		                   add_implicitly_removed_callbac(p_callbacks, callback);
		                   return cont(p$1);
		                  default:
		                   var v = result[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (run_callback_or_defer_it,
		                            mS,
		                            function(param, cont){
		                             function a(a){return cont([0, a]);}
		                             caml_push_trap
		                              (function(exn){
		                                if(run$1(exn)) return a([1, exn]);
		                                var
		                                 raise = caml_pop_trap(),
		                                 exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                                return raise(exn$0);
		                               });
		                             return caml_trampoline_cps_call2
		                                     (f, v, function(b){caml_pop_trap(); return a([0, b]);});
		                            },
		                            function(a){
		                             a = create_result_promise_and_call();
		                             var callback = a[2], p = a[1];
		                             return [0, p, callback, p$0[1]];
		                            },
		                            cont);
		                }
		               }
		               function catch$(f, h, cont){
		                function a(p){
		                 var p$0 = underlying(p);
		                 function create_result_promise_and_call(param){
		                  var
		                   p = new_pending([0, p$0]),
		                   saved_storage = current_storage[1];
		                  function callback(p_result, cont){
		                   if(1 === p_result[0]){
		                    var exn = p_result[1];
		                    current_storage[1] = saved_storage;
		                    var
		                     a =
		                       function(p$0){
		                        var p$1 = underlying(p);
		                        return caml_exact_trampoline_cps_call$1
		                                (make_into_proxy,
		                                 p$1,
		                                 p$0,
		                                 function(match){return cont(0);});
		                       };
		                    caml_push_trap
		                     (function(exn){
		                       if(run$1(exn)) return a(fail$1(exn));
		                       var
		                        raise = caml_pop_trap(),
		                        exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                       return raise(exn$0);
		                      });
		                    return caml_exact_trampoline_cps_call
		                            (h, exn, function(b){caml_pop_trap(); return a(b);});
		                   }
		                   var p$0 = underlying(p);
		                   return caml_exact_trampoline_cps_call$2
		                           (resolve,
		                            mT,
		                            0,
		                            p$0,
		                            p_result,
		                            function(match){return cont(0);});
		                  }
		                  return [0, p, callback];
		                 }
		                 var a = p$0[1];
		                 switch(a[0]){
		                   case 1:
		                    var exn = a[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (run_callback_or_defer_it,
		                             mU,
		                             function(param, cont){
		                              return caml_exact_trampoline_cps_call(h, exn, cont);
		                             },
		                             function(a){
		                              a = create_result_promise_and_call();
		                              var callback = a[2], p = a[1];
		                              return [0, p, callback, p$0[1]];
		                             },
		                             cont);
		                   case 2:
		                    var
		                     p_callbacks = a[1],
		                     a = create_result_promise_and_call(),
		                     callback = a[2],
		                     p$1 = a[1];
		                    add_implicitly_removed_callbac(p_callbacks, callback);
		                    return cont(p$1);
		                   default: return cont(p$0);
		                 }
		                }
		                caml_push_trap
		                 (function(exn){
		                   if(run$1(exn)) return a(fail$1(exn));
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (f, dummy, function(b){caml_pop_trap(); return a(b);});
		               }
		               function try_bind(f$0, f, h, cont){
		                function a(p){
		                 var p$0 = underlying(p);
		                 function create_result_promise_and_call(param){
		                  var
		                   p = new_pending([0, p$0]),
		                   saved_storage = current_storage[1];
		                  function callback(p_result, cont){
		                   if(1 === p_result[0]){
		                    var exn = p_result[1];
		                    current_storage[1] = saved_storage;
		                    var
		                     b =
		                       function(p$0){
		                        var p$1 = underlying(p);
		                        return caml_exact_trampoline_cps_call$1
		                                (make_into_proxy,
		                                 p$1,
		                                 p$0,
		                                 function(match){return cont(0);});
		                       };
		                    caml_push_trap
		                     (function(exn){
		                       if(run$1(exn)) return b(fail$1(exn));
		                       var
		                        raise = caml_pop_trap(),
		                        exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                       return raise(exn$0);
		                      });
		                    return caml_exact_trampoline_cps_call
		                            (h, exn, function(a){caml_pop_trap(); return b(a);});
		                   }
		                   var v = p_result[1];
		                   current_storage[1] = saved_storage;
		                   function a(p$0){
		                    var p$1 = underlying(p);
		                    return caml_exact_trampoline_cps_call$1
		                            (make_into_proxy,
		                             p$1,
		                             p$0,
		                             function(match){return cont(0);});
		                   }
		                   caml_push_trap
		                    (function(exn){
		                      if(run$1(exn)) return a(fail$1(exn));
		                      var
		                       raise = caml_pop_trap(),
		                       exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                      return raise(exn$0);
		                     });
		                   return caml_exact_trampoline_cps_call
		                           (f, v, function(b){caml_pop_trap(); return a(b);});
		                  }
		                  return [0, p, callback];
		                 }
		                 var a = p$0[1];
		                 switch(a[0]){
		                   case 1:
		                    var exn = a[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (run_callback_or_defer_it,
		                             mW,
		                             function(param, cont){
		                              return caml_exact_trampoline_cps_call(h, exn, cont);
		                             },
		                             function(a){
		                              a = create_result_promise_and_call();
		                              var callback = a[2], p = a[1];
		                              return [0, p, callback, p$0[1]];
		                             },
		                             cont);
		                   case 2:
		                    var
		                     p_callbacks = a[1],
		                     a = create_result_promise_and_call(),
		                     callback = a[2],
		                     p$1 = a[1];
		                    add_implicitly_removed_callbac(p_callbacks, callback);
		                    return cont(p$1);
		                   default:
		                    var v = a[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (run_callback_or_defer_it,
		                             mV,
		                             function(param, cont){
		                              return caml_exact_trampoline_cps_call(f, v, cont);
		                             },
		                             function(a){
		                              a = create_result_promise_and_call();
		                              var callback = a[2], p = a[1];
		                              return [0, p, callback, p$0[1]];
		                             },
		                             cont);
		                 }
		                }
		                caml_push_trap
		                 (function(exn){
		                   if(run$1(exn)) return a(fail$1(exn));
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (f$0, dummy, function(b){caml_pop_trap(); return a(b);});
		               }
		               function finalize(f$0, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (try_bind,
		                         f$0,
		                         function(x, cont){
		                          function a(param, cont){
		                           return caml_exact_trampoline_cps_call(return$10, x, cont);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (f,
		                                   dummy,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_bind$6, b, a, cont);
		                                   });
		                         },
		                         function(e, cont){
		                          function a(param, cont){return cont(fail$1(e));}
		                          return caml_exact_trampoline_cps_call
		                                  (f,
		                                   dummy,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_bind$6, b, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function on_cancel(p, f, cont){
		                var p$0 = underlying(p), match = p$0[1];
		                switch(match[0]){
		                  case 1:
		                   return match[1] === Canceled
		                           ? caml_exact_trampoline_cps_call$0
		                             (run_callback_or_defer_it,
		                              mY,
		                              function(param, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (handle_with_async_exception_ho, f, 0, cont);
		                              },
		                              function(param){
		                               return [0,
		                                       0,
		                                       function(param, cont){
		return caml_exact_trampoline_cps_call$1
		        (handle_with_async_exception_ho, f, 0, cont);
		                                       },
		                                       mX];
		                              },
		                              cont)
		                           : cont();
		                  case 2:
		                   var callbacks = match[1];
		                   return cont(add_cancel_callback(callbacks, f));
		                  default: return cont();
		                }
		               }
		               function dont_wait(f, h, cont){
		                function a(p){
		                 var match = underlying(p)[1];
		                 switch(match[0]){
		                   case 1:
		                    var exn = match[1];
		                    return caml_exact_trampoline_cps_call(h, exn, cont);
		                   case 2:
		                    var
		                     p_callbacks = match[1],
		                     callback =
		                       function(result, cont){
		                        if(1 !== result[0]) return cont(0);
		                        var exn = result[1];
		                        return caml_exact_trampoline_cps_call(h, exn, cont);
		                       };
		                    return cont
		                            (add_implicitly_removed_callbac(p_callbacks, callback));
		                   default: return cont(0);
		                 }
		                }
		                caml_push_trap
		                 (function(exn){
		                   if(run$1(exn)) return a(fail$1(exn));
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (f, dummy, function(b){caml_pop_trap(); return a(b);});
		               }
		               function async(f, cont){
		                function a(p){
		                 var match = underlying(p)[1];
		                 switch(match[0]){
		                   case 1:
		                    var exn = match[1];
		                    return caml_trampoline_cps_call2
		                            (async_exception_hook[1], exn, cont);
		                   case 2:
		                    var
		                     p_callbacks = match[1],
		                     callback =
		                       function(result, cont){
		                        if(1 !== result[0]) return cont(0);
		                        var exn = result[1];
		                        return caml_trampoline_cps_call2
		                                (async_exception_hook[1], exn, cont);
		                       };
		                    return cont
		                            (add_implicitly_removed_callbac(p_callbacks, callback));
		                   default: return cont(0);
		                 }
		                }
		                caml_push_trap
		                 (function(exn){
		                   if(run$1(exn)) return a(fail$1(exn));
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (f, dummy, function(b){caml_pop_trap(); return a(b);});
		               }
		               function join$3(ps){
		                var
		                 p = new_pending([1, ps]),
		                 number_pending_in_ps = [0, 0],
		                 join_result = [0, mZ];
		                function callback(new_result, cont){
		                 if(1 === new_result[0] && 1 !== join_result[1][0])
		                  join_result[1] = new_result;
		                 number_pending_in_ps[1] = number_pending_in_ps[1] - 1 | 0;
		                 var a = 0 === number_pending_in_ps[1] ? 1 : 0;
		                 function b(a){return cont(a);}
		                 if(! a) return b(a);
		                 var p$0 = underlying(p), a = join_result[1];
		                 return caml_exact_trampoline_cps_call$2
		                         (resolve,
		                          m0,
		                          0,
		                          underlying(p$0),
		                          a,
		                          function(match){return b(0);});
		                }
		                var ps$0 = ps;
		                for(;;){
		                 if(! ps$0)
		                  return 0 === number_pending_in_ps[1]
		                          ? [0, join_result[1]]
		                          : p;
		                 var
		                  ps$1 = ps$0[2],
		                  p$0 = ps$0[1],
		                  p_result = underlying(p$0)[1];
		                 switch(p_result[0]){
		                   case 1:
		                    if(1 === join_result[1][0])
		                     ps$0 = ps$1;
		                    else {join_result[1] = p_result; ps$0 = ps$1;}
		                    break;
		                   case 2:
		                    var p_callbacks = p_result[1];
		                    number_pending_in_ps[1] = number_pending_in_ps[1] + 1 | 0;
		                    add_implicitly_removed_callbac(p_callbacks, callback);
		                    ps$0 = ps$1;
		                    break;
		                   default: ps$0 = ps$1;
		                 }
		                }
		               }
		               function both$0(p1, p2, cont){
		                var pair = [0, 0, 0];
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$6,
		                         p1,
		                         function(v, cont){
		                          pair[1] = [0, v];
		                          return cont(return_unit);
		                         },
		                         function(p1){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6,
		                                   p2,
		                                   function(v, cont){
		                                    pair[2] = [0, v];
		                                    return cont(return_unit);
		                                   },
		                                   function(p2){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$90,
		     function(a, b){
		      a = pair[1];
		      var match = pair[2];
		      if(a && match){
		       var v2 = match[1], v1 = a[1];
		       return b([0, v1, v2]);
		      }
		      b = caml_pop_trap();
		      return b
		              (caml_maybe_attach_backtrace([0, Assert_failure, m1], 1));
		     },
		     join$3([0, p1, [0, p2, 0]]),
		     cont);
		                                   });
		                         });
		               }
		               function count_resolved_promises_in(ps){
		                var total$1 = 0, ps$2 = ps;
		                a:
		                for(;;){
		                 if(! ps$2) return [0, total$1];
		                 var ps$3 = ps$2[2], p$0 = ps$2[1];
		                 switch(underlying(p$0)[1][0]){
		                   case 1:
		                    break a;
		                   case 2:
		                    ps$2 = ps$3; break;
		                   default:
		                    var total$2 = total$1 + 1 | 0;
		                    total$1 = total$2;
		                    ps$2 = ps$3;
		                 }
		                }
		                var total = 1, rejected = [0, p$0, 0], ps$0 = ps$3;
		                for(;;){
		                 if(! ps$0) return [1, [0, total, rejected]];
		                 var ps$1 = ps$0[2], p = ps$0[1];
		                 if(1 === underlying(p)[1][0]){
		                  var rejected$0 = [0, p, rejected], total$0 = total + 1 | 0;
		                  total = total$0;
		                  rejected = rejected$0;
		                  ps$0 = ps$1;
		                 }
		                 else
		                  ps$0 = ps$1;
		                }
		               }
		               function nth_resolved(ps$1, n$2){
		                var ps = ps$1, n = n$2;
		                for(;;){
		                 if(! ps)
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, m2], 1);
		                 var ps$0 = ps[2], p = ps[1];
		                 switch(underlying(p)[1][0]){
		                   case 1:
		                    if(0 >= n) return p;
		                    var n$1 = n - 1 | 0;
		                    ps = ps$0;
		                    n = n$1;
		                    break;
		                   case 2:
		                    ps = ps$0; break;
		                   default:
		                    if(0 >= n) return p;
		                    var n$0 = n - 1 | 0;
		                    ps = ps$0;
		                    n = n$0;
		                 }
		                }
		               }
		               function nth_resolved_and_cancel_pendin(ps, n, cont){
		                function a(ps, n){
		                 if(! ps){
		                  var raise = caml_pop_trap();
		                  return raise
		                          (caml_maybe_attach_backtrace([0, Assert_failure, m3], 1));
		                 }
		                 var ps$0 = ps[2], p = ps[1];
		                 switch(underlying(p)[1][0]){
		                   case 1:
		                    if(0 >= n)
		                     return caml_exact_trampoline_cps_call$1
		                             (iter$0, cancel, ps$0, function(a){return cont(p);});
		                    var n$1 = n - 1 | 0;
		                    return caml_exact_trampoline_call2(a, ps$0, n$1);
		                   case 2:
		                    return caml_exact_trampoline_cps_call
		                            (cancel,
		                             p,
		                             function(b){return caml_exact_trampoline_call2(a, ps$0, n);});
		                   default:
		                    if(0 >= n)
		                     return caml_exact_trampoline_cps_call$1
		                             (iter$0, cancel, ps$0, function(a){return cont(p);});
		                    var n$0 = n - 1 | 0;
		                    return caml_exact_trampoline_call2(a, ps$0, n$0);
		                 }
		                }
		                return a(ps, n);
		               }
		               var prng = [246, function(a, cont){return cont(make$1([0]));}];
		               function choose(ps, cont){
		                function a(a){
		                 a = count_resolved_promises_in(ps);
		                 if(0 !== a[0]){
		                  a = a[1];
		                  var
		                   ps$0 = a[2],
		                   n$0 = a[1],
		                   a = caml_obj_tag(prng),
		                   b =
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (int,
		                               a,
		                               n$0,
		                               function(a){return cont(nth_resolved(ps$0, a));});
		                     };
		                  if(250 === a) return b(prng[1]);
		                  if(246 !== a && 244 !== a) return b(prng);
		                  return caml_exact_trampoline_cps_call
		                          (force_lazy_block, prng, b);
		                 }
		                 var n = a[1];
		                 if(0 === n){
		                  var
		                   p = new_pending([1, ps]),
		                   callback =
		                     function(result, cont){
		                      var p$0 = underlying(p);
		                      return caml_exact_trampoline_cps_call$2
		                              (resolve,
		                               m4,
		                               0,
		                               p$0,
		                               result,
		                               function(match){return cont(0);});
		                     };
		                  add_explicitly_removable_callb$0(ps, callback);
		                  return cont(p);
		                 }
		                 if(1 === n) return cont(nth_resolved(ps, 0));
		                 a = caml_obj_tag(prng);
		                 function c(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (int, a, n, function(a){return cont(nth_resolved(ps, a));});
		                 }
		                 if(250 === a) return c(prng[1]);
		                 if(246 !== a && 244 !== a) return c(prng);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, prng, c);
		                }
		                return 0 === ps
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg,
		                           "Lwt.choose [] would return a promise that is pending forever",
		                           a)
		                        : a(0);
		               }
		               function pick(ps, cont){
		                function a(a){
		                 a = count_resolved_promises_in(ps);
		                 if(0 !== a[0]){
		                  a = a[1];
		                  var qs = a[2], n$0 = a[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (iter$0,
		                           cancel,
		                           ps,
		                           function(a){
		                            a = caml_obj_tag(prng);
		                            function b(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (int,
		                                      a,
		                                      n$0,
		                                      function(a){return cont(nth_resolved(qs, a));});
		                            }
		                            if(250 === a) return b(prng[1]);
		                            if(246 !== a && 244 !== a) return b(prng);
		                            return caml_exact_trampoline_cps_call
		                                    (force_lazy_block, prng, b);
		                           });
		                 }
		                 var n = a[1];
		                 if(0 === n){
		                  var
		                   p = new_pending([1, ps]),
		                   callback =
		                     function(result, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (iter$0,
		                               cancel,
		                               ps,
		                               function(a){
		                                var p$0 = underlying(p);
		                                return caml_exact_trampoline_cps_call$2
		(resolve,
		 m5,
		 0,
		 p$0,
		 result,
		 function(match){return cont(0);});
		                               });
		                     };
		                  add_explicitly_removable_callb$0(ps, callback);
		                  return cont(p);
		                 }
		                 if(1 === n)
		                  return caml_exact_trampoline_cps_call$1
		                          (nth_resolved_and_cancel_pendin, ps, 0, cont);
		                 a = caml_obj_tag(prng);
		                 function b(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (int,
		                           a,
		                           n,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (nth_resolved_and_cancel_pendin, ps, a, cont);
		                           });
		                 }
		                 if(250 === a) return b(prng[1]);
		                 if(246 !== a && 244 !== a) return b(prng);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, prng, b);
		                }
		                return 0 === ps
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg,
		                           "Lwt.pick [] would return a promise that is pending forever",
		                           a)
		                        : a(0);
		               }
		               function is_sleeping(p){
		                switch(underlying(p)[1][0]){
		                  case 1:
		                   return 0;
		                  case 2:
		                   return 1;
		                  default: return 0;
		                }
		               }
		               function apply$0(f, x, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(run$1(exn)) return cont(fail$1(exn));
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_trampoline_cps_call2
		                        (f, x, function(a){caml_pop_trap(); return cont(a);});
		               }
		               var
		                pause_hook = [0, function(a, cont){return cont();}],
		                paused = create$19(),
		                bPn = [0, 0];
		               function pause(param, cont){
		                var p = add_task_r(paused);
		                bPn[1]++;
		                return caml_trampoline_cps_call2
		                        (pause_hook[1], bPn[1], function(a){return cont(p);});
		               }
		               function wakeup_paused(param, cont){
		                if(is_empty$7(paused)){bPn[1] = 0; return cont(0);}
		                var tmp = create$19();
		                tmp[1][2] = paused[2];
		                paused[2][1] = tmp[1];
		                tmp[1] = paused[1];
		                paused[1][2] = tmp;
		                paused[1] = paused;
		                paused[2] = paused;
		                bPn[1] = 0;
		                var curr = tmp[2];
		                function a(curr){
		                 var b = curr !== tmp ? 1 : 0;
		                 if(! b) return cont(b);
		                 function c(b){
		                  var curr$0 = curr[2];
		                  return caml_exact_trampoline_call1(a, curr$0);
		                 }
		                 if(! curr[4]) return c();
		                 var r = curr[3];
		                 return caml_exact_trampoline_cps_call$1(wakeup, r, 0, c);
		                }
		                return a(curr);
		               }
		               var
		                Closed = [248, "Lwt_stream.Closed", caml_fresh_oo_id()],
		                Full = [248, "Lwt_stream.Full", caml_fresh_oo_id()];
		               function new_node(param){
		                var node = [];
		                caml_update_dummy(node, [0, node, 0]);
		                return node;
		               }
		               function from_source(source){
		                var
		                 node = new_node(),
		                 match = wait(),
		                 close = match[2],
		                 closed = match[1];
		                return [0, source, close, closed, node, [0, node]];
		               }
		               function from(f){return from_source([0, [0, f, return_unit]]);}
		               function enqueue(e, last){
		                var node = last[1], new_last = new_node();
		                node[2] = e;
		                node[1] = new_last;
		                last[1] = new_last;
		               }
		               function enqueue$0(e, s){return enqueue(e, s[5]);}
		               function create$20(a){
		                a = wait();
		                var
		                 push_signal_resolver = a[2],
		                 push_signal = a[1],
		                 source = [0, push_signal, 0, 0],
		                 source$0 = from_source([2, source]),
		                 close = source$0[2],
		                 closed = source$0[3],
		                 last = source$0[5],
		                 push_signal_resolver$0 = [0, push_signal_resolver];
		                function push(x, cont){
		                 if(1 - is_sleeping(closed)){
		                  var
		                   a = caml_pop_trap(),
		                   Closed$0 = caml_maybe_attach_backtrace(Closed, 1);
		                  return a(Closed$0);
		                 }
		                 enqueue(x, last);
		                 function b(a){
		                  a = 0 === x ? 1 : 0;
		                  return a
		                          ? caml_exact_trampoline_cps_call$1(wakeup, close, 0, cont)
		                          : cont(a);
		                 }
		                 if(! source[2]) return b(0);
		                 source[2] = 0;
		                 var
		                  old_push_signal_resolver = push_signal_resolver$0[1],
		                  a = wait(),
		                  new_push_signal_resolver = a[2],
		                  new_waiter = a[1];
		                 source[1] = new_waiter;
		                 push_signal_resolver$0[1] = new_push_signal_resolver;
		                 return caml_exact_trampoline_cps_call$1
		                         (wakeup_later, old_push_signal_resolver, 0, b);
		                }
		                return [0, source$0, push];
		               }
		               function of_list$5(l, cont){
		                var match = create$20(), push = match[2], stream = match[1];
		                function a(param){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call
		                          (push, 0, function(a){return cont(stream);});
		                 var l = param[2], a$0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (push,
		                          [0, a$0],
		                          function(b){return caml_exact_trampoline_call1(a, l);});
		                }
		                return a(l);
		               }
		               function notify_pusher(info, last, cont){
		                enqueue(info[5], last);
		                info[5] = 0;
		                var
		                 old_wakener = info[7],
		                 match = task(),
		                 wakener = match[2],
		                 waiter = match[1];
		                info[6] = waiter;
		                info[7] = wakener;
		                return caml_exact_trampoline_cps_call$1
		                        (wakeup_later, old_wakener, 0, cont);
		               }
		               function class_init(table, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (new_variable,
		                         table,
		                         cst$1,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (new_variable,
		                                   table,
		                                   cst$1,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (new_variable,
		     table,
		     cst$1,
		     function(c){
		      return caml_exact_trampoline_cps_call$1
		              (new_variable,
		               table,
		               cst$1,
		               function(g){
		                var
		                 nmeths = shared.length - 1,
		                 nvals = vals.length - 1,
		                 res = caml_make_vect(nmeths + nvals | 0, 0),
		                 d = nmeths - 1 | 0;
		                function f(){
		                 var d = nvals - 1 | 0;
		                 function f(){
		                  var
		                   d = res[9],
		                   methods =
		                     [0,
		                      res[1],
		                      function(self_1, cont){return cont(self_1[a + 1][3]);},
		                      res[3],
		                      function(self_1, size, cont){
		                       function b(b){
		                        self_1[a + 1][3] = size;
		                        b = self_1[a + 1][4] < self_1[a + 1][3] ? 1 : 0;
		                        b = b ? 0 !== self_1[a + 1][5] ? 1 : 0 : b;
		                        return b
		                                ? (self_1
		                                    [a + 1]
		                                   [4]
		                                  = self_1[a + 1][4] + 1 | 0,
		                                  caml_exact_trampoline_cps_call$1
		                                   (notify_pusher, self_1[a + 1], self_1[c + 1], cont))
		                                : cont(b);
		                       }
		                       return size < 0
		                               ? caml_exact_trampoline_cps_call
		                                 (invalid_arg, "Lwt_stream.bounded_push#resize", b)
		                               : b(0);
		                      },
		                      res[4],
		                      function(self_1, x, cont){
		                       if(self_1[d + 1]) return cont(fail$1(Closed));
		                       if(0 !== self_1[a + 1][5]) return cont(fail$1(Full));
		                       if(self_1[a + 1][3] <= self_1[a + 1][4]){
		                        self_1[a + 1][5] = [0, x];
		                        return caml_exact_trampoline_cps_call$1
		                                (catch$,
		                                 function(param, cont){return cont(self_1[a + 1][6]);},
		                                 function(exn, b){
		                                  if(exn === Canceled){
		                                   self_1[a + 1][5] = 0;
		                                   b = task();
		                                   var wakener = b[2], waiter = b[1];
		                                   self_1[a + 1][6] = waiter;
		                                   self_1[a + 1][7] = wakener;
		                                   b = caml_pop_trap();
		                                   var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                                   return b(exn$0);
		                                  }
		                                  b = caml_pop_trap();
		                                  var exn$1 = caml_maybe_attach_backtrace(exn, 0);
		                                  return b(exn$1);
		                                 },
		                                 cont);
		                       }
		                       enqueue([0, x], self_1[c + 1]);
		                       self_1[a + 1][4] = self_1[a + 1][4] + 1 | 0;
		                       function e(a){return cont(return_unit);}
		                       if(! self_1[a + 1][2]) return e();
		                       self_1[a + 1][2] = 0;
		                       var
		                        old_wakener = self_1[b + 1][1],
		                        match = wait(),
		                        new_wakener = match[2],
		                        new_waiter = match[1];
		                       self_1[a + 1][1] = new_waiter;
		                       self_1[b + 1][1] = new_wakener;
		                       return caml_exact_trampoline_cps_call$1
		                               (wakeup_later, old_wakener, 0, e);
		                      },
		                      res[7],
		                      function(self_1, cont){
		                       var e = 1 - self_1[d + 1];
		                       if(! e) return cont(e);
		                       self_1[d + 1] = 1;
		                       var node = self_1[c + 1][1], new_last = new_node();
		                       node[2] = 0;
		                       node[1] = new_last;
		                       self_1[c + 1][1] = new_last;
		                       function f(d){
		                        function c(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (wakeup, self_1[g + 1], 0, cont);
		                        }
		                        if(! self_1[a + 1][2]) return c();
		                        self_1[a + 1][2] = 0;
		                        var old_wakener = self_1[b + 1][1];
		                        return caml_exact_trampoline_cps_call$1
		                                (wakeup_later, old_wakener, 0, c);
		                       }
		                       if(0 === self_1[a + 1][5]) return f();
		                       self_1[a + 1][5] = 0;
		                       var r = self_1[a + 1][7];
		                       return caml_exact_trampoline_cps_call$0
		                               (wakeup_later_general,
		                                "wakeup_later_exn",
		                                r,
		                                [1, Closed],
		                                f);
		                      },
		                      res[5],
		                      function(self_1, cont){return cont(self_1[a + 1][4]);},
		                      res[8],
		                      function(self_1, cont){
		                       return cont(0 !== self_1[a + 1][5] ? 1 : 0);
		                      },
		                      res[6],
		                      function(self_1, cont){return cont(self_1[d + 1]);},
		                      res[2],
		                      function(self_1, x, cont){
		                       self_1[a + 1][8] = x;
		                       return cont(0);
		                      }],
		                   len = methods.length - 1,
		                   i = [0, 0];
		                  function e(){
		                   if(i[1] >= len) return cont();
		                   var a = i[1], label = caml_check_bound(methods, a)[a + 1];
		                   return caml_exact_trampoline_cps_call$0
		                           (method_impl,
		                            table,
		                            i,
		                            methods,
		                            function(element){
		                             return caml_exact_trampoline_cps_call$1
		                                     (Labs[17],
		                                      label,
		                                      table[4],
		                                      function(b){
		                                       function a(){i[1]++; return caml_exact_trampoline_call0(e);}
		                                       return b
		       ? caml_exact_trampoline_cps_call$1
		         (resize$1,
		          table,
		          label + 1 | 0,
		          function(b){
		           caml_check_bound(table[2], label)[label + 1] = element;
		           return a();
		          })
		       : (table[6] = [0, [0, label, element], table[6]], a());
		                                      });
		                            });
		                  }
		                  return e();
		                 }
		                 function e(i){
		                  return caml_exact_trampoline_cps_call$1
		                          (new_variable,
		                           table,
		                           caml_check_bound(vals, i)[i + 1],
		                           function(a){
		                            var b = i + nmeths | 0;
		                            caml_check_bound(res, b)[b + 1] = a;
		                            a = i + 1 | 0;
		                            return d !== i ? caml_exact_trampoline_call1(e, a) : f();
		                           });
		                 }
		                 return d < 0 ? f() : e(0);
		                }
		                function e(i){
		                 var name = caml_check_bound(shared, i)[i + 1];
		                 function a(a){
		                  caml_check_bound(res, i)[i + 1] = a;
		                  a = i + 1 | 0;
		                  return d !== i ? caml_exact_trampoline_call1(e, a) : f();
		                 }
		                 caml_push_trap
		                  (function(exn){
		                    if(exn === Not_found)
		                     return caml_exact_trampoline_cps_call
		                             (new_method,
		                              table,
		                              function(label){
		                               return caml_exact_trampoline_cps_call$0
		                                       (Meths[2],
		name,
		label,
		table[3],
		function(b){
		 table[3] = b;
		 return caml_exact_trampoline_cps_call$0
		         (Labs[2],
		          label,
		          1,
		          table[4],
		          function(b){table[4] = b; return a(label);});
		});
		                              });
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   });
		                 return caml_exact_trampoline_cps_call$1
		                         (Meths[17],
		                          name,
		                          table[3],
		                          function(b){caml_pop_trap(); return a(b);});
		                }
		                return d < 0 ? f() : e(0);
		               });
		     });
		                                   });
		                         });
		               }
		               var table = caml_callback(create_table, [pub_meths]);
		               caml_callback(class_init, [table]);
		               caml_callback(init_class, [table]);
		               function feed(s, cont){
		                var match = s[1];
		                switch(match[0]){
		                  case 0:
		                   var from = match[1];
		                   return is_sleeping(from[2])
		                           ? cont(protected$(from[2]))
		                           : caml_exact_trampoline_cps_call$1
		                             (catch$,
		                              function(param, cont){
		                               function a(x, cont){
		                                enqueue$0(x, s);
		                                function a(a){return cont(return_unit);}
		                                return 0 === x
		? caml_exact_trampoline_cps_call$1(wakeup, s[2], 0, a)
		: a();
		                               }
		                               return caml_trampoline_cps_call2
		                                       (from[1],
		0,
		function(b){
		 return caml_exact_trampoline_cps_call$1
		         (symbol_bind$6, b, a, cont);
		});
		                              },
		                              function(b, a){
		                               a = caml_pop_trap();
		                               return a(caml_maybe_attach_backtrace(b, 0));
		                              },
		                              function(thread){
		                               from[2] = thread;
		                               return cont(protected$(thread));
		                              });
		                  case 1:
		                   var f = match[1];
		                   return caml_trampoline_cps_call2
		                           (f,
		                            0,
		                            function(x){
		                             enqueue$0(x, s);
		                             function a(a){return cont(return_unit);}
		                             return 0 === x
		                                     ? caml_exact_trampoline_cps_call$1(wakeup, s[2], 0, a)
		                                     : a();
		                            });
		                  case 2:
		                   var push = match[1];
		                   push[2] = 1;
		                   return cont(protected$(push[1]));
		                  default:
		                   var push$0 = match[1];
		                   push$0[2] = 1;
		                   return cont(protected$(push$0[1]));
		                }
		               }
		               function consume(s, node, cont){
		                var a = node === s[4] ? 1 : 0;
		                if(! a) return cont(a);
		                s[4] = node[1];
		                a = s[1];
		                if(3 !== a[0]) return cont();
		                var info = a[1];
		                return 0 === info[5]
		                        ? (info[4] = info[4] - 1 | 0, cont())
		                        : caml_exact_trampoline_cps_call$1
		                          (notify_pusher, info, s[5], cont);
		               }
		               function get_rec(s, node, cont){
		                if(node === s[5][1]){
		                 var
		                  b =
		                    function(param, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (get_rec, s, node, cont);
		                    };
		                 return caml_exact_trampoline_cps_call
		                         (feed,
		                          s,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol_bind$6, a, b, cont);
		                          });
		                }
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (return$10, node[2], cont);
		                }
		                return 0 !== node[2]
		                        ? caml_exact_trampoline_cps_call$1(consume, s, node, a)
		                        : a();
		               }
		               function get$5(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_rec, s, s[4], cont);
		               }
		               function get_exn_rec(s, node, cont){
		                if(node === s[5][1])
		                 return caml_exact_trampoline_cps_call$0
		                         (try_bind,
		                          function(param, cont){
		                           return caml_exact_trampoline_cps_call(feed, s, cont);
		                          },
		                          function(param, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (get_exn_rec, s, node, cont);
		                          },
		                          function(exn, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (return$10, [0, [1, exn]], cont);
		                          },
		                          cont);
		                var match = node[2];
		                if(! match) return cont(return_none);
		                var value = match[1];
		                return caml_exact_trampoline_cps_call$1
		                        (consume,
		                         s,
		                         node,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (return$10, [0, [0, value]], cont);
		                         });
		               }
		               function wrap_exn(s){
		                return from
		                        (function(param, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_exn_rec, s, s[4], cont);
		                         });
		               }
		               function junk_while_rec(node, f, s, cont){
		                function a(node){
		                 if(node === s[5][1]){
		                  var
		                   b =
		                     function(param, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (junk_while_rec, node, f, s, cont);
		                     };
		                  return caml_exact_trampoline_cps_call
		                          (feed,
		                           s,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, a, b, cont);
		                           });
		                 }
		                 if(! node[2]) return cont(return_unit);
		                 var test = f();
		                 return test
		                         ? caml_exact_trampoline_cps_call$1
		                           (consume,
		                            s,
		                            node,
		                            function(b){
		                             var node$0 = node[1];
		                             return caml_exact_trampoline_call1(a, node$0);
		                            })
		                         : cont(return_unit);
		                }
		                return a(node);
		               }
		               function map$20(f, s){
		                return from
		                        (function(param, cont){
		                          function f$0(param, cont){
		                           if(! param) return cont(0);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (f, x, function(x){return cont([0, x]);});
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (get$5,
		                                   s,
		                                   function(p){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$90, f$0, p, cont);
		                                   });
		                         });
		               }
		               function map_s(f, s){
		                return from
		                        (function(param, cont){
		                          function a(param, cont){
		                           if(! param) return cont(return_none);
		                           var x = param[1];
		                           function f$0(x, cont){return cont([0, x]);}
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    x,
		                                    function(p){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$90, f$0, p, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (get$5,
		                                   s,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_bind$6, b, a, cont);
		                                   });
		                         });
		               }
		               function iter_rec(node, f, s, cont){
		                function a(node){
		                 if(node === s[5][1]){
		                  var
		                   b =
		                     function(param, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (iter_rec, node, f, s, cont);
		                     };
		                  return caml_exact_trampoline_cps_call
		                          (feed,
		                           s,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, a, b, cont);
		                           });
		                 }
		                 var match = node[2];
		                 if(! match) return cont(return_unit);
		                 var x = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (consume,
		                          s,
		                          node,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    x,
		                                    function(match){
		                                     var node$0 = node[1];
		                                     return caml_exact_trampoline_call1(a, node$0);
		                                    });
		                          });
		                }
		                return a(node);
		               }
		               function return$11(x, cont){
		                return caml_exact_trampoline_cps_call(return$10, [0, x], cont);
		               }
		               function fail$2(e, cont){
		                return caml_exact_trampoline_cps_call(return$10, [1, e], cont);
		               }
		               function ok$1(x, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$90,
		                         function(y, cont){return cont([0, y]);},
		                         x,
		                         cont);
		               }
		               function map$21(f, e, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$90,
		                         function(param, cont){
		                          if(0 === param[0]){
		                           var x = param[1];
		                           return caml_trampoline_cps_call2
		                                   (f, x, function(a){return cont([0, a]);});
		                          }
		                          var e = param[1];
		                          return cont([1, e]);
		                         },
		                         e,
		                         cont);
		               }
		               function map_error$0(f, e, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$90,
		                         function(param, cont){
		                          if(0 === param[0]){var x = param[1]; return cont([0, x]);}
		                          var e = param[1];
		                          return caml_exact_trampoline_cps_call
		                                  (f, e, function(a){return cont([1, a]);});
		                         },
		                         e,
		                         cont);
		               }
		               function symbol_bind$7(e, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$6,
		                         e,
		                         function(param, cont){
		                          if(0 === param[0]){
		                           var x = param[1];
		                           return caml_trampoline_cps_call2(f, x, cont);
		                          }
		                          var e = param[1];
		                          return caml_exact_trampoline_cps_call
		                                  (return$10, [1, e], cont);
		                         },
		                         cont);
		               }
		               function iter_s(f, l, cont){
		                if(! l) return cont(return_unit);
		                var l$0 = l[2], x = l[1];
		                function a(param, cont){
		                 return caml_exact_trampoline_cps_call$1(iter_s, f, l$0, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (apply$0,
		                         f,
		                         x,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function fold_left_s(f, acc, l, cont){
		                if(! l)
		                 return caml_exact_trampoline_cps_call(return$10, acc, cont);
		                var l$0 = l[2], x = l[1];
		                function a(acc, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (fold_left_s, f, acc, l$0, cont);
		                }
		                return caml_trampoline_cps_call2
		                        (f,
		                         acc,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (apply$0,
		                                   b,
		                                   x,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_bind$6, b, a, cont);
		                                   });
		                         });
		               }
		               function create_empty(a){
		                a = create$19();
		                return [0, 0, create$19(), a];
		               }
		               function put(mvar, v, cont){
		                if(mvar[1]){
		                 var
		                  a = task(),
		                  w = a[2],
		                  res = a[1],
		                  node = add_r([0, v, w], mvar[2]);
		                 return caml_exact_trampoline_cps_call$1
		                         (on_cancel,
		                          res,
		                          function(param, cont){return cont(remove$5(node));},
		                          function(a){return cont(res);});
		                }
		                a = take_opt_l(mvar[3]);
		                function b(a){return cont(return_unit);}
		                if(a){
		                 var w$0 = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (wakeup_later, w$0, v, b);
		                }
		                mvar[1] = [0, v];
		                return b();
		               }
		               function take$3(mvar, cont){
		                var a = mvar[1];
		                function c(match){
		                 if(! match) return cont(add_task_r(mvar[3]));
		                 var v = match[1];
		                 return caml_exact_trampoline_cps_call(return$10, v, cont);
		                }
		                if(! a) return c(0);
		                var v$0 = a[1], a = take_opt_l(mvar[2]);
		                function b(a){return c([0, v$0]);}
		                if(a){
		                 a = a[1];
		                 var w = a[2], v = a[1];
		                 mvar[1] = [0, v];
		                 return caml_exact_trampoline_cps_call$1
		                         (wakeup_later, w, 0, b);
		                }
		                mvar[1] = 0;
		                return b();
		               }
		               function create$21(param){return [0, 0, create$19()];}
		               function lock(m){
		                return m[1] ? add_task_r(m[2]) : (m[1] = 1, return_unit);
		               }
		               function unlock(m, a){
		                var b = m[1];
		                if(! b) return a(b);
		                if(is_empty$7(m[2])){m[1] = 0; return a();}
		                var seq = m[2];
		                if(is_empty$7(seq)){
		                 a = caml_pop_trap();
		                 var Empty$0 = caml_maybe_attach_backtrace(Empty, 1);
		                 return a(Empty$0);
		                }
		                var node = seq[2];
		                remove$5(node);
		                return caml_exact_trampoline_cps_call$1
		                        (wakeup_later, node[3], 0, a);
		               }
		               function with_lock(m, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$6,
		                         lock(m),
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (finalize,
		                                   f,
		                                   function(param, cont){
		                                    return caml_exact_trampoline_cps_call
		    (unlock, m, function(a){return cont(return_unit);});
		                                   },
		                                   cont);
		                         },
		                         cont);
		               }
		               function is_empty$8(m){return is_empty$7(m[2]);}
		               function wait$0(mutex, cvar, cont){
		                var waiter = add_task_r(cvar);
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (finalize,
		                          function(param, cont){return cont(waiter);},
		                          function(param, cont){
		                           if(! mutex) return cont(return_unit);
		                           var m = mutex[1];
		                           return cont(lock(m));
		                          },
		                          cont);
		                }
		                if(! mutex) return a();
		                var m = mutex[1];
		                return caml_exact_trampoline_cps_call(unlock, m, a);
		               }
		               function broadcast(cvar, arg, cont){
		                var curr$5 = cvar[1], curr$2 = curr$5, wakeners = 0;
		                for(;;){
		                 if(curr$2 === cvar) break;
		                 if(curr$2[4]){
		                  var
		                   x = curr$2[3],
		                   acc = [0, x, wakeners],
		                   curr$3 = curr$2[1];
		                  curr$2 = curr$3;
		                  wakeners = acc;
		                 }
		                 else {var curr$4 = curr$2[1]; curr$2 = curr$4;}
		                }
		                var curr$1 = cvar[2], curr = curr$1;
		                for(;;){
		                 var
		                  a =
		                    function(param){
		                     if(! param) return cont(0);
		                     var l = param[2], wakener = param[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (wakeup_later,
		                              wakener,
		                              arg,
		                              function(a){return caml_exact_trampoline_call1(b, l);});
		                    };
		                 let b = a;
		                 if(curr === cvar) return a(wakeners);
		                 if(curr[4]) remove$5(curr);
		                 var curr$0 = curr[2];
		                 curr = curr$0;
		                }
		               }
		               function bind$9(v, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$6, v, f, cont);
		               }
		               var
		                map$22 =
		                  [0,
		                   ,
		                   function(v, f, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol$90, f, v, cont);
		                   }],
		                include$36 = Make([0, bind$9, return$10, map$22]),
		                symbol_bind$8 = include$36[1],
		                symbol_map$6 = include$36[2],
		                bind$10 = include$36[4],
		                return$12 = include$36[5],
		                map$23 = include$36[6],
		                Let_syntax$4 = include$36[11];
		               function bind$11(v, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$7, v, f, cont);
		               }
		               var
		                map$24 =
		                  [0,
		                   ,
		                   function(v, f, cont){
		                    return caml_exact_trampoline_cps_call$1(map$21, f, v, cont);
		                   }],
		                bQR =
		                  Monadic
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4])
		                   [2],
		                include$37 = Make2([0, bind$11, map$24, return$11]),
		                symbol_bind$9 = include$37[1],
		                symbol_map$7 = include$37[2],
		                Let_syntax$5 = include$37[3],
		                bind$12 = include$37[5],
		                return$13 = include$37[6],
		                map$25 = include$37[7],
		                open =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$ = open[3],
		                let$0 = open[4];
		               function protect$0(t, reason, acquire, release, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (acquire,
		                         reason,
		                         t,
		                         function(b){
		                          if(b)
		                           return caml_exact_trampoline_cps_call$1
		                                   (catch$,
		                                    function(param, cont){
		                                     function a(res, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (release,
		       reason,
		       t,
		       function(b){
		        function a(a){return cont(res);}
		        return b
		                ? caml_exact_trampoline_cps_call$1(broadcast, t[1], 0, a)
		                : a();
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (f,
		      dummy,
		      function(b){
		       return caml_trampoline_cps_call3(let$0, b, a, cont);
		      });
		                                    },
		                                    function(e, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (release,
		      reason,
		      t,
		      function(b){
		       function a(a){
		        return cont(raise_with_original_backtrace(e));
		       }
		       return b
		               ? caml_exact_trampoline_cps_call$1(broadcast, t[1], 0, a)
		               : a();
		      });
		                                    },
		                                    cont);
		                          function a(param, cont){
		                           return caml_exact_trampoline_cps_call$3
		                                   (protect$0, t, reason, acquire, release, f, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (wait$0,
		                                   0,
		                                   t[1],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               }
		               function pp_reason(ppf, param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_none, ppf, dummy, cont);
		                var v = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         ppf,
		                         cst$9,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, ppf, v, cont);
		                         });
		               }
		               function acquire_read(reason, t, cont){
		                var a = t[3];
		                if(typeof a !== "number"){
		                 var
		                  n = a[1],
		                  a = t[2],
		                  d = function(a){t[3] = [0, n + 1 | 0]; return cont(1);};
		                 if(! a) return d(0);
		                 var name$1 = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (info,
		                          [0, logs_src],
		                          function(m, cont){
		                           return caml_trampoline_cps_call7
		                                   (m, 0, 0, m9, name$1, pp_reason, reason, cont);
		                          },
		                          d);
		                }
		                if(a){
		                 a = t[2];
		                 var b = function(a){return cont(0);};
		                 if(! a) return b(0);
		                 var name = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (info,
		                          [0, logs_src],
		                          function(m, cont){
		                           return caml_trampoline_cps_call7
		                                   (m, 0, 0, m6, name, pp_reason, reason, cont);
		                          },
		                          b);
		                }
		                a = t[2];
		                function c(a){t[3] = m8; return cont(1);}
		                if(! a) return c();
		                var name$0 = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (info,
		                         [0, logs_src],
		                         function(m, cont){
		                          return caml_trampoline_cps_call7
		                                  (m, 0, 0, m7, name$0, pp_reason, reason, cont);
		                         },
		                         c);
		               }
		               function arg$0(reason, t, cont){
		                var a = t[3];
		                if(typeof a === "number")
		                 return caml_exact_trampoline_cps_call
		                         (failwith,
		                          "invalid read-releasing a rw-mutex locked for writing",
		                          cont);
		                var n = a[1];
		                if(1 === n){
		                 a = t[2];
		                 var c = function(a){t[3] = 0; return cont(1);};
		                 if(! a) return c(0);
		                 var name = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (info,
		                          [0, logs_src],
		                          function(m, cont){
		                           return caml_trampoline_cps_call7
		                                   (m, 0, 0, m_, name, pp_reason, reason, cont);
		                          },
		                          c);
		                }
		                a = t[2];
		                function b(a){t[3] = [0, n - 1 | 0]; return cont(0);}
		                if(! a) return b();
		                var name$0 = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (info,
		                         [0, logs_src],
		                         function(m, cont){
		                          return caml_trampoline_cps_call7
		                                  (m, 0, 0, m$, name$0, pp_reason, reason, cont);
		                         },
		                         b);
		               }
		               function empty$15(param){var ctor = Map; return new ctor;}
		               function of_map(key, data, map, cont){
		                var res = empty$15();
		                function f(k, d, cont){
		                 return caml_exact_trampoline_cps_call
		                         (key,
		                          k,
		                          function(key){
		                           return caml_exact_trampoline_cps_call
		                                   (data, d, function(data){return cont(res.set(key, data));});
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (iteri$1, map, f, function(match){return cont(res);});
		               }
		               var Promise = global.Promise;
		               function of_lwt(p){
		                o
		                 ([0,
		                   symbol_bind$9,
		                   symbol_map$7,
		                   Let_syntax$5,
		                   ,
		                   bind$12,
		                   return$13,
		                   map$25]);
		                var
		                 t8 =
		                   caml_js_wrap_callback
		                    (function(resolve, reject, cont){
		                      function p$0(param, cont){
		                       function a(v, cont){
		                        return caml_trampoline_cps_call2
		                                (return$12, resolve(v), cont);
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (p,
		                                dummy,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call$1
		 (symbol_bind$8, b, a, cont);
		                                });
		                      }
		                      return caml_exact_trampoline_cps_call$1
		                              (catch$,
		                               p$0,
		                               function(e, cont){
		                                return caml_exact_trampoline_cps_call
		(to_string$0,
		 e,
		 function(msg){
		  var t6 = caml_jsstring_of_string(msg);
		  reject(new error_constr(t6));
		  return caml_trampoline_cps_call2(return$12, 0, cont);
		 });
		                               },
		                               cont);
		                     });
		                return new Promise(t8);
		               }
		               var null$1 = null, undefined$0 = undefined;
		               function is_none$1(v){
		                var a = v === null$1 ? 1 : 0;
		                return a ? a : v === undefined$0 ? 1 : 0;
		               }
		               function is_some$1(v){return 1 - is_none$1(v);}
		               var global$0 = globalThis;
		               function find_path(o$1, a){
		                var o = o$1;
		                for(;;){
		                 if(! a) return;
		                 var
		                  ps = a[2],
		                  p = a[1],
		                  v = o[p],
		                  a = is_none$1(v) ? 0 : [0, v];
		                 if(! a) return;
		                 var o$0 = a[1];
		                 o = o$0;
		                 a = ps;
		                }
		               }
		               function set_if_some(o, p, param){
		                if(! param) return;
		                var f = param[1];
		                o[p] = f;
		               }
		               function is_array(jv){return global$0.Array.isArray(jv) | 0;}
		               function create$22(n){return new global$0.Array(n);}
		               function to_list$5(conv, v, cont){
		                var len = v.length;
		                function f(i, cont){
		                 return caml_exact_trampoline_cps_call(conv, v[i], cont);
		                }
		                if(0 > len)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, "List.init", cont);
		                var last = len - 1 | 0;
		                if(last < 0) return cont(0);
		                var i = 0;
		                if(0 !== last)
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          i,
		                          function(r1){
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    1,
		                                    function(r2){
		                                     var block = [0, r2, 24029];
		                                     function a(dst, offset, i){
		                                      function b(){return cont([0, r1, block]);}
		                                      if(last < i){dst[offset + 1] = 0; return b();}
		                                      if(i !== last)
		                                       return caml_exact_trampoline_cps_call
		       (f,
		        i,
		        function(r1){
		         return caml_exact_trampoline_cps_call
		                 (f,
		                  i + 1 | 0,
		                  function(r2){
		                   var dst$0 = [0, r2, 24029];
		                   dst[offset + 1] = [0, r1, dst$0];
		                   var i$0 = i + 2 | 0;
		                   return caml_exact_trampoline_call3(a, dst$0, 1, i$0);
		                  });
		        });
		                                      return caml_exact_trampoline_cps_call
		      (f,
		       i,
		       function(a){dst[offset + 1] = [0, a, 0]; return b();});
		                                     }
		                                     return a(block, 1, 2);
		                                    });
		                          });
		                return caml_exact_trampoline_cps_call
		                        (f, i, function(a){return cont([0, a, 0]);});
		               }
		               function v$3(name, msg){
		                var e = new global$0.Error(msg);
		                if(! name) return e;
		                var n = name[1];
		                e.name = n;
		                return e;
		               }
		               function throw$(name, msg, cont){
		                var e = v$3(name, msg);
		                return caml_trampoline_cps_call2
		                        (function(exn){throw exn;}, e, cont);
		               }
		               var promise = global$0.Promise;
		               function obj(props){
		                return caml_js_object
		                        (map$2
		                          (function(param){
		                            var v = param[2], p = param[1];
		                            return [0, caml_string_of_jsstring(p), v];
		                           },
		                           props));
		               }
		               function has(p, v){return is_some$1(v[p]);}
		               function listen$0(opt, type, f, t){
		                var
		                 opts = {},
		                 f$0 = caml_js_wrap_callback_strict(1, f);
		                t.addEventListener(type, f$0, opts);
		               }
		               var bPz = [0, 0];
		               function bQS(symbol){
		                function reduce(a, param){return 0;}
		                var
		                 bind = include$0[4],
		                 return$ = include$0[5],
		                 map = include$0[6],
		                 callbacks = empty$11([0, comparator$4]),
		                 empty =
		                   [0,
		                    callbacks,
		                    function(param, cont){
		                     function a(){
		                      return caml_trampoline_cps_call2(bPz[1], 0, cont);
		                     }
		                     return bPz[1]
		                             ? a()
		                             : caml_exact_trampoline_cps_call
		                               (create_table,
		                                0,
		                                function(b){
		                                 function c(a, cont){return cont(create_object_opt(0, b));}
		                                 return caml_exact_trampoline_cps_call
		 (init_class, b, function(b){bPz[1] = c; return a();});
		                                });
		                    },
		                    function(v, f, cont){
		                     return caml_trampoline_cps_call3(bind, v, f, cont);
		                    },
		                    return$,
		                    function(acc, value, cont){
		                     return caml_trampoline_cps_call3
		                             (map,
		                              acc,
		                              function(acc, cont){return cont(reduce());},
		                              cont);
		                    },
		                    function(a, cont){return cont(a[2]);}];
		                return [0, empty];
		               }
		               function bQT(a){
		                a = Make2$0(a);
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        a[3],
		                        ,
		                        a[8],
		                        ,
		                        ,
		                        a[25],
		                        a[5],
		                        a[6],
		                        ,
		                        a[27],
		                        ,
		                        ,
		                        ,
		                        ,
		                        a[16],
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        a[12],
		                        ,
		                        [0, , , , , a[24][7]]];
		               }
		               function bQU(M1){
		                var
		                 bind = M1[4],
		                 return$ = M1[5],
		                 map = [0, , M1[6]],
		                 include = Make2([0, bind, map, return$]),
		                 symbol_bind = include[1],
		                 symbol_map = include[2],
		                 return$0 = include[6],
		                 map$0 = include[7],
		                 include$0 =
		                   Make2$0([0, symbol_bind, symbol_map, , , , return$0, map$0]),
		                 unfold_step = include$0[4],
		                 find = include$0[21];
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        unfold_step,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        find];
		               }
		               function call$0(c, meth, args){
		                caml_js_meth_call(c, meth, args);
		               }
		               var bPA = global$0.console;
		               function msg_to_jv_array(msg){
		                var a = create$22(0), i = 0, param = msg;
		                for(;;){
		                 if(! param) return caml_js_to_array(a);
		                 var vs = param[2], v = param[1];
		                 a[i] = v;
		                 var i$0 = i + 1 | 0;
		                 i = i$0;
		                 param = vs;
		                }
		               }
		               var navigator = global$0.navigator;
		               function post(opt, p, v){
		                var opts = undefined$0;
		                p.postMessage(v, opts);
		                return 0;
		               }
		               var shared$0 = global$0.SharedWorker;
		               create$2(char, c_layout, 0);
		               var nil = [0];
		               function get$6(m, u){
		                var l1 = m[2][(u >>> 12 | 0) + 1];
		                if(l1 === nil) return m[1];
		                var l2 = l1[((u >>> 8 | 0) & 15) + 1];
		                if(l2 === cst$1) return m[1];
		                var
		                 k = u & 255,
		                 byte_num = k >>> 3 | 0,
		                 bit_num = k & 7,
		                 byte = caml_string_unsafe_get(l2, byte_num);
		                return 0 < (byte & 1 << bit_num) ? 1 : 0;
		               }
		               var
		                nil$0 = [0],
		                bQV =
		                  [0,
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     0,
		                     [0, 97, 0],
		                     [0, 98, 0],
		                     [0, 99, 0],
		                     [0, 100, 0],
		                     [0, 101, 0],
		                     [0, 102, 0],
		                     [0, 103, 0],
		                     [0, 104, 0],
		                     [0, 105, 0],
		                     [0, 106, 0],
		                     [0, 107, 0],
		                     [0, 108, 0],
		                     [0, 109, 0],
		                     [0, 110, 0],
		                     [0, 111, 0]],
		                    [0,
		                     [0, 112, 0],
		                     [0, 113, 0],
		                     [0, 114, 0],
		                     [0, 115, 0],
		                     [0, 116, 0],
		                     [0, 117, 0],
		                     [0, 118, 0],
		                     [0, 119, 0],
		                     [0, 120, 0],
		                     [0, 121, 0],
		                     [0, 122, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 224, 0],
		                     [0, 225, 0],
		                     [0, 226, 0],
		                     [0, 227, 0],
		                     [0, 228, 0],
		                     [0, 229, 0],
		                     [0, 230, 0],
		                     [0, 231, 0],
		                     [0, 232, 0],
		                     [0, 233, 0],
		                     [0, 234, 0],
		                     [0, 235, 0],
		                     [0, 236, 0],
		                     [0, 237, 0],
		                     [0, 238, 0],
		                     [0, 239, 0]],
		                    [0,
		                     [0, 240, 0],
		                     [0, 241, 0],
		                     [0, 242, 0],
		                     [0, 243, 0],
		                     [0, 244, 0],
		                     [0, 245, 0],
		                     [0, 246, 0],
		                     0,
		                     [0, 248, 0],
		                     [0, 249, 0],
		                     [0, 250, 0],
		                     [0, 251, 0],
		                     [0, 252, 0],
		                     [0, 253, 0],
		                     [0, 254, 0],
		                     0],
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 257, 0],
		                     0,
		                     [0, 259, 0],
		                     0,
		                     [0, 261, 0],
		                     0,
		                     [0, 263, 0],
		                     0,
		                     [0, 265, 0],
		                     0,
		                     [0, 267, 0],
		                     0,
		                     [0, 269, 0],
		                     0,
		                     [0, 271, 0],
		                     0],
		                    [0,
		                     [0, 273, 0],
		                     0,
		                     [0, 275, 0],
		                     0,
		                     [0, 277, 0],
		                     0,
		                     [0, 279, 0],
		                     0,
		                     [0, 281, 0],
		                     0,
		                     [0, 283, 0],
		                     0,
		                     [0, 285, 0],
		                     0,
		                     [0, 287, 0],
		                     0],
		                    [0,
		                     [0, 289, 0],
		                     0,
		                     [0, 291, 0],
		                     0,
		                     [0, 293, 0],
		                     0,
		                     [0, 295, 0],
		                     0,
		                     [0, 297, 0],
		                     0,
		                     [0, 299, 0],
		                     0,
		                     [0, 301, 0],
		                     0,
		                     [0, 303, 0],
		                     0],
		                    [0,
		                     [0, 105, [0, 775, 0]],
		                     0,
		                     [0, 307, 0],
		                     0,
		                     [0, 309, 0],
		                     0,
		                     [0, 311, 0],
		                     0,
		                     0,
		                     [0, 314, 0],
		                     0,
		                     [0, 316, 0],
		                     0,
		                     [0, 318, 0],
		                     0,
		                     [0, 320, 0]],
		                    [0,
		                     0,
		                     [0, 322, 0],
		                     0,
		                     [0, 324, 0],
		                     0,
		                     [0, 326, 0],
		                     0,
		                     [0, 328, 0],
		                     0,
		                     0,
		                     [0, 331, 0],
		                     0,
		                     [0, 333, 0],
		                     0,
		                     [0, 335, 0],
		                     0],
		                    [0,
		                     [0, 337, 0],
		                     0,
		                     [0, 339, 0],
		                     0,
		                     [0, 341, 0],
		                     0,
		                     [0, 343, 0],
		                     0,
		                     [0, 345, 0],
		                     0,
		                     [0, 347, 0],
		                     0,
		                     [0, 349, 0],
		                     0,
		                     [0, 351, 0],
		                     0],
		                    [0,
		                     [0, 353, 0],
		                     0,
		                     [0, 355, 0],
		                     0,
		                     [0, 357, 0],
		                     0,
		                     [0, 359, 0],
		                     0,
		                     [0, 361, 0],
		                     0,
		                     [0, 363, 0],
		                     0,
		                     [0, 365, 0],
		                     0,
		                     [0, 367, 0],
		                     0],
		                    [0,
		                     [0, 369, 0],
		                     0,
		                     [0, 371, 0],
		                     0,
		                     [0, 373, 0],
		                     0,
		                     [0, 375, 0],
		                     0,
		                     [0, 255, 0],
		                     [0, 378, 0],
		                     0,
		                     [0, 380, 0],
		                     0,
		                     [0, 382, 0],
		                     0,
		                     0],
		                    [0,
		                     0,
		                     [0, 595, 0],
		                     [0, 387, 0],
		                     0,
		                     [0, 389, 0],
		                     0,
		                     [0, 596, 0],
		                     [0, 392, 0],
		                     0,
		                     [0, 598, 0],
		                     [0, 599, 0],
		                     [0, 396, 0],
		                     0,
		                     0,
		                     [0, 477, 0],
		                     [0, 601, 0]],
		                    [0,
		                     [0, 603, 0],
		                     [0, 402, 0],
		                     0,
		                     [0, 608, 0],
		                     [0, 611, 0],
		                     0,
		                     [0, 617, 0],
		                     [0, 616, 0],
		                     [0, 409, 0],
		                     0,
		                     0,
		                     0,
		                     [0, 623, 0],
		                     [0, 626, 0],
		                     0,
		                     [0, 629, 0]],
		                    [0,
		                     [0, 417, 0],
		                     0,
		                     [0, 419, 0],
		                     0,
		                     [0, 421, 0],
		                     0,
		                     [0, 640, 0],
		                     [0, 424, 0],
		                     0,
		                     [0, 643, 0],
		                     0,
		                     0,
		                     [0, 429, 0],
		                     0,
		                     [0, 648, 0],
		                     [0, 432, 0]],
		                    [0,
		                     0,
		                     [0, 650, 0],
		                     [0, 651, 0],
		                     [0, 436, 0],
		                     0,
		                     [0, 438, 0],
		                     0,
		                     [0, 658, 0],
		                     [0, 441, 0],
		                     0,
		                     0,
		                     0,
		                     [0, 445, 0],
		                     0,
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 454, 0],
		                     [0, 454, 0],
		                     0,
		                     [0, 457, 0],
		                     [0, 457, 0],
		                     0,
		                     [0, 460, 0],
		                     [0, 460, 0],
		                     0,
		                     [0, 462, 0],
		                     0,
		                     [0, 464, 0]],
		                    [0,
		                     0,
		                     [0, 466, 0],
		                     0,
		                     [0, 468, 0],
		                     0,
		                     [0, 470, 0],
		                     0,
		                     [0, 472, 0],
		                     0,
		                     [0, 474, 0],
		                     0,
		                     [0, 476, 0],
		                     0,
		                     0,
		                     [0, 479, 0],
		                     0],
		                    [0,
		                     [0, 481, 0],
		                     0,
		                     [0, 483, 0],
		                     0,
		                     [0, 485, 0],
		                     0,
		                     [0, 487, 0],
		                     0,
		                     [0, 489, 0],
		                     0,
		                     [0, 491, 0],
		                     0,
		                     [0, 493, 0],
		                     0,
		                     [0, 495, 0],
		                     0],
		                    [0,
		                     0,
		                     [0, 499, 0],
		                     [0, 499, 0],
		                     0,
		                     [0, 501, 0],
		                     0,
		                     [0, 405, 0],
		                     [0, 447, 0],
		                     [0, 505, 0],
		                     0,
		                     [0, 507, 0],
		                     0,
		                     [0, 509, 0],
		                     0,
		                     [0, 511, 0],
		                     0],
		                    [0,
		                     [0, 513, 0],
		                     0,
		                     [0, 515, 0],
		                     0,
		                     [0, 517, 0],
		                     0,
		                     [0, 519, 0],
		                     0,
		                     [0, 521, 0],
		                     0,
		                     [0, 523, 0],
		                     0,
		                     [0, 525, 0],
		                     0,
		                     [0, 527, 0],
		                     0],
		                    [0,
		                     [0, 529, 0],
		                     0,
		                     [0, 531, 0],
		                     0,
		                     [0, 533, 0],
		                     0,
		                     [0, 535, 0],
		                     0,
		                     [0, 537, 0],
		                     0,
		                     [0, 539, 0],
		                     0,
		                     [0, 541, 0],
		                     0,
		                     [0, 543, 0],
		                     0],
		                    [0,
		                     [0, 414, 0],
		                     0,
		                     [0, 547, 0],
		                     0,
		                     [0, 549, 0],
		                     0,
		                     [0, 551, 0],
		                     0,
		                     [0, 553, 0],
		                     0,
		                     [0, 555, 0],
		                     0,
		                     [0, 557, 0],
		                     0,
		                     [0, 559, 0],
		                     0],
		                    [0,
		                     [0, 561, 0],
		                     0,
		                     [0, 563, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 11365, 0],
		                     [0, 572, 0],
		                     0,
		                     [0, 410, 0],
		                     [0, 11366, 0],
		                     0],
		                    [0,
		                     0,
		                     [0, 578, 0],
		                     0,
		                     [0, 384, 0],
		                     [0, 649, 0],
		                     [0, 652, 0],
		                     [0, 583, 0],
		                     0,
		                     [0, 585, 0],
		                     0,
		                     [0, 587, 0],
		                     0,
		                     [0, 589, 0],
		                     0,
		                     [0, 591, 0],
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 881, 0],
		                     0,
		                     [0, 883, 0],
		                     0,
		                     0,
		                     0,
		                     [0, 887, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 1011, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 940, 0],
		                     0,
		                     [0, 941, 0],
		                     [0, 942, 0],
		                     [0, 943, 0],
		                     0,
		                     [0, 972, 0],
		                     0,
		                     [0, 973, 0],
		                     [0, 974, 0]],
		                    [0,
		                     0,
		                     [0, 945, 0],
		                     [0, 946, 0],
		                     [0, 947, 0],
		                     [0, 948, 0],
		                     [0, 949, 0],
		                     [0, 950, 0],
		                     [0, 951, 0],
		                     [0, 952, 0],
		                     [0, 953, 0],
		                     [0, 954, 0],
		                     [0, 955, 0],
		                     [0, 956, 0],
		                     [0, 957, 0],
		                     [0, 958, 0],
		                     [0, 959, 0]],
		                    [0,
		                     [0, 960, 0],
		                     [0, 961, 0],
		                     0,
		                     [0, 963, 0],
		                     [0, 964, 0],
		                     [0, 965, 0],
		                     [0, 966, 0],
		                     [0, 967, 0],
		                     [0, 968, 0],
		                     [0, 969, 0],
		                     [0, 970, 0],
		                     [0, 971, 0],
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 983, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 985, 0],
		                     0,
		                     [0, 987, 0],
		                     0,
		                     [0, 989, 0],
		                     0,
		                     [0, 991, 0],
		                     0],
		                    [0,
		                     [0, 993, 0],
		                     0,
		                     [0, 995, 0],
		                     0,
		                     [0, 997, 0],
		                     0,
		                     [0, 999, 0],
		                     0,
		                     [0, 1001, 0],
		                     0,
		                     [0, 1003, 0],
		                     0,
		                     [0, 1005, 0],
		                     0,
		                     [0, 1007, 0],
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 952, 0],
		                     0,
		                     0,
		                     [0, 1016, 0],
		                     0,
		                     [0, 1010, 0],
		                     [0, 1019, 0],
		                     0,
		                     0,
		                     [0, 891, 0],
		                     [0, 892, 0],
		                     [0, 893, 0]],
		                    [0,
		                     [0, 1104, 0],
		                     [0, 1105, 0],
		                     [0, 1106, 0],
		                     [0, 1107, 0],
		                     [0, 1108, 0],
		                     [0, 1109, 0],
		                     [0, 1110, 0],
		                     [0, 1111, 0],
		                     [0, 1112, 0],
		                     [0, 1113, 0],
		                     [0, 1114, 0],
		                     [0, 1115, 0],
		                     [0, 1116, 0],
		                     [0, 1117, 0],
		                     [0, 1118, 0],
		                     [0, 1119, 0]],
		                    [0,
		                     [0, 1072, 0],
		                     [0, 1073, 0],
		                     [0, 1074, 0],
		                     [0, 1075, 0],
		                     [0, 1076, 0],
		                     [0, 1077, 0],
		                     [0, 1078, 0],
		                     [0, 1079, 0],
		                     [0, 1080, 0],
		                     [0, 1081, 0],
		                     [0, 1082, 0],
		                     [0, 1083, 0],
		                     [0, 1084, 0],
		                     [0, 1085, 0],
		                     [0, 1086, 0],
		                     [0, 1087, 0]],
		                    [0,
		                     [0, 1088, 0],
		                     [0, 1089, 0],
		                     [0, 1090, 0],
		                     [0, 1091, 0],
		                     [0, 1092, 0],
		                     [0, 1093, 0],
		                     [0, 1094, 0],
		                     [0, 1095, 0],
		                     [0, 1096, 0],
		                     [0, 1097, 0],
		                     [0, 1098, 0],
		                     [0, 1099, 0],
		                     [0, 1100, 0],
		                     [0, 1101, 0],
		                     [0, 1102, 0],
		                     [0, 1103, 0]],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 1121, 0],
		                     0,
		                     [0, 1123, 0],
		                     0,
		                     [0, 1125, 0],
		                     0,
		                     [0, 1127, 0],
		                     0,
		                     [0, 1129, 0],
		                     0,
		                     [0, 1131, 0],
		                     0,
		                     [0, 1133, 0],
		                     0,
		                     [0, 1135, 0],
		                     0],
		                    [0,
		                     [0, 1137, 0],
		                     0,
		                     [0, 1139, 0],
		                     0,
		                     [0, 1141, 0],
		                     0,
		                     [0, 1143, 0],
		                     0,
		                     [0, 1145, 0],
		                     0,
		                     [0, 1147, 0],
		                     0,
		                     [0, 1149, 0],
		                     0,
		                     [0, 1151, 0],
		                     0],
		                    [0,
		                     [0, 1153, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 1163, 0],
		                     0,
		                     [0, 1165, 0],
		                     0,
		                     [0, 1167, 0],
		                     0],
		                    [0,
		                     [0, 1169, 0],
		                     0,
		                     [0, 1171, 0],
		                     0,
		                     [0, 1173, 0],
		                     0,
		                     [0, 1175, 0],
		                     0,
		                     [0, 1177, 0],
		                     0,
		                     [0, 1179, 0],
		                     0,
		                     [0, 1181, 0],
		                     0,
		                     [0, 1183, 0],
		                     0],
		                    [0,
		                     [0, 1185, 0],
		                     0,
		                     [0, 1187, 0],
		                     0,
		                     [0, 1189, 0],
		                     0,
		                     [0, 1191, 0],
		                     0,
		                     [0, 1193, 0],
		                     0,
		                     [0, 1195, 0],
		                     0,
		                     [0, 1197, 0],
		                     0,
		                     [0, 1199, 0],
		                     0],
		                    [0,
		                     [0, 1201, 0],
		                     0,
		                     [0, 1203, 0],
		                     0,
		                     [0, 1205, 0],
		                     0,
		                     [0, 1207, 0],
		                     0,
		                     [0, 1209, 0],
		                     0,
		                     [0, 1211, 0],
		                     0,
		                     [0, 1213, 0],
		                     0,
		                     [0, 1215, 0],
		                     0],
		                    [0,
		                     [0, 1231, 0],
		                     [0, 1218, 0],
		                     0,
		                     [0, 1220, 0],
		                     0,
		                     [0, 1222, 0],
		                     0,
		                     [0, 1224, 0],
		                     0,
		                     [0, 1226, 0],
		                     0,
		                     [0, 1228, 0],
		                     0,
		                     [0, 1230, 0],
		                     0,
		                     0],
		                    [0,
		                     [0, 1233, 0],
		                     0,
		                     [0, 1235, 0],
		                     0,
		                     [0, 1237, 0],
		                     0,
		                     [0, 1239, 0],
		                     0,
		                     [0, 1241, 0],
		                     0,
		                     [0, 1243, 0],
		                     0,
		                     [0, 1245, 0],
		                     0,
		                     [0, 1247, 0],
		                     0],
		                    [0,
		                     [0, 1249, 0],
		                     0,
		                     [0, 1251, 0],
		                     0,
		                     [0, 1253, 0],
		                     0,
		                     [0, 1255, 0],
		                     0,
		                     [0, 1257, 0],
		                     0,
		                     [0, 1259, 0],
		                     0,
		                     [0, 1261, 0],
		                     0,
		                     [0, 1263, 0],
		                     0],
		                    [0,
		                     [0, 1265, 0],
		                     0,
		                     [0, 1267, 0],
		                     0,
		                     [0, 1269, 0],
		                     0,
		                     [0, 1271, 0],
		                     0,
		                     [0, 1273, 0],
		                     0,
		                     [0, 1275, 0],
		                     0,
		                     [0, 1277, 0],
		                     0,
		                     [0, 1279, 0],
		                     0],
		                    [0,
		                     [0, 1281, 0],
		                     0,
		                     [0, 1283, 0],
		                     0,
		                     [0, 1285, 0],
		                     0,
		                     [0, 1287, 0],
		                     0,
		                     [0, 1289, 0],
		                     0,
		                     [0, 1291, 0],
		                     0,
		                     [0, 1293, 0],
		                     0,
		                     [0, 1295, 0],
		                     0],
		                    [0,
		                     [0, 1297, 0],
		                     0,
		                     [0, 1299, 0],
		                     0,
		                     [0, 1301, 0],
		                     0,
		                     [0, 1303, 0],
		                     0,
		                     [0, 1305, 0],
		                     0,
		                     [0, 1307, 0],
		                     0,
		                     [0, 1309, 0],
		                     0,
		                     [0, 1311, 0],
		                     0],
		                    [0,
		                     [0, 1313, 0],
		                     0,
		                     [0, 1315, 0],
		                     0,
		                     [0, 1317, 0],
		                     0,
		                     [0, 1319, 0],
		                     0,
		                     [0, 1321, 0],
		                     0,
		                     [0, 1323, 0],
		                     0,
		                     [0, 1325, 0],
		                     0,
		                     [0, 1327, 0],
		                     0],
		                    [0,
		                     0,
		                     [0, 1377, 0],
		                     [0, 1378, 0],
		                     [0, 1379, 0],
		                     [0, 1380, 0],
		                     [0, 1381, 0],
		                     [0, 1382, 0],
		                     [0, 1383, 0],
		                     [0, 1384, 0],
		                     [0, 1385, 0],
		                     [0, 1386, 0],
		                     [0, 1387, 0],
		                     [0, 1388, 0],
		                     [0, 1389, 0],
		                     [0, 1390, 0],
		                     [0, 1391, 0]],
		                    [0,
		                     [0, 1392, 0],
		                     [0, 1393, 0],
		                     [0, 1394, 0],
		                     [0, 1395, 0],
		                     [0, 1396, 0],
		                     [0, 1397, 0],
		                     [0, 1398, 0],
		                     [0, 1399, 0],
		                     [0, 1400, 0],
		                     [0, 1401, 0],
		                     [0, 1402, 0],
		                     [0, 1403, 0],
		                     [0, 1404, 0],
		                     [0, 1405, 0],
		                     [0, 1406, 0],
		                     [0, 1407, 0]],
		                    [0,
		                     [0, 1408, 0],
		                     [0, 1409, 0],
		                     [0, 1410, 0],
		                     [0, 1411, 0],
		                     [0, 1412, 0],
		                     [0, 1413, 0],
		                     [0, 1414, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 11520, 0],
		                     [0, 11521, 0],
		                     [0, 11522, 0],
		                     [0, 11523, 0],
		                     [0, 11524, 0],
		                     [0, 11525, 0],
		                     [0, 11526, 0],
		                     [0, 11527, 0],
		                     [0, 11528, 0],
		                     [0, 11529, 0],
		                     [0, 11530, 0],
		                     [0, 11531, 0],
		                     [0, 11532, 0],
		                     [0, 11533, 0],
		                     [0, 11534, 0],
		                     [0, 11535, 0]],
		                    [0,
		                     [0, 11536, 0],
		                     [0, 11537, 0],
		                     [0, 11538, 0],
		                     [0, 11539, 0],
		                     [0, 11540, 0],
		                     [0, 11541, 0],
		                     [0, 11542, 0],
		                     [0, 11543, 0],
		                     [0, 11544, 0],
		                     [0, 11545, 0],
		                     [0, 11546, 0],
		                     [0, 11547, 0],
		                     [0, 11548, 0],
		                     [0, 11549, 0],
		                     [0, 11550, 0],
		                     [0, 11551, 0]],
		                    [0,
		                     [0, 11552, 0],
		                     [0, 11553, 0],
		                     [0, 11554, 0],
		                     [0, 11555, 0],
		                     [0, 11556, 0],
		                     [0, 11557, 0],
		                     0,
		                     [0, 11559, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 11565, 0],
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 43888, 0],
		                     [0, 43889, 0],
		                     [0, 43890, 0],
		                     [0, 43891, 0],
		                     [0, 43892, 0],
		                     [0, 43893, 0],
		                     [0, 43894, 0],
		                     [0, 43895, 0],
		                     [0, 43896, 0],
		                     [0, 43897, 0],
		                     [0, 43898, 0],
		                     [0, 43899, 0],
		                     [0, 43900, 0],
		                     [0, 43901, 0],
		                     [0, 43902, 0],
		                     [0, 43903, 0]],
		                    [0,
		                     [0, 43904, 0],
		                     [0, 43905, 0],
		                     [0, 43906, 0],
		                     [0, 43907, 0],
		                     [0, 43908, 0],
		                     [0, 43909, 0],
		                     [0, 43910, 0],
		                     [0, 43911, 0],
		                     [0, 43912, 0],
		                     [0, 43913, 0],
		                     [0, 43914, 0],
		                     [0, 43915, 0],
		                     [0, 43916, 0],
		                     [0, 43917, 0],
		                     [0, 43918, 0],
		                     [0, 43919, 0]],
		                    [0,
		                     [0, 43920, 0],
		                     [0, 43921, 0],
		                     [0, 43922, 0],
		                     [0, 43923, 0],
		                     [0, 43924, 0],
		                     [0, 43925, 0],
		                     [0, 43926, 0],
		                     [0, 43927, 0],
		                     [0, 43928, 0],
		                     [0, 43929, 0],
		                     [0, 43930, 0],
		                     [0, 43931, 0],
		                     [0, 43932, 0],
		                     [0, 43933, 0],
		                     [0, 43934, 0],
		                     [0, 43935, 0]],
		                    [0,
		                     [0, 43936, 0],
		                     [0, 43937, 0],
		                     [0, 43938, 0],
		                     [0, 43939, 0],
		                     [0, 43940, 0],
		                     [0, 43941, 0],
		                     [0, 43942, 0],
		                     [0, 43943, 0],
		                     [0, 43944, 0],
		                     [0, 43945, 0],
		                     [0, 43946, 0],
		                     [0, 43947, 0],
		                     [0, 43948, 0],
		                     [0, 43949, 0],
		                     [0, 43950, 0],
		                     [0, 43951, 0]],
		                    [0,
		                     [0, 43952, 0],
		                     [0, 43953, 0],
		                     [0, 43954, 0],
		                     [0, 43955, 0],
		                     [0, 43956, 0],
		                     [0, 43957, 0],
		                     [0, 43958, 0],
		                     [0, 43959, 0],
		                     [0, 43960, 0],
		                     [0, 43961, 0],
		                     [0, 43962, 0],
		                     [0, 43963, 0],
		                     [0, 43964, 0],
		                     [0, 43965, 0],
		                     [0, 43966, 0],
		                     [0, 43967, 0]],
		                    [0,
		                     [0, 5112, 0],
		                     [0, 5113, 0],
		                     [0, 5114, 0],
		                     [0, 5115, 0],
		                     [0, 5116, 0],
		                     [0, 5117, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 7306, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    [0,
		                     [0, 4304, 0],
		                     [0, 4305, 0],
		                     [0, 4306, 0],
		                     [0, 4307, 0],
		                     [0, 4308, 0],
		                     [0, 4309, 0],
		                     [0, 4310, 0],
		                     [0, 4311, 0],
		                     [0, 4312, 0],
		                     [0, 4313, 0],
		                     [0, 4314, 0],
		                     [0, 4315, 0],
		                     [0, 4316, 0],
		                     [0, 4317, 0],
		                     [0, 4318, 0],
		                     [0, 4319, 0]],
		                    [0,
		                     [0, 4320, 0],
		                     [0, 4321, 0],
		                     [0, 4322, 0],
		                     [0, 4323, 0],
		                     [0, 4324, 0],
		                     [0, 4325, 0],
		                     [0, 4326, 0],
		                     [0, 4327, 0],
		                     [0, 4328, 0],
		                     [0, 4329, 0],
		                     [0, 4330, 0],
		                     [0, 4331, 0],
		                     [0, 4332, 0],
		                     [0, 4333, 0],
		                     [0, 4334, 0],
		                     [0, 4335, 0]],
		                    [0,
		                     [0, 4336, 0],
		                     [0, 4337, 0],
		                     [0, 4338, 0],
		                     [0, 4339, 0],
		                     [0, 4340, 0],
		                     [0, 4341, 0],
		                     [0, 4342, 0],
		                     [0, 4343, 0],
		                     [0, 4344, 0],
		                     [0, 4345, 0],
		                     [0, 4346, 0],
		                     0,
		                     0,
		                     [0, 4349, 0],
		                     [0, 4350, 0],
		                     [0, 4351, 0]],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 7681, 0],
		                     0,
		                     [0, 7683, 0],
		                     0,
		                     [0, 7685, 0],
		                     0,
		                     [0, 7687, 0],
		                     0,
		                     [0, 7689, 0],
		                     0,
		                     [0, 7691, 0],
		                     0,
		                     [0, 7693, 0],
		                     0,
		                     [0, 7695, 0],
		                     0],
		                    [0,
		                     [0, 7697, 0],
		                     0,
		                     [0, 7699, 0],
		                     0,
		                     [0, 7701, 0],
		                     0,
		                     [0, 7703, 0],
		                     0,
		                     [0, 7705, 0],
		                     0,
		                     [0, 7707, 0],
		                     0,
		                     [0, 7709, 0],
		                     0,
		                     [0, 7711, 0],
		                     0],
		                    [0,
		                     [0, 7713, 0],
		                     0,
		                     [0, 7715, 0],
		                     0,
		                     [0, 7717, 0],
		                     0,
		                     [0, 7719, 0],
		                     0,
		                     [0, 7721, 0],
		                     0,
		                     [0, 7723, 0],
		                     0,
		                     [0, 7725, 0],
		                     0,
		                     [0, 7727, 0],
		                     0],
		                    [0,
		                     [0, 7729, 0],
		                     0,
		                     [0, 7731, 0],
		                     0,
		                     [0, 7733, 0],
		                     0,
		                     [0, 7735, 0],
		                     0,
		                     [0, 7737, 0],
		                     0,
		                     [0, 7739, 0],
		                     0,
		                     [0, 7741, 0],
		                     0,
		                     [0, 7743, 0],
		                     0],
		                    [0,
		                     [0, 7745, 0],
		                     0,
		                     [0, 7747, 0],
		                     0,
		                     [0, 7749, 0],
		                     0,
		                     [0, 7751, 0],
		                     0,
		                     [0, 7753, 0],
		                     0,
		                     [0, 7755, 0],
		                     0,
		                     [0, 7757, 0],
		                     0,
		                     [0, 7759, 0],
		                     0],
		                    [0,
		                     [0, 7761, 0],
		                     0,
		                     [0, 7763, 0],
		                     0,
		                     [0, 7765, 0],
		                     0,
		                     [0, 7767, 0],
		                     0,
		                     [0, 7769, 0],
		                     0,
		                     [0, 7771, 0],
		                     0,
		                     [0, 7773, 0],
		                     0,
		                     [0, 7775, 0],
		                     0],
		                    [0,
		                     [0, 7777, 0],
		                     0,
		                     [0, 7779, 0],
		                     0,
		                     [0, 7781, 0],
		                     0,
		                     [0, 7783, 0],
		                     0,
		                     [0, 7785, 0],
		                     0,
		                     [0, 7787, 0],
		                     0,
		                     [0, 7789, 0],
		                     0,
		                     [0, 7791, 0],
		                     0],
		                    [0,
		                     [0, 7793, 0],
		                     0,
		                     [0, 7795, 0],
		                     0,
		                     [0, 7797, 0],
		                     0,
		                     [0, 7799, 0],
		                     0,
		                     [0, 7801, 0],
		                     0,
		                     [0, 7803, 0],
		                     0,
		                     [0, 7805, 0],
		                     0,
		                     [0, 7807, 0],
		                     0],
		                    [0,
		                     [0, 7809, 0],
		                     0,
		                     [0, 7811, 0],
		                     0,
		                     [0, 7813, 0],
		                     0,
		                     [0, 7815, 0],
		                     0,
		                     [0, 7817, 0],
		                     0,
		                     [0, 7819, 0],
		                     0,
		                     [0, 7821, 0],
		                     0,
		                     [0, 7823, 0],
		                     0],
		                    [0,
		                     [0, 7825, 0],
		                     0,
		                     [0, 7827, 0],
		                     0,
		                     [0, 7829, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 223, 0],
		                     0],
		                    [0,
		                     [0, 7841, 0],
		                     0,
		                     [0, 7843, 0],
		                     0,
		                     [0, 7845, 0],
		                     0,
		                     [0, 7847, 0],
		                     0,
		                     [0, 7849, 0],
		                     0,
		                     [0, 7851, 0],
		                     0,
		                     [0, 7853, 0],
		                     0,
		                     [0, 7855, 0],
		                     0],
		                    [0,
		                     [0, 7857, 0],
		                     0,
		                     [0, 7859, 0],
		                     0,
		                     [0, 7861, 0],
		                     0,
		                     [0, 7863, 0],
		                     0,
		                     [0, 7865, 0],
		                     0,
		                     [0, 7867, 0],
		                     0,
		                     [0, 7869, 0],
		                     0,
		                     [0, 7871, 0],
		                     0],
		                    [0,
		                     [0, 7873, 0],
		                     0,
		                     [0, 7875, 0],
		                     0,
		                     [0, 7877, 0],
		                     0,
		                     [0, 7879, 0],
		                     0,
		                     [0, 7881, 0],
		                     0,
		                     [0, 7883, 0],
		                     0,
		                     [0, 7885, 0],
		                     0,
		                     [0, 7887, 0],
		                     0],
		                    [0,
		                     [0, 7889, 0],
		                     0,
		                     [0, 7891, 0],
		                     0,
		                     [0, 7893, 0],
		                     0,
		                     [0, 7895, 0],
		                     0,
		                     [0, 7897, 0],
		                     0,
		                     [0, 7899, 0],
		                     0,
		                     [0, 7901, 0],
		                     0,
		                     [0, 7903, 0],
		                     0],
		                    [0,
		                     [0, 7905, 0],
		                     0,
		                     [0, 7907, 0],
		                     0,
		                     [0, 7909, 0],
		                     0,
		                     [0, 7911, 0],
		                     0,
		                     [0, 7913, 0],
		                     0,
		                     [0, 7915, 0],
		                     0,
		                     [0, 7917, 0],
		                     0,
		                     [0, 7919, 0],
		                     0],
		                    [0,
		                     [0, 7921, 0],
		                     0,
		                     [0, 7923, 0],
		                     0,
		                     [0, 7925, 0],
		                     0,
		                     [0, 7927, 0],
		                     0,
		                     [0, 7929, 0],
		                     0,
		                     [0, 7931, 0],
		                     0,
		                     [0, 7933, 0],
		                     0,
		                     [0, 7935, 0],
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 7936, 0],
		                     [0, 7937, 0],
		                     [0, 7938, 0],
		                     [0, 7939, 0],
		                     [0, 7940, 0],
		                     [0, 7941, 0],
		                     [0, 7942, 0],
		                     [0, 7943, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 7952, 0],
		                     [0, 7953, 0],
		                     [0, 7954, 0],
		                     [0, 7955, 0],
		                     [0, 7956, 0],
		                     [0, 7957, 0],
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 7968, 0],
		                     [0, 7969, 0],
		                     [0, 7970, 0],
		                     [0, 7971, 0],
		                     [0, 7972, 0],
		                     [0, 7973, 0],
		                     [0, 7974, 0],
		                     [0, 7975, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 7984, 0],
		                     [0, 7985, 0],
		                     [0, 7986, 0],
		                     [0, 7987, 0],
		                     [0, 7988, 0],
		                     [0, 7989, 0],
		                     [0, 7990, 0],
		                     [0, 7991, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8000, 0],
		                     [0, 8001, 0],
		                     [0, 8002, 0],
		                     [0, 8003, 0],
		                     [0, 8004, 0],
		                     [0, 8005, 0],
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8017, 0],
		                     0,
		                     [0, 8019, 0],
		                     0,
		                     [0, 8021, 0],
		                     0,
		                     [0, 8023, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8032, 0],
		                     [0, 8033, 0],
		                     [0, 8034, 0],
		                     [0, 8035, 0],
		                     [0, 8036, 0],
		                     [0, 8037, 0],
		                     [0, 8038, 0],
		                     [0, 8039, 0]],
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8064, 0],
		                     [0, 8065, 0],
		                     [0, 8066, 0],
		                     [0, 8067, 0],
		                     [0, 8068, 0],
		                     [0, 8069, 0],
		                     [0, 8070, 0],
		                     [0, 8071, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8080, 0],
		                     [0, 8081, 0],
		                     [0, 8082, 0],
		                     [0, 8083, 0],
		                     [0, 8084, 0],
		                     [0, 8085, 0],
		                     [0, 8086, 0],
		                     [0, 8087, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8096, 0],
		                     [0, 8097, 0],
		                     [0, 8098, 0],
		                     [0, 8099, 0],
		                     [0, 8100, 0],
		                     [0, 8101, 0],
		                     [0, 8102, 0],
		                     [0, 8103, 0]],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8112, 0],
		                     [0, 8113, 0],
		                     [0, 8048, 0],
		                     [0, 8049, 0],
		                     [0, 8115, 0],
		                     0,
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8050, 0],
		                     [0, 8051, 0],
		                     [0, 8052, 0],
		                     [0, 8053, 0],
		                     [0, 8131, 0],
		                     0,
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8144, 0],
		                     [0, 8145, 0],
		                     [0, 8054, 0],
		                     [0, 8055, 0],
		                     0,
		                     0,
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8160, 0],
		                     [0, 8161, 0],
		                     [0, 8058, 0],
		                     [0, 8059, 0],
		                     [0, 8165, 0],
		                     0,
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 8056, 0],
		                     [0, 8057, 0],
		                     [0, 8060, 0],
		                     [0, 8061, 0],
		                     [0, 8179, 0],
		                     0,
		                     0,
		                     0]],
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 969, 0],
		                     0,
		                     0,
		                     0,
		                     [0, 107, 0],
		                     [0, 229, 0],
		                     0,
		                     0,
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     [0, 8526, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 8560, 0],
		                     [0, 8561, 0],
		                     [0, 8562, 0],
		                     [0, 8563, 0],
		                     [0, 8564, 0],
		                     [0, 8565, 0],
		                     [0, 8566, 0],
		                     [0, 8567, 0],
		                     [0, 8568, 0],
		                     [0, 8569, 0],
		                     [0, 8570, 0],
		                     [0, 8571, 0],
		                     [0, 8572, 0],
		                     [0, 8573, 0],
		                     [0, 8574, 0],
		                     [0, 8575, 0]],
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     [0, 8580, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 9424, 0],
		                     [0, 9425, 0],
		                     [0, 9426, 0],
		                     [0, 9427, 0],
		                     [0, 9428, 0],
		                     [0, 9429, 0],
		                     [0, 9430, 0],
		                     [0, 9431, 0],
		                     [0, 9432, 0],
		                     [0, 9433, 0]],
		                    [0,
		                     [0, 9434, 0],
		                     [0, 9435, 0],
		                     [0, 9436, 0],
		                     [0, 9437, 0],
		                     [0, 9438, 0],
		                     [0, 9439, 0],
		                     [0, 9440, 0],
		                     [0, 9441, 0],
		                     [0, 9442, 0],
		                     [0, 9443, 0],
		                     [0, 9444, 0],
		                     [0, 9445, 0],
		                     [0, 9446, 0],
		                     [0, 9447, 0],
		                     [0, 9448, 0],
		                     [0, 9449, 0]],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 11312, 0],
		                     [0, 11313, 0],
		                     [0, 11314, 0],
		                     [0, 11315, 0],
		                     [0, 11316, 0],
		                     [0, 11317, 0],
		                     [0, 11318, 0],
		                     [0, 11319, 0],
		                     [0, 11320, 0],
		                     [0, 11321, 0],
		                     [0, 11322, 0],
		                     [0, 11323, 0],
		                     [0, 11324, 0],
		                     [0, 11325, 0],
		                     [0, 11326, 0],
		                     [0, 11327, 0]],
		                    [0,
		                     [0, 11328, 0],
		                     [0, 11329, 0],
		                     [0, 11330, 0],
		                     [0, 11331, 0],
		                     [0, 11332, 0],
		                     [0, 11333, 0],
		                     [0, 11334, 0],
		                     [0, 11335, 0],
		                     [0, 11336, 0],
		                     [0, 11337, 0],
		                     [0, 11338, 0],
		                     [0, 11339, 0],
		                     [0, 11340, 0],
		                     [0, 11341, 0],
		                     [0, 11342, 0],
		                     [0, 11343, 0]],
		                    [0,
		                     [0, 11344, 0],
		                     [0, 11345, 0],
		                     [0, 11346, 0],
		                     [0, 11347, 0],
		                     [0, 11348, 0],
		                     [0, 11349, 0],
		                     [0, 11350, 0],
		                     [0, 11351, 0],
		                     [0, 11352, 0],
		                     [0, 11353, 0],
		                     [0, 11354, 0],
		                     [0, 11355, 0],
		                     [0, 11356, 0],
		                     [0, 11357, 0],
		                     [0, 11358, 0],
		                     [0, 11359, 0]],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 11361, 0],
		                     0,
		                     [0, 619, 0],
		                     [0, 7549, 0],
		                     [0, 637, 0],
		                     0,
		                     0,
		                     [0, 11368, 0],
		                     0,
		                     [0, 11370, 0],
		                     0,
		                     [0, 11372, 0],
		                     0,
		                     [0, 593, 0],
		                     [0, 625, 0],
		                     [0, 592, 0]],
		                    [0,
		                     [0, 594, 0],
		                     0,
		                     [0, 11379, 0],
		                     0,
		                     0,
		                     [0, 11382, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 575, 0],
		                     [0, 576, 0]],
		                    [0,
		                     [0, 11393, 0],
		                     0,
		                     [0, 11395, 0],
		                     0,
		                     [0, 11397, 0],
		                     0,
		                     [0, 11399, 0],
		                     0,
		                     [0, 11401, 0],
		                     0,
		                     [0, 11403, 0],
		                     0,
		                     [0, 11405, 0],
		                     0,
		                     [0, 11407, 0],
		                     0],
		                    [0,
		                     [0, 11409, 0],
		                     0,
		                     [0, 11411, 0],
		                     0,
		                     [0, 11413, 0],
		                     0,
		                     [0, 11415, 0],
		                     0,
		                     [0, 11417, 0],
		                     0,
		                     [0, 11419, 0],
		                     0,
		                     [0, 11421, 0],
		                     0,
		                     [0, 11423, 0],
		                     0],
		                    [0,
		                     [0, 11425, 0],
		                     0,
		                     [0, 11427, 0],
		                     0,
		                     [0, 11429, 0],
		                     0,
		                     [0, 11431, 0],
		                     0,
		                     [0, 11433, 0],
		                     0,
		                     [0, 11435, 0],
		                     0,
		                     [0, 11437, 0],
		                     0,
		                     [0, 11439, 0],
		                     0],
		                    [0,
		                     [0, 11441, 0],
		                     0,
		                     [0, 11443, 0],
		                     0,
		                     [0, 11445, 0],
		                     0,
		                     [0, 11447, 0],
		                     0,
		                     [0, 11449, 0],
		                     0,
		                     [0, 11451, 0],
		                     0,
		                     [0, 11453, 0],
		                     0,
		                     [0, 11455, 0],
		                     0],
		                    [0,
		                     [0, 11457, 0],
		                     0,
		                     [0, 11459, 0],
		                     0,
		                     [0, 11461, 0],
		                     0,
		                     [0, 11463, 0],
		                     0,
		                     [0, 11465, 0],
		                     0,
		                     [0, 11467, 0],
		                     0,
		                     [0, 11469, 0],
		                     0,
		                     [0, 11471, 0],
		                     0],
		                    [0,
		                     [0, 11473, 0],
		                     0,
		                     [0, 11475, 0],
		                     0,
		                     [0, 11477, 0],
		                     0,
		                     [0, 11479, 0],
		                     0,
		                     [0, 11481, 0],
		                     0,
		                     [0, 11483, 0],
		                     0,
		                     [0, 11485, 0],
		                     0,
		                     [0, 11487, 0],
		                     0],
		                    [0,
		                     [0, 11489, 0],
		                     0,
		                     [0, 11491, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 11500, 0],
		                     0,
		                     [0, 11502, 0],
		                     0,
		                     0],
		                    [0,
		                     0,
		                     0,
		                     [0, 11507, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 42561, 0],
		                     0,
		                     [0, 42563, 0],
		                     0,
		                     [0, 42565, 0],
		                     0,
		                     [0, 42567, 0],
		                     0,
		                     [0, 42569, 0],
		                     0,
		                     [0, 42571, 0],
		                     0,
		                     [0, 42573, 0],
		                     0,
		                     [0, 42575, 0],
		                     0],
		                    [0,
		                     [0, 42577, 0],
		                     0,
		                     [0, 42579, 0],
		                     0,
		                     [0, 42581, 0],
		                     0,
		                     [0, 42583, 0],
		                     0,
		                     [0, 42585, 0],
		                     0,
		                     [0, 42587, 0],
		                     0,
		                     [0, 42589, 0],
		                     0,
		                     [0, 42591, 0],
		                     0],
		                    [0,
		                     [0, 42593, 0],
		                     0,
		                     [0, 42595, 0],
		                     0,
		                     [0, 42597, 0],
		                     0,
		                     [0, 42599, 0],
		                     0,
		                     [0, 42601, 0],
		                     0,
		                     [0, 42603, 0],
		                     0,
		                     [0, 42605, 0],
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    [0,
		                     [0, 42625, 0],
		                     0,
		                     [0, 42627, 0],
		                     0,
		                     [0, 42629, 0],
		                     0,
		                     [0, 42631, 0],
		                     0,
		                     [0, 42633, 0],
		                     0,
		                     [0, 42635, 0],
		                     0,
		                     [0, 42637, 0],
		                     0,
		                     [0, 42639, 0],
		                     0],
		                    [0,
		                     [0, 42641, 0],
		                     0,
		                     [0, 42643, 0],
		                     0,
		                     [0, 42645, 0],
		                     0,
		                     [0, 42647, 0],
		                     0,
		                     [0, 42649, 0],
		                     0,
		                     [0, 42651, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     [0, 42787, 0],
		                     0,
		                     [0, 42789, 0],
		                     0,
		                     [0, 42791, 0],
		                     0,
		                     [0, 42793, 0],
		                     0,
		                     [0, 42795, 0],
		                     0,
		                     [0, 42797, 0],
		                     0,
		                     [0, 42799, 0],
		                     0],
		                    [0,
		                     0,
		                     0,
		                     [0, 42803, 0],
		                     0,
		                     [0, 42805, 0],
		                     0,
		                     [0, 42807, 0],
		                     0,
		                     [0, 42809, 0],
		                     0,
		                     [0, 42811, 0],
		                     0,
		                     [0, 42813, 0],
		                     0,
		                     [0, 42815, 0],
		                     0],
		                    [0,
		                     [0, 42817, 0],
		                     0,
		                     [0, 42819, 0],
		                     0,
		                     [0, 42821, 0],
		                     0,
		                     [0, 42823, 0],
		                     0,
		                     [0, 42825, 0],
		                     0,
		                     [0, 42827, 0],
		                     0,
		                     [0, 42829, 0],
		                     0,
		                     [0, 42831, 0],
		                     0],
		                    [0,
		                     [0, 42833, 0],
		                     0,
		                     [0, 42835, 0],
		                     0,
		                     [0, 42837, 0],
		                     0,
		                     [0, 42839, 0],
		                     0,
		                     [0, 42841, 0],
		                     0,
		                     [0, 42843, 0],
		                     0,
		                     [0, 42845, 0],
		                     0,
		                     [0, 42847, 0],
		                     0],
		                    [0,
		                     [0, 42849, 0],
		                     0,
		                     [0, 42851, 0],
		                     0,
		                     [0, 42853, 0],
		                     0,
		                     [0, 42855, 0],
		                     0,
		                     [0, 42857, 0],
		                     0,
		                     [0, 42859, 0],
		                     0,
		                     [0, 42861, 0],
		                     0,
		                     [0, 42863, 0],
		                     0],
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 42874, 0],
		                     0,
		                     [0, 42876, 0],
		                     0,
		                     [0, 7545, 0],
		                     [0, 42879, 0],
		                     0],
		                    [0,
		                     [0, 42881, 0],
		                     0,
		                     [0, 42883, 0],
		                     0,
		                     [0, 42885, 0],
		                     0,
		                     [0, 42887, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 42892, 0],
		                     0,
		                     [0, 613, 0],
		                     0,
		                     0],
		                    [0,
		                     [0, 42897, 0],
		                     0,
		                     [0, 42899, 0],
		                     0,
		                     0,
		                     0,
		                     [0, 42903, 0],
		                     0,
		                     [0, 42905, 0],
		                     0,
		                     [0, 42907, 0],
		                     0,
		                     [0, 42909, 0],
		                     0,
		                     [0, 42911, 0],
		                     0],
		                    [0,
		                     [0, 42913, 0],
		                     0,
		                     [0, 42915, 0],
		                     0,
		                     [0, 42917, 0],
		                     0,
		                     [0, 42919, 0],
		                     0,
		                     [0, 42921, 0],
		                     0,
		                     [0, 614, 0],
		                     [0, 604, 0],
		                     [0, 609, 0],
		                     [0, 620, 0],
		                     [0, 618, 0],
		                     0],
		                    [0,
		                     [0, 670, 0],
		                     [0, 647, 0],
		                     [0, 669, 0],
		                     [0, 43859, 0],
		                     [0, 42933, 0],
		                     0,
		                     [0, 42935, 0],
		                     0,
		                     [0, 42937, 0],
		                     0,
		                     [0, 42939, 0],
		                     0,
		                     [0, 42941, 0],
		                     0,
		                     [0, 42943, 0],
		                     0],
		                    [0,
		                     [0, 42945, 0],
		                     0,
		                     [0, 42947, 0],
		                     0,
		                     [0, 42900, 0],
		                     [0, 642, 0],
		                     [0, 7566, 0],
		                     [0, 42952, 0],
		                     0,
		                     [0, 42954, 0],
		                     0,
		                     [0, 612, 0],
		                     [0, 42957, 0],
		                     0,
		                     0,
		                     0],
		                    [0,
		                     [0, 42961, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 42967, 0],
		                     0,
		                     [0, 42969, 0],
		                     0,
		                     [0, 42971, 0],
		                     0,
		                     [0, 411, 0],
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, 42998, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     0,
		                     [0, 65345, 0],
		                     [0, 65346, 0],
		                     [0, 65347, 0],
		                     [0, 65348, 0],
		                     [0, 65349, 0],
		                     [0, 65350, 0],
		                     [0, 65351, 0],
		                     [0, 65352, 0],
		                     [0, 65353, 0],
		                     [0, 65354, 0],
		                     [0, 65355, 0],
		                     [0, 65356, 0],
		                     [0, 65357, 0],
		                     [0, 65358, 0],
		                     [0, 65359, 0]],
		                    [0,
		                     [0, 65360, 0],
		                     [0, 65361, 0],
		                     [0, 65362, 0],
		                     [0, 65363, 0],
		                     [0, 65364, 0],
		                     [0, 65365, 0],
		                     [0, 65366, 0],
		                     [0, 65367, 0],
		                     [0, 65368, 0],
		                     [0, 65369, 0],
		                     [0, 65370, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 66600, 0],
		                     [0, 66601, 0],
		                     [0, 66602, 0],
		                     [0, 66603, 0],
		                     [0, 66604, 0],
		                     [0, 66605, 0],
		                     [0, 66606, 0],
		                     [0, 66607, 0],
		                     [0, 66608, 0],
		                     [0, 66609, 0],
		                     [0, 66610, 0],
		                     [0, 66611, 0],
		                     [0, 66612, 0],
		                     [0, 66613, 0],
		                     [0, 66614, 0],
		                     [0, 66615, 0]],
		                    [0,
		                     [0, 66616, 0],
		                     [0, 66617, 0],
		                     [0, 66618, 0],
		                     [0, 66619, 0],
		                     [0, 66620, 0],
		                     [0, 66621, 0],
		                     [0, 66622, 0],
		                     [0, 66623, 0],
		                     [0, 66624, 0],
		                     [0, 66625, 0],
		                     [0, 66626, 0],
		                     [0, 66627, 0],
		                     [0, 66628, 0],
		                     [0, 66629, 0],
		                     [0, 66630, 0],
		                     [0, 66631, 0]],
		                    [0,
		                     [0, 66632, 0],
		                     [0, 66633, 0],
		                     [0, 66634, 0],
		                     [0, 66635, 0],
		                     [0, 66636, 0],
		                     [0, 66637, 0],
		                     [0, 66638, 0],
		                     [0, 66639, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 66776, 0],
		                     [0, 66777, 0],
		                     [0, 66778, 0],
		                     [0, 66779, 0],
		                     [0, 66780, 0],
		                     [0, 66781, 0],
		                     [0, 66782, 0],
		                     [0, 66783, 0],
		                     [0, 66784, 0],
		                     [0, 66785, 0],
		                     [0, 66786, 0],
		                     [0, 66787, 0],
		                     [0, 66788, 0],
		                     [0, 66789, 0],
		                     [0, 66790, 0],
		                     [0, 66791, 0]],
		                    [0,
		                     [0, 66792, 0],
		                     [0, 66793, 0],
		                     [0, 66794, 0],
		                     [0, 66795, 0],
		                     [0, 66796, 0],
		                     [0, 66797, 0],
		                     [0, 66798, 0],
		                     [0, 66799, 0],
		                     [0, 66800, 0],
		                     [0, 66801, 0],
		                     [0, 66802, 0],
		                     [0, 66803, 0],
		                     [0, 66804, 0],
		                     [0, 66805, 0],
		                     [0, 66806, 0],
		                     [0, 66807, 0]],
		                    [0,
		                     [0, 66808, 0],
		                     [0, 66809, 0],
		                     [0, 66810, 0],
		                     [0, 66811, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 66967, 0],
		                     [0, 66968, 0],
		                     [0, 66969, 0],
		                     [0, 66970, 0],
		                     [0, 66971, 0],
		                     [0, 66972, 0],
		                     [0, 66973, 0],
		                     [0, 66974, 0],
		                     [0, 66975, 0],
		                     [0, 66976, 0],
		                     [0, 66977, 0],
		                     0,
		                     [0, 66979, 0],
		                     [0, 66980, 0],
		                     [0, 66981, 0],
		                     [0, 66982, 0]],
		                    [0,
		                     [0, 66983, 0],
		                     [0, 66984, 0],
		                     [0, 66985, 0],
		                     [0, 66986, 0],
		                     [0, 66987, 0],
		                     [0, 66988, 0],
		                     [0, 66989, 0],
		                     [0, 66990, 0],
		                     [0, 66991, 0],
		                     [0, 66992, 0],
		                     [0, 66993, 0],
		                     0,
		                     [0, 66995, 0],
		                     [0, 66996, 0],
		                     [0, 66997, 0],
		                     [0, 66998, 0]],
		                    [0,
		                     [0, 66999, 0],
		                     [0, 67000, 0],
		                     [0, 67001, 0],
		                     0,
		                     [0, 67003, 0],
		                     [0, 67004, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 68800, 0],
		                     [0, 68801, 0],
		                     [0, 68802, 0],
		                     [0, 68803, 0],
		                     [0, 68804, 0],
		                     [0, 68805, 0],
		                     [0, 68806, 0],
		                     [0, 68807, 0],
		                     [0, 68808, 0],
		                     [0, 68809, 0],
		                     [0, 68810, 0],
		                     [0, 68811, 0],
		                     [0, 68812, 0],
		                     [0, 68813, 0],
		                     [0, 68814, 0],
		                     [0, 68815, 0]],
		                    [0,
		                     [0, 68816, 0],
		                     [0, 68817, 0],
		                     [0, 68818, 0],
		                     [0, 68819, 0],
		                     [0, 68820, 0],
		                     [0, 68821, 0],
		                     [0, 68822, 0],
		                     [0, 68823, 0],
		                     [0, 68824, 0],
		                     [0, 68825, 0],
		                     [0, 68826, 0],
		                     [0, 68827, 0],
		                     [0, 68828, 0],
		                     [0, 68829, 0],
		                     [0, 68830, 0],
		                     [0, 68831, 0]],
		                    [0,
		                     [0, 68832, 0],
		                     [0, 68833, 0],
		                     [0, 68834, 0],
		                     [0, 68835, 0],
		                     [0, 68836, 0],
		                     [0, 68837, 0],
		                     [0, 68838, 0],
		                     [0, 68839, 0],
		                     [0, 68840, 0],
		                     [0, 68841, 0],
		                     [0, 68842, 0],
		                     [0, 68843, 0],
		                     [0, 68844, 0],
		                     [0, 68845, 0],
		                     [0, 68846, 0],
		                     [0, 68847, 0]],
		                    [0,
		                     [0, 68848, 0],
		                     [0, 68849, 0],
		                     [0, 68850, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 68976, 0],
		                     [0, 68977, 0],
		                     [0, 68978, 0],
		                     [0, 68979, 0],
		                     [0, 68980, 0],
		                     [0, 68981, 0],
		                     [0, 68982, 0],
		                     [0, 68983, 0],
		                     [0, 68984, 0],
		                     [0, 68985, 0],
		                     [0, 68986, 0],
		                     [0, 68987, 0],
		                     [0, 68988, 0],
		                     [0, 68989, 0],
		                     [0, 68990, 0],
		                     [0, 68991, 0]],
		                    [0,
		                     [0, 68992, 0],
		                     [0, 68993, 0],
		                     [0, 68994, 0],
		                     [0, 68995, 0],
		                     [0, 68996, 0],
		                     [0, 68997, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 71872, 0],
		                     [0, 71873, 0],
		                     [0, 71874, 0],
		                     [0, 71875, 0],
		                     [0, 71876, 0],
		                     [0, 71877, 0],
		                     [0, 71878, 0],
		                     [0, 71879, 0],
		                     [0, 71880, 0],
		                     [0, 71881, 0],
		                     [0, 71882, 0],
		                     [0, 71883, 0],
		                     [0, 71884, 0],
		                     [0, 71885, 0],
		                     [0, 71886, 0],
		                     [0, 71887, 0]],
		                    [0,
		                     [0, 71888, 0],
		                     [0, 71889, 0],
		                     [0, 71890, 0],
		                     [0, 71891, 0],
		                     [0, 71892, 0],
		                     [0, 71893, 0],
		                     [0, 71894, 0],
		                     [0, 71895, 0],
		                     [0, 71896, 0],
		                     [0, 71897, 0],
		                     [0, 71898, 0],
		                     [0, 71899, 0],
		                     [0, 71900, 0],
		                     [0, 71901, 0],
		                     [0, 71902, 0],
		                     [0, 71903, 0]],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 93792, 0],
		                     [0, 93793, 0],
		                     [0, 93794, 0],
		                     [0, 93795, 0],
		                     [0, 93796, 0],
		                     [0, 93797, 0],
		                     [0, 93798, 0],
		                     [0, 93799, 0],
		                     [0, 93800, 0],
		                     [0, 93801, 0],
		                     [0, 93802, 0],
		                     [0, 93803, 0],
		                     [0, 93804, 0],
		                     [0, 93805, 0],
		                     [0, 93806, 0],
		                     [0, 93807, 0]],
		                    [0,
		                     [0, 93808, 0],
		                     [0, 93809, 0],
		                     [0, 93810, 0],
		                     [0, 93811, 0],
		                     [0, 93812, 0],
		                     [0, 93813, 0],
		                     [0, 93814, 0],
		                     [0, 93815, 0],
		                     [0, 93816, 0],
		                     [0, 93817, 0],
		                     [0, 93818, 0],
		                     [0, 93819, 0],
		                     [0, 93820, 0],
		                     [0, 93821, 0],
		                     [0, 93822, 0],
		                     [0, 93823, 0]],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   [0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    [0,
		                     [0, 125218, 0],
		                     [0, 125219, 0],
		                     [0, 125220, 0],
		                     [0, 125221, 0],
		                     [0, 125222, 0],
		                     [0, 125223, 0],
		                     [0, 125224, 0],
		                     [0, 125225, 0],
		                     [0, 125226, 0],
		                     [0, 125227, 0],
		                     [0, 125228, 0],
		                     [0, 125229, 0],
		                     [0, 125230, 0],
		                     [0, 125231, 0],
		                     [0, 125232, 0],
		                     [0, 125233, 0]],
		                    [0,
		                     [0, 125234, 0],
		                     [0, 125235, 0],
		                     [0, 125236, 0],
		                     [0, 125237, 0],
		                     [0, 125238, 0],
		                     [0, 125239, 0],
		                     [0, 125240, 0],
		                     [0, 125241, 0],
		                     [0, 125242, 0],
		                     [0, 125243, 0],
		                     [0, 125244, 0],
		                     [0, 125245, 0],
		                     [0, 125246, 0],
		                     [0, 125247, 0],
		                     [0, 125248, 0],
		                     [0, 125249, 0]],
		                    [0,
		                     [0, 125250, 0],
		                     [0, 125251, 0],
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     0],
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0,
		                    nil$0],
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0,
		                   nil$0];
		               function to_lower(u){
		                var l1 = bQV[(u >>> 12 | 0) + 1], a = 0;
		                if(l1 === nil$0)
		                 var us = a;
		                else
		                 var
		                  l2 = l1[((u >>> 4 | 0) & 255) + 1],
		                  us = l2 === nil$0 ? a : l2[(u & 15) + 1];
		                return us ? [0, -1039579032, us] : 925480876;
		               }
		               var
		                V$0 = [248, "Mandate__Schemas_library.V", caml_fresh_oo_id()];
		               function equal$28(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(c) var b$1 = rhs[3], a$1 = lhs[3], c = a$1 === b$1 ? 1 : 0;
		                if(c) var b$2 = rhs[4], a$2 = lhs[4], c = a$2 === b$2 ? 1 : 0;
		                if(c) var b$3 = rhs[5], a$3 = lhs[5], c = a$3 === b$3 ? 1 : 0;
		                if(c) var b$4 = rhs[6], a$4 = lhs[6], c = a$4 === b$4 ? 1 : 0;
		                if(! c) return cont(c);
		                var b$5 = rhs[7], a$5 = lhs[7];
		                return cont(a$5 === b$5 ? 1 : 0);
		               }
		               var letrec_function_context$9 = [];
		               function compare$45(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$9[7],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$9[6],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(x){
		                if(0 !== x) return cont(x);
		                var a = rhs[3], b = lhs[3];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$9[5],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[4], b = lhs[4];
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$9[4],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(x){
		                if(0 !== x) return cont(x);
		                var a = rhs[5], b = lhs[5];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$9[3],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[6], b = lhs[6];
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$9[2],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(x){
		                if(0 !== x) return cont(x);
		                var a = rhs[7], b = lhs[7];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$9[1],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function _6$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _5$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _4$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _3$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _2$1(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$2(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$2(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$9,
		                 [0, _6$0, _5$0, _4$0, _3$0, _2$1, _1$2, _0$2]);
		               function make$11(f, e, d, c, b, a, opt, param){
		                var
		                 monday = f ? f[1] : 0,
		                 tuesday = e ? e[1] : 0,
		                 wednesday = d ? d[1] : 0,
		                 thursday = c ? c[1] : 0,
		                 friday = b ? b[1] : 0,
		                 saturday = a ? a[1] : 0,
		                 sunday = opt ? opt[1] : 0;
		                return [0,
		                        monday,
		                        tuesday,
		                        wednesday,
		                        thursday,
		                        friday,
		                        saturday,
		                        sunday];
		               }
		               var letrec_function_context$10 = [];
		               function schema_versioned$12(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$10[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, na, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$10[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$10[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$10[1][1] = a;
		                            var
		                             default$ = match$19[1],
		                             default$0 = match$20[1],
		                             default$1 = match$21[1],
		                             default$2 = match$22[1],
		                             default$3 = match$23[1],
		                             default$4 = match$24[1],
		                             default$5 = match$25[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  sunday = e[2][1],
		                                  saturday = e[1],
		                                  friday = d[1],
		                                  thursday = c[1],
		                                  wednesday = b[1],
		                                  tuesday = a[1],
		                                  monday = param[1];
		                                 return cont
		 ([0,
		   monday,
		   tuesday,
		   wednesday,
		   thursday,
		   friday,
		   saturday,
		   sunday]);
		                                },
		                                function(param, cont){
		                                 var
		                                  sunday = param[7],
		                                  saturday = param[6],
		                                  friday = param[5],
		                                  thursday = param[4],
		                                  wednesday = param[3],
		                                  tuesday = param[2],
		                                  monday = param[1];
		                                 return cont
		 ([0,
		   monday,
		   [0,
		    tuesday,
		    [0,
		     wednesday,
		     [0, thursday, [0, friday, [0, saturday, [0, sunday, 0]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_monday,
		                                  0,
		                                  [0, default$5],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_tuesday,
		                                   0,
		                                   [0, default$4],
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_wednesday,
		                                    0,
		                                    [0, default$3],
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_thursday,
		                                     0,
		                                     [0, default$2],
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_friday,
		                                      0,
		                                      [0, default$1],
		                                      [0, bool_schema],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_saturday,
		                                       0,
		                                       [0, default$0],
		                                       [0, bool_schema],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_sunday,
		0,
		[0, default$],
		[0, bool_schema],
		0,
		0],
		                                       0]]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$10[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$10[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$8 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$10, [0, schematic_cache$8]);
		               caml_callback
		                (schema_versioned$12,
		                 [function(param, cont){return cont(0);}]);
		               function add$8(day, t){
		                switch(day){
		                  case 0:
		                   return [0, 1, t[2], t[3], t[4], t[5], t[6], t[7]];
		                  case 1:
		                   return [0, t[1], 1, t[3], t[4], t[5], t[6], t[7]];
		                  case 2:
		                   return [0, t[1], t[2], 1, t[4], t[5], t[6], t[7]];
		                  case 3:
		                   return [0, t[1], t[2], t[3], 1, t[5], t[6], t[7]];
		                  case 4:
		                   return [0, t[1], t[2], t[3], t[4], 1, t[6], t[7]];
		                  case 5:
		                   return [0, t[1], t[2], t[3], t[4], t[5], 1, t[7]];
		                  default: return [0, t[1], t[2], t[3], t[4], t[5], t[6], 1];
		                }
		               }
		               function length$12(days, cont){
		                var
		                 a = days[7] ? 1 : 0,
		                 b = days[6] ? 1 : 0,
		                 c = days[5] ? 1 : 0,
		                 d = days[4] ? 1 : 0,
		                 e = days[3] ? 1 : 0,
		                 f = days[2] ? 1 : 0,
		                 g = days[1] ? 1 : 0;
		                return cont
		                        ((((((g + f | 0) + e | 0) + d | 0) + c | 0) + b | 0) + a | 0);
		               }
		               var
		                all$15 = make$11(nh, ng, nf, ne, nd, nc, nb),
		                monday = make$11(ni, 0, 0, 0, 0, 0, 0),
		                tuesday = make$11(0, nj, 0, 0, 0, 0, 0),
		                wednesday = make$11(0, 0, nk, 0, 0, 0, 0),
		                thursday = make$11(0, 0, 0, nl, 0, 0, 0),
		                friday = make$11(0, 0, 0, 0, nm, 0, 0),
		                saturday = make$11(0, 0, 0, 0, 0, nn, 0),
		                sunday = make$11(0, 0, 0, 0, 0, 0, no),
		                until_tuesday = make$11(nq, np, 0, 0, 0, 0, 0),
		                until_wednesday = make$11(nt, ns, nr, 0, 0, 0, 0),
		                until_thursday = make$11(nx, nw, nv, nu, 0, 0, 0),
		                until_friday = make$11(nC, nB, nA, nz, ny, 0, 0),
		                until_saturday = make$11(nI, nH, nG, nF, nE, nD, 0);
		               function until(param){
		                switch(param){
		                  case 0:
		                   return monday;
		                  case 1:
		                   return until_tuesday;
		                  case 2:
		                   return until_wednesday;
		                  case 3:
		                   return until_thursday;
		                  case 4:
		                   return until_friday;
		                  case 5:
		                   return until_saturday;
		                  default: return all$15;
		                }
		               }
		               var
		                starting_tuesday = make$11(0, nO, nN, nM, nL, nK, nJ),
		                starting_wednesday = make$11(0, 0, nT, nS, nR, nQ, nP),
		                starting_thursday = make$11(0, 0, 0, nX, nW, nV, nU),
		                starting_friday = make$11(0, 0, 0, 0, n0, nZ, nY),
		                starting_saturday = make$11(0, 0, 0, 0, 0, n2, n1);
		               function starting(param){
		                switch(param){
		                  case 0:
		                   return all$15;
		                  case 1:
		                   return starting_tuesday;
		                  case 2:
		                   return starting_wednesday;
		                  case 3:
		                   return starting_thursday;
		                  case 4:
		                   return starting_friday;
		                  case 5:
		                   return starting_saturday;
		                  default: return sunday;
		                }
		               }
		               function intersection(l, r){
		                var
		                 a = l[7],
		                 a = a ? r[7] : a,
		                 b = l[6],
		                 b = b ? r[6] : b,
		                 c = l[5],
		                 c = c ? r[5] : c,
		                 d = l[4],
		                 d = d ? r[4] : d,
		                 e = l[3],
		                 e = e ? r[3] : e,
		                 f = l[2],
		                 f = f ? r[2] : f,
		                 g = l[1],
		                 g = g ? r[1] : g,
		                 weekdays = [0, g, f, e, d, c, b, a];
		                if
		                 (!
		                  weekdays[1]
		                  &&
		                   !
		                   weekdays[2]
		                   &&
		                    !
		                    weekdays[3]
		                    &&
		                     !
		                     weekdays[4]
		                     && ! weekdays[5] && ! weekdays[6] && ! weekdays[7])
		                 return 0;
		                return [0, weekdays];
		               }
		               function of_weekdays(days, cont){
		                var a = make$11(0, 0, 0, 0, 0, 0, 0);
		                return caml_exact_trampoline_cps_call$1
		                        (fold$9(days),
		                         a,
		                         function(weekdays, day, cont){
		                          return cont(add$8(day, weekdays));
		                         },
		                         cont);
		               }
		               function to_weekdays(a, cont){
		                var
		                 sunday = a[7],
		                 saturday = a[6],
		                 friday = a[5],
		                 thursday = a[4],
		                 wednesday = a[3],
		                 tuesday = a[2],
		                 monday = a[1],
		                 a = [0, some_if(sunday, 6), 0],
		                 a = [0, some_if(saturday, 5), a],
		                 a = [0, some_if(friday, 4), a],
		                 a = [0, some_if(thursday, 3), a],
		                 a = [0, some_if(wednesday, 2), a],
		                 a = [0, some_if(tuesday, 1), a];
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         [0, some_if(monday, 0), a],
		                         function(a, cont){return cont(a);},
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_list_exn, a, cont);
		                         });
		               }
		               function pp$21(f, wd, cont){
		                function a(param){
		                 var match = param[2], one = param[1];
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (of_to_string, to_string$17, f, one, cont);
		                 var two = match[1];
		                 if(! match[2])
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(f),
		                           n3,
		                           function(a){
		                            return caml_trampoline_cps_call5
		                                    (a, _11, one, _11, two, cont);
		                           });
		                 var tail = match[2];
		                 return caml_exact_trampoline_cps_call$0
		                         (of_to_string,
		                          to_string$17,
		                          f,
		                          one,
		                          function(match){
		                           return caml_exact_trampoline_cps_call$1
		                                   (comma,
		                                    f,
		                                    dummy,
		                                    function(match){
		                                     return caml_exact_trampoline_call1(a, [0, two, tail]);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call(to_weekdays, wd, a);
		               }
		               function pp_nth(fmt, n, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$23,
		                         n,
		                         10,
		                         function(a){
		                          if(11 <= n){
		                           if(14 > n)
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     n8,
		                                     function(a){return caml_trampoline_cps_call2(a, n, cont);});
		                          }
		                          else if(-1 === n)
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt), n9, cont);
		                          a = a - 1 | 0;
		                          if(2 < a >>> 0)
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    n4,
		                                    function(a){return caml_trampoline_cps_call2(a, n, cont);});
		                          switch(a){
		                            case 0:
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      n5,
		                                      function(a){return caml_trampoline_cps_call2(a, n, cont);});
		                            case 1:
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      n6,
		                                      function(a){return caml_trampoline_cps_call2(a, n, cont);});
		                            default:
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      n7,
		                                      function(a){return caml_trampoline_cps_call2(a, n, cont);});
		                          }
		                         });
		               }
		               function pp_year(fmt, y, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         n_,
		                         function(a){return caml_trampoline_cps_call2(a, y, cont);});
		               }
		               var letrec_function_context$11 = [];
		               function equal$29(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return cont(lhs0 === rhs0 ? 1 : 0);
		                 }
		                }
		                else {
		                 var lhs1 = lhs[2], lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs1 = rhs[2], rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$11[1],
		                           lhs0$0,
		                           rhs0$0,
		                           function(a){
		                            return a ? cont(lhs1 === rhs1 ? 1 : 0) : cont(a);
		                           });
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy(letrec_function_context$11, [0, equal$16]);
		               var letrec_function_context$12 = [];
		               function compare$46(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$12[3],
		                           0,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, lhs0, rhs0, cont);
		                           });
		                 }
		                }
		                else {
		                 var lhs1 = lhs[2], lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs1 = rhs[2], rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$12[2],
		                           lhs0$0,
		                           rhs0$0,
		                           function(x){
		                            return 0 === x
		                                    ? caml_trampoline_cps_call2
		                                      (letrec_function_context$12[1],
		                                       0,
		                                       function(a){
		return caml_trampoline_cps_call3(a, lhs1, rhs1, cont);
		                                       })
		                                    : cont(x);
		                           });
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               function _2$2(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$3(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$12, [0, _2$2, compare$34, _0$3]);
		               var
		                cst_Day = "Day",
		                cst_Weekday = "Weekday",
		                letrec_function_context$13 = [];
		               function schema_versioned$13(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$13[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, n$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$13[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$13[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$13[1][1] = b;
		                            var a = [0, int_schema, 0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$6,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_day,
		    cst_Day,
		    int_schema,
		    0],
		   [0,
		    [0,
		     function(param, cont){
		      var f1 = param[2], f0 = param[1];
		      return cont([1, f0, f1]);
		     },
		     function(param, cont){
		      if(0 === param[0]) return cont(0);
		      var f1 = param[2], f0 = param[1];
		      return cont([0, [0, f0, f1]]);
		     },
		     1,
		     0,
		     cst_weekday,
		     cst_Weekday,
		     [0,
		      0,
		      0,
		      [10,
		       function(param, cont){
		        var e1 = param[2][1], e0 = param[1];
		        return cont([0, e0, e1]);
		       },
		       function(param, cont){
		        var e1 = param[2], e0 = param[1];
		        return cont([0, e0, [0, e1, 0]]);
		       },
		       [0, b, a]],
		      0],
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$13[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$13[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$9 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$13, [0, schematic_cache$9]);
		               caml_callback
		                (schema_versioned$13,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$14 = [];
		               function equal$30(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhsperiod = rhs[1], lhsperiod = lhs[1];
		                    return cont(lhsperiod === rhsperiod ? 1 : 0);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var
		                     rhsday = rhs[2],
		                     rhsperiod$0 = rhs[1],
		                     lhsday = lhs[2],
		                     lhsperiod$0 = lhs[1],
		                     c = lhsperiod$0 === rhsperiod$0 ? 1 : 0;
		                    if(! c) return cont(c);
		                    if(lhsday){
		                     if(rhsday){
		                      var b = rhsday[1], a = lhsday[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$14[4], a, b, cont);
		                     }
		                    }
		                    else if(! rhsday) return cont(1);
		                    return cont(0);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var
		                     rhsweekstart = rhs[3],
		                     rhsweekdays = rhs[2],
		                     rhsperiod$1 = rhs[1],
		                     lhsweekstart = lhs[3],
		                     lhsweekdays = lhs[2],
		                     lhsperiod$1 = lhs[1],
		                     c = lhsperiod$1 === rhsperiod$1 ? 1 : 0,
		                     d =
		                       function(a){
		                        return a
		                                ? caml_trampoline_cps_call3
		                                  (letrec_function_context$14[2],
		                                   lhsweekstart,
		                                   rhsweekstart,
		                                   cont)
		                                : cont(a);
		                       };
		                    if(! c) return d(c);
		                    if(lhsweekdays){
		                     if(rhsweekdays){
		                      var b$0 = rhsweekdays[1], a$0 = lhsweekdays[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$14[3], a$0, b$0, d);
		                     }
		                    }
		                    else if(! rhsweekdays) return d(1);
		                    return d(0);
		                   }
		                   break;
		                  case 3:
		                   if(3 === rhs[0]){
		                    var rhsperiod$2 = rhs[1], lhsperiod$2 = lhs[1];
		                    return cont(lhsperiod$2 === rhsperiod$2 ? 1 : 0);
		                   }
		                   break;
		                  default:
		                   if(4 === rhs[0]){
		                    var
		                     rhsmonth = rhs[3],
		                     rhsday$0 = rhs[2],
		                     rhsperiod$3 = rhs[1],
		                     lhsmonth = lhs[3],
		                     lhsday$0 = lhs[2],
		                     lhsperiod$3 = lhs[1],
		                     c = lhsperiod$3 === rhsperiod$3 ? 1 : 0;
		                    a:
		                    if(c){
		                     if(lhsday$0){
		                      if(rhsday$0){
		                       var
		                        b$1 = rhsday$0[1],
		                        a$1 = lhsday$0[1],
		                        c = a$1 === b$1 ? 1 : 0;
		                       break a;
		                      }
		                     }
		                     else if(! rhsday$0){c = 1; break a;}
		                     c = 0;
		                    }
		                    if(! c) return cont(c);
		                    if(lhsmonth){
		                     if(rhsmonth){
		                      var b$2 = rhsmonth[1], a$2 = lhsmonth[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$14[1], a$2, b$2, cont);
		                     }
		                    }
		                    else if(! rhsmonth) return cont(1);
		                    return cont(0);
		                   }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$14,
		                 [0, equal$17, equal$16, equal$28, equal$29]);
		               var letrec_function_context$15 = [];
		               function compare$47(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhsperiod = rhs[1], lhsperiod = lhs[1];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context$15[10],
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (a, lhsperiod, rhsperiod, cont);
		                             });
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var
		                     rhsday = rhs[2],
		                     rhsperiod$0 = rhs[1],
		                     lhsday = lhs[2],
		                     lhsperiod$0 = lhs[1];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context$15[9],
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (a,
		                                       lhsperiod$0,
		                                       rhsperiod$0,
		                                       function(x){
		if(0 !== x) return cont(x);
		if(! lhsday) return rhsday ? cont(-1) : cont(0);
		var a = lhsday[1];
		if(! rhsday) return cont(1);
		var b = rhsday[1];
		return caml_trampoline_cps_call3
		        (letrec_function_context$15[8], a, b, cont);
		                                       });
		                             });
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var
		                     rhsweekstart = rhs[3],
		                     rhsweekdays = rhs[2],
		                     rhsperiod$1 = rhs[1],
		                     lhsweekstart = lhs[3],
		                     lhsweekdays = lhs[2],
		                     lhsperiod$1 = lhs[1];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context$15[7],
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (a,
		                                       lhsperiod$1,
		                                       rhsperiod$1,
		                                       function(x){
		if(0 !== x) return cont(x);
		function c(x){
		 return 0 === x
		         ? caml_trampoline_cps_call3
		           (letrec_function_context$15[5],
		            lhsweekstart,
		            rhsweekstart,
		            cont)
		         : cont(x);
		}
		if(! lhsweekdays) return rhsweekdays ? c(-1) : c(0);
		var a = lhsweekdays[1];
		if(! rhsweekdays) return c(1);
		var b = rhsweekdays[1];
		return caml_trampoline_cps_call3
		        (letrec_function_context$15[6], a, b, c);
		                                       });
		                             });
		                   }
		                   break;
		                  case 3:
		                   if(3 === rhs[0]){
		                    var rhsperiod$2 = rhs[1], lhsperiod$2 = lhs[1];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context$15[4],
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (a, lhsperiod$2, rhsperiod$2, cont);
		                             });
		                   }
		                   break;
		                  default:
		                   if(4 === rhs[0]){
		                    var
		                     rhsmonth = rhs[3],
		                     rhsday$0 = rhs[2],
		                     rhsperiod$3 = rhs[1],
		                     lhsmonth = lhs[3],
		                     lhsday$0 = lhs[2],
		                     lhsperiod$3 = lhs[1];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context$15[3],
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (a,
		                                       lhsperiod$3,
		                                       rhsperiod$3,
		                                       function(x){
		if(0 !== x) return cont(x);
		function c(x){
		 if(0 !== x) return cont(x);
		 if(! lhsmonth) return rhsmonth ? cont(-1) : cont(0);
		 var a = lhsmonth[1];
		 if(! rhsmonth) return cont(1);
		 var b = rhsmonth[1];
		 return caml_trampoline_cps_call3
		         (letrec_function_context$15[1], a, b, cont);
		}
		if(! lhsday$0) return rhsday$0 ? c(-1) : c(0);
		var a = lhsday$0[1];
		if(! rhsday$0) return c(1);
		var b = rhsday$0[1];
		return caml_trampoline_cps_call2
		        (letrec_function_context$15[2],
		         0,
		         function(d){return caml_trampoline_cps_call3(d, a, b, c);});
		                                       });
		                             });
		                   }
		                }
		                function to_int(param){
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   default: return 4;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               function _8$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _7$0(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _6$1(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _3$1(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$3(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$4(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$15,
		                 [0,
		                  compare$35,
		                  _8$0,
		                  _7$0,
		                  _6$1,
		                  compare$34,
		                  compare$45,
		                  _3$1,
		                  compare$46,
		                  _1$3,
		                  _0$4]);
		               var
		                cst_Month = "Month",
		                cst_Week = "Week",
		                cst_Year = "Year",
		                cst_period = "period",
		                letrec_function_context$16 = [];
		               function schema_versioned$14(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$16[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, oa, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$16[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$16[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$16[1][1] = a;
		                            a =
		                             [0,
		                              [0, 0, 0, 0, 0, cst_day, 0, 3, [0, int_schema], 0, 0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_month,
		                                0,
		                                3,
		                                [0, schema_versioned$3(schematic_version)],
		                                0,
		                                0],
		                               0]];
		                            var
		                             default$ = match$26[1],
		                             default$0 = match$27[1],
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_workday,
		                                 "Workday",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var period = param[1];
		                                    return cont(period);
		                                   },
		                                   function(period, cont){return cont([0, period, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_period,
		                                     0,
		                                     [0, default$0],
		                                     [0, int_schema],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f2 = param[3], f1 = param[2], f0 = param[1];
		                                   return cont([4, f0, f1, f2]);
		                                  },
		                                  function(param, cont){
		                                   if(4 !== param[0]) return cont(0);
		                                   var f2 = param[3], f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1, f2]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_year,
		                                  cst_Year,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      month = a[2][1],
		                                      day = a[1],
		                                      period = param[1];
		                                     return cont([0, period, day, month]);
		                                    },
		                                    function(param, cont){
		                                     var month = param[3], day = param[2], period = param[1];
		                                     return cont([0, period, [0, day, [0, month, 0]]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_period,
		                                      0,
		                                      [0, default$],
		                                      [0, int_schema],
		                                      0,
		                                      0],
		                                     a]],
		                                   0],
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$6,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$28[1],
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, "weekstart", 0, [0, default$], [0, c], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$12,
		       schematic_version,
		       function(d){
		        var
		         default$ = match$29[1],
		         c =
		           [0,
		            [0,
		             function(param, cont){
		              var f2 = param[3], f1 = param[2], f0 = param[1];
		              return cont([2, f0, f1, f2]);
		             },
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f2 = param[3], f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1, f2]]);
		             },
		             1,
		             0,
		             cst_week,
		             cst_Week,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 weekstart = a[2][1],
		                 weekdays = a[1],
		                 period = param[1];
		                return cont([0, period, weekdays, weekstart]);
		               },
		               function(param, cont){
		                var
		                 weekstart = param[3],
		                 weekdays = param[2],
		                 period = param[1];
		                return cont([0, period, [0, weekdays, [0, weekstart, 0]]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_period,
		                 0,
		                 [0, default$],
		                 [0, int_schema],
		                 0,
		                 0],
		                [0, [0, 0, 0, 0, 0, cst_weekdays, 0, 3, [0, d], 0, 0], a]]],
		              0],
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$13,
		                 schematic_version,
		                 function(a){
		                  var
		                   default$ = match$30[1],
		                   default$0 = match$31[1],
		                   res =
		                     [11,
		                      ob,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        0,
		                        cst_day,
		                        cst_Day,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var period = param[1];
		                           return cont(period);
		                          },
		                          function(period, cont){return cont([0, period, 0]);},
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_period,
		                            0,
		                            [0, default$0],
		                            [0, int_schema],
		                            0,
		                            0],
		                           0]],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){
		                          var f1 = param[2], f0 = param[1];
		                          return cont([1, f0, f1]);
		                         },
		                         function(param, cont){
		                          if(1 !== param[0]) return cont(0);
		                          var f1 = param[2], f0 = param[1];
		                          return cont([0, [0, f0, f1]]);
		                         },
		                         1,
		                         0,
		                         cst_month,
		                         cst_Month,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var day = param[2][1], period = param[1];
		                            return cont([0, period, day]);
		                           },
		                           function(param, cont){
		                            var day = param[2], period = param[1];
		                            return cont([0, period, [0, day, 0]]);
		                           },
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_period,
		                             0,
		                             [0, default$],
		                             [0, int_schema],
		                             0,
		                             0],
		                            [0, [0, 0, 0, 0, 0, cst_day, 0, 3, [0, a], 0, 0], 0]]],
		                          0],
		                         0],
		                        c]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$16[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$16[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$10 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$16, [0, schematic_cache$10]);
		               var
		                schema$9 =
		                  caml_callback
		                   (schema_versioned$14,
		                    [function(param, cont){return cont(0);}]),
		                cst_Date_range = "Date_range",
		                cst_start = "start",
		                letrec_function_context$17 = [];
		               function dates_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$17[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, oc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$17[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$17[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$17[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(4 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_year,
		                                 cst_Year,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var year = param[1];
		                                    return cont(year);
		                                   },
		                                   function(year, cont){return cont([0, year, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_year, 0, 2, [0, int_schema], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$6,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       cst_hint = "hint",
		                                       b = [0, [0, 0, 0, 0, 0, cst_hint, 0, 3, [0, c], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$5,
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0,
		            [0,
		             function(param, cont){
		              var f2 = param[3], f1 = param[2], f0 = param[1];
		              return cont([2, f0, f1, f2]);
		             },
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f2 = param[3], f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1, f2]]);
		             },
		             1,
		             0,
		             cst_month,
		             cst_Month,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 year = a[2][1],
		                 month = a[1],
		                 hint = param[1];
		                return cont([0, hint, month, year]);
		               },
		               function(param, cont){
		                var year = param[3], month = param[2], hint = param[1];
		                return cont([0, hint, [0, month, [0, year, 0]]]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_hint, 0, 3, [0, int_schema], 0, 0],
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_month,
		                  0,
		                  2,
		                  [0, schema_versioned$3(schematic_version)],
		                  0,
		                  0],
		                 [0,
		                  [0, 0, 0, 0, 0, cst_year, 0, 2, [0, int_schema], 0, 0],
		                  0]]]],
		              0],
		             0],
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([3, f0, f1]);
		              },
		              function(param, cont){
		               if(3 !== param[0]) return cont(0);
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              },
		              1,
		              0,
		              cst_week,
		              cst_Week,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var hint = param[2][1], week = param[1];
		                 return cont([0, week, hint]);
		                },
		                function(param, cont){
		                 var hint = param[2], week = param[1];
		                 return cont([0, week, [0, hint, 0]]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_week, 0, 2, [0, d], 0, 0], b]],
		               0],
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$1,
		                 schematic_version,
		                 function(b){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_start, 0, 2, [0, b], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$1,
		                           schematic_version,
		                           function(d){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([1, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_date_range,
		                                 cst_Date_range,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var start = param[2][1], end = param[1];
		                                    return cont([0, end, start]);
		                                   },
		                                   function(param, cont){
		                                    var start = param[2], end = param[1];
		                                    return cont([0, end, [0, start, 0]]);
		                                   },
		                                   [0, [0, 0, 0, 0, 0, cst_end, 0, 2, [0, d], 0, 0], a]],
		                                  0],
		                                 0],
		                                c];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$1,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  od,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_date,
		    cst_Date,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var date = param[1];
		       return cont(date);
		      },
		      function(date, cont){return cont([0, date, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_date, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$17[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$17[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$11 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$17, [0, schematic_cache$11]);
		               caml_callback
		                (dates_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function first_date(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var date = param[1]; return cont(date);
		                  case 1:
		                   var start = param[2]; return cont(start);
		                  case 2:
		                   var year = param[3], month = param[2], hint = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (make$8,
		                            year,
		                            month,
		                            value$4(hint, 1),
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (ok_or_failwith, a, cont);
		                            });
		                  case 3:
		                   var
		                    hint$0 = param[2],
		                    week = param[1],
		                    weekday = value$4(hint$0, 0),
		                    a = to_int$2(0, weekday);
		                   return caml_exact_trampoline_cps_call
		                           (to_date$2,
		                            week,
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (add_days, b, a, cont);
		                            });
		                  default:
		                   var year$0 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (make$8,
		                            year$0,
		                            0,
		                            1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (ok_or_failwith, a, cont);
		                            });
		                }
		               }
		               function days_to_next_weekday(opt, today, weekday$0, cont){
		                var next = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call
		                        (weekday,
		                         today,
		                         function(a){
		                          a = to_int$2(0, a);
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$23,
		                                   to_int$2(0, weekday$0) - a | 0,
		                                   7,
		                                   function(n){
		                                    if(0 === n && next) return cont(7);
		                                    return cont(n);
		                                   });
		                         });
		               }
		               function days_to_next_weekdays(opt, today, weekdays, cont){
		                var next = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call
		                        (to_weekdays,
		                         weekdays,
		                         function(b){
		                          var a = [0, next];
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$19,
		                                   b,
		                                   function(b, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (days_to_next_weekday, a, today, b, cont);
		                                   },
		                                   function(param){
		                                    var tl = param[2], hd = param[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (min_elt,
		     fold_left$1,
		     tl,
		     phys_compare,
		     function(match){
		      if(! match) return cont(hd);
		      var elt = match[1];
		      return 0 <= caml_int_compare(hd, elt) ? cont(elt) : cont(hd);
		     });
		                                   });
		                         });
		               }
		               var
		                open$0 =
		                  g
		                   ([0,
		                     symbol_bind$5,
		                     symbol_map$5,
		                     ,
		                     bind$8,
		                     return$9,
		                     map$17,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$3]),
		                symbol_map$8 = open$0[2],
		                let$1 = open$0[3],
		                let$2 = open$0[4],
		                and$1 = open$0[5],
		                letrec_function_context$18 = [];
		               function equal$31(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                return c
		                        ? caml_trampoline_cps_call3
		                          (letrec_function_context$18[1], lhs[3], rhs[3], cont)
		                        : cont(c);
		               }
		               caml_update_dummy(letrec_function_context$18, [0, equal$16]);
		               function first(starting, year, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_date$0,
		                         year,
		                         0,
		                         function(jan1){
		                          return caml_exact_trampoline_cps_call
		                                  (weekday,
		                                   jan1,
		                                   function(jan1_weekday){
		                                    return caml_exact_trampoline_cps_call$1
		    (add_days,
		     jan1,
		     - to_int$2([0, starting], jan1_weekday) | 0,
		     function(jan1_weekstart){
		      if(jan1_weekstart[3] < year && 29 > jan1_weekstart[1])
		       return caml_exact_trampoline_cps_call$1
		               (add_days, jan1_weekstart, 7, cont);
		      return cont(jan1_weekstart);
		     });
		                                   });
		                         });
		               }
		               function of_date$2(opt, date, cont){
		                var weekstart = opt ? opt[1] : 0;
		                function of_date_in_bounds
		                (weekstart, year, first_week_start, date){
		                 var
		                  a = to_int$3(first_week_start),
		                  n = ((to_int$3(date) - a | 0) / 7 | 0) + 1 | 0;
		                 return [0, year, n, weekstart];
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (first,
		                         weekstart,
		                         date[3],
		                         function(first_week_start){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$83,
		                                   date,
		                                   first_week_start,
		                                   function(a){
		                                    if(! a)
		                                     return caml_exact_trampoline_cps_call$1
		     (first,
		      weekstart,
		      date[3] + 1 | 0,
		      function(next_first_week_start){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$79,
		                date,
		                next_first_week_start,
		                function(a){
		                 return a
		                         ? cont
		                           (of_date_in_bounds
		                             (weekstart, date[3] + 1 | 0, next_first_week_start, date))
		                         : cont
		                           (of_date_in_bounds
		                             (weekstart, date[3], first_week_start, date));
		                });
		      });
		                                    var year = date[3] - 1 | 0;
		                                    return caml_exact_trampoline_cps_call$1
		    (first,
		     weekstart,
		     year,
		     function(prev_first_week_start){
		      return cont
		              (of_date_in_bounds
		                (weekstart, year, prev_first_week_start, date));
		     });
		                                   });
		                         });
		               }
		               function pp$22(f, a, cont){
		                switch(a[0]){
		                  case 0:
		                   var period = a[1];
		                   return 1 === period
		                           ? caml_exact_trampoline_cps_call(fprintf$0(f), oe, cont)
		                           : caml_exact_trampoline_cps_call
		                             (fprintf$0(f),
		                              of,
		                              function(a){
		                               return caml_trampoline_cps_call2(a, period, cont);
		                              });
		                  case 1:
		                   var period$0 = a[1];
		                   if(1 === period$0){
		                    a = a[2];
		                    if(! a)
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(f), oi, cont);
		                    a = a[1];
		                    if(0 === a[0]){
		                     var day = a[1];
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(f),
		                              og,
		                              function(a){
		                               return caml_trampoline_cps_call3(a, pp_nth, day, cont);
		                              });
		                    }
		                    var k = a[2], weekday = a[1];
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             oh,
		                             function(a){
		                              return caml_trampoline_cps_call5
		                                      (a, pp_nth, k, _11, weekday, cont);
		                             });
		                   }
		                   a = a[2];
		                   if(! a)
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             ol,
		                             function(a){
		                              return caml_trampoline_cps_call2(a, period$0, cont);
		                             });
		                   a = a[1];
		                   if(0 === a[0]){
		                    var day$0 = a[1];
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             oj,
		                             function(a){
		                              return caml_trampoline_cps_call4
		                                      (a, period$0, pp_nth, day$0, cont);
		                             });
		                   }
		                   var k$0 = a[2], weekday$0 = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            ok,
		                            function(a){
		                             return caml_trampoline_cps_call6
		                                     (a, period$0, pp_nth, k$0, _11, weekday$0, cont);
		                            });
		                  case 2:
		                   var period$1 = a[1];
		                   if(1 === period$1){
		                    a = a[2];
		                    if(! a)
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(f), on, cont);
		                    var weekdays = a[1];
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             om,
		                             function(a){
		                              return caml_trampoline_cps_call3(a, pp$21, weekdays, cont);
		                             });
		                   }
		                   var match = a[2];
		                   if(! match)
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             oq,
		                             function(a){
		                              return caml_trampoline_cps_call2(a, period$1, cont);
		                             });
		                   var weekdays$0 = match[1];
		                   if(! a[3])
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             op,
		                             function(a){
		                              return caml_trampoline_cps_call4
		                                      (a, period$1, pp$21, weekdays$0, cont);
		                             });
		                   var weekstart = a[3];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            oo,
		                            function(a){
		                             return caml_trampoline_cps_call6
		                                     (a, period$1, _11, weekstart, pp$21, weekdays$0, cont);
		                            });
		                  case 3:
		                   var period$2 = a[1];
		                   return 1 === period$2
		                           ? caml_exact_trampoline_cps_call(fprintf$0(f), or, cont)
		                           : caml_exact_trampoline_cps_call
		                             (fprintf$0(f),
		                              os,
		                              function(a){
		                               return caml_trampoline_cps_call2(a, period$2, cont);
		                              });
		                  default:
		                   var period$3 = a[1];
		                   if(1 === period$3){
		                    var day$1 = a[2];
		                    if(! day$1 && ! a[3])
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(f), ou, cont);
		                    var
		                     month = a[3],
		                     b = value$4(day$1, 1),
		                     c = value$4(month, 0);
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             ot,
		                             function(a){
		                              return caml_trampoline_cps_call5
		                                      (a, pp$11, c, pp_nth, b, cont);
		                             });
		                   }
		                   if(! a[2] && ! a[3])
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(f),
		                             ow,
		                             function(a){
		                              return caml_trampoline_cps_call2(a, period$3, cont);
		                             });
		                   var
		                    month$0 = a[3],
		                    day$2 = a[2],
		                    d = value$4(day$2, 1),
		                    e = value$4(month$0, 0);
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            ov,
		                            function(a){
		                             return caml_trampoline_cps_call6
		                                     (a, period$3, pp$11, e, pp_nth, d, cont);
		                            });
		                }
		               }
		               function week(weekdays, opt, period){
		                var weekstart = opt ? opt[1] : 0;
		                return [2, period, weekdays, weekstart];
		               }
		               var letrec_function_context$19 = [];
		               function equal_boundaries(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhscount = lhs[2], lhsstart = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhscount = rhs[2], rhsstart = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$19[3],
		                           lhsstart,
		                           rhsstart,
		                           function(a){
		                            return a ? cont(lhscount === rhscount ? 1 : 0) : cont(a);
		                           });
		                 }
		                }
		                else {
		                 var lhsstart$0 = lhs[2], lhsend = lhs[1];
		                 if(0 !== rhs[0]){
		                  var
		                   rhsstart$0 = rhs[2],
		                   rhsend = rhs[1],
		                   c =
		                     function(c){
		                      if(! c) return cont(c);
		                      if(lhsstart$0){
		                       if(rhsstart$0){
		                        var b = rhsstart$0[1], a = lhsstart$0[1];
		                        return caml_trampoline_cps_call3
		                                (letrec_function_context$19[1], a, b, cont);
		                       }
		                      }
		                      else if(! rhsstart$0) return cont(1);
		                      return cont(0);
		                     };
		                  if(lhsend){
		                   if(rhsend){
		                    var b = rhsend[1], a = lhsend[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$19[2], a, b, c);
		                   }
		                  }
		                  else if(! rhsend) return c(1);
		                  return c(0);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$19,
		                 [0, equal$21, equal$21, equal$21]);
		               var letrec_function_context$20 = [];
		               function compare_boundaries(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhscount = lhs[2], lhsstart = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhscount = rhs[2], rhsstart = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$20[4],
		                           lhsstart,
		                           rhsstart,
		                           function(x){
		                            return 0 === x
		                                    ? caml_trampoline_cps_call2
		                                      (letrec_function_context$20[3],
		                                       0,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (a, lhscount, rhscount, cont);
		                                       })
		                                    : cont(x);
		                           });
		                 }
		                }
		                else {
		                 var lhsstart$0 = lhs[2], lhsend = lhs[1];
		                 if(0 !== rhs[0]){
		                  var
		                   rhsstart$0 = rhs[2],
		                   rhsend = rhs[1],
		                   c =
		                     function(x){
		                      if(0 !== x) return cont(x);
		                      if(! lhsstart$0) return rhsstart$0 ? cont(-1) : cont(0);
		                      var a = lhsstart$0[1];
		                      if(! rhsstart$0) return cont(1);
		                      var b = rhsstart$0[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$20[1], a, b, cont);
		                     };
		                  if(! lhsend) return rhsend ? c(-1) : c(0);
		                  var a = lhsend[1];
		                  if(! rhsend) return c(1);
		                  var b = rhsend[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$20[2], a, b, c);
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var d = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), d));
		               }
		               function _1$4(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$20,
		                 [0, compare$39, compare$39, _1$4, compare$39]);
		               var
		                cst_Count = "Count",
		                cst_Dates = "Dates",
		                cst_dates = "dates",
		                letrec_function_context$21 = [];
		               function boundaries_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$21[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ox, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$21[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$21[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$21[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_start, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$1,
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([1, f0, f1]);
		             },
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_dates,
		             cst_Dates,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var start = param[2][1], end = param[1];
		                return cont([0, end, start]);
		               },
		               function(param, cont){
		                var start = param[2], end = param[1];
		                return cont([0, end, [0, start, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_end, 0, 3, [0, d], 0, 0], a]],
		              0],
		             0],
		            0],
		         c =
		           [0,
		            [0, 0, 0, 0, 0, cst_count, 0, 2, [0, int_schema], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$1,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, f0, f1]);
		                        },
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, [0, f0, f1]]);
		                        },
		                        1,
		                        0,
		                        cst_count,
		                        cst_Count,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var count = param[2][1], start = param[1];
		                           return cont([0, start, count]);
		                          },
		                          function(param, cont){
		                           var count = param[2], start = param[1];
		                           return cont([0, start, [0, count, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_start, 0, 2, [0, a], 0, 0], c]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$21[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$21[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$12 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$21, [0, schematic_cache$12]);
		               caml_callback
		                (boundaries_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$22 = [];
		               function equal$32(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$22[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$22[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$22, [0, equal$30, equal_boundaries]);
		               var letrec_function_context$23 = [];
		               function compare$48(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$23[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$23[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$23,
		                 [0, compare$47, compare_boundaries]);
		               var letrec_function_context$24 = [];
		               function schema_versioned$15(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$24[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, oy, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$24[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$24[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$24[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$14,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_rule, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (boundaries_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         default$ = match$32[1],
		         res =
		           [7,
		            function(param, cont){
		             var rule = param[2][1], boundaries = param[1];
		             return cont([0, boundaries, rule]);
		            },
		            function(param, cont){
		             var rule = param[2], boundaries = param[1];
		             return cont([0, boundaries, [0, rule, 0]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_boundaries,
		              0,
		              [0, default$],
		              [1, b],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$24[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$24[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$13 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$24, [0, schematic_cache$13]);
		               var
		                schema$10 =
		                  caml_callback
		                   (schema_versioned$15,
		                    [function(param, cont){return cont(0);}]);
		               function pp_boundaries(f, param, cont){
		                if(0 === param[0]){
		                 var count = param[2], start = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          oz,
		                          function(a){
		                           return caml_trampoline_cps_call4
		                                   (a, count, pp_v1$0, start, cont);
		                          });
		                }
		                var start$0 = param[2], end = param[1];
		                function a(ppf, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_none, ppf, dummy, cont);
		                 var v = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          ppf,
		                          " until ",
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_v1$0, ppf, v, cont);
		                          });
		                }
		                function b(ppf, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_none, ppf, dummy, cont);
		                 var v = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          ppf,
		                          " starting ",
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_v1$0, ppf, v, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         oA,
		                         function(c){
		                          return caml_trampoline_cps_call5
		                                  (c, b, start$0, a, end, cont);
		                         });
		               }
		               function pp$23(f, param, cont){
		                var rule = param[2], boundaries = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         oB,
		                         function(a){
		                          return caml_trampoline_cps_call5
		                                  (a, pp$22, rule, pp_boundaries, boundaries, cont);
		                         });
		               }
		               function start_date(a){
		                a = a[1];
		                if(0 === a[0]){var start = a[1]; return [0, start];}
		                var start$0 = a[2];
		                return start$0;
		               }
		               function weekly_weekdays(weekdays, start, cont){
		                if(weekdays){
		                 var weekdays$0 = weekdays[1];
		                 return cont(weekdays$0);
		                }
		                if(! start) return cont(monday);
		                var start$0 = start[1];
		                return caml_exact_trampoline_cps_call
		                        (weekday,
		                         start$0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_weekdays, [0, a, 0], cont);
		                         });
		               }
		               var workdays = make$11(oG, oF, oE, oD, oC, 0, 0);
		               function day_of_month_day(year, month, month_day, cont){
		                var match = value$4(month_day, oH);
		                if(0 === match[0]){var day = match[1]; return cont(day);}
		                var nth = match[2], weekday$0 = match[1];
		                function first_weekday_of_month(year, month, weekday$0, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (to_date$0,
		                          year,
		                          month,
		                          function(month_start){
		                           return caml_exact_trampoline_cps_call
		                                   (weekday,
		                                    month_start,
		                                    function(a){
		                                     return cont(to_int$2([0, a], weekday$0) + 1 | 0);
		                                    });
		                          });
		                }
		                if(0 > nth)
		                 return caml_exact_trampoline_cps_call$3
		                         (make_overflow,
		                          0,
		                          year,
		                          to_int$1(month) + 1 | 0,
		                          1,
		                          dummy,
		                          function(match){
		                           var year = match[3], month = match[2];
		                           return caml_exact_trampoline_cps_call$0
		                                   (first_weekday_of_month,
		                                    year,
		                                    month,
		                                    weekday$0,
		                                    function(day){
		                                     return caml_exact_trampoline_cps_call$3
		     (make_overflow,
		      0,
		      year,
		      to_int$1(month),
		      day - 7 | 0,
		      dummy,
		      function(match){var day = match[1]; return cont(day);});
		                                    });
		                          });
		                var a = (nth - 1 | 0) * 7 | 0;
		                return caml_exact_trampoline_cps_call$0
		                        (first_weekday_of_month,
		                         year,
		                         month,
		                         weekday$0,
		                         function(b){return cont(b + a | 0);});
		               }
		               function add_months(param, n, cont){
		                var month = param[2], year = param[1];
		                return caml_exact_trampoline_cps_call$3
		                        (make_overflow,
		                         0,
		                         year,
		                         to_int$1(month) + n | 0,
		                         1,
		                         dummy,
		                         function(match){
		                          var year = match[3], month = match[2];
		                          return cont([0, year, month]);
		                         });
		               }
		               function is_before_end(t, cont){
		                var a = t[3][1];
		                if(0 === a[0]){
		                 var count = a[2];
		                 return cont(t[2] < count ? 1 : 0);
		                }
		                a = a[1];
		                if(! a) return cont(1);
		                var end = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$80, t[1], end, cont);
		               }
		               function increment(remaining, t, cont){
		                var
		                 recurrence = t[3],
		                 nth = t[2],
		                 date = t[1],
		                 a = recurrence[2];
		                function c(date){
		                 var t$0 = [0, date, nth + remaining | 0, t[3]];
		                 return caml_exact_trampoline_cps_call
		                         (is_before_end,
		                          t$0,
		                          function(a){return cont(some_if(a, t$0));});
		                }
		                switch(a[0]){
		                  case 0:
		                   var period = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (add_days, date, caml_mul(remaining, period), c);
		                  case 1:
		                   var period$0 = a[1], month_day = a[2];
		                   if(month_day){
		                    var b = month_day[1];
		                    if(0 === b[0])
		                     var n = b[1], b = 28 < n;
		                    else
		                     var n$0 = b[2], b = 4 < n$0;
		                   }
		                   else
		                    b = 0;
		                   if(! b){
		                    var month_day$0 = a[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (add_months,
		                             [0, date[3], date[2]],
		                             caml_mul(period$0, remaining),
		                             function(match){
		                              var month = match[2], year = match[1];
		                              return caml_exact_trampoline_cps_call$0
		                                      (day_of_month_day,
		                                       year,
		                                       month,
		                                       month_day$0,
		                                       function(a){
		return caml_exact_trampoline_cps_call$3
		        (make_overflow, 0, year, to_int$1(month), a, dummy, c);
		                                       });
		                             });
		                   }
		                   if(0 === remaining) return c(date);
		                   var
		                    month = date[2],
		                    year = date[3],
		                    d =
		                      function(year, month, remaining){
		                       return caml_exact_trampoline_cps_call$1
		                               (add_months,
		                                [0, year, month],
		                                period$0,
		                                function(match){
		                                 var month = match[2], year = match[1];
		                                 return caml_exact_trampoline_cps_call$0
		 (day_of_month_day,
		  year,
		  month,
		  month_day,
		  function(a){
		   return caml_exact_trampoline_cps_call$0
		           (make$8,
		            year,
		            month,
		            a,
		            function(match){
		             if(0 !== match[0])
		              return caml_exact_trampoline_call3
		                      (d, year, month, remaining);
		             var date = match[1];
		             if(1 >= remaining) return c(date);
		             var remaining$0 = remaining - 1 | 0;
		             return caml_exact_trampoline_call3
		                     (d, year, month, remaining$0);
		            });
		  });
		                                });
		                      };
		                   return d(year, month, remaining);
		                  case 2:
		                   var weekstart = a[3], weekdays = a[2], period$1 = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (weekly_weekdays,
		                            weekdays,
		                            start_date(recurrence),
		                            function(weekdays){
		                             return caml_exact_trampoline_cps_call
		                                     (length$12,
		                                      weekdays,
		                                      function(length){
		                                       var weeks = caml_div(remaining, length);
		                                       function a(n, date){
		return 0 === n
		        ? c(date)
		        : caml_exact_trampoline_cps_call$1
		          (of_date$2,
		           [0, weekstart],
		           date,
		           function(old_week){
		            var t = range$0(0, 0, 0, 0, n), next = t[2], seed = t[1];
		            function a(seed, date){
		             return caml_trampoline_cps_call2
		                     (next,
		                      seed,
		                      function(match){
		                       if(typeof match === "number")
		                        return caml_exact_trampoline_cps_call$1
		                                (of_date$2,
		                                 [0, weekstart],
		                                 date,
		                                 function(new_week){
		                                  return 1 === period$1
		  ? c(date)
		  : caml_exact_trampoline_cps_call$1
		    (equal$31,
		     new_week,
		     old_week,
		     function(a){
		      return a
		              ? c(date)
		              : caml_exact_trampoline_cps_call$1
		                (add_days, date, 7 * (period$1 - 1 | 0) | 0, c);
		     });
		                                 });
		                       if(0 === match[0]){
		                        var seed = match[1];
		                        return caml_exact_trampoline_call2(a, seed, date);
		                       }
		                       var seed$0 = match[2];
		                       return caml_exact_trampoline_cps_call$0
		                               (days_to_next_weekdays,
		                                oI,
		                                date,
		                                weekdays,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call$1
		 (add_days,
		  date,
		  b,
		  function(v){
		   return caml_exact_trampoline_call2(a, seed$0, v);
		  });
		                                });
		                      });
		            }
		            return a(seed, date);
		           });
		                                       }
		                                       return 0 === weeks
		       ? a(remaining, date)
		       : caml_exact_trampoline_cps_call$1
		         (add_days,
		          date,
		          caml_mul(7 * weeks | 0, period$1),
		          function(date){
		           return caml_exact_trampoline_cps_call$1
		                   (symbol$23,
		                    remaining,
		                    length,
		                    function(b){return a(b, date);});
		          });
		                                      });
		                            });
		                  case 3:
		                   var
		                    period$2 = a[1],
		                    period$3 = caml_mul(period$2, remaining),
		                    weeks = period$3 / 5 | 0,
		                    f =
		                      function(date, period){
		                       var
		                        t = range$0(0, 0, 0, 0, period),
		                        next = t[2],
		                        seed = t[1];
		                       function a(seed, date){
		                        return caml_trampoline_cps_call2
		                                (next,
		                                 seed,
		                                 function(match){
		                                  if(typeof match === "number") return c(date);
		                                  if(0 === match[0]){
		                                   var seed = match[1];
		                                   return caml_exact_trampoline_call2(a, seed, date);
		                                  }
		                                  var seed$0 = match[2];
		                                  return caml_exact_trampoline_cps_call$0
		  (days_to_next_weekdays,
		   oJ,
		   date,
		   workdays,
		   function(b){
		    return caml_exact_trampoline_cps_call$1
		            (add_days,
		             date,
		             b,
		             function(v){
		              return caml_exact_trampoline_call2(a, seed$0, v);
		             });
		   });
		                                 });
		                       }
		                       return a(seed, date);
		                      };
		                   return 0 === weeks
		                           ? f(date, period$3)
		                           : caml_exact_trampoline_cps_call$1
		                             (symbol$23,
		                              period$3,
		                              5,
		                              function(period){
		                               return caml_exact_trampoline_cps_call$1
		                                       (add_days,
		date,
		7 * weeks | 0,
		function(a){return f(a, period);});
		                              });
		                  default:
		                   var period$4 = a[1], b = a[2];
		                   if(b && 29 === b[1]){
		                    b = a[3];
		                    if(b && 1 === b[1]){
		                     if(0 === remaining) return c(date);
		                     var
		                      year$0 = date[3],
		                      e =
		                        function(year, remaining){
		                         var year$0 = year + period$4 | 0;
		                         return caml_exact_trampoline_cps_call$0
		                                 (make$8,
		                                  year$0,
		                                  1,
		                                  29,
		                                  function(match){
		                                   if(0 !== match[0])
		                                    return caml_exact_trampoline_call2(e, year$0, remaining);
		                                   var date = match[1];
		                                   if(1 >= remaining) return c(date);
		                                   var remaining$0 = remaining - 1 | 0;
		                                   return caml_exact_trampoline_call2(e, year$0, remaining$0);
		                                  });
		                        };
		                     return e(year$0, remaining);
		                    }
		                   }
		                   var
		                    month$0 = a[3],
		                    day = a[2],
		                    period$5 = caml_mul(period$4, remaining),
		                    month$1 = value$4(month$0, 0),
		                    day$0 = value$4(day, 1),
		                    a = to_int$1(month$1);
		                   return caml_exact_trampoline_cps_call$3
		                           (make_overflow,
		                            oK,
		                            date[3] + period$5 | 0,
		                            a,
		                            day$0,
		                            dummy,
		                            c);
		                }
		               }
		               function snap(recurrence, date, cont){
		                var rule = recurrence[2], start = start_date(recurrence);
		                function a(date){
		                 function snap(a, cont){
		                  a:
		                  {
		                   b:
		                   {
		                    c:
		                    {
		                     d:
		                     for(;;)
		                      switch(a[0]){
		                        case 0:
		                         break a;
		                        case 1:
		                         break b;
		                        case 2:
		                         break c;
		                        case 3:
		                         var period$2 = a[1];
		                         a = week([0, workdays], 0, period$2);
		                         break;
		                        default: break d;
		                      }
		                     var period$3 = a[1], b = a[2];
		                     if(b && 29 === b[1]){
		                      b = a[3];
		                      if(b && 1 === b[1]){
		                       if(start)
		                        var
		                         start$2 = start[1],
		                         step$0 = period$3,
		                         first$2 = start$2[3];
		                       else
		                        var first$3 = date[3], step$0 = 1, first$2 = first$3;
		                       var
		                        d =
		                          function(year, nth){
		                           return caml_exact_trampoline_cps_call$0
		                                   (make$8,
		                                    year,
		                                    1,
		                                    29,
		                                    function(match){
		                                     if(0 === match[0]){
		                                      var occurrence = match[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$79,
		       occurrence,
		       date,
		       function(a){
		        if(a) return cont([0, occurrence, nth]);
		        var nth$0 = nth + 1 | 0, year$0 = year + step$0 | 0;
		        return caml_exact_trampoline_call2(d, year$0, nth$0);
		       });
		                                     }
		                                     var year$0 = year + step$0 | 0;
		                                     return caml_exact_trampoline_call2(d, year$0, nth);
		                                    });
		                          };
		                       return d(first$2, 0);
		                      }
		                     }
		                     var
		                      month = a[3],
		                      day = a[2],
		                      month$0 = value$4(month, 0),
		                      day$0 = value$4(day, 1),
		                      b = to_int$1(month$0);
		                     return caml_exact_trampoline_cps_call$3
		                             (make_overflow,
		                              oN,
		                              date[3],
		                              b,
		                              day$0,
		                              dummy,
		                              function(this_year_occurrence){
		                               return caml_exact_trampoline_cps_call$1
		                                       (symbol$80,
		date,
		this_year_occurrence,
		function(a){
		 function b(date){
		  if(! start) return cont([0, date, 0]);
		  var start$0 = start[1], years = date[3] - start$0[3] | 0;
		  return caml_exact_trampoline_cps_call$1
		          (symbol$23,
		           years,
		           period$3,
		           function(n){
		            if(0 === n)
		             return cont([0, date, caml_div(years, period$3)]);
		            var
		             a = caml_div(years, period$3) + 1 | 0,
		             b = date[1],
		             c = to_int$1(date[2]);
		            return caml_exact_trampoline_cps_call$3
		                    (make_overflow,
		                     oO,
		                     (date[3] - n | 0) + period$3 | 0,
		                     c,
		                     b,
		                     dummy,
		                     function(b){return cont([0, b, a]);});
		           });
		 }
		 if(a) return b(this_year_occurrence);
		 a = to_int$1(month$0);
		 return caml_exact_trampoline_cps_call$3
		         (make_overflow, oP, date[3] + 1 | 0, a, day$0, dummy, b);
		});
		                              });
		                    }
		                    var weekstart = a[3], weekdays = a[2], period$1 = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (weekly_weekdays,
		                             weekdays,
		                             start,
		                             function(weekdays){
		                              return caml_exact_trampoline_cps_call$0
		                                      (days_to_next_weekdays,
		                                       oL,
		                                       date,
		                                       weekdays,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (add_days,
		         date,
		         a,
		         function(date){
		          function a(date, nth){
		           return caml_exact_trampoline_cps_call$0
		                   (days_to_next_weekdays,
		                    oM,
		                    date,
		                    weekdays,
		                    function(n){
		                     return 0 === n
		                             ? cont([0, date, nth])
		                             : caml_exact_trampoline_cps_call$1
		                               (add_days, date, n, function(a){return cont([0, a, nth]);});
		                    });
		          }
		          if(! start) return a(date, 0);
		          var start$0 = start[1];
		          return caml_exact_trampoline_cps_call$1
		                  (symbol$23,
		                   to_int$2(0, weekstart) - 1 | 0,
		                   7,
		                   function(k){
		                    var k$0 = 0 <= k ? k : k + 7 | 0;
		                    if(6 < k$0 >>> 0)
		                     var b = 0;
		                    else
		                     switch(k$0){
		                       case 0:
		                        b = lO; break;
		                       case 1:
		                        b = lP; break;
		                       case 2:
		                        b = lQ; break;
		                       case 3:
		                        b = lR; break;
		                       case 4:
		                        b = lS; break;
		                       case 5:
		                        b = lT; break;
		                       default: b = lU;
		                     }
		                    return caml_exact_trampoline_cps_call$2
		                            (value_exn,
		                             lV,
		                             0,
		                             0,
		                             b,
		                             function(week_end){
		                              return caml_exact_trampoline_cps_call$1
		                                      (of_date$2,
		                                       [0, weekstart],
		                                       start$0,
		                                       function(start_week){
		return caml_exact_trampoline_cps_call$1
		        (of_date$2,
		         [0, weekstart],
		         date,
		         function(current_week){
		          function b(start_weekdays_until_sunday, cont){
		           return cont
		                   (intersection(start_weekdays_until_sunday, until(week_end)));
		          }
		          return caml_exact_trampoline_cps_call
		                  (weekday,
		                   start$0,
		                   function(c){
		                    return caml_trampoline_cps_call3
		                            (let$1,
		                             intersection(weekdays, starting(c)),
		                             b,
		                             function(first_week_days){
		                              function b(current_week_days_starting_mon, cont){
		                               return cont
		                                       (intersection
		 (current_week_days_starting_mon, starting(weekstart)));
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (weekday,
		                                       date,
		                                       function(day){
		return caml_trampoline_cps_call3
		        (let$1,
		         intersection(weekdays, until(day)),
		         b,
		         function(current_week_days){
		          return caml_exact_trampoline_cps_call$1
		                  (equal$31,
		                   start_week,
		                   current_week,
		                   function(c){
		                    if(c){
		                     var
		                      b =
		                        function(param, cont){
		                         var
		                          current_week_days = param[2],
		                          first_week_days = param[1];
		                         return caml_trampoline_cps_call3
		                                 (symbol_map$8,
		                                  intersection(first_week_days, current_week_days),
		                                  length$12,
		                                  cont);
		                        };
		                     return caml_trampoline_cps_call3
		                             (and$1,
		                              first_week_days,
		                              current_week_days,
		                              function(c){
		                               return caml_trampoline_cps_call3
		                                       (let$1,
		c,
		b,
		function(days){
		 var nth = value$4(days, 0) - 1 | 0;
		 return a(date, nth);
		});
		                              });
		                    }
		                    function week_to_int(week, cont){
		                     var weekstart = week[3], n = week[2], year = week[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (first,
		                              weekstart,
		                              year,
		                              function(first_week_start){
		                               return caml_exact_trampoline_cps_call$1
		                                       (add_days,
		first_week_start,
		(n - 1 | 0) * 7 | 0,
		function(a){return cont(to_int$3(a));});
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (week_to_int,
		                             current_week,
		                             function(current){
		                              return caml_exact_trampoline_cps_call
		                                      (week_to_int,
		                                       start_week,
		                                       function(start){
		var weeks = (current - start | 0) / 7 | 0;
		return caml_trampoline_cps_call3
		        (symbol_map$8,
		         current_week_days,
		         length$12,
		         function(b){
		          var current_week_days = value$4(b, 0);
		          return caml_trampoline_cps_call3
		                  (symbol_map$8,
		                   first_week_days,
		                   length$12,
		                   function(c){
		                    var
		                     first_week_days = value$4(c, 0),
		                     b = caml_div(weeks, period$1) - 1 | 0;
		                    return caml_exact_trampoline_cps_call
		                            (length$12,
		                             weekdays,
		                             function(c){
		                              var
		                               nth_until_current_week =
		                                 first_week_days + caml_mul(c, b) | 0;
		                              return caml_exact_trampoline_cps_call$1
		                                      (symbol$23,
		                                       weeks,
		                                       period$1,
		                                       function(n){
		return 0 === n
		        ? a
		          (date,
		           (nth_until_current_week + current_week_days | 0) - 1 | 0)
		        : caml_exact_trampoline_cps_call$1
		          (add_days,
		           date,
		           (period$1 - n | 0) * 7 | 0,
		           function(date){
		            return a
		                    (date, nth_until_current_week + current_week_days | 0);
		           });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   }
		                   var period$0 = a[1], month_day = a[2];
		                   if(month_day){
		                    b = month_day[1];
		                    if(0 === b[0])
		                     var n = b[1], b = 28 < n;
		                    else
		                     var n$0 = b[2], b = 4 < n$0;
		                   }
		                   else
		                    b = 0;
		                   if(! b){
		                    var month_day$0 = a[2], e = date[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (day_of_month_day,
		                             date[3],
		                             date[2],
		                             month_day$0,
		                             function(b){
		                              function a(year, month){
		                               var month$0 = to_int$1(month);
		                               function a(month, nth){
		                                return caml_exact_trampoline_cps_call$3
		(make_overflow,
		 0,
		 year,
		 month,
		 1,
		 dummy,
		 function(match){
		  var year = match[3], month = match[2];
		  return caml_exact_trampoline_cps_call$0
		          (day_of_month_day,
		           year,
		           month,
		           month_day$0,
		           function(a){
		            return caml_exact_trampoline_cps_call$3
		                    (make_overflow,
		                     0,
		                     year,
		                     to_int$1(month),
		                     a,
		                     dummy,
		                     function(a){return cont([0, a, nth]);});
		           });
		 });
		                               }
		                               if(! start) return a(month$0, 0);
		                               var
		                                start$0 = start[1],
		                                b = (year - start$0[3] | 0) * 12 | 0,
		                                months = (month$0 - to_int$1(start$0[2]) | 0) + b | 0;
		                               return caml_exact_trampoline_cps_call$1
		                                       (symbol$23,
		months,
		period$0,
		function(n){
		 if(0 !== n)
		  return a
		          ((month$0 - n | 0) + period$0 | 0,
		           caml_div(months, period$0) + 1 | 0);
		 var nth = caml_div(months, period$0);
		 return a(month$0, nth);
		});
		                              }
		                              return e <= b
		                                      ? a(date[3], date[2])
		                                      : caml_exact_trampoline_cps_call$1
		(add_months,
		 [0, date[3], date[2]],
		 1,
		 function(b){
		  var month = b[2], year = b[1];
		  return a(year, month);
		 });
		                             });
		                   }
		                   if(start)
		                    var
		                     start$1 = start[1],
		                     step = period$0,
		                     first$0 = [0, start$1[3], start$1[2]];
		                   else
		                    var
		                     first$1 = [0, date[3], date[2]],
		                     step = 1,
		                     first$0 = first$1;
		                   var
		                    c =
		                      function(ym, nth){
		                       var month = ym[2], year = ym[1];
		                       return caml_exact_trampoline_cps_call$0
		                               (day_of_month_day,
		                                year,
		                                month,
		                                month_day,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$0
		 (make$8,
		  year,
		  month,
		  a,
		  function(match){
		   if(0 !== match[0])
		    return caml_exact_trampoline_cps_call$1
		            (add_months,
		             ym,
		             step,
		             function(ym){
		              return caml_exact_trampoline_call2(c, ym, nth);
		             });
		   var occurrence = match[1];
		   return caml_exact_trampoline_cps_call$1
		           (symbol$79,
		            occurrence,
		            date,
		            function(a){
		             if(a) return cont([0, occurrence, nth]);
		             var nth$0 = nth + 1 | 0;
		             return caml_exact_trampoline_cps_call$1
		                     (add_months,
		                      ym,
		                      step,
		                      function(ym){
		                       return caml_exact_trampoline_call2(c, ym, nth$0);
		                      });
		            });
		  });
		                                });
		                      };
		                   return c(first$0, 0);
		                  }
		                  var period = a[1];
		                  if(! start) return cont([0, date, 0]);
		                  var
		                   start$0 = start[1],
		                   a = to_int$3(start$0),
		                   days = to_int$3(date) - a | 0,
		                   periods = caml_div(days, period);
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$23,
		                           days,
		                           period,
		                           function(n){
		                            if(0 === n) return cont([0, date, periods]);
		                            var a = periods + 1 | 0;
		                            return caml_exact_trampoline_cps_call$1
		                                    (add_days,
		                                     date,
		                                     period - n | 0,
		                                     function(b){return cont([0, b, a]);});
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (snap,
		                          rule,
		                          function(match){
		                           var
		                            nth = match[2],
		                            date = match[1],
		                            t = [0, date, nth, recurrence];
		                           return caml_exact_trampoline_cps_call
		                                   (is_before_end, t, function(a){return cont(some_if(a, t));});
		                          });
		                }
		                if(! start) return a(date);
		                var start$0 = start[1];
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$82,
		                         start$0,
		                         date,
		                         function(b){return b ? a(start$0) : a(date);});
		               }
		               var bPB = 1;
		               function occurrences(start, recurrence, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (snap,
		                         recurrence,
		                         start,
		                         function(match){
		                          if(! match) return cont(empty$6);
		                          var first = match[1];
		                          return cont
		                                  (unfold$0
		                                    (first,
		                                     function(occurrence, cont){
		                                      function a(next, cont){
		                                       return cont([0, occurrence[1], next]);
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (increment,
		       bPB,
		       occurrence,
		       function(b){
		        return caml_trampoline_cps_call3(let$2, b, a, cont);
		       });
		                                     }));
		                         });
		               }
		               function occurrences_count(today, recurrence, cont){
		                var a = recurrence[1];
		                if(0 !== a[0] && ! a[1]) return cont(0);
		                return caml_exact_trampoline_cps_call$1
		                        (occurrences,
		                         today,
		                         recurrence,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (length$2,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(return$9, a, cont);
		                                   });
		                         });
		               }
		               var
		                cst_participants = "participants",
		                letrec_function_context$25 = [];
		               function features_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$0);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$25[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){return cont([0, , , descriptor, 0]);}
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$25[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$25[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$25[1][1] = a;
		                  var
		                   default$ = match$33[1],
		                   default$0 = match$34[1],
		                   default$1 = match$35[1],
		                   default$2 = match$36[1],
		                   default$3 = match$37[1],
		                   default$4 = match$38[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        slots = d[2][1],
		                        scheduling = d[1],
		                        redirection = c[1],
		                        recurrence = b[1],
		                        postponing = a[1],
		                        participants = param[1];
		                       return cont
		                               ([0,
		                                 participants,
		                                 postponing,
		                                 recurrence,
		                                 redirection,
		                                 scheduling,
		                                 slots]);
		                      },
		                      function(param, cont){
		                       var
		                        slots = param[6],
		                        scheduling = param[5],
		                        redirection = param[4],
		                        recurrence = param[3],
		                        postponing = param[2],
		                        participants = param[1];
		                       return cont
		                               ([0,
		                                 participants,
		                                 [0,
		                                  postponing,
		                                  [0,
		                                   recurrence,
		                                   [0, redirection, [0, scheduling, [0, slots, 0]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_participants,
		                        0,
		                        [0, default$4],
		                        [0, bool_schema],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "postponing",
		                         0,
		                         [0, default$3],
		                         [0, bool_schema],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_recurrence,
		                          0,
		                          [0, default$2],
		                          [0, bool_schema],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "redirection",
		                           0,
		                           [0, default$1],
		                           [0, bool_schema],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_scheduling,
		                            0,
		                            [0, default$0],
		                            [0, bool_schema],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_slots,
		                             0,
		                             [0, default$],
		                             [0, bool_schema],
		                             0,
		                             0],
		                            0]]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$25[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$25[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$14 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$25, [0, schematic_cache$14]);
		               caml_callback
		                (features_schema_versioned, [function(param){return 0;}]);
		               function matchable_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_value_schema_v, cont){
		                                    function descriptor(schematic_param_value_schema_v){
		                                     return [7,
		     function(param, cont){
		      var
		       a = param[2],
		       value = a[2][1],
		       alternate = a[1],
		       canonical = param[1];
		      return cont([0, canonical, alternate, value]);
		     },
		     function(param, cont){
		      var
		       value = param[3],
		       alternate = param[2],
		       canonical = param[1];
		      return cont([0, canonical, [0, alternate, [0, value, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "canonical",
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "alternate",
		        0,
		        2,
		        [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_value,
		         0,
		         2,
		         [0, schematic_param_value_schema_v],
		         0,
		         0],
		        0]]]];
		                                    }
		                                    var
		                                     schematic_schema_id = match$39[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_value,
		 schematic_param_value_schema_v,
		 function(schematic_param_value_schema_v, cont){
		  return cont
		          ([0,
		            schematic_schema_id,
		            descriptor(schematic_param_value_schema_v)]);
		 }]],
		                                     a = descriptor(schematic_param_value_schema_v),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, 0, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               function make_destination(title, a, opt, value){
		                var alternate = a ? a[1] : 0, children = opt ? opt[1] : 0;
		                return [0, [0, title, alternate, value], children];
		               }
		               var cst_Unknown = "Unknown", cst_known = "known";
		               function participant_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_pv_schema_vers, cont){
		                                    function descriptor(schematic_param_pv_schema_vers){
		                                     return [11,
		     0,
		     [0,
		      [0,
		       function(f0, cont){return cont([0, f0]);},
		       function(param, cont){
		        if(0 !== param[0]) return cont(0);
		        var f0 = param[1];
		        return cont([0, f0]);
		       },
		       0,
		       0,
		       cst_unknown,
		       cst_Unknown,
		       schematic_param_name_schema_ve,
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(0 === param[0]) return cont(0);
		         var f0 = param[1];
		         return cont([0, f0]);
		        },
		        0,
		        0,
		        cst_known,
		        "Known",
		        schematic_param_pv_schema_vers,
		        0],
		       0]],
		     0];
		                                    }
		                                    var
		                                     schematic_schema_id = match$40[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 "pv",
		 schematic_param_pv_schema_vers,
		 function(schematic_param_pv_schema_vers, cont){
		  return cont
		          ([0,
		            schematic_schema_id,
		            descriptor(schematic_param_pv_schema_vers)]);
		 }]],
		                                     a = descriptor(schematic_param_pv_schema_vers),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, 0, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               function make$12
		               (dates,
		                daytime,
		                destination,
		                duration,
		                a,
		                opt,
		                priority,
		                recurrence,
		                slot,
		                type,
		                param){
		                var labels = a ? a[1] : 0, participants = opt ? opt[1] : 0;
		                return [0,
		                        dates,
		                        daytime,
		                        destination,
		                        duration,
		                        labels,
		                        participants,
		                        priority,
		                        recurrence,
		                        slot,
		                        type];
		               }
		               var cst_Value = "Value", letrec_function_context$26 = [];
		               function token_type_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$0);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$26[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, oR, oQ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$26[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$26[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$26[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(oV);},
		                        0,
		                        0,
		                        cst_keyword,
		                        "Keyword",
		                        oU,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(oT) : cont(0);},
		                         0,
		                         0,
		                         cst_value,
		                         cst_Value,
		                         oS,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$26[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$26[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$15 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$26, [0, schematic_cache$15]);
		               caml_callback
		                (token_type_schema_versioned, [function(param){return 0;}]);
		               var
		                schematic_cache$16 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$27 = [];
		               caml_update_dummy
		                (letrec_function_context$27, [0, schematic_cache$16]);
		               function schematic_version(param){return 0;}
		               var schematic_schema_version$180 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$27[1][1],
		                    schematic_schema_version$180]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$27[1][1],
		                             schematic_schema_version$180,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$27[1][1],
		schematic_schema_version$180,
		schematic_self,
		function(a){
		 letrec_function_context$27[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (token_type_schema_versioned,
		          schematic_version,
		          function(a){
		           var
		            res =
		              [10,
		               function(param, cont){
		                var e1 = param[2][1], e0 = param[1];
		                return cont([0, e0, e1]);
		               },
		               function(param, cont){
		                var e1 = param[2], e0 = param[1];
		                return cont([0, e0, [0, e1, 0]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 [10,
		                  function(param, cont){
		                   var e1 = param[2][1], e0 = param[1];
		                   return cont([0, e0, e1]);
		                  },
		                  function(param, cont){
		                   var e1 = param[2], e0 = param[1];
		                   return cont([0, e0, [0, e1, 0]]);
		                  },
		                  [0, int_schema, [0, int_schema, 0]]],
		                 0],
		                [0, a, 0]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$27[1][1],
		                    schematic_schema_version$180,
		                    res,
		                    function(a){
		                     letrec_function_context$27[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var cst_dest = "dest", cst_type$0 = "type_";
		               function completion_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_dest_schema_ve,
		                                    schematic_param_label_schema_v,
		                                    schematic_param_participant_sc,
		                                    schematic_param_priority_schem,
		                                    schematic_param_type_schema_ve,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_dest_schema_ve,
		                                     schematic_param_label_schema_v,
		                                     schematic_param_participant_sc,
		                                     schematic_param_priority_schem,
		                                     schematic_param_type_schema_ve,
		                                     cont){
		                                     return caml_exact_trampoline_cps_call
		     (value_schema_versioned,
		      schematic_version,
		      function(a){
		       return caml_exact_trampoline_cps_call$3
		               (a,
		                schematic_param_dest_schema_ve,
		                schematic_param_label_schema_v,
		                schematic_param_participant_sc,
		                schematic_param_priority_schem,
		                schematic_param_type_schema_ve,
		                function(a){
		                 return cont
		                         ([7,
		                           function(param, cont){
		                            var value = param[2][1], text = param[1];
		                            return cont([0, text, value]);
		                           },
		                           function(param, cont){
		                            var value = param[2], text = param[1];
		                            return cont([0, text, [0, value, 0]]);
		                           },
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_text,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, a], 0, 0], 0]]]);
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$45[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_dest,
		 schematic_param_dest_schema_ve,
		 function(schematic_param_dest_schema_ve, cont){
		  return cont
		          ([1,
		            cst_label,
		            schematic_param_label_schema_v,
		            function(schematic_param_label_schema_v, cont){
		             return cont
		                     ([1,
		                       cst_participant,
		                       schematic_param_participant_sc,
		                       function(schematic_param_participant_sc, cont){
		                        return cont
		                                ([1,
		                                  cst_priority,
		                                  schematic_param_priority_schem,
		                                  function(schematic_param_priority_schem, cont){
		                                   return cont
		   ([1,
		     cst_type$0,
		     schematic_param_type_schema_ve,
		     function(schematic_param_type_schema_ve, cont){
		      return caml_exact_trampoline_cps_call$3
		              (descriptor,
		               schematic_param_dest_schema_ve,
		               schematic_param_label_schema_v,
		               schematic_param_participant_sc,
		               schematic_param_priority_schem,
		               schematic_param_type_schema_ve,
		               function(a){return cont([0, schematic_schema_id, a]);});
		     }]);
		                                  }]);
		                       }]);
		            }]);
		 }]];
		                                    return caml_exact_trampoline_cps_call$3
		    (descriptor,
		     schematic_param_dest_schema_ve,
		     schematic_param_label_schema_v,
		     schematic_param_participant_sc,
		     schematic_param_priority_schem,
		     schematic_param_type_schema_ve,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                cst_Daytime = "Daytime",
		                cst_Destination = "Destination",
		                cst_Recurrence = "Recurrence",
		                cst_Type = "Type",
		                cst_duration = "duration",
		                parametric = 0,
		                documentation$0 = 0;
		               function value_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_dest_schema_ve,
		                                    schematic_param_label_schema_v,
		                                    schematic_param_participant_sc,
		                                    schematic_param_priority_schem,
		                                    schematic_param_type_schema_ve,
		                                    cont){
		                                    function descriptor$0
		                                    (schematic_param_dest_schema_ve,
		                                     schematic_param_label_schema_v,
		                                     schematic_param_participant_sc,
		                                     schematic_param_priority_schem,
		                                     schematic_param_type_schema_ve,
		                                     cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  function(f0, cont){return cont([8, f0]);},
		  function(param, cont){
		   if(8 !== param[0]) return cont(0);
		   var f0 = param[1];
		   return cont([0, f0]);
		  },
		  1,
		  0,
		  cst_type,
		  cst_Type,
		  [0,
		   0,
		   0,
		   [7,
		    function(param, cont){
		     var value = param[1];
		     return cont(value);
		    },
		    function(value, cont){return cont([0, value, 0]);},
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_value,
		      0,
		      2,
		      [0, schematic_param_type_schema_ve],
		      0,
		      0],
		     0]],
		   0],
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$15,
		      schematic_version,
		      function(c){
		       var
		        b =
		          [0,
		           [0,
		            function(f0, cont){return cont([1, f0]);},
		            function(param, cont){
		             if(1 !== param[0]) return cont(0);
		             var f0 = param[1];
		             return cont([0, f0]);
		            },
		            1,
		            0,
		            cst_daytime,
		            cst_Daytime,
		            [0,
		             0,
		             0,
		             [7,
		              function(param, cont){
		               var value = param[1];
		               return cont(value);
		              },
		              function(value, cont){return cont([0, value, 0]);},
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_value,
		                0,
		                2,
		                [0, schema_versioned$2(schematic_version)],
		                0,
		                0],
		               0]],
		             0],
		            0],
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_destination,
		             cst_Destination,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var value = param[1];
		                return cont(value);
		               },
		               function(value, cont){return cont([0, value, 0]);},
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_value,
		                 0,
		                 2,
		                 [0, schematic_param_dest_schema_ve],
		                 0,
		                 0],
		                0]],
		              0],
		             0],
		            [0,
		             [0,
		              function(f0, cont){return cont([3, f0]);},
		              function(param, cont){
		               if(3 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              cst_duration,
		              "Duration",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var value = param[1];
		                 return cont(value);
		                },
		                function(value, cont){return cont([0, value, 0]);},
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_value,
		                  0,
		                  2,
		                  [0, [0, q, documentation$0, descriptor, parametric]],
		                  0,
		                  0],
		                 0]],
		               0],
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([4, f0]);},
		               function(param, cont){
		                if(4 !== param[0]) return cont(0);
		                var f0 = param[1];
		                return cont([0, f0]);
		               },
		               1,
		               0,
		               cst_label,
		               "Label",
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var value = param[1];
		                  return cont(value);
		                 },
		                 function(value, cont){return cont([0, value, 0]);},
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_value,
		                   0,
		                   2,
		                   [0, schematic_param_label_schema_v],
		                   0,
		                   0],
		                  0]],
		                0],
		               0],
		              [0,
		               [0,
		                function(f0, cont){return cont([5, f0]);},
		                function(param, cont){
		                 if(5 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                1,
		                0,
		                cst_participant,
		                "Participant",
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var value = param[1];
		                   return cont(value);
		                  },
		                  function(value, cont){return cont([0, value, 0]);},
		                  [0,
		                   [0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    cst_value,
		                    0,
		                    2,
		                    [0, schematic_param_participant_sc],
		                    0,
		                    0],
		                   0]],
		                 0],
		                0],
		               [0,
		                [0,
		                 function(f0, cont){return cont([6, f0]);},
		                 function(param, cont){
		                  if(6 !== param[0]) return cont(0);
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 1,
		                 0,
		                 cst_priority,
		                 "Priority",
		                 [0,
		                  0,
		                  0,
		                  [7,
		                   function(param, cont){
		                    var value = param[1];
		                    return cont(value);
		                   },
		                   function(value, cont){return cont([0, value, 0]);},
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     cst_value,
		                     0,
		                     2,
		                     [0, schematic_param_priority_schem],
		                     0,
		                     0],
		                    0]],
		                  0],
		                 0],
		                [0,
		                 [0,
		                  function(f0, cont){return cont([7, f0]);},
		                  function(param, cont){
		                   if(7 !== param[0]) return cont(0);
		                   var f0 = param[1];
		                   return cont([0, f0]);
		                  },
		                  1,
		                  0,
		                  cst_recurrence,
		                  cst_Recurrence,
		                  [0,
		                   0,
		                   0,
		                   [7,
		                    function(param, cont){
		                     var value = param[1];
		                     return cont(value);
		                    },
		                    function(value, cont){return cont([0, value, 0]);},
		                    [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], 0]],
		                   0],
		                  0],
		                 a]]]]]]];
		       return caml_exact_trampoline_cps_call
		               (dates_schema_versioned,
		                schematic_version,
		                function(a){
		                 return cont
		                         ([11,
		                           oW,
		                           [0,
		                            [0,
		                             function(f0, cont){return cont([0, f0]);},
		                             function(param, cont){
		                              if(0 !== param[0]) return cont(0);
		                              var f0 = param[1];
		                              return cont([0, f0]);
		                             },
		                             1,
		                             0,
		                             cst_dates,
		                             cst_Dates,
		                             [0,
		                              0,
		                              0,
		                              [7,
		                               function(param, cont){
		                                var value = param[1];
		                                return cont(value);
		                               },
		                               function(value, cont){return cont([0, value, 0]);},
		                               [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, a], 0, 0], 0]],
		                              0],
		                             0],
		                            b],
		                           0]);
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$46[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_dest,
		 schematic_param_dest_schema_ve,
		 function(schematic_param_dest_schema_ve, cont){
		  return cont
		          ([1,
		            cst_label,
		            schematic_param_label_schema_v,
		            function(schematic_param_label_schema_v, cont){
		             return cont
		                     ([1,
		                       cst_participant,
		                       schematic_param_participant_sc,
		                       function(schematic_param_participant_sc, cont){
		                        return cont
		                                ([1,
		                                  cst_priority,
		                                  schematic_param_priority_schem,
		                                  function(schematic_param_priority_schem, cont){
		                                   return cont
		   ([1,
		     cst_type$0,
		     schematic_param_type_schema_ve,
		     function(schematic_param_type_schema_ve, cont){
		      return caml_exact_trampoline_cps_call$3
		              (descriptor$0,
		               schematic_param_dest_schema_ve,
		               schematic_param_label_schema_v,
		               schematic_param_participant_sc,
		               schematic_param_priority_schem,
		               schematic_param_type_schema_ve,
		               function(a){return cont([0, schematic_schema_id, a]);});
		     }]);
		                                  }]);
		                       }]);
		            }]);
		 }]];
		                                    return caml_exact_trampoline_cps_call$3
		    (descriptor$0,
		     schematic_param_dest_schema_ve,
		     schematic_param_label_schema_v,
		     schematic_param_participant_sc,
		     schematic_param_priority_schem,
		     schematic_param_type_schema_ve,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function merge$3(old, new$, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (append$0,
		                         new$[1],
		                         old[1],
		                         function(a){return cont([0, a]);});
		               }
		               function bind$13(v, f, cont){return cont(symbol_bind$3(v, f));}
		               var
		                map$26 =
		                  [0,
		                   ,
		                   function(v, f, cont){return cont(symbol_map$3(v, f));}],
		                include$38 = Make([0, bind$13, return$7, map$26]),
		                symbol_bind$10 = include$38[1],
		                symbol_map$9 = include$38[2],
		                bind$14 = include$38[4],
		                return$14 = include$38[5],
		                map$27 = include$38[6],
		                Let_syntax$6 = include$38[11];
		               function wrap(t, cont){
		                return caml_trampoline_cps_call3
		                        (map$27,
		                         t,
		                         function(t, cont){return cont([0, t, empty]);},
		                         cont);
		               }
		               function bind$15(t, f, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$10,
		                       symbol_map$9,
		                       ,
		                       bind$14,
		                       return$14,
		                       map$27,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$6])
		                    [3];
		                return caml_trampoline_cps_call3
		                        (a,
		                         t,
		                         function(param, cont){
		                          var state = param[2], t = param[1];
		                          function b(param, cont){
		                           var new_state = param[2], t = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (merge$3,
		                                    state,
		                                    new_state,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$14, [0, t, a], cont);
		                                    });
		                          }
		                          return caml_trampoline_cps_call2
		                                  (f,
		                                   t,
		                                   function(c){
		                                    return caml_trampoline_cps_call3(a, c, b, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function bind_with_merger(t, f, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$10,
		                       symbol_map$9,
		                       ,
		                       bind$14,
		                       return$14,
		                       map$27,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$6])
		                    [3];
		                return caml_trampoline_cps_call3
		                        (a,
		                         t,
		                         function(param, cont){
		                          var prev_state = param[2], t = param[1];
		                          function b(a, cont){
		                           var
		                            new_state = a[2],
		                            a = a[1],
		                            state_merger = a[2],
		                            t = a[1],
		                            state_merger$0 = value$4(state_merger, merge$3);
		                           return caml_trampoline_cps_call3
		                                   (state_merger$0,
		                                    prev_state,
		                                    new_state,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$14, [0, t, a], cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (f,
		                                   t,
		                                   function(c){
		                                    return caml_trampoline_cps_call3(a, c, b, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function return$15(v, cont){
		                return caml_trampoline_cps_call2
		                        (return$14, [0, v, empty], cont);
		               }
		               var
		                include$39 = Make([0, bind$15, return$15, -349054340]),
		                symbol_bind$11 = include$39[1],
		                symbol_map$10 = include$39[2],
		                bind$16 = include$39[4],
		                return$16 = include$39[5],
		                map$28 = include$39[6],
		                all$16 = include$39[9],
		                Let_syntax$7 = include$39[11];
		               function symbol$91(l, r, cont){
		                var
		                 a =
		                   g
		                    ([0,
		                      symbol_bind$10,
		                      symbol_map$9,
		                      ,
		                      bind$14,
		                      return$14,
		                      map$27,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$6]),
		                 b = a[4];
		                function c(param, cont){
		                 var
		                  a = param[2],
		                  state_r = a[2],
		                  r = a[1],
		                  state_l = param[1][2];
		                 return caml_exact_trampoline_cps_call$1
		                         (merge$3,
		                          state_l,
		                          state_r,
		                          function(a){return cont([0, r, a]);});
		                }
		                return caml_trampoline_cps_call3
		                        (a[6],
		                         l,
		                         r,
		                         function(a){
		                          return caml_trampoline_cps_call3(b, a, c, cont);
		                         });
		               }
		               var
		                any_char$0 = caml_callback(wrap, [any_char]),
		                at_end_of_input$0 = caml_callback(wrap, [at_end_of_input]);
		               function char$1(c, cont){
		                return caml_exact_trampoline_cps_call(wrap, char$0(c), cont);
		               }
		               var
		                commit$0 = caml_callback(wrap, [commit]),
		                end_of_input$0 = caml_callback(wrap, [end_of_input]);
		               caml_callback(wrap, [end_of_line]);
		               function fail$3(s, cont){
		                return caml_exact_trampoline_cps_call(wrap, fail$0(s), cont);
		               }
		               var peek_char$0 = caml_callback(wrap, [peek_char]);
		               function peek_string(n, cont){
		                var p = take$2(n);
		                return caml_exact_trampoline_cps_call
		                        (wrap,
		                         [0,
		                          function(input, pos, more, fail, succ, cont){
		                           function succ$0(input, param, more, v, cont){
		                            return caml_trampoline_cps_call5
		                                    (succ, input, pos, more, v, cont);
		                           }
		                           return caml_trampoline_cps_call6
		                                   (p[1], input, pos, more, fail, succ$0, cont);
		                          }],
		                         cont);
		               }
		               var pos$0 = caml_callback(wrap, [pos]);
		               function string$4(s, cont){
		                return caml_exact_trampoline_cps_call(wrap, string$3(s), cont);
		               }
		               function string_ci(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (wrap, string$2(lowercase_ascii, s), cont);
		               }
		               function take_while$0(f, cont){
		                return caml_exact_trampoline_cps_call
		                        (wrap, take_while(f), cont);
		               }
		               function token(type, p, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$11,
		                      symbol_map$10,
		                      ,
		                      bind$16,
		                      return$16,
		                      map$28,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$7]),
		                 and = open[6],
		                 let$ = open[4];
		                function a(a, cont){
		                 var end = a[2], a = a[1], res = a[2], start = a[1];
		                 return cont([0, res, start, end]);
		                }
		                return caml_trampoline_cps_call3
		                        (and,
		                         pos$0,
		                         p,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   b,
		                                   pos$0,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     b,
		     a,
		     function(p){
		      function f(state, param){
		       var end = param[3], start = param[2];
		       return start < end
		               ? [0, [0, [0, [0, start, end], type], state[1]]]
		               : state;
		      }
		      function a(param, cont){
		       var res = param[1];
		       return cont(res);
		      }
		      return caml_trampoline_cps_call3
		              (g
		                 ([0,
		                   symbol_bind$10,
		                   symbol_map$9,
		                   ,
		                   bind$14,
		                   return$14,
		                   map$27,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$6])
		                [4],
		               p,
		               function(param, cont){
		                var state = param[2], res = param[1];
		                return cont([0, res, f(state, res)]);
		               },
		               function(b){
		                return caml_trampoline_cps_call3(let$, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function digit(param, cont){
		                return 9 < param - 48 >>> 0 ? cont(0) : cont(1);
		               }
		               function alnum(c, cont){
		                return caml_exact_trampoline_cps_call
		                        (digit,
		                         c,
		                         function(a){
		                          if(a)
		                           ;
		                          else {
		                           a = 97 <= c ? 1 : 0;
		                           a = a ? c <= 122 ? 1 : 0 : a;
		                           if(a)
		                            ;
		                           else {
		                            a = 65 <= c ? 1 : 0;
		                            if(a) return cont(c <= 90 ? 1 : 0);
		                           }
		                          }
		                          return cont(a);
		                         });
		               }
		               function whitespace(param, cont){
		                if(9 !== param && 32 !== param) return cont(0);
		                return cont(1);
		               }
		               var cst$6 = "\xe2\x80\x8b";
		               function break$(accept_eof, cont){
		                return caml_exact_trampoline_cps_call
		                        (fail$3,
		                         "invalid word break",
		                         function(fail){
		                          return caml_trampoline_cps_call2
		                                  (return$16,
		                                   0,
		                                   function(ok){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_bind$11,
		     peek_char$0,
		     function(param, cont){
		      function a(){return cont(fail);}
		      if(! param) return accept_eof ? cont(ok) : a();
		      var c = param[1];
		      return caml_exact_trampoline_cps_call
		              (whitespace,
		               c,
		               function(d){
		                if(d) return cont(ok);
		                if(c !== 226) return a();
		                function b(s, cont){
		                 return s === cst$6 ? cont(ok) : cont(fail);
		                }
		                return caml_exact_trampoline_cps_call
		                        (peek_string,
		                         3,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$11, a, b, cont);
		                         });
		               });
		     },
		     function(p){return cont(symbol$63(p, "word-break"));});
		                                   });
		                         });
		               }
		               var
		                confirm = caml_callback(break$, [0]),
		                break$0 = caml_callback(break$, [1]),
		                open$1 =
		                  g
		                   ([0,
		                     symbol_bind$11,
		                     symbol_map$10,
		                     ,
		                     bind$16,
		                     return$16,
		                     map$28,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$7]),
		                symbol_bind$12 = open$1[1],
		                symbol_map$11 = open$1[2],
		                let$3 = open$1[3],
		                let$4 = open$1[4],
		                and$2 = open$1[5];
		               function make_completion(opt, replaced, result){
		                var cut = 0;
		                return [0, cut, replaced, result];
		               }
		               function bind_extensible(opt, v, f, cont){
		                var
		                 interleave = opt ? opt[1] : 0,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$11,
		                      symbol_map$10,
		                      ,
		                      bind$16,
		                      return$16,
		                      map$28,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$7]),
		                 and = open[6],
		                 let$ = open[4],
		                 let$0 = open[3];
		                function combine(completion, param){
		                 var value = param[2], next_completion = param[1];
		                 return [0, completion + next_completion, value];
		                }
		                return caml_trampoline_cps_call3
		                        (let$0,
		                         v,
		                         function(a, cont){
		                          var result = a[3], replaced = a[2], cut = a[1];
		                          if(0 === result[0]){
		                           a = result[1];
		                           var
		                            value = a[2],
		                            completion = a[1],
		                            b =
		                              function(next, cont){
		                               if(next[1]) return cont(next);
		                               var a = next[3];
		                               if(0 === a[0]){
		                                var
		                                 next_result = a[1],
		                                 a = [0, combine(completion, next_result)];
		                                return cont([0, cut, replaced + next[2] | 0, a]);
		                               }
		                               var next_results = a[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (map$19,
		next_results,
		function(a, cont){return cont(combine(completion, a));},
		function(a){
		 return cont([0, cut, replaced + next[2] | 0, [1, a]]);
		});
		                              };
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    value,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(let$, a, b, cont);
		                                    });
		                          }
		                          var results = result[1];
		                          function explore(param, cont){
		                           var value = param[2], completion = param[1];
		                           function a(next, cont){
		                            var a = next[3];
		                            if(0 === a[0]){
		                             var
		                              next_result = a[1],
		                              a = [0, combine(completion, next_result), 0];
		                             return cont([0, next[2], a]);
		                            }
		                            var next_results = a[1];
		                            function b(a, cont){return cont(combine(completion, a));}
		                            return caml_exact_trampoline_cps_call
		                                    (elements_of_list,
		                                     next_results,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (map$18, a, b, function(a){return cont([0, next[2], a]);});
		                                     });
		                           }
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    value,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (let$,
		      b,
		      a,
		      function(success){
		       return caml_trampoline_cps_call2
		               (return$16,
		                oX,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$64, success, a, cont);
		                });
		      });
		                                    });
		                          }
		                          function c(param, cont){
		                           var results = param[2], next_replaced = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$19,
		                                    results,
		                                    function(param, cont){var c = param[2]; return cont(c);},
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (elements_of_list,
		      a,
		      function(x){
		       function a(results){
		        if(! results)
		         return caml_exact_trampoline_cps_call
		                 (fail$3, "no valid completion", cont);
		        var tail = results[2], head = results[1];
		        return caml_trampoline_cps_call2
		                (return$16,
		                 [0, cut, replaced + next_replaced | 0, [1, [0, head, tail]]],
		                 cont);
		       }
		       return interleave
		               ? caml_trampoline_cps_call3
		                 (map$18,
		                  x,
		                  deconstruct,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (to_binable, round_robin(b), a);
		                  })
		               : caml_exact_trampoline_cps_call(of_list, x, a);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$19,
		                                   results,
		                                   explore,
		                                   function(match){
		                                    var tail = match[2], head = match[1];
		                                    function a(param, cont){
		                                     var
		                                      tail = param[2],
		                                      head = param[1],
		                                      next_replaced = head[1];
		                                     return cont([0, next_replaced, [0, head, tail]]);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (all$16,
		     tail,
		     function(b){
		      return caml_trampoline_cps_call3
		              (and,
		               head,
		               b,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         b,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call3(let$0, a, c, cont);
		                         });
		               });
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function bind$17(v, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (bind_extensible, 0, v, f, cont);
		               }
		               function or_with_concatenated_completio(l, r, cont){
		                var
		                 b =
		                   g
		                    ([0,
		                      symbol_bind$11,
		                      symbol_map$10,
		                      ,
		                      bind$16,
		                      return$16,
		                      map$28,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$7]),
		                 a = b[3],
		                 c = b[2];
		                return caml_trampoline_cps_call3
		                        (a,
		                         pos$0,
		                         function(start_pos, cont){
		                          function f(lc, cont){
		                           var match = lc[3];
		                           if(0 === match[0])
		                            return caml_trampoline_cps_call2
		                                    (return$16, [0, lc, 0], cont);
		                           var left_completions = match[1];
		                           return caml_trampoline_cps_call3
		                                   (a,
		                                    pos$0,
		                                    function(pos_after_l, cont){
		                                     var n_bt = pos_after_l - start_pos | 0;
		                                     function b(param, cont){
		                                      return caml_trampoline_cps_call3
		      (a,
		       r,
		       function(rc, cont){
		        var match = rc[3];
		        if(0 === match[0])
		         return caml_trampoline_cps_call2
		                 (return$16, [0, rc, -312493282], cont);
		        var right_completions = match[1];
		        if(lc[2] !== rc[2])
		         return caml_exact_trampoline_cps_call
		                 (fail$3, "unsupported usage", cont);
		        var
		         rt = right_completions[2],
		         rh = right_completions[1],
		         lt = left_completions[2],
		         lh = left_completions[1];
		        return caml_exact_trampoline_cps_call$1
		                (append$0,
		                 lt,
		                 [0, rh, rt],
		                 function(a){
		                  var
		                   all_completions = [0, lh, a],
		                   a = lc[1],
		                   b = rc[2],
		                   a = a || rc[1];
		                  return caml_trampoline_cps_call2
		                          (return$16,
		                           [0, [0, a, b, [1, all_completions]], -312493282],
		                           cont);
		                 });
		       },
		       cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (wrap,
		      backtrack(n_bt),
		      function(c){
		       return caml_trampoline_cps_call3
		               (a,
		                c,
		                b,
		                function(p){
		                 return caml_trampoline_cps_call2
		                         (return$16,
		                          [0, lc, 974571256],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$64, p, a, cont);
		                          });
		                });
		      });
		                                    },
		                                    function(p){
		                                     return caml_trampoline_cps_call3
		     (c,
		      p,
		      function(param, cont){
		       var
		        token_status = param[2],
		        res = param[1],
		        merger =
		          974571256 <= token_status
		           ? 0
		           : [0,
		             function(old_tokens, new_tokens, cont){return cont(new_tokens);
		             }];
		       return cont([0, res, merger]);
		      },
		      cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (bind_with_merger,
		                                   l,
		                                   f,
		                                   function(l_concat){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$64, l_concat, r, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function bind_stop_completion(complete, v, f, cont){
		                var
		                 a =
		                   g
		                    ([0,
		                      symbol_bind$11,
		                      symbol_map$10,
		                      ,
		                      bind$16,
		                      return$16,
		                      map$28,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$7]),
		                 b = a[4];
		                return caml_trampoline_cps_call3
		                        (a[3],
		                         v,
		                         function(res, cont){
		                          var result = res[3], replaced = res[2], cut = res[1];
		                          function combine(completion, param){
		                           var value = param[2], next_completion = param[1];
		                           return [0, completion + next_completion, value];
		                          }
		                          if(0 === result[0]){
		                           var
		                            match = result[1],
		                            value = match[2],
		                            completion = match[1],
		                            c =
		                              function(next, cont){
		                               if(next[1]) return cont(next);
		                               var a = next[3];
		                               if(0 === a[0]){
		                                var
		                                 next_result = a[1],
		                                 a = [0, combine(completion, next_result)];
		                                return cont([0, cut, replaced + next[2] | 0, a]);
		                               }
		                               var next_results = a[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (map$19,
		next_results,
		function(a, cont){return cont(combine(completion, a));},
		function(a){
		 return cont([0, cut, replaced + next[2] | 0, [1, a]]);
		});
		                              };
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    value,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(b, a, c, cont);
		                                    });
		                          }
		                          var
		                           completions = result[1],
		                           tl = completions[2],
		                           hd = completions[1];
		                          function a(a){
		                           return caml_trampoline_cps_call2
		                                   (return$16, [0, res[1], res[2], [1, a]], cont);
		                          }
		                          if(! complete) return a(completions);
		                          var complete$0 = complete[1];
		                          return caml_exact_trampoline_cps_call
		                                  (complete$0,
		                                   hd,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (rev$1,
		     [0, hd, b],
		     function(init){
		      function b(t, init){
		       if(! t)
		        return caml_exact_trampoline_cps_call(rev$1, init, a);
		       var l = t[2], lh = t[1];
		       return caml_exact_trampoline_cps_call
		               (complete$0,
		                lh,
		                function(lt){
		                 var
		                  rt = init[2],
		                  rh = init[1],
		                  param = [0, lh, lt],
		                  acc$0 = [0, rh, rt];
		                 for(;;){
		                  var match = param[2], last = param[1];
		                  if(! match){
		                   var init$0 = [0, last, acc$0];
		                   return caml_exact_trampoline_call2(b, l, init$0);
		                  }
		                  var tl = match[2], hd = match[1], acc = [0, last, acc$0];
		                  param = [0, hd, tl];
		                  acc$0 = acc;
		                 }
		                });
		      }
		      return b(tl, init);
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function return$17(v, cont){
		                return caml_trampoline_cps_call2
		                        (return$16, make_completion(0, 0, [0, [0, cst$1, v]]), cont);
		               }
		               var
		                map$29 =
		                  [0,
		                   ,
		                   function(v, f, cont){
		                    function f$0(param, cont){
		                     var v = param[2], c = param[1];
		                     return caml_trampoline_cps_call2
		                             (f, v, function(a){return cont([0, c, a]);});
		                    }
		                    return caml_trampoline_cps_call3
		                            (let$4,
		                             v,
		                             function(v, cont){
		                              var match = v[3];
		                              function a(result){return cont([0, v[1], v[2], result]);}
		                              if(0 === match[0]){
		                               var r = match[1];
		                               return caml_exact_trampoline_cps_call
		                                       (f$0, r, function(b){return a([0, b]);});
		                              }
		                              var c = match[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (map$19, c, f$0, function(b){return a([1, b]);});
		                             },
		                             cont);
		                   }],
		                include$40 = Make([0, bind$17, return$17, map$29]),
		                symbol_bind$13 = include$40[1],
		                symbol_map$12 = include$40[2],
		                bind$18 = include$40[4],
		                return$18 = include$40[5],
		                map$30 = include$40[6],
		                Let_syntax$8 = include$40[11];
		               function symbol$92(l, r, cont){
		                return caml_trampoline_cps_call3
		                        (bind$18, l, function(param, cont){return cont(r);}, cont);
		               }
		               function symbol$93(l, r, cont){
		                return caml_trampoline_cps_call3
		                        (bind$18,
		                         l,
		                         function(x, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_map$12,
		                                   r,
		                                   function(param, cont){return cont(x);},
		                                   cont);
		                         },
		                         cont);
		               }
		               var
		                cut_completion = caml_callback(return$16, [oY]),
		                stop_completion =
		                  caml_callback
		                   (symbol_bind$12,
		                    [at_end_of_input$0,
		                     function(param, cont){
		                      return param
		                              ? caml_exact_trampoline_cps_call
		                                (fail$3, "completion stopped", cont)
		                              : caml_trampoline_cps_call2(return$18, 0, cont);
		                     }]);
		               function utf8_length(s, cont){
		                var
		                 len = caml_ml_string_length(s) - 0 | 0,
		                 last = (len | 0) - 1 | 0,
		                 s$0 = caml_bytes_of_string(s);
		                function a(acc, i){
		                 if(last < i) return cont(acc);
		                 var need = utf_8_len[caml_bytes_unsafe_get(s$0, i) + 1];
		                 if(0 === need){
		                  var i$0 = i + 1 | 0;
		                  return caml_exact_trampoline_cps_call$0
		                          (malformed,
		                           s$0,
		                           i,
		                           1,
		                           function(param){
		                            var acc$0 = acc + 1 | 0;
		                            return caml_exact_trampoline_call2(a, acc$0, i$0);
		                           });
		                 }
		                 var rem = (last - i | 0) + 1 | 0;
		                 if(rem < need)
		                  return caml_exact_trampoline_cps_call$0
		                          (malformed,
		                           s$0,
		                           i,
		                           rem,
		                           function(param){return cont(acc + 1 | 0);});
		                 var i$1 = i + need | 0;
		                 return caml_exact_trampoline_cps_call$0
		                         (r_utf_8,
		                          s$0,
		                          i,
		                          need,
		                          function(param){
		                           var acc$0 = acc + 1 | 0;
		                           return caml_exact_trampoline_call2(a, acc$0, i$1);
		                          });
		                }
		                return a(0, 0);
		               }
		               function consts(failure_msg, b, a, opt, options, cont){
		                var
		                 complete = b ? b[1] : 1,
		                 fuzzy = a ? a[1] : 0,
		                 break$ = opt ? opt[1] : break$0,
		                 p = many_till(any_char$0, break$);
		                function c(query, cont){
		                 return caml_trampoline_cps_call3
		                         (let$3,
		                          at_end_of_input$0,
		                          function(end, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (utf8_length,
		                                    query,
		                                    function(replaced){
		                                     function a(match){
		                                      var completions = match[2], value = match[1];
		                                      if(value){
		                                       var value$0 = value[1];
		                                       return caml_trampoline_cps_call2
		       (return$16, [0, 0, replaced, [0, value$0]], cont);
		                                      }
		                                      if(completions){
		                                       var value$1 = completions[1];
		                                       if(! completions[2] && fuzzy)
		return caml_trampoline_cps_call2
		        (return$16, [0, 0, replaced, [0, value$1]], cont);
		                                       var tail = completions[2];
		                                       if(complete && end)
		return caml_trampoline_cps_call2
		        (return$16, [0, 0, replaced, [1, [0, value$1, tail]]], cont);
		                                      }
		                                      var
		                                       a =
		 list
		  ([0, comma],
		   function(ppf, v, cont){
		    return caml_exact_trampoline_cps_call$1
		            (string$1, ppf, v[1], cont);
		   });
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$30,
		       function(b){
		        return caml_trampoline_cps_call3
		                (b,
		                 a,
		                 options,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fail$3, value$4(failure_msg, a), cont);
		                 });
		       });
		                                     }
		                                     return options
		     ? caml_exact_trampoline_cps_call
		       (of_rev_keys,
		        options,
		        function(t){
		         function b(t, init){
		          if(! t) return a(init);
		          var
		           l = t[2],
		           a$0 = t[1],
		           completions = init[2],
		           res = init[1],
		           value = a$0[2],
		           name = a$0[1];
		          return caml_exact_trampoline_cps_call
		                  (lowercase_ascii$0,
		                   name,
		                   function(y){
		                    return caml_exact_trampoline_cps_call
		                            (lowercase_ascii$0,
		                             query,
		                             function(x){
		                              var res$0 = x === y ? [0, [0, name, value]] : res;
		                              function a(completions){
		                               var init = [0, res$0, completions];
		                               return caml_exact_trampoline_call2(b, l, init);
		                              }
		                              if(! end && ! fuzzy) return a(completions);
		                              return caml_exact_trampoline_cps_call
		                                      (lowercase_ascii$0,
		                                       query,
		                                       function(prefix){
		return caml_exact_trampoline_cps_call
		        (lowercase_ascii$0,
		         name,
		         function(s){
		          return caml_exact_trampoline_cps_call$0
		                  (is_prefix_gen,
		                   s,
		                   prefix,
		                   equal$2,
		                   function(b){
		                    return b
		                            ? a([0, [0, name, value], completions])
		                            : a(completions);
		                   });
		         });
		                                       });
		                             });
		                   });
		         }
		         return b(t, init$2);
		        })
		     : a(init$2);
		                                    });
		                          },
		                          cont);
		                }
		                return caml_trampoline_cps_call3
		                        (symbol_map$11,
		                         symbol_map$3
		                          (p,
		                           function(elts, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (fold_map,
		                                     elts,
		                                     empty,
		                                     function(acc, param, cont){
		                                      var state = param[2], v = param[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (merge$3, acc, state, function(a){return cont([0, a, v]);});
		                                     },
		                                     function(match){
		                                      var v = match[2], state = match[1];
		                                      return cont([0, v, state]);
		                                     });
		                           }),
		                         of_char_list,
		                         function(a){
		                          return caml_trampoline_cps_call3(let$3, a, c, cont);
		                         });
		               }
		               var
		                whitespace$0 =
		                  caml_callback
		                   (let$3,
		                    [caml_callback(take_while$0, [whitespace]),
		                     function(ws, cont){
		                      return caml_trampoline_cps_call2
		                              (return$16,
		                               make_completion(0, caml_ml_string_length(ws), oZ),
		                               cont);
		                     }]),
		                leading_whitespace =
		                  caml_callback
		                   (let$3,
		                    [caml_callback(take_while$0, [whitespace]),
		                     function(param, cont){
		                      return caml_trampoline_cps_call2
		                              (return$16, make_completion(0, 0, o0), cont);
		                     }]),
		                noncanonical_whitespace =
		                  caml_callback
		                   (let$3,
		                    [caml_callback(take_while$0, [whitespace]),
		                     function(ws, cont){
		                      var ws_count = caml_ml_string_length(ws);
		                      return caml_trampoline_cps_call2
		                              (return$16, make_completion(0, ws_count, o1), cont);
		                     }]),
		                whitespace1 =
		                  caml_callback
		                   (let$3,
		                    [caml_callback(take_while$0, [whitespace]),
		                     function(ws, cont){
		                      var ws_count = caml_ml_string_length(ws);
		                      return 0 < ws_count
		                              ? caml_trampoline_cps_call2
		                                (return$16, make_completion(0, ws_count, o2), cont)
		                              : caml_trampoline_cps_call2
		                                (return$16, make_completion(0, 0, o3), cont);
		                     }]),
		                leading_whitespace1 =
		                  caml_callback
		                   (let$3,
		                    [caml_callback(wrap, [count_while1(whitespace, substring)]),
		                     function(param, cont){
		                      return caml_trampoline_cps_call2
		                              (return$16, make_completion(0, 0, o4), cont);
		                     }]);
		               function number(completion, cont){
		                function a(s, cont){
		                 return s !== cst$1
		                         ? caml_exact_trampoline_cps_call
		                           (of_string$3,
		                            s,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (return$16,
		                                      make_completion(0, caml_ml_string_length(s), [0, [0, s, a]]),
		                                      cont);
		                            })
		                         : caml_trampoline_cps_call2
		                           (return$16,
		                            make_completion
		                             (0, 0, [1, [0, [0, "" + completion, completion], 0]]),
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$91, end_of_input$0, a, cont);
		                            });
		                }
		                return caml_exact_trampoline_cps_call
		                        (take_while$0,
		                         digit,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (symbol_bind$12,
		                                   b,
		                                   a,
		                                   function(p){return cont(symbol$63(p, cst_number));});
		                         });
		               }
		               function year(opt, reference, cont){
		                var complete = opt ? opt[1] : 925480876;
		                return caml_trampoline_cps_call2
		                        (return$16,
		                         0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$91,
		                                   end_of_input$0,
		                                   a,
		                                   function(b){
		                                    function a(d, cont){return cont([0, d - 48 | 0]);}
		                                    return caml_exact_trampoline_cps_call
		    (wrap,
		     satisfy(digit),
		     function(c){
		      return caml_trampoline_cps_call3
		              (symbol_map$11,
		               c,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$64,
		                         a,
		                         b,
		                         function(digit){
		                          function complete$0(replaced, ref, cont){
		                           if(typeof complete === "number" && 870530776 === complete)
		                            return caml_exact_trampoline_cps_call
		                                    (fail$3, "no completions", cont);
		                           var h = [0, "" + ref, ref];
		                           function a(t){
		                            var completions = [0, h, t];
		                            return caml_trampoline_cps_call2
		                                    (return$16,
		                                     make_completion(0, replaced, [1, completions]),
		                                     cont);
		                           }
		                           return 870530776 <= complete
		                                   ? a(0)
		                                   : caml_exact_trampoline_cps_call$1
		                                     (init$7,
		                                      4,
		                                      function(i, cont){
		                                       var v = (ref + 1 | 0) + i | 0;
		                                       return cont([0, "" + v, v]);
		                                      },
		                                      a);
		                          }
		                          return caml_trampoline_cps_call3
		                                  (symbol_bind$12,
		                                   digit,
		                                   function(param, cont){
		                                    if(! param)
		                                     return caml_exact_trampoline_cps_call$1
		     (complete$0, 0, reference, cont);
		                                    var t = param[1];
		                                    return caml_trampoline_cps_call3
		    (symbol_bind$12,
		     digit,
		     function(param, cont){
		      if(param){
		       var h = param[1];
		       return caml_trampoline_cps_call3
		               (symbol_bind$12,
		                digit,
		                function(param, cont){
		                 if(param){
		                  var d = param[1];
		                  return caml_trampoline_cps_call3
		                          (symbol_bind$12,
		                           digit,
		                           function(param, cont){
		                            if(param){
		                             var
		                              u = param[1],
		                              v =
		                                (((1000 * t | 0) + (100 * h | 0) | 0) + (10 * d | 0) | 0)
		                                + u
		                                | 0;
		                             return caml_trampoline_cps_call2
		                                     (return$16,
		                                      make_completion(0, 4, [0, [0, "" + v, v]]),
		                                      cont);
		                            }
		                            var
		                             n =
		                               caml_int_compare
		                                (((100 * t | 0) + (10 * h | 0) | 0) + d | 0,
		                                 reference / 10 | 0),
		                             reference$0 =
		                               0 === n
		                                ? reference
		                                : 0
		                                  <= n
		                                  ? ((1000 * t | 0) + (100 * h | 0) | 0) + (10 * d | 0) | 0
		                                  : (((1000
		                                   * t
		                                   | 0)
		                                   + (100 * h | 0)
		                                   | 0)
		                                   + (10 * d | 0)
		                                   | 0)
		                                   + 9
		                                   | 0;
		                            return caml_exact_trampoline_cps_call$1
		                                    (complete$0, 3, reference$0, cont);
		                           },
		                           cont);
		                 }
		                 var
		                  n =
		                    caml_int_compare((10 * t | 0) + h | 0, reference / 100 | 0),
		                  reference$0 =
		                    0 === n
		                     ? reference
		                     : 0
		                       <= n
		                       ? (1000 * t | 0) + (100 * h | 0) | 0
		                       : ((1000 * t | 0) + (100 * h | 0) | 0) + 99 | 0;
		                 return caml_exact_trampoline_cps_call$1
		                         (complete$0, 2, reference$0, cont);
		                },
		                cont);
		      }
		      var
		       n = caml_int_compare(t, reference / 1000 | 0),
		       reference$0 =
		         0 === n
		          ? reference
		          : 0 <= n ? 1000 * t | 0 : (1000 * t | 0) + 999 | 0;
		      return caml_exact_trampoline_cps_call$1
		              (complete$0, 1, reference$0, cont);
		     },
		     cont);
		                                   },
		                                   cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function wrap$0(p, cont){
		                return caml_trampoline_cps_call3
		                        (let$4,
		                         p,
		                         function(r, cont){
		                          return cont(make_completion(0, 0, [0, [0, cst$1, r]]));
		                         },
		                         cont);
		               }
		               caml_callback(wrap$0, [commit$0]);
		               caml_callback(wrap$0, [pos$0]);
		               var
		                confirm$0 = caml_callback(wrap$0, [confirm]),
		                break$1 = caml_callback(wrap$0, [break$0]),
		                end_of_input$1 = caml_callback(wrap$0, [end_of_input$0]),
		                peek_char$1 = caml_callback(wrap$0, [peek_char$0]);
		               function option$2(opt, default$, p, cont){
		                var complete_empty = opt ? opt[1] : 0;
		                return caml_trampoline_cps_call3
		                        (let$3,
		                         at_end_of_input$0,
		                         function(end, cont){
		                          var default$0 = make_completion(0, 0, [0, default$]);
		                          function a(res, cont){
		                           var a = res[3];
		                           if(0 !== a[0]){
		                            var c = a[1];
		                            if(complete_empty){
		                             if(! end) return cont(res);
		                             a = [1, cons$3(default$, c)];
		                             return cont([0, res[1], res[2], a]);
		                            }
		                           }
		                           return cont(res);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (option$0,
		                                   [0, default$0, empty],
		                                   p,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(symbol_map$11, b, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function _0$5(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               var letrec_function_context$28 = [];
		               caml_update_dummy(letrec_function_context$28, [0, _0$5]);
		               function disambiguate(texts, cont){
		                var init = empty$11([0, comparator$2]);
		                function a(t, counts){
		                 if(! t)
		                  return cont
		                          (function(index, text, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     counts,
		                                     text,
		                                     function(match){
		                                      if(match){
		                                       var n = match[1];
		                                       if(1 < n){
		var
		 buffer = create$1(8),
		 a =
		   function(acc, index){
		    return caml_exact_trampoline_cps_call$1
		            (symbol$23,
		             index,
		             256,
		             function(c){
		              var acc$0 = [0, c, acc];
		              function b(t){
		               if(! t)
		                return caml_exact_trampoline_cps_call
		                        (contents, buffer, function(s2){return cont(text + s2);});
		               var l = t[2], digit = t[1];
		               return caml_exact_trampoline_cps_call
		                       (of_int,
		                        917760 + digit | 0,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (add_utf_8_uchar,
		                                  buffer,
		                                  a,
		                                  function(a){return caml_exact_trampoline_call1(b, l);});
		                        });
		              }
		              if(256 > index) return b(acc$0);
		              var index$0 = index / 256 | 0;
		              return caml_exact_trampoline_call2(a, acc$0, index$0);
		             });
		   };
		return a(0, index);
		                                       }
		                                      }
		                                      return cont(text);
		                                     });
		                           });
		                 var l = t[2], text = t[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (update$0,
		                          counts,
		                          text,
		                          function(param, cont){
		                           if(! param) return cont(1);
		                           var n = param[1];
		                           return cont(n + 1 | 0);
		                          },
		                          function(init){
		                           return caml_exact_trampoline_call2(a, l, init);
		                          });
		                }
		                return a(texts, init);
		               }
		               var
		                snil = cst$1,
		                white_space_map =
		                  [0,
		                   0,
		                   [0,
		                    [0,
		                     "\0>\0\0\x01\0\0\0\0\0\0\0\0\0\0\0 \0\0\0\x01\0\0\0\0\0\0\0\0\0\0\0",
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil],
		                    [0,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil],
		                    [0,
		                     "\xff\x07\0\0\0\x83\0\0\0\0\0\x80\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil],
		                    [0,
		                     "\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil,
		                     snil],
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil,
		                    nil]];
		               function strings(c, b, opt, choices, cont){
		                function a(break$){
		                 var
		                  ci = b ? b[1] : 0,
		                  matcher =
		                    opt ? opt[1] : function(param, cont){return cont(0);};
		                 return caml_exact_trampoline_cps_call$1
		                         (mapi$4,
		                          choices,
		                          function(index, param, cont){
		                           var value = param[2], text = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (matcher,
		                                    text,
		                                    function(a){
		                                     return cont([0, [0, text], 0, 1, text, a, value, index]);
		                                    });
		                          },
		                          function(s){
		                           return caml_trampoline_cps_call3
		                                   (let$3,
		                                    at_end_of_input$0,
		                                    function(at_end, cont){
		                                     if(at_end)
		                                      return caml_exact_trampoline_cps_call
		      (elements_of_list,
		       choices,
		       function(a){
		        return caml_trampoline_cps_call3
		                (map$18,
		                 a,
		                 calendar,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (disambiguate,
		                           a,
		                           function(disambiguate){
		                            return caml_exact_trampoline_cps_call$1
		                                    (mapi$4,
		                                     choices,
		                                     function(index, param, cont){
		                                      var value = param[2], text = param[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (disambiguate,
		       index,
		       text,
		       function(a){return cont([0, a, value]);});
		                                     },
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (return$16, make_completion(0, 0, [1, a]), cont);
		                                     });
		                           });
		                 });
		       });
		                                     var
		                                      decoder$0 = decoder(0, o5, -328752538),
		                                      buffer = make(1, 0);
		                                     function f(param, c, cont){
		                                      var
		                                       choices = param[4],
		                                       selected = param[3],
		                                       length = param[2],
		                                       skipped = param[1];
		                                      caml_bytes_set(buffer, 0, c);
		                                      return caml_exact_trampoline_cps_call$2
		      (src$0,
		       decoder$0,
		       buffer,
		       0,
		       1,
		       function(match){
		        return caml_trampoline_cps_call2
		                (decoder$0[18],
		                 decoder$0,
		                 function(a){
		                  if(typeof a === "number"){
		                   if(1006505782 <= a)
		                    return cont
		                            ([0, [0, skipped + 1 | 0, length, selected, choices]]);
		                  }
		                  else {
		                   var variant = a[1];
		                   if(852405675 <= variant){
		                    var
		                     input_char = a[2],
		                     a = 917760 <= input_char,
		                     a = a ? input_char <= 917999 : a;
		                    if(! a){
		                     var
		                      process_case =
		                        function(case$, cont){
		                         function f(a, cont){
		                          var
		                           distance = a[2],
		                           s = a[1],
		                           a = input_char < 256 ? [0, input_char] : 0;
		                          if(s === cst$1) return cont(0);
		                          if(! a) return cont(0);
		                          var c = a[1];
		                          function f(idx, c$0){return c === c$0 ? 1 : 0;}
		                          return caml_exact_trampoline_cps_call$0
		                                  (findi,
		                                   iteri,
		                                   s,
		                                   f,
		                                   function(match){
		                                    if(! match) return cont(0);
		                                    var
		                                     pos = match[1][1],
		                                     pos$0 = pos + 1 | 0,
		                                     a = distance + pos$0 | 0;
		                                    return caml_exact_trampoline_cps_call$0
		    (sub_fun,
		     s,
		     pos$0,
		     caml_ml_string_length(s) - pos$0 | 0,
		     function(b){return cont([0, [0, b, a]]);});
		                                   });
		                         }
		                         return caml_exact_trampoline_cps_call$1
		                                 (filter_map$0,
		                                  case$[5],
		                                  f,
		                                  function(alternatives){
		                                   var
		                                    case$0 =
		                                      [0,
		                                       case$[1],
		                                       case$[2],
		                                       case$[3],
		                                       case$[4],
		                                       alternatives,
		                                       case$[6],
		                                       case$[7]],
		                                    match = case$0[1];
		                                   function a(case_after_parsing){
		                                    if(! case_after_parsing[1] && ! case_after_parsing[5])
		                                     return cont(0);
		                                    return cont([0, case_after_parsing]);
		                                   }
		                                   if(! match) return a(case$0);
		                                   var uchars = match[1];
		                                   function b(codepoint_index, byte_index){
		                                    function d(b){
		                                     if(! b)
		                                      return a
		      ([0,
		        0,
		        case$0[2],
		        case$0[3],
		        case$0[4],
		        case$0[5],
		        case$0[6],
		        case$0[7]]);
		                                     b = b[1];
		                                     var
		                                      matched_codepoint_length = b[3],
		                                      codepoint_index = b[2],
		                                      byte_index = b[1],
		                                      rest_start = byte_index + matched_codepoint_length | 0,
		                                      c = case$0[2] + codepoint_index | 0,
		                                      d = case$0[7],
		                                      e = case$0[6],
		                                      f = case$0[5],
		                                      g = case$0[4],
		                                      h = case$0[3];
		                                     return caml_exact_trampoline_cps_call$0
		     (get_sub,
		      uchars,
		      rest_start,
		      caml_ml_string_length(uchars) - rest_start | 0,
		      function(b){return a([0, [0, b], c, h, g, f, e, d]);});
		                                    }
		                                    if(byte_index === caml_ml_string_length(uchars))
		                                     return d(0);
		                                    var decode = get_utf_8_uchar$0(uchars, byte_index);
		                                    function c(a){
		                                     var
		                                      matched_codepoint_length = utf_decode_length(decode),
		                                      char = decode & 16777215,
		                                      a = get$6(white_space_map, input_char),
		                                      both_witespace = a ? get$6(white_space_map, char) : a;
		                                     a:
		                                     if(both_witespace)
		                                      a = both_witespace;
		                                     else if(ci){
		                                      a = to_lower(input_char);
		                                      var match = to_lower(char);
		                                      if(typeof a === "number"){
		                                       if(typeof match === "number"){
		a = input_char === char;
		break a;
		                                       }
		                                       a = match[2];
		                                       if(a && ! a[2]){
		var r = a[1], a = input_char === r;
		break a;
		                                       }
		                                      }
		                                      else {
		                                       var t1 = a[2];
		                                       if
		(t1
		 &&
		  ! t1[2] && typeof match === "number" && 925480876 === match){var l = t1[1], a = l === char; break a;}
		                                       if(typeof match !== "number"){
		var variant = match[1];
		if(-1039579032 === variant){
		 var t2 = match[2], t2$1 = t2, t1$1 = t1;
		 for(;;){
		  if(t1$1){
		   if(t2$1){
		    var
		     t2$0 = t2$1[2],
		     x2 = t2$1[1],
		     t1$0 = t1$1[2],
		     x1 = t1$1[1],
		     a = x1 === x2;
		    if(a){t2$1 = t2$0; t1$1 = t1$0; continue;}
		    break a;
		   }
		  }
		  else if(! t2$1){a = 1; break a;}
		  a = 0;
		  break a;
		 }
		}
		                                       }
		                                      }
		                                      a = 0;
		                                     }
		                                     else
		                                      a = input_char === char;
		                                     if(a)
		                                      return d
		      ([0,
		        [0, byte_index, codepoint_index, matched_codepoint_length]]);
		                                     var
		                                      byte_index$0 = byte_index + matched_codepoint_length | 0,
		                                      codepoint_index$0 = codepoint_index + 1 | 0;
		                                     return caml_exact_trampoline_call2
		     (b, codepoint_index$0, byte_index$0);
		                                    }
		                                    return 1 - utf_decode_is_valid(decode)
		    ? caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       failwith,
		       fmt$32,
		       function(a){
		        return caml_trampoline_cps_call3(a, byte_index, uchars, c);
		       })
		    : c(0);
		                                   }
		                                   return b(0, 0);
		                                  });
		                        },
		                      tl = choices[2],
		                      hd = choices[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (filter_map$0,
		                              tl,
		                              process_case,
		                              function(tl){
		                               return caml_exact_trampoline_cps_call
		                                       (process_case,
		hd,
		function(a){
		 if(a) var hd = a[1], a = [0, hd, tl]; else a = tl;
		 if(! a) return cont(0);
		 var tail = a[2], head = a[1];
		 return cont
		         ([0, [0, 0, length + 1 | 0, selected, [0, head, tail]]]);
		});
		                              });
		                    }
		                    var digit = input_char - 917760 | 0;
		                    if(selected)
		                     var
		                      selected$0 = selected[1],
		                      selected$1 = [0, (selected$0 * 256 | 0) + digit | 0];
		                    else
		                     selected$1 = [0, digit];
		                    return cont
		                            ([0, [0, 0, length + 1 | 0, selected$1, choices]]);
		                   }
		                  }
		                  return cont(0);
		                 });
		       });
		                                     }
		                                     var state = [0, 0, 0, 0, s];
		                                     function a(a, cont){
		                                      a = a[2];
		                                      var
		                                       choices = a[4],
		                                       selected = a[3],
		                                       scanned_length = a[2],
		                                       skipped = a[1];
		                                      function c(param, cont){
		                                       var at_end = param[2];
		                                       function a(choices){
		function a(choices){
		 return caml_exact_trampoline_cps_call
		         (elements_of_list,
		          s,
		          function(b){
		           var
		            a =
		              list
		               ([0, comma],
		                function(ppf, v, cont){
		                 var text = v[4];
		                 return caml_exact_trampoline_cps_call$1
		                         (string$1, ppf, text, cont);
		                });
		           return caml_exact_trampoline_cps_call$1
		                   (kasprintf,
		                    id,
		                    fmt$31,
		                    function(c){
		                     return caml_trampoline_cps_call3
		                             (c,
		                              a,
		                              b,
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (fail$3,
		a,
		function(failure){
		 if(! choices) return cont(failure);
		 var tl = choices[2], hd = choices[1];
		 function compare(c1, c2, cont){
		  var x = c1[2], a = c2[2];
		  return caml_trampoline_cps_call2
		          (letrec_function_context$28[1],
		           0,
		           function(b){
		            return caml_trampoline_cps_call2
		                    (b,
		                     x,
		                     function(b){return caml_trampoline_cps_call2(b, a, cont);});
		           });
		 }
		 return caml_exact_trampoline_cps_call
		         (elements_of_list,
		          [0, hd, tl],
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (stable_sort,
		                    a,
		                    compare,
		                    function(a){
		                     a = of_list$4(a);
		                     function b(ranked){
		                      return caml_exact_trampoline_cps_call
		                              (elements_of_list,
		                               ranked,
		                               function(a){
		                                return caml_trampoline_cps_call3
		(map$18,
		 a,
		 function(param, cont){
		  var text = param[4];
		  return cont(text);
		 },
		 function(a){
		  return caml_exact_trampoline_cps_call
		          (disambiguate,
		           a,
		           function(disambiguate){
		            return caml_exact_trampoline_cps_call$1
		                    (map$19,
		                     ranked,
		                     function(param, cont){
		                      var index = param[7], value = param[6], text = param[4];
		                      return caml_exact_trampoline_cps_call$1
		                              (disambiguate,
		                               index,
		                               text,
		                               function(a){return cont([0, a, value]);});
		                     },
		                     function(choices){
		                      return caml_trampoline_cps_call2
		                              (return$16,
		                               make_completion(0, scanned_length, [1, choices]),
		                               function(completion){
		                                var hd = ranked[1], value = hd[6], text = hd[4];
		                                return caml_trampoline_cps_call2
		(return$16,
		 make_completion(0, scanned_length, [0, [0, text, value]]),
		 function(valid){
		  if(! at_end)
		   return caml_exact_trampoline_cps_call$1
		           (symbol$91, break$, valid, cont);
		  var a = ranked[1][1];
		  if(a && a[1] === cst$1 && ! ranked[2])
		   return caml_exact_trampoline_cps_call$1
		           (symbol$91,
		            break$,
		            valid,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (symbol$64, a, completion, cont);
		            });
		  return cont(completion);
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     }
		                     if(! a)
		                      return caml_exact_trampoline_cps_call(failwith, bPX, b);
		                     var l = a[1];
		                     return b(l);
		                    });
		          });
		});
		                              });
		                    });
		          });
		}
		if(! selected) return a(choices);
		var selected$0 = selected[1];
		return caml_exact_trampoline_cps_call$1
		        (filter,
		         choices,
		         function(param, cont){
		          var index = param[7];
		          return cont(index === selected$0 ? 1 : 0);
		         },
		         function(choices$0){
		          return choices$0 ? a(choices$0) : a(choices);
		         });
		                                       }
		                                       return at_end
		       ? caml_exact_trampoline_cps_call
		         (elements_of_list, choices, a)
		       : caml_exact_trampoline_cps_call
		         (filter$6(choices),
		          function(a, cont){
		           a = a[1];
		           if(a && a[1] === cst$1) return cont(1);
		           return cont(0);
		          },
		          a);
		                                      }
		                                      function b(a){
		                                       return caml_trampoline_cps_call3
		       (and$2,
		        a,
		        at_end_of_input$0,
		        function(a){
		         return caml_trampoline_cps_call3(let$3, a, c, cont);
		        });
		                                      }
		                                      return 0 === skipped
		      ? caml_trampoline_cps_call2(return$16, 0, b)
		      : caml_exact_trampoline_cps_call
		        (wrap, backtrack(skipped), b);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (wrap,
		      scan(state, f, substring),
		      function(b){
		       return caml_trampoline_cps_call3(let$3, b, a, cont);
		      });
		                                    },
		                                    cont);
		                          });
		                }
		                return c
		                        ? a(c[1])
		                        : caml_trampoline_cps_call2(return$18, 0, a);
		               }
		               function strings_alternate
		               (break$, ci, matcher, rich_choices, cont){
		                function f(index, a, cont){
		                 var
		                  value = a[3],
		                  alternate = a[2],
		                  canonical = a[1],
		                  entry = [0, index, value],
		                  a = alternate,
		                  right = 0,
		                  left = [0, canonical, entry];
		                 for(;;){
		                  if(! a) return cont([0, left, right]);
		                  var
		                   l = a[2],
		                   ms = a[1],
		                   accu = [0, [0, ms, [0, canonical, entry]], right];
		                  a = l;
		                  right = accu;
		                 }
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (mapi$4,
		                         rich_choices,
		                         f,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (elements_of_list,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (unzip,
		     a,
		     function(match){
		      var alt_choices = match[2], canonical_choices = match[1];
		      return caml_exact_trampoline_cps_call
		              (of_list_exn,
		               canonical_choices,
		               function(can_choices){
		                return caml_exact_trampoline_cps_call
		                        (of_list,
		                         alt_choices,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_rev_keys,
		                                   a,
		                                   function(alt_choices){
		                                    return caml_exact_trampoline_cps_call$2
		    (strings,
		     break$,
		     ci,
		     matcher,
		     can_choices,
		     function(canonical){
		      function a(alternate){
		       function deduplicate(cpl, cont){
		        var result = cpl[3];
		        function b(result){
		         return cont([0, cpl[1], cpl[2], result]);
		        }
		        if(0 === result[0]){
		         var a = result[1], value = a[2][2], text = a[1];
		         return b([0, [0, text, value]]);
		        }
		        var l = result[1];
		        return caml_exact_trampoline_cps_call
		                (elements_of_list,
		                 l,
		                 function(t){
		                  var init = [0, empty$8([0, comparator$4]), 0];
		                  function a(t, init){
		                   if(t){
		                    var
		                     l$0 = t[2],
		                     a$0 = t[1],
		                     match = a$0[2],
		                     value = match[2],
		                     index = match[1],
		                     text = a$0[1],
		                     acc = init[2],
		                     seen = init[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (mem$3,
		                             seen,
		                             index,
		                             function(c){
		                              if(c)
		                               return caml_exact_trampoline_call2(a, l$0, [0, seen, acc]);
		                              var b = [0, [0, text, value], acc];
		                              return caml_exact_trampoline_cps_call$1
		                                      (add$4,
		                                       seen,
		                                       index,
		                                       function(c){
		return caml_exact_trampoline_call2(a, l$0, [0, c, b]);
		                                       });
		                             });
		                   }
		                   var l = init[2];
		                   return caml_exact_trampoline_cps_call
		                           (of_rev_keys,
		                            l,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (of_list_exn, a, function(a){return b([1, a]);});
		                            });
		                  }
		                  return a(t, init);
		                 });
		       }
		       return caml_exact_trampoline_cps_call$1
		               (or_with_concatenated_completio,
		                canonical,
		                alternate,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (map$28, a, deduplicate, cont);
		                });
		      }
		      if(! alt_choices)
		       return caml_exact_trampoline_cps_call
		               (fail$3, "no alternatives", a);
		      var t = alt_choices[2], h = alt_choices[1];
		      return caml_exact_trampoline_cps_call
		              (elements_of_list,
		               can_choices,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         b,
		                         calendar,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (disambiguate,
		                                   b,
		                                   function(disambiguate){
		                                    function canonify(cpl, cont){
		                                     var result = cpl[3];
		                                     function a(result){
		                                      return cont([0, cpl[1], cpl[2], result]);
		                                     }
		                                     if(0 === result[0]){
		                                      var
		                                       match = result[1][2],
		                                       entry = match[2],
		                                       canonical = match[1];
		                                      return a([0, [0, canonical, entry]]);
		                                     }
		                                     var l = result[1];
		                                     function f(a, cont){
		                                      a = a[2];
		                                      var entry = a[2], index = entry[1], canonical = a[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (disambiguate,
		       index,
		       canonical,
		       function(a){return cont([0, a, entry]);});
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (rev_map$0, l, f, function(b){return a([1, b]);});
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (strings,
		     break$,
		     ci,
		     matcher,
		     [0, h, t],
		     function(b){
		      return caml_trampoline_cps_call3(map$28, b, canonify, a);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function string$5(a, opt, s, cont){
		                var ci = a ? a[1] : 0, complete = opt ? opt[1] : 0;
		                if(complete)
		                 return caml_exact_trampoline_cps_call$2
		                         (strings, 0, [0, ci], 0, [0, [0, s, 0], 0], cont);
		                var sp = ci ? string_ci : string$4;
		                function b(param, cont){
		                 return caml_trampoline_cps_call2
		                         (return$16,
		                          make_completion(0, caml_ml_string_length(s), [0, [0, s, 0]]),
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (sp,
		                         s,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (wrap$0,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(let$3, a, b, cont);
		                                   });
		                         });
		               }
		               function char$2(c, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$6,
		                         c,
		                         function(b){
		                          var v = [0, b, c];
		                          function a(param, cont){
		                           return cont(make_completion(0, 1, [0, v]));
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (char$1,
		                                   c,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$4,
		     b,
		     a,
		     function(p){
		      return caml_trampoline_cps_call2
		              (return$16,
		               make_completion(0, 0, [1, [0, v, 0]]),
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$91,
		                         end_of_input$1,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$64, p, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var cst_out_of_bound = "out of bound";
		               function number_bounded(min, max, completion, cont){
		                function a(n, cont){
		                 if(min <= n && n <= max)
		                  return caml_trampoline_cps_call2(return$18, n, cont);
		                 return caml_exact_trampoline_cps_call
		                         (fail$3, cst_out_of_bound, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (number,
		                         completion,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$13, b, a, cont);
		                         });
		               }
		               function day_of_month(require_qualifier$0, completion, cont){
		                var
		                 require_qualifier =
		                   require_qualifier$0 ? require_qualifier$0[1] : 0,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 let$ = open[3];
		                function a(n, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$23,
		                          n,
		                          100,
		                          function(c){
		                           function a(suffix){
		                            return caml_exact_trampoline_cps_call$2
		                                    (strings,
		                                     0,
		                                     0,
		                                     0,
		                                     [0, [0, suffix, 0], 0],
		                                     function(p){
		                                      function a(p){
		                                       return caml_trampoline_cps_call3
		       (let$,
		        p,
		        function(param, cont){
		         var min = min$1[1];
		         if(n < min)
		          return caml_exact_trampoline_cps_call
		                  (fail$3, "number too small", cont);
		         var max = max$1[1];
		         return max < n
		                 ? caml_exact_trampoline_cps_call
		                   (fail$3, "number too big", cont)
		                 : caml_trampoline_cps_call2(return$18, n, cont);
		        },
		        cont);
		                                      }
		                                      return require_qualifier
		      ? a(p)
		      : caml_exact_trampoline_cps_call$0
		        (option$2, 0, [0, suffix, 0], p, a);
		                                     });
		                           }
		                           function b(){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$23,
		                                     n,
		                                     10,
		                                     function(b){
		                                      b = b - 1 | 0;
		                                      if(2 < b >>> 0) return a(cst_th);
		                                      switch(b){
		case 0:
		 return a(cst_st);
		case 1:
		 return a(cst_nd);
		default: return a(cst_rd);
		                                      }
		                                     });
		                           }
		                           return 4 <= c
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (symbol$23,
		                                      n,
		                                      100,
		                                      function(c){return 20 < c ? b() : a(cst_th);})
		                                   : b();
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (number,
		                         completion,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var month_values = caml_obj_dup(o6);
		               function complete(values, cont){
		                return caml_trampoline_cps_call3
		                        (let$4,
		                         end_of_input$0,
		                         function(param, cont){return cont([0, 0, 0, [1, values]]);},
		                         cont);
		               }
		               function month(fuzzy, opt, param, cont){
		                var start = opt ? opt[1] : 0, start$0 = to_int$1(start);
		                return caml_trampoline_cps_call3
		                        (map$11,
		                         range$0(0, 0, 0, 0, 12),
		                         function(i, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$23,
		                                   (i + start$0 | 0) - 1 | 0,
		                                   12,
		                                   function(a){
		                                    return cont(caml_check_bound(month_values, a)[a + 1]);
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_binable,
		                                   a,
		                                   function(months){
		                                    return caml_exact_trampoline_cps_call$3
		    (consts,
		     o7,
		     0,
		     fuzzy,
		     0,
		     months,
		     function(a){return cont(symbol$63(a, "month-name"));});
		                                   });
		                         });
		               }
		               function operator(symbol, cont){
		                function a(symbol, cont){
		                 var a = [0, [0, symbol, 0]];
		                 return caml_exact_trampoline_cps_call
		                         (utf8_length,
		                          symbol,
		                          function(b){return cont([0, 0, b, a]);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (string$4,
		                         symbol,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_map$10,
		                                   b,
		                                   a,
		                                   function(op){
		                                    return caml_exact_trampoline_cps_call$1(token, 0, op, cont);
		                                   });
		                         });
		               }
		               function keyword(name, cont){
		                function a(symbol, cont){
		                 var a = [0, [0, symbol, 0]];
		                 return caml_exact_trampoline_cps_call
		                         (utf8_length,
		                          symbol,
		                          function(b){return cont([0, 0, b, a]);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (string$4,
		                         name,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_map$10,
		                                   b,
		                                   a,
		                                   function(kw){
		                                    return caml_exact_trampoline_cps_call$1
		    (token,
		     0,
		     kw,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$93,
		               a,
		               leading_whitespace1,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$93, a, cut_completion, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function augment_single_completion(f, p, cont){
		                function f$0(c, cont){
		                 var a = c[3];
		                 if(0 !== a[0]){
		                  a = a[1];
		                  if(! a[2]){
		                   var v = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (f,
		                            v,
		                            function(a){return cont([0, c[1], c[2], [1, [0, v, a]]]);});
		                  }
		                 }
		                 return cont(c);
		                }
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$11,
		                      symbol_map$10,
		                      ,
		                      bind$16,
		                      return$16,
		                      map$28,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$7]),
		                 let$ = open[3],
		                 symbol_bind = open[1];
		                return caml_trampoline_cps_call3
		                        (let$,
		                         p,
		                         function(completion, cont){
		                          return caml_trampoline_cps_call2
		                                  (return$16,
		                                   completion,
		                                   function(original){
		                                    var match = completion[3];
		                                    if(0 !== match[0]) return cont(original);
		                                    var v = match[1];
		                                    return caml_trampoline_cps_call2
		    (return$16,
		     [0, completion[1], completion[2], [1, [0, v, 0]]],
		     function(complete){
		      return caml_trampoline_cps_call3
		              (symbol_bind,
		               confirm$0,
		               function(param, cont){
		                return 0 === param[3][0] ? cont(original) : cont(complete);
		               },
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$64, a, complete, cont);
		               });
		     });
		                                   });
		                         },
		                         function(p){
		                          return caml_trampoline_cps_call3(map$28, p, f$0, cont);
		                         });
		               }
		               function to_completion(f, param, cont){
		                var a = param[3], replaced = param[2];
		                if(0 === a[0]){
		                 a = a[1];
		                 var v = a[2], c = a[1];
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          v,
		                          function(a){
		                           return cont([0, [0, v], [0, replaced, [0, [0, c, a], 0]]]);
		                          });
		                }
		                a = a[1];
		                var tail = a[2], head = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$19,
		                         [0, head, tail],
		                         function(param, cont){
		                          var v = param[2], c = param[1];
		                          return caml_exact_trampoline_cps_call
		                                  (f, v, function(a){return cont([0, c, a]);});
		                         },
		                         function(a){return cont([0, 0, [0, replaced, a]]);});
		               }
		               function abbrev(short, long, value, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$11,
		                      symbol_map$10,
		                      ,
		                      bind$16,
		                      return$16,
		                      map$28,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$7]),
		                 let$ = open[3];
		                function a(param, cont){
		                 return caml_trampoline_cps_call2
		                         (return$16,
		                          [0, 0, caml_ml_string_length(short), [0, [0, long, value]]],
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (string$4,
		                         short,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var
		                stopper = caml_callback(string$5, [0, o8, cst$6]),
		                maybe_stopper = caml_callback(option$2, [0, o9, stopper]);
		               function filter$7(p, f, cont){
		                return caml_trampoline_cps_call3
		                        (g
		                           ([0,
		                             symbol_bind$11,
		                             symbol_map$10,
		                             ,
		                             bind$16,
		                             return$16,
		                             map$28,
		                             ,
		                             ,
		                             ,
		                             ,
		                             Let_syntax$7])
		                          [1],
		                         p,
		                         function(c, cont){
		                          var match = c[3];
		                          if(0 === match[0]){
		                           var value = match[1][2];
		                           return caml_exact_trampoline_cps_call
		                                   (f,
		                                    value,
		                                    function(a){
		                                     return a
		     ? caml_trampoline_cps_call2(return$16, c, cont)
		     : caml_exact_trampoline_cps_call
		       (fail$3, "result filtered out", cont);
		                                    });
		                          }
		                          var completions = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (filter$6(completions),
		                                   function(param, cont){
		                                    var v = param[2];
		                                    return caml_exact_trampoline_cps_call(f, v, cont);
		                                   },
		                                   function(match){
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fail$3, "all completions filtered out", cont);
		                                    var tl = match[2], hd = match[1];
		                                    return caml_trampoline_cps_call2
		    (return$16, [0, c[1], c[2], [1, [0, hd, tl]]], cont);
		                                   });
		                         },
		                         cont);
		               }
		               caml_callback(wrap$0, [at_end_of_input$0]);
		               function keep_n(n, p, cont){
		                return caml_trampoline_cps_call3
		                        (g
		                           ([0,
		                             symbol_bind$11,
		                             symbol_map$10,
		                             ,
		                             bind$16,
		                             return$16,
		                             map$28,
		                             ,
		                             ,
		                             ,
		                             ,
		                             Let_syntax$7])
		                          [1],
		                         p,
		                         function(c, cont){
		                          var match = c[3];
		                          if(0 === match[0])
		                           return caml_trampoline_cps_call2(return$16, c, cont);
		                          var completions = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (elements_of_list,
		                                   completions,
		                                   function(cpl){
		                                    return caml_exact_trampoline_cps_call$1
		    (take$0,
		     cpl,
		     n,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (of_list_exn,
		               a,
		               function(completions){
		                return caml_trampoline_cps_call2
		                        (return$16, [0, c[1], c[2], [1, completions]], cont);
		               });
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function leak_completing(p, cont){
		                function leak(cpl, cont){
		                 var result = cpl[3];
		                 function a(result){return cont([0, cpl[1], cpl[2], result]);}
		                 if(0 === result[0]){
		                  var match = result[1], v = match[2], s = match[1];
		                  return a([0, [0, s, [0, v, 0]]]);
		                 }
		                 var l = result[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$19,
		                          l,
		                          function(param, cont){
		                           var v = param[2], s = param[1];
		                           return cont([0, s, [0, v, 1]]);
		                          },
		                          function(b){return a([1, b]);});
		                }
		                return caml_trampoline_cps_call3(map$28, p, leak, cont);
		               }
		               g
		                ([0,
		                  symbol_bind$11,
		                  symbol_map$10,
		                  ,
		                  bind$16,
		                  return$16,
		                  map$28,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$7]);
		               function f$5(c, cont){
		                return caml_exact_trampoline_cps_call
		                        (alnum,
		                         c,
		                         function(a){
		                          if(a) return cont(a);
		                          a = c - 94 | 0;
		                          a:
		                          {
		                           if(32 < a >>> 0){
		                            a = a + 61 | 0;
		                            if(30 < a >>> 0) break a;
		                            switch(a){
		                              case 0:
		                              case 2:
		                              case 3:
		                              case 4:
		                              case 5:
		                              case 6:
		                              case 9:
		                              case 10:
		                              case 12:
		                              case 14:
		                              case 28:
		                              case 30: break;
		                              default: break a;
		                            }
		                           }
		                           else if(25 >= a - 3 >>> 0) break a;
		                           return cont(1);
		                          }
		                          return cont(0);
		                         });
		               }
		               var
		                atom$0 = count_while1(f$5, substring),
		                open$2 =
		                  g
		                   ([0,
		                     symbol_bind$13,
		                     symbol_map$12,
		                     ,
		                     bind$18,
		                     return$18,
		                     map$30,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$8]),
		                let$5 = open$2[3],
		                p$1 =
		                  symbol_map$3
		                   (sep_by1(char$0(46), atom$0),
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (concat$0, o_, a, cont);
		                    }),
		                local =
		                  caml_callback
		                   (let$5,
		                    [caml_callback(wrap$0, [caml_callback(wrap, [p$1])]),
		                     function(local, cont){
		                      return caml_trampoline_cps_call2
		                              (return$16,
		                               make_completion
		                                (0, caml_ml_string_length(local), [0, [0, local, local]]),
		                               cont);
		                     }]),
		                open$3 =
		                  g
		                   ([0,
		                     symbol_bind$13,
		                     symbol_map$12,
		                     ,
		                     bind$18,
		                     return$18,
		                     map$30,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$8]),
		                let$6 = open$3[3],
		                p$2 =
		                  symbol_map$3
		                   (lift2
		                     (function(x, r, cont){return cont([0, x, r]);},
		                      atom$0,
		                      many(symbol$61(char$0(46), atom$0))),
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (concat$0, o$, a, cont);
		                    }),
		                domain =
		                  caml_callback
		                   (let$6,
		                    [caml_callback(wrap$0, [caml_callback(wrap, [p$2])]),
		                     function(domain, cont){
		                      return caml_exact_trampoline_cps_call$2
		                              (contains$0,
		                               0,
		                               0,
		                               domain,
		                               46,
		                               function(has_ext){
		                                return caml_trampoline_cps_call2
		(return$16,
		 make_completion
		  (0,
		   caml_ml_string_length(domain),
		   [0, [0, domain, [0, domain, has_ext]]]),
		 cont);
		                               });
		                     }]),
		                completions =
		                  caml_callback
		                   (map$19,
		                    [common_domains, function(x, cont){return cont([0, x, x]);}]),
		                complete$0 = caml_callback(strings, [0, 0, 0, completions]),
		                open$4 =
		                  g
		                   ([0,
		                     symbol_bind$13,
		                     symbol_map$12,
		                     ,
		                     bind$18,
		                     return$18,
		                     map$30,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$8]),
		                let$7 = open$4[3],
		                domain$0 =
		                  caml_callback
		                   (let$7,
		                    [domain,
		                     function(param, cont){
		                      var has_ext = param[2], domain = param[1];
		                      function a(a){
		                       return caml_trampoline_cps_call2
		                               (return$18,
		                                domain,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call$1
		 (symbol$93, b, a, cont);
		                                });
		                      }
		                      return has_ext
		                              ? caml_trampoline_cps_call2(return$18, 0, a)
		                              : caml_exact_trampoline_cps_call$2(strings, 0, 0, 0, pa, a);
		                     }]),
		                domain$1 = caml_callback(symbol$64, [complete$0, domain$0]);
		               g
		                ([0,
		                  symbol_bind$11,
		                  symbol_map$10,
		                  ,
		                  bind$16,
		                  return$16,
		                  map$28,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$7]);
		               e = caml_callback(return$16, [make_completion(0, 1, pb)]);
		               var
		                trailing_period =
		                  caml_callback(symbol$91, [caml_callback(char$1, [46]), e]),
		                open$5 =
		                  g
		                   ([0,
		                     symbol_bind$13,
		                     symbol_map$12,
		                     ,
		                     bind$18,
		                     return$18,
		                     map$30,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$8]),
		                let$8 = open$5[3],
		                email =
		                  caml_callback
		                   (token,
		                    [1,
		                     caml_callback
		                      (let$8,
		                       [local,
		                        function(local, cont){
		                         function a(param, cont){
		                          function a(param, cont){
		                           return caml_trampoline_cps_call3
		                                   (let$8,
		                                    domain$1,
		                                    function(domain, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$33,
		      function(a){
		       return caml_trampoline_cps_call3
		               (a,
		                local,
		                domain,
		                function(a){
		                 return caml_trampoline_cps_call2(return$18, a, cont);
		                });
		      });
		                                    },
		                                    cont);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (char$2,
		                                   64,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$8, b, a, cont);
		                                   });
		                         }
		                         return caml_exact_trampoline_cps_call$0
		                                 (option$2,
		                                  0,
		                                  pc,
		                                  trailing_period,
		                                  function(b){
		                                   return caml_trampoline_cps_call3(let$8, b, a, cont);
		                                  });
		                        }])]),
		                open$6 =
		                  g
		                   ([0,
		                     symbol_bind$11,
		                     symbol_map$10,
		                     ,
		                     bind$16,
		                     return$16,
		                     map$28,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$7]),
		                let$9 = open$6[4],
		                cst_times = "times";
		               function merge_result(opt, l, r, cont){
		                var strict = opt ? opt[1] : 1;
		                function merge(name, l, r, cont){
		                 a:
		                 {
		                  if(l){
		                   var v = l[1];
		                   if(! r){var v$0 = v; break a;}
		                   if(strict)
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             fail,
		                             format$11,
		                             function(a){
		                              return caml_trampoline_cps_call2(a, name, cont);
		                             });
		                  }
		                  else if(! r)
		                   return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                  v$0 = r[1];
		                 }
		                 return caml_trampoline_cps_call2
		                         (of_string$14, [0, v$0], cont);
		                }
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 and = open[5],
		                 let$ = open[3];
		                function a(a, cont){
		                 var
		                  type = a[2],
		                  a = a[1],
		                  destination = a[2],
		                  a = a[1],
		                  slot = a[2],
		                  a = a[1],
		                  recurrence = a[2],
		                  a = a[1],
		                  priority = a[2],
		                  a = a[1],
		                  duration = a[2],
		                  a = a[1],
		                  daytime = a[2],
		                  dates = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (append$0,
		                          l[6],
		                          r[6],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0,
		                                    l[5],
		                                    r[5],
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (of_string$14,
		      [0,
		       dates,
		       daytime,
		       destination,
		       duration,
		       b,
		       a,
		       priority,
		       recurrence,
		       slot,
		       type],
		      cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (merge,
		                         cst_dates,
		                         l[1],
		                         r[1],
		                         function(left){
		                          return caml_exact_trampoline_cps_call$0
		                                  (merge,
		                                   cst_times,
		                                   l[2],
		                                   r[2],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     left,
		     b,
		     function(left){
		      return caml_exact_trampoline_cps_call$0
		              (merge,
		               "durations",
		               l[4],
		               r[4],
		               function(b){
		                return caml_trampoline_cps_call3
		                        (and,
		                         left,
		                         b,
		                         function(left){
		                          return caml_exact_trampoline_cps_call$0
		                                  (merge,
		                                   cst_priority,
		                                   l[7],
		                                   r[7],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     left,
		     b,
		     function(left){
		      return caml_exact_trampoline_cps_call$0
		              (merge,
		               cst_recurrence,
		               l[8],
		               r[8],
		               function(b){
		                return caml_trampoline_cps_call3
		                        (and,
		                         left,
		                         b,
		                         function(left){
		                          return caml_exact_trampoline_cps_call$0
		                                  (merge,
		                                   cst_slots,
		                                   l[9],
		                                   r[9],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     left,
		     b,
		     function(left){
		      return caml_exact_trampoline_cps_call$0
		              (merge,
		               cst_destination,
		               l[3],
		               r[3],
		               function(b){
		                return caml_trampoline_cps_call3
		                        (and,
		                         left,
		                         b,
		                         function(left){
		                          return caml_exact_trampoline_cps_call$0
		                                  (merge,
		                                   cst_type,
		                                   l[10],
		                                   r[10],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     left,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                day_name =
		                  symbol$63
		                   (caml_callback(consts, [pd, 0, 0, 0, day_names]),
		                    "weekday-name"),
		                day_shorthand =
		                  symbol$63
		                   (caml_callback(consts, [pf, 0, 0, 0, pe]), "day-shorthand"),
		                cst_noon = "noon";
		               function daytime(config, context, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 let$ = open[3],
		                 query_dates = value$4(context[1], [0, config[2]]);
		                return caml_exact_trampoline_cps_call$0
		                        (to_time$3,
		                         config[18],
		                         config[2],
		                         config[5],
		                         function(now){
		                          function a(raw_hour, cont){
		                           function a(minutes, cont){
		                            function b(military_hour, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (make$7,
		                                      military_hour,
		                                      minutes,
		                                      0,
		                                      function(match){
		                                       if(0 === match[0]){
		var daytime = match[1];
		return caml_trampoline_cps_call2(return$18, daytime, cont);
		                                       }
		                                       var e = match[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$34,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a,
		                  e,
		                  function(a){
		                   return caml_exact_trampoline_cps_call(fail$3, a, cont);
		                  });
		        });
		                                      });
		                            }
		                            function a(a){
		                             return caml_trampoline_cps_call3(let$, a, b, cont);
		                            }
		                            return 4735457 <= config[10]
		                                    ? caml_trampoline_cps_call2(return$18, raw_hour, a)
		                                    : caml_exact_trampoline_cps_call$1
		                                      (symbol$23,
		                                       raw_hour,
		                                       12,
		                                       function(b){
		var am = [0, cst_AM, b];
		return caml_exact_trampoline_cps_call$1
		        (symbol$23,
		         raw_hour,
		         12,
		         function(b){
		          var pm = [0, cst_PM, b + 12 | 0];
		          return caml_exact_trampoline_cps_call$3
		                  (consts,
		                   pg,
		                   0,
		                   0,
		                   0,
		                   [0, am, [0, pm, 0]],
		                   function(period_name){
		                    if(1 <= raw_hour && 12 >= raw_hour)
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$92, noncanonical_whitespace, period_name, a);
		                    return caml_exact_trampoline_cps_call
		                            (fail$3, "hour out of bounds", a);
		                   });
		         });
		                                       });
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (number_bounded,
		                                    0,
		                                    59,
		                                    30,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (char$2,
		      58,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$92,
		                c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$0
		                         (option$2,
		                          pi,
		                          ph,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (let$, symbol$63(b, cst_minutes), a, cont);
		                          });
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (number_bounded,
		                                   0,
		                                   23,
		                                   10,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     symbol$63(b, cst_hours),
		     a,
		     function(time){
		      return caml_exact_trampoline_cps_call$3
		              (consts,
		               pj,
		               0,
		               0,
		               0,
		               [0, [0, cst_noon, noon], [0, [0, "midnight", midnight], 0]],
		               function(shorthands){
		                function make(daytime, cont){
		                 var a = config[6];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$35,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (b, a, daytime, function(a){return cont([0, a, daytime]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (make,
		                         config[8],
		                         function(b){
		                          var a = [0, b, 0];
		                          return caml_exact_trampoline_cps_call
		                                  (make,
		                                   config[1],
		                                   function(c){
		                                    var b = [0, [0, cst_noon, noon], [0, c, a]];
		                                    return caml_exact_trampoline_cps_call
		    (make,
		     config[3],
		     function(c){
		      var default$ = [0, c, b];
		      function a(default$){
		       function f(cpl, cont){
		        var match = cpl[3];
		        if(0 === match[0]) return cont(cpl);
		        var sugg = match[1];
		        return caml_exact_trampoline_cps_call
		                (elements_of_list,
		                 sugg,
		                 function(sugg){
		                  function compare(b, param, cont){
		                   var dt2 = param[2], dt1 = b[2];
		                   function a(){
		                    return caml_trampoline_cps_call3(compare$41, dt1, dt2, cont);
		                   }
		                   if(0 !== query_dates[0]) return a();
		                   var would_be_date = query_dates[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (symbol$81,
		                            would_be_date,
		                            config[2],
		                            function(b){
		                             if(! b) return a();
		                             function offset_to_now(dt, cont){
		                              return caml_exact_trampoline_cps_call$0
		                                      (to_time$3,
		                                       config[18],
		                                       would_be_date,
		                                       dt,
		                                       function(would_be_time){
		var res = symbol$58(now, would_be_time);
		return caml_exact_trampoline_cps_call
		        (to_seconds,
		         res,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (symbol$23, a, 86400, cont);
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (offset_to_now,
		                                      dt2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (offset_to_now,
		        dt1,
		        function(b){return cont(- caml_int_compare(b, a) | 0);});
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (stable_sort,
		                           sugg,
		                           compare,
		                           function(sorted_sugg){
		                            return caml_exact_trampoline_cps_call
		                                    (of_list_exn,
		                                     sorted_sugg,
		                                     function(sorted_sugg){
		                                      return cont([0, cpl[1], cpl[2], [1, sorted_sugg]]);
		                                     });
		                           });
		                 });
		       }
		       return caml_trampoline_cps_call3
		               (map$28,
		                time,
		                f,
		                function(time){
		                 function f(param, cont){
		                  var
		                   base_time = param[2],
		                   m = to_tuple$0(base_time)[2],
		                   has_minutes = 0 !== m,
		                   spans = has_minutes ? 0 : pl;
		                  return caml_exact_trampoline_cps_call$1
		                          (filter_map$0,
		                           spans,
		                           function(minutes$0, cont){
		                            var span = minutes(minutes$0);
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$89,
		                                     base_time,
		                                     span,
		                                     function(a){return cont(ok$0(a));});
		                           },
		                           function(alternate_times){
		                            return caml_trampoline_cps_call3
		                                    (map$18,
		                                     alternate_times,
		                                     function(t, cont){
		                                      var a = [0, config[10]];
		                                      return caml_exact_trampoline_cps_call$1
		      (to_to_string,
		       function(b, c, cont){
		        return caml_exact_trampoline_cps_call$7
		                (pp_opt, a, pk, 0, dummy, b, c, cont);
		       },
		       t,
		       function(s){return cont([0, s, t]);});
		                                     },
		                                     cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (augment_single_completion,
		                          f,
		                          time,
		                          function(time){
		                           return caml_exact_trampoline_cps_call
		                                   (complete,
		                                    default$,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$64,
		      a,
		      time,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$64,
		                symbol$63(a, cst_time),
		                shorthands,
		                function(a){return cont(symbol$63(a, "time-shorthands"));});
		      });
		                                    });
		                          });
		                });
		      }
		      if(0 !== query_dates[0]) return a(default$);
		      var date = query_dates[1];
		      return caml_exact_trampoline_cps_call$1
		              (symbol$81,
		               date,
		               config[2],
		               function(b){
		                if(! b) return a(default$);
		                b = hours(1);
		                var daytime = config[5];
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$89,
		                         [0, daytime[1], 0, 0],
		                         b,
		                         function(match){
		                          if(0 !== match[0]) return a(default$);
		                          var daytime = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (make, daytime, function(b){return a(cons$3(b, default$));});
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function date_of_next_weekday(config, weekday, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (days_to_next_weekday,
		                         0,
		                         config[2],
		                         weekday,
		                         function(days){
		                          return caml_exact_trampoline_cps_call$1
		                                  (add_days, config[2], days, cont);
		                         });
		               }
		               function quarters(date, n, cont){
		                var
		                 a =
		                   ((((to_int$1(date[2]) - 1 | 0) + (n * 3 | 0) | 0) / 3 | 0)
		                   * 3
		                   | 0)
		                   + 1
		                   | 0;
		                return caml_exact_trampoline_cps_call$3
		                        (make_overflow, 0, date[3], a, 1, dummy, cont);
		               }
		               function date_of_next(config, next, cont){
		                var date = config[2];
		                return caml_exact_trampoline_cps_call
		                        (weekday,
		                         date,
		                         function(weekday$0){
		                          if(typeof next === "number"){
		                           if(529348384 > next)
		                            return 362594316 === next
		                                    ? caml_exact_trampoline_cps_call$1
		                                      (quarters,
		                                       date,
		                                       1,
		                                       function(date){return cont([2, 0, date[2], date[3]]);})
		                                    : 376298789
		                                      <= next
		                                      ? caml_exact_trampoline_cps_call$1
		(add_days, date, 1, function(a){return cont([0, a]);})
		                                      : caml_exact_trampoline_cps_call$1
		(add_days, date, -1, function(a){return cont([0, a]);});
		                           if(969837588 <= next){
		                            if(992015837 <= next) return cont([4, date[3] + 1 | 0]);
		                            return caml_exact_trampoline_cps_call
		                                    (of_date$1,
		                                     date,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$88, a, 1, function(a){return cont([3, a, 0]);});
		                                     });
		                           }
		                           if(659791777 <= next) return cont([0, date]);
		                           var a = to_int$1(date[2]) + 1 | 0;
		                           return caml_exact_trampoline_cps_call$3
		                                   (make_overflow,
		                                    0,
		                                    date[3],
		                                    a,
		                                    1,
		                                    dummy,
		                                    function(date){return cont([2, 0, date[2], date[3]]);});
		                          }
		                          var variant = next[1];
		                          if(-66910893 <= variant){
		                           if(758940238 <= variant){
		                            if(758941367 <= variant){
		                             var n = next[2];
		                             return caml_exact_trampoline_cps_call$1
		                                     (add_days, date, n, function(a){return cont([0, a]);});
		                            }
		                            var date$0 = next[2];
		                            return cont([0, date$0]);
		                           }
		                           if(28716022 <= variant){
		                            var n$0 = next[2];
		                            return cont([4, date[3] + n$0 | 0]);
		                           }
		                           var
		                            n$1 = next[2],
		                            a = date[1],
		                            b = to_int$1(date[2]) + n$1 | 0;
		                           return caml_exact_trampoline_cps_call$3
		                                   (make_overflow,
		                                    pD,
		                                    date[3],
		                                    b,
		                                    a,
		                                    dummy,
		                                    function(date){
		                                     return cont([2, [0, date[1]], date[2], date[3]]);
		                                    });
		                          }
		                          if(-229282104 <= variant){
		                           if(-229229497 <= variant){
		                            var n$2 = next[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$23,
		                                     to_int$2(0, weekday$0) + 2 | 0,
		                                     7,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (add_days,
		       date,
		       (n$2 * 7 | 0) - a | 0,
		       function(start){
		        return caml_exact_trampoline_cps_call$1
		                (add_days,
		                 start,
		                 1,
		                 function(a){return cont([1, a, start]);});
		       });
		                                     });
		                           }
		                           var day = next[2];
		                           return caml_exact_trampoline_cps_call$1
		                                   (date_of_next_weekday,
		                                    config,
		                                    day,
		                                    function(a){return cont([0, a]);});
		                          }
		                          if(-622066209 <= variant){
		                           var n$3 = next[2];
		                           return caml_exact_trampoline_cps_call
		                                   (weekday,
		                                    date,
		                                    function(b){
		                                     var a = [0, b];
		                                     return caml_exact_trampoline_cps_call
		     (of_date$1,
		      date,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$88, b, n$3, function(b){return cont([3, b, a]);});
		      });
		                                    });
		                          }
		                          var n$4 = next[2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (quarters,
		                                   date,
		                                   n$4,
		                                   function(date){return cont([2, 0, date[2], date[3]]);});
		                         });
		               }
		               function complete_weeks(config, next, a, cont){
		                a = a[2];
		                if(typeof a !== "number"){
		                 var variant = a[1];
		                 if(-229282104 === variant){
		                  var weekday = a[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (date_of_next_weekday,
		                           config,
		                           weekday,
		                           function(date){
		                            function f(week, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (add_days,
		                                      date,
		                                      week * 7 | 0,
		                                      function(date){
		                                       var a = [0, 758940238, date], b = config[4];
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$36,
		        function(c){
		         return caml_trampoline_cps_call3
		                 (c, b, date, function(b){return cont([0, b, a]);});
		        });
		                                      });
		                            }
		                            if(next) var stop = 5, start = 1; else {stop = 4; start = 0;}
		                            return caml_trampoline_cps_call3
		                                    (map$11,
		                                     range$0(0, 0, 0, start, stop),
		                                     f,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(to_binable, a, cont);
		                                     });
		                           });
		                 }
		                }
		                return cont(0);
		               }
		               function span(config, next, cont){
		                var a = next ? 1 : 0;
		                return caml_exact_trampoline_cps_call$1
		                        (append$0,
		                         [0, pF, [0, [0, "weekend", [0, -229229497, a]], pE]],
		                         day_names,
		                         function(options){
		                          return caml_exact_trampoline_cps_call
		                                  (weekday,
		                                   config[2],
		                                   function(weekday){
		                                    var a = [0, -229282104, weekday];
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$37,
		     function(b){
		      return caml_trampoline_cps_call3
		              (b,
		               _11,
		               weekday,
		               function(b){
		                var default$ = [0, [0, b, a], pG];
		                return caml_exact_trampoline_cps_call$3
		                        (consts,
		                         pH,
		                         0,
		                         0,
		                         0,
		                         options,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (augment_single_completion,
		                                   function(a, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (complete_weeks, config, next, a, cont);
		                                   },
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (complete,
		     default$,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$64,
		               b,
		               a,
		               function(a){return cont(symbol$63(a, cst_span));});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function this$(config, cont){
		                function a(this$, cont){
		                 var date = config[2];
		                 if(typeof this$ === "number")
		                  if(529348385 <= this$){
		                   if(969837588 === this$)
		                    return caml_exact_trampoline_cps_call
		                            (of_date$1, date, function(a){return cont([3, a, 0]);});
		                   if(992015837 === this$) return cont([4, date[3]]);
		                  }
		                  else {
		                   if(362594316 === this$)
		                    return caml_exact_trampoline_cps_call$1
		                            (quarters,
		                             date,
		                             0,
		                             function(date){return cont([2, 0, date[2], date[3]]);});
		                   if(529348384 <= this$){
		                    var a = to_int$1(date[2]);
		                    return caml_exact_trampoline_cps_call$3
		                            (make_overflow,
		                             0,
		                             date[3],
		                             a,
		                             1,
		                             dummy,
		                             function(date){return cont([2, 0, date[2], date[3]]);});
		                   }
		                  }
		                 else {
		                  var variant = this$[1];
		                  if(-229282104 === variant){
		                   var weekday$0 = this$[2];
		                   return caml_exact_trampoline_cps_call
		                           (weekday,
		                            config[2],
		                            function(a){
		                             a = to_int$2(0, a);
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$23,
		                                      to_int$2(0, weekday$0) - a | 0,
		                                      7,
		                                      function(days){
		                                       return caml_exact_trampoline_cps_call$1
		       (add_days,
		        config[2],
		        days,
		        function(a){return cont([0, a]);});
		                                      });
		                            });
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (date_of_next, config, this$, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (span,
		                         config,
		                         0,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_map$12, b, a, cont);
		                         });
		               }
		               function next$0(config, cont){
		                function a(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (date_of_next, config, a, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (span,
		                         config,
		                         1,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_map$12, b, a, cont);
		                         });
		               }
		               var
		                open$7 =
		                  g
		                   ([0,
		                     symbol_bind$13,
		                     symbol_map$12,
		                     ,
		                     bind$18,
		                     return$18,
		                     map$30,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$8]),
		                let$10 = open$7[4],
		                let$11 = open$7[3],
		                e =
		                  caml_callback
		                   (map$18,
		                    [pI,
		                     function(s2, cont){
		                      return cont
		                              ([0,
		                                [0,
		                                 cst_day + s2,
		                                 function(n, cont){return cont([0, 758941367, n]);}],
		                                [0,
		                                 [0,
		                                  cst_week + s2,
		                                  function(n, cont){return cont([0, -622066209, n]);}],
		                                 [0,
		                                  [0,
		                                   cst_month + s2,
		                                   function(n, cont){return cont([0, -66910893, n]);}],
		                                  [0,
		                                   [0,
		                                    cst_quarter + s2,
		                                    function(n, cont){return cont([0, -745846041, n]);}],
		                                   [0,
		                                    [0,
		                                     cst_year + s2,
		                                     function(n, cont){return cont([0, 28716022, n]);}],
		                                    0]]]]]);
		                     }]);
		               a:
		               {
		                if(e){
		                 b2 = e[2];
		                 if(b2){
		                  var
		                   plural_options = b2[1],
		                   singular_options = e[1],
		                   time_offset =
		                     caml_callback
		                      (let$11,
		                       [caml_callback(number, [1]),
		                        function(count, cont){
		                         var
		                          options = 1 < count ? plural_options : singular_options,
		                          complete = count <= 1000 ? 1 : 0;
		                         return caml_exact_trampoline_cps_call$3
		                                 (consts,
		                                  0,
		                                  [0, complete],
		                                  0,
		                                  0,
		                                  options,
		                                  function(span_parser){
		                                   function a(span_constructor, cont){
		                                    return caml_trampoline_cps_call2
		    (span_constructor, count, cont);
		                                   }
		                                   return caml_exact_trampoline_cps_call$1
		   (symbol$92,
		    whitespace1,
		    span_parser,
		    function(b){
		     return caml_trampoline_cps_call3(let$10, b, a, cont);
		    });
		                                  });
		                        }]);
		                  break a;
		                 }
		                }
		                time_offset = caml_callback(failwith, ["unreachable"]);
		               }
		               function floating(prefix, rest, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (strings,
		                         0,
		                         0,
		                         0,
		                         [0, [0, rest, 0], 0],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (string$5,
		                                   0,
		                                   0,
		                                   prefix,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$92, b, a, cont);
		                                   });
		                         });
		               }
		               function timmy_date(year, month, day, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (make$8,
		                         year,
		                         month,
		                         day,
		                         function(match){
		                          if(0 === match[0]){
		                           var date = match[1];
		                           return caml_trampoline_cps_call2(return$18, date, cont);
		                          }
		                          var e = match[1], a = to_int$1(month);
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$38,
		                                   function(b){
		                                    return caml_trampoline_cps_call5
		    (b,
		     year,
		     a,
		     day,
		     e,
		     function(a){
		      return caml_exact_trampoline_cps_call(fail$3, a, cont);
		     });
		                                   });
		                         });
		               }
		               var cst_afternoon = "afternoon";
		               function day_periods(config){
		                return [0,
		                        [0, cst_morning, [0, config[3], config[13]]],
		                        [0,
		                         [0, cst_afternoon, [0, config[1], config[8]]],
		                         [0, [0, cst_evening, [0, config[8], config[12]]], 0]]];
		               }
		               function day_period(config, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (consts, 0, 0, 0, 0, day_periods(config), cont);
		               }
		               function maybe_year(reference, month, day, cont){
		                g
		                 ([0,
		                   symbol_bind$13,
		                   symbol_map$12,
		                   ,
		                   bind$18,
		                   return$18,
		                   map$30,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$8]);
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$68,
		                         month,
		                         reference[2],
		                         function(c){
		                          function b(r){
		                           return caml_exact_trampoline_cps_call$1
		                                   (year,
		                                    0,
		                                    r,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$92,
		      whitespace1,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$0
		               (option$2, pJ, [0, cst$1, r], a, cont);
		      });
		                                    });
		                          }
		                          function a(){return b(reference[3]);}
		                          return c
		                                  ? a()
		                                  : caml_exact_trampoline_cps_call$1
		                                    (symbol$67,
		                                     month,
		                                     reference[2],
		                                     function(c){
		                                      if(c){
		                                       c = reference[1];
		                                       if(c <= value$4(day, 32)) return a();
		                                      }
		                                      return b(reference[3] + 1 | 0);
		                                     });
		                         });
		               }
		               function dates(config, opt, period, default_period, cont){
		                var
		                 augment_completions = opt ? opt[1] : 1,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 and = open[6],
		                 let$ = open[4],
		                 let$0 = open[3],
		                 symbol_map = open[2];
		                function augment_completion(f, p, cont){
		                 return augment_completions
		                         ? caml_exact_trampoline_cps_call$1
		                           (augment_single_completion, f, p, cont)
		                         : cont(p);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (option$2,
		                         pK,
		                         [0, cst$1, default_period],
		                         period,
		                         function(period){
		                          var reference = config[2], m = reference[2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$23,
		                                   (to_int$1(m) + 1 | 0) - 1 | 0,
		                                   12,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_int$4,
		     a + 1 | 0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (ok_or_failwith,
		               a,
		               function(next_month){
		                function f(a, cont){
		                 a = a[2];
		                 var b = a[1];
		                 if(0 !== b[0]) return cont(0);
		                 var
		                  period = a[2],
		                  a = b[1],
		                  year = a[3],
		                  month = a[2],
		                  day = a[1];
		                 function f(i, cont){
		                  return caml_exact_trampoline_cps_call$3
		                          (make_overflow,
		                           pL,
		                           year + i | 0,
		                           to_int$1(month),
		                           day,
		                           dummy,
		                           function(date){
		                            var a = [0, [0, date], period], b = config[4];
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$39,
		                                     function(c){
		                                      return caml_trampoline_cps_call3
		      (c, b, date, function(b){return cont([0, b, a]);});
		                                     });
		                           });
		                 }
		                 return caml_trampoline_cps_call3
		                         (map$11,
		                          range$0(0, 0, 0, 1, 5),
		                          f,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(to_binable, a, cont);
		                          });
		                }
		                function a(param, cont){
		                 var year = param[3], month = param[2], day = param[1];
		                 if(! day)
		                  return caml_trampoline_cps_call2
		                          (return$18, [0, [2, 0, month, year], default_period], cont);
		                 var day$0 = day[1];
		                 function a(param, cont){
		                  var period = param[2], date = param[1];
		                  return cont([0, [0, date], period]);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (timmy_date,
		                          year,
		                          month,
		                          day$0,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (and,
		                                    b,
		                                    period,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$, b, a, cont);
		                                    });
		                          });
		                }
		                function b(month, cont){
		                 function a(day, cont){
		                  function a(year, cont){return cont([0, day, month, year]);}
		                  return caml_exact_trampoline_cps_call$0
		                          (maybe_year,
		                           reference,
		                           month,
		                           day,
		                           function(b){
		                            return caml_trampoline_cps_call3(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$67,
		                          month,
		                          reference[2],
		                          function(b){
		                           var default$ = b ? reference[1] : 1;
		                           return caml_exact_trampoline_cps_call$1
		                                   (day_of_month,
		                                    0,
		                                    default$,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (symbol_map,
		      b,
		      return$9,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$92,
		                whitespace1,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$0
		                         (option$2,
		                          pN,
		                          pM,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$0, b, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (month,
		                         pO,
		                         [0, reference[2]],
		                         dummy,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$0,
		                                   c,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$0,
		     b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (token,
		               1,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (augment_completion,
		                         f,
		                         a,
		                         function(date){
		                          function a(param, cont){
		                           var period = param[2], date = param[1];
		                           return cont([0, [0, date], period]);
		                          }
		                          function b(qualified, cont){
		                           function a(day, cont){
		                            function a(param, cont){
		                             var year = param[2], month = param[1];
		                             return caml_exact_trampoline_cps_call$0
		                                     (timmy_date, year, month, day, cont);
		                            }
		                            var
		                             default_month =
		                               reference[1] <= day ? reference[2] : next_month;
		                            function default_year(month, day, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$68,
		                                      month,
		                                      reference[2],
		                                      function(b){
		                                       function a(){return cont(reference[3]);}
		                                       return b
		       ? a()
		       : caml_exact_trampoline_cps_call$1
		         (symbol$67,
		          month,
		          reference[2],
		          function(b){
		           if(b && reference[1] <= day) return a();
		           return cont(reference[3] + 1 | 0);
		          });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$0
		                                    (month,
		                                     pP,
		                                     [0, default_month],
		                                     dummy,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$0
		      (string$5,
		       0,
		       0,
		       cst_of,
		       function(c){
		        return caml_exact_trampoline_cps_call$1
		                (symbol$92,
		                 c,
		                 whitespace1,
		                 function(c){
		                  return caml_exact_trampoline_cps_call$0
		                          (option$2,
		                           0,
		                           pQ,
		                           c,
		                           function(c){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$92,
		                                     whitespace1,
		                                     c,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$92,
		       c,
		       b,
		       function(month){
		        return caml_exact_trampoline_cps_call$0
		                (bind_extensible,
		                 pS,
		                 month,
		                 function(month, cont){
		                  function a(year, cont){
		                   return caml_trampoline_cps_call2
		                           (return$18, [0, month, year], cont);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (default_year,
		                           month,
		                           day,
		                           function(default$){
		                            return caml_exact_trampoline_cps_call$1
		                                    (year,
		                                     pR,
		                                     default$,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$92,
		       whitespace1,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (kasprintf,
		                 id,
		                 fmt$40,
		                 function(c){
		                  return caml_trampoline_cps_call3
		                          (c,
		                           pp_year,
		                           default$,
		                           function(c){
		                            return caml_exact_trampoline_cps_call$0
		                                    (option$2,
		                                     0,
		                                     [0, c, default$],
		                                     b,
		                                     function(b){
		                                      return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 },
		                 function(p){
		                  function b(b){
		                   return caml_trampoline_cps_call3(let$0, b, a, cont);
		                  }
		                  return qualified
		                          ? caml_exact_trampoline_cps_call$1
		                            (default_year,
		                             default_month,
		                             day,
		                             function(c){
		                              var a = [0, default_month, c];
		                              return caml_exact_trampoline_cps_call$1
		                                      (default_year,
		                                       default_month,
		                                       day,
		                                       function(c){
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$41,
		         function(d){
		          return caml_trampoline_cps_call5
		                  (d,
		                   pp$11,
		                   default_month,
		                   pp_year,
		                   c,
		                   function(c){
		                    return caml_exact_trampoline_cps_call$0
		                            (option$2, 0, [0, c, a], p, b);
		                   });
		         });
		                                       });
		                             })
		                          : b(p);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (day_of_month,
		                                    [0, qualified],
		                                    1,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                    });
		                          }
		                          return caml_trampoline_cps_call2
		                                  (return$18,
		                                   1,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$0
		    (string$5,
		     0,
		     0,
		     "the",
		     function(d){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$92,
		               d,
		               whitespace1,
		               function(d){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$92,
		                         d,
		                         c,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$0
		                                  (option$2,
		                                   0,
		                                   pT,
		                                   c,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (let$0,
		     c,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (and,
		               b,
		               period,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (token,
		                                   1,
		                                   a,
		                                   function(date_day){
		                                    return caml_exact_trampoline_cps_call$1
		    (augment_completion,
		     function(a, cont){
		      return caml_exact_trampoline_cps_call$0
		              (complete_weeks, config, 1, a, cont);
		     },
		     day_name,
		     function(day_name){
		      function a(date, cont){
		       return caml_trampoline_cps_call3
		               (let$,
		                period,
		                function(period, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (date_of_next,
		                          config,
		                          date,
		                          function(a){return cont([0, a, period]);});
		                },
		                cont);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (or_with_concatenated_completio,
		               day_shorthand,
		               day_name,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$0,
		                         b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (token,
		                                   1,
		                                   a,
		                                   function(day){
		                                    function a(param, cont){
		                                     var period = param[2], date = param[1][2];
		                                     return cont([0, date, period]);
		                                    }
		                                    return caml_exact_trampoline_cps_call$0
		    (string$5,
		     0,
		     0,
		     cst_next,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$92,
		               b,
		               whitespace1,
		               function(left){
		                return caml_exact_trampoline_cps_call
		                        (next$0,
		                         config,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   left,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     b,
		     period,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (token,
		                         1,
		                         a,
		                         function(offset){
		                          function a(year, cont){
		                           return cont([0, [4, year], default_period]);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (year,
		                                   pU,
		                                   config[2][3],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (token,
		               1,
		               a,
		               function(year){
		                return caml_exact_trampoline_cps_call$1
		                        (or_with_concatenated_completio,
		                         day,
		                         date,
		                         function(l){
		                          return caml_exact_trampoline_cps_call$1
		                                  (or_with_concatenated_completio,
		                                   l,
		                                   date_day,
		                                   function(l){
		                                    return caml_exact_trampoline_cps_call$1
		    (or_with_concatenated_completio,
		     l,
		     offset,
		     function(l){
		      return caml_exact_trampoline_cps_call$1
		              (or_with_concatenated_completio, l, year, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function date(augment_completions, config, cont){
		                return caml_trampoline_cps_call2
		                        (return$18,
		                         0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (dates,
		                                   config,
		                                   augment_completions,
		                                   a,
		                                   0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_map$12,
		     a,
		     calendar,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol_map$12, a, first_date, cont);
		     });
		                                   });
		                         });
		               }
		               var cst_on = "on";
		               function time(config, cont){
		                var
		                 open$0 =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 and = open$0[6],
		                 let$ = open$0[4],
		                 let$0 = open$0[3],
		                 symbol_map$0 = open$0[2];
		                function to_completion$0(res, cont){
		                 function f(res, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (to_completion,
		                           function(param, cont){
		                            var value = param[1];
		                            return cont([0, value]);
		                           },
		                           res,
		                           function(a){
		                            var b = a[1];
		                            if(! b){
		                             var completions$1 = a[2];
		                             return cont
		                                     ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$1]);
		                            }
		                            b = b[1];
		                            var match = b[2], dates = b[1];
		                            if(match){
		                             var
		                              completions = a[2],
		                              a = match[1],
		                              end = a[2],
		                              start = a[1];
		                             return cont
		                                     ([0,
		                                       make$12
		([0, dates],
		 [0, [0, start, [0, end]]],
		 0,
		 0,
		 0,
		 0,
		 0,
		 0,
		 0,
		 0),
		                                       completions]);
		                            }
		                            var completions$0 = a[2];
		                            return cont
		                                    ([0,
		                                      make$12([0, dates], 0, 0, 0, 0, 0, 0, 0, 0, 0),
		                                      completions$0]);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (filter$7,
		                          res,
		                          function(a, cont){
		                           a = config[9];
		                           var
		                            scheduling = a[5],
		                            postponing = a[2],
		                            scheduling$0 = scheduling || postponing;
		                           return cont(scheduling$0);
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (keep_n,
		                                    5,
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(map$28, a, f, cont);
		                                    });
		                          });
		                }
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 symbol_map = open[2];
		                return caml_exact_trampoline_cps_call
		                        (day_period,
		                         config,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$92,
		                                   maybe_stopper,
		                                   whitespace1,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$92,
		     b,
		     stop_completion,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$92,
		               b,
		               cut_completion,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$92,
		                         b,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   a,
		                                   return$9,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$2
		    (dates,
		     config,
		     0,
		     a,
		     0,
		     function(date){
		      function a(param, cont){
		       var default$ = config[9][5] ? pW : pV;
		       function a(day, cont){
		        return caml_exact_trampoline_cps_call$1
		                (date_of_next,
		                 config,
		                 day,
		                 function(a){return cont([0, a, 0]);});
		       }
		       return caml_exact_trampoline_cps_call$1
		               (token,
		                1,
		                time_offset,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (complete,
		                          default$,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$64,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (let$,
		      b,
		      a,
		      function(offset){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$13,
		             symbol_map$12,
		             ,
		             bind$18,
		             return$18,
		             map$30,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$8]),
		        let$0 = open[3];
		       function a(month, cont){
		        function a(year, cont){
		         return caml_trampoline_cps_call2
		                 (return$18, [0, [2, 0, month, year], 0], cont);
		        }
		        return caml_exact_trampoline_cps_call$0
		                (maybe_year,
		                 config[2],
		                 month,
		                 0,
		                 function(b){
		                  return caml_trampoline_cps_call3(let$0, b, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call$0
		               (month,
		                pX,
		                [0, config[2][2]],
		                dummy,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (let$0,
		                          b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (token,
		                                    1,
		                                    a,
		                                    function(month_year){
		                                     function a(year, cont){return cont([0, [4, year], 0]);}
		                                     return caml_exact_trampoline_cps_call$1
		     (year,
		      pY,
		      config[2][3],
		      function(b){
		       return caml_trampoline_cps_call3
		               (let$,
		                b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (token,
		                          1,
		                          a,
		                          function(year){
		                           return caml_exact_trampoline_cps_call$1
		                                   (or_with_concatenated_completio,
		                                    offset,
		                                    year,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$64, a, month_year, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (keyword,
		               cst_in,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$0,
		                         b,
		                         a,
		                         function(in$){
		                          g
		                           ([0,
		                             symbol_bind$11,
		                             symbol_map$10,
		                             ,
		                             bind$16,
		                             return$16,
		                             map$28,
		                             ,
		                             ,
		                             ,
		                             ,
		                             Let_syntax$7]);
		                          var today = [0, cst_today, config[2]];
		                          return caml_exact_trampoline_cps_call$1
		                                  (add_days,
		                                   config[2],
		                                   1,
		                                   function(tomorrow_date){
		                                    var tomorrow = [0, cst_tomorrow, tomorrow_date];
		                                    return caml_exact_trampoline_cps_call
		    (weekday,
		     config[2],
		     function(weekday){
		      return caml_exact_trampoline_cps_call$1
		              (add_days,
		               config[2],
		               7,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$43,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (b,
		                                   _11,
		                                   weekday,
		                                   function(b){
		                                    var
		                                     next_week = [0, b, a],
		                                     b = to_int$1(config[2][2]) + 1 | 0;
		                                    return caml_exact_trampoline_cps_call$3
		    (make_overflow,
		     0,
		     config[2][3],
		     b,
		     1,
		     dummy,
		     function(date$0){
		      var a = date$0[3], b = date$0[2];
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$44,
		               function(c){
		                return caml_trampoline_cps_call4
		                        (c,
		                         pp$11,
		                         b,
		                         a,
		                         function(a){
		                          var next_month = [0, a, date$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_date$0,
		                                   config[2][3] + 1 | 0,
		                                   0,
		                                   function(b){
		                                    var a = config[2][3] + 1 | 0;
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$45,
		     function(c){
		      return caml_trampoline_cps_call2
		              (c,
		               a,
		               function(a){
		                var next_year = [0, a, b], a = config[16];
		                function c(a){
		                 return caml_exact_trampoline_cps_call
		                         (of_list_exn,
		                          a,
		                          function(default$){
		                           function f(seen, v, cont){
		                            var date = v[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (mem$3,
		                                     seen,
		                                     date,
		                                     function(b){
		                                      if(b) return cont([0, seen, 0]);
		                                      var a = [0, v];
		                                      return caml_exact_trampoline_cps_call$1
		      (add$4, seen, date, function(b){return cont([0, b, a]);});
		                                     });
		                           }
		                           var tl = default$[2], hd = default$[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_list$2,
		                                    [0, comparator$11],
		                                    [0, hd[2], 0],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (folding_map,
		      tl,
		      a,
		      f,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (filter_opt,
		                a,
		                function(tail){
		                 var hd = default$[1], default$0 = [0, hd, tail];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$19,
		                          default$0,
		                          function(param, cont){
		                           var date = param[2], str = param[1];
		                           return cont([0, str, [0, [0, date], 0]]);
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (complete,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$64,
		      a,
		      date,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (keyword,
		                cst_on,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$92,
		                          b,
		                          a,
		                          function(on){
		                           function a(param, cont){
		                            var day_period = param[2], date = param[1];
		                            return cont([0, date, day_period]);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (add_days,
		                                    config[2],
		                                    -1,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$0
		     (abbrev,
		      "ystd",
		      cst_yesterday,
		      [0, b],
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (add_days,
		                config[2],
		                1,
		                function(c){
		                 return caml_exact_trampoline_cps_call$0
		                         (abbrev,
		                          "tmr",
		                          cst_tomorrow,
		                          [0, c],
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (add_days,
		                                    config[2],
		                                    1,
		                                    function(d){
		                                     return caml_trampoline_cps_call2
		     (return$18,
		      [0, d],
		      function(d){
		       return caml_exact_trampoline_cps_call$1
		               (floating,
		                "tom",
		                "orrow",
		                function(e){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$92,
		                          e,
		                          d,
		                          function(d){
		                           return caml_trampoline_cps_call2
		                                   (return$18,
		                                    [0, config[2]],
		                                    function(e){
		                                     return caml_exact_trampoline_cps_call$1
		     (floating,
		      "tod",
		      "ay",
		      function(f){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$92,
		                f,
		                e,
		                function(e){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$64,
		                          e,
		                          d,
		                          function(d){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$64,
		                                    d,
		                                    c,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$64,
		      c,
		      b,
		      function(left){
		       return caml_exact_trampoline_cps_call
		               (day_period,
		                config,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$92,
		                          maybe_stopper,
		                          whitespace1,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$92,
		                                    c,
		                                    stop_completion,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$92,
		      c,
		      cut_completion,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$92,
		                c,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (symbol_map$0,
		                          b,
		                          return$9,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$0
		                                   (option$2,
		                                    0,
		                                    pZ,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3
		               (let$,
		                b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (token,
		                          1,
		                          a,
		                          function(floating){
		                           return caml_exact_trampoline_cps_call
		                                   (next$0,
		                                    config,
		                                    function(next){
		                                     return caml_exact_trampoline_cps_call
		     (day_period,
		      config,
		      function(day_period$0){
		       function a(param, cont){
		        function a(param, cont){
		         var day_period = param[2], next = param[1];
		         return cont([0, next, day_period]);
		        }
		        return caml_exact_trampoline_cps_call$1
		                (symbol$92,
		                 maybe_stopper,
		                 whitespace1,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$92,
		                           b,
		                           stop_completion,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$92,
		                                     b,
		                                     cut_completion,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$92,
		       b,
		       day_period$0,
		       function(b){
		        return caml_trampoline_cps_call3
		                (symbol_map$0,
		                 b,
		                 return$9,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$0
		                          (option$2,
		                           0,
		                           p0,
		                           b,
		                           function(b){
		                            return caml_trampoline_cps_call3
		                                    (and,
		                                     next,
		                                     b,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (let$,
		       b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call$1(token, 1, a, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (keyword,
		                cst_next,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (let$0,
		                          b,
		                          a,
		                          function(next){
		                           var today = [0, config[2]];
		                           function a(p, cont){return cont([0, today, [0, p]]);}
		                           return caml_exact_trampoline_cps_call
		                                   (day_period,
		                                    config,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (symbol_map$0,
		      b,
		      a,
		      function(day_period){
		       return caml_exact_trampoline_cps_call
		               (of_date$1,
		                config[2],
		                function(this_week){
		                 var this_week$0 = [3, this_week, 0];
		                 function f(param, cont){
		                  var span = param[2], name = param[1], sp_end = span[2];
		                  return caml_lessthan(config[5], sp_end)
		                          ? cont([0, [0, name, [0, today, [0, span]]]])
		                          : cont(0);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (filter_map$0,
		                          day_periods(config),
		                          f,
		                          function(b){
		                           var
		                            completions = [0, [0, cst_week, [0, this_week$0, 0]], b];
		                           function a(param, cont){
		                            function a(dates, cont){return cont([0, dates, 0]);}
		                            return caml_exact_trampoline_cps_call
		                                    (this$,
		                                     config,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (symbol_map$0,
		       b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (complete,
		                 completions,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$64,
		                           b,
		                           day_period,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$64,
		                                     b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1(token, 1, a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (keyword,
		                                    "this",
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (let$0,
		      b,
		      a,
		      function(this$){
		       return caml_exact_trampoline_cps_call
		               (to_completion$0,
		                floating,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (to_completion$0,
		                          this$,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (to_completion$0,
		                                    next,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call
		     (to_completion$0,
		      on,
		      function(d){
		       return caml_exact_trampoline_cps_call
		               (to_completion$0,
		                in$,
		                function(e){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$64,
		                          e,
		                          d,
		                          function(d){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$64,
		                                    d,
		                                    c,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$64,
		      c,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$64, b, a, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 default$ =
		                   [0,
		                    tomorrow,
		                    [0,
		                     today,
		                     [0, next_week, [0, next_month, [0, next_year, 0]]]]];
		                if(! a) return c(default$);
		                var hint = a[1];
		                function d(param){
		                 function a(match){
		                  if(match){
		                   var entry = match[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (filter,
		                            default$,
		                            function(param, cont){
		                             var d = param[2];
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$84, d, hint, cont);
		                            },
		                            function(a){return c([0, entry, a]);});
		                  }
		                  var a = config[4];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$42,
		                           function(b){
		                            return caml_trampoline_cps_call3
		                                    (b,
		                                     a,
		                                     hint,
		                                     function(a){
		                                      var hint_entry = [0, a, hint];
		                                      return caml_exact_trampoline_cps_call$1
		      (take$0, [0, hint_entry, default$], 5, c);
		                                     });
		                           });
		                 }
		                 if(! param) return a(0);
		                 var l = param[2], x = param[1], d$0 = x[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (equal$21,
		                          d$0,
		                          hint,
		                          function(b){
		                           return b ? a([0, x]) : caml_exact_trampoline_call1(d, l);
		                          });
		                }
		                return d(default$);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function email_matcher(email, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         email,
		                         64,
		                         function(a){
		                          if(a){
		                           a = a[2];
		                           if(a && ! a[2]){
		                            var domain = a[1];
		                            return cont([0, [0, domain, 2], 0]);
		                           }
		                          }
		                          return cont(0);
		                         });
		               }
		               function valid_boundary
		               (today, start, end, boundary_kind, rule, date, cont){
		                if(389604418 <= boundary_kind)
		                 var end$0 = end, start$0 = [0, date];
		                else
		                 var end$1 = [0, date], end$0 = end$1, start$0 = start;
		                var recurrence = [0, [1, end$0, start$0], rule];
		                return caml_exact_trampoline_cps_call$1
		                        (snap,
		                         recurrence,
		                         today,
		                         function(a){return cont(is_some(a));});
		               }
		               function default_boundaries
		               (config, rule, start, end, boundary_kind, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (date_of_next,
		                         config,
		                         969837588,
		                         function(a){
		                          var next_week = [0, "next week", a];
		                          return caml_exact_trampoline_cps_call$1
		                                  (date_of_next,
		                                   config,
		                                   529348384,
		                                   function(a){
		                                    var next_month = [0, "next month", a];
		                                    return caml_exact_trampoline_cps_call$1
		    (date_of_next,
		     config,
		     992015837,
		     function(b){
		      var next_year = [0, "next year", b];
		      function a(default_boundaries){
		       function f(param, cont){
		        var dates = param[2];
		        return caml_exact_trampoline_cps_call
		                (first_date,
		                 dates,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$7
		                          (valid_boundary,
		                           config[2],
		                           start,
		                           end,
		                           boundary_kind,
		                           rule,
		                           a,
		                           cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (filter$6(default_boundaries),
		                f,
		                function(suggested){
		                 return is_empty(suggested)
		                         ? caml_exact_trampoline_cps_call
		                           (fail$3, "no suggestions", cont)
		                         : caml_exact_trampoline_cps_call
		                           (of_list_exn,
		                            suggested,
		                            function(a){
		                             return caml_exact_trampoline_cps_call(complete, a, cont);
		                            });
		                });
		      }
		      if(389604418 <= boundary_kind){
		       var today = config[2];
		       return caml_exact_trampoline_cps_call$1
		               (add_days,
		                today,
		                1,
		                function(tomorrow){
		                 return a
		                         ([0,
		                           [0, cst_tomorrow, [0, tomorrow]],
		                           [0, next_week, [0, next_month, [0, next_year, 0]]]]);
		                });
		      }
		      function year(year, cont){
		       var a = [4, year];
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$46,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b, year, function(b){return cont([0, b, a]);});
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (year,
		               config[2][3] + 3 | 0,
		               function(c){
		                var b = [0, c, 0];
		                return caml_exact_trampoline_cps_call
		                        (year,
		                         config[2][3] + 2 | 0,
		                         function(c){
		                          return a
		                                  ([0, next_week, [0, next_month, [0, next_year, [0, c, b]]]]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var suggest_empty = caml_callback(complete, [p7]);
		               function start(config, rule, end, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 let$ = open[3],
		                 a = config[2];
		                function b(b, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (valid_boundary, a, 0, end, 389604418, rule, b, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (date,
		                         0,
		                         config,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter$7,
		                                   a,
		                                   b,
		                                   function(date){
		                                    function a(param, cont){
		                                     function a(param, cont){
		                                      return caml_exact_trampoline_cps_call$3
		      (default_boundaries,
		       config,
		       rule,
		       0,
		       end,
		       389604418,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (symbol_map$12,
		                 a,
		                 first_date,
		                 function(default$){
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$64,
		                           confirm$0,
		                           suggest_empty,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$93,
		                                     date,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$64, default$, a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (keyword,
		      cst_on,
		      function(b){
		       return caml_exact_trampoline_cps_call$0
		               (option$2,
		                0,
		                p8,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (keyword,
		     "starting",
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$92,
		               maybe_stopper,
		               whitespace1,
		               function(c){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$92,
		                         c,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var cst_until = "until";
		               function end$0(config, rule, start, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 let$ = open[3],
		                 a = config[2];
		                function b(b, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (valid_boundary, a, start, 0, 3455931, rule, b, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (date,
		                         0,
		                         config,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter$7,
		                                   a,
		                                   b,
		                                   function(date){
		                                    function a(param, cont){
		                                     return caml_exact_trampoline_cps_call$3
		     (default_boundaries,
		      config,
		      rule,
		      start,
		      0,
		      3455931,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (symbol_map$12,
		                a,
		                first_date,
		                function(default$){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$64,
		                          confirm$0,
		                          suggest_empty,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$93,
		                                    date,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$64, default$, a, cont);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (keyword,
		     cst_until,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$92,
		               maybe_stopper,
		               whitespace1,
		               function(c){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$92,
		                         c,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function boundaries(config, rule, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$13,
		                      symbol_map$12,
		                      ,
		                      bind$18,
		                      return$18,
		                      map$30,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$8]),
		                 let$ = open[3];
		                function a(param, cont){
		                 var c_start = param[2], start = param[1];
		                 function a(param, cont){
		                  var c_end = param[2], end = param[1];
		                  return cont
		                          ([0, [0, [0, start], [0, end]], [0, c_start, c_end]]);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (end$0,
		                          config,
		                          rule,
		                          [0, start],
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (leak_completing,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_map$12,
		      b,
		      a,
		      function(end){
		       return caml_trampoline_cps_call2
		               (return$18,
		                [0, [0, [0, start], 0], [0, c_start, 0]],
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$64, end, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (start,
		                         config,
		                         rule,
		                         0,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (leak_completing,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     b,
		     a,
		     function(start_then_maybe_end){
		      function a(param, cont){
		       var c_end = param[2], end = param[1];
		       function a(param, cont){
		        var c_start = param[2], start = param[1];
		        return cont
		                ([0, [0, [0, start], [0, end]], [0, c_start, c_end]]);
		       }
		       return caml_exact_trampoline_cps_call$0
		               (start,
		                config,
		                rule,
		                [0, end],
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (leak_completing,
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol_map$12,
		                                    b,
		                                    a,
		                                    function(start){
		                                     return caml_trampoline_cps_call2
		     (return$18,
		      [0, [0, 0, [0, end]], [0, 0, c_end]],
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$64, start, a, cont);
		      });
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call$0
		              (end$0,
		               config,
		               rule,
		               0,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (leak_completing,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(end_then_maybe_start){
		                                    return caml_trampoline_cps_call2
		    (return$18,
		     p9,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$64,
		               start_then_maybe_end,
		               end_then_maybe_start,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$64, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$8 =
		                  g
		                   ([0,
		                     symbol_bind$13,
		                     symbol_map$12,
		                     ,
		                     bind$18,
		                     return$18,
		                     map$30,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$8]),
		                let$12 = open$8[4],
		                let$13 = open$8[3],
		                e = [0, [0, cst_week, week(0, 0, 1)], p_],
		                default$7 =
		                  [0, p$, [0, [0, cst_Monday, week([0, monday], 0, 1)], e]],
		                e = [0, [0, cst_Sunday, week([0, sunday], 0, 1)], 0],
		                e = [0, [0, cst_Saturday, week([0, saturday], 0, 1)], e],
		                e = [0, [0, cst_Friday, week([0, friday], 0, 1)], e],
		                e = [0, [0, cst_Thursday, week([0, thursday], 0, 1)], e],
		                e = [0, [0, cst_Wednesday, week([0, wednesday], 0, 1)], e],
		                e = [0, [0, cst_Tuesday, week([0, tuesday], 0, 1)], e],
		                e =
		                  [0,
		                   qd,
		                   [0,
		                    qc,
		                    [0,
		                     qb,
		                     [0, qa, [0, [0, cst_Monday, week([0, monday], 0, 1)], e]]]]],
		                e =
		                  caml_callback
		                   (token,
		                    [1,
		                     caml_callback
		                      (consts,
		                       [qf, 0, 0, 0, [0, qe, [0, [0, cst_week, week(0, 0, 1)], e]]])]),
		                symbol$94 =
		                  caml_callback
		                   (symbol$64, [caml_callback(complete, [default$7]), e]),
		                e = caml_callback(return$18, [2]),
		                e =
		                  caml_callback
		                   (symbol$92,
		                    [caml_callback(string$5, [qi, qh, cst_other]), e]),
		                b2 = caml_callback(option$2, [qk, qj, whitespace$0]),
		                count$3 =
		                  caml_callback
		                   (token,
		                    [1,
		                     caml_callback
		                      (let$13,
		                       [caml_callback
		                         (symbol$64,
		                          [caml_callback(symbol$93, [caml_callback(number, [1]), b2]),
		                           e]),
		                        function(count, cont){
		                         var plural = 1 < count;
		                         function a(f, cont){
		                          return caml_trampoline_cps_call2(f, count, cont);
		                         }
		                         var
		                          choices =
		                            plural
		                             ? [0,
		                               [0, cst_days$0, function(n, cont){return cont([0, n]);}],
		                               [0,
		                                [0,
		                                 cst_weeks,
		                                 function(n, cont){return cont(week(0, 0, n));}],
		                                [0,
		                                 [0, "workdays", function(n, cont){return cont([3, n]);}],
		                                 [0,
		                                  [0, cst_months, function(n, cont){return cont([1, n, 0]);}],
		                                  [0,
		                                   [0,
		                                    "quarters",
		                                    function(n, cont){return cont([1, 3 * n | 0, 0]);}],
		                                   [0,
		                                    [0,
		                                     cst_years,
		                                     function(n, cont){return cont([4, n, 0, 0]);}],
		                                    0]]]]]]
		                             : [0,
		                               [0, cst_day, function(n, cont){return cont([0, n]);}],
		                               [0,
		                                [0,
		                                 cst_week,
		                                 function(n, cont){return cont(week(0, 0, n));}],
		                                [0,
		                                 [0, cst_workday, function(n, cont){return cont([3, n]);}],
		                                 [0,
		                                  [0, cst_month, function(n, cont){return cont([1, n, 0]);}],
		                                  [0,
		                                   [0,
		                                    cst_quarter,
		                                    function(n, cont){return cont([1, 3 * n | 0, 0]);}],
		                                   [0,
		                                    [0, cst_year, function(n, cont){return cont([4, n, 0, 0]);}],
		                                    0]]]]]];
		                         return caml_exact_trampoline_cps_call$3
		                                 (consts,
		                                  qg,
		                                  0,
		                                  0,
		                                  0,
		                                  choices,
		                                  function(b){
		                                   return caml_trampoline_cps_call3
		   (let$12, symbol$63(b, "timespan"), a, cont);
		                                  });
		                        }])]),
		                base_rule = caml_callback(symbol$64, [symbol$94, count$3]),
		                cst$20 = "!";
		               function make_parser(config, cont){
		                function standalone(p){
		                 return symbol_map$3
		                         (p,
		                          function(a, cont){
		                           a = a[1][3];
		                           if(0 === a[0]){var p = a[1]; return cont([0, p, 0]);}
		                           var c = a[1];
		                           return caml_exact_trampoline_cps_call
		                                   (elements_of_list, c, cont);
		                          });
		                }
		                var a = config[7];
		                function b(destination){
		                 g
		                  ([0,
		                    symbol_bind$13,
		                    symbol_map$12,
		                    ,
		                    bind$18,
		                    return$18,
		                    map$30,
		                    ,
		                    ,
		                    ,
		                    ,
		                    Let_syntax$8]);
		                 var match = config[14];
		                 function b(p, cont){return cont([1, p]);}
		                 function a(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol_map$12,
		                           a,
		                           b,
		                           function(known){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_map$12,
		                                     email,
		                                     function(s, cont){return cont([0, s]);},
		                                     function(unknown){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$64,
		       known,
		       unknown,
		       function(participant){
		        var match = config[19];
		        function a(type){
		         return caml_exact_trampoline_cps_call$1
		                 (date,
		                  ql,
		                  config,
		                  function(a){
		                   var date = standalone(a);
		                   return caml_exact_trampoline_cps_call$1
		                           (daytime,
		                            config,
		                            make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0),
		                            function(c){
		                             var
		                              daytime$1 = standalone(c),
		                              destination$0 = standalone(destination);
		                             function daytime$0(context, cont){
		                              g
		                               ([0,
		                                 symbol_bind$13,
		                                 symbol_map$12,
		                                 ,
		                                 bind$18,
		                                 return$18,
		                                 map$30,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$8]);
		                              function a(res, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (to_completion,
		function(value, cont){return cont([1, value]);},
		res,
		function(a){
		 var match = a[1];
		 if(match){
		  var completions = a[2], daytime = match[1];
		  return cont
		          ([0,
		            make$12(0, [0, [0, daytime, 0]], 0, 0, 0, 0, 0, 0, 0, 0),
		            completions]);
		 }
		 var completions$0 = a[2];
		 return cont
		         ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		});
		                              }
		                              return caml_exact_trampoline_cps_call$1
		                                      (daytime,
		                                       config,
		                                       context,
		                                       function(b){
		return caml_exact_trampoline_cps_call$1
		        (token,
		         1,
		         b,
		         function(b){
		          return caml_exact_trampoline_cps_call
		                  (keyword,
		                   cst_at,
		                   function(c){
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol$92,
		                             c,
		                             b,
		                             function(b){
		                              return caml_trampoline_cps_call3
		                                      (let$9, symbol$63(b, "time-of-day"), a, cont);
		                             });
		                   });
		         });
		                                       });
		                             }
		                             var
		                              open =
		                                g
		                                 ([0,
		                                   symbol_bind$13,
		                                   symbol_map$12,
		                                   ,
		                                   bind$18,
		                                   return$18,
		                                   map$30,
		                                   ,
		                                   ,
		                                   ,
		                                   ,
		                                   Let_syntax$8]),
		                              let$ = open[4],
		                              let$0 = open[3],
		                              symbol_map = open[2];
		                             function b(res, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (to_completion,
		                                       function(value, cont){return cont([3, value]);},
		                                       res,
		                                       function(a){
		var match = a[1];
		if(match){
		 var completions = a[2], duration = match[1];
		 return cont
		         ([0,
		           make$12(0, 0, 0, [0, duration], 0, 0, 0, 0, 0, 0),
		           completions]);
		}
		var completions$0 = a[2];
		return cont
		        ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		                                       });
		                             }
		                             function unit(a, opt, n, cont){
		                              var
		                               maybe_hours = a ? a[1] : 1,
		                               hour_shorthand = opt ? opt[1] : cst_h$0,
		                               choices =
		                                 1 < n ? maybe_hours ? pm : pt : maybe_hours ? pu : pv;
		                              return caml_exact_trampoline_cps_call$3
		                                      (consts,
		                                       po,
		                                       0,
		                                       pn,
		                                       0,
		                                       choices,
		                                       function(long){
		var
		 choices =
		   maybe_hours
		    ? 10
		      <= n
		      ? [0, pp, [0, [0, hour_shorthand, 60], 0]]
		      : [0, [0, hour_shorthand, 60], pr]
		    : ps;
		return caml_trampoline_cps_call3
		        (bind$16,
		         peek_char$0,
		         function(param, cont){
		          function a(){
		           return caml_exact_trampoline_cps_call(fail$3, cst$1, cont);
		          }
		          if(! param) return a();
		          var c = param[1];
		          return caml_exact_trampoline_cps_call
		                  (digit,
		                   c,
		                   function(b){
		                    return b
		                            ? caml_trampoline_cps_call2(return$16, 0, cont)
		                            : a();
		                   });
		         },
		         function(digit_break){
		          return caml_exact_trampoline_cps_call$1
		                  (symbol$64,
		                   break$0,
		                   digit_break,
		                   function(break$){
		                    return caml_exact_trampoline_cps_call$3
		                            (consts,
		                             pq,
		                             0,
		                             0,
		                             [0, break$],
		                             choices,
		                             function(short){
		                              return caml_trampoline_cps_call3
		                                      (symbol_map,
		                                       short,
		                                       function(v, cont){return cont([0, 0, v]);},
		                                       function(short){
		function a(v, cont){return cont([0, 1, v]);}
		return caml_exact_trampoline_cps_call$1
		        (symbol$92,
		         whitespace$0,
		         long,
		         function(b){
		          return caml_trampoline_cps_call3
		                  (symbol_map,
		                   b,
		                   a,
		                   function(long){
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol$64,
		                             short,
		                             long,
		                             function(a){return cont(symbol$63(a, "duration unit"));});
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             }
		                             function a(a, cont){
		                              a = [0, [0, "3 hours", hours(3)], 0];
		                              a = [0, [0, "2 hours", hours(2)], a];
		                              a = [0, [0, "1 hour 30 minutes", minutes(90)], a];
		                              a = [0, [0, "1 hour", hours(1)], a];
		                              var default$ = [0, [0, "30 minutes", minutes(30)], a];
		                              function b(n, cont){
		                               function a(param, cont){
		                                var
		                                 unit_minutes = param[2],
		                                 long = param[1],
		                                 seconds = caml_mul(n, unit_minutes) * 60 | 0;
		                                function b(next, cont){
		                                 var s = seconds + next | 0;
		                                 return caml_trampoline_cps_call2
		 (return$18, of_int_s(s), cont);
		                                }
		                                if(long)
		                                 var
		                                  ws = whitespace$0,
		                                  default$ =
		                                    [0,
		                                     pw,
		                                     [0,
		                                      [0, " 30 minutes", 1800],
		                                      [0,
		                                       [0, " 15 minutes", 900],
		                                       [0, [0, " 45 minutes", 2700], 0]]]];
		                                else {
		                                 ws = noncanonical_whitespace;
		                                 default$ =
		                                  [0,
		                                   pB,
		                                   [0,
		                                    [0, "30m", 1800],
		                                    [0, [0, "15m", 900], [0, [0, "45m", 2700], 0]]]];
		                                }
		                                function a(a){
		                                 return caml_trampoline_cps_call3(let$0, a, b, cont);
		                                }
		                                if(60 !== unit_minutes)
		                                 return caml_trampoline_cps_call2
		 (return$18,
		  0,
		  function(b){
		   return caml_exact_trampoline_cps_call$1
		           (symbol$92, break$1, b, a);
		  });
		                                function c(n, cont){
		                                 function a(param, cont){
		                                  var unit_minutes = param[2];
		                                  return cont([0, n, unit_minutes]);
		                                 }
		                                 return caml_exact_trampoline_cps_call$0
		 (unit,
		  px,
		  0,
		  n,
		  function(b){
		   return caml_exact_trampoline_cps_call$0
		           (option$2,
		            0,
		            py,
		            b,
		            function(b){
		             return caml_trampoline_cps_call3(let$, b, a, cont);
		            });
		  });
		                                }
		                                return caml_exact_trampoline_cps_call
		(number,
		 30,
		 function(b){
		  return caml_trampoline_cps_call3
		          (let$0,
		           b,
		           c,
		           function(minutes){
		            return caml_trampoline_cps_call3
		                    (symbol_map,
		                     minutes,
		                     function(param, cont){
		                      var unit = param[2], v = param[1];
		                      return cont(caml_mul(v, unit) * 60 | 0);
		                     },
		                     function(b){
		                      return caml_exact_trampoline_cps_call
		                              (complete,
		                               default$,
		                               function(c){
		                                return caml_exact_trampoline_cps_call$1
		(symbol$64,
		 c,
		 b,
		 function(b){
		  return caml_exact_trampoline_cps_call$1
		          (symbol$92,
		           ws,
		           b,
		           function(b){
		            return caml_exact_trampoline_cps_call$1
		                    (symbol$93,
		                     b,
		                     break$1,
		                     function(b){
		                      return caml_exact_trampoline_cps_call$0
		                              (option$2,
		                               pA,
		                               pz,
		                               b,
		                               function(b){
		                                return caml_exact_trampoline_cps_call
		(complete,
		 default$,
		 function(c){
		  return caml_exact_trampoline_cps_call$1(symbol$64, c, b, a);
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               }
		                               return caml_exact_trampoline_cps_call$0
		                                       (unit,
		0,
		pC,
		n,
		function(b){
		 return caml_exact_trampoline_cps_call$0
		         (unit,
		          0,
		          0,
		          n,
		          function(c){
		           return caml_exact_trampoline_cps_call$1
		                   (symbol$64,
		                    c,
		                    b,
		                    function(b){
		                     return caml_trampoline_cps_call3(let$0, b, a, cont);
		                    });
		          });
		});
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (number,
		                                       1,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (let$0,
		         a,
		         b,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (token,
		                   1,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (complete,
		                             default$,
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1
		                                      (symbol$64, b, a, cont);
		                             });
		                   });
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (keyword,
		                                      "for",
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (let$0,
		        c,
		        a,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (let$9,
		                  a,
		                  b,
		                  function(duration){
		                   return caml_exact_trampoline_cps_call
		                           (time,
		                            config,
		                            function(time){
		                             var
		                              open =
		                                g
		                                 ([0,
		                                   symbol_bind$13,
		                                   symbol_map$12,
		                                   ,
		                                   bind$18,
		                                   return$18,
		                                   map$30,
		                                   ,
		                                   ,
		                                   ,
		                                   ,
		                                   Let_syntax$8]),
		                              let$ = open[4],
		                              let$0 = open[3];
		                             function b(res, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (to_completion,
		                                       function(value, cont){return cont([0, value]);},
		                                       res,
		                                       function(a){
		var match = a[1];
		if(match){
		 var completions = a[2], dates = match[1];
		 return cont
		         ([0,
		           make$12([0, dates], 0, 0, 0, 0, 0, 0, 0, 0, 0),
		           completions]);
		}
		var completions$0 = a[2];
		return cont
		        ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		                                       });
		                             }
		                             function a(param, cont){
		                              function a(x, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (date_of_next, config, x, cont);
		                              }
		                              return caml_exact_trampoline_cps_call$1
		                                      (token,
		                                       1,
		                                       day_name,
		                                       function(b){
		return caml_trampoline_cps_call3(let$, b, a, cont);
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (keyword,
		                                      cst_on,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (let$0,
		        c,
		        a,
		        function(p){
		         function f(cpl, cont){
		          var match = cpl[3];
		          if(0 === match[0]) return cont(cpl);
		          var sugg = match[1];
		          function compare(a, param, cont){
		           var d2 = param[2], d1 = a[2];
		           if(0 === d1[0] && 0 === d2[0]){
		            var d2$0 = d2[1], d1$0 = d1[1];
		            return caml_trampoline_cps_call3
		                    (compare$39, d1$0, d2$0, cont);
		           }
		           return caml_exact_trampoline_cps_call
		                   (failwith,
		                    "unreachable: days of week must complete to `Dates_intf.dates.Date`",
		                    cont);
		          }
		          return caml_exact_trampoline_cps_call
		                  (elements_of_list,
		                   sugg,
		                   function(sugg){
		                    return caml_exact_trampoline_cps_call$1
		                            (stable_sort,
		                             sugg,
		                             compare,
		                             function(sorted_sugg){
		                              return caml_exact_trampoline_cps_call
		                                      (of_list_exn,
		                                       sorted_sugg,
		                                       function(sorted_sugg){
		return cont([0, cpl[1], cpl[2], [1, sorted_sugg]]);
		                                       });
		                             });
		                   });
		         }
		         return caml_trampoline_cps_call3
		                 (map$28,
		                  p,
		                  f,
		                  function(a){
		                   return caml_trampoline_cps_call3
		                           (let$9,
		                            a,
		                            b,
		                            function(on_dow){
		                             var
		                              open =
		                                g
		                                 ([0,
		                                   symbol_bind$13,
		                                   symbol_map$12,
		                                   ,
		                                   bind$18,
		                                   return$18,
		                                   map$30,
		                                   ,
		                                   ,
		                                   ,
		                                   ,
		                                   Let_syntax$8]),
		                              let$ = open[3];
		                             function a(res, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (to_completion,
		                                       function(value, cont){return cont([2, value]);},
		                                       res,
		                                       function(a){
		var match = a[1];
		if(match){
		 var completions = a[2], destination = match[1];
		 return cont
		         ([0,
		           make$12(0, 0, [0, destination], 0, 0, 0, 0, 0, 0, 0),
		           completions]);
		}
		var completions$0 = a[2];
		return cont
		        ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		                                       });
		                             }
		                             function b(param, cont){return cont(destination);}
		                             return caml_exact_trampoline_cps_call
		                                     (operator,
		                                      cst$41,
		                                      function(c){
		                                       return caml_exact_trampoline_cps_call$1
		       (symbol$93,
		        c,
		        cut_completion,
		        function(c){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol$93,
		                  c,
		                  whitespace$0,
		                  function(c){
		                   return caml_trampoline_cps_call3
		                           (let$,
		                            c,
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (let$9,
		                                      b,
		                                      a,
		                                      function(destination){
		                                       var
		open =
		  g
		   ([0,
		     symbol_bind$13,
		     symbol_map$12,
		     ,
		     bind$18,
		     return$18,
		     map$30,
		     ,
		     ,
		     ,
		     ,
		     Let_syntax$8]),
		let$ = open[3];
		                                       function a(res, cont){
		return caml_exact_trampoline_cps_call$1
		        (to_completion,
		         function(value, cont){return cont([5, value]);},
		         res,
		         function(a){
		          var match = a[1];
		          if(match){
		           var completions = a[2], participant = match[1];
		           return cont
		                   ([0,
		                     make$12(0, 0, 0, 0, 0, [0, [0, participant, 0]], 0, 0, 0, 0),
		                     completions]);
		          }
		          var completions$0 = a[2];
		          return cont
		                  ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		         });
		                                       }
		                                       function b(param, cont){return cont(participant);}
		                                       return caml_exact_trampoline_cps_call
		       (keyword,
		        "with",
		        function(c){
		         return caml_trampoline_cps_call3
		                 (let$,
		                  c,
		                  b,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (let$9,
		                            b,
		                            a,
		                            function(participant$0){
		                             var
		                              open =
		                                g
		                                 ([0,
		                                   symbol_bind$13,
		                                   symbol_map$12,
		                                   ,
		                                   bind$18,
		                                   return$18,
		                                   map$30,
		                                   ,
		                                   ,
		                                   ,
		                                   ,
		                                   Let_syntax$8]),
		                              let$ = open[4],
		                              let$0 = open[3];
		                             function c(res, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (to_completion,
		                                       function(a, cont){
		var context = a[2], recurrence = a[1];
		if(context[1]){
		 if(context[2])
		  return caml_exact_trampoline_cps_call
		          (failwith,
		           "why are we completing 'starting' and 'until' simultaneously?",
		           cont);
		}
		else if(! context[2]) return cont([7, recurrence]);
		a = recurrence[1];
		if(0 === a[0])
		 return caml_exact_trampoline_cps_call
		         (failwith,
		          "mandate is not supposed to yield count occurrences yet",
		          cont);
		var date = context[1] ? a[2] : a[1];
		return caml_exact_trampoline_cps_call$2
		        (value_exn,
		         0,
		         0,
		         0,
		         date,
		         function(a){return cont([0, [0, a]]);});
		                                       },
		                                       res,
		                                       function(a){
		var match = a[1];
		if(match){
		 var completions = a[2], recurrence = match[1][1];
		 return cont
		         ([0,
		           make$12(0, 0, 0, 0, 0, 0, 0, [0, recurrence], 0, 0),
		           completions]);
		}
		var completions$0 = a[2];
		return cont
		        ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		                                       });
		                             }
		                             function a(param, cont){
		                              var
		                               context = param[3],
		                               match = param[2],
		                               end = match[2],
		                               start = match[1],
		                               rule = param[1];
		                              return cont([0, [0, [1, end, start], rule], context]);
		                             }
		                             function b(param, cont){
		                              return caml_trampoline_cps_call3
		                                      (let$0,
		                                       base_rule,
		                                       function(rule, cont){
		function a(a, cont){
		 var context = a[2], boundaries = a[1];
		 switch(rule[0]){
		   case 1:
		    if(rule[2])
		     var rule$0 = rule;
		    else {
		     a = boundaries[1];
		     if(a)
		      var date = a[1], rule$0 = [1, rule[1], [0, [0, date[1]]]];
		     else
		      rule$0 = rule;
		    }
		    break;
		   case 4:
		    if(rule[2] || rule[3])
		     rule$0 = rule;
		    else {
		     a = boundaries[1];
		     if(a)
		      var
		       date$0 = a[1],
		       rule$0 = [4, rule[1], [0, date$0[1]], [0, date$0[2]]];
		     else
		      rule$0 = rule;
		    }
		    break;
		   default: rule$0 = rule;
		 }
		 return caml_trampoline_cps_call2
		         (return$18, [0, rule$0, boundaries, context], cont);
		}
		return caml_exact_trampoline_cps_call$1
		        (boundaries,
		         config,
		         rule,
		         function(b){
		          return caml_trampoline_cps_call3(let$0, b, a, cont);
		         });
		                                       },
		                                       cont);
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (keyword,
		                                      cst_every,
		                                      function(d){
		                                       return caml_trampoline_cps_call3
		       (let$0,
		        d,
		        b,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (let$,
		                  b,
		                  a,
		                  function(parser){
		                   return caml_trampoline_cps_call3
		                           (let$9,
		                            symbol$63(parser, cst_recurrence),
		                            c,
		                            function(recurrence){
		                             var
		                              open =
		                                g
		                                 ([0,
		                                   symbol_bind$13,
		                                   symbol_map$12,
		                                   ,
		                                   bind$18,
		                                   return$18,
		                                   map$30,
		                                   ,
		                                   ,
		                                   ,
		                                   ,
		                                   Let_syntax$8]),
		                              let$ = open[3];
		                             function a(res, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (to_completion,
		                                       function(value, cont){return cont([8, value]);},
		                                       res,
		                                       function(a){
		var match = a[1];
		if(match){
		 var completions = a[2], type = match[1];
		 return cont
		         ([0,
		           make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, [0, type]),
		           completions]);
		}
		var completions$0 = a[2];
		return cont
		        ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		                                       });
		                             }
		                             function b(param, cont){return cont(type);}
		                             return caml_exact_trampoline_cps_call
		                                     (keyword,
		                                      cst_as,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (let$,
		        c,
		        b,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (let$9,
		                  b,
		                  a,
		                  function(type){
		                   var
		                    open =
		                      g
		                       ([0,
		                         symbol_bind$13,
		                         symbol_map$12,
		                         ,
		                         bind$18,
		                         return$18,
		                         map$30,
		                         ,
		                         ,
		                         ,
		                         ,
		                         Let_syntax$8]),
		                    let$ = open[3];
		                   function a(res, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (to_completion,
		                             function(value, cont){return cont([4, value]);},
		                             res,
		                             function(a){
		                              var match = a[1];
		                              if(match){
		                               var completions = a[2], label = match[1];
		                               return cont
		                                       ([0,
		 make$12(0, 0, 0, 0, [0, [0, label, 0]], 0, 0, 0, 0, 0),
		 completions]);
		                              }
		                              var completions$0 = a[2];
		                              return cont
		                                      ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		                             });
		                   }
		                   function b(a, cont){
		                    a = config[11];
		                    if(! a)
		                     return caml_exact_trampoline_cps_call
		                             (fail$3, "no labels", cont);
		                    var tail = a[2], head = a[1];
		                    g
		                     ([0,
		                       symbol_bind$13,
		                       symbol_map$12,
		                       ,
		                       bind$18,
		                       return$18,
		                       map$30,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$8]);
		                    return caml_exact_trampoline_cps_call$2
		                            (strings_alternate,
		                             [0, confirm$0],
		                             p5,
		                             0,
		                             [0, head, tail],
		                             function(labels){
		                              return caml_exact_trampoline_cps_call$1
		                                      (token, 1, labels, cont);
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (operator,
		                            cst$8,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$93,
		                                      c,
		                                      cut_completion,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (let$,
		        c,
		        b,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (let$9,
		                  b,
		                  a,
		                  function(label){
		                   var
		                    open =
		                      g
		                       ([0,
		                         symbol_bind$13,
		                         symbol_map$12,
		                         ,
		                         bind$18,
		                         return$18,
		                         map$30,
		                         ,
		                         ,
		                         ,
		                         ,
		                         Let_syntax$8]),
		                    let$ = open[3];
		                   function a(res, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (to_completion,
		                             function(value, cont){return cont([6, value]);},
		                             res,
		                             function(a){
		                              var match = a[1];
		                              if(match){
		                               var completions = a[2], priority = match[1];
		                               return cont
		                                       ([0,
		 make$12(0, 0, 0, 0, 0, 0, [0, priority], 0, 0, 0),
		 completions]);
		                              }
		                              var completions$0 = a[2];
		                              return cont
		                                      ([0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), completions$0]);
		                             });
		                   }
		                   function b(a, cont){
		                    a = config[15];
		                    if(! a)
		                     return caml_exact_trampoline_cps_call
		                             (fail$3, "no priorities", cont);
		                    var tail = a[2], head = a[1];
		                    g
		                     ([0,
		                       symbol_bind$13,
		                       symbol_map$12,
		                       ,
		                       bind$18,
		                       return$18,
		                       map$30,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$8]);
		                    return caml_exact_trampoline_cps_call$2
		                            (strings_alternate,
		                             [0, confirm$0],
		                             p6,
		                             0,
		                             [0, head, tail],
		                             function(priorities){
		                              return caml_exact_trampoline_cps_call$1
		                                      (token, 1, priorities, cont);
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (operator,
		                            cst$20,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$93,
		                                      c,
		                                      cut_completion,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (let$,
		        c,
		        b,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (let$9,
		                  b,
		                  a,
		                  function(priority){
		                   function parser(context, cont){
		                    function exclusive(slot, p, cont){
		                     return is_some(slot)
		                             ? caml_exact_trampoline_cps_call
		                               (fail$3, "slot already filled", cont)
		                             : cont(p);
		                    }
		                    function task_only(context, p, cont){
		                     if(! context[6] && ! context[10]) return cont(p);
		                     return caml_exact_trampoline_cps_call
		                             (fail$3, "not a task query", cont);
		                    }
		                    return caml_exact_trampoline_cps_call$1
		                            (exclusive,
		                             context[4],
		                             duration,
		                             function(duration){
		                              return caml_exact_trampoline_cps_call
		                                      (daytime$0,
		                                       context,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (exclusive,
		         context[2],
		         a,
		         function(daytime){
		          return caml_exact_trampoline_cps_call$1
		                  (exclusive,
		                   context[3],
		                   destination,
		                   function(destination){
		                    return caml_exact_trampoline_cps_call$1
		                            (task_only,
		                             context,
		                             label,
		                             function(label){
		                              return caml_exact_trampoline_cps_call$1
		                                      (exclusive,
		                                       context[10],
		                                       participant$0,
		                                       function(p){
		function a(participant){
		 return caml_exact_trampoline_cps_call$1
		         (exclusive,
		          context[10],
		          type,
		          function(p){
		           function a(type){
		            return caml_exact_trampoline_cps_call$1
		                    (exclusive,
		                     context[7],
		                     priority,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (task_only,
		                               context,
		                               a,
		                               function(priority){
		                                return caml_exact_trampoline_cps_call$1
		(exclusive,
		 context[8],
		 recurrence,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (exclusive,
		           context[2],
		           a,
		           function(a){
		            return caml_exact_trampoline_cps_call$1
		                    (exclusive,
		                     context[4],
		                     a,
		                     function(recurrence){
		                      var a = context[1];
		                      function c(recurrence){
		                       var match = context[8];
		                       function a(time){
		                        var
		                         a = symbol$63(priority, cst_priority),
		                         b = symbol$63(label, cst_label),
		                         c = symbol$63(type, cst_type),
		                         d = symbol$63(destination, cst_destination),
		                         e = symbol$63(duration, cst_duration),
		                         f = symbol$63(time, cst_time);
		                        return caml_exact_trampoline_cps_call$1
		                                (symbol$64,
		                                 symbol$63(daytime, cst_daytime),
		                                 f,
		                                 function(f){
		                                  return caml_exact_trampoline_cps_call$1
		  (symbol$64,
		   f,
		   e,
		   function(e){
		    return caml_exact_trampoline_cps_call$1
		            (symbol$64,
		             e,
		             d,
		             function(d){
		              return caml_exact_trampoline_cps_call$1
		                      (symbol$64,
		                       d,
		                       c,
		                       function(c){
		                        return caml_exact_trampoline_cps_call$1
		                                (symbol$64,
		                                 c,
		                                 b,
		                                 function(b){
		                                  return caml_exact_trampoline_cps_call$1
		  (symbol$64,
		   b,
		   a,
		   function(p){
		    function a(p){
		     function a(entrypoint){
		      return cont(symbol$63(entrypoint, "time-allocation"));
		     }
		     return config[9][1]
		             ? caml_exact_trampoline_cps_call$1
		               (symbol$64, p, participant, a)
		             : a(p);
		    }
		    return config[9][3]
		            ? caml_exact_trampoline_cps_call$1
		              (symbol$64, p, recurrence, a)
		            : a(p);
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       }
		                       return match
		                               ? 2
		                                 === match[1][2][0]
		                                 ? a(on_dow)
		                                 : caml_exact_trampoline_cps_call
		                                   (fail$3,
		                                    "may not parse a time after an incompatible recurrence",
		                                    a)
		                               : caml_exact_trampoline_cps_call$1
		                                 (exclusive, context[1], time, a);
		                      }
		                      if(! a) return c(recurrence);
		                      a = a[1];
		                      function b(){
		                       return caml_exact_trampoline_cps_call
		                               (fail$3,
		                                "can only parse a recurrence after 'on X' if X is a day of the week",
		                                c);
		                      }
		                      if(0 !== a[0]) return b();
		                      var date = a[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (symbol$82,
		                               date,
		                               config[2],
		                               function(a){
		                                return a
		? caml_exact_trampoline_cps_call$1
		  (add_days,
		   config[2],
		   7,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (symbol$80,
		             date,
		             a,
		             function(a){return a ? c(recurrence) : b();});
		   })
		: b();
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           }
		           if(! context[5] && ! context[6] && ! context[7])
		            return a(p);
		           return caml_exact_trampoline_cps_call
		                   (fail$3, "not custom type query", a);
		          });
		}
		if(! context[5] && ! context[7] && ! context[10])
		 return a(p);
		return caml_exact_trampoline_cps_call
		        (fail$3, "not an event query", a);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   }
		                   var participant$1 = standalone(participant);
		                   return cont
		                           ([0, date, daytime$1, destination$0, parser, participant$1]);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        }
		        if(! match)
		         return caml_exact_trampoline_cps_call(fail$3, "no types", a);
		        var tail = match[2], head = match[1];
		        g
		         ([0,
		           symbol_bind$13,
		           symbol_map$12,
		           ,
		           bind$18,
		           return$18,
		           map$30,
		           ,
		           ,
		           ,
		           ,
		           Let_syntax$8]);
		        return caml_exact_trampoline_cps_call$2
		                (strings_alternate,
		                 [0, confirm$0],
		                 p4,
		                 0,
		                 [0, head, tail],
		                 function(types){
		                  return caml_exact_trampoline_cps_call$1(token, 1, types, a);
		                 });
		       });
		                                     });
		                           });
		                 }
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (fail$3, "no contacts", a);
		                 var t = match[2], h = match[1];
		                 g
		                  ([0,
		                    symbol_bind$13,
		                    symbol_map$12,
		                    ,
		                    bind$18,
		                    return$18,
		                    map$30,
		                    ,
		                    ,
		                    ,
		                    ,
		                    Let_syntax$8]);
		                 return caml_exact_trampoline_cps_call$2
		                         (strings_alternate,
		                          [0, confirm$0],
		                          p3,
		                          [0, email_matcher],
		                          [0, h, t],
		                          function(participants){
		                           return caml_exact_trampoline_cps_call$1
		                                   (token, 1, participants, a);
		                          });
		                }
		                if(! config[9][4])
		                 return caml_exact_trampoline_cps_call
		                         (fail$3, "redirections disabled", b);
		                if(! a)
		                 return caml_exact_trampoline_cps_call
		                         (fail$3, "no destinations", b);
		                var tail = a[2], head = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$13,
		                         peek_char$1,
		                         function(param, cont){
		                          function a(){
		                           return caml_trampoline_cps_call2(return$18, 0, cont);
		                          }
		                          if(! param) return a();
		                          var c = param[1];
		                          return caml_exact_trampoline_cps_call
		                                  (alnum,
		                                   c,
		                                   function(b){
		                                    return b
		    ? caml_exact_trampoline_cps_call
		      (fail$3, "invalid separator", cont)
		    : a();
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$64,
		                                   confirm$0,
		                                   a,
		                                   function(break$){
		                                    function stage(destinations, cont){
		                                     function refine_completion(b, cont){
		                                      var
		                                       dest = b[2],
		                                       name = b[1],
		                                       l = dest[2],
		                                       b = l,
		                                       accu$0 = 0;
		                                      for(;;){
		                                       if(! b)
		return caml_exact_trampoline_cps_call
		        (of_rev_keys, accu$0, cont);
		                                       var
		l$0 = b[2],
		a = b[1],
		s2$0 = a[1][1],
		s2 = cst$34 + s2$0,
		accu = [0, [0, name + s2, a], accu$0];
		                                       b = l$0;
		                                       accu$0 = accu;
		                                      }
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (rev_map$0,
		      destinations,
		      function(d, cont){
		       var matchable = d[1];
		       return cont([0, matchable[1], matchable[2], d]);
		      },
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (rev$1,
		                a,
		                function(choices){
		                 return caml_exact_trampoline_cps_call$2
		                         (strings_alternate,
		                          [0, break$],
		                          p1,
		                          0,
		                          choices,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (token,
		                                    1,
		                                    a,
		                                    function(root){
		                                     return caml_exact_trampoline_cps_call$0
		     (bind_stop_completion,
		      [0, refine_completion],
		      root,
		      function(dest, cont){
		       var match = dest[2];
		       if(! match)
		        return caml_trampoline_cps_call2(return$18, dest, cont);
		       var t = match[2], h = match[1];
		       function f(d, cont){
		        var s2 = d[1][1];
		        return cont([0, cst$34 + s2, d]);
		       }
		       return caml_trampoline_cps_call3
		               (map$18,
		                t,
		                f,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          h,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (complete,
		                                    [0, b, a],
		                                    function(suggestions){
		                                     return caml_exact_trampoline_cps_call
		     (stage,
		      [0, h, t],
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (operator,
		                cst$34,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$93,
		                          b,
		                          cut_completion,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$93,
		                                    b,
		                                    leading_whitespace,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$92,
		      maybe_stopper,
		      noncanonical_whitespace,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$92,
		                c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$92,
		                          b,
		                          a,
		                          function(p){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$64,
		                                    suggestions,
		                                    p,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (option$2, p2, [0, cst$1, dest], a, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      },
		      cont);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (stage,
		     [0, head, tail],
		     function(root){
		      return caml_trampoline_cps_call3
		              (g
		                 ([0,
		                   symbol_bind$13,
		                   symbol_map$12,
		                   ,
		                   bind$18,
		                   return$18,
		                   map$30,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$8])
		                [4],
		               root,
		               function(param, cont){
		                var value = param[1][3];
		                return cont(value);
		               },
		               b);
		     });
		                                   });
		                         });
		               }
		               var
		                e = "Unix.Unix_error",
		                Unix_error = [248, e, caml_fresh_oo_id()];
		               register_exception(e, [0, Unix_error, 0, cst$1, cst$1]);
		               register_printer
		                (function(b, cont){
		                  if(b[1] !== Unix_error) return cont(0);
		                  var s = b[4], s$0 = b[3], e = b[2];
		                  function a(msg){
		                   return caml_exact_trampoline_cps_call
		                           (sprintf,
		                            qm,
		                            function(a){
		                             return caml_trampoline_cps_call4
		                                     (a, msg, s$0, s, function(a){return cont([0, a]);});
		                            });
		                  }
		                  if(typeof e !== "number"){
		                   var x = e[1];
		                   return caml_exact_trampoline_cps_call
		                           (sprintf,
		                            qn,
		                            function(b){return caml_trampoline_cps_call2(b, x, a);});
		                  }
		                  b = e;
		                  if(34 <= b)
		                   switch(b){
		                     case 34:
		                      return a("ESPIPE");
		                     case 35:
		                      return a("ESRCH");
		                     case 36:
		                      return a("EXDEV");
		                     case 37:
		                      return a("EWOULDBLOCK");
		                     case 38:
		                      return a("EINPROGRESS");
		                     case 39:
		                      return a("EALREADY");
		                     case 40:
		                      return a("ENOTSOCK");
		                     case 41:
		                      return a("EDESTADDRREQ");
		                     case 42:
		                      return a("EMSGSIZE");
		                     case 43:
		                      return a("EPROTOTYPE");
		                     case 44:
		                      return a("ENOPROTOOPT");
		                     case 45:
		                      return a("EPROTONOSUPPORT");
		                     case 46:
		                      return a("ESOCKTNOSUPPORT");
		                     case 47:
		                      return a("EOPNOTSUPP");
		                     case 48:
		                      return a("EPFNOSUPPORT");
		                     case 49:
		                      return a("EAFNOSUPPORT");
		                     case 50:
		                      return a("EADDRINUSE");
		                     case 51:
		                      return a("EADDRNOTAVAIL");
		                     case 52:
		                      return a("ENETDOWN");
		                     case 53:
		                      return a("ENETUNREACH");
		                     case 54:
		                      return a("ENETRESET");
		                     case 55:
		                      return a("ECONNABORTED");
		                     case 56:
		                      return a("ECONNRESET");
		                     case 57:
		                      return a("ENOBUFS");
		                     case 58:
		                      return a("EISCONN");
		                     case 59:
		                      return a("ENOTCONN");
		                     case 60:
		                      return a("ESHUTDOWN");
		                     case 61:
		                      return a("ETOOMANYREFS");
		                     case 62:
		                      return a("ETIMEDOUT");
		                     case 63:
		                      return a("ECONNREFUSED");
		                     case 64:
		                      return a("EHOSTDOWN");
		                     case 65:
		                      return a("EHOSTUNREACH");
		                     case 66:
		                      return a("ELOOP");
		                     default: return a("EOVERFLOW");
		                   }
		                  switch(b){
		                    case 0:
		                     return a("E2BIG");
		                    case 1:
		                     return a("EACCES");
		                    case 2:
		                     return a("EAGAIN");
		                    case 3:
		                     return a("EBADF");
		                    case 4:
		                     return a("EBUSY");
		                    case 5:
		                     return a("ECHILD");
		                    case 6:
		                     return a("EDEADLK");
		                    case 7:
		                     return a("EDOM");
		                    case 8:
		                     return a("EEXIST");
		                    case 9:
		                     return a("EFAULT");
		                    case 10:
		                     return a("EFBIG");
		                    case 11:
		                     return a("EINTR");
		                    case 12:
		                     return a("EINVAL");
		                    case 13:
		                     return a("EIO");
		                    case 14:
		                     return a("EISDIR");
		                    case 15:
		                     return a("EMFILE");
		                    case 16:
		                     return a("EMLINK");
		                    case 17:
		                     return a("ENAMETOOLONG");
		                    case 18:
		                     return a("ENFILE");
		                    case 19:
		                     return a("ENODEV");
		                    case 20:
		                     return a("ENOENT");
		                    case 21:
		                     return a("ENOEXEC");
		                    case 22:
		                     return a("ENOLCK");
		                    case 23:
		                     return a("ENOMEM");
		                    case 24:
		                     return a("ENOSPC");
		                    case 25:
		                     return a("ENOSYS");
		                    case 26:
		                     return a("ENOTDIR");
		                    case 27:
		                     return a("ENOTEMPTY");
		                    case 28:
		                     return a("ENOTTY");
		                    case 29:
		                     return a("ENXIO");
		                    case 30:
		                     return a("EPERM");
		                    case 31:
		                     return a("EPIPE");
		                    case 32:
		                     return a("ERANGE");
		                    default: return a("EROFS");
		                  }
		                 });
		               var
		                popen_processes = caml_callback(create$5, [0, 7]),
		                popen_mutex = caml_ml_mutex_new();
		               function caseless_equal(a, b){
		                if(a === b) return 1;
		                var
		                 len = caml_ml_string_length(a),
		                 c = len === caml_ml_string_length(b) ? 1 : 0;
		                if(! c) return c;
		                function byte_loop(a, b, i$1, len){
		                 var i = i$1;
		                 for(;;){
		                  var
		                   c1 = caml_string_unsafe_get(a, i),
		                   c2 = caml_string_unsafe_get(b, i),
		                   c = lowercase_ascii(c2),
		                   c = lowercase_ascii(c1) === c ? 1 : 0;
		                  if(c){
		                   var i$0 = i + 1 | 0, c = i$0 === len ? 1 : 0;
		                   if(! c){i = i$0; continue;}
		                  }
		                  return c;
		                 }
		                }
		                var i = 0;
		                for(;;){
		                 if(i === len) return 1;
		                 var i$0 = i + 8 | 0;
		                 if(len < i$0) return byte_loop(a, b, i, len);
		                 c = caml_string_get64(b, i);
		                 if(caml_equal(caml_string_get64(a, i), c))
		                  i = i$0;
		                 else {c = byte_loop(a, b, i, i$0); if(! c) return c; i = i$0;}
		                }
		               }
		               function add$9(h, k, v){return [0, [0, k, v], h];}
		               function get$7(h, k){
		                var h$0 = h;
		                for(;;){
		                 if(! h$0) return 0;
		                 var
		                  h$1 = h$0[2],
		                  match = h$0[1],
		                  v = match[2],
		                  k$0 = match[1];
		                 if(caseless_equal(k, k$0)) return [0, v];
		                 h$0 = h$1;
		                }
		               }
		               var
		                headers_with_list_values = caml_obj_dup(qq),
		                tbl =
		                  caml_callback
		                   (create$5, [0, headers_with_list_values.length - 1]);
		               caml_callback
		                (function(a, cont){
		                  var b = a.length - 2 | 0;
		                  function d(){return cont();}
		                  function c(i){
		                   var h = a[i + 1];
		                   return caml_exact_trampoline_cps_call$0
		                           (add$0,
		                            tbl,
		                            h,
		                            0,
		                            function(a){
		                             a = i + 1 | 0;
		                             return b !== i ? caml_exact_trampoline_call1(c, a) : d();
		                            });
		                  }
		                  return b < 0 ? d() : c(0);
		                 },
		                 [headers_with_list_values]);
		               var
		                cst_chunked = "chunked",
		                cst_content_length = "content-length";
		               function get_transfer_encoding(headers, cont){
		                var list_value_only = opt$6[1];
		                function a(a){
		                 if(a && a[1] === cst_chunked) return cont(0);
		                 a = get$7(headers, cst_content_length);
		                 function b(match){
		                  if(! match) return cont(1);
		                  var len = match[1];
		                  return cont([0, len]);
		                 }
		                 if(a){var clen = a[1]; return b(of_string_opt(clen));}
		                 a = get$7(headers, "content-range");
		                 if(! a) return b(0);
		                 var range_s = a[1];
		                 function c(a){
		                  if(! a) return b(0);
		                  a = a[1];
		                  var total = a[3], fini = a[2], start = a[1];
		                  if
		                   (caml_lessthan(fini, total)
		                    &&
		                     caml_lessequal(start, total)
		                     && caml_lessequal(qs, start) && caml_lessequal(qt, total)){
		                   var
		                    num_bytes_to_read =
		                      caml_int64_add(caml_int64_sub(fini, start), qu);
		                   return b([0, num_bytes_to_read]);
		                  }
		                  return b(0);
		                 }
		                 caml_push_trap
		                  (function(exn){
		                    if(exn[1] === Scan_failure) return c(0);
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   });
		                 function d(start, fini, total, cont){
		                  return cont([0, start, fini, total]);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (sscanf,
		                          range_s,
		                          qr,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    d,
		                                    function(match){
		                                     var total = match[3], fini = match[2], start = match[1];
		                                     caml_pop_trap();
		                                     return c([0, [0, start, fini, total]]);
		                                    });
		                          });
		                }
		                var key = cst_transfer_encoding;
		                function b(){
		                 var h = headers, acc = 0;
		                 for(;;){
		                  if(! h) break;
		                  var h$0 = h[2], match = h[1], v = match[2], k = match[1];
		                  if(caseless_equal(key, k)){
		                   var acc$0 = [0, v, acc];
		                   h = h$0;
		                   acc = acc$0;
		                  }
		                  else
		                   h = h$0;
		                 }
		                 return acc
		                         ? caml_exact_trampoline_cps_call$1
		                           (concat, cst$25, acc, function(b){return a([0, b]);})
		                         : a(0);
		                }
		                return list_value_only
		                        ? caml_exact_trampoline_cps_call$1
		                          (key_index,
		                           tbl,
		                           key,
		                           function(c){
		                            c = caml_check_bound(tbl[2], c)[c + 1];
		                            for(;;){
		                             if(c){
		                              var
		                               k = c[1],
		                               next = c[3],
		                               c = 0 === caml_compare(k, cst_transfer_encoding);
		                              if(! c){c = next; continue;}
		                             }
		                             else
		                              c = 0;
		                             return c ? b() : a(get$7(headers, key));
		                            }
		                           })
		                        : b();
		               }
		               function add_transfer_encoding(headers, enc, cont){
		                return caml_exact_trampoline_cps_call
		                        (get_transfer_encoding,
		                         headers,
		                         function(match){
		                          if(typeof match === "number" && match){
		                           if(typeof enc === "number")
		                            return enc
		                                    ? cont(headers)
		                                    : cont(add$9(headers, cst_transfer_encoding, cst_chunked));
		                           var len = enc[1];
		                           return cont
		                                   (add$9
		                                     (headers, cst_content_length, caml_int64_format(cst_d, len)));
		                          }
		                          return cont(headers);
		                         });
		               }
		               function status_of_code(cod){
		                if(309 <= cod){
		                 var a = cod - 598 | 0;
		                 if(1 >= a >>> 0) return a ? 789753444 : -43455790;
		                 a = a + 198 | 0;
		                 if(111 >= a >>> 0)
		                  switch(a){
		                    case 0:
		                     return -99004555;
		                    case 1:
		                     return 324098644;
		                    case 2:
		                     return -720017128;
		                    case 3:
		                     return -438114087;
		                    case 4:
		                     return -358247754;
		                    case 5:
		                     return 13829438;
		                    case 6:
		                     return -176787538;
		                    case 7:
		                     return -12825579;
		                    case 8:
		                     return 1052164689;
		                    case 9:
		                     return -36288910;
		                    case 10:
		                     return 792903807;
		                    case 11:
		                     return -221106440;
		                    case 12:
		                     return 282375460;
		                    case 13:
		                     return 60220292;
		                    case 14:
		                     return -1028883702;
		                    case 15:
		                     return -459143713;
		                    case 16:
		                     return 382669006;
		                    case 17:
		                     return 897427648;
		                    case 18:
		                     return 491839979;
		                    case 20:
		                     return -785212614;
		                    case 22:
		                     return 578388242;
		                    case 23:
		                     return 240875818;
		                    case 24:
		                     return 558492973;
		                    case 26:
		                     return -867418942;
		                    case 28:
		                     return 807430278;
		                    case 29:
		                     return 65414873;
		                    case 31:
		                     return -1051942420;
		                    case 44:
		                     return 229723487;
		                    case 49:
		                     return 599500189;
		                    case 50:
		                     return -1042139761;
		                    case 51:
		                     return 626869805;
		                    case 99:
		                     return 874866960;
		                    case 100:
		                     return -732353682;
		                    case 101:
		                     return -498198474;
		                    case 102:
		                     return -957501398;
		                    case 103:
		                     return -774758938;
		                    case 104:
		                     return 731537414;
		                    case 105:
		                     return -1014316796;
		                    case 106:
		                     return -598402413;
		                    case 107:
		                     return 161957855;
		                    case 108:
		                     return 169087453;
		                    case 109:
		                     return 806912325;
		                    case 110:
		                     return 854525125;
		                    case 111:
		                     return -15361451;
		                  }
		                }
		                else if(200 <= cod)
		                 if(227 <= cod){
		                  if(300 <= cod)
		                   switch(cod - 300 | 0){
		                     case 0:
		                      return 18898339;
		                     case 1:
		                      return 384167631;
		                     case 2:
		                      return 398750242;
		                     case 3:
		                      return 260151748;
		                     case 4:
		                      return -387970219;
		                     case 5:
		                      return -398446314;
		                     case 6:
		                      return -199968061;
		                     case 7:
		                      return 1034456810;
		                     default: return 514453165;
		                   }
		                 }
		                 else
		                  switch(cod - 200 | 0){
		                    case 0:
		                     return 17692;
		                    case 1:
		                     return -558113336;
		                    case 2:
		                     return 566851975;
		                    case 3:
		                     return 102779818;
		                    case 4:
		                     return -527633381;
		                    case 5:
		                     return -234002583;
		                    case 6:
		                     return 893234971;
		                    case 7:
		                     return -886248552;
		                    case 8:
		                     return -330714374;
		                    case 26:
		                     return -247210088;
		                  }
		                else {
		                 a = cod - 100 | 0;
		                 if(3 >= a >>> 0)
		                  switch(a){
		                    case 0:
		                     return 192584839;
		                    case 1:
		                     return -1021676630;
		                    case 2:
		                     return -840540685;
		                    default: return 973294248;
		                  }
		                }
		                return [0, 748543309, cod];
		               }
		               function code_of_status(param){
		                if(typeof param === "number")
		                 return 13829438 <= param
		                         ? 514453165
		                           <= param
		                           ? 806912325
		                             <= param
		                             ? 893234971
		                               <= param
		                               ? 897427648
		                                 === param
		                                 ? 417
		                                 : 1034456810
		                                   <= param
		                                   ? 1052164689 <= param ? 408 : 307
		                                   : 973294248 <= param ? 103 : 206
		                               : 854525125
		                                 <= param
		                                 ? 874866960 <= param ? 499 : 510
		                                 : 807430278 <= param ? 428 : 509
		                             : 599500189
		                               <= param
		                               ? 626869805
		                                 === param
		                                 ? 451
		                                 : 789753444
		                                   <= param
		                                   ? 792903807 <= param ? 410 : 599
		                                   : 731537414 <= param ? 504 : 449
		                               : 566851975
		                                 <= param
		                                 ? 578388242 <= param ? 422 : 202
		                                 : 558492973 <= param ? 424 : 308
		                           : 229723487
		                             <= param
		                             ? 324098644
		                               <= param
		                               ? 382669006
		                                 === param
		                                 ? 416
		                                 : 398750242
		                                   <= param
		                                   ? 491839979 <= param ? 418 : 302
		                                   : 384167631 <= param ? 301 : 401
		                               : 260151748
		                                 <= param
		                                 ? 282375460 <= param ? 412 : 303
		                                 : 240875818 <= param ? 423 : 444
		                             : 102779818
		                               <= param
		                               ? 169087453
		                                 <= param
		                                 ? 192584839 <= param ? 100 : 508
		                                 : 161957855 <= param ? 507 : 203
		                               : 60220292
		                                 <= param
		                                 ? 65414873 <= param ? 429 : 413
		                                 : 18898339 <= param ? 300 : 405
		                         : -459143713
		                           <= param
		                           ? -221106440
		                             <= param
		                             ? -43455790
		                               <= param
		                               ? -36288910
		                                 === param
		                                 ? 409
		                                 : -12825579
		                                   <= param
		                                   ? 17692 <= param ? 200 : 407
		                                   : -15361451 <= param ? 511 : 598
		                               : -176787538
		                                 <= param
		                                 ? -99004555 <= param ? 400 : 406
		                                 : -199968061 <= param ? 306 : 411
		                             : -358247754
		                               <= param
		                               ? -247210088
		                                 <= param
		                                 ? -234002583 <= param ? 205 : 226
		                                 : -330714374 <= param ? 208 : 404
		                               : -398446314
		                                 <= param
		                                 ? -387970219 <= param ? 304 : 305
		                                 : -438114087 <= param ? 403 : 415
		                           : -840540685
		                             <= param
		                             ? -720017128
		                               <= param
		                               ? -598402413
		                                 === param
		                                 ? 506
		                                 : -527633381
		                                   <= param
		                                   ? -498198474 <= param ? 501 : 204
		                                   : -558113336 <= param ? 201 : 402
		                               : -774758938
		                                 <= param
		                                 ? -732353682 <= param ? 500 : 503
		                                 : -785212614 <= param ? 420 : 102
		                             : -1014316796
		                               <= param
		                               ? -886248552
		                                 <= param
		                                 ? -867418942 <= param ? 426 : 207
		                                 : -957501398 <= param ? 502 : 505
		                               : -1028883702
		                                 <= param
		                                 ? -1021676630 <= param ? 101 : 414
		                                 : -1042139761 <= param ? 450 : 431;
		                var code = param[2];
		                return code;
		               }
		               var
		                cst_Accepted = "Accepted",
		                cst_Unauthorized = "Unauthorized";
		               function reason_phrase_of_code(cod){
		                if(309 <= cod){
		                 var a = cod - 598 | 0;
		                 if(1 >= a >>> 0)
		                  return a
		                          ? "Network connect timeout error"
		                          : "Network read timeout error";
		                 a = a + 198 | 0;
		                 if(111 >= a >>> 0)
		                  switch(a){
		                    case 0:
		                     return "Bad Request";
		                    case 1:
		                     return cst_Unauthorized;
		                    case 2:
		                     return "Payment Required";
		                    case 3:
		                     return "Forbidden";
		                    case 4:
		                     return "Not Found";
		                    case 5:
		                     return "Method Not Allowed";
		                    case 6:
		                     return "Not Acceptable";
		                    case 7:
		                     return "Proxy Authentication Required";
		                    case 8:
		                     return "Request Timeout";
		                    case 9:
		                     return "Conflict";
		                    case 10:
		                     return "Gone";
		                    case 11:
		                     return "Length Required";
		                    case 12:
		                     return "Precondition Failed";
		                    case 13:
		                     return "Request Entity Too Large";
		                    case 14:
		                     return "Request-URI Too Long";
		                    case 15:
		                     return "Unsupported Media Type";
		                    case 16:
		                     return "Requested Range Not Satisfiable";
		                    case 17:
		                     return "Expectation Failed";
		                    case 18:
		                     return "I'm a teapot (RFC 2324)";
		                    case 20:
		                     return "Enhance Your Calm";
		                    case 22:
		                     return "Unprocessable Entity (WebDAV) (RFC 4918)";
		                    case 23:
		                     return "Locked (WebDAV) (RFC 4918)";
		                    case 24:
		                     return "Failed Dependency (WebDAV) (RFC 4918)";
		                    case 26:
		                     return "Upgrade Required (RFC 2817)";
		                    case 28:
		                     return "Precondition Required";
		                    case 29:
		                     return "Too Many Requests";
		                    case 31:
		                     return "Request Header Fields Too Large";
		                    case 44:
		                     return "No Response";
		                    case 49:
		                     return "Retry With";
		                    case 50:
		                     return "Blocked by Windows Parental Controls";
		                    case 51:
		                     return "Wrong Exchange server";
		                    case 99:
		                     return "Client Closed Request";
		                    case 100:
		                     return "Internal Server Error";
		                    case 101:
		                     return "Not Implemented";
		                    case 102:
		                     return "Bad Gateway";
		                    case 103:
		                     return "Service Unavailable";
		                    case 104:
		                     return "Gateway Timeout";
		                    case 105:
		                     return "HTTP Version Not Supported";
		                    case 106:
		                     return "Variant Also Negotiates (RFC 2295)";
		                    case 107:
		                     return "Insufficient Storage (WebDAV) (RFC 4918)";
		                    case 108:
		                     return "Loop Detected (WebDAV) (RFC 5842)";
		                    case 109:
		                     return "Bandwidth Limit Exceeded (Apache bw/limited extension)";
		                    case 110:
		                     return "Not Extended (RFC 2774)";
		                    case 111:
		                     return "Network Authentication Required";
		                  }
		                }
		                else if(200 <= cod)
		                 if(227 <= cod){
		                  if(300 <= cod)
		                   switch(cod - 300 | 0){
		                     case 0:
		                      return "Multiple Choices";
		                     case 1:
		                      return "Moved Permanently";
		                     case 2:
		                      return "Found";
		                     case 3:
		                      return "See Other";
		                     case 4:
		                      return "Not Modified";
		                     case 5:
		                      return "Use Proxy (since HTTP/1.1)";
		                     case 6:
		                      return "Switch Proxy";
		                     case 7:
		                      return "Temporary Redirect (since HTTP/1.1)";
		                     default: return "Permanent Redirect";
		                   }
		                 }
		                 else
		                  switch(cod - 200 | 0){
		                    case 0:
		                     return "OK";
		                    case 1:
		                     return cst_Created;
		                    case 2:
		                     return cst_Accepted;
		                    case 3:
		                     return "Non-Authoritative Information (since HTTP/1.1)";
		                    case 4:
		                     return "No Content";
		                    case 5:
		                     return "Reset Content";
		                    case 6:
		                     return "Partial Content";
		                    case 7:
		                     return "Multi-Status (WebDAV) (RFC 4918)";
		                    case 8:
		                     return "Already Reported (WebDAV) (RFC 5842)";
		                    case 26:
		                     return "IM Used (RFC 3229)";
		                  }
		                else {
		                 a = cod - 100 | 0;
		                 if(3 >= a >>> 0)
		                  switch(a){
		                    case 0:
		                     return "Continue";
		                    case 1:
		                     return "Switching Protocols";
		                    case 2:
		                     return "Processing (WebDAV) (RFC 2518)";
		                    default: return "Checkpoint";
		                  }
		                }
		                return "" + cod;
		               }
		               function string_of_status(s, cont){
		                if(typeof s === "number"){
		                 var
		                  code = code_of_status(s),
		                  s2 = reason_phrase_of_code(code),
		                  s2$0 = cst$7 + s2,
		                  s1 = "" + code;
		                 return cont(s1 + s2$0);
		                }
		                var
		                 code$0 = s[2],
		                 code$1 = "" + code$0,
		                 s2$1 = " Status " + code$1;
		                return cont(code$1 + s2$1);
		               }
		               function string_of_method(param){
		                if(typeof param === "number")
		                 return 357830602 <= param
		                         ? 492530731
		                           === param
		                           ? "DELETE"
		                           : 891112544
		                             <= param
		                             ? 994393768 <= param ? "PATCH" : "POST"
		                             : 801894688 <= param ? "HEAD" : "CONNECT"
		                         : 3997359
		                           <= param
		                           ? 336447077 <= param ? "TRACE" : "PUT"
		                           : 3546230 <= param ? "GET" : "OPTIONS";
		                var s = param[2];
		                return s;
		               }
		               function create_zero$0(len){
		                var
		                 r = len & 7,
		                 q = len >>> 3 | 0,
		                 len$0 = 0 === r ? q : q + 1 | 0,
		                 bits = make(len$0, 0);
		                return [0, len, bits];
		               }
		               function intersect(x, y){return 0 !== (x & y) ? 1 : 0;}
		               function make$13(size, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (init,
		                         size,
		                         f,
		                         function(cache){
		                          return cont
		                                  (function(i){return caml_check_bound(cache, i)[i + 1];});
		                         });
		               }
		               function equal$33(l1, l2){
		                var l2$1 = l2, l1$1 = l1;
		                for(;;){
		                 if(l1$1){
		                  if(l2$1){
		                   var
		                    l2$0 = l2$1[2],
		                    a2 = l2$1[1],
		                    l1$0 = l1$1[2],
		                    a1 = l1$1[1],
		                    y = a2[2],
		                    x = a2[1],
		                    y$0 = a1[2],
		                    x$0 = a1[1],
		                    a = x$0 === x ? 1 : 0,
		                    a = a ? y$0 === y ? 1 : 0 : a;
		                   if(! a) return a;
		                   l2$1 = l2$0;
		                   l1$1 = l1$0;
		                   continue;
		                  }
		                 }
		                 else if(! l2$1) return 1;
		                 return 0;
		                }
		               }
		               function union$3(l$3, l$4, cont){
		                a:
		                {
		                 var l$0 = l$3, l = l$4;
		                 for(;;){
		                  if(! l) return cont(l$0);
		                  if(! l$0) return cont(l);
		                  var
		                   r = l[2],
		                   a = l[1],
		                   c2 = a[2],
		                   c1 = a[1],
		                   r$0 = l$0[2],
		                   a = l$0[1],
		                   c2$0 = a[2],
		                   c1$0 = a[1],
		                   x = c2$0 + 1 | 0;
		                  if(x < c1) break a;
		                  var x$0 = c2 + 1 | 0;
		                  if(x$0 < c1$0) break;
		                  if(c2$0 < c2){
		                   var l$1 = [0, [0, min$0(c1$0, c1), c2], r];
		                   l$0 = r$0;
		                   l = l$1;
		                  }
		                  else {
		                   var l$2 = [0, [0, min$0(c1$0, c1), c2$0], r$0];
		                   l$0 = l$2;
		                   l = r;
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (union$3,
		                          l$0,
		                          r,
		                          function(a){return cont([0, [0, c1, c2], a]);});
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (union$3,
		                         r$0,
		                         l,
		                         function(a){return cont([0, [0, c1$0, c2$0], a]);});
		               }
		               function inter(l$1, l$2, cont){
		                var l$0 = l$1, l = l$2;
		                for(;;){
		                 if(! l) return cont(0);
		                 if(! l$0) return cont(0);
		                 var
		                  r = l[2],
		                  a = l[1],
		                  c2 = a[2],
		                  c1 = a[1],
		                  r$0 = l$0[2],
		                  a = l$0[1],
		                  c2$0 = a[2],
		                  c1$0 = a[1];
		                 if(c2$0 < c1) l$0 = r$0; else {if(c2 >= c1$0) break; l = r;}
		                }
		                return c2$0 < c2
		                        ? caml_exact_trampoline_cps_call$1
		                          (inter,
		                           r$0,
		                           l,
		                           function(a){
		                            return cont([0, [0, max$0(c1$0, c1), c2$0], a]);
		                           })
		                        : caml_exact_trampoline_cps_call$1
		                          (inter,
		                           l$0,
		                           r,
		                           function(a){return cont([0, [0, max$0(c1$0, c1), c2], a]);});
		               }
		               function diff(l$1, l$2){
		                var l$0 = l$1, l = l$2;
		                for(;;){
		                 if(! l) return l$0;
		                 if(! l$0) return 0;
		                 var
		                  r = l[2],
		                  a = l[1],
		                  c2 = a[2],
		                  c1 = a[1],
		                  r$0 = l$0[2],
		                  a = l$0[1],
		                  c2$0 = a[2],
		                  c1$0 = a[1];
		                 if(c2$0 < c1) return [0, [0, c1$0, c2$0], diff(r$0, l)];
		                 if(c2 < c1$0)
		                  l = r;
		                 else {
		                  var r$1 = c2 < c2$0 ? [0, [0, c2 + 1 | 0, c2$0], r$0] : r$0;
		                  if(c1$0 < c1)
		                   return [0, [0, c1$0, c1 - 1 | 0], diff(r$1, r)];
		                  l$0 = r$1;
		                  l = r;
		                 }
		                }
		               }
		               function single(c, cont){return cont([0, [0, c, c], 0]);}
		               var single$0 = caml_callback(make$13, [257, single]);
		               function add$10(c, l, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (union$3, single$0(c), l, cont);
		               }
		               function offset(o, l){
		                if(! l) return 0;
		                var r = l[2], match = l[1], c2 = match[2], c1 = match[1];
		                return [0, [0, c1 + o | 0, c2 + o | 0], offset(o, r)];
		               }
		               function hash_rec(a){
		                if(! a) return 0;
		                var r = a[2], a = a[1], j = a[2], i = a[1];
		                return (i + (13 * j | 0) | 0) + (257 * hash_rec(r) | 0) | 0;
		               }
		               function compare$49(a, param, cont){
		                var
		                 l2$1 = param[2],
		                 j = param[1],
		                 l1$1 = a[2],
		                 i = a[1],
		                 c$0 = caml_int_compare(i, j);
		                if(0 !== c$0) return cont(c$0);
		                var l1 = l1$1, l2 = l2$1;
		                for(;;){
		                 if(! l1) return l2 ? cont(-1) : cont(0);
		                 var l1$0 = l1[2], a1 = l1[1];
		                 if(! l2) return cont(1);
		                 var
		                  l2$0 = l2[2],
		                  a2 = l2[1],
		                  y = a2[2],
		                  x$0 = a2[1],
		                  y$0 = a1[2],
		                  x$1 = a1[1],
		                  x = caml_int_compare(x$1, x$0),
		                  c = 0 === x ? caml_int_compare(y$0, y) : x;
		                 if(0 !== c) return cont(c);
		                 l1 = l1$0;
		                 l2 = l2$0;
		                }
		               }
		               var CSetMap = k([0, compare$49]);
		               function cseq(c$0, c){
		                return caml_lessequal(c$0, c)
		                        ? [0, [0, c$0, c], 0]
		                        : [0, [0, c, c$0], 0];
		               }
		               var
		                e = [0, cseq(216, 222), 0],
		                e = [0, cseq(192, 214), e],
		                ts$0 = [0, cseq(65, 90), e],
		                empty$16 = 0,
		                upper = caml_callback(fold_left, [union$3, empty$16, ts$0]),
		                clower = offset(32, upper),
		                cdigit = cseq(48, 57),
		                ascii = cseq(0, 127);
		               function cadd(c, s, cont){
		                return caml_exact_trampoline_cps_call$1(add$10, c, s, cont);
		               }
		               var
		                space = caml_callback(add$10, [32, cseq(9, 13)]),
		                e = [0, cseq(65, 70), 0],
		                ts$1 = [0, cdigit, [0, cseq(97, 102), e]],
		                xdigit$0 = caml_callback(fold_left, [union$3, empty$16, ts$1]),
		                calpha =
		                  caml_callback
		                   (fold_right,
		                    [cadd, qv, caml_callback(union$3, [clower, upper])]),
		                calnum = caml_callback(union$3, [calpha, cdigit]),
		                cword = caml_callback(add$10, [95, calnum]),
		                notnl = diff(cany, single$0(10)),
		                nl$0 = single$0(10);
		               function set$5(str, cont){
		                var a = caml_ml_string_length(str) - 1 | 0;
		                function c(s){return cont(s);}
		                function b(s, i){
		                 var i$0 = caml_string_get(str, i);
		                 return caml_exact_trampoline_cps_call$1
		                         (union$3,
		                          single$0(i$0),
		                          s,
		                          function(d){
		                           var e = i + 1 | 0;
		                           return a !== i ? caml_exact_trampoline_call2(b, d, e) : c(d);
		                          });
		                }
		                return a < 0 ? c(empty$16) : b(empty$16, 0);
		               }
		               var
		                blank = caml_callback(set$5, ["\t "]),
		                e = [0, cseq(248, 255), 0],
		                e = [0, cseq(223, 246), e],
		                e = [0, single$0(181), e],
		                ts$2 = [0, cseq(97, 122), e],
		                lower$0 = caml_callback(fold_left, [union$3, empty$16, ts$2]),
		                e = [0, single$0(186), 0],
		                ts$3 = [0, lower$0, [0, upper, [0, single$0(170), e]]],
		                alpha$1 = caml_callback(fold_left, [union$3, empty$16, ts$3]),
		                alnum$1 =
		                  caml_callback
		                   (fold_left,
		                    [union$3, empty$16, [0, alpha$1, [0, cdigit, 0]]]),
		                ts$4 = [0, alnum$1, [0, single$0(95), 0]],
		                wordc$0 = caml_callback(fold_left, [union$3, empty$16, ts$4]),
		                e = [0, cseq(127, 159), 0],
		                ts$5 = [0, cseq(0, 31), e],
		                cntrl$0 = caml_callback(fold_left, [union$3, empty$16, ts$5]),
		                e = [0, cseq(160, 255), 0],
		                ts$6 = [0, cseq(33, 126), e],
		                graph$0 = caml_callback(fold_left, [union$3, empty$16, ts$6]),
		                e = [0, cseq(160, 255), 0],
		                ts$7 = [0, cseq(32, 126), e],
		                print$0 = caml_callback(fold_left, [union$3, empty$16, ts$7]),
		                e = [0, single$0(247), 0],
		                e = [0, single$0(215), e],
		                e = [0, cseq(187, 191), e],
		                e = [0, cseq(182, 185), e],
		                e = [0, cseq(171, 180), e],
		                e = [0, cseq(160, 169), e],
		                e = [0, cseq(123, 126), e],
		                e = [0, cseq(91, 96), e],
		                e = [0, cseq(58, 64), e],
		                ts$8 = [0, cseq(33, 47), e],
		                punct$0 = caml_callback(fold_left, [union$3, empty$16, ts$8]);
		               function length$13(t){return caml_ml_bytes_length(t) / 8 | 0;}
		               function unsafe_get(t, i){
		                return caml_int64_to_int32(caml_bytes_get64(t, i * 8 | 0));
		               }
		               function unsafe_set$0(t, i, x){
		                caml_bytes_set64(t, i * 8 | 0, caml_int64_of_int32(x));
		               }
		               function make_absent(len){return make(len * 8 | 0, 255);}
		               var x$8 = make_absent(1);
		               if(unsafe_get(x$8, 0) !== -1){
		                d = caml_pop_trap();
		                return d
		                        (caml_maybe_attach_backtrace([0, Assert_failure, bNI], 1));
		               }
		               function index_of_offset(slots, index, i){
		                var i$0 = index + i[1] | 0;
		                return slots <= i$0 ? i$0 - slots | 0 : i$0;
		               }
		               function bPY(t, x){
		                var
		                 hash = caml_hash(10, 100, 0, x),
		                 slots = length$13(t[1]),
		                 index = hash & (slots - 1 | 0),
		                 inserting = 1,
		                 i = [0, 0];
		                for(;;){
		                 if(! inserting){t[2] = t[2] + 1 | 0; return;}
		                 var
		                  idx = index_of_offset(slots, index, i),
		                  elem = unsafe_get(t[1], idx);
		                 if(elem === -1){
		                  unsafe_set$0(t[1], idx, x);
		                  inserting = 0;
		                 }
		                 else
		                  i[1]++;
		                }
		               }
		               function add$11(t$0, x, cont){
		                if(is_none(t$0[1])){
		                 var t = caml_create_bytes(0), a = length$13(t) - 1 | 0;
		                 if(a >= 0){
		                  var i = 0;
		                  for(;;){
		                   unsafe_set$0(t, i, -1);
		                   var b = i + 1 | 0;
		                   if(a === i) break;
		                   i = b;
		                  }
		                 }
		                 t$0[1] = [0, [0, t, 0]];
		                }
		                return caml_exact_trampoline_cps_call
		                        (get,
		                         t$0[1],
		                         function(t){
		                          var slots = length$13(t[1]), a = slots === 0;
		                          if(a)
		                           ;
		                          else {
		                           var x$0 = t[2], a = 0 < x$0;
		                           if(a) var x$1 = caml_div(slots, t[2]), a = x$1 < 2;
		                          }
		                          if(a){
		                           var
		                            old_table = t[1],
		                            slots$0 = length$13(old_table),
		                            b = slots$0 === 0 ? 1 : slots$0 << 1,
		                            table = make_absent(b);
		                           t[1] = table;
		                           b = slots$0 - 1 | 0;
		                           if(b >= 0){
		                            var i = 0;
		                            for(;;){
		                             var elem = unsafe_get(old_table, i);
		                             if(elem !== -1) bPY(t, elem);
		                             var c = i + 1 | 0;
		                             if(b === i) break;
		                             i = c;
		                            }
		                           }
		                          }
		                          return cont(bPY(t, x));
		                         });
		               }
		               function mem$6(t, x, cont){
		                var t$0 = t[1];
		                function a(){return cont(0);}
		                return is_none(t$0)
		                        ? a()
		                        : caml_exact_trampoline_cps_call
		                          (get,
		                           t$0,
		                           function(b){
		                            return b[2] === 0
		                                    ? a()
		                                    : caml_exact_trampoline_cps_call
		                                      (get,
		                                       t$0,
		                                       function(t){
		var
		 hash = caml_hash(10, 100, 0, x),
		 slots = length$13(t[1]),
		 index = hash & (slots - 1 | 0),
		 found = 0,
		 i = [0, 0];
		for(;;){
		 if(! found){
		  var x$0 = i[1];
		  if(x$0 < slots){
		   var
		    idx = index_of_offset(slots, index, i),
		    elem = unsafe_get(t[1], idx);
		   if(elem === x){found = 1; continue;}
		   if(elem === -1){i[1] = slots; continue;}
		   i[1]++;
		   continue;
		  }
		 }
		 return cont(found);
		}
		                                       });
		                           });
		               }
		               function compare$50(x, y, cont){
		                return cont(caml_int_compare(x, y));
		               }
		               var
		                Set = u([0, compare$50]),
		                empty$17 = Set[1],
		                add$12 = Set[2],
		                equal$34 = Set[32];
		               function hash_combine(h, accu){
		                return (accu * 65599 | 0) + h | 0;
		               }
		               function mk(ids, def){ids[1]++; return [0, ids[1], def];}
		               function eps(ids){return mk(ids, 0);}
		               function mark(ids, m){return mk(ids, [4, m]);}
		               function before(ids, c){return mk(ids, [6, c]);}
		               function after(ids, c){return mk(ids, [7, c]);}
		               function alt$0(ids, l){
		                if(! l) return mk(ids, bs);
		                if(l[2]) return mk(ids, [1, l]);
		                var c = l[1];
		                return c;
		               }
		               function seq$0(ids, kind, x, y){
		                var a = x[2], match = y[2];
		                if(typeof a !== "number" && 1 === a[0] && ! a[1]) return x;
		                if(typeof match !== "number" && 1 === match[0] && ! match[1])
		                 return y;
		                if(typeof a === "number") return y;
		                if(typeof match === "number" && caml_equal(kind, 332064784))
		                 return x;
		                return mk(ids, [2, kind, x, y]);
		               }
		               function is_eps(expr){
		                return typeof expr[2] === "number" ? 1 : 0;
		               }
		               function rename(ids, x, cont){
		                var match = x[2];
		                if(typeof match !== "number")
		                 switch(match[0]){
		                   case 1:
		                    var l = match[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (map$0,
		                             function(a, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (rename, ids, a, cont);
		                             },
		                             l,
		                             function(a){return cont(mk(ids, [1, a]));});
		                   case 2:
		                    var z = match[3], y = match[2], k = match[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (rename,
		                             ids,
		                             z,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (rename,
		                                       ids,
		                                       y,
		                                       function(b){return cont(mk(ids, [2, k, b, a]));});
		                             });
		                   case 3:
		                    var y$0 = match[3], k$0 = match[2], g = match[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (rename,
		                             ids,
		                             y$0,
		                             function(a){return cont(mk(ids, [3, g, k$0, a]));});
		                 }
		                return cont(mk(ids, x[2]));
		               }
		               function equal$35(a, t, cont){
		                var
		                 pmarks = a[2],
		                 marks = a[1],
		                 l2 = t[1],
		                 l2$1 = l2,
		                 l1$0 = marks;
		                for(;;){
		                 a:
		                 {
		                  if(l1$0){
		                   if(l2$1){
		                    var
		                     l2$0 = l2$1[2],
		                     a2 = l2$1[1],
		                     l1 = l1$0[2],
		                     a1 = l1$0[1],
		                     y = a2[2],
		                     x = a2[1],
		                     y$0 = a1[2],
		                     x$0 = a1[1],
		                     a = x$0 === x ? 1 : 0,
		                     a = a ? y$0 === y ? 1 : 0 : a;
		                    if(a){l2$1 = l2$0; l1$0 = l1; continue;}
		                    break a;
		                   }
		                  }
		                  else if(! l2$1){a = 1; break a;}
		                  a = 0;
		                 }
		                 return a
		                         ? caml_exact_trampoline_cps_call$1
		                           (equal$34, pmarks, t[2], cont)
		                         : cont(a);
		                }
		               }
		               function hash$16(m, accu){
		                var
		                 x = m[2],
		                 init = hash_combine(caml_hash(10, 100, 0, x), accu),
		                 l = m[1],
		                 l$1 = l,
		                 accu$0 = init;
		                for(;;){
		                 if(! l$1) return accu$0;
		                 var
		                  l$0 = l$1[2],
		                  a = l$1[1],
		                  i = a[2],
		                  a$0 = a[1],
		                  accu$1 = hash_combine(a$0, hash_combine(i, accu$0));
		                 l$1 = l$0;
		                 accu$0 = accu$1;
		                }
		               }
		               function marks_set_idx(idx, marks){
		                if(! marks) return 0;
		                var
		                 rem = marks[2],
		                 match = marks[1],
		                 idx$0 = match[2],
		                 a = match[1];
		                return idx$0 === -1
		                        ? [0, [0, a, idx], marks_set_idx(idx, rem)]
		                        : marks;
		               }
		               function marks_set_idx$0(marks, idx){
		                var a = marks[2];
		                return [0, marks_set_idx(idx, marks[1]), a];
		               }
		               function equal_list(l1, l2, cont){
		                function a(l1$0, l2$0){
		                 if(l1$0){
		                  if(l2$0){
		                   var
		                    l2 = l2$0[2],
		                    a2 = l2$0[1],
		                    l1 = l1$0[2],
		                    a1 = l1$0[1],
		                    b =
		                      function(b){
		                       return b ? caml_exact_trampoline_call2(a, l1, l2) : cont(b);
		                      };
		                   switch(a1[0]){
		                     case 0:
		                      var e1$0 = a1[3], l1$1 = a1[2];
		                      if(0 === a2[0]){
		                       var
		                        e2$0 = a2[3],
		                        l2$1 = a2[2],
		                        c = e1$0[1] === e2$0[1] ? 1 : 0;
		                       return c
		                               ? caml_exact_trampoline_cps_call$1
		                                 (equal_list, l1$1, l2$1, b)
		                               : b(c);
		                      }
		                      break;
		                     case 1:
		                      var e1 = a1[2], marks1$0 = a1[1];
		                      if(1 === a2[0]){
		                       var
		                        e2 = a2[2],
		                        marks2$0 = a2[1],
		                        c = e1[1] === e2[1] ? 1 : 0;
		                       return c
		                               ? caml_exact_trampoline_cps_call$1
		                                 (equal$35, marks1$0, marks2$0, b)
		                               : b(c);
		                      }
		                      break;
		                     default:
		                      var marks1 = a1[1];
		                      if(2 === a2[0]){
		                       var marks2 = a2[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (equal$35, marks1, marks2, b);
		                      }
		                   }
		                   return b(0);
		                  }
		                 }
		                 else if(! l2$0) return cont(1);
		                 return cont(0);
		                }
		                return a(l1, l2);
		               }
		               var letrec_function_context$29 = [];
		               function hash_list(l, init, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_left, letrec_function_context$29[1], init, l, cont);
		               }
		               function f$6(accu, x$0, cont){
		                switch(x$0[0]){
		                  case 0:
		                   var e = x$0[3], l = x$0[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (hash_list,
		                            l,
		                            accu,
		                            function(a){
		                             var x = e[1];
		                             return cont(hash_combine(388635598, hash_combine(x, a)));
		                            });
		                  case 1:
		                   var
		                    e$0 = x$0[2],
		                    marks = x$0[1],
		                    a = hash$16(marks, accu),
		                    x = e$0[1];
		                   return cont(hash_combine(726404471, hash_combine(x, a)));
		                  default:
		                   var marks$0 = x$0[1];
		                   return cont(hash_combine(471882453, hash$16(marks$0, accu)));
		                }
		               }
		               caml_update_dummy(letrec_function_context$29, [0, f$6]);
		               function tseq(kind, x, y, rem){
		                a:
		                if(x){
		                 var a = x[1];
		                 if(1 === a[0] && typeof a[2][2] === "number" && ! x[2]){var marks = a[1], a = [0, [1, marks, y], 0]; break a;}
		                 a = [0, [0, kind, x, y], 0];
		                }
		                else
		                 a = 0;
		                return symbol(a, rem);
		               }
		               function fold_right$4(t, init, f, cont){
		                if(! t) return cont(init);
		                var xs = t[2], x = t[1];
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$4,
		                         xs,
		                         init,
		                         f,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1(f, x, a, cont);
		                         });
		               }
		               function iter_marks(t, f, cont){
		                function a(param){
		                 if(! param) return cont();
		                 var l = param[2], a$0 = param[1];
		                 if(0 === a$0[0]){
		                  var l$0 = a$0[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (iter_marks,
		                           l$0,
		                           f,
		                           function(b){return caml_exact_trampoline_call1(a, l);});
		                 }
		                 var marks = a$0[1];
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          marks,
		                          function(b){return caml_exact_trampoline_call1(a, l);});
		                }
		                return a(t);
		               }
		               function first_match(a){
		                for(;;){
		                 if(! a) return 0;
		                 var match = a[1];
		                 if(2 === match[0]){var marks = match[1]; return [0, marks];}
		                 var r = a[2];
		                 a = r;
		                }
		               }
		               function remove_matches(t){
		                return find_all
		                        (function(param){return 2 === param[0] ? 0 : 1;}, t);
		               }
		               function set_idx(idx, xs, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$0,
		                         function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var x = param[3], l = param[2], kind = param[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (set_idx,
		                                      idx,
		                                      l,
		                                      function(a){return cont([0, kind, a, x]);});
		                            case 1:
		                             var x$0 = param[2], marks = param[1];
		                             return cont([1, marks_set_idx$0(marks, idx), x$0]);
		                            default:
		                             var marks$0 = param[1];
		                             return cont([2, marks_set_idx$0(marks$0, idx)]);
		                          }
		                         },
		                         xs,
		                         cont);
		               }
		               function add_match(t, marks){return [0, [2, marks], t];}
		               function loop$0(seen, l, y, cont){
		                function a(l){
		                 if(! l) return cont(0);
		                 var x = l[1];
		                 switch(x[0]){
		                   case 0:
		                    var r = l[2], x$0 = x[3], l$0 = x[2], kind = x[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (loop$0,
		                             seen,
		                             l$0,
		                             x$0,
		                             function(l){
		                              return caml_exact_trampoline_cps_call$0
		                                      (loop$0,
		                                       seen,
		                                       r,
		                                       y,
		                                       function(r){return cont(tseq(kind, l, x$0, r));});
		                             });
		                   case 1:
		                    if(typeof x[2][2] === "number"){
		                     var r$0 = l[2];
		                     return caml_exact_trampoline_cps_call$1
		                             (mem$6,
		                              seen,
		                              y[1],
		                              function(b){
		                               return b
		                                       ? caml_exact_trampoline_call1(a, r$0)
		                                       : caml_exact_trampoline_cps_call$1
		 (add$11,
		  seen,
		  y[1],
		  function(a){
		   return caml_exact_trampoline_cps_call$0
		           (loop$0, seen, r$0, y, function(a){return cont([0, x, a]);});
		  });
		                              });
		                    }
		                    var r$1 = l[2], x$1 = x[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (mem$6,
		                             seen,
		                             x$1[1],
		                             function(b){
		                              return b
		                                      ? caml_exact_trampoline_call1(a, r$1)
		                                      : caml_exact_trampoline_cps_call$1
		(add$11,
		 seen,
		 x$1[1],
		 function(a){
		  return caml_exact_trampoline_cps_call$0
		          (loop$0, seen, r$1, y, function(a){return cont([0, x, a]);});
		 });
		                             });
		                   default: return cont([0, x, 0]);
		                 }
		                }
		                return a(l);
		               }
		               function mk$0(idx, cat, desc, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (hash_list,
		                         desc,
		                         hash_combine(idx, hash_combine(cat, 0)),
		                         function(a){
		                          return cont([0, idx, cat, desc, 0, a & 1073741823]);
		                         });
		               }
		               function equal$36(a, t, cont){
		                var
		                 desc = a[3],
		                 category = a[2],
		                 idx = a[1],
		                 hash = a[5],
		                 a = hash === t[5] ? 1 : 0;
		                if(a){
		                 a = idx === t[1] ? 1 : 0;
		                 if(a){
		                  var y = t[2], a = category === y ? 1 : 0;
		                  if(a)
		                   return caml_exact_trampoline_cps_call$1
		                           (equal_list, desc, t[3], cont);
		                 }
		                }
		                return cont(a);
		               }
		               function status_no_mutex(s){
		                var b = s[4];
		                if(b){var s$0 = b[1]; return s$0;}
		                b = s[3];
		                if(b){
		                 b = b[1];
		                 if(2 === b[0]){
		                  var
		                   m = b[1],
		                   marks = m[1],
		                   l$1 = marks,
		                   accu = -1,
		                   b = m[2];
		                  for(;;){
		                   if(! l$1) break;
		                   var
		                    l$0 = l$1[2],
		                    a$0 = l$1[1],
		                    i$0 = a$0[1],
		                    accu$0 = max$0(accu, i$0);
		                   l$1 = l$0;
		                   accu = accu$0;
		                  }
		                  var
		                   len = 1 + accu | 0,
		                   t = caml_make_vect(len, -1),
		                   param = marks;
		                  for(;;){
		                   if(! param){var st = [0, t, b]; break;}
		                   var l = param[2], a = param[1], v = a[2], i = a[1];
		                   caml_check_bound(t, i)[i + 1] = v;
		                   param = l;
		                  }
		                 }
		                 else
		                  st = 1;
		                }
		                else
		                 st = 0;
		                s[4] = [0, st];
		                return st;
		               }
		               function hash$17(t){return t[5];}
		               function seeded_hash(seed, x){return hash$17(x);}
		               function key_index$0(h, key, cont){
		                var a = h[2].length - 2 | 0;
		                return cont(seeded_hash(dummy, key) & a);
		               }
		               function add$2(h, key, data, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (key_index$0,
		                         h,
		                         key,
		                         function(i){
		                          var
		                           bucket = [0, key, data, caml_check_bound(h[2], i)[i + 1]];
		                          caml_check_bound(h[2], i)[i + 1] = bucket;
		                          h[1] = h[1] + 1 | 0;
		                          var a = h[2].length - 1 << 1 < h[1] ? 1 : 0;
		                          return a
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (resize$0, key_index$0, h, cont)
		                                  : cont(a);
		                         });
		               }
		               function find$0(h, key, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (key_index$0,
		                         h,
		                         key,
		                         function(a){
		                          a = caml_check_bound(h[2], a)[a + 1];
		                          if(a){
		                           var k1 = a[1], d1 = a[2], next1 = a[3];
		                           return caml_exact_trampoline_cps_call$1
		                                   (equal$36,
		                                    key,
		                                    k1,
		                                    function(a){
		                                     if(a) return cont(d1);
		                                     if(next1){
		                                      var k2 = next1[1], d2 = next1[2], next2 = next1[3];
		                                      return caml_exact_trampoline_cps_call$1
		      (equal$36,
		       key,
		       k2,
		       function(a){
		        if(a) return cont(d2);
		        if(next2){
		         var k3 = next2[1], d3 = next2[2], next3 = next2[3];
		         return caml_exact_trampoline_cps_call$1
		                 (equal$36,
		                  key,
		                  k3,
		                  function(b){
		                   function a(b){
		                    if(b){
		                     var k = b[1], data = b[2], next = b[3];
		                     return caml_exact_trampoline_cps_call$1
		                             (equal$36,
		                              key,
		                              k,
		                              function(b){
		                               return b ? cont(data) : caml_exact_trampoline_call1(a, next);
		                              });
		                    }
		                    b = caml_pop_trap();
		                    var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                    return b(Not_found$0);
		                   }
		                   return b ? cont(d3) : a(next3);
		                  });
		        }
		        a = caml_pop_trap();
		        var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		        return a(Not_found$0);
		       });
		                                     }
		                                     a = caml_pop_trap();
		                                     var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                                     return a(Not_found$0);
		                                    });
		                          }
		                          a = caml_pop_trap();
		                          var Not_found$0 = caml_maybe_attach_backtrace(Not_found, 1);
		                          return a(Not_found$0);
		                         });
		               }
		               function create(sz, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create$5, dq, sz, cont);
		               }
		               var unknown = -1, eps_expr = [0, 0, 0], empty$19 = 0;
		               function delta_expr(ctx, marks, x, rem$0, cont){
		                var c = ctx[1], a = x[2];
		                if(typeof a === "number")
		                 return cont(add_match(rem$0, marks));
		                switch(a[0]){
		                  case 0:
		                   var s$0 = a[1], s = s$0;
		                   for(;;){
		                    if(s){
		                     var rem = s[2], a = s[1], c2 = a[2], c1 = a[1];
		                     if(c > c2){s = rem; continue;}
		                     a = c1 <= c;
		                    }
		                    else
		                     a = 0;
		                    return a
		                            ? cont([0, [1, marks, eps_expr], rem$0])
		                            : cont(rem$0);
		                   }
		                  case 1:
		                   var l = a[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (fold_right,
		                            function(a, b, cont){
		                             return caml_exact_trampoline_cps_call$2
		                                     (delta_expr, ctx, marks, a, b, cont);
		                            },
		                            l,
		                            rem$0,
		                            cont);
		                  case 2:
		                   var z = a[3], y = a[2], kind = a[1];
		                   return caml_exact_trampoline_cps_call$2
		                           (delta_expr,
		                            ctx,
		                            marks,
		                            y,
		                            empty$19,
		                            function(y){
		                             return caml_exact_trampoline_cps_call$3
		                                     (delta_seq, ctx, kind, y, z, rem$0, cont);
		                            });
		                  case 3:
		                   var y$0 = a[3], kind$0 = a[2], rep_kind = a[1];
		                   return caml_exact_trampoline_cps_call$2
		                           (delta_expr,
		                            ctx,
		                            marks,
		                            y$0,
		                            empty$19,
		                            function(y){
		                             var match = first_match(y);
		                             if(match)
		                              var
		                               marks$0 = match[1],
		                               marks$1 = marks$0,
		                               y$0 = remove_matches(y);
		                             else {marks$1 = marks; y$0 = y;}
		                             return 620821490 <= rep_kind
		                                     ? cont(add_match(tseq(kind$0, y$0, x, rem$0), marks))
		                                     : cont(tseq(kind$0, y$0, x, add_match(rem$0, marks$1)));
		                            });
		                  case 4:
		                   var i = a[1], a = marks[2];
		                   return cont
		                           (add_match
		                             (rem$0,
		                              [0, [0, [0, i, unknown], remove_assq(i, marks[1])], a]));
		                  case 5:
		                   var
		                    stop_inclusive = a[2],
		                    start_inclusive = a[1],
		                    a = marks[2];
		                   return cont
		                           (add_match
		                             (rem$0,
		                              [0,
		                               find_all
		                                (function(a){
		                                  var i = a[1], a = i < start_inclusive ? 1 : 0;
		                                  return a ? a : stop_inclusive < i ? 1 : 0;
		                                 },
		                                 marks[1]),
		                               a]));
		                  case 6:
		                   var cat = a[1];
		                   return intersect(ctx[3], cat)
		                           ? cont(add_match(rem$0, marks))
		                           : cont(rem$0);
		                  case 7:
		                   var cat$0 = a[1];
		                   return intersect(ctx[2], cat$0)
		                           ? cont(add_match(rem$0, marks))
		                           : cont(rem$0);
		                  default:
		                   var i$0 = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (add$12,
		                            i$0,
		                            marks[2],
		                            function(a){
		                             return cont(add_match(rem$0, [0, marks[1], a]));
		                            });
		                }
		               }
		               function delta_seq(ctx, kind, y$1, z, rem, cont){
		                var a = first_match(y$1);
		                if(! a) return cont(tseq(kind, y$1, z, rem));
		                var marks = a[1];
		                if(-730718166 === kind)
		                 return caml_exact_trampoline_cps_call$2
		                         (delta_expr,
		                          ctx,
		                          marks,
		                          z,
		                          rem,
		                          function(a){
		                           return cont(tseq(kind, remove_matches(y$1), z, a));
		                          });
		                if(332064784 > kind)
		                 return caml_exact_trampoline_cps_call$2
		                         (delta_expr,
		                          ctx,
		                          marks,
		                          z,
		                          tseq(kind, remove_matches(y$1), z, rem),
		                          cont);
		                var l = 0, a = y$1;
		                for(;;){
		                 if(! a){
		                  a = caml_pop_trap();
		                  return a
		                          (caml_maybe_attach_backtrace([0, Assert_failure, qw], 1));
		                 }
		                 var x = a[1];
		                 if(2 === x[0]) break;
		                 var r = a[2], l$0 = [0, x, l];
		                 l = l$0;
		                 a = r;
		                }
		                var r$0 = a[2], y = remove_matches(r$0), y$0 = rev(l);
		                return caml_exact_trampoline_cps_call$2
		                        (delta_expr,
		                         ctx,
		                         marks,
		                         z,
		                         tseq(kind, y, z, rem),
		                         function(a){return cont(tseq(kind, y$0, z, a));});
		               }
		               function delta_desc(ctx, marks, l, rem, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_right$4,
		                         l,
		                         rem,
		                         function(expr, acc, cont){
		                          switch(expr[0]){
		                            case 0:
		                             var z = expr[3], y = expr[2], kind = expr[1];
		                             return caml_exact_trampoline_cps_call$2
		                                     (delta_desc,
		                                      ctx,
		                                      dummy,
		                                      y,
		                                      empty$19,
		                                      function(y){
		                                       return caml_exact_trampoline_cps_call$3
		       (delta_seq, ctx, kind, y, z, acc, cont);
		                                      });
		                            case 1:
		                             var e = expr[2], marks = expr[1];
		                             return caml_exact_trampoline_cps_call$2
		                                     (delta_expr, ctx, marks, e, acc, cont);
		                            default: return cont([0, expr, acc]);
		                          }
		                         },
		                         cont);
		               }
		               function split$5(t$0, set){
		                var t = set;
		                for(;;){
		                 if(! t) return;
		                 var xs = t[2], match = t[1], y = match[2], x = match[1];
		                 caml_bytes_set(t$0, x, 1);
		                 caml_bytes_set(t$0, y + 1 | 0, 1);
		                 t = xs;
		                }
		               }
		               function equal$37(cset, x1$4, x2$4){
		                a:
		                {
		                 b:
		                 {
		                  c:
		                  {
		                   var x1 = x1$4, x2 = x2$4;
		                   d:
		                   for(;;){
		                    if(typeof x1 === "number") break b;
		                    switch(x1[0]){
		                      case 0:
		                       if(typeof x2 === "number") break a;
		                       if(0 !== x2[0]) break a;
		                       var s2 = x2[1], s1 = x1[1];
		                       return cset(s1, s2);
		                      case 1:
		                       break c;
		                      case 2:
		                       break d;
		                      case 3:
		                       if(typeof x2 === "number") break a;
		                       if(3 !== x2[0]) break a;
		                       var
		                        j2 = x2[3],
		                        i2 = x2[2],
		                        x2$0 = x2[1],
		                        j1 = x1[3],
		                        i1 = x1[2],
		                        x1$0 = x1[1],
		                        a = i1 === i2 ? 1 : 0;
		                       if(a){
		                        e:
		                        {
		                         if(j1){
		                          if(j2){
		                           var v1 = j2[1], v0 = j1[1], a = v0 === v1 ? 1 : 0;
		                           break e;
		                          }
		                         }
		                         else if(! j2){a = 1; break e;}
		                         a = 0;
		                        }
		                        if(a){x1 = x1$0; x2 = x2$0; break;}
		                       }
		                       return a;
		                      case 4:
		                       if(typeof x2 === "number") break a;
		                       if(4 === x2[0]) return 0;
		                       break a;
		                      case 6:
		                       if(typeof x2 === "number") break a;
		                       if(6 !== x2[0]) break a;
		                       var x2$1 = x2[1], x1$1 = x1[1];
		                       x1 = x1$1;
		                       x2 = x2$1;
		                       break;
		                      case 7:
		                       if(typeof x2 === "number") break a;
		                       if(7 !== x2[0]) break a;
		                       var
		                        r2 = x2[2],
		                        m2 = x2[1],
		                        r1 = x1[2],
		                        m1 = x1[1],
		                        a = m1 === m2 ? 1 : 0;
		                       if(! a) return a;
		                       x1 = r1;
		                       x2 = r2;
		                       break;
		                      case 8:
		                       if(typeof x2 === "number") break a;
		                       if(8 !== x2[0]) break a;
		                       var
		                        x2$2 = x2[2],
		                        sem = x2[1],
		                        x1$2 = x1[2],
		                        sem$0 = x1[1],
		                        a = caml_equal(sem$0, sem);
		                       if(! a) return a;
		                       x1 = x1$2;
		                       x2 = x2$2;
		                       break;
		                      case 9:
		                       if(typeof x2 === "number") break a;
		                       if(9 !== x2[0]) break a;
		                       var
		                        x2$3 = x2[2],
		                        rep = x2[1],
		                        x1$3 = x1[2],
		                        rep$0 = x1[1],
		                        a = caml_equal(rep$0, rep);
		                       if(! a) return a;
		                       x1 = x1$3;
		                       x2 = x2$3;
		                       break;
		                      default: break a;
		                    }
		                   }
		                   if(typeof x2 === "number") break a;
		                   if(2 !== x2[0]) break a;
		                   var l2$0 = x2[1], l1$0 = x1[1], l2$2 = l2$0, l1$2 = l1$0;
		                   for(;;){
		                    if(l1$2){
		                     if(l2$2){
		                      var
		                       l2$1 = l2$2[2],
		                       a2 = l2$2[1],
		                       l1$1 = l1$2[2],
		                       a1 = l1$2[1],
		                       a = equal$37(cset, a1, a2);
		                      if(! a) return a;
		                      l2$2 = l2$1;
		                      l1$2 = l1$1;
		                      continue;
		                     }
		                    }
		                    else if(! l2$2) return 1;
		                    return 0;
		                   }
		                  }
		                  if(typeof x2 === "number") break a;
		                  if(1 !== x2[0]) break a;
		                  var
		                   y = x2[1],
		                   x = x1[1],
		                   l2 = y[1],
		                   l1 = x[1],
		                   l2$4 = l2,
		                   l1$4 = l1;
		                  for(;;){
		                   if(l1$4){
		                    if(l2$4){
		                     var
		                      l2$3 = l2$4[2],
		                      a2$0 = l2$4[1],
		                      l1$3 = l1$4[2],
		                      a1$0 = l1$4[1],
		                      a = equal$37(cset, a1$0, a2$0);
		                     if(! a) return a;
		                     l2$4 = l2$3;
		                     l1$4 = l1$3;
		                     continue;
		                    }
		                   }
		                   else if(! l2$4) return 1;
		                   return 0;
		                  }
		                 }
		                 switch(x1){
		                   case 0:
		                    if(typeof x2 !== "number" || x2) break a; break;
		                   case 1:
		                    if(typeof x2 !== "number" || 1 !== x2) break a; break;
		                   case 2:
		                    if(typeof x2 !== "number" || 2 !== x2) break a; break;
		                   case 3:
		                    if(typeof x2 !== "number" || 3 !== x2) break a; break;
		                   case 4:
		                    if(typeof x2 !== "number" || 4 !== x2) break a; break;
		                   case 5:
		                    if(typeof x2 !== "number" || 5 !== x2) break a; break;
		                   case 6:
		                    if(typeof x2 !== "number" || 6 !== x2) break a; break;
		                   case 7:
		                    if(typeof x2 !== "number" || 7 !== x2) break a; break;
		                   case 8:
		                    if(typeof x2 !== "number" || 8 !== x2) break a; break;
		                   default: if(typeof x2 !== "number" || 9 > x2) break a;
		                 }
		                 return 1;
		                }
		                return 0;
		               }
		               function cset(cset){return [0, [0, cset]];}
		               function handle_case_cset(ign_case$0, b, cont){
		                a:
		                {
		                 b:
		                 {
		                  c:
		                  {
		                   d:
		                   {
		                    var ign_case = ign_case$0;
		                    e:
		                    for(;;)
		                     switch(b[0]){
		                       case 0:
		                        break a;
		                       case 1:
		                        break b;
		                       case 2:
		                        break c;
		                       case 3:
		                        break d;
		                       default:
		                        b = b[1];
		                        switch(b[0]){
		                          case 0:
		                           break e;
		                          case 1:
		                           var a = b[1]; ign_case = 1; b = a; break;
		                          default: var a$0 = b[1]; ign_case = 0; b = a$0;
		                        }
		                     }
		                    var l$1 = b[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (map$0,
		                             function(a, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (handle_case_cset, ign_case, a, cont);
		                             },
		                             l$1,
		                             function(ts){
		                              return caml_exact_trampoline_cps_call$0
		                                      (fold_left, union$3, empty$16, ts, cont);
		                             });
		                   }
		                   var r = b[2], r$0 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (handle_case_cset,
		                            ign_case,
		                            r,
		                            function(b){
		                             var a = diff(cany, b);
		                             return caml_exact_trampoline_cps_call$1
		                                     (handle_case_cset,
		                                      ign_case,
		                                      r$0,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(inter, b, a, cont);
		                                      });
		                            });
		                  }
		                  var l$0 = b[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$0,
		                           function(a, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (handle_case_cset, ign_case, a, cont);
		                           },
		                           l$0,
		                           function(ts){
		                            return caml_exact_trampoline_cps_call$0
		                                    (fold_left,
		                                     union$3,
		                                     empty$16,
		                                     ts,
		                                     function(a){return cont(diff(cany, a));});
		                           });
		                 }
		                 var l = b[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$0,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (handle_case_cset, ign_case, a, cont);
		                          },
		                          l,
		                          function(ts){
		                           return caml_exact_trampoline_cps_call$0
		                                   (fold_left, inter, cany, ts, cont);
		                          });
		                }
		                var s = b[1];
		                if(! ign_case) return cont(s);
		                return caml_exact_trampoline_cps_call$1
		                        (inter,
		                         s,
		                         clower,
		                         function(b){
		                          var a = [0, offset(-32, b), 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (inter,
		                                   s,
		                                   upper,
		                                   function(b){
		                                    var ts = [0, s, [0, offset(32, b), a]];
		                                    return caml_exact_trampoline_cps_call$0
		    (fold_left, union$3, empty$16, ts, cont);
		                                   });
		                         });
		               }
		               function handle_case(ign_case$0, r$9, cont){
		                a:
		                {
		                 b:
		                 {
		                  c:
		                  {
		                   d:
		                   {
		                    e:
		                    {
		                     f:
		                     {
		                      g:
		                      {
		                       h:
		                       {
		                        i:
		                        {
		                         var ign_case = ign_case$0, r = r$9;
		                         j:
		                         for(;;){
		                          if(typeof r === "number") return cont(r);
		                          switch(r[0]){
		                            case 0:
		                             break a;
		                            case 1:
		                             var match = r[1];
		                             switch(match[0]){
		                               case 0:
		                                break b;
		                               case 1:
		                                var r$0 = match[1]; ign_case = 1; r = r$0; break;
		                               default: var r$1 = match[1]; ign_case = 0; r = r$1;
		                             }
		                             break;
		                            case 2:
		                             break c;
		                            case 3:
		                             break d;
		                            case 4:
		                             break e;
		                            case 5:
		                             break f;
		                            case 6:
		                             break g;
		                            case 7:
		                             break h;
		                            case 8:
		                             break i;
		                            default: break j;
		                          }
		                         }
		                         var r$8 = r[2], k$0 = r[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (handle_case,
		                                  ign_case,
		                                  r$8,
		                                  function(a){return cont([9, k$0, a]);});
		                        }
		                        var r$7 = r[2], k = r[1];
		                        return caml_exact_trampoline_cps_call$1
		                                (handle_case,
		                                 ign_case,
		                                 r$7,
		                                 function(a){return cont([8, k, a]);});
		                       }
		                       var r$6 = r[2], i$0 = r[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (handle_case,
		                                ign_case,
		                                r$6,
		                                function(a){return cont([7, i$0, a]);});
		                      }
		                      var r$5 = r[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (handle_case,
		                               ign_case,
		                               r$5,
		                               function(a){return cont([6, a]);});
		                     }
		                     var r$4 = r[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (handle_case,
		                              ign_case,
		                              r$4,
		                              function(a){return cont([5, a]);});
		                    }
		                    var r$3 = r[2], n = r[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (handle_case,
		                             ign_case,
		                             r$3,
		                             function(a){return cont([4, n, a]);});
		                   }
		                   var j = r[3], i = r[2], r$2 = r[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (handle_case,
		                            ign_case,
		                            r$2,
		                            function(a){return cont([3, a, i, j]);});
		                  }
		                  var l$0 = r[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$0,
		                           function(a, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (handle_case, ign_case, a, cont);
		                           },
		                           l$0,
		                           function(a){return cont([2, a]);});
		                 }
		                 var l = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$0,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (handle_case, ign_case, a, cont);
		                          },
		                          l,
		                          function(l){return cont([1, [0, l]]);});
		                }
		                var s = r[1];
		                return caml_exact_trampoline_cps_call$1
		                        (handle_case_cset,
		                         ign_case,
		                         s,
		                         function(a){return cont([0, a]);});
		               }
		               function seq$1(l){
		                if(l && ! l[2]){var r = l[1]; return r;}
		                return [2, l];
		               }
		               var
		                f$7 =
		                  caml_callback
		                   (make$13,
		                    [256,
		                     function(i, cont){
		                      return caml_exact_trampoline_cps_call
		                              (chr, i, function(i){return cont(cset(single$0(i)));});
		                     }]),
		                any$0 = cset(cany);
		               function as_set_elems(elems, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(exn === Exit) return cont(0);
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call$1
		                        (map$0,
		                         function(param, cont){
		                          if(typeof param !== "number" && 0 === param[0]){var e = param[1]; return cont(e);}
		                          return caml_pop_trap()(Exit);
		                         },
		                         elems,
		                         function(e){caml_pop_trap(); return cont([0, e]);});
		               }
		               var empty$20 = [1, empty_alternative];
		               function alt$1(elems, cont){
		                if(! elems) return cont(empty$20);
		                if(elems[2])
		                 return caml_exact_trampoline_cps_call
		                         (as_set_elems,
		                          elems,
		                          function(match){
		                           if(! match) return cont([1, [0, elems]]);
		                           var elems$0 = match[1];
		                           return cont([0, [4, [0, elems$0]]]);
		                          });
		                var x = elems[1];
		                return cont(x);
		               }
		               var epsilon = seq$1(0);
		               function repn(r, i, j, cont){
		                var cst_Re_repn = "Re.repn";
		                function a(a){
		                 if(j){
		                  var j$0 = j[1];
		                  if(j$0 < i)
		                   return caml_exact_trampoline_cps_call
		                           (invalid_arg, cst_Re_repn, cont);
		                  if(0 === j$0){
		                   if(0 === i) return cont(epsilon);
		                  }
		                  else if(1 === j$0 && 1 === i) return cont(r);
		                 }
		                 return cont([3, r, i, j]);
		                }
		                return i < 0
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg, cst_Re_repn, a)
		                        : a();
		               }
		               function rep(r, cont){
		                return caml_exact_trampoline_cps_call$0(repn, r, 0, 0, cont);
		               }
		               function rep1(r, cont){
		                return caml_exact_trampoline_cps_call$0(repn, r, 1, 0, cont);
		               }
		               function opt(r, cont){
		                return caml_exact_trampoline_cps_call$0(repn, r, 0, qx, cont);
		               }
		               function compl(elems, cont){
		                return caml_exact_trampoline_cps_call
		                        (as_set_elems,
		                         elems,
		                         function(match){
		                          function a(a){return cont([0, [2, a]]);}
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (invalid_arg, "Re.compl", a);
		                          var s = match[1];
		                          return a(s);
		                         });
		               }
		               function no_case(t){
		                if(typeof t !== "number" && 0 === t[0]){var x = t[1]; return [0, [4, [1, x]]];
		                }
		                return [1, [1, t]];
		               }
		               function merge_sequences(a){
		                a:
		                {
		                 b:
		                 for(;;){
		                  if(! a) return 0;
		                  var x = a[1];
		                  if(typeof x === "number") break a;
		                  switch(x[0]){
		                    case 1:
		                     var b = x[1];
		                     if(0 !== b[0]) break a;
		                     var r$0 = a[2], l = b[1];
		                     a = symbol(l, r$0);
		                     break;
		                    case 2:
		                     break b;
		                    default: break a;
		                  }
		                 }
		                 b = x[1];
		                 if(b){
		                  var
		                   r$1 = a[2],
		                   y = b[2],
		                   x$0 = b[1],
		                   r$2 = merge_sequences(r$1);
		                  if(r$2){
		                   a = r$2[1];
		                   if(typeof a !== "number" && 2 === a[0]){
		                    a = a[1];
		                    if(a){
		                     var r$3 = r$2[2], y$0 = a[2], x$1 = a[1];
		                     if(equal$37(equal$33, x$0, x$1)){
		                      a = [0, seq$1(y$0), 0];
		                      return [0,
		                              [2, [0, x$0, [0, [1, [0, [0, seq$1(y), a]]], 0]]],
		                              r$3];
		                     }
		                    }
		                   }
		                  }
		                  return [0, [2, [0, x$0, y]], r$2];
		                 }
		                }
		                var r = a[2];
		                return [0, x, merge_sequences(r)];
		               }
		               function anchored(b){
		                a:
		                {
		                 b:
		                 for(;;){
		                  if(typeof b === "number")
		                   switch(b){case 5:case 8: return 1;}
		                  else
		                   switch(b[0]){
		                     case 1:
		                      var a$1 = b[1];
		                      if(0 === a$1[0]) break a;
		                      var r = a$1[1];
		                      b = r;
		                      continue;
		                     case 2:
		                      break b;
		                     case 3:
		                      var i = b[2], r$0 = b[1], b = 0 < i ? 1 : 0;
		                      if(! b) return b;
		                      b = r$0;
		                      continue;
		                     case 0: break;
		                     case 5:
		                     case 6:
		                      b = b[1]; continue;
		                     default: b = b[2]; continue;
		                   }
		                  return 0;
		                 }
		                 var l$1 = b[1], b = l$1;
		                 for(;;){
		                  if(! b) return 0;
		                  var l$0 = b[2], a$0 = b[1], b = anchored(a$0);
		                  if(b) return b;
		                  b = l$0;
		                 }
		                }
		                var als = a$1[1], b = als;
		                for(;;){
		                 if(! b) return 1;
		                 var l = b[2], a = b[1], b = anchored(a);
		                 if(! b) return b;
		                 b = l;
		                }
		               }
		               function break_idx(t){return (t + 5 | 0) * -1 | 0;}
		               function get_info(param){return param[1];}
		               function follow_transition(param, color){return param[(1 + color | 0) + 1];
		               }
		               function set_transition(param, color, st){
		                var a = 1 + color | 0;
		                caml_check_bound(param, a)[a + 1] = st;
		               }
		               function is_unknown_transition(st, color){
		                var
		                 st$0 = follow_transition(st, color),
		                 info = get_info(st$0),
		                 x = info[1];
		                return x === -2 ? 1 : 0;
		               }
		               function unsafe_set$1(t, idx, pos){t[1][idx + 1] = pos;}
		               function set$6(t, idx, pos$0, cont){
		                function a(a){return cont(unsafe_set$1(t, idx, pos$0));}
		                if(t[2] > idx) return a();
		                for(;;){
		                 t[2] = 2 * t[2] | 0;
		                 if(t[2] > idx){
		                  var pos = t[1];
		                  t[1] = caml_make_vect(t[2], 0);
		                  return caml_exact_trampoline_cps_call$3
		                          (blit$0, pos, 0, t[1], 0, pos.length - 1, a);
		                 }
		                }
		               }
		               var inexistant = 1, letter = 2;
		               function category(re, color){
		                if(color === -1) return inexistant;
		                if(color === re[6]) return 28;
		                var t = re[4], a = caml_string_get(t, color);
		                a:
		                {
		                 if(170 <= a)
		                  if(187 <= a){
		                   a = a - 192 | 0;
		                   if(54 < a >>> 0){
		                    if(56 > a) break a;
		                   }
		                   else if(23 === a) break a;
		                  }
		                  else {a = a - 171 | 0; if(14 >= a >>> 0 && 10 !== a) break a;
		                  }
		                 else if(65 <= a){
		                  a = a - 91 | 0;
		                  if(5 < a >>> 0){
		                   if(32 <= a) break a;
		                  }
		                  else if(4 !== a) break a;
		                 }
		                 else {
		                  if(48 > a){if(10 === a) return 12; break a;}
		                  if(58 <= a) break a;
		                 }
		                 return letter;
		                }
		                return 4;
		               }
		               var
		                unknown_state =
		                  [0, [0, -2, 0, [0, unknown, -1, empty$19, 0, -1]]];
		               function find_state(re, desc, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(exn !== Not_found){
		                    var
		                     a = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return a(exn$0);
		                   }
		                   a = status_no_mutex(desc);
		                   a:
		                   {
		                    if(typeof a === "number" && a){var break_state = 0; break a;
		                    }
		                    break_state = 1;
		                   }
		                   var
		                    idx = desc[1],
		                    a = break_state ? -5 - idx | 0 : idx,
		                    state = [0, a, 0, desc];
		                   if(break_state)
		                    var st$0 = [0, state];
		                   else {
		                    var
		                     ncol = re[5],
		                     st = caml_make_vect(ncol + 1 | 0, unknown_state);
		                    caml_check_bound(st, 0)[1] = state;
		                    st$0 = st;
		                   }
		                   return caml_exact_trampoline_cps_call$0
		                           (add$2, re[8], desc, st$0, function(a){return cont(st$0);});
		                  });
		                return caml_exact_trampoline_cps_call$1
		                        (find$0,
		                         re[8],
		                         desc,
		                         function(a){caml_pop_trap(); return cont(a);});
		               }
		               var empty$18 = [0, 0, empty$17];
		               function delta(re, next_cat, color, st, cont){
		                var
		                 st$0 = st[3],
		                 tbl_ref = re[7],
		                 prev_cat = st$0[2],
		                 ctx = [0, color, prev_cat, next_cat];
		                return caml_exact_trampoline_cps_call$2
		                        (delta_desc,
		                         ctx,
		                         empty$18,
		                         st$0[3],
		                         empty$19,
		                         function(l){
		                          var seen = tbl_ref[2], match = seen[1];
		                          function a(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (loop$0,
		                                    seen,
		                                    l,
		                                    eps_expr,
		                                    function(expr){
		                                     var t = tbl_ref[1];
		                                     return caml_exact_trampoline_cps_call$2
		     (fill,
		      t[2],
		      0,
		      caml_ml_bytes_length(t[2]),
		      0,
		      function(a){
		       var tbl = tbl_ref[1];
		       return caml_exact_trampoline_cps_call$1
		               (iter_marks,
		                expr,
		                function(marks, cont){
		                 function a(b){
		                  if(! b) return cont();
		                  var l = b[2], a$0 = b[1], i = a$0[2];
		                  if(0 > i) return caml_exact_trampoline_call1(a, l);
		                  b = i < 0;
		                  b ||= tbl[1] <= i;
		                  function c(b){
		                   var
		                    i$0 = i >>> 3 | 0,
		                    s$0 = tbl[2],
		                    c = caml_bytes_unsafe_get(s$0, i$0),
		                    mask = 1 << (i & 7),
		                    x = c | mask,
		                    s = tbl[2];
		                   return caml_exact_trampoline_cps_call
		                           (chr,
		                            x,
		                            function(b){
		                             caml_bytes_unsafe_set(s, i$0, b);
		                             return caml_exact_trampoline_call1(a, l);
		                            });
		                  }
		                  return b
		                          ? caml_exact_trampoline_cps_call
		                            (invalid_arg, "Bit_vector.set", c)
		                          : c();
		                 }
		                 return a(marks[1]);
		                },
		                function(b){
		                 var t = tbl_ref[1], len = t[1], tbl = tbl_ref[1];
		                 function a(idx){
		                  function d(){
		                   if(idx === len){
		                    tbl_ref[1] = create_zero$0(2 * len | 0);
		                    set(tbl_ref[3], 2 * len | 0);
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (set_idx,
		                            idx,
		                            expr,
		                            function(expr){
		                             return caml_exact_trampoline_cps_call$0
		                                     (mk$0, idx, next_cat, expr, cont);
		                            });
		                  }
		                  if(idx === len) return d();
		                  var b = idx < 0, b = b || tbl[1] <= idx;
		                  function c(b){
		                   var i = idx >>> 3 | 0, s = tbl[2];
		                   if(0 >= (caml_bytes_unsafe_get(s, i) & 1 << (idx & 7)))
		                    return d();
		                   var idx$0 = idx + 1 | 0;
		                   return caml_exact_trampoline_call1(a, idx$0);
		                  }
		                  return b
		                          ? caml_exact_trampoline_cps_call
		                            (invalid_arg, "Bit_vector.get", c)
		                          : c();
		                 }
		                 return a(0);
		                });
		      });
		                                    });
		                          }
		                          if(! match) return a();
		                          var t = match[1];
		                          t[2] = 0;
		                          var t$0 = t[1];
		                          return caml_exact_trampoline_cps_call$2
		                                  (fill, t$0, 0, caml_ml_bytes_length(t$0), 255, a);
		                         });
		               }
		               function validate(re, s, pos, st, cont){
		                var
		                 c = caml_string_get(s, pos),
		                 t = re[3],
		                 color = caml_string_unsafe_get(t, c);
		                caml_ml_mutex_lock(re[11]);
		                function a(){caml_ml_mutex_unlock(re[11]); return cont();}
		                if(! is_unknown_transition(st, color)) return a();
		                var cat = category(re, color);
		                return caml_exact_trampoline_cps_call$2
		                        (delta,
		                         re,
		                         cat,
		                         color,
		                         get_info(st),
		                         function(desc){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_state,
		                                   re,
		                                   desc,
		                                   function(st$0){set_transition(st, color, st$0); return a();});
		                         });
		               }
		               function next$1(colors, st, s, pos){
		                var
		                 c = caml_string_unsafe_get(s, pos),
		                 c$0 = caml_string_unsafe_get(colors, c);
		                return follow_transition(st, c$0);
		               }
		               var null_char = -1;
		               function get_color(re, s, pos){
		                if(pos < 0) return null_char;
		                var slen = caml_ml_string_length(s);
		                if(slen <= pos) return null_char;
		                if
		                 (pos === (slen - 1 | 0)
		                  && re[6] !== -1 && equal(caml_string_unsafe_get(s, pos), 10))
		                 return re[6];
		                var
		                 c = caml_string_unsafe_get(s, pos),
		                 t = re[3],
		                 c$0 = caml_string_unsafe_get(t, c);
		                return c$0;
		               }
		               function scan_str
		               (re, positions, s, initial_state, last, pos, groups, cont){
		                if
		                 (last === caml_ml_string_length(s)
		                  &&
		                   re[6] !== -1
		                   && pos < last && equal(caml_string_get(s, last - 1 | 0), 10)){
		                 var last$0 = last - 1 | 0;
		                 return caml_exact_trampoline_cps_call$8
		                         (scan_str,
		                          re,
		                          positions,
		                          s,
		                          initial_state,
		                          last$0,
		                          pos,
		                          groups,
		                          function(st){
		                           var x = get_info(st)[1];
		                           function a(){
		                            var
		                             st$0 = follow_transition(st, re[6]),
		                             info = get_info(st$0),
		                             t = info[1];
		                            if(0 <= t){
		                             var b = function(a){return cont(st$0);};
		                             if(! groups) return b(0);
		                             var t$0 = info[1];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$6, positions, t$0, last$0, b);
		                            }
		                            var x = info[1];
		                            if(x <= -3){
		                             var c = function(a){return cont(st$0);};
		                             return groups
		                                     ? caml_exact_trampoline_cps_call$0
		                                       (set$6, positions, break_idx(info[1]), last$0, c)
		                                     : c(0);
		                            }
		                            var color = re[6];
		                            caml_ml_mutex_lock(re[11]);
		                            function d(){
		                             caml_ml_mutex_unlock(re[11]);
		                             return caml_exact_trampoline_call0(a);
		                            }
		                            if(! is_unknown_transition(st, color)) return d();
		                            var
		                             cat = category(re, color),
		                             t$1 = re[3],
		                             real_c = caml_string_unsafe_get(t$1, 10);
		                            return caml_exact_trampoline_cps_call$2
		                                    (delta,
		                                     re,
		                                     cat,
		                                     real_c,
		                                     get_info(st),
		                                     function(desc){
		                                      return caml_exact_trampoline_cps_call$1
		      (find_state,
		       re,
		       desc,
		       function(st$0){set_transition(st, color, st$0); return d();});
		                                     });
		                           }
		                           return x <= -3 ? cont(st) : a();
		                          });
		                }
		                if(groups){
		                 var
		                  colors = re[3],
		                  a =
		                    function(pos, st0, st){
		                     if(pos >= last) return cont(st);
		                     var
		                      st0$0 = next$1(colors, st, s, pos),
		                      idx = get_info(st0$0)[1];
		                     if(0 > idx)
		                      return idx <= -3
		                              ? caml_exact_trampoline_cps_call$0
		                                (set$6,
		                                 positions,
		                                 break_idx(idx),
		                                 pos,
		                                 function(a){return cont(st0$0);})
		                              : caml_exact_trampoline_cps_call$2
		                                (validate,
		                                 re,
		                                 s,
		                                 pos,
		                                 st0,
		                                 function(b){
		                                  return caml_exact_trampoline_call3(a, pos, st0, st0);
		                                 });
		                     var y = positions[2];
		                     if(idx >= y)
		                      return caml_exact_trampoline_cps_call$0
		                              (set$6,
		                               positions,
		                               idx,
		                               pos,
		                               function(b){
		                                var pos$0 = pos + 1 | 0;
		                                return caml_exact_trampoline_call3(a, pos$0, st0$0, st0$0);
		                               });
		                     unsafe_set$1(positions, idx, pos);
		                     var pos$0 = pos + 1 | 0;
		                     return caml_exact_trampoline_call3(a, pos$0, st0$0, st0$0);
		                    };
		                 return a(pos, initial_state, initial_state);
		                }
		                var colors$0 = re[3];
		                function b(pos, st0, st){
		                 if(pos >= last) return cont(st);
		                 var
		                  st0$0 = next$1(colors$0, st, s, pos),
		                  idx = get_info(st0$0)[1];
		                 if(0 > idx)
		                  return idx <= -3
		                          ? cont(st0$0)
		                          : caml_exact_trampoline_cps_call$2
		                            (validate,
		                             re,
		                             s,
		                             pos,
		                             st0,
		                             function(a){
		                              return caml_exact_trampoline_call3(b, pos, st0, st0);
		                             });
		                 var pos$0 = pos + 1 | 0;
		                 return caml_exact_trampoline_call3(b, pos$0, st0$0, st0$0);
		                }
		                return b(pos, initial_state, initial_state);
		               }
		               function enforce_kind(ids, kind$0, kind, cr){
		                if(typeof kind$0 === "number" && 332064784 === kind$0){
		                 if(typeof kind === "number" && 332064784 === kind) return cr;
		                 return seq$0(ids, kind, cr, eps(ids));
		                }
		                return cr;
		               }
		               function translate(ctx$2, ast$3, cont){
		                a:
		                {
		                 b:
		                 {
		                  c:
		                  {
		                   d:
		                   {
		                    e:
		                    {
		                     f:
		                     {
		                      g:
		                      {
		                       h:
		                       {
		                        var ctx = ctx$2, ast = ast$3;
		                        i:
		                        for(;;){
		                         var
		                          colors = ctx[8],
		                          cache = ctx[7],
		                          names = ctx[6],
		                          pos = ctx[5],
		                          greedy = ctx[4],
		                          ign_group = ctx[3],
		                          kind = ctx[2],
		                          ids = ctx[1];
		                         if(typeof ast === "number") break a;
		                         switch(ast[0]){
		                           case 0:
		                            break b;
		                           case 1:
		                            break c;
		                           case 2:
		                            break d;
		                           case 3:
		                            break e;
		                           case 4:
		                            var ast$0 = ast[2], n = ast[1];
		                            if(! ign_group) break f;
		                            ast = ast$0;
		                            break;
		                           case 5:
		                            var
		                             ast$1 = ast[1],
		                             ctx$0 =
		                               [0,
		                                ctx[1],
		                                ctx[2],
		                                1,
		                                ctx[4],
		                                ctx[5],
		                                ctx[6],
		                                ctx[7],
		                                ctx[8]];
		                            ctx = ctx$0;
		                            ast = ast$1;
		                            break;
		                           case 6:
		                            break g;
		                           case 7:
		                            break h;
		                           case 8:
		                            break i;
		                           default:
		                            var
		                             ast$2 = ast[2],
		                             greedy$0 = ast[1],
		                             ctx$1 =
		                               [0,
		                                ctx[1],
		                                ctx[2],
		                                ctx[3],
		                                greedy$0,
		                                ctx[5],
		                                ctx[6],
		                                ctx[7],
		                                ctx[8]];
		                            ctx = ctx$1;
		                            ast = ast$2;
		                         }
		                        }
		                        var r$3 = ast[2], kind$0 = ast[1];
		                        return caml_exact_trampoline_cps_call$1
		                                (translate,
		                                 [0,
		                                  ctx[1],
		                                  kind$0,
		                                  ctx[3],
		                                  ctx[4],
		                                  ctx[5],
		                                  ctx[6],
		                                  ctx[7],
		                                  ctx[8]],
		                                 r$3,
		                                 function(match){
		                                  var kind = match[2], cr = match[1];
		                                  return cont
		  ([0, enforce_kind(ids, kind$0, kind, cr), kind$0]);
		                                 });
		                       }
		                       var r$2 = ast[2], i$3 = ast[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (translate,
		                                ctx,
		                                r$2,
		                                function(match){
		                                 var kind = match[2], cr = match[1];
		                                 return cont
		 ([0, seq$0(ids, 332064784, mk(ids, [8, i$3]), cr), kind]);
		                                });
		                      }
		                      var r$1 = ast[1], b = pos[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (translate,
		                               ctx,
		                               r$1,
		                               function(match){
		                                var
		                                 kind = match[2],
		                                 cr = match[1],
		                                 x = pos[1],
		                                 m = x - 1 | 0;
		                                return caml_int_compare(m, b) === -1
		? cont([0, cr, kind])
		: cont
		  ([0, seq$0(ids, 332064784, mk(ids, [5, b, m]), cr), kind]);
		                               });
		                     }
		                     var p = pos[1];
		                     if(n){
		                      var name = n[1];
		                      names[1] = [0, [0, name, p / 2 | 0], names[1]];
		                     }
		                     var x = pos[1];
		                     pos[1] = x + 2 | 0;
		                     return caml_exact_trampoline_cps_call$1
		                             (translate,
		                              ctx,
		                              ast$0,
		                              function(a){
		                               var
		                                kind = a[2],
		                                cr = a[1],
		                                a = seq$0(ids, 332064784, cr, mark(ids, p + 1 | 0));
		                               return cont
		                                       ([0, seq$0(ids, 332064784, mark(ids, p), a), kind]);
		                              });
		                    }
		                    var j$0 = ast[3], i$2 = ast[2], r$0 = ast[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (translate,
		                             ctx,
		                             r$0,
		                             function(match){
		                              var kind$0 = match[2], cr = match[1];
		                              function a(n, rem){
		                               return n === 0
		                                       ? cont([0, rem, kind])
		                                       : caml_exact_trampoline_cps_call$1
		 (rename,
		  ids,
		  cr,
		  function(b){
		   var v = seq$0(ids, kind$0, b, rem), n$0 = n - 1 | 0;
		   return caml_exact_trampoline_call2(a, n$0, v);
		  });
		                              }
		                              if(! j$0) return a(i$2, mk(ids, [3, greedy, kind$0, cr]));
		                              var
		                               j = j$0[1],
		                               f =
		                                 620821490 <= greedy
		                                  ? function
		                                   (rem, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (rename,
		     ids,
		     cr,
		     function(a){
		      a = [0, seq$0(ids, kind$0, a, rem), 0];
		      return cont(alt$0(ids, [0, eps(ids), a]));
		     });
		                                   }
		                                  : function
		                                   (rem, cont){
		                                    var a = [0, eps(ids), 0];
		                                    return caml_exact_trampoline_cps_call$1
		    (rename,
		     ids,
		     cr,
		     function(b){
		      return cont(alt$0(ids, [0, seq$0(ids, kind$0, b, rem), a]));
		     });
		                                   },
		                               v = eps(ids),
		                               n = j - i$2 | 0;
		                              function b(n, v){
		                               return n === 0
		                                       ? a(i$2, v)
		                                       : caml_exact_trampoline_cps_call
		 (f,
		  v,
		  function(v){
		   var n$0 = n - 1 | 0;
		   return caml_exact_trampoline_call2(b, n$0, v);
		  });
		                              }
		                              return b(n, v);
		                             });
		                   }
		                   var l$0 = ast[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (trans_seq,
		                            ctx,
		                            l$0,
		                            function(a){return cont([0, a, kind]);});
		                  }
		                  var l = ast[1][1], merged_sequences = merge_sequences(l);
		                  if(merged_sequences && ! merged_sequences[2]){
		                   var r = merged_sequences[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (translate,
		                            ctx,
		                            r,
		                            function(match){
		                             var kind$0 = match[2], cr = match[1];
		                             return cont([0, enforce_kind(ids, kind, kind$0, cr), kind]);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (map$0,
		                           function(r, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (translate,
		                                     ctx,
		                                     r,
		                                     function(match){
		                                      var kind$0 = match[2], cr = match[1];
		                                      return cont(enforce_kind(ids, kind, kind$0, cr));
		                                     });
		                           },
		                           merged_sequences,
		                           function(a){return cont([0, alt$0(ids, a), kind]);});
		                 }
		                 var cset = ast[1];
		                 b:
		                 {
		                  if(cset && ! cset[2]){
		                   var a = cset[1], j = a[2], i = a[1];
		                   if(i === j){a = [0, i]; break b;}
		                  }
		                  a = 0;
		                 }
		                 var
		                  c =
		                    function(s){
		                     var a = s ? 0 : 1, a = a ? mk(ids, bs) : mk(ids, [0, s]);
		                     return cont([0, a, kind]);
		                    };
		                 if(a){
		                  var i$1 = a[1], i$0 = caml_string_get(colors, i$1);
		                  return c(single$0(i$0));
		                 }
		                 var v = [0, hash_rec(cset) & 1073741823, cset];
		                 caml_push_trap
		                  (function(exn){
		                    if(exn === Not_found)
		                     return caml_exact_trampoline_cps_call$0
		                             (fold_right,
		                              function(param, acc, cont){
		                               var
		                                y = param[2],
		                                x = param[1],
		                                start = caml_string_get(colors, x),
		                                stop = caml_string_get(colors, y);
		                               return caml_exact_trampoline_cps_call$1
		                                       (union$3, cseq(start, stop), acc, cont);
		                              },
		                              cset,
		                              empty$16,
		                              function(l){
		                               return caml_exact_trampoline_cps_call$0
		                                       (CSetMap[2],
		v,
		l,
		cache[1],
		function(a){cache[1] = a; return c(l);});
		                              });
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   });
		                 return caml_exact_trampoline_cps_call$1
		                         (CSetMap[17],
		                          v,
		                          cache[1],
		                          function(a){caml_pop_trap(); return c(a);});
		                }
		                var search_boundary = 32;
		                switch(ast){
		                  case 0:
		                   return cont([0, after(ids, 9), kind]);
		                  case 1:
		                   return cont([0, before(ids, 9), kind]);
		                  case 2:
		                   a = before(ids, letter);
		                   return cont
		                           ([0, seq$0(ids, 332064784, after(ids, 5), a), kind]);
		                  case 3:
		                   a = before(ids, 5);
		                   return cont
		                           ([0, seq$0(ids, 332064784, after(ids, letter), a), kind]);
		                  case 4:
		                   var
		                    cat = 5,
		                    a = before(ids, cat),
		                    a = [0, seq$0(ids, 332064784, after(ids, cat), a), 0],
		                    d = before(ids, letter);
		                   return cont
		                           ([0,
		                             alt$0
		                              (ids, [0, seq$0(ids, 332064784, after(ids, letter), d), a]),
		                             kind]);
		                  case 5:
		                   return cont([0, after(ids, inexistant), kind]);
		                  case 6:
		                   return cont([0, before(ids, inexistant), kind]);
		                  case 7:
		                   return cont([0, before(ids, 17), kind]);
		                  case 8:
		                   return cont([0, after(ids, search_boundary), kind]);
		                  default:
		                   return cont([0, before(ids, search_boundary), kind]);
		                }
		               }
		               function trans_seq(ctx, param, cont){
		                var kind = ctx[2], ids = ctx[1];
		                if(! param) return cont(eps(ids));
		                var r = param[1];
		                if(! param[2])
		                 return caml_exact_trampoline_cps_call$1
		                         (translate,
		                          ctx,
		                          r,
		                          function(match){
		                           var kind$0 = match[2], cr = match[1];
		                           return cont(enforce_kind(ids, kind, kind$0, cr));
		                          });
		                var rem = param[2];
		                return caml_exact_trampoline_cps_call$1
		                        (translate,
		                         ctx,
		                         r,
		                         function(match){
		                          var kind = match[2], cr = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (trans_seq,
		                                   ctx,
		                                   rem,
		                                   function(cr$0){
		                                    return is_eps(cr$0)
		    ? cont(cr)
		    : is_eps(cr) ? cont(cr$0) : cont(seq$0(ids, kind, cr, cr$0));
		                                   });
		                         });
		               }
		               function compile(r, cont){
		                function a(regexp){
		                 return caml_exact_trampoline_cps_call$1
		                         (handle_case,
		                          0,
		                          regexp,
		                          function(regexp){
		                           var color_map = make(257, 0), lnl = [0, 0];
		                           function colorize(regexp$2, cont){
		                            var regexp = regexp$2;
		                            for(;;){
		                             if(typeof regexp === "number")
		                              switch(regexp){
		                                case 7:
		                                 lnl[1] = 1; return cont();
		                                case 0:
		                                case 1:
		                                 return cont(split$5(color_map, nl$0));
		                                case 2:
		                                case 3:
		                                case 4:
		                                 return cont(split$5(color_map, cword));
		                                default: return cont();
		                              }
		                             switch(regexp[0]){
		                               case 0:
		                                var s = regexp[1]; return cont(split$5(color_map, s));
		                               case 1:
		                                var l = regexp[1][1];
		                                return caml_exact_trampoline_cps_call$1
		(iter$0, colorize, l, cont);
		                               case 2:
		                                var l$0 = regexp[1];
		                                return caml_exact_trampoline_cps_call$1
		(iter$0, colorize, l$0, cont);
		                               case 3:
		                                var regexp$0 = regexp[1]; regexp = regexp$0; break;
		                               case 4:
		                               case 7:
		                                regexp = regexp[2]; break;
		                               case 5:
		                               case 6:
		                                regexp = regexp[1]; break;
		                               default: var regexp$1 = regexp[2]; regexp = regexp$1;
		                             }
		                            }
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (colorize,
		                                    regexp,
		                                    function(b){
		                                     var
		                                      need_lnl = lnl[1],
		                                      c = caml_create_bytes(256),
		                                      color_repr = caml_create_bytes(256);
		                                     caml_bytes_set(c, 0, 0);
		                                     caml_bytes_set(color_repr, 0, 0);
		                                     function a(v, i){
		                                      if(0 !== caml_bytes_get(color_map, i))
		                                       var v$0 = v + 1 | 0, v$1 = v$0;
		                                      else
		                                       v$1 = v;
		                                      return caml_exact_trampoline_cps_call
		      (chr,
		       v$1,
		       function(b){
		        caml_bytes_set(c, i, b);
		        return caml_exact_trampoline_cps_call
		                (chr,
		                 i,
		                 function(b){
		                  caml_bytes_set(color_repr, v$1, b);
		                  b = i + 1 | 0;
		                  return 255 !== i
		                          ? caml_exact_trampoline_call2(a, v$1, b)
		                          : caml_exact_trampoline_cps_call$0
		                            (sub_string,
		                             color_repr,
		                             0,
		                             v$1 + 1 | 0,
		                             function(color_repr){
		                              var
		                               colors = caml_string_of_bytes(c),
		                               ncolor = caml_ml_string_length(color_repr),
		                               lnl = need_lnl ? ncolor : null_char,
		                               ncolor$0 = need_lnl ? ncolor + 1 | 0 : ncolor,
		                               ctx =
		                                 [0,
		                                  [0, 0],
		                                  332064784,
		                                  0,
		                                  -904640576,
		                                  [0, 0],
		                                  [0, 0],
		                                  [0, CSetMap[1]],
		                                  colors];
		                              return caml_exact_trampoline_cps_call$1
		                                      (translate,
		                                       ctx,
		                                       regexp,
		                                       function(match){
		var
		 kind = match[2],
		 r = match[1],
		 initial = enforce_kind(ctx[1], 332064784, kind, r);
		rev(ctx[6][1]);
		var a = caml_ml_mutex_new();
		return caml_exact_trampoline_cps_call
		        (create,
		         97,
		         function(b){
		          return cont
		                  ([0,
		                    initial,
		                    0,
		                    colors,
		                    color_repr,
		                    ncolor$0,
		                    lnl,
		                    [0, create_zero$0(1), [0, 0], [0, 0]],
		                    b,
		                    ,
		                    ,
		                    a]);
		         });
		                                       });
		                             });
		                 });
		       });
		                                     }
		                                     return a(0, 1);
		                                    });
		                          });
		                }
		                if(anchored(r)) return a([4, 0, r]);
		                var b = [0, [4, 0, r], 0];
		                return caml_exact_trampoline_cps_call
		                        (rep,
		                         any$0,
		                         function(t){
		                          a:
		                          {
		                           if(typeof t !== "number" && 0 === t[0]){var c = t; break a;}
		                           c = [8, -1034406550, t];
		                          }
		                          return a(seq$1([0, c, b]));
		                         });
		               }
		               function rg$0(c$0, c){return cset(cseq(c$0, c));}
		               var
		                notnl$0 = cset(notnl),
		                lower = cset(lower$0),
		                upper$0 = cset(upper),
		                alpha = cset(alpha$1),
		                digit$0 = cset(cdigit),
		                alnum$0 = cset(alnum$1),
		                wordc = cset(wordc$0),
		                ascii$0 = cset(ascii),
		                blank$0 = cset(blank),
		                cntrl = cset(cntrl$0),
		                graph = cset(graph$0),
		                print = cset(print$0),
		                punct = cset(punct$0),
		                space$0 = cset(space),
		                xdigit = cset(xdigit$0),
		                Parse_error$1 =
		                  [248, "Re__Parse_buffer.Parse_error", caml_fresh_oo_id()];
		               function create$23(str){return [0, str, 0];}
		               function unget(t){t[2] = t[2] - 1 | 0;}
		               function eos$0(t){
		                return t[2] === caml_ml_string_length(t[1]) ? 1 : 0;
		               }
		               function test$0(t, c){
		                var
		                 a = 1 - eos$0(t),
		                 a = a ? caml_string_get(t[1], t[2]) === c ? 1 : 0 : a;
		                return a;
		               }
		               function accept(t, c){
		                var r = test$0(t, c);
		                if(r) t[2] = t[2] + 1 | 0;
		                return r;
		               }
		               function get$8(t){
		                var r = caml_string_get(t[1], t[2]);
		                t[2] = t[2] + 1 | 0;
		                return r;
		               }
		               function accept_s(t, s){
		                var len = caml_ml_string_length(s);
		                try{
		                 var b = len - 1 | 0;
		                 if(b >= 0){
		                  var j = 0;
		                  for(;;){
		                   try{
		                    var a = caml_string_get(t[1], t[2] + j | 0);
		                    if(caml_string_get(s, j) !== a) throw Exit;
		                   }
		                   catch(exn){throw Exit;}
		                   a = j + 1 | 0;
		                   if(b === j) break;
		                   j = a;
		                  }
		                 }
		                 t[2] = t[2] + len | 0;
		                 return 1;
		                }
		                catch(exn$0){
		                 var exn = caml_wrap_exception(exn$0);
		                 if(exn === Exit) return 0;
		                 throw caml_maybe_attach_backtrace(exn, 0);
		                }
		               }
		               function integer(t){
		                if(eos$0(t)) return 0;
		                var d$0 = get$8(t);
		                if(9 < d$0 - 48 >>> 0){unget(t); return 0;}
		                var i$1 = d$0 - 48 | 0, i = i$1;
		                for(;;){
		                 if(eos$0(t)) return [0, i];
		                 var d = get$8(t);
		                 if(9 < d - 48 >>> 0){unget(t); return [0, i];}
		                 var i$0 = (10 * i | 0) + (d - 48 | 0) | 0;
		                 if(i$0 < i)
		                  throw caml_maybe_attach_backtrace(Parse_error$1, 1);
		                 i = i$0;
		                }
		               }
		               var
		                Parse_error$2 =
		                  [248, "Re__Emacs.Parse_error", caml_fresh_oo_id()],
		                Not_supported =
		                  [248, "Re__Emacs.Not_supported", caml_fresh_oo_id()],
		                Not_supported$0 =
		                  [248, "Re__Perl.Not_supported", caml_fresh_oo_id()];
		               function char_of_int$0(x, cont){
		                caml_push_trap
		                 (function(exn){
		                   var
		                    raise = caml_pop_trap(),
		                    Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return raise(Parse_error);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (char_of_int,
		                         x,
		                         function(x){caml_pop_trap(); return cont(x);});
		               }
		               var
		                word_char = [0, alnum$0, [0, f$7(95), 0]],
		                word = [1, caml_callback(alt$1, [word_char])],
		                not_word = [1, caml_callback(alt$1, [word_char])],
		                not_space = [1, caml_callback(compl, [[0, space$0, 0]])],
		                not_digit = [1, caml_callback(compl, [[0, digit$0, 0]])],
		                bol$0 = 0,
		                eol = 1,
		                bow$0 = 2,
		                eow = 3,
		                not_boundary = 4,
		                bos$0 = 5,
		                eos = 6,
		                start$0 = 8,
		                space$1 = [1, space$0],
		                digit$1 = [1, digit$0];
		               function compile_pat(opt$0, s, cont){
		                var
		                 opts = opt$0 ? opt$0[1] : 0,
		                 ungreedy = memq(-243745063, opts),
		                 dotall = memq(-424303016, opts),
		                 dollar_endonly = memq(-712595228, opts),
		                 multiline = memq(1071952589, opts),
		                 buf = create$23(s);
		                function greedy_mod(r){
		                 var gr$0 = accept(buf, 63), gr = ungreedy ? 1 - gr$0 : gr$0;
		                 if(gr){
		                  if(typeof r !== "number" && 0 === r[0]) return r;
		                  return [9, 620821490, r];
		                 }
		                 if(typeof r !== "number" && 0 === r[0]) return r;
		                 return [9, -904640576, r];
		                }
		                function regexp(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (branch,
		                          dummy,
		                          function(b){
		                           var left = [0, b, 0];
		                           function a(left){
		                            return accept(buf, 124)
		                                    ? caml_exact_trampoline_cps_call
		                                      (branch,
		                                       dummy,
		                                       function(b){
		var left$0 = [0, b, left];
		return caml_exact_trampoline_call1(a, left$0);
		                                       })
		                                    : caml_exact_trampoline_cps_call(alt$1, rev(left), cont);
		                           }
		                           return a(left);
		                          });
		                }
		                function branch(param, cont){
		                 function a(left){
		                  if(! eos$0(buf) && ! test$0(buf, 124) && ! test$0(buf, 41))
		                   return caml_exact_trampoline_cps_call
		                           (atom,
		                            dummy,
		                            function(r){
		                             function c(b){
		                              var left$0 = [0, b, left];
		                              return caml_exact_trampoline_call1(a, left$0);
		                             }
		                             if(accept(buf, 42))
		                              return caml_exact_trampoline_cps_call
		                                      (rep, r, function(a){return c(greedy_mod(a));});
		                             if(accept(buf, 43))
		                              return caml_exact_trampoline_cps_call
		                                      (rep1, r, function(a){return c(greedy_mod(a));});
		                             if(accept(buf, 63))
		                              return caml_exact_trampoline_cps_call
		                                      (opt, r, function(a){return c(greedy_mod(a));});
		                             if(! accept(buf, 123)) return c(r);
		                             var b = integer(buf);
		                             if(! b){unget(buf); return c(r);}
		                             var i = b[1], j = accept(buf, 44) ? integer(buf) : [0, i];
		                             if(1 - accept(buf, 125)){
		                              b = caml_pop_trap();
		                              var
		                               Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                              return b(Parse_error);
		                             }
		                             if(j){
		                              var j$0 = j[1];
		                              if(j$0 < i){
		                               b = caml_pop_trap();
		                               var
		                                Parse_error$0 =
		                                  caml_maybe_attach_backtrace(Parse_error$1, 1);
		                               return b(Parse_error$0);
		                              }
		                             }
		                             return caml_exact_trampoline_cps_call$0
		                                     (repn, r, i, j, function(a){return c(greedy_mod(a));});
		                            });
		                  return cont(seq$1(rev(left)));
		                 }
		                 return a(0);
		                }
		                function atom(a, cont){
		                 if(accept(buf, 46))
		                  return dotall ? cont(any$0) : cont(notnl$0);
		                 if(! accept(buf, 40)){
		                  if(accept(buf, 94))
		                   return multiline ? cont(bol$0) : cont(bos$0);
		                  var leol = 7;
		                  if(accept(buf, 36))
		                   return multiline
		                           ? cont(eol)
		                           : dollar_endonly ? cont(leol) : cont(eos);
		                  if(accept(buf, 91))
		                   return accept(buf, 94)
		                           ? caml_exact_trampoline_cps_call
		                             (bracket,
		                              0,
		                              function(a){
		                               return caml_exact_trampoline_cps_call(compl, a, cont);
		                              })
		                           : caml_exact_trampoline_cps_call
		                             (bracket,
		                              0,
		                              function(a){
		                               return caml_exact_trampoline_cps_call(alt$1, a, cont);
		                              });
		                  if(! accept(buf, 92)){
		                   if(eos$0(buf)){
		                    a = caml_pop_trap();
		                    var
		                     Parse_error$10 =
		                       caml_maybe_attach_backtrace(Parse_error$1, 1);
		                    return a(Parse_error$10);
		                   }
		                   var c = get$8(buf);
		                   a:
		                   {
		                    if(64 <= c){
		                     if(92 !== c && 123 !== c) break a;
		                    }
		                    else
		                     if(44 <= c){if(63 > c) break a;} else if(42 > c) break a;
		                    a = caml_pop_trap();
		                    var
		                     Parse_error$11 =
		                       caml_maybe_attach_backtrace(Parse_error$1, 1);
		                    return a(Parse_error$11);
		                   }
		                   return cont(f$7(c));
		                  }
		                  if(eos$0(buf)){
		                   a = caml_pop_trap();
		                   var
		                    Parse_error$4 =
		                      caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return a(Parse_error$4);
		                  }
		                  var n1$0 = get$8(buf), a = n1$0 - 48 | 0;
		                  if(74 >= a >>> 0)
		                   switch(a){
		                     case 17:
		                      return cont(bos$0);
		                     case 18:
		                      return cont(not_boundary);
		                     case 20:
		                      return caml_exact_trampoline_cps_call
		                              (compl, [0, digit$0, 0], cont);
		                     case 21:
		                      a = caml_pop_trap();
		                      var
		                       Parse_error$9 =
		                         caml_maybe_attach_backtrace(Parse_error$1, 1);
		                      return a(Parse_error$9);
		                     case 23:
		                      return cont(start$0);
		                     case 33:
		                      var
		                       buf$0 = create$1(12),
		                       f =
		                         function(a){
		                          if(! accept(buf, 92)){
		                           if(! eos$0(buf))
		                            return caml_exact_trampoline_cps_call$1
		                                    (add_char, buf$0, get$8(buf), f);
		                           a = caml_pop_trap();
		                           var
		                            Parse_error$0 =
		                              caml_maybe_attach_backtrace(Parse_error$1, 1);
		                           return a(Parse_error$0);
		                          }
		                          if(eos$0(buf)){
		                           a = caml_pop_trap();
		                           var
		                            Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                           return a(Parse_error);
		                          }
		                          var c = get$8(buf);
		                          return 69 === c
		                                  ? caml_exact_trampoline_cps_call
		                                    (contents,
		                                     buf$0,
		                                     function(s){
		                                      var b = caml_ml_string_length(s) - 1 | 0, a = 0;
		                                      if(b < 0)
		                                       var l$0 = a;
		                                      else {
		                                       var l = a, i = b;
		                                       for(;;){
		var
		 c = caml_string_get(s, i),
		 a = [0, f$7(c), l],
		 b = i - 1 | 0;
		if(0 === i){l$0 = a; break;}
		l = a;
		i = b;
		                                       }
		                                      }
		                                      return cont(seq$1(l$0));
		                                     })
		                                  : caml_exact_trampoline_cps_call$1
		                                    (add_char,
		                                     buf$0,
		                                     92,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (add_char, buf$0, c, f);
		                                     });
		                         };
		                      return f(0);
		                     case 35:
		                      return caml_exact_trampoline_cps_call
		                              (compl, [0, space$0, 0], cont);
		                     case 39:
		                      return caml_exact_trampoline_cps_call
		                              (compl, [0, alnum$0, [0, f$7(95), 0]], cont);
		                     case 42:
		                      return cont(leol);
		                     case 50:
		                      return caml_exact_trampoline_cps_call
		                              (alt$1, [0, bow$0, [0, eow, 0]], cont);
		                     case 52:
		                      return cont(digit$0);
		                     case 53:
		                      return cont(f$7(27));
		                     case 54:
		                      return cont(f$7(12));
		                     case 62:
		                      return cont(f$7(10));
		                     case 63:
		                      if(accept(buf, 123)){
		                       var acc$1 = 0;
		                       for(;;){
		                        if(accept(buf, 125)){a = [0, acc$1]; break;}
		                        a = maybe_octaldigit();
		                        if(! a){
		                         a = caml_pop_trap();
		                         var
		                          Parse_error$8 =
		                            caml_maybe_attach_backtrace(Parse_error$1, 1);
		                         return a(Parse_error$8);
		                        }
		                        var p = a[1], acc$4 = [0, p, acc$1];
		                        acc$1 = acc$4;
		                       }
		                      }
		                      else
		                       a = 0;
		                      if(! a){
		                       a = caml_pop_trap();
		                       var
		                        Parse_error$7 =
		                          caml_maybe_attach_backtrace(Parse_error$1, 1);
		                       return a(Parse_error$7);
		                      }
		                      var digits$1 = a[1], digits = digits$1, acc = 0, i = 1;
		                      for(;;){
		                       if(! digits) break;
		                       var
		                        digits$0 = digits[2],
		                        d = digits[1],
		                        acc$0 = acc + caml_mul(d, i) | 0,
		                        i$0 = caml_mul(i, i);
		                       digits = digits$0;
		                       acc = acc$0;
		                       i = i$0;
		                      }
		                      return caml_exact_trampoline_cps_call
		                              (char_of_int$0, acc, function(c){return cont(f$7(c));});
		                     case 66:
		                      return cont(f$7(13));
		                     case 67:
		                      return cont(space$0);
		                     case 68:
		                      return cont(f$7(9));
		                     case 71:
		                      return caml_exact_trampoline_cps_call
		                              (alt$1, [0, alnum$0, [0, f$7(95), 0]], cont);
		                     case 72:
		                      if(accept(buf, 123)){
		                       var acc$2 = 0;
		                       for(;;){
		                        if(accept(buf, 125)){a = [0, acc$2]; break;}
		                        var acc$3 = [0, hexdigit(), acc$2];
		                        acc$2 = acc$3;
		                       }
		                      }
		                      else
		                       a = 0;
		                      a:
		                      {
		                       if(a){
		                        a = a[1];
		                        if(a){
		                         var e = a[2], c1 = a[1];
		                         if(! e){var c2$0 = c1, c1$0 = 0; break a;}
		                         if(! e[2]){var c2 = e[1], c2$0 = c2, c1$0 = c1; break a;}
		                        }
		                        e = caml_pop_trap();
		                        var
		                         Parse_error$6 =
		                           caml_maybe_attach_backtrace(Parse_error$1, 1);
		                        return e(Parse_error$6);
		                       }
		                       var
		                        c1$1 = hexdigit(),
		                        c2$1 = hexdigit(),
		                        c2$0 = c2$1,
		                        c1$0 = c1$1;
		                      }
		                      var code = (c1$0 * 16 | 0) + c2$0 | 0;
		                      return caml_exact_trampoline_cps_call
		                              (char_of_int$0, code, function(c){return cont(f$7(c));});
		                     case 74:
		                      return cont(eos);
		                     case 8:
		                     case 9:
		                      e = caml_pop_trap();
		                      var
		                       Not_supported =
		                         caml_maybe_attach_backtrace(Not_supported$0, 1);
		                      return e(Not_supported);
		                     case 0:
		                     case 1:
		                     case 2:
		                     case 3:
		                     case 4:
		                     case 5:
		                     case 6:
		                     case 7:
		                      var n2 = maybe_octaldigit(), n3 = maybe_octaldigit();
		                      if(n2 && n3){
		                       var n3$0 = n3[1], n2$0 = n2[1], n1 = n1$0 - 48 | 0;
		                       return caml_exact_trampoline_cps_call
		                               (char_of_int$0,
		                                ((n1 * 64 | 0) + (n2$0 * 8 | 0) | 0) + n3$0 | 0,
		                                function(c){return cont(f$7(c));});
		                      }
		                      e = caml_pop_trap();
		                      var
		                       Not_supported$1 =
		                         caml_maybe_attach_backtrace(Not_supported$0, 1);
		                      return e(Not_supported$1);
		                     case 10:
		                     case 11:
		                     case 12:
		                     case 13:
		                     case 14:
		                     case 15:
		                     case 16:
		                     case 43:
		                     case 44:
		                     case 45:
		                     case 46:
		                     case 47:
		                     case 48: break;
		                     default:
		                      e = caml_pop_trap();
		                      var
		                       Parse_error$5 =
		                         caml_maybe_attach_backtrace(Parse_error$1, 1);
		                      return e(Parse_error$5);
		                   }
		                  return cont(f$7(n1$0));
		                 }
		                 if(! accept(buf, 63))
		                  return caml_exact_trampoline_cps_call
		                          (regexp,
		                           dummy,
		                           function(r){
		                            if(! (1 - accept(buf, 41))) return cont([4, 0, r]);
		                            var
		                             raise = caml_pop_trap(),
		                             Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                            return raise(Parse_error);
		                           });
		                 if(accept(buf, 58))
		                  return caml_exact_trampoline_cps_call
		                          (regexp,
		                           dummy,
		                           function(r){
		                            if(! (1 - accept(buf, 41))) return cont(r);
		                            var
		                             raise = caml_pop_trap(),
		                             Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                            return raise(Parse_error);
		                           });
		                 if(! accept(buf, 35)){
		                  if(! accept(buf, 60)){
		                   e = caml_pop_trap();
		                   var
		                    Parse_error$3 =
		                      caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return e(Parse_error$3);
		                  }
		                  if(eos$0(buf)){
		                   e = caml_pop_trap();
		                   var
		                    Parse_error$0 =
		                      caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return e(Parse_error$0);
		                  }
		                  var c$0 = get$8(buf), e = c$0 - 91 | 0;
		                  a:
		                  {
		                   if(5 < e >>> 0){
		                    if(57 < e + 26 >>> 0) break a;
		                   }
		                   else if(4 !== e) break a;
		                   var
		                    b = create$1(32),
		                    g =
		                      function(a){
		                       if(eos$0(buf)){
		                        a = caml_pop_trap();
		                        var
		                         Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                        return a(Parse_error);
		                       }
		                       var c = get$8(buf);
		                       a:
		                       {
		                        if(65 <= c){
		                         a = c - 91 | 0;
		                         if(5 < a >>> 0){
		                          if(32 <= a) break a;
		                         }
		                         else if(4 !== a) break a;
		                        }
		                        else {
		                         if(58 <= c){
		                          if(62 === c)
		                           return caml_exact_trampoline_cps_call
		                                   (contents,
		                                    b,
		                                    function(name){
		                                     return caml_exact_trampoline_cps_call
		     (regexp,
		      dummy,
		      function(r){
		       if(1 - accept(buf, 41)){
		        var
		         raise = caml_pop_trap(),
		         Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		        return raise(Parse_error);
		       }
		       var name$0 = [0, name];
		       return cont([4, name$0, r]);
		      });
		                                    });
		                          break a;
		                         }
		                         if(48 > c) break a;
		                        }
		                        return caml_exact_trampoline_cps_call$1(add_char, b, c, g);
		                       }
		                       a = caml_pop_trap();
		                       var
		                        Parse_error$0 =
		                          caml_maybe_attach_backtrace(Parse_error$1, 1);
		                       return a(Parse_error$0);
		                      };
		                   return caml_exact_trampoline_cps_call$1(add_char, b, c$0, g);
		                  }
		                  e = caml_pop_trap();
		                  var
		                   Parse_error$2 =
		                     caml_maybe_attach_backtrace(Parse_error$1, 1);
		                  return e(Parse_error$2);
		                 }
		                 for(;;){
		                  if(eos$0(buf)){
		                   e = caml_pop_trap();
		                   var
		                    Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return e(Parse_error);
		                  }
		                  if(accept(buf, 41)) return cont(epsilon);
		                  buf[2] = buf[2] + 1 | 0;
		                 }
		                }
		                function hexdigit(param){
		                 if(eos$0(buf))
		                  throw caml_maybe_attach_backtrace(Parse_error$1, 1);
		                 var d = get$8(buf);
		                 if(65 <= d){
		                  if(97 <= d){
		                   if(103 > d) return (d - 97 | 0) + 10 | 0;
		                  }
		                  else if(71 > d) return (d - 65 | 0) + 10 | 0;
		                 }
		                 else if(9 >= d - 48 >>> 0) return d - 48 | 0;
		                 throw caml_maybe_attach_backtrace(Parse_error$1, 1);
		                }
		                function maybe_octaldigit(param){
		                 if(eos$0(buf)) return 0;
		                 var d = get$8(buf);
		                 return 7 < d - 48 >>> 0 ? 0 : [0, d - 48 | 0];
		                }
		                function bracket(s, cont){
		                 function a(s){
		                  if(0 !== s && accept(buf, 93)) return cont(s);
		                  return caml_exact_trampoline_cps_call
		                          (char,
		                           dummy,
		                           function(b){
		                            if(0 !== b[0]){
		                             var st = b[1], s$1 = [0, st, s];
		                             return caml_exact_trampoline_call1(a, s$1);
		                            }
		                            var c = b[1];
		                            if(! accept(buf, 45)){
		                             var s$0 = [0, f$7(c), s];
		                             return caml_exact_trampoline_call1(a, s$0);
		                            }
		                            if(! accept(buf, 93))
		                             return caml_exact_trampoline_cps_call
		                                     (char,
		                                      dummy,
		                                      function(b){
		                                       if(0 === b[0]){
		var c$0 = b[1];
		return caml_exact_trampoline_call1(a, [0, rg$0(c, c$0), s]);
		                                       }
		                                       var st = b[1], b = [0, f$7(45), [0, st, s]];
		                                       return caml_exact_trampoline_call1(a, [0, f$7(c), b]);
		                                      });
		                            b = [0, f$7(45), s];
		                            return cont([0, f$7(c), b]);
		                           });
		                 }
		                 return a(s);
		                }
		                function char(a, cont){
		                 if(eos$0(buf)){
		                  a = caml_pop_trap();
		                  var
		                   Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                  return a(Parse_error);
		                 }
		                 var c$0 = get$8(buf);
		                 if(91 !== c$0){
		                  if(92 !== c$0) return cont([0, c$0]);
		                  if(eos$0(buf)){
		                   a = caml_pop_trap();
		                   var
		                    Parse_error$3 =
		                      caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return a(Parse_error$3);
		                  }
		                  var c = get$8(buf);
		                  if(58 <= c){
		                   if(123 > c)
		                    switch(c - 58 | 0){
		                      case 10:
		                       return cont(not_digit);
		                      case 25:
		                       return cont(not_space);
		                      case 29:
		                       return cont(not_word);
		                      case 40:
		                       return cont(char_b);
		                      case 42:
		                       return cont(digit$1);
		                      case 52:
		                       return cont(char_newline);
		                      case 56:
		                       return cont(char_cr);
		                      case 57:
		                       return cont(space$1);
		                      case 58:
		                       return cont(char_tab);
		                      case 61:
		                       return cont(word);
		                      case 0:
		                      case 1:
		                      case 2:
		                      case 3:
		                      case 4:
		                      case 5:
		                      case 6:
		                      case 33:
		                      case 34:
		                      case 35:
		                      case 36:
		                      case 37:
		                      case 38: break;
		                      default:
		                       a = caml_pop_trap();
		                       var
		                        Parse_error$4 =
		                          caml_maybe_attach_backtrace(Parse_error$1, 1);
		                       return a(Parse_error$4);
		                    }
		                  }
		                  else if(48 <= c){
		                   a = caml_pop_trap();
		                   var
		                    Not_supported$1 =
		                      caml_maybe_attach_backtrace(Not_supported$0, 1);
		                   return a(Not_supported$1);
		                  }
		                  return cont([0, c]);
		                 }
		                 if(accept(buf, 61)){
		                  a = caml_pop_trap();
		                  var
		                   Not_supported =
		                     caml_maybe_attach_backtrace(Not_supported$0, 1);
		                  return a(Not_supported);
		                 }
		                 function d(a){
		                  if(a){var set = a[1]; return cont([1, set]);}
		                  if(! accept(buf, 46)) return cont([0, c$0]);
		                  if(eos$0(buf)){
		                   a = caml_pop_trap();
		                   var
		                    Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return a(Parse_error);
		                  }
		                  var c = get$8(buf);
		                  if(1 - accept(buf, 46)){
		                   a = caml_pop_trap();
		                   var
		                    Not_supported =
		                      caml_maybe_attach_backtrace(Not_supported$0, 1);
		                   return a(Not_supported);
		                  }
		                  if(! (1 - accept(buf, 93))) return cont([0, c]);
		                  a = caml_pop_trap();
		                  var
		                   Parse_error$0 =
		                     caml_maybe_attach_backtrace(Parse_error$1, 1);
		                  return a(Parse_error$0);
		                 }
		                 if(! accept(buf, 58)) return d(0);
		                 var compl$0 = accept(buf, 94);
		                 try{
		                  a = names;
		                  for(;;){
		                   if(! a) throw caml_maybe_attach_backtrace(Not_found, 1);
		                   var l = a[2], class$ = a[1];
		                   if(accept_s(buf, class$)) break;
		                   a = l;
		                  }
		                 }
		                 catch(exn$1){
		                  var exn = caml_wrap_exception(exn$1);
		                  if(exn === Not_found){
		                   a = caml_pop_trap();
		                   var
		                    Parse_error$2 =
		                      caml_maybe_attach_backtrace(Parse_error$1, 1);
		                   return a(Parse_error$2);
		                  }
		                  a = caml_pop_trap();
		                  var exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                  return a(exn$0);
		                 }
		                 if(1 - accept_s(buf, ":]")){
		                  a = caml_pop_trap();
		                  var
		                   Parse_error$0 =
		                     caml_maybe_attach_backtrace(Parse_error$1, 1);
		                  return a(Parse_error$0);
		                 }
		                 var switch$ = caml_string_compare(class$, cst_lower);
		                 function b(posix_class){
		                  function a(a){return d([0, a]);}
		                  return compl$0
		                          ? caml_exact_trampoline_cps_call
		                            (compl, [0, posix_class, 0], a)
		                          : a(posix_class);
		                 }
		                 if(0 <= switch$){
		                  if(0 >= switch$) return b(lower);
		                  if(class$ === cst_print) return b(print);
		                  if(class$ === cst_punct) return b(punct);
		                  if(class$ === cst_space) return b(space$0);
		                  if(class$ === cst_upper) return b(upper$0);
		                  if(class$ === cst_word) return b(wordc);
		                  if(class$ === cst_xdigit) return b(xdigit);
		                 }
		                 else {
		                  if(class$ === cst_alnum) return b(alnum$0);
		                  if(class$ === cst_alpha) return b(alpha);
		                  if(class$ === cst_ascii) return b(ascii$0);
		                  if(class$ === cst_blank) return b(blank$0);
		                  if(class$ === cst_cntrl) return b(cntrl);
		                  if(class$ === cst_digit) return b(digit$0);
		                  if(class$ === cst_graph) return b(graph);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, "Invalid pcre class: " + class$, b);
		                }
		                return caml_exact_trampoline_cps_call
		                        (regexp,
		                         dummy,
		                         function(res){
		                          if(1 - eos$0(buf)){
		                           var
		                            raise = caml_pop_trap(),
		                            Parse_error = caml_maybe_attach_backtrace(Parse_error$1, 1);
		                           return raise(Parse_error);
		                          }
		                          var
		                           r =
		                             memq(616470068, opts)
		                              ? seq$1([0, start$0, [0, res, 0]])
		                              : res,
		                           r$0 = memq(604571177, opts) ? no_case(r) : r;
		                          return caml_exact_trampoline_cps_call(compile, r$0, cont);
		                         });
		               }
		               function quote(s){
		                var
		                 len = caml_ml_string_length(s),
		                 buf = caml_create_bytes(len << 1),
		                 b = len - 1 | 0,
		                 a = 0;
		                if(b < 0)
		                 var pos$4 = a;
		                else {
		                 var pos = a, i = 0;
		                 for(;;){
		                  var c = caml_string_unsafe_get(s, i);
		                  a:
		                  {
		                   b:
		                   {
		                    if(91 <= c){
		                     a = c - 93 | 0;
		                     if(29 < a >>> 0){
		                      if(32 <= a) break b;
		                     }
		                     else if(1 !== a) break b;
		                    }
		                    else
		                     if(47 <= c){
		                      if(63 !== c) break b;
		                     }
		                     else {
		                      if(36 > c) break b;
		                      switch(c - 36 | 0){
		                        case 1:
		                        case 2:
		                        case 3:
		                        case 8:
		                        case 9:
		                         break b;
		                      }
		                     }
		                    caml_bytes_unsafe_set(buf, pos, 92);
		                    var pos$1 = pos + 1 | 0;
		                    caml_bytes_unsafe_set(buf, pos$1, c);
		                    var pos$2 = pos$1 + 1 | 0, pos$3 = pos$2;
		                    break a;
		                   }
		                   caml_bytes_unsafe_set(buf, pos, c);
		                   var pos$0 = pos + 1 | 0, pos$3 = pos$0;
		                  }
		                  a = i + 1 | 0;
		                  if(b === i){pos$4 = pos$3; break;}
		                  pos = pos$3;
		                  i = a;
		                 }
		                }
		                var r = caml_create_bytes(pos$4);
		                caml_blit_bytes(buf, 0, r, 0, pos$4);
		                return caml_string_of_bytes(r);
		               }
		               function is_success(code){
		                var match = status_of_code(code);
		                a:
		                if(typeof match === "number"){
		                 if(-247210087 <= match){
		                  if(102779818 <= match){
		                   if
		                    (566851975 !== match
		                     && 893234971 !== match && 102779819 <= match)
		                    break a;
		                  }
		                  else if(-234002583 !== match && 17692 !== match) break a;
		                 }
		                 else
		                  if(-527633381 <= match){
		                   if
		                    (-330714374 !== match
		                     && -527633380 <= match && -247210088 > match)
		                    break a;
		                  }
		                  else if(-886248552 !== match && -558113336 !== match)
		                   break a;
		                 return 1;
		                }
		                return 0;
		               }
		               caml_callback(of_string$8, [cst$1]);
		               caml_callback(of_string$8, [cst$1]);
		               var buf$0 = create$23("[ \t]*\\([^ \t;]+\\)");
		               function test2(c, c$0){
		                var
		                 a =
		                   (buf$0[2] + 1 | 0) < caml_ml_string_length(buf$0[1]) ? 1 : 0;
		                if(a){
		                 a = caml_string_get(buf$0[1], buf$0[2]) === c ? 1 : 0;
		                 a =
		                  a
		                   ? caml_string_get
		                      (buf$0[1], buf$0[2] + 1 | 0)
		                     === c$0
		                     ? 1
		                     : 0
		                   : a;
		                }
		                return a;
		               }
		               function regexp(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (branch,
		                         dummy,
		                         function(b){
		                          var left = [0, b, 0];
		                          function a(left){
		                           return accept_s(buf$0, "\\|")
		                                   ? caml_exact_trampoline_cps_call
		                                     (branch,
		                                      dummy,
		                                      function(b){
		                                       var left$0 = [0, b, left];
		                                       return caml_exact_trampoline_call1(a, left$0);
		                                      })
		                                   : caml_exact_trampoline_cps_call(alt$1, rev(left), cont);
		                          }
		                          return a(left);
		                         });
		               }
		               function branch(param, cont){
		                function a(left){
		                 if(! eos$0(buf$0) && ! test2(92, 124) && ! test2(92, 41))
		                  return caml_exact_trampoline_cps_call
		                          (atom,
		                           dummy,
		                           function(r){
		                            function b(b){
		                             var left$0 = [0, b, left];
		                             return caml_exact_trampoline_call1(a, left$0);
		                            }
		                            return accept(buf$0, 42)
		                                    ? caml_exact_trampoline_cps_call(rep, r, b)
		                                    : accept
		                                       (buf$0, 43)
		                                      ? caml_exact_trampoline_cps_call(rep1, r, b)
		                                      : accept
		 (buf$0, 63)
		? caml_exact_trampoline_cps_call(opt, r, b)
		: b(r);
		                           });
		                 return cont(seq$1(rev(left)));
		                }
		                return a(0);
		               }
		               var cst$23 = "\\)";
		               function atom(a, cont){
		                if(accept(buf$0, 46)) return cont(notnl$0);
		                if(accept(buf$0, 94)) return cont(bol$0);
		                if(accept(buf$0, 36)) return cont(eol);
		                if(accept(buf$0, 91))
		                 return accept(buf$0, 94)
		                         ? caml_exact_trampoline_cps_call
		                           (bracket,
		                            0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call(compl, a, cont);
		                            })
		                         : caml_exact_trampoline_cps_call
		                           (bracket,
		                            0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call(alt$1, a, cont);
		                            });
		                if(! accept(buf$0, 92)){
		                 if(eos$0(buf$0)){
		                  a = caml_pop_trap();
		                  var
		                   Parse_error$1 =
		                     caml_maybe_attach_backtrace(Parse_error$2, 1);
		                  return a(Parse_error$1);
		                 }
		                 var c = get$8(buf$0);
		                 a:
		                 {
		                  if(44 <= c){if(63 !== c) break a;} else if(42 > c) break a;
		                  a = caml_pop_trap();
		                  var
		                   Parse_error$3 =
		                     caml_maybe_attach_backtrace(Parse_error$2, 1);
		                  return a(Parse_error$3);
		                 }
		                 return cont(f$7(c));
		                }
		                if(accept(buf$0, 40))
		                 return caml_exact_trampoline_cps_call
		                         (regexp,
		                          dummy,
		                          function(r){
		                           if(! (1 - accept_s(buf$0, cst$23))) return cont([4, 0, r]);
		                           var
		                            raise = caml_pop_trap(),
		                            Parse_error = caml_maybe_attach_backtrace(Parse_error$2, 1);
		                           return raise(Parse_error);
		                          });
		                if(accept(buf$0, 96)) return cont(bos$0);
		                if(accept(buf$0, 39)) return cont(eos);
		                if(accept(buf$0, 61)) return cont(start$0);
		                if(accept(buf$0, 98))
		                 return caml_exact_trampoline_cps_call
		                         (alt$1, [0, bow$0, [0, eow, 0]], cont);
		                if(accept(buf$0, 66)) return cont(not_boundary);
		                if(accept(buf$0, 60)) return cont(bow$0);
		                if(accept(buf$0, 62)) return cont(eow);
		                if(accept(buf$0, 119))
		                 return caml_exact_trampoline_cps_call
		                         (alt$1, [0, alnum$0, [0, f$7(95), 0]], cont);
		                if(accept(buf$0, 87))
		                 return caml_exact_trampoline_cps_call
		                         (compl, [0, alnum$0, [0, f$7(95), 0]], cont);
		                if(eos$0(buf$0)){
		                 a = caml_pop_trap();
		                 var
		                  Parse_error = caml_maybe_attach_backtrace(Parse_error$2, 1);
		                 return a(Parse_error);
		                }
		                var c$0 = get$8(buf$0);
		                a:
		                {
		                 if(63 <= c$0){
		                  if(91 <= c$0){
		                   if(95 <= c$0) break a;
		                  }
		                  else if(64 <= c$0) break a;
		                 }
		                 else {
		                  if(48 <= c$0){
		                   if(58 <= c$0) break a;
		                   a = caml_pop_trap();
		                   var
		                    Not_supported$0 =
		                      caml_maybe_attach_backtrace(Not_supported, 1);
		                   return a(Not_supported$0);
		                  }
		                  if(36 > c$0) break a;
		                  switch(c$0 - 36 | 0){
		                    case 0:
		                    case 6:
		                    case 7:
		                    case 10: break;
		                    default: break a;
		                  }
		                 }
		                 return cont(f$7(c$0));
		                }
		                a = caml_pop_trap();
		                var
		                 Parse_error$0 = caml_maybe_attach_backtrace(Parse_error$2, 1);
		                return a(Parse_error$0);
		               }
		               function bracket(s, cont){
		                function a(s){
		                 if(0 !== s && accept(buf$0, 93)) return cont(s);
		                 var c = char$3();
		                 if(! accept(buf$0, 45)){
		                  var s$0 = [0, f$7(c), s];
		                  return caml_exact_trampoline_call1(a, s$0);
		                 }
		                 if(accept(buf$0, 93)){
		                  var b = [0, f$7(45), s];
		                  return cont([0, f$7(c), b]);
		                 }
		                 var c$0 = char$3();
		                 return caml_exact_trampoline_cps_call
		                         (chr,
		                          max$0(c, c$0),
		                          function(c$0){
		                           var s$0 = [0, rg$0(c, c$0), s];
		                           return caml_exact_trampoline_call1(a, s$0);
		                          });
		                }
		                return a(s);
		               }
		               function char$3(param){
		                if(eos$0(buf$0))
		                 throw caml_maybe_attach_backtrace(Parse_error$2, 1);
		                return get$8(buf$0);
		               }
		               var res$0 = caml_callback(regexp, [dummy]);
		               if(1 - eos$0(buf$0)){
		                d = caml_pop_trap();
		                var
		                 Parse_error$5 = caml_maybe_attach_backtrace(Parse_error$2, 1);
		                return d(Parse_error$5);
		               }
		               var re$0 = res$0 ;
		               caml_callback(compile, [seq$1([0, start$0, [0, re$0, 0]])]);
		               caml_callback
		                (caml_callback(sprintf, [qy]), ["v2.5.4-875-ge39bb0a"]);
		               function read_rest(x, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub,
		                         x[1],
		                         x[2],
		                         x[3] - x[2] | 0,
		                         function(s){x[2] = x[3]; return cont(s);});
		               }
		               function make$14(d, c, b, opt, param, cont){
		                var
		                 version = d ? d[1] : 540315116,
		                 status = c ? c[1] : 17692,
		                 encoding = b ? b[1] : 1,
		                 headers = opt ? opt[1] : 0;
		                a:
		                {
		                 b:
		                 if(typeof status === "number"){
		                  if(-498198474 <= status){
		                   if
		                    (-387970219 !== status
		                     && 192584839 !== status && 973294248 !== status)
		                    break b;
		                  }
		                  else if
		                   (-1021676630 !== status
		                    && -840540685 !== status && -527633381 > status)
		                   break b;
		                  var body_allowed = 0;
		                  break a;
		                 }
		                 body_allowed = 1;
		                }
		                function a(headers){
		                 return cont([0, headers, version, status]);
		                }
		                if(! body_allowed) return a(headers);
		                if(typeof encoding === "number" && encoding)
		                 return caml_exact_trampoline_cps_call
		                         (get_transfer_encoding,
		                          headers,
		                          function(match){
		                           return typeof match === "number"
		                                   ? match
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (add_transfer_encoding, headers, 0, a)
		                                     : a(headers)
		                                   : a(headers);
		                          });
		                return caml_exact_trampoline_cps_call$1
		                        (add_transfer_encoding, headers, encoding, a);
		               }
		               function kmsg$0(k, a, level$0, msgf, cont){
		                var src = a ? a[1] : default$4;
		                if(3 > level$0)
		                 switch(level$0){
		                   case 1:
		                    incr(err_count); break;
		                   case 2:
		                    incr(warn_count); break;
		                 }
		                a = level(src);
		                if(! a) return caml_trampoline_cps_call2(k, 0, cont);
		                var current_level = a[1];
		                if(current_level < level$0)
		                 return caml_trampoline_cps_call2(k, 0, cont);
		                a = wait();
		                var unblock = a[2], ret = a[1];
		                function k$0(param, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol_bind$6, ret, k, cont);
		                }
		                function over(param, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (wakeup, unblock, 0, cont);
		                }
		                return caml_exact_trampoline_cps_call$3
		                        (report, src, level$0, over, k$0, msgf, cont);
		               }
		               function kunit$0(param, cont){
		                return caml_exact_trampoline_cps_call(return$10, 0, cont);
		               }
		               function src_log$0(src){
		                function msg(level, msgf, cont){
		                 var src$0 = [0, src];
		                 return caml_exact_trampoline_cps_call$2
		                         (kmsg$0, kunit$0, src$0, level, msgf, cont);
		                }
		                function err(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 1, msgf, cont);
		                }
		                function warn(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 2, msgf, cont);
		                }
		                function info(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 3, msgf, cont);
		                }
		                function debug(msgf, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 4, msgf, cont);
		                }
		                return [0, msg, , err, warn, info, debug];
		               }
		               function read_line(ic, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call(return$10, a, cont);
		                }
		                if(ic[2] >= ic[3]) return a(0);
		                var start = ic[2];
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call
		                           (read_rest, ic, function(b){return a([0, b]);});
		                  });
		                for(;;){
		                 if(10 === caml_string_get(ic[1], ic[2])) break;
		                 ic[2] = ic[2] + 1 | 0;
		                }
		                a:
		                {
		                 if(0 < ic[2] && 13 === caml_string_get(ic[1], ic[2] - 1 | 0)){var l = (ic[2] - start | 0) - 1 | 0; break a;}
		                 l = ic[2] - start | 0;
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub,
		                         ic[1],
		                         start,
		                         l,
		                         function(s){
		                          ic[2] = ic[2] + 1 | 0;
		                          caml_pop_trap();
		                          return a([0, s]);
		                         });
		               }
		               function create_stream(fn, arg){
		                var fin = [0, 0];
		                return from
		                        (function(param, cont){
		                          if(fin[1]) return cont(return_none);
		                          function a(param, cont){
		                           if(typeof param === "number") return cont(return_none);
		                           if(0 === param[0]){
		                            var c = param[1];
		                            return caml_exact_trampoline_cps_call
		                                    (return$10, [0, c], cont);
		                           }
		                           var c$0 = param[1];
		                           fin[1] = 1;
		                           return caml_exact_trampoline_cps_call
		                                   (return$10, [0, c$0], cont);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (fn,
		                                   dummy,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_bind$6, b, a, cont);
		                                   });
		                         });
		               }
		               function to_string$22(body, cont){
		                if(typeof body !== "number"){
		                 var variant$0 = body[1];
		                 if(-976970511 > variant$0){
		                  var
		                   s$0 = body[2],
		                   b = create$1(1024),
		                   f =
		                     function(a, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (write_stringlit, b, a, cont);
		                     },
		                   c =
		                     function(param, cont){
		                      return caml_exact_trampoline_cps_call
		                              (contents,
		                               b,
		                               function(a){
		                                return caml_exact_trampoline_cps_call(return$10, a, cont);
		                               });
		                     };
		                  return caml_exact_trampoline_cps_call$0
		                          (iter_rec,
		                           s$0[4],
		                           f,
		                           s$0,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, a, c, cont);
		                           });
		                 }
		                }
		                function a(a){
		                 return caml_exact_trampoline_cps_call(return$10, a, cont);
		                }
		                if(typeof body === "number") return a(cst$1);
		                var variant = body[1];
		                if(-968575390 <= variant){
		                 var sl = body[2];
		                 return caml_exact_trampoline_cps_call$1(concat, cst$1, sl, a);
		                }
		                var s = body[2];
		                return a(s);
		               }
		               function of_string$15(s){return [0, -976970511, s];}
		               function drain_body(body, cont){
		                if(typeof body !== "number"){
		                 var variant = body[1];
		                 if(-976970511 > variant){
		                  var s = body[2], f = function(param){return 1;};
		                  return caml_exact_trampoline_cps_call$0
		                          (junk_while_rec, s[4], f, s, cont);
		                 }
		                }
		                return cont(return_unit);
		               }
		               function of_stream(s){return [0, -977172320, s];}
		               function get_timezone_offset(date, cont){
		                var offset = date.getTimezoneOffset();
		                return offset !== offset
		                        ? cont(0)
		                        : caml_exact_trampoline_cps_call(of_float, offset, cont);
		               }
		               var
		                fmt$301 = new dateTimeFormat_constr(undefined$, undefined$),
		                options = fmt$301.resolvedOptions(0),
		                name$11 = caml_string_of_jsstring(options.timeZone);
		               function offset_calendar_time_s(a, param, cont){
		                var
		                 seconds = param[3],
		                 minutes = param[2],
		                 hours = param[1],
		                 day = a[3],
		                 month = a[2],
		                 year = a[1];
		                return caml_exact_trampoline_cps_call
		                        (of_tuple$0,
		                         [0, year, month, day],
		                         function(a){
		                          a = is_ok(a);
		                          function b(is_input_ok){
		                           function a(a){
		                            var
		                             t8 = month - 1 | 0,
		                             js_date =
		                               new
		                                date_fromTimeValue
		                                (year, t8, day, hours, minutes, seconds);
		                            return caml_exact_trampoline_cps_call
		                                    (get_timezone_offset,
		                                     js_date,
		                                     function(a){return cont((a * 60 | 0) * -1 | 0);});
		                           }
		                           return is_input_ok
		                                   ? a()
		                                   : caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      failwith,
		                                      fmt$48,
		                                      function(b){
		                                       return caml_trampoline_cps_call7
		       (b, year, month, day, hours, minutes, seconds, a);
		                                      });
		                          }
		                          return a
		                                  ? caml_exact_trampoline_cps_call
		                                    (of_tuple$1,
		                                     [0, hours, minutes, seconds],
		                                     function(a){return b(is_ok(a));})
		                                  : b(a);
		                         });
		               }
		               function offset_timestamp_s(unix_timestamp, cont){
		                var
		                 t14 = caml_int64_to_float(unix_timestamp) * 1000.,
		                 js_date = new date_fromTimeValue(t14);
		                return caml_exact_trampoline_cps_call
		                        (get_timezone_offset,
		                         js_date,
		                         function(a){return cont((a * 60 | 0) * -1 | 0);});
		               }
		               var
		                timezone_local =
		                  [0, name$11, offset_calendar_time_s, offset_timestamp_s];
		               function today(param, cont){
		                var t = ocaml_ptime_clock_now_d_ps();
		                return caml_exact_trampoline_cps_call$1
		                        (of_time$0, timezone_local, t, cont);
		               }
		               function wakeup$0(param, cont){
		                if(1 !== param) return cont(0);
		                var t1 = caml_js_wrap_callback(wakeup_paused);
		                global.setTimeout(t1, 0.);
		                return cont(0);
		               }
		               pause_hook[1] = wakeup$0;
		               function prerr_string(s){
		                var t4 = caml_jsstring_of_string(s);
		                console.log(t4);
		               }
		               async_exception_hook[1] =
		                function(exn, cont){
		                 prerr_string("Exception during Lwt.async: ");
		                 return caml_exact_trampoline_cps_call
		                         (to_string$0,
		                          exn,
		                          function(a){
		                           prerr_string(a);
		                           return caml_exact_trampoline_cps_call
		                                   (print_backtrace, stderr, cont);
		                          });
		                };
		               function sleep(seconds, cont){
		                var
		                 d$0 = to_float_s(seconds),
		                 match = task(),
		                 w = match[2],
		                 t = match[1],
		                 d = d$0 * 1000.;
		                function callback(a, cont){
		                 return caml_exact_trampoline_cps_call$1(wakeup, w, a, cont);
		                }
		                var id = [0, 0];
		                function loop(d, param){
		                 if(2147483000. < d)
		                  var remain = d - 2147483000., step = 2147483000.;
		                 else {remain = 0.; step = d;}
		                 var
		                  cb =
		                    remain === 0.
		                     ? callback
		                     : function(a, cont){return cont(loop(remain));},
		                  t171 = caml_js_wrap_callback(cb);
		                 id[1] = [0, global.setTimeout(t171, step)];
		                 return 0;
		                }
		                loop(d);
		                return caml_exact_trampoline_cps_call$1
		                        (on_cancel,
		                         t,
		                         function(a, cont){
		                          a = id[1];
		                          if(! a) return cont(0);
		                          var t174 = a[1];
		                          id[1] = 0;
		                          return cont(global.clearTimeout(t174));
		                         },
		                         function(a){return cont(t);});
		               }
		               function pp_reason$0(pp, f){
		                return function(param, cont){
		                 if(typeof param === "number")
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string, f, "connectivity or CORS error", cont);
		                 var variant = param[1];
		                 if(804243368 <= variant){
		                  var e = param[2];
		                  return caml_exact_trampoline_cps_call$1(pp, f, e, cont);
		                 }
		                 var e$0 = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          qC,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, pp_decoding, e$0, cont);
		                          });};
		               }
		               function pp$24(pp_reason, ppf, param, cont){
		                var
		                 uri = param[4],
		                 reason = param[2],
		                 method = param[1],
		                 v = string_of_method(method),
		                 indent = opt$8[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_open_box,
		                         ppf,
		                         indent,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   ppf,
		                                   v,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_char,
		     ppf,
		     32,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_v,
		               ppf,
		               uri,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_char,
		                         ppf,
		                         58,
		                         function(a){
		                          pp_v1(ppf);
		                          return caml_trampoline_cps_call3
		                                  (pp_reason,
		                                   ppf,
		                                   reason,
		                                   function(a){return cont(pp_close_box(ppf));});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                src$1 = create$18(qD, "schematic-http"),
		                Logs = src_log$0(src$1);
		               function bind$19(v, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$7, v, f, cont);
		               }
		               var
		                map$31 =
		                  [0,
		                   ,
		                   function(v, f, cont){
		                    return caml_exact_trampoline_cps_call$1(map$21, f, v, cont);
		                   }],
		                include$41 = Make2([0, bind$19, map$31, return$11]),
		                symbol_bind$14 = include$41[1],
		                bind$20 = include$41[5],
		                return$19 = include$41[6],
		                map$32 = include$41[7];
		               function bQW(a, cont){
		                return caml_exact_trampoline_cps_call$1(fmt$0, qE, a, cont);
		               }
		               function pp_uid(a, b, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (option, 0, bQW, a, b, cont);
		               }
		               function with_timeout
		               (opt, method, f, name, uid, uri, timeout, v, cont){
		                var cancel$0 = opt ? opt[1] : 0;
		                if(! timeout) return cont(v);
		                var timeout$0 = timeout[1];
		                function a(param, cont){
		                 if(param){
		                  var
		                   v = param[1],
		                   a =
		                     function(a){
		                      return caml_exact_trampoline_cps_call(return$10, v, cont);
		                     };
		                  return cancel$0
		                          ? caml_exact_trampoline_cps_call(cancel, timeout$0, a)
		                          : a(0);
		                 }
		                 function f$0(param, cont){
		                  return caml_exact_trampoline_cps_call
		                          (f, [1, [0, method, -610669292, 0, uri]], cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (Logs[4],
		                          function(m, cont){
		                           return caml_trampoline_cps_call10
		                                   (m,
		                                    0,
		                                    0,
		                                    qF,
		                                    pp_uid,
		                                    uid,
		                                    name,
		                                    string_of_method(method),
		                                    pp_v,
		                                    uri,
		                                    cont);
		                          },
		                          function(p){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$90, f$0, p, cont);
		                          });
		                }
		                function f$0(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$90,
		                         f$0,
		                         timeout$0,
		                         function(c){
		                          var b = [0, c, 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$90,
		                                   return$4,
		                                   v,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (choose,
		     [0, c, b],
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol_bind$6, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function stream_schema(param){
		                var
		                 descriptor =
		                   [4,
		                    function(param, cont){
		                     return caml_exact_trampoline_cps_call
		                             (of_list$5, 0, function(a){return cont();});
		                    },
		                    function(param){},
		                    3];
		                return [0, id$9, 0, descriptor, 0];
		               }
		               function Make_requests(Call){
		                var call = Call[1];
		                function get(timeout, headers, body, response, uri, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (call, timeout, headers, body, response, 3546230, uri, cont);
		                }
		                function post(timeout, headers, body, response, uri, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (call,
		                          timeout,
		                          headers,
		                          body,
		                          response,
		                          891112544,
		                          uri,
		                          cont);
		                }
		                return [0, , , get, , , post];
		               }
		               function Map_error(Handler, E){
		                var
		                 Body = Handler[1],
		                 Coding = Handler[2],
		                 Monad = Handler[3],
		                 send_content_length = Handler[4];
		                function raw(timeout, headers, body, meth, uri, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (Handler[5],
		                          timeout,
		                          headers,
		                          body,
		                          meth,
		                          uri,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map_error$0,
		                                    function(error, cont){
		                                     var a = error[2];
		                                     if(typeof a !== "number"){
		                                      var variant = a[1];
		                                      if(804243368 <= variant){
		                                       var
		reason = a[2],
		a = error[4],
		b = error[3],
		c = [0, 804243368, E[1].call(null, reason)];
		                                       return cont([0, error[1], c, b, a]);
		                                      }
		                                     }
		                                     return cont(error);
		                                    },
		                                    a,
		                                    cont);
		                          });
		                }
		                return [0, Body, Coding, Monad, send_content_length, raw];
		               }
		               var empty$32 = [0, 0, 0, 3, 0], string$7 = [0, 0, 0, 8, 0];
		               function Make$9(Handler){
		                var
		                 Body = Handler[1],
		                 Coding = Handler[2],
		                 raw = Handler[5],
		                 stream = stream_schema(),
		                 stream_response = stream_schema();
		                function call(timeout, a, body, response, method, uri, cont){
		                 var headers = a ? a[1] : 0;
		                 function content_length(l, headers){
		                  return Handler[4]
		                          ? [0, [0, "Content-Length", "" + l], headers]
		                          : headers;
		                 }
		                 function b(body, headers){
		                  function a(headers){
		                   function a(a, cont){
		                    var body = a[2], resp = a[1], a = response[3];
		                    function b(body){
		                     return caml_trampoline_cps_call3
		                             (Handler[3][7],
		                              body,
		                              function(body, cont){return cont([0, body, resp]);},
		                              cont);
		                    }
		                    if
		                     (typeof a === "number" && 3 === a && response === empty$32){
		                     var
		                      c =
		                        function(param, cont){
		                         return caml_trampoline_cps_call2(Handler[3][6], 0, cont);
		                        };
		                     return caml_exact_trampoline_cps_call
		                             (Body[1],
		                              body,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (symbol_bind$6, a, c, b);
		                              });
		                    }
		                    if(response === stream)
		                     return caml_exact_trampoline_cps_call
		                             (Body[3],
		                              body,
		                              function(a){
		                               a =
		                                map$20
		                                 (function(param, cont){
		                                   if(0 === param[0]){
		                                    var chunk = param[1];
		                                    return cont(chunk);
		                                   }
		                                   var error = param[1];
		                                   function a(a, cont){return cont(pp_reason$0(pp_none, a));}
		                                   function b(b, c, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (pp$24, a, b, c, cont);
		                                   }
		                                   return caml_exact_trampoline_cps_call$1
		   (kasprintf,
		    failwith,
		    fmt$49,
		    function(a){
		     return caml_trampoline_cps_call5
		             (a, pp_v, uri, b, error, cont);
		    });
		                                  },
		                                  a);
		                               return caml_trampoline_cps_call2(Handler[3][6], a, b);
		                              });
		                    if(response === stream_response)
		                     return caml_exact_trampoline_cps_call
		                             (Body[3],
		                              body,
		                              function(a){
		                               return caml_trampoline_cps_call2(Handler[3][6], a, b);
		                              });
		                    if
		                     (typeof a === "number" && 8 === a && response === string$7){
		                     var
		                      d =
		                        function(body, cont){
		                         return caml_trampoline_cps_call2(Handler[3][6], body, cont);
		                        };
		                     return caml_exact_trampoline_cps_call
		                             (Body[2],
		                              body,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (symbol_bind$14, a, d, b);
		                              });
		                    }
		                    function e(body, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (Coding[4],
		                              response,
		                              body,
		                              function(match){
		                               if(0 === match[0]){
		                                var body = match[1];
		                                return caml_trampoline_cps_call2(Handler[3][6], body, cont);
		                               }
		                               var e = match[1], status = [0, resp[3]];
		                               return caml_exact_trampoline_cps_call
		                                       (fail$2, [0, method, [0, -627660277, e], status, uri], cont);
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (Body[2],
		                             body,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (symbol_bind$14, a, e, b);
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$3
		                           (raw,
		                            timeout,
		                            [0, headers],
		                            body,
		                            method,
		                            uri,
		                            function(b){
		                             return caml_trampoline_cps_call3(Handler[3][5], b, a, cont);
		                            });
		                  }
		                  function b(param){
		                   function c(b){
		                    return is_none(b)
		                            ? a([0, [0, "Content-Type", Handler[2][5]], headers])
		                            : a(headers);
		                   }
		                   if(! param) return c(0);
		                   var l = param[2], x = param[1], name = x[1];
		                   return caml_exact_trampoline_cps_call
		                           (lowercase_ascii$0,
		                            name,
		                            function(a){
		                             return a === cst_content_type
		                                     ? c([0, x])
		                                     : caml_exact_trampoline_call1(b, l);
		                            });
		                  }
		                  return body ? b(headers) : a(headers);
		                 }
		                 if(body){
		                  a = body[1];
		                  var schema = a[1], s = a[2];
		                  if(schema === stream)
		                   return b([0, Body[5].call(null, method, uri, s)], headers);
		                  var match = schema[3];
		                  if(typeof match === "number" && 8 === match){
		                   var s$0 = a[2];
		                   if(schema === string$7){
		                    var
		                     headers$0 =
		                       content_length(caml_ml_string_length(s$0), headers);
		                    return b
		                            ([0, Body[4].call(null, method, uri, s$0)], headers$0);
		                   }
		                  }
		                  var value = a[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (Coding[2],
		                           schema,
		                           value,
		                           function(body){
		                            var
		                             headers$0 =
		                               content_length(caml_ml_string_length(body), headers);
		                            return b
		                                    ([0, Body[4].call(null, method, uri, body)], headers$0);
		                           });
		                 }
		                 a:
		                 if(typeof method === "number"){
		                  if
		                   (3997359 !== method
		                    && 891112544 !== method && 994393768 !== method)
		                   break a;
		                  var headers$1 = content_length(0, headers);
		                  return b(0, headers$1);
		                 }
		                 return b(0, headers);
		                }
		                function call$0
		                (timeout, opt, body, response, method, uri, cont){
		                 var headers = opt ? opt[1] : 0;
		                 return caml_exact_trampoline_cps_call$7
		                         (call,
		                          timeout,
		                          [0, headers],
		                          body,
		                          response,
		                          method,
		                          uri,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (Handler[3][7],
		                                    a,
		                                    function(a, cont){
		                                     var resp = a[2], body = a[1], h = resp[1], a = resp[3];
		                                     return cont([0, body, rev(h), a]);
		                                    },
		                                    cont);
		                          });
		                }
		                var
		                 include = Make_requests([0, call$0]),
		                 get = include[3],
		                 post = include[6];
		                function call$1
		                (timeout, opt, body, response, method, uri, cont){
		                 var headers = opt ? opt[1] : 0;
		                 return caml_exact_trampoline_cps_call$7
		                         (call,
		                          timeout,
		                          [0, headers],
		                          body,
		                          response,
		                          method,
		                          uri,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (Handler[3][7],
		                                    a,
		                                    function(param, cont){
		                                     var body = param[1];
		                                     return cont(body);
		                                    },
		                                    cont);
		                          });
		                }
		                var
		                 include$0 = Make_requests([0, call$1]),
		                 get$0 = include$0[3];
		                return [0,
		                        ,
		                        ,
		                        string$7,
		                        ,
		                        [0, , , , get, , , post],
		                        ,
		                        ,
		                        get$0];
		               }
		               function bQX(a, cont){
		                return caml_exact_trampoline_cps_call$1(fmt$0, qU, a, cont);
		               }
		               var bQY = [0, pp_none];
		               function pp_retry(ppf, v, cont){
		                var a = 1 < v ? [0, v] : 0;
		                return caml_exact_trampoline_cps_call$2
		                        (option, bQY, bQX, ppf, a, cont);
		               }
		               function Check_status(Status, Handler){
		                var
		                 Body = Handler[1],
		                 Coding = Handler[2],
		                 Monad = Handler[3],
		                 send_content_length = Handler[4];
		                function raw(timeout, headers, body, method, uri, cont){
		                 function f(r, cont){
		                  var body = r[2], resp = r[1], status = resp[3];
		                  a:
		                  {
		                   var a = Status[1].call(null, status);
		                   for(;;){
		                    if(typeof a === "number")
		                     return caml_trampoline_cps_call2(Monad[6], r, cont);
		                    var variant = a[1];
		                    if(-129353909 > variant) break;
		                    if(106380200 <= variant) break a;
		                    var schema = a[2];
		                    a =
		                     [0,
		                      -914833977,
		                      [0, schema, function(e, cont){return cont(e);}]];
		                   }
		                   if(-679826326 <= variant){
		                    var
		                     f = a[2],
		                     c =
		                       function(param, cont){
		                        var status$0 = [0, status];
		                        return caml_trampoline_cps_call2
		                                (f,
		                                 resp,
		                                 function(a){
		                                  var reason = [0, 804243368, [0, a]];
		                                  return caml_exact_trampoline_cps_call
		  (fail$2, [0, method, reason, status$0, uri], cont);
		                                 });
		                       };
		                    return caml_exact_trampoline_cps_call
		                            (Logs[4],
		                             function(m, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (string_of_status,
		                                       status,
		                                       function(a){
		return caml_trampoline_cps_call7
		        (m, 0, 0, q0, a, pp_v, uri, cont);
		                                       });
		                             },
		                             function(left){
		                              return caml_exact_trampoline_cps_call
		                                      (Body[1],
		                                       body,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (both$0,
		         left,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (symbol_bind$6, a, c, cont);
		         });
		                                       });
		                             });
		                   }
		                   a = a[2];
		                   var
		                    decode = a[2],
		                    schema$0 = a[1],
		                    d =
		                      function(param, cont){
		                       function a(body, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (Handler[2][4],
		                                 schema$0,
		                                 body,
		                                 function(match){
		                                  if(0 === match[0]){
		                                   var error = match[1], status$0 = [0, status];
		                                   return caml_trampoline_cps_call2
		   (decode,
		    error,
		    function(a){
		     var reason = [0, 804243368, [0, a]];
		     return caml_exact_trampoline_cps_call
		             (fail$2, [0, method, reason, status$0, uri], cont);
		    });
		                                  }
		                                  var e = match[1], a = e[3];
		                                  return caml_exact_trampoline_cps_call$1
		  (kasprintf,
		   id,
		   fmt$51,
		   function(b){
		    return caml_trampoline_cps_call2
		            (b,
		             a,
		             function(a){
		              var e$0 = [0, e[1], e[2], a];
		              return caml_exact_trampoline_cps_call
		                      (fail$2,
		                       [0, method, [0, -627660277, e$0], [0, status], uri],
		                       cont);
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (Body[2],
		                                body,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call$1
		 (symbol_bind$14, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (Logs[4],
		                            function(m, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (string_of_status,
		                                      status,
		                                      function(a){
		                                       return caml_trampoline_cps_call7
		       (m, 0, 0, q1, a, pp_v, uri, cont);
		                                      });
		                            },
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol_bind$6, a, d, cont);
		                            });
		                  }
		                  var error = a[2];
		                  function b(param, cont){
		                   return caml_exact_trampoline_cps_call
		                           (fail$2,
		                            [0, method, [0, 804243368, [0, error]], [0, status], uri],
		                            cont);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (Logs[4],
		                           function(m, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (string_of_status,
		                                     status,
		                                     function(a){
		                                      return caml_trampoline_cps_call7
		      (m, 0, 0, qZ, a, pp_v, uri, cont);
		                                     });
		                           },
		                           function(left){
		                            return caml_exact_trampoline_cps_call
		                                    (Body[1],
		                                     body,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (both$0,
		       left,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (symbol_bind$6, a, b, cont);
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$3
		                         (Handler[5],
		                          timeout,
		                          headers,
		                          body,
		                          method,
		                          uri,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map_error$0,
		                                    function(error, cont){
		                                     var match = error[2];
		                                     if(typeof match !== "number"){
		                                      var variant = match[1];
		                                      if(804243368 <= variant){
		                                       var e = match[2];
		                                       return cont
		       ([0, error[1], [0, 804243368, [1, e]], error[3], error[4]]);
		                                      }
		                                     }
		                                     return cont(error);
		                                    },
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(Handler[3][5], a, f, cont);
		                                    });
		                          });
		                }
		                return [0, Body, Coding, Monad, send_content_length, raw];
		               }
		               function check$0(status){
		                return is_success(code_of_status(status))
		                        ? 17724
		                        : [0, 106380200, status];
		               }
		               function With_timeout(Timeout, Handler){
		                var
		                 Body = Handler[1],
		                 Coding = Handler[2],
		                 Monad = Handler[3],
		                 send_content_length = Handler[4];
		                function raw(timeout, a, body, method, uri, cont){
		                 var
		                  headers = a ? a[1] : 0,
		                  a = [0, value(timeout, Timeout[1])];
		                 return caml_exact_trampoline_cps_call$3
		                         (Handler[5], a, [0, headers], body, method, uri, cont);
		                }
		                return [0, Body, Coding, Monad, send_content_length, raw];
		               }
		               var uid = [0, 0];
		               function Cohttp(Client, Coding){
		                function exn(action, method, uri, e, cont){
		                 a:
		                 if(e[1] === Unix_error){
		                  var e$0 = e[2];
		                  if(typeof e$0 === "number"){
		                   if(32 <= e$0){
		                    if(51 !== e$0 && 59 !== e$0) break a;
		                   }
		                   else if(3 !== e$0 && 31 > e$0) break a;
		                   var
		                    a =
		                      function(param, cont){
		                       return caml_exact_trampoline_cps_call
		                               (fail$2, [0, method, -610669292, status, uri], cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (Logs[5],
		                            function(m, cont){
		                             return caml_trampoline_cps_call8
		                                     (m,
		                                      0,
		                                      0,
		                                      qG,
		                                      action,
		                                      pp_v,
		                                      uri,
		                                      unix_error_message(e$0),
		                                      cont);
		                            },
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol_bind$6, b, a, cont);
		                            });
		                  }
		                 }
		                 function b(param, cont){
		                  return caml_exact_trampoline_cps_call
		                          (fail$2, [0, method, -610669292, 0, uri], cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (Logs[4],
		                          function(m, cont){
		                           return caml_trampoline_cps_call9
		                                   (m, 0, 0, qH, action, pp_v, uri, pp$1, e, cont);
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol_bind$6, a, b, cont);
		                          });
		                }
		                function catch$0(action, method, uri, f, cont){
		                 function f$0(param, cont){
		                  function a(param, cont){
		                   if(0 === param[0]){
		                    var ok = param[1];
		                    return caml_exact_trampoline_cps_call(return$10, ok, cont);
		                   }
		                   var e = param[1];
		                   function a(param, cont){
		                    return caml_exact_trampoline_cps_call
		                            (fail$2, [0, method, -610669292, 0, uri], cont);
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (Logs[5],
		                            function(m, cont){
		                             return caml_trampoline_cps_call9
		                                     (m, 0, 0, qI, action, pp_v, uri, Client[1][10], e, cont);
		                            },
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol_bind$6, b, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (Client[1][9],
		                           f,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (catch$,
		                          f$0,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (exn, action, method, uri, a, cont);
		                          },
		                          cont);
		                }
		                function of_string(method, uri, s){
		                 return [0, of_string$15(s), method, 0, 0, uri];
		                }
		                function of_stream$0(method, uri, s){
		                 return [0, of_stream(s), method, 0, 0, uri];
		                }
		                var cst_reading_body = "reading body";
		                function to_string(param, cont){
		                 var
		                  uri = param[5],
		                  uid = param[4],
		                  timeout = param[3],
		                  method = param[2],
		                  cohttp = param[1];
		                 return caml_exact_trampoline_cps_call$2
		                         (catch$0,
		                          "reading body of",
		                          method,
		                          uri,
		                          function(param, cont){
		                           function a(body, cont){
		                            function a(param, cont){
		                             return caml_trampoline_cps_call2(return$19, body, cont);
		                            }
		                            return caml_exact_trampoline_cps_call
		                                    (Logs[6],
		                                     function(m, cont){
		                                      return caml_trampoline_cps_call8
		      (m, 0, 0, qJ, pp_uid, uid, lines, body, cont);
		                                     },
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol_bind$6, b, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$22,
		                                    cohttp,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_bind$6,
		      b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$9
		               (with_timeout,
		                qK,
		                method,
		                function(a, cont){return cont(a);},
		                cst_reading_body,
		                uid,
		                uri,
		                timeout,
		                a,
		                cont);
		      });
		                                    });
		                          },
		                          cont);
		                }
		                function to_stream(param, cont){
		                 var
		                  uri = param[5],
		                  uid = param[4],
		                  timeout = param[3],
		                  method = param[2],
		                  cohttp = param[1];
		                 function a(a){
		                  var
		                   body =
		                     map_s
		                      (function(ok, cont){
		                        if(0 === ok[0])
		                         return caml_exact_trampoline_cps_call(return$10, ok, cont);
		                        var e = ok[1];
		                        return caml_exact_trampoline_cps_call$2
		                                (exn, "streaming body of", method, uri, e, cont);
		                       },
		                       wrap_exn(a));
		                  return cont
		                          (from
		                            (function(param, cont){
		                              function a(chunk, cont){
		                               if(! chunk){
		                                var f = function(param, cont){return cont(0);};
		                                return caml_exact_trampoline_cps_call
		(Logs[5],
		 function(m, cont){
		  return caml_trampoline_cps_call6
		          (m, 0, 0, qN, pp_uid, uid, cont);
		 },
		 function(p){
		  return caml_exact_trampoline_cps_call$1
		          (symbol$90, f, p, cont);
		 });
		                               }
		                               var match = chunk[1];
		                               if(0 === match[0]){
		                                var
		                                 body = match[1],
		                                 a =
		                                   function(param, cont){
		                                    return caml_exact_trampoline_cps_call
		    (return$10, chunk, cont);
		                                   };
		                                return caml_exact_trampoline_cps_call
		(Logs[6],
		 function(m, cont){
		  return caml_trampoline_cps_call8
		          (m, 0, 0, qL, pp_uid, uid, lines, body, cont);
		 },
		 function(b){
		  return caml_exact_trampoline_cps_call$1
		          (symbol_bind$6, b, a, cont);
		 });
		                               }
		                               function b(param, cont){
		                                return caml_exact_trampoline_cps_call
		(return$10, chunk, cont);
		                               }
		                               return caml_exact_trampoline_cps_call
		                                       (Logs[6],
		function(m, cont){
		 return caml_trampoline_cps_call6
		         (m, 0, 0, qM, pp_uid, uid, cont);
		},
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (symbol_bind$6, a, b, cont);
		});
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (get$5,
		                                       body,
		                                       function(b){
		return caml_exact_trampoline_cps_call$9
		        (with_timeout,
		         qO,
		         method,
		         return$4,
		         cst_reading_body,
		         uid,
		         uri,
		         timeout,
		         b,
		         function(b){
		          return caml_exact_trampoline_cps_call$1
		                  (symbol_bind$6, b, a, cont);
		         });
		                                       });
		                             }));
		                 }
		                 if(typeof cohttp === "number")
		                  return caml_exact_trampoline_cps_call(of_list$5, 0, a);
		                 var variant = cohttp[1];
		                 if(-976970511 === variant){
		                  var s = cohttp[2];
		                  return caml_exact_trampoline_cps_call
		                          (of_list$5, [0, s, 0], a);
		                 }
		                 if(-968575390 <= variant){
		                  var sl = cohttp[2];
		                  return caml_exact_trampoline_cps_call(of_list$5, sl, a);
		                 }
		                 var s$0 = cohttp[2];
		                 return a(s$0);
		                }
		                function drain(param, cont){
		                 var cohttp = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (catch$,
		                          function(param, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (drain_body, cohttp, cont);
		                          },
		                          function(param, cont){
		                           return caml_exact_trampoline_cps_call(return$10, 0, cont);
		                          },
		                          cont);
		                }
		                function raw(timeout, headers, body, method, uri, cont){
		                 uid[1] = uid[1] + 1 | 0;
		                 var uid$0 = uid[1];
		                 function f(param, cont){
		                  function a(param, cont){
		                   function f(param, cont){
		                    var v = param[2], h = param[1];
		                    return caml_exact_trampoline_cps_call
		                            (Logs[6],
		                             function(m, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (capitalize_ascii,
		                                       h,
		                                       function(a){
		return caml_trampoline_cps_call7
		        (m, 0, 0, qR, uid$0, a, v, cont);
		                                       });
		                             },
		                             cont);
		                   }
		                   function a(param, cont){
		                    if(headers)
		                     var v = headers[1], headers$0 = [0, rev(v)];
		                    else
		                     headers$0 = 0;
		                    return caml_exact_trampoline_cps_call$1
		                            (map$3,
		                             body,
		                             function(param, cont){
		                              var cohttp = param[1];
		                              return cont(cohttp);
		                             },
		                             function(a){
		                              return caml_exact_trampoline_cps_call$7
		                                      (Client[3],
		                                       dummy,
		                                       headers$0,
		                                       a,
		                                       dummy,
		                                       method,
		                                       uri,
		                                       function(p){
		return caml_exact_trampoline_cps_call$1
		        (symbol$90,
		         of_string$0,
		         p,
		         function(request){
		          function a(timeout){
		           function a(param, cont){
		            var body = param[2], resp = param[1], status = resp[3];
		            if(typeof status !== "number"){
		             var variant = status[1];
		             if(748543309 === variant && 0 === status[2]){
		              var
		               b =
		                 function(param, cont){
		                  function a(param, cont){
		                   return caml_exact_trampoline_cps_call
		                           (fail$2, [0, method, -610669292, 0, uri], cont);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (drain_body,
		                           body,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, b, a, cont);
		                           });
		                 };
		              return caml_exact_trampoline_cps_call
		                      (Logs[5],
		                       function(m, cont){
		                        return caml_trampoline_cps_call5(m, 0, 0, qQ, uid$0, cont);
		                       },
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (symbol_bind$6, a, b, cont);
		                       });
		             }
		            }
		            function a(param, cont){
		             return caml_trampoline_cps_call2
		                     (return$19,
		                      [0, resp, [0, body, method, timeout, [0, uid$0], uri]],
		                      cont);
		            }
		            return caml_exact_trampoline_cps_call
		                    (Logs[5],
		                     function(m, cont){
		                      return caml_exact_trampoline_cps_call
		                              (string_of_status,
		                               status,
		                               function(a){
		                                return caml_trampoline_cps_call5
		(m,
		 0,
		 0,
		 qP,
		 uid$0,
		 function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                               });
		                     },
		                     function(b){
		                      return caml_exact_trampoline_cps_call$1
		                              (symbol_bind$6, b, a, cont);
		                     });
		           }
		           return caml_exact_trampoline_cps_call$9
		                   (with_timeout,
		                    0,
		                    method,
		                    function(a, cont){return cont(a);},
		                    "reading headers",
		                    [0, uid$0],
		                    uri,
		                    timeout,
		                    request,
		                    function(b){
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol_bind$14, b, a, cont);
		                    });
		          }
		          if(! timeout) return a(0);
		          var delay = timeout[1];
		          return caml_exact_trampoline_cps_call
		                  (sleep, delay, function(b){return a([0, b]);});
		         });
		                                       });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (iter_s,
		                            f,
		                            value(headers, 0),
		                            function(left){
		                             function pp_body(fmt, a, cont){
		                              if(a){
		                               a = a[1][1];
		                               if(typeof a !== "number"){
		                                var variant = a[1];
		                                if(-976970511 === variant){
		                                 var body = a[2];
		                                 if(body !== cst$1)
		                                  return caml_exact_trampoline_cps_call$1
		  (lines, fmt, body, cont);
		                                }
		                                else {
		                                 if(-968575390 > variant)
		                                  return caml_exact_trampoline_cps_call$1
		  (pp_print_string, fmt, cst_stream, cont);
		                                 var body$0 = a[2];
		                                 if(body$0)
		                                  return caml_exact_trampoline_cps_call$1
		  (list(0, lines), fmt, body$0, cont);
		                                }
		                               }
		                              }
		                              return cont(0);
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (Logs[6],
		                                      function(m, cont){
		                                       return caml_trampoline_cps_call7
		       (m, 0, 0, qS, uid$0, pp_body, body, cont);
		                                      },
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (both$0,
		        left,
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol_bind$6, b, a, cont);
		        });
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (Logs[5],
		                           function(m, cont){
		                            return caml_trampoline_cps_call8
		                                    (m,
		                                     0,
		                                     0,
		                                     qT,
		                                     uid$0,
		                                     string_of_method(method),
		                                     pp_v,
		                                     uri,
		                                     cont);
		                           },
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$2
		                         (catch$0, "requesting", method, uri, f, cont);
		                }
		                return [0,
		                        [0, drain, to_string, to_stream, of_string, of_stream$0],
		                        Coding,
		                        [0, , , , , bind$20, return$19, map$32],
		                        1,
		                        raw];
		               }
		               var
		                V$1 = [248, "Gapi__Schemas_library.V", caml_fresh_oo_id()],
		                cst_etag = "etag",
		                letrec_function_context$30 = [];
		               function schema_versioned$17(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$30[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, q2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$30[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$30[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$30[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var etag = param[2][1], kind = param[1];
		                                 return cont([0, kind, etag]);
		                                },
		                                function(param, cont){
		                                 var etag = param[2], kind = param[1];
		                                 return cont([0, kind, [0, etag, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_kind,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_etag,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$30[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$30[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$17 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$30, [0, schematic_cache$17]);
		               caml_callback
		                (schema_versioned$17,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$18 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$31 = [];
		               caml_update_dummy
		                (letrec_function_context$31, [0, schematic_cache$18]);
		               function schematic_version$0(param, cont){return cont(0);}
		               var
		                cst_selfLink = "selfLink",
		                schema$268 = [0, id$1, 0, descriptor$0, 0],
		                schematic_schema_version$179 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$31[1][1],
		                    schematic_schema_version$179]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$31[1][1],
		                             schematic_schema_version$179,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$31[1][1],
		schematic_schema_version$179,
		schematic_self,
		function(b){
		 letrec_function_context$31[1][1] = b;
		 var
		  a =
		    [0,
		     [0, 0, 0, 0, 0, cst_selfLink, 0, 2, [0, schema$268], 0, 0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$4,
		          schematic_version$0,
		          function(c){
		           var
		            b =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_id,
		                0,
		                2,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_title,
		                 0,
		                 2,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0, [0, 0, 0, 0, 0, cst_updated, 0, 2, [0, c], 0, 0], a]]];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$17,
		                    schematic_version$0,
		                    function(a){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           c = b[2],
		                           selfLink = c[2][1],
		                           updated = c[1],
		                           title = b[1],
		                           id = a[1],
		                           meta = param[1];
		                          return cont([0, meta, id, title, updated, selfLink]);
		                         },
		                         function(param, cont){
		                          var
		                           selfLink = param[5],
		                           updated = param[4],
		                           title = param[3],
		                           id = param[2],
		                           meta = param[1];
		                          return cont
		                                  ([0,
		                                    meta,
		                                    [0, id, [0, title, [0, updated, [0, selfLink, 0]]]]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [1, a], 0, 0], b]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$31[1][1],
		                              schematic_schema_version$179,
		                              res,
		                              function(a){
		                               letrec_function_context$31[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$19 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$32 = [];
		               caml_update_dummy
		                (letrec_function_context$32, [0, schematic_cache$19]);
		               var schematic_schema_version$2 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$32[1][1],
		                    schematic_schema_version$2]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$32[1][1],
		                             schematic_schema_version$2,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$32[1][1],
		schematic_schema_version$2,
		schematic_self,
		function(a){
		 letrec_function_context$32[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var title = param[1];
		      return cont([0, title]);
		     },
		     function(param, cont){
		      var title = param[1];
		      return cont([0, title, 0]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_title,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$32[1][1],
		          schematic_schema_version$2,
		          res,
		          function(a){
		           letrec_function_context$32[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schema_versioned$18(param){
		                function decode(t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_string$0, to_date_time(0, t)[1], cont);
		                }
		                function encode(date, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (value_exn, 0, 0, q3, of_date(0, date), cont);
		                }
		                return [0, id$10, 0, [4, decode, encode, 9], 0];
		               }
		               var cs = [];
		               function status_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cs[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, q4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cs[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cs[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cs[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(q8);},
		                                  0,
		                                  0,
		                                  cst_needsAction,
		                                  "NeedsAction",
		                                  q7,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(q6) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_completed,
		                                   cst_Completed,
		                                   q5,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cs[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cs[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$33 = [];
		               function link_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$33[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, q9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$33[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$33[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$33[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  link = a[2][1],
		                                  description = a[1],
		                                  type = param[1];
		                                 return cont([0, type, description, link]);
		                                },
		                                function(param, cont){
		                                 var
		                                  link = param[3],
		                                  description = param[2],
		                                  type = param[1];
		                                 return cont([0, type, [0, description, [0, link, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_description,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_link,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$33[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$33[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$20 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cs, [0, schematic_cache$20]);
		               var schematic_cache$21 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$33, [0, schematic_cache$21]);
		               caml_callback
		                (status_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (link_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var cst_due = "due";
		               function Moded(M, cont){
		                var letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$1,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, q_, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      schematic_param_name_schema_ve,
		                                      function(b){
		                                       var a = M[6].call(null, 0), b = [0, b];
		                                       if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                                       var c = [0, [0, 0, 0, 0, 0, cst_title, 0, a, b, 0, 0], 0];
		                                       return caml_exact_trampoline_cps_call
		       (status_schema_versioned,
		        schematic_version,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var
		                    default$ = M[5].call(null, 0),
		                    a =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_status, 0, [0, default$], [0, b], 0, 0],
		                       c];
		                   return caml_exact_trampoline_cps_call
		                           (option_schema,
		                            schematic_param_name_schema_ve,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      b,
		                                      function(c){
		                                       var
		default$ = M[5].call(null, 0),
		b =
		  [0,
		   [0, 0, 0, 0, 0, cst_notes, 0, [0, default$], [0, c], 0, 0],
		   a];
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        bool_schema,
		        function(c){
		         var
		          default$ = M[5].call(null, 0),
		          a =
		            [0,
		             [0, 0, 0, 0, 0, cst_hidden, 0, [0, default$], [0, c], 0, 0],
		             b];
		         return caml_exact_trampoline_cps_call
		                 (option_schema,
		                  schema_versioned$18(),
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            b,
		                            function(c){
		                             var
		                              default$ = M[5].call(null, 0),
		                              b =
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_due, 0, [0, default$], [0, c], 0, 0],
		                                 a];
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      bool_schema,
		                                      function(a){
		                                       var
		default$ = M[5].call(null, 0),
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     b = a[2],
		     c = b[2],
		     d = c[2],
		     title = d[2][1],
		     status = d[1],
		     notes = c[1],
		     hidden = b[1],
		     due = a[1],
		     deleted = param[1];
		    return cont([0, deleted, due, hidden, notes, status, title]);
		   },
		   function(param, cont){
		    var
		     title = param[6],
		     status = param[5],
		     notes = param[4],
		     hidden = param[3],
		     due = param[2],
		     deleted = param[1];
		    return cont
		            ([0,
		              deleted,
		              [0,
		               due,
		               [0, hidden, [0, notes, [0, status, [0, title, 0]]]]]]);
		   },
		   [0,
		    [0, 0, 0, 0, 0, cst_deleted, 0, [0, default$], [0, a], 0, 0],
		    b]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){return cont([0, , schema_versioned]);});
		               }
		               var
		                R$0 =
		                  [0,
		                   schema_versioned$8,
		                   ,
		                   ,
		                   ,
		                   default$5,
		                   some_if_optional,
		                   some_if_required,
		                   pp$16,
		                   equal$24,
		                   compare$42,
		                   [0, schema_versioned$9, , equal$25, pp$17, switch$]],
		                Read = caml_callback(Moded, [R$0]),
		                W$0 =
		                  [0,
		                   option_schema_versioned,
		                   ,
		                   ,
		                   ,
		                   default$6,
		                   some_if_optional$0,
		                   some_if_required$0,
		                   pp$18,
		                   equal$26,
		                   compare$43,
		                   [0, schema_versioned$10, , equal$27, pp$19, switch$0]];
		               caml_callback(Moded, [W$0]);
		               var
		                schematic_cache$22 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$34 = [];
		               caml_update_dummy
		                (letrec_function_context$34, [0, schematic_cache$22]);
		               function schematic_version$1(param, cont){return cont(0);}
		               var schematic_schema_version$178 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$34[1][1],
		                    schematic_schema_version$178]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$34[1][1],
		                             schematic_schema_version$178,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$34[1][1],
		schematic_schema_version$178,
		schematic_self,
		function(a){
		 letrec_function_context$34[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (Read[2],
		          schematic_version$1,
		          function(b){
		           var
		            descriptor = 10,
		            parametric = 0,
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_parent,
		                0,
		                3,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_position,
		                 0,
		                 3,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_selfLink,
		                  0,
		                  2,
		                  [0, schematic_param_name_schema_ve],
		                  0,
		                  0],
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_updated,
		                   0,
		                   2,
		                   [0, [0, bt, 0, descriptor, parametric]],
		                   0,
		                   0],
		                  [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0]]]]];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$17,
		                    schematic_version$1,
		                    function(c){
		                     var
		                      b = [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [1, c], 0, 0], a];
		                     return caml_exact_trampoline_cps_call
		                             (link_schema_versioned,
		                              schematic_version$1,
		                              function(a){
		                               var
		                                default$ = match$47[1],
		                                res =
		                                  [7,
		                                   function(param, cont){
		                                    var
		                                     a = param[2],
		                                     b = a[2],
		                                     c = b[2],
		                                     d = c[2],
		                                     e = d[2],
		                                     f = e[2],
		                                     g = f[2],
		                                     writable = g[2][1],
		                                     updated = g[1],
		                                     selfLink = f[1],
		                                     position = e[1],
		                                     parent = d[1],
		                                     meta = c[1],
		                                     links = b[1],
		                                     id = a[1],
		                                     completed = param[1];
		                                    return cont
		    ([0,
		      completed,
		      id,
		      links,
		      meta,
		      parent,
		      position,
		      selfLink,
		      updated,
		      writable]);
		                                   },
		                                   function(param, cont){
		                                    var
		                                     writable = param[9],
		                                     updated = param[8],
		                                     selfLink = param[7],
		                                     position = param[6],
		                                     parent = param[5],
		                                     meta = param[4],
		                                     links = param[3],
		                                     id = param[2],
		                                     completed = param[1];
		                                    return cont
		    ([0,
		      completed,
		      [0,
		       id,
		       [0,
		        links,
		        [0,
		         meta,
		         [0,
		          parent,
		          [0, position, [0, selfLink, [0, updated, [0, writable, 0]]]]]]]]]);
		                                   },
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_completed,
		                                     0,
		                                     3,
		                                     [0, [0, bt, 0, descriptor, parametric]],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_id,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       "links",
		                                       0,
		                                       [0, default$],
		                                       [0, [0, 0, 0, [3, a], 0]],
		                                       0,
		                                       0],
		                                      b]]]];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$34[1][1],
		schematic_schema_version$178,
		res,
		function(a){
		 letrec_function_context$34[1][1] = a;
		 return cont(res);
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$35 = [];
		               function schema_versioned$19(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$35[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, q$, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$35[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$35[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$35[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var message = param[2][1], code = param[1];
		                       return cont([0, code, message]);
		                      },
		                      function(param, cont){
		                       var message = param[2], code = param[1];
		                       return cont([0, code, [0, message, 0]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_code, 0, 3, [0, int_schema], 0, 0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_message,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$35[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$35[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$23 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$35, [0, schematic_cache$23]);
		               caml_callback
		                (schema_versioned$19, [function(param){return 0;}]);
		               var
		                cst_formattedType = "formattedType",
		                cst_formattedValue = "formattedValue",
		                letrec_function_context$36 = [];
		               function schema_versioned$20(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$36[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, ra, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$36[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$36[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$36[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        countryCode = i[2][1],
		                        country = i[1],
		                        postalCode = h[1],
		                        region = g[1],
		                        city = f[1],
		                        extendedAddress = e[1],
		                        streetAddress = d[1],
		                        poBox = c[1],
		                        formattedType = b[1],
		                        type = a[1],
		                        formattedValue = param[1];
		                       return cont
		                               ([0,
		                                 formattedValue,
		                                 type,
		                                 formattedType,
		                                 poBox,
		                                 streetAddress,
		                                 extendedAddress,
		                                 city,
		                                 region,
		                                 postalCode,
		                                 country,
		                                 countryCode]);
		                      },
		                      function(param, cont){
		                       var
		                        countryCode = param[11],
		                        country = param[10],
		                        postalCode = param[9],
		                        region = param[8],
		                        city = param[7],
		                        extendedAddress = param[6],
		                        streetAddress = param[5],
		                        poBox = param[4],
		                        formattedType = param[3],
		                        type = param[2],
		                        formattedValue = param[1];
		                       return cont
		                               ([0,
		                                 formattedValue,
		                                 [0,
		                                  type,
		                                  [0,
		                                   formattedType,
		                                   [0,
		                                    poBox,
		                                    [0,
		                                     streetAddress,
		                                     [0,
		                                      extendedAddress,
		                                      [0,
		                                       city,
		                                       [0,
		region,
		[0, postalCode, [0, country, [0, countryCode, 0]]]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_formattedValue,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_type,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_formattedType,
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "poBox",
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            "streetAddress",
		                            0,
		                            3,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             "extendedAddress",
		                             0,
		                             3,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              cst_city,
		                              0,
		                              3,
		                              [0, schematic_param_name_schema_ve],
		                              0,
		                              0],
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "region",
		                               0,
		                               3,
		                               [0, schematic_param_name_schema_ve],
		                               0,
		                               0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                "postalCode",
		                                0,
		                                3,
		                                [0, schematic_param_name_schema_ve],
		                                0,
		                                0],
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_country,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "countryCode",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]]]]]]]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$36[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$36[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$24 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$36, [0, schematic_cache$24]);
		               caml_callback
		                (schema_versioned$20, [function(param){return 0;}]);
		               var letrec_function_context$37 = [];
		               function schema_versioned$21(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$37[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rb, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$37[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$37[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$37[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        formatted_type = a[2][1],
		                        type = a[1],
		                        url = param[1];
		                       return cont([0, url, type, formatted_type]);
		                      },
		                      function(param, cont){
		                       var
		                        formatted_type = param[3],
		                        type = param[2],
		                        url = param[1];
		                       return cont([0, url, [0, type, [0, formatted_type, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_url,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_type,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_formattedType,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$37[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$37[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$25 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$37, [0, schematic_cache$25]);
		               caml_callback
		                (schema_versioned$21, [function(param){return 0;}]);
		               var
		                schematic_cache$26 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$38 = [];
		               caml_update_dummy
		                (letrec_function_context$38, [0, schematic_cache$26]);
		               var
		                schematic_schema_version$3 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$38[1][1],
		                     schematic_schema_version$3]);
		               if(e)
		                var schema$12 = e[1], descriptor$4 = schema$12;
		               else
		                descriptor$4 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$38[1][1],
		                              schematic_schema_version$3,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$38[1][1],
		 schematic_schema_version$3,
		 schematic_self,
		 function(a){
		  letrec_function_context$38[1][1] = a;
		  var
		   res =
		     [7,
		      function(param, cont){
		       var
		        a = param[2],
		        day = a[2][1],
		        month = a[1],
		        year = param[1];
		       return cont([0, year, month, day]);
		      },
		      function(param, cont){
		       var day = param[3], month = param[2], year = param[1];
		       return cont([0, year, [0, month, [0, day, 0]]]);
		      },
		      [0,
		       [0, 0, 0, 0, 0, cst_year, 0, 2, [0, int_schema], 0, 0],
		       [0,
		        [0, 0, 0, 0, 0, cst_month, 0, 2, [0, int_schema], 0, 0],
		        [0,
		         [0, 0, 0, 0, 0, cst_day, 0, 2, [0, int_schema], 0, 0],
		         0]]]];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$38[1][1],
		           schematic_schema_version$3,
		           res,
		           function(a){
		            letrec_function_context$38[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               function schema_versioned$22(param){
		                function decode(param, cont){
		                 var day = param[3], month = param[2], year = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (of_tuple$0, [0, year, month, day], cont);
		                }
		                function encode(param, cont){
		                 var year = param[3], month = param[2], day = param[1];
		                 return cont([0, year, to_int$1(month), day]);
		                }
		                var descriptor = [4, decode, encode, descriptor$4];
		                return [0, id$11, 0, descriptor, 0];
		               }
		               var letrec_function_context$39 = [];
		               function schema_versioned$23(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$39[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rc, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$39[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$39[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$39[1][1] = a;
		                  var
		                   default$ = match$48[1],
		                   default$0 = match$49[1],
		                   default$1 = match$50[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        verified = a[2][1],
		                        source_primary = a[1],
		                        primary = param[1];
		                       return cont([0, primary, source_primary, verified]);
		                      },
		                      function(param, cont){
		                       var
		                        verified = param[3],
		                        source_primary = param[2],
		                        primary = param[1];
		                       return cont
		                               ([0, primary, [0, source_primary, [0, verified, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_primary,
		                        0,
		                        [0, default$1],
		                        [0, bool_schema],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "sourcePrimary",
		                         0,
		                         [0, default$0],
		                         [0, bool_schema],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "verified",
		                          0,
		                          [0, default$],
		                          [0, bool_schema],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$39[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$39[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$27 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$39, [0, schematic_cache$27]);
		               caml_callback
		                (schema_versioned$23, [function(param){return 0;}]);
		               var
		                cst_displayName = "displayName",
		                letrec_function_context$40 = [];
		               function schema_versioned$24(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$40[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rd, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$40[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$40[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(b){
		                  letrec_function_context$40[1][1] = b;
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_type,
		                       0,
		                       3,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_value,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$23,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  value = c[2][1],
		                                  type = c[1],
		                                  metadata = b[1],
		                                  formattedType = a[1],
		                                  displayName = param[1];
		                                 return cont
		 ([0, displayName, formattedType, metadata, type, value]);
		                                },
		                                function(param, cont){
		                                 var
		                                  value = param[5],
		                                  type = param[4],
		                                  metadata = param[3],
		                                  formattedType = param[2],
		                                  displayName = param[1];
		                                 return cont
		 ([0,
		   displayName,
		   [0, formattedType, [0, metadata, [0, type, [0, value, 0]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_displayName,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_formattedType,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0, [0, 0, 0, 0, 0, cst_metadata, 0, 2, [0, b], 0, 0], a]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$40[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$40[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$28 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$40, [0, schematic_cache$28]);
		               caml_callback
		                (schema_versioned$24, [function(param){return 0;}]);
		               var letrec_function_context$41 = [];
		               function schema_versioned$25(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$41[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, re, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$41[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$41[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$41[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        formatted_type = a[2][1],
		                        type = a[1],
		                        date = param[1];
		                       return cont([0, date, type, formatted_type]);
		                      },
		                      function(param, cont){
		                       var
		                        formatted_type = param[3],
		                        type = param[2],
		                        date = param[1];
		                       return cont([0, date, [0, type, [0, formatted_type, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_date,
		                        0,
		                        2,
		                        [0, schema_versioned$22()],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_type,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_formattedType,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$41[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$41[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$29 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$41, [0, schematic_cache$29]);
		               caml_callback
		                (schema_versioned$25, [function(param){return 0;}]);
		               var letrec_function_context$42 = [];
		               function schema_versioned$26(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$42[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rf, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$42[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$42[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$42[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        addressMeAs = a[2][1],
		                        formattedValue = a[1],
		                        value = param[1];
		                       return cont([0, value, formattedValue, addressMeAs]);
		                      },
		                      function(param, cont){
		                       var
		                        addressMeAs = param[3],
		                        formattedValue = param[2],
		                        value = param[1];
		                       return cont
		                               ([0, value, [0, formattedValue, [0, addressMeAs, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_value,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_formattedValue,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "addressMeAs",
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$42[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$42[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$30 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$42, [0, schematic_cache$30]);
		               caml_callback
		                (schema_versioned$26, [function(param){return 0;}]);
		               var
		                cst_familyName = "familyName",
		                cst_givenName = "givenName",
		                letrec_function_context$43 = [];
		               function schema_versioned$27(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$43[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rh, rg, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$43[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$43[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$43[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        j = i[2],
		                        k = j[2],
		                        l = k[2],
		                        phoneticHonorificSuffix = l[2][1],
		                        phoneticHonorificPrefix = l[1],
		                        phoneticMiddleName = k[1],
		                        phoneticGivenName = j[1],
		                        phoneticFamilyName = i[1],
		                        phoneticFullName = h[1],
		                        honorificSuffix = g[1],
		                        honorificPrefix = f[1],
		                        middleName = e[1],
		                        unstructuredName = d[1],
		                        displayNameLastFirst = c[1],
		                        givenName = b[1],
		                        familyName = a[1],
		                        displayName = param[1];
		                       return cont
		                               ([0,
		                                 displayName,
		                                 familyName,
		                                 givenName,
		                                 displayNameLastFirst,
		                                 unstructuredName,
		                                 middleName,
		                                 honorificPrefix,
		                                 honorificSuffix,
		                                 phoneticFullName,
		                                 phoneticFamilyName,
		                                 phoneticGivenName,
		                                 phoneticMiddleName,
		                                 phoneticHonorificPrefix,
		                                 phoneticHonorificSuffix]);
		                      },
		                      function(param, cont){
		                       var
		                        phoneticHonorificSuffix = param[14],
		                        phoneticHonorificPrefix = param[13],
		                        phoneticMiddleName = param[12],
		                        phoneticGivenName = param[11],
		                        phoneticFamilyName = param[10],
		                        phoneticFullName = param[9],
		                        honorificSuffix = param[8],
		                        honorificPrefix = param[7],
		                        middleName = param[6],
		                        unstructuredName = param[5],
		                        displayNameLastFirst = param[4],
		                        givenName = param[3],
		                        familyName = param[2],
		                        displayName = param[1];
		                       return cont
		                               ([0,
		                                 displayName,
		                                 [0,
		                                  familyName,
		                                  [0,
		                                   givenName,
		                                   [0,
		                                    displayNameLastFirst,
		                                    [0,
		                                     unstructuredName,
		                                     [0,
		                                      middleName,
		                                      [0,
		                                       honorificPrefix,
		                                       [0,
		honorificSuffix,
		[0,
		 phoneticFullName,
		 [0,
		  phoneticFamilyName,
		  [0,
		   phoneticGivenName,
		   [0,
		    phoneticMiddleName,
		    [0,
		     phoneticHonorificPrefix,
		     [0, phoneticHonorificSuffix, 0]]]]]]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_displayName,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_familyName,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_givenName,
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "displayNameLastFirst",
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            "unstructuredName",
		                            0,
		                            3,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             "middleName",
		                             0,
		                             3,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              "honorificPrefix",
		                              0,
		                              3,
		                              [0, schematic_param_name_schema_ve],
		                              0,
		                              0],
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "honorificSuffix",
		                               0,
		                               3,
		                               [0, schematic_param_name_schema_ve],
		                               0,
		                               0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                "phoneticFullName",
		                                0,
		                                3,
		                                [0, schematic_param_name_schema_ve],
		                                0,
		                                0],
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "phoneticFamilyName",
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "phoneticGivenName",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "phoneticMiddleName",
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "phoneticHonorificPrefix",
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "phoneticHonorificSuffix",
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]]]]]]]]]]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$43[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$43[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$31 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$43, [0, schematic_cache$31]);
		               caml_callback
		                (schema_versioned$27, [function(param){return 0;}]);
		               var
		                cst_current = "current",
		                cst_domain = "domain",
		                cst_startDate = "startDate",
		                letrec_function_context$44 = [];
		               function schema_versioned$28(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$44[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, ri, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$44[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$44[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$44[1][1] = a;
		                  a =
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     "endDate",
		                     0,
		                     3,
		                     [0, schema_versioned$22()],
		                     0,
		                     0],
		                    [0,
		                     [0, 0, 0, 0, 0, cst_current, 0, 3, [0, bool_schema], 0, 0],
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_name,
		                       0,
		                       3,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "phoneticName",
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "department",
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_title,
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "jobDescription",
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            "symbol",
		                            0,
		                            3,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_domain,
		                             0,
		                             3,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              cst_location,
		                              0,
		                              3,
		                              [0, schematic_param_name_schema_ve],
		                              0,
		                              0],
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "costCenter",
		                               0,
		                               3,
		                               [0, schematic_param_name_schema_ve],
		                               0,
		                               0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                "fullTimeEquivalentMillipercent",
		                                0,
		                                3,
		                                [0, int_schema],
		                                0,
		                                0],
		                               0]]]]]]]]]]]];
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        j = i[2],
		                        k = j[2],
		                        l = k[2],
		                        m = l[2],
		                        full_time_equivalent_milliperc = m[2][1],
		                        cost_center = m[1],
		                        location = l[1],
		                        domain = k[1],
		                        symbol = j[1],
		                        jobDescription = i[1],
		                        title = h[1],
		                        department = g[1],
		                        phonetic_name = f[1],
		                        name = e[1],
		                        current = d[1],
		                        end_date = c[1],
		                        start_date = b[1],
		                        formatted_type = a[1],
		                        type = param[1];
		                       return cont
		                               ([0,
		                                 type,
		                                 formatted_type,
		                                 start_date,
		                                 end_date,
		                                 current,
		                                 name,
		                                 phonetic_name,
		                                 department,
		                                 title,
		                                 jobDescription,
		                                 symbol,
		                                 domain,
		                                 location,
		                                 cost_center,
		                                 full_time_equivalent_milliperc]);
		                      },
		                      function(param, cont){
		                       var
		                        full_time_equivalent_milliperc = param[15],
		                        cost_center = param[14],
		                        location = param[13],
		                        domain = param[12],
		                        symbol = param[11],
		                        jobDescription = param[10],
		                        title = param[9],
		                        department = param[8],
		                        phonetic_name = param[7],
		                        name = param[6],
		                        current = param[5],
		                        end_date = param[4],
		                        start_date = param[3],
		                        formatted_type = param[2],
		                        type = param[1];
		                       return cont
		                               ([0,
		                                 type,
		                                 [0,
		                                  formatted_type,
		                                  [0,
		                                   start_date,
		                                   [0,
		                                    end_date,
		                                    [0,
		                                     current,
		                                     [0,
		                                      name,
		                                      [0,
		                                       phonetic_name,
		                                       [0,
		department,
		[0,
		 title,
		 [0,
		  jobDescription,
		  [0,
		   symbol,
		   [0,
		    domain,
		    [0,
		     location,
		     [0, cost_center, [0, full_time_equivalent_milliperc, 0]]]]]]]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_type,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_formattedType,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_startDate,
		                          0,
		                          3,
		                          [0, schema_versioned$22()],
		                          0,
		                          0],
		                         a]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$44[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$44[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$32 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$44, [0, schematic_cache$32]);
		               caml_callback
		                (schema_versioned$28, [function(param){return 0;}]);
		               var letrec_function_context$45 = [];
		               function schema_versioned$29(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$45[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rj, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$45[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$45[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$45[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        formattedType = b[2][1],
		                        type = b[1],
		                        canonicalForm = a[1],
		                        value = param[1];
		                       return cont([0, value, canonicalForm, type, formattedType]);
		                      },
		                      function(param, cont){
		                       var
		                        formattedType = param[4],
		                        type = param[3],
		                        canonicalForm = param[2],
		                        value = param[1];
		                       return cont
		                               ([0,
		                                 value,
		                                 [0, canonicalForm, [0, type, [0, formattedType, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_value,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "canonicalForm",
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_type,
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_formattedType,
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          0]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$45[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$45[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$33 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$45, [0, schematic_cache$33]);
		               caml_callback
		                (schema_versioned$29, [function(param){return 0;}]);
		               var letrec_function_context$46 = [];
		               function schema_versioned$30(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$46[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rk, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$46[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$46[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$46[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var default$ = param[2][1], url = param[1];
		                       return cont([0, url, default$]);
		                      },
		                      function(param, cont){
		                       var default$ = param[2], url = param[1];
		                       return cont([0, url, [0, default$, 0]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_url,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, 0, 0, 0, 0, cst_default, 0, 3, [0, bool_schema], 0, 0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$46[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$46[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$34 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$46, [0, schematic_cache$34]);
		               caml_callback
		                (schema_versioned$30, [function(param){return 0;}]);
		               var cst_resourceName = "resourceName", ct = [];
		               function schema_versioned$31(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         ct[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rl, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      ct[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 ct[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(b){
		                  ct[1][1] = b;
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_resourceName,
		                       0,
		                       2,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$30,
		                           schematic_version,
		                           function(c){
		                            var
		                             default$ = match$51[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_photos,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, c], 0]],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$29,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$52[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "phoneNumbers",
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, c], 0]],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$28,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$53[1],
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_organizations,
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (metadata_schema_versioned$0,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_metadata, 0, 3, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$27,
		                           schematic_version,
		                           function(c){
		                            var
		                             default$ = match$54[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "names",
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, c], 0]],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$26,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$55[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "genders",
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, c], 0]],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$25,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$56[1],
		         b =
		           [0,
		            [0,
		             rm,
		             0,
		             0,
		             0,
		             cst_events,
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$24,
		                 schematic_version,
		                 function(c){
		                  var
		                   default$ = match$57[1],
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       "emailAddresses",
		                       0,
		                       [0, default$],
		                       [0, [0, 0, 0, [3, c], 0]],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$21,
		                           schematic_version,
		                           function(c){
		                            var
		                             default$ = match$58[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "calendarUrls",
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, c], 0]],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$20,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       default$ = match$59[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    resourceName = i[2][1],
		    photos = i[1],
		    phoneNumbers = h[1],
		    organizations = g[1],
		    metadata = f[1],
		    names = e[1],
		    genders = d[1],
		    events = c[1],
		    emailAddresses = b[1],
		    calendarUrls = a[1],
		    addresses = param[1];
		   return cont
		           ([0,
		             addresses,
		             calendarUrls,
		             emailAddresses,
		             events,
		             genders,
		             names,
		             metadata,
		             organizations,
		             phoneNumbers,
		             photos,
		             resourceName]);
		  },
		  function(param, cont){
		   var
		    resourceName = param[11],
		    photos = param[10],
		    phoneNumbers = param[9],
		    organizations = param[8],
		    metadata = param[7],
		    names = param[6],
		    genders = param[5],
		    events = param[4],
		    emailAddresses = param[3],
		    calendarUrls = param[2],
		    addresses = param[1];
		   return cont
		           ([0,
		             addresses,
		             [0,
		              calendarUrls,
		              [0,
		               emailAddresses,
		               [0,
		                events,
		                [0,
		                 genders,
		                 [0,
		                  names,
		                  [0,
		                   metadata,
		                   [0,
		                    organizations,
		                    [0, phoneNumbers, [0, photos, [0, resourceName, 0]]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "addresses",
		    0,
		    [0, default$],
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       ct[1][1],
		       schematic_schema_version,
		       res,
		       function(a){ct[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var letrec_function_context$47 = [];
		               function metadata_schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$47[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rn, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$47[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$47[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$47[1][1] = a;
		                  var
		                   default$ = match$60[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var deleted = param[1];
		                       return cont([0, deleted]);
		                      },
		                      function(param, cont){
		                       var deleted = param[1];
		                       return cont([0, deleted, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_deleted,
		                        0,
		                        [0, default$],
		                        [0, bool_schema],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$47[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$47[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$35 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ct, [0, schematic_cache$35]);
		               var schematic_cache$36 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$47, [0, schematic_cache$36]);
		               caml_callback
		                (schema_versioned$31, [function(param){return 0;}]);
		               caml_callback
		                (metadata_schema_versioned$0, [function(param){return 0;}]);
		               var letrec_function_context$48 = [];
		               function schema_versioned$32(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$48[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, ro, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$48[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$48[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$48[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$31,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var person = param[1];
		                                 return cont([0, person]);
		                                },
		                                function(param, cont){
		                                 var person = param[1];
		                                 return cont([0, person, 0]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_person, 0, 2, [0, a], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$48[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$48[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$37 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$48, [0, schematic_cache$37]);
		               caml_callback
		                (schema_versioned$32, [function(param){return 0;}]);
		               var
		                schematic_cache$38 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$49 = [];
		               caml_update_dummy
		                (letrec_function_context$49, [0, schematic_cache$38]);
		               function schematic_version$2(param){return 0;}
		               var schematic_schema_version$177 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$49[1][1],
		                    schematic_schema_version$177]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$49[1][1],
		                             schematic_schema_version$177,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$49[1][1],
		schematic_schema_version$177,
		schematic_self,
		function(a){
		 letrec_function_context$49[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$32,
		          schematic_version$2,
		          function(a){
		           var
		            default$ = match$61[1],
		            res =
		              [7,
		               function(param, cont){
		                var results = param[1];
		                return cont([0, results]);
		               },
		               function(param, cont){
		                var results = param[1];
		                return cont([0, results, 0]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 "results",
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, a], 0]],
		                 0,
		                 0],
		                0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$49[1][1],
		                    schematic_schema_version$177,
		                    res,
		                    function(a){
		                     letrec_function_context$49[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function of_string$16(repr, cont){
		                return repr !== cst$1
		                        ? caml_trampoline_cps_call2(of_string$14, repr, cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           fail,
		                           format$12,
		                           function(a){
		                            return caml_trampoline_cps_call2(a, cst_calendar, cont);
		                           });
		               }
		               function schema_versioned$16(versions, cont){
		                return caml_trampoline_cps_call2
		                        (versions,
		                         V$1,
		                         function(match){
		                          function a(){
		                           var
		                            init =
		                              map$14
		                               (of_string$16,
		                                function(repr, cont){
		                                 return repr !== cst$1 ? cont(repr) : cont("%undefined%");
		                                },
		                                schematic_param_name_schema_ve);
		                           return cont
		                                   ([0,
		                                     [0, cst_calendar + cst_id$1],
		                                     init[2],
		                                     init[3],
		                                     init[4]]);
		                          }
		                          if(! match) return a();
		                          var version = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_string_exn,
		                                   "0.24.0",
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$66,
		     version,
		     b,
		     function(b){
		      return b
		              ? cont
		                ([0,
		                  [0, cst_calendar + cst_id$1],
		                  schematic_param_name_schema_ve[2],
		                  schematic_param_name_schema_ve[3],
		                  schematic_param_name_schema_ve[4]])
		              : a();
		     });
		                                   });
		                         });
		               }
		               var
		                schema$11 =
		                  caml_callback
		                   (schema_versioned$16,
		                    [function(param, cont){return cont(0);}]),
		                cst_allowedConferenceSolutionT =
		                  "allowedConferenceSolutionTypes",
		                letrec_function_context$50 = [];
		               function conference_properties_schema_v
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$50[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, rp, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$50[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$50[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$50[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var allowedConferenceSolutionTypes = param[1];
		                                 return cont([0, allowedConferenceSolutionTypes]);
		                                },
		                                function(param, cont){
		                                 var allowedConferenceSolutionTypes = param[1];
		                                 return cont([0, allowedConferenceSolutionTypes, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_allowedConferenceSolutionT,
		                                  0,
		                                  3,
		                                  [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$50[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$50[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$39 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$50, [0, schematic_cache$39]);
		               caml_callback
		                (conference_properties_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_conferenceProperties = "conferenceProperties",
		                cst_timeZone = "timeZone",
		                letrec_function_context$51 = [];
		               function schema_versioned$33(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$51[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, rq, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$51[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$51[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$51[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (conference_properties_schema_v,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    conferenceProperties = c[2][1],
		    timeZone = c[1],
		    location = b[1],
		    description = a[1],
		    summary = param[1];
		   return cont
		           ([0,
		             summary,
		             description,
		             location,
		             timeZone,
		             conferenceProperties]);
		  },
		  function(param, cont){
		   var
		    conferenceProperties = param[5],
		    timeZone = param[4],
		    location = param[3],
		    description = param[2],
		    summary = param[1];
		   return cont
		           ([0,
		             summary,
		             [0,
		              description,
		              [0, location, [0, timeZone, [0, conferenceProperties, 0]]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_summary,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_description,
		     0,
		     3,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_location,
		      0,
		      3,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_timeZone,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_conferenceProperties,
		        0,
		        3,
		        [0, a],
		        0,
		        0],
		       0]]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$51[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$51[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$40 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$51, [0, schematic_cache$40]);
		               caml_callback
		                (schema_versioned$33,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$41 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$52 = [];
		               caml_update_dummy
		                (letrec_function_context$52, [0, schematic_cache$41]);
		               function schematic_version$3(param, cont){return cont(0);}
		               var schematic_schema_version$176 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$52[1][1],
		                    schematic_schema_version$176]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$52[1][1],
		                             schematic_schema_version$176,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$52[1][1],
		schematic_schema_version$176,
		schematic_self,
		function(a){
		 letrec_function_context$52[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$33,
		          schematic_version$3,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_insert, 0, 2, [1, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$16,
		                    schematic_version$3,
		                    function(c){
		                     var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$17,
		                              schematic_version$3,
		                              function(a){
		                               var
		                                res =
		                                  [7,
		                                   function(param, cont){
		                                    var
		                                     a = param[2],
		                                     insert = a[2][1],
		                                     id = a[1],
		                                     meta = param[1];
		                                    return cont([0, meta, id, insert]);
		                                   },
		                                   function(param, cont){
		                                    var insert = param[3], id = param[2], meta = param[1];
		                                    return cont([0, meta, [0, id, [0, insert, 0]]]);
		                                   },
		                                   [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [1, a], 0, 0], b]];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$52[1][1],
		schematic_schema_version$176,
		res,
		function(a){
		 letrec_function_context$52[1][1] = a;
		 return cont(res);
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var cst_method = "method", letrec_function_context$53 = [];
		               function schema_versioned$34(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$53[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, rr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$53[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$53[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$53[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var method = param[2][1], type = param[1];
		                                 return cont([0, type, method]);
		                                },
		                                function(param, cont){
		                                 var method = param[2], type = param[1];
		                                 return cont([0, type, [0, method, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_method,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$53[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$53[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$42 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$53, [0, schematic_cache$42]);
		               caml_callback
		                (schema_versioned$34,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$54 = [];
		               function schema_versioned$35(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$54[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, rs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$54[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$54[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$54[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var minutes = param[2][1], method = param[1];
		                                 return cont([0, method, minutes]);
		                                },
		                                function(param, cont){
		                                 var minutes = param[2], method = param[1];
		                                 return cont([0, method, [0, minutes, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_method,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_minutes, 0, 2, [0, int_schema], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$54[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$54[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$43 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$54, [0, schematic_cache$43]);
		               caml_callback
		                (schema_versioned$35,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Owner = "Owner",
		                cst_Reader = "Reader",
		                letrec_function_context$55 = [];
		               function access_role_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$55[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ru, rt, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$55[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$55[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$55[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(rC);},
		                                  0,
		                                  0,
		                                  cst_owner,
		                                  cst_Owner,
		                                  rB,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(rA) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_writer,
		                                   "Writer",
		                                   rz,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(ry) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_reader,
		                                    cst_Reader,
		                                    rx,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 <= param ? cont(rw) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_freeBusyReader,
		                                     "Free_busy_reader",
		                                     rv,
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$55[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$55[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$44 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$55, [0, schematic_cache$44]);
		               caml_callback
		                (access_role_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_backgroundColor = "backgroundColor",
		                cst_colorId = "colorId",
		                cst_defaultReminders = "defaultReminders",
		                cst_selected = "selected",
		                cu = [];
		               function schema_versioned$36(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cu[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cu[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cu[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cu[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (conference_properties_schema_v$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$62[1],
		                                       default$0 = match$63[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_primary,
		   0,
		   [0, default$0],
		   [0, bool_schema],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_deleted,
		    0,
		    [0, default$],
		    [0, bool_schema],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_conferenceProperties,
		     0,
		     3,
		     [0, b],
		     0,
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call
		      (notifications_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, "notificationSettings", 0, 3, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$35,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_defaultReminders,
		                       0,
		                       2,
		                       [0, [0, 0, 0, [3, c], 0]],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (access_role_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             default$ = match$64[1],
		                             default$0 = match$65[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_summary,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_description,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_location,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_timeZone,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "summaryOverride",
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_colorId,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_backgroundColor,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		"foregroundColor",
		0,
		3,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_hidden,
		 0,
		 [0, default$0],
		 [0, bool_schema],
		 0,
		 0],
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_selected,
		  0,
		  [0, default$],
		  [0, bool_schema],
		  0,
		  0],
		 [0, [0, 0, 0, 0, 0, "accessRole", 0, 2, [0, c], 0, 0], a]]]]]]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$16,
		                                     schematic_version,
		                                     function(c){
		                                      var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$17,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              i = h[2],
		              j = i[2],
		              k = j[2],
		              l = k[2],
		              m = l[2],
		              n = m[2],
		              o = n[2],
		              p = o[2],
		              conference_properties = p[2][1],
		              deleted = p[1],
		              primary = o[1],
		              notificationSettings = n[1],
		              defaultReminders = m[1],
		              access_role = l[1],
		              selected = k[1],
		              hidden = j[1],
		              foregroundColor = i[1],
		              backgroundColor = h[1],
		              colorId = g[1],
		              summaryOverride = f[1],
		              timeZone = e[1],
		              location = d[1],
		              description = c[1],
		              summary = b[1],
		              id = a[1],
		              meta = param[1];
		             return cont
		                     ([0,
		                       meta,
		                       id,
		                       summary,
		                       description,
		                       location,
		                       timeZone,
		                       summaryOverride,
		                       colorId,
		                       backgroundColor,
		                       foregroundColor,
		                       hidden,
		                       selected,
		                       access_role,
		                       defaultReminders,
		                       notificationSettings,
		                       primary,
		                       deleted,
		                       conference_properties]);
		            },
		            function(param, cont){
		             var
		              conference_properties = param[18],
		              deleted = param[17],
		              primary = param[16],
		              notificationSettings = param[15],
		              defaultReminders = param[14],
		              access_role = param[13],
		              selected = param[12],
		              hidden = param[11],
		              foregroundColor = param[10],
		              backgroundColor = param[9],
		              colorId = param[8],
		              summaryOverride = param[7],
		              timeZone = param[6],
		              location = param[5],
		              description = param[4],
		              summary = param[3],
		              id = param[2],
		              meta = param[1];
		             return cont
		                     ([0,
		                       meta,
		                       [0,
		                        id,
		                        [0,
		                         summary,
		                         [0,
		                          description,
		                          [0,
		                           location,
		                           [0,
		                            timeZone,
		                            [0,
		                             summaryOverride,
		                             [0,
		                              colorId,
		                              [0,
		                               backgroundColor,
		                               [0,
		                                foregroundColor,
		                                [0,
		                                 hidden,
		                                 [0,
		                                  selected,
		                                  [0,
		                                   access_role,
		                                   [0,
		                                    defaultReminders,
		                                    [0,
		                                     notificationSettings,
		                                     [0, primary, [0, deleted, [0, conference_properties, 0]]]]]]]]]]]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [1, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cu[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){cu[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cv = [];
		               function notifications_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cv[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, rD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cv[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cv[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cv[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$34,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var notifications = param[1];
		   return cont([0, notifications]);
		  },
		  function(param, cont){
		   var notifications = param[1];
		   return cont([0, notifications, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_notifications,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cv[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cv[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$56 = [];
		               function conference_properties_schema_v$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$56[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, rE, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$56[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$56[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$56[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var allowedConferenceSolutionTypes = param[1];
		                                 return cont([0, allowedConferenceSolutionTypes]);
		                                },
		                                function(param, cont){
		                                 var allowedConferenceSolutionTypes = param[1];
		                                 return cont([0, allowedConferenceSolutionTypes, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_allowedConferenceSolutionT,
		                                  0,
		                                  3,
		                                  [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$56[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$56[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$45 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cu, [0, schematic_cache$45]);
		               var schematic_cache$46 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cv, [0, schematic_cache$46]);
		               var schematic_cache$47 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$56, [0, schematic_cache$47]);
		               caml_callback
		                (schema_versioned$36,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (notifications_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (conference_properties_schema_v$0,
		                 [function(param, cont){return cont(0);}]);
		               function calendar_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$36,
		                                   schematic_version,
		                                   function(a){return cont([0, rF, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (calendar_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$48 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$57 = [];
		               caml_update_dummy
		                (letrec_function_context$57, [0, schematic_cache$48]);
		               function schematic_version$4(param, cont){return cont(0);}
		               var
		                cst_Deleted = "Deleted",
		                cst_Sync_token = "Sync_token",
		                cst_Updated = "Updated",
		                cst_sync_token = "sync_token",
		                schematic_schema_version$175 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$57[1][1],
		                    schematic_schema_version$175]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$57[1][1],
		                             schematic_schema_version$175,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$57[1][1],
		schematic_schema_version$175,
		schematic_self,
		function(a){
		 letrec_function_context$57[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (calendar_schema_versioned,
		          schematic_version$4,
		          function(b){
		           var letrec_function_context = [];
		           function raw_deleted_schema_versioned
		           (schematic_version, cont){
		            return caml_exact_trampoline_cps_call
		                    (schematic_version,
		                     V$1,
		                     function(schematic_schema_version){
		                      return caml_exact_trampoline_cps_call$1
		                              (find_packed_by_id,
		                               letrec_function_context[1][1],
		                               schematic_schema_version,
		                               function(match){
		                                function a(descriptor){return cont([0, rG, 0, descriptor]);}
		                                if(! match)
		                                 return caml_exact_trampoline_cps_call
		 (fixpoint,
		  function(schematic_self, cont){
		   return caml_exact_trampoline_cps_call$1
		           (find_packed_by_id,
		            letrec_function_context[1][1],
		            schematic_schema_version,
		            function(match){
		             if(! match)
		              return caml_exact_trampoline_cps_call$0
		                      (set$3,
		                       letrec_function_context[1][1],
		                       schematic_schema_version,
		                       schematic_self,
		                       function(b){
		                        letrec_function_context[1][1] = b;
		                        var
		                         a =
		                           [0,
		                            [0, 0, 0, 0, 0, cst_deleted, 0, 2, [0, bool_schema], 0, 0],
		                            0];
		                        return caml_exact_trampoline_cps_call
		                                (schema_versioned$35,
		                                 schematic_version,
		                                 function(c){
		                                  var
		                                   b =
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_defaultReminders,
		                                       0,
		                                       2,
		                                       [0, [0, 0, 0, [3, c], 0]],
		                                       0,
		                                       0],
		                                      a];
		                                  return caml_exact_trampoline_cps_call
		  (schema_versioned$16,
		   schematic_version,
		   function(c){
		    var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		    return caml_exact_trampoline_cps_call
		            (schema_versioned$17,
		             schematic_version,
		             function(b){
		              var
		               res =
		                 [7,
		                  function(param, cont){
		                   var
		                    a = param[2],
		                    b = a[2],
		                    deleted = b[2][1],
		                    defaultReminders = b[1],
		                    id = a[1],
		                    meta = param[1];
		                   return cont([0, meta, id, defaultReminders, deleted]);
		                  },
		                  function(param, cont){
		                   var
		                    deleted = param[4],
		                    defaultReminders = param[3],
		                    id = param[2],
		                    meta = param[1];
		                   return cont
		                           ([0, meta, [0, id, [0, defaultReminders, [0, deleted, 0]]]]);
		                  },
		                  [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [1, b], 0, 0], a]];
		              return caml_exact_trampoline_cps_call$0
		                      (set$3,
		                       letrec_function_context[1][1],
		                       schematic_schema_version,
		                       res,
		                       function(a){
		                        letrec_function_context[1][1] = a;
		                        return cont(res);
		                       });
		             });
		   });
		                                 });
		                       });
		             var schema = match[1];
		             return cont(schema);
		            });
		  },
		  a);
		                                var schema = match[1];
		                                return a(schema);
		                               });
		                     });
		           }
		           var schematic_cache = [0, empty$11([0, comparator$9])];
		           caml_update_dummy
		            (letrec_function_context, [0, schematic_cache]);
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([1, f0]);},
		                function(param, cont){
		                 if(1 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                0,
		                0,
		                cst_sync_token,
		                cst_Sync_token,
		                schematic_param_name_schema_ve,
		                0],
		               [0,
		                [0,
		                 function(f0, cont){return cont([2, f0]);},
		                 function(param, cont){
		                  if(2 !== param[0]) return cont(0);
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 0,
		                 0,
		                 cst_updated,
		                 cst_Updated,
		                 b,
		                 0],
		                0]];
		           return caml_exact_trampoline_cps_call
		                   (raw_deleted_schema_versioned,
		                    function(param, cont){return cont(0);},
		                    function(raw_deleted_schema){
		                     return caml_exact_trampoline_cps_call
		                             (raw_deleted_schema_versioned,
		                              schematic_version$4,
		                              function(b){
		                               var
		                                res =
		                                  [11,
		                                   0,
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([0, f0]);},
		                                     function(param, cont){
		                                      if(0 !== param[0]) return cont(0);
		                                      var f0 = param[1];
		                                      return cont([0, f0]);
		                                     },
		                                     0,
		                                     0,
		                                     cst_deleted,
		                                     cst_Deleted,
		                                     map$14
		                                      (function(param, cont){
		var
		 deleted = param[4],
		 defaultReminders = param[3],
		 id = param[2],
		 meta = param[1];
		return deleted
		        ? cont([0, [0, meta, id, defaultReminders]])
		        : cont(rH);
		                                       },
		                                       function(param, cont){
		var
		 defaultReminders = param[3],
		 id = param[2],
		 meta = param[1];
		return cont([0, meta, id, defaultReminders, 1]);
		                                       },
		                                       b),
		                                     0],
		                                    a],
		                                   0];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$57[1][1],
		schematic_schema_version$175,
		res,
		function(a){
		 letrec_function_context$57[1][1] = a;
		 return cont(res);
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$58 = [];
		               function metadata_schema_versioned$1(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$58[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rI, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$58[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$58[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$58[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var deleted = param[2][1], updateTime = param[1];
		                       return cont([0, updateTime, deleted]);
		                      },
		                      function(param, cont){
		                       var deleted = param[2], updateTime = param[1];
		                       return cont([0, updateTime, [0, deleted, 0]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "updateTime",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, 0, 0, 0, 0, cst_deleted, 0, 2, [0, bool_schema], 0, 0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$58[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$58[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$49 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$58, [0, schematic_cache$49]);
		               caml_callback
		                (metadata_schema_versioned$1, [function(param){return 0;}]);
		               var
		                cst_System = "System",
		                cst_Unspecified = "Unspecified",
		                cst_User = "User",
		                letrec_function_context$59 = [];
		               function group_type_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$59[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rJ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$59[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$59[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$59[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(rP);},
		                        0,
		                        0,
		                        cst_GROUP_TYPE_UNSPECIFIED,
		                        cst_Unspecified,
		                        rO,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(rN) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_USER_CONTACT_GROUP,
		                         cst_User,
		                         rM,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(rL) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_SYSTEM_CONTACT_GROUP,
		                          cst_System,
		                          rK,
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$59[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$59[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$50 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$59, [0, schematic_cache$50]);
		               caml_callback
		                (group_type_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$60 = [];
		               function client_data_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$60[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rQ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$60[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$60[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$60[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var value = param[2][1], key = param[1];
		                       return cont([0, key, value]);
		                      },
		                      function(param, cont){
		                       var value = param[2], key = param[1];
		                       return cont([0, key, [0, value, 0]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_key,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_value,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$60[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$60[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$51 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$60, [0, schematic_cache$51]);
		               caml_callback
		                (client_data_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$61 = [];
		               function schema_versioned$37(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$61[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rR, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$61[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$61[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$61[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (client_data_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$66[1],
		                             default$0 = match$67[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "formattedName",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "memberResourceNames",
		                                   0,
		                                   [0, default$0],
		                                   [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, 0, 0, 0, 0, "memberCount", 0, 3, [0, int_schema], 0, 0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "clientData",
		                                     0,
		                                     [0, default$],
		                                     [0, [0, 0, 0, [3, b], 0]],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (group_type_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, "groupType", 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (metadata_schema_versioned$1,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              clientData = f[2][1],
		              memberCount = f[1],
		              memberResourceNames = e[1],
		              formattedName = d[1],
		              name = c[1],
		              groupType = b[1],
		              metadata = a[1],
		              resourceName = param[1];
		             return cont
		                     ([0,
		                       resourceName,
		                       metadata,
		                       groupType,
		                       name,
		                       formattedName,
		                       memberResourceNames,
		                       memberCount,
		                       clientData]);
		            },
		            function(param, cont){
		             var
		              clientData = param[8],
		              memberCount = param[7],
		              memberResourceNames = param[6],
		              formattedName = param[5],
		              name = param[4],
		              groupType = param[3],
		              metadata = param[2],
		              resourceName = param[1];
		             return cont
		                     ([0,
		                       resourceName,
		                       [0,
		                        metadata,
		                        [0,
		                         groupType,
		                         [0,
		                          name,
		                          [0,
		                           formattedName,
		                           [0,
		                            memberResourceNames,
		                            [0, memberCount, [0, clientData, 0]]]]]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_resourceName,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0, [0, 0, 0, 0, 0, cst_metadata, 0, 3, [0, a], 0, 0], b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$61[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$61[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$52 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$61, [0, schematic_cache$52]);
		               caml_callback
		                (schema_versioned$37, [function(param){return 0;}]);
		               var
		                cst_requestedResourceName = "requestedResourceName",
		                letrec_function_context$62 = [];
		               function schema_versioned$38(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$62[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, rS, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$62[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$62[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$62[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$19,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_requestedResourceName,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, b], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$37,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    status = a[2][1],
		    requestedResourceName = a[1],
		    contactGroup = param[1];
		   return cont
		           ([0, contactGroup, requestedResourceName, status]);
		  },
		  function(param, cont){
		   var
		    status = param[3],
		    requestedResourceName = param[2],
		    contactGroup = param[1];
		   return cont
		           ([0,
		             contactGroup,
		             [0, requestedResourceName, [0, status, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, "contactGroup", 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$62[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$62[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$53 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$62, [0, schematic_cache$53]);
		               caml_callback
		                (schema_versioned$38, [function(param){return 0;}]);
		               var
		                schematic_cache$54 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$63 = [];
		               caml_update_dummy
		                (letrec_function_context$63, [0, schematic_cache$54]);
		               function schematic_version$5(param){return 0;}
		               var
		                cst_responses = "responses",
		                schematic_schema_version$174 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$63[1][1],
		                    schematic_schema_version$174]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$63[1][1],
		                             schematic_schema_version$174,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$63[1][1],
		schematic_schema_version$174,
		schematic_self,
		function(a){
		 letrec_function_context$63[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$38,
		          schematic_version$5,
		          function(a){
		           var
		            default$ = match$68[1],
		            res =
		              [7,
		               function(param, cont){
		                var responses = param[1];
		                return cont([0, responses]);
		               },
		               function(param, cont){
		                var responses = param[1];
		                return cont([0, responses, 0]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_responses,
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, a], 0]],
		                 0,
		                 0],
		                0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$63[1][1],
		                    schematic_schema_version$174,
		                    res,
		                    function(a){
		                     letrec_function_context$63[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$55 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$64 = [];
		               caml_update_dummy
		                (letrec_function_context$64, [0, schematic_cache$55]);
		               var cst_Contact = "Contact", schematic_schema_version$51 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$64[1][1],
		                    schematic_schema_version$51]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$64[1][1],
		                             schematic_schema_version$51,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$64[1][1],
		schematic_schema_version$51,
		schematic_self,
		function(a){
		 letrec_function_context$64[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(rW);},
		       0,
		       0,
		       cst_DIRECTORY_MERGE_SOURCE_TYP$0,
		       cst_Unspecified,
		       rV,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){return param ? cont(rU) : cont(0);},
		        0,
		        0,
		        cst_DIRECTORY_MERGE_SOURCE_TYP,
		        cst_Contact,
		        rT,
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$64[1][1],
		          schematic_schema_version$51,
		          res,
		          function(a){
		           letrec_function_context$64[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$56 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$65 = [];
		               caml_update_dummy
		                (letrec_function_context$65, [0, schematic_cache$56]);
		               var
		                cst_Domain_contact = "Domain_contact",
		                schematic_schema_version$50 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$65[1][1],
		                    schematic_schema_version$50]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$65[1][1],
		                             schematic_schema_version$50,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$65[1][1],
		schematic_schema_version$50,
		schematic_self,
		function(a){
		 letrec_function_context$65[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(r2);},
		       0,
		       0,
		       cst_DIRECTORY_SOURCE_TYPE_UNSP,
		       cst_Unspecified,
		       r1,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         return 1 === param ? cont(r0) : cont(0);
		        },
		        0,
		        0,
		        cst_DIRECTORY_SOURCE_TYPE_DOMA$0,
		        cst_Domain_contact,
		        rZ,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(2);},
		         function(param, cont){
		          return 2 <= param ? cont(rY) : cont(0);
		         },
		         0,
		         0,
		         cst_DIRECTORY_SOURCE_TYPE_DOMA,
		         "Domain_profile",
		         rX,
		         0],
		        0]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$65[1][1],
		          schematic_schema_version$50,
		          res,
		          function(a){
		           letrec_function_context$65[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_endIndex = "endIndex",
		                cst_startIndex = "startIndex",
		                letrec_function_context$66 = [];
		               function range_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$66[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, r3, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$66[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$66[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$66[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var end_index = param[2][1], start_index = param[1];
		                       return cont([0, start_index, end_index]);
		                      },
		                      function(param, cont){
		                       var end_index = param[2], start_index = param[1];
		                       return cont([0, start_index, [0, end_index, 0]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_startIndex, 0, 2, [0, int_schema], 0, 0],
		                       [0,
		                        [0, 0, 0, 0, 0, cst_endIndex, 0, 2, [0, int_schema], 0, 0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$66[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$66[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$57 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$66, [0, schematic_cache$57]);
		               caml_callback
		                (range_schema_versioned, [function(param){return 0;}]);
		               var
		                cst_elements = "elements",
		                cst_paragraphStyle = "paragraphStyle",
		                cw = [];
		               function schema_versioned$39(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cw[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, r4, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cw[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cw[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cw[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (style_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_paragraphStyle, 0, 2, [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (element_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var style = param[2][1], elements = param[1];
		   return cont([0, elements, style]);
		  },
		  function(param, cont){
		   var style = param[2], elements = param[1];
		   return cont([0, elements, [0, style, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_elements,
		    0,
		    2,
		    [0, [0, 0, 0, [3, b], 0]],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cw[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cw[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cx = [];
		               function element_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cx[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, r5, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cx[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cx[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cx[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (text_run_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, "textRun", 0, 3, [0, b], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (range_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var text_run = param[2][1], range = param[1];
		   return cont([0, range, text_run]);
		  },
		  function(param, cont){
		   var text_run = param[2], range = param[1];
		   return cont([0, range, [0, text_run, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_range, 0, 2, [1, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cx[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cx[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cy = [];
		               function text_run_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cy[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, r6, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cy[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cy[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cy[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var content = param[1];
		                       return cont([0, content]);
		                      },
		                      function(param, cont){
		                       var content = param[1];
		                       return cont([0, content, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_content,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cy[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){cy[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cz = [];
		               function style_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cz[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, r7, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cz[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cz[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cz[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (named_style_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var named_style = param[2][1], heading_id = param[1];
		                                 return cont([0, heading_id, named_style]);
		                                },
		                                function(param, cont){
		                                 var named_style = param[2], heading_id = param[1];
		                                 return cont([0, heading_id, [0, named_style, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "headingId",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, "namedStyleType", 0, 3, [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cz[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cz[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cst_Title = "Title", letrec_function_context$67 = [];
		               function named_style_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$67[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, r8, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$67[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$67[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$67[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(sq);},
		                        0,
		                        0,
		                        cst_NAMED_STYLE_TYPE_UNSPECIFI,
		                        cst_Unspecified,
		                        sp,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(so) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_NORMAL_TEXT,
		                         "Normal",
		                         sn,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(sm) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_TITLE,
		                          cst_Title,
		                          sl,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(sk) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_SUBTITLE,
		                           "Subtitle",
		                           sj,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 === param ? cont(si) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_HEADING_1,
		                            "Heading_1",
		                            sh,
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(5);},
		                             function(param, cont){
		                              return 5 === param ? cont(sg) : cont(0);
		                             },
		                             0,
		                             0,
		                             cst_HEADING_2,
		                             "Heading_2",
		                             sf,
		                             0],
		                            [0,
		                             [0,
		                              function(param, cont){return cont(6);},
		                              function(param, cont){
		                               return 6 === param ? cont(se) : cont(0);
		                              },
		                              0,
		                              0,
		                              cst_HEADING_3,
		                              "Heading_3",
		                              sd,
		                              0],
		                             [0,
		                              [0,
		                               function(param, cont){return cont(7);},
		                               function(param, cont){
		                                return 7 === param ? cont(sc) : cont(0);
		                               },
		                               0,
		                               0,
		                               cst_HEADING_4,
		                               "Heading_4",
		                               sb,
		                               0],
		                              [0,
		                               [0,
		                                function(param, cont){return cont(8);},
		                                function(param, cont){
		                                 return 8 === param ? cont(sa) : cont(0);
		                                },
		                                0,
		                                0,
		                                cst_HEADING_5,
		                                "Heading_5",
		                                r$,
		                                0],
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(9);},
		                                 function(param, cont){
		                                  return 9 <= param ? cont(r_) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_HEADING_6,
		                                 "Heading_6",
		                                 r9,
		                                 0],
		                                0]]]]]]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$67[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$67[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$58 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cw, [0, schematic_cache$58]);
		               var schematic_cache$59 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cx, [0, schematic_cache$59]);
		               var schematic_cache$60 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cy, [0, schematic_cache$60]);
		               var schematic_cache$61 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cz, [0, schematic_cache$61]);
		               var schematic_cache$62 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$67, [0, schematic_cache$62]);
		               caml_callback
		                (schema_versioned$39, [function(param){return 0;}]);
		               caml_callback
		                (element_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (text_run_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (style_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (named_style_schema_versioned, [function(param){return 0;}]);
		               var cB = [];
		               function request_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cB[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, sr, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cB[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cB[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cB[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (range_request_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, "deleteContentRange", 0, 3, [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (update_paragraph_style_schema_,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, "updateParagraphStyle", 0, 3, [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (insert_text_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              delete_content_range = a[2][1],
		              update_paragraph_style = a[1],
		              insert_text = param[1];
		             return cont
		                     ([0,
		                       insert_text,
		                       update_paragraph_style,
		                       delete_content_range]);
		            },
		            function(param, cont){
		             var
		              delete_content_range = param[3],
		              update_paragraph_style = param[2],
		              insert_text = param[1];
		             return cont
		                     ([0,
		                       insert_text,
		                       [0, update_paragraph_style, [0, delete_content_range, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, "insertText", 0, 3, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cB[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){cB[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cC = [];
		               function insert_text_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cC[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, ss, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cC[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cC[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cC[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (location_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var location = param[2][1], text = param[1];
		                                 return cont([0, text, location]);
		                                },
		                                function(param, cont){
		                                 var location = param[2], text = param[1];
		                                 return cont([0, text, [0, location, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_text,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0, [0, 0, 0, 0, 0, cst_location, 0, 2, [0, a], 0, 0], 0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cC[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cC[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cst_fields = "fields", cD = [];
		               function update_paragraph_style_schema_
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cD[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, su, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cD[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cD[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cD[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (range_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_fields,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_range, 0, 2, [0, b], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (style_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    update_range = a[2][1],
		    fields = a[1],
		    style = param[1];
		   return cont([0, style, fields, update_range]);
		  },
		  function(param, cont){
		   var
		    update_range = param[3],
		    fields = param[2],
		    style = param[1];
		   return cont([0, style, [0, fields, [0, update_range, 0]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_paragraphStyle, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cD[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cD[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cE = [];
		               function range_request_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cE[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, sv, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cE[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cE[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cE[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (range_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var range = param[1];
		                                 return cont([0, range]);
		                                },
		                                function(param, cont){
		                                 var range = param[1];
		                                 return cont([0, range, 0]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_range, 0, 2, [0, a], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cE[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cE[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cF = [];
		               function location_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cF[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, sw, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cF[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cF[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cF[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var index = param[1];
		                       return cont([0, index]);
		                      },
		                      function(param, cont){
		                       var index = param[1];
		                       return cont([0, index, 0]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_index, 0, 2, [0, int_schema], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cF[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){cF[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cG = [];
		               function write_control_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cG[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, sx, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cG[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cG[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cG[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "requiredRevisionId",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cG[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){cG[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$63 = [0, empty$11([0, comparator$9])],
		                cA = [];
		               caml_update_dummy(cA, [0, schematic_cache$63]);
		               var schematic_cache$64 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cB, [0, schematic_cache$64]);
		               var schematic_cache$65 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cC, [0, schematic_cache$65]);
		               var schematic_cache$66 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cD, [0, schematic_cache$66]);
		               var schematic_cache$67 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cE, [0, schematic_cache$67]);
		               var schematic_cache$68 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cF, [0, schematic_cache$68]);
		               var schematic_cache$69 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cG, [0, schematic_cache$69]);
		               var
		                schematic_cache$70 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$68 = [];
		               caml_update_dummy
		                (letrec_function_context$68, [0, schematic_cache$70]);
		               function schematic_version$6(param){return 0;}
		               var
		                cst_writeControl = "writeControl",
		                schematic_schema_version$173 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [cA[1][1], schematic_schema_version$173]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             cA[1][1],
		                             schematic_schema_version$173,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		cA[1][1],
		schematic_schema_version$173,
		schematic_self,
		function(a){
		 cA[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (write_control_schema_versioned,
		          schematic_version$6,
		          function(b){
		           var
		            a =
		              [0,
		               [0, 0, 0, 0, 0, cst_writeControl, 0, 2, [0, b], 0, 0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (request_schema_versioned,
		                    schematic_version$6,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var write_control = param[2][1], requests = param[1];
		                          return cont([0, requests, write_control]);
		                         },
		                         function(param, cont){
		                          var write_control = param[2], requests = param[1];
		                          return cont([0, requests, [0, write_control, 0]]);
		                         },
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "requests",
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, b], 0]],
		                           0,
		                           0],
		                          a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              cA[1][1],
		                              schematic_schema_version$173,
		                              res,
		                              function(a){cA[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (request_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (insert_text_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (update_paragraph_style_schema_, [function(param){return 0;}]);
		               caml_callback
		                (range_request_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (location_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (write_control_schema_versioned, [function(param){return 0;}]);
		               function schematic_version$7(param){return 0;}
		               var
		                cst_documentId = "documentId",
		                schematic_schema_version$172 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$68[1][1],
		                    schematic_schema_version$172]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$68[1][1],
		                             schematic_schema_version$172,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$68[1][1],
		schematic_schema_version$172,
		schematic_self,
		function(a){
		 letrec_function_context$68[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (write_control_schema_versioned,
		          schematic_version$7,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 write_control_response = param[2][1],
		                 document_id = param[1];
		                return cont([0, document_id, write_control_response]);
		               },
		               function(param, cont){
		                var
		                 write_control_response = param[2],
		                 document_id = param[1];
		                return cont
		                        ([0, document_id, [0, write_control_response, 0]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_documentId,
		                 0,
		                 2,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0, 0, 0, 0, 0, cst_writeControl, 0, 2, [0, a], 0, 0],
		                 0]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$68[1][1],
		                    schematic_schema_version$172,
		                    res,
		                    function(a){
		                     letrec_function_context$68[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var cI = [];
		               function body_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         cI[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, sy, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      cI[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cI[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  cI[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (structural_element_schema_vers,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var content = param[1];
		                                 return cont([0, content]);
		                                },
		                                function(param, cont){
		                                 var content = param[1];
		                                 return cont([0, content, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_content,
		                                  0,
		                                  2,
		                                  [0, [0, 0, 0, [3, a], 0]],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cI[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cI[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var letrec_function_context$69 = [];
		               function structural_element_schema_vers
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$69[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, sz, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$69[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$69[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$69[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$39,
		                           schematic_version,
		                           function(a){
		                            var
		                             default$ = match$69[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  paragraph = a[2][1],
		                                  end_index = a[1],
		                                  start_index = param[1];
		                                 return cont([0, start_index, end_index, paragraph]);
		                                },
		                                function(param, cont){
		                                 var
		                                  paragraph = param[3],
		                                  end_index = param[2],
		                                  start_index = param[1];
		                                 return cont
		 ([0, start_index, [0, end_index, [0, paragraph, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_startIndex,
		                                  0,
		                                  [0, default$],
		                                  [0, int_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_endIndex, 0, 2, [0, int_schema], 0, 0],
		                                  [0, [0, 0, 0, 0, 0, cst_paragraph, 0, 3, [0, a], 0, 0], 0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$69[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$69[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$71 = [0, empty$11([0, comparator$9])],
		                cH = [];
		               caml_update_dummy(cH, [0, schematic_cache$71]);
		               var schematic_cache$72 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cI, [0, schematic_cache$72]);
		               var schematic_cache$73 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$69, [0, schematic_cache$73]);
		               function schematic_version$8(param){return 0;}
		               var schematic_schema_version$171 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [cH[1][1], schematic_schema_version$171]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             cH[1][1],
		                             schematic_schema_version$171,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		cH[1][1],
		schematic_schema_version$171,
		schematic_self,
		function(a){
		 cH[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (body_schema_versioned,
		          schematic_version$8,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 b = a[2],
		                 body = b[2][1],
		                 title = b[1],
		                 revision_id = a[1],
		                 id = param[1];
		                return cont([0, id, revision_id, title, body]);
		               },
		               function(param, cont){
		                var
		                 body = param[4],
		                 title = param[3],
		                 revision_id = param[2],
		                 id = param[1];
		                return cont
		                        ([0, id, [0, revision_id, [0, title, [0, body, 0]]]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_documentId,
		                 0,
		                 2,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  "revisionId",
		                  0,
		                  2,
		                  [0, schematic_param_name_schema_ve],
		                  0,
		                  0],
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_title,
		                   0,
		                   2,
		                   [0, schematic_param_name_schema_ve],
		                   0,
		                   0],
		                  [0, [0, 0, 0, 0, 0, cst_body, 0, 2, [0, a], 0, 0], 0]]]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    cH[1][1],
		                    schematic_schema_version$171,
		                    res,
		                    function(a){cH[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (body_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (structural_element_schema_vers, [function(param){return 0;}]);
		               function datetime_schema_versioned(param){
		                var
		                 descriptor =
		                   [4,
		                    function(param, cont){
		                     var offset = param[2], t = param[1];
		                     return caml_exact_trampoline_cps_call
		                             (of_gmt_offset_seconds,
		                              offset,
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (of_string$0, [0, t, a], cont);
		                              });
		                    },
		                    function(param, cont){
		                     var tz = param[2], t = param[1];
		                     return caml_exact_trampoline_cps_call$0
		                             (gmt_offset_seconds_at_datetime,
		                              tz,
		                              sB,
		                              sA,
		                              function(a){return cont([0, t, a]);});
		                    },
		                    10];
		                return [0, id$12, 0, descriptor, 0];
		               }
		               var cst_Tentative = "Tentative", cJ = [];
		               function response_status_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cJ[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, sC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cJ[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cJ[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cJ[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(sK);},
		                                  0,
		                                  0,
		                                  cst_needsAction,
		                                  "Needs_action",
		                                  sJ,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(sI) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_declined,
		                                   "Declined",
		                                   sH,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(sG) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_tentative,
		                                    cst_Tentative,
		                                    sF,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 <= param ? cont(sE) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_accepted,
		                                     cst_Accepted,
		                                     sD,
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cJ[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cJ[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Cancelled = "Cancelled",
		                cst_Confirmed = "Confirmed",
		                cK = [];
		               function status_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cK[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, sL, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cK[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cK[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cK[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(sR);},
		                                  0,
		                                  0,
		                                  cst_confirmed,
		                                  cst_Confirmed,
		                                  sQ,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(sP) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_tentative,
		                                   cst_Tentative,
		                                   sO,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(sN) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_cancelled,
		                                    cst_Cancelled,
		                                    sM,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cK[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cK[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$70 = [];
		               function transparency_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$70[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, sS, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$70[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$70[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$70[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(sW);},
		                                  0,
		                                  0,
		                                  cst_opaque,
		                                  "Opaque",
		                                  sV,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(sU) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_transparent,
		                                   "Transparent",
		                                   sT,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$70[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$70[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$74 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cJ, [0, schematic_cache$74]);
		               var schematic_cache$75 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cK, [0, schematic_cache$75]);
		               var schematic_cache$76 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$70, [0, schematic_cache$76]);
		               caml_callback
		                (response_status_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (transparency_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var cst_Other = "Other", letrec_function_context$71 = [];
		               function event_type_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$71[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, sX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$71[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$71[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$71[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(s9);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_default,
		                                  cst_Default,
		                                  s8,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 1 === param)
		                                     return cont(s7);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_focusTime,
		                                   "Focus_time",
		                                   s6,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 2 === param)
		                                      return cont(s5);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_fromGmail,
		                                    "From_gmail",
		                                    s4,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 3 === param)
		                                       return cont(s3);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_outOfOffice,
		                                     "Out_of_office",
		                                     s2,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && 4 === param)
		return cont(s1);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_workingLocation,
		                                      "Working_location",
		                                      s0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		if(typeof param === "number" && 5 <= param) return cont(sZ);
		return cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_birthday,
		                                       "Birthday",
		                                       sY,
		                                       0],
		                                      [0,
		                                       [0,
		function(f0, cont){return cont([0, f0]);},
		function(param, cont){
		 if(typeof param === "number") return cont(0);
		 var f0 = param[1];
		 return cont([0, f0]);
		},
		0,
		0,
		cst_other,
		cst_Other,
		schematic_param_name_schema_ve,
		0],
		                                       0]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$71[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$71[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$77 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$71, [0, schematic_cache$77]);
		               caml_callback
		                (event_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function equal$38(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(! c) return cont(c);
		                var y = rhs[2], x = lhs[2];
		                if(x){
		                 if(y){
		                  var b$0 = y[1], a$0 = x[1];
		                  return cont(a$0 === b$0 ? 1 : 0);
		                 }
		                }
		                else if(! y) return cont(1);
		                return cont(0);
		               }
		               var letrec_function_context$72 = [];
		               function schema_versioned$40(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$72[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, s_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$72[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$72[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$72[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var display_name = param[2][1], email = param[1];
		                                 return cont([0, email, display_name]);
		                                },
		                                function(param, cont){
		                                 var display_name = param[2], email = param[1];
		                                 return cont([0, email, [0, display_name, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_email,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_displayName,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$72[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$72[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$78 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$72, [0, schematic_cache$78]);
		               caml_callback
		                (schema_versioned$40,
		                 [function(param, cont){return cont(0);}]);
		               var cst_Some = "(Some ", cst_display_name = "display_name";
		               function pp$25(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         s$,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   ta,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Event_intf.Insert_persona.email",
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               tb,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   tc,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     td,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               te,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_display_name,
		                         function(a){
		                          a = x[2];
		                          function b(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    tg,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), th, cont);
		                                    });
		                          }
		                          if(! a)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_None, b);
		                          var x$0 = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   fmt,
		                                   cst_Some,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     tf,
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               x$0,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, cst$18, b);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function equal$39(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                a:
		                {
		                 if(x){
		                  if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                a:
		                if(c){
		                 var y$0 = rhs[3], x$0 = lhs[3];
		                 if(x$0){
		                  if(y$0){
		                   var b$1 = y$0[1], a$1 = x$0[1], c = a$1 === b$1 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y$0){c = 1; break a;}
		                 c = 0;
		                }
		                if(! c) return cont(c);
		                var b$2 = rhs[4], a$2 = lhs[4];
		                return cont(a$2 === b$2 ? 1 : 0);
		               }
		               var letrec_function_context$73 = [];
		               function schema_versioned$41(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$73[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ti, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$73[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$73[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$73[1][1] = a;
		                            var
		                             default$ = match$70[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  self = b[2][1],
		                                  display_name = b[1],
		                                  email = a[1],
		                                  persona_id = param[1];
		                                 return cont([0, persona_id, email, display_name, self]);
		                                },
		                                function(param, cont){
		                                 var
		                                  self = param[4],
		                                  display_name = param[3],
		                                  email = param[2],
		                                  persona_id = param[1];
		                                 return cont
		 ([0,
		   persona_id,
		   [0, email, [0, display_name, [0, self, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_id,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_email,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_displayName,
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_self,
		                                     0,
		                                     [0, default$],
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$73[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$73[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$79 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$73, [0, schematic_cache$79]);
		               caml_callback
		                (schema_versioned$41,
		                 [function(param, cont){return cont(0);}]);
		               function pp$26(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         tj,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   tk,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Event_intf.Persona.persona_id",
		     function(a){
		      a = x[1];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                tm,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          tn,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    to,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_email,
		      function(b){
		       var a = x[2];
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                tp,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    tq,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      tr,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ts,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_display_name,
		                          function(a){
		                           a = x[3];
		                           function b(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     tu,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       tv,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 tw,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (a,
		                           cst_self,
		                           function(b){
		                            var a = x[4];
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     tx,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 ty,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt), tz, cont);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           if(! a)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, b);
		                           var x$0 = a[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      tt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x$0,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, b);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(! a)
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst_None, b);
		      var x$0 = a[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst_Some,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         tl,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, fmt, cst$18, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var cst_organizer = "organizer", cst_resource = "resource";
		               function attendee_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_persona_schema, cont){
		                                    function descriptor(schematic_param_persona_schema, cont){
		                                     var
		                                      default$ = match$71[1],
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_comment,
		  0,
		  3,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "additionalGuests",
		   0,
		   [0, default$],
		   [0, int_schema],
		   0,
		   0],
		  0]];
		                                     return caml_exact_trampoline_cps_call
		     (response_status_schema_version,
		      schematic_version,
		      function(b){
		       var
		        default$ = match$72[1],
		        default$0 = match$73[1],
		        default$1 = match$74[1];
		       return cont
		               ([7,
		                 function(param, cont){
		                  var
		                   a = param[2],
		                   b = a[2],
		                   c = b[2],
		                   d = c[2],
		                   e = d[2],
		                   additional_guests = e[2][1],
		                   comment = e[1],
		                   response_status = d[1],
		                   optional = c[1],
		                   resource = b[1],
		                   is_organizer = a[1],
		                   persona = param[1];
		                  return cont
		                          ([0,
		                            persona,
		                            is_organizer,
		                            resource,
		                            optional,
		                            response_status,
		                            comment,
		                            additional_guests]);
		                 },
		                 function(param, cont){
		                  var
		                   additional_guests = param[7],
		                   comment = param[6],
		                   response_status = param[5],
		                   optional = param[4],
		                   resource = param[3],
		                   is_organizer = param[2],
		                   persona = param[1];
		                  return cont
		                          ([0,
		                            persona,
		                            [0,
		                             is_organizer,
		                             [0,
		                              resource,
		                              [0,
		                               optional,
		                               [0,
		                                response_status,
		                                [0, comment, [0, additional_guests, 0]]]]]]]);
		                 },
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_persona,
		                   0,
		                   2,
		                   [1, schematic_param_persona_schema],
		                   0,
		                   0],
		                  [0,
		                   [0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    cst_organizer,
		                    0,
		                    [0, default$1],
		                    [0, bool_schema],
		                    0,
		                    0],
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     cst_resource,
		                     0,
		                     [0, default$0],
		                     [0, bool_schema],
		                     0,
		                     0],
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      "optional",
		                      0,
		                      [0, default$],
		                      [0, bool_schema],
		                      0,
		                      0],
		                     [0,
		                      [0, 0, 0, 0, 0, "responseStatus", 0, 2, [0, b], 0, 0],
		                      a]]]]]]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$75[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_persona,
		 schematic_param_persona_schema,
		 function(schematic_param_persona_schema, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_persona_schema,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_persona_schema,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var cst_Phone = "Phone", cL = [];
		               function entrypoint_type_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cL[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, tA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cL[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cL[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cL[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(tI);},
		                                  0,
		                                  0,
		                                  cst_more,
		                                  "More",
		                                  tH,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(tG) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_phone,
		                                   cst_Phone,
		                                   tF,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(tE) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_sip,
		                                    "Sip",
		                                    tD,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 <= param ? cont(tC) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_video,
		                                     "Video",
		                                     tB,
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cL[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cL[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_Success = "Success", cM = [];
		               function status_code_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cM[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, tJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cM[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cM[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cM[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(tP);},
		                                  0,
		                                  0,
		                                  cst_failure,
		                                  cst_Failure,
		                                  tO,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(tN) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_pending,
		                                   "Pending",
		                                   tM,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(tL) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_success,
		                                    cst_Success,
		                                    tK,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cM[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cM[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$74 = [];
		               function conference_type_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$74[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, tQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$74[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$74[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$74[1][1] = b;
		                            function schematic_case(name, cont){
		                             return cont
		                                     ([0,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(tT);},
		                                       0,
		                                       0,
		                                       name,
		                                       name,
		                                       [0, 0, 0, [9, name], 0],
		                                       0]);
		                            }
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(1);},
		                                 function(param, cont){return param ? cont(tS) : cont(0);},
		                                 0,
		                                 0,
		                                 cst_addOn,
		                                 "Third_party",
		                                 tR,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$0,
		                                     schematic_case,
		                                     tU,
		                                     function(b){
		                                      var cst_hangoutsMeet = "hangoutsMeet";
		                                      return caml_exact_trampoline_cps_call
		      (schematic_case,
		       cst_hangoutsMeet,
		       function(c){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){return param ? cont(0) : cont(tV);},
		              0,
		              0,
		              cst_hangoutsMeet,
		              "Google_meet",
		              [0, 0, 0, [11, 0, [0, c, b], 0], 0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$74[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$74[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$80 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cL, [0, schematic_cache$80]);
		               var schematic_cache$81 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cM, [0, schematic_cache$81]);
		               var schematic_cache$82 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$74, [0, schematic_cache$82]);
		               caml_callback
		                (entrypoint_type_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_code_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (conference_type_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var cN = [];
		               function schema_versioned$42(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cN[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, tW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cN[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cN[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cN[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (gadget_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "conferenceId",
		   0,
		   3,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "signature",
		    0,
		    3,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_notes,
		     0,
		     3,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0, [0, 0, 0, 0, 0, cst_gadget, 0, 3, [0, b], 0, 0], 0]]]];
		                                      return caml_exact_trampoline_cps_call
		      (solution_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, "conferenceSolution", 0, 3, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (entrypoint_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   default$ = match$76[1],
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       "entryPoints",
		                       0,
		                       [0, default$],
		                       [0, [0, 0, 0, [3, c], 0]],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (create_request_schema_versione,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  gadget = e[2][1],
		                                  notes = e[1],
		                                  signature = d[1],
		                                  id = c[1],
		                                  solution = b[1],
		                                  entrypoints = a[1],
		                                  create_request = param[1];
		                                 return cont
		 ([0,
		   create_request,
		   entrypoints,
		   solution,
		   id,
		   signature,
		   notes,
		   gadget]);
		                                },
		                                function(param, cont){
		                                 var
		                                  gadget = param[7],
		                                  notes = param[6],
		                                  signature = param[5],
		                                  id = param[4],
		                                  solution = param[3],
		                                  entrypoints = param[2],
		                                  create_request = param[1];
		                                 return cont
		 ([0,
		   create_request,
		   [0,
		    entrypoints,
		    [0,
		     solution,
		     [0, id, [0, signature, [0, notes, [0, gadget, 0]]]]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, "createRequest", 0, 3, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cN[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cN[1][1] = a; return cont(res);});
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cO = [];
		               function create_request_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cO[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, tX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cO[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cO[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cO[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_status, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (type_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              status = a[2][1],
		              solution_key = a[1],
		              request_id = param[1];
		             return cont([0, request_id, solution_key, status]);
		            },
		            function(param, cont){
		             var
		              status = param[3],
		              solution_key = param[2],
		              request_id = param[1];
		             return cont
		                     ([0, request_id, [0, solution_key, [0, status, 0]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "requestId",
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, "conferenceSolutionKey", 0, 2, [0, b], 0, 0],
		              a]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cO[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){cO[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cP = [];
		               function type_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cP[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, tY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cP[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cP[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cP[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (conference_type_schema_version,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var type = param[1];
		   return cont([0, type]);
		  },
		  function(param, cont){
		   var type = param[1];
		   return cont([0, type, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cP[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cP[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cQ = [];
		               function entrypoint_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cQ[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, tZ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cQ[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cQ[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            cQ[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_uri,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_label,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_pin,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "accessCode",
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "meetingCode",
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      "passcode",
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       "password",
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (entrypoint_type_schema_version,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    password = f[2][1],
		    passcode = f[1],
		    meetingCode = e[1],
		    accessCode = d[1],
		    pin = c[1],
		    label = b[1],
		    uri = a[1],
		    entrypoint_type = param[1];
		   return cont
		           ([0,
		             entrypoint_type,
		             uri,
		             label,
		             pin,
		             accessCode,
		             meetingCode,
		             passcode,
		             password]);
		  },
		  function(param, cont){
		   var
		    password = param[8],
		    passcode = param[7],
		    meetingCode = param[6],
		    accessCode = param[5],
		    pin = param[4],
		    label = param[3],
		    uri = param[2],
		    entrypoint_type = param[1];
		   return cont
		           ([0,
		             entrypoint_type,
		             [0,
		              uri,
		              [0,
		               label,
		               [0,
		                pin,
		                [0,
		                 accessCode,
		                 [0, meetingCode, [0, passcode, [0, password, 0]]]]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, "entryPointType", 0, 3, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cQ[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cQ[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cR = [];
		               function status_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cR[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cR[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cR[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cR[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_code_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var code = param[1];
		   return cont([0, code]);
		  },
		  function(param, cont){
		   var code = param[1];
		   return cont([0, code, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, "statusCode", 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cR[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cR[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cS = [];
		               function solution_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cS[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t1, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cS[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cS[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            cS[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0, 0, 0, 0, 0, "iconUri", 0, 3, [0, schema$268], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (type_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    icon = a[2][1],
		    name = a[1],
		    key = param[1];
		   return cont([0, key, name, icon]);
		  },
		  function(param, cont){
		   var icon = param[3], name = param[2], key = param[1];
		   return cont([0, key, [0, name, [0, icon, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cS[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cS[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_display = "display",
		                cst_iconLink = "iconLink",
		                cst_width = "width",
		                letrec_function_context$75 = [];
		               function gadget_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$75[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$75[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$75[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$75[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  preferences = f[2][1],
		                                  display = f[1],
		                                  height = e[1],
		                                  width = d[1],
		                                  icon = c[1],
		                                  link = b[1],
		                                  title = a[1],
		                                  type = param[1];
		                                 return cont
		 ([0,
		   type,
		   title,
		   link,
		   icon,
		   width,
		   height,
		   display,
		   preferences]);
		                                },
		                                function(param, cont){
		                                 var
		                                  preferences = param[8],
		                                  display = param[7],
		                                  height = param[6],
		                                  width = param[5],
		                                  icon = param[4],
		                                  link = param[3],
		                                  title = param[2],
		                                  type = param[1];
		                                 return cont
		 ([0,
		   type,
		   [0,
		    title,
		    [0,
		     link,
		     [0,
		      icon,
		      [0, width, [0, height, [0, display, [0, preferences, 0]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_title,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_link,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_iconLink, 0, 2, [0, schema$268], 0, 0],
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_width, 0, 3, [0, int_schema], 0, 0],
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_height, 0, 3, [0, int_schema], 0, 0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_display,
		0,
		3,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 "preferences",
		 0,
		 2,
		 [0,
		  [0,
		   0,
		   0,
		   mapping_schema(schematic_param_name_schema_ve)[3],
		   0]],
		 0,
		 0],
		0]]]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$75[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$75[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$83 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cN, [0, schematic_cache$83]);
		               var schematic_cache$84 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cO, [0, schematic_cache$84]);
		               var schematic_cache$85 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cP, [0, schematic_cache$85]);
		               var schematic_cache$86 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cQ, [0, schematic_cache$86]);
		               var schematic_cache$87 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cR, [0, schematic_cache$87]);
		               var schematic_cache$88 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cS, [0, schematic_cache$88]);
		               var schematic_cache$89 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$75, [0, schematic_cache$89]);
		               caml_callback
		                (schema_versioned$42,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (create_request_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (entrypoint_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (solution_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (gadget_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_param_a_schema_versi = [0, 0, 0, 7, 0],
		                descriptor$1 = 8,
		                letrec_function_context$76 = [];
		               function time_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$76[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t3, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$76[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$76[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$76[1][1] = a;
		                            a = "dateTime";
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_datetime,
		                                  "Datetime",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var timezone = param[2][1], date_time = param[1];
		                                     return cont([0, date_time, timezone]);
		                                    },
		                                    function(param, cont){
		                                     var timezone = param[2], date_time = param[1];
		                                     return cont([0, date_time, [0, timezone, t5]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      a,
		                                      0,
		                                      2,
		                                      [0, datetime_schema_versioned()],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_timeZone,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_date,
		0,
		0,
		[0, schematic_param_a_schema_versi],
		0,
		0],
		                                       0]]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(0 === param[0]) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_date,
		                                   cst_Date,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var date = param[1];
		                                      return cont(date);
		                                     },
		                                     function(date, cont){return cont([0, date, t4]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_date,
		                                       0,
		                                       2,
		                                       [0,
		[0, 0, 0, [4, of_string$12, to_string$20, descriptor$1], 0]],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		a,
		0,
		0,
		[0, schematic_param_a_schema_versi],
		0,
		0],
		                                       0]]],
		                                    0],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$76[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$76[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$90 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$76, [0, schematic_cache$90]);
		               caml_callback
		                (time_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var cst_shared = "shared", letrec_function_context$77 = [];
		               function schema_versioned$43(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$77[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t6, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$77[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$77[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$77[1][1] = a;
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               mapping_schema(schematic_param_name_schema_ve)[3],
		                               0]];
		                            var
		                             default$ = match$77[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 mapping_schema(schematic_param_name_schema_ve)[3],
		                                 0]],
		                             default$0 = match$78[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var shared = param[2][1], private$ = param[1];
		                                 return cont([0, private$, shared]);
		                                },
		                                function(param, cont){
		                                 var shared = param[2], private$ = param[1];
		                                 return cont([0, private$, [0, shared, 0]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_private, 0, [0, default$0], b, 0, 0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_shared, 0, [0, default$], a, 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$77[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$77[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$91 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$77, [0, schematic_cache$91]);
		               caml_callback
		                (schema_versioned$43,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$78 = [];
		               function schema_versioned$44(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$78[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$78[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$78[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$78[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(a){
		                                      a = [0, [0, 0, 0, mapping_schema(a)[3], 0]];
		                                      var
		                                       default$ = match$79[1],
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, cst_shared, 0, [0, default$], a, 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        a = [0, [0, 0, 0, mapping_schema(a)[3], 0]];
		        var
		         default$ = match$80[1],
		         res =
		           [7,
		            function(param, cont){
		             var shared = param[2][1], private$ = param[1];
		             return cont([0, private$, shared]);
		            },
		            function(param, cont){
		             var shared = param[2], private$ = param[1];
		             return cont([0, private$, [0, shared, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_private, 0, [0, default$], a, 0, 0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$78[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$78[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$92 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$78, [0, schematic_cache$92]);
		               caml_callback
		                (schema_versioned$44,
		                 [function(param, cont){return cont(0);}]);
		               var cT = [];
		               function reminders_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cT[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cT[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cT[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cT[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$35,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var overrides = param[2][1], useDefault = param[1];
		   return cont([0, useDefault, overrides]);
		  },
		  function(param, cont){
		   var overrides = param[2], useDefault = param[1];
		   return cont([0, useDefault, [0, overrides, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, "useDefault", 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "overrides",
		     0,
		     3,
		     [0, [0, 0, 0, [3, a], 0]],
		     0,
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cT[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cT[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cU = [];
		               function source_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cU[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cU[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cU[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cU[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var title = param[2][1], url = param[1];
		                                 return cont([0, url, title]);
		                                },
		                                function(param, cont){
		                                 var title = param[2], url = param[1];
		                                 return cont([0, url, [0, title, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_url,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_title,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     cU[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){cU[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_mimeType = "mimeType", letrec_function_context$79 = [];
		               function attachement_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$79[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, t_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$79[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$79[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$79[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  file_id = c[2][1],
		                                  icon_link = c[1],
		                                  mime_type = b[1],
		                                  attachement_title = a[1],
		                                  fileUrl = param[1];
		                                 return cont
		 ([0,
		   fileUrl,
		   attachement_title,
		   mime_type,
		   icon_link,
		   file_id]);
		                                },
		                                function(param, cont){
		                                 var
		                                  file_id = param[5],
		                                  icon_link = param[4],
		                                  mime_type = param[3],
		                                  attachement_title = param[2],
		                                  fileUrl = param[1];
		                                 return cont
		 ([0,
		   fileUrl,
		   [0,
		    attachement_title,
		    [0, mime_type, [0, icon_link, [0, file_id, 0]]]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, "fileUrl", 0, 2, [0, schema$268], 0, 0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_title,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_mimeType,
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_iconLink,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      "fileId",
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$79[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$79[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$93 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cT, [0, schematic_cache$93]);
		               var schematic_cache$94 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cU, [0, schematic_cache$94]);
		               var schematic_cache$95 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$79, [0, schematic_cache$95]);
		               caml_callback
		                (reminders_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (source_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (attachement_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function Moded$0(M, Persona, cont){
		                var letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$1,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, t$, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(b){
		                             letrec_function_context[1][1] = b;
		                             var
		                              a =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_visibility,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0];
		                             return caml_exact_trampoline_cps_call
		                                     (transparency_schema_versioned,
		                                      schematic_version,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        b,
		        function(c){
		         var
		          default$ = M[5].call(null, 0),
		          b =
		            [0,
		             [0, 0, 0, 0, 0, cst_sequence, 0, 3, [0, int_schema], 0, 0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_summary,
		               0,
		               3,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_transparency,
		                0,
		                [0, default$],
		                [0, c],
		                0,
		                0],
		               a]]];
		         return caml_exact_trampoline_cps_call
		                 (status_schema_versioned$0,
		                  schematic_version,
		                  function(c){
		                   var
		                    a = [0, [0, 0, 0, 0, 0, cst_status, 0, 3, [0, c], 0, 0], b];
		                   return caml_exact_trampoline_cps_call
		                           (time_schema_versioned,
		                            schematic_version,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      b,
		                                      function(c){
		                                       var b = M[6].call(null, 0), c = [0, c];
		                                       if(b) var default$ = b[1], b = [0, default$]; else b = 2;
		                                       var d = [0, [0, 0, 0, 0, 0, cst_start, 0, b, c, 0, 0], a];
		                                       return caml_exact_trampoline_cps_call
		       (source_schema_versioned,
		        schematic_version,
		        function(b){
		         var
		          a = [0, [0, 0, 0, 0, 0, cst_source, 0, 3, [0, b], 0, 0], d];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                  function(c){
		                   var
		                    default$ = M[5].call(null, 0),
		                    b =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "guestsCanInviteOthers",
		                        0,
		                        3,
		                        [0, bool_schema],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "guestsCanModify",
		                         0,
		                         3,
		                         [0, bool_schema],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "guestsCanSeeOtherGuests",
		                          0,
		                          3,
		                          [0, bool_schema],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_location,
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_recurrence,
		                            0,
		                            [0, default$],
		                            [0, c],
		                            0,
		                            0],
		                           a]]]]];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$44,
		                            schematic_version,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$43,
		                                      schematic_version,
		                                      function(c){
		                                       c = [0, M[11][1].call(null, schematic_version, c, a)];
		                                       var
		default$ = M[11][5].call(null, ub, ua),
		d =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "extendedProperties",
		    0,
		    [0, default$],
		    c,
		    0,
		    0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (time_schema_versioned,
		        schematic_version,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var a = M[6].call(null, 0), b = [0, b];
		                   if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                   var
		                    c =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_description,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0, [0, 0, 0, 0, 0, cst_end, 0, a, b, 0, 0], d]];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$42,
		                            schematic_version,
		                            function(b){
		                             var
		                              default$ = match$81[1],
		                              a =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "attendeesOmitted",
		                                  0,
		                                  [0, default$],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_colorId,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, 0, 0, 0, 0, "conferenceData", 0, 3, [0, b], 0, 0],
		                                   c]]];
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$40,
		                                      schematic_version,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (Persona[3],
		        schematic_version,
		        function(d){
		         var c = M[11][1].call(null, schematic_version, d, b);
		         return caml_exact_trampoline_cps_call
		                 (attendee_schema_versioned,
		                  schematic_version,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (b,
		                            c,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      [0, 0, 0, [3, b], 0],
		                                      function(b){
		                                       var
		default$ = M[7].call(null, 0),
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     b = a[2],
		     c = b[2],
		     d = c[2],
		     e = d[2],
		     f = e[2],
		     g = f[2],
		     h = g[2],
		     i = h[2],
		     j = i[2],
		     k = j[2],
		     l = k[2],
		     m = l[2],
		     n = m[2],
		     o = n[2],
		     p = o[2],
		     q = p[2],
		     r = q[2],
		     visibility = r[2][1],
		     transparency = r[1],
		     summary = q[1],
		     sequence = p[1],
		     status = o[1],
		     start = n[1],
		     source = m[1],
		     recurrence = l[1],
		     location = k[1],
		     guests_can_see_other_guests = j[1],
		     guests_can_modify = i[1],
		     guests_can_invite_others = h[1],
		     extended_properties = g[1],
		     end = f[1],
		     description = e[1],
		     conference = d[1],
		     color_id = c[1],
		     attendees_omitted = b[1],
		     attendees = a[1],
		     anyone_can_add_self = param[1];
		    return cont
		            ([0,
		              anyone_can_add_self,
		              attendees,
		              attendees_omitted,
		              color_id,
		              conference,
		              description,
		              end,
		              extended_properties,
		              guests_can_invite_others,
		              guests_can_modify,
		              guests_can_see_other_guests,
		              location,
		              recurrence,
		              source,
		              start,
		              status,
		              sequence,
		              summary,
		              transparency,
		              visibility]);
		   },
		   function(param, cont){
		    var
		     visibility = param[20],
		     transparency = param[19],
		     summary = param[18],
		     sequence = param[17],
		     status = param[16],
		     start = param[15],
		     source = param[14],
		     recurrence = param[13],
		     location = param[12],
		     guests_can_see_other_guests = param[11],
		     guests_can_modify = param[10],
		     guests_can_invite_others = param[9],
		     extended_properties = param[8],
		     end = param[7],
		     description = param[6],
		     conference = param[5],
		     color_id = param[4],
		     attendees_omitted = param[3],
		     attendees = param[2],
		     anyone_can_add_self = param[1];
		    return cont
		            ([0,
		              anyone_can_add_self,
		              [0,
		               attendees,
		               [0,
		                attendees_omitted,
		                [0,
		                 color_id,
		                 [0,
		                  conference,
		                  [0,
		                   description,
		                   [0,
		                    end,
		                    [0,
		                     extended_properties,
		                     [0,
		                      guests_can_invite_others,
		                      [0,
		                       guests_can_modify,
		                       [0,
		                        guests_can_see_other_guests,
		                        [0,
		                         location,
		                         [0,
		                          recurrence,
		                          [0,
		                           source,
		                           [0,
		                            start,
		                            [0,
		                             status,
		                             [0,
		                              sequence,
		                              [0, summary, [0, transparency, [0, visibility, 0]]]]]]]]]]]]]]]]]]]]);
		   },
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "anyoneCanAddSelf",
		     0,
		     3,
		     [0, bool_schema],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_attendees,
		      0,
		      [0, default$],
		      [0, b],
		      0,
		      0],
		     a]]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          return caml_exact_trampoline_cps_call$1
		                                  (M[11][4],
		                                   Persona[2],
		                                   pp$25,
		                                   function(pp_attendees_switch){
		                                    return cont([0, , , schema_versioned]);
		                                   });
		                         });
		               }
		               var
		                Read$4 =
		                  caml_callback
		                   (Moded$0, [R$0, [0, equal$39, pp$26, schema_versioned$41]]);
		               caml_callback
		                (Moded$0, [W$0, [0, equal$39, pp$26, schema_versioned$41]]);
		               caml_callback
		                (Moded$0, [R$0, [0, equal$38, pp$25, schema_versioned$40]]);
		               var cV = [];
		               function common_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cV[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, uc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cV[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cV[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            cV[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (time_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "recurringEventId",
		   0,
		   3,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0, 0, 0, 0, 0, "originalStartTime", 0, 3, [0, b], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$17,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              original_start_time = a[2][1],
		              recurring_event_id = a[1],
		              meta = param[1];
		             return cont
		                     ([0, meta, recurring_event_id, original_start_time]);
		            },
		            function(param, cont){
		             var
		              original_start_time = param[3],
		              recurring_event_id = param[2],
		              meta = param[1];
		             return cont
		                     ([0,
		                       meta,
		                       [0, recurring_event_id, [0, original_start_time, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [1, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 cV[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){cV[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_attachments = "attachments",
		                letrec_function_context$80 = [];
		               function schema_versioned$45(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$80[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ud, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$80[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$80[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$80[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (event_type_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$82[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_eventType,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (attachement_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$83[1],
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_attachments,
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (reminders_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   default$ = match$84[1],
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       "endTimeUnspecified",
		                       0,
		                       3,
		                       [0, bool_schema],
		                       0,
		                       0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "iCalUID",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "hangoutLink",
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0, 0, 0, 0, 0, "privateCopy", 0, 3, [0, bool_schema], 0, 0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_locked,
		                           0,
		                           [0, default$],
		                           [0, bool_schema],
		                           0,
		                           0],
		                          [0, [0, 0, 0, 0, 0, cst_reminders, 0, 3, [0, c], 0, 0], b]]]]]];
		                  return caml_exact_trampoline_cps_call
		                          (Read$4[3],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$41,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_organizer, 0, 3, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$41,
		       schematic_version,
		       function(b){
		        b =
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_updated,
		           0,
		           2,
		           [0, datetime_schema_versioned()],
		           0,
		           0],
		          [0, [0, 0, 0, 0, 0, cst_creator, 0, 3, [0, b], 0, 0], a]];
		        var
		         c =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_id,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "htmlLink",
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_created,
		               0,
		               3,
		               [0, datetime_schema_versioned()],
		               0,
		               0],
		              b]]];
		        return caml_exact_trampoline_cps_call
		                (common_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        j = i[2],
		                        k = j[2],
		                        l = k[2],
		                        m = l[2],
		                        n = m[2],
		                        type = n[2][1],
		                        attachments = n[1],
		                        reminders = m[1],
		                        locked = l[1],
		                        private_copy = k[1],
		                        hangout_link = j[1],
		                        ical_uid = i[1],
		                        end_time_unspecified = h[1],
		                        writable = g[1],
		                        organizer = f[1],
		                        creator = e[1],
		                        updated = d[1],
		                        created = c[1],
		                        htmlLink = b[1],
		                        id = a[1],
		                        common = param[1];
		                       return cont
		                               ([0,
		                                 common,
		                                 id,
		                                 htmlLink,
		                                 created,
		                                 updated,
		                                 creator,
		                                 organizer,
		                                 writable,
		                                 end_time_unspecified,
		                                 ical_uid,
		                                 hangout_link,
		                                 private_copy,
		                                 locked,
		                                 reminders,
		                                 attachments,
		                                 type]);
		                      },
		                      function(param, cont){
		                       var
		                        type = param[16],
		                        attachments = param[15],
		                        reminders = param[14],
		                        locked = param[13],
		                        private_copy = param[12],
		                        hangout_link = param[11],
		                        ical_uid = param[10],
		                        end_time_unspecified = param[9],
		                        writable = param[8],
		                        organizer = param[7],
		                        creator = param[6],
		                        updated = param[5],
		                        created = param[4],
		                        htmlLink = param[3],
		                        id = param[2],
		                        common = param[1];
		                       return cont
		                               ([0,
		                                 common,
		                                 [0,
		                                  id,
		                                  [0,
		                                   htmlLink,
		                                   [0,
		                                    created,
		                                    [0,
		                                     updated,
		                                     [0,
		                                      creator,
		                                      [0,
		                                       organizer,
		                                       [0,
		writable,
		[0,
		 end_time_unspecified,
		 [0,
		  ical_uid,
		  [0,
		   hangout_link,
		   [0,
		    private_copy,
		    [0, locked, [0, reminders, [0, attachments, [0, type, 0]]]]]]]]]]]]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, a], 0, 0], c]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$80[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$80[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$96 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cV, [0, schematic_cache$96]);
		               var schematic_cache$97 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$80, [0, schematic_cache$97]);
		               caml_callback
		                (common_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (schema_versioned$45,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$98 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$81 = [];
		               caml_update_dummy
		                (letrec_function_context$81, [0, schematic_cache$98]);
		               function schematic_version$9(param, cont){return cont(0);}
		               var schematic_schema_version$170 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$81[1][1],
		                    schematic_schema_version$170]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$81[1][1],
		                             schematic_schema_version$170,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$81[1][1],
		schematic_schema_version$170,
		schematic_self,
		function(a){
		 letrec_function_context$81[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$45,
		          schematic_version$9,
		          function(c){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([1, f0]);},
		                function(param, cont){
		                 if(1 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                0,
		                0,
		                cst_sync_token,
		                cst_Sync_token,
		                schematic_param_name_schema_ve,
		                0],
		               [0,
		                [0,
		                 function(f0, cont){return cont([2, f0]);},
		                 function(param, cont){
		                  if(2 !== param[0]) return cont(0);
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 0,
		                 0,
		                 cst_updated,
		                 cst_Updated,
		                 c,
		                 0],
		                0]],
		            b =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_id,
		                0,
		                2,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_status,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [9, cst_cancelled], 0]],
		                 0,
		                 0],
		                0]];
		           return caml_exact_trampoline_cps_call
		                   (common_schema_versioned,
		                    schematic_version$9,
		                    function(c){
		                     var
		                      res =
		                        [11,
		                         0,
		                         [0,
		                          [0,
		                           function(param, cont){
		                            var f2 = param[3], f1 = param[2], f0 = param[1];
		                            return cont([0, f0, f1, f2]);
		                           },
		                           function(param, cont){
		                            if(0 !== param[0]) return cont(0);
		                            var f2 = param[3], f1 = param[2], f0 = param[1];
		                            return cont([0, [0, f0, f1, f2]]);
		                           },
		                           1,
		                           0,
		                           cst_deleted,
		                           cst_Deleted,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){
		                              var
		                               a = param[2],
		                               status = a[2][1],
		                               id = a[1],
		                               common = param[1];
		                              return cont([0, common, id, status]);
		                             },
		                             function(param, cont){
		                              var status = param[3], id = param[2], common = param[1];
		                              return cont([0, common, [0, id, [0, status, 0]]]);
		                             },
		                             [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, c], 0, 0], b]],
		                            0],
		                           0],
		                          a],
		                         0];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$81[1][1],
		                              schematic_schema_version$170,
		                              res,
		                              function(a){
		                               letrec_function_context$81[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var cY = [];
		               function content_hints_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   cY[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ue, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                cY[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           cY[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            cY[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "indexableText",
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (thumbnail_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var indexable_text = param[2][1], thumbnail = param[1];
		   return cont([0, thumbnail, indexable_text]);
		  },
		  function(param, cont){
		   var indexable_text = param[2], thumbnail = param[1];
		   return cont([0, thumbnail, [0, indexable_text, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_thumbnail, 0, 3, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       cY[1][1],
		       schematic_schema_version,
		       res,
		       function(a){cY[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var c6 = [];
		               function thumbnail_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   c6[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, uf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                c6[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           c6[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            c6[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var mime_type = param[2][1], image = param[1];
		                                 return cont([0, image, mime_type]);
		                                },
		                                function(param, cont){
		                                 var mime_type = param[2], image = param[1];
		                                 return cont([0, image, [0, mime_type, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "image",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_mimeType,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     c6[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){c6[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var c7 = [];
		               function content_restriction_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   c7[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ug, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                c7[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           c7[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            c7[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "restrictionTime",
		                                 0,
		                                 2,
		                                 [0, schema$269],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (user_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    type = c[2][1],
		    restriction_time = c[1],
		    restricting_user = b[1],
		    reason = a[1],
		    read_only = param[1];
		   return cont
		           ([0,
		             read_only,
		             reason,
		             restricting_user,
		             restriction_time,
		             type]);
		  },
		  function(param, cont){
		   var
		    type = param[5],
		    restriction_time = param[4],
		    restricting_user = param[3],
		    reason = param[2],
		    read_only = param[1];
		   return cont
		           ([0,
		             read_only,
		             [0,
		              reason,
		              [0, restricting_user, [0, restriction_time, [0, type, 0]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_readOnly, 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_reason,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0, 0, 0, 0, 0, "restrictingUser", 0, 2, [0, b], 0, 0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       c7[1][1],
		       schematic_schema_version,
		       res,
		       function(a){c7[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_emailAddress = "emailAddress", c8 = [];
		               function user_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   c8[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, uh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                c8[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           c8[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            c8[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  email_address = c[2][1],
		                                  permission_id = c[1],
		                                  me = b[1],
		                                  photo_link = a[1],
		                                  display_name = param[1];
		                                 return cont
		 ([0,
		   display_name,
		   photo_link,
		   me,
		   permission_id,
		   email_address]);
		                                },
		                                function(param, cont){
		                                 var
		                                  email_address = param[5],
		                                  permission_id = param[4],
		                                  me = param[3],
		                                  photo_link = param[2],
		                                  display_name = param[1];
		                                 return cont
		 ([0,
		   display_name,
		   [0,
		    photo_link,
		    [0, me, [0, permission_id, [0, email_address, 0]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_displayName,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "photoLink",
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_me, 0, 2, [0, bool_schema], 0, 0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "permissionId",
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_emailAddress,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     c8[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){c8[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$82 = [];
		               function shortcut_details_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$82[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ui, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$82[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$82[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$82[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var target_mime_type = param[2][1], target_id = param[1];
		                                 return cont([0, target_id, target_mime_type]);
		                                },
		                                function(param, cont){
		                                 var target_mime_type = param[2], target_id = param[1];
		                                 return cont([0, target_id, [0, target_mime_type, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "targetId",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "targetMimeType",
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$82[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$82[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$99 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(cY, [0, schematic_cache$99]);
		               var schematic_cache$100 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(c6, [0, schematic_cache$100]);
		               var schematic_cache$101 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(c7, [0, schematic_cache$101]);
		               var schematic_cache$102 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(c8, [0, schematic_cache$102]);
		               var schematic_cache$103 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$82, [0, schematic_cache$103]);
		               caml_callback
		                (content_hints_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (thumbnail_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (content_restriction_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (user_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (shortcut_details_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var cst_parents = "parents", cst_trashed = "trashed";
		               function Moded$1(M, cont){
		                var a = [];
		                function common_schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$1,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    a[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function b(descriptor){
		                                      return cont([0, uj, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 a[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            a[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(b){
		                             a[1][1] = b;
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      bool_schema,
		                                      function(c){
		                                       var
		b =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "viewedByMeTime",
		    0,
		    3,
		    [0, schema$269],
		    0,
		    0],
		   [0,
		    [0, 0, 0, 0, 0, "writersCanShare", 0, 2, [0, c], 0, 0],
		    0]];
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        bool_schema,
		        function(d){
		         var
		          c = [0, [0, 0, 0, 0, 0, cst_starred, 0, 2, [0, d], 0, 0], b];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  schematic_param_name_schema_ve,
		                  function(b){
		                   b = [0, 0, 0, mapping_schema(b)[3], 0];
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            b,
		                            function(d){
		                             var
		                              default$ = M[5].call(null, 0),
		                              b =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "originalFilename",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_properties,
		                                   0,
		                                   [0, default$],
		                                   [0, d],
		                                   0,
		                                   0],
		                                  c]];
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      schematic_param_name_schema_ve,
		                                      function(d){
		                                       var
		c = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, d], 0, 0], b];
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        schema$269,
		        function(d){
		         var
		          b =
		            [0, [0, 0, 0, 0, 0, "modifiedTime", 0, 2, [0, d], 0, 0], c];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  schematic_param_name_schema_ve,
		                  function(d){
		                   var
		                    c =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_description,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "folderColorRgb",
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0, [0, 0, 0, 0, 0, cst_mimeType, 0, 2, [0, d], 0, 0], b]]];
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            bool_schema,
		                            function(d){
		                             var
		                              b =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "copyRequiresWriterPermission",
		                                  0,
		                                  2,
		                                  [0, d],
		                                  0,
		                                  0],
		                                 c];
		                             return caml_exact_trampoline_cps_call
		                                     (content_restriction_schema_ver,
		                                      schematic_version,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        [0, 0, 0, [3, c], 0],
		        function(d){
		         var
		          default$ = M[5].call(null, 0),
		          c =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "contentRestrictions",
		              0,
		              [0, default$],
		              [0, d],
		              0,
		              0],
		             b];
		         return caml_exact_trampoline_cps_call
		                 (content_hints_schema_versioned,
		                  schematic_version,
		                  function(d){
		                   var
		                    b =
		                      [0, [0, 0, 0, 0, 0, "contentHints", 0, 3, [0, d], 0, 0], c];
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            schematic_param_name_schema_ve,
		                            function(c){
		                             c = [0, 0, 0, mapping_schema(c)[3], 0];
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      c,
		                                      function(c){
		                                       var
		default$ = M[5].call(null, 0),
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     b = a[2],
		     c = b[2],
		     d = c[2],
		     e = d[2],
		     f = e[2],
		     g = f[2],
		     h = g[2],
		     i = h[2],
		     j = i[2],
		     k = j[2],
		     l = k[2],
		     writers_can_share = l[2][1],
		     viewed_by_me_time = l[1],
		     starred = k[1],
		     properties = j[1],
		     original_filename = i[1],
		     name = h[1],
		     modified_time = g[1],
		     mime_type = f[1],
		     folder_color_rgb = e[1],
		     description = d[1],
		     copy_requires_writer_permissio = c[1],
		     content_restrictions = b[1],
		     content_hints = a[1],
		     app_properties = param[1];
		    return cont
		            ([0,
		              app_properties,
		              content_hints,
		              content_restrictions,
		              copy_requires_writer_permissio,
		              description,
		              folder_color_rgb,
		              mime_type,
		              modified_time,
		              name,
		              original_filename,
		              properties,
		              starred,
		              viewed_by_me_time,
		              writers_can_share]);
		   },
		   function(param, cont){
		    var
		     writers_can_share = param[14],
		     viewed_by_me_time = param[13],
		     starred = param[12],
		     properties = param[11],
		     original_filename = param[10],
		     name = param[9],
		     modified_time = param[8],
		     mime_type = param[7],
		     folder_color_rgb = param[6],
		     description = param[5],
		     copy_requires_writer_permissio = param[4],
		     content_restrictions = param[3],
		     content_hints = param[2],
		     app_properties = param[1];
		    return cont
		            ([0,
		              app_properties,
		              [0,
		               content_hints,
		               [0,
		                content_restrictions,
		                [0,
		                 copy_requires_writer_permissio,
		                 [0,
		                  description,
		                  [0,
		                   folder_color_rgb,
		                   [0,
		                    mime_type,
		                    [0,
		                     modified_time,
		                     [0,
		                      name,
		                      [0,
		                       original_filename,
		                       [0,
		                        properties,
		                        [0,
		                         starred,
		                         [0, viewed_by_me_time, [0, writers_can_share, 0]]]]]]]]]]]]]]);
		   },
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "appProperties",
		     0,
		     [0, default$],
		     [0, c],
		     0,
		     0],
		    b]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        a[1][1],
		        schematic_schema_version,
		        res,
		        function(b){a[1][1] = b; return cont(res);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       b);
		                                     var schema = match[1];
		                                     return b(schema);
		                                    });
		                          });
		                }
		                var b = [];
		                function creation_schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$1,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    b[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 b[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            b[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             b[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (shortcut_details_schema_versio,
		                                      schematic_version,
		                                      function(d){
		                                       var
		c = list_schema(schematic_param_name_schema_ve),
		a =
		  [0,
		   [0, 0, 0, 0, 0, "shortcutDetails", 0, 3, [0, d], 0, 0],
		   0];
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        c,
		        function(d){
		         var
		          default$ = M[5].call(null, 0),
		          c =
		            [0,
		             [0, 0, 0, 0, 0, cst_parents, 0, [0, default$], [0, d], 0, 0],
		             a];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  schematic_param_name_schema_ve,
		                  function(d){
		                   var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, d], 0, 0], c];
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            schema$269,
		                            function(d){
		                             var
		                              c =
		                                [0, [0, 0, 0, 0, 0, "createdTime", 0, 2, [0, d], 0, 0], a];
		                             return caml_exact_trampoline_cps_call
		                                     (common_schema_versioned,
		                                      schematic_version,
		                                      function(a){
		                                       var
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     b = a[2],
		     c = b[2],
		     shortcut_details = c[2][1],
		     parents = c[1],
		     id = b[1],
		     created_time = a[1],
		     common = param[1];
		    return cont
		            ([0, common, created_time, id, parents, shortcut_details]);
		   },
		   function(param, cont){
		    var
		     shortcut_details = param[5],
		     parents = param[4],
		     id = param[3],
		     created_time = param[2],
		     common = param[1];
		    return cont
		            ([0,
		              common,
		              [0,
		               created_time,
		               [0, id, [0, parents, [0, shortcut_details, 0]]]]]);
		   },
		   [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, a], 0, 0], c]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        b[1][1],
		        schematic_schema_version,
		        res,
		        function(a){b[1][1] = a; return cont(res);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var letrec_function_context = [];
		                function update_schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$1,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(a){return cont();}
		                                     return match
		     ? a()
		     : caml_exact_trampoline_cps_call
		       (fixpoint,
		        function(schematic_self, cont){
		         return caml_exact_trampoline_cps_call$1
		                 (find_packed_by_id,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  function(match){
		                   if(! match)
		                    return caml_exact_trampoline_cps_call$0
		                            (set$3,
		                             letrec_function_context[1][1],
		                             schematic_schema_version,
		                             schematic_self,
		                             function(a){
		                              letrec_function_context[1][1] = a;
		                              return caml_trampoline_cps_call3
		                                      (M[1],
		                                       schematic_version,
		                                       bool_schema,
		                                       function(b){
		var
		 a = [0, [0, 0, 0, 0, 0, cst_trashed, 0, 2, [0, b], 0, 0], 0];
		return caml_exact_trampoline_cps_call
		        (common_schema_versioned,
		         schematic_version,
		         function(b){
		          var
		           res =
		             [7,
		              function(param, cont){
		               var trashed = param[2][1], update_common = param[1];
		               return cont([0, update_common, trashed]);
		              },
		              function(param, cont){
		               var trashed = param[2], update_common = param[1];
		               return cont([0, update_common, [0, trashed, 0]]);
		              },
		              [0, [0, 0, 0, 0, 0, "update_common", 0, 2, [1, b], 0, 0], a]];
		          return caml_exact_trampoline_cps_call$0
		                  (set$3,
		                   letrec_function_context[1][1],
		                   schematic_schema_version,
		                   res,
		                   function(a){
		                    letrec_function_context[1][1] = a;
		                    return cont(res);
		                   });
		         });
		                                       });
		                             });
		                   var schema = match[1];
		                   return cont(schema);
		                  });
		        },
		        a);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy(a, [0, schematic_cache]);
		                var schematic_cache$0 = [0, empty$11([0, comparator$9])];
		                caml_update_dummy(b, [0, schematic_cache$0]);
		                var schematic_cache$1 = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache$1]);
		                return caml_exact_trampoline_cps_call
		                        (common_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(common_schema){
		                          return caml_exact_trampoline_cps_call
		                                  (creation_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(creation_schema){
		                                    return caml_exact_trampoline_cps_call
		    (update_schema_versioned,
		     function(param, cont){return cont(0);},
		     function(update_schema){
		      return cont([0, , creation_schema_versioned]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$42 = caml_callback(Moded$1, [R$0]),
		                creation_schema_versioned = include$42[2];
		               function schema_versioned$46(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (creation_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, uk, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$46,
		                 [function(param, cont){return cont(0);}]);
		               var cst_canDelete = "canDelete", c_ = [];
		               function capabilities_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   c_[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ul, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                c_[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           c_[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            c_[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  i = h[2],
		                                  j = i[2],
		                                  k = j[2],
		                                  l = k[2],
		                                  m = l[2],
		                                  n = m[2],
		                                  o = n[2],
		                                  p = o[2],
		                                  q = p[2],
		                                  r = q[2],
		                                  s = r[2],
		                                  t = s[2],
		                                  u = t[2],
		                                  v = u[2],
		                                  w = v[2],
		                                  x = w[2],
		                                  can_untrash = x[2][1],
		                                  can_trash_children = x[1],
		                                  can_trash = w[1],
		                                  can_share = v[1],
		                                  can_rename = u[1],
		                                  can_remove_my_drive_parent = t[1],
		                                  can_remove_children = s[1],
		                                  can_read_drive = r[1],
		                                  can_read_revisions = q[1],
		                                  can_move_item_within_drive = p[1],
		                                  can_move_item_out_of_drive = o[1],
		                                  can_move_children_within_drive = n[1],
		                                  can_move_children_out_of_drive = m[1],
		                                  can_modify_content_restriction = l[1],
		                                  can_modify_content = k[1],
		                                  can_list_children = j[1],
		                                  can_edit = i[1],
		                                  can_download = h[1],
		                                  can_delete_children = g[1],
		                                  can_delete = f[1],
		                                  can_copy = e[1],
		                                  can_comment = d[1],
		                                  can_change_copy_requires_write = c[1],
		                                  can_add_my_drive_parent = b[1],
		                                  can_add_folder_from_another_dr = a[1],
		                                  can_add_children = param[1];
		                                 return cont
		 ([0,
		   can_add_children,
		   can_add_folder_from_another_dr,
		   can_add_my_drive_parent,
		   can_change_copy_requires_write,
		   can_comment,
		   can_copy,
		   can_delete,
		   can_delete_children,
		   can_download,
		   can_edit,
		   can_list_children,
		   can_modify_content,
		   can_modify_content_restriction,
		   can_move_children_out_of_drive,
		   can_move_children_within_drive,
		   can_move_item_out_of_drive,
		   can_move_item_within_drive,
		   can_read_revisions,
		   can_read_drive,
		   can_remove_children,
		   can_remove_my_drive_parent,
		   can_rename,
		   can_share,
		   can_trash,
		   can_trash_children,
		   can_untrash]);
		                                },
		                                function(param, cont){
		                                 var
		                                  can_untrash = param[26],
		                                  can_trash_children = param[25],
		                                  can_trash = param[24],
		                                  can_share = param[23],
		                                  can_rename = param[22],
		                                  can_remove_my_drive_parent = param[21],
		                                  can_remove_children = param[20],
		                                  can_read_drive = param[19],
		                                  can_read_revisions = param[18],
		                                  can_move_item_within_drive = param[17],
		                                  can_move_item_out_of_drive = param[16],
		                                  can_move_children_within_drive = param[15],
		                                  can_move_children_out_of_drive = param[14],
		                                  can_modify_content_restriction = param[13],
		                                  can_modify_content = param[12],
		                                  can_list_children = param[11],
		                                  can_edit = param[10],
		                                  can_download = param[9],
		                                  can_delete_children = param[8],
		                                  can_delete = param[7],
		                                  can_copy = param[6],
		                                  can_comment = param[5],
		                                  can_change_copy_requires_write = param[4],
		                                  can_add_my_drive_parent = param[3],
		                                  can_add_folder_from_another_dr = param[2],
		                                  can_add_children = param[1];
		                                 return cont
		 ([0,
		   can_add_children,
		   [0,
		    can_add_folder_from_another_dr,
		    [0,
		     can_add_my_drive_parent,
		     [0,
		      can_change_copy_requires_write,
		      [0,
		       can_comment,
		       [0,
		        can_copy,
		        [0,
		         can_delete,
		         [0,
		          can_delete_children,
		          [0,
		           can_download,
		           [0,
		            can_edit,
		            [0,
		             can_list_children,
		             [0,
		              can_modify_content,
		              [0,
		               can_modify_content_restriction,
		               [0,
		                can_move_children_out_of_drive,
		                [0,
		                 can_move_children_within_drive,
		                 [0,
		                  can_move_item_out_of_drive,
		                  [0,
		                   can_move_item_within_drive,
		                   [0,
		                    can_read_revisions,
		                    [0,
		                     can_read_drive,
		                     [0,
		                      can_remove_children,
		                      [0,
		                       can_remove_my_drive_parent,
		                       [0,
		                        can_rename,
		                        [0,
		                         can_share,
		                         [0, can_trash, [0, can_trash_children, [0, can_untrash, 0]]]]]]]]]]]]]]]]]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "canAddChildren",
		                                  0,
		                                  2,
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "canAddFolderFromAnotherDrive",
		                                   0,
		                                   3,
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "canAddMyDriveParent",
		                                    0,
		                                    2,
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "canChangeCopyRequiresWriterPermission",
		                                     0,
		                                     2,
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0, 0, 0, 0, 0, "canComment", 0, 2, [0, bool_schema], 0, 0],
		                                     [0,
		                                      [0, 0, 0, 0, 0, "canCopy", 0, 2, [0, bool_schema], 0, 0],
		                                      [0,
		                                       [0, 0, 0, 0, 0, cst_canDelete, 0, 2, [0, bool_schema], 0, 0],
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 "canDeleteChildren",
		 0,
		 3,
		 [0, bool_schema],
		 0,
		 0],
		[0,
		 [0, 0, 0, 0, 0, "canDownload", 0, 2, [0, bool_schema], 0, 0],
		 [0,
		  [0, 0, 0, 0, 0, "canEdit", 0, 2, [0, bool_schema], 0, 0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "canListChildren",
		    0,
		    2,
		    [0, bool_schema],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "canModifyContent",
		     0,
		     2,
		     [0, bool_schema],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      "canModifyContentRestriction",
		      0,
		      3,
		      [0, bool_schema],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "canMoveChildrenOutOfDrive",
		       0,
		       3,
		       [0, bool_schema],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "canMoveChildrenWithinDrive",
		        0,
		        3,
		        [0, bool_schema],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         "canMoveItemOutOfDrive",
		         0,
		         2,
		         [0, bool_schema],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          "canMoveItemWithinDrive",
		          0,
		          2,
		          [0, bool_schema],
		          0,
		          0],
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           "canReadRevisions",
		           0,
		           2,
		           [0, bool_schema],
		           0,
		           0],
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            "canReadDrive",
		            0,
		            3,
		            [0, bool_schema],
		            0,
		            0],
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             "canRemoveChildren",
		             0,
		             2,
		             [0, bool_schema],
		             0,
		             0],
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "canRemoveMyDriveParent",
		              0,
		              2,
		              [0, bool_schema],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, "canRename", 0, 2, [0, bool_schema], 0, 0],
		              [0,
		               [0, 0, 0, 0, 0, "canShare", 0, 2, [0, bool_schema], 0, 0],
		               [0,
		                [0, 0, 0, 0, 0, "canTrash", 0, 2, [0, bool_schema], 0, 0],
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  "canTrashChildren",
		                  0,
		                  3,
		                  [0, bool_schema],
		                  0,
		                  0],
		                 [0,
		                  [0, 0, 0, 0, 0, "canUntrash", 0, 2, [0, bool_schema], 0, 0],
		                  0]]]]]]]]]]]]]]]]]]]]]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     c_[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){c_[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var float_schema = [0, 0, 0, 2, 0], c$ = [];
		               function image_media_metadata_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   c$[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, um, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                c$[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           c$[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            c$[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_time,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "cameraMake",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "cameraModel",
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "exposureTime",
		                                    0,
		                                    2,
		                                    [0, float_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0, 0, 0, 0, 0, "aperture", 0, 2, [0, float_schema], 0, 0],
		                                    [0,
		                                     [0, 0, 0, 0, 0, "flashUsed", 0, 2, [0, bool_schema], 0, 0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       "focalLength",
		                                       0,
		                                       2,
		                                       [0, float_schema],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0, 0, 0, 0, 0, "isoSpeed", 0, 2, [0, int_schema], 0, 0],
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 "meteringMode",
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  "sensor",
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "exposureMode",
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "colorSpace",
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "whiteBalance",
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      "exposureBias",
		      0,
		      2,
		      [0, float_schema],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "maxApertureValue",
		       0,
		       2,
		       [0, float_schema],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "subjectDistance",
		        0,
		        2,
		        [0, int_schema],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         "lens",
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]]]]]]]]]]]]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (location_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    j = i[2],
		    k = j[2],
		    l = k[2],
		    m = l[2],
		    n = m[2],
		    o = n[2],
		    p = o[2],
		    q = p[2],
		    r = q[2],
		    s = r[2],
		    lens = s[2][1],
		    subject_distance = s[1],
		    max_aperture_value = r[1],
		    exposure_bias = q[1],
		    white_balance = p[1],
		    color_space = o[1],
		    exposure_mode = n[1],
		    sensor = m[1],
		    metering_mode = l[1],
		    iso_speed = k[1],
		    focal_length = j[1],
		    flash_used = i[1],
		    aperture = h[1],
		    exposure_time = g[1],
		    camera_model = f[1],
		    camera_make = e[1],
		    time = d[1],
		    location = c[1],
		    rotation = b[1],
		    image_height = a[1],
		    image_width = param[1];
		   return cont
		           ([0,
		             image_width,
		             image_height,
		             rotation,
		             location,
		             time,
		             camera_make,
		             camera_model,
		             exposure_time,
		             aperture,
		             flash_used,
		             focal_length,
		             iso_speed,
		             metering_mode,
		             sensor,
		             exposure_mode,
		             color_space,
		             white_balance,
		             exposure_bias,
		             max_aperture_value,
		             subject_distance,
		             lens]);
		  },
		  function(param, cont){
		   var
		    lens = param[21],
		    subject_distance = param[20],
		    max_aperture_value = param[19],
		    exposure_bias = param[18],
		    white_balance = param[17],
		    color_space = param[16],
		    exposure_mode = param[15],
		    sensor = param[14],
		    metering_mode = param[13],
		    iso_speed = param[12],
		    focal_length = param[11],
		    flash_used = param[10],
		    aperture = param[9],
		    exposure_time = param[8],
		    camera_model = param[7],
		    camera_make = param[6],
		    time = param[5],
		    location = param[4],
		    rotation = param[3],
		    image_height = param[2],
		    image_width = param[1];
		   return cont
		           ([0,
		             image_width,
		             [0,
		              image_height,
		              [0,
		               rotation,
		               [0,
		                location,
		                [0,
		                 time,
		                 [0,
		                  camera_make,
		                  [0,
		                   camera_model,
		                   [0,
		                    exposure_time,
		                    [0,
		                     aperture,
		                     [0,
		                      flash_used,
		                      [0,
		                       focal_length,
		                       [0,
		                        iso_speed,
		                        [0,
		                         metering_mode,
		                         [0,
		                          sensor,
		                          [0,
		                           exposure_mode,
		                           [0,
		                            color_space,
		                            [0,
		                             white_balance,
		                             [0,
		                              exposure_bias,
		                              [0, max_aperture_value, [0, subject_distance, [0, lens, 0]]]]]]]]]]]]]]]]]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_width, 0, 2, [0, int_schema], 0, 0],
		   [0,
		    [0, 0, 0, 0, 0, cst_height, 0, 2, [0, int_schema], 0, 0],
		    [0,
		     [0, 0, 0, 0, 0, "rotation", 0, 2, [0, int_schema], 0, 0],
		     [0, [0, 0, 0, 0, 0, cst_location, 0, 2, [0, b], 0, 0], a]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       c$[1][1],
		       schematic_schema_version,
		       res,
		       function(a){c$[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_latitude = "latitude",
		                cst_longitude = "longitude",
		                da = [];
		               function location_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   da[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, un, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                da[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           da[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            da[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  altitude = a[2][1],
		                                  longitude = a[1],
		                                  latitude = param[1];
		                                 return cont([254, latitude, longitude, altitude]);
		                                },
		                                function(param, cont){
		                                 var
		                                  altitude = param[3],
		                                  longitude = param[2],
		                                  latitude = param[1];
		                                 return cont([0, latitude, [0, longitude, [0, altitude, 0]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_latitude, 0, 2, [0, float_schema], 0, 0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_longitude,
		                                   0,
		                                   2,
		                                   [0, float_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, 0, 0, 0, 0, "altitude", 0, 2, [0, float_schema], 0, 0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     da[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){da[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$83 = [];
		               function video_media_metadata_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$83[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, uo, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$83[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$83[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$83[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  duration_millis = a[2][1],
		                                  vido_height = a[1],
		                                  video_width = param[1];
		                                 return cont([0, video_width, vido_height, duration_millis]);
		                                },
		                                function(param, cont){
		                                 var
		                                  duration_millis = param[3],
		                                  vido_height = param[2],
		                                  video_width = param[1];
		                                 return cont
		 ([0, video_width, [0, vido_height, [0, duration_millis, 0]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_width, 0, 2, [0, int_schema], 0, 0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_height, 0, 2, [0, int_schema], 0, 0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "durationMillis",
		                                    0,
		                                    2,
		                                    [0, int_schema],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$83[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$83[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$104 = [0, empty$11([0, comparator$9])],
		                c9 = [];
		               caml_update_dummy(c9, [0, schematic_cache$104]);
		               var schematic_cache$105 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(c_, [0, schematic_cache$105]);
		               var schematic_cache$106 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(c$, [0, schematic_cache$106]);
		               var schematic_cache$107 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(da, [0, schematic_cache$107]);
		               var schematic_cache$108 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$83, [0, schematic_cache$108]);
		               function schematic_version$10(param, cont){return cont(0);}
		               var schematic_schema_version$169 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [c9[1][1], schematic_schema_version$169]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             c9[1][1],
		                             schematic_schema_version$169,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		c9[1][1],
		schematic_schema_version$169,
		schematic_self,
		function(a){
		 c9[1][1] = a;
		 a =
		  [0,
		   [0,
		    0,
		    0,
		    mapping_schema(schematic_param_name_schema_ve)[3],
		    0]];
		 var
		  default$ = match$85[1],
		  b =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      "isAppAuthorized",
		      0,
		      2,
		      [0, bool_schema],
		      0,
		      0],
		     [0,
		      [0, 0, 0, 0, 0, "exportLinks", 0, [0, default$], a, 0, 0],
		      0]];
		 return caml_exact_trampoline_cps_call
		         (video_media_metadata_schema_ve,
		          schematic_version$10,
		          function(c){
		           var
		            cst_imageMediaMetadata = "imageMediaMetadata",
		            a =
		              [0,
		               [0, 0, 0, 0, 0, cst_imageMediaMetadata, 0, 3, [0, c], 0, 0],
		               b];
		           return caml_exact_trampoline_cps_call
		                   (image_media_metadata_schema_ve,
		                    schematic_version$10,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "hasAugmentedPermissions",
		                          0,
		                          3,
		                          [0, bool_schema],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "fullFileExtension",
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            "fileExtension",
		                            0,
		                            3,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             "md5Checksum",
		                             0,
		                             3,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              cst_size,
		                              0,
		                              3,
		                              [0, schematic_param_name_schema_ve],
		                              0,
		                              0],
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "quotaBytesUsed",
		                               0,
		                               3,
		                               [0, schematic_param_name_schema_ve],
		                               0,
		                               0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                "headRevisionId",
		                                0,
		                                3,
		                                [0, schematic_param_name_schema_ve],
		                                0,
		                                0],
		                               [0,
		                                [0, 0, 0, 0, 0, cst_imageMediaMetadata, 0, 3, [0, c], 0, 0],
		                                a]]]]]]]];
		                     return caml_exact_trampoline_cps_call
		                             (capabilities_schema_versioned,
		                              schematic_version$10,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_shared, 0, 2, [0, bool_schema], 0, 0],
		                                   [0,
		                                    [0, 0, 0, 0, 0, "ownedByMe", 0, 3, [0, bool_schema], 0, 0],
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_capabilities, 0, 2, [0, c], 0, 0],
		                                     b]]];
		                               return caml_exact_trampoline_cps_call
		                                       (user_schema_versioned,
		schematic_version$10,
		function(c){
		 var
		  b =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      "driveId",
		      0,
		      3,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0, 0, 0, 0, 0, "lastModifyingUser", 0, 2, [0, c], 0, 0],
		      a]];
		 return caml_exact_trampoline_cps_call
		         (user_schema_versioned,
		          schematic_version$10,
		          function(c){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                "owners",
		                0,
		                2,
		                [0, [0, 0, 0, [3, c], 0]],
		                0,
		                0],
		               b];
		           return caml_exact_trampoline_cps_call
		                   (user_schema_versioned,
		                    schematic_version$10,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0, 0, 0, 0, 0, "trashedTime", 0, 3, [0, schema$269], 0, 0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "spaces",
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_version,
		                            0,
		                            2,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             "webContentLink",
		                             0,
		                             3,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              "webViewLink",
		                              0,
		                              2,
		                              [0, schematic_param_name_schema_ve],
		                              0,
		                              0],
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_iconLink,
		                               0,
		                               2,
		                               [0, schematic_param_name_schema_ve],
		                               0,
		                               0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                "hasThumbnail",
		                                0,
		                                2,
		                                [0, bool_schema],
		                                0,
		                                0],
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "thumbnailLink",
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "thumbnailVersion",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, "viewedByMe", 0, 2, [0, bool_schema], 0, 0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "modifiedByMeTime",
		                                    0,
		                                    3,
		                                    [0, schema$269],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "modifiedByMe",
		                                     0,
		                                     2,
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      "sharedWithMeTime",
		                                      0,
		                                      3,
		                                      [0, schema$269],
		                                      0,
		                                      0],
		                                     [0, [0, 0, 0, 0, 0, "sharingUser", 0, 3, [0, c], 0, 0], a]]]]]]]]]]]]]];
		                     return caml_exact_trampoline_cps_call
		                             (user_schema_versioned,
		                              schematic_version$10,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_trashed, 0, 2, [0, bool_schema], 0, 0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "explicitlyTrashed",
		                                     0,
		                                     2,
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    [0, [0, 0, 0, 0, 0, "trashingUser", 0, 3, [0, c], 0, 0], b]]];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$46,
		schematic_version$10,
		function(b){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       d = c[2],
		       e = d[2],
		       f = e[2],
		       g = f[2],
		       h = g[2],
		       i = h[2],
		       j = i[2],
		       k = j[2],
		       l = k[2],
		       m = l[2],
		       n = m[2],
		       o = n[2],
		       p = o[2],
		       q = p[2],
		       r = q[2],
		       s = r[2],
		       t = s[2],
		       u = t[2],
		       v = u[2],
		       w = v[2],
		       x = w[2],
		       y = x[2],
		       z = y[2],
		       A = z[2],
		       B = A[2],
		       C = B[2],
		       D = C[2],
		       E = D[2],
		       F = E[2],
		       G = F[2],
		       export_links = G[2][1],
		       is_app_authorized = G[1],
		       video_media_metadata = F[1],
		       image_media_metadata = E[1],
		       head_revision_id = D[1],
		       quota_bytes_used = C[1],
		       size = B[1],
		       md5_checksum = A[1],
		       file_extension = z[1],
		       full_file_extension = y[1],
		       has_augmented_permissions = x[1],
		       capabilities = w[1],
		       owned_by_me = v[1],
		       shared = u[1],
		       last_modifying_user = t[1],
		       drive_id = s[1],
		       owners = r[1],
		       sharing_user = q[1],
		       shared_with_me_time = p[1],
		       modified_by_me = o[1],
		       modified_by_me_time = n[1],
		       viewed_by_me = m[1],
		       thumbnail_version = l[1],
		       thumbnail_link = k[1],
		       has_thumbnail = j[1],
		       icon_link = i[1],
		       web_view_link = h[1],
		       web_content_link = g[1],
		       version = f[1],
		       spaces = e[1],
		       trashed_time = d[1],
		       trashing_user = c[1],
		       explicitly_trashed = b[1],
		       trashed = a[1],
		       writable = param[1];
		      return cont
		              ([0,
		                writable,
		                trashed,
		                explicitly_trashed,
		                trashing_user,
		                trashed_time,
		                spaces,
		                version,
		                web_content_link,
		                web_view_link,
		                icon_link,
		                has_thumbnail,
		                thumbnail_link,
		                thumbnail_version,
		                viewed_by_me,
		                modified_by_me_time,
		                modified_by_me,
		                shared_with_me_time,
		                sharing_user,
		                owners,
		                drive_id,
		                last_modifying_user,
		                shared,
		                owned_by_me,
		                capabilities,
		                has_augmented_permissions,
		                full_file_extension,
		                file_extension,
		                md5_checksum,
		                size,
		                quota_bytes_used,
		                head_revision_id,
		                image_media_metadata,
		                video_media_metadata,
		                is_app_authorized,
		                export_links]);
		     },
		     function(param, cont){
		      var
		       export_links = param[35],
		       is_app_authorized = param[34],
		       video_media_metadata = param[33],
		       image_media_metadata = param[32],
		       head_revision_id = param[31],
		       quota_bytes_used = param[30],
		       size = param[29],
		       md5_checksum = param[28],
		       file_extension = param[27],
		       full_file_extension = param[26],
		       has_augmented_permissions = param[25],
		       capabilities = param[24],
		       owned_by_me = param[23],
		       shared = param[22],
		       last_modifying_user = param[21],
		       drive_id = param[20],
		       owners = param[19],
		       sharing_user = param[18],
		       shared_with_me_time = param[17],
		       modified_by_me = param[16],
		       modified_by_me_time = param[15],
		       viewed_by_me = param[14],
		       thumbnail_version = param[13],
		       thumbnail_link = param[12],
		       has_thumbnail = param[11],
		       icon_link = param[10],
		       web_view_link = param[9],
		       web_content_link = param[8],
		       version = param[7],
		       spaces = param[6],
		       trashed_time = param[5],
		       trashing_user = param[4],
		       explicitly_trashed = param[3],
		       trashed = param[2],
		       writable = param[1];
		      return cont
		              ([0,
		                writable,
		                [0,
		                 trashed,
		                 [0,
		                  explicitly_trashed,
		                  [0,
		                   trashing_user,
		                   [0,
		                    trashed_time,
		                    [0,
		                     spaces,
		                     [0,
		                      version,
		                      [0,
		                       web_content_link,
		                       [0,
		                        web_view_link,
		                        [0,
		                         icon_link,
		                         [0,
		                          has_thumbnail,
		                          [0,
		                           thumbnail_link,
		                           [0,
		                            thumbnail_version,
		                            [0,
		                             viewed_by_me,
		                             [0,
		                              modified_by_me_time,
		                              [0,
		                               modified_by_me,
		                               [0,
		                                shared_with_me_time,
		                                [0,
		                                 sharing_user,
		                                 [0,
		                                  owners,
		                                  [0,
		                                   drive_id,
		                                   [0,
		                                    last_modifying_user,
		                                    [0,
		                                     shared,
		                                     [0,
		                                      owned_by_me,
		                                      [0,
		                                       capabilities,
		                                       [0,
		has_augmented_permissions,
		[0,
		 full_file_extension,
		 [0,
		  file_extension,
		  [0,
		   md5_checksum,
		   [0,
		    size,
		    [0,
		     quota_bytes_used,
		     [0,
		      head_revision_id,
		      [0,
		       image_media_metadata,
		       [0,
		        video_media_metadata,
		        [0, is_app_authorized, [0, export_links, 0]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);
		     },
		     [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], a]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          c9[1][1],
		          schematic_schema_version$169,
		          res,
		          function(a){c9[1][1] = a; return cont(res);});
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (capabilities_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (image_media_metadata_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (location_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (video_media_metadata_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback(Moded$1, [W$0]);
		               var dc = [];
		               function label_type_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dc[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, up, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dc[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dc[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dc[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(ut);},
		                        0,
		                        0,
		                        cst_system,
		                        cst_System,
		                        us,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(ur) : cont(0);},
		                         0,
		                         0,
		                         cst_user,
		                         cst_User,
		                         uq,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dc[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dc[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var dd = [];
		               function message_list_visibility_schema
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dd[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uu, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dd[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dd[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dd[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(uy);},
		                        0,
		                        0,
		                        cst_show,
		                        "Show",
		                        ux,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(uw) : cont(0);},
		                         0,
		                         0,
		                         cst_hide,
		                         "Hide",
		                         uv,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dd[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dd[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var de = [];
		               function label_list_visibility_schema_v
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         de[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uz, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      de[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 de[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  de[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(uF);},
		                        0,
		                        0,
		                        cst_label_show,
		                        "Label_show",
		                        uE,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(uD) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_label_hide,
		                         "Label_hide",
		                         uC,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(uB) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_label_show_if_unread,
		                          "Label_show_if_unread",
		                          uA,
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           de[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){de[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var df = [];
		               function label_color_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         df[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uG, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      df[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 df[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  df[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var background_color = param[2][1], text_color = param[1];
		                       return cont([0, text_color, background_color]);
		                      },
		                      function(param, cont){
		                       var background_color = param[2], text_color = param[1];
		                       return cont([0, text_color, [0, background_color, 0]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "textColor",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_backgroundColor,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           df[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){df[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var letrec_function_context$84 = [];
		               function insert_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$84[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uH, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$84[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$84[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$84[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (label_color_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, cst_color, 0, 3, [0, b], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (label_list_visibility_schema_v,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, "labelListVisibility", 0, 2, [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (message_list_visibility_schema,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              color = b[2][1],
		              label_list_visibility = b[1],
		              message_list_visibility = a[1],
		              name = param[1];
		             return cont
		                     ([0,
		                       name,
		                       message_list_visibility,
		                       label_list_visibility,
		                       color]);
		            },
		            function(param, cont){
		             var
		              color = param[4],
		              label_list_visibility = param[3],
		              message_list_visibility = param[2],
		              name = param[1];
		             return cont
		                     ([0,
		                       name,
		                       [0,
		                        message_list_visibility,
		                        [0, label_list_visibility, [0, color, 0]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_name,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, "messageListVisibility", 0, 2, [0, a], 0, 0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$84[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$84[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$109 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dc, [0, schematic_cache$109]);
		               var schematic_cache$110 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dd, [0, schematic_cache$110]);
		               var schematic_cache$111 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(de, [0, schematic_cache$111]);
		               var schematic_cache$112 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(df, [0, schematic_cache$112]);
		               var schematic_cache$113 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$84, [0, schematic_cache$113]);
		               caml_callback
		                (label_type_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (message_list_visibility_schema, [function(param){return 0;}]);
		               caml_callback
		                (label_list_visibility_schema_v, [function(param){return 0;}]);
		               caml_callback
		                (label_color_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (insert_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$85 = [];
		               function schema_versioned$47(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$85[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uI, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$85[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$85[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$85[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (insert_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "messagesTotal",
		                                 0,
		                                 3,
		                                 [0, int_schema],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "messagesUnread",
		                                  0,
		                                  3,
		                                  [0, int_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, "threadsTotal", 0, 3, [0, int_schema], 0, 0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "threadsUnread",
		                                    0,
		                                    3,
		                                    [0, int_schema],
		                                    0,
		                                    0],
		                                   [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (label_type_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    writable = e[2][1],
		    threads_unread = e[1],
		    threads_total = d[1],
		    messages_unread = c[1],
		    messages_total = b[1],
		    type = a[1],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             type,
		             messages_total,
		             messages_unread,
		             threads_total,
		             threads_unread,
		             writable]);
		  },
		  function(param, cont){
		   var
		    writable = param[7],
		    threads_unread = param[6],
		    threads_total = param[5],
		    messages_unread = param[4],
		    messages_total = param[3],
		    type = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0,
		              type,
		              [0,
		               messages_total,
		               [0,
		                messages_unread,
		                [0, threads_total, [0, threads_unread, [0, writable, 0]]]]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, b], 0, 0], a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$85[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$85[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$114 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$85, [0, schematic_cache$114]);
		               caml_callback
		                (schema_versioned$47, [function(param){return 0;}]);
		               var
		                schematic_cache$115 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$86 = [];
		               caml_update_dummy
		                (letrec_function_context$86, [0, schematic_cache$115]);
		               function schematic_version$11(param){return 0;}
		               var schematic_schema_version$168 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$86[1][1],
		                    schematic_schema_version$168]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$86[1][1],
		                             schematic_schema_version$168,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$86[1][1],
		schematic_schema_version$168,
		schematic_self,
		function(a){
		 letrec_function_context$86[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$47,
		          schematic_version$11,
		          function(a){
		           var
		            default$ = match$86[1],
		            res =
		              [7,
		               function(param, cont){
		                var labels = param[1];
		                return cont([0, labels]);
		               },
		               function(param, cont){
		                var labels = param[1];
		                return cont([0, labels, 0]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_labels,
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, a], 0]],
		                 0,
		                 0],
		                0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$86[1][1],
		                    schematic_schema_version$168,
		                    res,
		                    function(a){
		                     letrec_function_context$86[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function bytes_str_schema_versioned(param){
		                function decode_base64_string(str, cont){
		                 return 0 === caml_ml_string_length(str)
		                         ? cont(uJ)
		                         : caml_exact_trampoline_cps_call$3
		                           (decode,
		                            uK,
		                            [0, uri_safe_alphabet],
		                            0,
		                            0,
		                            str,
		                            function(v){
		                             if(0 === v[0]) return cont(v);
		                             var e = v[1], x = e[2];
		                             return caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$52,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (a, str, x, function(a){return cont([1, a]);});
		                                      });
		                            });
		                }
		                function encode_base64_string(str_bytes, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (encode$0,
		                          uL,
		                          [0, uri_safe_alphabet],
		                          0,
		                          0,
		                          str_bytes,
		                          function(a){
		                           if(0 === a[0]){var v = a[1]; return cont(v);}
		                           a = caml_pop_trap();
		                           return a
		                                   (caml_maybe_attach_backtrace
		                                     ([0, Failure, "impossible base64 encode error"], 1));
		                          });
		                }
		                return [0,
		                        0,
		                        0,
		                        [4,
		                         decode_base64_string,
		                         encode_base64_string,
		                         descriptor$1],
		                        0];
		               }
		               var
		                cst_filename = "filename",
		                cst_headers = "headers",
		                dg = [];
		               function schema_versioned$48(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dg[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uM, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dg[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dg[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dg[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$48,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$87[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_parts,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (message_part_body_schema_versi,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_body, 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (header_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         default$ = match$88[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              parts = d[2][1],
		              body = d[1],
		              headers = c[1],
		              filename = b[1],
		              mime_type = a[1],
		              part_id = param[1];
		             return cont
		                     ([0, part_id, mime_type, filename, headers, body, parts]);
		            },
		            function(param, cont){
		             var
		              parts = param[6],
		              body = param[5],
		              headers = param[4],
		              filename = param[3],
		              mime_type = param[2],
		              part_id = param[1];
		             return cont
		                     ([0,
		                       part_id,
		                       [0,
		                        mime_type,
		                        [0, filename, [0, headers, [0, body, [0, parts, 0]]]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "partId",
		              0,
		              3,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_mimeType,
		               0,
		               3,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_filename,
		                0,
		                3,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_headers,
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, a], 0]],
		                 0,
		                 0],
		                b]]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dg[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){dg[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var dh = [];
		               function header_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dh[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uN, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dh[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dh[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dh[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var value = param[2][1], name = param[1];
		                       return cont([0, name, value]);
		                      },
		                      function(param, cont){
		                       var value = param[2], name = param[1];
		                       return cont([0, name, [0, value, 0]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_name,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_value,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dh[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dh[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var letrec_function_context$87 = [];
		               function message_part_body_schema_versi
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$87[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, uO, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$87[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$87[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$87[1][1] = a;
		                  a = [0, bytes_str_schema_versioned()];
		                  var
		                   default$ = match$89[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        data = a[2][1],
		                        size = a[1],
		                        attachement_id = param[1];
		                       return cont([0, attachement_id, size, data]);
		                      },
		                      function(param, cont){
		                       var
		                        data = param[3],
		                        size = param[2],
		                        attachement_id = param[1];
		                       return cont([0, attachement_id, [0, size, [0, data, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "attachementId",
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, 0, 0, 0, 0, cst_size, 0, 2, [0, int_schema], 0, 0],
		                        [0, [0, 0, 0, 0, 0, cst_data, 0, [0, default$], a, 0, 0], 0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$87[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$87[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$116 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dg, [0, schematic_cache$116]);
		               var schematic_cache$117 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dh, [0, schematic_cache$117]);
		               var schematic_cache$118 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$87, [0, schematic_cache$118]);
		               caml_callback
		                (schema_versioned$48, [function(param){return 0;}]);
		               caml_callback
		                (header_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (message_part_body_schema_versi, [function(param){return 0;}]);
		               var
		                schematic_cache$119 = [0, empty$11([0, comparator$9])],
		                di = [];
		               caml_update_dummy(di, [0, schematic_cache$119]);
		               var
		                schematic_cache$120 = [0, empty$11([0, comparator$9])],
		                dj = [];
		               caml_update_dummy(dj, [0, schematic_cache$120]);
		               var
		                schematic_cache$121 = [0, empty$11([0, comparator$9])],
		                dk = [];
		               caml_update_dummy(dk, [0, schematic_cache$121]);
		               var
		                schematic_cache$122 = [0, empty$11([0, comparator$9])],
		                dl = [];
		               caml_update_dummy(dl, [0, schematic_cache$122]);
		               var
		                schematic_cache$123 = [0, empty$11([0, comparator$9])],
		                dm = [];
		               caml_update_dummy(dm, [0, schematic_cache$123]);
		               var
		                schematic_cache$124 = [0, empty$11([0, comparator$9])],
		                dn = [];
		               caml_update_dummy(dn, [0, schematic_cache$124]);
		               var
		                schematic_cache$125 = [0, empty$11([0, comparator$9])],
		                dp = [];
		               caml_update_dummy(dp, [0, schematic_cache$125]);
		               var
		                schematic_cache$126 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$88 = [];
		               caml_update_dummy
		                (letrec_function_context$88, [0, schematic_cache$126]);
		               var cst_threadId = "threadId", schematic_schema_version$4 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id, [di[1][1], schematic_schema_version$4]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             di[1][1],
		                             schematic_schema_version$4,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		di[1][1],
		schematic_schema_version$4,
		schematic_self,
		function(a){
		 di[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var thread_id = param[2][1], id = param[1];
		      return cont([0, id, thread_id]);
		     },
		     function(param, cont){
		      var thread_id = param[2], id = param[1];
		      return cont([0, id, [0, thread_id, 0]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_id,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_threadId,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       0]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          di[1][1],
		          schematic_schema_version$4,
		          res,
		          function(a){di[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$12(param){return 0;}
		               var cst_payload = "payload", schematic_schema_version$167 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dj[1][1], schematic_schema_version$167]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dj[1][1],
		                             schematic_schema_version$167,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dj[1][1],
		schematic_schema_version$167,
		schematic_self,
		function(a){
		 dj[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$48,
		          schematic_version$12,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var payload = param[2][1], id = param[1];
		                return cont([0, id, payload]);
		               },
		               function(param, cont){
		                var payload = param[2], id = param[1];
		                return cont([0, id, [0, payload, 0]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_id,
		                 0,
		                 2,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0, [0, 0, 0, 0, 0, cst_payload, 0, 2, [0, a], 0, 0], 0]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    dj[1][1],
		                    schematic_schema_version$167,
		                    res,
		                    function(a){dj[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$166 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dk[1][1], schematic_schema_version$166]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dk[1][1],
		                             schematic_schema_version$166,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dk[1][1],
		schematic_schema_version$166,
		schematic_self,
		function(a){
		 dk[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var raw = param[2][1], id = param[1];
		      return cont([0, id, raw]);
		     },
		     function(param, cont){
		      var raw = param[2], id = param[1];
		      return cont([0, id, [0, raw, 0]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_id,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        uP,
		        0,
		        0,
		        0,
		        cst_raw,
		        0,
		        2,
		        [0, bytes_str_schema_versioned()],
		        0,
		        0],
		       0]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          dk[1][1],
		          schematic_schema_version$166,
		          res,
		          function(a){dk[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$13(param){return 0;}
		               var schematic_schema_version$165 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dl[1][1], schematic_schema_version$165]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dl[1][1],
		                             schematic_schema_version$165,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dl[1][1],
		schematic_schema_version$165,
		schematic_self,
		function(a){
		 dl[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$48,
		          schematic_version$13,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 payload = a[2][1],
		                 raw = a[1],
		                 id = param[1];
		                return cont([0, id, raw, payload]);
		               },
		               function(param, cont){
		                var payload = param[3], raw = param[2], id = param[1];
		                return cont([0, id, [0, raw, [0, payload, 0]]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_id,
		                 0,
		                 3,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  uQ,
		                  0,
		                  0,
		                  0,
		                  cst_raw,
		                  0,
		                  3,
		                  [0, bytes_str_schema_versioned()],
		                  0,
		                  0],
		                 [0, [0, 0, 0, 0, 0, cst_payload, 0, 3, [0, a], 0, 0], 0]]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    dl[1][1],
		                    schematic_schema_version$165,
		                    res,
		                    function(a){dl[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$14(param){return 0;}
		               var schematic_schema_version$164 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dm[1][1], schematic_schema_version$164]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dm[1][1],
		                             schematic_schema_version$164,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dm[1][1],
		schematic_schema_version$164,
		schematic_self,
		function(a){
		 dm[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$48,
		          schematic_version$14,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 payload = a[2][1],
		                 raw = a[1],
		                 id = param[1];
		                return cont([0, id, raw, payload]);
		               },
		               function(param, cont){
		                var payload = param[3], raw = param[2], id = param[1];
		                return cont([0, id, [0, raw, [0, payload, 0]]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_id,
		                 0,
		                 3,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  uR,
		                  0,
		                  0,
		                  0,
		                  cst_raw,
		                  0,
		                  2,
		                  [0, bytes_str_schema_versioned()],
		                  0,
		                  0],
		                 [0, [0, 0, 0, 0, 0, cst_payload, 0, 3, [0, a], 0, 0], 0]]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    dm[1][1],
		                    schematic_schema_version$164,
		                    res,
		                    function(a){dm[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$49 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id, [dn[1][1], schematic_schema_version$49]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dn[1][1],
		                             schematic_schema_version$49,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dn[1][1],
		schematic_schema_version$49,
		schematic_self,
		function(a){
		 dn[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(uZ);},
		       0,
		       0,
		       cst_messageAdded,
		       "Message_added",
		       uY,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         return 1 === param ? cont(uX) : cont(0);
		        },
		        0,
		        0,
		        cst_messageDeleted,
		        "Message_deleted",
		        uW,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(2);},
		         function(param, cont){
		          return 2 === param ? cont(uV) : cont(0);
		         },
		         0,
		         0,
		         cst_labelAdded,
		         "Label_added",
		         uU,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(3);},
		          function(param, cont){
		           return 3 <= param ? cont(uT) : cont(0);
		          },
		          0,
		          0,
		          cst_labelRemoved,
		          "Label_removed",
		          uS,
		          0],
		         0]]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          dn[1][1],
		          schematic_schema_version$49,
		          res,
		          function(a){dn[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$48 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id, [dp[1][1], schematic_schema_version$48]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dp[1][1],
		                             schematic_schema_version$48,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dp[1][1],
		schematic_schema_version$48,
		schematic_self,
		function(a){
		 dp[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(u7);},
		       0,
		       0,
		       cst_minimal,
		       "Minimal",
		       u6,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         return 1 === param ? cont(u5) : cont(0);
		        },
		        0,
		        0,
		        cst_full,
		        "Full",
		        u4,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(2);},
		         function(param, cont){
		          return 2 === param ? cont(u3) : cont(0);
		         },
		         0,
		         0,
		         cst_raw,
		         "Raw",
		         u2,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(3);},
		          function(param, cont){
		           return 3 <= param ? cont(u1) : cont(0);
		          },
		          0,
		          0,
		          cst_metadata,
		          "Metadata",
		          u0,
		          0],
		         0]]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          dp[1][1],
		          schematic_schema_version$48,
		          res,
		          function(a){dp[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$47 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$88[1][1],
		                    schematic_schema_version$47]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$88[1][1],
		                             schematic_schema_version$47,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$88[1][1],
		schematic_schema_version$47,
		schematic_self,
		function(a){
		 letrec_function_context$88[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(u$);},
		       0,
		       0,
		       cst_receivedTime,
		       "Received_time",
		       u_,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){return param ? cont(u9) : cont(0);},
		        0,
		        0,
		        cst_dateHeader,
		        "Date_header",
		        u8,
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$88[1][1],
		          schematic_schema_version$47,
		          res,
		          function(a){
		           letrec_function_context$88[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$127 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$89 = [];
		               caml_update_dummy
		                (letrec_function_context$89, [0, schematic_cache$127]);
		               var
		                cst_addLabelIds = "addLabelIds",
		                cst_ids = "ids",
		                cst_removeLabelIds = "removeLabelIds",
		                schematic_schema_version$5 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$89[1][1],
		                    schematic_schema_version$5]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$89[1][1],
		                             schematic_schema_version$5,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$89[1][1],
		schematic_schema_version$5,
		schematic_self,
		function(a){
		 letrec_function_context$89[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		          function(b){
		           var
		            default$ = match$90[1],
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_removeLabelIds,
		                0,
		                [0, default$],
		                [0, b],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (option_schema,
		                    [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                    function(b){
		                     var
		                      default$ = match$91[1],
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           remove_label_ids = a[2][1],
		                           add_label_ids = a[1],
		                           ids = param[1];
		                          return cont([0, ids, add_label_ids, remove_label_ids]);
		                         },
		                         function(param, cont){
		                          var
		                           remove_label_ids = param[3],
		                           add_label_ids = param[2],
		                           ids = param[1];
		                          return cont
		                                  ([0, ids, [0, add_label_ids, [0, remove_label_ids, 0]]]);
		                         },
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_ids,
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_addLabelIds,
		                            0,
		                            [0, default$],
		                            [0, b],
		                            0,
		                            0],
		                           a]]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$89[1][1],
		                              schematic_schema_version$5,
		                              res,
		                              function(a){
		                               letrec_function_context$89[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$128 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$90 = [];
		               caml_update_dummy
		                (letrec_function_context$90, [0, schematic_cache$128]);
		               var schematic_schema_version$6 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$90[1][1],
		                    schematic_schema_version$6]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$90[1][1],
		                             schematic_schema_version$6,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$90[1][1],
		schematic_schema_version$6,
		schematic_self,
		function(a){
		 letrec_function_context$90[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var ids = param[1];
		      return cont([0, ids]);
		     },
		     function(param, cont){
		      var ids = param[1];
		      return cont([0, ids, 0]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_ids,
		       0,
		       2,
		       [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		       0,
		       0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$90[1][1],
		          schematic_schema_version$6,
		          res,
		          function(a){
		           letrec_function_context$90[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$129 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$91 = [];
		               caml_update_dummy
		                (letrec_function_context$91, [0, schematic_cache$129]);
		               var schematic_schema_version$7 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$91[1][1],
		                    schematic_schema_version$7]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$91[1][1],
		                             schematic_schema_version$7,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$91[1][1],
		schematic_schema_version$7,
		schematic_self,
		function(a){
		 letrec_function_context$91[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		          function(b){
		           var
		            default$ = match$92[1],
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_removeLabelIds,
		                0,
		                [0, default$],
		                [0, b],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (option_schema,
		                    [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                    function(b){
		                     var
		                      default$ = match$93[1],
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           remove_label_ids = param[2][1],
		                           add_label_ids = param[1];
		                          return cont([0, add_label_ids, remove_label_ids]);
		                         },
		                         function(param, cont){
		                          var remove_label_ids = param[2], add_label_ids = param[1];
		                          return cont([0, add_label_ids, [0, remove_label_ids, 0]]);
		                         },
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_addLabelIds,
		                           0,
		                           [0, default$],
		                           [0, b],
		                           0,
		                           0],
		                          a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$91[1][1],
		                              schematic_schema_version$7,
		                              res,
		                              function(a){
		                               letrec_function_context$91[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function equal$40(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  case 2:
		                   if(2 === rhs) return cont(1); break;
		                  case 3:
		                   if(3 === rhs) return cont(1); break;
		                  case 4:
		                   if(4 === rhs) return cont(1); break;
		                  case 5:
		                   if(5 === rhs) return cont(1); break;
		                  case 6:
		                   if(6 === rhs) return cont(1); break;
		                  case 7:
		                   if(7 === rhs) return cont(1); break;
		                  case 8:
		                   if(8 === rhs) return cont(1); break;
		                  case 9:
		                   if(9 === rhs) return cont(1); break;
		                  case 10:
		                   if(10 === rhs) return cont(1); break;
		                  case 11:
		                   if(11 === rhs) return cont(1); break;
		                  case 12:
		                   if(12 === rhs) return cont(1); break;
		                  case 13:
		                   if(13 === rhs) return cont(1); break;
		                  case 14:
		                   if(14 === rhs) return cont(1); break;
		                  case 15:
		                   if(15 === rhs) return cont(1); break;
		                  case 16:
		                   if(16 === rhs) return cont(1); break;
		                  case 17:
		                   if(17 === rhs) return cont(1); break;
		                  case 18:
		                   if(18 === rhs) return cont(1); break;
		                  case 19:
		                   if(19 === rhs) return cont(1); break;
		                  case 20:
		                   if(20 === rhs) return cont(1); break;
		                  case 21:
		                   if(21 === rhs) return cont(1); break;
		                  case 22:
		                   if(22 === rhs) return cont(1); break;
		                  case 23:
		                   if(23 === rhs) return cont(1); break;
		                  case 24:
		                   if(24 === rhs) return cont(1); break;
		                  case 25:
		                   if(25 === rhs) return cont(1); break;
		                  case 26:
		                   if(26 === rhs) return cont(1); break;
		                  case 27:
		                   if(27 === rhs) return cont(1); break;
		                  case 28:
		                   if(28 === rhs) return cont(1); break;
		                  case 29:
		                   if(29 === rhs) return cont(1); break;
		                  case 30:
		                   if(30 === rhs) return cont(1); break;
		                  case 31:
		                   if(31 === rhs) return cont(1); break;
		                  case 32:
		                   if(32 === rhs) return cont(1); break;
		                  case 33:
		                   if(33 === rhs) return cont(1); break;
		                  case 34:
		                   if(34 === rhs) return cont(1); break;
		                  case 35:
		                   if(35 === rhs) return cont(1); break;
		                  case 36:
		                   if(36 === rhs) return cont(1); break;
		                  default: if(37 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var
		                schematic_cache$130 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$92 = [];
		               caml_update_dummy
		                (letrec_function_context$92, [0, schematic_cache$130]);
		               var
		                cst_Calendar = "Calendar",
		                cst_Contacts = "Contacts",
		                cst_Email = "Email",
		                cst_Gmail = "Gmail",
		                cst_Profile = "Profile",
		                cst_Tasks = "Tasks",
		                schematic_schema_version$46 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$92[1][1],
		                    schematic_schema_version$46]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$92[1][1],
		                             schematic_schema_version$46,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$92[1][1],
		schematic_schema_version$46,
		schematic_self,
		function(a){
		 letrec_function_context$92[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(wm);},
		       0,
		       0,
		       cst_https_www_googleapis_com_a,
		       cst_Calendar,
		       [0, ah[1], wl, ah[3], ah[4]],
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         return 1 === param ? cont(wk) : cont(0);
		        },
		        0,
		        0,
		        cst_https_www_googleapis_com_a$0,
		        "Calendar_events",
		        [0, ag[1], wj, ag[3], ag[4]],
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(2);},
		         function(param, cont){
		          return 2 === param ? cont(wi) : cont(0);
		         },
		         0,
		         0,
		         cst_https_www_googleapis_com_a$1,
		         "Calendar_events_readonly",
		         [0, af[1], wh, af[3], af[4]],
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(3);},
		          function(param, cont){
		           return 3 === param ? cont(wg) : cont(0);
		          },
		          0,
		          0,
		          cst_https_www_googleapis_com_a$2,
		          "Calendar_readonly",
		          [0, ae[1], wf, ae[3], ae[4]],
		          0],
		         [0,
		          [0,
		           function(param, cont){return cont(4);},
		           function(param, cont){
		            return 4 === param ? cont(we) : cont(0);
		           },
		           0,
		           0,
		           cst_https_www_googleapis_com_a$3,
		           "Calendar_settings_readonly",
		           [0, ad[1], wd, ad[3], ad[4]],
		           0],
		          [0,
		           [0,
		            function(param, cont){return cont(5);},
		            function(param, cont){
		             return 5 === param ? cont(wc) : cont(0);
		            },
		            0,
		            0,
		            cst_https_www_googleapis_com_a$4,
		            cst_Contacts,
		            [0, ac[1], wb, ac[3], ac[4]],
		            0],
		           [0,
		            [0,
		             function(param, cont){return cont(6);},
		             function(param, cont){
		              return 6 === param ? cont(wa) : cont(0);
		             },
		             0,
		             0,
		             cst_https_www_googleapis_com_a$5,
		             "Contacts_other_readonly",
		             [0, ab[1], v$, ab[3], ab[4]],
		             0],
		            [0,
		             [0,
		              function(param, cont){return cont(7);},
		              function(param, cont){
		               return 7 === param ? cont(v_) : cont(0);
		              },
		              0,
		              0,
		              cst_https_www_googleapis_com_a$6,
		              "Contacts_readonly",
		              [0, aa[1], v9, aa[3], aa[4]],
		              0],
		             [0,
		              [0,
		               function(param, cont){return cont(8);},
		               function(param, cont){
		                return 8 === param ? cont(v8) : cont(0);
		               },
		               0,
		               0,
		               cst_https_www_googleapis_com_a$7,
		               "Directory_readonly",
		               [0, $[1], v7, $[3], $[4]],
		               0],
		              [0,
		               [0,
		                function(param, cont){return cont(9);},
		                function(param, cont){
		                 return 9 === param ? cont(v6) : cont(0);
		                },
		                0,
		                0,
		                cst_https_www_googleapis_com_a$8,
		                "Drive",
		                [0, _[1], v5, _[3], _[4]],
		                0],
		               [0,
		                [0,
		                 function(param, cont){return cont(10);},
		                 function(param, cont){
		                  return 10 === param ? cont(v4) : cont(0);
		                 },
		                 0,
		                 0,
		                 cst_https_www_googleapis_com_a$9,
		                 "Drive_appdata",
		                 [0, Z[1], v3, Z[3], Z[4]],
		                 0],
		                [0,
		                 [0,
		                  function(param, cont){return cont(11);},
		                  function(param, cont){
		                   return 11 === param ? cont(v2) : cont(0);
		                  },
		                  0,
		                  0,
		                  cst_https_www_googleapis_com_a$10,
		                  "Drive_file",
		                  [0, Y[1], v1, Y[3], Y[4]],
		                  0],
		                 [0,
		                  [0,
		                   function(param, cont){return cont(12);},
		                   function(param, cont){
		                    return 12 === param ? cont(vZ) : cont(0);
		                   },
		                   0,
		                   0,
		                   cst_https_www_googleapis_com_a$11,
		                   "Drive_metadata",
		                   [0, X[1], vY, X[3], X[4]],
		                   0],
		                  [0,
		                   [0,
		                    function(param, cont){return cont(13);},
		                    function(param, cont){
		                     return 13 === param ? cont(vX) : cont(0);
		                    },
		                    0,
		                    0,
		                    cst_https_www_googleapis_com_a$12,
		                    "Drive_metadata_readonly",
		                    [0, W[1], vW, W[3], W[4]],
		                    0],
		                   [0,
		                    [0,
		                     function(param, cont){return cont(14);},
		                     function(param, cont){
		                      return 14 === param ? cont(vV) : cont(0);
		                     },
		                     0,
		                     0,
		                     cst_https_www_googleapis_com_a$13,
		                     "Drive_photos_readonly",
		                     [0, V[1], vU, V[3], V[4]],
		                     0],
		                    [0,
		                     [0,
		                      function(param, cont){return cont(15);},
		                      function(param, cont){
		                       return 15 === param ? cont(vT) : cont(0);
		                      },
		                      0,
		                      0,
		                      cst_https_www_googleapis_com_a$14,
		                      "Drive_readonly",
		                      [0, U[1], vS, U[3], U[4]],
		                      0],
		                     [0,
		                      [0,
		                       function(param, cont){return cont(16);},
		                       function(param, cont){
		                        return 16 === param ? cont(vR) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_https_www_googleapis_com_a$15,
		                       "Drive_scripts",
		                       [0, T[1], vQ, T[3], T[4]],
		                       0],
		                      [0,
		                       [0,
		                        function(param, cont){return cont(17);},
		                        function(param, cont){
		                         return 17 === param ? cont(vP) : cont(0);
		                        },
		                        0,
		                        0,
		                        cst_https_www_googleapis_com_a$16,
		                        "Documents",
		                        [0, S[1], vO, S[3], S[4]],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(18);},
		                         function(param, cont){
		                          return 18 === param ? cont(vN) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_https_www_googleapis_com_a$17,
		                         "Documents_readonly",
		                         [0, R[1], vM, R[3], R[4]],
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(19);},
		                          function(param, cont){
		                           return 19 === param ? cont(vL) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_email,
		                          cst_Email,
		                          [0, Q[1], vK, Q[3], Q[4]],
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(20);},
		                           function(param, cont){
		                            return 20 === param ? cont(vJ) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_https_mail_google_com,
		                           cst_Gmail,
		                           vI,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(21);},
		                            function(param, cont){
		                             return 21 === param ? cont(vH) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_https_www_googleapis_com_a$18,
		                            "Gmail_insert",
		                            vG,
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(22);},
		                             function(param, cont){
		                              return 22 === param ? cont(vF) : cont(0);
		                             },
		                             0,
		                             0,
		                             cst_https_www_googleapis_com_a$19,
		                             "Gmail_labels",
		                             vE,
		                             0],
		                            [0,
		                             [0,
		                              function(param, cont){return cont(23);},
		                              function(param, cont){
		                               return 23 === param ? cont(vD) : cont(0);
		                              },
		                              0,
		                              0,
		                              cst_https_www_googleapis_com_a$20,
		                              "Gmail_modify",
		                              vC,
		                              0],
		                             [0,
		                              [0,
		                               function(param, cont){return cont(24);},
		                               function(param, cont){
		                                return 24 === param ? cont(vB) : cont(0);
		                               },
		                               0,
		                               0,
		                               cst_https_www_googleapis_com_a$21,
		                               "Gmail_metadata",
		                               vA,
		                               0],
		                              [0,
		                               [0,
		                                function(param, cont){return cont(25);},
		                                function(param, cont){
		                                 return 25 === param ? cont(vz) : cont(0);
		                                },
		                                0,
		                                0,
		                                cst_https_www_googleapis_com_a$22,
		                                "Gmail_readonly",
		                                vy,
		                                0],
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(26);},
		                                 function(param, cont){
		                                  return 26 === param ? cont(vx) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_openid,
		                                 "Openid",
		                                 [0, P[1], vw, P[3], P[4]],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(27);},
		                                  function(param, cont){
		                                   return 27 === param ? cont(vv) : cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_profile,
		                                  cst_Profile,
		                                  [0, O[1], vu, O[3], O[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(28);},
		                                   function(param, cont){
		                                    return 28 === param ? cont(vt) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_User_addresses_read,
		                                   cst_User_addresses_read,
		                                   [0, N[1], vs, N[3], N[4]],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(29);},
		                                    function(param, cont){
		                                     return 29 === param ? cont(vr) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_https_www_googleapis_com_a$23,
		                                    "User_birthday_read",
		                                    [0, M[1], vq, M[3], M[4]],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(30);},
		                                     function(param, cont){
		                                      return 30 === param ? cont(vp) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_https_www_googleapis_com_a$24,
		                                     "User_emails_read",
		                                     [0, L[1], vo, L[3], L[4]],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(31);},
		                                      function(param, cont){
		                                       return 31 === param ? cont(vn) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_https_www_googleapis_com_a$25,
		                                      "User_gender_read",
		                                      [0, K[1], vm, K[3], K[4]],
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(32);},
		                                       function(param, cont){
		return 32 === param ? cont(vl) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_https_www_googleapis_com_a$26,
		                                       "User_organization_read",
		                                       [0, J[1], vk, J[3], J[4]],
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(33);},
		function(param, cont){
		 return 33 === param ? cont(vj) : cont(0);
		},
		0,
		0,
		cst_https_www_googleapis_com_a$27,
		"User_phonenumbers_read",
		[0, I[1], vi, I[3], I[4]],
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(34);},
		 function(param, cont){
		  return 34 === param ? cont(vh) : cont(0);
		 },
		 0,
		 0,
		 cst_https_www_googleapis_com_a$28,
		 "Userinfo_email",
		 [0, H[1], vg, H[3], H[4]],
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(35);},
		  function(param, cont){
		   return 35 === param ? cont(vf) : cont(0);
		  },
		  0,
		  0,
		  cst_https_www_googleapis_com_a$29,
		  "Userinfo_profile",
		  [0, G[1], ve, G[3], G[4]],
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(36);},
		   function(param, cont){
		    return 36 === param ? cont(vd) : cont(0);
		   },
		   0,
		   0,
		   cst_https_www_googleapis_com_a$30,
		   cst_Tasks,
		   [0, F[1], vc, F[3], F[4]],
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(37);},
		    function(param, cont){
		     return 37 <= param ? cont(vb) : cont(0);
		    },
		    0,
		    0,
		    cst_https_www_googleapis_com_a$31,
		    "Tasks_readonly",
		    [0, E[1], va, E[3], E[4]],
		    0],
		   0]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$92[1][1],
		          schematic_schema_version$46,
		          res,
		          function(a){
		           letrec_function_context$92[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function to_string$23(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(cst_https_www_googleapis_com_a);
		                  case 1:
		                   return cont(cst_https_www_googleapis_com_a$0);
		                  case 2:
		                   return cont(cst_https_www_googleapis_com_a$1);
		                  case 3:
		                   return cont(cst_https_www_googleapis_com_a$2);
		                  case 4:
		                   return cont(cst_https_www_googleapis_com_a$3);
		                  case 5:
		                   return cont(cst_https_www_googleapis_com_a$4);
		                  case 6:
		                   return cont(cst_https_www_googleapis_com_a$5);
		                  case 7:
		                   return cont(cst_https_www_googleapis_com_a$6);
		                  case 8:
		                   return cont(cst_https_www_googleapis_com_a$7);
		                  case 9:
		                   return cont(cst_https_www_googleapis_com_a$8);
		                  case 10:
		                   return cont(cst_https_www_googleapis_com_a$9);
		                  case 11:
		                   return cont(cst_https_www_googleapis_com_a$10);
		                  case 12:
		                   return cont(cst_https_www_googleapis_com_a$11);
		                  case 13:
		                   return cont(cst_https_www_googleapis_com_a$12);
		                  case 14:
		                   return cont(cst_https_www_googleapis_com_a$13);
		                  case 15:
		                   return cont(cst_https_www_googleapis_com_a$14);
		                  case 16:
		                   return cont(cst_https_www_googleapis_com_a$15);
		                  case 17:
		                   return cont(cst_https_www_googleapis_com_a$16);
		                  case 18:
		                   return cont(cst_https_www_googleapis_com_a$17);
		                  case 19:
		                   return cont(cst_email);
		                  case 20:
		                   return cont(cst_https_mail_google_com);
		                  case 21:
		                   return cont(cst_https_www_googleapis_com_a$18);
		                  case 22:
		                   return cont(cst_https_www_googleapis_com_a$19);
		                  case 23:
		                   return cont(cst_https_www_googleapis_com_a$20);
		                  case 24:
		                   return cont(cst_https_www_googleapis_com_a$21);
		                  case 25:
		                   return cont(cst_https_www_googleapis_com_a$22);
		                  case 26:
		                   return cont(cst_openid);
		                  case 27:
		                   return cont(cst_profile);
		                  case 28:
		                   return cont(cst_User_addresses_read);
		                  case 29:
		                   return cont(cst_https_www_googleapis_com_a$23);
		                  case 30:
		                   return cont(cst_https_www_googleapis_com_a$24);
		                  case 31:
		                   return cont(cst_https_www_googleapis_com_a$25);
		                  case 32:
		                   return cont(cst_https_www_googleapis_com_a$26);
		                  case 33:
		                   return cont(cst_https_www_googleapis_com_a$27);
		                  case 34:
		                   return cont(cst_https_www_googleapis_com_a$28);
		                  case 35:
		                   return cont(cst_https_www_googleapis_com_a$29);
		                  case 36:
		                   return cont(cst_https_www_googleapis_com_a$30);
		                  default: return cont(cst_https_www_googleapis_com_a$31);
		                }
		               }
		               function of_string$17(scope, cont){
		                var
		                 switch$ =
		                   caml_string_compare
		                    (scope, cst_https_www_googleapis_com_a$13);
		                if(0 <= switch$){
		                 if(0 >= switch$) return cont(wF);
		                 var
		                  switch$0 =
		                    caml_string_compare
		                     (scope, cst_https_www_googleapis_com_a$23);
		                 if(0 <= switch$0){
		                  if(0 >= switch$0) return cont(wv);
		                  if(scope === cst_https_www_googleapis_com_a$24)
		                   return cont(wu);
		                  if(scope === cst_https_www_googleapis_com_a$25)
		                   return cont(wt);
		                  if(scope === cst_https_www_googleapis_com_a$26)
		                   return cont(ws);
		                  if(scope === cst_https_www_googleapis_com_a$27)
		                   return cont(wr);
		                  if(scope === cst_https_www_googleapis_com_a$28)
		                   return cont(wq);
		                  if(scope === cst_https_www_googleapis_com_a$29)
		                   return cont(wp);
		                  if(scope === cst_openid) return cont(wo);
		                  if(scope === cst_profile) return cont(wn);
		                 }
		                 else {
		                  if(scope === cst_https_www_googleapis_com_a$14)
		                   return cont(wE);
		                  if(scope === cst_https_www_googleapis_com_a$15)
		                   return cont(wD);
		                  if(scope === cst_https_www_googleapis_com_a$18)
		                   return cont(wC);
		                  if(scope === cst_https_www_googleapis_com_a$19)
		                   return cont(wB);
		                  if(scope === cst_https_www_googleapis_com_a$21)
		                   return cont(wA);
		                  if(scope === cst_https_www_googleapis_com_a$20)
		                   return cont(wz);
		                  if(scope === cst_https_www_googleapis_com_a$22)
		                   return cont(wy);
		                  if(scope === cst_https_www_googleapis_com_a$30)
		                   return cont(wx);
		                  if(scope === cst_https_www_googleapis_com_a$31)
		                   return cont(ww);
		                 }
		                }
		                else {
		                 var
		                  switch$1 =
		                    caml_string_compare(scope, cst_https_www_googleapis_com_a$5);
		                 if(0 <= switch$1){
		                  if(0 >= switch$1) return cont(wP);
		                  if(scope === cst_https_www_googleapis_com_a$6)
		                   return cont(wO);
		                  if(scope === cst_https_www_googleapis_com_a$7)
		                   return cont(wN);
		                  if(scope === cst_https_www_googleapis_com_a$16)
		                   return cont(wM);
		                  if(scope === cst_https_www_googleapis_com_a$17)
		                   return cont(wL);
		                  if(scope === cst_https_www_googleapis_com_a$8)
		                   return cont(wK);
		                  if(scope === cst_https_www_googleapis_com_a$9)
		                   return cont(wJ);
		                  if(scope === cst_https_www_googleapis_com_a$10)
		                   return cont(wI);
		                  if(scope === cst_https_www_googleapis_com_a$11)
		                   return cont(wH);
		                  if(scope === cst_https_www_googleapis_com_a$12)
		                   return cont(wG);
		                 }
		                 else {
		                  if(scope === cst_User_addresses_read) return cont(wY);
		                  if(scope === cst_email) return cont(wX);
		                  if(scope === cst_https_mail_google_com) return cont(wW);
		                  if(scope === cst_https_www_googleapis_com_a)
		                   return cont(wV);
		                  if(scope === cst_https_www_googleapis_com_a$0)
		                   return cont(wU);
		                  if(scope === cst_https_www_googleapis_com_a$1)
		                   return cont(wT);
		                  if(scope === cst_https_www_googleapis_com_a$2)
		                   return cont(wS);
		                  if(scope === cst_https_www_googleapis_com_a$3)
		                   return cont(wR);
		                  if(scope === cst_https_www_googleapis_com_a$4)
		                   return cont(wQ);
		                 }
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         fail,
		                         format$13,
		                         function(a){
		                          return caml_trampoline_cps_call2(a, scope, cont);
		                         });
		               }
		               var letrec_function_context$93 = [];
		               function equal$41(x, cont){
		                return cont
		                        (function(y, cont){
		                          function a(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$93[1],
		                                      a$0,
		                                      b,
		                                      function(b){
		                                       return b
		       ? caml_exact_trampoline_call2(a, x$0, y$0)
		       : cont(b);
		                                      });
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return a(x, y);
		                         });
		               }
		               caml_update_dummy(letrec_function_context$93, [0, equal$40]);
		               function of_string$18(scopes, cont){
		                return scopes !== cst$1
		                        ? caml_exact_trampoline_cps_call$1
		                          (split$0,
		                           scopes,
		                           32,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (map$18,
		                                     a,
		                                     of_string$17,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(all$14, a, cont);
		                                     });
		                           })
		                        : cont(wZ);
		               }
		               function to_string$24(l, cont){
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         l,
		                         to_string$23,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0, w0, a, cont);
		                         });
		               }
		               function schema_versioned$49(param){
		                return [0,
		                        id$13,
		                        0,
		                        [4, of_string$18, to_string$24, descriptor$1],
		                        0];
		               }
		               var letrec_function_context$94 = [];
		               function equal$42(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$94[2],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                          a:
		                          if(c){
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b$0 = y[1], a$0 = x[1], c = a$0 === b$0 ? 1 : 0;
		                             break a;
		                            }
		                           }
		                           else if(! y){c = 1; break a;}
		                           c = 0;
		                          }
		                          if(c)
		                           var b$1 = rhs[4], a$1 = lhs[4], c = a$1 === b$1 ? 1 : 0;
		                          if(c)
		                           var b$2 = rhs[5], a$2 = lhs[5], c = a$2 === b$2 ? 1 : 0;
		                          function d(c){
		                           if(c) var b = rhs[7], a = lhs[7], c = a === b ? 1 : 0;
		                           if(! c) return cont(c);
		                           var b$0 = rhs[8], a$0 = lhs[8];
		                           return cont(a$0 === b$0 ? 1 : 0);
		                          }
		                          return c
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$94[1], lhs[6], rhs[6], d)
		                                  : d(c);
		                         });
		               }
		               function equal_access_type(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$94, [0, equal$41, equal_access_type]);
		               var
		                cst_expires_in = "expires_in",
		                cst_scope = "scope",
		                cst_user_id = "user_id",
		                dr = [];
		               function schema_versioned$50(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dr[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, w1, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dr[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dr[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            dr[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 w8,
		                                 0,
		                                 0,
		                                 0,
		                                 "audience",
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  w7,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_email,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   w6,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_expires_in,
		                                   0,
		                                   2,
		                                   [0, int_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    w5,
		                                    0,
		                                    0,
		                                    0,
		                                    "issued_to",
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     w4,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_scope,
		                                     0,
		                                     2,
		                                     [0, schema_versioned$49()],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      w3,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_user_id,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       w2,
		                                       0,
		                                       0,
		                                       0,
		                                       "verified_email",
		                                       0,
		                                       2,
		                                       [0, bool_schema],
		                                       0,
		                                       0],
		                                      0]]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (access_type_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    verified_email = f[2][1],
		    user_id = f[1],
		    scope = e[1],
		    issued_to = d[1],
		    expires_in = c[1],
		    email = b[1],
		    audience = a[1],
		    access_type = param[1];
		   return cont
		           ([0,
		             access_type,
		             audience,
		             email,
		             expires_in,
		             issued_to,
		             scope,
		             user_id,
		             verified_email]);
		  },
		  function(param, cont){
		   var
		    verified_email = param[8],
		    user_id = param[7],
		    scope = param[6],
		    issued_to = param[5],
		    expires_in = param[4],
		    email = param[3],
		    audience = param[2],
		    access_type = param[1];
		   return cont
		           ([0,
		             access_type,
		             [0,
		              audience,
		              [0,
		               email,
		               [0,
		                expires_in,
		                [0,
		                 issued_to,
		                 [0, scope, [0, user_id, [0, verified_email, 0]]]]]]]]);
		  },
		  [0,
		   [0, w9, 0, 0, 0, cst_access_type, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dr[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dr[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_Offline = "Offline", letrec_function_context$95 = [];
		               function access_type_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$95[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, w_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$95[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$95[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$95[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(xc);},
		                                  0,
		                                  0,
		                                  cst_offline,
		                                  cst_Offline,
		                                  xb,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(xa) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_online,
		                                   "Online",
		                                   w$,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$95[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$95[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$131 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dr, [0, schematic_cache$131]);
		               var schematic_cache$132 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$95, [0, schematic_cache$132]);
		               var
		                schema$13 =
		                  caml_callback
		                   (schema_versioned$50,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (access_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_access_token = "access_token",
		                letrec_function_context$96 = [];
		               function schema_versioned$51(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$96[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, xd, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$96[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$96[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$96[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        scope = b[2][1],
		                        token_type = b[1],
		                        expires_in = a[1],
		                        access_token = param[1];
		                       return cont
		                               ([0, access_token, expires_in, token_type, scope]);
		                      },
		                      function(param, cont){
		                       var
		                        scope = param[4],
		                        token_type = param[3],
		                        expires_in = param[2],
		                        access_token = param[1];
		                       return cont
		                               ([0,
		                                 access_token,
		                                 [0, expires_in, [0, token_type, [0, scope, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_access_token,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, 0, 0, 0, 0, cst_expires_in, 0, 2, [0, int_schema], 0, 0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_token_type,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_scope,
		                           0,
		                           2,
		                           [0, schema_versioned$49()],
		                           0,
		                           0],
		                          0]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$96[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$96[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$133 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$96, [0, schematic_cache$133]);
		               caml_callback
		                (schema_versioned$51, [function(param){return 0;}]);
		               var
		                schematic_cache$134 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$97 = [];
		               caml_update_dummy
		                (letrec_function_context$97, [0, schematic_cache$134]);
		               function schematic_version$15(param){return 0;}
		               var schematic_schema_version$163 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$97[1][1],
		                    schematic_schema_version$163]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$97[1][1],
		                             schematic_schema_version$163,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$97[1][1],
		schematic_schema_version$163,
		schematic_self,
		function(b){
		 letrec_function_context$97[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      "refresh_token",
		      0,
		      3,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$51,
		          schematic_version$15,
		          function(b){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var refresh_token = param[2][1], oauth = param[1];
		                return cont([0, oauth, refresh_token]);
		               },
		               function(param, cont){
		                var refresh_token = param[2], oauth = param[1];
		                return cont([0, oauth, [0, refresh_token, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_oauth, 0, 2, [1, b], 0, 0], a]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$97[1][1],
		                    schematic_schema_version$163,
		                    res,
		                    function(a){
		                     letrec_function_context$97[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$98 = [];
		               function schema_versioned$52(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$98[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, xe, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$98[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$98[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$98[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$19,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_requestedResourceName,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, b], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$31,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    status = a[2][1],
		    requestedResourceName = a[1],
		    person = param[1];
		   return cont([0, person, requestedResourceName, status]);
		  },
		  function(param, cont){
		   var
		    status = param[3],
		    requestedResourceName = param[2],
		    person = param[1];
		   return cont
		           ([0, person, [0, requestedResourceName, [0, status, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_person, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$98[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$98[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$135 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$98, [0, schematic_cache$135]);
		               caml_callback
		                (schema_versioned$52, [function(param){return 0;}]);
		               var
		                schematic_cache$136 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$99 = [];
		               caml_update_dummy
		                (letrec_function_context$99, [0, schematic_cache$136]);
		               function schematic_version$16(param){return 0;}
		               var schematic_schema_version$162 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$99[1][1],
		                    schematic_schema_version$162]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$99[1][1],
		                             schematic_schema_version$162,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$99[1][1],
		schematic_schema_version$162,
		schematic_self,
		function(a){
		 letrec_function_context$99[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$52,
		          schematic_version$16,
		          function(a){
		           var
		            default$ = match$94[1],
		            res =
		              [7,
		               function(param, cont){
		                var responses = param[1];
		                return cont([0, responses]);
		               },
		               function(param, cont){
		                var responses = param[1];
		                return cont([0, responses, 0]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_responses,
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, a], 0]],
		                 0,
		                 0],
		                0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$99[1][1],
		                    schematic_schema_version$162,
		                    res,
		                    function(a){
		                     letrec_function_context$99[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$137 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$100 = [];
		               caml_update_dummy
		                (letrec_function_context$100, [0, schematic_cache$137]);
		               var schematic_schema_version$45 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$100[1][1],
		                    schematic_schema_version$45]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$100[1][1],
		                             schematic_schema_version$45,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$100[1][1],
		schematic_schema_version$45,
		schematic_self,
		function(a){
		 letrec_function_context$100[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(xm);},
		       0,
		       0,
		       cst_READ_SOURCE_TYPE_UNSPECIFI,
		       cst_Unspecified,
		       xl,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         return 1 === param ? cont(xk) : cont(0);
		        },
		        0,
		        0,
		        cst_READ_SOURCE_TYPE_PROFILE,
		        cst_Profile,
		        xj,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(2);},
		         function(param, cont){
		          return 2 === param ? cont(xi) : cont(0);
		         },
		         0,
		         0,
		         cst_READ_SOURCE_TYPE_CONTACT,
		         cst_Contact,
		         xh,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(3);},
		          function(param, cont){
		           return 3 <= param ? cont(xg) : cont(0);
		          },
		          0,
		          0,
		          cst_READ_SOURCE_TYPE_DOMAIN_CO,
		          cst_Domain_contact,
		          xf,
		          0],
		         0]]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$100[1][1],
		          schematic_schema_version$45,
		          res,
		          function(a){
		           letrec_function_context$100[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               create$18(xn, "gapi");
		               var cst_details = "details", ds = [];
		               function google_error_payload_schema_ve
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         ds[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, xo, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      ds[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 ds[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(b){
		                  ds[1][1] = b;
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_message,
		                       0,
		                       2,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_status,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call
		                          (google_error_details_schema_ve,
		                           schematic_version,
		                           function(c){
		                            var
		                             default$ = match$95[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "errors",
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, c], 0]],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (google_error_details_schema_ve,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       default$ = match$96[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    status = c[2][1],
		    message = c[1],
		    errors = b[1],
		    details = a[1],
		    code = param[1];
		   return cont([0, code, details, errors, message, status]);
		  },
		  function(param, cont){
		   var
		    status = param[5],
		    message = param[4],
		    errors = param[3],
		    details = param[2],
		    code = param[1];
		   return cont
		           ([0,
		             code,
		             [0, details, [0, errors, [0, message, [0, status, 0]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_code, 0, 2, [0, int_schema], 0, 0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_details,
		     0,
		     [0, default$],
		     [0, [0, 0, 0, [3, a], 0]],
		     0,
		     0],
		    b]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       ds[1][1],
		       schematic_schema_version,
		       res,
		       function(a){ds[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var dt = [];
		               function google_error_details_schema_ve
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$1);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dt[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, xp, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dt[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dt[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dt[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        reason = b[2][1],
		                        message = b[1],
		                        domain = a[1],
		                        type = param[1];
		                       return cont([0, type, domain, message, reason]);
		                      },
		                      function(param, cont){
		                       var
		                        reason = param[4],
		                        message = param[3],
		                        domain = param[2],
		                        type = param[1];
		                       return cont
		                               ([0, type, [0, domain, [0, message, [0, reason, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "@type",
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_domain,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_message,
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_reason,
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          0]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dt[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dt[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$138 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ds, [0, schematic_cache$138]);
		               var schematic_cache$139 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dt, [0, schematic_cache$139]);
		               var
		                schematic_cache$140 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$101 = [];
		               caml_update_dummy
		                (letrec_function_context$101, [0, schematic_cache$140]);
		               caml_callback
		                (google_error_payload_schema_ve, [function(param){return 0;}]);
		               caml_callback
		                (google_error_details_schema_ve, [function(param){return 0;}]);
		               function schematic_version$17(param){return 0;}
		               var
		                schematic_schema_version$161 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$101[1][1],
		                     schematic_schema_version$161]),
		                cst_Structured = "Structured",
		                cst_Unstructured = "Unstructured",
		                cst_error_description = "error_description",
		                cst_structured = "structured",
		                cst_unstructured = "unstructured";
		               if(e)
		                var schema$14 = e[1], descriptor$5 = schema$14;
		               else
		                descriptor$5 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$101[1][1],
		                              schematic_schema_version$161,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$101[1][1],
		 schematic_schema_version$161,
		 schematic_self,
		 function(b){
		  letrec_function_context$101[1][1] = b;
		  var
		   a =
		     [0,
		      [0,
		       function(param, cont){
		        var f1 = param[2], f0 = param[1];
		        return cont([1, f0, f1]);
		       },
		       function(param, cont){
		        if(1 !== param[0]) return cont(0);
		        var f1 = param[2], f0 = param[1];
		        return cont([0, [0, f0, f1]]);
		       },
		       1,
		       0,
		       cst_structured,
		       cst_Structured,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var description = param[2][1], error = param[1];
		          return cont([0, error, description]);
		         },
		         function(param, cont){
		          var description = param[2], error = param[1];
		          return cont([0, error, [0, description, 0]]);
		         },
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_error,
		           0,
		           2,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_error_description,
		            0,
		            3,
		            [0, schematic_param_name_schema_ve],
		            0,
		            0],
		           0]]],
		        0],
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([2, f0]);},
		        function(param, cont){
		         if(2 !== param[0]) return cont(0);
		         var f0 = param[1];
		         return cont([0, f0]);
		        },
		        0,
		        0,
		        cst_unstructured,
		        cst_Unstructured,
		        no_input_schema,
		        0],
		       0]];
		  return caml_exact_trampoline_cps_call
		          (google_error_payload_schema_ve,
		           schematic_version$17,
		           function(b){
		            var
		             res =
		               [11,
		                0,
		                [0,
		                 [0,
		                  function(f0, cont){return cont([0, f0]);},
		                  function(param, cont){
		                   if(0 !== param[0]) return cont(0);
		                   var f0 = param[1];
		                   return cont([0, f0]);
		                  },
		                  1,
		                  0,
		                  "structured_grpc",
		                  "Structured_grpc",
		                  [0,
		                   0,
		                   0,
		                   [7,
		                    function(param, cont){
		                     var error = param[1];
		                     return cont(error);
		                    },
		                    function(error, cont){return cont([0, error, 0]);},
		                    [0, [0, 0, 0, 0, 0, cst_error, 0, 2, [0, b], 0, 0], 0]],
		                   0],
		                  0],
		                 a],
		                0];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$101[1][1],
		                     schematic_schema_version$161,
		                     res,
		                     function(a){
		                      letrec_function_context$101[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var google_error_schema = [0, , , descriptor$5];
		               caml_callback(of_schema$1, [google_error_schema]);
		               var letrec_function_context$102 = [];
		               function equal$43(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                a:
		                if(c){
		                 var y = rhs[3], x = lhs[3];
		                 if(x){
		                  if(y){
		                   var b$1 = y[1], a$1 = x[1], c = a$1 === b$1 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                a:
		                if(c){
		                 var y$0 = rhs[4], x$0 = lhs[4];
		                 if(x$0){
		                  if(y$0){
		                   var b$2 = y$0[1], a$2 = x$0[1], c = a$2 === b$2 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y$0){c = 1; break a;}
		                 c = 0;
		                }
		                a:
		                if(c){
		                 var y$1 = rhs[5], x$1 = lhs[5];
		                 if(x$1){
		                  if(y$1){
		                   var b$3 = y$1[1], a$3 = x$1[1], c = a$3 === b$3 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y$1){c = 1; break a;}
		                 c = 0;
		                }
		                a:
		                if(c){
		                 var y$2 = rhs[6], x$2 = lhs[6];
		                 if(x$2){
		                  if(y$2){
		                   var b$4 = y$2[1], a$4 = x$2[1], c = a$4 === b$4 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y$2){c = 1; break a;}
		                 c = 0;
		                }
		                if(c) var b$5 = rhs[7], a$5 = lhs[7], c = a$5 === b$5 ? 1 : 0;
		                if(! c) return cont(c);
		                var y$3 = rhs[8], x$3 = lhs[8];
		                if(x$3){
		                 if(y$3){
		                  var b$6 = y$3[1], a$6 = x$3[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$102[1], a$6, b$6, cont);
		                 }
		                }
		                else if(! y$3) return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy(letrec_function_context$102, [0, equal$13]);
		               var letrec_function_context$103 = [];
		               function schema_versioned$53(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$1,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$103[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, xq, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$103[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$103[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$103[1][1] = a;
		                            var
		                             default$ = match$97[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  picture = f[2][1],
		                                  name = f[1],
		                                  locale = e[1],
		                                  hd = d[1],
		                                  given_name = c[1],
		                                  family_name = b[1],
		                                  email_verified = a[1],
		                                  email = param[1];
		                                 return cont
		 ([0,
		   email,
		   email_verified,
		   family_name,
		   given_name,
		   hd,
		   locale,
		   name,
		   picture]);
		                                },
		                                function(param, cont){
		                                 var
		                                  picture = param[8],
		                                  name = param[7],
		                                  locale = param[6],
		                                  hd = param[5],
		                                  given_name = param[4],
		                                  family_name = param[3],
		                                  email_verified = param[2],
		                                  email = param[1];
		                                 return cont
		 ([0,
		   email,
		   [0,
		    email_verified,
		    [0,
		     family_name,
		     [0,
		      given_name,
		      [0, hd, [0, locale, [0, name, [0, picture, 0]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_email,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "email_verified",
		                                   0,
		                                   [0, default$],
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "family_name",
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "given_name",
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_hd,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_locale,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_name,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       [0,
		[0, 0, 0, 0, 0, "picture", 0, 3, [0, schema$268], 0, 0],
		0]]]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$103[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$103[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$141 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$103, [0, schematic_cache$141]);
		               var
		                schema$15 =
		                  caml_callback
		                   (schema_versioned$53,
		                    [function(param, cont){return cont(0);}]);
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               caml_callback(of_string$8, ["https://www.googleapis.com"]);
		               caml_callback(of_string$8, ["https://docs.googleapis.com"]);
		               caml_callback(of_string$8, ["https://gmail.googleapis.com"]);
		               caml_callback(of_string$8, ["https://oauth2.googleapis.com"]);
		               caml_callback(of_string$8, ["https://people.googleapis.com"]);
		               caml_callback(of_string$8, ["https://accounts.google.com"]);
		               function uri_of_uri(uri){
		                return [0,
		                        [246,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_string$12, 0, uri, cont);
		                         }],
		                        [250, uri]];
		               }
		               function of_string$19(str, cont){
		                var
		                 a =
		                   [246,
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call
		                             (of_string$8, str, cont);
		                    }];
		                return caml_exact_trampoline_cps_call
		                        (from_val, str, function(b){return cont([0, b, a]);});
		               }
		               function force(t, cont){
		                var a = t[2], b = caml_obj_tag(a);
		                if(250 === b) return cont(a[1]);
		                if(246 !== b && 244 !== b) return cont(a);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, a, cont);
		               }
		               function to_string$25(pct_encoder, t, cont){
		                if(pct_encoder)
		                 return caml_exact_trampoline_cps_call
		                         (force,
		                          t,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (to_string$12, pct_encoder, a, cont);
		                          });
		                var a = t[1], b = caml_obj_tag(a);
		                if(250 === b) return cont(a[1]);
		                if(246 !== b && 244 !== b) return cont(a);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, a, cont);
		               }
		               function compare$51(lhs, rhs, cont){
		                var a = rhs[1], b = caml_obj_tag(a);
		                function c(y){
		                 var a = lhs[1], b = caml_obj_tag(a);
		                 function c(x){return cont(caml_string_compare(x, y));}
		                 if(250 === b) return c(a[1]);
		                 if(246 !== b && 244 !== b) return c(a);
		                 return caml_exact_trampoline_cps_call(force_lazy_block, a, c);
		                }
		                if(250 === b) return c(a[1]);
		                if(246 !== b && 244 !== b) return c(a);
		                return caml_exact_trampoline_cps_call(force_lazy_block, a, c);
		               }
		               function equal$44(lhs, rhs, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (compare$51,
		                         lhs,
		                         rhs,
		                         function(a){return cont(0 === a ? 1 : 0);});
		               }
		               function pp$27(fmt, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (force,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1(pp_v, fmt, a, cont);
		                         });
		               }
		               function make$15
		               (scheme,
		                userinfo,
		                host,
		                port,
		                path,
		                query,
		                fragment,
		                param,
		                cont){
		                return caml_exact_trampoline_cps_call$9
		                        (make$3,
		                         scheme,
		                         userinfo,
		                         host,
		                         port,
		                         path,
		                         query,
		                         fragment,
		                         dummy,
		                         function(a){return cont(uri_of_uri(a));});
		               }
		               function with_uri
		               (scheme,
		                userinfo,
		                host$0,
		                port,
		                path,
		                query,
		                fragment,
		                t,
		                cont){
		                return caml_exact_trampoline_cps_call
		                        (force,
		                         t,
		                         function(uri){
		                          function with$(f, o, u, cont){
		                           if(! o) return cont(u);
		                           var x = o[1];
		                           return caml_exact_trampoline_cps_call$1(f, u, x, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (with$,
		                                   with_scheme,
		                                   scheme,
		                                   uri,
		                                   function(uri){
		                                    function a(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (with$,
		      with_host,
		      host$0,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$0
		               (with$,
		                with_port,
		                port,
		                a,
		                function(u){
		                 function a(u){
		                  if(query){
		                   var x = query[1];
		                   if(x)
		                    var q = x[1], uri = with_query(u, q);
		                   else
		                    uri = with_query(u, 0);
		                  }
		                  else
		                   uri = u;
		                  if(fragment){
		                   var x$0 = fragment[1];
		                   if(x$0)
		                    var
		                     frag = x$0[1],
		                     a =
		                       [0,
		                        uri[1],
		                        uri[2],
		                        uri[3],
		                        uri[4],
		                        uri[5],
		                        uri[6],
		                        [0, frag]];
		                   else
		                    a = [0, uri[1], uri[2], uri[3], uri[4], uri[5], uri[6], 0];
		                  }
		                  else
		                   a = uri;
		                  return cont(uri_of_uri(a));
		                 }
		                 if(! path) return a(u);
		                 var x = path[1];
		                 if(! x)
		                  return caml_exact_trampoline_cps_call$1
		                          (with_path, u, cst$1, a);
		                 var p = x[1];
		                 return caml_exact_trampoline_cps_call$1(with_path, u, p, a);
		                });
		      });
		                                    }
		                                    if(! userinfo) return a(uri);
		                                    var userinfo$0 = userinfo[1];
		                                    function b(userinfo){
		                                     return host(uri)
		     ? a
		       ([0,
		         uri[1],
		         userinfo,
		         uri[3],
		         uri[4],
		         uri[5],
		         uri[6],
		         uri[7]])
		     : a
		       ([0,
		         uri[1],
		         userinfo,
		         [0, [0, 803994504, cst$1]],
		         uri[4],
		         uri[5],
		         uri[6],
		         uri[7]]);
		                                    }
		                                    if(! userinfo$0) return b(0);
		                                    var u = userinfo$0[1];
		                                    return caml_exact_trampoline_cps_call
		    (userinfo_of_encoded, u, function(a){return b([0, a]);});
		                                   });
		                         });
		               }
		               function scheme$1(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (force, t, function(a){return cont(scheme(a));});
		               }
		               function host$1(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (force, t, function(a){return cont(host(a));});
		               }
		               function path$0(pct_encoder, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (force,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (path, pct_encoder, a, cont);
		                         });
		               }
		               function to_uri(a, cont){
		                var uri = a[2], a = caml_obj_tag(uri);
		                if(250 === a) return cont(uri[1]);
		                if(246 !== a && 244 !== a) return cont(uri);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, uri, cont);
		               }
		               var
		                descriptor$6 =
		                  [4,
		                   function(s, cont){
		                    return caml_exact_trampoline_cps_call
		                            (of_string$19, s, function(a){return cont([0, a]);});
		                   },
		                   function(eta, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (to_string$25, 0, eta, cont);
		                   },
		                   8],
		                schema$262 = [0, id$14, 0, descriptor$6, 0];
		               function schema_versioned$54(param, cont){return cont(schema$262);
		               }
		               var bPZ = require$$1$2.nanoid;
		               function nanoid(size, param){
		                return caml_string_of_jsstring(bPZ());
		               }
		               function make$16(u, version){
		                var
		                 b6 = version << 4 | caml_bytes_get(u, 6) & 15,
		                 b8 = 128 | caml_bytes_get(u, 8) & 63;
		                caml_bytes_set(u, 6, b6);
		                caml_bytes_set(u, 8, b8);
		                return caml_string_of_bytes(u);
		               }
		               function make_named(version, digest, ns, s2, cont){
		                var hash = caml_bytes_of_string(digest(ns + s2));
		                return caml_exact_trampoline_cps_call$0
		                        (sub,
		                         hash,
		                         0,
		                         16,
		                         function(a){return cont(make$16(a, version));});
		               }
		               function v3$0(ns, n, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (make_named, 3, string, ns, n, cont);
		               }
		               function v5$0(ns, s2, cont){
		                var s = ns + s2;
		                function cls(n, x){return x << n | x >>> (32 - n | 0) | 0;}
		                var
		                 len = caml_ml_string_length(s),
		                 blen = 8 * len | 0,
		                 rem = len % 64 | 0,
		                 mlen =
		                   55 < rem
		                    ? (len + 128 | 0) - rem | 0
		                    : (len + 64 | 0) - rem | 0,
		                 m = caml_create_bytes(mlen);
		                return caml_exact_trampoline_cps_call$3
		                        (blit_string,
		                         s,
		                         0,
		                         m,
		                         0,
		                         len,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (fill,
		                                   m,
		                                   len,
		                                   mlen - len | 0,
		                                   0,
		                                   function(q){
		                                    caml_bytes_set(m, len, 128);
		                                    caml_bytes_set(m, mlen - 4 | 0, (blen >>> 24 | 0) & 255);
		                                    caml_bytes_set(m, mlen - 3 | 0, (blen >>> 16 | 0) & 255);
		                                    caml_bytes_set(m, mlen - 2 | 0, (blen >>> 8 | 0) & 255);
		                                    caml_bytes_set(m, mlen - 1 | 0, blen & 255);
		                                    var
		                                     w = caml_make_vect(16, 0),
		                                     q = (caml_ml_bytes_length(m) / 64 | 0) - 1 | 0,
		                                     g = 1732584193,
		                                     o = -271733879,
		                                     l = -1732584194,
		                                     n = 271733878,
		                                     p = -1009589776;
		                                    if(q < 0)
		                                     var h4 = p, h3 = n, h2 = l, h1 = o, h0 = g;
		                                    else {
		                                     var i = 0, h4$0 = p, h3$0 = n, h2$0 = l, h1$0 = o, h0$0 = g;
		                                     a:
		                                     for(;;){
		                                      var base = i * 64 | 0, j = 0;
		                                      for(;;){
		                                       g = get_int32_be(m, base + (j * 4 | 0) | 0);
		                                       caml_check_bound(w, j)[j + 1] = g;
		                                       g = j + 1 | 0;
		                                       if(15 === j) break;
		                                       j = g;
		                                      }
		                                      var
		                                       t = 0,
		                                       e = h4$0,
		                                       d = h3$0,
		                                       c$0 = h2$0,
		                                       b = h1$0,
		                                       a = h0$0;
		                                      for(;;){
		                                       if(19 < t)
		if(39 < t)
		 if(59 < t)
		  var k = -899497514, f = b ^ c$0 ^ d;
		 else {k = -1894007588; f = b & c$0 | b & d | c$0 & d;}
		else {k = 1859775393; f = b ^ c$0 ^ d;}
		                                       else {k = 1518500249; f = b & c$0 | (b ^ -1) & d;}
		                                       var s = t & 15;
		                                       if(16 <= t){
		g = (s + 2 | 0) & 15;
		o = caml_check_bound(w, s)[s + 1];
		l = (s + 8 | 0) & 15;
		g = caml_check_bound(w, g)[g + 1];
		n = (s + 13 | 0) & 15;
		l = caml_check_bound(w, l)[l + 1];
		w[s + 1] = cls(1, caml_check_bound(w, n)[n + 1] ^ l ^ g ^ o);
		                                       }
		                                       g = caml_check_bound(w, s)[s + 1];
		                                       var
		temp = (((cls(5, a) + f | 0) + e | 0) + g | 0) + k | 0,
		c = cls(30, b),
		g = t + 1 | 0;
		                                       if(79 === t){
		g = h0$0 + temp | 0;
		l = h1$0 + a | 0;
		n = h2$0 + c | 0;
		o = h3$0 + c$0 | 0;
		p = h4$0 + d | 0;
		var r = i + 1 | 0;
		if(q !== i){
		 i = r;
		 h4$0 = p;
		 h3$0 = o;
		 h2$0 = n;
		 h1$0 = l;
		 h0$0 = g;
		 break;
		}
		h4 = p;
		h3 = o;
		h2 = n;
		h1 = l;
		h0 = g;
		break a;
		                                       }
		                                       t = g;
		                                       e = d;
		                                       d = c$0;
		                                       c$0 = c;
		                                       b = a;
		                                       a = temp;
		                                      }
		                                     }
		                                    }
		                                    var h = caml_create_bytes(20);
		                                    return caml_exact_trampoline_cps_call$0
		    (set_int32_be,
		     h,
		     0,
		     h0,
		     function(a){
		      return caml_exact_trampoline_cps_call$0
		              (set_int32_be,
		               h,
		               4,
		               h1,
		               function(a){
		                return caml_exact_trampoline_cps_call$0
		                        (set_int32_be,
		                         h,
		                         8,
		                         h2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (set_int32_be,
		                                   h,
		                                   12,
		                                   h3,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (set_int32_be,
		     h,
		     16,
		     h4,
		     function(a){
		      var hash = caml_bytes_of_string(caml_string_of_bytes(h));
		      return caml_exact_trampoline_cps_call$0
		              (sub, hash, 0, 16, function(a){return cont(make$16(a, 5));});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function v4_random(rstate){
		                var
		                 r0 = caml_lxm_next(rstate),
		                 r1 = caml_lxm_next(rstate),
		                 u = caml_create_bytes(16);
		                set_int64_be(u, 0, r0);
		                set_int64_be(u, 8, r1);
		                return make$16(u, 4);
		               }
		               function of_string$20(a, s){
		                var pos = a ? a[1] : 0, len = caml_ml_string_length(s);
		                if
		                 (len >= (pos + 36 | 0)
		                  &&
		                   45 === caml_string_get(s, pos + 8 | 0)
		                   &&
		                    45 === caml_string_get(s, pos + 13 | 0)
		                    &&
		                     45 === caml_string_get(s, pos + 18 | 0)
		                     && 45 === caml_string_get(s, pos + 23 | 0))
		                 try{
		                  var
		                   u = caml_create_bytes(16),
		                   ihex =
		                     function(c){
		                      if(48 > c) throw caml_maybe_attach_backtrace(Exit, 1);
		                      if(57 >= c) return c - 48 | 0;
		                      if(65 > c) throw caml_maybe_attach_backtrace(Exit, 1);
		                      if(70 >= c) return c - 55 | 0;
		                      if(97 > c) throw caml_maybe_attach_backtrace(Exit, 1);
		                      if(102 < c) throw caml_maybe_attach_backtrace(Exit, 1);
		                      return c - 87 | 0;
		                     },
		                   byte =
		                     function(s, j){
		                      var a = ihex(caml_string_get(s, j + 1 | 0));
		                      return ihex(caml_string_get(s, j)) << 4 | a;
		                     },
		                   j = pos,
		                   i = 0;
		                  for(;;){
		                   if(4 <= i) break;
		                   caml_bytes_set(u, i, byte(s, j));
		                   var i$0 = i + 1 | 0;
		                   j = j + 2 | 0;
		                   i = i$0;
		                  }
		                  var j$0 = j + 1 | 0, j$1 = j$0, i$1 = i;
		                  for(;;){
		                   if(6 <= i$1) break;
		                   caml_bytes_set(u, i$1, byte(s, j$1));
		                   var i$2 = i$1 + 1 | 0;
		                   j$1 = j$1 + 2 | 0;
		                   i$1 = i$2;
		                  }
		                  var j$2 = j$1 + 1 | 0, j$3 = j$2, i$3 = i$1;
		                  for(;;){
		                   if(8 <= i$3) break;
		                   caml_bytes_set(u, i$3, byte(s, j$3));
		                   var i$4 = i$3 + 1 | 0;
		                   j$3 = j$3 + 2 | 0;
		                   i$3 = i$4;
		                  }
		                  var j$4 = j$3 + 1 | 0, j$5 = j$4, i$5 = i$3;
		                  for(;;){
		                   if(10 <= i$5) break;
		                   caml_bytes_set(u, i$5, byte(s, j$5));
		                   var i$6 = i$5 + 1 | 0;
		                   j$5 = j$5 + 2 | 0;
		                   i$5 = i$6;
		                  }
		                  var j$6 = j$5 + 1 | 0, j$7 = j$6, i$7 = i$5;
		                  for(;;){
		                   if(16 <= i$7){a = [0, caml_string_of_bytes(u)]; return a;}
		                   caml_bytes_set(u, i$7, byte(s, j$7));
		                   var i$8 = i$7 + 1 | 0;
		                   j$7 = j$7 + 2 | 0;
		                   i$7 = i$8;
		                  }
		                 }
		                 catch(exn$0){
		                  var exn = caml_wrap_exception(exn$0);
		                  if(exn === Exit) return 0;
		                  throw caml_maybe_attach_backtrace(exn, 0);
		                 }
		                return 0;
		               }
		               function to_string$26(opt, u, cont){
		                var upper = opt ? opt[1] : 0, hbase = upper ? 55 : 87;
		                function hex(hbase, i){
		                 return 10 <= i ? hbase + i | 0 : 48 + i | 0;
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string,
		                         "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
		                         function(s){
		                          function byte(s, i, c){
		                           caml_bytes_set(s, i, hex(hbase, c >>> 4 | 0));
		                           caml_bytes_set(s, i + 1 | 0, hex(hbase, c & 15));
		                          }
		                          var j = 0, i = 0;
		                          for(;;){
		                           if(4 <= j) break;
		                           byte(s, i, caml_string_get(u, j));
		                           var j$0 = j + 1 | 0;
		                           j = j$0;
		                           i = i + 2 | 0;
		                          }
		                          var i$0 = i + 1 | 0, j$1 = j, i$1 = i$0;
		                          for(;;){
		                           if(6 <= j$1) break;
		                           byte(s, i$1, caml_string_get(u, j$1));
		                           var j$2 = j$1 + 1 | 0;
		                           j$1 = j$2;
		                           i$1 = i$1 + 2 | 0;
		                          }
		                          var i$2 = i$1 + 1 | 0, j$3 = j$1, i$3 = i$2;
		                          for(;;){
		                           if(8 <= j$3) break;
		                           byte(s, i$3, caml_string_get(u, j$3));
		                           var j$4 = j$3 + 1 | 0;
		                           j$3 = j$4;
		                           i$3 = i$3 + 2 | 0;
		                          }
		                          var i$4 = i$3 + 1 | 0, j$5 = j$3, i$5 = i$4;
		                          for(;;){
		                           if(10 <= j$5) break;
		                           byte(s, i$5, caml_string_get(u, j$5));
		                           var j$6 = j$5 + 1 | 0;
		                           j$5 = j$6;
		                           i$5 = i$5 + 2 | 0;
		                          }
		                          var i$6 = i$5 + 1 | 0, j$7 = j$5, i$7 = i$6;
		                          for(;;){
		                           if(16 <= j$7) return cont(caml_string_of_bytes(s));
		                           byte(s, i$7, caml_string_get(u, j$7));
		                           var j$8 = j$7 + 1 | 0;
		                           j$7 = j$8;
		                           i$7 = i$7 + 2 | 0;
		                          }
		                         });
		               }
		               function pp$28(ppf, u, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_string$26,
		                         0,
		                         u,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, ppf, a, cont);
		                         });
		               }
		               var
		                default_seed =
		                  [246,
		                   function(a, cont){
		                    return caml_exact_trampoline_cps_call
		                            (make_self_init, dummy, cont);
		                   }];
		               function create$24(a, cont){
		                if(typeof a === "number"){
		                 a = caml_obj_tag(default_seed);
		                 var b = function(a){return cont(v4_random(a));};
		                 if(250 === a) return b(default_seed[1]);
		                 if(246 !== a && 244 !== a) return b(default_seed);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, default_seed, b);
		                }
		                var variant = a[1];
		                if(19231 <= variant){
		                 a = a[2];
		                 var n = a[2], ns = a[1];
		                 return caml_exact_trampoline_cps_call$1(v5$0, ns, n, cont);
		                }
		                a = a[2];
		                var n$0 = a[2], ns$0 = a[1];
		                return caml_exact_trampoline_cps_call$1(v3$0, ns$0, n$0, cont);
		               }
		               function schema_versioned$55(param, cont){
		                function decode(s, cont){
		                 var a = of_string$20(0, s);
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$53,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b, s, function(b){return cont(of_option(a, b));});
		                          });
		                }
		                function encode(id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (to_string$26, 0, id, cont);
		                }
		                return cont
		                        ([0, id$15, 0, [4, decode, encode, descriptor$1], 0]);
		               }
		               var letrec_function_context$104 = [];
		               function schema_versioned$56(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$104[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, xr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$104[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$104[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$104[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(x3);},
		                                  0,
		                                  0,
		                                  cst_default,
		                                  cst_Default,
		                                  x2,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(x1) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_gray,
		                                   "Gray",
		                                   x0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(xZ) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_brown,
		                                    "Brown",
		                                    xY,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(xX) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_orange,
		                                     "Orange",
		                                     xW,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(xV) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_yellow,
		                                      "Yellow",
		                                      xU,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(xT) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_green,
		                                       "Green",
		                                       xS,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(xR) : cont(0);
		},
		0,
		0,
		cst_blue,
		"Blue",
		xQ,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 === param ? cont(xP) : cont(0);
		 },
		 0,
		 0,
		 cst_purple,
		 "Purple",
		 xO,
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(8);},
		  function(param, cont){
		   return 8 === param ? cont(xN) : cont(0);
		  },
		  0,
		  0,
		  cst_pink,
		  "Pink",
		  xM,
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(9);},
		   function(param, cont){
		    return 9 === param ? cont(xL) : cont(0);
		   },
		   0,
		   0,
		   cst_red,
		   "Red",
		   xK,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(10);},
		    function(param, cont){
		     return 10 === param ? cont(xJ) : cont(0);
		    },
		    0,
		    0,
		    cst_gray_background,
		    "Gray_background",
		    xI,
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(11);},
		     function(param, cont){
		      return 11 === param ? cont(xH) : cont(0);
		     },
		     0,
		     0,
		     cst_brown_background,
		     "Brown_background",
		     xG,
		     0],
		    [0,
		     [0,
		      function(param, cont){return cont(12);},
		      function(param, cont){
		       return 12 === param ? cont(xF) : cont(0);
		      },
		      0,
		      0,
		      cst_orange_background,
		      "Orange_background",
		      xE,
		      0],
		     [0,
		      [0,
		       function(param, cont){return cont(13);},
		       function(param, cont){
		        return 13 === param ? cont(xD) : cont(0);
		       },
		       0,
		       0,
		       cst_yellow_background,
		       "Yellow_background",
		       xC,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(14);},
		        function(param, cont){
		         return 14 === param ? cont(xB) : cont(0);
		        },
		        0,
		        0,
		        cst_green_background,
		        "Green_background",
		        xA,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(15);},
		         function(param, cont){
		          return 15 === param ? cont(xz) : cont(0);
		         },
		         0,
		         0,
		         cst_blue_background,
		         "Blue_background",
		         xy,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(16);},
		          function(param, cont){
		           return 16 === param ? cont(xx) : cont(0);
		          },
		          0,
		          0,
		          cst_purple_background,
		          "Purple_background",
		          xw,
		          0],
		         [0,
		          [0,
		           function(param, cont){return cont(17);},
		           function(param, cont){
		            return 17 === param ? cont(xv) : cont(0);
		           },
		           0,
		           0,
		           cst_pink_background,
		           "Pink_background",
		           xu,
		           0],
		          [0,
		           [0,
		            function(param, cont){return cont(18);},
		            function(param, cont){
		             return 18 <= param ? cont(xt) : cont(0);
		            },
		            0,
		            0,
		            cst_red_background,
		            "Red_background",
		            xs,
		            0],
		           0]]]]]]]]]]]]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$104[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$104[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$142 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$104, [0, schematic_cache$142]);
		               caml_callback
		                (schema_versioned$56,
		                 [function(param, cont){return cont(0);}]);
		               function date_or_time_schema_versioned(param){
		                function decode(s, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_string$12,
		                          s,
		                          function(match){
		                           if(0 !== match[0])
		                            return caml_exact_trampoline_cps_call
		                                    (of_rfc3339$0,
		                                     s,
		                                     function(e){
		                                      if(0 !== e[0]) return cont(e);
		                                      var time = e[1];
		                                      return caml_trampoline_cps_call2
		      (of_string$14, [1, time], cont);
		                                     });
		                           var date = match[1];
		                           return caml_trampoline_cps_call2
		                                   (of_string$14, [0, date], cont);
		                          });
		                }
		                function encode(param, cont){
		                 if(0 === param[0]){
		                  var date = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (to_to_string, pp_v1$0, date, cont);
		                 }
		                 var t = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (to_rfc3339$0, 0, t, cont);
		                }
		                return [0, id$16, 0, [4, decode, encode, descriptor$1], 0];
		               }
		               var letrec_function_context$105 = [];
		               function schema_versioned$57(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$105[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, x4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$105[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$105[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$105[1][1] = a;
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_end,
		                               0,
		                               3,
		                               [0, date_or_time_schema_versioned()],
		                               0,
		                               0],
		                              0];
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var end = param[2][1], start = param[1];
		                                 return cont([0, start, end]);
		                                },
		                                function(param, cont){
		                                 var end = param[2], start = param[1];
		                                 return cont([0, start, [0, end, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_start,
		                                  0,
		                                  2,
		                                  [0, date_or_time_schema_versioned()],
		                                  0,
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$105[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$105[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$143 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$105, [0, schematic_cache$143]);
		               caml_callback
		                (schema_versioned$57,
		                 [function(param, cont){return cont(0);}]);
		               var schema$16 = caml_callback(schema_versioned$55, [dummy]);
		               function to_string$27(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_string$26, 0, s, cont);
		               }
		               function sexp_of_t$32(id, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$27, id, function(a){return cont([0, a]);});
		               }
		               function encode$6(str, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (pct_encode, 0, x5, str, cont);
		               }
		               function decode$4(str, cont){
		                return caml_exact_trampoline_cps_call
		                        (decode$0, str, function(x){return cont([0, x]);});
		               }
		               function Make$10(O){
		                var
		                 include = Make$2([0, compare_decoded, sexp_of_t$32]),
		                 equal = include[7],
		                 compare = include[8],
		                 comparator = include[16];
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        pp$28,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        schema_versioned$55,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        equal,
		                        compare,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        comparator];
		               }
		               var Database = Make$10(), Page = Make$10(), People = Make$10();
		               function schema_versioned$58(param){
		                return [0, id$17, 0, [4, decode$4, encode$6, 8], 0];
		               }
		               var
		                _2$3 = People[25],
		                e = People[62],
		                _2$4 = People[54],
		                _2$5 = People[53],
		                bPa = People[37],
		                _3$2 = Database[25],
		                b2 = Database[62],
		                _3$3 = Database[54],
		                _3$4 = Database[53],
		                du = Database[37],
		                dv = [];
		               function person_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dv[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, x6, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dv[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dv[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dv[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var email = param[1];
		                       return cont([0, email]);
		                      },
		                      function(param, cont){
		                       var email = param[1];
		                       return cont([0, email, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_email,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dv[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dv[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cst_avatar_url = "avatar_url", dw = [];
		               function people_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dw[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, x7, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dw[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dw[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(b){
		                  dw[1][1] = b;
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_avatar_url, 0, 3, [0, schema$268], 0, 0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_name,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$55,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  name = a[2][1],
		                                  avatar_url = a[1],
		                                  id = param[1];
		                                 return cont([0, id, avatar_url, name]);
		                                },
		                                function(param, cont){
		                                 var name = param[3], avatar_url = param[2], id = param[1];
		                                 return cont([0, id, [0, avatar_url, [0, name, 0]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dw[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dw[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                bQZ = Page[37],
		                schematic_cache$144 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dv, [0, schematic_cache$144]);
		               var schematic_cache$145 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dw, [0, schematic_cache$145]);
		               var
		                schematic_cache$146 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$106 = [];
		               caml_update_dummy
		                (letrec_function_context$106, [0, schematic_cache$146]);
		               var
		                person_schema =
		                  caml_callback
		                   (person_schema_versioned, [function(param){return 0;}]),
		                people_schema =
		                  caml_callback
		                   (people_schema_versioned, [function(param){return 0;}]);
		               function schematic_version$18(param){return 0;}
		               var cst_Person = "Person", schematic_schema_version$160 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$106[1][1],
		                    schematic_schema_version$160]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$106[1][1],
		                             schematic_schema_version$160,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$106[1][1],
		schematic_schema_version$160,
		schematic_self,
		function(a){
		 letrec_function_context$106[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$55,
		          schematic_version$18,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([2, f0]);},
		                function(param, cont){
		                 if(2 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                1,
		                0,
		                cst_unknown,
		                cst_Unknown,
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){var id = param[1]; return cont(id);},
		                  function(id, cont){return cont([0, id, 0]);},
		                  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		                 0],
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (people_schema_versioned,
		                    schematic_version$18,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([1, f0]);},
		                          function(param, cont){
		                           if(1 !== param[0]) return cont(0);
		                           var f0 = param[1];
		                           return cont([0, f0]);
		                          },
		                          0,
		                          0,
		                          cst_bot,
		                          "Bot",
		                          c,
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (person_schema_versioned,
		                              schematic_version$18,
		                              function(c){
		                               var
		                                a = [0, [0, 0, 0, 0, 0, cst_person, 0, 2, [0, c], 0, 0], 0];
		                               return caml_exact_trampoline_cps_call
		                                       (people_schema_versioned,
		schematic_version$18,
		function(c){
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){
		        var f1 = param[2], f0 = param[1];
		        return cont([0, f0, f1]);
		       },
		       function(param, cont){
		        if(0 !== param[0]) return cont(0);
		        var f1 = param[2], f0 = param[1];
		        return cont([0, [0, f0, f1]]);
		       },
		       1,
		       0,
		       cst_person,
		       cst_Person,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var person = param[2][1], people = param[1];
		          return cont([0, people, person]);
		         },
		         function(param, cont){
		          var person = param[2], people = param[1];
		          return cont([0, people, [0, person, 0]]);
		         },
		         [0, [0, 0, 0, 0, 0, cst_people, 0, 2, [1, c], 0, 0], a]],
		        0],
		       0],
		      b],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$106[1][1],
		          schematic_schema_version$160,
		          res,
		          function(a){
		           letrec_function_context$106[1][1] = a;
		           return cont(res);
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schema_versioned$59(b){
		                var
		                 descriptor =
		                   object
		                    (function(a, cont){return cont(a);},
		                     function(a, cont){return cont(a);},
		                     [0,
		                      field(0, 0, 0, 0, 0, 2, 0, 0, cst_id, [0, schema$16]),
		                      0]),
		                 b =
		                   [0,
		                    case$
		                     (function(param, cont){
		                       var id = param[1];
		                       return cont([2, id]);
		                      },
		                      function(param, cont){
		                       if(2 !== param[0]) return cont(0);
		                       var id = param[1];
		                       return cont([0, [0, id, 0]]);
		                      },
		                      0,
		                      0,
		                      0,
		                      cst_unknown,
		                      [0, 0, 0, descriptor, 0]),
		                    0],
		                 a =
		                   [0,
		                    field
		                     (0, 0, 0, 0, 0, 2, 0, 0, cst_people, [1, people_schema]),
		                    0],
		                 descriptor$0 =
		                   object
		                    (function(a, cont){return cont(a);},
		                     function(a, cont){return cont(a);},
		                     [0,
		                      field
		                       (0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        2,
		                        0,
		                        0,
		                        cst_type,
		                        [0, [0, 0, 0, [9, cst_bot], 0]]),
		                      a]),
		                 b =
		                   [0,
		                    case$
		                     (function(param, cont){
		                       var f0 = param[2][1];
		                       return cont([1, f0]);
		                      },
		                      function(param, cont){
		                       if(1 !== param[0]) return cont(0);
		                       var f0 = param[1];
		                       return cont([0, [0, 0, [0, f0, 0]]]);
		                      },
		                      0,
		                      0,
		                      0,
		                      cst_bot,
		                      [0, 0, 0, descriptor$0, 0]),
		                    b],
		                 a =
		                   [0,
		                    field
		                     (0, 0, 0, 0, 0, 2, 0, 0, cst_person, [0, person_schema]),
		                    0],
		                 a =
		                   [0,
		                    field
		                     (0, 0, 0, 0, 0, 2, 0, 0, cst_people, [1, people_schema]),
		                    a],
		                 descriptor$1 =
		                   object
		                    (function(a, cont){
		                      a = a[2];
		                      var person = a[2][1], people = a[1];
		                      return cont([0, 0, people, person]);
		                     },
		                     function(param, cont){
		                      var person = param[3], people = param[2];
		                      return cont([0, 0, [0, people, [0, person, 0]]]);
		                     },
		                     [0,
		                      field
		                       (0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        2,
		                        0,
		                        0,
		                        cst_type,
		                        [0, [0, 0, 0, [9, cst_person], 0]]),
		                      a]),
		                 descriptor$2 =
		                   union$2
		                    (0,
		                     [0,
		                      case$
		                       (function(param, cont){
		                         var f1 = param[3], f0 = param[2];
		                         return cont([0, f0, f1]);
		                        },
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, [0, 0, f0, f1]]);
		                        },
		                        0,
		                        0,
		                        0,
		                        cst_person,
		                        [0, 0, 0, descriptor$1, 0]),
		                      b]);
		                return [0, id$18, 0, descriptor$2, 0];
		               }
		               schema_versioned$59();
		               var letrec_function_context$107 = [];
		               function database_reference_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$107[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, x8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$107[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$107[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$107[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (du,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$107[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$107[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$147 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$107, [0, schematic_cache$147]);
		               caml_callback
		                (database_reference_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$108 = [];
		               function page_reference_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$108[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, x9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$108[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$108[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$108[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (bQZ,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$108[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$108[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$148 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$108, [0, schematic_cache$148]);
		               caml_callback
		                (page_reference_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var cst_href = "href", cst_plain_text = "plain_text", dx = [];
		               function common_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dx[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, x_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dx[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dx[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            dx[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_href, 0, 3, [0, schema$268], 0, 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_plain_text,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (annotations_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    plain_text = a[2][1],
		    href = a[1],
		    annotations = param[1];
		   return cont([0, annotations, href, plain_text]);
		  },
		  function(param, cont){
		   var
		    plain_text = param[3],
		    href = param[2],
		    annotations = param[1];
		   return cont([0, annotations, [0, href, [0, plain_text, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_annotations, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dx[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dx[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var dy = [];
		               function annotations_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dy[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, x$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dy[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dy[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            dy[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, "italic", 0, 2, [0, bool_schema], 0, 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "strikethrough",
		                                  0,
		                                  2,
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, "underline", 0, 2, [0, bool_schema], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$56,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    underline = d[2][1],
		    strikethrough = d[1],
		    italic = c[1],
		    color = b[1],
		    code = a[1],
		    bold = param[1];
		   return cont
		           ([0, bold, code, color, italic, strikethrough, underline]);
		  },
		  function(param, cont){
		   var
		    underline = param[6],
		    strikethrough = param[5],
		    italic = param[4],
		    color = param[3],
		    code = param[2],
		    bold = param[1];
		   return cont
		           ([0,
		             bold,
		             [0,
		              code,
		              [0,
		               color,
		               [0, italic, [0, strikethrough, [0, underline, 0]]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, "bold", 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0, 0, 0, 0, 0, cst_code, 0, 2, [0, bool_schema], 0, 0],
		    [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, b], 0, 0], a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dy[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dy[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var dz = [];
		               function text_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dz[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ya, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dz[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dz[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dz[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (link_schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var link = param[2][1], content = param[1];
		   return cont([0, content, link]);
		  },
		  function(param, cont){
		   var link = param[2], content = param[1];
		   return cont([0, content, [0, link, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_content,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_link, 0, 3, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dz[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dz[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_expression = "expression", dA = [];
		               function equation_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dA[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yb, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dA[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dA[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dA[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var expression = param[1];
		                                 return cont([0, expression]);
		                                },
		                                function(param, cont){
		                                 var expression = param[1];
		                                 return cont([0, expression, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_expression,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dA[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dA[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var dB = [];
		               function link_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dB[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dB[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dB[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dB[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var url = param[1];
		                                 return cont([0, url]);
		                                },
		                                function(param, cont){
		                                 var url = param[1];
		                                 return cont([0, url, 0]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$268], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dB[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dB[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Database = "Database",
		                cst_Page = "Page",
		                cst_database = "database",
		                dC = [];
		               function mention_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dC[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yd, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dC[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dC[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            dC[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_user,
		                                 cst_User,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var user = param[1];
		                                    return cont(user);
		                                   },
		                                   function(user, cont){return cont([0, user, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_user,
		                                     0,
		                                     2,
		                                     [0, schema_versioned$59(schematic_version)],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (page_reference_schema_versione,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_page,
		   cst_Page,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var page = param[1];
		      return cont(page);
		     },
		     function(page, cont){return cont([0, page, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_page, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$57,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_date,
		             cst_Date,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var date = param[1];
		                return cont(date);
		               },
		               function(date, cont){return cont([0, date, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_date, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (database_reference_schema_vers,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        0,
		                        cst_database,
		                        cst_Database,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var database = param[1];
		                           return cont(database);
		                          },
		                          function(database, cont){return cont([0, database, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_database, 0, 2, [0, b], 0, 0], 0]],
		                         0],
		                        0],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dC[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dC[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Mention = "Mention",
		                cst_Text = "Text",
		                letrec_function_context$109 = [];
		               function schema_versioned$60(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$109[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ye, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$109[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$109[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$109[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (text_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_text, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (common_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([2, f0, f1]);
		             },
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_text,
		             cst_Text,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var text = param[2][1], common = param[1];
		                return cont([0, common, text]);
		               },
		               function(param, cont){
		                var text = param[2], common = param[1];
		                return cont([0, common, [0, text, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, c], 0, 0], a]],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (mention_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_mention, 0, 2, [0, c], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (common_schema_versioned$0,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([1, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_mention,
		                                 cst_Mention,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var mention = param[2][1], common = param[1];
		                                    return cont([0, common, mention]);
		                                   },
		                                   function(param, cont){
		                                    var mention = param[2], common = param[1];
		                                    return cont([0, common, [0, mention, 0]]);
		                                   },
		                                   [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, d], 0, 0], a]],
		                                  0],
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (equation_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_equation, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (common_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, f0, f1]);
		              },
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              },
		              1,
		              0,
		              cst_equation,
		              "Equation",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var equation = param[2][1], common = param[1];
		                 return cont([0, common, equation]);
		                },
		                function(param, cont){
		                 var equation = param[2], common = param[1];
		                 return cont([0, common, [0, equation, 0]]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, b], 0, 0], a]],
		               0],
		              0],
		             c],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$109[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$109[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$149 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dx, [0, schematic_cache$149]);
		               var schematic_cache$150 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dy, [0, schematic_cache$150]);
		               var schematic_cache$151 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dz, [0, schematic_cache$151]);
		               var schematic_cache$152 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dA, [0, schematic_cache$152]);
		               var schematic_cache$153 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dB, [0, schematic_cache$153]);
		               var schematic_cache$154 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dC, [0, schematic_cache$154]);
		               var schematic_cache$155 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$109, [0, schematic_cache$155]);
		               caml_callback
		                (common_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (annotations_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (text_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (equation_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (link_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (mention_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (schema_versioned$60,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Created_time = "Created_time",
		                cst_Last_edited_time = "Last_edited_time",
		                cst_People = "People",
		                cst_Relation = "Relation",
		                cst_Select = "Select",
		                cst_Status = "Status",
		                cst_Url = "Url",
		                cst_multi_select = "multi_select",
		                cst_peoples = "peoples";
		               function content_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_checkbox_schem,
		                                    schematic_param_date_schema_ve,
		                                    schematic_param_email_schema_v,
		                                    schematic_param_file_schema_ve,
		                                    schematic_param_formula_schema,
		                                    schematic_param_number_schema_,
		                                    schematic_param_people_schema_,
		                                    schematic_param_peoples_schema,
		                                    schematic_param_phone_schema_v,
		                                    schematic_param_relation_schem,
		                                    schematic_param_rollup_schema_,
		                                    schematic_param_select_schema_,
		                                    schematic_param_status_schema_,
		                                    schematic_param_multi_select_s,
		                                    schematic_param_text_schema_ve,
		                                    schematic_param_time_schema_ve,
		                                    schematic_param_title_schema_v,
		                                    schematic_param_url_schema_ver,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_checkbox_schem,
		                                     schematic_param_date_schema_ve,
		                                     schematic_param_email_schema_v,
		                                     schematic_param_file_schema_ve,
		                                     schematic_param_formula_schema,
		                                     schematic_param_number_schema_,
		                                     schematic_param_people_schema_,
		                                     schematic_param_peoples_schema,
		                                     schematic_param_phone_schema_v,
		                                     schematic_param_relation_schem,
		                                     schematic_param_rollup_schema_,
		                                     schematic_param_select_schema_,
		                                     schematic_param_status_schema_,
		                                     schematic_param_multi_select_s,
		                                     schematic_param_text_schema_ve,
		                                     schematic_param_time_schema_ve,
		                                     schematic_param_title_schema_v,
		                                     schematic_param_url_schema_ver){
		                                     var
		                                      cst_created_by = "created_by",
		                                      cst_last_edited_by = "last_edited_by",
		                                      cst_rich_text = "rich_text";
		                                     return [11,
		     yg,
		     [0,
		      [0,
		       function(f0, cont){return cont([0, f0]);},
		       function(param, cont){
		        if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		        return cont(0);
		       },
		       1,
		       0,
		       cst_checkbox,
		       cst_Checkbox,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var checkbox = param[1];
		          return cont(checkbox);
		         },
		         function(checkbox, cont){return cont([0, checkbox, 0]);},
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_checkbox,
		           0,
		           2,
		           [0, schematic_param_checkbox_schem],
		           0,
		           0],
		          0]],
		        0],
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		         return cont(0);
		        },
		        1,
		        0,
		        cst_created_by,
		        "Created_by",
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){
		           var created_by = param[1];
		           return cont(created_by);
		          },
		          function(created_by, cont){return cont([0, created_by, 0]);},
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_created_by,
		            0,
		            2,
		            [0, schematic_param_people_schema_],
		            0,
		            0],
		           0]],
		         0],
		        0],
		       [0,
		        [0,
		         function(f0, cont){return cont([2, f0]);},
		         function(param, cont){
		          if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		          return cont(0);
		         },
		         1,
		         0,
		         cst_created_time,
		         cst_Created_time,
		         [0,
		          0,
		          0,
		          [7,
		           function(param, cont){
		            var created_time = param[1];
		            return cont(created_time);
		           },
		           function(created_time, cont){
		            return cont([0, created_time, 0]);
		           },
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_created_time,
		             0,
		             2,
		             [0, schematic_param_time_schema_ve],
		             0,
		             0],
		            0]],
		          0],
		         0],
		        [0,
		         [0,
		          function(f0, cont){return cont([3, f0]);},
		          function(param, cont){
		           if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		           return cont(0);
		          },
		          1,
		          0,
		          cst_date,
		          cst_Date,
		          [0,
		           0,
		           0,
		           [7,
		            function(param, cont){
		             var date = param[1];
		             return cont(date);
		            },
		            function(date, cont){return cont([0, date, 0]);},
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_date,
		              0,
		              2,
		              [0, schematic_param_date_schema_ve],
		              0,
		              0],
		             0]],
		           0],
		          0],
		         [0,
		          [0,
		           function(f0, cont){return cont([4, f0]);},
		           function(param, cont){
		            if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		            return cont(0);
		           },
		           1,
		           0,
		           cst_email,
		           cst_Email,
		           [0,
		            0,
		            0,
		            [7,
		             function(param, cont){
		              var email = param[1];
		              return cont(email);
		             },
		             function(email, cont){return cont([0, email, 0]);},
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_email,
		               0,
		               2,
		               [0, schematic_param_email_schema_v],
		               0,
		               0],
		              0]],
		            0],
		           0],
		          [0,
		           [0,
		            function(f0, cont){return cont([5, f0]);},
		            function(param, cont){
		             if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		             return cont(0);
		            },
		            1,
		            0,
		            "files",
		            "Files",
		            [0,
		             0,
		             0,
		             [7,
		              function(param, cont){var id = param[1]; return cont(id);},
		              function(id, cont){return cont([0, id, 0]);},
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_id,
		                0,
		                2,
		                [0, schematic_param_file_schema_ve],
		                0,
		                0],
		               0]],
		             0],
		            0],
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_formula,
		             "Formula",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var formula = param[1];
		                return cont(formula);
		               },
		               function(formula, cont){return cont([0, formula, 0]);},
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_formula,
		                 0,
		                 2,
		                 [0, schematic_param_formula_schema],
		                 0,
		                 0],
		                0]],
		              0],
		             0],
		            [0,
		             [0,
		              function(f0, cont){return cont([7, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_last_edited_by,
		              "Last_edited_by",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var last_edited_by = param[1];
		                 return cont(last_edited_by);
		                },
		                function(last_edited_by, cont){
		                 return cont([0, last_edited_by, 0]);
		                },
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_last_edited_by,
		                  0,
		                  2,
		                  [0, schematic_param_people_schema_],
		                  0,
		                  0],
		                 0]],
		               0],
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([8, f0]);},
		               function(param, cont){
		                if(typeof param !== "number" && 8 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                return cont(0);
		               },
		               1,
		               0,
		               cst_last_edited_time,
		               cst_Last_edited_time,
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var last_edited_time = param[1];
		                  return cont(last_edited_time);
		                 },
		                 function(last_edited_time, cont){
		                  return cont([0, last_edited_time, 0]);
		                 },
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_last_edited_time,
		                   0,
		                   2,
		                   [0, schematic_param_time_schema_ve],
		                   0,
		                   0],
		                  0]],
		                0],
		               0],
		              [0,
		               [0,
		                function(f0, cont){return cont([9, f0]);},
		                function(param, cont){
		                 if(typeof param !== "number" && 9 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                 return cont(0);
		                },
		                1,
		                0,
		                cst_multi_select,
		                "Multi_select",
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var multi_select = param[1];
		                   return cont(multi_select);
		                  },
		                  function(multi_select, cont){
		                   return cont([0, multi_select, 0]);
		                  },
		                  [0,
		                   [0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    cst_multi_select,
		                    0,
		                    2,
		                    [0, schematic_param_multi_select_s],
		                    0,
		                    0],
		                   0]],
		                 0],
		                0],
		               [0,
		                [0,
		                 function(f0, cont){return cont([10, f0]);},
		                 function(param, cont){
		                  if(typeof param !== "number" && 10 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                  return cont(0);
		                 },
		                 1,
		                 0,
		                 cst_number,
		                 cst_Number,
		                 [0,
		                  0,
		                  0,
		                  [7,
		                   function(param, cont){
		                    var number = param[1];
		                    return cont(number);
		                   },
		                   function(number, cont){return cont([0, number, 0]);},
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     cst_number,
		                     0,
		                     2,
		                     [0, schematic_param_number_schema_],
		                     0,
		                     0],
		                    0]],
		                  0],
		                 0],
		                [0,
		                 [0,
		                  function(f0, cont){return cont([11, f0]);},
		                  function(param, cont){
		                   if(typeof param !== "number" && 11 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                   return cont(0);
		                  },
		                  1,
		                  0,
		                  cst_people,
		                  cst_People,
		                  [0,
		                   0,
		                   0,
		                   [7,
		                    function(param, cont){
		                     var people = param[1];
		                     return cont(people);
		                    },
		                    function(people, cont){return cont([0, people, 0]);},
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_people,
		                      0,
		                      2,
		                      [0, schematic_param_peoples_schema],
		                      0,
		                      0],
		                     0]],
		                   0],
		                  0],
		                 [0,
		                  [0,
		                   function(f0, cont){return cont([12, f0]);},
		                   function(param, cont){
		                    if(typeof param !== "number" && 12 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                    return cont(0);
		                   },
		                   1,
		                   0,
		                   cst_phone_number,
		                   "Phone_number",
		                   [0,
		                    0,
		                    0,
		                    [7,
		                     function(param, cont){
		                      var phone_number = param[1];
		                      return cont(phone_number);
		                     },
		                     function(phone_number, cont){
		                      return cont([0, phone_number, 0]);
		                     },
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_phone_number,
		                       0,
		                       2,
		                       [0, schematic_param_phone_schema_v],
		                       0,
		                       0],
		                      0]],
		                    0],
		                   0],
		                  [0,
		                   [0,
		                    function(f0, cont){return cont([13, f0]);},
		                    function(param, cont){
		                     if(typeof param !== "number" && 13 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                     return cont(0);
		                    },
		                    1,
		                    0,
		                    cst_relation,
		                    cst_Relation,
		                    [0,
		                     0,
		                     0,
		                     [7,
		                      function(param, cont){
		                       var relation = param[1];
		                       return cont(relation);
		                      },
		                      function(relation, cont){return cont([0, relation, 0]);},
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_relation,
		                        0,
		                        2,
		                        [0, schematic_param_relation_schem],
		                        0,
		                        0],
		                       0]],
		                     0],
		                    0],
		                   [0,
		                    [0,
		                     function(f0, cont){return cont([14, f0]);},
		                     function(param, cont){
		                      if(typeof param !== "number" && 14 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                      return cont(0);
		                     },
		                     1,
		                     0,
		                     cst_rollup,
		                     "Rollup",
		                     [0,
		                      0,
		                      0,
		                      [7,
		                       function(param, cont){
		                        var rollup = param[1];
		                        return cont(rollup);
		                       },
		                       function(rollup, cont){return cont([0, rollup, 0]);},
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_rollup,
		                         0,
		                         2,
		                         [0, schematic_param_rollup_schema_],
		                         0,
		                         0],
		                        0]],
		                      0],
		                     0],
		                    [0,
		                     [0,
		                      function(f0, cont){return cont([15, f0]);},
		                      function(param, cont){
		                       if(typeof param !== "number" && 15 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                       return cont(0);
		                      },
		                      1,
		                      0,
		                      cst_select,
		                      cst_Select,
		                      [0,
		                       0,
		                       0,
		                       [7,
		                        function(param, cont){
		                         var select = param[1];
		                         return cont(select);
		                        },
		                        function(select, cont){return cont([0, select, 0]);},
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_select,
		                          0,
		                          2,
		                          [0, schematic_param_select_schema_],
		                          0,
		                          0],
		                         0]],
		                       0],
		                      0],
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([16, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 16 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_status,
		                       cst_Status,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var status = param[1];
		                          return cont(status);
		                         },
		                         function(status, cont){return cont([0, status, 0]);},
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_status,
		                           0,
		                           2,
		                           [0, schematic_param_status_schema_],
		                           0,
		                           0],
		                          0]],
		                        0],
		                       0],
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([17, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 17 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        1,
		                        0,
		                        cst_rich_text,
		                        "Rich_text",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var rich_text = param[1];
		                           return cont(rich_text);
		                          },
		                          function(rich_text, cont){return cont([0, rich_text, 0]);},
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_rich_text,
		                            0,
		                            2,
		                            [0, schematic_param_text_schema_ve],
		                            0,
		                            0],
		                           0]],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([18, f0]);},
		                         function(param, cont){
		                          if(typeof param !== "number" && 18 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_title,
		                         cst_Title,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var title = param[1];
		                            return cont(title);
		                           },
		                           function(title, cont){return cont([0, title, 0]);},
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_title,
		                             0,
		                             2,
		                             [0, schematic_param_title_schema_v],
		                             0,
		                             0],
		                            0]],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([19, f0]);},
		                          function(param, cont){
		                           if(typeof param !== "number" && 19 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                           return cont(0);
		                          },
		                          1,
		                          0,
		                          cst_url,
		                          cst_Url,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){var url = param[1]; return cont(url);},
		                            function(url, cont){return cont([0, url, 0]);},
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              cst_url,
		                              0,
		                              2,
		                              [0, schematic_param_url_schema_ver],
		                              0,
		                              0],
		                             0]],
		                           0],
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(0);},
		                           function(param, cont){
		                            return typeof param === "number" ? cont(yf) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_unknown,
		                           cst_Unknown,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){return cont(0);},
		                             function(param, cont){return cont(0);},
		                             0],
		                            0],
		                           0],
		                          0]]]]]]]]]]]]]]]]]]]]],
		     0];
		                                    }
		                                    var
		                                     schematic_schema_id = match$98[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_checkbox,
		 schematic_param_checkbox_schem,
		 function(schematic_param_checkbox_schem, cont){
		  return cont
		          ([1,
		            cst_date,
		            schematic_param_date_schema_ve,
		            function(schematic_param_date_schema_ve, cont){
		             return cont
		                     ([1,
		                       cst_email,
		                       schematic_param_email_schema_v,
		                       function(schematic_param_email_schema_v, cont){
		                        return cont
		                                ([1,
		                                  cst_file,
		                                  schematic_param_file_schema_ve,
		                                  function(schematic_param_file_schema_ve, cont){
		                                   return cont
		   ([1,
		     cst_formula,
		     schematic_param_formula_schema,
		     function(schematic_param_formula_schema, cont){
		      return cont
		              ([1,
		                cst_number,
		                schematic_param_number_schema_,
		                function(schematic_param_number_schema_, cont){
		                 return cont
		                         ([1,
		                           cst_people,
		                           schematic_param_people_schema_,
		                           function(schematic_param_people_schema_, cont){
		                            return cont
		                                    ([1,
		                                      cst_peoples,
		                                      schematic_param_peoples_schema,
		                                      function(schematic_param_peoples_schema, cont){
		                                       return cont
		       ([1,
		         cst_phone,
		         schematic_param_phone_schema_v,
		         function(schematic_param_phone_schema_v, cont){
		          return cont
		                  ([1,
		                    cst_relation,
		                    schematic_param_relation_schem,
		                    function(schematic_param_relation_schem, cont){
		                     return cont
		                             ([1,
		                               cst_rollup,
		                               schematic_param_rollup_schema_,
		                               function(schematic_param_rollup_schema_, cont){
		                                return cont
		([1,
		  cst_select,
		  schematic_param_select_schema_,
		  function(schematic_param_select_schema_, cont){
		   return cont
		           ([1,
		             cst_status,
		             schematic_param_status_schema_,
		             function(schematic_param_status_schema_, cont){
		              return cont
		                      ([1,
		                        cst_multi_select,
		                        schematic_param_multi_select_s,
		                        function(schematic_param_multi_select_s, cont){
		                         return cont
		                                 ([1,
		                                   cst_text,
		                                   schematic_param_text_schema_ve,
		                                   function(schematic_param_text_schema_ve, cont){
		                                    return cont
		    ([1,
		      cst_time,
		      schematic_param_time_schema_ve,
		      function(schematic_param_time_schema_ve, cont){
		       return cont
		               ([1,
		                 cst_title,
		                 schematic_param_title_schema_v,
		                 function(schematic_param_title_schema_v, cont){
		                  return cont
		                          ([1,
		                            cst_url,
		                            schematic_param_url_schema_ver,
		                            function(schematic_param_url_schema_ver, cont){
		                             return cont
		                                     ([0,
		                                       schematic_schema_id,
		                                       descriptor
		(schematic_param_checkbox_schem,
		 schematic_param_date_schema_ve,
		 schematic_param_email_schema_v,
		 schematic_param_file_schema_ve,
		 schematic_param_formula_schema,
		 schematic_param_number_schema_,
		 schematic_param_people_schema_,
		 schematic_param_peoples_schema,
		 schematic_param_phone_schema_v,
		 schematic_param_relation_schem,
		 schematic_param_rollup_schema_,
		 schematic_param_select_schema_,
		 schematic_param_status_schema_,
		 schematic_param_multi_select_s,
		 schematic_param_text_schema_ve,
		 schematic_param_time_schema_ve,
		 schematic_param_title_schema_v,
		 schematic_param_url_schema_ver)]);
		                            }]);
		                 }]);
		      }]);
		                                   }]);
		                        }]);
		             }]);
		  }]);
		                               }]);
		                    }]);
		         }]);
		                                      }]);
		                           }]);
		                }]);
		     }]);
		                                  }]);
		                       }]);
		            }]);
		 }]],
		                                     a =
		                                       descriptor
		(schematic_param_checkbox_schem,
		 schematic_param_date_schema_ve,
		 schematic_param_email_schema_v,
		 schematic_param_file_schema_ve,
		 schematic_param_formula_schema,
		 schematic_param_number_schema_,
		 schematic_param_people_schema_,
		 schematic_param_peoples_schema,
		 schematic_param_phone_schema_v,
		 schematic_param_relation_schem,
		 schematic_param_rollup_schema_,
		 schematic_param_select_schema_,
		 schematic_param_status_schema_,
		 schematic_param_multi_select_s,
		 schematic_param_text_schema_ve,
		 schematic_param_time_schema_ve,
		 schematic_param_title_schema_v,
		 schematic_param_url_schema_ver),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, 0, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$110 = [];
		               function unknown_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$110[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$110[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$110[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$110[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var id = param[1];
		                                 return cont([0, id]);
		                                },
		                                function(param, cont){
		                                 var id = param[1];
		                                 return cont([0, id, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_id,
		                                  0,
		                                  2,
		                                  [0, schema_versioned$58()],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$110[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$110[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$156 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$110, [0, schematic_cache$156]);
		               caml_callback
		                (unknown_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$61
		               (schematic_version,
		                schematic_param_checkbox_schem,
		                schematic_param_date_schema_ve,
		                schematic_param_email_schema_v,
		                schematic_param_file_schema_ve,
		                schematic_param_formula_schema,
		                schematic_param_number_schema_,
		                schematic_param_people_schema_,
		                schematic_param_peoples_schema,
		                schematic_param_phone_schema_v,
		                schematic_param_relation_schem,
		                schematic_param_rollup_schema_,
		                schematic_param_select_schema_,
		                schematic_param_status_schema_,
		                schematic_param_multi_select_s,
		                schematic_param_text_schema_ve,
		                schematic_param_time_schema_ve,
		                schematic_param_title_schema_v,
		                schematic_param_url_schema_ver,
		                cont){
		                o
		                 ([0,
		                   symbol_bind$4,
		                   symbol_map$4,
		                   Let_syntax$2,
		                   ,
		                   bind$6,
		                   of_string$14,
		                   map$15]);
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          function descriptor
		                          (schematic_param_checkbox_schem,
		                           schematic_param_date_schema_ve,
		                           schematic_param_email_schema_v,
		                           schematic_param_file_schema_ve,
		                           schematic_param_formula_schema,
		                           schematic_param_number_schema_,
		                           schematic_param_people_schema_,
		                           schematic_param_peoples_schema,
		                           schematic_param_phone_schema_v,
		                           schematic_param_relation_schem,
		                           schematic_param_rollup_schema_,
		                           schematic_param_select_schema_,
		                           schematic_param_status_schema_,
		                           schematic_param_multi_select_s,
		                           schematic_param_text_schema_ve,
		                           schematic_param_time_schema_ve,
		                           schematic_param_title_schema_v,
		                           schematic_param_url_schema_ver,
		                           cont){
		                           var
		                            a =
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_id,
		                                0,
		                                2,
		                                [0, schema_versioned$58()],
		                                0,
		                                0],
		                               0];
		                           return caml_exact_trampoline_cps_call
		                                   (content_schema_versioned,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$10
		     (b,
		      schematic_param_checkbox_schem,
		      schematic_param_date_schema_ve,
		      schematic_param_email_schema_v,
		      schematic_param_file_schema_ve,
		      schematic_param_formula_schema,
		      schematic_param_number_schema_,
		      schematic_param_people_schema_,
		      schematic_param_peoples_schema,
		      schematic_param_phone_schema_v,
		      schematic_param_relation_schem,
		      schematic_param_rollup_schema_,
		      schematic_param_select_schema_,
		      schematic_param_status_schema_,
		      schematic_param_multi_select_s,
		      schematic_param_text_schema_ve,
		      schematic_param_time_schema_ve,
		      schematic_param_title_schema_v,
		      schematic_param_url_schema_ver,
		      function(b){
		       return cont
		               ([7,
		                 function(param, cont){
		                  var id = param[2][1], content = param[1];
		                  return cont([0, content, id]);
		                 },
		                 function(param, cont){
		                  var id = param[2], content = param[1];
		                  return cont([0, content, [0, id, 0]]);
		                 },
		                 [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, b], 0, 0], a]]);
		      });
		                                    });
		                          }
		                          var
		                           schematic_schema_id = match$99[1],
		                           schematic_parametric =
		                             [0,
		                              [1,
		                               cst_checkbox,
		                               schematic_param_checkbox_schem,
		                               function(schematic_param_checkbox_schem, cont){
		                                return cont
		([1,
		  cst_date,
		  schematic_param_date_schema_ve,
		  function(schematic_param_date_schema_ve, cont){
		   return cont
		           ([1,
		             cst_email,
		             schematic_param_email_schema_v,
		             function(schematic_param_email_schema_v, cont){
		              return cont
		                      ([1,
		                        cst_file,
		                        schematic_param_file_schema_ve,
		                        function(schematic_param_file_schema_ve, cont){
		                         return cont
		                                 ([1,
		                                   cst_formula,
		                                   schematic_param_formula_schema,
		                                   function(schematic_param_formula_schema, cont){
		                                    return cont
		    ([1,
		      cst_number,
		      schematic_param_number_schema_,
		      function(schematic_param_number_schema_, cont){
		       return cont
		               ([1,
		                 cst_people,
		                 schematic_param_people_schema_,
		                 function(schematic_param_people_schema_, cont){
		                  return cont
		                          ([1,
		                            cst_peoples,
		                            schematic_param_peoples_schema,
		                            function(schematic_param_peoples_schema, cont){
		                             return cont
		                                     ([1,
		                                       cst_phone,
		                                       schematic_param_phone_schema_v,
		                                       function(schematic_param_phone_schema_v, cont){
		return cont
		        ([1,
		          cst_relation,
		          schematic_param_relation_schem,
		          function(schematic_param_relation_schem, cont){
		           return cont
		                   ([1,
		                     cst_rollup,
		                     schematic_param_rollup_schema_,
		                     function(schematic_param_rollup_schema_, cont){
		                      return cont
		                              ([1,
		                                cst_select,
		                                schematic_param_select_schema_,
		                                function(schematic_param_select_schema_, cont){
		                                 return cont
		 ([1,
		   cst_status,
		   schematic_param_status_schema_,
		   function(schematic_param_status_schema_, cont){
		    return cont
		            ([1,
		              cst_multi_select,
		              schematic_param_multi_select_s,
		              function(schematic_param_multi_select_s, cont){
		               return cont
		                       ([1,
		                         cst_text,
		                         schematic_param_text_schema_ve,
		                         function(schematic_param_text_schema_ve, cont){
		                          return cont
		                                  ([1,
		                                    cst_time,
		                                    schematic_param_time_schema_ve,
		                                    function(schematic_param_time_schema_ve, cont){
		                                     return cont
		     ([1,
		       cst_title,
		       schematic_param_title_schema_v,
		       function(schematic_param_title_schema_v, cont){
		        return cont
		                ([1,
		                  cst_url,
		                  schematic_param_url_schema_ver,
		                  function(schematic_param_url_schema_ver, cont){
		                   return caml_exact_trampoline_cps_call$10
		                           (descriptor,
		                            schematic_param_checkbox_schem,
		                            schematic_param_date_schema_ve,
		                            schematic_param_email_schema_v,
		                            schematic_param_file_schema_ve,
		                            schematic_param_formula_schema,
		                            schematic_param_number_schema_,
		                            schematic_param_people_schema_,
		                            schematic_param_peoples_schema,
		                            schematic_param_phone_schema_v,
		                            schematic_param_relation_schem,
		                            schematic_param_rollup_schema_,
		                            schematic_param_select_schema_,
		                            schematic_param_status_schema_,
		                            schematic_param_multi_select_s,
		                            schematic_param_text_schema_ve,
		                            schematic_param_time_schema_ve,
		                            schematic_param_title_schema_v,
		                            schematic_param_url_schema_ver,
		                            function(a){return cont([0, schematic_schema_id, a]);});
		                  }]);
		       }]);
		                                    }]);
		                         }]);
		              }]);
		   }]);
		                                }]);
		                     }]);
		          }]);
		                                       }]);
		                            }]);
		                 }]);
		      }]);
		                                   }]);
		                        }]);
		             }]);
		  }]);
		                               }]];
		                          return caml_exact_trampoline_cps_call$10
		                                  (descriptor,
		                                   schematic_param_checkbox_schem,
		                                   schematic_param_date_schema_ve,
		                                   schematic_param_email_schema_v,
		                                   schematic_param_file_schema_ve,
		                                   schematic_param_formula_schema,
		                                   schematic_param_number_schema_,
		                                   schematic_param_people_schema_,
		                                   schematic_param_peoples_schema,
		                                   schematic_param_phone_schema_v,
		                                   schematic_param_relation_schem,
		                                   schematic_param_rollup_schema_,
		                                   schematic_param_select_schema_,
		                                   schematic_param_status_schema_,
		                                   schematic_param_multi_select_s,
		                                   schematic_param_text_schema_ve,
		                                   schematic_param_time_schema_ve,
		                                   schematic_param_title_schema_v,
		                                   schematic_param_url_schema_ver,
		                                   function(a){
		                                    var parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       var known = [0, b, 0, a, schematic_parametric];
		       return caml_exact_trampoline_cps_call
		               (unknown_schema_versioned,
		                schematic_version,
		                function(a){
		                 a =
		                  [0,
		                   case$
		                    (function(param, cont){
		                      var id = param[1];
		                      return cont([0, 0, id]);
		                     },
		                     function(param, cont){return cont(0);},
		                     0,
		                     0,
		                     0,
		                     cst_unknown,
		                     a),
		                   0];
		                 var
		                  descriptor =
		                    union$2
		                     (0,
		                      [0,
		                       case$
		                        (function(a, cont){return cont(a);},
		                         return$9,
		                         0,
		                         0,
		                         0,
		                         cst_known,
		                         known),
		                       a]),
		                  parametric = known[4];
		                 return cont([0, , , descriptor, parametric]);
		                });
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$111 = [];
		               function patch_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$111[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yi, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$111[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$111[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$111[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var id = param[1];
		                                 return cont([0, id]);
		                                },
		                                function(param, cont){
		                                 var id = param[1];
		                                 return cont([0, id, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$111[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$111[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$157 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$111, [0, schematic_cache$157]);
		               caml_callback
		                (patch_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$112 = [];
		               function schema_versioned$62(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$112[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yj, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$112[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$112[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$112[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_id,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$56,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    name = a[2][1],
		    id = a[1],
		    color = param[1];
		   return cont([0, color, id, name]);
		  },
		  function(param, cont){
		   var name = param[3], id = param[2], color = param[1];
		   return cont([0, color, [0, id, [0, name, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$112[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$112[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$158 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$112, [0, schematic_cache$158]);
		               caml_callback
		                (schema_versioned$62,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$113 = [];
		               function schema_versioned$63(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$113[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yk, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$113[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$113[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$113[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$62,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var options = param[1];
		   return cont([0, options]);
		  },
		  function(param, cont){
		   var options = param[1];
		   return cont([0, options, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_options,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$113[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$113[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$159 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$113, [0, schematic_cache$159]);
		               caml_callback
		                (schema_versioned$63,
		                 [function(param, cont){return cont(0);}]);
		               var dD = [];
		               function group_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dD[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yl, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dD[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dD[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            dD[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_id,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "option_ids",
		                                   0,
		                                   2,
		                                   [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$56,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    option_ids = b[2][1],
		    name = b[1],
		    group_id = a[1],
		    color = param[1];
		   return cont([0, color, group_id, name, option_ids]);
		  },
		  function(param, cont){
		   var
		    option_ids = param[4],
		    name = param[3],
		    group_id = param[2],
		    color = param[1];
		   return cont
		           ([0, color, [0, group_id, [0, name, [0, option_ids, 0]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dD[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dD[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$114 = [];
		               function schema_versioned$64(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$114[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ym, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$114[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$114[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$114[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (group_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "groups",
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$62,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var groups = param[2][1], options = param[1];
		             return cont([0, options, groups]);
		            },
		            function(param, cont){
		             var groups = param[2], options = param[1];
		             return cont([0, options, [0, groups, 0]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_options,
		              0,
		              2,
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$114[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$114[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$160 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dD, [0, schematic_cache$160]);
		               var schematic_cache$161 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$114, [0, schematic_cache$161]);
		               caml_callback
		                (group_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (schema_versioned$64,
		                 [function(param, cont){return cont(0);}]);
		               var dE = [];
		               function number_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dE[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dE[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dE[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dE[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (format_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var format = param[1];
		   return cont([0, format]);
		  },
		  function(param, cont){
		   var format = param[1];
		   return cont([0, format, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_format, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dE[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dE[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_Won = "Won", dF = [];
		               function format_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dF[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yo, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dF[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dF[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dF[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(yK);},
		                                  0,
		                                  0,
		                                  cst_number,
		                                  "Number_",
		                                  yJ,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(yI) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_number_with_commas,
		                                   "Number_with_commas",
		                                   yH,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(yG) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_percent,
		                                    "Percent",
		                                    yF,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(yE) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_dollar,
		                                     "Dollar",
		                                     yD,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(yC) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_euro,
		                                      "Euro",
		                                      yB,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(yA) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_pound,
		                                       "Pound",
		                                       yz,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(yy) : cont(0);
		},
		0,
		0,
		cst_yen,
		"Yen",
		yx,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 === param ? cont(yw) : cont(0);
		 },
		 0,
		 0,
		 cst_ruble,
		 "Ruble",
		 yv,
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(8);},
		  function(param, cont){
		   return 8 === param ? cont(yu) : cont(0);
		  },
		  0,
		  0,
		  cst_rupee,
		  "Rupee",
		  yt,
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(9);},
		   function(param, cont){
		    return 9 === param ? cont(ys) : cont(0);
		   },
		   0,
		   0,
		   cst_won,
		   cst_Won,
		   yr,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(10);},
		    function(param, cont){
		     return 10 <= param ? cont(yq) : cont(0);
		    },
		    0,
		    0,
		    cst_yuan,
		    "Yuan",
		    yp,
		    0],
		   0]]]]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dF[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dF[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_database_id = "database_id", dG = [];
		               function relation_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dG[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yL, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dG[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dG[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            dG[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "synced_property_name",
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "synced_property_id",
		                                  0,
		                                  3,
		                                  [0, schema_versioned$58()],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$55,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    synced_property_id = a[2][1],
		    synced_property_name = a[1],
		    database_id = param[1];
		   return cont
		           ([0, database_id, synced_property_name, synced_property_id]);
		  },
		  function(param, cont){
		   var
		    synced_property_id = param[3],
		    synced_property_name = param[2],
		    database_id = param[1];
		   return cont
		           ([0,
		             database_id,
		             [0, synced_property_name, [0, synced_property_id, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_database_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dG[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dG[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var dH = [];
		               function rollup_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dH[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yM, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dH[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dH[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dH[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (rollup_function_schema_version,
		                                     schematic_version,
		                                     function(a){
		                                      a =
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 "rollup_property_name",
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  "rollup_property_id",
		  0,
		  2,
		  [0, schema_versioned$58()],
		  0,
		  0],
		 [0, [0, 0, 0, 0, 0, cst_function, 0, 2, [0, a], 0, 0], 0]]];
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    function$ = c[2][1],
		    rollup_property_id = c[1],
		    rollup_property_name = b[1],
		    relation_property_id = a[1],
		    relation_property_name = param[1];
		   return cont
		           ([0,
		             relation_property_name,
		             relation_property_id,
		             rollup_property_name,
		             rollup_property_id,
		             function$]);
		  },
		  function(param, cont){
		   var
		    function$ = param[5],
		    rollup_property_id = param[4],
		    rollup_property_name = param[3],
		    relation_property_id = param[2],
		    relation_property_name = param[1];
		   return cont
		           ([0,
		             relation_property_name,
		             [0,
		              relation_property_id,
		              [0,
		               rollup_property_name,
		               [0, rollup_property_id, [0, function$, 0]]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "relation_property_name",
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "relation_property_id",
		     0,
		     2,
		     [0, schema_versioned$58()],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dH[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dH[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_Min = "Min", dI = [];
		               function rollup_function_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dI[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, yN, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dI[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dI[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dI[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(zv);},
		                                  0,
		                                  0,
		                                  cst_average,
		                                  "Average",
		                                  zu,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(zt) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_checked,
		                                   "Checked",
		                                   zs,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(zr) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_count,
		                                    cst_Count,
		                                    zq,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(zp) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_count_all,
		                                     "Count_all",
		                                     zo,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(zn) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_count_empty,
		                                      "Count_empty",
		                                      zm,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(zl) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_count_not_empty,
		                                       "Count_not_empty",
		                                       zk,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(zj) : cont(0);
		},
		0,
		0,
		cst_count_unique_values,
		"Count_unique_values",
		zi,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 === param ? cont(zh) : cont(0);
		 },
		 0,
		 0,
		 cst_count_values,
		 "Count_values",
		 zg,
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(8);},
		  function(param, cont){
		   return 8 === param ? cont(zf) : cont(0);
		  },
		  0,
		  0,
		  cst_date_range,
		  cst_Date_range,
		  ze,
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(9);},
		   function(param, cont){
		    return 9 === param ? cont(zd) : cont(0);
		   },
		   0,
		   0,
		   cst_earliest_date,
		   "Earliest_date",
		   zc,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(10);},
		    function(param, cont){
		     return 10 === param ? cont(zb) : cont(0);
		    },
		    0,
		    0,
		    cst_latest_date,
		    "Latest_date",
		    za,
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(11);},
		     function(param, cont){
		      return 11 === param ? cont(y$) : cont(0);
		     },
		     0,
		     0,
		     cst_max,
		     cst_Max,
		     y_,
		     0],
		    [0,
		     [0,
		      function(param, cont){return cont(12);},
		      function(param, cont){
		       return 12 === param ? cont(y9) : cont(0);
		      },
		      0,
		      0,
		      cst_median,
		      "Median",
		      y8,
		      0],
		     [0,
		      [0,
		       function(param, cont){return cont(13);},
		       function(param, cont){
		        return 13 === param ? cont(y7) : cont(0);
		       },
		       0,
		       0,
		       cst_min,
		       cst_Min,
		       y6,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(14);},
		        function(param, cont){
		         return 14 === param ? cont(y5) : cont(0);
		        },
		        0,
		        0,
		        cst_percent_checked,
		        "Percent_checked",
		        y4,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(15);},
		         function(param, cont){
		          return 15 === param ? cont(y3) : cont(0);
		         },
		         0,
		         0,
		         cst_percent_empty,
		         "Percent_empty",
		         y2,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(16);},
		          function(param, cont){
		           return 16 === param ? cont(y1) : cont(0);
		          },
		          0,
		          0,
		          cst_percent_not_empty,
		          "Percent_not_empty",
		          y0,
		          0],
		         [0,
		          [0,
		           function(param, cont){return cont(17);},
		           function(param, cont){
		            return 17 === param ? cont(yZ) : cont(0);
		           },
		           0,
		           0,
		           cst_percent_unchecked,
		           "Percent_unchecked",
		           yY,
		           0],
		          [0,
		           [0,
		            function(param, cont){return cont(18);},
		            function(param, cont){
		             return 18 === param ? cont(yX) : cont(0);
		            },
		            0,
		            0,
		            cst_range,
		            "Range",
		            yW,
		            0],
		           [0,
		            [0,
		             function(param, cont){return cont(19);},
		             function(param, cont){
		              return 19 === param ? cont(yV) : cont(0);
		             },
		             0,
		             0,
		             cst_show_original,
		             "Show_original",
		             yU,
		             0],
		            [0,
		             [0,
		              function(param, cont){return cont(20);},
		              function(param, cont){
		               return 20 === param ? cont(yT) : cont(0);
		              },
		              0,
		              0,
		              cst_show_unique,
		              "Show_unique",
		              yS,
		              0],
		             [0,
		              [0,
		               function(param, cont){return cont(21);},
		               function(param, cont){
		                return 21 === param ? cont(yR) : cont(0);
		               },
		               0,
		               0,
		               cst_sum,
		               "Sum",
		               yQ,
		               0],
		              [0,
		               [0,
		                function(param, cont){return cont(22);},
		                function(param, cont){
		                 return 22 <= param ? cont(yP) : cont(0);
		                },
		                0,
		                0,
		                cst_unchecked,
		                "Unchecked",
		                yO,
		                0],
		               0]]]]]]]]]]]]]]]]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dI[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dI[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var ignore_schema = [0, 0, 0, 3, 0];
		               function property_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$63,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$64,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$63,
		               schematic_version,
		               function(c){
		                return caml_exact_trampoline_cps_call
		                        (rollup_schema_versioned,
		                         schematic_version,
		                         function(d){
		                          return caml_exact_trampoline_cps_call
		                                  (relation_schema_versioned,
		                                   schematic_version,
		                                   function(e){
		                                    return caml_exact_trampoline_cps_call
		    (number_schema_versioned,
		     schematic_version,
		     function(f){
		      return caml_exact_trampoline_cps_call$11
		              (schema_versioned$61,
		               schematic_version,
		               ignore_schema,
		               ignore_schema,
		               ignore_schema,
		               ignore_schema,
		               ignore_schema,
		               f,
		               ignore_schema,
		               ignore_schema,
		               ignore_schema,
		               e,
		               d,
		               c,
		               b,
		               a,
		               ignore_schema,
		               ignore_schema,
		               ignore_schema,
		               ignore_schema,
		               function(a){return cont([0, zw, 0, a[3], a[4]]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var schematic_cache$162 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dE, [0, schematic_cache$162]);
		               var schematic_cache$163 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dF, [0, schematic_cache$163]);
		               var schematic_cache$164 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dG, [0, schematic_cache$164]);
		               var schematic_cache$165 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dH, [0, schematic_cache$165]);
		               var schematic_cache$166 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dI, [0, schematic_cache$166]);
		               var
		                schematic_cache$167 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$115 = [];
		               caml_update_dummy
		                (letrec_function_context$115, [0, schematic_cache$167]);
		               caml_callback
		                (number_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (format_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (relation_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (rollup_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (rollup_function_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (property_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$19(param, cont){return cont(0);}
		               var schematic_schema_version$159 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$115[1][1],
		                    schematic_schema_version$159]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$115[1][1],
		                             schematic_schema_version$159,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$115[1][1],
		schematic_schema_version$159,
		schematic_self,
		function(a){
		 letrec_function_context$115[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$60,
		          schematic_version$19,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_title,
		                0,
		                2,
		                [0, [0, 0, 0, [3, b], 0]],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (property_schema_versioned,
		                    schematic_version$19,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_properties,
		                          0,
		                          2,
		                          [0, [0, 0, 0, mapping_schema(c)[3], 0]],
		                          0,
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$4,
		                              schematic_version$19,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_last_edited_time, 0, 2, [0, c], 0, 0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$55,
		schematic_version$19,
		function(c){
		 var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$4,
		          schematic_version$19,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 b = a[2],
		                 c = b[2],
		                 title = c[2][1],
		                 properties = c[1],
		                 last_edited_time = b[1],
		                 id = a[1],
		                 created_time = param[1];
		                return cont
		                        ([0, created_time, id, last_edited_time, properties, title]);
		               },
		               function(param, cont){
		                var
		                 title = param[5],
		                 properties = param[4],
		                 last_edited_time = param[3],
		                 id = param[2],
		                 created_time = param[1];
		                return cont
		                        ([0,
		                          created_time,
		                          [0,
		                           id,
		                           [0, last_edited_time, [0, properties, [0, title, 0]]]]]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_created_time, 0, 2, [0, a], 0, 0],
		                b]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$115[1][1],
		                    schematic_schema_version$159,
		                    res,
		                    function(a){
		                     letrec_function_context$115[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback(M$2, [[0, b2, du]]);
		               function checkbox_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont([0, bu, 0, bool_schema[3], bool_schema[4]]);
		                         });
		               }
		               function email_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    bv,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               function file_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          var a = schema_versioned$58();
		                          return cont([0, zx, 0, a[3], a[4]]);
		                         });
		               }
		               var dJ = [];
		               function formula_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dJ[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, zy, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dJ[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dJ[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            dJ[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_number,
		                                 "Number_formula",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var number = param[1];
		                                    return cont(number);
		                                   },
		                                   function(number, cont){return cont([0, number, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_number, 0, 3, [0, float_schema], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([3, f0]);},
		                                  function(param, cont){
		                                   if(3 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_string,
		                                  "String_formula",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var string = param[1];
		                                     return cont(string);
		                                    },
		                                    function(string, cont){return cont([0, string, 0]);},
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_string,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$57,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  zz,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_boolean,
		    "Boolean_formula",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var boolean = param[1];
		       return cont(boolean);
		      },
		      function(boolean, cont){return cont([0, boolean, 0]);},
		      [0,
		       [0, 0, 0, 0, 0, cst_boolean, 0, 2, [0, bool_schema], 0, 0],
		       0]],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([1, f0]);},
		     function(param, cont){
		      if(1 !== param[0]) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     1,
		     0,
		     cst_date,
		     "Date_formula",
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var date = param[1];
		        return cont(date);
		       },
		       function(date, cont){return cont([0, date, 0]);},
		       [0, [0, 0, 0, 0, 0, cst_date, 0, 3, [0, b], 0, 0], 0]],
		      0],
		     0],
		    a]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dJ[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dJ[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function number_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont([0, bw, 0, float_schema[3], float_schema[4]]);
		                         });
		               }
		               function people_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          var a = schema_versioned$59(schematic_version);
		                          return cont([0, zA, 0, a[3], a[4]]);
		                         });
		               }
		               function phone_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    bx,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var dK = [];
		               function relation_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dK[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, zB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dK[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dK[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dK[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$55,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dK[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dK[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var dL = [];
		               function rollup_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dL[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, zC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dL[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dL[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dL[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (rollup_type_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var type = param[1];
		   return cont([0, type]);
		  },
		  function(param, cont){
		   var type = param[1];
		   return cont([0, type, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dL[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dL[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var dM = [];
		               function rollup_type_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dM[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, zD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dM[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dM[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dM[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(zJ);},
		                                  0,
		                                  0,
		                                  cst_array,
		                                  cst_Array,
		                                  zI,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(zH) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_date,
		                                   cst_Date,
		                                   zG,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(zF) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_number,
		                                    cst_Number,
		                                    zE,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dM[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dM[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function select_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$62,
		                                   schematic_version,
		                                   function(a){return cont([0, zK, 0, a[3], a[4]]);});
		                         });
		               }
		               var dN = [];
		               function text_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   dN[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, zL, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                dN[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dN[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            dN[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$60,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dN[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dN[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function time_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$4,
		                                   schematic_version,
		                                   function(a){return cont([0, zM, 0, a[3], a[4]]);});
		                         });
		               }
		               var letrec_function_context$116 = [];
		               function title_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$116[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, zN, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$116[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$116[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$116[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$60,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$116[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$116[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$168 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dJ, [0, schematic_cache$168]);
		               var schematic_cache$169 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dK, [0, schematic_cache$169]);
		               var schematic_cache$170 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dL, [0, schematic_cache$170]);
		               var schematic_cache$171 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dM, [0, schematic_cache$171]);
		               var schematic_cache$172 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dN, [0, schematic_cache$172]);
		               var schematic_cache$173 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$116, [0, schematic_cache$173]);
		               caml_callback
		                (file_schema_versioned,
		                 [function(param, cont){return cont();}]);
		               caml_callback
		                (formula_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (people_schema_versioned$0,
		                 [function(param, cont){return cont();}]);
		               caml_callback
		                (relation_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (rollup_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (rollup_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (select_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (text_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (time_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (title_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Workspace = "Workspace",
		                cst_page_id = "page_id",
		                letrec_function_context$117 = [];
		               function parent_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$117[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, zO, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$117[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$117[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$117[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  return typeof param === "number" ? cont(zP) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_workspace,
		                                 cst_Workspace,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$55,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_page_id,
		   "Page_id",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var page_id = param[1];
		      return cont(page_id);
		     },
		     function(page_id, cont){return cont([0, page_id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_page_id, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (du,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            zQ,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_database_id,
		              "Database_id",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var database_id = param[1];
		                 return cont(database_id);
		                },
		                function(database_id, cont){
		                 return cont([0, database_id, 0]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_database_id, 0, 2, [0, a], 0, 0], 0]],
		               0],
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$117[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$117[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function property_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (title_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (time_schema_versioned$0,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (text_schema_versioned$0,
		               schematic_version,
		               function(c){
		                return caml_exact_trampoline_cps_call
		                        (select_schema_versioned,
		                         schematic_version,
		                         function(e){
		                          var d = [0, 0, 0, [3, e], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (select_schema_versioned,
		                                   schematic_version,
		                                   function(e){
		                                    return caml_exact_trampoline_cps_call
		    (select_schema_versioned,
		     schematic_version,
		     function(f){
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               f,
		               function(f){
		                return caml_exact_trampoline_cps_call
		                        (rollup_schema_versioned$0,
		                         schematic_version,
		                         function(g){
		                          return caml_exact_trampoline_cps_call
		                                  (relation_schema_versioned$0,
		                                   schematic_version,
		                                   function(i){
		                                    var h = [0, 0, 0, [3, i], 0];
		                                    return caml_exact_trampoline_cps_call
		    (phone_schema_versioned,
		     schematic_version,
		     function(i){
		      return caml_exact_trampoline_cps_call
		              (people_schema_versioned$0,
		               schematic_version,
		               function(k){
		                var j = [0, 0, 0, [3, k], 0];
		                return caml_exact_trampoline_cps_call
		                        (people_schema_versioned$0,
		                         schematic_version,
		                         function(k){
		                          return caml_exact_trampoline_cps_call
		                                  (number_schema_versioned$0,
		                                   schematic_version,
		                                   function(l){
		                                    return caml_exact_trampoline_cps_call
		    (formula_schema_versioned,
		     schematic_version,
		     function(m){
		      return caml_exact_trampoline_cps_call
		              (file_schema_versioned,
		               schematic_version,
		               function(n){
		                return caml_exact_trampoline_cps_call
		                        (email_schema_versioned,
		                         schematic_version,
		                         function(o){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$57,
		                                   schematic_version,
		                                   function(p){
		                                    return caml_exact_trampoline_cps_call
		    (checkbox_schema_versioned,
		     schematic_version,
		     function(q){
		      return caml_exact_trampoline_cps_call$11
		              (schema_versioned$61,
		               schematic_version,
		               q,
		               p,
		               o,
		               n,
		               m,
		               l,
		               k,
		               j,
		               i,
		               h,
		               g,
		               f,
		               e,
		               d,
		               c,
		               b,
		               a,
		               schema$268,
		               function(a){return cont([0, zR, 0, a[3], a[4]]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                schematic_cache$174 = [0, empty$11([0, comparator$9])],
		                dO = [];
		               caml_update_dummy(dO, [0, schematic_cache$174]);
		               var schematic_cache$175 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$117, [0, schematic_cache$175]);
		               function schematic_version$20(param, cont){return cont(0);}
		               var schematic_schema_version$158 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dO[1][1], schematic_schema_version$158]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dO[1][1],
		                             schematic_schema_version$158,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dO[1][1],
		schematic_schema_version$158,
		schematic_self,
		function(a){
		 dO[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (property_schema_versioned$0,
		          schematic_version$20,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_properties,
		                0,
		                2,
		                [0, [0, 0, 0, mapping_schema(b)[3], 0]],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (parent_schema_versioned,
		                    schematic_version$20,
		                    function(c){
		                     var
		                      b = [0, [0, 0, 0, 0, 0, cst_parent, 0, 2, [0, c], 0, 0], a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$4,
		                              schematic_version$20,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_last_edited_time, 0, 2, [0, c], 0, 0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$55,
		schematic_version$20,
		function(c){
		 var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$4,
		          schematic_version$20,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 b = a[2],
		                 c = b[2],
		                 d = c[2],
		                 properties = d[2][1],
		                 parent = d[1],
		                 last_edited_time = c[1],
		                 id = b[1],
		                 created_time = a[1],
		                 archived = param[1];
		                return cont
		                        ([0,
		                          archived,
		                          created_time,
		                          id,
		                          last_edited_time,
		                          parent,
		                          properties]);
		               },
		               function(param, cont){
		                var
		                 properties = param[6],
		                 parent = param[5],
		                 last_edited_time = param[4],
		                 id = param[3],
		                 created_time = param[2],
		                 archived = param[1];
		                return cont
		                        ([0,
		                          archived,
		                          [0,
		                           created_time,
		                           [0,
		                            id,
		                            [0, last_edited_time, [0, parent, [0, properties, 0]]]]]]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, bool_schema], 0, 0],
		                [0,
		                 [0, 0, 0, 0, 0, cst_created_time, 0, 2, [0, a], 0, 0],
		                 b]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    dO[1][1],
		                    schematic_schema_version$158,
		                    res,
		                    function(a){dO[1][1] = a; return cont(res);});
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (parent_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (property_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$21(param, cont){return cont(0);}
		               var
		                bU =
		                  caml_callback
		                   (title_schema_versioned, [schematic_version$21]),
		                j =
		                  caml_callback
		                   (time_schema_versioned$0, [schematic_version$21]),
		                b1 =
		                  caml_callback
		                   (text_schema_versioned$0, [schematic_version$21]),
		                cg =
		                  [0,
		                   0,
		                   0,
		                   [3,
		                    caml_callback
		                     (patch_schema_versioned, [schematic_version$21])],
		                   0],
		                b_ =
		                  caml_callback
		                   (patch_schema_versioned, [schematic_version$21]),
		                h =
		                  caml_callback
		                   (option_schema,
		                    [caml_callback
		                      (patch_schema_versioned, [schematic_version$21])]),
		                b3 =
		                  caml_callback
		                   (rollup_schema_versioned$0, [schematic_version$21]),
		                b4 =
		                  [0,
		                   0,
		                   0,
		                   [3,
		                    caml_callback
		                     (relation_schema_versioned$0, [schematic_version$21])],
		                   0],
		                b5 =
		                  [0,
		                   bx,
		                   0,
		                   schematic_param_name_schema_ve[3],
		                   schematic_param_name_schema_ve[4]],
		                b$ =
		                  [0,
		                   0,
		                   0,
		                   [3,
		                    caml_callback
		                     (people_schema_versioned$0, [schematic_version$21])],
		                   0],
		                ch =
		                  caml_callback
		                   (people_schema_versioned$0, [schematic_version$21]),
		                bZ = [0, bw, 0, float_schema[3], float_schema[4]],
		                bY =
		                  caml_callback
		                   (formula_schema_versioned, [schematic_version$21]),
		                ca =
		                  caml_callback(file_schema_versioned, [schematic_version$21]),
		                cf =
		                  [0,
		                   bv,
		                   0,
		                   schematic_param_name_schema_ve[3],
		                   schematic_param_name_schema_ve[4]],
		                z = caml_callback(schema_versioned$57, [schematic_version$21]);
		               caml_callback
		                (schema_versioned$61,
		                 [schematic_version$21,
		                  [0, bu, 0, bool_schema[3], bool_schema[4]],
		                  z,
		                  cf,
		                  ca,
		                  bY,
		                  bZ,
		                  ch,
		                  b$,
		                  b5,
		                  b4,
		                  b3,
		                  h,
		                  b_,
		                  cg,
		                  b1,
		                  j,
		                  bU,
		                  schema$268]);
		               var
		                cst_workspace_icon = "workspace_icon",
		                cst_workspace_name = "workspace_name",
		                dR = [];
		               function response_success_schema_versio
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dR[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, zV, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dR[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dR[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dR[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        workspace_icon = d[2][1],
		                        workspace_name = d[1],
		                        workspace_id = c[1],
		                        owner = b[1],
		                        bot_id = a[1],
		                        access_token = param[1];
		                       return cont
		                               ([0,
		                                 access_token,
		                                 bot_id,
		                                 owner,
		                                 workspace_id,
		                                 workspace_name,
		                                 workspace_icon]);
		                      },
		                      function(param, cont){
		                       var
		                        workspace_icon = param[6],
		                        workspace_name = param[5],
		                        workspace_id = param[4],
		                        owner = param[3],
		                        bot_id = param[2],
		                        access_token = param[1];
		                       return cont
		                               ([0,
		                                 access_token,
		                                 [0,
		                                  bot_id,
		                                  [0,
		                                   owner,
		                                   [0,
		                                    workspace_id,
		                                    [0, workspace_name, [0, workspace_icon, 0]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_access_token,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         "bot_id",
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, no_input_schema], 0, 0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_workspace_id,
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_workspace_name,
		                            0,
		                            3,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_workspace_icon,
		                             0,
		                             3,
		                             [0, schema$268],
		                             0,
		                             0],
		                            0]]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dR[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dR[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var letrec_function_context$118 = [];
		               function response_failure_schema_versio
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$118[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, zW, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$118[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$118[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$118[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var error = param[1];
		                       return cont([0, error]);
		                      },
		                      function(param, cont){
		                       var error = param[1];
		                       return cont([0, error, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_error,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$118[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$118[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$176 = [0, empty$11([0, comparator$9])],
		                dP = [];
		               caml_update_dummy(dP, [0, schematic_cache$176]);
		               var
		                schematic_cache$177 = [0, empty$11([0, comparator$9])],
		                dQ = [];
		               caml_update_dummy(dQ, [0, schematic_cache$177]);
		               var schematic_cache$178 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dR, [0, schematic_cache$178]);
		               var schematic_cache$179 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$118, [0, schematic_cache$179]);
		               var schematic_schema_version$8 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id, [dP[1][1], schematic_schema_version$8]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dP[1][1],
		                             schematic_schema_version$8,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dP[1][1],
		schematic_schema_version$8,
		schematic_self,
		function(a){
		 dP[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       redirect_uri = a[2][1],
		       grant_type = a[1],
		       code = param[1];
		      return cont([0, code, grant_type, redirect_uri]);
		     },
		     function(param, cont){
		      var
		       redirect_uri = param[3],
		       grant_type = param[2],
		       code = param[1];
		      return cont
		              ([0, code, [0, grant_type, [0, redirect_uri, 0]]]);
		     },
		     [0,
		      [0,
		       zU,
		       0,
		       0,
		       0,
		       cst_code,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        zT,
		        0,
		        0,
		        0,
		        cst_grant_type,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         zS,
		         0,
		         0,
		         0,
		         cst_redirect_uri,
		         0,
		         2,
		         [0, schema$268],
		         0,
		         0],
		        0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          dP[1][1],
		          schematic_schema_version$8,
		          res,
		          function(a){dP[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$22(param){return 0;}
		               var schematic_schema_version$157 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dQ[1][1], schematic_schema_version$157]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dQ[1][1],
		                             schematic_schema_version$157,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dQ[1][1],
		schematic_schema_version$157,
		schematic_self,
		function(a){
		 dQ[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (response_failure_schema_versio,
		          schematic_version$22,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([1, f0]);},
		                function(param, cont){
		                 if(0 === param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                0,
		                0,
		                cst_failure,
		                cst_Failure,
		                b,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (response_success_schema_versio,
		                    schematic_version$22,
		                    function(b){
		                     var
		                      res =
		                        [11,
		                         0,
		                         [0,
		                          [0,
		                           function(f0, cont){return cont([0, f0]);},
		                           function(param, cont){
		                            if(0 !== param[0]) return cont(0);
		                            var f0 = param[1];
		                            return cont([0, f0]);
		                           },
		                           0,
		                           0,
		                           cst_success,
		                           cst_Success,
		                           b,
		                           0],
		                          a],
		                         0];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              dQ[1][1],
		                              schematic_schema_version$157,
		                              res,
		                              function(a){dQ[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (response_success_schema_versio, [function(param){return 0;}]);
		               caml_callback
		                (response_failure_schema_versio, [function(param){return 0;}]);
		               var letrec_function_context$119 = [];
		               function notion_code_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version();
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$119[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, zX, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$119[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$119[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$119[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(Af);},
		                        0,
		                        0,
		                        cst_invalid_json,
		                        "Invalid_json",
		                        Ae,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(Ad) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_invalid_request_url,
		                         "Invalid_request_url",
		                         Ac,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(Ab) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_invalid_request,
		                          "Invalid_request",
		                          Aa,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(z$) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_validation_error,
		                           "Validation_error",
		                           z_,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 === param ? cont(z9) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_missing_version,
		                            "Missing_version",
		                            z8,
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(5);},
		                             function(param, cont){
		                              return 5 === param ? cont(z7) : cont(0);
		                             },
		                             0,
		                             0,
		                             cst_unauthorized,
		                             cst_Unauthorized,
		                             z6,
		                             0],
		                            [0,
		                             [0,
		                              function(param, cont){return cont(6);},
		                              function(param, cont){
		                               return 6 === param ? cont(z5) : cont(0);
		                              },
		                              0,
		                              0,
		                              cst_restricted_resource,
		                              "Restricted_resource",
		                              z4,
		                              0],
		                             [0,
		                              [0,
		                               function(param, cont){return cont(7);},
		                               function(param, cont){
		                                return 7 === param ? cont(z3) : cont(0);
		                               },
		                               0,
		                               0,
		                               cst_object_not_found,
		                               "Object_not_found",
		                               z2,
		                               0],
		                              [0,
		                               [0,
		                                function(param, cont){return cont(8);},
		                                function(param, cont){
		                                 return 8 === param ? cont(z1) : cont(0);
		                                },
		                                0,
		                                0,
		                                cst_conflict_error,
		                                "Conflict_error",
		                                z0,
		                                0],
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(9);},
		                                 function(param, cont){
		                                  return 9 <= param ? cont(zZ) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_internal_server_error,
		                                 "Internal_server_error",
		                                 zY,
		                                 0],
		                                0]]]]]]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$119[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$119[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$180 = [0, empty$11([0, comparator$9])],
		                dS = [];
		               caml_update_dummy(dS, [0, schematic_cache$180]);
		               var schematic_cache$181 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$119, [0, schematic_cache$181]);
		               function schematic_version$23(param){return 0;}
		               var schematic_schema_version$156 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dS[1][1], schematic_schema_version$156]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dS[1][1],
		                             schematic_schema_version$156,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dS[1][1],
		schematic_schema_version$156,
		schematic_self,
		function(b){
		 dS[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_message,
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (notion_code_schema_versioned,
		          schematic_version$23,
		          function(b){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var message = param[2][1], code = param[1];
		                return cont([0, code, message]);
		               },
		               function(param, cont){
		                var message = param[2], code = param[1];
		                return cont([0, code, [0, message, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_code, 0, 2, [0, b], 0, 0], a]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    dS[1][1],
		                    schematic_schema_version$156,
		                    res,
		                    function(a){dS[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (notion_code_schema_versioned, [function(param){return 0;}]);
		               function contains_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    function descriptor(schematic_param_a_schema_versi){
		                                     return [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       is_not_empty = b[2][1],
		       is_empty = b[1],
		       does_not_contain = a[1],
		       contains = param[1];
		      return cont
		              ([0, contains, does_not_contain, is_empty, is_not_empty]);
		     },
		     function(param, cont){
		      var
		       is_not_empty = param[4],
		       is_empty = param[3],
		       does_not_contain = param[2],
		       contains = param[1];
		      return cont
		              ([0,
		                contains,
		                [0, does_not_contain, [0, is_empty, [0, is_not_empty, 0]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_contains,
		       0,
		       3,
		       [0, schematic_param_a_schema_versi],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "does_not_contain",
		        0,
		        3,
		        [0, schematic_param_a_schema_versi],
		        0,
		        0],
		       [0,
		        [0, 0, 0, 0, 0, cst_is_empty, 0, 3, [0, bool_schema], 0, 0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_is_not_empty,
		          0,
		          3,
		          [0, bool_schema],
		          0,
		          0],
		         0]]]]];
		                                    }
		                                    var
		                                     schematic_schema_id = match$100[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_a$0,
		 schematic_param_a_schema_versi,
		 function(schematic_param_a_schema_versi, cont){
		  return cont
		          ([0,
		            schematic_schema_id,
		            descriptor(schematic_param_a_schema_versi)]);
		 }]],
		                                     a = descriptor(schematic_param_a_schema_versi),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, 0, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               var cst_after = "after", letrec_function_context$120 = [];
		               function date_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$120[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Ag, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$120[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$120[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$120[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_is_empty, 0, 3, [0, bool_schema], 0, 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_is_not_empty,
		                                  0,
		                                  3,
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_equals, 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, 0, 0, 0, 0, cst_before, 0, 3, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        is_not_empty = c[2][1],
		                        is_empty = c[1],
		                        equals = b[1],
		                        before = a[1],
		                        after = param[1];
		                       return cont
		                               ([0, after, before, equals, is_empty, is_not_empty]);
		                      },
		                      function(param, cont){
		                       var
		                        is_not_empty = param[5],
		                        is_empty = param[4],
		                        equals = param[3],
		                        before = param[2],
		                        after = param[1];
		                       return cont
		                               ([0,
		                                 after,
		                                 [0,
		                                  before,
		                                  [0, equals, [0, is_empty, [0, is_not_empty, 0]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_after, 0, 3, [0, b], 0, 0], a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$120[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$120[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$182 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$120, [0, schematic_cache$182]);
		               caml_callback
		                (date_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function equals_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    function descriptor(schematic_param_a_schema_versi){
		                                     return [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       is_not_empty = b[2][1],
		       is_empty = b[1],
		       does_not_equal = a[1],
		       equals = param[1];
		      return cont
		              ([0, equals, does_not_equal, is_empty, is_not_empty]);
		     },
		     function(param, cont){
		      var
		       is_not_empty = param[4],
		       is_empty = param[3],
		       does_not_equal = param[2],
		       equals = param[1];
		      return cont
		              ([0,
		                equals,
		                [0, does_not_equal, [0, is_empty, [0, is_not_empty, 0]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_equals,
		       0,
		       3,
		       [0, schematic_param_a_schema_versi],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "does_not_equal",
		        0,
		        3,
		        [0, schematic_param_a_schema_versi],
		        0,
		        0],
		       [0,
		        [0, 0, 0, 0, 0, cst_is_empty, 0, 3, [0, bool_schema], 0, 0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_is_not_empty,
		          0,
		          3,
		          [0, bool_schema],
		          0,
		          0],
		         0]]]]];
		                                    }
		                                    var
		                                     schematic_schema_id = match$101[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_a$0,
		 schematic_param_a_schema_versi,
		 function(schematic_param_a_schema_versi, cont){
		  return cont
		          ([0,
		            schematic_schema_id,
		            descriptor(schematic_param_a_schema_versi)]);
		 }]],
		                                     a = descriptor(schematic_param_a_schema_versi),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, 0, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               var
		                cst_And = "And",
		                cst_Or = "Or",
		                letrec_function_context$121 = [];
		               function schema_versioned$65(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$121[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Ah, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$121[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$121[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$121[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (equals_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (a,
		       schematic_param_name_schema_ve,
		       function(b){
		        var
		         a =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([6, f0, f1]);
		             },
		             function(param, cont){
		              if(6 !== param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_status,
		             cst_Status,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var status = param[2][1], property = param[1];
		                return cont([0, property, status]);
		               },
		               function(param, cont){
		                var status = param[2], property = param[1];
		                return cont([0, property, [0, status, 0]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_property,
		                 0,
		                 2,
		                 [0, schema_versioned$58()],
		                 0,
		                 0],
		                [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, b], 0, 0], 0]]],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (equals_schema_versioned,
		                 schematic_version,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (b,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([5, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(5 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_select,
		                                 cst_Select,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var select = param[2][1], property = param[1];
		                                    return cont([0, property, select]);
		                                   },
		                                   function(param, cont){
		                                    var select = param[2], property = param[1];
		                                    return cont([0, property, [0, select, 0]]);
		                                   },
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_property,
		                                     0,
		                                     2,
		                                     [0, schema_versioned$58()],
		                                     0,
		                                     0],
		                                    [0, [0, 0, 0, 0, 0, cst_select, 0, 2, [0, c], 0, 0], 0]]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (bPa,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (contains_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (c,
		                 a,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f1 = param[2], f0 = param[1];
		                        return cont([4, f0, f1]);
		                       },
		                       function(param, cont){
		                        if(4 !== param[0]) return cont(0);
		                        var f1 = param[2], f0 = param[1];
		                        return cont([0, [0, f0, f1]]);
		                       },
		                       1,
		                       0,
		                       cst_people,
		                       cst_People,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var people = param[2][1], property = param[1];
		                          return cont([0, property, people]);
		                         },
		                         function(param, cont){
		                          var people = param[2], property = param[1];
		                          return cont([0, property, [0, people, 0]]);
		                         },
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_property,
		                           0,
		                           2,
		                           [0, schema_versioned$58()],
		                           0,
		                           0],
		                          [0, [0, 0, 0, 0, 0, cst_people, 0, 2, [0, c], 0, 0], 0]]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$65,
		                           schematic_version,
		                           function(d){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_or,
		                                 cst_Or,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){var or = param[1]; return cont(or);},
		                                   function(or, cont){return cont([0, or, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_or,
		                                     0,
		                                     2,
		                                     [0, [0, 0, 0, [3, d], 0]],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                a],
		                             c =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_timestamp,
		                                 0,
		                                 0,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (date_schema_versioned,
		                                     schematic_version,
		                                     function(e){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_last_edited_time,
		   cst_Last_edited_time,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var last_edited_time = param[1];
		      return cont(last_edited_time);
		     },
		     function(last_edited_time, cont){
		      return cont([0, last_edited_time, Ai]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_last_edited_time, 0, 2, [0, e], 0, 0],
		      c]],
		    0],
		   0],
		  b],
		                                       d =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_timestamp,
		   0,
		   0,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (date_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_created_time,
		             cst_Created_time,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var created_time = param[1];
		                return cont(created_time);
		               },
		               function(created_time, cont){
		                return cont([0, created_time, Aj]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_created_time, 0, 2, [0, c], 0, 0],
		                d]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$65,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        0,
		                        cst_and,
		                        cst_And,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){var and = param[1]; return cont(and);},
		                          function(and, cont){return cont([0, and, 0]);},
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_and,
		                            0,
		                            2,
		                            [0, [0, 0, 0, [3, a], 0]],
		                            0,
		                            0],
		                           0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$121[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$121[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$183 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$121, [0, schematic_cache$183]);
		               caml_callback
		                (schema_versioned$65,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$66(v, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function decode(a, cont){
		                 switch(a[0]){
		                   case 0:
		                    var
		                     and = a[1],
		                     b = function(and, cont){return cont([0, and]);};
		                    return caml_trampoline_cps_call3
		                            (map$18,
		                             and,
		                             decode,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (all$14,
		                                       a,
		                                       function(a){
		return caml_trampoline_cps_call3(let$, a, b, cont);
		                                       });
		                             });
		                   case 1:
		                    var created_time = a[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             decode_timestamp(created_time),
		                             function(date, cont){return cont([1, date]);},
		                             cont);
		                   case 2:
		                    var last_edited_time = a[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             decode_timestamp(last_edited_time),
		                             function(date, cont){return cont([2, date]);},
		                             cont);
		                   case 3:
		                    var
		                     or = a[1],
		                     c = function(or, cont){return cont([3, or]);};
		                    return caml_trampoline_cps_call3
		                            (map$18,
		                             or,
		                             decode,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (all$14,
		                                       a,
		                                       function(a){
		return caml_trampoline_cps_call3(let$, a, c, cont);
		                                       });
		                             });
		                   case 4:
		                    var
		                     people = a[2],
		                     id = a[1],
		                     a = people[1],
		                     d =
		                       function(people, cont){return cont([4, id, [0, people]]);};
		                    if(a)
		                     if(people[2] || people[3] || people[4])
		                      a = B;
		                     else
		                      var v = a[1], a = [0, [2, v]];
		                    else {
		                     a = people[2];
		                     if(a)
		                      if(people[3] || people[4])
		                       a = B;
		                      else
		                       var v$0 = a[1], a = [0, [3, v$0]];
		                     else {
		                      a = people[3];
		                      if(a)
		                       a = a[1] ? people[4] ? B : by : people[4] ? B : bz;
		                      else {a = people[4]; a = a ? a[1] ? bz : by : Ak;}
		                     }
		                    }
		                    return caml_trampoline_cps_call3(let$, a, d, cont);
		                   case 5:
		                    var select = a[2], id$0 = a[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             decode_equals(select),
		                             function(select, cont){return cont([4, id$0, [1, select]]);},
		                             cont);
		                   default:
		                    var status = a[2], id$1 = a[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             decode_equals(status),
		                             function(status, cont){return cont([4, id$1, [2, status]]);},
		                             cont);
		                 }
		                }
		                function encode(param, cont){
		                 switch(param[0]){
		                   case 0:
		                    var and = param[1];
		                    return caml_trampoline_cps_call3
		                            (map$18, and, encode, function(a){return cont([0, a]);});
		                   case 1:
		                    var created_time = param[1];
		                    return cont([1, encode_timestamp(created_time)]);
		                   case 2:
		                    var last_edited_time = param[1];
		                    return cont([2, encode_timestamp(last_edited_time)]);
		                   case 3:
		                    var or = param[1];
		                    return caml_trampoline_cps_call3
		                            (map$18, or, encode, function(a){return cont([3, a]);});
		                   default:
		                    var a = param[2], id = param[1];
		                    switch(a[0]){
		                      case 0:
		                       var people = a[1];
		                       if(typeof people === "number")
		                        a = 0 === people ? bA : As;
		                       else
		                        switch(people[0]){
		                          case 2:
		                           var v = people[1], a = [0, [0, v], 0, 0, 0]; break;
		                          case 3:
		                           var v$0 = people[1], a = [0, 0, [0, v$0], 0, 0]; break;
		                          default: a = bA;
		                        }
		                       return cont([4, id, a]);
		                      case 1:
		                       var select = a[1];
		                       return cont([5, id, encode_equals(select)]);
		                      default:
		                       var status = a[1];
		                       return cont([6, id, encode_equals(status)]);
		                    }
		                 }
		                }
		                function decode_equals(param){
		                 var a = param[1];
		                 a:
		                 if(a){
		                  if(! param[2] && ! param[3] && ! param[4]){var v = a[1]; return [0, [5, v]];}
		                 }
		                 else {
		                  a = param[2];
		                  if(! a){
		                   a = param[3];
		                   b:
		                   {
		                    if(a){
		                     if(a[1]){if(param[4]) break a; break b;}
		                     if(param[4]) break a;
		                    }
		                    else {a = param[4]; if(! a) return Ao; if(! a[1]) break b;}
		                    return An;
		                   }
		                   return Am;
		                  }
		                  if(! param[3] && ! param[4]){
		                   var v$0 = a[1];
		                   return [0, [4, v$0]];
		                  }
		                 }
		                 return Al;
		                }
		                function decode_timestamp(param){
		                 var a = param[1];
		                 a:
		                 if(a){
		                  if(! param[2] && ! param[3] && ! param[4] && ! param[5]){var v = a[1]; return [0, [0, v]];}
		                 }
		                 else {
		                  a = param[2];
		                  if(a){
		                   if(! param[3] && ! param[4] && ! param[5]){var v$0 = a[1]; return [0, [1, v$0]];}
		                  }
		                  else {
		                   a = param[3];
		                   if(! a){
		                    if(param[4]){
		                     if(param[5]) break a;
		                    }
		                    else if(! param[5]) return Ar;
		                    return Aq;
		                   }
		                   if(! param[4] && ! param[5]){
		                    var v$1 = a[1];
		                    return [0, [5, v$1]];
		                   }
		                  }
		                 }
		                 return Ap;
		                }
		                function encode_timestamp(param){
		                 if(typeof param !== "number")
		                  switch(param[0]){
		                    case 1:
		                     var v$0 = param[1]; return [0, 0, [0, v$0], 0, 0, 0];
		                    case 5:
		                     var v$1 = param[1]; return [0, 0, 0, [0, v$1], 0, 0];
		                  }
		                 var v = param[1];
		                 return [0, [0, v], 0, 0, 0, 0];
		                }
		                function encode_equals(param){
		                 if(typeof param === "number"){if(0 !== param) return Au;}
		                 else
		                  switch(param[0]){
		                    case 4:
		                     var v = param[1]; return [0, 0, [0, v], 0, 0];
		                    case 5:
		                     var v$0 = param[1]; return [0, [0, v$0], 0, 0, 0];
		                  }
		                 return At;
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$65,
		                         v,
		                         function(a){return cont(map$14(decode, encode, a));});
		               }
		               caml_callback
		                (schema_versioned$66,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$184 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$122 = [];
		               caml_update_dummy
		                (letrec_function_context$122, [0, schematic_cache$184]);
		               function schematic_version$24(param, cont){return cont(0);}
		               var schematic_schema_version$155 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$122[1][1],
		                    schematic_schema_version$155]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$122[1][1],
		                             schematic_schema_version$155,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$122[1][1],
		schematic_schema_version$155,
		schematic_self,
		function(a){
		 letrec_function_context$122[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$66,
		          schematic_version$24,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var filter = param[1];
		                return cont([0, filter]);
		               },
		               function(param, cont){
		                var filter = param[1];
		                return cont([0, filter, 0]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_filter, 0, 3, [0, a], 0, 0], 0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$122[1][1],
		                    schematic_schema_version$155,
		                    res,
		                    function(a){
		                     letrec_function_context$122[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback(make$3, [Ax, 0, Aw, 0, Av, 0, 0, dummy]);
		               var
		                V$2 =
		                  [248,
		                   "Openai__Schemas__Schemas_library.V",
		                   caml_fresh_oo_id()],
		                cst_Url_citation = "Url_citation",
		                dU = [];
		               function annotation_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dU[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, Ay, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dU[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dU[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dU[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (url_citation_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [11,
		                                Az,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_url_citation,
		                                  cst_Url_citation,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var url_citation = param[1];
		                                     return cont(url_citation);
		                                    },
		                                    function(url_citation, cont){
		                                     return cont([0, url_citation, 0]);
		                                    },
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_url_citation, 0, 2, [0, a], 0, 0],
		                                     0]],
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dU[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dU[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var dV = [];
		               function choice_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dV[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, AA, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dV[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dV[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dV[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (finish_reason_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_finish_reason, 0, 2, [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (message_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    finish_reason = a[2][1],
		    message = a[1],
		    index = param[1];
		   return cont([0, index, message, finish_reason]);
		  },
		  function(param, cont){
		   var
		    finish_reason = param[3],
		    message = param[2],
		    index = param[1];
		   return cont([0, index, [0, message, [0, finish_reason, 0]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_index, 0, 2, [0, int_schema], 0, 0],
		   [0, [0, 0, 0, 0, 0, cst_message, 0, 2, [0, b], 0, 0], a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       dV[1][1],
		       schematic_schema_version,
		       res,
		       function(a){dV[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                cst_audio_tokens = "audio_tokens",
		                cst_reasoning_tokens = "reasoning_tokens",
		                dW = [];
		               function completion_tokens_details_sche
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dW[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, AB, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dW[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dW[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dW[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        rejected_prediction_tokens = b[2][1],
		                        accepted_prediction_tokens = b[1],
		                        audio_tokens = a[1],
		                        reasoning_tokens = param[1];
		                       return cont
		                               ([0,
		                                 reasoning_tokens,
		                                 audio_tokens,
		                                 accepted_prediction_tokens,
		                                 rejected_prediction_tokens]);
		                      },
		                      function(param, cont){
		                       var
		                        rejected_prediction_tokens = param[4],
		                        accepted_prediction_tokens = param[3],
		                        audio_tokens = param[2],
		                        reasoning_tokens = param[1];
		                       return cont
		                               ([0,
		                                 reasoning_tokens,
		                                 [0,
		                                  audio_tokens,
		                                  [0,
		                                   accepted_prediction_tokens,
		                                   [0, rejected_prediction_tokens, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_reasoning_tokens,
		                        0,
		                        2,
		                        [0, int_schema],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_audio_tokens,
		                         0,
		                         2,
		                         [0, int_schema],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "accepted_prediction_tokens",
		                          0,
		                          2,
		                          [0, int_schema],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "rejected_prediction_tokens",
		                           0,
		                           2,
		                           [0, int_schema],
		                           0,
		                           0],
		                          0]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dW[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dW[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var dX = [];
		               function finish_reason_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dX[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, AC, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dX[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dX[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dX[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(AK);},
		                        0,
		                        0,
		                        cst_content_filter,
		                        "Content_filter",
		                        AJ,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(AI) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_length,
		                         "Length",
		                         AH,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(AG) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_stop,
		                          "Stop",
		                          AF,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 <= param ? cont(AE) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_tool_calls,
		                           "Tool_calls",
		                           AD,
		                           0],
		                          0]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dX[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dX[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cst_refusal = "refusal", dY = [];
		               function message_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dY[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, AL, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dY[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dY[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dY[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (annotation_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  annotations = b[2][1],
		                                  refusal = b[1],
		                                  content = a[1],
		                                  role = param[1];
		                                 return cont([0, role, content, refusal, annotations]);
		                                },
		                                function(param, cont){
		                                 var
		                                  annotations = param[4],
		                                  refusal = param[3],
		                                  content = param[2],
		                                  role = param[1];
		                                 return cont
		 ([0, role, [0, content, [0, refusal, [0, annotations, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_role,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_content,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_refusal,
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_annotations,
		                                     0,
		                                     2,
		                                     [0, [0, 0, 0, [3, a], 0]],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     dY[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){dY[1][1] = a; return cont(res);});
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                cst_end_index = "end_index",
		                cst_start_index = "start_index",
		                dZ = [];
		               function url_citation_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         dZ[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, AM, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      dZ[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 dZ[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  dZ[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        url = b[2][1],
		                        title = b[1],
		                        start_index = a[1],
		                        end_index = param[1];
		                       return cont([0, end_index, start_index, title, url]);
		                      },
		                      function(param, cont){
		                       var
		                        url = param[4],
		                        title = param[3],
		                        start_index = param[2],
		                        end_index = param[1];
		                       return cont
		                               ([0, end_index, [0, start_index, [0, title, [0, url, 0]]]]);
		                      },
		                      [0,
		                       [0, AQ, 0, 0, 0, cst_end_index, 0, 2, [0, int_schema], 0, 0],
		                       [0,
		                        [0,
		                         AP,
		                         0,
		                         0,
		                         0,
		                         cst_start_index,
		                         0,
		                         2,
		                         [0, int_schema],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          AO,
		                          0,
		                          0,
		                          0,
		                          cst_title,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0, AN, 0, 0, 0, cst_url, 0, 2, [0, schema$268], 0, 0],
		                          0]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           dZ[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){dZ[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cst_total_tokens = "total_tokens", d0 = [];
		               function usage_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         d0[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, AR, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      d0[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 d0[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  d0[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (completion_tokens_details_sche,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_completion_tokens_details,
		                                 0,
		                                 2,
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (prompt_tokens_details_schema_v,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    completion_tokens_details = c[2][1],
		    prompt_tokens_details = c[1],
		    total_tokens = b[1],
		    completion_tokens = a[1],
		    prompt_tokens = param[1];
		   return cont
		           ([0,
		             prompt_tokens,
		             completion_tokens,
		             total_tokens,
		             prompt_tokens_details,
		             completion_tokens_details]);
		  },
		  function(param, cont){
		   var
		    completion_tokens_details = param[5],
		    prompt_tokens_details = param[4],
		    total_tokens = param[3],
		    completion_tokens = param[2],
		    prompt_tokens = param[1];
		   return cont
		           ([0,
		             prompt_tokens,
		             [0,
		              completion_tokens,
		              [0,
		               total_tokens,
		               [0,
		                prompt_tokens_details,
		                [0, completion_tokens_details, 0]]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "prompt_tokens",
		    0,
		    2,
		    [0, int_schema],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "completion_tokens",
		     0,
		     2,
		     [0, int_schema],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_total_tokens,
		      0,
		      2,
		      [0, int_schema],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_prompt_tokens_details,
		       0,
		       2,
		       [0, b],
		       0,
		       0],
		      a]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       d0[1][1],
		       schematic_schema_version,
		       res,
		       function(a){d0[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                cst_cached_tokens = "cached_tokens",
		                letrec_function_context$123 = [];
		               function prompt_tokens_details_schema_v
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$2);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$123[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, AS, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$123[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$123[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$123[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var audio_tokens = param[2][1], cached_tokens = param[1];
		                       return cont([0, cached_tokens, audio_tokens]);
		                      },
		                      function(param, cont){
		                       var audio_tokens = param[2], cached_tokens = param[1];
		                       return cont([0, cached_tokens, [0, audio_tokens, 0]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_cached_tokens,
		                        0,
		                        2,
		                        [0, int_schema],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_audio_tokens,
		                         0,
		                         2,
		                         [0, int_schema],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$123[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$123[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$185 = [0, empty$11([0, comparator$9])],
		                dT = [];
		               caml_update_dummy(dT, [0, schematic_cache$185]);
		               var schematic_cache$186 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dU, [0, schematic_cache$186]);
		               var schematic_cache$187 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dV, [0, schematic_cache$187]);
		               var schematic_cache$188 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dW, [0, schematic_cache$188]);
		               var schematic_cache$189 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dX, [0, schematic_cache$189]);
		               var schematic_cache$190 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dY, [0, schematic_cache$190]);
		               var schematic_cache$191 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(dZ, [0, schematic_cache$191]);
		               var schematic_cache$192 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d0, [0, schematic_cache$192]);
		               var schematic_cache$193 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$123, [0, schematic_cache$193]);
		               function schematic_version$25(param){return 0;}
		               var
		                cst_choices = "choices",
		                cst_service_tier = "service_tier",
		                schematic_schema_version$154 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [dT[1][1], schematic_schema_version$154]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             dT[1][1],
		                             schematic_schema_version$154,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		dT[1][1],
		schematic_schema_version$154,
		schematic_self,
		function(b){
		 dT[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_service_tier,
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "system_fingerprint",
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0]];
		 return caml_exact_trampoline_cps_call
		         (usage_schema_versioned,
		          schematic_version$25,
		          function(c){
		           var
		            b = [0, [0, 0, 0, 0, 0, cst_usage, 0, 2, [0, c], 0, 0], a];
		           return caml_exact_trampoline_cps_call
		                   (choice_schema_versioned,
		                    schematic_version$25,
		                    function(a){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           c = b[2],
		                           d = c[2],
		                           e = d[2],
		                           system_fingerprint = e[2][1],
		                           service_tier = e[1],
		                           usage = d[1],
		                           choices = c[1],
		                           model = b[1],
		                           created = a[1],
		                           id = param[1];
		                          return cont
		                                  ([0,
		                                    id,
		                                    created,
		                                    model,
		                                    choices,
		                                    usage,
		                                    service_tier,
		                                    system_fingerprint]);
		                         },
		                         function(param, cont){
		                          var
		                           system_fingerprint = param[7],
		                           service_tier = param[6],
		                           usage = param[5],
		                           choices = param[4],
		                           model = param[3],
		                           created = param[2],
		                           id = param[1];
		                          return cont
		                                  ([0,
		                                    id,
		                                    [0,
		                                     created,
		                                     [0,
		                                      model,
		                                      [0,
		                                       choices,
		                                       [0, usage, [0, service_tier, [0, system_fingerprint, 0]]]]]]]);
		                         },
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_id,
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_created,
		                            0,
		                            2,
		                            [0, timestamp_schema_versioned()],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_model,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              cst_choices,
		                              0,
		                              2,
		                              [0, [0, 0, 0, [3, a], 0]],
		                              0,
		                              0],
		                             b]]]]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              dT[1][1],
		                              schematic_schema_version$154,
		                              res,
		                              function(a){dT[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (annotation_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (choice_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (completion_tokens_details_sche, [function(param){return 0;}]);
		               caml_callback
		                (finish_reason_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (message_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (url_citation_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (usage_schema_versioned, [function(param){return 0;}]);
		               caml_callback
		                (prompt_tokens_details_schema_v, [function(param){return 0;}]);
		               var cst_messages = "messages", d1 = [];
		               function schema_versioned$67(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   d1[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                d1[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d1[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            d1[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_model,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (message_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var model = param[2][1], messages = param[1];
		   return cont([0, messages, model]);
		  },
		  function(param, cont){
		   var model = param[2], messages = param[1];
		   return cont([0, messages, [0, model, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_messages,
		    0,
		    2,
		    [0, schema_versioned$7(schematic_version, b)],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       d1[1][1],
		       schematic_schema_version,
		       res,
		       function(a){d1[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Assistant = "Assistant",
		                cst_Developer = "Developer",
		                letrec_function_context$124 = [];
		               function message_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$124[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, AT, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$124[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$124[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$124[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                A5,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f2 = param[3], f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1, f2]);
		                                  },
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f2 = param[3], f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1, f2]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_assistant,
		                                  cst_Assistant,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      refusal = a[2][1],
		                                      name = a[1],
		                                      content = param[1];
		                                     return cont([0, content, name, refusal]);
		                                    },
		                                    function(param, cont){
		                                     var refusal = param[3], name = param[2], content = param[1];
		                                     return cont([0, content, [0, name, [0, refusal, 0]]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      A4,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_content,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       A3,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_name,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		A2,
		0,
		0,
		0,
		cst_refusal,
		0,
		3,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([1, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(1 !== param[0]) return cont(0);
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_developer,
		                                   cst_Developer,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var name = param[2][1], content = param[1];
		                                      return cont([0, content, name]);
		                                     },
		                                     function(param, cont){
		                                      var name = param[2], content = param[1];
		                                      return cont([0, content, [0, name, 0]]);
		                                     },
		                                     [0,
		                                      [0,
		                                       A1,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_content,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		A0,
		0,
		0,
		0,
		cst_name,
		0,
		3,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([2, f0, f1]);
		                                    },
		                                    function(param, cont){
		                                     if(2 !== param[0]) return cont(0);
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([0, [0, f0, f1]]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_system,
		                                    cst_System,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var name = param[2][1], content = param[1];
		                                       return cont([0, content, name]);
		                                      },
		                                      function(param, cont){
		                                       var name = param[2], content = param[1];
		                                       return cont([0, content, [0, name, 0]]);
		                                      },
		                                      [0,
		                                       [0,
		AZ,
		0,
		0,
		0,
		cst_content,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       [0,
		[0,
		 AY,
		 0,
		 0,
		 0,
		 cst_name,
		 0,
		 3,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		0]]],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){
		                                      var f1 = param[2], f0 = param[1];
		                                      return cont([3, f0, f1]);
		                                     },
		                                     function(param, cont){
		                                      if(3 !== param[0]) return cont(0);
		                                      var f1 = param[2], f0 = param[1];
		                                      return cont([0, [0, f0, f1]]);
		                                     },
		                                     1,
		                                     0,
		                                     "tool_call",
		                                     "Tool_call",
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var tool_call_id = param[2][1], content = param[1];
		return cont([0, content, tool_call_id]);
		                                       },
		                                       function(param, cont){
		var tool_call_id = param[2], content = param[1];
		return cont([0, content, [0, tool_call_id, 0]]);
		                                       },
		                                       [0,
		[0,
		 AX,
		 0,
		 0,
		 0,
		 cst_content,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		[0,
		 [0,
		  AW,
		  0,
		  0,
		  0,
		  "tool_call_id",
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 0]]],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){
		                                       var f1 = param[2], f0 = param[1];
		                                       return cont([4, f0, f1]);
		                                      },
		                                      function(param, cont){
		                                       if(4 !== param[0]) return cont(0);
		                                       var f1 = param[2], f0 = param[1];
		                                       return cont([0, [0, f0, f1]]);
		                                      },
		                                      1,
		                                      0,
		                                      cst_user,
		                                      cst_User,
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){
		 var name = param[2][1], content = param[1];
		 return cont([0, content, name]);
		},
		function(param, cont){
		 var name = param[2], content = param[1];
		 return cont([0, content, [0, name, 0]]);
		},
		[0,
		 [0,
		  AV,
		  0,
		  0,
		  0,
		  cst_content,
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 [0,
		  [0,
		   AU,
		   0,
		   0,
		   0,
		   cst_name,
		   0,
		   3,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  0]]],
		                                       0],
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$124[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$124[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$194 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d1, [0, schematic_cache$194]);
		               var schematic_cache$195 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$124, [0, schematic_cache$195]);
		               caml_callback
		                (schema_versioned$67,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (message_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function equal$45(lhs, rhs, cont){
		                var
		                 rhsend_index = rhs[4],
		                 rhsstart_index = rhs[3],
		                 rhstitle = rhs[2],
		                 rhsurl = rhs[1],
		                 lhsend_index = lhs[4],
		                 lhsstart_index = lhs[3],
		                 lhstitle = lhs[2],
		                 lhsurl = lhs[1],
		                 c = lhsurl === rhsurl ? 1 : 0;
		                a:
		                if(c){
		                 if(lhstitle){
		                  if(rhstitle){
		                   var b = rhstitle[1], a = lhstitle[1], c = a === b ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! rhstitle){c = 1; break a;}
		                 c = 0;
		                }
		                c = c ? lhsstart_index === rhsstart_index ? 1 : 0 : c;
		                return c
		                        ? cont(lhsend_index === rhsend_index ? 1 : 0)
		                        : cont(c);
		               }
		               var letrec_function_context$125 = [];
		               function schema_versioned$68(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$125[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, A7, A6, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$125[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$125[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$125[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                A8,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, f0, f1, f2, f3]);
		                                  },
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, [0, f0, f1, f2, f3]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_url_citation,
		                                  cst_Url_citation,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      b = a[2],
		                                      end_index = b[2][1],
		                                      start_index = b[1],
		                                      title = a[1],
		                                      url = param[1];
		                                     return cont([0, url, title, start_index, end_index]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      end_index = param[4],
		                                      start_index = param[3],
		                                      title = param[2],
		                                      url = param[1];
		                                     return cont
		     ([0, url, [0, title, [0, start_index, [0, end_index, 0]]]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_url,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_title,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_start_index,
		0,
		2,
		[0, int_schema],
		0,
		0],
		                                       [0,
		[0, 0, 0, 0, 0, cst_end_index, 0, 2, [0, int_schema], 0, 0],
		0]]]]],
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$125[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$125[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$196 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$125, [0, schematic_cache$196]);
		               caml_callback
		                (schema_versioned$68,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$126 = [];
		               function string_or_json_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$126[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, A9, 0, descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$126[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$126[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$126[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  "json_string",
		                                  "Json_string",
		                                  schematic_param_name_schema_ve,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(0 === param[0]) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   0,
		                                   0,
		                                   cst_json,
		                                   cst_Json,
		                                   no_input_schema,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$126[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$126[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$197 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$126, [0, schematic_cache$197]);
		               caml_callback
		                (string_or_json_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$69(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (string_or_json_schema_versione,
		                         v,
		                         function(a){
		                          return cont
		                                  (map$14
		                                    (function(param, cont){
		                                      if(0 === param[0]){
		                                       var s = param[1];
		                                       return caml_exact_trampoline_cps_call(of_string$11, s, cont);
		                                      }
		                                      var j = param[1];
		                                      return cont([0, j]);
		                                     },
		                                     function(j, cont){return cont([1, j]);},
		                                     a));
		                         });
		               }
		               caml_callback
		                (schema_versioned$69,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$127 = [];
		               function schema_versioned$70(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$127[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, A$, A_, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$127[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$127[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$127[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(948354667);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 948354667 === param)
		                                    return cont(Bh);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_user,
		                                  cst_User,
		                                  Bg,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(-291661378);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && -291661378 === param)
		                                     return cont(Bf);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_assistant,
		                                   cst_Assistant,
		                                   Be,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(662113039);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 662113039 === param)
		                                      return cont(Bd);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_system,
		                                    cst_System,
		                                    Bc,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(519160618);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 519160618 === param)
		                                       return cont(Bb);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_developer,
		                                     cst_Developer,
		                                     Ba,
		                                     0],
		                                    0]]]],
		                                1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$127[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$127[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$198 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$127, [0, schematic_cache$198]);
		               caml_callback
		                (schema_versioned$70,
		                 [function(param, cont){return cont(0);}]);
		               function equal$46(a, b, cont){return cont(a === b ? 1 : 0);}
		               function schema_versioned$71(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    ai,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                cst_image_url = "image_url",
		                letrec_function_context$128 = [];
		               function schema_versioned$72(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$128[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Bi, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$128[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$128[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$128[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                Bl,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  "input_text",
		                                  "Input_text",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var text = param[1];
		                                     return cont(text);
		                                    },
		                                    function(text, cont){return cont([0, text, 0]);},
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_text,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(1 !== param[0]) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   1,
		                                   0,
		                                   "input_image",
		                                   "Input_image",
		                                   [0,
		                                    0,
		                                    Bk,
		                                    [7,
		                                     function(param, cont){
		                                      var image_url = param[1];
		                                      return cont(image_url);
		                                     },
		                                     function(image_url, cont){return cont([0, image_url, 0]);},
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_image_url, 0, 2, [0, schema$268], 0, 0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([2, f0]);},
		                                    function(param, cont){
		                                     if(2 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    "input_file",
		                                    "Input_file",
		                                    [0,
		                                     0,
		                                     Bj,
		                                     [7,
		                                      function(param, cont){
		                                       var file_url = param[1];
		                                       return cont(file_url);
		                                      },
		                                      function(file_url, cont){return cont([0, file_url, 0]);},
		                                      [0,
		                                       [0, 0, 0, 0, 0, "file_url", 0, 2, [0, schema$268], 0, 0],
		                                       0]],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$128[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$128[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$199 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$128, [0, schematic_cache$199]);
		               caml_callback
		                (schema_versioned$72,
		                 [function(param, cont){return cont(0);}]);
		               var cst_strict = "strict", letrec_function_context$129 = [];
		               function schema_versioned$73(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$129[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Bm, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$129[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$129[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$129[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  strict = b[2][1],
		                                  schema = b[1],
		                                  name = a[1],
		                                  type = param[1];
		                                 return cont([0, type, name, schema, strict]);
		                                },
		                                function(param, cont){
		                                 var
		                                  strict = param[4],
		                                  schema = param[3],
		                                  name = param[2],
		                                  type = param[1];
		                                 return cont
		 ([0, type, [0, name, [0, schema, [0, strict, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_schema$0,
		                                    0,
		                                    2,
		                                    [0, no_input_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_strict, 0, 3, [0, bool_schema], 0, 0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$129[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$129[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$200 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$129, [0, schematic_cache$200]);
		               caml_callback
		                (schema_versioned$73,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$130 = [];
		               function schema_versioned$74(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$130[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Bn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$130[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$130[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$130[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$73,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var format = param[1];
		   return cont([0, format]);
		  },
		  function(param, cont){
		   var format = param[1];
		   return cont([0, format, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_format, 0, 3, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$130[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$130[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$201 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$130, [0, schematic_cache$201]);
		               caml_callback
		                (schema_versioned$74,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$131 = [];
		               function effort_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$131[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Bo, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$131[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$131[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$131[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(BA);},
		                                  0,
		                                  0,
		                                  cst_none,
		                                  cst_None,
		                                  Bz,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(By) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_low,
		                                   "Low",
		                                   Bx,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(Bw) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_medium,
		                                    "Medium",
		                                    Bv,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(Bu) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_high,
		                                     "High",
		                                     Bt,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(Bs) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_xhigh,
		                                      "Xhigh",
		                                      Br,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 <= param ? cont(Bq) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_max,
		                                       cst_Max,
		                                       Bp,
		                                       0],
		                                      0]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$131[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$131[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$202 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$131, [0, schematic_cache$202]);
		               caml_callback
		                (effort_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$132 = [];
		               function schema_versioned$75(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$132[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$132[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$132[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$132[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (effort_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var effort = param[1];
		   return cont([0, effort]);
		  },
		  function(param, cont){
		   var effort = param[1];
		   return cont([0, effort, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_effort, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$132[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$132[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$203 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$132, [0, schematic_cache$203]);
		               caml_callback
		                (schema_versioned$75,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_parameters = "parameters",
		                letrec_function_context$133 = [];
		               function schema_versioned$76(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$133[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$133[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$133[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$133[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  allowed_callers = e[2][1],
		                                  defer_loading = e[1],
		                                  strict = d[1],
		                                  output_schema = c[1],
		                                  parameters = b[1],
		                                  description = a[1],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   description,
		   parameters,
		   output_schema,
		   strict,
		   defer_loading,
		   allowed_callers]);
		                                },
		                                function(param, cont){
		                                 var
		                                  allowed_callers = param[7],
		                                  defer_loading = param[6],
		                                  strict = param[5],
		                                  output_schema = param[4],
		                                  parameters = param[3],
		                                  description = param[2],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   [0,
		    description,
		    [0,
		     parameters,
		     [0,
		      output_schema,
		      [0, strict, [0, defer_loading, [0, allowed_callers, 0]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_description,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_parameters,
		                                    0,
		                                    3,
		                                    [0, no_input_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "output_schema",
		                                     0,
		                                     3,
		                                     [0, no_input_schema],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_strict, 0, 3, [0, bool_schema], 0, 0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       "defer_loading",
		                                       0,
		                                       3,
		                                       [0, bool_schema],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		"allowed_callers",
		0,
		3,
		[0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		0,
		0],
		                                       0]]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$133[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$133[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$204 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$133, [0, schematic_cache$204]);
		               caml_callback
		                (schema_versioned$76,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Function = "Function",
		                letrec_function_context$134 = [];
		               function fn_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$134[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$134[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$134[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$134[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$76,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  BE,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_function,
		    cst_Function,
		    a,
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$134[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$134[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$205 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$134, [0, schematic_cache$205]);
		               caml_callback
		                (fn_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$135 = [];
		               function schema_versioned$77(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$135[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BF, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$135[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$135[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$135[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (fn_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    tools = a[2][1],
		    description = a[1],
		    name = param[1];
		   return cont([0, name, description, tools]);
		  },
		  function(param, cont){
		   var
		    tools = param[3],
		    description = param[2],
		    name = param[1];
		   return cont([0, name, [0, description, [0, tools, 0]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_description,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_tools,
		      0,
		      2,
		      [0, [0, 0, 0, [3, a], 0]],
		      0,
		      0],
		     0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$135[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$135[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$206 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$135, [0, schematic_cache$206]);
		               caml_callback
		                (schema_versioned$77,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_execution = "execution",
		                letrec_function_context$136 = [];
		               function schema_versioned$78(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$136[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$136[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$136[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$136[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var description = param[2][1], execution = param[1];
		                                 return cont([0, execution, description]);
		                                },
		                                function(param, cont){
		                                 var description = param[2], execution = param[1];
		                                 return cont([0, execution, [0, description, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_execution,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_description,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$136[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$136[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$207 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$136, [0, schematic_cache$207]);
		               caml_callback
		                (schema_versioned$78,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$137 = [];
		               function schema_versioned$79(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$137[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BH, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$137[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$137[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$137[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var search_context_size = param[1];
		                                 return cont([0, search_context_size]);
		                                },
		                                function(param, cont){
		                                 var search_context_size = param[1];
		                                 return cont([0, search_context_size, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  BI,
		                                  0,
		                                  0,
		                                  0,
		                                  "search_context_size",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$137[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$137[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$208 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$137, [0, schematic_cache$208]);
		               caml_callback
		                (schema_versioned$79,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$138 = [];
		               function schema_versioned$80(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$138[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$138[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$138[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$138[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var enabled = param[1];
		                                 return cont([0, enabled]);
		                                },
		                                function(param, cont){
		                                 var enabled = param[1];
		                                 return cont([0, enabled, 0]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_enabled, 0, 3, [0, bool_schema], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$138[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$138[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$209 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$138, [0, schematic_cache$209]);
		               caml_callback
		                (schema_versioned$80,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$139 = [];
		               function schema_versioned$81(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$139[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$139[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$139[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$139[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$80,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(4 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_programmatic_tool_calling,
		   "Programmatic_tool_calling",
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$79,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_web_search,
		             "Web_search",
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$78,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_tool_search,
		                       "Tool_search",
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$77,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_namespace,
		                                 "Namespace",
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$76,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  BL,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_function,
		    cst_Function,
		    a,
		    0],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$139[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$139[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$210 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$139, [0, schematic_cache$210]);
		               caml_callback
		                (schema_versioned$81,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Program = "Program",
		                cst_program = "program",
		                letrec_function_context$140 = [];
		               function schema_versioned$82(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$140[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BM, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$140[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$140[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$140[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                BO,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(BN);},
		                                  0,
		                                  0,
		                                  cst_direct,
		                                  "Direct",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(! param) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_program,
		                                   cst_Program,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var caller_id = param[1];
		                                      return cont(caller_id);
		                                     },
		                                     function(caller_id, cont){return cont([0, caller_id, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       "caller_id",
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$140[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$140[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$211 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$140, [0, schematic_cache$211]);
		               caml_callback
		                (schema_versioned$82,
		                 [function(param, cont){return cont(0);}]);
		               var d2 = [];
		               function client_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   d2[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                d2[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d2[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            d2[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_service_tier,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$75,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0, [0, 0, 0, 0, 0, cst_reasoning, 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$74,
		       schematic_version,
		       function(d){
		        var
		         a =
		           [0,
		            [0,
		             0,
		             0,
		             mapping_schema(schematic_param_name_schema_ve)[3],
		             0]],
		         default$ = match$102[1],
		         c =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             "tool_choice",
		             0,
		             3,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0,
		             [0,
		              BQ,
		              0,
		              0,
		              0,
		              "parallel_tool_calls",
		              0,
		              3,
		              [0, bool_schema],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, cst_metadata, 0, [0, default$], a, 0, 0],
		              [0, [0, 0, 0, 0, 0, cst_text, 0, 3, [0, d], 0, 0], b]]]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$81,
		                 schematic_version,
		                 function(b){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_tools,
		                       0,
		                       3,
		                       [0, [0, 0, 0, [3, b], 0]],
		                       0,
		                       0],
		                      c];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$71,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, "previous_response_id", 0, 3, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (input_item_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    service_tier = h[2][1],
		    reasoning = h[1],
		    text = g[1],
		    metadata = f[1],
		    parallel_tool_calls = e[1],
		    tool_choice = d[1],
		    tools = c[1],
		    previous_response_id = b[1],
		    input = a[1],
		    model = param[1];
		   return cont
		           ([0,
		             model,
		             input,
		             previous_response_id,
		             tools,
		             tool_choice,
		             parallel_tool_calls,
		             metadata,
		             text,
		             reasoning,
		             service_tier]);
		  },
		  function(param, cont){
		   var
		    service_tier = param[10],
		    reasoning = param[9],
		    text = param[8],
		    metadata = param[7],
		    parallel_tool_calls = param[6],
		    tool_choice = param[5],
		    tools = param[4],
		    previous_response_id = param[3],
		    input = param[2],
		    model = param[1];
		   return cont
		           ([0,
		             model,
		             [0,
		              input,
		              [0,
		               previous_response_id,
		               [0,
		                tools,
		                [0,
		                 tool_choice,
		                 [0,
		                  parallel_tool_calls,
		                  [0,
		                   metadata,
		                   [0, text, [0, reasoning, [0, service_tier, 0]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_model,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_input,
		     0,
		     2,
		     [0, [0, 0, 0, [3, a], 0]],
		     0,
		     0],
		    b]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       d2[1][1],
		       schematic_schema_version,
		       res,
		       function(a){d2[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_call_id = "call_id",
		                cst_function_call_output = "function_call_output",
		                letrec_function_context$141 = [];
		               function input_item_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$141[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BS, BR, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$141[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$141[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$141[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$72,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   BT,
		   0,
		   0,
		   0,
		   cst_content,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$70,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([2, f0, f1]);
		             },
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             "user_message_with_parts",
		             "User_message_with_parts",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var content = param[2][1], role = param[1];
		                return cont([0, role, content]);
		               },
		               function(param, cont){
		                var content = param[2], role = param[1];
		                return cont([0, role, [0, content, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_role, 0, 2, [0, c], 0, 0], a]],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$82,
		                 schematic_version,
		                 function(d){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var
		                         f3 = param[4],
		                         f2 = param[3],
		                         f1 = param[2],
		                         f0 = param[1];
		                        return cont([1, f0, f1, f2, f3]);
		                       },
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var
		                         f3 = param[4],
		                         f2 = param[3],
		                         f1 = param[2],
		                         f0 = param[1];
		                        return cont([0, [0, f0, f1, f2, f3]]);
		                       },
		                       1,
		                       0,
		                       cst_function_call_output,
		                       "Function_call_output",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           caller = b[2][1],
		                           output = b[1],
		                           call_id = a[1],
		                           type = param[1];
		                          return cont([0, type, call_id, output, caller]);
		                         },
		                         function(param, cont){
		                          var
		                           caller = param[4],
		                           output = param[3],
		                           call_id = param[2],
		                           type = param[1];
		                          return cont
		                                  ([0, type, [0, call_id, [0, output, [0, caller, 0]]]]);
		                         },
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_type,
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_call_id,
		                            0,
		                            2,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_output,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0, [0, 0, 0, 0, 0, cst_caller, 0, 3, [0, d], 0, 0], 0]]]]],
		                        0],
		                       0],
		                      b],
		                   c =
		                     [0,
		                      [0,
		                       BU,
		                       0,
		                       0,
		                       0,
		                       cst_content,
		                       0,
		                       2,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$70,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1]]);
		                                  },
		                                  1,
		                                  0,
		                                  "simple_message",
		                                  "Simple_message",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var content = param[2][1], role = param[1];
		                                     return cont([0, role, content]);
		                                    },
		                                    function(param, cont){
		                                     var content = param[2], role = param[1];
		                                     return cont([0, role, [0, content, 0]]);
		                                    },
		                                    [0, [0, 0, 0, 0, 0, cst_role, 0, 2, [0, b], 0, 0], c]],
		                                   0],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$141[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$141[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$212 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d2, [0, schematic_cache$212]);
		               var
		                schematic_cache$213 = [0, empty$11([0, comparator$9])],
		                d3 = [];
		               caml_update_dummy(d3, [0, schematic_cache$213]);
		               var schematic_cache$214 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$141, [0, schematic_cache$214]);
		               caml_callback
		                (client_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$26(param, cont){return cont(0);}
		               var cst_client = "client", schematic_schema_version$153 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [d3[1][1], schematic_schema_version$153]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             d3[1][1],
		                             schematic_schema_version$153,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		d3[1][1],
		schematic_schema_version$153,
		schematic_self,
		function(a){
		 d3[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          schematic_param_name_schema_ve,
		          function(b){
		           var
		            default$ = match$103[1],
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                "safety_identifier",
		                0,
		                [0, default$],
		                [0, b],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (client_schema_versioned,
		                    schematic_version$26,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var safety_identifier = param[2][1], client = param[1];
		                          return cont([0, client, safety_identifier]);
		                         },
		                         function(param, cont){
		                          var safety_identifier = param[2], client = param[1];
		                          return cont([0, client, [0, safety_identifier, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_client, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              d3[1][1],
		                              schematic_schema_version$153,
		                              res,
		                              function(a){d3[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (input_item_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$142 = [];
		               function schema_versioned$83(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$142[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BV, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$142[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$142[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$142[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var cached_tokens = param[1];
		                                 return cont([0, cached_tokens]);
		                                },
		                                function(param, cont){
		                                 var cached_tokens = param[1];
		                                 return cont([0, cached_tokens, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_cached_tokens,
		                                  0,
		                                  2,
		                                  [0, int_schema],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$142[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$142[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$215 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$142, [0, schematic_cache$215]);
		               caml_callback
		                (schema_versioned$83,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$143 = [];
		               function schema_versioned$84(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$143[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$143[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$143[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$143[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var reasoning_tokens = param[1];
		                                 return cont([0, reasoning_tokens]);
		                                },
		                                function(param, cont){
		                                 var reasoning_tokens = param[1];
		                                 return cont([0, reasoning_tokens, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_reasoning_tokens,
		                                  0,
		                                  2,
		                                  [0, int_schema],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$143[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$143[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$216 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$143, [0, schematic_cache$216]);
		               caml_callback
		                (schema_versioned$84,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$144 = [];
		               function schema_versioned$85(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$144[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$144[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$144[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$144[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$84,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$104[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_output_tokens_details,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$83,
		       schematic_version,
		       function(b){
		        var
		         default$ = match$105[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              output_tokens_details = c[2][1],
		              input_tokens_details = c[1],
		              total_tokens = b[1],
		              output_tokens = a[1],
		              input_tokens = param[1];
		             return cont
		                     ([0,
		                       input_tokens,
		                       output_tokens,
		                       total_tokens,
		                       input_tokens_details,
		                       output_tokens_details]);
		            },
		            function(param, cont){
		             var
		              output_tokens_details = param[5],
		              input_tokens_details = param[4],
		              total_tokens = param[3],
		              output_tokens = param[2],
		              input_tokens = param[1];
		             return cont
		                     ([0,
		                       input_tokens,
		                       [0,
		                        output_tokens,
		                        [0,
		                         total_tokens,
		                         [0, input_tokens_details, [0, output_tokens_details, 0]]]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, "input_tokens", 0, 2, [0, int_schema], 0, 0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               "output_tokens",
		               0,
		               2,
		               [0, int_schema],
		               0,
		               0],
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_total_tokens,
		                0,
		                2,
		                [0, int_schema],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_input_tokens_details,
		                 0,
		                 [0, default$],
		                 [0, b],
		                 0,
		                 0],
		                a]]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$144[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$144[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$217 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$144, [0, schematic_cache$217]);
		               caml_callback
		                (schema_versioned$85,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Function_call = "Function_call",
		                cst_Message = "Message",
		                cst_Program_output = "Program_output",
		                cst_Reasoning = "Reasoning",
		                cst_Tool_search_call = "Tool_search_call",
		                cst_Tool_search_output = "Tool_search_output",
		                cst_Web_search_call = "Web_search_call",
		                cst_fingerprint = "fingerprint",
		                cst_function_call = "function_call",
		                cst_program_output = "program_output",
		                cst_tool_search_call = "tool_search_call",
		                cst_tool_search_output = "tool_search_output",
		                cst_web_search_call = "web_search_call",
		                d5 = [];
		               function output_item_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   d5[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, BY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                d5[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d5[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            d5[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([2, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_tool_search_call,
		                                 cst_Tool_search_call,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var call_id = param[2][1], id = param[1];
		                                    return cont([0, id, call_id]);
		                                   },
		                                   function(param, cont){
		                                    var call_id = param[2], id = param[1];
		                                    return cont([0, id, [0, call_id, 0]]);
		                                   },
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_id,
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_call_id,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([3, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(3 !== param[0]) return cont(0);
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_tool_search_output,
		                                  cst_Tool_search_output,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var call_id = param[2][1], id = param[1];
		                                     return cont([0, id, call_id]);
		                                    },
		                                    function(param, cont){
		                                     var call_id = param[2], id = param[1];
		                                     return cont([0, id, [0, call_id, 0]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_id,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_call_id,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([4, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(4 !== param[0]) return cont(0);
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_web_search_call,
		                                   cst_Web_search_call,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var status = param[2][1], id = param[1];
		                                      return cont([0, id, status]);
		                                     },
		                                     function(param, cont){
		                                      var status = param[2], id = param[1];
		                                      return cont([0, id, [0, status, 0]]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_id,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_status,
		0,
		3,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([5, f0]);},
		                                    function(param, cont){
		                                     if(5 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_reasoning,
		                                    cst_Reasoning,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){var id = param[1]; return cont(id);},
		                                      function(id, cont){return cont([0, id, 0]);},
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_id,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){
		                                      var
		                                       f3 = param[4],
		                                       f2 = param[3],
		                                       f1 = param[2],
		                                       f0 = param[1];
		                                      return cont([6, f0, f1, f2, f3]);
		                                     },
		                                     function(param, cont){
		                                      if(6 !== param[0]) return cont(0);
		                                      var
		                                       f3 = param[4],
		                                       f2 = param[3],
		                                       f1 = param[2],
		                                       f0 = param[1];
		                                      return cont([0, [0, f0, f1, f2, f3]]);
		                                     },
		                                     1,
		                                     0,
		                                     cst_program,
		                                     cst_Program,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var
		 a = param[2],
		 b = a[2],
		 fingerprint = b[2][1],
		 code = b[1],
		 call_id = a[1],
		 id = param[1];
		return cont([0, id, call_id, code, fingerprint]);
		                                       },
		                                       function(param, cont){
		var
		 fingerprint = param[4],
		 code = param[3],
		 call_id = param[2],
		 id = param[1];
		return cont
		        ([0, id, [0, call_id, [0, code, [0, fingerprint, 0]]]]);
		                                       },
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_id,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_call_id,
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_code,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_fingerprint,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   0]]]]],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){
		                                       var
		f3 = param[4],
		f2 = param[3],
		f1 = param[2],
		f0 = param[1];
		                                       return cont([7, f0, f1, f2, f3]);
		                                      },
		                                      function(param, cont){
		                                       if(7 !== param[0]) return cont(0);
		                                       var
		f3 = param[4],
		f2 = param[3],
		f1 = param[2],
		f0 = param[1];
		                                       return cont([0, [0, f0, f1, f2, f3]]);
		                                      },
		                                      1,
		                                      0,
		                                      cst_program_output,
		                                      cst_Program_output,
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){
		 var
		  a = param[2],
		  b = a[2],
		  status = b[2][1],
		  result = b[1],
		  call_id = a[1],
		  id = param[1];
		 return cont([0, id, call_id, result, status]);
		},
		function(param, cont){
		 var
		  status = param[4],
		  result = param[3],
		  call_id = param[2],
		  id = param[1];
		 return cont
		         ([0, id, [0, call_id, [0, result, [0, status, 0]]]]);
		},
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_id,
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_call_id,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_result,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_status,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    0]]]]],
		                                       0],
		                                      0],
		                                     0]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (content_item_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_message,
		   cst_Message,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var content = param[1];
		      return cont(content);
		     },
		     function(content, cont){return cont([0, content, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_content,
		       0,
		       2,
		       [0, [0, 0, 0, [3, c], 0]],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$82,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, 0, 0, 0, 0, cst_caller, 0, 3, [0, c], 0, 0], 0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$69,
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [11,
		                      BZ,
		                      [0,
		                       [0,
		                        function(param, cont){
		                         var
		                          f3 = param[4],
		                          f2 = param[3],
		                          f1 = param[2],
		                          f0 = param[1];
		                         return cont([0, f0, f1, f2, f3]);
		                        },
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var
		                          f3 = param[4],
		                          f2 = param[3],
		                          f1 = param[2],
		                          f0 = param[1];
		                         return cont([0, [0, f0, f1, f2, f3]]);
		                        },
		                        1,
		                        0,
		                        cst_function_call,
		                        cst_Function_call,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            b = a[2],
		                            caller = b[2][1],
		                            arguments$ = b[1],
		                            name = a[1],
		                            call_id = param[1];
		                           return cont([0, call_id, name, arguments$, caller]);
		                          },
		                          function(param, cont){
		                           var
		                            caller = param[4],
		                            arguments$ = param[3],
		                            name = param[2],
		                            call_id = param[1];
		                           return cont
		                                   ([0, call_id, [0, name, [0, arguments$, [0, caller, 0]]]]);
		                          },
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_call_id,
		                            0,
		                            2,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_name,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0, [0, 0, 0, 0, 0, cst_arguments, 0, 2, [0, c], 0, 0], a]]]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d5[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){d5[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Output_text = "Output_text",
		                cst_output_text = "output_text",
		                letrec_function_context$145 = [];
		               function content_item_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$145[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, B0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$145[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$145[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$145[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$68,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       default$ = match$108[1],
		                                       res =
		 [11,
		  B1,
		  [0,
		   [0,
		    function(param, cont){
		     var f1 = param[2], f0 = param[1];
		     return cont([0, f0, f1]);
		    },
		    function(param, cont){
		     var f1 = param[2], f0 = param[1];
		     return cont([0, [0, f0, f1]]);
		    },
		    1,
		    0,
		    cst_output_text,
		    cst_Output_text,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var annotations = param[2][1], text = param[1];
		       return cont([0, text, annotations]);
		      },
		      function(param, cont){
		       var annotations = param[2], text = param[1];
		       return cont([0, text, [0, annotations, 0]]);
		      },
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_text,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_annotations,
		         0,
		         [0, default$],
		         [0, [0, 0, 0, [3, a], 0]],
		         0,
		         0],
		        0]]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$145[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$145[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$218 = [0, empty$11([0, comparator$9])],
		                d4 = [];
		               caml_update_dummy(d4, [0, schematic_cache$218]);
		               var schematic_cache$219 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d5, [0, schematic_cache$219]);
		               var schematic_cache$220 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$145, [0, schematic_cache$220]);
		               function schematic_version$27(param, cont){return cont(0);}
		               var schematic_schema_version$152 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [d4[1][1], schematic_schema_version$152]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             d4[1][1],
		                             schematic_schema_version$152,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		d4[1][1],
		schematic_schema_version$152,
		schematic_self,
		function(a){
		 d4[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          schematic_param_name_schema_ve,
		          function(b){
		           var
		            default$ = match$106[1],
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_service_tier,
		                0,
		                [0, default$],
		                [0, b],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$85,
		                    schematic_version$27,
		                    function(b){
		                     return caml_exact_trampoline_cps_call
		                             (option_schema,
		                              b,
		                              function(c){
		                               var
		                                default$ = match$107[1],
		                                b =
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_usage, 0, [0, default$], [0, c], 0, 0],
		                                   a];
		                               return caml_exact_trampoline_cps_call
		                                       (output_item_schema_versioned,
		schematic_version$27,
		function(a){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       service_tier = b[2][1],
		       usage = b[1],
		       output = a[1],
		       id = param[1];
		      return cont([0, id, output, usage, service_tier]);
		     },
		     function(param, cont){
		      var
		       service_tier = param[4],
		       usage = param[3],
		       output = param[2],
		       id = param[1];
		      return cont
		              ([0, id, [0, output, [0, usage, [0, service_tier, 0]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_id,
		       0,
		       2,
		       [0,
		        [0,
		         ai,
		         0,
		         schematic_param_name_schema_ve[3],
		         schematic_param_name_schema_ve[4]]],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_output,
		        0,
		        2,
		        [0, [0, 0, 0, [3, a], 0]],
		        0,
		        0],
		       b]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          d4[1][1],
		          schematic_schema_version$152,
		          res,
		          function(a){d4[1][1] = a; return cont(res);});
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (output_item_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (content_item_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var d7 = [];
		               function output_item_schema_versioned$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   d7[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, B2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                d7[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d7[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            d7[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([2, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_tool_search_call,
		                                 cst_Tool_search_call,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var call_id = param[2][1], id = param[1];
		                                    return cont([0, id, call_id]);
		                                   },
		                                   function(param, cont){
		                                    var call_id = param[2], id = param[1];
		                                    return cont([0, id, [0, call_id, 0]]);
		                                   },
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_id,
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_call_id,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([3, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(3 !== param[0]) return cont(0);
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_tool_search_output,
		                                  cst_Tool_search_output,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var call_id = param[2][1], id = param[1];
		                                     return cont([0, id, call_id]);
		                                    },
		                                    function(param, cont){
		                                     var call_id = param[2], id = param[1];
		                                     return cont([0, id, [0, call_id, 0]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_id,
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_call_id,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([4, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(4 !== param[0]) return cont(0);
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_web_search_call,
		                                   cst_Web_search_call,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var status = param[2][1], id = param[1];
		                                      return cont([0, id, status]);
		                                     },
		                                     function(param, cont){
		                                      var status = param[2], id = param[1];
		                                      return cont([0, id, [0, status, 0]]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_id,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_status,
		0,
		3,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([5, f0]);},
		                                    function(param, cont){
		                                     if(5 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_reasoning,
		                                    cst_Reasoning,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){var id = param[1]; return cont(id);},
		                                      function(id, cont){return cont([0, id, 0]);},
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_id,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){
		                                      var
		                                       f3 = param[4],
		                                       f2 = param[3],
		                                       f1 = param[2],
		                                       f0 = param[1];
		                                      return cont([6, f0, f1, f2, f3]);
		                                     },
		                                     function(param, cont){
		                                      if(6 !== param[0]) return cont(0);
		                                      var
		                                       f3 = param[4],
		                                       f2 = param[3],
		                                       f1 = param[2],
		                                       f0 = param[1];
		                                      return cont([0, [0, f0, f1, f2, f3]]);
		                                     },
		                                     1,
		                                     0,
		                                     cst_program,
		                                     cst_Program,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var
		 a = param[2],
		 b = a[2],
		 fingerprint = b[2][1],
		 code = b[1],
		 call_id = a[1],
		 id = param[1];
		return cont([0, id, call_id, code, fingerprint]);
		                                       },
		                                       function(param, cont){
		var
		 fingerprint = param[4],
		 code = param[3],
		 call_id = param[2],
		 id = param[1];
		return cont
		        ([0, id, [0, call_id, [0, code, [0, fingerprint, 0]]]]);
		                                       },
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_id,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_call_id,
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_code,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_fingerprint,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   0]]]]],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){
		                                       var
		f3 = param[4],
		f2 = param[3],
		f1 = param[2],
		f0 = param[1];
		                                       return cont([7, f0, f1, f2, f3]);
		                                      },
		                                      function(param, cont){
		                                       if(7 !== param[0]) return cont(0);
		                                       var
		f3 = param[4],
		f2 = param[3],
		f1 = param[2],
		f0 = param[1];
		                                       return cont([0, [0, f0, f1, f2, f3]]);
		                                      },
		                                      1,
		                                      0,
		                                      cst_program_output,
		                                      cst_Program_output,
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){
		 var
		  a = param[2],
		  b = a[2],
		  status = b[2][1],
		  result = b[1],
		  call_id = a[1],
		  id = param[1];
		 return cont([0, id, call_id, result, status]);
		},
		function(param, cont){
		 var
		  status = param[4],
		  result = param[3],
		  call_id = param[2],
		  id = param[1];
		 return cont
		         ([0, id, [0, call_id, [0, result, [0, status, 0]]]]);
		},
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_id,
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_call_id,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_result,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_status,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    0]]]]],
		                                       0],
		                                      0],
		                                     0]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (content_item_schema_versioned$0,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_message,
		   cst_Message,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var content = param[1];
		      return cont(content);
		     },
		     function(content, cont){return cont([0, content, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_content,
		       0,
		       2,
		       [0, [0, 0, 0, [3, c], 0]],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$82,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, 0, 0, 0, 0, cst_caller, 0, 3, [0, c], 0, 0], 0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$69,
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [11,
		                      B3,
		                      [0,
		                       [0,
		                        function(param, cont){
		                         var
		                          f3 = param[4],
		                          f2 = param[3],
		                          f1 = param[2],
		                          f0 = param[1];
		                         return cont([0, f0, f1, f2, f3]);
		                        },
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var
		                          f3 = param[4],
		                          f2 = param[3],
		                          f1 = param[2],
		                          f0 = param[1];
		                         return cont([0, [0, f0, f1, f2, f3]]);
		                        },
		                        1,
		                        0,
		                        cst_function_call,
		                        cst_Function_call,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            b = a[2],
		                            caller = b[2][1],
		                            arguments$ = b[1],
		                            name = a[1],
		                            call_id = param[1];
		                           return cont([0, call_id, name, arguments$, caller]);
		                          },
		                          function(param, cont){
		                           var
		                            caller = param[4],
		                            arguments$ = param[3],
		                            name = param[2],
		                            call_id = param[1];
		                           return cont
		                                   ([0, call_id, [0, name, [0, arguments$, [0, caller, 0]]]]);
		                          },
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_call_id,
		                            0,
		                            2,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_name,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0, [0, 0, 0, 0, 0, cst_arguments, 0, 2, [0, c], 0, 0], a]]]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d7[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){d7[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$146 = [];
		               function content_item_schema_versioned$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$146[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, B4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$146[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$146[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$146[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$68,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       default$ = match$111[1],
		                                       res =
		 [11,
		  B5,
		  [0,
		   [0,
		    function(param, cont){
		     var f1 = param[2], f0 = param[1];
		     return cont([0, f0, f1]);
		    },
		    function(param, cont){
		     var f1 = param[2], f0 = param[1];
		     return cont([0, [0, f0, f1]]);
		    },
		    1,
		    0,
		    cst_output_text,
		    cst_Output_text,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var annotations = param[2][1], text = param[1];
		       return cont([0, text, annotations]);
		      },
		      function(param, cont){
		       var annotations = param[2], text = param[1];
		       return cont([0, text, [0, annotations, 0]]);
		      },
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_text,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_annotations,
		         0,
		         [0, default$],
		         [0, [0, 0, 0, [3, a], 0]],
		         0,
		         0],
		        0]]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$146[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$146[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$221 = [0, empty$11([0, comparator$9])],
		                d6 = [];
		               caml_update_dummy(d6, [0, schematic_cache$221]);
		               var schematic_cache$222 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d7, [0, schematic_cache$222]);
		               var schematic_cache$223 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$146, [0, schematic_cache$223]);
		               function schematic_version$28(param, cont){return cont(0);}
		               var schematic_schema_version$151 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [d6[1][1], schematic_schema_version$151]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             d6[1][1],
		                             schematic_schema_version$151,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		d6[1][1],
		schematic_schema_version$151,
		schematic_self,
		function(a){
		 d6[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          schematic_param_name_schema_ve,
		          function(b){
		           var
		            default$ = match$109[1],
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_service_tier,
		                0,
		                [0, default$],
		                [0, b],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$85,
		                    schematic_version$28,
		                    function(b){
		                     return caml_exact_trampoline_cps_call
		                             (option_schema,
		                              b,
		                              function(c){
		                               var
		                                default$ = match$110[1],
		                                b =
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_usage, 0, [0, default$], [0, c], 0, 0],
		                                   a];
		                               return caml_exact_trampoline_cps_call
		                                       (output_item_schema_versioned$0,
		schematic_version$28,
		function(a){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       service_tier = b[2][1],
		       usage = b[1],
		       output = a[1],
		       id = param[1];
		      return cont([0, id, output, usage, service_tier]);
		     },
		     function(param, cont){
		      var
		       service_tier = param[4],
		       usage = param[3],
		       output = param[2],
		       id = param[1];
		      return cont
		              ([0, id, [0, output, [0, usage, [0, service_tier, 0]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_id,
		       0,
		       2,
		       [0,
		        [0,
		         ai,
		         0,
		         schematic_param_name_schema_ve[3],
		         schematic_param_name_schema_ve[4]]],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_output,
		        0,
		        2,
		        [0, [0, 0, 0, [3, a], 0]],
		        0,
		        0],
		       b]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          d6[1][1],
		          schematic_schema_version$151,
		          res,
		          function(a){d6[1][1] = a; return cont(res);});
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (output_item_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (content_item_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$224 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$147 = [];
		               caml_update_dummy
		                (letrec_function_context$147, [0, schematic_cache$224]);
		               var cst_Standard = "Standard", schematic_schema_version$44 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$147[1][1],
		                    schematic_schema_version$44]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$147[1][1],
		                             schematic_schema_version$44,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$147[1][1],
		schematic_schema_version$44,
		schematic_self,
		function(a){
		 letrec_function_context$147[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(B9);},
		       0,
		       0,
		       cst_standard,
		       cst_Standard,
		       B8,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){return param ? cont(B7) : cont(0);},
		        0,
		        0,
		        cst_fast,
		        "Fast",
		        B6,
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$147[1][1],
		          schematic_schema_version$44,
		          res,
		          function(a){
		           letrec_function_context$147[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$148 = [];
		               function schema_versioned$86(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$148[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, B_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$148[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$148[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$148[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(Cy);},
		                                  0,
		                                  0,
		                                  cst_gpt_4o,
		                                  "Gpt_4o",
		                                  Cx,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(Cw) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_gpt_4o_mini,
		                                   "Gpt_4o_mini",
		                                   Cv,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(Cu) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_gpt_4_1,
		                                    "Gpt_4_1",
		                                    Ct,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(Cs) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_gpt_4_1_mini,
		                                     "Gpt_4_1_mini",
		                                     Cr,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(Cq) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_gpt_4_1_nano,
		                                      "Gpt_4_1_nano",
		                                      Cp,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(Co) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_gpt_5_5,
		                                       "Gpt_5_5",
		                                       Cn,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(Cm) : cont(0);
		},
		0,
		0,
		cst_gpt_5_5_pro,
		"Gpt_5_5_pro",
		Cl,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 === param ? cont(Ck) : cont(0);
		 },
		 0,
		 0,
		 cst_gpt_5_6_luna,
		 "Gpt_5_6_luna",
		 Cj,
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(8);},
		  function(param, cont){
		   return 8 === param ? cont(Ci) : cont(0);
		  },
		  0,
		  0,
		  cst_gpt_5_6_terra,
		  "Gpt_5_6_terra",
		  Ch,
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(9);},
		   function(param, cont){
		    return 9 === param ? cont(Cg) : cont(0);
		   },
		   0,
		   0,
		   cst_gpt_5_4,
		   "Gpt_5_4",
		   Cf,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(10);},
		    function(param, cont){
		     return 10 === param ? cont(Ce) : cont(0);
		    },
		    0,
		    0,
		    cst_gpt_5_4_mini,
		    "Gpt_5_4_mini",
		    Cd,
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(11);},
		     function(param, cont){
		      return 11 === param ? cont(Cc) : cont(0);
		     },
		     0,
		     0,
		     cst_gpt_5_4_nano,
		     "Gpt_5_4_nano",
		     Cb,
		     0],
		    [0,
		     [0,
		      function(param, cont){return cont(12);},
		      function(param, cont){
		       return 12 <= param ? cont(Ca) : cont(0);
		      },
		      0,
		      0,
		      cst_gpt_5_4_pro,
		      "Gpt_5_4_pro",
		      B$,
		      0],
		     0]]]]]]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$148[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$148[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$225 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$148, [0, schematic_cache$225]);
		               var
		                schema$17 =
		                  caml_callback
		                   (schema_versioned$86,
		                    [function(param, cont){return cont(0);}]);
		               function model_name(model, cont){
		                return caml_trampoline_cps_call3
		                        (encode$4,
		                         schema$17,
		                         model,
		                         function(j){
		                          if(typeof j !== "number"){
		                           var variant = j[1];
		                           if(-976970511 === variant){var s = j[2]; return cont(s);}
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (parse_error, j, iQ, cont);
		                         });
		               }
		               function pricing_of_model(param){
		                switch(param){
		                  case 0:
		                   return [0,
		                           [0,
		                            [0, 2500000, 1250000, 10000000],
		                            [0, [0, 2500000, 1250000, 10000000]]],
		                           [0, [0, [0, 4250000, 2125000, 17000000], 0]]];
		                  case 1:
		                   return [0,
		                           [0,
		                            [0, 150000, 75000, 600000],
		                            [0, [0, 150000, 75000, 600000]]],
		                           [0, [0, [0, 250000, 125000, 1000000], 0]]];
		                  case 2:
		                   return [0,
		                           [0,
		                            [0, 2000000, 500000, 8000000],
		                            [0, [0, 2000000, 500000, 8000000]]],
		                           [0, [0, [0, 3500000, 875000, 14000000], 0]]];
		                  case 3:
		                   return [0,
		                           [0,
		                            [0, 400000, 100000, 1600000],
		                            [0, [0, 400000, 100000, 1600000]]],
		                           [0, [0, [0, 700000, 175000, 2800000], 0]]];
		                  case 4:
		                   return [0,
		                           [0,
		                            [0, 100000, 25000, 400000],
		                            [0, [0, 100000, 25000, 400000]]],
		                           [0, [0, [0, 200000, 50000, 800000], 0]]];
		                  case 5:
		                   return [0,
		                           [0,
		                            [0, 5000000, 500000, 30000000],
		                            [0, [0, 10000000, 1000000, 45000000]]],
		                           [0, [0, [0, 12500000, 1250000, 75000000], 0]]];
		                  case 6:
		                   return [0,
		                           [0,
		                            [0, 30000000, 30000000, 180000000],
		                            [0, [0, 60000000, 60000000, 270000000]]],
		                           0];
		                  case 7:
		                   return [0,
		                           [0,
		                            [0, 200000, 20000, 1200000],
		                            [0, [0, 400000, 40000, 1800000]]],
		                           [0,
		                            [0,
		                             [0, 400000, 40000, 2400000],
		                             [0, [0, 800000, 80000, 3600000]]]]];
		                  case 8:
		                   return [0,
		                           [0,
		                            [0, 2000000, 200000, 12000000],
		                            [0, [0, 4000000, 400000, 18000000]]],
		                           [0,
		                            [0,
		                             [0, 4000000, 400000, 24000000],
		                             [0, [0, 8000000, 800000, 36000000]]]]];
		                  case 9:
		                   return [0,
		                           [0,
		                            [0, 2500000, 250000, 15000000],
		                            [0, [0, 5000000, 500000, 22500000]]],
		                           [0, [0, [0, 5000000, 500000, 30000000], 0]]];
		                  case 10:
		                   return [0,
		                           [0,
		                            [0, 750000, 75000, 4500000],
		                            [0, [0, 750000, 75000, 4500000]]],
		                           [0, [0, [0, 1500000, 150000, 9000000], 0]]];
		                  case 11:
		                   return [0,
		                           [0,
		                            [0, 200000, 20000, 1250000],
		                            [0, [0, 200000, 20000, 1250000]]],
		                           0];
		                  default:
		                   return [0,
		                           [0,
		                            [0, 30000000, 30000000, 180000000],
		                            [0, [0, 60000000, 60000000, 270000000]]],
		                           0];
		                }
		               }
		               caml_callback
		                (of_alist_exn$1,
		                 [[0, comparator$2],
		                  caml_callback
		                   (map$7,
		                    [all$1,
		                     function(model, cont){
		                      var a = pricing_of_model(model);
		                      return caml_exact_trampoline_cps_call
		                              (model_name, model, function(b){return cont([0, b, a]);});
		                     }])]);
		               create$18(0, "RFC5545");
		               var
		                digit_parser =
		                  symbol_map$3
		                   (satisfy
		                     (function(param, cont){
		                       return 9 < param - 48 >>> 0 ? cont(0) : cont(1);
		                      }),
		                    function(c, cont){return cont(c - 48 | 0);}),
		                integer_parser =
		                  symbol_bind$3
		                   (digit_parser,
		                    function(first, cont){
		                     function f(acc, c, cont){
		                      return 9 < c - 48 >>> 0
		                              ? cont(0)
		                              : cont([0, ((acc * 10 | 0) + c | 0) - 48 | 0]);
		                     }
		                     return cont
		                             (symbol_map$3
		                               (scan
		                                 (first, f, function(b, a, param, cont){return cont(0);}),
		                                function(param, cont){
		                                 var state = param[2];
		                                 return cont(state);
		                                }));
		                    }),
		                h = caml_callback(return$7, [-1]),
		                h = symbol$61(char$0(45), h),
		                z = caml_callback(return$7, [1]),
		                signed_integer_parser =
		                  symbol_map$3
		                   (symbol$65
		                     (caml_callback
		                       (option$0,
		                        [1, caml_callback(symbol$64, [symbol$61(char$0(43), z), h])]),
		                      integer_parser),
		                    function(param, cont){
		                     var value = param[2], sign = param[1];
		                     return cont(caml_mul(sign, value));
		                    }),
		                digit2_parser =
		                  symbol_bind$3
		                   (digit_parser,
		                    function(d, cont){
		                     return cont
		                             (symbol_bind$3
		                               (digit_parser,
		                                function(u, cont){
		                                 return caml_exact_trampoline_cps_call
		 (return$7, (d * 10 | 0) + u | 0, cont);
		                                }));
		                    }),
		                month_parser =
		                  symbol_bind$3
		                   (digit2_parser,
		                    function(i, cont){
		                     return caml_exact_trampoline_cps_call
		                             (of_int$4,
		                              i,
		                              function(match){
		                               if(0 === match[0]){
		                                var month = match[1];
		                                return caml_exact_trampoline_cps_call(return$7, month, cont);
		                               }
		                               var m = match[1];
		                               return cont(fail$0(m));
		                              });
		                    }),
		                bymonth_parser =
		                  symbol_bind$3
		                   (integer_parser,
		                    function(i, cont){
		                     return caml_exact_trampoline_cps_call
		                             (of_int$4,
		                              i,
		                              function(match){
		                               if(0 === match[0]){
		                                var month = match[1];
		                                return caml_exact_trampoline_cps_call(return$7, month, cont);
		                               }
		                               var m = match[1];
		                               return cont(fail$0(m));
		                              });
		                    }),
		                date_parser =
		                  symbol_bind$3
		                   (symbol_bind$3
		                     (digit2_parser,
		                      function(h, cont){
		                       return cont
		                               (symbol_bind$3
		                                 (digit2_parser,
		                                  function(u, cont){
		                                   return caml_exact_trampoline_cps_call
		   (return$7, (h * 100 | 0) + u | 0, cont);
		                                  }));
		                      }),
		                    function(year, cont){
		                     return cont
		                             (symbol_bind$3
		                               (month_parser,
		                                function(month, cont){
		                                 return cont
		 (symbol_bind$3
		   (digit2_parser,
		    function(day, cont){
		     return caml_exact_trampoline_cps_call$0
		             (make$8,
		              year,
		              month,
		              day,
		              function(match){
		               if(0 === match[0]){
		                var date = match[1];
		                return caml_exact_trampoline_cps_call(return$7, date, cont);
		               }
		               var m = match[1];
		               return cont(fail$0(m));
		              });
		    }));
		                                }));
		                    });
		               function symbol$95(parser, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (option$0, 0, symbol_map$3(parser, return$9), cont);
		               }
		               var
		                date_or_date_time_parser =
		                  symbol_bind$3
		                   (date_parser,
		                    function(date, cont){
		                     var
		                      time =
		                        symbol_bind$3
		                         (digit2_parser,
		                          function(hours, cont){
		                           return cont
		                                   (symbol_bind$3
		                                     (digit2_parser,
		                                      function(minutes, cont){
		                                       return cont
		       (symbol_bind$3
		         (digit2_parser,
		          function(seconds, cont){
		           return caml_exact_trampoline_cps_call$0
		                   (make$7,
		                    hours,
		                    minutes,
		                    seconds,
		                    function(match){
		                     if(0 === match[0]){
		                      var date = match[1];
		                      return caml_exact_trampoline_cps_call(return$7, date, cont);
		                     }
		                     var m = match[1];
		                     return cont(fail$0(m));
		                    });
		          }));
		                                      }));
		                          });
		                     function a(daytime, cont){
		                      if(! daytime) return cont([0, date]);
		                      var
		                       match = daytime[1],
		                       utc = match[2],
		                       daytime$0 = match[1];
		                      return cont([1, [0, date, daytime$0, is_some(utc)]]);
		                     }
		                     return caml_exact_trampoline_cps_call
		                             (symbol$95,
		                              char$0(90),
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (symbol$95,
		symbol$65(symbol$61(char$0(84), time), b),
		function(b){return cont(symbol_map$3(b, a));});
		                              });
		                    }),
		                z = caml_callback(return$7, [6]),
		                z = [0, symbol$61(string$3("YEARLY"), z), 0],
		                h = caml_callback(return$7, [5]),
		                h = [0, symbol$61(string$3("MONTHLY"), h), z],
		                z = caml_callback(return$7, [4]),
		                z = [0, symbol$61(string$3("WEEKLY"), z), h],
		                h = caml_callback(return$7, [3]),
		                h = [0, symbol$61(string$3("DAILY"), h), z],
		                z = caml_callback(return$7, [2]),
		                z = [0, symbol$61(string$3("HOURLY"), z), h],
		                h = caml_callback(return$7, [1]),
		                h = [0, symbol$61(string$3("MINUTELY"), h), z],
		                z = caml_callback(return$7, [0]),
		                frequency_parser =
		                  caml_callback
		                   (choice, [0, [0, symbol$61(string$3("SECONDLY"), z), h]]),
		                z = caml_callback(return$7, [6]),
		                z = [0, symbol$61(string$3("SU"), z), 0],
		                h = caml_callback(return$7, [5]),
		                h = [0, symbol$61(string$3("SA"), h), z],
		                z = caml_callback(return$7, [4]),
		                z = [0, symbol$61(string$3("FR"), z), h],
		                h = caml_callback(return$7, [3]),
		                h = [0, symbol$61(string$3("TH"), h), z],
		                z = caml_callback(return$7, [2]),
		                z = [0, symbol$61(string$3("WE"), z), h],
		                h = caml_callback(return$7, [1]),
		                h = [0, symbol$61(string$3("TU"), h), z],
		                z = caml_callback(return$7, [0]),
		                weekday_parser =
		                  caml_callback
		                   (choice, [0, [0, symbol$61(string$3("MO"), z), h]]),
		                z =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("WKST="), weekday_parser),
		                     function(d, cont){var x = [12, d]; return cont([1, x]);}),
		                   0],
		                h = caml_callback(sep_by, [char$0(44), integer_parser]),
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYSETPOS="), h),
		                     function(l, cont){var x = [11, l]; return cont([1, x]);}),
		                   z],
		                z = caml_callback(sep_by, [char$0(44), bymonth_parser]),
		                z =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYMONTH="), z),
		                     function(l, cont){var x = [10, l]; return cont([1, x]);}),
		                   h],
		                h = caml_callback(sep_by, [char$0(44), integer_parser]),
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYWEEKNO="), h),
		                     function(l, cont){var x = [9, l]; return cont([1, x]);}),
		                   z],
		                z = caml_callback(sep_by, [char$0(44), integer_parser]),
		                z =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYYEARDAY="), z),
		                     function(l, cont){var x = [8, l]; return cont([1, x]);}),
		                   h],
		                h = caml_callback(sep_by, [char$0(44), integer_parser]),
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYMONTHDAY="), h),
		                     function(l, cont){var x = [7, l]; return cont([1, x]);}),
		                   z],
		                p$3 =
		                  symbol$65
		                   (caml_callback
		                     (option$0,
		                      [0, symbol_map$3(signed_integer_parser, return$9)]),
		                    weekday_parser),
		                sep = char$0(44),
		                z =
		                  symbol_bind$3
		                   (p$3,
		                    function(head, cont){
		                     return cont
		                             (symbol_bind$3
		                               (many(symbol$61(sep, p$3)),
		                                function(tail, cont){
		                                 return caml_exact_trampoline_cps_call
		 (return$7, [0, head, tail], cont);
		                                }));
		                    }),
		                z =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYDAY="), z),
		                     function(l, cont){var x = [6, l]; return cont([1, x]);}),
		                   h],
		                h = caml_callback(sep_by, [char$0(44), integer_parser]),
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYHOUR="), h),
		                     function(l, cont){var x = [5, l]; return cont([1, x]);}),
		                   z],
		                z = caml_callback(sep_by, [char$0(44), integer_parser]),
		                z =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYMINUTE="), z),
		                     function(l, cont){var x = [4, l]; return cont([1, x]);}),
		                   h],
		                h = caml_callback(sep_by, [char$0(44), integer_parser]),
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("BYSECOND="), h),
		                     function(l, cont){var x = [3, l]; return cont([1, x]);}),
		                   z],
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("INTERVAL="), integer_parser),
		                     function(i, cont){var x = [2, i]; return cont([1, x]);}),
		                   h],
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("COUNT="), integer_parser),
		                     function(i, cont){var x = [1, i]; return cont([1, x]);}),
		                   h],
		                h =
		                  [0,
		                   symbol_map$3
		                    (symbol$61(string$3("UNTIL="), date_or_date_time_parser),
		                     function(t, cont){var x = [0, t]; return cont([1, x]);}),
		                   h],
		                rule_part_parser =
		                  caml_callback
		                   (choice,
		                    [0,
		                     [0,
		                      symbol_map$3
		                       (symbol$61(string$3("FREQ="), frequency_parser),
		                        function(freq, cont){return cont([0, freq]);}),
		                      h]]),
		                safe_string_parser =
		                  take_till
		                   (function(c){
		                     var a = c === 59 ? 1 : 0;
		                     if(a)
		                      ;
		                     else {
		                      a = c === 58 ? 1 : 0;
		                      if(a)
		                       ;
		                      else {
		                       a = c === 44 ? 1 : 0;
		                       if(a)
		                        ;
		                       else {
		                        a = c === 34 ? 1 : 0;
		                        if(! a){
		                         a = 0 <= c ? 1 : 0;
		                         a = a ? c <= 8 ? 1 : 0 : a;
		                         if(a)
		                          ;
		                         else {
		                          a = 10 <= c ? 1 : 0;
		                          a = a ? c <= 31 ? 1 : 0 : a;
		                          a ||= 127 === c ? 1 : 0;
		                         }
		                         return a;
		                        }
		                       }
		                      }
		                     }
		                     return a;
		                    }),
		                h = caml_callback(option$0, [47, char$0(47)]),
		                tzid_parser =
		                  symbol_map$3
		                   (symbol$61
		                     (symbol$61(string$3("TZID="), h), safe_string_parser),
		                    function(tz, cont){return cont([0, -533547815, tz]);}),
		                h = caml_callback(return$7, [758940238]),
		                h = symbol$61(string$3("DATE"), h),
		                z = caml_callback(return$7, [-924611237]),
		                z =
		                  caml_callback
		                   (symbol$64, [symbol$61(string$3("DATE-TIME"), z), h]),
		                value_parser =
		                  symbol_map$3
		                   (symbol$61(string$3("VALUE="), z),
		                    function(value, cont){return cont([0, -991563951, value]);}),
		                z = symbol$61(value_parser, caml_callback(return$7, [0])),
		                z =
		                  caml_callback
		                   (symbol$64, [symbol_map$3(tzid_parser, return$9), z]);
		               many(symbol$61(char$0(59), z));
		               caml_callback(sep_by, [char$0(59), rule_part_parser]);
		               function decode$5(displacement){
		                return 0 === (displacement & 1)
		                        ? displacement >>> 1 | 0
		                        : - (displacement >>> 1 | 0) | 0;
		               }
		               function get16(s, i){
		                var j = 2 * i | 0, i$0 = j + 1 | 0;
		                return (caml_string_unsafe_get(s, j) << 8)
		                       + caml_string_unsafe_get(s, i$0)
		                       | 0;
		               }
		               function sexp_of_pos(param, cont){
		                var
		                 offset_006 = param[3],
		                 col_004 = param[2],
		                 line_002 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int,
		                         offset_006,
		                         function(arg_007){
		                          var bnds_001 = [0, [1, [0, Cz, [0, arg_007, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int,
		                                   col_004,
		                                   function(arg_005){
		                                    var
		                                     bnds_001$0 = [0, [1, [0, CA, [0, arg_005, 0]]], bnds_001];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int,
		     line_002,
		     function(arg_003){
		      var
		       bnds_001 = [0, [1, [0, CB, [0, arg_003, 0]]], bnds_001$0];
		      return cont([1, bnds_001]);
		     });
		                                   });
		                         });
		               }
		               var
		                State = caml_callback(init_mod, [CF, CE]),
		                Mode = caml_callback(init_mod, [CH, CG]);
		               caml_callback(update_mod, [CI, State, State]);
		               caml_callback(update_mod, [CJ, Mode, Mode]);
		               var
		                Parse_error$3 =
		                  [248,
		                   "Parsexp__Parse_error.Parse_error",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Parse_error$3,
		                  function(a, cont){
		                   if(a[1] === Parse_error$3){
		                    var
		                     arg0_001 = a[2],
		                     message = arg0_001[2],
		                     position = arg0_001[1],
		                     b = [0, [1, [0, CK, [0, [0, message], 0]]], 0];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_pos,
		                             position,
		                             function(a){
		                              var res0_002 = [1, [0, [1, [0, CL, [0, a, 0]]], b]];
		                              return cont([1, [0, CM, [0, res0_002, 0]]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, CN], 1));
		                  }]);
		               var
		                Of_sexp_error$0 =
		                  [248,
		                   "Parsexp__Of_sexp_error.Of_sexp_error",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Of_sexp_error$0,
		                  function(a, cont){
		                   if(a[1] !== Of_sexp_error$0){
		                    a = caml_pop_trap();
		                    return a
		                            (caml_maybe_attach_backtrace([0, Assert_failure, CS], 1));
		                   }
		                   var
		                    arg0_008 = a[2],
		                    location_006 = arg0_008[3],
		                    sub_sexp_004 = arg0_008[2],
		                    user_exn_002 = arg0_008[1];
		                   function b(arg_007){
		                    var
		                     bnds_001 = [0, [1, [0, CO, [0, arg_007, 0]]], 0],
		                     bnds_001$0 =
		                       [0, [1, [0, CP, [0, sub_sexp_004, 0]]], bnds_001];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_exn,
		                             user_exn_002,
		                             function(arg_003){
		                              var
		                               bnds_001 = [0, [1, [0, CQ, [0, arg_003, 0]]], bnds_001$0];
		                              return cont([1, [0, CR, [0, [1, bnds_001], 0]]]);
		                             });
		                   }
		                   if(! location_006) return b(D);
		                   var
		                    x = location_006[1],
		                    end_pos_011 = x[2],
		                    start_pos_009 = x[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_pos,
		                            end_pos_011,
		                            function(arg_012){
		                             var bnds_008 = [0, [1, [0, CC, [0, arg_012, 0]]], 0];
		                             return caml_exact_trampoline_cps_call
		                                     (sexp_of_pos,
		                                      start_pos_009,
		                                      function(arg_010){
		                                       var
		bnds_008$0 = [0, [1, [0, CD, [0, arg_010, 0]]], bnds_008];
		                                       return b([1, [0, [1, bnds_008$0], 0]]);
		                                      });
		                            });
		                  }]);
		               function sexp_conversion_error_message
		               (containing_sexp, location, invalid_sexp, a, exn, cont){
		                if(containing_sexp)
		                 var
		                  x = containing_sexp[1],
		                  a = [0, [1, [0, CT, [0, x, 0]]], 0];
		                else
		                 a = 0;
		                a = [0, a, 0];
		                if(invalid_sexp)
		                 var
		                  x$0 = invalid_sexp[1],
		                  b = [0, [1, [0, CU, [0, x$0, 0]]], 0];
		                else
		                 b = 0;
		                var d = [0, b, a];
		                function c(a){
		                 a = [0, [0, a, 0], d];
		                 if(location)
		                  var x = location[1], b = [0, [0, x], 0];
		                 else
		                  b = 0;
		                 return cont([1, flatten([0, CV, [0, b, a]])]);
		                }
		                if(exn[1] !== Failure)
		                 return caml_exact_trampoline_cps_call(sexp_of_exn, exn, c);
		                var x$1 = exn[2];
		                return c([0, x$1]);
		               }
		               var
		                Conv_exn =
		                  [248,
		                   "Sexplib__Pre_sexp.Annot.Conv_exn",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Conv_exn,
		                  function(param, a){
		                   if(param[1] === Conv_exn){
		                    var exn = param[3], location = param[2];
		                    return caml_exact_trampoline_cps_call$3
		                            (sexp_conversion_error_message,
		                             0,
		                             [0, location],
		                             0,
		                             dummy,
		                             exn,
		                             a);
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, CW], 1));
		                  }]);
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Of_sexp_error,
		                  function(a, cont){
		                   if(a[1] !== Of_sexp_error){
		                    a = caml_pop_trap();
		                    return a
		                            (caml_maybe_attach_backtrace([0, Assert_failure, CX], 1));
		                   }
		                   var exn = a[2];
		                   if(exn[1] === Conv_exn){
		                    var invalid_sexp = a[3], exn$0 = exn[3], location = exn[2];
		                    return caml_exact_trampoline_cps_call$3
		                            (sexp_conversion_error_message,
		                             0,
		                             [0, location],
		                             [0, invalid_sexp],
		                             dummy,
		                             exn$0,
		                             cont);
		                   }
		                   var invalid_sexp$0 = a[3];
		                   return caml_exact_trampoline_cps_call$3
		                           (sexp_conversion_error_message,
		                            0,
		                            0,
		                            [0, invalid_sexp$0],
		                            dummy,
		                            exn,
		                            cont);
		                  }]);
		               var
		                Parse_error$4 =
		                  [248, "Sexplib__Pre_sexp.Parse_error", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Parse_error$4,
		                  function(a, cont){
		                   if(a[1] === Parse_error$4){
		                    var pe = a[2], ppos = pe[2][2][1];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_int,
		                             ppos[4],
		                             function(b){
		                              var a = [0, [1, [0, CY, [0, b, 0]]], 0];
		                              return caml_exact_trampoline_cps_call
		                                      (sexp_of_int,
		                                       ppos[3],
		                                       function(c){
		var b = [0, [1, [0, CZ, [0, c, 0]]], a];
		return caml_exact_trampoline_cps_call
		        (sexp_of_int,
		         ppos[2],
		         function(c){
		          var a = [0, [1, [0, C0, [0, c, 0]]], b];
		          return caml_exact_trampoline_cps_call
		                  (sexp_of_int,
		                   ppos[1],
		                   function(b){
		                    return cont
		                            ([1,
		                              [0,
		                               C3,
		                               [0,
		                                [1,
		                                 [0,
		                                  [1, [0, C2, [0, [0, pe[1]], 0]]],
		                                  [0, [1, [0, C1, [0, b, 0]]], a]]],
		                                0]]]);
		                   });
		         });
		                                       });
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, C4], 1));
		                  }]);
		               var bstr_ws_buf = create$2(char, c_layout, 1);
		               caml_ba_set_1(bstr_ws_buf, 0, 32);
		               var
		                E$0 =
		                  [248,
		                   "Sexplib__Pre_sexp.Of_string_conv_exn.E",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  E$0,
		                  function(param, a){
		                   if(param[1] === E$0){
		                    var osce = param[2];
		                    return caml_exact_trampoline_cps_call$3
		                            (sexp_conversion_error_message,
		                             [0, osce[2]],
		                             0,
		                             [0, osce[3]],
		                             dummy,
		                             osce[1],
		                             a);
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, C5], 1));
		                  }]);
		               var fortran_layout = 1;
		               create$2(0, fortran_layout, 0);
		               create$2(1, fortran_layout, 0);
		               var
		                Coding$1 = [248, "Schematic_sexp.Coding", caml_fresh_oo_id()];
		               function of_json$0(param, cont){
		                if(typeof param === "number") return cont(C6);
		                var variant = param[1];
		                if(65 === variant){
		                 var items = param[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          items,
		                          of_json$0,
		                          function(a){return cont([1, [0, C7, [0, [1, a], 0]]]);});
		                }
		                if(365180284 <= variant){
		                 if(737456202 <= variant){
		                  var b = param[2];
		                  return caml_exact_trampoline_cps_call
		                          (string_of_bool,
		                           b,
		                           function(a){return cont([1, [0, C8, [0, [0, a], 0]]]);});
		                 }
		                 var f = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (to_string$10,
		                          f,
		                          function(a){return cont([1, [0, C9, [0, [0, a], 0]]]);});
		                }
		                if(79 <= variant){
		                 var fields = param[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          fields,
		                          function(param, cont){
		                           var value = param[2], name = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (of_json$0,
		                                    value,
		                                    function(a){return cont([1, [0, [0, name], [0, a, 0]]]);});
		                          },
		                          function(a){return cont([1, [0, C_, [0, [1, a], 0]]]);});
		                }
		                var s = param[2];
		                return cont([1, [0, C$, [0, [0, s], 0]]]);
		               }
		               function to_json$0(json, cont){
		                var
		                 cst_invalid_sexp_shape_for_JSO = "invalid sexp shape for JSON";
		                function to_json(a, cont){
		                 if(0 === a[0]){
		                  if(a[1] === cst_null$0) return cont(870828711);
		                 }
		                 else {
		                  a = a[1];
		                  if(a){
		                   var c = a[1];
		                   if(0 === c[0]){
		                    c = c[1];
		                    if(c !== cst_a$1)
		                     if(c !== cst_b$0)
		                      if(c !== cst_f)
		                       if(c !== cst_o){
		                        if(c === cst_s$3){
		                         a = a[2];
		                         if(a){
		                          c = a[1];
		                          if(0 === c[0] && ! a[2]){
		                           var s = c[1];
		                           return cont([0, -976970511, s]);
		                          }
		                         }
		                        }
		                       }
		                       else {
		                        a = a[2];
		                        if(a){
		                         c = a[1];
		                         if(0 !== c[0] && ! a[2]){
		                          var fields = c[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   fields,
		                                   field_to_json,
		                                   function(a){return cont([0, 79, a]);});
		                         }
		                        }
		                       }
		                      else {
		                       a = a[2];
		                       if(a){
		                        c = a[1];
		                        if(0 === c[0] && ! a[2]){
		                         var f = c[1];
		                         return caml_exact_trampoline_cps_call
		                                 (of_string$6,
		                                  f,
		                                  function(a){return cont([0, 365180284, a]);});
		                        }
		                       }
		                      }
		                     else {
		                      a = a[2];
		                      if(a){
		                       c = a[1];
		                       if(0 === c[0] && ! a[2]){
		                        var b = c[1];
		                        return caml_exact_trampoline_cps_call
		                                (of_string$2,
		                                 b,
		                                 function(a){return cont([0, 737456202, a]);});
		                       }
		                      }
		                     }
		                    else {
		                     c = a[2];
		                     if(c){
		                      a = c[1];
		                      if(0 !== a[0] && ! c[2]){
		                       var items = a[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (map$7,
		                                items,
		                                to_json,
		                                function(a){return cont([0, 65, a]);});
		                      }
		                     }
		                    }
		                   }
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (failwith, cst_invalid_sexp_shape_for_JSO, cont);
		                }
		                function field_to_json(a, cont){
		                 if(0 !== a[0]){
		                  a = a[1];
		                  if(a){
		                   var b = a[1];
		                   if(0 === b[0]){
		                    a = a[2];
		                    if(a && ! a[2]){
		                     var value = a[1], name = b[1];
		                     return caml_exact_trampoline_cps_call
		                             (to_json, value, function(a){return cont([0, name, a]);});
		                    }
		                   }
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (failwith, cst_invalid_sexp_shape_for_JSO, cont);
		                }
		                caml_push_trap(function(exn){return cont(0);});
		                return caml_exact_trampoline_cps_call
		                        (to_json,
		                         json,
		                         function(a){caml_pop_trap(); return cont([0, a]);});
		               }
		               function type_name$0(param, cont){
		                return 0 === param[0]
		                        ? cont("incompatible atom")
		                        : param
		                           [1]
		                          ? cont("incompatible list")
		                          : cont(cst_empty_list);
		               }
		               function of_atom(conv, param, cont){
		                if(0 !== param[0]) return cont(0);
		                var v = param[1];
		                caml_push_trap(function(exn){return cont(0);});
		                return caml_exact_trampoline_cps_call
		                        (conv,
		                         v,
		                         function(a){caml_pop_trap(); return cont([0, a]);});
		               }
		               function null$2(param, cont){return cont(unit);}
		               function of_any$0(coding, v, cont){
		                return coding === Coding$1 ? cont([0, v]) : cont(0);
		               }
		               function of_bool$0(b, cont){
		                return caml_exact_trampoline_cps_call
		                        (string_of_bool, b, function(a){return cont([0, a]);});
		               }
		               function of_fields$0(fields, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         fields,
		                         function(param, cont){
		                          var v = param[2], name = param[1];
		                          return cont([1, [0, [0, name], [0, v, 0]]]);
		                         },
		                         function(a){return cont([1, a]);});
		               }
		               function of_float$4(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$10, v, function(a){return cont([0, a]);});
		               }
		               function of_int$6(v, cont){return cont([0, "" + v]);}
		               function of_int64$0(v, cont){
		                return cont([0, caml_int64_format(cst_d, v)]);
		               }
		               function of_list$6(l, cont){return cont([1, l]);}
		               function of_option$1(param, cont){
		                if(! param) return cont(Da);
		                var v = param[1];
		                return cont([1, [0, v, 0]]);
		               }
		               function of_string$21(s, cont){return cont([0, s]);}
		               function of_time$2(t, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (to_rfc3339, 0, 0, 0, t, function(a){return cont([0, a]);});
		               }
		               function of_time_local$0(param, cont){
		                var tz_offset_s = param[2], t = param[1];
		                return caml_exact_trampoline_cps_call$2
		                        (to_rfc3339,
		                         0,
		                         0,
		                         [0, tz_offset_s],
		                         t,
		                         function(a){return cont([0, a]);});
		               }
		               function to_bool$0(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_atom, of_string$2, a, cont);
		               }
		               function to_fields$0(param, cont){
		                if(0 === param[0]) return cont(0);
		                var fields = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         fields,
		                         function(a, cont){
		                          if(0 !== a[0]){
		                           a = a[1];
		                           if(a){
		                            var b = a[1];
		                            if(0 === b[0]){
		                             a = a[2];
		                             if(a && ! a[2]){
		                              var value = a[1], name = b[1];
		                              return cont([0, [0, name, value]]);
		                             }
		                            }
		                           }
		                          }
		                          return cont(0);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call(all$11, a, cont);
		                         });
		               }
		               function to_float$3(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_atom, of_string$6, a, cont);
		               }
		               function to_int$4(a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_atom, of_string$3, a, cont);
		               }
		               function to_int64$2(param, cont){
		                if(0 !== param[0]) return cont(0);
		                var v = param[1];
		                try{var a = [0, caml_int64_of_string(v)];}
		                catch(exn){return cont(0);}
		                return cont(a);
		               }
		               function to_list$6(param, cont){
		                if(0 === param[0]) return cont(0);
		                var l = param[1];
		                return cont([0, l]);
		               }
		               function to_option$3(a, cont){
		                if(0 !== a[0]){
		                 a = a[1];
		                 if(! a) return cont(Db);
		                 if(! a[2]){var v = a[1]; return cont([0, [0, v]]);}
		                }
		                return cont(0);
		               }
		               function to_string$28(param, cont){
		                if(0 !== param[0]) return cont(0);
		                var s = param[1];
		                return cont([0, s]);
		               }
		               function to_time$4(param, cont){
		                if(0 !== param[0]) return cont([1, 0]);
		                var s = param[1], t = of_rfc3339(Dc, 0, 0, s);
		                if(0 === t[0]) return cont(t);
		                var x = t[1], e = x[2][2];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$54,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   pp_rfc3339_error,
		                                   e,
		                                   function(a){return cont([1, [0, a]]);});
		                         });
		               }
		               function to_time$5(v, cont){
		                function a(param, cont){var t = param[1]; return cont(t);}
		                return caml_exact_trampoline_cps_call
		                        (to_time$4,
		                         v,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_map$0, b, a, cont);
		                         });
		               }
		               function to_time_local$0(v, cont){
		                function a(param, cont){
		                 var match = param[2], t = param[1];
		                 if(! match) return cont([1, x$0]);
		                 var tz = match[1];
		                 return caml_exact_trampoline_cps_call
		                         (of_string$0, [0, t, tz], cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (to_time$4,
		                         v,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$1, b, a, cont);
		                         });
		               }
		               var
		                encode$7 =
		                  caml_callback
		                    (Make$5,
		                     [[0,
		                       Coding$1,
		                       "s-expression",
		                       ,
		                       pp_mach,
		                       key_get,
		                       key_set,
		                       null$2,
		                       of_any$0,
		                       of_bool$0,
		                       of_date$0,
		                       of_fields$0,
		                       of_float$4,
		                       of_int$6,
		                       of_int64$0,
		                       of_json$0,
		                       of_list$6,
		                       of_option$1,
		                       of_string$21,
		                       of_time$2,
		                       of_time_local$0,
		                       to_bool$0,
		                       to_date,
		                       to_fields$0,
		                       to_float$3,
		                       to_int$4,
		                       to_int64$2,
		                       to_json$0,
		                       to_list$6,
		                       to_option$3,
		                       to_string$28,
		                       to_time$5,
		                       to_time_local$0,
		                       type_name$0]])
		                   [2];
		               function make$17(s, cont){return cont([0, s]);}
		               var bPC = [0, 0];
		               function opaque(s, cont){
		                function a(){
		                 return caml_trampoline_cps_call2
		                         (bPC[1], 0, function(a){return cont([1, s, a]);});
		                }
		                return bPC[1]
		                        ? a()
		                        : caml_exact_trampoline_cps_call
		                          (create_table,
		                           0,
		                           function(b){
		                            function c(a, cont){return cont(create_object_opt(0, b));}
		                            return caml_exact_trampoline_cps_call
		                                    (init_class, b, function(b){bPC[1] = c; return a();});
		                           });
		               }
		               var
		                keywords = caml_callback(of_list$2, [[0, comparator$2], Dd]);
		               function escape_char(c, cont){
		                return 39 === c
		                        ? cont(cst$0)
		                        : 92
		                          === c
		                          ? cont(cst)
		                          : caml_exact_trampoline_cps_call(to_string$6, c, cont);
		               }
		               function pp_quoted(f, param, cont){
		                if(0 === param[0]){
		                 var s = param[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (concat_map$0,
		                          0,
		                          s,
		                          escape_char,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(f),
		                                    De,
		                                    function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                          });
		                }
		                var o = param[2], s$0 = param[1], a = o[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         Df,
		                         function(b){
		                          return caml_trampoline_cps_call3(b, s$0, a, cont);
		                         });
		               }
		               function _41(f, param, cont){
		                if(0 === param[0]){
		                 var
		                  s = param[1],
		                  a =
		                    function(){
		                     return caml_exact_trampoline_cps_call$1
		                             (pp_quoted, f, [0, s], cont);
		                    };
		                 return is_empty$0(s)
		                         ? a()
		                         : caml_exact_trampoline_cps_call$1
		                           (mem$3,
		                            keywords,
		                            s,
		                            function(b){
		                             if(b) return a();
		                             var len = caml_ml_string_length(s), i$0 = 0;
		                             for(;;){
		                              b = i$0 < len;
		                              if(b){
		                               b = caml_string_get(s, i$0);
		                               a:
		                               {
		                                b:
		                                {
		                                 if(97 <= b){if(123 > b) break b;} else if(95 === b) break b;
		                                 b = 1;
		                                 break a;
		                                }
		                                b = 0;
		                               }
		                               if(! b){var i = i$0 + 1 | 0; i$0 = i; continue;}
		                              }
		                              return b
		                                      ? a()
		                                      : caml_exact_trampoline_cps_call$1
		(pp_print_string, f, s, cont);
		                             }
		                            });
		                }
		                var o = param[2], s$0 = param[1], b = o[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         Dg,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, s$0, b, cont);
		                         });
		               }
		               function pp_unquoted(f, param, cont){
		                if(0 === param[0]){
		                 var s = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, f, s, cont);
		                }
		                var o = param[2], s$0 = param[1], a = o[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         Dh,
		                         function(b){
		                          return caml_trampoline_cps_call3(b, s$0, a, cont);
		                         });
		               }
		               function compare$52(l, r, cont){
		                if(0 === l[0]){
		                 var l$0 = l[1];
		                 if(0 !== r[0]) return cont(1);
		                 var r$0 = r[1];
		                 return cont(caml_string_compare(l$0, r$0));
		                }
		                var l$1 = l[2];
		                if(0 === r[0]) return cont(-1);
		                var r$1 = r[2];
		                return cont(caml_int_compare(l$1[2], r$1[2]));
		               }
		               function sexp_of_t$33(param, cont){
		                if(0 === param[0]){var s = param[1]; return cont([0, s]);}
		                var o = param[2], s$0 = param[1], n = o[2];
		                return cont([1, [0, [0, s$0], [0, [0, "" + n], 0]]]);
		               }
		               var
		                include$43 = Make$2([0, compare$52, sexp_of_t$33]),
		                symbol$96 = include$43[3],
		                equal$47 = include$43[7],
		                comparator$13 = include$43[16];
		               function plausible_suggestions(var$, available_ids, cont){
		                if(0 !== var$[0]) return cont(0);
		                var prefix = var$[1];
		                function close_enough(other_var, cont){
		                 if(0 !== other_var[0]) return cont(0);
		                 var id = other_var[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (edit_distance,
		                          prefix,
		                          id,
		                          function(a){
		                           a = a < 3 ? 1 : 0;
		                           function b(a){return cont(some_if(a, id));}
		                           return a
		                                   ? b(a)
		                                   : caml_exact_trampoline_cps_call$0
		                                     (is_prefix_gen, id, prefix, equal$2, b);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0, available_ids, close_enough, cont);
		               }
		               var
		                V$3 = [248, "Graph__Schemas_library.V", caml_fresh_oo_id()],
		                cst_column = "column",
		                letrec_function_context$149 = [];
		               function schema_versioned$87(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$3);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$149[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, Di, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$149[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$149[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$149[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var line = param[2][1], column = param[1];
		                       return cont([0, column, line]);
		                      },
		                      function(param, cont){
		                       var line = param[2], column = param[1];
		                       return cont([0, column, [0, line, 0]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_column, 0, 2, [0, int_schema], 0, 0],
		                       [0,
		                        [0, 0, 0, 0, 0, cst_line, 0, 2, [0, int_schema], 0, 0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$149[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$149[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$226 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$149, [0, schematic_cache$226]);
		               caml_callback
		                (schema_versioned$87, [function(param){return 0;}]);
		               function of_lexing(param){
		                var pos_cnum = param[4], pos_lnum = param[2];
		                return [0, pos_cnum, pos_lnum];
		               }
		               var letrec_function_context$150 = [];
		               function schema_versioned$88(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$3);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$150[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, Dj, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$150[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$150[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$150[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$87,
		                           schematic_version,
		                           function(b){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, cst_end, 0, 2, [0, b], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$87,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var end = param[2][1], start = param[1];
		   return cont([0, start, end]);
		  },
		  function(param, cont){
		   var end = param[2], start = param[1];
		   return cont([0, start, [0, end, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_start, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$150[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$150[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$227 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$150, [0, schematic_cache$227]);
		               caml_callback
		                (schema_versioned$88, [function(param){return 0;}]);
		               function of_lexing$0(start, end){
		                var a = of_lexing(end);
		                return [0, of_lexing(start), a];
		               }
		               function pp$29(f, param, cont){
		                var end = param[2], start = param[1];
		                if(start[2] !== end[2]){
		                 var g = end[1], h = end[2], i = start[1], j = start[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          Dm,
		                          function(a){
		                           return caml_trampoline_cps_call5(a, j, i, h, g, cont);
		                          });
		                }
		                if((end[1] - 1 | 0) <= start[1]){
		                 var a = end[1], b = start[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          Dk,
		                          function(c){
		                           return caml_trampoline_cps_call3(c, b, a, cont);
		                          });
		                }
		                var c = end[1], d = start[1], e = start[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         Dl,
		                         function(a){
		                          return caml_trampoline_cps_call4(a, e, d, c, cont);
		                         });
		               }
		               function _72(pp, f, param, cont){
		                var value = param[1];
		                return caml_trampoline_cps_call3(pp, f, value, cont);
		               }
		               var
		                cst_Eq = "Eq",
		                cst_Gt = "Gt",
		                cst_Gte = "Gte",
		                cst_Inside = "Inside",
		                cst_Lt = "Lt",
		                cst_Lte = "Lte",
		                cst_Neq = "Neq";
		               function pp_bin_op(fmt, op, cont){
		                switch(op){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_And, cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Eq, cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Gt, cont);
		                  case 3:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Gte, cont);
		                  case 4:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Inside, cont);
		                  case 5:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Lt, cont);
		                  case 6:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Lte, cont);
		                  case 7:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Neq, cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Or, cont);
		                }
		               }
		               function precedence_bin_op(op){
		                return op ? 8 <= op ? 1 : 3 : 2;
		               }
		               function pp_direction(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Ast.Unlocated.Descending", cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Ast.Unlocated.Ascending", cont);
		               }
		               var bPo = [];
		               function pp_sort(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Dn,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Do,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Ast.Unlocated.sort_expr",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call3
		              (bPo[2],
		               function(fmt, cont){
		                return caml_trampoline_cps_call2(bPo[3], fmt, cont);
		               },
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Dp,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     Dq,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Dr,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_direction,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (bPo[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Ds,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), Dt, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                cst_Ast_Unlocated_Null = "Ast.Unlocated.Null",
		                cst_args = "args",
		                cst_collection = "collection",
		                cst_field_name = "field_name",
		                cst_from = "from",
		                bT = [];
		               function dump_expression(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst_Ast_Unlocated_Null, cont);
		                var cst_exp = "exp";
		                switch(param[0]){
		                  case 0:
		                   var arhs = param[3], aop = param[2], alhs = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Du,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Dv,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_lhs,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[72],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[73], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            alhs,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Dw,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Dx,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Dy,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_op,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (bT[71],
		                                      0,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        fmt,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a,
		                  aop,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Dz,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DA,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        DB,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a,
		                  cst_rhs,
		                  function(a){
		                   return caml_trampoline_cps_call3
		                           (bT[69],
		                            function(fmt, cont){
		                             return caml_trampoline_cps_call2(bT[70], fmt, cont);
		                            },
		                            fmt,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a,
		                                      arhs,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        DC,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), DD, cont);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var aargs = param[2], af = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            DE,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DF,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_f$0,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[67],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[68], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            af,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DG,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        DH,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  DI,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_args,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DJ,
		                                      function(b){
		                                       function a(accu, l$0){
		if(! l$0)
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          DL,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt),
		                    DM,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt), DN, cont);
		                    });
		          });
		var l = l$0[2], a$0 = l$0[1];
		function b(b){
		 return caml_trampoline_cps_call3
		         (bT[65],
		          function(fmt, cont){
		           return caml_trampoline_cps_call2(bT[66], fmt, cont);
		          },
		          fmt,
		          function(b){
		           return caml_trampoline_cps_call2
		                   (b,
		                    a$0,
		                    function(b){return caml_exact_trampoline_call2(a, 1, l);});
		          });
		}
		return accu
		        ? caml_exact_trampoline_cps_call(fprintf$0(fmt), DK, b)
		        : b();
		                                       }
		                                       return a(0, aargs);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var
		                    aallow_missing = param[3],
		                    afield_name = param[2],
		                    asource = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            DO,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DP,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_source,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[63],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[64], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            asource,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DQ,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        DR,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  DS,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_field_name,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (bT[62],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        afield_name,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  DT,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            DU,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DV,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        "allow_missing",
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  DW,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aallow_missing,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      DX,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), DY, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var aname = param[2], afrom = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            DZ,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      D0,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_from,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[60],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[61], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            afrom,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      D1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        D2,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  D3,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_name,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (bT[59],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aname,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  D4,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), D5, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 4:
		                   var
		                    akey = param[3],
		                    aindexed = param[2],
		                    aexpression = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            D6,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      D7,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_expression,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[57],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[58], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aexpression,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      D8,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        D9,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  D_,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            "indexed",
		                            function(b){
		                             function a(a){
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       D$,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (fprintf$0(fmt),
		         Ea,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (fprintf$0(fmt),
		                   Eb,
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (a,
		                             cst_key,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (bT[53],
		                                       function(fmt, cont){
		return caml_trampoline_cps_call2(bT[54], fmt, cont);
		                                       },
		                                       fmt,
		                                       function(a){
		return caml_trampoline_cps_call2
		        (a,
		         akey,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (fprintf$0(fmt),
		                   Ec,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), Ed, cont);
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             }
		                             if(! aindexed)
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, fmt, cst_None, a);
		                             var x = aindexed[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string,
		                                      fmt,
		                                      cst_Some,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (bT[55],
		        function(fmt, cont){
		         return caml_trampoline_cps_call2(bT[56], fmt, cont);
		        },
		        fmt,
		        function(b){
		         return caml_trampoline_cps_call2
		                 (b,
		                  x,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst$18, a);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 5:
		                   var
		                    aelse = param[3],
		                    athen = param[2],
		                    acondition = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Ee,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Ef,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        "condition",
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[51],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[52], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            acondition,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Eg,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Eh,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Ei,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_then$0,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[49],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[50], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        athen,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Ej,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Ek,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      El,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_else$0,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[47],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[48], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aelse,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Em,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), En, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 6:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Eo,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Ep,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Eq, cont);
		        });
		                                      });
		                            });
		                  case 7:
		                   var a0$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Er,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Es,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Et, cont);
		        });
		                                      });
		                            });
		                  case 8:
		                   var aexpression$0 = param[2], abindings = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Eu,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Ev,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        "bindings",
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Ew,
		                  function(b){
		                   function a(accu, l$0){
		                    if(! l$0)
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              EB,
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (fprintf$0(fmt),
		EC,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          ED,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt),
		                    EE,
		                    function(a){
		                     return caml_trampoline_cps_call2
		                             (a,
		                              cst_expression,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (bT[41],
		function(fmt, cont){
		 return caml_trampoline_cps_call2(bT[42], fmt, cont);
		},
		fmt,
		function(a){
		 return caml_trampoline_cps_call2
		         (a,
		          aexpression$0,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt),
		                    EF,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt), EG, cont);
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    var l = l$0[2], a$0 = l$0[1];
		                    function b(b){
		                     var a1 = a$0[2], a0 = a$0[1];
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              Ey,
		                              function(b){
		                               return caml_trampoline_cps_call3
		                                       (bT[45],
		function(fmt, cont){
		 return caml_trampoline_cps_call2(bT[46], fmt, cont);
		},
		fmt,
		function(b){
		 return caml_trampoline_cps_call2
		         (b,
		          a0,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt),
		                    Ez,
		                    function(b){
		                     return caml_trampoline_cps_call3
		                             (bT[43],
		                              function(fmt, cont){
		                               return caml_trampoline_cps_call2(bT[44], fmt, cont);
		                              },
		                              fmt,
		                              function(b){
		                               return caml_trampoline_cps_call2
		                                       (b,
		a1,
		function(b){
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          EA,
		          function(b){return caml_exact_trampoline_call2(a, 1, l);});
		});
		                              });
		                    });
		          });
		});
		                              });
		                    }
		                    return accu
		                            ? caml_exact_trampoline_cps_call(fprintf$0(fmt), Ex, b)
		                            : b();
		                   }
		                   return a(0, abindings);
		                  });
		        });
		                                      });
		                            });
		                  case 9:
		                   var a0$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            EH,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      EI,
		                                      function(b){
		                                       function a(accu, l$0){
		if(! l$0)
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          EK,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt), EL, cont);
		          });
		var l = l$0[2], a$0 = l$0[1];
		function b(b){
		 return caml_trampoline_cps_call3
		         (bT[39],
		          function(fmt, cont){
		           return caml_trampoline_cps_call2(bT[40], fmt, cont);
		          },
		          fmt,
		          function(b){
		           return caml_trampoline_cps_call2
		                   (b,
		                    a$0,
		                    function(b){return caml_exact_trampoline_call2(a, 1, l);});
		          });
		}
		return accu
		        ? caml_exact_trampoline_cps_call(fprintf$0(fmt), EJ, b)
		        : b();
		                                       }
		                                       return a(0, a0$1);
		                                      });
		                            });
		                  case 10:
		                   var a0$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            EM,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      EN,
		                                      function(b){
		                                       function a(accu, l$0){
		if(! l$0)
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          ES,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt), ET, cont);
		          });
		var l = l$0[2], a$0 = l$0[1];
		function b(b){
		 var a1 = a$0[2], a0 = a$0[1];
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          EP,
		          function(b){
		           return caml_trampoline_cps_call3
		                   (bT[37],
		                    function(fmt, cont){
		                     return caml_trampoline_cps_call2(bT[38], fmt, cont);
		                    },
		                    fmt,
		                    function(b){
		                     return caml_trampoline_cps_call2
		                             (b,
		                              a0,
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (fprintf$0(fmt),
		EQ,
		function(b){
		 return caml_trampoline_cps_call3
		         (bT[35],
		          function(fmt, cont){
		           return caml_trampoline_cps_call2(bT[36], fmt, cont);
		          },
		          fmt,
		          function(b){
		           return caml_trampoline_cps_call2
		                   (b,
		                    a1,
		                    function(b){
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              ER,
		                              function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                    });
		          });
		});
		                              });
		                    });
		          });
		}
		return accu
		        ? caml_exact_trampoline_cps_call(fprintf$0(fmt), EO, b)
		        : b();
		                                       }
		                                       return a(0, a0$2);
		                                      });
		                            });
		                  case 11:
		                   var a0$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            EU,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[33],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[34], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$3,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), EV, cont);
		        });
		                                      });
		                            });
		                  case 12:
		                   var a0$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            EW,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (bT[32],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$4,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), EX, cont);
		        });
		                                      });
		                            });
		                  case 13:
		                   var a0$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            EY,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      EZ,
		                                      function(b){
		                                       function a(accu, l$0){
		if(! l$0)
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          E5,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt), E6, cont);
		          });
		var l = l$0[2], a$0 = l$0[1];
		function b(b){
		 var a1 = a$0[2], a0 = a$0[1];
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          E1,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt),
		                    E2,
		                    function(b){
		                     return caml_trampoline_cps_call2
		                             (b,
		                              a0,
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (fprintf$0(fmt),
		E3,
		function(b){
		 return caml_trampoline_cps_call3
		         (bT[30],
		          function(fmt, cont){
		           return caml_trampoline_cps_call2(bT[31], fmt, cont);
		          },
		          fmt,
		          function(b){
		           return caml_trampoline_cps_call2
		                   (b,
		                    a1,
		                    function(b){
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              E4,
		                              function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                    });
		          });
		});
		                              });
		                    });
		          });
		}
		return accu
		        ? caml_exact_trampoline_cps_call(fprintf$0(fmt), E0, b)
		        : b();
		                                       }
		                                       return a(0, a0$5);
		                                      });
		                            });
		                  case 14:
		                   var apick = param[2], aexp = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            E7,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      E8,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_exp,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[28],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[29], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aexp,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      E9,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        E_,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  E$,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_pick,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (bT[27],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        apick,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Fa,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Fb, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 15:
		                   var aselected = param[2], aexpression$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Fc,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Fd,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_expression,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[25],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[26], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aexpression$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Fe,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Ff,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Fg,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_selected,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[23],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[24], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aselected,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Fh,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Fi, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 16:
		                   var a0$6 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Fj,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Fk,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$6,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Fl, cont);
		        });
		                                      });
		                            });
		                  case 17:
		                   var aindex = param[2], acollection = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Fm,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Fn,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_collection,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[21],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[22], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            acollection,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Fo,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Fp,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Fq,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_index,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[19],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[20], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aindex,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Fr,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Fs, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 18:
		                   var atype = param[2], aexpression$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Ft,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Fu,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_expression,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[17],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[18], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aexpression$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Fv,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Fw,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Fx,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_type$0,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[15],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[16], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        atype,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Fy,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Fz, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 19:
		                   var aexp$0 = param[2], aop$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            FA,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FB,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_op,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (bT[14],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aop$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FC,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        FD,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  FE,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_exp,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[12],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[13], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aexp$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  FF,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), FG, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 20:
		                   var afilter = param[2], aexp$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            FH,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FI,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_exp,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[10],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[11], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aexp$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FJ,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        FK,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  FL,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_filter,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[8],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[9], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        afilter,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  FM,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), FN, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 21:
		                   var asort = param[2], aexpression$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            FO,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FP,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_expression,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[6],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[7], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aexpression$3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FQ,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        FR,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  FS,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_sort,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (bT[5],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        asort,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  FT,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), FU, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var alimit = param[2], aexpression$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            FV,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FW,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_expression,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bT[3],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(bT[4], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aexpression$4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      FX,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        FY,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  FZ,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_limit,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (bT[1],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(bT[2], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        alimit,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  F0,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), F1, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               var bPp = [];
		               function pp_field_name(fmt, param, cont){
		                if(0 === param[0]){
		                 var a0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          F2,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (bPp[3],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      a0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), F3, cont);
		      });
		                                    });
		                          });
		                }
		                var a0$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         F4,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (bPp[1],
		                                   function(fmt, cont){
		                                    return caml_trampoline_cps_call2(bPp[2], fmt, cont);
		                                   },
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0$0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), F5, cont);
		     });
		                                   });
		                         });
		               }
		               var bPb = [];
		               function pp_pick(fmt, param, cont){
		                if(0 === param[0]){
		                 var a0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          F6,
		                          function(b){
		                           function a(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt), F7, cont);
		                           }
		                           if(! a0)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, a);
		                           var x = a0[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (bPb[3],
		      function(fmt, cont){
		       return caml_trampoline_cps_call2(bPb[4], fmt, cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                x,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, a);
		                });
		      });
		                                    });
		                          });
		                }
		                var a0$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         F8,
		                         function(b){
		                          function a(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt), F9, cont);
		                          }
		                          if(! a0$0)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_None, a);
		                          var x = a0$0[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   fmt,
		                                   cst_Some,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (bPb[1],
		     function(fmt, cont){
		      return caml_trampoline_cps_call2(bPb[2], fmt, cont);
		     },
		     fmt,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               x,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, cst$18, a);
		               });
		     });
		                                   });
		                         });
		               }
		               var cb = [];
		               function pp_type(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst_Ast_Unlocated_Null, cont);
		                switch(param[0]){
		                  case 0:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            F_,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (cb[11],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(cb[12], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), F$, cont);
		        });
		                                      });
		                            });
		                  case 1:
		                   var a0$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Ga,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Gb,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Gc, cont);
		        });
		                                      });
		                            });
		                  case 2:
		                   var a0$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Gd,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Ge,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$1,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Gf, cont);
		        });
		                                      });
		                            });
		                  case 3:
		                   var a0$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Gg,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (cb[9],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(cb[10], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$2,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Gh, cont);
		        });
		                                      });
		                            });
		                  case 4:
		                   var adata = param[2], akey = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Gi,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Gj,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_key,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (cb[7],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2(cb[8], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            akey,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Gk,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Gl,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Gm,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_data,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (cb[5],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2(cb[6], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        adata,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Gn,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Go, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 5:
		                   var a0$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Gp,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Gq,
		                                      function(b){
		                                       function a(accu, l$0){
		if(! l$0)
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          Gw,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt), Gx, cont);
		          });
		var l = l$0[2], a$0 = l$0[1];
		function b(b){
		 var a1 = a$0[2], a0 = a$0[1];
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          Gs,
		          function(b){
		           return caml_trampoline_cps_call3
		                   (cb[4],
		                    function(fmt, cont){
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt), Gt, cont);
		                    },
		                    fmt,
		                    function(b){
		                     return caml_trampoline_cps_call2
		                             (b,
		                              a0,
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (fprintf$0(fmt),
		Gu,
		function(b){
		 return caml_trampoline_cps_call3
		         (cb[2],
		          function(fmt, cont){
		           return caml_trampoline_cps_call2(cb[3], fmt, cont);
		          },
		          fmt,
		          function(b){
		           return caml_trampoline_cps_call2
		                   (b,
		                    a1,
		                    function(b){
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              Gv,
		                              function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                    });
		          });
		});
		                              });
		                    });
		          });
		}
		return accu
		        ? caml_exact_trampoline_cps_call(fprintf$0(fmt), Gr, b)
		        : b();
		                                       }
		                                       return a(0, a0$3);
		                                      });
		                            });
		                  case 6:
		                   var a0$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Gy,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Gz,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$4,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), GA, cont);
		        });
		                                      });
		                            });
		                  default:
		                   var a0$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            GB,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      GC,
		                                      function(b){
		                                       function a(accu, l$0){
		if(! l$0)
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt),
		          GE,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt), GF, cont);
		          });
		var l = l$0[2], a$0 = l$0[1];
		function b(b){
		 return caml_trampoline_cps_call2
		         (cb[1],
		          fmt,
		          function(b){
		           return caml_trampoline_cps_call2
		                   (b,
		                    a$0,
		                    function(b){return caml_exact_trampoline_call2(a, 1, l);});
		          });
		}
		return accu
		        ? caml_exact_trampoline_cps_call(fprintf$0(fmt), GD, b)
		        : b();
		                                       }
		                                       return a(0, a0$5);
		                                      });
		                            });
		                }
		               }
		               function pp_unary_op(fmt, param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, "Ast.Unlocated.Bang", cont);
		               }
		               caml_update_dummy(bPo, [0, pp_direction, _72, dump_expression]);
		               function _2$6(param, cont){return cont(pp_bin_op);}
		               caml_update_dummy
		                (bT,
		                 [0,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  pp_sort,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  pp_unary_op,
		                  _72,
		                  pp_type,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  pp_pick,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _41,
		                  _72,
		                  pp_type,
		                  _72,
		                  dump_expression,
		                  _72,
		                  _41,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  _41,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _41,
		                  _72,
		                  dump_expression,
		                  pp_field_name,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _72,
		                  dump_expression,
		                  _2$6,
		                  _72,
		                  dump_expression]);
		               caml_update_dummy(bPp, [0, _72, dump_expression, _41]);
		               caml_update_dummy
		                (bPb, [0, _72, dump_expression, _72, dump_expression]);
		               caml_update_dummy
		                (cb,
		                 [0,
		                  pp_type,
		                  _72,
		                  pp_type,
		                  _72,
		                  _72,
		                  pp_type,
		                  _72,
		                  pp_type,
		                  _72,
		                  pp_type,
		                  _72,
		                  _41]);
		               function escape_char$0(c, cont){
		                return 10 === c
		                        ? cont(cst_n)
		                        : 34
		                          === c
		                          ? cont(cst$3)
		                          : 92
		                            === c
		                            ? cont(cst)
		                            : caml_exact_trampoline_cps_call(to_string$6, c, cont);
		               }
		               var
		                prefix_ops =
		                  caml_callback
		                   (of_list$2,
		                    [[0, comparator$13], caml_callback(map$18, [GG, make$17])]);
		               function pp_direction$0(ppf, v, cont){
		                var a = v ? cst_desc : cst_asc;
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, ppf, a, cont);
		               }
		               function pp_unary_op$0(ppf, v, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, ppf, cst$20, cont);
		               }
		               var cst$28 = "!=", cst$27 = "<=", cst$24 = "=", cst$26 = ">=";
		               function pp_expression(f, expression, cont){
		                if(typeof expression === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, f, cst_null, cont);
		                switch(expression[0]){
		                  case 0:
		                   var
		                    child_expr = expression[3],
		                    op = expression[2],
		                    child_expr$0 = expression[1];
		                   switch(op){
		                     case 0:
		                      var op_str = cst_and; break;
		                     case 1:
		                      op_str = cst$24; break;
		                     case 2:
		                      op_str = cst$41; break;
		                     case 3:
		                      op_str = cst$26; break;
		                     case 4:
		                      op_str = cst_inside; break;
		                     case 5:
		                      op_str = cst$51; break;
		                     case 6:
		                      op_str = cst$27; break;
		                     case 7:
		                      op_str = cst$28; break;
		                     default: op_str = cst_or;
		                   }
		                   var a = child_expr$0[1];
		                   a:
		                   {
		                    if(typeof a !== "number")
		                     switch(a[0]){
		                       case 0:
		                        var
		                         child_op = a[2],
		                         child_prec = precedence_bin_op(child_op),
		                         op_prec = precedence_bin_op(op),
		                         a = child_prec < op_prec;
		                        break a;
		                       case 5:
		                        a = 1; break a;
		                     }
		                    a = 0;
		                   }
		                   var
		                    pp_lhs =
		                      a
		                       ? parens
		                         (function(a, b, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (_72, pp_expression, a, b, cont);
		                          })
		                       : function
		                        (a, b, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (_72, pp_expression, a, b, cont);
		                        },
		                    a = child_expr[1];
		                   a:
		                   {
		                    if(typeof a !== "number")
		                     switch(a[0]){
		                       case 0:
		                        var
		                         child_op$0 = a[2],
		                         child_prec$0 = precedence_bin_op(child_op$0),
		                         op_prec$0 = precedence_bin_op(op),
		                         a = child_prec$0 <= op_prec$0;
		                        break a;
		                       case 5:
		                        a = 1; break a;
		                     }
		                    a = 0;
		                   }
		                   var
		                    pp_rhs =
		                      a
		                       ? parens
		                         (function(a, b, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (_72, pp_expression, a, b, cont);
		                          })
		                       : function
		                        (a, b, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (_72, pp_expression, a, b, cont);
		                        };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GH,
		                            function(a){
		                             return caml_trampoline_cps_call6
		                                     (a, pp_lhs, child_expr$0, op_str, pp_rhs, child_expr, cont);
		                            });
		                  case 1:
		                   var
		                    fn = expression[1],
		                    a = fn[1],
		                    b =
		                      function(){
		                       var
		                        args = expression[2],
		                        a =
		                          list
		                           ([0, comma],
		                            function(a, b, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (_72, pp_expression, a, b, cont);
		                            });
		                       function b(a, b, cont){
		                        return caml_exact_trampoline_cps_call$0
		                                (_72, pp_expression, a, b, cont);
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (fprintf$0(f),
		                                GI,
		                                function(c){
		                                 return caml_trampoline_cps_call5(c, b, fn, a, args, cont);
		                                });
		                      };
		                   if(typeof a === "number") return b();
		                   if(12 !== a[0]) return b();
		                   var c = expression[2];
		                   if(! c) return b();
		                   var d = c[2];
		                   if(! d) return b();
		                   if(d[2]) return b();
		                   var arg2 = d[1], arg1 = c[1], fn$0 = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (mem$3,
		                            prefix_ops,
		                            fn$0,
		                            function(d){
		                             if(! d) return b();
		                             function a(a, b, cont){
		                              return caml_exact_trampoline_cps_call$0
		                                      (_72, pp_expression, a, b, cont);
		                             }
		                             function c(a, b, cont){
		                              return caml_exact_trampoline_cps_call$0
		                                      (_72, pp_expression, a, b, cont);
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      GJ,
		                                      function(b){
		                                       return caml_trampoline_cps_call7
		       (b, c, arg1, pp_unquoted, fn$0, a, arg2, cont);
		                                      });
		                            });
		                  case 2:
		                   var
		                    allow_missing = expression[3],
		                    field_name = expression[2],
		                    source = expression[1],
		                    e = allow_missing ? "?" : cst$1,
		                    g =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GK,
		                            function(a){
		                             return caml_trampoline_cps_call6
		                                     (a, g, source, e, pp_field_name$0, field_name, cont);
		                            });
		                  case 3:
		                   var
		                    name = expression[2],
		                    from = expression[1],
		                    h =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GL,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, h, from, _41, name, cont);
		                            });
		                  case 4:
		                   var
		                    key = expression[3],
		                    indexed = expression[2],
		                    expression$0 = expression[1],
		                    i =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    j =
		                      function(ppf, param, cont){
		                       if(! param)
		                        return caml_exact_trampoline_cps_call$1
		                                (pp_none, ppf, dummy, cont);
		                       var v = param[1];
		                       return caml_exact_trampoline_cps_call$0
		                               (_72,
		                                pp_expression,
		                                ppf,
		                                v,
		                                function(a){return cont(pp_v1(ppf));});
		                      },
		                    k =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GM,
		                            function(a){
		                             return caml_trampoline_cps_call7
		                                     (a, k, expression$0, j, indexed, i, key, cont);
		                            });
		                  case 5:
		                   var
		                    else$ = expression[3],
		                    then = expression[2],
		                    condition = expression[1],
		                    l =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    m =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    n =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GN,
		                            function(a){
		                             return caml_trampoline_cps_call7
		                                     (a, n, condition, m, then, l, else$, cont);
		                            });
		                  case 6:
		                   var int = expression[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GO,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, pp$3, int, cont);
		                            });
		                  case 8:
		                   var
		                    expression$1 = expression[2],
		                    bindings = expression[1],
		                    pp_sep =
		                      function(ppf, param, cont){
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_print_string, ppf, cst$38, cont);
		                      },
		                    p =
		                      list
		                       ([0,
		                         function(ppf, v, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   ppf,
		                                   cst_and,
		                                   function(a){return cont(pp_v1(ppf));});
		                         }],
		                        function(ppf, param, cont){
		                         var snd = param[2], fst = param[1];
		                         return caml_exact_trampoline_cps_call$0
		                                 (_72,
		                                  _41,
		                                  ppf,
		                                  fst,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$1
		   (pp_sep,
		    ppf,
		    dummy,
		    function(a){
		     return caml_exact_trampoline_cps_call$0
		             (_72, pp_expression, ppf, snd, cont);
		    });
		                                  });
		                        }),
		                    o =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GP,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, p, bindings, o, expression$1, cont);
		                            });
		                  case 9:
		                   var
		                    lst = expression[1],
		                    q =
		                      list
		                       ([0, comma],
		                        function(a, b, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (_72, pp_expression, a, b, cont);
		                        });
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GQ,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, q, lst, cont);
		                            });
		                  case 12:
		                   var id = expression[1];
		                   return caml_exact_trampoline_cps_call$1(_41, f, id, cont);
		                  case 13:
		                   var
		                    fields = expression[1],
		                    pp_sep$0 =
		                      function(ppf, param, cont){
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_print_string, ppf, cst$9, cont);
		                      },
		                    r =
		                      list
		                       ([0, comma],
		                        function(ppf, param, cont){
		                         var snd = param[2], fst = param[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (_41,
		                                  ppf,
		                                  [0, fst],
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$1
		   (pp_sep$0,
		    ppf,
		    dummy,
		    function(a){
		     return caml_exact_trampoline_cps_call$0
		             (_72, pp_expression, ppf, snd, cont);
		    });
		                                  });
		                        });
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GR,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, r, fields, cont);
		                            });
		                  case 15:
		                   var
		                    selected = expression[2],
		                    expression$2 = expression[1],
		                    s =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    t =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GS,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, t, expression$2, s, selected, cont);
		                            });
		                  case 16:
		                   var string = expression[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (concat_map$0,
		                            0,
		                            string,
		                            escape_char$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      GT,
		                                      function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                            });
		                  case 17:
		                   var
		                    index = expression[2],
		                    collection = expression[1],
		                    u =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    v =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GU,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, v, collection, u, index, cont);
		                            });
		                  case 19:
		                   var
		                    exp = expression[2],
		                    op$0 = expression[1],
		                    w =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GV,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, pp_unary_op$0, op$0, w, exp, cont);
		                            });
		                  case 20:
		                   var
		                    filter = expression[2],
		                    exp$0 = expression[1],
		                    x =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    y =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GW,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, y, exp$0, x, filter, cont);
		                            });
		                  case 21:
		                   var
		                    sort = expression[2],
		                    expression$3 = expression[1],
		                    z = sort[1],
		                    B = sort[2],
		                    A =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    C =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GX,
		                            function(a){
		                             return caml_trampoline_cps_call7
		                                     (a, C, expression$3, pp_direction$0, B, A, z, cont);
		                            });
		                  case 22:
		                   var
		                    limit = expression[2],
		                    expression$4 = expression[1],
		                    D =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      },
		                    E =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (_72, pp_expression, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            GY,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, E, expression$4, D, limit, cont);
		                            });
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (dump_expression, f, expression, cont);
		                }
		               }
		               function pp_field_name$0(fmt, param, cont){
		                if(0 === param[0]){
		                 var id = param[1];
		                 return caml_exact_trampoline_cps_call$1(_41, fmt, id, cont);
		                }
		                var expr = param[1];
		                function a(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (_72, pp_expression, a, b, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         GZ,
		                         function(b){
		                          return caml_trampoline_cps_call3(b, a, expr, cont);
		                         });
		               }
		               function pp_expression$0(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (_72, pp_expression, a, b, cont);
		               }
		               var none$2 = [0, none$0, none$0];
		               function name$12(n){
		                var value = [12, [0, n]];
		                return [0, value, none$2];
		               }
		               function call$1(f, args){return [1, name$12(f), args];}
		               function string$6(s){
		                var value = [16, s];
		                return [0, value, none$2];
		               }
		               var
		                symbol_bind$15 = include$0[1],
		                symbol_map$13 = include$0[2],
		                bind$21 = include$0[4],
		                return$20 = include$0[5],
		                map$33 = include$0[6],
		                all$17 = include$0[9],
		                Let_syntax$9 = include$0[11];
		               function make$18(map, param){return map;}
		               function cut(param, cont){
		                return cont(function(a, cont){return cont(a);});
		               }
		               function map2$0(x, y, f){return f(x, y);}
		               function map3(x, y, z, f){return f(x, y, z);}
		               function name$13(a, param){}
		               function index_by(map, comparator, index, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$5,
		                         map,
		                         empty$11(comparator),
		                         function(key, data, res, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (index,
		                                   key,
		                                   data,
		                                   function(match){
		                                    if(! match) return cont(res);
		                                    var new_key = match[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (update$0,
		     res,
		     new_key,
		     function(param, cont){
		      if(! param)
		       return caml_exact_trampoline_cps_call
		               (get_comparator,
		                map,
		                function(a){return cont(singleton$3(a, key)(data));});
		      var map$0 = param[1];
		      return caml_exact_trampoline_cps_call$0
		              (set$3, map$0, key, data, cont);
		     },
		     cont);
		                                   });
		                         },
		                         cont);
		               }
		               function max$14(map, comparator, f, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (to_sequence$2,
		                         0,
		                         0,
		                         0,
		                         map,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$11,
		                                   a,
		                                   function(param, cont){
		                                    var data = param[2];
		                                    return caml_exact_trampoline_cps_call
		    (f, data, function(a){return cont([0, a, data]);});
		                                   },
		                                   function(t){
		                                    function compare(a, param, cont){
		                                     var r = param[1], l = a[1];
		                                     return caml_trampoline_cps_call3(comparator[1], l, r, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$0
		    (max_elt,
		     fold$0,
		     t,
		     compare,
		     function(a){
		      return caml_trampoline_cps_call3(map$17, a, get_data, cont);
		     });
		                                   });
		                         });
		               }
		               var d8 = [];
		               function schema_versioned$89(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$3);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         d8[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, G0, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      d8[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 d8[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(b){
		                  d8[1][1] = b;
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_message,
		                       0,
		                       2,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$88,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_location, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (kind_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    message = a[2][1],
		    location = a[1],
		    kind = param[1];
		   return cont([0, kind, location, message]);
		  },
		  function(param, cont){
		   var
		    message = param[3],
		    location = param[2],
		    kind = param[1];
		   return cont([0, kind, [0, location, [0, message, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [1, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       d8[1][1],
		       schematic_schema_version,
		       res,
		       function(a){d8[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var cst_Name = "Name", letrec_function_context$151 = [];
		               function kind_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$3);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$151[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, 0, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$151[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$151[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$151[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      G5,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){
		                         if(typeof param === "number" && ! param) return cont(G4);
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        "lexical",
		                        "Lexical",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){return cont(0);},
		                          function(param, cont){return cont(0);},
		                          0],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          if(typeof param === "number" && 1 === param)
		                           return cont(G3);
		                          return cont(0);
		                         },
		                         0,
		                         0,
		                         "syntax",
		                         "Syntax",
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){return cont(0);},
		                           function(param, cont){return cont(0);},
		                           0],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           if(typeof param === "number" && 2 === param)
		                            return cont(G2);
		                           return cont(0);
		                          },
		                          0,
		                          0,
		                          cst_type,
		                          cst_Type,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){return cont(0);},
		                            function(param, cont){return cont(0);},
		                            0],
		                           0],
		                          0],
		                         [0,
		                          [0,
		                           function(f0, cont){return cont([0, f0]);},
		                           function(param, cont){
		                            if(typeof param === "number") return cont(0);
		                            var f0 = param[1];
		                            return cont([0, f0]);
		                           },
		                           1,
		                           0,
		                           cst_name,
		                           cst_Name,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){
		                              var suggestions = param[1];
		                              return cont(suggestions);
		                             },
		                             function(suggestions, cont){
		                              return cont([0, suggestions, 0]);
		                             },
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "suggestions",
		                               0,
		                               2,
		                               [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                               0,
		                               0],
		                              0]],
		                            0],
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(3);},
		                            function(param, cont){
		                             if(typeof param === "number" && 3 <= param) return cont(G1);
		                             return cont(0);
		                            },
		                            0,
		                            0,
		                            cst_execution,
		                            "Execution",
		                            [0,
		                             0,
		                             0,
		                             [7,
		                              function(param, cont){return cont(0);},
		                              function(param, cont){return cont(0);},
		                              0],
		                             0],
		                            0],
		                           0]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$151[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$151[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$228 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d8, [0, schematic_cache$228]);
		               var schematic_cache$229 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$151, [0, schematic_cache$229]);
		               var
		                schema$18 =
		                  caml_callback
		                   (schema_versioned$89, [function(param){return 0;}]);
		               caml_callback
		                (kind_schema_versioned, [function(param){return 0;}]);
		               function pp$30(fmt, param, cont){
		                var message = param[3], location = param[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         G6,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (a, pp$29, location, message, cont);
		                         });
		               }
		               function of_message$0(kind, location, fmt, cont){
		                function f(message, cont){
		                 return cont([0, kind, location, message]);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, f, fmt, cont);
		               }
		               function fail$4(kind, location, fmt, cont){
		                function f(message, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (of_message$0,
		                          kind,
		                          location,
		                          G7,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a, message, function(x){return cont([1, x]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, f, fmt, cont);
		               }
		               function missing_var(location, var$, available_vars, fmt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (plausible_suggestions,
		                         var$,
		                         available_vars,
		                         function(suggestions){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fail$4, [0, suggestions], location, fmt, cont);
		                         });
		               }
		               var
		                logs_src$1 = create$18(0, "Drone"),
		                Logs$0 = src_log(logs_src$1),
		                debug = Logs$0[6];
		               function debug$0(indentation, msgf, cont){
		                function msgf$0(m, cont){
		                 function m$0(header, tags, fmt, cont){
		                  var a = make$0(indentation * 2 | 0, 32);
		                  return caml_trampoline_cps_call5
		                          (m, header, tags, symbol$0(G8, fmt), a, cont);
		                 }
		                 return caml_exact_trampoline_cps_call(msgf, m$0, cont);
		                }
		                return caml_exact_trampoline_cps_call(Logs$0[6], msgf$0, cont);
		               }
		               function scope(indentation, msgf, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (debug$0,
		                         indentation,
		                         msgf,
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (f, indentation + 1 | 0, cont);
		                         });
		               }
		               function pp$31(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Graph_string_format.Email", cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Graph_string_format.Phone", cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Graph_string_format.Uri", cont);
		                }
		               }
		               var cst_Uri = "Uri", letrec_function_context$152 = [];
		               function schema_versioned$90(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$3,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$152[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, G_, G9, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$152[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$152[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$152[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(He);},
		                                  0,
		                                  0,
		                                  cst_email,
		                                  cst_Email,
		                                  Hd,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(Hc) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_phone,
		                                   cst_Phone,
		                                   Hb,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(Ha) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_uri,
		                                    cst_Uri,
		                                    G$,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$152[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$152[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$230 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$152, [0, schematic_cache$230]);
		               caml_callback
		                (schema_versioned$90,
		                 [function(param, cont){return cont(0);}]);
		               var cst_Id = "Id";
		               function make$19(param, cont){
		                var Id = [248, cst_Id, caml_fresh_oo_id()];
		                return cont([1, [0, Id]]);
		               }
		               function provably_equal(a, b, cont){
		                function c(a, b){
		                 a:
		                 {
		                  switch(a[0]){
		                    case 0:
		                     var a$0 = a[1], d = caml_obj_tag(a$0);
		                     if(250 === d)
		                      return caml_exact_trampoline_call2(c, a$0[1], b);
		                     if(246 !== d && 244 !== d)
		                      return caml_exact_trampoline_call2(c, a$0, b);
		                     return caml_exact_trampoline_cps_call
		                             (force_lazy_block,
		                              a$0,
		                              function(a){return caml_exact_trampoline_call2(c, a, b);});
		                    case 1:
		                     var a$1 = a[1];
		                     switch(b[0]){
		                       case 1:
		                        var b$1 = b[1];
		                        return a$1[1] === b$1[1] ? cont(bW) : cont(0);
		                       case 0:
		                        break a;
		                     }
		                     break;
		                    case 2:
		                     var a$2 = a[1];
		                     switch(b[0]){
		                       case 2:
		                        var b$2 = b[1];
		                        return caml_exact_trampoline_cps_call$1
		                                (provably_equal,
		                                 a$2,
		                                 b$2,
		                                 function(match){return match ? cont(Hf) : cont(0);});
		                       case 0:
		                        break a;
		                     }
		                     break;
		                    case 3:
		                     var a_witness = a[3], a_data = a[2], a_key = a[1];
		                     switch(b[0]){
		                       case 3:
		                        return caml_exact_trampoline_cps_call$1
		                                (provably_equal,
		                                 a_key,
		                                 b[1],
		                                 function(match){
		                                  return caml_exact_trampoline_cps_call$1
		  (provably_equal,
		   a_data,
		   b[2],
		   function(match$0){
		    return caml_exact_trampoline_cps_call$1
		            (provably_equal,
		             a_witness,
		             b[3],
		             function(match$1){
		              if(match && match$0 && match$1) return cont(Hg);
		              return cont(0);
		             });
		   });
		                                 });
		                       case 0:
		                        break a;
		                     }
		                     break;
		                    default:
		                     var a$3 = a[1];
		                     switch(b[0]){
		                       case 4:
		                        var b$3 = b[1];
		                        return caml_exact_trampoline_cps_call$1
		                                (provably_equal,
		                                 a$3,
		                                 b$3,
		                                 function(match){return match ? cont(Hh) : cont(0);});
		                       case 0:
		                        break a;
		                     }
		                  }
		                  return cont(0);
		                 }
		                 var b$0 = b[1], d = caml_obj_tag(b$0);
		                 if(250 === d)
		                  return caml_exact_trampoline_call2(c, a, b$0[1]);
		                 if(246 !== d && 244 !== d)
		                  return caml_exact_trampoline_call2(c, a, b$0);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block,
		                          b$0,
		                          function(b){return caml_exact_trampoline_call2(c, a, b);});
		                }
		                return c(a, b);
		               }
		               var
		                open$9 =
		                  o
		                   ([0,
		                     symbol_bind$4,
		                     symbol_map$4,
		                     Let_syntax$2,
		                     ,
		                     bind$6,
		                     of_string$14,
		                     map$15]),
		                let$14 = open$9[3],
		                let$15 = open$9[4],
		                and$3 = open$9[5],
		                and$4 = open$9[6];
		               function assoc_schema_versioned(key, param){
		                function res(key_schema, data_schema, cont){
		                 var a = data_schema[1];
		                 function b(ppf, param, cont){
		                  if(! param)
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_none, ppf, dummy, cont);
		                  var v = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           ppf,
		                           v,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_char, ppf, 45, cont);
		                           });
		                 }
		                 var c = key_schema[1];
		                 function d(ppf, param, cont){
		                  if(! param)
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_none, ppf, dummy, cont);
		                  var v = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           ppf,
		                           v,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_char, ppf, 45, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$56,
		                          function(e){
		                           return caml_trampoline_cps_call5
		                                   (e,
		                                    d,
		                                    c,
		                                    b,
		                                    a,
		                                    function(id){
		                                     var
		                                      descriptor =
		tuple
		 (function(a, cont){return cont(a);},
		  function(a, cont){return cont(a);},
		  [0, key_schema, [0, data_schema, 0]]);
		                                     function decode(l, cont){
		                                      return caml_trampoline_cps_call3
		      (map$18,
		       l,
		       function(param, cont){
		        var d = param[2][1], k = param[1];
		        return cont([0, k, d]);
		       },
		       function(l){
		        return caml_exact_trampoline_cps_call$1
		                (of_alist$1,
		                 key,
		                 l,
		                 function(match){
		                  var variant = match[1];
		                  if(17724 > variant)
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf, fail, format$14, cont);
		                  var map = match[2];
		                  return caml_trampoline_cps_call2(of_string$14, map, cont);
		                 });
		       });
		                                     }
		                                     function encode(map, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (to_alist$0,
		       0,
		       map,
		       function(a){
		        return caml_trampoline_cps_call3
		                (map$18,
		                 a,
		                 function(param, cont){
		                  var d = param[2], k = param[1];
		                  return cont([0, k, [0, d, 0]]);
		                 },
		                 cont);
		       });
		                                     }
		                                     return cont
		     ([0,
		       ,
		       0,
		       [4, decode, encode, [3, [0, 0, 0, descriptor, 0]]],
		       0]);
		                                    });
		                          });
		                }
		                return res;
		               }
		               var
		                include$44 =
		                  caml_callback
		                   (M$2, [[0, comparator$2, thread_id_schema_versioned]]),
		                equal$48 = include$44[55],
		                of_alist_exn$2 = include$44[114];
		               function pp$32(pp, f, m, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (to_sequence$2,
		                         0,
		                         0,
		                         0,
		                         m,
		                         function(b){
		                          function a(f, cont){
		                           return cont
		                                   (function(t, cont){
		                                     var next = t[2], seed = t[1];
		                                     function a(seed){
		                                      return caml_trampoline_cps_call2
		      (next,
		       seed,
		       function(match){
		        if(typeof match === "number") return cont(0);
		        if(0 === match[0]){
		         var seed = match[1];
		         return caml_exact_trampoline_call1(a, seed);
		        }
		        var
		         seed$0 = match[2],
		         a$0 = match[1],
		         value = a$0[2],
		         key = a$0[1];
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(f),
		                 Io,
		                 function(b){
		                  return caml_trampoline_cps_call4
		                          (b,
		                           key,
		                           pp,
		                           value,
		                           function(b){return caml_exact_trampoline_call1(a, seed$0);});
		                 });
		       });
		                                     }
		                                     return a(seed);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(f),
		                                   Ip,
		                                   function(c){
		                                    return caml_trampoline_cps_call2
		    (c,
		     a,
		     function(a){return caml_trampoline_cps_call2(a, b, cont);});
		                                   });
		                         });
		               }
		               var
		                bQ0 = include$44[109],
		                T$1 = caml_callback(init_mod, [Ir, Iq]),
		                compare$53 = T$1[2];
		               function sexp_of_t$34(param, cont){return cont(Is);}
		               var
		                Cmp = Make$2([0, compare$53, sexp_of_t$34]),
		                letrec_function_context$153 = [];
		               function equal$49(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(1);
		                }
		                else
		                 switch(lhs[0]){
		                   case 0:
		                    if(typeof rhs !== "number" && 0 === rhs[0]){
		                     var rhsvalue = rhs[1], lhsvalue = lhs[1];
		                     return cont(lhsvalue === rhsvalue ? 1 : 0);
		                    }
		                    break;
		                   case 1:
		                    if(typeof rhs !== "number" && 1 === rhs[0]){
		                     var rhsvalue$0 = rhs[1], lhsvalue$0 = lhs[1];
		                     return cont(caml_equal(lhsvalue$0, rhsvalue$0));
		                    }
		                    break;
		                   case 2:
		                    if(typeof rhs !== "number" && 2 === rhs[0]){
		                     var rhsvalue$1 = rhs[1], lhsvalue$1 = lhs[1];
		                     return cont(lhsvalue$1 === rhsvalue$1 ? 1 : 0);
		                    }
		                    break;
		                   case 3:
		                    if(typeof rhs !== "number" && 3 === rhs[0]){
		                     var rhsvalue$2 = rhs[1], lhsvalue$2 = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$153[6],
		                              lhsvalue$2,
		                              rhsvalue$2,
		                              cont);
		                    }
		                    break;
		                   case 4:
		                    if(typeof rhs !== "number" && 4 === rhs[0]){
		                     var
		                      rhsvalue$3 = rhs[1],
		                      lhsvalue$3 = lhs[1],
		                      a =
		                        function(x, y){
		                         if(x){
		                          if(y){
		                           var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context$153[5],
		                                    a$0,
		                                    b,
		                                    function(b){
		                                     return b
		     ? caml_exact_trampoline_call2(a, x$0, y$0)
		     : cont(b);
		                                    });
		                          }
		                         }
		                         else if(! y) return cont(1);
		                         return cont(0);
		                        };
		                     return a(lhsvalue$3, rhsvalue$3);
		                    }
		                    break;
		                   case 5:
		                    if(typeof rhs !== "number" && 5 === rhs[0]){
		                     var rhsvalue$4 = rhs[1], lhsvalue$4 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$153[3],
		                              letrec_function_context$153[4],
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue$4, rhsvalue$4, cont);
		                              });
		                    }
		                    break;
		                   case 6:
		                    if(typeof rhs !== "number" && 6 === rhs[0]){
		                     var rhsvalue$5 = rhs[1], lhsvalue$5 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$153[1],
		                              letrec_function_context$153[2],
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue$5, rhsvalue$5, cont);
		                              });
		                    }
		                    break;
		                   default:
		                    if(typeof rhs !== "number" && 7 === rhs[0]){
		                     var rhsvalue$6 = rhs[1], lhsvalue$6 = lhs[1];
		                     return cont(lhsvalue$6 === rhsvalue$6 ? 1 : 0);
		                    }
		                 }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$153,
		                 [0,
		                  equal$48,
		                  equal$49,
		                  equal$11,
		                  equal$49,
		                  equal$49,
		                  equal$15]);
		               var letrec_function_context$154 = [];
		               function compare$54(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(0);
		                }
		                else
		                 switch(lhs[0]){
		                   case 0:
		                    if(typeof rhs !== "number" && 0 === rhs[0]){
		                     var rhsvalue = rhs[1], lhsvalue = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$154[9],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue, rhsvalue, cont);
		                              });
		                    }
		                    break;
		                   case 1:
		                    if(typeof rhs !== "number" && 1 === rhs[0]){
		                     var rhsvalue$0 = rhs[1], lhsvalue$0 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$154[8],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue$0, rhsvalue$0, cont);
		                              });
		                    }
		                    break;
		                   case 2:
		                    if(typeof rhs !== "number" && 2 === rhs[0]){
		                     var rhsvalue$1 = rhs[1], lhsvalue$1 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$154[7],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue$1, rhsvalue$1, cont);
		                              });
		                    }
		                    break;
		                   case 3:
		                    if(typeof rhs !== "number" && 3 === rhs[0]){
		                     var rhsvalue$2 = rhs[1], lhsvalue$2 = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$154[6],
		                              lhsvalue$2,
		                              rhsvalue$2,
		                              cont);
		                    }
		                    break;
		                   case 4:
		                    if(typeof rhs !== "number" && 4 === rhs[0]){
		                     var
		                      rhsvalue$3 = rhs[1],
		                      lhsvalue$3 = lhs[1],
		                      a =
		                        function(x, y){
		                         if(! x) return y ? cont(-1) : cont(0);
		                         if(! y) return cont(1);
		                         var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                         return caml_trampoline_cps_call3
		                                 (letrec_function_context$154[5],
		                                  a$0,
		                                  b,
		                                  function(x){
		                                   return 0 === x
		   ? caml_exact_trampoline_call2(a, x$0, y$0)
		   : cont(x);
		                                  });
		                        };
		                     return a(lhsvalue$3, rhsvalue$3);
		                    }
		                    break;
		                   case 5:
		                    if(typeof rhs !== "number" && 5 === rhs[0]){
		                     var rhsvalue$4 = rhs[1], lhsvalue$4 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$154[4],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue$4, rhsvalue$4, cont);
		                              });
		                    }
		                    break;
		                   case 6:
		                    if(typeof rhs !== "number" && 6 === rhs[0]){
		                     var rhsvalue$5 = rhs[1], lhsvalue$5 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$154[2],
		                              letrec_function_context$154[3],
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue$5, rhsvalue$5, cont);
		                              });
		                    }
		                    break;
		                   default:
		                    if(typeof rhs !== "number" && 7 === rhs[0]){
		                     var rhsvalue$6 = rhs[1], lhsvalue$6 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$154[1],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsvalue$6, rhsvalue$6, cont);
		                              });
		                    }
		                 }
		                function to_int(param){
		                 if(typeof param === "number") return 6;
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   case 6:
		                    return 7;
		                   default: return 8;
		                 }
		                }
		                var b = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), b));
		               }
		               function _8$1(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _5$1(param, cont){
		                return cont
		                        (function(a, b, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (compare_direct, compare$54, a, b, cont);
		                         });
		               }
		               function _2$7(param, a, b, cont){
		                return cont(caml_float_compare(a, b));
		               }
		               function _1$5(param, a, b, cont){
		                return cont(caml_int64_compare(a, b));
		               }
		               function _0$6(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$154,
		                 [0,
		                  _8$1,
		                  compare_direct,
		                  compare$54,
		                  _5$1,
		                  compare$54,
		                  compare$29,
		                  _2$7,
		                  _1$5,
		                  _0$6]);
		               var
		                cst_List = "List",
		                int64_schema = [0, 0, 0, 5, 0],
		                letrec_function_context$155 = [];
		               function schema_versioned$91(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$3,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$155[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, It, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$155[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$155[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$155[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([7, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 1,
		                                 0,
		                                 cst_string,
		                                 cst_String,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var value = param[1];
		                                    return cont(value);
		                                   },
		                                   function(value, cont){return cont([0, value, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_value,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$91,
		                                     schematic_version,
		                                     function(data){
		                                      return caml_trampoline_cps_call3
		      (bQ0,
		       schematic_version,
		       data,
		       function(b){
		        var
		         c =
		           [0,
		            [0,
		             function(param, cont){return cont(0);},
		             function(param, cont){
		              return typeof param === "number" ? cont(Iu) : cont(0);
		             },
		             0,
		             0,
		             cst_null,
		             cst_Null,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){return cont(0);},
		               function(param, cont){return cont(0);},
		               0],
		              0],
		             0],
		            [0,
		             [0,
		              function(f0, cont){return cont([6, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_object,
		              cst_Object,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var value = param[1];
		                 return cont(value);
		                },
		                function(value, cont){return cont([0, value, 0]);},
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_value,
		                  0,
		                  2,
		                  [0, [0, 0, b[2], b[3], b[4]]],
		                  0,
		                  0],
		                 0]],
		               0],
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$91,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$91,
		                           schematic_version,
		                           function(b){
		                            var comparator = Cmp[16];
		                            return caml_exact_trampoline_cps_call$1
		                                    (assoc_schema_versioned([0, comparator]),
		                                     b,
		                                     a,
		                                     function(a){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_map,
		   cst_Map,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var value = param[1];
		      return cont(value);
		     },
		     function(value, cont){return cont([0, value, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_value,
		       0,
		       2,
		       [0, [0, 0, a[2], a[3], a[4]]],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  c];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$91,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            Iv,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_bool,
		              cst_Bool,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var value = param[1];
		                 return cont(value);
		                },
		                function(value, cont){return cont([0, value, 0]);},
		                [0,
		                 [0, 0, 0, 0, 0, cst_value, 0, 2, [0, bool_schema], 0, 0],
		                 0]],
		               0],
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([1, f0]);},
		               function(param, cont){
		                if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                return cont(0);
		               },
		               1,
		               0,
		               cst_int,
		               cst_Int,
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var value = param[1];
		                  return cont(value);
		                 },
		                 function(value, cont){return cont([0, value, 0]);},
		                 [0,
		                  [0, 0, 0, 0, 0, cst_value, 0, 2, [0, int64_schema], 0, 0],
		                  0]],
		                0],
		               0],
		              [0,
		               [0,
		                function(f0, cont){return cont([2, f0]);},
		                function(param, cont){
		                 if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                 return cont(0);
		                },
		                1,
		                0,
		                cst_float,
		                cst_Float,
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var value = param[1];
		                   return cont(value);
		                  },
		                  function(value, cont){return cont([0, value, 0]);},
		                  [0,
		                   [0, 0, 0, 0, 0, cst_value, 0, 2, [0, float_schema], 0, 0],
		                   0]],
		                 0],
		                0],
		               [0,
		                [0,
		                 function(f0, cont){return cont([3, f0]);},
		                 function(param, cont){
		                  if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                  return cont(0);
		                 },
		                 1,
		                 0,
		                 cst_json,
		                 cst_Json,
		                 [0,
		                  0,
		                  0,
		                  [7,
		                   function(param, cont){
		                    var value = param[1];
		                    return cont(value);
		                   },
		                   function(value, cont){return cont([0, value, 0]);},
		                   [0,
		                    [0, 0, 0, 0, 0, cst_value, 0, 2, [0, no_input_schema], 0, 0],
		                    0]],
		                  0],
		                 0],
		                [0,
		                 [0,
		                  function(f0, cont){return cont([4, f0]);},
		                  function(param, cont){
		                   if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                   return cont(0);
		                  },
		                  1,
		                  0,
		                  cst_list,
		                  cst_List,
		                  [0,
		                   0,
		                   0,
		                   [7,
		                    function(param, cont){
		                     var value = param[1];
		                     return cont(value);
		                    },
		                    function(value, cont){return cont([0, value, 0]);},
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_value,
		                      0,
		                      2,
		                      [0, [0, 0, 0, [3, a], 0]],
		                      0,
		                      0],
		                     0]],
		                   0],
		                  0],
		                 b]]]]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$155[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$155[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$231 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$155, [0, schematic_cache$231]);
		               caml_callback
		                (schema_versioned$91,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$156 = [];
		               function pp$33(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst_Null, cont);
		                switch(param[0]){
		                  case 0:
		                   var avalue = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Iw,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Ix,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  Iy,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            avalue,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Iz,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), IA, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var avalue$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            IB,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IC,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ID,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            avalue$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IE,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), IF, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var avalue$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            IG,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IH,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  II,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            avalue$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IJ,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), IK, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var avalue$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            IL,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IM,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$156[5],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            avalue$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IN,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), IO, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 4:
		                   var avalue$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            IP,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IQ,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  IR,
		                  function(b){
		                   function a(accu, l$0){
		                    if(! l$0)
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              IT,
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (fprintf$0(fmt),
		IU,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt), IV, cont);
		});
		                              });
		                    var l = l$0[2], a$0 = l$0[1];
		                    function b(b){
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$156[4],
		                              fmt,
		                              function(b){
		                               return caml_trampoline_cps_call2
		                                       (b,
		a$0,
		function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                              });
		                    }
		                    return accu
		                            ? caml_exact_trampoline_cps_call(fprintf$0(fmt), IS, b)
		                            : b();
		                   }
		                   return a(0, avalue$3);
		                  });
		        });
		                                      });
		                            });
		                  case 5:
		                   var avalue$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            IW,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      IX,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$156[3],
		                  0,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            fmt,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a,
		                                      avalue$4,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        IY,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), IZ, cont);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 6:
		                   var avalue$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            I0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      I1,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (letrec_function_context$156[1],
		                  function(fmt, cont){
		                   return caml_trampoline_cps_call2
		                           (letrec_function_context$156[2], fmt, cont);
		                  },
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            avalue$5,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      I2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), I3, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var avalue$6 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            I4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      I5,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_value,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  I6,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            avalue$6,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      I7,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), I8, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               function show(x, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$57,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, pp$33, x, cont);
		                         });
		               }
		               function _2$8(param, cont){
		                return cont
		                        (function(f, map, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (to_sequence$2,
		                                   0,
		                                   0,
		                                   0,
		                                   map,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (to_seq$0,
		     a,
		     function(e){
		      var
		       a = T$1[3],
		       b = T$1[3],
		       c =
		         [0,
		          function(ppf, v, cont){
		           return caml_exact_trampoline_cps_call$1
		                   (pp_print_char,
		                    ppf,
		                    58,
		                    function(a){return cont(pp_v1(ppf));});
		          }],
		       d =
		         seq
		          ([0, comma],
		           function(d, e, cont){
		            return caml_exact_trampoline_cps_call$3
		                    (pair, c, b, a, d, e, cont);
		           });
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(f),
		               I9,
		               function(a){
		                return caml_trampoline_cps_call3(a, d, e, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$156,
		                 [0, pp$32, pp$33, _2$8, pp$33, _16]);
		               caml_callback
		                (update_mod,
		                 [I_,
		                  T$1,
		                  [0, equal$49, compare$54, pp$33, show, schema_versioned$91]]);
		               var
		                pp$34 = T$1[3],
		                schema_versioned$92 = T$1[5],
		                schema$19 =
		                  caml_callback
		                   (schema_versioned$92,
		                    [function(param, cont){return cont(0);}]),
		                equal$50 = Cmp[7],
		                cst_cases = "cases",
		                cst_tuple = "tuple",
		                cst_value_type = "value_type",
		                cst_variant = "variant",
		                d9 = [];
		               function schema_versioned$93(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$3,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   d9[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, I$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                d9[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d9[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            d9[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$93,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_variant,
		   cst_Variant,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var cases = param[1];
		      return cont(cases);
		     },
		     function(cases, cont){return cont([0, cases, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_cases,
		       0,
		       2,
		       [0, [0, 0, 0, [3, b], 0]],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$93,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_tuple,
		             cst_Tuple,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var elements = param[1];
		                return cont(elements);
		               },
		               function(elements, cont){return cont([0, elements, 0]);},
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_elements,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, c], 0]],
		                 0,
		                 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$90,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_string,
		                       cst_String,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var format = param[1];
		                          return cont(format);
		                         },
		                         function(format, cont){return cont([0, format, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_format, 0, 3, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (field_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(4);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && 4 <= param) return cont(Ja);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_null,
		                                 cst_Null,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([3, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  cst_record,
		                                  cst_Record,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var fields = param[1];
		                                     return cont(fields);
		                                    },
		                                    function(fields, cont){return cont([0, fields, 0]);},
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_fields,
		                                      0,
		                                      2,
		                                      [0, [0, 0, 0, mapping_schema(c)[3], 0]],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$93,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, c], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$93,
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([2, f0, f1]);
		             },
		             function(param, cont){
		              if(typeof param !== "number" && 2 === param[0]){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              }
		              return cont(0);
		             },
		             1,
		             0,
		             cst_map,
		             cst_Map,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var data = param[2][1], key = param[1];
		                return cont([0, key, data]);
		               },
		               function(param, cont){
		                var data = param[2], key = param[1];
		                return cont([0, key, [0, data, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, d], 0, 0], a]],
		              0],
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$93,
		                 schematic_version,
		                 function(b){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(1);},
		                       function(param, cont){
		                        if(typeof param === "number" && 1 === param)
		                         return cont(Jd);
		                        return cont(0);
		                       },
		                       0,
		                       0,
		                       cst_int,
		                       cst_Int,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){return cont(0);},
		                         function(param, cont){return cont(0);},
		                         0],
		                        0],
		                       0],
		                      [0,
		                       [0,
		                        function(param, cont){return cont(2);},
		                        function(param, cont){
		                         if(typeof param === "number" && 2 === param)
		                          return cont(Jc);
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_float,
		                        cst_Float,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){return cont(0);},
		                          function(param, cont){return cont(0);},
		                          0],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(3);},
		                         function(param, cont){
		                          if(typeof param === "number" && 3 === param)
		                           return cont(Jb);
		                          return cont(0);
		                         },
		                         0,
		                         0,
		                         cst_json,
		                         cst_Json,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){return cont(0);},
		                           function(param, cont){return cont(0);},
		                           0],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([1, f0]);},
		                          function(param, cont){
		                           if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                           return cont(0);
		                          },
		                          1,
		                          0,
		                          cst_list,
		                          cst_List,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var elements = param[1];
		                             return cont(elements);
		                            },
		                            function(elements, cont){return cont([0, elements, 0]);},
		                            [0, [0, 0, 0, 0, 0, cst_elements, 0, 2, [0, b], 0, 0], 0]],
		                           0],
		                          0],
		                         c]]]];
		                  return caml_trampoline_cps_call2
		                          (T$1[5],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$93,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       res =
		 [11,
		  Jf,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){
		     if(typeof param === "number" && ! param) return cont(Je);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_bool,
		    cst_Bool,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){
		      var f1 = param[2], f0 = param[1];
		      return cont([0, f0, f1]);
		     },
		     function(param, cont){
		      if(typeof param !== "number" && 0 === param[0]){
		       var f1 = param[2], f0 = param[1];
		       return cont([0, [0, f0, f1]]);
		      }
		      return cont(0);
		     },
		     1,
		     0,
		     cst_const,
		     cst_Const,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var value = param[2][1], value_type = param[1];
		        return cont([0, value_type, value]);
		       },
		       function(param, cont){
		        var value = param[2], value_type = param[1];
		        return cont([0, value_type, [0, value, 0]]);
		       },
		       [0, [0, 0, 0, 0, 0, cst_value_type, 0, 2, [0, c], 0, 0], b]],
		      0],
		     0],
		    a]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       d9[1][1],
		       schematic_schema_version,
		       res,
		       function(a){d9[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$157 = [];
		               function field_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$3,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$157[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Jg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$157[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$157[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$157[1][1] = b;
		                            var
		                             default$ = match$112[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_writable,
		                                 0,
		                                 [0, default$],
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$93,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var writable = param[2][1], type = param[1];
		   return cont([0, type, writable]);
		  },
		  function(param, cont){
		   var writable = param[2], type = param[1];
		   return cont([0, type, [0, writable, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$157[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$157[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$232 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d9, [0, schematic_cache$232]);
		               var schematic_cache$233 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$157, [0, schematic_cache$233]);
		               caml_callback
		                (schema_versioned$93,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (field_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               g
		                ([0,
		                  symbol_bind$5,
		                  symbol_map$5,
		                  ,
		                  bind$8,
		                  return$9,
		                  map$17,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$3]);
		               function to_ast(t, cont){
		                if(typeof t === "number") return cont([0, 0, none$2]);
		                switch(t[0]){
		                  case 0:
		                   var value = t[1], s = value ? cst_true : cst_false;
		                   return cont([0, [12, [0, s]], none$2]);
		                  case 1:
		                   var value$0 = t[1]; return cont([0, [6, value$0], none$2]);
		                  case 2:
		                   var value$1 = t[1]; return cont([0, [7, value$1], none$2]);
		                  case 4:
		                   var value$2 = t[1];
		                   return caml_trampoline_cps_call3
		                           (map$18,
		                            value$2,
		                            to_ast,
		                            function(a){
		                             var value = [9, a];
		                             return cont([0, value, none$2]);
		                            });
		                  case 6:
		                   var value$3 = t[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (to_alist$0,
		                            0,
		                            value$3,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (map$18,
		                                      a,
		                                      function(param, cont){
		                                       var v = param[2], name = param[1];
		                                       return caml_exact_trampoline_cps_call
		       (to_ast, v, function(a){return cont([0, name, a]);});
		                                      },
		                                      function(a){
		                                       var value = [13, a];
		                                       return cont([0, value, none$2]);
		                                      });
		                            });
		                  case 7:
		                   var value$4 = t[1]; return cont([0, [16, value$4], none$2]);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            invalid_arg,
		                            fmt$58,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, pp$34, t, cont);
		                            });
		                }
		               }
		               function of_date$3(param, cont){
		                var
		                 year = param[3],
		                 month = param[2],
		                 day = param[1],
		                 a = [0, [0, cst_Year, [1, caml_int64_of_int32(year)]], 0];
		                return caml_exact_trampoline_cps_call
		                        (to_string$18,
		                         month,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (lowercase_ascii$0,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_alist_exn$1,
		     [0, comparator$2],
		     [0,
		      [0, cst_Day, [1, caml_int64_of_int32(day)]],
		      [0, [0, cst_Month, [7, b]], a]],
		     function(a){return cont([6, a]);});
		                                   });
		                         });
		               }
		               var
		                semantic_action$0 =
		                  [0,
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = a[4],
		                     startpos_x = a[3],
		                     x = a[2],
		                     endpos_3 = menhir_stack[4],
		                     value = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, value],
		                              startpos_1,
		                              endpos_3,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = a[4],
		                     startpos_x = a[3],
		                     x = a[2],
		                     endpos_4 = menhir_stack[4],
		                     filter = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, filter],
		                              startpos_1,
		                              endpos_4,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     b = a[5][5],
		                     match = b[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     field = b[2],
		                     endpos_x = a[4],
		                     startpos_x = a[3],
		                     x = a[2],
		                     endpos_5 = menhir_stack[4],
		                     value = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [2, field, value],
		                              startpos_1,
		                              endpos_5,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     value =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     name = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, name, value],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1],
		                     name = [0, x, of_lexing$0(startpos_x, endpos_x)],
		                     v = [0, name, [0, [12, name[1]], name[2]]];
		                    return cont
		                            ([0, menhir_s, v, startpos_x, endpos_x, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_2 = menhir_stack[4],
		                     v = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0, menhir_s, v, startpos_x, endpos_2, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_expression = match[3],
		                     expression = match[2],
		                     menhir_s = match[1],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     action = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, expression, action],
		                              startpos_expression,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_bindings = menhir_stack[4],
		                     bindings = menhir_stack[2];
		                    return caml_exact_trampoline_cps_call$1
		                            (map$0,
		                             function(param, cont){
		                              var value = param[2], id = param[1];
		                              return cont([0, id, value]);
		                             },
		                             bindings,
		                             function(v){
		                              return cont
		                                      ([0,
		menhir_s,
		v,
		startpos_1,
		endpos_bindings,
		menhir_stack$0]);
		                             });
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_types = menhir_stack[4],
		                     types = menhir_stack[2];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              types,
		                              startpos_1,
		                              endpos_types,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_res = match[3],
		                     res = match[2],
		                     menhir_s = match[1],
		                     endpos_2 = menhir_stack[4],
		                     v = flatten(res);
		                    return cont
		                            ([0, menhir_s, v, startpos_res, endpos_2, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_2 = menhir_stack[4],
		                     v = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0, menhir_s, v, startpos_x, endpos_2, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_v = menhir_stack[4],
		                     startpos_v = menhir_stack[3],
		                     v = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, [6, v], startpos_v, endpos_v, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_v = menhir_stack[4],
		                     startpos_v = menhir_stack[3],
		                     v = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, [7, v], startpos_v, endpos_v, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5][5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     type = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [11, type],
		                              startpos_1,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     items = a[2],
		                     endpos_3 = menhir_stack[4];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [9, items],
		                              startpos_1,
		                              endpos_3,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_v = menhir_stack[4],
		                     startpos_v = menhir_stack[3],
		                     v = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [16, v],
		                              startpos_v,
		                              endpos_v,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     exp = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [19, 0, exp],
		                              startpos_1,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_1 = a[4],
		                     startpos_1 = a[3],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     a = of_lexing$0(startpos_1, endpos_1),
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, [0, [12, [0, cst$32]], a], [0, lhs, [0, rhs, 0]]],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_1 = a[4],
		                     startpos_1 = a[3],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     a = of_lexing$0(startpos_1, endpos_1),
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, [0, [12, [0, cst$34]], a], [0, lhs, [0, rhs, 0]]],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_1 = a[4],
		                     startpos_1 = a[3],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     a = of_lexing$0(startpos_1, endpos_1),
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, [0, [12, [0, cst$52]], a], [0, lhs, [0, rhs, 0]]],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_1 = a[4],
		                     startpos_1 = a[3],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     a = of_lexing$0(startpos_1, endpos_1),
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, [0, [12, [0, cst$33]], a], [0, lhs, [0, rhs, 0]]],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_1 = a[4],
		                     startpos_1 = a[3],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     a = of_lexing$0(startpos_1, endpos_1),
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, [0, [12, [0, cst$53]], a], [0, lhs, [0, rhs, 0]]],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 0, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 8, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 1, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 2, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 3, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 5, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 6, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 7, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     rhs =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     lhs = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, lhs, 4, rhs],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     exp = a[2],
		                     endpos_3 = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, exp, startpos_1, endpos_3, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_id = menhir_stack[4],
		                     startpos_id = menhir_stack[3],
		                     id = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [12, id],
		                              startpos_id,
		                              endpos_id,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, 0, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     allow_missing = a[2],
		                     endpos_field_name = menhir_stack[4],
		                     field_name = menhir_stack[2],
		                     source = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [2, source, field_name, allow_missing],
		                              startpos_x,
		                              endpos_field_name,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     xs = a[2],
		                     endpos_4 = menhir_stack[4],
		                     f = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, f, xs],
		                              startpos_x,
		                              endpos_4,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     xs = a[2],
		                     endpos_3 = menhir_stack[4];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [13, xs],
		                              startpos_1,
		                              endpos_3,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = a[4],
		                     startpos_x_inlined1 = a[3],
		                     x_inlined1 = a[2],
		                     endpos_4 = menhir_stack[4],
		                     index =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     collection = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [17, collection, index],
		                              startpos_x,
		                              endpos_4,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     selected =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     expression = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [15, expression, selected],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     filter =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     exp = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [20, exp, filter],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5][5],
		                     match = a[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     direction = a[2],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     sort_expr =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     expression = [0, x, of_lexing$0(startpos_x, endpos_x)],
		                     v = [21, expression, [0, sort_expr, value(direction, 0)]];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              v,
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     limit =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     expression = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [22, expression, limit],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_pick = menhir_stack[4],
		                     pick = menhir_stack[2],
		                     exp = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [14, exp, pick],
		                              startpos_x,
		                              endpos_pick,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_name = menhir_stack[4],
		                     name = menhir_stack[2],
		                     from = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [3, from, [0, name]],
		                              startpos_x,
		                              endpos_name,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5][5],
		                     match = a[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     indexed = a[2],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     key =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     expression = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [4, expression, indexed, key],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5][5],
		                     b = a[5][5],
		                     match = b[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = b[4],
		                     startpos_x = b[3],
		                     x = b[2],
		                     endpos_x_inlined1 = a[4],
		                     startpos_x_inlined1 = a[3],
		                     x_inlined1 = a[2],
		                     endpos_x_inlined2 = menhir_stack[4],
		                     startpos_x_inlined2 = menhir_stack[3],
		                     x_inlined2 = menhir_stack[2],
		                     else$ =
		                       [0,
		                        x_inlined2,
		                        of_lexing$0(startpos_x_inlined2, endpos_x_inlined2)],
		                     then =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     condition = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [5, condition, then, else$],
		                              startpos_1,
		                              endpos_x_inlined2,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5][5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     bindings = a[2],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     expression = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [8, bindings, expression],
		                              startpos_1,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     type =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     expression = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [18, expression, type],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_id = match[3],
		                     id = match[2],
		                     menhir_s = match[1],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     exp = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, id, exp],
		                              startpos_id,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     id = menhir_stack[2],
		                     menhir_s = menhir_stack[1],
		                     value =
		                       [0, [12, [0, id]], of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, id, value],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_steps = menhir_stack[4],
		                     startpos_steps = menhir_stack[3],
		                     steps = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    function a(v){
		                     return cont
		                             ([0,
		                               menhir_s,
		                               v,
		                               startpos_steps,
		                               endpos_steps,
		                               menhir_stack$0]);
		                    }
		                    if(! steps)
		                     return caml_exact_trampoline_cps_call
		                             (failwith,
		                              "menhir's nonempty_list yielded an empty list",
		                              a);
		                    var tail = steps[2], head = steps[1];
		                    return a([0, head, tail]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     exp =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     id = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, id, exp],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, 0, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, 1, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_id = menhir_stack[4],
		                     startpos_id = menhir_stack[3],
		                     id = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, id],
		                              startpos_id,
		                              endpos_id,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_max],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_min],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_day],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_hour],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_month],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_minute],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_second],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_week],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, cst_year],
		                              startpos_1,
		                              endpos_1,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_s = menhir_env[4],
		                     startpos = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, 0, startpos, startpos, menhir_stack]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_s = menhir_env[4],
		                     startpos = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, 0, startpos, startpos, menhir_stack]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, x, startpos_x, endpos_x, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_s = menhir_env[4],
		                     startpos = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, 0, startpos, startpos, menhir_stack]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, x, startpos_x, endpos_x, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_s = menhir_env[4],
		                     startpos = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, 0, startpos, startpos, menhir_stack]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, x, startpos_x, endpos_x, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_s = menhir_env[4],
		                     startpos = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, 0, startpos, startpos, menhir_stack]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1],
		                     x$0 = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x$0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_s = menhir_env[4],
		                     startpos = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, 0, startpos, startpos, menhir_stack]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, [0, x], startpos_x, endpos_x, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, v$0, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     exp = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, [0, exp]],
		                              startpos_1,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, v, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     exp = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, [0, exp]],
		                              startpos_1,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_id = menhir_stack[4],
		                     startpos_id = menhir_stack[3],
		                     id = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, id],
		                              startpos_id,
		                              endpos_id,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = a[4],
		                     startpos_x = a[3],
		                     x = a[2],
		                     endpos_3 = menhir_stack[4],
		                     e = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0, menhir_s, [1, e], startpos_1, endpos_3, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_s = menhir_env[4],
		                     startpos = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, 0, startpos, startpos, menhir_stack]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1],
		                     x$0 = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x$0, 0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2],
		                     x$0 = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x$0, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, 0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, 0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, 0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, 0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1],
		                     x$0 = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x$0, 0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2],
		                     x$0 = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x$0, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1],
		                     x$0 = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x$0, 0],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_xs = menhir_stack[4],
		                     xs = menhir_stack[2],
		                     x$0 = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, x$0, xs],
		                              startpos_x,
		                              endpos_xs,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, 0, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, 1, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_x = menhir_stack[4],
		                     startpos_x = menhir_stack[3],
		                     x = menhir_stack[2],
		                     menhir_s = menhir_stack[1],
		                     id = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [0, id],
		                              startpos_x,
		                              endpos_x,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_v = menhir_stack[4],
		                     startpos_v = menhir_stack[3],
		                     v = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, [1, v], startpos_v, endpos_v, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = a[4],
		                     startpos_x = a[3],
		                     x = a[2],
		                     endpos_3 = menhir_stack[4],
		                     data = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [3, data],
		                              startpos_1,
		                              endpos_3,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     b = a[5][5],
		                     match = b[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     endpos_x = b[4],
		                     startpos_x = b[3],
		                     x = b[2],
		                     endpos_x_inlined1 = a[4],
		                     startpos_x_inlined1 = a[3],
		                     x_inlined1 = a[2],
		                     endpos_5 = menhir_stack[4],
		                     data =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     key = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [4, key, data],
		                              startpos_1,
		                              endpos_5,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_1 = menhir_stack[4],
		                     startpos_1 = menhir_stack[3],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, 0, startpos_1, endpos_1, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     xs = a[2],
		                     endpos_3 = menhir_stack[4];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [5, xs],
		                              startpos_1,
		                              endpos_3,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     menhir_stack$0 = menhir_stack[5],
		                     endpos_v = menhir_stack[4],
		                     startpos_v = menhir_stack[3],
		                     v = menhir_stack[2],
		                     menhir_s = menhir_stack[1];
		                    return cont
		                            ([0, menhir_s, [6, v], startpos_v, endpos_v, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     startpos_head = match[3],
		                     head = match[2],
		                     menhir_s = match[1],
		                     endpos_tail = menhir_stack[4],
		                     tail = menhir_stack[2];
		                    a:
		                    {
		                     if(typeof tail !== "number" && 7 === tail[0]){
		                      var tail$0 = tail[1], v = [7, [0, head, tail$0]];
		                      break a;
		                     }
		                     v = [7, [0, head, [0, tail, 0]]];
		                    }
		                    return cont
		                            ([0,
		                              menhir_s,
		                              v,
		                              startpos_head,
		                              endpos_tail,
		                              menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     a = menhir_stack[5],
		                     match = a[5],
		                     menhir_stack$0 = match[5],
		                     startpos_1 = match[3],
		                     menhir_s = match[1],
		                     t = a[2],
		                     endpos_3 = menhir_stack[4];
		                    return cont
		                            ([0, menhir_s, t, startpos_1, endpos_3, menhir_stack$0]);
		                   },
		                   function(menhir_env, cont){
		                    var
		                     menhir_stack = menhir_env[3],
		                     match = menhir_stack[5][5],
		                     menhir_stack$0 = match[5],
		                     endpos_x = match[4],
		                     startpos_x = match[3],
		                     x = match[2],
		                     menhir_s = match[1],
		                     endpos_x_inlined1 = menhir_stack[4],
		                     startpos_x_inlined1 = menhir_stack[3],
		                     x_inlined1 = menhir_stack[2],
		                     value =
		                       [0,
		                        x_inlined1,
		                        of_lexing$0(startpos_x_inlined1, endpos_x_inlined1)],
		                     name = [0, x, of_lexing$0(startpos_x, endpos_x)];
		                    return cont
		                            ([0,
		                              menhir_s,
		                              [1, name, value],
		                              startpos_x,
		                              endpos_x_inlined1,
		                              menhir_stack$0]);
		                   }];
		               function token2terminal(tok){
		                if(typeof tok === "number")
		                 switch(tok){
		                   case 0:
		                    return 1;
		                   case 1:
		                    return 2;
		                   case 2:
		                    return 3;
		                   case 3:
		                    return 4;
		                   case 4:
		                    return 5;
		                   case 5:
		                    return 6;
		                   case 6:
		                    return 8;
		                   case 7:
		                    return 9;
		                   case 8:
		                    return 10;
		                   case 9:
		                    return 11;
		                   case 10:
		                    return 12;
		                   case 11:
		                    return 13;
		                   case 12:
		                    return 14;
		                   case 13:
		                    return 15;
		                   case 14:
		                    return 16;
		                   case 15:
		                    return 17;
		                   case 16:
		                    return 18;
		                   case 17:
		                    return 19;
		                   case 18:
		                    return 20;
		                   case 19:
		                    return 21;
		                   case 20:
		                    return 22;
		                   case 21:
		                    return 23;
		                   case 22:
		                    return 24;
		                   case 23:
		                    return 25;
		                   case 24:
		                    return 26;
		                   case 25:
		                    return 27;
		                   case 26:
		                    return 28;
		                   case 27:
		                    return 29;
		                   case 28:
		                    return 30;
		                   case 29:
		                    return 31;
		                   case 30:
		                    return 32;
		                   case 31:
		                    return 34;
		                   case 32:
		                    return 35;
		                   case 33:
		                    return 36;
		                   case 34:
		                    return 37;
		                   case 35:
		                    return 39;
		                   case 36:
		                    return 40;
		                   case 37:
		                    return 41;
		                   case 38:
		                    return 43;
		                   case 39:
		                    return 44;
		                   case 40:
		                    return 45;
		                   case 41:
		                    return 46;
		                   case 42:
		                    return 47;
		                   case 43:
		                    return 48;
		                   case 44:
		                    return 49;
		                   case 45:
		                    return 50;
		                   case 46:
		                    return 51;
		                   case 47:
		                    return 52;
		                   case 48:
		                    return 53;
		                   case 49:
		                    return 54;
		                   case 50:
		                    return 55;
		                   case 51:
		                    return 56;
		                   case 52:
		                    return 57;
		                   case 53:
		                    return 58;
		                   case 54:
		                    return 59;
		                   default: return 60;
		                 }
		                switch(tok[0]){
		                  case 0:
		                   return 7;
		                  case 1:
		                   return 33;
		                  case 2:
		                   return 38;
		                  default: return 42;
		                }
		               }
		               function token2value(tok){
		                if(typeof tok === "number") return 0;
		                var v = tok[1];
		                return v;
		               }
		               function error$2(i$0, j){
		                var
		                 i$1 = (61 * i$0 | 0) + j | 0,
		                 i = i$1 >>> 3 | 0,
		                 c =
		                   caml_string_unsafe_get
		                    ('Q%\x85x\xc7 H\x88\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\x16\x10W\x8cr\x04\xa8\0\0\0\0\0\0\0\x01D\x84\x15\xe3\x1c\x81"\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x10\x07\x800\x04\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\b\0\0\x02\x89\b+\xc69\x02D\0\0\0\0\0\0\0\0\xa2B\n\xf1\x8e@\x91\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\b\0\0\0\0\0\0\0X\n$ \xaf\x18\xe4\t\x10Q!\x05x\xc7 H\x80\0\0\0\0\0\0\0\v\xbf\xb7\xa1\xee7\xcd\xce\xa2B\n\xf1\x8e@\x91\x02O\xa5hs\r2#(\x90\x82\xbcc\x90$@\xbb\xfbz\x1e\xe3|\xdc\xea$ \xaf\x18\xe4\t\x10*\xfe\xde\x01\x98\x0f7:\x89\b+\xc69\x02D\v\xbf\xb7\xa1\xee7\xcd\xce\xa2B\x1a\xf1\x8e@\x91\0\0\0\0\0\0\0\0\0\0\x04\0\0\0\0\0\0\0\0\0\0\0\0\x04\x97K\xd0\xe6\x1ad\xc6\0\0\0\0\0\0\x81@\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x10(\x90\x82\xbcc\x90$@\xbb\xfbz\x1e\xe3|\xdc\xea$ \xaf\x18\xe4\t\x10.\xfe\xde\x87\xb8\xdf78\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xa0B\0\xf0\x06\0\x80\x05\x12\x10W\x8cr\x04\x88\x12}+C\x98i\x91\x18\0\0\0\0\0\0\0\n$ \xaf\x18\xe4\t\x10.\xfe\xde\x87\xb8\xdf7:\x89\b+\xc69\x02D\v\xbf\xb7\xa1\xee7\xcd\xce\xa2B\n\xf1\x8e@\x91\x02\xef\xed\xe8{\x8d\xf3s\xa8\x90\x82\xbcc\x90$@\xab\xfbx\x06`<\xdc\xea$ \xaf\x18\xe4\t\x10.\xfe\xde\x87\xb8\xdf7:\x89\b+\xc69\x02D\n\xbf\xb7\x80f\x03\xcd\xce\xa2B\n\xf1\x8e@\x91\x02\xaf\xed\xe0\x19\x80\xf3s\xa8\x90\x82\xbcc\x90$@\xab\xfbx\x06`<\xdc\xea$ \xaf\x18\xe4\t\x10*\xfe\xde\x01\x98\x0f7:\x89\b+\xc69\x02D\n\xbf\xb7\x80f\x03\xcd\xce\xa2B\n\xf1\x8e@\x91\x02\xaf\xed\xe0\x19\x80\xf3s\xa8\x90\x82\xbcc\x90$@\xbb\xfbz\x1e\xe3|\xdc\xea$ \xaf\b`\t\0\0\0\0\0\0\0\0\x02\x89\b+\xc2\x18\x02@\x14HA^\x10\xc0\x12\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\b\0\0\0\0\0\0\0\b\n$ \xaf\b`\t\0\0\0 \0\0\0\x14\x02\x89\b+\xc2\x18\x02@\v\xbf\xbf\xa1\xee7\xcd\xce\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\b\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x02\x80\0\0\0\0\x02\0\0\0\0\0\0\0\0\0\0\0\0\n\0\0\0\0\0\0\0\0\0\0\0\0\0\x04\x02\0\0\0\0 \0\0\0\0\0\0\0\x01D\x84\x15\xe1\f\x01 \0\b\x04\0\0\0\0\0\0\0\0\0\0\0\0\x01w\xf7\xf4=\xc6\xf9\xb9\xc0\0\0\x06\0\0\0\0\xff\xff\xbf\xff\xff\xfe\xffr\xef\xed\xe8{\x8d\xf3s\xbf\xff\xef\xff\xff\xff\xbf\xdc\xbb\xfbz\x1e\xe3|\xdc\xe0\0\0\0\0\0\0\0Q!\x05x\xc7 H\x81w\xf6\xf4=\xc6\xf9\xb9\xd4HA^1\xc8\x12`\0\0\0\0\0\0\x02\x05\x12\x10W\x8cr\x04\x88\x17\x7foC\xdco\x9b\x9c\x92\xfbZ\x1c\xc3L\x8c\xe0\0\0\0\0@\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xa2B\n\xf1\x8e@\x91\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x92\xe9Z\x1c\xc3L\xd8\xc0\0\0\0\0\0\0\0\0\0\0\0\0\0\x10\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\0\0\x04\0\0\0\0\0\0\0\0\0\0\x13]+C\x98i\x91\x19D\x84\x15\xe3\x1c\x81"\x04\x97J\xd0\xe6\x1a\xe4FQ!\x05x\xc7 H\x81w\xf6\xf4=\xc6\xf9\xb9\xcb\xbf\xb7\xa1\xee7\xcd\xce\x10\0\0\x01\x100\0%\x12\x10W\x8cr\x04\x88\x16]+C\xdcm\x91\x18 \0\0\x02  \0J\0 \x0f\0`\b\0\0\0\0\0\0\0\0\x01%\xd2\xf49\x86\x99\x11\x80\0\0\0\0\0\0\0\0\x80\0\0\0\0\0\0\0\0\0\0\0\0 (\x90\x82\xbc!\x80$\0\xbb\xfb\xfa\x1e\xe3|\xdc\xe0\b\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\'\xd2\xb49\x86\x991\x94XA^1\xc8\x12 \0\0\0\0\0\0\0\0\0H\0\0\0\0\0\xa8\x10\x80<\x01\x80 \0\0\0\0\0\0\0\0\0\0\0\0\0\x02 \0P!\0x\x03\0@\0\0\0\0\0\0\0\0\0\0\0\0\0\x04\0\0\xa2B\n\xf1\x8e@\x91\x02K\xa5hs\r\xb2#\0\0\0\0\0\0\0\0\x80\0\0\0\0\0\0\n$ \xaf\x18\xe4\t\x10$\xbaV\x870\xdb"0\0\0\0\0\0\0\0\x14HA^1\xc8\x12 It\xad\x0ea\xb6D`\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0 \0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0@\0\0\x04\0@\0\x14\0@\x1e\0\xc0\x10\0\x10\0\0\x01\0\x10\0%\0\x10\x07\x800\x04\0\0\0\0\0\0\0\0\0\0\0\0\0\0@\0\n$ \xaf\b`\t\0\b\0 \0\x80\b\0\x10\0\0\0\0\0\0\0\x14\0@\x1e\0\xc0\x10\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x80\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\0\0\x10\x01\0\0\0\0\0\0\0\0\0\x02\x89\b+\xc69\x02D\t.\x95\xa1\xcc6\xc8\x8c\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0(\0\x80<\x01\x80 \0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0',
		                     i),
		                 c$0 = c >>> ((i$1 ^ -1) & 7) | 0,
		                 c$1 = c$0 & 1;
		                return c$1;
		               }
		               function action(i, j){
		                var
		                 k =
		                   decode$5
		                    (get16
		                      ('\x0f"\0\0\0\0\0\0\x0f"\0\0\x0f"\0\0\0\0\0\0\0\0\0\0\0v\0\0\0\0\0\0\0\xda\x0f"\0\0\x0f"\0\0\0\xbe\0\xb4\x0f"\x0f"\0\0\bL\x0f"\t\xae\x0f"\x07`\x0f"\n\x9a\x0f"\x04&\x0f"\0\0\x01\x88\0\0\r\xd4\x02\x12\0\0\0\0\0\0\0,\x0f"\x05\xfe\x0f"\x06t\0\0\0\0\x10\x1c\x0f"\r\xd4\0\0\x0f"\x06\xea\x0f"\t8\x0f"\x07\xd6\x0f"\n$\x0f"\x03\xb0\x0f"\r^\x0f"\v\x86\x0f"\v\x10\x0f"\v\xfc\x0f"\fr\x0f"\f\xe8\x0f"\x04\x9c\x0f\xf6\0\0\x0f\xf6\x0f\xf6\0\0\0\0\x01\x02\x01.\x0f\xf6\x108\x0f\xf6\x01\xd8\0\0\0\0\x01>\0\0\x01\xa6\x01\x02\0\0\x108\0\0\x108\0\0\x0f\xf6\0L\0\0\x01b\x01\0\0v\x05\x12\0\x03\x05\x88\0\0\x0f"\b\xc2\x0f"\x01H\x0f"\x03:\t\xae\x01v\0\0\0\0\0\0\x0f"\0\0\0\0\t\xae\0\0\0E\0\0\x01\xa0\0\xbe\0\0\t\xae\x0f"\t\xae\x0f"\x02\xc4\x02N\x0f*\x0f"\x0eH\n\x16\0v\0\0\t\xae\0\0\0\xc4\0\xc2\x0f\xf6\0\xec\x01:\0\0\x0e\xb6\x0f"\0\0\x01 \x10\x1c\0\0\0\x9c\x10\x1c\0\0\0\xfe\x0f"\x0e\xb6\0\0\x01|\x0f"\t\xae\0\0\x0f"\r\xd4\0\0\0\0\x018\0\0\0\0\x01V\0v\x01T\0v\0\0\x01\x1a\x0f\xf6\x108\0\0\0v\0\0\0\x90\0\0\0\0\x01V\0\0\x0f"\x0f\x92\0\0\0\0\x0f\x92\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0',
		                       i)),
		                 i$0 = k + j | 0;
		                return get16
		                        ('\0\x06\x01A\0\n\x01A\x01A\x01A\0\x0e\x01A\x01A\0\x12\x01A\x01A\x01A\x01A\0\x16\x01A\x01A\x02\x06\x01A\x01A\0\x1a\x01A\0\x1e\x01A\0"\0&\0*\0.\x01A\x01A\x01A\x01A\0J\x01A\x01A\x01A\0N\x006\0:\x01A\x01A\0R\x01A\x01A\x01A\x01A\x01A\x01\xa2\0>\x01A\x01A\0V\x01A\x01A\x01A\0b\x01f\x01A\x01A\x01A\0\x06\x01I\0\n\x01I\x01I\x01I\0\x0e\x01I\x01I\0\x12\x01I\x01I\x01I\x01I\0\x16\x01I\x01I\0\xb6\x01I\x01I\0\x1a\x01I\0\x1e\x01I\0"\0&\0*\0.\x01I\x01I\x01I\x01I\0J\x01I\x01I\x01I\0N\x006\0:\x01I\x01I\0R\x01I\x01I\x01I\x01I\x01I\x02R\0>\x01I\x01I\0V\x01I\x01I\x01I\0b\x02\xf7\x01I\x01I\x01I\0E\x01\x8d\0E\0E\0E\x02\x82\0E\0E\0E\0E\0E\0E\0E\0Z\0E\0E\x01f\0E\0E\0E\0E\0\xd5\0E\0\xd5\0^\0F\x01\x19\0E\0E\0E\0E\x02V\0E\0E\0E\x01\xae\x01\xb6\x02v\0E\0E\x02\x9a\0E\0E\0E\0E\0E\x02b\x01Z\0E\0E\x02\x8e\0E\0E\0E\x01m\x02\xca\0E\0E\0E\0\xcd\x01!\0\xcd\0\xcd\0\xcd\x02\xde\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\x02\x9e\0\xcd\0\xcd\x01f\0\xcd\0\xcd\0\xcd\0\xcd\x02\xbf\0\xcd\x01m\x02\xea\x02\xaa\x01^\0\xcd\0\xcd\0\xcd\0\xcd\x01z\0\xcd\0\xcd\0\xcd\x01m\x01\x11\0\x9a\0\xcd\0\xcd\x01\xd2\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\x01\xe2\0\0\0\xcd\0\xcd\x02\xd2\0\xcd\0\xcd\0\xcd\0\0\0\0\0\xcd\0\xcd\0\xcd\x01\xb9\0\0\x01\xb9\x01\xb9\x01\xb9\0\0\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\0\0\x01\xb9\x01\xb9\x01f\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01u\x01\xb9\x02\x0e\x01}\0\0\x01\x82\x01\xb9\x01\xb9\x01\xb9\x01\xb9\0\0\x01\xb9\x01\xb9\x01\xb9\0\0\0\0\0\0\x01\xb9\x01\xb9\0\0\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\0\0\0\0\x01\xb9\x01\xb9\0\0\x01\xb9\x01\xb9\x01\xb9\0\0\0\0\x01\xb9\x01\xb9\x01\xb9\0v\0\0\0\xc9\0~\0\xc9\0\0\0\x86\0\xc9\0n\0\xa2\0\xbe\0\xc9\0\xde\0\0\0\xc9\0\xe6\0\xa6\x01\xaa\0\xc9\0\x8e\0\xee\0\0\0\xf6\x019\0\0\0\xaa\0\0\x01\x06\x01\x0e\x01\xc2\0\xc9\0\0\x01\x16\x01\xca\0\xc9\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\xc9\0\xc9\0\xc6\0\xca\0\0\0\0\0\xfe\0\xc9\0\0\0\xc9\x01>\0\xc9\0\0\0\0\x01\xde\x016\0\xc9\0\xc5\0\0\0\xc5\0~\0\xc5\0\0\0\x86\0\xc5\0n\0\xc5\0\xbe\0\xc5\0\xc5\0\0\0\xc5\0\xe6\0\0\0\xc5\0\xc5\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0\xc5\0\xc5\0\0\x01\x16\0\xc5\0\xc5\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\xc5\0\xc5\0\xc6\0\xca\0\0\0\0\0\xfe\0\xc5\0\0\0\xc5\0\xc5\0\xc5\0\0\0\0\0\xc5\x016\0\xc5\0\xc1\0\0\0\xc1\0~\0\xc1\0\0\0\x86\0\xc1\0n\0\xc1\0\xbe\0\xc1\0\xc1\0\0\0\xc1\0\xe6\0\0\0\xc1\0\xc1\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0\xc1\0\xc1\0\0\x01\x16\0\xc1\0\xc1\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\xc1\0\xc1\0\xc6\0\xca\0\0\0\0\0\xfe\0\xc1\0\0\0\xc1\x01>\0\xc1\0\0\0\0\0\xc1\x016\0\xc1\0a\0\0\0a\0a\0a\0\0\0\x86\0a\0n\0a\0\xbe\0a\0a\0\0\0a\0a\0\0\0a\0a\0\x8e\0a\0\0\0a\0\0\0\0\0\0\0\0\0a\0a\0a\0a\0\0\0a\0a\0a\0\0\0\0\0\0\0a\0a\0\0\0a\0a\0a\0\xc6\0\xca\0\0\0\0\0a\0a\0\0\0a\0a\0a\0\0\0\0\0a\0a\0a\0]\0\0\0]\0]\0]\0\0\0]\0]\0n\0]\0]\0]\0]\0\0\0]\0]\0\0\0]\0]\0\x8e\0]\0\0\0]\0\0\0\0\0\0\0\0\0]\0]\0]\0]\0\0\0]\0]\0]\0\0\0\0\0\0\0]\0]\0\0\0]\0]\0]\0\xc6\0\xca\0\0\0\0\0]\0]\0\0\0]\0]\0]\0\0\0\0\0]\0]\0]\0i\0\0\0i\0~\0i\0\0\0\x86\0i\0n\0i\0\xbe\0i\0i\0\0\0i\0\xe6\0\0\0i\0i\0\x8e\0i\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0i\0i\0\0\x01\x16\0i\0i\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0i\0i\0\xc6\0\xca\0\0\0\0\0\xfe\0i\0\0\0i\0i\0i\0\0\0\0\0i\0i\0i\x01M\0\0\x01M\0~\x01M\0\0\0\x86\x01M\0n\x01M\0\xbe\x01M\x01M\0\0\x01M\0\xe6\0\0\x01M\x01M\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\x01M\x01M\0\0\x01\x16\x01M\x01M\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\x01M\x01M\0\xc6\0\xca\0\0\0\0\0\xfe\x01M\0\0\x01M\x01>\x01M\0\0\0\0\x01M\x016\x01M\x01E\0\0\x01E\0~\x01E\0\0\0\x86\x01E\0n\x01E\0\xbe\x01E\x01E\0\0\x01E\0\xe6\0\0\x01E\x01E\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\x01E\x01E\0\0\x01\x16\x01E\x01E\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\x01E\x01E\0\xc6\0\xca\0\0\0\0\0\xfe\x01E\0\0\x01E\x01>\x01E\0\0\0\0\x01E\x016\x01E\0\xb1\0\0\0\xb1\0~\0\xb1\0\0\0\x86\0\xb1\0n\0\xb1\0\xbe\0\xb1\0\xb1\0\0\0\xb1\0\xe6\0\0\0\xb1\0\xb1\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0\xb1\0\xb1\0\0\x01\x16\0\xb1\0\xb1\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\xb1\0\xb1\0\xc6\0\xca\0\0\0\0\0\xfe\0\xb1\0\0\0\xb1\x01>\0\xb1\0\0\0\0\0\xb1\x016\0\xb1\0Y\0\0\0Y\0Y\0Y\0\0\0Y\0Y\0n\0Y\0Y\0Y\0Y\0\0\0Y\0Y\0\0\0Y\0Y\0\x8e\0Y\0\0\0Y\0\0\0\0\0\0\0\0\0Y\0Y\0Y\0Y\0\0\0Y\0Y\0Y\0\0\0\0\0\0\0Y\0Y\0\0\0Y\0Y\0Y\0\xc6\0\xca\0\0\0\0\0Y\0Y\0\0\0Y\0Y\0Y\0\0\0\0\0Y\0Y\0Y\0\xa9\0\0\0\xa9\0~\0\xa9\0\0\0\x86\0\xa9\0n\0\xa9\0\xbe\0\xa9\0\xa9\0\0\0\xa9\0\xe6\0\0\0\xa9\0\xa9\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0\xa9\0\xa9\0\0\x01\x16\0\xa9\0\xa9\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\xa9\0\xa9\0\xc6\0\xca\0\0\0\0\0\xfe\0\xa9\0\0\0\xa9\x01>\0\xa9\0\0\0\0\0\xa9\x016\0\xa9\0\xad\0\0\0\xad\0~\0\xad\0\0\0\x86\0\xad\0n\0\xad\0\xbe\0\xad\0\xad\0\0\0\xad\0\xe6\0\0\0\xad\0\xad\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0\xad\0\xad\0\0\x01\x16\0\xad\0\xad\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\xad\0\xad\0\xc6\0\xca\0\0\0\0\0\xfe\0\xad\0\0\0\xad\x01>\0\xad\0\0\0\0\0\xad\x016\0\xad\0m\0\0\0m\0~\0m\0\0\0\x86\0m\0n\0m\0\xbe\0m\0m\0\0\0m\0\xe6\0\0\0m\0m\0\x8e\0m\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0m\0m\0\0\x01\x16\0m\0m\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0m\0m\0\xc6\0\xca\0\0\0\0\0\xfe\0m\0\0\0m\0m\0m\0\0\0\0\0m\x016\0m\0Q\0\0\0Q\0Q\0Q\0\0\0Q\0Q\0n\0Q\0Q\0Q\0Q\0\0\0Q\0Q\0\0\0Q\0Q\0\x8e\0Q\0\0\0Q\0\0\0\0\0\0\0\0\0Q\0Q\0Q\0Q\0\0\0Q\0Q\0Q\0\0\0\0\0\0\0Q\0Q\0\0\0Q\0Q\0Q\0\xc6\0\xca\0\0\0\0\0Q\0Q\0\0\0Q\0Q\0Q\0\0\0\0\0Q\0Q\0Q\0\xb5\0\0\0\xb5\0~\0\xb5\0\0\0\x86\0\xb5\0n\0\xb5\0\xbe\0\xb5\0\xb5\0\0\0\xb5\0\xe6\0\0\0\xb5\0\xb5\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\0\xb5\0\xb5\0\0\x01\x16\0\xb5\0\xb5\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\xb5\0\xb5\0\xc6\0\xca\0\0\0\0\0\xfe\0\xb5\0\0\0\xb5\x01>\0\xb5\0\0\0\0\0\xb5\x016\0\xb5\0U\0\0\0U\0U\0U\0\0\0\x86\0U\0n\0U\0\xbe\0U\0U\0\0\0U\0U\0\0\0U\0U\0\x8e\0U\0\0\0U\0\0\0\0\0\0\0\0\0U\0U\0U\0U\0\0\0U\0U\0U\0\0\0\0\0\0\0U\0U\0\0\0U\0U\0U\0\xc6\0\xca\0\0\0\0\0U\0U\0\0\0U\0U\0U\0\0\0\0\0U\0U\0U\0v\0\0\0\0\0~\x02\x1a\0\0\0\x86\x01\xf6\0n\0\xa2\0\xbe\x015\0\xde\0\0\x015\0\xe6\0\0\x01\xaa\x02J\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\x01\xc2\0\0\0\0\x01\x16\x01\xca\0\0\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\x02\xa6\x02"\0\xc6\0\xca\0\0\0\0\0\xfe\0\xd1\0\0\0\xd1\x01>\x015\x01e\0\0\x01\xde\x016\x015\0\x85\0\0\0\x85\0\0\0\x85\0\0\0\x86\0\x85\0n\0\x85\0\xbe\0\x85\0\x85\0\0\0\x85\0\xe6\0\0\0\x85\0\x85\0\x8e\0\x85\0\0\0\0\x01e\0\0\0\0\0\0\x01e\0\0\0\x85\0\x85\0\0\0\0\0\x85\0\x85\x01e\0\0\0\0\0\0\0\0\0\0\0\0\0\x85\0\x85\0\xc6\0\xca\0\0\0\0\0\xfe\0\x85\x02>\0\x85\0\x85\0\x85\0\0\0\0\0\x85\0\x85\0\x85\0e\0\0\0e\0\0\0e\0\0\0\x86\0e\0n\0e\0\xbe\0e\0e\0\0\0e\0\xe6\0\0\0e\0e\0\x8e\0e\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0e\0e\0\0\0\0\0e\0e\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0e\0e\0\xc6\0\xca\0\0\0\0\0\xfe\0e\0\0\0e\0e\0e\0\0\0\0\0e\0e\0e\0\x89\0\0\0\x89\0\0\0\x89\0\0\0\x86\0\x89\0n\0\x89\0\xbe\0\x89\0\x89\0\0\0\x89\0\xe6\0\0\0\x89\0\x89\0\x8e\0\x89\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x89\0\x89\0\0\0\0\0\x89\0\x89\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x89\0\x89\0\xc6\0\xca\0\0\0\0\0\xfe\0\x89\0\0\0\x89\0\x89\0\x89\0\0\0\0\0\x89\0\x89\0\x89\0}\0\0\0}\0\0\0}\0\0\0\x86\0}\0n\0}\0\xbe\0}\0}\0\0\0}\0\xe6\0\0\0}\0}\0\x8e\0}\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0}\0}\0\0\0\0\0}\0}\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0}\0}\0\xc6\0\xca\0\0\0\0\0\xfe\0}\0\0\0}\0}\0}\0\0\0\0\0}\0}\0}\0y\0\0\0y\0\0\0y\0\0\0\x86\0y\0n\0y\0\xbe\0y\0y\0\0\0y\0\xe6\0\0\0y\0y\0\x8e\0y\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0y\0y\0\0\0\0\0y\0y\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0y\0y\0\xc6\0\xca\0\0\0\0\0\xfe\0y\0\0\0y\0y\0y\0\0\0\0\0y\0y\0y\0u\0\0\0u\0\0\0u\0\0\0\x86\0u\0n\0u\0\xbe\0u\0u\0\0\0u\0\xe6\0\0\0u\0u\0\x8e\0u\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0u\0u\0\0\0\0\0u\0u\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0u\0u\0\xc6\0\xca\0\0\0\0\0\xfe\0u\0\0\0u\0u\0u\0\0\0\0\0u\0u\0u\0q\0\0\0q\0\0\0q\0\0\0\x86\0q\0n\0q\0\xbe\0q\0q\0\0\0q\0\xe6\0\0\0q\0q\0\x8e\0q\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0q\0q\0\0\0\0\0q\0q\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0q\0q\0\xc6\0\xca\0\0\0\0\0\xfe\0q\0\0\0q\0q\0q\0\0\0\0\0q\0q\0q\0\x81\0\0\0\x81\0\0\0\x81\0\0\0\x86\0\x81\0n\0\x81\0\xbe\0\x81\0\x81\0\0\0\x81\0\xe6\0\0\0\x81\0\x81\0\x8e\0\x81\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x81\0\x81\0\0\0\0\0\x81\0\x81\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x81\0\x81\0\xc6\0\xca\0\0\0\0\0\xfe\0\x81\0\0\0\x81\0\x81\0\x81\0\0\0\0\0\x81\0\x81\0\x81\0v\0\0\0\0\0~\0\0\0\0\0\x86\0\xda\0n\0\xa2\0\xbe\0\0\0\xde\0\0\0\0\0\xe6\0\0\x01\xaa\x01\x85\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\x01\xc2\0\0\0\0\x01\x16\x01\xca\0\0\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\x02\xb2\0\0\0\xc6\0\xca\0\0\0\0\0\xfe\0\0\0\0\x01\xee\x01>\0\0\0\0\0\0\x01\xde\x016\0v\0\0\0\x1d\0~\0\0\0\0\0\x86\0\0\0n\0\xa2\0\xbe\0\0\0\xde\0\0\0\0\0\xe6\0\0\x01\xaa\0\0\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\x01\xc2\0\x1d\0\0\x01\x16\x01\xca\0\x1d\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\0\x1d\0\0\0\xc6\0\xca\0\0\0\0\0\xfe\0\0\0\0\0\0\x01>\0\0\0\0\0v\x01\xde\0\x1d\0~\0\0\0\0\0\x86\x01]\0n\0\xa2\0\xbe\0\0\0\xde\0\0\0\0\0\xe6\0\0\x01\xaa\0\0\0\x8e\0\xee\0\0\0\xf6\0\0\0\0\0\0\0\0\x01\x06\x01\x0e\x01\xc2\0\0\0\0\x01\x16\x01\xca\0\0\0\0\0\0\0\0\x01\x1e\x01&\0\0\x01.\x02\x96\0\0\0\xc6\0\xca\0\0\0\0\0\xfe\0\0\0\0\x02j\x01>\0\x06\0\0\0\n\x01\xde\x016\0\0\0\x0e\0!\x01Y\0\x12\0\0\0\0\x011\0\0\0\x16\x011\0\0\0\0\0\0\x01)\0\x1a\0\0\0\x1e\0\0\0"\0&\0*\0.\0\0\0\0\0\0\x002\0J\0\0\0\0\0!\0N\x006\0:\0!\0\0\0R\0\0\0\0\0\0\0\0\x022\0!\0>\0\0\0\0\0V\0\0\x02N\x011\0b\x03\x1b\0v\x03\x1f\x011\0~\0\0\0!\0\x86\0\0\0n\0\xa2\0\xbe\0\0\0\xde\x03#\0\0\0\xe6\0\0\x01\xaa\0\0\0\x8e\0\xee\0\0\0\xf6\x03\'\x03+\x03/\x033\x01\x06\x01\x0e\x01\xc2\0\0\0\0\x01\x16\x01\xca\0\0\0\0\x037\x03;\x01\x1e\x01&\0\0\x01.\x03\x0f\0\0\0\xc6\0\xca\0\0\x03?\0\xfe\0\x06\0\0\0\n\x01>\0\0\0\0\x01B\x01\xde\x016\x01F\0\0\0\0\0\0\0\0\0\x16\0\0\0\0\0\0\0\0\0\x06\x01J\0\n\x01N\0\0\0"\0&\0*\0.\0\xd2\0\0\0\0\0\0\x01R\0\x16\0\0\0\0\x01\xc1\x006\0:\0\0\0\0\x01\x96\0\0\0"\0&\0*\0.\0\0\0>\0\0\x01f\x01V\x01\x8e\0\0\0\0\0\0\x006\0:\0\0\0\0\0\0\0\0\0\0\0\0\x01\xc1\0\0\0\0\0>\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\xc1\0\0\0\0\0\0\0\0\0\0\0\0\0\xdd\0\0\0\xdd\x01\x9a\0\0\0\0\0\0\0\0\x01\xc1',
		                         i$0);
		               }
		               function goto(i, j){
		                var
		                 k =
		                   decode$5
		                    (get16
		                      ('\0#\0\0\0\0\0\0\0\b\0\0\0^\0\0\0\0\0\0\0\0\0\0\0"\0\0\0\0\0\0\0\0\0\x9e\0\0\0\x8a\0\0\0.\0\0\0\xc2\0\xe4\0\0\0\x80\0N\0\x80\0\xdc\0\x80\0\xf2\0\x80\0v\0\x80\0\r\0\0\0\0\0\0\0\x80\0h\0\0\0\0\0\0\0\0\0\xf0\0\x80\0\xb2\0\x80\0\0\0\0\0r\0\x98\0\x80\0\0\0f\0\x80\0\xac\0\x80\0\xa4\0\x80\0\xca\0\x80\0\x86\0\x80\0\x92\0\x80\0J\0\x80\0P\0\x80\0\xf8\0\x80\0\xc4\0\x80\0\xd6\0\x80\0\xec\0\x80\0\xf4\0\0\0\xe2\0\xe8\0\0\0\0\0B\0\0\x01\0\0\0\0\xa0\0\0\0\0\0\0\0\0\0\0\0\0\0\xa2\0\0\0\0\0\0\0\0\0\0\0\x9a\0\0\0\0\0\0\0:\x01\x04\0\x80\0\xb0\0\x80\0\0\0B\0\x80\x000\0\0\0\xfe\0\x80\0\x80\0\0\0\0\0\0\0\0\x004\0\0\0\0\0\x80\0\0\0\0\0\0\0\0\0\x84\0\0\0\x80\0\xd0\0\x80\0d\0\x80\0\x80\0\0\0\xbe\0\x80\0\0\0.\0\0\0\x80\0\0\0\0\0\0\0t\0\0\0\0\0\0\0\x80\0\t\0\0\x005\0\x07\0\0\0\0\0$\0\0\0\0\0z\0\x80\0\0\0\0\0`\0\x80\0\0\0\xaa\0\x80\0\0\0\0\0\0\0\0\0\0\0\x0e\0V\0\0\0 \0\0\0\0\0\xb8\0\0\0\0\0\x13\0\0\0\0\0\0\0\0\0~\0\0\0+\0\x80\0\0\0\0\0\x10\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0',
		                       i)),
		                 i$0 = k + j | 0;
		                return caml_string_unsafe_get
		                        ("\x9d\x1a%\xbc\x9f\x1a\xc3\xc5\xae\x9cw\xa0&\x8c\xaf\xb1\x1a\x98\x1a{\xb4(\xa3\x9a\x8f\xa2\x1a\xb6\xbd\x11\xd1\x9a\xa0\x80}\x91\xbf\xc0\xb7\x8c{t]\x81p\x8c\x1a\xb4\x1a\x83\x8fw^(\xba\x1a\x8f`,\x1ar\x1a\x1a\x97E\xb7\x1dG-\x1a\x1az\x1a\x1a\x92\xa9\x85\x8a9{\\\x1ah\x1a\xc1[#4\xa5\x1ab\x1a\x83\xc0A\x1a\x86\xb9\x1a\\C\x1a\\6\x1a`\x8b\x1a\x1a=\x1a\x1a\xac;\\o1\x1ae\x1a\x1ac\x8e\x1a\x7fK\x1aj?\x1a\0\x88\x1aYM\\\x1a\x1f\\\0\x1a\x1b\x1a\x1a\\O\x1a/!\x1a\\I\x1a\0v\0\0m",
		                         i$0);
		               }
		               function goto_nt(state, nt){
		                var code = goto(state, nt);
		                return code - 1 | 0;
		               }
		               function goto_prod(state, prod){
		                return goto_nt
		                        (state,
		                         caml_string_unsafe_get
		                          ('\x03\x02\x01\0"""!! \x1f\x1e\x1e\x1d\x1c\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1b\x1a\x1a\x19\x18\x17\x17\x16\x16\x16\x16\x16\x16\x16\x16\x16\x16\x15\x15\x14\x14\x13\x13\x12\x12\x11\x11\x10\x10\x0f\x0f\x0f\x0f\x0e\x0e\r\r\r\f\f\v\v\n\n\t\t\b\b\x07\x07\x06\x06\x05\x05\x05\x05\x05\x05\x05\x05\x05\x04',
		                           prod));
		               }
		               function semantic_action(prod){
		                var a = prod - 4 | 0;
		                return caml_check_bound(semantic_action$0, a)[a + 1];
		               }
		               function run$2(env, please_discard){
		                return please_discard
		                        ? [0, env]
		                        : check_for_default_reduction(env);
		               }
		               function check_for_default_reduction(env){
		                var
		                 state = env[4],
		                 code =
		                   caml_string_unsafe_get
		                    ("\0DC\x14\0B\0&@A=<\0;?>\0\0\x10\0\x11\0\0\0\0%\0\0\0\0\0\0\0\0\0\0L\0(\0\0gfP\0\0\0\0\0:9\0\0\0V\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0n\0\0li\0\0\0\0\0\0hJ\0m\0\0a\0p\0j\0\0k\0\0\0\0\0\0/\0\0\0\0\0\0\0\x000'U\0c*\0H\0)\0\0_\0\0\0\0\0\0\0\0\0\0\0[\0$\0\0\0\0\0\x13\0\0Y\0\x007\0\0e\0\0\0\x07\0\0\0\x06\0\0\x05\v\0\n\x01\0\0\0\0]\0\0\0\r\0\f\0\x0e\x02\0F\0\0\x0f\x03\0DCB@A=<;?>\x04",
		                     state);
		                if(0 !== code){
		                 var prod = code - 1 | 0;
		                 return announce_reduce(env, prod);
		                }
		                if(env[1]) return [3, env];
		                var
		                 token = env[2][1],
		                 value = token2value(token),
		                 terminal = token2terminal(token),
		                 state$0 = env[4],
		                 c = error$2(state$0, terminal);
		                if(1 !== c){
		                 var env$0 = [0, 1, env[2], env[3], env[4]];
		                 return [3, env$0];
		                }
		                var
		                 action$0 = action(state$0, terminal),
		                 opcode = action$0 & 3,
		                 param = action$0 >>> 2 | 0;
		                if(2 > opcode) return announce_reduce(env, param);
		                var please_discard = 2 === opcode ? 1 : 0;
		                return shift(env, please_discard, terminal, value, param);
		               }
		               function shift(env, please_discard, terminal, value, s){
		                var
		                 match = env[2],
		                 endp = match[3],
		                 startp = match[2],
		                 stack = [0, env[4], value, startp, endp, env[3]],
		                 new_env = [0, env[1], env[2], stack, s];
		                return [1, env, new_env, please_discard];
		               }
		               function announce_reduce(env, prod){
		                if(prod >= 4) return [2, env, prod];
		                var v = env[3][2];
		                return [4, v];
		               }
		               function reduce$0(env, prod, cont){
		                return caml_exact_trampoline_cps_call
		                        (semantic_action(prod),
		                         env,
		                         function(stack){
		                          var
		                           current = goto_prod(stack[1], prod),
		                           env$0 = [0, env[1], env[2], stack, current];
		                          return cont(run$2(env$0, 0));
		                         });
		               }
		               var error_value = 0;
		               function start$1(s, initial){
		                var empty = [];
		                caml_update_dummy
		                 (empty, [0, s, error_value, initial, initial, empty]);
		                var env = [0, 0, [0, 0, initial, initial], empty, s];
		                return run$2(env, 1);
		               }
		               function offer(param, cont){
		                if(typeof param !== "number" && 0 === param[0]){
		                 var env = param[1];
		                 return cont
		                         (function(triple){
		                           var env$0 = [0, 0, triple, env[3], env[4]];
		                           return check_for_default_reduction(env$0);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (invalid_arg, "offer expects InputNeeded", cont);
		               }
		               function expression(initial_position){
		                return start$1(193, initial_position);
		               }
		               function command(initial_position){
		                return start$1(0, initial_position);
		               }
		               function read(lexbuf, cont){
		                function a(){
		                 function b(ocaml_lex_state){
		                  var
		                   ocaml_lex_state$0 =
		                     engine(ocaml_lex_tables, ocaml_lex_state, lexbuf);
		                  if(69 < ocaml_lex_state$0 >>> 0)
		                   return caml_trampoline_cps_call2
		                           (lexbuf[1],
		                            lexbuf,
		                            function(a){
		                             return caml_exact_trampoline_call1(b, ocaml_lex_state$0);
		                            });
		                  var e = ocaml_lex_state$0;
		                  if(37 <= e)
		                   switch(e){
		                     case 39:
		                      return cont(51);
		                     case 40:
		                      return cont(49);
		                     case 41:
		                      return cont(48);
		                     case 42:
		                      return cont(47);
		                     case 43:
		                      return cont(46);
		                     case 44:
		                      return cont(45);
		                     case 45:
		                      return cont(41);
		                     case 46:
		                      return cont(42);
		                     case 47:
		                      return cont(38);
		                     case 48:
		                      return cont(37);
		                     case 49:
		                      return cont(36);
		                     case 50:
		                      return cont(28);
		                     case 51:
		                      return cont(27);
		                     case 52:
		                      return cont(22);
		                     case 53:
		                      return cont(19);
		                     case 54:
		                      return cont(18);
		                     case 55:
		                      return cont(16);
		                     case 56:
		                      return cont(15);
		                     case 57:
		                      return cont(10);
		                     case 58:
		                      return cont(8);
		                     case 59:
		                      return cont(7);
		                     case 60:
		                      return cont(6);
		                     case 61:
		                      return cont(4);
		                     case 62:
		                      return caml_exact_trampoline_cps_call
		                              (lexeme,
		                               lexbuf,
		                               function(a){return cont([1, caml_int64_of_string(a)]);});
		                     case 63:
		                      return caml_exact_trampoline_cps_call
		                              (lexeme,
		                               lexbuf,
		                               function(a){
		                                return caml_exact_trampoline_cps_call
		(of_string$6, a, function(a){return cont([3, a]);});
		                               });
		                     case 64:
		                      var
		                       buffer = create$1(64),
		                       c =
		                         function(b){
		                          function a(ocaml_lex_state){
		                           var
		                            ocaml_lex_state$0 =
		                              engine(ocaml_lex_tables, ocaml_lex_state, lexbuf);
		                           if(3 < ocaml_lex_state$0 >>> 0)
		                            return caml_trampoline_cps_call2
		                                    (lexbuf[1],
		                                     lexbuf,
		                                     function(b){
		                                      return caml_exact_trampoline_call1(a, ocaml_lex_state$0);
		                                     });
		                           switch(ocaml_lex_state$0){
		                             case 0:
		                              return caml_exact_trampoline_cps_call
		                                      (contents, buffer, function(a){return cont([0, a]);});
		                             case 1:
		                              return caml_exact_trampoline_cps_call$1
		                                      (add_char, buffer, 10, c);
		                             case 2:
		                              var c$0 = sub_lexeme_char(lexbuf, lexbuf[5] + 1 | 0);
		                              return caml_exact_trampoline_cps_call$1
		                                      (add_char, buffer, c$0, c);
		                             default:
		                              return caml_exact_trampoline_cps_call$1
		                                      (add_char, buffer, lexeme_char(lexbuf, 0), c);
		                           }
		                          }
		                          return a(149);
		                         };
		                      return c(0);
		                     case 65:
		                      var
		                       buffer$0 = create$1(32),
		                       d =
		                         function(b){
		                          function a(ocaml_lex_state){
		                           var
		                            ocaml_lex_state$0 =
		                              engine(ocaml_lex_tables, ocaml_lex_state, lexbuf);
		                           if(2 < ocaml_lex_state$0 >>> 0)
		                            return caml_trampoline_cps_call2
		                                    (lexbuf[1],
		                                     lexbuf,
		                                     function(b){
		                                      return caml_exact_trampoline_call1(a, ocaml_lex_state$0);
		                                     });
		                           switch(ocaml_lex_state$0){
		                             case 0:
		                              return caml_exact_trampoline_cps_call
		                                      (contents, buffer$0, function(a){return cont([2, a]);});
		                             case 1:
		                              var c = sub_lexeme_char(lexbuf, lexbuf[5] + 1 | 0);
		                              return caml_exact_trampoline_cps_call$1
		                                      (add_char, buffer$0, c, d);
		                             default:
		                              return caml_exact_trampoline_cps_call$1
		                                      (add_char, buffer$0, lexeme_char(lexbuf, 0), d);
		                           }
		                          }
		                          return a(144);
		                         };
		                      return d(0);
		                     case 66:
		                      return caml_exact_trampoline_cps_call
		                              (lexeme, lexbuf, function(a){return cont([2, a]);});
		                     case 69:
		                      return cont(39);
		                     case 37:
		                     case 38:
		                      return cont(0);
		                     default: return caml_exact_trampoline_call0(a);
		                   }
		                  switch(e){
		                    case 0:
		                     return cont(53);
		                    case 1:
		                     return cont(55);
		                    case 2:
		                     return cont(54);
		                    case 3:
		                     return cont(50);
		                    case 4:
		                     return cont(40);
		                    case 5:
		                     return cont(34);
		                    case 6:
		                     return cont(33);
		                    case 7:
		                     return cont(31);
		                    case 8:
		                     return cont(32);
		                    case 9:
		                     return cont(29);
		                    case 10:
		                     return cont(30);
		                    case 11:
		                     return cont(26);
		                    case 12:
		                     return cont(25);
		                    case 13:
		                     return cont(21);
		                    case 14:
		                     return cont(20);
		                    case 15:
		                     return cont(17);
		                    case 16:
		                     return cont(14);
		                    case 17:
		                     return cont(12);
		                    case 18:
		                     return cont(11);
		                    case 19:
		                     return cont(5);
		                    case 20:
		                     return cont(3);
		                    case 21:
		                     return cont(1);
		                    case 22:
		                     return cont(9);
		                    case 23:
		                     return cont(52);
		                    case 24:
		                     return cont(43);
		                    case 25:
		                    case 26:
		                     return cont(44);
		                    case 27:
		                    case 28:
		                     return cont(35);
		                    case 29:
		                    case 30:
		                     return cont(24);
		                    case 31:
		                    case 32:
		                     return cont(23);
		                    case 33:
		                    case 34:
		                     return cont(13);
		                    default: return cont(2);
		                  }
		                 }
		                 return b(0);
		                }
		                return a();
		               }
		               function pp_token$0(f, cont){
		                return cont
		                        (function(param, cont){
		                          if(typeof param === "number")
		                           switch(param){
		                             case 0:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_year, cont);
		                             case 1:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_where, cont);
		                             case 2:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_week, cont);
		                             case 3:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_type, cont);
		                             case 4:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst$53, cont);
		                             case 5:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_then, cont);
		                             case 6:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 42, cont);
		                             case 7:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 93, cont);
		                             case 8:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 91, cont);
		                             case 9:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_sort, cont);
		                             case 10:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 47, cont);
		                             case 11:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_set, cont);
		                             case 12:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_select, cont);
		                             case 13:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_second, cont);
		                             case 14:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_remove, cont);
		                             case 15:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 43, cont);
		                             case 16:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 124, cont);
		                             case 17:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_pick, cont);
		                             case 18:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 41, cont);
		                             case 19:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 40, cont);
		                             case 20:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_or, cont);
		                             case 21:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_null, cont);
		                             case 22:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst$28, cont);
		                             case 23:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_month, cont);
		                             case 24:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_minute, cont);
		                             case 25:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_Min, cont);
		                             case 26:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_max, cont);
		                             case 27:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst$27, cont);
		                             case 28:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 60, cont);
		                             case 29:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_limit, cont);
		                             case 30:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_let, cont);
		                             case 31:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_inside, cont);
		                             case 32:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_index, cont);
		                             case 33:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_in, cont);
		                             case 34:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_if, cont);
		                             case 35:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_hour, cont);
		                             case 36:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst$26, cont);
		                             case 37:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 62, cont);
		                             case 38:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 61, cont);
		                             case 39:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_end_of_input, cont);
		                             case 40:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_else, cont);
		                             case 41:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, ".?", cont);
		                             case 42:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 46, cont);
		                             case 43:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_desc, cont);
		                             case 44:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_day, cont);
		                             case 45:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 45, cont);
		                             case 46:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 125, cont);
		                             case 47:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 123, cont);
		                             case 48:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 44, cont);
		                             case 49:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 58, cont);
		                             case 50:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_by, cont);
		                             case 51:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char, f, 33, cont);
		                             case 52:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_asc, cont);
		                             case 53:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_as, cont);
		                             case 54:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_and, cont);
		                             default:
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, f, cst_add, cont);
		                           }
		                          switch(param[0]){
		                            case 0:
		                             var s = param[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (string$1, f, s, cont);
		                            case 1:
		                             var i = param[1];
		                             return caml_exact_trampoline_cps_call$1(int64$0, f, i, cont);
		                            case 2:
		                             var i$0 = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(f),
		                                      Jo,
		                                      function(a){return caml_trampoline_cps_call2(a, i$0, cont);});
		                            default:
		                             var i$1 = param[1];
		                             return caml_exact_trampoline_cps_call$1(float, f, i$1, cont);
		                          }
		                         });
		               }
		               function parse$0(parser, s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (from_string,
		                         0,
		                         s,
		                         function(buf){
		                          var start = parser(buf[12]);
		                          function parse(last){
		                           function fail(kind, fmt, cont){
		                            var location = of_lexing$0(buf[11], buf[12]);
		                            function f(message, cont){
		                             var x = [0, kind, location, message];
		                             return cont([1, x]);
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf, f, fmt, cont);
		                           }
		                           return function(checkpoint, cont){
		                            if(typeof checkpoint === "number")
		                             return caml_exact_trampoline_cps_call$1(fail, 1, Jp, cont);
		                            switch(checkpoint[0]){
		                              case 0:
		                               caml_push_trap
		                                (function(exn){
		                                  return caml_exact_trampoline_cps_call$1(fail, 0, Jq, cont);
		                                 });
		                               return caml_exact_trampoline_cps_call
		                                       (read,
		buf,
		function(token){
		 caml_pop_trap();
		 var a = [0, token, buf[11], buf[12]];
		 return caml_exact_trampoline_cps_call
		         (offer,
		          checkpoint,
		          function(b){
		           b = b(a);
		           return caml_exact_trampoline_cps_call
		                   (parse([0, token]), b, cont);
		          });
		});
		                              case 3:
		                               if(! last)
		                                return caml_exact_trampoline_cps_call$1(fail, 1, Js, cont);
		                               var token = last[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (fail,
		1,
		Jr,
		function(a){
		 return caml_trampoline_cps_call3(a, pp_token$0, token, cont);
		});
		                              case 4:
		                               var ast = checkpoint[1];
		                               return caml_trampoline_cps_call2(of_string$14, ast, cont);
		                              default:
		                               var
		                                a =
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call(parse(last), a, cont);
		                                  };
		                               if(typeof checkpoint !== "number")
		                                switch(checkpoint[0]){
		                                  case 1:
		                                   var please_discard = checkpoint[3], env = checkpoint[2];
		                                   return a(run$2(env, please_discard));
		                                  case 2:
		                                   var prod = checkpoint[2], env$0 = checkpoint[1];
		                                   return caml_exact_trampoline_cps_call$1
		   (reduce$0, env$0, prod, a);
		                                  case 3:
		                                   var
		                                    env$1 = checkpoint[1],
		                                    state = env$1[4],
		                                    error_terminal = 0,
		                                    c = error$2(state, error_terminal),
		                                    strategy = -822677911;
		                                   if(1 === c){
		                                    var
		                                     action$0 = action(state, error_terminal),
		                                     opcode = action$0 & 3,
		                                     prod$0 = action$0 >>> 2 | 0;
		                                    if(2 > opcode)
		                                     return -798940232 <= strategy
		     ? a(announce_reduce(env$1, prod$0))
		     : caml_exact_trampoline_cps_call$1
		       (reduce$0, env$1, prod$0, a);
		                                    var
		                                     please_discard$0 = 2 === opcode ? 1 : 0,
		                                     please_discard$1 =
		                                       -798940232 <= strategy ? 0 : please_discard$0;
		                                    return a
		    (shift
		      (env$1,
		       please_discard$1,
		       error_terminal,
		       error_value,
		       prod$0));
		                                   }
		                                   if(-798940232 <= strategy) return a(0);
		                                   var cell = env$1[3], next = cell[5];
		                                   if(next === cell) return a(0);
		                                   var env$2 = [0, env$1[1], env$1[2], next, cell[1]];
		                                   return a([3, env$2]);
		                                }
		                               return caml_exact_trampoline_cps_call
		                                       (invalid_arg,
		"resume expects HandlingError | Shifting | AboutToReduce",
		a);
		                            }};
		                          }
		                          return caml_exact_trampoline_cps_call(parse(0), start, cont);
		                         });
		               }
		               var cst_fixme = "fixme";
		               function Make$11(M, cont){
		                function arr(f){return [0, f];}
		                function arr2(f){
		                 return [0,
		                         function(param, cont){
		                          var y = param[2], x = param[1];
		                          return caml_trampoline_cps_call3(f, x, y, cont);
		                         }];
		                }
		                function monadic(f){
		                 return [1,
		                         function(x, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (f, x, function(a){return cont([0, a, 0]);});
		                         },
		                         calendar];
		                }
		                function const$(v){
		                 return [0, function(param, cont){return cont(v);}];
		                }
		                var
		                 id$0 = [0, function(a, cont){return cont(a);}],
		                 dup = [0, function(x, cont){return cont([0, x, x]);}],
		                 cons =
		                   [0,
		                    function(param, cont){
		                     var y = param[2], x = param[1];
		                     return cont([0, x, y]);
		                    }],
		                 flip =
		                   [0,
		                    function(param, cont){
		                     var y = param[2], x = param[1];
		                     return cont([0, y, x]);
		                    }];
		                function name$3(name, param, cont){
		                 if(0 === param[0]){var f = param[1]; return cont([0, f]);}
		                 var map = param[2], base = param[1];
		                 function base$0(x, cont){
		                  return caml_trampoline_cps_call2
		                          (base,
		                           x,
		                           function(res){M[18].call(null); return cont(res);});
		                 }
		                 return cont([1, base$0, map]);
		                }
		                function first(param){
		                 if(0 === param[0]){
		                  var
		                   f = param[1],
		                   f$0 =
		                     function(param, cont){
		                      var y = param[2], x = param[1];
		                      return caml_trampoline_cps_call2
		                              (f, x, function(a){return cont([0, a, y]);});
		                     };
		                  return [0, f$0];
		                 }
		                 var map = param[2], base = param[1];
		                 function map$0(param, cont){
		                  var
		                   match = param[2],
		                   y = match[2],
		                   x = match[1],
		                   x$0 = param[1];
		                  return caml_trampoline_cps_call2
		                          (map, [0, x$0, x], function(a){return cont([0, a, y]);});
		                 }
		                 function base$0(param, cont){
		                  var y = param[2], x = param[1];
		                  return caml_trampoline_cps_call2
		                          (base,
		                           x,
		                           function(match){
		                            var x = match[2], x$0 = match[1];
		                            return cont([0, x$0, [0, x, y]]);
		                           });
		                 }
		                 return [1, base$0, map$0];
		                }
		                function second(param){
		                 if(0 === param[0]){
		                  var
		                   f = param[1],
		                   f$0 =
		                     function(param, cont){
		                      var y = param[2], x = param[1];
		                      return caml_trampoline_cps_call2
		                              (f, y, function(a){return cont([0, x, a]);});
		                     };
		                  return [0, f$0];
		                 }
		                 var map = param[2], base = param[1];
		                 function map$0(param, cont){
		                  var
		                   match = param[2],
		                   x = match[2],
		                   y = match[1],
		                   y$0 = param[1];
		                  return caml_trampoline_cps_call2
		                          (map, [0, y$0, y], function(a){return cont([0, x, a]);});
		                 }
		                 function base$0(param, cont){
		                  var y = param[2], x = param[1];
		                  return caml_trampoline_cps_call2
		                          (base,
		                           y,
		                           function(match){
		                            var y = match[2], y$0 = match[1];
		                            return cont([0, y$0, [0, y, x]]);
		                           });
		                 }
		                 return [1, base$0, map$0];
		                }
		                function applyM(param, cont){
		                 if(0 === param[0]){
		                  var f = param[1];
		                  return cont
		                          (function(x, cont){
		                            return caml_trampoline_cps_call2
		                                    (f,
		                                     x,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(M[7], a, cont);
		                                     });
		                           });
		                 }
		                 var map = param[2], base = param[1];
		                 return cont
		                         (function(x, cont){
		                           return caml_trampoline_cps_call2
		                                   (base,
		                                    x,
		                                    function(match){
		                                     var extra = match[2], base = match[1];
		                                     return caml_trampoline_cps_call3
		     (M[8],
		      base,
		      function(x, cont){
		       return caml_trampoline_cps_call2(map, [0, x, extra], cont);
		      },
		      function(res){M[18].call(null, res); return cont(res);});
		                                    });
		                          });
		                }
		                function composeM(action, f, cont){
		                 if(0 !== f[0])
		                  return caml_exact_trampoline_cps_call$1
		                          (name$3,
		                           dummy,
		                           monadic
		                            (function(x, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (applyM,
		                                       f,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (a,
		         x,
		         function(a){
		          return caml_trampoline_cps_call2(action, a, cont);
		         });
		                                       });
		                             }),
		                           cont);
		                 var f$0 = f[1];
		                 return cont([0, f$0]);
		                }
		                function compose$0(f1, f2, cont){
		                 if(0 === f1[0]){
		                  var f = f1[1];
		                  if(0 === f2[0]){
		                   var g$0 = f2[1];
		                   return cont
		                           ([0,
		                             function(a, cont){
		                              return caml_exact_trampoline_cps_call$0
		                                      (compose, f, g$0, a, cont);
		                             }]);
		                  }
		                  var
		                   map = f2[2],
		                   base = f2[1],
		                   map$0 =
		                     function(a, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (compose, f, map, a, cont);
		                     };
		                  return cont([1, base, map$0]);
		                 }
		                 var map$1 = f1[2], base$0 = f1[1];
		                 if(0 === f2[0]){
		                  var
		                   g$1 = f2[1],
		                   base$1 =
		                     function(a, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (compose, base$0, g$1, a, cont);
		                     };
		                  return cont([1, base$1, map$1]);
		                 }
		                 function map$2(a, cont){
		                  a = a[1];
		                  var extra = a[2], res = a[1];
		                  return caml_trampoline_cps_call2
		                          (map$1, [0, res, extra], cont);
		                 }
		                 function base$2(x, cont){
		                  var
		                   open = g([0, M[3], M[4], , M[6], M[7], M[8], , , , , M[13]]),
		                   let$ = open[4],
		                   let$0 = open[3];
		                  function a(g_res, cont){
		                   return caml_trampoline_cps_call2
		                           (base$0,
		                            g_res,
		                            function(match){
		                             var extra = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      res,
		                                      function(res, cont){return cont([0, res, extra]);},
		                                      cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (applyM,
		                           f2,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (b,
		                                     x,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (let$0, b, a, function(a){return cont([0, a, 0]);});
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (name$3, dummy, [1, base$2, map$2], cont);
		                }
		                function choice(if$, then, else$, cont){
		                 if(0 === if$[0]){
		                  var if$0 = if$[1];
		                  if(0 === then[0]){
		                   var then$0 = then[1];
		                   if(0 === else$[0]){
		                    var
		                     else$0 = else$[1],
		                     f =
		                       function(x, cont){
		                        return caml_trampoline_cps_call2
		                                (if$0,
		                                 x,
		                                 function(match){
		                                  if(0 === match[0]){
		                                   var y = match[1];
		                                   return caml_trampoline_cps_call2(then$0, y, cont);
		                                  }
		                                  var y$0 = match[1];
		                                  return caml_trampoline_cps_call2(else$0, y$0, cont);
		                                 });
		                       };
		                    return cont([0, f]);
		                   }
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (name$3,
		                           dummy,
		                           monadic
		                            (function(x, cont){
		                              return caml_trampoline_cps_call2
		                                      (if$0,
		                                       x,
		                                       function(match){
		if(0 === match[0]){
		 var y = match[1];
		 return caml_exact_trampoline_cps_call
		         (applyM,
		          then,
		          function(a){
		           return caml_exact_trampoline_cps_call(a, y, cont);
		          });
		}
		var y$0 = match[1];
		return caml_exact_trampoline_cps_call
		        (applyM,
		         else$,
		         function(a){
		          return caml_exact_trampoline_cps_call(a, y$0, cont);
		         });
		                                       });
		                             }),
		                           cont);
		                 }
		                 var map = if$[2], base = if$[1];
		                 if(0 === then[0]){
		                  var then$1 = then[1];
		                  if(0 === else$[0]){
		                   var
		                    else$1 = else$[1],
		                    map$0 =
		                      function(x, cont){
		                       var match = map();
		                       if(0 === match[0]){
		                        var y = match[1];
		                        return caml_trampoline_cps_call2(then$1, y, cont);
		                       }
		                       var y$0 = match[1];
		                       return caml_trampoline_cps_call2(else$1, y$0, cont);
		                      };
		                   return cont([1, base, map$0]);
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (name$3,
		                          dummy,
		                          monadic
		                           (function(x, cont){
		                             function a(cond, cont){
		                              if(0 === cond[0]){
		                               var y = cond[1];
		                               return caml_exact_trampoline_cps_call
		                                       (applyM,
		then,
		function(a){
		 return caml_exact_trampoline_cps_call(a, y, cont);
		});
		                              }
		                              var y$0 = cond[1];
		                              return caml_exact_trampoline_cps_call
		                                      (applyM,
		                                       else$,
		                                       function(a){
		return caml_exact_trampoline_cps_call(a, y$0, cont);
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (applyM,
		                                      if$,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (b,
		        x,
		        function(b){
		         return caml_trampoline_cps_call3(M[6], b, a, cont);
		        });
		                                      });
		                            }),
		                          cont);
		                }
		                function symbol(a, b, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (compose$0, b, a, cont);
		                }
		                function symbol$0(a, b, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (compose$0, a, b, cont);
		                }
		                function pair$0(f1, f2, cont){
		                 function c(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (name$3, dummy, a, cont);
		                 }
		                 if(0 !== f1[0] && 0 !== f2[0])
		                  return caml_exact_trampoline_cps_call$1
		                          (name$3,
		                           dummy,
		                           monadic
		                            (function(param, cont){
		                              var y = param[2], x = param[1];
		                              function a(x, y){return [0, x, y];}
		                              return caml_exact_trampoline_cps_call
		                                      (applyM,
		                                       f2,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (b,
		         y,
		         function(b){
		          return caml_exact_trampoline_cps_call
		                  (applyM,
		                   f1,
		                   function(c){
		                    return caml_exact_trampoline_cps_call
		                            (c, x, function(c){return cont(M[15].call(null, c, b, a));});
		                   });
		         });
		                                       });
		                             }),
		                           c);
		                 if(0 === f2[0]){
		                  var b = first(f1), a = second(f2);
		                  return caml_exact_trampoline_cps_call$1(compose$0, b, a, c);
		                 }
		                 var b$0 = second(f2), a$0 = first(f1);
		                 return caml_exact_trampoline_cps_call$1
		                         (compose$0, b$0, a$0, c);
		                }
		                function triple(f1, f2, f3, cont){
		                 function a(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (name$3, dummy, a, cont);
		                 }
		                 if(0 === f1[0] && 0 === f2[0] && 0 === f3[0]){
		                  var
		                   f =
		                     function(param, cont){
		                      var
		                       match = param[2],
		                       c = match[2],
		                       b = match[1],
		                       a = param[1];
		                      return cont([0, a, b, c]);
		                     },
		                   b = [0, f];
		                  return caml_exact_trampoline_cps_call$1
		                          (pair$0,
		                           f2,
		                           f3,
		                           function(c){
		                            return caml_exact_trampoline_cps_call$1
		                                    (pair$0,
		                                     f1,
		                                     c,
		                                     function(b$0){
		                                      function f(param, cont){
		                                       var c = param[3], b = param[2], a = param[1];
		                                       return cont([0, a, [0, b, c]]);
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (compose$0,
		       b$0,
		       [0, f],
		       function(a$0){
		        return caml_exact_trampoline_cps_call$1
		                (compose$0, b, a$0, a);
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (name$3,
		                          dummy,
		                          monadic
		                           (function(param, cont){
		                             var z = param[3], y = param[2], x = param[1];
		                             function a(x, y, z){return [0, x, y, z];}
		                             return caml_exact_trampoline_cps_call
		                                     (applyM,
		                                      f3,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (b,
		        z,
		        function(b){
		         return caml_exact_trampoline_cps_call
		                 (applyM,
		                  f2,
		                  function(c){
		                   return caml_exact_trampoline_cps_call
		                           (c,
		                            y,
		                            function(c){
		                             return caml_exact_trampoline_cps_call
		                                     (applyM,
		                                      f1,
		                                      function(d){
		                                       return caml_exact_trampoline_cps_call
		       (d,
		        x,
		        function(d){return cont(M[16].call(null, d, c, b, a));});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            }),
		                          a);
		                }
		                function map(f){
		                 if(0 === f[0]){
		                  var
		                   f$0 = f[1],
		                   f$1 =
		                     function(a, cont){
		                      return caml_trampoline_cps_call3(map$18, a, f$0, cont);
		                     };
		                  return [0, f$1];
		                 }
		                 var map = f[2], base = f[1];
		                 function base$0(x, cont){
		                  return caml_trampoline_cps_call2
		                          (base,
		                           x,
		                           function(match){
		                            var extra = match[2], res = match[1];
		                            return caml_trampoline_cps_call3
		                                    (M[8],
		                                     res,
		                                     function(r, cont){return cont([0, r, extra]);},
		                                     cont);
		                           });
		                 }
		                 function map$0(param, cont){
		                  var lst = param[1];
		                  return caml_trampoline_cps_call3(map$18, lst, map, cont);
		                 }
		                 function base$1(l, cont){
		                  return caml_trampoline_cps_call3
		                          (map$18,
		                           l,
		                           base$0,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (M[11], a, function(a){return cont([0, a, 0]);});
		                           });
		                 }
		                 return [1, base$1, map$0];
		                }
		                function filter_map(f){
		                 g([0, M[3], M[4], , M[6], M[7], M[8], , , , , M[13]]);
		                 if(0 !== f[0])
		                  return function(m, cont){
		                   return caml_exact_trampoline_cps_call
		                           (applyM,
		                            f,
		                            function(b){
		                             var a = M[6];
		                             return caml_exact_trampoline_cps_call$1
		                                     (M[20],
		                                      m,
		                                      function(c, cont){
		                                       return caml_trampoline_cps_call3(a, c, b, cont);
		                                      },
		                                      function(res){M[18].call(null, res); return cont(res);});
		                            });};
		                 var f$0 = f[1];
		                 return function(m, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (M[19],
		                           m,
		                           f$0,
		                           function(res){M[18].call(null, res); return cont(res);});};
		                }
		                function tee(arr1, arr2, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (pair$0,
		                          arr1,
		                          arr2,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (compose$0,
		                                    b,
		                                    dup,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (name$3, dummy, a, cont);
		                                    });
		                          });
		                }
		                function tee3(arr1, arr2, arr3, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (triple,
		                          arr1,
		                          arr2,
		                          arr3,
		                          function(b){
		                           function f(x, cont){return cont([0, x, x, x]);}
		                           return caml_exact_trampoline_cps_call$1
		                                   (compose$0,
		                                    b,
		                                    [0, f],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (name$3, dummy, a, cont);
		                                    });
		                          });
		                }
		                var
		                 Arr =
		                   [0,
		                    M,
		                    arr,
		                    arr2,
		                    monadic,
		                    const$,
		                    ,
		                    id$0,
		                    dup,
		                    cons,
		                    flip,
		                    first,
		                    second,
		                    applyM,
		                    compose$0,
		                    composeM,
		                    choice,
		                    ,
		                    [0, symbol, symbol$0],
		                    symbol,
		                    ,
		                    pair$0,
		                    map,
		                    filter_map,
		                    tee,
		                    tee3,
		                    name$3];
		                return caml_exact_trampoline_cps_call$1
		                        (init_mod,
		                         Hj,
		                         Hi,
		                         function(T){
		                          var List = Make$4();
		                          function pp(printer, opt, fmt, param, cont){
		                           function a(opt, param){
		                            var
		                             sep =
		                               opt ? opt[1] : function(a, param, cont){return cont();};
		                            if(! param) return cont(0);
		                            var hd = param[1];
		                            if(! param[2])
		                             return caml_trampoline_cps_call3(printer[1], fmt, hd, cont);
		                            var tl = param[2];
		                            return caml_trampoline_cps_call3
		                                    (printer[1],
		                                     fmt,
		                                     hd,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (sep,
		       fmt,
		       0,
		       function(b){
		        return caml_exact_trampoline_call2(a, [0, sep], tl);
		       });
		                                     });
		                           }
		                           return a(opt, param);
		                          }
		                          function length(l){
		                           var acc = 0, param = l;
		                           for(;;){
		                            if(! param) return acc;
		                            var tl = param[2], acc$0 = acc + 1 | 0;
		                            acc = acc$0;
		                            param = tl;
		                           }
		                          }
		                          function filter_mapi(l, f, cont){
		                           function map(i, param, cont){
		                            function a(i, param){
		                             if(! param) return cont(0);
		                             var tl = param[2], hd = param[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (f[1],
		                                      i,
		                                      hd,
		                                      function(match){
		                                       if(match){
		var value = match[1];
		return caml_exact_trampoline_cps_call$1
		        (map,
		         i + 1 | 0,
		         tl,
		         function(l){return cont([0, value, l]);});
		                                       }
		                                       var i$0 = i + 1 | 0;
		                                       return caml_exact_trampoline_call2(a, i$0, tl);
		                                      });
		                            }
		                            return a(i, param);
		                           }
		                           return caml_exact_trampoline_cps_call$1(map, 0, l, cont);
		                          }
		                          function mapi(l, f, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter_mapi,
		                                    l,
		                                    [0,
		                                     function(i, x, cont){
		                                      return caml_trampoline_cps_call3
		      (f[1], i, x, function(a){return cont([0, a]);});
		                                     }],
		                                    cont);
		                          }
		                          function iteri(l, f, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (mapi, l, f, function(a){return cont(0);});
		                          }
		                          function find_mapi(l, f, cont){
		                           function a(i, param){
		                            if(! param) return cont(0);
		                            var tl = param[2], hd = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (f[1],
		                                     i,
		                                     hd,
		                                     function(match){
		                                      if(match){var value = match[1]; return cont([0, value]);}
		                                      var i$0 = i + 1 | 0;
		                                      return caml_exact_trampoline_call2(a, i$0, tl);
		                                     });
		                           }
		                           return a(0, l);
		                          }
		                          function filter_map(l, f, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter_mapi,
		                                    l,
		                                    [0,
		                                     function(param, v, cont){return cont(f[1].call(null, v));}],
		                                    cont);
		                          }
		                          function find_map(l, f, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_mapi,
		                                    l,
		                                    [0,
		                                     function(param, v, cont){
		                                      return caml_exact_trampoline_cps_call(f[1], v, cont);
		                                     }],
		                                    cont);
		                          }
		                          function map(l, f, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter_map,
		                                    l,
		                                    [0, function(x){return [0, f[1].call(null, x)];}],
		                                    cont);
		                          }
		                          var
		                           Lambdas = Make$4(),
		                           Fields = [0, , pp, length, , , find_map, , , iteri, map];
		                          return caml_exact_trampoline_cps_call$0
		                                  (update_mod,
		                                   Hk,
		                                   T,
		                                   [0],
		                                   function(a){
		                                    var cst = " &";
		                                    function pp_depth(depth, f, t, cont){
		                                     function a(depth, t){
		                                      function pp(f, t, cont){
		                                       return caml_exact_trampoline_cps_call$0
		       (pp_depth, depth, f, t, cont);
		                                      }
		                                      if(typeof t === "number")
		                                       switch(t){
		 case 0:
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string, f, cst_bool, cont);
		 case 1:
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string, f, cst_int, cont);
		 case 2:
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string, f, cst_float, cont);
		 case 3:
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string, f, cst_json, cont);
		 case 4:
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string, f, cst$14, cont);
		 default:
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string, f, cst_null, cont);
		                                       }
		                                      switch(t[0]){
		case 0:
		 var value = t[2], type = t[1];
		 return caml_exact_trampoline_cps_call$1
		         (pp_value,
		          depth,
		          type,
		          function(a){
		           return caml_exact_trampoline_cps_call$1(a, f, value, cont);
		          });
		case 1:
		 var t$0 = t[1];
		 if(0 > depth)
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string, f, "<Fixpoint>", cont);
		 var depth$0 = depth - 1 | 0, b = caml_obj_tag(t$0);
		 if(250 === b)
		  return caml_exact_trampoline_call2(a, depth$0, t$0[1]);
		 if(246 !== b && 244 !== b)
		  return caml_exact_trampoline_call2(a, depth$0, t$0);
		 return caml_exact_trampoline_cps_call
		         (force_lazy_block,
		          t$0,
		          function(b){
		           return caml_exact_trampoline_call2(a, depth$0, b);
		          });
		case 2:
		 var lambdas = t[1];
		 return caml_trampoline_cps_call3
		         (Lambdas[2],
		          [0,
		           function(f, t, cont){
		            return caml_exact_trampoline_cps_call$0
		                    (pp_lambda, depth, f, t, cont);
		           }],
		          [0,
		           function(ppf, v, cont){
		            return caml_exact_trampoline_cps_call$1
		                    (pp_print_string,
		                     ppf,
		                     cst,
		                     function(a){return cont(pp_v1(ppf));});
		           }],
		          function(a){
		           return caml_exact_trampoline_cps_call$2
		                   (hvbox, 0, a, f, lambdas, cont);
		          });
		case 3:
		 var data = t[1];
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(f),
		          Hl,
		          function(a){
		           return caml_trampoline_cps_call3(a, pp, data, cont);
		          });
		case 4:
		 var key = t[4], data$0 = t[3];
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(f),
		          Hm,
		          function(a){
		           return caml_trampoline_cps_call5
		                   (a, pp, key, pp, data$0, cont);
		          });
		case 5:
		 var name = t[1]; break;
		case 6:
		 b = t[1];
		 var match = b[4];
		 if(! match){
		  var fields = b[3];
		  return caml_trampoline_cps_call3
		          (Fields[2],
		           [0,
		            function(f, t, cont){
		             return caml_exact_trampoline_cps_call$0
		                     (pp_field, depth, f, t, cont);
		            }],
		           [0, comma],
		           function(a){
		            return caml_exact_trampoline_cps_call
		                    (fprintf$0(f),
		                     Hn,
		                     function(b){
		                      return caml_trampoline_cps_call3(b, a, fields, cont);
		                     });
		           });
		 }
		 name = match[1];
		 break;
		case 7:
		 var name$0 = t[1];
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(f),
		          Ho,
		          function(a){
		           return caml_trampoline_cps_call2(a, name$0, cont);
		          });
		case 8:
		 b = t[1];
		 if(b)
		  switch(b[1]){
		    case 0:
		     return caml_exact_trampoline_cps_call$1
		             (pp_print_string, f, cst_email, cont);
		    case 1:
		     return caml_exact_trampoline_cps_call$1
		             (pp_print_string, f, cst_phone, cont);
		    default:
		     return caml_exact_trampoline_cps_call$1
		             (pp_print_string, f, cst_url, cont);
		  }
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, f, cst_string, cont);
		case 9:
		 var types = t[1];
		 return caml_trampoline_cps_call3
		         (List[2],
		          [0, pp],
		          [0, comma],
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(f),
		                    Hp,
		                    function(b){
		                     return caml_trampoline_cps_call3(b, a, types, cont);
		                    });
		          });
		case 10:
		 var cases = t[1][1];
		 return caml_exact_trampoline_cps_call$2
		         (hvbox,
		          0,
		          list
		           ([0,
		             function(ppf, v, cont){
		              return caml_exact_trampoline_cps_call$1
		                      (pp_print_string,
		                       ppf,
		                       " |",
		                       function(a){return cont(pp_v1(ppf));});
		             }],
		            function(f, param, cont){
		             var type = param[4];
		             return caml_exact_trampoline_cps_call$2
		                     (box$0, 0, pp, f, type, cont);
		            }),
		          f,
		          cases,
		          cont);
		default:
		 var repr = t[2];
		 return caml_exact_trampoline_cps_call$1(pp, f, repr, cont);
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, f, name, cont);
		                                     }
		                                     return a(depth, t);
		                                    }
		                                    function pp_lambda(depth, f, lambda, cont){
		                                     var
		                                      result = lambda[3],
		                                      parameters = lambda[2],
		                                      args = lambda[1];
		                                     return caml_trampoline_cps_call2
		     (result,
		      parameters,
		      function(b){
		       function a(a, b, cont){
		        return caml_exact_trampoline_cps_call$0
		                (pp_depth, depth, a, b, cont);
		       }
		       return caml_trampoline_cps_call2
		               (args,
		                parameters,
		                function(c){
		                 return caml_trampoline_cps_call3
		                         (List[2],
		                          [0,
		                           function(f, t, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (pp_depth, depth, f, t, cont);
		                           }],
		                          [0, comma],
		                          function(d){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(f),
		                                    Hq,
		                                    function(e){
		                                     return caml_trampoline_cps_call5(e, d, c, a, b, cont);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    function pp_field(depth, f, param, cont){
		                                     var type = param[4], name = param[2];
		                                     function a(a, b, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (pp_depth, depth, a, b, cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(f),
		      Hr,
		      function(b){
		       return caml_trampoline_cps_call4(b, name, a, type, cont);
		      });
		                                    }
		                                    function pp_value(depth, type, cont){
		                                     function a(type){
		                                      if(typeof type === "number")
		                                       switch(type){
		 case 0:
		  return cont(pp_print_bool);
		 case 1:
		  return cont(int64$0);
		 case 2:
		  return cont(float);
		 case 3:
		  return cont(_16);
		 case 4:
		  return cont
		          (function(b, a, cont){
		            a = caml_pop_trap();
		            return a
		                    (caml_maybe_attach_backtrace([0, Match_failure, Hs], 1));
		           });
		 default:
		  return cont
		          (function(ppf, param, cont){
		            return caml_exact_trampoline_cps_call$1
		                    (pp_print_string, ppf, cst_null, cont);
		           });
		                                       }
		                                      switch(type[0]){
		case 0:
		 var value = type[2], type$0 = type[1];
		 return cont
		         (function(fmt, param, cont){
		           return caml_exact_trampoline_cps_call$1
		                   (pp_value,
		                    depth,
		                    type$0,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1(a, fmt, value, cont);
		                    });
		          });
		case 1:
		 var type$1 = type[1], b = caml_obj_tag(type$1);
		 if(250 === b)
		  return caml_exact_trampoline_call1(a, type$1[1]);
		 if(246 !== b && 244 !== b)
		  return caml_exact_trampoline_call1(a, type$1);
		 return caml_exact_trampoline_cps_call
		         (force_lazy_block, type$1, a);
		case 2:
		 return cont
		         (function(fmt, param, cont){
		           return caml_exact_trampoline_cps_call$0
		                   (pp_depth, depth, fmt, type, cont);
		          });
		case 3:
		 var data = type[1];
		 return caml_exact_trampoline_cps_call$1
		         (pp_value,
		          depth,
		          data,
		          function(a){
		           var pp_v1 = list([0, comma], a);
		           return cont
		                   (function(state, v, cont){
		                     return caml_exact_trampoline_cps_call$0
		                             (pp_open_box_gen,
		                              state,
		                              0,
		                              2,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (pp_print_char,
		state,
		91,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (pp_v1,
		          state,
		          v,
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (pp_print_char,
		                    state,
		                    93,
		                    function(a){return cont(pp_close_box(state));});
		          });
		});
		                              });
		                    });
		          });
		case 4:
		 return cont
		         (function(fmt, param, cont){
		           return caml_exact_trampoline_cps_call$0
		                   (pp_depth, depth, fmt, type, cont);
		          });
		case 5:
		 var type$2 = type[2];
		 return caml_exact_trampoline_call1(a, type$2);
		case 6:
		 var
		  fields = type[1][3],
		  last = Fields[3].call(null, fields) - 1 | 0,
		  terminator =
		    function(fmt, param, cont){
		     return cont(pp_print_custom_break(fmt, Hu, Ht));
		    },
		  pp_fields =
		    function(fmt, object, cont){
		     return caml_exact_trampoline_cps_call$1
		             (Fields[9],
		              fields,
		              [0,
		               function(i, cont){
		                var delimiter = i === last ? pp_none : comma;
		                return cont
		                        (function(param, cont){
		                          if(param[1]){
		                           var match = param[3], name = param[2];
		                           if(0 === match[0]){
		                            var type = param[4], resolve = match[1];
		                            return caml_trampoline_cps_call2
		                                    (resolve,
		                                     object,
		                                     function(a){
		                                      var v = [0, name, a];
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_value,
		       depth,
		       type,
		       function(b){
		        var
		         indent = opt$9[1],
		         a =
		           [0,
		            function(ppf, v, cont){
		             return caml_exact_trampoline_cps_call$1
		                     (pp_print_char,
		                      ppf,
		                      58,
		                      function(a){return cont(pp_v1(ppf));});
		            }];
		        return caml_exact_trampoline_cps_call$1
		                (pp_open_box,
		                 fmt,
		                 indent,
		                 function(c){
		                  return caml_exact_trampoline_cps_call$3
		                          (pair,
		                           a,
		                           pp_print_string,
		                           b,
		                           fmt,
		                           v,
		                           function(a){
		                            pp_close_box(fmt);
		                            return caml_exact_trampoline_cps_call$1
		                                    (delimiter, fmt, v, cont);
		                           });
		                 });
		       });
		                                     });
		                           }
		                          }
		                          var type$0 = param[4], name$0 = param[2];
		                          function pp_sep(ppf, v, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_char,
		                                    ppf,
		                                    58,
		                                    function(a){return cont(pp_v1(ppf));});
		                          }
		                          var indent = opt$10[1], v = [0, name$0, type$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_open_box,
		                                   fmt,
		                                   indent,
		                                   function(a){
		                                    var snd = v[2], fst = v[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string,
		     fmt,
		     fst,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_sep,
		               fmt,
		               dummy,
		               function(a){
		                return caml_exact_trampoline_cps_call$0
		                        (pp_depth,
		                         depth,
		                         fmt,
		                         snd,
		                         function(a){
		                          pp_close_box(fmt);
		                          return caml_exact_trampoline_cps_call$1
		                                  (delimiter, fmt, v, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }],
		              cont);
		    };
		 return cont
		         (function(fmt, object, cont){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt),
		                    Hv,
		                    function(a){
		                     return caml_trampoline_cps_call5
		                             (a, pp_fields, object, terminator, 0, cont);
		                    });
		          });
		case 7:
		 return caml_exact_trampoline_cps_call
		         (failwith, "FIXME pp_value parameter", cont);
		case 8:
		 return cont(string$1);
		case 9:
		 return cont
		         (function(fmt, param, cont){
		           return caml_exact_trampoline_cps_call$0
		                   (pp_depth, depth, fmt, type, cont);
		          });
		case 10:
		 return cont
		         (function(fmt, param, cont){
		           return caml_exact_trampoline_cps_call$0
		                   (pp_depth, depth, fmt, type, cont);
		          });
		default:
		 var view = type[3], repr = type[2];
		 return cont
		         (function(fmt, value, cont){
		           return caml_trampoline_cps_call2
		                   (view,
		                    value,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1
		                             (pp_value,
		                              depth,
		                              repr,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1(b, fmt, a, cont);
		                              });
		                    });
		          });
		                                      }
		                                     }
		                                     return a(type);
		                                    }
		                                    function pp(f, t, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (pp_depth, 1, f, t, cont);
		                                    }
		                                    function pp_v1$0(state, t, cont){
		                                     if(typeof t === "number")
		                                      switch(t){
		case 0:
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, state, cst_Bool, cont);
		case 1:
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, state, cst_Int, cont);
		case 2:
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, state, cst_Float, cont);
		case 3:
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, state, cst_Json, cont);
		case 4:
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, state, cst_Never, cont);
		default:
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, state, cst_Null, cont);
		                                      }
		                                     switch(t[0]){
		                                       case 0:
		var value = t[2], type = t[1];
		if(typeof type === "number")
		 switch(type){
		   case 0:
		    return caml_exact_trampoline_cps_call$1
		            (pp_print_bool, state, value, cont);
		   case 1:
		    return caml_exact_trampoline_cps_call$1
		            (int64$0, state, value, cont);
		 }
		else if(8 === type[0])
		 return caml_exact_trampoline_cps_call$1
		         (string$1, state, value, cont);
		return caml_exact_trampoline_cps_call
		        (fprintf$0(state),
		         Hw,
		         function(a){
		          return caml_trampoline_cps_call3(a, pp_v1$0, type, cont);
		         });
		                                       case 1:
		var
		 t$0 = t[1],
		 a = caml_obj_tag(t$0),
		 b =
		   function(a){
		    return caml_exact_trampoline_cps_call
		            (fprintf$0(state),
		             Hx,
		             function(b){
		              return caml_trampoline_cps_call3(b, pp_v1$0, a, cont);
		             });
		   };
		if(250 === a) return b(t$0[1]);
		if(246 !== a && 244 !== a) return b(t$0);
		return caml_exact_trampoline_cps_call
		        (force_lazy_block, t$0, b);
		                                       case 2:
		var lambdas = t[1];
		return caml_trampoline_cps_call3
		        (Lambdas[2],
		         [0, pp_lambda$0],
		         [0,
		          function(ppf, v, cont){
		           return caml_exact_trampoline_cps_call$1
		                   (pp_print_string,
		                    ppf,
		                    cst,
		                    function(a){return cont(pp_v1(ppf));});
		          }],
		         function(a){
		          return caml_exact_trampoline_cps_call$2
		                  (hvbox, 0, a, state, lambdas, cont);
		         });
		                                       case 3:
		var data = t[1];
		return caml_exact_trampoline_cps_call
		        (fprintf$0(state),
		         Hy,
		         function(a){
		          return caml_trampoline_cps_call3(a, pp_v1$0, data, cont);
		         });
		                                       case 4:
		var key = t[4], data$0 = t[3];
		return caml_exact_trampoline_cps_call
		        (fprintf$0(state),
		         Hz,
		         function(a){
		          return caml_trampoline_cps_call5
		                  (a, pp_v1$0, key, pp_v1$0, data$0, cont);
		         });
		                                       case 5:
		var name = t[1]; break;
		                                       case 6:
		a = t[1];
		var match = a[4];
		if(! match){
		 var fields = a[3];
		 return caml_trampoline_cps_call3
		         (Fields[2],
		          [0, pp_field$0],
		          [0, comma],
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(state),
		                    HB,
		                    function(b){
		                     return caml_trampoline_cps_call3(b, a, fields, cont);
		                    });
		          });
		}
		name = match[1];
		break;
		                                       case 7:
		var name$0 = t[1];
		return caml_exact_trampoline_cps_call
		        (fprintf$0(state),
		         HC,
		         function(a){
		          return caml_trampoline_cps_call2(a, name$0, cont);
		         });
		                                       case 8:
		a = t[1];
		if(! a)
		 return caml_exact_trampoline_cps_call$1
		         (pp_print_string, state, cst_String, cont);
		var fmt = a[1];
		return caml_exact_trampoline_cps_call
		        (fprintf$0(state),
		         HD,
		         function(a){
		          return caml_trampoline_cps_call3(a, pp$31, fmt, cont);
		         });
		                                       case 9:
		var types = t[1];
		return caml_trampoline_cps_call3
		        (List[2],
		         [0, pp_v1$0],
		         [0, comma],
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (fprintf$0(state),
		                   HE,
		                   function(b){
		                    return caml_trampoline_cps_call3(b, a, types, cont);
		                   });
		         });
		                                       case 10:
		var
		 cases = t[1][1],
		 pp_v1$1 =
		   list
		    ([0, comma],
		     function(ppf, param, cont){
		      var type = param[4], name = param[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_open_box,
		               ppf,
		               0,
		               function(b){
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_v1$0,
		                          ppf,
		                          type,
		                          function(a){return cont(pp_close_box(ppf));});
		                }
		                if(! name) return a();
		                var v = name[1];
		                return caml_exact_trampoline_cps_call$2
		                        (append$4, string$1, comma, ppf, v, a);
		               });
		     });
		return caml_exact_trampoline_cps_call$0
		        (pp_open_box_gen,
		         state,
		         0,
		         2,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (pp_print_string,
		                   state,
		                   "Variant(",
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_v1$1,
		                             state,
		                             cases,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char,
		                                       state,
		                                       41,
		                                       function(a){return cont(pp_close_box(state));});
		                             });
		                   });
		         });
		                                       default:
		var
		 repr = t[2],
		 build = t[1],
		 buildable =
		   build
		    ? 0 === build[1][0] ? "buildable" : "maybe buildable"
		    : "not buildable";
		return caml_exact_trampoline_cps_call
		        (fprintf$0(state),
		         HF,
		         function(a){
		          return caml_trampoline_cps_call4
		                  (a, pp_v1$0, repr, buildable, cont);
		         });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(state),
		      HA,
		      function(a){
		       return caml_trampoline_cps_call2(a, name, cont);
		      });
		                                    }
		                                    function pp_lambda$0(f, lambda, cont){
		                                     var
		                                      result = lambda[3],
		                                      parameters = lambda[2],
		                                      args = lambda[1];
		                                     return caml_trampoline_cps_call2
		     (result,
		      parameters,
		      function(a){
		       return caml_trampoline_cps_call2
		               (args,
		                parameters,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (List[2],
		                          [0, pp_v1$0],
		                          [0, comma],
		                          function(c){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(f),
		                                    HG,
		                                    function(d){
		                                     return caml_trampoline_cps_call5(d, c, b, pp_v1$0, a, cont);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    function pp_field$0(f, param, cont){
		                                     var type = param[4], name = param[2];
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(f),
		      HH,
		      function(a){
		       return caml_trampoline_cps_call4
		               (a, name, pp_v1$0, type, cont);
		      });
		                                    }
		                                    function comparator$1(t, cont){
		                                     function a(t){
		                                      if(typeof t === "number")
		                                       switch(t){
		 case 0:
		  return cont
		          ([0,
		            [0,
		             symbol$10,
		             symbol$6,
		             symbol$8,
		             symbol$9,
		             symbol$5,
		             symbol$7,
		             equal$1,
		             compare$2,
		             min$5,
		             max$5,
		             ascending$0,
		             descending$0,
		             between$0,
		             clamp_exn$0,
		             clamp$0,
		             comparator$0]]);
		 case 1:
		  return cont
		          ([0,
		            [0,
		             function(b, a, cont){return cont(caml_greaterequal(b, a));},
		             function(b, a, cont){return cont(caml_lessequal(b, a));},
		             function(b, a, cont){return cont(caml_equal(b, a));},
		             function(b, a, cont){return cont(caml_greaterthan(b, a));},
		             function(b, a, cont){return cont(caml_lessthan(b, a));},
		             function(b, a, cont){return cont(caml_notequal(b, a));},
		             equal64,
		             compare$19,
		             min$3,
		             max$3,
		             ascending,
		             descending,
		             between$3,
		             clamp_exn$2,
		             clamp$2,
		             comparator$6]]);
		 case 2:
		  return cont
		          ([0,
		            [0,
		             function(b, a, cont){return cont(a <= b ? 1 : 0);},
		             function(b, a, cont){return cont(b <= a ? 1 : 0);},
		             function(b, a, cont){return cont(b === a ? 1 : 0);},
		             function(b, a, cont){return cont(a < b ? 1 : 0);},
		             function(b, a, cont){return cont(b < a ? 1 : 0);},
		             function(b, a, cont){return cont(b !== a ? 1 : 0);},
		             function(b, a, cont){return cont(b === a ? 1 : 0);},
		             function(b, a, cont){return cont(caml_float_compare(b, a));},
		             min$11,
		             max$12,
		             ascending$1,
		             descending$1,
		             between$4,
		             clamp_exn$3,
		             clamp$3,
		             comparator$7]]);
		 case 3:
		  return caml_exact_trampoline_cps_call
		          (encode$7,
		           no_input_schema,
		           function(sexp_of_t){
		            var
		             include = Make$2([0, compare$29, sexp_of_t]),
		             symbol = include[1],
		             symbol$0 = include[2],
		             symbol$1 = include[3],
		             symbol$2 = include[4],
		             symbol$3 = include[5],
		             symbol$4 = include[6],
		             equal = include[7],
		             compare = include[8],
		             min = include[9],
		             max = include[10],
		             ascending = include[11],
		             descending = include[12],
		             between = include[13],
		             clamp_exn = include[14],
		             clamp = include[15],
		             comparator = include[16];
		            return cont
		                    ([0,
		                      [0,
		                       symbol,
		                       symbol$0,
		                       symbol$1,
		                       symbol$2,
		                       symbol$3,
		                       symbol$4,
		                       equal,
		                       compare,
		                       min,
		                       max,
		                       ascending,
		                       descending,
		                       between,
		                       clamp_exn,
		                       clamp,
		                       comparator]]);
		           });
		 case 4:
		  var
		   compare =
		     function(b, param, a){
		      a = caml_pop_trap();
		      return a
		              (caml_maybe_attach_backtrace([0, Match_failure, HI], 1));
		     },
		   sexp_of_t =
		     function(a, cont){
		      a = caml_pop_trap();
		      return a
		              (caml_maybe_attach_backtrace([0, Match_failure, HJ], 1));
		     },
		   include = Make$2([0, compare, sexp_of_t]),
		   symbol = include[1],
		   symbol$0 = include[2],
		   symbol$1 = include[3],
		   symbol$2 = include[4],
		   symbol$3 = include[5],
		   symbol$4 = include[6],
		   equal = include[7],
		   compare$0 = include[8],
		   min = include[9],
		   max = include[10],
		   ascending$4 = include[11],
		   descending$4 = include[12],
		   between$1 = include[13],
		   clamp_exn$4 = include[14],
		   clamp$4 = include[15],
		   comparator$3 = include[16];
		  return cont
		          ([0,
		            [0,
		             symbol,
		             symbol$0,
		             symbol$1,
		             symbol$2,
		             symbol$3,
		             symbol$4,
		             equal,
		             compare$0,
		             min,
		             max,
		             ascending$4,
		             descending$4,
		             between$1,
		             clamp_exn$4,
		             clamp$4,
		             comparator$3]]);
		 default:
		  var
		   compare$1 = function(a, param, cont){return cont(0);},
		   sexp_of_t$0 = function(param, cont){return cont(HK);},
		   include$0 = Make$2([0, compare$1, sexp_of_t$0]),
		   symbol$23 = include$0[1],
		   symbol$24 = include$0[2],
		   symbol$25 = include$0[3],
		   symbol$26 = include$0[4],
		   symbol$27 = include$0[5],
		   symbol$28 = include$0[6],
		   equal$0 = include$0[7],
		   compare$3 = include$0[8],
		   min$0 = include$0[9],
		   max$0 = include$0[10],
		   ascending$5 = include$0[11],
		   descending$5 = include$0[12],
		   between$5 = include$0[13],
		   clamp_exn$5 = include$0[14],
		   clamp$5 = include$0[15],
		   comparator$4 = include$0[16];
		  return cont
		          ([0,
		            [0,
		             symbol$23,
		             symbol$24,
		             symbol$25,
		             symbol$26,
		             symbol$27,
		             symbol$28,
		             equal$0,
		             compare$3,
		             min$0,
		             max$0,
		             ascending$5,
		             descending$5,
		             between$5,
		             clamp_exn$5,
		             clamp$5,
		             comparator$4]]);
		                                       }
		                                      switch(t[0]){
		case 0:
		 return cont
		         ([0,
		           [0,
		            symbol$17,
		            symbol$18,
		            symbol$19,
		            symbol$20,
		            symbol$21,
		            symbol$22,
		            equal$5,
		            compare$8,
		            min$8,
		            max$8,
		            ascending$3,
		            descending$3,
		            between,
		            clamp_exn,
		            clamp,
		            comparator]]);
		case 1:
		 var t$0 = t[1], b = caml_obj_tag(t$0);
		 if(250 === b) return caml_exact_trampoline_call1(a, t$0[1]);
		 if(246 !== b && 244 !== b)
		  return caml_exact_trampoline_call1(a, t$0);
		 return caml_exact_trampoline_cps_call
		         (force_lazy_block, t$0, a);
		case 2:
		 return cont(HL);
		case 3:
		 var data = t[1];
		 return caml_exact_trampoline_cps_call
		         (comparator$1,
		          data,
		          function(err){
		           if(0 !== err[0]) return cont(err);
		           var Element = err[1], a = Element[8];
		           function compare(b, c, cont){
		            return caml_exact_trampoline_cps_call$0
		                    (compare_list, a, b, c, cont);
		           }
		           function sexp_of_t(list, cont){
		            return caml_exact_trampoline_cps_call$1
		                    (map$7,
		                     list,
		                     Element[16][2],
		                     function(a){return cont([1, a]);});
		           }
		           var
		            include = Make$2([0, compare, sexp_of_t]),
		            symbol = include[1],
		            symbol$0 = include[2],
		            symbol$1 = include[3],
		            symbol$2 = include[4],
		            symbol$3 = include[5],
		            symbol$4 = include[6],
		            equal = include[7],
		            compare$0 = include[8],
		            min = include[9],
		            max = include[10],
		            ascending = include[11],
		            descending = include[12],
		            between = include[13],
		            clamp_exn = include[14],
		            clamp = include[15],
		            comparator = include[16];
		           return cont
		                   ([0,
		                     [0,
		                      symbol,
		                      symbol$0,
		                      symbol$1,
		                      symbol$2,
		                      symbol$3,
		                      symbol$4,
		                      equal,
		                      compare$0,
		                      min,
		                      max,
		                      ascending,
		                      descending,
		                      between,
		                      clamp_exn,
		                      clamp,
		                      comparator]]);
		          });
		case 4:
		 var data$0 = t[3];
		 return caml_exact_trampoline_cps_call
		         (comparator$1,
		          data$0,
		          function(err){
		           if(0 !== err[0]) return cont(err);
		           var Data_cmp = err[1];
		           function compare(l, param, cont){
		            return caml_exact_trampoline_cps_call$0
		                    (compare_direct, Data_cmp[8], l, param, cont);
		           }
		           function sexp_of_t(param, cont){return cont(HM);}
		           var
		            include = Make$2([0, compare, sexp_of_t]),
		            symbol = include[1],
		            symbol$0 = include[2],
		            symbol$1 = include[3],
		            symbol$2 = include[4],
		            symbol$3 = include[5],
		            symbol$4 = include[6],
		            equal = include[7],
		            compare$0 = include[8],
		            min = include[9],
		            max = include[10],
		            ascending = include[11],
		            descending = include[12],
		            between = include[13],
		            clamp_exn = include[14],
		            clamp = include[15],
		            comparator = include[16];
		           return cont
		                   ([0,
		                     [0,
		                      symbol,
		                      symbol$0,
		                      symbol$1,
		                      symbol$2,
		                      symbol$3,
		                      symbol$4,
		                      equal,
		                      compare$0,
		                      min,
		                      max,
		                      ascending,
		                      descending,
		                      between,
		                      clamp_exn,
		                      clamp,
		                      comparator]]);
		          });
		case 5:
		 var type = t[2];
		 return caml_exact_trampoline_call1(a, type);
		case 6:
		 b = t[1];
		 var match = b[2];
		 if(match){
		  var comparable = match[1];
		  return cont([0, comparable]);
		 }
		 var
		  name = b[4],
		  c =
		    function(a, b, cont){
		     return caml_exact_trampoline_cps_call$2
		             (option, 0, pp_print_string, a, b, cont);
		    };
		 return caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          id,
		          fmt$55,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (a, c, name, function(a){return cont([1, a]);});
		          });
		case 7:
		 return cont(HN);
		case 8:
		 return cont
		         ([0,
		           [0,
		            symbol$16,
		            symbol$12,
		            symbol$14,
		            symbol$15,
		            symbol$11,
		            symbol$13,
		            equal$4,
		            compare$4,
		            min$6,
		            max$6,
		            ascending$2,
		            descending$2,
		            between$2,
		            clamp_exn$1,
		            clamp$1,
		            comparator$2]]);
		case 9:
		 return cont(HO);
		case 10:
		 var
		  cases = t[1][1],
		  f =
		    function(acc, param, cont){
		     var type = param[4], lift = param[2];
		     return caml_exact_trampoline_cps_call
		             (comparator$1,
		              type,
		              function(err){
		               if(0 !== err[0]) return cont(err);
		               var Cmp = err[1];
		               function f(left, right, cont){
		                return caml_trampoline_cps_call2
		                        (lift,
		                         left,
		                         function(match){
		                          return caml_trampoline_cps_call2
		                                  (lift,
		                                   right,
		                                   function(match$0){
		                                    if(! match) return match$0 ? cont(HS) : cont(0);
		                                    var l = match[1];
		                                    if(! match$0) return cont(HR);
		                                    var r = match$0[1];
		                                    return caml_trampoline_cps_call3
		    (Cmp[8], l, r, function(a){return cont([0, a]);});
		                                   });
		                         });
		               }
		               return cont([0, [0, f, acc]]);
		              });
		    },
		  d =
		    function(cases, cont){
		     return caml_exact_trampoline_cps_call
		             (of_rev_keys,
		              cases,
		              function(cases){
		               function compare(left, right, cont){
		                function a(param){
		                 function b(a){
		                  return caml_exact_trampoline_cps_call$2
		                          (value_exn, HP, 0, 0, a, cont);
		                 }
		                 if(! param) return b(0);
		                 var l = param[2], x = param[1];
		                 return caml_trampoline_cps_call3
		                         (x,
		                          left,
		                          right,
		                          function(r){
		                           return r ? b(r) : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                return a(cases);
		               }
		               function sexp_of_t(param, cont){return cont(HQ);}
		               var
		                include = Make$2([0, compare, sexp_of_t]),
		                symbol = include[1],
		                symbol$0 = include[2],
		                symbol$1 = include[3],
		                symbol$2 = include[4],
		                symbol$3 = include[5],
		                symbol$4 = include[6],
		                equal = include[7],
		                compare$0 = include[8],
		                min = include[9],
		                max = include[10],
		                ascending = include[11],
		                descending = include[12],
		                between = include[13],
		                clamp_exn = include[14],
		                clamp = include[15],
		                comparator = include[16];
		               return cont
		                       ([0,
		                         symbol,
		                         symbol$0,
		                         symbol$1,
		                         symbol$2,
		                         symbol$3,
		                         symbol$4,
		                         equal,
		                         compare$0,
		                         min,
		                         max,
		                         ascending,
		                         descending,
		                         between,
		                         clamp_exn,
		                         clamp,
		                         comparator]);
		              });
		    };
		 return caml_exact_trampoline_cps_call$2
		         (fold_result,
		          fold_left$1,
		          0,
		          f,
		          cases,
		          function(a){
		           return caml_trampoline_cps_call3(let$15, a, d, cont);
		          });
		default:
		 var view = t[3], repr = t[2];
		 return caml_exact_trampoline_cps_call
		         (comparator$1,
		          repr,
		          function(err){
		           if(0 !== err[0]) return cont(err);
		           var Cmp = err[1];
		           function compare(left, right, cont){
		            return caml_trampoline_cps_call2
		                    (view,
		                     right,
		                     function(a){
		                      return caml_trampoline_cps_call2
		                              (view,
		                               left,
		                               function(b){
		                                return caml_trampoline_cps_call3(Cmp[8], b, a, cont);
		                               });
		                     });
		           }
		           function sexp_of_t(param, cont){return cont(HT);}
		           var
		            include = Make$2([0, compare, sexp_of_t]),
		            symbol = include[1],
		            symbol$0 = include[2],
		            symbol$1 = include[3],
		            symbol$2 = include[4],
		            symbol$3 = include[5],
		            symbol$4 = include[6],
		            equal = include[7],
		            compare$0 = include[8],
		            min = include[9],
		            max = include[10],
		            ascending = include[11],
		            descending = include[12],
		            between = include[13],
		            clamp_exn = include[14],
		            clamp = include[15],
		            comparator = include[16];
		           return cont
		                   ([0,
		                     [0,
		                      symbol,
		                      symbol$0,
		                      symbol$1,
		                      symbol$2,
		                      symbol$3,
		                      symbol$4,
		                      equal,
		                      compare$0,
		                      min,
		                      max,
		                      ascending,
		                      descending,
		                      between,
		                      clamp_exn,
		                      clamp,
		                      comparator]]);
		          });
		                                      }
		                                     }
		                                     return a(t);
		                                    }
		                                    var Dump = [0, pp_v1$0];
		                                    return caml_exact_trampoline_cps_call
		    (make$19,
		     dummy,
		     function(rtti_bool){
		      return caml_exact_trampoline_cps_call
		              (make$19,
		               dummy,
		               function(rtti_int64){
		                return caml_exact_trampoline_cps_call
		                        (make$19,
		                         dummy,
		                         function(rtti_float){
		                          return caml_exact_trampoline_cps_call
		                                  (make$19,
		                                   dummy,
		                                   function(rtti_null){
		                                    return caml_exact_trampoline_cps_call
		    (make$19,
		     dummy,
		     function(rtti_string){
		      return caml_exact_trampoline_cps_call
		              (make$19,
		               dummy,
		               function(rtti_unit){
		                return caml_exact_trampoline_cps_call
		                        (make$19,
		                         dummy,
		                         function(rtti_json){
		                          function rtti(t$1, cont){
		                           a:
		                           {
		                            var t = t$1;
		                            b:
		                            for(;;){
		                             if(typeof t === "number")
		                              switch(t){
		                                case 0:
		                                 return cont(rtti_bool);
		                                case 1:
		                                 return cont(rtti_int64);
		                                case 2:
		                                 return cont(rtti_float);
		                                case 3:
		                                 return cont(rtti_json);
		                                case 4:
		                                 return caml_exact_trampoline_cps_call
		 (failwith, "fixme rtti never", cont);
		                                default: return cont(rtti_null);
		                              }
		                             switch(t[0]){
		                               case 0:
		                                return cont(rtti_unit);
		                               case 1:
		                                break a;
		                               case 2:
		                                return caml_exact_trampoline_cps_call
		(failwith, cst_fixme, cont);
		                               case 3:
		                                break b;
		                               case 5:
		                                var type = t[2]; t = type; break;
		                               case 6:
		                                var rtti$0 = t[1][5]; return cont(rtti$0);
		                               case 8:
		                                return cont(rtti_string);
		                               case 10:
		                                var rtti$1 = t[1][2]; return cont(rtti$1);
		                               case 11:
		                                var witness = t[4]; return cont(witness);
		                               default:
		                                return caml_exact_trampoline_cps_call(make$19, dummy, cont);
		                             }
		                            }
		                            var data = t[1];
		                            return caml_exact_trampoline_cps_call
		                                    (rtti, data, function(a){return cont([2, a]);});
		                           }
		                           var t$0 = t[1];
		                           return cont
		                                   ([0,
		                                     [246,
		                                      function(a, cont){
		                                       a = caml_obj_tag(t$0);
		                                       function b(a){
		return caml_exact_trampoline_cps_call(rtti, a, cont);
		                                       }
		                                       if(250 === a) return b(t$0[1]);
		                                       if(246 !== a && 244 !== a) return b(t$0);
		                                       return caml_exact_trampoline_cps_call
		       (force_lazy_block, t$0, b);
		                                      }]]);
		                          }
		                          function option$0(type, cont){
		                           function make_none_case(lift){
		                            function return$(param, cont){return cont(0);}
		                            return [0, name, lift, return$, 5];
		                           }
		                           var
		                            none =
		                              make_none_case
		                               (function(param, cont){return param ? cont(0) : cont(HU);});
		                           if(typeof type === "number"){
		                            if(5 === type){
		                             var
		                              null_case =
		                                make_none_case(function(value, cont){return cont(HV);});
		                             return cont([10, [0, [0, null_case, 0], [4, rtti_null]]]);
		                            }
		                           }
		                           else
		                            switch(type[0]){
		                              case 5:
		                               var type$0 = type[2], name$1 = type[1];
		                               return caml_exact_trampoline_cps_call
		                                       (option$0,
		type$0,
		function(a){return cont([5, name$1, a]);});
		                              case 10:
		                               var
		                                match = type[1],
		                                rtti$0 = match[2],
		                                cases = match[1],
		                                found_null = [0, 0];
		                               return caml_exact_trampoline_cps_call$1
		                                       (map$7,
		cases,
		function(case$, cont){
		 var match = case$[4];
		 if(typeof match === "number" && 5 <= match){
		  found_null[1] = 1;
		  var a = case$[3];
		  return cont
		          ([0,
		            case$[1],
		            function(param, cont){
		             if(! param) return cont(HW);
		             var value = param[1];
		             return caml_trampoline_cps_call2(case$[2], value, cont);
		            },
		            function(b, cont){
		             return caml_exact_trampoline_cps_call$0
		                     (compose, return$9, a, b, cont);
		            },
		            5]);
		 }
		 var b = case$[3], c = case$[2];
		 return cont
		         ([0,
		           case$[1],
		           function(a, cont){
		            return caml_trampoline_cps_call3(bind$8, a, c, cont);
		           },
		           function(a, cont){
		            return caml_exact_trampoline_cps_call$0
		                    (compose, return$9, b, a, cont);
		           },
		           case$[4]]);
		},
		function(cases){
		 var b = [4, rtti$0];
		 function a(cases){return cont([10, [0, cases, b]]);}
		 return found_null[1]
		         ? a(cases)
		         : caml_exact_trampoline_cps_call$1
		           (append$0, cases, [0, none, 0], a);
		});
		                            }
		                           return caml_exact_trampoline_cps_call
		                                   (rtti,
		                                    type,
		                                    function(a){
		                                     function lift(a, cont){return cont(a);}
		                                     return cont
		     ([10,
		       [0,
		        [0, [0, name$0, lift, return$9, type], [0, none, 0]],
		        [4, a]]]);
		                                    });
		                          }
		                          function resolve(type, cont){
		                           function a(type){
		                            if(typeof type !== "number")
		                             switch(type[0]){
		                               case 1:
		                                var type$0 = type[1], b = caml_obj_tag(type$0);
		                                if(250 === b)
		                                 return caml_exact_trampoline_call1(a, type$0[1]);
		                                if(246 !== b && 244 !== b)
		                                 return caml_exact_trampoline_call1(a, type$0);
		                                return caml_exact_trampoline_cps_call
		(force_lazy_block, type$0, a);
		                               case 4:
		                                var
		                                 data = type[3],
		                                 c = type[7],
		                                 d = type[6],
		                                 e = type[5],
		                                 f = type[4];
		                                return caml_exact_trampoline_cps_call
		(resolve,
		 data,
		 function(a){
		  return cont([4, type[1], type[2], a, f, e, d, c]);
		 });
		                             }
		                            return cont(type);
		                           }
		                           return a(type);
		                          }
		                          function equal_no_indentation(l, r, indentation, cont){
		                           function equal(l, r, cont){
		                            function a(l, r){
		                             a:
		                             {
		                              b:
		                              {
		                               if(typeof l === "number")
		                                switch(l){
		                                  case 0:
		                                   if(typeof r === "number"){
		                                    if(0 === r) return cont(HX);
		                                    break a;
		                                   }
		                                   switch(r[0]){case 1: break;case 5: break b;default: break a;
		                                   }
		                                   break;
		                                  case 1:
		                                   if(typeof r === "number"){
		                                    if(1 === r) return cont(HY);
		                                    break a;
		                                   }
		                                   switch(r[0]){case 1: break;case 5: break b;default: break a;
		                                   }
		                                   break;
		                                  case 2:
		                                   if(typeof r === "number"){
		                                    if(2 === r) return cont(HZ);
		                                    break a;
		                                   }
		                                   switch(r[0]){case 1: break;case 5: break b;default: break a;
		                                   }
		                                   break;
		                                  case 3:
		                                   if(typeof r === "number"){
		                                    if(3 === r) return cont(H0);
		                                    break a;
		                                   }
		                                   switch(r[0]){case 1: break;case 5: break b;default: break a;
		                                   }
		                                   break;
		                                  case 4:
		                                   if(typeof r === "number"){
		                                    if(4 === r) return cont(H1);
		                                    break a;
		                                   }
		                                   switch(r[0]){case 1: break;case 5: break b;default: break a;
		                                   }
		                                   break;
		                                  default:
		                                   if(typeof r === "number"){
		                                    if(5 === r) return cont(H2);
		                                    break a;
		                                   }
		                                   switch(r[0]){case 1: break;case 5: break b;default: break a;
		                                   }
		                                }
		                               else
		                                switch(l[0]){
		                                  case 0:
		                                   var lv = l[2], l$1 = l[1];
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 0:
		                                      var rv = r[2], r$2 = r[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (equal,
		       l$1,
		       r$2,
		       function(match){
		        return match
		                ? caml_exact_trampoline_cps_call
		                  (comparator$1,
		                   l$1,
		                   function(match){
		                    if(0 === match[0]){
		                     var Cmp = match[1];
		                     return caml_trampoline_cps_call3
		                             (Cmp[3], lv, rv, function(a){return cont(some_if(a, 0));});
		                    }
		                    var e = match[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (warn,
		                             0,
		                             function(m, cont){
		                              return caml_trampoline_cps_call9
		                                      (m, 0, 0, H3, pp, l$1, pp, r$2, e, cont);
		                             },
		                             function(match){return cont(0);});
		                   })
		                : cont(0);
		       });
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 1:
		                                   var l$2 = l[1], b = caml_obj_tag(l$2);
		                                   if(250 === b)
		                                    return caml_exact_trampoline_call2(a, l$2[1], r);
		                                   if(246 !== b && 244 !== b)
		                                    return caml_exact_trampoline_call2(a, l$2, r);
		                                   return caml_exact_trampoline_cps_call
		   (force_lazy_block,
		    l$2,
		    function(b){return caml_exact_trampoline_call2(a, b, r);});
		                                  case 2:
		                                   var left = l[1];
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 2:
		                                      var
		                                       right = r[1],
		                                       equal_lambdas =
		 function(left, right, cont){
		  if(left){
		   if(right){
		    var
		     right_lambda = right[1],
		     left_lambda = left[1],
		     right_tail = right[2],
		     left_tail = left[2];
		    return caml_trampoline_cps_call2
		            (left_lambda[1],
		             left_lambda[2],
		             function(left_args){
		              return caml_trampoline_cps_call2
		                      (right_lambda[1],
		                       right_lambda[2],
		                       function(right_args){
		                        return caml_trampoline_cps_call2
		                                (left_lambda[3],
		                                 left_lambda[2],
		                                 function(left_result){
		                                  return caml_trampoline_cps_call2
		  (right_lambda[3],
		   right_lambda[2],
		   function(right_result){
		    function equal_args(left, right, cont){
		     if(left){
		      if(right){
		       var
		        right_tail = right[2],
		        right_head = right[1],
		        left_tail = left[2],
		        left_head = left[1];
		       return caml_exact_trampoline_cps_call$1
		               (equal,
		                left_head,
		                right_head,
		                function(match){
		                 return caml_exact_trampoline_cps_call$1
		                         (equal_args,
		                          left_tail,
		                          right_tail,
		                          function(match$0){
		                           if(match && match$0) return cont(H4);
		                           return cont(0);
		                          });
		                });
		      }
		     }
		     else if(! right) return cont(H5);
		     return cont(0);
		    }
		    return caml_exact_trampoline_cps_call$1
		            (equal_args,
		             left_args,
		             right_args,
		             function(match){
		              return caml_exact_trampoline_cps_call$1
		                      (equal,
		                       left_result,
		                       right_result,
		                       function(match$0){
		                        return caml_exact_trampoline_cps_call$1
		                                (equal_lambdas,
		                                 left_tail,
		                                 right_tail,
		                                 function(match$1){
		                                  if(match && match$0 && match$1) return cont(H6);
		                                  return cont(0);
		                                 });
		                       });
		             });
		   });
		                                 });
		                       });
		             });
		   }
		  }
		  else if(! right) return cont(H7);
		  return cont(0);
		 };
		                                      return caml_exact_trampoline_cps_call$1
		      (equal_lambdas,
		       left,
		       right,
		       function(match){return match ? cont(H8) : cont(0);});
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 3:
		                                   var l$3 = l[1];
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 3:
		                                      var r$3 = r[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (equal,
		       l$3,
		       r$3,
		       function(match){return match ? cont(H9) : cont(0);});
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 4:
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 4:
		                                      return caml_exact_trampoline_cps_call$1
		      (equal,
		       l[4],
		       r[4],
		       function(match){
		        return caml_exact_trampoline_cps_call$1
		                (equal,
		                 l[3],
		                 r[3],
		                 function(match$0){
		                  return caml_exact_trampoline_cps_call$1
		                          (provably_equal,
		                           l[7],
		                           r[7],
		                           function(match$1){
		                            if(match && match$0 && match$1) return cont(H_);
		                            return cont(0);
		                           });
		                 });
		       });
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 6:
		                                   var l$4 = l[1][5];
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 6:
		                                      var r$4 = r[1][5];
		                                      return caml_exact_trampoline_cps_call$1
		      (provably_equal, l$4, r$4, cont);
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 8:
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 8:
		                                      return cont(H$);
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 9:
		                                   var l$5 = l[1];
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 9:
		                                      var
		                                       r$5 = r[1],
		                                       equal_hlist =
		 function(left, right, cont){
		  if(left){
		   if(right){
		    var
		     right_tail = right[2],
		     right_head = right[1],
		     left_tail = left[2],
		     left_head = left[1];
		    return caml_exact_trampoline_cps_call$1
		            (equal,
		             left_head,
		             right_head,
		             function(match){
		              return caml_exact_trampoline_cps_call$1
		                      (equal_hlist,
		                       left_tail,
		                       right_tail,
		                       function(match$0){
		                        if(match && match$0) return cont(Ia);
		                        return cont(0);
		                       });
		             });
		   }
		  }
		  else if(! right) return cont(Ib);
		  return cont(0);
		 };
		                                      return caml_exact_trampoline_cps_call$1
		      (equal_hlist,
		       l$5,
		       r$5,
		       function(match){return match ? cont(Ic) : cont(0);});
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 10:
		                                   var l$6 = l[1][2];
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 10:
		                                      var r$6 = r[1][2];
		                                      return caml_exact_trampoline_cps_call$1
		      (provably_equal, l$6, r$6, cont);
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                  case 11:
		                                   var l$7 = l[4];
		                                   if(typeof r === "number") break a;
		                                   switch(r[0]){
		                                     case 11:
		                                      var r$7 = r[4];
		                                      return caml_exact_trampoline_cps_call$1
		      (provably_equal, l$7, r$7, cont);
		                                     case 1: break;
		                                     case 5:
		                                      break b;
		                                     default: break a;
		                                   }
		                                   break;
		                                }
		                               if(typeof r !== "number" && 1 === r[0]){
		                                var r$1 = r[1], b = caml_obj_tag(r$1);
		                                if(250 === b)
		                                 return caml_exact_trampoline_call2(a, l, r$1[1]);
		                                if(246 !== b && 244 !== b)
		                                 return caml_exact_trampoline_call2(a, l, r$1);
		                                return caml_exact_trampoline_cps_call
		(force_lazy_block,
		 r$1,
		 function(b){return caml_exact_trampoline_call2(a, l, b);});
		                               }
		                               if(typeof l !== "number" && 7 === l[0]) break b;
		                               var l$0 = l[2];
		                               return caml_exact_trampoline_call2(a, l$0, r);
		                              }
		                              if(typeof r !== "number" && 5 === r[0]){
		                               var r$0 = r[2];
		                               return caml_exact_trampoline_call2(a, l, r$0);
		                              }
		                             }
		                             return cont(0);
		                            }
		                            return a(l, r);
		                           }
		                           function msgf(m, cont){
		                            var a = parens(pp);
		                            return caml_trampoline_cps_call8
		                                    (m, 0, 0, Ie, parens(pp), l, a, r, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (debug$0,
		                                    indentation,
		                                    msgf,
		                                    function(match){
		                                     var lvl = indentation + 1 | 0;
		                                     return caml_exact_trampoline_cps_call
		     (resolve,
		      r,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (resolve,
		                l,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (equal,
		                          b,
		                          a,
		                          function(result){
		                           return caml_exact_trampoline_cps_call$1
		                                   (debug$0,
		                                    lvl,
		                                    function(m, cont){
		                                     var a = is_some(result);
		                                     return caml_exact_trampoline_cps_call$0
		     (m,
		      0,
		      0,
		      Id,
		      function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                    },
		                                    function(match){return cont(result);});
		                          });
		                });
		      });
		                                    });
		                          }
		                          function equal(l, r, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_no_indentation, l, r, 0, cont);
		                          }
		                          function const$(type, value){return [0, type, value];}
		                          function function$(args, result){
		                           return [2,
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(args);},
		                                     0,
		                                     function(param, cont){return cont(result);}],
		                                    0]];
		                          }
		                          function lambda(args, result){
		                           return [0,
		                                   function(param, cont){return cont(args);},
		                                   0,
		                                   function(param, cont){return cont(result);}];
		                          }
		                          function functions(lambdas){return [2, lambdas];}
		                          function variant(name, cases, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (make$19,
		                                    dummy,
		                                    function(a){
		                                     var variant = [10, [0, cases, a]];
		                                     if(! name) return cont(variant);
		                                     var name$0 = name[1];
		                                     return cont([5, name$0, variant]);
		                                    });
		                          }
		                          function is_nullish(type, cont){
		                           function a(type){
		                            if(typeof type === "number"){
		                             if(type >= 4) return cont(1);
		                            }
		                            else
		                             switch(type[0]){
		                               case 0:
		                                var type$0 = type[1];
		                                return caml_exact_trampoline_call1(a, type$0);
		                               case 1:
		                                var t = type[1], b = caml_obj_tag(t);
		                                if(250 === b) return caml_exact_trampoline_call1(a, t[1]);
		                                if(246 !== b && 244 !== b)
		                                 return caml_exact_trampoline_call1(a, t);
		                                return caml_exact_trampoline_cps_call
		(force_lazy_block, t, a);
		                               case 10:
		                                var
		                                 cases = type[1][1],
		                                 c =
		                                   function(t){
		                                    function a(a){return cont(1 - a);}
		                                    if(! t) return a(0);
		                                    var xs = t[2], x = t[1], type = x[4];
		                                    return caml_exact_trampoline_cps_call
		    (is_nullish,
		     type,
		     function(b){
		      return 1 - b ? a(1) : caml_exact_trampoline_call1(c, xs);
		     });
		                                   };
		                                return c(cases);
		                               case 5:
		                               case 11:
		                                var type$1 = type[2];
		                                return caml_exact_trampoline_call1(a, type$1);
		                             }
		                            return cont(0);
		                           }
		                           return a(type);
		                          }
		                          function either(first, second, cont){
		                           function lift(param, cont){
		                            if(0 === param[0]) return cont(0);
		                            var v = param[1];
		                            return cont([0, v]);
		                           }
		                           function lift$0(param, cont){
		                            if(0 !== param[0]) return cont(0);
		                            var v = param[1];
		                            return cont([0, v]);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (variant,
		                                    0,
		                                    [0,
		                                     [0, name$2, lift$0, return$1, first],
		                                     [0, [0, name$1, lift, return$2, second], 0]],
		                                    cont);
		                          }
		                          function field_get(name, cont){
		                           var
		                            a =
		                              [0,
		                               function(field, cont){
		                                var field_name = field[2], a = [0, field];
		                                return caml_exact_trampoline_cps_call$1
		(symbol$96,
		 [0, field_name],
		 name,
		 function(b){return cont(some_if(b, a));});
		                               }],
		                            b = Fields[6];
		                           return cont
		                                   (function(c, cont){
		                                     return caml_exact_trampoline_cps_call$1(b, c, a, cont);
		                                    });
		                          }
		                          function field_names(names, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Fields[10],
		                                    names,
		                                    [0, function(param){var name = param[2]; return [0, name];}],
		                                    cont);
		                          }
		                          var
		                           Bind_parameter =
		                             [248,
		                              "Graph__Graph_type_bootstrap.Make(Arr).Bind_parameter",
		                              caml_fresh_oo_id()];
		                          function cast(location, target, source, cont){
		                           function cast(target, source, lvl, cont){
		                            function a(target, source){
		                             if(typeof target !== "number" && 1 === target[0]){
		                              var target$1 = target[1], b = caml_obj_tag(target$1);
		                              if(250 === b)
		                               return caml_exact_trampoline_call2(a, target$1[1], source);
		                              if(246 !== b && 244 !== b)
		                               return caml_exact_trampoline_call2(a, target$1, source);
		                              return caml_exact_trampoline_cps_call
		                                      (force_lazy_block,
		                                       target$1,
		                                       function(b){
		return caml_exact_trampoline_call2(a, b, source);
		                                       });
		                             }
		                             if(typeof source !== "number" && 1 === source[0]){
		                              var source$1 = source[1], b = caml_obj_tag(source$1);
		                              if(250 === b)
		                               return caml_exact_trampoline_call2(a, target, source$1[1]);
		                              if(246 !== b && 244 !== b)
		                               return caml_exact_trampoline_call2(a, target, source$1);
		                              return caml_exact_trampoline_cps_call
		                                      (force_lazy_block,
		                                       source$1,
		                                       function(b){
		return caml_exact_trampoline_call2(a, target, b);
		                                       });
		                             }
		                             if(typeof target !== "number" && 5 === target[0]){
		                              var target$0 = target[2];
		                              return caml_exact_trampoline_call2(a, target$0, source);
		                             }
		                             if(typeof source !== "number" && 5 === source[0]){
		                              var source$0 = source[2];
		                              return caml_exact_trampoline_call2(a, target, source$0);
		                             }
		                             return caml_exact_trampoline_cps_call$0
		                                     (equal_no_indentation,
		                                      source,
		                                      target,
		                                      lvl,
		                                      function(match){
		                                       return match
		       ? cont([0, Arr[7]])
		       : caml_exact_trampoline_cps_call$0
		         (scope,
		          lvl,
		          function(m, cont){
		           return caml_trampoline_cps_call8
		                   (m, 0, 0, In, pp, source, pp, target, cont);
		          },
		          function(indentation, cont){
		           a:
		           {
		            b:
		            {
		             c:
		             {
		              if(typeof target === "number"){
		               if(2 === target){
		                if(typeof source === "number")
		                 switch(source){
		                   case 1:
		                    return caml_exact_trampoline_cps_call
		                            (of_string$0, Arr[2].call(null, to_float), cont);
		                   case 4:
		                    break b;
		                   default: break a;
		                 }
		                switch(source[0]){
		                  case 11: break;
		                  case 10:
		                   break c;
		                  case 0:
		                   break b;
		                  default: break a;
		                }
		               }
		              }
		              else
		               switch(target[0]){
		                 case 3:
		                  var target$0 = target[1];
		                  if(typeof source === "number"){
		                   if(4 === source) break b;
		                   break a;
		                  }
		                  switch(source[0]){
		                    case 3:
		                     var
		                      source$1 = source[1],
		                      g =
		                        function(next, cont){
		                         if(0 !== next[0])
		                          return cont
		                                  (Arr[4].call
		                                    (null,
		                                     function(source_list, cont){
		                                      return caml_exact_trampoline_cps_call
		      (Arr[13],
		       next,
		       function(a){
		        return caml_trampoline_cps_call3
		                (map$18,
		                 source_list,
		                 a,
		                 function(a){
		                  return caml_trampoline_cps_call2(Arr[1][11], a, cont);
		                 });
		       });
		                                     }));
		                         var next$0 = next[1];
		                         return cont
		                                 (Arr[2].call
		                                   (null,
		                                    function(source_list, cont){
		                                     return caml_trampoline_cps_call3
		     (map$18, source_list, next$0, cont);
		                                    }));
		                        };
		                     return caml_exact_trampoline_cps_call$0
		                             (cast,
		                              target$0,
		                              source$1,
		                              indentation,
		                              function(a){
		                               return caml_trampoline_cps_call3(let$15, a, g, cont);
		                              });
		                    case 11: break;
		                    case 10:
		                     break c;
		                    case 0:
		                     break b;
		                    default: break a;
		                  }
		                  break;
		                 case 4:
		                  var a = target[3];
		                  if(typeof a !== "number" && 7 === a[0]){
		                   var match = target[4];
		                   if(typeof match !== "number" && 7 === match[0]){
		                    var key_parameter = match[1], data_parameter = a[1];
		                    if(typeof source === "number"){
		                     if(4 === source) break b;
		                     break a;
		                    }
		                    switch(source[0]){
		                      case 4:
		                       var
		                        key = source[4],
		                        data = source[3],
		                        h =
		                          function(param, cont){
		                           return cont
		                                   (Arr[2].call(null, function(a, cont){return cont(a);}));
		                          };
		                       return caml_perform_effect
		                               ([0, Bind_parameter, [0, key_parameter, [0, key]]],
		                                function(left){
		                                 return caml_perform_effect
		 ([0, Bind_parameter, [0, data_parameter, [0, data]]],
		  function(a){
		   return caml_trampoline_cps_call3
		           (and$4,
		            left,
		            a,
		            function(a){
		             return caml_trampoline_cps_call3(let$15, a, h, cont);
		            });
		  });
		                                });
		                      case 11: break;
		                      case 10:
		                       break c;
		                      case 0:
		                       break b;
		                      default: break a;
		                    }
		                   }
		                  }
		                  break;
		                 case 6:
		                  a = target[1][1];
		                  if(a){
		                   a = a[1];
		                   var build = a[2], build_type = a[1];
		                   if(typeof source === "number"){
		                    if(4 === source) break b;
		                    break a;
		                   }
		                   switch(source[0]){
		                     case 6:
		                      var
		                       source_fields = source[1][3],
		                       i =
		                         function(build_fields, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (Arr[18][1], build_fields, build, cont);
		                         },
		                       build$0 =
		                         function(fields, cont){
		                          if(! fields) return cont([0, Arr[5].call(null, 0)]);
		                          var
		                           tail = fields[2],
		                           match = fields[1],
		                           type = match[2],
		                           name = match[1];
		                          function a(a, cont){
		                           var
		                            build_tail = a[2],
		                            a = a[1][1],
		                            source_type = a[4],
		                            resolve = a[3];
		                           function b(cast, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (Arr[18][1],
		                                     resolve,
		                                     cast,
		                                     function(head){
		                                      var
		                                       a =
		 Arr[2].call
		  (null,
		   function(param, cont){
		    var tail = param[2], head = param[1];
		    return cont([0, head, tail]);
		   });
		                                      return caml_exact_trampoline_cps_call$1
		      (Arr[21],
		       head,
		       build_tail,
		       function(c){
		        var
		         b =
		           Arr[2].call
		            (null, function(src, cont){return cont([0, src, src]);});
		        return caml_exact_trampoline_cps_call$1
		                (Arr[18][1],
		                 b,
		                 c,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1
		                          (Arr[18][1], b, a, cont);
		                 });
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (cast,
		                                    type,
		                                    source_type,
		                                    indentation,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(let$15, a, b, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (field_get,
		                                   [0, name],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (b,
		     source_fields,
		     function(match){
		      function b(left){
		       return caml_exact_trampoline_cps_call
		               (build$0,
		                tail,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and$3,
		                          left,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$14, b, a, cont);
		                          });
		                });
		      }
		      if(! match)
		       return caml_exact_trampoline_cps_call$0
		               (cast,
		                type,
		                5,
		                indentation,
		                function(a){
		                 if(0 !== a[0])
		                  return caml_exact_trampoline_cps_call$0
		                          (fail$4,
		                           2,
		                           location,
		                           Il,
		                           function(a){return caml_trampoline_cps_call2(a, name, b);});
		                 var cast = a[1], a = Arr[5].call(null, 0);
		                 return caml_exact_trampoline_cps_call$1
		                         (Arr[18][2],
		                          cast,
		                          a,
		                          function(a){return b([0, [0, [0, 1, name, a, type, 0]]]);});
		                });
		      var field = match[1];
		      return b([0, field]);
		     });
		                                   });
		                         };
		                      return caml_exact_trampoline_cps_call
		                              (build$0,
		                               build_type,
		                               function(a){
		                                return caml_trampoline_cps_call3(let$15, a, i, cont);
		                               });
		                     case 11: break;
		                     case 10:
		                      break c;
		                     case 0:
		                      break b;
		                     default: break a;
		                   }
		                  }
		                  break;
		                 case 9:
		                  var target$1 = target[1];
		                  if(typeof source === "number"){
		                   if(4 === source) break b;
		                   break a;
		                  }
		                  switch(source[0]){
		                    case 9:
		                     var
		                      source$2 = source[1],
		                      cast_tuple =
		                        function(target, source, lvl, cont){
		                         if(target){
		                          if(source){
		                           var
		                            source_tail = source[2],
		                            source_head = source[1],
		                            target_tail = target[2],
		                            target_head = target[1],
		                            a =
		                              function(param, cont){
		                               var
		                                convert_tail = param[2],
		                                convert_head = param[1],
		                                a =
		                                  Arr[2].call
		                                   (null,
		                                    function(param, cont){
		                                     var tail = param[2], head = param[1];
		                                     return cont([0, head, tail]);
		                                    });
		                               return caml_exact_trampoline_cps_call$1
		                                       (Arr[21],
		convert_head,
		convert_tail,
		function(c){
		 var
		  b =
		    Arr[2].call
		     (null,
		      function(param, cont){
		       var tail = param[2], head = param[1];
		       return cont([0, head, tail]);
		      });
		 return caml_exact_trampoline_cps_call$1
		         (Arr[18][1],
		          b,
		          c,
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (Arr[18][1], b, a, cont);
		          });
		});
		                              };
		                           return caml_exact_trampoline_cps_call$0
		                                   (cast,
		                                    target_head,
		                                    source_head,
		                                    lvl,
		                                    function(left){
		                                     return caml_exact_trampoline_cps_call$0
		     (cast_tuple,
		      target_tail,
		      source_tail,
		      lvl,
		      function(b){
		       return caml_trampoline_cps_call3
		               (and$4,
		                left,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(let$15, b, a, cont);
		                });
		      });
		                                    });
		                          }
		                         }
		                         else if(! source) return cont([0, Arr[7]]);
		                         return caml_exact_trampoline_cps_call$0
		                                 (fail$4, 2, location, Im, cont);
		                        };
		                     return caml_exact_trampoline_cps_call$0
		                             (cast_tuple, target$1, source$2, indentation, cont);
		                    case 11: break;
		                    case 10:
		                     break c;
		                    case 0:
		                     break b;
		                    default: break a;
		                  }
		                  break;
		                 case 11:
		                  a = target[1];
		                  if(a){
		                   a = a[1];
		                   if(0 === a[0]){
		                    var
		                     repr$0 = target[2],
		                     build$1 = a[1],
		                     j =
		                       function(next, cont){
		                        var a = Arr[2].call(null, build$1);
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][1], next, a, cont);
		                       };
		                    return caml_exact_trampoline_cps_call$0
		                            (cast,
		                             repr$0,
		                             source,
		                             indentation,
		                             function(a){
		                              return caml_trampoline_cps_call3(let$15, a, j, cont);
		                             });
		                   }
		                  }
		                  break;
		               }
		              if(typeof source !== "number" && 11 === source[0]){
		               var
		                view = source[3],
		                repr = source[2],
		                f =
		                  function(next, cont){
		                   var a = Arr[2].call(null, view);
		                   return caml_exact_trampoline_cps_call$1
		                           (Arr[18][2], next, a, cont);
		                  };
		               return caml_exact_trampoline_cps_call$0
		                       (cast,
		                        target,
		                        repr,
		                        indentation,
		                        function(a){
		                         return caml_trampoline_cps_call3(let$15, a, f, cont);
		                        });
		              }
		              if(typeof target !== "number" && 7 === target[0]){
		               var
		                name = target[1],
		                e =
		                  function(param, cont){
		                   return cont
		                           (Arr[2].call(null, function(a, cont){return cont(a);}));
		                  };
		               return caml_perform_effect
		                       ([0, Bind_parameter, [0, name, [0, source]]],
		                        function(a){
		                         return caml_trampoline_cps_call3(let$15, a, e, cont);
		                        });
		              }
		             }
		             if(typeof source !== "number" && 10 === source[0]){
		              var
		               source$0 = source[1][1],
		               d =
		                 function(cases, cont){
		                  return cont
		                          (Arr[4].call
		                            (null,
		                             function(v, cont){
		                              function a(param){
		                               function b(match){
		                                if(! match)
		                                 return caml_exact_trampoline_cps_call
		 (failwith, cst_no_case_matched, cont);
		                                var res = match[1];
		                                return cont(res);
		                               }
		                               if(! param) return b(0);
		                               var l = param[2], x = param[1];
		                               return caml_trampoline_cps_call2
		                                       (x,
		v,
		function(r){
		 return r ? b(r) : caml_exact_trampoline_call1(a, l);
		});
		                              }
		                              return a(cases);
		                             }));
		                 };
		              return caml_trampoline_cps_call3
		                      (map$18,
		                       source$0,
		                       function(param, cont){
		                        var source = param[4], lift = param[2];
		                        function msgf(m, cont){
		                         return caml_trampoline_cps_call6
		                                 (m, 0, 0, Ik, pp, source, cont);
		                        }
		                        return caml_exact_trampoline_cps_call$1
		                                (debug$0,
		                                 indentation,
		                                 msgf,
		                                 function(match){
		                                  var lvl = indentation + 1 | 0;
		                                  function a(next, cont){
		                                   return caml_exact_trampoline_cps_call
		   (Arr[13],
		    next,
		    function(next){
		     return cont
		             (function(v, cont){
		               return caml_trampoline_cps_call2
		                       (lift,
		                        v,
		                        function(a){
		                         return caml_trampoline_cps_call3(map$17, a, next, cont);
		                        });
		              });
		    });
		                                  }
		                                  return caml_exact_trampoline_cps_call$0
		  (cast,
		   target,
		   source,
		   lvl,
		   function(b){
		    return caml_trampoline_cps_call3(let$15, b, a, cont);
		   });
		                                 });
		                       },
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (all$10,
		                                 a,
		                                 function(a){
		                                  return caml_trampoline_cps_call3(let$15, a, d, cont);
		                                 });
		                       });
		             }
		             if(typeof target !== "number" && 10 === target[0]){
		              var
		               cases = target[1][1],
		               b =
		                 function(param){
		                  function a(match){
		                   if(! match)
		                    return caml_exact_trampoline_cps_call$0
		                            (fail$4, 2, location, Ij, cont);
		                   var case$ = match[1];
		                   return cont([0, case$]);
		                  }
		                  if(! param) return a(0);
		                  var
		                   l = param[2],
		                   x = param[1],
		                   target = x[4],
		                   return$ = x[3];
		                  function msgf(m, cont){
		                   return caml_trampoline_cps_call8
		                           (m, 0, 0, Ii, pp, source, pp, target, cont);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (debug$0,
		                           indentation,
		                           msgf,
		                           function(match){
		                            var lvl = indentation + 1 | 0;
		                            function c(next, cont){
		                             var a = Arr[2].call(null, return$);
		                             return caml_exact_trampoline_cps_call$1
		                                     (Arr[18][1], next, a, cont);
		                            }
		                            return caml_exact_trampoline_cps_call$0
		                                    (cast,
		                                     target,
		                                     source,
		                                     lvl,
		                                     function(d){
		                                      return caml_trampoline_cps_call3
		      (let$15,
		       d,
		       c,
		       function(c){
		        var res = ok$0(c);
		        return res ? a(res) : caml_exact_trampoline_call1(b, l);
		       });
		                                     });
		                           });
		                 };
		              return b(cases);
		             }
		            }
		            if(typeof source === "number"){
		             if(4 === source)
		              return cont
		                      ([0,
		                        [0,
		                         function(param, a){
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Match_failure, Ih], 1));
		                         }]]);
		            }
		            else if(0 === source[0]){
		             var
		              value = source[2],
		              const_type = source[1],
		              c =
		                function(next, cont){
		                 var a = Arr[5].call(null, value);
		                 return caml_exact_trampoline_cps_call$1
		                         (Arr[18][1], a, next, cont);
		                };
		             return caml_exact_trampoline_cps_call$0
		                     (cast,
		                      target,
		                      const_type,
		                      indentation,
		                      function(a){
		                       return caml_trampoline_cps_call3(let$15, a, c, cont);
		                      });
		            }
		           }
		           return caml_exact_trampoline_cps_call$1
		                   (debug$0,
		                    indentation,
		                    function(m, cont){
		                     return caml_trampoline_cps_call8
		                             (m, 0, 0, If, pp_v1$0, source, pp_v1$0, target, cont);
		                    },
		                    function(match){
		                     return caml_exact_trampoline_cps_call$0
		                             (fail$4,
		                              2,
		                              location,
		                              Ig,
		                              function(a){
		                               return caml_trampoline_cps_call5
		                                       (a, pp_v1$0, source, pp_v1$0, target, cont);
		                              });
		                    });
		          },
		          cont);
		                                      });
		                            }
		                            return a(target, source);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (cast, target, source, 0, cont);
		                          }
		                          return caml_trampoline_cps_call2
		                                  (Arr[1][7],
		                                   0,
		                                   function(a){
		                                    function record(name, write, fields, cont){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$5,
		   symbol_map$5,
		   ,
		   bind$8,
		   return$9,
		   map$17,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$3]),
		                                      let$ = open[4];
		                                     function compare_elt(b, a, cont){
		                                      a = a[1];
		                                      var
		                                       valueR = a[2],
		                                       typR = a[1],
		                                       b = b[1],
		                                       valueL = b[2],
		                                       typL = b[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (equal,
		       typL,
		       typR,
		       function(match){
		        return match
		                ? caml_exact_trampoline_cps_call
		                  (comparator$1,
		                   typL,
		                   function(match){
		                    function a(Cmp){
		                     return caml_trampoline_cps_call3
		                             (Cmp[8], valueL, valueR, cont);
		                    }
		                    if(0 === match[0]){var cmp = match[1]; return a(cmp);}
		                    var e = match[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             failwith,
		                             fmt$59,
		                             function(b){
		                              return caml_trampoline_cps_call4(b, pp, typL, e, a);
		                             });
		                   })
		                : cont(-1);
		       });
		                                     }
		                                     function compare(a, b, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (compare_array_local, compare_elt, a, b, cont);
		                                     }
		                                     function sexp_of_t(param, cont){return cont(Jm);}
		                                     var
		                                      include = Make$2([0, compare, sexp_of_t]),
		                                      symbol = include[1],
		                                      symbol$0 = include[2],
		                                      symbol$1 = include[3],
		                                      symbol$2 = include[4],
		                                      symbol$3 = include[5],
		                                      symbol$4 = include[6],
		                                      equal$0 = include[7],
		                                      compare$0 = include[8],
		                                      min = include[9],
		                                      max = include[10],
		                                      ascending = include[11],
		                                      descending = include[12],
		                                      between = include[13],
		                                      clamp_exn = include[14],
		                                      clamp = include[15],
		                                      comparator = include[16];
		                                     return caml_exact_trampoline_cps_call
		     (make$19,
		      dummy,
		      function(b){
		       var
		        init =
		          [0,
		           [0,
		            [0,
		             [0,
		              0,
		              Arr[2].call(null, function(param, cont){return cont([0]);})]],
		            [0,
		             [0,
		              symbol,
		              symbol$0,
		              symbol$1,
		              symbol$2,
		              symbol$3,
		              symbol$4,
		              equal$0,
		              compare$0,
		              min,
		              max,
		              ascending,
		              descending,
		              between,
		              clamp_exn,
		              clamp,
		              comparator]],
		            0,
		            name,
		            b]];
		       function a(t, init){
		        if(t){
		         var
		          l = t[2],
		          a$0 = t[1],
		          acc = init[2],
		          i = init[1],
		          type = a$0[2][1],
		          field_name = a$0[1],
		          obj$0 = acc[1],
		          resolve$0 =
		            function(fields, cont){
		             var
		              match = caml_check_bound(fields, i)[i + 1][1],
		              v = match[2],
		              t = match[1];
		             return caml_exact_trampoline_cps_call
		                     (resolve,
		                      type,
		                      function(a){
		                       return caml_exact_trampoline_cps_call
		                               (resolve,
		                                t,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call$1
		 (equal,
		  b,
		  a,
		  function(match){
		   return match
		           ? cont(v)
		           : caml_exact_trampoline_cps_call$1
		             (kasprintf,
		              failwith,
		              fmt$60,
		              function(a){
		               return caml_trampoline_cps_call6
		                       (a, field_name, pp, t, pp, type, cont);
		              });
		  });
		                                });
		                      });
		            };
		         return caml_trampoline_cps_call3
		                 (let$,
		                  write,
		                  function(write, cont){
		                   return cont
		                           (function(fields, v, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (copy$0,
		                                      fields,
		                                      function(fields){
		                                       caml_check_bound(fields, i)[i + 1] = [0, [0, type, v]];
		                                       return caml_trampoline_cps_call2(write, fields, cont);
		                                      });
		                            });
		                  },
		                  function(field_write){
		                   var
		                    b = obj$0[5],
		                    c = obj$0[4],
		                    d = obj$0[3],
		                    e =
		                      [0,
		                       [0,
		                        1,
		                        field_name,
		                        Arr[2].call(null, resolve$0),
		                        type,
		                        field_write],
		                       d],
		                    f = obj$0[2],
		                    open =
		                      g
		                       ([0,
		                         symbol_bind$5,
		                         symbol_map$5,
		                         ,
		                         bind$8,
		                         return$9,
		                         map$17,
		                         ,
		                         ,
		                         ,
		                         ,
		                         Let_syntax$3]),
		                    let$ = open[4];
		                   return caml_trampoline_cps_call3
		                           (let$,
		                            obj$0[1],
		                            function(a, cont){
		                             var
		                              build = a[2],
		                              input_types = a[1],
		                              b =
		                                Arr[2].call
		                                 (null,
		                                  function(param, cont){
		                                   var tail = param[2], head = param[1];
		                                   return cont
		   (caml_array_concat
		     ([0, tail, [0, [0, [0, [0, type, head]]], 0]]));
		                                  }),
		                              a = Arr[12].call(null, build),
		                              c =
		                                Arr[2].call
		                                 (null,
		                                  function(param, cont){
		                                   var tail = param[2], head = param[1];
		                                   return cont([0, head, tail]);
		                                  });
		                             return caml_exact_trampoline_cps_call$1
		                                     (Arr[18][1],
		                                      c,
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (Arr[18][1],
		        a,
		        b,
		        function(a){
		         return cont([0, [0, [0, field_name, type], input_types], a]);
		        });
		                                      });
		                            },
		                            function(d){
		                             var init = [0, i + 1 | 0, [0, [0, d, f, e, c, b]]];
		                             return caml_exact_trampoline_call2(a, l, init);
		                            });
		                  });
		        }
		        var obj = init[2][1];
		        return cont([6, obj]);
		       }
		       return a(fields, [0, 0, init]);
		      });
		                                    }
		                                    var
		                                     record$0 = [0, , , , , , record][6],
		                                     Type =
		                                       [0,
		Arr,
		,
		List,
		,
		,
		,
		,
		,
		pp,
		Dump,
		,
		is_nullish,
		0,
		,
		const$,
		,
		,
		,
		,
		,
		,
		,
		function$,
		lambda,
		functions,
		1,
		2,
		,
		,
		,
		,
		5,
		option$0,
		string$0,
		,
		,
		either,
		true$,
		false$,
		Bind_parameter,
		field_get,
		field_names,
		comparator$1,
		equal_no_indentation,
		equal,
		resolve,
		,
		,
		cast,
		,
		,
		,
		record$0];
		                                    function to_bool_compare(parent_name, location, param, cont){
		                                     var cmp = param[3], t = param[2], kind = param[1];
		                                     if(0 === kind[0]){
		                                      var to_bool = kind[1];
		                                      return cont
		      ([0,
		        function(x, y, cont){
		         return caml_trampoline_cps_call3
		                 (cmp,
		                  x,
		                  y,
		                  function(a){
		                   return caml_trampoline_cps_call2(to_bool, a, cont);
		                  });
		        }]);
		                                     }
		                                     var a = Type[10][1];
		                                     return caml_exact_trampoline_cps_call$0
		     (fail$4,
		      2,
		      location,
		      JS,
		      function(b){
		       return caml_trampoline_cps_call4(b, parent_name, a, t, cont);
		      });
		                                    }
		                                    function to_bool_opt_compare(param){
		                                     var cmp = param[3], kind = param[1];
		                                     if(0 === kind[0]){
		                                      var to_bool = kind[1];
		                                      return function(x, y, cont){
		                                       return caml_trampoline_cps_call3
		       (cmp,
		        x,
		        y,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (to_bool, a, function(a){return cont([0, a]);});
		        });};
		                                     }
		                                     var to_bool_opt = kind[1];
		                                     return function(x, y, cont){
		                                      return caml_trampoline_cps_call3
		      (cmp,
		       x,
		       y,
		       function(a){
		        return caml_trampoline_cps_call2(to_bool_opt, a, cont);
		       });};
		                                    }
		                                    function compile_compare(location, t, op, cont){
		                                     var
		                                      open = g(include$0),
		                                      and = open[18],
		                                      let$ = open[17],
		                                      let$0 = open[14];
		                                     function compile_compare(t, cont){
		                                      function a(t){
		                                       function of_comparable(comparable, cont){
		return caml_trampoline_cps_call2
		        (of_string$14,
		         [0,
		          [0, function(a, cont){return cont(a);}],
		          0,
		          function(lhs, rhs, cont){
		           switch(op - 1 | 0){
		             case 1:
		              return caml_trampoline_cps_call3
		                      (comparable[4], lhs, rhs, cont);
		             case 2:
		              return caml_trampoline_cps_call3
		                      (comparable[1], lhs, rhs, cont);
		             case 4:
		              return caml_trampoline_cps_call3
		                      (comparable[5], lhs, rhs, cont);
		             case 5:
		              return caml_trampoline_cps_call3
		                      (comparable[2], lhs, rhs, cont);
		             case 6:
		              return caml_trampoline_cps_call3
		                      (comparable[6], lhs, rhs, cont);
		             default:
		              return caml_trampoline_cps_call3
		                      (comparable[3], lhs, rhs, cont);
		           }
		          }],
		         cont);
		                                       }
		                                       if(typeof t === "number")
		switch(t){
		  case 0:
		   return caml_exact_trampoline_cps_call
		           (of_comparable,
		            [0,
		             symbol$10,
		             symbol$6,
		             symbol$8,
		             symbol$9,
		             symbol$5,
		             symbol$7],
		            cont);
		  case 1:
		   return caml_exact_trampoline_cps_call
		           (of_comparable,
		            [0,
		             function(b, a, cont){return cont(caml_greaterequal(b, a));},
		             function(b, a, cont){return cont(caml_lessequal(b, a));},
		             function(b, a, cont){return cont(caml_equal(b, a));},
		             function(b, a, cont){return cont(caml_greaterthan(b, a));},
		             function(b, a, cont){return cont(caml_lessthan(b, a));},
		             function(b, a, cont){return cont(caml_notequal(b, a));}],
		            cont);
		  case 2:
		   return caml_exact_trampoline_cps_call
		           (of_comparable,
		            [0,
		             function(b, a, cont){return cont(a <= b ? 1 : 0);},
		             function(b, a, cont){return cont(b <= a ? 1 : 0);},
		             function(b, a, cont){return cont(b === a ? 1 : 0);},
		             function(b, a, cont){return cont(a < b ? 1 : 0);},
		             function(b, a, cont){return cont(b < a ? 1 : 0);},
		             function(b, a, cont){return cont(b !== a ? 1 : 0);}],
		            cont);
		  case 3:
		   return caml_exact_trampoline_cps_call$0
		           (fail$4, 2, location, JT, cont);
		  case 4:
		   return cont
		           ([0,
		             [0,
		              [0,
		               function(a, cont){
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Match_failure, JV], 1));
		               }],
		              4,
		              function(a, cont){
		               a = caml_pop_trap();
		               return a
		                       (caml_maybe_attach_backtrace([0, Match_failure, JU], 1));
		              }]]);
		  default:
		   switch(op - 1 | 0){
		     case 1:
		     case 4:
		     case 6:
		      var
		       b =
		         [0,
		          [0, function(param, cont){return cont(0);}],
		          Type[39],
		          function(a, param, cont){return cont(0);}];
		      break;
		     default:
		      b =
		       [0,
		        [0, function(param, cont){return cont(1);}],
		        Type[38],
		        function(a, param, cont){return cont(0);}];
		   }
		   return cont([0, b]);
		}
		                                       switch(t[0]){
		 case 0:
		  return caml_exact_trampoline_cps_call
		          (of_comparable,
		           [0,
		            symbol$17,
		            symbol$18,
		            symbol$19,
		            symbol$20,
		            symbol$21,
		            symbol$22],
		           cont);
		 case 1:
		  var t$0 = t[1], b = caml_obj_tag(t$0);
		  if(250 === b) return caml_exact_trampoline_call1(a, t$0[1]);
		  if(246 !== b && 244 !== b)
		   return caml_exact_trampoline_call1(a, t$0);
		  return caml_exact_trampoline_cps_call
		          (force_lazy_block, t$0, a);
		 case 2:
		  return caml_exact_trampoline_cps_call$0
		          (fail$4, 2, location, JW, cont);
		 case 3:
		  var data = t[1];
		  return caml_exact_trampoline_cps_call
		          (compare_list, data, cont);
		 case 4:
		  var data$0 = t[3];
		  return caml_exact_trampoline_cps_call
		          (compare_map, data$0, cont);
		 case 5:
		  var type = t[2];
		  return caml_exact_trampoline_call1(a, type);
		 case 6:
		  b = t[1];
		  var match = b[2];
		  if(match){
		   var comparable = match[1];
		   return caml_exact_trampoline_cps_call
		           (of_comparable, comparable, cont);
		  }
		  var
		   name = b[4],
		   e =
		     function(a, b, cont){
		      return caml_exact_trampoline_cps_call$2
		              (option, 0, pp_print_string, a, b, cont);
		     };
		  return caml_exact_trampoline_cps_call$0
		          (fail$4,
		           2,
		           location,
		           JX,
		           function(a){
		            return caml_trampoline_cps_call3(a, e, name, cont);
		           });
		 case 7:
		  return caml_exact_trampoline_cps_call$0
		          (fail$4, 2, location, JY, cont);
		 case 8:
		  return caml_exact_trampoline_cps_call
		          (of_comparable,
		           [0,
		            symbol$16,
		            symbol$12,
		            symbol$14,
		            symbol$15,
		            symbol$11,
		            symbol$13],
		           cont);
		 case 9:
		  return caml_exact_trampoline_cps_call$0
		          (fail$4, 2, location, JZ, cont);
		 case 10:
		  var cases = t[1][1];
		  if(1 !== op && 7 !== op){
		   var
		    init$0 = [0, function(a, param, cont){return cont(0);}],
		    g =
		      function(compare, cont){
		       return caml_exact_trampoline_cps_call
		               (Type[33],
		                0,
		                function(a){
		                 return cont
		                         ([0, [1, function(a, cont){return cont(a);}], a, compare]);
		                });
		      },
		    d =
		      function(a){
		       return caml_exact_trampoline_cps_call$1(let$, a, g, cont);
		      };
		   return cases
		           ? caml_exact_trampoline_cps_call
		             (of_rev_keys,
		              cases,
		              function(t){
		               function a(t, init){
		                if(! t) return d(init);
		                var l = t[2], a$0 = t[1], type = a$0[4], lift = a$0[2];
		                function b(param, cont){
		                 var cmp = param[2], next = param[1];
		                 return cont
		                         (function(lhs, rhs, cont){
		                           return caml_trampoline_cps_call2
		                                   (lift,
		                                    lhs,
		                                    function(match){
		                                     return caml_trampoline_cps_call2
		     (lift,
		      rhs,
		      function(match$0){
		       if(! match)
		        return match$0
		                ? caml_trampoline_cps_call3(next, lhs, rhs, cont)
		                : caml_trampoline_cps_call3(next, lhs, rhs, cont);
		       var lhs$0 = match[1];
		       if(! match$0)
		        return caml_trampoline_cps_call3(next, lhs, rhs, cont);
		       var rhs$0 = match$0[1], cmp$0 = to_bool_opt_compare(cmp);
		       return caml_exact_trampoline_cps_call$1
		               (cmp$0, lhs$0, rhs$0, cont);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (compile_compare,
		                         type,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$1
		                                  (and,
		                                   init,
		                                   c,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$1
		    (let$,
		     c,
		     b,
		     function(init){
		      return caml_exact_trampoline_call2(a, l, init);
		     });
		                                   });
		                         });
		               }
		               return a(t, init$0);
		              })
		           : d(init$0);
		  }
		  var
		   init =
		     [0,
		      function(a, param, cont){
		       return caml_exact_trampoline_cps_call
		               (failwith,
		                "no case matched while trying to compare two variants",
		                cont);
		      }],
		   f =
		     function(compare, cont){
		      return cont
		              ([0, [0, function(a, cont){return cont(a);}], 0, compare]);
		     },
		   c =
		     function(a){
		      return caml_exact_trampoline_cps_call$1(let$, a, f, cont);
		     };
		  return cases
		          ? caml_exact_trampoline_cps_call
		            (of_rev_keys,
		             cases,
		             function(t){
		              function a(t, init){
		               if(! t) return c(init);
		               var l = t[2], a$0 = t[1], type = a$0[4], lift = a$0[2];
		               return caml_exact_trampoline_cps_call$1
		                       (let$,
		                        init,
		                        function(next, cont){
		                         return cont
		                                 (function(lhs, rhs, cont){
		                                   return caml_trampoline_cps_call2
		   (lift,
		    lhs,
		    function(match){
		     return caml_trampoline_cps_call2
		             (lift,
		              rhs,
		              function(match$0){
		               if(match){
		                if(match$0){
		                 var
		                  rhs$0 = match$0[1],
		                  lhs$0 = match[1],
		                  a =
		                    function(cmp, cont){
		                     function a(cmp, cont){
		                      return caml_trampoline_cps_call3(cmp, lhs$0, rhs$0, cont);
		                     }
		                     return caml_exact_trampoline_cps_call$0
		                             (to_bool_compare,
		                              cst_variant,
		                              location,
		                              cmp,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                              });
		                    };
		                 return caml_exact_trampoline_cps_call
		                         (compile_compare,
		                          type,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$0,
		                                    b,
		                                    a,
		                                    function(a){return cont(value$4(ok$0(a), 0));});
		                          });
		                }
		               }
		               else if(! match$0)
		                return caml_trampoline_cps_call3(next, lhs, rhs, cont);
		               return cont(7 === op ? 1 : 0);
		              });
		    });
		                                  });
		                        },
		                        function(init){
		                         return caml_exact_trampoline_call2(a, l, init);
		                        });
		              }
		              return a(t, init);
		             })
		          : c(init);
		 default:
		  var
		   view = t[3],
		   repr = t[2],
		   h =
		     function(param, cont){
		      var compare = param[3], res = param[2], kind = param[1];
		      return cont
		              ([0,
		                kind,
		                res,
		                function(lhs, rhs, cont){
		                 return caml_trampoline_cps_call2
		                         (view,
		                          rhs,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (view,
		                                    lhs,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(compare, b, a, cont);
		                                    });
		                          });
		                }]);
		     };
		  return caml_exact_trampoline_cps_call
		          (compile_compare,
		           repr,
		           function(a){
		            return caml_exact_trampoline_cps_call$1(let$, a, h, cont);
		           });
		                                       }
		                                      }
		                                      return a(t);
		                                     }
		                                     function compare_map(data, cont){
		                                      if(1 === op){
		                                       var
		a =
		  function(cmp, cont){
		   function a(cmp, cont){
		    return cont
		            ([0,
		              [0, function(a, cont){return cont(a);}],
		              0,
		              function(l, param, cont){
		               return caml_exact_trampoline_cps_call$0
		                       (equal$11, cmp, l, param, cont);
		              }]);
		   }
		   return caml_exact_trampoline_cps_call$0
		           (to_bool_compare,
		            cst_map,
		            location,
		            cmp,
		            function(b){
		             return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		            });
		  };
		                                       return caml_exact_trampoline_cps_call
		       (compile_compare,
		        data,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		        });
		                                      }
		                                      if(7 !== op)
		                                       return caml_exact_trampoline_cps_call$0
		       (fail$4, 2, location, J0, cont);
		                                      function b(cmp, cont){
		                                       function a(cmp, cont){
		return cont
		        ([0,
		          [0, function(a, cont){return cont(a);}],
		          0,
		          function(l, param, cont){
		           return caml_exact_trampoline_cps_call$0
		                   (equal$11,
		                    function(l, r, cont){
		                     return caml_trampoline_cps_call3
		                             (cmp, l, r, function(a){return cont(1 - a);});
		                    },
		                    l,
		                    param,
		                    function(a){return cont(1 - a);});
		          }]);
		                                       }
		                                       return caml_exact_trampoline_cps_call$0
		       (to_bool_compare,
		        cst_map,
		        location,
		        cmp,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (compile_compare,
		       data,
		       function(a){
		        return caml_exact_trampoline_cps_call$1(let$0, a, b, cont);
		       });
		                                     }
		                                     function compare_list(t, cont){
		                                      if(1 === op){
		                                       var
		a =
		  function(cmp, cont){
		   function a(cmp, cont){
		    return cont
		            ([0,
		              [0, function(a, cont){return cont(a);}],
		              0,
		              function(x, y, cont){
		               return caml_exact_trampoline_cps_call$0
		                       (equal_with_local_closure, cmp, x, y, cont);
		              }]);
		   }
		   return caml_exact_trampoline_cps_call$0
		           (to_bool_compare,
		            cst_list,
		            location,
		            cmp,
		            function(b){
		             return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		            });
		  };
		                                       return caml_exact_trampoline_cps_call
		       (compile_compare,
		        t,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		        });
		                                      }
		                                      if(7 !== op)
		                                       return caml_exact_trampoline_cps_call$0
		       (fail$4, 2, location, J1, cont);
		                                      function b(cmp, cont){
		                                       function a(cmp, cont){
		return cont
		        ([0,
		          [0, function(a, cont){return cont(a);}],
		          0,
		          function(t1, t2, cont){
		           function a(t1$0, t2$0){
		            function b(a){return cont(1 - a);}
		            if(t1$0){
		             if(t2$0){
		              var t2 = t2$0[2], x2 = t2$0[1], t1 = t1$0[2], x1 = t1$0[1];
		              return caml_trampoline_cps_call3
		                      (cmp,
		                       x1,
		                       x2,
		                       function(c){
		                        c = 1 - c;
		                        return c ? caml_exact_trampoline_call2(a, t1, t2) : b(c);
		                       });
		             }
		            }
		            else if(! t2$0) return b(1);
		            return b(0);
		           }
		           return a(t1, t2);
		          }]);
		                                       }
		                                       return caml_exact_trampoline_cps_call$0
		       (to_bool_compare,
		        cst_list,
		        location,
		        cmp,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (compile_compare,
		       t,
		       function(a){
		        return caml_exact_trampoline_cps_call$1(let$0, a, b, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (compile_compare, t, cont);
		                                    }
		                                    var Arr$0 = Type[1];
		                                    function nullable(type, cont){
		                                     function a(type){
		                                      var
		                                       b = Arr$0[1],
		                                       b = g([0, b[3], b[4], , b[6], b[7], b[8], , , , , b[13]]),
		                                       let$ = b[3],
		                                       symbol_map = b[2];
		                                      if(typeof type !== "number")
		                                       switch(type[0]){
		 case 1:
		  var t = type[1], b = caml_obj_tag(t);
		  if(250 === b) return caml_exact_trampoline_call1(a, t[1]);
		  if(246 !== b && 244 !== b)
		   return caml_exact_trampoline_call1(a, t);
		  return caml_exact_trampoline_cps_call
		          (force_lazy_block, t, a);
		 case 5:
		  var type$0 = type[2];
		  return caml_exact_trampoline_call1(a, type$0);
		 case 10:
		  var
		   cases = type[1][1],
		   c =
		     function(t, init){
		      if(t){
		       var l = t[2], a = t[1], type$1 = a[4];
		       if(typeof init === "number")
		        return 870530776 <= init
		                ? caml_exact_trampoline_cps_call
		                  (Type[12],
		                   type$1,
		                   function(b){
		                    return b
		                            ? caml_exact_trampoline_call2(c, l, 870530776)
		                            : caml_exact_trampoline_call2(c, l, [0, 925978388, a]);
		                   })
		                : caml_exact_trampoline_call2(c, l, -197222864);
		       var b = init[2];
		       return caml_exact_trampoline_cps_call
		               (Type[12],
		                type$1,
		                function(a){
		                 return a
		                         ? caml_exact_trampoline_call2(c, l, [0, 925978388, b])
		                         : caml_exact_trampoline_call2(c, l, -197222864);
		                });
		      }
		      if(typeof init === "number"){
		       var
		        apply_type = function(t, cont){return cont(t);},
		        apply = function(f, cont){return cont(f);},
		        apply$0 = function(f, cont){return cont(f);},
		        applyM = function(f, cont){return cont(f);};
		       return cont([0, type, apply_type, apply, apply$0, applyM]);
		      }
		      var match = init[2], type$0 = match[4], lift = match[2];
		      return caml_exact_trampoline_cps_call
		              (nullable,
		               type$0,
		               function(Probe){
		                var type = Probe[1];
		                function apply_type(t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Probe[2],
		                          t,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(Type[33], a, cont);
		                          });
		                }
		                function apply(f, cont){
		                 var a = Arr$0[2].call(null, return$9);
		                 return caml_exact_trampoline_cps_call
		                         (Probe[4],
		                          f,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Arr$0[18][1],
		                                    b,
		                                    a,
		                                    function(c){
		                                     var
		                                      a = Arr$0[7],
		                                      b =
		Arr$0[2].call
		 (null,
		  function(param, cont){
		   var sideload = param[2], v = param[1];
		   return caml_trampoline_cps_call2
		           (lift,
		            v,
		            function(match){
		             if(! match) return cont(Jn);
		             var v = match[1];
		             return cont([1, [0, v, sideload]]);
		            });
		  });
		                                     return caml_exact_trampoline_cps_call$0
		     (Arr$0[16], b, a, c, cont);
		                                    });
		                          });
		                }
		                function apply$0(f, cont){
		                 var
		                  a =
		                    Arr$0[2].call
		                     (null, function(x, cont){return cont([0, x, 0]);}),
		                  b = Arr$0[2].call(null, calendar);
		                 return caml_exact_trampoline_cps_call$1
		                         (Arr$0[18][2],
		                          f,
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (apply,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (Arr$0[18][2], b, a, cont);
		                                    });
		                          });
		                }
		                function applyM(f, v, cont){
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          v,
		                          function(v, cont){
		                           return caml_trampoline_cps_call2
		                                   (lift,
		                                    v,
		                                    function(match){
		                                     if(! match)
		                                      return caml_trampoline_cps_call2(Arr$0[1][7], 0, cont);
		                                     var v = match[1];
		                                     return caml_trampoline_cps_call2
		     (Arr$0[1][7],
		      v,
		      function(a){
		       return caml_trampoline_cps_call3
		               (Probe[5],
		                f,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (symbol_map, a, return$9, cont);
		                });
		      });
		                                    });
		                          },
		                          cont);
		                }
		                return cont([0, type, apply_type, apply$0, apply, applyM]);
		               });
		     };
		  return c(cases, 870530776);
		 case 11:
		  var view = type[3], repr = type[2];
		  return caml_exact_trampoline_cps_call
		          (nullable,
		           repr,
		           function(Probe){
		            var type = Probe[1];
		            function apply_type(t, cont){
		             return caml_exact_trampoline_cps_call(Probe[2], t, cont);
		            }
		            function apply(f, cont){
		             return caml_exact_trampoline_cps_call
		                     (Probe[3],
		                      f,
		                      function(b){
		                       var a = Arr$0[2].call(null, view);
		                       return caml_exact_trampoline_cps_call$1
		                               (Arr$0[18][1], a, b, cont);
		                      });
		            }
		            function apply$0(f, cont){
		             return caml_exact_trampoline_cps_call
		                     (Probe[4],
		                      f,
		                      function(b){
		                       var
		                        a = Arr$0[2].call(null, view),
		                        a = Arr$0[11].call(null, a);
		                       return caml_exact_trampoline_cps_call$1
		                               (Arr$0[18][1], a, b, cont);
		                      });
		            }
		            function applyM(f, x, cont){
		             return caml_trampoline_cps_call3
		                     (Arr$0[1][8],
		                      x,
		                      view,
		                      function(a){
		                       return caml_trampoline_cps_call3(Probe[5], f, a, cont);
		                      });
		            }
		            return cont([0, type, apply_type, apply, apply$0, applyM]);
		           });
		                                       }
		                                      function apply_type(t, cont){return cont(t);}
		                                      function apply(f, cont){return cont(f);}
		                                      function apply$0(f, cont){return cont(f);}
		                                      function applyM(f, cont){return cont(f);}
		                                      return cont([0, type, apply_type, apply, apply$0, applyM]);
		                                     }
		                                     return a(type);
		                                    }
		                                    function pure(x, param, cont){return cont([0, x]);}
		                                    function fresh_pure(param, cont){
		                                     return caml_exact_trampoline_cps_call
		     (opaque,
		      "abstract",
		      function(x){
		       return cont(function(param, cont){return cont([0, x]);});
		      });
		                                    }
		                                    function get(type, name, values, cont){
		                                     var match = name();
		                                     if(0 === match[0]){
		                                      var name$0 = match[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       values[1],
		       name$0,
		       function(a){
		        if(! a)
		         return caml_exact_trampoline_cps_call$1
		                 (kasprintf,
		                  failwith,
		                  fmt$62,
		                  function(a){
		                   return caml_trampoline_cps_call3(a, pp_quoted, name$0, cont);
		                  });
		        a = a[1][1];
		        var v = a[2], t = a[1];
		        return caml_exact_trampoline_cps_call$1
		                (Type[45],
		                 type,
		                 t,
		                 function(match){
		                  if(match) return cont(v);
		                  var a = Type[9], b = Type[9];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           failwith,
		                           fmt$61,
		                           function(c){
		                            return caml_trampoline_cps_call5(c, b, t, a, type, cont);
		                           });
		                 });
		       });
		                                     }
		                                     var name$1 = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      values[2],
		      name$1,
		      function(a){
		       if(! a)
		        return caml_exact_trampoline_cps_call$1
		                (kasprintf,
		                 failwith,
		                 fmt$64,
		                 function(a){
		                  return caml_trampoline_cps_call3(a, pp_quoted, name$1, cont);
		                 });
		       a = a[1][1];
		       var v = a[2], t = a[1];
		       return caml_exact_trampoline_cps_call$1
		               (Type[45],
		                type,
		                t,
		                function(match){
		                 if(match) return cont(v);
		                 var a = Type[9], b = Type[9];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          failwith,
		                          fmt$63,
		                          function(c){
		                           return caml_trampoline_cps_call5(c, b, t, a, type, cont);
		                          });
		                });
		      });
		                                    }
		                                    function getf(type, name, cont){
		                                     return caml_trampoline_cps_call2
		     (name,
		      0,
		      function(match){
		       if(0 === match[0]){
		        var name = match[1], a = function(param){return [0, name];};
		        return cont
		                (Type[1][2].call
		                  (null,
		                   function(b, cont){
		                    return caml_exact_trampoline_cps_call$0
		                            (get, type, a, b, cont);
		                   }));
		       }
		       var name$0 = match[1];
		       function b(param){return [1, name$0];}
		       return cont
		               (Type[1][4].call
		                 (null,
		                  function(a, cont){
		                   return caml_exact_trampoline_cps_call$0
		                           (get, type, b, a, cont);
		                  }));
		      });
		                                    }
		                                    function add(name, typ, value, values, cont){
		                                     return caml_trampoline_cps_call2
		     (name,
		      0,
		      function(match){
		       if(0 === match[0]){
		        var name = match[1], a = values[2];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 values[1],
		                 name,
		                 [0, [0, typ, value]],
		                 function(b){return cont([0, b, a]);});
		       }
		       var name$0 = match[1];
		       return caml_exact_trampoline_cps_call$0
		               (set$3,
		                values[2],
		                name$0,
		                [0, [0, typ, value]],
		                function(a){return cont([0, values[1], a]);});
		      });
		                                    }
		                                    function addf(name){
		                                     return Type[1][2].call
		     (null,
		      function(param, cont){
		       var value = param[3], typ = param[2], values = param[1];
		       return caml_exact_trampoline_cps_call$2
		               (add, name, typ, value, values, cont);
		      });
		                                    }
		                                    function return$(type, v){
		                                     return [0, type, Arr[5].call(null, v)];
		                                    }
		                                    var Arr$1 = Type[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (of_alist_exn$1,
		     [0, comparator$13],
		     [0,
		      [0, [0, cst_bool], Jw],
		      [0,
		       [0, [0, cst_int], Jv],
		       [0,
		        [0, [0, cst_float], Ju],
		        [0, [0, [0, cst_string], Jt], 0]]]],
		     function(a){
		      var empty = [0, empty$11([0, comparator$13]), a];
		      function add$0(opt, key, type, get, bindings, cont){
		       var
		        overwrite = opt ? opt[1] : 1,
		        data = [0, type, get],
		        b = bindings[2];
		       function a(a){return cont([0, a, b]);}
		       return overwrite
		               ? caml_exact_trampoline_cps_call$0
		                 (set$3, bindings[1], key, data, a)
		               : caml_exact_trampoline_cps_call$0
		                 (update$0,
		                  bindings[1],
		                  key,
		                  function(a, cont){return cont(value$4(a, data));},
		                  a);
		      }
		      function add$1(overwrite, name, t, get, bindings, cont){
		       var a = Arr$1[5].call(null, 0);
		       return caml_exact_trampoline_cps_call$1
		               (Arr$1[18][1],
		                a,
		                get,
		                function(a){
		                 return caml_exact_trampoline_cps_call$3
		                         (add$0, overwrite, name, t, a, bindings, cont);
		                });
		      }
		      function find(name, bindings, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id, bindings[1], name, cont);
		      }
		      function find_type(name, bindings, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id, bindings[2], name, cont);
		      }
		      function values(param, cont){
		       var
		        values = param[1],
		        open =
		          g
		           ([0,
		             symbol_bind$2,
		             symbol_map$2,
		             ,
		             bind$5,
		             return$6,
		             map$11,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$1]),
		        let$ = open[4];
		       function a(param, cont){
		        var type = param[2][1], name = param[1];
		        return cont([0, name, [0, type]]);
		       }
		       return caml_exact_trampoline_cps_call$2
		               (to_sequence$2,
		                0,
		                0,
		                0,
		                values,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$3
		              (add$1,
		               Jx,
		               [0, cst_true],
		               0,
		               Arr$1[5].call(null, 1),
		               empty,
		               function(a){
		                return caml_exact_trampoline_cps_call$3
		                        (add$1,
		                         Jy,
		                         [0, cst_false],
		                         0,
		                         Arr$1[5].call(null, 0),
		                         a,
		                         function(b){
		                          var
		                           a =
		                             Arr$1[5].call
		                              (null,
		                               [0,
		                                function(param, cont){
		                                 var rhs = param[2][1], lhs = param[1];
		                                 return cont(caml_int64_add(lhs, rhs));
		                                },
		                                [0,
		                                 function(param, cont){
		                                  var rhs = param[2][1], lhs = param[1];
		                                  return cont(lhs + rhs);
		                                 },
		                                 [0,
		                                  function(param, cont){
		                                   var rhs = param[2][1], lhs = param[1];
		                                   return cont(lhs + rhs);
		                                  },
		                                  [0,
		                                   function(param, cont){
		                                    var rhs = param[2][1], lhs = param[1];
		                                    if(lhs && rhs){
		                                     var s2 = rhs[1], s1 = lhs[1];
		                                     return cont([0, s1 + s2]);
		                                    }
		                                    return cont(0);
		                                   },
		                                   0]]]]);
		                          return caml_exact_trampoline_cps_call
		                                  (Type[33],
		                                   Jz,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (Type[33],
		     JA,
		     function(e){
		      var d = [0, e, 0];
		      return caml_exact_trampoline_cps_call
		              (Type[33],
		               JB,
		               function(e){
		                e = [0, Type[24].call(null, [0, e, d], c), 0];
		                e = [0, Type[24].call(null, JD, JC), e];
		                e = [0, Type[24].call(null, JE, 2), e];
		                e = [0, Type[24].call(null, JF, 1), e];
		                return caml_exact_trampoline_cps_call$3
		                        (add$1,
		                         JG,
		                         [0, cst$32],
		                         Type[25].call(null, e),
		                         a,
		                         b,
		                         function(b){
		                          var
		                           a =
		                             Arr$1[5].call
		                              (null,
		                               [0,
		                                function(param, cont){
		                                 var bool = param[1];
		                                 return cont(1 - bool);
		                                },
		                                0]);
		                          return caml_exact_trampoline_cps_call$3
		                                  (add$1,
		                                   JI,
		                                   [0, cst$20],
		                                   Type[23].call(null, JH, 0),
		                                   a,
		                                   b,
		                                   function(b){
		                                    var
		                                     a =
		                                       Arr$1[5].call
		(null,
		 [0,
		  function(param, cont){
		   var f = param[1];
		   return cont(caml_int64_of_float(Math.floor(f)));
		  },
		  0]);
		                                    return caml_exact_trampoline_cps_call$3
		    (add$1,
		     JK,
		     [0, "floor"],
		     Type[23].call(null, JJ, 1),
		     a,
		     b,
		     function(a){
		      return caml_exact_trampoline_cps_call$3
		              (add$1,
		               JP,
		               [0, cst_length],
		               [2,
		                [0,
		                 [0,
		                  function(param, cont){
		                   var data = param[1];
		                   return cont([0, [3, data, 0], 0]);
		                  },
		                  JO,
		                  function(param, cont){return cont(1);}],
		                 [0,
		                  [0,
		                   function(param, cont){return cont(JN);},
		                   0,
		                   function(param, cont){return cont(5);}],
		                  [0,
		                   [0,
		                    function(param, cont){
		                     var data = param[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (Type[37],
		                              [3, data, 0],
		                              5,
		                              function(a){return cont([0, a, 0]);});
		                    },
		                    JM,
		                    function(param, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (Type[37], 1, 5, cont);
		                    }],
		                   [0,
		                    [0,
		                     function(param, cont){
		                      var data = param[2][1], key = param[1];
		                      return caml_exact_trampoline_cps_call
		                              (make$19,
		                               dummy,
		                               function(a){
		                                return cont
		([0,
		  [4,
		   0,
		   [0,
		    symbol$17,
		    symbol$18,
		    symbol$19,
		    symbol$20,
		    symbol$21,
		    symbol$22,
		    equal$5,
		    compare$8,
		    min$8,
		    max$8,
		    ascending$3,
		    descending$3,
		    between,
		    clamp_exn,
		    clamp,
		    comparator],
		   data,
		   key,
		   0,
		   0,
		   a],
		  0]);
		                               });
		                     },
		                     JL,
		                     function(param, cont){return cont(1);}],
		                    0]]]]],
		               Arr$1[5].call
		                (null,
		                 [0,
		                  function(param, cont){
		                   var l = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (length$1,
		                            l,
		                            function(a){return cont(caml_int64_of_int32(a));});
		                  },
		                  [0,
		                   function(param, cont){
		                    var null$ = param[1];
		                    return cont(null$);
		                   },
		                   [0,
		                    function(a, cont){
		                     a = a[1];
		                     if(0 === a[0]){
		                      var l = a[1];
		                      return caml_exact_trampoline_cps_call
		                              (length$1,
		                               l,
		                               function(a){
		                                var x = caml_int64_of_int32(a);
		                                return cont([0, x]);
		                               });
		                     }
		                     var null$ = a[1];
		                     return cont([1, null$]);
		                    },
		                    [0,
		                     function(param, cont){
		                      var t = param[1];
		                      return cont(caml_int64_of_int32(t[3]));
		                     },
		                     0]]]]),
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$3
		                        (add$1,
		                         JR,
		                         [0, cst_head],
		                         [2,
		                          [0,
		                           [0,
		                            function(param, cont){
		                             var t = param[1];
		                             return cont([0, [3, t, 0], 0]);
		                            },
		                            JQ,
		                            function(param, cont){
		                             var t = param[1];
		                             return caml_exact_trampoline_cps_call(Type[33], t, cont);
		                            }],
		                           0]],
		                         Arr$1[5].call
		                          (null,
		                           [0,
		                            function(param, cont){
		                             var l = param[1];
		                             return caml_exact_trampoline_cps_call(hd$0, l, cont);
		                            },
		                            0]),
		                         a,
		                         function(standard){
		                          function compile_type(a, name, type, cont){
		                           var
		                            bindings = a ? a[1] : empty,
		                            Fail = [248, "Fail", caml_fresh_oo_id()];
		                           function fail(location, fmt, cont){
		                            function f(s, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (of_message$0,
		                                      2,
		                                      location,
		                                      J2,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        s,
		        function(a){
		         var raise = caml_pop_trap();
		         return raise(caml_maybe_attach_backtrace([0, Fail, a], 1));
		        });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf, f, fmt, cont);
		                           }
		                           function compile_type(bindings, self, param, cont){
		                            if(typeof param === "number") return cont(J3);
		                            switch(param[0]){
		                              case 0:
		                               var id = param[1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (equal_option,
		equal$47,
		[0, id[1]],
		name,
		function(a){
		 return a
		         ? cont
		           ([0,
		             [1,
		              [246,
		               function(a, cont){
		                a = caml_obj_tag(self);
		                function b(match){var t = match[1]; return cont(t);}
		                if(250 === a) return b(self[1]);
		                if(246 !== a && 244 !== a) return b(self);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, self, b);
		               }]]])
		         : caml_exact_trampoline_cps_call$1
		           (find_type,
		            id[1],
		            bindings,
		            function(match){
		             if(match){var type = match[1]; return cont(type);}
		             var a = id[1];
		             return caml_exact_trampoline_cps_call$1
		                     (fail,
		                      id[2],
		                      J4,
		                      function(b){
		                       return caml_trampoline_cps_call3(b, pp_quoted, a, cont);
		                      });
		            });
		});
		                              case 1:
		                               var value = param[1]; return cont([0, [0, 1, value]]);
		                              case 2:
		                               var value$0 = param[1]; return cont([0, [0, 2, value$0]]);
		                              case 3:
		                               var data = param[1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (compile_type,
		bindings,
		self,
		data[1],
		function(match){
		 var data = match[1];
		 return cont([0, [3, data, 0]]);
		});
		                              case 4:
		                               var data$0 = param[2], key = param[1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (compile_type,
		bindings,
		self,
		key[1],
		function(match){
		 var key = match[1];
		 return caml_exact_trampoline_cps_call$0
		         (compile_type,
		          bindings,
		          self,
		          data$0[1],
		          function(match){
		           var data = match[1];
		           return caml_exact_trampoline_cps_call
		                   (Type[43],
		                    key,
		                    function(match){
		                     function a(Comparable){
		                      return caml_exact_trampoline_cps_call
		                              (make$19,
		                               dummy,
		                               function(a){
		                                return cont([0, [4, 0, Comparable, data, key, 0, 0, a]]);
		                               });
		                     }
		                     if(0 === match[0]){var cmp = match[1]; return a(cmp);}
		                     var e = match[1], b = Type[9];
		                     return caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              failwith,
		                              fmt$65,
		                              function(c){
		                               return caml_trampoline_cps_call4(c, b, key, e, a);
		                              });
		                    });
		          });
		});
		                              case 5:
		                               var fields = param[1];
		                               return caml_trampoline_cps_call3
		                                       (map$18,
		fields,
		function(param, cont){
		 var type = param[2], name = param[1];
		 return caml_exact_trampoline_cps_call$0
		         (compile_type,
		          bindings,
		          self,
		          type[1],
		          function(a){return cont([0, name[1], a]);});
		},
		function(fields){
		 return caml_exact_trampoline_cps_call$0
		         (Type[53], 0, 0, fields, function(a){return cont([0, a]);});
		});
		                              case 6:
		                               var value$1 = param[1]; return cont([0, [0, J5, value$1]]);
		                              default:
		                               var cases = param[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (mapi$0,
		cases,
		function(index, type, cont){
		 return caml_exact_trampoline_cps_call$0
		         (compile_type,
		          bindings,
		          self,
		          type,
		          function(match){
		           var type = match[1];
		           return cont
		                   ([0,
		                     0,
		                     function(param, cont){
		                      var
		                       match = param[2][1],
		                       value = match[2],
		                       case_type = match[1];
		                      return param[1] !== index
		                              ? cont(0)
		                              : caml_exact_trampoline_cps_call$1
		                                (Type[45],
		                                 case_type,
		                                 type,
		                                 function(match){
		                                  if(match) return cont([0, value]);
		                                  var a = Type[9], b = Type[9];
		                                  return caml_exact_trampoline_cps_call$1
		  (kasprintf,
		   failwith,
		   fmt$66,
		   function(c){
		    return caml_trampoline_cps_call5
		            (c, b, case_type, a, type, cont);
		   });
		                                 });
		                     },
		                     function(value, cont){
		                      return cont([0, index, [0, [0, type, value]]]);
		                     },
		                     type]);
		          });
		},
		function(cases){
		 return caml_exact_trampoline_cps_call
		         (make$19,
		          dummy,
		          function(a){return cont([0, [10, [0, cases, a]]]);});
		});
		                            }
		                           }
		                           var res = [];
		                           caml_update_dummy
		                            (res,
		                             [246,
		                              function(a, cont){
		                               return caml_exact_trampoline_cps_call$0
		                                       (compile_type, bindings, res, type, cont);
		                              }]);
		                           caml_push_trap
		                            (function(exn){
		                              if(exn[1] === Fail){var e = exn[2]; return cont([1, e]);}
		                              var
		                               raise = caml_pop_trap(),
		                               exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                              return raise(exn$0);
		                             });
		                           a = caml_obj_tag(res);
		                           function b(a){caml_pop_trap(); return cont([0, a]);}
		                           if(250 === a) return b(res[1]);
		                           if(246 !== a && 244 !== a) return b(res);
		                           return caml_exact_trampoline_cps_call
		                                   (force_lazy_block, res, b);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (opaque,
		                                   cst_context,
		                                   function(context_id){
		                                    var
		                                     d = Type[44],
		                                     c = Type[37],
		                                     b = Type[9],
		                                     Arr$0 = Type[1],
		                                     e = Type[49],
		                                     f = Type[45],
		                                     h = Type[33];
		                                    function reverse(param, cont){
		                                     var r = param[3], l = param[2], t = param[1];
		                                     return cont([0, t, r, l]);
		                                    }
		                                    function unify(strict, l, r, cont){
		                                     function unify(strict, l, r, lvl, cont){
		                                      var
		                                       open =
		 g
		  ([0,
		    symbol_bind$5,
		    symbol_map$5,
		    ,
		    bind$8,
		    return$9,
		    map$17,
		    ,
		    ,
		    ,
		    ,
		    Let_syntax$3]),
		                                       let$ = open[4],
		                                       symbol_map = open[2],
		                                       symbol_bind = open[1];
		                                      return caml_exact_trampoline_cps_call$0
		      (scope,
		       lvl,
		       function(m, cont){
		        return caml_trampoline_cps_call8
		                (m, 0, 0, Jl, b, l, b, r, cont);
		       },
		       function(indentation, cont){
		        function null_lenient(t, cont){
		         var
		          a = Arr$0[5].call(null, 0),
		          b = Arr$0[2].call(null, return$9);
		         return caml_exact_trampoline_cps_call
		                 (h, t, function(c){return cont([0, c, b, a]);});
		        }
		        function variant(variant, t, cont){
		         var cases = variant[1];
		         function a(t$0, init){
		          if(t$0){
		           var
		            l = t$0[2],
		            a$0 = t$0[1],
		            type = a$0[4],
		            return$ = a$0[3],
		            name = a$0[1];
		           if(typeof init === "number"){
		            var
		             msgf =
		               function(m, cont){
		                return caml_trampoline_cps_call8
		                        (m,
		                         0,
		                         0,
		                         Jh,
		                         function(ppf, v, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_char,
		                                   ppf,
		                                   32,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$2
		    (option, 0, string$1, ppf, v, cont);
		                                   });
		                         },
		                         name,
		                         b,
		                         type,
		                         cont);
		               };
		            return caml_exact_trampoline_cps_call$1
		                    (debug$0,
		                     indentation,
		                     msgf,
		                     function(match){
		                      var lvl = indentation + 1 | 0;
		                      return caml_exact_trampoline_cps_call$2
		                              (unify,
		                               1,
		                               type,
		                               t,
		                               lvl,
		                               function(b){
		                                if(! b) return caml_exact_trampoline_call2(a, l, init);
		                                b = b[1];
		                                var r = b[3], res = b[1];
		                                return caml_exact_trampoline_cps_call$0
		(d,
		 res,
		 type,
		 lvl,
		 function(b){
		  if(! b) return caml_exact_trampoline_call2(a, l, 0);
		  b = Arr$0[2].call(null, return$);
		  return caml_exact_trampoline_cps_call$1
		          (Arr$0[14],
		           b,
		           r,
		           function(b){
		            return caml_exact_trampoline_call2
		                    (a, l, [0, [0, [10, variant], Arr$0[7], b]]);
		           });
		 });
		                               });
		                     });
		           }
		           var u$0 = init[1];
		           return caml_exact_trampoline_call2(a, l, [0, u$0]);
		          }
		          if(typeof init !== "number"){
		           var u = init[1];
		           return cont([0, u]);
		          }
		          if(init) return cont(0);
		          var
		           e = Arr$0[2].call(null, return$2),
		           f = Arr$0[2].call(null, return$1);
		          return caml_exact_trampoline_cps_call$1
		                  (c,
		                   [10, variant],
		                   t,
		                   function(a){return cont([0, [0, a, f, e]]);});
		         }
		         return a(cases, 1);
		        }
		        function variants(param, right, cont){
		         var cases_right = right[1], cases_left = param[1];
		         function a(left_to_right_cases, cont){
		          function unify_left(left, cont){
		           function a(param){
		            function b(match){
		             if(! match)
		              return caml_exact_trampoline_cps_call
		                      (failwith, cst_no_case_matched, cont);
		             var unified = match[1];
		             return cont(unified);
		            }
		            if(! param) return b(0);
		            var l = param[2], x = param[1];
		            return caml_trampoline_cps_call2
		                    (x,
		                     left,
		                     function(r){
		                      return r ? b(r) : caml_exact_trampoline_call1(a, l);
		                     });
		           }
		           return a(left_to_right_cases);
		          }
		          var a = Arr$0[7];
		          return cont
		                  ([0, [10, right], Arr$0[4].call(null, unify_left), a]);
		         }
		         return caml_trampoline_cps_call3
		                 (map$18,
		                  cases_left,
		                  function(param, cont){
		                   var
		                    type_left = param[4],
		                    lift = param[2],
		                    name_left = param[1];
		                   function msgf(m, cont){
		                    return caml_trampoline_cps_call8
		                            (m,
		                             0,
		                             0,
		                             Ji,
		                             function(ppf, v, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_char,
		                                       ppf,
		                                       32,
		                                       function(a){
		return caml_exact_trampoline_cps_call$2
		        (option, 0, string$1, ppf, v, cont);
		                                       });
		                             },
		                             name_left,
		                             b,
		                             type_left,
		                             cont);
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (debug$0,
		                            indentation,
		                            msgf,
		                            function(match){
		                             var lvl = indentation + 1 | 0;
		                             function a(param){
		                              function b(res){return cont(res);}
		                              if(! param) return b(0);
		                              var
		                               l = param[2],
		                               x = param[1],
		                               type_right = x[4],
		                               return_right = x[3];
		                              function c(param, cont){
		                               var unify_left = param[2], type_unified = param[1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (d,
		type_unified,
		type_right,
		lvl,
		function(match){
		 return match
		         ? caml_exact_trampoline_cps_call
		           (Arr$0[13],
		            unify_left,
		            function(unify_left){
		             return cont
		                     ([0,
		                       function(left_value, cont){
		                        var a = Arr$0[1][8];
		                        function b(b, cont){
		                         return caml_trampoline_cps_call3(a, b, return_right, cont);
		                        }
		                        return caml_trampoline_cps_call2
		                                (lift,
		                                 left_value,
		                                 function(a){
		                                  return caml_trampoline_cps_call3
		  (symbol_map,
		   a,
		   unify_left,
		   function(a){
		    return caml_trampoline_cps_call3(symbol_map, a, b, cont);
		   });
		                                 });
		                       }]);
		            })
		         : cont(0);
		});
		                              }
		                              return caml_exact_trampoline_cps_call$2
		                                      (unify,
		                                       1,
		                                       type_left,
		                                       type_right,
		                                       lvl,
		                                       function(d){
		return caml_trampoline_cps_call3
		        (symbol_bind,
		         d,
		         c,
		         function(r){
		          return r ? b(r) : caml_exact_trampoline_call1(a, l);
		         });
		                                       });
		                             }
		                             return a(cases_right);
		                            });
		                  },
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (all$13,
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$, b, a, cont);
		                            });
		                  });
		        }
		        function view(repr, f, r, cont){
		         return caml_exact_trampoline_cps_call$2
		                 (unify,
		                  strict,
		                  repr,
		                  r,
		                  indentation,
		                  function(a){
		                   if(! a) return cont(0);
		                   a = a[1];
		                   var
		                    right = a[3],
		                    left = a[2],
		                    unified = a[1],
		                    a = Arr$0[2].call(null, f);
		                   return caml_exact_trampoline_cps_call$1
		                           (Arr$0[19],
		                            a,
		                            left,
		                            function(a){return cont([0, [0, unified, a, right]]);});
		                  });
		        }
		        function try_casting(l, r, cont){
		         return caml_exact_trampoline_cps_call$0
		                 (e,
		                  of_lexing$0(dummy_pos, dummy_pos),
		                  l,
		                  r,
		                  function(match){
		                   if(0 !== match[0]) return cont(0);
		                   var c = match[1];
		                   return cont([0, [0, l, Arr$0[7], c]]);
		                  });
		        }
		        return caml_exact_trampoline_cps_call$1
		                (try_casting,
		                 r,
		                 l,
		                 function(a){
		                  return caml_trampoline_cps_call3
		                          (symbol_map,
		                           a,
		                           reverse,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (try_casting,
		                                     l,
		                                     r,
		                                     function(e){
		                                      e = first_some(e, a);
		                                      if(e){var u = e[1]; return cont([0, u]);}
		                                      function d(res){
		                                       function a(a){return cont(res);}
		                                       if(! res)
		return caml_exact_trampoline_cps_call$1
		        (debug$0,
		         indentation,
		         function(m, cont){
		          return caml_exact_trampoline_cps_call$0(m, 0, 0, Jk, cont);
		         },
		         a);
		                                       var unified = res[1][1];
		                                       return caml_exact_trampoline_cps_call$1
		       (debug$0,
		        indentation,
		        function(m, cont){
		         return caml_trampoline_cps_call6
		                 (m, 0, 0, Jj, b, unified, cont);
		        },
		        a);
		                                      }
		                                      a:
		                                      {
		                                       b:
		                                       {
		c:
		{
		 d:
		 {
		  e:
		  {
		   if(typeof l !== "number")
		    switch(l[0]){
		      case 0:
		       if(typeof r === "number"){if(5 === r) break b; break a;}
		       switch(r[0]){
		         case 0:
		          return caml_exact_trampoline_cps_call$1
		                  (f,
		                   l,
		                   r,
		                   function(match){
		                    return match ? d([0, [0, l, Arr$0[7], Arr$0[7]]]) : d(0);
		                   });
		         case 1: break;
		         case 5:
		          break e;
		         case 11:
		          break d;
		         case 10:
		          break b;
		         default: break a;
		       }
		       break;
		      case 1:
		       var
		        l$2 = l[1],
		        e = caml_obj_tag(l$2),
		        g =
		          function(a){
		           return caml_exact_trampoline_cps_call$2
		                   (unify, strict, a, r, indentation, d);
		          };
		       if(250 === e) return g(l$2[1]);
		       if(246 !== e && 244 !== e) return g(l$2);
		       return caml_exact_trampoline_cps_call
		               (force_lazy_block, l$2, g);
		      case 10:
		       var l$3 = l[1];
		       if(typeof r === "number") break c;
		       switch(r[0]){
		         case 10:
		          var r$3 = r[1];
		          return caml_exact_trampoline_cps_call$1
		                  (variants,
		                   r$3,
		                   l$3,
		                   function(a){
		                    return caml_trampoline_cps_call3
		                            (symbol_map,
		                             a,
		                             reverse,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (variants,
		                                       l$3,
		                                       r$3,
		                                       function(b){return d(first_some(b, a));});
		                             });
		                   });
		         case 1: break;
		         case 5:
		          break e;
		         case 11:
		          break d;
		         default: break c;
		       }
		       break;
		    }
		   if(typeof r !== "number" && 1 === r[0]){
		    var
		     r$2 = r[1],
		     e = caml_obj_tag(r$2),
		     h =
		       function(a){
		        return caml_exact_trampoline_cps_call$2
		                (unify, strict, l, a, indentation, d);
		       };
		    if(250 === e) return h(r$2[1]);
		    if(246 !== e && 244 !== e) return h(r$2);
		    return caml_exact_trampoline_cps_call
		            (force_lazy_block, r$2, h);
		   }
		   if(typeof l !== "number" && 5 === l[0]){
		    var l$1 = l[2];
		    return caml_exact_trampoline_cps_call$2
		            (unify, strict, l$1, r, indentation, d);
		   }
		  }
		  if(typeof r !== "number" && 5 === r[0]){
		   var r$1 = r[2];
		   return caml_exact_trampoline_cps_call$2
		           (unify, strict, l, r$1, indentation, d);
		  }
		  if(typeof l !== "number" && 11 === l[0]){
		   var f$1 = l[3], repr$0 = l[2];
		   return caml_exact_trampoline_cps_call$0
		           (view, repr$0, f$1, r, d);
		  }
		 }
		 if(typeof r !== "number" && 11 === r[0]){
		  var f$0 = r[3], repr = r[2];
		  return caml_exact_trampoline_cps_call$0
		          (view,
		           repr,
		           f$0,
		           l,
		           function(a){
		            return caml_trampoline_cps_call3(symbol_map, a, reverse, d);
		           });
		 }
		}
		if(typeof l !== "number" && 10 === l[0]){
		 var l$0 = l[1];
		 return caml_exact_trampoline_cps_call$1(variant, l$0, r, d);
		}
		                                       }
		                                       if(typeof r === "number"){
		if(5 === r && ! strict)
		 return caml_exact_trampoline_cps_call
		         (null_lenient, l, function(a){return d([0, a]);});
		                                       }
		                                       else if(10 === r[0]){
		var r$0 = r[1];
		return caml_exact_trampoline_cps_call$1
		        (variant,
		         r$0,
		         l,
		         function(a){
		          return caml_trampoline_cps_call3(symbol_map, a, reverse, d);
		         });
		                                       }
		                                       if(typeof l === "number" && 5 <= l && ! strict)
		return caml_exact_trampoline_cps_call
		        (null_lenient,
		         r,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (reverse, a, function(a){return d([0, a]);});
		         });
		                                      }
		                                      if(strict) return d(0);
		                                      var
		                                       i = Arr$0[2].call(null, return$2),
		                                       j = Arr$0[2].call(null, return$1);
		                                      return caml_exact_trampoline_cps_call$1
		      (c, l, r, function(a){return d([0, [0, a, j, i]]);});
		                                     });
		                           });
		                 });
		       },
		       cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call$2
		     (unify, strict, l, r, 0, cont);
		                                    }
		                                    function union(l, r, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (unify,
		      0,
		      l,
		      r,
		      function(match){
		       if(match){var u = match[1]; return cont(u);}
		       var
		        a = Arr$0[2].call(null, return$2),
		        b = Arr$0[2].call(null, return$1);
		       return caml_exact_trampoline_cps_call$1
		               (c, l, r, function(c){return cont([0, c, b, a]);});
		      });
		                                    }
		                                    function nullable_join(query, cont){
		                                     function a(query){
		                                      var run = query[2], type = query[1], b = Arr[1];
		                                      g([0, b[3], b[4], , b[6], b[7], b[8], , , , , b[13]]);
		                                      return caml_exact_trampoline_cps_call
		      (Type[46],
		       type,
		       function(b){
		        if(typeof b !== "number" && 10 === b[0]){
		         b = b[1][1];
		         if(b){
		          var c = b[2];
		          if(c){
		           var d = c[1][4];
		           if(typeof d === "number" && 5 <= d && ! c[2]){
		            b = b[1];
		            var outer_type = b[4], outer_lift = b[2];
		            return caml_exact_trampoline_cps_call
		                    (Type[46],
		                     outer_type,
		                     function(type){
		                      if(typeof type !== "number" && 10 === type[0]){
		                       var b = type[1][1];
		                       if(b){
		                        b = b[2];
		                        if(b){
		                         var c = b[1], d = c[4];
		                         if(typeof d === "number" && 5 <= d && ! b[2]){
		                          var
		                           return_null = c[3],
		                           e =
		                             Arr[2].call
		                              (null,
		                               function(param, cont){
		                                if(! param)
		                                 return caml_trampoline_cps_call2(return_null, 0, cont);
		                                var value = param[1];
		                                return cont(value);
		                               }),
		                           c = Arr[2].call(null, outer_lift);
		                          return caml_exact_trampoline_cps_call$1
		                                  (Arr[18][1],
		                                   run,
		                                   c,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[18][1],
		     b,
		     e,
		     function(b){
		      var query = [0, type, b];
		      return caml_exact_trampoline_call1(a, query);
		     });
		                                   });
		                         }
		                        }
		                       }
		                      }
		                      return cont(query);
		                     });
		           }
		          }
		         }
		        }
		        return cont(query);
		       });
		                                     }
		                                     return a(query);
		                                    }
		                                    var
		                                     a = Arr[1],
		                                     a = g([0, a[3], a[4], , a[6], a[7], a[8], , , , , a[13]]),
		                                     symbol_map = a[2],
		                                     let$ = a[3],
		                                     let$0 = a[4],
		                                     and = a[6],
		                                     open =
		                                       Syntax2([0, symbol_bind$1, symbol_map$0, Let_syntax$0]),
		                                     symbol = open[1],
		                                     symbol$0 = open[2],
		                                     let$1 = open[3],
		                                     let$2 = open[4],
		                                     and$0 = open[5];
		                                    function traverse_view(query, f, cont){
		                                     function a(query){
		                                      var run = query[2], type = query[1];
		                                      if(typeof type !== "number" && 11 === type[0]){
		                                       var
		view = type[3],
		repr = type[2],
		b = Arr[2].call(null, view);
		                                       return caml_exact_trampoline_cps_call$1
		       (Arr[18][1],
		        run,
		        b,
		        function(b){
		         var query = [0, repr, b];
		         return caml_exact_trampoline_call1(a, query);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call(f, query, cont);
		                                     }
		                                     return a(query);
		                                    }
		                                    function to_bool_option(location, t, cont){
		                                     if(typeof t === "number")
		                                      switch(t){
		case 0:
		 return cont([0, [0, function(a, cont){return cont(a);}]]);
		case 4:
		 return cont
		         ([0,
		           [0,
		            function(param, a){
		             a = caml_pop_trap();
		             return a
		                     (caml_maybe_attach_backtrace([0, Match_failure, J7], 1));
		            }]]);
		                                      }
		                                     else
		                                      switch(t[0]){
		case 0:
		 var match = t[1];
		 if(typeof match === "number" && ! match){
		  var value = t[2];
		  return cont
		          ([0, [0, function(param, cont){return cont(value);}]]);
		 }
		 break;
		case 10:
		 var
		  cases = t[1][1],
		  b =
		    function(cases, cont){
		     return cont
		             ([1,
		               function(v, cont){
		                function a(param){
		                 function b(o){
		                  if(o){var x = o[1]; return cont(x);}
		                  var a = Type[9];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$67,
		                           function(b){
		                            return caml_trampoline_cps_call3
		                                    (b,
		                                     a,
		                                     t,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (of_string$1,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call(raise, a, cont);
		       });
		                                     });
		                           });
		                 }
		                 if(! param) return b(0);
		                 var l = param[2], case$ = param[1];
		                 return caml_trampoline_cps_call2
		                         (case$,
		                          v,
		                          function(r){
		                           return r ? b(r) : caml_exact_trampoline_call1(a, l);
		                          });
		                }
		                return a(cases);
		               }]);
		    };
		 return caml_exact_trampoline_cps_call$1
		         (map$7,
		          cases,
		          function(param, cont){
		           var match = param[4];
		           if(typeof match === "number"){
		            var lift = param[2];
		            if(! match)
		             return caml_exact_trampoline_cps_call
		                     (of_string$0,
		                      function(a, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (compose, return$9, lift, a, cont);
		                      },
		                      cont);
		            if(5 <= match)
		             return caml_exact_trampoline_cps_call
		                     (of_string$0,
		                      function(v, cont){
		                       return caml_trampoline_cps_call2
		                               (lift,
		                                v,
		                                function(match){return match ? cont(J8) : cont(0);});
		                      },
		                      cont);
		           }
		           var a = Type[9];
		           return caml_exact_trampoline_cps_call$0
		                   (fail$4,
		                    2,
		                    location,
		                    J9,
		                    function(b){
		                     return caml_trampoline_cps_call3(b, a, t, cont);
		                    });
		          },
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (all$10,
		                    a,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1(let$2, a, b, cont);
		                    });
		          });
		                                      }
		                                     var a = Type[9];
		                                     return caml_exact_trampoline_cps_call$0
		     (fail$4,
		      2,
		      location,
		      J6,
		      function(b){
		       return caml_trampoline_cps_call3(b, a, t, cont);
		      });
		                                    }
		                                    function to_bool(location, t, cont){
		                                     function a(param, cont){
		                                      if(0 === param[0]){
		                                       var to_bool = param[1];
		                                       return cont(to_bool);
		                                      }
		                                      var to_bool_option = param[1];
		                                      return cont
		      (function(v, cont){
		        return caml_trampoline_cps_call2
		                (to_bool_option,
		                 v,
		                 function(match){
		                  if(! match) return cont(0);
		                  var b = match[1];
		                  return cont(b);
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (to_bool_option,
		      location,
		      t,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$0, b, a, cont);
		      });
		                                    }
		                                    function cmp(location, op, lhs_run, rhs_run, param, cont){
		                                     var r = param[3], l = param[2], res = param[1];
		                                     function a(param, cont){
		                                      var compare = param[3], type = param[2];
		                                      return caml_exact_trampoline_cps_call$1
		      (Arr[18][1],
		       lhs_run,
		       l,
		       function(lhs){
		        return caml_exact_trampoline_cps_call$1
		                (Arr[18][1],
		                 rhs_run,
		                 r,
		                 function(rhs){
		                  var a = Arr[3].call(null, compare);
		                  return caml_exact_trampoline_cps_call$1
		                          (Arr[21],
		                           lhs,
		                           rhs,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (Arr[18][1],
		                                     Arr[8],
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (Arr[18][1],
		       b,
		       a,
		       function(run){return cont([0, type, run]);});
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$0
		     (compile_compare,
		      location,
		      res,
		      op,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (init_mod,
		     J$,
		     J_,
		     function(Expression){
		      return caml_exact_trampoline_cps_call$1
		              (init_mod,
		               Kb,
		               Ka,
		               function(Field_name){
		                return caml_exact_trampoline_cps_call$1
		                        (init_mod,
		                         Kd,
		                         Kc,
		                         function(Call){
		                          return caml_exact_trampoline_cps_call$1
		                                  (init_mod,
		                                   Kf,
		                                   Ke,
		                                   function(Index){
		                                    return caml_exact_trampoline_cps_call$1
		    (init_mod,
		     Kh,
		     Kg,
		     function(If){
		      return caml_exact_trampoline_cps_call$1
		              (init_mod,
		               Kj,
		               Ki,
		               function(Object){
		                return caml_exact_trampoline_cps_call$1
		                        (init_mod,
		                         Kl,
		                         Kk,
		                         function(Sort){
		                          return caml_exact_trampoline_cps_call$1
		                                  (init_mod,
		                                   Kn,
		                                   Km,
		                                   function(Where){
		                                    return caml_exact_trampoline_cps_call$1
		    (init_mod,
		     Kp,
		     Ko,
		     function(Select){
		      return caml_exact_trampoline_cps_call$1
		              (init_mod,
		               Kr,
		               Kq,
		               function(Limit){
		                return caml_exact_trampoline_cps_call$1
		                        (init_mod,
		                         Kt,
		                         Ks,
		                         function(Subscript){
		                          function compile(bindings, a, cont){
		                           var location = a[2], ast = a[1], a = Arr[1];
		                           g([0, a[3], a[4], , a[6], a[7], a[8], , , , , a[13]]);
		                           var
		                            open =
		                              Syntax2([0, symbol_bind$1, symbol_map$0, Let_syntax$0]),
		                            and = open[5],
		                            let$ = open[4],
		                            let$0 = open[3],
		                            symbol = open[2],
		                            symbol$0 = open[1];
		                           function typefail(fmt, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (fail$4, 2, location, fmt, cont);
		                           }
		                           function field(allow_missing, n, param, cont){
		                            function a(param){
		                             var run = param[2], type = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (nullable,
		                                      type,
		                                      function(Probe){
		                                       var type = Probe[1];
		                                       if(typeof type !== "number")
		switch(type[0]){
		  case 0:
		   var
		    value = type[2],
		    type$0 = type[1],
		    b = Arr[5].call(null, value);
		   return caml_exact_trampoline_cps_call
		           (Probe[3],
		            b,
		            function(b){
		             return caml_exact_trampoline_cps_call$1
		                     (Arr[18][1],
		                      run,
		                      b,
		                      function(b){
		                       return caml_exact_trampoline_cps_call
		                               (Probe[2],
		                                type$0,
		                                function(c){
		                                 return caml_exact_trampoline_call1(a, [0, c, b]);
		                                });
		                      });
		            });
		  case 6:
		   var fields = type[1][3];
		   return caml_trampoline_cps_call3
		           (Type[41],
		            n,
		            fields,
		            function(a){
		             if(a){
		              a = a[1][1];
		              var type = a[4], resolve = a[3];
		              return caml_exact_trampoline_cps_call
		                      (Probe[3],
		                       resolve,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][1],
		                                 run,
		                                 a,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (Probe[2],
		   type,
		   function(b){
		    return caml_exact_trampoline_cps_call
		            (of_string$0, [0, b, a], cont);
		   });
		                                 });
		                       });
		             }
		             if(allow_missing){
		              a = Arr[5].call(null, 0);
		              return caml_exact_trampoline_cps_call
		                      (Probe[3],
		                       a,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][1],
		                                 run,
		                                 a,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (Probe[2],
		   5,
		   function(b){
		    return caml_trampoline_cps_call2
		            (of_string$14, [0, b, a], cont);
		   });
		                                 });
		                       });
		             }
		             var b = Probe[1], c = Type[9];
		             return caml_exact_trampoline_cps_call
		                     (Type[42],
		                      fields,
		                      function(a){
		                       return caml_exact_trampoline_cps_call$2
		                               (missing_var,
		                                location,
		                                n,
		                                a,
		                                Kv,
		                                function(a){
		                                 return caml_trampoline_cps_call5
		 (a, pp_quoted, n, c, b, cont);
		                                });
		                      });
		            });
		  case 10:
		   var cases = type[1][1];
		   return caml_exact_trampoline_cps_call
		           (opaque,
		            cst_case,
		            function(case_id){
		             return caml_exact_trampoline_cps_call
		                     (opaque,
		                      cst_variant,
		                      function(variant_id){
		                       function case_key(param, cont){return cont([0, case_id]);}
		                       function variant_key(param, cont){return cont([0, variant_id]);
		                       }
		                       function a(cases, cont){
		                        function f(res, param, cont){
		                         var query = param[2], match = param[1];
		                         if(res){
		                          var result = res[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (union,
		                                   result[1],
		                                   query[1],
		                                   function(match$0){
		                                    var r = match$0[3], l = match$0[2], unified = match$0[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[18][1],
		     result[2],
		     l,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (Arr[18][1],
		               query[2],
		               r,
		               function(c){
		                var
		                 b =
		                   Arr[2].call
		                    (null,
		                     function(param, cont){
		                      var obj = param[2], values = param[1];
		                      return caml_trampoline_cps_call2
		                              (match[2],
		                               obj,
		                               function(match$0){
		                                if(! match$0) return cont([1, values]);
		                                var value = match$0[1];
		                                return caml_exact_trampoline_cps_call$2
		(add,
		 case_key,
		 match[4],
		 value,
		 values,
		 function(values){return cont([0, values]);});
		                               });
		                     });
		                return caml_exact_trampoline_cps_call$0
		                        (Arr[16],
		                         b,
		                         c,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (getf,
		                                   Probe[1],
		                                   variant_key,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[24],
		     Arr[7],
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (Arr[18][1],
		               b,
		               a,
		               function(a){return cont([0, [0, [0, unified, a]]]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         }
		                         var
		                          a = query[2],
		                          b =
		                            Arr[2].call
		                             (null,
		                              function(param, cont){
		                               var obj = param[2], values = param[1];
		                               return caml_trampoline_cps_call2
		                                       (match[2],
		obj,
		function(match$0){
		 function a(values){return cont(values);}
		 if(! match$0)
		  return caml_exact_trampoline_cps_call
		          (failwith, "no case were matched", a);
		 var value = match$0[1];
		 return caml_exact_trampoline_cps_call$2
		         (add, case_key, match[4], value, values, a);
		});
		                              });
		                         return caml_exact_trampoline_cps_call$1
		                                 (getf,
		                                  Probe[1],
		                                  variant_key,
		                                  function(c){
		                                   return caml_exact_trampoline_cps_call$1
		   (Arr[24],
		    Arr[7],
		    c,
		    function(c){
		     return caml_exact_trampoline_cps_call$1
		             (Arr[18][1],
		              c,
		              b,
		              function(b){
		               return caml_exact_trampoline_cps_call$1
		                       (Arr[18][1],
		                        b,
		                        a,
		                        function(a){return cont([0, [0, [0, query[1], a]]]);});
		              });
		    });
		                                  });
		                        }
		                        function finish(a, cont){
		                         if(! a)
		                          return caml_exact_trampoline_cps_call
		                                  (failwith, "no cases", cont);
		                         a = a[1];
		                         var
		                          result_run = a[2],
		                          result_type = a[1],
		                          set_value =
		                            Arr[2].call
		                             (null,
		                              function(param, cont){
		                               var values = param[2], variant = param[1];
		                               return caml_exact_trampoline_cps_call$2
		                                       (add, variant_key, Probe[1], variant, values, cont);
		                              });
		                         return caml_exact_trampoline_cps_call$1
		                                 (Arr[18][1],
		                                  set_value,
		                                  result_run,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call
		   (Probe[4],
		    a,
		    function(a){
		     return caml_exact_trampoline_cps_call$1
		             (Arr[24],
		              run,
		              Arr[7],
		              function(b){
		               return caml_exact_trampoline_cps_call$1
		                       (Arr[18][1],
		                        b,
		                        a,
		                        function(a){
		                         return caml_exact_trampoline_cps_call
		                                 (Probe[2],
		                                  result_type,
		                                  function(b){return cont([0, [0, b, a]]);});
		                        });
		              });
		    });
		                                  });
		                        }
		                        return caml_exact_trampoline_cps_call$3
		                                (fold_until, fold_left$1, 0, f, finish, cases, cont);
		                       }
		                       return caml_exact_trampoline_cps_call$0
		                               (fold_map,
		                                cases,
		                                0,
		                                function(found, case$, cont){
		                                 var type = case$[4];
		                                 return caml_exact_trampoline_cps_call$1
		 (getf,
		  type,
		  case_key,
		  function(a){
		   return caml_exact_trampoline_cps_call$0
		           (field,
		            allow_missing,
		            n,
		            [0, type, a],
		            function(query){
		             if(0 === query[0]){
		              var query$0 = query[1];
		              return cont([0, 1, [0, [0, case$, query$0]]]);
		             }
		             var e = query[1];
		             return cont([0, found, [1, [0, case$, e]]]);
		            });
		  });
		                                },
		                                function(match){
		                                 var cases = match[2], at_least_one = match[1];
		                                 return caml_exact_trampoline_cps_call
		 (all$10,
		  cases,
		  function(ok){
		   function b(ok){
		    return caml_exact_trampoline_cps_call$1(let$0, ok, a, cont);
		   }
		   if(0 === ok[0]) return b(ok);
		   var error = ok[1][2];
		   return at_least_one
		           ? caml_trampoline_cps_call3
		             (map$18,
		              cases,
		              function(a, cont){
		               if(0 === a[0]){
		                a = a[1];
		                var
		                 match = a[2],
		                 run = match[2],
		                 type = match[1],
		                 case$ = a[1],
		                 a = Arr[2].call(null, return$9);
		                return caml_exact_trampoline_cps_call$1
		                        (Arr[18][1],
		                         run,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Type[33],
		                                   type,
		                                   function(b){return cont([0, case$, [0, b, a]]);});
		                         });
		               }
		               var case$0 = a[1][1];
		               return cont([0, case$0, return$(5, 0)]);
		              },
		              function(a){
		               return caml_exact_trampoline_cps_call(of_string$0, a, b);
		              })
		           : b([1, error]);
		  });
		                                });
		                      });
		            });
		  case 11:
		   var
		    view = type[3],
		    repr = type[2],
		    b = Arr[2].call(null, view);
		   return caml_exact_trampoline_cps_call
		           (Probe[3],
		            b,
		            function(b){
		             return caml_exact_trampoline_cps_call$1
		                     (Arr[18][1],
		                      run,
		                      b,
		                      function(b){
		                       return caml_exact_trampoline_cps_call
		                               (Probe[2],
		                                repr,
		                                function(c){
		                                 return caml_exact_trampoline_call1(a, [0, c, b]);
		                                });
		                      });
		            });
		}
		                                       var c = Type[9];
		                                       return caml_exact_trampoline_cps_call
		       (typefail,
		        Ku,
		        function(a){
		         return caml_trampoline_cps_call5
		                 (a, pp_quoted, n, c, type, cont);
		        });
		                                      });
		                            }
		                            return a(param);
		                           }
		                           if(typeof ast === "number")
		                            return caml_exact_trampoline_cps_call
		                                    (of_string$0, return$(5, 0), cont);
		                           switch(ast[0]){
		                             case 0:
		                              var
		                               rhs = ast[3],
		                               op = ast[2],
		                               lhs = ast[1],
		                               c =
		                                 function(param, cont){
		                                  var rhs = param[2], lhs = param[1];
		                                  function bool(lhs, param, always, maybe, cont){
		                                   return caml_exact_trampoline_cps_call$0
		   (unify,
		    0,
		    lhs[1],
		    param[1],
		    function(a){
		     if(a){
		      a = a[1];
		      var
		       r = a[3],
		       l = a[2],
		       unified = a[1],
		       b =
		         function(param$0, cont){
		          if(0 === param$0[0]){
		           var
		            to_bool = param$0[1],
		            a =
		              Arr[2].call
		               (null,
		                function(param, cont){
		                 var rhs = param[2], lhs = param[1];
		                 return caml_trampoline_cps_call2
		                         (to_bool,
		                          rhs,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (to_bool, lhs, function(b){return cont(always(b, a));});
		                          });
		                }),
		            b = param[2];
		           return caml_trampoline_cps_call2
		                   (Arr[26],
		                    "Rhs run",
		                    function(c){
		                     return caml_trampoline_cps_call2
		                             (c,
		                              b,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (Arr[18][1],
		b,
		r,
		function(c){
		 var b = lhs[2];
		 return caml_trampoline_cps_call2
		         (Arr[26],
		          "Lhs run",
		          function(d){
		           return caml_trampoline_cps_call2
		                   (d,
		                    b,
		                    function(b){
		                     return caml_exact_trampoline_cps_call$1
		                             (Arr[18][1],
		                              b,
		                              l,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (Arr[24],
		b,
		c,
		function(b){
		 return caml_exact_trampoline_cps_call$1
		         (Arr[18][1], b, a, function(run){return cont([0, 0, run]);});
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          }
		          var
		           to_bool_option = param$0[1],
		           c =
		             Arr[2].call
		              (null,
		               function(param, cont){
		                var rhs = param[2], lhs = param[1];
		                return caml_trampoline_cps_call2
		                        (to_bool_option,
		                         rhs,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (to_bool_option,
		                                   lhs,
		                                   function(b){return cont(maybe(b, a));});
		                         });
		               });
		          return caml_exact_trampoline_cps_call$1
		                  (Arr[18][1],
		                   param[2],
		                   r,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (Arr[18][1],
		                             lhs[2],
		                             l,
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1
		                                      (Arr[24],
		                                       b,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (Arr[18][1],
		         a,
		         c,
		         function(run){
		          return caml_exact_trampoline_cps_call
		                  (Type[33],
		                   Type[13],
		                   function(type){return cont([0, type, run]);});
		         });
		                                       });
		                             });
		                   });
		         };
		      return caml_exact_trampoline_cps_call$1
		              (to_bool_option,
		               location,
		               unified,
		               function(a){
		                return caml_exact_trampoline_cps_call$1(symbol, a, b, cont);
		               });
		     }
		     var c = param[1], d = Type[9], e = lhs[1], f = Type[9];
		     return caml_exact_trampoline_cps_call
		             (typefail,
		              Kw,
		              function(a){
		               return caml_trampoline_cps_call5(a, f, e, d, c, cont);
		              });
		    });
		                                  }
		                                  switch(op){
		                                    case 0:
		                                     return caml_exact_trampoline_cps_call$2
		     (bool,
		      lhs,
		      rhs,
		      function(a, b){a = a ? b : a; return a;},
		      function(l, r){
		       if(l && r){
		        var r$0 = r[1], l$0 = l[1], r$1 = l$0 ? r$0 : l$0;
		        return [0, r$1];
		       }
		       return 0;
		      },
		      cont);
		                                    case 4:
		                                     var
		                                      element_run = lhs[2],
		                                      element_type = lhs[1],
		                                      collection_run = rhs[2],
		                                      collection_type = rhs[1],
		                                      compile_membership =
		function
		(type_name,
		 collection_element_type,
		 collection_to_list,
		 cont){
		 return caml_exact_trampoline_cps_call$0
		         (unify,
		          1,
		          element_type,
		          collection_element_type,
		          function(a){
		           if(a){
		            a = a[1];
		            var
		             collection_elem_conv = a[3],
		             element_conv = a[2],
		             unified_type = a[1],
		             b =
		               function(cmp, cont){
		                function a(eq, cont){
		                 var
		                  a =
		                    Arr[3].call
		                     (null,
		                      function(element, converted_list, cont){
		                       function a(t){
		                        if(! t) return cont(0);
		                        var xs = t[2], coll_element = t[1];
		                        return caml_trampoline_cps_call3
		                                (eq,
		                                 element,
		                                 coll_element,
		                                 function(b){
		                                  return b ? cont(1) : caml_exact_trampoline_call1(a, xs);
		                                 });
		                       }
		                       return a(converted_list);
		                      }),
		                  b = Arr[22].call(null, collection_elem_conv);
		                 return caml_exact_trampoline_cps_call$1
		                         (Arr[18][1],
		                          collection_run,
		                          collection_to_list,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Arr[18][1],
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (Arr[18][1],
		      element_run,
		      element_conv,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (Arr[21],
		                c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1
		                         (Arr[18][1],
		                          Arr[8],
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Arr[18][1], b, a, function(run){return cont([0, 0, run]);});
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (to_bool_compare,
		                         "inside operator",
		                         location,
		                         cmp,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               };
		            return caml_exact_trampoline_cps_call$0
		                    (compile_compare,
		                     location,
		                     unified_type,
		                     1,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1(let$0, a, b, cont);
		                     });
		           }
		           var c = Type[9], d = Type[9];
		           return caml_exact_trampoline_cps_call
		                   (typefail,
		                    Ky,
		                    function(a){
		                     return caml_trampoline_cps_call6
		                             (a,
		                              d,
		                              element_type,
		                              type_name,
		                              c,
		                              collection_element_type,
		                              cont);
		                    });
		          });
		};
		                                     if(typeof collection_type !== "number")
		                                      switch(collection_type[0]){
		case 3:
		 var list_element_type = collection_type[1];
		 return caml_exact_trampoline_cps_call$0
		         (compile_membership,
		          "list element type",
		          list_element_type,
		          Arr[7],
		          cont);
		case 4:
		 var map_data_type = collection_type[3];
		 return caml_exact_trampoline_cps_call$0
		         (compile_membership,
		          "map value type",
		          map_data_type,
		          Arr[2].call
		           (null,
		            function(param, cont){
		             return caml_exact_trampoline_cps_call(encode, param, cont);
		            }),
		          cont);
		                                      }
		                                     var a = Type[9];
		                                     return caml_exact_trampoline_cps_call
		     (typefail,
		      Kz,
		      function(b){
		       return caml_trampoline_cps_call3
		               (b, a, collection_type, cont);
		      });
		                                    case 8:
		                                     return caml_exact_trampoline_cps_call$2
		     (bool,
		      lhs,
		      rhs,
		      function(a, b){a ||= b; return a;},
		      function(l, r){
		       if(l){
		        var l$0 = l[1];
		        if(! r) return [0, l$0];
		        var r$0 = r[1], l$1 = l$0 || r$0;
		        return [0, l$1];
		       }
		       if(! r) return 0;
		       var r$1 = r[1];
		       return [0, r$1];
		      },
		      cont);
		                                    default:
		                                     var
		                                      lhs_run = lhs[2],
		                                      lhs_type = lhs[1],
		                                      rhs_run = rhs[2],
		                                      rhs_type = rhs[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (unify,
		      1,
		      lhs_type,
		      rhs_type,
		      function(match){
		       if(match){
		        var unification = match[1];
		        return caml_exact_trampoline_cps_call$3
		                (cmp, location, op, lhs_run, rhs_run, unification, cont);
		       }
		       var a = Type[9], b = Type[9];
		       return caml_exact_trampoline_cps_call
		               (typefail,
		                Kx,
		                function(c){
		                 return caml_trampoline_cps_call5
		                         (c, b, lhs_type, a, rhs_type, cont);
		                });
		      });
		                                  }
		                                 };
		                              return caml_exact_trampoline_cps_call$1
		                                      (compile,
		                                       bindings,
		                                       lhs,
		                                       function(left){
		return caml_exact_trampoline_cps_call$1
		        (compile,
		         bindings,
		         rhs,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (and,
		                   left,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1(let$0, a, c, cont);
		                   });
		         });
		                                       });
		                             case 1:
		                              var effective = ast[2], f = ast[1];
		                              return caml_trampoline_cps_call4
		                                      (Call[1], bindings, f, effective, cont);
		                             case 2:
		                              var
		                               allow_missing = ast[3],
		                               field_name = ast[2],
		                               source = ast[1],
		                               d =
		                                 function(source, cont){
		                                  function a(field_name, cont){
		                                   return caml_exact_trampoline_cps_call$0
		   (field, allow_missing, field_name, source, cont);
		                                  }
		                                  return caml_trampoline_cps_call3
		  (Field_name[1],
		   bindings,
		   field_name,
		   function(b){
		    return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		   });
		                                 };
		                              return caml_exact_trampoline_cps_call$1
		                                      (compile,
		                                       bindings,
		                                       source,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1(let$0, a, d, cont);
		                                       });
		                             case 3:
		                              var
		                               name = ast[2],
		                               from = ast[1],
		                               e =
		                                 function(from_query, cont){
		                                  return caml_exact_trampoline_cps_call$1
		  (traverse_view,
		   from_query,
		   function(param, cont){
		    var context_run = param[2], context_type = param[1];
		    return caml_exact_trampoline_cps_call
		            (nullable,
		             context_type,
		             function(Probe){
		              var context_type = Probe[1];
		              a:
		              if(typeof context_type !== "number"){
		               switch(context_type[0]){
		                 case 3:
		                  var a = context_type[2];
		                  if(! a)
		                   return caml_exact_trampoline_cps_call
		                           (Probe[2],
		                            [3, context_type[1], [0, name]],
		                            function(type){
		                             return caml_exact_trampoline_cps_call
		                                     (Probe[3],
		                                      Arr[7],
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (Arr[18][1],
		        context_run,
		        a,
		        function(a){return cont([0, [0, type, a]]);});
		                                      });
		                            });
		                  var previous_name = a[1];
		                  break;
		                 case 4:
		                  a = context_type[5];
		                  if(! a)
		                   return caml_exact_trampoline_cps_call
		                           (Probe[2],
		                            [4,
		                             context_type[1],
		                             context_type[2],
		                             context_type[3],
		                             context_type[4],
		                             [0, name],
		                             context_type[6],
		                             context_type[7]],
		                            function(type){
		                             return caml_exact_trampoline_cps_call
		                                     (Probe[3],
		                                      Arr[7],
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (Arr[18][1],
		        context_run,
		        a,
		        function(a){return cont([0, [0, type, a]]);});
		                                      });
		                            });
		                  previous_name = a[1];
		                  break;
		                 default: break a;
		               }
		               return caml_exact_trampoline_cps_call
		                       (typefail,
		                        KB,
		                        function(a){
		                         return caml_trampoline_cps_call3
		                                 (a, _41, previous_name, cont);
		                        });
		              }
		              var b = Type[9];
		              return caml_exact_trampoline_cps_call
		                      (typefail,
		                       KA,
		                       function(a){
		                        return caml_trampoline_cps_call3(a, b, context_type, cont);
		                       });
		             });
		   },
		   cont);
		                                 };
		                              return caml_exact_trampoline_cps_call$1
		                                      (compile,
		                                       bindings,
		                                       from,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1(let$0, a, e, cont);
		                                       });
		                             case 4:
		                              var key = ast[3], indexed = ast[2], expression = ast[1];
		                              return caml_trampoline_cps_call5
		                                      (Index[1], bindings, expression, indexed, key, cont);
		                             case 5:
		                              var else$ = ast[3], then = ast[2], condition = ast[1];
		                              return caml_trampoline_cps_call5
		                                      (If[1], bindings, condition, then, else$, cont);
		                             case 6:
		                              var i = ast[1];
		                              return caml_exact_trampoline_cps_call
		                                      (of_string$0, return$(Type[26], i), cont);
		                             case 7:
		                              var i$0 = ast[1];
		                              return caml_exact_trampoline_cps_call
		                                      (of_string$0, return$(Type[27], i$0), cont);
		                             case 8:
		                              var
		                               expression$0 = ast[2],
		                               let_bindings = ast[1],
		                               h =
		                                 function(bindings, cont){
		                                  return caml_exact_trampoline_cps_call$1
		  (compile, bindings, expression$0, cont);
		                                 },
		                               j =
		                                 function(t, cont){
		                                  function a(t, bindings){
		                                   if(! t) return cont(bindings);
		                                   var
		                                    l = t[2],
		                                    a$0 = t[1],
		                                    match = a$0[2],
		                                    run = match[2],
		                                    type = match[1],
		                                    name = a$0[1];
		                                   return caml_exact_trampoline_cps_call$3
		   (add$0,
		    0,
		    name,
		    type,
		    run,
		    bindings,
		    function(init){
		     return caml_exact_trampoline_call2(a, l, init);
		    });
		                                  }
		                                  return a(t, bindings);
		                                 };
		                              return caml_trampoline_cps_call3
		                                      (map$18,
		                                       let_bindings,
		                                       function(param, cont){
		var value = param[2], name = param[1];
		function a(query, cont){return cont([0, name[1], query]);}
		return caml_exact_trampoline_cps_call$1
		        (compile,
		         bindings,
		         value,
		         function(b){
		          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		         });
		                                       },
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (all$10,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (symbol,
		                   a,
		                   j,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1(let$0, a, h, cont);
		                   });
		         });
		                                       });
		                             case 9:
		                              var
		                               lst = ast[1],
		                               k =
		                                 function(lst, cont){
		                                  function a(list_query, cont){
		                                   var run = list_query[2], type = list_query[1];
		                                   return cont([0, [3, type, 0], run]);
		                                  }
		                                  return caml_exact_trampoline_cps_call
		  (of_string$0,
		   [0, 4, Arr[5].call(null, 0)],
		   function(init){
		    function b(t, init){
		     if(! t)
		      return caml_exact_trampoline_cps_call$1(let$, init, a, cont);
		     var
		      l = t[2],
		      a$0 = t[1],
		      elt_run = a$0[2],
		      elt_type = a$0[1];
		     return caml_exact_trampoline_cps_call$1
		             (let$0,
		              init,
		              function(param, cont){
		               var acc_run = param[2], acc_type = param[1];
		               return caml_exact_trampoline_cps_call$1
		                       (union,
		                        acc_type,
		                        elt_type,
		                        function(a){
		                         var
		                          elt_cast = a[3],
		                          acc_cast = a[2],
		                          type = a[1],
		                          b = Arr[9],
		                          a = Arr[22].call(null, acc_cast);
		                         return caml_exact_trampoline_cps_call$1
		                                 (Arr[18][1],
		                                  acc_run,
		                                  a,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$1
		   (Arr[18][1],
		    elt_run,
		    elt_cast,
		    function(c){
		     return caml_exact_trampoline_cps_call$1
		             (Arr[24],
		              c,
		              a,
		              function(a){
		               return caml_exact_trampoline_cps_call$1
		                       (Arr[18][1],
		                        a,
		                        b,
		                        function(a){
		                         return caml_exact_trampoline_cps_call
		                                 (of_string$0, [0, type, a], cont);
		                        });
		              });
		    });
		                                  });
		                        });
		              },
		              function(init){
		               return caml_exact_trampoline_call2(b, l, init);
		              });
		    }
		    return b(lst, init);
		   });
		                                 },
		                               b =
		                                 function(accu, param){
		                                  if(! param)
		                                   return caml_exact_trampoline_cps_call
		   (all$10,
		    accu,
		    function(a){
		     return caml_exact_trampoline_cps_call$1(let$0, a, k, cont);
		    });
		                                  var l = param[2], a = param[1];
		                                  return caml_exact_trampoline_cps_call$1
		  (compile,
		   bindings,
		   a,
		   function(a){
		    var accu$0 = [0, a, accu];
		    return caml_exact_trampoline_call2(b, accu$0, l);
		   });
		                                 };
		                              return b(0, lst);
		                             case 10:
		                              return caml_exact_trampoline_cps_call
		                                      (failwith, "fixme map", cont);
		                             case 11:
		                              var
		                               type = ast[1],
		                               l =
		                                 function(param, cont){
		                                  var type = param[1];
		                                  if(typeof type !== "number" && 4 === type[0]){
		                                   var Comparable = type[2], comparator = Comparable[16];
		                                   return caml_exact_trampoline_cps_call
		   (of_string$0,
		    return$(type, empty$11([0, comparator])),
		    cont);
		                                  }
		                                  var a = Type[9];
		                                  return caml_exact_trampoline_cps_call
		  (typefail,
		   KC,
		   function(b){
		    return caml_trampoline_cps_call3(b, a, type, cont);
		   });
		                                 };
		                              return caml_exact_trampoline_cps_call$0
		                                      (compile_type,
		                                       [0, bindings],
		                                       0,
		                                       type[1],
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (symbol$0, a, l, cont);
		                                       });
		                             case 12:
		                              var name$0 = ast[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (find,
		                                       name$0,
		                                       bindings,
		                                       function(a){
		if(! a)
		 return caml_exact_trampoline_cps_call$1
		         (symbol$96,
		          name$0,
		          context_id,
		          function(a){
		           if(a)
		            return caml_exact_trampoline_cps_call(typefail, KD, cont);
		           function available_bindings(param, cont){
		            return caml_exact_trampoline_cps_call
		                    (values,
		                     bindings,
		                     function(a){
		                      return caml_trampoline_cps_call3
		                              (map$11,
		                               a,
		                               calendar,
		                               function(a){
		                                return caml_exact_trampoline_cps_call(to_binable, a, cont);
		                               });
		                     });
		           }
		           return caml_exact_trampoline_cps_call$1
		                   (find,
		                    context_id,
		                    bindings,
		                    function(a){
		                     if(! a)
		                      return caml_exact_trampoline_cps_call
		                              (available_bindings,
		                               dummy,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$2
		(missing_var,
		 location,
		 name$0,
		 a,
		 KE,
		 function(a){
		  return caml_trampoline_cps_call3(a, pp_quoted, name$0, cont);
		 });
		                               });
		                     a = a[1];
		                     var get = a[2], type = a[1];
		                     return caml_exact_trampoline_cps_call$0
		                             (field,
		                              0,
		                              name$0,
		                              [0, type, get],
		                              function(res){
		                               if(0 === res[0]) return cont(res);
		                               var err = res[1];
		                               return caml_exact_trampoline_cps_call
		                                       (available_bindings,
		dummy,
		function(available_vars){
		 var match = err[1];
		 function a(a){return cont([1, a]);}
		 if(typeof match === "number") return a(err);
		 var suggestions = match[1], b = err[3], c = err[2];
		 return caml_exact_trampoline_cps_call$1
		         (plausible_suggestions,
		          name$0,
		          available_vars,
		          function(d){
		           return caml_exact_trampoline_cps_call$1
		                   (append$0,
		                    suggestions,
		                    d,
		                    function(d){return a([0, [0, d], c, b]);});
		          });
		});
		                              });
		                    });
		          });
		a = a[1];
		var get = a[2], type = a[1];
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$68,
		         function(a){
		          return caml_trampoline_cps_call3
		                  (a,
		                   pp_quoted,
		                   name$0,
		                   function(node_name){
		                    return caml_exact_trampoline_cps_call$1
		                            (Arr[26],
		                             dummy,
		                             get,
		                             function(run){return cont([0, [0, type, run]]);});
		                   });
		         });
		                                       });
		                             case 13:
		                              var fields = ast[1];
		                              return caml_trampoline_cps_call3
		                                      (Object[1], bindings, fields, cont);
		                             case 14:
		                              var
		                               pick = ast[2],
		                               exp = ast[1],
		                               m =
		                                 function(query, cont){
		                                  return caml_exact_trampoline_cps_call$1
		  (traverse_view,
		   query,
		   function(param, cont){
		    if(0 === param[0]){
		     var match = param[1];
		     if(typeof match !== "number" && 4 === match[0]){
		      var
		       exp_f = param[2],
		       exp_t = match[3],
		       ctx = function(param, cont){return cont([0, context_id]);},
		       a =
		         function(param, cont){
		          var pick_f = param[2], pick_t = param[1];
		          function a(Pick_cmp, cont){
		           function compare(l, r, cont){
		            return caml_trampoline_cps_call3
		                    (Pick_cmp[8], l, r, function(a){return cont(- a | 0);});
		           }
		           var
		            sexp_of_t = Pick_cmp[16][2],
		            include = Make$2([0, compare, sexp_of_t]),
		            comparator = include[16],
		            a =
		              Arr[4].call
		               (null,
		                function(param, cont){
		                 var values = param[2], match = param[1];
		                 function boundary(comparator, cont){
		                  function a(v, cont){
		                   return caml_exact_trampoline_cps_call$2
		                           (add,
		                            ctx,
		                            exp_t,
		                            v,
		                            values,
		                            function(values){
		                             return caml_trampoline_cps_call3
		                                     (Arr[13], pick_f, values, cont);
		                            });
		                  }
		                  return caml_trampoline_cps_call2
		                          (Arr[1][7],
		                           match,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$0
		                                    (Arr[1][22], b, comparator, a, cont);
		                           });
		                 }
		                 return 0 === pick[0]
		                         ? caml_exact_trampoline_cps_call
		                           (boundary, Pick_cmp[16], cont)
		                         : caml_exact_trampoline_cps_call(boundary, comparator, cont);
		                });
		           return caml_exact_trampoline_cps_call$1
		                   (Arr[24],
		                    exp_f,
		                    Arr[7],
		                    function(b){
		                     return caml_exact_trampoline_cps_call$1
		                             (Arr[18][1],
		                              b,
		                              a,
		                              function(run){
		                               return caml_exact_trampoline_cps_call
		                                       (Type[33],
		exp_t,
		function(type){
		 return caml_exact_trampoline_cps_call
		         (of_string$0, [0, type, run], cont);
		});
		                              });
		                    });
		          }
		          return caml_exact_trampoline_cps_call
		                  (Type[43],
		                   pick_t,
		                   function(t){
		                    function b(b){
		                     return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                    }
		                    if(0 === t[0]) return b(t);
		                    var msg = t[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (of_message$0,
		                             2,
		                             location,
		                             KG,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (a, msg, function(a){return b([1, a]);});
		                             });
		                   });
		         };
		      return caml_exact_trampoline_cps_call$1
		              (getf,
		               exp_t,
		               ctx,
		               function(b){
		                return caml_exact_trampoline_cps_call$3
		                        (add$0,
		                         0,
		                         context_id,
		                         exp_t,
		                         b,
		                         bindings,
		                         function(bindings){
		                          var match = pick[1];
		                          function b(b){
		                           return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (compile,
		                                    bindings,
		                                    [0, [12, context_id], of_lexing$0(KI, KH)],
		                                    b);
		                          var ast = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (compile, bindings, ast, b);
		                         });
		               });
		     }
		    }
		    return caml_exact_trampoline_cps_call(typefail, KF, cont);
		   },
		   cont);
		                                 };
		                              return caml_exact_trampoline_cps_call$1
		                                      (compile,
		                                       bindings,
		                                       exp,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1(let$0, a, m, cont);
		                                       });
		                             case 15:
		                              var selected = ast[2], expression$1 = ast[1];
		                              return caml_trampoline_cps_call4
		                                      (Select[1], bindings, expression$1, selected, cont);
		                             case 16:
		                              var s = ast[1];
		                              return caml_exact_trampoline_cps_call
		                                      (of_string$0,
		                                       return$(Type[15].call(null, Type[34], s), 0),
		                                       cont);
		                             case 17:
		                              var index = ast[2], collection = ast[1];
		                              return caml_trampoline_cps_call4
		                                      (Subscript[1], bindings, collection, index, cont);
		                             case 18:
		                              var
		                               type$0 = ast[2],
		                               expression$2 = ast[1],
		                               n =
		                                 function(param, cont){
		                                  var
		                                   a = param[2],
		                                   run = a[2],
		                                   type = a[1],
		                                   target = param[1][1];
		                                  function b(cast, cont){
		                                   return caml_exact_trampoline_cps_call$1
		   (Arr[18][1],
		    run,
		    cast,
		    function(a){return cont([0, target, a]);});
		                                  }
		                                  return caml_exact_trampoline_cps_call$0
		  (Type[49],
		   location,
		   target,
		   type,
		   function(a){
		    return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		   });
		                                 };
		                              return caml_exact_trampoline_cps_call$0
		                                      (compile_type,
		                                       [0, bindings],
		                                       0,
		                                       type$0[1],
		                                       function(left){
		return caml_trampoline_cps_call3
		        (Expression[1],
		         bindings,
		         expression$2,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (and,
		                   left,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1(let$0, a, n, cont);
		                   });
		         });
		                                       });
		                             case 19:
		                              var
		                               exp$0 = ast[2],
		                               o =
		                                 function(param, cont){
		                                  var run = param[2], type = param[1];
		                                  function a(a, cont){
		                                   if(0 === a[0]){
		                                    var
		                                     to_bool = a[1],
		                                     a =
		                                       Arr[2].call
		(null,
		 function(x, cont){
		  return caml_trampoline_cps_call2
		          (to_bool, x, function(a){return cont(1 - a);});
		 });
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[18][1],
		     run,
		     a,
		     function(run){return cont([0, 0, run]);});
		                                   }
		                                   var
		                                    to_bool_option = a[1],
		                                    a =
		                                      Arr[2].call
		                                       (null,
		function(x, cont){
		 return caml_trampoline_cps_call2
		         (to_bool_option,
		          x,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (map$17, a, function(a, cont){return cont(1 - a);}, cont);
		          });
		});
		                                   return caml_exact_trampoline_cps_call$1
		   (Arr[18][1],
		    run,
		    a,
		    function(run){
		     return caml_exact_trampoline_cps_call
		             (Type[33], 0, function(a){return cont([0, a, run]);});
		    });
		                                  }
		                                  return caml_exact_trampoline_cps_call$1
		  (to_bool_option,
		   location,
		   type,
		   function(b){
		    return caml_exact_trampoline_cps_call$1(symbol, b, a, cont);
		   });
		                                 };
		                              return caml_exact_trampoline_cps_call$1
		                                      (compile,
		                                       bindings,
		                                       exp$0,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1(let$0, a, o, cont);
		                                       });
		                             case 20:
		                              var filter = ast[2], exp$1 = ast[1];
		                              return caml_trampoline_cps_call4
		                                      (Where[1], bindings, exp$1, filter, cont);
		                             case 21:
		                              var sort = ast[2], expression$3 = ast[1];
		                              return caml_trampoline_cps_call4
		                                      (Sort[1], bindings, expression$3, sort, cont);
		                             default:
		                              var limit = ast[2], expression$4 = ast[1];
		                              return caml_trampoline_cps_call4
		                                      (Limit[1], bindings, expression$4, limit, cont);
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (update_mod,
		                                   KJ,
		                                   Expression,
		                                   [0, compile],
		                                   function(a){
		                                    function compile(bindings, param, cont){
		                                     if(0 === param[0]){
		                                      var name = param[1];
		                                      return cont([0, name]);
		                                     }
		                                     var expr = param[1];
		                                     function a(field_value, cont){
		                                      var a = field_value[1];
		                                      function c(n, cont){return cont(n);}
		                                      function b(a){
		                                       return caml_exact_trampoline_cps_call$1(let$2, a, c, cont);
		                                      }
		                                      if(typeof a !== "number" && 0 === a[0]){
		                                       var match = a[1];
		                                       if(typeof match !== "number" && 8 === match[0]){
		var field_name = a[2];
		return caml_exact_trampoline_cps_call
		        (of_string$0, [0, field_name], b);
		                                       }
		                                      }
		                                      var d = field_value[1], e = Type[9];
		                                      return caml_exact_trampoline_cps_call$0
		      (fail$4,
		       2,
		       expr[2],
		       KK,
		       function(a){return caml_trampoline_cps_call3(a, e, d, b);});
		                                     }
		                                     return caml_trampoline_cps_call3
		     (Expression[1],
		      bindings,
		      expr,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$0
		    (update_mod,
		     KL,
		     Field_name,
		     [0, compile],
		     function(a){
		      function compile(bindings, f, effective, cont){
		       function a(param, cont){
		        var type = param[1];
		        if(typeof type !== "number" && 2 === type[0]){
		         var run = param[2], lambdas = type[1];
		         return caml_exact_trampoline_cps_call$1
		                 (Arr[26],
		                  dummy,
		                  run,
		                  function(run){
		                   function hlist_head(param, cont){
		                    var hd = param[1];
		                    return cont(hd);
		                   }
		                   function hlist_tail(param, cont){
		                    var tl = param[2];
		                    return cont(tl);
		                   }
		                   function a(a, cont){
		                    var effective_run = a[2], effective_type = a[1];
		                    function try_lambda(param, lambda_run, cont){
		                     var
		                      result = param[3],
		                      parameters = param[2],
		                      formal = param[1];
		                     function a(cast, cont){
		                      var
		                       a =
		                         Arr[2].call
		                          (null,
		                           function(param, cont){
		                            var effective = param[2], lambda = param[1];
		                            return caml_trampoline_cps_call2(lambda, effective, cont);
		                           });
		                      return caml_exact_trampoline_cps_call$1
		                              (Arr[19],
		                               effective_run,
		                               cast,
		                               function(b){
		                                return caml_exact_trampoline_cps_call$1
		(Arr[24],
		 lambda_run,
		 b,
		 function(b){
		  return caml_exact_trampoline_cps_call$1
		          (Arr[19],
		           b,
		           a,
		           function(run){
		            return caml_trampoline_cps_call2
		                    (result, parameters, function(a){return cont([0, a, run]);});
		           });
		 });
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$0
		                             (try_with,
		                              function(param, cont){
		                               return caml_trampoline_cps_call2
		                                       (formal,
		parameters,
		function(a){
		 return caml_exact_trampoline_cps_call$0
		         (Type[49], f[2], [9, a], effective_type, cont);
		});
		                              },
		                              0,
		                              [0,
		                               function(effect, cont){
		                                if(effect[1] !== Type[40]) return cont(0);
		                                var a = effect[2], type = a[2][1], name = a[1];
		                                return caml_exact_trampoline_cps_call
		(debug,
		 function(m, cont){
		  return caml_trampoline_cps_call7
		          (m, 0, 0, KN, name, Type[9], type, cont);
		 },
		 function(match){
		  return cont
		          ([0,
		            function(k, cont){
		             return caml_exact_trampoline_cps_call$1
		                     (continue$, k, KO, cont);
		            }]);
		 });
		                               }],
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                              });
		                    }
		                    function null_passthrough(res, cont){
		                     function a(){return cont(res);}
		                     if(0 === res[0]) return a();
		                     var match = res[1][1];
		                     if(typeof match !== "number") return a();
		                     if(2 !== match) return a();
		                     function b(b){
		                      return b ? cont([0, [0, 5, Arr[5].call(null, 0)]]) : a();
		                     }
		                     if(typeof effective_type === "number"){if(5 === effective_type) return b(1);
		                     }
		                     else if(9 === effective_type[0]){
		                      var elts = effective_type[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (Type[3][6],
		                               elts,
		                               [0,
		                                function(t, cont){
		                                 return caml_exact_trampoline_cps_call$1
		 (Type[45],
		  Type[32],
		  t,
		  function(a){
		   return caml_trampoline_cps_call3
		           (map$17, a, function(param, cont){return cont(0);}, cont);
		  });
		                                }],
		                               function(a){return b(is_some(a));});
		                     }
		                     return b(0);
		                    }
		                    function b(lambdas, run){
		                     function a(a){
		                      return caml_exact_trampoline_cps_call
		                              (null_passthrough, a, cont);
		                     }
		                     if(! lambdas)
		                      return caml_exact_trampoline_cps_call$0
		                              (fail$4, 2, f[2], KP, a);
		                     var
		                      lambdas$0 = lambdas[2],
		                      head = lambdas[1],
		                      c = Arr[2].call(null, hlist_head);
		                     return caml_exact_trampoline_cps_call$1
		                             (Arr[18][1],
		                              run,
		                              c,
		                              function(c){
		                               return caml_exact_trampoline_cps_call$1
		                                       (try_lambda,
		head,
		c,
		function(ok){
		 if(0 === ok[0]) return a(ok);
		 var c = Arr[2].call(null, hlist_tail);
		 return caml_exact_trampoline_cps_call$1
		         (Arr[18][1],
		          run,
		          c,
		          function(run){
		           return caml_exact_trampoline_call2(b, lambdas$0, run);
		          });
		});
		                              });
		                    }
		                    if(! lambdas) return b(lambdas, run);
		                    if(lambdas[2]) return b(lambdas, run);
		                    var lambda = lambdas[1], a = Arr[2].call(null, hlist_head);
		                    return caml_exact_trampoline_cps_call$1
		                            (Arr[18][1],
		                             run,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (try_lambda,
		                                       lambda,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (null_passthrough, a, cont);
		                                       });
		                             });
		                   }
		                   function b(args, cont){
		                    function acc(param, cont){
		                     if(! param) return cont([0, 0, Arr[5].call(null, 0)]);
		                     var match = param[1], type_1 = match[1], a = param[2];
		                     if(a){
		                      var match$0 = a[1], run1 = match[2];
		                      if(0 === match$0[0]){
		                       var tail = a[2], run2 = match$0[2], type_2 = match$0[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (Arr[26],
		                                dummy,
		                                run1,
		                                function(run1){
		                                 return caml_exact_trampoline_cps_call$1
		 (Arr[26],
		  dummy,
		  run2,
		  function(run2){
		   return caml_exact_trampoline_cps_call
		           (acc,
		            tail,
		            function(match){
		             var
		              run_tail = match[2],
		              type_tail = match[1],
		              a =
		                Arr[2].call
		                 (null,
		                  function(param, cont){
		                   var tl = param[3], hd = param[2], hd$0 = param[1];
		                   return cont([0, hd$0, [0, hd, tl]]);
		                  });
		             return caml_exact_trampoline_cps_call$0
		                     (Arr[25],
		                      run1,
		                      run2,
		                      run_tail,
		                      function(b){
		                       return caml_exact_trampoline_cps_call$1
		                               (Arr[18][1],
		                                b,
		                                a,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (Arr[26],
		  dummy,
		  a,
		  function(a){
		   return cont([0, [0, type_1, [0, type_2, type_tail]], a]);
		  });
		                                });
		                      });
		            });
		  });
		                                });
		                      }
		                     }
		                     var tail$0 = param[2], run = match[2];
		                     return caml_exact_trampoline_cps_call$1
		                             (Arr[26],
		                              dummy,
		                              run,
		                              function(run){
		                               return caml_exact_trampoline_cps_call
		                                       (acc,
		tail$0,
		function(match){
		 var
		  run_tail = match[2],
		  type_tail = match[1],
		  a =
		    Arr[2].call
		     (null,
		      function(param, cont){
		       var tl = param[2], hd = param[1];
		       return cont([0, hd, tl]);
		      });
		 return caml_exact_trampoline_cps_call$1
		         (Arr[24],
		          run,
		          run_tail,
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (Arr[18][1],
		                    b,
		                    a,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1
		                             (Arr[26],
		                              dummy,
		                              a,
		                              function(a){return cont([0, [0, type_1, type_tail], a]);});
		                    });
		          });
		});
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (acc,
		                             args,
		                             function(match){
		                              var run = match[2], types = match[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (Arr[26],
		                                       dummy,
		                                       run,
		                                       function(run){return cont([0, [9, types], run]);});
		                             });
		                   }
		                   return caml_trampoline_cps_call2
		                           (Expression[1],
		                            bindings,
		                            function(c){
		                             return caml_trampoline_cps_call3
		                                     (map$18,
		                                      effective,
		                                      c,
		                                      function(c){
		                                       return caml_exact_trampoline_cps_call
		       (all$10,
		        c,
		        function(c){
		         return caml_exact_trampoline_cps_call$1
		                 (let$2,
		                  c,
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        }
		        var a = Type[9];
		        return caml_exact_trampoline_cps_call$0
		                (fail$4,
		                 2,
		                 f[2],
		                 KM,
		                 function(b){
		                  return caml_trampoline_cps_call3(b, a, type, cont);
		                 });
		       }
		       return caml_trampoline_cps_call3
		               (Expression[1],
		                bindings,
		                f,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(symbol, b, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$0
		              (update_mod,
		               KQ,
		               Call,
		               [0, compile],
		               function(a){
		                function compile(bindings, expression, indexed, key, cont){
		                 function a(query, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (traverse_view,
		                           query,
		                           function(param, cont){
		                            var context_run = param[2], context_type = param[1];
		                            return caml_exact_trampoline_cps_call
		                                    (nullable,
		                                     context_type,
		                                     function(Probe){
		                                      var map_type = Probe[1];
		                                      if(typeof map_type !== "number" && 4 === map_type[0]){
		                                       var
		data_type = map_type[3],
		ctx = function(param, cont){return cont([0, context_id]);},
		b =
		  function(a, cont){
		   var
		    b = a[2],
		    map_run = b[2],
		    selected_map_type = b[1],
		    a = a[1],
		    key_run = a[2],
		    key_type = a[1];
		   function c(Comparable, cont){
		    var
		     symbol = Comparable[1],
		     symbol$0 = Comparable[2],
		     symbol$1 = Comparable[3],
		     symbol$2 = Comparable[4],
		     symbol$3 = Comparable[5],
		     symbol$4 = Comparable[6],
		     equal = Comparable[7],
		     compare = Comparable[8],
		     min = Comparable[9],
		     max = Comparable[10],
		     ascending = Comparable[11],
		     descending = Comparable[12],
		     between = Comparable[13],
		     clamp_exn = Comparable[14],
		     clamp = Comparable[15],
		     comparator = Comparable[16];
		    function filter_map(values, cont){
		     var
		      a =
		        Arr[2].call
		         (null,
		          function(m, cont){
		           return caml_trampoline_cps_call2(return$9, m, cont);
		          }),
		      b = addf(ctx),
		      c =
		        Arr[2].call
		         (null,
		          function(v, cont){return cont([0, values, map_type, v]);});
		     return caml_exact_trampoline_cps_call$1
		             (Arr[18][1],
		              c,
		              b,
		              function(b){
		               return caml_exact_trampoline_cps_call$1
		                       (Arr[18][1],
		                        b,
		                        map_run,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1
		                                 (Arr[18][1],
		                                  b,
		                                  a,
		                                  function(filter){return cont(Arr[23].call(null, filter));});
		                        });
		              });
		    }
		    var
		     run =
		       Arr[4].call
		        (null,
		         function(values, cont){
		          function f(map, cont){
		           return caml_trampoline_cps_call3
		                   (symbol_map,
		                    map,
		                    function(param, cont){return cont(param);},
		                    function(map){
		                     function a(map, cont){return cont(map);}
		                     return caml_exact_trampoline_cps_call$0
		                             (Arr[1][21],
		                              map,
		                              [0, comparator],
		                              function(param, data, cont){
		                               return caml_trampoline_cps_call3
		                                       (let$,
		data,
		function(data, cont){
		 return caml_exact_trampoline_cps_call$2
		         (add,
		          ctx,
		          data_type,
		          data,
		          values,
		          function(values){
		           return caml_trampoline_cps_call3
		                   (Arr[13],
		                    key_run,
		                    values,
		                    function(a){
		                     return caml_trampoline_cps_call3
		                             (symbol_map, a, return$9, cont);
		                    });
		          });
		},
		cont);
		                              },
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (filter_map,
		values,
		function(c){
		 return caml_exact_trampoline_cps_call
		         (c,
		          b,
		          function(b){
		           return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		          });
		});
		                              });
		                    });
		          }
		          return caml_trampoline_cps_call3
		                  (Arr[13],
		                   context_run,
		                   values,
		                   function(a){
		                    return caml_trampoline_cps_call3(Probe[5], f, a, cont);
		                   });
		         }),
		     Comparable$0 =
		       [0,
		        symbol,
		        symbol$0,
		        symbol$1,
		        symbol$2,
		        symbol$3,
		        symbol$4,
		        equal,
		        compare,
		        min,
		        max,
		        ascending,
		        descending,
		        between,
		        clamp_exn,
		        clamp,
		        comparator];
		    return caml_exact_trampoline_cps_call
		            (make$19,
		             dummy,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (Probe[2],
		                       [4, 0, Comparable$0, selected_map_type, key_type, 0, 0, a],
		                       function(type){return cont([0, type, run]);});
		             });
		   }
		   return caml_exact_trampoline_cps_call
		           (Type[43],
		            key_type,
		            function(t){
		             function a(a){
		              return caml_exact_trampoline_cps_call$1(let$2, a, c, cont);
		             }
		             if(0 === t[0]) return a(t);
		             var msg = t[1];
		             return caml_exact_trampoline_cps_call$0
		                     (of_message$0,
		                      2,
		                      expression[2],
		                      KS,
		                      function(b){
		                       return caml_trampoline_cps_call2
		                               (b, msg, function(b){return a([1, b]);});
		                      });
		            });
		  };
		                                       return caml_exact_trampoline_cps_call$1
		       (getf,
		        data_type,
		        ctx,
		        function(a){
		         return caml_exact_trampoline_cps_call$3
		                 (add$0,
		                  0,
		                  context_id,
		                  data_type,
		                  a,
		                  bindings,
		                  function(bindings$0){
		                   return caml_trampoline_cps_call3
		                           (Expression[1],
		                            bindings$0,
		                            key,
		                            function(left){
		                             function a(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (and$0,
		                                       left,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1(let$1, a, b, cont);
		                                       });
		                             }
		                             if(! indexed)
		                              return caml_exact_trampoline_cps_call$1
		                                      (getf,
		                                       map_type,
		                                       ctx,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (of_string$0, [0, map_type, b], a);
		                                       });
		                             var selected = indexed[1], location = selected[2];
		                             return caml_exact_trampoline_cps_call$1
		                                     (getf,
		                                      map_type,
		                                      ctx,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$3
		       (add$0,
		        0,
		        context_id,
		        map_type,
		        b,
		        bindings,
		        function(bindings){
		         return caml_trampoline_cps_call3
		                 (Expression[1],
		                  bindings,
		                  [0,
		                   [15, [0, [12, context_id], location], selected],
		                   location],
		                  a);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      }
		                                      var a = Type[9];
		                                      return caml_exact_trampoline_cps_call$0
		      (fail$4,
		       2,
		       expression[2],
		       KR,
		       function(b){
		        return caml_trampoline_cps_call3(b, a, map_type, cont);
		       });
		                                     });
		                           },
		                           cont);
		                 }
		                 return caml_trampoline_cps_call3
		                         (Expression[1],
		                          bindings,
		                          expression,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (update_mod,
		                         KT,
		                         Index,
		                         [0, compile],
		                         function(a){
		                          function compile(bindings, condition, then, else$, cont){
		                           function general_case(param, cont){
		                            function a(param, cont){
		                             var run = param[2], type = param[1];
		                             function a(to_bool, cont){
		                              var a = Arr[7], b = Arr[2].call(null, to_bool);
		                              return caml_exact_trampoline_cps_call$1
		                                      (Arr[18][1],
		                                       run,
		                                       b,
		                                       function(b){
		return caml_exact_trampoline_cps_call$1
		        (Arr[24],
		         b,
		         a,
		         function(run){return cont([0, run, bindings, bindings]);});
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_bool,
		                                      condition[2],
		                                      type,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                                      });
		                            }
		                            return caml_trampoline_cps_call3
		                                    (Expression[1],
		                                     bindings,
		                                     condition,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                                     });
		                           }
		                           var b = condition[1];
		                           function d(param, cont){
		                            var
		                             else_bindings = param[3],
		                             then_bindings = param[2],
		                             condition_run = param[1];
		                            function a(a, cont){
		                             var
		                              b = a[2],
		                              else_run = b[2],
		                              else_type = b[1],
		                              a = a[1],
		                              then_run = a[2],
		                              then_type = a[1];
		                             return caml_exact_trampoline_cps_call$0
		                                     (unify,
		                                      0,
		                                      then_type,
		                                      else_type,
		                                      function(a){
		                                       if(a){
		a = a[1];
		var else$0 = a[3], then = a[2], type = a[1];
		return caml_exact_trampoline_cps_call$1
		        (Arr[18][1],
		         else_run,
		         else$0,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (Arr[18][1],
		                   then_run,
		                   then,
		                   function(c){
		                    var
		                     b =
		                       Arr[2].call
		                        (null,
		                         function(param, cont){
		                          var values = param[2], condition = param[1];
		                          return condition ? cont([0, values]) : cont([1, values]);
		                         });
		                    return caml_exact_trampoline_cps_call$0
		                            (Arr[16],
		                             b,
		                             c,
		                             a,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (Arr[15],
		                                       function(v, cont){
		return caml_trampoline_cps_call3
		        (Arr[1][8],
		         v,
		         calendar,
		         function(condition){
		          function a(param, cont){
		           var condition = param[2], values = param[1][2];
		           return cont([0, condition, values]);
		          }
		          return caml_trampoline_cps_call3
		                  (Arr[1][17],
		                   [0,
		                    symbol$10,
		                    symbol$6,
		                    symbol$8,
		                    symbol$9,
		                    symbol$5,
		                    symbol$7,
		                    equal$1,
		                    compare$2,
		                    min$5,
		                    max$5,
		                    ascending$0,
		                    descending$0,
		                    between$0,
		                    clamp_exn$0,
		                    clamp$0,
		                    comparator$0],
		                   condition,
		                   function(b){
		                    return caml_trampoline_cps_call3
		                            (and,
		                             v,
		                             b,
		                             function(b){
		                              return caml_trampoline_cps_call3(let$0, b, a, cont);
		                             });
		                   });
		         });
		                                       },
		                                       function(b){
		return caml_trampoline_cps_call2
		        (b,
		         condition_run,
		         function(b){
		          return caml_exact_trampoline_cps_call$1
		                  (Arr[18][1],
		                   b,
		                   a,
		                   function(run){
		                    return caml_exact_trampoline_cps_call
		                            (of_string$0, [0, type, run], cont);
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       }
		                                       var b = Type[9], c = Type[9];
		                                       return caml_exact_trampoline_cps_call$0
		       (fail$4,
		        2,
		        else$[2],
		        KU,
		        function(a){
		         return caml_trampoline_cps_call5
		                 (a, c, then_type, b, else_type, cont);
		        });
		                                      });
		                            }
		                            return caml_trampoline_cps_call3
		                                    (Expression[1],
		                                     then_bindings,
		                                     then,
		                                     function(left){
		                                      return caml_trampoline_cps_call3
		      (Expression[1],
		       else_bindings,
		       else$,
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (and$0,
		                 left,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                 });
		       });
		                                     });
		                           }
		                           function c(a){
		                            return caml_exact_trampoline_cps_call$1(let$1, a, d, cont);
		                           }
		                           if(typeof b !== "number" && 0 === b[0]){
		                            var lhs = b[1], a = lhs[1];
		                            if(typeof a !== "number" && 12 === a[0]){
		                             var op = b[2], name = a[1], a = op - 1 | 0;
		                             if(6 >= a >>> 0 && 3 !== a){
		                              var
		                               rhs = b[3],
		                               name_key = function(param, cont){return cont([0, name]);};
		                              return caml_exact_trampoline_cps_call$1
		                                      (find,
		                                       name,
		                                       bindings,
		                                       function(a){
		if(! a)
		 return caml_exact_trampoline_cps_call
		         (general_case, dummy, c);
		a = a[1];
		var lhs_get = a[2], lhs_type = a[1];
		function b(a, cont){
		 var rhs_run = a[2], rhs_type = a[1];
		 if(typeof lhs_type !== "number" && 10 === lhs_type[0]){
		  a = lhs_type[1];
		  var rtti = a[2], cases = a[1];
		  return caml_exact_trampoline_cps_call
		          (opaque,
		           cst_lhs,
		           function(lhs_id){
		            function lhs_key(param, cont){return cont([0, lhs_id]);}
		            return caml_exact_trampoline_cps_call
		                    (opaque,
		                     cst_rhs,
		                     function(rhs_id){
		                      function rhs_key(param, cont){return cont([0, rhs_id]);}
		                      function a(cases, cont){
		                       function variant(cases){
		                        if(cases && ! cases[2]){
		                         var type = cases[1][4];
		                         return [0, type];
		                        }
		                        return [0, [10, [0, cases, rtti]]];
		                       }
		                       return caml_exact_trampoline_cps_call$1
		                               (filter_map$0,
		                                cases,
		                                function(param, cont){
		                                 var then = param[2];
		                                 return cont(then);
		                                },
		                                function(a){
		                                 var then_type = variant(a)[1];
		                                 return caml_exact_trampoline_cps_call$1
		 (getf,
		  then_type,
		  name_key,
		  function(a){
		   return caml_exact_trampoline_cps_call$3
		           (add$0,
		            0,
		            name,
		            then_type,
		            a,
		            bindings,
		            function(then_bindings){
		             return caml_exact_trampoline_cps_call$1
		                     (filter_map$0,
		                      cases,
		                      function(param, cont){
		                       var else$ = param[3];
		                       return cont(else$);
		                      },
		                      function(a){
		                       var else_type = variant(a)[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (getf,
		                                else_type,
		                                name_key,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$3
		 (add$0,
		  0,
		  name,
		  else_type,
		  a,
		  bindings,
		  function(else_bindings){
		   function search_case(param, cont){
		    if(! param)
		     return cont
		             (Arr[2].call
		               (null,
		                function(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (failwith, "no case match", cont);
		                }));
		    var tail = param[2], run = param[1][1];
		    return caml_exact_trampoline_cps_call
		            (search_case,
		             tail,
		             function(c){
		              var
		               a = Arr[7],
		               b =
		                 Arr[2].call
		                  (null,
		                   function(param, cont){
		                    var input = param[2], res = param[1];
		                    if(! res) return cont([1, input]);
		                    var res$0 = res[1];
		                    return cont([0, res$0]);
		                   });
		              return caml_exact_trampoline_cps_call$0
		                      (Arr[16],
		                       b,
		                       a,
		                       c,
		                       function(a){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[24],
		                                 run,
		                                 Arr[7],
		                                 function(b){
		                                  return caml_exact_trampoline_cps_call$1
		  (Arr[18][1], b, a, cont);
		                                 });
		                       });
		             });
		   }
		   return caml_exact_trampoline_cps_call
		           (search_case,
		            cases,
		            function(run){
		             return cont([0, run, then_bindings, else_bindings]);
		            });
		  });
		                                });
		                      });
		            });
		  });
		                                });
		                      }
		                      return caml_trampoline_cps_call3
		                              (map$18,
		                               cases,
		                               function(case$, cont){
		                                var case_type = case$[4], lift = case$[2];
		                                function a(param, cont){
		                                 var run = param[2], type = param[1];
		                                 function a(to_bool, cont){
		                                  if(typeof type !== "number" && 0 === type[0]){
		                                   var a = type[1];
		                                   if(typeof a === "number" && ! a){
		                                    var
		                                     value = type[2],
		                                     c =
		                                       Arr[2].call
		(null,
		 function(param, cont){
		  var values = param[2], lifted = param[1];
		  return caml_trampoline_cps_call3
		          (map$17,
		           lifted,
		           function(lifted, cont){
		            return caml_exact_trampoline_cps_call$2
		                    (add,
		                     name_key,
		                     case_type,
		                     lifted,
		                     values,
		                     function(values){return cont([0, value, values]);});
		           },
		           cont);
		 }),
		                                     d = Arr[7],
		                                     a = Arr[2].call(null, lift);
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[18][1],
		     lhs_get,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (Arr[24],
		               a,
		               d,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (Arr[18][1],
		                         a,
		                         c,
		                         function(run){
		                          return value
		                                  ? cont([0, run, [0, case$], 0])
		                                  : cont([0, run, 0, [0, case$]]);
		                         });
		               });
		     });
		                                   }
		                                  }
		                                  a =
		                                   Arr[2].call
		                                    (null,
		                                     function(param, cont){
		                                      var
		                                       match = param[2],
		                                       lhs_value = match[2],
		                                       values = match[1],
		                                       condition = param[1];
		                                      return caml_exact_trampoline_cps_call$2
		      (add,
		       name_key,
		       lhs_type,
		       lhs_value,
		       values,
		       function(values){
		        return caml_trampoline_cps_call2
		                (to_bool,
		                 condition,
		                 function(a){return cont([0, [0, a, values]]);});
		       });
		                                     });
		                                  var b = Arr[11].call(null, run);
		                                  return caml_exact_trampoline_cps_call$1
		  (Arr[18][1],
		   b,
		   a,
		   function(c){
		    var
		     a = Arr[7],
		     b =
		       Arr[2].call
		        (null,
		         function(param, cont){
		          var values = param[3], rhs = param[2], lhs_value = param[1];
		          return caml_trampoline_cps_call2
		                  (lift,
		                   lhs_value,
		                   function(match){
		                    if(! match) return cont(KV);
		                    var lifted = match[1];
		                    return caml_exact_trampoline_cps_call$2
		                            (add,
		                             lhs_key,
		                             case_type,
		                             lifted,
		                             values,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$2
		                                      (add,
		                                       rhs_key,
		                                       rhs_type,
		                                       rhs,
		                                       a,
		                                       function(values){
		var x = [0, values, [0, values, lhs_value]];
		return cont([1, x]);
		                                       });
		                             });
		                   });
		         });
		    return caml_exact_trampoline_cps_call$0
		            (Arr[16],
		             b,
		             a,
		             c,
		             function(a){
		              return caml_exact_trampoline_cps_call$0
		                      (Arr[25],
		                       lhs_get,
		                       rhs_run,
		                       Arr[7],
		                       function(b){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][1],
		                                 b,
		                                 a,
		                                 function(run){
		                                  return cont([0, run, [0, case$], [0, case$]]);
		                                 });
		                       });
		             });
		   });
		                                 }
		                                 return caml_exact_trampoline_cps_call$1
		 (to_bool,
		  condition[2],
		  type,
		  function(b){
		   return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		  });
		                                }
		                                return caml_exact_trampoline_cps_call$1
		(getf,
		 case_type,
		 lhs_key,
		 function(b){
		  return caml_exact_trampoline_cps_call
		          (function(a, cont){
		            return caml_exact_trampoline_cps_call$3
		                    (add$0, 0, lhs_id, case_type, b, a, cont);
		           },
		           bindings,
		           function(b){
		            return caml_exact_trampoline_cps_call$1
		                    (getf,
		                     rhs_type,
		                     rhs_key,
		                     function(c){
		                      return caml_exact_trampoline_cps_call
		                              (function(a, cont){
		                                return caml_exact_trampoline_cps_call$3
		(add$0, 0, rhs_id, rhs_type, c, a, cont);
		                               },
		                               b,
		                               function(bindings){
		                                function b(a, cont){
		                                 var
		                                  b = a[2],
		                                  rhs_run = b[2],
		                                  rhs_type = b[1],
		                                  a = a[1],
		                                  lhs_run = a[2],
		                                  lhs_type = a[1];
		                                 return caml_exact_trampoline_cps_call$0
		 (unify,
		  1,
		  lhs_type,
		  rhs_type,
		  function(match){
		   if(! match)
		    return 2 <= op
		            ? 7
		              <= op
		              ? caml_exact_trampoline_cps_call
		                (of_string$0,
		                 return$(Type[15].call(null, Type[13], 1), 0),
		                 cont)
		              : caml_exact_trampoline_cps_call
		                (of_string$0, return$(5, 0), cont)
		            : caml_exact_trampoline_cps_call
		              (of_string$0,
		               return$(Type[15].call(null, Type[13], 0), 0),
		               cont);
		   var unification = match[1];
		   return caml_exact_trampoline_cps_call$3
		           (cmp, condition[2], op, lhs_run, rhs_run, unification, cont);
		  });
		                                }
		                                return caml_trampoline_cps_call3
		(Expression[1],
		 bindings,
		 [0, [12, lhs_id], lhs[2]],
		 function(left){
		  return caml_trampoline_cps_call3
		          (Expression[1],
		           bindings,
		           [0, [12, rhs_id], rhs[2]],
		           function(c){
		            return caml_exact_trampoline_cps_call$1
		                    (and$0,
		                     left,
		                     c,
		                     function(c){
		                      return caml_exact_trampoline_cps_call$1
		                              (let$1,
		                               c,
		                               b,
		                               function(b){
		                                return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               },
		                               function(b){
		                                return caml_exact_trampoline_cps_call
		(all$10,
		 b,
		 function(b){
		  return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		 });
		                               });
		                     });
		           });
		 }
		 return caml_exact_trampoline_cps_call
		         (general_case, dummy, cont);
		}
		return caml_trampoline_cps_call3
		        (Expression[1],
		         bindings,
		         rhs,
		         function(a){
		          return caml_exact_trampoline_cps_call$1(let$1, a, b, c);
		         });
		                                       });
		                             }
		                            }
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (general_case, dummy, c);
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (update_mod,
		                                   KW,
		                                   If,
		                                   [0, compile],
		                                   function(a){
		                                    function compile(bindings, fields, cont){
		                                     function a(fields, cont){
		                                      return caml_trampoline_cps_call3
		      (map$18,
		       fields,
		       function(param, cont){
		        var type = param[2][1], name = param[1];
		        return cont([0, name, [0, type]]);
		       },
		       function(a){
		        return caml_exact_trampoline_cps_call$0
		                (Type[53],
		                 0,
		                 0,
		                 a,
		                 function(type){
		                  var
		                   run =
		                     Arr[4].call
		                      (null,
		                       function(values, cont){
		                        return caml_trampoline_cps_call3
		                                (map$18,
		                                 fields,
		                                 function(a, cont){
		                                  a = a[2];
		                                  var run = a[2], type = a[1];
		                                  function b(res, cont){return cont([0, [0, type, res]]);}
		                                  return caml_trampoline_cps_call3
		  (Arr[13],
		   run,
		   values,
		   function(a){
		    return caml_trampoline_cps_call3(symbol_map, a, b, cont);
		   });
		                                 },
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (M[11],
		   a,
		   function(a){
		    return caml_trampoline_cps_call3(M[8], a, to_array, cont);
		   });
		                                 });
		                       });
		                  return cont([0, type, run]);
		                 });
		       });
		                                     }
		                                     return caml_trampoline_cps_call3
		     (map$18,
		      fields,
		      function(param, cont){
		       var value = param[2], name = param[1];
		       function a(value, cont){return cont([0, name, value]);}
		       return caml_trampoline_cps_call3
		               (Expression[1],
		                bindings,
		                value,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                });
		      },
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (all$10,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$0
		    (update_mod,
		     KX,
		     Object,
		     [0, compile],
		     function(a){
		      function sort_list
		      (bindings,
		       element_type,
		       iterator,
		       sort_expr,
		       direction,
		       cont){
		       function ctx(param, cont){return cont([0, context_id]);}
		       return caml_exact_trampoline_cps_call$1
		               (getf,
		                element_type,
		                ctx,
		                function(a){
		                 return caml_exact_trampoline_cps_call$3
		                         (add$0,
		                          0,
		                          context_id,
		                          element_type,
		                          a,
		                          bindings,
		                          function(bindings){
		                           function a(bindings){
		                            function a(param, cont){
		                             var filter_run = param[2], type = param[1];
		                             function a(Cmp, cont){
		                              return cont
		                                      (Arr[4].call
		(null,
		 function(param, cont){
		  var values = param[2], list = param[1];
		  function a(a, cont){
		   return caml_trampoline_cps_call3(map$18, a, get_data, cont);
		  }
		  var
		   b =
		     direction ? of_rev_keys : function(a, cont){return cont(a);};
		  function c(c, param, cont){
		   var b = param[1], a = c[1];
		   return caml_trampoline_cps_call3(Cmp[8], a, b, cont);
		  }
		  function d(a, cont){
		   return caml_exact_trampoline_cps_call$1
		           (stable_sort, a, c, cont);
		  }
		  return caml_trampoline_cps_call3
		          (map$18,
		           list,
		           function(v, cont){
		            return caml_exact_trampoline_cps_call$2
		                    (add,
		                     ctx,
		                     element_type,
		                     v,
		                     values,
		                     function(values){
		                      function a(sort_key, cont){return cont([0, sort_key, v]);}
		                      return caml_trampoline_cps_call3
		                              (Arr[13],
		                               filter_run,
		                               values,
		                               function(b){
		                                return caml_trampoline_cps_call3(let$0, b, a, cont);
		                               });
		                     });
		           },
		           function(c){
		            return caml_trampoline_cps_call2
		                    (Arr[1][11],
		                     c,
		                     function(c){
		                      return caml_trampoline_cps_call3
		                              (symbol_map,
		                               c,
		                               d,
		                               function(c){
		                                return caml_trampoline_cps_call3
		(symbol_map,
		 c,
		 b,
		 function(b){
		  return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		 });
		                               });
		                     });
		           });
		 }));
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (Type[43],
		                                      type,
		                                      function(t){
		                                       function b(b){
		return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                                       }
		                                       if(0 === t[0]) return b(t);
		                                       var msg = t[1];
		                                       return caml_exact_trampoline_cps_call$0
		       (of_message$0,
		        2,
		        sort_expr[2],
		        KY,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a, msg, function(a){return b([1, a]);});
		        });
		                                      });
		                            }
		                            return caml_trampoline_cps_call3
		                                    (Expression[1],
		                                     bindings,
		                                     sort_expr,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                                     });
		                           }
		                           if(! iterator) return a(bindings);
		                           var iterator$0 = iterator[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (getf,
		                                    element_type,
		                                    ctx,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$3
		     (add$0, 0, iterator$0, element_type, b, bindings, a);
		                                    });
		                          });
		                });
		      }
		      function compile(bindings, expression, param, cont){
		       var direction = param[2], sort_expr = param[1];
		       function a(query, cont){
		        return caml_exact_trampoline_cps_call$1
		                (traverse_view,
		                 query,
		                 function(param, cont){
		                  var run = param[2], type = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (nullable,
		                           type,
		                           function(ThisProbe){
		                            var match = ThisProbe[1];
		                            if(typeof match !== "number")
		                             switch(match[0]){
		                               case 3:
		                                var
		                                 iterator = match[2],
		                                 element_type = match[1],
		                                 b =
		                                   function(f, cont){
		                                    return caml_exact_trampoline_cps_call
		    (ThisProbe[4],
		     f,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (Arr[24],
		               run,
		               Arr[7],
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (Arr[18][1],
		                         b,
		                         a,
		                         function(run){
		                          return caml_exact_trampoline_cps_call
		                                  (ThisProbe[2],
		                                   ThisProbe[1],
		                                   function(type){return cont([0, type, run]);});
		                         });
		               });
		     });
		                                   };
		                                return caml_exact_trampoline_cps_call$3
		(sort_list,
		 bindings,
		 element_type,
		 iterator,
		 sort_expr,
		 direction,
		 function(a){
		  return caml_exact_trampoline_cps_call$1(let$2, a, b, cont);
		 });
		                               case 4:
		                                var
		                                 iterator$0 = match[5],
		                                 element_type$0 = match[3],
		                                 c =
		                                   function(f_list, cont){
		                                    var
		                                     a =
		                                       Arr[2].call
		(null,
		 function(sorted_list, cont){
		  return caml_exact_trampoline_cps_call$1
		          (mapi$0,
		           sorted_list,
		           function(idx, elt, cont){
		            return cont([0, caml_int64_of_int32(idx), elt]);
		           },
		           function(a){
		            return caml_exact_trampoline_cps_call$1
		                    (of_alist_exn$1, [0, comparator$6], a, cont);
		           });
		 }),
		                                     b =
		                                       Arr[2].call
		(null,
		 function(param, cont){
		  var values = param[2];
		  return caml_exact_trampoline_cps_call
		          (encode,
		           param[1],
		           function(a){return cont([0, a, values]);});
		 });
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[18][1],
		     b,
		     f_list,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (Arr[18][1],
		               b,
		               a,
		               function(f){
		                return caml_exact_trampoline_cps_call
		                        (ThisProbe[4],
		                         f,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (Arr[24],
		                                   run,
		                                   Arr[7],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[18][1],
		     b,
		     a,
		     function(run){
		      return caml_exact_trampoline_cps_call
		              (make$19,
		               dummy,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (ThisProbe[2],
		                         [4,
		                          0,
		                          [0,
		                           function(b, a, cont){return cont(caml_greaterequal(b, a));},
		                           function(b, a, cont){return cont(caml_lessequal(b, a));},
		                           function(b, a, cont){return cont(caml_equal(b, a));},
		                           function(b, a, cont){return cont(caml_greaterthan(b, a));},
		                           function(b, a, cont){return cont(caml_lessthan(b, a));},
		                           function(b, a, cont){return cont(caml_notequal(b, a));},
		                           equal64,
		                           compare$19,
		                           min$3,
		                           max$3,
		                           ascending,
		                           descending,
		                           between$3,
		                           clamp_exn$2,
		                           clamp$2,
		                           comparator$6],
		                          match[3],
		                          1,
		                          match[5],
		                          0,
		                          a],
		                         function(type){return cont([0, type, run]);});
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   };
		                                return caml_exact_trampoline_cps_call$3
		(sort_list,
		 bindings,
		 element_type$0,
		 iterator$0,
		 sort_expr,
		 direction,
		 function(a){
		  return caml_exact_trampoline_cps_call$1(let$2, a, c, cont);
		 });
		                             }
		                            var a = Type[9];
		                            return caml_exact_trampoline_cps_call$0
		                                    (fail$4,
		                                     2,
		                                     expression[2],
		                                     KZ,
		                                     function(b){
		                                      return caml_trampoline_cps_call3(b, a, type, cont);
		                                     });
		                           });
		                 },
		                 cont);
		       }
		       return caml_trampoline_cps_call3
		               (Expression[1],
		                bindings,
		                expression,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$0
		              (update_mod,
		               K0,
		               Sort,
		               [0, compile],
		               function(a){
		                function compile(bindings, location, query, filter, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (traverse_view,
		                          query,
		                          function(param, cont){
		                           var run = param[2], type = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (Arr[26],
		                                    dummy,
		                                    run,
		                                    function(run){
		                                     return caml_exact_trampoline_cps_call
		     (nullable,
		      type,
		      function(Probe){
		       var type = Probe[1];
		       if(typeof type !== "number")
		        switch(type[0]){
		          case 3:
		           var iterator = type[2], element_type = type[1];
		           return caml_exact_trampoline_cps_call
		                   (fresh_pure,
		                    dummy,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$0
		                             (value_map,
		                              iterator,
		                              a,
		                              pure,
		                              function(ctx){
		                               return caml_exact_trampoline_cps_call$1
		                                       (getf,
		element_type,
		ctx,
		function(a){
		 return caml_exact_trampoline_cps_call$3
		         (add$0,
		          0,
		          context_id,
		          element_type,
		          a,
		          bindings,
		          function(bindings){
		           function a(bindings){
		            function a(param, cont){
		             var filter_run = param[2], type$0 = param[1];
		             function a(to_bool, cont){
		              var
		               run$0 =
		                 Arr[4].call
		                  (null,
		                   function(values, cont){
		                    var
		                     f =
		                       Arr[4].call
		                        (null,
		                         function(list, cont){
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   list,
		                                   function(v, cont){
		                                    return caml_exact_trampoline_cps_call$2
		    (add,
		     ctx,
		     element_type,
		     v,
		     values,
		     function(values){
		      function a(keep, cont){
		       return caml_trampoline_cps_call2
		               (to_bool, keep, function(a){return cont(some_if(a, v));});
		      }
		      return caml_trampoline_cps_call3
		              (Arr[13],
		               filter_run,
		               values,
		               function(b){
		                return caml_trampoline_cps_call3(let$0, b, a, cont);
		               });
		     });
		                                   },
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (Arr[1][11],
		     a,
		     function(a){
		      return caml_trampoline_cps_call3
		              (symbol_map, a, filter_opt, cont);
		     });
		                                   });
		                         });
		                    return caml_exact_trampoline_cps_call
		                            (Probe[3],
		                             f,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (Arr[18][1],
		                                       run,
		                                       a,
		                                       function(a){
		return caml_trampoline_cps_call3(Arr[13], a, values, cont);
		                                       });
		                             });
		                   });
		              return caml_exact_trampoline_cps_call
		                      (Probe[2],
		                       [3, element_type, type[2]],
		                       function(type){return cont([0, type, run$0]);});
		             }
		             return caml_exact_trampoline_cps_call$1
		                     (to_bool,
		                      filter[2],
		                      type$0,
		                      function(b){
		                       return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                      });
		            }
		            return caml_trampoline_cps_call3
		                    (Expression[1],
		                     bindings,
		                     filter,
		                     function(b){
		                      return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                     });
		           }
		           if(! iterator) return a(bindings);
		           var iterator$0 = iterator[1];
		           return caml_exact_trampoline_cps_call$1
		                   (getf,
		                    element_type,
		                    ctx,
		                    function(b){
		                     return caml_exact_trampoline_cps_call$3
		                             (add$0, 0, iterator$0, element_type, b, bindings, a);
		                    });
		          });
		});
		                              });
		                    });
		          case 4:
		           var iterator$0 = type[5], element_type$0 = type[3];
		           return caml_exact_trampoline_cps_call
		                   (fresh_pure,
		                    dummy,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$0
		                             (value_map,
		                              iterator$0,
		                              a,
		                              pure,
		                              function(ctx){
		                               return caml_exact_trampoline_cps_call$1
		                                       (getf,
		element_type$0,
		ctx,
		function(a){
		 return caml_exact_trampoline_cps_call$3
		         (add$0,
		          0,
		          context_id,
		          element_type$0,
		          a,
		          bindings,
		          function(bindings){
		           function a(bindings){
		            function a(param, cont){
		             var filter_run = param[2], type$0 = param[1];
		             function a(to_bool, cont){
		              function filter_map(values, cont){
		               var
		                a =
		                  Arr[2].call
		                   (null,
		                    function(param, cont){
		                     var v = param[2], keep = param[1];
		                     return caml_trampoline_cps_call2
		                             (to_bool, keep, function(a){return cont(some_if(a, v));});
		                    }),
		                b = addf(ctx),
		                c =
		                  Arr[2].call
		                   (null,
		                    function(v, cont){
		                     return cont([0, values, element_type$0, v]);
		                    });
		               return caml_exact_trampoline_cps_call$1
		                       (Arr[18][1],
		                        c,
		                        b,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1
		                                 (Arr[18][1],
		                                  b,
		                                  filter_run,
		                                  function(b){
		                                   b = Arr[11].call(null, b);
		                                   return caml_exact_trampoline_cps_call$1
		   (Arr[18][1],
		    Arr[8],
		    b,
		    function(b){
		     return caml_exact_trampoline_cps_call$1
		             (Arr[18][1],
		              b,
		              a,
		              function(filter){return cont(Arr[23].call(null, filter));});
		    });
		                                  });
		                        });
		              }
		              var
		               a =
		                 Arr[4].call
		                  (null,
		                   function(values, cont){
		                    function f(map, cont){
		                     function a(m, cont){return cont(m);}
		                     return caml_trampoline_cps_call3
		                             (symbol_map,
		                              map,
		                              function(param, cont){return cont(param);},
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (filter_map,
		values,
		function(c){
		 return caml_exact_trampoline_cps_call
		         (c,
		          b,
		          function(b){
		           return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		          });
		});
		                              });
		                    }
		                    return caml_trampoline_cps_call3
		                            (Arr[13],
		                             run,
		                             values,
		                             function(a){
		                              return caml_trampoline_cps_call3(Probe[5], f, a, cont);
		                             });
		                   });
		              return caml_trampoline_cps_call2
		                      (Arr[26],
		                       "Where run",
		                       function(b){
		                        return caml_trampoline_cps_call2
		                                (b,
		                                 a,
		                                 function(run){
		                                  return caml_exact_trampoline_cps_call
		  (Probe[2],
		   [4,
		    type[1],
		    type[2],
		    element_type$0,
		    type[4],
		    type[5],
		    type[6],
		    type[7]],
		   function(type){return cont([0, type, run]);});
		                                 });
		                       });
		             }
		             return caml_exact_trampoline_cps_call$1
		                     (to_bool,
		                      filter[2],
		                      type$0,
		                      function(b){
		                       return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                      });
		            }
		            return caml_trampoline_cps_call3
		                    (Expression[1],
		                     bindings,
		                     filter,
		                     function(b){
		                      return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                     });
		           }
		           if(! iterator$0) return a(bindings);
		           var iterator = iterator$0[1];
		           return caml_exact_trampoline_cps_call$1
		                   (getf,
		                    element_type$0,
		                    ctx,
		                    function(b){
		                     return caml_exact_trampoline_cps_call$3
		                             (add$0, 0, iterator, element_type$0, b, bindings, a);
		                    });
		          });
		});
		                              });
		                    });
		        }
		       var a = Type[9];
		       return caml_exact_trampoline_cps_call$0
		               (fail$4,
		                2,
		                location,
		                K1,
		                function(b){
		                 return caml_trampoline_cps_call3(b, a, type, cont);
		                });
		      });
		                                    });
		                          },
		                          cont);
		                }
		                function compile$0(bindings, expression, filter, cont){
		                 function a(query, cont){
		                  return caml_exact_trampoline_cps_call$2
		                          (compile, bindings, expression[2], query, filter, cont);
		                 }
		                 return caml_trampoline_cps_call3
		                         (Expression[1],
		                          bindings,
		                          expression,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (update_mod,
		                         K2,
		                         Where,
		                         [0, compile$0, compile],
		                         function(a){
		                          function compile(bindings, expression, selected, cont){
		                           function a(query, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (traverse_view,
		                                     query,
		                                     function(param, cont){
		                                      var run = param[2], t = param[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (Arr[26],
		       dummy,
		       run,
		       function(run){
		        return caml_exact_trampoline_cps_call
		                (nullable,
		                 t,
		                 function(Probe){
		                  var match = Probe[1];
		                  if(typeof match !== "number")
		                   switch(match[0]){
		                     case 3:
		                      var iterator = match[2], data_type = match[1];
		                      return caml_exact_trampoline_cps_call
		                              (fresh_pure,
		                               dummy,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$0
		(value_map,
		 iterator,
		 a,
		 pure,
		 function(ctx){
		  return caml_trampoline_cps_call3
		          (map$17,
		           iterator,
		           function(i, cont){
		            return cont
		                    ([0, i, function(param, cont){return cont([0, i]);}]);
		           },
		           function(iterator_with_key){
		            function a(param, cont){
		             var selected_run = param[2], selected_type = param[1];
		             function values_add(key, cont){
		              var
		               a = addf(key),
		               b =
		                 Arr[2].call
		                  (null,
		                   function(param, cont){
		                    var data = param[2], values = param[1];
		                    return cont([0, values, data_type, data]);
		                   });
		              return caml_exact_trampoline_cps_call$1
		                      (Arr[18][1], b, a, cont);
		             }
		             function a(b){
		              var a = Arr[2].call(null, get_data);
		              return caml_exact_trampoline_cps_call
		                      (values_add,
		                       ctx,
		                       function(c){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[24],
		                                 c,
		                                 a,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$1
		  (Arr[18][1],
		   a,
		   b,
		   function(a){
		    return caml_trampoline_cps_call2
		            (Arr[26],
		             "Add iterator",
		             function(b){
		              return caml_trampoline_cps_call2
		                      (b,
		                       a,
		                       function(values){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][1],
		                                 values,
		                                 selected_run,
		                                 function(f){
		                                  var
		                                   a = Arr[22].call(null, f),
		                                   b =
		                                     Arr[2].call
		                                      (null,
		                                       function(param, cont){
		var values = param[2], lst = param[1];
		return caml_trampoline_cps_call3
		        (map$18,
		         lst,
		         function(x, cont){return cont([0, values, x]);},
		         cont);
		                                       });
		                                  return caml_exact_trampoline_cps_call$1
		  (Arr[18][1],
		   b,
		   a,
		   function(f){
		    return caml_exact_trampoline_cps_call$1
		            (Arr[24],
		             run,
		             Arr[7],
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (Probe[4],
		                       f,
		                       function(b){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][2],
		                                 b,
		                                 a,
		                                 function(run){
		                                  return caml_exact_trampoline_cps_call
		  (Probe[2],
		   [3, selected_type, match[2]],
		   function(type){return cont([0, type, run]);});
		                                 });
		                       });
		             });
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       });
		             }
		             if(! iterator_with_key)
		              return a(Arr[2].call(null, calendar));
		             var iterator_key = iterator_with_key[1][2];
		             return caml_exact_trampoline_cps_call
		                     (values_add, iterator_key, a);
		            }
		            return caml_exact_trampoline_cps_call$1
		                    (getf,
		                     data_type,
		                     ctx,
		                     function(b){
		                      return caml_exact_trampoline_cps_call$3
		                              (add$0,
		                               0,
		                               context_id,
		                               data_type,
		                               b,
		                               bindings,
		                               function(bindings){
		                                function b(bindings){
		                                 return caml_trampoline_cps_call3
		 (Expression[1],
		  bindings,
		  selected,
		  function(b){
		   return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		  });
		                                }
		                                if(! iterator_with_key) return b(bindings);
		                                var
		                                 match = iterator_with_key[1],
		                                 iterator_key = match[2],
		                                 iterator = match[1];
		                                return caml_exact_trampoline_cps_call$1
		(getf,
		 data_type,
		 iterator_key,
		 function(a){
		  return caml_exact_trampoline_cps_call$3
		          (add$0, 0, iterator, data_type, a, bindings, b);
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     case 4:
		                      var iterator$0 = match[5], data_type$0 = match[3];
		                      return caml_exact_trampoline_cps_call
		                              (fresh_pure,
		                               dummy,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$0
		(value_map,
		 iterator$0,
		 a,
		 pure,
		 function(ctx){
		  return caml_trampoline_cps_call3
		          (map$17,
		           iterator$0,
		           function(i, cont){
		            return cont
		                    ([0, i, function(param, cont){return cont([0, i]);}]);
		           },
		           function(iterator_with_key){
		            function a(param, cont){
		             var selected_run = param[2], selected_type = param[1];
		             function filter_map(values, cont){
		              function a(set_values){
		               var
		                a = Arr[2].call(null, return$9),
		                b =
		                  Arr[2].call
		                   (null,
		                    function(v, cont){return cont([0, values, data_type$0, v]);});
		               return caml_exact_trampoline_cps_call$1
		                       (Arr[18][1],
		                        b,
		                        set_values,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1
		                                 (Arr[18][1],
		                                  b,
		                                  selected_run,
		                                  function(b){
		                                   return caml_exact_trampoline_cps_call$1
		   (Arr[18][1],
		    b,
		    a,
		    function(filter){return cont(Arr[23].call(null, filter));});
		                                  });
		                        });
		              }
		              if(! iterator_with_key) return a(addf(ctx));
		              var
		               iterator_key = iterator_with_key[1][2],
		               b = addf(iterator_key),
		               c =
		                 Arr[2].call
		                  (null,
		                   function(a, cont){
		                    var values = a[2], a = a[1], v = a[3], data_type = a[2];
		                    return cont([0, values, data_type, v]);
		                   }),
		               d = addf(ctx);
		              return caml_exact_trampoline_cps_call$1
		                      (Arr[24],
		                       Arr[7],
		                       d,
		                       function(d){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][1],
		                                 d,
		                                 c,
		                                 function(c){
		                                  return caml_exact_trampoline_cps_call$1(Arr[18][1], c, b, a);
		                                 });
		                       });
		             }
		             var
		              run$0 =
		                Arr[4].call
		                 (null,
		                  function(values, cont){
		                   function f(map, cont){
		                    function a(m, cont){return cont(m);}
		                    return caml_trampoline_cps_call3
		                            (symbol_map,
		                             map,
		                             function(param, cont){return cont(param);},
		                             function(b){
		                              return caml_exact_trampoline_cps_call
		                                      (filter_map,
		                                       values,
		                                       function(c){
		return caml_exact_trampoline_cps_call
		        (c,
		         b,
		         function(b){
		          return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		         });
		                                       });
		                             });
		                   }
		                   return caml_trampoline_cps_call3
		                           (Arr[13],
		                            run,
		                            values,
		                            function(a){
		                             return caml_trampoline_cps_call3(Probe[5], f, a, cont);
		                            });
		                  });
		             return caml_exact_trampoline_cps_call
		                     (Probe[2],
		                      [4,
		                       0,
		                       match[2],
		                       selected_type,
		                       match[4],
		                       match[5],
		                       match[6],
		                       match[7]],
		                      function(type){return cont([0, type, run$0]);});
		            }
		            return caml_exact_trampoline_cps_call$1
		                    (getf,
		                     data_type$0,
		                     ctx,
		                     function(b){
		                      return caml_exact_trampoline_cps_call$3
		                              (add$0,
		                               0,
		                               context_id,
		                               data_type$0,
		                               b,
		                               bindings,
		                               function(bindings){
		                                function b(bindings){
		                                 return caml_trampoline_cps_call3
		 (Expression[1],
		  bindings,
		  selected,
		  function(b){
		   return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		  });
		                                }
		                                if(! iterator_with_key) return b(bindings);
		                                var
		                                 match = iterator_with_key[1],
		                                 iterator_key = match[2],
		                                 iterator = match[1];
		                                return caml_exact_trampoline_cps_call$1
		(getf,
		 data_type$0,
		 iterator_key,
		 function(a){
		  return caml_exact_trampoline_cps_call$3
		          (add$0, 0, iterator, data_type$0, a, bindings, b);
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                   }
		                  var a = Type[9];
		                  return caml_exact_trampoline_cps_call$0
		                          (fail$4,
		                           2,
		                           expression[2],
		                           K3,
		                           function(b){
		                            return caml_trampoline_cps_call3(b, a, t, cont);
		                           });
		                 });
		       });
		                                     },
		                                     cont);
		                           }
		                           return caml_trampoline_cps_call3
		                                   (Expression[1],
		                                    bindings,
		                                    expression,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (update_mod,
		                                   K4,
		                                   Select,
		                                   [0, compile],
		                                   function(a){
		                                    function compile(bindings, expression, limit, cont){
		                                     function a(query_expression, cont){
		                                      function a(query_limit, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (traverse_view,
		        query_limit,
		        function(a, cont){
		         var limit_run = a[2], limit_type = a[1];
		         function c(limit_value, cont){
		          return caml_exact_trampoline_cps_call$1
		                  (traverse_view,
		                   query_expression,
		                   function(param, cont){
		                    var collection_run = param[2], collection_type = param[1];
		                    return caml_exact_trampoline_cps_call
		                            (nullable,
		                             collection_type,
		                             function(Probe){
		                              var match = Probe[1];
		                              if(typeof match !== "number")
		                               switch(match[0]){
		                                 case 3:
		                                  var
		                                   f =
		                                     Arr[2].call
		                                      (null,
		                                       function(param, cont){
		var count = param[2], list = param[1];
		return caml_exact_trampoline_cps_call$1
		        (take$0, list, count, cont);
		                                       });
		                                  return caml_exact_trampoline_cps_call
		  (Probe[4],
		   f,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (Arr[24],
		             collection_run,
		             limit_value,
		             function(b){
		              return caml_exact_trampoline_cps_call$1
		                      (Arr[18][1],
		                       b,
		                       a,
		                       function(run){
		                        return caml_exact_trampoline_cps_call
		                                (Probe[2],
		                                 Probe[1],
		                                 function(type){
		                                  return caml_exact_trampoline_cps_call
		  (of_string$0, [0, type, run], cont);
		                                 });
		                       });
		             });
		   });
		                                 case 4:
		                                  var
		                                   Comparable = match[2],
		                                   comparator = Comparable[16],
		                                   f$0 =
		                                     Arr[2].call
		                                      (null,
		                                       function(param, cont){
		var count = param[2];
		return caml_exact_trampoline_cps_call$2
		        (to_sequence$2,
		         0,
		         0,
		         0,
		         param[1],
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (take$1,
		                   a,
		                   count,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (of_sequence_exn$1, [0, comparator], a, cont);
		                   });
		         });
		                                       });
		                                  return caml_exact_trampoline_cps_call
		  (Probe[4],
		   f$0,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (Arr[24],
		             collection_run,
		             limit_value,
		             function(b){
		              return caml_exact_trampoline_cps_call$1
		                      (Arr[18][1],
		                       b,
		                       a,
		                       function(run){
		                        return caml_exact_trampoline_cps_call
		                                (Probe[2],
		                                 Probe[1],
		                                 function(type){
		                                  return caml_exact_trampoline_cps_call
		  (of_string$0, [0, type, run], cont);
		                                 });
		                       });
		             });
		   });
		                               }
		                              var a = Type[9];
		                              return caml_exact_trampoline_cps_call$0
		                                      (fail$4,
		                                       2,
		                                       expression[2],
		                                       K5,
		                                       function(b){
		return caml_trampoline_cps_call3
		        (b, a, collection_type, cont);
		                                       });
		                             });
		                   },
		                   cont);
		         }
		         function b(a){
		          return caml_exact_trampoline_cps_call$1(let$1, a, c, cont);
		         }
		         if(typeof limit_type === "number"){
		          if(1 === limit_type){
		           a =
		            Arr[2].call
		             (null,
		              function(a, cont){return cont(caml_int64_to_int32(a));});
		           return caml_exact_trampoline_cps_call$1
		                   (Arr[18][1], limit_run, a, function(a){return b([0, a]);});
		          }
		         }
		         else if(0 === limit_type[0]){
		          a = limit_type[1];
		          if(typeof a === "number" && 1 === a){
		           var value = limit_type[2];
		           return b([0, Arr[5].call(null, caml_int64_to_int32(value))]);
		          }
		         }
		         var d = Type[9];
		         return caml_exact_trampoline_cps_call$0
		                 (fail$4,
		                  2,
		                  limit[2],
		                  K6,
		                  function(a){
		                   return caml_trampoline_cps_call3(a, d, limit_type, b);
		                  });
		        },
		        cont);
		                                      }
		                                      return caml_trampoline_cps_call3
		      (Expression[1],
		       bindings,
		       limit,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		       });
		                                     }
		                                     return caml_trampoline_cps_call3
		     (Expression[1],
		      bindings,
		      expression,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$0
		    (update_mod,
		     K7,
		     Limit,
		     [0, compile],
		     function(a){
		      function compile(bindings, collection, index, cont){
		       function a(query_collection, cont){
		        return caml_exact_trampoline_cps_call$1
		                (traverse_view,
		                 query_collection,
		                 function(param, cont){
		                  var collection_run = param[2], collection_type = param[1];
		                  function a(query_index, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (traverse_view,
		                            query_index,
		                            function(param, cont){
		                             var index_run = param[2], index_type = param[1];
		                             return caml_exact_trampoline_cps_call
		                                     (nullable,
		                                      collection_type,
		                                      function(Probe_collection){
		                                       return caml_exact_trampoline_cps_call
		       (nullable,
		        index_type,
		        function(Probe_index){
		         var match = Probe_collection[1];
		         if(typeof match !== "number" && 4 === match[0]){
		          var
		           key_type = match[4],
		           data_type = match[3],
		           open =
		             o
		              ([0,
		                symbol_bind$1,
		                symbol_map$0,
		                Let_syntax$0,
		                ,
		                bind$1,
		                of_string$0,
		                map$5]),
		           let$ = open[4],
		           b =
		             function(cast, cont){
		              var
		               lookup =
		                 Arr[2].call
		                  (null,
		                   function(param, cont){
		                    return caml_trampoline_cps_call2
		                            (Arr[1][7],
		                             param,
		                             function(a){return cont(Arr[1][2][1].call(null, a));});
		                   }),
		               a =
		                 Arr[4].call
		                  (null,
		                   function(param, cont){
		                    var match = param[1];
		                    if(! match)
		                     return caml_trampoline_cps_call2(Arr[1][7], 0, cont);
		                    var lookup = param[2], index = match[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (Arr[1][2][2], lookup, index, cont);
		                   });
		              return caml_exact_trampoline_cps_call$1
		                      (Arr[21],
		                       cast,
		                       lookup,
		                       function(b){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[18][1],
		                                 b,
		                                 a,
		                                 function(f){
		                                  return caml_exact_trampoline_cps_call$1
		  (Arr[21],
		   index_run,
		   Arr[7],
		   function(a){
		    return caml_exact_trampoline_cps_call
		            (Probe_index[4],
		             f,
		             function(b){
		              return caml_exact_trampoline_cps_call$1
		                      (Arr[18][2],
		                       b,
		                       a,
		                       function(f){
		                        return caml_exact_trampoline_cps_call$1
		                                (Arr[24],
		                                 collection_run,
		                                 Arr[7],
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$1
		  (Arr[18][1],
		   Arr[10],
		   f,
		   function(b){
		    return caml_exact_trampoline_cps_call
		            (Probe_collection[4],
		             b,
		             function(b){
		              return caml_exact_trampoline_cps_call$1
		                      (Arr[18][2],
		                       b,
		                       a,
		                       function(run){
		                        return caml_exact_trampoline_cps_call
		                                (Type[33],
		                                 data_type,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (Probe_index[2],
		   a,
		   function(a){
		    return caml_exact_trampoline_cps_call
		            (Probe_collection[2],
		             a,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (nullable_join, [0, a, run], cont);
		             });
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       });
		             };
		          return caml_exact_trampoline_cps_call$0
		                  (Type[49],
		                   index[2],
		                   key_type,
		                   Probe_index[1],
		                   function(error){
		                    function a(a){
		                     return caml_exact_trampoline_cps_call$1(let$2, a, b, cont);
		                    }
		                    if(0 !== error[0])
		                     return caml_exact_trampoline_cps_call
		                             (Type[46],
		                              key_type,
		                              function(match){
		                               if(typeof match === "number") return a(error);
		                               if(11 !== match[0]) return a(error);
		                               var b = match[1];
		                               if(! b) return a(error);
		                               b = b[1];
		                               if(0 === b[0]){
		                                var
		                                 repr = match[2],
		                                 build = b[1],
		                                 c =
		                                   function(cast, cont){
		                                    var
		                                     a =
		                                       Arr[2].call
		(null,
		 function(x, cont){
		  return caml_trampoline_cps_call2
		          (build, x, function(x){return cont([0, x]);});
		 });
		                                    return caml_exact_trampoline_cps_call$1
		    (Arr[18][1], cast, a, cont);
		                                   };
		                                return caml_exact_trampoline_cps_call$0
		(Type[49],
		 index[2],
		 repr,
		 Probe_index[1],
		 function(b){
		  return caml_trampoline_cps_call3(let$, b, c, a);
		 });
		                               }
		                               var repr$0 = match[2], build$0 = b[1];
		                               function d(cast, cont){
		                                var a = Arr[2].call(null, build$0);
		                                return caml_exact_trampoline_cps_call$1
		(Arr[18][1], cast, a, cont);
		                               }
		                               return caml_exact_trampoline_cps_call$0
		                                       (Type[49],
		index[2],
		repr$0,
		Probe_index[1],
		function(b){
		 return caml_trampoline_cps_call3(let$, b, d, a);
		});
		                              });
		                    var f = error[1], c = Arr[2].call(null, return$9);
		                    return caml_exact_trampoline_cps_call$1
		                            (Arr[18][1], f, c, function(b){return a([0, b]);});
		                   });
		         }
		         var a = Type[9];
		         return caml_exact_trampoline_cps_call$0
		                 (fail$4,
		                  2,
		                  collection[2],
		                  K8,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (b, a, collection_type, cont);
		                  });
		        });
		                                      });
		                            },
		                            cont);
		                  }
		                  return caml_trampoline_cps_call3
		                          (Expression[1],
		                           bindings,
		                           index,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                           });
		                 },
		                 cont);
		       }
		       return caml_trampoline_cps_call3
		               (Expression[1],
		                bindings,
		                collection,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$0
		              (update_mod,
		               K9,
		               Subscript,
		               [0, compile],
		               function(a){return cont();});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (Make$11,
		                 [[0,
		                   ,
		                   [0, make$18, find_packed_by_id],
		                   symbol_bind$15,
		                   symbol_map$13,
		                   ,
		                   bind$21,
		                   return$20,
		                   map$33,
		                   ,
		                   ,
		                   all$17,
		                   ,
		                   Let_syntax$9,
		                   ,
		                   map2$0,
		                   map3,
		                   cut,
		                   name$13,
		                   filter_map$3,
		                   filter_map$3,
		                   index_by,
		                   max$14]]);
		               var cst_stripe = "stripe-";
		               function make$20(opt, name){
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          dummy,
		                          function(schematic_schema_version){
		                           var s2 = name + cst_id$1;
		                           return cont
		                                   ([0,
		                                     [0, cst_stripe + s2],
		                                     0,
		                                     schematic_param_name_schema_ve[3],
		                                     schematic_param_name_schema_ve[4]]);
		                          });
		                }
		                return [0, schema_versioned];
		               }
		               var
		                schematic_cache$234 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$158 = [];
		               caml_update_dummy
		                (letrec_function_context$158, [0, schematic_cache$234]);
		               var schematic_schema_version$9 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$158[1][1],
		                    schematic_schema_version$9]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$158[1][1],
		                             schematic_schema_version$9,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$158[1][1],
		schematic_schema_version$9,
		schematic_self,
		function(a){
		 letrec_function_context$158[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       page = a[2][1],
		       limit = a[1],
		       query = param[1];
		      return cont([0, query, limit, page]);
		     },
		     function(param, cont){
		      var page = param[3], limit = param[2], query = param[1];
		      return cont([0, query, [0, limit, [0, page, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_query,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0, 0, 0, 0, 0, cst_limit, 0, 3, [0, int_schema], 0, 0],
		       [0,
		        [0, 0, 0, 0, 0, cst_page, 0, 3, [0, int_schema], 0, 0],
		        0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$158[1][1],
		          schematic_schema_version$9,
		          res,
		          function(a){
		           letrec_function_context$158[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var cst_ref = "ref";
		               function expandable_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_elt_schema_ver,
		                                    schematic_param_id_schema_vers,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_elt_schema_ver,
		                                     schematic_param_id_schema_vers){
		                                     return [11,
		     0,
		     [0,
		      [0,
		       function(f0, cont){return cont([0, f0]);},
		       function(param, cont){
		        if(0 !== param[0]) return cont(0);
		        var f0 = param[1];
		        return cont([0, f0]);
		       },
		       0,
		       0,
		       cst_ref,
		       "Ref",
		       schematic_param_id_schema_vers,
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(0 === param[0]) return cont(0);
		         var f0 = param[1];
		         return cont([0, f0]);
		        },
		        0,
		        0,
		        "inline",
		        "Inline",
		        schematic_param_elt_schema_ver,
		        0],
		       0]],
		     0];
		                                    }
		                                    var
		                                     schematic_schema_id = cst_stripe + "expandable",
		                                     schematic_parametric =
		                                       [0,
		[1,
		 "elt",
		 schematic_param_elt_schema_ver,
		 function(schematic_param_elt_schema_ver, cont){
		  return cont
		          ([1,
		            cst_id,
		            schematic_param_id_schema_vers,
		            function(schematic_param_id_schema_vers, cont){
		             return cont
		                     ([0,
		                       schematic_schema_id,
		                       descriptor
		                        (schematic_param_elt_schema_ver,
		                         schematic_param_id_schema_vers)]);
		            }]);
		 }]],
		                                     a =
		                                       descriptor
		(schematic_param_elt_schema_ver,
		 schematic_param_id_schema_vers),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, K_, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$159 = [];
		               function automatic_tax_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$159[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + "-automatic-tax"], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$159[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$159[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$159[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var enabled = param[1];
		                                 return cont([0, enabled]);
		                                },
		                                function(param, cont){
		                                 var enabled = param[1];
		                                 return cont([0, enabled, 0]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_enabled, 0, 2, [0, bool_schema], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$159[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$159[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$235 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$159, [0, schematic_cache$235]);
		               caml_callback
		                (automatic_tax_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                Id$0 = make$20(0, cst_prod),
		                cst_product = "product",
		                d_ = [];
		               function schema_versioned$94(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   d_[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + cst_product], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                d_[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d_[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            d_[1][1] = a;
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_updated,
		                               0,
		                               2,
		                               [0, timestamp_schema_versioned()],
		                               0,
		                               0],
		                              0];
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "images",
		                                 0,
		                                 2,
		                                 [0, [0, 0, 0, [3, schema$268], 0]],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_url,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_created,
		                                   0,
		                                   2,
		                                   [0, timestamp_schema_versioned()],
		                                   0,
		                                   0],
		                                  a]]];
		                            return caml_exact_trampoline_cps_call
		                                    (marketing_feature_schema_versi,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_name,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_description,
		    0,
		    3,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_metadata,
		     0,
		     2,
		     [0,
		      [0,
		       0,
		       0,
		       mapping_schema(schematic_param_name_schema_ve)[3],
		       0]],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      "marketing_features",
		      0,
		      2,
		      [0, [0, 0, 0, [3, c], 0]],
		      0,
		      0],
		     b]]]];
		                                      return caml_exact_trampoline_cps_call
		      (Id$0[1],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              updated = g[2][1],
		              created = g[1],
		              url = f[1],
		              images = e[1],
		              marketing_features = d[1],
		              metadata = c[1],
		              description = b[1],
		              name = a[1],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       name,
		                       description,
		                       metadata,
		                       marketing_features,
		                       images,
		                       url,
		                       created,
		                       updated]);
		            },
		            function(param, cont){
		             var
		              updated = param[9],
		              created = param[8],
		              url = param[7],
		              images = param[6],
		              marketing_features = param[5],
		              metadata = param[4],
		              description = param[3],
		              name = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        name,
		                        [0,
		                         description,
		                         [0,
		                          metadata,
		                          [0,
		                           marketing_features,
		                           [0, images, [0, url, [0, created, [0, updated, 0]]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 d_[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){d_[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$160 = [];
		               function marketing_feature_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$160[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "product-marketing-feature"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$160[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$160[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$160[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var name = param[1];
		                                 return cont([0, name]);
		                                },
		                                function(param, cont){
		                                 var name = param[1];
		                                 return cont([0, name, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$160[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$160[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$236 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d_, [0, schematic_cache$236]);
		               var schematic_cache$237 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$160, [0, schematic_cache$237]);
		               caml_callback
		                (schema_versioned$94,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (marketing_feature_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$238 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$161 = [];
		               caml_update_dummy
		                (letrec_function_context$161, [0, schematic_cache$238]);
		               function schematic_version$29(param, cont){return cont();}
		               var
		                cst_starting_after = "starting_after",
		                schematic_schema_version$150 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$161[1][1],
		                    schematic_schema_version$150]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$161[1][1],
		                             schematic_schema_version$150,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$161[1][1],
		schematic_schema_version$150,
		schematic_self,
		function(b){
		 letrec_function_context$161[1][1] = b;
		 var
		  a =
		    [0,
		     [0, 0, 0, 0, 0, cst_limit, 0, 3, [0, int_schema], 0, 0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (Id$0[1],
		          schematic_version$29,
		          function(b){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var limit = param[2][1], starting_after = param[1];
		                return cont([0, starting_after, limit]);
		               },
		               function(param, cont){
		                var limit = param[2], starting_after = param[1];
		                return cont([0, starting_after, [0, limit, 0]]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_starting_after, 0, 3, [0, b], 0, 0],
		                a]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$161[1][1],
		                    schematic_schema_version$150,
		                    res,
		                    function(a){
		                     letrec_function_context$161[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$239 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$162 = [];
		               caml_update_dummy
		                (letrec_function_context$162, [0, schematic_cache$239]);
		               function schematic_version$30(param, cont){return cont(0);}
		               var
		                cst_has_more = "has_more",
		                schematic_schema_version$149 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$162[1][1],
		                    schematic_schema_version$149]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$162[1][1],
		                             schematic_schema_version$149,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$162[1][1],
		schematic_schema_version$149,
		schematic_self,
		function(b){
		 letrec_function_context$162[1][1] = b;
		 var
		  a =
		    [0,
		     [0, 0, 0, 0, 0, cst_has_more, 0, 3, [0, bool_schema], 0, 0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$94,
		          schematic_version$30,
		          function(b){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 has_more = a[2][1],
		                 data = a[1],
		                 object = param[1];
		                return cont([0, object, data, has_more]);
		               },
		               function(param, cont){
		                var has_more = param[3], data = param[2], object = param[1];
		                return cont([0, object, [0, data, [0, has_more, 0]]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_object,
		                 0,
		                 2,
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   [11,
		                    0,
		                    [0,
		                     [0,
		                      function(param, cont){return cont(848054398);},
		                      function(param, cont){return cont(La);},
		                      0,
		                      0,
		                      cst_list,
		                      cst_List,
		                      K$,
		                      0],
		                     0],
		                    1],
		                   0]],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_data,
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, b], 0]],
		                  0,
		                  0],
		                 a]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$162[1][1],
		                    schematic_schema_version$149,
		                    res,
		                    function(a){
		                     letrec_function_context$162[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_price = "price",
		                Id$1 = make$20(0, cst_price),
		                cst_currency = "currency",
		                d$ = [];
		               function schema_versioned$95(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   d$[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + cst_price], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                d$[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d$[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            d$[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Id$0[1],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_product, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (recurrence_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_active, 0, 2, [0, bool_schema], 0, 0],
		            [0,
		             [0, 0, 0, 0, 0, "unit_amount", 0, 3, [0, int_schema], 0, 0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_currency,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0, [0, 0, 0, 0, 0, "recurring", 0, 3, [0, c], 0, 0], a]]]];
		        return caml_exact_trampoline_cps_call
		                (Id$1[1],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        product = d[2][1],
		                        recurring = d[1],
		                        currency = c[1],
		                        unit_amount = b[1],
		                        active = a[1],
		                        id = param[1];
		                       return cont
		                               ([0, id, active, unit_amount, currency, recurring, product]);
		                      },
		                      function(param, cont){
		                       var
		                        product = param[6],
		                        recurring = param[5],
		                        currency = param[4],
		                        unit_amount = param[3],
		                        active = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0,
		                                  active,
		                                  [0,
		                                   unit_amount,
		                                   [0, currency, [0, recurring, [0, product, 0]]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           d$[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){d$[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$163 = [];
		               function recurrence_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$163[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + "price-recurrence"], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$163[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$163[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$163[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var interval_count = param[2][1], interval = param[1];
		                                 return cont([0, interval, interval_count]);
		                                },
		                                function(param, cont){
		                                 var interval_count = param[2], interval = param[1];
		                                 return cont([0, interval, [0, interval_count, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_interval,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "interval_count",
		                                   0,
		                                   2,
		                                   [0, int_schema],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$163[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$163[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$240 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(d$, [0, schematic_cache$240]);
		               var schematic_cache$241 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$163, [0, schematic_cache$241]);
		               caml_callback
		                (schema_versioned$95,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (recurrence_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                Id$2 = make$20(0, "cus"),
		                schematic_cache$242 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$164 = [];
		               caml_update_dummy
		                (letrec_function_context$164, [0, schematic_cache$242]);
		               function schematic_version$31(param, cont){return cont();}
		               var schematic_schema_version$148 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$164[1][1],
		                    schematic_schema_version$148]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$164[1][1],
		                             schematic_schema_version$148,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$164[1][1],
		schematic_schema_version$148,
		schematic_self,
		function(b){
		 letrec_function_context$164[1][1] = b;
		 var
		  default$ = match$113[1],
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_email,
		      0,
		      3,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_name,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_description,
		        0,
		        3,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_metadata,
		         0,
		         3,
		         [0,
		          [0,
		           0,
		           0,
		           mapping_schema(schematic_param_name_schema_ve)[3],
		           0]],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_deleted,
		          0,
		          [0, default$],
		          [0, bool_schema],
		          0,
		          0],
		         0]]]]];
		 return caml_exact_trampoline_cps_call
		         (Id$2[1],
		          schematic_version$31,
		          function(b){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 b = a[2],
		                 c = b[2],
		                 d = c[2],
		                 deleted = d[2][1],
		                 metadata = d[1],
		                 description = c[1],
		                 name = b[1],
		                 email = a[1],
		                 id = param[1];
		                return cont
		                        ([0, id, email, name, description, metadata, deleted]);
		               },
		               function(param, cont){
		                var
		                 deleted = param[6],
		                 metadata = param[5],
		                 description = param[4],
		                 name = param[3],
		                 email = param[2],
		                 id = param[1];
		                return cont
		                        ([0,
		                          id,
		                          [0,
		                           email,
		                           [0, name, [0, description, [0, metadata, [0, deleted, 0]]]]]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$164[1][1],
		                    schematic_schema_version$148,
		                    res,
		                    function(a){
		                     letrec_function_context$164[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$243 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$165 = [];
		               caml_update_dummy
		                (letrec_function_context$165, [0, schematic_cache$243]);
		               var schematic_schema_version$10 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$165[1][1],
		                    schematic_schema_version$10]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$165[1][1],
		                             schematic_schema_version$10,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$165[1][1],
		schematic_schema_version$10,
		schematic_self,
		function(a){
		 letrec_function_context$165[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       metadata = b[2][1],
		       description = b[1],
		       name = a[1],
		       email = param[1];
		      return cont([0, email, name, description, metadata]);
		     },
		     function(param, cont){
		      var
		       metadata = param[4],
		       description = param[3],
		       name = param[2],
		       email = param[1];
		      return cont
		              ([0, email, [0, name, [0, description, [0, metadata, 0]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_email,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_name,
		        0,
		        3,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_description,
		         0,
		         3,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_metadata,
		          0,
		          3,
		          [0,
		           [0,
		            0,
		            0,
		            mapping_schema(schematic_param_name_schema_ve)[3],
		            0]],
		          0,
		          0],
		         0]]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$165[1][1],
		          schematic_schema_version$10,
		          res,
		          function(a){
		           letrec_function_context$165[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                Id$3 = make$20(0, "pi"),
		                cst_client_secret = "client_secret",
		                letrec_function_context$166 = [];
		               function schema_versioned$96(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$166[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + "payment-intent"], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$166[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$166[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$166[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_client_secret,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$3[1],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var client_secret = param[2][1], id = param[1];
		   return cont([0, id, client_secret]);
		  },
		  function(param, cont){
		   var client_secret = param[2], id = param[1];
		   return cont([0, id, [0, client_secret, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$166[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$166[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$244 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$166, [0, schematic_cache$244]);
		               caml_callback
		                (schema_versioned$96,
		                 [function(param, cont){return cont(0);}]);
		               var
		                Subscription_id = make$20(0, "sub"),
		                Id$4 = make$20(0, cst_in),
		                cst_Draft = "Draft",
		                cst_Open = "Open",
		                ea = [];
		               function status_schema_versioned$2(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   ea[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + "invoice-status"], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                ea[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ea[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            ea[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(Lk);},
		                                  0,
		                                  0,
		                                  cst_draft,
		                                  cst_Draft,
		                                  Lj,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(Li) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_open,
		                                   cst_Open,
		                                   Lh,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(Lg) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_paid,
		                                    "Paid",
		                                    Lf,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(Le) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_uncollectible,
		                                     "Uncollectible",
		                                     Ld,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 <= param ? cont(Lc) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_void,
		                                      "Void",
		                                      Lb,
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     ea[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){ea[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_due_date = "due_date",
		                letrec_function_context$167 = [];
		               function schema_versioned$97(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$167[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + "invoice"], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$167[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$167[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$167[1][1] = a;
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "effective_at",
		                               0,
		                               3,
		                               [0, timestamp_schema_versioned()],
		                               0,
		                               0],
		                              0];
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_due_date,
		                               0,
		                               3,
		                               [0, timestamp_schema_versioned()],
		                               0,
		                               0],
		                              a];
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_created,
		                               0,
		                               2,
		                               [0, timestamp_schema_versioned()],
		                               0,
		                               0],
		                              a];
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               "period_end",
		                               0,
		                               2,
		                               [0, timestamp_schema_versioned()],
		                               0,
		                               0],
		                              a];
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_currency,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0, Ll, 0, 0, 0, cst_total, 0, 2, [0, int_schema], 0, 0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "period_start",
		                                   0,
		                                   2,
		                                   [0, timestamp_schema_versioned()],
		                                   0,
		                                   0],
		                                  a]]];
		                            return caml_exact_trampoline_cps_call
		                                    (Subscription_id[1],
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (expandable_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call$1
		                (c,
		                 no_input_schema,
		                 a,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_subscription, 0, 3, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (status_schema_versioned$2,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "hosted_invoice_url",
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "invoice_pdf",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], a]]];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$3[1],
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$96,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (expandable_schema_versioned,
		                 schematic_version,
		                 function(d){
		                  return caml_exact_trampoline_cps_call$1
		                          (d,
		                           c,
		                           a,
		                           function(c){
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, "payment_intent", 0, 3, [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$4[1],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    j = i[2],
		    k = j[2],
		    effective_at = k[2][1],
		    due_date = k[1],
		    created = j[1],
		    period_end = i[1],
		    period_start = h[1],
		    total = g[1],
		    currency = f[1],
		    subscription = e[1],
		    status = d[1],
		    invoice_pdf = c[1],
		    hosted_invoice_url = b[1],
		    payment_intent = a[1],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             payment_intent,
		             hosted_invoice_url,
		             invoice_pdf,
		             status,
		             subscription,
		             currency,
		             total,
		             period_start,
		             period_end,
		             created,
		             due_date,
		             effective_at]);
		  },
		  function(param, cont){
		   var
		    effective_at = param[13],
		    due_date = param[12],
		    created = param[11],
		    period_end = param[10],
		    period_start = param[9],
		    total = param[8],
		    currency = param[7],
		    subscription = param[6],
		    status = param[5],
		    invoice_pdf = param[4],
		    hosted_invoice_url = param[3],
		    payment_intent = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0,
		              payment_intent,
		              [0,
		               hosted_invoice_url,
		               [0,
		                invoice_pdf,
		                [0,
		                 status,
		                 [0,
		                  subscription,
		                  [0,
		                   currency,
		                   [0,
		                    total,
		                    [0,
		                     period_start,
		                     [0,
		                      period_end,
		                      [0, created, [0, due_date, [0, effective_at, 0]]]]]]]]]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$167[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$167[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$245 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ea, [0, schematic_cache$245]);
		               var schematic_cache$246 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$167, [0, schematic_cache$246]);
		               caml_callback
		                (status_schema_versioned$2,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (schema_versioned$97,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_customer = "customer",
		                letrec_function_context$168 = [];
		               function query_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$168[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(a){return cont();}
		                                    return match
		    ? a()
		    : caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$168[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$168[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(b){
		                             letrec_function_context$168[1][1] = b;
		                             var
		                              a =
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_limit, 0, 3, [0, int_schema], 0, 0],
		                                 0];
		                             return caml_exact_trampoline_cps_call
		                                     (Id$4[1],
		                                      schematic_version,
		                                      function(c){
		                                       var
		b =
		  [0, [0, 0, 0, 0, 0, "ending_before", 0, 3, [0, c], 0, 0], a];
		                                       return caml_exact_trampoline_cps_call
		       (Id$4[1],
		        schematic_version,
		        function(c){
		         var
		          a =
		            [0,
		             [0, 0, 0, 0, 0, cst_starting_after, 0, 3, [0, c], 0, 0],
		             b];
		         return caml_exact_trampoline_cps_call
		                 (Subscription_id[1],
		                  schematic_version,
		                  function(c){
		                   var
		                    b =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_subscription, 0, 3, [0, c], 0, 0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (status_schema_versioned$2,
		                            schematic_version,
		                            function(c){
		                             var
		                              a = [0, [0, 0, 0, 0, 0, cst_status, 0, 3, [0, c], 0, 0], b];
		                             return caml_exact_trampoline_cps_call
		                                     (Id$2[1],
		                                      schematic_version,
		                                      function(b){
		                                       var
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     b = a[2],
		     c = b[2],
		     d = c[2],
		     limit = d[2][1],
		     ending_before = d[1],
		     starting_after = c[1],
		     subscription = b[1],
		     status = a[1],
		     customer = param[1];
		    return cont
		            ([0,
		              customer,
		              status,
		              subscription,
		              starting_after,
		              ending_before,
		              limit]);
		   },
		   function(param, cont){
		    var
		     limit = param[6],
		     ending_before = param[5],
		     starting_after = param[4],
		     subscription = param[3],
		     status = param[2],
		     customer = param[1];
		    return cont
		            ([0,
		              customer,
		              [0,
		               status,
		               [0,
		                subscription,
		                [0, starting_after, [0, ending_before, [0, limit, 0]]]]]]);
		   },
		   [0, [0, 0, 0, 0, 0, cst_customer, 0, 3, [0, b], 0, 0], a]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context$168[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context$168[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                   });
		                         });
		               }
		               var schematic_cache$247 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$168, [0, schematic_cache$247]);
		               caml_callback
		                (query_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$169 = [];
		               function result_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$169[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(a){return cont();}
		                                    return match
		    ? a()
		    : caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$169[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$169[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(b){
		                             letrec_function_context$169[1][1] = b;
		                             var
		                              a =
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_has_more, 0, 3, [0, bool_schema], 0, 0],
		                                 0];
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$97,
		                                      schematic_version,
		                                      function(b){
		                                       var
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     has_more = a[2][1],
		     data = a[1],
		     object = param[1];
		    return cont([0, object, data, has_more]);
		   },
		   function(param, cont){
		    var has_more = param[3], data = param[2], object = param[1];
		    return cont([0, object, [0, data, [0, has_more, 0]]]);
		   },
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_object,
		     0,
		     2,
		     [0,
		      [0,
		       0,
		       0,
		       [11,
		        0,
		        [0,
		         [0,
		          function(param, cont){return cont(848054398);},
		          function(param, cont){return cont(Ln);},
		          0,
		          0,
		          cst_list,
		          cst_List,
		          Lm,
		          0],
		         0],
		        1],
		       0]],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_data,
		      0,
		      2,
		      [0, [0, 0, 0, [3, b], 0]],
		      0,
		      0],
		     a]]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context$169[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context$169[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                   });
		                         });
		               }
		               var schematic_cache$248 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$169, [0, schematic_cache$248]);
		               caml_callback
		                (result_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                Id$5 = make$20(0, cst_si),
		                cst_quantity = "quantity",
		                eb = [];
		               function item_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   eb[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-item"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                eb[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           eb[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            eb[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_quantity, 0, 3, [0, int_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$95,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_object,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_price, 0, 2, [0, c], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call
		      (Id$5[1],
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              quantity = b[2][1],
		              price = b[1],
		              object = a[1],
		              id = param[1];
		             return cont([0, id, object, price, quantity]);
		            },
		            function(param, cont){
		             var
		              quantity = param[4],
		              price = param[3],
		              object = param[2],
		              id = param[1];
		             return cont
		                     ([0, id, [0, object, [0, price, [0, quantity, 0]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 eb[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){eb[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$170 = [];
		               function schema_versioned$98(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$170[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-items"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$170[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$170[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$170[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (item_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var data = param[2][1], object = param[1];
		   return cont([0, object, data]);
		  },
		  function(param, cont){
		   var data = param[2], object = param[1];
		   return cont([0, object, [0, data, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_object,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_data,
		     0,
		     2,
		     [0, [0, 0, 0, [3, a], 0]],
		     0,
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$170[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$170[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$249 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(eb, [0, schematic_cache$249]);
		               var schematic_cache$250 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$170, [0, schematic_cache$250]);
		               caml_callback
		                (item_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (schema_versioned$98,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$251 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$171 = [];
		               caml_update_dummy
		                (letrec_function_context$171, [0, schematic_cache$251]);
		               var schematic_schema_version$11 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$171[1][1],
		                    schematic_schema_version$11]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$171[1][1],
		                             schematic_schema_version$11,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$171[1][1],
		schematic_schema_version$11,
		schematic_self,
		function(a){
		 letrec_function_context$171[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var quantity = param[1];
		      return cont([0, quantity]);
		     },
		     function(param, cont){
		      var quantity = param[1];
		      return cont([0, quantity, 0]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_quantity, 0, 2, [0, int_schema], 0, 0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$171[1][1],
		          schematic_schema_version$11,
		          res,
		          function(a){
		           letrec_function_context$171[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_Active = "Active",
		                cst_Canceled = "Canceled",
		                letrec_function_context$172 = [];
		               function status_schema_versioned$3(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$172[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-status"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$172[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$172[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$172[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(LD);},
		                                  0,
		                                  0,
		                                  cst_incomplete,
		                                  "Incomplete",
		                                  LC,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(LB) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_incomplete_expired,
		                                   "Incomplete_expired",
		                                   LA,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(Lz) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_trialing,
		                                    "Trialing",
		                                    Ly,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(Lx) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_active,
		                                     cst_Active,
		                                     Lw,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(Lv) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_past_due,
		                                      "Past_due",
		                                      Lu,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(Lt) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_canceled,
		                                       cst_Canceled,
		                                       Ls,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(Lr) : cont(0);
		},
		0,
		0,
		cst_unpaid,
		"Unpaid",
		Lq,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 <= param ? cont(Lp) : cont(0);
		 },
		 0,
		 0,
		 cst_paused,
		 "Paused",
		 Lo,
		 0],
		0]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$172[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$172[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$252 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$172, [0, schematic_cache$252]);
		               caml_callback
		                (status_schema_versioned$3,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_automatic_tax = "automatic_tax",
		                cst_cancel_at_period_end = "cancel_at_period_end",
		                cst_start_date = "start_date",
		                letrec_function_context$173 = [];
		               function schema_versioned$99(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$173[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0, [0, cst_stripe + cst_subscription], 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$173[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$173[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$173[1][1] = a;
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_start_date,
		                               0,
		                               2,
		                               [0, timestamp_schema_versioned()],
		                               0,
		                               0],
		                              0];
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "current_period_end",
		                                 0,
		                                 2,
		                                 [0, timestamp_schema_versioned()],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (automatic_tax_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_automatic_tax, 0, 3, [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (status_schema_versioned$3,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Id$4[1],
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$97,
		                           schematic_version,
		                           function(c){
		                            return caml_exact_trampoline_cps_call
		                                    (expandable_schema_versioned,
		                                     schematic_version,
		                                     function(d){
		                                      return caml_exact_trampoline_cps_call$1
		      (d,
		       c,
		       a,
		       function(c){
		        var
		         a =
		           [0,
		            [0, LE, 0, 0, 0, "latest_invoice", 0, 3, [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$98,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_description,
		                       0,
		                       3,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      [0, [0, 0, 0, 0, 0, cst_items, 0, 2, [0, c], 0, 0], a]];
		                  return caml_exact_trampoline_cps_call
		                          (Id$2[1],
		                           schematic_version,
		                           function(c){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_cancel_at_period_end,
		                                 0,
		                                 2,
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_customer, 0, 2, [0, c], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call
		                                    (Subscription_id[1],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    start_date = h[2][1],
		    current_period_end = h[1],
		    automatic_tax = g[1],
		    status = f[1],
		    latest_invoice = e[1],
		    items = d[1],
		    description = c[1],
		    customer = b[1],
		    cancel_at_period_end = a[1],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             cancel_at_period_end,
		             customer,
		             description,
		             items,
		             latest_invoice,
		             status,
		             automatic_tax,
		             current_period_end,
		             start_date]);
		  },
		  function(param, cont){
		   var
		    start_date = param[10],
		    current_period_end = param[9],
		    automatic_tax = param[8],
		    status = param[7],
		    latest_invoice = param[6],
		    items = param[5],
		    description = param[4],
		    customer = param[3],
		    cancel_at_period_end = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0,
		              cancel_at_period_end,
		              [0,
		               customer,
		               [0,
		                description,
		                [0,
		                 items,
		                 [0,
		                  latest_invoice,
		                  [0,
		                   status,
		                   [0,
		                    automatic_tax,
		                    [0, current_period_end, [0, start_date, 0]]]]]]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$173[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$173[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$253 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$173, [0, schematic_cache$253]);
		               caml_callback
		                (schema_versioned$99,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$174 = [];
		               function creation_item_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$174[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-creation-item"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$174[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$174[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$174[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_quantity, 0, 3, [0, int_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$1[1],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var quantity = param[2][1], price = param[1];
		   return cont([0, price, quantity]);
		  },
		  function(param, cont){
		   var quantity = param[2], price = param[1];
		   return cont([0, price, [0, quantity, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_price, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$174[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$174[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$254 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$174, [0, schematic_cache$254]);
		               caml_callback
		                (creation_item_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var ed = [];
		               function payment_behavior_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   ed[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-payment-behavior"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                ed[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ed[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            ed[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(LK);},
		                                  0,
		                                  0,
		                                  cst_allow_incomplete,
		                                  "Allow_incomplete",
		                                  LJ,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(LI) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_default_incomplete,
		                                   "Default_incomplete",
		                                   LH,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(LG) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_error_if_incomplete,
		                                    "Error_if_incomplete",
		                                    LF,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     ed[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){ed[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var ee = [];
		               function trial_settings_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   ee[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-trial-settings"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                ee[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ee[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            ee[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (trial_end_behavior_schema_vers,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var end_behavior = param[1];
		   return cont([0, end_behavior]);
		  },
		  function(param, cont){
		   var end_behavior = param[1];
		   return cont([0, end_behavior, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, "end_behavior", 0, 3, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       ee[1][1],
		       schematic_schema_version,
		       res,
		       function(a){ee[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var ef = [];
		               function trial_end_behavior_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   ef[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-trial-end-behavior"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                ef[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ef[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            ef[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (missing_payment_method_behavio,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var missing_payment_method = param[1];
		   return cont([0, missing_payment_method]);
		  },
		  function(param, cont){
		   var missing_payment_method = param[1];
		   return cont([0, missing_payment_method, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "missing_payment_method",
		    0,
		    2,
		    [0, a],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       ef[1][1],
		       schematic_schema_version,
		       res,
		       function(a){ef[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$175 = [];
		               function missing_payment_method_behavio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$175[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0,
		        cst_stripe + "subscription-missing-payment-method-behavior"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$175[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$175[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$175[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(LQ);},
		                                  0,
		                                  0,
		                                  cst_cancel,
		                                  "Cancel",
		                                  LP,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(LO) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_pause,
		                                   cst_Pause,
		                                   LN,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(LM) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_create_invoice,
		                                    "Create_invoice",
		                                    LL,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$175[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$175[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$255 = [0, empty$11([0, comparator$9])],
		                ec = [];
		               caml_update_dummy(ec, [0, schematic_cache$255]);
		               var schematic_cache$256 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ed, [0, schematic_cache$256]);
		               var schematic_cache$257 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ee, [0, schematic_cache$257]);
		               var schematic_cache$258 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ef, [0, schematic_cache$258]);
		               var schematic_cache$259 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$175, [0, schematic_cache$259]);
		               function schematic_version$32(param, cont){return cont(0);}
		               var schematic_schema_version$147 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [ec[1][1], schematic_schema_version$147]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             ec[1][1],
		                             schematic_schema_version$147,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		ec[1][1],
		schematic_schema_version$147,
		schematic_self,
		function(a){
		 ec[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (trial_settings_schema_versione,
		          schematic_version$32,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                "trial_period_days",
		                0,
		                3,
		                [0, int_schema],
		                0,
		                0],
		               [0,
		                [0, 0, 0, 0, 0, "trial_settings", 0, 3, [0, b], 0, 0],
		                0]];
		           return caml_exact_trampoline_cps_call
		                   (automatic_tax_schema_versioned,
		                    schematic_version$32,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0, 0, 0, 0, 0, cst_automatic_tax, 0, 3, [0, c], 0, 0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (creation_item_schema_versioned,
		                              schematic_version$32,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_items,
		                                    0,
		                                    2,
		                                    [0, schema_versioned$7(schematic_version$32, c)],
		                                    0,
		                                    0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (payment_behavior_schema_versio,
		schematic_version$32,
		function(c){
		 var
		  b =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_cancel_at_period_end,
		      0,
		      3,
		      [0, bool_schema],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_description,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0, 0, 0, 0, 0, "payment_behavior", 0, 2, [0, c], 0, 0],
		       a]]];
		 return caml_exact_trampoline_cps_call
		         (Id$2[1],
		          schematic_version$32,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 b = a[2],
		                 c = b[2],
		                 d = c[2],
		                 e = d[2],
		                 f = e[2],
		                 trial_settings = f[2][1],
		                 trial_period_days = f[1],
		                 automatic_tax = e[1],
		                 items = d[1],
		                 payment_behavior = c[1],
		                 description = b[1],
		                 cancel_at_period_end = a[1],
		                 customer = param[1];
		                return cont
		                        ([0,
		                          customer,
		                          cancel_at_period_end,
		                          description,
		                          payment_behavior,
		                          items,
		                          automatic_tax,
		                          trial_period_days,
		                          trial_settings]);
		               },
		               function(param, cont){
		                var
		                 trial_settings = param[8],
		                 trial_period_days = param[7],
		                 automatic_tax = param[6],
		                 items = param[5],
		                 payment_behavior = param[4],
		                 description = param[3],
		                 cancel_at_period_end = param[2],
		                 customer = param[1];
		                return cont
		                        ([0,
		                          customer,
		                          [0,
		                           cancel_at_period_end,
		                           [0,
		                            description,
		                            [0,
		                             payment_behavior,
		                             [0,
		                              items,
		                              [0,
		                               automatic_tax,
		                               [0, trial_period_days, [0, trial_settings, 0]]]]]]]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_customer, 0, 2, [0, a], 0, 0], b]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    ec[1][1],
		                    schematic_schema_version$147,
		                    res,
		                    function(a){ec[1][1] = a; return cont(res);});
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (payment_behavior_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (trial_settings_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (trial_end_behavior_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (missing_payment_method_behavio,
		                 [function(param, cont){return cont(0);}]);
		               var cst_All = "All", eh = [];
		               function query_status_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   eh[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "subscription-query-status"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                eh[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           eh[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            eh[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(LW);},
		                                  0,
		                                  0,
		                                  cst_canceled,
		                                  cst_Canceled,
		                                  LV,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(LU) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_ended,
		                                   "Ended",
		                                   LT,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(LS) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_all,
		                                    cst_All,
		                                    LR,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     eh[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){eh[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$260 = [0, empty$11([0, comparator$9])],
		                eg = [];
		               caml_update_dummy(eg, [0, schematic_cache$260]);
		               var schematic_cache$261 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(eh, [0, schematic_cache$261]);
		               var
		                schematic_cache$262 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$176 = [];
		               caml_update_dummy
		                (letrec_function_context$176, [0, schematic_cache$262]);
		               function schematic_version$33(param, cont){return cont(0);}
		               var schematic_schema_version$146 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [eg[1][1], schematic_schema_version$146]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             eg[1][1],
		                             schematic_schema_version$146,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		eg[1][1],
		schematic_schema_version$146,
		schematic_self,
		function(a){
		 eg[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (query_status_schema_versioned,
		          schematic_version$33,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_status, 0, 3, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (Id$1[1],
		                    schematic_version$33,
		                    function(c){
		                     var
		                      b = [0, [0, 0, 0, 0, 0, cst_price, 0, 3, [0, c], 0, 0], a];
		                     return caml_exact_trampoline_cps_call
		                             (Id$2[1],
		                              schematic_version$33,
		                              function(a){
		                               var
		                                res =
		                                  [7,
		                                   function(param, cont){
		                                    var
		                                     a = param[2],
		                                     status = a[2][1],
		                                     price = a[1],
		                                     customer = param[1];
		                                    return cont([0, customer, price, status]);
		                                   },
		                                   function(param, cont){
		                                    var
		                                     status = param[3],
		                                     price = param[2],
		                                     customer = param[1];
		                                    return cont([0, customer, [0, price, [0, status, 0]]]);
		                                   },
		                                   [0, [0, 0, 0, 0, 0, cst_customer, 0, 2, [0, a], 0, 0], b]];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		eg[1][1],
		schematic_schema_version$146,
		res,
		function(a){eg[1][1] = a; return cont(res);});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (query_status_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$34(param, cont){return cont(0);}
		               var schematic_schema_version$145 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$176[1][1],
		                    schematic_schema_version$145]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$176[1][1],
		                             schematic_schema_version$145,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$176[1][1],
		schematic_schema_version$145,
		schematic_self,
		function(a){
		 letrec_function_context$176[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$99,
		          schematic_version$34,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var data = param[2][1], object = param[1];
		                return cont([0, object, data]);
		               },
		               function(param, cont){
		                var data = param[2], object = param[1];
		                return cont([0, object, [0, data, 0]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_object,
		                 0,
		                 2,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_data,
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, a], 0]],
		                  0,
		                  0],
		                 0]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$176[1][1],
		                    schematic_schema_version$145,
		                    res,
		                    function(a){
		                     letrec_function_context$176[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var Id$6 = make$20(0, "bps"), ei = [];
		               function schema_versioned$100(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   ei[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                ei[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ei[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            ei[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (body_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_body, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (after_completion_schema_versio,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var body = param[2][1], after_completion = param[1];
		             return cont([0, after_completion, body]);
		            },
		            function(param, cont){
		             var body = param[2], after_completion = param[1];
		             return cont([0, after_completion, [0, body, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, "after_completion", 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 ei[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){ei[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var ej = [];
		               function body_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   ej[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow-body"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                ej[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ej[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            ej[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (subscription_update_confirm_sc,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       cst_subscription_update_confir = "subscription_update_confirm",
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_subscription_update_confir,
		   "Subscription_update_confirm",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var subscription_update_confirm = param[1];
		      return cont(subscription_update_confirm);
		     },
		     function(subscription_update_confirm, cont){
		      return cont([0, subscription_update_confirm, 0]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_subscription_update_confir,
		       0,
		       2,
		       [0, b],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (subscription_cancel_schema_ver,
		       schematic_version,
		       function(c){
		        var
		         cst_subscription_cancel = "subscription_cancel",
		         b =
		           [0,
		            [0,
		             function(param, cont){return cont(0);},
		             function(param, cont){
		              return typeof param === "number" ? cont(LX) : cont(0);
		             },
		             0,
		             0,
		             "payment_method_update",
		             "Payment_method_update",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){return cont(0);},
		               function(param, cont){return cont(0);},
		               0],
		              0],
		             0],
		            [0,
		             [0,
		              function(f0, cont){return cont([1, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_subscription_cancel,
		              "Subscription_cancel",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var subscription_cancel = param[1];
		                 return cont(subscription_cancel);
		                },
		                function(subscription_cancel, cont){
		                 return cont([0, subscription_cancel, 0]);
		                },
		                [0,
		                 [0, 0, 0, 0, 0, cst_subscription_cancel, 0, 2, [0, c], 0, 0],
		                 0]],
		               0],
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call
		                (subscription_update_schema_ver,
		                 schematic_version,
		                 function(a){
		                  var
		                   cst_subscription_update = "subscription_update",
		                   res =
		                     [11,
		                      LY,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        1,
		                        0,
		                        cst_subscription_update,
		                        "Subscription_update",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var subscription_update = param[1];
		                           return cont(subscription_update);
		                          },
		                          function(subscription_update, cont){
		                           return cont([0, subscription_update, 0]);
		                          },
		                          [0,
		                           [0, 0, 0, 0, 0, cst_subscription_update, 0, 2, [0, a], 0, 0],
		                           0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ej[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){ej[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var ek = [];
		               function subscription_update_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   ek[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow-subscription-update"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                ek[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           ek[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            ek[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Subscription_id[1],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var subscription = param[1];
		   return cont([0, subscription]);
		  },
		  function(param, cont){
		   var subscription = param[1];
		   return cont([0, subscription, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_subscription, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       ek[1][1],
		       schematic_schema_version,
		       res,
		       function(a){ek[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var el = [];
		               function subscription_cancel_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   el[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow-subscription-cancel"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                el[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           el[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            el[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (retention_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, "retention", 0, 3, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Subscription_id[1],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var retention = param[2][1], subscription = param[1];
		             return cont([0, subscription, retention]);
		            },
		            function(param, cont){
		             var retention = param[2], subscription = param[1];
		             return cont([0, subscription, [0, retention, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_subscription, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 el[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){el[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var em = [];
		               function retention_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   em[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow-retention"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                em[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           em[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            em[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (coupon_offer_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       cst_coupon_offer = "coupon_offer",
		                                       res =
		 [11,
		  LZ,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_coupon_offer,
		    "Coupon_offer",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var coupon_offer = param[1];
		       return cont(coupon_offer);
		      },
		      function(coupon_offer, cont){
		       return cont([0, coupon_offer, 0]);
		      },
		      [0,
		       [0, 0, 0, 0, 0, cst_coupon_offer, 0, 2, [0, a], 0, 0],
		       0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       em[1][1],
		       schematic_schema_version,
		       res,
		       function(a){em[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var en = [];
		               function subscription_update_confirm_sc
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   en[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0,
		        cst_stripe
		        + "customer-portal-flow-subscription-update-confirm"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                en[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           en[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            en[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (subscription_update_confirm_it,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_items,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (Subscription_id[1],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var items = param[2][1], subscription = param[1];
		             return cont([0, subscription, items]);
		            },
		            function(param, cont){
		             var items = param[2], subscription = param[1];
		             return cont([0, subscription, [0, items, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_subscription, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 en[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){en[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var st = [];
		               function subscription_update_confirm_it
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   st[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0,
		        cst_stripe
		        + "customer-portal-flow-subscription-update-confirm-item"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                st[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           st[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            st[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_quantity, 0, 3, [0, int_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$1[1],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_price, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (Id$5[1],
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              quantity = a[2][1],
		              price = a[1],
		              id = param[1];
		             return cont([0, id, price, quantity]);
		            },
		            function(param, cont){
		             var quantity = param[3], price = param[2], id = param[1];
		             return cont([0, id, [0, price, [0, quantity, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 st[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){st[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var a9r = [];
		               function coupon_offer_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   a9r[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow-coupon-offer"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                a9r[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           a9r[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            a9r[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var coupon = param[1];
		                                 return cont([0, coupon]);
		                                },
		                                function(param, cont){
		                                 var coupon = param[1];
		                                 return cont([0, coupon, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_coupon,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     a9r[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){a9r[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var a9s = [];
		               function after_completion_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   a9s[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow-after-completion"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                a9s[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           a9s[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            a9s[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){return param ? cont(0) : cont(L0);},
		                                 0,
		                                 0,
		                                 "portal_homepage",
		                                 "Portal_homepage",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (redirect_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       cst_redirect = "redirect",
		                                       res =
		 [11,
		  L1,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(! param) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_redirect,
		    "Redirect",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var redirect = param[1];
		       return cont(redirect);
		      },
		      function(redirect, cont){return cont([0, redirect, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_redirect, 0, 2, [0, b], 0, 0], 0]],
		     0],
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       a9s[1][1],
		       schematic_schema_version,
		       res,
		       function(a){a9s[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_return_url = "return_url",
		                letrec_function_context$177 = [];
		               function redirect_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$177[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "customer-portal-flow-redirect"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$177[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$177[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$177[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var return_url = param[1];
		                                 return cont([0, return_url]);
		                                },
		                                function(param, cont){
		                                 var return_url = param[1];
		                                 return cont([0, return_url, 0]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_return_url, 0, 2, [0, schema$268], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$177[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$177[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$263 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ei, [0, schematic_cache$263]);
		               var schematic_cache$264 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ej, [0, schematic_cache$264]);
		               var schematic_cache$265 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(ek, [0, schematic_cache$265]);
		               var schematic_cache$266 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(el, [0, schematic_cache$266]);
		               var schematic_cache$267 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(em, [0, schematic_cache$267]);
		               var schematic_cache$268 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(en, [0, schematic_cache$268]);
		               var schematic_cache$269 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(st, [0, schematic_cache$269]);
		               var schematic_cache$270 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(a9r, [0, schematic_cache$270]);
		               var schematic_cache$271 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(a9s, [0, schematic_cache$271]);
		               var schematic_cache$272 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$177, [0, schematic_cache$272]);
		               caml_callback
		                (schema_versioned$100,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (body_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (subscription_update_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (subscription_cancel_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (retention_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (subscription_update_confirm_sc,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (subscription_update_confirm_it,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (coupon_offer_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (after_completion_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (redirect_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var a9t = [];
		               function schema_versioned$101(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   a9t[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                a9t[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           a9t[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            a9t[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_return_url,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$268], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$2[1],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0, [0, 0, 0, 0, 0, cst_customer, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (Id$6[1],
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              url = b[2][1],
		              return_url = b[1],
		              customer = a[1],
		              id = param[1];
		             return cont([0, id, customer, return_url, url]);
		            },
		            function(param, cont){
		             var
		              url = param[4],
		              return_url = param[3],
		              customer = param[2],
		              id = param[1];
		             return cont
		                     ([0, id, [0, customer, [0, return_url, [0, url, 0]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 a9t[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){a9t[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$273 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(a9t, [0, schematic_cache$273]);
		               var
		                schematic_cache$274 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$178 = [];
		               caml_update_dummy
		                (letrec_function_context$178, [0, schematic_cache$274]);
		               caml_callback
		                (schema_versioned$101,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$35(param, cont){return cont(0);}
		               var schematic_schema_version$144 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$178[1][1],
		                    schematic_schema_version$144]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$178[1][1],
		                             schematic_schema_version$144,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$178[1][1],
		schematic_schema_version$144,
		schematic_self,
		function(a){
		 letrec_function_context$178[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$100,
		          schematic_version$35,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_return_url,
		                0,
		                2,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_configuration,
		                 0,
		                 3,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0, [0, 0, 0, 0, 0, "flow_data", 0, 3, [0, b], 0, 0], 0]]];
		           return caml_exact_trampoline_cps_call
		                   (Id$2[1],
		                    schematic_version$35,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           flow_data = b[2][1],
		                           configuration = b[1],
		                           return_url = a[1],
		                           customer = param[1];
		                          return cont
		                                  ([0, customer, return_url, configuration, flow_data]);
		                         },
		                         function(param, cont){
		                          var
		                           flow_data = param[4],
		                           configuration = param[3],
		                           return_url = param[2],
		                           customer = param[1];
		                          return cont
		                                  ([0,
		                                    customer,
		                                    [0, return_url, [0, configuration, [0, flow_data, 0]]]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_customer, 0, 2, [0, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$178[1][1],
		                              schematic_schema_version$144,
		                              res,
		                              function(a){
		                               letrec_function_context$178[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var Id$7 = make$20(0, "cs"), bf9 = [];
		               function customer_update_value_schema_v
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bf9[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bf9[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bf9[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bf9[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(L9);},
		                                  0,
		                                  0,
		                                  cst_auto,
		                                  "Auto",
		                                  L8,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(L7) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_never,
		                                   cst_Never,
		                                   L6,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bf9[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bf9[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bf_ = [];
		               function customer_update_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bf_[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "checkout-session-customer-update"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bf_[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bf_[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bf_[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (customer_update_value_schema_v,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, "shipping", 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (customer_update_value_schema_v,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_name, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (customer_update_value_schema_v,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        shipping = a[2][1],
		                        name = a[1],
		                        address = param[1];
		                       return cont([0, address, name, shipping]);
		                      },
		                      function(param, cont){
		                       var
		                        shipping = param[3],
		                        name = param[2],
		                        address = param[1];
		                       return cont([0, address, [0, name, [0, shipping, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_address, 0, 3, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bf_[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bf_[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bf$ = [];
		               function tag_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bf$[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, L_, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bf$[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bf$[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bf$[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return cont(Ma);},
		                                  0,
		                                  0,
		                                  cst_checkout_session,
		                                  "M",
		                                  L$,
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bf$[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bf$[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$179 = [];
		               function line_item_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$179[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont
		     ([0,
		       [0, cst_stripe + "checkout-session-line-item"],
		       0,
		       descriptor,
		       0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$179[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$179[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$179[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_quantity, 0, 3, [0, int_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$1[1],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var quantity = param[2][1], price = param[1];
		   return cont([0, price, quantity]);
		  },
		  function(param, cont){
		   var quantity = param[2], price = param[1];
		   return cont([0, price, [0, quantity, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_price, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$179[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$179[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$275 = [0, empty$11([0, comparator$9])],
		                bbJ = [];
		               caml_update_dummy(bbJ, [0, schematic_cache$275]);
		               var
		                schematic_cache$276 = [0, empty$11([0, comparator$9])],
		                bf8 = [];
		               caml_update_dummy(bf8, [0, schematic_cache$276]);
		               var schematic_cache$277 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bf9, [0, schematic_cache$277]);
		               var schematic_cache$278 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bf_, [0, schematic_cache$278]);
		               var schematic_cache$279 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bf$, [0, schematic_cache$279]);
		               var schematic_cache$280 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$179, [0, schematic_cache$280]);
		               function schematic_version$36(param, cont){return cont(0);}
		               var
		                cst_Subscription = "Subscription",
		                cst_line_items = "line_items",
		                cst_mode = "mode",
		                cst_success_url = "success_url",
		                schematic_schema_version$143 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bbJ[1][1], schematic_schema_version$143]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bbJ[1][1],
		                             schematic_schema_version$143,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bbJ[1][1],
		schematic_schema_version$143,
		schematic_self,
		function(b){
		 bbJ[1][1] = b;
		 var
		  a =
		    [0,
		     [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$268], 0, 0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (line_item_schema_versioned,
		          schematic_version$36,
		          function(c){
		           var
		            b =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_success_url,
		                0,
		                2,
		                [0, schema$268],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_mode,
		                 0,
		                 2,
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   [11,
		                    0,
		                    [0,
		                     [0,
		                      function(param, cont){return cont(-32289987);},
		                      function(param, cont){return cont(L3);},
		                      0,
		                      0,
		                      cst_subscription,
		                      cst_Subscription,
		                      L2,
		                      0],
		                     0],
		                    1],
		                   0]],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_line_items,
		                  0,
		                  3,
		                  [0, [0, 0, 0, [3, c], 0]],
		                  0,
		                  0],
		                 a]]];
		           return caml_exact_trampoline_cps_call
		                   (tag_schema_versioned,
		                    schematic_version$36,
		                    function(c){
		                     var
		                      a = [0, [0, 0, 0, 0, 0, cst_object, 0, 2, [0, c], 0, 0], b];
		                     return caml_exact_trampoline_cps_call
		                             (Id$2[1],
		                              schematic_version$36,
		                              function(c){
		                               var
		                                b =
		                                  [0, [0, 0, 0, 0, 0, cst_customer, 0, 3, [0, c], 0, 0], a];
		                               return caml_exact_trampoline_cps_call
		                                       (Id$7[1],
		schematic_version$36,
		function(a){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       d = c[2],
		       e = d[2],
		       url = e[2][1],
		       line_items = e[1],
		       mode = d[1],
		       success_url = c[1],
		       object = b[1],
		       customer = a[1],
		       id = param[1];
		      return cont
		              ([0,
		                id,
		                customer,
		                object,
		                success_url,
		                mode,
		                line_items,
		                url]);
		     },
		     function(param, cont){
		      var
		       url = param[7],
		       line_items = param[6],
		       mode = param[5],
		       success_url = param[4],
		       object = param[3],
		       customer = param[2],
		       id = param[1];
		      return cont
		              ([0,
		                id,
		                [0,
		                 customer,
		                 [0,
		                  object,
		                  [0, success_url, [0, mode, [0, line_items, [0, url, 0]]]]]]]);
		     },
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          bbJ[1][1],
		          schematic_schema_version$143,
		          res,
		          function(a){bbJ[1][1] = a; return cont(res);});
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$37(param, cont){return cont(0);}
		               var schematic_schema_version$142 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bf8[1][1], schematic_schema_version$142]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bf8[1][1],
		                             schematic_schema_version$142,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bf8[1][1],
		schematic_schema_version$142,
		schematic_self,
		function(a){
		 bf8[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (customer_update_schema_version,
		          schematic_version$37,
		          function(b){
		           var
		            a =
		              [0,
		               [0, 0, 0, 0, 0, "customer_update", 0, 2, [0, b], 0, 0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (automatic_tax_schema_versioned,
		                    schematic_version$37,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "allow_promotion_codes",
		                          0,
		                          3,
		                          [0, bool_schema],
		                          0,
		                          0],
		                         [0,
		                          [0, 0, 0, 0, 0, cst_automatic_tax, 0, 3, [0, c], 0, 0],
		                          a]];
		                     return caml_exact_trampoline_cps_call
		                             (line_item_schema_versioned,
		                              schematic_version$37,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_success_url,
		                                    0,
		                                    2,
		                                    [0, schema$268],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_mode,
		                                     0,
		                                     2,
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       [11,
		0,
		[0,
		 [0,
		  function(param, cont){return cont(-32289987);},
		  function(param, cont){return cont(L5);},
		  0,
		  0,
		  cst_subscription,
		  cst_Subscription,
		  L4,
		  0],
		 0],
		1],
		                                       0]],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_line_items,
		                                      0,
		                                      2,
		                                      [0, [0, 0, 0, [3, c], 0]],
		                                      0,
		                                      0],
		                                     b]]];
		                               return caml_exact_trampoline_cps_call
		                                       (Id$2[1],
		schematic_version$37,
		function(b){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       d = c[2],
		       e = d[2],
		       customer_update = e[2][1],
		       automatic_tax = e[1],
		       allow_promotion_codes = d[1],
		       line_items = c[1],
		       mode = b[1],
		       success_url = a[1],
		       customer = param[1];
		      return cont
		              ([0,
		                customer,
		                success_url,
		                mode,
		                line_items,
		                allow_promotion_codes,
		                automatic_tax,
		                customer_update]);
		     },
		     function(param, cont){
		      var
		       customer_update = param[7],
		       automatic_tax = param[6],
		       allow_promotion_codes = param[5],
		       line_items = param[4],
		       mode = param[3],
		       success_url = param[2],
		       customer = param[1];
		      return cont
		              ([0,
		                customer,
		                [0,
		                 success_url,
		                 [0,
		                  mode,
		                  [0,
		                   line_items,
		                   [0,
		                    allow_promotion_codes,
		                    [0, automatic_tax, [0, customer_update, 0]]]]]]]);
		     },
		     [0, [0, 0, 0, 0, 0, cst_customer, 0, 3, [0, b], 0, 0], a]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          bf8[1][1],
		          schematic_schema_version$142,
		          res,
		          function(a){bf8[1][1] = a; return cont(res);});
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (customer_update_value_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (customer_update_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (tag_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (line_item_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var M$4 = k([0, compare_decoded]);
		               function read_lines_l(ic){
		                var l = [0, 0];
		                try{for(;;){var a = l[1]; l[1] = [0, input_line(ic), a];}}
		                catch(exn$0){
		                 var exn = caml_wrap_exception(exn$0);
		                 if(exn === End_of_file) return rev(l[1]);
		                 throw caml_maybe_attach_backtrace(exn, 0);
		                }
		               }
		               function with_in(file, f, cont){
		                var ic = open_in_bin(file);
		                return caml_exact_trampoline_cps_call$1
		                        (protect,
		                         function(param){caml_ml_close_channel(ic);},
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call(f, ic, cont);
		                         },
		                         cont);
		               }
		               var
		                Out_of_range =
		                  [248, "Timedesc__Span.Out_of_range", caml_fresh_oo_id()];
		               function normalize$0(a){
		                var ns = a[2], s$0 = a[1];
		                if(0 <= ns){
		                 var
		                  s_to_add = caml_int64_of_int32(ns / 1000000000 | 0),
		                  ns$0 = ns % 1000000000 | 0;
		                 if
		                  (!
		                   caml_lessthan(s$0, Me)
		                   &&
		                    !
		                    caml_greaterequal
		                     (caml_int64_sub(draw_maximum, s$0), s_to_add))
		                  throw caml_maybe_attach_backtrace(Out_of_range, 1);
		                 return [0, caml_int64_add(s$0, s_to_add), ns$0];
		                }
		                if(ns === -2147483648){
		                 if(! caml_greaterthan(s$0, min_int64))
		                  throw caml_maybe_attach_backtrace(Out_of_range, 1);
		                 a = [0, caml_int64_sub(s$0, s), -1147483648];
		                }
		                else
		                 a = [0, s$0, ns];
		                var
		                 ns$1 = a[2],
		                 s$1 = a[1],
		                 ns$2 = - ns$1 | 0,
		                 s_to_sub =
		                   caml_int64_of_int32
		                    (((ns$2 + 1000000000 | 0) - 1 | 0) / 1000000000 | 0),
		                 ns_to_sub_from_one_s = ns$2 % 1000000000 | 0,
		                 ns$3 = 1000000000 - ns_to_sub_from_one_s | 0;
		                if
		                 (!
		                  caml_greaterequal(s$1, Mf)
		                  &&
		                   !
		                   caml_greaterequal(caml_int64_sub(s$1, min_int64), s_to_sub))
		                 throw caml_maybe_attach_backtrace(Out_of_range, 1);
		                return [0, caml_int64_sub(s$1, s_to_sub), ns$3];
		               }
		               function make$21(a, opt, param){
		                var s = a ? a[1] : Mg, ns = opt ? opt[1] : 0;
		                return normalize$0([0, s, ns]);
		               }
		               function make_small(opt, ns, param){
		                var s = opt ? opt[1] : 0;
		                return make$21([0, caml_int64_of_int32(s)], ns);
		               }
		               function symbol$97(a, param){
		                var
		                 ns_y = param[2],
		                 s_y = param[1],
		                 ns_x = a[2],
		                 s_x = a[1],
		                 s = caml_int64_add(s_x, s_y),
		                 ns = ns_x + ns_y | 0;
		                return normalize$0([0, s, ns]);
		               }
		               function symbol$98(a, param){
		                var
		                 ns_y = param[2],
		                 s_y = param[1],
		                 ns_x = a[2],
		                 s_x = a[1],
		                 ns = ns_x - ns_y | 0;
		                if(0 <= ns) return [0, caml_int64_sub(s_x, s_y), ns];
		                var s_x$0 = caml_int64_sub(s_x, s);
		                return [0, caml_int64_sub(s_x$0, s_y), ns + 1000000000 | 0];
		               }
		               function neg$0(param){
		                var ns = param[2], s$0 = param[1];
		                if(0 === ns) return [0, caml_int64_neg(s$0), ns];
		                var n = caml_int64_neg(s$0);
		                return [0, caml_int64_sub(n, s), 1000000000 - ns | 0];
		               }
		               function symbol$99(a, param){
		                var
		                 ns_y = param[2],
		                 s_y = param[1],
		                 ns_x = a[2],
		                 s_x = a[1],
		                 a = caml_lessthan(s_x, s_y);
		                if(a)
		                 ;
		                else {
		                 a = caml_equal(s_x, s_y);
		                 a = a ? ns_x < ns_y ? 1 : 0 : a;
		                }
		                return a;
		               }
		               function symbol$100(x, y){
		                var a = symbol$99(x, y);
		                if(a) return a;
		                var
		                 ns_y = y[2],
		                 s_y = y[1],
		                 ns_x = x[2],
		                 s_x = x[1],
		                 a = caml_equal(s_x, s_y),
		                 a = a ? ns_x === ns_y ? 1 : 0 : a;
		                return a;
		               }
		               function abs$2(x){return symbol$100(zero$0, x) ? x : neg$0(x);}
		               function to_float_s$0(param){
		                var ns = param[2], s = param[1];
		                return caml_int64_to_float(s) + ns / 1000000000.;
		               }
		               var
		                Error_exn =
		                  [248,
		                   "Timedesc__Span.For_human'.Error_exn",
		                   caml_fresh_oo_id()];
		               function view(x){
		                var
		                 sign = symbol$99(x, zero$0) ? 3901488 : 4003188,
		                 match = abs$2(x),
		                 ns = match[2],
		                 s = match[1],
		                 seconds = caml_int64_mod(s, Mi),
		                 minutes = caml_int64_div(s, Mj),
		                 hours = caml_int64_div(minutes, Mk),
		                 days = caml_int64_div(hours, Ml),
		                 hours$0 = caml_int64_mod(hours, Mm),
		                 minutes$0 = caml_int64_mod(minutes, Mn);
		                return [0,
		                        sign,
		                        caml_int64_to_int32(days),
		                        caml_int64_to_int32(hours$0),
		                        caml_int64_to_int32(minutes$0),
		                        caml_int64_to_int32(seconds),
		                        ns];
		               }
		               var
		                hour_to_seconds = caml_int64_create_lo_mi_hi(3600, 0, 0),
		                day_to_seconds = caml_int64_create_lo_mi_hi(86400, 0, 0);
		               function make_exn
		               (sign$0, days$1, hours$1, minutes$1, seconds$1, ns$0, a){
		                var
		                 sign = sign$0 ? sign$0[1] : 4003188,
		                 days$0 = days$1 ? days$1[1] : 0,
		                 hours$0 = hours$1 ? hours$1[1] : 0,
		                 minutes$0 = minutes$1 ? minutes$1[1] : 0,
		                 seconds$0 = seconds$1 ? seconds$1[1] : 0,
		                 ns = 0;
		                if(0 <= days$0)
		                 if(0 <= hours$0)
		                  if(0 <= minutes$0)
		                   if(0 <= seconds$0)
		                    var
		                      days = caml_int64_of_int32(days$0),
		                      hours = caml_int64_of_int32(hours$0),
		                      minutes = caml_int64_of_int32(minutes$0),
		                      seconds = caml_int64_of_int32(seconds$0),
		                      s =
		                        caml_int64_add
		                         (caml_int64_add
		                           (caml_int64_add
		                             (caml_int64_mul(days, day_to_seconds),
		                              caml_int64_mul(hours, hour_to_seconds)),
		                            caml_int64_mul(minutes, minute_to_seconds)),
		                          seconds),
		                      x = make$21([0, s], [0, ns]),
		                      a = 4003188 <= sign ? x : neg$0(x),
		                      a = [0, a];
		                   else
		                    a = [1, [0, -378519081, seconds$0]];
		                  else
		                   a = [1, [0, -490659209, minutes$0]];
		                 else
		                  a = [1, [0, -1072122841, hours$0]];
		                else
		                 a = [1, [0, -810629057, days$0]];
		                if(0 === a[0]){var x$0 = a[1]; return x$0;}
		                var e = a[1];
		                throw caml_maybe_attach_backtrace([0, Error_exn, e], 1);
		               }
		               var seconds_in_day = caml_int64_create_lo_mi_hi(86400, 0, 0);
		               function timestamp_of_ptime(x){
		                var
		                 ps = x[2],
		                 d = x[1],
		                 s = caml_int64_div(ps, s_to_ps_mult),
		                 ns =
		                   caml_int64_to_int32(caml_int64_mod(ps, s_to_ps_mult)) / 1000
		                   | 0;
		                return make$21
		                        ([0,
		                          caml_int64_add
		                           (caml_int64_mul(caml_int64_of_int32(d), seconds_in_day), s)],
		                         [0, ns]);
		               }
		               var
		                x$9 = timestamp_of_ptime([0, -719528, gE]),
		                x$10 =
		                  symbol$97
		                   (x$9,
		                    make$21([0, caml_int64_create_lo_mi_hi(50400, 0, 0)], 0));
		               if(0 === x$10[2])
		                var timestamp_min = x$10;
		               else
		                var
		                 n$0 = x$10[1],
		                 timestamp_min = [0, caml_int64_add(n$0, bl), 0];
		               var
		                x$11 = timestamp_of_ptime([0, 2932896, ps_day_max]),
		                z = make_small([0, 50400], 0),
		                x$12 = symbol$98(symbol$98(x$11, make_small(Mo, 0)), z),
		                timestamp_max = [0, x$12[1], 0];
		               make_exn(0, Mp, 0, 0, 0);
		               function make$22(year, month){
		                if(year >= 0 && 9999 >= year){
		                 if(1 <= month && 12 >= month)
		                  return [0, [0, (year * 12 | 0) + (month - 1 | 0) | 0]];
		                 return [1, [0, 554978456, month]];
		                }
		                return [1, [0, -577554587, year]];
		               }
		               function year_month(t){
		                var month_count = t[1];
		                return 0 <= month_count
		                        ? [0, month_count / 12 | 0, (month_count % 12 | 0) + 1 | 0]
		                        : [0,
		                          (month_count - 11 | 0) / 12 | 0,
		                          (((month_count % 12 | 0) + 12 | 0) % 12 | 0) + 1 | 0];
		               }
		               function jd_of_ymd(year, month, day){
		                var
		                 a = (14 - month | 0) / 12 | 0,
		                 y = (year + 4800 | 0) - a | 0,
		                 m = (month + (12 * a | 0) | 0) - 3 | 0;
		                return (((((day + (((153 * m | 0) + 2 | 0) / 5 | 0) | 0)
		                       + (365 * y | 0)
		                       | 0)
		                       + (y / 4 | 0)
		                       | 0)
		                       - (y / 100 | 0)
		                       | 0)
		                       + (y / 400 | 0)
		                       | 0)
		                       - 32045
		                       | 0;
		               }
		               function ymd_of_jd(jd){
		                var
		                 a = jd + 32044 | 0,
		                 b = ((4 * a | 0) + 3 | 0) / 146097 | 0,
		                 c = a - ((146097 * b | 0) / 4 | 0) | 0,
		                 d = ((4 * c | 0) + 3 | 0) / 1461 | 0,
		                 e = c - ((1461 * d | 0) / 4 | 0) | 0,
		                 m = ((5 * e | 0) + 2 | 0) / 153 | 0,
		                 day = (e - (((153 * m | 0) + 2 | 0) / 5 | 0) | 0) + 1 | 0,
		                 month = (m + 3 | 0) - (12 * (m / 10 | 0) | 0) | 0,
		                 year =
		                   (((100 * b | 0) + d | 0) - 4800 | 0) + (m / 10 | 0) | 0;
		                return [0, year, month, day];
		               }
		               var
		                jd_of_unix_epoch = jd_of_ymd(1970, 1, 1),
		                cst_unexpected_case = "unexpected case";
		               function weekday_of_jd(jd, cont){
		                var
		                 d = (jd - jd_of_unix_epoch | 0) % 7 | 0,
		                 match = 0 <= d ? d : d + 7 | 0;
		                if(6 < match >>> 0)
		                 return caml_exact_trampoline_cps_call
		                         (failwith, cst_unexpected_case, cont);
		                switch(match){
		                  case 0:
		                   return cont(4200545);
		                  case 1:
		                   return cont(3506557);
		                  case 2:
		                   return cont(4149254);
		                  case 3:
		                   return cont(4153708);
		                  case 4:
		                   return cont(3853996);
		                  case 5:
		                   return cont(4203428);
		                  default: return cont(4349046);
		                }
		               }
		               function weekday_of_ymd(year, month, day, cont){
		                return caml_exact_trampoline_cps_call
		                        (weekday_of_jd, jd_of_ymd(year, month, day), cont);
		               }
		               function is_leap_year(year){
		                var
		                 divisible_by_4 = 0 === (year % 4 | 0) ? 1 : 0,
		                 divisible_by_100 = 0 === (year % 100 | 0),
		                 divisible_by_400 = 0 === (year % 400 | 0) ? 1 : 0;
		                if(divisible_by_4)
		                 var a = 1 - divisible_by_100, a = a || divisible_by_400;
		                else
		                 a = divisible_by_4;
		                return a;
		               }
		               function day_count_of_year(year){
		                return is_leap_year(year) ? 366 : 365;
		               }
		               function day_offset_from_start_of_year(year, month, cont){
		                function aux(month, cont){
		                 var switcher = month - 1 | 0;
		                 if(11 < switcher >>> 0)
		                  return caml_exact_trampoline_cps_call
		                          (failwith, cst_unexpected_case, cont);
		                 switch(switcher){
		                   case 0:
		                    return cont(0);
		                   case 1:
		                    return cont(31);
		                   case 2:
		                    return cont(59);
		                   case 3:
		                    return cont(90);
		                   case 4:
		                    return cont(120);
		                   case 5:
		                    return cont(151);
		                   case 6:
		                    return cont(181);
		                   case 7:
		                    return cont(212);
		                   case 8:
		                    return cont(243);
		                   case 9:
		                    return cont(273);
		                   case 10:
		                    return cont(304);
		                   default: return cont(334);
		                 }
		                }
		                return is_leap_year(year)
		                        ? 2
		                          < month
		                          ? caml_exact_trampoline_cps_call
		                            (aux, month, function(a){return cont(a + 1 | 0);})
		                          : caml_exact_trampoline_cps_call(aux, month, cont)
		                        : caml_exact_trampoline_cps_call(aux, month, cont);
		               }
		               function jd_of_ydoy(year, day_of_year, cont){
		                function a(month){
		                 function b(month){
		                  return caml_exact_trampoline_cps_call$1
		                          (day_offset_from_start_of_year,
		                           year,
		                           month,
		                           function(a){
		                            var day = day_of_year - a | 0;
		                            return cont(jd_of_ymd(year, month, day));
		                           });
		                 }
		                 return 1 <= month
		                         ? caml_exact_trampoline_cps_call$1
		                           (day_offset_from_start_of_year,
		                            year,
		                            month,
		                            function(offset){
		                             if((offset + 1 | 0) <= day_of_year) return b(month);
		                             var month$0 = month - 1 | 0;
		                             return caml_exact_trampoline_call1(a, month$0);
		                            })
		                         : caml_exact_trampoline_cps_call
		                           (failwith, cst_unexpected_case, b);
		                }
		                return a(12);
		               }
		               function jd_of_start_of_iso_year(year, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (weekday_of_ymd,
		                         year,
		                         1,
		                         4,
		                         function(match){
		                          return 4153708 <= match
		                                  ? 4203428
		                                    <= match
		                                    ? 4349046
		                                      <= match
		                                      ? cont(jd_of_ymd(year, 1, 2))
		                                      : cont(jd_of_ymd(year, 1, 3))
		                                    : 4200545
		                                      <= match
		                                      ? cont(jd_of_ymd(year, 1, 1))
		                                      : cont(jd_of_ymd(year - 1 | 0, 12, 29))
		                                  : 3853996
		                                    === match
		                                    ? cont(jd_of_ymd(year, 1, 4))
		                                    : 4149254
		                                      <= match
		                                      ? cont(jd_of_ymd(year - 1 | 0, 12, 30))
		                                      : cont(jd_of_ymd(year - 1 | 0, 12, 31));
		                         });
		               }
		               function week_count_of_iso_year(year, cont){
		                return caml_exact_trampoline_cps_call
		                        (jd_of_start_of_iso_year,
		                         year,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (jd_of_start_of_iso_year,
		                                   year + 1 | 0,
		                                   function(b){return cont((b - a | 0) / 7 | 0);});
		                         });
		               }
		               function iso_int_of_weekday(weekday){
		                return 4153708 <= weekday
		                        ? 4203428
		                          <= weekday
		                          ? 4349046 <= weekday ? 3 : 2
		                          : 4200545 <= weekday ? 4 : 7
		                        : 3853996 === weekday ? 1 : 4149254 <= weekday ? 6 : 5;
		               }
		               function jd_of_iso_week_date(year, week, weekday, cont){
		                var weekday_int = iso_int_of_weekday(weekday);
		                return caml_exact_trampoline_cps_call$0
		                        (weekday_of_ymd,
		                         year,
		                         1,
		                         4,
		                         function(a){
		                          var
		                           jan_4_weekday_int = iso_int_of_weekday(a),
		                           day_of_year =
		                             ((week * 7 | 0) + weekday_int | 0)
		                             - (jan_4_weekday_int + 3 | 0)
		                             | 0,
		                           day_count_of_prev_year = day_count_of_year(year - 1 | 0),
		                           day_count_of_cur_year = day_count_of_year(year);
		                          if(1 <= day_of_year)
		                           if(day_count_of_cur_year < day_of_year)
		                            var
		                             day_of_year$0 = day_of_year - day_count_of_cur_year | 0,
		                             year$0 = year + 1 | 0;
		                           else {day_of_year$0 = day_of_year; year$0 = year;}
		                          else {
		                           day_of_year$0 = day_count_of_prev_year + day_of_year | 0;
		                           year$0 = year - 1 | 0;
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (jd_of_ydoy, year$0, day_of_year$0, cont);
		                         });
		               }
		               function make$23(year, week, cont){
		                if(year >= -1 && 10000 >= year){
		                 var a = function(){return cont([1, [0, -19918314, week]]);};
		                 return 1 <= week
		                         ? caml_exact_trampoline_cps_call
		                           (week_count_of_iso_year,
		                            year,
		                            function(b){
		                             return b < week
		                                     ? a()
		                                     : caml_exact_trampoline_cps_call$0
		                                       (jd_of_iso_week_date,
		year,
		week,
		3853996,
		function(a){return cont([0, [0, a]]);});
		                            })
		                         : a();
		                }
		                return cont([1, [0, 2259935, year]]);
		               }
		               function year_week(t, cont){
		                var
		                 jd = t[1],
		                 match = ymd_of_jd(jd),
		                 day = match[3],
		                 month = match[2],
		                 year = match[1];
		                return caml_exact_trampoline_cps_call$1
		                        (day_offset_from_start_of_year,
		                         year,
		                         month,
		                         function(a){
		                          var day_of_year = a + day | 0;
		                          return caml_exact_trampoline_cps_call
		                                  (weekday_of_jd,
		                                   jd,
		                                   function(weekday){
		                                    var
		                                     week_of_year =
		                                       ((10 + day_of_year | 0) - iso_int_of_weekday(weekday) | 0)
		                                       / 7
		                                       | 0;
		                                    if(0 > week_of_year){
		                                     var b = caml_pop_trap();
		                                     return b
		     (caml_maybe_attach_backtrace([0, Assert_failure, My], 1));
		                                    }
		                                    if(53 < week_of_year){
		                                     b = caml_pop_trap();
		                                     return b
		     (caml_maybe_attach_backtrace([0, Assert_failure, Mx], 1));
		                                    }
		                                    function a(year, week){
		                                     if(weekday === 3853996) return cont([0, year, week]);
		                                     var raise = caml_pop_trap();
		                                     return raise
		     (caml_maybe_attach_backtrace([0, Assert_failure, Mz], 1));
		                                    }
		                                    return 0 === week_of_year
		    ? caml_exact_trampoline_cps_call
		      (week_count_of_iso_year,
		       year - 1 | 0,
		       function(b){return a(year - 1 | 0, b);})
		    : 53
		      === week_of_year
		      ? caml_exact_trampoline_cps_call
		        (week_count_of_iso_year,
		         year,
		         function(b){
		          return 53 <= b ? a(year, week_of_year) : a(year + 1 | 0, 1);
		         })
		      : a(year, week_of_year);
		                                   });
		                         });
		               }
		               var
		                Error_exn$0 =
		                  [248, "Timedesc__Date.Ymd'.Error_exn", caml_fresh_oo_id()];
		               function make$24(year$0, month$0, day, cont){
		                var a = make$22(year$0, month$0);
		                if(0 !== a[0]){var e = a[1]; return cont([1, e]);}
		                var x = a[1], a = year_month(x), month = a[2], year = a[1];
		                function c(){return cont([1, [0, 545273268, day]]);}
		                if(1 > day) return c();
		                a = month - 1 | 0;
		                function b(a){
		                 return a < day
		                         ? c()
		                         : cont([0, [0, jd_of_ymd(year, month, day)]]);
		                }
		                if(11 < a >>> 0)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, cst_invalid_month$0, b);
		                switch(a){
		                  case 1:
		                   return is_leap_year(year) ? b(29) : b(28);
		                  case 3:
		                  case 5:
		                  case 8:
		                  case 10:
		                   return b(30);
		                  default: return b(31);
		                }
		               }
		               function option_get_exn_or(s, x, cont){
		                if(! x)
		                 return caml_exact_trampoline_cps_call(invalid_arg, s, cont);
		                var x$0 = x[1];
		                return cont(x$0);
		               }
		               var
		                Error_exn$1 =
		                  [248, "Timedesc__Time.Error_exn", caml_fresh_oo_id()];
		               function make$25(b, a, hour, minute, second, param){
		                var ns = b ? b[1] : 0, s_frac = a ? a[1] : 0.;
		                if(0 <= hour && 24 >= hour){
		                 if(0 <= minute && 59 >= minute){
		                  if(0 <= second && 60 >= second){
		                   if(s_frac < 0.) return [1, [0, -81896606, s_frac]];
		                   if(0 > ns) return [1, [0, -36072467, ns]];
		                   var ns$0 = ns + (s_frac * 1000000000. | 0) | 0;
		                   if(1000000000 <= ns$0) return [1, [0, -36072467, ns$0]];
		                   a:
		                   if(24 === hour){
		                    if(0 === minute && 0 === second && 0 === ns$0){a = [0, [0, 23, 59, 59, 999999999]]; break a;
		                    }
		                    a = [1, [0, -765575476, hour]];
		                   }
		                   else
		                    a = [0, [0, hour, minute, second, ns$0]];
		                   if(0 === a[0]){
		                    a = a[1];
		                    var
		                     ns$1 = a[4],
		                     second$0 = a[3],
		                     minute$0 = a[2],
		                     hour$0 = a[1],
		                     is_leap_second = 60 === second$0,
		                     second$1 = is_leap_second ? 59 : second$0,
		                     ns$2 = is_leap_second ? ns$1 + 1000000000 | 0 : ns$1,
		                     x =
		                       make_exn
		                        (MA, 0, [0, hour$0], [0, minute$0], [0, second$1]),
		                     s = caml_int64_to_int32(x[1]);
		                    return [0, [0, s, ns$2]];
		                   }
		                   var e = a[1];
		                   return [1, e];
		                  }
		                  return [1, [0, -309856484, second]];
		                 }
		                 return [1, [0, -599258500, minute]];
		                }
		                return [1, [0, -765575476, hour]];
		               }
		               function uint8(pos, s){
		                return [0, pos + 1 | 0, caml_string_get(s, pos)];
		               }
		               function be_uint16(pos, s){
		                var
		                 a = uint8(pos, s),
		                 c0 = a[2],
		                 pos$0 = a[1],
		                 a = uint8(pos$0, s),
		                 c1 = a[2],
		                 pos$1 = a[1];
		                return [0, pos$1, (c0 * 256 | 0) + c1 | 0];
		               }
		               function be_int32(pos, s){
		                var
		                 a = be_uint16(pos, s),
		                 c01 = a[2],
		                 pos$0 = a[1],
		                 a = be_uint16(pos$0, s),
		                 c23 = a[2],
		                 pos$1 = a[1];
		                return [0, pos$1, (c01 << 16) + (65535 & c23) | 0];
		               }
		               function take$4(pos, len, s, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (get_sub,
		                         s,
		                         pos,
		                         len,
		                         function(a){return cont([0, pos + len | 0, a]);});
		               }
		               function count$2(n, f, pos, s){
		                if(0 > n)
		                 throw caml_maybe_attach_backtrace([0, Assert_failure, MC], 1);
		                var b = n - 1 | 0, buf = 0;
		                if(b < 0)
		                 var pos$2 = pos, buf$1 = buf;
		                else {
		                 var pos$1 = pos, buf$0 = buf, for$ = 0;
		                 for(;;){
		                  var
		                   a = f(pos$1, s),
		                   x = a[2],
		                   pos$0 = a[1],
		                   a = [0, x, buf$0],
		                   c = for$ + 1 | 0;
		                  if(b === for$){pos$2 = pos$0; buf$1 = a; break;}
		                  pos$1 = pos$0;
		                  buf$0 = a;
		                  for$ = c;
		                 }
		                }
		                return [0, pos$2, rev(buf$1)];
		               }
		               function compare$55(b, a, cont){
		                return cont(caml_compare(b, a));
		               }
		               var
		                include$45 = u([0, compare$55]),
		                empty$21 = include$45[1],
		                add$13 = include$45[2],
		                mem$7 = include$45[31];
		               function compare$56(b, a, cont){
		                return cont(caml_compare(b, a));
		               }
		               var
		                include$46 = u([0, compare$56]),
		                empty$22 = include$46[1],
		                add$14 = include$46[2],
		                to_seq$1 = include$46[40];
		               function is_digit$3(c, cont){
		                return 9 < c - 48 >>> 0 ? cont(0) : cont(1);
		               }
		               var digit$2 = satisfy(is_digit$3);
		               function optional_char(target){
		                return symbol_bind$3
		                        (peek_char,
		                         function(c, cont){
		                          if(! c)
		                           return caml_exact_trampoline_cps_call(return$7, 0, cont);
		                          var c$0 = c[1];
		                          return c$0 === target
		                                  ? caml_exact_trampoline_cps_call
		                                    (return$7,
		                                     0,
		                                     function(a){return cont(symbol$61(any_char, a));})
		                                  : caml_exact_trampoline_cps_call(return$7, 0, cont);
		                         });
		               }
		               function f$8(param, cont){
		                return 9 < param - 48 >>> 0 ? cont(0) : cont(1);
		               }
		               var
		                num_string = count_while1(f$8, substring),
		                nat_zero =
		                  symbol_bind$3
		                   (num_string,
		                    function(s, cont){
		                     caml_push_trap
		                      (function(exn){
		                        return caml_exact_trampoline_cps_call
		                                (sprintf,
		                                 MD,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (a, s, function(a){return cont(fail$0(a));});
		                                 });
		                       });
		                     return caml_exact_trampoline_cps_call
		                             (return$7,
		                              caml_int_of_string(s),
		                              function(a){caml_pop_trap(); return cont(a);});
		                    }),
		                one_digit_nat_zero =
		                  symbol_bind$3
		                   (digit$2,
		                    function(c, cont){
		                     return caml_exact_trampoline_cps_call
		                             (sprintf,
		                              ME,
		                              function(a){
		                               return caml_trampoline_cps_call2
		                                       (a,
		c,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (return$7, caml_int_of_string(a), cont);
		});
		                              });
		                    }),
		                two_digit_nat_zero =
		                  symbol_bind$3
		                   (digit$2,
		                    function(c1, cont){
		                     return cont
		                             (symbol_bind$3
		                               (digit$2,
		                                function(c2, cont){
		                                 return caml_exact_trampoline_cps_call
		 (sprintf,
		  MF,
		  function(a){
		   return caml_trampoline_cps_call3
		           (a,
		            c1,
		            c2,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (return$7, caml_int_of_string(a), cont);
		            });
		  });
		                                }));
		                    }),
		                max_two_digit_nat_zero =
		                  caml_callback
		                   (symbol$64,
		                    [two_digit_nat_zero,
		                     symbol_bind$3
		                      (digit$2,
		                       function(c, cont){
		                        return caml_exact_trampoline_cps_call
		                                (sprintf,
		                                 MG,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (a,
		   c,
		   function(a){
		    return caml_exact_trampoline_cps_call
		            (return$7, caml_int_of_string(a), cont);
		   });
		                                 });
		                       })]),
		                include$47 = u([0, compare_decoded]),
		                union$4 = include$47[5],
		                to_seq$2 = include$47[40],
		                of_seq$0 = include$47[43];
		               function check_table(a, cont){
		                var
		                 entries = a[2],
		                 starts = a[1],
		                 size = caml_ba_dim_1(starts);
		                if(size === entries.length - 1){
		                 var
		                  b =
		                    function(seen, has_no_dup, i){
		                     if(has_no_dup && i < size){
		                      var start = caml_ba_get_1(starts, i);
		                      return caml_exact_trampoline_cps_call$1
		                              (mem$7,
		                               start,
		                               seen,
		                               function(c){
		                                function a(seen, has_no_dup){
		                                 return caml_exact_trampoline_call3
		 (b, seen, has_no_dup, i + 1 | 0);
		                                }
		                                return c
		? a(seen, 0)
		: caml_exact_trampoline_cps_call$1
		  (add$13, start, seen, function(b){return a(b, has_no_dup);});
		                               });
		                     }
		                     var is_sorted$0 = 1, i$0 = 0;
		                     for(;;){
		                      if(is_sorted$0 && i$0 < size){
		                       if(0 < i$0)
		                        var
		                         cur = caml_ba_get_1(starts, i$0),
		                         prev = caml_ba_get_1(starts, i$0 - 1 | 0),
		                         is_sorted$1 = caml_lessthan(cur, prev) ? 0 : is_sorted$0;
		                       else
		                        is_sorted$1 = is_sorted$0;
		                       is_sorted$0 = is_sorted$1;
		                       i$0 = i$0 + 1 | 0;
		                       continue;
		                      }
		                      var is_sorted = has_no_dup ? is_sorted$0 : has_no_dup;
		                      return cont(is_sorted);
		                     }
		                    };
		                 return b(empty$21, 1, 0);
		                }
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, MH], 1));
		               }
		               function process_table(a, cont){
		                var
		                 entries = a[2],
		                 starts = a[1],
		                 size = caml_ba_dim_1(starts);
		                if(size !== entries.length - 1){
		                 a = caml_pop_trap();
		                 return a
		                         (caml_maybe_attach_backtrace([0, Assert_failure, MJ], 1));
		                }
		                if(0 === size)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg, "time zone record table is empty", cont);
		                var
		                 first_start = caml_ba_get_1(starts, 0),
		                 first_entry = caml_check_bound(entries, 0)[1];
		                function b(starts, entries){
		                 var a = entries.length - 2 | 0;
		                 function c(r){
		                  var seq = to_seq$1(r), seq$0 = seq, acc = 0;
		                  for(;;){
		                   var b = seq$0();
		                   if(! b) break;
		                   var next = b[2], x = b[1], acc$0 = [0, x, acc];
		                   seq$0 = next;
		                   acc = acc$0;
		                  }
		                  if(acc){
		                   var
		                    tl = acc[2],
		                    hd = acc[1],
		                    len = list_length(0, acc),
		                    a = caml_make_vect(len, hd),
		                    i$1 = len - 2 | 0,
		                    i = i$1,
		                    b = tl;
		                   for(;;){
		                    if(! b){var recorded_offsets = a; break;}
		                    var tl$0 = b[2], hd$0 = b[1];
		                    a[i + 1] = hd$0;
		                    var i$0 = i - 1 | 0;
		                    i = i$0;
		                    b = tl$0;
		                   }
		                  }
		                  else
		                   recorded_offsets = [0];
		                  var table = [0, starts, entries];
		                  return caml_exact_trampoline_cps_call
		                          (check_table,
		                           table,
		                           function(a){
		                            if(a) return cont([0, recorded_offsets, table]);
		                            a = caml_pop_trap();
		                            return a
		                                    (caml_maybe_attach_backtrace([0, Assert_failure, MI], 1));
		                           });
		                 }
		                 function b(acc, i){
		                  var entry = entries[i + 1];
		                  return caml_exact_trampoline_cps_call$1
		                          (add$14,
		                           entry[2],
		                           acc,
		                           function(e){
		                            var d = i + 1 | 0;
		                            return a !== i ? caml_exact_trampoline_call2(b, e, d) : c(e);
		                           });
		                 }
		                 return a < 0 ? c(empty$22) : b(empty$22, 0);
		                }
		                if(caml_lessthan(timestamp_min[1], first_start)){
		                 var
		                  starts$0 = create$2(7, c_layout, size + 1 | 0),
		                  sub = caml_ba_sub(starts$0, 1, size);
		                 caml_ba_set_1(starts$0, 0, timestamp_min[1]);
		                 caml_ba_blit(starts, sub);
		                 return caml_exact_trampoline_cps_call$1
		                         (append,
		                          [0, first_entry],
		                          entries,
		                          function(a){return b(starts$0, a);});
		                }
		                caml_ba_set_1(starts, 0, timestamp_min[1]);
		                return b(starts, entries);
		               }
		               var
		                z = symbol$61(end_of_input, caml_callback(return$7, [zero$0])),
		                h = caml_callback(return$7, [3901488]),
		                h = symbol$61(char$0(45), h),
		                b3 = caml_callback(return$7, [4003188]),
		                h =
		                  caml_callback
		                   (symbol$64,
		                    [symbol_bind$3
		                      (caml_callback(symbol$64, [symbol$61(char$0(43), b3), h]),
		                       function(sign, cont){
		                        var
		                         b =
		                           symbol_bind$3
		                            (symbol$62(max_two_digit_nat_zero, end_of_input),
		                             function(hour, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (return$7, [0, hour, 0], cont);
		                             });
		                        function a(param, cont){
		                         var minute = param[2], hour = param[1];
		                         if(24 > hour && 60 > minute)
		                          return caml_exact_trampoline_cps_call
		                                  (return$7,
		                                   make_exn([0, sign], 0, [0, hour], [0, minute], 0),
		                                   cont);
		                         return cont(fail$0("invalid offset"));
		                        }
		                        return caml_exact_trampoline_cps_call$1
		                                (symbol$64,
		                                 symbol_bind$3
		                                  (max_two_digit_nat_zero,
		                                   function(hour, cont){
		                                    return cont
		    (symbol_bind$3
		      (symbol$62
		        (symbol$61(char$0(58), max_two_digit_nat_zero),
		         end_of_input),
		       function(minute, cont){
		        return caml_exact_trampoline_cps_call
		                (return$7, [0, hour, minute], cont);
		       }));
		                                   }),
		                                 b,
		                                 function(b){return cont(symbol_bind$3(b, a));});
		                       }),
		                     z]),
		                fixed_offset_name_parser = symbol$61(string$3(cst_UTC), h),
		                one_day = make_exn(0, ML, 0, 0, 0);
		               function make_offset_only(offset, cont){
		                if(caml_greaterthan(abs$2(offset), one_day)) return cont(0);
		                var
		                 offset$0 = caml_int64_to_int32(offset[1]),
		                 data = [0, timestamp_min[1]],
		                 ba = create$2(7, 0, data.length - 1),
		                 a = data.length - 2 | 0;
		                if(a >= 0){
		                 var i = 0;
		                 for(;;){
		                  caml_ba_set_1(ba, i | 0, caml_check_bound(data, i)[i + 1]);
		                  var b = i + 1 | 0;
		                  if(a === i) break;
		                  i = b;
		                 }
		                }
		                return caml_exact_trampoline_cps_call
		                        (process_table,
		                         [0, ba, [0, [0, 0, offset$0]]],
		                         function(a){return cont([0, [0, [1, offset$0], a]]);});
		               }
		               var
		                dummy_tz =
		                  caml_callback
		                   (option_get_exn_or,
		                    ["expected successful construction of UTC",
		                     caml_callback(make_offset_only, [zero$0])]);
		               function bsearch_table(timestamp, a){
		                var starts = a[1], n = caml_ba_dim_1(starts);
		                if(0 === n) return 50834029;
		                var
		                 x = caml_ba_get_1(starts, 0),
		                 c = caml_int64_compare(x, timestamp),
		                 x$0 = caml_ba_get_1(starts, n - 1 | 0),
		                 a = caml_int64_compare(x$0, timestamp);
		                if(0 < c) return -923815278;
		                if(0 > a) return 814295299;
		                var j$1 = n - 1 | 0, i = 0, j = j$1;
		                for(;;){
		                 if(j < i) return [0, 550003881, j];
		                 var
		                  middle = i + ((j - i | 0) / 2 | 0) | 0,
		                  y = caml_ba_get_1(starts, middle),
		                  n$0 = caml_int64_compare(timestamp, y);
		                 if(0 === n$0) return [0, 14611, middle];
		                 if(0 <= n$0){
		                  var i$0 = middle + 1 | 0;
		                  i = i$0;
		                 }
		                 else {var j$0 = middle - 1 | 0; j = j$0;}
		                }
		               }
		               function local_interval_of_table(param, i){
		                var
		                 entries = param[2],
		                 starts = param[1],
		                 size = caml_ba_dim_1(starts),
		                 start_utc = caml_ba_get_1(starts, i),
		                 entry = caml_check_bound(entries, i)[i + 1],
		                 end_exc_utc =
		                   i === (size - 1 | 0)
		                    ? timestamp_max[1]
		                    : caml_ba_get_1(starts, i + 1 | 0);
		                return [0,
		                        caml_int64_add(start_utc, caml_int64_of_int32(entry[2])),
		                        caml_int64_add(end_exc_utc, caml_int64_of_int32(entry[2]))];
		               }
		               function interval_mem(t, a){
		                var
		                 y = a[2],
		                 x = a[1],
		                 a = caml_lessequal(x, t),
		                 a = a ? caml_lessthan(t, y) : a;
		                return a;
		               }
		               function relative_entry(pos$4, s){
		                var
		                 a = uint8(pos$4, s),
		                 flags = a[2],
		                 pos$5 = a[1],
		                 is_abs = 0 !== (flags & 64) ? 1 : 0,
		                 value_is_64bit = 0 !== (flags & 32),
		                 is_dst = 0 !== (flags & 16) ? 1 : 0,
		                 is_pos = 0 !== (flags & 8),
		                 hour_nz = 0 !== (flags & 4),
		                 minute_nz = 0 !== (flags & 2),
		                 second_nz = 0 !== (flags & 1);
		                if(value_is_64bit){
		                 a = be_int32(pos$5, s);
		                 var
		                  c0123 = a[2],
		                  pos = a[1],
		                  a = be_int32(pos, s),
		                  c4567 = a[2],
		                  pos$0 = a[1],
		                  value =
		                    caml_int64_add
		                     (caml_int64_shift_left(caml_int64_of_int32(c0123), 32),
		                      caml_int64_and(MB, caml_int64_of_int32(c4567))),
		                  pos$6 = pos$0;
		                }
		                else {
		                 a = be_int32(pos$5, s);
		                 var
		                  x$0 = a[2],
		                  pos$7 = a[1],
		                  value$0 = caml_int64_and(caml_int64_of_int32(x$0), MN),
		                  value = value$0,
		                  pos$6 = pos$7;
		                }
		                var sign = is_pos ? 4003188 : 3901488;
		                if(hour_nz){
		                 a = uint8(pos$6, s);
		                 var hours = a[2], pos$1 = a[1];
		                }
		                else {hours = 0; pos$1 = pos$6;}
		                if(minute_nz){
		                 a = uint8(pos$1, s);
		                 var minutes = a[2], pos$2 = a[1];
		                }
		                else {minutes = 0; pos$2 = pos$1;}
		                if(second_nz){
		                 a = uint8(pos$2, s);
		                 var seconds = a[2], pos$3 = a[1];
		                }
		                else {seconds = 0; pos$3 = pos$2;}
		                var
		                 x =
		                   make_exn
		                    ([0, sign], 0, [0, hours], [0, minutes], [0, seconds]),
		                 offset = caml_int64_to_int32(x[1]);
		                return [0, pos$3, [0, value, is_abs, is_dst, offset]];
		               }
		               function half_compressed_of_string_exn(s, cont){
		                function c(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (invalid_arg, "failed to deserialize compressed tzdb", cont);
		                 var x = match[1];
		                 return cont(x);
		                }
		                caml_push_trap(function(exn){return c(0);});
		                var
		                 a = be_uint16(0, s),
		                 table_count = a[2],
		                 pos = a[1],
		                 a = M$4[1],
		                 b = table_count - 1 | 0;
		                function e(pos, m){
		                 if(pos === caml_ml_string_length(s)){caml_pop_trap(); return c([0, m]);}
		                 var raise = caml_pop_trap();
		                 return raise
		                         (caml_maybe_attach_backtrace([0, Assert_failure, MQ], 1));
		                }
		                function d(pos$0, m, for$){
		                 var
		                  match = uint8(pos$0, s),
		                  name_len = match[2],
		                  pos = match[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (take$4,
		                          pos,
		                          name_len,
		                          s,
		                          function(a){
		                           var
		                            name = a[2],
		                            pos = a[1],
		                            a = be_uint16(pos, s),
		                            table_str_len = a[2],
		                            pos$0 = a[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (take$4,
		                                    pos$0,
		                                    table_str_len,
		                                    s,
		                                    function(match){
		                                     var table_str = match[2], pos = match[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (M$4[2],
		      name,
		      table_str,
		      m,
		      function(a){
		       var c = for$ + 1 | 0;
		       return b !== for$
		               ? caml_exact_trampoline_call3(d, pos, a, c)
		               : e(pos, a);
		      });
		                                    });
		                          });
		                }
		                return b < 0 ? e(pos, a) : d(pos, a, 0);
		               }
		               var
		                db = [0, M$4[1]],
		                half_compressed =
		                  caml_callback
		                   (half_compressed_of_string_exn,
		                    ["\x02W\x0eAfrica/Abidjan\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\fAfrica/Accra\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x12Africa/Addis_Ababa\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\x0eAfrica/Algiers\0U\v\b\0\xcb\x07\0\b\0\xf99\x90\b\x02\r\xea`|\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1c\0\xef\xff\x10\x01\x1c\0\xcb\x15\x10\x02\f\0\xddm\xf0\x01\f\0\xef\xe2\xf0\x01\f\0\xef\xff\x10\x01\x1c\n\x8c\x0e\x10\x01<\0\0\0\x0e{\xecy\x10\x01\0\v\x03\n\0\t\x06\x05\b\x02\x04\x01\x07\rAfrica/Asmara\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\rAfrica/Asmera\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\rAfrica/Bamako\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\rAfrica/Bangui\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\rAfrica/Banjul\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\rAfrica/Bissau\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\x82\xdb\x180\0\x02\0\x01\x0fAfrica/Blantyre\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\x12Africa/Brazzaville\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\x10Africa/Bujumbura\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\fAfrica/Cairo\x01R\"\f\0\x1b\xa1p\x02\f\x007P\xf0\x02\f\0I\xc5\xf0\x02\f\0Y\xb4\x10\x02\f\0j\xd7\x90\x02\f\0\x87\xbcp\x02\f\0\x9c\xd4p\x02\f\0\xa6\x0e\xf0\x02\f\0\xafIp\x02\f\0\xc1\xbep\x02\f\0\xc3,\x10\x02\f\0\xc9\xc3\x90\x02\f\0\xca\xf8\xf0\x02\f\0\xef\xe2\xf0\x02\f\0\xf9\x1dp\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0'\x9b\x10\x03\x1c\0.2\x90\x03\x1c\0\xe6\xc4\x90\x03\x1c\0\xef\xff\x10\x03\x1c\x01\x13m`\x03\x1c\x01\x14\xe9\x10\x03\x1c\x01\x17o\xf0\x03\x1c\x01\x18\xc1p\x03\x1c\x01\x1e\x07p\x03\x1c\x01\x1e#\x90\x03\x1c\x010\x98\x90\x03\x1c\x019\xd3\x10\x03\x1c\x01LH\x10\x03\x1c\x01v[\xf0\x03\x1c\x01\x87\x7fp\x03\x1c\x06\xd0>\x90\x03\x1c\x10&n\x10\x03<\0\0\0\x0ez\x11\xdd\x10\x03\0{\x0f!\v\x16\v\x17\v\x16\v\x16\v\x16\v\x17\v\x16\v\x16\v\x16\v\x17\v\x16\v\x1e\x03\x1d\x04\x17\v\x16\v\x16\v\x16\v\x17\v\x18\n\x16\v\x16\v\x17\v\x16\v\x16\v\x14\f\x15\f\x15\f\x15\f\x19\f\x15\f\x15\f\x15\f\x15\f\x19\f\x15\f\x15\t\x19\b\x1a\x07\x1b\x06\x1c\x05\x10\0\x1f\x01\x11\x02 \r\x13\x0e\x12\x0e\x12\x0e\x13\r\x13\r\x13\r\x13\x0e\x12\x0e\x13\r\x13\r\x13\r\x13\r\x13\x0e\x12\x0e\x13\r\x13\r\x11Africa/Casablanca\x01Q+\x18\0\xf9+\x80\x18\x01\x9fH\x80\x18\x01\xa8\x83\0\b\x006\r\x80\b\0@\x99\x80\b\0I\xd4\0\b\0TQ\xf0\b\0Z\xe9p\b\0\\I\0\b\0e\x83\x80\b\0f\xd5\0\b\0j\xbbp\b\0l\x1b\0\b\0p\x0f\x80\b\0v\xa7\0\b\0y;\xf0\b\0\x81$\xf0\b\0\x813\0\b\0\x93\xa8\0\b\0\x9c\xd4p\b\0\x9c\xe2\x80\b\0\xc5\xb2\xf0\b\x03`\xc9\xf0|\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1c\0(\xde\x80\x01\x1c\0,\xd3\0\x01\x1c\0.$\x80\x01\f\0.$\x80\x01\x1c\x007_\0\x01\f\x007_\0\x01\f\0\xafW\x80\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\x01\x14\xdb\0\x01\x1c\x019\xd3\x10\x01\x1c\x01D_\x10\x01\x1c\x01N\xeb\x10\x01\x1c\x01g\xf7\x90\x01\x1c\x01h\x13\xb0\x01\x1c\x03!\x9e\x10\x01\x1c*)v\x90\x01\f\n\x90\x02\x90\x01<\0\0\0\x0e\x81\xdf;\xa0\x01\0[\x17*\x07'\x0f%\x15#\x06)\x16(\x0f%\v$\x10\"\x13&\f\x18\x03!\b\x19\n \x0e\x1a\r \t\x1a\x11 \b\x1a\x12\x1f\x05\x1c\x14\x1f\x04\x1a\x1e\0\x1b\x01\x1d\x01\x1b\x01\x1d\x01\x1b\x02\x1b\x01\x1d\x01\x1b\x02\x1b\x01\x1d\x01\x1b\x01\x1d\x01\x1b\x02\x1b\x01\x1d\x01\x1b\x01\x1d\x01\x1d\x01\x1b\x01\x1d\x01\x1b\x02\x1b\fAfrica/Ceuta\0\xef\x13\b\0TQ\xf0\b\0Z\xe9p\b\0y;\xf0\b\0\xc5\xb2\xf0|\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01\x1c\x01D_\x10\x01\x1c\x01g\xf7\x90\x01\x1c\x03!\x9e\x10\x01\x1c\x03\xd4\xea\x10\x02\f\n\x90\x02\x90\x01<\0\0\0\x0e\x81\xdf;\xa0\x01\0v\x04\x12\x01\x0f\x02\x0e\x03\r\0\x11\x10\t\x07\t\x07\t\x07\t\x07\n\x07\t\x07\t\x07\t\x07\t\x07\t\b\v\x06\v\x06\v\x06\f\x05\f\x05\f\x06\v\x06\v\x06\f\x05\f\x05\f\x05\f\x06\v\x06\v\x06\f\x05\f\x05\f\x06\v\x06\v\x06\v\x06\f\x05\f\x05\f\x06\v\x06\v\x06\f\x05\f\x05\f\x06\v\x06\v\x06\v\x06\f\x05\f\x05\f\x06\v\x06\v\x06\f\x05\f\x05\f\x05\f\x06\v\x06\v\x06\f\x05\f\x0eAfrica/Conakry\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\fAfrica/Dakar\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x14Africa/Dar_es_Salaam\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\x0fAfrica/Djibouti\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\rAfrica/Douala\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\x0fAfrica/El_Aaiun\x01<(\x18\0\xf9+\x80\x18\x01\x9fH\x80\x18\x01\xa8\x83\0\x1c\0\x16[p\x01\x1c\0(\xde\x80\x01\x1c\0,\xd3\0\x01\x1c\0.$\x80\x01\x1c\x007_\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\x01\x14\xdb\0\x01\x1c\x019\xd3\x10\x01\x1c\x01D_\x10\x01\x1c\x01N\xeb\x10\x01\x1c\x01g\xf7\x90\x01\x1c\x01h\x13\xb0\x01\x1c8\x1aC\x10\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\f\0.$\x80\x01\b\x006\r\x80\f\x007_\0\x01\b\0@\x99\x80\b\0I\xd4\0\b\0TQ\xf0\b\0\\I\0\b\0e\x83\x80\b\0f\xd5\0\b\0j\xbbp\b\0l\x1b\0\b\0p\x0f\x80\b\0v\xa7\0\b\0y;\xf0\b\0\x81$\xf0\b\0\x813\0\b\0\x93\xa8\0\b\0\x9c\xd4p\b\0\x9c\xe2\x80\f\0\xafW\x80\x01\b\0\xc5\xb2\xf0(\0\0\0\x0e\x85Eg\xb0\0X\x11'\x03\x1f\x0e&\f\x17\x10\x1f\x0e\x1b\r \v#\x0f\x1c\x04\x13\n\x18\x05\x1a\t\x1e\x06\x1d\t\x19\x06!\t\x18\x06\"\b\x16\x07$\b\x15\x06%\0\x12\x01\x14\x01\x12\x01\x14\x01\x12\x02\x12\x01\x14\x01\x12\x02\x12\x01\x14\x01\x12\x01\x14\x01\x12\x02\x12\x01\x14\x01\x12\x01\x14\x01\x14\x01\x12\x01\x14\x01\x12\x02\x12\x0fAfrica/Freetown\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x0fAfrica/Gaborone\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\rAfrica/Harare\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\x13Africa/Johannesburg\x008\x06\x1c\0\xef\xff\x10\x03\x1cJg\xbd\x18\x03n\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1e\f\0\xef\xe2\xf0\x02\f\x14\xcb\x8e(\x02.\0\0\0\r\xe6\xee\xf8`\x01\x1e\0\x07\x02\x05\x04\x01\x03\0\x03\vAfrica/Juba\0\xa6\x14\f\0\xdc\x1cp\x02\f\0\xddm\xf0\x02\f\0\xde\xbfp\x02\f\0\xe0\x10\xf0\x02\f\0\xe1bp\x02\f\0\xe2\xb3\xf0\x02\f\0\xe4\x05p\x02\f\0\xe5V\xf0\x02\f'\x96\xd50\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xfb\xdc\x90\x03\x1c\0\xfd.\x10\x03\x1c\0\xfe\x7f\x90\x03\x1c\0\xff\xd1\x10\x03\x1c\x01\x01\"\x90\x03\x1c\x01\x02t\x10\x03\x1c\x01\x03\xc5\x90\x03\x1c\x01\x05\x17\x10\x03\f\x1a\xce\xc6P\x03<\0\0\0\x0ez\x11\xcf\0\x03\0#\t\x13\0\x10\x01\x11\x01\x0f\x02\x0e\x03\r\x04\f\x06\n\x07\x10\x01\x0f\x02\x0e\x04\f\x05\v\x06\n\x07\x10\x02\x0e\x03\x12\b\x0eAfrica/Kampala\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\x0fAfrica/Khartoum\0\xa6\x14\f\0\xdc\x1cp\x02\f\0\xddm\xf0\x02\f\0\xde\xbfp\x02\f\0\xe0\x10\xf0\x02\f\0\xe1bp\x02\f\0\xe2\xb3\xf0\x02\f\0\xe4\x05p\x02\f\0\xe5V\xf0\x02\f!x\x9f0\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xfb\xdc\x90\x03\x1c\0\xfd.\x10\x03\x1c\0\xfe\x7f\x90\x03\x1c\0\xff\xd1\x10\x03\x1c\x01\x01\"\x90\x03\x1c\x01\x02t\x10\x03\x1c\x01\x03\xc5\x90\x03\x1c\x01\x05\x17\x10\x03\f\x1a\xce\xc6P\x03<\0\0\0\x0ez\x11\xcf\0\x03\0#\t\x13\0\x10\x01\x11\x01\x0f\x02\x0e\x03\r\x04\f\x06\n\x07\x10\x01\x0f\x02\x0e\x04\f\x05\v\x06\n\x07\x10\x02\x0e\x03\x12\b\rAfrica/Kigali\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\x0fAfrica/Kinshasa\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\fAfrica/Lagos\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\x11Africa/Libreville\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\vAfrica/Lome\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\rAfrica/Luanda\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\x11Africa/Lubumbashi\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\rAfrica/Lusaka\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\rAfrica/Malabo\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\rAfrica/Maputo\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x02,\0\0\0\x0e\x06\xb6\x8c\x96\x02\0\x02\0\x01\rAfrica/Maseru\x008\x06\x1c\0\xef\xff\x10\x03\x1cJg\xbd\x18\x03n\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1e\f\0\xef\xe2\xf0\x02\f\x14\xcb\x8e(\x02.\0\0\0\r\xe6\xee\xf8`\x01\x1e\0\x07\x02\x05\x04\x01\x03\0\x03\x0eAfrica/Mbabane\x008\x06\x1c\0\xef\xff\x10\x03\x1cJg\xbd\x18\x03n\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1e\f\0\xef\xe2\xf0\x02\f\x14\xcb\x8e(\x02.\0\0\0\r\xe6\xee\xf8`\x01\x1e\0\x07\x02\x05\x04\x01\x03\0\x03\x10Africa/Mogadishu\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\x0fAfrica/Monrovia\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e}>\x11\x8e\0\x02\0\x01\x0eAfrica/Nairobi\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\x0fAfrica/Ndjamena\0 \x03\f\0\xc0l\xf0\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02<\0\0\0\x0e\x8b\xda(\x90\x02\0\x03\x01\x02\0\rAfrica/Niamey\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\x11Africa/Nouakchott\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x12Africa/Ouagadougou\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x11Africa/Porto-Novo\0-\x05h\xff\xff\xff\xf1\x86\x8cH\xe0\v\x05\xa4\xef/\r#\n\nY\xe3\xd1\x1e\f\n\xa7\xab\xa7\x01(\0\0\0\x0e\0\x1f'\xf1\0\x05\0\x04\x01\x02\x03\x0fAfrica/Sao_Tome\0\x1f\x03\b\x01\xe13\x80l\xff\xff\xff\xf1\x86\x8cH\xe0\x01,\0\0\0\x0e\xd3\xbd?0\x01\0\x03\x01\x02\0\x0fAfrica/Timbuktu\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x0eAfrica/Tripoli\0\x90\x12\x1c\0v\xb5\x10\x02\x1c\0\xb7@\x80\x02\x1c\0\xed\\\x10\x02\x1c\0\xef\xff\x10\x02\x1c\0\xf1P\x90\x02\x1c\0\xf3\xf3\x90\x02\x1c\0\xf5E\x10\x02\x1c\0\xf6\x96\x90\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x01\f\0\xea\x9c\xf0\x01\f\0\xef\xe2\xf0\x01\f\0\xf14p\x01\f\0\xf14p\x02\f\x01\x14\xdb\0\x02\f\f\x0e9p\x01\f\x1ch. \x01\f\x01\x1b\x80\x90\x02,\0\0\0\x0e\x90\x05\xf9\x80\x01\0\x19\b\x11\0\v\x03\v\x04\v\x07\t\x05\n\x02\v\x04\v\x03\v\x10\x0e\x06\f\x0f\x01\r\fAfrica/Tunis\0\x84\x11\f\0\x98\xee\0\x01\f\0\xc1\xcc\x80\x01\f\0\xc8d\0\x01\f\0\xc8r\x10\x01\f\0\xc9\xb5\x80\x01\f\0\xef\xf1\0\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xe9g\x90\x02\x1c\0\xef\xf1\0\x02\x1c\x01 \xb8\x80\x02\x1c\x12/ \x80\x02\x1c\x1bn\xe6\x80\x02<\0\0\0\x0e\x87;\x97\x10\x02\0\x13\b\x10\x01\r\x04\x0e\0\f\x05\r\x02\x0f\x03\v\x07\t\x07\n\x06\x0fAfrica/Windhoek\0m\b\x1c\x01\x14\xcc\xf0\x01\x1c\x01\x1e\x07p\x01\x1c\x07\x86\x1f\x80\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x02\f\0\xc1\xda\x90\x02\f\0\xcb\x15\x10\x02\f\0\xdcT\xb0\x02,\0\0\0\x0e\x9fz_\0\x02\x002\x03\x07\x02\x06\0\x05\x01\x04\x01\x05\0\x05\0\x05\0\x05\0\x05\x01\x04\x01\x05\0\x05\0\x05\0\x05\0\x05\x01\x05\0\x05\0\x05\0\x05\0\x05\x01\x04\x01\x05\0\x05\0\x05\0\x05\fAmerica/Adak\x01#\x17\x04\0\xef\xe2\xf0\v\x04\0\xf9\x1dp\v\x04\x01B\xf1p\v\x04\x01\x83\x8a\xf0\vt\xff\xff\xff\xf1\x86\x8cH\xe0\n\x04\0(\xc2`\n\x14\0\\W\x10\n\x14\0\x9c\xf0\x90\n\x04\x019\xb6\xf0\n\x14\0\xa6+\x10\t\x14\0\xafe\x90\t\x14\0\xc7.\xa0\t\x14\0\xcb\x15\x10\t\x14\0\xd4O\x90\t\x14\0\xe6\xc4\x90\n\x04\0\xef\xe2\xf0\n\x14\0\xef\xff\x10\n\x14\0\xef\xff\x10\t\x04\0\xf9\x1dp\n\x04\x01\v\x92p\n\x04\x01\x14\xcc\xf0\n\x04\x019\xb6\xf0\n4\0\0\0\x0ez\f\np\n\0\x8e\x04\x16\0\x10\x01\x10\0\x10\0\x06\x03\x07\x02\x10\x01\x0e\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0e\x12\x05\v\x0f\x11\x0f\x11\x0f\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\n\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\x11America/Anchorage\x01#\x17\x04\0\xef\xe2\xf0\n\x04\0\xf9\x1dp\n\x04\x01B\xf1p\n\x04\x01\x83\x8a\xf0\nt\xff\xff\xff\xf1\x86\x8cH\xe0\t\x04\0(\xc2`\t\x14\0\\W\x10\t\x14\0\x9c\xf0\x90\t\x04\x019\xb6\xf0\t\x14\0\xa6+\x10\b\x14\0\xafe\x90\b\x14\0\xc7.\xa0\b\x14\0\xcb\x15\x10\b\x14\0\xd4O\x90\b\x14\0\xe6\xc4\x90\t\x04\0\xef\xe2\xf0\t\x14\0\xef\xff\x10\t\x14\0\xef\xff\x10\b\x04\0\xf9\x1dp\t\x04\x01\v\x92p\t\x04\x01\x14\xcc\xf0\t\x04\x019\xb6\xf0\t4\0\0\0\x0ez\v\xfc`\t\0\x8e\x04\x16\0\x10\x01\x10\0\x10\0\x06\x03\x07\x02\x10\x01\x0e\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0e\x12\x05\v\x0f\x11\x0f\x11\x0f\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\n\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\x10America/Anguilla\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x0fAmerica/Antigua\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x11America/Araguaina\0\x8e\x11\x04\0\x8a_p\x03\x04\0\x93\x99\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xc0l\xf0\x03\x04\0\xc1\xbep\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x011\xea\x10\x02\x14\x019\xd3\x10\x02\x14\x01LH\x10\x02\x14\x01M\x99\x90\x02\x14\x01U\x82\x90\x02\x14\n\xab\xb2\x10\x02\x14\x124t\x90\x024\0\0\0\x0e\x97=EP\x02\0\x1d\x07\x10\x04\b\x01\f\0\v\0\r\x02\x0e\x02\n\x04\t\x05\b\x04\b\x06\b\x04\n\x03\r\0\x0f\x02\x1eAmerica/Argentina/Buenos_Aires\0x\x0f\x04\0eup\x03\x14\f]o\x90\x03\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xafIp\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xbep\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\x1e#\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\b\x0e\x03\r\x02\n\x05\v\x04\v\x04\v\x05\x01\x07\f\0\t\x06\x1bAmerica/Argentina/Catamarca\0\x84\x11\x04\0\x19\x1a\x90\x03\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\x07\xfc\xc6\x80\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x06\xa1\xfd\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\n\x10\x06\x0f\x05\v\b\f\x03\r\x07\f\b\x02\t\x04\0\x0e\x01 America/Argentina/ComodRivadavia\0\x84\x11\x04\0\x19\x1a\x90\x03\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\x07\xfc\xc6\x80\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x06\xa1\xfd\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\n\x10\x06\x0f\x05\v\b\f\x03\r\x07\f\b\x02\t\x04\0\x0e\x01\x19America/Argentina/Cordoba\0\x84\x11\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xbep\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\x1e#\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\t\x10\x04\x0f\x03\v\x06\f\x02\r\x05\f\x06\x01\b\x0e\0\n\x07\x17America/Argentina/Jujuy\0|\x10\x04\0eup\x03\x14\x019\xe1 \x03\x14\f]o\x90\x03\x04\0\xb8\x83\xf0\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xb0`\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\v\xae\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x11\t\x0f\x05\x0e\x04\v\x03\x01\x03\n\x07\f\x06\x02\b\r\0\x1aAmerica/Argentina/La_Rioja\0\x8b\x12\x04\0\x19\x1a\x90\x03\x14\f]o\x90\x03\x04\0Xp\xa0\x03\x04\0eup\x03\x04\0\xac\xa6p\x04\x04\x07\xfc\xc6\x80\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xafIp\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\0\xda\xca\xf0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x06\xa1\xfd\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x14\v\x11\x07\x10\x06\r\t\x0e\x04\x02\f\b\x0e\t\x01\n\x05\0\x0f\x03\x19America/Argentina/Mendoza\0\x90\x13\x04\0eup\x03\x04\0\xb4\x8fp\x04\x04\0\xb5\xe0\xf0\x04\x04\x07\xf0\xe9\0\x04\x14\x01(\xbd\xa0\x03\x14\x01,\xa4\x10\x03\x14\f]o\x90\x03\x04\0\xb8\x83\xf0\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xa6+\x10\x03\x04\0\xb8u\xe0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x06 \xca\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\r\x12\t\x11\b\x0e\x07\x04\x01\x05\x02\x0f\v\x06\f\x03\n\x10\0\x1eAmerica/Argentina/Rio_Gallegos\0x\x0f\x04\0\x19\x1a\x90\x03\x04\0eup\x03\x04\x07\xfc\xc6\x80\x04\x14\f]o\x90\x03\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xafIp\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x06\xa1\xfd\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\t\x0e\x05\r\x04\n\x07\v\x06\v\x06\v\x07\x03\b\x02\0\f\x01\x17America/Argentina/Salta\0v\x0f\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x11\b\x0e\x04\r\x03\t\x06\n\x02\v\x05\n\x06\x01\x07\f\0\x1aAmerica/Argentina/San_Juan\0\x8b\x12\x04\0H\x90\x90\x03\x14\f]o\x90\x03\x04\0Xp\xa0\x03\x04\0eup\x03\x04\0\xac\xa6p\x04\x04\x07\xfbu\0\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xafIp\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\0\xda\xca\xf0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x06s\xd9p\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x14\v\x11\x07\x10\x06\r\t\x0e\x04\x02\f\b\x0e\t\x01\n\x05\0\x0f\x03\x1aAmerica/Argentina/San_Luis\0\x97\x14\x04\0?V\x10\x04\x14\0\x1c\xf2\xf0\x03\x04\0H\x90\x90\x03\x04\0yX\x10\x03\x04\0\xb4\x8fp\x04\x04\0\xc1\xbep\x04\x04\x07\xfbu\0\x04\x14\x01\x1b\x8e\xa0\x03\x14\x01\x1e#\x90\x03\x14\x0f\xaf\xaa\xf0\x03\x04\0\xc5\xb2\xf0\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xc8d\0\x03\x04\x01\x1e#\x90\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x06s\xd9p\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x14\x0f\x13\f\x12\v\x10\n\x07\x04\x03\t\r\x06\x02\x11\x01\0\b\x05\x0e\x19America/Argentina/Tucuman\0\x92\x13\x04\0\x0f\xe0\x10\x03\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\x07\xfc\xc6\x80\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xbep\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\x1e#\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x06\xab8p\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x15\v\x12\x06\x11\x05\r\b\x0e\x03\x0f\x07\x0e\b\x02\n\x04\0\x10\x01\f\t\x19America/Argentina/Ushuaia\0x\x0f\x04\0\x1b\xbd\x90\x03\x04\0eup\x03\x04\x07\xfa#\x80\x04\x14\f]o\x90\x03\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xafIp\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x06\xa1\xfd\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\t\x0e\x05\r\x04\n\x07\v\x06\v\x06\v\x07\x03\b\x02\0\f\x01\rAmerica/Aruba\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x10America/Asuncion\x01\\'\x04\0\v\xcfp\x03\x14\0\xc1\xda\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xe6\xc4\x90\x03\x14\0\xef\xff\x10\x03\x14\0\xf99\x90\x03\x14\x01\x02t\x10\x03\x04\0\xb8\x83\xf0\x04\x04\0\xc1\xbep\x04\x04\0\xc3\x0f\xf0\x04\x04\0\xc4ap\x04\x14\0\xf1P\x90\x03\x14\0\xf2\xa2\x10\x03\x14\0\xf7\xe8\x10\x03\x14\x01\x02t\x10\x03\x14\x01\r\0\x10\x03\x14\x01\x14\xe9\x10\x03\x14\x01\x1c\xd2\x10\x03\x14\x01\x1e#\x90\x03\x14\x01\x1fu\x10\x03\x14\x01 \xc6\x90\x03\x14\x01'^\x10\x03\x04\0\xc7\x04p\x04\x14\x01\x1a/\x10\x03\x04\0\xc8U\xf0\x04\x04\0\xca\xf8\xf0\x04\x04\0\xd43p\x04\x04\0\xddm\xf0\x04\x04\0\xe6\xa8p\x04\x04\0\xe9Kp\x04\x04\0\xef\xe2\xf0\x04\x04\0\xf14p\x04\x04\0\xf9\x1dp\x04\x04\x01\x14\xcc\xf0\x04\x04\x01\x1e\x07p\x04\x14\x02\xd2\x84\x10\x03\x04\x02\xd1\x16p\x04d\xff\xff\xff\xf1\x86\x8cH\xe0\x03$\0\0\0\x0e~\x9f\x91`\x03\0g%&$#\x18\x17\x16\x17\x16\x17\x1e\v\x1f\v\x1e\v\x1e\v\x1e\v\x1f\v\x1e\v\x1e\v\x1e\v\x1f\v\x1e\x0f\x1a\v\x1e\r\b\x13\x1d\f\n\x11\t\x12\x18\x14\x07\x15\b\x12\x19\x10\x19\x10\x19\x12\x1e\x01\"\x02!\x06\b\x12\b\x12\b\x15\x07\x15\x07\x15\x1c\x03 \x03 \x04\x1b\x06\x1b\x06\x1b\x06\x1c\x05\x1c\x05\x1c\x06\x1b\x06\x1b\x06\x1c\x05\x1c\x05\x1c\x05\x1c\x06\0\x10America/Atikokan\0$\x03g\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x13$\x04\"m;\xd8\x05'\0\0\0\r\xe2\xfa\xdd0\x05\x13$\0\x03\0\x02\x01\fAmerica/Atka\x01#\x17\x04\0\xef\xe2\xf0\v\x04\0\xf9\x1dp\v\x04\x01B\xf1p\v\x04\x01\x83\x8a\xf0\vt\xff\xff\xff\xf1\x86\x8cH\xe0\n\x04\0(\xc2`\n\x14\0\\W\x10\n\x14\0\x9c\xf0\x90\n\x04\x019\xb6\xf0\n\x14\0\xa6+\x10\t\x14\0\xafe\x90\t\x14\0\xc7.\xa0\t\x14\0\xcb\x15\x10\t\x14\0\xd4O\x90\t\x14\0\xe6\xc4\x90\n\x04\0\xef\xe2\xf0\n\x14\0\xef\xff\x10\n\x14\0\xef\xff\x10\t\x04\0\xf9\x1dp\n\x04\x01\v\x92p\n\x04\x01\x14\xcc\xf0\n\x04\x019\xb6\xf0\n4\0\0\0\x0ez\f\np\n\0\x8e\x04\x16\0\x10\x01\x10\0\x10\0\x06\x03\x07\x02\x10\x01\x0e\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0e\x12\x05\v\x0f\x11\x0f\x11\x0f\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\n\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\rAmerica/Bahia\0\x9e\x12\x04\0\x81$\xf0\x03\x04\0\x8a_p\x03\x04\0\x93\x99\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xc0l\xf0\x03\x04\0\xc1\xbep\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x011\xea\x10\x02\x14\x019\xd3\x10\x02\x14\x01C\r\x90\x02\x14\x01LH\x10\x02\x14\x01M\x99\x90\x02\x14\x01U\x82\x90\x02\x14\x10KX\x10\x024\0\0\0\x0e\x97=EP\x02\0'\b\x11\x05\t\x02\x0e\x01\r\x01\x0f\x03\r\x03\f\x02\x0f\0\x0f\x04\v\x04\v\x03\v\x05\n\x06\t\x05\t\x07\t\x05\v\x04\x0f\x01\x10\x05\x16America/Bahia_Banderas\0\x90\r\x04\0\xc1\xbep\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xcb\x15\x10\x06\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x06\x14\0\xd4O\x90\x05\x14\0\xf99\x90\x06\x04\x01\v\x92p\x06\x04\x01\x14\xbe\xe0\x06\x04\x01\x14\xcc\xf0\x064\0\0\0\x0e\xaa\xdb;0\x06\x007\x03\f\x01\x06\x01\x06\x01\x06\x02\x04\x02\b\0\b\x01\x06\x01\x06\x02\x04\x02\x04\x02\x04\x02\x06\x01\x06\x01\x07\n\x05\v\x05\v\x07\t\x07\t\x07\t\x07\v\x05\v\x05\v\x07\t\x07\t\x07\v\x05\v\x10America/Barbados\0>\x07\x04\0\x93\x99\xf0\x04\x04\0\xd0>\xf0\x04\x04\0\xddm\xf0\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01\x02t\x10\x03\x14\x01\v\xae\x90\x034\0\0\0\x0e\x87t\xaa\0\x03\0\t\x03\x06\0\x04\x02\x04\x02\x05\x01\rAmerica/Belem\0<\x07\x04\0\x8a_p\x03\x04\0\x93\x99\xf0\x03\x04\0\xafIp\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x01M\x99\x90\x024\0\0\0\x0e\x97=EP\x02\0\x07\x03\x06\x02\x04\x01\x05\0\x0eAmerica/Belize\0.\x05\x04\0I\xc5\xf0\x06\x04\0V\xf4\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\x10\xa7\xa1\x10\x054\0\0\0\x0e\x80\xd6\x92\x80\x05\0\x05\x02\x04\x01\x03\0\x14America/Blanc-Sablon\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x11America/Boa_Vista\0R\n\x04\0\t,p\x04\x04\0\x8a_p\x04\x04\0\x93\x99\xf0\x04\x04\0\xafIp\x04\x04\0\xc1\xbep\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01'^\x10\x03\x14\x01M\x99\x90\x03\x14\x15\xea\xfe\x10\x034\0\0\0\x0e\x97=S`\x03\0\v\x05\t\x03\x06\x02\x07\x01\b\x04\x06\0\x0eAmerica/Bogota\0 \x03\x04\x01q\x15\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x044\0\0\0\x0e\xa3w*p\x04\0\x03\x01\x02\0\rAmerica/Boise\0\xfe\x11\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x04\x01B\xf1p\x07\x04\x01^\xa0\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\x81A\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x14America/Buenos_Aires\0x\x0f\x04\0eup\x03\x14\f]o\x90\x03\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xafIp\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xbep\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\x1e#\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\b\x0e\x03\r\x02\n\x05\v\x04\v\x04\v\x05\x01\x07\f\0\t\x06\x15America/Cambridge_Bay\x01\x07\x13\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xc2\x04\xc0\x06\x14\0\xcb\x15\x10\x06\x04\0\t\x1e`\x06\x14\0\xcb\x07\0\x05\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x14\xcc\xf0\x054\0\0\0\x0e}\xd4\xd0\xb0\x06\0\x8a\x05\x12\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\t\x03\t\x03\r\x02\r\x02\r\x03\t\x03\t\x03\r\x02\r\x02\r\x02\r\x10\v\x11\n\b\x03\r\x02\r\x02\r\x03\t\x03\t\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x14America/Campo_Grande\0\xc8\x14\x04\0\x81$\xf0\x04\x04\0\x8a_p\x04\x04\0\x90\xf6\xf0\x04\x04\0\x93\x99\xf0\x04\x04\0\x9c\xd4p\x04\x04\0\xa6\x0e\xf0\x04\x04\0\xafIp\x04\x04\0\xc0l\xf0\x04\x04\0\xc1\xbep\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01'^\x10\x03\x14\x010\x98\x90\x03\x14\x011\xea\x10\x03\x14\x019\xd3\x10\x03\x14\x01C\r\x90\x03\x14\x01LH\x10\x03\x14\x01M\x99\x90\x03\x14\x01U\x82\x90\x03\x14\x01X%\x90\x034\0\0\0\x0e\x97=S`\x03\0E\t\x13\x06\n\x03\x10\x01\x0f\x01\x11\x04\x0f\x04\x0e\x03\x11\0\x11\x05\r\x05\r\x04\r\x06\f\x07\n\x06\n\b\n\x06\r\x05\x11\x01\x0e\x04\x12\x02\r\x05\x11\x03\v\x05\x0e\x04\x0e\x05\r\x05\r\x06\r\x04\x0e\x04\x0e\x05\r\x05\r\x05\r\x05\x11\x01\x0eAmerica/Cancun\0\x96\x10\x04\0n\xcc\x10\x06\x04\0\x81A\x10\x05\x04\0\xc1\xbep\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x14\0\x9c\xd4p\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4A\x80\x04\x14\0\xd4O\x90\x05\x14\0\xf99\x90\x05\x04\x01\v\x92p\x06\x14\x18\xef\xa90\x05\x04\x01\xec\xe6\xd0\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x04\x01\v\x92p\x05$\0\0\0\x0e\x8f\xfe\x9d \x05\0+\r\x0f\f\v\x03\b\x0e\x07\x05\0\b\x04\x06\x04\t\x02\t\x03\b\x03\b\x04\x06\x04\x06\x04\x06\x04\b\x03\b\x03\b\x04\x06\x04\x06\x04\b\x03\b\x03\x01\x0fAmerica/Caracas\0\"\x03f\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1e\x04\x0f\xca\x17\0\x04&\0\0\0\x0e\xc0\xcfI\x90\x04\x1e\0\x03\0\x02\x01\x11America/Catamarca\0\x84\x11\x04\0\x19\x1a\x90\x03\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\x07\xfc\xc6\x80\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x06\xa1\xfd\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\n\x10\x06\x0f\x05\v\b\f\x03\r\x07\f\b\x02\t\x04\0\x0e\x01\x0fAmerica/Cayenne\0 \x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04i\xcf\n0\x03$\0\0\0\x0e\vg\xe2\xb0\x04\0\x03\0\x02\x01\x0eAmerica/Cayman\0$\x03g\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x13$\x04\"m;\xd8\x05'\0\0\0\r\xe2\xfa\xdd0\x05\x13$\0\x03\0\x02\x01\x0fAmerica/Chicago\0\xfe\x11\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x054\0\0\0\x0ez\v\xc4 \x05\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x11America/Chihuahua\0\x8a\f\x04\0\xc1\xbep\x07\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x14\0\xd4]\xa0\x06\x14\0\xf99\x90\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xd4O\x90\x054\0\0\0\x0e\xaa\xdb- \x05\x007\t\v\x07\n\x07\x05\x03\x02\x04\x01\x04\x06\0\x06\x03\x02\x03\x02\x04\x01\x04\x01\x04\x01\x04\x02\x03\x02\x03\x02\x04\x01\x04\x01\x04\x02\x03\x02\x03\x02\x03\x02\x04\x01\x04\x01\x04\x02\x03\x02\x03\x02\x04\x01\b\x15America/Ciudad_Juarez\0\xd1\x12\x14\0\x86\xa30\x06\x04\0(\xc2`\x07\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xb8\xa0\x10\x06\x04\0\xc1\xbep\x07\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x14\0\xd4]\xa0\x06\x14\0\xf99\x90\x06\x04\x01\v\x92p\x06\x04\x010|p\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xd4O\x90\x054\0\0\0\x0e\xaa\xdb- \x05\0Z\x0f\x11\r\x10\r\v\b\x07\t\x06\t\f\x05\f\b\x07\b\x07\t\x06\t\x06\t\x06\t\x07\b\x07\b\x04\n\x02\n\x02\n\x02\n\x02\n\x02\n\x03\n\x02\n\x02\n\x02\n\x02\n\x03\n\x02\x0e\x01\0\n\x02\n\x02\n\x02\n\x03\n\x02\n\x02\n\x02\n\x02\n\x03\n\x02\n\x02\n\x02\n\x02\n\x02\n\x03\n\x02\n\x15America/Coral_Harbour\0$\x03g\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x13$\x04\"m;\xd8\x05'\0\0\0\r\xe2\xfa\xdd0\x05\x13$\0\x03\0\x02\x01\x0fAmerica/Cordoba\0\x84\x11\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xbep\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\x1e#\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\t\x10\x04\x0f\x03\v\x06\f\x02\r\x05\f\x06\x01\b\x0e\0\n\x07\x12America/Costa_Rica\0D\b\x04\0K\x17p\x06\x04\0\x81$\xf0\x06\x04\0\xd6\xd6p\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\x01\t\v\x90\x05\x14\x01^\xbd\x10\x05\x14\x14\0\x90\x10\x054\0\0\0\x0e\x8a\xaa\0\x80\x05\0\t\x03\x07\x01\x05\x01\x06\x02\x04\0\x11America/Coyhaique\x01-\x1e\x14\0x\x06\x90\x03\x14\0\x8a{\x90\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xef\xff\x10\x03\x14\0\xf99\x90\x03\x14\x01\x02t\x10\x03\x14\x01\v\xae\x90\x03\x14\x01\x14\xe9\x10\x03\x14\x01\x1e#\x90\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0\xc1\xbep\x04\x04\0\xca\xf8\xf0\x04\x04\0\xd43p\x04\x04\0\xddm\xf0\x04\x04\0\xe6\xa8p\x04\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\0\xfecp\x03\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x01\x1e\x07p\x04\x04\x010|p\x04\x04\x019\xb6\xf0\x04\x04\x01L+\xf0\x04\x04\x01g\xdbp\x04\x04\x03,\r\xf0\x04$\0\0\0\x0ey\xe6\x93\xd0\x04\0n\f\x1d\b\x0e\n\x0e\v\r\t\x0f\v\r\v\x0e\n\x0e\n\x0e\v\r\v\r\v\x0e\n\x0e\n\x0e\n\x0e\v\r\v\r\v\x12\x06\x0e\n\x0e\v\r\x07\x11\v\x0e\n\x0e\n\x0e\n\x0e\v\r\v\x10\b\x0e\b\x13\x07\x0e\v\r\v\r\v\r\v\x0e\n\x0e\n\x0e\v\r\v\x10\b\x0e\n\x11\x07\x16\x01\x1a\x02\x19\x03\x18\x03\x1c\0\x1b\0\x1b\0\x19\x04\x16\x04\x16\x04\x16\x05\x15\x04\x17\x04\x14\x0fAmerica/Creston\0Y\v\x14\0x\x06\x90\x06\x14\0\xcb\x15\x10\x06\x14)\xee#\x10\x06\x14*wZ\xf4\x06\x14@\xa2-\xe0\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0\xef\xe2\xf0\x07\x04\0\xf14p\x07\x04\x01\x14\xcc\xf0\x07\x04\x03\x8e\xd2\x8c\x07$\0\0\0\r\xd7w\xc3\xd0\x07\0\f\x05\n\x04\b\x01\b\x02\t\0\x07\x03\x06\x0eAmerica/Cuiaba\0\xc6\x14\x04\0\x81$\xf0\x04\x04\0\x8a_p\x04\x04\0\x90\xf6\xf0\x04\x04\0\x93\x99\xf0\x04\x04\0\x9c\xd4p\x04\x04\0\xa6\x0e\xf0\x04\x04\0\xafIp\x04\x04\0\xc0l\xf0\x04\x04\0\xc1\xbep\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01'^\x10\x03\x14\x010\x98\x90\x03\x14\x011\xea\x10\x03\x14\x019\xd3\x10\x03\x14\x01C\r\x90\x03\x14\x01LH\x10\x03\x14\x01M\x99\x90\x03\x14\x01U\x82\x90\x03\x14\x038\x07\x90\x034\0\0\0\x0e\x97=S`\x03\0C\t\x13\x06\n\x03\x10\x01\x0f\x01\x11\x04\x0f\x04\x0e\x03\x11\0\x11\x05\r\x05\r\x04\r\x06\f\x07\n\x06\n\b\n\x06\r\x05\x11\x01\x12\x02\r\x05\x11\x03\v\x05\x0e\x04\x0e\x05\r\x05\r\x06\r\x04\x0e\x04\x0e\x05\r\x05\r\x05\r\x05\x11\x01\x0fAmerica/Curacao\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x14America/Danmarkshavn\0V\x07\x04\0\xe6~@\x03\x04\0\xef\xf1\0\x03\x04\0\xf9+\x80\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\b\0\x82\xa0\xa0\x14\0\xef\xf1\0\x024\0\0\0\x0e\x8c\xc13p\x02\0\"\x03\x06\0\x05\x01\x05\x01\x05\x01\x05\x02\x05\x01\x05\x01\x05\x01\x05\x01\x05\x01\x05\x02\x05\x01\x05\x01\x05\x01\x05\x01\x05\x01\x04\x0eAmerica/Dawson\0\xb9\x0f\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x07\x14\f8\x85\x90\x07d\xff\xff\xff\xf1\x86\x8cH\xe0\b\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\x9a\xd0\x07\x04\x019\xb6\xf0\b$\0\0\0\x0e\x80\xa4\xa3\xb0\b\0T\x07\x0e\x06\b\x05\b\x05\t\x04\t\x05\b\x05\b\x05\b\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x01\r\0\r\0\r\x01\r\0\r\0\r\0\r\0\r\0\r\x01\r\0\r\0\r\0\r\0\f\x14America/Dawson_Creek\x006\x06\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0\xa0\xc8\xf0\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x07\x02\x05\0\x04\x01\x04\x03\x0eAmerica/Denver\0\xfe\x11\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x0fAmerica/Detroit\0\xec\x0f\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01\x83\x8a\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\\W\x10\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0e\x7f\xb4\x96\x90\x04\0\x87\x06\x0e\0\x07\x05\r\0\r\x01\f\x01\r\0\r\0\r\0\r\0\r\x01\f\x01\r\0\r\0\r\0\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\t\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\x10America/Dominica\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x10America/Edmonton\0\xe2\r\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0e}\xd4\xd0\xb0\x06\0\x89\x05\f\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x10America/Eirunepe\0X\v\x04\0\x8a_p\x05\x04\0\x93\x99\xf0\x05\x04\0\xa6\x0e\xf0\x05\x04\0\xafIp\x05\x04\n\x1e\x85p\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\x01'^\x10\x04\x14\x01M\x99\x90\x04\x14\n\xb4\xec\x90\x04\x04\x1a\xf9\x9f\x10\x044\0\0\0\x0e\x97=ap\x04\0\v\x05\n\x03\x06\x01\x07\0\b\x02\t\x04\x13America/El_Salvador\0(\x04\x04\0\xc1\xbep\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\x01\x1e#\x90\x054\0\0\0\x0e\x9a\x0e\x94\0\x05\0\x05\x01\x03\0\x02\0\x10America/Ensenada\x01\x04\x12\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xb8\xa0\x10\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8d\x07\x11\0\x10\x01\x10\0\x10\0\b\x06\t\x05\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\r\x03\x0e\x02\x0e\x02\f\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x13America/Fort_Nelson\0\xbb\x0e\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\xa6+\x10\x07\x04\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\\\x05\r\0\f\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\n\x02\n\x03\t\x03\t\x03\n\x02\n\x02\n\x03\t\x03\t\x03\n\x02\n\x02\n\x02\n\x03\t\x03\t\x03\n\x02\n\x02\n\x03\t\x03\t\x03\b\x04\x06\x04\x06\x04\b\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x12America/Fort_Wayne\0\x82\b\x04\0\xef\xe2\xf0\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14B\xa7\x94\x90\x044\0\0\0\x0ez\v\xb6\x10\x04\0G\x03\x07\0\x06\x01\x05\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x11America/Fortaleza\0v\x0f\x04\0\x12f\xf0\x03\x04\0\x8a_p\x03\x04\0\x93\x99\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xc1\xbep\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x01LH\x10\x02\x14\x01M\x99\x90\x02\x14\x01U\x82\x90\x02\x14\x01\xd6\xb5\x90\x02\x14\x12!\xff\x90\x024\0\0\0\x0e\x97=EP\x02\0\x11\x07\x0e\x05\b\x02\n\x01\t\x01\v\x03\r\x06\b\0\f\x04\x11America/Glace_Bay\0\xe2\r\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x019\xb6\xf0\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xe6\xc4\x90\x03\x14\0\xef\xff\x10\x034\0\0\0\x0e}\xd4\xa6\x80\x03\0\x89\x05\f\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0fAmerica/Godthab\0\xe9\x11\x04\0\xe6~@\x03\x04\0\xef\xf1\0\x03\x04\0\xf9+\x80\x03\x04\x01\x14\xdb\0\x03\x04\x01\x1e\x15\x80\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\0\xc1\xcc\x80\x02\x14\0\xc1\xcc\x80\x01\x04\0\xc1\xcc\x80\x02\x14\0\xcb\x07\0\x02\x14\0\xcb\x07\0\x01\x14\0\xef\xf1\0\x02\x14\0\xf9+\x80\x02\x04\x01\x14\xdb\0\x02\x04\x01\x1e\x15\x80\x02\x14\x01\xe9\x1c\x80\x014\0\0\0\x0e\x8c\xc13p\x02\0x\x05\x10\0\v\x01\v\x01\v\x01\v\x02\v\x01\v\x01\v\x01\v\x01\v\x01\v\x02\v\x01\v\x01\v\x01\v\x01\v\x01\f\x03\t\x03\t\x03\t\x04\x06\x04\x06\x04\t\x03\t\x03\t\x04\x06\x04\x06\x04\x06\x04\t\x03\t\x03\t\x04\x06\x04\x06\x04\t\x03\t\x03\t\x03\t\x04\x06\x04\x06\x04\t\x03\t\x03\t\x04\x06\x04\b\x0f\r\n\r\n\r\n\x0e\x07\x0e\x07\x0e\n\r\n\r\n\x0e\x07\x0e\x07\x0e\x07\x0e\n\r\n\r\n\x0e\x07\x0e\x11America/Goose_Bay\x01\x04\x12\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xbe\xe0\x04\x04\x01\x14\xcc\xf0\x04\x04\x019\xb6\xf0\x04\x04\x019\xd2\xd4\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xcb# \x03\x14\0\xd43\xac\x03\x14\0\xd4O\x90\x03\x14\0\xd4O\x90\x02\x14\0\xe6\xc4\x90\x03\x14\0\xef\xff\x10\x034\0\0\0\x0ez\v\xa8\0\x03\0\x8d\x07\x11\0\x10\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\f\x02\x0e\x03\v\x04\n\x04\r\x02\r\x02\r\x04\n\x04\n\x04\r\x02\r\x02\r\x02\r\x04\n\x04\n\x04\r\x02\r\x02\r\x04\n\x04\n\x04\t\x05\b\x05\b\x05\t\x05\b\x06\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\x12America/Grand_Turk\0\xdb\x0f\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x04\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x04\x14\x05\xa8\xe0\x80\x044\0\0\0\x0e\x8a\xfd\x1d\x10\x04\0v\x05\x0e\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\n\x02\n\x03\t\x03\t\x03\n\x02\n\x02\n\x03\t\x03\t\x03\n\x02\n\x02\n\x02\n\x03\t\x03\t\x03\n\x02\n\x02\n\x03\t\x03\t\x03\b\x04\x06\x04\x06\x04\b\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\r\x04\x06\x04\x06\x04\b\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\b\x04\x06\x04\x06\x04\x06\x04\x06\x04\b\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\b\x04\x06\x04\x0fAmerica/Grenada\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x12America/Guadeloupe\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x11America/Guatemala\0J\t\x04\0w\xeap\x06\x04\0\xa3k\xf0\x06\x04\0\xca\xf8\xf0\x06\x04\0\xddm\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\x0e\x1b\n\x90\x05\x14\x11^\xe1\x90\x05\x14\x1b\x8b\xf5\x90\x054\0\0\0\x0e\x80\xc9c\x80\x05\0\t\x04\b\0\x06\x01\x05\x03\x07\x02\x11America/Guayaquil\0 \x03\x04\0Z\xe9p\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x044\0\0\0\x0e\xa4\x8a\xb3\xf0\x04\0\x03\x01\x02\0\x0eAmerica/Guyana\0 \x03\x04\x1fV;\x04\x04d\xff\xff\xff\xf1\x86\x8cH\xe0\x03$\0\0\0\x0e\x83\xf2\xbc\xdc\x03\0\x03\x01\x02\0\x0fAmerica/Halifax\0\xe6\r\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x019\xb6\xf0\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xe6\xc4\x90\x03\x14\0\xef\xff\x10\x034\0\0\0\x0ez\v\xa8\0\x03\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0eAmerica/Havana\x01r%\x04\0\xca\xf8\xf0\x05\x04\0\xd43p\x05\x04\0\xd5\x84\xf0\x05\x04\0\xd6\xd6p\x05\x04\0\xef\xe2\xf0\x05\x04\0\xef\xf1\0\x05\x04\0\xf9\x1dp\x05\x04\0\xf9+\x80\x05\x04\x01\x02W\xf0\x05\x04\x01\v\x92p\x05\x04\x01\v\xa0\x80\x05\x04\x01\x14\xcc\xf0\x05\x04\x01\x14\xdb\0\x05\x04\x01\x1e\x15\x80\x05\x04\x01'P\0\x05\x04\x010\x8a\x80\x05\x04\x019\xc5\0\x05\x04\x04\xdd\xd9\x80\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6\x1d\0\x04\x14\0\xafW\x80\x04\x14\0\xb8\x92\0\x04\x14\0\xcb\x07\0\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4A\x80\x04\x14\0\xd4O\x90\x04\x14\0\xdd|\0\x04\x14\0\xe6\xb6\x80\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xf1\0\x04\x14\0\xef\xff\x10\x04\x14\0\xf99\x90\x04\x14\x01\t\v\x90\x04\x14\x01\n]\x10\x04\x14\x01\v\xae\x90\x04\x14\x01\x14\xe9\x10\x044\0\0\0\x0ez\v\x99\xf0\x04\0\x89\x12$\x04\x1e\x06\x1e\x01\"\x02!\x03 \x04\x1e\x06\x1c\x06\x1f\0\x19\v\x17\v#\0#\0#\0#\x01\"\x01\x17\v\x17\v\x19\t\x19\t\x1c\b\x1c\x07\x1b\x07\x1b\x07\x1b\x07\x1b\x07\x1d\x05\x1d\x07\x1a\f\x16\r\x16\f\x16\f\x18\n\x18\n\x16\x11\x14\x0f\x15\x0e\x14\x0f\x15\x0f\x15\x10\x15\r\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x12America/Hermosillo\0*\x04\x04\x01\v\x92p\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xd4O\x90\x064\0\0\0\x0e\xaa\xdb;0\x06\0\x07\x01\x03\0\x02\0\x02\0\x1cAmerica/Indiana/Indianapolis\0\x82\b\x04\0\xef\xe2\xf0\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14B\xa7\x94\x90\x044\0\0\0\x0ez\v\xb6\x10\x04\0G\x03\x07\0\x06\x01\x05\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x14America/Indiana/Knox\0\xf4\x14\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x05\x14\x1b%\x12\x80\x05\x04\x01\v\x92p\x054\0\0\0\x0ez\v\xc4 \x05\0q\b\x13\0\x10\x01\x10\0\x10\0\t\x07\n\x06\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x12\x11\x04\f\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\x17America/Indiana/Marengo\0\xb0\x0e\x14\0\\W\x10\x05\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01B\xf1p\x05\x04\x01\x83\x99\0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\x9c\xe2\x80\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xef\xff\x10\x04\x149>\xf0\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0Q\x07\r\x01\v\x02\v\x01\v\x01\0\x06\b\x05\f\x03\n\x04\t\x04\t\x04\n\x04\t\x04\t\x04\t\x04\t\x04\t\x04\n\x04\t\x04\t\x04\t\x04\t\x04\n\x04\t\x04\t\x04\t\x04\t\x04\t\x04\n\x04\t\x04\t\x04\t\x04\t\x04\n\x04\t\x04\t\x04\t\x04\t\x04\t\x04\n\x04\t\x04\x1aAmerica/Indiana/Petersburg\0\xcc\x12\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\x14\xdb\0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6\x1d\0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x05\x14\0\xafe\x90\x04\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x05\x145u\xe3\x80\x05\x04\0\xf9\x1dp\x05\x04\x019\xb6\xf0\x054\0\0\0\x0ez\v\xc4 \x05\0U\x05\x11\0\r\x01\r\0\r\0\x06\x04\x07\x03\r\x01\f\x0f\x0e\x02\n\x10\b\x10\t\x10\v\x10\t\x10\t\x10\t\x10\t\x10\t\x10\v\x10\t\x10\t\x10\t\x10\t\x10\v\x10\t\x10\t\x10\t\x10\t\x10\t\x10\v\x10\t\x10\t\x10\t\x10\t\x10\v\x10\t\x10\t\x10\t\x10\t\x10\t\x10\v\x10\t\x10\x19America/Indiana/Tell_City\0\x82\b\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x06\x14B\xa7\x94\x90\x05\x04\0\xef\xe2\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x044\0\0\0\x0ez\v\xb6\x10\x04\0G\x06\x07\x05\x04\x02\x01\x03\0\x03\0\x03\x01\x03\0\x03\0\x03\0\x03\0\x03\0\x03\x01\x03\0\x03\0\x03\0\x03\0\x03\x01\x03\0\x03\0\x03\0\x03\0\x03\0\x03\x01\x03\0\x03\0\x03\0\x03\0\x03\x01\x03\0\x03\0\x03\0\x03\0\x03\0\x03\x01\x03\0\x03\x15America/Indiana/Vevay\0\x92\n\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xef\xff\x10\x04\x14>\xde\x96\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0K\x04\t\0\x07\x01\x07\0\b\x02\x06\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x19America/Indiana/Vincennes\0\x8e\n\x14\0\xafe\x90\x05\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x05\x14B\xa7\x94\x90\x05\x04\0\xef\xe2\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6\x1d\0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x044\0\0\0\x0ez\v\xb6\x10\x04\0G\x05\t\x04\x03\x01\0\x02\x06\x02\x07\x02\b\x02\x07\x02\x07\x02\x07\x02\x07\x02\x07\x02\b\x02\x07\x02\x07\x02\x07\x02\x07\x02\b\x02\x07\x02\x07\x02\x07\x02\x07\x02\x07\x02\b\x02\x07\x02\x07\x02\x07\x02\x07\x02\b\x02\x07\x02\x07\x02\x07\x02\x07\x02\x07\x02\b\x02\x07\x02\x17America/Indiana/Winamac\0\x88\t\x04\x01\x14\xdb\0\x06\x14B\xa7\x94\x90\x05\x04\0\xef\xe2\xf0\x05\x04\x019\xa8\xe0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x044\0\0\0\x0ez\v\xb6\x10\x04\0G\x05\b\x02\x01\0\x07\x03\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x14America/Indianapolis\0\x82\b\x04\0\xef\xe2\xf0\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14B\xa7\x94\x90\x044\0\0\0\x0ez\v\xb6\x10\x04\0G\x03\x07\0\x06\x01\x05\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x0eAmerica/Inuvik\x01\0\x12\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x07\x14\0\xe6\xc4\x90\x06\x04\0\xef\xd4\xe0\x07\x04\0\xef\xe2\xf0\x07\x14\0\xef\xff\x10\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x14\0\xef\xff\x10\x064\0\0\0\x0e}\xd4\xde\xc0\x07\0\x89\x02\x11\0\v\0\v\0\v\0\v\x01\x07\x01\v\0\x10\t\x10\n\x10\n\x10\f\b\f\x10\n\x10\n\x10\n\x06\r\x06\x0e\x05\x0e\x05\x0e\x06\r\x06\r\x06\x0e\x05\x0e\x05\x0e\x06\r\x06\r\x06\r\x06\x0e\x05\x0e\x05\x0e\x06\r\x06\r\x06\x0e\x05\x0e\x05\x0e\x04\x0f\x03\x0f\x03\x0f\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x04\x0f\x03\x0f\x0fAmerica/Iqaluit\0\xf4\x10\x14\0\xcb# \x05\x04\x01\x14\xcc\xf0\x06\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x07\0\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0e}\xd4\xb4\x90\x04\0\x89\x07\x0f\x02\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\f\x04\f\x05\v\x05\v\x05\f\x04\f\x04\f\x05\v\x05\v\x05\f\x04\f\x04\f\x04\f\x01\0\x05\n\x05\f\x04\f\x04\f\x05\v\x05\v\x05\t\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\x0fAmerica/Jamaica\0V\t\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01B\xf1p\x05\x04\x01\x83\x8a\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\x9c\xf0\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0e\x81\0\xd0\x90\x04\0\x15\x04\b\x03\x05\x02\x07\x01\x06\x01\x07\0\x07\0\x07\0\x07\0\x07\x01\x06\x01\rAmerica/Jujuy\0|\x10\x04\0eup\x03\x14\x019\xe1 \x03\x14\f]o\x90\x03\x04\0\xb8\x83\xf0\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xb0`\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\v\xae\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x11\t\x0f\x05\x0e\x04\v\x03\x01\x03\n\x07\f\x06\x02\b\r\0\x0eAmerica/Juneau\x01/\x19\x14\0\xa6+\x10\b\x14\0\xafe\x90\b\x14\0\xc7.\xa0\b\x14\0\xcb\x15\x10\b\x14\0\xd4O\x90\b\x14\0\xef\xff\x10\b\x04\0(\xde\x80\t\x04\0\xef\xe2\xf0\t\x04\0\xf9\x1dp\t\x04\x01\v\x92p\t\x04\x01\x14\xcc\xf0\t\x04\x019\xb6\xf0\t\x14\0\xef\xff\x10\b\x04\0\xef\xe2\xf0\b\x04\0\xef\xf1\0\b\x04\0\xf9\x1dp\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xf1\0\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8e\x12\x18\r\x17\x0f\x17\r\x17\r\x13\x11\x14\x10\x17\x0f\x15\x0f\x17\r\x17\r\x05\x0e\x16\r\x17\x0f\x15\b\x06\x02\x07\x05\x07\x05\x07\x04\t\x04\n\x03\n\x03\n\x04\t\x04\t\x04\n\x03\n\x03\n\x04\t\x04\t\x04\t\x04\n\x03\n\x03\n\x04\t\x04\t\x04\n\x03\n\x03\n\x01\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\0\v\x01\v\0\v\x1bAmerica/Kentucky/Louisville\0\xfe\x11\x14\0\\W\x10\x05\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01B\xf1p\x05\x04\x01\x83\x99\0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\x9c\xe2\x80\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\b\x10\x01\x0f\x02\x0f\x01\x0f\x01\0\x07\t\x06\x0f\x02\x0e\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x02\x0e\x02\x0f\x01\x0f\x01\x0f\x01\r\x03\r\x04\f\x04\f\x04\r\x03\r\x03\r\x04\f\x04\f\x04\r\x03\r\x03\r\x03\r\x04\f\x04\f\x04\r\x03\r\x03\r\x04\f\x04\f\x04\v\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\x1bAmerica/Kentucky/Monticello\x01\x1c\x16\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x07\0\x04\x14\0\xcb\x15\x10\x05\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x05\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x054\0\0\0\x0ez\v\xc4 \x05\0\x8d\x06\x15\0\x11\x01\x11\0\x11\0\x07\x05\b\x04\x11\x01\x10\x01\x11\0\x11\0\x11\0\x11\0\x11\x01\x10\x01\x11\0\x11\0\x11\0\x0e\x02\x0e\x03\f\x03\f\x03\x0e\x02\x0e\x02\x0e\x03\f\x03\f\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x03\f\x13\v\x13\x0f\x12\x0f\x12\x0f\x13\r\x13\r\x13\n\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\x0fAmerica/Knox_IN\0\xf4\x14\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x05\x14\x1b%\x12\x80\x05\x04\x01\v\x92p\x054\0\0\0\x0ez\v\xc4 \x05\0q\b\x13\0\x10\x01\x10\0\x10\0\t\x07\n\x06\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x12\x11\x04\f\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\x12America/Kralendijk\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x0eAmerica/La_Paz\0-\x04\x17N\x97{\x80\x03 $g\xff\xff\xff\xf1\x86\x8cH\xe0\x04 $\x04\0\xd0>\xf0\x04'\0\0\0\r\xe2\xfa\xd2\x84\x04 $\0\x04\x01\x03\0\x02\fAmerica/Lima\x008\x06\x04\0v\x98\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\x01j\x9a\x90\x04\x14\x05.S\x10\x04\x14\x07\x0f\x86\x90\x044\0\0\0\x0e\x97\x8c{p\x04\0\t\x01\x05\0\x02\0\x03\0\x04\0\x13America/Los_Angeles\0\xfe\x11\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x12America/Louisville\0\xfe\x11\x14\0\\W\x10\x05\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01B\xf1p\x05\x04\x01\x83\x99\0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\x9c\xe2\x80\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\b\x10\x01\x0f\x02\x0f\x01\x0f\x01\0\x07\t\x06\x0f\x02\x0e\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x02\x0e\x02\x0f\x01\x0f\x01\x0f\x01\r\x03\r\x04\f\x04\f\x04\r\x03\r\x03\r\x04\f\x04\f\x04\r\x03\r\x03\r\x03\r\x04\f\x04\f\x04\r\x03\r\x03\r\x04\f\x04\f\x04\v\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\n\x05\n\x05\n\x05\n\x05\v\x05\n\x05\x15America/Lower_Princes\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x0eAmerica/Maceio\0~\x10\x04\0\x12f\xf0\x03\x04\0\x8a_p\x03\x04\0\x93\x99\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xc1\xbep\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x01LH\x10\x02\x14\x01M\x99\x90\x02\x14\x01U\x82\x90\x02\x14\x01\xd6\xb5\x90\x02\x14\x06\xd9y\x10\x02\x14\n\xab\xb2\x10\x024\0\0\0\x0e\x97=EP\x02\0\x13\x07\x0f\x05\b\x02\n\x01\t\x01\v\x03\x0e\x03\r\x06\b\0\f\x04\x0fAmerica/Managua\0n\x0e\x14\x01\x15\x050\x05\x14\x01]k\x90\x05\x04\0\x82vp\x06\x04\0\xca\xea\xe0\x06\x04\0\xe6\xa8p\x06\x04\x01_\xba0\x06\x04\x07\x86\x11p\x06\x14\x07\xad\xba\x90\x05\x14\x0f\x8e\xd1\x90\x05\x04\x03`\xc9\xf0\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x04\0\x82\x92\x90\x05\x04\x15\xad?\xd0\x05$\0\0\0\x0e\x7f\xb7+\x80\x05\0\x0f\n\r\t\x07\x02\x01\x02\f\x05\v\x06\b\x04\0\x03\x0eAmerica/Manaus\0J\t\x04\0\x8a_p\x04\x04\0\x93\x99\xf0\x04\x04\0\xa6\x0e\xf0\x04\x04\0\xafIp\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01'^\x10\x03\x14\x01M\x99\x90\x03\x14\n\xb4\xec\x90\x034\0\0\0\x0e\x97=S`\x03\0\t\x04\b\x03\x05\x01\x06\0\x07\x02\x0fAmerica/Marigot\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x12America/Martinique\0 \x03\x04\0\xe6\xa8p\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x034\0\0\0\x0e\x8c\xc1%`\x03\0\x03\x01\x02\0\x11America/Matamoros\0\xb4\r\x04\0\xc1\xbep\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xb8\xa0\x10\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xf99\x90\x05\x14\r\xfc\xb8\x10\x054\0\0\0\x0e\x9b\xc9\xa8 \x05\0[\x04\f\x02\v\x01\t\x01\t\x01\t\x02\b\x02\n\0\n\x01\t\x01\t\x02\b\x02\b\x02\b\x02\t\x01\t\x01\x07\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x10America/Mazatlan\0r\b\x04\0\xc1\xbep\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xf99\x90\x064\0\0\0\x0e\xaa\xdb;0\x06\x007\x03\x07\x01\x05\x01\x05\x01\x05\x02\x04\x02\x06\0\x06\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x0fAmerica/Mendoza\0\x90\x13\x04\0eup\x03\x04\0\xb4\x8fp\x04\x04\0\xb5\xe0\xf0\x04\x04\x07\xf0\xe9\0\x04\x14\x01(\xbd\xa0\x03\x14\x01,\xa4\x10\x03\x14\f]o\x90\x03\x04\0\xb8\x83\xf0\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xa6+\x10\x03\x04\0\xb8u\xe0\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x06 \xca\xf0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\r\x12\t\x11\b\x0e\x07\x04\x01\x05\x02\x0f\v\x06\f\x03\n\x10\0\x11America/Menominee\0\xfe\x12\x04\0\xef\xe2\xf0\x06\x04\0\xef\xf1\0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x054\0\0\0\x0e\x7f\xb4\x96\x90\x05\0\x87\b\x11\x01\t\x07\n\x06\x10\x02\x0f\x02\x10\0\x10\0\x10\0\x10\0\x10\x02\x0f\x02\x10\0\x10\0\x10\0\x0e\x03\x0e\x04\r\x04\r\x04\x0e\x03\x0e\x03\x0e\x04\r\x04\r\x04\x0e\x03\x0e\x03\x0e\x03\x0e\x04\r\x04\r\x04\x0e\x03\x0e\x03\x0e\x04\r\x04\r\x04\f\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\x0eAmerica/Merida\0\x80\n\x04\0\xc1\xbep\x06\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xf99\x90\x05\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x14\x19B\x9b\x90\x05\x04\x01\x99\xf4p\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x05$\0\0\0\x0e\x8f\xfe\x9d \x05\x009\b\t\x07\x06\x04\x02\x04\x02\x04\x02\x05\x01\x05\x03\0\x03\x04\x02\x04\x02\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x12America/Metlakatla\0\xc6\x12\x14\0@\xa7\x90\b\x04\0e\x83\x80\t\x14\0\xa6+\x10\b\x14\0\xafe\x90\b\x04\x019\xb6\xf0\t\x14\0\xafe\x90\b\x04<3\xad\x10\t\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0O\f\x11\x07\x10\b\x10\x07\x10\x07\r\v\x0e\n\x10\b\x0f\b\x10\x07\x10\x07\x10\x07\x10\x07\x10\b\x0f\b\x06\x03\x04\x02\x04\x02\t\x01\0\x04\x02\x04\x03\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x03\x04\x02\x04\x02\x04\x02\x04\x02\x04\x03\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x03\x04\x02\x04\x13America/Mexico_City\0r\b\x04\0\xc1\xbep\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xf99\x90\x054\0\0\0\x0e\xaa\xdb- \x05\x007\x03\x07\x01\x05\x01\x05\x01\x05\x02\x04\x02\x06\0\x06\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x10America/Miquelon\0\xb3\n\x14\0\xa6+\x10\x02\x14\0\xafe\x90\x02\x14\0\xcb\x15\x10\x02\x14\0\xd4O\x90\x02\x14\r\x07\x81\x10\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x04\x01\v\x92p\x03\x04\x01\x14\xcc\xf0\x03\x04\x019\xb6\xf0\x03$\0\0\0\x0e\x8c\xe2\x1a\xe0\x03\0l\x05\t\x04\x06\x03\x07\x02\x07\x02\x07\x03\x06\x03\x06\x03\x07\x02\x07\x02\x07\x03\x06\x03\x06\x03\x06\x03\x07\x02\x07\x02\x07\x03\x06\x03\x06\x03\x07\x02\x07\x02\x07\x01\b\0\b\0\b\x01\b\0\b\0\b\0\b\0\b\0\b\x01\b\0\b\0\b\0\b\0\b\x01\b\0\b\0\b\0\b\0\b\0\b\x01\b\0\b\0\b\0\b\0\b\x01\b\0\b\0\b\0\b\0\b\0\b\x01\b\0\b\x0fAmerica/Moncton\0\xf6\x10\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x019\xb6\xf0\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xaf\x81t\x03\x14\0\xcb\x15\x10\x03\x14\0\xd43\xac\x03\x14\0\xd4O\x90\x03\x14\0\xe6\xc4\x90\x03\x14\0\xef\xff\x10\x03\x14\x02\xcf\xe1\x10\x034\0\0\0\x0ez\v\xa8\0\x03\0\x8b\x05\x0f\0\r\x01\r\0\x0e\0\r\0\r\x01\f\x01\r\0\r\0\r\0\r\0\r\x01\f\x01\r\0\r\0\r\0\v\x02\v\x03\t\x03\t\x03\v\x02\v\x02\n\x03\t\x03\t\x03\v\x02\v\x02\v\x02\v\x03\t\x03\t\x03\v\x02\v\x02\v\x03\t\x03\t\x03\b\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x11America/Monterrey\0z\t\x04\0\xc1\xbep\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xf99\x90\x05\x14\r\xfc\xb8\x10\x054\0\0\0\x0e\x9b\xc9\xa8 \x05\x009\x03\b\x02\x07\x01\x05\x01\x05\x01\x05\x02\x04\x02\x06\0\x06\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x12America/Montevideo\0\xfb\x1f\x16\0I\xbe\xe8\x02\x1e\x04\0A\xdc\xf0\x03\x04\0d#\xf0\x03\x04\0eup\x03\x04\0n\xaf\xf0\x03\x04\0w\xeap\x03\x04\0\x81$\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xca\xf8\xf0\x03\x04\0\xd43p\x03\x04\0\xe6\xc4\x90\x03\x04\0\xf99\x90\x03\x04\x01\xa8t\xf0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\0I\xe2\x10\x02\x14\0\x93\xaf\b\x02\x14\x01\x02t\x10\x02\x14\x01\v\xae\x90\x02\x14\x01\x14\xe9\x10\x02\x14\x010\x98\x90\x02\x14\x019\xd3\x10\x02\x14\x01g\xf7\x90\x02\x14\x01zl\x90\x02\x14\x03>\x9f\x10\x02\x16\x02\xcf\xe1\x10\x01\x1e\x14\x03\x7f8\x90\x02\x14\x0e\x91\xb1\x90\x02\x14\x15\xbc\xd9\x90\x024\0\0\0\x0ez\n,P\x02\x004\x0f\x1e\x01\x1b\x04\x1a\0\f\x11\x06\x19\x03\x17\x05\x18\x03\x10\x0e\x1c\x02\x18\x04\x16\x07\x16\t\x16\b\x15\t\x1d\r\x12\n\x13\v\x14\n\x14\n\x14\v\x13\v\x13\v\x14\n\x14\n\x14\n\x10America/Montreal\0\xe6\r\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x12America/Montserrat\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x0eAmerica/Nassau\0\xe6\r\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x10America/New_York\0\xfe\x11\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01B\xf1p\x05\x04\x01\x83\x8a\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\\W\x10\x04\x14\0\x9c\xf0\x90\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x0fAmerica/Nipigon\0\xe6\r\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\fAmerica/Nome\x01#\x17\x04\0\xef\xe2\xf0\v\x04\0\xf9\x1dp\v\x04\x01B\xf1p\v\x04\x01\x83\x8a\xf0\vt\xff\xff\xff\xf1\x86\x8cH\xe0\n\x04\0(\xb4P\t\x14\0\\W\x10\n\x14\0\x9c\xf0\x90\n\x04\x019\xb6\xf0\t\x14\0\xa6+\x10\b\x14\0\xafe\x90\b\x14\0\xc7.\xa0\b\x14\0\xcb\x15\x10\b\x14\0\xd4O\x90\b\x14\0\xe6\xc4\x90\n\x04\0\xef\xe2\xf0\t\x14\0\xef\xff\x10\n\x14\0\xef\xff\x10\b\x04\0\xf9\x1dp\t\x04\x01\v\x92p\t\x04\x01\x14\xcc\xf0\t\x04\x019\xb6\xf0\t4\0\0\0\x0ez\f\np\n\0\x8e\x04\x16\0\x10\x01\x10\0\x10\0\x06\x03\x07\x02\x10\x01\x0e\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0e\x12\x05\v\x0f\x11\x0f\x11\x0f\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\n\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\x0fAmerica/Noronha\0v\x0f\x04\0\t,p\x02\x04\0\x8a_p\x02\x04\0\x93\x99\xf0\x02\x04\0\x9c\xd4p\x02\x04\0\xa6\x0e\xf0\x02\x04\0\xafIp\x02\x04\0\xc1\xbep\x02t\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x14\x01'^\x10\x01\x14\x01LH\x10\x01\x14\x01M\x99\x90\x01\x14\x01U\x82\x90\x01\x14\x01\xdf\xf0\x10\x01\x14\x12!\xff\x90\x014\0\0\0\x0e\x97=7@\x01\0\x11\x07\x0e\x05\b\x02\n\x01\t\x01\v\x03\r\x06\b\0\f\x04\x1bAmerica/North_Dakota/Beulah\x01\x16\x15\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6\x1d\0\x05\x14\0\xa6+\x10\x06\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x06\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x06\x04\x019\xb6\xf0\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x07\x14\0\x12\x01\x12\0\x12\0\b\x06\t\x05\x12\x01\x11\x01\x12\0\x12\0\x12\0\x12\0\x12\x01\x11\x01\x12\0\x12\0\x12\0\x10\x02\x10\x03\x0f\x03\x0f\x03\x10\x02\x10\x02\x10\x03\x0f\x03\x0f\x03\x10\x02\x10\x02\x10\x02\x10\x03\x0f\x03\x0f\x03\x10\x02\x10\x02\x10\x03\x0f\x03\x0f\x03\r\x04\v\x04\v\x04\r\x13\n\x13\f\x13\f\x13\f\x13\f\x13\x0e\x13\f\x13\f\x13\f\x13\f\x13\x0e\x13\f\x13\f\x13\f\x13\f\x13\f\x13\x0e\x13\f\x13\f\x13\f\x13\f\x13\x0e\x13\f\x13\f\x13\f\x13\f\x13\f\x13\x0e\x13\f\x13\x1bAmerica/North_Dakota/Center\x01\x1c\x16\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x06\x14\0\xcb\x15\x10\x05\x14\0\xd4A\x80\x05\x14\0\xd4O\x90\x06\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x06\x15\0\x11\x01\x11\0\x11\0\x07\x05\b\x04\x11\x01\x10\x01\x11\0\x11\0\x11\0\x11\0\x11\x01\x10\x01\x11\0\x11\0\x11\0\x0e\x02\x0e\x03\v\x03\v\x03\x0e\x02\x0e\x12\r\x13\f\x13\f\x13\x0f\x12\x0f\x12\x0f\x12\x0f\x13\f\x13\f\x13\x0f\x12\x0f\x12\x0f\x13\f\x13\f\x13\n\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\t\x14\t\x14\t\x14\t\x14\n\x14\t\x14\x1eAmerica/North_Dakota/New_Salem\x01\x16\x15\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x06\x14\0\xcb\x15\x10\x05\x14\0\xd4A\x80\x05\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x06\x14\0\x10\x01\x10\0\x10\0\x07\x05\b\x04\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\v\x03\v\x03\x0e\x02\x0e\x02\x0e\x03\v\x03\v\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x03\v\x03\v\x03\x0e\x02\x0e\x11\r\x12\f\x12\f\x12\n\x13\t\x13\t\x13\n\x13\t\x13\t\x13\t\x13\t\x13\t\x13\n\x13\t\x13\t\x13\t\x13\t\x13\n\x13\t\x13\t\x13\t\x13\t\x13\t\x13\n\x13\t\x13\t\x13\t\x13\t\x13\n\x13\t\x13\t\x13\t\x13\t\x13\t\x13\n\x13\t\x13\fAmerica/Nuuk\0\xe9\x11\x04\0\xe6~@\x03\x04\0\xef\xf1\0\x03\x04\0\xf9+\x80\x03\x04\x01\x14\xdb\0\x03\x04\x01\x1e\x15\x80\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\0\xc1\xcc\x80\x02\x14\0\xc1\xcc\x80\x01\x04\0\xc1\xcc\x80\x02\x14\0\xcb\x07\0\x02\x14\0\xcb\x07\0\x01\x14\0\xef\xf1\0\x02\x14\0\xf9+\x80\x02\x04\x01\x14\xdb\0\x02\x04\x01\x1e\x15\x80\x02\x14\x01\xe9\x1c\x80\x014\0\0\0\x0e\x8c\xc13p\x02\0x\x05\x10\0\v\x01\v\x01\v\x01\v\x02\v\x01\v\x01\v\x01\v\x01\v\x01\v\x02\v\x01\v\x01\v\x01\v\x01\v\x01\f\x03\t\x03\t\x03\t\x04\x06\x04\x06\x04\t\x03\t\x03\t\x04\x06\x04\x06\x04\x06\x04\t\x03\t\x03\t\x04\x06\x04\x06\x04\t\x03\t\x03\t\x03\t\x04\x06\x04\x06\x04\t\x03\t\x03\t\x04\x06\x04\b\x0f\r\n\r\n\r\n\x0e\x07\x0e\x07\x0e\n\r\n\r\n\x0e\x07\x0e\x07\x0e\x07\x0e\n\r\n\r\n\x0e\x07\x0e\x0fAmerica/Ojinaga\0\xdc\x14\x14\0\xa6+\x10\x06\x14\0\xa6+\x10\x05\x14\0\xafW\x80\x05\x14\0\xafe\x90\x06\x14\0\xafe\x90\x05\x14\0\xb8\xa0\x10\x06\x04\0\xc1\xbep\x07\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x14\0\xd4]\xa0\x06\x14\0\xf99\x90\x06\x04\x01\v\x92p\x06\x04\x010|p\x06\x04\x019\xb6\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xd4O\x90\x054\0\0\0\x0e\xaa\xdb- \x05\0Y\x11\x13\x0e\x12\x0e\f\t\b\n\x07\n\r\x06\r\t\b\t\b\n\x07\n\x07\n\x07\n\b\t\b\t\x05\v\0\v\0\v\0\v\0\v\0\v\x03\v\0\v\0\v\0\v\0\v\x03\v\0\x0f\x02\x10\x01\x10\x01\x10\x01\x10\x04\x10\x01\x10\x01\x10\x01\x10\x01\x10\x04\x10\x01\x10\x01\x10\x01\x10\x01\x10\x01\x10\x04\x10\x01\x10\x0eAmerica/Panama\0$\x03g\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x13$\x04\"m;\xd8\x05'\0\0\0\r\xe2\xfa\xdd0\x05\x13$\0\x03\0\x02\x01\x13America/Pangnirtung\0\xf4\x10\x14\0\xcb# \x05\x04\x01\x14\xcc\xf0\x06\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x07\0\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0e}\xd4\xb4\x90\x04\0\x89\x07\x0f\x02\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\f\x04\f\x05\v\x05\v\x05\f\x04\f\x04\f\x05\v\x05\v\x05\f\x04\f\x04\f\x04\f\x01\0\x05\n\x05\f\x04\f\x04\f\x05\v\x05\v\x05\t\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\b\x06\b\x06\b\x06\b\x06\t\x06\b\x06\x12America/Paramaribo\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\x03$\0\0\0\x0e\x951\xe8\xd8\x03\0\x02\0\x01\x0fAmerica/Phoenix\0Y\v\x14\0x\x06\x90\x06\x14\0\xcb\x15\x10\x06\x14)\xee#\x10\x06\x14*wZ\xf4\x06\x14@\xa2-\xe0\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0\xef\xe2\xf0\x07\x04\0\xf14p\x07\x04\x01\x14\xcc\xf0\x07\x04\x03\x8e\xd2\x8c\x07$\0\0\0\r\xd7w\xc3\xd0\x07\0\f\x05\n\x04\b\x01\b\x02\t\0\x07\x03\x06\x16America/Port-au-Prince\0\xd0\x12\x04\0\xe6\xa8p\x05\x04\0\xef\xe2\xf0\x05\x04\x01\v\xa0\x80\x05\x04\x01\x14\xcc\xf0\x05\x04\x01\x14\xdb\0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x07\0\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4A\x80\x04\x14\0\xd4]\xa0\x04\x14\0\xef\xff\x10\x04\x14\x02\x8fG\x90\x04\x14\n\x18&0\x04\x14\r\xfc\x9b\xf0\x044\0\0\0\x0e\x92\x8e\xfd\xf0\x04\0Y\x06\x11\0\r\x01\r\x01\r\x01\r\x01\f\x04\t\x04\t\x04\v\x02\v\x02\v\x04\t\x04\t\x04\v\x02\v\x02\x10\x03\n\x03\x0f\x05\x07\x05\x07\x05\x07\x05\x0e\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x15America/Port_of_Spain\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x12America/Porto_Acre\0J\t\x04\0\x8a_p\x05\x04\0\x93\x99\xf0\x05\x04\0\xafIp\x05\x04\n\x1e\x85p\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\x01'^\x10\x04\x14\x01M\x99\x90\x04\x04&T\x9a\x90\x044\0\0\0\x0e\x97=ap\x04\0\t\x04\b\x02\x05\x01\x06\0\x07\x03\x13America/Porto_Velho\0<\x07\x04\0\x8a_p\x04\x04\0\x93\x99\xf0\x04\x04\0\xafIp\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01'^\x10\x03\x14\x01M\x99\x90\x034\0\0\0\x0e\x97=S`\x03\0\x07\x03\x06\x02\x04\x01\x05\0\x13America/Puerto_Rico\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x14America/Punta_Arenas\0\xff\x19\x14\0x\x06\x90\x03\x14\0\x8a{\x90\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xef\xff\x10\x03\x14\0\xf99\x90\x03\x14\x01\x02t\x10\x03\x14\x01\v\xae\x90\x03\x14\x01\x14\xe9\x10\x03\x14\x01\x1e#\x90\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0\x93\x99\xf0\x03\x04\0\xc1\xbep\x04\x04\0\xca\xf8\xf0\x04\x04\0\xd43p\x04\x04\0\xddm\xf0\x04\x04\0\xe6\xa8p\x04\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\x14\xcc\xf0\x04\x04\x010|p\x04\x04\x019\xb6\xf0\x04\x04\x01L+\xf0\x04\x04\x03,\r\xf0\x04$\0\0\0\x0ey\xe6\x93\xd0\x04\0^\n\x18\x06\r\b\r\t\f\x07\x0e\t\f\t\r\b\r\b\r\t\f\t\f\t\r\b\r\b\r\b\r\t\f\t\f\t\x11\x04\r\b\r\t\f\x05\x10\t\r\b\r\b\r\b\r\t\f\t\x0f\x06\r\x06\x12\x05\r\t\f\t\f\t\f\t\r\b\r\b\r\t\f\t\x0f\x06\r\b\x10\x05\x13\x01\x16\x02\x15\x03\x14\x03\x17\0\v\x13America/Rainy_River\0\xec\x0e\x04\0\xef\xf1\0\x06\x04\0\xf9+\x80\x06\x04\x01\v\xa0\x80\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x07\0\x05\x14\0\xd4A\x80\x05\x14\0\xe6\xb6\x80\x05\x14\0\xef\xf1\0\x054\0\0\0\x0ez\v\xc4 \x05\0\x8d\x06\r\0\f\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x04\t\x04\t\x03\b\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x14America/Rankin_Inlet\0\xe8\x0e\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x05\x04\x01\x14\xcc\xf0\x054\0\0\0\x0e}\xd4\xc2\xa0\x05\0\x89\x05\r\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\f\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0eAmerica/Recife\0v\x0f\x04\0\t,p\x03\x04\0\x8a_p\x03\x04\0\x93\x99\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xc1\xbep\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x01LH\x10\x02\x14\x01M\x99\x90\x02\x14\x01U\x82\x90\x02\x14\x01\xdf\xf0\x10\x02\x14\x12!\xff\x90\x024\0\0\0\x0e\x97=EP\x02\0\x11\x07\x0e\x05\b\x02\n\x01\t\x01\v\x03\r\x06\b\0\f\x04\x0eAmerica/Regina\0\xb9\x14\x14\0\x9e^0\x06\x14\0\xef\xff\x10\x06\x14\0\xf99\x90\x06\x14\x01\x02t\x10\x06\x14\x01\x14\xe9\x10\x06\x14\x01\x1e#\x90\x06\x14\x02\xf4\xcb\x10\x06\x14\x04\xb8\xfd\x90\x06\x14\x06\x9a\xe7\xe0\x06\x14\x15\xaaHp\x06\x14\x17\xbb\x1ct\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0=#\x90\x07\x04\0\xc1\xbep\x07\x04\0\xca\xf8\xf0\x07\x04\0\xe6\xa8p\x07\x04\0\xef\xe2\xf0\x07\x04\0\xef\xff\x10\x06\x04\x01\x02W\xf0\x07$\0\0\0\x0e\0qJ<\x07\x006\v\x13\n\x12\t\x0e\x04\x0e\x04\x0e\x05\r\x05\x0e\x07\x10\x01\x0f\x02\x10\x02\x10\x01\x10\0\b\f\x03\x10\x03\x0e\x04\x0e\x04\x0e\x05\r\x05\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x05\x0e\x04\x0e\x06\x10\x11\x10America/Resolute\0\xe8\x0e\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x05\x04\x01\x14\xcc\xf0\x054\0\0\0\x0e}\xd4\xc2\xa0\x05\0\x89\x05\r\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\f\b\x03\t\x02\t\x02\t\x03\b\x03\b\f\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x12America/Rio_Branco\0J\t\x04\0\x8a_p\x05\x04\0\x93\x99\xf0\x05\x04\0\xafIp\x05\x04\n\x1e\x85p\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\x01'^\x10\x04\x14\x01M\x99\x90\x04\x04&T\x9a\x90\x044\0\0\0\x0e\x97=ap\x04\0\t\x04\b\x02\x05\x01\x06\0\x07\x03\x0fAmerica/Rosario\0\x84\x11\x04\0eup\x03\x14\f]o\x90\x03\x04\0\xafIp\x04\x04\0{\xde\xf0\x03\x04\0\x81$\xf0\x03\x04\0\xaf;`\x03\x04\0\xb8\x83\xf0\x03\x04\0\xc1\xbep\x03\x04\0\xc8d\0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01\x1e#\x90\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x010\xa6\xa0\x02\x14\x0e\xb7\xdf\0\x02\x14\x1bpF\x10\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0\x13\t\x10\x04\x0f\x03\v\x06\f\x02\r\x05\f\x06\x01\b\x0e\0\n\x07\x14America/Santa_Isabel\x01\x04\x12\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xb8\xa0\x10\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8d\x07\x11\0\x10\x01\x10\0\x10\0\b\x06\t\x05\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\r\x03\x0e\x02\x0e\x02\f\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x10America/Santarem\0C\b\x04\0\x8a_p\x04\x04\0\x93\x99\xf0\x04\x04\0\xafIp\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01'^\x10\x03\x14\x01M\x99\x90\x03\x04&T\x9a\x90\x034\0\0\0\x0e\x97=S`\x03\0\b\x03\x07\x02\x04\x01\x05\0\x06\x10America/Santiago\x01J\x1e\x14\0x\x06\x90\x03\x14\0\x8a{\x90\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xc1\xda\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xef\xff\x10\x03\x14\0\xf99\x90\x03\x14\x01\x02t\x10\x03\x14\x01\v\xae\x90\x03\x14\x01\x14\xe9\x10\x03\x14\x01\x1e#\x90\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0\xc1\xbep\x04\x04\0\xca\xf8\xf0\x04\x04\0\xd43p\x04\x04\0\xddm\xf0\x04\x04\0\xe6\xa8p\x04\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x01\x1e\x07p\x04\x04\x010|p\x04\x04\x019\xb6\xf0\x04\x04\x01L+\xf0\x04\x04\x01g\xdbp\x04\x04\x03,\r\xf0\x04$\0\0\0\x0ey\xe6\x93\xd0\x04\0\x8b\r\x1d\t\x0f\v\x0f\f\x0e\n\x10\f\x0e\f\x0f\v\x0f\v\x0f\f\x0e\f\x0e\f\x0f\v\x0f\v\x0f\v\x0f\f\x0e\f\x0e\f\x13\x07\x0f\v\x0f\f\x0e\b\x12\f\x0f\v\x0f\v\x0f\v\x0f\f\x0e\f\x11\t\x0f\t\x14\b\x0f\f\x0e\f\x0e\f\x0e\f\x0f\v\x0f\v\x0f\f\x0e\f\x11\t\x0f\v\x12\b\x16\x01\x1a\x02\x19\x03\x18\x03\x1c\0\x1b\0\x1b\0\x19\x05\x16\x05\x16\x05\x16\x06\x15\x05\x17\x05\x16\x05\x16\x05\x16\x05\x16\x05\x17\x04\x17\x05\x16\x05\x16\x05\x16\x05\x16\x05\x17\x04\x17\x05\x16\x05\x16\x05\x16\x05\x15America/Santo_Domingo\0j\r\x16\x01DX\b\x04\x1e\x16\x01q+\b\x04\x1e\x16\x01s\xce\b\x04\x1e\x16\x01vq\b\x04\x1ed\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x04\0.$\x80\x04\x04\0l\x13\xf8\x05\x04\0n\xb6\xf8\x05\x04\0p\bx\x05\x04\0r\xabx\x05\x040\xeb&\x90\x05\x04\x01o\xd9\x88\x04$\0\0\0\x0ey\xb72\xe8\x05\0\r\x04\f\0\t\x03\x06\x02\x07\x01\b\v\n\x05\x11America/Sao_Paulo\0\xc8\x14\x04\0\x81$\xf0\x03\x04\0\x8a_p\x03\x04\0\x90\xf6\xf0\x03\x04\0\x93\x99\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xc0l\xf0\x03\x04\0\xc1\xbep\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x011\xea\x10\x02\x14\x019\xd3\x10\x02\x14\x01C\r\x90\x02\x14\x01LH\x10\x02\x14\x01M\x99\x90\x02\x14\x01U\x82\x90\x02\x14\x01X%\x90\x024\0\0\0\x0e\x97=EP\x02\0E\t\x13\x06\n\x03\x10\x01\x0f\x01\x11\x04\x0f\x04\x0e\x03\x11\0\x11\x05\r\x05\r\x04\r\x06\f\x07\n\x06\n\b\n\x06\r\x05\x11\x01\x0e\x04\x12\x02\r\x05\x11\x03\v\x05\x0e\x04\x0e\x05\r\x05\r\x06\r\x04\x0e\x04\x0e\x05\r\x05\r\x05\r\x05\x11\x01\x14America/Scoresbysund\0\xea\x12\x04\0\xe6\xb6\x80\x02\x04\x01\x14\xdb\0\x02\x04\x01\x1e\x15\x80\x02t\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x14\0\xc1\xcc\x80\x01\x14\0\xcb\x07\0\x01\x18\0\xc1\xcc\x80\x18\0\xcb\x07\0\x18\0\xef\xf1\0\x18\0\xf9+\x80\x04\0\xef\xe2\xf0\x01\x04\0\xef\xf1\0\x01\x04\0\xf9+\x80\x01\x04\x01\x14\xdb\0\x01\x04\x01\x1e\x15\x80\x01\x18\0\xef\xd4\xe0\x18\0\xef\xf1\x004\0\0\0\x0e\x8c\xc1%`\x01\0y\x03\x11\0\x0f\n\b\v\b\v\b\f\b\v\b\v\b\v\b\v\b\v\b\f\b\v\b\v\b\v\b\v\b\v\t\r\x07\r\x07\r\x07\x0e\x06\x0e\x06\x0e\x07\r\x07\r\x07\x0e\x06\x0e\x06\x0e\x06\x0e\x07\r\x07\r\x07\x0e\x06\x0e\x06\x0e\x07\r\x07\r\x07\r\x07\x0e\x06\x0e\x06\x0e\x07\r\x07\r\x07\x0e\x06\x0e\x06\x0e\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x10America/Shiprock\0\xfe\x11\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\rAmerica/Sitka\x01\x1d\x16\x14\0\xa6+\x10\b\x14\0\xafe\x90\b\x14\0\xc7.\xa0\b\x14\0\xcb\x15\x10\b\x14\0\xd4O\x90\b\x14\0\xef\xff\x10\b\x04\0(\xde\x80\t\x04\0\xef\xe2\xf0\t\x04\0\xf9\x1dp\t\x04\x01\v\x92p\t\x04\x01\x14\xcc\xf0\t\x04\x019\xb6\xf0\t\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8e\x10\x15\f\x14\r\x14\f\x14\f\x11\x0f\x12\x0e\x14\r\x13\r\x14\f\x14\f\x14\f\x14\f\x14\r\x13\b\x06\x02\x07\x05\x07\x05\x07\x04\t\x04\n\x03\n\x03\n\x04\t\x04\t\x04\n\x03\n\x03\n\x04\t\x04\t\x04\t\x04\n\x03\n\x03\n\x04\t\x04\t\x04\n\x03\n\x03\n\x01\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\x01\v\0\v\0\v\0\v\0\v\0\v\x01\v\0\v\x15America/St_Barthelemy\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x10America/St_Johns\x01\x16\x12\x06\0\xef\xe2\xf0\x03\x1e\x06\0\xf9\x1dp\x03\x1e\x06\x01\v\x92p\x03\x1e\x06\x01\x14\xbe\xe0\x03\x1e\x06\x01\x14\xcc\xf0\x03\x1e\x06\x019\xb6\xf0\x03\x1e\x06\x019\xd2\xd4\x03\x1ev\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x16\0\xa6+\x10\x02\x1e\x16\0\xafe\x90\x02\x1e\x16\0\xcb\x15\x10\x02\x1e\x16\0\xcb# \x02\x1e\x16\0\xd43\xac\x02\x1e\x16\0\xd4O\x90\x02\x1e\x16\0\xd4O\x90\x01\x1e\x16\0\xe6\xc4\x90\x02\x1e\x16\0\xef\xff\x10\x02\x1e6\0\0\0\x0ez\v\xa0\xf8\x02\x1e\0\x8d\x07\x11\0\x10\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\f\x02\x0e\x03\v\x04\n\x04\r\x02\r\x02\r\x04\n\x04\n\x04\r\x02\r\x02\r\x02\r\x04\n\x04\n\x04\r\x02\r\x02\r\x04\n\x04\n\x04\t\x05\b\x05\b\x05\t\x05\b\x06\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\x10America/St_Kitts\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x10America/St_Lucia\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x11America/St_Thomas\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x12America/St_Vincent\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x15America/Swift_Current\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\x06$\0\0\0\x0e}\xd4\xd0\xb0\x06\0\x02\0\x01\x13America/Tegucigalpa\x006\x06\x04\0y;\xf0\x06\x04\0\xc1\xbep\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\x01\x1e#\x90\x05\x14!!\x0f\x90\x054\0\0\0\x0e\x9a\x0e\x94\0\x05\0\x07\x02\x05\x01\x03\x01\x04\0\rAmerica/Thule\0\xb6\f\x04\0\xef\xe2\xf0\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x019\xb6\xf0\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xef\xff\x10\x03\x14\0\xf99\x90\x034\0\0\0\x0e\xa1i2\0\x03\0c\x04\v\0\t\0\n\x02\x07\x02\x07\x02\b\x01\b\x01\b\x01\b\x02\x07\x02\x07\x02\b\x01\b\x01\b\x02\x07\x02\x07\x02\x06\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x05\x03\x13America/Thunder_Bay\0\xe6\r\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0fAmerica/Tijuana\x01\x04\x12\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xb8\xa0\x10\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8d\x07\x11\0\x10\x01\x10\0\x10\0\b\x06\t\x05\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\r\x03\x0e\x02\x0e\x02\f\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x0fAmerica/Toronto\0\xe6\r\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0fAmerica/Tortola\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x11America/Vancouver\0\xd2\x0e\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x07\x04\x019\xb6\xf0\x074\0\0\0\x0ez\v\xe0@\x07\0s\x05\r\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\f\x0eAmerica/Virgin\0.\x05\x14\x06-\xc1\xb0\x03\x14Q\x0f\x9d\x07\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0<\xf9`\x04$\0\0\0\r\xf4ZL\xd9\x04\0\x05\x02\x04\x01\0\x03\x12America/Whitehorse\0\xb2\x0e\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x07\x04\x019\x9a\xd0\x074\0\0\0\x0e\x8c\xdd)@\x07\0S\x05\r\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\f\x10America/Winnipeg\0\xec\x0e\x04\0\xef\xf1\0\x06\x04\0\xf9+\x80\x06\x04\x01\v\xa0\x80\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x07\0\x05\x14\0\xd4A\x80\x05\x14\0\xe6\xb6\x80\x05\x14\0\xef\xf1\0\x054\0\0\0\x0ez\v\xc4 \x05\0\x8d\x06\r\0\f\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x04\t\x04\t\x03\b\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x0fAmerica/Yakutat\x01\v\x13\x04\0(\xd0p\t\x04\0\xef\xe2\xf0\t\x04\0\xf9\x1dp\t\x04\x01\v\x92p\t\x04\x01\x14\xcc\xf0\t\x04\x019\xb6\xf0\t\x04\x01B\xf1p\t\x04\x01\x83\x8a\xf0\tt\xff\xff\xff\xf1\x86\x8cH\xe0\b\x14\0\\W\x10\b\x14\0\x9c\xf0\x90\b\x14\0\xa6+\x10\b\x14\0\xafe\x90\b\x14\0\xc7.\xa0\b\x14\0\xcb\x15\x10\b\x14\0\xd4O\x90\b\x14\0\xe6\xc4\x90\b\x14\0\xef\xff\x10\b4\0\0\0\x0ez\v\xeeP\b\0\x8e\b\x12\x01\x11\x02\x11\x01\x11\x01\t\x07\n\x06\x11\x02\x10\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x10\x02\0\r\x01\x11\x01\x11\x01\x0f\x03\x0f\x04\x0e\x04\x0e\x04\x0f\x03\x0f\x03\x0f\x04\x0e\x04\x0e\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x04\x0e\x04\x0e\x04\x0f\x03\x0f\x03\x0f\x04\x0e\x04\x0e\x04\f\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\x13America/Yellowknife\0\xe2\r\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0e}\xd4\xd0\xb0\x06\0\x89\x05\f\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x10Antarctica/Casey\0v\x0f\f\0\x9a1p\b\f\0\xb5\xc4\xd0\b\f\0\xcd\x7f\xd0\b\f\0\xd0L\xc4\b\f\0\xd4\t@\b\f\0\xd4\x17\x14\b\f\x02\x99\xd3\x90\bl\xff\xff\xff\xf1\x86\x8cH\xe0\v\f\x01\t'\xb0\v\f\x01\v\xca\xec\v\f\x01\x14\xdb<\v\f\x01\x15\x050\v\f\x03\x19\xd10\v\f\b\xc6m\xf0\v,\0\0\0\x0e\xc4M\xbd@\v\0\x11\x07\x0e\x01\f\0\r\x06\v\x04\b\x02\n\x05\t\x05\t\x03\x10Antarctica/Davis\0.\x05l\xff\xff\xff\xf1\x86\x8cH\xe0\x05\f\0\x9aM\x90\x07\f\x03\x11\xaf\xf0\x05\f\0\xbd\xe6\x10\x07,\0\0\0\x0e\xc4M\xcbP\x05\0\x05\0\x04\x03\x02\x01\x19Antarctica/DumontDUrville\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\t0 \f\x1c7J\x88\n/\0\0\0\r\xd0*\x11(\t0 \0\x03\0\x02\x01\x14Antarctica/Macquarie\x01\x1a\x16\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x02f\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x010\x8a\x80\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\vl\xff\xff\xff\xf1\x86\x8cH\xe0\n\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xe6\xb6\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n\f\x02\xcf\xd3\0\n,\0\0\0\x0ey\xcaI\xa0\n\0\x8b\t\x15\x06\r\x06\n\b\v\x07\v\x07\v\x07\f\x07\v\x07\v\x07\v\x07\v\x07\v\x07\x0f\x04\x0e\x04\v\x07\v\x07\v\x06\x0e\x05\x0e\x05\r\x05\r\x05\x0f\x02\x10\x02\x10\x02\x10\x02\x10\x02\x11\x02\x10\x02\x10\x02\x10\x02\x10\0\x13\x03\x10\x02\x10\x02\x10\x02\x10\x02\x11\x01\x10\x03\x11\x01\x11\x01\x14\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x12\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11Antarctica/Mawson\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x05,\0\0\0\x0e\xc4M\xd9`\x05\0\x02\0\x01\x12Antarctica/McMurdo\0\xef\x10\f\0\x93\xa8\0\f\f\0\xa6\x1d\0\f\f\0\xafW\x80\f\f\0\xd4A\x80\f\f\0\xdd|\0\f\f\0\xf9+\x80\f\f\x01\x02f\0\f|\xff\xff\xff\xf1\x86\x8cH\xe0\r\x1c\0\xe6\xb6\x80\r\x1c\0\xef\xf1\0\r\x1c\x01\x02f\0\r\x1c\x01\v\xa0\x80\r\x1c\x01\x1e\x15\x80\r\x1c\x019\xc5\0\r\x1c\x01B\xff\x80\r<\0\0\0\x0e\x82\x8c\xb5\0\r\0\x84\x07\x0f\0\x0e\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\f\x03\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\n\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x06\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x11Antarctica/Palmer\0\xef\x1a\x14\0x\x06\x90\x03\x14\0\x8a{\x90\x03\x04\0\x93\x99\xf0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x04\0\xc1\xbep\x04\x04\0\xca\xf8\xf0\x04\x04\0\xddm\xf0\x04\x04\0\xe6\xa8p\x04\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\x14\xcc\xf0\x04\x04\x010|p\x04\x04\x019\xb6\xf0\x04\x04\x01L+\xf0\x04\x04\x03,\r\xf0\x04\x14\0\xd5\xa1\x10\x03\x14\0\xef\xff\x10\x03\x14\0\xf99\x90\x03\x14\x01\x02t\x10\x03\x14\x01\x14\xe9\x10\x03\x14\x01\x1e#\x90\x03\x04\x0f\fM\x10\x04\x04\0\x81$\xf0\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x024\0\0\0\x0e\x81\x17\x01\xd0\x02\0H\x18\x19\x17\x16\x10\x06\x14\x06\x15\x05\x15\x05\x15\t\x11\x06\x14\x06\x15\x05\x12\b\x15\x06\x14\x06\x14\x06\x14\x06\x15\x05\x15\x07\x13\x06\x13\n\x12\x06\x15\x05\x15\x05\x15\x05\x15\x06\x14\x06\x14\x06\x15\x05\x15\x07\x13\x06\x14\b\x12\v\x01\x0e\x03\r\x04\f\x04\x0f\0\x02\x12Antarctica/Rothera\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\x03$\0\0\0\x0e\x86u\xe4 \x03\0\x02\0\x01\x15Antarctica/South_Pole\0\xef\x10\f\0\x93\xa8\0\f\f\0\xa6\x1d\0\f\f\0\xafW\x80\f\f\0\xd4A\x80\f\f\0\xdd|\0\f\f\0\xf9+\x80\f\f\x01\x02f\0\f|\xff\xff\xff\xf1\x86\x8cH\xe0\r\x1c\0\xe6\xb6\x80\r\x1c\0\xef\xf1\0\r\x1c\x01\x02f\0\r\x1c\x01\v\xa0\x80\r\x1c\x01\x1e\x15\x80\r\x1c\x019\xc5\0\r\x1c\x01B\xff\x80\r<\0\0\0\x0e\x82\x8c\xb5\0\r\0\x84\x07\x0f\0\x0e\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\f\x03\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\n\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x06\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x10Antarctica/Syowa\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x03,\0\0\0\x0eN\x8e\xed\xd4\x03\0\x02\0\x01\x10Antarctica/Troll\0y\x07\x1c\x008\xbe\x90\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80(\0\0\0\x0e\xbb\x80\xfe \0H\x03\x06\0\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x11Antarctica/Vostok\0%\x04h\xff\xff\xff\xf1\x86\x8cH\xe0\f6\xc9\xc00\x05\f\x01hK\xf0\x07(\0\0\0\x0e\xa6\xc0\xf00\0\x04\0\x03\x02\x01\x13Arctic/Longyearbyen\0\xc6\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xfb0\x02\0y\x05\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\tAsia/Aden\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x03,\0\0\0\x0eN\x8e\xed\xd4\x03\0\x02\0\x01\vAsia/Almaty\0\xb0\x13\f\0\x93\xa8\0\x06\f\0\xef\xff\x10\x05\f$\\\xd3`\x05\x1c\0\xef\xf1\0\x06\f\0\xef\xf1\0\x06\f\0\xf0\r \x06\f\0\xf14p\x06\f\0\xf9+\x80\x06\f\x01\x14\xdb\0\x06\f\x01\x1e\x15\x80\x06|\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x1c\0\\:\xf0\x07\x1c\0\xc1\xcc\x80\x07\x1c\0\xcb\x07\0\x07\x1c\0\xef\xf1\0\x07\x1c\0\xef\xff\x10\x07\x1c\0\xf1P\x90\x07\x1c\0\xf9+\x80\x07<\0\0\0\x0e\x8e\x9b4\xc0\x07\x003\n\x12\x06\x0f\x06\x0f\x06\x10\x05\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x07\x03\x01\0\v\x04\x0e\x04\x0e\x04\x0e\x04\x11\b\r\b\r\b\r\t\f\t\f\t\r\b\r\b\r\t\x02\nAsia/Amman\x01j,\f\0p\x0f\x80\x02\f\0\x9a1p\x02\f\0\xc7\x04p\x02\f\0\xc9\xa7p\x02\f\0\xd43p\x02\f\0\xd4A\x80\x02\f\0\xd6\xd6p\x02\f\0\xddm\xf0\x02\f\0\xdd|\0\x02\f\0\xe6\xa8p\x02\f\0\xef\xe2\xf0\x02\f\0\xef\xf1\0\x02\f\0\xf14p\x02\f\0\xf1B\x80\x02\f\0\xf2\x85\xf0\x02\f\0\xf9\x1dp\x02\f\x01\v\xa0\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\f\x03>\x82\xf0\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\x81A\x10\x03\x1c\0\x9c\xe2\x80\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xdd|\0\x03\x1c\0\xee\x9f\x80\x03\x1c\0\xee\xad\x90\x03\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf3\xf3\x90\x03\x1c\0\xf7\xda\0\x03\x1c\0\xff\xd1\x10\x03\x1c\x01\x02f\0\x03\x1c\x01\x02t\x10\x03\x1c\x01\v\xa0\x80\x03\x1c\x01\v\xae\x90\x03\x1c\x01\x16:\x90\x03\x1c\x01\x17\x8c\x10\x03\x1c\x01\x18\xdd\x90\x03\f\x01B\xff\x80\x03\x1c\x01y\r\0\x03\x1c\f;(\x90\x03<\0\0\0\x0e\x7f\xe61\0\x03\0W\x14+\x01&\x03&\x03'\x0e\x1b\x03%\x03*\f\x1e\n\x1d\n\x1d\x0f'\x02$\x04 \x06\"\t\x1d\n\x1d\x07$\x05#\b!\b!\b)\0\x1f\r\x1a\r\x1c\v\x1c\x11\x18\x10\x19\v\x1c\x11\x18\x11\x18\x12\x17\x12\x17\x12\x18\x11\x18\x13\x15\x12\x17\x12\x18\x11\x18\x11\x18\x11\x18\x11\x18\x12\x17\x12\x16(\vAsia/Anadyr\0\xd4\x17\f\x01\x1e#\x90\v\x1c\0\xcb\x07\0\f\x1c\0\\:\xf0\r\x1c\0\xc1\xcc\x80\r\x1c\0\xcb\x07\0\r\f\0\x93\xa8\0\f\f\0\xc1\xcc\x80\f\f\0\xef\xff\x10\v\x1c\0\xef\xf1\0\f\f\0\xef\xf1\0\f\x1c\0\xef\xf1\0\r\f\0\xf0\r \f\f\0\xf14p\f\f\0\xf1B\x80\f\f\0\xf9+\x80\f\f\x01\x14\xdb\0\f\f\x01\x1e\x15\x80\f\x1c\0\xef\xff\x10\r\x1c\0\xf1P\x90\r\x1c\0\xf9+\x80\r\f\0\xf14p\r|\xff\xff\xff\xf1\x86\x8cH\xe0\x0e<\0\0\0\x0e\x8e\x9a\xd2P\x0e\0?\x15\x16\x14\x11\r\x11\f\x12\v\n\t\n\t\n\t\n\t\n\t\n\x0e\b\x07\x05\x02\t\n\t\n\t\n\t\x13\x0f\x04\x0f\x04\x0f\x04\x10\x03\x10\x03\x10\x04\x0f\x04\x0f\x04\x10\x03\x10\x03\x10\x03\x10\x04\x0f\x04\x0f\x01\0\x06\nAsia/Aqtau\0\xc6\x17\x1c\0\xc1\xcc\x80\x05\x1c\0\xcb\x07\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf9+\x80\x05\f\0\xef\xf1\0\x04\x1c\0\\:\xf0\x06\f\0\x93\xa8\0\x05\f\0\xef\xff\x10\x04\f\x01\x14\xdb\0\x04\f\x01\x1e\x15\x80\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf1B\x80\x05\f\0\xf9+\x80\x05\f\x01\x1e\x15\x80\x05\x1c\0\xef\xe2\xf0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06l\xff\xff\xff\xf1\x86\x8cH\xe0\x06,\0\0\0\x0e\x8f\x8c\x85P\x06\x001\x15\x16\x11\x0e\x13\r\x14\f\x12\v\x12\v\x12\v\x12\v\x12\v\x12\x0f\n\x07\x06\x05\v\x12\v\x12\x04\x02\x04\x03\b\x01\b\x01\b\x01\t\0\t\0\t\x01\b\x01\b\x01\x10\vAsia/Aqtobe\0\xb5\x14\x1c\0\\:\xf0\x06\x1c\0\xc1\xcc\x80\x06\x1c\0\xcb\x07\0\x06\f\0\x93\xa8\0\x05\f\0\xef\xff\x10\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf1B\x80\x05\f\0\xf9+\x80\x05\f\x01\x14\xdb\0\x05\f\x01\x1e\x15\x80\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06\x1c\0\xf9+\x80\x06\f\0\xf14p\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\x002\r\x13\x12\x0e\t\x0f\b\x10\x07\x0e\x06\x0e\x06\x0e\x06\x0e\x06\x0e\x06\x0e\n\x05\x04\x03\0\x06\x0e\x06\x0e\x06\x0e\x06\x11\v\x02\v\x02\v\x02\f\x01\f\x01\f\x02\v\x02\v\x02\f\rAsia/Ashgabat\0k\f\f\0\x93\xa8\0\x05\f\0\xef\xff\x10\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf9+\x80\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\0\x18\x07\v\x05\t\x05\t\x05\n\x04\b\x03\b\x03\b\x03\b\x03\b\x03\b\x06\x02\x01\0\x0eAsia/Ashkhabad\0k\f\f\0\x93\xa8\0\x05\f\0\xef\xff\x10\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf9+\x80\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\0\x18\x07\v\x05\t\x05\t\x05\n\x04\b\x03\b\x03\b\x03\b\x03\b\x03\b\x06\x02\x01\0\vAsia/Atyrau\0\xcc\x18\x1c\0\xc1\xcc\x80\x05\x1c\0\xcb\x07\0\x05\x1c\0\\:\xf0\x06\x1c\0\xcb\x07\0\x06\f\0\x93\xa8\0\x05\f\0\xef\xff\x10\x04\f\x01\x14\xdb\0\x04\f\x01\x1e\x15\x80\x04\f\x01\x1e#\x90\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf1B\x80\x05\f\0\xf9+\x80\x05\f\x01\x14\xdb\0\x05\f\x01\x1e\x15\x80\x05\x1c\0\xef\xe2\xf0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06\x1c\0\xf9+\x80\x06l\xff\xff\xff\xf1\x86\x8cH\xe0\x06,\0\0\0\x0e\x8f\x8c\x85P\x06\x001\x16\x17\x11\r\x13\f\x14\v\x12\n\x12\n\x12\n\x12\n\x12\n\x12\x0e\t\x05\x04\x02\n\x12\n\x12\n\x12\n\x15\x0f\x03\x0f\x03\x0f\x01\b\0\x07\0\x07\x01\x06\x01\x06\x01\x10\fAsia/Baghdad\0\x9a\x0f\f\0\xc9\xa7p\x03\f\0\xee\xad\x90\x03\f\0\xef\xf1\0\x03\f\0\xf14p\x03\f\0\xf1B\x80\x03\f\0\xf2\x85\xf0\x03\f\0\xf9+\x80\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xee\xad\x90\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1B\x80\x04\x1c\0\xf1P\x90\x04\x1c\0\xf1^\xa0\x04<\0\0\0\x0e\x90\xa4\x1fp\x04\x005\x07\x0e\0\b\x05\f\x03\n\x01\t\x02\t\x02\t\x02\t\x02\t\x06\r\x04\v\x04\t\x04\t\x04\t\x04\v\x04\t\x04\t\x04\t\x04\v\x04\t\x04\t\x04\t\x04\v\x04\t\x04\t\x04\t\x04\fAsia/Bahrain\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x03,\0\0\0\x0e}\xfeI\xe0\x03\0\x02\0\x01\tAsia/Baku\0\xb2\x11\f\0\xef\xff\x10\x03\x1c\0\xef\xf1\0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\0\xf9+\x80\x04\f\x01\x14\xdb\0\x04\f\x01\x1e\x15\x80\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xc1\xcc\x80\x05\x1c\0\xca\xf8\xf0\x05\x1c\0\xcb\x07\0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05\x1c\x06\x98\xed\xa0\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0A\b\x10\x04\r\x04\r\x04\x0e\x03\f\x02\f\x02\f\x02\f\x02\f\x02\f\x05\x01\0\x01\x02\x0f\x06\n\x06\v\x06\v\x07\t\x07\t\x07\v\x06\v\x06\v\x07\t\x07\t\x07\t\x07\v\x06\v\x06\v\x07\t\x07\t\x07\v\x06\v\x06\v\x06\fAsia/Bangkok\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\x06*\x04\fK\xb3\xe2\0\x07/\0\0\0\r\xd0*<\xe4\x06*\x04\0\x03\0\x02\x01\fAsia/Barnaul\0\xd7\x17\f\0\x9d\x1a\xc0\x06\x1c\0R\xe4P\x07\x1c\0\xc1\xcc\x80\x07\f\0\xc1\xcc\x80\x07\x1c\0\xcb\x07\0\x07\x1c\0\xf9+\x80\x07\f\0\x93\xa8\0\x07\f\0\xef\xff\x10\x06\f\x01\x14\xdb\0\x06\f\x01\x1e\x15\x80\x06\f\x06\xbd\xadp\x06\x1c\0\xef\xf1\0\x07\f\0\xef\xf1\0\x07\f\0\xf0\r \x07\f\0\xf14p\x07\f\0\xf9+\x80\x07\f\x02\xaa\xf7\x10\x07|\xff\xff\xff\xf1\x86\x8cH\xe0\b\x1c\0\\:\xf0\b\x1c\0\xef\xf1\0\b\x1c\0\xef\xff\x10\b\x1c\0\xf1P\x90\b<\0\0\0\x0e\x8e\x9b&\xb0\b\0B\x11\x16\x0e\x14\x0e\x14\x0e\x15\r\x13\f\x13\f\x13\f\x13\f\x13\f\x13\x0f\v\x07\x06\x12\f\x13\f\x13\f\x13\x01\0\x05\b\x04\b\x04\b\x04\t\x02\t\x02\t\x04\b\x04\b\x04\t\x02\t\x02\t\x02\t\x04\b\x04\b\x04\t\x03\n\x10\fAsia/Beijing\0B\x07\f\0\xafIp\b\f\0\xc1\xbep\b\f\0\xca\xf8\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xe9\x10\t\x1c\x01\x1e#\x90\t<\0\0\0\x0e\x98.\t@\t\0\r\x03\x06\0\x04\x02\x05\x01\x05\x02\x04\x02\x04\x02\vAsia/Beirut\x01\x1a\x18\f\0\x85\x19p\x02\f\0\xb4\x8fp\x02\f\0\xc9\xa7p\x02\f\0\xcd\x9b\xf0\x02\f\0\xd1\x90p\x02\f\0\xddm\xf0\x02\f\0\xef\xe2\xf0\x02\f\x01\x14\xcc\xf0\x02\f\x01\x1e\x07p\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xcb\x15\x10\x03\x1c\0\xe6\xc4\x90\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf99\x90\x03\x1c\x01\x03\xc5\x90\x03\x1c\x01\x05\x17\x10\x03\x1c\x01\x0f\xa3\x10\x03\x1c\x01\x16:\x90\x03\x1c\x01\x17\x8c\x10\x03\x1c\x01\x18\xdd\x90\x03\x1c\x01-\xf5\x90\x03\x1c\n\x81\x82\x10\x03<\0\0\0\x0e~\x1a\x15\x80\x03\0\x7f\t\x17\0\x13\x02\x13\x02\x13\x02\x14\x02\x13\x02\x12\x02\x16\x05\x0f\x05\x0f\x05\x0f\x05\x15\x01\x11\x04\x0f\x05\x0f\x05\x10\x03\f\x06\r\x06\r\x06\x0e\x06\r\x06\r\x06\r\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\n\b\v\x07\v\x07\v\b\n\b\fAsia/Bishkek\0\xbc\x15\f\0\xb5\xbd\xc8\x06\x1c\0\xc1\xda\x90\x06\x1c\0\xcb\x15\x10\x06\f\0\xc9\xb5\x80\x05\f\0\xddm\xf0\x05\f\0\xe6\xa8p\x05\f\x01\x14\xcc\xf0\x05\f\x01\x1e\x07p\x05\x1c\0\xef\xf1\0\x06\x1c\0\xf0\"8\x06\x1c\x01\x02t\x10\x06\x1c\x01(\x93p\x06\f\0\xef\xf1\0\x06\f\0\xf0\r \x06\f\0\xf14p\x06\f\0\xf9+\x80\x06|\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x1c\0\xef\xf1\0\x07\x1c\0\xef\xff\x10\x07\x1c\0\xf1P\x90\x07<\0\0\0\x0e\x8e\x9b4\xc0\x07\x003\x10\x14\x0e\x12\x0e\x12\x0e\x13\r\x11\f\x11\f\x11\f\x11\f\x11\f\x11\x0f\b\x03\v\x04\n\x04\n\x04\n\x04\n\x05\t\x06\x02\x06\x02\x07\x01\x07\x01\x07\x02\x06\x02\x06\x02\x07\x01\0\vAsia/Brunei\0Y\t\x1e\x01i?\xb0\b\x14\x1e\x01j\x910\b\x14\x1e\x05\x13\xdf\xf8\b\x14n\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x1e\f\0Td\xb0\t\f\0w\xf3\xd0\b\f\x06\xb7\x15\xf0\b\f\f\xdd@\xf8\b.\0\0\0\x0e&\xfd\xbd\xb0\x07\x1e\0\x13\x03\b\x07\x02\x05\x01\x05\0\x05\0\x05\0\x05\x01\x05\0\x05\x04\x06\rAsia/Calcutta\0N\b\x1e\0\x8f\xc1\x90\x06\x1e\x0e\x01)\xe4\xf0\x05\x1e\x0e\x05\xde\xdf\xf0\x05\x1e\x1eC=\xcfn\x06\x1e\x0f\x1d-\xd3\b\x05\x15\n\x0eC\xb5\xd1\x8a\x05\x1eo\xff\xff\xff\xf1\x86\x8cH\xe0\x055\x14/\0\0\0\r\xa0-\xcfH\x055\x14\0\b\x06\x07\x04\x05\x03\x01\0\x02\nAsia/Chita\0\xca\x15\f\0\x93\xa8\0\t\f\0\xef\xff\x10\b\f\x06\xbd\xadp\b\x1c\0\xef\xf1\0\t\f\0\xef\xf1\0\t\f\0\xf0\r \t\f\0\xf14p\t\f\0\xf9+\x80\t\f\x01\x14\xdb\0\t\f\x01\x1e\x15\x80\t\f\x02\xab\x05 \t|\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1c\0\\:\xf0\n\x1c\0\xc1\xcc\x80\n\f\0\xc1\xcc\x80\n\x1c\0\xcb\x07\0\n\x1c\0\xef\xf1\0\n\x1c\0\xef\xff\x10\n\x1c\0\xf1P\x90\n\x1c\0\xf9+\x80\n<\0\0\0\x0e\x8e\x9b\n\x90\n\0A\v\x14\x06\x11\x06\x11\x06\x12\x05\x10\x04\x10\x04\x10\x04\x10\x04\x10\x04\x10\x07\x03\x01\0\f\x04\x10\x04\x10\x04\x10\x04\x13\b\x0f\b\x0f\b\x0f\t\r\t\r\t\x0f\b\x0f\b\x0f\t\r\t\r\t\r\t\x0f\b\x0f\b\x0f\t\x0e\x02\n\x0fAsia/Choibalsan\0\x91\x0e\x1c\0\xef\xff\x10\t\x1c\0\xf0\x1b0\t\x1c\0\xf1P\x90\t\x1c\0\xf99\x90\t\x1c\x04\xdc\xb20\t\x1c\t\xdd\xeb\xf0\t\x1c\x0f\xf8I\x90\tl\xff\xff\xff\xf1\x86\x8cH\xe0\b\f\0\xca\xf8\xf0\b\f\0\xef\xc6\xd0\b\f\0\xef\xe2\xf0\b\f\0\xf14p\b\f\0\xf9\x1dp\b,\0\0\0\x0e\x88\x7f\x93\xb0\b\x002\x07\r\x05\v\x02\n\0\n\0\n\0\n\0\n\0\n\0\f\0\n\0\n\0\n\0\n\0\n\x03\n\0\n\0\n\x04\b\0\n\0\n\0\n\0\n\0\f\x06\t\x01\t\x0eAsia/Chongqing\0B\x07\f\0\xafIp\b\f\0\xc1\xbep\b\f\0\xca\xf8\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xe9\x10\t\x1c\x01\x1e#\x90\t<\0\0\0\x0e\x98.\t@\t\0\r\x03\x06\0\x04\x02\x05\x01\x05\x02\x04\x02\x04\x02\x0eAsia/Chungking\0B\x07\f\0\xafIp\b\f\0\xc1\xbep\b\f\0\xca\xf8\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xe9\x10\t\x1c\x01\x1e#\x90\t<\0\0\0\x0e\x98.\t@\t\0\r\x03\x06\0\x04\x02\x05\x01\x05\x02\x04\x02\x04\x02\fAsia/Colombo\0*\x04\x0e\x11\xce\xea\b\x05\x1e\f\0\xca\xff\xf8\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1e.\0\0\0\x0e\xab\x19\xb7H\x06\x1e\0\x04\x02\x03\x01\0\nAsia/Dacca\0 \x03\f\x01\x01\x14\x80\x06|\xff\xff\xff\xf1\x86\x8cH\xe0\x07<\0\0\0\x0e\xc3\xaf{0\x07\0\x03\x01\x02\0\rAsia/Damascus\x01V'\f\0\xa2\x1ap\x02\f\0\xc9\xa7p\x02\f\0\xe5V\xf0\x02\f\0\xe6\xa8p\x02\f\0\xe7\xf9\xf0\x02\f\0\xef\xe2\xf0\x02\f\0\xf14p\x02\f\0\xf2\x85\xf0\x02\f\0\xf3\xd7p\x02\f\x01\x14\xcc\xf0\x02\f\x01\x16\x1ep\x02\f\x01\x1e\x07p\x02\f\x01/*\xf0\x02\f\x015\xc2p\x02\f\x01A\x9f\xf0\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xb3Z\x10\x03\x1c\0\xbc\x94\x90\x03\x1c\0\xc0\x89\x10\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xc7 \x90\x03\x1c\0\xcb\x15\x10\x03\x1c\0\xe8\x16\x10\x03\x1c\0\xed\\\x10\x03\x1c\0\xee\xad\x90\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf14p\x03\x1c\0\xf1P\x90\x03\x1c\0\xf7\xe8\x10\x03\x1c\0\xf99\x90\x03\x1c\0\xfa\x8b\x10\x03\x1c\0\xfb\xdc\x90\x03\x1c\x01\x17\x8c\x10\x03\x1c\x01\x18\xdd\x90\x03\f\x01\x1e\x07p\x03\x1c\x01?\x19\x10\x03\x1c\x02\x970\x90\x03\x1c\b\xa87\x90\x03<\0\0\0\x0ez\x11\xeb \x03\0a\x0f&\x01 \x01!\x01 \x01 \x01 \x01!\x01 \0#\0%\x03\x1f\x03$\r\x11\x0e\x10\f\x14\x07\x19\x05\x1a\x06\x1e\x04\x16\x06\x1c\x06\x19\x06\x1b\x06\x18\x07\x17\b\x19\x06\x1b\x06\x19\x06\x19\x06\x19\x06\x1b\x06\x19\x06\x19\x02\x1d\v\x15\n\x12\v\x15\t\x15\t\x15\t\x15\t\x15\v\x13\v\x13\v\x15\t\x15\t\x15\t\x15\v\x13\v\x13\"\nAsia/Dhaka\0 \x03\f\x01\x01\x14\x80\x06|\xff\xff\xff\xf1\x86\x8cH\xe0\x07<\0\0\0\x0e\xc3\xaf{0\x07\0\x03\x01\x02\0\tAsia/Dili\0 \x03l\xff\xff\xff\xf1\x86\x8cH\xe0\b\f-\xd9h\x90\t,\0\0\0\x0e\x85]\xe7\x90\b\0\x03\0\x02\x01\nAsia/Dubai\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x04,\0\0\0\x0e\x1bfP\xc8\x04\0\x02\0\x01\rAsia/Dushanbe\0d\v\f\0\xd5\xa1\x10\x05\x1c\0\xef\xf1\0\x06\f\0\xef\xf1\0\x06\f\0\xf0\r \x06\f\0\xf14p\x06\f\0\xf9+\x80\x06|\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x1c\0\xef\xf1\0\x07\x1c\0\xef\xff\x10\x07\x1c\0\xf1P\x90\x07<\0\0\0\x0e\x8e\x9b4\xc0\x07\0\x17\x06\n\x04\b\x04\b\x04\t\x03\x07\x02\x07\x02\x07\x02\x07\x02\x07\x02\x07\x05\x01\0\x0eAsia/Famagusta\0\xff\x13\f\0\xc4ap\x02\f\0\xe6\xa8p\x02\f\0\xef\xe2\xf0\x02\f\0\xf14p\x02\f\0\xf9\x1dp\x02\f\x01\x14\xdb\0\x02\f\x01\x15\x050\x02\f\x01\x1e\x15\x80\x02\f\x02$\xa8@\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\f\0\xd9O@\x03\x1c\0\xe5s\x10\x03\x1c\0\xee\xad\x90\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf99\x90\x03\x1c\x01\x1c\xd2\x10\x03<\0\0\0\x0e\x83ag\0\x03\0\x82\t\x12\x02\x11\0\r\x01\x10\x03\x0e\x02\x10\x01\x0f\x02\x0f\x02\x0f\x02\x0f\x04\x0f\x02\x0f\x02\x0f\x02\x0f\x02\x0f\x02\x0f\x04\x0f\x02\x0f\x02\x0f\x02\x0f\x02\x0f\x02\x10\x02\x0f\x02\x0f\x06\v\x07\n\x07\n\x07\v\x05\v\x05\v\x07\n\x07\n\x07\n\x07\v\x05\v\x05\v\x07\n\x07\n\x07\v\x05\v\x05\v\x05\v\f\b\n\x07\v\x05\v\x05\v\x07\n\x07\n\x07\v\x05\v\x05\v\x05\v\x07\n\x07\n\x07\v\x05\v\x05\v\x07\n\x07\n\x07\n\x07\v\x05\v\x05\v\x07\n\x07\tAsia/Gaza\x02\x15C\f\x007_\0\x02\f\0\x81$\xf0\x02\f\0\x93\x99\xf0\x02\f\0\x93\xa8\0\x02\f\0\x9eB\x10\x02\f\0\xa0\xc8\xb4\x02\f\0\xa6\x0e\xf0\x02\f\0\xafIp\x02\f\0\xb4\x8f4\x02\f\0\xb8\x83\xf0\x02\f\0\xc1\xbep\x02\f\0\xc4ap\x02\f\0\xc7\x04p\x02\f\0\xca\xf8\xf0\x02\f\0\xcd\x9b\xf0\x02\f\0\xd43p\x02\f\0\xd4A\x80\x02\f\0\xd9\x95\x90\x02\f\0\xdd|\0\x02\f\0\xe2\xd0\x10\x02\f\0\xe5V\xf0\x02\f\0\xe6\xa8p\x02\f\0\xe6\xb6\x80\x02\f\0\xef\xe2\xf0\x02\f\0\xf9\x1dp\x02\f\x01\x02W\xf0\x02\f\x01\v\x92p\x02\f\x01\x13\x89\x80\x02\f\x01\x14\xcc\xf0\x02\f\x01\x14\xdb\0\x02\f\x01\x16\x1ep\x02\f\x01\x1c\xc4\0\x02\f\x01\x1c\xd2\x10\x02\f\x01\x1e\x07p\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0}>\x80\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xc4o\x80\x03\x1c\0\xc9\xb5\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb\x15\x10\x03\x1c\0\xccf\x90\x03\x1c\0\xd4O\x90\x03\x1c\0\xdd\x8a\x10\x03\x1c\0\xe6\xc4\x90\x03\x1c\0\xeb\xeep\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf9+\x80\x03\x1c\0\xf99\x90\x03\x1c\0\xfb\xdc\x90\x03\x1c\x01\x02f\0\x03\x1c\x01\x03\xa9p\x03\x1c\x01\v\xae\x90\x03\x1c\x01\f\xf2<\x03\x1c\x01\x12F\x10\x03\x1c\x01\x14\xdb\0\x03\x1c\x01\x14\xe9\x10\x03\x1c\x01\x1b\x80\x90\x03\x1c\x01\"\x18\x10\x03\x1c\x010\x8a\x80\x03\x1c\x013;\xcc\x03\x1c\x019\xd3\x10\x03\x1c\x01?\x19\x10\x03\x1c\x01U\x82\x90\x03\x1c\x06\xd9k\0\x03\x1c\tC\xc8\x90\x03<\0\0\0\x0e\x81\xf0C\0\x03\0x\"B\x010\x07A\0@\x03;\t?\x02:\f8\n=\x064\r8\x0f8\x0f6\x0e6\v9\x0e\x04#\x122\x122\x127\x170\x17.\x17.\x17.\x17.\x122\x13-\x141\x113\r8\x105\b<\x05>\x16/\x17.\x1c)\x1b)!$!$!&\x1e(\x1d'\x1f% .\x17,\x18+\x19(\x1c(!$!$!(\x1c(\x1c(!$!$!$!(\x1a*\x19+\x17.\x15\vAsia/Harbin\0B\x07\f\0\xafIp\b\f\0\xc1\xbep\b\f\0\xca\xf8\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xe9\x10\t\x1c\x01\x1e#\x90\t<\0\0\0\x0e\x98.\t@\t\0\r\x03\x06\0\x04\x02\x05\x01\x05\x02\x04\x02\x04\x02\vAsia/Hebron\x02)F\f\0(\xd0p\x02\f\x007_\0\x02\f\0\x81$\xf0\x02\f\0\x93\x99\xf0\x02\f\0\x93\xa8\0\x02\f\0\x9eB\x10\x02\f\0\xa0\xc8\xb4\x02\f\0\xa6\x0e\xf0\x02\f\0\xafIp\x02\f\0\xb5\xe0\xf0\x02\f\0\xb8\x83\xf0\x02\f\0\xc1\xbep\x02\f\0\xc4ap\x02\f\0\xc7\x04p\x02\f\0\xca\xf8\xf0\x02\f\0\xcd\x9b\xf0\x02\f\0\xce\xedp\x02\f\0\xd43p\x02\f\0\xd4A\x80\x02\f\0\xd9\x95\x90\x02\f\0\xdd|\0\x02\f\0\xe2\xd0\x10\x02\f\0\xe5V\xf0\x02\f\0\xe6\xa8p\x02\f\0\xe6\xb6\x80\x02\f\0\xef\xe2\xf0\x02\f\0\xf9\x1dp\x02\f\x01\x02W\xf0\x02\f\x01\v\x92p\x02\f\x01\x13\x89\x80\x02\f\x01\x14\xcc\xf0\x02\f\x01\x14\xdb\0\x02\f\x01\x16\x1ep\x02\f\x01\x1c\xc4\0\x02\f\x01\x1c\xd2\x10\x02\f\x01\x1e\x07p\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0&I\x90\x03\x1c\0}>\x80\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xc4o\x80\x03\x1c\0\xc9\xb5\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb\x15\x10\x03\x1c\0\xccf\x90\x03\x1c\0\xd4O\x90\x03\x1c\0\xdd\x8a\x10\x03\x1c\0\xe6\xc4\x90\x03\x1c\0\xeb\xeep\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf9+\x80\x03\x1c\0\xf99\x90\x03\x1c\0\xfb\xdc\x90\x03\x1c\x01\x02f\0\x03\x1c\x01\x03\xa9p\x03\x1c\x01\v\xa0\x80\x03\x1c\x01\v\xae\x90\x03\x1c\x01\x10\xf4\x90\x03\x1c\x01\x12F\x10\x03\x1c\x01\x14\xdb\0\x03\x1c\x01\x14\xe9\x10\x03\x1c\x01\x1b\x80\x90\x03\x1c\x01\"\x18\x10\x03\x1c\x010\x8a\x80\x03\x1c\x013;\xcc\x03\x1c\x019\xd3\x10\x03\x1c\x01U\x82\x90\x03\x1c\x06\xd9k\0\x03\x1c\tC\xc8\x90\x03<\0\0\0\x0e\x81\xf0C\0\x03\0z$E\x023\bD\x01C\x04?\nB\x03>\r<\vA\x078\x0e<\x11<\x11:\x0f:\f=\x0f\x05&\x145\x145\x14;\x193\x191\x191\x191\x191\x145\x150\x164\x136\x109\x127\t@\x06%\x001\x182\x191\x1e,\x1d,#'#'#) +\x1f*!(\"1\x19/\x1a.\x1b+\x1e+#'#'#+\x1e+\x1e+#'#'#'#+\x1c-\x1b.\x191\x17\x10Asia/Ho_Chi_Minh\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x07,\0\0\0\x0e\x83\xb1~ \x07\0\x02\0\x01\x0eAsia/Hong_Kong\0R\t\f\0\xd43p\b\f\0\xef\xe2\xf0\b\f\0\xf9\x1dp\b\f\x01\x83\x8a\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\0\\W\x10\t\x1c\0\xef\xff\x10\t\x1c\x04\xd4\xad\x10\t<\0\0\0\x0ez\x01\xd9\xd8\t\0\x11\x04\b\x01\x06\x01\x06\x02\x06\x01\x05\x03\x06\x01\x06\x01\x07\0\tAsia/Hovd\0\x91\x0e\x1c\0\xef\xff\x10\b\x1c\0\xf0\x1b0\b\x1c\0\xf1P\x90\b\x1c\0\xf99\x90\b\x1c\x04\xdc\xb20\b\x1c\t\xdd\xeb\xf0\b\x1c\x0f\xf8I\x90\bl\xff\xff\xff\xf1\x86\x8cH\xe0\x07\f\0\xca\xf8\xf0\x07\f\0\xef\xc6\xd0\x07\f\0\xef\xe2\xf0\x07\f\0\xf14p\x07\f\0\xf9\x1dp\x07,\0\0\0\x0e\x88\x7f\xa1\xc0\x07\x002\x07\r\x05\v\x02\n\0\n\0\n\0\n\0\n\0\n\0\f\0\n\0\n\0\n\0\n\0\n\x03\n\0\n\0\n\x04\b\0\n\0\n\0\n\0\n\0\f\x06\t\x01\t\fAsia/Irkutsk\0\xc3\x14\f\0\x93\xa8\0\b\f\0\xef\xff\x10\x07\x1c\0\xef\xf1\0\b\f\0\xef\xf1\0\b\f\0\xf0\r \b\f\0\xf14p\b\f\0\xf9+\x80\b\f\x01\x14\xdb\0\b\f\x01\x1e\x15\x80\b\f\x06\xbd\xadp\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\0\\:\xf0\t\x1c\0\xc1\xcc\x80\t\f\0\xc1\xcc\x80\t\x1c\0\xcb\x07\0\t\x1c\0\xef\xf1\0\t\x1c\0\xef\xff\x10\t\x1c\0\xf1P\x90\t\x1c\0\xf9+\x80\t<\0\0\0\x0e\x8e\x9b\x18\xa0\t\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\rAsia/Istanbul\x013$\f\0\xcb\x07\0\x02\f\0\xd4A\x80\x02\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x02W\xf0\x02\f\x01\x13\x89\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1c\xc4\0\x02\f\x01\x1e\x07p\x02\f\x01\x1e\x15\x80\x02\f\x01'A\xf0\x02\f\x01'P\0\x02\f\x01(\x93p\x02\f\x02\n \x10\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\f\0S\0p\x03\f\0s\xd9\xd0\x03\x1c\0\xb7N\x90\x03\x1c\0\xb8\x92\0\x03\x1c\0\xb8\xa0\x10\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xc1\xe8\xa0\x03\x1c\0\xc3\x1e\0\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb\x15\x10\x03\x1c\0\xccX\x80\x03\f\0\xd7\xfd\xc0\x03\x1c\0\xdd\x8a\x10\x03\x1c\0\xe0\x1f\0\x03\x1c\0\xe6\xb6\x80\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf1B\x80\x03\x1c\0\xf9+\x80\x03\x1c\t\x91\x9f \x04<\0\0\0\x0e\x7f\xe2J\x90\x03\0P\x0e#\0\x15\b\x11\f\x13\n\x19\x04\x1c\x10\"\x0f\r\x1d\x01 \x02\x1f\x02\x1f\x02\x1f\x02\x1f\x03\x1f\x02\x1f\x02\x1f\x02\x1e\x03\x1f\x02!\x06\x18\x06\x18\x06\x18\t\x14\t\x14\t\x18\x06\x18\x06\x18\t\x14\t\x14\t\x16\t\x18\x06\x18\x06\x18\t\x17\x07\x14\t\x18\x06\x1a\x05\x18\v\x12\x1b\fAsia/Jakarta\0R\t\f\x19\xb6\x98\x88\x07o\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x07\f\x0e\x03\xc2_\xf8\x07\x1e\f\x04\xe5\xd7\x98\b\x0e\x06\x97j\xe8\x07\x1e\x0e\x10\x9eX\x80\x07\x1e\f\x11\xa8\xa5(\t\x0ej\x12<\x80\x07\x14/\0\0\0\r\xb8\xda\0\x80\x07\x07\f\0\t\x01\b\x07\x05\x06\x04\x03\x02\0\rAsia/Jayapura\0(\x04l\xff\xff\xff\xf1\x86\x8cH\xe0\t\f$\\\xe8x\t\x0e\x16A\xf8X\t\x1e,\0\0\0\x0e3\x8ax\xb8\t\0\x04\0\x03\x02\x01\x0eAsia/Jerusalem\x01\xae2\f\x007_\0\x02\f\0\x81$\xf0\x02\f\0\x93\x99\xf0\x02\f\0\x93\xa8\0\x02\f\0\xa6\x0e\xf0\x02\f\0\xafIp\x02\f\0\xb8\x83\xf0\x02\f\0\xc1\xbep\x02\f\0\xc4ap\x02\f\0\xc7\x04p\x02\f\0\xca\xf8\xf0\x02\f\0\xcd\x9b\xf0\x02\f\0\xd43p\x02\f\0\xddm\xf0\x02\f\0\xe0\x10\xf0\x02\f\0\xe6\x9a`\x02\f\0\xe9Kp\x02\f\0\xf2\x85\xf0\x02\f\0\xf3\xd7p\x02\f\0\xf9\x1dp\x02\f\0\xfb\xc0p\x02\f\0\xfd\x11\xf0\x02\f\x01\x17o\xf0\x02\f\x01 \xaap\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xbf7\x90\x03\x1c\0\xc8r\x10\x03\x1c\0\xe2\xd0\x10\x03\x1c\0\xe4!\x90\x03\x1c\0\xed\\\x10\x03\x1c\0\xf3\xf3\x90\x03\x1c\0\xf5E\x10\x03\x1c\0\xf6\x96\x90\x03\x1c\0\xf99\x90\x03\x1c\0\xfb\xea\xa0\x03\x1c\0\xff\xd1\x10\x03\x1c\x01\t\v\x90\x03\x1c\x01\v\xae\x90\x03\x1c\x01\x12F\x10\x03\x1c\x01\x12b0\x03\x1c\x01\x14\xe9\x10\x03\x1c\x01\x1b\x80\x90\x03\x1c\x01\"\x18\x10\x03\x1c\x01'^\x10\x03\x1c\x010\x8a\x80\x03\x1c\x019\xd3\x10\x03\x1c\x01U\x82\x90\x03\x1c\x06\xd9k\0\x03\x1c\tC\xc8\x90\x03<\0\0\0\x0e\x81\xf0C\0\x03\0w\x181\x01!\x050\0/\x03,\x06.\x02*\t(\x07-\x04%\n(\f(\f&\v&\b)\v#\x12\x1f\x10 \x0e'\n+\x0f\x1e\r\x1f\x15\x1b\x13 \r\"\x14\x1c\x11\x1d\x0e#\x14\x1c\x11\x1d\x0e$\x11\x1d\x10 \x16\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\nAsia/Kabul\0!\x03l\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x0egs<\xa0\x04\x1e,\0\0\0\r\xe2\xfaQ\xc0\x04\0\x03\0\x02\x01\x0eAsia/Kamchatka\0\xc8\x15\x1c\0\xcb\x07\0\f\f\0\x93\xa8\0\f\f\0\xc1\xcc\x80\f\f\0\xef\xff\x10\v\f\x01\x1e#\x90\v\x1c\0\xef\xf1\0\f\f\0\xef\xf1\0\f\f\0\xf0\r \f\f\0\xf14p\f\f\0\xf9+\x80\f\f\x01\x14\xdb\0\f\f\x01\x1e\x15\x80\f|\xff\xff\xff\xf1\x86\x8cH\xe0\r\x1c\0\\:\xf0\r\x1c\0\xc1\xcc\x80\r\x1c\0\xcb\x07\0\r\x1c\0\xef\xf1\0\r\x1c\0\xef\xff\x10\r\x1c\0\xf1P\x90\r\x1c\0\xf9+\x80\r<\0\0\0\x0e\x8e\x9a\xe0`\r\0?\f\x14\b\x11\b\x11\b\x12\x07\x10\x06\x10\x06\x10\x06\x10\x06\x10\x06\x10\t\x05\x03\x01\r\x06\x10\x06\x10\x06\x10\x06\x13\n\x0f\n\x0f\n\x0f\v\x0e\v\x0e\v\x0f\n\x0f\n\x0f\v\x0e\v\x0e\v\x0e\v\x0f\n\x0f\n\0\x04\x02\fAsia/Karachi\0C\b\x1c\0\xd9\x95\x90\x06\x1c\n\xa2w\x90\x06\x1c:_\x9a\x80\x06l\xff\xff\xff\xf1\x86\x8cH\xe0\x05\f\0\xc9\xa7p\x05\f\0\xef\xe2\xf0\x05\f\x01\x07\x9d\xf0\x05,\0\0\0\x0e{\xc3bP\x05\0\b\x03\x07\x02\x05\x01\x04\0\x06\fAsia/Kashgar\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x06,\0\0\0\x0e*rq\x84\x06\0\x02\0\x01\x0eAsia/Kathmandu\0\x1b\x02n\xff\xff\xff\xf1\x86\x8cH\xe0\x05-.\0\0\0\x0e\x97\x8b\xe7\xc8\x05-\0\x02\0\x01\rAsia/Katmandu\0\x1b\x02n\xff\xff\xff\xf1\x86\x8cH\xe0\x05-.\0\0\0\x0e\x97\x8b\xe7\xc8\x05-\0\x02\0\x01\rAsia/Khandyga\0\xef\x1b\f\0\x93\xa8\0\t\f\0\xef\xff\x10\b\x1c\0\xef\xf1\0\t\f\0\xef\xf1\0\t\f\0\xf0\r \t\f\0\xf14p\t\f\0\xf9+\x80\t\f\x01\x14\xdb\0\t\f\x01\x1e\x15\x80\t\f\x05\xdd\xc6\xb0\t|\xff\xff\xff\xf1\x86\x8cH\xe0\n\f\0X8`\n\x1c\0\\:\xf0\n\x1c\0r\xc0\x90\v\x1c\0\xc1\xcc\x80\n\x1c\0\xc1\xcc\x80\v\f\0\xc1\xcc\x80\v\x1c\0\xcb\x07\0\n\f\0\xdf\xf4\xd0\n\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\n\x1c\0\xef\xff\x10\n\x1c\0\xf1P\x90\n\x1c\0\xf9+\x80\n\f\x01\x14\xdb\0\n\f\x01\x1e\x15\x80\n<\0\0\0\x0e\x8e\x9b\n\x90\n\0B\n\x1a\x05\x15\x05\x15\x05\x16\x04\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x06\x02\x01\0\f\x03\x14\x03\x14\x03\x14\x03\x17\x07\x11\x07\x11\x07\x11\b\x0e\b\x0e\b\x11\x07\x11\x07\v\r\x19\x0f\x19\x0f\x19\x0f\x19\x13\x18\x13\x18\x13\x19\x10\x12\t\fAsia/Kolkata\0N\b\x1e\0\x8f\xc1\x90\x06\x1e\x0e\x01)\xe4\xf0\x05\x1e\x0e\x05\xde\xdf\xf0\x05\x1e\x1eC=\xcfn\x06\x1e\x0f\x1d-\xd3\b\x05\x15\n\x0eC\xb5\xd1\x8a\x05\x1eo\xff\xff\xff\xf1\x86\x8cH\xe0\x055\x14/\0\0\0\r\xa0-\xcfH\x055\x14\0\b\x06\x07\x04\x05\x03\x01\0\x02\x10Asia/Krasnoyarsk\0\xc3\x14\f\0\x93\xa8\0\x07\f\0\xef\xff\x10\x06\x1c\0\xef\xf1\0\x07\f\0\xef\xf1\0\x07\f\0\xf0\r \x07\f\0\xf14p\x07\f\0\xf9+\x80\x07\f\x01\x14\xdb\0\x07\f\x01\x1e\x15\x80\x07\f\x06\xbd\xadp\x07|\xff\xff\xff\xf1\x86\x8cH\xe0\b\x1c\0\\:\xf0\b\x1c\0\xc1\xcc\x80\b\f\0\xc1\xcc\x80\b\x1c\0\xcb\x07\0\b\x1c\0\xef\xf1\0\b\x1c\0\xef\xff\x10\b\x1c\0\xf1P\x90\b\x1c\0\xf9+\x80\b<\0\0\0\x0e\x8e\x9b&\xb0\b\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\x11Asia/Kuala_Lumpur\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\b,\0\0\0\x0e\x90\x05\xa5 \b\0\x02\0\x01\fAsia/Kuching\0Y\t\x1e\x01i?\xb0\b\x14\x1e\x01j\x910\b\x14\x1e\x05\x13\xdf\xf8\b\x14n\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x1e\f\0Td\xb0\t\f\0w\xf3\xd0\b\f\x06\xb7\x15\xf0\b\f\f\xdd@\xf8\b.\0\0\0\x0e&\xfd\xbd\xb0\x07\x1e\0\x13\x03\b\x07\x02\x05\x01\x05\0\x05\0\x05\0\x05\x01\x05\0\x05\x04\x06\vAsia/Kuwait\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x03,\0\0\0\x0eN\x8e\xed\xd4\x03\0\x02\0\x01\nAsia/Macao\0R\t\f\0\xd43p\b\f\0\xef\xe2\xf0\b\f\0\xf9\x1dp\b\f\x01\x83\x8a\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\0\\W\x10\t\x1c\0\xef\xff\x10\t\x1c\x04\xd4\xad\x10\t<\0\0\0\x0ez\x01\xd9\xd8\t\0\x11\x04\b\x01\x06\x01\x06\x02\x06\x01\x05\x03\x06\x01\x06\x01\x07\0\nAsia/Macau\0R\t\f\0\xd43p\b\f\0\xef\xe2\xf0\b\f\0\xf9\x1dp\b\f\x01\x83\x8a\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\0\\W\x10\t\x1c\0\xef\xff\x10\t\x1c\x04\xd4\xad\x10\t<\0\0\0\x0ez\x01\xd9\xd8\t\0\x11\x04\b\x01\x06\x01\x06\x02\x06\x01\x05\x03\x06\x01\x06\x01\x07\0\fAsia/Magadan\0\xca\x15\f\0\x93\xa8\0\v\f\0\xef\xff\x10\n\f\x06\xbd\xadp\n\x1c\0\xef\xf1\0\v\f\0\xef\xf1\0\v\f\0\xf0\r \v\f\0\xf14p\v\f\0\xf9+\x80\v\f\x01\x14\xdb\0\v\f\x01\x1e\x15\x80\v\f\x02\xcf\xef \v|\xff\xff\xff\xf1\x86\x8cH\xe0\f\x1c\0\\:\xf0\f\x1c\0\xc1\xcc\x80\f\f\0\xc1\xcc\x80\f\x1c\0\xcb\x07\0\f\x1c\0\xef\xf1\0\f\x1c\0\xef\xff\x10\f\x1c\0\xf1P\x90\f\x1c\0\xf9+\x80\f<\0\0\0\x0e\x8e\x9a\xeep\f\0A\v\x14\x06\x11\x06\x11\x06\x12\x05\x10\x04\x10\x04\x10\x04\x10\x04\x10\x04\x10\x07\x03\x01\0\f\x04\x10\x04\x10\x04\x10\x04\x13\b\x0f\b\x0f\b\x0f\t\r\t\r\t\x0f\b\x0f\b\x0f\t\r\t\r\t\r\t\x0f\b\x0f\b\x0f\t\x0e\x02\n\rAsia/Makassar\x002\x05o\xff\xff\xff\xf1\x86\x8cH\xe0\x079$\f\x06\xce\xd0\xf0\b\f\x11qG\xf0\t\f\x18$x\0\b/\0\0\0\x0e\x1bf\x14\xb0\x079$\0\x05\0\x04\x03\x02\x01\vAsia/Manila\0.\x05\f\0Z\xe9p\b\f\0\xea\x9c\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x17\xd0&\x10\t<\0\0\0\x0e\x87\x0f\xb3 \t\0\x05\x02\x04\x01\x03\0\vAsia/Muscat\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x04,\0\0\0\x0e\x1bfP\xc8\x04\0\x02\0\x01\fAsia/Nicosia\0\xf4\x11\f\0\xc4ap\x02\f\0\xe6\xa8p\x02\f\0\xef\xe2\xf0\x02\f\0\xf14p\x02\f\0\xf9\x1dp\x02\f\x01\x14\xdb\0\x02\f\x01\x15\x050\x02\f\x01\x1e\x15\x80\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xe5s\x10\x03\x1c\0\xee\xad\x90\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf99\x90\x03\x1c\x01\x1c\xd2\x10\x03<\0\0\0\x0e\x83ag\0\x03\0\x83\b\x10\x02\x0f\0\v\x01\x0e\x03\f\x02\x0e\x01\r\x02\r\x02\r\x02\r\x04\r\x02\r\x02\r\x02\r\x02\r\x02\r\x04\r\x02\r\x02\r\x02\r\x02\r\x02\x0e\x02\r\x02\r\x06\n\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\x11Asia/Novokuznetsk\0\xc8\x15\x1c\0\xcb\x07\0\x07\f\0\x93\xa8\0\x07\f\0\xc1\xcc\x80\x07\f\0\xef\xff\x10\x06\f\x01\x1e#\x90\x06\x1c\0\xef\xf1\0\x07\f\0\xef\xf1\0\x07\f\0\xf0\r \x07\f\0\xf14p\x07\f\0\xf9+\x80\x07\f\x01\x14\xdb\0\x07\f\x01\x1e\x15\x80\x07|\xff\xff\xff\xf1\x86\x8cH\xe0\b\x1c\0\\:\xf0\b\x1c\0\xc1\xcc\x80\b\x1c\0\xcb\x07\0\b\x1c\0\xef\xf1\0\b\x1c\0\xef\xff\x10\b\x1c\0\xf1P\x90\b\x1c\0\xf9+\x80\b<\0\0\0\x0e\x8e\x9b&\xb0\b\0?\f\x14\b\x11\b\x11\b\x12\x07\x10\x06\x10\x06\x10\x06\x10\x06\x10\x06\x10\t\x05\x03\x01\r\x06\x10\x06\x10\x06\x10\x06\x13\n\x0f\n\x0f\n\x0f\v\x0e\v\x0e\v\x0f\n\x0f\n\x0f\v\x0e\v\x0e\v\x0e\v\x0f\n\x0f\n\0\x04\x02\x10Asia/Novosibirsk\0\xe3\x19\f\0\xa6U@\x06\f\0\xef\xf1\0\x06\f\x01\x14\xdb\0\x06\f\x01\x1e\x15\x80\x06\f\x06\xbd\xadp\x06\x1c\0I\xa9\xd0\x07\x1c\0\xc1\xcc\x80\x07\x1c\0\xcb\x07\0\x07\x1c\0\xef\xf1\0\x07\x1c\0\xf9+\x80\x07\f\0\x93\xa8\0\x07\f\0\xc1\xcc\x80\x07\f\0\xef\xff\x10\x06\x1c\0\xef\xf1\0\x07\f\0\xef\xf1\0\x07\f\0\xf0\r \x07\f\0\xf14p\x07\f\0\xf9+\x80\x07\f\x03G\xd9\x90\x07|\xff\xff\xff\xf1\x86\x8cH\xe0\b\x1c\0\\:\xf0\b\x1c\0\xef\xf1\0\b\x1c\0\xef\xff\x10\b\x1c\0\xf1P\x90\b<\0\0\0\x0e\x8e\x9b&\xb0\b\0B\x13\x18\x10\x16\x10\x16\x10\x17\x0f\x15\x0e\x15\x0e\x15\x0e\x15\x0e\x15\x0e\x15\x11\b\f\n\x14\x0e\x15\x05\0\b\x01\b\x01\t\x02\x07\x02\x07\x02\x07\x03\x06\x03\x06\x03\x07\x02\x07\x02\x07\x03\x06\x03\x06\x03\x06\x03\x07\x02\x07\x02\x07\x03\v\x04\x12\tAsia/Omsk\0\xc3\x14\f\0\x93\xa8\0\x06\f\0\xef\xff\x10\x05\x1c\0\xef\xf1\0\x06\f\0\xef\xf1\0\x06\f\0\xf0\r \x06\f\0\xf14p\x06\f\0\xf9+\x80\x06\f\x01\x14\xdb\0\x06\f\x01\x1e\x15\x80\x06\f\x06\xbd\xadp\x06|\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x1c\0\\:\xf0\x07\x1c\0\xc1\xcc\x80\x07\f\0\xc1\xcc\x80\x07\x1c\0\xcb\x07\0\x07\x1c\0\xef\xf1\0\x07\x1c\0\xef\xff\x10\x07\x1c\0\xf1P\x90\x07\x1c\0\xf9+\x80\x07<\0\0\0\x0e\x8e\x9b4\xc0\x07\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\tAsia/Oral\0\xcd\x18\f\0\xef\xf1\0\x04\x1c\0\\:\xf0\x05\x1c\0\xc1\xcc\x80\x05\x1c\0\xcb\x07\0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xf9+\x80\x05\f\0\x93\xa8\0\x05\f\0\xef\xf1\0\x04\f\0\xef\xff\x10\x04\f\0\xf9+\x80\x04\f\x01\x14\xdb\0\x04\f\x01\x1e\x15\x80\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf1B\x80\x05\f\x01\x1e\x15\x80\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06\f\0\xf14p\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\x002\x12\x17\x16\x13\x10\x14\x0f\x15\x0e\x13\r\x13\r\x13\r\x13\r\x04\b\x04\t\x04\0\x06\x01\b\x04\0\x04\0\x04\0\x05\n\x03\n\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\x11\x0fAsia/Phnom_Penh\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\x06*\x04\fK\xb3\xe2\0\x07/\0\0\0\r\xd0*<\xe4\x06*\x04\0\x03\0\x02\x01\x0eAsia/Pontianak\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x07,\0\0\0\x0e\x9bN+\xa0\x07\0\x02\0\x01\x0eAsia/Pyongyang\0\"\x03n\xff\xff\xff\xf1\x86\x8cH\xe0\b\x1e\f\x05\x1es\0\t.\0\0\0\x0e\xcfA\xb9\x90\b\x1e\0\x03\0\x02\x01\nAsia/Qatar\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x03,\0\0\0\x0e}\xfeI\xe0\x03\0\x02\0\x01\rAsia/Qostanay\0\xc2\x16\x1c\0\\:\xf0\x06\x1c\0\xc1\xcc\x80\x06\x1c\0\xcb\x07\0\x06\f\0\x93\xa8\0\x05\f\0\xef\xff\x10\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf1B\x80\x05\f\0\xf9+\x80\x05\f\x01\x14\xdb\0\x05\f\x01\x1e\x15\x80\x05\f$\\\xc5P\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06\x1c\0\xf9+\x80\x06\f\0\xf14p\x06\f\x01\x1e\x15\x80\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\x003\x0e\x15\x13\x0f\t\x10\b\x11\x07\x0f\x06\x0f\x06\x0f\x06\x0f\x06\x0f\x06\x0f\n\x05\x04\x03\0\x06\x0f\x06\x0f\x06\x0f\x06\x12\v\x02\v\x02\v\x02\f\x01\f\x01\f\x02\v\x02\v\x02\x14\r\x0eAsia/Qyzylorda\0\xc2\x16\x1c\0\\:\xf0\x06\x1c\0\xc1\xcc\x80\x06\x1c\0\xcb\x07\0\x06\f\0\x93\x99\xf0\x06\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xef\xff\x10\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf1B\x80\x05\f\0\xf9+\x80\x05\f\x01\x14\xdb\0\x05\f\x01\x1e\x15\x80\x05\f\x1a\x97\xd7\xd0\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06\x1c\0\xf9+\x80\x06\f\0\xf14p\x06\f\x01\x1e\x15\x80\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\x003\x0e\x15\x13\x0f\t\x10\b\x11\x07\x0f\x05\x0f\x05\x0f\x05\x0f\x05\x0f\x05\x0f\n\x04\x06\x03\0\x06\x0f\x05\x0f\x05\x0f\x05\x12\v\x02\v\x02\v\x02\f\x01\f\x01\f\x02\v\x02\v\x02\x14\r\fAsia/Rangoon\x004\x05o\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x18/\x0e\x05\xa7k\xd8\x06\x1e\f*\0\x88\xc7\t\x0eK;\xe9\x80\x06\x1e/\0\0\0\r\xd0*@\xf1\x06\x18/\0\x05\0\x04\x03\x02\x01\vAsia/Riyadh\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x03,\0\0\0\x0eN\x8e\xed\xd4\x03\0\x02\0\x01\vAsia/Saigon\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x07,\0\0\0\x0e\x83\xb1~ \x07\0\x02\0\x01\rAsia/Sakhalin\0\xd6\x17\x1c\0\xc1\xcc\x80\v\x1c\0\xcb\x07\0\v\f\0\x93\xa8\0\v\f\0\xc1\xcc\x80\v\f\0\xef\xff\x10\n\f\x01\x14\xdb\0\n\f\x01\x14\xe9\x10\n\f\x01\x1e\x15\x80\n\f\x06\xbd\xadp\n\x1c\0\xef\xf1\0\v\f\0\xef\xf1\0\v\f\0\xf0\r \v\f\0\xf14p\v\f\0\xf9+\x80\v\f\x01\x14\xdb\0\v\f\x02\xaa\xf7\x10\v|\xff\xff\xff\xf1\x86\x8cH\xe0\f\x1c\0\\:\xf0\f\x1c\0\xef\xf1\0\f\x1c\0\xef\xff\x10\f\x1c\0\xf1P\x90\f\x1c\0\xf9+\x80\f<\0\0\0\x0e\x8e\x9a\xeep\f\0A\x10\x16\f\x13\f\x13\f\x14\v\x12\n\x12\n\x12\n\x12\n\x12\n\x12\r\t\x04\x02\x11\n\x12\n\x12\n\x12\n\x15\x0e\x01\x06\x01\x05\x01\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x07\0\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x07\x03\b\x0f\x0eAsia/Samarkand\0d\v\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf1B\x80\x05\f\0\xf9+\x80\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06\f\0\xf14p\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\0\x17\x05\n\t\x06\x03\x07\x02\b\x01\x06\0\x06\0\x06\0\x06\0\x06\0\x06\x04\x06\0\nAsia/Seoul\0(\x04\f\0\xcb\x07\0\t|\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1c\x01\x14\xdb\0\n<\0\0\0\x0e\x9a\x17\x17\xb0\n\0\x05\x01\x03\0\x02\0\rAsia/Shanghai\0B\x07\f\0\xafIp\b\f\0\xc1\xbep\b\f\0\xca\xf8\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xe9\x10\t\x1c\x01\x1e#\x90\t<\0\0\0\x0e\x98.\t@\t\0\r\x03\x06\0\x04\x02\x05\x01\x05\x02\x04\x02\x04\x02\x0eAsia/Singapore\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\b,\0\0\0\x0e\x90\x05\xa5 \b\0\x02\0\x01\x12Asia/Srednekolymsk\0\xc3\x14\f\0\x93\xa8\0\v\f\0\xef\xff\x10\n\x1c\0\xef\xf1\0\v\f\0\xef\xf1\0\v\f\0\xf0\r \v\f\0\xf14p\v\f\0\xf9+\x80\v\f\x01\x14\xdb\0\v\f\x01\x1e\x15\x80\v\f\x06\xbd\xadp\v|\xff\xff\xff\xf1\x86\x8cH\xe0\f\x1c\0\\:\xf0\f\x1c\0\xc1\xcc\x80\f\f\0\xc1\xcc\x80\f\x1c\0\xcb\x07\0\f\x1c\0\xef\xf1\0\f\x1c\0\xef\xff\x10\f\x1c\0\xf1P\x90\f\x1c\0\xf9+\x80\f<\0\0\0\x0e\x8e\x9a\xeep\f\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\vAsia/Taipei\x006\x06\f\0y;\xf0\b\f\0\xf14p\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\0\xef\xff\x10\t\x1c\x07\f\xe3\x90\t<\0\0\0\x0e\x81p\r \t\0\x07\x02\x05\x01\x03\x01\x04\0\rAsia/Tashkent\0d\v\f\0\xef\xff\x10\x05\x1c\0\xef\xf1\0\x06\f\0\xef\xf1\0\x06\f\0\xf0\r \x06\f\0\xf14p\x06\f\0\xf9+\x80\x06|\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x1c\0\xef\xf1\0\x07\x1c\0\xef\xff\x10\x07\x1c\0\xf1P\x90\x07<\0\0\0\x0e\x8e\x9b4\xc0\x07\0\x17\x06\n\x04\b\x04\b\x04\t\x03\x07\x02\x07\x02\x07\x02\x07\x02\x07\x02\x07\x05\x01\0\fAsia/Tbilisi\0\xcc\x18\f\0\xa6U@\x03\x1c\0w\xeap\x04\f\0\xc1\xcc\x80\x04\f\0\xef\xe2\xf0\x03\x1c\0\xef\xd4\xe0\x04\f\0\xef\xe2\xf0\x04\x1c\0\xef\xff\x10\x04\f\0\xef\xff\x10\x03\x1c\0\xef\xf1\0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\0\xf9+\x80\x04\f\x01\x14\xcc\xf0\x04\f\x01\x1e\x07p\x04\f\x02\xf4\xae\xf0\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xc1\xda\x90\x05\x1c\0\xcb\x15\x10\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05\x1c\0\xf99\x90\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\x001\x10\x17\v\x14\v\x14\v\x15\n\x13\t\x13\t\x13\t\x13\t\x13\t\x13\f\b\x07\x04\x03\x06\x03\x06\x05\x13\x05\x16\x0f\x12\r\x12\x0e\x11\x0e\x11\x0e\x12\r\x12\r\x12\x01\0\x02\vAsia/Tehran\0\xbe\x10\x0e\0\x813\0\x03\x1e\x0e\0\x97\x8ep\x03\x1e\x0e\0\xbb&\xf0\x03\x1e\x0e\0\xf2\x85\xf0\x03\x1e\x0e\0\xf5(\xf0\x03\x1e\f\0\xafW\x80\x04\f\x01\x18\xcf\x80\x04~\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1e\x1e\0\xee\xad\x90\x04\x1e\x1e\0\xef\xff\x10\x04\x1e\x1e\0\xf2\xa2\x10\x04\x1e\x1e\x01\x03\xbe\x88\x04\x1e\x1e\x04\xb1\x14\x90\x04\x1e\x1e\x13\xf3a\x10\x04\x1e\x1c\0\xcc_\x88\x05>\0\0\0\x0e\x87\x07\xfbX\x04\x1e\0F\x07\x0f\x06\x0e\x05\0\v\x01\n\x04\r\x02\t\x03\b\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\f\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\rAsia/Tel_Aviv\x01\xae2\f\x007_\0\x02\f\0\x81$\xf0\x02\f\0\x93\x99\xf0\x02\f\0\x93\xa8\0\x02\f\0\xa6\x0e\xf0\x02\f\0\xafIp\x02\f\0\xb8\x83\xf0\x02\f\0\xc1\xbep\x02\f\0\xc4ap\x02\f\0\xc7\x04p\x02\f\0\xca\xf8\xf0\x02\f\0\xcd\x9b\xf0\x02\f\0\xd43p\x02\f\0\xddm\xf0\x02\f\0\xe0\x10\xf0\x02\f\0\xe6\x9a`\x02\f\0\xe9Kp\x02\f\0\xf2\x85\xf0\x02\f\0\xf3\xd7p\x02\f\0\xf9\x1dp\x02\f\0\xfb\xc0p\x02\f\0\xfd\x11\xf0\x02\f\x01\x17o\xf0\x02\f\x01 \xaap\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xbf7\x90\x03\x1c\0\xc8r\x10\x03\x1c\0\xe2\xd0\x10\x03\x1c\0\xe4!\x90\x03\x1c\0\xed\\\x10\x03\x1c\0\xf3\xf3\x90\x03\x1c\0\xf5E\x10\x03\x1c\0\xf6\x96\x90\x03\x1c\0\xf99\x90\x03\x1c\0\xfb\xea\xa0\x03\x1c\0\xff\xd1\x10\x03\x1c\x01\t\v\x90\x03\x1c\x01\v\xae\x90\x03\x1c\x01\x12F\x10\x03\x1c\x01\x12b0\x03\x1c\x01\x14\xe9\x10\x03\x1c\x01\x1b\x80\x90\x03\x1c\x01\"\x18\x10\x03\x1c\x01'^\x10\x03\x1c\x010\x8a\x80\x03\x1c\x019\xd3\x10\x03\x1c\x01U\x82\x90\x03\x1c\x06\xd9k\0\x03\x1c\tC\xc8\x90\x03<\0\0\0\x0e\x81\xf0C\0\x03\0w\x181\x01!\x050\0/\x03,\x06.\x02*\t(\x07-\x04%\n(\f(\f&\v&\b)\v#\x12\x1f\x10 \x0e'\n+\x0f\x1e\r\x1f\x15\x1b\x13 \r\"\x14\x1c\x11\x1d\x0e#\x14\x1c\x11\x1d\x0e$\x11\x1d\x10 \x16\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\vAsia/Thimbu\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x06,\0\0\0\x0e\x9a\xd5\x04\xc8\x06\0\x02\0\x01\fAsia/Thimphu\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x06,\0\0\0\x0e\x9a\xd5\x04\xc8\x06\0\x02\0\x01\nAsia/Tokyo\0E\b\x1c\x01\v\xa0\x80\n\x1c\x019\xc5\0\n\x1cq{^\0\nl\xff\xff\xff\xf1\x86\x8cH\xe0\t\f\0\xa6\x1d\0\t\f\0\xafW\x80\t\f\0\xd4A\x80\t,\0\0\0\r\xdf6[\x90\t\0\n\x03\x07\x02\x05\0\x06\x01\x04\x01\x04\nAsia/Tomsk\0\xef\x1b\f\0\xec\n\x90\x06\x1c\0(\xde\x80\x07\x1c\0\xc1\xcc\x80\x07\f\0\xc1\xcc\x80\x07\x1c\0\xcb\x07\0\x07\f\0\x93\xa8\0\x07\f\0\xef\xff\x10\x06\f\x01\x14\xdb\0\x06\f\x01\x1e\x15\x80\x06\f\x06\xbd\xadp\x06\x1c\0\xef\xf1\0\x07\f\0\xef\xf1\0\x07\f\0\xf0\r \x07\f\0\xf14p\x07\f\0\xf9+\x80\x07\f\x01\x14\xdb\0\x07\f\x01\x1e\x15\x80\x07\f\x02\xfe\x05\x90\x07|\xff\xff\xff\xf1\x86\x8cH\xe0\b\x1c\0\\:\xf0\b\x1c\0\xc1\xcc\x80\b\x1c\0\xcb\x07\0\b\x1c\0\xef\xf1\0\b\x1c\0\xef\xff\x10\b\x1c\0\xf1P\x90\b\x1c\0\xf9+\x80\b<\0\0\0\x0e\x8e\x9b&\xb0\b\0B\x12\x1a\r\x17\r\x17\r\x18\f\x16\v\x16\v\x16\v\x16\v\x16\v\x16\x0e\n\x06\x05\x13\v\x16\v\x16\v\x16\v\x19\x0f\x15\x0f\x15\x0f\x15\x10\x14\x10\x14\x10\x15\x01\0\x04\x07\x04\b\x02\b\x02\b\x02\b\x04\x07\x04\x07\x04\b\x03\t\x11\x12Asia/Ujung_Pandang\x002\x05o\xff\xff\xff\xf1\x86\x8cH\xe0\x079$\f\x06\xce\xd0\xf0\b\f\x11qG\xf0\t\f\x18$x\0\b/\0\0\0\x0e\x1bf\x14\xb0\x079$\0\x05\0\x04\x03\x02\x01\x10Asia/Ulaanbaatar\0\x91\x0e\x1c\0\xef\xff\x10\t\x1c\0\xf0\x1b0\t\x1c\0\xf1P\x90\t\x1c\0\xf99\x90\t\x1c\x04\xdc\xb20\t\x1c\t\xdd\xeb\xf0\t\x1c\x0f\xf8I\x90\tl\xff\xff\xff\xf1\x86\x8cH\xe0\b\f\0\xca\xf8\xf0\b\f\0\xef\xc6\xd0\b\f\0\xef\xe2\xf0\b\f\0\xf14p\b\f\0\xf9\x1dp\b,\0\0\0\x0e\x88\x7f\x93\xb0\b\x002\x07\r\x05\v\x02\n\0\n\0\n\0\n\0\n\0\n\0\f\0\n\0\n\0\n\0\n\0\n\x03\n\0\n\0\n\x04\b\0\n\0\n\0\n\0\n\0\f\x06\t\x01\t\x0fAsia/Ulan_Bator\0\x91\x0e\x1c\0\xef\xff\x10\t\x1c\0\xf0\x1b0\t\x1c\0\xf1P\x90\t\x1c\0\xf99\x90\t\x1c\x04\xdc\xb20\t\x1c\t\xdd\xeb\xf0\t\x1c\x0f\xf8I\x90\tl\xff\xff\xff\xf1\x86\x8cH\xe0\b\f\0\xca\xf8\xf0\b\f\0\xef\xc6\xd0\b\f\0\xef\xe2\xf0\b\f\0\xf14p\b\f\0\xf9\x1dp\b,\0\0\0\x0e\x88\x7f\x93\xb0\b\x002\x07\r\x05\v\x02\n\0\n\0\n\0\n\0\n\0\n\0\f\0\n\0\n\0\n\0\n\0\n\x03\n\0\n\0\n\x04\b\0\n\0\n\0\n\0\n\0\f\x06\t\x01\t\vAsia/Urumqi\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x06,\0\0\0\x0e*rq\x84\x06\0\x02\0\x01\rAsia/Ust-Nera\0\xd0\x16\f\0\x93\xa8\0\v\f\0\xdf\xf4\xd0\v\f\0\xef\xff\x10\n\f\x05\xdd\xc6\xb0\n\x1c\0\xef\xf1\0\v\f\0\xef\xf1\0\v\f\0\xf0\r \v\f\0\xf1\x18P\v\f\0\xf14p\v\f\0\xf9+\x80\v\f\x01\x14\xdb\0\v\f\x01\x1e\x15\x80\v|\xff\xff\xff\xf1\x86\x8cH\xe0\f\x1c\0\\:\xf0\f\x1c\0\xc1\xcc\x80\f\f\0\xc1\xcc\x80\f\x1c\0\xcb\x07\0\f\x1c\0\xef\xf1\0\f\x1c\0\xef\xff\x10\f\x1c\0\xf1P\x90\f\x1c\0\xf9+\x80\f<\0\0\0\x0e\x8e\x9b\n\x90\f\0A\f\x15\x07\x12\b\x12\b\x13\x06\x11\x05\x11\x05\x11\x05\x11\x05\x11\x05\x11\t\x04\x02\0\r\x05\x11\x05\x11\x05\x11\x05\x14\n\x10\n\x10\n\x10\v\x0e\v\x0e\v\x10\n\x10\n\x10\v\x0e\v\x0e\v\x0e\v\x10\n\x10\n\x10\v\x0f\x01\x03\x0eAsia/Vientiane\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\x06*\x04\fK\xb3\xe2\0\x07/\0\0\0\r\xd0*<\xe4\x06*\x04\0\x03\0\x02\x01\x10Asia/Vladivostok\0\xc3\x14\f\0\x93\xa8\0\n\f\0\xef\xff\x10\t\x1c\0\xef\xf1\0\n\f\0\xef\xf1\0\n\f\0\xf0\r \n\f\0\xf14p\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n\f\x01\x1e\x15\x80\n\f\x06\xbd\xadp\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\0\\:\xf0\v\x1c\0\xc1\xcc\x80\v\f\0\xc1\xcc\x80\v\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xef\xff\x10\v\x1c\0\xf1P\x90\v\x1c\0\xf9+\x80\v<\0\0\0\x0e\x8e\x9a\xfc\x80\v\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\fAsia/Yakutsk\0\xc3\x14\f\0\x93\xa8\0\t\f\0\xef\xff\x10\b\x1c\0\xef\xf1\0\t\f\0\xef\xf1\0\t\f\0\xf0\r \t\f\0\xf14p\t\f\0\xf9+\x80\t\f\x01\x14\xdb\0\t\f\x01\x1e\x15\x80\t\f\x06\xbd\xadp\t|\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1c\0\\:\xf0\n\x1c\0\xc1\xcc\x80\n\f\0\xc1\xcc\x80\n\x1c\0\xcb\x07\0\n\x1c\0\xef\xf1\0\n\x1c\0\xef\xff\x10\n\x1c\0\xf1P\x90\n\x1c\0\xf9+\x80\n<\0\0\0\x0e\x8e\x9b\n\x90\n\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\vAsia/Yangon\x004\x05o\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x18/\x0e\x05\xa7k\xd8\x06\x1e\f*\0\x88\xc7\t\x0eK;\xe9\x80\x06\x1e/\0\0\0\r\xd0*@\xf1\x06\x18/\0\x05\0\x04\x03\x02\x01\x12Asia/Yekaterinburg\0\xc3\x14\f\0\x93\xa8\0\x05\f\0\xef\xff\x10\x04\x1c\0\xef\xf1\0\x05\f\0\xef\xf1\0\x05\f\0\xf0\r \x05\f\0\xf14p\x05\f\0\xf9+\x80\x05\f\x01\x14\xdb\0\x05\f\x01\x1e\x15\x80\x05\f\x06\xbd\xadp\x05|\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x1c\0\\:\xf0\x06\x1c\0\xc1\xcc\x80\x06\f\0\xc1\xcc\x80\x06\x1c\0\xcb\x07\0\x06\x1c\0\xef\xf1\0\x06\x1c\0\xef\xff\x10\x06\x1c\0\xf1P\x90\x06\x1c\0\xf9+\x80\x06<\0\0\0\x0e\x8e\x9bB\xd0\x06\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\fAsia/Yerevan\0\xae\x11\f\0\xef\xf1\0\x03\f\0\xef\xff\x10\x03\x1c\0\xef\xf1\0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\0\xf9+\x80\x04\f\x01\x14\xdb\0\x04\f\x01\x1e\x15\x80\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xc1\xcc\x80\x05\x1c\0\xcb\x07\0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05\x1c\x02\xd8\xffp\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0=\t\x10\x05\r\x05\r\x05\x0e\x04\f\x03\f\x03\f\x03\f\x03\f\x03\f\x06\x02\x01\x02\0\x02\0\x02\0\x02\x03\x0f\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\n\b\v\x07\v\x07\v\b\n\b\x0fAtlantic/Azores\0\xce\x0e\x04\0\x85'\x80\x01\x04\0\xef\xf1\0\x01\x04\0\xf9+\x80\x01\x04\x01\x14\xdb\0\x01\x04\x01\x1e\x15\x80\x01x\xff\xff\xff\xf1\x86\x8cH\xe0\x18\0j\xc9\x80\x18\0\xc1\xcc\x80\x18\0\xcb\x07\0\x1c\0w\xeap\x01\b\0x\x06\x90\x18\0\xef\xf1\0\x18\0\xf9+\x808\0\0\0\x0e\x90w\x84\xb0\0w\x05\r\x01\v\x01\v\x02\v\x01\v\x01\v\x01\v\x01\v\x01\v\x02\v\x01\v\x01\n\t\x06\0\v\x01\v\x01\f\x03\b\x03\b\x03\b\x04\x07\x04\x07\x04\b\x03\b\x03\b\x04\x07\x04\x07\x04\x07\x04\b\x03\b\x03\b\x04\x07\x04\x07\x04\b\x03\b\x03\b\x03\b\x04\x07\x04\x07\x04\b\x03\b\x03\b\x04\x07\x04\x07\x04\b\x03\b\x03\b\x03\b\x04\x07\x04\x07\x04\b\x03\b\x03\b\x04\x07\x04\x07\x04\x07\x04\b\x03\b\x03\b\x04\x07\x04\x10Atlantic/Bermuda\0\xde\r\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x019\xb6\xf0\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xe6\xc4\x90\x03\x14\0\xef\xff\x10\x034\0\0\0\x0e\x81\x94j\x80\x03\0\x85\x05\f\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0fAtlantic/Canary\0\xc1\v\b\0\xe6\xc4\x90\b\0\xef\xf1\0\b\0\xf9+\x80\b\x01\x14\xdb\0\b\x01\x1e\x15\x80|\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\0\xef\xf1\0\x01\x1c\0\xf9+\x80\x01<\0\0\0\x0e\x8c\xc0\xed \x01\0y\x05\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x13Atlantic/Cape_Verde\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\x01$\0\0\0\x0e\x84\x8b\xae`\x01\0\x02\0\x01\x0fAtlantic/Faeroe\0\xba\n\b\0\xef\xf1\0\b\0\xf9+\x80\b\x01\x14\xdb\0\b\x01\x1e\x15\x80|\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\0\xef\xf1\0\x01\x1c\0\xf9+\x80\x01<\0\0\0\x0e\x8e\x97\xa2\xb0\x01\0w\x04\t\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x0eAtlantic/Faroe\0\xba\n\b\0\xef\xf1\0\b\0\xf9+\x80\b\x01\x14\xdb\0\b\x01\x1e\x15\x80|\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\0\xef\xf1\0\x01\x1c\0\xf9+\x80\x01<\0\0\0\x0e\x8e\x97\xa2\xb0\x01\0w\x04\t\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x12Atlantic/Jan_Mayen\0\xc6\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xfb0\x02\0y\x05\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x10Atlantic/Madeira\0\xc2\f\b\0\xe6\xb6\x80\b\0\xef\xf1\0\b\0\xef\xff\x10\b\0\xf9+\x80\b\x01\x14\xdb\0\b\x01\x1e\x15\x80|\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\0\xef\xf1\0\x01\x1c\0\xf9+\x80\x01<\0\0\0\x0e\x90\x80\xb1 \x01\0u\x06\v\0\t\x01\t\x03\t\x01\t\x02\t\x01\t\x01\t\x01\t\x03\t\x01\t\x01\t\x01\t\x01\t\x01\n\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x12Atlantic/Reykjavik\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x16Atlantic/South_Georgia\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\x02$\0\0\0\r\xe2\xfa\xb4\xe0\x02\0\x02\0\x01\x12Atlantic/St_Helena\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x10Atlantic/Stanley\0\x9e\x0f\x14\0\xafe\x90\x03\x04\x01\x1e\x07p\x04\x04\x01\x1e\x15\x80\x04\x04\x01\x1e#\x90\x04\x04\x01'A\xf0\x04\x04\x010|p\x04\x14\0\xb8\xa0\x10\x03\x14\0\xc1\xda\x90\x03\x14\0\xb8\xa0\x10\x02\x14\0\xc1\xbep\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x04\0\xb8\xa0\x10\x03\x04\x01\x1e\x07p\x03\x04\x01'A\xf0\x03$\0\0\0\x0e\x92\x85\xb5`\x03\x009\n\x0e\t\f\b\r\x06\x02\x07\x01\x07\x01\x07\x01\x07\x04\x06\x04\x07\x01\x07\x01\x07\x01\x07\x01\x07\x04\x07\x01\x07\x01\x07\x01\x07\x01\x07\x03\x06\x05\0\x05\x06\x04\x06\x04\x06\x04\x06\x04\x06\x05\x06\x04\x06\x04\v\rAustralia/ACT\x01\r\x14\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xd4A\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x14\xdb\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\x8a\n\x13\0\x12\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x06\x0e\x01\x11\x01\x11\x01\x11\x03\x0f\x04\x10\x04\x10\x03\x10\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x05\x0e\x05\x0e\x05\x0e\x05\x0f\x04\v\t\x0f\x05\x0e\x05\x0e\x05\x0f\x04\x0f\x05\x0e\x04\x0f\x06\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\b\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x12Australia/Adelaide\x01\x13\x12\x0e\0\x9c\xe2\x80\t\x1e\x0e\0\xa6\x1d\0\t\x1e\x0e\0\xafW\x80\t\x1e\x0e\0\xb8\x92\0\t\x1e\x0e\0\xc1\xcc\x80\t\x1e\x0e\0\xcb\x07\0\t\x1e\x0e\0\xd4A\x80\t\x1e\x0e\0\xef\xf1\0\t\x1e\x0e\0\xf9+\x80\t\x1e~\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x1e\0\xef\xf1\0\n\x1e\x1e\0\xf9+\x80\n\x1e\x1e\x01\x14\xdb\0\n\x1e\x1e\x01\x1e\x15\x80\n\x1e\x1e\x01'P\0\n\x1e\x1e\x019\xc5\0\n\x1e\x1e\x01B\xff\x80\n\x1e>\0\0\0\x0e|\xe3\xf7\xa8\n\x1e\0\x8a\t\x11\0\x10\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x03\r\x04\x0e\x04\x0e\x03\x0e\x03\x0e\x01\x0f\x04\r\x02\x0f\x03\x0e\x04\r\x05\f\x05\f\x05\f\x05\r\x04\r\x04\r\x05\f\x05\f\x05\r\x04\r\x05\f\x04\r\x06\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\b\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x12Australia/Brisbane\x008\x06\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\x019\xc5\0\v\x1c!<\xb1\0\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\t\x02\x05\0\x04\x01\x03\x01\x03\x01\x15Australia/Broken_Hill\x01\x13\x12\x0e\0\x9c\xe2\x80\t\x1e\x0e\0\xa6\x1d\0\t\x1e\x0e\0\xafW\x80\t\x1e\x0e\0\xb8\x92\0\t\x1e\x0e\0\xc1\xcc\x80\t\x1e\x0e\0\xcb\x07\0\t\x1e\x0e\0\xd4A\x80\t\x1e\x0e\0\xef\xf1\0\t\x1e\x0e\0\xf9+\x80\t\x1e~\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x1e\0\xef\xf1\0\n\x1e\x1e\0\xf9+\x80\n\x1e\x1e\x01\x14\xdb\0\n\x1e\x1e\x01\x1e\x15\x80\n\x1e\x1e\x01'P\0\n\x1e\x1e\x019\xc5\0\n\x1e\x1e\x01B\xff\x80\n\x1e>\0\0\0\x0e|\xe3\xf7\xa8\n\x1e\0\x8a\t\x11\0\x10\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x06\f\x01\x0f\x01\x0f\x01\x0f\x03\r\x04\x0e\x04\x0e\x03\x0e\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x05\f\x05\f\x05\f\x05\r\x04\r\x04\r\x05\f\x05\f\x05\r\x04\r\x05\f\x04\r\x06\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\b\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x12Australia/Canberra\x01\r\x14\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xd4A\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x14\xdb\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\x8a\n\x13\0\x12\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x06\x0e\x01\x11\x01\x11\x01\x11\x03\x0f\x04\x10\x04\x10\x03\x10\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x05\x0e\x05\x0e\x05\x0e\x05\x0f\x04\v\t\x0f\x05\x0e\x05\x0e\x05\x0f\x04\x0f\x05\x0e\x04\x0f\x06\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\b\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x10Australia/Currie\x01\x16\x15\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x02f\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x010\x8a\x80\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\vl\xff\xff\xff\xf1\x86\x8cH\xe0\n\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xe6\xb6\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n,\0\0\0\x0ey\xcaI\xa0\n\0\x8d\t\x14\x06\r\x06\n\b\v\x07\v\x07\v\x07\f\x07\v\x07\v\x07\v\x07\v\x07\v\x07\x0f\x04\x0e\x04\v\x07\v\x07\v\x06\x0e\x05\x0e\x05\r\x05\r\x05\x0f\x02\x10\x02\x10\x02\x10\x02\x10\x02\x11\x02\x10\x02\x10\x02\x10\x02\x10\0\x13\x03\x10\x02\x10\x02\x10\x02\x10\x02\x11\x01\x10\x03\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x12\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x10Australia/Darwin\0a\v\x1e\0\xef\xf1\0\n\x1e\x1e\0\xf9+\x80\n\x1e\x1e!<\xc6\x18\n\x1e\x1e.\x98\x84\0\n\x1el\xff\xff\xff\xf1\x86\x8cH\xe0\t\x0e\0ml\x80\t\x1e\x0e\0r\xb2\x80\t\x1e\x0e\0\xe6\xb6\x80\t\x1e\x0e\0\xef\xf1\0\t\x1e\x0e\x07\xfbq\x18\t\x1e,\0\0\0\r\xec\x8aIx\t\0\v\x04\n\t\x02\x05\x03\x06\0\b\x01\x07\x0fAustralia/Eucla\0e\v\x0e\0\x8am\x80\b-\x0e\0\x93\xa8\0\b-\x0e\0\xa6\x1d\0\b-\x0e\0\xcb\x07\0\b-~\xff\xff\xff\xf1\x86\x8cH\xe0\t-\x1e\x01\x14\xdb\0\t-\x1e\x01\x1e\x15\x80\t-\x1e\x0e}\xdd\0\t-\x1e\x10KJ\0\t-\x1e\x1b\xc1\xf5\0\t->\0\0\0\x0e\x82\x83\xa84\t-\0\r\x04\n\x02\b\x02\x07\0\t\x01\x06\x03\x05\x03\x10Australia/Hobart\x01\x16\x15\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x02f\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x010\x8a\x80\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\vl\xff\xff\xff\xf1\x86\x8cH\xe0\n\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xe6\xb6\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n,\0\0\0\x0ey\xcaI\xa0\n\0\x8d\t\x14\x06\r\x06\n\b\v\x07\v\x07\v\x07\f\x07\v\x07\v\x07\v\x07\v\x07\v\x07\x0f\x04\x0e\x04\v\x07\v\x07\v\x06\x0e\x05\x0e\x05\r\x05\r\x05\x0f\x02\x10\x02\x10\x02\x10\x02\x10\x02\x11\x02\x10\x02\x10\x02\x10\x02\x10\0\x13\x03\x10\x02\x10\x02\x10\x02\x10\x02\x11\x01\x10\x03\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x12\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\rAustralia/LHI\x01\x1b\x17\x1c\0\xcb\x0e\b\v\x1c\0\xef\xf8\b\v\x1c\0\xf92\x88\v\x1c\x01\x14\xe2\b\v\x1c\x01\x1e\x1c\x88\v\x1c\x01'W\b\v\x1c\x019\xcc\b\v\x1c\x019\xd3\x10\v\x1e\x019\xd3\x10\v\x1e\x1e\x019\xda\x18\v\x1en\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x0e\0\xa6\x0e\xf0\n\x1e\x0e\0\xa6\x15\xf8\n\x1e\x0e\0\xafIp\n\x1e\x0e\0\xafPx\n\x1e\x0e\0\xb8\x8a\xf8\n\x1e\x0e\0\xc1\xc5x\n\x1e\x0e\0\xca\xff\xf8\n\x1e\x0e\0\xd4:x\n\x1e\x0e\0\xef\xe9\xf8\n\x1e\x0e\0\xf9$x\n\x1e\x0e\x01\x14\xd3\xf8\n\x1e.\0\0\0\x0e\x8er\x1e\0\n\x1e\0w\n\x16\t\r\b\v\b\v\b\v\x07\x0f\x04\x10\x05\x10\x05\x0f\x05\f\x06\f\x06\f\x06\x0e\x06\f\x06\f\x06\x11\x03\x11\x03\x11\x03\x11\x04\x10\0\x15\x04\x11\x03\x11\x03\x11\x04\x10\x04\x11\x03\x10\x04\x12\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x13\x01\x14\x01\x13\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x12Australia/Lindeman\0B\x07\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\x019\xc5\0\v\x1c!<\xb1\0\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\r\x03\x06\0\x05\x01\x04\x01\x04\x01\x04\x02\x04\x01\x13Australia/Lord_Howe\x01\x1b\x17\x1c\0\xcb\x0e\b\v\x1c\0\xef\xf8\b\v\x1c\0\xf92\x88\v\x1c\x01\x14\xe2\b\v\x1c\x01\x1e\x1c\x88\v\x1c\x01'W\b\v\x1c\x019\xcc\b\v\x1c\x019\xd3\x10\v\x1e\x019\xd3\x10\v\x1e\x1e\x019\xda\x18\v\x1en\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x0e\0\xa6\x0e\xf0\n\x1e\x0e\0\xa6\x15\xf8\n\x1e\x0e\0\xafIp\n\x1e\x0e\0\xafPx\n\x1e\x0e\0\xb8\x8a\xf8\n\x1e\x0e\0\xc1\xc5x\n\x1e\x0e\0\xca\xff\xf8\n\x1e\x0e\0\xd4:x\n\x1e\x0e\0\xef\xe9\xf8\n\x1e\x0e\0\xf9$x\n\x1e\x0e\x01\x14\xd3\xf8\n\x1e.\0\0\0\x0e\x8er\x1e\0\n\x1e\0w\n\x16\t\r\b\v\b\v\b\v\x07\x0f\x04\x10\x05\x10\x05\x0f\x05\f\x06\f\x06\f\x06\x0e\x06\f\x06\f\x06\x11\x03\x11\x03\x11\x03\x11\x04\x10\0\x15\x04\x11\x03\x11\x03\x11\x04\x10\x04\x11\x03\x10\x04\x12\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x13\x01\x14\x01\x13\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x13\x01\x13\x02\x13\x01\x13\x01\x13\x01\x13\x01\x13Australia/Melbourne\x01\r\x14\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xd4A\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x14\xdb\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\x8a\n\x13\0\x12\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x03\x0f\x04\x0f\x05\x10\x03\x10\x03\x10\x01\x11\x01\x11\x02\x11\x01\x11\x04\x0f\x05\x0e\x05\x0e\x05\x0e\x05\x0f\x04\v\t\x0f\x05\x0e\x05\x0e\x05\x0f\x04\x0f\x05\x0e\x04\x0f\x06\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\b\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\rAustralia/NSW\x01\r\x14\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xd4A\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x14\xdb\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\x8a\n\x13\0\x12\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x06\x0e\x01\x11\x01\x11\x01\x11\x03\x0f\x04\x10\x04\x10\x03\x10\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x05\x0e\x05\x0e\x05\x0e\x05\x0f\x04\v\t\x0f\x05\x0e\x05\x0e\x05\x0f\x04\x0f\x05\x0e\x04\x0f\x06\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\b\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x0fAustralia/North\0a\v\x1e\0\xef\xf1\0\n\x1e\x1e\0\xf9+\x80\n\x1e\x1e!<\xc6\x18\n\x1e\x1e.\x98\x84\0\n\x1el\xff\xff\xff\xf1\x86\x8cH\xe0\t\x0e\0ml\x80\t\x1e\x0e\0r\xb2\x80\t\x1e\x0e\0\xe6\xb6\x80\t\x1e\x0e\0\xef\xf1\0\t\x1e\x0e\x07\xfbq\x18\t\x1e,\0\0\0\r\xec\x8aIx\t\0\v\x04\n\t\x02\x05\x03\x06\0\b\x01\x07\x0fAustralia/Perth\0Z\v\f\0\x8am\x80\b\f\0\x93\xa8\0\b\f\0\xa6\x1d\0\b\f\0\xcb\x07\0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xdb\0\t\x1c\x01\x1e\x15\x80\t\x1c\x0e}\xdd\0\t\x1c\x10KJ\0\t\x1c\x1b\xc1\xf5\0\t<\0\0\0\x0e\x82\x83\xb2\xc0\t\0\r\x04\n\x02\b\x02\x07\0\t\x01\x06\x03\x05\x03\x14Australia/Queensland\x008\x06\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\x019\xc5\0\v\x1c!<\xb1\0\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\t\x02\x05\0\x04\x01\x03\x01\x03\x01\x0fAustralia/South\x01\x13\x12\x0e\0\x9c\xe2\x80\t\x1e\x0e\0\xa6\x1d\0\t\x1e\x0e\0\xafW\x80\t\x1e\x0e\0\xb8\x92\0\t\x1e\x0e\0\xc1\xcc\x80\t\x1e\x0e\0\xcb\x07\0\t\x1e\x0e\0\xd4A\x80\t\x1e\x0e\0\xef\xf1\0\t\x1e\x0e\0\xf9+\x80\t\x1e~\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x1e\0\xef\xf1\0\n\x1e\x1e\0\xf9+\x80\n\x1e\x1e\x01\x14\xdb\0\n\x1e\x1e\x01\x1e\x15\x80\n\x1e\x1e\x01'P\0\n\x1e\x1e\x019\xc5\0\n\x1e\x1e\x01B\xff\x80\n\x1e>\0\0\0\x0e|\xe3\xf7\xa8\n\x1e\0\x8a\t\x11\0\x10\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x03\r\x04\x0e\x04\x0e\x03\x0e\x03\x0e\x01\x0f\x04\r\x02\x0f\x03\x0e\x04\r\x05\f\x05\f\x05\f\x05\r\x04\r\x04\r\x05\f\x05\f\x05\r\x04\r\x05\f\x04\r\x06\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\b\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x10Australia/Sydney\x01\r\x14\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xd4A\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x14\xdb\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\x8a\n\x13\0\x12\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x06\x0e\x01\x11\x01\x11\x01\x11\x03\x0f\x04\x10\x04\x10\x03\x10\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x05\x0e\x05\x0e\x05\x0e\x05\x0f\x04\v\t\x0f\x05\x0e\x05\x0e\x05\x0f\x04\x0f\x05\x0e\x04\x0f\x06\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\b\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x12Australia/Tasmania\x01\x16\x15\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x02f\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x010\x8a\x80\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\vl\xff\xff\xff\xf1\x86\x8cH\xe0\n\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xe6\xb6\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n,\0\0\0\x0ey\xcaI\xa0\n\0\x8d\t\x14\x06\r\x06\n\b\v\x07\v\x07\v\x07\f\x07\v\x07\v\x07\v\x07\v\x07\v\x07\x0f\x04\x0e\x04\v\x07\v\x07\v\x06\x0e\x05\x0e\x05\r\x05\r\x05\x0f\x02\x10\x02\x10\x02\x10\x02\x10\x02\x11\x02\x10\x02\x10\x02\x10\x02\x10\0\x13\x03\x10\x02\x10\x02\x10\x02\x10\x02\x11\x01\x10\x03\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x12\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x12Australia/Victoria\x01\r\x14\f\0\x9c\xe2\x80\n\f\0\xa6\x1d\0\n\f\0\xafW\x80\n\f\0\xb8\x92\0\n\f\0\xc1\xcc\x80\n\f\0\xcb\x07\0\n\f\0\xd4A\x80\n\f\0\xef\xf1\0\n\f\0\xf9+\x80\n\f\x01\x14\xdb\0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\0\xcb\x07\0\v\x1c\0\xef\xf1\0\v\x1c\0\xf9+\x80\v\x1c\x01\x14\xdb\0\v\x1c\x01\x1e\x15\x80\v\x1c\x01'P\0\v\x1c\x019\xc5\0\v\x1c\x01B\xff\x80\v<\0\0\0\x0e|\xe3\xf0\xa0\v\0\x8a\n\x13\0\x12\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x01\x11\x01\x11\x02\x11\x01\x11\x01\x11\x01\x11\x03\x0f\x04\x0f\x05\x10\x03\x10\x03\x10\x01\x11\x01\x11\x02\x11\x01\x11\x04\x0f\x05\x0e\x05\x0e\x05\x0e\x05\x0f\x04\v\t\x0f\x05\x0e\x05\x0e\x05\x0f\x04\x0f\x05\x0e\x04\x0f\x06\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\b\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x07\f\x07\r\x07\f\x07\f\x07\f\x07\f\x0eAustralia/West\0Z\v\f\0\x8am\x80\b\f\0\x93\xa8\0\b\f\0\xa6\x1d\0\b\f\0\xcb\x07\0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xdb\0\t\x1c\x01\x1e\x15\x80\t\x1c\x0e}\xdd\0\t\x1c\x10KJ\0\t\x1c\x1b\xc1\xf5\0\t<\0\0\0\x0e\x82\x83\xb2\xc0\t\0\r\x04\n\x02\b\x02\x07\0\t\x01\x06\x03\x05\x03\x14Australia/Yancowinna\x01\x13\x12\x0e\0\x9c\xe2\x80\t\x1e\x0e\0\xa6\x1d\0\t\x1e\x0e\0\xafW\x80\t\x1e\x0e\0\xb8\x92\0\t\x1e\x0e\0\xc1\xcc\x80\t\x1e\x0e\0\xcb\x07\0\t\x1e\x0e\0\xd4A\x80\t\x1e\x0e\0\xef\xf1\0\t\x1e\x0e\0\xf9+\x80\t\x1e~\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x1e\0\xef\xf1\0\n\x1e\x1e\0\xf9+\x80\n\x1e\x1e\x01\x14\xdb\0\n\x1e\x1e\x01\x1e\x15\x80\n\x1e\x1e\x01'P\0\n\x1e\x1e\x019\xc5\0\n\x1e\x1e\x01B\xff\x80\n\x1e>\0\0\0\x0e|\xe3\xf7\xa8\n\x1e\0\x8a\t\x11\0\x10\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x01\x0f\x06\f\x01\x0f\x01\x0f\x01\x0f\x03\r\x04\x0e\x04\x0e\x03\x0e\x01\x0f\x01\x0f\x01\x0f\x02\x0f\x01\x0f\x01\x0f\x05\f\x05\f\x05\f\x05\r\x04\r\x04\r\x05\f\x05\f\x05\r\x04\r\x05\f\x04\r\x06\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\b\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\x07\n\x07\v\x07\n\x07\n\x07\n\x07\n\vBrazil/Acre\0J\t\x04\0\x8a_p\x05\x04\0\x93\x99\xf0\x05\x04\0\xafIp\x05\x04\n\x1e\x85p\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\x01'^\x10\x04\x14\x01M\x99\x90\x04\x04&T\x9a\x90\x044\0\0\0\x0e\x97=ap\x04\0\t\x04\b\x02\x05\x01\x06\0\x07\x03\x10Brazil/DeNoronha\0v\x0f\x04\0\t,p\x02\x04\0\x8a_p\x02\x04\0\x93\x99\xf0\x02\x04\0\x9c\xd4p\x02\x04\0\xa6\x0e\xf0\x02\x04\0\xafIp\x02\x04\0\xc1\xbep\x02t\xff\xff\xff\xf1\x86\x8cH\xe0\x01\x14\x01'^\x10\x01\x14\x01LH\x10\x01\x14\x01M\x99\x90\x01\x14\x01U\x82\x90\x01\x14\x01\xdf\xf0\x10\x01\x14\x12!\xff\x90\x014\0\0\0\x0e\x97=7@\x01\0\x11\x07\x0e\x05\b\x02\n\x01\t\x01\v\x03\r\x06\b\0\f\x04\vBrazil/East\0\xc8\x14\x04\0\x81$\xf0\x03\x04\0\x8a_p\x03\x04\0\x90\xf6\xf0\x03\x04\0\x93\x99\xf0\x03\x04\0\x9c\xd4p\x03\x04\0\xa6\x0e\xf0\x03\x04\0\xafIp\x03\x04\0\xc0l\xf0\x03\x04\0\xc1\xbep\x03t\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x14\x01'^\x10\x02\x14\x010\x98\x90\x02\x14\x011\xea\x10\x02\x14\x019\xd3\x10\x02\x14\x01C\r\x90\x02\x14\x01LH\x10\x02\x14\x01M\x99\x90\x02\x14\x01U\x82\x90\x02\x14\x01X%\x90\x024\0\0\0\x0e\x97=EP\x02\0E\t\x13\x06\n\x03\x10\x01\x0f\x01\x11\x04\x0f\x04\x0e\x03\x11\0\x11\x05\r\x05\r\x04\r\x06\f\x07\n\x06\n\b\n\x06\r\x05\x11\x01\x0e\x04\x12\x02\r\x05\x11\x03\v\x05\x0e\x04\x0e\x05\r\x05\r\x06\r\x04\x0e\x04\x0e\x05\r\x05\r\x05\r\x05\x11\x01\vBrazil/West\0J\t\x04\0\x8a_p\x04\x04\0\x93\x99\xf0\x04\x04\0\xa6\x0e\xf0\x04\x04\0\xafIp\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\x01'^\x10\x03\x14\x01M\x99\x90\x03\x14\n\xb4\xec\x90\x034\0\0\0\x0e\x97=S`\x03\0\t\x04\b\x03\x05\x01\x06\0\x07\x02\x03CET\0\xcc\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x87\x18\x1a\xb0\x02\0\x7f\x05\n\0\t\x01\b\x01\t\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x07CST6CDT\0\xfe\x11\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x054\0\0\0\x0ez\v\xc4 \x05\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x0fCanada/Atlantic\0\xe6\r\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x019\xb6\xf0\x04t\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xe6\xc4\x90\x03\x14\0\xef\xff\x10\x034\0\0\0\x0ez\v\xa8\0\x03\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0eCanada/Central\0\xec\x0e\x04\0\xef\xf1\0\x06\x04\0\xf9+\x80\x06\x04\x01\v\xa0\x80\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x07\0\x05\x14\0\xd4A\x80\x05\x14\0\xe6\xb6\x80\x05\x14\0\xef\xf1\0\x054\0\0\0\x0ez\v\xc4 \x05\0\x8d\x06\r\0\f\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\f\0\f\x01\v\x01\f\0\f\0\f\0\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x02\n\x04\t\x04\t\x04\n\x02\n\x02\n\x04\t\x04\t\x03\b\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x07\x05\x07\x05\x07\x05\x07\x05\b\x05\x07\x05\x0eCanada/Eastern\0\xe6\r\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x05\f\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x0fCanada/Mountain\0\xe2\r\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0e}\xd4\xd0\xb0\x06\0\x89\x05\f\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x13Canada/Newfoundland\x01\x16\x12\x06\0\xef\xe2\xf0\x03\x1e\x06\0\xf9\x1dp\x03\x1e\x06\x01\v\x92p\x03\x1e\x06\x01\x14\xbe\xe0\x03\x1e\x06\x01\x14\xcc\xf0\x03\x1e\x06\x019\xb6\xf0\x03\x1e\x06\x019\xd2\xd4\x03\x1ev\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x16\0\xa6+\x10\x02\x1e\x16\0\xafe\x90\x02\x1e\x16\0\xcb\x15\x10\x02\x1e\x16\0\xcb# \x02\x1e\x16\0\xd43\xac\x02\x1e\x16\0\xd4O\x90\x02\x1e\x16\0\xd4O\x90\x01\x1e\x16\0\xe6\xc4\x90\x02\x1e\x16\0\xef\xff\x10\x02\x1e6\0\0\0\x0ez\v\xa0\xf8\x02\x1e\0\x8d\x07\x11\0\x10\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\f\x02\x0e\x03\v\x04\n\x04\r\x02\r\x02\r\x04\n\x04\n\x04\r\x02\r\x02\r\x02\r\x04\n\x04\n\x04\r\x02\r\x02\r\x04\n\x04\n\x04\t\x05\b\x05\b\x05\t\x05\b\x06\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\x0eCanada/Pacific\0\xd2\x0e\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x07\x04\x019\xb6\xf0\x074\0\0\0\x0ez\v\xe0@\x07\0s\x05\r\0\v\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\f\x13Canada/Saskatchewan\0\xb9\x14\x14\0\x9e^0\x06\x14\0\xef\xff\x10\x06\x14\0\xf99\x90\x06\x14\x01\x02t\x10\x06\x14\x01\x14\xe9\x10\x06\x14\x01\x1e#\x90\x06\x14\x02\xf4\xcb\x10\x06\x14\x04\xb8\xfd\x90\x06\x14\x06\x9a\xe7\xe0\x06\x14\x15\xaaHp\x06\x14\x17\xbb\x1ct\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0=#\x90\x07\x04\0\xc1\xbep\x07\x04\0\xca\xf8\xf0\x07\x04\0\xe6\xa8p\x07\x04\0\xef\xe2\xf0\x07\x04\0\xef\xff\x10\x06\x04\x01\x02W\xf0\x07$\0\0\0\x0e\0qJ<\x07\x006\v\x13\n\x12\t\x0e\x04\x0e\x04\x0e\x05\r\x05\x0e\x07\x10\x01\x0f\x02\x10\x02\x10\x01\x10\0\b\f\x03\x10\x03\x0e\x04\x0e\x04\x0e\x05\r\x05\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x05\x0e\x04\x0e\x06\x10\x11\fCanada/Yukon\0\xb2\x0e\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x07\x04\x019\x9a\xd0\x074\0\0\0\x0e\x8c\xdd)@\x07\0S\x05\r\0\v\0\v\x01\n\x01\v\0\v\0\v\0\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x02\t\x03\b\x03\b\x03\t\x02\t\x02\t\x03\b\x03\b\x03\x07\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x04\x06\x04\x06\x04\x06\x04\x06\f\x11Chile/Continental\x01J\x1e\x14\0x\x06\x90\x03\x14\0\x8a{\x90\x03\x14\0\xa6+\x10\x03\x14\0\xafe\x90\x03\x14\0\xc1\xda\x90\x03\x14\0\xcb\x15\x10\x03\x14\0\xd4O\x90\x03\x14\0\xef\xff\x10\x03\x14\0\xf99\x90\x03\x14\x01\x02t\x10\x03\x14\x01\v\xae\x90\x03\x14\x01\x14\xe9\x10\x03\x14\x01\x1e#\x90\x03d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x04\0\xc1\xbep\x04\x04\0\xca\xf8\xf0\x04\x04\0\xd43p\x04\x04\0\xddm\xf0\x04\x04\0\xe6\xa8p\x04\x04\0\xef\xe2\xf0\x04\x04\0\xf9\x1dp\x04\x04\x01\v\x92p\x04\x04\x01\x14\xcc\xf0\x04\x04\x01\x1e\x07p\x04\x04\x010|p\x04\x04\x019\xb6\xf0\x04\x04\x01L+\xf0\x04\x04\x01g\xdbp\x04\x04\x03,\r\xf0\x04$\0\0\0\x0ey\xe6\x93\xd0\x04\0\x8b\r\x1d\t\x0f\v\x0f\f\x0e\n\x10\f\x0e\f\x0f\v\x0f\v\x0f\f\x0e\f\x0e\f\x0f\v\x0f\v\x0f\v\x0f\f\x0e\f\x0e\f\x13\x07\x0f\v\x0f\f\x0e\b\x12\f\x0f\v\x0f\v\x0f\v\x0f\f\x0e\f\x11\t\x0f\t\x14\b\x0f\f\x0e\f\x0e\f\x0e\f\x0f\v\x0f\v\x0f\f\x0e\f\x11\t\x0f\v\x12\b\x16\x01\x1a\x02\x19\x03\x18\x03\x1c\0\x1b\0\x1b\0\x19\x05\x16\x05\x16\x05\x16\x06\x15\x05\x17\x05\x16\x05\x16\x05\x16\x05\x16\x05\x17\x04\x17\x05\x16\x05\x16\x05\x16\x05\x16\x05\x17\x04\x17\x05\x16\x05\x16\x05\x16\x05\x12Chile/EasterIsland\x01h#\x14\0x\x06\x90\x05\x14\0\x8a{\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xc1\xda\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xef\xff\x10\x05\x14\0\xf99\x90\x05\x14\x01\x02t\x10\x06\x14\x01\x02t\x10\x05\x14\x01\v\xae\x90\x06\x14\x01\x14\xe9\x10\x06\x14\x01\x14\xe9\x10\x05\x14\x01\x1e#\x90\x06\x14\x01\x1e#\x90\x05d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0\xc1\xbep\x07\x04\0\xc1\xbep\x06\x04\0\xca\xf8\xf0\x07\x04\0\xca\xf8\xf0\x06\x04\0\xd43p\x07\x04\0\xddm\xf0\x06\x04\0\xe6\xa8p\x06\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x1e\x07p\x06\x04\x010|p\x06\x04\x019\xb6\xf0\x06\x04\x01L+\xf0\x06\x04\x01g\xdbp\x06\x04\x03,\r\xf0\x06$\0\0\0\x0ey\xe6\x93\xd0\x07\0\x8b\x10\"\t\x13\f\x13\x0e\x11\v\x15\x0e\x11\x0e\x13\f\x13\f\x13\x0e\x11\x0e\x11\x0e\x13\f\x14\r\x14\r\x14\x0f\x12\x0f\x12\x0f\x18\x07\x14\r\x14\x0f\x12\b\x17\x0f\x14\r\x14\r\x14\r\x14\x0f\x12\x0f\x16\n\x14\n\x19\b\x14\x0f\x12\x0f\x12\x0f\x12\x0f\x14\r\x14\r\x14\x0f\x12\x0f\x16\n\x14\r\x17\b\x1b\x01\x1f\x02\x1e\x03\x1d\x03!\0 \0 \0\x1e\x05\x1b\x05\x1b\x05\x1b\x06\x1a\x05\x1c\x05\x1b\x05\x1b\x05\x1b\x05\x1b\x05\x1c\x04\x1c\x05\x1b\x05\x1b\x05\x1b\x05\x1b\x05\x1c\x04\x1c\x05\x1b\x05\x1b\x05\x1b\x05\x04Cuba\x01r%\x04\0\xca\xf8\xf0\x05\x04\0\xd43p\x05\x04\0\xd5\x84\xf0\x05\x04\0\xd6\xd6p\x05\x04\0\xef\xe2\xf0\x05\x04\0\xef\xf1\0\x05\x04\0\xf9\x1dp\x05\x04\0\xf9+\x80\x05\x04\x01\x02W\xf0\x05\x04\x01\v\x92p\x05\x04\x01\v\xa0\x80\x05\x04\x01\x14\xcc\xf0\x05\x04\x01\x14\xdb\0\x05\x04\x01\x1e\x15\x80\x05\x04\x01'P\0\x05\x04\x010\x8a\x80\x05\x04\x019\xc5\0\x05\x04\x04\xdd\xd9\x80\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6\x1d\0\x04\x14\0\xafW\x80\x04\x14\0\xb8\x92\0\x04\x14\0\xcb\x07\0\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4A\x80\x04\x14\0\xd4O\x90\x04\x14\0\xdd|\0\x04\x14\0\xe6\xb6\x80\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xf1\0\x04\x14\0\xef\xff\x10\x04\x14\0\xf99\x90\x04\x14\x01\t\v\x90\x04\x14\x01\n]\x10\x04\x14\x01\v\xae\x90\x04\x14\x01\x14\xe9\x10\x044\0\0\0\x0ez\v\x99\xf0\x04\0\x89\x12$\x04\x1e\x06\x1e\x01\"\x02!\x03 \x04\x1e\x06\x1c\x06\x1f\0\x19\v\x17\v#\0#\0#\0#\x01\"\x01\x17\v\x17\v\x19\t\x19\t\x1c\b\x1c\x07\x1b\x07\x1b\x07\x1b\x07\x1b\x07\x1d\x05\x1d\x07\x1a\f\x16\r\x16\f\x16\f\x18\n\x18\n\x16\x11\x14\x0f\x15\x0e\x14\x0f\x15\x0f\x15\x10\x15\r\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x13\x10\x13\x10\x13\x10\x13\x10\x14\x10\x13\x10\x03EET\x01\f\x15\f\0\xe6\xc4\x90\x02\f\0\xe8\b\0\x02\f\0\xed?\xf0\x02\f\0\xee/\0\x02\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\f\x01,\x96\0\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xb4\xb9\xa0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xe6\xb6\x80\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf0)@\x03\x1c\0\xf3\xd7p\x03\x1c\0\xf7\xda\0\x03\x1c\0\xf9+\x80\x03\x1c\0\xf9\x7f\xe0\x03<\0\0\0\x0e\x83`\x15\x80\x03\0\x83\t\x14\b\n\x04\r\x01\x11\0\x13\x03\x10\x02\x0f\x04\x0e\x04\x0e\x04\x0e\x05\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x05\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x12\x06\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\x03EST\0$\x03g\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x13$\x04\"m;\xd8\x05'\0\0\0\r\xe2\xfa\xdd0\x05\x13$\0\x03\0\x02\x01\x07EST5EDT\0\xfe\x11\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01B\xf1p\x05\x04\x01\x83\x8a\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\\W\x10\x04\x14\0\x9c\xf0\x90\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x05Egypt\x01R\"\f\0\x1b\xa1p\x02\f\x007P\xf0\x02\f\0I\xc5\xf0\x02\f\0Y\xb4\x10\x02\f\0j\xd7\x90\x02\f\0\x87\xbcp\x02\f\0\x9c\xd4p\x02\f\0\xa6\x0e\xf0\x02\f\0\xafIp\x02\f\0\xc1\xbep\x02\f\0\xc3,\x10\x02\f\0\xc9\xc3\x90\x02\f\0\xca\xf8\xf0\x02\f\0\xef\xe2\xf0\x02\f\0\xf9\x1dp\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0'\x9b\x10\x03\x1c\0.2\x90\x03\x1c\0\xe6\xc4\x90\x03\x1c\0\xef\xff\x10\x03\x1c\x01\x13m`\x03\x1c\x01\x14\xe9\x10\x03\x1c\x01\x17o\xf0\x03\x1c\x01\x18\xc1p\x03\x1c\x01\x1e\x07p\x03\x1c\x01\x1e#\x90\x03\x1c\x010\x98\x90\x03\x1c\x019\xd3\x10\x03\x1c\x01LH\x10\x03\x1c\x01v[\xf0\x03\x1c\x01\x87\x7fp\x03\x1c\x06\xd0>\x90\x03\x1c\x10&n\x10\x03<\0\0\0\x0ez\x11\xdd\x10\x03\0{\x0f!\v\x16\v\x17\v\x16\v\x16\v\x16\v\x17\v\x16\v\x16\v\x16\v\x17\v\x16\v\x1e\x03\x1d\x04\x17\v\x16\v\x16\v\x16\v\x17\v\x18\n\x16\v\x16\v\x17\v\x16\v\x16\v\x14\f\x15\f\x15\f\x15\f\x19\f\x15\f\x15\f\x15\f\x15\f\x19\f\x15\f\x15\t\x19\b\x1a\x07\x1b\x06\x1c\x05\x10\0\x1f\x01\x11\x02 \r\x13\x0e\x12\x0e\x12\x0e\x13\r\x13\r\x13\r\x13\x0e\x12\x0e\x13\r\x13\r\x13\r\x13\r\x13\x0e\x12\x0e\x13\r\x13\r\x04Eire\0\xcc\nx\xff\xff\xff\xf1\x86\x8cH\xe0\x18\x01\x14\xdb\0\x18\x01\x1e\x15\x80\x18\x01'P\0\f\0\xb8\x92\0\x01\f\0\xc1\xcc\x80\x01\f\0\xca\xf8\xf0\x01\f\0\xcb\x07\0\x01\f\0\xd4A\x80\x018\0\0\0\x0e|\xe4}@\0\x8a\0\t\x04\x03\x04\x03\x04\x03\x04\x03\x05\x02\x05\x02\x05\x03\x04\x03\x04\x03\x06\x01\x07\x01\x07\x01\x07\x02\x07\x01\x07\x01\x07\x01\x07\x01\x07\x02\x05\x02\x07\x01\x07\x01\x07\x01\x07\x01\x07\x01\b\x01\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x07Etc/GMT\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\tEtc/GMT+0\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\tEtc/GMT+1\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x01\0\x01\0\nEtc/GMT+10\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\n\0\x01\0\nEtc/GMT+11\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\v\0\x01\0\nEtc/GMT+12\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\f\0\x01\0\tEtc/GMT+2\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x02\0\x01\0\tEtc/GMT+3\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x03\0\x01\0\tEtc/GMT+4\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x04\0\x01\0\tEtc/GMT+5\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x05\0\x01\0\tEtc/GMT+6\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x06\0\x01\0\tEtc/GMT+7\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\x07\0\x01\0\tEtc/GMT+8\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\b\0\x01\0\tEtc/GMT+9\0\x0e\x01l\xff\xff\xff\xf1\x86\x8cH\xe0\t\0\x01\0\tEtc/GMT-0\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\tEtc/GMT-1\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x01\0\x01\0\nEtc/GMT-10\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\n\0\x01\0\nEtc/GMT-11\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\v\0\x01\0\nEtc/GMT-12\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\f\0\x01\0\nEtc/GMT-13\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\r\0\x01\0\nEtc/GMT-14\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x0e\0\x01\0\tEtc/GMT-2\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x02\0\x01\0\tEtc/GMT-3\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x03\0\x01\0\tEtc/GMT-4\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x04\0\x01\0\tEtc/GMT-5\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x05\0\x01\0\tEtc/GMT-6\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x06\0\x01\0\tEtc/GMT-7\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\0\x01\0\tEtc/GMT-8\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\b\0\x01\0\tEtc/GMT-9\0\x0e\x01d\xff\xff\xff\xf1\x86\x8cH\xe0\t\0\x01\0\bEtc/GMT0\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\rEtc/Greenwich\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x07Etc/UCT\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x07Etc/UTC\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\rEtc/Universal\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\bEtc/Zulu\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x10Europe/Amsterdam\0\xcc\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x87\x18\x1a\xb0\x02\0\x7f\x05\n\0\t\x01\b\x01\t\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x0eEurope/Andorra\0\xb6\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x96 e0\x02\0o\x04\t\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x10Europe/Astrakhan\0\xc8\x15\x1c\0\xc1\xcc\x80\x04\f\0\xc1\xcc\x80\x04\x1c\0\xcb\x07\0\x04\f\0\xef\xf1\0\x03\f\0\xef\xff\x10\x03\f\0\xf9+\x80\x03\f\x01\x14\xdb\0\x03\f\x01\x1e\x15\x80\x03\f\x06\xbd\xadp\x03\x1c\0\xef\xf1\0\x04\x1c\0\xf9+\x80\x04\x1c\x01\xdf\xd3\xf0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\x02\xaa\xf7\x10\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0?\x10\x14\x0e\x12\x0e\x12\x0e\x13\r\x11\f\x11\f\x11\f\x11\f\t\x04\t\x05\f\v\x04\t\x03\t\x03\t\x03\n\x06\x02\x06\x02\x06\x02\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\0\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\x01\b\x0f\rEurope/Athens\x01\f\x15\f\0\xe6\xc4\x90\x02\f\0\xe8\b\0\x02\f\0\xed?\xf0\x02\f\0\xee/\0\x02\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\f\x01,\x96\0\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xb4\xb9\xa0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xe6\xb6\x80\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf0)@\x03\x1c\0\xf3\xd7p\x03\x1c\0\xf7\xda\0\x03\x1c\0\xf9+\x80\x03\x1c\0\xf9\x7f\xe0\x03<\0\0\0\x0e\x83`\x15\x80\x03\0\x83\t\x14\b\n\x04\r\x01\x11\0\x13\x03\x10\x02\x0f\x04\x0e\x04\x0e\x04\x0e\x05\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x05\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x0e\x04\x12\x06\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x06\f\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\v\x07\v\x07\f\x06\f\x06\f\x07\v\x07\x0eEurope/Belfast\0\xcc\n\x1c\0\xb8\x92\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xca\xf8\xf0\x01\x1c\0\xcb\x07\0\x01\x1c\0\xd4A\x80\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80\b\x01'P\0(\0\0\0\x0e|\xe4}@\0\x8a\x05\t\0\b\0\b\0\b\0\b\x01\x07\x01\x07\x01\b\0\b\0\b\x02\x06\x03\x06\x03\x06\x03\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x04\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x0fEurope/Belgrade\0\xba\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x92Wf\xb0\x02\0s\x04\t\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\rEurope/Berlin\0\xc6\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xfb0\x02\0y\x05\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x11Europe/Bratislava\0\xc8\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8a\xd7\xde\xb0\x02\0{\x05\n\x01\t\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x0fEurope/Brussels\0\xcc\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x87\x18\x1a\xb0\x02\0\x7f\x05\n\0\t\x01\b\x01\t\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x10Europe/Bucharest\0\xf8\x13\f\0\xa6\x0e\xf0\x02\f\0\xe6\xc4\x90\x02\f\0\xef\xe2\xf0\x02\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x14\xcc\xf0\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb?@\x03\x1c\0\xef\xd4\xe0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf0\r \x03\x1c\0\xf9+\x80\x03\x1c\0\xf99\x90\x03<\0\0\0\x0e\x8b!\x88\x80\x03\0{\b\x12\0\x10\x01\x0f\x03\r\x03\r\x03\r\x04\r\x03\r\x03\r\x03\r\x03\r\x03\r\x04\f\x03\r\x03\r\x03\r\x02\x0e\x02\x11\x05\v\x06\n\x06\n\x07\t\x07\t\x07\n\x06\n\x06\n\x07\t\x07\t\x07\t\x07\n\x06\n\x06\n\x07\t\x07\t\x07\n\x06\n\x06\n\x06\n\x07\t\x07\t\x07\n\x06\n\x06\n\x07\t\x07\t\x07\n\x06\n\x06\n\x06\n\x07\t\x07\t\x07\n\x06\n\x06\n\x07\t\x07\t\x07\t\x07\n\x06\n\x06\n\x07\t\x07\x0fEurope/Budapest\0\xcc\f\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf0\r \x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xdf\x10\x02\0y\x05\v\0\b\x01\b\x01\b\x01\t\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\n\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x0fEurope/Busingen\0\xbe\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8e\x97\xa2\xb0\x02\0w\x04\t\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x0fEurope/Chisinau\x01\r\x17\f\0\xc1\xe8\xa0\x02\f\0\xef\xe2\xf0\x02\f\0\xef\xf1\0\x02\f\x01\x14\xcc\xf0\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\x1c\x007P\xf0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb10\x03\x1c\0\xef\xd4\xe0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf99\x90\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0x\x12\x16\x11\x14\x11\x14\x11\x15\x10\x13\x0f\x13\x0f\x13\x0f\x13\x0f\x13\x0f\x13\x06\0\f\x02\v\x01\r\x01\r\x01\r\x01\x0e\x03\n\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\b\x05\x07\x05\t\x04\t\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x11Europe/Copenhagen\0\xc6\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xfb0\x02\0y\x05\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\rEurope/Dublin\0\xcc\nx\xff\xff\xff\xf1\x86\x8cH\xe0\x18\x01\x14\xdb\0\x18\x01\x1e\x15\x80\x18\x01'P\0\f\0\xb8\x92\0\x01\f\0\xc1\xcc\x80\x01\f\0\xca\xf8\xf0\x01\f\0\xcb\x07\0\x01\f\0\xd4A\x80\x018\0\0\0\x0e|\xe4}@\0\x8a\0\t\x04\x03\x04\x03\x04\x03\x04\x03\x05\x02\x05\x02\x05\x03\x04\x03\x04\x03\x06\x01\x07\x01\x07\x01\x07\x02\x07\x01\x07\x01\x07\x01\x07\x01\x07\x02\x05\x02\x07\x01\x07\x01\x07\x01\x07\x01\x07\x01\b\x01\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x05\x02\x05\x02\x07\x01\x07\x01\x07\x02\x05\x02\x10Europe/Gibraltar\0\xbc\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x90w\x84\xb0\x02\0u\x04\t\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x0fEurope/Guernsey\0\xcc\n\x1c\0\xb8\x92\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xca\xf8\xf0\x01\x1c\0\xcb\x07\0\x01\x1c\0\xd4A\x80\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80\b\x01'P\0(\0\0\0\x0e|\xe4}@\0\x8a\x05\t\0\b\0\b\0\b\0\b\x01\x07\x01\x07\x01\b\0\b\0\b\x02\x06\x03\x06\x03\x06\x03\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x04\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x0fEurope/Helsinki\0\xc4\v\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf9+\x80\x03<\0\0\0\x0e\x8e\x97\x94\xa0\x03\0w\x04\n\0\x07\0\b\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\t\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x12Europe/Isle_of_Man\0\xcc\n\x1c\0\xb8\x92\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xca\xf8\xf0\x01\x1c\0\xcb\x07\0\x01\x1c\0\xd4A\x80\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80\b\x01'P\0(\0\0\0\x0e|\xe4}@\0\x8a\x05\t\0\b\0\b\0\b\0\b\x01\x07\x01\x07\x01\b\0\b\0\b\x02\x06\x03\x06\x03\x06\x03\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x04\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x0fEurope/Istanbul\x013$\f\0\xcb\x07\0\x02\f\0\xd4A\x80\x02\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x02W\xf0\x02\f\x01\x13\x89\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1c\xc4\0\x02\f\x01\x1e\x07p\x02\f\x01\x1e\x15\x80\x02\f\x01'A\xf0\x02\f\x01'P\0\x02\f\x01(\x93p\x02\f\x02\n \x10\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\f\0S\0p\x03\f\0s\xd9\xd0\x03\x1c\0\xb7N\x90\x03\x1c\0\xb8\x92\0\x03\x1c\0\xb8\xa0\x10\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xc1\xe8\xa0\x03\x1c\0\xc3\x1e\0\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb\x15\x10\x03\x1c\0\xccX\x80\x03\f\0\xd7\xfd\xc0\x03\x1c\0\xdd\x8a\x10\x03\x1c\0\xe0\x1f\0\x03\x1c\0\xe6\xb6\x80\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf1B\x80\x03\x1c\0\xf9+\x80\x03\x1c\t\x91\x9f \x04<\0\0\0\x0e\x7f\xe2J\x90\x03\0P\x0e#\0\x15\b\x11\f\x13\n\x19\x04\x1c\x10\"\x0f\r\x1d\x01 \x02\x1f\x02\x1f\x02\x1f\x02\x1f\x03\x1f\x02\x1f\x02\x1f\x02\x1e\x03\x1f\x02!\x06\x18\x06\x18\x06\x18\t\x14\t\x14\t\x18\x06\x18\x06\x18\t\x14\t\x14\t\x16\t\x18\x06\x18\x06\x18\t\x17\x07\x14\t\x18\x06\x1a\x05\x18\v\x12\x1b\rEurope/Jersey\0\xcc\n\x1c\0\xb8\x92\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xca\xf8\xf0\x01\x1c\0\xcb\x07\0\x01\x1c\0\xd4A\x80\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80\b\x01'P\0(\0\0\0\x0e|\xe4}@\0\x8a\x05\t\0\b\0\b\0\b\0\b\x01\x07\x01\x07\x01\b\0\b\0\b\x02\x06\x03\x06\x03\x06\x03\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x04\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x12Europe/Kaliningrad\0\xbc\x13\x1c\0\xc1\xcc\x80\x03\f\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\f\0\xef\xf1\0\x02\f\0\xef\xff\x10\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\f\x06\xbd\xadp\x02\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0?\x0e\x12\r\x10\r\x10\r\x11\f\x0f\v\x0f\v\x0f\v\x0f\v\t\x04\t\x05\t\x03\t\x03\t\x03\t\x03\t\x03\n\x06\x02\x06\x02\x06\x02\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\0\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\x01\b\vEurope/Kiev\0\xed\x12\f\0\xef\xf1\0\x02\f\x01\x14\xdb\0\x02\f\x01\x14\xe9\x10\x02\f\x01\x1e\x15\x80\x02\f\x02W\xf6\xa0\x02\x1c\0\x81$\xf0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0v\r\x11\f\x0f\f\x0f\f\x10\v\x0e\n\x0e\n\x0e\n\x0e\n\x0e\n\x0e\x05\x04\b\0\b\0\b\0\b\0\t\x02\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\fEurope/Kirov\0\xc1\x14\x1c\0\xc1\xcc\x80\x04\f\0\xc1\xcc\x80\x04\x1c\0\xcb\x07\0\x04\f\0\xef\xf1\0\x03\f\0\xef\xff\x10\x03\f\0\xf9+\x80\x03\f\x01\x14\xdb\0\x03\f\x01\x1e\x15\x80\x03\f\x06\xbd\xadp\x03\x1c\0\xef\xf1\0\x04\x1c\0\xf9+\x80\x04\x1c\x01\xdf\xd3\xf0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0>\x0f\x13\x0e\x11\x0e\x11\x0e\x12\r\x10\f\x10\f\x10\f\x10\f\t\x04\t\x05\f\v\x04\t\x03\t\x03\t\x03\n\x06\x02\x06\x02\x06\x02\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\0\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\x01\b\vEurope/Kyiv\0\xed\x12\f\0\xef\xf1\0\x02\f\x01\x14\xdb\0\x02\f\x01\x14\xe9\x10\x02\f\x01\x1e\x15\x80\x02\f\x02W\xf6\xa0\x02\x1c\0\x81$\xf0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0v\r\x11\f\x0f\f\x0f\f\x10\v\x0e\n\x0e\n\x0e\n\x0e\n\x0e\n\x0e\x05\x04\b\0\b\0\b\0\b\0\t\x02\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\rEurope/Lisbon\0\xe4\x10\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\0\xef\xe2\xf0\x01\x1c\0\xef\xf1\0\x01\x1c\0\xef\xf1\0\x02\x1c\0\xef\xff\x10\x01\x1c\0\xf9+\x80\x01\x1c\0\xf99\x90\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\0\xe6\xb6\x80\b\0\xef\xf1\0\f\0\xef\xf1\0\x01\b\0\xf9+\x80\b\x01\x14\xdb\0\b\x01\x1e\x15\x80(\0\0\0\x0e\x86\x1e\xe1 \0\x80\b\x0f\x03\n\x07\n\x03\n\x06\t\x02\n\x03\n\x03\n\x03\f\x03\n\x05\n\x03\n\x03\n\x03\n\x03\f\x03\n\x03\v\x04\v\x04\v\x04\v\x06\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\x10Europe/Ljubljana\0\xba\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x92Wf\xb0\x02\0s\x04\t\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\rEurope/London\0\xcc\n\x1c\0\xb8\x92\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xca\xf8\xf0\x01\x1c\0\xcb\x07\0\x01\x1c\0\xd4A\x80\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80\b\x01'P\0(\0\0\0\x0e|\xe4}@\0\x8a\x05\t\0\b\0\b\0\b\0\b\x01\x07\x01\x07\x01\b\0\b\0\b\x02\x06\x03\x06\x03\x06\x03\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x04\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x11Europe/Luxembourg\0\xcc\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x87\x18\x1a\xb0\x02\0\x7f\x05\n\0\t\x01\b\x01\t\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\rEurope/Madrid\0\xf0\x10\f\0\xe6\xb6\x80\x01\f\0\xe6\xc4\x90\x01\f\0\xef\xf1\0\x01\f\0\xef\xff\x10\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xe6\xa8p\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9\x1dp\x02\x1c\0\xf9+\x80\x02\x1c\0\xf9G\xa0\x02<\0\0\0\x0e\x81\x81\x85\0\x02\0\x85\x07\x0f\x01\f\x01\n\x03\f\x01\x0e\x02\v\x02\r\0\v\x02\v\x02\v\x02\v\x04\v\x02\v\x02\v\x02\v\x02\v\x02\v\x04\v\x02\v\x02\v\x02\v\x02\v\x02\r\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\fEurope/Malta\x01\"\x17\f\0\x9c\xe2\x80\x01\f\0\xa6\x1d\0\x01\f\0\xc3\x1e\0\x01\f\0\xca\xf8\xf0\x01\f\0\xe5V\xf0\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xee\x9f\x80\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02\x1c\0\xf99\x90\x02\x1c\x01\x03\xc5\x90\x02\x1c\x01\f\xf2\0\x02\x1c\x01\x14\xe9\x10\x02\x1c\x01\x1c\xe0 \x02\x1c\x019\xc5\0\x02\x1c\x01B\xff\x80\x02<\0\0\0\x0ez9j\x10\x02\0\x8d\t\x16\0\x14\x01\x15\x01\f\x05\x11\x02\x13\x03\x12\x03\x12\x03\x12\x03\x12\x03\x10\x04\x0f\x05\r\x05\r\x05\r\x06\r\x05\r\x05\r\x05\r\x05\r\x05\r\x06\r\x05\r\x05\r\x05\r\x05\r\x05\x0e\x07\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\x07\v\b\n\b\n\b\v\x07\v\x07\v\b\n\b\n\b\n\b\v\x07\v\x07\v\b\n\b\x10Europe/Mariehamn\0\xc4\v\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf9+\x80\x03<\0\0\0\x0e\x8e\x97\x94\xa0\x03\0w\x04\n\0\x07\0\b\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\t\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\fEurope/Minsk\0\xb3\x12\x1c\0\xc1\xcc\x80\x03\f\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\f\0\xef\xf1\0\x02\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\f\0\xef\xff\x10\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\x1c\x02\xd9\r\x80\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0<\r\x11\f\x0f\f\x0f\f\x10\v\x0e\n\x0e\n\x0e\n\x0e\n\x0e\n\t\x06\x04\x03\x04\x03\x04\x03\x04\x03\x05\x07\x02\x07\x02\x07\x02\b\0\b\0\b\x02\x07\x02\x07\x02\b\0\b\0\b\0\b\x02\x07\x02\x07\x02\b\x01\rEurope/Monaco\0\xda\r\f\0\xe6\xb6\x80\x01\f\0\xef\xe2\xf0\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02\x1c\0\xf9G\xa0\x02<\0\0\0\x0e\x85.\xf0 \x02\0\x81\x06\f\x01\v\0\n\x02\t\x02\n\0\t\x02\t\x02\t\x02\t\x03\t\x02\t\x02\t\x02\t\x02\t\x02\t\x03\t\x02\t\x02\t\x02\t\x02\t\x02\n\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\rEurope/Moscow\0\xc3\x14\f\0\x93\xa8\0\x03\f\0\xef\xff\x10\x02\x1c\0\xef\xf1\0\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03\f\0\xf9+\x80\x03\f\x01\x14\xdb\0\x03\f\x01\x1e\x15\x80\x03\f\x06\xbd\xadp\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\\:\xf0\x04\x1c\0\xc1\xcc\x80\x04\f\0\xc1\xcc\x80\x04\x1c\0\xcb\x07\0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04\x1c\0\xf9+\x80\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\x0eEurope/Nicosia\0\xf4\x11\f\0\xc4ap\x02\f\0\xe6\xa8p\x02\f\0\xef\xe2\xf0\x02\f\0\xf14p\x02\f\0\xf9\x1dp\x02\f\x01\x14\xdb\0\x02\f\x01\x15\x050\x02\f\x01\x1e\x15\x80\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xe5s\x10\x03\x1c\0\xee\xad\x90\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf99\x90\x03\x1c\x01\x1c\xd2\x10\x03<\0\0\0\x0e\x83ag\0\x03\0\x83\b\x10\x02\x0f\0\v\x01\x0e\x03\f\x02\x0e\x01\r\x02\r\x02\r\x02\r\x04\r\x02\r\x02\r\x02\r\x02\r\x02\r\x04\r\x02\r\x02\r\x02\r\x02\r\x02\x0e\x02\r\x02\r\x06\n\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x05\n\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\t\x07\t\x07\n\x05\n\x05\n\x07\t\x07\vEurope/Oslo\0\xc6\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xfb0\x02\0y\x05\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\fEurope/Paris\0\xda\r\f\0\xe6\xb6\x80\x01\f\0\xef\xe2\xf0\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02\x1c\0\xf9G\xa0\x02<\0\0\0\x0e\x85.\xf0 \x02\0\x81\x06\f\x01\v\0\n\x02\t\x02\n\0\t\x02\t\x02\t\x02\t\x03\t\x02\t\x02\t\x02\t\x02\t\x02\t\x03\t\x02\t\x02\t\x02\t\x02\t\x02\n\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x04\b\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x07\x05\x07\x05\b\x04\b\x04\b\x05\x07\x05\x10Europe/Podgorica\0\xba\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x92Wf\xb0\x02\0s\x04\t\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\rEurope/Prague\0\xc8\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8a\xd7\xde\xb0\x02\0{\x05\n\x01\t\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\vEurope/Riga\0\xf2\x13\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\f\0\xef\xf1\0\x02\f\0\xef\xff\x10\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf9+\x80\x03\x1c\x02\xa1\xae\x80\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0u\x0e\x12\r\x10\r\x10\r\x11\f\x0f\v\x0f\v\x0f\v\x0f\v\x07\x03\x07\x04\x07\x02\x07\x02\x07\x02\x07\x02\x07\x02\t\x02\b\x05\x01\x05\x01\x06\n\x06\x01\x05\x01\x05\x01\x06\0\x06\0\x06\0\x06\x01\x05\x01\x05\x01\x06\0\x06\0\x06\x01\x05\x01\x05\x01\x05\x01\x06\0\x06\0\x06\x01\x05\x01\x05\x01\x06\0\x06\0\x06\x01\x05\x01\x05\x01\x05\x01\x06\0\x06\0\x06\x01\x05\x01\x05\x01\x06\0\x06\0\x06\0\x06\x01\x05\x01\x05\x01\x06\0\x06\vEurope/Rome\0\xf8\x10\f\0\x9c\xe2\x80\x01\f\0\xa6\x1d\0\x01\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02\x1c\0\xf9G\xa0\x02\x1c\x019\xc5\0\x02\x1c\x01B\xff\x80\x02<\0\0\0\x0ez9j\x10\x02\0\x8d\x07\x0f\0\r\x01\x0e\x01\x0e\0\r\x01\x0e\0\x0e\0\r\x01\x0e\x01\r\x01\f\x02\n\x03\n\x03\n\x03\n\x04\n\x03\n\x03\n\x03\n\x03\n\x03\n\x04\n\x03\n\x03\n\x03\n\x03\n\x03\v\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\rEurope/Samara\0\xce\x16\x1c\0\xcb\x07\0\x04\f\0\x1b\xaf\x80\x04\f\0\xc1\xcc\x80\x04\x1c\0\xef\xf1\0\x03\f\0\xef\xff\x10\x03\f\0\xf9+\x80\x03\f\x01\x1e#\x90\x03\x1c\0\xef\xf1\0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\x01\x14\xdb\0\x04\f\x01\x1e\x15\x80\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xc1\xcc\x80\x05\x1c\0\xcb\x07\0\x05\x1c\0\xd4%`\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05\x1c\0\xf9+\x80\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0?\r\x15\n\x12\n\x12\n\x13\t\x11\b\x11\b\x11\b\x11\b\x07\x04\x07\x05\x03\x04\x01\x10\b\x11\b\x11\b\x11\b\x14\v\x0f\v\x0f\v\x0f\f\x0e\f\x0e\f\x0f\v\x0f\v\x0f\f\x0e\f\x0e\f\x0e\f\x0f\v\x0f\v\0\x06\x02\x11Europe/San_Marino\0\xf8\x10\f\0\x9c\xe2\x80\x01\f\0\xa6\x1d\0\x01\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02\x1c\0\xf9G\xa0\x02\x1c\x019\xc5\0\x02\x1c\x01B\xff\x80\x02<\0\0\0\x0ez9j\x10\x02\0\x8d\x07\x0f\0\r\x01\x0e\x01\x0e\0\r\x01\x0e\0\x0e\0\r\x01\x0e\x01\r\x01\f\x02\n\x03\n\x03\n\x03\n\x04\n\x03\n\x03\n\x03\n\x03\n\x03\n\x04\n\x03\n\x03\n\x03\n\x03\n\x03\v\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\x0fEurope/Sarajevo\0\xba\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x92Wf\xb0\x02\0s\x04\t\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x0eEurope/Saratov\0\xc8\x15\x1c\0\xc1\xcc\x80\x04\f\0\xc1\xcc\x80\x04\x1c\0\xcb\x07\0\x04\f\0\xef\xf1\0\x03\f\0\xef\xff\x10\x03\f\0\xf9+\x80\x03\f\x01\x14\xdb\0\x03\f\x01\x1e\x15\x80\x03\f\x06\xbd\xadp\x03\x1c\0\xef\xf1\0\x04\x1c\0\xf9+\x80\x04\x1c\x01\xdf\xd3\xf0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\x03\xf71\x10\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0?\x10\x14\x0e\x12\x0e\x12\x0e\x13\r\x11\f\x11\f\x11\f\t\x04\t\x03\t\x05\f\v\x04\t\x03\t\x03\t\x03\n\x06\x02\x06\x02\x06\x02\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\0\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\x01\b\x0f\x11Europe/Simferopol\0\xde\x18\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb\x15\x10\x03\f\0\xc1\xe8\xa0\x03\x1c\0\xef\xf1\0\x03\f\0\xef\xf1\0\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\f\0\xef\xf1\0\x03\f\x01\x14\xbe\xe0\x03\f\x01\x15\x050\x03\x1c\x03G\xd9\x90\x03\f\x01q$\0\x02\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0-\xfaP\x04\f\0\xca\xf8\xf0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04\x1c\0\xf9\x0f`\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0C\x10\x17\x0f\x14\x0f\x14\x0f\x15\x0e\x13\b\x13\b\x13\b\x13\b\x13\b\f\v\x05\x04\x05\x04\x11\x03\x13\b\x16\n\x02\x06\x01\x06\x01\x07\0\x07\0\x07\x01\x06\x01\x06\x01\x07\0\x07\0\x07\0\x07\x01\x06\x01\x06\x01\x07\0\x07\0\x07\x01\x06\x12\t\rEurope/Skopje\0\xba\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x92Wf\xb0\x02\0s\x04\t\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\fEurope/Sofia\x01\x04\x15\f\0\xe6\xd2\xa0\x02\f\0\xe6\xe0\xb0\x02\f\0\xe8\x16\x10\x02\f\0\xef\xe2\xf0\x02\f\0\xef\xf1\0\x02\f\0\xf1P\x90\x02\f\0\xf9+\x80\x02\f\x01\x14\xcc\xf0\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb?@\x03\x1c\0\xef\xd4\xe0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf7\xcb\xf0\x03\x1c\0\xf9\x0f`\x03\x1c\0\xf99\x90\x03<\0\0\0\x0e\x8a\xd7\xa6p\x03\0{\n\x14\x05\x11\x02\x11\0\x12\x01\x0f\x04\x0f\x06\x0f\x04\x0f\x04\x0f\x04\x0f\x04\x0f\x04\x0f\x06\x0e\x03\x10\x03\x10\x03\x10\x03\x10\x03\x13\x07\r\b\f\b\f\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\v\t\f\b\f\b\f\t\v\t\x10Europe/Stockholm\0\xc6\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xfb0\x02\0y\x05\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x0eEurope/Tallinn\0\xf0\x13\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\f\0\xef\xf1\0\x02\f\0\xef\xff\x10\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x14\xe9\x10\x02\f\x01\x1e\x15\x80\x02\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\x1c\x04\x8a\xcb\0\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0s\x0e\x12\r\x10\r\x10\r\x11\f\x0f\v\x0f\v\x0f\v\x0f\v\b\x03\b\x04\b\x02\b\x02\b\x02\b\x02\b\x02\t\x05\x01\x05\x01\x06\x01\x07\n\x05\x01\x05\x01\x07\0\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x05\x01\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x05\x01\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x07\0\x07\0\x07\0\x07\x01\x05\x01\x05\x01\x07\0\x07\rEurope/Tirane\x01\x1a\x17\f\0\xc1\xbep\x01\f\0\xc3\x0f\xf0\x01\f\0\xc7\x04p\x01\f\0\xca\xf8\xf0\x01\f\0\xda\xca\xf0\x01\f\0\xef\xf1\0\x01\f\0\xf0\r \x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf1P\x90\x02\x1c\0\xf9+\x80\x02\x1c\x01\x03\xc5\x90\x02\x1c\x01\r\0\x10\x02\x1c\x01\x16:\x90\x02\x1c\x01\x18\xdd\x90\x02\x1c\x01\x1c\xd2\x10\x02\x1c\x01\x1e#\x90\x02<\0\0\0\x0e\x81\x9b\xf1\x10\x02\0\x85\n\x16\x02\x12\x03\x13\x03\x15\0\x14\x01\x14\x01\x14\x03\x11\x03\x15\x03\x10\x04\x0e\x06\r\x05\r\x05\r\x05\r\x05\r\x05\r\x07\r\x05\r\x05\r\x05\r\x05\r\x05\x0f\b\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\b\f\t\v\t\v\t\f\b\f\b\f\t\v\t\v\t\v\t\f\b\f\b\f\t\v\t\x0fEurope/Tiraspol\x01\r\x17\f\0\xc1\xe8\xa0\x02\f\0\xef\xe2\xf0\x02\f\0\xef\xf1\0\x02\f\x01\x14\xcc\xf0\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\x1c\x007P\xf0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb10\x03\x1c\0\xef\xd4\xe0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xef\xff\x10\x03\x1c\0\xf99\x90\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0x\x12\x16\x11\x14\x11\x14\x11\x15\x10\x13\x0f\x13\x0f\x13\x0f\x13\x0f\x13\x0f\x13\x06\0\f\x02\v\x01\r\x01\r\x01\r\x01\x0e\x03\n\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\b\x05\x07\x05\t\x04\t\x04\t\x04\t\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x07\x05\x07\x05\t\x04\t\x04\t\x05\x07\x05\x10Europe/Ulyanovsk\0\xdc\x18\x1c\0\\:\xf0\x04\x1c\0\xc1\xcc\x80\x04\x1c\0\xcb\x07\0\x04\f\0\x93\xa8\0\x03\f\0\xc1\xcc\x80\x04\f\0\xef\xf1\0\x03\f\0\xef\xff\x10\x02\x1c\0\xef\xf1\0\x03\f\0\xef\xff\x10\x03\f\0\xf9+\x80\x03\f\x01\x14\xdb\0\x03\f\x01\x1e\x15\x80\x03\f\x06\xbd\xadp\x03\x1c\0\xef\xf1\0\x04\x1c\0\xf9+\x80\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\x02\xaa\xf7\x10\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0A\x13\x17\x11\x15\x11\x15\x11\x16\x10\x14\x0f\x14\x0f\x14\x0f\x14\x0f\r\b\r\t\x07\x06\x03\0\x05\r\x05\r\x05\r\x05\x0e\n\x02\n\x02\n\x02\v\x01\v\x01\v\x02\n\x02\n\x02\v\x01\v\x01\v\x01\v\x02\n\x02\n\x02\v\x04\f\x12\x0fEurope/Uzhgorod\0\xed\x12\f\0\xef\xf1\0\x02\f\x01\x14\xdb\0\x02\f\x01\x14\xe9\x10\x02\f\x01\x1e\x15\x80\x02\f\x02W\xf6\xa0\x02\x1c\0\x81$\xf0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0v\r\x11\f\x0f\f\x0f\f\x10\v\x0e\n\x0e\n\x0e\n\x0e\n\x0e\n\x0e\x05\x04\b\0\b\0\b\0\b\0\t\x02\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\fEurope/Vaduz\0\xbe\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8e\x97\xa2\xb0\x02\0w\x04\t\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x0eEurope/Vatican\0\xf8\x10\f\0\x9c\xe2\x80\x01\f\0\xa6\x1d\0\x01\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02\x1c\0\xf9G\xa0\x02\x1c\x019\xc5\0\x02\x1c\x01B\xff\x80\x02<\0\0\0\x0ez9j\x10\x02\0\x8d\x07\x0f\0\r\x01\x0e\x01\x0e\0\r\x01\x0e\0\x0e\0\r\x01\x0e\x01\r\x01\f\x02\n\x03\n\x03\n\x03\n\x04\n\x03\n\x03\n\x03\n\x03\n\x03\n\x04\n\x03\n\x03\n\x03\n\x03\n\x03\v\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x05\t\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\b\x06\b\x06\t\x05\t\x05\t\x06\b\x06\rEurope/Vienna\0\xcc\f\f\0\xe6\xa8p\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf0\x1b0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8c\xc0\xdf\x10\x02\0y\x05\v\0\t\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\n\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x0eEurope/Vilnius\0\xfa\x15\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x02\f\x01\x14\xdb\0\x01\x1c\0\xcb\x15\x10\x02\x1c\0\xcb\x07\0\x03\f\0\xef\xf1\0\x02\f\0\xef\xff\x10\x02\f\0\xf9+\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1e\x15\x80\x02\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\x1c\x06j\xad\0\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0q\x10\x14\x0f\x12\x0f\x12\x0f\x13\x0e\x11\r\x11\r\x11\r\x11\r\n\x06\n\x07\n\x05\n\x05\n\x05\n\x05\n\x05\v\b\x04\b\x03\x02\x01\t\f\b\x04\t\0\t\0\t\0\t\x04\b\x04\b\x04\t\0\t\0\t\x04\b\x04\b\x04\b\x04\t\0\t\0\t\x04\b\x04\b\x04\t\0\t\0\t\x04\b\x04\b\x04\b\x04\t\0\t\0\t\x04\b\x04\b\x04\t\0\t\0\t\0\t\x04\b\x04\b\x04\t\0\t\x10Europe/Volgograd\0\xcf\x16\x1c\0\xc1\xcc\x80\x04\f\0\xc1\xcc\x80\x04\x1c\0\xcb\x07\0\x04\f\0\xef\xf1\0\x03\f\0\xef\xff\x10\x03\f\0\xf9+\x80\x03\f\x01\x14\xdb\0\x03\f\x01\x1e\x15\x80\x03\f\x04\x12\xc4p\x03\f\x06\xbd\xadp\x03\x1c\0\xef\xf1\0\x04\x1c\0\xf9+\x80\x04\x1c\x01\xdf\xd3\xf0\x04\f\0\xef\xf1\0\x04\f\0\xf0\r \x04\f\0\xf14p\x04\f\x07\x88\xd0\x90\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c\0\xef\xf1\0\x05\x1c\0\xef\xff\x10\x05\x1c\0\xf1P\x90\x05<\0\0\0\x0e\x8e\x9bP\xe0\x05\0@\x11\x15\x0f\x13\x0f\x13\x0f\x14\x0e\x12\r\x12\r\x12\r\n\x04\n\x03\n\x05\r\f\x04\n\x03\n\x03\n\x03\v\x06\x02\x06\x02\x06\x02\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\0\x07\0\x07\0\x07\x02\x06\x02\x06\x02\x07\x01\t\x10\b\rEurope/Warsaw\0\xd2\f\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xef\xff\x10\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x87\x18\f\xa0\x02\0\x7f\x05\v\0\n\x01\b\x01\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\t\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\n\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\rEurope/Zagreb\0\xba\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x92Wf\xb0\x02\0s\x04\t\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x11Europe/Zaporozhye\0\xed\x12\f\0\xef\xf1\0\x02\f\x01\x14\xdb\0\x02\f\x01\x14\xe9\x10\x02\f\x01\x1e\x15\x80\x02\f\x02W\xf6\xa0\x02\x1c\0\x81$\xf0\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xcb\x07\0\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf9+\x80\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0v\r\x11\f\x0f\f\x0f\f\x10\v\x0e\n\x0e\n\x0e\n\x0e\n\x0e\n\x0e\x05\x04\b\0\b\0\b\0\b\0\t\x02\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\rEurope/Zurich\0\xbe\n\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x8e\x97\xa2\xb0\x02\0w\x04\t\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\x07\x01\x07\0\x07\0\x07\0\x07\0\x07\0\b\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x05\x03\x05\x03\x06\x02\x06\x02\x06\x03\x05\x03\x07Factory\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x02GB\0\xcc\n\x1c\0\xb8\x92\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xca\xf8\xf0\x01\x1c\0\xcb\x07\0\x01\x1c\0\xd4A\x80\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80\b\x01'P\0(\0\0\0\x0e|\xe4}@\0\x8a\x05\t\0\b\0\b\0\b\0\b\x01\x07\x01\x07\x01\b\0\b\0\b\x02\x06\x03\x06\x03\x06\x03\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x04\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x07GB-Eire\0\xcc\n\x1c\0\xb8\x92\0\x01\x1c\0\xc1\xcc\x80\x01\x1c\0\xca\xf8\xf0\x01\x1c\0\xcb\x07\0\x01\x1c\0\xd4A\x80\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\x01\x14\xdb\0\b\x01\x1e\x15\x80\b\x01'P\0(\0\0\0\x0e|\xe4}@\0\x8a\x05\t\0\b\0\b\0\b\0\b\x01\x07\x01\x07\x01\b\0\b\0\b\x02\x06\x03\x06\x03\x06\x03\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x04\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x01\x07\x01\x07\x03\x06\x03\x06\x03\x07\x01\x07\x03GMT\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x05GMT+0\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x05GMT-0\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x04GMT0\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\tGreenwich\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x03HST\0J\b\x16\x06\x9a\xb6\xa8\t\x1e\x16\x10g\xccp\t\x1e\x16F$\xd2\x8a\t\x1ef\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x06\0\x1c.\x10\n\x1e\x06\0=T\xc8\n\x1e\x04\x03,*\x10\n&\0\0\0\r\xeeT'\xde\n\x1e\0\b\x03\x07\x02\x04\x01\0\x05\x06\bHongkong\0R\t\f\0\xd43p\b\f\0\xef\xe2\xf0\b\f\0\xf9\x1dp\b\f\x01\x83\x8a\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\0\\W\x10\t\x1c\0\xef\xff\x10\t\x1c\x04\xd4\xad\x10\t<\0\0\0\x0ez\x01\xd9\xd8\t\0\x11\x04\b\x01\x06\x01\x06\x02\x06\x01\x05\x03\x06\x01\x06\x01\x07\0\x07Iceland\0\x17\x02h\xff\xff\xff\xf1\x86\x8cH\xe0(\0\0\0\x0e\fZIh\0\x02\0\x01\x13Indian/Antananarivo\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\rIndian/Chagos\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x06,\0\0\0\x0e\xaaZ\x94\xd0\x06\0\x02\0\x01\x10Indian/Christmas\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\x06*\x04\fK\xb3\xe2\0\x07/\0\0\0\r\xd0*<\xe4\x06*\x04\0\x03\0\x02\x01\fIndian/Cocos\x004\x05o\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x18/\x0e\x05\xa7k\xd8\x06\x1e\f*\0\x88\xc7\t\x0eK;\xe9\x80\x06\x1e/\0\0\0\r\xd0*@\xf1\x06\x18/\0\x05\0\x04\x03\x02\x01\rIndian/Comoro\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\x10Indian/Kerguelen\0\"\x03n\xff\xff\xff\xf1\x86\x8cH\xe0\x046\f\x96y$\x80\x05.\0\0\0\r\xd0*V8\x046\0\x03\0\x02\x01\vIndian/Mahe\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x04,\0\0\0\x0e\x1bfP\xc8\x04\0\x02\0\x01\x0fIndian/Maldives\0\"\x03n\xff\xff\xff\xf1\x86\x8cH\xe0\x046\f\x96y$\x80\x05.\0\0\0\r\xd0*V8\x046\0\x03\0\x02\x01\x10Indian/Mauritius\0.\x05\f\0\xca\xf8\xf0\x04\f\0\xd5\x84\xf0\x04|\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x1c0($\xb0\x05<\0\0\0\x0e\x91y\xa4`\x05\0\x05\x02\x04\x01\x03\0\x0eIndian/Mayotte\x009\x06n\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1e\x0e\x02\xd9\x06x\x02\x1e\f\n~\xcd|\x03\x0e\r%\xcc\x88\x02-\f%\xef\b\\\x03.\0\0\0\x0e\x05s\x89\x1c\x02\x1e\0\x06\0\x05\x04\x01\x03\x02\x0eIndian/Reunion\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x04,\0\0\0\x0e\x1bfP\xc8\x04\0\x02\0\x01\x04Iran\0\xbe\x10\x0e\0\x813\0\x03\x1e\x0e\0\x97\x8ep\x03\x1e\x0e\0\xbb&\xf0\x03\x1e\x0e\0\xf2\x85\xf0\x03\x1e\x0e\0\xf5(\xf0\x03\x1e\f\0\xafW\x80\x04\f\x01\x18\xcf\x80\x04~\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1e\x1e\0\xee\xad\x90\x04\x1e\x1e\0\xef\xff\x10\x04\x1e\x1e\0\xf2\xa2\x10\x04\x1e\x1e\x01\x03\xbe\x88\x04\x1e\x1e\x04\xb1\x14\x90\x04\x1e\x1e\x13\xf3a\x10\x04\x1e\x1c\0\xcc_\x88\x05>\0\0\0\x0e\x87\x07\xfbX\x04\x1e\0F\x07\x0f\x06\x0e\x05\0\v\x01\n\x04\r\x02\t\x03\b\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\f\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\b\x03\b\x03\t\x03\b\x03\x06Israel\x01\xae2\f\x007_\0\x02\f\0\x81$\xf0\x02\f\0\x93\x99\xf0\x02\f\0\x93\xa8\0\x02\f\0\xa6\x0e\xf0\x02\f\0\xafIp\x02\f\0\xb8\x83\xf0\x02\f\0\xc1\xbep\x02\f\0\xc4ap\x02\f\0\xc7\x04p\x02\f\0\xca\xf8\xf0\x02\f\0\xcd\x9b\xf0\x02\f\0\xd43p\x02\f\0\xddm\xf0\x02\f\0\xe0\x10\xf0\x02\f\0\xe6\x9a`\x02\f\0\xe9Kp\x02\f\0\xf2\x85\xf0\x02\f\0\xf3\xd7p\x02\f\0\xf9\x1dp\x02\f\0\xfb\xc0p\x02\f\0\xfd\x11\xf0\x02\f\x01\x17o\xf0\x02\f\x01 \xaap\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\x1c\0\xbf7\x90\x03\x1c\0\xc8r\x10\x03\x1c\0\xe2\xd0\x10\x03\x1c\0\xe4!\x90\x03\x1c\0\xed\\\x10\x03\x1c\0\xf3\xf3\x90\x03\x1c\0\xf5E\x10\x03\x1c\0\xf6\x96\x90\x03\x1c\0\xf99\x90\x03\x1c\0\xfb\xea\xa0\x03\x1c\0\xff\xd1\x10\x03\x1c\x01\t\v\x90\x03\x1c\x01\v\xae\x90\x03\x1c\x01\x12F\x10\x03\x1c\x01\x12b0\x03\x1c\x01\x14\xe9\x10\x03\x1c\x01\x1b\x80\x90\x03\x1c\x01\"\x18\x10\x03\x1c\x01'^\x10\x03\x1c\x010\x8a\x80\x03\x1c\x019\xd3\x10\x03\x1c\x01U\x82\x90\x03\x1c\x06\xd9k\0\x03\x1c\tC\xc8\x90\x03<\0\0\0\x0e\x81\xf0C\0\x03\0w\x181\x01!\x050\0/\x03,\x06.\x02*\t(\x07-\x04%\n(\f(\f&\v&\b)\v#\x12\x1f\x10 \x0e'\n+\x0f\x1e\r\x1f\x15\x1b\x13 \r\"\x14\x1c\x11\x1d\x0e#\x14\x1c\x11\x1d\x0e$\x11\x1d\x10 \x16\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\x19\x17\x19\x17\x1a\x16\x1a\x16\x1a\x17\x19\x17\x07Jamaica\0V\t\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01B\xf1p\x05\x04\x01\x83\x8a\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\x9c\xf0\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0e\x81\0\xd0\x90\x04\0\x15\x04\b\x03\x05\x02\x07\x01\x06\x01\x07\0\x07\0\x07\0\x07\0\x07\x01\x06\x01\x05Japan\0E\b\x1c\x01\v\xa0\x80\n\x1c\x019\xc5\0\n\x1cq{^\0\nl\xff\xff\xff\xf1\x86\x8cH\xe0\t\f\0\xa6\x1d\0\t\f\0\xafW\x80\t\f\0\xd4A\x80\t,\0\0\0\r\xdf6[\x90\t\0\n\x03\x07\x02\x05\0\x06\x01\x04\x01\x04\tKwajalein\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\x0e\xa5\xe9\xc5`\f\0\x02\0\x01\x05Libya\0\x90\x12\x1c\0v\xb5\x10\x02\x1c\0\xb7@\x80\x02\x1c\0\xed\\\x10\x02\x1c\0\xef\xff\x10\x02\x1c\0\xf1P\x90\x02\x1c\0\xf3\xf3\x90\x02\x1c\0\xf5E\x10\x02\x1c\0\xf6\x96\x90\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\x01\f\0\xea\x9c\xf0\x01\f\0\xef\xe2\xf0\x01\f\0\xf14p\x01\f\0\xf14p\x02\f\x01\x14\xdb\0\x02\f\f\x0e9p\x01\f\x1ch. \x01\f\x01\x1b\x80\x90\x02,\0\0\0\x0e\x90\x05\xf9\x80\x01\0\x19\b\x11\0\v\x03\v\x04\v\x07\t\x05\n\x02\v\x04\v\x03\v\x10\x0e\x06\f\x0f\x01\r\x03MET\0\xcc\v\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x87\x18\x1a\xb0\x02\0\x7f\x05\n\0\t\x01\b\x01\t\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\t\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x03MST\0Y\v\x14\0x\x06\x90\x06\x14\0\xcb\x15\x10\x06\x14)\xee#\x10\x06\x14*wZ\xf4\x06\x14@\xa2-\xe0\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0\xef\xe2\xf0\x07\x04\0\xf14p\x07\x04\x01\x14\xcc\xf0\x07\x04\x03\x8e\xd2\x8c\x07$\0\0\0\r\xd7w\xc3\xd0\x07\0\f\x05\n\x04\b\x01\b\x02\t\0\x07\x03\x06\x07MST7MDT\0\xfe\x11\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x10Mexico/BajaNorte\x01\x04\x12\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xb8\xa0\x10\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8d\x07\x11\0\x10\x01\x10\0\x10\0\b\x06\t\x05\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x02\x0e\x02\x0e\x03\r\x03\r\x03\r\x03\x0e\x02\x0e\x02\f\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x0eMexico/BajaSur\0r\b\x04\0\xc1\xbep\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xf99\x90\x064\0\0\0\x0e\xaa\xdb;0\x06\x007\x03\x07\x01\x05\x01\x05\x01\x05\x02\x04\x02\x06\0\x06\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x0eMexico/General\0r\b\x04\0\xc1\xbep\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xf99\x90\x054\0\0\0\x0e\xaa\xdb- \x05\x007\x03\x07\x01\x05\x01\x05\x01\x05\x02\x04\x02\x06\0\x06\x01\x05\x01\x05\x02\x04\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x01\x05\x02\x04\x02\x04\x02\x05\x01\x05\x01\x05\x02\x04\x02\x02NZ\0\xef\x10\f\0\x93\xa8\0\f\f\0\xa6\x1d\0\f\f\0\xafW\x80\f\f\0\xd4A\x80\f\f\0\xdd|\0\f\f\0\xf9+\x80\f\f\x01\x02f\0\f|\xff\xff\xff\xf1\x86\x8cH\xe0\r\x1c\0\xe6\xb6\x80\r\x1c\0\xef\xf1\0\r\x1c\x01\x02f\0\r\x1c\x01\v\xa0\x80\r\x1c\x01\x1e\x15\x80\r\x1c\x019\xc5\0\r\x1c\x01B\xff\x80\r<\0\0\0\x0e\x82\x8c\xb5\0\r\0\x84\x07\x0f\0\x0e\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\f\x03\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\n\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x06\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x07NZ-CHAT\0\xff\x10\x0e\0\x93\xa8\0\f-\x0e\0\xa6\x1d\0\f-\x0e\0\xafW\x80\f-\x0e\0\xd4A\x80\f-\x0e\0\xdd|\0\f-\x0e\0\xf9+\x80\f-\x0e\x01\x02f\0\f-~\xff\xff\xff\xf1\x86\x8cH\xe0\r-\x1e\0\xe6\xb6\x80\r-\x1e\0\xef\xf1\0\r-\x1e\x01\x02f\0\r-\x1e\x01\v\xa0\x80\r-\x1e\x01\x1e\x15\x80\r-\x1e\x019\xc5\0\r-\x1e\x01B\xff\x80\r->\0\0\0\x0e\x82\x8c\xb5\0\r-\0\x84\x07\x0f\0\x0e\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\f\x03\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\n\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x06\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x06Navajo\0\xfe\x11\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x03PRC\0B\x07\f\0\xafIp\b\f\0\xc1\xbep\b\f\0\xca\xf8\xf0\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\x01\x14\xe9\x10\t\x1c\x01\x1e#\x90\t<\0\0\0\x0e\x98.\t@\t\0\r\x03\x06\0\x04\x02\x05\x01\x05\x02\x04\x02\x04\x02\x07PST8PDT\0\xfe\x11\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\fPacific/Apia\0Y\t\x04\0\xf8\x040\vt\xff\xff\xff\xf1\x86\x8cH\xe0\n\f\0y\x82@\r\x1c\0\x7f\xa9@\x0e\x14\0\xe6\xb6\x80\n\x1c\0\xe6\xb6\x80\x0e\f\0\xf9+\x80\r\x1c\0\xef\xf1\0\x0e4\0\0\0\x0e\xc6\x12\xde\xd0\n\0\x18\x01\b\0\x04\x03\x02\x07\x06\x05\x06\x05\x06\x05\x06\x05\x06\x05\x06\x07\x06\x05\x06\x05\x06\x10Pacific/Auckland\0\xef\x10\f\0\x93\xa8\0\f\f\0\xa6\x1d\0\f\f\0\xafW\x80\f\f\0\xd4A\x80\f\f\0\xdd|\0\f\f\0\xf9+\x80\f\f\x01\x02f\0\f|\xff\xff\xff\xf1\x86\x8cH\xe0\r\x1c\0\xe6\xb6\x80\r\x1c\0\xef\xf1\0\r\x1c\x01\x02f\0\r\x1c\x01\v\xa0\x80\r\x1c\x01\x1e\x15\x80\r\x1c\x019\xc5\0\r\x1c\x01B\xff\x80\r<\0\0\0\x0e\x82\x8c\xb5\0\r\0\x84\x07\x0f\0\x0e\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\f\x03\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\n\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x06\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x14Pacific/Bougainville\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\v,\0\0\0\x0e\xce\x12\x8e\xa0\v\0\x02\0\x01\x0fPacific/Chatham\0\xff\x10\x0e\0\x93\xa8\0\f-\x0e\0\xa6\x1d\0\f-\x0e\0\xafW\x80\f-\x0e\0\xd4A\x80\f-\x0e\0\xdd|\0\f-\x0e\0\xf9+\x80\f-\x0e\x01\x02f\0\f-~\xff\xff\xff\xf1\x86\x8cH\xe0\r-\x1e\0\xe6\xb6\x80\r-\x1e\0\xef\xf1\0\r-\x1e\x01\x02f\0\r-\x1e\x01\v\xa0\x80\r-\x1e\x01\x1e\x15\x80\r-\x1e\x019\xc5\0\r-\x1e\x01B\xff\x80\r->\0\0\0\x0e\x82\x8c\xb5\0\r-\0\x84\x07\x0f\0\x0e\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\r\x01\r\x01\r\x01\r\x01\r\x02\r\x01\f\x03\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\v\x03\v\x03\v\x04\n\x04\n\x04\n\x04\n\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x06\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\x05\b\x05\t\x05\b\x05\b\x05\b\x05\b\rPacific/Chuuk\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\t0 \f\x1c7J\x88\n/\0\0\0\r\xd0*\x11(\t0 \0\x03\0\x02\x01\x0ePacific/Easter\x01h#\x14\0x\x06\x90\x05\x14\0\x8a{\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xc1\xda\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xef\xff\x10\x05\x14\0\xf99\x90\x05\x14\x01\x02t\x10\x06\x14\x01\x02t\x10\x05\x14\x01\v\xae\x90\x06\x14\x01\x14\xe9\x10\x06\x14\x01\x14\xe9\x10\x05\x14\x01\x1e#\x90\x06\x14\x01\x1e#\x90\x05d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0\xc1\xbep\x07\x04\0\xc1\xbep\x06\x04\0\xca\xf8\xf0\x07\x04\0\xca\xf8\xf0\x06\x04\0\xd43p\x07\x04\0\xddm\xf0\x06\x04\0\xe6\xa8p\x06\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x1e\x07p\x06\x04\x010|p\x06\x04\x019\xb6\xf0\x06\x04\x01L+\xf0\x06\x04\x01g\xdbp\x06\x04\x03,\r\xf0\x06$\0\0\0\x0ey\xe6\x93\xd0\x07\0\x8b\x10\"\t\x13\f\x13\x0e\x11\v\x15\x0e\x11\x0e\x13\f\x13\f\x13\x0e\x11\x0e\x11\x0e\x13\f\x14\r\x14\r\x14\x0f\x12\x0f\x12\x0f\x18\x07\x14\r\x14\x0f\x12\b\x17\x0f\x14\r\x14\r\x14\r\x14\x0f\x12\x0f\x16\n\x14\n\x19\b\x14\x0f\x12\x0f\x12\x0f\x12\x0f\x14\r\x14\r\x14\x0f\x12\x0f\x16\n\x14\r\x17\b\x1b\x01\x1f\x02\x1e\x03\x1d\x03!\0 \0 \0\x1e\x05\x1b\x05\x1b\x05\x1b\x06\x1a\x05\x1c\x05\x1b\x05\x1b\x05\x1b\x05\x1b\x05\x1c\x04\x1c\x05\x1b\x05\x1b\x05\x1b\x05\x1b\x05\x1c\x04\x1c\x05\x1b\x05\x1b\x05\x1b\x05\rPacific/Efate\0d\v\f\0w\xeap\v\f\0\x813\0\v\f\0\x9c\xd4p\v\f\0\xe6\xa8p\v\f\0\xef\xe2\xf0\v|\xff\xff\xff\xf1\x86\x8cH\xe0\f\x1c\0\xef\xff\x10\f\x1c\0\xf99\x90\f\x1c\x01g\xf7\x90\f\x1c\x11\xd8+\x90\f<\0\0\0\x0e\x80\xedP`\f\0\x17\x05\n\x01\t\x04\x06\x04\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x06\x04\x07\x02\b\0\x11Pacific/Enderbury\0 \x03d\xff\xff\xff\xf1\x86\x8cH\xe0\v\f\x1c\xaf4\xf0\r$\0\0\0\x0e\x8b\xc9\xbb\xe0\v\0\x03\0\x02\x01\x0fPacific/Fakaofo\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\r,\0\0\0\x0e\xc8qP\xd0\r\0\x02\0\x01\fPacific/Fiji\0\xac\x16\f\0$\xea\0\f\f\0S\x0e\x80\f\f\0\\I\0\f\f\0e\x83\x80\f\f\0n\xaf\xf0\f\f\0w\xf8\x80\f\f\0\x93\xa8\0\f\f\0\x9c\xe2\x80\f\f\0\xafW\x80\f|\xff\xff\xff\xf1\x86\x8cH\xe0\r\x1c\x01\x14\xdb\0\r\x1c\x010\x8a\x80\r\x1c\x01L:\0\r\x1c\x01g\xe9\x80\r\x1c\x01q$\0\r\x1c\x01z^\x80\r\x1c\x01zl\x90\r\x1c\x01\x83\x99\0\r\x1c\x01\x8c\xd3\x80\r\x1c\x01\xc42\x80\r\x1c\x12YP\x80\r<\0\0\0\x0e\xaf\xae\xcf\0\r\0\x1d\t\x15\x07\f\x06\x14\x07\n\b\v\x05\r\x05\x0e\x04\x10\x03\x0f\x03\x11\x02\x11\x02\x11\x02\x12\x01\x13\0\x10Pacific/Funafuti\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\r\xf7\xa9\xc9\xec\f\0\x02\0\x01\x11Pacific/Galapagos\0'\x04\x14\f\xfeF\x90\x05d\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x04\0Z\xe9p\x06$\0\0\0\x0e\x97\x8c{p\x06\0\x04\x01\x03\0\x02\x0fPacific/Gambier\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\t$\0\0\0\x0e\r\xc3\xff$\t\0\x02\0\x01\x13Pacific/Guadalcanal\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\v,\0\0\0\x0e\r\xc2\xea\xac\v\0\x02\0\x01\fPacific/Guam\0Y\v\f\0\\:\xf0\n\f\0s\xf6,\n\f\0\xa6\x0e\xf0\n\f\0\xafIp\n\f+\xdd\xba\xf0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\x010\x98\x90\v\x1c\x01C\rT\v\x1c\x04;\xbf\x10\v\x1c\x04J?\x90\v<\0\0\0\x0ez\n\xe3 \v\0\f\x05\n\x03\x06\x03\t\0\b\x01\x07\x02\x04\x10Pacific/Honolulu\0J\b\x16\x06\x9a\xb6\xa8\t\x1e\x16\x10g\xccp\t\x1e\x16F$\xd2\x8a\t\x1ef\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x06\0\x1c.\x10\n\x1e\x06\0=T\xc8\n\x1e\x04\x03,*\x10\n&\0\0\0\r\xeeT'\xde\n\x1e\0\b\x03\x07\x02\x04\x01\0\x05\x06\x10Pacific/Johnston\0J\b\x16\x06\x9a\xb6\xa8\t\x1e\x16\x10g\xccp\t\x1e\x16F$\xd2\x8a\t\x1ef\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x06\0\x1c.\x10\n\x1e\x06\0=T\xc8\n\x1e\x04\x03,*\x10\n&\0\0\0\r\xeeT'\xde\n\x1e\0\b\x03\x07\x02\x04\x01\0\x05\x06\x0ePacific/Kanton\0 \x03d\xff\xff\xff\xf1\x86\x8cH\xe0\v\f\x1c\xaf4\xf0\r$\0\0\0\x0e\x8b\xc9\xbb\xe0\v\0\x03\0\x02\x01\x12Pacific/Kiritimati\0 \x03d\xff\xff\xff\xf1\x86\x8cH\xe0\n\f\x1c\xaf9\xa0\x0e$\0\0\0\x0e\x8b\xc9\xa9 \n\0\x03\0\x02\x01\x0ePacific/Kosrae\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\v,\0\0\0\x0e\xaf\xff\x1e`\v\0\x02\0\x01\x11Pacific/Kwajalein\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\x0e\xa5\xe9\xc5`\f\0\x02\0\x01\x0ePacific/Majuro\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\r\xf7\xa9\xc9\xec\f\0\x02\0\x01\x11Pacific/Marquesas\0\x1b\x02f\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1e&\0\0\0\x0e\r\xc4\x03h\t\x1e\0\x02\0\x01\x0ePacific/Midway\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\v$\0\0\0\x0e\ny\xb2(\v\0\x02\0\x01\rPacific/Nauru\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\x0e\x8a\x95`\b\f\0\x02\0\x01\fPacific/Niue\0\"\x03f\xff\xff\xff\xf1\x86\x8cH\xe0\v\x14\x04\x16\x05N\x14\v&\0\0\0\x0eY\x15!l\v\x14\0\x03\0\x02\x01\x0fPacific/Norfolk\0q\t\x1c\0\xef\xf1\0\f\x1c\0\xf9+\x80\f\f\0\xef\xf1\0\v\f\0\xf9+\x80\v\x1c\x07\x88\xc9\x88\f\fLY\xff\0\v\x0e\0\xa6\x1d\0\v\x1e~\xff\xff\xff\xf1\x86\x8cH\xe0\f\x1e>\0\0\0\x0e\x82\x83\x81\x88\f\x1e\0-\x07\b\x06\x05\x04\x02\0\x02\0\x02\0\x02\0\x03\0\x02\0\x02\0\x02\0\x02\0\x02\x01\x02\0\x02\0\x02\0\x02\0\x02\0\x02\x01\x02\0\x02\0\x02\0\x02\0\x0ePacific/Noumea\0<\x07\f\0p\x01p\v\f\0qR\xf0\v\f\0w\xf8\x80\v|\xff\xff\xff\xf1\x86\x8cH\xe0\f\x1c\x01o\xe0\x90\f\x1c!h\\\xb0\f<\0\0\0\x0e\x88Zqp\f\0\x07\x03\x06\0\x04\x01\x05\x02\x11Pacific/Pago_Pago\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\v$\0\0\0\x0e\ny\xb2(\v\0\x02\0\x01\rPacific/Palau\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\t,\0\0\0\r\xf7\xa9\xee\f\t\0\x02\0\x01\x10Pacific/Pitcairn\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\b$\0\0\0\x0e\xae\xb7\xf9(\b\0\x02\0\x01\x0fPacific/Pohnpei\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\v,\0\0\0\x0e\r\xc2\xea\xac\v\0\x02\0\x01\x0ePacific/Ponape\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\v,\0\0\0\x0e\r\xc2\xea\xac\v\0\x02\0\x01\x14Pacific/Port_Moresby\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\t0 \f\x1c7J\x88\n/\0\0\0\r\xd0*\x11(\t0 \0\x03\0\x02\x01\x11Pacific/Rarotonga\0M\x06\x04\0\x93\x99\xf0\n\x04\0\xa6\x15\xf8\n\x04\0\xafPx\nv\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1e\x16\x019\xcc\b\t\x1e6\0\0\0\x0e\x8a\x1f\xd2H\t\x1e\0\x1b\x03\x05\0\x04\x01\x04\x01\x04\x02\x04\x01\x04\x01\x04\x01\x04\x01\x04\x01\x04\x02\x04\x01\x04\x01\x04\x01\x0ePacific/Saipan\0Y\v\f\0\\:\xf0\n\f\0s\xf6,\n\f\0\xa6\x0e\xf0\n\f\0\xafIp\n\f+\xdd\xba\xf0\n|\xff\xff\xff\xf1\x86\x8cH\xe0\v\x1c\x010\x98\x90\v\x1c\x01C\rT\v\x1c\x04;\xbf\x10\v\x1c\x04J?\x90\v<\0\0\0\x0ez\n\xe3 \v\0\f\x05\n\x03\x06\x03\t\0\b\x01\x07\x02\x04\rPacific/Samoa\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\v$\0\0\0\x0e\ny\xb2(\v\0\x02\0\x01\x0ePacific/Tahiti\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\n$\0\0\0\x0e\r\xc4\f\xd8\n\0\x02\0\x01\x0ePacific/Tarawa\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\r\xf7\xa9\xc9\xec\f\0\x02\0\x01\x11Pacific/Tongatapu\0D\b\f\0\\I\0\r\f\0n\xaf\xf0\r\f\0\xd86\0\r|\xff\xff\xff\xf1\x86\x8cH\xe0\x0e\x1c\x010\x8a\x80\x0e\x1c\x01q2\x10\x0e\x1c\x1b\xcb=\x90\x0e<\0\0\0\x0e\xb1n\xfe\xf0\x0e\0\t\x03\x07\x02\x04\x01\x05\x01\x06\0\fPacific/Truk\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\t0 \f\x1c7J\x88\n/\0\0\0\r\xd0*\x11(\t0 \0\x03\0\x02\x01\fPacific/Wake\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\r\xf7\xa9\xc9\xec\f\0\x02\0\x01\x0ePacific/Wallis\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\f,\0\0\0\r\xf7\xa9\xc9\xec\f\0\x02\0\x01\vPacific/Yap\0$\x03o\xff\xff\xff\xf1\x86\x8cH\xe0\t0 \f\x1c7J\x88\n/\0\0\0\r\xd0*\x11(\t0 \0\x03\0\x02\x01\x06Poland\0\xd2\f\f\0\xe6\xb6\x80\x01\f\0\xef\xf1\0\x01\f\0\xf9+\x80\x01\f\x01\x14\xdb\0\x01\f\x01\x1e\x15\x80\x01|\xff\xff\xff\xf1\x86\x8cH\xe0\x02\x1c\0\xc1\xcc\x80\x02\x1c\0\xcb\x07\0\x02\x1c\0\xef\xf1\0\x02\x1c\0\xef\xff\x10\x02\x1c\0\xf9+\x80\x02<\0\0\0\x0e\x87\x18\f\xa0\x02\0\x7f\x05\v\0\n\x01\b\x01\n\0\b\x01\b\x01\b\x01\b\x02\b\x01\b\x01\b\x01\t\x01\b\x01\b\x02\b\x01\b\x01\b\x01\b\x01\b\x01\n\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\x06\x04\x06\x04\x07\x03\x07\x03\x07\x04\x06\x04\bPortugal\0\xe4\x10\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\0\xef\xe2\xf0\x01\x1c\0\xef\xf1\0\x01\x1c\0\xef\xf1\0\x02\x1c\0\xef\xff\x10\x01\x1c\0\xf9+\x80\x01\x1c\0\xf99\x90\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\0\xe6\xb6\x80\b\0\xef\xf1\0\f\0\xef\xf1\0\x01\b\0\xf9+\x80\b\x01\x14\xdb\0\b\x01\x1e\x15\x80(\0\0\0\x0e\x86\x1e\xe1 \0\x80\b\x0f\x03\n\x07\n\x03\n\x06\t\x02\n\x03\n\x03\n\x03\f\x03\n\x05\n\x03\n\x03\n\x03\n\x03\f\x03\n\x03\v\x04\v\x04\v\x04\v\x06\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\x03ROC\x006\x06\f\0y;\xf0\b\f\0\xf14p\b|\xff\xff\xff\xf1\x86\x8cH\xe0\t\x1c\0\xef\xff\x10\t\x1c\x07\f\xe3\x90\t<\0\0\0\x0e\x81p\r \t\0\x07\x02\x05\x01\x03\x01\x04\0\x03ROK\0(\x04\f\0\xcb\x07\0\t|\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1c\x01\x14\xdb\0\n<\0\0\0\x0e\x9a\x17\x17\xb0\n\0\x05\x01\x03\0\x02\0\tSingapore\0\x19\x02l\xff\xff\xff\xf1\x86\x8cH\xe0\b,\0\0\0\x0e\x90\x05\xa5 \b\0\x02\0\x01\x06Turkey\x013$\f\0\xcb\x07\0\x02\f\0\xd4A\x80\x02\f\0\xef\xf1\0\x02\f\0\xf9+\x80\x02\f\x01\x02W\xf0\x02\f\x01\x13\x89\x80\x02\f\x01\x14\xdb\0\x02\f\x01\x1c\xc4\0\x02\f\x01\x1e\x07p\x02\f\x01\x1e\x15\x80\x02\f\x01'A\xf0\x02\f\x01'P\0\x02\f\x01(\x93p\x02\f\x02\n \x10\x02|\xff\xff\xff\xf1\x86\x8cH\xe0\x03\f\0S\0p\x03\f\0s\xd9\xd0\x03\x1c\0\xb7N\x90\x03\x1c\0\xb8\x92\0\x03\x1c\0\xb8\xa0\x10\x03\x1c\0\xc1\xcc\x80\x03\x1c\0\xc1\xda\x90\x03\x1c\0\xc1\xe8\xa0\x03\x1c\0\xc3\x1e\0\x03\x1c\0\xcb\x07\0\x03\x1c\0\xcb\x15\x10\x03\x1c\0\xccX\x80\x03\f\0\xd7\xfd\xc0\x03\x1c\0\xdd\x8a\x10\x03\x1c\0\xe0\x1f\0\x03\x1c\0\xe6\xb6\x80\x03\x1c\0\xef\xf1\0\x03\x1c\0\xf1B\x80\x03\x1c\0\xf9+\x80\x03\x1c\t\x91\x9f \x04<\0\0\0\x0e\x7f\xe2J\x90\x03\0P\x0e#\0\x15\b\x11\f\x13\n\x19\x04\x1c\x10\"\x0f\r\x1d\x01 \x02\x1f\x02\x1f\x02\x1f\x02\x1f\x03\x1f\x02\x1f\x02\x1f\x02\x1e\x03\x1f\x02!\x06\x18\x06\x18\x06\x18\t\x14\t\x14\t\x18\x06\x18\x06\x18\t\x14\t\x14\t\x16\t\x18\x06\x18\x06\x18\t\x17\x07\x14\t\x18\x06\x1a\x05\x18\v\x12\x1b\x03UCT\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\tUS/Alaska\x01#\x17\x04\0\xef\xe2\xf0\n\x04\0\xf9\x1dp\n\x04\x01B\xf1p\n\x04\x01\x83\x8a\xf0\nt\xff\xff\xff\xf1\x86\x8cH\xe0\t\x04\0(\xc2`\t\x14\0\\W\x10\t\x14\0\x9c\xf0\x90\t\x04\x019\xb6\xf0\t\x14\0\xa6+\x10\b\x14\0\xafe\x90\b\x14\0\xc7.\xa0\b\x14\0\xcb\x15\x10\b\x14\0\xd4O\x90\b\x14\0\xe6\xc4\x90\t\x04\0\xef\xe2\xf0\t\x14\0\xef\xff\x10\t\x14\0\xef\xff\x10\b\x04\0\xf9\x1dp\t\x04\x01\v\x92p\t\x04\x01\x14\xcc\xf0\t\x04\x019\xb6\xf0\t4\0\0\0\x0ez\v\xfc`\t\0\x8e\x04\x16\0\x10\x01\x10\0\x10\0\x06\x03\x07\x02\x10\x01\x0e\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0e\x12\x05\v\x0f\x11\x0f\x11\x0f\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\n\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\vUS/Aleutian\x01#\x17\x04\0\xef\xe2\xf0\v\x04\0\xf9\x1dp\v\x04\x01B\xf1p\v\x04\x01\x83\x8a\xf0\vt\xff\xff\xff\xf1\x86\x8cH\xe0\n\x04\0(\xc2`\n\x14\0\\W\x10\n\x14\0\x9c\xf0\x90\n\x04\x019\xb6\xf0\n\x14\0\xa6+\x10\t\x14\0\xafe\x90\t\x14\0\xc7.\xa0\t\x14\0\xcb\x15\x10\t\x14\0\xd4O\x90\t\x14\0\xe6\xc4\x90\n\x04\0\xef\xe2\xf0\n\x14\0\xef\xff\x10\n\x14\0\xef\xff\x10\t\x04\0\xf9\x1dp\n\x04\x01\v\x92p\n\x04\x01\x14\xcc\xf0\n\x04\x019\xb6\xf0\n4\0\0\0\x0ez\f\np\n\0\x8e\x04\x16\0\x10\x01\x10\0\x10\0\x06\x03\x07\x02\x10\x01\x0e\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0e\x12\x05\v\x0f\x11\x0f\x11\x0f\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x13\r\x14\f\x14\f\x14\r\x13\r\x13\r\x14\f\x14\f\x14\n\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\n\b\t\b\t\b\t\b\t\b\t\b\n\b\t\b\nUS/Arizona\0Y\v\x14\0x\x06\x90\x06\x14\0\xcb\x15\x10\x06\x14)\xee#\x10\x06\x14*wZ\xf4\x06\x14@\xa2-\xe0\x06d\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x04\0\xef\xe2\xf0\x07\x04\0\xf14p\x07\x04\x01\x14\xcc\xf0\x07\x04\x03\x8e\xd2\x8c\x07$\0\0\0\r\xd7w\xc3\xd0\x07\0\f\x05\n\x04\b\x01\b\x02\t\0\x07\x03\x06\nUS/Central\0\xfe\x11\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x019\xb6\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x054\0\0\0\x0ez\v\xc4 \x05\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\x0fUS/East-Indiana\0\x82\b\x04\0\xef\xe2\xf0\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14B\xa7\x94\x90\x044\0\0\0\x0ez\v\xb6\x10\x04\0G\x03\x07\0\x06\x01\x05\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\x04\x02\x04\x02\x04\x02\x04\x02\x05\x02\x04\x02\nUS/Eastern\0\xfe\x11\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01B\xf1p\x05\x04\x01\x83\x8a\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\\W\x10\x04\x14\0\x9c\xf0\x90\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0ez\v\xb6\x10\x04\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\tUS/Hawaii\0J\b\x16\x06\x9a\xb6\xa8\t\x1e\x16\x10g\xccp\t\x1e\x16F$\xd2\x8a\t\x1ef\xff\xff\xff\xf1\x86\x8cH\xe0\n\x1e\x06\0\x1c.\x10\n\x1e\x06\0=T\xc8\n\x1e\x04\x03,*\x10\n&\0\0\0\r\xeeT'\xde\n\x1e\0\b\x03\x07\x02\x04\x01\0\x05\x06\x11US/Indiana-Starke\0\xf4\x14\x04\0\xef\xe2\xf0\x06\x04\0\xf9\x1dp\x06\x04\x01\v\x92p\x06\x04\x01\x14\xcc\xf0\x06\x04\x01\x14\xdb\0\x06\x04\x019\xb6\xf0\x06\x04\x01B\xf1p\x06\x04\x01\x83\x8a\xf0\x06t\xff\xff\xff\xf1\x86\x8cH\xe0\x05\x14\0\\W\x10\x05\x14\0\x9c\xf0\x90\x05\x14\0\xa6+\x10\x05\x14\0\xafe\x90\x05\x14\0\xcb\x15\x10\x05\x14\0\xd4O\x90\x05\x14\0\xe6\xc4\x90\x05\x14\0\xef\xff\x10\x05\x14\x1b%\x12\x80\x05\x04\x01\v\x92p\x054\0\0\0\x0ez\v\xc4 \x05\0q\b\x13\0\x10\x01\x10\0\x10\0\t\x07\n\x06\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x10\0\x10\x01\x0f\x01\x10\0\x10\0\x10\0\x0e\x02\x0e\x03\r\x03\r\x03\x0e\x12\x11\x04\f\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\v\x05\v\x05\v\x05\v\x05\f\x05\v\x05\vUS/Michigan\0\xec\x0f\x04\0\xef\xe2\xf0\x05\x04\0\xf9\x1dp\x05\x04\x01\v\x92p\x05\x04\x01\x14\xcc\xf0\x05\x04\x019\xb6\xf0\x05\x04\x01\x83\x8a\xf0\x05t\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x14\0\\W\x10\x04\x14\0\xa6+\x10\x04\x14\0\xafe\x90\x04\x14\0\xcb\x15\x10\x04\x14\0\xd4O\x90\x04\x14\0\xe6\xc4\x90\x04\x14\0\xef\xff\x10\x044\0\0\0\x0e\x7f\xb4\x96\x90\x04\0\x87\x06\x0e\0\x07\x05\r\0\r\x01\f\x01\r\0\r\0\r\0\r\0\r\x01\f\x01\r\0\r\0\r\0\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x02\v\x03\n\x03\n\x03\v\x02\v\x02\v\x03\n\x03\n\x03\t\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\b\x04\b\x04\b\x04\b\x04\t\x04\b\x04\vUS/Mountain\0\xfe\x11\x04\0\xef\xe2\xf0\x07\x04\0\xf9\x1dp\x07\x04\x01\v\x92p\x07\x04\x01\x14\xcc\xf0\x07\x04\x019\xb6\xf0\x07\x04\x01B\xf1p\x07\x04\x01\x83\x8a\xf0\x07t\xff\xff\xff\xf1\x86\x8cH\xe0\x06\x14\0\\W\x10\x06\x14\0\x9c\xf0\x90\x06\x14\0\xa6+\x10\x06\x14\0\xafe\x90\x06\x14\0\xcb\x15\x10\x06\x14\0\xd4O\x90\x06\x14\0\xe6\xc4\x90\x06\x14\0\xef\xff\x10\x064\0\0\0\x0ez\v\xd20\x06\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\nUS/Pacific\0\xfe\x11\x04\0\xef\xe2\xf0\b\x04\0\xf9\x1dp\b\x04\x01\v\x92p\b\x04\x01\x14\xcc\xf0\b\x04\x019\xb6\xf0\b\x04\x01B\xf1p\b\x04\x01\x83\x8a\xf0\bt\xff\xff\xff\xf1\x86\x8cH\xe0\x07\x14\0\\W\x10\x07\x14\0\x9c\xf0\x90\x07\x14\0\xa6+\x10\x07\x14\0\xafe\x90\x07\x14\0\xcb\x15\x10\x07\x14\0\xd4O\x90\x07\x14\0\xe6\xc4\x90\x07\x14\0\xef\xff\x10\x074\0\0\0\x0ez\v\xe0@\x07\0\x8d\x07\x10\0\x0f\x01\x0f\0\x0f\0\b\x06\t\x05\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x01\x0e\x01\x0f\0\x0f\0\x0f\0\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x02\r\x03\f\x03\f\x03\r\x02\r\x02\r\x03\f\x03\f\x03\v\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\n\x04\n\x04\n\x04\n\x04\v\x04\n\x04\bUS/Samoa\0\x19\x02d\xff\xff\xff\xf1\x86\x8cH\xe0\v$\0\0\0\x0e\ny\xb2(\v\0\x02\0\x01\x03UTC\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\tUniversal\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0\x04W-SU\0\xc3\x14\f\0\x93\xa8\0\x03\f\0\xef\xff\x10\x02\x1c\0\xef\xf1\0\x03\f\0\xef\xf1\0\x03\f\0\xf0\r \x03\f\0\xf14p\x03\f\0\xf9+\x80\x03\f\x01\x14\xdb\0\x03\f\x01\x1e\x15\x80\x03\f\x06\xbd\xadp\x03|\xff\xff\xff\xf1\x86\x8cH\xe0\x04\x1c\0\\:\xf0\x04\x1c\0\xc1\xcc\x80\x04\f\0\xc1\xcc\x80\x04\x1c\0\xcb\x07\0\x04\x1c\0\xef\xf1\0\x04\x1c\0\xef\xff\x10\x04\x1c\0\xf1P\x90\x04\x1c\0\xf9+\x80\x04<\0\0\0\x0e\x8e\x9b^\xf0\x04\0@\n\x13\x05\x10\x05\x10\x05\x11\x04\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x03\x0f\x06\x02\x01\0\v\x03\x0f\x03\x0f\x03\x0f\x03\x12\x07\x0e\x07\x0e\x07\x0e\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\f\b\f\b\f\b\x0e\x07\x0e\x07\x0e\b\r\t\x03WET\0\xe4\x10\x1c\0\xc1\xcc\x80\x01\x1c\0\xcb\x07\0\x01\x1c\0\xef\xe2\xf0\x01\x1c\0\xef\xf1\0\x01\x1c\0\xef\xf1\0\x02\x1c\0\xef\xff\x10\x01\x1c\0\xf9+\x80\x01\x1c\0\xf99\x90\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\b\0\xe6\xb6\x80\b\0\xef\xf1\0\f\0\xef\xf1\0\x01\b\0\xf9+\x80\b\x01\x14\xdb\0\b\x01\x1e\x15\x80(\0\0\0\x0e\x86\x1e\xe1 \0\x80\b\x0f\x03\n\x07\n\x03\n\x06\t\x02\n\x03\n\x03\n\x03\f\x03\n\x05\n\x03\n\x03\n\x03\n\x03\f\x03\n\x03\v\x04\v\x04\v\x04\v\x06\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\0\x0e\0\x0e\x01\r\x01\r\x01\x0e\0\x0e\x04Zulu\0\r\x01h\xff\xff\xff\xf1\x86\x8cH\xe0\0\x01\0"]);
		               function make$26(name, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         fixed_offset_name_parser,
		                         name,
		                         function(a){
		                          if(0 === a[0]) var x = a[1], a = [0, x]; else a = 0;
		                          if(! a)
		                           return caml_exact_trampoline_cps_call$1
		                                   (M$4[18],
		                                    name,
		                                    db[1],
		                                    function(match){
		                                     function a(match){
		                                      if(! match) return cont(0);
		                                      var record = match[1];
		                                      return cont([0, [0, [0, name], record]]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call$1
		      (M$4[18],
		       name,
		       half_compressed,
		       function(b){
		        if(! b) return a(0);
		        var compressed_table = b[1];
		        function c(match){
		         function b(table){
		          return caml_exact_trampoline_cps_call
		                  (check_table,
		                   table,
		                   function(b){
		                    if(b)
		                     return caml_exact_trampoline_cps_call$0
		                             (M$4[2],
		                              name,
		                              table,
		                              db[1],
		                              function(b){
		                               db[1] = b;
		                               return caml_exact_trampoline_cps_call
		                                       (process_table, table, function(b){return a([0, b]);});
		                              });
		                    b = caml_pop_trap();
		                    return b
		                            (caml_maybe_attach_backtrace([0, Assert_failure, MS], 1));
		                   });
		         }
		         if(! match)
		          return caml_exact_trampoline_cps_call
		                  (invalid_arg, "failed to deserialize compressed table", b);
		         var x = match[1];
		         return b(x);
		        }
		        caml_push_trap(function(exn){return c(0);});
		        b = uint8(0, compressed_table);
		        var
		         uniq_relative_entry_count = b[2],
		         pos = b[1],
		         b =
		           count$2
		            (uniq_relative_entry_count,
		             relative_entry,
		             pos,
		             compressed_table),
		         uniq_relative_entries = b[2],
		         pos$0 = b[1],
		         b = be_uint16(pos$0, compressed_table),
		         index_count = b[2],
		         pos$1 = b[1],
		         b = count$2(index_count, uint8, pos$1, compressed_table),
		         indices = b[2],
		         pos$2 = b[1];
		        return caml_exact_trampoline_cps_call
		                (to_array,
		                 indices,
		                 function(indices){
		                  return caml_exact_trampoline_cps_call
		                          (to_array,
		                           uniq_relative_entries,
		                           function(uniq_relative_entries){
		                            var
		                             size = indices.length - 1,
		                             starts = create$2(7, c_layout, size),
		                             entries = caml_make_vect(size, MO),
		                             b = indices.length - 2 | 0;
		                            if(b >= 0){
		                             var i = 0;
		                             for(;;){
		                              var
		                               index = indices[i + 1],
		                               entry =
		                                 caml_check_bound(uniq_relative_entries, index)[index + 1];
		                              if(entry[2])
		                               caml_ba_set_1(starts, i, entry[1]);
		                              else {
		                               var a = entry[1];
		                               caml_ba_set_1
		                                (starts,
		                                 i,
		                                 caml_int64_add(caml_ba_get_1(starts, i - 1 | 0), a));
		                              }
		                              a = [0, entry[3], entry[4]];
		                              caml_check_bound(entries, i)[i + 1] = a;
		                              a = i + 1 | 0;
		                              if(b === i) break;
		                              i = a;
		                             }
		                            }
		                            var table = [0, starts, entries];
		                            return caml_exact_trampoline_cps_call
		                                    (check_table,
		                                     table,
		                                     function(a){
		                                      a = a ? [0, , [0, table]] : [0, , 0];
		                                      var x = a[2];
		                                      if(pos$2 === caml_ml_string_length(compressed_table)){caml_pop_trap(); return c(x);}
		                                      a = caml_pop_trap();
		                                      return a
		      (caml_maybe_attach_backtrace([0, Assert_failure, MP], 1));
		                                     });
		                           });
		                 });
		       });
		                                     var table = match[1];
		                                     return caml_exact_trampoline_cps_call
		     (check_table,
		      table,
		      function(b){
		       if(b)
		        return caml_exact_trampoline_cps_call
		                (process_table, table, function(b){return a([0, b]);});
		       b = caml_pop_trap();
		       return b
		               (caml_maybe_attach_backtrace([0, Assert_failure, MR], 1));
		      });
		                                    });
		                          var fixed = a[1];
		                          return caml_exact_trampoline_cps_call
		                                  (make_offset_only, fixed, cont);
		                         });
		               }
		               var bQ1 = M$4[39].call(null, db[1]);
		               function bQ2(a, cont){return cont(a[1]);}
		               var
		                s0$0 =
		                  caml_callback
		                   (of_seq$0,
		                    [function(a, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (map, bQ2, bQ1, dummy, cont);
		                     }]),
		                bQ3 = M$4[39].call(null, half_compressed);
		               function bQ4(a, cont){return cont(a[1]);}
		               var
		                s1$0 =
		                  caml_callback
		                   (of_seq$0,
		                    [function(a, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (map, bQ4, bQ3, dummy, cont);
		                     }]);
		               of_seq(to_seq$2(caml_callback(union$4, [s0$0, s1$0])));
		               function get_local_tz_for_arg(a, cont){
		                var cst_etc_localtime = "/etc/localtime";
		                function process_etc_localtime_symlink(param, cont){
		                 caml_push_trap(function(exn){return cont(0);});
		                 var real_path = caml_unix_readlink(cst_etc_localtime);
		                 return caml_exact_trampoline_cps_call$1
		                         (split_on_char,
		                          47,
		                          real_path,
		                          function(parts){
		                           var accu = [0, 0, parts];
		                           function a(accu, l$0){
		                            if(l$0){
		                             var l = l$0[2], parts = accu[2], acc = accu[1];
		                             return caml_exact_trampoline_cps_call
		                                     (tl_exn,
		                                      parts,
		                                      function(b){
		                                       var accu = [0, [0, parts, acc], b];
		                                       return caml_exact_trampoline_call2(a, accu, l);
		                                      });
		                            }
		                            var combinations = accu[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$0,
		                                     function(a, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (concat, cst$34, a, cont);
		                                     },
		                                     combinations,
		                                     function(a){caml_pop_trap(); return cont(a);});
		                           }
		                           return a(accu, parts);
		                          });
		                }
		                var a = getenv_opt("TZ");
		                function b(l){
		                 var l$0 = l || Md;
		                 function b(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call
		                           (invalid_arg,
		                            "get_local_tz_for_arg: Could not determine the local time zone. Please specify ~tz* explicitly or use an appropriate timedesc-tzlocal.* module.",
		                            cont);
		                  var x = match[1];
		                  return cont(x);
		                 }
		                 if(! l$0) return b(0);
		                 function a(accu, l$0){
		                  if(! l$0) return b(accu);
		                  var l = l$0[2], name = l$0[1];
		                  if(! accu)
		                   return caml_exact_trampoline_cps_call
		                           (make$26,
		                            name,
		                            function(b){return caml_exact_trampoline_call2(a, b, l);});
		                  var tz = accu[1];
		                  return caml_exact_trampoline_call2(a, [0, tz], l);
		                 }
		                 return a(0, l$0);
		                }
		                if(a){
		                 var
		                  name = a[1],
		                  d =
		                    function(name){
		                     return name === cst_etc_localtime
		                             ? caml_exact_trampoline_cps_call
		                               (process_etc_localtime_symlink, dummy, b)
		                             : b([0, name, 0]);
		                    };
		                 return 58 === caml_string_get(name, 0)
		                         ? caml_exact_trampoline_cps_call$0
		                           (get_sub, name, 1, caml_ml_string_length(name) - 1 | 0, d)
		                         : d(name);
		                }
		                if(! caml_sys_file_exists("/system/bin/getprop")){
		                 var
		                  c =
		                    function(accu, l$1){
		                     if(l$1){
		                      var l = l$1[2], file = l$1[1];
		                      if(accu){
		                       var tz = accu[1];
		                       return caml_exact_trampoline_call2(c, [0, tz], l);
		                      }
		                      caml_push_trap
		                       (function(exn){return caml_exact_trampoline_call2(c, 0, l);});
		                      return caml_exact_trampoline_cps_call$1
		                              (with_in,
		                               file,
		                               function(ic, cont){
		                                var lines = read_lines_l(ic);
		                                if(! lines) return cont(0);
		                                var x = lines[1];
		                                return caml_exact_trampoline_cps_call$0
		(get_sub,
		 x,
		 0,
		 5,
		 function(b){
		  if(b === "TZif2") return cont(0);
		  function a(accu, l$0){
		   if(! l$0) return cont(accu);
		   var l = l$0[2], line = l$0[1];
		   if(! accu)
		    return caml_exact_trampoline_cps_call$1
		            (split_on_char,
		             32,
		             line,
		             function(b){
		              return caml_exact_trampoline_cps_call
		                      (hd_exn,
		                       b,
		                       function(b){
		                        return caml_exact_trampoline_cps_call$1
		                                (split_on_char,
		                                 35,
		                                 b,
		                                 function(b){
		                                  return caml_exact_trampoline_cps_call
		  (hd_exn,
		   b,
		   function(name){
		    return caml_exact_trampoline_call2(a, [0, name], l);
		   });
		                                 });
		                       });
		             });
		   var tz = accu[1];
		   return caml_exact_trampoline_call2(a, [0, tz], l);
		  }
		  return a(0, lines);
		 });
		                               },
		                               function(a){
		                                caml_pop_trap();
		                                return caml_exact_trampoline_call2(c, a, l);
		                               });
		                     }
		                     if(accu){var name = accu[1]; return b([0, name, 0]);}
		                     function a(accu, l$0){
		                      if(! l$0){
		                       if(! accu)
		                        return caml_exact_trampoline_cps_call
		                                (process_etc_localtime_symlink, dummy, b);
		                       var name = accu[1];
		                       return b([0, name, 0]);
		                      }
		                      var l = l$0[2], file = l$0[1];
		                      if(accu){
		                       var tz = accu[1];
		                       return caml_exact_trampoline_call2(a, [0, tz], l);
		                      }
		                      caml_push_trap
		                       (function(exn){return caml_exact_trampoline_call2(a, 0, l);});
		                      return caml_exact_trampoline_cps_call$1
		                              (with_in,
		                               file,
		                               function(ic, cont){
		                                var lines = read_lines_l(ic);
		                                function a(accu, l$0){
		                                 if(! l$0) return cont(accu);
		                                 var l = l$0[2], line = l$0[1];
		                                 if(accu){
		                                  var tz = accu[1];
		                                  return caml_exact_trampoline_call2(a, [0, tz], l);
		                                 }
		                                 function b(name){
		                                  if(! name) return caml_exact_trampoline_call2(a, 0, l);
		                                  var s = name[1];
		                                  return caml_exact_trampoline_cps_call$1
		  (split_on_char,
		   32,
		   s,
		   function(b){
		    return caml_exact_trampoline_cps_call$1
		            (concat,
		             cst$13,
		             b,
		             function(b){
		              return caml_exact_trampoline_call2(a, [0, b], l);
		             });
		   });
		                                 }
		                                 caml_push_trap
		                                  (function(exn){
		                                    caml_push_trap(function(exn){return b(0);});
		                                    function a(a, cont){return cont(a);}
		                                    return caml_exact_trampoline_cps_call$1
		    (sscanf,
		     line,
		     Mb,
		     function(c){
		      return caml_trampoline_cps_call2
		              (c, a, function(a){caml_pop_trap(); return b([0, a]);});
		     });
		                                   });
		                                 function c(a, cont){return cont(a);}
		                                 return caml_exact_trampoline_cps_call$1
		 (sscanf,
		  line,
		  Mc,
		  function(a){
		   return caml_trampoline_cps_call2
		           (a, c, function(a){caml_pop_trap(); return b([0, a]);});
		  });
		                                }
		                                return a(0, lines);
		                               },
		                               function(b){
		                                caml_pop_trap();
		                                return caml_exact_trampoline_call2(a, b, l);
		                               });
		                     }
		                     return a(0, l$0);
		                    };
		                 return c(0, l);
		                }
		                a = caml_unix_pipe(qp, 0);
		                var
		                 new_stdout = a[2],
		                 in_read = a[1],
		                 inchan = caml_unix_inchannel_of_filedescr(in_read);
		                caml_push_trap
		                 (function(e){
		                   caml_ml_close_channel(inchan);
		                   caml_unix_close(new_stdout);
		                   var
		                    raise = caml_pop_trap(),
		                    e$0 = caml_maybe_attach_backtrace(e, 0);
		                   return raise(e$0);
		                  });
		                var toclose = [0, 0];
		                function close_after(a){
		                 a = toclose[1];
		                 for(;;){
		                  if(! a) return;
		                  var l = a[2], fd = a[1];
		                  try{caml_unix_close(fd); a = l;}
		                  catch(exn$0){
		                   var exn = caml_wrap_exception(exn$0);
		                   if(exn[1] !== Unix_error)
		                    throw caml_maybe_attach_backtrace(exn, 0);
		                   a = l;
		                  }
		                 }
		                }
		                if(1 === new_stdout)
		                 a = 1;
		                else {
		                 var fd$0 = new_stdout;
		                 for(;;){
		                  if(3 <= fd$0){a = fd$0; break;}
		                  var fd = caml_unix_dup(qo, fd$0);
		                  toclose[1] = [0, fd, toclose[1]];
		                  fd$0 = fd;
		                 }
		                }
		                var
		                 redirections = [0, 0, a, 2],
		                 cst_bin_sh = "/bin/sh",
		                 args = [0, cst_bin_sh, "-c", "getprop"],
		                 proc = [1, inchan];
		                return caml_exact_trampoline_cps_call$1
		                        (protect,
		                         close_after,
		                         function(param, cont){
		                          return cont
		                                  (caml_unix_spawn(cst_bin_sh, args, 0, 1, redirections));
		                         },
		                         function(pid){
		                          caml_ml_mutex_lock(popen_mutex);
		                          caml_push_trap
		                           (function(e){
		                             caml_ml_mutex_unlock(popen_mutex);
		                             var
		                              raise = caml_pop_trap(),
		                              e$0 = caml_maybe_attach_backtrace(e, 0);
		                             return raise(e$0);
		                            });
		                          return caml_exact_trampoline_cps_call$0
		                                  (add$0,
		                                   popen_processes,
		                                   proc,
		                                   pid,
		                                   function(x){
		                                    caml_pop_trap();
		                                    caml_ml_mutex_unlock(popen_mutex);
		                                    caml_pop_trap();
		                                    caml_unix_close(new_stdout);
		                                    var name = read_lines_l(inchan);
		                                    caml_ml_close_channel(inchan);
		                                    return b(name);
		                                   });
		                         });
		               }
		               make$21(0, MT);
		               function min_of_local_date_time_result(r){
		                var x = -306849112 <= r[1] ? r[2] : r[2][1];
		                return x;
		               }
		               var
		                jd_span_of_unix_epoch =
		                  make_exn(0, [0, jd_of_unix_epoch], 0, 0, 0);
		               function of_timestamp(opt, x, cont){
		                function a(tz_of_date_time){
		                 if
		                  (symbol$100(timestamp_min, x)
		                   && symbol$100(x, timestamp_max)){
		                  var
		                   timestamp = x[1],
		                   table = tz_of_date_time[2][2],
		                   entries = table[2],
		                   a = bsearch_table(timestamp, table);
		                  if(typeof a === "number")
		                   if(50834029 === a)
		                    a = 0;
		                   else if(814295299 <= a){
		                    a = entries.length - 2 | 0;
		                    a = [0, caml_check_bound(entries, a)[a + 1]];
		                   }
		                   else
		                    a = 0;
		                  else {
		                   var variant = a[1];
		                   if(550003881 <= variant)
		                    var i = a[2], a = [0, caml_check_bound(entries, i)[i + 1]];
		                   else
		                    var
		                     i$0 = a[2],
		                     a = [0, caml_check_bound(entries, i$0)[i$0 + 1]];
		                  }
		                  if(! a) return cont(0);
		                  var
		                   entry = a[1],
		                   timestamp_local = symbol$97(x, make_small([0, entry[2]], 0)),
		                   x$0 = symbol$97(jd_span_of_unix_epoch, timestamp_local),
		                   v = view(x$0),
		                   a = ymd_of_jd(v[2]),
		                   day = a[3],
		                   month = a[2],
		                   year = a[1],
		                   ns = v[6],
		                   second = v[5],
		                   minute = v[4],
		                   hour = v[3];
		                  return caml_exact_trampoline_cps_call$0
		                          (make$24,
		                           year,
		                           month,
		                           day,
		                           function(a){
		                            if(0 !== a[0]){
		                             var e = a[1], a = caml_pop_trap();
		                             return a
		                                     (caml_maybe_attach_backtrace([0, Error_exn$0, e], 1));
		                            }
		                            var
		                             date = a[1],
		                             a = make$25([0, ns], 0, hour, minute, second);
		                            if(0 === a[0]){
		                             var time = a[1];
		                             return cont
		                                     ([0,
		                                       [0,
		date,
		time,
		tz_of_date_time,
		[0, -306849112, make_small([0, entry[2]], 0)]]]);
		                            }
		                            var e$0 = a[1], a = caml_pop_trap();
		                            return a
		                                    (caml_maybe_attach_backtrace([0, Error_exn$1, e$0], 1));
		                           });
		                 }
		                 return cont(0);
		                }
		                return opt
		                        ? a(opt[1])
		                        : caml_exact_trampoline_cps_call
		                          (get_local_tz_for_arg, dummy, a);
		               }
		               caml_callback
		                (option_get_exn_or,
		                 ["expected successful date time construction for min_val",
		                  caml_callback(of_timestamp, [[0, dummy_tz], timestamp_min])]);
		               caml_callback
		                (option_get_exn_or,
		                 ["expected successful date time construction for max_val",
		                  caml_callback(of_timestamp, [[0, dummy_tz], timestamp_max])]);
		               function to_zoned(opt, zl, cont){
		                function a(tz){
		                 var
		                  time$0 = zl[2],
		                  date$0 = zl[1],
		                  time = zl[2],
		                  date = zl[1],
		                  a = make_small([0, time[1]], [0, time[2] % 1000000000 | 0]),
		                  timestamp_local =
		                    symbol$97
		                     (symbol$98
		                       (make_exn(0, [0, date[1]], 0, 0, 0),
		                        jd_span_of_unix_epoch),
		                      a),
		                  timestamp = timestamp_local[1],
		                  table = tz[2][2],
		                  entries = table[2],
		                  starts = table[1],
		                  size = caml_ba_dim_1(starts),
		                  a = bsearch_table(timestamp, table);
		                 if(typeof a === "number")
		                  var
		                   index =
		                     50834029 === a ? 0 : 814295299 <= a ? [0, size - 1 | 0] : MM;
		                 else {
		                  var variant = a[1];
		                  if(550003881 <= variant)
		                   var i = a[2], index = [0, i];
		                  else
		                   var i$0 = a[2], index = [0, i$0];
		                 }
		                 function b(a){
		                  if(typeof a === "number") return cont(MU);
		                  var variant = a[1];
		                  if(-306849112 <= variant){
		                   var e = a[2];
		                   return cont
		                           ([0,
		                             [0,
		                              date$0,
		                              time$0,
		                              tz,
		                              [0, -306849112, make_small([0, e[2]], 0)]]]);
		                  }
		                  a = a[2];
		                  var
		                   e2 = a[2],
		                   e1 = a[1],
		                   x1 = make_small([0, e1[2]], 0),
		                   x2 = make_small([0, e2[2]], 0);
		                  return cont
		                          ([0, [0, date$0, time$0, tz, [0, -328798100, [0, x1, x2]]]]);
		                 }
		                 if(! index) return b(870530776);
		                 var index$0 = index[1];
		                 a:
		                 {
		                  if
		                   (0 < index$0
		                    &&
		                     interval_mem
		                      (timestamp, local_interval_of_table(table, index$0 - 1 | 0))){
		                   a = index$0 - 1 | 0;
		                   var x1 = [0, caml_check_bound(entries, a)[a + 1]];
		                   break a;
		                  }
		                  x1 = 0;
		                 }
		                 var
		                  x2 =
		                    interval_mem
		                      (timestamp, local_interval_of_table(table, index$0))
		                     ? [0, caml_check_bound(entries, index$0)[index$0 + 1]]
		                     : 0;
		                 a:
		                 {
		                  if
		                   (index$0 < (size - 1 | 0)
		                    &&
		                     interval_mem
		                      (timestamp, local_interval_of_table(table, index$0 + 1 | 0))){
		                   a = index$0 + 1 | 0;
		                   var x3 = [0, caml_check_bound(entries, a)[a + 1]];
		                   break a;
		                  }
		                  x3 = 0;
		                 }
		                 a:
		                 {
		                  if(x1){
		                   var x = x1[1];
		                   if(x2){
		                    var y = x2[1];
		                    if(x3)
		                     return caml_exact_trampoline_cps_call
		                             (failwith, cst_unexpected_case, b);
		                    var y$0 = y, x$0 = x;
		                    break a;
		                   }
		                   if(x3){y$0 = x3[1]; x$0 = x; break a;}
		                   var x$1 = x;
		                  }
		                  else if(x2){
		                   a = x2[1];
		                   if(x3){y$0 = x3[1]; x$0 = a; break a;}
		                   x$1 = a;
		                  }
		                  else {if(! x3) return b(870530776); x$1 = x3[1];}
		                  return b([0, -306849112, x$1]);
		                 }
		                 return b([0, -328798100, [0, x$0, y$0]]);
		                }
		                return opt
		                        ? a(opt[1])
		                        : caml_exact_trampoline_cps_call
		                          (get_local_tz_for_arg, dummy, a);
		               }
		               var
		                Error_exn$2 =
		                  [248,
		                   "Timedesc__Date_time.Ymd_date_time.Error_exn",
		                   caml_fresh_oo_id()];
		               function string_of_error(e, cont){
		                if(typeof e === "number") return cont("does not exist");
		                var variant = e[1];
		                if(-81896606 <= variant){
		                 if(-36072467 === variant){
		                  var x = e[2];
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           MV,
		                           function(a){return caml_trampoline_cps_call2(a, x, cont);});
		                 }
		                 if(554978456 <= variant){
		                  if(653440095 > variant){
		                   var x$0 = e[2];
		                   return caml_exact_trampoline_cps_call
		                           (sprintf,
		                            MX,
		                            function(a){return caml_trampoline_cps_call2(a, x$0, cont);});
		                  }
		                  var
		                   match = e[2],
		                   offset = match[2],
		                   tz = match[1],
		                   offset$0 = view(offset),
		                   a = offset$0[4],
		                   b = offset$0[3],
		                   c = 4003188 <= offset$0[1] ? 43 : 45;
		                  if(tz) var tz$0 = tz[1], tz$1 = tz$0; else tz$1 = cst_none;
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           MW,
		                           function(d){
		                            return caml_trampoline_cps_call5(d, tz$1, c, b, a, cont);
		                           });
		                 }
		                 if(545273268 <= variant){
		                  var x$1 = e[2];
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           MY,
		                           function(a){return caml_trampoline_cps_call2(a, x$1, cont);});
		                 }
		                 var x$2 = e[2];
		                 return caml_exact_trampoline_cps_call
		                         (sprintf,
		                          MZ,
		                          function(a){return caml_trampoline_cps_call2(a, x$2, cont);});
		                }
		                if(-577554587 <= variant){
		                 if(-309856484 <= variant){
		                  var x$3 = e[2];
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           M0,
		                           function(a){return caml_trampoline_cps_call2(a, x$3, cont);});
		                 }
		                 var x$4 = e[2];
		                 return caml_exact_trampoline_cps_call
		                         (sprintf,
		                          M1,
		                          function(a){return caml_trampoline_cps_call2(a, x$4, cont);});
		                }
		                if(-599258500 <= variant){
		                 var x$5 = e[2];
		                 return caml_exact_trampoline_cps_call
		                         (sprintf,
		                          M2,
		                          function(a){return caml_trampoline_cps_call2(a, x$5, cont);});
		                }
		                var x$6 = e[2];
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         M3,
		                         function(a){return caml_trampoline_cps_call2(a, x$6, cont);});
		               }
		               function string_of_error$0(e, cont){
		                if(typeof e !== "number"){
		                 var variant = e[1];
		                 if(-19918314 === variant){
		                  var x = e[2];
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           M5,
		                           function(a){return caml_trampoline_cps_call2(a, x, cont);});
		                 }
		                 if(2259935 === variant){
		                  var x$0 = e[2];
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           M6,
		                           function(a){return caml_trampoline_cps_call2(a, x$0, cont);});
		                 }
		                }
		                return caml_exact_trampoline_cps_call
		                        (string_of_error, e, cont);
		               }
		               var
		                ym_p =
		                  symbol_bind$3
		                   (nat_zero,
		                    function(year, cont){
		                     return cont
		                             (symbol_bind$3
		                               (symbol$61(char$0(45), max_two_digit_nat_zero),
		                                function(month, cont){
		                                 var match = make$22(year, month);
		                                 if(0 === match[0]){
		                                  var x = match[1];
		                                  return caml_exact_trampoline_cps_call(return$7, x, cont);
		                                 }
		                                 var e = match[1];
		                                 return caml_exact_trampoline_cps_call
		 (string_of_error,
		  e,
		  function(a){
		   return caml_exact_trampoline_cps_call
		           (sprintf,
		            M7,
		            function(b){
		             return caml_trampoline_cps_call2
		                     (b, a, function(a){return cont(fail$0(a));});
		            });
		  });
		                                }));
		                    }),
		                ymd_p =
		                  symbol_bind$3
		                   (ym_p,
		                    function(ym, cont){
		                     return cont
		                             (symbol_bind$3
		                               (symbol$61(char$0(45), max_two_digit_nat_zero),
		                                function(day, cont){
		                                 var
		                                  match = year_month(ym),
		                                  month = match[2],
		                                  year = match[1];
		                                 return caml_exact_trampoline_cps_call$0
		 (make$24,
		  year,
		  month,
		  day,
		  function(match){
		   if(0 === match[0]){
		    var x = match[1];
		    return caml_exact_trampoline_cps_call(return$7, x, cont);
		   }
		   var e = match[1];
		   return caml_exact_trampoline_cps_call
		           (string_of_error,
		            e,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (sprintf,
		                      M8,
		                      function(b){
		                       return caml_trampoline_cps_call2
		                               (b, a, function(a){return cont(fail$0(a));});
		                      });
		            });
		  });
		                                }));
		                    }),
		                iso_week_p =
		                  symbol_bind$3
		                   (nat_zero,
		                    function(year, cont){
		                     var a = char$0(87);
		                     return cont
		                             (symbol_bind$3
		                               (symbol$61
		                                 (symbol$61(optional_char(45), a), max_two_digit_nat_zero),
		                                function(week, cont){
		                                 return caml_exact_trampoline_cps_call$1
		 (make$23,
		  year,
		  week,
		  function(match){
		   if(0 === match[0]){
		    var x = match[1];
		    return caml_exact_trampoline_cps_call(return$7, x, cont);
		   }
		   var e = match[1];
		   return caml_exact_trampoline_cps_call
		           (string_of_error$0,
		            e,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (sprintf,
		                      M9,
		                      function(b){
		                       return caml_trampoline_cps_call2
		                               (b, a, function(a){return cont(fail$0(a));});
		                      });
		            });
		  });
		                                }));
		                    }),
		                iso_week_date_p =
		                  symbol_bind$3
		                   (iso_week_p,
		                    function(iso_week, cont){
		                     return cont
		                             (symbol_bind$3
		                               (symbol$61(char$0(45), one_digit_nat_zero),
		                                function(weekday, cont){
		                                 var a = weekday - 1 | 0;
		                                 if(6 < a >>> 0)
		                                  a = 0;
		                                 else
		                                  switch(a){
		                                    case 0:
		                                     a = Mq; break;
		                                    case 1:
		                                     a = Mr; break;
		                                    case 2:
		                                     a = Ms; break;
		                                    case 3:
		                                     a = Mt; break;
		                                    case 4:
		                                     a = Mu; break;
		                                    case 5:
		                                     a = Mv; break;
		                                    default: a = Mw;
		                                  }
		                                 if(! a) return cont(fail$0("invalid weekday"));
		                                 var weekday$0 = a[1];
		                                 return caml_exact_trampoline_cps_call
		 (year_week,
		  iso_week,
		  function(match){
		   var week = match[2], year = match[1];
		   return caml_exact_trampoline_cps_call$1
		           (make$23,
		            year,
		            week,
		            function(match){
		             function a(match){
		              if(0 === match[0]){
		               var x = match[1];
		               return caml_exact_trampoline_cps_call(return$7, x, cont);
		              }
		              var e = match[1];
		              return caml_exact_trampoline_cps_call
		                      (string_of_error$0,
		                       e,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (sprintf,
		                                 M_,
		                                 function(b){
		                                  return caml_trampoline_cps_call2
		  (b, a, function(a){return cont(fail$0(a));});
		                                 });
		                       });
		             }
		             if(0 === match[0]){
		              var x = match[1];
		              return caml_exact_trampoline_cps_call
		                      (year_week,
		                       x,
		                       function(match){
		                        var week = match[2], year = match[1];
		                        return caml_exact_trampoline_cps_call$0
		                                (jd_of_iso_week_date,
		                                 year,
		                                 week,
		                                 weekday$0,
		                                 function(b){return a([0, [0, b]]);});
		                       });
		             }
		             var e = match[1];
		             return a([1, e]);
		            });
		  });
		                                }));
		                    }),
		                iso_ord_p =
		                  symbol_bind$3
		                   (nat_zero,
		                    function(year, cont){
		                     return cont
		                             (symbol_bind$3
		                               (symbol$61(char$0(45), nat_zero),
		                                function(day_of_year, cont){
		                                 function a(match){
		                                  if(0 === match[0]){
		                                   var x$0 = match[1];
		                                   return caml_exact_trampoline_cps_call(return$7, x$0, cont);
		                                  }
		                                  var e = match[1], variant = e[1];
		                                  function a(a){
		                                   return caml_exact_trampoline_cps_call
		   (sprintf,
		    M$,
		    function(b){
		     return caml_trampoline_cps_call2
		             (b, a, function(a){return cont(fail$0(a));});
		    });
		                                  }
		                                  if(-96365478 !== variant)
		                                   return caml_exact_trampoline_cps_call(string_of_error, e, a);
		                                  var x = e[2];
		                                  return caml_exact_trampoline_cps_call
		  (sprintf,
		   M4,
		   function(b){return caml_trampoline_cps_call2(b, x, a);});
		                                 }
		                                 if(year >= 0 && 9999 >= year){
		                                  if
		                                   (1 <= day_of_year && day_count_of_year(year) >= day_of_year)
		                                   return caml_exact_trampoline_cps_call$1
		   (jd_of_ydoy,
		    year,
		    day_of_year,
		    function(b){return a([0, [0, b]]);});
		                                  return a([1, [0, -96365478, day_of_year]]);
		                                 }
		                                 return a([1, [0, -577554587, year]]);
		                                }));
		                    });
		               caml_callback
		                (choice,
		                 [0, [0, ymd_p, [0, iso_week_date_p, [0, iso_ord_p, 0]]]]);
		               h =
		                [0,
		                 symbol_bind$3
		                  (two_digit_nat_zero,
		                   function(hour, cont){
		                    return caml_exact_trampoline_cps_call
		                            (return$7, [0, hour, 0], cont);
		                   }),
		                 0];
		               var
		                hm_p =
		                  caml_callback
		                   (choice,
		                    [0,
		                     [0,
		                      symbol_bind$3
		                       (two_digit_nat_zero,
		                        function(hour, cont){
		                         return cont
		                                 (symbol_bind$3
		                                   (symbol$61(optional_char(58), two_digit_nat_zero),
		                                    function(minute, cont){
		                                     return caml_exact_trampoline_cps_call
		     (return$7, [0, hour, minute], cont);
		                                    }));
		                        }),
		                      h]]),
		                h =
		                  [0,
		                   symbol_map$3
		                    (hm_p,
		                     function(param, cont){
		                      var minute = param[2], hour = param[1];
		                      return cont([0, hour, minute, 0, 0]);
		                     }),
		                   0],
		                h =
		                  [0,
		                   symbol_bind$3
		                    (two_digit_nat_zero,
		                     function(hour, cont){
		                      return cont
		                              (symbol_bind$3
		                                (symbol$61(optional_char(58), two_digit_nat_zero),
		                                 function(minute, cont){
		                                  return cont
		  (symbol_bind$3
		    (symbol$61(optional_char(58), two_digit_nat_zero),
		     function(second, cont){
		      return caml_exact_trampoline_cps_call
		              (return$7, [0, hour, minute, second, 0], cont);
		     }));
		                                 }));
		                     }),
		                   h];
		               caml_callback
		                (choice,
		                 [0,
		                  [0,
		                   symbol_bind$3
		                    (two_digit_nat_zero,
		                     function(hour, cont){
		                      return cont
		                              (symbol_bind$3
		                                (symbol$61(optional_char(58), two_digit_nat_zero),
		                                 function(minute, cont){
		                                  return cont
		  (symbol_bind$3
		    (symbol$61(optional_char(58), two_digit_nat_zero),
		     function(second, cont){
		      var b = [0, char$0(44), 0];
		      function a(s, cont){
		       function a(s){
		        var frac_s = caml_ml_string_length(s);
		        if(9 === frac_s)
		         return caml_exact_trampoline_cps_call
		                 (return$7,
		                  [0, hour, minute, second, caml_int_of_string(s)],
		                  cont);
		        var switcher = frac_s - 1 | 0;
		        function a(a){
		         var ns = caml_mul(caml_int_of_string(s), a);
		         return caml_exact_trampoline_cps_call
		                 (return$7, [0, hour, minute, second, ns], cont);
		        }
		        if(8 < switcher >>> 0)
		         return caml_exact_trampoline_cps_call
		                 (failwith, cst_unexpected_case, a);
		        switch(switcher){
		          case 0:
		           return a(100000000);
		          case 1:
		           return a(10000000);
		          case 2:
		           return a(1000000);
		          case 3:
		           return a(100000);
		          case 4:
		           return a(10000);
		          case 5:
		           return a(1000);
		          case 6:
		           return a(100);
		          case 7:
		           return a(10);
		          default: return a(1);
		        }
		       }
		       return 9 < caml_ml_string_length(s)
		               ? caml_exact_trampoline_cps_call$0(get_sub, s, 0, 9, a)
		               : a(s);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (choice,
		               0,
		               [0, char$0(46), b],
		               function(b){
		                return cont(symbol_bind$3(symbol$61(b, num_string), a));
		               });
		     }));
		                                 }));
		                     }),
		                   h]]);
		               var
		                V$4 =
		                  [248,
		                   "Routine_schemas__Schemas_library.V",
		                   caml_fresh_oo_id()];
		               function Make_compound(M, cont){
		                var a = M[3];
		                function pp(b, c, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (of_to_string, a, b, c, cont);
		                }
		                function sexp_of_t(t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (M[3], t, function(a){return cont([0, a]);});
		                }
		                var descriptor = [4, M[4], M[3], 8], b = M[1];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$69,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   b,
		                                   function(a){
		                                    var id = [0, a], schema = [0, id, 0, descriptor, 0];
		                                    function schema_versioned(param, cont){return cont(schema);}
		                                    var
		                                     compare = M[2],
		                                     Comparable = Make$2([0, compare, sexp_of_t]),
		                                     equal = Comparable[7],
		                                     compare$0 = Comparable[8],
		                                     comparator = Comparable[16],
		                                     comparator$0 = Comparable[16];
		                                    return caml_exact_trampoline_cps_call
		    (M_printable,
		     [0, pp, comparator$0, schema_versioned],
		     function(By){
		      return caml_exact_trampoline_cps_call
		              (M_printable$0,
		               [0, pp, comparator$0, schema_versioned],
		               function(Set){
		                return cont
		                        ([0,
		                          ,
		                          pp,
		                          ,
		                          sexp_of_t,
		                          schema,
		                          schema_versioned,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          equal,
		                          compare$0,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          comparator,
		                          ,
		                          By]);
		               });
		     });
		                                   });
		                         });
		               }
		               function to_nanoid(id){return id;}
		               function of_nanoid(id){return id;}
		               function char_to_byte(c, cont){
		                if(65 <= c && c <= 90) return cont(c - 65 | 0);
		                if(97 <= c && c <= 122) return cont((26 + c | 0) - 97 | 0);
		                if(48 <= c && c <= 57) return cont((52 + c | 0) - 48 | 0);
		                return c === 45
		                        ? cont(62)
		                        : c
		                          === 95
		                          ? cont(63)
		                          : caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             failwith,
		                             fmt$70,
		                             function(a){return caml_trampoline_cps_call2(a, c, cont);});
		               }
		               function byte_to_char(c, cont){
		                return 26 <= c
		                        ? 52
		                          <= c
		                          ? 62
		                            <= c
		                            ? 62
		                              === c
		                              ? cont(45)
		                              : 63
		                                === c
		                                ? cont(95)
		                                : caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   failwith,
		                                   fmt$71,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);})
		                            : caml_exact_trampoline_cps_call
		                              (of_int_exn, 48 + (c - 52 | 0) | 0, cont)
		                          : caml_exact_trampoline_cps_call
		                            (of_int_exn, 97 + (c - 26 | 0) | 0, cont)
		                        : caml_exact_trampoline_cps_call
		                          (of_int_exn, 65 + c | 0, cont);
		               }
		               function to_bytes(id, cont){
		                var
		                 res = make(16, 0),
		                 t = range$0(0, 0, 0, 0, 5),
		                 next = t[2],
		                 seed = t[1];
		                function a(seed){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          seed,
		                          function(match){
		                           if(typeof match === "number")
		                            return caml_exact_trampoline_cps_call
		                                    (char_to_byte,
		                                     caml_string_get(id, 20),
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (of_int_exn,
		       a << 2,
		       function(a){caml_bytes_set(res, 15, a); return cont(res);});
		                                     });
		                           if(0 === match[0]){
		                            var seed = match[1];
		                            return caml_exact_trampoline_call1(a, seed);
		                           }
		                           var seed$0 = match[2], a$0 = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (char_to_byte,
		                                    caml_string_get(id, a$0 * 4 | 0),
		                                    function(b0){
		                                     return caml_exact_trampoline_cps_call
		     (char_to_byte,
		      caml_string_get(id, (a$0 * 4 | 0) + 1 | 0),
		      function(b1){
		       return caml_exact_trampoline_cps_call
		               (char_to_byte,
		                caml_string_get(id, (a$0 * 4 | 0) + 2 | 0),
		                function(b2){
		                 return caml_exact_trampoline_cps_call
		                         (char_to_byte,
		                          caml_string_get(id, (a$0 * 4 | 0) + 3 | 0),
		                          function(b3){
		                           return caml_exact_trampoline_cps_call
		                                   (of_int_exn,
		                                    b0 << 2 | b1 >>> 4 | 0,
		                                    function(b){
		                                     caml_bytes_set(res, a$0 * 3 | 0, b);
		                                     return caml_exact_trampoline_cps_call
		     (of_int_exn,
		      (b1 & 15) << 4 | b2 >>> 2 | 0,
		      function(b){
		       caml_bytes_set(res, (a$0 * 3 | 0) + 1 | 0, b);
		       return caml_exact_trampoline_cps_call
		               (of_int_exn,
		                (b2 & 3) << 6 | b3,
		                function(b){
		                 caml_bytes_set(res, (a$0 * 3 | 0) + 2 | 0, b);
		                 return caml_exact_trampoline_call1(a, seed$0);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return a(seed);
		               }
		               var nanoid_length = 21;
		               function of_bytes(bytes, cont){
		                if(16 === caml_ml_bytes_length(bytes)){
		                 var
		                  res = make(nanoid_length, 0),
		                  t = range$0(0, 0, 0, 0, 5),
		                  next = t[2],
		                  seed = t[1],
		                  a =
		                    function(seed){
		                     return caml_trampoline_cps_call2
		                             (next,
		                              seed,
		                              function(match){
		                               if(typeof match === "number")
		                                return caml_exact_trampoline_cps_call
		(byte_to_char,
		 (caml_bytes_get(bytes, 15) & 252) >>> 2 | 0,
		 function(a){
		  caml_bytes_set(res, 20, a);
		  return cont(to_string(res));
		 });
		                               if(0 === match[0]){
		                                var seed = match[1];
		                                return caml_exact_trampoline_call1(a, seed);
		                               }
		                               var
		                                seed$0 = match[2],
		                                a$0 = match[1],
		                                b0 = caml_bytes_get(bytes, a$0 * 3 | 0),
		                                b1 = caml_bytes_get(bytes, (a$0 * 3 | 0) + 1 | 0),
		                                b2 = caml_bytes_get(bytes, (a$0 * 3 | 0) + 2 | 0);
		                               return caml_exact_trampoline_cps_call
		                                       (byte_to_char,
		b0 >>> 2 | 0,
		function(b){
		 caml_bytes_set(res, a$0 * 4 | 0, b);
		 return caml_exact_trampoline_cps_call
		         (byte_to_char,
		          (b0 & 3) << 4 | b1 >>> 4 | 0,
		          function(b){
		           caml_bytes_set(res, (a$0 * 4 | 0) + 1 | 0, b);
		           return caml_exact_trampoline_cps_call
		                   (byte_to_char,
		                    (b1 & 15) << 2 | b2 >>> 6 | 0,
		                    function(b){
		                     caml_bytes_set(res, (a$0 * 4 | 0) + 2 | 0, b);
		                     return caml_exact_trampoline_cps_call
		                             (byte_to_char,
		                              b2 & 63,
		                              function(b){
		                               caml_bytes_set(res, (a$0 * 4 | 0) + 3 | 0, b);
		                               return caml_exact_trampoline_call1(a, seed$0);
		                              });
		                    });
		          });
		});
		                              });
		                    };
		                 return a(seed);
		                }
		                var raise = caml_pop_trap();
		                return raise
		                        (caml_maybe_attach_backtrace([0, Assert_failure, Nd], 1));
		               }
		               function salt(salt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_bytes,
		                         id,
		                         function(bytes){
		                          var
		                           len = caml_ml_bytes_length(salt),
		                           l = caml_ml_bytes_length(bytes);
		                          function a(salted){
		                           return caml_exact_trampoline_cps_call
		                                   (of_bytes, salted, cont);
		                          }
		                          if(0 === l) return a(bytes);
		                          var r = caml_create_bytes(l), b = l - 1 | 0;
		                          function c(i){
		                           var c$0 = caml_bytes_unsafe_get(bytes, i);
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$23,
		                                    i,
		                                    len,
		                                    function(d){
		                                     return caml_exact_trampoline_cps_call
		     (of_int_exn,
		      c$0 ^ caml_bytes_get(salt, d),
		      function(d){
		       caml_bytes_unsafe_set(r, i, d);
		       d = i + 1 | 0;
		       return b !== i ? caml_exact_trampoline_call1(c, d) : a(r);
		      });
		                                    });
		                          }
		                          return b < 0 ? a(r) : c(0);
		                         });
		               }
		               function hash$18(input, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string,
		                         string(input),
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_bytes, a, cont);
		                         });
		               }
		               function make$27(param){return nanoid();}
		               function Make_basic(Name, cont){
		                var name = Name[1];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return cont
		                                   ([0,
		                                     [0, name + cst_id$1],
		                                     0,
		                                     schematic_param_name_schema_ve[3],
		                                     schematic_param_name_schema_ve[4]]);
		                          });
		                }
		                var
		                 schema =
		                   [0,
		                    [0, name + cst_id$1],
		                    0,
		                    schematic_param_name_schema_ve[3],
		                    schematic_param_name_schema_ve[4]];
		                function of_string(s, cont){
		                 return caml_trampoline_cps_call2(of_string$14, s, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (M_printable,
		                         [0, pp_print_string, comparator$2, schema_versioned],
		                         function(By){
		                          return caml_exact_trampoline_cps_call
		                                  (M_printable$0,
		                                   [0, pp_print_string, comparator$2, schema_versioned],
		                                   function(Set){
		                                    return cont
		    ([0,
		      pp_print_string,
		      ,
		      ,
		      schema_versioned,
		      schema,
		      of_string,
		      ,
		      to_string$7,
		      symbol$16,
		      symbol$12,
		      symbol$14,
		      symbol$15,
		      symbol$11,
		      symbol$13,
		      equal$4,
		      compare$4,
		      min$6,
		      max$6,
		      ascending$2,
		      descending$2,
		      between$2,
		      clamp_exn$1,
		      clamp$1,
		      comparator$2,
		      ,
		      ,
		      [0,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[55],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[109],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[128]]]);
		                                   });
		                         });
		               }
		               function Make$12(Name, cont){
		                var
		                 name = Name[1],
		                 sep = Name[2],
		                 s2 = Name[2],
		                 prefix = name + s2;
		                function of_string(s, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (chop_prefix,
		                          s,
		                          prefix,
		                          function(match){
		                           if(match){
		                            var id$0 = match[1];
		                            if(caml_ml_string_length(id$0) === 21)
		                             return caml_trampoline_cps_call2(of_string$14, id$0, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$72,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (a, name, s, function(x){return cont([1, x]);});
		                                    });
		                          });
		                }
		                function to_string(id$0, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$73,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, prefix, id$0, cont);
		                          });
		                }
		                function schema_versioned(param, cont){
		                 var id = [0, name + cst_id$1];
		                 return cont
		                         ([0, id, 0, [4, of_string, to_string, descriptor$1], 0]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         dummy,
		                         function(schema){
		                          return caml_exact_trampoline_cps_call
		                                  (M_printable,
		                                   [0, pp$2, comparator$2, schema_versioned],
		                                   function(By){
		                                    return caml_exact_trampoline_cps_call
		    (M_printable$0,
		     [0, pp$2, comparator$2, schema_versioned],
		     function(Set){
		      function of_string_lenient(mode, s, cont){
		       if(typeof mode === "number")
		        return mode
		                ? caml_exact_trampoline_cps_call
		                  (of_string,
		                   s,
		                   function(ok){
		                    return 0 === ok[0]
		                            ? cont(ok)
		                            : caml_exact_trampoline_cps_call
		                              (hash$18,
		                               s,
		                               function(a){
		                                return caml_trampoline_cps_call2(of_string$14, a, cont);
		                               });
		                   })
		                : caml_exact_trampoline_cps_call
		                  (of_string,
		                   s,
		                   function(ok){
		                    return 0 === ok[0]
		                            ? cont(ok)
		                            : 21
		                              <= caml_ml_string_length(s)
		                              ? caml_exact_trampoline_cps_call$0
		                                (sub_fun,
		                                 s,
		                                 0,
		                                 nanoid_length,
		                                 function(a){
		                                  return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                 })
		                              : caml_exact_trampoline_cps_call$1
		                                (kasprintf,
		                                 id,
		                                 fmt$75,
		                                 function(a){
		                                  return caml_trampoline_cps_call3
		  (a, name, s, function(x){return cont([1, x]);});
		                                 });
		                   });
		       var override_sep = mode[1];
		       return caml_exact_trampoline_cps_call
		               (of_string,
		                s,
		                function(ok){
		                 return 0 === ok[0]
		                         ? cont(ok)
		                         : caml_exact_trampoline_cps_call$1
		                           (chop_prefix,
		                            s,
		                            name + override_sep,
		                            function(match){
		                             if(! match)
		                              return caml_exact_trampoline_cps_call$1
		                                      (kasprintf, id, fmt$74, function(x){return cont([1, x]);});
		                             var id$0 = match[1], s1 = Name[2], s2 = s1 + id$0;
		                             return caml_exact_trampoline_cps_call
		                                     (of_string, name + s2, cont);
		                            });
		                });
		      }
		      function schema_lenient_make(mode, param, cont){
		       function decode(a, cont){
		        return caml_exact_trampoline_cps_call$1
		                (of_string_lenient, mode, a, cont);
		       }
		       var id = [0, name + cst_id$1];
		       return cont
		               ([0, id, 0, [4, decode, to_string, descriptor$1], 0]);
		      }
		      function pp(a, b, cont){
		       return caml_exact_trampoline_cps_call$2
		               (using, to_string, pp_print_string, a, b, cont);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (concat$0,
		               0,
		               [0, name, [0, sep, [0, make$0(nanoid_length, 48), 0]]],
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (of_string,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (ok_or_failwith,
		                                   a,
		                                   function(null$){
		                                    return cont
		    ([0,
		      pp,
		      ,
		      name,
		      schema_versioned,
		      schema,
		      of_string,
		      ,
		      to_string,
		      symbol$16,
		      symbol$12,
		      symbol$14,
		      symbol$15,
		      symbol$11,
		      symbol$13,
		      equal$4,
		      compare$4,
		      min$6,
		      max$6,
		      ascending$2,
		      descending$2,
		      between$2,
		      clamp_exn$1,
		      clamp$1,
		      comparator$2,
		      sexp_of_string,
		      [0,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       Set[9],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       Set[16],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       Set[70],
		       ,
		       Set[72],
		       ,
		       ,
		       Set[75],
		       ,
		       Set[77]],
		      [0,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[25],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[45],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[53],
		       ,
		       By[55],
		       ,
		       ,
		       By[58],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[109],
		       By[110],
		       By[111],
		       ,
		       ,
		       By[114],
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       ,
		       By[127],
		       By[128]],
		      hash$18,
		      make$27,
		      ,
		      salt,
		      to_bytes,
		      of_nanoid,
		      to_nanoid,
		      of_bytes,
		      ,
		      schema_lenient_make]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                Device = caml_callback(Make$12, [[0, cst_device, cst$33]]),
		                Document = caml_callback(Make$12, [[0, cst_document, cst$21]]),
		                include$48 = caml_callback(Make$12, [[0, cst_block, cst$21]]),
		                Event_recurrent =
		                  caml_callback(Make$12, [[0, cst_event_rec, cst$21]]),
		                Single = caml_callback(Make$12, [[0, cst_event, cst$21]]),
		                letrec_function_context$180 = [];
		               function compare$57(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$180[3], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhsdate = lhs[2], lhsrecurrence = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhsdate = rhs[2], rhsrecurrence = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$180[2],
		                           lhsrecurrence,
		                           rhsrecurrence,
		                           function(x){
		                            return 0 === x
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$180[1], lhsdate, rhsdate, cont)
		                                    : cont(x);
		                           });
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var _1$6 = Event_recurrent[16], _0$7 = Single[16];
		               caml_update_dummy
		                (letrec_function_context$180, [0, compare$39, _1$6, _0$7]);
		               function sexp_of_t$35(param, cont){
		                if(0 === param[0]){
		                 var id = param[1];
		                 return caml_exact_trampoline_cps_call(Single[25], id, cont);
		                }
		                var date = param[2], recurrence = param[1];
		                return caml_exact_trampoline_cps_call
		                        (to_sexp,
		                         date,
		                         function(b){
		                          var a = [0, b, 0];
		                          return caml_exact_trampoline_cps_call
		                                  (Event_recurrent[25],
		                                   recurrence,
		                                   function(b){return cont([1, [0, b, a]]);});
		                         });
		               }
		               function of_string$22(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(a){
		                          if(a && a[1] === cst_event){
		                           a = a[2];
		                           if(a){
		                            var match = a[2], id = a[1];
		                            if(match){
		                             if(! match[2]){
		                              var date = match[1];
		                              if(caml_ml_string_length(id) === 21)
		                               return caml_exact_trampoline_cps_call
		                                       (of_string$12,
		date,
		function(match){
		 if(0 === match[0]){
		  var date$0 = match[1];
		  return cont
		          ([0, [1, Event_recurrent[33].call(null, id), date$0]]);
		 }
		 var error = match[1];
		 return caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          fail,
		          format$16,
		          function(a){
		           return caml_trampoline_cps_call3(a, date, error, cont);
		          });
		});
		                             }
		                            }
		                            else if(caml_ml_string_length(id) === 21)
		                             return cont([0, [0, Single[33].call(null, id)]]);
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   fail,
		                                   format$15,
		                                   function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                         });
		               }
		               function to_string$29(param, cont){
		                if(0 === param[0]){
		                 var id$0 = param[1];
		                 return caml_exact_trampoline_cps_call(Single[8], id$0, cont);
		                }
		                var
		                 date = param[2],
		                 recurrence = param[1],
		                 a = Event_recurrent[34].call(null, recurrence);
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$76,
		                         function(b){
		                          return caml_trampoline_cps_call4(b, a, pp_v1$0, date, cont);
		                         });
		               }
		               var
		                schema$263 =
		                  [0, id$19, 0, [4, of_string$22, to_string$29, 8], 0];
		               function schema_versioned$102(param, cont){return cont(schema$263);
		               }
		               function pp$35(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, to_string$29, a, b, cont);
		               }
		               function hash$19(input, cont){
		                return caml_exact_trampoline_cps_call
		                        (Single[28], input, function(a){return cont([0, a]);});
		               }
		               function make$28(param){return [0, Single[29].call(null)];}
		               var
		                Comparable = Make$2([0, compare$57, sexp_of_t$35]),
		                symbol$101 = Comparable[1],
		                symbol$102 = Comparable[2],
		                symbol$103 = Comparable[3],
		                symbol$104 = Comparable[4],
		                symbol$105 = Comparable[5],
		                symbol$106 = Comparable[6],
		                equal$51 = Comparable[7],
		                compare$58 = Comparable[8],
		                min$13 = Comparable[9],
		                max$15 = Comparable[10],
		                ascending$4 = Comparable[11],
		                descending$4 = Comparable[12],
		                between$5 = Comparable[13],
		                clamp_exn$4 = Comparable[14],
		                clamp$4 = Comparable[15],
		                comparator$14 = Comparable[16],
		                comparator$15 = Comparable[16],
		                By$0 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$35, comparator$15, schema_versioned$102]]);
		               caml_callback
		                (M_printable$0,
		                 [[0, pp$35, comparator$15, schema_versioned$102]]);
		               function value_map$0(t, singular, occurrence, cont){
		                if(0 === t[0])
		                 return caml_exact_trampoline_cps_call(singular, dummy, cont);
		                var date = t[2], recurrence = t[1];
		                return caml_exact_trampoline_cps_call$1
		                        (occurrence, recurrence, date, cont);
		               }
		               var
		                By$1 =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   By$0[60],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   By$0[109],
		                   ,
		                   ,
		                   By$0[112]],
		                include$49 = caml_callback(Make$12, [[0, cst_page, cst$21]]),
		                pp$36 = include$49[1],
		                schema_versioned$103 = include$49[4],
		                schema$20 = include$49[5],
		                of_string$23 = include$49[6],
		                to_string$30 = include$49[8],
		                symbol$107 = include$49[9],
		                symbol$108 = include$49[10],
		                symbol$109 = include$49[11],
		                symbol$110 = include$49[12],
		                symbol$111 = include$49[13],
		                symbol$112 = include$49[14],
		                equal$52 = include$49[15],
		                compare$59 = include$49[16],
		                min$14 = include$49[17],
		                max$16 = include$49[18],
		                ascending$5 = include$49[19],
		                descending$5 = include$49[20],
		                between$6 = include$49[21],
		                clamp_exn$5 = include$49[22],
		                clamp$5 = include$49[23],
		                comparator$16 = include$49[24],
		                By$2 = include$49[27],
		                hash$20 = include$49[28],
		                make$29 = include$49[29],
		                schema_lenient_make = include$49[37];
		               caml_callback(schema_lenient_make, [Ne]);
		               var
		                include$50 = caml_callback(Make$12, [[0, cst_people, cst$21]]),
		                include$51 = caml_callback(Make$12, [[0, cst_row, cst$21]]),
		                Table = caml_callback(Make$12, [[0, cst_table, cst$21]]),
		                include$52 = caml_callback(Make$12, [[0, cst_org, cst$21]]),
		                pp$37 = include$52[1],
		                name$14 = include$52[3],
		                schema_versioned$104 = include$52[4],
		                schema$21 = include$52[5],
		                of_string$24 = include$52[6],
		                to_string$31 = include$52[8],
		                symbol$113 = include$52[9],
		                symbol$114 = include$52[10],
		                symbol$115 = include$52[11],
		                symbol$116 = include$52[12],
		                symbol$117 = include$52[13],
		                symbol$118 = include$52[14],
		                equal$53 = include$52[15],
		                compare$60 = include$52[16],
		                min$15 = include$52[17],
		                max$17 = include$52[18],
		                ascending$6 = include$52[19],
		                descending$6 = include$52[20],
		                between$7 = include$52[21],
		                clamp_exn$6 = include$52[22],
		                clamp$6 = include$52[23],
		                comparator$17 = include$52[24],
		                By$3 = include$52[27],
		                make$30 = include$52[29],
		                of_nanoid$0 = include$52[33],
		                to_nanoid$0 = include$52[34],
		                Workspace =
		                  caml_callback(Make$12, [[0, cst_workspace, cst$21]]),
		                letrec_function_context$181 = [];
		               function compare$61(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(x){
		                 return 0 === x
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$181[2],
		                            lhs[2],
		                            rhs[2],
		                            function(x){
		                             return 0 === x
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$181[1], lhs[3], rhs[3], cont)
		                                     : cont(x);
		                            })
		                         : cont(x);
		                }
		                if(! x) return y ? c(-1) : c(0);
		                var a = x[1];
		                if(! y) return c(1);
		                var b = y[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$181[3], a, b, c);
		               }
		               var
		                _2$9 = include$51[16],
		                _1$7 = Table[16],
		                _0$8 = Workspace[16];
		               caml_update_dummy
		                (letrec_function_context$181, [0, _2$9, _1$7, _0$8]);
		               function to_string$32(param, cont){
		                var
		                 row_id = param[3],
		                 table_id = param[2],
		                 workspace_id = param[1];
		                if(workspace_id)
		                 var
		                  wid = workspace_id[1],
		                  s1$0 = Workspace[34].call(null, wid),
		                  workspace_part = s1$0 + cst$21;
		                else
		                 workspace_part = cst$1;
		                var
		                 s2 = include$51[34].call(null, row_id),
		                 s2$3 = cst$21 + s2,
		                 s1 = Table[34].call(null, table_id),
		                 s2$2 = s1 + s2$3,
		                 s2$1 = workspace_part + s2$2,
		                 s2$0 = cst$21 + s2$1;
		                return cont(cst_object + s2$0);
		               }
		               var name$15 = cst_object;
		               function of_string$25(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(b){
		                          if(b){
		                           var c = b[2];
		                           if(c){
		                            var d = c[2];
		                            if(d){
		                             var
		                              a = d[2],
		                              row_id = d[1],
		                              workspace_id = c[1],
		                              id_name = b[1];
		                             if(a){
		                              if(! a[2]){
		                               var row_id$0 = a[1];
		                               if
		                                (id_name === cst_object
		                                 &&
		                                  caml_ml_string_length(workspace_id) === 21
		                                  &&
		                                   caml_ml_string_length(row_id) === 21
		                                   && caml_ml_string_length(row_id$0) === 21){
		                                a = include$51[33].call(null, row_id$0);
		                                b = Table[33].call(null, row_id);
		                                return cont
		([0, [0, [0, Workspace[33].call(null, workspace_id)], b, a]]);
		                               }
		                              }
		                             }
		                             else if
		                              (id_name === cst_object
		                               &&
		                                caml_ml_string_length(workspace_id) === 21
		                                && caml_ml_string_length(row_id) === 21){
		                              a = include$51[33].call(null, row_id);
		                              return cont
		                                      ([0, [0, 0, Table[33].call(null, workspace_id), a]]);
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Nf,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$15, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$53 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$15, compare$61, to_string$32, of_string$25]]),
		                _33 = include$53[2],
		                sexp_of_t$36 = include$53[4],
		                schema$22 = include$53[5],
		                schema_versioned$105 = include$53[6],
		                equal$54 = include$53[14],
		                compare$62 = include$53[15],
		                comparator$18 = include$53[23],
		                By$4 = include$53[25],
		                letrec_function_context$182 = [];
		               function compare$63(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$182[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$182[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               var _1$8 = Table[16], _0$9 = Workspace[16], bQ5 = By$4[109];
		               caml_update_dummy(letrec_function_context$182, [0, _1$8, _0$9]);
		               var
		                schematic_cache$281 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$183 = [];
		               caml_update_dummy
		                (letrec_function_context$183, [0, schematic_cache$281]);
		               var
		                schematic_schema_version$141 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$183[1][1],
		                     schematic_schema_version$141]);
		               if(h)
		                var schema$23 = h[1], descriptor$7 = schema$23;
		               else
		                descriptor$7 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$183[1][1],
		                              schematic_schema_version$141,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$183[1][1],
		 schematic_schema_version$141,
		 schematic_self,
		 function(a){
		  letrec_function_context$183[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Table[4],
		           dummy,
		           function(b){
		            var
		             a =
		               [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (Workspace[4],
		                     dummy,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var table_id = param[2][1], workspace_id = param[1];
		                           return cont([0, workspace_id, table_id]);
		                          },
		                          function(param, cont){
		                           var table_id = param[2], workspace_id = param[1];
		                           return cont([0, workspace_id, [0, table_id, 0]]);
		                          },
		                          [0,
		                           [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		                           a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$183[1][1],
		                               schematic_schema_version$141,
		                               res,
		                               function(a){
		                                letrec_function_context$183[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var record_schema = [0, Ng, 0, descriptor$7, 0];
		               function to_string$33(param, cont){
		                var
		                 table_id = param[2],
		                 workspace_id = param[1],
		                 s2 = Table[34].call(null, table_id),
		                 s2$2 = cst$21 + s2,
		                 s1 = Workspace[34].call(null, workspace_id),
		                 s2$1 = s1 + s2$2,
		                 s2$0 = cst$21 + s2$1;
		                return cont(cst_table_ref + s2$0);
		               }
		               var name$16 = cst_table_ref;
		               function of_string$26(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(a){
		                          if(a){
		                           var b = a[2];
		                           if(b){
		                            var c = b[2];
		                            if(c && ! c[2]){
		                             var table_id = c[1], workspace_id = b[1], id_name = a[1];
		                             if
		                              (id_name === cst_table_ref
		                               &&
		                                caml_ml_string_length(workspace_id) === 21
		                                && caml_ml_string_length(table_id) === 21){
		                              a = Table[33].call(null, table_id);
		                              return cont
		                                      ([0, [0, Workspace[33].call(null, workspace_id), a]]);
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Nh,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$16, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$54 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$16, compare$63, to_string$33, of_string$26]]),
		                pp$38 = include$54[2],
		                schema$24 = include$54[5],
		                schema_versioned$106 = include$54[6],
		                compare$64 = include$54[15],
		                letrec_function_context$184 = [];
		               function compare$65(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$184[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$184[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               var _1$9 = Workspace[16];
		               caml_update_dummy
		                (letrec_function_context$184, [0, _1$9, compare$60]);
		               var
		                schematic_cache$282 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$185 = [];
		               caml_update_dummy
		                (letrec_function_context$185, [0, schematic_cache$282]);
		               var
		                schematic_schema_version$140 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$185[1][1],
		                     schematic_schema_version$140]),
		                cst_org_id = "org_id";
		               if(h)
		                var schema$25 = h[1], descriptor$8 = schema$25;
		               else
		                descriptor$8 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$185[1][1],
		                              schematic_schema_version$140,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$185[1][1],
		 schematic_schema_version$140,
		 schematic_self,
		 function(a){
		  letrec_function_context$185[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Workspace[4],
		           dummy,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$104,
		                     dummy,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var workspace_id = param[2][1], org_id = param[1];
		                           return cont([0, org_id, workspace_id]);
		                          },
		                          function(param, cont){
		                           var workspace_id = param[2], org_id = param[1];
		                           return cont([0, org_id, [0, workspace_id, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$185[1][1],
		                               schematic_schema_version$140,
		                               res,
		                               function(a){
		                                letrec_function_context$185[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var record_schema$0 = [0, Ni, 0, descriptor$8, 0];
		               function to_string$34(param, cont){
		                var
		                 workspace_id = param[2],
		                 org_id = param[1],
		                 s2 = Workspace[34].call(null, workspace_id),
		                 s2$2 = cst$21 + s2,
		                 s1 = to_nanoid$0(org_id),
		                 s2$1 = s1 + s2$2,
		                 s2$0 = cst$21 + s2$1;
		                return cont(cst_workspace_ref + s2$0);
		               }
		               var name$17 = cst_workspace_ref;
		               function of_string$27(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(a){
		                          if(a){
		                           var b = a[2];
		                           if(b){
		                            var c = b[2];
		                            if(c && ! c[2]){
		                             var workspace_id = c[1], org_id = b[1], id_name = a[1];
		                             if
		                              (id_name === cst_workspace_ref
		                               &&
		                                caml_ml_string_length(org_id) === 21
		                                && caml_ml_string_length(workspace_id) === 21){
		                              a = Workspace[33].call(null, workspace_id);
		                              return cont([0, [0, of_nanoid$0(org_id), a]]);
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Nj,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$17, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$55 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$17, compare$65, to_string$34, of_string$27]]),
		                pp$39 = include$55[2],
		                schema$26 = include$55[5],
		                schema_versioned$107 = include$55[6],
		                compare$66 = include$55[15],
		                letrec_function_context$186 = [];
		               function compare$67(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$186[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$186[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               var _1$10 = Table[16], _0$10 = Workspace[16];
		               caml_update_dummy
		                (letrec_function_context$186, [0, _1$10, _0$10]);
		               var cst_metrics_database = "metrics-database";
		               function to_string$35(param, cont){
		                var
		                 table_id = param[2],
		                 workspace_id = param[1],
		                 s2 = Table[34].call(null, table_id),
		                 s2$2 = cst$21 + s2,
		                 s1 = Workspace[34].call(null, workspace_id),
		                 s2$1 = s1 + s2$2,
		                 s2$0 = cst$21 + s2$1;
		                return cont(cst_metrics_database + s2$0);
		               }
		               var name$18 = cst_metrics_database;
		               function of_string$28(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(a){
		                          if(a){
		                           var b = a[2];
		                           if(b){
		                            var c = b[2];
		                            if(c && ! c[2]){
		                             var table_id = c[1], workspace_id = b[1], id_name = a[1];
		                             if
		                              (id_name === cst_metrics_database
		                               &&
		                                caml_ml_string_length(workspace_id) === 21
		                                && caml_ml_string_length(table_id) === 21){
		                              a = Table[33].call(null, table_id);
		                              return cont
		                                      ([0, [0, Workspace[33].call(null, workspace_id), a]]);
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Nk,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$18, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$56 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$18, compare$67, to_string$35, of_string$28]]),
		                pp$40 = include$56[2],
		                schema_versioned$108 = include$56[6],
		                include$57 = caml_callback(Make$12, [[0, cst_task, cst$21]]),
		                _16$0 = include$57[1],
		                schema_versioned$109 = include$57[4],
		                schema$27 = include$57[5],
		                of_string$29 = include$57[6],
		                to_string$36 = include$57[8],
		                symbol$119 = include$57[9],
		                symbol$120 = include$57[10],
		                symbol$121 = include$57[11],
		                symbol$122 = include$57[12],
		                symbol$123 = include$57[13],
		                symbol$124 = include$57[14],
		                equal$55 = include$57[15],
		                compare$68 = include$57[16],
		                min$16 = include$57[17],
		                max$18 = include$57[18],
		                ascending$7 = include$57[19],
		                descending$7 = include$57[20],
		                between$8 = include$57[21],
		                clamp_exn$7 = include$57[22],
		                clamp$7 = include$57[23],
		                comparator$19 = include$57[24],
		                By$5 = include$57[27],
		                make$31 = include$57[29],
		                salt$0 = include$57[31],
		                of_bytes$0 = include$57[35],
		                schema_lenient_make$0 = include$57[37],
		                schema_lenient = caml_callback(schema_lenient_make$0, [0]),
		                Task_recurrent =
		                  caml_callback(Make$12, [[0, cst_task_rec, cst$21]]),
		                Agent = caml_callback(Make$12, [[0, cst_agent, cst$21]]),
		                Assistant =
		                  caml_callback(Make$12, [[0, cst_assistant, cst$21]]),
		                letrec_function_context$187 = [];
		               function compare_t(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$187[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$187[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var _1$11 = Assistant[16], _0$11 = Agent[16];
		               caml_update_dummy
		                (letrec_function_context$187, [0, _1$11, _0$11]);
		               var cst_Agent = "Agent", letrec_function_context$188 = [];
		               function t_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$188[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$188[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$188[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$188[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Nm,
		                                     Nl,
		                                     1,
		                                     0,
		                                     2,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (Assistant[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_assistant,
		             cst_Assistant,
		             c,
		             a],
		            0];
		        return caml_exact_trampoline_cps_call
		                (Agent[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_agent,
		                        cst_Agent,
		                        a,
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$188[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$188[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$283 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$188, [0, schematic_cache$283]);
		               caml_callback
		                (t_schema_versioned, [function(param, cont){return cont(0);}]);
		               function schema_versioned$110(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (t_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, Nn, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$28 =
		                  caml_callback
		                   (schema_versioned$110,
		                    [function(param, cont){return cont(0);}]);
		               function of_string$30(s, cont){
		                var open = g(include$0), let$ = open[17];
		                return caml_exact_trampoline_cps_call
		                        (Agent[6],
		                         s,
		                         function(match){
		                          if(0 === match[0]){
		                           var id = match[1];
		                           return cont([0, [0, id]]);
		                          }
		                          function a(id, cont){return cont([1, id]);}
		                          return caml_exact_trampoline_cps_call
		                                  (Assistant[6],
		                                   s,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                   });
		                         });
		               }
		               function to_string$37(param, cont){
		                if(0 === param[0]){
		                 var id = param[1];
		                 return caml_exact_trampoline_cps_call(Agent[8], id, cont);
		                }
		                var id$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (Assistant[8], id$0, cont);
		               }
		               function sexp_of_t$37(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$37, t, function(a){return cont([0, a]);});
		               }
		               function pp$41(a, b, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (using, to_string$37, pp_print_string, a, b, cont);
		               }
		               var
		                include$58 = Make$2([0, compare_t, sexp_of_t$37]),
		                equal$56 = include$58[7],
		                compare$69 = include$58[8],
		                comparator$20 = include$58[16];
		               caml_callback
		                (M_printable,
		                 [[0, pp$41, comparator$20, schema_versioned$110]]);
		               caml_callback
		                (M_printable$0,
		                 [[0, pp$41, comparator$20, schema_versioned$110]]);
		               var
		                Automation =
		                  caml_callback(Make$12, [[0, cst_automation, cst$21]]),
		                letrec_function_context$189 = [];
		               function compare$70(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$189[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$189[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$189, [0, compare$69, compare$60]);
		               var
		                schematic_cache$284 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$190 = [];
		               caml_update_dummy
		                (letrec_function_context$190, [0, schematic_cache$284]);
		               function schematic_version$38(param, cont){return cont(0);}
		               var
		                schematic_schema_version$139 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$190[1][1],
		                     schematic_schema_version$139]);
		               if(h)
		                var schema$29 = h[1], descriptor$9 = schema$29;
		               else
		                descriptor$9 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$190[1][1],
		                              schematic_schema_version$139,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$190[1][1],
		 schematic_schema_version$139,
		 schematic_self,
		 function(a){
		  letrec_function_context$190[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$110,
		           schematic_version$38,
		           function(b){
		            var
		             a =
		               [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$104,
		                     schematic_version$38,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var agent_id = param[2][1], org_id = param[1];
		                           return cont([0, org_id, agent_id]);
		                          },
		                          function(param, cont){
		                           var agent_id = param[2], org_id = param[1];
		                           return cont([0, org_id, [0, agent_id, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$190[1][1],
		                               schematic_schema_version$139,
		                               res,
		                               function(a){
		                                letrec_function_context$190[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                record_schema$1 = [0, No, 0, descriptor$9, 0],
		                cst_agent_ref = "agent_ref";
		               function to_string$38(param, cont){
		                var agent_id = param[2], org_id = param[1];
		                return caml_exact_trampoline_cps_call
		                        (to_string$37,
		                         agent_id,
		                         function(s2){
		                          var
		                           s2$2 = cst$21 + s2,
		                           s1 = to_nanoid$0(org_id),
		                           s2$1 = s1 + s2$2,
		                           s2$0 = cst$21 + s2$1;
		                          return cont(cst_agent_ref + s2$0);
		                         });
		               }
		               var name$19 = cst_agent_ref;
		               function of_string$31(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(match){
		                          if(match){
		                           var a = match[2];
		                           if(a){
		                            var b = a[2];
		                            if(b){
		                             var c = b[2];
		                             if(c && ! c[2]){
		                              var
		                               agent_nanoid = c[1],
		                               agent_kind = b[1],
		                               org_id = a[1],
		                               id_name = match[1];
		                              if
		                               (id_name === cst_agent_ref
		                                && caml_ml_string_length(org_id) === 21){
		                               var s2 = cst$21 + agent_nanoid;
		                               return caml_exact_trampoline_cps_call
		                                       (of_string$30,
		agent_kind + s2,
		function(match){
		 if(0 !== match[0])
		  return caml_exact_trampoline_cps_call
		          (error$0,
		           Nq,
		           function(a){
		            return caml_trampoline_cps_call3(a, name$19, s, cont);
		           });
		 var agent_id = match[1];
		 return cont([0, [0, of_nanoid$0(org_id), agent_id]]);
		});
		                              }
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Np,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$19, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$59 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$19, compare$70, to_string$38, of_string$31]]),
		                _10 = include$59[2],
		                sexp_of_t$38 = include$59[4],
		                schema$30 = include$59[5],
		                schema_versioned$111 = include$59[6],
		                compare$71 = include$59[15],
		                letrec_function_context$191 = [];
		               function compare$72(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$191[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$191[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               var _1$12 = Automation[16];
		               caml_update_dummy
		                (letrec_function_context$191, [0, _1$12, compare$60]);
		               var
		                schematic_cache$285 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$192 = [];
		               caml_update_dummy
		                (letrec_function_context$192, [0, schematic_cache$285]);
		               var
		                schematic_schema_version$138 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$192[1][1],
		                     schematic_schema_version$138]);
		               if(h)
		                var schema$31 = h[1], descriptor$10 = schema$31;
		               else
		                descriptor$10 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$192[1][1],
		                              schematic_schema_version$138,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$192[1][1],
		 schematic_schema_version$138,
		 schematic_self,
		 function(a){
		  letrec_function_context$192[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Automation[4],
		           dummy,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$104,
		                     dummy,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var automation_id = param[2][1], org_id = param[1];
		                           return cont([0, org_id, automation_id]);
		                          },
		                          function(param, cont){
		                           var automation_id = param[2], org_id = param[1];
		                           return cont([0, org_id, [0, automation_id, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$192[1][1],
		                               schematic_schema_version$138,
		                               res,
		                               function(a){
		                                letrec_function_context$192[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                record_schema$2 = [0, Nr, 0, descriptor$10, 0],
		                cst_automation_ref = "automation_ref";
		               function to_string$39(param, cont){
		                var
		                 automation_id = param[2],
		                 org_id = param[1],
		                 s2 = Automation[34].call(null, automation_id),
		                 s2$2 = cst$21 + s2,
		                 s1 = to_nanoid$0(org_id),
		                 s2$1 = s1 + s2$2,
		                 s2$0 = cst$21 + s2$1;
		                return cont(cst_automation_ref + s2$0);
		               }
		               var name$20 = cst_automation_ref;
		               function of_string$32(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(a){
		                          if(a){
		                           var b = a[2];
		                           if(b){
		                            var c = b[2];
		                            if(c && ! c[2]){
		                             var automation_id = c[1], org_id = b[1], id_name = a[1];
		                             if
		                              (id_name === cst_automation_ref
		                               &&
		                                caml_ml_string_length(org_id) === 21
		                                && caml_ml_string_length(automation_id) === 21){
		                              a = Automation[33].call(null, automation_id);
		                              return cont([0, [0, of_nanoid$0(org_id), a]]);
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Ns,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$20, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$60 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$20, compare$72, to_string$39, of_string$32]]),
		                _11$0 = include$60[2],
		                sexp_of_t$39 = include$60[4],
		                schema$32 = include$60[5],
		                schema_versioned$112 = include$60[6],
		                compare$73 = include$60[15],
		                Conversation =
		                  caml_callback(Make$12, [[0, cst_conversation, cst$21]]),
		                cst_step = "step",
		                include$61 = caml_callback(Make$12, [[0, cst_step, cst$21]]),
		                cst_automation_run$0 = "automation-run",
		                Automation_run =
		                  caml_callback(Make$12, [[0, cst_automation_run$0, cst$21]]),
		                letrec_function_context$193 = [];
		               function compare$74(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$193[3],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$193[2],
		                                     lhs[2],
		                                     rhs[2],
		                                     function(x){
		                                      return 0 === x
		      ? caml_trampoline_cps_call3
		        (letrec_function_context$193[1], lhs[3], rhs[3], cont)
		      : cont(x);
		                                     })
		                                  : cont(x);
		                         });
		               }
		               var _2$10 = Conversation[16];
		               caml_update_dummy
		                (letrec_function_context$193,
		                 [0, _2$10, compare$69, compare$60]);
		               var
		                schematic_cache$286 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$194 = [];
		               caml_update_dummy
		                (letrec_function_context$194, [0, schematic_cache$286]);
		               function schematic_version$39(param, cont){return cont(0);}
		               var
		                schematic_schema_version$137 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$194[1][1],
		                     schematic_schema_version$137]),
		                cst_conversation_id = "conversation_id";
		               if(h)
		                var schema$33 = h[1], descriptor$11 = schema$33;
		               else
		                descriptor$11 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$194[1][1],
		                              schematic_schema_version$137,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$194[1][1],
		 schematic_schema_version$137,
		 schematic_self,
		 function(a){
		  letrec_function_context$194[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Conversation[4],
		           schematic_version$39,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_conversation_id, 0, 2, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$110,
		                     schematic_version$39,
		                     function(c){
		                      var
		                       b =
		                         [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, c], 0, 0], a];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$104,
		                               schematic_version$39,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      conversation_id = a[2][1],
		                                      agent_id = a[1],
		                                      org_id = param[1];
		                                     return cont([0, org_id, agent_id, conversation_id]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      conversation_id = param[3],
		                                      agent_id = param[2],
		                                      org_id = param[1];
		                                     return cont
		     ([0, org_id, [0, agent_id, [0, conversation_id, 0]]]);
		                                    },
		                                    [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, a], 0, 0], b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$194[1][1],
		 schematic_schema_version$137,
		 res,
		 function(a){
		  letrec_function_context$194[1][1] = a;
		  return cont(res);
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                record_schema$3 = [0, Nt, 0, descriptor$11, 0],
		                cst_conversation_ref = "conversation_ref";
		               function to_string$40(param, cont){
		                var
		                 conversation_id = param[3],
		                 agent_id = param[2],
		                 org_id = param[1],
		                 s2 = Conversation[34].call(null, conversation_id),
		                 s2$0 = cst$21 + s2;
		                return caml_exact_trampoline_cps_call
		                        (to_string$37,
		                         agent_id,
		                         function(s1){
		                          var
		                           s2$3 = s1 + s2$0,
		                           s2$2 = cst$21 + s2$3,
		                           s1$0 = to_nanoid$0(org_id),
		                           s2$1 = s1$0 + s2$2,
		                           s2 = cst$21 + s2$1;
		                          return cont(cst_conversation_ref + s2);
		                         });
		               }
		               var name$21 = cst_conversation_ref;
		               function of_string$33(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(match){
		                          if(match){
		                           var a = match[2];
		                           if(a){
		                            var b = a[2];
		                            if(b){
		                             var c = b[2];
		                             if(c){
		                              var d = c[2];
		                              if(d && ! d[2]){
		                               var
		                                conversation_id = d[1],
		                                agent_nanoid = c[1],
		                                agent_kind = b[1],
		                                org_id = a[1],
		                                id_name = match[1];
		                               if
		                                (id_name === cst_conversation_ref
		                                 &&
		                                  caml_ml_string_length(org_id) === 21
		                                  && caml_ml_string_length(conversation_id) === 21){
		                                var s2 = cst$21 + agent_nanoid;
		                                return caml_exact_trampoline_cps_call
		(of_string$30,
		 agent_kind + s2,
		 function(a){
		  if(0 !== a[0])
		   return caml_exact_trampoline_cps_call
		           (error$0,
		            Nv,
		            function(a){
		             return caml_trampoline_cps_call3(a, name$21, s, cont);
		            });
		  var
		   agent_id = a[1],
		   a = Conversation[33].call(null, conversation_id);
		  return cont([0, [0, of_nanoid$0(org_id), agent_id, a]]);
		 });
		                               }
		                              }
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Nu,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$21, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$62 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$21, compare$74, to_string$40, of_string$33]]),
		                _12$1 = include$62[2],
		                sexp_of_t$40 = include$62[4],
		                schema$34 = include$62[5],
		                schema_versioned$113 = include$62[6],
		                compare$75 = include$62[15],
		                letrec_function_context$195 = [];
		               function compare$76(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$195[3],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$195[2],
		                                     lhs[2],
		                                     rhs[2],
		                                     function(x){
		                                      return 0 === x
		      ? caml_trampoline_cps_call3
		        (letrec_function_context$195[1], lhs[3], rhs[3], cont)
		      : cont(x);
		                                     })
		                                  : cont(x);
		                         });
		               }
		               var _2$11 = Automation_run[16], _1$13 = Automation[16];
		               caml_update_dummy
		                (letrec_function_context$195, [0, _2$11, _1$13, compare$60]);
		               var
		                schematic_cache$287 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$196 = [];
		               caml_update_dummy
		                (letrec_function_context$196, [0, schematic_cache$287]);
		               var
		                schematic_schema_version$136 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$196[1][1],
		                     schematic_schema_version$136]),
		                cst_automation_run_id = "automation_run_id";
		               if(h)
		                var schema$35 = h[1], descriptor$12 = schema$35;
		               else
		                descriptor$12 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$196[1][1],
		                              schematic_schema_version$136,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$196[1][1],
		 schematic_schema_version$136,
		 schematic_self,
		 function(a){
		  letrec_function_context$196[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Automation_run[4],
		           dummy,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_automation_run_id, 0, 2, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (Automation[4],
		                     dummy,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, c], 0, 0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$104,
		                               dummy,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      automation_run_id = a[2][1],
		                                      automation_id = a[1],
		                                      org_id = param[1];
		                                     return cont([0, org_id, automation_id, automation_run_id]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      automation_run_id = param[3],
		                                      automation_id = param[2],
		                                      org_id = param[1];
		                                     return cont
		     ([0, org_id, [0, automation_id, [0, automation_run_id, 0]]]);
		                                    },
		                                    [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, a], 0, 0], b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$196[1][1],
		 schematic_schema_version$136,
		 res,
		 function(a){
		  letrec_function_context$196[1][1] = a;
		  return cont(res);
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                record_schema$4 = [0, Nw, 0, descriptor$12, 0],
		                cst_automation_run_ref = "automation_run_ref";
		               function to_string$41(param, cont){
		                var
		                 automation_run_id = param[3],
		                 automation_id = param[2],
		                 org_id = param[1],
		                 s2 = Automation_run[34].call(null, automation_run_id),
		                 s2$4 = cst$21 + s2,
		                 s1 = Automation[34].call(null, automation_id),
		                 s2$3 = s1 + s2$4,
		                 s2$2 = cst$21 + s2$3,
		                 s1$0 = to_nanoid$0(org_id),
		                 s2$1 = s1$0 + s2$2,
		                 s2$0 = cst$21 + s2$1;
		                return cont(cst_automation_run_ref + s2$0);
		               }
		               var name$22 = cst_automation_run_ref;
		               function of_string$34(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         s,
		                         58,
		                         function(b){
		                          if(b){
		                           var a = b[2];
		                           if(a){
		                            var c = a[2];
		                            if(c){
		                             var d = c[2];
		                             if(d && ! d[2]){
		                              var
		                               automation_run_id = d[1],
		                               automation_id = c[1],
		                               org_id = a[1],
		                               id_name = b[1];
		                              if
		                               (id_name === cst_automation_run_ref
		                                &&
		                                 caml_ml_string_length(org_id) === 21
		                                 &&
		                                  caml_ml_string_length(automation_id) === 21
		                                  && caml_ml_string_length(automation_run_id) === 21){
		                               b = Automation_run[33].call(null, automation_run_id);
		                               a = Automation[33].call(null, automation_id);
		                               return cont([0, [0, of_nanoid$0(org_id), a, b]]);
		                              }
		                             }
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (error$0,
		                                   Nx,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, name$22, s, cont);
		                                   });
		                         });
		               }
		               var
		                include$63 =
		                  caml_callback
		                   (Make_compound,
		                    [[0, name$22, compare$76, to_string$41, of_string$34]]),
		                _13 = include$63[2],
		                sexp_of_t$41 = include$63[4],
		                schema$36 = include$63[5],
		                schema_versioned$114 = include$63[6],
		                compare$77 = include$63[15],
		                include$64 = caml_callback(Make_basic, [[0, cst_account]]),
		                pp$42 = include$64[1],
		                schema_versioned$115 = include$64[4],
		                of_string$35 = include$64[6],
		                to_string$42 = include$64[8],
		                equal$57 = include$64[15],
		                include$65 =
		                  caml_callback(Make_basic, [[0, "google-account"]]),
		                pp$43 = include$65[1],
		                schema_versioned$116 = include$65[4],
		                schema$37 = include$65[5],
		                to_string$43 = include$65[8],
		                symbol$125 = include$65[9],
		                symbol$126 = include$65[10],
		                symbol$127 = include$65[11],
		                symbol$128 = include$65[12],
		                symbol$129 = include$65[13],
		                symbol$130 = include$65[14],
		                equal$58 = include$65[15],
		                compare$78 = include$65[16],
		                min$17 = include$65[17],
		                max$19 = include$65[18],
		                ascending$8 = include$65[19],
		                descending$8 = include$65[20],
		                between$9 = include$65[21],
		                clamp_exn$8 = include$65[22],
		                clamp$8 = include$65[23],
		                comparator$21 = include$65[24],
		                By$6 = include$65[27],
		                schematic_cache$288 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$197 = [];
		               caml_update_dummy
		                (letrec_function_context$197, [0, schematic_cache$288]);
		               var schematic_schema_version$43 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$197[1][1],
		                    schematic_schema_version$43]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$197[1][1],
		                             schematic_schema_version$43,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$197[1][1],
		schematic_schema_version$43,
		schematic_self,
		function(a){
		 letrec_function_context$197[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(NB);},
		       0,
		       0,
		       cst_standard,
		       cst_Standard,
		       NA,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){return param ? cont(Nz) : cont(0);},
		        0,
		        0,
		        cst_premium,
		        "Premium",
		        Ny,
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$197[1][1],
		          schematic_schema_version$43,
		          res,
		          function(a){
		           letrec_function_context$197[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                include$66 =
		                  caml_callback(Make$12, [[0, cst_account, cst$21]]),
		                pp$44 = include$66[1],
		                schema_versioned$117 = include$66[4],
		                schema$38 = include$66[5],
		                of_string$36 = include$66[6],
		                to_string$44 = include$66[8],
		                symbol$131 = include$66[9],
		                symbol$132 = include$66[10],
		                symbol$133 = include$66[11],
		                symbol$134 = include$66[12],
		                symbol$135 = include$66[13],
		                symbol$136 = include$66[14],
		                equal$59 = include$66[15],
		                compare$79 = include$66[16],
		                min$18 = include$66[17],
		                max$20 = include$66[18],
		                ascending$9 = include$66[19],
		                descending$9 = include$66[20],
		                between$10 = include$66[21],
		                clamp_exn$9 = include$66[22],
		                clamp$9 = include$66[23],
		                comparator$22 = include$66[24],
		                By$7 = include$66[27],
		                to_nanoid$1 = include$66[34],
		                schematic_cache$289 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$198 = [];
		               caml_update_dummy
		                (letrec_function_context$198, [0, schematic_cache$289]);
		               var schematic_schema_version$42 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$198[1][1],
		                    schematic_schema_version$42]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$198[1][1],
		                             schematic_schema_version$42,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$198[1][1],
		schematic_schema_version$42,
		schematic_self,
		function(a){
		 letrec_function_context$198[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(NH);},
		       0,
		       0,
		       cst_no_crdt,
		       "No_crdt",
		       NG,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         return 1 === param ? cont(NF) : cont(0);
		        },
		        0,
		        0,
		        cst_crdt_write,
		        "Crdt_write",
		        NE,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(2);},
		         function(param, cont){
		          return 2 <= param ? cont(ND) : cont(0);
		         },
		         0,
		         0,
		         cst_crdt_read_write,
		         "Crdt_read_write",
		         NC,
		         0],
		        0]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$198[1][1],
		          schematic_schema_version$42,
		          res,
		          function(a){
		           letrec_function_context$198[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$199 = [];
		               function schema_versioned$118(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$199[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, NI, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$199[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$199[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$199[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$115,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_email, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$117,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var email = param[2][1], id = param[1];
		             return cont([0, id, email]);
		            },
		            function(param, cont){
		             var email = param[2], id = param[1];
		             return cont([0, id, [0, email, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$199[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$199[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$290 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$199, [0, schematic_cache$290]);
		               caml_callback
		                (schema_versioned$118,
		                 [function(param, cont){return cont(0);}]);
		               function name$23(name){return name;}
		               var
		                schema_versioned$119 = W$0[1],
		                default$8 = W$0[5],
		                some_if_optional$1 = W$0[6],
		                pp$45 = W$0[8],
		                equal$60 = W$0[9];
		               function name$24(name){return name + "-patch";}
		               function decode$6(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$7,
		                         s,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$77,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b, s, function(b){return cont(of_option(a, b));});
		                                   });
		                         });
		               }
		               var
		                pp$46 = Workspace[1],
		                name$25 = Workspace[3],
		                schema_versioned$120 = Workspace[4],
		                schema$39 = Workspace[5],
		                of_string$37 = Workspace[6],
		                to_string$45 = Workspace[8],
		                symbol$137 = Workspace[9],
		                symbol$138 = Workspace[10],
		                symbol$139 = Workspace[11],
		                symbol$140 = Workspace[12],
		                symbol$141 = Workspace[13],
		                symbol$142 = Workspace[14],
		                equal$61 = Workspace[15],
		                compare$80 = Workspace[16],
		                min$19 = Workspace[17],
		                max$21 = Workspace[18],
		                ascending$10 = Workspace[19],
		                descending$10 = Workspace[20],
		                between$11 = Workspace[21],
		                clamp_exn$10 = Workspace[22],
		                clamp$10 = Workspace[23],
		                comparator$23 = Workspace[24],
		                Set$0 = Workspace[26],
		                By$8 = Workspace[27],
		                make$32 = Workspace[29];
		               function default_workspace_of_organizat(id, cont){
		                var
		                 s2 = to_nanoid$0(id),
		                 s2$0 = cst$21 + s2,
		                 raw_id = name$25 + s2$0;
		                return caml_exact_trampoline_cps_call
		                        (of_string$37,
		                         raw_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (ok_or_failwith, a, cont);
		                         });
		               }
		               var
		                Map$0 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$2, comparator$2, thread_id_schema_versioned]]);
		               function schematic_version$40(param, cont){return cont(0);}
		               caml_callback(Map$0[109], [schematic_version$40, int_schema]);
		               function Moded$2(M, Ref, Name, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[2],
		                          letrec_function_context[3],
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(a){
		                                     if(! a) return cont(a);
		                                     var b = rhs[2], c = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[1],
		      function(a, b, cont){return cont(a === b ? 1 : 0);},
		      function(a){
		       return caml_trampoline_cps_call3(a, c, b, cont);
		      });
		                                    });
		                          });
		                }
		                var _2 = M[9], _1 = M[9];
		                caml_update_dummy
		                 (letrec_function_context, [0, _2, _1, equal$53]);
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      var schematic_parametric = Name[1] ? 0 : 0;
		                                      return cont
		      ([0, Name[1], 0, descriptor, schematic_parametric]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      schematic_param_name_schema_ve,
		                                      function(b){
		                                       var
		a = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], 0];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$104,
		        schematic_version,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  b,
		                  function(b){
		                   var
		                    res =
		                      [7,
		                       function(param, cont){
		                        var name = param[2][1], owner = param[1];
		                        return cont([0, owner, name]);
		                       },
		                       function(param, cont){
		                        var name = param[2], owner = param[1];
		                        return cont([0, owner, [0, name, 0]]);
		                       },
		                       [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, b], 0, 0], a]];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          return cont([0, equal, , , schema_versioned, schema]);
		                         });
		               }
		               var
		                Left =
		                  [0,
		                   schema_versioned$11,
		                   ,
		                   make$10,
		                   ,
		                   ,
		                   ,
		                   make$10,
		                   make$10,
		                   make$10],
		                include$293 = caml_callback(Moded$2, [R$0, Left, [0, name$3]]);
		               caml_callback(Moded$2, [W$0, Left, [0, name$4]]);
		               function is_default(organization, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (default_workspace_of_organizat,
		                         organization,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139, a, id, cont);
		                         });
		               }
		               var letrec_function_context$200 = [];
		               function equal$62(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$200[3],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(a){
		                           return a
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$200[1], lhs[3], rhs[3], cont)
		                                   : cont(a);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$200[2], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               var _2$12 = include$293[1];
		               caml_update_dummy
		                (letrec_function_context$200, [0, _2$12, equal$61, equal$20]);
		               var letrec_function_context$201 = [];
		               function schema_versioned$121(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$201[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, NJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$201[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$201[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$201[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$293[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$120,
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        writable = a[2][1],
		                        id = a[1],
		                        created = param[1];
		                       return cont([0, created, id, writable]);
		                      },
		                      function(param, cont){
		                       var writable = param[3], id = param[2], created = param[1];
		                       return cont([0, created, [0, id, [0, writable, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$201[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$201[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$291 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$201, [0, schematic_cache$291]);
		               var
		                schema$40 =
		                  caml_callback
		                   (schema_versioned$121,
		                    [function(param, cont){return cont(0);}]),
		                cst_cookie = "cookie",
		                letrec_function_context$202 = [];
		               function schema_versioned$122(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$202[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, NK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$202[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$202[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$202[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_cookie,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_default, 0, 0, [0, bool_schema], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$121,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var cookie = param[2][1], raw = param[1];
		   return cont([0, raw, cookie]);
		  },
		  function(param, cont){
		   var cookie = param[2], raw = param[1];
		   return caml_exact_trampoline_cps_call$1
		           (is_default,
		            raw[3][1],
		            raw[2],
		            function(a){
		             return cont([0, raw, [0, cookie, [0, [0, a], 0]]]);
		            });
		  },
		  [0, [0, 0, 0, 0, 0, cst_raw, 0, 2, [1, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$202[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$202[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$292 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$202, [0, schematic_cache$292]);
		               caml_callback
		                (schema_versioned$122,
		                 [function(param, cont){return cont(0);}]);
		               function equal$63(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               var letrec_function_context$203 = [];
		               function schema_versioned$123(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$203[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, NM, NL, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$203[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$203[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$203[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(NQ);},
		                                  0,
		                                  0,
		                                  cst_reader,
		                                  cst_Reader,
		                                  [0, ak[1], NP, ak[3], ak[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(NO) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_reader_writer,
		                                   "Reader_writer",
		                                   [0, aj[1], NN, aj[3], aj[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$203[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$203[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$293 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$203, [0, schematic_cache$293]);
		               var
		                schema$41 =
		                  caml_callback
		                   (schema_versioned$123,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$204 = [];
		               function equal$64(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$204[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$204[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$204, [0, equal$59, equal$63]);
		               var letrec_function_context$205 = [];
		               function schema_versioned$124(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$205[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, NR, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$205[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$205[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$205[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, NS, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$123,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var id = param[2][1], access_role = param[1];
		             return cont([0, access_role, id]);
		            },
		            function(param, cont){
		             var id = param[2], access_role = param[1];
		             return cont([0, access_role, [0, id, 0]]);
		            },
		            [0,
		             [0, NT, 0, 0, 0, cst_access_role, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$205[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$205[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$294 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$205, [0, schematic_cache$294]);
		               var
		                schema$42 =
		                  caml_callback
		                   (schema_versioned$124,
		                    [function(param, cont){return cont(0);}]),
		                Impl$0 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$44, comparator$22, schema_versioned$117]]);
		               function schema_versioned$125(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$124,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (Impl$0[109],
		     schematic_version,
		     a,
		     function(a){return cont([0, NU, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$125,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$295 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$206 = [];
		               caml_update_dummy
		                (letrec_function_context$206, [0, schematic_cache$295]);
		               function schematic_version$41(param, cont){return cont(0);}
		               var schematic_schema_version$135 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$206[1][1],
		                    schematic_schema_version$135]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$206[1][1],
		                             schematic_schema_version$135,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$206[1][1],
		schematic_schema_version$135,
		schematic_self,
		function(a){
		 letrec_function_context$206[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$125,
		          schematic_version$41,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_members, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$121,
		                    schematic_version$41,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var members = param[2][1], raw = param[1];
		                          return cont([0, raw, members]);
		                         },
		                         function(param, cont){
		                          var members = param[2], raw = param[1];
		                          return cont([0, raw, [0, members, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_raw, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$206[1][1],
		                              schematic_schema_version$135,
		                              res,
		                              function(a){
		                               letrec_function_context$206[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$207 = [];
		               function equal$65(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$207[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$207, [0, equal$19]);
		               var letrec_function_context$208 = [];
		               function pp$47(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$208[1], fmt, cont);
		               }
		               caml_update_dummy(letrec_function_context$208, [0, pp$13]);
		               function of_string$38(name, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (make$26,
		                          a,
		                          function(a){
		                           if(! a){
		                            var
		                             msgf =
		                               function(m, cont){
		                                return caml_trampoline_cps_call5(m, 0, 0, Nc, name, cont);
		                               };
		                            return caml_exact_trampoline_cps_call$2
		                                    (kmsg, kunit, 0, 1, msgf, function(match){return cont(0);});
		                           }
		                           var timere_tz = a[1];
		                           function offset_timestamp_s(unix_timestamp, cont){
		                            function b(timedesc){
		                             return caml_exact_trampoline_cps_call
		                                     (of_float,
		                                      to_float_s$0(min_of_local_date_time_result(timedesc[4])),
		                                      cont);
		                            }
		                            caml_push_trap
		                             (function(e){
		                               return caml_exact_trampoline_cps_call$1
		                                       (reraisef,
		e,
		Na,
		function(a){
		 return caml_trampoline_cps_call3(a, unix_timestamp, 0, b);
		});
		                              });
		                            var
		                             x$0 = caml_int64_to_float(unix_timestamp),
		                             s$0 = caml_int64_of_float(x$0),
		                             frac = Math.abs(x$0 - caml_int64_to_float(s$0));
		                            if(frac <= 1.){
		                             var
		                              ns = max(0, frac * 1000000000. | 0),
		                              a =
		                                0. <= x$0
		                                 ? [0, s$0, ns]
		                                 : [0, caml_int64_sub(s$0, s), 1000000000 - ns | 0],
		                              x = normalize$0(a);
		                             return caml_exact_trampoline_cps_call$1
		                                     (of_timestamp,
		                                      [0, timere_tz],
		                                      x,
		                                      function(match){
		                                       function a(x){caml_pop_trap(); return b(x);}
		                                       if(! match)
		return caml_exact_trampoline_cps_call
		        (invalid_arg, "of_timestamp_exn", a);
		                                       var x = match[1];
		                                       return a(x);
		                                      });
		                            }
		                            a = caml_pop_trap();
		                            return a
		                                    (caml_maybe_attach_backtrace([0, Assert_failure, Mh], 1));
		                           }
		                           function offset_calendar_time_s(a, param, cont){
		                            var
		                             second = param[3],
		                             minute = param[2],
		                             hour = param[1],
		                             day = a[3],
		                             month = a[2],
		                             year = a[1];
		                            function b(timedesc){
		                             return caml_exact_trampoline_cps_call
		                                     (of_float,
		                                      to_float_s$0(min_of_local_date_time_result(timedesc[4])),
		                                      cont);
		                            }
		                            caml_push_trap
		                             (function(e){
		                               return caml_exact_trampoline_cps_call$1
		                                       (reraisef,
		e,
		Nb,
		function(a){
		 return caml_trampoline_cps_call8
		         (a, year, month, day, hour, minute, second, 0, b);
		});
		                              });
		                            var tz = [0, timere_tz];
		                            return caml_exact_trampoline_cps_call$0
		                                    (make$24,
		                                     year,
		                                     month,
		                                     day,
		                                     function(a){
		                                      function c(a){
		                                       if(0 === a[0]){var x = a[1]; caml_pop_trap(); return b(x);}
		                                       var e = a[1], a = caml_pop_trap();
		                                       return a
		       (caml_maybe_attach_backtrace([0, Error_exn$2, e], 1));
		                                      }
		                                      if(0 !== a[0]){var e$0 = a[1]; return c([1, e$0]);}
		                                      var date = a[1], a = make$25(0, 0, hour, minute, second);
		                                      if(0 === a[0]){
		                                       var time = a[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (to_zoned,
		        tz,
		        [0, date, time],
		        function(a){
		         if(0 === a[0])
		          var dt = a[1], a = [0, dt];
		         else
		          var e = a[1], a = [1, e];
		         if(0 === a[0]){var dt$0 = a[1]; return c([0, dt$0]);}
		         var e$0 = a[1];
		         return c([1, e$0]);
		        });
		                                      }
		                                      var e = a[1];
		                                      return c([1, e]);
		                                     });
		                           }
		                           var a = timere_tz[1];
		                           function b(name){
		                            return cont
		                                    ([0, [0, name, offset_calendar_time_s, offset_timestamp_s]]);
		                           }
		                           if(0 === a[0]){var name$0 = a[1]; return b(name$0);}
		                           var s$0 = a[1], dur = view(make_small([0, s$0], 0));
		                           if(0 === dur[3] && 0 === dur[4]) return b(cst_UTC);
		                           var c = dur[4], d = dur[3], e = 4003188 <= dur[1] ? 43 : 45;
		                           return caml_exact_trampoline_cps_call
		                                   (sprintf,
		                                    MK,
		                                    function(a){
		                                     return caml_trampoline_cps_call4(a, e, d, c, b);
		                                    });
		                          });
		                }
		                return name !== "Indiana/Indianapolis"
		                        ? caml_exact_trampoline_cps_call$1
		                          (chop_prefix,
		                           name,
		                           "GMT",
		                           function(match){
		                            if(! match) return a(name);
		                            var gmt = match[1];
		                            return a(cst_UTC + gmt);
		                           })
		                        : a("America/Indiana/Indianapolis");
		               }
		               function of_timmy(tz, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$19,
		                         tz,
		                         function(s){
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$38,
		                                   s,
		                                   function(match){
		                                    return match ? cont([0, tz]) : cont([1, [0, 151268647, s]]);
		                                   });
		                         });
		               }
		               function schema_versioned$126(v){
		                return map$14
		                        (function(s, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$38,
		                                   s,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$78,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b, s, function(b){return cont(of_option(a, b));});
		     });
		                                   });
		                         },
		                         to_string$19,
		                         schematic_param_name_schema_ve);
		               }
		               if(0 !== caml_callback(of_timmy, [timezone])[0]){
		                d = caml_pop_trap();
		                return d
		                        (caml_maybe_attach_backtrace([0, Assert_failure, bNH], 1));
		               }
		               function equal$66(a, param, cont){
		                var
		                 rhs2 = param[3],
		                 rhs1 = param[2],
		                 rhs0 = param[1],
		                 lhs2 = a[3],
		                 lhs1 = a[2],
		                 lhs0 = a[1],
		                 a = lhs0 === rhs0 ? 1 : 0,
		                 a = a ? lhs1 === rhs1 ? 1 : 0 : a;
		                return a ? cont(lhs2 === rhs2 ? 1 : 0) : cont(a);
		               }
		               var letrec_function_context$209 = [];
		               function compare$81(a, param, cont){
		                var
		                 rhs2 = param[3],
		                 rhs1 = param[2],
		                 rhs0 = param[1],
		                 lhs2 = a[3],
		                 lhs1 = a[2],
		                 lhs0 = a[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$209[3],
		                         0,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   lhs0,
		                                   rhs0,
		                                   function(x){
		                                    return 0 === x
		    ? caml_trampoline_cps_call2
		      (letrec_function_context$209[2],
		       0,
		       function(a){
		        return caml_trampoline_cps_call3
		                (a,
		                 lhs1,
		                 rhs1,
		                 function(x){
		                  return 0 === x
		                          ? caml_trampoline_cps_call2
		                            (letrec_function_context$209[1],
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call3(a, lhs2, rhs2, cont);
		                             })
		                          : cont(x);
		                 });
		       })
		    : cont(x);
		                                   });
		                         });
		               }
		               function _2$13(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$14(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$12(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$209, [0, _2$13, _1$14, _0$12]);
		               function pp$48(fmt, param, cont){
		                var a2 = param[3], a1 = param[2], a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         NV,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   NW,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               NX,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         NY,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   a1,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     NZ,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               N0,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         a2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt), N1, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$210 = [];
		               function schema_versioned$127(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$210[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, N2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$210[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$210[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$210[1][1] = a;
		                            var
		                             res =
		                               [10,
		                                function(param, cont){
		                                 var a = param[2], e2 = a[2][1], e1 = a[1], e0 = param[1];
		                                 return cont([0, e0, e1, e2]);
		                                },
		                                function(param, cont){
		                                 var e2 = param[3], e1 = param[2], e0 = param[1];
		                                 return cont([0, e0, [0, e1, [0, e2, 0]]]);
		                                },
		                                [0, int_schema, [0, int_schema, [0, int_schema, 0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$210[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$210[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$296 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$210, [0, schematic_cache$296]);
		               var
		                schema$43 =
		                  caml_callback
		                   (schema_versioned$127,
		                    [function(param, cont){return cont(0);}]);
		               function equal$67(a, b, cont){return cont(a === b ? 1 : 0);}
		               var letrec_function_context$211 = [];
		               function compare$82(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$211[1],
		                         0,
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               function _0$13(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(letrec_function_context$211, [0, _0$13]);
		               function pp$49(fmt, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), N3, cont);
		               }
		               function of_utf8_string_res(x, cont){return cont([0, x]);}
		               function of_utf8_string(x){return to_option$2([0, x]);}
		               function to_utf8_string(a, cont){return cont(a);}
		               function schema_versioned$128(v, cont){
		                return cont
		                        (map$14
		                          (of_utf8_string_res,
		                           to_utf8_string,
		                           schematic_param_name_schema_ve));
		               }
		               var
		                schema$267 =
		                  map$14
		                   (of_utf8_string_res,
		                    to_utf8_string,
		                    schematic_param_name_schema_ve),
		                letrec_function_context$212 = [];
		               function equal$68(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$212[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$212[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$212, [0, equal$55, equal$54]);
		               var letrec_function_context$213 = [];
		               function compare$83(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$213[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$213[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               caml_update_dummy
		                (letrec_function_context$213, [0, compare$68, compare$62]);
		               var cst_Task = "Task", letrec_function_context$214 = [];
		               function schema_versioned$129(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$214[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, N5, N4, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$214[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$214[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$214[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$109,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_task,
		   cst_Task,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$105,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_object,
		              cst_Object,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$214[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$214[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$297 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$214, [0, schematic_cache$297]);
		               var
		                schema$44 =
		                  caml_callback
		                   (schema_versioned$129,
		                    [function(param, cont){return cont(0);}]);
		               function to_string$46(param, cont){
		                if(0 === param[0]){
		                 var id = param[1];
		                 return caml_exact_trampoline_cps_call(to_string$32, id, cont);
		                }
		                var id$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (to_string$36, id$0, cont);
		               }
		               function pp$50(a, b, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (using, to_string$46, pp_print_string, a, b, cont);
		               }
		               function of_string$39(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$25,
		                         s,
		                         function(match){
		                          if(0 === match[0]){
		                           var id = match[1];
		                           return cont([0, [0, id]]);
		                          }
		                          function a(id, cont){return cont([1, id]);}
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$29,
		                                   s,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(map$15, b, a, cont);
		                                   });
		                         });
		               }
		               var
		                logs_src$2 = create$18(0, "Routine_schemas"),
		                include$67 = src_log(logs_src$2),
		                warn$0 = include$67[4];
		               function to_string$47(opt, a, cont){
		                var
		                 every = opt ? opt[1] : 0,
		                 rule = a[2],
		                 boundaries = a[1],
		                 prefix = every ? N6 : Oi;
		                function pp_kind(fmt, param, cont){
		                 if(typeof param === "number")
		                  return 529348384 <= param
		                          ? 992015837
		                            <= param
		                            ? caml_exact_trampoline_cps_call(fprintf$0(fmt), N7, cont)
		                            : caml_exact_trampoline_cps_call(fprintf$0(fmt), N8, cont)
		                          : 3403324
		                            <= param
		                            ? caml_exact_trampoline_cps_call(fprintf$0(fmt), N9, cont)
		                            : caml_exact_trampoline_cps_call(fprintf$0(fmt), N_, cont);
		                 var weekday = param[2];
		                 return weekday
		                         ? caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            N$,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, _11, weekday, cont);
		                            })
		                         : caml_exact_trampoline_cps_call(fprintf$0(fmt), Oa, cont);
		                }
		                function pp_period(kind, fmt, n, cont){
		                 if(1 !== n)
		                  return 2 === n
		                          ? caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             prefix,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       Of,
		                                       function(b){
		return caml_trampoline_cps_call4(b, a, pp_kind, kind, cont);
		                                       });
		                             })
		                          : caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             prefix,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       Og,
		                                       function(b){
		return caml_trampoline_cps_call5
		        (b, a, n, pp_kind, kind, cont);
		                                       });
		                             });
		                 if(every)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_kind, fmt, kind, cont);
		                 if(typeof kind === "number"){
		                  if(-300116725 === kind)
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Ob, cont);
		                  if(3403324 === kind)
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Oc, cont);
		                 }
		                 else {
		                  var variant = kind[1];
		                  if(969837588 === variant)
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), Oe, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_kind,
		                          fmt,
		                          kind,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (always, Od, fmt, kind, cont);
		                          });
		                }
		                function pp_month_day(fmt, param, cont){
		                 if(0 === param[0]){
		                  var n = param[1];
		                  return caml_exact_trampoline_cps_call$1(nth$3, fmt, n, cont);
		                 }
		                 var kth = param[2], weekday = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Oh,
		                          function(a){
		                           return caml_trampoline_cps_call5
		                                   (a, nth$3, kth, _11, weekday, cont);
		                          });
		                }
		                function b(rule_string){
		                 if(0 !== boundaries[0]){
		                  var match = boundaries[1];
		                  if(match){
		                   var date = match[1], t = ocaml_ptime_clock_now_d_ps();
		                   return caml_exact_trampoline_cps_call$1
		                           (of_time$0,
		                            timezone_local,
		                            t,
		                            function(today){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$80,
		                                      date,
		                                      today,
		                                      function(a){
		                                       return a
		       ? caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          id,
		          fmt$88,
		          function(a){
		           return caml_trampoline_cps_call2(a, rule_string, cont);
		          })
		       : cont(rule_string);
		                                      });
		                            });
		                  }
		                 }
		                 return cont(rule_string);
		                }
		                switch(rule[0]){
		                  case 0:
		                   var
		                    period = rule[1],
		                    c =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (pp_period, 3403324, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$79,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, c, period, b);
		                            });
		                  case 1:
		                   a = rule[2];
		                   var period$0 = rule[1];
		                   a:
		                   if(a){
		                    var month_day = a[1];
		                    if(0 === month_day[0] && 1 === month_day[1]) break a;
		                    var
		                     e =
		                       function(a, b, cont){
		                        return caml_exact_trampoline_cps_call$0
		                                (pp_period, 529348384, a, b, cont);
		                       };
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             fmt$81,
		                             function(a){
		                              return caml_trampoline_cps_call5
		                                      (a, e, period$0, pp_month_day, month_day, b);
		                             });
		                   }
		                   var
		                    d =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (pp_period, 529348384, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$80,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, d, period$0, b);
		                            });
		                  case 2:
		                   a = rule[2];
		                   var period$1 = rule[1];
		                   if(a){
		                    var
		                     weekstart = rule[3],
		                     weekdays = a[1],
		                     f = [0, 969837588, weekstart],
		                     g =
		                       function(a, b, cont){
		                        return caml_exact_trampoline_cps_call$0
		                                (pp_period, f, a, b, cont);
		                       };
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             fmt$82,
		                             function(a){
		                              return caml_trampoline_cps_call5
		                                      (a, g, period$1, pp$21, weekdays, b);
		                             });
		                   }
		                   var
		                    weekstart$0 = rule[3],
		                    h = [0, 969837588, weekstart$0],
		                    i =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (pp_period, h, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$83,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, i, period$1, b);
		                            });
		                  case 3:
		                   var
		                    period$2 = rule[1],
		                    j =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (pp_period, -300116725, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$84,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, j, period$2, b);
		                            });
		                  default:
		                   a = rule[2];
		                   var period$3 = rule[1];
		                   if(a && 1 !== a[1]){
		                    var
		                     month$0 = rule[3],
		                     day = a[1],
		                     month$1 = value(month$0, 0),
		                     m =
		                       function(a, b, cont){
		                        return caml_exact_trampoline_cps_call$0
		                                (pp_period, 992015837, a, b, cont);
		                       };
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             fmt$87,
		                             function(a){
		                              return caml_trampoline_cps_call7
		                                      (a, m, period$3, nth$3, day, pp$11, month$1, b);
		                             });
		                   }
		                   a = rule[3];
		                   if(a){
		                    var month = a[1];
		                    if(month){
		                     var
		                      k =
		                        function(a, b, cont){
		                         return caml_exact_trampoline_cps_call$0
		                                 (pp_period, 992015837, a, b, cont);
		                        };
		                     return caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              id,
		                              fmt$85,
		                              function(a){
		                               return caml_trampoline_cps_call5
		                                       (a, k, period$3, pp$11, month, b);
		                              });
		                    }
		                   }
		                   var
		                    l =
		                      function(a, b, cont){
		                       return caml_exact_trampoline_cps_call$0
		                               (pp_period, 992015837, a, b, cont);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$86,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, l, period$3, b);
		                            });
		                }
		               }
		               var letrec_function_context$215 = [];
		               function compare$84(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhs0 = rhs[1], lhs0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[14], lhs0, rhs0, cont);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[13], lhs0$0, rhs0$0, cont);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[12], lhs0$1, rhs0$1, cont);
		                   }
		                   break;
		                  case 3:
		                   if(3 === rhs[0]){
		                    var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[11], lhs0$2, rhs0$2, cont);
		                   }
		                   break;
		                  case 4:
		                   if(4 === rhs[0]){
		                    var rhs0$3 = rhs[1], lhs0$3 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[10], lhs0$3, rhs0$3, cont);
		                   }
		                   break;
		                  case 5:
		                   if(5 === rhs[0]){
		                    var rhs0$4 = rhs[1], lhs0$4 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[9], lhs0$4, rhs0$4, cont);
		                   }
		                   break;
		                  case 6:
		                   if(6 === rhs[0]){
		                    var rhs0$5 = rhs[1], lhs0$5 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[8], lhs0$5, rhs0$5, cont);
		                   }
		                   break;
		                  case 7:
		                   if(7 === rhs[0]){
		                    var rhs0$6 = rhs[1], lhs0$6 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[7], lhs0$6, rhs0$6, cont);
		                   }
		                   break;
		                  case 8:
		                   if(8 === rhs[0]){
		                    var rhs0$7 = rhs[1], lhs0$7 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[6], lhs0$7, rhs0$7, cont);
		                   }
		                   break;
		                  case 9:
		                   if(9 === rhs[0]){
		                    var rhs0$8 = rhs[1], lhs0$8 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[5], lhs0$8, rhs0$8, cont);
		                   }
		                   break;
		                  case 10:
		                   if(10 === rhs[0]){
		                    var rhs0$9 = rhs[1], lhs0$9 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[4], lhs0$9, rhs0$9, cont);
		                   }
		                   break;
		                  case 11:
		                   if(11 === rhs[0]){
		                    var rhs0$10 = rhs[1], lhs0$10 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[3], lhs0$10, rhs0$10, cont);
		                   }
		                   break;
		                  case 12:
		                   if(12 === rhs[0]){
		                    var rhs0$11 = rhs[1], lhs0$11 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[2], lhs0$11, rhs0$11, cont);
		                   }
		                   break;
		                  default:
		                   if(13 === rhs[0]){
		                    var rhs0$12 = rhs[1], lhs0$12 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$215[1], lhs0$12, rhs0$12, cont);
		                   }
		                }
		                function to_int(param){
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   case 6:
		                    return 6;
		                   case 7:
		                    return 7;
		                   case 8:
		                    return 8;
		                   case 9:
		                    return 9;
		                   case 10:
		                    return 10;
		                   case 11:
		                    return 11;
		                   case 12:
		                    return 12;
		                   default: return 13;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var
		                _5$2 = Task_recurrent[16],
		                _3$5 = include$50[16],
		                _1$15 = Event_recurrent[16];
		               caml_update_dummy
		                (letrec_function_context$215,
		                 [0,
		                  compare$77,
		                  compare$75,
		                  compare$73,
		                  compare$71,
		                  compare$66,
		                  compare$64,
		                  compare$60,
		                  compare$62,
		                  _5$2,
		                  compare$83,
		                  _3$5,
		                  compare$59,
		                  _1$15,
		                  compare$58]);
		               var
		                cst_Automation = "Automation",
		                cst_Automation_run = "Automation_run",
		                cst_Conversation = "Conversation",
		                cst_Event = "Event",
		                cst_Event_recurrent = "Event_recurrent",
		                cst_Organization = "Organization",
		                cst_Table_ref = "Table_ref",
		                cst_Task_recurrent = "Task_recurrent",
		                cst_Workspace_ref = "Workspace_ref",
		                letrec_function_context$216 = [];
		               function schema_versioned$130(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$216[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$216[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$216[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$216[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Ok,
		                                     Oj,
		                                     2,
		                                     2,
		                                     1,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$114,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([13, f0]);},
		             function(param, cont){
		              if(13 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_automation_run,
		             cst_Automation_run,
		             c,
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 Om,
		                 Ol,
		                 2,
		                 2,
		                 1,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$113,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([12, f0]);},
		                                 function(param, cont){
		                                  if(12 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_conversation,
		                                 cst_Conversation,
		                                 d,
		                                 a],
		                                b];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Oo,
		                                     On,
		                                     2,
		                                     2,
		                                     1,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$112,
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([11, f0]);},
		             function(param, cont){
		              if(11 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_automation,
		             cst_Automation,
		             d,
		             a],
		            c];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 Oq,
		                 Op,
		                 2,
		                 2,
		                 1,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$111,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([10, f0]);},
		                                 function(param, cont){
		                                  if(10 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_agent,
		                                 cst_Agent,
		                                 d,
		                                 a],
		                                b];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Os,
		                                     Or,
		                                     1,
		                                     0,
		                                     3,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$107,
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([9, f0]);},
		             function(param, cont){
		              if(9 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_workspace_ref,
		             cst_Workspace_ref,
		             d,
		             a],
		            c];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 Ou,
		                 Ot,
		                 1,
		                 0,
		                 3,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$106,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([8, f0]);},
		                                 function(param, cont){
		                                  if(8 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_table_ref,
		                                 cst_Table_ref,
		                                 d,
		                                 a],
		                                b];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Ow,
		                                     Ov,
		                                     2,
		                                     2,
		                                     1,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([7, f0]);},
		             function(param, cont){
		              if(7 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_organization,
		             cst_Organization,
		             d,
		             a],
		            c];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 Oy,
		                 Ox,
		                 0,
		                 21,
		                 9,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$105,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([6, f0]);},
		                                 function(param, cont){
		                                  if(6 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_object,
		                                 cst_Object,
		                                 d,
		                                 a],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (Task_recurrent[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_task_recurrent,
		   cst_Task_recurrent,
		   b,
		   0],
		  c];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$129,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_task,
		             cst_Task,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (include$50[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_people,
		                       cst_People,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$103,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_page,
		                                 cst_Page,
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Event_recurrent[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_event,
		    cst_Event,
		    schema$263,
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([1, f0]);},
		     function(param, cont){
		      if(1 !== param[0]) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     cst_event_recurrent,
		     cst_Event_recurrent,
		     a,
		     0],
		    b]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$216[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$216[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$298 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$216, [0, schematic_cache$298]);
		               caml_callback
		                (schema_versioned$130,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$217 = [];
		               function pp$51(fmt, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Oz,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[14],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OA, cont);
		        });
		                                      });
		                            });
		                  case 1:
		                   var a0$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OB,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[13],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OC, cont);
		        });
		                                      });
		                            });
		                  case 2:
		                   var a0$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OD,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[12],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$1,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OE, cont);
		        });
		                                      });
		                            });
		                  case 3:
		                   var a0$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OF,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[11],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$2,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OG, cont);
		        });
		                                      });
		                            });
		                  case 4:
		                   var a0$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OH,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[10],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$3,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OI, cont);
		        });
		                                      });
		                            });
		                  case 5:
		                   var a0$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OJ,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[9],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$4,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OK, cont);
		        });
		                                      });
		                            });
		                  case 6:
		                   var a0$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OL,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[8],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$5,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OM, cont);
		        });
		                                      });
		                            });
		                  case 7:
		                   var a0$6 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ON,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[7],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$6,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OO, cont);
		        });
		                                      });
		                            });
		                  case 8:
		                   var a0$7 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OP,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[6],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$7,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OQ, cont);
		        });
		                                      });
		                            });
		                  case 9:
		                   var a0$8 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OR,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[5],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$8,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OS, cont);
		        });
		                                      });
		                            });
		                  case 10:
		                   var a0$9 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OT,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[4],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$9,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OU, cont);
		        });
		                                      });
		                            });
		                  case 11:
		                   var a0$10 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OV,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[3],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$10,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OW, cont);
		        });
		                                      });
		                            });
		                  case 12:
		                   var a0$11 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OX,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[2],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$11,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), OY, cont);
		        });
		                                      });
		                            });
		                  default:
		                   var a0$12 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            OZ,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$217[1],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$12,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), O0, cont);
		        });
		                                      });
		                            });
		                }
		               }
		               var
		                _5$3 = Task_recurrent[1],
		                _3$6 = include$50[1],
		                _1$16 = Event_recurrent[1];
		               caml_update_dummy
		                (letrec_function_context$217,
		                 [0,
		                  _13,
		                  _12$1,
		                  _11$0,
		                  _10,
		                  pp$39,
		                  pp$38,
		                  pp$37,
		                  _33,
		                  _5$3,
		                  pp$50,
		                  _3$6,
		                  pp$36,
		                  _1$16,
		                  pp$35]);
		               function to_string$48(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var t = param[1];
		                   return caml_exact_trampoline_cps_call(to_string$29, t, cont);
		                  case 1:
		                   var t$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Event_recurrent[8], t$0, cont);
		                  case 2:
		                   var t$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$30, t$1, cont);
		                  case 3:
		                   var t$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (include$50[8], t$2, cont);
		                  case 4:
		                   var t$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$46, t$3, cont);
		                  case 5:
		                   var t$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Task_recurrent[8], t$4, cont);
		                  case 6:
		                   var t$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$32, t$5, cont);
		                  case 7:
		                   var t$6 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$31, t$6, cont);
		                  case 8:
		                   var t$7 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$33, t$7, cont);
		                  case 9:
		                   var t$8 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$34, t$8, cont);
		                  case 10:
		                   var t$9 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$38, t$9, cont);
		                  case 11:
		                   var t$10 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$39, t$10, cont);
		                  case 12:
		                   var t$11 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$40, t$11, cont);
		                  default:
		                   var t$12 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$41, t$12, cont);
		                }
		               }
		               function task$0(id){return [4, [1, id]];}
		               function of_string$40(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$22,
		                         s,
		                         function(match){
		                          if(0 !== match[0])
		                           return caml_exact_trampoline_cps_call
		                                   (Event_recurrent[6],
		                                    s,
		                                    function(match){
		                                     if(0 !== match[0])
		                                      return caml_exact_trampoline_cps_call
		      (of_string$23,
		       s,
		       function(match){
		        if(0 !== match[0])
		         return caml_exact_trampoline_cps_call
		                 (include$50[6],
		                  s,
		                  function(match){
		                   if(0 !== match[0])
		                    return caml_exact_trampoline_cps_call
		                            (of_string$29,
		                             s,
		                             function(match){
		                              if(0 !== match[0])
		                               return caml_exact_trampoline_cps_call
		                                       (Task_recurrent[6],
		s,
		function(match){
		 if(0 !== match[0])
		  return caml_exact_trampoline_cps_call
		          (of_string$25,
		           s,
		           function(match){
		            if(0 !== match[0])
		             return caml_exact_trampoline_cps_call
		                     (of_string$24,
		                      s,
		                      function(match){
		                       if(0 !== match[0])
		                        return caml_exact_trampoline_cps_call
		                                (of_string$26,
		                                 s,
		                                 function(match){
		                                  if(0 !== match[0])
		                                   return caml_exact_trampoline_cps_call
		   (of_string$27,
		    s,
		    function(match){
		     if(0 !== match[0])
		      return caml_exact_trampoline_cps_call
		              (of_string$31,
		               s,
		               function(match){
		                if(0 !== match[0])
		                 return caml_exact_trampoline_cps_call
		                         (of_string$32,
		                          s,
		                          function(match){
		                           if(0 !== match[0])
		                            return caml_exact_trampoline_cps_call
		                                    (of_string$33,
		                                     s,
		                                     function(match){
		                                      if(0 !== match[0])
		                                       return caml_exact_trampoline_cps_call
		       (of_string$34,
		        s,
		        function(match){
		         if(0 !== match[0])
		          return caml_exact_trampoline_cps_call$1
		                  (kasprintf,
		                   fail,
		                   format$17,
		                   function(a){return caml_trampoline_cps_call2(a, s, cont);});
		         var id = match[1];
		         return caml_trampoline_cps_call2
		                 (of_string$14, [13, id], cont);
		        });
		                                      var id = match[1];
		                                      return caml_trampoline_cps_call2
		      (of_string$14, [12, id], cont);
		                                     });
		                           var id = match[1];
		                           return caml_trampoline_cps_call2
		                                   (of_string$14, [11, id], cont);
		                          });
		                var id = match[1];
		                return caml_trampoline_cps_call2
		                        (of_string$14, [10, id], cont);
		               });
		     var id = match[1];
		     return caml_trampoline_cps_call2
		             (of_string$14, [9, id], cont);
		    });
		                                  var id = match[1];
		                                  return caml_trampoline_cps_call2
		  (of_string$14, [8, id], cont);
		                                 });
		                       var id = match[1];
		                       return caml_trampoline_cps_call2
		                               (of_string$14, [7, id], cont);
		                      });
		            var id = match[1];
		            return caml_trampoline_cps_call2
		                    (of_string$14, [6, id], cont);
		           });
		 var id = match[1];
		 return caml_trampoline_cps_call2
		         (of_string$14, [5, id], cont);
		});
		                              var id = match[1];
		                              return caml_trampoline_cps_call2
		                                      (of_string$14, [4, [1, id]], cont);
		                             });
		                   var id = match[1];
		                   return caml_trampoline_cps_call2
		                           (of_string$14, [3, id], cont);
		                  });
		        var id = match[1];
		        return caml_trampoline_cps_call2
		                (of_string$14, [2, id], cont);
		       });
		                                     var id = match[1];
		                                     return caml_trampoline_cps_call2
		     (of_string$14, [1, id], cont);
		                                    });
		                          var id = match[1];
		                          return caml_trampoline_cps_call2
		                                  (of_string$14, [0, id], cont);
		                         });
		               }
		               function pp$52(a, b, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (using, to_string$48, pp_print_string, a, b, cont);
		               }
		               var letrec_function_context$218 = [];
		               function kind_schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$218[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, O1, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$218[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$218[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$218[1][1] = a;
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           O3,
		                           O2,
		                           2,
		                           2,
		                           1,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(13);},
		                                 function(param, cont){
		                                  return 13 <= param ? cont(O5) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_automation_run,
		                                 cst_Automation_run,
		                                 O4,
		                                 [0, [0, b, V$4]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     O7,
		                                     O6,
		                                     2,
		                                     2,
		                                     1,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){return cont(12);},
		   function(param, cont){
		    return 12 === param ? cont(O9) : cont(0);
		   },
		   0,
		   0,
		   cst_conversation,
		   cst_Conversation,
		   O8,
		   [0, [0, c, V$4]]],
		  a];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       O$,
		       O_,
		       2,
		       2,
		       1,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(param, cont){return cont(11);},
		             function(param, cont){
		              return 11 === param ? cont(Pb) : cont(0);
		             },
		             0,
		             0,
		             cst_automation,
		             cst_Automation,
		             Pa,
		             [0, [0, c, V$4]]],
		            b];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 Pd,
		                 Pc,
		                 2,
		                 2,
		                 1,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(10);},
		                       function(param, cont){
		                        return 10 === param ? cont(Pf) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_agent,
		                       cst_Agent,
		                       Pe,
		                       [0, [0, c, V$4]]],
		                      a];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           Ph,
		                           Pg,
		                           1,
		                           0,
		                           4,
		                           function(c){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(9);},
		                                 function(param, cont){
		                                  return 9 === param ? cont(Pj) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_workspace_ref,
		                                 cst_Workspace_ref,
		                                 Pi,
		                                 [0, [0, c, V$4]]],
		                                b];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Pl,
		                                     Pk,
		                                     1,
		                                     0,
		                                     4,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){return cont(8);},
		   function(param, cont){
		    return 8 === param ? cont(Pn) : cont(0);
		   },
		   0,
		   0,
		   cst_table_ref,
		   cst_Table_ref,
		   Pm,
		   [0, [0, c, V$4]]],
		  a];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       Pp,
		       Po,
		       2,
		       2,
		       1,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(param, cont){return cont(7);},
		             function(param, cont){
		              return 7 === param ? cont(Pr) : cont(0);
		             },
		             0,
		             0,
		             cst_organization,
		             cst_Organization,
		             Pq,
		             [0, [0, c, V$4]]],
		            b];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 Pt,
		                 Ps,
		                 0,
		                 21,
		                 9,
		                 function(b){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(PH);},
		                        0,
		                        0,
		                        cst_event,
		                        cst_Event,
		                        PG,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(PF) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_event_rec,
		                         cst_Event_recurrent,
		                         PE,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(PD) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_page,
		                          cst_Page,
		                          PC,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(PB) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_people,
		                           cst_People,
		                           PA,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 === param ? cont(Pz) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_task,
		                            cst_Task,
		                            Py,
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(5);},
		                             function(param, cont){
		                              return 5 === param ? cont(Px) : cont(0);
		                             },
		                             0,
		                             0,
		                             cst_task_rec,
		                             cst_Task_recurrent,
		                             Pw,
		                             0],
		                            [0,
		                             [0,
		                              function(param, cont){return cont(6);},
		                              function(param, cont){
		                               return 6 === param ? cont(Pv) : cont(0);
		                              },
		                              0,
		                              0,
		                              cst_object,
		                              cst_Object,
		                              Pu,
		                              [0, [0, b, V$4]]],
		                             a]]]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$218[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$218[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$299 = [0, empty$11([0, comparator$9])],
		                bga = [];
		               caml_update_dummy(bga, [0, schematic_cache$299]);
		               var schematic_cache$300 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$218, [0, schematic_cache$300]);
		               function schematic_version$42(param){return 0;}
		               var
		                schematic_schema_version$134 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [bga[1][1], schematic_schema_version$134]);
		               if(h)
		                var schema$45 = h[1], descriptor$14 = schema$45;
		               else
		                descriptor$14 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              bga[1][1],
		                              schematic_schema_version$134,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bga[1][1],
		 schematic_schema_version$134,
		 schematic_self,
		 function(b){
		  bga[1][1] = b;
		  var
		   a =
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_id,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0];
		  return caml_exact_trampoline_cps_call
		          (kind_schema_versioned$0,
		           schematic_version$42,
		           function(b){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var id = param[2][1], kind = param[1];
		                 return cont([0, kind, id]);
		                },
		                function(param, cont){
		                 var id = param[2], kind = param[1];
		                 return cont([0, kind, [0, id, 0]]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, b], 0, 0], a]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     bga[1][1],
		                     schematic_schema_version$134,
		                     res,
		                     function(a){bga[1][1] = a; return cont(res);});
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               caml_callback
		                (kind_schema_versioned$0, [function(param){return 0;}]);
		               function schema_versioned$131(param, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 symbol_map = open[2];
		                function decode(param, cont){
		                 var id = param[2], kind = param[1];
		                 switch(kind){
		                   case 0:
		                    var a = function(id, cont){return cont([0, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$22,
		                             id,
		                             function(b){
		                              return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                             });
		                   case 1:
		                    var b = function(id, cont){return cont([1, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (Event_recurrent[6],
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, b, cont);
		                             });
		                   case 2:
		                    var c = function(id, cont){return cont([2, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$23,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, c, cont);
		                             });
		                   case 3:
		                    var d = function(id, cont){return cont([3, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (include$50[6],
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, d, cont);
		                             });
		                   case 4:
		                    var e = function(id, cont){return cont([4, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$39,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, e, cont);
		                             });
		                   case 5:
		                    var f = function(id, cont){return cont([5, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (Task_recurrent[6],
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, f, cont);
		                             });
		                   case 6:
		                    var g = function(id, cont){return cont([6, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$25,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, g, cont);
		                             });
		                   case 7:
		                    var h = function(id, cont){return cont([7, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$24,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, h, cont);
		                             });
		                   case 8:
		                    var i = function(id, cont){return cont([8, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$26,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, i, cont);
		                             });
		                   case 9:
		                    var j = function(id, cont){return cont([9, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$27,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, j, cont);
		                             });
		                   case 10:
		                    var k = function(id, cont){return cont([10, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$31,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, k, cont);
		                             });
		                   case 11:
		                    var l = function(id, cont){return cont([11, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$32,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, l, cont);
		                             });
		                   case 12:
		                    var m = function(id, cont){return cont([12, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$33,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, m, cont);
		                             });
		                   default:
		                    var n = function(id, cont){return cont([13, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$34,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, n, cont);
		                             });
		                 }
		                }
		                function encode(id, cont){
		                 switch(id[0]){
		                   case 0:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 0, a]);});
		                   case 1:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 1, a]);});
		                   case 2:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 2, a]);});
		                   case 3:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 3, a]);});
		                   case 4:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 4, a]);});
		                   case 5:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 5, a]);});
		                   case 6:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 6, a]);});
		                   case 7:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 7, a]);});
		                   case 8:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 8, a]);});
		                   case 9:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 9, a]);});
		                   case 10:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 10, a]);});
		                   case 11:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 11, a]);});
		                   case 12:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 12, a]);});
		                   default:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$48, id, function(a){return cont([0, 13, a]);});
		                 }
		                }
		                var descriptor = [4, decode, encode, descriptor$14];
		                return cont([0, id$21, 0, descriptor, 0]);
		               }
		               var schema$46 = caml_callback(schema_versioned$131, [dummy]);
		               function sexp_of_t$42(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var id = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$29, id, function(a){return cont([0, a]);});
		                  case 1:
		                   var id$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Event_recurrent[8],
		                            id$0,
		                            function(a){return cont([0, a]);});
		                  case 2:
		                   var id$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$30, id$1, function(a){return cont([0, a]);});
		                  case 3:
		                   var id$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (include$50[8], id$2, function(a){return cont([0, a]);});
		                  case 4:
		                   var id$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$46, id$3, function(a){return cont([0, a]);});
		                  case 5:
		                   var id$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Task_recurrent[8], id$4, function(a){return cont([0, a]);});
		                  case 6:
		                   var obj = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$36, obj, cont);
		                  case 7:
		                   var id$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$31, id$5, function(a){return cont([0, a]);});
		                  case 8:
		                   var id$6 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$33, id$6, function(a){return cont([0, a]);});
		                  case 9:
		                   var id$7 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$34, id$7, function(a){return cont([0, a]);});
		                  case 10:
		                   var t = param[1];
		                   return caml_exact_trampoline_cps_call(sexp_of_t$38, t, cont);
		                  case 11:
		                   var t$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$39, t$0, cont);
		                  case 12:
		                   var t$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$40, t$1, cont);
		                  default:
		                   var t$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$41, t$2, cont);
		                }
		               }
		               var
		                include$68 = Make$2([0, compare$84, sexp_of_t$42]),
		                equal$69 = include$68[7],
		                compare$85 = include$68[8],
		                comparator$24 = include$68[16];
		               function schema_versioned$132(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$130,
		                                   schematic_version,
		                                   function(a){return cont([0, PI, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$132,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$219 = [];
		               function pp$53(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$219[1], fmt, cont);
		               }
		               caml_update_dummy(letrec_function_context$219, [0, pp$51]);
		               caml_callback
		                (M_printable,
		                 [[0, pp$53, comparator$24, schema_versioned$132]]);
		               function schema_versioned$133(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$130,
		                                   schematic_version,
		                                   function(a){return cont([0, PJ, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$133,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$220 = [];
		               function pp$54(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$220[1], fmt, cont);
		               }
		               caml_update_dummy(letrec_function_context$220, [0, pp$51]);
		               caml_callback
		                (M_printable$0,
		                 [[0, pp$54, comparator$24, schema_versioned$133]]);
		               var letrec_function_context$221 = [];
		               function compare$86(lhs, rhs, cont){
		                var rhsemoji = rhs[1], lhsemoji = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$221[1], lhsemoji, rhsemoji, cont);
		               }
		               caml_update_dummy(letrec_function_context$221, [0, compare$82]);
		               var cst_Emoji = "Emoji", letrec_function_context$222 = [];
		               function schema_versioned$134(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$222[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, PK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$222[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$222[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$222[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     PM,
		                                     PL,
		                                     0,
		                                     23,
		                                     0,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  PN,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_emoji,
		    cst_Emoji,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var emoji = param[1];
		       return cont(emoji);
		      },
		      function(emoji, cont){return cont([0, emoji, 0]);},
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_emoji,
		        0,
		        2,
		        [0,
		         map$14
		          (of_utf8_string_res,
		           to_utf8_string,
		           schematic_param_name_schema_ve)],
		        0,
		        0],
		       0]],
		     0],
		    [0, [0, a, V$4]]],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$222[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$222[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$301 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$222, [0, schematic_cache$301]);
		               var
		                schema$47 =
		                  caml_callback
		                   (schema_versioned$134,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$223 = [];
		               function pp$55(fmt, param, cont){
		                var aemoji = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         PO,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   PP,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_emoji,
		     function(a){
		      return caml_trampoline_cps_call2
		              (letrec_function_context$223[1],
		               fmt,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         aemoji,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   PQ,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), PR, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$223, [0, pp$49]);
		               var
		                sexp_of_t$43 = caml_callback(encode$7, [schema$47]),
		                include$69 = Make$2([0, compare$86, sexp_of_t$43]),
		                equal$70 = include$69[7],
		                compare$87 = include$69[8],
		                letrec_function_context$224 = [];
		               function modern_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$224[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, PS, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$224[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$224[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$224[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$131,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var referee = param[1];
		   return cont([0, referee]);
		  },
		  function(param, cont){
		   var referee = param[1];
		   return cont([0, referee, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, "referee", 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$224[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$224[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$302 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$224, [0, schematic_cache$302]);
		               caml_callback
		                (modern_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var cst_row_id = "row_id", letrec_function_context$225 = [];
		               function legacy_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$225[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, PT, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$225[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$225[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$225[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$51[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_row_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$120,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        row_id = a[2][1],
		                        table_id = a[1],
		                        workspace_id = param[1];
		                       return cont([0, workspace_id, table_id, row_id]);
		                      },
		                      function(param, cont){
		                       var
		                        row_id = param[3],
		                        table_id = param[2],
		                        workspace_id = param[1];
		                       return cont
		                               ([0, workspace_id, [0, table_id, [0, row_id, 0]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_workspace_id, 0, 3, [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$225[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$225[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$303 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$225, [0, schematic_cache$303]);
		               caml_callback
		                (legacy_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Legacy = "Legacy",
		                cst_legacy = "legacy",
		                letrec_function_context$226 = [];
		               function either_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$226[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, PU, 0, descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$226[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$226[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$226[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (legacy_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_legacy,
		   cst_Legacy,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       PW,
		       PV,
		       2,
		       2,
		       1,
		       function(c){
		        var b = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (modern_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        "modern",
		                        "Modern",
		                        c,
		                        b],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$226[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$226[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$304 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$226, [0, schematic_cache$304]);
		               caml_callback
		                (either_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var bP0 = [];
		               function equal_bullet(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bP0[1],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                          if(! c) return cont(c);
		                          var b$0 = rhs[3], a$0 = lhs[3];
		                          return cont(a$0 === b$0 ? 1 : 0);
		                         });
		               }
		               var bPD = [];
		               function equal_callout(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(c){
		                 if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                 if(! c) return cont(c);
		                 var y = rhs[3], x = lhs[3];
		                 if(x){
		                  if(y){
		                   var b$0 = y[1], a$0 = x[1];
		                   return caml_trampoline_cps_call3(bPD[1], a$0, b$0, cont);
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3(bPD[2], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               function equal_check(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(! c) return cont(c);
		                var b$1 = rhs[3], a$1 = lhs[3];
		                return cont(a$1 === b$1 ? 1 : 0);
		               }
		               function equal_code(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(! c) return cont(c);
		                var b$0 = rhs[2], a$0 = lhs[2];
		                return cont(a$0 === b$0 ? 1 : 0);
		               }
		               function equal_heading(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(! c) return cont(c);
		                var b$1 = rhs[3], a$1 = lhs[3];
		                return cont(a$1 === b$1 ? 1 : 0);
		               }
		               function equal_list_type(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               var bP1 = [];
		               function equal_object(x, cont){
		                return caml_trampoline_cps_call2(bP1[1], x, cont);
		               }
		               function equal_paragraph(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1];
		                return cont(a === b ? 1 : 0);
		               }
		               var bPE = [];
		               function equal_recurrent_task(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(c){
		                 if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                 return c
		                         ? caml_trampoline_cps_call3(bPE[1], lhs[3], rhs[3], cont)
		                         : cont(c);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3(bPE[2], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               var letrec_function_context$227 = [];
		               function equal_todo(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(! c) return cont(c);
		                var y = rhs[3], x = lhs[3];
		                if(x){
		                 if(y){
		                  var b$1 = y[1], a$1 = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$227[1], a$1, b$1, cont);
		                 }
		                }
		                else if(! y) return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy(bP0, [0, equal_list_type]);
		               caml_update_dummy(bPD, [0, equal$70, equal$66]);
		               caml_update_dummy(bP1, [0, equal$69]);
		               var _0$14 = Task_recurrent[15];
		               caml_update_dummy(bPE, [0, equal$32, _0$14]);
		               caml_update_dummy(letrec_function_context$227, [0, equal$55]);
		               var bPq = [];
		               function compare_bullet(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPq[3],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          if(0 !== x) return cont(x);
		                          var a = rhs[2], b = lhs[2];
		                          return caml_trampoline_cps_call2
		                                  (bPq[2],
		                                   0,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (c,
		     b,
		     a,
		     function(x){
		      if(0 !== x) return cont(x);
		      var a = rhs[3], b = lhs[3];
		      return caml_trampoline_cps_call2
		              (bPq[1],
		               0,
		               function(c){
		                return caml_trampoline_cps_call3(c, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var bPr = [];
		               function compare_callout(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(x){
		                 if(0 !== x) return cont(x);
		                 var a = rhs[2], b = lhs[2];
		                 return caml_trampoline_cps_call2
		                         (bPr[2],
		                          0,
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(x){
		                                     if(0 !== x) return cont(x);
		                                     var y = rhs[3], x$0 = lhs[3];
		                                     if(! x$0) return y ? cont(-1) : cont(0);
		                                     var a = x$0[1];
		                                     if(! y) return cont(1);
		                                     var b = y[1];
		                                     return caml_trampoline_cps_call3(bPr[1], a, b, cont);
		                                    });
		                          });
		                }
		                if(! x) return y ? c(-1) : c(0);
		                var a = x[1];
		                if(! y) return c(1);
		                var b = y[1];
		                return caml_trampoline_cps_call3(bPr[3], a, b, c);
		               }
		               var bPs = [];
		               function compare_check(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (bPs[3],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (bPs[2],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(x){
		                if(0 !== x) return cont(x);
		                var a = rhs[3], b = lhs[3];
		                return caml_trampoline_cps_call2
		                        (bPs[1],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var bPF = [];
		               function compare_code(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (bPF[2],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (bPF[1],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3(c, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               var bPt = [];
		               function compare_heading(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (bPt[3],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (bPt[2],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(x){
		                if(0 !== x) return cont(x);
		                var a = rhs[3], b = lhs[3];
		                return caml_trampoline_cps_call2
		                        (bPt[1],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function compare_list_type(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(0);
		                }
		                else if(! rhs) return cont(0);
		                function to_int(param){return param ? 1 : 0;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var bP2 = [];
		               function compare_object(x, cont){
		                return caml_trampoline_cps_call2(bP2[1], x, cont);
		               }
		               var bP3 = [];
		               function compare_paragraph(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (bP3[1],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               }
		               var bPu = [];
		               function compare_recurrent_task(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(x){
		                 if(0 !== x) return cont(x);
		                 var a = rhs[2], b = lhs[2];
		                 return caml_trampoline_cps_call2
		                         (bPu[2],
		                          0,
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(x){
		                                     return 0 === x
		     ? caml_trampoline_cps_call3(bPu[1], lhs[3], rhs[3], cont)
		     : cont(x);
		                                    });
		                          });
		                }
		                if(! x) return y ? c(-1) : c(0);
		                var a = x[1];
		                if(! y) return c(1);
		                var b = y[1];
		                return caml_trampoline_cps_call3(bPu[3], a, b, c);
		               }
		               var letrec_function_context$228 = [];
		               function compare_todo(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$228[3],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$228[2],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(x){
		                if(0 !== x) return cont(x);
		                var y = rhs[3], x$0 = lhs[3];
		                if(! x$0) return y ? cont(-1) : cont(0);
		                var a = x$0[1];
		                if(! y) return cont(1);
		                var b = y[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$228[1], a, b, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function _2$14(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$17(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(bPq, [0, _2$14, _1$17, compare_list_type]);
		               function _1$18(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(bPr, [0, compare$87, _1$18, compare$81]);
		               function _2$15(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$19(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _0$15(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy(bPs, [0, _2$15, _1$19, _0$15]);
		               function _1$20(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _0$16(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(bPF, [0, _1$20, _0$16]);
		               function _2$16(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$21(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$17(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(bPt, [0, _2$16, _1$21, _0$17]);
		               caml_update_dummy(bP2, [0, compare$85]);
		               function _0$18(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(bP3, [0, _0$18]);
		               function _1$22(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               var _0$19 = Task_recurrent[16];
		               caml_update_dummy(bPu, [0, compare$48, _1$22, _0$19]);
		               function _1$23(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _0$20(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$228, [0, compare$68, _1$23, _0$20]);
		               var cst_depth = "depth", cst_list_type = "list_type", bgb = [];
		               function bullet_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bgb[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, PX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bgb[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bgb[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bgb[1][1] = b;
		                            var
		                             default$ = match$115[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_content,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_depth,
		                                  0,
		                                  [0, default$],
		                                  [0, int_schema],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (list_type_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    depth = a[2][1],
		    content = a[1],
		    list_type = param[1];
		   return cont([0, list_type, content, depth]);
		  },
		  function(param, cont){
		   var
		    depth = param[3],
		    content = param[2],
		    list_type = param[1];
		   return cont([0, list_type, [0, content, [0, depth, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_list_type, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bgb[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bgb[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_background_color = "background_color", bgc = [];
		               function callout_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bgc[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, PY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bgc[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bgc[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bgc[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$134,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_content,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_icon, 0, 3, [0, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$127,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              icon = a[2][1],
		              content = a[1],
		              background_color = param[1];
		             return cont([0, background_color, content, icon]);
		            },
		            function(param, cont){
		             var
		              icon = param[3],
		              content = param[2],
		              background_color = param[1];
		             return cont
		                     ([0, background_color, [0, content, [0, icon, 0]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_background_color, 0, 3, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bgc[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bgc[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bgd = [];
		               function check_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bgd[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, PZ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bgd[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bgd[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bgd[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     P1,
		                                     P0,
		                                     0,
		                                     24,
		                                     1,
		                                     function(a){
		                                      var
		                                       default$ = match$116[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    depth = a[2][1],
		    content = a[1],
		    checked = param[1];
		   return cont([0, checked, content, depth]);
		  },
		  function(param, cont){
		   var
		    depth = param[3],
		    content = param[2],
		    checked = param[1];
		   return cont([0, checked, [0, content, [0, depth, 0]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_checked, 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_content,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_depth,
		      0,
		      [0, default$],
		      [0, int_schema],
		      [0, [0, a, V$4]],
		      0],
		     0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bgd[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bgd[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_language = "language", bge = [];
		               function code_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bge[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, P2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bge[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bge[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bge[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var content = param[2][1], language = param[1];
		                                 return cont([0, language, content]);
		                                },
		                                function(param, cont){
		                                 var content = param[2], language = param[1];
		                                 return cont([0, language, [0, content, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_language,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_content,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bge[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bge[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_retracted = "retracted", bgf = [];
		               function heading_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bgf[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, P3, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bgf[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bgf[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bgf[1][1] = a;
		                            var
		                             default$ = match$117[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  retracted = a[2][1],
		                                  level = a[1],
		                                  content = param[1];
		                                 return cont([0, content, level, retracted]);
		                                },
		                                function(param, cont){
		                                 var
		                                  retracted = param[3],
		                                  level = param[2],
		                                  content = param[1];
		                                 return cont([0, content, [0, level, [0, retracted, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_content,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_level, 0, 2, [0, int_schema], 0, 0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_retracted,
		                                    0,
		                                    [0, default$],
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bgf[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bgf[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Ordered = "Ordered",
		                cst_Unordered = "Unordered",
		                bgs = [];
		               function list_type_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bgs[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, P4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bgs[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bgs[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bgs[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(P8);},
		                                  0,
		                                  0,
		                                  cst_ordered,
		                                  cst_Ordered,
		                                  P7,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(P6) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_unordered,
		                                   cst_Unordered,
		                                   P5,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bgs[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bgs[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function object_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (either_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    var
		                                     schema =
		                                       map$14
		(function(a, cont){
		  if(0 === a[0]){
		   var referee = a[1][1];
		   return cont([0, referee]);
		  }
		  a = a[1];
		  var row_id = a[3], table_id = a[2], workspace_id = a[1];
		  return cont([0, [6, [0, workspace_id, table_id, row_id]]]);
		 },
		 function(referee, cont){
		  if(6 !== referee[0]) return cont([0, [0, referee]]);
		  var
		   match = referee[1],
		   row_id = match[3],
		   table_id = match[2],
		   workspace_id = match[1];
		  return cont([1, [0, workspace_id, table_id, row_id]]);
		 },
		 a);
		                                    return cont([0, P9, 0, schema[3], schema[4]]);
		                                   });
		                         });
		               }
		               var bgt = [];
		               function paragraph_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bgt[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, P_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bgt[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bgt[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bgt[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var content = param[1];
		                                 return cont([0, content]);
		                                },
		                                function(param, cont){
		                                 var content = param[1];
		                                 return cont([0, content, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_content,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bgt[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bgt[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_recurrent_task_id = "recurrent_task_id", bgu = [];
		               function recurrent_task_schema_versione
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bgu[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, P$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bgu[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bgu[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bgu[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$15,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_content,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (Task_recurrent[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              recurrence = a[2][1],
		              content = a[1],
		              recurrent_task_id = param[1];
		             return cont([0, recurrent_task_id, content, recurrence]);
		            },
		            function(param, cont){
		             var
		              recurrence = param[3],
		              content = param[2],
		              recurrent_task_id = param[1];
		             return cont
		                     ([0, recurrent_task_id, [0, content, [0, recurrence, 0]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_recurrent_task_id, 0, 3, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bgu[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bgu[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$229 = [];
		               function todo_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$229[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Qa, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$229[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$229[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$229[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (schema_lenient,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    task = a[2][1],
		    content = a[1],
		    checked = param[1];
		   return cont([0, checked, content, task]);
		  },
		  function(param, cont){
		   var task = param[3], content = param[2], checked = param[1];
		   return cont([0, checked, [0, content, [0, task, 0]]]);
		  },
		  [0,
		   [0, Qd, 0, 0, 0, cst_checked, 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0,
		     Qc,
		     0,
		     0,
		     0,
		     cst_content,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0, [0, Qb, 0, 0, 0, cst_task, 0, 3, [0, a], 0, 0], 0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$229[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$229[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$305 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bgb, [0, schematic_cache$305]);
		               var schematic_cache$306 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bgc, [0, schematic_cache$306]);
		               var schematic_cache$307 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bgd, [0, schematic_cache$307]);
		               var schematic_cache$308 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bge, [0, schematic_cache$308]);
		               var schematic_cache$309 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bgf, [0, schematic_cache$309]);
		               var schematic_cache$310 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bgs, [0, schematic_cache$310]);
		               var schematic_cache$311 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bgt, [0, schematic_cache$311]);
		               var schematic_cache$312 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bgu, [0, schematic_cache$312]);
		               var schematic_cache$313 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$229, [0, schematic_cache$313]);
		               caml_callback
		                (bullet_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (callout_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (check_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (code_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (heading_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (list_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (object_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (paragraph_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (recurrent_task_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (todo_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var bP4 = [];
		               function pp_bullet(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Qe,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Qf,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_list_type,
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bP4[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Qg,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     Qh,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Qi,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_content,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Qj,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Qk,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Ql,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Qm,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_depth,
		     function(b){
		      var a = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Qn,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Qo,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), Qp, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var bPG = [];
		               function pp_callout(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Qq,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Qr,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_background_color,
		     function(a){
		      a = x[1];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Qs,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Qt,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    Qu,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_content,
		      function(b){
		       var a = x[2];
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Qv,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    Qw,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      Qx,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Qy,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_icon,
		                          function(a){
		                           a = x[3];
		                           function b(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     Qz,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt), QA, cont);
		                                     });
		                           }
		                           if(! a)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, b);
		                           var x$0 = a[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (bPG[1],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x$0,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, b);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(! a)
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst_None, b);
		      var x$0 = a[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst_Some,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (bPG[2],
		                         fmt,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, fmt, cst$18, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_check(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         QB,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QC,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_checked,
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QD,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QE,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     QF,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QG,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_content,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QH,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QI,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         QJ,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QK,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_depth,
		     function(b){
		      var a = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QL,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QM,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), QN, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_code(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         QO,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QP,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_language,
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QQ,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QR,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     QS,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QT,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_content,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QU,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QV,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), QW, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_heading(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         QX,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   QY,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_content,
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               QZ,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Q0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     Q1,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Q2,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_level,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Q3,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Q4,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Q5,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Q6,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_retracted,
		     function(b){
		      var a = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Q7,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Q8,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), Q9, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_list_type(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst_Unordered, cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst_Ordered, cont);
		               }
		               var bP5 = [];
		               function pp_object(fmt, cont){
		                return caml_trampoline_cps_call2(bP5[1], fmt, cont);
		               }
		               function pp_paragraph(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Q_,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Q$,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_content,
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Ra,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Rb,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), Rc, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var bPH = [];
		               function pp_recurrent_task(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Rd,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Re,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_recurrent_task_id,
		     function(a){
		      a = x[1];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Rf,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Rg,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    Rh,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_content,
		      function(b){
		       var a = x[2];
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Ri,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    Rj,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      Rk,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Rl,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_recurrence,
		                          function(b){
		                           var a = x[3];
		                           return caml_trampoline_cps_call2
		                                   (bPH[1],
		                                    fmt,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Rm,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), Rn, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(! a)
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst_None, b);
		      var x$0 = a[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst_Some,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (bPH[2],
		                         fmt,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, fmt, cst$18, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$230 = [];
		               function pp_todo(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Ro,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Rp,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_checked,
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Rq,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Rr,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     Rs,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Rt,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_content,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Ru,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Rv,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Rw,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Rx,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_task,
		     function(a){
		      a = x[3];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Ry,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), Rz, cont);
		                });
		      }
		      if(! a)
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst_None, b);
		      var x$0 = a[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst_Some,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$230[1],
		                         fmt,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, fmt, cst$18, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(bP4, [0, pp_list_type]);
		               caml_update_dummy(bPG, [0, pp$55, pp$48]);
		               caml_update_dummy(bP5, [0, pp$52]);
		               var _0$21 = Task_recurrent[1];
		               caml_update_dummy(bPH, [0, pp$23, _0$21]);
		               caml_update_dummy(letrec_function_context$230, [0, _16$0]);
		               var
		                cst_Divider = "Divider",
		                cst_blockquote = "blockquote",
		                cst_callout = "callout",
		                cst_check = "check",
		                cst_divider = "divider",
		                cst_embed = "embed",
		                cst_heading = "heading",
		                cst_recurrent_task = "recurrent_task";
		               function Make_kind(Payload, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 if(typeof lhs === "number"){
		                  if(typeof rhs === "number") return cont(1);
		                 }
		                 else
		                  switch(lhs[0]){
		                    case 0:
		                     if(typeof rhs !== "number" && 0 === rhs[0]){
		                      var rhs0 = rhs[1], lhs0 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[23],
		                               letrec_function_context[24],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0, rhs0, cont);
		                               });
		                     }
		                     break;
		                    case 1:
		                     if(typeof rhs !== "number" && 1 === rhs[0]){
		                      var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[21],
		                               letrec_function_context[22],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$0, rhs0$0, cont);
		                               });
		                     }
		                     break;
		                    case 2:
		                     if(typeof rhs !== "number" && 2 === rhs[0]){
		                      var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[19],
		                               letrec_function_context[20],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$1, rhs0$1, cont);
		                               });
		                     }
		                     break;
		                    case 3:
		                     if(typeof rhs !== "number" && 3 === rhs[0]){
		                      var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[17],
		                               letrec_function_context[18],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$2, rhs0$2, cont);
		                               });
		                     }
		                     break;
		                    case 4:
		                     if(typeof rhs !== "number" && 4 === rhs[0]){
		                      var rhs0$3 = rhs[1], lhs0$3 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[15],
		                               letrec_function_context[16],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$3, rhs0$3, cont);
		                               });
		                     }
		                     break;
		                    case 5:
		                     if(typeof rhs !== "number" && 5 === rhs[0]){
		                      var rhs0$4 = rhs[1], lhs0$4 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[13],
		                               letrec_function_context[14],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$4, rhs0$4, cont);
		                               });
		                     }
		                     break;
		                    case 6:
		                     if(typeof rhs !== "number" && 6 === rhs[0]){
		                      var rhs0$5 = rhs[1], lhs0$5 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[11],
		                               letrec_function_context[12],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$5, rhs0$5, cont);
		                               });
		                     }
		                     break;
		                    case 7:
		                     if(typeof rhs !== "number" && 7 === rhs[0]){
		                      var rhs0$6 = rhs[1], lhs0$6 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[9],
		                               letrec_function_context[10],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$6, rhs0$6, cont);
		                               });
		                     }
		                     break;
		                    case 8:
		                     if(typeof rhs !== "number" && 8 === rhs[0]){
		                      var rhs0$7 = rhs[1], lhs0$7 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[7],
		                               letrec_function_context[8],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$7, rhs0$7, cont);
		                               });
		                     }
		                     break;
		                    case 9:
		                     if(typeof rhs !== "number" && 9 === rhs[0]){
		                      var rhs0$8 = rhs[1], lhs0$8 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[5],
		                               letrec_function_context[6],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$8, rhs0$8, cont);
		                               });
		                     }
		                     break;
		                    case 10:
		                     if(typeof rhs !== "number" && 10 === rhs[0]){
		                      var rhs0$9 = rhs[1], lhs0$9 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[3],
		                               letrec_function_context[4],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$9, rhs0$9, cont);
		                               });
		                     }
		                     break;
		                    default:
		                     if(typeof rhs !== "number" && 11 === rhs[0]){
		                      var rhs0$10 = rhs[1], lhs0$10 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[1],
		                               letrec_function_context[2],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$10, rhs0$10, cont);
		                               });
		                     }
		                  }
		                 return cont(0);
		                }
		                var
		                 _23 = Payload[1],
		                 _21 = Payload[1],
		                 _19 = Payload[1],
		                 _17 = Payload[1],
		                 _15 = Payload[1],
		                 _13 = Payload[1],
		                 _11 = Payload[1],
		                 _9 = Payload[1],
		                 _7 = Payload[1],
		                 _5 = Payload[1],
		                 _3 = Payload[1],
		                 _1 = Payload[1];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0,
		                   _23,
		                   equal_todo,
		                   _21,
		                   equal_recurrent_task,
		                   _19,
		                   equal_paragraph,
		                   _17,
		                   equal_paragraph,
		                   _15,
		                   equal_object,
		                   _13,
		                   equal_heading,
		                   _11,
		                   equal_paragraph,
		                   _9,
		                   equal_callout,
		                   _7,
		                   equal_code,
		                   _5,
		                   equal_check,
		                   _3,
		                   equal_bullet,
		                   _1,
		                   equal_paragraph]);
		                var letrec_function_context$0 = [];
		                function compare(lhs, rhs, cont){
		                 if(typeof lhs === "number"){
		                  if(typeof rhs === "number") return cont(0);
		                 }
		                 else
		                  switch(lhs[0]){
		                    case 0:
		                     if(typeof rhs !== "number" && 0 === rhs[0]){
		                      var rhs0 = rhs[1], lhs0 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[23],
		                               letrec_function_context$0[24],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0, rhs0, cont);
		                               });
		                     }
		                     break;
		                    case 1:
		                     if(typeof rhs !== "number" && 1 === rhs[0]){
		                      var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[21],
		                               letrec_function_context$0[22],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$0, rhs0$0, cont);
		                               });
		                     }
		                     break;
		                    case 2:
		                     if(typeof rhs !== "number" && 2 === rhs[0]){
		                      var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[19],
		                               letrec_function_context$0[20],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$1, rhs0$1, cont);
		                               });
		                     }
		                     break;
		                    case 3:
		                     if(typeof rhs !== "number" && 3 === rhs[0]){
		                      var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[17],
		                               letrec_function_context$0[18],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$2, rhs0$2, cont);
		                               });
		                     }
		                     break;
		                    case 4:
		                     if(typeof rhs !== "number" && 4 === rhs[0]){
		                      var rhs0$3 = rhs[1], lhs0$3 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[15],
		                               letrec_function_context$0[16],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$3, rhs0$3, cont);
		                               });
		                     }
		                     break;
		                    case 5:
		                     if(typeof rhs !== "number" && 5 === rhs[0]){
		                      var rhs0$4 = rhs[1], lhs0$4 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[13],
		                               letrec_function_context$0[14],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$4, rhs0$4, cont);
		                               });
		                     }
		                     break;
		                    case 6:
		                     if(typeof rhs !== "number" && 6 === rhs[0]){
		                      var rhs0$5 = rhs[1], lhs0$5 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[11],
		                               letrec_function_context$0[12],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$5, rhs0$5, cont);
		                               });
		                     }
		                     break;
		                    case 7:
		                     if(typeof rhs !== "number" && 7 === rhs[0]){
		                      var rhs0$6 = rhs[1], lhs0$6 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[9],
		                               letrec_function_context$0[10],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$6, rhs0$6, cont);
		                               });
		                     }
		                     break;
		                    case 8:
		                     if(typeof rhs !== "number" && 8 === rhs[0]){
		                      var rhs0$7 = rhs[1], lhs0$7 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[7],
		                               letrec_function_context$0[8],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$7, rhs0$7, cont);
		                               });
		                     }
		                     break;
		                    case 9:
		                     if(typeof rhs !== "number" && 9 === rhs[0]){
		                      var rhs0$8 = rhs[1], lhs0$8 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[5],
		                               letrec_function_context$0[6],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$8, rhs0$8, cont);
		                               });
		                     }
		                     break;
		                    case 10:
		                     if(typeof rhs !== "number" && 10 === rhs[0]){
		                      var rhs0$9 = rhs[1], lhs0$9 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[3],
		                               letrec_function_context$0[4],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$9, rhs0$9, cont);
		                               });
		                     }
		                     break;
		                    default:
		                     if(typeof rhs !== "number" && 11 === rhs[0]){
		                      var rhs0$10 = rhs[1], lhs0$10 = lhs[1];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context$0[1],
		                               letrec_function_context$0[2],
		                               function(a){
		                                return caml_trampoline_cps_call3(a, lhs0$10, rhs0$10, cont);
		                               });
		                     }
		                  }
		                 function to_int(param){
		                  if(typeof param === "number") return 5;
		                  switch(param[0]){
		                    case 0:
		                     return 0;
		                    case 1:
		                     return 1;
		                    case 2:
		                     return 2;
		                    case 3:
		                     return 3;
		                    case 4:
		                     return 4;
		                    case 5:
		                     return 6;
		                    case 6:
		                     return 7;
		                    case 7:
		                     return 8;
		                    case 8:
		                     return 9;
		                    case 9:
		                     return 10;
		                    case 10:
		                     return 11;
		                    default: return 12;
		                  }
		                 }
		                 var a = to_int(rhs);
		                 return cont(caml_int_compare(to_int(lhs), a));
		                }
		                var
		                 _23$0 = Payload[2],
		                 _21$0 = Payload[2],
		                 _19$0 = Payload[2],
		                 _17$0 = Payload[2],
		                 _15$0 = Payload[2],
		                 _13$0 = Payload[2],
		                 _11$0 = Payload[2],
		                 _9$0 = Payload[2],
		                 _7$0 = Payload[2],
		                 _5$0 = Payload[2],
		                 _3$0 = Payload[2],
		                 _1$0 = Payload[2];
		                caml_update_dummy
		                 (letrec_function_context$0,
		                  [0,
		                   _23$0,
		                   compare_todo,
		                   _21$0,
		                   compare_recurrent_task,
		                   _19$0,
		                   compare_paragraph,
		                   _17$0,
		                   compare_paragraph,
		                   _15$0,
		                   compare_object,
		                   _13$0,
		                   compare_heading,
		                   _11$0,
		                   compare_paragraph,
		                   _9$0,
		                   compare_callout,
		                   _7$0,
		                   compare_code,
		                   _5$0,
		                   compare_check,
		                   _3$0,
		                   compare_bullet,
		                   _1$0,
		                   compare_paragraph]);
		                var letrec_function_context$1 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$1[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, [0, Payload[7]], 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$1[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$1[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$1[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (todo_schema_versioned,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (Payload[3],
		        schematic_version,
		        a,
		        function(b){
		         var
		          a =
		            [0,
		             [0,
		              function(f0, cont){return cont([11, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 11 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              0,
		              0,
		              cst_todo,
		              cst_Todo,
		              b,
		              0],
		             0];
		         return caml_exact_trampoline_cps_call
		                 (recurrent_task_schema_versione,
		                  schematic_version,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (Payload[3],
		                            schematic_version,
		                            b,
		                            function(c){
		                             var
		                              b =
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([10, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 10 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_recurrent_task,
		                                  cst_Recurrent_task,
		                                  c,
		                                  0],
		                                 a];
		                             return caml_exact_trampoline_cps_call
		                                     (paragraph_schema_versioned,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (Payload[3],
		        schematic_version,
		        a,
		        function(c){
		         var
		          a =
		            [0,
		             [0,
		              function(f0, cont){return cont([9, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 9 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              0,
		              0,
		              cst_query,
		              cst_Query,
		              c,
		              0],
		             b];
		         return caml_exact_trampoline_cps_call
		                 (paragraph_schema_versioned,
		                  schematic_version,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (Payload[3],
		                            schematic_version,
		                            b,
		                            function(c){
		                             var
		                              b =
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([8, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 8 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_paragraph,
		                                  cst_Paragraph,
		                                  c,
		                                  0],
		                                 a];
		                             return caml_exact_trampoline_cps_call$3
		                                     (make$4,
		                                      RB,
		                                      RA,
		                                      0,
		                                      22,
		                                      2,
		                                      function(c){
		                                       var a = [0, [0, c, V$4]];
		                                       return caml_exact_trampoline_cps_call
		       (object_schema_versioned,
		        schematic_version,
		        function(c){
		         return caml_trampoline_cps_call3
		                 (Payload[3],
		                  schematic_version,
		                  c,
		                  function(d){
		                   var
		                    c =
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([7, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_object,
		                        cst_Object,
		                        d,
		                        a],
		                       b];
		                   return caml_exact_trampoline_cps_call
		                           (heading_schema_versioned,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (Payload[3],
		                                      schematic_version,
		                                      a,
		                                      function(b){
		                                       var
		a =
		  [0,
		   [0,
		    function(f0, cont){return cont([6, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    0,
		    0,
		    cst_heading,
		    cst_Heading,
		    b,
		    0],
		   c];
		                                       return caml_exact_trampoline_cps_call
		       (paragraph_schema_versioned,
		        schematic_version,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (Payload[3],
		                  schematic_version,
		                  b,
		                  function(c){
		                   var
		                    b =
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){
		                         return typeof param === "number" ? cont(RC) : cont(0);
		                        },
		                        0,
		                        0,
		                        cst_divider,
		                        cst_Divider,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){return cont(0);},
		                          function(param, cont){return cont(0);},
		                          0],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([5, f0]);},
		                         function(param, cont){
		                          if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                          return cont(0);
		                         },
		                         0,
		                         0,
		                         cst_embed,
		                         cst_Embed,
		                         c,
		                         0],
		                        a]];
		                   return caml_exact_trampoline_cps_call
		                           (callout_schema_versioned,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (Payload[3],
		                                      schematic_version,
		                                      a,
		                                      function(c){
		                                       var
		a =
		  [0,
		   [0,
		    function(f0, cont){return cont([4, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    0,
		    0,
		    cst_callout,
		    cst_Callout,
		    c,
		    0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (code_schema_versioned,
		        schematic_version,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (Payload[3],
		                  schematic_version,
		                  b,
		                  function(c){
		                   var
		                    b =
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([3, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_code,
		                        cst_Code,
		                        c,
		                        0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (check_schema_versioned,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (Payload[3],
		                                      schematic_version,
		                                      a,
		                                      function(c){
		                                       var
		a =
		  [0,
		   [0,
		    function(f0, cont){return cont([2, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    0,
		    0,
		    cst_check,
		    cst_Check,
		    c,
		    0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (bullet_schema_versioned,
		        schematic_version,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (Payload[3],
		                  schematic_version,
		                  b,
		                  function(c){
		                   var
		                    b =
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([1, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_bullet,
		                        cst_Bullet,
		                        c,
		                        0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (paragraph_schema_versioned,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (Payload[3],
		                                      schematic_version,
		                                      a,
		                                      function(a){
		                                       var
		res =
		  [11,
		   RD,
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		      return cont(0);
		     },
		     0,
		     0,
		     cst_blockquote,
		     cst_Blockquote,
		     a,
		     0],
		    b],
		   0];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context$1[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context$1[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$1, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, param, cont){
		                           if(typeof param === "number")
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_Divider, cont);
		                           switch(param[0]){
		                             case 0:
		                              var a0 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RE,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[23],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[24], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RF, cont);
		                   });
		         });
		                                       });
		                             case 1:
		                              var a0$0 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RG,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[21],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[22], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$0,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RH, cont);
		                   });
		         });
		                                       });
		                             case 2:
		                              var a0$1 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RI,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[19],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[20], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$1,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RJ, cont);
		                   });
		         });
		                                       });
		                             case 3:
		                              var a0$2 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RK,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[17],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[18], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$2,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RL, cont);
		                   });
		         });
		                                       });
		                             case 4:
		                              var a0$3 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RM,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[15],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[16], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$3,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RN, cont);
		                   });
		         });
		                                       });
		                             case 5:
		                              var a0$4 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RO,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[13],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[14], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$4,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RP, cont);
		                   });
		         });
		                                       });
		                             case 6:
		                              var a0$5 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RQ,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[11],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[12], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$5,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RR, cont);
		                   });
		         });
		                                       });
		                             case 7:
		                              var a0$6 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RS,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[9],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[10], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$6,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RT, cont);
		                   });
		         });
		                                       });
		                             case 8:
		                              var a0$7 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RU,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[7],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[8], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$7,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RV, cont);
		                   });
		         });
		                                       });
		                             case 9:
		                              var a0$8 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RW,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[5],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[6], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$8,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RX, cont);
		                   });
		         });
		                                       });
		                             case 10:
		                              var a0$9 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       RY,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[3],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[4], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$9,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), RZ, cont);
		                   });
		         });
		                                       });
		                             default:
		                              var a0$10 = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       R0,
		                                       function(a){
		return caml_trampoline_cps_call3
		        (letrec_function_context[1],
		         function(fmt, cont){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[2], fmt, cont);
		         },
		         fmt,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   a0$10,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), R1, cont);
		                   });
		         });
		                                       });
		                           }
		                          }
		                          var
		                           _23 = Payload[5],
		                           _21 = Payload[5],
		                           _19 = Payload[5],
		                           _17 = Payload[5],
		                           _15 = Payload[5],
		                           _13 = Payload[5],
		                           _11 = Payload[5],
		                           _9 = Payload[5],
		                           _7 = Payload[5],
		                           _5 = Payload[5],
		                           _3 = Payload[5],
		                           _1 = Payload[5];
		                          caml_update_dummy
		                           (letrec_function_context,
		                            [0,
		                             _23,
		                             pp_todo,
		                             _21,
		                             pp_recurrent_task,
		                             _19,
		                             pp_paragraph,
		                             _17,
		                             pp_paragraph,
		                             _15,
		                             pp_object,
		                             _13,
		                             pp_heading,
		                             _11,
		                             pp_paragraph,
		                             _9,
		                             pp_callout,
		                             _7,
		                             pp_code,
		                             _5,
		                             pp_check,
		                             _3,
		                             pp_bullet,
		                             _1,
		                             pp_paragraph]);
		                          return cont
		                                  ([0, equal, compare, schema_versioned, schema, pp]);
		                         });
		               }
		               function equal$71(poly_a, a, param, cont){return cont(1);}
		               function compare$88(poly_a, a, param, cont){return cont(0);}
		               function schema_versioned$135(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi$0, cont){
		                                    var
		                                     id = match$118[1],
		                                     a = schematic_param_a_schema_versi[4],
		                                     b = schematic_param_a_schema_versi[3];
		                                    return caml_exact_trampoline_cps_call$1
		    (combine,
		     schematic_param_a_schema_versi$0,
		     id,
		     function(c){return cont([0, c, 0, b, a]);});
		                                   });
		                         });
		               }
		               function pp$56(poly_a, fmt, param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, cst$17, cont);
		               }
		               caml_callback
		                (Make_kind,
		                 [[0,
		                   equal$71,
		                   compare$88,
		                   schema_versioned$135,
		                   ,
		                   pp$56,
		                   ,
		                   "block-kind"]]);
		               function equal$72(poly_a, cont){return cont(poly_a);}
		               function compare$89(poly_a, cont){return cont(poly_a);}
		               function pp$57(poly_a, fmt, cont){
		                return caml_trampoline_cps_call2(poly_a, fmt, cont);
		               }
		               function schema_versioned$136(version, content, cont){return cont(content);
		               }
		               var
		                include$70 =
		                  caml_callback
		                   (Make_kind,
		                    [[0,
		                      equal$72,
		                      compare$89,
		                      schema_versioned$136,
		                      ,
		                      pp$57,
		                      ,
		                      "block-content"]]),
		                equal$73 = include$70[1],
		                compare$90 = include$70[2],
		                schema_versioned$137 = include$70[3],
		                schema$48 = include$70[4],
		                pp$58 = include$70[5],
		                letrec_function_context$231 = [];
		               function equal$74(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$231[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$231[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               var _0$22 = include$48[15];
		               caml_update_dummy
		                (letrec_function_context$231, [0, equal$73, _0$22]);
		               var letrec_function_context$232 = [];
		               function compare$91(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$232[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$232[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               var _0$23 = include$48[16];
		               caml_update_dummy
		                (letrec_function_context$232, [0, compare$90, _0$23]);
		               var
		                schematic_cache$314 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$233 = [];
		               caml_update_dummy
		                (letrec_function_context$233, [0, schematic_cache$314]);
		               function schematic_version$43(param, cont){return cont(0);}
		               var schematic_schema_version$133 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$233[1][1],
		                    schematic_schema_version$133]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$233[1][1],
		                             schematic_schema_version$133,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$233[1][1],
		schematic_schema_version$133,
		schematic_self,
		function(a){
		 letrec_function_context$233[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$137,
		          schematic_version$43,
		          function(b){
		           var
		            a =
		              [0, [0, R2, 0, 0, 0, cst_content, 0, 2, [1, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (include$48[4],
		                    schematic_version$43,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var content = param[2][1], id = param[1];
		                          return cont([0, id, content]);
		                         },
		                         function(param, cont){
		                          var content = param[2], id = param[1];
		                          return cont([0, id, [0, content, 0]]);
		                         },
		                         [0, [0, R3, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$233[1][1],
		                              schematic_schema_version$133,
		                              res,
		                              function(a){
		                               letrec_function_context$233[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$234 = [];
		               function pp$59(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         R4,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   R5,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_id,
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$234[2],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   R6,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     R7,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               R8,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_content,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$234[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               R9,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), R_, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var _0$24 = include$48[1];
		               caml_update_dummy
		                (letrec_function_context$234, [0, pp$58, _0$24]);
		               function id$32(param, cont){
		                var id = param[1];
		                return cont(id);
		               }
		               function text(param){
		                if(typeof param === "number") return cst$1;
		                switch(param[0]){
		                  case 7:
		                   return cst$1;
		                  case 0:
		                  case 5:
		                  case 6:
		                  case 8:
		                  case 9:
		                   var content = param[1][1]; break;
		                  default: content = param[1][2];
		                }
		                return content;
		               }
		               function with_text(a, content){
		                if(typeof content === "number") return content;
		                switch(content[0]){
		                  case 0:
		                   return [0, [0, a]];
		                  case 1:
		                   var bullet = content[1];
		                   return [1, [0, bullet[1], a, bullet[3]]];
		                  case 2:
		                   var check = content[1];
		                   return [2, [0, check[1], a, check[3]]];
		                  case 3:
		                   var code = content[1]; return [3, [0, code[1], a]];
		                  case 4:
		                   var callout = content[1];
		                   return [4, [0, callout[1], a, callout[3]]];
		                  case 5:
		                   return [5, [0, a]];
		                  case 6:
		                   var heading = content[1];
		                   return [6, [0, a, heading[2], heading[3]]];
		                  case 7:
		                   return content;
		                  case 8:
		                   return [8, [0, a]];
		                  case 9:
		                   return [9, [0, a]];
		                  case 10:
		                   var task = content[1];
		                   return [10, [0, task[1], a, task[3]]];
		                  default:
		                   var task$0 = content[1];
		                   return [11, [0, task$0[1], a, task$0[3]]];
		                }
		               }
		               function make$33(id, content){
		                var id$1; id$1 = include$48[29].call(null);
		                return [0, id$1, content];
		               }
		               function text$0(block){return text(block[2]);}
		               var letrec_function_context$235 = [];
		               function schema_versioned$138(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$235[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, R$, 0, descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$235[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$235[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$235[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$137,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (include$48[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var content = param[2][1], id = param[1];
		             return cont([0, id, content]);
		            },
		            function(param, cont){
		             var content = param[2], id = param[1];
		             return cont([0, id, [0, content, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 3, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$235[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$235[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$315 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$235, [0, schematic_cache$315]);
		               caml_callback
		                (schema_versioned$138,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$139(v, cont){
		                function decode(param, cont){
		                 var content = param[2], id = param[1];
		                 if(id)
		                  var id$0 = id[1], id$1 = id$0;
		                 else
		                  id$1 = include$48[29].call(null);
		                 return caml_trampoline_cps_call2
		                         (of_string$14, [0, id$1, content], cont);
		                }
		                function encode(param, cont){
		                 var content = param[2], id = param[1];
		                 return cont([0, [0, id], content]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$138,
		                         v,
		                         function(a){return cont(map$14(decode, encode, a));});
		               }
		               var
		                schema$49 =
		                  caml_callback
		                   (schema_versioned$139,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$236 = [];
		               function equal$75(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$236[1],
		                            a$0,
		                            b,
		                            function(b){
		                             return b
		                                     ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                     : cont(b);
		                            });
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                }
		                return a(x, y);
		               }
		               caml_update_dummy(letrec_function_context$236, [0, equal$74]);
		               var letrec_function_context$237 = [];
		               function compare$92(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 if(! x) return y ? cont(-1) : cont(0);
		                 if(! y) return cont(1);
		                 var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context$237[1],
		                          a$0,
		                          b,
		                          function(x){
		                           return 0 === x
		                                   ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                   : cont(x);
		                          });
		                }
		                return a(x, y);
		               }
		               caml_update_dummy(letrec_function_context$237, [0, compare$91]);
		               var letrec_function_context$238 = [];
		               function schema_versioned$140(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$238[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Sa, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$238[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$238[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$238[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$139,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var blocks = param[1];
		   return cont([0, blocks]);
		  },
		  function(param, cont){
		   var blocks = param[1];
		   return cont([0, blocks, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_blocks,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$238[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$238[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$316 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$238, [0, schematic_cache$316]);
		               caml_callback
		                (schema_versioned$140,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$239 = [];
		               function _13$0(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Sb,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Sc,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_blocks,
		     function(a){
		      var x$0 = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Sd,
		               function(b){
		                function a(accu, l$0){
		                 if(! l$0)
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Sf,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     Sg,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt), Sh, cont);
		                                     });
		                           });
		                 var l = l$0[2], a$0 = l$0[1];
		                 function b(b){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$239[1],
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a$0,
		                                     function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                           });
		                 }
		                 return accu
		                         ? caml_exact_trampoline_cps_call(fprintf$0(fmt), Se, b)
		                         : b();
		                }
		                return a(0, x$0);
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$239, [0, pp$59]);
		               var letrec_function_context$240 = [];
		               function schema_versioned$141(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$240[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Si, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$240[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$240[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$240[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_version, 0, 2, [0, int_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var version = param[2][1], time = param[1];
		   return cont([0, time, version]);
		  },
		  function(param, cont){
		   var version = param[2], time = param[1];
		   return cont([0, time, [0, version, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_time, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$240[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$240[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$317 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$240, [0, schematic_cache$317]);
		               caml_callback
		                (schema_versioned$141,
		                 [function(param, cont){return cont(0);}]);
		               function make$34(opt, time){
		                var version = opt ? opt[1] : 0;
		                return [0, time, version];
		               }
		               function pp$60(f, param, cont){
		                var version = param[2], time = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         Sj,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (a, version, _12, time, cont);
		                         });
		               }
		               function compare$93(a, param, cont){
		                var r = param[2], l = a[2];
		                return cont(caml_int_compare(l, r));
		               }
		               function sexp_of_t$44(etag, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_to_string,
		                         pp$60,
		                         etag,
		                         function(a){return cont([0, a]);});
		               }
		               var
		                include$71 = Make$2([0, compare$93, sexp_of_t$44]),
		                equal$76 = include$71[7],
		                include$72 = caml_callback(Make$12, [[0, cst_column, cst$21]]),
		                pp$61 = include$72[1],
		                schema_versioned$142 = include$72[4],
		                schema$50 = include$72[5],
		                of_string$41 = include$72[6],
		                equal$77 = include$72[15],
		                comparator$25 = include$72[24],
		                Set$1 = include$72[26],
		                By$9 = include$72[27],
		                hash$21 = include$72[28],
		                make$35 = include$72[29],
		                compare_direct$0 = By$9[51],
		                equal$78 = By$9[53],
		                to_alist$1 = By$9[56],
		                schema_versioned$143 = By$9[102],
		                empty$23 = By$9[104],
		                of_alist_exn$3 = By$9[107],
		                _10$0 = By$9[121];
		               function _17(poly_a, fmt, cont){
		                return caml_trampoline_cps_call2(poly_a, fmt, cont);
		               }
		               function compare$94(poly_a, cont){return cont(poly_a);}
		               function schema_versioned$144
		               (schematic_version, schematic_param_a_schema_versi, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (map$14
		                                    (function(param, cont){
		                                      var value = param[1];
		                                      return cont([0, value]);
		                                     },
		                                     function(value, cont){return cont([0, value]);},
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var value = param[1];
		return cont([0, value]);
		                                       },
		                                       function(param, cont){
		var value = param[1];
		return cont([0, value, 0]);
		                                       },
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_value,
		 0,
		 2,
		 [0, schematic_param_a_schema_versi],
		 0,
		 0],
		0]]]));
		                         });
		               }
		               var letrec_function_context$241 = [];
		               function schema_versioned$145(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$241[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Sk, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$241[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$241[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$241[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$51[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_row, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var row = param[2][1], table = param[1];
		             return cont([0, table, row]);
		            },
		            function(param, cont){
		             var row = param[2], table = param[1];
		             return cont([0, table, [0, row, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_table, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$241[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$241[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$318 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$241, [0, schematic_cache$318]);
		               caml_callback
		                (schema_versioned$145,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$242 = [];
		               function compare$95(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$242[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$242[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               var _1$24 = include$51[16], _0$25 = Table[16];
		               caml_update_dummy
		                (letrec_function_context$242, [0, _1$24, _0$25]);
		               var letrec_function_context$243 = [];
		               function pp$62(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Sl,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Sm,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Cell.Relation.Table.table",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$243[2],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Sn,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     So,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Sp,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_row,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$243[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Sq,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), Sr, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var _1$25 = include$51[1], _0$26 = Table[1];
		               caml_update_dummy
		                (letrec_function_context$243, [0, _1$25, _0$26]);
		               var cst_Member = "Member", letrec_function_context$244 = [];
		               function schema_versioned$146(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$244[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, St, Ss, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$244[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$244[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$244[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$50[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_event,
		   cst_Event,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0], 0]],
		    0],
		   0],
		  [0,
		   [0,
		    function(f0, cont){return cont([4, f0]);},
		    function(param, cont){
		     if(4 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_people,
		    cst_People,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){var id = param[1]; return cont(id);},
		      function(id, cont){return cont([0, id, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		     0],
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$109,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_task,
		             cst_Task,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){var id = param[1]; return cont(id);},
		               function(id, cont){return cont([0, id, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$103,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_page,
		                       cst_Page,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){var id = param[1]; return cont(id);},
		                         function(id, cont){return cont([0, id, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$117,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                Su,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_member,
		                                  cst_Member,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){var id = param[1]; return cont(id);},
		                                    function(id, cont){return cont([0, id, 0]);},
		                                    [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		                                   0],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$244[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$244[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$319 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$244, [0, schematic_cache$319]);
		               caml_callback
		                (schema_versioned$146,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$245 = [];
		               function compare$96(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhsid = rhs[1], lhsid = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$245[5], lhsid, rhsid, cont);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var rhsid$0 = rhs[1], lhsid$0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$245[4], lhsid$0, rhsid$0, cont);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhsid$1 = rhs[1], lhsid$1 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$245[3], lhsid$1, rhsid$1, cont);
		                   }
		                   break;
		                  case 3:
		                   if(3 === rhs[0]){
		                    var rhsid$2 = rhs[1], lhsid$2 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$245[2], lhsid$2, rhsid$2, cont);
		                   }
		                   break;
		                  default:
		                   if(4 === rhs[0]){
		                    var rhsid$3 = rhs[1], lhsid$3 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$245[1], lhsid$3, rhsid$3, cont);
		                   }
		                }
		                function to_int(param){
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   default: return 4;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var _4$1 = include$50[16];
		               caml_update_dummy
		                (letrec_function_context$245,
		                 [0, _4$1, compare$58, compare$68, compare$59, compare$79]);
		               var letrec_function_context$246 = [];
		               function pp$63(fmt, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var aid = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Sv,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Sw,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$246[5],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aid,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      Sx,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), Sy, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var aid$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Sz,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SA,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$246[4],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aid$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SB,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), SC, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var aid$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            SD,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SE,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$246[3],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aid$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SF,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), SG, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var aid$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            SH,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SI,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$246[2],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aid$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SJ,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), SK, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var aid$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            SL,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SM,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$246[1],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aid$3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      SN,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), SO, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               var _4$2 = include$50[1];
		               caml_update_dummy
		                (letrec_function_context$246,
		                 [0, _4$2, pp$35, _16$0, pp$36, pp$44]);
		               var cst_Table = "Table", letrec_function_context$247 = [];
		               function schema_versioned$147(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$247[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, SQ, SP, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$247[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$247[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$247[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     SS,
		                                     SR,
		                                     0,
		                                     23,
		                                     0,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$146,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_default,
		             cst_Default,
		             c,
		             a],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$145,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_table,
		                        cst_Table,
		                        a,
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$247[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$247[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$320 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$247, [0, schematic_cache$320]);
		               caml_callback
		                (schema_versioned$147,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$248 = [];
		               function compare$97(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$248[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$248[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               caml_update_dummy
		                (letrec_function_context$248, [0, compare$96, compare$95]);
		               var letrec_function_context$249 = [];
		               function _12$2(fmt, param, cont){
		                if(0 === param[0]){
		                 var a0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ST,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$249[2],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      a0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), SU, cont);
		      });
		                                    });
		                          });
		                }
		                var a0$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         SV,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$249[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0$0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), SW, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$249, [0, pp$63, pp$62]);
		               var letrec_function_context$250 = [];
		               function compare$98(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(0);
		                }
		                else
		                 switch(lhs[0]){
		                   case 0:
		                    if(typeof rhs !== "number" && 0 === rhs[0]){
		                     var rhs0 = rhs[1], lhs0 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[22],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call2
		                                       (letrec_function_context$250[21],
		a,
		function(a){
		 return caml_trampoline_cps_call3(a, lhs0, rhs0, cont);
		});
		                              });
		                    }
		                    break;
		                   case 1:
		                    if(typeof rhs !== "number" && 1 === rhs[0]){
		                     var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[19],
		                              letrec_function_context$250[20],
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$0, rhs0$0, cont);
		                              });
		                    }
		                    break;
		                   case 2:
		                    if(typeof rhs !== "number" && 2 === rhs[0]){
		                     var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[18],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call2
		                                       (letrec_function_context$250[17],
		a,
		function(a){
		 return caml_trampoline_cps_call3(a, lhs0$1, rhs0$1, cont);
		});
		                              });
		                    }
		                    break;
		                   case 3:
		                    if(typeof rhs !== "number" && 3 === rhs[0]){
		                     var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[16],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call2
		                                       (letrec_function_context$250[15],
		a,
		function(a){
		 return caml_trampoline_cps_call3(a, lhs0$2, rhs0$2, cont);
		});
		                              });
		                    }
		                    break;
		                   case 4:
		                    if(typeof rhs !== "number" && 4 === rhs[0]){
		                     var rhs0$3 = rhs[1], lhs0$3 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[13],
		                              function(x, y, cont){
		                               function a(x, y){
		                                if(! x) return y ? cont(-1) : cont(0);
		                                if(! y) return cont(1);
		                                var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                                return caml_trampoline_cps_call3
		(letrec_function_context$250[14],
		 a$0,
		 b,
		 function(x){
		  return 0 === x
		          ? caml_exact_trampoline_call2(a, x$0, y$0)
		          : cont(x);
		 });
		                               }
		                               return a(x, y);
		                              },
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$3, rhs0$3, cont);
		                              });
		                    }
		                    break;
		                   case 5:
		                    if(typeof rhs !== "number" && 5 === rhs[0]){
		                     var rhs0$4 = rhs[1], lhs0$4 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[11],
		                              letrec_function_context$250[12],
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$4, rhs0$4, cont);
		                              });
		                    }
		                    break;
		                   case 6:
		                    if(typeof rhs !== "number" && 6 === rhs[0]){
		                     var rhs0$5 = rhs[1], lhs0$5 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[9],
		                              letrec_function_context$250[10],
		                              function(a){
		                               return caml_trampoline_cps_call2
		                                       (letrec_function_context$250[8],
		a,
		function(a){
		 return caml_trampoline_cps_call3(a, lhs0$5, rhs0$5, cont);
		});
		                              });
		                    }
		                    break;
		                   case 7:
		                    if(typeof rhs !== "number" && 7 === rhs[0]){
		                     var rhs0$6 = rhs[1], lhs0$6 = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$250[7], lhs0$6, rhs0$6, cont);
		                    }
		                    break;
		                   case 8:
		                    if(typeof rhs !== "number" && 8 === rhs[0]){
		                     var rhs0$7 = rhs[1], lhs0$7 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[6],
		                              0,
		                              function(a){
		                               return caml_trampoline_cps_call2
		                                       (letrec_function_context$250[5],
		a,
		function(a){
		 return caml_trampoline_cps_call3(a, lhs0$7, rhs0$7, cont);
		});
		                              });
		                    }
		                    break;
		                   case 9:
		                    if(typeof rhs !== "number" && 9 === rhs[0]){
		                     var rhs0$8 = rhs[1], lhs0$8 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[3],
		                              function(x, y, cont){
		                               function a(x, y){
		                                if(! x) return y ? cont(-1) : cont(0);
		                                if(! y) return cont(1);
		                                var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                                return caml_trampoline_cps_call3
		(letrec_function_context$250[4],
		 a$0,
		 b,
		 function(x){
		  return 0 === x
		          ? caml_exact_trampoline_call2(a, x$0, y$0)
		          : cont(x);
		 });
		                               }
		                               return a(x, y);
		                              },
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$8, rhs0$8, cont);
		                              });
		                    }
		                    break;
		                   default:
		                    if(typeof rhs !== "number" && 10 === rhs[0]){
		                     var rhs0$9 = rhs[1], lhs0$9 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$250[1],
		                              letrec_function_context$250[2],
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$9, rhs0$9, cont);
		                              });
		                    }
		                 }
		                function to_int(param){
		                 if(typeof param === "number") return 6;
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   case 6:
		                    return 7;
		                   case 7:
		                    return 8;
		                   case 8:
		                    return 9;
		                   case 9:
		                    return 10;
		                   default: return 11;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               function _16$1(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _6$2(param, a, b, cont){
		                return cont(caml_int64_compare(a, b));
		               }
		               function _4$3(param, a, b, cont){
		                return cont(caml_float_compare(a, b));
		               }
		               function _0$27(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$250,
		                 [0,
		                  compare$94,
		                  compare$29,
		                  compare$94,
		                  compare$98,
		                  compare$94,
		                  _16$1,
		                  compare$97,
		                  compare$94,
		                  compare_direct$0,
		                  compare$98,
		                  compare$94,
		                  compare$92,
		                  compare$94,
		                  compare$98,
		                  compare$94,
		                  _6$2,
		                  compare$94,
		                  _4$3,
		                  compare$94,
		                  compare$39,
		                  compare$94,
		                  _0$27]);
		               var cst_Note = "Note", letrec_function_context$251 = [];
		               function schema_versioned$148(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$251[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, SY, SX, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$251[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$251[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$251[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     S0,
		                                     SZ,
		                                     0,
		                                     22,
		                                     4,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call$1
		      (schema_versioned$144,
		       schematic_version,
		       no_input_schema,
		       function(b){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([10, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 10 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_json,
		             cst_Json,
		             [0, b[1], S1, b[3], b[4]],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$148,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (schema_versioned$144,
		                           schematic_version,
		                           [0, 0, 0, [3, a], 0],
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([9, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 9 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_tuple,
		                                 cst_Tuple,
		                                 b,
		                                 0],
		                                c];
		                            return caml_exact_trampoline_cps_call$1
		                                    (schema_versioned$144,
		                                     schematic_version,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([8, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 8 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_string,
		   cst_String,
		   c,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$147,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([7, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_relation,
		             cst_Relation,
		             c,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$148,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (schema_versioned$143,
		                           schematic_version,
		                           b,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (schema_versioned$144,
		                                     schematic_version,
		                                     b,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){return cont(0);},
		   function(param, cont){
		    return typeof param === "number" ? cont(S2) : cont(0);
		   },
		   0,
		   0,
		   cst_null,
		   cst_Null,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){return cont(0);},
		     function(param, cont){return cont(0);},
		     0],
		    0],
		   0],
		  [0,
		   [0,
		    function(f0, cont){return cont([6, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    0,
		    0,
		    cst_record,
		    cst_Record,
		    c,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$140,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (schema_versioned$144,
		                 schematic_version,
		                 a,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([5, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       0,
		                       0,
		                       cst_note,
		                       cst_Note,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$148,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (schema_versioned$144,
		                                     schematic_version,
		                                     [0, 0, 0, [3, b], 0],
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_list,
		   cst_List,
		   c,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call$1
		      (schema_versioned$144,
		       schematic_version,
		       int64_schema,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_int,
		             cst_Int,
		             c,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call$1
		                (schema_versioned$144,
		                 schematic_version,
		                 float_schema,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       0,
		                       0,
		                       cst_float,
		                       cst_Float,
		                       c,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$1,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (schema_versioned$144,
		                                     schematic_version,
		                                     a,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_date,
		   cst_Date,
		   c,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call$1
		      (schema_versioned$144,
		       schematic_version,
		       bool_schema,
		       function(b){
		        var
		         res =
		           [11,
		            S3,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              0,
		              0,
		              cst_bool,
		              cst_Bool,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$251[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$251[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$321 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$251, [0, schematic_cache$321]);
		               caml_callback
		                (schema_versioned$148,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$252 = [];
		               function pp$64(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, "Cell.Null", cont);
		                switch(param[0]){
		                  case 0:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            S4,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[18],
		                                      function(fmt, cont){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), S5, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), S6, cont);
		        });
		                                      });
		                            });
		                  case 1:
		                   var a0$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            S7,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[16],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2
		       (letrec_function_context$252[17], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), S8, cont);
		        });
		                                      });
		                            });
		                  case 2:
		                   var a0$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            S9,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[15],
		                                      function(fmt, cont){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), S_, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$1,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), S$, cont);
		        });
		                                      });
		                            });
		                  case 3:
		                   var a0$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Ta,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[14],
		                                      function(fmt, cont){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), Tb, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$2,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Tc, cont);
		        });
		                                      });
		                            });
		                  case 4:
		                   var a0$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Td,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[12],
		                                      function(fmt, x, cont){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Te,
		        function(b){
		         function a(accu, l$0){
		          if(! l$0)
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt), Tg, cont);
		          var l = l$0[2], a$0 = l$0[1];
		          function b(b){
		           return caml_trampoline_cps_call2
		                   (letrec_function_context$252[13],
		                    fmt,
		                    function(b){
		                     return caml_trampoline_cps_call2
		                             (b,
		                              a$0,
		                              function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                    });
		          }
		          return accu
		                  ? caml_exact_trampoline_cps_call(fprintf$0(fmt), Tf, b)
		                  : b();
		         }
		         return a(0, x);
		        });
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$3,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Th, cont);
		        });
		                                      });
		                            });
		                  case 5:
		                   var a0$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Ti,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[10],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2
		       (letrec_function_context$252[11], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$4,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Tj, cont);
		        });
		                                      });
		                            });
		                  case 6:
		                   var a0$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Tk,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[7],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context$252[8],
		        function(fmt, cont){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$252[9], fmt, cont);
		        },
		        fmt,
		        cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$5,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Tl, cont);
		        });
		                                      });
		                            });
		                  case 7:
		                   var a0$6 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Tm,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$252[6],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$6,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Tn, cont);
		        });
		                                      });
		                            });
		                  case 8:
		                   var a0$7 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            To,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[5],
		                                      function(fmt, cont){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), Tp, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$7,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Tq, cont);
		        });
		                                      });
		                            });
		                  case 9:
		                   var a0$8 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Tr,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[3],
		                                      function(fmt, x, cont){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        Ts,
		        function(b){
		         function a(accu, l$0){
		          if(! l$0)
		           return caml_exact_trampoline_cps_call
		                   (fprintf$0(fmt), Tu, cont);
		          var l = l$0[2], a$0 = l$0[1];
		          function b(b){
		           return caml_trampoline_cps_call2
		                   (letrec_function_context$252[4],
		                    fmt,
		                    function(b){
		                     return caml_trampoline_cps_call2
		                             (b,
		                              a$0,
		                              function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                    });
		          }
		          return accu
		                  ? caml_exact_trampoline_cps_call(fprintf$0(fmt), Tt, b)
		                  : b();
		         }
		         return a(0, x);
		        });
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$8,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Tv, cont);
		        });
		                                      });
		                            });
		                  default:
		                   var a0$9 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Tw,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$252[1],
		                                      function(fmt, cont){
		                                       return caml_trampoline_cps_call2
		       (letrec_function_context$252[2], fmt, cont);
		                                      },
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$9,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Tx, cont);
		        });
		                                      });
		                            });
		                }
		               }
		               caml_update_dummy
		                (letrec_function_context$252,
		                 [0,
		                  _17,
		                  _16,
		                  _17,
		                  pp$64,
		                  _17,
		                  _12$2,
		                  _17,
		                  _10$0,
		                  pp$64,
		                  _17,
		                  _13$0,
		                  _17,
		                  pp$64,
		                  _17,
		                  _17,
		                  _17,
		                  pp_v1$0,
		                  _17]);
		               var letrec_function_context$253 = [];
		               function t_without_union_key_schema_ver
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$253[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Ty, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$253[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$253[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$253[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([10, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 10 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_json,
		                                 cst_Json,
		                                 no_input_schema,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (t_without_union_key_schema_ver,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([8, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 8 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_string,
		   cst_String,
		   schematic_param_name_schema_ve,
		   0],
		  [0,
		   [0,
		    function(f0, cont){return cont([9, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 9 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    0,
		    0,
		    cst_tuple,
		    cst_Tuple,
		    [0, 0, 0, [3, c], 0],
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$147,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([7, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_relation,
		             cst_Relation,
		             c,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (t_without_union_key_schema_ver,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (schema_versioned$143,
		                           schematic_version,
		                           b,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  return typeof param === "number" ? cont(TA) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_null,
		                                 cst_Null,
		                                 Tz,
		                                 0],
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([6, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_record,
		                                  cst_Record,
		                                  c,
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$140,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_note,
		   cst_Note,
		   c,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (t_without_union_key_schema_ver,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_float,
		             cst_Float,
		             float_schema,
		             0],
		            [0,
		             [0,
		              function(f0, cont){return cont([3, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              0,
		              0,
		              cst_int,
		              cst_Int,
		              int64_schema,
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([4, f0]);},
		               function(param, cont){
		                if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                return cont(0);
		               },
		               0,
		               0,
		               cst_list,
		               cst_List,
		               [0, 0, 0, [3, c], 0],
		               0],
		              a]]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$1,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_bool,
		                        cst_Bool,
		                        bool_schema,
		                        0],
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([1, f0]);},
		                         function(param, cont){
		                          if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                          return cont(0);
		                         },
		                         0,
		                         0,
		                         cst_date,
		                         cst_Date,
		                         a,
		                         0],
		                        b]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$253[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$253[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$322 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$253, [0, schematic_cache$322]);
		               caml_callback
		                (t_without_union_key_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_With_union_key = "With_union_key",
		                cst_Without_union_key = "Without_union_key",
		                cst_with_union_key = "with_union_key",
		                cst_without_union_key = "without_union_key",
		                letrec_function_context$254 = [];
		               function with_optional_union_key_schema
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$254[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, TB, 0, descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$254[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$254[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$254[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (t_without_union_key_schema_ver,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_without_union_key,
		   cst_Without_union_key,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$148,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_with_union_key,
		              cst_With_union_key,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$254[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$254[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$323 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$254, [0, schematic_cache$323]);
		               caml_callback
		                (with_optional_union_key_schema,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$149(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_optional_union_key_schema,
		                         v,
		                         function(a){
		                          var
		                           schema =
		                             map$14
		                              (function(param, cont){
		                                var x = param[1];
		                                return caml_trampoline_cps_call2(of_string$14, x, cont);
		                               },
		                               function(x, cont){return cont([0, x]);},
		                               a);
		                          return cont([0, TC, schema[2], schema[3], schema[4]]);
		                         });
		               }
		               var
		                schema$51 =
		                  caml_callback
		                   (schema_versioned$149,
		                    [function(param, cont){return cont(0);}]);
		               function sexp_of_t$45(param, cont){return cont(TD);}
		               var
		                include$73 = Make$2([0, compare$98, sexp_of_t$45]),
		                equal$79 = include$73[7],
		                compare$99 = include$73[8],
		                letrec_function_context$255 = [];
		               function equal_path_item(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(1);
		                }
		                else if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(typeof rhs !== "number" && 0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$255[1], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(typeof rhs !== "number" && 0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return cont(lhs0$0 === rhs0$0 ? 1 : 0);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy(letrec_function_context$255, [0, equal$77]);
		               var cst_field = "field", letrec_function_context$256 = [];
		               function path_item_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$256[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, TF, TE, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$256[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$256[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$256[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 "tuple_field",
		                                 "Tuple_field",
		                                 [0, int_schema[1], TI, int_schema[3], int_schema[4]],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   return typeof param === "number" ? cont(TH) : cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_list_elt,
		                                  "List_elt",
		                                  [0, al[1], TG, al[3], al[4]],
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$142,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    0,
		    0,
		    cst_field,
		    "Field",
		    [0, b[1], TJ, b[3], b[4]],
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$256[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$256[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$324 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$256, [0, schematic_cache$324]);
		               caml_callback
		                (path_item_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$257 = [];
		               function equal$80(x, cont){
		                return cont
		                        (function(y, cont){
		                          function a(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$257[1],
		                                      a$0,
		                                      b,
		                                      function(b){
		                                       return b
		       ? caml_exact_trampoline_call2(a, x$0, y$0)
		       : cont(b);
		                                      });
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return a(x, y);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$257, [0, equal_path_item]);
		               var letrec_function_context$258 = [];
		               function schema_versioned$150(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$258[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, TL, TK, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$258[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$258[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$258[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (path_item_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$258[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$258[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$325 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$258, [0, schematic_cache$325]);
		               caml_callback
		                (schema_versioned$150,
		                 [function(param, cont){return cont(0);}]);
		               function equal$81(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var letrec_function_context$259 = [];
		               function schema_versioned$151(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$259[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, TM, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$259[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$259[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$259[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     TO,
		                                     TN,
		                                     0,
		                                     23,
		                                     0,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(2);},
		   function(param, cont){
		    return 2 <= param ? cont(TQ) : cont(0);
		   },
		   0,
		   0,
		   cst_uri,
		   cst_Uri,
		   TP,
		   [0, [0, b, V$4]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       TS,
		       TR,
		       0,
		       23,
		       0,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){return cont(1);},
		             function(param, cont){
		              return 1 === param ? cont(TU) : cont(0);
		             },
		             0,
		             0,
		             cst_phone,
		             cst_Phone,
		             TT,
		             [0, [0, c, V$4]]],
		            a];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 TW,
		                 TV,
		                 0,
		                 23,
		                 0,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(TY);},
		                        0,
		                        0,
		                        cst_email,
		                        cst_Email,
		                        TX,
		                        [0, [0, a, V$4]]],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$259[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$259[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$326 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$259, [0, schematic_cache$326]);
		               caml_callback
		                (schema_versioned$151,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$260 = [];
		               function equal$82(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$260[1],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(! c) return cont(c);
		                          var b = rhs[2], a = lhs[2];
		                          return cont(a === b ? 1 : 0);
		                         });
		               }
		               caml_update_dummy(letrec_function_context$260, [0, equal$77]);
		               var letrec_function_context$261 = [];
		               function schema_versioned$152(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$261[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, T0, TZ, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$261[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$261[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$261[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 T1,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_field_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$142,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var field_name = param[2][1], field_id = param[1];
		   return cont([0, field_id, field_name]);
		  },
		  function(param, cont){
		   var field_name = param[2], field_id = param[1];
		   return cont([0, field_id, [0, field_name, 0]]);
		  },
		  [0, [0, T2, 0, 0, 0, "field_id", 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$261[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$261[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$327 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$261, [0, schematic_cache$327]);
		               caml_callback
		                (schema_versioned$152,
		                 [function(param, cont){return cont(0);}]);
		               function equal$83(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               var
		                cst_Read_only = "Read_only",
		                letrec_function_context$262 = [];
		               function schema_versioned$153(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$262[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, T4, T3, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$262[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$262[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$262[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     T6,
		                                     T5,
		                                     0,
		                                     23,
		                                     0,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(1);},
		   function(param, cont){return param ? cont(T8) : cont(0);},
		   0,
		   0,
		   cst_read_write,
		   "Read_write",
		   T7,
		   [0, [0, b, V$4]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       T_,
		       T9,
		       0,
		       23,
		       0,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){return param ? cont(0) : cont(Ua);},
		              0,
		              0,
		              cst_read_only,
		              cst_Read_only,
		              T$,
		              [0, [0, b, V$4]]],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$262[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$262[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$328 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$262, [0, schematic_cache$328]);
		               var
		                schema$52 =
		                  caml_callback
		                   (schema_versioned$153,
		                    [function(param, cont){return cont(0);}]);
		               function equal$84(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(! c) return cont(c);
		                var b$1 = rhs[3], a$1 = lhs[3];
		                return cont(a$1 === b$1 ? 1 : 0);
		               }
		               var letrec_function_context$263 = [];
		               function schema_versioned$154(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$263[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Uc, Ub, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$263[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$263[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$263[1][1] = a;
		                            var
		                             default$ = match$119[1],
		                             default$0 = match$120[1],
		                             default$1 = match$121[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  can_write_on_update = a[2][1],
		                                  can_write_on_create = a[1],
		                                  can_read = param[1];
		                                 return cont
		 ([0, can_read, can_write_on_create, can_write_on_update]);
		                                },
		                                function(param, cont){
		                                 var
		                                  can_write_on_update = param[3],
		                                  can_write_on_create = param[2],
		                                  can_read = param[1];
		                                 return cont
		 ([0,
		   can_read,
		   [0, can_write_on_create, [0, can_write_on_update, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  Ud,
		                                  0,
		                                  0,
		                                  0,
		                                  "can_read",
		                                  0,
		                                  [0, default$1],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "can_write_on_create",
		                                   0,
		                                   [0, default$0],
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "can_write_on_update",
		                                    0,
		                                    [0, default$],
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$263[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$263[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$329 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$263, [0, schematic_cache$329]);
		               var
		                schema$53 =
		                  caml_callback
		                   (schema_versioned$154,
		                    [function(param, cont){return cont(0);}]);
		               function make$36(b, a, opt, param){
		                var
		                 can_read = 1,
		                 can_write_on_create = 1,
		                 can_write_on_update = 1;
		                return [0, can_read, can_write_on_create, can_write_on_update];
		               }
		               var letrec_function_context$264 = [];
		               function equal$85(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$264[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$264[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$264, [0, equal$84, equal$83]);
		               var letrec_function_context$265 = [];
		               function schema_versioned$155(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$265[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Uf, Ue, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$265[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$265[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$265[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Uh,
		                                     Ug,
		                                     1,
		                                     0,
		                                     4,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$154,
		       schematic_version,
		       function(c){
		        var
		         default$ = make$36(),
		         b =
		           [0,
		            [0, Ui, 0, 0, 0, cst_data, 0, [0, default$], [0, c], a, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$153,
		                 schematic_version,
		                 function(a){
		                  var
		                   default$ = match$122[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var data = param[2][1], schema = param[1];
		                       return cont([0, schema, data]);
		                      },
		                      function(param, cont){
		                       var data = param[2], schema = param[1];
		                       return cont([0, schema, [0, data, 0]]);
		                      },
		                      [0,
		                       [0,
		                        Uj,
		                        0,
		                        0,
		                        0,
		                        cst_schema$0,
		                        0,
		                        [0, default$],
		                        [0, a],
		                        0,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$265[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$265[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$330 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$265, [0, schematic_cache$330]);
		               caml_callback
		                (schema_versioned$155,
		                 [function(param, cont){return cont(0);}]);
		               function make$37(a, opt, param){
		                var
		                 schema = a ? a[1] : 1,
		                 data = make$36();
		                return [0, schema, data];
		               }
		               var letrec_function_context$266 = [];
		               function schema_versioned$156(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$266[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Ul, Uk, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$266[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$266[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$266[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(Uv);},
		                                  0,
		                                  0,
		                                  cst_member,
		                                  cst_Member,
		                                  Uu,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(Ut) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_page,
		                                   cst_Page,
		                                   Us,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(Ur) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_task,
		                                    cst_Task,
		                                    Uq,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(Up) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_event,
		                                     cst_Event,
		                                     Uo,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 <= param ? cont(Un) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_people,
		                                      cst_People,
		                                      Um,
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$266[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$266[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$331 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$266, [0, schematic_cache$331]);
		               var
		                schema$54 =
		                  caml_callback
		                   (schema_versioned$156,
		                    [function(param, cont){return cont(0);}]);
		               function equal$86(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  case 2:
		                   if(2 === rhs) return cont(1); break;
		                  case 3:
		                   if(3 === rhs) return cont(1); break;
		                  default: if(4 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               function compare$100(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  case 2:
		                   if(2 === rhs) return cont(0); break;
		                  case 3:
		                   if(3 === rhs) return cont(0); break;
		                  default: if(4 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   default: return 4;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var letrec_function_context$267 = [];
		               function schema_versioned$157(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$267[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Ux, Uw, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$267[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$267[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$267[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Uz,
		                                     Uy,
		                                     0,
		                                     23,
		                                     0,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$156,
		       schematic_version,
		       function(b){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_default,
		             cst_Default,
		             [0, b[1], UA, b[3], b[4]],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call
		                (Table[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_table,
		                        cst_Table,
		                        [0, a[1], UB, a[3], a[4]],
		                        0],
		                       c],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$267[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$267[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$332 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$267, [0, schematic_cache$332]);
		               caml_callback
		                (schema_versioned$157,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$268 = [];
		               function equal$87(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$268[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$268[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               var _0$28 = Table[15];
		               caml_update_dummy
		                (letrec_function_context$268, [0, equal$86, _0$28]);
		               var cst_reverse = "reverse", letrec_function_context$269 = [];
		               function schema_versioned$158(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$269[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, UC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$269[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$269[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$269[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$152,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, UD, 0, 0, 0, cst_reverse, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$157,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var reverse = param[2][1], target = param[1];
		             return cont([0, target, reverse]);
		            },
		            function(param, cont){
		             var reverse = param[2], target = param[1];
		             return cont([0, target, [0, reverse, 0]]);
		            },
		            [0, [0, UE, 0, 0, 0, cst_table, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$269[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$269[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$333 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$269, [0, schematic_cache$333]);
		               caml_callback
		                (schema_versioned$158,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$270 = [];
		               function equal$88(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$270[2],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(! c) return cont(c);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$270[1], a, b, cont);
		                           }
		                          }
		                          else if(! y) return cont(1);
		                          return cont(0);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$270, [0, equal$82, equal$87]);
		               var ci = [];
		               function equal$89(lhs, rhs, cont){
		                if(typeof lhs === "number")
		                 switch(lhs){
		                   case 0:
		                    if(typeof rhs === "number" && ! rhs) return cont(1); break;
		                   case 1:
		                    if(typeof rhs === "number" && 1 === rhs) return cont(1);
		                    break;
		                   case 2:
		                    if(typeof rhs === "number" && 2 === rhs) return cont(1);
		                    break;
		                   case 3:
		                    if(typeof rhs === "number" && 3 === rhs) return cont(1);
		                    break;
		                   case 4:
		                    if(typeof rhs === "number" && 4 === rhs) return cont(1);
		                    break;
		                   case 5:
		                    if(typeof rhs === "number" && 5 === rhs) return cont(1);
		                    break;
		                   default:
		                    if(typeof rhs === "number" && 6 <= rhs) return cont(1);
		                 }
		                else
		                 switch(lhs[0]){
		                   case 0:
		                    if(typeof rhs !== "number" && 0 === rhs[0]){
		                     var
		                      rhsvalue = rhs[2],
		                      rhsschema = rhs[1],
		                      lhsvalue = lhs[2],
		                      lhsschema = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (ci[9],
		                              lhsschema,
		                              rhsschema,
		                              function(a){
		                               return a
		                                       ? caml_trampoline_cps_call3(ci[8], lhsvalue, rhsvalue, cont)
		                                       : cont(a);
		                              });
		                    }
		                    break;
		                   case 1:
		                    if(typeof rhs !== "number" && 1 === rhs[0]){
		                     var rhselements = rhs[1], lhselements = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (ci[7], lhselements, rhselements, cont);
		                    }
		                    break;
		                   case 2:
		                    if(typeof rhs !== "number" && 2 === rhs[0]){
		                     var rhsfields = rhs[1], lhsfields = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (ci[5],
		                              ci[6],
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a, lhsfields, rhsfields, cont);
		                              });
		                    }
		                    break;
		                   case 3:
		                    if(typeof rhs !== "number" && 3 === rhs[0]){
		                     var rhs0 = rhs[1], lhs0 = lhs[1];
		                     return caml_trampoline_cps_call3(ci[4], lhs0, rhs0, cont);
		                    }
		                    break;
		                   case 4:
		                    if(typeof rhs !== "number" && 4 === rhs[0]){
		                     var rhsformat = rhs[1], lhsformat = lhs[1];
		                     if(lhsformat){
		                      if(rhsformat){
		                       var b = rhsformat[1], a = lhsformat[1];
		                       return caml_trampoline_cps_call3(ci[3], a, b, cont);
		                      }
		                     }
		                     else if(! rhsformat) return cont(1);
		                     return cont(0);
		                    }
		                    break;
		                   case 5:
		                    if(typeof rhs !== "number" && 5 === rhs[0]){
		                     var rhsvalue$0 = rhs[1], lhsvalue$0 = lhs[1];
		                     return cont(lhsvalue$0 === rhsvalue$0 ? 1 : 0);
		                    }
		                    break;
		                   case 6:
		                    if(typeof rhs !== "number" && 6 === rhs[0]){
		                     var
		                      rhselements$0 = rhs[1],
		                      lhselements$0 = lhs[1],
		                      c =
		                        function(x, y){
		                         if(x){
		                          if(y){
		                           var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                           return caml_trampoline_cps_call3
		                                   (ci[2],
		                                    a,
		                                    b,
		                                    function(a){
		                                     return a
		     ? caml_exact_trampoline_call2(c, x$0, y$0)
		     : cont(a);
		                                    });
		                          }
		                         }
		                         else if(! y) return cont(1);
		                         return cont(0);
		                        };
		                     return c(lhselements$0, rhselements$0);
		                    }
		                    break;
		                   default:
		                    if(typeof rhs !== "number" && 7 === rhs[0]){
		                     var
		                      rhscases = rhs[1],
		                      lhscases = lhs[1],
		                      d =
		                        function(x, y){
		                         if(x){
		                          if(y){
		                           var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                           return caml_trampoline_cps_call3
		                                   (ci[1],
		                                    a,
		                                    b,
		                                    function(a){
		                                     return a
		     ? caml_exact_trampoline_call2(d, x$0, y$0)
		     : cont(a);
		                                    });
		                          }
		                         }
		                         else if(! y) return cont(1);
		                         return cont(0);
		                        };
		                     return d(lhscases, rhscases);
		                    }
		                 }
		                return cont(0);
		               }
		               var letrec_function_context$271 = [];
		               function equal_field(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                a:
		                {
		                 if(x){
		                  if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                a:
		                if(c){
		                 var y$0 = rhs[2], x$0 = lhs[2];
		                 if(x$0){
		                  if(y$0){
		                   var b$0 = y$0[1], a$0 = x$0[1], c = a$0 === b$0 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y$0){c = 1; break a;}
		                 c = 0;
		                }
		                if(c) var b$1 = rhs[3], a$1 = lhs[3], c = a$1 === b$1 ? 1 : 0;
		                function d(a){
		                 return a
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$271[1], lhs[5], rhs[5], cont)
		                         : cont(a);
		                }
		                return c
		                        ? caml_trampoline_cps_call3
		                          (letrec_function_context$271[2], lhs[4], rhs[4], d)
		                        : d(c);
		               }
		               caml_update_dummy
		                (ci,
		                 [0,
		                  equal$89,
		                  equal$89,
		                  equal$81,
		                  equal$88,
		                  equal$78,
		                  equal_field,
		                  equal$89,
		                  equal$79,
		                  equal$89]);
		               caml_update_dummy
		                (letrec_function_context$271, [0, equal$89, equal$85]);
		               var
		                cst_String_const = "String_const",
		                cst_string_const = "string_const",
		                bht = [];
		               function schema_versioned$159(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bht[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, UG, UF, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bht[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bht[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bht[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     UI,
		                                     UH,
		                                     0,
		                                     22,
		                                     4,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(6);},
		   function(param, cont){
		    if(typeof param === "number" && 6 <= param) return cont(UK);
		    return cont(0);
		   },
		   0,
		   0,
		   cst_json,
		   cst_Json,
		   [0,
		    0,
		    UJ,
		    [7,
		     function(param, cont){return cont(0);},
		     function(param, cont){return cont(0);},
		     0],
		    0],
		   [0, [0, b, V$4]]],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$159,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([7, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_variant,
		             cst_Variant,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var cases = param[1];
		                return cont(cases);
		               },
		               function(cases, cont){return cont([0, cases, 0]);},
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_cases,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, c], 0]],
		                 0,
		                 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$159,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([5, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_string_const,
		                       cst_String_const,
		                       [0,
		                        0,
		                        UL,
		                        [7,
		                         function(param, cont){
		                          var value = param[1];
		                          return cont(value);
		                         },
		                         function(value, cont){return cont([0, value, 0]);},
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_value,
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          0]],
		                        0],
		                       0],
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([6, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        1,
		                        0,
		                        cst_tuple,
		                        cst_Tuple,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var elements = param[1];
		                           return cont(elements);
		                          },
		                          function(elements, cont){return cont([0, elements, 0]);},
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_elements,
		                            0,
		                            2,
		                            [0, [0, 0, 0, [3, c], 0]],
		                            0,
		                            0],
		                           0]],
		                         0],
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$151,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(c){
		                                      var
		                                       default$ = match$123[1],
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_string,
		   cst_String,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var format = param[1];
		      return cont(format);
		     },
		     function(format, cont){return cont([0, format, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_format, 0, [0, default$], [0, c], 0, 0],
		      0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$158,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_relation,
		             cst_Relation,
		             c,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (field_schema_versioned$0,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (schema_versioned$143,
		                           schematic_version,
		                           b,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(4);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && 4 === param)
		                                   return cont(UN);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_note,
		                                 cst_Note,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(5);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 5 === param)
		                                    return cont(UM);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_null,
		                                  cst_Null,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([2, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_record,
		                                   cst_Record,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var fields = param[1];
		                                      return cont(fields);
		                                     },
		                                     function(fields, cont){return cont([0, fields, 0]);},
		                                     [0, [0, 0, 0, 0, 0, cst_fields, 0, 2, [0, c], 0, 0], 0]],
		                                    0],
		                                   0],
		                                  a]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$159,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(1);},
		   function(param, cont){
		    if(typeof param === "number" && 1 === param)
		     return cont(UQ);
		    return cont(0);
		   },
		   0,
		   0,
		   cst_float,
		   cst_Float,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){return cont(0);},
		     function(param, cont){return cont(0);},
		     0],
		    0],
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(2);},
		    function(param, cont){
		     if(typeof param === "number" && 2 === param)
		      return cont(UP);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_int,
		    cst_Int,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(3);},
		     function(param, cont){
		      if(typeof param === "number" && 3 === param)
		       return cont(UO);
		      return cont(0);
		     },
		     0,
		     0,
		     cst_date,
		     cst_Date,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){return cont(0);},
		       function(param, cont){return cont(0);},
		       0],
		      0],
		     0],
		    [0,
		     [0,
		      function(f0, cont){return cont([1, f0]);},
		      function(param, cont){
		       if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		       return cont(0);
		      },
		      1,
		      0,
		      cst_list,
		      cst_List,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var elements = param[1];
		         return cont(elements);
		        },
		        function(elements, cont){return cont([0, elements, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_elements, 0, 2, [0, c], 0, 0], 0]],
		       0],
		      0],
		     b]]]];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       US,
		       UR,
		       1,
		       0,
		       4,
		       function(c){
		        var b = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$149,
		                 schematic_version,
		                 function(d){
		                  var
		                   c = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, d], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$159,
		                           schematic_version,
		                           function(d){
		                            var
		                             res =
		                               [11,
		                                UU,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(UT);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_bool,
		                                  cst_Bool,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 === param[0]){
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([0, [0, f0, f1]]);
		                                    }
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_const,
		                                   cst_Const,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var value = param[2][1], schema = param[1];
		                                      return cont([0, schema, value]);
		                                     },
		                                     function(param, cont){
		                                      var value = param[2], schema = param[1];
		                                      return cont([0, schema, [0, value, 0]]);
		                                     },
		                                     [0, [0, 0, 0, 0, 0, cst_schema$0, 0, 2, [0, d], 0, 0], c]],
		                                    0],
		                                   b],
		                                  a]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bht[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bht[1][1] = a; return cont(res);});
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$272 = [];
		               function field_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$272[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, UV, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$272[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$272[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$272[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$159,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$155,
		       schematic_version,
		       function(b){
		        var
		         default$ = make$37(0),
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              value = c[2][1],
		              permissions = c[1],
		              name = b[1],
		              description = a[1],
		              computed = param[1];
		             return cont
		                     ([0, computed, description, name, permissions, value]);
		            },
		            function(param, cont){
		             var
		              value = param[5],
		              permissions = param[4],
		              name = param[3],
		              description = param[2],
		              computed = param[1];
		             return cont
		                     ([0,
		                       computed,
		                       [0, description, [0, name, [0, permissions, [0, value, 0]]]]]);
		            },
		            [0,
		             [0,
		              UX,
		              0,
		              0,
		              0,
		              cst_computed,
		              0,
		              3,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               UW,
		               0,
		               0,
		               0,
		               cst_description,
		               0,
		               3,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_name,
		                0,
		                2,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_permissions,
		                 0,
		                 [0, default$],
		                 [0, b],
		                 0,
		                 0],
		                a]]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$272[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$272[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$334 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bht, [0, schematic_cache$334]);
		               var schematic_cache$335 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$272, [0, schematic_cache$335]);
		               var
		                schema$55 =
		                  caml_callback
		                   (schema_versioned$159,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (field_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function make_field(computed, description, name, opt, value){
		                var permissions = opt ? opt[1] : make$37(0);
		                return [0, computed, description, name, permissions, value];
		               }
		               var letrec_function_context$273 = [];
		               function equal$90(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$273[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$273, [0, equal$77]);
		               function schema_versioned$160(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$142,
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$56 =
		                  caml_callback
		                   (schema_versioned$160,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$274 = [];
		               function equal$91(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$274[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$274, [0, equal$77]);
		               function schema_versioned$161(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$142,
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$57 =
		                  caml_callback
		                   (schema_versioned$161,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$275 = [];
		               function equal$92(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(d){
		                 function c(b){
		                  function a(d){
		                   function c(d){
		                    function c(c){
		                     if(! c) return cont(c);
		                     var y = rhs[6], x = lhs[6];
		                     if(x){
		                      if(y){
		                       var b = y[1], a = x[1];
		                       return caml_trampoline_cps_call3
		                               (letrec_function_context$275[1], a, b, cont);
		                      }
		                     }
		                     else if(! y) return cont(1);
		                     return cont(0);
		                    }
		                    if(! d) return c(d);
		                    var y = rhs[5], x = lhs[5];
		                    if(x){
		                     if(y){
		                      var b = y[1], a = x[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$275[2], a, b, c);
		                     }
		                    }
		                    else if(! y) return c(1);
		                    return c(0);
		                   }
		                   if(! d) return c(d);
		                   var y = rhs[4], x = lhs[4];
		                   if(x){
		                    if(y){
		                     var b = y[1], a = x[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$275[3], a, b, c);
		                    }
		                   }
		                   else if(! y) return c(1);
		                   return c(0);
		                  }
		                  return b
		                          ? caml_trampoline_cps_call3
		                            (letrec_function_context$275[4], lhs[3], rhs[3], a)
		                          : a(b);
		                 }
		                 if(! d) return c(d);
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b = y[1], a = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$275[5], a, b, c);
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$275[6], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               var _2$17 = Set$1[16];
		               caml_update_dummy
		                (letrec_function_context$275,
		                 [0, equal$90, equal$91, equal$44, _2$17, equal$67, equal$66]);
		               var letrec_function_context$276 = [];
		               function schema_versioned$162(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$276[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, UY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$276[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$276[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$276[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$160,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_title_field, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$161,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, U0, 0, 0, 0, cst_icon, 0, 3, [0, schema$262], 0, 0],
		            [0,
		             [0, UZ, 0, 0, 0, cst_notes_field, 0, 3, [0, c], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call
		                (Set$1[65],
		                 schematic_version,
		                 function(c){
		                  var
		                   default$ = Set$1[67],
		                   a =
		                     [0,
		                      [0,
		                       U2,
		                       0,
		                       0,
		                       0,
		                       cst_emoji,
		                       0,
		                       3,
		                       [0,
		                        map$14
		                         (of_utf8_string_res,
		                          to_utf8_string,
		                          schematic_param_name_schema_ve)],
		                       0,
		                       0],
		                      [0,
		                       [0,
		                        U1,
		                        0,
		                        0,
		                        0,
		                        cst_hidden_columns,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$127,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  title_field = d[2][1],
		                                  notes_field = d[1],
		                                  icon = c[1],
		                                  hidden_columns = b[1],
		                                  emoji = a[1],
		                                  color = param[1];
		                                 return cont
		 ([0,
		   color,
		   emoji,
		   hidden_columns,
		   icon,
		   notes_field,
		   title_field]);
		                                },
		                                function(param, cont){
		                                 var
		                                  title_field = param[6],
		                                  notes_field = param[5],
		                                  icon = param[4],
		                                  hidden_columns = param[3],
		                                  emoji = param[2],
		                                  color = param[1];
		                                 return cont
		 ([0,
		   color,
		   [0,
		    emoji,
		    [0,
		     hidden_columns,
		     [0, icon, [0, notes_field, [0, title_field, 0]]]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_color, 0, 3, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$276[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$276[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$336 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$276, [0, schematic_cache$336]);
		               var
		                schema$58 =
		                  caml_callback
		                   (schema_versioned$162,
		                    [function(param, cont){return cont(0);}]),
		                _0$29 = Set$1[67];
		               function make$38
		               (color, emoji, opt, icon, notes_field, title_field, param){
		                var hidden_columns = _0$29;
		                return [0,
		                        color,
		                        emoji,
		                        hidden_columns,
		                        icon,
		                        notes_field,
		                        title_field];
		               }
		               function schema_versioned$163(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$149,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (schema_versioned$143,
		     schematic_version,
		     a,
		     function(a){return cont([0, U4, U3, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$163,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$277 = [];
		               function equal$93(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$277[1],
		                         letrec_function_context$277[2],
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               caml_update_dummy
		                (letrec_function_context$277, [0, equal$78, equal$79]);
		               function schema_versioned$164(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (field_schema_versioned$0,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (schema_versioned$143,
		     schematic_version,
		     a,
		     function(a){return cont([0, U6, U5, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$164,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$278 = [];
		               function equal$94(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$278[1],
		                         letrec_function_context$278[2],
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               caml_update_dummy
		                (letrec_function_context$278, [0, equal$78, equal_field]);
		               function schema_versioned$165(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$163,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (include$51[27][102],
		     schematic_version,
		     a,
		     function(a){return cont([0, U7, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$165,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$279 = [];
		               function equal$95(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$279[1],
		                         letrec_function_context$279[2],
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               var _1$26 = include$51[27][53];
		               caml_update_dummy
		                (letrec_function_context$279, [0, _1$26, equal$93]);
		               function equal$96(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(c) var b$1 = rhs[3], a$1 = lhs[3], c = a$1 === b$1 ? 1 : 0;
		                if(c) var b$2 = rhs[4], a$2 = lhs[4], c = a$2 === b$2 ? 1 : 0;
		                if(! c) return cont(c);
		                var b$3 = rhs[5], a$3 = lhs[5];
		                return cont(a$3 === b$3 ? 1 : 0);
		               }
		               var letrec_function_context$280 = [];
		               function schema_versioned$166(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$280[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, U8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$280[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$280[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$280[1][1] = b;
		                            var
		                             default$ = match$124[1],
		                             default$0 = match$125[1],
		                             default$1 = match$126[1],
		                             default$2 = match$127[1],
		                             a =
		                               [0,
		                                [0,
		                                 Va,
		                                 0,
		                                 0,
		                                 0,
		                                 "can_update_schema",
		                                 0,
		                                 [0, default$2],
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  U$,
		                                  0,
		                                  0,
		                                  0,
		                                  "can_create_row",
		                                  0,
		                                  [0, default$1],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   U_,
		                                   0,
		                                   0,
		                                   0,
		                                   "can_update_row",
		                                   0,
		                                   [0, default$0],
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    U9,
		                                    0,
		                                    0,
		                                    0,
		                                    "can_delete_row",
		                                    0,
		                                    [0, default$],
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Vc,
		                                     Vb,
		                                     0,
		                                     25,
		                                     9,
		                                     function(b){
		                                      var
		                                       default$ = match$128[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    can_delete_row = c[2][1],
		    can_update_row = c[1],
		    can_create_row = b[1],
		    can_update_schema = a[1],
		    can_update_type = param[1];
		   return cont
		           ([0,
		             can_update_type,
		             can_update_schema,
		             can_create_row,
		             can_update_row,
		             can_delete_row]);
		  },
		  function(param, cont){
		   var
		    can_delete_row = param[5],
		    can_update_row = param[4],
		    can_create_row = param[3],
		    can_update_schema = param[2],
		    can_update_type = param[1];
		   return cont
		           ([0,
		             can_update_type,
		             [0,
		              can_update_schema,
		              [0,
		               can_create_row,
		               [0, can_update_row, [0, can_delete_row, 0]]]]]);
		  },
		  [0,
		   [0,
		    Vd,
		    0,
		    0,
		    0,
		    "can_update_type",
		    0,
		    [0, default$],
		    [0, bool_schema],
		    [0, [0, b, V$4]],
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$280[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$280[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$337 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$280, [0, schematic_cache$337]);
		               var
		                schema$59 =
		                  caml_callback
		                   (schema_versioned$166,
		                    [function(param, cont){return cont(0);}]);
		               function make$39(d, c, b, a, opt, param){
		                var
		                 can_update_type = 1,
		                 can_update_schema = 1,
		                 can_create_row = 1,
		                 can_update_row = 1,
		                 can_delete_row = 1;
		                return [0,
		                        can_update_type,
		                        can_update_schema,
		                        can_create_row,
		                        can_update_row,
		                        can_delete_row];
		               }
		               function equal$97(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  case 2:
		                   if(2 === rhs) return cont(1); break;
		                  default: if(3 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var
		                cst_Integration_app = "Integration_app",
		                cst_Internal_builtin_custom_ty = "Internal_builtin_custom_type",
		                cst_Internal_builtin_type_exte =
		                  "Internal_builtin_type_extensions",
		                cst_User_defined = "User_defined",
		                letrec_function_context$281 = [];
		               function schema_versioned$167(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$281[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Vf, Ve, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$281[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$281[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$281[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Vh,
		                                     Vg,
		                                     0,
		                                     25,
		                                     5,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(3);},
		   function(param, cont){
		    return 3 <= param ? cont(Vj) : cont(0);
		   },
		   0,
		   0,
		   cst_internal_builtin_custom_ty,
		   cst_Internal_builtin_custom_ty,
		   Vi,
		   [0, [0, b, V$4]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       Vl,
		       Vk,
		       0,
		       23,
		       0,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){return param ? cont(0) : cont(Vr);},
		              0,
		              0,
		              cst_user_defined,
		              cst_User_defined,
		              Vq,
		              0],
		             [0,
		              [0,
		               function(param, cont){return cont(1);},
		               function(param, cont){
		                return 1 === param ? cont(Vp) : cont(0);
		               },
		               0,
		               0,
		               cst_integration_app,
		               cst_Integration_app,
		               Vo,
		               0],
		              [0,
		               [0,
		                function(param, cont){return cont(2);},
		                function(param, cont){
		                 return 2 === param ? cont(Vn) : cont(0);
		                },
		                0,
		                0,
		                cst_internal_builtin_type_exte,
		                cst_Internal_builtin_type_exte,
		                Vm,
		                [0, [0, b, V$4]]],
		               a]]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$281[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$281[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$338 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$281, [0, schematic_cache$338]);
		               var
		                schema$60 =
		                  caml_callback
		                   (schema_versioned$167,
		                    [function(param, cont){return cont(0);}]),
		                _2$18 = include$51[27][104],
		                letrec_function_context$282 = [];
		               function schema_versioned$168(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$282[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Vs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$282[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$282[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$282[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$167,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$129[1],
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_origin, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$166,
		       schematic_version,
		       function(c){
		        var
		         default$ = make$39(),
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_permissions,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$165,
		                 schematic_version,
		                 function(c){
		                  var
		                   default$ = include$51[27][104],
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_rows, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$164,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, Vt, 0, 0, 0, cst_schema$0, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$162,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       default$ = make$38(0, 0, 0, 0, 0, 0),
		                                       default$0 = match$130[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    origin = f[2][1],
		    permissions = f[1],
		    rows = e[1],
		    schema = d[1],
		    meta = c[1],
		    description = b[1],
		    data_name = a[1],
		    name = param[1];
		   return cont
		           ([0,
		             name,
		             data_name,
		             description,
		             meta,
		             schema,
		             rows,
		             permissions,
		             origin]);
		  },
		  function(param, cont){
		   var
		    origin = param[8],
		    permissions = param[7],
		    rows = param[6],
		    schema = param[5],
		    meta = param[4],
		    description = param[3],
		    data_name = param[2],
		    name = param[1];
		   return cont
		           ([0,
		             name,
		             [0,
		              data_name,
		              [0,
		               description,
		               [0,
		                meta,
		                [0, schema, [0, rows, [0, permissions, [0, origin, 0]]]]]]]]);
		  },
		  [0,
		   [0,
		    Vx,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     Vw,
		     0,
		     0,
		     0,
		     cst_data_name,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      Vv,
		      0,
		      0,
		      0,
		      cst_description,
		      0,
		      [0, default$0],
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0, Vu, 0, 0, 0, cst_meta, 0, [0, default$], [0, a], 0, 0],
		      b]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$282[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$282[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$339 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$282, [0, schematic_cache$339]);
		               var
		                schema$61 =
		                  caml_callback
		                   (schema_versioned$168,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$283 = [];
		               function equal$98(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(c) var b$1 = rhs[3], a$1 = lhs[3], c = a$1 === b$1 ? 1 : 0;
		                function d(b){
		                 function a(b){
		                  function a(b){
		                   function a(a){
		                    return a
		                            ? caml_trampoline_cps_call3
		                              (letrec_function_context$283[1], lhs[8], rhs[8], cont)
		                            : cont(a);
		                   }
		                   return b
		                           ? caml_trampoline_cps_call3
		                             (letrec_function_context$283[2], lhs[7], rhs[7], a)
		                           : a(b);
		                  }
		                  return b
		                          ? caml_trampoline_cps_call3
		                            (letrec_function_context$283[3], lhs[6], rhs[6], a)
		                          : a(b);
		                 }
		                 return b
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$283[4], lhs[5], rhs[5], a)
		                         : a(b);
		                }
		                return c
		                        ? caml_trampoline_cps_call3
		                          (letrec_function_context$283[5], lhs[4], rhs[4], d)
		                        : d(c);
		               }
		               caml_update_dummy
		                (letrec_function_context$283,
		                 [0, equal$97, equal$96, equal$95, equal$94, equal$92]);
		               caml_callback(of_schema$1, [schema$61]);
		               var
		                bP6 =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:task_extensions______"])]),
		                bP7 =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:event_extensions_____"])]),
		                bP8 =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:page_extensions______"])]),
		                bQ6 =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:people_extensions____"])]),
		                bQ7 =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:calendar_extensions__"])]),
		                bQ8 =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:ai_agent_extensions__"])]),
		                bQ9 =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:ai_step_extensions___"])]),
		                bQ_ =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:ai_automation_ext____"])]),
		                bQ$ =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:ai_conversation_ext__"])]);
		               function data_name_to_name(data_name, cont){
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         data_name,
		                         function(a){
		                          var
		                           chars = to_list$1(a),
		                           chars$0 = chars,
		                           acc = 0,
		                           prev_was_sep = 1;
		                          for(;;){
		                           if(! chars$0) break;
		                           var chars$1 = chars$0[2], c = chars$0[1];
		                           if(is_alpha(c)){
		                            var acc$0 = [0, c, acc];
		                            chars$0 = chars$1;
		                            acc = acc$0;
		                            prev_was_sep = 0;
		                           }
		                           else {
		                            if(! prev_was_sep && ! is_empty(acc)){
		                             var acc$1 = [0, 95, acc];
		                             chars$0 = chars$1;
		                             acc = acc$1;
		                             prev_was_sep = 1;
		                             continue;
		                            }
		                            chars$0 = chars$1;
		                            prev_was_sep = 1;
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (of_rev_keys,
		                                   acc,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_char_list,
		     a,
		     function(processed){
		      return caml_exact_trampoline_cps_call$1
		              (rstrip,
		               [0, function(y, cont){return cont(95 === y ? 1 : 0);}],
		               processed,
		               function(sanitized){
		                return caml_exact_trampoline_cps_call$0
		                        (is_suffix_gen,
		                         sanitized,
		                         cst_s$0,
		                         equal$2,
		                         function(a){
		                          return a ? cont(sanitized) : cont(sanitized + cst_s$0);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var cst_Root = "Root", letrec_function_context$284 = [];
		               function schema_versioned$169(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$284[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Vy, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$284[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$284[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$284[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$105,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){return param ? cont(0) : cont(VA);},
		    0,
		    0,
		    cst_root,
		    cst_Root,
		    Vz,
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(! param) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     cst_object,
		     cst_Object,
		     a,
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$284[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$284[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                bRa =
		                  caml_callback
		                   (ok_or_failwith,
		                    [caml_callback(Table[6], ["table:ai_automation_run_ext"])]),
		                schematic_cache$340 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$284, [0, schematic_cache$340]);
		               caml_callback
		                (schema_versioned$169,
		                 [function(param, cont){return cont(0);}]);
		               function of_option$2(o, cont){
		                if(! o) return cont(0);
		                var parent = o[1];
		                return cont([0, parent]);
		               }
		               function schema_versioned$170(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$169,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (bQ5,
		     schematic_version,
		     a,
		     function(a){return cont([0, VB, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$170,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$285 = [];
		               function schema_versioned$171(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$285[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, VC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$285[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$285[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$285[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$170,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_object_hierarchy, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$168,
		       schematic_version,
		       function(b){
		        return caml_trampoline_cps_call3
		                (Table[27][102],
		                 schematic_version,
		                 b,
		                 function(b){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var hierarchy = param[2][1], tables = param[1];
		                       return cont([0, tables, hierarchy]);
		                      },
		                      function(param, cont){
		                       var hierarchy = param[2], tables = param[1];
		                       return cont([0, tables, [0, hierarchy, 0]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_tables, 0, 2, [0, b], 0, 0], a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$285[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$285[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$341 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$285, [0, schematic_cache$341]);
		               caml_callback
		                (schema_versioned$171,
		                 [function(param, cont){return cont(0);}]);
		               function title_field(schema, meta, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4],
		                 match = meta[6];
		                if(! match)
		                 return caml_exact_trampoline_cps_call$2
		                         (to_sequence$2,
		                          0,
		                          0,
		                          0,
		                          schema,
		                          function(t){
		                           var next = t[2], seed = t[1];
		                           function a(s){
		                            return caml_trampoline_cps_call2
		                                    (next,
		                                     s,
		                                     function(match){
		                                      if(typeof match === "number") return cont(0);
		                                      if(0 === match[0])
		                                       return caml_exact_trampoline_call1(a, match[1]);
		                                      var a$0 = match[1], b = a$0[2][3] !== cst_Title ? 0 : 1;
		                                      return b
		      ? cont([0, a$0])
		      : caml_exact_trampoline_call1(a, match[2]);
		                                     });
		                           }
		                           return a(seed);
		                          });
		                var column_id = match[1];
		                function a(column, cont){return cont([0, column_id, column]);}
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         schema,
		                         column_id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var
		                cst_Extension_row = "Extension_row",
		                letrec_function_context$286 = [];
		               function schema_versioned$172(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$286[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, VE, VD, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$286[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$286[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$286[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     VG,
		                                     VF,
		                                     0,
		                                     23,
		                                     0,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (include$51[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_extension_row,
		              cst_Extension_row,
		              b,
		              a],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$286[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$286[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$342 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$286, [0, schematic_cache$342]);
		               var
		                schema$62 =
		                  caml_callback
		                   (schema_versioned$172,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$287 = [];
		               function equal$99(lhs, rhs, cont){
		                var rhs0 = rhs[1], lhs0 = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$287[1], lhs0, rhs0, cont);
		               }
		               var _0$30 = include$51[15];
		               caml_update_dummy(letrec_function_context$287, [0, _0$30]);
		               var letrec_function_context$288 = [];
		               function _10$1(fmt, param, cont){
		                var a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         VH,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$288[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), VI, cont);
		     });
		                                   });
		                         });
		               }
		               var _0$31 = include$51[1];
		               caml_update_dummy(letrec_function_context$288, [0, _0$31]);
		               var letrec_function_context$289 = [];
		               function compare$101(lhs, rhs, cont){
		                var rhs0 = rhs[1], lhs0 = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$289[1], lhs0, rhs0, cont);
		               }
		               var _0$32 = include$51[16];
		               caml_update_dummy(letrec_function_context$289, [0, _0$32]);
		               caml_callback(encode$7, [schema$62]);
		               var
		                include$74 =
		                  caml_callback(Make$12, [[0, cst_integration, cst$21]]),
		                pp$65 = include$74[1],
		                name$27 = include$74[3],
		                to_string$49 = include$74[8],
		                symbol$143 = include$74[9],
		                symbol$144 = include$74[10],
		                symbol$145 = include$74[11],
		                symbol$146 = include$74[12],
		                symbol$147 = include$74[13],
		                symbol$148 = include$74[14],
		                equal$100 = include$74[15],
		                compare$102 = include$74[16],
		                min$20 = include$74[17],
		                max$22 = include$74[18],
		                ascending$11 = include$74[19],
		                descending$11 = include$74[20],
		                between$12 = include$74[21],
		                clamp_exn$11 = include$74[22],
		                clamp$11 = include$74[23],
		                comparator$26 = include$74[24],
		                By$10 = include$74[27],
		                make$40 = include$74[29],
		                of_nanoid$1 = include$74[33],
		                bRb = include$74[6];
		               function of_string$42(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (bRb,
		                         s,
		                         function(error){
		                          return 0 === error[0]
		                                  ? cont(error)
		                                  : caml_exact_trampoline_cps_call$1
		                                    (lsplit2,
		                                     s,
		                                     45,
		                                     function(a){
		                                      if(a){
		                                       a = a[1];
		                                       if(a[1] === cst_integration){
		var nanoid = a[2];
		if(21 === caml_ml_string_length(nanoid))
		 return cont([0, of_nanoid$1(nanoid)]);
		                                       }
		                                      }
		                                      return cont(error);
		                                     });
		                         });
		               }
		               var
		                id$33 = [0, name$27 + cst_id$1],
		                schema$265 =
		                  [0,
		                   id$33,
		                   0,
		                   [4, of_string$42, to_string$49, descriptor$1],
		                   0];
		               function schema_versioned$173(param, cont){return cont(schema$265);
		               }
		               var
		                By_id =
		                  caml_callback
		                   (M$2, [[0, comparator$26, schema_versioned$173]]),
		                letrec_function_context$290 = [];
		               function equal_http_error(lhs, rhs, cont){
		                var rhs$0 = rhs[1], lhs$0 = lhs[1];
		                a:
		                {
		                 if(typeof lhs$0 === "number"){
		                  if(typeof rhs$0 === "number" && 202403584 === rhs$0){var c = 1; break a;}
		                 }
		                 else if(typeof rhs$0 !== "number"){
		                  var variant = rhs$0[1];
		                  if(-447096405 === variant){
		                   var
		                    rhs$1 = rhs$0[2],
		                    lhs$1 = lhs$0[2],
		                    c = lhs$1 === rhs$1 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 c = 0;
		                }
		                if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                return c
		                        ? caml_trampoline_cps_call3
		                          (letrec_function_context$290[1], lhs[3], rhs[3], cont)
		                        : cont(c);
		               }
		               caml_update_dummy(letrec_function_context$290, [0, equal$44]);
		               var letrec_function_context$291 = [];
		               function pp_http_error(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         VJ,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   VK,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integration.Error.reason",
		     function(a){
		      a = x[1];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                VO,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          VP,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    VQ,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_status,
		      function(b){
		       var a = x[2];
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                VR,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    VS,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      VT,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                VU,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_uri,
		                          function(b){
		                           var a = x[3];
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$291[1],
		                                    fmt,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                VV,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), VW, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(typeof a === "number")
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, "`Unexpected_status", b);
		      var x$0 = a[2];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               VL,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         VM,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(fprintf$0(fmt), VN, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$291, [0, pp$27]);
		               var letrec_function_context$292 = [];
		               function http_error_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$292[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, VX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$292[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$292[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$292[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  uri = a[2][1],
		                                  status = a[1],
		                                  reason = param[1];
		                                 return cont([0, reason, status, uri]);
		                                },
		                                function(param, cont){
		                                 var uri = param[3], status = param[2], reason = param[1];
		                                 return cont([0, reason, [0, status, [0, uri, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_reason,
		                                  0,
		                                  2,
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    [11,
		                                     0,
		                                     [0,
		                                      [0,
		                                       function(f0, cont){return cont([0, -447096405, f0]);},
		                                       function(param, cont){
		if(typeof param !== "number"){
		 var variant = param[1];
		 if(-447096405 === variant){
		  var f0 = param[2];
		  return cont([0, f0]);
		 }
		}
		return cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       "unexpected_content",
		                                       "Unexpected_content",
		                                       schematic_param_name_schema_ve,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(202403584);},
		function(param, cont){
		 if(typeof param === "number" && 202403584 === param)
		  return cont(VZ);
		 return cont(0);
		},
		0,
		0,
		cst_unexpected_status$0,
		"Unexpected_status",
		VY,
		0],
		                                       0]],
		                                     1],
		                                    0]],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_status,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_uri, 0, 2, [0, schema$262], 0, 0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$292[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$292[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$343 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$292, [0, schematic_cache$343]);
		               caml_callback
		                (http_error_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$293 = [];
		               function equal_error(lhs, rhs, cont){
		                if(101210703 <= lhs[1]){
		                 if(typeof rhs !== "number"){
		                  var variant = rhs[1];
		                  if(101210703 === variant){
		                   var rhs$0 = rhs[2], lhs$0 = lhs[2];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$293[1], lhs$0, rhs$0, cont);
		                  }
		                 }
		                }
		                else if(typeof rhs !== "number"){
		                 var variant$0 = rhs[1];
		                 if(-581978067 === variant$0){
		                  var rhs$1 = rhs[2], lhs$1 = lhs[2];
		                  return cont(lhs$1 === rhs$1 ? 1 : 0);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$293, [0, equal_http_error]);
		               var letrec_function_context$294 = [];
		               function pp_error$0(fmt, param, cont){
		                var variant = param[1];
		                if(101210703 <= variant){
		                 var x = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          V0,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$294[1],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      x,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), V1, cont);
		      });
		                                    });
		                          });
		                }
		                var x$0 = param[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         V2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   V3,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     x$0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), V4, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$294, [0, pp_http_error]);
		               var letrec_function_context$295 = [];
		               function error_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$295[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, V6, V5, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$295[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$295[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$295[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([0, -581978067, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number"){
		                                   var variant = param[1];
		                                   if(-581978067 === variant){
		                                    var f0 = param[2];
		                                    return cont([0, f0]);
		                                   }
		                                  }
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 "integration_config",
		                                 "Integration_config",
		                                 schematic_param_name_schema_ve,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (http_error_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, 101210703, f0]);},
		    function(param, cont){
		     if(typeof param !== "number"){
		      var variant = param[1];
		      if(101210703 === variant){
		       var f0 = param[2];
		       return cont([0, f0]);
		      }
		     }
		     return cont(0);
		    },
		    0,
		    0,
		    "integration_api",
		    "Integration_api",
		    b,
		    0],
		   a],
		  1];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$295[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$295[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$344 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$295, [0, schematic_cache$344]);
		               caml_callback
		                (error_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$296 = [];
		               function equal$101(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                return c
		                        ? caml_trampoline_cps_call3
		                          (letrec_function_context$296[1], lhs[2], rhs[2], cont)
		                        : cont(c);
		               }
		               caml_update_dummy
		                (letrec_function_context$296, [0, equal_error]);
		               var letrec_function_context$297 = [];
		               function _13$1(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         V7,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   V8,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integration.Error.integration",
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               V9,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   V_,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     V$,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Wa,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_error,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$297[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Wb,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), Wc, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$297, [0, pp_error$0]);
		               var letrec_function_context$298 = [];
		               function schema_versioned$174(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$298[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Wd, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$298[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$298[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$298[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (error_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var error = param[2][1], integration = param[1];
		   return cont([0, integration, error]);
		  },
		  function(param, cont){
		   var error = param[2], integration = param[1];
		   return cont([0, integration, [0, error, 0]]);
		  },
		  [0,
		   [0,
		    Wf,
		    0,
		    0,
		    0,
		    cst_integration,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, We, 0, 0, 0, cst_error, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$298[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$298[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$345 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$298, [0, schematic_cache$345]);
		               caml_callback
		                (schema_versioned$174,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$299 = [];
		               function broken_cause_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$299[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Wg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$299[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$299[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$299[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(Wk);},
		                                  0,
		                                  0,
		                                  cst_backend,
		                                  "Backend",
		                                  Wj,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(Wi) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_configuration,
		                                   "Configuration",
		                                   Wh,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$299[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$299[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$346 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$299, [0, schematic_cache$346]);
		               caml_callback
		                (broken_cause_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function pp_broken_cause(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Integration.Report.Configuration",
		                           cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Integration.Report.Backend", cont);
		               }
		               var letrec_function_context$300 = [];
		               function schema_versioned$175(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$300[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Wm, Wl, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$300[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$300[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$300[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_error,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_details,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (broken_cause_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    details = a[2][1],
		    error = a[1],
		    origin = param[1];
		   return cont([0, origin, error, details]);
		  },
		  function(param, cont){
		   var details = param[3], error = param[2], origin = param[1];
		   return cont([0, origin, [0, error, [0, details, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, "errorType", 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$300[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$300[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$347 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$300, [0, schematic_cache$347]);
		               var
		                schema$63 =
		                  caml_callback
		                   (schema_versioned$175,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$301 = [];
		               function pp$66(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Wn,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Wo,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integration.Report.origin",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$301[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Wp,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     Wq,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Wr,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_error,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Ws,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Wt,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Wu,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Wv,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_details,
		     function(b){
		      var a = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               Ww,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   Wx,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), Wy, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$301, [0, pp_broken_cause]);
		               function of_error(a, cont){
		                var
		                 error = a[2],
		                 integration = a[1],
		                 variant = error[1],
		                 origin = 101210703 <= variant ? 0 : 1,
		                 variant$0 = error[1];
		                function b(error, details){
		                 return cont([0, origin, error, details]);
		                }
		                if(101210703 > variant$0){
		                 var error$0 = error[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$93,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a,
		                                    integration,
		                                    error$0,
		                                    function(details){return b(error$0, details);});
		                          });
		                }
		                a = error[2];
		                var match = a[1];
		                if(typeof match === "number"){
		                 var uri = a[3], status = a[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$89,
		                          function(a){
		                           return caml_trampoline_cps_call5
		                                   (a,
		                                    integration,
		                                    status,
		                                    pp$27,
		                                    uri,
		                                    function(details){
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$90,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a, integration, function(a){return b(a, details);});
		      });
		                                    });
		                          });
		                }
		                var uri$0 = a[3], str = match[2];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$91,
		                         function(a){
		                          return caml_trampoline_cps_call5
		                                  (a,
		                                   integration,
		                                   str,
		                                   pp$27,
		                                   uri$0,
		                                   function(details){
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$92,
		     function(a){
		      return caml_trampoline_cps_call3
		              (a, integration, str, function(a){return b(a, details);});
		     });
		                                   });
		                         });
		               }
		               function equal$102(poly_error, lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(lhs){
		                  if(typeof rhs === "number" && rhs) return cont(1);
		                 }
		                 else if(typeof rhs === "number" && ! rhs) return cont(1);
		                }
		                else if(typeof rhs !== "number"){
		                 var rhs0 = rhs[1], lhs0 = lhs[1];
		                 return caml_trampoline_cps_call3
		                         (poly_error, lhs0, rhs0, cont);
		                }
		                return cont(0);
		               }
		               var
		                cst_Ready = "Ready",
		                cst_Synchronizing = "Synchronizing",
		                cst_ready = "ready";
		               function schema_versioned$176(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_error_schema_v, cont){
		                                    function descriptor(schematic_param_error_schema_v){
		                                     return [11,
		     WB,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){
		        if(typeof param === "number" && ! param) return cont(WA);
		        return cont(0);
		       },
		       0,
		       0,
		       cst_ready,
		       cst_Ready,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){return cont(0);},
		         function(param, cont){return cont(0);},
		         0],
		        0],
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         if(typeof param === "number" && param) return cont(Wz);
		         return cont(0);
		        },
		        0,
		        0,
		        cst_synchronizing,
		        cst_Synchronizing,
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){return cont(0);},
		          function(param, cont){return cont(0);},
		          0],
		         0],
		        0],
		       [0,
		        [0,
		         function(f0, cont){return cont([0, f0]);},
		         function(param, cont){
		          if(typeof param === "number") return cont(0);
		          var f0 = param[1];
		          return cont([0, f0]);
		         },
		         0,
		         0,
		         "broken",
		         "Broken",
		         schematic_param_error_schema_v,
		         0],
		        0]]],
		     0];
		                                    }
		                                    var
		                                     schematic_schema_id = match$131[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_error,
		 schematic_param_error_schema_v,
		 function(schematic_param_error_schema_v, cont){
		  return cont
		          ([0,
		            schematic_schema_id,
		            descriptor(schematic_param_error_schema_v)]);
		 }]],
		                                     a = descriptor(schematic_param_error_schema_v),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, 0, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               function pp$67(poly_error, fmt, param, cont){
		                if(typeof param === "number")
		                 return param
		                         ? caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Integration.Status.Synchronizing",
		                            cont)
		                         : caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Integration.Status.Ready", cont);
		                var a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         WC,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (poly_error,
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), WD, cont);
		     });
		                                   });
		                         });
		               }
		               function map$34(poly_error, param, cont){
		                if(typeof param === "number")
		                 return param ? cont(1) : cont(0);
		                var a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (poly_error, a0, function(a){return cont([0, a]);});
		               }
		               var letrec_function_context$302 = [];
		               function schema_versioned$177(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$302[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, WE, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$302[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$302[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$302[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(WI);},
		                                  0,
		                                  0,
		                                  cst_bleeding,
		                                  "Bleeding",
		                                  WH,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(WG) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_stable,
		                                   "Stable",
		                                   WF,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$302[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$302[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$348 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$302, [0, schematic_cache$348]);
		               caml_callback
		                (schema_versioned$177,
		                 [function(param, cont){return cont(0);}]);
		               function api$0(param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call
		                          (of_string$19, "https://api.routine.co", cont)
		                        : caml_exact_trampoline_cps_call
		                          (of_string$19, "https://api.bleeding.routine.co", cont);
		               }
		               var letrec_function_context$303 = [];
		               function environment_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$303[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, WJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$303[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$303[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$303[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){return param ? cont(0) : cont(WL);},
		                                 0,
		                                 0,
		                                 cst_development,
		                                 "Development",
		                                 WK,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$177,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(! param) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_production,
		    "Production",
		    b,
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$303[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$303[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$349 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$303, [0, schematic_cache$349]);
		               caml_callback
		                (environment_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$304 = [];
		               function schema_versioned$178(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$304[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, WM, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$304[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$304[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$304[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(WQ);},
		                                  0,
		                                  0,
		                                  cst_task_add,
		                                  "Task_add",
		                                  WP,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(WO) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_task_archive,
		                                   "Task_archive",
		                                   WN,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$304[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$304[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$350 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$304, [0, schematic_cache$350]);
		               caml_callback
		                (schema_versioned$178,
		                 [function(param, cont){return cont(0);}]);
		               var cst_privacy = "privacy", letrec_function_context$305 = [];
		               function schema_versioned$179(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$305[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, WR, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$305[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$305[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$305[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  tou = e[2][1],
		                                  privacy = e[1],
		                                  homepage = d[1],
		                                  icon = c[1],
		                                  email = b[1],
		                                  description = a[1],
		                                  name = param[1];
		                                 return cont
		 ([0, name, description, email, icon, homepage, privacy, tou]);
		                                },
		                                function(param, cont){
		                                 var
		                                  tou = param[7],
		                                  privacy = param[6],
		                                  homepage = param[5],
		                                  icon = param[4],
		                                  email = param[3],
		                                  description = param[2],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   [0,
		    description,
		    [0,
		     email,
		     [0, icon, [0, homepage, [0, privacy, [0, tou, 0]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  WY,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   WX,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_description,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    WW,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_email,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0, WV, 0, 0, 0, cst_icon, 0, 3, [0, schema$262], 0, 0],
		                                    [0,
		                                     [0, WU, 0, 0, 0, "homepage", 0, 2, [0, schema$262], 0, 0],
		                                     [0,
		                                      [0, WT, 0, 0, 0, cst_privacy, 0, 2, [0, schema$262], 0, 0],
		                                      [0, [0, WS, 0, 0, 0, "tou", 0, 2, [0, schema$262], 0, 0], 0]]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$305[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$305[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$351 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$305, [0, schematic_cache$351]);
		               caml_callback
		                (schema_versioned$179,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$180(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    bB,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                schema$282 =
		                  [0,
		                   bB,
		                   0,
		                   schematic_param_name_schema_ve[3],
		                   schematic_param_name_schema_ve[4]];
		               function equal$103(a, b, cont){return cont(a === b ? 1 : 0);}
		               var bP9 = [];
		               function equal_userinfo(x, cont){
		                return caml_trampoline_cps_call2(bP9[1], x, cont);
		               }
		               caml_update_dummy(bP9, [0, equal$43]);
		               var cst_capacities = "capacities", bhv = [];
		               function grant_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bhv[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, WZ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bhv[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bhv[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bhv[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, W0, 0, 0, 0, cst_time, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$178,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var time = param[2][1], capacities = param[1];
		             return cont([0, capacities, time]);
		            },
		            function(param, cont){
		             var time = param[2], capacities = param[1];
		             return cont([0, capacities, [0, time, 0]]);
		            },
		            [0,
		             [0,
		              W1,
		              0,
		              0,
		              0,
		              cst_capacities,
		              0,
		              2,
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bhv[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bhv[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$352 = [0, empty$11([0, comparator$9])],
		                bhu = [];
		               caml_update_dummy(bhu, [0, schematic_cache$352]);
		               var schematic_cache$353 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bhv, [0, schematic_cache$353]);
		               var
		                schematic_cache$354 = [0, empty$11([0, comparator$9])],
		                bhw = [];
		               caml_update_dummy(bhw, [0, schematic_cache$354]);
		               var
		                schematic_cache$355 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$306 = [];
		               caml_update_dummy
		                (letrec_function_context$306, [0, schematic_cache$355]);
		               function schematic_version$44(param, cont){return cont(0);}
		               var cst_service = "service", schematic_schema_version$132 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bhu[1][1], schematic_schema_version$132]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bhu[1][1],
		                             schematic_schema_version$132,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bhu[1][1],
		schematic_schema_version$132,
		schematic_self,
		function(a){
		 bhu[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$115,
		          schematic_version$44,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$179,
		                    schematic_version$44,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var owner = param[2][1], service = param[1];
		                          return cont([0, service, owner]);
		                         },
		                         function(param, cont){
		                          var owner = param[2], service = param[1];
		                          return cont([0, service, [0, owner, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_service, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bhu[1][1],
		                              schematic_schema_version$132,
		                              res,
		                              function(a){bhu[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$45(param, cont){return cont(0);}
		               caml_callback(schema_versioned$53, [schematic_version$45]);
		               caml_callback
		                (grant_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$46(param, cont){return cont(0);}
		               var schematic_schema_version$131 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bhw[1][1], schematic_schema_version$131]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bhw[1][1],
		                             schematic_schema_version$131,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bhw[1][1],
		schematic_schema_version$131,
		schematic_self,
		function(a){
		 bhw[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (grant_schema_versioned,
		          schematic_version$46,
		          function(b){
		           var
		            a = [0, [0, W2, 0, 0, 0, cst_grant, 0, 3, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$179,
		                    schematic_version$46,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var grant = param[2][1], client = param[1];
		                          return cont([0, client, grant]);
		                         },
		                         function(param, cont){
		                          var grant = param[2], client = param[1];
		                          return cont([0, client, [0, grant, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_client, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bhw[1][1],
		                              schematic_schema_version$131,
		                              res,
		                              function(a){bhw[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_return_origin = "return_origin",
		                cst_return_path = "return_path",
		                cst_return_query = "return_query",
		                schematic_schema_version$12 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$306[1][1],
		                    schematic_schema_version$12]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$306[1][1],
		                             schematic_schema_version$12,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$306[1][1],
		schematic_schema_version$12,
		schematic_self,
		function(a){
		 letrec_function_context$306[1][1] = a;
		 a =
		  [0,
		   [0,
		    0,
		    0,
		    mapping_schema
		      ([0, 0, 0, [3, schematic_param_name_schema_ve], 0])
		     [3],
		    0]];
		 var
		  default$ = match$132[1],
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       return_origin = a[2][1],
		       return_query = a[1],
		       return_path = param[1];
		      return cont([0, return_path, return_query, return_origin]);
		     },
		     function(param, cont){
		      var
		       return_origin = param[3],
		       return_query = param[2],
		       return_path = param[1];
		      return cont
		              ([0, return_path, [0, return_query, [0, return_origin, 0]]]);
		     },
		     [0,
		      [0,
		       W5,
		       0,
		       0,
		       0,
		       cst_return_path,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        W4,
		        0,
		        0,
		        0,
		        cst_return_query,
		        0,
		        [0, default$],
		        a,
		        0,
		        0],
		       [0,
		        [0,
		         W3,
		         0,
		         0,
		         0,
		         cst_return_origin,
		         0,
		         3,
		         [0, schema$262],
		         0,
		         0],
		        0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$306[1][1],
		          schematic_schema_version$12,
		          res,
		          function(a){
		           letrec_function_context$306[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var bhy = [];
		               function grant_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bhy[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, W6, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bhy[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bhy[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bhy[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, W7, 0, 0, 0, cst_time, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$178,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var time = param[2][1], capacities = param[1];
		             return cont([0, capacities, time]);
		            },
		            function(param, cont){
		             var time = param[2], capacities = param[1];
		             return cont([0, capacities, [0, time, 0]]);
		            },
		            [0,
		             [0,
		              W8,
		              0,
		              0,
		              0,
		              cst_capacities,
		              0,
		              2,
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bhy[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bhy[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$356 = [0, empty$11([0, comparator$9])],
		                bhx = [];
		               caml_update_dummy(bhx, [0, schematic_cache$356]);
		               var schematic_cache$357 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bhy, [0, schematic_cache$357]);
		               var
		                schematic_cache$358 = [0, empty$11([0, comparator$9])],
		                bhz = [];
		               caml_update_dummy(bhz, [0, schematic_cache$358]);
		               var
		                schematic_cache$359 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$307 = [];
		               caml_update_dummy
		                (letrec_function_context$307, [0, schematic_cache$359]);
		               function schematic_version$47(param, cont){return cont(0);}
		               var schematic_schema_version$130 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bhx[1][1], schematic_schema_version$130]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bhx[1][1],
		                             schematic_schema_version$130,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bhx[1][1],
		schematic_schema_version$130,
		schematic_self,
		function(a){
		 bhx[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$115,
		          schematic_version$47,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$179,
		                    schematic_version$47,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var owner = param[2][1], service = param[1];
		                          return cont([0, service, owner]);
		                         },
		                         function(param, cont){
		                          var owner = param[2], service = param[1];
		                          return cont([0, service, [0, owner, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_service, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bhx[1][1],
		                              schematic_schema_version$130,
		                              res,
		                              function(a){bhx[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$48(param, cont){return cont(0);}
		               caml_callback(schema_versioned$53, [schematic_version$48]);
		               caml_callback
		                (grant_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$49(param, cont){return cont(0);}
		               var schematic_schema_version$129 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bhz[1][1], schematic_schema_version$129]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bhz[1][1],
		                             schematic_schema_version$129,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bhz[1][1],
		schematic_schema_version$129,
		schematic_self,
		function(a){
		 bhz[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (grant_schema_versioned$0,
		          schematic_version$49,
		          function(b){
		           var
		            a = [0, [0, W9, 0, 0, 0, cst_grant, 0, 3, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$179,
		                    schematic_version$49,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var grant = param[2][1], client = param[1];
		                          return cont([0, client, grant]);
		                         },
		                         function(param, cont){
		                          var grant = param[2], client = param[1];
		                          return cont([0, client, [0, grant, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_client, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bhz[1][1],
		                              schematic_schema_version$129,
		                              res,
		                              function(a){bhz[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$13 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$307[1][1],
		                    schematic_schema_version$13]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$307[1][1],
		                             schematic_schema_version$13,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$307[1][1],
		schematic_schema_version$13,
		schematic_self,
		function(a){
		 letrec_function_context$307[1][1] = a;
		 a =
		  [0,
		   [0,
		    0,
		    0,
		    mapping_schema
		      ([0, 0, 0, [3, schematic_param_name_schema_ve], 0])
		     [3],
		    0]];
		 var
		  default$ = match$133[1],
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       return_origin = a[2][1],
		       return_query = a[1],
		       return_path = param[1];
		      return cont([0, return_path, return_query, return_origin]);
		     },
		     function(param, cont){
		      var
		       return_origin = param[3],
		       return_query = param[2],
		       return_path = param[1];
		      return cont
		              ([0, return_path, [0, return_query, [0, return_origin, 0]]]);
		     },
		     [0,
		      [0,
		       Xa,
		       0,
		       0,
		       0,
		       cst_return_path,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        W$,
		        0,
		        0,
		        0,
		        cst_return_query,
		        0,
		        [0, default$],
		        a,
		        0,
		        0],
		       [0,
		        [0,
		         W_,
		         0,
		         0,
		         0,
		         cst_return_origin,
		         0,
		         3,
		         [0, schema$262],
		         0,
		         0],
		        0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$307[1][1],
		          schematic_schema_version$13,
		          res,
		          function(a){
		           letrec_function_context$307[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function userinfo_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$53,
		                                   schematic_version,
		                                   function(a){return cont([0, Xb, 0, a[3], a[4]]);});
		                         });
		               }
		               var bhK = [];
		               function grant_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bhK[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Xc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bhK[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bhK[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bhK[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, Xd, 0, 0, 0, cst_time, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$178,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var time = param[2][1], capacities = param[1];
		             return cont([0, capacities, time]);
		            },
		            function(param, cont){
		             var time = param[2], capacities = param[1];
		             return cont([0, capacities, [0, time, 0]]);
		            },
		            [0,
		             [0,
		              Xe,
		              0,
		              0,
		              0,
		              cst_capacities,
		              0,
		              2,
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bhK[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bhK[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$308 = [];
		               function return_info_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$308[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, Xh, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$308[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$308[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$308[1][1] = a;
		                  a =
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     mapping_schema
		                       ([0, 0, 0, [3, schematic_param_name_schema_ve], 0])
		                      [3],
		                     0]];
		                  var
		                   default$ = match$134[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        return_origin = a[2][1],
		                        return_query = a[1],
		                        return_path = param[1];
		                       return cont([0, return_path, return_query, return_origin]);
		                      },
		                      function(param, cont){
		                       var
		                        return_origin = param[3],
		                        return_query = param[2],
		                        return_path = param[1];
		                       return cont
		                               ([0, return_path, [0, return_query, [0, return_origin, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        Xk,
		                        0,
		                        0,
		                        0,
		                        cst_return_path,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         Xj,
		                         0,
		                         0,
		                         0,
		                         cst_return_query,
		                         0,
		                         [0, default$],
		                         a,
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          Xi,
		                          0,
		                          0,
		                          0,
		                          cst_return_origin,
		                          0,
		                          3,
		                          [0, schema$262],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$308[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$308[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$360 = [0, empty$11([0, comparator$9])],
		                bhA = [];
		               caml_update_dummy(bhA, [0, schematic_cache$360]);
		               var schematic_cache$361 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bhK, [0, schematic_cache$361]);
		               var
		                schematic_cache$362 = [0, empty$11([0, comparator$9])],
		                bhL = [];
		               caml_update_dummy(bhL, [0, schematic_cache$362]);
		               var schematic_cache$363 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$308, [0, schematic_cache$363]);
		               function schematic_version$50(param, cont){return cont(0);}
		               var schematic_schema_version$128 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bhA[1][1], schematic_schema_version$128]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bhA[1][1],
		                             schematic_schema_version$128,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bhA[1][1],
		schematic_schema_version$128,
		schematic_self,
		function(a){
		 bhA[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$115,
		          schematic_version$50,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$179,
		                    schematic_version$50,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var owner = param[2][1], service = param[1];
		                          return cont([0, service, owner]);
		                         },
		                         function(param, cont){
		                          var owner = param[2], service = param[1];
		                          return cont([0, service, [0, owner, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_service, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bhA[1][1],
		                              schematic_schema_version$128,
		                              res,
		                              function(a){bhA[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (userinfo_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (grant_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$51(param, cont){return cont(0);}
		               var
		                schematic_schema_version$127 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [bhL[1][1], schematic_schema_version$127]);
		               if(h)
		                var schema$64 = h[1], descriptor$15 = schema$64;
		               else
		                descriptor$15 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              bhL[1][1],
		                              schematic_schema_version$127,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bhL[1][1],
		 schematic_schema_version$127,
		 schematic_self,
		 function(a){
		  bhL[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (grant_schema_versioned$1,
		           schematic_version$51,
		           function(b){
		            var
		             a = [0, [0, Xg, 0, 0, 0, cst_grant, 0, 3, [0, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$179,
		                     schematic_version$51,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var grant = param[2][1], client = param[1];
		                           return cont([0, client, grant]);
		                          },
		                          function(param, cont){
		                           var grant = param[2], client = param[1];
		                           return cont([0, client, [0, grant, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_client, 0, 2, [1, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               bhL[1][1],
		                               schematic_schema_version$127,
		                               res,
		                               function(a){bhL[1][1] = a; return cont(res);});
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var client_grant_schema = [0, Xf, 0, descriptor$15, 0];
		               caml_callback
		                (return_info_schema_versioned, [function(param){return 0;}]);
		               var
		                schematic_cache$364 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$309 = [];
		               caml_update_dummy
		                (letrec_function_context$309, [0, schematic_cache$364]);
		               function schematic_version$52(param){return 0;}
		               var schematic_schema_version$126 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$309[1][1],
		                    schematic_schema_version$126]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$309[1][1],
		                             schematic_schema_version$126,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$309[1][1],
		schematic_schema_version$126,
		schematic_self,
		function(a){
		 letrec_function_context$309[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (return_info_schema_versioned,
		          schematic_version$52,
		          function(a){
		           var
		            res =
		              [11,
		               0,
		               [0,
		                [0,
		                 function(f0, cont){return cont([0, f0]);},
		                 function(param, cont){
		                  if(0 !== param[0]) return cont(0);
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 0,
		                 0,
		                 cst_uri,
		                 cst_Uri,
		                 schema$262,
		                 0],
		                [0,
		                 [0,
		                  function(f0, cont){return cont([1, f0]);},
		                  function(param, cont){
		                   if(0 === param[0]) return cont(0);
		                   var f0 = param[1];
		                   return cont([0, f0]);
		                  },
		                  0,
		                  0,
		                  cst_legacy,
		                  cst_Legacy,
		                  a,
		                  0],
		                 0]],
		               0];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$309[1][1],
		                    schematic_schema_version$126,
		                    res,
		                    function(a){
		                     letrec_function_context$309[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$365 = [0, empty$11([0, comparator$9])],
		                bh8 = [];
		               caml_update_dummy(bh8, [0, schematic_cache$365]);
		               var
		                schematic_cache$366 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$310 = [];
		               caml_update_dummy
		                (letrec_function_context$310, [0, schematic_cache$366]);
		               function schematic_version$53(param, cont){return cont(0);}
		               var schematic_schema_version$125 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bh8[1][1], schematic_schema_version$125]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bh8[1][1],
		                             schematic_schema_version$125,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bh8[1][1],
		schematic_schema_version$125,
		schematic_self,
		function(b){
		 bh8[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_uid,
		      0,
		      0,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$122,
		          schematic_version$53,
		          function(c){
		           var
		            b =
		              [0,
		               [0,
		                Xm,
		                0,
		                0,
		                0,
		                cst_premium,
		                0,
		                3,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0, [0, Xl, 0, 0, 0, cst_workspace, 0, 2, [0, c], 0, 0], a]];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$117,
		                    schematic_version$53,
		                    function(c){
		                     var
		                      a =
		                        [0, [0, Xn, 0, 0, 0, cst_user_id, 0, 2, [0, c], 0, 0], b];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$115,
		                              schematic_version$53,
		                              function(c){
		                               var
		                                b = [0, [0, Xo, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$177,
		schematic_version$53,
		function(a){
		 var
		  default$ = match$135[1],
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       d = c[2],
		       workspace = d[2][1],
		       premium = d[1],
		       user_id = c[1],
		       id = b[1],
		       channel = a[1],
		       token = param[1];
		      return cont
		              ([0, token, channel, id, user_id, premium, workspace]);
		     },
		     function(param, cont){
		      var
		       workspace = param[6],
		       premium = param[5],
		       user_id = param[4],
		       id = param[3],
		       channel = param[2],
		       token = param[1];
		      return cont
		              ([0,
		                token,
		                [0,
		                 channel,
		                 [0, id, [0, user_id, [0, premium, [0, workspace, Xr]]]]]]);
		     },
		     [0,
		      [0,
		       Xq,
		       0,
		       0,
		       0,
		       cst_token,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        Xp,
		        0,
		        0,
		        0,
		        cst_channel,
		        0,
		        [0, default$],
		        [0, a],
		        0,
		        0],
		       b]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          bh8[1][1],
		          schematic_schema_version$125,
		          res,
		          function(a){bh8[1][1] = a; return cont(res);});
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$124 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$310[1][1],
		                    schematic_schema_version$124]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$310[1][1],
		                             schematic_schema_version$124,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$310[1][1],
		schematic_schema_version$124,
		schematic_self,
		function(a){
		 letrec_function_context$310[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$4,
		          dummy,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var granted = param[1];
		                return cont([0, granted]);
		               },
		               function(param, cont){
		                var granted = param[1];
		                return cont([0, granted, 0]);
		               },
		               [0, [0, 0, 0, 0, 0, "granted", 0, 2, [0, a], 0, 0], 0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$310[1][1],
		                    schematic_schema_version$124,
		                    res,
		                    function(a){
		                     letrec_function_context$310[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$311 = [];
		               function compare$103(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhs0 = rhs[1], lhs0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$311[7], lhs0, rhs0, cont);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$311[6], lhs0$0, rhs0$0, cont);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$311[5], lhs0$1, rhs0$1, cont);
		                   }
		                   break;
		                  case 3:
		                   if(3 === rhs[0]){
		                    var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$311[4], lhs0$2, rhs0$2, cont);
		                   }
		                   break;
		                  case 4:
		                   if(4 === rhs[0]){
		                    var rhs0$3 = rhs[1], lhs0$3 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$311[3], lhs0$3, rhs0$3, cont);
		                   }
		                   break;
		                  case 5:
		                   if(5 === rhs[0]){
		                    var rhs0$4 = rhs[1], lhs0$4 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$311[2], lhs0$4, rhs0$4, cont);
		                   }
		                   break;
		                  default:
		                   if(6 === rhs[0]){
		                    var rhs0$5 = rhs[1], lhs0$5 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$311[1], lhs0$5, rhs0$5, cont);
		                   }
		                }
		                function to_int(param){
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   default: return 6;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var
		                _5$4 = Task_recurrent[16],
		                _3$7 = include$50[16],
		                _1$27 = Event_recurrent[16];
		               caml_update_dummy
		                (letrec_function_context$311,
		                 [0,
		                  compare$62,
		                  _5$4,
		                  compare$68,
		                  _3$7,
		                  compare$59,
		                  _1$27,
		                  compare$58]);
		               var letrec_function_context$312 = [];
		               function schema_versioned$181(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$312[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$312[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$312[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$312[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     Xt,
		                                     Xs,
		                                     0,
		                                     21,
		                                     9,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$105,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(6 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_object,
		             cst_Object,
		             c,
		             a],
		            0];
		        return caml_exact_trampoline_cps_call
		                (Task_recurrent[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([5, f0]);},
		                       function(param, cont){
		                        if(5 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_task_recurrent,
		                       cst_Task_recurrent,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$109,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(4 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_task,
		                                 cst_Task,
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (include$50[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_people,
		   cst_People,
		   c,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$103,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_page,
		             cst_Page,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (Event_recurrent[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_event,
		                        cst_Event,
		                        schema$263,
		                        0],
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([1, f0]);},
		                         function(param, cont){
		                          if(1 !== param[0]) return cont(0);
		                          var f0 = param[1];
		                          return cont([0, f0]);
		                         },
		                         0,
		                         0,
		                         cst_event_recurrent,
		                         cst_Event_recurrent,
		                         a,
		                         0],
		                        b]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$312[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$312[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$367 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$312, [0, schematic_cache$367]);
		               caml_callback
		                (schema_versioned$181,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$313 = [];
		               function pp$68(fmt, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Xu,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$313[7],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Xv, cont);
		        });
		                                      });
		                            });
		                  case 1:
		                   var a0$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Xw,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$313[6],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Xx, cont);
		        });
		                                      });
		                            });
		                  case 2:
		                   var a0$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            Xy,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$313[5],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$1,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), Xz, cont);
		        });
		                                      });
		                            });
		                  case 3:
		                   var a0$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            XA,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$313[4],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$2,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), XB, cont);
		        });
		                                      });
		                            });
		                  case 4:
		                   var a0$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            XC,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$313[3],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$3,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), XD, cont);
		        });
		                                      });
		                            });
		                  case 5:
		                   var a0$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            XE,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$313[2],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$4,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), XF, cont);
		        });
		                                      });
		                            });
		                  default:
		                   var a0$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            XG,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$313[1],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$5,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), XH, cont);
		        });
		                                      });
		                            });
		                }
		               }
		               var
		                _5$5 = Task_recurrent[1],
		                _3$8 = include$50[1],
		                _1$28 = Event_recurrent[1];
		               caml_update_dummy
		                (letrec_function_context$313,
		                 [0, _33, _5$5, _16$0, _3$8, pp$36, _1$28, pp$35]);
		               function to_string$50(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var t = param[1];
		                   return caml_exact_trampoline_cps_call(to_string$29, t, cont);
		                  case 1:
		                   var t$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Event_recurrent[8], t$0, cont);
		                  case 2:
		                   var t$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$30, t$1, cont);
		                  case 3:
		                   var t$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (include$50[8], t$2, cont);
		                  case 4:
		                   var t$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$36, t$3, cont);
		                  case 5:
		                   var t$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Task_recurrent[8], t$4, cont);
		                  default:
		                   var t$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$32, t$5, cont);
		                }
		               }
		               function to_reference_id(param){
		                switch(param[0]){
		                  case 0:
		                   var id = param[1]; return [0, id];
		                  case 1:
		                   var id$0 = param[1]; return [1, id$0];
		                  case 2:
		                   var id$1 = param[1]; return [2, id$1];
		                  case 3:
		                   var id$2 = param[1]; return [3, id$2];
		                  case 4:
		                   var id$3 = param[1]; return task$0(id$3);
		                  case 5:
		                   var id$4 = param[1]; return [5, id$4];
		                  default: var id$5 = param[1]; return [6, id$5];
		                }
		               }
		               function pp_v$0(a, b, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (using, to_string$50, pp_print_string, a, b, cont);
		               }
		               var letrec_function_context$314 = [];
		               function kind_schema_versioned$1(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$314[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, XI, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$314[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$314[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$314[1][1] = a;
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           XK,
		                           XJ,
		                           0,
		                           21,
		                           9,
		                           function(a){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(XY);},
		                                  0,
		                                  0,
		                                  cst_event,
		                                  cst_Event,
		                                  XX,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(XW) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_event_rec,
		                                   cst_Event_recurrent,
		                                   XV,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(XU) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_page,
		                                    cst_Page,
		                                    XT,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(XS) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_people,
		                                     cst_People,
		                                     XR,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(XQ) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_task,
		                                      cst_Task,
		                                      XP,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(XO) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_task_rec,
		                                       cst_Task_recurrent,
		                                       XN,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 <= param ? cont(XM) : cont(0);
		},
		0,
		0,
		cst_object,
		cst_Object,
		XL,
		[0, [0, a, V$4]]],
		                                       0]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$314[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$314[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                schematic_cache$368 = [0, empty$11([0, comparator$9])],
		                bh9 = [];
		               caml_update_dummy(bh9, [0, schematic_cache$368]);
		               var schematic_cache$369 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$314, [0, schematic_cache$369]);
		               function schematic_version$54(param){return 0;}
		               var
		                schematic_schema_version$123 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [bh9[1][1], schematic_schema_version$123]);
		               if(h)
		                var schema$65 = h[1], descriptor$16 = schema$65;
		               else
		                descriptor$16 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              bh9[1][1],
		                              schematic_schema_version$123,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bh9[1][1],
		 schematic_schema_version$123,
		 schematic_self,
		 function(b){
		  bh9[1][1] = b;
		  var
		   a =
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_id,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0];
		  return caml_exact_trampoline_cps_call
		          (kind_schema_versioned$1,
		           schematic_version$54,
		           function(b){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var id = param[2][1], kind = param[1];
		                 return cont([0, kind, id]);
		                },
		                function(param, cont){
		                 var id = param[2], kind = param[1];
		                 return cont([0, kind, [0, id, 0]]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, b], 0, 0], a]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     bh9[1][1],
		                     schematic_schema_version$123,
		                     res,
		                     function(a){bh9[1][1] = a; return cont(res);});
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               caml_callback
		                (kind_schema_versioned$1, [function(param){return 0;}]);
		               function schema_versioned$182(param){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 symbol_map = open[2];
		                function decode(param, cont){
		                 var id = param[2], kind = param[1];
		                 switch(kind){
		                   case 0:
		                    var a = function(id, cont){return cont([0, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$22,
		                             id,
		                             function(b){
		                              return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                             });
		                   case 1:
		                    var b = function(id, cont){return cont([1, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (Event_recurrent[6],
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, b, cont);
		                             });
		                   case 2:
		                    var c = function(id, cont){return cont([2, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$23,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, c, cont);
		                             });
		                   case 3:
		                    var d = function(id, cont){return cont([3, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (include$50[6],
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, d, cont);
		                             });
		                   case 4:
		                    var e = function(id, cont){return cont([4, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$29,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, e, cont);
		                             });
		                   case 5:
		                    var f = function(id, cont){return cont([5, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (Task_recurrent[6],
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, f, cont);
		                             });
		                   default:
		                    var g = function(id, cont){return cont([6, id]);};
		                    return caml_exact_trampoline_cps_call
		                            (of_string$25,
		                             id,
		                             function(a){
		                              return caml_trampoline_cps_call3(symbol_map, a, g, cont);
		                             });
		                 }
		                }
		                function encode(id, cont){
		                 switch(id[0]){
		                   case 0:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$50, id, function(a){return cont([0, 0, a]);});
		                   case 1:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$50, id, function(a){return cont([0, 1, a]);});
		                   case 2:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$50, id, function(a){return cont([0, 2, a]);});
		                   case 3:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$50, id, function(a){return cont([0, 3, a]);});
		                   case 4:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$50, id, function(a){return cont([0, 4, a]);});
		                   case 5:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$50, id, function(a){return cont([0, 5, a]);});
		                   default:
		                    return caml_exact_trampoline_cps_call
		                            (to_string$50, id, function(a){return cont([0, 6, a]);});
		                 }
		                }
		                var descriptor = [4, decode, encode, descriptor$16];
		                return [0, id$22, 0, descriptor, 0];
		               }
		               var schema$66 = schema_versioned$182();
		               function sexp_of_t$46(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var id = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$29, id, function(a){return cont([0, a]);});
		                  case 1:
		                   var id$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Event_recurrent[8],
		                            id$0,
		                            function(a){return cont([0, a]);});
		                  case 2:
		                   var id$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$30, id$1, function(a){return cont([0, a]);});
		                  case 3:
		                   var id$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (include$50[8], id$2, function(a){return cont([0, a]);});
		                  case 4:
		                   var id$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_string$36, id$3, function(a){return cont([0, a]);});
		                  case 5:
		                   var id$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (Task_recurrent[8], id$4, function(a){return cont([0, a]);});
		                  default:
		                   var obj = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$36, obj, cont);
		                }
		               }
		               var
		                include$75 = Make$2([0, compare$103, sexp_of_t$46]),
		                symbol$149 = include$75[3],
		                equal$104 = include$75[7],
		                compare$104 = include$75[8],
		                comparator$27 = include$75[16];
		               function schema_versioned$183(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$181,
		                                   schematic_version,
		                                   function(a){return cont([0, XZ, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$183,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$315 = [];
		               function pp$69(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$315[1], fmt, cont);
		               }
		               caml_update_dummy(letrec_function_context$315, [0, pp$68]);
		               caml_callback
		                (M_printable,
		                 [[0, pp$69, comparator$27, schema_versioned$183]]);
		               function schema_versioned$184(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$181,
		                                   schematic_version,
		                                   function(a){return cont([0, X0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$184,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$316 = [];
		               function pp$70(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$316[1], fmt, cont);
		               }
		               caml_update_dummy(letrec_function_context$316, [0, pp$68]);
		               caml_callback
		                (M_printable$0,
		                 [[0, pp$70, comparator$27, schema_versioned$184]]);
		               var letrec_function_context$317 = [];
		               function equal_occurrence(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$317[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$317[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               var _1$29 = Task_recurrent[15];
		               caml_update_dummy
		                (letrec_function_context$317, [0, _1$29, equal$21]);
		               var letrec_function_context$318 = [];
		               function compare_occurrence(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$318[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$318[1], lhs[2], rhs[2], cont)
		                                  : cont(x);
		                         });
		               }
		               var _1$30 = Task_recurrent[16];
		               caml_update_dummy
		                (letrec_function_context$318, [0, _1$30, compare$39]);
		               var letrec_function_context$319 = [];
		               function occurrence_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$319[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, X2, X1, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$319[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$319[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$319[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Task_recurrent[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, X3, 0, 0, 0, cst_recurrence, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$1,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var recurrence = param[2][1], date = param[1];
		             return cont([0, date, recurrence]);
		            },
		            function(param, cont){
		             var recurrence = param[2], date = param[1];
		             return cont([0, date, [0, recurrence, 0]]);
		            },
		            [0, [0, X4, 0, 0, 0, cst_date, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$319[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$319[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$370 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$319, [0, schematic_cache$370]);
		               caml_callback
		                (occurrence_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$320 = [];
		               function pp_occurrence(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         X5,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   X6,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Task.date",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$320[2],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   X7,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     X8,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               X9,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_recurrence,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$320[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               X_,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), X$, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var _1$31 = Task_recurrent[1];
		               caml_update_dummy
		                (letrec_function_context$320, [0, _1$31, pp_v1$0]);
		               var letrec_function_context$321 = [];
		               function equal$105(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$321[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$321[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$321, [0, equal$21, equal$22]);
		               var letrec_function_context$322 = [];
		               function compare$105(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$322[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$322[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               caml_update_dummy
		                (letrec_function_context$322, [0, compare$39, compare$40]);
		               var letrec_function_context$323 = [];
		               function schema_versioned$185(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$323[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, Ya, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$323[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$323[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$323[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$1,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_date,
		   cst_Date,
		   [0, a[1], Yb, a[3], a[4]],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$5,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_batch,
		              "Batch",
		              [0, a[1], Yc, a[3], a[4]],
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$323[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$323[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$371 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$323, [0, schematic_cache$371]);
		               var
		                schema$67 =
		                  caml_callback
		                   (schema_versioned$185,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$324 = [];
		               function _12$3(fmt, param, cont){
		                if(0 === param[0]){
		                 var a0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Yd,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$324[2],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      a0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), Ye, cont);
		      });
		                                    });
		                          });
		                }
		                var a0$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Yf,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$324[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0$0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), Yg, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$324, [0, pp_v1$0, pp$14]);
		               function to_week_date(a, cont){
		                if(! a) return cont(Yh);
		                a = a[1];
		                if(0 === a[0]){
		                 var week = a[1];
		                 return cont([0, [0, week], 0]);
		                }
		                var date = a[1], b = [0, date];
		                return caml_exact_trampoline_cps_call
		                        (of_date$1, date, function(a){return cont([0, [0, a], b]);});
		               }
		               function optional_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$1,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema, a, function(a){return cont([0, , , a[3]]);});
		                                   });
		                         });
		               }
		               var
		                optional_schema =
		                  caml_callback
		                   (optional_schema_versioned,
		                    [function(param, cont){return cont(0);}]);
		               function encode$8(a, cont){
		                if(! a) return cont(0);
		                a = a[1];
		                if(0 === a[0]){
		                 var week = a[1];
		                 return caml_exact_trampoline_cps_call
		                         (to_date$2, week, function(a){return cont([0, a]);});
		                }
		                var date = a[1];
		                return cont([0, date]);
		               }
		               var descriptor$17 = optional_schema[3];
		               function decode$7(x, cont){
		                if(x) var date = x[1], a = [0, [1, date]]; else a = 0;
		                return caml_trampoline_cps_call2(of_string$14, a, cont);
		               }
		               function Templatable_moded(M, Name, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[4],
		                          letrec_function_context[5],
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(b){
		                                     function a(a){
		                                      if(! a) return cont(a);
		                                      var b = rhs[3], c = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[1],
		       function(x, y, cont){
		        if(x){
		         if(y){
		          var b = y[1], a = x[1];
		          return caml_trampoline_cps_call3
		                  (letrec_function_context[2], a, b, cont);
		         }
		        }
		        else if(! y) return cont(1);
		        return cont(0);
		       },
		       function(a){
		        return caml_trampoline_cps_call3(a, c, b, cont);
		       });
		                                     }
		                                     if(! b) return a(b);
		                                     var c = rhs[2], d = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[3],
		      function(a, b, cont){return cont(a === b ? 1 : 0);},
		      function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                    });
		                          });
		                }
		                var _4 = M[9], _2 = M[9], _1 = M[9];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0, _4, equal$44, _2, _1, equal$75]);
		                var letrec_function_context$0 = [];
		                function compare(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context$0[5],
		                          letrec_function_context$0[6],
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(x){
		                                     if(0 !== x) return cont(x);
		                                     var a = rhs[2], b = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context$0[4],
		      0,
		      function(c){
		       return caml_trampoline_cps_call2
		               (letrec_function_context$0[3],
		                c,
		                function(c){
		                 return caml_trampoline_cps_call3
		                         (c,
		                          b,
		                          a,
		                          function(x){
		                           if(0 !== x) return cont(x);
		                           var a = rhs[3], b = lhs[3];
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$0[1],
		                                    function(x, y, cont){
		                                     if(! x) return y ? cont(-1) : cont(0);
		                                     var a = x[1];
		                                     if(! y) return cont(1);
		                                     var b = y[1];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context$0[2], a, b, cont);
		                                    },
		                                    function(c){
		                                     return caml_trampoline_cps_call3(c, b, a, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var _5 = M[10], _3 = M[10];
		                function _2$0(param, a, b, cont){
		                 return cont(caml_string_compare(a, b));
		                }
		                var _1$0 = M[10];
		                caml_update_dummy
		                 (letrec_function_context$0,
		                  [0, _5, compare$51, _3, _2$0, _1$0, compare$92]);
		                function make(a, opt, title){
		                 var
		                  notes = a ? a[1] : M[5].call(null, Yi),
		                  url = opt ? opt[1] : M[5].call(null, 0);
		                 return [0, notes, title, url];
		                }
		                var letrec_function_context$1 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$1[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      var a = Name[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$94,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(b){
		                  var a = Name[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$95,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){return cont([0, [0, a], Yj, descriptor, 0]);});
		                           });
		                 });
		       });
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$1[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$1[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$1[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      schema$262,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(b){
		         var
		          default$ = M[5].call(null, 0),
		          a =
		            [0,
		             [0, Yk, 0, 0, 0, cst_url, 0, [0, default$], [0, b], 0, 0],
		             0];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  schematic_param_name_schema_ve,
		                  function(c){
		                   var b = M[6].call(null, 0), c = [0, c];
		                   if(b) var default$ = b[1], b = [0, default$]; else b = 2;
		                   var d = [0, [0, Yl, 0, 0, 0, cst_title, 0, b, c, 0, 0], a];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$140,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      a,
		                                      function(a){
		                                       var
		default$ = M[5].call(null, Ym),
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     url = a[2][1],
		     title = a[1],
		     notes = param[1];
		    return cont([0, notes, title, url]);
		   },
		   function(param, cont){
		    var url = param[3], title = param[2], notes = param[1];
		    return cont([0, notes, [0, title, [0, url, 0]]]);
		   },
		   [0,
		    [0, Yn, 0, 0, 0, cst_notes, 0, [0, default$], [0, a], 0, 0],
		    d]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context$1[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context$1[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$1, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    Yo,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      Yp,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Task.Templatable_moded.notes",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[4],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[5], fmt, cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      Yq,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Yr,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Ys,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_title,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[3],
		      function(fmt, cont){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), Yt, cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Yu,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    Yv,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      Yw,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_url,
		                function(b){
		                 var a = x[3];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[1],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[2],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      Yx,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), Yy, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var _4 = M[8], _2 = M[8], _1 = M[8];
		                          caml_update_dummy
		                           (letrec_function_context, [0, _4, pp$27, _2, _1, _13$0]);
		                          return cont
		                                  ([0, equal, compare, make, schema_versioned, , pp]);
		                         });
		               }
		               var
		                schema_0_6 =
		                  [0, id$23, 0, [4, decode$7, encode$8, descriptor$17], 0],
		                Read_name = [0, "task-read"],
		                Patch_name = [0, "task-patch"];
		               function With_integration(I, cont){
		                var letrec_function_context = [];
		                function equal_integration(lhs, rhs, cont){
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[2],
		                          lhs[1],
		                          rhs[1],
		                          function(c){
		                           if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                           if(! c) return cont(c);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b$0 = y[1], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context[1], a$0, b$0, cont);
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          });
		                }
		                var _1 = I[2];
		                caml_update_dummy(letrec_function_context, [0, _1, equal$100]);
		                var letrec_function_context$0 = [];
		                function compare_integration(lhs, rhs, cont){
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context$0[3],
		                          lhs[1],
		                          rhs[1],
		                          function(x){
		                           if(0 !== x) return cont(x);
		                           var a = rhs[2], b = lhs[2];
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$0[2],
		                                    0,
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (c,
		      b,
		      a,
		      function(x){
		       if(0 !== x) return cont(x);
		       var y = rhs[3], x$0 = lhs[3];
		       if(! x$0) return y ? cont(-1) : cont(0);
		       var a = x$0[1];
		       if(! y) return cont(1);
		       var b = y[1];
		       return caml_trampoline_cps_call3
		               (letrec_function_context$0[1], a, b, cont);
		      });
		                                    });
		                          });
		                }
		                var _2 = I[1];
		                function _1$0(param, a, b, cont){
		                 return cont(caml_string_compare(a, b));
		                }
		                caml_update_dummy
		                 (letrec_function_context$0, [0, _2, _1$0, compare$102]);
		                var
		                 cst_distant_task_id = "distant_task_id",
		                 letrec_function_context$1 = [];
		                function integration_schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$1[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, Yz, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$1[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$1[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$1[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      I[4].call(null, schematic_version),
		                                      function(a){
		                                       var
		default$ = match$136[1],
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     data = a[2][1],
		     distant_task_id = a[1],
		     id = param[1];
		    return cont([0, id, distant_task_id, data]);
		   },
		   function(param, cont){
		    var
		     data = param[3],
		     distant_task_id = param[2],
		     id = param[1];
		    return cont([0, id, [0, distant_task_id, [0, data, 0]]]);
		   },
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     "integration_id",
		     0,
		     2,
		     [0, schema$265],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_distant_task_id,
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "integration_data",
		       0,
		       [0, default$],
		       [0, a],
		       0,
		       0],
		      0]]]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context$1[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context$1[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$1, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (integration_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(integration_schema){
		                          var letrec_function_context = [];
		                          function pp_integration(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    YA,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      YB,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Task.With_integration.id",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[2],
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      YC,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                YD,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          YE,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_distant_task_id,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      YF,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          YG,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    YH,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      YI,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_data,
		                function(a){
		                 a = x[3];
		                 function b(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           YJ,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt), YK, cont);
		                           });
		                 }
		                 if(! a)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst_None, b);
		                 var x$0 = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          cst_Some,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[1],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      x$0,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst$18, b);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var _1 = I[3];
		                          caml_update_dummy(letrec_function_context, [0, _1, pp$65]);
		                          function Moded(M, Name, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Templatable_moded,
		                                    M,
		                                    Name,
		                                    function(Templatable){
		                                     var letrec_function_context = [];
		                                     function equal(lhs, rhs, cont){
		                                      var a = rhs[1], b = lhs[1];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[15],
		       function(x, y, cont){
		        if(x){
		         if(y){
		          var b = y[1], a = x[1];
		          return caml_trampoline_cps_call3
		                  (letrec_function_context[16], a, b, cont);
		         }
		        }
		        else if(! y) return cont(1);
		        return cont(0);
		       },
		       function(c){
		        return caml_trampoline_cps_call3
		                (c,
		                 b,
		                 a,
		                 function(b){
		                  function a(b){
		                   function a(b){
		                    function a(b){
		                     function a(b){
		                      function a(b){
		                       function a(b){
		                        function a(a){
		                         return a
		                                 ? caml_trampoline_cps_call3
		                                   (letrec_function_context[1], lhs[9], rhs[9], cont)
		                                 : cont(a);
		                        }
		                        if(! b) return a(b);
		                        var c = rhs[8], d = lhs[8];
		                        return caml_trampoline_cps_call2
		                                (letrec_function_context[2],
		                                 function(a, b, cont){return cont(a === b ? 1 : 0);},
		                                 function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                       }
		                       if(! b) return a(b);
		                       var c = rhs[7], d = lhs[7];
		                       return caml_trampoline_cps_call2
		                               (letrec_function_context[3],
		                                function(x, y, cont){
		                                 if(x){
		                                  if(y){
		                                   var b = y[1], a = x[1];
		                                   return caml_trampoline_cps_call3
		   (letrec_function_context[4], a, b, cont);
		                                  }
		                                 }
		                                 else if(! y) return cont(1);
		                                 return cont(0);
		                                },
		                                function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                      }
		                      if(! b) return a(b);
		                      var c = rhs[6], d = lhs[6];
		                      return caml_trampoline_cps_call2
		                              (letrec_function_context[5],
		                               function(x, y, cont){
		                                if(x){
		                                 if(y){
		                                  var b = y[1], a = x[1];
		                                  return caml_trampoline_cps_call3
		  (letrec_function_context[6], a, b, cont);
		                                 }
		                                }
		                                else if(! y) return cont(1);
		                                return cont(0);
		                               },
		                               function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                     }
		                     if(! b) return a(b);
		                     var c = rhs[5], d = lhs[5];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context[7],
		                              function(x, y, cont){
		                               if(x){
		                                if(y){
		                                 var b = y[1], a = x[1];
		                                 return caml_trampoline_cps_call3
		 (letrec_function_context[8], a, b, cont);
		                                }
		                               }
		                               else if(! y) return cont(1);
		                               return cont(0);
		                              },
		                              function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                    }
		                    if(! b) return a(b);
		                    var c = rhs[4], d = lhs[4];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context[9],
		                             function(x, y, cont){
		                              if(x){
		                               if(y){
		                                var b = y[1], a = x[1];
		                                return caml_trampoline_cps_call3
		(letrec_function_context[10], a, b, cont);
		                               }
		                              }
		                              else if(! y) return cont(1);
		                              return cont(0);
		                             },
		                             function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                   }
		                   if(! b) return a(b);
		                   var c = rhs[3], d = lhs[3];
		                   return caml_trampoline_cps_call2
		                           (letrec_function_context[11],
		                            function(x, y, cont){
		                             if(x){
		                              if(y){
		                               var b = y[1], a = x[1];
		                               return caml_trampoline_cps_call3
		                                       (letrec_function_context[12], a, b, cont);
		                              }
		                             }
		                             else if(! y) return cont(1);
		                             return cont(0);
		                            },
		                            function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                  }
		                  if(! b) return a(b);
		                  var c = rhs[2], d = lhs[2];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context[13],
		                           function(x, y, cont){
		                            if(x){
		                             if(y){
		                              var b = y[1], a = x[1];
		                              return caml_trampoline_cps_call3
		                                      (letrec_function_context[14], a, b, cont);
		                             }
		                            }
		                            else if(! y) return cont(1);
		                            return cont(0);
		                           },
		                           function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                 });
		       });
		                                     }
		                                     var
		                                      _15 = Templatable[1],
		                                      _14 = M[9],
		                                      _13 = M[9],
		                                      _11 = M[9],
		                                      _9 = M[9],
		                                      _7 = M[9],
		                                      _5 = M[9],
		                                      _3 = M[9],
		                                      _1 = M[9];
		                                     caml_update_dummy
		                                      (letrec_function_context,
		                                       [0,
		_15,
		_14,
		_13,
		equal$105,
		_11,
		equal$104,
		_9,
		equal_occurrence,
		_7,
		equal_integration,
		_5,
		equal$99,
		_3,
		equal$20,
		_1,
		equal$20]);
		                                     var letrec_function_context$0 = [];
		                                     function compare(lhs, rhs, cont){
		                                      var a = rhs[1], b = lhs[1];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context$0[16],
		       function(x, y, cont){
		        if(! x) return y ? cont(-1) : cont(0);
		        var a = x[1];
		        if(! y) return cont(1);
		        var b = y[1];
		        return caml_trampoline_cps_call3
		                (letrec_function_context$0[17], a, b, cont);
		       },
		       function(c){
		        return caml_trampoline_cps_call3
		                (c,
		                 b,
		                 a,
		                 function(x){
		                  if(0 !== x) return cont(x);
		                  var a = rhs[2], b = lhs[2];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$0[14],
		                           function(x, y, cont){
		                            if(! x) return y ? cont(-1) : cont(0);
		                            var a = x[1];
		                            if(! y) return cont(1);
		                            var b = y[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$0[15], a, b, cont);
		                           },
		                           function(c){
		                            return caml_trampoline_cps_call3
		                                    (c,
		                                     b,
		                                     a,
		                                     function(x){
		                                      if(0 !== x) return cont(x);
		                                      var a = rhs[3], b = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context$0[12],
		       function(x, y, cont){
		        if(! x) return y ? cont(-1) : cont(0);
		        var a = x[1];
		        if(! y) return cont(1);
		        var b = y[1];
		        return caml_trampoline_cps_call3
		                (letrec_function_context$0[13], a, b, cont);
		       },
		       function(c){
		        return caml_trampoline_cps_call3
		                (c,
		                 b,
		                 a,
		                 function(x){
		                  if(0 !== x) return cont(x);
		                  var a = rhs[4], b = lhs[4];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$0[10],
		                           function(x, y, cont){
		                            if(! x) return y ? cont(-1) : cont(0);
		                            var a = x[1];
		                            if(! y) return cont(1);
		                            var b = y[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$0[11], a, b, cont);
		                           },
		                           function(c){
		                            return caml_trampoline_cps_call3
		                                    (c,
		                                     b,
		                                     a,
		                                     function(x){
		                                      if(0 !== x) return cont(x);
		                                      var a = rhs[5], b = lhs[5];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context$0[8],
		       function(x, y, cont){
		        if(! x) return y ? cont(-1) : cont(0);
		        var a = x[1];
		        if(! y) return cont(1);
		        var b = y[1];
		        return caml_trampoline_cps_call3
		                (letrec_function_context$0[9], a, b, cont);
		       },
		       function(c){
		        return caml_trampoline_cps_call3
		                (c,
		                 b,
		                 a,
		                 function(x){
		                  if(0 !== x) return cont(x);
		                  var a = rhs[6], b = lhs[6];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$0[6],
		                           function(x, y, cont){
		                            if(! x) return y ? cont(-1) : cont(0);
		                            var a = x[1];
		                            if(! y) return cont(1);
		                            var b = y[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$0[7], a, b, cont);
		                           },
		                           function(c){
		                            return caml_trampoline_cps_call3
		                                    (c,
		                                     b,
		                                     a,
		                                     function(x){
		                                      if(0 !== x) return cont(x);
		                                      var a = rhs[7], b = lhs[7];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context$0[4],
		       function(x, y, cont){
		        if(! x) return y ? cont(-1) : cont(0);
		        var a = x[1];
		        if(! y) return cont(1);
		        var b = y[1];
		        return caml_trampoline_cps_call3
		                (letrec_function_context$0[5], a, b, cont);
		       },
		       function(c){
		        return caml_trampoline_cps_call3
		                (c,
		                 b,
		                 a,
		                 function(x){
		                  if(0 !== x) return cont(x);
		                  var a = rhs[8], b = lhs[8];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$0[3],
		                           0,
		                           function(c){
		                            return caml_trampoline_cps_call2
		                                    (letrec_function_context$0[2],
		                                     c,
		                                     function(c){
		                                      return caml_trampoline_cps_call3
		      (c,
		       b,
		       a,
		       function(x){
		        return 0 === x
		                ? caml_trampoline_cps_call3
		                  (letrec_function_context$0[1], lhs[9], rhs[9], cont)
		                : cont(x);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     var _16 = Templatable[2], _15$0 = M[10];
		                                     function _14$0(param, a, b, cont){
		                                      return cont(caml_int_compare(a, b));
		                                     }
		                                     var
		                                      _13$0 = M[10],
		                                      _11$0 = M[10],
		                                      _9$0 = M[10],
		                                      _7$0 = M[10],
		                                      _5$0 = M[10],
		                                      _3$0 = M[10],
		                                      _1$0 = M[10];
		                                     caml_update_dummy
		                                      (letrec_function_context$0,
		                                       [0,
		_16,
		_15$0,
		_14$0,
		_13$0,
		compare$105,
		_11$0,
		compare$104,
		_9$0,
		compare_occurrence,
		_7$0,
		compare_integration,
		_5$0,
		compare$101,
		_3$0,
		compare$37,
		_1$0,
		compare$37]);
		                                     function make(g, f, e, d, c, b, a, opt, templatable){
		                                      var
		                                       archived = g ? g[1] : M[5].call(null, 0),
		                                       completed = f ? f[1] : M[5].call(null, 0),
		                                       extension_row = e ? e[1] : M[5].call(null, 0),
		                                       integration = d ? d[1] : M[5].call(null, 0),
		                                       occurrence = c ? c[1] : M[5].call(null, 0),
		                                       parent = b ? b[1] : M[5].call(null, 0),
		                                       scheduled = a ? a[1] : M[5].call(null, 0),
		                                       starred = opt ? opt[1] : M[5].call(null, 0);
		                                      return [0,
		      archived,
		      completed,
		      extension_row,
		      integration,
		      occurrence,
		      parent,
		      scheduled,
		      starred,
		      templatable];
		                                     }
		                                     var letrec_function_context$1 = [];
		                                     function schema_versioned(schematic_version, cont){
		                                      return caml_trampoline_cps_call2
		      (schematic_version,
		       V$4,
		       function(schematic_schema_version){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$1[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  function a(descriptor){
		                   return cont([0, [0, Name[1]], YL, descriptor, 0]);
		                  }
		                  if(! match)
		                   return caml_exact_trampoline_cps_call
		                           (fixpoint,
		                            function(schematic_self, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (find_packed_by_id,
		                                      letrec_function_context$1[1][1],
		                                      schematic_schema_version,
		                                      function(match){
		                                       if(! match)
		return caml_exact_trampoline_cps_call$0
		        (set$3,
		         letrec_function_context$1[1][1],
		         schematic_schema_version,
		         schematic_self,
		         function(a){
		          letrec_function_context$1[1][1] = a;
		          return caml_exact_trampoline_cps_call
		                  (Templatable[4],
		                   schematic_version,
		                   function(b){
		                    var
		                     a =
		                       [0,
		                        [0, YM, 0, 0, 0, cst_templatable, 0, 2, [1, b], 0, 0],
		                        0];
		                    return caml_trampoline_cps_call3
		                            (M[1],
		                             schematic_version,
		                             bool_schema,
		                             function(e){
		                              var
		                               default$ = M[5].call(null, 0),
		                               d =
		                                 [0,
		                                  [0,
		                                   YN,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_starred,
		                                   0,
		                                   [0, default$],
		                                   [0, e],
		                                   0,
		                                   0],
		                                  a];
		                              function c(b){
		                               var
		                                default$ = M[5].call(null, 0),
		                                a =
		                                  [0,
		                                   [0,
		                                    YQ,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_scheduled,
		                                    0,
		                                    [0, default$],
		                                    [0, b],
		                                    0,
		                                    0],
		                                   d];
		                               return caml_exact_trampoline_cps_call
		                                       (option_schema,
		schema_versioned$182(),
		function(b){
		 return caml_trampoline_cps_call3
		         (M[1],
		          schematic_version,
		          b,
		          function(c){
		           var
		            default$ = M[5].call(null, 0),
		            b =
		              [0,
		               [0, YR, 0, 0, 0, cst_parent, 0, [0, default$], [0, c], 0, 0],
		               a];
		           return caml_exact_trampoline_cps_call
		                   (occurrence_schema_versioned,
		                    schematic_version,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (option_schema,
		                              a,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (M[1],
		schematic_version,
		a,
		function(c){
		 var
		  default$ = M[5].call(null, 0),
		  a =
		    [0,
		     [0,
		      YS,
		      0,
		      0,
		      0,
		      cst_occurrence,
		      0,
		      [0, default$],
		      [0, c],
		      0,
		      0],
		     b];
		 return caml_exact_trampoline_cps_call
		         (integration_schema_versioned,
		          schematic_version,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (option_schema,
		                    b,
		                    function(b){
		                     return caml_trampoline_cps_call3
		                             (M[1],
		                              schematic_version,
		                              b,
		                              function(c){
		                               var
		                                default$ = M[5].call(null, 0),
		                                b =
		                                  [0,
		                                   [0,
		                                    YT,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_integration,
		                                    0,
		                                    [0, default$],
		                                    [1, c],
		                                    0,
		                                    0],
		                                   a];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$172,
		schematic_version,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          a,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (M[1],
		                    schematic_version,
		                    a,
		                    function(c){
		                     var
		                      default$ = M[5].call(null, 0),
		                      a =
		                        [0,
		                         [0,
		                          YU,
		                          0,
		                          0,
		                          0,
		                          cst_extension_row,
		                          0,
		                          [0, default$],
		                          [0, c],
		                          0,
		                          0],
		                         b];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$4,
		                              schematic_version,
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (option_schema,
		b,
		function(b){
		 return caml_trampoline_cps_call3
		         (M[1],
		          schematic_version,
		          b,
		          function(c){
		           var
		            default$ = M[5].call(null, 0),
		            b =
		              [0,
		               [0,
		                YV,
		                0,
		                0,
		                0,
		                cst_completed,
		                0,
		                [0, default$],
		                [0, c],
		                0,
		                0],
		               a];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$4,
		                    schematic_version,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (option_schema,
		                              a,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (M[1],
		schematic_version,
		a,
		function(a){
		 var
		  default$ = M[5].call(null, 0),
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       d = c[2],
		       e = d[2],
		       f = e[2],
		       g = f[2],
		       templatable = g[2][1],
		       starred = g[1],
		       scheduled = f[1],
		       parent = e[1],
		       occurrence = d[1],
		       integration = c[1],
		       extension_row = b[1],
		       completed = a[1],
		       archived = param[1];
		      return cont
		              ([0,
		                archived,
		                completed,
		                extension_row,
		                integration,
		                occurrence,
		                parent,
		                scheduled,
		                starred,
		                templatable]);
		     },
		     function(param, cont){
		      var
		       templatable = param[9],
		       starred = param[8],
		       scheduled = param[7],
		       parent = param[6],
		       occurrence = param[5],
		       integration = param[4],
		       extension_row = param[3],
		       completed = param[2],
		       archived = param[1];
		      return cont
		              ([0,
		                archived,
		                [0,
		                 completed,
		                 [0,
		                  extension_row,
		                  [0,
		                   integration,
		                   [0,
		                    occurrence,
		                    [0,
		                     parent,
		                     [0, scheduled, [0, starred, [0, templatable, 0]]]]]]]]]);
		     },
		     [0,
		      [0,
		       YW,
		       0,
		       0,
		       0,
		       cst_ignored,
		       0,
		       [0, default$],
		       [0, a],
		       0,
		       0],
		      b]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$1[1][1],
		          schematic_schema_version,
		          res,
		          function(a){
		           letrec_function_context$1[1][1] = a;
		           return cont(res);
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              }
		                              function b(){
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$185,
		schematic_version,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          a,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (M[1], schematic_version, a, c);
		          });
		});
		                              }
		                              if(! schematic_schema_version) return b();
		                              var version = schematic_schema_version[1];
		                              return caml_exact_trampoline_cps_call$3
		                                      (make$4,
		                                       YP,
		                                       YO,
		                                       0,
		                                       6,
		                                       0,
		                                       function(r){
		return caml_exact_trampoline_cps_call$1
		        (equal$14,
		         version,
		         r,
		         function(d){
		          function a(a){
		           return a
		                   ? caml_trampoline_cps_call3
		                     (M[1], schematic_version, schema_0_6, c)
		                   : b();
		          }
		          return d
		                  ? a(d)
		                  : caml_exact_trampoline_cps_call$1(less_than, version, r, a);
		         });
		                                       });
		                             });
		                   });
		         });
		                                       var schema = match[1];
		                                       return cont(schema);
		                                      });
		                            },
		                            a);
		                  var schema = match[1];
		                  return a(schema);
		                 });
		       });
		                                     }
		                                     var schematic_cache = [0, empty$11([0, comparator$9])];
		                                     caml_update_dummy
		                                      (letrec_function_context$1, [0, schematic_cache]);
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned,
		      function(param, cont){return cont(0);},
		      function(schema){
		       var letrec_function_context = [];
		       function pp(fmt, x, cont){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 YX,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           YY,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     "Task.With_integration.Moded.archived",
		                                     function(b){
		                                      var a = x[1];
		                                      return caml_trampoline_cps_call3
		      (letrec_function_context[15],
		       function(fmt, param, cont){
		        if(! param)
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string, fmt, cst_None, cont);
		        var x = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string,
		                 fmt,
		                 cst_Some,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context[16],
		                           fmt,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     x,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, fmt, cst$18, cont);
		                                     });
		                           });
		                 });
		       },
		       fmt,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           YZ,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     Y0,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Y1,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 cst_completed,
		                 function(b){
		                  var a = x[2];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context[13],
		                           function(fmt, param, cont){
		                            if(! param)
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string, fmt, cst_None, cont);
		                            var x = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string,
		                                     fmt,
		                                     cst_Some,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[14],
		       fmt,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 x,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst$18, cont);
		                 });
		       });
		                                     });
		                           },
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Y2,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 Y3,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Y4,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     cst_extension_row,
		                                     function(b){
		                                      var a = x[3];
		                                      return caml_trampoline_cps_call3
		      (letrec_function_context[11],
		       function(fmt, param, cont){
		        if(! param)
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string, fmt, cst_None, cont);
		        var x = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string,
		                 fmt,
		                 cst_Some,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context[12],
		                           fmt,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     x,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, fmt, cst$18, cont);
		                                     });
		                           });
		                 });
		       },
		       fmt,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Y5,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     Y6,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Y7,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 cst_integration,
		                 function(b){
		                  var a = x[4];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context[9],
		                           function(fmt, param, cont){
		                            if(! param)
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string, fmt, cst_None, cont);
		                            var x = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string,
		                                     fmt,
		                                     cst_Some,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[10],
		       fmt,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 x,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst$18, cont);
		                 });
		       });
		                                     });
		                           },
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Y8,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 Y9,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Y_,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     cst_occurrence,
		                                     function(b){
		                                      var a = x[5];
		                                      return caml_trampoline_cps_call3
		      (letrec_function_context[7],
		       function(fmt, param, cont){
		        if(! param)
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string, fmt, cst_None, cont);
		        var x = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string,
		                 fmt,
		                 cst_Some,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context[8],
		                           fmt,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     x,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, fmt, cst$18, cont);
		                                     });
		                           });
		                 });
		       },
		       fmt,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Y$,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     Za,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Zb,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 cst_parent,
		                 function(b){
		                  var a = x[6];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context[5],
		                           function(fmt, param, cont){
		                            if(! param)
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string, fmt, cst_None, cont);
		                            var x = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string,
		                                     fmt,
		                                     cst_Some,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[6],
		       fmt,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 x,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst$18, cont);
		                 });
		       });
		                                     });
		                           },
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Zc,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 Zd,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Ze,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     cst_scheduled,
		                                     function(b){
		                                      var a = x[7];
		                                      return caml_trampoline_cps_call3
		      (letrec_function_context[3],
		       function(fmt, param, cont){
		        if(! param)
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string, fmt, cst_None, cont);
		        var x = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string,
		                 fmt,
		                 cst_Some,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context[4],
		                           fmt,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     x,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, fmt, cst$18, cont);
		                                     });
		                           });
		                 });
		       },
		       fmt,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Zf,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     Zg,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Zh,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 cst_starred,
		                 function(b){
		                  var a = x[8];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context[2],
		                           function(fmt, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt), Zi, cont);
		                           },
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       Zj,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 Zk,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Zl,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     cst_templatable,
		                                     function(b){
		                                      var a = x[9];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[1],
		       fmt,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           Zm,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt), Zn, cont);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       var
		        _15 = Templatable[6],
		        _14 = M[8],
		        _13 = M[8],
		        _11 = M[8],
		        _9 = M[8],
		        _7 = M[8],
		        _5 = M[8],
		        _3 = M[8],
		        _1 = M[8];
		       caml_update_dummy
		        (letrec_function_context,
		         [0,
		          _15,
		          _14,
		          _13,
		          _12$3,
		          _11,
		          pp_v$0,
		          _9,
		          pp_occurrence,
		          _7,
		          pp_integration,
		          _5,
		          _10$1,
		          _3,
		          _12,
		          _1,
		          _12]);
		       return cont
		               ([0,
		                 Templatable,
		                 equal,
		                 compare,
		                 make,
		                 schema_versioned,
		                 schema,
		                 pp]);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (Moded,
		                                   R$0,
		                                   Read_name,
		                                   function(include){
		                                    var
		                                     Templatable = include[1],
		                                     equal = include[2],
		                                     schema_versioned = include[5],
		                                     schema = include[6],
		                                     a = include[4];
		                                    function make
		                                    (archived,
		                                     completed,
		                                     extension_row,
		                                     integration,
		                                     occurrence,
		                                     parent,
		                                     scheduled,
		                                     starred,
		                                     templatable,
		                                     cont){
		                                     return cont
		     (a
		       ([0, archived],
		        [0, completed],
		        [0, extension_row],
		        [0, integration],
		        [0, occurrence],
		        [0, parent],
		        [0, scheduled],
		        [0, starred],
		        templatable));
		                                    }
		                                    var
		                                     Read =
		                                       [0, Templatable, , , schema_versioned, schema, , , make];
		                                    return caml_exact_trampoline_cps_call$1
		    (Moded,
		     W$0,
		     Patch_name,
		     function(include){
		      var schema = include[6];
		      function make
		      (archived,
		       completed,
		       extension_row,
		       integration,
		       notes,
		       occurrence,
		       parent,
		       scheduled,
		       starred,
		       title,
		       url,
		       param){
		       return [0,
		               archived,
		               completed,
		               extension_row,
		               integration,
		               occurrence,
		               parent,
		               scheduled,
		               starred,
		               [0, notes, title, url]];
		      }
		      function todo(param){
		       if(! param[1] && ! param[2]) return 1;
		       return 0;
		      }
		      var letrec_function_context = [];
		      function equal_with_id(poly_id, lhs, rhs, cont){
		       var y = rhs[1], x = lhs[1];
		       function a(x, y){
		        function c(d){
		         function c(b){
		          function a(d){
		           function c(b){
		            function a(b){
		             function a(a){
		              return a
		                      ? caml_trampoline_cps_call3
		                        (letrec_function_context[1], lhs[7], rhs[7], cont)
		                      : cont(a);
		             }
		             return b
		                     ? caml_trampoline_cps_call3(poly_id, lhs[6], rhs[6], a)
		                     : a(b);
		            }
		            return b
		                    ? caml_trampoline_cps_call3
		                      (letrec_function_context[2], lhs[5], rhs[5], a)
		                    : a(b);
		           }
		           if(! d) return c(d);
		           var y = rhs[4], x = lhs[4];
		           if(x){
		            if(y){
		             var b = y[1], a = x[1];
		             return caml_trampoline_cps_call3
		                     (letrec_function_context[3], a, b, c);
		            }
		           }
		           else if(! y) return c(1);
		           return c(0);
		          }
		          return b
		                  ? caml_trampoline_cps_call3
		                    (letrec_function_context[4], lhs[3], rhs[3], a)
		                  : a(b);
		         }
		         if(! d) return c(d);
		         var y = rhs[2], x = lhs[2];
		         if(x){
		          if(y){
		           var b = y[1], a = x[1];
		           return caml_trampoline_cps_call3
		                   (letrec_function_context[5], a, b, c);
		          }
		         }
		         else if(! y) return c(1);
		         return c(0);
		        }
		        if(x){
		         if(y){
		          var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		          return caml_trampoline_cps_call3
		                  (letrec_function_context[6],
		                   a$0,
		                   b,
		                   function(b){
		                    return b ? caml_exact_trampoline_call2(a, x$0, y$0) : c(b);
		                   });
		         }
		        }
		        else if(! y) return c(1);
		        return c(0);
		       }
		       return a(x, y);
		      }
		      caml_update_dummy
		       (letrec_function_context,
		        [0,
		         equal,
		         equal$76,
		         equal$20,
		         equal$20,
		         equal$103,
		         equal$51]);
		      function make_with_id
		      (a, opt, created, deleted, etag, id, writable, cont){
		       var allocations = a ? a[1] : 0, client = opt ? opt[1] : 0;
		       return cont
		               ([0,
		                 allocations,
		                 client,
		                 created,
		                 deleted,
		                 etag,
		                 id,
		                 writable]);
		      }
		      function with_id_schema_versioned(schematic_version, cont){
		       return caml_trampoline_cps_call2
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return cont
		                         (function(schematic_param_id_schema_vers, cont){
		                           function descriptor(schematic_param_id_schema_vers, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_id,
		   0,
		   2,
		   [0, schematic_param_id_schema_vers],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$141,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_etag, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_deleted, 0, 3, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$4,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$180,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(a){
		        var default$ = match$137[1], default$0 = match$138[1];
		        return cont
		                ([7,
		                  function(param, cont){
		                   var
		                    a = param[2],
		                    b = a[2],
		                    c = b[2],
		                    d = c[2],
		                    e = d[2],
		                    writable = e[2][1],
		                    id = e[1],
		                    etag = d[1],
		                    deleted = c[1],
		                    created = b[1],
		                    client = a[1],
		                    allocations = param[1];
		                   return cont
		                           ([0,
		                             allocations,
		                             client,
		                             created,
		                             deleted,
		                             etag,
		                             id,
		                             writable]);
		                  },
		                  function(param, cont){
		                   var
		                    writable = param[7],
		                    id = param[6],
		                    etag = param[5],
		                    deleted = param[4],
		                    created = param[3],
		                    client = param[2],
		                    allocations = param[1];
		                   return cont
		                           ([0,
		                             allocations,
		                             [0,
		                              client,
		                              [0,
		                               created,
		                               [0, deleted, [0, etag, [0, id, [0, writable, 0]]]]]]]);
		                  },
		                  [0,
		                   [0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    cst_allocations,
		                    0,
		                    [0, default$0],
		                    [0, [0, 0, 0, [3, schema$263], 0]],
		                    0,
		                    0],
		                   [0,
		                    [0, 0, 0, 0, 0, cst_client, 0, [0, default$], [0, a], 0, 0],
		                    b]]]);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           var
		                            schematic_schema_id = match$139[1],
		                            schematic_parametric =
		                              [0,
		                               [1,
		                                cst_id,
		                                schematic_param_id_schema_vers,
		                                function(schematic_param_id_schema_vers, cont){
		                                 return caml_exact_trampoline_cps_call
		 (descriptor,
		  schematic_param_id_schema_vers,
		  function(a){return cont([0, schematic_schema_id, a]);});
		                                }]];
		                           return caml_exact_trampoline_cps_call
		                                   (descriptor,
		                                    schematic_param_id_schema_vers,
		                                    function(a){
		                                     var parametric = schematic_parametric[1];
		                                     return caml_exact_trampoline_cps_call
		     (of_parametric,
		      parametric,
		      function(match){
		       function b(b){
		        return cont([0, b, Zo, a, schematic_parametric]);
		       }
		       if(! match) return b(0);
		       var name = match[1];
		       return caml_exact_trampoline_cps_call
		               (to_id, name, function(a){return b([0, a]);});
		      });
		                                    });
		                          });
		                });
		      }
		      var letrec_function_context$0 = [];
		      function equal$0(x, cont){
		       return caml_trampoline_cps_call2
		               (letrec_function_context$0[1],
		                letrec_function_context$0[2],
		                function(a){return caml_trampoline_cps_call2(a, x, cont);});
		      }
		      caml_update_dummy
		       (letrec_function_context$0, [0, equal_with_id, equal$55]);
		      function schema_versioned$0(schematic_version, cont){
		       return caml_trampoline_cps_call2
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$109,
		                          schematic_version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (with_id_schema_versioned,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (b, a, function(a){return cont([0, Zq, Zp, a[3], a[4]]);});
		                                    });
		                          });
		                });
		      }
		      var Patch = [0, , , , , schema, , , make];
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$0,
		               function(param, cont){return cont(0);},
		               function(schema){
		                return cont
		                        ([0,
		                          ,
		                          ,
		                          ,
		                          integration_schema_versioned,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Read,
		                          Patch,
		                          todo,
		                          ,
		                          ,
		                          ,
		                          with_id_schema_versioned,
		                          ,
		                          ,
		                          ,
		                          equal$0,
		                          ,
		                          schema_versioned$0,
		                          schema,
		                          ,
		                          ,
		                          ,
		                          make_with_id]);
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$325 = [];
		               function pp$71(fmt, param, cont){
		                if(0 === param[0]){
		                 var a0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Zr,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$325[2],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      a0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), Zs, cont);
		      });
		                                    });
		                          });
		                }
		                var a0$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         Zt,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$325[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0$0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), Zu, cont);
		     });
		                                   });
		                         });
		               }
		               var _1$32 = Task_recurrent[1];
		               caml_update_dummy
		                (letrec_function_context$325, [0, _1$32, _16$0]);
		               var
		                T$2 =
		                  caml_callback
		                   (With_integration,
		                    [[0, compare$29, equal$15, _16, schema_versioned]]),
		                integration_schema_versioned = T$2[4],
		                Read$0 = T$2[9],
		                Patch = T$2[10],
		                todo = T$2[11],
		                with_id_schema_versioned = T$2[15],
		                equal$106 = T$2[19],
		                schema_versioned$186 = T$2[21],
		                schema$68 = T$2[22],
		                make$41 = T$2[26];
		               function make_from_fresh_todo
		               (checked, created, opt, parent, content, cont){
		                var id = opt ? opt[1] : make$31();
		                if(is_empty$0(content)) return cont(0);
		                var
		                 completed = some_if(checked, created),
		                 a = Read$0[1][3].call(null, 0, 0, content);
		                return caml_trampoline_cps_call9
		                        (Read$0[8],
		                         0,
		                         completed,
		                         0,
		                         0,
		                         0,
		                         parent,
		                         0,
		                         0,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (b,
		                                   a,
		                                   function(b){
		                                    var a = make$34(0, created);
		                                    return caml_trampoline_cps_call4
		    (make$41,
		     0,
		     0,
		     created,
		     function(c){
		      return caml_trampoline_cps_call4
		              (c,
		               0,
		               a,
		               id,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a, b, function(task){return cont([0, task]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function Moded$3(M, Name, Task_name, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Templatable_moded,
		                         M,
		                         Task_name,
		                         function(Templatable){
		                          var letrec_function_context = [];
		                          function equal(lhs, rhs, cont){
		                           var a = rhs[1], b = lhs[1];
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[4],
		                                    function(x, y, cont){
		                                     if(x){
		                                      if(y){
		                                       var b = y[1], a = x[1];
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context[5], a, b, cont);
		                                      }
		                                     }
		                                     else if(! y) return cont(1);
		                                     return cont(0);
		                                    },
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (c,
		      b,
		      a,
		      function(b){
		       function a(a){
		        return a
		                ? caml_trampoline_cps_call3
		                  (letrec_function_context[1], lhs[3], rhs[3], cont)
		                : cont(a);
		       }
		       if(! b) return a(b);
		       var c = rhs[2], d = lhs[2];
		       return caml_trampoline_cps_call2
		               (letrec_function_context[2],
		                letrec_function_context[3],
		                function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		      });
		                                    });
		                          }
		                          var _4 = Templatable[1], _3 = M[9], _1 = M[9];
		                          caml_update_dummy
		                           (letrec_function_context,
		                            [0, _4, _3, equal$32, _1, equal$104]);
		                          function make(opt, recurrence, templatable){
		                           var parent = opt ? opt[1] : M[5].call(null, 0);
		                           return [0, parent, recurrence, templatable];
		                          }
		                          var letrec_function_context$0 = [];
		                          function schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$4,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$0[1][1],
		      schematic_schema_version,
		      function(match){
		       function a(descriptor){
		        return cont([0, [0, Name[1]], 0, descriptor, 0]);
		       }
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context$0[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context$0[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context$0[1][1] = a;
		                                       return caml_exact_trampoline_cps_call
		       (Templatable[4],
		        schematic_version,
		        function(b){
		         var
		          a =
		            [0, [0, 0, 0, 0, 0, cst_templatable, 0, 2, [1, b], 0, 0], 0];
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$15,
		                  schematic_version,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            b,
		                            function(c){
		                             var b = M[6].call(null, 0), c = [0, c];
		                             if(b) var default$ = b[1], b = [0, default$]; else b = 2;
		                             var
		                              d = [0, [0, 0, 0, 0, 0, cst_recurrence, 0, b, c, 0, 0], a];
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      schema_versioned$182(),
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(a){
		         var
		          default$ = M[5].call(null, 0),
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               templatable = a[2][1],
		               recurrence = a[1],
		               parent = param[1];
		              return cont([0, parent, recurrence, templatable]);
		             },
		             function(param, cont){
		              var
		               templatable = param[3],
		               recurrence = param[2],
		               parent = param[1];
		              return cont
		                      ([0, parent, [0, recurrence, [0, templatable, 0]]]);
		             },
		             [0,
		              [0, 0, 0, 0, 0, cst_parent, 0, [0, default$], [0, a], 0, 0],
		              d]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$0[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$0[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 a);
		       var schema = match[1];
		       return a(schema);
		      });
		                                    });
		                          }
		                          var schematic_cache = [0, empty$11([0, comparator$9])];
		                          caml_update_dummy
		                           (letrec_function_context$0, [0, schematic_cache]);
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(schema){
		                                    var letrec_function_context = [];
		                                    function pp(fmt, x, cont){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      Zv,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Zw,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          "Task_recurrent.Moded.parent",
		                          function(b){
		                           var a = x[1];
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context[4],
		                                    function(fmt, param, cont){
		                                     if(! param)
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, fmt, cst_None, cont);
		                                     var x = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string,
		      fmt,
		      cst_Some,
		      function(a){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[5],
		                fmt,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          x,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst$18, cont);
		                          });
		                });
		      });
		                                    },
		                                    fmt,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                Zx,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          Zy,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    Zz,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_recurrence,
		      function(b){
		       var a = x[2];
		       return caml_trampoline_cps_call3
		               (letrec_function_context[2],
		                function(fmt, cont){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[3], fmt, cont);
		                },
		                fmt,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ZA,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ZB,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ZC,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_templatable,
		                          function(b){
		                           var a = x[3];
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[1],
		                                    fmt,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ZD,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), ZE, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var _4 = Templatable[6], _3 = M[8], _1 = M[8];
		                                    caml_update_dummy
		                                     (letrec_function_context, [0, _4, _3, pp$23, _1, pp_v$0]);
		                                    return cont
		    ([0, , equal, , make, schema_versioned, schema, pp]);
		                                   });
		                         });
		               }
		               var
		                Read$5 =
		                  caml_callback
		                   (Moded$3, [R$0, [0, "task-recurrent-read"], Read_name]),
		                include$294 =
		                  caml_callback
		                   (Moded$3, [W$0, [0, "task-recurrent-patch"], Patch_name]),
		                schema$69 = include$294[6],
		                pp$72 = Task_recurrent[1],
		                schema_versioned$187 = Task_recurrent[4],
		                schema$70 = Task_recurrent[5],
		                symbol$150 = Task_recurrent[9],
		                symbol$151 = Task_recurrent[10],
		                symbol$152 = Task_recurrent[11],
		                symbol$153 = Task_recurrent[12],
		                symbol$154 = Task_recurrent[13],
		                symbol$155 = Task_recurrent[14],
		                equal$107 = Task_recurrent[15],
		                compare$106 = Task_recurrent[16],
		                min$21 = Task_recurrent[17],
		                max$23 = Task_recurrent[18],
		                ascending$12 = Task_recurrent[19],
		                descending$12 = Task_recurrent[20],
		                between$13 = Task_recurrent[21],
		                clamp_exn$12 = Task_recurrent[22],
		                clamp$12 = Task_recurrent[23],
		                comparator$28 = Task_recurrent[24],
		                By$11 = Task_recurrent[27],
		                make$42 = Task_recurrent[29],
		                to_bytes$0 = Task_recurrent[32],
		                letrec_function_context$326 = [];
		               function equal$108(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$326[5],
		                         lhs[1],
		                         rhs[1],
		                         function(d){
		                          function c(b){
		                           function a(b){
		                            function a(a){
		                             return a
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$326[1], lhs[5], rhs[5], cont)
		                                     : cont(a);
		                            }
		                            return b
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$326[2], lhs[4], rhs[4], a)
		                                    : a(b);
		                           }
		                           return b
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$326[3], lhs[3], rhs[3], a)
		                                   : a(b);
		                          }
		                          if(! d) return c(d);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$326[4], a, b, c);
		                           }
		                          }
		                          else if(! y) return c(1);
		                          return c(0);
		                         });
		               }
		               var _4$4 = Read$5[2];
		               caml_update_dummy
		                (letrec_function_context$326,
		                 [0, _4$4, equal$107, equal$76, equal$20, equal$20]);
		               var letrec_function_context$327 = [];
		               function schema_versioned$188(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$327[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ZG, ZF, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$327[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$327[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$327[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Read$5[5],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$187,
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$141,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_etag, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$4,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_deleted, 0, 3, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    writable = c[2][1],
		    id = c[1],
		    etag = b[1],
		    deleted = a[1],
		    created = param[1];
		   return cont([0, created, deleted, etag, id, writable]);
		  },
		  function(param, cont){
		   var
		    writable = param[5],
		    id = param[4],
		    etag = param[3],
		    deleted = param[2],
		    created = param[1];
		   return cont
		           ([0,
		             created,
		             [0, deleted, [0, etag, [0, id, [0, writable, 0]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$327[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$327[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$372 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$327, [0, schematic_cache$372]);
		               var
		                schema$71 =
		                  caml_callback
		                   (schema_versioned$188,
		                    [function(param, cont){return cont(0);}]);
		               function salt_date(date, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_time$0,
		                         timezone,
		                         epoch,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$85,
		                                   date,
		                                   a,
		                                   function(s){
		                                    var n = s[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$23,
		     n,
		     255,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (of_int_exn,
		               a,
		               function(b0){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$23,
		                         n / 255 | 0,
		                         255,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_int_exn,
		                                   a,
		                                   function(b1){
		                                    var a = 0 <= n ? 0 : 1;
		                                    return caml_exact_trampoline_cps_call
		    (of_int_exn,
		     a,
		     function(b2){
		      var l = [0, b0, [0, b1, [0, b2, 0]]];
		      return caml_exact_trampoline_cps_call
		              (length$1,
		               l,
		               function(b){
		                var t$0 = caml_create_bytes(b), init = 0, t = l;
		                for(;;){
		                 if(! t) return cont(t$0);
		                 var l$0 = t[2], a = t[1];
		                 caml_bytes_set(t$0, init, a);
		                 var init$0 = init + 1 | 0;
		                 init = init$0;
		                 t = l$0;
		                }
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make$43(created, id, parent, recurrence, templatable){
		                var
		                 writable =
		                   Read$5[4].call(null, parent, recurrence, templatable),
		                 t = ocaml_ptime_clock_now_d_ps(),
		                 etag = make$34(0, t);
		                return [0, created, 0, etag, id, writable];
		               }
		               function equal$109(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var letrec_function_context$328 = [];
		               function schema_versioned$189(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$328[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ZH, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$328[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$328[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$328[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(ZN);},
		                                  0,
		                                  0,
		                                  cst_initializing,
		                                  "Initializing",
		                                  [0, ao[1], ZM, ao[3], ao[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(ZL) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_synchronizing,
		                                   cst_Synchronizing,
		                                   [0, an[1], ZK, an[3], an[4]],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(ZJ) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_synchronized,
		                                    "Synchronized",
		                                    [0, am[1], ZI, am[3], am[4]],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$328[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$328[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$373 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$328, [0, schematic_cache$373]);
		               caml_callback
		                (schema_versioned$189,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$190(a, l, param){return l;}
		               function equal$110(l, param, cont){return cont(l);}
		               function pp$73(l, param, cont){return cont(l);}
		               function return$21(l, param, cont){return cont(l);}
		               function map$35(l, param, cont){return cont(l);}
		               function both$1(a, b){return [0, a, b];}
		               function schema_versioned$191(a, param, r){return r;}
		               function equal$111(param, r, cont){return cont(r);}
		               function pp$74(param, r, cont){return cont(r);}
		               function return$22(param, r, cont){return cont(r);}
		               function map$36(param, r, cont){return cont(r);}
		               function both$2(a, b){return [0, a, b];}
		               function of_string$43(email, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (lsplit2,
		                         email,
		                         64,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    fail,
		                                    format$18,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(a, email, cont);
		                                    });
		                          var email$0 = match[1];
		                          return cont([0, email$0]);
		                         });
		               }
		               function to_string$51(param, cont){
		                var domain = param[2], name = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$96,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, name, domain, cont);
		                         });
		               }
		               var letrec_function_context$329 = [];
		               function compare$107(a, param, cont){
		                var
		                 rhs1 = param[2],
		                 rhs0 = param[1],
		                 lhs1 = a[2],
		                 lhs0 = a[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$329[2],
		                         0,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   lhs0,
		                                   rhs0,
		                                   function(x){
		                                    return 0 === x
		    ? caml_trampoline_cps_call2
		      (letrec_function_context$329[1],
		       0,
		       function(a){
		        return caml_trampoline_cps_call3(a, lhs1, rhs1, cont);
		       })
		    : cont(x);
		                                   });
		                         });
		               }
		               function _1$33(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _0$33(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$329, [0, _1$33, _0$33]);
		               function sexp_of_t$47(email, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$51, email, function(a){return cont([0, a]);});
		               }
		               var
		                include$76 = Make$2([0, compare$107, sexp_of_t$47]),
		                symbol$156 = include$76[3],
		                equal$112 = include$76[7],
		                compare$108 = include$76[8],
		                comparator$29 = include$76[16],
		                h =
		                  map$14
		                   (of_string$43, to_string$51, schematic_param_name_schema_ve),
		                schema$72 = [0, ZO, h[2], h[3], h[4]];
		               function schema_versioned$192(param, cont){return cont(schema$72);
		               }
		               function pp$75(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, to_string$51, a, b, cont);
		               }
		               function of_google_id(id, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (compose,
		                         ok_or_failwith,
		                         of_string$43,
		                         to_string$43(id),
		                         cont);
		               }
		               caml_callback(M$2, [[0, comparator$29, schema_versioned$192]]);
		               function personal_organization_of_user_(id, cont){
		                var
		                 s2 = to_nanoid$1(id),
		                 s2$0 = cst$21 + s2,
		                 raw_id = name$14 + s2$0;
		                return caml_exact_trampoline_cps_call
		                        (of_string$24,
		                         raw_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (ok_or_failwith, a, cont);
		                         });
		               }
		               function compare$109(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  case 2:
		                   if(2 === rhs) return cont(0); break;
		                  case 3:
		                   if(3 === rhs) return cont(0); break;
		                  case 4:
		                   if(4 === rhs) return cont(0); break;
		                  case 5:
		                   if(5 === rhs) return cont(0); break;
		                  case 6:
		                   if(6 === rhs) return cont(0); break;
		                  case 7:
		                   if(7 === rhs) return cont(0); break;
		                  case 8:
		                   if(8 === rhs) return cont(0); break;
		                  case 9:
		                   if(9 === rhs) return cont(0); break;
		                  default: if(10 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   case 6:
		                    return 6;
		                   case 7:
		                    return 7;
		                   case 8:
		                    return 8;
		                   case 9:
		                    return 9;
		                   default: return 10;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var
		                cst_Member_invite = "Member_invite",
		                cst_Rename = "Rename",
		                cst_Workspace_create = "Workspace_create",
		                letrec_function_context$330 = [];
		               function schema_versioned$193(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$330[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ZP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$330[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$330[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$330[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(Z$);},
		                                  0,
		                                  0,
		                                  cst_delete,
		                                  cst_Delete,
		                                  [0, az[1], Z_, az[3], az[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(Z9) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_member_invite,
		                                   cst_Member_invite,
		                                   [0, ay[1], Z8, ay[3], ay[4]],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(Z7) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_member_remove,
		                                    "Member_remove",
		                                    [0, ax[1], Z6, ax[3], ax[4]],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(Z5) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_member_uninvite,
		                                     "Member_uninvite",
		                                     [0, aw[1], Z4, aw[3], aw[4]],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(Z3) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_rename,
		                                      cst_Rename,
		                                      [0, av[1], Z2, av[3], av[4]],
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(Z1) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_workspace_create,
		                                       cst_Workspace_create,
		                                       [0, au[1], Z0, au[3], au[4]],
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(ZZ) : cont(0);
		},
		0,
		0,
		cst_workspace_member_add,
		"Workspace_member_add",
		[0, at[1], ZY, at[3], at[4]],
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 === param ? cont(ZX) : cont(0);
		 },
		 0,
		 0,
		 cst_workspace_member_remove,
		 "Workspace_member_remove",
		 [0, as[1], ZW, as[3], as[4]],
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(8);},
		  function(param, cont){
		   return 8 === param ? cont(ZV) : cont(0);
		  },
		  0,
		  0,
		  cst_workspace_member_set_role,
		  "Workspace_member_set_role",
		  [0, ar[1], ZU, ar[3], ar[4]],
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(9);},
		   function(param, cont){
		    return 9 === param ? cont(ZT) : cont(0);
		   },
		   0,
		   0,
		   cst_workspace_remove,
		   "Workspace_remove",
		   [0, aq[1], ZS, aq[3], aq[4]],
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(10);},
		    function(param, cont){
		     return 10 <= param ? cont(ZR) : cont(0);
		    },
		    0,
		    0,
		    cst_workspace_rename,
		    "Workspace_rename",
		    [0, ap[1], ZQ, ap[3], ap[4]],
		    0],
		   0]]]]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$330[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$330[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$374 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$330, [0, schematic_cache$374]);
		               caml_callback
		                (schema_versioned$193,
		                 [function(param, cont){return cont(0);}]);
		               function pp$76(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Delete",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Member_invite",
		                            cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Member_remove",
		                            cont);
		                  case 3:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Member_uninvite",
		                            cont);
		                  case 4:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Rename",
		                            cont);
		                  case 5:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Workspace_create",
		                            cont);
		                  case 6:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Workspace_member_add",
		                            cont);
		                  case 7:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Workspace_member_remove",
		                            cont);
		                  case 8:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Workspace_member_set_role",
		                            cont);
		                  case 9:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Workspace_remove",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Organization.Permission.T.Workspace_rename",
		                            cont);
		                }
		               }
		               function sexp_of_t$48(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$97,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$76, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$77 = Make$2([0, compare$109, sexp_of_t$48]),
		                comparator$30 = include$77[16],
		                T$3 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$76, comparator$30, schema_versioned$193]]),
		                of_list$7 = T$3[75];
		               function schematic_version$55(param, cont){return cont(0);}
		               caml_callback(T$3[70], [schematic_version$55]);
		               function equal$113(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               var letrec_function_context$331 = [];
		               function schema_versioned$194(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$331[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _b, _a, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$331[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$331[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$331[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(_f);},
		                                  0,
		                                  0,
		                                  cst_member,
		                                  cst_Member,
		                                  [0, aB[1], _e, aB[3], aB[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(_d) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_owner,
		                                   cst_Owner,
		                                   [0, aA[1], _c, aA[3], aA[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$331[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$331[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$375 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$331, [0, schematic_cache$375]);
		               caml_callback
		                (schema_versioned$194,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$332 = [];
		               function equal$114(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$332[3],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(b){
		                           function a(c){
		                            if(! c) return cont(c);
		                            var b = rhs[4], a = lhs[4];
		                            return cont(a === b ? 1 : 0);
		                           }
		                           return b
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$332[1], lhs[3], rhs[3], a)
		                                   : a(b);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$332[2], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$332,
		                 [0, equal$59, equal$57, equal$113]);
		               var letrec_function_context$333 = [];
		               function schema_versioned$195(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$333[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _g, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$333[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$333[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$333[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 _h,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, _i, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$115,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, _j, 0, 0, 0, cst_email, 0, 2, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$194,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        name = b[2][1],
		                        id = b[1],
		                        email = a[1],
		                        access_role = param[1];
		                       return cont([0, access_role, email, id, name]);
		                      },
		                      function(param, cont){
		                       var
		                        name = param[4],
		                        id = param[3],
		                        email = param[2],
		                        access_role = param[1];
		                       return cont
		                               ([0, access_role, [0, email, [0, id, [0, name, 0]]]]);
		                      },
		                      [0,
		                       [0, _k, 0, 0, 0, cst_access_role, 0, 2, [0, b], 0, 0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$333[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$333[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$376 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$333, [0, schematic_cache$376]);
		               var
		                schema$73 =
		                  caml_callback
		                   (schema_versioned$195,
		                    [function(param, cont){return cont(0);}]),
		                Impl$1 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$44, comparator$22, schema_versioned$117]]),
		                singleton$5 = Impl$1[112],
		                letrec_function_context$334 = [];
		               function equal$115(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$334[1],
		                         letrec_function_context$334[2],
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               var _1$34 = Impl$1[55];
		               caml_update_dummy
		                (letrec_function_context$334, [0, _1$34, equal$114]);
		               function schema_versioned$196(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$195,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (Impl$1[109],
		     schematic_version,
		     a,
		     function(a){return cont([0, _l, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$196,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$78 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$75, comparator$29, schema_versioned$192]]),
		                equal$116 = include$78[16],
		                members_pending = include$78[72],
		                bRc = include$78[70];
		               function schema_versioned$197(version, cont){
		                return caml_exact_trampoline_cps_call
		                        (bRc,
		                         version,
		                         function(a){return cont([0, 0, a[2], a[3], a[4]]);});
		               }
		               caml_callback
		                (schema_versioned$197,
		                 [function(param, cont){return cont(0);}]);
		               function Moded$4(M, Ref, Name){
		                var letrec_function_context = [];
		                function equal(poly_id, lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[2],
		                          poly_id,
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(a){
		                                     if(! a) return cont(a);
		                                     var b = rhs[2], c = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[1],
		      function(a, b, cont){return cont(a === b ? 1 : 0);},
		      function(a){
		       return caml_trampoline_cps_call3(a, c, b, cont);
		      });
		                                    });
		                          });
		                }
		                var _1 = M[9], _0 = M[9];
		                caml_update_dummy(letrec_function_context, [0, _1, _0]);
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return cont
		                                   (function(schematic_param_id_schema_vers, cont){
		                                     function descriptor(schematic_param_id_schema_vers, cont){
		                                      return caml_trampoline_cps_call3
		      (M[1],
		       schematic_version,
		       schematic_param_name_schema_ve,
		       function(b){
		        var
		         a = [0, [0, _m, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], 0];
		        return caml_trampoline_cps_call3
		                (M[1],
		                 schematic_version,
		                 schematic_param_id_schema_vers,
		                 function(b){
		                  return cont
		                          ([7,
		                            function(param, cont){
		                             var name = param[2][1], owner = param[1];
		                             return cont([0, owner, name]);
		                            },
		                            function(param, cont){
		                             var name = param[2], owner = param[1];
		                             return cont([0, owner, [0, name, 0]]);
		                            },
		                            [0, [0, _n, 0, 0, 0, cst_owner, 0, 2, [0, b], 0, 0], a]]);
		                 });
		       });
		                                     }
		                                     var match = Name[1];
		                                     if(match)
		                                      var
		                                       schematic_schema_id = match[1],
		                                       schematic_parametric =
		 [0,
		  [1,
		   cst_id,
		   schematic_param_id_schema_vers,
		   function(schematic_param_id_schema_vers, cont){
		    return caml_exact_trampoline_cps_call
		            (descriptor,
		             schematic_param_id_schema_vers,
		             function(a){return cont([0, schematic_schema_id, a]);});
		   }]];
		                                     else
		                                      schematic_parametric = 0;
		                                     return caml_exact_trampoline_cps_call
		     (descriptor,
		      schematic_param_id_schema_vers,
		      function(b){
		       function a(a){
		        return cont([0, a, 0, b, schematic_parametric]);
		       }
		       if(schematic_parametric){
		        var parametric = schematic_parametric[1];
		        return caml_exact_trampoline_cps_call
		                (of_parametric,
		                 parametric,
		                 function(match){
		                  if(! match) return a(0);
		                  var name = match[1];
		                  return caml_exact_trampoline_cps_call
		                          (to_id, name, function(b){return a([0, b]);});
		                 });
		       }
		       var match = Name[1];
		       if(! match) return a(0);
		       var id = match[1];
		       return caml_exact_trampoline_cps_call$1
		               (combine, schematic_param_id_schema_vers, id, a);
		      });
		                                    });
		                          });
		                }
		                return [0, equal, , schema_versioned];
		               }
		               var Read$6 = Moded$4(R$0, Left, [0, name$5]);
		               Moded$4(W$0, Left, [0, name$6]);
		               function is_personal(user, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (personal_organization_of_user_,
		                         user,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$115, a, id, cont);
		                         });
		               }
		               var letrec_function_context$335 = [];
		               function equal$117(poly_subscription, lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$335[4],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(d){
		                           function c(a){
		                            if(! a) return cont(a);
		                            var b = rhs[4], c = lhs[4];
		                            return caml_trampoline_cps_call2
		                                    (letrec_function_context$335[1],
		                                     letrec_function_context$335[2],
		                                     function(a){
		                                      return caml_trampoline_cps_call3(a, c, b, cont);
		                                     });
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3(poly_subscription, a, b, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$335[3], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               var _3$9 = Read$6[1];
		               caml_update_dummy
		                (letrec_function_context$335,
		                 [0, _3$9, equal$59, equal$53, equal$20]);
		               function schema_versioned$198(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_subscription_s, cont){
		                                    function descriptor(schematic_param_subscription_s, cont){
		                                     var
		                                      a =
		[0,
		 [0, 0, 0, 0, 0, cst_personal, 0, 0, [0, bool_schema], 0, 0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$117,
		      schematic_version,
		      function(b){
		       return caml_trampoline_cps_call3
		               (Read$6[3],
		                schematic_version,
		                b,
		                function(c){
		                 var
		                  b =
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_subscription,
		                      0,
		                      3,
		                      [0, schematic_param_subscription_s],
		                      0,
		                      0],
		                     [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, c], 0, 0], a]];
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$104,
		                          schematic_version,
		                          function(c){
		                           var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$4,
		                                    schematic_version,
		                                    function(b){
		                                     return cont
		     ([7,
		       function(param, cont){
		        var
		         a = param[2],
		         b = a[2],
		         writable = b[2][1],
		         subscription = b[1],
		         id = a[1],
		         created = param[1];
		        return cont([0, created, id, subscription, writable]);
		       },
		       function(param, cont){
		        var
		         writable = param[4],
		         subscription = param[3],
		         id = param[2],
		         created = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (is_personal,
		                 writable[1],
		                 id,
		                 function(a){
		                  return cont
		                          ([0,
		                            created,
		                            [0, id, [0, subscription, [0, writable, [0, [0, a], 0]]]]]);
		                 });
		       },
		       [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, b], 0, 0], a]]);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$140[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_subscription,
		 schematic_param_subscription_s,
		 function(schematic_param_subscription_s, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_subscription_s,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_subscription_s,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, _o, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$336 = [];
		               function equal_org(poly_a, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$336[1], poly_a, cont);
		               }
		               caml_update_dummy(letrec_function_context$336, [0, equal$117]);
		               function org_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$198,
		     schematic_version,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (a,
		               schematic_param_a_schema_versi,
		               function(init){
		                var id = match$141[1], a = init[4], b = init[3];
		                return caml_exact_trampoline_cps_call$1
		                        (combine,
		                         schematic_param_a_schema_versi,
		                         id,
		                         function(c){return cont([0, c, 0, b, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$337 = [];
		               function equal_workspaces(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$337[1],
		                         letrec_function_context$337[2],
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               var _1$35 = By$8[53];
		               caml_update_dummy
		                (letrec_function_context$337, [0, _1$35, equal$62]);
		               function workspaces_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$121,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (By$8[102],
		     schematic_version,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (workspaces_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$338 = [];
		               function equal$118(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$338[4],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(b){
		                           function a(a){
		                            return a
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$338[1], lhs[4], rhs[4], cont)
		                                    : cont(a);
		                           }
		                           if(! b) return a(b);
		                           var c = rhs[3], d = lhs[3];
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$338[2],
		                                    function(a, b, cont){return cont(a === b ? 1 : 0);},
		                                    function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$338[3], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$338,
		                 [0, equal_workspaces, equal_org, equal$116, equal$115]);
		               var
		                cst_members_pending$0 = "members_pending",
		                letrec_function_context$339 = [];
		               function schema_versioned$199(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$339[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _p, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$339[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$339[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$339[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (workspaces_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_workspaces, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (org_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_organization, 0, 2, [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$197,
		                           schematic_version,
		                           function(c){
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_members_pending$0, 0, 2, [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$196,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    workspaces = b[2][1],
		    organization = b[1],
		    members_pending = a[1],
		    members = param[1];
		   return cont
		           ([0, members, members_pending, organization, workspaces]);
		  },
		  function(param, cont){
		   var
		    workspaces = param[4],
		    organization = param[3],
		    members_pending = param[2],
		    members = param[1];
		   return cont
		           ([0,
		             members,
		             [0, members_pending, [0, organization, [0, workspaces, 0]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_members, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$339[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$339[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$377 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$339, [0, schematic_cache$377]);
		               var
		                schema$74 =
		                  caml_callback
		                   (schema_versioned$199,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (of_string_exn, ["0.21.8-beta.1.subscription-token"]);
		               var letrec_function_context$340 = [];
		               function schema_versioned$200(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$340[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _q, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$340[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$340[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$340[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_start_date, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, _r, 0, 0, 0, cst_until, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (status_schema_versioned$3,
		                 schematic_version,
		                 function(c){
		                  var
		                   default$ = match$142[1],
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_status, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (Id$0[1],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, _s, 0, 0, 0, cst_quantity, 0, 3, [0, int_schema], 0, 0],
		                                [0, [0, 0, 0, 0, 0, cst_product, 0, 2, [0, c], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$1[1],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_price, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(b){
		        var
		         default$ = match$143[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              start_date = f[2][1],
		              until = f[1],
		              status = e[1],
		              product = d[1],
		              quantity = c[1],
		              price = b[1],
		              org = a[1],
		              canceled = param[1];
		             return cont
		                     ([0,
		                       canceled,
		                       org,
		                       price,
		                       quantity,
		                       product,
		                       status,
		                       until,
		                       start_date]);
		            },
		            function(param, cont){
		             var
		              start_date = param[8],
		              until = param[7],
		              status = param[6],
		              product = param[5],
		              quantity = param[4],
		              price = param[3],
		              org = param[2],
		              canceled = param[1];
		             return cont
		                     ([0,
		                       canceled,
		                       [0,
		                        org,
		                        [0,
		                         price,
		                         [0,
		                          quantity,
		                          [0, product, [0, status, [0, until, [0, start_date, 0]]]]]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_canceled,
		              0,
		              [0, default$],
		              [0, bool_schema],
		              0,
		              0],
		             [0, [0, 0, 0, 0, 0, cst_org, 0, 2, [0, b], 0, 0], a]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$340[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$340[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$378 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$340, [0, schematic_cache$378]);
		               var
		                schema$75 =
		                  caml_callback
		                   (schema_versioned$200,
		                    [function(param, cont){return cont(0);}]),
		                cst_Meetings = "Meetings",
		                letrec_function_context$341 = [];
		               function schema_versioned$201(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$341[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _t, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$341[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$341[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$341[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(_z);},
		                                  0,
		                                  0,
		                                  cst_focus,
		                                  "Focus",
		                                  _y,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(_x) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_meetings,
		                                   cst_Meetings,
		                                   _w,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(_v) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_processing,
		                                    "Processing",
		                                    _u,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$341[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$341[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$379 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$341, [0, schematic_cache$379]);
		               caml_callback
		                (schema_versioned$201,
		                 [function(param, cont){return cont(0);}]);
		               function equal$119(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var letrec_function_context$342 = [];
		               function schema_versioned$202(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$342[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _A, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$342[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$342[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$342[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$201,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var kind = param[2][1], name = param[1];
		   return cont([0, name, kind]);
		  },
		  function(param, cont){
		   var kind = param[2], name = param[1];
		   return cont([0, name, [0, kind, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$342[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$342[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$380 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$342, [0, schematic_cache$380]);
		               caml_callback
		                (schema_versioned$202,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$343 = [];
		               function equal$120(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                return c
		                        ? caml_trampoline_cps_call3
		                          (letrec_function_context$343[1], lhs[2], rhs[2], cont)
		                        : cont(c);
		               }
		               caml_update_dummy(letrec_function_context$343, [0, equal$119]);
		               function compare$110(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  default: if(2 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   default: return 2;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var
		                cst_Primary = "Primary",
		                cst_Secondary = "Secondary",
		                letrec_function_context$344 = [];
		               function schema_versioned$203(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$344[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _B, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$344[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$344[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$344[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(_H);},
		                                  0,
		                                  0,
		                                  cst_default,
		                                  cst_Default,
		                                  _G,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(_F) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_primary,
		                                   cst_Primary,
		                                   _E,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(_D) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_secondary,
		                                    cst_Secondary,
		                                    _C,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$344[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$344[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$381 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$344, [0, schematic_cache$381]);
		               var
		                schema$76 =
		                  caml_callback
		                   (schema_versioned$203,
		                    [function(param, cont){return cont(0);}]);
		               function pp$77(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Default, cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Primary, cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Secondary, cont);
		                }
		               }
		               function sexp_of_t$49(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$98,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$77, t, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$79 = Make$2([0, compare$110, sexp_of_t$49]),
		                equal$121 = include$79[7];
		               function schema_versioned$204(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$203,
		                         v,
		                         function(schema){
		                          return caml_trampoline_cps_call2
		                                  (v,
		                                   V$4,
		                                   function(match){
		                                    function a(){return cont(schema);}
		                                    if(! match) return a();
		                                    var version = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_string_exn,
		     "0.8.5-beta.1.default-calendar",
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$66,
		               version,
		               b,
		               function(b){
		                if(! b) return a();
		                function encode(other, cont){
		                 return 2 <= other ? cont(other) : cont(1);
		                }
		                return cont(map$14(of_string$14, encode, schema));
		               });
		     });
		                                   });
		                         });
		               }
		               function to_string$52(param){
		                switch(param){
		                  case 0:
		                   return cst_default;
		                  case 1:
		                   return cst_primary;
		                  default: return cst_secondary;
		                }
		               }
		               function active(param){return 2 <= param ? 0 : 1;}
		               function equal$122(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  case 2:
		                   if(2 === rhs) return cont(1); break;
		                  case 3:
		                   if(3 === rhs) return cont(1); break;
		                  case 4:
		                   if(4 === rhs) return cont(1); break;
		                  case 5:
		                   if(5 === rhs) return cont(1); break;
		                  case 6:
		                   if(6 === rhs) return cont(1); break;
		                  case 7:
		                   if(7 === rhs) return cont(1); break;
		                  default: if(8 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var letrec_function_context$345 = [];
		               function schema_versioned$205(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$345[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _I, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$345[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$345[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$345[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(_0);},
		                                  0,
		                                  0,
		                                  cst_a$0,
		                                  "A",
		                                  _Z,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(_Y) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_b,
		                                   "B",
		                                   _X,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(_W) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_c$0,
		                                    "C",
		                                    _V,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(_U) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_d$0,
		                                     "D",
		                                     _T,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(_S) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_e,
		                                      cst_E,
		                                      _R,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(_Q) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_f$0,
		                                       cst_F$0,
		                                       _P,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(_O) : cont(0);
		},
		0,
		0,
		cst_g,
		"G",
		_N,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 === param ? cont(_M) : cont(0);
		 },
		 0,
		 0,
		 cst_h$0,
		 "H",
		 _L,
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(8);},
		  function(param, cont){
		   return 8 <= param ? cont(_K) : cont(0);
		  },
		  0,
		  0,
		  cst_i$0,
		  "I",
		  _J,
		  0],
		 0]]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$345[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$345[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$382 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$345, [0, schematic_cache$382]);
		               var
		                schema$77 =
		                  caml_callback
		                   (schema_versioned$205,
		                    [function(param, cont){return cont(0);}]);
		               function pp$78(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.A", cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.B", cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.C", cont);
		                  case 3:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.D", cont);
		                  case 4:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.E", cont);
		                  case 5:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.F", cont);
		                  case 6:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.G", cont);
		                  case 7:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.H", cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Calendar.Color.I", cont);
		                }
		               }
		               caml_callback
		                (M_printable, [[0, pp$2, comparator$2, schema_versioned$16]]);
		               caml_callback(M$3, [[0, comparator$2, schema_versioned$16]]);
		               var letrec_function_context$346 = [];
		               function equal$123(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$346[5],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(d){
		                           if(d) var b = rhs[3], a = lhs[3], d = a === b ? 1 : 0;
		                           function c(b){
		                            function a(b){
		                             function a(c){
		                              if(c) var b = rhs[7], a = lhs[7], c = a === b ? 1 : 0;
		                              if(! c) return cont(c);
		                              var b$0 = rhs[8], a$0 = lhs[8];
		                              return cont(a$0 === b$0 ? 1 : 0);
		                             }
		                             return b
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$346[1], lhs[6], rhs[6], a)
		                                     : a(b);
		                            }
		                            return b
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$346[2], lhs[5], rhs[5], a)
		                                    : a(b);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[4], x = lhs[4];
		                           if(x){
		                            if(y){
		                             var b$0 = y[1], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$346[3], a$0, b$0, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$346[4], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$346,
		                 [0, equal$121, equal$4, equal$99, equal$58, equal$122]);
		               var letrec_function_context$347 = [];
		               function schema_versioned$206(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$347[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, _1, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$347[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$347[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$347[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_summary,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0, 0, 0, 0, 0, "isWritable", 0, 2, [0, bool_schema], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$204,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_role, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$16,
		       schematic_version,
		       function(c){
		        var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$172,
		                 schematic_version,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$144[1],
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_disabled, 0, 2, [0, bool_schema], 0, 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_extension_row,
		                                  0,
		                                  [0, default$],
		                                  [0, c],
		                                  0,
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$116,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_connection, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$205,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              writable = f[2][1],
		              summary = f[1],
		              role = e[1],
		              id = d[1],
		              extension_row = c[1],
		              disabled = b[1],
		              connection = a[1],
		              color = param[1];
		             return cont
		                     ([0,
		                       color,
		                       connection,
		                       disabled,
		                       extension_row,
		                       id,
		                       role,
		                       summary,
		                       writable]);
		            },
		            function(param, cont){
		             var
		              writable = param[8],
		              summary = param[7],
		              role = param[6],
		              id = param[5],
		              extension_row = param[4],
		              disabled = param[3],
		              connection = param[2],
		              color = param[1];
		             return cont
		                     ([0,
		                       color,
		                       [0,
		                        connection,
		                        [0,
		                         disabled,
		                         [0,
		                          extension_row,
		                          [0, id, [0, role, [0, summary, [0, writable, 0]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$347[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$347[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$383 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$347, [0, schematic_cache$383]);
		               var
		                schema$78 =
		                  caml_callback
		                   (schema_versioned$206,
		                    [function(param, cont){return cont(0);}]);
		               function active$0(a){
		                var role = a[6], disabled = a[3], a = 1 - disabled;
		                return a ? active(role) : a;
		               }
		               var
		                By_id$0 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$2, comparator$2, schema_versioned$16]]);
		               function with_valid_default(calendars, cont){
		                function is_default(calendar, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (equal$121, calendar[6], 0, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (encode,
		                         calendars,
		                         function(calendars_list){
		                          function a(b){
		                           function d(match){
		                            function b(c){
		                             function d(b){
		                              if(b){var calendar = b[1]; return a([0, calendar]);}
		                              b = calendars_list;
		                              for(;;){
		                               if(! b) return a(0);
		                               var l = b[2], calendar$0 = b[1];
		                               if(calendar$0[8]) return a([0, calendar$0]);
		                               b = l;
		                              }
		                             }
		                             if(! c) return d(0);
		                             var l = c[2], calendar = c[1], c = calendar[8];
		                             function e(a){
		                              return a
		                                      ? d([0, calendar])
		                                      : caml_exact_trampoline_call1(b, l);
		                             }
		                             return c
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (equal$121, calendar[6], 1, e)
		                                     : e(c);
		                            }
		                            function a(default$){
		                             if(! default$) return cont(calendars);
		                             var default$0 = default$[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (map$13,
		                                      calendars,
		                                      function(calendar, cont){
		                                       var y = default$0[5], x = calendar[5];
		                                       return x === y
		       ? cont
		         ([0,
		           calendar[1],
		           calendar[2],
		           0,
		           calendar[4],
		           calendar[5],
		           0,
		           calendar[7],
		           calendar[8]])
		       : caml_exact_trampoline_cps_call
		         (is_default,
		          calendar,
		          function(a){
		           return a
		                   ? cont
		                     ([0,
		                       calendar[1],
		                       calendar[2],
		                       calendar[3],
		                       calendar[4],
		                       calendar[5],
		                       1,
		                       calendar[7],
		                       calendar[8]])
		                   : cont(calendar);
		          });
		                                      },
		                                      cont);
		                            }
		                            if(! match) return b(calendars_list);
		                            var calendar = match[1];
		                            return a([0, calendar]);
		                           }
		                           if(! b) return d(0);
		                           var l = b[2], calendar = b[1], b = calendar[8];
		                           function c(b){
		                            return b
		                                    ? d([0, calendar])
		                                    : caml_exact_trampoline_call1(a, l);
		                           }
		                           return b
		                                   ? caml_exact_trampoline_cps_call(is_default, calendar, c)
		                                   : c(b);
		                          }
		                          return a(calendars_list);
		                         });
		               }
		               function equal_hours(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               function hours_schema_versioned(param){
		                function encode(param, cont){
		                 return param ? cont(24) : cont(12);
		                }
		                function decode(i, cont){
		                 return 12 === i
		                         ? caml_trampoline_cps_call2(of_string$14, 0, cont)
		                         : 24
		                           === i
		                           ? caml_trampoline_cps_call2(of_string$14, 1, cont)
		                           : caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              fail,
		                              format$19,
		                              function(a){return caml_trampoline_cps_call2(a, i, cont);});
		                }
		                return [0, id$24, 0, [4, decode, encode, 4], 0];
		               }
		               function Moded$5(Patch, Settings, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[2],
		                          letrec_function_context[3],
		                          function(c){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[1],
		                                    c,
		                                    function(c){
		                                     return caml_trampoline_cps_call3(c, b, a, cont);
		                                    });
		                          });
		                }
		                var _2$0 = Settings[9], _1 = Patch[9];
		                caml_update_dummy
		                 (letrec_function_context, [0, _2$0, _1, equal_hours]);
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, _2, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             a = hours_schema_versioned();
		                             return caml_trampoline_cps_call3
		                                     (Patch[1],
		                                      schematic_version,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (Settings[1],
		        schematic_version,
		        a,
		        function(a){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var hours = param[1];
		              return cont([0, hours]);
		             },
		             function(param, cont){
		              var hours = param[1];
		              return cont([0, hours, 0]);
		             },
		             [0, [0, 0, 0, 0, 0, cst_hours, 0, 2, [0, a], 0, 0], 0]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$0[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$0[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          return caml_exact_trampoline_cps_call
		                                  (of_schema$1,
		                                   schema,
		                                   function(pp){
		                                    return cont([0, equal, , schema_versioned, schema, pp]);
		                                   });
		                         });
		               }
		               var
		                include$295 = caml_callback(Moded$5, [R$0, W$0]),
		                equal$124 = include$295[1],
		                bRd = include$295[3];
		               function schema_versioned$207(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (bRd,
		                         v,
		                         function(a){return cont([0, _3, a[2], a[3], a[4]]);});
		               }
		               var
		                schema$79 =
		                  caml_callback
		                   (schema_versioned$207,
		                    [function(param, cont){return cont(0);}]),
		                include$296 = caml_callback(Moded$5, [W$0, W$0]),
		                equal$125 = include$296[1],
		                bRe = include$296[3];
		               function schema_versioned$208(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (bRe,
		                         v,
		                         function(a){return cont([0, _4, a[2], a[3], a[4]]);});
		               }
		               caml_callback
		                (schema_versioned$208,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$297 = caml_callback(Moded$5, [R$0, R$0]),
		                schema_versioned$209 = include$297[3],
		                schema$80 = include$297[4];
		               caml_callback(of_schema$1, [schema$80]);
		               function Moded$6(M, Name, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[2],
		                          function(a, b, cont){return cont(a === b ? 1 : 0);},
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(a){
		                                     if(! a) return cont(a);
		                                     var b = rhs[2], c = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[1],
		      function(a, b, cont){return cont(a === b ? 1 : 0);},
		      function(a){
		       return caml_trampoline_cps_call3(a, c, b, cont);
		      });
		                                    });
		                          });
		                }
		                var _1 = M[9], _0 = M[9];
		                caml_update_dummy(letrec_function_context, [0, _1, _0]);
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, [0, Name[1]], 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      bool_schema,
		                                      function(b){
		                                       var
		default$ = M[5].call(null, 1),
		a =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_allow_contact_access,
		    0,
		    [0, default$],
		    [0, b],
		    0,
		    0],
		   0];
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        bool_schema,
		        function(b){
		         var
		          default$ = M[5].call(null, 1),
		          res =
		            [7,
		             function(param, cont){
		              var
		               allow_contact_access = param[2][1],
		               allow_calendar_access = param[1];
		              return cont
		                      ([0, allow_calendar_access, allow_contact_access]);
		             },
		             function(param, cont){
		              var
		               allow_contact_access = param[2],
		               allow_calendar_access = param[1];
		              return cont
		                      ([0, allow_calendar_access, [0, allow_contact_access, 0]]);
		             },
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_allow_calendar_access,
		               0,
		               [0, default$],
		               [0, b],
		               0,
		               0],
		              a]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$0[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$0[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    _5,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      _6,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Settings.Access_restrictions.Moded.allow_calendar_access",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[2],
		                          function(fmt, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt), _7, cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      _8,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                _9,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          __,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_allow_contact_access,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[1],
		      function(fmt, cont){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), _$, cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          $a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt), $b, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var _1 = M[8], _0 = M[8];
		                          caml_update_dummy(letrec_function_context, [0, _1, _0]);
		                          return cont([0, equal, , schema_versioned, , pp]);
		                         });
		               }
		               var
		                include$298 =
		                  caml_callback(Moded$6, [R$0, [0, "access-restrictions"]]),
		                equal$126 = include$298[1],
		                schema_versioned$210 = include$298[3],
		                include$299 =
		                  caml_callback
		                   (Moded$6, [W$0, [0, "access-restrictions-patch"]]),
		                equal$127 = include$299[1],
		                schema_versioned$211 = include$299[3];
		               function patch(access, a){
		                var
		                 allow_contact_access = a[2],
		                 allow_calendar_access = a[1],
		                 a = value$4(allow_contact_access, access[2]);
		                return [0, value$4(allow_calendar_access, access[1]), a];
		               }
		               function Moded$7(Name, M, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[4],
		                          letrec_function_context[5],
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(b){
		                                     function a(a){
		                                      if(! a) return cont(a);
		                                      var b = rhs[3], c = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[1],
		       letrec_function_context[2],
		       function(a){
		        return caml_trampoline_cps_call3(a, c, b, cont);
		       });
		                                     }
		                                     if(! b) return a(b);
		                                     var c = rhs[2], d = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[3],
		      function(a, b, cont){return cont(a === b ? 1 : 0);},
		      function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                    });
		                          });
		                }
		                var _4 = M[9], _2 = M[9], _1 = M[9];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0, _4, equal$121, _2, _1, equal$122]);
		                function make(color, a, opt, param){
		                 var
		                  disabled = a ? a[1] : M[5].call(null, 0),
		                  role = opt ? opt[1] : M[5].call(null, 2);
		                 return [0, color, disabled, role];
		                }
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, [0, Name[1]], 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$204,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(b){
		         var
		          default$ = M[5].call(null, 2),
		          a =
		            [0,
		             [0, 0, 0, 0, 0, cst_role, 0, [0, default$], [0, b], 0, 0],
		             0];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  bool_schema,
		                  function(c){
		                   var
		                    default$ = M[5].call(null, 0),
		                    b =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_disabled,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$205,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      a,
		                                      function(f){
		                                       var match = M[6].call(null, 0), e = [0, f];
		                                       if(match)
		var default$ = match[1], c = [0, default$];
		                                       else
		c = 2;
		                                       function a(a){
		var
		 res =
		   [7,
		    function(param, cont){
		     var
		      a = param[2],
		      role = a[2][1],
		      disabled = a[1],
		      color = param[1];
		     return cont([0, color, disabled, role]);
		    },
		    function(param, cont){
		     var role = param[3], disabled = param[2], color = param[1];
		     return cont([0, color, [0, disabled, [0, role, 0]]]);
		    },
		    [0, [0, 0, 0, 0, 0, a, 0, c, e, 0, 0], b]];
		return caml_exact_trampoline_cps_call$0
		        (set$3,
		         letrec_function_context$0[1][1],
		         schematic_schema_version,
		         res,
		         function(a){
		          letrec_function_context$0[1][1] = a;
		          return cont(res);
		         });
		                                       }
		                                       var d = cst_color;
		                                       if(! schematic_schema_version) return a(d);
		                                       var version = schematic_schema_version[1];
		                                       return caml_exact_trampoline_cps_call$3
		       (make$4,
		        $d,
		        $c,
		        0,
		        9,
		        1,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (less_than,
		                  version,
		                  b,
		                  function(b){return b ? a("assigned_color") : a(d);});
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    $e,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $f,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Settings.Calendar_config.Moded.color",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[4],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[5], fmt, cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $g,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                $h,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          $i,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_disabled,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[3],
		      function(fmt, cont){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), $j, cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          $k,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    $l,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $m,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_role,
		                function(b){
		                 var a = x[3];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[1],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[2], fmt, cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $n,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), $o, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var _4 = M[8], _2 = M[8], _1 = M[8];
		                          caml_update_dummy
		                           (letrec_function_context, [0, _4, pp$77, _2, _1, pp$78]);
		                          return cont([0, equal, make, schema_versioned, schema, pp]);
		                         });
		               }
		               var
		                include$300 =
		                  caml_callback(Moded$7, [[0, "calendar-config"], R$0]),
		                equal$128 = include$300[1],
		                schema_versioned$212 = include$300[3],
		                include$301 =
		                  caml_callback(Moded$7, [[0, "calendar-config-patch"], W$0]),
		                equal$129 = include$301[1],
		                schema_versioned$213 = include$301[3],
		                schema$81 = include$301[4],
		                bRf = include$301[2];
		               function make$44(color, disabled, role, param){return bRf(color, [0, disabled], [0, role]);
		               }
		               function patch$0(config, a){
		                var
		                 role = a[3],
		                 disabled = a[2],
		                 color = a[1],
		                 a = value$4(role, config[3]),
		                 b = value$4(disabled, config[2]);
		                return [0, value$4(color, config[1]), b, a];
		               }
		               function of_calendar(calendar, cont){
		                return cont([0, calendar[1], calendar[3], calendar[6]]);
		               }
		               function Moded$8(Name, Patch, Settings, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[14],
		                          letrec_function_context[15],
		                          function(c){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[13],
		                                    c,
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (c,
		      b,
		      a,
		      function(b){
		       function a(b){
		        function a(b){
		         function a(a){
		          if(! a) return cont(a);
		          var b = rhs[5], c = lhs[5];
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[2],
		                   letrec_function_context[3],
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context[1],
		                             a,
		                             function(a){
		                              return caml_trampoline_cps_call3(a, c, b, cont);
		                             });
		                   });
		         }
		         if(! b) return a(b);
		         var c = rhs[4], d = lhs[4];
		         return caml_trampoline_cps_call2
		                 (letrec_function_context[5],
		                  letrec_function_context[6],
		                  function(b){
		                   return caml_trampoline_cps_call2
		                           (letrec_function_context[4],
		                            b,
		                            function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                  });
		        }
		        if(! b) return a(b);
		        var c = rhs[3], d = lhs[3];
		        return caml_trampoline_cps_call2
		                (letrec_function_context[8],
		                 letrec_function_context[9],
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context[7],
		                           b,
		                           function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                 });
		       }
		       if(! b) return a(b);
		       var c = rhs[2], d = lhs[2];
		       return caml_trampoline_cps_call2
		               (letrec_function_context[11],
		                letrec_function_context[12],
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[10],
		                          b,
		                          function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 _14 = Settings[9],
		                 _13 = Patch[9],
		                 _11 = Settings[9],
		                 _10 = Patch[9],
		                 _8 = Settings[9],
		                 _7 = Patch[9],
		                 _5 = Settings[9],
		                 _4 = Patch[9],
		                 _2 = Settings[9],
		                 _1 = Patch[9];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0,
		                   _14,
		                   _13,
		                   equal$23,
		                   _11,
		                   _10,
		                   equal$23,
		                   _8,
		                   _7,
		                   equal$23,
		                   _5,
		                   _4,
		                   equal$23,
		                   _2,
		                   _1,
		                   equal$23]);
		                var cst_night = "night", letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, [0, Name[1]], 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             a = schema_versioned$2(schematic_version);
		                             return caml_trampoline_cps_call3
		                                     (Patch[1],
		                                      schematic_version,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (Settings[1],
		        schematic_version,
		        a,
		        function(b){
		         var a = Settings[6].call(null, 0), b = [0, b];
		         if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		         var
		          d = schema_versioned$2(schematic_version),
		          c = [0, [0, 0, 0, 0, 0, cst_night, 0, a, b, 0, 0], 0];
		         return caml_trampoline_cps_call3
		                 (Patch[1],
		                  schematic_version,
		                  d,
		                  function(a){
		                   return caml_trampoline_cps_call3
		                           (Settings[1],
		                            schematic_version,
		                            a,
		                            function(b){
		                             var a = Settings[6].call(null, 0), b = [0, b];
		                             if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                             var
		                              e = schema_versioned$2(schematic_version),
		                              d = [0, [0, 0, 0, 0, 0, cst_evening, 0, a, b, 0, 0], c];
		                             return caml_trampoline_cps_call3
		                                     (Patch[1],
		                                      schematic_version,
		                                      e,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (Settings[1],
		        schematic_version,
		        a,
		        function(b){
		         var a = Settings[6].call(null, 0), b = [0, b];
		         if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		         var
		          e = schema_versioned$2(schematic_version),
		          c = [0, [0, 0, 0, 0, 0, cst_afternoon, 0, a, b, 0, 0], d];
		         return caml_trampoline_cps_call3
		                 (Patch[1],
		                  schematic_version,
		                  e,
		                  function(a){
		                   return caml_trampoline_cps_call3
		                           (Settings[1],
		                            schematic_version,
		                            a,
		                            function(b){
		                             var a = Settings[6].call(null, 0), b = [0, b];
		                             if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                             var
		                              e = schema_versioned$2(schematic_version),
		                              d = [0, [0, 0, 0, 0, 0, cst_noon, 0, a, b, 0, 0], c];
		                             return caml_trampoline_cps_call3
		                                     (Patch[1],
		                                      schematic_version,
		                                      e,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (Settings[1],
		        schematic_version,
		        a,
		        function(b){
		         var a = Settings[6].call(null, 0), b = [0, b];
		         if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		         var
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               b = a[2],
		               c = b[2],
		               night = c[2][1],
		               evening = c[1],
		               afternoon = b[1],
		               noon = a[1],
		               day = param[1];
		              return cont([0, day, noon, afternoon, evening, night]);
		             },
		             function(param, cont){
		              var
		               night = param[5],
		               evening = param[4],
		               afternoon = param[3],
		               noon = param[2],
		               day = param[1];
		              return cont
		                      ([0,
		                        day,
		                        [0, noon, [0, afternoon, [0, evening, [0, night, 0]]]]]);
		             },
		             [0, [0, 0, 0, 0, 0, cst_day, 0, a, b, 0, 0], d]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$0[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$0[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    $p,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $q,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Settings.Hours_config.Moded.day",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[13],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context[14],
		                                    function(fmt, cont){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[15], fmt, cont);
		                                    },
		                                    fmt,
		                                    cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $r,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                $s,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          $t,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_noon,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[10],
		      function(fmt, cont){
		       return caml_trampoline_cps_call3
		               (letrec_function_context[11],
		                function(fmt, cont){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[12], fmt, cont);
		                },
		                fmt,
		                cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          $u,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    $v,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $w,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_afternoon,
		                function(b){
		                 var a = x[3];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[7],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context[8],
		                                    function(fmt, cont){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[9], fmt, cont);
		                                    },
		                                    fmt,
		                                    cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $x,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                $y,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          $z,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_evening,
		                                    function(b){
		                                     var a = x[4];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[4],
		      function(fmt, cont){
		       return caml_trampoline_cps_call3
		               (letrec_function_context[5],
		                function(fmt, cont){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[6], fmt, cont);
		                },
		                fmt,
		                cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          $A,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    $B,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $C,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_night,
		                function(b){
		                 var a = x[5];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[1],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context[2],
		                                    function(fmt, cont){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[3], fmt, cont);
		                                    },
		                                    fmt,
		                                    cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      $D,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), $E, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var
		                           _14 = Settings[8],
		                           _13 = Patch[8],
		                           _11 = Settings[8],
		                           _10 = Patch[8],
		                           _8 = Settings[8],
		                           _7 = Patch[8],
		                           _5 = Settings[8],
		                           _4 = Patch[8],
		                           _2 = Settings[8],
		                           _1 = Patch[8];
		                          caml_update_dummy
		                           (letrec_function_context,
		                            [0,
		                             _14,
		                             _13,
		                             _12$0,
		                             _11,
		                             _10,
		                             _12$0,
		                             _8,
		                             _7,
		                             _12$0,
		                             _5,
		                             _4,
		                             _12$0,
		                             _2,
		                             _1,
		                             _12$0]);
		                          return cont([0, equal, , schema_versioned, schema, pp]);
		                         });
		               }
		               var
		                include$302 =
		                  caml_callback(Moded$8, [[0, "hours-settings"], R$0, W$0]),
		                equal$130 = include$302[1],
		                schema_versioned$214 = include$302[3],
		                schema$82 = include$302[4],
		                include$303 =
		                  caml_callback
		                   (Moded$8, [[0, "hours-settings-patch"], W$0, W$0]),
		                equal$131 = include$303[1],
		                schema_versioned$215 = include$303[3];
		               function patch$1(settings, a){
		                var
		                 night = a[5],
		                 evening = a[4],
		                 afternoon = a[3],
		                 noon = a[2],
		                 day = a[1],
		                 a = value$4(night, settings[5]),
		                 b = value$4(evening, settings[4]),
		                 c = value$4(afternoon, settings[3]),
		                 d = value$4(noon, settings[2]);
		                return [0, value$4(day, settings[1]), d, c, b, a];
		               }
		               var
		                include$304 =
		                  caml_callback(Moded$8, [[0, "hours-config"], R$0, R$0]),
		                schema_versioned$216 = include$304[3],
		                schema$83 = include$304[4],
		                include$80 =
		                  caml_callback(M$2, [[0, comparator$2, schema_versioned$16]]),
		                equal$132 = include$80[55],
		                merge$4 = include$80[59],
		                schema_versioned$217 = include$80[109],
		                empty$24 = include$80[111],
		                include$81 =
		                  caml_callback
		                   (M$2, [[0, comparator$2, thread_id_schema_versioned]]),
		                equal$133 = include$81[55],
		                schema_versioned$218 = include$81[109],
		                default$9 = include$81[111],
		                cst_access_restrictions = "access_restrictions";
		               function Moded$9(Name, Atomic, M, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[19],
		                          letrec_function_context[21],
		                          letrec_function_context[20],
		                          function(c){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[18],
		                                    c,
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (c,
		      b,
		      a,
		      function(b){
		       function a(b){
		        function a(b){
		         function a(b){
		          function a(b){
		           function a(a){
		            if(! a) return cont(a);
		            var b = rhs[7], c = lhs[7];
		            return caml_trampoline_cps_call2
		                    (letrec_function_context[1],
		                     letrec_function_context[2],
		                     function(a){
		                      return caml_trampoline_cps_call3(a, c, b, cont);
		                     });
		           }
		           if(! b) return a(b);
		           var c = rhs[6], d = lhs[6];
		           return caml_trampoline_cps_call2
		                   (letrec_function_context[3],
		                    function(x$1, y$1, cont){
		                     var x = x$1, y = y$1;
		                     for(;;){
		                      if(x){
		                       if(y){
		                        var
		                         y$0 = y[2],
		                         b = y[1],
		                         x$0 = x[2],
		                         a = x[1],
		                         c = a === b ? 1 : 0;
		                        if(! c) return cont(c);
		                        x = x$0;
		                        y = y$0;
		                        continue;
		                       }
		                      }
		                      else if(! y) return cont(1);
		                      return cont(0);
		                     }
		                    },
		                    function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		          }
		          if(! b) return a(b);
		          var c = rhs[5], d = lhs[5];
		          return caml_trampoline_cps_call2
		                  (letrec_function_context[4],
		                   function(x, y, cont){
		                    function a(x, y){
		                     if(x){
		                      if(y){
		                       var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                       return caml_trampoline_cps_call3
		                               (letrec_function_context[5],
		                                a$0,
		                                b,
		                                function(b){
		                                 return b
		 ? caml_exact_trampoline_call2(a, x$0, y$0)
		 : cont(b);
		                                });
		                      }
		                     }
		                     else if(! y) return cont(1);
		                     return cont(0);
		                    }
		                    return a(x, y);
		                   },
		                   function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		         }
		         if(! b) return a(b);
		         var c = rhs[4], d = lhs[4];
		         return caml_trampoline_cps_call3
		                 (letrec_function_context[6],
		                  letrec_function_context[8],
		                  letrec_function_context[7],
		                  function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		        }
		        if(! b) return a(b);
		        var c = rhs[3], d = lhs[3];
		        return caml_trampoline_cps_call3
		                (letrec_function_context[9],
		                 letrec_function_context[11],
		                 letrec_function_context[10],
		                 function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		       }
		       if(! b) return a(b);
		       var c = rhs[2], d = lhs[2];
		       return caml_trampoline_cps_call2
		               (letrec_function_context[15],
		                letrec_function_context[16],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[14],
		                          letrec_function_context[17],
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[13],
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[12],
		      function(a, param, cont){return cont(1);},
		      b,
		      function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 _20 = M[9],
		                 _18 = M[9],
		                 _17 = M[9],
		                 _15 = M[11][3],
		                 _12 = M[11][3],
		                 _9 = Atomic[3],
		                 _7 = M[11][3],
		                 _6 = M[9],
		                 _2 = M[11][3];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0,
		                   _20,
		                   equal$16,
		                   _18,
		                   _17,
		                   equal$69,
		                   _15,
		                   equal$131,
		                   equal$130,
		                   _12,
		                   equal$125,
		                   equal$124,
		                   _9,
		                   equal$132,
		                   _7,
		                   _6,
		                   equal$129,
		                   equal$128,
		                   equal$133,
		                   _2,
		                   equal$127,
		                   equal$126]);
		                function make(g, f, e, d, c, b, opt, param, cont){
		                 var access_restrictions = g ? g[1] : default$9;
		                 function a(calendars){
		                  var
		                   locale = e ? e[1] : M[11][5].call(null, empty$1, empty$2),
		                   hours = d ? d[1] : M[11][5].call(null, empty$4, empty$5),
		                   mru_destinations = c ? c[1] : M[5].call(null, 0),
		                   mru_peoples = b ? b[1] : M[5].call(null, 0),
		                   week_start = opt ? opt[1] : M[5].call(null, 6);
		                  return cont
		                          ([0,
		                            access_restrictions,
		                            calendars,
		                            locale,
		                            hours,
		                            mru_destinations,
		                            mru_peoples,
		                            week_start]);
		                 }
		                 return f
		                         ? a(f[1])
		                         : caml_trampoline_cps_call2
		                           (Atomic[5],
		                            0,
		                            function(b){
		                             return caml_trampoline_cps_call2(b, empty$24, a);
		                            });
		                }
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, [0, Name[1]], 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$6,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(b){
		         var
		          default$ = M[5].call(null, 6),
		          a =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_week_start,
		              0,
		              [0, default$],
		              [0, b],
		              0,
		              0],
		             0];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                  function(c){
		                   var
		                    default$ = M[5].call(null, 0),
		                    b =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "mru_peoples",
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$131,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      [0, 0, 0, [3, a], 0],
		                                      function(c){
		                                       var
		default$ = M[5].call(null, 0),
		a =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_mru_destinations,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$215,
		        schematic_version,
		        function(b){
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$214,
		                  schematic_version,
		                  function(c){
		                   c = [0, M[11][1].call(null, schematic_version, c, b)];
		                   var
		                    default$ = M[11][5].call(null, empty$4, empty$5),
		                    d =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_hours, 0, [0, default$], c, 0, 0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$208,
		                            schematic_version,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$207,
		                                      schematic_version,
		                                      function(b){
		                                       b = [0, M[11][1].call(null, schematic_version, b, a)];
		                                       var
		default$ = M[11][5].call(null, empty$1, empty$2),
		c =
		  [0,
		   [0, 0, 0, 0, 0, cst_locale, 0, [0, default$], b, 0, 0],
		   d];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$213,
		        schematic_version,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$212,
		                            schematic_version,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (schema_versioned$217,
		                                      schematic_version,
		                                      M[11][1].call(null, schematic_version, b, a),
		                                      function(b){
		                                       var
		a =
		  [0,
		   Atomic[1].call
		    (null, schematic_version, schematic_param_a_schema_versi, b)];
		                                       return caml_trampoline_cps_call2
		       (Atomic[5],
		        0,
		        function(b){
		         return caml_trampoline_cps_call2
		                 (b,
		                  empty$24,
		                  function(default$){
		                   var
		                    b =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_calendars, 0, [0, default$], a, 0, 0],
		                       c];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$211,
		                            schematic_version,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$210,
		                                      schematic_version,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (schema_versioned$218,
		        schematic_version,
		        M[11][1].call(null, schematic_version, c, a),
		        function(a){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               b = a[2],
		               c = b[2],
		               d = c[2],
		               e = d[2],
		               week_start = e[2][1],
		               mru_peoples = e[1],
		               mru_destinations = d[1],
		               hours = c[1],
		               locale = b[1],
		               calendars = a[1],
		               access_restrictions = param[1];
		              return cont
		                      ([0,
		                        access_restrictions,
		                        calendars,
		                        locale,
		                        hours,
		                        mru_destinations,
		                        mru_peoples,
		                        week_start]);
		             },
		             function(param, cont){
		              var
		               week_start = param[7],
		               mru_peoples = param[6],
		               mru_destinations = param[5],
		               hours = param[4],
		               locale = param[3],
		               calendars = param[2],
		               access_restrictions = param[1];
		              return cont
		                      ([0,
		                        access_restrictions,
		                        [0,
		                         calendars,
		                         [0,
		                          locale,
		                          [0,
		                           hours,
		                           [0, mru_destinations, [0, mru_peoples, [0, week_start, 0]]]]]]]);
		             },
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_access_restrictions,
		               0,
		               [0, default$9],
		               [0, a],
		               0,
		               0],
		              b]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$0[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$0[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var
		                           a = M[5].call(null, 6),
		                           b = M[5].call(null, 0),
		                           c = M[5].call(null, 0),
		                           d = M[11][5].call(null, empty$4, empty$5),
		                           e = M[11][5].call(null, empty$1, empty$2);
		                          return caml_exact_trampoline_cps_call$1
		                                  (Atomic[5],
		                                   0,
		                                   empty$24,
		                                   function(f){
		                                    var empty = [0, default$9, f, e, d, c, b, a];
		                                    return cont
		    ([0, equal, make, schema_versioned, schema, , , empty]);
		                                   });
		                         });
		               }
		               var
		                include$305 =
		                  caml_callback
		                   (Moded$9,
		                    [[0, cst_settings],
		                     [0, schema_versioned$191, , equal$111, pp$74, return$22],
		                     R$0]),
		                schema_versioned$219 = include$305[3],
		                schema$84 = include$305[4],
		                include$306 =
		                  caml_callback
		                   (Moded$9,
		                    [[0, "settings-patch"],
		                     [0, schema_versioned$191, , equal$111, pp$74, return$22],
		                     W$0]),
		                schema$85 = include$306[4],
		                bRg = include$306[2];
		               function make$45
		               (a,
		                opt,
		                locale,
		                hours,
		                mru_destinations,
		                mru_peoples,
		                week_start,
		                param,
		                cont){
		                var
		                 access_restrictions = a ? a[1] : default$9,
		                 calendars = opt ? opt[1] : empty$24;
		                return caml_exact_trampoline_cps_call$9
		                        (bRg,
		                         [0, access_restrictions],
		                         [0, calendars],
		                         locale,
		                         hours,
		                         [0, mru_destinations],
		                         [0, mru_peoples],
		                         [0, week_start],
		                         dummy,
		                         cont);
		               }
		               function normalize_calendars_patch(calendars_patch, cont){
		                function f(key, data, a, cont){
		                 var calendars = a[2], default$ = a[1];
		                 if(default$){
		                  if(data){
		                   var data$0 = data[1], a = data$0[3];
		                   if(a && ! a[1]){
		                    var previous = default$[1];
		                    return caml_exact_trampoline_cps_call
		                            (warn$0,
		                             function(m, cont){
		                              return caml_trampoline_cps_call8
		                                      (m, 0, 0, $F, pp$2, previous, pp$2, key, cont);
		                             },
		                             function(match){
		                              return caml_exact_trampoline_cps_call$0
		                                      (set$3,
		                                       calendars,
		                                       key,
		                                       [0, [0, data$0[1], data$0[2], 0]],
		                                       function(a){return cont([0, default$, a]);});
		                             });
		                   }
		                  }
		                 }
		                 else if(data){
		                  a = data[1][3];
		                  if(a && ! a[1])
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            calendars,
		                            key,
		                            data,
		                            function(a){return cont([0, [0, key], a]);});
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (set$3,
		                          calendars,
		                          key,
		                          data,
		                          function(a){return cont([0, default$, a]);});
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (fold$5, calendars_patch, [0, 0, empty$24], f, cont);
		               }
		               var
		                include$307 =
		                  caml_callback
		                   (Moded$9,
		                    [[0, "atomic-settings"],
		                     [0, schema_versioned$190, , equal$110, pp$73, return$21],
		                     R$0]),
		                equal$134 = include$307[1],
		                empty$25 = include$307[7],
		                schematic_cache$384 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$348 = [];
		               caml_update_dummy
		                (letrec_function_context$348, [0, schematic_cache$384]);
		               function schematic_version$56(param, cont){return cont(0);}
		               var
		                schematic_schema_version$122 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$348[1][1],
		                     schematic_schema_version$122]);
		               if(h)
		                var schema$86 = h[1], descriptor$18 = schema$86;
		               else
		                descriptor$18 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$348[1][1],
		                              schematic_schema_version$122,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$348[1][1],
		 schematic_schema_version$122,
		 schematic_self,
		 function(b){
		  letrec_function_context$348[1][1] = b;
		  var
		   a =
		     [0,
		      [0,
		       $K,
		       0,
		       0,
		       0,
		       cst_token,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0];
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$118,
		           schematic_version$56,
		           function(b){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var token = param[2][1], account = param[1];
		                 return cont([0, account, token]);
		                },
		                function(param, cont){
		                 var token = param[2], account = param[1];
		                 return cont([0, account, [0, token, 0]]);
		                },
		                [0, [0, $L, 0, 0, 0, cst_account, 0, 2, [0, b], 0, 0], a]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$348[1][1],
		                     schematic_schema_version$122,
		                     res,
		                     function(a){
		                      letrec_function_context$348[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                impersonation_schema = [0, $J, $I, descriptor$18, 0],
		                include$82 =
		                  caml_callback(Make$12, [[0, cst_attachment, cst$21]]),
		                schema_versioned$220 = include$82[4],
		                of_string$44 = include$82[6],
		                equal$135 = include$82[15],
		                letrec_function_context$349 = [];
		               function equal$136(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$349[3],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(c){
		                           if(c) var b = rhs[3], a = lhs[3], c = a === b ? 1 : 0;
		                           if(c)
		                            var b$0 = rhs[4], a$0 = lhs[4], c = a$0 === b$0 ? 1 : 0;
		                           return c
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$349[1], lhs[5], rhs[5], cont)
		                                   : cont(c);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$349[2], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$349,
		                 [0, equal$44, equal$135, equal$20]);
		               var cst_mime = "mime", letrec_function_context$350 = [];
		               function schema_versioned$221(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$350[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, $M, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$350[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$350[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$350[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_mime,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$262], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$220,
		                                     schematic_version,
		                                     function(c){
		                                      var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              url = c[2][1],
		              name = c[1],
		              mime = b[1],
		              id = a[1],
		              created = param[1];
		             return cont([0, created, id, mime, name, url]);
		            },
		            function(param, cont){
		             var
		              url = param[5],
		              name = param[4],
		              mime = param[3],
		              id = param[2],
		              created = param[1];
		             return cont
		                     ([0, created, [0, id, [0, mime, [0, name, [0, url, 0]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$350[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$350[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$385 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$350, [0, schematic_cache$385]);
		               caml_callback
		                (schema_versioned$221,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$351 = [];
		               function equal_boundaries$0(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhscount = lhs[2], lhsstart = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhscount = rhs[2], rhsstart = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$351[3],
		                           lhsstart,
		                           rhsstart,
		                           function(a){
		                            return a ? cont(lhscount === rhscount ? 1 : 0) : cont(a);
		                           });
		                 }
		                }
		                else {
		                 var lhsstart$0 = lhs[2], lhsend = lhs[1];
		                 if(0 !== rhs[0]){
		                  var
		                   rhsstart$0 = rhs[2],
		                   rhsend = rhs[1],
		                   c =
		                     function(a){
		                      return a
		                              ? caml_trampoline_cps_call3
		                                (letrec_function_context$351[1],
		                                 lhsstart$0,
		                                 rhsstart$0,
		                                 cont)
		                              : cont(a);
		                     };
		                  if(lhsend){
		                   if(rhsend){
		                    var b = rhsend[1], a = lhsend[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$351[2], a, b, c);
		                   }
		                  }
		                  else if(! rhsend) return c(1);
		                  return c(0);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$351,
		                 [0, equal$21, equal$21, equal$21]);
		               var letrec_function_context$352 = [];
		               function boundaries_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$352[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, $N, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$352[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$352[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$352[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_start, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$1,
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([1, f0, f1]);
		             },
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_dates,
		             cst_Dates,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var start = param[2][1], end = param[1];
		                return cont([0, end, start]);
		               },
		               function(param, cont){
		                var start = param[2], end = param[1];
		                return cont([0, end, [0, start, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_end, 0, 3, [0, d], 0, 0], a]],
		              0],
		             0],
		            0],
		         c =
		           [0,
		            [0, 0, 0, 0, 0, cst_count, 0, 2, [0, int_schema], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$1,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, f0, f1]);
		                        },
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, [0, f0, f1]]);
		                        },
		                        1,
		                        0,
		                        cst_count,
		                        cst_Count,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var count = param[2][1], start = param[1];
		                           return cont([0, start, count]);
		                          },
		                          function(param, cont){
		                           var count = param[2], start = param[1];
		                           return cont([0, start, [0, count, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_start, 0, 2, [0, a], 0, 0], c]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$352[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$352[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$386 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$352, [0, schematic_cache$386]);
		               caml_callback
		                (boundaries_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$353 = [];
		               function equal$137(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$353[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$353[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$353,
		                 [0, equal$30, equal_boundaries$0]);
		               var letrec_function_context$354 = [];
		               function schema_versioned$222(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$354[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, $P, $O, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$354[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$354[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$354[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$14,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_rule, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (boundaries_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var rule = param[2][1], boundaries = param[1];
		             return cont([0, boundaries, rule]);
		            },
		            function(param, cont){
		             var rule = param[2], boundaries = param[1];
		             return cont([0, boundaries, [0, rule, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_boundaries, 0, 2, [1, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$354[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$354[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$387 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$354, [0, schematic_cache$387]);
		               var
		                schema$87 =
		                  caml_callback
		                   (schema_versioned$222,
		                    [function(param, cont){return cont(0);}]);
		               function to_mandate(param){
		                var rule = param[2], boundaries = param[1];
		                if(0 === boundaries[0])
		                 var
		                  count = boundaries[2],
		                  start = boundaries[1],
		                  boundaries$0 = [0, start, count];
		                else
		                 var
		                  start$0 = boundaries[2],
		                  end = boundaries[1],
		                  boundaries$0 = [1, end, [0, start$0]];
		                return [0, boundaries$0, rule];
		               }
		               function of_mandate(a, cont){
		                var
		                 rule = a[2],
		                 boundaries = a[1],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function b(boundaries, cont){
		                 return cont([0, boundaries, rule]);
		                }
		                if(0 === boundaries[0])
		                 var
		                  count = boundaries[2],
		                  start = boundaries[1],
		                  a = [0, [0, start, count]];
		                else {
		                 a = boundaries[2];
		                 var end = boundaries[1];
		                 if(a)
		                  var start$0 = a[1], a = [0, [1, end, start$0]];
		                 else
		                  a = 0;
		                }
		                return caml_trampoline_cps_call3(let$, a, b, cont);
		               }
		               function start_date$0(t){
		                var a = t[1], start = 0 === a[0] ? a[1] : a[2];
		                return start;
		               }
		               function snap$0(t, date, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (snap, to_mandate(t), date, cont);
		               }
		               function occurs_on(recurrence, day, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (snap$0,
		                         recurrence,
		                         day,
		                         function(match){
		                          if(! match) return cont(0);
		                          var date = match[1][1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$81, date, day, cont);
		                         });
		               }
		               var letrec_function_context$355 = [];
		               function equal$138(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   var lhsdate = lhs[1];
		                   if(0 === rhs[0]){
		                    var rhsdate = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$355[5], lhsdate, rhsdate, cont);
		                   }
		                   break;
		                  case 1:
		                   var lhsend = lhs[2], lhsstart = lhs[1];
		                   if(1 === rhs[0]){
		                    var rhsend = rhs[2], rhsstart = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$355[4],
		                             lhsstart,
		                             rhsstart,
		                             function(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$355[3], lhsend, rhsend, cont)
		                                      : cont(a);
		                             });
		                   }
		                   break;
		                  default:
		                   var lhsend$0 = lhs[2], lhsstart$0 = lhs[1];
		                   if(2 === rhs[0]){
		                    var rhsend$0 = rhs[2], rhsstart$0 = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$355[2],
		                             lhsstart$0,
		                             rhsstart$0,
		                             function(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$355[1], lhsend$0, rhsend$0, cont)
		                                      : cont(a);
		                             });
		                   }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$355,
		                 [0, equal$20, equal$20, equal$21, equal$21, equal$21]);
		               var
		                cst_Times = "Times",
		                cst_end_date = "end_date",
		                cst_end_time = "end_time",
		                cst_start_time = "start_time",
		                letrec_function_context$356 = [];
		               function schema_versioned$223(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$356[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, $R, $Q, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$356[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$356[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$356[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, $S, 0, 0, 0, cst_end_time, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([2, f0, f1]);
		             },
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_times,
		             cst_Times,
		             [0,
		              0,
		              $U,
		              [7,
		               function(param, cont){
		                var end = param[2][1], start = param[1];
		                return cont([0, start, end]);
		               },
		               function(param, cont){
		                var end = param[2], start = param[1];
		                return cont([0, start, [0, end, 0]]);
		               },
		               [0, [0, $T, 0, 0, 0, cst_start_time, 0, 2, [0, c], 0, 0], a]],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$1,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, $V, 0, 0, 0, cst_end_date, 0, 2, [0, c], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$1,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([1, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_dates,
		                                 cst_Dates,
		                                 [0,
		                                  0,
		                                  $X,
		                                  [7,
		                                   function(param, cont){
		                                    var end = param[2][1], start = param[1];
		                                    return cont([0, start, end]);
		                                   },
		                                   function(param, cont){
		                                    var end = param[2], start = param[1];
		                                    return cont([0, start, [0, end, 0]]);
		                                   },
		                                   [0, [0, $W, 0, 0, 0, cst_start_date, 0, 2, [0, d], 0, 0], a]],
		                                  0],
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$1,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_date,
		    cst_Date,
		    [0,
		     0,
		     $Z,
		     [7,
		      function(param, cont){
		       var date = param[1];
		       return cont(date);
		      },
		      function(date, cont){return cont([0, date, 0]);},
		      [0, [0, $Y, 0, 0, 0, cst_date, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   c],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$356[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$356[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$388 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$356, [0, schematic_cache$388]);
		               var
		                schema$88 =
		                  caml_callback
		                   (schema_versioned$223,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$357 = [];
		               function _19(fmt, param, cont){
		                var cst_end = "end_";
		                switch(param[0]){
		                  case 0:
		                   var adate = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            $0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      $1,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_date,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$357[5],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            adate,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      $2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), $3, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var aend = param[2], astart = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            $4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      $5,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_start,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$357[4],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            astart,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      $6,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        $7,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  $8,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_end,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$357[3],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aend,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  $9,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), $_, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var aend$0 = param[2], astart$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            $$,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aaa,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_start,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$357[2],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            astart$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aab,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        aac,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aad,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_end,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$357[1],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aend$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aae,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), aaf, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               caml_update_dummy
		                (letrec_function_context$357,
		                 [0, _12, _12, pp_v1$0, pp_v1$0, pp_v1$0]);
		               function end$1(timezone, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var date = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (add_days,
		                            date,
		                            1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_time$1, timezone, a, cont);
		                            });
		                  case 1:
		                   var end = param[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (add_days,
		                            end,
		                            1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_time$1, timezone, a, cont);
		                            });
		                  default: var end$0 = param[2]; return cont(end$0);
		                }
		               }
		               function start$2(timezone, param, cont){
		                if(2 === param[0]){var start = param[1]; return cont(start);}
		                var date = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (to_time$1, timezone, date, cont);
		               }
		               function start_date$1(timezone, param, cont){
		                if(2 === param[0]){
		                 var start = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (of_time$0, timezone, start, cont);
		                }
		                var date = param[1];
		                return cont(date);
		               }
		               function is_full_day(param){return 2 === param[0] ? 0 : 1;}
		               function equal_attendance(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               function compare_attendance(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(0);
		                }
		                else if(! rhs) return cont(0);
		                function to_int(param){return param ? 1 : 0;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var letrec_function_context$358 = [];
		               function attendance_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$358[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aah, aag, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$358[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$358[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$358[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aal);},
		                                  0,
		                                  0,
		                                  cst_attend,
		                                  "Attend",
		                                  [0, aD[1], aak, aD[3], aD[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(aaj) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_ignore,
		                                   cst_Ignore,
		                                   [0, aC[1], aai, aC[3], aC[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$358[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$358[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$389 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$358, [0, schematic_cache$389]);
		               caml_callback
		                (attendance_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function pp_attendance(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Event_schema_intf.Ignore", cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Event_schema_intf.Attend", cont);
		               }
		               function equal_availability(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               var letrec_function_context$359 = [];
		               function availability_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$359[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aan, aam, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$359[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$359[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$359[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aap,
		                                     aao,
		                                     0,
		                                     23,
		                                     0,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(1);},
		   function(param, cont){return param ? cont(aar) : cont(0);},
		   0,
		   0,
		   cst_free,
		   cst_Free,
		   [0, aE[1], aaq, aE[3], aE[4]],
		   [0, [0, b, V$4]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aat,
		       aas,
		       0,
		       23,
		       0,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){return param ? cont(0) : cont(aav);},
		              0,
		              0,
		              cst_busy,
		              "Busy",
		              [0, aF[1], aau, aF[3], aF[4]],
		              [0, [0, b, V$4]]],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$359[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$359[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$390 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$359, [0, schematic_cache$390]);
		               caml_callback
		                (availability_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function pp_availability(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Event_schema_intf.Free", cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Event_schema_intf.Busy", cont);
		               }
		               var letrec_function_context$360 = [];
		               function schema_versioned$224(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$360[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aaw, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$360[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$360[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$360[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aaA);},
		                                  0,
		                                  0,
		                                  cst_active,
		                                  cst_Active,
		                                  [0, aH[1], aaz, aH[3], aH[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(aay) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_passive,
		                                   "Passive",
		                                   [0, aG[1], aax, aG[3], aG[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$360[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$360[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$391 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$360, [0, schematic_cache$391]);
		               caml_callback
		                (schema_versioned$224,
		                 [function(param, cont){return cont(0);}]);
		               function equal_yes_no_maybe(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               function compare_yes_no_maybe(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  default: if(2 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   default: return 2;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var
		                cst_Maybe = "Maybe",
		                cst_No = "No",
		                cst_Yes = "Yes",
		                letrec_function_context$361 = [];
		               function yes_no_maybe_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$361[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aaB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$361[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$361[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$361[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aaH);},
		                                  0,
		                                  0,
		                                  cst_yes,
		                                  cst_Yes,
		                                  aaG,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aaF) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_no,
		                                   cst_No,
		                                   aaE,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(aaD) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_maybe,
		                                    cst_Maybe,
		                                    aaC,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$361[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$361[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$392 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$361, [0, schematic_cache$392]);
		               var
		                yes_no_maybe_schema =
		                  caml_callback
		                   (yes_no_maybe_schema_versioned,
		                    [function(param, cont){return cont(0);}]);
		               function show_yes_no_maybe(param){
		                switch(param){
		                  case 0:
		                   return cst_Yes;
		                  case 1:
		                   return cst_No;
		                  default: return cst_Maybe;
		                }
		               }
		               function pp_yes_no_maybe(f, ynm, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, f, show_yes_no_maybe(ynm), cont);
		               }
		               var letrec_function_context$362 = [];
		               function equal_attendee(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                a:
		                if(c){
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b$0 = y[1], a$0 = x[1], c = a$0 === b$0 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                if(c) var b$1 = rhs[3], a$1 = lhs[3], c = a$1 === b$1 ? 1 : 0;
		                if(! c) return cont(c);
		                var y$0 = rhs[4], x$0 = lhs[4];
		                if(x$0){
		                 if(y$0){
		                  var b$2 = y$0[1], a$2 = x$0[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$362[1], a$2, b$2, cont);
		                 }
		                }
		                else if(! y$0) return cont(1);
		                return cont(0);
		               }
		               function equal_creator(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(! c) return cont(c);
		                var y = rhs[2], x = lhs[2];
		                if(x){
		                 if(y){
		                  var b$0 = y[1], a$0 = x[1];
		                  return cont(a$0 === b$0 ? 1 : 0);
		                 }
		                }
		                else if(! y) return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$362, [0, equal_yes_no_maybe]);
		               function make_attendee(name, opt, status, email){
		                var organizer = opt ? opt[1] : 0;
		                return [0, email, name, organizer, status];
		               }
		               var bPc = [];
		               function compare_attendee(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (bPc[4],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var y = rhs[2], x$0 = lhs[2];
		                                    function c(x){
		                                     if(0 !== x) return cont(x);
		                                     var a = rhs[3], b = lhs[3];
		                                     return caml_trampoline_cps_call2
		     (bPc[2],
		      0,
		      function(c){
		       return caml_trampoline_cps_call3
		               (c,
		                b,
		                a,
		                function(x){
		                 if(0 !== x) return cont(x);
		                 var y = rhs[4], x$0 = lhs[4];
		                 if(! x$0) return y ? cont(-1) : cont(0);
		                 var a = x$0[1];
		                 if(! y) return cont(1);
		                 var b = y[1];
		                 return caml_trampoline_cps_call3(bPc[1], a, b, cont);
		                });
		      });
		                                    }
		                                    if(! x$0) return y ? c(-1) : c(0);
		                                    var a = x$0[1];
		                                    if(! y) return c(1);
		                                    var b = y[1];
		                                    return caml_trampoline_cps_call2
		    (bPc[3],
		     0,
		     function(d){return caml_trampoline_cps_call3(d, a, b, c);});
		                                   });
		                         });
		               }
		               function _2$19(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$36(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _0$34(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (bPc, [0, compare_yes_no_maybe, _2$19, _1$36, _0$34]);
		               var bin = [];
		               function attendee_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bin[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aaI, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bin[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bin[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bin[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (yes_no_maybe_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       default$ = match$145[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    status = b[2][1],
		    organizer = b[1],
		    name = a[1],
		    email = param[1];
		   return cont([0, email, name, organizer, status]);
		  },
		  function(param, cont){
		   var
		    status = param[4],
		    organizer = param[3],
		    name = param[2],
		    email = param[1];
		   return cont
		           ([0, email, [0, name, [0, organizer, [0, status, 0]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_email,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_name,
		     0,
		     3,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_organizer,
		      0,
		      [0, default$],
		      [0, bool_schema],
		      0,
		      0],
		     [0, [0, 0, 0, 0, 0, cst_status, 0, 3, [0, a], 0, 0], 0]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bin[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bin[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$363 = [];
		               function creator_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$363[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aaJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$363[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$363[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$363[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var name = param[2][1], email = param[1];
		                                 return cont([0, email, name]);
		                                },
		                                function(param, cont){
		                                 var name = param[2], email = param[1];
		                                 return cont([0, email, [0, name, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_email,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$363[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$363[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$393 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bin, [0, schematic_cache$393]);
		               var schematic_cache$394 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$363, [0, schematic_cache$394]);
		               var
		                attendee_schema =
		                  caml_callback
		                   (attendee_schema_versioned$0,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (creator_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$364 = [];
		               function pp_attendee(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         aaK,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aaL,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Event_schema_intf.email",
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aaM,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aaN,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aaO,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aaP,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_name,
		                         function(a){
		                          a = x[2];
		                          function b(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aaR,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aaS,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                aaT,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_organizer,
		                          function(b){
		                           var a = x[3];
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aaU,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                aaV,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aaW,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aaX,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_status,
		      function(a){
		       a = x[4];
		       function b(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 aaY,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt), aaZ, cont);
		                 });
		       }
		       if(! a)
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, fmt, cst_None, b);
		       var x$0 = a[1];
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                fmt,
		                cst_Some,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context$364[1],
		                          fmt,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    x$0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, fmt, cst$18, b);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          if(! a)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_None, b);
		                          var x$0 = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   fmt,
		                                   cst_Some,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aaQ,
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               x$0,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, cst$18, b);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$364, [0, pp_yes_no_maybe]);
		               function merge_attendees(attendee1, attendee2, cont){
		                var status = attendee1[4], match = attendee2[4];
		                function a(status){
		                 var name = first_some(attendee2[2], attendee1[2]);
		                 return cont([0, attendee2[1], name, attendee2[3], status]);
		                }
		                if(! status) return match ? a(match) : a(0);
		                if(! match) return a(status);
		                var right = match[1], left = status[1];
		                return caml_exact_trampoline_cps_call$1
		                        (equal_yes_no_maybe,
		                         left,
		                         right,
		                         function(b){
		                          return b
		                                  ? a(status)
		                                  : caml_exact_trampoline_cps_call
		                                    (warn$0,
		                                     function(m, cont){
		                                      return caml_trampoline_cps_call8
		      (m,
		       0,
		       0,
		       aa0,
		       pp_attendee,
		       attendee1,
		       pp_attendee,
		       attendee2,
		       cont);
		                                     },
		                                     function(match$0){return a(match);});
		                         });
		               }
		               var
		                By_email =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$2, comparator$2, thread_id_schema_versioned]]),
		                underlying$0 = list_schema(attendee_schema);
		               function decode$8(attendees, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (By_email[14],
		                         [0, comparator$2],
		                         attendees,
		                         function(att, cont){return cont(att[1]);},
		                         merge_attendees,
		                         function(v){return cont([0, v]);});
		               }
		               function encode$9(attendees, cont){
		                return caml_exact_trampoline_cps_call(encode, attendees, cont);
		               }
		               var
		                attendees_schema = map$14(decode$8, encode$9, underlying$0),
		                bio = [];
		               function calendar_status_schema_version
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bio[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aa1, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bio[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bio[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bio[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aa7);},
		                                  0,
		                                  0,
		                                  cst_confirmed,
		                                  cst_Confirmed,
		                                  aa6,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aa5) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_tentative,
		                                   cst_Tentative,
		                                   aa4,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(aa3) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_cancelled,
		                                    cst_Cancelled,
		                                    aa2,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bio[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bio[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$365 = [];
		               function link_type_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$365[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aa8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$365[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$365[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$365[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(abg);},
		                                  0,
		                                  0,
		                                  cst_discord,
		                                  "Discord",
		                                  abf,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(abe) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_meet,
		                                   "Meet",
		                                   abd,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(abc) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_teams,
		                                    "Teams",
		                                    abb,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(aba) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_whereby,
		                                     "Whereby",
		                                     aa$,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 <= param ? cont(aa_) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_zoom,
		                                      "Zoom",
		                                      aa9,
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$365[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$365[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$395 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bio, [0, schematic_cache$395]);
		               var schematic_cache$396 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$365, [0, schematic_cache$396]);
		               caml_callback
		                (calendar_status_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (link_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function equal_calendar_status(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               function equal_link_type(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  case 2:
		                   if(2 === rhs) return cont(1); break;
		                  case 3:
		                   if(3 === rhs) return cont(1); break;
		                  default: if(4 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var letrec_function_context$366 = [];
		               function link_schema_versioned$1(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$366[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, abh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$366[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$366[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$366[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (link_type_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var type = param[2][1], url = param[1];
		   return cont([0, url, type]);
		  },
		  function(param, cont){
		   var type = param[2], url = param[1];
		   return cont([0, url, [0, type, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$262], 0, 0],
		   [0, [0, 0, 0, 0, 0, cst_type, 0, 3, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$366[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$366[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$397 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$366, [0, schematic_cache$397]);
		               caml_callback
		                (link_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$367 = [];
		               function equal_link(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$367[2],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(! c) return cont(c);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$367[1], a, b, cont);
		                           }
		                          }
		                          else if(! y) return cont(1);
		                          return cont(0);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$367, [0, equal_link_type, equal$44]);
		               var
		                open$10 =
		                  g
		                   ([0,
		                     symbol_bind$5,
		                     symbol_map$5,
		                     ,
		                     bind$8,
		                     return$9,
		                     map$17,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$3]),
		                let$16 = open$10[3];
		               function to_availability(override, is_full_day){
		                if(! override) return is_full_day ? 1 : 0;
		                var availability = override[1];
		                return availability;
		               }
		               function Moded$10(M, Name, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[10],
		                          function(x, y, cont){
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context[11], a, b, cont);
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          },
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(b){
		                                     function a(d){
		                                      function c(d){
		                                       function c(b){
		function a(b){
		 function a(a){
		  if(! a) return cont(a);
		  var b = rhs[7], c = lhs[7];
		  return caml_trampoline_cps_call2
		          (letrec_function_context[1],
		           function(x, y, cont){
		            if(x){
		             if(y){
		              var b = y[1], a = x[1];
		              return caml_trampoline_cps_call3
		                      (letrec_function_context[2], a, b, cont);
		             }
		            }
		            else if(! y) return cont(1);
		            return cont(0);
		           },
		           function(a){
		            return caml_trampoline_cps_call3(a, c, b, cont);
		           });
		 }
		 if(! b) return a(b);
		 var c = rhs[6], d = lhs[6];
		 return caml_trampoline_cps_call2
		         (letrec_function_context[3],
		          letrec_function_context[4],
		          function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		}
		if(! b) return a(b);
		var c = rhs[5], d = lhs[5];
		return caml_trampoline_cps_call2
		        (letrec_function_context[5],
		         function(a, b, cont){return cont(a === b ? 1 : 0);},
		         function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                       }
		                                       if(! d) return c(d);
		                                       var y = rhs[4], x = lhs[4];
		                                       if(x){
		if(y){
		 var b = y[1], a = x[1];
		 return caml_trampoline_cps_call3
		         (letrec_function_context[6], a, b, c);
		}
		                                       }
		                                       else if(! y) return c(1);
		                                       return c(0);
		                                      }
		                                      if(! d) return c(d);
		                                      var y = rhs[3], x = lhs[3];
		                                      if(x){
		                                       if(y){
		var b = y[1], a = x[1];
		return caml_trampoline_cps_call3
		        (letrec_function_context[7], a, b, c);
		                                       }
		                                      }
		                                      else if(! y) return c(1);
		                                      return c(0);
		                                     }
		                                     if(! b) return a(b);
		                                     var c = rhs[2], d = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[8],
		      function(x, y, cont){
		       if(x){
		        if(y){
		         var b = y[1], a = x[1];
		         return caml_trampoline_cps_call3
		                 (letrec_function_context[9], a, b, cont);
		        }
		       }
		       else if(! y) return cont(1);
		       return cont(0);
		      },
		      function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                    });
		                          });
		                }
		                var _10 = M[9], _8 = M[9], _6 = M[9], _3 = M[9], _1 = M[9];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0,
		                   _10,
		                   equal$55,
		                   _8,
		                   equal$75,
		                   _6,
		                   equal$4,
		                   equal$4,
		                   _3,
		                   equal_attendance,
		                   _1,
		                   equal$20]);
		                var letrec_function_context$0 = [];
		                function compare(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context$0[11],
		                          function(x, y, cont){
		                           if(! x) return y ? cont(-1) : cont(0);
		                           var a = x[1];
		                           if(! y) return cont(1);
		                           var b = y[1];
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context$0[12], a, b, cont);
		                          },
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(x){
		                                     if(0 !== x) return cont(x);
		                                     var a = rhs[2], b = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context$0[9],
		      function(x, y, cont){
		       if(! x) return y ? cont(-1) : cont(0);
		       var a = x[1];
		       if(! y) return cont(1);
		       var b = y[1];
		       return caml_trampoline_cps_call3
		               (letrec_function_context$0[10], a, b, cont);
		      },
		      function(c){
		       return caml_trampoline_cps_call3
		               (c,
		                b,
		                a,
		                function(x){
		                 if(0 !== x) return cont(x);
		                 var y = rhs[3], x$0 = lhs[3];
		                 function c(x){
		                  if(0 !== x) return cont(x);
		                  var y = rhs[4], x$0 = lhs[4];
		                  function c(x){
		                   if(0 !== x) return cont(x);
		                   var a = rhs[5], b = lhs[5];
		                   return caml_trampoline_cps_call2
		                           (letrec_function_context$0[6],
		                            0,
		                            function(c){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$0[5],
		                                      c,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (c,
		        b,
		        a,
		        function(x){
		         if(0 !== x) return cont(x);
		         var a = rhs[6], b = lhs[6];
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$0[3],
		                  letrec_function_context$0[4],
		                  function(c){
		                   return caml_trampoline_cps_call3
		                           (c,
		                            b,
		                            a,
		                            function(x){
		                             if(0 !== x) return cont(x);
		                             var a = rhs[7], b = lhs[7];
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$0[1],
		                                      function(x, y, cont){
		                                       if(! x) return y ? cont(-1) : cont(0);
		                                       var a = x[1];
		                                       if(! y) return cont(1);
		                                       var b = y[1];
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context$0[2], a, b, cont);
		                                      },
		                                      function(c){
		                                       return caml_trampoline_cps_call3(c, b, a, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  }
		                  if(! x$0) return y ? c(-1) : c(0);
		                  var a = x$0[1];
		                  if(! y) return c(1);
		                  var b = y[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$0[7], a, b, c);
		                 }
		                 if(! x$0) return y ? c(-1) : c(0);
		                 var a = x$0[1];
		                 if(! y) return c(1);
		                 var b = y[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context$0[8], a, b, c);
		                });
		      });
		                                    });
		                          });
		                }
		                var _11 = M[10], _9 = M[10], _7 = M[10];
		                function _6$0(param, a, b, cont){
		                 return cont(caml_int_compare(a, b));
		                }
		                var _3$0 = M[10], _1$0 = M[10];
		                caml_update_dummy
		                 (letrec_function_context$0,
		                  [0,
		                   _11,
		                   compare$68,
		                   _9,
		                   compare$92,
		                   _7,
		                   _6$0,
		                   compare$4,
		                   compare$4,
		                   _3$0,
		                   compare_attendance,
		                   _1$0,
		                   compare$37]);
		                var
		                 cst_google_event_missing = "google_event_missing",
		                 letrec_function_context$1 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$1[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      var cst_api_event = "api-event-";
		                                      return caml_trampoline_cps_call3
		      (map$17,
		       Name[1],
		       function(s2, cont){return cont(cst_api_event + s2);},
		       function(match){
		        var schematic_parametric = match ? 0 : 0;
		        return caml_trampoline_cps_call3
		                (map$17,
		                 Name[1],
		                 function(s2, cont){return cont(cst_api_event + s2);},
		                 function(a){
		                  return cont([0, a, 0, descriptor, schematic_parametric]);
		                 });
		       });
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$1[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$1[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$1[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$109,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        a,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var
		                    default$ = M[5].call(null, 0),
		                    a =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_task, 0, [0, default$], [0, b], 0, 0],
		                       0];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$140,
		                            schematic_version,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      b,
		                                      function(c){
		                                       var
		default$ = M[5].call(null, abi),
		b =
		  [0,
		   [0, 0, 0, 0, 0, cst_notes, 0, [0, default$], [0, c], 0, 0],
		   a];
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        bool_schema,
		        function(c){
		         var
		          default$ = M[5].call(null, 0),
		          a =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_google_event_missing,
		              0,
		              [0, default$],
		              [0, c],
		              0,
		              0],
		             b];
		         return caml_exact_trampoline_cps_call
		                 (option_schema,
		                  schematic_param_name_schema_ve,
		                  function(c){
		                   var
		                    default$ = match$146[1],
		                    b =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_google_event_id,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$16,
		                            schematic_version,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      a,
		                                      function(c){
		                                       var
		default$ = match$147[1],
		a =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_google_calendar_id,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (attendance_schema_versioned,
		        schematic_version,
		        function(b){
		         return caml_exact_trampoline_cps_call
		                 (option_schema,
		                  b,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            b,
		                            function(c){
		                             var
		                              default$ = M[5].call(null, 0),
		                              b =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_attendance,
		                                  0,
		                                  [0, default$],
		                                  [0, c],
		                                  0,
		                                  0],
		                                 a];
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$4,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        a,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(a){
		                   var
		                    default$ = M[5].call(null, 0),
		                    res =
		                      [7,
		                       function(param, cont){
		                        var
		                         a = param[2],
		                         b = a[2],
		                         c = b[2],
		                         d = c[2],
		                         e = d[2],
		                         task = e[2][1],
		                         notes = e[1],
		                         google_event_missing = d[1],
		                         google_event_id = c[1],
		                         google_calendar_id = b[1],
		                         attendance = a[1],
		                         archived = param[1];
		                        return cont
		                                ([0,
		                                  archived,
		                                  attendance,
		                                  google_calendar_id,
		                                  google_event_id,
		                                  google_event_missing,
		                                  notes,
		                                  task]);
		                       },
		                       function(param, cont){
		                        var
		                         task = param[7],
		                         notes = param[6],
		                         google_event_missing = param[5],
		                         google_event_id = param[4],
		                         google_calendar_id = param[3],
		                         attendance = param[2],
		                         archived = param[1];
		                        return cont
		                                ([0,
		                                  archived,
		                                  [0,
		                                   attendance,
		                                   [0,
		                                    google_calendar_id,
		                                    [0,
		                                     google_event_id,
		                                     [0, google_event_missing, [0, notes, [0, task, 0]]]]]]]);
		                       },
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_archived,
		                         0,
		                         [0, default$],
		                         [0, a],
		                         0,
		                         0],
		                        b]];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$1[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context$1[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$1, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    abj,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abk,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Event_schema.Before_crdt.Moded.archived",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[10],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[11],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abl,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                abm,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          abn,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_attendance,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[8],
		      function(fmt, param, cont){
		       if(! param)
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, fmt, cst_None, cont);
		       var x = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                fmt,
		                cst_Some,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[9],
		                          fmt,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    x,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, fmt, cst$18, cont);
		                                    });
		                          });
		                });
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          abo,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    abp,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abq,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_google_calendar_id,
		                function(a){
		                 a = x[3];
		                 function b(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           abr,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     abt,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       abu,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 cst_google_event_id,
		                 function(a){
		                  a = x[4];
		                  function b(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            abv,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      abw,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        abx,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a,
		                  cst_google_event_missing,
		                  function(b){
		                   var a = x[5];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context[5],
		                            function(fmt, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt), aby, cont);
		                            },
		                            fmt,
		                            function(b){
		                             return caml_trampoline_cps_call2
		                                     (b,
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        abz,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  abA,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            abB,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a,
		                                      cst_notes,
		                                      function(b){
		                                       var a = x[6];
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context[3],
		        function(fmt, cont){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context[4], fmt, cont);
		        },
		        fmt,
		        function(b){
		         return caml_trampoline_cps_call2
		                 (b,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            abC,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      abD,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        abE,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a,
		                  cst_task,
		                  function(b){
		                   var a = x[7];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context[1],
		                            function(fmt, param, cont){
		                             if(! param)
		                              return caml_exact_trampoline_cps_call$1
		                                      (pp_print_string, fmt, cst_None, cont);
		                             var x = param[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string,
		                                      fmt,
		                                      cst_Some,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (letrec_function_context[2],
		        fmt,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a,
		                  x,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst$18, cont);
		                  });
		        });
		                                      });
		                            },
		                            fmt,
		                            function(b){
		                             return caml_trampoline_cps_call2
		                                     (b,
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        abF,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), abG, cont);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  }
		                  if(! a)
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_None, b);
		                  var x$0 = a[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           cst_Some,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (letrec_function_context[6],
		                                     fmt,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a,
		       x$0,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, fmt, cst$18, b);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 }
		                 if(! a)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst_None, b);
		                 var x$0 = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          cst_Some,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[7],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      x$0,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst$18, b);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var _10 = M[8], _8 = M[8], _6 = M[8], _3 = M[8], _1 = M[8];
		                          caml_update_dummy
		                           (letrec_function_context,
		                            [0,
		                             _10,
		                             _16$0,
		                             _8,
		                             _13$0,
		                             _6,
		                             pp_print_string,
		                             pp$2,
		                             _3,
		                             pp_attendance,
		                             _1,
		                             _12]);
		                          return cont([0, equal, compare, schema_versioned, , pp]);
		                         });
		               }
		               var name$29 = cst_patch;
		               caml_callback(Moded$10, [W$0, [0, [0, name$29]]]);
		               var
		                name$28 = cst_read,
		                include$308 =
		                  caml_callback(Moded$10, [R$0, [0, [0, name$28]]]),
		                schema_versioned$225 = include$308[3];
		               function make$46
		               (archived,
		                attendance,
		                a,
		                opt,
		                task,
		                google_calendar_id,
		                google_event_id){
		                return [0, archived, attendance];
		               }
		               var letrec_function_context$368 = [];
		               function schema_versioned$226(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$368[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(a){return cont();}
		                                    return match
		    ? a()
		    : caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$368[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$368[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$368[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$225,
		                                      schematic_version,
		                                      function(b){
		                                       var
		a =
		  [0,
		   [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		   [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0]];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$141,
		        schematic_version,
		        function(b){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               writable = a[2][1],
		               id = a[1],
		               etag = param[1];
		              return cont([0, etag, id, writable]);
		             },
		             function(param, cont){
		              var writable = param[3], id = param[2], etag = param[1];
		              return cont([0, etag, [0, id, [0, writable, 0]]]);
		             },
		             [0, [0, abH, 0, 0, 0, cst_etag, 0, 2, [0, b], 0, 0], a]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$368[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$368[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                   });
		                         });
		               }
		               var schematic_cache$398 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$368, [0, schematic_cache$398]);
		               caml_callback
		                (schema_versioned$226,
		                 [function(param, cont){return cont(0);}]);
		               function role(event){
		                var match = event[2];
		                return event[1] ? abI : match ? match[1] ? abJ : abK : 0;
		               }
		               function Moded$11(M, Atomic, Name, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[21],
		                          function(x, y, cont){
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context[22], a, b, cont);
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          },
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(b){
		                                     function a(b){
		                                      function a(b){
		                                       function a(b){
		function a(b){
		 function a(b){
		  function a(b){
		   function a(b){
		    function a(b){
		     function a(a){
		      if(! a) return cont(a);
		      var b = rhs[11], c = lhs[11];
		      return caml_trampoline_cps_call2
		              (letrec_function_context[1],
		               function(a, b, cont){return cont(a === b ? 1 : 0);},
		               function(a){
		                return caml_trampoline_cps_call3(a, c, b, cont);
		               });
		     }
		     if(! b) return a(b);
		     var c = rhs[10], d = lhs[10];
		     return caml_trampoline_cps_call2
		             (letrec_function_context[2],
		              letrec_function_context[3],
		              function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		    }
		    if(! b) return a(b);
		    var c = rhs[9], d = lhs[9];
		    return caml_trampoline_cps_call2
		            (letrec_function_context[5],
		             function(x, y, cont){
		              if(x){
		               if(y){
		                var b = y[1], a = x[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context[6], a, b, cont);
		               }
		              }
		              else if(! y) return cont(1);
		              return cont(0);
		             },
		             function(b){
		              return caml_trampoline_cps_call3
		                      (letrec_function_context[4],
		                       function(a, param, cont){return cont(1);},
		                       b,
		                       function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		             });
		   }
		   if(! b) return a(b);
		   var c = rhs[8], d = lhs[8];
		   return caml_trampoline_cps_call2
		           (letrec_function_context[8],
		            letrec_function_context[9],
		            function(b){
		             return caml_trampoline_cps_call3
		                     (letrec_function_context[7],
		                      function(a, param, cont){return cont(1);},
		                      b,
		                      function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		            });
		  }
		  if(! b) return a(b);
		  var c = rhs[7], d = lhs[7];
		  return caml_trampoline_cps_call2
		          (letrec_function_context[10],
		           function(x, y, cont){
		            if(x){
		             if(y){var b = y[1], a = x[1]; return cont(a === b ? 1 : 0);}
		            }
		            else if(! y) return cont(1);
		            return cont(0);
		           },
		           function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		 }
		 if(! b) return a(b);
		 var c = rhs[6], d = lhs[6];
		 return caml_trampoline_cps_call2
		         (letrec_function_context[11],
		          function(x, y, cont){
		           if(x){
		            if(y){
		             var b = y[1], a = x[1];
		             return caml_trampoline_cps_call3
		                     (letrec_function_context[12], a, b, cont);
		            }
		           }
		           else if(! y) return cont(1);
		           return cont(0);
		          },
		          function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		}
		if(! b) return a(b);
		var c = rhs[5], d = lhs[5];
		return caml_trampoline_cps_call2
		        (letrec_function_context[13],
		         function(x, y, cont){
		          if(x){
		           if(y){var b = y[1], a = x[1]; return cont(a === b ? 1 : 0);}
		          }
		          else if(! y) return cont(1);
		          return cont(0);
		         },
		         function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                       }
		                                       if(! b) return a(b);
		                                       var c = rhs[4], d = lhs[4];
		                                       return caml_trampoline_cps_call2
		       (letrec_function_context[14],
		        function(x, y, cont){
		         if(x){
		          if(y){
		           var b = y[1], a = x[1];
		           return caml_trampoline_cps_call3
		                   (letrec_function_context[15], a, b, cont);
		          }
		         }
		         else if(! y) return cont(1);
		         return cont(0);
		        },
		        function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                      }
		                                      if(! b) return a(b);
		                                      var c = rhs[3], d = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[17],
		       letrec_function_context[18],
		       function(b){
		        return caml_trampoline_cps_call2
		                (letrec_function_context[16],
		                 b,
		                 function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		       });
		                                     }
		                                     if(! b) return a(b);
		                                     var c = rhs[2], d = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[19],
		      function(x, y, cont){
		       if(x){
		        if(y){
		         var b = y[1], a = x[1];
		         return caml_trampoline_cps_call3
		                 (letrec_function_context[20], a, b, cont);
		        }
		       }
		       else if(! y) return cont(1);
		       return cont(0);
		      },
		      function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                    });
		                          });
		                }
		                var
		                 _21 = M[9],
		                 _20 = M[9],
		                 _18 = Atomic[3],
		                 _17 = M[9],
		                 _15 = Atomic[3],
		                 _14 = M[9],
		                 _12$0 = M[9],
		                 _11 = M[9],
		                 _9 = M[9],
		                 _8 = M[9],
		                 _6 = M[9],
		                 _5 = By_email[55],
		                 _3 = M[9],
		                 _1 = M[9];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0,
		                   _21,
		                   _20,
		                   equal$138,
		                   _18,
		                   _17,
		                   equal$55,
		                   _15,
		                   _14,
		                   equal$75,
		                   _12$0,
		                   _11,
		                   equal$99,
		                   _9,
		                   _8,
		                   equal_availability,
		                   _6,
		                   _5,
		                   equal_attendee,
		                   _3,
		                   equal_attendance,
		                   _1,
		                   equal$20]);
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      var a = Name[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$99,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(b){
		                  var a = Name[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$100,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){return cont([0, [0, a], 0, descriptor, 0]);});
		                           });
		                 });
		       });
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      schematic_param_name_schema_ve,
		                                      function(b){
		                                       var a = M[6].call(null, 0), b = [0, b];
		                                       if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                                       var c = [0, [0, 0, 0, 0, 0, cst_title, 0, a, b, 0, 0], 0];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$223,
		        schematic_version,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var a = M[6].call(null, 0), b = [0, b];
		                   if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                   var d = [0, [0, 0, 0, 0, 0, cst_time, 0, a, b, 0, 0], c];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$109,
		                            schematic_version,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(c){
		         var
		          a =
		            [0,
		             Atomic[1].call
		              (null, schematic_version, schematic_param_a_schema_versi, c)],
		          b = M[5].call(null, 0);
		         return caml_trampoline_cps_call2
		                 (Atomic[5],
		                  0,
		                  function(c){
		                   return caml_trampoline_cps_call2
		                           (c,
		                            b,
		                            function(default$){
		                             var
		                              b =
		                                [0, [0, 0, 0, 0, 0, cst_task, 0, [0, default$], a, 0, 0], d];
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$140,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(d){
		         var
		          a =
		            [0,
		             Atomic[1].call
		              (null, schematic_version, schematic_param_a_schema_versi, d)],
		          c = M[5].call(null, abL);
		         return caml_trampoline_cps_call2
		                 (Atomic[5],
		                  0,
		                  function(d){
		                   return caml_trampoline_cps_call2
		                           (d,
		                            c,
		                            function(default$){
		                             var
		                              c =
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_notes, 0, [0, default$], a, 0, 0],
		                                 b];
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      schematic_param_name_schema_ve,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(b){
		         var
		          default$ = M[5].call(null, 0),
		          a =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_location,
		              0,
		              [0, default$],
		              [0, b],
		              0,
		              0],
		             c];
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$172,
		                  schematic_version,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (option_schema,
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      b,
		                                      function(c){
		                                       var
		default$ = M[5].call(null, 0),
		b =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_extension_row,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   a];
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        schematic_param_name_schema_ve,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(c){
		                   var
		                    default$ = M[5].call(null, 0),
		                    a =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_description,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       b];
		                   return caml_exact_trampoline_cps_call
		                           (availability_schema_versioned,
		                            schematic_version,
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        b,
		        function(c){
		         var
		          default$ = M[5].call(null, 0),
		          b =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_availability_override,
		              0,
		              [0, default$],
		              [0, c],
		              0,
		              0],
		             a];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  attendees_schema,
		                  function(c){
		                   var
		                    default$ = M[5].call(null, By_email[111]),
		                    a =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_attendees,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       b];
		                   return caml_exact_trampoline_cps_call
		                           (attendance_schema_versioned,
		                            schematic_version,
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        b,
		        function(c){
		         var
		          default$ = M[5].call(null, 0),
		          b =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_attendance,
		              0,
		              [0, default$],
		              [0, c],
		              0,
		              0],
		             a];
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$4,
		                  schematic_version,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (option_schema,
		                            a,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      a,
		                                      function(a){
		                                       var
		default$ = M[5].call(null, 0),
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     b = a[2],
		     c = b[2],
		     d = c[2],
		     e = d[2],
		     f = e[2],
		     g = f[2],
		     h = g[2],
		     i = h[2],
		     title = i[2][1],
		     time = i[1],
		     task = h[1],
		     notes = g[1],
		     location = f[1],
		     extension_row = e[1],
		     description = d[1],
		     availability_override = c[1],
		     attendees = b[1],
		     attendance = a[1],
		     archived = param[1];
		    return cont
		            ([0,
		              archived,
		              attendance,
		              attendees,
		              availability_override,
		              description,
		              extension_row,
		              location,
		              notes,
		              task,
		              time,
		              title]);
		   },
		   function(param, cont){
		    var
		     title = param[11],
		     time = param[10],
		     task = param[9],
		     notes = param[8],
		     location = param[7],
		     extension_row = param[6],
		     description = param[5],
		     availability_override = param[4],
		     attendees = param[3],
		     attendance = param[2],
		     archived = param[1];
		    return cont
		            ([0,
		              archived,
		              [0,
		               attendance,
		               [0,
		                attendees,
		                [0,
		                 availability_override,
		                 [0,
		                  description,
		                  [0,
		                   extension_row,
		                   [0,
		                    location,
		                    [0, notes, [0, task, [0, time, [0, title, 0]]]]]]]]]]]);
		   },
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_archived,
		     0,
		     [0, default$],
		     [0, a],
		     0,
		     0],
		    b]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context$0[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context$0[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    abM,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abN,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Event_schema.Moded.archived",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[21],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[22],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abO,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                abP,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          abQ,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_attendance,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[19],
		      function(fmt, param, cont){
		       if(! param)
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, fmt, cst_None, cont);
		       var x = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                fmt,
		                cst_Some,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[20],
		                          fmt,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    x,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, fmt, cst$18, cont);
		                                    });
		                          });
		                });
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          abR,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    abS,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abT,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_attendees,
		                function(b){
		                 var a = x[3];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[16],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context[17],
		                                    function(fmt, cont){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[18], fmt, cont);
		                                    },
		                                    fmt,
		                                    cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abU,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                abV,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          abW,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_availability_override,
		                                    function(b){
		                                     var a = x[4];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[14],
		      function(fmt, param, cont){
		       if(! param)
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, fmt, cst_None, cont);
		       var x = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                fmt,
		                cst_Some,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[15],
		                          fmt,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    x,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, fmt, cst$18, cont);
		                                    });
		                          });
		                });
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          abX,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    abY,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      abZ,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_description,
		                function(b){
		                 var a = x[5];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[13],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ab0,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ab1,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ab2,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ab3,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_extension_row,
		                                    function(b){
		                                     var a = x[6];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[11],
		      function(fmt, param, cont){
		       if(! param)
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, fmt, cst_None, cont);
		       var x = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                fmt,
		                cst_Some,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[12],
		                          fmt,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    x,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, fmt, cst$18, cont);
		                                    });
		                          });
		                });
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ab4,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ab5,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ab6,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_location,
		                function(b){
		                 var a = x[7];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[10],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ab7,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ab8,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ab9,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ab_,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_notes,
		                                    function(b){
		                                     var a = x[8];
		                                     return caml_trampoline_cps_call4
		     (letrec_function_context[7],
		      function(fmt, param, cont){
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst$17, cont);
		      },
		      function(fmt, cont){
		       return caml_trampoline_cps_call3
		               (letrec_function_context[8],
		                function(fmt, cont){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[9], fmt, cont);
		                },
		                fmt,
		                cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ab$,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aca,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      acb,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_task,
		                function(b){
		                 var a = x[9];
		                 return caml_trampoline_cps_call4
		                         (letrec_function_context[4],
		                          function(fmt, param, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst$17, cont);
		                          },
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context[5],
		                                    function(fmt, param, cont){
		                                     if(! param)
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, fmt, cst_None, cont);
		                                     var x = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string,
		      fmt,
		      cst_Some,
		      function(a){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[6],
		                fmt,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          x,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst$18, cont);
		                          });
		                });
		      });
		                                    },
		                                    fmt,
		                                    cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      acd,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ace,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          acf,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_time,
		                                    function(b){
		                                     var a = x[10];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[2],
		      function(fmt, cont){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[3], fmt, cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          acg,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ach,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aci,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_title,
		                function(b){
		                 var a = x[11];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[1],
		                          function(fmt, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt), acj, cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ack,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), acl, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var
		                           _21 = M[8],
		                           _20 = M[8],
		                           _18 = Atomic[4],
		                           _17 = M[8],
		                           _15 = Atomic[4],
		                           _14 = M[8],
		                           _12$0 = M[8],
		                           _11 = M[8],
		                           _9 = M[8],
		                           _8 = M[8],
		                           _6 = M[8],
		                           _5 = By_email[128],
		                           _3 = M[8],
		                           _1 = M[8];
		                          caml_update_dummy
		                           (letrec_function_context,
		                            [0,
		                             _21,
		                             _20,
		                             _19,
		                             _18,
		                             _17,
		                             _16$0,
		                             _15,
		                             _14,
		                             _13$0,
		                             _12$0,
		                             _11,
		                             _10$1,
		                             _9,
		                             _8,
		                             pp_availability,
		                             _6,
		                             _5,
		                             pp_attendee,
		                             _3,
		                             pp_attendance,
		                             _1,
		                             _12]);
		                          var name = [0, Name[1]];
		                          return caml_exact_trampoline_cps_call$1
		                                  (Moded$10,
		                                   M,
		                                   [0, name],
		                                   function(Before_crdt){
		                                    return cont([0, equal, schema_versioned, schema, pp]);
		                                   });
		                         });
		               }
		               var Read_name$0 = [0, name$28], Patch_name$0 = [0, name$29];
		               function Make_writable(Atomic, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (Moded$11,
		                         R$0,
		                         [0, Atomic[1], , Atomic[3], Atomic[4], Atomic[5]],
		                         Read_name$0,
		                         function(Read){
		                          return caml_exact_trampoline_cps_call$0
		                                  (Moded$11,
		                                   W$0,
		                                   [0, Atomic[1], , Atomic[3], Atomic[4], Atomic[5]],
		                                   Patch_name$0,
		                                   function(Patch){
		                                    function diff(previous, event, cont){
		                                     var curr = event[1], prev = previous[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (equal_option,
		      equal$20,
		      prev,
		      curr,
		      function(a){
		       var
		        archived = some_if(1 - a, curr),
		        curr$0 = event[2],
		        prev = previous[2];
		       return caml_exact_trampoline_cps_call$0
		               (equal_option,
		                equal_attendance,
		                prev,
		                curr$0,
		                function(a){
		                 var
		                  attendance = some_if(1 - a, curr$0),
		                  attendees = [0, event[3]],
		                  curr = event[4],
		                  prev = previous[4];
		                 return caml_exact_trampoline_cps_call$0
		                         (equal_option,
		                          equal_availability,
		                          prev,
		                          curr,
		                          function(a){
		                           var
		                            availability_override = some_if(1 - a, curr),
		                            curr$0 = event[5],
		                            prev = previous[5];
		                           a:
		                           {
		                            if(prev){
		                             if(curr$0){
		                              var x = curr$0[1], x$0 = prev[1], a = x$0 === x;
		                              break a;
		                             }
		                            }
		                            else if(! curr$0){a = 1; break a;}
		                            a = 0;
		                           }
		                           var
		                            description = some_if(1 - a, curr$0),
		                            curr$1 = event[6],
		                            prev$0 = previous[6];
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_option,
		                                    equal$99,
		                                    prev$0,
		                                    curr$1,
		                                    function(a){
		                                     var
		                                      extension_row = some_if(1 - a, curr$1),
		                                      curr = event[7],
		                                      prev = previous[7];
		                                     a:
		                                     {
		                                      if(prev){
		                                       if(curr){
		var x = curr[1], x$0 = prev[1], a = x$0 === x;
		break a;
		                                       }
		                                      }
		                                      else if(! curr){a = 1; break a;}
		                                      a = 0;
		                                     }
		                                     var location = some_if(1 - a, curr);
		                                     return caml_trampoline_cps_call4
		     (Atomic[7],
		      function(a, cont){return cont(a);},
		      return$9,
		      event[8],
		      function(notes){
		       var a = Atomic[10].call(null, previous[9], event[9]);
		       return caml_exact_trampoline_cps_call$1
		               (Atomic[7],
		                function(param, cont){return cont(0);},
		                function(param, cont){
		                 var current = param[2], previous = param[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (equal_option,
		                          equal$55,
		                          previous,
		                          current,
		                          function(a){return cont(some_if(1 - a, current));});
		                },
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(task){
		                           var curr = event[10], prev = previous[10];
		                           return caml_exact_trampoline_cps_call$1
		                                   (equal$138,
		                                    prev,
		                                    curr,
		                                    function(a){
		                                     var
		                                      time = some_if(1 - a, curr),
		                                      curr$0 = event[11],
		                                      prev = previous[11],
		                                      title = some_if(1 - (prev === curr$0), curr$0);
		                                     return cont
		     ([0,
		       archived,
		       attendance,
		       attendees,
		       availability_override,
		       description,
		       extension_row,
		       location,
		       notes,
		       task,
		       time,
		       title]);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return cont([0, Read, Patch, diff]);
		                                   });
		                         });
		               }
		               var
		                Writable_atomic =
		                  caml_callback
		                   (Make_writable,
		                    [[0,
		                      schema_versioned$190,
		                      ,
		                      equal$110,
		                      pp$73,
		                      return$21,
		                      ,
		                      map$35,
		                      ,
		                      ,
		                      both$1]]),
		                Writable_composite =
		                  caml_callback
		                   (Make_writable,
		                    [[0,
		                      schema_versioned$191,
		                      ,
		                      equal$111,
		                      pp$74,
		                      return$22,
		                      ,
		                      map$36,
		                      ,
		                      ,
		                      both$2]]),
		                include$83 = Writable_composite[1],
		                equal$139 = include$83[1],
		                schema_versioned$227 = include$83[2];
		               function make$47
		               (archived,
		                attendance,
		                a,
		                availability_override,
		                description,
		                extension_row,
		                location,
		                opt,
		                task,
		                time,
		                title){
		                var
		                 attendees = a ? a[1] : By_email[111],
		                 notes = opt ? opt[1] : acm;
		                return [0,
		                        archived,
		                        attendance,
		                        attendees,
		                        availability_override,
		                        description,
		                        extension_row,
		                        location,
		                        notes,
		                        task,
		                        time,
		                        title];
		               }
		               function availability(event){
		                var a = is_full_day(event[10]);
		                return to_availability(event[4], a);
		               }
		               var
		                include$84 = Writable_atomic[1],
		                schema_versioned$228 = include$84[2],
		                include$85 = Writable_composite[2],
		                schema_versioned$229 = include$85[2],
		                schema$89 = include$85[3],
		                diff$0 = Writable_composite[3],
		                schematic_cache$399 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$369 = [];
		               caml_update_dummy
		                (letrec_function_context$369, [0, schematic_cache$399]);
		               function schematic_version$57(param, cont){return cont(0);}
		               var schematic_schema_version$121 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$369[1][1],
		                    schematic_schema_version$121]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$369[1][1],
		                             schematic_schema_version$121,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$369[1][1],
		schematic_schema_version$121,
		schematic_self,
		function(a){
		 letrec_function_context$369[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$229,
		          schematic_version$57,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var patch = param[2][1], id = param[1];
		                return cont([0, id, patch]);
		               },
		               function(param, cont){
		                var patch = param[2], id = param[1];
		                return cont([0, id, [0, patch, 0]]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		                [0, [0, 0, 0, 0, 0, cst_patch, 0, 2, [1, a], 0, 0], 0]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$369[1][1],
		                    schematic_schema_version$121,
		                    res,
		                    function(a){
		                     letrec_function_context$369[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$370 = [];
		               function creation_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$370[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, acn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$370[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$370[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$370[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$227,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, bool_schema], 0, 0],
		  [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$16,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              writable = a[2][1],
		              draft = a[1],
		              calendar = param[1];
		             return cont([0, calendar, draft, writable]);
		            },
		            function(param, cont){
		             var
		              writable = param[3],
		              draft = param[2],
		              calendar = param[1];
		             return cont([0, calendar, [0, draft, [0, writable, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_calendar, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$370[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$370[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$400 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$370, [0, schematic_cache$400]);
		               var
		                creation_schema =
		                  caml_callback
		                   (creation_schema_versioned$0,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$371 = [];
		               function equal$140(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$371[8],
		                         lhs[1],
		                         rhs[1],
		                         function(d){
		                          function c(d){
		                           function c(d){
		                            if(d) var b = rhs[4], a = lhs[4], d = a === b ? 1 : 0;
		                            function c(b){
		                             function a(d){
		                              function c(d){
		                               function c(a){
		                                return a
		? caml_trampoline_cps_call3
		  (letrec_function_context$371[1], lhs[9], rhs[9], cont)
		: cont(a);
		                               }
		                               if(! d) return c(d);
		                               var y = rhs[8], x = lhs[8];
		                               if(x){
		                                if(y){
		                                 var b = y[1], a = x[1];
		                                 return caml_trampoline_cps_call3
		 (letrec_function_context$371[2], a, b, c);
		                                }
		                               }
		                               else if(! y) return c(1);
		                               return c(0);
		                              }
		                              if(! d) return c(d);
		                              var y = rhs[7], x = lhs[7];
		                              if(x){
		                               if(y){
		                                var b = y[1], a = x[1];
		                                return caml_trampoline_cps_call3
		(letrec_function_context$371[3], a, b, c);
		                               }
		                              }
		                              else if(! y) return c(1);
		                              return c(0);
		                             }
		                             return b
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$371[4], lhs[6], rhs[6], a)
		                                     : a(b);
		                            }
		                            if(! d) return c(d);
		                            var y = rhs[5], x = lhs[5];
		                            if(x){
		                             if(y){
		                              var b$0 = y[1], a$0 = x[1];
		                              return caml_trampoline_cps_call3
		                                      (letrec_function_context$371[5], a$0, b$0, c);
		                             }
		                            }
		                            else if(! y) return c(1);
		                            return c(0);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$371[6], a, b, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          if(! d) return c(d);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$371[7], a, b, c);
		                           }
		                          }
		                          else if(! y) return c(1);
		                          return c(0);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$371,
		                 [0,
		                  equal$139,
		                  equal$120,
		                  equal_link,
		                  equal$51,
		                  equal$4,
		                  equal_creator,
		                  equal_calendar_status,
		                  equal$4]);
		               var cst_slot = "slot", letrec_function_context$372 = [];
		               function schema_versioned$230(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$372[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aco, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$372[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$372[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$372[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_start, 0, 0, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$224,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, "isArchived", 0, 0, [0, bool_schema], 0, 0],
		            [0, [0, 0, 0, 0, 0, cst_role, 0, 1, [0, c], 0, 0], a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, "allDay", 0, 0, [0, bool_schema], 0, 0],
		                      [0, [0, 0, 0, 0, 0, cst_end, 0, 0, [0, c], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$227,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$202,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_slot, 0, 3, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (link_schema_versioned$1,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, bool_schema], 0, 0],
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_google_event_id,
		              0,
		              3,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		              [0, [0, 0, 0, 0, 0, cst_link, 0, 3, [0, c], 0, 0], a]]]];
		        return caml_exact_trampoline_cps_call
		                (creator_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_creator, 0, 3, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (calendar_status_schema_version,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_calendar_status, 0, 3, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$16,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    writable = g[2][1],
		    type = g[1],
		    link = f[1],
		    id = e[1],
		    google_event_id = d[1],
		    draft = c[1],
		    creator = b[1],
		    calendar_status = a[1],
		    calendar = param[1];
		   return cont
		           ([0,
		             calendar,
		             calendar_status,
		             creator,
		             draft,
		             google_event_id,
		             id,
		             link,
		             type,
		             writable]);
		  },
		  function(a, cont){
		   var
		    writable = a[9],
		    type = a[8],
		    link = a[7],
		    id = a[6],
		    google_event_id = a[5],
		    draft = a[4],
		    creator = a[3],
		    calendar_status = a[2],
		    calendar = a[1],
		    a = writable[10];
		   function b(c){
		    c =
		     [0,
		      [0,
		       role(make$46(writable[1], writable[2], 0, [0, writable[8]]))],
		      [0, [0, c], 0]];
		    var
		     a = is_some(writable[1]),
		     a = a || caml_equal(calendar_status, acp),
		     param = writable[10],
		     d = [0, [0, a], c];
		    function b(a){
		     a = [0, [0, a], d];
		     var b = 2 === writable[10][0] ? 0 : 1;
		     return cont
		             ([0,
		               calendar,
		               [0,
		                calendar_status,
		                [0,
		                 creator,
		                 [0,
		                  draft,
		                  [0,
		                   google_event_id,
		                   [0, id, [0, link, [0, type, [0, writable, [0, [0, b], a]]]]]]]]]]);
		    }
		    switch(param[0]){
		      case 0:
		       var date = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (add_days,
		                date,
		                1,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (to_time$1, timezone_local, a, b);
		                });
		      case 1:
		       var end = param[2];
		       return caml_exact_trampoline_cps_call$1
		               (add_days,
		                end,
		                1,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (to_time$1, timezone_local, a, b);
		                });
		      default: var end$0 = param[2]; return b(end$0);
		    }
		   }
		   if(2 === a[0]){var start = a[1]; return b(start);}
		   var date = a[1];
		   return caml_exact_trampoline_cps_call$1
		           (to_time$1, timezone_local, date, b);
		  },
		  [0, [0, 0, 0, 0, 0, cst_calendar, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$372[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$372[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$401 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$372, [0, schematic_cache$401]);
		               var
		                schema$90 =
		                  caml_callback
		                   (schema_versioned$230,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$373 = [];
		               function schema_versioned$231(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$373[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(a){return cont();}
		                                    return match
		    ? a()
		    : caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$373[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$373[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$373[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$228,
		                                      schematic_version,
		                                      function(b){
		                                       var
		a =
		  [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$202,
		        schematic_version,
		        function(c){
		         var
		          b = [0, [0, 0, 0, 0, 0, cst_slot, 0, 3, [0, c], 0, 0], a];
		         return caml_exact_trampoline_cps_call
		                 (link_schema_versioned$1,
		                  schematic_version,
		                  function(c){
		                   var
		                    a =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, bool_schema], 0, 0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_google_event_id,
		                         0,
		                         3,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		                         [0, [0, 0, 0, 0, 0, cst_link, 0, 3, [0, c], 0, 0], b]]]];
		                   return caml_exact_trampoline_cps_call
		                           (creator_schema_versioned,
		                            schematic_version,
		                            function(c){
		                             var
		                              b = [0, [0, 0, 0, 0, 0, cst_creator, 0, 3, [0, c], 0, 0], a];
		                             return caml_exact_trampoline_cps_call
		                                     (calendar_status_schema_version,
		                                      schematic_version,
		                                      function(c){
		                                       var
		a =
		  [0,
		   [0, 0, 0, 0, 0, cst_calendar_status, 0, 3, [0, c], 0, 0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$16,
		        schematic_version,
		        function(b){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               b = a[2],
		               c = b[2],
		               d = c[2],
		               e = d[2],
		               f = e[2],
		               g = f[2],
		               writable = g[2][1],
		               type = g[1],
		               link = f[1],
		               id = e[1],
		               google_event_id = d[1],
		               draft = c[1],
		               creator = b[1],
		               calendar_status = a[1],
		               calendar = param[1];
		              return cont
		                      ([0,
		                        calendar,
		                        calendar_status,
		                        creator,
		                        draft,
		                        google_event_id,
		                        id,
		                        link,
		                        type,
		                        writable]);
		             },
		             function(param, cont){
		              var
		               writable = param[9],
		               type = param[8],
		               link = param[7],
		               id = param[6],
		               google_event_id = param[5],
		               draft = param[4],
		               creator = param[3],
		               calendar_status = param[2],
		               calendar = param[1];
		              return cont
		                      ([0,
		                        calendar,
		                        [0,
		                         calendar_status,
		                         [0,
		                          creator,
		                          [0,
		                           draft,
		                           [0,
		                            google_event_id,
		                            [0, id, [0, link, [0, type, [0, writable, 0]]]]]]]]]);
		             },
		             [0, [0, 0, 0, 0, 0, cst_calendar, 0, 2, [0, b], 0, 0], a]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$373[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$373[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                   });
		                         });
		               }
		               var schematic_cache$402 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$373, [0, schematic_cache$402]);
		               caml_callback
		                (schema_versioned$231,
		                 [function(param, cont){return cont(0);}]);
		               function of_creation
		               (calendar_status,
		                creator,
		                google_event_id,
		                link,
		                slot,
		                id,
		                param){
		                var
		                 writable = param[3],
		                 draft = param[2],
		                 calendar = param[1];
		                return [0,
		                        calendar,
		                        calendar_status,
		                        creator,
		                        draft,
		                        google_event_id,
		                        id,
		                        link,
		                        slot,
		                        writable];
		               }
		               function id$34(t){return t[6];}
		               caml_callback(M$3, [[0, comparator$14, schema_versioned$102]]);
		               function attendees_self(calendar, event, cont){
		                var self_email = to_string$43(calendar[2]);
		                return caml_exact_trampoline_cps_call$1
		                        (By_email[25], event[9][3], self_email, cont);
		               }
		               function will_attend(calendar, event, cont){
		                function a(param, cont){
		                 var status = param[4];
		                 return cont(status);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (attendees_self,
		                         calendar,
		                         event,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$16, b, a, cont);
		                         });
		               }
		               function role$0(calendar, event, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (will_attend,
		                         calendar,
		                         event,
		                         function(match){
		                          if(match && 1 === match[1]) return cont(acq);
		                          return cont
		                                  (role
		                                    (make$46(event[9][1], event[9][2], 0, [0, event[9][8]])));
		                         });
		               }
		               function active$1(calendar, event, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (role$0,
		                         calendar,
		                         event,
		                         function(match){
		                          return match
		                                  ? match[1] ? cont(0) : cont(1)
		                                  : cont(active$0(calendar));
		                         });
		               }
		               function availability$0(event){return availability(event[9]);}
		               function patch$2(event, patch){
		                var
		                 writable = event[9],
		                 title = patch[11],
		                 time = patch[10],
		                 task = patch[9],
		                 notes = patch[8],
		                 location = patch[7],
		                 extension_row = patch[6],
		                 description = patch[5],
		                 availability_override = patch[4],
		                 attendees = patch[3],
		                 attendance = patch[2],
		                 archived = patch[1],
		                 a = value$4(title, writable[11]),
		                 b = value$4(time, writable[10]),
		                 c = value$4(task, writable[9]),
		                 d = value$4(notes, writable[8]),
		                 e = value$4(location, writable[7]),
		                 f = value$4(extension_row, writable[6]),
		                 g = value$4(description, writable[5]),
		                 h = value$4(availability_override, writable[4]),
		                 i = value$4(attendees, writable[3]),
		                 j = value$4(attendance, writable[2]),
		                 a =
		                   [0,
		                    value$4(archived, writable[1]),
		                    j,
		                    i,
		                    h,
		                    g,
		                    f,
		                    e,
		                    d,
		                    c,
		                    b,
		                    a];
		                return [0,
		                        event[1],
		                        event[2],
		                        event[3],
		                        event[4],
		                        event[5],
		                        event[6],
		                        event[7],
		                        event[8],
		                        a];
		               }
		               function enumerate_days(date_min, date_max){
		                function f(current, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$83,
		                          current,
		                          date_max,
		                          function(a){
		                           return a
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (add_days,
		                                      current,
		                                      1,
		                                      function(a){return cont([0, [0, current, a]]);})
		                                   : cont(0);
		                          });
		                }
		                return unfold$0(date_min, f);
		               }
		               var
		                bP_ = By_email[111],
		                _3$10 = By_email[55],
		                pp$79 = Event_recurrent[1],
		                schema_versioned$232 = Event_recurrent[4],
		                schema$91 = Event_recurrent[5],
		                symbol$157 = Event_recurrent[9],
		                symbol$158 = Event_recurrent[10],
		                symbol$159 = Event_recurrent[11],
		                symbol$160 = Event_recurrent[12],
		                symbol$161 = Event_recurrent[13],
		                symbol$162 = Event_recurrent[14],
		                equal$141 = Event_recurrent[15],
		                compare$111 = Event_recurrent[16],
		                min$22 = Event_recurrent[17],
		                max$24 = Event_recurrent[18],
		                ascending$13 = Event_recurrent[19],
		                descending$13 = Event_recurrent[20],
		                between$14 = Event_recurrent[21],
		                clamp_exn$13 = Event_recurrent[22],
		                clamp$13 = Event_recurrent[23],
		                comparator$31 = Event_recurrent[24],
		                By$12 = Event_recurrent[27],
		                make$48 = Event_recurrent[29],
		                letrec_function_context$374 = [];
		               function equal$142(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$374[3],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(a){
		                           return a
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$374[1], lhs[3], rhs[3], cont)
		                                   : cont(a);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$374[2], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$374,
		                 [0, equal$65, equal$18, equal$23]);
		               var
		                cst_timezone = "timezone",
		                letrec_function_context$375 = [];
		               function schema_versioned$233(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$375[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, acr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$375[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$375[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$375[1][1] = a;
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_duration,
		                               0,
		                               2,
		                               [0, [0, q, documentation$0, descriptor, parametric]],
		                               0,
		                               0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_timezone,
		                                0,
		                                2,
		                                [0, schema_versioned$126()],
		                                0,
		                                0],
		                               0]];
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  timezone = a[2][1],
		                                  duration = a[1],
		                                  time = param[1];
		                                 return cont([0, time, duration, timezone]);
		                                },
		                                function(param, cont){
		                                 var
		                                  timezone = param[3],
		                                  duration = param[2],
		                                  time = param[1];
		                                 return cont([0, time, [0, duration, [0, timezone, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_time,
		                                  0,
		                                  2,
		                                  [0, schema_versioned$2(schematic_version)],
		                                  0,
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$375[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$375[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$403 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$375, [0, schematic_cache$403]);
		               caml_callback
		                (schema_versioned$233,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$376 = [];
		               function pp$80(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         acs,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   act,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Recurrent.Daytime.time",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$376[3],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   acu,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     acv,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               acw,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_duration,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$376[2],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               acx,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         acy,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   acz,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_timezone,
		     function(b){
		      var a = x[3];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$376[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   acA,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), acB, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$376, [0, pp$47, pp$12, _12$0]);
		               function of_time$3(timezone, param, cont){
		                if(2 !== param[0]) return cont(0);
		                var
		                 end = param[2],
		                 start = param[1],
		                 duration = symbol$58(end, start);
		                return caml_exact_trampoline_cps_call$1
		                        (of_time$1,
		                         timezone,
		                         start,
		                         function(time){
		                          return cont([0, [0, time, duration, timezone]]);
		                         });
		               }
		               var letrec_function_context$377 = [];
		               function equal_t(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$377[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$377, [0, equal$142]);
		               function t_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$233,
		                                   schematic_version,
		                                   function(a){return cont([0, acC, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (t_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$378 = [];
		               function pp_t$0(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$378[1], fmt, cont);
		               }
		               caml_update_dummy(letrec_function_context$378, [0, pp$80]);
		               var letrec_function_context$379 = [];
		               function equal$143(x, y, cont){
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$379[1], a, b, cont);
		                 }
		                }
		                else if(! y) return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy(letrec_function_context$379, [0, equal_t]);
		               function schema_versioned$234(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (t_schema_versioned$0,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, acD, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$234,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$380 = [];
		               function pp$81(fmt, param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst_None, cont);
		                var x = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         fmt,
		                         cst_Some,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$380[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     x,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string, fmt, cst$18, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$380, [0, pp_t$0]);
		               var letrec_function_context$381 = [];
		               function equal$144(x, y, cont){
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$381[1], a, b, cont);
		                 }
		                }
		                else if(! y) return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy(letrec_function_context$381, [0, equal$138]);
		               function schema_versioned$235(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$223,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, acE, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$235,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$382 = [];
		               function pp$82(fmt, param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst_None, cont);
		                var x = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         fmt,
		                         cst_Some,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$382[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     x,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string, fmt, cst$18, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$382, [0, _19]);
		               var
		                Exceptions =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp_v1$0, comparator$11, schema_versioned$1]]),
		                letrec_function_context$383 = [];
		               function equal_exceptions(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$383[1],
		                         function(x, y, cont){
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$383[2], a, b, cont);
		                           }
		                          }
		                          else if(! y) return cont(1);
		                          return cont(0);
		                         },
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               var _1$37 = Exceptions[55];
		               caml_update_dummy
		                (letrec_function_context$383, [0, _1$37, equal$21]);
		               function exceptions_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$1,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){
		      return caml_trampoline_cps_call3
		              (Exceptions[109],
		               schematic_version,
		               a,
		               function(a){return cont([0, acF, 0, a[3], a[4]]);});
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (exceptions_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function exception_status(exceptions, date_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         exceptions,
		                         date_id,
		                         function(a){
		                          if(! a) return cont(-787066551);
		                          a = a[1];
		                          if(! a) return cont(-534737479);
		                          var date = a[1];
		                          return cont([0, -739127961, date]);
		                         });
		               }
		               function has_occurrence(exceptions, recurrence, date_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (occurs_on,
		                         recurrence,
		                         date_id,
		                         function(a){
		                          return a
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (exception_status,
		                                     exceptions,
		                                     date_id,
		                                     function(match){
		                                      if(typeof match === "number")
		                                       return -534737479 <= match ? cont(0) : cont([0, date_id]);
		                                      var day = match[2];
		                                      return cont([0, day]);
		                                     })
		                                  : cont(0);
		                         });
		               }
		               var letrec_function_context$384 = [];
		               function equal$145(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$384[1], lhs, rhs, cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$384, [0, equal_attendance]);
		               var
		                cst_Attendance = "Attendance",
		                letrec_function_context$385 = [];
		               function schema_versioned$236(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$385[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, acH, acG, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$385[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$385[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$385[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     acJ,
		                                     acI,
		                                     0,
		                                     23,
		                                     0,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (attendance_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont(f0);},
		              function(param, cont){return cont([0, param]);},
		              0,
		              0,
		              cst_attendance,
		              cst_Attendance,
		              b,
		              a],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$385[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$385[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$404 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$385, [0, schematic_cache$404]);
		               caml_callback
		                (schema_versioned$236,
		                 [function(param, cont){return cont(0);}]);
		               function wrap$1(attendance, cont){return cont(attendance);}
		               function unwrap(param, cont){return cont(param);}
		               function Moded$12(M, Daytime, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[17],
		                          function(x, y, cont){
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context[18], a, b, cont);
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          },
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(b){
		                                     function a(b){
		                                      function a(b){
		                                       function a(b){
		function a(b){
		 function a(b){
		  function a(b){
		   function a(b){
		    function a(a){
		     if(! a) return cont(a);
		     var b = rhs[10], c = lhs[10];
		     return caml_trampoline_cps_call2
		             (letrec_function_context[1],
		              function(a, b, cont){return cont(a === b ? 1 : 0);},
		              function(a){
		               return caml_trampoline_cps_call3(a, c, b, cont);
		              });
		    }
		    if(! b) return a(b);
		    var c = rhs[9], d = lhs[9];
		    return caml_trampoline_cps_call2
		            (letrec_function_context[2],
		             letrec_function_context[3],
		             function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		   }
		   if(! b) return a(b);
		   var c = rhs[8], d = lhs[8];
		   return caml_trampoline_cps_call2
		           (letrec_function_context[4],
		            letrec_function_context[5],
		            function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		  }
		  if(! b) return a(b);
		  var c = rhs[7], d = lhs[7];
		  return caml_trampoline_cps_call2
		          (letrec_function_context[6],
		           function(x, y, cont){
		            if(x){
		             if(y){var b = y[1], a = x[1]; return cont(a === b ? 1 : 0);}
		            }
		            else if(! y) return cont(1);
		            return cont(0);
		           },
		           function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		 }
		 if(! b) return a(b);
		 var c = rhs[6], d = lhs[6];
		 return caml_trampoline_cps_call2
		         (letrec_function_context[7],
		          letrec_function_context[8],
		          function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		}
		if(! b) return a(b);
		var c = rhs[5], d = lhs[5];
		return caml_trampoline_cps_call2
		        (letrec_function_context[9],
		         function(x, y, cont){
		          if(x){
		           if(y){var b = y[1], a = x[1]; return cont(a === b ? 1 : 0);}
		          }
		          else if(! y) return cont(1);
		          return cont(0);
		         },
		         function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                       }
		                                       if(! b) return a(b);
		                                       var c = rhs[4], d = lhs[4];
		                                       return caml_trampoline_cps_call2
		       (letrec_function_context[10],
		        letrec_function_context[11],
		        function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                      }
		                                      if(! b) return a(b);
		                                      var c = rhs[3], d = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[12],
		       function(x, y, cont){
		        if(x){
		         if(y){
		          var b = y[1], a = x[1];
		          return caml_trampoline_cps_call3
		                  (letrec_function_context[13], a, b, cont);
		         }
		        }
		        else if(! y) return cont(1);
		        return cont(0);
		       },
		       function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                     }
		                                     if(! b) return a(b);
		                                     var c = rhs[2], d = lhs[2];
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[15],
		      letrec_function_context[16],
		      function(b){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[14],
		                b,
		                function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		      });
		                                    });
		                          });
		                }
		                var
		                 _17 = M[9],
		                 _16 = M[9],
		                 _14 = M[9],
		                 _12 = M[9],
		                 _11 = M[9],
		                 _9 = M[9],
		                 _8 = M[9],
		                 _7 = Daytime[1],
		                 _6 = M[9],
		                 _4 = M[9],
		                 _1 = M[9];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0,
		                   _17,
		                   _16,
		                   equal$137,
		                   _14,
		                   equal$75,
		                   _12,
		                   _11,
		                   equal_exceptions,
		                   _9,
		                   _8,
		                   _7,
		                   _6,
		                   equal_availability,
		                   _4,
		                   _3$10,
		                   equal_attendee,
		                   _1,
		                   equal$145]);
		                function make(g, f, e, d, c, b, a, opt, recurrence, title){
		                 var
		                  attendance = g ? g[1] : M[5].call(null, 0),
		                  attendees = f ? f[1] : M[5].call(null, bP_),
		                  availability_override = e ? e[1] : M[5].call(null, 0),
		                  daytime = d ? d[1] : M[5].call(null, Daytime[6]),
		                  description = c ? c[1] : M[5].call(null, 0),
		                  exceptions = b ? b[1] : M[5].call(null, Exceptions[111]),
		                  location = a ? a[1] : M[5].call(null, 0),
		                  notes = opt ? opt[1] : M[5].call(null, acK);
		                 return [0,
		                         attendance,
		                         attendees,
		                         availability_override,
		                         daytime,
		                         description,
		                         exceptions,
		                         location,
		                         notes,
		                         recurrence,
		                         title];
		                }
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      var cst_event_recurrent_content = "event-recurrent-content";
		                                      M[12].call(null, cst_event_recurrent_content);
		                                      return cont
		      ([0,
		        [0, M[12].call(null, cst_event_recurrent_content)],
		        0,
		        descriptor,
		        0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      schematic_param_name_schema_ve,
		                                      function(b){
		                                       var a = M[6].call(null, 0), b = [0, b];
		                                       if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                                       var c = [0, [0, 0, 0, 0, 0, cst_title, 0, a, b, 0, 0], 0];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$222,
		        schematic_version,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var a = M[6].call(null, 0), b = [0, b];
		                   if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                   var
		                    d = [0, [0, 0, 0, 0, 0, cst_recurrence, 0, a, b, 0, 0], c];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$140,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      a,
		                                      function(b){
		                                       var
		default$ = M[5].call(null, acL),
		a =
		  [0,
		   [0, 0, 0, 0, 0, cst_notes, 0, [0, default$], [0, b], 0, 0],
		   d];
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        schematic_param_name_schema_ve,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  b,
		                  function(c){
		                   var
		                    default$ = M[5].call(null, 0),
		                    b =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_location,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (exceptions_schema_versioned,
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      a,
		                                      function(c){
		                                       var
		default$ = M[5].call(null, Exceptions[111]),
		a =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_exceptions,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        schematic_param_name_schema_ve,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  b,
		                  function(c){
		                   var
		                    default$ = M[5].call(null, 0),
		                    b =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_description,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (Daytime[2],
		                            schematic_version,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      a,
		                                      function(c){
		                                       var
		default$ = M[5].call(null, Daytime[6]),
		a =
		  [0,
		   [0, 0, 0, 0, 0, cst_daytime, 0, [0, default$], [0, c], 0, 0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (availability_schema_versioned,
		        schematic_version,
		        function(b){
		         return caml_exact_trampoline_cps_call
		                 (option_schema,
		                  b,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            b,
		                            function(c){
		                             var
		                              default$ = M[5].call(null, 0),
		                              b =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_availability_override,
		                                  0,
		                                  [0, default$],
		                                  [0, c],
		                                  0,
		                                  0],
		                                 a];
		                             return caml_trampoline_cps_call3
		                                     (M[1],
		                                      schematic_version,
		                                      attendees_schema,
		                                      function(c){
		                                       var
		default$ = M[5].call(null, bP_),
		a =
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_attendees,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$236,
		        schematic_version,
		        function(b){
		         return caml_exact_trampoline_cps_call
		                 (option_schema,
		                  b,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            b,
		                            function(b){
		                             var
		                              default$ = M[5].call(null, 0),
		                              res =
		                                [7,
		                                 function(param, cont){
		                                  var
		                                   a = param[2],
		                                   b = a[2],
		                                   c = b[2],
		                                   d = c[2],
		                                   e = d[2],
		                                   f = e[2],
		                                   g = f[2],
		                                   h = g[2],
		                                   title = h[2][1],
		                                   recurrence = h[1],
		                                   notes = g[1],
		                                   location = f[1],
		                                   exceptions = e[1],
		                                   description = d[1],
		                                   daytime = c[1],
		                                   availability_override = b[1],
		                                   attendees = a[1],
		                                   attendance = param[1];
		                                  return cont
		  ([0,
		    attendance,
		    attendees,
		    availability_override,
		    daytime,
		    description,
		    exceptions,
		    location,
		    notes,
		    recurrence,
		    title]);
		                                 },
		                                 function(param, cont){
		                                  var
		                                   title = param[10],
		                                   recurrence = param[9],
		                                   notes = param[8],
		                                   location = param[7],
		                                   exceptions = param[6],
		                                   description = param[5],
		                                   daytime = param[4],
		                                   availability_override = param[3],
		                                   attendees = param[2],
		                                   attendance = param[1];
		                                  return cont
		  ([0,
		    attendance,
		    [0,
		     attendees,
		     [0,
		      availability_override,
		      [0,
		       daytime,
		       [0,
		        description,
		        [0,
		         exceptions,
		         [0, location, [0, notes, [0, recurrence, [0, title, 0]]]]]]]]]]);
		                                 },
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_attendance,
		                                   0,
		                                   [0, default$],
		                                   [0, b],
		                                   0,
		                                   0],
		                                  a]];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context$0[1][1],
		                                      schematic_schema_version,
		                                      res,
		                                      function(a){
		                                       letrec_function_context$0[1][1] = a;
		                                       return cont(res);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          return cont([0, equal, make, schema_versioned, schema]);
		                         });
		               }
		               var
		                R$1 =
		                  [0,
		                   schema_versioned$8,
		                   ,
		                   ,
		                   ,
		                   default$5,
		                   some_if_optional,
		                   ,
		                   pp$16,
		                   equal$24,
		                   ,
		                   ,
		                   name$23],
		                Creation =
		                  caml_callback
		                   (Moded$12,
		                    [R$1, [0, equal$144, schema_versioned$235, , pp$82, , 0]]),
		                Read$1 = [0, equal$143, schema_versioned$234, , pp$81, , 0],
		                include$309 = caml_callback(Moded$12, [R$1, Read$1]),
		                W$1 =
		                  [0,
		                   schema_versioned$119,
		                   ,
		                   ,
		                   ,
		                   default$8,
		                   some_if_optional$1,
		                   ,
		                   pp$45,
		                   equal$60,
		                   ,
		                   ,
		                   name$24],
		                include$310 = caml_callback(Moded$12, [W$1, Read$1]),
		                equal$146 = include$309[1],
		                schema_versioned$237 = include$309[3],
		                bRh = include$309[2];
		               function make$49
		               (attendance,
		                attendees,
		                availability_override,
		                daytime,
		                description,
		                exceptions,
		                location,
		                notes,
		                title){
		                var
		                 a = [0, attendance],
		                 b = [0, availability_override],
		                 c = [0, daytime],
		                 d = [0, description],
		                 e = [0, location];
		                return function(f){
		                 return bRh
		                         (a, attendees, b, c, d, exceptions, e, notes, f, title);};
		               }
		               function first_time(t, cont){
		                var first_date = start_date$0(t[9]), match = t[4];
		                if(! match) return cont([0, first_date]);
		                var
		                 daytime = match[1],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 timezone = daytime[3],
		                 time = daytime[1];
		                function a(start_time, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$78,
		                          start_time,
		                          daytime[2],
		                          function(end_time){return cont([2, start_time, end_time]);});
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (to_time$2,
		                         timezone,
		                         first_date,
		                         time,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(match){
		                                    if(0 === match[0]){var time = match[1]; return cont(time);}
		                                    var error = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     failwith,
		     fmt$101,
		     function(a){
		      return caml_trampoline_cps_call2(a, error, cont);
		     });
		                                   });
		                         });
		               }
		               var
		                schema_versioned$238 = include$310[3],
		                schema$92 = include$310[4],
		                bRi = include$310[2];
		               function make$50
		               (attendance,
		                attendees,
		                availability_override,
		                daytime,
		                description,
		                exceptions,
		                location,
		                notes,
		                recurrence,
		                title,
		                param){
		                return bRi
		                        ([0, attendance],
		                         [0, attendees],
		                         [0, availability_override],
		                         [0, daytime],
		                         [0, description],
		                         [0, exceptions],
		                         [0, location],
		                         [0, notes],
		                         recurrence,
		                         title);
		               }
		               var empty$26 = make$50(0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
		               function of_occurrence(timezone, a, cont){
		                var
		                 title = a[11],
		                 time = a[10],
		                 task = a[9],
		                 notes = a[8],
		                 location = a[7],
		                 description = a[5],
		                 availability_override = a[4],
		                 attendees = a[3],
		                 attendance = a[2],
		                 archived = a[1],
		                 open = g(include$0),
		                 let$ = open[17],
		                 let$0 = open[11];
		                function b(param, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (let$0,
		                          attendance,
		                          function(attendance, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$0,
		                                    attendance,
		                                    function(attendance, cont){return cont(attendance);},
		                                    cont);
		                          },
		                          function(attendance){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$0,
		                                    time,
		                                    function(time, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_time$3, timezone, time, cont);
		                                    },
		                                    function(daytime){
		                                     return cont
		     (make$50
		       (attendance,
		        attendees,
		        availability_override,
		        daytime,
		        description,
		        0,
		        location,
		        notes,
		        0,
		        title));
		                                    });
		                          });
		                }
		                var a = is_some(archived) ? bC : is_some(task) ? bC : acM;
		                return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		               }
		               var
		                schematic_cache$405 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$386 = [];
		               caml_update_dummy
		                (letrec_function_context$386, [0, schematic_cache$405]);
		               function schematic_version$58(param, cont){return cont(0);}
		               var
		                schematic_schema_version$120 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$386[1][1],
		                     schematic_schema_version$120]);
		               if(h)
		                var schema$93 = h[1], descriptor$19 = schema$93;
		               else
		                descriptor$19 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$386[1][1],
		                              schematic_schema_version$120,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$386[1][1],
		 schematic_schema_version$120,
		 schematic_self,
		 function(a){
		  letrec_function_context$386[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$238,
		           schematic_version$58,
		           function(b){
		            var
		             a = [0, [0, 0, 0, 0, 0, cst_patch, 0, 2, [1, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$232,
		                     schematic_version$58,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var patch = param[2][1], id = param[1];
		                           return cont([0, id, patch]);
		                          },
		                          function(param, cont){
		                           var patch = param[2], id = param[1];
		                           return cont([0, id, [0, patch, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$386[1][1],
		                               schematic_schema_version$120,
		                               res,
		                               function(a){
		                                letrec_function_context$386[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                patch_schema = [0, acN, 0, descriptor$19, 0],
		                schematic_cache$406 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$387 = [];
		               caml_update_dummy
		                (letrec_function_context$387, [0, schematic_cache$406]);
		               function schematic_version$59(param, cont){return cont(0);}
		               var
		                schematic_schema_version$119 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$387[1][1],
		                     schematic_schema_version$119]);
		               if(h)
		                var schema$94 = h[1], descriptor$20 = schema$94;
		               else
		                descriptor$20 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$387[1][1],
		                              schematic_schema_version$119,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$387[1][1],
		 schematic_schema_version$119,
		 schematic_self,
		 function(a){
		  letrec_function_context$387[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Creation[3],
		           schematic_version$59,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, bool_schema], 0, 0],
		                [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0]];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$16,
		                     schematic_version$59,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            writable = a[2][1],
		                            draft = a[1],
		                            calendar = param[1];
		                           return cont([0, calendar, draft, writable]);
		                          },
		                          function(param, cont){
		                           var
		                            writable = param[3],
		                            draft = param[2],
		                            calendar = param[1];
		                           return cont([0, calendar, [0, draft, [0, writable, 0]]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_calendar, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$387[1][1],
		                               schematic_schema_version$119,
		                               res,
		                               function(a){
		                                letrec_function_context$387[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                creation_schema$0 = [0, acO, 0, descriptor$20, 0],
		                letrec_function_context$388 = [];
		               function equal$147(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$388[6],
		                         lhs[1],
		                         rhs[1],
		                         function(d){
		                          function c(d){
		                           if(d) var b = rhs[3], a = lhs[3], d = a === b ? 1 : 0;
		                           function c(b){
		                            function a(d){
		                             function c(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$388[1], lhs[7], rhs[7], cont)
		                                      : cont(a);
		                             }
		                             if(! d) return c(d);
		                             var y = rhs[6], x = lhs[6];
		                             if(x){
		                              if(y){
		                               var b = y[1], a = x[1];
		                               return caml_trampoline_cps_call3
		                                       (letrec_function_context$388[2], a, b, c);
		                              }
		                             }
		                             else if(! y) return c(1);
		                             return c(0);
		                            }
		                            return b
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$388[3], lhs[5], rhs[5], a)
		                                    : a(b);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[4], x = lhs[4];
		                           if(x){
		                            if(y){
		                             var b$0 = y[1], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$388[4], a$0, b$0, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          if(! d) return c(d);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$388[5], a, b, c);
		                           }
		                          }
		                          else if(! y) return c(1);
		                          return c(0);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$388,
		                 [0,
		                  equal$146,
		                  equal_link,
		                  equal$141,
		                  equal$4,
		                  equal_creator,
		                  equal$4]);
		               var letrec_function_context$389 = [];
		               function schema_versioned$239(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$389[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, acP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$389[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$389[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$389[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$237,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (link_schema_versioned$1,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_link, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$232,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, bool_schema], 0, 0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_google_event_id,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b]]];
		                  return caml_exact_trampoline_cps_call
		                          (creator_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_creator, 0, 3, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$16,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    writable = e[2][1],
		    link = e[1],
		    id = d[1],
		    google_event_id = c[1],
		    draft = b[1],
		    creator = a[1],
		    calendar = param[1];
		   return cont
		           ([0,
		             calendar,
		             creator,
		             draft,
		             google_event_id,
		             id,
		             link,
		             writable]);
		  },
		  function(param, cont){
		   var
		    writable = param[7],
		    link = param[6],
		    id = param[5],
		    google_event_id = param[4],
		    draft = param[3],
		    creator = param[2],
		    calendar = param[1];
		   return cont
		           ([0,
		             calendar,
		             [0,
		              creator,
		              [0,
		               draft,
		               [0, google_event_id, [0, id, [0, link, [0, writable, 0]]]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_calendar, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$389[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$389[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$407 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$389, [0, schematic_cache$407]);
		               var
		                schema$95 =
		                  caml_callback
		                   (schema_versioned$239,
		                    [function(param, cont){return cont(0);}]);
		               function patch$3(event, a){
		                var
		                 title = a[10],
		                 recurrence = a[9],
		                 notes = a[8],
		                 location = a[7],
		                 exceptions = a[6],
		                 description = a[5],
		                 daytime = a[4],
		                 availability_override = a[3],
		                 attendees = a[2],
		                 attendance = a[1],
		                 a = value$4(title, event[7][10]),
		                 b = value$4(recurrence, event[7][9]),
		                 c = value$4(notes, event[7][8]),
		                 d = value$4(location, event[7][7]),
		                 e = value$4(exceptions, event[7][6]),
		                 f = value$4(description, event[7][5]),
		                 g = value$4(daytime, event[7][4]),
		                 h = value$4(availability_override, event[7][3]),
		                 i = value$4(attendees, event[7][2]),
		                 a =
		                   [0,
		                    value$4(attendance, event[7][1]),
		                    i,
		                    h,
		                    g,
		                    f,
		                    e,
		                    d,
		                    c,
		                    b,
		                    a];
		                return [0,
		                        event[1],
		                        event[2],
		                        event[3],
		                        event[4],
		                        event[5],
		                        event[6],
		                        a];
		               }
		               function make_occurrence(event, date_id, cont){
		                var
		                 open$0 =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$1 = open$0[4],
		                 writable = event[7],
		                 recurrence = event[5],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function a(date, cont){
		                 var id = [1, recurrence, date_id], a = writable[4];
		                 function c(time, cont){
		                  return cont
		                          ([0,
		                            id,
		                            [0,
		                             0,
		                             0,
		                             writable[2],
		                             writable[3],
		                             writable[5],
		                             0,
		                             writable[7],
		                             writable[8],
		                             0,
		                             time,
		                             writable[10]]]);
		                 }
		                 function b(a){
		                  return caml_trampoline_cps_call3(let$, a, c, cont);
		                 }
		                 if(! a) return b([0, [0, date]]);
		                 a = a[1];
		                 var timezone = a[3], duration = a[2], time = a[1];
		                 function d(start, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$78,
		                           start,
		                           duration,
		                           function(a){return cont([2, start, a]);});
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (to_time$2,
		                          timezone,
		                          date,
		                          time,
		                          function(a){
		                           return caml_trampoline_cps_call3(let$, to_option$2(a), d, b);
		                          });
		                }
		                function b(param, cont){
		                 var writable = param[2], id = param[1];
		                 return cont
		                         ([0,
		                           event[1],
		                           0,
		                           event[2],
		                           event[3],
		                           0,
		                           id,
		                           event[6],
		                           0,
		                           writable]);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (has_occurrence,
		                         writable[6],
		                         writable[9],
		                         date_id,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$0,
		                                   c,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(let$1, a, b, cont);
		                                   });
		                         });
		               }
		               function make_occurrence_by_date(event, day, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3],
		                 exceptions = event[7][6];
		                function a(date_id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (make_occurrence, event, date_id, cont);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (fold$5,
		                         exceptions,
		                         243049859,
		                         function(key, data, acc, cont){
		                          return typeof acc === "number"
		                                  ? caml_exact_trampoline_cps_call$0
		                                    (equal_option,
		                                     equal$21,
		                                     data,
		                                     [0, day],
		                                     function(a){
		                                      return a
		      ? cont([0, 80666710, key])
		      : caml_exact_trampoline_cps_call$1
		        (symbol$81,
		         key,
		         day,
		         function(a){return a ? cont(-534737479) : cont(acc);});
		                                     })
		                                  : cont(acc);
		                         },
		                         function(match){
		                          function b(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          }
		                          if(typeof match === "number")
		                           return 243049859 <= match
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (occurs_on,
		                                      event[7][9],
		                                      day,
		                                      function(a){return a ? b([0, day]) : b(0);})
		                                   : b(0);
		                          var date_id = match[2];
		                          return b([0, date_id]);
		                         });
		               }
		               function snap$1(event, day, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                function a(occ, cont){
		                 function f(occ, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (exception_status,
		                           event[7][6],
		                           occ[1],
		                           function(match){
		                            if(typeof match !== "number"){
		                             var day = match[2];
		                             return cont([0, [0, occ[1], day]]);
		                            }
		                            if(-534737479 > match)
		                             return cont([0, [0, occ[1], occ[1]]]);
		                            function a(next, cont){
		                             return caml_exact_trampoline_cps_call(f, next, cont);
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (increment,
		                                     bPB,
		                                     occ,
		                                     function(b){
		                                      return caml_trampoline_cps_call3(let$, b, a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          occ,
		                          function(candidate){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter_map$3,
		                                    event[7][6],
		                                    function(param, cont){
		                                     if(! param) return cont(0);
		                                     var date = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$80,
		      day,
		      date,
		      function(c){
		       function b(){return cont(0);}
		       if(! c) return b();
		       function a(a){return a ? cont([0, date]) : b();}
		       if(! candidate) return a(1);
		       var x = candidate[1], cand_date = x[2];
		       return caml_exact_trampoline_cps_call$1
		               (symbol$83, day, cand_date, a);
		      });
		                                    },
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (min_elt$3,
		      a,
		      function(better_candidate){
		       return caml_trampoline_cps_call3
		               (let$,
		                first_some(better_candidate, candidate),
		                function(best, cont){
		                 function a(occ, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (make_occurrence, event, occ[1], cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (snap$0,
		                          event[7][9],
		                          best[1],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                },
		                cont);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (snap$0,
		                         event[7][9],
		                         day,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function translate$0(t, default_timezone, origin, dest, cont){
		                var open = g(include$0), let$ = open[17], match = t[7][4];
		                if(match)
		                 var daytime = match[1], timezone = daytime[3];
		                else
		                 timezone = default_timezone;
		                return caml_exact_trampoline_cps_call$1
		                        (start_date$1,
		                         timezone,
		                         origin,
		                         function(orig_date){
		                          return caml_exact_trampoline_cps_call$1
		                                  (start_date$1,
		                                   timezone,
		                                   dest,
		                                   function(dest_date){
		                                    function a(recurrence, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_time$3,
		      timezone,
		      dest,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (equal$138,
		                origin,
		                dest,
		                function(b){
		                 var daytime = some_if(1 - b, a);
		                 return cont
		                         (patch$3
		                           (t, make$50(0, 0, 0, daytime, 0, 0, 0, 0, recurrence, 0)));
		                });
		      });
		                                    }
		                                    function b(occurrence_to_move, cont){
		                                     var
		                                      recurrence = occurrence_to_move[3],
		                                      match = recurrence[1];
		                                     function b(boundaries){
		                                      var periodic = recurrence[2];
		                                      function a(rule){
		                                       return caml_exact_trampoline_cps_call
		       (of_mandate,
		        [0, boundaries, rule],
		        function(a){
		         return caml_exact_trampoline_cps_call$2
		                 (value_exn,
		                  acR,
		                  0,
		                  acQ,
		                  a,
		                  function(recurrence){return cont([0, recurrence]);});
		        });
		                                      }
		                                      switch(periodic[0]){
		case 1:
		 var b = periodic[2];
		 if(! b) return a(periodic);
		 if(0 === b[1][0])
		  return a([1, periodic[1], [0, [0, dest_date[1]]]]);
		 var
		  k = (dest_date[1] / 7 | 0) + 1 | 0,
		  k$0 = 5 === k ? -1 : k;
		 return caml_exact_trampoline_cps_call
		         (weekday,
		          dest_date,
		          function(wd){return a([1, periodic[1], [0, [1, wd, k$0]]]);});
		case 2:
		 b = periodic[2];
		 if(! b) return a(periodic);
		 var weekdays = b[1];
		 return caml_exact_trampoline_cps_call
		         (weekday,
		          occurrence_to_move[1],
		          function(old_weekday){
		           return caml_exact_trampoline_cps_call
		                   (weekday,
		                    dest_date,
		                    function(new_weekday){
		                     switch(old_weekday){
		                       case 0:
		                        var
		                         b =
		                           [0,
		                            0,
		                            weekdays[2],
		                            weekdays[3],
		                            weekdays[4],
		                            weekdays[5],
		                            weekdays[6],
		                            weekdays[7]];
		                        break;
		                       case 1:
		                        b =
		                         [0,
		                          weekdays[1],
		                          0,
		                          weekdays[3],
		                          weekdays[4],
		                          weekdays[5],
		                          weekdays[6],
		                          weekdays[7]];
		                        break;
		                       case 2:
		                        b =
		                         [0,
		                          weekdays[1],
		                          weekdays[2],
		                          0,
		                          weekdays[4],
		                          weekdays[5],
		                          weekdays[6],
		                          weekdays[7]];
		                        break;
		                       case 3:
		                        b =
		                         [0,
		                          weekdays[1],
		                          weekdays[2],
		                          weekdays[3],
		                          0,
		                          weekdays[5],
		                          weekdays[6],
		                          weekdays[7]];
		                        break;
		                       case 4:
		                        b =
		                         [0,
		                          weekdays[1],
		                          weekdays[2],
		                          weekdays[3],
		                          weekdays[4],
		                          0,
		                          weekdays[6],
		                          weekdays[7]];
		                        break;
		                       case 5:
		                        b =
		                         [0,
		                          weekdays[1],
		                          weekdays[2],
		                          weekdays[3],
		                          weekdays[4],
		                          weekdays[5],
		                          0,
		                          weekdays[7]];
		                        break;
		                       default:
		                        b =
		                         [0,
		                          weekdays[1],
		                          weekdays[2],
		                          weekdays[3],
		                          weekdays[4],
		                          weekdays[5],
		                          weekdays[6],
		                          0];
		                     }
		                     var weekdays$0 = add$8(new_weekday, b);
		                     return a([2, periodic[1], [0, weekdays$0], periodic[3]]);
		                    });
		          });
		case 4:
		 if(! periodic[2] && ! periodic[3]) return a(periodic);
		 return a
		         ([4, periodic[1], [0, dest_date[1]], [0, dest_date[2]]]);
		default: return a(periodic);
		                                      }
		                                     }
		                                     if(0 === match[0]){
		                                      var count = match[2];
		                                      return b([0, dest_date, count - occurrence_to_move[2] | 0]);
		                                     }
		                                     var end = match[1];
		                                     function a(end){return b([1, end, [0, dest_date]]);}
		                                     if(! end) return a(0);
		                                     var end$0 = end[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$85,
		      dest_date,
		      occurrence_to_move[1],
		      function(s){
		       var to_add = s[1];
		       return caml_exact_trampoline_cps_call$1
		               (add_days,
		                end$0,
		                to_add,
		                function(b){
		                 return caml_trampoline_cps_call2(return$9, b, a);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (snap$0,
		     t[7][9],
		     orig_date,
		     function(match){
		      function c(c){
		       return caml_exact_trampoline_cps_call$1
		               (let$,
		                c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                });
		      }
		      if(! match)
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$103,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (a, pp_v1$0, orig_date, function(a){return c([1, a]);});
		                });
		      var occ = match[1];
		      function d(param, cont){return cont(occ);}
		      return caml_exact_trampoline_cps_call$1
		              (symbol$84,
		               occ[1],
		               orig_date,
		               function(b){
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1(let$, a, d, c);
		                }
		                return b
		                        ? caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$102,
		                           function(b){
		                            return caml_trampoline_cps_call3
		                                    (b, pp_v1$0, orig_date, function(b){return a([1, b]);});
		                           })
		                        : a(acS);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                schematic_cache$408 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$390 = [];
		               caml_update_dummy
		                (letrec_function_context$390, [0, schematic_cache$408]);
		               var
		                cst_organizationId = "organizationId",
		                schematic_schema_version$118 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$390[1][1],
		                    schematic_schema_version$118]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$390[1][1],
		                             schematic_schema_version$118,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$390[1][1],
		schematic_schema_version$118,
		schematic_self,
		function(a){
		 letrec_function_context$390[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$104,
		          dummy,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var organization_id = param[1];
		                return cont([0, organization_id]);
		               },
		               function(param, cont){
		                var organization_id = param[1];
		                return cont([0, organization_id, 0]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, a], 0, 0],
		                0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$390[1][1],
		                    schematic_schema_version$118,
		                    res,
		                    function(a){
		                     letrec_function_context$390[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function to_string$53(param, cont){
		                var value = param[1];
		                return cont(value);
		               }
		               function decode$9(value, cont){
		                return caml_trampoline_cps_call2
		                        (of_string$14, [0, value], cont);
		               }
		               var
		                schema$266 =
		                  [0, id$25, 0, [4, decode$9, to_string$53, descriptor$1], 0];
		               caml_callback(encode$7, [schema$266]);
		               caml_callback
		                (ok_or_failwith,
		                 [caml_callback
		                   (of_string$41, ["column:FixedIntegrationAppId"])]);
		               function equal_connection_id(a, b, cont){return cont(a === b ? 1 : 0);
		               }
		               var letrec_function_context$391 = [];
		               function compare_connection_id(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$391[1],
		                         0,
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               function _0$35(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(letrec_function_context$391, [0, _0$35]);
		               function connection_id_schema_versioned
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    bD,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                connection_id_schema =
		                  [0,
		                   bD,
		                   0,
		                   schematic_param_name_schema_ve[3],
		                   schematic_param_name_schema_ve[4]];
		               function pp_connection_id(fmt, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), acT, cont);
		               }
		               var letrec_function_context$392 = [];
		               function compare_data_collection_key(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$392[1],
		                         0,
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               function _0$36(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(letrec_function_context$392, [0, _0$36]);
		               function data_collection_key_schema_ver
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    acU,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               function pp_data_collection_key(fmt, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), acV, cont);
		               }
		               var
		                Flow_instance =
		                  caml_callback
		                   (Make_basic, [[0, "integration-app-flow-instance"]]);
		               function equal_pagination_stopped_reaso(lhs, rhs, cont){
		                var
		                 rhsmax_number_of_records = rhs[1],
		                 lhsmax_number_of_records = lhs[1];
		                return cont
		                        (lhsmax_number_of_records === rhsmax_number_of_records
		                          ? 1
		                          : 0);
		               }
		               var letrec_function_context$393 = [];
		               function pagination_stopped_reason_sche
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$393[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, acW, , descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$393[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$393[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$393[1][1] = a;
		                            a = "max_number_of_records";
		                            var
		                             res =
		                               [11,
		                                acX,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  a,
		                                  "Max_number_of_records",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var max_number_of_records = param[1];
		                                     return cont(max_number_of_records);
		                                    },
		                                    function(max_number_of_records, cont){
		                                     return cont([0, max_number_of_records, 0]);
		                                    },
		                                    [0, [0, 0, 0, 0, 0, a, 0, 2, [0, int_schema], 0, 0], 0]],
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$393[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$393[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$409 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$393, [0, schematic_cache$409]);
		               caml_callback
		                (pagination_stopped_reason_sche,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$394 = [];
		               function equal_status(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(lhs){
		                  if(typeof rhs === "number" && rhs) return cont(1);
		                 }
		                 else if(typeof rhs === "number" && ! rhs) return cont(1);
		                }
		                else if(typeof rhs !== "number"){
		                 var rhs0 = rhs[1], lhs0 = lhs[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context$394[1], lhs0, rhs0, cont);
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$394,
		                 [0, equal_pagination_stopped_reaso]);
		               var letrec_function_context$395 = [];
		               function status_schema_versioned$4(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$395[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, acY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$395[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$395[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$395[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(1);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && param) return cont(ac0);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_no_list_method,
		                                 "No_list_method",
		                                 [0,
		                                  0,
		                                  acZ,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (pagination_stopped_reason_sche,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  ac4,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){
		     if(typeof param === "number" && ! param) return cont(ac3);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_success,
		    cst_Success,
		    [0,
		     0,
		     ac2,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(typeof param === "number") return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     "pagination_stopped",
		     "Pagination_stopped",
		     [0, b[1], ac1, b[3], b[4]],
		     0],
		    a]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$395[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$395[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$410 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$395, [0, schematic_cache$410]);
		               caml_callback
		                (status_schema_versioned$4,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$396 = [];
		               function status_old_format_schema_versi
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$396[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ac5, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$396[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$396[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$396[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(ac9);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_success,
		                                  "Success_old",
		                                  ac8,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(typeof param === "number") return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   0,
		                                   0,
		                                   "pagination_stopped_old",
		                                   "Pagination_stopped_old",
		                                   int_schema,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(1);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && param) return cont(ac7);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_no_list_method,
		                                    "No_list_method_old",
		                                    ac6,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$396[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$396[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$411 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$396, [0, schematic_cache$411]);
		               caml_callback
		                (status_old_format_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$397 = [];
		               function with_optional_union_key_schema$0
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$397[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ac_, 0, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$397[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$397[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$397[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_old_format_schema_versi,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   "old_format",
		   "Old_format",
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (status_schema_versioned$4,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              "new_format",
		              "New_format",
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$397[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$397[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$412 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$397, [0, schematic_cache$412]);
		               caml_callback
		                (with_optional_union_key_schema$0,
		                 [function(param, cont){return cont(0);}]);
		               function status_schema_versioned$5(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_optional_union_key_schema$0,
		                         v,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (v,
		                                   V$4,
		                                   function(match){
		                                    function c(b){
		                                     return cont
		     (map$14
		       (function(x, cont){
		         if(0 === x[0]){
		          var status = x[1];
		          return caml_trampoline_cps_call2(of_string$14, status, cont);
		         }
		         var old_status = x[1];
		         if(typeof old_status === "number")
		          return old_status
		                  ? caml_trampoline_cps_call2(of_string$14, 1, cont)
		                  : caml_trampoline_cps_call2(of_string$14, 0, cont);
		         var max_records = old_status[1];
		         return caml_trampoline_cps_call2
		                 (of_string$14, [0, [0, max_records]], cont);
		        },
		        b,
		        a));
		                                    }
		                                    function b(){
		                                     return c(function(v, cont){return cont([0, v]);});
		                                    }
		                                    if(! match) return b();
		                                    var version = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_string_exn,
		     "0.26.0",
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$66,
		               version,
		               a,
		               function(a){
		                return a
		                        ? c
		                          (function(param, cont){
		                            if(typeof param === "number")
		                             return param ? cont(ac$) : cont(ada);
		                            var max_number_of_records = param[1][1];
		                            return cont([1, [0, max_number_of_records]]);
		                           })
		                        : b();
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (status_schema_versioned$5,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$398 = [];
		               function equal$148(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$398[4],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(b){
		                           function a(c){
		                            if(! c) return cont(c);
		                            var y = rhs[4], x = lhs[4];
		                            if(x){
		                             if(y){
		                              var b = y[1], a = x[1];
		                              return caml_trampoline_cps_call3
		                                      (letrec_function_context$398[1], a, b, cont);
		                             }
		                            }
		                            else if(! y) return cont(1);
		                            return cont(0);
		                           }
		                           return b
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$398[2], lhs[3], rhs[3], a)
		                                   : a(b);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$398[3], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               var _1$38 = Flow_instance[15], _0$37 = Table[15];
		               caml_update_dummy
		                (letrec_function_context$398,
		                 [0, equal$20, equal_status, _1$38, _0$37]);
		               var letrec_function_context$399 = [];
		               function schema_versioned$240(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$399[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adb, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$399[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$399[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$399[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     ade,
		                                     adc,
		                                     2,
		                                     0,
		                                     1,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$148[1],
		                   b =
		                     [0,
		                      [0,
		                       adf,
		                       0,
		                       0,
		                       0,
		                       "last_synced",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       a,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (status_schema_versioned$5,
		                           schematic_version,
		                           function(c){
		                            var
		                             a =
		                               [0, [0, adg, 0, 0, 0, "sub_status", 0, 2, [0, c], 0, 0], b];
		                            return caml_exact_trampoline_cps_call
		                                    (Flow_instance[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   adh,
		   0,
		   0,
		   0,
		   "integration_app_flow_instance",
		   0,
		   2,
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              last_synced = b[2][1],
		              sub_status = b[1],
		              integration_app_flow_instance = a[1],
		              table = param[1];
		             return cont
		                     ([0,
		                       table,
		                       integration_app_flow_instance,
		                       sub_status,
		                       last_synced]);
		            },
		            function(param, cont){
		             var
		              last_synced = param[4],
		              sub_status = param[3],
		              integration_app_flow_instance = param[2],
		              table = param[1];
		             return cont
		                     ([0,
		                       table,
		                       [0,
		                        integration_app_flow_instance,
		                        [0, sub_status, [0, last_synced, 0]]]]);
		            },
		            [0, [0, adi, 0, 0, 0, cst_table, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$399[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$399[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$413 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$399, [0, schematic_cache$413]);
		               caml_callback
		                (schema_versioned$240,
		                 [function(param, cont){return cont(0);}]);
		               function equal$149(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                a:
		                if(c){
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b$0 = y[1], a$0 = x[1], c = a$0 === b$0 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                if(! c) return cont(c);
		                var b$1 = rhs[3], a$1 = lhs[3];
		                return cont(a$1 === b$1 ? 1 : 0);
		               }
		               var letrec_function_context$400 = [];
		               function schema_versioned$241(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$400[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adk, adj, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$400[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$400[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$400[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     adm,
		                                     adl,
		                                     1,
		                                     0,
		                                     4,
		                                     function(a){
		                                      var
		                                       default$ = match$149[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    pin_to_personal_workspace_menu = a[2][1],
		    integration_key = a[1],
		    database_display_name = param[1];
		   return cont
		           ([0,
		             database_display_name,
		             integration_key,
		             pin_to_personal_workspace_menu]);
		  },
		  function(param, cont){
		   var
		    pin_to_personal_workspace_menu = param[3],
		    integration_key = param[2],
		    database_display_name = param[1];
		   return cont
		           ([0,
		             database_display_name,
		             [0, integration_key, [0, pin_to_personal_workspace_menu, 0]]]);
		  },
		  [0,
		   [0,
		    adp,
		    0,
		    0,
		    0,
		    "database_display_name",
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     ado,
		     0,
		     0,
		     0,
		     cst_integration_key,
		     0,
		     3,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      adn,
		      0,
		      0,
		      0,
		      "pin_to_personal_workspace_menu",
		      0,
		      [0, default$],
		      [0, bool_schema],
		      [0, [0, a, V$4]],
		      0],
		     0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$400[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$400[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$414 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$400, [0, schematic_cache$414]);
		               caml_callback
		                (schema_versioned$241,
		                 [function(param, cont){return cont(0);}]);
		               var bP$ = [];
		               function equal$150(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                return c
		                        ? caml_trampoline_cps_call3(bP$[1], lhs[2], rhs[2], cont)
		                        : cont(c);
		               }
		               var letrec_function_context$401 = [];
		               function equal_last_known_state(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$401[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$401[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy(bP$, [0, equal_last_known_state]);
		               caml_update_dummy
		                (letrec_function_context$401, [0, equal$149, equal$148]);
		               var bip = [];
		               function schema_versioned$242(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bip[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adr, adq, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bip[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bip[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bip[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (last_known_state_schema_versio,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var last_known_state = param[2][1], description = param[1];
		   return cont([0, description, last_known_state]);
		  },
		  function(param, cont){
		   var last_known_state = param[2], description = param[1];
		   return cont([0, description, [0, last_known_state, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_description,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, 0, 0, 0, 0, "last_known_state", 0, 2, [0, a], 0, 0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bip[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bip[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Creation_pending = "Creation_pending",
		                cst_creation_pending = "creation_pending",
		                letrec_function_context$402 = [];
		               function last_known_state_schema_versio
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$402[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adt, ads, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$402[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$402[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$402[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$241,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_creation_pending,
		   cst_Creation_pending,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$240,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            adu,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_ready,
		              cst_Ready,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$402[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$402[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$415 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bip, [0, schematic_cache$415]);
		               var schematic_cache$416 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$402, [0, schematic_cache$416]);
		               caml_callback
		                (schema_versioned$242,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (last_known_state_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$403 = [];
		               function equal$151(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhs0 = rhs[1], lhs0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$403[4], lhs0, rhs0, cont);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$403[3], lhs0$0, rhs0$0, cont);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$403[2], lhs0$1, rhs0$1, cont);
		                   }
		                   break;
		                  default:
		                   if(3 === rhs[0]){
		                    var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$403[1], lhs0$2, rhs0$2, cont);
		                   }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$403,
		                 [0, equal$148, equal$150, equal$149, equal$148]);
		               var letrec_function_context$404 = [];
		               function schema_versioned$243(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$404[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adw, adv, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$404[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$404[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$404[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     ady,
		                                     adx,
		                                     2,
		                                     0,
		                                     1,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$240,
		       schematic_version,
		       function(b){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             "force_refresh",
		             "Force_refresh",
		             [0, b[1], adz, b[3], b[4]],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 adB,
		                 adA,
		                 0,
		                 25,
		                 9,
		                 function(b){
		                  var a = [0, [0, b, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$242,
		                           schematic_version,
		                           function(d){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_error,
		                                 cst_Error,
		                                 d,
		                                 a],
		                                c];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     adD,
		                                     adC,
		                                     0,
		                                     22,
		                                     4,
		                                     function(c){
		                                      var a = [0, [0, c, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$241,
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_creation_pending,
		             cst_Creation_pending,
		             d,
		             a],
		            b];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 adF,
		                 adE,
		                 0,
		                 22,
		                 4,
		                 function(b){
		                  var a = [0, [0, b, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$240,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                adG,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_ready,
		                                  cst_Ready,
		                                  b,
		                                  a],
		                                 c],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$404[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$404[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$417 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$404, [0, schematic_cache$417]);
		               var
		                schema$96 =
		                  caml_callback
		                   (schema_versioned$243,
		                    [function(param, cont){return cont(0);}]),
		                include$86 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$2, comparator$2, thread_id_schema_versioned]]),
		                compare_direct$1 = include$86[53],
		                schema_versioned$244 = include$86[109],
		                pp$83 = include$86[128],
		                cst_data_collection_key = "data_collection_key",
		                letrec_function_context$405 = [];
		               function schema_versioned$245(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$405[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adH, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$405[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$405[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$405[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$149,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (schema_versioned$244,
		       schematic_version,
		       a,
		       function(b){
		        var
		         a =
		           [0,
		            [0, adI, 0, 0, 0, cst_parameters, 0, 2, [0, b], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (data_collection_key_schema_ver,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_data_collection_key, 0, 2, [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (connection_id_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  parameters = a[2][1],
		                                  data_collection_key = a[1],
		                                  connection_id = param[1];
		                                 return cont
		 ([0, connection_id, data_collection_key, parameters]);
		                                },
		                                function(param, cont){
		                                 var
		                                  parameters = param[3],
		                                  data_collection_key = param[2],
		                                  connection_id = param[1];
		                                 return cont
		 ([0,
		   connection_id,
		   [0, data_collection_key, [0, parameters, 0]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, "connection_id", 0, 2, [0, a], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$405[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$405[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$418 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$405, [0, schematic_cache$418]);
		               var
		                schema$97 =
		                  caml_callback
		                   (schema_versioned$245,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$406 = [];
		               function pp$84(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         adJ,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   adK,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integration_app.Enabled_data_collection.Id.T.connection_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$406[4],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   adL,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     adM,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               adN,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_data_collection_key,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$406[3],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               adO,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         adP,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   adQ,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_parameters,
		     function(b){
		      var a = x[3];
		      return caml_trampoline_cps_call3
		              (letrec_function_context$406[1],
		               function(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$406[2], fmt, cont);
		               },
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   adR,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), adS, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$406,
		                 [0, pp$83, pp$64, pp_data_collection_key, pp_connection_id]);
		               var letrec_function_context$407 = [];
		               function compare$112(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$407[4],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$407[3],
		                                     lhs[2],
		                                     rhs[2],
		                                     function(x){
		                                      if(0 !== x) return cont(x);
		                                      var a = rhs[3], b = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context$407[1],
		       letrec_function_context$407[2],
		       function(c){
		        return caml_trampoline_cps_call3(c, b, a, cont);
		       });
		                                     })
		                                  : cont(x);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$407,
		                 [0,
		                  compare_direct$1,
		                  compare$99,
		                  compare_data_collection_key,
		                  compare_connection_id]);
		               var
		                sexp_of_t$50 = caml_callback(encode$7, [schema$97]),
		                include$87 = Make$2([0, compare$112, sexp_of_t$50]),
		                symbol$163 = include$87[1],
		                symbol$164 = include$87[2],
		                symbol$165 = include$87[3],
		                symbol$166 = include$87[4],
		                symbol$167 = include$87[5],
		                symbol$168 = include$87[6],
		                equal$152 = include$87[7],
		                compare$113 = include$87[8],
		                min$23 = include$87[9],
		                max$25 = include$87[10],
		                ascending$14 = include$87[11],
		                descending$14 = include$87[12],
		                between$15 = include$87[13],
		                clamp_exn$14 = include$87[14],
		                clamp$14 = include$87[15],
		                comparator$32 = include$87[16],
		                T$4 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$84, comparator$32, schema_versioned$245]]),
		                empty$27 = T$4[111];
		               function schema_versioned$246(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    return caml_trampoline_cps_call3
		    (T$4[109],
		     schematic_version,
		     schematic_param_a_schema_versi,
		     function(init){return cont([0, 0, 0, init[3], init[4]]);});
		                                   });
		                         });
		               }
		               var letrec_function_context$408 = [];
		               function schema_versioned$247(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$408[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adU, adT, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$408[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$408[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$408[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$243,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$246,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var enabled_data_collections = param[1];
		                       return cont([0, enabled_data_collections]);
		                      },
		                      function(param, cont){
		                       var enabled_data_collections = param[1];
		                       return cont([0, enabled_data_collections, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_enabled_data_collections,
		                        0,
		                        2,
		                        [0, a],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$408[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$408[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$419 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$408, [0, schematic_cache$419]);
		               var
		                schema$98 =
		                  caml_callback
		                   (schema_versioned$247,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$409 = [];
		               function data_record_change_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$409[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, adW, adV, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$409[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$409[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$409[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                adY,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  cst_created,
		                                  cst_Created,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var record = param[1];
		                                     return cont(record);
		                                    },
		                                    function(record, cont){return cont([0, record, 0]);},
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_record,
		                                      0,
		                                      2,
		                                      [0, no_input_schema],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_updated,
		                                   cst_Updated,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var record = param[1];
		                                      return cont(record);
		                                     },
		                                     function(record, cont){return cont([0, record, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_record,
		                                       0,
		                                       2,
		                                       [0, no_input_schema],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){
		                                     return typeof param === "number" ? cont(adX) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_deleted,
		                                    cst_Deleted,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$409[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$409[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$420 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$409, [0, schematic_cache$420]);
		               caml_callback
		                (data_record_change_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$421 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$410 = [];
		               caml_update_dummy
		                (letrec_function_context$410, [0, schematic_cache$421]);
		               function schematic_version$60(param, cont){return cont(0);}
		               var
		                cst_workspaceId = "workspaceId",
		                schematic_schema_version$117 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$410[1][1],
		                    schematic_schema_version$117]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$410[1][1],
		                             schematic_schema_version$117,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$410[1][1],
		schematic_schema_version$117,
		schematic_self,
		function(a){
		 letrec_function_context$410[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (Flow_instance[4],
		          schematic_version$60,
		          function(b){
		           var
		            a =
		              [0,
		               [0, 0, 0, 0, 0, "recordId", 0, 2, [0, schema$266], 0, 0],
		               [0,
		                [0, 0, 0, 0, 0, "flowInstanceId", 0, 2, [0, b], 0, 0],
		                0]];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$120,
		                    schematic_version$60,
		                    function(c){
		                     var
		                      b =
		                        [0, [0, 0, 0, 0, 0, cst_workspaceId, 0, 2, [0, c], 0, 0], a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$104,
		                              schematic_version$60,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, c], 0, 0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (data_record_change_schema_vers,
		schematic_version$60,
		function(b){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       instance_id = c[2][1],
		       record_id = c[1],
		       workspace_id = b[1],
		       organization_id = a[1],
		       data_record_change = param[1];
		      return cont
		              ([0,
		                data_record_change,
		                organization_id,
		                workspace_id,
		                record_id,
		                instance_id]);
		     },
		     function(param, cont){
		      var
		       instance_id = param[5],
		       record_id = param[4],
		       workspace_id = param[3],
		       organization_id = param[2],
		       data_record_change = param[1];
		      return cont
		              ([0,
		                data_record_change,
		                [0,
		                 organization_id,
		                 [0, workspace_id, [0, record_id, [0, instance_id, 0]]]]]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_data_record_change, 0, 2, [1, b], 0, 0],
		      a]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$410[1][1],
		          schematic_schema_version$117,
		          res,
		          function(a){
		           letrec_function_context$410[1][1] = a;
		           return cont(res);
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function base_client_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$67,
		                                   schematic_version,
		                                   function(a){return cont([0, adZ, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                base_client_schema =
		                  caml_callback
		                   (base_client_schema_versioned,
		                    [function(param, cont){return cont(0);}]),
		                schematic_cache$422 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$411 = [];
		               caml_update_dummy
		                (letrec_function_context$411, [0, schematic_cache$422]);
		               function schematic_version$61(param, cont){return cont(0);}
		               var schematic_schema_version$116 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$411[1][1],
		                    schematic_schema_version$116]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$411[1][1],
		                             schematic_schema_version$116,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$411[1][1],
		schematic_schema_version$116,
		schematic_self,
		function(a){
		 letrec_function_context$411[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$104,
		          schematic_version$61,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (option_schema,
		                    a,
		                    function(b){
		                     var
		                      default$ = match$150[1],
		                      a =
		                        [0,
		                         [0,
		                          ad0,
		                          0,
		                          0,
		                          0,
		                          cst_organization_id,
		                          0,
		                          [0, default$],
		                          [0, b],
		                          0,
		                          0],
		                         0];
		                     return caml_exact_trampoline_cps_call
		                             (base_client_schema_versioned,
		                              schematic_version$61,
		                              function(b){
		                               var
		                                res =
		                                  [7,
		                                   function(param, cont){
		                                    var organization_id = param[2][1], base = param[1];
		                                    return cont([0, base, organization_id]);
		                                   },
		                                   function(param, cont){
		                                    var organization_id = param[2], base = param[1];
		                                    return cont([0, base, [0, organization_id, 0]]);
		                                   },
		                                   [0, [0, ad1, 0, 0, 0, cst_base, 0, 2, [1, b], 0, 0], a]];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$411[1][1],
		schematic_schema_version$116,
		res,
		function(a){
		 letrec_function_context$411[1][1] = a;
		 return cont(res);
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function base_client_schema_versioned$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (client_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, ad2, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (base_client_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$423 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$412 = [];
		               caml_update_dummy
		                (letrec_function_context$412, [0, schematic_cache$423]);
		               function schematic_version$62(param, cont){return cont(0);}
		               var schematic_schema_version$115 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$412[1][1],
		                    schematic_schema_version$115]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$412[1][1],
		                             schematic_schema_version$115,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$412[1][1],
		schematic_schema_version$115,
		schematic_self,
		function(a){
		 letrec_function_context$412[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$104,
		          schematic_version$62,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (option_schema,
		                    a,
		                    function(b){
		                     var
		                      default$ = match$151[1],
		                      a =
		                        [0,
		                         [0,
		                          ad3,
		                          0,
		                          0,
		                          0,
		                          cst_organization_id,
		                          0,
		                          [0, default$],
		                          [0, b],
		                          0,
		                          0],
		                         0];
		                     return caml_exact_trampoline_cps_call
		                             (base_client_schema_versioned$0,
		                              schematic_version$62,
		                              function(b){
		                               var
		                                res =
		                                  [7,
		                                   function(param, cont){
		                                    var organization_id = param[2][1], base = param[1];
		                                    return cont([0, base, organization_id]);
		                                   },
		                                   function(param, cont){
		                                    var organization_id = param[2], base = param[1];
		                                    return cont([0, base, [0, organization_id, 0]]);
		                                   },
		                                   [0, [0, ad4, 0, 0, 0, cst_base, 0, 2, [1, b], 0, 0], a]];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$412[1][1],
		schematic_schema_version$115,
		res,
		function(a){
		 letrec_function_context$412[1][1] = a;
		 return cont(res);
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$413 = [];
		               function equal$153(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$413[1],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                          if(! c) return cont(c);
		                          var b$0 = rhs[3], a$0 = lhs[3];
		                          return cont(a$0 === b$0 ? 1 : 0);
		                         });
		               }
		               caml_update_dummy(letrec_function_context$413, [0, equal$15]);
		               var letrec_function_context$414 = [];
		               function schema_versioned$248(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$414[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ad5, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$414[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$414[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$414[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  result = a[2][1],
		                                  name = a[1],
		                                  arguments$ = param[1];
		                                 return cont([0, arguments$, name, result]);
		                                },
		                                function(param, cont){
		                                 var
		                                  result = param[3],
		                                  name = param[2],
		                                  arguments$ = param[1];
		                                 return cont([0, arguments$, [0, name, [0, result, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_arguments,
		                                  0,
		                                  2,
		                                  [0, no_input_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_result,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$414[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$414[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$424 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$414, [0, schematic_cache$424]);
		               caml_callback
		                (schema_versioned$248,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$415 = [];
		               function equal_role(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(0 === lhs){
		                  if(typeof rhs === "number" && ! rhs) return cont(1);
		                 }
		                 else if(typeof rhs === "number" && rhs) return cont(1);
		                }
		                else
		                 if(0 === lhs[0]){
		                  if(typeof rhs !== "number" && 0 === rhs[0]){
		                   var
		                    rhsattachments = rhs[1],
		                    lhsattachments = lhs[1],
		                    a =
		                      function(x, y){
		                       if(x){
		                        if(y){
		                         var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                         return caml_trampoline_cps_call3
		                                 (letrec_function_context$415[2],
		                                  a$0,
		                                  b,
		                                  function(b){
		                                   return b
		   ? caml_exact_trampoline_call2(a, x$0, y$0)
		   : cont(b);
		                                  });
		                        }
		                       }
		                       else if(! y) return cont(1);
		                       return cont(0);
		                      };
		                   return a(lhsattachments, rhsattachments);
		                  }
		                 }
		                 else if(typeof rhs !== "number" && 0 !== rhs[0]){
		                  var
		                   rhstool_calls = rhs[1],
		                   lhstool_calls = lhs[1],
		                   b =
		                     function(x, y){
		                      if(x){
		                       if(y){
		                        var y$0 = y[2], b$0 = y[1], x$0 = x[2], a = x[1];
		                        return caml_trampoline_cps_call3
		                                (letrec_function_context$415[1],
		                                 a,
		                                 b$0,
		                                 function(a){
		                                  return a
		  ? caml_exact_trampoline_call2(b, x$0, y$0)
		  : cont(a);
		                                 });
		                       }
		                      }
		                      else if(! y) return cont(1);
		                      return cont(0);
		                     };
		                  return b(lhstool_calls, rhstool_calls);
		                 }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$415, [0, equal$153, equal$136]);
		               var letrec_function_context$416 = [];
		               function role_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$416[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ad6, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$416[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$416[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$416[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && ! param) return cont(ad8);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_system,
		                                 cst_System,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(1);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && param) return cont(ad7);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_developer,
		                                  cst_Developer,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     ad_,
		                                     ad9,
		                                     1,
		                                     1,
		                                     2,
		                                     function(c){
		                                      var b = [0, [0, c, V$2]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$248,
		       schematic_version,
		       function(d){
		        var
		         default$ = match$152[1],
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_assistant,
		             cst_Assistant,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var tool_calls = param[1];
		                return cont(tool_calls);
		               },
		               function(tool_calls, cont){return cont([0, tool_calls, 0]);},
		               [0,
		                [0,
		                 ad$,
		                 0,
		                 0,
		                 0,
		                 cst_tool_calls,
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, d], 0]],
		                 b,
		                 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aeb,
		                 aea,
		                 1,
		                 0,
		                 2,
		                 function(b){
		                  var a = [0, [0, b, V$2]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$221,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$153[1],
		                             res =
		                               [11,
		                                aed,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  cst_user,
		                                  cst_User,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var attachments = param[1];
		                                     return cont(attachments);
		                                    },
		                                    function(attachments, cont){
		                                     return cont([0, attachments, 0]);
		                                    },
		                                    [0,
		                                     [0,
		                                      aec,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_attachments,
		                                      0,
		                                      [0, default$],
		                                      [0, [0, 0, 0, [3, b], 0]],
		                                      a,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 c],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$416[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$416[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$425 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$416, [0, schematic_cache$425]);
		               caml_callback
		                (role_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$417 = [];
		               function equal$154(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$417[2],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                          if(! c) return cont(c);
		                          var y = rhs[3], x = lhs[3];
		                          function d(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$417[1],
		                                      a,
		                                      b,
		                                      function(a){
		                                       return a
		       ? caml_exact_trampoline_call2(d, x$0, y$0)
		       : cont(a);
		                                      });
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return d(x, y);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$417, [0, equal$45, equal_role]);
		               var
		                cst_citations = "citations",
		                letrec_function_context$418 = [];
		               function schema_versioned$249(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$2,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$418[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aef, aee, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$418[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$418[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$418[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aeh,
		                                     aeg,
		                                     1,
		                                     0,
		                                     2,
		                                     function(b){
		                                      var a = [0, [0, b, V$2]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$68,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$154[1],
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_content,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0,
		             [0,
		              aei,
		              0,
		              0,
		              0,
		              cst_citations,
		              0,
		              [0, default$],
		              [0, [0, 0, 0, [3, c], 0]],
		              a,
		              0],
		             0]];
		        return caml_exact_trampoline_cps_call
		                (role_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        citations = a[2][1],
		                        content = a[1],
		                        role = param[1];
		                       return cont([0, role, content, citations]);
		                      },
		                      function(param, cont){
		                       var
		                        citations = param[3],
		                        content = param[2],
		                        role = param[1];
		                       return cont([0, role, [0, content, [0, citations, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_role, 0, 2, [1, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$418[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$418[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$426 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$418, [0, schematic_cache$426]);
		               caml_callback
		                (schema_versioned$249,
		                 [function(param, cont){return cont(0);}]);
		               function equal$155(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  case 2:
		                   if(2 === rhs) return cont(1); break;
		                  case 3:
		                   if(3 === rhs) return cont(1); break;
		                  case 4:
		                   if(4 === rhs) return cont(1); break;
		                  case 5:
		                   if(5 === rhs) return cont(1); break;
		                  case 6:
		                   if(6 === rhs) return cont(1); break;
		                  case 7:
		                   if(7 === rhs) return cont(1); break;
		                  case 8:
		                   if(8 === rhs) return cont(1); break;
		                  case 9:
		                   if(9 === rhs) return cont(1); break;
		                  case 10:
		                   if(10 === rhs) return cont(1); break;
		                  case 11:
		                   if(11 === rhs) return cont(1); break;
		                  case 12:
		                   if(12 === rhs) return cont(1); break;
		                  case 13:
		                   if(13 === rhs) return cont(1); break;
		                  case 14:
		                   if(14 === rhs) return cont(1); break;
		                  case 15:
		                   if(15 === rhs) return cont(1); break;
		                  case 16:
		                   if(16 === rhs) return cont(1); break;
		                  case 17:
		                   if(17 === rhs) return cont(1); break;
		                  default: if(18 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var cst_Notion = "Notion", letrec_function_context$419 = [];
		               function schema_versioned$250(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$419[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aej, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$419[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$419[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$419[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     ael,
		                                     aek,
		                                     2,
		                                     0,
		                                     1,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(18);},
		   function(param, cont){
		    return 18 <= param ? cont(aen) : cont(0);
		   },
		   0,
		   0,
		   cst_notion,
		   cst_Notion,
		   aem,
		   [0, [0, b, V$4]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aep,
		       aeo,
		       1,
		       1,
		       2,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){return cont(17);},
		             function(param, cont){
		              return 17 === param ? cont(aer) : cont(0);
		             },
		             0,
		             0,
		             cst_instantly,
		             "Instantly",
		             aeq,
		             [0, [0, c, V$4]]],
		            a];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aet,
		                 aes,
		                 1,
		                 1,
		                 2,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(16);},
		                       function(param, cont){
		                        return 16 === param ? cont(aev) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_linkedin,
		                       "Linkedin",
		                       aeu,
		                       [0, [0, c, V$4]]],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aex,
		                           aew,
		                           1,
		                           1,
		                           2,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(15);},
		                                 function(param, cont){
		                                  return 15 === param ? cont(aez) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_featurebase,
		                                 "Featurebase",
		                                 aey,
		                                 [0, [0, c, V$4]]],
		                                a];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aeB,
		                                     aeA,
		                                     1,
		                                     1,
		                                     2,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(14);},
		   function(param, cont){
		    return 14 === param ? cont(aeD) : cont(0);
		   },
		   0,
		   0,
		   cst_todoist,
		   "Todoist",
		   aeC,
		   [0, [0, c, V$4]]],
		  b];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aeF,
		       aeE,
		       2,
		       3,
		       3,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){return cont(13);},
		             function(param, cont){
		              return 13 === param ? cont(aeH) : cont(0);
		             },
		             0,
		             0,
		             cst_ticktick,
		             "Ticktick",
		             aeG,
		             [0, [0, c, V$4]]],
		            a];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aeJ,
		                 aeI,
		                 1,
		                 0,
		                 6,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(12);},
		                       function(param, cont){
		                        return 12 === param ? cont(aeL) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_whatsapp,
		                       "Whatsapp",
		                       aeK,
		                       [0, [0, c, V$4]]],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aeN,
		                           aeM,
		                           1,
		                           0,
		                           6,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(11);},
		                                 function(param, cont){
		                                  return 11 === param ? cont(aeP) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_jira,
		                                 "Jira",
		                                 aeO,
		                                 [0, [0, c, V$4]]],
		                                a];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aeR,
		                                     aeQ,
		                                     1,
		                                     0,
		                                     5,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(10);},
		   function(param, cont){
		    return 10 === param ? cont(aeT) : cont(0);
		   },
		   0,
		   0,
		   cst_trello,
		   "Trello",
		   aeS,
		   [0, [0, c, V$4]]],
		  b];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aeV,
		       aeU,
		       1,
		       0,
		       5,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){return cont(9);},
		             function(param, cont){
		              return 9 === param ? cont(aeX) : cont(0);
		             },
		             0,
		             0,
		             cst_gitlab,
		             "Gitlab",
		             aeW,
		             [0, [0, c, V$4]]],
		            a];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aeZ,
		                 aeY,
		                 1,
		                 0,
		                 5,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(8);},
		                       function(param, cont){
		                        return 8 === param ? cont(ae1) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_linear,
		                       "Linear",
		                       ae0,
		                       [0, [0, c, V$4]]],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           ae3,
		                           ae2,
		                           1,
		                           0,
		                           5,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(7);},
		                                 function(param, cont){
		                                  return 7 === param ? cont(ae5) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_pipedrive,
		                                 "Pipedrive",
		                                 ae4,
		                                 [0, [0, c, V$4]]],
		                                a];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     ae7,
		                                     ae6,
		                                     1,
		                                     0,
		                                     5,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){return cont(4);},
		   function(param, cont){
		    return 4 === param ? cont(afb) : cont(0);
		   },
		   0,
		   0,
		   cst_gmail,
		   cst_Gmail,
		   afa,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(5);},
		    function(param, cont){
		     return 5 === param ? cont(ae$) : cont(0);
		    },
		    0,
		    0,
		    cst_slack,
		    "Slack",
		    ae_,
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(6);},
		     function(param, cont){
		      return 6 === param ? cont(ae9) : cont(0);
		     },
		     0,
		     0,
		     cst_attio,
		     "Attio",
		     ae8,
		     [0, [0, c, V$4]]],
		    b]]];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       afd,
		       afc,
		       1,
		       0,
		       2,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){return cont(3);},
		             function(param, cont){
		              return 3 === param ? cont(aff) : cont(0);
		             },
		             0,
		             0,
		             cst_github,
		             "Github",
		             afe,
		             [0, [0, c, V$4]]],
		            a];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 afh,
		                 afg,
		                 1,
		                 0,
		                 4,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(2);},
		                       function(param, cont){
		                        return 2 === param ? cont(afj) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_clickup,
		                       "Clickup",
		                       afi,
		                       [0, [0, c, V$4]]],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           afl,
		                           afk,
		                           2,
		                           0,
		                           4,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(1);},
		                                 function(param, cont){
		                                  return 1 === param ? cont(afn) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_asana,
		                                 "Asana",
		                                 afm,
		                                 [0, [0, c, V$4]]],
		                                a];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     afp,
		                                     afo,
		                                     1,
		                                     0,
		                                     4,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){return param ? cont(0) : cont(afr);},
		    0,
		    0,
		    cst_apolloio,
		    "Apollo",
		    afq,
		    [0, [0, a, V$4]]],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$419[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$419[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$427 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$419, [0, schematic_cache$427]);
		               var
		                schema$99 =
		                  caml_callback
		                   (schema_versioned$250,
		                    [function(param, cont){return cont(0);}]),
		                Id$8 = caml_callback(Make$12, [[0, cst_mcp, cst$21]]),
		                letrec_function_context$420 = [];
		               function equal$156(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$420[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$420[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               var _1$39 = Id$8[15];
		               caml_update_dummy
		                (letrec_function_context$420, [0, _1$39, equal$155]);
		               var
		                cst_Mcp_server = "Mcp_server",
		                cst_Membrane = "Membrane",
		                cst_mcp_server = "mcp_server",
		                cst_membrane = "membrane",
		                letrec_function_context$421 = [];
		               function schema_versioned$251(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$421[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$421[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$421[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$421[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     afu,
		                                     aft,
		                                     2,
		                                     3,
		                                     2,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (Id$8[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_mcp_server,
		             cst_Mcp_server,
		             c,
		             a],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$250,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_membrane,
		                        cst_Membrane,
		                        a,
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$421[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$421[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$428 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$421, [0, schematic_cache$428]);
		               caml_callback
		                (schema_versioned$251,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$422 = [];
		               function equal$157(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$422[1], x, cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$422, [0, equal_connection_id]);
		               function schema_versioned$252(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (connection_id_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$252,
		                 [function(param, cont){return cont(0);}]);
		               function equal$158(a, b, cont){return cont(a === b ? 1 : 0);}
		               function schema_versioned$253(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var letrec_function_context$423 = [];
		               function equal$159(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$423[3],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(c){
		                           if(! c) return cont(c);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$423[1], a, b, cont);
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$423[2], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$423,
		                 [0, equal$53, equal$157, equal$156]);
		               var letrec_function_context$424 = [];
		               function schema_versioned$254(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$424[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afv, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$424[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$424[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$424[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(b){
		        var
		         default$ = match$155[1],
		         a =
		           [0,
		            [0,
		             afw,
		             0,
		             0,
		             0,
		             cst_org_id,
		             0,
		             [0, default$],
		             [0, b],
		             0,
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$252,
		                 schematic_version,
		                 function(c){
		                  var
		                   b = [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$251,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  org_id = a[2][1],
		                                  data = a[1],
		                                  key = param[1];
		                                 return cont([0, key, data, org_id]);
		                                },
		                                function(param, cont){
		                                 var org_id = param[3], data = param[2], key = param[1];
		                                 return cont([0, key, [0, data, [0, org_id, 0]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, a], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$424[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$424[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$429 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$424, [0, schematic_cache$429]);
		               caml_callback
		                (schema_versioned$254,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$425 = [];
		               function equal$160(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$425[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$425[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$425, [0, equal$59, equal$158]);
		               var letrec_function_context$426 = [];
		               function schema_versioned$255(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$426[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afx, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$426[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$426[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$426[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$253,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var data = param[2][1], key = param[1];
		             return cont([0, key, data]);
		            },
		            function(param, cont){
		             var data = param[2], key = param[1];
		             return cont([0, key, [0, data, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$426[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$426[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$430 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$426, [0, schematic_cache$430]);
		               caml_callback
		                (schema_versioned$255,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$427 = [];
		               function equal$161(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$427[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$427[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$427, [0, equal$69, equal$158]);
		               var letrec_function_context$428 = [];
		               function schema_versioned$256(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$428[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afy, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$428[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$428[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$428[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$131,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$253,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var data = param[2][1], key = param[1];
		             return cont([0, key, data]);
		            },
		            function(param, cont){
		             var data = param[2], key = param[1];
		             return cont([0, key, [0, data, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$428[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$428[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$431 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$428, [0, schematic_cache$431]);
		               caml_callback
		                (schema_versioned$256,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$429 = [];
		               function equal$162(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 function c(c){
		                  function a(b){
		                   if(! b) return cont(b);
		                   var y = rhs[3], x = lhs[3];
		                   function a(x, y){
		                    if(x){
		                     if(y){
		                      var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$429[1],
		                               a$0,
		                               b,
		                               function(b){
		                                return b
		? caml_exact_trampoline_call2(a, x$0, y$0)
		: cont(b);
		                               });
		                     }
		                    }
		                    else if(! y) return cont(1);
		                    return cont(0);
		                   }
		                   return a(x, y);
		                  }
		                  if(! c) return a(c);
		                  var y = rhs[2], x = lhs[2];
		                  function b(x, y){
		                   if(x){
		                    if(y){
		                     var y$0 = y[2], b$0 = y[1], x$0 = x[2], a$0 = x[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$429[2],
		                              a$0,
		                              b$0,
		                              function(c){
		                               return c ? caml_exact_trampoline_call2(b, x$0, y$0) : a(c);
		                              });
		                    }
		                   }
		                   else if(! y) return a(1);
		                   return a(0);
		                  }
		                  return b(x, y);
		                 }
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$429[3],
		                            a$0,
		                            b,
		                            function(b){
		                             return b ? caml_exact_trampoline_call2(a, x$0, y$0) : c(b);
		                            });
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                return a(x, y);
		               }
		               caml_update_dummy
		                (letrec_function_context$429,
		                 [0, equal$161, equal$160, equal$159]);
		               var letrec_function_context$430 = [];
		               function schema_versioned$257(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$430[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afz, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$430[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$430[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$430[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$256,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$156[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_references,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$255,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$157[1],
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_mentions,
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$254,
		                 schematic_version,
		                 function(a){
		                  var
		                   default$ = match$158[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        references = a[2][1],
		                        mentions = a[1],
		                        integrations = param[1];
		                       return cont([0, integrations, mentions, references]);
		                      },
		                      function(param, cont){
		                       var
		                        references = param[3],
		                        mentions = param[2],
		                        integrations = param[1];
		                       return cont
		                               ([0, integrations, [0, mentions, [0, references, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_integrations,
		                        0,
		                        [0, default$],
		                        [0, [0, 0, 0, [3, a], 0]],
		                        0,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$430[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$430[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$432 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$430, [0, schematic_cache$432]);
		               var
		                schema$100 =
		                  caml_callback
		                   (schema_versioned$257,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$431 = [];
		               function equal$163(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$431[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$431[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$431, [0, equal$75, equal$162]);
		               var letrec_function_context$432 = [];
		               function schema_versioned$258(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$432[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$432[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$432[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$432[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$140,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_document, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       afC,
		       afB,
		       1,
		       0,
		       2,
		       function(c){
		        var b = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$257,
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var document = param[2][1], context = param[1];
		                       return cont([0, context, document]);
		                      },
		                      function(param, cont){
		                       var document = param[2], context = param[1];
		                       return cont([0, context, [0, document, 0]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_context, 0, [0, default$], [0, c], b, 0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$432[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$432[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$433 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$432, [0, schematic_cache$433]);
		               caml_callback
		                (schema_versioned$258,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$434 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$433 = [];
		               caml_update_dummy
		                (letrec_function_context$433, [0, schematic_cache$434]);
		               function schematic_version$63(param, cont){return cont(0);}
		               var
		                schematic_schema_version$114 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$433[1][1],
		                     schematic_schema_version$114]);
		               if(h)
		                var schema$101 = h[1], descriptor$21 = schema$101;
		               else
		                descriptor$21 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$433[1][1],
		                              schematic_schema_version$114,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$433[1][1],
		 schematic_schema_version$114,
		 schematic_self,
		 function(a){
		  letrec_function_context$433[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$68,
		           schematic_version$63,
		           function(a){
		            var
		             default$ = match$159[1],
		             res =
		               [7,
		                function(param, cont){
		                 var citations = param[2][1], text = param[1];
		                 return cont([0, text, citations]);
		                },
		                function(param, cont){
		                 var citations = param[2], text = param[1];
		                 return cont([0, text, [0, citations, 0]]);
		                },
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_text,
		                  0,
		                  2,
		                  [0, schematic_param_name_schema_ve],
		                  0,
		                  0],
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_citations,
		                   0,
		                   [0, default$],
		                   [0, [0, 0, 0, [3, a], 0]],
		                   0,
		                   0],
		                  0]]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$433[1][1],
		                     schematic_schema_version$114,
		                     res,
		                     function(a){
		                      letrec_function_context$433[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$102 = [0, afD, 0, descriptor$21, 0],
		                pp$85 = Conversation[1],
		                schema_versioned$259 = Conversation[4],
		                schema$103 = Conversation[5],
		                to_string$54 = Conversation[8],
		                symbol$169 = Conversation[9],
		                symbol$170 = Conversation[10],
		                symbol$171 = Conversation[11],
		                symbol$172 = Conversation[12],
		                symbol$173 = Conversation[13],
		                symbol$174 = Conversation[14],
		                equal$164 = Conversation[15],
		                compare$114 = Conversation[16],
		                min$24 = Conversation[17],
		                max$26 = Conversation[18],
		                ascending$15 = Conversation[19],
		                descending$15 = Conversation[20],
		                between$16 = Conversation[21],
		                clamp_exn$15 = Conversation[22],
		                clamp$15 = Conversation[23],
		                comparator$33 = Conversation[24],
		                Set$2 = Conversation[26],
		                By$13 = Conversation[27],
		                make$51 = Conversation[29],
		                letrec_function_context$434 = [];
		               function equal$165(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$434[1],
		                            a$0,
		                            b,
		                            function(b){
		                             return b
		                                     ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                     : cont(b);
		                            });
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                }
		                return a(x, y);
		               }
		               caml_update_dummy(letrec_function_context$434, [0, equal$153]);
		               var letrec_function_context$435 = [];
		               function schema_versioned$260(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$435[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afE, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$435[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$435[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$435[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$248,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var tool_calls = param[1];
		   return cont([0, tool_calls]);
		  },
		  function(param, cont){
		   var tool_calls = param[1];
		   return cont([0, tool_calls, 0]);
		  },
		  [0,
		   [0,
		    afF,
		    0,
		    0,
		    0,
		    cst_tool_calls,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$435[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$435[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$435 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$435, [0, schematic_cache$435]);
		               caml_callback
		                (schema_versioned$260,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$436 = [];
		               function equal$166(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(b){
		                 function a(c){
		                  function a(b){
		                   function a(d){
		                    function c(c){
		                     a:
		                     if(c){
		                      var y = rhs[6], x = lhs[6];
		                      if(x){
		                       if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                      }
		                      else if(! y){c = 1; break a;}
		                      c = 0;
		                     }
		                     function d(c){
		                      a:
		                      if(c){
		                       var y = rhs[8], x = lhs[8];
		                       if(x){
		                        if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                       }
		                       else if(! y){c = 1; break a;}
		                       c = 0;
		                      }
		                      return c
		                              ? caml_trampoline_cps_call3
		                                (letrec_function_context$436[1], lhs[9], rhs[9], cont)
		                              : cont(c);
		                     }
		                     if(! c) return d(c);
		                     var y$0 = rhs[7], x$0 = lhs[7];
		                     if(x$0){
		                      if(y$0){
		                       var b$0 = y$0[1], a$0 = x$0[1];
		                       return caml_trampoline_cps_call3
		                               (letrec_function_context$436[2], a$0, b$0, d);
		                      }
		                     }
		                     else if(! y$0) return d(1);
		                     return d(0);
		                    }
		                    if(! d) return c(d);
		                    var y = rhs[5], x = lhs[5];
		                    if(x){
		                     if(y){
		                      var b = y[1], a = x[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$436[3], a, b, c);
		                     }
		                    }
		                    else if(! y) return c(1);
		                    return c(0);
		                   }
		                   return b
		                           ? caml_trampoline_cps_call3
		                             (letrec_function_context$436[4], lhs[4], rhs[4], a)
		                           : a(b);
		                  }
		                  if(! c) return a(c);
		                  var y = rhs[3], x = lhs[3];
		                  function b(x, y){
		                   if(x){
		                    if(y){
		                     var y$0 = y[2], b$0 = y[1], x$0 = x[2], a$0 = x[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$436[5],
		                              a$0,
		                              b$0,
		                              function(c){
		                               return c ? caml_exact_trampoline_call2(b, x$0, y$0) : a(c);
		                              });
		                    }
		                   }
		                   else if(! y) return a(1);
		                   return a(0);
		                  }
		                  return b(x, y);
		                 }
		                 return b
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$436[6], lhs[2], rhs[2], a)
		                         : a(b);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$436[7], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$436,
		                 [0,
		                  equal$20,
		                  equal$46,
		                  equal$165,
		                  equal$164,
		                  equal$154,
		                  equal$162,
		                  equal$56]);
		               var letrec_function_context$437 = [];
		               function schema_versioned$261(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$437[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$437[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$437[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$437[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_title,
		   0,
		   3,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0, 0, 0, 0, 0, cst_touched_last, 0, 2, [0, b], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$71,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_last_prompt_hash,
		             0,
		             3,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0,
		             [0, 0, 0, 0, 0, cst_last_response_id, 0, 3, [0, c], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 afI,
		                 afH,
		                 2,
		                 1,
		                 2,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$260,
		                           schematic_version,
		                           function(c){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     c,
		                                     function(d){
		                                      var
		                                       default$0 = match$160[1],
		                                       c =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_in_progress,
		   0,
		   [0, default$0],
		   [0, d],
		   a,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$259,
		       schematic_version,
		       function(b){
		        var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], c];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$249,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_history,
		                       0,
		                       2,
		                       [0, [0, 0, 0, [3, c], 0]],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           afK,
		                           afJ,
		                           1,
		                           0,
		                           2,
		                           function(c){
		                            var a = [0, [0, c, V$4]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$257,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0, 0, 0, 0, 0, cst_context, 0, [0, default$], [0, d], a, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       afM,
		       afL,
		       2,
		       2,
		       1,
		       function(b){
		        var a = [0, [0, b, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$110,
		                 schematic_version,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(b){
		                            var
		                             default$ = match$161[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  touched_last = g[2][1],
		                                  title = g[1],
		                                  last_response_id = f[1],
		                                  last_prompt_hash = e[1],
		                                  in_progress = d[1],
		                                  id = c[1],
		                                  history = b[1],
		                                  context = a[1],
		                                  agent_id = param[1];
		                                 return cont
		 ([0,
		   agent_id,
		   context,
		   history,
		   id,
		   in_progress,
		   last_prompt_hash,
		   last_response_id,
		   title,
		   touched_last]);
		                                },
		                                function(param, cont){
		                                 var
		                                  touched_last = param[9],
		                                  title = param[8],
		                                  last_response_id = param[7],
		                                  last_prompt_hash = param[6],
		                                  in_progress = param[5],
		                                  id = param[4],
		                                  history = param[3],
		                                  context = param[2],
		                                  agent_id = param[1];
		                                 return cont
		 ([0,
		   agent_id,
		   [0,
		    context,
		    [0,
		     history,
		     [0,
		      id,
		      [0,
		       in_progress,
		       [0,
		        last_prompt_hash,
		        [0, last_response_id, [0, title, [0, touched_last, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_agent_id,
		                                  0,
		                                  [0, default$],
		                                  [0, b],
		                                  a,
		                                  0],
		                                 c]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$437[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$437[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$436 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$437, [0, schematic_cache$436]);
		               var
		                schema$104 =
		                  caml_callback
		                   (schema_versioned$261,
		                    [function(param, cont){return cont(0);}]),
		                schematic_cache$437 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$438 = [];
		               caml_update_dummy
		                (letrec_function_context$438, [0, schematic_cache$437]);
		               function schematic_version$64(param, cont){return cont(0);}
		               var
		                schematic_schema_version$113 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$438[1][1],
		                     schematic_schema_version$113]);
		               if(h)
		                var schema$105 = h[1], descriptor$22 = schema$105;
		               else
		                descriptor$22 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$438[1][1],
		                              schematic_schema_version$113,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$438[1][1],
		 schematic_schema_version$113,
		 schematic_self,
		 function(a){
		  letrec_function_context$438[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$258,
		           schematic_version$64,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_working_memory, 0, 3, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$258,
		                     schematic_version$64,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0, 0, 0, 0, 0, cst_user_preferences, 0, 3, [0, c], 0, 0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$258,
		                               schematic_version$64,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      working_memory = a[2][1],
		                                      user_preferences = a[1],
		                                      agent_instructions = param[1];
		                                     return cont
		     ([0, agent_instructions, user_preferences, working_memory]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      working_memory = param[3],
		                                      user_preferences = param[2],
		                                      agent_instructions = param[1];
		                                     return cont
		     ([0,
		       agent_instructions,
		       [0, user_preferences, [0, working_memory, 0]]]);
		                                    },
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_agent_instructions, 0, 3, [0, a], 0, 0],
		                                     b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$438[1][1],
		 schematic_schema_version$113,
		 res,
		 function(a){
		  letrec_function_context$438[1][1] = a;
		  return cont(res);
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$106 = [0, afN, 0, descriptor$22, 0],
		                letrec_function_context$439 = [];
		               function equal$167(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$439[6],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          function a(b){
		                           function a(b){
		                            function a(c){
		                             a:
		                             if(c){
		                              var y = rhs[5], x = lhs[5];
		                              if(x){
		                               if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                              }
		                              else if(! y){c = 1; break a;}
		                              c = 0;
		                             }
		                             a:
		                             if(c){
		                              var y$0 = rhs[6], x$0 = lhs[6];
		                              if(x$0){
		                               if(y$0){
		                                var b$0 = y$0[1], a$0 = x$0[1], c = a$0 === b$0 ? 1 : 0;
		                                break a;
		                               }
		                              }
		                              else if(! y$0){c = 1; break a;}
		                              c = 0;
		                             }
		                             function d(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$439[1], lhs[8], rhs[8], cont)
		                                      : cont(a);
		                             }
		                             return c
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$439[2], lhs[7], rhs[7], d)
		                                     : d(c);
		                            }
		                            return b
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$439[3], lhs[4], rhs[4], a)
		                                    : a(b);
		                           }
		                           return b
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$439[4], lhs[3], rhs[3], a)
		                                   : a(b);
		                          }
		                          if(! c) return a(c);
		                          var y = rhs[2], x = lhs[2];
		                          function b(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b$0 = y[1], x$0 = x[2], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$439[5],
		                                      a$0,
		                                      b$0,
		                                      function(c){
		                                       return c ? caml_exact_trampoline_call2(b, x$0, y$0) : a(c);
		                                      });
		                            }
		                           }
		                           else if(! y) return a(1);
		                           return a(0);
		                          }
		                          return b(x, y);
		                         });
		               }
		               var _2$20 = Conversation[26][16], _1$40 = Automation[15];
		               caml_update_dummy
		                (letrec_function_context$439,
		                 [0, equal$163, equal$163, equal$56, _2$20, _1$40, equal$163]);
		               var letrec_function_context$440 = [];
		               function schema_versioned$262(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$440[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afO, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$440[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$440[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$440[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$258,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_working_memory, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$258,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_key,
		             0,
		             3,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_name,
		              0,
		              3,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, cst_user_preferences, 0, 2, [0, c], 0, 0],
		              a]]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$110,
		                 schematic_version,
		                 function(c){
		                  var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Conversation[26][65],
		                           schematic_version,
		                           function(c){
		                            var
		                             default$ = Conversation[26][67],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_conversations,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Automation[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$162[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_automations,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, c], 0]],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$258,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              working_memory = f[2][1],
		              user_preferences = f[1],
		              name = e[1],
		              key = d[1],
		              id = c[1],
		              conversations = b[1],
		              automations = a[1],
		              agent_instructions = param[1];
		             return cont
		                     ([0,
		                       agent_instructions,
		                       automations,
		                       conversations,
		                       id,
		                       key,
		                       name,
		                       user_preferences,
		                       working_memory]);
		            },
		            function(param, cont){
		             var
		              working_memory = param[8],
		              user_preferences = param[7],
		              name = param[6],
		              key = param[5],
		              id = param[4],
		              conversations = param[3],
		              automations = param[2],
		              agent_instructions = param[1];
		             return cont
		                     ([0,
		                       agent_instructions,
		                       [0,
		                        automations,
		                        [0,
		                         conversations,
		                         [0,
		                          id,
		                          [0,
		                           key,
		                           [0, name, [0, user_preferences, [0, working_memory, 0]]]]]]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_agent_instructions, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$440[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$440[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$438 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$440, [0, schematic_cache$438]);
		               var
		                schema$107 =
		                  caml_callback
		                   (schema_versioned$262,
		                    [function(param, cont){return cont(0);}]),
		                pp$86 = include$61[1],
		                schema_versioned$263 = include$61[4],
		                schema$108 = include$61[5],
		                symbol$175 = include$61[9],
		                symbol$176 = include$61[10],
		                symbol$177 = include$61[11],
		                symbol$178 = include$61[12],
		                symbol$179 = include$61[13],
		                symbol$180 = include$61[14],
		                equal$168 = include$61[15],
		                compare$115 = include$61[16],
		                min$25 = include$61[17],
		                max$27 = include$61[18],
		                ascending$16 = include$61[19],
		                descending$16 = include$61[20],
		                between$17 = include$61[21],
		                clamp_exn$16 = include$61[22],
		                clamp$16 = include$61[23],
		                comparator$34 = include$61[24],
		                By$14 = include$61[27],
		                make$52 = include$61[29],
		                letrec_function_context$441 = [];
		               function equal$169(lhs, rhs, cont){
		                var rhsprompt = rhs[1], lhsprompt = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$441[1], lhsprompt, rhsprompt, cont);
		               }
		               caml_update_dummy(letrec_function_context$441, [0, equal$163]);
		               var cst_prompt = "prompt", letrec_function_context$442 = [];
		               function schema_versioned$264(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$442[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$442[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$442[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$442[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$258,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  afR,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_agent,
		    cst_Agent,
		    [0,
		     0,
		     afQ,
		     [7,
		      function(param, cont){
		       var prompt = param[1];
		       return cont(prompt);
		      },
		      function(prompt, cont){return cont([0, prompt, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_prompt, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$442[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$442[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$439 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$442, [0, schematic_cache$439]);
		               var
		                schema$109 =
		                  caml_callback
		                   (schema_versioned$264,
		                    [function(param, cont){return cont(0);}]);
		               function Moded$13(M, Name, cont){
		                var letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, [0, Name[1]], 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$258,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(b){
		         var a = M[6].call(null, 0), b = [0, b];
		         if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		         var c = [0, [0, 0, 0, 0, 0, cst_prompt, 0, a, b, 0, 0], 0];
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  schematic_param_name_schema_ve,
		                  function(b){
		                   var a = M[6].call(null, 0), b = [0, b];
		                   if(a) var default$ = a[1], a = [0, default$]; else a = 2;
		                   var
		                    res =
		                      [7,
		                       function(param, cont){
		                        var prompt = param[2][1], name = param[1];
		                        return cont([0, name, prompt]);
		                       },
		                       function(param, cont){
		                        var prompt = param[2], name = param[1];
		                        return cont([0, name, [0, prompt, 0]]);
		                       },
		                       [0, [0, 0, 0, 0, 0, cst_name, 0, a, b, 0, 0], c]];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){return cont([0, , , , schema]);});
		               }
		               var
		                Create = caml_callback(Moded$13, [R$0, [0, "ai-step-create"]]),
		                Patch$1 = caml_callback(Moded$13, [W$0, [0, "ai-step-patch"]]),
		                letrec_function_context$443 = [];
		               function equal$170(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$443[2],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(c){
		                           if(! c) return cont(c);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){var b = y[1], a = x[1]; return cont(a === b ? 1 : 0);}
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$443[1], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$443, [0, equal$168, equal$169]);
		               var letrec_function_context$444 = [];
		               function schema_versioned$265(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$444[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afS, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$444[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$444[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$444[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 afT,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$263,
		                                     schematic_version,
		                                     function(c){
		                                      var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$264,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              name = a[2][1],
		              id = a[1],
		              action = param[1];
		             return cont([0, action, id, name]);
		            },
		            function(param, cont){
		             var name = param[3], id = param[2], action = param[1];
		             return cont([0, action, [0, id, [0, name, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_action, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$444[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$444[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$440 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$444, [0, schematic_cache$440]);
		               var
		                schema$110 =
		                  caml_callback
		                   (schema_versioned$265,
		                    [function(param, cont){return cont(0);}]),
		                pp$87 = Automation[1],
		                schema_versioned$266 = Automation[4],
		                schema$111 = Automation[5],
		                to_string$55 = Automation[8],
		                symbol$181 = Automation[9],
		                symbol$182 = Automation[10],
		                symbol$183 = Automation[11],
		                symbol$184 = Automation[12],
		                symbol$185 = Automation[13],
		                symbol$186 = Automation[14],
		                equal$171 = Automation[15],
		                compare$116 = Automation[16],
		                min$26 = Automation[17],
		                max$28 = Automation[18],
		                ascending$17 = Automation[19],
		                descending$17 = Automation[20],
		                between$18 = Automation[21],
		                clamp_exn$17 = Automation[22],
		                clamp$17 = Automation[23],
		                comparator$35 = Automation[24],
		                By$15 = Automation[27],
		                make$53 = Automation[29],
		                letrec_function_context$445 = [];
		               function equal$172(lhs, rhs, cont){
		                if(typeof lhs === "number")
		                 switch(lhs){
		                   case 0:
		                    if(typeof rhs === "number" && ! rhs) return cont(1); break;
		                   case 1:
		                    if(typeof rhs === "number" && 1 === rhs) return cont(1);
		                    break;
		                   case 2:
		                    if(typeof rhs === "number" && 2 === rhs) return cont(1);
		                    break;
		                   case 3:
		                    if(typeof rhs === "number" && 3 === rhs) return cont(1);
		                    break;
		                   case 4:
		                    if(typeof rhs === "number" && 4 === rhs) return cont(1);
		                    break;
		                   default:
		                    if(typeof rhs === "number" && 5 <= rhs) return cont(1);
		                 }
		                else if(typeof rhs !== "number"){
		                 var rhstable_id = rhs[1], lhstable_id = lhs[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context$445[1],
		                          lhstable_id,
		                          rhstable_id,
		                          cont);
		                }
		                return cont(0);
		               }
		               var _0$38 = Table[15];
		               caml_update_dummy(letrec_function_context$445, [0, _0$38]);
		               var
		                cst_Table_row = "Table_row",
		                cst_table_row = "table_row",
		                letrec_function_context$446 = [];
		               function schema_versioned$267(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$446[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, afU, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$446[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$446[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$446[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Table[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  af1,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){
		     if(typeof param === "number" && ! param) return cont(af0);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_event,
		    cst_Event,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(1);},
		     function(param, cont){
		      if(typeof param === "number" && 1 === param)
		       return cont(afZ);
		      return cont(0);
		     },
		     0,
		     0,
		     cst_task,
		     cst_Task,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){return cont(0);},
		       function(param, cont){return cont(0);},
		       0],
		      0],
		     0],
		    [0,
		     [0,
		      function(param, cont){return cont(2);},
		      function(param, cont){
		       if(typeof param === "number" && 2 === param)
		        return cont(afY);
		       return cont(0);
		      },
		      0,
		      0,
		      cst_page,
		      cst_Page,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){return cont(0);},
		        function(param, cont){return cont(0);},
		        0],
		       0],
		      0],
		     [0,
		      [0,
		       function(param, cont){return cont(3);},
		       function(param, cont){
		        if(typeof param === "number" && 3 === param)
		         return cont(afX);
		        return cont(0);
		       },
		       0,
		       0,
		       cst_people,
		       cst_People,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){return cont(0);},
		         function(param, cont){return cont(0);},
		         0],
		        0],
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(4);},
		        function(param, cont){
		         if(typeof param === "number" && 4 === param)
		          return cont(afW);
		         return cont(0);
		        },
		        0,
		        0,
		        cst_event_recurrent,
		        cst_Event_recurrent,
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){return cont(0);},
		          function(param, cont){return cont(0);},
		          0],
		         0],
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(5);},
		         function(param, cont){
		          if(typeof param === "number" && 5 <= param)
		           return cont(afV);
		          return cont(0);
		         },
		         0,
		         0,
		         cst_task_recurrent,
		         cst_Task_recurrent,
		         [0,
		          0,
		          0,
		          [7,
		           function(param, cont){return cont(0);},
		           function(param, cont){return cont(0);},
		           0],
		          0],
		         0],
		        [0,
		         [0,
		          function(f0, cont){return cont([0, f0]);},
		          function(param, cont){
		           if(typeof param === "number") return cont(0);
		           var f0 = param[1];
		           return cont([0, f0]);
		          },
		          1,
		          0,
		          cst_table_row,
		          cst_Table_row,
		          [0,
		           0,
		           0,
		           [7,
		            function(param, cont){
		             var table_id = param[1];
		             return cont(table_id);
		            },
		            function(table_id, cont){return cont([0, table_id, 0]);},
		            [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, a], 0, 0], 0]],
		           0],
		          0],
		         0]]]]]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$446[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$446[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$441 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$446, [0, schematic_cache$441]);
		               caml_callback
		                (schema_versioned$267,
		                 [function(param, cont){return cont(0);}]);
		               function compare$117(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  default: if(2 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   default: return 2;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var letrec_function_context$447 = [];
		               function schema_versioned$268(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$447[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, af2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$447[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$447[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$447[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(af8);},
		                                  0,
		                                  0,
		                                  cst_creation,
		                                  "Creation",
		                                  af7,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(af6) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_update,
		                                   "Update",
		                                   af5,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(af4) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_deletion,
		                                    "Deletion",
		                                    af3,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$447[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$447[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$442 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$447, [0, schematic_cache$442]);
		               caml_callback
		                (schema_versioned$268,
		                 [function(param, cont){return cont(0);}]);
		               function pp$88(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Ai.Automation.Trigger.Event_kind.T.Creation",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Ai.Automation.Trigger.Event_kind.T.Update",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Ai.Automation.Trigger.Event_kind.T.Deletion",
		                            cont);
		                }
		               }
		               function sexp_of_t$51(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$104,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$88, t, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$88 = Make$2([0, compare$117, sexp_of_t$51]),
		                comparator$36 = include$88[16],
		                Event_kinds =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$88, comparator$36, schema_versioned$268]]),
		                all_event_kinds = caml_callback(Event_kinds[75], [all$3]),
		                letrec_function_context$448 = [];
		               function equal$173(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$448[3],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(a){
		                           return a
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$448[1], lhs[3], rhs[3], cont)
		                                   : cont(a);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$448[2], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               var _2$21 = Workspace[15], _1$41 = Event_kinds[16];
		               caml_update_dummy
		                (letrec_function_context$448, [0, _2$21, _1$41, equal$172]);
		               var letrec_function_context$449 = [];
		               function schema_versioned$269(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$449[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, af9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$449[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$449[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$449[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Workspace[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       af$,
		       af_,
		       1,
		       0,
		       6,
		       function(c){
		        var b = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (Event_kinds[70],
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_on_change,
		                       0,
		                       [0, all_event_kinds],
		                       [0, d],
		                       b,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$267,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  workspace_id = a[2][1],
		                                  on_change = a[1],
		                                  kind = param[1];
		                                 return cont([0, kind, on_change, workspace_id]);
		                                },
		                                function(param, cont){
		                                 var
		                                  workspace_id = param[3],
		                                  on_change = param[2],
		                                  kind = param[1];
		                                 return cont([0, kind, [0, on_change, [0, workspace_id, 0]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [1, a], 0, 0], c]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$449[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$449[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$443 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$449, [0, schematic_cache$443]);
		               caml_callback
		                (schema_versioned$269,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$450 = [];
		               function equal$174(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(1);
		                }
		                else if(0 === lhs[0]){
		                 var
		                  lhstimezone = lhs[3],
		                  lhsrecurrence = lhs[2],
		                  lhsdaytime = lhs[1];
		                 if(typeof rhs !== "number" && 0 === rhs[0]){
		                  var
		                   rhstimezone = rhs[3],
		                   rhsrecurrence = rhs[2],
		                   rhsdaytime = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$450[4],
		                           lhsdaytime,
		                           rhsdaytime,
		                           function(b){
		                            function a(a){
		                             return a
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$450[2],
		lhstimezone,
		rhstimezone,
		cont)
		                                     : cont(a);
		                            }
		                            return b
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$450[3],
		                                       lhsrecurrence,
		                                       rhsrecurrence,
		                                       a)
		                                    : a(b);
		                           });
		                 }
		                }
		                else {
		                 var lhswatched = lhs[1];
		                 if(typeof rhs !== "number" && 0 !== rhs[0]){
		                  var
		                   rhswatched = rhs[1],
		                   a =
		                     function(x, y){
		                      if(x){
		                       if(y){
		                        var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                        return caml_trampoline_cps_call3
		                                (letrec_function_context$450[1],
		                                 a$0,
		                                 b,
		                                 function(b){
		                                  return b
		  ? caml_exact_trampoline_call2(a, x$0, y$0)
		  : cont(b);
		                                 });
		                       }
		                      }
		                      else if(! y) return cont(1);
		                      return cont(0);
		                     };
		                  return a(lhswatched, rhswatched);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$450,
		                 [0, equal$173, equal$65, equal$137, equal$23]);
		               var
		                cst_Commit_pattern = "Commit_pattern",
		                cst_Manual = "Manual",
		                cst_Recurrent = "Recurrent",
		                cst_watched = "watched",
		                letrec_function_context$451 = [];
		               function schema_versioned$270(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$451[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aga, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$451[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$451[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$451[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     agc,
		                                     agb,
		                                     1,
		                                     0,
		                                     2,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$269,
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_commit_pattern,
		             cst_Commit_pattern,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var watched = param[1];
		                return cont(watched);
		               },
		               function(watched, cont){return cont([0, watched, 0]);},
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_watched,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, d], 0]],
		                 0,
		                 0],
		                0]],
		              0],
		             a],
		            0],
		         c =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_timezone,
		             0,
		             2,
		             [0, schema_versioned$126()],
		             0,
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$222,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      age,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){
		                         return typeof param === "number" ? cont(agd) : cont(0);
		                        },
		                        0,
		                        0,
		                        cst_manual,
		                        cst_Manual,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){return cont(0);},
		                          function(param, cont){return cont(0);},
		                          0],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){
		                          var f2 = param[3], f1 = param[2], f0 = param[1];
		                          return cont([0, f0, f1, f2]);
		                         },
		                         function(param, cont){
		                          if(typeof param !== "number" && 0 === param[0]){
		                           var f2 = param[3], f1 = param[2], f0 = param[1];
		                           return cont([0, [0, f0, f1, f2]]);
		                          }
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_recurrent,
		                         cst_Recurrent,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var
		                             a = param[2],
		                             timezone = a[2][1],
		                             recurrence = a[1],
		                             daytime = param[1];
		                            return cont([0, daytime, recurrence, timezone]);
		                           },
		                           function(param, cont){
		                            var
		                             timezone = param[3],
		                             recurrence = param[2],
		                             daytime = param[1];
		                            return cont([0, daytime, [0, recurrence, [0, timezone, 0]]]);
		                           },
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_daytime,
		                             0,
		                             2,
		                             [0, schema_versioned$2(schematic_version)],
		                             0,
		                             0],
		                            [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, a], 0, 0], c]]],
		                          0],
		                         0],
		                        b]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$451[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$451[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$444 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$451, [0, schematic_cache$444]);
		               var
		                schema$112 =
		                  caml_callback
		                   (schema_versioned$270,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$452 = [];
		               function equal$175(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$452[3],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          a:
		                          if(c){
		                           var y = rhs[2], x = lhs[2];
		                           if(x){
		                            if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                           }
		                           else if(! y){c = 1; break a;}
		                           c = 0;
		                          }
		                          function d(c){
		                           if(c) var b = rhs[4], a = lhs[4], c = a === b ? 1 : 0;
		                           return c
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$452[1], lhs[5], rhs[5], cont)
		                                   : cont(c);
		                          }
		                          if(! c) return d(c);
		                          var y$0 = rhs[3], x$0 = lhs[3];
		                          function e(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$452[2],
		                                      a,
		                                      b,
		                                      function(a){
		                                       return a ? caml_exact_trampoline_call2(e, x$0, y$0) : d(a);
		                                      });
		                            }
		                           }
		                           else if(! y) return d(1);
		                           return d(0);
		                          }
		                          return e(x$0, y$0);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$452,
		                 [0, equal$174, equal$168, equal$171]);
		               var letrec_function_context$453 = [];
		               function schema_versioned$271(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$453[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$453[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$453[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$453[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     agh,
		                                     agg,
		                                     1,
		                                     0,
		                                     2,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$270,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$163[1],
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_trigger, 0, [0, default$], [0, c], a, 0],
		            0];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 agj,
		                 agi,
		                 1,
		                 0,
		                 5,
		                 function(c){
		                  var
		                   default$ = match$164[1],
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_enabled,
		                       0,
		                       [0, default$],
		                       [0, bool_schema],
		                       [0, [0, c, V$4]],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$263,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 agk,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_steps,
		                                  0,
		                                  2,
		                                  [0, [0, 0, 0, [3, c], 0]],
		                                  0,
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    trigger = c[2][1],
		    enabled = c[1],
		    steps = b[1],
		    name = a[1],
		    id = param[1];
		   return cont([0, id, name, steps, enabled, trigger]);
		  },
		  function(param, cont){
		   var
		    trigger = param[5],
		    enabled = param[4],
		    steps = param[3],
		    name = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0, name, [0, steps, [0, enabled, [0, trigger, 0]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$453[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$453[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$445 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$453, [0, schematic_cache$445]);
		               var
		                schema$113 =
		                  caml_callback
		                   (schema_versioned$271,
		                    [function(param, cont){return cont(0);}]);
		               function make$54(opt, name, steps, enabled$0, trigger$0, param){
		                var
		                 id = opt ? opt[1] : make$53(),
		                 enabled = 1,
		                 trigger = trigger$0 ? trigger$0[1] : 0;
		                return [0, id, name, steps, enabled, trigger];
		               }
		               var
		                schematic_cache$446 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$454 = [];
		               caml_update_dummy
		                (letrec_function_context$454, [0, schematic_cache$446]);
		               var schematic_schema_version$112 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$454[1][1],
		                    schematic_schema_version$112]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$454[1][1],
		                             schematic_schema_version$112,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$454[1][1],
		schematic_schema_version$112,
		schematic_self,
		function(a){
		 letrec_function_context$454[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (Agent[4],
		          dummy,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_name,
		                0,
		                3,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 3, [0, b], 0, 0], 0]];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$105,
		                    dummy,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           agent_id = a[2][1],
		                           name = a[1],
		                           id = param[1];
		                          return cont([0, id, name, agent_id]);
		                         },
		                         function(param, cont){
		                          var agent_id = param[3], name = param[2], id = param[1];
		                          return cont([0, id, [0, name, [0, agent_id, 0]]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$454[1][1],
		                              schematic_schema_version$112,
		                              res,
		                              function(a){
		                               letrec_function_context$454[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function equal$176(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var letrec_function_context$455 = [];
		               function schema_versioned$272(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$455[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agl, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$455[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$455[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$455[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                ags,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(agr);},
		                                  0,
		                                  0,
		                                  cst_one,
		                                  "One",
		                                  [0,
		                                   0,
		                                   agq,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(agp) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   "many",
		                                   "Many",
		                                   [0,
		                                    0,
		                                    ago,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(agn) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_any,
		                                    cst_Any,
		                                    [0,
		                                     0,
		                                     agm,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$455[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$455[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$447 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$455, [0, schematic_cache$447]);
		               caml_callback
		                (schema_versioned$272,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$456 = [];
		               function equal$177(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], d = a === b ? 1 : 0;
		                function c(c){
		                 if(c){
		                  var y = rhs[3], x = lhs[3], x$0 = x, y$0 = y;
		                  for(;;){
		                   if(x$0){
		                    if(y$0){
		                     var
		                      y$1 = y$0[2],
		                      b = y$0[1],
		                      x$1 = x$0[2],
		                      a = x$0[1],
		                      c = a === b ? 1 : 0;
		                     if(c){x$0 = x$1; y$0 = y$1; continue;}
		                     break;
		                    }
		                   }
		                   else if(! y$0){c = 1; break;}
		                   c = 0;
		                   break;
		                  }
		                 }
		                 return c
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$456[1], lhs[4], rhs[4], cont)
		                         : cont(c);
		                }
		                if(! d) return c(d);
		                var y = rhs[2], x = lhs[2];
		                if(x){
		                 if(y){
		                  var b$0 = y[1], a$0 = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$456[2], a$0, b$0, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$456, [0, equal$176, equal$75]);
		               var
		                cst_answer_count = "answer_count",
		                cst_long = "long",
		                cst_short = "short",
		                letrec_function_context$457 = [];
		               function schema_versioned$273(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$457[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agt, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$457[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$457[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$457[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$272,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$165[1],
		                                       a =
		 [0,
		  [0,
		   agu,
		   0,
		   0,
		   0,
		   cst_choices,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		   0,
		   0],
		  [0,
		   [0, 0, 0, 0, 0, cst_answer_count, 0, 2, [0, b], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$140,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$166[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        answer_count = b[2][1],
		                        choices = b[1],
		                        long = a[1],
		                        short = param[1];
		                       return cont([0, short, long, choices, answer_count]);
		                      },
		                      function(param, cont){
		                       var
		                        answer_count = param[4],
		                        choices = param[3],
		                        long = param[2],
		                        short = param[1];
		                       return cont
		                               ([0, short, [0, long, [0, choices, [0, answer_count, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        agw,
		                        0,
		                        0,
		                        0,
		                        cst_short,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, agv, 0, 0, 0, cst_long, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$457[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$457[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$448 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$457, [0, schematic_cache$448]);
		               var
		                schema$114 =
		                  caml_callback
		                   (schema_versioned$273,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$458 = [];
		               function equal$178(lhs, rhs, cont){
		                var rhsquestions = rhs[1], lhsquestions = lhs[1];
		                function a(x, y){
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$458[1],
		                            a$0,
		                            b,
		                            function(b){
		                             return b
		                                     ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                     : cont(b);
		                            });
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                }
		                return a(lhsquestions, rhsquestions);
		               }
		               caml_update_dummy(letrec_function_context$458, [0, equal$177]);
		               var
		                cst_Questions = "Questions",
		                cst_questions = "questions",
		                letrec_function_context$459 = [];
		               function schema_versioned$274(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$459[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agx, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$459[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$459[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$459[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$273,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  agy,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_questions,
		    cst_Questions,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var questions = param[1];
		       return cont(questions);
		      },
		      function(questions, cont){return cont([0, questions, 0]);},
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_questions,
		        0,
		        2,
		        [0, [0, 0, 0, [3, a], 0]],
		        0,
		        0],
		       0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$459[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$459[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$449 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$459, [0, schematic_cache$449]);
		               caml_callback
		                (schema_versioned$274,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$460 = [];
		               function equal$179(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$460[1],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(! c) return cont(c);
		                          var y = rhs[2], x = lhs[2], x$0 = x, y$0 = y;
		                          for(;;){
		                           if(x$0){
		                            if(y$0){
		                             var
		                              y$1 = y$0[2],
		                              b = y$0[1],
		                              x$1 = x$0[2],
		                              a = x$0[1],
		                              c = a === b ? 1 : 0;
		                             if(! c) return cont(c);
		                             x$0 = x$1;
		                             y$0 = y$1;
		                             continue;
		                            }
		                           }
		                           else if(! y$0) return cont(1);
		                           return cont(0);
		                          }
		                         });
		               }
		               caml_update_dummy(letrec_function_context$460, [0, equal$177]);
		               var cst_answers = "answers", letrec_function_context$461 = [];
		               function schema_versioned$275(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$461[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agz, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$461[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$461[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$461[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 agA,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_answers,
		                                 0,
		                                 2,
		                                 [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$273,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var answers = param[2][1], question = param[1];
		   return cont([0, question, answers]);
		  },
		  function(param, cont){
		   var answers = param[2], question = param[1];
		   return cont([0, question, [0, answers, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_question, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$461[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$461[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$450 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$461, [0, schematic_cache$450]);
		               caml_callback
		                (schema_versioned$275,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$462 = [];
		               function equal$180(lhs, rhs, cont){
		                var
		                 rhsanswered_questions = rhs[1],
		                 lhsanswered_questions = lhs[1];
		                function a(x, y){
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$462[1],
		                            a$0,
		                            b,
		                            function(b){
		                             return b
		                                     ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                     : cont(b);
		                            });
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                }
		                return a(lhsanswered_questions, rhsanswered_questions);
		               }
		               caml_update_dummy(letrec_function_context$462, [0, equal$179]);
		               var letrec_function_context$463 = [];
		               function schema_versioned$276(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$463[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$463[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$463[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$463[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$275,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  agC,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_answers,
		    "Answers",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var answered_questions = param[1];
		       return cont(answered_questions);
		      },
		      function(answered_questions, cont){
		       return cont([0, answered_questions, 0]);
		      },
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "answered_questions",
		        0,
		        2,
		        [0, [0, 0, 0, [3, a], 0]],
		        0,
		        0],
		       0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$463[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$463[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$451 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$463, [0, schematic_cache$451]);
		               caml_callback
		                (schema_versioned$276,
		                 [function(param, cont){return cont(0);}]);
		               function of_answers(param, answers, cont){
		                var questions = param[1];
		                function f$0(a, b, cont){return cont([0, a, b]);}
		                function f(a){
		                 return function(b, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (map2_ok, a, b, f$0, cont);};
		                }
		                function a(match){
		                 if(! match) return cont(0);
		                 var pairs = match[1];
		                 return caml_trampoline_cps_call3
		                         (map$18,
		                          pairs,
		                          function(param, cont){
		                           var answers = param[2], question = param[1];
		                           return cont([0, question, answers]);
		                          },
		                          function(a){return cont([0, [0, a]]);});
		                }
		                return 0 === of_lists(questions, answers)[0]
		                        ? caml_exact_trampoline_cps_call
		                          (f(questions), answers, function(b){return a([0, b]);})
		                        : a(0);
		               }
		               var letrec_function_context$464 = [];
		               function equal$181(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$464[3], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhsconversation = lhs[2], lhsresponse = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhsconversation = rhs[2], rhsresponse = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$464[2],
		                           lhsresponse,
		                           rhsresponse,
		                           function(c){
		                            if(! c) return cont(c);
		                            if(lhsconversation){
		                             if(rhsconversation){
		                              var b = rhsconversation[1], a = lhsconversation[1];
		                              return caml_trampoline_cps_call3
		                                      (letrec_function_context$464[1], a, b, cont);
		                             }
		                            }
		                            else if(! rhsconversation) return cont(1);
		                            return cont(0);
		                           });
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$464,
		                 [0, equal$164, equal$180, equal$153]);
		               var
		                cst_Ask_user = "Ask_user",
		                cst_Call = "Call",
		                cst_response = "response",
		                letrec_function_context$465 = [];
		               function schema_versioned$277(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$465[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$465[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$465[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$465[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     agF,
		                                     agE,
		                                     1,
		                                     1,
		                                     3,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$259,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$167[1],
		                   b =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_conversation,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$276,
		                           schematic_version,
		                           function(d){
		                            var
		                             default$ = match$168[1],
		                             c =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([1, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(0 === param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_ask_user,
		                                 cst_Ask_user,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var conversation = param[2][1], response = param[1];
		                                    return cont([0, response, conversation]);
		                                   },
		                                   function(param, cont){
		                                    var conversation = param[2], response = param[1];
		                                    return cont([0, response, [0, conversation, 0]]);
		                                   },
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_response,
		                                     0,
		                                     [0, default$],
		                                     [0, d],
		                                     0,
		                                     0],
		                                    b]],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$248,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  agG,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_call,
		    cst_Call,
		    a,
		    0],
		   c],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$465[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$465[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$452 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$465, [0, schematic_cache$452]);
		               caml_callback
		                (schema_versioned$277,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$466 = [];
		               function t_without_union_key_schema_ver$0
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$466[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agH, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$466[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$466[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$466[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$259,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_conversation, 0, 3, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$276,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([1, f0, f1]);
		             },
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_ask_user,
		             cst_Ask_user,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var conversation = param[2][1], response = param[1];
		                return cont([0, response, conversation]);
		               },
		               function(param, cont){
		                var conversation = param[2], response = param[1];
		                return cont([0, response, [0, conversation, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_response, 0, 2, [0, c], 0, 0], a]],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$248,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_call,
		                        cst_Call,
		                        a,
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$466[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$466[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$453 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$466, [0, schematic_cache$453]);
		               caml_callback
		                (t_without_union_key_schema_ver$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$467 = [];
		               function with_optional_union_key_schema$1
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$467[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agI, 0, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$467[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$467[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$467[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (t_without_union_key_schema_ver$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_without_union_key,
		   cst_Without_union_key,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$277,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_with_union_key,
		              cst_With_union_key,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$467[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$467[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$454 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$467, [0, schematic_cache$454]);
		               caml_callback
		                (with_optional_union_key_schema$1,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$278(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (with_optional_union_key_schema$1,
		                         v,
		                         function(a){
		                          var
		                           schema =
		                             map$14
		                              (function(param, cont){
		                                var x = param[1];
		                                return caml_trampoline_cps_call2(of_string$14, x, cont);
		                               },
		                               function(x, cont){return cont([0, x]);},
		                               a);
		                          return cont([0, agJ, schema[2], schema[3], schema[4]]);
		                         });
		               }
		               caml_callback
		                (schema_versioned$278,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$468 = [];
		               function equal$182(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$468[4],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(c){
		                           if(c) var b = rhs[3], a = lhs[3], c = a === b ? 1 : 0;
		                           function d(b){
		                            if(! b) return cont(b);
		                            var y = rhs[5], x = lhs[5];
		                            function a(x, y){
		                             if(x){
		                              if(y){
		                               var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                               return caml_trampoline_cps_call3
		                                       (letrec_function_context$468[1],
		a$0,
		b,
		function(b){
		 return b
		         ? caml_exact_trampoline_call2(a, x$0, y$0)
		         : cont(b);
		});
		                              }
		                             }
		                             else if(! y) return cont(1);
		                             return cont(0);
		                            }
		                            return a(x, y);
		                           }
		                           return c
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$468[2], lhs[4], rhs[4], d)
		                                   : d(c);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$468[3], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$468,
		                 [0, equal$181, equal$178, equal$46, equal$168]);
		               var cst_step_id = "step_id", letrec_function_context$469 = [];
		               function schema_versioned$279(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$469[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$469[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$469[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$469[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$278,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$169[1],
		                                       a =
		 [0,
		  [0,
		   agL,
		   0,
		   0,
		   0,
		   cst_tool_calls,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$274,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             agN,
		             0,
		             0,
		             0,
		             cst_call_id,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0, [0, agM, 0, 0, 0, cst_request, 0, 2, [0, c], 0, 0], a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$71,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, "response_id", 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$263,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  tool_calls = c[2][1],
		                                  request = c[1],
		                                  call_id = b[1],
		                                  response_id = a[1],
		                                  step_id = param[1];
		                                 return cont
		 ([0, step_id, response_id, call_id, request, tool_calls]);
		                                },
		                                function(param, cont){
		                                 var
		                                  tool_calls = param[5],
		                                  request = param[4],
		                                  call_id = param[3],
		                                  response_id = param[2],
		                                  step_id = param[1];
		                                 return cont
		 ([0,
		   step_id,
		   [0,
		    response_id,
		    [0, call_id, [0, request, [0, tool_calls, 0]]]]]);
		                                },
		                                [0, [0, agO, 0, 0, 0, cst_step_id, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$469[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$469[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$455 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$469, [0, schematic_cache$455]);
		               caml_callback
		                (schema_versioned$279,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$470 = [];
		               function equal$183(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(1);
		                }
		                else
		                 switch(lhs[0]){
		                   case 0:
		                    if(typeof rhs !== "number" && 0 === rhs[0]){
		                     var rhsmessage = rhs[1], lhsmessage = lhs[1];
		                     return cont(lhsmessage === rhsmessage ? 1 : 0);
		                    }
		                    break;
		                   case 1:
		                    if(typeof rhs !== "number" && 1 === rhs[0]){
		                     var
		                      rhsconversation = rhs[2],
		                      rhsbreakpoint = rhs[1],
		                      lhsconversation = lhs[2],
		                      lhsbreakpoint = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$470[5],
		                              lhsbreakpoint,
		                              rhsbreakpoint,
		                              function(c){
		                               if(! c) return cont(c);
		                               if(lhsconversation){
		                                if(rhsconversation){
		                                 var b = rhsconversation[1], a = lhsconversation[1];
		                                 return caml_trampoline_cps_call3
		 (letrec_function_context$470[4], a, b, cont);
		                                }
		                               }
		                               else if(! rhsconversation) return cont(1);
		                               return cont(0);
		                              });
		                    }
		                    break;
		                   default:
		                    if(typeof rhs !== "number" && 2 === rhs[0]){
		                     var
		                      rhsconversation$0 = rhs[3],
		                      rhsresponse = rhs[2],
		                      rhsbreakpoint$0 = rhs[1],
		                      lhsconversation$0 = lhs[3],
		                      lhsresponse = lhs[2],
		                      lhsbreakpoint$0 = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$470[3],
		                              lhsbreakpoint$0,
		                              rhsbreakpoint$0,
		                              function(b){
		                               function a(c){
		                                if(! c) return cont(c);
		                                if(lhsconversation$0){
		                                 if(rhsconversation$0){
		                                  var b = rhsconversation$0[1], a = lhsconversation$0[1];
		                                  return caml_trampoline_cps_call3
		  (letrec_function_context$470[1], a, b, cont);
		                                 }
		                                }
		                                else if(! rhsconversation$0) return cont(1);
		                                return cont(0);
		                               }
		                               return b
		                                       ? caml_trampoline_cps_call3
		 (letrec_function_context$470[2],
		  lhsresponse,
		  rhsresponse,
		  a)
		                                       : a(b);
		                              });
		                    }
		                 }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$470,
		                 [0, equal$164, equal$180, equal$182, equal$164, equal$182]);
		               var
		                cst_Failed = "Failed",
		                cst_pending_resume = "pending_resume",
		                cst_pending_user_input = "pending_user_input",
		                letrec_function_context$471 = [];
		               function schema_versioned$280(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$471[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$471[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$471[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$471[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     agR,
		                                     agQ,
		                                     1,
		                                     1,
		                                     3,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$259,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$170[1],
		                   b =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_conversation,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$276,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0, [0, agS, 0, 0, 0, cst_response, 0, 2, [0, d], 0, 0], b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$279,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       cst_breakpoint = "breakpoint",
		                                       b =
		 [0,
		  [0,
		   function(param, cont){
		    var f2 = param[3], f1 = param[2], f0 = param[1];
		    return cont([2, f0, f1, f2]);
		   },
		   function(param, cont){
		    if(typeof param !== "number" && 2 === param[0]){
		     var f2 = param[3], f1 = param[2], f0 = param[1];
		     return cont([0, [0, f0, f1, f2]]);
		    }
		    return cont(0);
		   },
		   1,
		   0,
		   cst_pending_resume,
		   "Pending_resume",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       conversation = a[2][1],
		       response = a[1],
		       breakpoint = param[1];
		      return cont([0, breakpoint, response, conversation]);
		     },
		     function(param, cont){
		      var
		       conversation = param[3],
		       response = param[2],
		       breakpoint = param[1];
		      return cont
		              ([0, breakpoint, [0, response, [0, conversation, 0]]]);
		     },
		     [0, [0, 0, 0, 0, 0, cst_breakpoint, 0, 2, [1, d], 0, 0], c]],
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       agU,
		       agT,
		       1,
		       1,
		       3,
		       function(c){
		        var a = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$259,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0, agV, 0, 0, 0, cst_conversation, 0, 3, [0, d], 0, 0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$279,
		                           schematic_version,
		                           function(d){
		                            var
		                             res =
		                               [11,
		                                agX,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   return typeof param === "number" ? cont(agW) : cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_completed,
		                                  cst_Completed,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_failed,
		                                   cst_Failed,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var message = param[1];
		                                      return cont(message);
		                                     },
		                                     function(message, cont){return cont([0, message, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_message,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([1, f0, f1]);
		                                    },
		                                    function(param, cont){
		                                     if(typeof param !== "number" && 1 === param[0]){
		                                      var f1 = param[2], f0 = param[1];
		                                      return cont([0, [0, f0, f1]]);
		                                     }
		                                     return cont(0);
		                                    },
		                                    1,
		                                    0,
		                                    cst_pending_user_input,
		                                    "Pending_user_input",
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var conversation = param[2][1], breakpoint = param[1];
		                                       return cont([0, breakpoint, conversation]);
		                                      },
		                                      function(param, cont){
		                                       var conversation = param[2], breakpoint = param[1];
		                                       return cont([0, breakpoint, [0, conversation, 0]]);
		                                      },
		                                      [0, [0, 0, 0, 0, 0, cst_breakpoint, 0, 2, [1, d], 0, 0], c]],
		                                     0],
		                                    a],
		                                   b]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$471[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$471[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$456 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$471, [0, schematic_cache$456]);
		               var
		                schema$115 =
		                  caml_callback
		                   (schema_versioned$280,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$472 = [];
		               function equal$184(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(! c) return cont(c);
		                var y = rhs[3], x = lhs[3];
		                function d(x, y){
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$472[1],
		                            a,
		                            b,
		                            function(a){
		                             return a
		                                     ? caml_exact_trampoline_call2(d, x$0, y$0)
		                                     : cont(a);
		                            });
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                }
		                return d(x, y);
		               }
		               caml_update_dummy(letrec_function_context$472, [0, equal$181]);
		               var letrec_function_context$473 = [];
		               function schema_versioned$281(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$473[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, agY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$473[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$473[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$473[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     ag0,
		                                     agZ,
		                                     1,
		                                     0,
		                                     5,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$278,
		       schematic_version,
		       function(b){
		        var
		         default$ = match$171[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              tool_calls = a[2][1],
		              output = a[1],
		              name = param[1];
		             return cont([0, name, output, tool_calls]);
		            },
		            function(param, cont){
		             var
		              tool_calls = param[3],
		              output = param[2],
		              name = param[1];
		             return cont([0, name, [0, output, [0, tool_calls, 0]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_name,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_output,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_tool_calls,
		                0,
		                [0, default$],
		                [0, [0, 0, 0, [3, b], 0]],
		                a,
		                0],
		               0]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$473[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$473[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$457 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$473, [0, schematic_cache$457]);
		               caml_callback
		                (schema_versioned$281,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$474 = [];
		               function equal$185(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$474[8],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          a:
		                          if(c){
		                           var y = rhs[2], x = lhs[2];
		                           if(x){
		                            if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                           }
		                           else if(! y){c = 1; break a;}
		                           c = 0;
		                          }
		                          function d(d){
		                           function c(d){
		                            function c(b){
		                             function a(b){
		                              function a(c){
		                               function a(a){
		                                return a
		? caml_trampoline_cps_call3
		  (letrec_function_context$474[1], lhs[9], rhs[9], cont)
		: cont(a);
		                               }
		                               if(! c) return a(c);
		                               var y = rhs[8], x = lhs[8];
		                               function b(x, y){
		                                if(x){
		                                 if(y){
		                                  var y$0 = y[2], b$0 = y[1], x$0 = x[2], a$0 = x[1];
		                                  return caml_trampoline_cps_call3
		  (letrec_function_context$474[2],
		   a$0,
		   b$0,
		   function(c){
		    return c ? caml_exact_trampoline_call2(b, x$0, y$0) : a(c);
		   });
		                                 }
		                                }
		                                else if(! y) return a(1);
		                                return a(0);
		                               }
		                               return b(x, y);
		                              }
		                              return b
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$474[3], lhs[7], rhs[7], a)
		                                      : a(b);
		                             }
		                             return b
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$474[4], lhs[6], rhs[6], a)
		                                     : a(b);
		                            }
		                            if(! d) return c(d);
		                            var y = rhs[5], x = lhs[5];
		                            if(x){
		                             if(y){
		                              var b = y[1], a = x[1];
		                              return caml_trampoline_cps_call3
		                                      (letrec_function_context$474[5], a, b, c);
		                             }
		                            }
		                            else if(! y) return c(1);
		                            return c(0);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[4], x = lhs[4];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$474[6], a, b, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          return c
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$474[7], lhs[3], rhs[3], d)
		                                  : d(c);
		                         });
		               }
		               var _1$42 = Automation_run[15];
		               caml_update_dummy
		                (letrec_function_context$474,
		                 [0,
		                  equal$174,
		                  equal$184,
		                  equal$183,
		                  equal$20,
		                  equal$15,
		                  equal$69,
		                  _1$42,
		                  equal$171]);
		               var letrec_function_context$475 = [];
		               function schema_versioned$282(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$475[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ag1, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$475[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$475[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$475[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$270,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$281,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_step_results,
		             0,
		             2,
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$280,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$4,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_started_at, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     no_input_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$172[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_object_context,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$131,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_object_id$0, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Automation_run[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_automation_name,
		                       0,
		                       3,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$266,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  trigger = g[2][1],
		                                  step_results = g[1],
		                                  status = f[1],
		                                  started_at = e[1],
		                                  object_context = d[1],
		                                  object_id = c[1],
		                                  id = b[1],
		                                  automation_name = a[1],
		                                  automation_id = param[1];
		                                 return cont
		 ([0,
		   automation_id,
		   automation_name,
		   id,
		   object_id,
		   object_context,
		   started_at,
		   status,
		   step_results,
		   trigger]);
		                                },
		                                function(param, cont){
		                                 var
		                                  trigger = param[9],
		                                  step_results = param[8],
		                                  status = param[7],
		                                  started_at = param[6],
		                                  object_context = param[5],
		                                  object_id = param[4],
		                                  id = param[3],
		                                  automation_name = param[2],
		                                  automation_id = param[1];
		                                 return cont
		 ([0,
		   automation_id,
		   [0,
		    automation_name,
		    [0,
		     id,
		     [0,
		      object_id,
		      [0,
		       object_context,
		       [0,
		        started_at,
		        [0, status, [0, step_results, [0, trigger, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, b], 0, 0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$475[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$475[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$458 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$475, [0, schematic_cache$458]);
		               var
		                schema$116 =
		                  caml_callback
		                   (schema_versioned$282,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$476 = [];
		               function schema_versioned$283(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$476[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ag2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$476[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$476[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$476[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$261,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (By$13[102],
		       schematic_version,
		       a,
		       function(b){
		        var
		         a =
		           [0,
		            [0, 0, 0, 0, 0, cst_conversations, 0, 2, [0, b], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$265,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (By$14[102],
		                           schematic_version,
		                           b,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_steps, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$271,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (By$15[102],
		       schematic_version,
		       a,
		       function(c){
		        var
		         a =
		           [0, [0, 0, 0, 0, 0, cst_automations, 0, 2, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 ag4,
		                 ag3,
		                 1,
		                 0,
		                 5,
		                 function(c){
		                  var b = [0, [0, c, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$282,
		                           schematic_version,
		                           function(c){
		                            return caml_trampoline_cps_call3
		                                    (Automation_run[27][102],
		                                     schematic_version,
		                                     c,
		                                     function(d){
		                                      var
		                                       default$ = Automation_run[27][104],
		                                       c =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_automation_runs,
		   0,
		   [0, default$],
		   [0, d],
		   b,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       ag6,
		       ag5,
		       1,
		       0,
		       2,
		       function(b){
		        var a = [0, [0, b, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$262,
		                 schematic_version,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(d){
		                            var
		                             default$ = match$173[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assistant,
		                                 0,
		                                 [0, default$],
		                                 [0, d],
		                                 a,
		                                 0],
		                                c];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$262,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (Agent[27][102],
		       schematic_version,
		       a,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              conversations = d[2][1],
		              steps = d[1],
		              automations = c[1],
		              automation_runs = b[1],
		              assistant = a[1],
		              agents = param[1];
		             return cont
		                     ([0,
		                       agents,
		                       assistant,
		                       automation_runs,
		                       automations,
		                       steps,
		                       conversations]);
		            },
		            function(param, cont){
		             var
		              conversations = param[6],
		              steps = param[5],
		              automations = param[4],
		              automation_runs = param[3],
		              assistant = param[2],
		              agents = param[1];
		             return cont
		                     ([0,
		                       agents,
		                       [0,
		                        assistant,
		                        [0,
		                         automation_runs,
		                         [0, automations, [0, steps, [0, conversations, 0]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_agents, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$476[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$476[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$459 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$476, [0, schematic_cache$459]);
		               caml_callback
		                (schema_versioned$283,
		                 [function(param, cont){return cont(0);}]);
		               function compare$118(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(0);
		                }
		                else if(! rhs) return cont(0);
		                function to_int(param){return param ? 1 : 0;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var cst_Google = "Google", letrec_function_context$477 = [];
		               function schema_versioned$284(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$477[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ag7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$477[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$477[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$477[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(ag$);},
		                                  0,
		                                  0,
		                                  cst_email,
		                                  cst_Email,
		                                  ag_,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(ag9) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_google,
		                                   cst_Google,
		                                   ag8,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$477[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$477[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$460 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$477, [0, schematic_cache$460]);
		               caml_callback
		                (schema_versioned$284,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$478 = [];
		               function equal$186(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$478[1], lhs[1], rhs[1], cont);
		               }
		               caml_update_dummy(letrec_function_context$478, [0, equal$112]);
		               var letrec_function_context$479 = [];
		               function schema_versioned$285(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$479[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aha, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$479[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$479[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$479[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var email = param[1];
		                                 return cont([0, email]);
		                                },
		                                function(param, cont){
		                                 var email = param[1];
		                                 return cont([0, email, 0]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_email, 0, 2, [0, schema$72], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$479[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$479[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$461 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$479, [0, schematic_cache$461]);
		               caml_callback
		                (schema_versioned$285,
		                 [function(param, cont){return cont(0);}]);
		               function equal$187(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               var letrec_function_context$480 = [];
		               function schema_versioned$286(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$480[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ahb, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$480[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$480[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$480[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(ahf);},
		                                  0,
		                                  0,
		                                  cst_account_missing,
		                                  "Account_missing",
		                                  [0, aJ[1], ahe, aJ[3], aJ[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(ahd) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_token_revoked,
		                                   "Token_revoked",
		                                   [0, aI[1], ahc, aI[3], aI[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$480[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$480[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$462 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$480, [0, schematic_cache$462]);
		               caml_callback
		                (schema_versioned$286,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$481 = [];
		               function equal$188(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(d){
		                 function c(d){
		                  function c(b){
		                   function a(a){
		                    return a
		                            ? caml_trampoline_cps_call3
		                              (letrec_function_context$481[1], lhs[5], rhs[5], cont)
		                            : cont(a);
		                   }
		                   return b
		                           ? caml_trampoline_cps_call3
		                             (letrec_function_context$481[2], lhs[4], rhs[4], a)
		                           : a(b);
		                  }
		                  if(! d) return c(d);
		                  var y = rhs[3], x = lhs[3];
		                  if(x){
		                   if(y){
		                    var b = y[1], a = x[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$481[3], a, b, c);
		                   }
		                  }
		                  else if(! y) return c(1);
		                  return c(0);
		                 }
		                 if(! d) return c(d);
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b = y[1], a = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$481[4], a, b, c);
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$481[5], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$481,
		                 [0, equal$43, equal$42, equal$187, equal$109, equal$109]);
		               var letrec_function_context$482 = [];
		               function schema_versioned$287(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$482[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ahg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$482[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$482[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$482[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$53,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_userinfo, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$50,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_tokeninfo, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$286,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_error, 0, 3, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           ahi,
		                           ahh,
		                           0,
		                           25,
		                           7,
		                           function(c){
		                            var b = [0, [0, c, V$4]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$189,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0, 0, 0, 0, 0, cst_contacts_state$0, 0, 3, [0, d], b, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       ahk,
		       ahj,
		       0,
		       25,
		       4,
		       function(b){
		        var a = [0, [0, b, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$189,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        userinfo = c[2][1],
		                        tokeninfo = c[1],
		                        error = b[1],
		                        contacts_state = a[1],
		                        calendars_state = param[1];
		                       return cont
		                               ([0,
		                                 calendars_state,
		                                 contacts_state,
		                                 error,
		                                 tokeninfo,
		                                 userinfo]);
		                      },
		                      function(param, cont){
		                       var
		                        userinfo = param[5],
		                        tokeninfo = param[4],
		                        error = param[3],
		                        contacts_state = param[2],
		                        calendars_state = param[1];
		                       return cont
		                               ([0,
		                                 calendars_state,
		                                 [0,
		                                  contacts_state,
		                                  [0, error, [0, tokeninfo, [0, userinfo, 0]]]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_calendars_state$0, 0, 3, [0, b], a, 0],
		                       c]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$482[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$482[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$463 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$482, [0, schematic_cache$463]);
		               caml_callback
		                (schema_versioned$287,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$483 = [];
		               function equal$189(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$483[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$483[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$483, [0, equal$188, equal$186]);
		               var letrec_function_context$484 = [];
		               function schema_versioned$288(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$484[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ahl, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$484[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$484[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$484[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$287,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_google,
		   cst_Google,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       ahn,
		       ahm,
		       0,
		       25,
		       6,
		       function(c){
		        var b = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$285,
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [11,
		                      aho,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_email,
		                        cst_Email,
		                        c,
		                        b],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$484[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$484[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$464 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$484, [0, schematic_cache$464]);
		               var
		                schema$117 =
		                  caml_callback
		                   (schema_versioned$288,
		                    [function(param, cont){return cont(0);}]);
		               function pp$89(ppf, v, cont){
		                var a = v ? cst_google : cst_email;
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, ppf, a, cont);
		               }
		               var letrec_function_context$485 = [];
		               function compare$119(a, param, cont){
		                var
		                 rhs1 = param[2],
		                 rhs0 = param[1],
		                 lhs1 = a[2],
		                 lhs0 = a[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$485[2],
		                         lhs0,
		                         rhs0,
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call2
		                                    (letrec_function_context$485[1],
		                                     0,
		                                     function(a){
		                                      return caml_trampoline_cps_call3(a, lhs1, rhs1, cont);
		                                     })
		                                  : cont(x);
		                         });
		               }
		               function _1$43(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$485, [0, _1$43, compare$118]);
		               var letrec_function_context$486 = [];
		               function schema_versioned$289(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$486[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ahp, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$486[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$486[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$486[1][1] = b;
		                            var a = [0, schematic_param_name_schema_ve, 0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$284,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [10,
		  function(param, cont){
		   var e1 = param[2][1], e0 = param[1];
		   return cont([0, e0, e1]);
		  },
		  function(param, cont){
		   var e1 = param[2], e0 = param[1];
		   return cont([0, e0, [0, e1, 0]]);
		  },
		  [0, b, a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$486[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$486[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$465 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$486, [0, schematic_cache$465]);
		               var
		                schema$118 =
		                  caml_callback
		                   (schema_versioned$289,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$487 = [];
		               function pp$90(fmt, param, cont){
		                var a1 = param[2], a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         ahq,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$487[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               ahr,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         ahs,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   a1,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), aht, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$487, [0, pp$89]);
		               function to_string$56(param, cont){
		                var id$0 = param[2], provider = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$105,
		                         function(a){
		                          return caml_trampoline_cps_call5
		                                  (a, cst_connection, pp$89, provider, id$0, cont);
		                         });
		               }
		               function sexp_of_t$52(id, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$56, id, function(a){return cont([0, a]);});
		               }
		               function pp$91(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, to_string$56, a, b, cont);
		               }
		               var
		                Comparable$0 = Make$2([0, compare$119, sexp_of_t$52]),
		                symbol$187 = Comparable$0[1],
		                symbol$188 = Comparable$0[2],
		                symbol$189 = Comparable$0[3],
		                symbol$190 = Comparable$0[4],
		                symbol$191 = Comparable$0[5],
		                symbol$192 = Comparable$0[6],
		                equal$190 = Comparable$0[7],
		                compare$120 = Comparable$0[8],
		                min$27 = Comparable$0[9],
		                max$29 = Comparable$0[10],
		                ascending$18 = Comparable$0[11],
		                descending$18 = Comparable$0[12],
		                between$19 = Comparable$0[13],
		                clamp_exn$18 = Comparable$0[14],
		                clamp$18 = Comparable$0[15],
		                comparator$37 = Comparable$0[16],
		                comparator$38 = Comparable$0[16],
		                By$16 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$90, comparator$38, schema_versioned$289]]),
		                comparator$39 = Comparable$0[16];
		               caml_callback
		                (M_printable$0,
		                 [[0, pp$90, comparator$39, schema_versioned$289]]);
		               function of_google_email(email){
		                return [0, 1, to_string$43(email)];
		               }
		               function pp$92(fmt, os, cont){
		                if(typeof os === "number")
		                 return os
		                         ? caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_x64, cont)
		                         : caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_arm64, cont);
		                var s = os[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, s, cont);
		               }
		               function to_string$57(arch, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_to_string, pp$92, arch, cont);
		               }
		               function of_string$45(arch, cont){
		                return arch !== cst_arm64
		                        ? arch
		                          !== cst_x64
		                          ? caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             fail,
		                             format$20,
		                             function(a){
		                              return caml_trampoline_cps_call2(a, arch, cont);
		                             })
		                          : cont(ahy)
		                        : cont(ahz);
		               }
		               var cst_Arm64 = "Arm64", cst_X64 = "X64";
		               function schema_versioned$290(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          function descriptor(schematic_param_a_schema_versi){
		                           return [11,
		                                   0,
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && ! param) return cont(ahx);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_arm64,
		                                     cst_Arm64,
		                                     ahw,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(1);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && param) return cont(ahv);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_x64,
		                                      cst_X64,
		                                      ahu,
		                                      0],
		                                     0]],
		                                   0];
		                          }
		                          var
		                           schematic_schema_id = match$174[1],
		                           schematic_parametric =
		                             [0,
		                              [1,
		                               cst_a$0,
		                               schematic_param_a_schema_versi,
		                               function(schematic_param_a_schema_versi, cont){
		                                return cont([0, schematic_schema_id, descriptor()]);
		                               }]],
		                           a = descriptor(),
		                           parametric = schematic_parametric[1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_parametric,
		                                   parametric,
		                                   function(match){
		                                    function b(b){
		                                     return cont([0, b, 0, a, schematic_parametric]);
		                                    }
		                                    if(! match) return b(0);
		                                    var name = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (to_id, name, function(a){return b([0, a]);});
		                                   });
		                         });
		               }
		               var bRj = By$16[109];
		               caml_callback
		                (schema_versioned$290,
		                 [function(param, cont){return cont();}]);
		               var letrec_function_context$488 = [];
		               function schema_versioned$291(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$488[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ahA, 0, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$488[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$488[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$488[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(ahE);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_arm64,
		                                  cst_Arm64,
		                                  ahD,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && param) return cont(ahC);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_x64,
		                                   cst_X64,
		                                   ahB,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([0, f0]);},
		                                    function(param, cont){
		                                     if(typeof param === "number") return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    0,
		                                    0,
		                                    cst_unknown,
		                                    cst_Unknown,
		                                    schematic_param_name_schema_ve,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$488[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$488[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$466 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$488, [0, schematic_cache$466]);
		               caml_callback
		                (schema_versioned$291,
		                 [function(param, cont){return cont(0);}]);
		               function any_schema_versioned(version, cont){
		                function decode(param, cont){
		                 if(typeof param === "number")
		                  return param ? cont(ahF) : cont(ahG);
		                 var s = param[1];
		                 return cont([0, [0, s]]);
		                }
		                function encode(param, cont){
		                 if(typeof param === "number")
		                  return param ? cont(1) : cont(0);
		                 var s = param[1];
		                 return cont([0, s]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$291,
		                         version,
		                         function(a){return cont(map$14(decode, encode, a));});
		               }
		               caml_callback
		                (any_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function pp$93(fmt, os, cont){
		                if(typeof os === "number")
		                 switch(os){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, cst_macos, cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, "gnu-linux", cont);
		                   case 2:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, cst_win, cont);
		                   case 3:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, cst_android, cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string, fmt, cst_ios, cont);
		                 }
		                var s = os[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, s, cont);
		               }
		               var
		                cst_Gnu_linux = "Gnu_linux",
		                cst_Macos = "Macos",
		                cst_Windows = "Windows";
		               function desktop_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          function descriptor(schematic_param_a_schema_versi){
		                           return [11,
		                                   0,
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && ! param) return cont(ahM);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_macos,
		                                     cst_Macos,
		                                     ahL,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(1);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && 1 === param)
		return cont(ahK);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_gnu_linux,
		                                      cst_Gnu_linux,
		                                      ahJ,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(2);},
		                                       function(param, cont){
		if(typeof param === "number" && 2 === param)
		 return cont(ahI);
		return cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_win,
		                                       cst_Windows,
		                                       ahH,
		                                       0],
		                                      0]]],
		                                   0];
		                          }
		                          var
		                           schematic_schema_id = match$175[1],
		                           schematic_parametric =
		                             [0,
		                              [1,
		                               cst_a$0,
		                               schematic_param_a_schema_versi,
		                               function(schematic_param_a_schema_versi, cont){
		                                return cont([0, schematic_schema_id, descriptor()]);
		                               }]],
		                           a = descriptor(),
		                           parametric = schematic_parametric[1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_parametric,
		                                   parametric,
		                                   function(match){
		                                    function b(b){
		                                     return cont([0, b, 0, a, schematic_parametric]);
		                                    }
		                                    if(! match) return b(0);
		                                    var name = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (to_id, name, function(a){return b([0, a]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (desktop_schema_versioned,
		                 [function(param, cont){return cont();}]);
		               var cst_Android = "Android", cst_IOs = "IOs";
		               function descriptor$23(schematic_param_a_schema_versi){
		                return [11,
		                        0,
		                        [0,
		                         [0,
		                          function(param, cont){return cont(3);},
		                          function(param, cont){
		                           if(typeof param === "number" && 3 === param)
		                            return cont(ahQ);
		                           return cont(0);
		                          },
		                          0,
		                          0,
		                          cst_android,
		                          cst_Android,
		                          ahP,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(4);},
		                           function(param, cont){
		                            if(typeof param === "number" && 4 <= param)
		                             return cont(ahO);
		                            return cont(0);
		                           },
		                           0,
		                           0,
		                           cst_ios,
		                           cst_IOs,
		                           ahN,
		                           0],
		                          0]],
		                        0];
		               }
		               var
		                schematic_schema_id$0 = match$176[1],
		                parametric$1 =
		                  [1,
		                   cst_a$0,
		                   schematic_param_a_schema_versi,
		                   function(schematic_param_a_schema_versi, cont){
		                    return cont([0, schematic_schema_id$0, descriptor$23()]);
		                   }],
		                h = caml_callback(of_parametric, [parametric$1]);
		               if(h){var name$30 = h[1]; caml_callback(to_id, [name$30]);}
		               var letrec_function_context$489 = [];
		               function schema_versioned$292(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$489[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ahR, 0, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$489[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$489[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$489[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(ah1);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_macos,
		                                  cst_Macos,
		                                  ah0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 1 === param)
		                                     return cont(ahZ);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_gnu_linux,
		                                   cst_Gnu_linux,
		                                   ahY,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 2 === param)
		                                      return cont(ahX);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_win,
		                                    cst_Windows,
		                                    ahW,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 3 === param)
		                                       return cont(ahV);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_android,
		                                     cst_Android,
		                                     ahU,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && 4 <= param)
		return cont(ahT);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_ios,
		                                      cst_IOs,
		                                      ahS,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(f0, cont){return cont([0, f0]);},
		                                       function(param, cont){
		if(typeof param === "number") return cont(0);
		var f0 = param[1];
		return cont([0, f0]);
		                                       },
		                                       0,
		                                       0,
		                                       cst_unknown,
		                                       cst_Unknown,
		                                       schematic_param_name_schema_ve,
		                                       0],
		                                      0]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$489[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$489[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$467 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$489, [0, schematic_cache$467]);
		               caml_callback
		                (schema_versioned$292,
		                 [function(param, cont){return cont(0);}]);
		               function any_schema_versioned$0(version, cont){
		                function decode(param, cont){
		                 if(typeof param === "number")
		                  switch(param){
		                    case 0:
		                     return cont(ah2);
		                    case 1:
		                     return cont(ah3);
		                    case 2:
		                     return cont(ah4);
		                    case 3:
		                     return cont(ah5);
		                    default: return cont(ah6);
		                  }
		                 var s = param[1];
		                 return cont([0, [0, s]]);
		                }
		                function encode(param, cont){
		                 if(typeof param === "number")
		                  switch(param){
		                    case 0:
		                     return cont(0);
		                    case 1:
		                     return cont(1);
		                    case 2:
		                     return cont(2);
		                    case 3:
		                     return cont(3);
		                    default: return cont(4);
		                  }
		                 var s = param[1];
		                 return cont([0, s]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$292,
		                         version,
		                         function(a){return cont(map$14(decode, encode, a));});
		               }
		               var
		                any_schema =
		                  caml_callback
		                   (any_schema_versioned$0,
		                    [function(param, cont){return cont(0);}]),
		                cst_Electron = "Electron",
		                cst_electron = "electron",
		                biR = [];
		               function frontend_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   biR[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ah8, ah7, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                biR[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           biR[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            biR[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                ah$,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_electron,
		                                  cst_Electron,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var version = param[1];
		                                     return cont(version);
		                                    },
		                                    function(version, cont){return cont([0, version, 0]);},
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_version,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([1, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(1 !== param[0]) return cont(0);
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   },
		                                   1,
		                                   0,
		                                   "browser",
		                                   "Browser",
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var version = param[2][1], name = param[1];
		                                      return cont([0, name, version]);
		                                     },
		                                     function(param, cont){
		                                      var version = param[2], name = param[1];
		                                      return cont([0, name, [0, version, 0]]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_name,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_version,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([2, f0]);},
		                                    function(param, cont){
		                                     if(2 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_android,
		                                    cst_Android,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var version = param[1];
		                                       return cont(version);
		                                      },
		                                      function(version, cont){return cont([0, version, 0]);},
		                                      [0,
		                                       [0,
		ah_,
		0,
		0,
		0,
		cst_version,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([3, f0]);},
		                                     function(param, cont){
		                                      if(3 !== param[0]) return cont(0);
		                                      var f0 = param[1];
		                                      return cont([0, f0]);
		                                     },
		                                     1,
		                                     0,
		                                     cst_ios,
		                                     cst_IOs,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var version = param[1];
		return cont(version);
		                                       },
		                                       function(version, cont){return cont([0, version, 0]);},
		                                       [0,
		[0,
		 ah9,
		 0,
		 0,
		 0,
		 cst_version,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		0]],
		                                      0],
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     biR[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){biR[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$490 = [];
		               function os_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$490[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aia, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$490[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$490[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$490[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_version, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (any_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var version = param[2][1], name = param[1];
		             return cont([0, name, version]);
		            },
		            function(param, cont){
		             var version = param[2], name = param[1];
		             return cont([0, name, [0, version, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$490[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$490[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$468 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(biR, [0, schematic_cache$468]);
		               var schematic_cache$469 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$490, [0, schematic_cache$469]);
		               caml_callback
		                (frontend_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (os_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$491 = [];
		               function schema_versioned$293(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$491[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aib, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$491[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$491[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$491[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (frontend_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_frontend, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (any_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_architecture, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (os_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        frontend = a[2][1],
		                        architecture = a[1],
		                        os = param[1];
		                       return cont([0, os, architecture, frontend]);
		                      },
		                      function(param, cont){
		                       var
		                        frontend = param[3],
		                        architecture = param[2],
		                        os = param[1];
		                       return cont([0, os, [0, architecture, [0, frontend, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_os, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$491[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$491[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$470 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$491, [0, schematic_cache$470]);
		               caml_callback
		                (schema_versioned$293,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Api_server = "Api_server",
		                cst_Ios = "Ios",
		                cst_Web = "Web",
		                cst_Website = "Website",
		                letrec_function_context$492 = [];
		               function schema_versioned$294(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$492[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aic, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$492[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$492[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$492[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(1);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && 1 === param)
		                                   return cont(aig);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_ios,
		                                 cst_Ios,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(2);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 2 === param)
		                                    return cont(aif);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_web,
		                                  cst_Web,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(3);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 3 === param)
		                                     return cont(aie);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_routine_co,
		                                   cst_Website,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(4);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 4 <= param)
		                                      return cont(aid);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_api_server,
		                                    cst_Api_server,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$290,
		                                     schematic_version,
		                                     function(c){
		                                      var b = [0, c, 0];
		                                      return caml_exact_trampoline_cps_call
		      (desktop_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         res =
		           [11,
		            aii,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){
		               if(typeof param === "number" && ! param) return cont(aih);
		               return cont(0);
		              },
		              0,
		              0,
		              cst_android,
		              cst_Android,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){return cont(0);},
		                function(param, cont){return cont(0);},
		                0],
		               0],
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([0, f0]);},
		               function(param, cont){
		                if(typeof param === "number") return cont(0);
		                var f0 = param[1];
		                return cont([0, f0]);
		               },
		               0,
		               0,
		               cst_electron,
		               cst_Electron,
		               [0,
		                0,
		                0,
		                [10,
		                 function(param, cont){
		                  var e1 = param[2][1], e0 = param[1];
		                  return cont([0, e0, e1]);
		                 },
		                 function(param, cont){
		                  var e1 = param[2], e0 = param[1];
		                  return cont([0, e0, [0, e1, 0]]);
		                 },
		                 [0, c, b]],
		                0],
		               0],
		              a]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$492[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$492[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$471 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$492, [0, schematic_cache$471]);
		               caml_callback
		                (schema_versioned$294,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$493 = [];
		               function schema_versioned$295(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$493[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aij, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$493[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$493[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$493[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$294,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_distribution, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$293,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var distribution = param[2][1], runtime = param[1];
		             return cont([0, runtime, distribution]);
		            },
		            function(param, cont){
		             var distribution = param[2], runtime = param[1];
		             return cont([0, runtime, [0, distribution, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_runtime, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$493[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$493[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$472 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$493, [0, schematic_cache$472]);
		               caml_callback
		                (schema_versioned$295,
		                 [function(param, cont){return cont(0);}]);
		               function Moded$14(M, cont){
		                var letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      M[12].call(null, cst_device);
		                                      return cont
		      ([0, [0, M[12].call(null, cst_device)], 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      schematic_param_name_schema_ve,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(b){
		         var
		          default$ = M[5].call(null, 0),
		          a =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "push_token",
		              0,
		              [0, default$],
		              [0, b],
		              0,
		              0],
		             0];
		         return caml_exact_trampoline_cps_call
		                 (option_schema,
		                  schematic_param_name_schema_ve,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            b,
		                            function(b){
		                             var
		                              default$ = M[5].call(null, 0),
		                              res =
		                                [7,
		                                 function(param, cont){
		                                  var push_token = param[2][1], name = param[1];
		                                  return cont([0, name, push_token]);
		                                 },
		                                 function(param, cont){
		                                  var push_token = param[2], name = param[1];
		                                  return cont([0, name, [0, push_token, 0]]);
		                                 },
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		                                  a]];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      res,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return cont(res);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          return cont([0, , schema_versioned, schema]);
		                         });
		               }
		               var
		                Read$2 = caml_callback(Moded$14, [R$1]),
		                Patch$0 = caml_callback(Moded$14, [W$1]),
		                letrec_function_context$494 = [];
		               function dist_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$494[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ail, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$494[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$494[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$494[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(1);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && 1 === param)
		                                   return cont(ait);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_ios,
		                                 cst_Ios,
		                                 ais,
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(2);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 2 === param)
		                                    return cont(air);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_web,
		                                  cst_Web,
		                                  aiq,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(3);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 3 === param)
		                                     return cont(aip);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_routine_co,
		                                   cst_Website,
		                                   aio,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(4);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 4 <= param)
		                                      return cont(ain);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_api_server,
		                                    cst_Api_server,
		                                    aim,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$290,
		                                     schematic_version,
		                                     function(c){
		                                      var b = [0, c, 0];
		                                      return caml_exact_trampoline_cps_call
		      (desktop_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){
		               if(typeof param === "number" && ! param) return cont(aiv);
		               return cont(0);
		              },
		              0,
		              0,
		              cst_android,
		              cst_Android,
		              aiu,
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([0, f0]);},
		               function(param, cont){
		                if(typeof param === "number") return cont(0);
		                var f0 = param[1];
		                return cont([0, f0]);
		               },
		               0,
		               0,
		               cst_electron,
		               cst_Electron,
		               [0,
		                0,
		                0,
		                [10,
		                 function(param, cont){
		                  var e1 = param[2][1], e0 = param[1];
		                  return cont([0, e0, e1]);
		                 },
		                 function(param, cont){
		                  var e1 = param[2], e0 = param[1];
		                  return cont([0, e0, [0, e1, 0]]);
		                 },
		                 [0, c, b]],
		                0],
		               0],
		              a]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$494[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$494[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$473 = [0, empty$11([0, comparator$9])],
		                bjZ = [];
		               caml_update_dummy(bjZ, [0, schematic_cache$473]);
		               var schematic_cache$474 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$494, [0, schematic_cache$474]);
		               function schematic_version$65(param, cont){return cont(0);}
		               var
		                schematic_schema_version$111 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [bjZ[1][1], schematic_schema_version$111]);
		               if(h)
		                var schema$119 = h[1], descriptor$24 = schema$119;
		               else
		                descriptor$24 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              bjZ[1][1],
		                              schematic_schema_version$111,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bjZ[1][1],
		 schematic_schema_version$111,
		 schematic_self,
		 function(a){
		  bjZ[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Read$2[2],
		           schematic_version$65,
		           function(b){
		            var
		             a =
		               [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (Device[4],
		                     schematic_version$65,
		                     function(c){
		                      var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                      return caml_exact_trampoline_cps_call
		                              (dist_schema_versioned,
		                               schematic_version$65,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      writable = a[2][1],
		                                      id = a[1],
		                                      distribution = param[1];
		                                     return cont([0, distribution, id, writable]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      writable = param[3],
		                                      id = param[2],
		                                      distribution = param[1];
		                                     return cont([0, distribution, [0, id, [0, writable, 0]]]);
		                                    },
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_distribution, 0, 2, [0, a], 0, 0],
		                                     b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bjZ[1][1],
		 schematic_schema_version$111,
		 res,
		 function(a){bjZ[1][1] = a; return cont(res);});
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$120 = [0, aik, 0, descriptor$24, 0];
		               caml_callback
		                (dist_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function dist_of_string(s, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                return caml_exact_trampoline_cps_call$1
		                        (chop_prefix,
		                         s,
		                         "macos-",
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (chop_prefix,
		                                    s,
		                                    "gnu-linux-",
		                                    function(match){
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call$1
		      (chop_prefix,
		       s,
		       "win-",
		       function(match){
		        if(! match)
		         return s !== cst_android
		                 ? s
		                   !== cst_ios
		                   ? s
		                     !== cst_routine_co
		                     ? s
		                       !== cst_web
		                       ? caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          fail,
		                          format$21,
		                          function(a){return caml_trampoline_cps_call2(a, s, cont);})
		                       : caml_trampoline_cps_call2(of_string$14, 2, cont)
		                     : caml_trampoline_cps_call2(of_string$14, 3, cont)
		                   : caml_trampoline_cps_call2(of_string$14, 1, cont)
		                 : caml_trampoline_cps_call2(of_string$14, 0, cont);
		        var arch = match[1];
		        function a(architecture, cont){
		         return cont([0, [0, 2, architecture]]);
		        }
		        return caml_exact_trampoline_cps_call
		                (of_string$45,
		                 arch,
		                 function(b){
		                  return caml_trampoline_cps_call3(let$, b, a, cont);
		                 });
		       });
		                                     var arch = match[1];
		                                     function a(architecture, cont){
		                                      return cont([0, [0, 1, architecture]]);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (of_string$45,
		      arch,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          var arch = match[1];
		                          function a(architecture, cont){
		                           return cont([0, [0, 0, architecture]]);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$45,
		                                   arch,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               }
		               function dist_to_string(a, cont){
		                if(typeof a === "number")
		                 switch(a){
		                   case 0:
		                    return cont(cst_android);
		                   case 1:
		                    return cont(cst_ios);
		                   case 2:
		                    return cont(cst_web);
		                   case 3:
		                    return cont(cst_routine_co);
		                   default: return cont("server/api");
		                 }
		                a = a[1];
		                var architecture = a[2], os = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$106,
		                         function(a){
		                          return caml_trampoline_cps_call5
		                                  (a, pp$93, os, pp$92, architecture, cont);
		                         });
		               }
		               var
		                schematic_cache$475 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$495 = [];
		               caml_update_dummy
		                (letrec_function_context$495, [0, schematic_cache$475]);
		               var schematic_schema_version$110 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$495[1][1],
		                    schematic_schema_version$110]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$495[1][1],
		                             schematic_schema_version$110,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$495[1][1],
		schematic_schema_version$110,
		schematic_self,
		function(a){
		 letrec_function_context$495[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$4,
		          dummy,
		          function(a){
		           var
		            res =
		              [11,
		               aiw,
		               [0,
		                [0,
		                 function(f0, cont){return cont([0, f0]);},
		                 function(param, cont){
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 1,
		                 0,
		                 "ai_limit_exceeded",
		                 "Ai_limit_exceeded",
		                 [0,
		                  0,
		                  0,
		                  [7,
		                   function(param, cont){
		                    var reset_time = param[1];
		                    return cont(reset_time);
		                   },
		                   function(reset_time, cont){return cont([0, reset_time, 0]);},
		                   [0, [0, 0, 0, 0, 0, "reset_time", 0, 2, [0, a], 0, 0], 0]],
		                  0],
		                 0],
		                0],
		               0];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$495[1][1],
		                    schematic_schema_version$110,
		                    res,
		                    function(a){
		                     letrec_function_context$495[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_Contains = "Contains",
		                letrec_function_context$496 = [];
		               function schema_versioned$296(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$496[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aiy, aix, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$496[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$496[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$496[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(15500);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 15500 === param)
		                                    return cont(aiW);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_eq,
		                                  cst_Eq,
		                                  aiV,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(3901498);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 3901498 === param)
		                                     return cont(aiU);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_neq,
		                                   cst_Neq,
		                                   aiT,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(17064);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 17064 === param)
		                                      return cont(aiS);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_lt,
		                                    cst_Lt,
		                                    aiR,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3805373);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 3805373 === param)
		                                       return cont(aiQ);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_lte,
		                                     cst_Lte,
		                                     aiP,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(15949);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && 15949 === param)
		return cont(aiO);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_gt,
		                                      cst_Gt,
		                                      aiN,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(3556728);},
		                                       function(param, cont){
		if(typeof param === "number" && 3556728 === param)
		 return cont(aiM);
		return cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_gte,
		                                       cst_Gte,
		                                       aiL,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(103618111);},
		function(param, cont){
		 if(typeof param === "number" && 103618111 === param)
		  return cont(aiK);
		 return cont(0);
		},
		0,
		0,
		cst_contains,
		cst_Contains,
		aiJ,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(-23885269);},
		 function(param, cont){
		  if(typeof param === "number" && -23885269 === param)
		   return cont(aiI);
		  return cont(0);
		 },
		 0,
		 0,
		 cst_not_contains,
		 "Not_contains",
		 aiH,
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(613978708);},
		  function(param, cont){
		   if(typeof param === "number" && 613978708 === param)
		    return cont(aiG);
		   return cont(0);
		  },
		  0,
		  0,
		  cst_starts_with,
		  "Starts_with",
		  aiF,
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(259676648);},
		   function(param, cont){
		    if(typeof param === "number" && 259676648 === param)
		     return cont(aiE);
		    return cont(0);
		   },
		   0,
		   0,
		   cst_not_starts_with,
		   "Not_starts_with",
		   aiD,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(708102797);},
		    function(param, cont){
		     if(typeof param === "number" && 708102797 === param)
		      return cont(aiC);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_ends_with,
		    "Ends_with",
		    aiB,
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(192136481);},
		     function(param, cont){
		      if(typeof param === "number" && 192136481 === param)
		       return cont(aiA);
		      return cont(0);
		     },
		     0,
		     0,
		     cst_not_ends_with,
		     "Not_ends_with",
		     aiz,
		     0],
		    0]]]]]]]]]]]],
		                                1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$496[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$496[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$476 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$496, [0, schematic_cache$476]);
		               var
		                schema$121 =
		                  caml_callback
		                   (schema_versioned$296,
		                    [function(param, cont){return cont(0);}]);
		               function equal$191(lhs, rhs, cont){
		                if(3901498 <= lhs){
		                 if(192136481 <= lhs){
		                  if(613978708 <= lhs){
		                   if(708102797 <= lhs){
		                    if(typeof rhs === "number" && 708102797 === rhs)
		                     return cont(1);
		                   }
		                   else if(typeof rhs === "number" && 613978708 === rhs)
		                    return cont(1);
		                  }
		                  else
		                   if(259676648 <= lhs){
		                    if(typeof rhs === "number" && 259676648 === rhs)
		                     return cont(1);
		                   }
		                   else if(typeof rhs === "number" && 192136481 === rhs)
		                    return cont(1);
		                 }
		                 else
		                  if(103618111 <= lhs){
		                   if(typeof rhs === "number" && 103618111 === rhs)
		                    return cont(1);
		                  }
		                  else if(typeof rhs === "number" && 3901498 === rhs)
		                   return cont(1);
		                }
		                else
		                 if(15949 <= lhs){
		                  if(3556728 <= lhs){
		                   if(3805373 <= lhs){
		                    if(typeof rhs === "number" && 3805373 === rhs)
		                     return cont(1);
		                   }
		                   else if(typeof rhs === "number" && 3556728 === rhs)
		                    return cont(1);
		                  }
		                  else
		                   if(17064 <= lhs){
		                    if(typeof rhs === "number" && 17064 === rhs) return cont(1);
		                   }
		                   else if(typeof rhs === "number" && 15949 === rhs)
		                    return cont(1);
		                 }
		                 else
		                  if(15500 <= lhs){
		                   if(typeof rhs === "number" && 15500 === rhs) return cont(1);
		                  }
		                  else if(typeof rhs === "number" && -23885269 === rhs)
		                   return cont(1);
		                return cont(0);
		               }
		               caml_callback(encode$7, [schema$121]);
		               function equal$192(poly_a, cont){return cont(poly_a);}
		               function schema_versioned$297
		               (schematic_version, schematic_param_a_schema_versi, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (map$14
		                                    (function(param, cont){
		                                      var value = param[1];
		                                      return cont([0, value]);
		                                     },
		                                     function(value, cont){return cont([0, value]);},
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var value = param[1];
		return cont([0, value]);
		                                       },
		                                       function(param, cont){
		var value = param[1];
		return cont([0, value, 0]);
		                                       },
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_value,
		 0,
		 2,
		 [0, schematic_param_a_schema_versi],
		 0,
		 0],
		0]]]));
		                         });
		               }
		               function field_name_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    aiX,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               function equal_field_name(a, b, cont){return cont(a === b ? 1 : 0);
		               }
		               var letrec_function_context$497 = [];
		               function equal_pipeline(poly_a, lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$497[1],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3(poly_a, lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$497, [0, equal_field_name]);
		               var bj0 = [];
		               function schema_versioned$298(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bj0[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aiZ, aiY, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bj0[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bj0[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bj0[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (value_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_rhs, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$296,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var rhs = param[2][1], op = param[1];
		             return cont([0, op, rhs]);
		            },
		            function(param, cont){
		             var rhs = param[2], op = param[1];
		             return cont([0, op, [0, rhs, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_op, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bj0[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bj0[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$498 = [];
		               function value_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$498[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ai0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$498[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$498[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$498[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  return typeof param === "number" ? cont(ai1) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_null,
		                                 cst_Null,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     ai3,
		                                     ai2,
		                                     2,
		                                     3,
		                                     3,
		                                     function(c){
		                                      var b = [0, [0, c, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$1,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call$1
		                (schema_versioned$297,
		                 schematic_version,
		                 c,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       0,
		                       0,
		                       cst_date,
		                       cst_Date,
		                       d,
		                       b],
		                      a];
		                  return caml_exact_trampoline_cps_call$1
		                          (schema_versioned$297,
		                           schematic_version,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_string,
		                                 cst_String,
		                                 b,
		                                 0],
		                                c];
		                            return caml_exact_trampoline_cps_call$1
		                                    (schema_versioned$297,
		                                     schematic_version,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_bool,
		   cst_Bool,
		   c,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call$1
		      (schema_versioned$297,
		       schematic_version,
		       int64_schema,
		       function(a){
		        var
		         res =
		           [11,
		            ai4,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              0,
		              0,
		              cst_int,
		              cst_Int,
		              a,
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$498[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$498[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$477 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bj0, [0, schematic_cache$477]);
		               var schematic_cache$478 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$498, [0, schematic_cache$478]);
		               caml_callback
		                (schema_versioned$298,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (value_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var bPI = [];
		               function equal$193(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPI[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3(bPI[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               var letrec_function_context$499 = [];
		               function equal_value(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(1);
		                }
		                else
		                 switch(lhs[0]){
		                   case 0:
		                    if(typeof rhs !== "number" && 0 === rhs[0]){
		                     var rhs0 = rhs[1], lhs0 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$499[5],
		                              function(a, b, cont){return cont(caml_equal(a, b));},
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0, rhs0, cont);
		                              });
		                    }
		                    break;
		                   case 1:
		                    if(typeof rhs !== "number" && 1 === rhs[0]){
		                     var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$499[4],
		                              function(a, b, cont){return cont(a === b ? 1 : 0);},
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$0, rhs0$0, cont);
		                              });
		                    }
		                    break;
		                   case 2:
		                    if(typeof rhs !== "number" && 2 === rhs[0]){
		                     var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$499[3],
		                              function(a, b, cont){return cont(a === b ? 1 : 0);},
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$1, rhs0$1, cont);
		                              });
		                    }
		                    break;
		                   default:
		                    if(typeof rhs !== "number" && 3 === rhs[0]){
		                     var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                     return caml_trampoline_cps_call2
		                             (letrec_function_context$499[1],
		                              letrec_function_context$499[2],
		                              function(a){
		                               return caml_trampoline_cps_call3(a, lhs0$2, rhs0$2, cont);
		                              });
		                    }
		                 }
		                return cont(0);
		               }
		               caml_update_dummy(bPI, [0, equal_value, equal$191]);
		               caml_update_dummy
		                (letrec_function_context$499,
		                 [0, equal$192, equal$21, equal$192, equal$192, equal$192]);
		               var bj1 = [];
		               function schema_versioned$299(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bj1[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ai6, ai5, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bj1[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bj1[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bj1[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (op_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var op = param[2][1], rhs = param[1];
		   return cont([0, rhs, op]);
		  },
		  function(param, cont){
		   var op = param[2], rhs = param[1];
		   return cont([0, rhs, [0, op, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_rhs,
		    0,
		    2,
		    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_op, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bj1[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bj1[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Not_inside = "Not_inside",
		                letrec_function_context$500 = [];
		               function op_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$500[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ai7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$500[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$500[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$500[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(-764103652);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && -764103652 === param)
		                                    return cont(ai$);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_inside,
		                                  cst_Inside,
		                                  ai_,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(76551432);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 76551432 === param)
		                                     return cont(ai9);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_not_inside,
		                                   cst_Not_inside,
		                                   ai8,
		                                   0],
		                                  0]],
		                                1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$500[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$500[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$479 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bj1, [0, schematic_cache$479]);
		               var schematic_cache$480 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$500, [0, schematic_cache$480]);
		               caml_callback
		                (schema_versioned$299,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (op_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$501 = [];
		               function equal$194(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1], x$0 = x, y$0 = y;
		                for(;;){
		                 a:
		                 {
		                  if(x$0){
		                   if(y$0){
		                    var
		                     y$1 = y$0[2],
		                     b = y$0[1],
		                     x$1 = x$0[2],
		                     a = x$0[1],
		                     c = a === b ? 1 : 0;
		                    if(c){x$0 = x$1; y$0 = y$1; continue;}
		                    break a;
		                   }
		                  }
		                  else if(! y$0){c = 1; break a;}
		                  c = 0;
		                 }
		                 return c
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$501[1], lhs[2], rhs[2], cont)
		                         : cont(c);
		                }
		               }
		               function equal_op(lhs, rhs, cont){
		                if(76551432 <= lhs){
		                 if(typeof rhs === "number" && 76551432 === rhs)
		                  return cont(1);
		                }
		                else if(typeof rhs === "number" && -764103652 === rhs)
		                 return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy(letrec_function_context$501, [0, equal_op]);
		               var letrec_function_context$502 = [];
		               function equal$195(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(typeof rhs === "number") return cont(1);
		                }
		                else if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(typeof rhs !== "number" && 0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$502[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(typeof rhs !== "number" && 0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$502[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$502, [0, equal$57, equal$69]);
		               var cst_myself = "myself";
		               function of_string$46(repr, cont){
		                return repr !== cst_myself
		                        ? caml_exact_trampoline_cps_call
		                          (of_string$35,
		                           repr,
		                           function(match){
		                            if(0 !== match[0])
		                             return caml_exact_trampoline_cps_call
		                                     (of_string$40,
		                                      repr,
		                                      function(error){
		                                       if(0 !== error[0]) return cont(error);
		                                       var id = error[1];
		                                       return cont([0, [0, id]]);
		                                      });
		                            var id = match[1];
		                            return cont([0, [1, id]]);
		                           })
		                        : cont(aja);
		               }
		               function to_string$58(param, cont){
		                if(typeof param === "number") return cont(cst_myself);
		                if(0 === param[0]){
		                 var id = param[1];
		                 return caml_exact_trampoline_cps_call(to_string$48, id, cont);
		                }
		                var id$0 = param[1];
		                return cont(to_string$42(id$0));
		               }
		               var
		                schema$122 =
		                  map$14
		                   (of_string$46, to_string$58, schematic_param_name_schema_ve),
		                bj2 = [];
		               function schema_versioned$300(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bj2[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajc, ajb, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bj2[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bj2[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bj2[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (op_schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var op = param[2][1], rhs = param[1];
		   return cont([0, rhs, op]);
		  },
		  function(param, cont){
		   var op = param[2], rhs = param[1];
		   return cont([0, rhs, [0, op, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_rhs, 0, 3, [0, schema$122], 0, 0],
		   [0, [0, 0, 0, 0, 0, cst_op, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bj2[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bj2[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$503 = [];
		               function op_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$503[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajd, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$503[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$503[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$503[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(15500);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 15500 === param)
		                                    return cont(ajh);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_eq,
		                                  cst_Eq,
		                                  ajg,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(3901498);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 3901498 === param)
		                                     return cont(ajf);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_neq,
		                                   cst_Neq,
		                                   aje,
		                                   0],
		                                  0]],
		                                1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$503[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$503[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$481 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bj2, [0, schematic_cache$481]);
		               var schematic_cache$482 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$503, [0, schematic_cache$482]);
		               caml_callback
		                (schema_versioned$300,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (op_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$504 = [];
		               function equal$196(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(a){
		                 return a
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$504[1], lhs[2], rhs[2], cont)
		                         : cont(a);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$504[2], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               function equal_op$0(lhs, rhs, cont){
		                if(3901498 <= lhs){
		                 if(typeof rhs === "number" && 3901498 === rhs)
		                  return cont(1);
		                }
		                else if(typeof rhs === "number" && 15500 === rhs)
		                 return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$504, [0, equal_op$0, equal$195]);
		               var
		                cst_Collection = "Collection",
		                cst_Comparison = "Comparison",
		                cst_Membership = "Membership",
		                cst_comparison = "comparison",
		                cst_membership = "membership",
		                bj3 = [];
		               function atom_filter_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bj3[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aji, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bj3[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bj3[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bj3[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$299,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_membership,
		   cst_Membership,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (collection_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_collection,
		             cst_Collection,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$300,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_relation,
		                       cst_Relation,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$298,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                ajj,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_comparison,
		                                  cst_Comparison,
		                                  b,
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bj3[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bj3[1][1] = a; return cont(res);});
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Emptiness = "Emptiness",
		                cst_Filter = "Filter",
		                cst_emptiness = "emptiness",
		                cst_empty = "empty",
		                cst_match_kind = "match_kind",
		                bj4 = [];
		               function collection_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bj4[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajk, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bj4[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bj4[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bj4[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (collection_kind_schema_version,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_match_kind, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (atom_filter_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, f0, f1]);
		              },
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              },
		              1,
		              0,
		              cst_emptiness,
		              cst_Emptiness,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var field = param[2][1], empty = param[1];
		                 return cont([0, empty, field]);
		                },
		                function(param, cont){
		                 var field = param[2], empty = param[1];
		                 return cont([0, empty, [0, field, 0]]);
		                },
		                [0,
		                 [0, 0, 0, 0, 0, cst_empty, 0, 2, [0, bool_schema], 0, 0],
		                 [0,
		                  [0,
		                   ajl,
		                   0,
		                   0,
		                   0,
		                   cst_field,
		                   0,
		                   3,
		                   [0, schematic_param_name_schema_ve],
		                   0,
		                   0],
		                  0]]],
		               0],
		              0],
		             [0,
		              [0,
		               function(param, cont){
		                var f1 = param[2], f0 = param[1];
		                return cont([1, f0, f1]);
		               },
		               function(param, cont){
		                if(0 === param[0]) return cont(0);
		                var f1 = param[2], f0 = param[1];
		                return cont([0, [0, f0, f1]]);
		               },
		               1,
		               0,
		               cst_filter,
		               cst_Filter,
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var match_kind = param[2][1], filter = param[1];
		                  return cont([0, filter, match_kind]);
		                 },
		                 function(param, cont){
		                  var match_kind = param[2], filter = param[1];
		                  return cont([0, filter, [0, match_kind, 0]]);
		                 },
		                 [0, [0, 0, 0, 0, 0, cst_filter, 0, 2, [0, b], 0, 0], a]],
		                0],
		               0],
		              0]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bj4[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bj4[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_All_of = "All_of",
		                cst_One_of = "One_of",
		                letrec_function_context$505 = [];
		               function collection_kind_schema_version
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$505[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajm, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$505[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$505[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$505[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(ajq);},
		                                  0,
		                                  0,
		                                  cst_one_of,
		                                  cst_One_of,
		                                  ajp,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(ajo) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_all_of,
		                                   cst_All_of,
		                                   ajn,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$505[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$505[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$483 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bj3, [0, schematic_cache$483]);
		               var schematic_cache$484 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bj4, [0, schematic_cache$484]);
		               var schematic_cache$485 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$505, [0, schematic_cache$485]);
		               caml_callback
		                (atom_filter_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (collection_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (collection_kind_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var bPd = [];
		               function equal_atom_filter(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhs0 = rhs[1], lhs0 = lhs[1];
		                    return caml_trampoline_cps_call3(bPd[4], lhs0, rhs0, cont);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (bPd[3], lhs0$0, rhs0$0, cont);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (bPd[2], lhs0$1, rhs0$1, cont);
		                   }
		                   break;
		                  default:
		                   if(3 === rhs[0]){
		                    var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (bPd[1], lhs0$2, rhs0$2, cont);
		                   }
		                }
		                return cont(0);
		               }
		               var letrec_function_context$506 = [];
		               function equal_collection(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhsfield = lhs[2], lhsempty = lhs[1];
		                 if(0 === rhs[0]){
		                  var
		                   rhsfield = rhs[2],
		                   rhsempty = rhs[1],
		                   c = lhsempty === rhsempty ? 1 : 0;
		                  if(! c) return cont(c);
		                  if(lhsfield){
		                   if(rhsfield){
		                    var b = rhsfield[1], a = lhsfield[1];
		                    return cont(a === b ? 1 : 0);
		                   }
		                  }
		                  else if(! rhsfield) return cont(1);
		                  return cont(0);
		                 }
		                }
		                else {
		                 var lhsmatch_kind = lhs[2], lhsfilter = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhsmatch_kind = rhs[2], rhsfilter = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$506[2],
		                           lhsfilter,
		                           rhsfilter,
		                           function(a){
		                            return a
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$506[1],
		                                       lhsmatch_kind,
		                                       rhsmatch_kind,
		                                       cont)
		                                    : cont(a);
		                           });
		                 }
		                }
		                return cont(0);
		               }
		               function equal_collection_kind(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(1);
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               caml_update_dummy
		                (bPd, [0, equal$194, equal_collection, equal$196, equal$193]);
		               caml_update_dummy
		                (letrec_function_context$506,
		                 [0, equal_collection_kind, equal_atom_filter]);
		               var letrec_function_context$507 = [];
		               function kind_schema_versioned$2(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$507[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$507[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$507[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$507[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(ajv);},
		                                  0,
		                                  0,
		                                  cst_one_of,
		                                  cst_One_of,
		                                  aju,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(ajt) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_all_of,
		                                   cst_All_of,
		                                   ajs,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$507[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$507[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$486 = [0, empty$11([0, comparator$9])],
		                bj5 = [];
		               caml_update_dummy(bj5, [0, schematic_cache$486]);
		               var schematic_cache$487 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$507, [0, schematic_cache$487]);
		               function schematic_version$66(param, cont){return cont(0);}
		               var schematic_schema_version$109 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bj5[1][1], schematic_schema_version$109]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bj5[1][1],
		                             schematic_schema_version$109,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bj5[1][1],
		schematic_schema_version$109,
		schematic_self,
		function(a){
		 bj5[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (kind_schema_versioned$2,
		          schematic_version$66,
		          function(b){
		           var
		            a =
		              [0, [0, 0, 0, 0, 0, cst_match_kind, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (atom_filter_schema_versioned,
		                    schematic_version$66,
		                    function(b){
		                     var
		                      res =
		                        [11,
		                         0,
		                         [0,
		                          [0,
		                           function(param, cont){
		                            var f1 = param[2], f0 = param[1];
		                            return cont([0, f0, f1]);
		                           },
		                           function(param, cont){
		                            if(0 !== param[0]) return cont(0);
		                            var f1 = param[2], f0 = param[1];
		                            return cont([0, [0, f0, f1]]);
		                           },
		                           1,
		                           0,
		                           cst_emptiness,
		                           cst_Emptiness,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){
		                              var field = param[2][1], empty = param[1];
		                              return cont([0, empty, field]);
		                             },
		                             function(param, cont){
		                              var field = param[2], empty = param[1];
		                              return cont([0, empty, [0, field, 0]]);
		                             },
		                             [0,
		                              [0, 0, 0, 0, 0, cst_empty, 0, 2, [0, bool_schema], 0, 0],
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_field,
		                                0,
		                                3,
		                                [0, schematic_param_name_schema_ve],
		                                0,
		                                0],
		                               0]]],
		                            0],
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){
		                             var f1 = param[2], f0 = param[1];
		                             return cont([1, f0, f1]);
		                            },
		                            function(param, cont){
		                             if(0 === param[0]) return cont(0);
		                             var f1 = param[2], f0 = param[1];
		                             return cont([0, [0, f0, f1]]);
		                            },
		                            1,
		                            0,
		                            cst_filter,
		                            cst_Filter,
		                            [0,
		                             0,
		                             0,
		                             [7,
		                              function(param, cont){
		                               var match_kind = param[2][1], filter = param[1];
		                               return cont([0, filter, match_kind]);
		                              },
		                              function(param, cont){
		                               var match_kind = param[2], filter = param[1];
		                               return cont([0, filter, [0, match_kind, 0]]);
		                              },
		                              [0, [0, 0, 0, 0, 0, cst_filter, 0, 2, [0, b], 0, 0], a]],
		                             0],
		                            0],
		                           0]],
		                         0];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bj5[1][1],
		                              schematic_schema_version$109,
		                              res,
		                              function(a){bj5[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (kind_schema_versioned$2,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$508 = [];
		               function filter_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$508[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajx, ajw, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$508[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$508[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$508[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$299,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_membership,
		   cst_Membership,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (collection_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_collection,
		             cst_Collection,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$300,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_relation,
		                       cst_Relation,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$298,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                ajy,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_comparison,
		                                  cst_Comparison,
		                                  b,
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$508[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$508[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$488 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$508, [0, schematic_cache$488]);
		               caml_callback
		                (filter_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$509 = [];
		               function equal_filter(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhs0 = rhs[1], lhs0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$509[4], lhs0, rhs0, cont);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var rhs0$0 = rhs[1], lhs0$0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$509[3], lhs0$0, rhs0$0, cont);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhs0$1 = rhs[1], lhs0$1 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$509[2], lhs0$1, rhs0$1, cont);
		                   }
		                   break;
		                  default:
		                   if(3 === rhs[0]){
		                    var rhs0$2 = rhs[1], lhs0$2 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$509[1], lhs0$2, rhs0$2, cont);
		                   }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$509,
		                 [0, equal$194, equal_collection, equal$196, equal$193]);
		               function schema_versioned$301(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (filter_schema_versioned,
		                                   schematic_version,
		                                   function(schematic_param_a_schema_versi){
		                                    return caml_trampoline_cps_call2
		    (schematic_version,
		     V$4,
		     function(schematic_schema_version){
		      var
		       a =
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_filter,
		           0,
		           2,
		           [1, schematic_param_a_schema_versi],
		           0,
		           0],
		          0];
		      return caml_exact_trampoline_cps_call
		              (field_name_schema_versioned,
		               schematic_version,
		               function(b){
		                return cont
		                        ([0,
		                          ajz,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var filter = param[2][1], lhs = param[1];
		                            return cont([0, lhs, filter]);
		                           },
		                           function(param, cont){
		                            var filter = param[2], lhs = param[1];
		                            return cont([0, lhs, [0, filter, 0]]);
		                           },
		                           [0, [0, 0, 0, 0, 0, cst_lhs, 0, 2, [0, b], 0, 0], a]],
		                          0]);
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$301,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$510 = [];
		               function equal$197(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$510[1],
		                         letrec_function_context$510[2],
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               caml_update_dummy
		                (letrec_function_context$510,
		                 [0, equal_pipeline, equal_filter]);
		               var cst_Atom = "Atom", letrec_function_context$511 = [];
		               function schema_versioned$302(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$511[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajB, ajA, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$511[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$511[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$511[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$302,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_rhs, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$302,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([2, f0, f1]);
		             },
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_or,
		             cst_Or,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var rhs = param[2][1], lhs = param[1];
		                return cont([0, lhs, rhs]);
		               },
		               function(param, cont){
		                var rhs = param[2], lhs = param[1];
		                return cont([0, lhs, [0, rhs, 0]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_lhs, 0, 2, [0, c], 0, 0], a]],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$302,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_rhs, 0, 2, [0, c], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$302,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([1, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_and,
		                                 cst_And,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var rhs = param[2][1], lhs = param[1];
		                                    return cont([0, lhs, rhs]);
		                                   },
		                                   function(param, cont){
		                                    var rhs = param[2], lhs = param[1];
		                                    return cont([0, lhs, [0, rhs, 0]]);
		                                   },
		                                   [0, [0, 0, 0, 0, 0, cst_lhs, 0, 2, [0, d], 0, 0], a]],
		                                  0],
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$301,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       cst_atom = "atom",
		                                       res =
		 [11,
		  ajC,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_atom,
		    cst_Atom,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var atom = param[1];
		       return cont(atom);
		      },
		      function(atom, cont){return cont([0, atom, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_atom, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   c],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$511[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$511[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$489 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$511, [0, schematic_cache$489]);
		               var
		                schema$123 =
		                  caml_callback
		                   (schema_versioned$302,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$512 = [];
		               function equal$198(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   var lhsatom = lhs[1];
		                   if(0 === rhs[0]){
		                    var rhsatom = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$512[5], lhsatom, rhsatom, cont);
		                   }
		                   break;
		                  case 1:
		                   var lhsrhs = lhs[2], lhslhs = lhs[1];
		                   if(1 === rhs[0]){
		                    var rhsrhs = rhs[2], rhslhs = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$512[4],
		                             lhslhs,
		                             rhslhs,
		                             function(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$512[3], lhsrhs, rhsrhs, cont)
		                                      : cont(a);
		                             });
		                   }
		                   break;
		                  default:
		                   var lhsrhs$0 = lhs[2], lhslhs$0 = lhs[1];
		                   if(2 === rhs[0]){
		                    var rhsrhs$0 = rhs[2], rhslhs$0 = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$512[2],
		                             lhslhs$0,
		                             rhslhs$0,
		                             function(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$512[1], lhsrhs$0, rhsrhs$0, cont)
		                                      : cont(a);
		                             });
		                   }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$512,
		                 [0, equal$198, equal$198, equal$198, equal$198, equal$197]);
		               var
		                include$89 =
		                  caml_callback(Make$12, [[0, cst_task_binding, cst$21]]),
		                pp$94 = include$89[1],
		                schema_versioned$303 = include$89[4],
		                schema$124 = include$89[5],
		                symbol$193 = include$89[9],
		                symbol$194 = include$89[10],
		                symbol$195 = include$89[11],
		                symbol$196 = include$89[12],
		                symbol$197 = include$89[13],
		                symbol$198 = include$89[14],
		                equal$199 = include$89[15],
		                compare$121 = include$89[16],
		                min$28 = include$89[17],
		                max$30 = include$89[18],
		                ascending$19 = include$89[19],
		                descending$19 = include$89[20],
		                between$20 = include$89[21],
		                clamp_exn$19 = include$89[22],
		                clamp$19 = include$89[23],
		                comparator$40 = include$89[24],
		                By$17 = include$89[27],
		                make$55 = include$89[29];
		               function equal$200(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1];
		                return cont(a === b ? 1 : 0);
		               }
		               var letrec_function_context$513 = [];
		               function schema_versioned$304(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$513[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajE, ajD, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$513[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$513[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$513[1][1] = a;
		                            var
		                             default$ = match$177[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var enabled = param[1];
		                                 return cont([0, enabled]);
		                                },
		                                function(param, cont){
		                                 var enabled = param[1];
		                                 return cont([0, enabled, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  ajF,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_enabled,
		                                  0,
		                                  [0, default$],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$513[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$513[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$490 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$513, [0, schematic_cache$490]);
		               var
		                schema$125 =
		                  caml_callback
		                   (schema_versioned$304,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$514 = [];
		               function equal$201(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$514[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$514, [0, equal$50]);
		               var cst_New = "New", letrec_function_context$515 = [];
		               function serialization_schema_versioned
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$515[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajG, 0, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$515[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$515[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$515[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$159,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_legacy,
		   cst_Legacy,
		   [0, a[1], ajH, a[3], a[4]],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (schema_versioned$92,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_new,
		              cst_New,
		              a,
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$515[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$515[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$491 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$515, [0, schematic_cache$491]);
		               caml_callback
		                (serialization_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$305(version, cont){
		                function decode(a, cont){
		                 if(0 === a[0]){var result = a[1]; return cont([0, result]);}
		                 a = a[1];
		                 if(typeof a !== "number" && 5 === a[0]){
		                  var value = a[1];
		                  return cont([0, [7, value]]);
		                 }
		                 return cont(ajI);
		                }
		                function encode(result, cont){return cont([0, result]);}
		                return caml_exact_trampoline_cps_call
		                        (serialization_schema_versioned,
		                         version,
		                         function(a){return cont(map$14(decode, encode, a));});
		               }
		               caml_callback
		                (schema_versioned$305,
		                 [function(param, cont){return cont(0);}]);
		               var bkd = [];
		               function status_values_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bkd[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajQ, ajP, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bkd[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bkd[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bkd[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$305,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, ajR, 0, 0, 0, cst_write, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$305,
		       schematic_version,
		       function(b){
		        var
		         default$ = match$178[1],
		         res =
		           [7,
		            function(param, cont){
		             var write = param[2][1], read = param[1];
		             return cont([0, read, write]);
		            },
		            function(param, cont){
		             var write = param[2], read = param[1];
		             return cont([0, read, [0, write, 0]]);
		            },
		            [0,
		             [0,
		              ajS,
		              0,
		              0,
		              0,
		              cst_read,
		              0,
		              [0, default$],
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bkd[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bkd[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Values = "Values",
		                cst_done = "done",
		                letrec_function_context$516 = [];
		               function status_mapping_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$516[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ajU, ajT, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$516[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$516[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$516[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_values_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, ajV, 0, 0, 0, cst_discarded, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (status_values_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, ajW, 0, 0, 0, cst_done, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (status_values_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, ajX, 0, 0, 0, cst_todo, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$142,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                aj0,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, f0, f1, f2, f3]);
		                                  },
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, [0, f0, f1, f2, f3]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_values,
		                                  cst_Values,
		                                  [0,
		                                   0,
		                                   ajZ,
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      b = a[2],
		                                      discarded = b[2][1],
		                                      done = b[1],
		                                      todo = a[1],
		                                      column = param[1];
		                                     return cont([0, column, todo, done, discarded]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      discarded = param[4],
		                                      done = param[3],
		                                      todo = param[2],
		                                      column = param[1];
		                                     return cont
		     ([0, column, [0, todo, [0, done, [0, discarded, 0]]]]);
		                                    },
		                                    [0, [0, ajY, 0, 0, 0, cst_column, 0, 2, [0, b], 0, 0], a]],
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$516[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$516[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$492 = [0, empty$11([0, comparator$9])],
		                bj6 = [];
		               caml_update_dummy(bj6, [0, schematic_cache$492]);
		               var schematic_cache$493 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bkd, [0, schematic_cache$493]);
		               var schematic_cache$494 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$516, [0, schematic_cache$494]);
		               function schematic_version$67(param, cont){return cont(0);}
		               var
		                cst_scheduled_mapping = "scheduled_mapping",
		                cst_status_mapping = "status_mapping",
		                cst_url_mapping = "url_mapping",
		                schematic_schema_version$108 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bj6[1][1], schematic_schema_version$108]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bj6[1][1],
		                             schematic_schema_version$108,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bj6[1][1],
		schematic_schema_version$108,
		schematic_self,
		function(a){
		 bj6[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$142,
		          schematic_version$67,
		          function(b){
		           var
		            a =
		              [0,
		               [0, ajJ, 0, 0, 0, cst_url_mapping, 0, 3, [0, b], 0, 0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$142,
		                    schematic_version$67,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0, ajK, 0, 0, 0, cst_scheduled_mapping, 0, 3, [0, c], 0, 0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (status_mapping_schema_versione,
		                              schematic_version$67,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, ajL, 0, 0, 0, cst_status_mapping, 0, 3, [0, c], 0, 0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$302,
		schematic_version$67,
		function(c){
		 var
		  b =
		    [0, [0, ajM, 0, 0, 0, cst_filter, 0, 3, [0, c], 0, 0], a];
		 return caml_exact_trampoline_cps_call
		         (Table[4],
		          schematic_version$67,
		          function(c){
		           var
		            a =
		              [0, [0, ajN, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$120,
		                    schematic_version$67,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           c = b[2],
		                           d = c[2],
		                           url_mapping = d[2][1],
		                           scheduled_mapping = d[1],
		                           status_mapping = c[1],
		                           filter = b[1],
		                           table_id = a[1],
		                           workspace_id = param[1];
		                          return cont
		                                  ([0,
		                                    workspace_id,
		                                    table_id,
		                                    filter,
		                                    status_mapping,
		                                    scheduled_mapping,
		                                    url_mapping]);
		                         },
		                         function(param, cont){
		                          var
		                           url_mapping = param[6],
		                           scheduled_mapping = param[5],
		                           status_mapping = param[4],
		                           filter = param[3],
		                           table_id = param[2],
		                           workspace_id = param[1];
		                          return cont
		                                  ([0,
		                                    workspace_id,
		                                    [0,
		                                     table_id,
		                                     [0,
		                                      filter,
		                                      [0,
		                                       status_mapping,
		                                       [0, scheduled_mapping, [0, url_mapping, 0]]]]]]);
		                         },
		                         [0,
		                          [0, ajO, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		                          a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bj6[1][1],
		                              schematic_schema_version$108,
		                              res,
		                              function(a){bj6[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (status_values_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_mapping_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var bLU = [];
		               function status_values_schema_versioned$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bLU[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aj8, aj7, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bLU[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bLU[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bLU[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$305,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, aj9, 0, 0, 0, cst_write, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$305,
		       schematic_version,
		       function(b){
		        var
		         default$ = match$179[1],
		         res =
		           [7,
		            function(param, cont){
		             var write = param[2][1], read = param[1];
		             return cont([0, read, write]);
		            },
		            function(param, cont){
		             var write = param[2], read = param[1];
		             return cont([0, read, [0, write, 0]]);
		            },
		            [0,
		             [0,
		              aj_,
		              0,
		              0,
		              0,
		              cst_read,
		              0,
		              [0, default$],
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bLU[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bLU[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$517 = [];
		               function status_mapping_schema_versione$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$517[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aka, aj$, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$517[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$517[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$517[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_values_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, akb, 0, 0, 0, cst_discarded, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (status_values_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, akc, 0, 0, 0, cst_done, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (status_values_schema_versioned$0,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, akd, 0, 0, 0, cst_todo, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$142,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                akg,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, f0, f1, f2, f3]);
		                                  },
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, [0, f0, f1, f2, f3]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_values,
		                                  cst_Values,
		                                  [0,
		                                   0,
		                                   akf,
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      b = a[2],
		                                      discarded = b[2][1],
		                                      done = b[1],
		                                      todo = a[1],
		                                      column = param[1];
		                                     return cont([0, column, todo, done, discarded]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      discarded = param[4],
		                                      done = param[3],
		                                      todo = param[2],
		                                      column = param[1];
		                                     return cont
		     ([0, column, [0, todo, [0, done, [0, discarded, 0]]]]);
		                                    },
		                                    [0, [0, ake, 0, 0, 0, cst_column, 0, 2, [0, b], 0, 0], a]],
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$517[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$517[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$495 = [0, empty$11([0, comparator$9])],
		                bLT = [];
		               caml_update_dummy(bLT, [0, schematic_cache$495]);
		               var schematic_cache$496 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bLU, [0, schematic_cache$496]);
		               var schematic_cache$497 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$517, [0, schematic_cache$497]);
		               function schematic_version$68(param, cont){return cont(0);}
		               var schematic_schema_version$107 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bLT[1][1], schematic_schema_version$107]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bLT[1][1],
		                             schematic_schema_version$107,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bLT[1][1],
		schematic_schema_version$107,
		schematic_self,
		function(a){
		 bLT[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$142,
		          schematic_version$68,
		          function(b){
		           var
		            a =
		              [0,
		               [0, aj1, 0, 0, 0, cst_url_mapping, 0, 3, [0, b], 0, 0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$142,
		                    schematic_version$68,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0, aj2, 0, 0, 0, cst_scheduled_mapping, 0, 3, [0, c], 0, 0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (status_mapping_schema_versione$0,
		                              schematic_version$68,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, aj3, 0, 0, 0, cst_status_mapping, 0, 3, [0, c], 0, 0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$302,
		schematic_version$68,
		function(c){
		 var
		  b =
		    [0, [0, aj4, 0, 0, 0, cst_filter, 0, 3, [0, c], 0, 0], a];
		 return caml_exact_trampoline_cps_call
		         (Table[4],
		          schematic_version$68,
		          function(c){
		           var
		            a =
		              [0, [0, aj5, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$120,
		                    schematic_version$68,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           c = b[2],
		                           d = c[2],
		                           url_mapping = d[2][1],
		                           scheduled_mapping = d[1],
		                           status_mapping = c[1],
		                           filter = b[1],
		                           table_id = a[1],
		                           workspace_id = param[1];
		                          return cont
		                                  ([0,
		                                    workspace_id,
		                                    table_id,
		                                    filter,
		                                    status_mapping,
		                                    scheduled_mapping,
		                                    url_mapping]);
		                         },
		                         function(param, cont){
		                          var
		                           url_mapping = param[6],
		                           scheduled_mapping = param[5],
		                           status_mapping = param[4],
		                           filter = param[3],
		                           table_id = param[2],
		                           workspace_id = param[1];
		                          return cont
		                                  ([0,
		                                    workspace_id,
		                                    [0,
		                                     table_id,
		                                     [0,
		                                      filter,
		                                      [0,
		                                       status_mapping,
		                                       [0, scheduled_mapping, [0, url_mapping, 0]]]]]]);
		                         },
		                         [0,
		                          [0, aj6, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		                          a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bLT[1][1],
		                              schematic_schema_version$107,
		                              res,
		                              function(a){bLT[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (status_values_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_mapping_schema_versione$0,
		                 [function(param, cont){return cont(0);}]);
		               var bL0 = [];
		               function equal$202(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bL0[6],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(d){
		                           function c(d){
		                            function c(d){
		                             function c(c){
		                              if(! c) return cont(c);
		                              var y = rhs[6], x = lhs[6];
		                              if(x){
		                               if(y){
		                                var b = y[1], a = x[1];
		                                return caml_trampoline_cps_call3(bL0[1], a, b, cont);
		                               }
		                              }
		                              else if(! y) return cont(1);
		                              return cont(0);
		                             }
		                             if(! d) return c(d);
		                             var y = rhs[5], x = lhs[5];
		                             if(x){
		                              if(y){
		                               var b = y[1], a = x[1];
		                               return caml_trampoline_cps_call3(bL0[2], a, b, c);
		                              }
		                             }
		                             else if(! y) return c(1);
		                             return c(0);
		                            }
		                            if(! d) return c(d);
		                            var y = rhs[4], x = lhs[4];
		                            if(x){
		                             if(y){
		                              var b = y[1], a = x[1];
		                              return caml_trampoline_cps_call3(bL0[3], a, b, c);
		                             }
		                            }
		                            else if(! y) return c(1);
		                            return c(0);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3(bL0[4], a, b, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3(bL0[5], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               var bPJ = [];
		               function equal_status_values(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 function c(a){
		                  return a
		                          ? caml_trampoline_cps_call3(bPJ[1], lhs[2], rhs[2], cont)
		                          : cont(a);
		                 }
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (bPJ[2],
		                            a$0,
		                            b,
		                            function(b){
		                             return b ? caml_exact_trampoline_call2(a, x$0, y$0) : c(b);
		                            });
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                return a(x, y);
		               }
		               var letrec_function_context$518 = [];
		               function equal_status_mapping(lhs, rhs, cont){
		                var
		                 rhsdiscarded = rhs[4],
		                 rhsdone = rhs[3],
		                 rhstodo = rhs[2],
		                 rhscolumn = rhs[1],
		                 lhsdiscarded = lhs[4],
		                 lhsdone = lhs[3],
		                 lhstodo = lhs[2],
		                 lhscolumn = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$518[4],
		                         lhscolumn,
		                         rhscolumn,
		                         function(b){
		                          function a(b){
		                           function a(a){
		                            return a
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$518[1],
		                                       lhsdiscarded,
		                                       rhsdiscarded,
		                                       cont)
		                                    : cont(a);
		                           }
		                           return b
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$518[2], lhsdone, rhsdone, a)
		                                   : a(b);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$518[3], lhstodo, rhstodo, a)
		                                  : a(b);
		                         });
		               }
		               var _1$44 = Table[15];
		               caml_update_dummy
		                (bL0,
		                 [0,
		                  equal$77,
		                  equal$77,
		                  equal_status_mapping,
		                  equal$198,
		                  _1$44,
		                  equal$61]);
		               caml_update_dummy(bPJ, [0, equal$201, equal$201]);
		               caml_update_dummy
		                (letrec_function_context$518,
		                 [0,
		                  equal_status_values,
		                  equal_status_values,
		                  equal_status_values,
		                  equal$77]);
		               var bMg = [];
		               function schema_versioned$306(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bMg[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aki, akh, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bMg[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bMg[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bMg[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$142,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, akj, 0, 0, 0, cst_url_mapping, 0, 3, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$142,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, akk, 0, 0, 0, cst_scheduled_mapping, 0, 3, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (status_mapping_schema_versione$1,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, akl, 0, 0, 0, cst_status_mapping, 0, 3, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$302,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, akm, 0, 0, 0, cst_filter, 0, 3, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Table[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, akn, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$120,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              url_mapping = d[2][1],
		              scheduled_mapping = d[1],
		              status_mapping = c[1],
		              filter = b[1],
		              table_id = a[1],
		              workspace_id = param[1];
		             return cont
		                     ([0,
		                       workspace_id,
		                       table_id,
		                       filter,
		                       status_mapping,
		                       scheduled_mapping,
		                       url_mapping]);
		            },
		            function(param, cont){
		             var
		              url_mapping = param[6],
		              scheduled_mapping = param[5],
		              status_mapping = param[4],
		              filter = param[3],
		              table_id = param[2],
		              workspace_id = param[1];
		             return cont
		                     ([0,
		                       workspace_id,
		                       [0,
		                        table_id,
		                        [0,
		                         filter,
		                         [0,
		                          status_mapping,
		                          [0, scheduled_mapping, [0, url_mapping, 0]]]]]]);
		            },
		            [0,
		             [0, ako, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bMg[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bMg[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bMh = [];
		               function status_values_schema_versioned$1
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bMh[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, akq, akp, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bMh[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bMh[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bMh[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$305,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, akr, 0, 0, 0, cst_write, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$305,
		       schematic_version,
		       function(b){
		        var
		         default$ = match$180[1],
		         res =
		           [7,
		            function(param, cont){
		             var write = param[2][1], read = param[1];
		             return cont([0, read, write]);
		            },
		            function(param, cont){
		             var write = param[2], read = param[1];
		             return cont([0, read, [0, write, 0]]);
		            },
		            [0,
		             [0,
		              aks,
		              0,
		              0,
		              0,
		              cst_read,
		              0,
		              [0, default$],
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bMh[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bMh[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$519 = [];
		               function status_mapping_schema_versione$1
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$519[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aku, akt, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$519[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$519[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$519[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_values_schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, akv, 0, 0, 0, cst_discarded, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (status_values_schema_versioned$1,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, akw, 0, 0, 0, cst_done, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (status_values_schema_versioned$1,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, akx, 0, 0, 0, cst_todo, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$142,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                akA,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, f0, f1, f2, f3]);
		                                  },
		                                  function(param, cont){
		                                   var
		                                    f3 = param[4],
		                                    f2 = param[3],
		                                    f1 = param[2],
		                                    f0 = param[1];
		                                   return cont([0, [0, f0, f1, f2, f3]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_values,
		                                  cst_Values,
		                                  [0,
		                                   0,
		                                   akz,
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      b = a[2],
		                                      discarded = b[2][1],
		                                      done = b[1],
		                                      todo = a[1],
		                                      column = param[1];
		                                     return cont([0, column, todo, done, discarded]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      discarded = param[4],
		                                      done = param[3],
		                                      todo = param[2],
		                                      column = param[1];
		                                     return cont
		     ([0, column, [0, todo, [0, done, [0, discarded, 0]]]]);
		                                    },
		                                    [0, [0, aky, 0, 0, 0, cst_column, 0, 2, [0, b], 0, 0], a]],
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$519[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$519[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$498 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bMg, [0, schematic_cache$498]);
		               var schematic_cache$499 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bMh, [0, schematic_cache$499]);
		               var schematic_cache$500 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$519, [0, schematic_cache$500]);
		               var
		                schema$126 =
		                  caml_callback
		                   (schema_versioned$306,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_values_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_mapping_schema_versione$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$520 = [];
		               function equal$203(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(d){
		                 function c(c){
		                  if(c) var b = rhs[3], a = lhs[3], c = a === b ? 1 : 0;
		                  if(! c) return cont(c);
		                  var b$0 = rhs[4], a$0 = lhs[4];
		                  return cont(a$0 === b$0 ? 1 : 0);
		                 }
		                 if(! d) return c(d);
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b = y[1], a = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$520[1], a, b, c);
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$520[2], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$520, [0, equal$20, equal$105]);
		               var letrec_function_context$521 = [];
		               function schema_versioned$307(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$521[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, akC, akB, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$521[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$521[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$521[1][1] = b;
		                            var
		                             default$ = match$181[1],
		                             default$0 = match$182[1],
		                             a =
		                               [0,
		                                [0,
		                                 akE,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_discarded,
		                                 0,
		                                 [0, default$0],
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  akD,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_starred,
		                                  0,
		                                  [0, default$],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0, akF, 0, 0, 0, cst_status_changed_at, 0, 3, [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$185,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              starred = b[2][1],
		              discarded = b[1],
		              status_changed_at = a[1],
		              scheduling = param[1];
		             return cont
		                     ([0, scheduling, status_changed_at, discarded, starred]);
		            },
		            function(param, cont){
		             var
		              starred = param[4],
		              discarded = param[3],
		              status_changed_at = param[2],
		              scheduling = param[1];
		             return cont
		                     ([0,
		                       scheduling,
		                       [0, status_changed_at, [0, discarded, [0, starred, 0]]]]);
		            },
		            [0,
		             [0, akG, 0, 0, 0, cst_scheduling, 0, 3, [0, a], 0, 0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$521[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$521[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$501 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$521, [0, schematic_cache$501]);
		               caml_callback
		                (schema_versioned$307,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$522 = [];
		               function equal$204(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$522[3],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          if(! a) return cont(a);
		                          var b = rhs[2], c = lhs[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$522[1],
		                                   letrec_function_context$522[2],
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, c, b, cont);
		                                   });
		                         });
		               }
		               var _2$22 = include$51[27][53];
		               caml_update_dummy
		                (letrec_function_context$522,
		                 [0, _2$22, equal$203, equal$202]);
		               var _0$39 = include$51[27][104];
		               function make$56(opt, config){
		                var rows = _0$39;
		                return [0, config, rows];
		               }
		               var letrec_function_context$523 = [];
		               function schema_versioned$308(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$523[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, akI, akH, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$523[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$523[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$523[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$307,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (include$51[27][102],
		       schematic_version,
		       a,
		       function(b){
		        var
		         default$ = include$51[27][104],
		         a =
		           [0,
		            [0, akJ, 0, 0, 0, cst_rows, 0, [0, default$], [0, b], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$306,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var rows = param[2][1], config = param[1];
		                       return cont([0, config, rows]);
		                      },
		                      function(param, cont){
		                       var rows = param[2], config = param[1];
		                       return cont([0, config, [0, rows, 0]]);
		                      },
		                      [0, [0, akK, 0, 0, 0, cst_config, 0, 2, [1, b], 0, 0], a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$523[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$523[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$502 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$523, [0, schematic_cache$502]);
		               var
		                schema$127 =
		                  caml_callback
		                   (schema_versioned$308,
		                    [function(param, cont){return cont(0);}]),
		                schematic_cache$503 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$524 = [];
		               caml_update_dummy
		                (letrec_function_context$524, [0, schematic_cache$503]);
		               var schematic_schema_version$14 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$524[1][1],
		                    schematic_schema_version$14]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$524[1][1],
		                             schematic_schema_version$14,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$524[1][1],
		schematic_schema_version$14,
		schematic_self,
		function(a){
		 letrec_function_context$524[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       body = a[2][1],
		       url = a[1],
		       title = param[1];
		      return cont([0, title, url, body]);
		     },
		     function(param, cont){
		      var body = param[3], url = param[2], title = param[1];
		      return cont([0, title, [0, url, [0, body, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_title,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_url,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_body,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$524[1][1],
		          schematic_schema_version$14,
		          res,
		          function(a){
		           letrec_function_context$524[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$525 = [];
		               function compare$122(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$525[2],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    if(0 !== x) return cont(x);
		                                    var a = rhs[2], b = lhs[2];
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$525[1],
		     0,
		     function(c){
		      return caml_trampoline_cps_call3(c, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function _1$45(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$40(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$525, [0, _1$45, _0$40]);
		               function pp$95(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         akL,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   akM,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_google.Config.Account.T.directory_enabled",
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               akN,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   akO,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     akP,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               akQ,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_other_enabled,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   akR,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               akS,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), akT, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$526 = [];
		               function schema_versioned$309(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$526[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, akU, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$526[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$526[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$526[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     akW,
		                                     akV,
		                                     2,
		                                     3,
		                                     4,
		                                     function(a){
		                                      var
		                                       default$ = match$183[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    other_enabled = param[2][1],
		    directory_enabled = param[1];
		   return cont([0, directory_enabled, other_enabled]);
		  },
		  function(param, cont){
		   var other_enabled = param[2], directory_enabled = param[1];
		   return cont([0, directory_enabled, [0, other_enabled, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_directory_enabled,
		    0,
		    2,
		    [0, bool_schema],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_other_enabled,
		     0,
		     [0, default$],
		     [0, bool_schema],
		     [0, [0, a, V$4]],
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$526[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$526[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$504 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$526, [0, schematic_cache$504]);
		               var
		                schema$128 =
		                  caml_callback
		                   (schema_versioned$309,
		                    [function(param, cont){return cont(0);}]),
		                sexp_of_t$53 = caml_callback(encode$7, [schema$128]),
		                include$90 = Make$2([0, compare$122, sexp_of_t$53]),
		                equal$205 = include$90[7],
		                letrec_function_context$527 = [];
		               function equal$206(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$527[1],
		                         letrec_function_context$527[2],
		                         function(c){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               }
		               var _1$46 = By$6[53];
		               caml_update_dummy
		                (letrec_function_context$527, [0, _1$46, equal$205]);
		               var letrec_function_context$528 = [];
		               function pp$96(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         akX,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   akY,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_google.Config.accounts",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call3
		              (letrec_function_context$528[1],
		               function(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$528[2], fmt, cont);
		               },
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   akZ,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), ak0, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var _1$47 = By$6[121];
		               caml_update_dummy
		                (letrec_function_context$528, [0, _1$47, pp$95]);
		               var letrec_function_context$529 = [];
		               function schema_versioned$310(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$529[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ak1, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$529[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$529[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$529[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$309,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (By$6[102],
		       schematic_version,
		       a,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var accounts = param[1];
		             return cont([0, accounts]);
		            },
		            function(param, cont){
		             var accounts = param[1];
		             return cont([0, accounts, 0]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_accounts, 0, 2, [0, a], 0, 0], 0]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$529[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$529[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$505 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$529, [0, schematic_cache$505]);
		               caml_callback
		                (schema_versioned$310,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$91 = caml_callback(M_printable, [[0, _2$3, e, bPa]]),
		                equal$207 = include$91[55],
		                pp$97 = include$91[128],
		                include$92 = caml_callback(M_printable, [[0, _3$2, b2, du]]),
		                equal$208 = include$92[55],
		                pp$98 = include$92[128],
		                schematic_cache$506 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$530 = [];
		               caml_update_dummy
		                (letrec_function_context$530, [0, schematic_cache$506]);
		               var
		                schematic_schema_version$15 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$530[1][1],
		                     schematic_schema_version$15]);
		               if(h)
		                var schema$129 = h[1], descriptor$25 = schema$129;
		               else
		                descriptor$25 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$530[1][1],
		                              schematic_schema_version$15,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$530[1][1],
		 schematic_schema_version$15,
		 schematic_self,
		 function(a){
		  letrec_function_context$530[1][1] = a;
		  var
		   res =
		     [7,
		      function(param, cont){
		       var
		        a = param[2],
		        b = a[2],
		        c = b[2],
		        workspace_icon = c[2][1],
		        workspace_name = c[1],
		        workspace_id = b[1],
		        owner = a[1],
		        access_token = param[1];
		       return cont
		               ([0,
		                 access_token,
		                 owner,
		                 workspace_id,
		                 workspace_name,
		                 workspace_icon]);
		      },
		      function(param, cont){
		       var
		        workspace_icon = param[5],
		        workspace_name = param[4],
		        workspace_id = param[3],
		        owner = param[2],
		        access_token = param[1];
		       return cont
		               ([0,
		                 access_token,
		                 [0,
		                  owner,
		                  [0,
		                   workspace_id,
		                   [0, workspace_name, [0, workspace_icon, 0]]]]]);
		      },
		      [0,
		       [0,
		        ak8,
		        0,
		        0,
		        0,
		        cst_access_token,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         ak7,
		         0,
		         0,
		         0,
		         cst_owner,
		         0,
		         2,
		         [0, no_input_schema],
		         0,
		         0],
		        [0,
		         [0,
		          ak6,
		          0,
		          0,
		          0,
		          cst_workspace_id,
		          0,
		          2,
		          [0, schematic_param_name_schema_ve],
		          0,
		          0],
		         [0,
		          [0,
		           ak5,
		           0,
		           0,
		           0,
		           cst_workspace_name,
		           0,
		           3,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          [0,
		           [0,
		            ak4,
		            0,
		            0,
		            0,
		            cst_workspace_icon,
		            0,
		            3,
		            [0, schema$262],
		            0,
		            0],
		           0]]]]]];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$530[1][1],
		           schematic_schema_version$15,
		           res,
		           function(a){
		            letrec_function_context$530[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                access_token_response_schema = [0, ak3, ak2, descriptor$25, 0];
		               function equal_status$0
		               (poly_select, poly_status, poly_checkbox, lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   var lhsoptions = lhs[1];
		                   if(0 === rhs[0]){
		                    var rhsoptions = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (poly_select, lhsoptions, rhsoptions, cont);
		                   }
		                   break;
		                  case 1:
		                   var lhsstatus = lhs[1];
		                   if(1 === rhs[0]){
		                    var rhsstatus = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (poly_status, lhsstatus, rhsstatus, cont);
		                   }
		                   break;
		                  default:
		                   var lhscheckbox = lhs[1];
		                   if(2 === rhs[0]){
		                    var rhscheckbox = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (poly_checkbox, lhscheckbox, rhscheckbox, cont);
		                   }
		                }
		                return cont(0);
		               }
		               var bQa = [];
		               function equal_select_option(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bQa[1],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(! c) return cont(c);
		                          var b = rhs[2], a = lhs[2];
		                          return cont(a === b ? 1 : 0);
		                         });
		               }
		               function equal_group_id(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               var bPK = [];
		               function equal_status_option(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPK[2],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(c){
		                           if(! c) return cont(c);
		                           var b = rhs[3], a = lhs[3];
		                           return cont(a === b ? 1 : 0);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3(bPK[1], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               var bPe = [];
		               function equal_select_option_mapping(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPe[4],
		                         lhs[1],
		                         rhs[1],
		                         function(d){
		                          function c(c){
		                           function a(b){
		                            if(! b) return cont(b);
		                            var y = rhs[4], x = lhs[4];
		                            function a(x, y){
		                             if(x){
		                              if(y){
		                               var
		                                y$0 = y[2],
		                                b = y[1],
		                                x$0 = x[2],
		                                a$0 = x[1],
		                                c =
		                                  function(b){
		                                   return b
		   ? caml_exact_trampoline_call2(a, x$0, y$0)
		   : cont(b);
		                                  };
		                               if(a$0){
		                                if(b){
		                                 var b$0 = b[1], a$1 = a$0[1];
		                                 return caml_trampoline_cps_call3(bPe[1], a$1, b$0, c);
		                                }
		                               }
		                               else if(! b) return c(1);
		                               return c(0);
		                              }
		                             }
		                             else if(! y) return cont(1);
		                             return cont(0);
		                            }
		                            return a(x, y);
		                           }
		                           if(! c) return a(c);
		                           var y = rhs[3], x = lhs[3];
		                           function b(x, y){
		                            if(x){
		                             if(y){
		                              var
		                               y$0 = y[2],
		                               b$0 = y[1],
		                               x$0 = x[2],
		                               a$0 = x[1],
		                               c =
		                                 function(c){
		                                  return c ? caml_exact_trampoline_call2(b, x$0, y$0) : a(c);
		                                 };
		                              if(a$0){
		                               if(b$0){
		                                var b$1 = b$0[1], a$1 = a$0[1];
		                                return caml_trampoline_cps_call3(bPe[2], a$1, b$1, c);
		                               }
		                              }
		                              else if(! b$0) return c(1);
		                              return c(0);
		                             }
		                            }
		                            else if(! y) return a(1);
		                            return a(0);
		                           }
		                           return b(x, y);
		                          }
		                          if(! d) return c(d);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3(bPe[3], a, b, c);
		                           }
		                          }
		                          else if(! y) return c(1);
		                          return c(0);
		                         });
		               }
		               var letrec_function_context$531 = [];
		               function equal_status_option_mapping(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$531[4],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(c){
		                           function a(b){
		                            if(! b) return cont(b);
		                            var y = rhs[4], x = lhs[4];
		                            function a(x, y){
		                             if(x){
		                              if(y){
		                               var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                               return caml_trampoline_cps_call3
		                                       (letrec_function_context$531[1],
		a$0,
		b,
		function(b){
		 return b
		         ? caml_exact_trampoline_call2(a, x$0, y$0)
		         : cont(b);
		});
		                              }
		                             }
		                             else if(! y) return cont(1);
		                             return cont(0);
		                            }
		                            return a(x, y);
		                           }
		                           if(! c) return a(c);
		                           var y = rhs[3], x = lhs[3];
		                           function b(x, y){
		                            if(x){
		                             if(y){
		                              var y$0 = y[2], b$0 = y[1], x$0 = x[2], a$0 = x[1];
		                              return caml_trampoline_cps_call3
		                                      (letrec_function_context$531[2],
		                                       a$0,
		                                       b$0,
		                                       function(c){
		return c ? caml_exact_trampoline_call2(b, x$0, y$0) : a(c);
		                                       });
		                             }
		                            }
		                            else if(! y) return a(1);
		                            return a(0);
		                           }
		                           return b(x, y);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$531[3], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy(bQa, [0, equal$4]);
		               caml_update_dummy(bPK, [0, equal_group_id, equal$4]);
		               caml_update_dummy(bPe, [0, equal$4, equal$4, equal$4, equal$4]);
		               caml_update_dummy
		                (letrec_function_context$531,
		                 [0, equal$4, equal$4, equal$4, equal$4]);
		               function compare_status
		               (poly_select, poly_status, poly_checkbox, lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   var lhsoptions = lhs[1];
		                   if(0 === rhs[0]){
		                    var rhsoptions = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (poly_select, lhsoptions, rhsoptions, cont);
		                   }
		                   break;
		                  case 1:
		                   var lhsstatus = lhs[1];
		                   if(1 === rhs[0]){
		                    var rhsstatus = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (poly_status, lhsstatus, rhsstatus, cont);
		                   }
		                   break;
		                  default:
		                   var lhscheckbox = lhs[1];
		                   if(2 === rhs[0]){
		                    var rhscheckbox = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (poly_checkbox, lhscheckbox, rhscheckbox, cont);
		                   }
		                }
		                function to_int(param){
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   default: return 2;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var bPL = [];
		               function compare_select_option(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPL[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          if(0 !== x) return cont(x);
		                          var a = rhs[2], b = lhs[2];
		                          return caml_trampoline_cps_call2
		                                  (bPL[1],
		                                   0,
		                                   function(c){
		                                    return caml_trampoline_cps_call3(c, b, a, cont);
		                                   });
		                         });
		               }
		               function compare_group_id(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  default: if(2 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   default: return 2;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var bPv = [];
		               function compare_status_option(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPv[3],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (bPv[2],
		                                     lhs[2],
		                                     rhs[2],
		                                     function(x){
		                                      if(0 !== x) return cont(x);
		                                      var a = rhs[3], b = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (bPv[1],
		       0,
		       function(c){
		        return caml_trampoline_cps_call3(c, b, a, cont);
		       });
		                                     })
		                                  : cont(x);
		                         });
		               }
		               var bPf = [];
		               function compare_select_option_mapping(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPf[4],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          if(0 !== x) return cont(x);
		                          var y = rhs[2], x$0 = lhs[2];
		                          function c(x){
		                           if(0 !== x) return cont(x);
		                           var y = rhs[3], x$0 = lhs[3];
		                           function a(x, y){
		                            function d(x){
		                             if(0 !== x) return cont(x);
		                             var y = rhs[4], x$0 = lhs[4];
		                             function a(x, y){
		                              if(! x) return y ? cont(-1) : cont(0);
		                              if(! y) return cont(1);
		                              var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                              function c(x){
		                               return 0 === x
		                                       ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                       : cont(x);
		                              }
		                              if(! a$0) return b ? c(-1) : c(0);
		                              var a$1 = a$0[1];
		                              if(! b) return c(1);
		                              var b$0 = b[1];
		                              return caml_trampoline_cps_call3(bPf[1], a$1, b$0, c);
		                             }
		                             return a(x$0, y);
		                            }
		                            if(! x) return y ? d(-1) : d(0);
		                            if(! y) return d(1);
		                            var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                            function c(x){
		                             return 0 === x
		                                     ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                     : d(x);
		                            }
		                            if(! a$0) return b ? c(-1) : c(0);
		                            var a$1 = a$0[1];
		                            if(! b) return c(1);
		                            var b$0 = b[1];
		                            return caml_trampoline_cps_call3(bPf[2], a$1, b$0, c);
		                           }
		                           return a(x$0, y);
		                          }
		                          if(! x$0) return y ? c(-1) : c(0);
		                          var a = x$0[1];
		                          if(! y) return c(1);
		                          var b = y[1];
		                          return caml_trampoline_cps_call3(bPf[3], a, b, c);
		                         });
		               }
		               var letrec_function_context$532 = [];
		               function compare_status_option_mapping(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$532[4],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$532[3],
		                                     lhs[2],
		                                     rhs[2],
		                                     function(x){
		                                      if(0 !== x) return cont(x);
		                                      var y = rhs[3], x$0 = lhs[3];
		                                      function a(x, y){
		                                       function c(x){
		if(0 !== x) return cont(x);
		var y = rhs[4], x$0 = lhs[4];
		function a(x, y){
		 if(! x) return y ? cont(-1) : cont(0);
		 if(! y) return cont(1);
		 var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		 return caml_trampoline_cps_call3
		         (letrec_function_context$532[1],
		          a$0,
		          b,
		          function(x){
		           return 0 === x
		                   ? caml_exact_trampoline_call2(a, x$0, y$0)
		                   : cont(x);
		          });
		}
		return a(x$0, y);
		                                       }
		                                       if(! x) return y ? c(-1) : c(0);
		                                       if(! y) return c(1);
		                                       var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context$532[2],
		        a$0,
		        b,
		        function(x){
		         return 0 === x
		                 ? caml_exact_trampoline_call2(a, x$0, y$0)
		                 : c(x);
		        });
		                                      }
		                                      return a(x$0, y);
		                                     })
		                                  : cont(x);
		                         });
		               }
		               function _1$48(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(bPL, [0, _1$48, compare$4]);
		               function _2$23(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy(bPv, [0, _2$23, compare_group_id, compare$4]);
		               caml_update_dummy
		                (bPf, [0, compare$4, compare$4, compare$4, compare$4]);
		               caml_update_dummy
		                (letrec_function_context$532,
		                 [0, compare$4, compare$4, compare$4, compare$4]);
		               function status_schema_versioned$6(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_select_schema_,
		                                    schematic_param_status_schema_,
		                                    schematic_param_checkbox_schem){
		                                    return [0,
		    0,
		    0,
		    [11,
		     0,
		     [0,
		      [0,
		       function(f0, cont){return cont([0, f0]);},
		       function(param, cont){
		        if(0 !== param[0]) return cont(0);
		        var f0 = param[1];
		        return cont([0, f0]);
		       },
		       1,
		       0,
		       cst_select,
		       cst_Select,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var options = param[1];
		          return cont(options);
		         },
		         function(options, cont){return cont([0, options, 0]);},
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_options,
		           0,
		           2,
		           [2, schematic_param_select_schema_],
		           0,
		           0],
		          0]],
		        0],
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(1 !== param[0]) return cont(0);
		         var f0 = param[1];
		         return cont([0, f0]);
		        },
		        1,
		        0,
		        cst_status,
		        cst_Status,
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){
		           var status = param[1];
		           return cont(status);
		          },
		          function(status, cont){return cont([0, status, 0]);},
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_status,
		            0,
		            2,
		            [2, schematic_param_status_schema_],
		            0,
		            0],
		           0]],
		         0],
		        0],
		       [0,
		        [0,
		         function(f0, cont){return cont([2, f0]);},
		         function(param, cont){
		          if(2 !== param[0]) return cont(0);
		          var f0 = param[1];
		          return cont([0, f0]);
		         },
		         1,
		         0,
		         cst_checkbox,
		         cst_Checkbox,
		         [0,
		          0,
		          0,
		          [7,
		           function(param, cont){
		            var checkbox = param[1];
		            return cont(checkbox);
		           },
		           function(checkbox, cont){return cont([0, checkbox, 0]);},
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_checkbox,
		             0,
		             2,
		             [2, schematic_param_checkbox_schem],
		             0,
		             0],
		            0]],
		          0],
		         0],
		        0]]],
		     0],
		    0];
		                                   });
		                         });
		               }
		               var bMD = [];
		               function select_option_schema_versioned
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bMD[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ak9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bMD[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bMD[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bMD[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var name = param[2][1], option_id = param[1];
		                                 return cont([0, option_id, name]);
		                                },
		                                function(param, cont){
		                                 var name = param[2], option_id = param[1];
		                                 return cont([0, option_id, [0, name, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bMD[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bMD[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_In_progress = "In_progress", bNN = [];
		               function group_id_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNN[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ak_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNN[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNN[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bNN[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(ale);},
		                                  0,
		                                  0,
		                                  cst_todo,
		                                  cst_Todo,
		                                  ald,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(alc) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_in_progress,
		                                   cst_In_progress,
		                                   alb,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(ala) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_completed,
		                                    cst_Completed,
		                                    ak$,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bNN[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bNN[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bNO = [];
		               function status_option_schema_versioned
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNO[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, alf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNO[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNO[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bNO[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (group_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    name = a[2][1],
		    group_id = a[1],
		    option_id = param[1];
		   return cont([0, option_id, group_id, name]);
		  },
		  function(param, cont){
		   var
		    name = param[3],
		    group_id = param[2],
		    option_id = param[1];
		   return cont([0, option_id, [0, group_id, [0, name, 0]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_group, 0, 2, [0, b], 0, 0], a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bNO[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bNO[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bNR = [];
		               function select_option_mapping_schema_v
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNR[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, alg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNR[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNR[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bNR[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$184[1],
		                                       a =
		 [0,
		  [0,
		   alh,
		   0,
		   0,
		   0,
		   "ignoredStatusEquivalentIds",
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$185[1],
		         b =
		           [0,
		            [0,
		             ali,
		             0,
		             0,
		             0,
		             "completedStatusEquivalentIds",
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(a){
		                  var
		                   default$ = match$186[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        ignored_equivalent_ids = b[2][1],
		                        completed_equivalent_ids = b[1],
		                        active_id = a[1],
		                        completed_id = param[1];
		                       return cont
		                               ([0,
		                                 completed_id,
		                                 active_id,
		                                 completed_equivalent_ids,
		                                 ignored_equivalent_ids]);
		                      },
		                      function(param, cont){
		                       var
		                        ignored_equivalent_ids = param[4],
		                        completed_equivalent_ids = param[3],
		                        active_id = param[2],
		                        completed_id = param[1];
		                       return cont
		                               ([0,
		                                 completed_id,
		                                 [0,
		                                  active_id,
		                                  [0,
		                                   completed_equivalent_ids,
		                                   [0, ignored_equivalent_ids, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        alk,
		                        0,
		                        0,
		                        0,
		                        "completedStatusId",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         alj,
		                         0,
		                         0,
		                         0,
		                         "activeStatusId",
		                         0,
		                         [0, default$],
		                         [0, a],
		                         0,
		                         0],
		                        b]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNR[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bNR[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$533 = [];
		               function status_option_mapping_schema_v
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$533[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, alm, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$533[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$533[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$533[1][1] = a;
		                            var
		                             default$ = match$187[1],
		                             default$0 = match$188[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  status_ignored_ids = b[2][1],
		                                  status_completed_equivalent_id = b[1],
		                                  status_active_id = a[1],
		                                  status_completed_id = param[1];
		                                 return cont
		 ([0,
		   status_completed_id,
		   status_active_id,
		   status_completed_equivalent_id,
		   status_ignored_ids]);
		                                },
		                                function(param, cont){
		                                 var
		                                  status_ignored_ids = param[4],
		                                  status_completed_equivalent_id = param[3],
		                                  status_active_id = param[2],
		                                  status_completed_id = param[1];
		                                 return cont
		 ([0,
		   status_completed_id,
		   [0,
		    status_active_id,
		    [0,
		     status_completed_equivalent_id,
		     [0, status_ignored_ids, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  alq,
		                                  0,
		                                  0,
		                                  0,
		                                  "completedStatusPropertyId",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   alp,
		                                   0,
		                                   0,
		                                   0,
		                                   "activeStatusPropertyId",
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    alo,
		                                    0,
		                                    0,
		                                    0,
		                                    "completedStatusPropertyEquivalentIds",
		                                    0,
		                                    [0, default$0],
		                                    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     aln,
		                                     0,
		                                     0,
		                                     0,
		                                     "ignoredStatusPropertyEquivalentIds",
		                                     0,
		                                     [0, default$],
		                                     [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$533[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$533[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$507 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bMD, [0, schematic_cache$507]);
		               var schematic_cache$508 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNN, [0, schematic_cache$508]);
		               var schematic_cache$509 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNO, [0, schematic_cache$509]);
		               var schematic_cache$510 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNR, [0, schematic_cache$510]);
		               var schematic_cache$511 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$533, [0, schematic_cache$511]);
		               caml_callback
		                (select_option_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (group_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_option_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (select_option_mapping_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_option_mapping_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               function pp_status
		               (poly_select, poly_status, poly_checkbox, fmt, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var aoptions = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            alr,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      als,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_options,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (poly_select,
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aoptions,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      alt,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), alu, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var astatus = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            alv,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      alw,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_status,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (poly_status,
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            astatus,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      alx,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), aly, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var acheckbox = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            alz,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      alA,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_checkbox,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (poly_checkbox,
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            acheckbox,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      alB,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), alC, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               var
		                cst_Integrations_notion_Column =
		                  "Integrations_notion.Column.option_id",
		                bQb = [];
		               function pp_select_option(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         alD,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alE,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_Integrations_notion_Column,
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bQb[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alF,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     alG,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               alH,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_name,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alI,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               alJ,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), alK, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_group_id(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Integrations_notion.Column.Todo",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Integrations_notion.Column.In_progress",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Integrations_notion.Column.Completed",
		                            cont);
		                }
		               }
		               var bPM = [];
		               function pp_status_option(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         alL,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alM,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_Integrations_notion_Column,
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bPM[2],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alN,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     alO,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               alP,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         "group_id",
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (bPM[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               alQ,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         alR,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alS,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_name,
		     function(b){
		      var a = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               alT,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alU,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), alV, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var bPg = [];
		               function pp_select_option_mapping(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         alW,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alX,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_notion.Column.completed_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bPg[4],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   alY,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     alZ,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               al0,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         "active_id",
		                         function(a){
		                          a = x[2];
		                          function b(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    al1,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      al2,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                al3,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          "completed_equivalent_ids",
		                          function(a){
		                           var x$0 = x[3];
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    al4,
		                                    function(b){
		                                     function a(accu, l$0){
		                                      if(! l$0)
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        al6,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  al7,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            al8,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      al9,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        "ignored_equivalent_ids",
		        function(a){
		         var x$0 = x[4];
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  al_,
		                  function(b){
		                   function a(accu, l$0){
		                    if(! l$0)
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              ama,
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (fprintf$0(fmt),
		amb,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (fprintf$0(fmt), amc, cont);
		});
		                              });
		                    var l = l$0[2], a$0 = l$0[1];
		                    function b(c){
		                     function b(b){return caml_exact_trampoline_call2(a, 1, l);}
		                     if(! a$0)
		                      return caml_exact_trampoline_cps_call$1
		                              (pp_print_string, fmt, cst_None, b);
		                     var x = a$0[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (pp_print_string,
		                              fmt,
		                              cst_Some,
		                              function(a){
		                               return caml_trampoline_cps_call2
		                                       (bPg[1],
		fmt,
		function(a){
		 return caml_trampoline_cps_call2
		         (a,
		          x,
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (pp_print_string, fmt, cst$18, b);
		          });
		});
		                              });
		                    }
		                    return accu
		                            ? caml_exact_trampoline_cps_call(fprintf$0(fmt), al$, b)
		                            : b();
		                   }
		                   return a(0, x$0);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      var l = l$0[2], a$0 = l$0[1];
		                                      function b(c){
		                                       function b(b){return caml_exact_trampoline_call2(a, 1, l);}
		                                       if(! a$0)
		return caml_exact_trampoline_cps_call$1
		        (pp_print_string, fmt, cst_None, b);
		                                       var x = a$0[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_print_string,
		        fmt,
		        cst_Some,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (bPg[2],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            x,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_print_string, fmt, cst$18, b);
		                            });
		                  });
		        });
		                                      }
		                                      return accu
		      ? caml_exact_trampoline_cps_call(fprintf$0(fmt), al5, b)
		      : b();
		                                     }
		                                     return a(0, x$0);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          if(! a)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_None, b);
		                          var x$0 = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   fmt,
		                                   cst_Some,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (bPg[3],
		     fmt,
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               x$0,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, cst$18, b);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$534 = [];
		               function pp_status_option_mapping(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         amd,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   ame,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_notion.Column.status_completed_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$534[4],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amf,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     amg,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               amh,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         "status_active_id",
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$534[3],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               ami,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         amj,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amk,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "status_completed_equivalent_ids",
		     function(a){
		      var x$0 = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aml,
		               function(b){
		                function a(accu, l$0){
		                 if(! l$0)
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           amn,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     amo,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       amp,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 amq,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (a,
		                           "status_ignored_ids",
		                           function(a){
		                            var x$0 = x[4];
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     amr,
		                                     function(b){
		                                      function a(accu, l$0){
		                                       if(! l$0)
		return caml_exact_trampoline_cps_call
		        (fprintf$0(fmt),
		         amt,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (fprintf$0(fmt),
		                   amu,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), amv, cont);
		                   });
		         });
		                                       var l = l$0[2], a$0 = l$0[1];
		                                       function b(b){
		return caml_trampoline_cps_call2
		        (letrec_function_context$534[1],
		         fmt,
		         function(b){
		          return caml_trampoline_cps_call2
		                  (b,
		                   a$0,
		                   function(b){return caml_exact_trampoline_call2(a, 1, l);});
		         });
		                                       }
		                                       return accu
		       ? caml_exact_trampoline_cps_call(fprintf$0(fmt), ams, b)
		       : b();
		                                      }
		                                      return a(0, x$0);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var l = l$0[2], a$0 = l$0[1];
		                 function b(b){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$534[2],
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a$0,
		                                     function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                           });
		                 }
		                 return accu
		                         ? caml_exact_trampoline_cps_call(fprintf$0(fmt), amm, b)
		                         : b();
		                }
		                return a(0, x$0);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(bQb, [0, pp$2]);
		               caml_update_dummy(bPM, [0, pp_group_id, pp$2]);
		               caml_update_dummy(bPg, [0, pp$2, pp$2, pp$2, pp$2]);
		               caml_update_dummy
		                (letrec_function_context$534, [0, pp$2, pp$2, pp$2, pp$2]);
		               var letrec_function_context$535 = [];
		               function equal_valued(poly_name, poly_value, lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$535[1],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(a){
		                           return a
		                                   ? caml_trampoline_cps_call3
		                                     (poly_value, lhs[3], rhs[3], cont)
		                                   : cont(a);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3(poly_name, lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy(letrec_function_context$535, [0, equal$4]);
		               var letrec_function_context$536 = [];
		               function compare_valued(poly_name, poly_value, lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$536[1],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (poly_name,
		                                     lhs[2],
		                                     rhs[2],
		                                     function(x){
		                                      return 0 === x
		      ? caml_trampoline_cps_call3
		        (poly_value, lhs[3], rhs[3], cont)
		      : cont(x);
		                                     })
		                                  : cont(x);
		                         });
		               }
		               caml_update_dummy(letrec_function_context$536, [0, compare$4]);
		               var letrec_function_context$537 = [];
		               function pp_valued(poly_name, poly_value, fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         amw,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amx,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_notion.Column.id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$537[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amy,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     amz,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               amA,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_name,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (poly_name,
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               amB,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         amC,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amD,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_value,
		     function(b){
		      var a = x[3];
		      return caml_trampoline_cps_call2
		              (poly_value,
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amE,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), amF, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$537, [0, pp$2]);
		               var letrec_function_context$538 = [];
		               function equal$209(x, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$538[1],
		                         function(a, b, cont){return cont(a === b ? 1 : 0);},
		                         function(a, param, cont){return cont(1);},
		                         function(a){return caml_trampoline_cps_call2(a, x, cont);});
		               }
		               caml_update_dummy
		                (letrec_function_context$538, [0, equal_valued]);
		               var letrec_function_context$539 = [];
		               function compare$123(x, cont){
		                function a(a, param, cont){return cont(0);}
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$539[2],
		                         0,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (letrec_function_context$539[1],
		                                   b,
		                                   a,
		                                   function(a){return caml_trampoline_cps_call2(a, x, cont);});
		                         });
		               }
		               function _0$41(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$539, [0, compare_valued, _0$41]);
		               function schema_versioned$311(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_trampoline_cps_call2
		                                  (schematic_version,
		                                   V$4,
		                                   function(schematic_schema_version){
		                                    return cont
		    ([0,
		      amG,
		      0,
		      [7,
		       function(param, cont){
		        var
		         a = param[2],
		         value = a[2][1],
		         name = a[1],
		         id = param[1];
		        return cont([0, id, name, value]);
		       },
		       function(param, cont){
		        var value = param[3], name = param[2], id = param[1];
		        return cont([0, id, [0, name, [0, value, 0]]]);
		       },
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_id,
		         0,
		         2,
		         [0, schema_versioned$58()],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_name,
		          0,
		          2,
		          [0, schematic_param_name_schema_ve],
		          0,
		          0],
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_value,
		           0,
		           2,
		           [2, schematic_param_a_schema_versi],
		           0,
		           0],
		          0]]]],
		      0]);
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$311,
		                 [function(param, cont){return cont();}]);
		               var letrec_function_context$540 = [];
		               function pp$99(fmt, cont){
		                return caml_trampoline_cps_call4
		                        (letrec_function_context$540[1],
		                         function(fmt, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt), amH, cont);
		                         },
		                         function(fmt, param, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, fmt, cst$17, cont);
		                         },
		                         fmt,
		                         cont);
		               }
		               caml_update_dummy(letrec_function_context$540, [0, pp_valued]);
		               var letrec_function_context$541 = [];
		               function equal_status$1(x, cont){
		                return caml_trampoline_cps_call4
		                        (letrec_function_context$541[2],
		                         function(x, y, cont){
		                          function a(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$541[5],
		                                      a$0,
		                                      b,
		                                      function(b){
		                                       return b
		       ? caml_exact_trampoline_call2(a, x$0, y$0)
		       : cont(b);
		                                      });
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return a(x, y);
		                         },
		                         function(x, y, cont){
		                          function a(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$541[4],
		                                      a$0,
		                                      b,
		                                      function(b){
		                                       return b
		       ? caml_exact_trampoline_call2(a, x$0, y$0)
		       : cont(b);
		                                      });
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return a(x, y);
		                         },
		                         letrec_function_context$541[3],
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (letrec_function_context$541[1],
		                                   function(a, b, cont){return cont(a === b ? 1 : 0);},
		                                   a,
		                                   function(a){return caml_trampoline_cps_call2(a, x, cont);});
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$541,
		                 [0,
		                  equal_valued,
		                  equal_status$0,
		                  equal_ignore,
		                  equal_status_option,
		                  equal_select_option]);
		               var letrec_function_context$542 = [];
		               function compare_status$0(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$542[3],
		                         0,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (letrec_function_context$542[2],
		                                   function(x, y, cont){
		                                    function a(x, y){
		                                     if(! x) return y ? cont(-1) : cont(0);
		                                     if(! y) return cont(1);
		                                     var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context$542[5],
		      a$0,
		      b,
		      function(x){
		       return 0 === x
		               ? caml_exact_trampoline_call2(a, x$0, y$0)
		               : cont(x);
		      });
		                                    }
		                                    return a(x, y);
		                                   },
		                                   function(x, y, cont){
		                                    function a(x, y){
		                                     if(! x) return y ? cont(-1) : cont(0);
		                                     if(! y) return cont(1);
		                                     var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context$542[4],
		      a$0,
		      b,
		      function(x){
		       return 0 === x
		               ? caml_exact_trampoline_call2(a, x$0, y$0)
		               : cont(x);
		      });
		                                    }
		                                    return a(x, y);
		                                   },
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$542[6],
		     0,
		     function(b){
		      return caml_trampoline_cps_call3
		              (letrec_function_context$542[1],
		               b,
		               a,
		               function(a){return caml_trampoline_cps_call2(a, x, cont);});
		     });
		                                   });
		                         });
		               }
		               function _3$11(b, a, param, cont){return cont(0);}
		               function _0$42(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$542,
		                 [0,
		                  compare_valued,
		                  compare_status,
		                  _3$11,
		                  compare_status_option,
		                  compare_select_option,
		                  _0$42]);
		               var letrec_function_context$543 = [];
		               function pp_status$0(fmt, cont){
		                return caml_trampoline_cps_call4
		                        (letrec_function_context$543[1],
		                         function(fmt, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt), amO, cont);
		                         },
		                         function(fmt, cont){
		                          return caml_trampoline_cps_call5
		                                  (letrec_function_context$543[2],
		                                   function(fmt, x, cont){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     amL,
		     function(b){
		      function a(accu, l$0){
		       if(! l$0)
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt), amN, cont);
		       var l = l$0[2], a$0 = l$0[1];
		       function b(b){
		        return caml_trampoline_cps_call2
		                (letrec_function_context$543[5],
		                 fmt,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (b,
		                           a$0,
		                           function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                 });
		       }
		       return accu
		               ? caml_exact_trampoline_cps_call(fprintf$0(fmt), amM, b)
		               : b();
		      }
		      return a(0, x);
		     });
		                                   },
		                                   function(fmt, x, cont){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     amI,
		     function(b){
		      function a(accu, l$0){
		       if(! l$0)
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt), amK, cont);
		       var l = l$0[2], a$0 = l$0[1];
		       function b(b){
		        return caml_trampoline_cps_call2
		                (letrec_function_context$543[4],
		                 fmt,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (b,
		                           a$0,
		                           function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                 });
		       }
		       return accu
		               ? caml_exact_trampoline_cps_call(fprintf$0(fmt), amJ, b)
		               : b();
		      }
		      return a(0, x);
		     });
		                                   },
		                                   function(fmt, cont){
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$543[3], fmt, cont);
		                                   },
		                                   fmt,
		                                   cont);
		                         },
		                         fmt,
		                         cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$543,
		                 [0,
		                  pp_valued,
		                  pp_status,
		                  pp_ignore,
		                  pp_status_option,
		                  pp_select_option]);
		               var letrec_function_context$544 = [];
		               function equal_status_mapping$0(x, cont){
		                return caml_trampoline_cps_call4
		                        (letrec_function_context$544[2],
		                         letrec_function_context$544[5],
		                         letrec_function_context$544[4],
		                         letrec_function_context$544[3],
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (letrec_function_context$544[1],
		                                   function(a, b, cont){return cont(a === b ? 1 : 0);},
		                                   a,
		                                   function(a){return caml_trampoline_cps_call2(a, x, cont);});
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$544,
		                 [0,
		                  equal_valued,
		                  equal_status$0,
		                  equal_ignore,
		                  equal_status_option_mapping,
		                  equal_select_option_mapping]);
		               var letrec_function_context$545 = [];
		               function compare_status_mapping(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$545[3],
		                         0,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (letrec_function_context$545[2],
		                                   letrec_function_context$545[5],
		                                   letrec_function_context$545[4],
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$545[6],
		     0,
		     function(b){
		      return caml_trampoline_cps_call3
		              (letrec_function_context$545[1],
		               b,
		               a,
		               function(a){return caml_trampoline_cps_call2(a, x, cont);});
		     });
		                                   });
		                         });
		               }
		               function _3$12(b, a, param, cont){return cont(0);}
		               function _0$43(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$545,
		                 [0,
		                  compare_valued,
		                  compare_status,
		                  _3$12,
		                  compare_status_option_mapping,
		                  compare_select_option_mapping,
		                  _0$43]);
		               var letrec_function_context$546 = [];
		               function pp_status_mapping(fmt, cont){
		                return caml_trampoline_cps_call4
		                        (letrec_function_context$546[1],
		                         function(fmt, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt), amP, cont);
		                         },
		                         function(fmt, cont){
		                          return caml_trampoline_cps_call5
		                                  (letrec_function_context$546[2],
		                                   function(fmt, cont){
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$546[5], fmt, cont);
		                                   },
		                                   function(fmt, cont){
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$546[4], fmt, cont);
		                                   },
		                                   function(fmt, cont){
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$546[3], fmt, cont);
		                                   },
		                                   fmt,
		                                   cont);
		                         },
		                         fmt,
		                         cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$546,
		                 [0,
		                  pp_valued,
		                  pp_status,
		                  pp_ignore,
		                  pp_status_option_mapping,
		                  pp_select_option_mapping]);
		               var
		                cst_statusColumnId = "statusColumnId",
		                letrec_function_context$547 = [];
		               function status_mapping_schema_versione$2
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$547[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$547[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$547[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$547[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_option_mapping_schema_v,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (select_option_mapping_schema_v,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (status_schema_versioned$6,
		                 schematic_version,
		                 function(c){
		                  c =
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     cst_value,
		                     0,
		                     2,
		                     [1, c(b, a, ignore_schema)],
		                     0,
		                     0],
		                    0];
		                  var
		                   default$ = match$189[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        value = a[2][1],
		                        name = a[1],
		                        status_mapping_id = param[1];
		                       return cont([0, status_mapping_id, name, value]);
		                      },
		                      function(param, cont){
		                       var
		                        value = param[3],
		                        name = param[2],
		                        status_mapping_id = param[1];
		                       return cont
		                               ([0, status_mapping_id, [0, name, [0, value, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_statusColumnId,
		                        0,
		                        2,
		                        [0, schema_versioned$58()],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_name,
		                         0,
		                         [0, default$],
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        c]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$547[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$547[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$512 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$547, [0, schematic_cache$512]);
		               caml_callback
		                (status_mapping_schema_versione$2,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$548 = [];
		               function status_schema_versioned$7(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$548[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$548[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$548[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$548[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_option_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var a = [0, 0, 0, [3, b], 0];
		                                      return caml_exact_trampoline_cps_call
		      (select_option_schema_versioned,
		       schematic_version,
		       function(c){
		        var b = [0, 0, 0, [3, c], 0];
		        return caml_exact_trampoline_cps_call
		                (status_schema_versioned$6,
		                 schematic_version,
		                 function(c){
		                  c =
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     "statusColumnName",
		                     0,
		                     2,
		                     [0, schematic_param_name_schema_ve],
		                     0,
		                     0],
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_value,
		                      0,
		                      2,
		                      [1, c(b, a, ignore_schema)],
		                      0,
		                      0],
		                     0]];
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        value = a[2][1],
		                        name = a[1],
		                        status_id = param[1];
		                       return cont([0, status_id, name, value]);
		                      },
		                      function(param, cont){
		                       var value = param[3], name = param[2], status_id = param[1];
		                       return cont([0, status_id, [0, name, [0, value, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_statusColumnId,
		                        0,
		                        2,
		                        [0, schema_versioned$58()],
		                        0,
		                        0],
		                       c]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$548[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$548[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$513 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$548, [0, schematic_cache$513]);
		               caml_callback
		                (status_schema_versioned$7,
		                 [function(param, cont){return cont(0);}]);
		               function status_schema_versioned$8(v, cont){
		                function decode(param, cont){
		                 var value = param[3], name = param[2], id = param[1];
		                 return cont([0, [0, id, name, value]]);
		                }
		                function encode(param, cont){
		                 var value = param[3], name = param[2], id = param[1];
		                 return cont([0, id, name, value]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (status_schema_versioned$7,
		                         v,
		                         function(serialization){
		                          var descriptor = [4, decode, encode, serialization[3]];
		                          return cont([0, id$27, 0, descriptor, 0]);
		                         });
		               }
		               function status_mapping_schema_versione$3(v, cont){
		                function decode(param, cont){
		                 var value = param[3], name = param[2], id = param[1];
		                 return cont([0, [0, id, name, value]]);
		                }
		                function encode(param, cont){
		                 var value = param[3], name = param[2], id = param[1];
		                 return cont([0, id, name, value]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (status_mapping_schema_versione$2,
		                         v,
		                         function(serialization){
		                          var descriptor = [4, decode, encode, serialization[3]];
		                          return cont([0, id$28, 0, descriptor, 0]);
		                         });
		               }
		               var
		                Id$9 =
		                  caml_callback(Make$12, [[0, "integration-import", cst$21]]),
		                schematic_cache$514 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$549 = [];
		               caml_update_dummy
		                (letrec_function_context$549, [0, schematic_cache$514]);
		               var schematic_schema_version$106 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$549[1][1],
		                    schematic_schema_version$106]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$549[1][1],
		                             schematic_schema_version$106,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$549[1][1],
		schematic_schema_version$106,
		schematic_self,
		function(a){
		 letrec_function_context$549[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var status_name = param[2][1], status_id = param[1];
		      return cont([0, status_id, status_name]);
		     },
		     function(param, cont){
		      var status_name = param[2], status_id = param[1];
		      return cont([0, status_id, [0, status_name, 0]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "status_id",
		       0,
		       2,
		       [0, schema_versioned$58()],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "status_name",
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       0]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$549[1][1],
		          schematic_schema_version$106,
		          res,
		          function(a){
		           letrec_function_context$549[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$550 = [];
		               function equal$210(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$550[5],
		                         lhs[1],
		                         rhs[1],
		                         function(d){
		                          function c(d){
		                           function c(b){
		                            function a(c){
		                             if(c) var b = rhs[5], a = lhs[5], c = a === b ? 1 : 0;
		                             function d(c){
		                              if(! c) return cont(c);
		                              var y = rhs[7], x = lhs[7];
		                              if(x){
		                               if(y){var b = y[1], a = x[1]; return cont(a === b ? 1 : 0);}
		                              }
		                              else if(! y) return cont(1);
		                              return cont(0);
		                             }
		                             return c
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$550[1], lhs[6], rhs[6], d)
		                                     : d(c);
		                            }
		                            return b
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$550[2], lhs[4], rhs[4], a)
		                                    : a(b);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$550[3], a, b, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          if(! d) return c(d);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3
		                                    (letrec_function_context$550[4], a, b, c);
		                           }
		                          }
		                          else if(! y) return c(1);
		                          return c(0);
		                         });
		               }
		               var _0$44 = Id$9[15];
		               caml_update_dummy
		                (letrec_function_context$550,
		                 [0, equal_status_mapping$0, _3$4, _2$5, equal$4, _0$44]);
		               var ck = [];
		               function compare$124(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (ck[7],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          if(0 !== x) return cont(x);
		                          var y = rhs[2], x$0 = lhs[2];
		                          function c(x){
		                           if(0 !== x) return cont(x);
		                           var y = rhs[3], x$0 = lhs[3];
		                           function c(x){
		                            return 0 === x
		                                    ? caml_trampoline_cps_call3
		                                      (ck[4],
		                                       lhs[4],
		                                       rhs[4],
		                                       function(x){
		if(0 !== x) return cont(x);
		var a = rhs[5], b = lhs[5];
		return caml_trampoline_cps_call2
		        (ck[3],
		         0,
		         function(c){
		          return caml_trampoline_cps_call3
		                  (c,
		                   b,
		                   a,
		                   function(x){
		                    return 0 === x
		                            ? caml_trampoline_cps_call3
		                              (ck[2],
		                               lhs[6],
		                               rhs[6],
		                               function(x){
		                                if(0 !== x) return cont(x);
		                                var y = rhs[7], x$0 = lhs[7];
		                                if(! x$0) return y ? cont(-1) : cont(0);
		                                var a = x$0[1];
		                                if(! y) return cont(1);
		                                var b = y[1];
		                                return caml_trampoline_cps_call2
		(ck[1],
		 0,
		 function(c){
		  return caml_trampoline_cps_call3(c, a, b, cont);
		 });
		                               })
		                            : cont(x);
		                   });
		         });
		                                       })
		                                    : cont(x);
		                           }
		                           if(! x$0) return y ? c(-1) : c(0);
		                           var a = x$0[1];
		                           if(! y) return c(1);
		                           var b = y[1];
		                           return caml_trampoline_cps_call3(ck[5], a, b, c);
		                          }
		                          if(! x$0) return y ? c(-1) : c(0);
		                          var a = x$0[1];
		                          if(! y) return c(1);
		                          var b = y[1];
		                          return caml_trampoline_cps_call3(ck[6], a, b, c);
		                         });
		               }
		               function _6$3(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _4$5(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               var _0$45 = Id$9[16];
		               caml_update_dummy
		                (ck,
		                 [0,
		                  _6$3,
		                  compare_status_mapping,
		                  _4$5,
		                  _3$3,
		                  _2$4,
		                  compare$4,
		                  _0$45]);
		               var
		                cst_assigneeId = "assigneeId",
		                cst_status_column_mapping = "status_column_mapping",
		                bNS = [];
		               function schema_versioned$312(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNS[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, amQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNS[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNS[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bNS[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "scheduleColumnId",
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (status_mapping_schema_versione$3,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$190[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "databaseName",
		   0,
		   [0, default$],
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_status_column_mapping,
		    0,
		    2,
		    [1, c],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call
		      (du,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0, [0, 0, 0, 0, 0, "databaseId", 0, 2, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (bPa,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       "assigneeColumnId",
		                       0,
		                       3,
		                       [0, schema_versioned$58()],
		                       0,
		                       0],
		                      [0, [0, 0, 0, 0, 0, cst_assigneeId, 0, 3, [0, c], 0, 0], a]];
		                  return caml_exact_trampoline_cps_call
		                          (Id$9[4],
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  schedule_column_id = e[2][1],
		                                  status_column_mapping = e[1],
		                                  database_name = d[1],
		                                  database_id = c[1],
		                                  assignee = b[1],
		                                  assignee_column_id = a[1],
		                                  id = param[1];
		                                 return cont
		 ([0,
		   id,
		   assignee_column_id,
		   assignee,
		   database_id,
		   database_name,
		   status_column_mapping,
		   schedule_column_id]);
		                                },
		                                function(param, cont){
		                                 var
		                                  schedule_column_id = param[7],
		                                  status_column_mapping = param[6],
		                                  database_name = param[5],
		                                  database_id = param[4],
		                                  assignee = param[3],
		                                  assignee_column_id = param[2],
		                                  id = param[1];
		                                 return cont
		 ([0,
		   id,
		   [0,
		    assignee_column_id,
		    [0,
		     assignee,
		     [0,
		      database_id,
		      [0,
		       database_name,
		       [0, status_column_mapping, [0, schedule_column_id, 0]]]]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bNS[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bNS[1][1] = a; return cont(res);});
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$515 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNS, [0, schematic_cache$515]);
		               var
		                schematic_cache$516 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$551 = [];
		               caml_update_dummy
		                (letrec_function_context$551, [0, schematic_cache$516]);
		               caml_callback
		                (schema_versioned$312,
		                 [function(param, cont){return cont(0);}]);
		               var schematic_schema_version$16 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$551[1][1],
		                    schematic_schema_version$16]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$551[1][1],
		                             schematic_schema_version$16,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$551[1][1],
		schematic_schema_version$16,
		schematic_self,
		function(a){
		 letrec_function_context$551[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var count = param[1];
		      return cont([0, count]);
		     },
		     function(param, cont){
		      var count = param[1];
		      return cont([0, count, 0]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_count, 0, 2, [0, int_schema], 0, 0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$551[1][1],
		          schematic_schema_version$16,
		          res,
		          function(a){
		           letrec_function_context$551[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_assignee = "assignee",
		                cst_database_name = "database_name",
		                letrec_function_context$552 = [];
		               function pp$100(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         amR,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amS,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_notion.Import.id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$552[5],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   amT,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     amU,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               amV,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         "assignee_column_id",
		                         function(a){
		                          a = x[2];
		                          function b(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    amW,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      amX,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                amY,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_assignee,
		                          function(a){
		                           a = x[3];
		                           function b(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     amZ,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       am0,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 am1,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (a,
		                           cst_database_id,
		                           function(b){
		                            var a = x[4];
		                            return caml_trampoline_cps_call2
		                                    (letrec_function_context$552[2],
		                                     fmt,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 am2,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           am3,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     am4,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a,
		       cst_database_name,
		       function(b){
		        var a = x[5];
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 am5,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (b,
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     am6,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       am7,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 am8,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (a,
		                           cst_status_column_mapping,
		                           function(b){
		                            var a = x[6];
		                            return caml_trampoline_cps_call2
		                                    (letrec_function_context$552[1],
		                                     fmt,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 am9,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           am_,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     am$,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a,
		       "schedule_column_id",
		       function(a){
		        a = x[7];
		        function b(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  anb,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), anc, cont);
		                  });
		        }
		        if(! a)
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string, fmt, cst_None, b);
		        var x$0 = a[1];
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string,
		                 fmt,
		                 cst_Some,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           ana,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     x$0,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, fmt, cst$18, b);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           if(! a)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, b);
		                           var x$0 = a[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context$552[3],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x$0,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, b);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          if(! a)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_None, b);
		                          var x$0 = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   fmt,
		                                   cst_Some,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (letrec_function_context$552[4],
		     fmt,
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               x$0,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, cst$18, b);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var _0$46 = Id$9[1];
		               caml_update_dummy
		                (letrec_function_context$552,
		                 [0, pp_status_mapping, _3$2, _2$3, pp$2, _0$46]);
		               var
		                include$93 =
		                  caml_callback
		                   (M_printable, [[0, Id$9[1], Id$9[24], Id$9[4]]]),
		                equal$211 = include$93[55],
		                pp$101 = include$93[128];
		               function map_to_list_schema_versioned
		               (get_key, comparator, name, id_pp, list_schema, version){
		                return map$14
		                        (function(l, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (of_list_with_key$1,
		                                   comparator,
		                                   l,
		                                   get_key,
		                                   function(param){
		                                    var variant = param[1];
		                                    if(17724 <= variant){
		                                     var map = param[2];
		                                     return cont([0, map]);
		                                    }
		                                    var id$0 = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$107,
		     function(a){
		      return caml_trampoline_cps_call4
		              (a, name, id_pp, id$0, function(x){return cont([1, x]);});
		     });
		                                   });
		                         },
		                         encode,
		                         list_schema);
		               }
		               function schematic_version$69(param, cont){return cont(0);}
		               var
		                bRk =
		                  [0,
		                   0,
		                   0,
		                   [3,
		                    caml_callback(schema_versioned$312, [schematic_version$69])]],
		                letrec_function_context$553 = [];
		               function equal_people(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(b){
		                 function a(c){
		                  if(c) var b = rhs[3], a = lhs[3], c = a === b ? 1 : 0;
		                  if(! c) return cont(c);
		                  var b$0 = rhs[4], a$0 = lhs[4];
		                  return cont(a$0 === b$0 ? 1 : 0);
		                 }
		                 return b
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$553[1], lhs[2], rhs[2], a)
		                         : a(b);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$553[2], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               var bRl = Id$9[1], bRm = [0, Id$9[24]];
		               caml_update_dummy
		                (letrec_function_context$553, [0, _2$5, equal$44]);
		               var letrec_function_context$554 = [];
		               function compare_people(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(x){
		                 return 0 === x
		                         ? caml_trampoline_cps_call3
		                           (letrec_function_context$554[3],
		                            lhs[2],
		                            rhs[2],
		                            function(x){
		                             if(0 !== x) return cont(x);
		                             var a = rhs[3], b = lhs[3];
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$554[2],
		                                      0,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (c,
		        b,
		        a,
		        function(x){
		         if(0 !== x) return cont(x);
		         var a = rhs[4], b = lhs[4];
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$554[1],
		                  0,
		                  function(c){
		                   return caml_trampoline_cps_call3(c, b, a, cont);
		                  });
		        });
		                                      });
		                            })
		                         : cont(x);
		                }
		                if(! x) return y ? c(-1) : c(0);
		                var a = x[1];
		                if(! y) return c(1);
		                var b = y[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$554[4], a, b, c);
		               }
		               function _3$13(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               function _2$24(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$554,
		                 [0, _3$13, _2$24, _2$4, compare$51]);
		               var letrec_function_context$555 = [];
		               function people_schema_versioned$1(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$555[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, and, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$555[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$555[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$555[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_email,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (bPa,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    email = b[2][1],
		    name = b[1],
		    id = a[1],
		    avatar_url = param[1];
		   return cont([0, avatar_url, id, name, email]);
		  },
		  function(param, cont){
		   var
		    email = param[4],
		    name = param[3],
		    id = param[2],
		    avatar_url = param[1];
		   return cont
		           ([0, avatar_url, [0, id, [0, name, [0, email, 0]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_avatar_url, 0, 3, [0, schema$262], 0, 0],
		   [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$555[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$555[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$517 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$555, [0, schematic_cache$517]);
		               caml_callback
		                (people_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$556 = [];
		               function pp_people(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         ane,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   anf,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_notion.avatar_url",
		     function(a){
		      a = x[1];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ang,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          anh,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ani,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_id,
		      function(b){
		       var a = x[2];
		       return caml_trampoline_cps_call2
		               (letrec_function_context$556[1],
		                fmt,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    anj,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ank,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                anl,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_name,
		                          function(b){
		                           var a = x[3];
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    anm,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ann,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ano,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    anp,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_email,
		      function(b){
		       var a = x[4];
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                anq,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    anr,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), ans, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(! a)
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst_None, b);
		      var x$0 = a[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst_Some,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$556[2],
		                         fmt,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, fmt, cst$18, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$556, [0, _2$3, pp$27]);
		               function schematic_version$70(param, cont){return cont(0);}
		               var letrec_function_context$557 = [];
		               function equal_database(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$557[3],
		                         lhs[1],
		                         rhs[1],
		                         function(d){
		                          if(d) var b = rhs[2], a = lhs[2], d = a === b ? 1 : 0;
		                          function c(b){
		                           if(! b) return cont(b);
		                           var y = rhs[4], x = lhs[4];
		                           function a(x, y){
		                            if(x){
		                             if(y){
		                              var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                              return caml_trampoline_cps_call3
		                                      (letrec_function_context$557[1],
		                                       a$0,
		                                       b,
		                                       function(b){
		return b
		        ? caml_exact_trampoline_call2(a, x$0, y$0)
		        : cont(b);
		                                       });
		                             }
		                            }
		                            else if(! y) return cont(1);
		                            return cont(0);
		                           }
		                           return a(x, y);
		                          }
		                          if(! d) return c(d);
		                          var y = rhs[3], x = lhs[3];
		                          function e(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$557[2],
		                                      a,
		                                      b,
		                                      function(a){
		                                       return a ? caml_exact_trampoline_call2(e, x$0, y$0) : c(a);
		                                      });
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          return e(x, y);
		                         });
		               }
		               var
		                bRo =
		                  [0,
		                   0,
		                   0,
		                   [3,
		                    caml_callback
		                     (people_schema_versioned$1, [schematic_version$70])]];
		               caml_update_dummy
		                (letrec_function_context$557,
		                 [0, equal_status$1, equal$209, _3$4]);
		               var letrec_function_context$558 = [];
		               function compare_database(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$558[4],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          if(0 !== x) return cont(x);
		                          var a = rhs[2], b = lhs[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$558[3],
		                                   0,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (c,
		     b,
		     a,
		     function(x){
		      if(0 !== x) return cont(x);
		      var y = rhs[3], x$0 = lhs[3];
		      function a(x, y){
		       function c(x){
		        if(0 !== x) return cont(x);
		        var y = rhs[4], x$0 = lhs[4];
		        function a(x, y){
		         if(! x) return y ? cont(-1) : cont(0);
		         if(! y) return cont(1);
		         var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		         return caml_trampoline_cps_call3
		                 (letrec_function_context$558[1],
		                  a$0,
		                  b,
		                  function(x){
		                   return 0 === x
		                           ? caml_exact_trampoline_call2(a, x$0, y$0)
		                           : cont(x);
		                  });
		        }
		        return a(x$0, y);
		       }
		       if(! x) return y ? c(-1) : c(0);
		       if(! y) return c(1);
		       var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		       return caml_trampoline_cps_call3
		               (letrec_function_context$558[2],
		                a$0,
		                b,
		                function(x){
		                 return 0 === x
		                         ? caml_exact_trampoline_call2(a, x$0, y$0)
		                         : c(x);
		                });
		      }
		      return a(x$0, y);
		     });
		                                   });
		                         });
		               }
		               function _1$49(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$558,
		                 [0, compare_status$0, compare$123, _1$49, _3$3]);
		               var letrec_function_context$559 = [];
		               function database_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$559[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ant, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$559[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$559[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$559[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (status_schema_versioned$8,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "statusColumns",
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$311,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_title,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "peopleColumns",
		              0,
		              2,
		              [0, [0, 0, 0, [3, c], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call
		                (du,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        status_columns = b[2][1],
		                        people_columns = b[1],
		                        title = a[1],
		                        id = param[1];
		                       return cont([0, id, title, people_columns, status_columns]);
		                      },
		                      function(param, cont){
		                       var
		                        status_columns = param[4],
		                        people_columns = param[3],
		                        title = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0, title, [0, people_columns, [0, status_columns, 0]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$559[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$559[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$518 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$559, [0, schematic_cache$518]);
		               caml_callback
		                (database_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$560 = [];
		               function pp_database(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         anu,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   anv,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_notion.id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$560[3],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   anw,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     anx,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               any,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_title,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   anz,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               anA,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         anB,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   anC,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "people_columns",
		     function(a){
		      var x$0 = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               anD,
		               function(b){
		                function a(accu, l$0){
		                 if(! l$0)
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           anF,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     anG,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       anH,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 anI,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (a,
		                           "status_columns",
		                           function(a){
		                            var x$0 = x[4];
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     anJ,
		                                     function(b){
		                                      function a(accu, l$0){
		                                       if(! l$0)
		return caml_exact_trampoline_cps_call
		        (fprintf$0(fmt),
		         anL,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (fprintf$0(fmt),
		                   anM,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt), anN, cont);
		                   });
		         });
		                                       var l = l$0[2], a$0 = l$0[1];
		                                       function b(b){
		return caml_trampoline_cps_call2
		        (letrec_function_context$560[1],
		         fmt,
		         function(b){
		          return caml_trampoline_cps_call2
		                  (b,
		                   a$0,
		                   function(b){return caml_exact_trampoline_call2(a, 1, l);});
		         });
		                                       }
		                                       return accu
		       ? caml_exact_trampoline_cps_call(fprintf$0(fmt), anK, b)
		       : b();
		                                      }
		                                      return a(0, x$0);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var l = l$0[2], a$0 = l$0[1];
		                 function b(b){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$560[2],
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a$0,
		                                     function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                           });
		                 }
		                 return accu
		                         ? caml_exact_trampoline_cps_call(fprintf$0(fmt), anE, b)
		                         : b();
		                }
		                return a(0, x$0);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$560, [0, pp_status$0, pp$99, _3$2]);
		               function schematic_version$71(param, cont){return cont(0);}
		               var letrec_function_context$561 = [];
		               function equal$212(poly_status_error, lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(c){
		                 if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                 function d(b){
		                  function a(b){
		                   function a(a){
		                    if(! a) return cont(a);
		                    var b = rhs[6], c = lhs[6];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context$561[1],
		                             poly_status_error,
		                             function(a){
		                              return caml_trampoline_cps_call3(a, c, b, cont);
		                             });
		                   }
		                   if(! b) return a(b);
		                   var c = rhs[5], d = lhs[5];
		                   return caml_trampoline_cps_call2
		                           (letrec_function_context$561[2],
		                            letrec_function_context$561[3],
		                            function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                  }
		                  if(! b) return a(b);
		                  var c = rhs[4], d = lhs[4];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$561[4],
		                           letrec_function_context$561[5],
		                           function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                 }
		                 if(! c) return d(c);
		                 var e = rhs[3], f = lhs[3];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context$561[6],
		                          letrec_function_context$561[7],
		                          function(a){return caml_trampoline_cps_call3(a, f, e, d);});
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$561[8], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               var
		                bRr =
		                  [0,
		                   0,
		                   0,
		                   [3,
		                    caml_callback
		                     (database_schema_versioned, [schematic_version$71])]];
		               caml_update_dummy
		                (letrec_function_context$561,
		                 [0,
		                  equal$102,
		                  equal$208,
		                  equal_database,
		                  equal$207,
		                  equal_people,
		                  equal$211,
		                  equal$210,
		                  equal$0]);
		               var letrec_function_context$562 = [];
		               function pp$102(poly_status_error, fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         anO,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   anP,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Integrations_notion.Config.self",
		     function(a){
		      a = x[1];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                anQ,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          anR,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    anS,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_secret,
		      function(b){
		       var a = x[2];
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                anT,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    anU,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      anV,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                anW,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_imports,
		                          function(b){
		                           var a = x[3];
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context$562[6],
		                                    function(fmt, cont){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context$562[7], fmt, cont);
		                                    },
		                                    fmt,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                anX,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          anY,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    anZ,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_people,
		      function(b){
		       var a = x[4];
		       return caml_trampoline_cps_call3
		               (letrec_function_context$562[4],
		                function(fmt, cont){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context$562[5], fmt, cont);
		                },
		                fmt,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    an0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      an1,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                an2,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_databases,
		                          function(b){
		                           var a = x[5];
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context$562[2],
		                                    function(fmt, cont){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context$562[3], fmt, cont);
		                                    },
		                                    fmt,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                an3,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          an4,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    an5,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_status,
		      function(b){
		       var a = x[6];
		       return caml_trampoline_cps_call3
		               (letrec_function_context$562[1],
		                function(fmt, cont){
		                 return caml_trampoline_cps_call2
		                         (poly_status_error, fmt, cont);
		                },
		                fmt,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    an6,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), an7, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(! a)
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst_None, b);
		      var x$0 = a[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst_Some,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$562[8],
		                         fmt,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, fmt, cst$18, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$562,
		                 [0,
		                  pp$67,
		                  pp$98,
		                  pp_database,
		                  pp$97,
		                  pp_people,
		                  pp$101,
		                  pp$100,
		                  pp$28]);
		               function bRn(import$, cont){return cont(import$[1]);}
		               function bRq(people, cont){return cont(people[2]);}
		               function bRt(database, cont){return cont(database[1]);}
		               var
		                cst_status_error = "status_error",
		                bRp = [0, e],
		                bRs = [0, b2];
		               function schema_versioned$313
		               (schematic_version, schematic_param_status_error_s, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          function descriptor(schematic_param_status_error_s, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$176,
		                                    schematic_version,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (a,
		      schematic_param_status_error_s,
		      function(a){
		       a =
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_databases,
		          0,
		          2,
		          [0,
		           map_to_list_schema_versioned
		            (bRt, bRs, cst_Database, _3$2, bRr)],
		          0,
		          0],
		         [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, a], 0, 0], 0]];
		       a =
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_people,
		          0,
		          2,
		          [0,
		           map_to_list_schema_versioned
		            (bRq, bRp, cst_People, _2$3, bRo)],
		          0,
		          0],
		         a];
		       var
		        b =
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_secret,
		            0,
		            2,
		            [0, schematic_param_name_schema_ve],
		            0,
		            0],
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_imports,
		             0,
		             2,
		             [0,
		              map_to_list_schema_versioned
		               (bRn, bRm, "Import", bRl, bRk)],
		             0,
		             0],
		            a]];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$55,
		                schematic_version,
		                function(a){
		                 return cont
		                         ([7,
		                           function(param, cont){
		                            var
		                             a = param[2],
		                             b = a[2],
		                             c = b[2],
		                             d = c[2],
		                             status = d[2][1],
		                             databases = d[1],
		                             people = c[1],
		                             imports = b[1],
		                             secret = a[1],
		                             self = param[1];
		                            return cont
		                                    ([0, self, secret, imports, people, databases, status]);
		                           },
		                           function(param, cont){
		                            var
		                             status = param[6],
		                             databases = param[5],
		                             people = param[4],
		                             imports = param[3],
		                             secret = param[2],
		                             self = param[1];
		                            return cont
		                                    ([0,
		                                      self,
		                                      [0,
		                                       secret,
		                                       [0, imports, [0, people, [0, databases, [0, status, 0]]]]]]);
		                           },
		                           [0, [0, 0, 0, 0, 0, cst_self, 0, 3, [0, a], 0, 0], b]]);
		                });
		      });
		                                    });
		                          }
		                          var
		                           schematic_schema_id = match$191[1],
		                           parametric =
		                             [1,
		                              cst_status_error,
		                              schematic_param_status_error_s,
		                              function(schematic_param_status_error_s, cont){
		                               return caml_exact_trampoline_cps_call
		                                       (descriptor,
		schematic_param_status_error_s,
		function(a){return cont([0, schematic_schema_id, a]);});
		                              }];
		                          return caml_exact_trampoline_cps_call
		                                  (descriptor,
		                                   schematic_param_status_error_s,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       function f(param){
		        if(0 === param[0]){
		         var descriptor = param[2];
		         return [0, cst_notion_config, descriptor];
		        }
		        var next = param[3], parameter = param[2], name = param[1];
		        function next$0(s, cont){
		         return caml_trampoline_cps_call2
		                 (next, s, function(a){return cont(f(a));});
		        }
		        return [1, name, parameter, next$0];
		       }
		       var parametric$0 = [0, f(parametric)];
		       return cont([0, b, 0, a, parametric$0]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$563 = [];
		               function schema_versioned$314(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$563[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, an8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$563[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$563[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$563[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aoa);},
		                                  0,
		                                  0,
		                                  cst_google,
		                                  cst_Google,
		                                  an$,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(an_) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_notion,
		                                   cst_Notion,
		                                   an9,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$563[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$563[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$519 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$563, [0, schematic_cache$519]);
		               caml_callback
		                (schema_versioned$314,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$564 = [];
		               function _14(poly_status_error, fmt, param, cont){
		                if(0 === param[0]){
		                 var a0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aob,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$564[2],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      a0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), aoc, cont);
		      });
		                                    });
		                          });
		                }
		                var a0$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         aod,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (letrec_function_context$564[1],
		                                   function(fmt, cont){
		                                    return caml_trampoline_cps_call2
		    (poly_status_error, fmt, cont);
		                                   },
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0$0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), aoe, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$564, [0, pp$102, pp$96]);
		               function schema_versioned$315(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_status_error_s, cont){
		                                    function descriptor(schematic_param_status_error_s, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (schema_versioned$313,
		      schematic_version,
		      schematic_param_status_error_s,
		      function(b){
		       var
		        a =
		          [0,
		           [0,
		            function(f0, cont){return cont([1, f0]);},
		            function(param, cont){
		             if(0 === param[0]) return cont(0);
		             var f0 = param[1];
		             return cont([0, f0]);
		            },
		            0,
		            0,
		            cst_notion,
		            cst_Notion,
		            b,
		            0],
		           0];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$310,
		                schematic_version,
		                function(b){
		                 return cont
		                         ([11,
		                           aof,
		                           [0,
		                            [0,
		                             function(f0, cont){return cont([0, f0]);},
		                             function(param, cont){
		                              if(0 !== param[0]) return cont(0);
		                              var f0 = param[1];
		                              return cont([0, f0]);
		                             },
		                             0,
		                             0,
		                             cst_google,
		                             cst_Google,
		                             b,
		                             0],
		                            a],
		                           0]);
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$192[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_status_error,
		 schematic_param_status_error_s,
		 function(schematic_param_status_error_s, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_status_error_s,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_status_error_s,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function schema$130(schematic_param_status_error_s, cont){
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$315,
		                         function(param, cont){return cont(0);},
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (a, schematic_param_status_error_s, cont);
		                         });
		               }
		               function map_status(f, param, cont){
		                if(0 === param[0]){
		                 var config = param[1];
		                 return cont([0, config]);
		                }
		                var config$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         config$0[6],
		                         function(a){
		                          return cont
		                                  ([1,
		                                    [0,
		                                     config$0[1],
		                                     config$0[2],
		                                     config$0[3],
		                                     config$0[4],
		                                     config$0[5],
		                                     a]]);
		                         });
		               }
		               var
		                schematic_cache$520 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$565 = [];
		               caml_update_dummy
		                (letrec_function_context$565, [0, schematic_cache$520]);
		               var schematic_schema_version$17 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$565[1][1],
		                    schematic_schema_version$17]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$565[1][1],
		                             schematic_schema_version$17,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$565[1][1],
		schematic_schema_version$17,
		schematic_self,
		function(a){
		 letrec_function_context$565[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var invited_email = param[1];
		      return cont([0, invited_email]);
		     },
		     function(param, cont){
		      var invited_email = param[1];
		      return cont([0, invited_email, 0]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, "invited_email", 0, 2, [0, schema$72], 0, 0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$565[1][1],
		          schematic_schema_version$17,
		          res,
		          function(a){
		           letrec_function_context$565[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function client_id_of_channel(channel, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$0,
		                         channel,
		                         function(api){
		                          return caml_exact_trampoline_cps_call
		                                  (force,
		                                   api,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (with_path,
		     a,
		     "/.well-known/mcp-client.json",
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (to_string$25, 0, uri_of_uri(a), cont);
		     });
		                                   });
		                         });
		               }
		               var
		                stable_client_id = caml_callback(client_id_of_channel, [1]),
		                bleeding_client_id = caml_callback(client_id_of_channel, [0]);
		               function redirect_uri_of_port(port, cont){
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         aog,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, port, "/oauth/callback", cont);
		                         });
		               }
		               caml_callback(map$18, [redirect_ports, redirect_uri_of_port]);
		               function compare$125(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  case 2:
		                   if(2 === rhs) return cont(0); break;
		                  case 3:
		                   if(3 === rhs) return cont(0); break;
		                  case 4:
		                   if(4 === rhs) return cont(0); break;
		                  case 5:
		                   if(5 === rhs) return cont(0); break;
		                  case 6:
		                   if(6 === rhs) return cont(0); break;
		                  case 7:
		                   if(7 === rhs) return cont(0); break;
		                  case 8:
		                   if(8 === rhs) return cont(0); break;
		                  case 9:
		                   if(9 === rhs) return cont(0); break;
		                  default: if(10 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   case 5:
		                    return 5;
		                   case 6:
		                    return 6;
		                   case 7:
		                    return 7;
		                   case 8:
		                    return 8;
		                   case 9:
		                    return 9;
		                   default: return 10;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var cst_Inbox = "Inbox", letrec_function_context$566 = [];
		               function schema_versioned$316(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$566[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aoi, aoh, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$566[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$566[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$566[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(10);},
		                                 function(param, cont){
		                                  return 10 <= param ? cont(aok) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_task,
		                                 cst_Task,
		                                 aoj,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aom,
		                                     aol,
		                                     2,
		                                     0,
		                                     3,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){return cont(7);},
		   function(param, cont){
		    return 7 === param ? cont(aos) : cont(0);
		   },
		   0,
		   0,
		   cst_page,
		   cst_Page,
		   aor,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(8);},
		    function(param, cont){
		     return 8 === param ? cont(aoq) : cont(0);
		    },
		    0,
		    0,
		    cst_people,
		    cst_People,
		    aop,
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(9);},
		     function(param, cont){
		      return 9 === param ? cont(aoo) : cont(0);
		     },
		     0,
		     0,
		     cst_projects,
		     "Projects",
		     aon,
		     [0, [0, c, V$4]]],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aou,
		       aot,
		       2,
		       3,
		       3,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(param, cont){return cont(6);},
		             function(param, cont){
		              return 6 === param ? cont(aow) : cont(0);
		             },
		             0,
		             0,
		             cst_meetings,
		             cst_Meetings,
		             aov,
		             [0, [0, c, V$4]]],
		            b];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aoy,
		                 aox,
		                 0,
		                 25,
		                 7,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(2);},
		                       function(param, cont){
		                        return 2 === param ? cont(aoG) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_calendar,
		                       cst_Calendar,
		                       aoF,
		                       0],
		                      [0,
		                       [0,
		                        function(param, cont){return cont(3);},
		                        function(param, cont){
		                         return 3 === param ? cont(aoE) : cont(0);
		                        },
		                        0,
		                        0,
		                        cst_inbox,
		                        cst_Inbox,
		                        aoD,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(4);},
		                         function(param, cont){
		                          return 4 === param ? cont(aoC) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_journal,
		                         "Journal",
		                         aoB,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(5);},
		                          function(param, cont){
		                           return 5 === param ? cont(aoA) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_labels,
		                          "Labels",
		                          aoz,
		                          [0, [0, c, V$4]]],
		                         a]]]];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aoI,
		                           aoH,
		                           1,
		                           0,
		                           5,
		                           function(a){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aoM);},
		                                  0,
		                                  0,
		                                  cst_agenda,
		                                  "Agenda",
		                                  aoL,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aoK) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_assistant,
		                                   cst_Assistant,
		                                   aoJ,
		                                   [0, [0, a, V$4]]],
		                                  b]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$566[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$566[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$521 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$566, [0, schematic_cache$521]);
		               var
		                schema$131 =
		                  caml_callback
		                   (schema_versioned$316,
		                    [function(param, cont){return cont(0);}]),
		                sexp_of_t$54 = caml_callback(encode$7, [schema$131]),
		                include$94 = Make$2([0, compare$125, sexp_of_t$54]),
		                symbol$199 = include$94[3],
		                compare$126 = include$94[8],
		                cst_App_screen = "App_screen",
		                cst_Organization_homepage = "Organization_homepage",
		                cst_app_screen = "app_screen",
		                cst_organization_homepage = "organization_homepage",
		                letrec_function_context$567 = [];
		               function schema_versioned$317(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$567[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aoO, aoN, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$567[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$567[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$567[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aoQ,
		                                     aoP,
		                                     1,
		                                     0,
		                                     2,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_organization_id, 0, 2, [0, c], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$110,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f1 = param[2], f0 = param[1];
		                        return cont([5, f0, f1]);
		                       },
		                       function(param, cont){
		                        if(5 !== param[0]) return cont(0);
		                        var f1 = param[2], f0 = param[1];
		                        return cont([0, [0, f0, f1]]);
		                       },
		                       1,
		                       0,
		                       cst_agent,
		                       cst_Agent,
		                       [0,
		                        0,
		                        aoR,
		                        [7,
		                         function(param, cont){
		                          var organization_id = param[2][1], agent_id = param[1];
		                          return cont([0, agent_id, organization_id]);
		                         },
		                         function(param, cont){
		                          var organization_id = param[2], agent_id = param[1];
		                          return cont([0, agent_id, [0, organization_id, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, d], 0, 0], b]],
		                        0],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aoT,
		                           aoS,
		                           1,
		                           0,
		                           1,
		                           function(b){
		                            var a = [0, [0, b, V$4]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(4 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   "workspace_homepage",
		   "Workspace_homepage",
		   [0,
		    0,
		    aoU,
		    [7,
		     function(param, cont){
		      var value = param[1];
		      return cont(value);
		     },
		     function(value, cont){return cont([0, value, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, d], 0, 0], 0]],
		    0],
		   a],
		  c];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aoW,
		       aoV,
		       0,
		       26,
		       1,
		       function(c){
		        var a = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (Table[4],
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, d], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$120,
		                           schematic_version,
		                           function(e){
		                            var
		                             d =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([3, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_database,
		                                 cst_Database,
		                                 [0,
		                                  0,
		                                  aoX,
		                                  [7,
		                                   function(param, cont){
		                                    var table_id = param[2][1], workspace_id = param[1];
		                                    return cont([0, workspace_id, table_id]);
		                                   },
		                                   function(param, cont){
		                                    var table_id = param[2], workspace_id = param[1];
		                                    return cont([0, workspace_id, [0, table_id, 0]]);
		                                   },
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, e], 0, 0],
		                                    c]],
		                                  0],
		                                 a],
		                                b];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aoZ,
		                                     aoY,
		                                     0,
		                                     25,
		                                     6,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_organization_homepage,
		             cst_Organization_homepage,
		             [0,
		              0,
		              ao0,
		              [7,
		               function(param, cont){
		                var value = param[1];
		                return cont(value);
		               },
		               function(value, cont){return cont([0, value, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             a],
		            d];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$316,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$104,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([1, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_app_screen,
		                                 cst_App_screen,
		                                 [0,
		                                  0,
		                                  ao2,
		                                  [7,
		                                   function(param, cont){
		                                    var value = param[2][1], organization = param[1];
		                                    return cont([0, organization, value]);
		                                   },
		                                   function(param, cont){
		                                    var value = param[2], organization = param[1];
		                                    return cont([0, organization, [0, value, 0]]);
		                                   },
		                                   [0,
		                                    [0, ao1, 0, 0, 0, cst_organization, 0, 3, [0, d], 0, 0],
		                                    a]],
		                                  0],
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$131,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  ao4,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_object,
		    cst_Object,
		    [0,
		     0,
		     ao3,
		     [7,
		      function(param, cont){
		       var value = param[1];
		       return cont(value);
		      },
		      function(value, cont){return cont([0, value, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   c],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$567[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$567[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$522 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$567, [0, schematic_cache$522]);
		               var
		                schema$132 =
		                  caml_callback
		                   (schema_versioned$317,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$568 = [];
		               function compare$127(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var rhsvalue = rhs[1], lhsvalue = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$568[9], lhsvalue, rhsvalue, cont);
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var
		                     rhsvalue$0 = rhs[2],
		                     rhsorganization = rhs[1],
		                     lhsvalue$0 = lhs[2],
		                     lhsorganization = lhs[1],
		                     c =
		                       function(x){
		                        return 0 === x
		                                ? caml_trampoline_cps_call3
		                                  (letrec_function_context$568[7],
		                                   lhsvalue$0,
		                                   rhsvalue$0,
		                                   cont)
		                                : cont(x);
		                       };
		                    if(! lhsorganization) return rhsorganization ? c(-1) : c(0);
		                    var a = lhsorganization[1];
		                    if(! rhsorganization) return c(1);
		                    var b = rhsorganization[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$568[8], a, b, c);
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhsvalue$1 = rhs[1], lhsvalue$1 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$568[6],
		                             lhsvalue$1,
		                             rhsvalue$1,
		                             cont);
		                   }
		                   break;
		                  case 3:
		                   if(3 === rhs[0]){
		                    var
		                     rhstable_id = rhs[2],
		                     rhsworkspace_id = rhs[1],
		                     lhstable_id = lhs[2],
		                     lhsworkspace_id = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$568[5],
		                             lhsworkspace_id,
		                             rhsworkspace_id,
		                             function(x){
		                              return 0 === x
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$568[4],
		 lhstable_id,
		 rhstable_id,
		 cont)
		                                      : cont(x);
		                             });
		                   }
		                   break;
		                  case 4:
		                   if(4 === rhs[0]){
		                    var rhsvalue$2 = rhs[1], lhsvalue$2 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$568[3],
		                             lhsvalue$2,
		                             rhsvalue$2,
		                             cont);
		                   }
		                   break;
		                  default:
		                   if(5 === rhs[0]){
		                    var
		                     rhsorganization_id = rhs[2],
		                     rhsagent_id = rhs[1],
		                     lhsorganization_id = lhs[2],
		                     lhsagent_id = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$568[2],
		                             lhsagent_id,
		                             rhsagent_id,
		                             function(x){
		                              return 0 === x
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$568[1],
		 lhsorganization_id,
		 rhsorganization_id,
		 cont)
		                                      : cont(x);
		                             });
		                   }
		                }
		                function to_int(param){
		                 switch(param[0]){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   case 3:
		                    return 3;
		                   case 4:
		                    return 4;
		                   default: return 5;
		                 }
		                }
		                var d = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), d));
		               }
		               var _5$6 = Table[16];
		               caml_update_dummy
		                (letrec_function_context$568,
		                 [0,
		                  compare$60,
		                  compare$69,
		                  compare$80,
		                  _5$6,
		                  compare$80,
		                  compare$60,
		                  compare$126,
		                  compare$60,
		                  compare$85]);
		               var
		                sexp_of_t$55 = caml_callback(encode$7, [schema$132]),
		                include$95 = Make$2([0, compare$127, sexp_of_t$55]),
		                equal$213 = include$95[7],
		                letrec_function_context$569 = [];
		               function schema_versioned$318(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$569[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ao6, ao5, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$569[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$569[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$569[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, ao7, 0, 0, 0, cst_home, 0, 2, [0, bool_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$317,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var home = param[2][1], target = param[1];
		   return cont([0, target, home]);
		  },
		  function(param, cont){
		   var home = param[2], target = param[1];
		   return cont([0, target, [0, home, 0]]);
		  },
		  [0, [0, ao8, 0, 0, 0, cst_target, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$569[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$569[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$523 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$569, [0, schematic_cache$523]);
		               caml_callback
		                (schema_versioned$318,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$570 = [];
		               function equal$214(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$570[1],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(! c) return cont(c);
		                          var b = rhs[2], a = lhs[2];
		                          return cont(a === b ? 1 : 0);
		                         });
		               }
		               caml_update_dummy(letrec_function_context$570, [0, equal$213]);
		               var cst_previous_value = "previous_value", bNT = [];
		               function change_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNT[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ao_, ao9, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNT[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNT[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bNT[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var previous_value = param[2][1], current_value = param[1];
		                                 return cont([0, current_value, previous_value]);
		                                },
		                                function(param, cont){
		                                 var previous_value = param[2], current_value = param[1];
		                                 return cont([0, current_value, [0, previous_value, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "current_value",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_previous_value,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bNT[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bNT[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_change = "change",
		                cst_property_name = "property_name",
		                letrec_function_context$571 = [];
		               function edit_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$571[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, apa, ao$, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$571[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$571[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$571[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_property_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (change_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var property_name = param[2][1], change = param[1];
		   return cont([0, change, property_name]);
		  },
		  function(param, cont){
		   var property_name = param[2], change = param[1];
		   return cont([0, change, [0, property_name, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_change, 0, 2, [1, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$571[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$571[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$524 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNT, [0, schematic_cache$524]);
		               var schematic_cache$525 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$571, [0, schematic_cache$525]);
		               caml_callback
		                (change_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (edit_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function pp_change(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         apb,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apc,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.current_value",
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               apd,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   ape,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     apf,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               apg,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_previous_value,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aph,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               api,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), apj, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$572 = [];
		               function pp_edit(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         apk,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apl,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.change",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$572[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apm,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     apn,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               apo,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_property_name,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   app,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               apq,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), apr, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$572, [0, pp_change]);
		               var letrec_function_context$573 = [];
		               function extras_workspace_id_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$573[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aps, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$573[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$573[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$573[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var workspace_id = param[1];
		   return cont([0, workspace_id]);
		  },
		  function(param, cont){
		   var workspace_id = param[1];
		   return cont([0, workspace_id, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$573[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$573[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$526 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$573, [0, schematic_cache$526]);
		               caml_callback
		                (extras_workspace_id_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$574 = [];
		               function pp_extras_workspace_id(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         apt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apu,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.workspace_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$574[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apv,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), apw, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$574, [0, pp$46]);
		               var cst_extras = "extras";
		               function object_metrics_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_id_schema_vers,
		                                    schematic_param_action_schema_,
		                                    schematic_param_extras_schema_,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_id_schema_vers,
		                                     schematic_param_action_schema_,
		                                     schematic_param_extras_schema_){
		                                     return [7,
		     function(param, cont){
		      var
		       a = param[2],
		       extras = a[2][1],
		       action = a[1],
		       id = param[1];
		      return cont([0, id, action, extras]);
		     },
		     function(param, cont){
		      var extras = param[3], action = param[2], id = param[1];
		      return cont([0, id, [0, action, [0, extras, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_id,
		       0,
		       2,
		       [2, schematic_param_id_schema_vers],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_action,
		        0,
		        2,
		        [1, schematic_param_action_schema_],
		        0,
		        0],
		       [0,
		        [0,
		         apx,
		         0,
		         0,
		         0,
		         cst_extras,
		         0,
		         2,
		         [1, schematic_param_extras_schema_],
		         0,
		         0],
		        0]]]];
		                                    }
		                                    var
		                                     schematic_schema_id = match$193[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_id,
		 schematic_param_id_schema_vers,
		 function(schematic_param_id_schema_vers, cont){
		  return cont
		          ([1,
		            cst_action,
		            schematic_param_action_schema_,
		            function(schematic_param_action_schema_, cont){
		             return cont
		                     ([1,
		                       cst_extras,
		                       schematic_param_extras_schema_,
		                       function(schematic_param_extras_schema_, cont){
		                        return cont
		                                ([0,
		                                  schematic_schema_id,
		                                  descriptor
		                                   (schematic_param_id_schema_vers,
		                                    schematic_param_action_schema_,
		                                    schematic_param_extras_schema_)]);
		                       }]);
		            }]);
		 }]],
		                                     a =
		                                       descriptor
		(schematic_param_id_schema_vers,
		 schematic_param_action_schema_,
		 schematic_param_extras_schema_),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, , , a, schematic_parametric]);
		      }
		      if(! match) return b();
		      var name = match[1];
		      return caml_exact_trampoline_cps_call(to_id, name, b);
		     });
		                                   });
		                         });
		               }
		               function pp_object_metrics
		               (poly_id, poly_action, poly_extras, fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         apy,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apz,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (poly_id,
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apA,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     apB,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               apC,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_action,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (poly_action,
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               apD,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         apE,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apF,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_extras,
		     function(b){
		      var a = x[3];
		      return caml_trampoline_cps_call2
		              (poly_extras,
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apG,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), apH, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_ignored(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         apI,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   apJ,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.ignored",
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst$17,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         apK,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt), apL, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$575 = [];
		               function ignored_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$575[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$575[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$575[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$575[1][1] = a;
		                            var
		                             default$ = match$194[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var ignored = param[1];
		                                 return cont([0, ignored]);
		                                },
		                                function(param, cont){
		                                 var ignored = param[1];
		                                 return cont([0, ignored, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_ignored,
		                                  0,
		                                  [0, default$],
		                                  [0, schematic_param_a_schema_versi],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$575[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$575[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$527 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$575, [0, schematic_cache$527]);
		               caml_callback
		                (ignored_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function Make$13(M, cont){
		                var
		                 id_schema_versioned = M[1],
		                 pp_id = M[3],
		                 name = M[13],
		                 cst_metrics_action = "-metrics-action";
		                function action_schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call
		                                   (M[5],
		                                    schematic_version,
		                                    function(init){
		                                     return cont
		     ([0, [0, name + cst_metrics_action], 0, init[3], init[4]]);
		                                    });
		                          });
		                }
		                var cst_metrics_extras = "-metrics-extras";
		                function extras_schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call
		                                   (M[9],
		                                    schematic_version,
		                                    function(init){
		                                     return cont
		     ([0, [0, name + cst_metrics_extras], 0, init[3], init[4]]);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (action_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(action_schema){
		                          return caml_exact_trampoline_cps_call
		                                  (extras_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(extras_schema){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (extras_schema_versioned,
		     schematic_version,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (action_schema_versioned,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (id_schema_versioned,
		                         schematic_version,
		                         function(c){
		                          return caml_exact_trampoline_cps_call
		                                  (object_metrics_schema_versione,
		                                   schematic_version,
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call$0
		    (d,
		     c,
		     b,
		     a,
		     function(init){
		      function action_schema_versioned(schematic_version, cont){
		       return caml_exact_trampoline_cps_call
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call
		                         (M[5],
		                          schematic_version,
		                          function(init){
		                           return cont
		                                   ([0, [0, name + cst_metrics_action], 0, init[3], init[4]]);
		                          });
		                });
		      }
		      function extras_schema_versioned(schematic_version, cont){
		       return caml_exact_trampoline_cps_call
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call
		                         (M[9],
		                          schematic_version,
		                          function(init){
		                           return cont
		                                   ([0, [0, name + cst_metrics_extras], 0, init[3], init[4]]);
		                          });
		                });
		      }
		      function schema_versioned(schematic_version, cont){
		       return caml_exact_trampoline_cps_call
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call
		                         (extras_schema_versioned,
		                          schematic_version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (action_schema_versioned,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (id_schema_versioned,
		      schematic_version,
		      function(c){
		       return caml_exact_trampoline_cps_call
		               (object_metrics_schema_versione,
		                schematic_version,
		                function(d){
		                 return caml_exact_trampoline_cps_call$0
		                         (d,
		                          c,
		                          b,
		                          a,
		                          function(init){
		                           return cont
		                                   ([0, [0, name + "-metrics-object"], 0, init[3], init[4]]);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (action_schema_versioned,
		               function(param, cont){return cont(0);},
		               function(action_schema){
		                return caml_exact_trampoline_cps_call
		                        (extras_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(extras_schema){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(schema){
		                                    var a = [];
		                                    function pp_action(fmt, cont){
		                                     return caml_trampoline_cps_call2(a[1], fmt, cont);
		                                    }
		                                    var b = [];
		                                    function pp_extras(fmt, cont){
		                                     return caml_trampoline_cps_call2(b[1], fmt, cont);
		                                    }
		                                    var letrec_function_context = [];
		                                    function pp(fmt, cont){
		                                     return caml_trampoline_cps_call5
		     (letrec_function_context[1],
		      function(fmt, cont){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[4], fmt, cont);
		      },
		      function(fmt, cont){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[3], fmt, cont);
		      },
		      function(fmt, cont){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[2], fmt, cont);
		      },
		      fmt,
		      cont);
		                                    }
		                                    var _0 = M[7];
		                                    caml_update_dummy(a, [0, _0]);
		                                    var _0$0 = M[11];
		                                    caml_update_dummy(b, [0, _0$0]);
		                                    caml_update_dummy
		                                     (letrec_function_context,
		                                      [0, pp_object_metrics, pp_extras, pp_action, pp_id]);
		                                    return cont
		    ([0,
		      id_schema_versioned,
		      ,
		      pp_id,
		      ,
		      ,
		      action_schema,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      schema_versioned,
		      ,
		      pp]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$117,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, apM, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               function extras_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (ignored_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, , , a[3], a[4]]);});
		                         });
		               }
		               var
		                cst_Edited = "Edited",
		                cst_device_id = "device_id",
		                cst_edit = "edit",
		                cst_edited = "edited",
		                cst_first_name = "first_name",
		                cst_last_name = "last_name",
		                cst_score = "score",
		                cst_sentiment = "sentiment",
		                bNU = [];
		               function action_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNU[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNU[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNU[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bNU[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  return typeof param === "number" ? cont(apO) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_deleted,
		                                 cst_Deleted,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([3, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  "logged_in",
		                                  "Logged_in",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var device_id = param[1];
		                                     return cont(device_id);
		                                    },
		                                    function(device_id, cont){return cont([0, device_id, 0]);},
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_device_id,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([4, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   "logged_out",
		                                   "Logged_out",
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var device_id = param[1];
		                                      return cont(device_id);
		                                     },
		                                     function(device_id, cont){return cont([0, device_id, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_device_id,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([5, f0]);},
		                                    function(param, cont){
		                                     if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                     return cont(0);
		                                    },
		                                    1,
		                                    0,
		                                    "invited",
		                                    "Invited",
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var email = param[1];
		                                       return cont(email);
		                                      },
		                                      function(email, cont){return cont([0, email, 0]);},
		                                      [0,
		                                       [0,
		apN,
		0,
		0,
		0,
		cst_email,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([6, f0]);},
		                                     function(param, cont){
		                                      if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                      return cont(0);
		                                     },
		                                     1,
		                                     0,
		                                     "nps_answered",
		                                     "NPS_answered",
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var score = param[1];
		return cont(score);
		                                       },
		                                       function(score, cont){return cont([0, score, 0]);},
		                                       [0,
		[0, 0, 0, 0, 0, cst_score, 0, 2, [0, int_schema], 0, 0],
		0]],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(f0, cont){return cont([7, f0]);},
		                                      function(param, cont){
		                                       if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                       return cont(0);
		                                      },
		                                      1,
		                                      0,
		                                      "pmf_answered",
		                                      "PMF_answered",
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){
		 var sentiment = param[1];
		 return cont(sentiment);
		},
		function(sentiment, cont){return cont([0, sentiment, 0]);},
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_sentiment,
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 0]],
		                                       0],
		                                      0],
		                                     0]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (edit_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){
		    var f2 = param[3], f1 = param[2], f0 = param[1];
		    return cont([1, f0, f1, f2]);
		   },
		   function(param, cont){
		    if(typeof param !== "number" && 1 === param[0]){
		     var f2 = param[3], f1 = param[2], f0 = param[1];
		     return cont([0, [0, f0, f1, f2]]);
		    }
		    return cont(0);
		   },
		   1,
		   0,
		   cst_created,
		   cst_Created,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       email = a[2][1],
		       last_name = a[1],
		       first_name = param[1];
		      return cont([0, first_name, last_name, email]);
		     },
		     function(param, cont){
		      var
		       email = param[3],
		       last_name = param[2],
		       first_name = param[1];
		      return cont([0, first_name, [0, last_name, [0, email, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_first_name,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_last_name,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_email,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]]]],
		    0],
		   0],
		  [0,
		   [0,
		    function(f0, cont){return cont([2, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    1,
		    0,
		    cst_edited,
		    cst_Edited,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var edit = param[1];
		       return cont(edit);
		      },
		      function(edit, cont){return cont([0, edit, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_edit, 0, 2, [1, c], 0, 0], 0]],
		     0],
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call
		      (authentication_schema_versione,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            apP,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              0,
		              0,
		              "authenticating",
		              "Authenticating",
		              a,
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bNU[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bNU[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$576 = [];
		               function authentication_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$576[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, apQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$576[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$576[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$576[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                apS,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(apR);},
		                                  0,
		                                  0,
		                                  cst_email,
		                                  cst_Email,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(! param) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_google,
		                                   cst_Google,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var scope = param[1];
		                                      return cont(scope);
		                                     },
		                                     function(scope, cont){return cont([0, scope, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_scope,
		                                       0,
		                                       2,
		                                       [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$576[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$576[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$528 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNU, [0, schematic_cache$528]);
		               var schematic_cache$529 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$576, [0, schematic_cache$529]);
		               caml_callback
		                (id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (authentication_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var bQc = [];
		               function pp_id(fmt, param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst_None, cont);
		                var x = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         fmt,
		                         cst_Some,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (bQc[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     x,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string, fmt, cst$18, cont);
		     });
		                                   });
		                         });
		               }
		               var bQd = [];
		               function pp_extras(fmt, cont){
		                return caml_trampoline_cps_call2(bQd[1], fmt, cont);
		               }
		               var letrec_function_context$577 = [];
		               function pp_action(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, "Metrics_intf.User.M.Deleted", cont);
		                switch(param[0]){
		                  case 0:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            apT,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$577[2],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), apU, cont);
		        });
		                                      });
		                            });
		                  case 1:
		                   var
		                    aemail = param[3],
		                    alast_name = param[2],
		                    afirst_name = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            apV,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      apW,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_first_name,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  apX,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            afirst_name,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      apY,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        apZ,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ap0,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_last_name,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ap1,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        alast_name,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ap2,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ap3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ap4,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_email,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ap5,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aemail,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ap6,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ap7, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var aedit = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ap8,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ap9,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_edit,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$577[1],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aedit,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ap_,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ap$, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var adevice_id = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aqa,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqb,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_device_id,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqc,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            adevice_id,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqd,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), aqe, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 4:
		                   var adevice_id$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aqf,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqg,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_device_id,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqh,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            adevice_id$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqi,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), aqj, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 5:
		                   var aemail$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aqk,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aql,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_email,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqm,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aemail$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqn,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), aqo, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 6:
		                   var ascore = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aqp,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqq,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_score,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqr,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            ascore,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqs,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), aqt, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var asentiment = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aqu,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqv,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_sentiment,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqw,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            asentiment,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqx,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), aqy, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               function pp_authentication(fmt, param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, "Metrics_intf.User.M.Email", cont);
		                var ascope = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         aqz,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aqA,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_scope,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aqB,
		               function(b){
		                function a(accu, l$0){
		                 if(! l$0)
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           aqE,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     aqF,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt), aqG, cont);
		                                     });
		                           });
		                 var l = l$0[2], a$0 = l$0[1];
		                 function b(b){
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           aqD,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a$0,
		                                     function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                           });
		                 }
		                 return accu
		                         ? caml_exact_trampoline_cps_call(fprintf$0(fmt), aqC, b)
		                         : b();
		                }
		                return a(0, ascope);
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(bQc, [0, pp$44]);
		               caml_update_dummy(bQd, [0, pp_ignored]);
		               caml_update_dummy
		                (letrec_function_context$577, [0, pp_edit, pp_authentication]);
		               var
		                include$96 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned,
		                      ,
		                      pp_id,
		                      ,
		                      action_schema_versioned,
		                      ,
		                      pp_action,
		                      ,
		                      extras_schema_versioned,
		                      ,
		                      pp_extras,
		                      ,
		                      cst_user]]),
		                action_schema = include$96[6],
		                schema_versioned$319 = include$96[14],
		                _16$2 = include$96[16];
		               function id_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$104,
		                                   schematic_version,
		                                   function(a){return cont([0, aqH, 0, a[3], a[4]]);});
		                         });
		               }
		               function extras_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (ignored_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, , , a[3], a[4]]);});
		                         });
		               }
		               var
		                cst_Added_user = "Added_user",
		                cst_Edited_user = "Edited_user",
		                cst_Removed_user = "Removed_user",
		                cst_added_user = "added_user",
		                cst_edited_user = "edited_user",
		                cst_invitation_token = "invitation_token",
		                cst_removed_user = "removed_user",
		                letrec_function_context$578 = [];
		               function action_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$578[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$578[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$578[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$578[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_removed_user,
		   cst_Removed_user,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var user_id = param[1];
		      return cont(user_id);
		     },
		     function(user_id, cont){return cont([0, user_id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_user_id, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (edit_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_edit, 0, 2, [1, c], 0, 0], 0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$117,
		                 schematic_version,
		                 function(e){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f1 = param[2], f0 = param[1];
		                        return cont([4, f0, f1]);
		                       },
		                       function(param, cont){
		                        if(typeof param !== "number" && 4 === param[0]){
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, [0, f0, f1]]);
		                        }
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_edited_user,
		                       cst_Edited_user,
		                       [0,
		                        0,
		                        aqI,
		                        [7,
		                         function(param, cont){
		                          var edit = param[2][1], user_id = param[1];
		                          return cont([0, user_id, edit]);
		                         },
		                         function(param, cont){
		                          var edit = param[2], user_id = param[1];
		                          return cont([0, user_id, [0, edit, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_user_id, 0, 2, [0, e], 0, 0], b]],
		                        0],
		                       0],
		                      a],
		                   d =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_invitation_token,
		                       0,
		                       2,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$117,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 1,
		                                 0,
		                                 cst_edited,
		                                 cst_Edited,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var property_name = param[1];
		                                    return cont(property_name);
		                                   },
		                                   function(property_name, cont){
		                                    return cont([0, property_name, 0]);
		                                   },
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_property_name,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   return typeof param === "number" ? cont(aqK) : cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_deleted,
		                                  cst_Deleted,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var
		                                     f3 = param[4],
		                                     f2 = param[3],
		                                     f1 = param[2],
		                                     f0 = param[1];
		                                    return cont([2, f0, f1, f2, f3]);
		                                   },
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 2 === param[0]){
		                                     var
		                                      f3 = param[4],
		                                      f2 = param[3],
		                                      f1 = param[2],
		                                      f0 = param[1];
		                                     return cont([0, [0, f0, f1, f2, f3]]);
		                                    }
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   "invited_user",
		                                   "Invited_user",
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var
		                                       a = param[2],
		                                       b = a[2],
		                                       invitation_token = b[2][1],
		                                       org_name = b[1],
		                                       uri = a[1],
		                                       email = param[1];
		                                      return cont([0, email, uri, org_name, invitation_token]);
		                                     },
		                                     function(param, cont){
		                                      var
		                                       invitation_token = param[4],
		                                       org_name = param[3],
		                                       uri = param[2],
		                                       email = param[1];
		                                      return cont
		      ([0,
		        email,
		        [0, uri, [0, org_name, [0, invitation_token, 0]]]]);
		                                     },
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_email, 0, 2, [0, schema$72], 0, 0],
		                                      [0,
		                                       [0, 0, 0, 0, 0, cst_uri, 0, 2, [0, schema$262], 0, 0],
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_name,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_invitation_token,
		  0,
		  2,
		  [0, schematic_param_name_schema_ve],
		  0,
		  0],
		 0]]]]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([3, f0, f1]);
		                                    },
		                                    function(param, cont){
		                                     if(typeof param !== "number" && 3 === param[0]){
		                                      var f1 = param[2], f0 = param[1];
		                                      return cont([0, [0, f0, f1]]);
		                                     }
		                                     return cont(0);
		                                    },
		                                    1,
		                                    0,
		                                    cst_added_user,
		                                    cst_Added_user,
		                                    [0,
		                                     0,
		                                     aqJ,
		                                     [7,
		                                      function(param, cont){
		                                       var invitation_token = param[2][1], user_id = param[1];
		                                       return cont([0, user_id, invitation_token]);
		                                      },
		                                      function(param, cont){
		                                       var invitation_token = param[2], user_id = param[1];
		                                       return cont([0, user_id, [0, invitation_token, 0]]);
		                                      },
		                                      [0, [0, 0, 0, 0, 0, cst_user_id, 0, 2, [0, b], 0, 0], d]],
		                                     0],
		                                    0],
		                                   c]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$115,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  aqN,
		  [0,
		   [0,
		    function(param, cont){
		     var f1 = param[2], f0 = param[1];
		     return cont([0, f0, f1]);
		    },
		    function(param, cont){
		     if(typeof param !== "number" && 0 === param[0]){
		      var f1 = param[2], f0 = param[1];
		      return cont([0, [0, f0, f1]]);
		     }
		     return cont(0);
		    },
		    1,
		    0,
		    cst_created,
		    cst_Created,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var email = param[2][1], name = param[1];
		       return cont([0, name, email]);
		      },
		      function(param, cont){
		       var email = param[2], name = param[1];
		       return cont([0, name, [0, email, 0]]);
		      },
		      [0,
		       [0,
		        aqM,
		        0,
		        0,
		        0,
		        cst_name,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0, [0, aqL, 0, 0, 0, cst_email, 0, 2, [0, b], 0, 0], 0]]],
		     0],
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$578[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$578[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$530 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$578, [0, schematic_cache$530]);
		               caml_callback
		                (id_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var bQe = [];
		               function pp_id$0(fmt, cont){
		                return caml_trampoline_cps_call2(bQe[1], fmt, cont);
		               }
		               var bQf = [];
		               function pp_extras$0(fmt, cont){
		                return caml_trampoline_cps_call2(bQf[1], fmt, cont);
		               }
		               var letrec_function_context$579 = [];
		               function pp_action$0(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          "Metrics_intf.Organization.M.Deleted",
		                          cont);
		                switch(param[0]){
		                  case 0:
		                   var aemail = param[2], aname = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aqO,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqP,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_name,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqQ,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aname,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqR,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        aqS,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqT,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_email,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$579[7],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aemail,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqU,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), aqV, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var aproperty_name = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aqW,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqX,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_property_name,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aqY,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperty_name,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aqZ,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), aq0, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var
		                    ainvitation_token = param[4],
		                    aorg_name = param[3],
		                    auri = param[2],
		                    aemail$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aq1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aq2,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_email,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$579[6],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aemail$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aq3,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        aq4,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aq5,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_uri,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$579[5],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        auri,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aq6,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aq7,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aq8,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        "org_name",
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aq9,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aorg_name,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aq_,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        aq$,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ara,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_invitation_token,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arb,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        ainvitation_token,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  arc,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), ard, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var ainvitation_token$0 = param[2], auser_id = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            are,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arf,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_user_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$579[4],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            auser_id,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arg,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        arh,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ari,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_invitation_token,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arj,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        ainvitation_token$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ark,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), arl, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 4:
		                   var aedit = param[2], auser_id$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            arm,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arn,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_user_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$579[3],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            auser_id$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aro,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        arp,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  arq,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_edit,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$579[2],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aedit,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  arr,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), ars, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var auser_id$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            art,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aru,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_user_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$579[1],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            auser_id$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arv,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), arw, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               caml_update_dummy(bQe, [0, pp$37]);
		               caml_update_dummy(bQf, [0, pp_ignored]);
		               caml_update_dummy
		                (letrec_function_context$579,
		                 [0, pp$44, pp_edit, pp$44, pp$44, pp$27, pp$75, pp$42]);
		               var
		                include$97 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$0,
		                      ,
		                      pp_id$0,
		                      ,
		                      action_schema_versioned$0,
		                      ,
		                      pp_action$0,
		                      ,
		                      extras_schema_versioned$0,
		                      ,
		                      pp_extras$0,
		                      ,
		                      cst_organization]]),
		                action_schema$0 = include$97[6],
		                schema_versioned$320 = include$97[14],
		                _13$2 = include$97[16],
		                bNV = [];
		               function action_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNV[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNV[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNV[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bNV[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_removed_user,
		   cst_Removed_user,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var user_id = param[1];
		      return cont(user_id);
		     },
		     function(user_id, cont){return cont([0, user_id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_user_id, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (edit_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_edit, 0, 2, [1, c], 0, 0], 0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$117,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f1 = param[2], f0 = param[1];
		                        return cont([2, f0, f1]);
		                       },
		                       function(param, cont){
		                        if(typeof param !== "number" && 2 === param[0]){
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, [0, f0, f1]]);
		                        }
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_edited_user,
		                       cst_Edited_user,
		                       [0,
		                        0,
		                        arx,
		                        [7,
		                         function(param, cont){
		                          var edit = param[2][1], user_id = param[1];
		                          return cont([0, user_id, edit]);
		                         },
		                         function(param, cont){
		                          var edit = param[2], user_id = param[1];
		                          return cont([0, user_id, [0, edit, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_user_id, 0, 2, [0, d], 0, 0], b]],
		                        0],
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$117,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [11,
		                                arA,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(arz);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_created,
		                                  cst_Created,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_edited,
		                                   cst_Edited,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var property_name = param[1];
		                                      return cont(property_name);
		                                     },
		                                     function(property_name, cont){
		                                      return cont([0, property_name, 0]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_property_name,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(1);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && param) return cont(ary);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_deleted,
		                                    cst_Deleted,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([1, f0]);},
		                                     function(param, cont){
		                                      if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                      return cont(0);
		                                     },
		                                     1,
		                                     0,
		                                     cst_added_user,
		                                     cst_Added_user,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var user_id = param[1];
		return cont(user_id);
		                                       },
		                                       function(user_id, cont){return cont([0, user_id, 0]);},
		                                       [0, [0, 0, 0, 0, 0, cst_user_id, 0, 2, [0, a], 0, 0], 0]],
		                                      0],
		                                     0],
		                                    c]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bNV[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bNV[1][1] = a; return cont(res);});
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$580 = [];
		               function extras_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$580[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$580[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$580[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$580[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id]);
		  },
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organization_id, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$580[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$580[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function id_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (Workspace[4],
		                                   schematic_version,
		                                   function(a){return cont([0, arB, 0, a[3], a[4]]);});
		                         });
		               }
		               var schematic_cache$531 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNV, [0, schematic_cache$531]);
		               var schematic_cache$532 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$580, [0, schematic_cache$532]);
		               caml_callback
		                (action_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (id_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var bPh = [];
		               function pp_action$1(fmt, param, cont){
		                if(typeof param === "number")
		                 return 0 === param
		                         ? caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Workspace.M.Created",
		                            cont)
		                         : caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Workspace.M.Deleted",
		                            cont);
		                switch(param[0]){
		                  case 0:
		                   var aproperty_name = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            arC,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arD,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_property_name,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  arE,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperty_name,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arF,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), arG, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var auser_id = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            arH,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arI,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_user_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (bPh[4],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            auser_id,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arJ,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), arK, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var aedit = param[2], auser_id$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            arL,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arM,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_user_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (bPh[3],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            auser_id$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arN,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        arO,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  arP,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_edit,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (bPh[2],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aedit,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  arQ,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), arR, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var auser_id$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            arS,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arT,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_user_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (bPh[1],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            auser_id$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      arU,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), arV, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               var bQg = [];
		               function pp_extras$1(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         arW,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   arX,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Workspace.M.organization_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bQg[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   arY,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), arZ, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$581 = [];
		               function pp_id$1(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$581[1], fmt, cont);
		               }
		               caml_update_dummy(bPh, [0, pp$44, pp_edit, pp$44, pp$44]);
		               caml_update_dummy(bQg, [0, pp$37]);
		               var _0$47 = Workspace[1];
		               caml_update_dummy(letrec_function_context$581, [0, _0$47]);
		               var
		                include$98 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$1,
		                      ,
		                      pp_id$1,
		                      ,
		                      action_schema_versioned$1,
		                      ,
		                      pp_action$1,
		                      ,
		                      extras_schema_versioned$1,
		                      ,
		                      pp_extras$1,
		                      ,
		                      cst_workspace]]),
		                action_schema$1 = include$98[6],
		                schema_versioned$321 = include$98[14],
		                _18 = include$98[16],
		                cst_Disabled = "Disabled",
		                cst_Enabled = "Enabled",
		                cst_type_name = "type_name",
		                letrec_function_context$582 = [];
		               function action_schema_versioned$2(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$582[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$582[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$582[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$582[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && ! param) return cont(ar2);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 "uninstalled",
		                                 "Uninstalled",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(1);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 1 === param)
		                                    return cont(ar1);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_enabled,
		                                  cst_Enabled,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(2);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 2 <= param)
		                                     return cont(ar0);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_disabled,
		                                   cst_Disabled,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call
		                                    (edit_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  ar3,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    1,
		    0,
		    "installed",
		    "Installed",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var type_name = param[1];
		       return cont(type_name);
		      },
		      function(type_name, cont){return cont([0, type_name, 0]);},
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_type_name,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       0]],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([1, f0]);},
		     function(param, cont){
		      if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		      return cont(0);
		     },
		     0,
		     0,
		     cst_edited,
		     cst_Edited,
		     b,
		     0],
		    a]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$582[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$582[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function extras_schema_versioned$2(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (extras_workspace_id_schema_ver,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, , , a[3], a[4]]);});
		                                   });
		                         });
		               }
		               function id_schema_versioned$2(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    ar4,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var schematic_cache$533 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$582, [0, schematic_cache$533]);
		               caml_callback
		                (action_schema_versioned$2,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$2,
		                 [function(param, cont){return cont(0);}]);
		               var bQh = [];
		               function pp_action$2(fmt, param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Integration.M.Uninstalled",
		                             cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Integration.M.Enabled",
		                             cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Integration.M.Disabled",
		                             cont);
		                 }
		                if(0 === param[0]){
		                 var atype_name = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ar5,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ar6,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_type_name,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ar7,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          atype_name,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ar8,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), ar9, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         ar_,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (bQh[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), ar$, cont);
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$583 = [];
		               function pp_extras$2(fmt, param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst_None, cont);
		                var x = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         fmt,
		                         cst_Some,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$583[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     x,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string, fmt, cst$18, cont);
		     });
		                                   });
		                         });
		               }
		               function pp_id$2(fmt, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), asa, cont);
		               }
		               caml_update_dummy(bQh, [0, pp_edit]);
		               caml_update_dummy
		                (letrec_function_context$583, [0, pp_extras_workspace_id]);
		               var
		                include$99 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$2,
		                      ,
		                      pp_id$2,
		                      ,
		                      action_schema_versioned$2,
		                      ,
		                      pp_action$2,
		                      ,
		                      extras_schema_versioned$2,
		                      ,
		                      pp_extras$2,
		                      ,
		                      cst_integration]]),
		                action_schema$2 = include$99[6],
		                schema_versioned$322 = include$99[14],
		                _11$1 = include$99[16],
		                letrec_function_context$584 = [];
		               function action_schema_versioned$3(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$584[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$584[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$584[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$584[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  return typeof param === "number" ? cont(asb) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_deleted,
		                                 cst_Deleted,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (edit_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  asc,
		  [0,
		   [0,
		    function(param, cont){
		     var f1 = param[2], f0 = param[1];
		     return cont([0, f0, f1]);
		    },
		    function(param, cont){
		     if(typeof param !== "number" && 0 === param[0]){
		      var f1 = param[2], f0 = param[1];
		      return cont([0, [0, f0, f1]]);
		     }
		     return cont(0);
		    },
		    1,
		    0,
		    cst_created,
		    cst_Created,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var name = param[2][1], workspace_id = param[1];
		       return cont([0, workspace_id, name]);
		      },
		      function(param, cont){
		       var name = param[2], workspace_id = param[1];
		       return cont([0, workspace_id, [0, name, 0]]);
		      },
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_workspace_id,
		        0,
		        2,
		        [0, schematic_param_a_schema_versi],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_name,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]]],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([1, f0]);},
		     function(param, cont){
		      if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		      return cont(0);
		     },
		     0,
		     0,
		     cst_edited,
		     cst_Edited,
		     b,
		     0],
		    a]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$584[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$584[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function extras_schema_versioned$3(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (extras_workspace_id_schema_ver,
		                                   schematic_version,
		                                   function(a){return cont([0, , , a[3], a[4]]);});
		                         });
		               }
		               function id_schema_versioned$3(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    asd,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var schematic_cache$534 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$584, [0, schematic_cache$534]);
		               caml_callback
		                (action_schema_versioned$3,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$3,
		                 [function(param, cont){return cont(0);}]);
		               var bQi = [];
		               function pp_action$3(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, "Metrics_intf.Type.M.Deleted", cont);
		                if(0 === param[0]){
		                 var aname = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          ase,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    asf,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_workspace_id,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                fmt,
		                cst$17,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          asg,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ash,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      asi,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_name,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          asj,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    aname,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      ask,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), asl, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         asm,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (bQi[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), asn, cont);
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$585 = [];
		               function pp_extras$3(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$585[1], fmt, cont);
		               }
		               function pp_id$3(fmt, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), aso, cont);
		               }
		               caml_update_dummy(bQi, [0, pp_edit]);
		               caml_update_dummy
		                (letrec_function_context$585, [0, pp_extras_workspace_id]);
		               var
		                include$100 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$3,
		                      ,
		                      pp_id$3,
		                      ,
		                      action_schema_versioned$3,
		                      ,
		                      pp_action$3,
		                      ,
		                      extras_schema_versioned$3,
		                      ,
		                      pp_extras$3,
		                      ,
		                      cst_type]]),
		                action_schema$3 = include$100[6],
		                schema_versioned$323 = include$100[14],
		                _15 = include$100[16],
		                letrec_function_context$586 = [];
		               function schema_versioned$324(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$586[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, asp, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$586[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$586[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$586[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return cont(asr);},
		                                  0,
		                                  0,
		                                  cst_submitted,
		                                  "Submitted",
		                                  asq,
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$586[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$586[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$535 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$586, [0, schematic_cache$535]);
		               var
		                schema$133 =
		                  caml_callback
		                   (schema_versioned$324,
		                    [function(param, cont){return cont(0);}]);
		               function pp$103(fmt, param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         fmt,
		                         "Metrics_intf.Console.Submitted",
		                         cont);
		               }
		               var cst_Closed = "Closed", letrec_function_context$587 = [];
		               function schema_versioned$325(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$587[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, ass, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$587[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$587[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$587[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(asy);},
		                                  0,
		                                  0,
		                                  cst_opened,
		                                  "Opened",
		                                  asx,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(asw) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_hidden,
		                                   "Hidden",
		                                   asv,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(asu) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_closed,
		                                    cst_Closed,
		                                    ast,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$587[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$587[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$536 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$587, [0, schematic_cache$536]);
		               var
		                schema$134 =
		                  caml_callback
		                   (schema_versioned$325,
		                    [function(param, cont){return cont(0);}]);
		               function pp$104(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Dashboard.Opened",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Dashboard.Hidden",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Dashboard.Closed",
		                            cont);
		                }
		               }
		               var
		                schematic_cache$537 = [0, empty$11([0, comparator$9])],
		                bNW = [];
		               caml_update_dummy(bNW, [0, schematic_cache$537]);
		               var
		                schematic_cache$538 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$588 = [];
		               caml_update_dummy
		                (letrec_function_context$588, [0, schematic_cache$538]);
		               var schematic_schema_version$105 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bNW[1][1], schematic_schema_version$105]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bNW[1][1],
		                             schematic_schema_version$105,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bNW[1][1],
		schematic_schema_version$105,
		schematic_self,
		function(a){
		 bNW[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (Table[4],
		          dummy,
		          function(b){
		           var
		            a =
		              [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (Workspace[4],
		                    dummy,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var table_id = param[2][1], workspace_id = param[1];
		                          return cont([0, workspace_id, table_id]);
		                         },
		                         function(param, cont){
		                          var table_id = param[2], workspace_id = param[1];
		                          return cont([0, workspace_id, [0, table_id, 0]]);
		                         },
		                         [0,
		                          [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		                          a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bNW[1][1],
		                              schematic_schema_version$105,
		                              res,
		                              function(a){bNW[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_has_relation = "has_relation",
		                schematic_schema_version$18 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$588[1][1],
		                    schematic_schema_version$18]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$588[1][1],
		                             schematic_schema_version$18,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$588[1][1],
		schematic_schema_version$18,
		schematic_self,
		function(a){
		 letrec_function_context$588[1][1] = a;
		 var
		  res =
		    [11,
		     asA,
		     [0,
		      [0,
		       function(param, cont){
		        var f1 = param[2], f0 = param[1];
		        return cont([0, f0, f1]);
		       },
		       function(param, cont){
		        if(typeof param !== "number" && 0 === param[0]){
		         var f1 = param[2], f0 = param[1];
		         return cont([0, [0, f0, f1]]);
		        }
		        return cont(0);
		       },
		       1,
		       0,
		       cst_created,
		       cst_Created,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var has_relation = param[2][1], name = param[1];
		          return cont([0, name, has_relation]);
		         },
		         function(param, cont){
		          var has_relation = param[2], name = param[1];
		          return cont([0, name, [0, has_relation, 0]]);
		         },
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_name,
		           0,
		           2,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_has_relation,
		            0,
		            2,
		            [0, bool_schema],
		            0,
		            0],
		           0]]],
		        0],
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		         return cont(0);
		        },
		        1,
		        0,
		        cst_edited,
		        cst_Edited,
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){
		           var has_relation = param[1];
		           return cont(has_relation);
		          },
		          function(has_relation, cont){
		           return cont([0, has_relation, 0]);
		          },
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_has_relation,
		            0,
		            2,
		            [0, bool_schema],
		            0,
		            0],
		           0]],
		         0],
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(0);},
		         function(param, cont){
		          return typeof param === "number" ? cont(asz) : cont(0);
		         },
		         0,
		         0,
		         cst_deleted,
		         cst_Deleted,
		         [0,
		          0,
		          0,
		          [7,
		           function(param, cont){return cont(0);},
		           function(param, cont){return cont(0);},
		           0],
		          0],
		         0],
		        0]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$588[1][1],
		          schematic_schema_version$18,
		          res,
		          function(a){
		           letrec_function_context$588[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback(schema_versioned$108, [dummy]);
		               var
		                schematic_cache$539 = [0, empty$11([0, comparator$9])],
		                bNX = [];
		               caml_update_dummy(bNX, [0, schematic_cache$539]);
		               var
		                schematic_cache$540 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$589 = [];
		               caml_update_dummy
		                (letrec_function_context$589, [0, schematic_cache$540]);
		               var schematic_schema_version$104 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bNX[1][1], schematic_schema_version$104]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bNX[1][1],
		                             schematic_schema_version$104,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bNX[1][1],
		schematic_schema_version$104,
		schematic_self,
		function(a){
		 bNX[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (Table[4],
		          dummy,
		          function(b){
		           var
		            a =
		              [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (Workspace[4],
		                    dummy,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var table_id = param[2][1], workspace_id = param[1];
		                          return cont([0, workspace_id, table_id]);
		                         },
		                         function(param, cont){
		                          var table_id = param[2], workspace_id = param[1];
		                          return cont([0, workspace_id, [0, table_id, 0]]);
		                         },
		                         [0,
		                          [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		                          a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bNX[1][1],
		                              schematic_schema_version$104,
		                              res,
		                              function(a){bNX[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$19 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$589[1][1],
		                    schematic_schema_version$19]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$589[1][1],
		                             schematic_schema_version$19,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$589[1][1],
		schematic_schema_version$19,
		schematic_self,
		function(a){
		 letrec_function_context$589[1][1] = a;
		 var
		  res =
		    [11,
		     asC,
		     [0,
		      [0,
		       function(param, cont){
		        var f1 = param[2], f0 = param[1];
		        return cont([0, f0, f1]);
		       },
		       function(param, cont){
		        if(typeof param !== "number" && 0 === param[0]){
		         var f1 = param[2], f0 = param[1];
		         return cont([0, [0, f0, f1]]);
		        }
		        return cont(0);
		       },
		       1,
		       0,
		       cst_created,
		       cst_Created,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var has_relation = param[2][1], name = param[1];
		          return cont([0, name, has_relation]);
		         },
		         function(param, cont){
		          var has_relation = param[2], name = param[1];
		          return cont([0, name, [0, has_relation, 0]]);
		         },
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_name,
		           0,
		           2,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_has_relation,
		            0,
		            2,
		            [0, bool_schema],
		            0,
		            0],
		           0]]],
		        0],
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		         return cont(0);
		        },
		        1,
		        0,
		        cst_edited,
		        cst_Edited,
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){
		           var has_relation = param[1];
		           return cont(has_relation);
		          },
		          function(has_relation, cont){
		           return cont([0, has_relation, 0]);
		          },
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_has_relation,
		            0,
		            2,
		            [0, bool_schema],
		            0,
		            0],
		           0]],
		         0],
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(0);},
		         function(param, cont){
		          return typeof param === "number" ? cont(asB) : cont(0);
		         },
		         0,
		         0,
		         cst_deleted,
		         cst_Deleted,
		         [0,
		          0,
		          0,
		          [7,
		           function(param, cont){return cont(0);},
		           function(param, cont){return cont(0);},
		           0],
		          0],
		         0],
		        0]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$589[1][1],
		          schematic_schema_version$19,
		          res,
		          function(a){
		           letrec_function_context$589[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback(schema_versioned$108, [dummy]);
		               var bPN = [];
		               function pp_extras$4(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         asD,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   asE,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Database.M.workspace_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bPN[2],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   asF,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     asG,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               asH,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_table_id,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (bPN[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               asI,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), asJ, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_action$4(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          "Metrics_intf.Database.M.Deleted",
		                          cont);
		                if(0 === param[0]){
		                 var ahas_relation = param[2], aname = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          asK,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    asL,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_name,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                asM,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          aname,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    asN,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      asO,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                asP,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_has_relation,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    asQ,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      ahas_relation,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                asR,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), asS, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var ahas_relation$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         asT,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   asU,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_has_relation,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               asV,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         ahas_relation$0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   asW,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), asX, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$590 = [];
		               function pp_id$4(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$590[1], fmt, cont);
		               }
		               var _1$50 = Table[1], _0$48 = Workspace[1];
		               caml_update_dummy(bPN, [0, _1$50, _0$48]);
		               caml_update_dummy(letrec_function_context$590, [0, pp$40]);
		               var bNY = [];
		               function extras_schema_versioned$4(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNY[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNY[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNY[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bNY[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Table[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Workspace[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var table_id = param[2][1], workspace_id = param[1];
		             return cont([0, workspace_id, table_id]);
		            },
		            function(param, cont){
		             var table_id = param[2], workspace_id = param[1];
		             return cont([0, workspace_id, [0, table_id, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bNY[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bNY[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$591 = [];
		               function action_schema_versioned$4(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$591[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$591[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$591[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$591[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                asZ,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   }
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  cst_created,
		                                  cst_Created,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var has_relation = param[2][1], name = param[1];
		                                     return cont([0, name, has_relation]);
		                                    },
		                                    function(param, cont){
		                                     var has_relation = param[2], name = param[1];
		                                     return cont([0, name, [0, has_relation, 0]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_name,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_has_relation,
		                                       0,
		                                       2,
		                                       [0, bool_schema],
		                                       0,
		                                       0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_edited,
		                                   cst_Edited,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var has_relation = param[1];
		                                      return cont(has_relation);
		                                     },
		                                     function(has_relation, cont){
		                                      return cont([0, has_relation, 0]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_has_relation,
		                                       0,
		                                       2,
		                                       [0, bool_schema],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){
		                                     return typeof param === "number" ? cont(asY) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_deleted,
		                                    cst_Deleted,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$591[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$591[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function id_schema_versioned$4(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$108,
		                                   schematic_version,
		                                   function(a){return cont([0, as1, as0, a[3], a[4]]);});
		                         });
		               }
		               var schematic_cache$541 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNY, [0, schematic_cache$541]);
		               var schematic_cache$542 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$591, [0, schematic_cache$542]);
		               caml_callback
		                (extras_schema_versioned$4,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned$4,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (id_schema_versioned$4,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$101 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$4,
		                      ,
		                      pp_id$4,
		                      ,
		                      action_schema_versioned$4,
		                      ,
		                      pp_action$4,
		                      ,
		                      extras_schema_versioned$4,
		                      ,
		                      pp_extras$4,
		                      ,
		                      cst_database]]),
		                id_schema_versioned$5 = include$101[1],
		                pp_id$5 = include$101[3],
		                action_schema$4 = include$101[6],
		                schema_versioned$326 = include$101[14],
		                pp$105 = include$101[16],
		                cst_shortcut = "shortcut",
		                letrec_function_context$592 = [];
		               function schema_versioned$327(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$592[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, as2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$592[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$592[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$592[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (change_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  as3,
		  [0,
		   [0,
		    function(param, cont){
		     var f1 = param[2], f0 = param[1];
		     return cont([0, f0, f1]);
		    },
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f1 = param[2], f0 = param[1];
		     return cont([0, [0, f0, f1]]);
		    },
		    1,
		    0,
		    cst_created,
		    cst_Created,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var shortcut = param[2][1], action = param[1];
		       return cont([0, action, shortcut]);
		      },
		      function(param, cont){
		       var shortcut = param[2], action = param[1];
		       return cont([0, action, [0, shortcut, 0]]);
		      },
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_action,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_shortcut,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]]],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){
		      var f1 = param[2], f0 = param[1];
		      return cont([1, f0, f1]);
		     },
		     function(param, cont){
		      if(1 !== param[0]) return cont(0);
		      var f1 = param[2], f0 = param[1];
		      return cont([0, [0, f0, f1]]);
		     },
		     1,
		     0,
		     cst_deleted,
		     cst_Deleted,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var shortcut = param[2][1], action = param[1];
		        return cont([0, action, shortcut]);
		       },
		       function(param, cont){
		        var shortcut = param[2], action = param[1];
		        return cont([0, action, [0, shortcut, 0]]);
		       },
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_action,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_shortcut,
		          0,
		          2,
		          [0, schematic_param_name_schema_ve],
		          0,
		          0],
		         0]]],
		      0],
		     0],
		    [0,
		     [0,
		      function(param, cont){
		       var f1 = param[2], f0 = param[1];
		       return cont([2, f0, f1]);
		      },
		      function(param, cont){
		       if(2 !== param[0]) return cont(0);
		       var f1 = param[2], f0 = param[1];
		       return cont([0, [0, f0, f1]]);
		      },
		      1,
		      0,
		      "pressed",
		      "Pressed",
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var shortcut = param[2][1], action = param[1];
		         return cont([0, action, shortcut]);
		        },
		        function(param, cont){
		         var shortcut = param[2], action = param[1];
		         return cont([0, action, [0, shortcut, 0]]);
		        },
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_action,
		          0,
		          2,
		          [0, schematic_param_name_schema_ve],
		          0,
		          0],
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_shortcut,
		           0,
		           2,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          0]]],
		       0],
		      0],
		     [0,
		      [0,
		       function(param, cont){
		        var f1 = param[2], f0 = param[1];
		        return cont([3, f0, f1]);
		       },
		       function(param, cont){
		        if(3 !== param[0]) return cont(0);
		        var f1 = param[2], f0 = param[1];
		        return cont([0, [0, f0, f1]]);
		       },
		       1,
		       0,
		       cst_edited,
		       cst_Edited,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var change = param[2][1], action = param[1];
		          return cont([0, action, change]);
		         },
		         function(param, cont){
		          var change = param[2], action = param[1];
		          return cont([0, action, [0, change, 0]]);
		         },
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_action,
		           0,
		           2,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          [0, [0, 0, 0, 0, 0, cst_change, 0, 2, [1, a], 0, 0], 0]]],
		        0],
		       0],
		      0]]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$592[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$592[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$543 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$592, [0, schematic_cache$543]);
		               var
		                schema$135 =
		                  caml_callback
		                   (schema_versioned$327,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$593 = [];
		               function _10$2(fmt, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var ashortcut = param[2], aaction = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            as4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      as5,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_action,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  as6,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aaction,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      as7,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        as8,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  as9,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_shortcut,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      as_,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        ashortcut,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  as$,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), ata, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var ashortcut$0 = param[2], aaction$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            atb,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      atc,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_action,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  atd,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aaction$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ate,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        atf,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  atg,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_shortcut,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ath,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        ashortcut$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  ati,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), atj, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var ashortcut$1 = param[2], aaction$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            atk,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      atl,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_action,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  atm,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aaction$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      atn,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        ato,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  atp,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_shortcut,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      atq,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        ashortcut$1,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  atr,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), ats, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var achange = param[2], aaction$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            att,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      atu,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_action,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  atv,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aaction$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      atw,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        atx,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  aty,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_change,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$593[1],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        achange,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  atz,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), atA, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               caml_update_dummy(letrec_function_context$593, [0, pp_change]);
		               var bNZ = [];
		               function action_schema_versioned$5(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bNZ[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bNZ[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bNZ[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bNZ[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (change_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  atE,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){
		     if(typeof param === "number" && ! param) return cont(atD);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_created,
		    cst_Created,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		      return cont(0);
		     },
		     1,
		     0,
		     cst_edited,
		     cst_Edited,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var property_name = param[1];
		        return cont(property_name);
		       },
		       function(property_name, cont){
		        return cont([0, property_name, 0]);
		       },
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_property_name,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]],
		      0],
		     0],
		    [0,
		     [0,
		      function(param, cont){return cont(1);},
		      function(param, cont){
		       if(typeof param === "number" && param) return cont(atC);
		       return cont(0);
		      },
		      0,
		      0,
		      cst_deleted,
		      cst_Deleted,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){return cont(0);},
		        function(param, cont){return cont(0);},
		        0],
		       0],
		      0],
		     [0,
		      [0,
		       function(f0, cont){return cont([1, f0]);},
		       function(param, cont){
		        if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		        return cont(0);
		       },
		       1,
		       0,
		       "moved",
		       "Moved",
		       [0,
		        0,
		        atB,
		        [7,
		         function(param, cont){
		          var change = param[1];
		          return cont(change);
		         },
		         function(change, cont){return cont([0, change, 0]);},
		         [0, [0, 0, 0, 0, 0, cst_change, 0, 2, [1, a], 0, 0], 0]],
		        0],
		       0],
		      0]]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bNZ[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bNZ[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Api = "Api",
		                cst_Console = "Console",
		                cst_Integration = "Integration",
		                cst_View = "View",
		                bN0 = [];
		               function source_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN0[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, atG, atF, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN0[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN0[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN0[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(atU);},
		                                  0,
		                                  0,
		                                  cst_console,
		                                  cst_Console,
		                                  [0, aP[1], atT, aP[3], aP[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(atS) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_block,
		                                   "Block",
		                                   [0, aO[1], atR, aO[3], aO[4]],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(atQ) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_app,
		                                    "App",
		                                    [0, aN[1], atP, aN[3], aN[4]],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(atO) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_view,
		                                     cst_View,
		                                     [0, aM[1], atN, aM[3], aM[4]],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(atM) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_api,
		                                      cst_Api,
		                                      [0, aL[1], atL, aL[3], aL[4]],
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(atK) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_integration,
		                                       cst_Integration,
		                                       [0, aK[1], atJ, aK[3], aK[4]],
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 <= param ? cont(atI) : cont(0);
		},
		0,
		0,
		cst_other,
		cst_Other,
		atH,
		0],
		                                       0]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bN0[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bN0[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bN1 = [];
		               function nature_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN1[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, atW, atV, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN1[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN1[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN1[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(at0);},
		                                  0,
		                                  0,
		                                  cst_default,
		                                  cst_Default,
		                                  atZ,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(atY) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_custom,
		                                   "Custom",
		                                   atX,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bN1[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bN1[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_nature = "nature", bN2 = [];
		               function extras_schema_versioned$5(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN2[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN2[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN2[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN2[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (source_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_source, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (extras_custom_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$195[1],
		                   b =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_extras_custom,
		                       0,
		                       [0, default$],
		                       [1, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (nature_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, cst_nature, 0, 2, [0, c], 0, 0], b];
		                            return caml_exact_trampoline_cps_call
		                                    (Workspace[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    source = b[2][1],
		    extras_custom = b[1],
		    nature = a[1],
		    workspace_id = param[1];
		   return cont
		           ([0, workspace_id, nature, extras_custom, source]);
		  },
		  function(param, cont){
		   var
		    source = param[4],
		    extras_custom = param[3],
		    nature = param[2],
		    workspace_id = param[1];
		   return cont
		           ([0,
		             workspace_id,
		             [0, nature, [0, extras_custom, [0, source, 0]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bN2[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bN2[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$594 = [];
		               function extras_custom_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$594[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, at1, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$594[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$594[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$594[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$51[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_row_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (id_schema_versioned$5,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        row_id = a[2][1],
		                        table_id = a[1],
		                        database_id = param[1];
		                       return cont([0, database_id, table_id, row_id]);
		                      },
		                      function(param, cont){
		                       var
		                        row_id = param[3],
		                        table_id = param[2],
		                        database_id = param[1];
		                       return cont([0, database_id, [0, table_id, [0, row_id, 0]]]);
		                      },
		                      [0,
		                       [0, at2, 0, 0, 0, cst_database_id, 0, 2, [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$594[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$594[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function id_schema_versioned$6(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$131,
		                                   schematic_version,
		                                   function(a){return cont([0, at3, 0, a[3], a[4]]);});
		                         });
		               }
		               var schematic_cache$544 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bNZ, [0, schematic_cache$544]);
		               var schematic_cache$545 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN0, [0, schematic_cache$545]);
		               var schematic_cache$546 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN1, [0, schematic_cache$546]);
		               var schematic_cache$547 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN2, [0, schematic_cache$547]);
		               var schematic_cache$548 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$594, [0, schematic_cache$548]);
		               caml_callback
		                (action_schema_versioned$5,
		                 [function(param, cont){return cont(0);}]);
		               var
		                source_schema =
		                  caml_callback
		                   (source_schema_versioned$0,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (nature_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$5,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_custom_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (id_schema_versioned$6,
		                 [function(param, cont){return cont(0);}]);
		               var bQj = [];
		               function pp_action$5(fmt, param, cont){
		                if(typeof param === "number")
		                 return 0 === param
		                         ? caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Object.M.Created",
		                            cont)
		                         : caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Object.M.Deleted",
		                            cont);
		                if(0 === param[0]){
		                 var aproperty_name = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          at4,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    at5,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_property_name,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                at6,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          aproperty_name,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    at7,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), at8, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var achange = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         at9,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   at_,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_change,
		     function(a){
		      return caml_trampoline_cps_call2
		              (bQj[1],
		               fmt,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         achange,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   at$,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), aua, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_source(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Object.M.Console",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Metrics_intf.Object.M.Block", cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Metrics_intf.Object.M.App", cont);
		                  case 3:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Metrics_intf.Object.M.View", cont);
		                  case 4:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Metrics_intf.Object.M.Api", cont);
		                  case 5:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Object.M.Integration",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, "Metrics_intf.Object.M.Other", cont);
		                }
		               }
		               function pp_nature(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "Metrics_intf.Object.M.Custom", cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Metrics_intf.Object.M.Default",
		                           cont);
		               }
		               var bPi = [];
		               function pp_extras$5(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         aub,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auc,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Object.M.workspace_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bPi[4],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aud,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aue,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               auf,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_nature,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (bPi[3],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aug,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         auh,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aui,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_extras_custom,
		     function(a){
		      a = x[3];
		      function b(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                auj,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          auk,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aul,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_source,
		      function(b){
		       var a = x[4];
		       return caml_trampoline_cps_call2
		               (bPi[1],
		                fmt,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aum,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), aun, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(! a)
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst_None, b);
		      var x$0 = a[1];
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string,
		               fmt,
		               cst_Some,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (bPi[2],
		                         fmt,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   x$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, fmt, cst$18, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var bPw = [];
		               function pp_extras_custom(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         auo,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aup,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Object.M.database_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bPw[3],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auq,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aur,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aus,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_table_id,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (bPw[2],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aut,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         auu,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auv,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_row_id,
		     function(b){
		      var a = x[3];
		      return caml_trampoline_cps_call2
		              (bPw[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auw,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), aux, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$595 = [];
		               function pp_id$6(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$595[1], fmt, cont);
		               }
		               caml_update_dummy(bQj, [0, pp_change]);
		               var _0$49 = Workspace[1];
		               caml_update_dummy
		                (bPi, [0, pp_source, pp_extras_custom, pp_nature, _0$49]);
		               var _2$25 = include$51[1], _1$51 = Table[1];
		               caml_update_dummy(bPw, [0, _2$25, _1$51, pp_id$5]);
		               caml_update_dummy(letrec_function_context$595, [0, pp$52]);
		               var
		                include$102 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$6,
		                      ,
		                      pp_id$6,
		                      ,
		                      action_schema_versioned$5,
		                      ,
		                      pp_action$5,
		                      ,
		                      extras_schema_versioned$5,
		                      ,
		                      pp_extras$5,
		                      ,
		                      cst_object]]),
		                action_schema$5 = include$102[6],
		                schema_versioned$328 = include$102[14],
		                _12$4 = include$102[16],
		                letrec_function_context$596 = [];
		               function schema_versioned$329(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$596[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, auy, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$596[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$596[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$596[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (edit_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  auz,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_edited,
		    cst_Edited,
		    a,
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$596[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$596[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$549 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$596, [0, schematic_cache$549]);
		               var
		                schema$136 =
		                  caml_callback
		                   (schema_versioned$329,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$597 = [];
		               function _14$0(fmt, param, cont){
		                var a0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         auA,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$597[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), auB, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$597, [0, pp_edit]);
		               var cst_params = "params", bN3 = [];
		               function schema_versioned$330(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN3[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, auC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN3[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN3[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN3[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (params_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  auE,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    "upserted",
		    "Upserted",
		    [0,
		     0,
		     auD,
		     [7,
		      function(param, cont){
		       var params = param[1];
		       return cont(params);
		      },
		      function(params, cont){return cont([0, params, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_params, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bN3[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bN3[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_has_groupings = "has_groupings",
		                cst_has_sorting = "has_sorting",
		                cst_has_visible_fields = "has_visible_fields",
		                letrec_function_context$598 = [];
		               function params_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$598[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, auF, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$598[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$598[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$598[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  has_sorting = b[2][1],
		                                  has_groupings = b[1],
		                                  has_visible_fields = a[1],
		                                  has_filter = param[1];
		                                 return cont
		 ([0,
		   has_filter,
		   has_visible_fields,
		   has_groupings,
		   has_sorting]);
		                                },
		                                function(param, cont){
		                                 var
		                                  has_sorting = param[4],
		                                  has_groupings = param[3],
		                                  has_visible_fields = param[2],
		                                  has_filter = param[1];
		                                 return cont
		 ([0,
		   has_filter,
		   [0,
		    has_visible_fields,
		    [0, has_groupings, [0, has_sorting, 0]]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, "has_filter", 0, 2, [0, bool_schema], 0, 0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_has_visible_fields,
		                                   0,
		                                   2,
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_has_groupings,
		                                    0,
		                                    2,
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_has_sorting,
		                                     0,
		                                     2,
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$598[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$598[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$550 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN3, [0, schematic_cache$550]);
		               var schematic_cache$551 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$598, [0, schematic_cache$551]);
		               var
		                schema$137 =
		                  caml_callback
		                   (schema_versioned$330,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (params_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$599 = [];
		               function _17$0(fmt, param, cont){
		                var aparams = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         auG,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auH,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_params,
		     function(a){
		      return caml_trampoline_cps_call2
		              (letrec_function_context$599[1],
		               fmt,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         aparams,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auI,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), auJ, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_params(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         auK,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auL,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.View.has_filter",
		     function(b){
		      var a = x[1];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               auM,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auN,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     auO,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               auP,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_has_visible_fields,
		                         function(b){
		                          var a = x[2];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auQ,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               auR,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         auS,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auT,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_has_groupings,
		     function(b){
		      var a = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               auU,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auV,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     auW,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               auX,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_has_sorting,
		                         function(b){
		                          var a = x[4];
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   auY,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               auZ,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), au0, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$599, [0, pp_params]);
		               function id_schema_versioned$7(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$110,
		                                   schematic_version,
		                                   function(a){return cont([0, au1, 0, a[3], a[4]]);});
		                         });
		               }
		               var bN4 = [];
		               function extras_schema_versioned$6(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN4[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN4[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN4[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN4[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id]);
		  },
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organization_id, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bN4[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bN4[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_catalog_key = "catalog_key",
		                cst_is_assistant = "is_assistant",
		                letrec_function_context$600 = [];
		               function action_schema_versioned$6(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$600[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$600[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$600[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$600[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                au4,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   }
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  cst_created,
		                                  cst_Created,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var is_assistant = param[2][1], catalog_key = param[1];
		                                     return cont([0, catalog_key, is_assistant]);
		                                    },
		                                    function(param, cont){
		                                     var is_assistant = param[2], catalog_key = param[1];
		                                     return cont([0, catalog_key, [0, is_assistant, 0]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      au3,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_catalog_key,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_is_assistant,
		                                       0,
		                                       2,
		                                       [0, bool_schema],
		                                       0,
		                                       0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_edited,
		                                   cst_Edited,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var property_name = param[1];
		                                      return cont(property_name);
		                                     },
		                                     function(property_name, cont){
		                                      return cont([0, property_name, 0]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_property_name,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){
		                                     return typeof param === "number" ? cont(au2) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_deleted,
		                                    cst_Deleted,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$600[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$600[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$552 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN4, [0, schematic_cache$552]);
		               var schematic_cache$553 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$600, [0, schematic_cache$553]);
		               caml_callback
		                (id_schema_versioned$7,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$6,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned$6,
		                 [function(param, cont){return cont(0);}]);
		               var bQk = [];
		               function pp_id$7(fmt, cont){
		                return caml_trampoline_cps_call2(bQk[1], fmt, cont);
		               }
		               var letrec_function_context$601 = [];
		               function pp_extras$6(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         au5,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   au6,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Ai_agent.M.organization_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$601[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   au7,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), au8, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_action$6(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          "Metrics_intf.Ai_agent.M.Deleted",
		                          cont);
		                if(0 === param[0]){
		                 var ais_assistant = param[2], acatalog_key = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          au9,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    au_,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_catalog_key,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                au$,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          acatalog_key,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    ava,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      avb,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                avc,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_is_assistant,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    avd,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      ais_assistant,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ave,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), avf, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var aproperty_name = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         avg,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avh,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_property_name,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avi,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         aproperty_name,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avj,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), avk, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(bQk, [0, pp$41]);
		               caml_update_dummy(letrec_function_context$601, [0, pp$37]);
		               var
		                include$103 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$7,
		                      ,
		                      pp_id$7,
		                      ,
		                      action_schema_versioned$6,
		                      ,
		                      pp_action$6,
		                      ,
		                      extras_schema_versioned$6,
		                      ,
		                      pp_extras$6,
		                      ,
		                      cst_ai_agent]]),
		                action_schema$6 = include$103[6],
		                schema_versioned$331 = include$103[14],
		                pp$106 = include$103[16];
		               function id_schema_versioned$8(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$259,
		                                   schematic_version,
		                                   function(a){return cont([0, avl, 0, a[3], a[4]]);});
		                         });
		               }
		               var bN5 = [];
		               function extras_schema_versioned$7(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN5[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN5[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN5[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN5[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id]);
		  },
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organization_id, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bN5[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bN5[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bN6 = [];
		               function message_kind_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN6[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, avm, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN6[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN6[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN6[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(avq);},
		                                  0,
		                                  0,
		                                  cst_plain,
		                                  "Plain",
		                                  avp,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(avo) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_rich,
		                                   "Rich",
		                                   avn,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bN6[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bN6[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_citation_count = "citation_count",
		                cst_has_attachments = "has_attachments",
		                cst_limit_exceeded = "limit_exceeded",
		                cst_linked_automation_run = "linked_automation_run",
		                cst_mcp_call_count = "mcp_call_count",
		                cst_tool_call_count = "tool_call_count",
		                letrec_function_context$602 = [];
		               function action_schema_versioned$7(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$602[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$602[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$602[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$602[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_has_attachments,
		                                 0,
		                                 2,
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_tool_call_count,
		                                  0,
		                                  2,
		                                  [0, int_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_mcp_call_count,
		                                   0,
		                                   2,
		                                   [0, int_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_citation_count,
		                                    0,
		                                    2,
		                                    [0, int_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_limit_exceeded,
		                                     0,
		                                     2,
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (message_kind_schema_versioned,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){return cont(0);},
		   function(param, cont){
		    return typeof param === "number" ? cont(avr) : cont(0);
		   },
		   0,
		   0,
		   cst_deleted,
		   cst_Deleted,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){return cont(0);},
		     function(param, cont){return cont(0);},
		     0],
		    0],
		   0],
		  [0,
		   [0,
		    function(param, cont){
		     var
		      f5 = param[6],
		      f4 = param[5],
		      f3 = param[4],
		      f2 = param[3],
		      f1 = param[2],
		      f0 = param[1];
		     return cont([1, f0, f1, f2, f3, f4, f5]);
		    },
		    function(param, cont){
		     if(typeof param !== "number" && 0 !== param[0]){
		      var
		       f5 = param[6],
		       f4 = param[5],
		       f3 = param[4],
		       f2 = param[3],
		       f1 = param[2],
		       f0 = param[1];
		      return cont([0, [0, f0, f1, f2, f3, f4, f5]]);
		     }
		     return cont(0);
		    },
		    1,
		    0,
		    "message_sent",
		    "Message_sent",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var
		        a = param[2],
		        b = a[2],
		        c = b[2],
		        d = c[2],
		        limit_exceeded = d[2][1],
		        citation_count = d[1],
		        mcp_call_count = c[1],
		        tool_call_count = b[1],
		        has_attachments = a[1],
		        kind = param[1];
		       return cont
		               ([0,
		                 kind,
		                 has_attachments,
		                 tool_call_count,
		                 mcp_call_count,
		                 citation_count,
		                 limit_exceeded]);
		      },
		      function(param, cont){
		       var
		        limit_exceeded = param[6],
		        citation_count = param[5],
		        mcp_call_count = param[4],
		        tool_call_count = param[3],
		        has_attachments = param[2],
		        kind = param[1];
		       return cont
		               ([0,
		                 kind,
		                 [0,
		                  has_attachments,
		                  [0,
		                   tool_call_count,
		                   [0,
		                    mcp_call_count,
		                    [0, citation_count, [0, limit_exceeded, 0]]]]]]);
		      },
		      [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, d], 0, 0], a]],
		     0],
		    0],
		   0]],
		                                       c =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_linked_automation_run,
		   0,
		   2,
		   [0, bool_schema],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$110,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            avs,
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, f0, f1]);
		              },
		              function(param, cont){
		               if(typeof param !== "number" && 0 === param[0]){
		                var f1 = param[2], f0 = param[1];
		                return cont([0, [0, f0, f1]]);
		               }
		               return cont(0);
		              },
		              1,
		              0,
		              cst_created,
		              cst_Created,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var
		                  linked_automation_run = param[2][1],
		                  agent_id = param[1];
		                 return cont([0, agent_id, linked_automation_run]);
		                },
		                function(param, cont){
		                 var linked_automation_run = param[2], agent_id = param[1];
		                 return cont([0, agent_id, [0, linked_automation_run, 0]]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, a], 0, 0], c]],
		               0],
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$602[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$602[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$554 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN5, [0, schematic_cache$554]);
		               var schematic_cache$555 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN6, [0, schematic_cache$555]);
		               var schematic_cache$556 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$602, [0, schematic_cache$556]);
		               caml_callback
		                (id_schema_versioned$8,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$7,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (message_kind_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned$7,
		                 [function(param, cont){return cont(0);}]);
		               var bQl = [];
		               function pp_id$8(fmt, cont){
		                return caml_trampoline_cps_call2(bQl[1], fmt, cont);
		               }
		               var bQm = [];
		               function pp_extras$7(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         avt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avu,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Ai_conversation.M.organization_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bQm[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avv,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), avw, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_message_kind(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Metrics_intf.Ai_conversation.M.Rich",
		                           cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Metrics_intf.Ai_conversation.M.Plain",
		                           cont);
		               }
		               var letrec_function_context$603 = [];
		               function pp_action$7(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          "Metrics_intf.Ai_conversation.M.Deleted",
		                          cont);
		                if(0 === param[0]){
		                 var alinked_automation_run = param[2], aagent_id = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          avx,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    avy,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_agent_id,
		      function(a){
		       return caml_trampoline_cps_call2
		               (letrec_function_context$603[2],
		                fmt,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          aagent_id,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    avz,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      avA,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                avB,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_linked_automation_run,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    avC,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      alinked_automation_run,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                avD,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), avE, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 alimit_exceeded = param[6],
		                 acitation_count = param[5],
		                 amcp_call_count = param[4],
		                 atool_call_count = param[3],
		                 ahas_attachments = param[2],
		                 akind = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         avF,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avG,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_kind,
		     function(a){
		      return caml_trampoline_cps_call2
		              (letrec_function_context$603[1],
		               fmt,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         akind,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avH,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     avI,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avJ,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_has_attachments,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avK,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     ahas_attachments,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avL,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         avM,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avN,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_tool_call_count,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avO,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         atool_call_count,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avP,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     avQ,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avR,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_mcp_call_count,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avS,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     amcp_call_count,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avT,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         avU,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avV,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_citation_count,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avW,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         acitation_count,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   avX,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     avY,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               avZ,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_limit_exceeded,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   av0,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     alimit_exceeded,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               av1,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), av2, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(bQl, [0, pp$85]);
		               caml_update_dummy(bQm, [0, pp$37]);
		               caml_update_dummy
		                (letrec_function_context$603, [0, pp_message_kind, pp$41]);
		               var
		                include$104 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$8,
		                      ,
		                      pp_id$8,
		                      ,
		                      action_schema_versioned$7,
		                      ,
		                      pp_action$7,
		                      ,
		                      extras_schema_versioned$7,
		                      ,
		                      pp_extras$7,
		                      ,
		                      cst_ai_conversation]]),
		                action_schema$7 = include$104[6],
		                schema_versioned$332 = include$104[14],
		                pp$107 = include$104[16];
		               function id_schema_versioned$9(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$266,
		                                   schematic_version,
		                                   function(a){return cont([0, av3, 0, a[3], a[4]]);});
		                         });
		               }
		               var bN7 = [];
		               function extras_schema_versioned$8(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN7[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN7[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN7[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN7[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id]);
		  },
		  function(param, cont){
		   var organization_id = param[1];
		   return cont([0, organization_id, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organization_id, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bN7[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bN7[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_has_agent = "has_agent",
		                cst_step_count = "step_count",
		                letrec_function_context$604 = [];
		               function action_schema_versioned$8(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$604[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$604[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$604[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$604[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                av8,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   }
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  cst_created,
		                                  cst_Created,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var has_agent = param[2][1], step_count = param[1];
		                                     return cont([0, step_count, has_agent]);
		                                    },
		                                    function(param, cont){
		                                     var has_agent = param[2], step_count = param[1];
		                                     return cont([0, step_count, [0, has_agent, 0]]);
		                                    },
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_step_count, 0, 2, [0, int_schema], 0, 0],
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_has_agent, 0, 2, [0, bool_schema], 0, 0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([1, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 !== param[0]){
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([0, [0, f0, f1]]);
		                                    }
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_edited,
		                                   cst_Edited,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var enabled = param[2][1], property_name = param[1];
		                                      return cont([0, property_name, enabled]);
		                                     },
		                                     function(param, cont){
		                                      var enabled = param[2], property_name = param[1];
		                                      return cont([0, property_name, [0, enabled, 0]]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_property_name,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0, av7, 0, 0, 0, cst_enabled, 0, 3, [0, bool_schema], 0, 0],
		                                       0]]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && ! param) return cont(av6);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_deleted,
		                                    cst_Deleted,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(1);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 1 === param)
		                                       return cont(av5);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     "step_created",
		                                     "Step_created",
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(2);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && 2 <= param)
		return cont(av4);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      "step_deleted",
		                                      "Step_deleted",
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){return cont(0);},
		function(param, cont){return cont(0);},
		0],
		                                       0],
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$604[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$604[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$557 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN7, [0, schematic_cache$557]);
		               var schematic_cache$558 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$604, [0, schematic_cache$558]);
		               caml_callback
		                (id_schema_versioned$9,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$8,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned$8,
		                 [function(param, cont){return cont(0);}]);
		               var bQn = [];
		               function pp_id$9(fmt, cont){
		                return caml_trampoline_cps_call2(bQn[1], fmt, cont);
		               }
		               var letrec_function_context$605 = [];
		               function pp_extras$8(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         av9,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   av_,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Ai_automation.M.organization_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$605[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   av$,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), awa, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_action$8(fmt, param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_automation.M.Deleted",
		                             cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_automation.M.Step_created",
		                             cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_automation.M.Step_deleted",
		                             cont);
		                 }
		                if(0 === param[0]){
		                 var ahas_agent = param[2], astep_count = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          awb,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    awc,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_step_count,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                awd,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          astep_count,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    awe,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      awf,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                awg,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          cst_has_agent,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    awh,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      ahas_agent,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                awi,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt), awj, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var aenabled = param[2], aproperty_name = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         awk,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awl,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_property_name,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               awm,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         aproperty_name,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awn,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     awo,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               awp,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_enabled,
		                         function(b){
		                          function a(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    awr,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), aws, cont);
		                                    });
		                          }
		                          if(! aenabled)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_None, a);
		                          var x = aenabled[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   fmt,
		                                   cst_Some,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     awq,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               x,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, fmt, cst$18, a);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(bQn, [0, pp$87]);
		               caml_update_dummy(letrec_function_context$605, [0, pp$37]);
		               var
		                include$105 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$9,
		                      ,
		                      pp_id$9,
		                      ,
		                      action_schema_versioned$8,
		                      ,
		                      pp_action$8,
		                      ,
		                      extras_schema_versioned$8,
		                      ,
		                      pp_extras$8,
		                      ,
		                      cst_ai_automation$0]]),
		                action_schema$8 = include$105[6],
		                schema_versioned$333 = include$105[14],
		                pp$108 = include$105[16];
		               function id_schema_versioned$10(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (Automation_run[4],
		                                   schematic_version,
		                                   function(a){return cont([0, awt, 0, a[3], a[4]]);});
		                         });
		               }
		               var bN8 = [];
		               function extras_schema_versioned$9(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN8[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN8[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN8[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN8[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var automation_id = param[2][1], organization_id = param[1];
		             return cont([0, organization_id, automation_id]);
		            },
		            function(param, cont){
		             var automation_id = param[2], organization_id = param[1];
		             return cont([0, organization_id, [0, automation_id, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_organization_id, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bN8[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bN8[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bN9 = [];
		               function trigger_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN9[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, awu, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN9[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN9[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN9[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(awA);},
		                                  0,
		                                  0,
		                                  cst_manual,
		                                  cst_Manual,
		                                  awz,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(awy) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_recurrent,
		                                   cst_Recurrent,
		                                   awx,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(aww) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_commit_pattern,
		                                    cst_Commit_pattern,
		                                    awv,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bN9[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bN9[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bN_ = [];
		               function status_schema_versioned$9(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bN_[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, awB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bN_[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bN_[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bN_[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(awH);},
		                                  0,
		                                  0,
		                                  cst_completed,
		                                  cst_Completed,
		                                  awG,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(awF) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_failed,
		                                   cst_Failed,
		                                   awE,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(awD) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_paused_for_user_input,
		                                    "Paused_for_user_input",
		                                    awC,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bN_[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bN_[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_resumed = "resumed", letrec_function_context$606 = [];
		               function action_schema_versioned$9(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$606[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$606[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$606[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$606[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_step_count, 0, 2, [0, int_schema], 0, 0],
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_resumed, 0, 2, [0, bool_schema], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (status_schema_versioned$9,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (trigger_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            awI,
		            [0,
		             [0,
		              function(param, cont){
		               var
		                f3 = param[4],
		                f2 = param[3],
		                f1 = param[2],
		                f0 = param[1];
		               return cont([0, f0, f1, f2, f3]);
		              },
		              function(param, cont){
		               var
		                f3 = param[4],
		                f2 = param[3],
		                f1 = param[2],
		                f0 = param[1];
		               return cont([0, [0, f0, f1, f2, f3]]);
		              },
		              1,
		              0,
		              "finished",
		              "Finished",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var
		                  a = param[2],
		                  b = a[2],
		                  resumed = b[2][1],
		                  step_count = b[1],
		                  status = a[1],
		                  trigger = param[1];
		                 return cont([0, trigger, status, step_count, resumed]);
		                },
		                function(param, cont){
		                 var
		                  resumed = param[4],
		                  step_count = param[3],
		                  status = param[2],
		                  trigger = param[1];
		                 return cont
		                         ([0, trigger, [0, status, [0, step_count, [0, resumed, 0]]]]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, a], 0, 0], b]],
		               0],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$606[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$606[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$559 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN8, [0, schematic_cache$559]);
		               var schematic_cache$560 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN9, [0, schematic_cache$560]);
		               var schematic_cache$561 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bN_, [0, schematic_cache$561]);
		               var schematic_cache$562 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$606, [0, schematic_cache$562]);
		               caml_callback
		                (id_schema_versioned$10,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$9,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (trigger_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (status_schema_versioned$9,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned$9,
		                 [function(param, cont){return cont(0);}]);
		               var bQo = [];
		               function pp_id$10(fmt, cont){
		                return caml_trampoline_cps_call2(bQo[1], fmt, cont);
		               }
		               var bPO = [];
		               function pp_extras$9(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         awJ,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awK,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.Ai_automation_run.M.organization_id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (bPO[2],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awL,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     awM,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               awN,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_automation_id,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (bPO[1],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               awO,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), awP, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_trigger(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_automation_run.M.Manual",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_automation_run.M.Recurrent",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_automation_run.M.Commit_pattern",
		                            cont);
		                }
		               }
		               function pp_status$1(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_automation_run.M.Completed",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_automation_run.M.Failed",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_automation_run.M.Paused_for_user_input",
		                            cont);
		                }
		               }
		               var letrec_function_context$607 = [];
		               function pp_action$9(fmt, param, cont){
		                var
		                 aresumed = param[4],
		                 astep_count = param[3],
		                 astatus = param[2],
		                 atrigger = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         awQ,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awR,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_trigger,
		     function(a){
		      return caml_trampoline_cps_call2
		              (letrec_function_context$607[2],
		               fmt,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         atrigger,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awS,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     awT,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               awU,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_status,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$607[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     astatus,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               awV,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         awW,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awX,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_step_count,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               awY,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         astep_count,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   awZ,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aw0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aw1,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_resumed,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aw2,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     aresumed,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aw3,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt), aw4, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var _0$50 = Automation_run[1];
		               caml_update_dummy(bQo, [0, _0$50]);
		               caml_update_dummy(bPO, [0, pp$87, pp$37]);
		               caml_update_dummy
		                (letrec_function_context$607, [0, pp_status$1, pp_trigger]);
		               var
		                include$106 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$10,
		                      ,
		                      pp_id$10,
		                      ,
		                      action_schema_versioned$9,
		                      ,
		                      pp_action$9,
		                      ,
		                      extras_schema_versioned$9,
		                      ,
		                      pp_extras$9,
		                      ,
		                      cst_ai_automation_run]]),
		                action_schema$9 = include$106[6],
		                schema_versioned$334 = include$106[14],
		                pp$109 = include$106[16];
		               function id_schema_versioned$11(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (Id$8[4],
		                                   schematic_version,
		                                   function(a){return cont([0, aw5, 0, a[3], a[4]]);});
		                         });
		               }
		               function extras_schema_versioned$10(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (ignored_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, , , a[3], a[4]]);});
		                         });
		               }
		               var
		                cst_connected = "connected",
		                letrec_function_context$608 = [];
		               function action_schema_versioned$10(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$608[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$608[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$608[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$608[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                aw9,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   }
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  "added",
		                                  "Added",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var connected = param[2][1], transport = param[1];
		                                     return cont([0, transport, connected]);
		                                    },
		                                    function(param, cont){
		                                     var connected = param[2], transport = param[1];
		                                     return cont([0, transport, [0, connected, 0]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_transport,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_connected, 0, 2, [0, bool_schema], 0, 0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_updated,
		                                   cst_Updated,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var connected = param[1];
		                                      return cont(connected);
		                                     },
		                                     function(connected, cont){return cont([0, connected, 0]);},
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_connected, 0, 2, [0, bool_schema], 0, 0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && ! param) return cont(aw8);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_enabled,
		                                    cst_Enabled,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(1);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 1 === param)
		                                       return cont(aw7);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_disabled,
		                                     cst_Disabled,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(2);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && 2 <= param)
		return cont(aw6);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      "removed",
		                                      "Removed",
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){return cont(0);},
		function(param, cont){return cont(0);},
		0],
		                                       0],
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(f0, cont){return cont([2, f0]);},
		                                       function(param, cont){
		if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		return cont(0);
		                                       },
		                                       1,
		                                       0,
		                                       "tested",
		                                       "Tested",
		                                       [0,
		0,
		0,
		[7,
		 function(param, cont){
		  var connected = param[1];
		  return cont(connected);
		 },
		 function(connected, cont){return cont([0, connected, 0]);},
		 [0,
		  [0, 0, 0, 0, 0, cst_connected, 0, 2, [0, bool_schema], 0, 0],
		  0]],
		0],
		                                       0],
		                                      0]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$608[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$608[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$563 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$608, [0, schematic_cache$563]);
		               caml_callback
		                (id_schema_versioned$11,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (extras_schema_versioned$10,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_schema_versioned$10,
		                 [function(param, cont){return cont(0);}]);
		               var bQp = [];
		               function pp_id$11(fmt, cont){
		                return caml_trampoline_cps_call2(bQp[1], fmt, cont);
		               }
		               var letrec_function_context$609 = [];
		               function pp_extras$10(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$609[1], fmt, cont);
		               }
		               function pp_action$10(fmt, param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_mcp_server.M.Enabled",
		                             cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_mcp_server.M.Disabled",
		                             cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_mcp_server.M.Removed",
		                             cont);
		                 }
		                switch(param[0]){
		                  case 0:
		                   var aconnected = param[2], atransport = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            aw_,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aw$,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_transport,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  axa,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            atransport,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      axb,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt),
		        axc,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  axd,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            cst_connected,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      axe,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        aconnected,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  axf,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt), axg, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var aconnected$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            axh,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      axi,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_connected,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  axj,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aconnected$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      axk,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), axl, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var aconnected$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            axm,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      axn,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_connected,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  axo,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aconnected$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      axp,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), axq, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               var _0$51 = Id$8[1];
		               caml_update_dummy(bQp, [0, _0$51]);
		               caml_update_dummy(letrec_function_context$609, [0, pp_ignored]);
		               var
		                cst_ai_mcp_server = "ai_mcp_server",
		                include$107 =
		                  caml_callback
		                   (Make$13,
		                    [[0,
		                      id_schema_versioned$11,
		                      ,
		                      pp_id$11,
		                      ,
		                      action_schema_versioned$10,
		                      ,
		                      pp_action$10,
		                      ,
		                      extras_schema_versioned$10,
		                      ,
		                      pp_extras$10,
		                      ,
		                      cst_ai_mcp_server]]),
		                action_schema$10 = include$107[6],
		                schema_versioned$335 = include$107[14],
		                pp$110 = include$107[16],
		                letrec_function_context$610 = [];
		               function schema_versioned$336(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$610[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, axr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$610[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$610[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$610[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                axw,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(axv);},
		                                  0,
		                                  0,
		                                  "session_started",
		                                  "Session_started",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(axu) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   "session_confirmed",
		                                   "Session_confirmed",
		                                   [0,
		                                    0,
		                                    axt,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(axs) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    "session_cancelled",
		                                    "Session_cancelled",
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$610[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$610[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$564 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$610, [0, schematic_cache$564]);
		               var
		                schema$138 =
		                  caml_callback
		                   (schema_versioned$336,
		                    [function(param, cont){return cont(0);}]);
		               function pp$111(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_voice.Session_started",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_voice.Session_confirmed",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Metrics_intf.Ai_voice.Session_cancelled",
		                            cont);
		                }
		               }
		               var letrec_function_context$611 = [];
		               function schema_versioned$337(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$611[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, axx, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$611[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$611[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$611[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                axC,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(axB);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  "started",
		                                  "Started",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(typeof param === "number") return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   1,
		                                   0,
		                                   "stopped",
		                                   "Stopped",
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var reason = param[1];
		                                      return cont(reason);
		                                     },
		                                     function(reason, cont){return cont([0, reason, 0]);},
		                                     [0,
		                                      [0,
		                                       axA,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_reason,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(1);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 1 === param)
		                                      return cont(axz);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    "transcribed",
		                                    "Transcribed",
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(2);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 2 <= param)
		                                       return cont(axy);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     "automation_applied",
		                                     "Automation_applied",
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$611[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$611[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$565 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$611, [0, schematic_cache$565]);
		               var
		                schema$139 =
		                  caml_callback
		                   (schema_versioned$337,
		                    [function(param, cont){return cont(0);}]);
		               function pp$112(fmt, param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_recording.Started",
		                             cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_recording.Transcribed",
		                             cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Metrics_intf.Ai_recording.Automation_applied",
		                             cont);
		                 }
		                var areason = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         axD,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   axE,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_reason,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               axF,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         areason,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   axG,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), axH, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                schematic_cache$566 = [0, empty$11([0, comparator$9])],
		                bN$ = [];
		               caml_update_dummy(bN$, [0, schematic_cache$566]);
		               var
		                schematic_cache$567 = [0, empty$11([0, comparator$9])],
		                bOa = [];
		               caml_update_dummy(bOa, [0, schematic_cache$567]);
		               var
		                schematic_cache$568 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$612 = [];
		               caml_update_dummy
		                (letrec_function_context$612, [0, schematic_cache$568]);
		               function schematic_version$72(param, cont){return cont(0);}
		               var
		                cst_Ai_agent = "Ai_agent",
		                cst_Ai_automation = "Ai_automation",
		                cst_Ai_automation_run = "Ai_automation_run",
		                cst_Ai_conversation = "Ai_conversation",
		                cst_Ai_mcp_server = "Ai_mcp_server",
		                cst_Ai_recording = "Ai_recording",
		                cst_Ai_voice = "Ai_voice",
		                cst_Dashboard = "Dashboard",
		                cst_Hotkey = "Hotkey",
		                cst_Settings = "Settings",
		                cst_ai_recording = "ai_recording",
		                cst_ai_voice = "ai_voice",
		                cst_dashboard = "dashboard",
		                cst_hotkey = "hotkey",
		                schematic_schema_version$103 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bN$[1][1], schematic_schema_version$103]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bN$[1][1],
		                             schematic_schema_version$103,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bN$[1][1],
		schematic_schema_version$103,
		schematic_self,
		function(a){
		 bN$[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$321,
		          schematic_version$72,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([18, f0]);},
		                function(param, cont){
		                 if(18 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                1,
		                0,
		                cst_workspace,
		                cst_Workspace,
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var properties = param[1];
		                   return cont(properties);
		                  },
		                  function(properties, cont){return cont([0, properties, 0]);},
		                  [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, b], 0, 0], 0]],
		                 0],
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$330,
		                    schematic_version$72,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([17, f0]);},
		                          function(param, cont){
		                           if(17 !== param[0]) return cont(0);
		                           var f0 = param[1];
		                           return cont([0, f0]);
		                          },
		                          1,
		                          0,
		                          cst_view,
		                          cst_View,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var properties = param[1];
		                             return cont(properties);
		                            },
		                            function(properties, cont){return cont([0, properties, 0]);},
		                            [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                           0],
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$319,
		                              schematic_version$72,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([16, f0]);},
		                                    function(param, cont){
		                                     if(16 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_user,
		                                    cst_User,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var properties = param[1];
		                                       return cont(properties);
		                                      },
		                                      function(properties, cont){return cont([0, properties, 0]);},
		                                      [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                     0],
		                                    0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$323,
		schematic_version$72,
		function(c){
		 var
		  b =
		    [0,
		     [0,
		      function(f0, cont){return cont([15, f0]);},
		      function(param, cont){
		       if(15 !== param[0]) return cont(0);
		       var f0 = param[1];
		       return cont([0, f0]);
		      },
		      1,
		      0,
		      cst_type,
		      cst_Type,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var properties = param[1];
		         return cont(properties);
		        },
		        function(properties, cont){return cont([0, properties, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		       0],
		      0],
		     a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$329,
		          schematic_version$72,
		          function(c){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([14, f0]);},
		                function(param, cont){
		                 if(14 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                1,
		                0,
		                cst_settings,
		                cst_Settings,
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var properties = param[1];
		                   return cont(properties);
		                  },
		                  function(properties, cont){return cont([0, properties, 0]);},
		                  [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                 0],
		                0],
		               b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$320,
		                    schematic_version$72,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([13, f0]);},
		                          function(param, cont){
		                           if(13 !== param[0]) return cont(0);
		                           var f0 = param[1];
		                           return cont([0, f0]);
		                          },
		                          1,
		                          0,
		                          cst_organization,
		                          cst_Organization,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var properties = param[1];
		                             return cont(properties);
		                            },
		                            function(properties, cont){return cont([0, properties, 0]);},
		                            [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                           0],
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$328,
		                              schematic_version$72,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([12, f0]);},
		                                    function(param, cont){
		                                     if(12 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_object,
		                                    cst_Object,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var properties = param[1];
		                                       return cont(properties);
		                                      },
		                                      function(properties, cont){return cont([0, properties, 0]);},
		                                      [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                     0],
		                                    0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$322,
		schematic_version$72,
		function(c){
		 var
		  b =
		    [0,
		     [0,
		      function(f0, cont){return cont([11, f0]);},
		      function(param, cont){
		       if(11 !== param[0]) return cont(0);
		       var f0 = param[1];
		       return cont([0, f0]);
		      },
		      1,
		      0,
		      cst_integration,
		      cst_Integration,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var properties = param[1];
		         return cont(properties);
		        },
		        function(properties, cont){return cont([0, properties, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		       0],
		      0],
		     a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$327,
		          schematic_version$72,
		          function(c){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([10, f0]);},
		                function(param, cont){
		                 if(10 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                1,
		                0,
		                cst_hotkey,
		                cst_Hotkey,
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var properties = param[1];
		                   return cont(properties);
		                  },
		                  function(properties, cont){return cont([0, properties, 0]);},
		                  [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                 0],
		                0],
		               b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$326,
		                    schematic_version$72,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([9, f0]);},
		                          function(param, cont){
		                           if(9 !== param[0]) return cont(0);
		                           var f0 = param[1];
		                           return cont([0, f0]);
		                          },
		                          1,
		                          0,
		                          cst_database,
		                          cst_Database,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var properties = param[1];
		                             return cont(properties);
		                            },
		                            function(properties, cont){return cont([0, properties, 0]);},
		                            [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                           0],
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$325,
		                              schematic_version$72,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([8, f0]);},
		                                    function(param, cont){
		                                     if(8 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_dashboard,
		                                    cst_Dashboard,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var properties = param[1];
		                                       return cont(properties);
		                                      },
		                                      function(properties, cont){return cont([0, properties, 0]);},
		                                      [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                     0],
		                                    0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$324,
		schematic_version$72,
		function(c){
		 var
		  b =
		    [0,
		     [0,
		      function(f0, cont){return cont([7, f0]);},
		      function(param, cont){
		       if(7 !== param[0]) return cont(0);
		       var f0 = param[1];
		       return cont([0, f0]);
		      },
		      1,
		      0,
		      cst_console,
		      cst_Console,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var properties = param[1];
		         return cont(properties);
		        },
		        function(properties, cont){return cont([0, properties, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		       0],
		      0],
		     a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$336,
		          schematic_version$72,
		          function(c){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([6, f0]);},
		                function(param, cont){
		                 if(6 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                1,
		                0,
		                cst_ai_voice,
		                cst_Ai_voice,
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var properties = param[1];
		                   return cont(properties);
		                  },
		                  function(properties, cont){return cont([0, properties, 0]);},
		                  [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                 0],
		                0],
		               b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$337,
		                    schematic_version$72,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([5, f0]);},
		                          function(param, cont){
		                           if(5 !== param[0]) return cont(0);
		                           var f0 = param[1];
		                           return cont([0, f0]);
		                          },
		                          1,
		                          0,
		                          cst_ai_recording,
		                          cst_Ai_recording,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var properties = param[1];
		                             return cont(properties);
		                            },
		                            function(properties, cont){return cont([0, properties, 0]);},
		                            [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                           0],
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$335,
		                              schematic_version$72,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([4, f0]);},
		                                    function(param, cont){
		                                     if(4 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_ai_mcp_server,
		                                    cst_Ai_mcp_server,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var properties = param[1];
		                                       return cont(properties);
		                                      },
		                                      function(properties, cont){return cont([0, properties, 0]);},
		                                      [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                     0],
		                                    0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$332,
		schematic_version$72,
		function(c){
		 var
		  b =
		    [0,
		     [0,
		      function(f0, cont){return cont([3, f0]);},
		      function(param, cont){
		       if(3 !== param[0]) return cont(0);
		       var f0 = param[1];
		       return cont([0, f0]);
		      },
		      1,
		      0,
		      cst_ai_conversation,
		      cst_Ai_conversation,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var properties = param[1];
		         return cont(properties);
		        },
		        function(properties, cont){return cont([0, properties, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		       0],
		      0],
		     a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$334,
		          schematic_version$72,
		          function(c){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([2, f0]);},
		                function(param, cont){
		                 if(2 !== param[0]) return cont(0);
		                 var f0 = param[1];
		                 return cont([0, f0]);
		                },
		                1,
		                0,
		                cst_ai_automation_run,
		                cst_Ai_automation_run,
		                [0,
		                 0,
		                 0,
		                 [7,
		                  function(param, cont){
		                   var properties = param[1];
		                   return cont(properties);
		                  },
		                  function(properties, cont){return cont([0, properties, 0]);},
		                  [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                 0],
		                0],
		               b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$333,
		                    schematic_version$72,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([1, f0]);},
		                          function(param, cont){
		                           if(1 !== param[0]) return cont(0);
		                           var f0 = param[1];
		                           return cont([0, f0]);
		                          },
		                          1,
		                          0,
		                          cst_ai_automation$0,
		                          cst_Ai_automation,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var properties = param[1];
		                             return cont(properties);
		                            },
		                            function(properties, cont){return cont([0, properties, 0]);},
		                            [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                           0],
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$331,
		                              schematic_version$72,
		                              function(a){
		                               var
		                                res =
		                                  [11,
		                                   axI,
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([0, f0]);},
		                                     function(param, cont){
		                                      if(0 !== param[0]) return cont(0);
		                                      var f0 = param[1];
		                                      return cont([0, f0]);
		                                     },
		                                     1,
		                                     0,
		                                     cst_ai_agent,
		                                     cst_Ai_agent,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var properties = param[1];
		return cont(properties);
		                                       },
		                                       function(properties, cont){return cont([0, properties, 0]);},
		                                       [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, a], 0, 0], 0]],
		                                      0],
		                                     0],
		                                    b],
		                                   0];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bN$[1][1],
		schematic_schema_version$103,
		res,
		function(a){bN$[1][1] = a; return cont(res);});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_gender = "gender",
		                cst_internal_identifier = "internal_identifier",
		                schematic_schema_version$20 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOa[1][1], schematic_schema_version$20]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOa[1][1],
		                             schematic_schema_version$20,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOa[1][1],
		schematic_schema_version$20,
		schematic_self,
		function(a){
		 bOa[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       internal_identifier = c[2][1],
		       gender = c[1],
		       email = b[1],
		       last_name = a[1],
		       first_name = param[1];
		      return cont
		              ([0,
		                first_name,
		                last_name,
		                email,
		                gender,
		                internal_identifier]);
		     },
		     function(param, cont){
		      var
		       internal_identifier = param[5],
		       gender = param[4],
		       email = param[3],
		       last_name = param[2],
		       first_name = param[1];
		      return cont
		              ([0,
		                first_name,
		                [0,
		                 last_name,
		                 [0, email, [0, gender, [0, internal_identifier, 0]]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_first_name,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_last_name,
		        0,
		        3,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_email,
		         0,
		         3,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_gender,
		          0,
		          3,
		          [0, schematic_param_name_schema_ve],
		          0,
		          0],
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_internal_identifier,
		           0,
		           3,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          0]]]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          bOa[1][1],
		          schematic_schema_version$20,
		          res,
		          function(a){bOa[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_App_api = "App_api",
		                cst_App_controller = "App_controller",
		                cst_App_ui = "App_ui",
		                schematic_schema_version$41 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$612[1][1],
		                    schematic_schema_version$41]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$612[1][1],
		                             schematic_schema_version$41,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$612[1][1],
		schematic_schema_version$41,
		schematic_self,
		function(a){
		 letrec_function_context$612[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(axS);},
		       0,
		       0,
		       cst_app_api,
		       cst_App_api,
		       [0, aR[1], axR, aR[3], aR[4]],
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){
		         return 1 === param ? cont(axQ) : cont(0);
		        },
		        0,
		        0,
		        cst_app_controller,
		        cst_App_controller,
		        axP,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(2);},
		         function(param, cont){
		          return 2 === param ? cont(axO) : cont(0);
		         },
		         0,
		         0,
		         cst_app_ui,
		         cst_App_ui,
		         axN,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(3);},
		          function(param, cont){
		           return 3 === param ? cont(axM) : cont(0);
		          },
		          0,
		          0,
		          cst_api,
		          cst_Api,
		          [0, aQ[1], axL, aQ[3], aQ[4]],
		          0],
		         [0,
		          [0,
		           function(param, cont){return cont(4);},
		           function(param, cont){
		            return 4 <= param ? cont(axK) : cont(0);
		           },
		           0,
		           0,
		           cst_other,
		           cst_Other,
		           axJ,
		           0],
		          0]]]]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$612[1][1],
		          schematic_schema_version$41,
		          res,
		          function(a){
		           letrec_function_context$612[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var bOb = [];
		               function event_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOb[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, axT, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOb[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOb[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOb[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$321,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([18, f0]);},
		   function(param, cont){
		    if(18 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_workspace,
		   cst_Workspace,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var properties = param[1];
		      return cont(properties);
		     },
		     function(properties, cont){return cont([0, properties, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$330,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([17, f0]);},
		             function(param, cont){
		              if(17 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_view,
		             cst_View,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var properties = param[1];
		                return cont(properties);
		               },
		               function(properties, cont){return cont([0, properties, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$319,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([16, f0]);},
		                       function(param, cont){
		                        if(16 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_user,
		                       cst_User,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var properties = param[1];
		                          return cont(properties);
		                         },
		                         function(properties, cont){return cont([0, properties, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$323,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([15, f0]);},
		                                 function(param, cont){
		                                  if(15 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_type,
		                                 cst_Type,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var properties = param[1];
		                                    return cont(properties);
		                                   },
		                                   function(properties, cont){return cont([0, properties, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$329,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([14, f0]);},
		   function(param, cont){
		    if(14 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_settings,
		   cst_Settings,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var properties = param[1];
		      return cont(properties);
		     },
		     function(properties, cont){return cont([0, properties, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$320,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([13, f0]);},
		             function(param, cont){
		              if(13 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_organization,
		             cst_Organization,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var properties = param[1];
		                return cont(properties);
		               },
		               function(properties, cont){return cont([0, properties, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$328,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([12, f0]);},
		                       function(param, cont){
		                        if(12 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_object,
		                       cst_Object,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var properties = param[1];
		                          return cont(properties);
		                         },
		                         function(properties, cont){return cont([0, properties, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$322,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([11, f0]);},
		                                 function(param, cont){
		                                  if(11 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_integration,
		                                 cst_Integration,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var properties = param[1];
		                                    return cont(properties);
		                                   },
		                                   function(properties, cont){return cont([0, properties, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$327,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([10, f0]);},
		   function(param, cont){
		    if(10 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_hotkey,
		   cst_Hotkey,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var properties = param[1];
		      return cont(properties);
		     },
		     function(properties, cont){return cont([0, properties, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$326,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([9, f0]);},
		             function(param, cont){
		              if(9 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_database,
		             cst_Database,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var properties = param[1];
		                return cont(properties);
		               },
		               function(properties, cont){return cont([0, properties, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$325,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([8, f0]);},
		                       function(param, cont){
		                        if(8 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_dashboard,
		                       cst_Dashboard,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var properties = param[1];
		                          return cont(properties);
		                         },
		                         function(properties, cont){return cont([0, properties, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$324,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([7, f0]);},
		                                 function(param, cont){
		                                  if(7 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_console,
		                                 cst_Console,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var properties = param[1];
		                                    return cont(properties);
		                                   },
		                                   function(properties, cont){return cont([0, properties, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$336,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(6 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_ai_voice,
		   cst_Ai_voice,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var properties = param[1];
		      return cont(properties);
		     },
		     function(properties, cont){return cont([0, properties, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$337,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(5 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_ai_recording,
		             cst_Ai_recording,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var properties = param[1];
		                return cont(properties);
		               },
		               function(properties, cont){return cont([0, properties, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$335,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(4 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_ai_mcp_server,
		                       cst_Ai_mcp_server,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var properties = param[1];
		                          return cont(properties);
		                         },
		                         function(properties, cont){return cont([0, properties, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$332,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_ai_conversation,
		                                 cst_Ai_conversation,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var properties = param[1];
		                                    return cont(properties);
		                                   },
		                                   function(properties, cont){return cont([0, properties, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$334,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_ai_automation_run,
		   cst_Ai_automation_run,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var properties = param[1];
		      return cont(properties);
		     },
		     function(properties, cont){return cont([0, properties, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$333,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_ai_automation$0,
		             cst_Ai_automation,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var properties = param[1];
		                return cont(properties);
		               },
		               function(properties, cont){return cont([0, properties, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$331,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      axU,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        0,
		                        cst_ai_agent,
		                        cst_Ai_agent,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var properties = param[1];
		                           return cont(properties);
		                          },
		                          function(properties, cont){return cont([0, properties, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_properties, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOb[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bOb[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function attr_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0, axV, 0, no_input_schema[3], no_input_schema[4]]);
		                         });
		               }
		               var letrec_function_context$613 = [];
		               function source_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$613[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, axW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$613[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$613[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$613[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(ax6);},
		                                  0,
		                                  0,
		                                  cst_app_api,
		                                  cst_App_api,
		                                  [0, aT[1], ax5, aT[3], aT[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(ax4) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_app_controller,
		                                   cst_App_controller,
		                                   ax3,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(ax2) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_app_ui,
		                                    cst_App_ui,
		                                    ax1,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(ax0) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_api,
		                                     cst_Api,
		                                     [0, aS[1], axZ, aS[3], aS[4]],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 <= param ? cont(axY) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_other,
		                                      cst_Other,
		                                      axX,
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$613[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$613[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$569 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOb, [0, schematic_cache$569]);
		               var
		                schematic_cache$570 = [0, empty$11([0, comparator$9])],
		                bOc = [];
		               caml_update_dummy(bOc, [0, schematic_cache$570]);
		               var schematic_cache$571 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$613, [0, schematic_cache$571]);
		               var
		                event_schema =
		                  caml_callback
		                   (event_schema_versioned,
		                    [function(param, cont){return cont(0);}]),
		                schematic_schema_version$21 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOc[1][1], schematic_schema_version$21]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOc[1][1],
		                             schematic_schema_version$21,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOc[1][1],
		schematic_schema_version$21,
		schematic_self,
		function(a){
		 bOc[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       internal_identifier = c[2][1],
		       gender = c[1],
		       email = b[1],
		       last_name = a[1],
		       first_name = param[1];
		      return cont
		              ([0,
		                first_name,
		                last_name,
		                email,
		                gender,
		                internal_identifier]);
		     },
		     function(param, cont){
		      var
		       internal_identifier = param[5],
		       gender = param[4],
		       email = param[3],
		       last_name = param[2],
		       first_name = param[1];
		      return cont
		              ([0,
		                first_name,
		                [0,
		                 last_name,
		                 [0, email, [0, gender, [0, internal_identifier, 0]]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_first_name,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_last_name,
		        0,
		        3,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_email,
		         0,
		         3,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_gender,
		          0,
		          3,
		          [0, schematic_param_name_schema_ve],
		          0,
		          0],
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_internal_identifier,
		           0,
		           3,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          0]]]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          bOc[1][1],
		          schematic_schema_version$21,
		          res,
		          function(a){bOc[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (source_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var b9 = [];
		               function pp_event(fmt, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var aproperties = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ax7,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ax8,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[19],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ax9,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ax_, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var aproperties$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ax$,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aya,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[18],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayb,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayc, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var aproperties$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayd,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aye,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[17],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayf,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayg, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var aproperties$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayh,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayi,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[16],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayj,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayk, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 4:
		                   var aproperties$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayl,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aym,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[15],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayn,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayo, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 5:
		                   var aproperties$4 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayp,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayq,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[14],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayr,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ays, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 6:
		                   var aproperties$5 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayt,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayu,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[13],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$5,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayv,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayw, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 7:
		                   var aproperties$6 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayx,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayy,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[12],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$6,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayz,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayA, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 8:
		                   var aproperties$7 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayB,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayC,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[11],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$7,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayD,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayE, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 9:
		                   var aproperties$8 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayF,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayG,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[10],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$8,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayH,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayI, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 10:
		                   var aproperties$9 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayJ,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayK,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[9],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$9,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayL,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayM, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 11:
		                   var aproperties$10 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayN,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayO,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[8],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$10,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayP,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayQ, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 12:
		                   var aproperties$11 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayR,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayS,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[7],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$11,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayT,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayU, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 13:
		                   var aproperties$12 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayV,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayW,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[6],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$12,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ayX,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ayY, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 14:
		                   var aproperties$13 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ayZ,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ay0,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[5],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$13,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ay1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ay2, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 15:
		                   var aproperties$14 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ay3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ay4,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[4],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$14,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ay5,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ay6, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 16:
		                   var aproperties$15 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ay7,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ay8,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[3],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$15,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      ay9,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), ay_, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 17:
		                   var aproperties$16 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ay$,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aza,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[2],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$16,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      azb,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), azc, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var aproperties$17 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            azd,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      aze,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_properties,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (b9[1],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aproperties$17,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      azf,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), azg, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               var letrec_function_context$614 = [];
		               function pp_attr(fmt, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$614[1],
		                         0,
		                         function(a){return caml_trampoline_cps_call2(a, fmt, cont);});
		               }
		               caml_update_dummy
		                (b9,
		                 [0,
		                  _18,
		                  _17$0,
		                  _16$2,
		                  _15,
		                  _14$0,
		                  _13$2,
		                  _12$4,
		                  _11$1,
		                  _10$2,
		                  pp$105,
		                  pp$104,
		                  pp$103,
		                  pp$111,
		                  pp$112,
		                  pp$110,
		                  pp$107,
		                  pp$109,
		                  pp$108,
		                  pp$106]);
		               function _0$52(param, cont){return cont(_16);}
		               caml_update_dummy(letrec_function_context$614, [0, _0$52]);
		               var
		                cst_extra_attrs = "extra_attrs",
		                letrec_function_context$615 = [];
		               function schema_versioned$338(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$615[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(a){return cont();}
		                                    return match
		    ? a()
		    : caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$615[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$615[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$615[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (attr_schema_versioned,
		                                      schematic_version,
		                                      function(b){
		                                       var
		a =
		  [0,
		   [0,
		    azh,
		    0,
		    0,
		    0,
		    cst_extra_attrs,
		    0,
		    2,
		    [0, [0, 0, 0, mapping_schema(b)[3], 0]],
		    0,
		    0],
		   0];
		                                       return caml_exact_trampoline_cps_call
		       (event_schema_versioned,
		        schematic_version,
		        function(c){
		         var
		          b = [0, [0, azi, 0, 0, 0, cst_event, 0, 2, [0, c], 0, 0], a];
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$4,
		                  schematic_version,
		                  function(a){
		                   var
		                    res =
		                      [7,
		                       function(param, cont){
		                        var
		                         a = param[2],
		                         extra_attrs = a[2][1],
		                         event = a[1],
		                         time = param[1];
		                        return cont([0, time, event, extra_attrs]);
		                       },
		                       function(param, cont){
		                        var
		                         extra_attrs = param[3],
		                         event = param[2],
		                         time = param[1];
		                        return cont([0, time, [0, event, [0, extra_attrs, 0]]]);
		                       },
		                       [0, [0, azj, 0, 0, 0, cst_time, 0, 2, [0, a], 0, 0], b]];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$615[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context$615[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                   });
		                         });
		               }
		               var schematic_cache$572 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$615, [0, schematic_cache$572]);
		               caml_callback
		                (schema_versioned$338,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$616 = [];
		               function pp$113(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         azk,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   azl,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Metrics_intf.time",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$616[3],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   azm,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     azn,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               azo,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_event,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$616[2],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               azp,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         azq,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   azr,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_extra_attrs,
		     function(a){
		      var x$0 = x[3];
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               azs,
		               function(b){
		                function a(accu, l$0){
		                 if(! l$0)
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           azy,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     azz,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt), azA, cont);
		                                     });
		                           });
		                 var l = l$0[2], a$0 = l$0[1];
		                 function b(b){
		                  var a1 = a$0[2], a0 = a$0[1];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(fmt),
		                           azu,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (fprintf$0(fmt),
		                                     azv,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a0,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (fprintf$0(fmt),
		                 azw,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$616[1],
		                           fmt,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a1,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(fmt),
		       azx,
		       function(b){return caml_exact_trampoline_call2(a, 1, l);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 }
		                 return accu
		                         ? caml_exact_trampoline_cps_call(fprintf$0(fmt), azt, b)
		                         : b();
		                }
		                return a(0, x$0);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$616, [0, pp_attr, pp_event, _12]);
		               function event_name(event_schema, object_name, event, cont){
		                var descriptor = event_schema[3];
		                function b(field_name){
		                 function aux(param){
		                  if(! param) return 0;
		                  var a = param[1];
		                  if(95 === a){
		                   var match = param[2];
		                   if(match){
		                    var tl = match[2], a$0 = match[1];
		                    return [0, 32, aux([0, uppercase_ascii(a$0), tl])];
		                   }
		                  }
		                  var tl$0 = param[2];
		                  return [0, a, aux(tl$0)];
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (of_char_list,
		                          aux(to_list$1(field_name)),
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (capitalize_ascii,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$109,
		      function(b){
		       return caml_trampoline_cps_call3(b, object_name, a, cont);
		      });
		                                    });
		                          });
		                }
		                if(typeof descriptor !== "number" && 11 === descriptor[0]){
		                 var
		                  cases = descriptor[2],
		                  a =
		                    function(param){
		                     function c(a){return b(value$4(a, cst$1));}
		                     if(! param) return c(0);
		                     var l = param[2], x = param[1];
		                     return caml_trampoline_cps_call2
		                             (x[2],
		                              event,
		                              function(match){
		                               var r = match ? [0, x[5]] : 0;
		                               return r ? c(r) : caml_exact_trampoline_call1(a, l);
		                              });
		                    };
		                 return a(cases);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         failwith,
		                         fmt$108,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (a, pp_descriptor$0, descriptor, descriptor, b);
		                         });
		               }
		               function object_event_name(schema, name, param, cont){
		                var action = param[2];
		                return caml_exact_trampoline_cps_call$0
		                        (event_name, schema, name, action, cont);
		               }
		               function event_name$0(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var properties = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$6,
		                            "AI Agent",
		                            properties,
		                            cont);
		                  case 1:
		                   var properties$0 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$8,
		                            "AI Automation",
		                            properties$0,
		                            cont);
		                  case 2:
		                   var properties$1 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$9,
		                            "AI Automation Run",
		                            properties$1,
		                            cont);
		                  case 3:
		                   var properties$2 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$7,
		                            "AI Conversation",
		                            properties$2,
		                            cont);
		                  case 4:
		                   var properties$3 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$10,
		                            "AI MCP Server",
		                            properties$3,
		                            cont);
		                  case 5:
		                   var properties$4 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (event_name, schema$139, "AI Recording", properties$4, cont);
		                  case 6:
		                   var properties$5 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (event_name, schema$138, "AI Voice", properties$5, cont);
		                  case 7:
		                   var properties$6 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (event_name, schema$133, cst_Console, properties$6, cont);
		                  case 8:
		                   var properties$7 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (event_name, schema$134, cst_Dashboard, properties$7, cont);
		                  case 9:
		                   var properties$8 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$4,
		                            cst_Database,
		                            properties$8,
		                            cont);
		                  case 10:
		                   var properties$9 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (event_name, schema$135, cst_Hotkey, properties$9, cont);
		                  case 11:
		                   var properties$10 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$2,
		                            cst_Integration,
		                            properties$10,
		                            cont);
		                  case 12:
		                   var properties$11 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$5,
		                            cst_Object,
		                            properties$11,
		                            cont);
		                  case 13:
		                   var properties$12 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$0,
		                            cst_Organization,
		                            properties$12,
		                            cont);
		                  case 14:
		                   var properties$13 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (event_name, schema$136, cst_Settings, properties$13, cont);
		                  case 15:
		                   var properties$14 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$3,
		                            cst_Type,
		                            properties$14,
		                            cont);
		                  case 16:
		                   var properties$15 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema,
		                            cst_User,
		                            properties$15,
		                            cont);
		                  case 17:
		                   var properties$16 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (event_name, schema$137, cst_View, properties$16, cont);
		                  default:
		                   var properties$17 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (object_event_name,
		                            action_schema$1,
		                            cst_Workspace,
		                            properties$17,
		                            cont);
		                }
		               }
		               function user(id, action){
		                return [16, [0, id, action, extras]];
		               }
		               function workspace(id, organization_id, action){
		                return [18, [0, id, action, [0, organization_id]]];
		               }
		               function organization(id, action){
		                return [13, [0, id, action, extras$0]];
		               }
		               function integration(id, workspace_id, action, cont){
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         workspace_id,
		                         function(workspace_id, cont){
		                          return cont([0, workspace_id]);
		                         },
		                         function(extras){
		                          return cont([11, [0, id, action, extras]]);
		                         });
		               }
		               function object$0(id, workspace_id, source, action){
		                if(6 === id[0])
		                 var
		                  match = id[1],
		                  row_id = match[3],
		                  table_id = match[2],
		                  extras_custom$0 =
		                    [0, [0, [0, workspace_id, table_id], table_id, row_id]],
		                  extras_custom = extras_custom$0,
		                  nature = 1;
		                else {extras_custom = 0; nature = 0;}
		                return [12,
		                        [0,
		                         id,
		                         action,
		                         [0, workspace_id, nature, extras_custom, source]]];
		               }
		               function ai_agent(id, organization_id, action){
		                return [0, [0, id, action, [0, organization_id]]];
		               }
		               function ai_conversation(id, organization_id, action){return [3, [0, id, action, [0, organization_id]]];
		               }
		               function ai_automation(id, organization_id, action){return [1, [0, id, action, [0, organization_id]]];
		               }
		               function ai_mcp_server(id, action){
		                return [4, [0, id, action, extras$1]];
		               }
		               function make_edit
		               (property_name, previous_value, current_value){
		                return [0, [0, current_value, previous_value], property_name];
		               }
		               function make$57(time, extra_attrs$0, event){
		                if(time)
		                 var x = time[1], time$0 = x;
		                else
		                 var t = ocaml_ptime_clock_now_d_ps(), time$0 = t;
		                var extra_attrs = extra_attrs$0 ? extra_attrs$0[1] : 0;
		                return [0, time$0, event, extra_attrs];
		               }
		               var
		                pp$114 = include$50[1],
		                schema_versioned$339 = include$50[4],
		                schema$140 = include$50[5],
		                to_string$59 = include$50[8],
		                symbol$200 = include$50[9],
		                symbol$201 = include$50[10],
		                symbol$202 = include$50[11],
		                symbol$203 = include$50[12],
		                symbol$204 = include$50[13],
		                symbol$205 = include$50[14],
		                equal$215 = include$50[15],
		                compare$128 = include$50[16],
		                min$29 = include$50[17],
		                max$31 = include$50[18],
		                ascending$20 = include$50[19],
		                descending$20 = include$50[20],
		                between$21 = include$50[21],
		                clamp_exn$20 = include$50[22],
		                clamp$20 = include$50[23],
		                comparator$41 = include$50[24],
		                By$18 = include$50[27];
		               function Moded$15(M, Name, cont){
		                var letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      var schematic_parametric = Name[1] ? 0 : 0;
		                                      return cont
		      ([0, Name[1], 0, descriptor, schematic_parametric]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$172,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        a,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var
		                    default$ = M[5].call(null, 0),
		                    a =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_extension_row,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       0];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$4,
		                            schematic_version,
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        b,
		        function(c){
		         var
		          default$ = M[5].call(null, 0),
		          b =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_archived,
		              0,
		              [0, default$],
		              [0, c],
		              0,
		              0],
		             a];
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$140,
		                  schematic_version,
		                  function(a){
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            a,
		                            function(a){
		                             var
		                              default$ = M[5].call(null, azB),
		                              res =
		                                [7,
		                                 function(param, cont){
		                                  var
		                                   a = param[2],
		                                   extension_row = a[2][1],
		                                   archived = a[1],
		                                   notes = param[1];
		                                  return cont([0, notes, archived, extension_row]);
		                                 },
		                                 function(param, cont){
		                                  var
		                                   extension_row = param[3],
		                                   archived = param[2],
		                                   notes = param[1];
		                                  return cont
		  ([0, notes, [0, archived, [0, extension_row, 0]]]);
		                                 },
		                                 [0,
		                                  [0, azC, 0, 0, 0, cst_notes, 0, [0, default$], [0, a], 0, 0],
		                                  b]];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      res,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return cont(res);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function equal(lhs, rhs, cont){
		                           var a = rhs[1], b = lhs[1];
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[5],
		                                    letrec_function_context[6],
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (c,
		      b,
		      a,
		      function(b){
		       function a(a){
		        if(! a) return cont(a);
		        var b = rhs[3], c = lhs[3];
		        return caml_trampoline_cps_call2
		                (letrec_function_context[1],
		                 function(x, y, cont){
		                  if(x){
		                   if(y){
		                    var b = y[1], a = x[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context[2], a, b, cont);
		                   }
		                  }
		                  else if(! y) return cont(1);
		                  return cont(0);
		                 },
		                 function(a){
		                  return caml_trampoline_cps_call3(a, c, b, cont);
		                 });
		       }
		       if(! b) return a(b);
		       var c = rhs[2], d = lhs[2];
		       return caml_trampoline_cps_call2
		               (letrec_function_context[3],
		                function(x, y, cont){
		                 if(x){
		                  if(y){
		                   var b = y[1], a = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context[4], a, b, cont);
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                },
		                function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		      });
		                                    });
		                          }
		                          var _5 = M[9], _3 = M[9], _1 = M[9];
		                          caml_update_dummy
		                           (letrec_function_context,
		                            [0, _5, equal$99, _3, equal$20, _1, equal$75]);
		                          var letrec_function_context$0 = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    azD,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      azE,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "People.Moded.notes",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context$0[5],
		                          function(fmt, cont){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$0[6], fmt, cont);
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      azF,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                azG,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          azH,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_archived,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context$0[3],
		      function(fmt, param, cont){
		       if(! param)
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, fmt, cst_None, cont);
		       var x = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string,
		                fmt,
		                cst_Some,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context$0[4],
		                          fmt,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    x,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_print_string, fmt, cst$18, cont);
		                                    });
		                          });
		                });
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          azI,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    azJ,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      azK,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_extension_row,
		                function(b){
		                 var a = x[3];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context$0[1],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context$0[2],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      azL,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), azM, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var _5$0 = M[8], _3$0 = M[8], _1$0 = M[8];
		                          caml_update_dummy
		                           (letrec_function_context$0,
		                            [0, _5$0, _10$1, _3$0, _12, _1$0, _13$0]);
		                          return cont([0, schema_versioned, schema, equal, pp]);
		                         });
		               }
		               var
		                include$311 = caml_callback(Moded$15, [R$0, [0, name$7]]),
		                init_schema_versioned = include$311[1],
		                equal$216 = include$311[3],
		                include$312 = caml_callback(Moded$15, [W$0, [0, name$8]]),
		                schema$141 = include$312[2],
		                equal$217 = include$312[3],
		                letrec_function_context$617 = [];
		               function name_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$617[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, azN, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$617[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$617[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$617[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  family = b[2][1],
		                                  given = b[1],
		                                  display_last_first = a[1],
		                                  display = param[1];
		                                 return cont([0, display, display_last_first, given, family]);
		                                },
		                                function(param, cont){
		                                 var
		                                  family = param[4],
		                                  given = param[3],
		                                  display_last_first = param[2],
		                                  display = param[1];
		                                 return cont
		 ([0,
		   display,
		   [0, display_last_first, [0, given, [0, family, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_display,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   "displayLastFirst",
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "given",
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_family,
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$617[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$617[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$573 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$617, [0, schematic_cache$573]);
		               caml_callback
		                (name_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function equal_name(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                a:
		                if(c){
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b$0 = y[1], a$0 = x[1], c = a$0 === b$0 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                a:
		                if(c){
		                 var y$0 = rhs[3], x$0 = lhs[3];
		                 if(x$0){
		                  if(y$0){
		                   var b$1 = y$0[1], a$1 = x$0[1], c = a$1 === b$1 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y$0){c = 1; break a;}
		                 c = 0;
		                }
		                if(! c) return cont(c);
		                var y$1 = rhs[4], x$1 = lhs[4];
		                if(x$1){
		                 if(y$1){
		                  var b$2 = y$1[1], a$2 = x$1[1];
		                  return cont(a$2 === b$2 ? 1 : 0);
		                 }
		                }
		                else if(! y$1) return cont(1);
		                return cont(0);
		               }
		               var
		                cst_job_title = "job_title",
		                letrec_function_context$618 = [];
		               function organization_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$618[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, azO, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$618[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$618[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$618[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  current = a[2][1],
		                                  job_title = a[1],
		                                  name = param[1];
		                                 return cont([0, name, job_title, current]);
		                                },
		                                function(param, cont){
		                                 var
		                                  current = param[3],
		                                  job_title = param[2],
		                                  name = param[1];
		                                 return cont([0, name, [0, job_title, [0, current, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_job_title,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_current, 0, 3, [0, bool_schema], 0, 0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$618[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$618[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$574 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$618, [0, schematic_cache$574]);
		               caml_callback
		                (organization_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function equal_organization(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                a:
		                if(c){
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b$0 = y[1], a$0 = x[1], c = a$0 === b$0 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                if(! c) return cont(c);
		                var y$0 = rhs[3], x$0 = lhs[3];
		                if(x$0){
		                 if(y$0){
		                  var b$1 = y$0[1], a$1 = x$0[1];
		                  return cont(a$1 === b$1 ? 1 : 0);
		                 }
		                }
		                else if(! y$0) return cont(1);
		                return cont(0);
		               }
		               var
		                cst_Connections = "Connections",
		                cst_Self = "Self",
		                letrec_function_context$619 = [];
		               function schema_versioned$340(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$619[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, azP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$619[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$619[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$619[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(azX);},
		                                  0,
		                                  0,
		                                  cst_connections,
		                                  cst_Connections,
		                                  azW,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(azV) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_directory,
		                                   "Directory",
		                                   azU,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(azT) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_other,
		                                    cst_Other,
		                                    azS,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 <= param ? cont(azR) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_self,
		                                     cst_Self,
		                                     azQ,
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$619[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$619[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$575 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$619, [0, schematic_cache$575]);
		               caml_callback
		                (schema_versioned$340,
		                 [function(param, cont){return cont(0);}]);
		               function sexp_of_t$56(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(azY);
		                  case 1:
		                   return cont(azZ);
		                  case 2:
		                   return cont(az0);
		                  default: return cont(az1);
		                }
		               }
		               function compare$129(l, r, cont){
		                a:
		                {
		                 switch(l){
		                   case 0:
		                    if(! r) return cont(0); if(3 <= r) break a; return cont(-1);
		                   case 1:
		                    switch(r){
		                      case 1:
		                       return cont(0);
		                      case 2:
		                       return cont(-1);
		                      case 3:
		                       break a;
		                    }
		                    break;
		                   case 2:
		                    switch(r){
		                      case 1:
		                       return cont(1);
		                      case 2:
		                       return cont(0);
		                      case 3:
		                       break a;
		                    }
		                    break;
		                   default: return 3 <= r ? cont(0) : cont(-1);
		                 }
		                 return cont(1);
		                }
		                return cont(1);
		               }
		               var
		                include$108 = Make$2([0, compare$129, sexp_of_t$56]),
		                equal$218 = include$108[7],
		                compare$130 = include$108[8],
		                cst_otherEmails = "otherEmails",
		                letrec_function_context$620 = [];
		               function schema_versioned$341(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$620[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, az2, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$620[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$620[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$620[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (init_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$340,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_source, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (organization_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_address,
		                       0,
		                       3,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_photo,
		                        0,
		                        3,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_phones,
		                         0,
		                         2,
		                         [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_organizations,
		                          0,
		                          2,
		                          [0, [0, 0, 0, [3, c], 0]],
		                          0,
		                          0],
		                         b]]]];
		                  return caml_exact_trampoline_cps_call
		                          (name_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_name, 0, 3, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$116,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_email,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_otherEmails,
		    0,
		    2,
		    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, c], 0, 0], b]]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$339,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              i = h[2],
		              writable = i[2][1],
		              source = i[1],
		              organizations = h[1],
		              phones = g[1],
		              photo = f[1],
		              address = e[1],
		              name = d[1],
		              owner = c[1],
		              other_emails = b[1],
		              email = a[1],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       email,
		                       other_emails,
		                       owner,
		                       name,
		                       address,
		                       photo,
		                       phones,
		                       organizations,
		                       source,
		                       writable]);
		            },
		            function(param, cont){
		             var
		              writable = param[11],
		              source = param[10],
		              organizations = param[9],
		              phones = param[8],
		              photo = param[7],
		              address = param[6],
		              name = param[5],
		              owner = param[4],
		              other_emails = param[3],
		              email = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        email,
		                        [0,
		                         other_emails,
		                         [0,
		                          owner,
		                          [0,
		                           name,
		                           [0,
		                            address,
		                            [0,
		                             photo,
		                             [0,
		                              phones,
		                              [0, organizations, [0, source, [0, writable, 0]]]]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$620[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$620[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$576 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$620, [0, schematic_cache$576]);
		               var
		                schema$142 =
		                  caml_callback
		                   (schema_versioned$341,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$621 = [];
		               function equal$219(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$621[6],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                          if(c){
		                           var y = rhs[3], x = lhs[3], x$0 = x, y$0 = y;
		                           for(;;){
		                            if(x$0){
		                             if(y$0){
		                              var
		                               y$1 = y$0[2],
		                               b$0 = y$0[1],
		                               x$1 = x$0[2],
		                               a$0 = x$0[1],
		                               c = a$0 === b$0 ? 1 : 0;
		                              if(c){x$0 = x$1; y$0 = y$1; continue;}
		                              break;
		                             }
		                            }
		                            else if(! y$0){c = 1; break;}
		                            c = 0;
		                            break;
		                           }
		                          }
		                          function d(d){
		                           function c(c){
		                            a:
		                            if(c){
		                             var y = rhs[6], x = lhs[6];
		                             if(x){
		                              if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                             }
		                             else if(! y){c = 1; break a;}
		                             c = 0;
		                            }
		                            a:
		                            if(c){
		                             var y$0 = rhs[7], x$0 = lhs[7];
		                             if(x$0){
		                              if(y$0){
		                               var b$0 = y$0[1], a$0 = x$0[1], c = a$0 === b$0 ? 1 : 0;
		                               break a;
		                              }
		                             }
		                             else if(! y$0){c = 1; break a;}
		                             c = 0;
		                            }
		                            if(c){
		                             var y$1 = rhs[8], x$1 = lhs[8], x$2 = x$1, y$2 = y$1;
		                             for(;;){
		                              if(x$2){
		                               if(y$2){
		                                var
		                                 y$3 = y$2[2],
		                                 b$1 = y$2[1],
		                                 x$3 = x$2[2],
		                                 a$1 = x$2[1],
		                                 c = a$1 === b$1 ? 1 : 0;
		                                if(c){x$2 = x$3; y$2 = y$3; continue;}
		                                break;
		                               }
		                              }
		                              else if(! y$2){c = 1; break;}
		                              c = 0;
		                              break;
		                             }
		                            }
		                            function d(b){
		                             function a(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$621[1], lhs[11], rhs[11], cont)
		                                      : cont(a);
		                             }
		                             return b
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$621[2], lhs[10], rhs[10], a)
		                                     : a(b);
		                            }
		                            if(! c) return d(c);
		                            var y$4 = rhs[9], x$4 = lhs[9];
		                            function e(x, y){
		                             if(x){
		                              if(y){
		                               var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                               return caml_trampoline_cps_call3
		                                       (letrec_function_context$621[3],
		a,
		b,
		function(a){
		 return a ? caml_exact_trampoline_call2(e, x$0, y$0) : d(a);
		});
		                              }
		                             }
		                             else if(! y) return d(1);
		                             return d(0);
		                            }
		                            return e(x$4, y$4);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[5], x = lhs[5];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$621[4], a, b, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          return c
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$621[5], lhs[4], rhs[4], d)
		                                  : d(c);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$621,
		                 [0,
		                  equal$216,
		                  equal$218,
		                  equal_organization,
		                  equal_name,
		                  equal$58,
		                  equal$215]);
		               var
		                include$109 =
		                  caml_callback(Make$12, [[0, "activity", cst$21]]),
		                pp$115 = include$109[1],
		                schema_versioned$342 = include$109[4],
		                schema$143 = include$109[5],
		                symbol$206 = include$109[9],
		                symbol$207 = include$109[10],
		                symbol$208 = include$109[11],
		                symbol$209 = include$109[12],
		                symbol$210 = include$109[13],
		                symbol$211 = include$109[14],
		                equal$220 = include$109[15],
		                compare$131 = include$109[16],
		                min$30 = include$109[17],
		                max$32 = include$109[18],
		                ascending$21 = include$109[19],
		                descending$21 = include$109[20],
		                between$22 = include$109[21],
		                clamp_exn$21 = include$109[22],
		                clamp$21 = include$109[23],
		                comparator$42 = include$109[24],
		                By$19 = include$109[27],
		                make$58 = include$109[29],
		                letrec_function_context$622 = [];
		               function equal_mention_origin(lhs, rhs, cont){
		                var
		                 rhsblock = rhs[3],
		                 rhspath = rhs[2],
		                 rhsobject = rhs[1],
		                 lhsblock = lhs[3],
		                 lhspath = lhs[2],
		                 lhsobject = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$622[3],
		                         lhsobject,
		                         rhsobject,
		                         function(b){
		                          function a(a){
		                           return a
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$622[1], lhsblock, rhsblock, cont)
		                                   : cont(a);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$622[2], lhspath, rhspath, a)
		                                  : a(b);
		                         });
		               }
		               var _2$26 = include$48[15];
		               caml_update_dummy
		                (letrec_function_context$622, [0, _2$26, equal$80, equal$54]);
		               var cst_cell = "cell", letrec_function_context$623 = [];
		               function mention_origin_schema_versione
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$623[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, az4, az3, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$623[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$623[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$623[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$48[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, az5, 0, 0, 0, cst_block, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$150,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, az6, 0, 0, 0, cst_path, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$105,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){
		                         var f2 = param[3], f1 = param[2], f0 = param[1];
		                         return cont([0, f0, f1, f2]);
		                        },
		                        function(param, cont){
		                         var f2 = param[3], f1 = param[2], f0 = param[1];
		                         return cont([0, [0, f0, f1, f2]]);
		                        },
		                        1,
		                        0,
		                        cst_cell,
		                        cst_Cell,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            block = a[2][1],
		                            path = a[1],
		                            object = param[1];
		                           return cont([0, object, path, block]);
		                          },
		                          function(param, cont){
		                           var block = param[3], path = param[2], object = param[1];
		                           return cont([0, object, [0, path, [0, block, 0]]]);
		                          },
		                          [0, [0, az7, 0, 0, 0, cst_object, 0, 2, [0, a], 0, 0], b]],
		                         0],
		                        0],
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$623[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$623[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$577 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$623, [0, schematic_cache$577]);
		               var
		                mention_origin_schema =
		                  caml_callback
		                   (mention_origin_schema_versione,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$624 = [];
		               function equal_relation_origin(lhs, rhs, cont){
		                var
		                 rhspath = rhs[2],
		                 rhsobject = rhs[1],
		                 lhspath = lhs[2],
		                 lhsobject = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$624[2],
		                         lhsobject,
		                         rhsobject,
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$624[1], lhspath, rhspath, cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$624, [0, equal$80, equal$54]);
		               var letrec_function_context$625 = [];
		               function relation_origin_schema_version
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$625[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, az8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$625[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$625[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$625[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$150,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, az9, 0, 0, 0, cst_path, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$105,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, f0, f1]);
		              },
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              },
		              1,
		              0,
		              cst_cell,
		              cst_Cell,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var path = param[2][1], object = param[1];
		                 return cont([0, object, path]);
		                },
		                function(param, cont){
		                 var path = param[2], object = param[1];
		                 return cont([0, object, [0, path, 0]]);
		                },
		                [0, [0, az_, 0, 0, 0, cst_object, 0, 2, [0, b], 0, 0], a]],
		               0],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$625[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$625[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$578 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$625, [0, schematic_cache$578]);
		               caml_callback
		                (relation_origin_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var bQq = [];
		               function equal$221(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                return c
		                        ? caml_trampoline_cps_call3(bQq[1], lhs[2], rhs[2], cont)
		                        : cont(c);
		               }
		               var letrec_function_context$626 = [];
		               function equal_origin(lhs, rhs, cont){
		                var
		                 rhssource = rhs[2],
		                 rhsaccount = rhs[1],
		                 lhssource = lhs[2],
		                 lhsaccount = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$626[2],
		                         lhsaccount,
		                         rhsaccount,
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$626[1], lhssource, rhssource, cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy(bQq, [0, equal_origin]);
		               caml_update_dummy
		                (letrec_function_context$626, [0, equal$218, equal$58]);
		               var bOd = [];
		               function schema_versioned$343(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOd[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, az$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOd[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOd[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOd[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (origin_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var origin = param[2][1], error = param[1];
		   return cont([0, error, origin]);
		  },
		  function(param, cont){
		   var origin = param[2], error = param[1];
		   return cont([0, error, [0, origin, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_error,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOd[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOd[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$627 = [];
		               function origin_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$627[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAa, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$627[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$627[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$627[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$340,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, "peopleSource", 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$116,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, f0, f1]);
		              },
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              },
		              1,
		              0,
		              cst_contacts,
		              cst_Contacts,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var source = param[2][1], account = param[1];
		                 return cont([0, account, source]);
		                },
		                function(param, cont){
		                 var source = param[2], account = param[1];
		                 return cont([0, account, [0, source, 0]]);
		                },
		                [0, [0, 0, 0, 0, 0, cst_account, 0, 2, [0, b], 0, 0], a]],
		               0],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$627[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$627[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$579 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOd, [0, schematic_cache$579]);
		               var schematic_cache$580 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$627, [0, schematic_cache$580]);
		               caml_callback
		                (schema_versioned$343,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (origin_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var bPP = [];
		               function equal$222(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPP[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3(bPP[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               var letrec_function_context$628 = [];
		               function equal_origin$0(lhs, rhs, cont){
		                var rhsobject = rhs[1], lhsobject = lhs[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$628[1], lhsobject, rhsobject, cont);
		               }
		               function equal_error$0(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(1); break;
		                  case 1:
		                   if(1 === rhs) return cont(1); break;
		                  default: if(2 <= rhs) return cont(1);
		                }
		                return cont(0);
		               }
		               caml_update_dummy(bPP, [0, equal_error$0, equal_origin$0]);
		               caml_update_dummy(letrec_function_context$628, [0, equal$54]);
		               var bOe = [];
		               function schema_versioned$344(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOe[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAb, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOe[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOe[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOe[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (error_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_error, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (origin_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var error = param[2][1], origin = param[1];
		             return cont([0, origin, error]);
		            },
		            function(param, cont){
		             var error = param[2], origin = param[1];
		             return cont([0, origin, [0, error, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOe[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOe[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOf = [];
		               function origin_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOf[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOf[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOf[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOf[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$105,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  aAe,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    "object_push",
		    "Object_push",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var object = param[1];
		       return cont(object);
		      },
		      function(object, cont){return cont([0, object, 0]);},
		      [0, [0, aAd, 0, 0, 0, cst_object, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOf[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOf[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$629 = [];
		               function error_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$629[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$629[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$629[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$629[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aAl);},
		                                  0,
		                                  0,
		                                  cst_create_record_failed,
		                                  "Create_record_failed",
		                                  aAk,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aAj) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_update_record_failed,
		                                   "Update_record_failed",
		                                   aAi,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(aAh) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_delete_record_failed,
		                                    "Delete_record_failed",
		                                    aAg,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$629[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$629[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$581 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOe, [0, schematic_cache$581]);
		               var schematic_cache$582 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOf, [0, schematic_cache$582]);
		               var schematic_cache$583 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$629, [0, schematic_cache$583]);
		               caml_callback
		                (schema_versioned$344,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (origin_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (error_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$630 = [];
		               function equal$223(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$630[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$630[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$630, [0, equal$221, equal$222]);
		               var letrec_function_context$631 = [];
		               function schema_versioned$345(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$631[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAm, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$631[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$631[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$631[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$343,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_google,
		   cst_Google,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$344,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            aAn,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_integration_app,
		              cst_Integration_app,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$631[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$631[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$584 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$631, [0, schematic_cache$584]);
		               caml_callback
		                (schema_versioned$345,
		                 [function(param, cont){return cont(0);}]);
		               function equal_summary(lhs, rhs, cont){
		                var
		                 rhsshort_questions = rhs[1],
		                 lhsshort_questions = lhs[1],
		                 x = lhsshort_questions,
		                 y = rhsshort_questions;
		                for(;;){
		                 if(x){
		                  if(y){
		                   var
		                    y$0 = y[2],
		                    b = y[1],
		                    x$0 = x[2],
		                    a = x[1],
		                    c = a === b ? 1 : 0;
		                   if(! c) return cont(c);
		                   x = x$0;
		                   y = y$0;
		                   continue;
		                  }
		                 }
		                 else if(! y) return cont(1);
		                 return cont(0);
		                }
		               }
		               var letrec_function_context$632 = [];
		               function summary_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$632[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAp, aAo, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$632[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$632[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$632[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                aAq,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_questions,
		                                  cst_Questions,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var short_questions = param[1];
		                                     return cont(short_questions);
		                                    },
		                                    function(short_questions, cont){
		                                     return cont([0, short_questions, 0]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      "short_questions",
		                                      0,
		                                      2,
		                                      [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$632[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$632[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$585 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$632, [0, schematic_cache$585]);
		               caml_callback
		                (summary_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$633 = [];
		               function equal_item(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   if(0 === rhs[0]){
		                    var
		                     rhstriggered = rhs[2],
		                     rhsorigin = rhs[1],
		                     lhstriggered = lhs[2],
		                     lhsorigin = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$633[7],
		                             lhsorigin,
		                             rhsorigin,
		                             function(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$633[6],
		 lhstriggered,
		 rhstriggered,
		 cont)
		                                      : cont(a);
		                             });
		                   }
		                   break;
		                  case 1:
		                   if(1 === rhs[0]){
		                    var
		                     rhstriggered$0 = rhs[2],
		                     rhsorigin$0 = rhs[1],
		                     lhstriggered$0 = lhs[2],
		                     lhsorigin$0 = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$633[5],
		                             lhsorigin$0,
		                             rhsorigin$0,
		                             function(a){
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$633[4],
		 lhstriggered$0,
		 rhstriggered$0,
		 cont)
		                                      : cont(a);
		                             });
		                   }
		                   break;
		                  case 2:
		                   if(2 === rhs[0]){
		                    var rhserror = rhs[1], lhserror = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$633[3], lhserror, rhserror, cont);
		                   }
		                   break;
		                  default:
		                   if(3 === rhs[0]){
		                    var
		                     rhssummary = rhs[3],
		                     rhsautomation_name = rhs[2],
		                     rhsrun_id = rhs[1],
		                     lhssummary = lhs[3],
		                     lhsautomation_name = lhs[2],
		                     lhsrun_id = lhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$633[2],
		                             lhsrun_id,
		                             rhsrun_id,
		                             function(a){
		                              a =
		                               a ? lhsautomation_name === rhsautomation_name ? 1 : 0 : a;
		                              return a
		                                      ? caml_trampoline_cps_call3
		(letrec_function_context$633[1],
		 lhssummary,
		 rhssummary,
		 cont)
		                                      : cont(a);
		                             });
		                   }
		                }
		                return cont(0);
		               }
		               var _5$7 = Automation_run[15];
		               caml_update_dummy
		                (letrec_function_context$633,
		                 [0,
		                  equal_summary,
		                  _5$7,
		                  equal$223,
		                  equal$59,
		                  equal_relation_origin,
		                  equal$59,
		                  equal_mention_origin]);
		               var cst_run_id = "run_id", letrec_function_context$634 = [];
		               function item_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$634[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAs, aAr, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$634[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$634[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$634[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aAu,
		                                     aAt,
		                                     1,
		                                     1,
		                                     3,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (summary_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             aAw,
		             0,
		             0,
		             0,
		             cst_automation_name,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0, [0, aAv, 0, 0, 0, cst_summary, 0, 2, [0, c], 0, 0], 0]];
		        return caml_exact_trampoline_cps_call
		                (Automation_run[4],
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f2 = param[3], f1 = param[2], f0 = param[1];
		                        return cont([3, f0, f1, f2]);
		                       },
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f2 = param[3], f1 = param[2], f0 = param[1];
		                        return cont([0, [0, f0, f1, f2]]);
		                       },
		                       1,
		                       0,
		                       "automation_ask_user",
		                       "Automation_ask_user",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           summary = a[2][1],
		                           automation_name = a[1],
		                           run_id = param[1];
		                          return cont([0, run_id, automation_name, summary]);
		                         },
		                         function(param, cont){
		                          var
		                           summary = param[3],
		                           automation_name = param[2],
		                           run_id = param[1];
		                          return cont
		                                  ([0, run_id, [0, automation_name, [0, summary, 0]]]);
		                         },
		                         [0, [0, aAx, 0, 0, 0, cst_run_id, 0, 2, [0, d], 0, 0], b]],
		                        0],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$345,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_error,
		                                 cst_Error,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var error = param[1];
		                                    return cont(error);
		                                   },
		                                   function(error, cont){return cont([0, error, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_error, 0, 2, [0, b], 0, 0], 0]],
		                                  0],
		                                 0],
		                                c];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       cst_triggered = "triggered",
		                                       b =
		 [0, [0, aAy, 0, 0, 0, cst_triggered, 0, 2, [0, c], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (relation_origin_schema_version,
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([1, f0, f1]);
		             },
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             "set_relation",
		             "Set_relation",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var triggered = param[2][1], origin = param[1];
		                return cont([0, origin, triggered]);
		               },
		               function(param, cont){
		                var triggered = param[2], origin = param[1];
		                return cont([0, origin, [0, triggered, 0]]);
		               },
		               [0, [0, aAz, 0, 0, 0, cst_origin, 0, 2, [0, d], 0, 0], b]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$117,
		                 schematic_version,
		                 function(b){
		                  var
		                   a =
		                     [0, [0, aAA, 0, 0, 0, cst_triggered, 0, 2, [0, b], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (mention_origin_schema_versione,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                aAC,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_mention,
		                                  cst_Mention,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var triggered = param[2][1], origin = param[1];
		                                     return cont([0, origin, triggered]);
		                                    },
		                                    function(param, cont){
		                                     var triggered = param[2], origin = param[1];
		                                     return cont([0, origin, [0, triggered, 0]]);
		                                    },
		                                    [0, [0, aAB, 0, 0, 0, cst_origin, 0, 2, [0, b], 0, 0], a]],
		                                   0],
		                                  0],
		                                 c],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$634[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$634[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$586 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$634, [0, schematic_cache$586]);
		               caml_callback
		                (item_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$635 = [];
		               function equal$224(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$635[7],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(d){
		                           function c(b){
		                            function a(c){
		                             if(c) var b = rhs[5], a = lhs[5], c = a === b ? 1 : 0;
		                             function d(d){
		                              function c(c){
		                               if(! c) return cont(c);
		                               var y = rhs[8], x = lhs[8];
		                               if(x){
		                                if(y){
		                                 var b = y[1], a = x[1];
		                                 return caml_trampoline_cps_call3
		 (letrec_function_context$635[1], a, b, cont);
		                                }
		                               }
		                               else if(! y) return cont(1);
		                               return cont(0);
		                              }
		                              if(! d) return c(d);
		                              var y = rhs[7], x = lhs[7];
		                              if(x){
		                               if(y){
		                                var b = y[1], a = x[1];
		                                return caml_trampoline_cps_call3
		(letrec_function_context$635[2], a, b, c);
		                               }
		                              }
		                              else if(! y) return c(1);
		                              return c(0);
		                             }
		                             return c
		                                     ? caml_trampoline_cps_call3
		                                       (letrec_function_context$635[3], lhs[6], rhs[6], d)
		                                     : d(c);
		                            }
		                            return b
		                                    ? caml_trampoline_cps_call3
		                                      (letrec_function_context$635[4], lhs[4], rhs[4], a)
		                                    : a(b);
		                           }
		                           if(! d) return c(d);
		                           var y = rhs[3], x = lhs[3];
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$635[5], a, b, c);
		                            }
		                           }
		                           else if(! y) return c(1);
		                           return c(0);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$635[6], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$635,
		                 [0,
		                  equal$20,
		                  equal$20,
		                  equal$59,
		                  equal$44,
		                  equal_item,
		                  equal$220,
		                  equal$20]);
		               var letrec_function_context$636 = [];
		               function schema_versioned$346(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$636[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aAE, aAD, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$636[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$636[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$636[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, aAF, 0, 0, 0, cst_viewed, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, aAG, 0, 0, 0, cst_archived, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$117,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, aAJ, 0, 0, 0, cst_location, 0, 2, [0, schema$262], 0, 0],
		                      [0,
		                       [0,
		                        aAI,
		                        0,
		                        0,
		                        0,
		                        cst_message,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0, [0, aAH, 0, 0, 0, cst_recipient, 0, 2, [0, c], 0, 0], b]]];
		                  return caml_exact_trampoline_cps_call
		                          (item_schema_versioned$0,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, aAK, 0, 0, 0, cst_item, 0, 3, [1, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$342,
		                                     schematic_version,
		                                     function(c){
		                                      var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              viewed = f[2][1],
		              archived = f[1],
		              recipient = e[1],
		              message = d[1],
		              location = c[1],
		              item = b[1],
		              id = a[1],
		              created = param[1];
		             return cont
		                     ([0,
		                       created,
		                       id,
		                       item,
		                       location,
		                       message,
		                       recipient,
		                       archived,
		                       viewed]);
		            },
		            function(param, cont){
		             var
		              viewed = param[8],
		              archived = param[7],
		              recipient = param[6],
		              message = param[5],
		              location = param[4],
		              item = param[3],
		              id = param[2],
		              created = param[1];
		             return cont
		                     ([0,
		                       created,
		                       [0,
		                        id,
		                        [0,
		                         item,
		                         [0,
		                          location,
		                          [0, message, [0, recipient, [0, archived, [0, viewed, 0]]]]]]]]);
		            },
		            [0, [0, aAL, 0, 0, 0, cst_created, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$636[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$636[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$587 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$636, [0, schematic_cache$587]);
		               caml_callback
		                (schema_versioned$346,
		                 [function(param, cont){return cont(0);}]);
		               function make$59(a, opt, item, location, recipient, fmt, cont){
		                if(a)
		                 var created = a[1];
		                else
		                 var t = ocaml_ptime_clock_now_d_ps(), created = t;
		                var id = opt ? opt[1] : make$58();
		                function f(message, cont){
		                 return cont
		                         ([0, created, id, item, location, message, recipient, 0, 0]);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, f, fmt, cont);
		               }
		               function make_mention
		               (id$0,
		                created,
		                recipient,
		                triggered,
		                origin,
		                archived,
		                viewed,
		                cont){
		                var
		                 object = origin[1],
		                 row_id = object[3],
		                 table_id = object[2],
		                 workspace_id = object[1],
		                 a = include$51[1],
		                 b = Table[1];
		                function c(a, b, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (option, 0, pp$46, a, b, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$110,
		                         function(d){
		                          return caml_trampoline_cps_call7
		                                  (d,
		                                   c,
		                                   workspace_id,
		                                   b,
		                                   table_id,
		                                   a,
		                                   row_id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_string$19,
		     a,
		     function(location){
		      var a = triggered[4];
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$111,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(message){
		                          return cont
		                                  ([0,
		                                    created,
		                                    id$0,
		                                    [0, [0, origin, triggered[3]]],
		                                    location,
		                                    message,
		                                    recipient,
		                                    archived,
		                                    viewed]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function Moded$16(M, Ref, Name, cont){
		                var letrec_function_context = [];
		                function equal(lhs, rhs, cont){
		                 var a = rhs[1], b = lhs[1];
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[10],
		                          function(x, y, cont){
		                           if(x){
		                            if(y){
		                             var b = y[1], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context[11], a, b, cont);
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          },
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (c,
		                                    b,
		                                    a,
		                                    function(b){
		                                     function a(b){
		                                      function a(b){
		                                       function a(a){
		if(! a) return cont(a);
		var b = rhs[5], c = lhs[5];
		return caml_trampoline_cps_call2
		        (letrec_function_context[1],
		         function(x, y, cont){
		          if(x){
		           if(y){
		            var b = y[1], a = x[1];
		            return caml_trampoline_cps_call3
		                    (letrec_function_context[2], a, b, cont);
		           }
		          }
		          else if(! y) return cont(1);
		          return cont(0);
		         },
		         function(a){
		          return caml_trampoline_cps_call3(a, c, b, cont);
		         });
		                                       }
		                                       if(! b) return a(b);
		                                       var c = rhs[4], d = lhs[4];
		                                       return caml_trampoline_cps_call2
		       (letrec_function_context[3],
		        function(a, b, cont){return cont(a === b ? 1 : 0);},
		        function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                      }
		                                      if(! b) return a(b);
		                                      var c = rhs[3], d = lhs[3];
		                                      return caml_trampoline_cps_call2
		      (letrec_function_context[4],
		       function(x, y, cont){
		        if(x){
		         if(y){
		          var b = y[1], a = x[1];
		          return caml_trampoline_cps_call3
		                  (letrec_function_context[5], a, b, cont);
		         }
		        }
		        else if(! y) return cont(1);
		        return cont(0);
		       },
		       function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		                                     }
		                                     if(! b) return a(b);
		                                     var c = rhs[2], d = lhs[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[7],
		      letrec_function_context[9],
		      function(x, y, cont){
		       if(x){
		        if(y){
		         var b = y[1], a = x[1];
		         return caml_trampoline_cps_call3
		                 (letrec_function_context[8], a, b, cont);
		        }
		       }
		       else if(! y) return cont(1);
		       return cont(0);
		      },
		      function(b){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[6],
		                b,
		                function(b){return caml_trampoline_cps_call3(b, d, c, a);});
		      });
		                                    });
		                          });
		                }
		                var
		                 _10 = M[9],
		                 _8 = M[9],
		                 _7 = M[9],
		                 _5 = M[9],
		                 _4 = Ref[8],
		                 _3 = Document[15],
		                 _1 = M[9];
		                caml_update_dummy
		                 (letrec_function_context,
		                  [0,
		                   _10,
		                   equal$52,
		                   _8,
		                   _7,
		                   equal$99,
		                   _5,
		                   _4,
		                   _3,
		                   equal$75,
		                   _1,
		                   equal$20]);
		                function make(d, c, b, title, opt, param, cont){
		                 var archived = d ? d[1] : M[5].call(null, 0);
		                 function a(content){
		                  var
		                   extension_row = b ? b[1] : M[5].call(null, 0),
		                   parent = opt ? opt[1] : M[5].call(null, 0);
		                  return cont
		                          ([0, archived, content, extension_row, title, parent]);
		                 }
		                 return c
		                         ? a(c[1])
		                         : caml_exact_trampoline_cps_call$1
		                           (Ref[3],
		                            aAM,
		                            dummy,
		                            function(b){return a(M[5].call(null, b));});
		                }
		                var letrec_function_context$0 = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context$0[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      var schematic_parametric = Name[1] ? 0 : 0;
		                                      return cont
		      ([0, Name[1], 0, descriptor, schematic_parametric]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context$0[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$0[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context$0[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$103,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        a,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var
		                    default$ = M[5].call(null, 0),
		                    a =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_parent, 0, [0, default$], [0, b], 0, 0],
		                       0];
		                   return caml_trampoline_cps_call3
		                           (M[1],
		                            schematic_version,
		                            schematic_param_name_schema_ve,
		                            function(c){
		                             var b = M[6].call(null, 0), c = [0, c];
		                             if(b) var default$ = b[1], b = [0, default$]; else b = 2;
		                             var d = [0, [0, 0, 0, 0, 0, cst_title, 0, b, c, 0, 0], a];
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$172,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        a,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (M[1],
		                  schematic_version,
		                  a,
		                  function(b){
		                   var
		                    default$ = M[5].call(null, 0),
		                    a =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_extension_row,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       d];
		                   return caml_exact_trampoline_cps_call
		                           (Document[4],
		                            schematic_version,
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$140,
		                                      schematic_version,
		                                      function(b){
		                                       b = Ref[1].call(null, schematic_version, b);
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        b,
		        function(c){
		         var b = [0, c];
		         return caml_exact_trampoline_cps_call$1
		                 (Ref[3],
		                  aAN,
		                  dummy,
		                  function(d){
		                   var
		                    default$ = M[5].call(null, d),
		                    c =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_notes, 0, [0, default$], b, 0, 0],
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$4,
		                            schematic_version,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (option_schema,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (M[1],
		        schematic_version,
		        a,
		        function(a){
		         var
		          default$ = M[5].call(null, 0),
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               b = a[2],
		               c = b[2],
		               parent = c[2][1],
		               title = c[1],
		               extension_row = b[1],
		               content = a[1],
		               archived = param[1];
		              return cont
		                      ([0, archived, content, extension_row, title, parent]);
		             },
		             function(param, cont){
		              var
		               parent = param[5],
		               title = param[4],
		               extension_row = param[3],
		               content = param[2],
		               archived = param[1];
		              return cont
		                      ([0,
		                        archived,
		                        [0, content, [0, extension_row, [0, title, [0, parent, 0]]]]]);
		             },
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_archived,
		               0,
		               [0, default$],
		               [0, a],
		               0,
		               0],
		              c]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$0[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context$0[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context$0, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, x, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aAO,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aAP,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                "Page.Moded.archived",
		                function(b){
		                 var a = x[1];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[10],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[11],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aAQ,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                aAR,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aAS,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_content,
		                                    function(b){
		                                     var a = x[2];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[6],
		      function(fmt, cont){
		       return caml_trampoline_cps_call4
		               (letrec_function_context[7],
		                function(fmt, cont){
		                 return caml_trampoline_cps_call2
		                         (letrec_function_context[9], fmt, cont);
		                },
		                function(fmt, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, cst_None, cont);
		                 var x = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          cst_Some,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[8],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      x,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (pp_print_string, fmt, cst$18, cont);
		      });
		                                    });
		                          });
		                },
		                fmt,
		                cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aAT,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aAU,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aAV,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_extension_row,
		                function(b){
		                 var a = x[3];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[4],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[5],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aAW,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                aAX,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aAY,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    cst_title,
		                                    function(b){
		                                     var a = x[4];
		                                     return caml_trampoline_cps_call3
		     (letrec_function_context[3],
		      function(fmt, cont){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), aAZ, cont);
		      },
		      fmt,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aA0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aA1,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aA2,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                cst_parent,
		                function(b){
		                 var a = x[5];
		                 return caml_trampoline_cps_call3
		                         (letrec_function_context[1],
		                          function(fmt, param, cont){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, fmt, cst_None, cont);
		                           var x = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string,
		                                    fmt,
		                                    cst_Some,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[2],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                x,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string, fmt, cst$18, cont);
		                });
		      });
		                                    });
		                          },
		                          fmt,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt),
		      aA3,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), aA4, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var
		                           _10 = M[8],
		                           _8 = M[8],
		                           _7 = M[8],
		                           _5 = M[8],
		                           _4 = Ref[7],
		                           _3 = Document[1],
		                           _1 = M[8];
		                          caml_update_dummy
		                           (letrec_function_context,
		                            [0, _10, pp$36, _8, _7, _10$1, _5, _4, _3, _13$0, _1, _12]);
		                          return cont
		                                  ([0, equal, , make, schema_versioned, schema, pp]);
		                         });
		               }
		               var
		                Read$7 = caml_callback(Moded$16, [R$0, Left, [0, name$9]]),
		                Patch$2 = caml_callback(Moded$16, [W$0, Left, [0, name$10]]),
		                letrec_function_context$637 = [];
		               function equal$225(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$637[3],
		                         lhs[1],
		                         rhs[1],
		                         function(b){
		                          function a(a){
		                           return a
		                                   ? caml_trampoline_cps_call3
		                                     (letrec_function_context$637[1], lhs[3], rhs[3], cont)
		                                   : cont(a);
		                          }
		                          return b
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$637[2], lhs[2], rhs[2], a)
		                                  : a(b);
		                         });
		               }
		               var _2$27 = Read$7[1];
		               caml_update_dummy
		                (letrec_function_context$637, [0, _2$27, equal$52, equal$20]);
		               var letrec_function_context$638 = [];
		               function schema_versioned$347(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$638[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aA6, aA5, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$638[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$638[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$638[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Read$7[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$103,
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        writable = a[2][1],
		                        id = a[1],
		                        created = param[1];
		                       return cont([0, created, id, writable]);
		                      },
		                      function(param, cont){
		                       var writable = param[3], id = param[2], created = param[1];
		                       return cont([0, created, [0, id, [0, writable, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$638[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$638[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$588 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$638, [0, schematic_cache$588]);
		               var
		                schema$144 =
		                  caml_callback
		                   (schema_versioned$347,
		                    [function(param, cont){return cont(0);}]);
		               function error_if(error, b){
		                var b$0 = 1 - b;
		                return b$0 ? aA7 : [1, error];
		               }
		               function basic_authorize(organization, actor, permission, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         organization[1],
		                         actor,
		                         function(match){
		                          if(! match) return cont(aA_);
		                          var actor_record = match[1];
		                          function a(role_permissions){
		                           return caml_exact_trampoline_cps_call$1
		                                   (mem$3,
		                                    role_permissions,
		                                    permission,
		                                    function(a){return a ? cont(aA8) : cont(aA9);});
		                          }
		                          return actor_record[1]
		                                  ? caml_exact_trampoline_cps_call(of_list$7, all$2, a)
		                                  : caml_exact_trampoline_cps_call(of_list$7, 0, a);
		                         });
		               }
		               function auth_if_not_personal(organization, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (is_personal,
		                         organization[3][4][1],
		                         organization[3][2],
		                         function(is_personal){
		                          return cont
		                                  (error_if("the organization is personal", is_personal));
		                         });
		               }
		               function compare$132(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  case 2:
		                   if(2 === rhs) return cont(0); break;
		                  default: if(3 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   case 2:
		                    return 2;
		                   default: return 3;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var letrec_function_context$639 = [];
		               function schema_versioned$348(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$639[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aA$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$639[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$639[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$639[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aBh);},
		                                  0,
		                                  0,
		                                  cst_delete,
		                                  cst_Delete,
		                                  aBg,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aBf) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_member_invite,
		                                   cst_Member_invite,
		                                   aBe,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(aBd) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_rename,
		                                    cst_Rename,
		                                    aBc,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 <= param ? cont(aBb) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_workspace_create,
		                                     cst_Workspace_create,
		                                     aBa,
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$639[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$639[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$589 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$639, [0, schematic_cache$589]);
		               caml_callback
		                (schema_versioned$348,
		                 [function(param, cont){return cont(0);}]);
		               function pp$116(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Permission.Organization.Action.T.Delete",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Permission.Organization.Action.T.Member_invite",
		                            cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Permission.Organization.Action.T.Rename",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Permission.Organization.Action.T.Workspace_create",
		                            cont);
		                }
		               }
		               function sexp_of_t$57(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$113,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$116, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$110 = Make$2([0, compare$132, sexp_of_t$57]),
		                comparator$43 = include$110[16],
		                T$5 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$116, comparator$43, schema_versioned$348]]),
		                of_list$8 = T$5[75];
		               function schema_versioned$349(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (T$5[70],
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$349,
		                 [function(param, cont){return cont(0);}]);
		               function authorize(organization, member, action, cont){
		                var open = g(include$0), let$ = open[14];
		                function b(param, cont){
		                 return 2 === action
		                         ? cont(aBi)
		                         : caml_exact_trampoline_cps_call
		                           (auth_if_not_personal, organization, cont);
		                }
		                switch(action){
		                  case 0:
		                   var a = 0; break;
		                  case 1:
		                   a = 1; break;
		                  case 2:
		                   a = 4; break;
		                  default: a = 5;
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (basic_authorize,
		                         organization,
		                         member,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                         });
		               }
		               function compare$133(lhs, rhs, cont){return cont(0);}
		               var cst_Remove = "Remove", letrec_function_context$640 = [];
		               function schema_versioned$350(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$640[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBj, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$640[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$640[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$640[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return cont(aBl);},
		                                  0,
		                                  0,
		                                  cst_remove,
		                                  cst_Remove,
		                                  aBk,
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$640[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$640[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$590 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$640, [0, schematic_cache$590]);
		               caml_callback
		                (schema_versioned$350,
		                 [function(param, cont){return cont(0);}]);
		               function pp$117(fmt, param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         fmt,
		                         "Permission.Member.Action.T.Remove",
		                         cont);
		               }
		               function sexp_of_t$58(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$114,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$117, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$111 = Make$2([0, compare$133, sexp_of_t$58]),
		                comparator$44 = include$111[16],
		                T$6 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$117, comparator$44, schema_versioned$350]]),
		                of_list$9 = T$6[75];
		               function schema_versioned$351(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (T$6[70],
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$351,
		                 [function(param, cont){return cont(0);}]);
		               function authorize$0(organization, actor, action, member, cont){
		                var open = g(include$0), let$ = open[14];
		                return caml_exact_trampoline_cps_call$0
		                        (basic_authorize,
		                         organization,
		                         actor,
		                         2,
		                         function(basic_auth){
		                          function a(param, cont){
		                           function a(param, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$133,
		                                     actor,
		                                     member,
		                                     function(a){return a ? cont(aBm) : cont(basic_auth);});
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$133,
		                                    member,
		                                    organization[3][4][1],
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (let$,
		      error_if("cannot remove organization owner", b),
		      a,
		      cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (auth_if_not_personal,
		                                   organization,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                   });
		                         });
		               }
		               function compare$134(lhs, rhs, cont){return cont(0);}
		               var letrec_function_context$641 = [];
		               function schema_versioned$352(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$641[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$641[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$641[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$641[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return cont(aBp);},
		                                  0,
		                                  0,
		                                  cst_uninvite,
		                                  "Uninvite",
		                                  aBo,
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$641[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$641[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$591 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$641, [0, schematic_cache$591]);
		               caml_callback
		                (schema_versioned$352,
		                 [function(param, cont){return cont(0);}]);
		               function pp$118(fmt, param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string,
		                         fmt,
		                         "Permission.Invitation.Action.T.Uninvite",
		                         cont);
		               }
		               function sexp_of_t$59(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$115,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$118, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$112 = Make$2([0, compare$134, sexp_of_t$59]),
		                comparator$45 = include$112[16],
		                T$7 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$118, comparator$45, schema_versioned$352]]);
		               function schematic_version$73(param, cont){return cont(0);}
		               caml_callback(T$7[70], [schematic_version$73]);
		               function compare$135(lhs, rhs, cont){
		                switch(lhs){
		                  case 0:
		                   if(! rhs) return cont(0); break;
		                  case 1:
		                   if(1 === rhs) return cont(0); break;
		                  default: if(2 <= rhs) return cont(0);
		                }
		                function to_int(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   default: return 2;
		                 }
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var letrec_function_context$642 = [];
		               function schema_versioned$353(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$642[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBq, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$642[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$642[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$642[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aBw);},
		                                  0,
		                                  0,
		                                  cst_member_add,
		                                  "Member_add",
		                                  aBv,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aBu) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_remove,
		                                   cst_Remove,
		                                   aBt,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(aBs) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_rename,
		                                    cst_Rename,
		                                    aBr,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$642[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$642[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$592 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$642, [0, schematic_cache$592]);
		               caml_callback
		                (schema_versioned$353,
		                 [function(param, cont){return cont(0);}]);
		               function pp$119(fmt, param, cont){
		                switch(param){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Permission.Workspace.Action.T.Member_add",
		                            cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Permission.Workspace.Action.T.Remove",
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string,
		                            fmt,
		                            "Permission.Workspace.Action.T.Rename",
		                            cont);
		                }
		               }
		               function sexp_of_t$60(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$116,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$119, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$113 = Make$2([0, compare$135, sexp_of_t$60]),
		                compare$136 = include$113[8],
		                comparator$46 = include$113[16],
		                T$8 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$119, comparator$46, schema_versioned$353]]);
		               function schematic_version$74(param, cont){return cont(0);}
		               caml_callback(T$8[70], [schematic_version$74]);
		               function compare$137(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(0);
		                }
		                else if(! rhs) return cont(0);
		                function to_int(param){return param ? 1 : 0;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var cst_Read = "Read", letrec_function_context$643 = [];
		               function schema_versioned$354(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$643[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBx, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$643[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$643[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$643[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aBB);},
		                                  0,
		                                  0,
		                                  cst_read,
		                                  cst_Read,
		                                  aBA,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(aBz) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_write,
		                                   "Write",
		                                   aBy,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$643[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$643[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$593 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$643, [0, schematic_cache$593]);
		               caml_callback
		                (schema_versioned$354,
		                 [function(param, cont){return cont(0);}]);
		               function pp$120(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Permission.Workspace.Data.Action.T.Write",
		                           cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Permission.Workspace.Data.Action.T.Read",
		                           cont);
		               }
		               function sexp_of_t$61(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$117,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$120, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$114 = Make$2([0, compare$137, sexp_of_t$61]),
		                compare$138 = include$114[8],
		                comparator$47 = include$114[16],
		                T$9 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$120, comparator$47, schema_versioned$354]]);
		               function schematic_version$75(param, cont){return cont(0);}
		               caml_callback(T$9[70], [schematic_version$75]);
		               function compare$139(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs) return cont(0);
		                }
		                else if(! rhs) return cont(0);
		                function to_int(param){return param ? 1 : 0;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               var letrec_function_context$644 = [];
		               function schema_versioned$355(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$644[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$644[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$644[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$644[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aBG);},
		                                  0,
		                                  0,
		                                  cst_remove,
		                                  cst_Remove,
		                                  aBF,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(aBE) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_set_role,
		                                   "Set_role",
		                                   aBD,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$644[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$644[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$594 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$644, [0, schematic_cache$594]);
		               caml_callback
		                (schema_versioned$355,
		                 [function(param, cont){return cont(0);}]);
		               function pp$121(fmt, param, cont){
		                return param
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Permission.Workspace.Member.Action.T.Set_role",
		                           cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           "Permission.Workspace.Member.Action.T.Remove",
		                           cont);
		               }
		               function sexp_of_t$62(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$118,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$121, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$115 = Make$2([0, compare$139, sexp_of_t$62]),
		                comparator$48 = include$115[16],
		                T$10 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$121, comparator$48, schema_versioned$355]]);
		               function schema_versioned$356(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (T$10[70],
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$356,
		                 [function(param, cont){return cont(0);}]);
		               var bOg = [];
		               function subscription_creation_schema_v
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOg[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBI, aBH, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOg[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOg[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOg[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Id$1[1],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var price = param[1];
		   return cont([0, price]);
		  },
		  function(param, cont){
		   var price = param[1];
		   return cont([0, price, 0]);
		  },
		  [0, [0, aBJ, 0, 0, 0, cst_price, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOg[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOg[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOl = [];
		               function available_price_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOl[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOl[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOl[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bOl[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 aBR,
		                                 0,
		                                 0,
		                                 0,
		                                 "publicly_available",
		                                 0,
		                                 2,
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (status_schema_versioned$3,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0, aBS, 0, 0, 0, "subscription_status", 0, 3, [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$95,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              publicly_available = a[2][1],
		              subscription_status = a[1],
		              price = param[1];
		             return cont
		                     ([0, price, subscription_status, publicly_available]);
		            },
		            function(param, cont){
		             var
		              publicly_available = param[3],
		              subscription_status = param[2],
		              price = param[1];
		             return cont
		                     ([0,
		                       price,
		                       [0, subscription_status, [0, publicly_available, 0]]]);
		            },
		            [0, [0, aBT, 0, 0, 0, cst_price, 0, 2, [1, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOl[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOl[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOm = [];
		               function available_plan_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOm[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aBV, aBU, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOm[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOm[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOm[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (available_price_schema_version,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   aBW,
		   0,
		   0,
		   0,
		   "prices",
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$94,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              prices = a[2][1],
		              product = a[1],
		              plan = param[1];
		             return cont([0, plan, product, prices]);
		            },
		            function(param, cont){
		             var prices = param[3], product = param[2], plan = param[1];
		             return cont([0, plan, [0, product, [0, prices, 0]]]);
		            },
		            [0,
		             [0,
		              aBY,
		              0,
		              0,
		              0,
		              cst_plan,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0, [0, aBX, 0, 0, 0, cst_product, 0, 2, [0, b], 0, 0], a]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOm[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOm[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$595 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOg, [0, schematic_cache$595]);
		               var
		                schematic_cache$596 = [0, empty$11([0, comparator$9])],
		                bOh = [];
		               caml_update_dummy(bOh, [0, schematic_cache$596]);
		               var
		                schematic_cache$597 = [0, empty$11([0, comparator$9])],
		                bOi = [];
		               caml_update_dummy(bOi, [0, schematic_cache$597]);
		               var
		                schematic_cache$598 = [0, empty$11([0, comparator$9])],
		                bOj = [];
		               caml_update_dummy(bOj, [0, schematic_cache$598]);
		               var
		                schematic_cache$599 = [0, empty$11([0, comparator$9])],
		                bOk = [];
		               caml_update_dummy(bOk, [0, schematic_cache$599]);
		               var schematic_cache$600 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOl, [0, schematic_cache$600]);
		               var schematic_cache$601 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOm, [0, schematic_cache$601]);
		               var
		                schematic_cache$602 = [0, empty$11([0, comparator$9])],
		                bOn = [];
		               caml_update_dummy(bOn, [0, schematic_cache$602]);
		               var
		                schematic_cache$603 = [0, empty$11([0, comparator$9])],
		                bOo = [];
		               caml_update_dummy(bOo, [0, schematic_cache$603]);
		               var
		                schematic_cache$604 = [0, empty$11([0, comparator$9])],
		                bOp = [];
		               caml_update_dummy(bOp, [0, schematic_cache$604]);
		               var
		                schematic_cache$605 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$645 = [];
		               caml_update_dummy
		                (letrec_function_context$645, [0, schematic_cache$605]);
		               caml_callback
		                (subscription_creation_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$76(param, cont){return cont();}
		               var
		                cst_subscription_id = "subscription_id",
		                schematic_schema_version$102 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOh[1][1], schematic_schema_version$102]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOh[1][1],
		                             schematic_schema_version$102,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOh[1][1],
		schematic_schema_version$102,
		schematic_self,
		function(b){
		 bOh[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      aBK,
		      0,
		      0,
		      0,
		      cst_client_secret,
		      0,
		      3,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (Subscription_id[1],
		          schematic_version$76,
		          function(b){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var client_secret = param[2][1], subscription_id = param[1];
		                return cont([0, subscription_id, client_secret]);
		               },
		               function(param, cont){
		                var client_secret = param[2], subscription_id = param[1];
		                return cont([0, subscription_id, [0, client_secret, 0]]);
		               },
		               [0,
		                [0, aBL, 0, 0, 0, cst_subscription_id, 0, 2, [0, b], 0, 0],
		                a]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    bOh[1][1],
		                    schematic_schema_version$102,
		                    res,
		                    function(a){bOh[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schematic_schema_version$22 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOi[1][1], schematic_schema_version$22]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOi[1][1],
		                             schematic_schema_version$22,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOi[1][1],
		schematic_schema_version$22,
		schematic_self,
		function(a){
		 bOi[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var url = param[1];
		      return cont([0, url]);
		     },
		     function(param, cont){
		      var url = param[1];
		      return cont([0, url, 0]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$262], 0, 0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          bOi[1][1],
		          schematic_schema_version$22,
		          res,
		          function(a){bOi[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$77(param, cont){return cont();}
		               var schematic_schema_version$101 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOj[1][1], schematic_schema_version$101]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOj[1][1],
		                             schematic_schema_version$101,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOj[1][1],
		schematic_schema_version$101,
		schematic_self,
		function(a){
		 bOj[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (Subscription_id[1],
		          schematic_version$77,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var subscription_id = param[1];
		                return cont([0, subscription_id]);
		               },
		               function(param, cont){
		                var subscription_id = param[1];
		                return cont([0, subscription_id, 0]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_subscription_id, 0, 2, [0, a], 0, 0],
		                0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    bOj[1][1],
		                    schematic_schema_version$101,
		                    res,
		                    function(a){bOj[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$78(param, cont){return cont(0);}
		               var schematic_schema_version$100 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOk[1][1], schematic_schema_version$100]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOk[1][1],
		                             schematic_schema_version$100,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOk[1][1],
		schematic_schema_version$100,
		schematic_self,
		function(a){
		 bOk[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (status_schema_versioned$3,
		          schematic_version$78,
		          function(b){
		           var
		            a =
		              [0, [0, aBM, 0, 0, 0, cst_status, 0, 2, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (Id$1[1],
		                    schematic_version$78,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0, aBN, 0, 0, 0, "stripe_price", 0, 2, [0, c], 0, 0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$99,
		                              schematic_version$78,
		                              function(a){
		                               var
		                                res =
		                                  [7,
		                                   function(param, cont){
		                                    var
		                                     a = param[2],
		                                     b = a[2],
		                                     status = b[2][1],
		                                     stripe_price = b[1],
		                                     stripe_subscription = a[1],
		                                     plan = param[1];
		                                    return cont
		    ([0, plan, stripe_subscription, stripe_price, status]);
		                                   },
		                                   function(param, cont){
		                                    var
		                                     status = param[4],
		                                     stripe_price = param[3],
		                                     stripe_subscription = param[2],
		                                     plan = param[1];
		                                    return cont
		    ([0,
		      plan,
		      [0, stripe_subscription, [0, stripe_price, [0, status, 0]]]]);
		                                   },
		                                   [0,
		                                    [0,
		                                     aBP,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_plan,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0, aBO, 0, 0, 0, "stripe_subscription", 0, 2, [0, a], 0, 0],
		                                     b]]];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOk[1][1],
		schematic_schema_version$100,
		res,
		function(a){bOk[1][1] = a; return cont(res);});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (available_price_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (available_plan_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$79(param, cont){return cont(0);}
		               var schematic_schema_version$99 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOn[1][1], schematic_schema_version$99]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOn[1][1],
		                             schematic_schema_version$99,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOn[1][1],
		schematic_schema_version$99,
		schematic_self,
		function(a){
		 bOn[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (available_plan_schema_versione,
		          schematic_version$79,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var plans = param[2][1], publishableKey = param[1];
		                return cont([0, publishableKey, plans]);
		               },
		               function(param, cont){
		                var plans = param[2], publishableKey = param[1];
		                return cont([0, publishableKey, [0, plans, 0]]);
		               },
		               [0,
		                [0,
		                 aB0,
		                 0,
		                 0,
		                 0,
		                 "publishableKey",
		                 0,
		                 2,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0,
		                  aBZ,
		                  0,
		                  0,
		                  0,
		                  "plans",
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, a], 0]],
		                  0,
		                  0],
		                 0]]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    bOn[1][1],
		                    schematic_schema_version$99,
		                    res,
		                    function(a){bOn[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$80(param, cont){return cont(0);}
		               var schematic_schema_version$98 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOo[1][1], schematic_schema_version$98]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOo[1][1],
		                             schematic_schema_version$98,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOo[1][1],
		schematic_schema_version$98,
		schematic_self,
		function(b){
		 bOo[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      function(param, cont){return cont(0);},
		      function(param, cont){return param ? cont(0) : cont(aB1);},
		      0,
		      0,
		      "deleteplan",
		      "DeletePlan",
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){return cont(0);},
		        function(param, cont){return cont(0);},
		        0],
		       0],
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (subscription_creation_schema_v,
		          schematic_version$80,
		          function(b){
		           var
		            res =
		              [11,
		               aB2,
		               [0,
		                [0,
		                 function(f0, cont){return cont([0, f0]);},
		                 function(param, cont){
		                  if(! param) return cont(0);
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 0,
		                 0,
		                 "updateplan",
		                 "UpdatePlan",
		                 b,
		                 0],
		                a],
		               0];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    bOo[1][1],
		                    schematic_schema_version$98,
		                    res,
		                    function(a){bOo[1][1] = a; return cont(res);});
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$81(param, cont){return cont(0);}
		               caml_callback(schema_versioned$97, [schematic_version$81]);
		               function schematic_version$82(param, cont){return cont(0);}
		               caml_callback(query_schema_versioned, [schematic_version$82]);
		               function schematic_version$83(param, cont){return cont(0);}
		               caml_callback(result_schema_versioned, [schematic_version$83]);
		               function schematic_version$84(param, cont){return cont(0);}
		               var
		                h =
		                  caml_callback(schema_versioned$101, [schematic_version$84]),
		                customer_portal_schema = [0, aB3, 0, h[3], h[4]],
		                schematic_schema_version$23 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOp[1][1], schematic_schema_version$23]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOp[1][1],
		                             schematic_schema_version$23,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOp[1][1],
		schematic_schema_version$23,
		schematic_self,
		function(a){
		 bOp[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var ignored = param[1];
		      return cont([0, ignored]);
		     },
		     function(param, cont){
		      var ignored = param[1];
		      return cont([0, ignored, 0]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "_ignored",
		       0,
		       3,
		       [0, schematic_param_a_schema_versi],
		       0,
		       0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          bOp[1][1],
		          schematic_schema_version$23,
		          res,
		          function(a){bOp[1][1] = a; return cont(res);});
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function schematic_version$85(param, cont){return cont();}
		               var schematic_schema_version$97 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$645[1][1],
		                    schematic_schema_version$97]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$645[1][1],
		                             schematic_schema_version$97,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$645[1][1],
		schematic_schema_version$97,
		schematic_self,
		function(a){
		 letrec_function_context$645[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (Id$2[1],
		          schematic_version$85,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var id = param[1];
		                return cont([0, id]);
		               },
		               function(param, cont){
		                var id = param[1];
		                return cont([0, id, 0]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$645[1][1],
		                    schematic_schema_version$97,
		                    res,
		                    function(a){
		                     letrec_function_context$645[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$606 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$646 = [];
		               caml_update_dummy
		                (letrec_function_context$646, [0, schematic_cache$606]);
		               var schematic_schema_version$96 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$646[1][1],
		                    schematic_schema_version$96]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$646[1][1],
		                             schematic_schema_version$96,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$646[1][1],
		schematic_schema_version$96,
		schematic_self,
		function(b){
		 letrec_function_context$646[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      function(param, cont){return cont(0);},
		      function(param, cont){return param ? cont(0) : cont(aB4);},
		      0,
		      0,
		      "synced",
		      "Synced",
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){return cont(0);},
		        function(param, cont){return cont(0);},
		        0],
		       0],
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$120,
		          dummy,
		          function(b){
		           var
		            res =
		              [11,
		               aB6,
		               [0,
		                [0,
		                 function(param, cont){
		                  var f1 = param[2], f0 = param[1];
		                  return cont([0, f0, f1]);
		                 },
		                 function(param, cont){
		                  if(! param) return cont(0);
		                  var f1 = param[2], f0 = param[1];
		                  return cont([0, [0, f0, f1]]);
		                 },
		                 1,
		                 0,
		                 "crdt_notification",
		                 "Crdt_notification",
		                 [0,
		                  0,
		                  0,
		                  [7,
		                   function(param, cont){
		                    var workspace = param[2][1], message = param[1];
		                    return cont([0, message, workspace]);
		                   },
		                   function(param, cont){
		                    var workspace = param[2], message = param[1];
		                    return cont([0, message, [0, workspace, 0]]);
		                   },
		                   [0,
		                    [0,
		                     aB5,
		                     0,
		                     0,
		                     0,
		                     cst_message,
		                     0,
		                     3,
		                     [0, no_input_schema],
		                     0,
		                     0],
		                    [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], 0]]],
		                  0],
		                 0],
		                a],
		               0];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$646[1][1],
		                    schematic_schema_version$96,
		                    res,
		                    function(a){
		                     letrec_function_context$646[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                Dict =
		                  caml_callback
		                   (M$2, [[0, comparator$2, thread_id_schema_versioned]]);
		               function schematic_version$86(param, cont){return cont(0);}
		               caml_callback(schema_versioned$338, [schematic_version$86]);
		               o
		                ([0,
		                  symbol_bind$9,
		                  symbol_map$7,
		                  Let_syntax$5,
		                  ,
		                  bind$12,
		                  return$13,
		                  map$25]);
		               var
		                cst_Both = "Both",
		                cst_anonymousId = "anonymousId",
		                cst_userId = "userId",
		                letrec_function_context$647 = [];
		               function schema_versioned$357(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$647[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aB7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$647[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$647[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$647[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(param, cont){
		    var f1 = param[2], f0 = param[1];
		    return cont([2, f0, f1]);
		   },
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f1 = param[2], f0 = param[1];
		    return cont([0, [0, f0, f1]]);
		   },
		   1,
		   0,
		   "both",
		   cst_Both,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var user_id = param[2][1], anonymous_id = param[1];
		      return cont([0, anonymous_id, user_id]);
		     },
		     function(param, cont){
		      var user_id = param[2], anonymous_id = param[1];
		      return cont([0, anonymous_id, [0, user_id, 0]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_anonymousId,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0, [0, 0, 0, 0, 0, cst_userId, 0, 2, [0, b], 0, 0], 0]]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$117,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              "anonymous",
		              "Anonymous",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var anonymous_id = param[1];
		                 return cont(anonymous_id);
		                },
		                function(anonymous_id, cont){
		                 return cont([0, anonymous_id, 0]);
		                },
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_anonymousId,
		                  0,
		                  2,
		                  [0, schematic_param_name_schema_ve],
		                  0,
		                  0],
		                 0]],
		               0],
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([1, f0]);},
		               function(param, cont){
		                if(1 !== param[0]) return cont(0);
		                var f0 = param[1];
		                return cont([0, f0]);
		               },
		               1,
		               0,
		               "persistent",
		               "Persistent",
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var user_id = param[1];
		                  return cont(user_id);
		                 },
		                 function(user_id, cont){return cont([0, user_id, 0]);},
		                 [0, [0, 0, 0, 0, 0, cst_userId, 0, 2, [0, b], 0, 0], 0]],
		                0],
		               0],
		              a]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$647[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$647[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$607 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$647, [0, schematic_cache$607]);
		               caml_callback
		                (schema_versioned$357,
		                 [function(param, cont){return cont(0);}]);
		               var bOq = [];
		               function common_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOq[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aB8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOq[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOq[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOq[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (source_schema_versioned$1,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_source, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (context_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        timestamp = a[2][1],
		                        source = a[1],
		                        context = param[1];
		                       return cont([0, context, source, timestamp]);
		                      },
		                      function(param, cont){
		                       var
		                        timestamp = param[3],
		                        source = param[2],
		                        context = param[1];
		                       return cont([0, context, [0, source, [0, timestamp, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_context, 0, 3, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOq[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bOq[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOr = [];
		               function context_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOr[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aB9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOr[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOr[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOr[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (library_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_library, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$295,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_platform, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (versioned_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        library = a[2][1],
		                        platform = a[1],
		                        app = param[1];
		                       return cont([0, app, platform, library]);
		                      },
		                      function(param, cont){
		                       var library = param[3], platform = param[2], app = param[1];
		                       return cont([0, app, [0, platform, [0, library, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_app, 0, 3, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOr[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bOr[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOs = [];
		               function library_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOs[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aB_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOs[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOs[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOs[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var version = param[2][1], name = param[1];
		                                 return cont([0, name, version]);
		                                },
		                                function(param, cont){
		                                 var version = param[2], name = param[1];
		                                 return cont([0, name, [0, version, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_version,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOs[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOs[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$648 = [];
		               function versioned_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$648[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aB$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$648[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$648[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$648[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_version,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (source_schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var version = param[2][1], name = param[1];
		   return cont([0, name, version]);
		  },
		  function(param, cont){
		   var version = param[2], name = param[1];
		   return cont([0, name, [0, version, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$648[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$648[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$608 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOq, [0, schematic_cache$608]);
		               var schematic_cache$609 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOr, [0, schematic_cache$609]);
		               var schematic_cache$610 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOs, [0, schematic_cache$610]);
		               var schematic_cache$611 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$648, [0, schematic_cache$611]);
		               caml_callback
		                (common_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (context_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (library_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (versioned_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$612 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$649 = [];
		               caml_update_dummy
		                (letrec_function_context$649, [0, schematic_cache$612]);
		               function schematic_version$87(param, cont){return cont(0);}
		               var cst_traits = "traits", schematic_schema_version$95 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$649[1][1],
		                    schematic_schema_version$95]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$649[1][1],
		                             schematic_schema_version$95,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$649[1][1],
		schematic_schema_version$95,
		schematic_self,
		function(a){
		 letrec_function_context$649[1][1] = a;
		 a = [0, [0, 0, 0, mapping_schema(bool_schema)[3], 0]];
		 var
		  default$ = match$196[1],
		  b =
		    [0,
		     [0,
		      0,
		      0,
		      mapping_schema(schematic_param_name_schema_ve)[3],
		      0]],
		  default$0 = match$197[1],
		  c =
		    [0,
		     [0, 0, 0, 0, 0, cst_traits, 0, [0, default$0], b, 0, 0],
		     [0,
		      [0, 0, 0, 0, 0, cst_integrations, 0, [0, default$], a, 0, 0],
		      0]];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$117,
		          schematic_version$87,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_anonymousId,
		                0,
		                3,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0, [0, 0, 0, 0, 0, cst_userId, 0, 2, [0, b], 0, 0], c]];
		           return caml_exact_trampoline_cps_call
		                   (common_schema_versioned$1,
		                    schematic_version$87,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           c = b[2],
		                           integrations = c[2][1],
		                           traits = c[1],
		                           user_id = b[1],
		                           anonymous_id = a[1],
		                           common = param[1];
		                          return cont
		                                  ([0, common, anonymous_id, user_id, traits, integrations]);
		                         },
		                         function(param, cont){
		                          var
		                           integrations = param[5],
		                           traits = param[4],
		                           user_id = param[3],
		                           anonymous_id = param[2],
		                           common = param[1];
		                          return cont
		                                  ([0,
		                                    common,
		                                    [0,
		                                     anonymous_id,
		                                     [0, user_id, [0, traits, [0, integrations, 0]]]]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$649[1][1],
		                              schematic_schema_version$95,
		                              res,
		                              function(a){
		                               letrec_function_context$649[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$613 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$650 = [];
		               caml_update_dummy
		                (letrec_function_context$650, [0, schematic_cache$613]);
		               function schematic_version$88(param, cont){return cont(0);}
		               var schematic_schema_version$94 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$650[1][1],
		                    schematic_schema_version$94]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$650[1][1],
		                             schematic_schema_version$94,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$650[1][1],
		schematic_schema_version$94,
		schematic_self,
		function(a){
		 letrec_function_context$650[1][1] = a;
		 return caml_trampoline_cps_call3
		         (Dict[109],
		          schematic_version$88,
		          schematic_param_name_schema_ve,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (Dict[109],
		                    schematic_version$88,
		                    a,
		                    function(c){
		                     var
		                      default$ = Dict[111],
		                      a =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          mapping_schema(schematic_param_name_schema_ve)[3],
		                          0]],
		                      default$0 = match$198[1],
		                      b =
		                        [0,
		                         [0, 0, 0, 0, 0, cst_traits, 0, [0, default$0], a, 0, 0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_integrations,
		                           0,
		                           [0, default$],
		                           [0, c],
		                           0,
		                           0],
		                          0]];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$357,
		                              schematic_version$88,
		                              function(c){
		                               var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                               return caml_exact_trampoline_cps_call
		                                       (common_schema_versioned$1,
		schematic_version$88,
		function(b){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       integrations = b[2][1],
		       traits = b[1],
		       id = a[1],
		       common = param[1];
		      return cont([0, common, id, traits, integrations]);
		     },
		     function(param, cont){
		      var
		       integrations = param[4],
		       traits = param[3],
		       id = param[2],
		       common = param[1];
		      return cont
		              ([0, common, [0, id, [0, traits, [0, integrations, 0]]]]);
		     },
		     [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, b], 0, 0], a]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$650[1][1],
		          schematic_schema_version$94,
		          res,
		          function(a){
		           letrec_function_context$650[1][1] = a;
		           return cont(res);
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$614 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$651 = [];
		               caml_update_dummy
		                (letrec_function_context$651, [0, schematic_cache$614]);
		               function schematic_version$89(param, cont){return cont(0);}
		               var schematic_schema_version$93 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$651[1][1],
		                    schematic_schema_version$93]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$651[1][1],
		                             schematic_schema_version$93,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$651[1][1],
		schematic_schema_version$93,
		schematic_self,
		function(a){
		 letrec_function_context$651[1][1] = a;
		 a = [0, [0, 0, 0, mapping_schema(no_input_schema)[3], 0]];
		 var
		  default$ = match$199[1],
		  b =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      "extra_properties",
		      0,
		      [0, default$],
		      a,
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_event,
		       0,
		       0,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0]];
		 return caml_exact_trampoline_cps_call
		         (event_schema_versioned,
		          schematic_version$89,
		          function(c){
		           var
		            a =
		              [0, [0, 0, 0, 0, 0, "event_body", 0, 2, [1, c], 0, 0], b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$357,
		                    schematic_version$89,
		                    function(c){
		                     var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], a];
		                     return caml_exact_trampoline_cps_call
		                             (common_schema_versioned$1,
		                              schematic_version$89,
		                              function(a){
		                               var
		                                res =
		                                  [7,
		                                   function(param, cont){
		                                    var
		                                     a = param[2],
		                                     b = a[2],
		                                     extra_properties = b[2][1],
		                                     event_body = b[1],
		                                     id = a[1],
		                                     common = param[1];
		                                    return cont([0, common, id, event_body, extra_properties]);
		                                   },
		                                   function(param, cont){
		                                    var
		                                     extra_properties = param[4],
		                                     event_body = param[3],
		                                     id = param[2],
		                                     common = param[1];
		                                    return caml_exact_trampoline_cps_call
		    (event_name$0,
		     event_body,
		     function(a){
		      return cont
		              ([0,
		                common,
		                [0,
		                 id,
		                 [0, event_body, [0, extra_properties, [0, [0, a], 0]]]]]);
		     });
		                                   },
		                                   [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, a], 0, 0], b]];
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$651[1][1],
		schematic_schema_version$93,
		res,
		function(a){
		 letrec_function_context$651[1][1] = a;
		 return cont(res);
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$615 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$652 = [];
		               caml_update_dummy
		                (letrec_function_context$652, [0, schematic_cache$615]);
		               function schematic_version$90(param, cont){return cont(0);}
		               var schematic_schema_version$92 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$652[1][1],
		                    schematic_schema_version$92]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$652[1][1],
		                             schematic_schema_version$92,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$652[1][1],
		schematic_schema_version$92,
		schematic_self,
		function(b){
		 letrec_function_context$652[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_userId,
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "previousId",
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0]];
		 return caml_exact_trampoline_cps_call
		         (common_schema_versioned$1,
		          schematic_version$90,
		          function(b){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 previous_id = a[2][1],
		                 user_id = a[1],
		                 common = param[1];
		                return cont([0, common, user_id, previous_id]);
		               },
		               function(param, cont){
		                var
		                 previous_id = param[3],
		                 user_id = param[2],
		                 common = param[1];
		                return cont([0, common, [0, user_id, [0, previous_id, 0]]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_common, 0, 2, [1, b], 0, 0], a]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$652[1][1],
		                    schematic_schema_version$92,
		                    res,
		                    function(a){
		                     letrec_function_context$652[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                src$2 = create$18(0, "routine-metrics"),
		                Logs_sync = src_log(src$2),
		                Logs$1 = src_log$0(src$2);
		               function bRu(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, string_of_status, a, b, cont);
		               }
		               function bRv(a, cont){return cont(pp_reason$0(bRu, a));}
		               function pp_error$1(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (pp$24, bRv, a, b, cont);
		               }
		               function push_metrics(t, metrics, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3];
		                function a(param, cont){
		                 return caml_trampoline_cps_call3
		                         (t[2][2], t[1], metrics, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (Logs$1[6],
		                         function(f, cont){
		                          return caml_trampoline_cps_call6
		                                  (f, 0, 0, aCa, pp$113, metrics, cont);
		                         },
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function push_dont_wait(t, time, extra_attrs, event, cont){
		                function f(param, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4]),
		                  symbol_bind = open[1];
		                 function a(param, cont){
		                  if(0 === param[0])
		                   return caml_trampoline_cps_call2(return$12, 0, cont);
		                  var e = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (Logs$1[3],
		                           function(m, cont){
		                            return caml_trampoline_cps_call6
		                                    (m, 0, 0, aCb, pp_error$1, e, cont);
		                           },
		                           cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (push_metrics,
		                          t,
		                          make$57(time, extra_attrs, event),
		                          function(b){
		                           return caml_trampoline_cps_call3(symbol_bind, b, a, cont);
		                          });
		                }
		                function handler(exn, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Logs_sync[3],
		                          function(m, cont){
		                           return caml_trampoline_cps_call6
		                                   (m, 0, 0, aCc, pp$1, exn, cont);
		                          },
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (dont_wait, f, handler, cont);
		               }
		               var cst_Warning = "Warning", letrec_function_context$653 = [];
		               function level_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$653[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCd, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$653[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$653[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$653[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aCn);},
		                                  0,
		                                  0,
		                                  cst_debug,
		                                  "Debug",
		                                  aCm,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aCl) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_error,
		                                   cst_Error,
		                                   aCk,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(aCj) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_fatal,
		                                    "Fatal",
		                                    aCi,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(aCh) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_info,
		                                     cst_Info,
		                                     aCg,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 <= param ? cont(aCf) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_warning,
		                                      cst_Warning,
		                                      aCe,
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$653[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$653[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$616 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$653, [0, schematic_cache$616]);
		               var
		                level_schema =
		                  caml_callback
		                   (level_schema_versioned,
		                    [function(param, cont){return cont(0);}]),
		                bOu = [];
		               function breadcrumb_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOu[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOu[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOu[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bOu[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_type,
		                                 0,
		                                 3,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_message,
		   0,
		   3,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, c], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call
		      (level_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              type = d[2][1],
		              timestamp = d[1],
		              message = c[1],
		              level = b[1],
		              data = a[1],
		              category = param[1];
		             return cont
		                     ([0, category, data, level, message, timestamp, type]);
		            },
		            function(param, cont){
		             var
		              type = param[6],
		              timestamp = param[5],
		              message = param[4],
		              level = param[3],
		              data = param[2],
		              category = param[1];
		             return cont
		                     ([0,
		                       category,
		                       [0,
		                        data,
		                        [0, level, [0, message, [0, timestamp, [0, type, 0]]]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              "category",
		              0,
		              3,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, cst_data, 0, 3, [0, no_input_schema], 0, 0],
		              [0, [0, 0, 0, 0, 0, cst_level, 0, 2, [0, a], 0, 0], b]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOu[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOu[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOv = [];
		               function contexts_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOv[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOv[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOv[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOv[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var device = param[1];
		                                 return cont([0, device]);
		                                },
		                                function(param, cont){
		                                 var device = param[1];
		                                 return cont([0, device, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_device,
		                                  0,
		                                  2,
		                                  [0, schematic_param_a_schema_versi],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOv[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOv[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOw = [];
		               function exn_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOw[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCt, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOw[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOw[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bOw[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_type,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_value,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (stacktrace_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0, [0, 0, 0, 0, 0, cst_stacktrace, 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (mechanism_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              value = b[2][1],
		              type = b[1],
		              stacktrace = a[1],
		              mechanism = param[1];
		             return cont([0, mechanism, stacktrace, type, value]);
		            },
		            function(param, cont){
		             var
		              value = param[4],
		              type = param[3],
		              stacktrace = param[2],
		              mechanism = param[1];
		             return cont
		                     ([0, mechanism, [0, stacktrace, [0, type, [0, value, 0]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_mechanism, 0, 3, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOw[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOw[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOx = [];
		               function frame_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOx[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCu, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOx[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOx[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOx[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  line = c[2][1],
		                                  function$ = c[1],
		                                  filename = b[1],
		                                  column = a[1],
		                                  path = param[1];
		                                 return cont([0, path, column, filename, function$, line]);
		                                },
		                                function(param, cont){
		                                 var
		                                  line = param[5],
		                                  function$ = param[4],
		                                  filename = param[3],
		                                  column = param[2],
		                                  path = param[1];
		                                 return cont
		 ([0,
		   path,
		   [0, column, [0, filename, [0, function$, [0, line, 0]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "abs_path",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, "colno", 0, 3, [0, int_schema], 0, 0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_filename,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_function,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0, 0, 0, 0, 0, "lineno", 0, 3, [0, int_schema], 0, 0],
		                                     0]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOx[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOx[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOy = [];
		               function mechanism_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOy[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCv, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOy[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOy[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOy[1][1] = a;
		                            var
		                             default$ = match$205[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var type = param[2][1], handled = param[1];
		                                 return cont([0, handled, type]);
		                                },
		                                function(param, cont){
		                                 var type = param[2], handled = param[1];
		                                 return cont([0, handled, [0, type, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "handled",
		                                  0,
		                                  [0, default$],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_type,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOy[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOy[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOz = [];
		               function message_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOz[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCw, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOz[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOz[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOz[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  params = a[2][1],
		                                  message = a[1],
		                                  formatted = param[1];
		                                 return cont([0, formatted, message, params]);
		                                },
		                                function(param, cont){
		                                 var
		                                  params = param[3],
		                                  message = param[2],
		                                  formatted = param[1];
		                                 return cont([0, formatted, [0, message, [0, params, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "formatted",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_message,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_params,
		                                    0,
		                                    3,
		                                    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOz[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOz[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var cst_env = "env", bOA = [];
		               function request_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOA[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCx, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOA[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOA[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOA[1][1] = a;
		                            a =
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               mapping_schema(schematic_param_name_schema_ve)[3],
		                               0]];
		                            var
		                             default$ = match$206[1],
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 mapping_schema(schematic_param_name_schema_ve)[3],
		                                 0]],
		                             default$0 = match$207[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  env = c[2][1],
		                                  url = c[1],
		                                  method = b[1],
		                                  headers = a[1],
		                                  data = param[1];
		                                 return cont([0, data, headers, method, url, env]);
		                                },
		                                function(param, cont){
		                                 var
		                                  env = param[5],
		                                  url = param[4],
		                                  method = param[3],
		                                  headers = param[2],
		                                  data = param[1];
		                                 return cont
		 ([0, data, [0, headers, [0, method, [0, url, [0, env, 0]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_data,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_headers, 0, [0, default$0], b, 0, 0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_method,
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_url, 0, 3, [0, schema$268], 0, 0],
		                                    [0, [0, 0, 0, 0, 0, cst_env, 0, [0, default$], a, 0, 0], 0]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOA[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOA[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOB = [];
		               function stacktrace_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOB[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCy, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOB[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOB[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOB[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (frame_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var frames = param[1];
		   return cont([0, frames]);
		  },
		  function(param, cont){
		   var frames = param[1];
		   return cont([0, frames, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "frames",
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOB[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOB[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_username = "username",
		                letrec_function_context$654 = [];
		               function user_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         dummy,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$654[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aCz, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$654[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$654[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$654[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  username = d[2][1],
		                                  segment = d[1],
		                                  name = c[1],
		                                  ip_address = b[1],
		                                  id = a[1],
		                                  email = param[1];
		                                 return cont
		 ([0, email, id, ip_address, name, segment, username]);
		                                },
		                                function(param, cont){
		                                 var
		                                  username = param[6],
		                                  segment = param[5],
		                                  name = param[4],
		                                  ip_address = param[3],
		                                  id = param[2],
		                                  email = param[1];
		                                 return cont
		 ([0,
		   email,
		   [0,
		    id,
		    [0, ip_address, [0, name, [0, segment, [0, username, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_email,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_id,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "ip_address",
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_name,
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      "segment",
		                                      0,
		                                      3,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_username,
		                                       0,
		                                       3,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$654[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$654[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$617 = [0, empty$11([0, comparator$9])],
		                bOt = [];
		               caml_update_dummy(bOt, [0, schematic_cache$617]);
		               var schematic_cache$618 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOu, [0, schematic_cache$618]);
		               var schematic_cache$619 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOv, [0, schematic_cache$619]);
		               var schematic_cache$620 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOw, [0, schematic_cache$620]);
		               var schematic_cache$621 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOx, [0, schematic_cache$621]);
		               var schematic_cache$622 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOy, [0, schematic_cache$622]);
		               var schematic_cache$623 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOz, [0, schematic_cache$623]);
		               var schematic_cache$624 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOA, [0, schematic_cache$624]);
		               var schematic_cache$625 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOB, [0, schematic_cache$625]);
		               var schematic_cache$626 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$654, [0, schematic_cache$626]);
		               function schematic_version$91(param, cont){return cont(0);}
		               var
		                schematic_schema_version$91 = 0,
		                h =
		                  caml_callback
		                   (find_packed_by_id,
		                    [bOt[1][1], schematic_schema_version$91]),
		                cst_release = "release",
		                cst_tags = "tags";
		               if(h)
		                var schema$145 = h[1], descriptor$26 = schema$145;
		               else
		                descriptor$26 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              bOt[1][1],
		                              schematic_schema_version$91,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bOt[1][1],
		 schematic_schema_version$91,
		 schematic_self,
		 function(b){
		  bOt[1][1] = b;
		  var
		   a =
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_platform,
		       0,
		       0,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0];
		  return caml_exact_trampoline_cps_call
		          (contexts_schema_versioned,
		           schematic_version$91,
		           function(c){
		            var
		             b =
		               [0, [0, 0, 0, 0, 0, cst_contexts, 0, 0, [0, c], 0, 0], a];
		            return caml_exact_trampoline_cps_call
		                    (user_schema_versioned$0,
		                     schematic_version$91,
		                     function(c){
		                      var
		                       a =
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "transaction",
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0, [0, 0, 0, 0, 0, cst_user, 0, 3, [0, c], 0, 0], b]];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$4,
		                               schematic_version$91,
		                               function(c){
		                                var
		                                 b =
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     "server_name",
		                                     0,
		                                     3,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_tags,
		                                      0,
		                                      2,
		                                      [0,
		                                       [0,
		0,
		0,
		mapping_schema(schematic_param_name_schema_ve)[3],
		0]],
		                                      0,
		                                      0],
		                                     [0, [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, c], 0, 0], a]]];
		                                return caml_exact_trampoline_cps_call
		(request_schema_versioned$0,
		 schematic_version$91,
		 function(c){
		  var
		   a =
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_release,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0, [0, 0, 0, 0, 0, cst_request, 0, 3, [0, c], 0, 0], b]];
		  return caml_exact_trampoline_cps_call
		          (message_schema_versioned$1,
		           schematic_version$91,
		           function(c){
		            var
		             b = [0, [0, 0, 0, 0, 0, cst_message, 0, 3, [0, c], 0, 0], a];
		            return caml_exact_trampoline_cps_call
		                    (level_schema_versioned,
		                     schematic_version$91,
		                     function(d){
		                      var
		                       default$ = match$200[1],
		                       default$0 = match$201[1],
		                       a =
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           mapping_schema(schematic_param_name_schema_ve)[3],
		                           0]],
		                       default$1 = match$202[1],
		                       c =
		                         [0,
		                          [0, 0, 0, 0, 0, "extra", 0, [0, default$1], a, 0, 0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_fingerprint,
		                            0,
		                            [0, default$0],
		                            [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                            0,
		                            0],
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             "event_id",
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            [0,
		                             [0, 0, 0, 0, 0, cst_level, 0, [0, default$], [0, d], 0, 0],
		                             b]]]];
		                      return caml_exact_trampoline_cps_call
		                              (exn_schema_versioned,
		                               schematic_version$91,
		                               function(a){
		                                return caml_exact_trampoline_cps_call
		(function(schematic_param_a_schema_versi, cont){
		  function descriptor(schematic_param_a_schema_versi){
		   return [7,
		           function(param, cont){
		            var values = param[1];
		            return cont([0, values]);
		           },
		           function(param, cont){
		            var values = param[1];
		            return cont([0, values, 0]);
		           },
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_values,
		             0,
		             2,
		             [0, [0, 0, 0, [3, schematic_param_a_schema_versi], 0]],
		             0,
		             0],
		            0]];
		  }
		  var
		   schematic_schema_id = match$208[1],
		   schematic_parametric =
		     [0,
		      [1,
		       cst_a$0,
		       schematic_param_a_schema_versi,
		       function(schematic_param_a_schema_versi, cont){
		        return cont
		                ([0,
		                  schematic_schema_id,
		                  descriptor(schematic_param_a_schema_versi)]);
		       }]],
		   a = descriptor(schematic_param_a_schema_versi),
		   parametric = schematic_parametric[1];
		  return caml_exact_trampoline_cps_call
		          (of_parametric,
		           parametric,
		           function(match){
		            function b(b){
		             return cont([0, b, 0, a, schematic_parametric]);
		            }
		            if(! match) return b(0);
		            var name = match[1];
		            return caml_exact_trampoline_cps_call
		                    (to_id, name, function(a){return b([0, a]);});
		           });
		 },
		 a,
		 function(b){
		  var
		   default$ = match$203[1],
		   default$0 = match$204[1],
		   a =
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_dist,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_environment,
		        0,
		        [0, default$0],
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0, 0, 0, 0, 0, "exception", 0, [0, default$], [0, b], 0, 0],
		        c]]];
		  return caml_exact_trampoline_cps_call
		          (breadcrumb_schema_versioned,
		           schematic_version$91,
		           function(b){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var
		                  a = param[2],
		                  b = a[2],
		                  c = b[2],
		                  d = c[2],
		                  e = d[2],
		                  f = e[2],
		                  g = f[2],
		                  h = g[2],
		                  i = h[2],
		                  j = i[2],
		                  k = j[2],
		                  l = k[2],
		                  m = l[2],
		                  n = m[2],
		                  user = n[2][1],
		                  transaction = n[1],
		                  timestamp = m[1],
		                  tags = l[1],
		                  server_name = k[1],
		                  request = j[1],
		                  release = i[1],
		                  message = h[1],
		                  level = g[1],
		                  id = f[1],
		                  fingerprint = e[1],
		                  extra = d[1],
		                  exceptions = c[1],
		                  environment = b[1],
		                  dist = a[1],
		                  breadcrumbs = param[1];
		                 return cont
		                         ([0,
		                           breadcrumbs,
		                           dist,
		                           environment,
		                           exceptions,
		                           extra,
		                           fingerprint,
		                           id,
		                           level,
		                           message,
		                           release,
		                           request,
		                           server_name,
		                           tags,
		                           timestamp,
		                           transaction,
		                           user]);
		                },
		                function(param, cont){
		                 var
		                  user = param[16],
		                  transaction = param[15],
		                  timestamp = param[14],
		                  tags = param[13],
		                  server_name = param[12],
		                  request = param[11],
		                  release = param[10],
		                  message = param[9],
		                  level = param[8],
		                  id = param[7],
		                  fingerprint = param[6],
		                  extra = param[5],
		                  exceptions = param[4],
		                  environment = param[3],
		                  dist = param[2],
		                  breadcrumbs = param[1];
		                 return cont
		                         ([0,
		                           breadcrumbs,
		                           [0,
		                            dist,
		                            [0,
		                             environment,
		                             [0,
		                              exceptions,
		                              [0,
		                               extra,
		                               [0,
		                                fingerprint,
		                                [0,
		                                 id,
		                                 [0,
		                                  level,
		                                  [0,
		                                   message,
		                                   [0,
		                                    release,
		                                    [0,
		                                     request,
		                                     [0,
		                                      server_name,
		                                      [0, tags, [0, timestamp, [0, transaction, [0, user, aCq]]]]]]]]]]]]]]]]);
		                },
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  "breadcrumbs",
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, b], 0]],
		                  0,
		                  0],
		                 a]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     bOt[1][1],
		                     schematic_schema_version$91,
		                     res,
		                     function(a){bOt[1][1] = a; return cont(res);});
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$146 = [0, aCp, 0, descriptor$26, 0];
		               caml_callback
		                (breadcrumb_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (contexts_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (exn_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (frame_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (mechanism_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (message_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (request_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (stacktrace_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (user_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function make$60(dist, fingerprint, opt, exceptions, cont){
		                function a(id){
		                 var timestamp = ocaml_ptime_clock_now_d_ps();
		                 return caml_trampoline_cps_call3
		                         (map$17,
		                          exceptions,
		                          function(values, cont){return cont([0, values]);},
		                          function(a){
		                           return cont
		                                   (function(d, c, b){
		                                     return function
		                                      (e, message, release, request, server_name, opt){
		                                      return function(transaction, user, param){
		                                       var
		breadcrumbs = d ? d[1] : 0,
		environment = c ? c[1] : cst_production,
		exceptions = a ? a[1] : aCo,
		extra = b ? b[1] : 0,
		fingerprint$0 = fingerprint ? fingerprint[1] : 0,
		level = e ? e[1] : 1,
		tags = opt ? opt[1] : 0;
		                                       return [0,
		       breadcrumbs,
		       dist,
		       environment,
		       exceptions,
		       extra,
		       fingerprint$0,
		       id,
		       level,
		       message,
		       release,
		       request,
		       server_name,
		       tags,
		       timestamp,
		       transaction,
		       user];};};
		                                    });
		                          });
		                }
		                return opt
		                        ? a(opt[1])
		                        : caml_exact_trampoline_cps_call
		                          (create$24,
		                           19230,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (to_string$26, 0, b, a);
		                           });
		               }
		               var
		                xhr_response_supported =
		                  [246,
		                   function(param, cont){
		                    var
		                     xhr = caml_xmlhttprequest_create(),
		                     rt = xhr.responseType;
		                    return cont
		                            (caml_string_of_jsstring(typeof rt) === cst_string ? 1 : 0);
		                   }];
		               function string_of_uint8array(u8a, offset, len, cont){
		                var s = caml_create_bytes(len), a = len - 1 | 0;
		                function c(){return cont(caml_string_of_bytes(s));}
		                function b(i){
		                 var i$0 = offset + i | 0;
		                 return caml_exact_trampoline_cps_call
		                         (chr,
		                          u8a[i$0],
		                          function(d){
		                           caml_bytes_unsafe_set(s, i, d);
		                           d = i + 1 | 0;
		                           return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		                          });
		                }
		                return a < 0 ? c() : b(0);
		               }
		               function catch$0(f, cont){
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         dummy,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$90,
		                                   function(v, cont){return cont([0, v]);},
		                                   a,
		                                   cont);
		                         });
		               }
		               function pp_error$2(a, e, cont){
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Match_failure, aCA], 1));
		               }
		               function parse(ic, cont){
		                function parse_headers(headers, cont){
		                 function a(param, cont){
		                  if(param){
		                   var line = param[1];
		                   if(line !== cst$1)
		                    return caml_exact_trampoline_cps_call$0
		                            (split$4,
		                             qz,
		                             line,
		                             58,
		                             function(x){
		                              function a(match){
		                               if(match){
		                                var a = match[2];
		                                if(a && ! a[2]){
		                                 var tl = a[1], hd = match[1];
		                                 return caml_exact_trampoline_cps_call
		 (parse_headers, add$9(headers, hd, tl), cont);
		                                }
		                               }
		                               return caml_exact_trampoline_cps_call
		                                       (return$10, headers, cont);
		                              }
		                              if(! x) return a(x);
		                              var b = x[2];
		                              if(! b) return a(x);
		                              if(b[2]) return a(x);
		                              var y = b[1], x$0 = x[1];
		                              return caml_exact_trampoline_cps_call
		                                      (trim, y, function(b){return a([0, x$0, [0, b, 0]]);});
		                             });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (return$10, headers, cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (read_line,
		                          ic,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol_bind$6, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call(parse_headers, 0, cont);
		               }
		               function Body_builder(P){
		                var
		                 src = create$18(aCB, "cohttp.lwt.jsoo"),
		                 Log = src_log(src),
		                 empty = 50834029;
		                function chunked_body_str(text){
		                 var body_len = text.length, pos = [0, 0];
		                 function chunkerizer(param, cont){
		                  if(pos[1] === body_len)
		                   return caml_exact_trampoline_cps_call(return$10, 0, cont);
		                  if(body_len <= (pos[1] + P[2] | 0)){
		                   var t5 = pos[1], str = text.substring(t5);
		                   pos[1] = body_len;
		                   return caml_exact_trampoline_cps_call
		                           (return$10, [1, P[3].call(null, str)], cont);
		                  }
		                  var
		                   t8 = pos[1] + P[2] | 0,
		                   t7 = pos[1],
		                   str$0 = text.substring(t7, t8);
		                  pos[1] = pos[1] + P[2] | 0;
		                  return caml_exact_trampoline_cps_call
		                          (return$10, [0, P[3].call(null, str$0)], cont);
		                 }
		                 return 0 === body_len
		                         ? empty
		                         : of_stream(create_stream(chunkerizer));
		                }
		                function chunked_body_binary(t11){
		                 var
		                  body_len = t11.byteLength,
		                  u8a = new uint8Array(t11),
		                  pos = [0, 0];
		                 function chunkerizer(param, cont){
		                  return pos[1] === body_len
		                          ? caml_exact_trampoline_cps_call(return$10, 0, cont)
		                          : body_len
		                            <= (pos[1] + P[2] | 0)
		                            ? caml_exact_trampoline_cps_call$0
		                              (string_of_uint8array,
		                               u8a,
		                               pos[1],
		                               body_len - pos[1] | 0,
		                               function(str){
		                                pos[1] = body_len;
		                                return caml_exact_trampoline_cps_call
		(return$10, [1, str], cont);
		                               })
		                            : caml_exact_trampoline_cps_call$0
		                              (string_of_uint8array,
		                               u8a,
		                               pos[1],
		                               P[2],
		                               function(str){
		                                pos[1] = pos[1] + P[2] | 0;
		                                return caml_exact_trampoline_cps_call
		(return$10, [0, str], cont);
		                               });
		                 }
		                 return 0 === body_len
		                         ? empty
		                         : of_stream(create_stream(chunkerizer));
		                }
		                function get(param, cont){
		                 var variant = param[1];
		                 if(571404121 > variant){
		                  var js_str = param[2];
		                  return P[1]
		                          ? cont(chunked_body_str(js_str))
		                          : cont(of_string$15(P[3].call(null, js_str)));
		                 }
		                 var t13 = param[2];
		                 if(P[1]) return cont(chunked_body_binary(t13));
		                 var u8a = new uint8Array(t13);
		                 return caml_exact_trampoline_cps_call$0
		                         (string_of_uint8array,
		                          u8a,
		                          0,
		                          t13.byteLength,
		                          function(a){return cont(of_string$15(a));});
		                }
		                function construct_body(xml, cont){
		                 function respText(param){
		                  var x = xml.responseText;
		                  return x == no_handler
		                          ? [0, -976970511, cst$1]
		                          : [0, -976970511, x];
		                 }
		                 var a = caml_obj_tag(xhr_response_supported);
		                 function b(match){
		                  function a(b){
		                   return caml_exact_trampoline_cps_call(get, b, cont);
		                  }
		                  if(! match) return a(respText());
		                  if(xml.response === no_handler)
		                   return caml_exact_trampoline_cps_call
		                           (Log[4],
		                            function(m, cont){
		                             return caml_trampoline_cps_call4(m, 0, 0, aCC, cont);
		                            },
		                            function(b){return a([0, -976970511, cst$1]);});
		                  var
		                   e = xml.response,
		                   ab = e instanceof arrayBuffer ? e : no_handler;
		                  return ab == no_handler
		                          ? caml_exact_trampoline_cps_call
		                            (Log[4],
		                             function(m, cont){
		                              return caml_trampoline_cps_call4(m, 0, 0, aCD, cont);
		                             },
		                             function(b){return a(respText());})
		                          : a([0, 571404121, ab]);
		                 }
		                 if(250 === a) return b(xhr_response_supported[1]);
		                 if(246 !== a && 244 !== a) return b(xhr_response_supported);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, xhr_response_supported, b);
		                }
		                return [0, , , , , , construct_body];
		               }
		               function convert_body_string(a){
		                return caml_string_of_jsbytes(a);
		               }
		               var
		                P$0 = [0, 1, 131072, convert_body_string, 0],
		                Bb$0 = Body_builder(P$0),
		                true$0 = true;
		               function call$3(headers, body, meth, uri, cont){
		                var xml = caml_xmlhttprequest_create(), t18 = ! ! P$0[4];
		                xml.withCredentials = t18;
		                var a = caml_obj_tag(xhr_response_supported);
		                function b(a){
		                 if(a) xml.responseType = "arraybuffer";
		                 a = task();
		                 var wake = a[2], res = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (to_string$12,
		                          0,
		                          uri,
		                          function(b){
		                           var
		                            t24 = caml_jsstring_of_string(b),
		                            t23 = caml_jsstring_of_string(string_of_method(meth));
		                           xml.open(t23, t24, true$0);
		                           if(headers){
		                            var headers$0 = headers[1], b = headers$0;
		                            for(;;){
		                             if(! b) break;
		                             var
		                              l = b[2],
		                              a = b[1],
		                              v = a[2],
		                              k = a[1],
		                              t28 = caml_jsstring_of_string(v),
		                              t27 = caml_jsstring_of_string(k);
		                             xml.setRequestHeader(t27, t28);
		                             b = l;
		                            }
		                           }
		                           var
		                            t32 =
		                              caml_js_wrap_callback
		                               (function(param, cont){
		                                 return 4 <= xml.readyState
		 ? (caml_push_trap
		    (function(e){
		      var a = underlying(res)[1];
		      switch(a[0]){
		        case 1:
		         var exn = a[1], a = [1, exn]; break;
		        case 2:
		         a = 0; break;
		        default: var v = a[1], a = [0, v];
		      }
		      if(0 === a)
		       return caml_exact_trampoline_cps_call$1
		               (wakeup_exn, wake, e, cont);
		      a = caml_pop_trap();
		      var e$0 = caml_maybe_attach_backtrace(e, 0);
		      return a(e$0);
		     }),
		   caml_exact_trampoline_cps_call
		    (Bb$0[6],
		     xml,
		     function(body){
		      var
		       resp_headers =
		         caml_string_of_jsstring(xml.getAllResponseHeaders()),
		       channel =
		         [0, resp_headers, 0, caml_ml_string_length(resp_headers)];
		      function f(resp_headers, cont){
		       a:
		       {
		        var b = [0, resp_headers];
		        if(typeof body !== "number"){
		         var variant$0 = body[1];
		         if(-976970511 > variant$0){var a = 0; break a;}
		        }
		        if(typeof body === "number")
		         a = qA;
		        else {
		         var variant = body[1];
		         if(-968575390 <= variant)
		          a = 0;
		         else
		          var
		           s = body[2],
		           a = [0, caml_int64_of_int32(caml_ml_string_length(s))];
		        }
		       }
		       return caml_exact_trampoline_cps_call$3
		               (make$14,
		                aCE,
		                [0, status_of_code(xml.status)],
		                [0, a],
		                b,
		                dummy,
		                cont);
		      }
		      return caml_exact_trampoline_cps_call
		              (parse,
		               channel,
		               function(p){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$90,
		                         f,
		                         p,
		                         function(response){
		                          return caml_exact_trampoline_cps_call$1
		                                  (wakeup,
		                                   wake,
		                                   [0, response, body],
		                                   function(a){caml_pop_trap(); return cont(a);});
		                         });
		               });
		     }))
		 : cont(0);
		                                });
		                           xml.onreadystatechange = t32;
		                           function d(param, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (on_cancel,
		                                     res,
		                                     function(param, cont){return cont(xml.abort());},
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol_bind$6,
		       res,
		       function(param, cont){
		        var b = param[2], r = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (symbol_bind$6,
		                 r,
		                 function(r, cont){
		                  return caml_exact_trampoline_cps_call
		                          (return$10, [0, r, b], cont);
		                 },
		                 cont);
		       },
		       cont);
		                                     });
		                           }
		                           function c(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, a, d, cont);
		                           }
		                           if(! body)
		                            return caml_exact_trampoline_cps_call
		                                    (return$10, xml.send(no_handler), c);
		                           var body$0 = body[1];
		                           function e(body, cont){
		                            var
		                             len = caml_ml_string_length(body),
		                             t37 = new uint8Array(len),
		                             a = len - 1 | 0;
		                            if(a >= 0){
		                             var i = 0;
		                             for(;;){
		                              var v = caml_string_get(body, i);
		                              t37[i] = v;
		                              var b = i + 1 | 0;
		                              if(a === i) break;
		                              i = b;
		                             }
		                            }
		                            return caml_exact_trampoline_cps_call
		                                    (return$10, xml.send(t37), cont);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$22,
		                                    body$0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_bind$6, a, e, c);
		                                    });
		                          });
		                }
		                if(250 === a) return b(xhr_response_supported[1]);
		                if(246 !== a && 244 !== a) return b(xhr_response_supported);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, xhr_response_supported, b);
		               }
		               function call$2(a, headers, body, param, meth, uri, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (call$3, headers, body, meth, uri, cont);
		               }
		               function convert_body_string$0(a){
		                return caml_string_of_jsbytes(a);
		               }
		               Body_builder([0, 0, 0, convert_body_string$0]);
		               function prerelease_to_semver(param){
		                if(typeof param === "number") return aCF;
		                if(0 === param[0]){
		                 var name = param[2], n = param[1];
		                 return [0, cst_beta, [0, "" + n, [0, name, 0]]];
		                }
		                var n$0 = param[1];
		                return [0, cst_rc, [0, "" + n$0, 0]];
		               }
		               function beta(n, name, cont){return cont([0, n, name]);}
		               function rc$0(n, cont){return cont([1, n]);}
		               var
		                cst_overriden_from_env = "overriden-from-env",
		                env_override_suffix = cst$14 + cst_overriden_from_env,
		                dash = char$0(45),
		                dot$0 = char$0(46);
		               function hex(param, cont){
		                if(58 <= param){
		                 if(5 >= param - 97 >>> 0) return cont(1);
		                }
		                else if(48 <= param) return cont(1);
		                return cont(0);
		               }
		               function digit$3(param, cont){
		                return 9 < param - 48 >>> 0 ? cont(0) : cont(1);
		               }
		               var
		                nat$0 =
		                  symbol_map$3
		                   (count_while1(digit$3, substring),
		                    function(a, cont){return cont(caml_int_of_string(a));});
		               function build
		               (major,
		                minor,
		                subminor,
		                prerelease,
		                patch,
		                commit,
		                dirty,
		                env_override,
		                cont){
		                return cont
		                        ([0,
		                          major,
		                          minor,
		                          subminor,
		                          prerelease,
		                          patch,
		                          commit,
		                          dirty,
		                          env_override]);
		               }
		               var
		                h = caml_callback(return$7, [0]),
		                alpha$0 = symbol$61(string$3(cst_alpha), h);
		               function f$9(param, cont){
		                return 25 < param - 97 >>> 0 ? cont(0) : cont(1);
		               }
		               var
		                word$0 = count_while1(f$9, substring),
		                h =
		                  symbol_map$3
		                   (sep_by1(char$0(45), word$0),
		                    function(a, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (concat, cst$33, a, cont);
		                    }),
		                h = caml_callback(option$0, [cst$1, symbol$61(char$0(46), h)]),
		                m$7 = symbol$61(string$3("beta."), nat$0),
		                beta$0 = symbol$60(symbol_map$3(m$7, beta), h),
		                m$8 = symbol$61(string$3("rc."), nat$0),
		                rc$1 = symbol_map$3(m$8, rc$0),
		                h = caml_callback(return$7, [1]),
		                h =
		                  caml_callback
		                   (option$0, [0, symbol$61(string$3(env_override_suffix), h)]),
		                b3 = caml_callback(return$7, [1]),
		                b3 =
		                  caml_callback
		                   (option$0, [0, symbol$61(string$3("-dirty"), b3)]),
		                z = count_while1(hex, substring),
		                z =
		                  caml_callback
		                   (option$0,
		                    [0,
		                     symbol_map$3
		                      (symbol$61(symbol$61(dash, char$0(103)), z), some)]),
		                b4 = caml_callback(option$0, [0, symbol$61(dash, nat$0)]),
		                j =
		                  caml_callback
		                   (option$0,
		                    [0,
		                     symbol_map$3
		                      (symbol$61
		                        (dash,
		                         caml_callback
		                          (symbol$64,
		                           [caml_callback(symbol$64, [alpha$0, beta$0]), rc$1])),
		                       some)]),
		                b$ = symbol$61(dot$0, nat$0),
		                bZ = symbol$61(dot$0, nat$0),
		                git_version_parser =
		                  symbol$60
		                   (symbol$60
		                     (symbol$60
		                       (symbol$60
		                         (symbol$60
		                           (symbol$60
		                             (symbol$60
		                               (symbol$60(caml_callback(return$7, [build]), nat$0), bZ),
		                              b$),
		                            j),
		                          b4),
		                        z),
		                      b3),
		                    h);
		               function make_version
		               (git_version, substituted_version, param, cont){
		                var version_from_env = getenv_opt("ROUTINE_VERSION");
		                a:
		                if(version_from_env)
		                 var
		                  version = version_from_env[1],
		                  version$0 = version + env_override_suffix,
		                  dev = 1;
		                else {
		                 if
		                  (0 < caml_ml_string_length(substituted_version)
		                   && equal(caml_string_get(substituted_version, 0), 37)){version$0 = git_version; dev = 1; break a;}
		                 version$0 = substituted_version;
		                 dev = 0;
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         git_version_parser,
		                         version$0,
		                         function(a){
		                          function c(a){return cont([0, dev, a]);}
		                          if(0 !== a[0]){
		                           var error = a[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    failwith,
		                                    fmt$120,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(a, version$0, error, c);
		                                    });
		                          }
		                          a = a[1];
		                          var
		                           env_override = a[8],
		                           dirty = a[7],
		                           commit = a[6],
		                           patch = a[5],
		                           prerelease = a[4],
		                           subminor = a[3],
		                           minor = a[2],
		                           major = a[1];
		                          function b(subminor, prerelease){
		                           var
		                            a = env_override ? [0, cst_overriden_from_env] : 0,
		                            b = dirty ? aCG : 0,
		                            d = dev ? aCH : 0,
		                            build =
		                              filter_map
		                               (function(x){return x;}, [0, d, [0, b, [0, a, 0]]]);
		                           return caml_exact_trampoline_cps_call$3
		                                   (from_parts,
		                                    major,
		                                    minor,
		                                    subminor,
		                                    prerelease,
		                                    build,
		                                    function(match){
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf, failwith, fmt$119, c);
		                                     var version = match[1];
		                                     return c(version);
		                                    });
		                          }
		                          if(prerelease && typeof prerelease[1] === "number")
		                           return caml_exact_trampoline_cps_call
		                                   (failwith,
		                                    "alpha prerelease are reserved for dev commits",
		                                    function(a){return b(a[1], a[2]);});
		                          if(commit){
		                           var commit$0 = commit[1];
		                           if(! prerelease)
		                            return b
		                                    (subminor + 1 | 0,
		                                     symbol
		                                      (prerelease_to_semver(0),
		                                       [0, "" + patch, [0, cst_g + commit$0, 0]]));
		                           var prerelease$0 = prerelease[1];
		                           return b
		                                   (subminor,
		                                    symbol
		                                     (prerelease_to_semver(prerelease$0),
		                                      [0, "" + patch, [0, cst_g + commit$0, 0]]));
		                          }
		                          if(! prerelease) return b(subminor, 0);
		                          var prerelease$1 = prerelease[1];
		                          return b(subminor, prerelease_to_semver(prerelease$1));
		                         });
		               }
		               var
		                b$ = "3.1.0-dirty\n",
		                version = caml_callback(trim, [b$]),
		                b4 = "3.1.0",
		                bZ = caml_callback(make_version, [version, b4, dummy]),
		                version$0 = bZ[2],
		                dev = bZ[1],
		                object$1 = global$0.Object;
		               function of_js(o, cont){
		                if(is_none$1(o)) return cont(870828711);
		                if(is_array(o))
		                 return caml_exact_trampoline_cps_call$1
		                         (to_list$5, of_js, o, function(a){return cont([0, 65, a]);});
		                var type = typeof o;
		                return caml_equal(type, cst_string)
		                        ? cont([0, -976970511, caml_string_of_jsstring(o)])
		                        : caml_equal
		                           (type, cst_number)
		                          ? cont([0, 365180284, o])
		                          : caml_equal
		                             (type, cst_boolean)
		                            ? cont([0, 737456202, o | 0])
		                            : caml_exact_trampoline_cps_call$1
		                              (to_list$5,
		                               function(a, cont){return cont(a);},
		                               object$1.keys(o),
		                               function(keys){
		                                function f(key, cont){
		                                 return caml_exact_trampoline_cps_call
		 (of_js,
		  o[key],
		  function(a){
		   return cont([0, caml_string_of_jsstring(key), a]);
		  });
		                                }
		                                return caml_exact_trampoline_cps_call$1
		(map$7, keys, f, function(a){return cont([0, 79, a]);});
		                               });
		               }
		               function of_js$0(o, cont){
		                return caml_exact_trampoline_cps_call(of_js, o, cont);
		               }
		               function to_js(x, cont){
		                if(typeof x === "number") return cont(null);
		                var variant = x[1];
		                if(65 === variant){
		                 var a = x[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          a,
		                          to_js,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_array,
		                                    a,
		                                    function(a){return cont(caml_js_from_array(a));});
		                          });
		                }
		                if(365180284 <= variant){
		                 if(737456202 <= variant){var n = x[2]; return cont(! ! n);}
		                 var n$0 = x[2];
		                 return cont(n$0);
		                }
		                if(79 <= variant){
		                 var
		                  o = x[2],
		                  res = {},
		                  b =
		                    function(t){
		                     if(! t) return cont(res);
		                     var l = t[2], a = t[1], v = a[2], k = a[1];
		                     return caml_exact_trampoline_cps_call
		                             (to_js,
		                              v,
		                              function(a){
		                               res[caml_jsstring_of_string(k)] = a;
		                               return caml_exact_trampoline_call1(b, l);
		                              });
		                    };
		                 return b(o);
		                }
		                var s = x[2];
		                return cont(caml_jsstring_of_string(s));
		               }
		               function of_string$47(s, cont){
		                caml_push_trap
		                 (function(exn){return cont([1, cst_parse_error]);});
		                var t1 = caml_jsstring_of_string(s), js = JSON.parse(t1);
		                return caml_exact_trampoline_cps_call
		                        (of_js,
		                         js,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$0,
		                                   a,
		                                   function(a){caml_pop_trap(); return cont(a);});
		                         });
		               }
		               function to_string$60(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_js,
		                         t,
		                         function(obj){
		                          var
		                           t13 = caml_js_wrap_callback(output_reviver),
		                           json$0 = json.stringify(obj, t13);
		                          return cont(caml_string_of_jsstring(json$0));
		                         });
		               }
		               function date_of_js(date, cont){
		                if(! (date instanceof date_fromTimeValue)) return cont(0);
		                var a = date.getDate(), b = date.getMonth() + 1 | 0;
		                return cont([0, [0, date.getFullYear(), b, a]]);
		               }
		               var date$0 = global$0.Date;
		               function js_of_date(param, cont){
		                var
		                 t6 = param[3],
		                 m = param[2],
		                 t4 = param[1],
		                 t5 = m - 1 | 0;
		                return cont(new date_fromTimeValue(t4, t5, t6));
		               }
		               function js_of_ptime(t){
		                var t8 = to_float_s(t) * 1000.;
		                return new date_fromTimeValue(t8);
		               }
		               var
		                Coding$2 =
		                  [248, "Schematic_jsoo__Jsoo.Coding", caml_fresh_oo_id()];
		               function compare$140(a, param, cont){
		                return caml_exact_trampoline_cps_call(failwith, "FIXME", cont);
		               }
		               function pp$122(fmt, t10, cont){
		                return test(t10)
		                        ? caml_exact_trampoline_cps_call$1
		                          (pp_print_string,
		                           fmt,
		                           caml_string_of_jsstring(JSON.stringify(t10)),
		                           cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (pp_print_string, fmt, "undefined", cont);
		               }
		               function type_name$1(o, cont){
		                return o === no_handler
		                        ? cont(cst_null)
		                        : cont(caml_string_of_jsstring(typeof o));
		               }
		               function f$10(o, f, cont){
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call
		                           (type_name$1,
		                            o,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (type_error,
		                                      cst_object,
		                                      a,
		                                      function(x){return cont([1, x]);});
		                            });
		                  });
		                return caml_exact_trampoline_cps_call
		                        (of_string$0,
		                         to_option$1(o[caml_jsstring_of_string(f)]),
		                         function(a){caml_pop_trap(); return cont(a);});
		               }
		               function f$11(o, f, v, cont){
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call
		                           (type_name$1,
		                            o,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (type_error,
		                                      cst_object,
		                                      a,
		                                      function(x){return cont([1, x]);});
		                            });
		                  });
		                o[caml_jsstring_of_string(f)] = v;
		                return caml_exact_trampoline_cps_call
		                        (of_string$0,
		                         o,
		                         function(a){caml_pop_trap(); return cont(a);});
		               }
		               function null$3(param, cont){return cont(null);}
		               function of_any$1(coding, v, cont){
		                return coding === Coding$2 ? cont([0, v]) : cont(0);
		               }
		               function of_bool$1(v, cont){return cont(! ! v);}
		               function of_fields$1(fields, cont){
		                var t = fields, res = {};
		                for(;;){
		                 if(! t) return cont(res);
		                 var l = t[2], a = t[1], v = a[2], field = a[1];
		                 res[caml_jsstring_of_string(field)] = v;
		                 t = l;
		                }
		               }
		               function of_float$5(v, cont){return cont(v);}
		               function of_int$7(v, cont){return cont(v);}
		               function of_int64$1(v, cont){
		                return cont(caml_int64_to_float(v));
		               }
		               function of_json$1(v, cont){
		                return caml_exact_trampoline_cps_call(to_js, v, cont);
		               }
		               function of_list$10(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_array,
		                         v,
		                         function(a){return cont(caml_js_from_array(a));});
		               }
		               function of_option$3(v, cont){return cont(option$1(v));}
		               function of_string$48(v, cont){
		                return cont(caml_jsstring_of_string(v));
		               }
		               function of_time$4(v, cont){return cont(js_of_ptime(v));}
		               function of_time_local$1(v, cont){return cont(js_of_ptime(v[1]));
		               }
		               function to_bool$1(v, cont){
		                if(typeof v !== cst_boolean) return cont(0);
		                var x = v | 0;
		                return cont([0, x]);
		               }
		               function to_fields$1(t4, cont){
		                a:
		                {
		                 try{var keys = object_constructor.keys(t4);}
		                 catch(a){break a;}
		                 if(typeof t4 === cst_object){
		                  var
		                   f =
		                     function(key, cont){
		                      return cont([0, caml_string_of_jsstring(key), t4[key]]);
		                     };
		                  return caml_exact_trampoline_cps_call$1
		                          (map$7,
		                           concat_of_array(caml_js_to_array(keys)),
		                           f,
		                           function(x){return cont([0, x]);});
		                 }
		                }
		                return cont(0);
		               }
		               function to_float$4(v, cont){
		                return typeof v === cst_number ? cont([0, v]) : cont(0);
		               }
		               function to_int$5(v, cont){
		                function f(v, cont){
		                 return caml_exact_trampoline_cps_call(of_float, v, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (to_float$4,
		                         v,
		                         function(t){
		                          return caml_exact_trampoline_cps_call$1(map$3, t, f, cont);
		                         });
		               }
		               function to_int64$3(v, cont){
		                function f(v, cont){
		                 return caml_exact_trampoline_cps_call(of_float$0, v, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (to_float$4,
		                         v,
		                         function(t){
		                          return caml_exact_trampoline_cps_call$1(map$3, t, f, cont);
		                         });
		               }
		               function to_json$1(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_js, v, function(a){return cont([0, a]);});
		               }
		               function to_list$7(v, cont){
		                if(! (v instanceof array_constructor)) return cont(0);
		                var x = concat_of_array(caml_js_to_array(v));
		                return cont([0, x]);
		               }
		               function to_option$4(v, cont){
		                return cont([0, to_option$0(v)]);
		               }
		               function to_string$61(v, cont){
		                if(typeof v !== cst_string) return cont(0);
		                var x = caml_string_of_jsstring(v);
		                return cont([0, x]);
		               }
		               function to_time$6(v, cont){
		                if(! (v instanceof date$0)) return cont([1, 0]);
		                var ms = v.getTime();
		                return cont(of_option(of_float_s$0(ms / 1000.), 0));
		               }
		               function to_time_local$1(v, cont){
		                function a(time, cont){return cont([0, time, 0]);}
		                return caml_exact_trampoline_cps_call
		                        (to_time$6,
		                         v,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                         });
		               }
		               var
		                name$31 = "javascript",
		                key_get$0 = [0, -198771759, f$10],
		                key_set$0 = [0, -198771759, f$11],
		                of_date$4 = [0, -198771759, js_of_date],
		                to_date$3 = [0, -198771759, date_of_js],
		                include$116 =
		                  [0,
		                   Coding$2,
		                   name$31,
		                   compare$140,
		                   pp$122,
		                   key_get$0,
		                   key_set$0,
		                   null$3,
		                   of_any$1,
		                   of_bool$1,
		                   of_date$4,
		                   of_fields$1,
		                   of_float$5,
		                   of_int$7,
		                   of_int64$1,
		                   of_json$1,
		                   of_list$10,
		                   of_option$3,
		                   of_string$48,
		                   of_time$4,
		                   of_time_local$1,
		                   to_bool$1,
		                   to_date$3,
		                   to_fields$1,
		                   to_float$4,
		                   to_int$5,
		                   to_int64$3,
		                   to_json$1,
		                   to_list$7,
		                   to_option$4,
		                   to_string$61,
		                   to_time$6,
		                   to_time_local$1,
		                   type_name$1],
		                bZ = caml_callback(Make$5, [include$116]),
		                encode$10 = bZ[2],
		                decode$10 = bZ[4];
		               function helpers(name, schema){
		                function to_js(v, cont){
		                 return caml_trampoline_cps_call3(encode$10, schema, v, cont);
		                }
		                function of_js(js, cont){
		                 return caml_exact_trampoline_cps_call
		                         (decode$10,
		                          schema,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(a, js, cont);
		                          });
		                }
		                function of_js_exn(js, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_js,
		                          js,
		                          function(match){
		                           if(0 === match[0]){
		                            var event = match[1];
		                            return cont(event);
		                           }
		                           var e = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$121,
		                                    function(a){
		                                     return caml_trampoline_cps_call4
		     (a,
		      name,
		      pp_decoding,
		      e,
		      function(a){
		       var t12 = caml_jsstring_of_string(a);
		       return cont(caml_throw_js_exception(new error_constr(t12)));
		      });
		                                    });
		                          });
		                }
		                return [0, to_js, , of_js_exn];
		               }
		               var
		                bZ = caml_callback(Make$6, [[0, of_string$47, to_string$60]]),
		                pp$10 = bZ[10],
		                to_string$16 = bZ[9],
		                decode$3 = bZ[4],
		                encode$5 = bZ[2];
		               function of_time$5(t, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (to_rfc3339,
		                         0,
		                         0,
		                         0,
		                         t,
		                         function(a){return cont(caml_jsstring_of_string(a));});
		               }
		               function to_time$7(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$61,
		                         v,
		                         function(match){
		                          if(! match) return cont([1, 0]);
		                          var string = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (to_time$0, [0, -976970511, string], cont);
		                         });
		               }
		               function of_time_local$2(param, cont){
		                var tz_offset_s = param[2], t = param[1];
		                return caml_exact_trampoline_cps_call$2
		                        (to_rfc3339,
		                         0,
		                         0,
		                         [0, tz_offset_s],
		                         t,
		                         function(a){return cont(caml_jsstring_of_string(a));});
		               }
		               function to_time_local$2(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$61,
		                         v,
		                         function(match){
		                          if(! match) return cont([1, 0]);
		                          var string = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (to_time_local, [0, -976970511, string], cont);
		                         });
		               }
		               var
		                include$117 =
		                  caml_callback
		                   (Make$5,
		                    [[0,
		                      Coding$2,
		                      name$31,
		                      ,
		                      pp$122,
		                      key_get$0,
		                      key_set$0,
		                      null$3,
		                      of_any$1,
		                      of_bool$1,
		                      61643255,
		                      of_fields$1,
		                      of_float$5,
		                      of_int$7,
		                      of_int64$1,
		                      of_json$1,
		                      of_list$10,
		                      of_option$3,
		                      of_string$48,
		                      of_time$5,
		                      of_time_local$2,
		                      to_bool$1,
		                      61643255,
		                      to_fields$1,
		                      to_float$4,
		                      to_int$5,
		                      to_int64$3,
		                      to_json$1,
		                      to_list$7,
		                      to_option$4,
		                      to_string$61,
		                      to_time$7,
		                      to_time_local$2,
		                      type_name$1]]),
		                encode_versioned$0 = include$117[3],
		                decode$11 = include$117[4];
		               function of_string$49(s, cont){
		                caml_push_trap
		                 (function(exn){
		                   if(exn[1] === Error$0){
		                    var t12 = exn[2], x = caml_string_of_jsstring(t12.message);
		                    return cont([1, x]);
		                   }
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                var t2 = caml_jsstring_of_string(s), t1 = global.JSON;
		                return caml_exact_trampoline_cps_call
		                        (of_string$0,
		                         t1.parse(t2),
		                         function(a){caml_pop_trap(); return cont(a);});
		               }
		               function to_string$62(t5, cont){
		                var t4 = global.JSON;
		                return cont(caml_string_of_jsstring(t4.stringify(t5)));
		               }
		               var
		                String$0 =
		                  Make_string
		                   ([0,
		                     ,
		                     ,
		                     encode_versioned$0,
		                     decode$11,
		                     cst_application_json,
		                     of_string$49,
		                     to_string$62]);
		               bZ = helpers("Timmy.Week.t", schema$8);
		               var of_js_exn = bZ[3], to_js$0 = bZ[1];
		               function to_js$1(param, cont){
		                var
		                 year = param[3],
		                 month = param[2],
		                 day = param[1],
		                 t2 = to_int$1(month) - 1 | 0;
		                return cont(new date_fromTimeValue(year, t2, day));
		               }
		               function of_js$1(js, cont){
		                var a = js.getDate(), b = js.getMonth() + 1 | 0;
		                return caml_exact_trampoline_cps_call$1
		                        (of_tuple_exn, aCI, [0, js.getFullYear(), b, a], cont);
		               }
		               var sentry = /*@__PURE__*/ requireProd();
		               g
		                ([0,
		                  symbol_bind$5,
		                  symbol_map$5,
		                  ,
		                  bind$8,
		                  return$9,
		                  map$17,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$3]);
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               function raise$1(exn){throw exn;}
		               function fatal(msg){
		                return raise$1
		                        (v$3([0, "ControllerFatal"], caml_jsstring_of_string(msg)));
		               }
		               var
		                buffer$0 =
		                  [246,
		                   function(param, cont){
		                    var builtin = global.Buffer;
		                    if(test(builtin)) return cont(builtin);
		                    call$0
		                     (bPA,
		                      cst_info,
		                      msg_to_jv_array([0, "loading Buffer", [0, builtin, 0]]));
		                    var buffer = requireBuffer$1(), t2 = buffer.Buffer;
		                    global.Buffer = t2;
		                    return cont(buffer.Buffer);
		                   }];
		               function base64_decode(s, cont){
		                var
		                 t6 = caml_jsstring_of_string(s),
		                 a = caml_obj_tag(buffer$0);
		                function b(t5){return cont(t5.from(t6, "base64"));}
		                if(250 === a) return b(buffer$0[1]);
		                if(246 !== a && 244 !== a) return b(buffer$0);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, buffer$0, b);
		               }
		               var node_crypto = /*@__PURE__*/ requireCryptoBrowserify();
		               find_path(global$0, aCJ);
		               function distribution(a, cont){
		                a = getenv("ROUTINE_DIST");
		                if(! a) return cont(2);
		                var dist = a[1];
		                return caml_exact_trampoline_cps_call
		                        (dist_of_string,
		                         dist,
		                         function(match){
		                          if(0 === match[0]){var dist = match[1]; return cont(dist);}
		                          var e = match[1];
		                          return cont(fatal(e));
		                         });
		               }
		               var
		                E$1 = [248, "Ppx_assert_lib.Runtime.E", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  E$1,
		                  function(param, a){
		                   if(param[1] === E$1){
		                    var arg1_002 = param[3], arg0_001 = param[2];
		                    return a
		                            ([1, [0, aCK, [0, [0, arg0_001], [0, arg1_002, 0]]]]);
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aCL], 1));
		                  }]);
		               var null$4 = "<unknown>", libname_ref = [0, null$4];
		               function set$7(str){libname_ref[1] = str;}
		               function unset(param){libname_ref[1] = null$4;}
		               try{bZ = caml_sys_getenv("BENCHMARKS_RUNNER"); var v$4 = bZ;}
		               catch(exn){
		                var exn$0 = caml_wrap_exception(exn);
		                if(exn$0 !== Not_found){
		                 b2 = caml_pop_trap();
		                 var exn$15 = caml_maybe_attach_backtrace(exn$0, 0);
		                 return b2(exn$15);
		                }
		                v$4 = cst$1;
		               }
		               var
		                add_environment_var = v$4 === "TRUE",
		                libs_to_entries = caml_callback(create$5, [0, 10]);
		               try{caml_sys_getenv("FORCE_DROP_BENCH"); var force_drop = 1;}
		               catch(exn){
		                var exn$2 = caml_wrap_exception(exn);
		                if(exn$2 !== Not_found){
		                 b$ = caml_pop_trap();
		                 var exn$14 = caml_maybe_attach_backtrace(exn$2, 0);
		                 return b$(exn$14);
		                }
		                force_drop = 0;
		               }
		               string(cst$1);
		               function compare$141(b, a, cont){
		                return cont(caml_compare(b, a));
		               }
		               var r = [0, 0];
		               function create$25(loc, trips, cont){
		                var gid = r[1];
		                r[1] = 1 + gid | 0;
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         trips,
		                         function(param, cont){
		                          var t = param[3], vs = param[2], x = param[1];
		                          return cont([0, x, [0, vs, t]]);
		                         },
		                         function(members){return cont([0, gid, loc, members]);});
		               }
		               function sexp_of_t$63(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    arg1_492 = param[2],
		                    arg0_491 = param[1],
		                    res0_493 = [0, arg0_491];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$63,
		                            arg1_492,
		                            function(res1_494){
		                             return cont([1, [0, aCR, [0, res0_493, [0, res1_494, 0]]]]);
		                            });
		                  case 1:
		                   var
		                    arg1_496 = param[2],
		                    arg0_495 = param[1],
		                    res0_497 = [0, arg0_495];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_list,
		                            sexp_of_t$63,
		                            arg1_496,
		                            function(res1_498){
		                             return cont([1, [0, aCS, [0, res0_497, [0, res1_498, 0]]]]);
		                            });
		                  case 2:
		                   var arg0_503 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_list,
		                            function(param, cont){
		                             var
		                              arg1_500 = param[2],
		                              arg0_499 = param[1],
		                              res0_501 = [0, arg0_499];
		                             return caml_exact_trampoline_cps_call
		                                     (sexp_of_t$63,
		                                      arg1_500,
		                                      function(res1_502){
		                                       return cont([1, [0, res0_501, [0, res1_502, 0]]]);
		                                      });
		                            },
		                            arg0_503,
		                            function(res0_504){
		                             return cont([1, [0, aCT, [0, res0_504, 0]]]);
		                            });
		                  case 3:
		                   var arg0_509 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_list,
		                            function(param, cont){
		                             var
		                              arg1_506 = param[2],
		                              arg0_505 = param[1],
		                              res0_507 = [0, arg0_505];
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_list,
		                                      sexp_of_t$63,
		                                      arg1_506,
		                                      function(res1_508){
		                                       return cont([1, [0, res0_507, [0, res1_508, 0]]]);
		                                      });
		                            },
		                            arg0_509,
		                            function(res0_510){
		                             return cont([1, [0, aCU, [0, res0_510, 0]]]);
		                            });
		                  case 4:
		                   var arg0_511 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_list,
		                            sexp_of_t$63,
		                            arg0_511,
		                            function(res0_512){
		                             return cont([1, [0, aCV, [0, res0_512, 0]]]);
		                            });
		                  case 5:
		                   var
		                    arg0_517 = param[1],
		                    arg1_514 = arg0_517[2],
		                    arg0_513 = arg0_517[1],
		                    res0_515 = [0, arg0_513];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_list,
		                            function(param, cont){
		                             var variant = param[1];
		                             if(-59723313 <= variant){
		                              var
		                               v_277 = param[2],
		                               arg1_279 = v_277[2],
		                               arg0_278 = v_277[1],
		                               res0_280 = [0, arg0_278];
		                              return caml_exact_trampoline_cps_call$1
		                                      (sexp_of_option,
		                                       sexp_of_t$63,
		                                       arg1_279,
		                                       function(res1_281){
		return cont
		        ([1, [0, aCM, [0, [1, [0, res0_280, [0, res1_281, 0]]], 0]]]);
		                                       });
		                             }
		                             var
		                              v_282 = param[2],
		                              arg1_284 = v_282[2],
		                              arg0_283 = v_282[1],
		                              res0_285 = [0, arg0_283];
		                             return caml_exact_trampoline_cps_call
		                                     (sexp_of_t$63,
		                                      arg1_284,
		                                      function(res1_286){
		                                       return cont
		       ([1, [0, aCN, [0, [1, [0, res0_285, [0, res1_286, 0]]], 0]]]);
		                                      });
		                            },
		                            arg1_514,
		                            function(res1_516){
		                             var res0_518 = [1, [0, res0_515, [0, res1_516, 0]]];
		                             return cont([1, [0, aCW, [0, res0_518, 0]]]);
		                            });
		                  case 6:
		                   var
		                    arg0_523 = param[1],
		                    arg1_520 = arg0_523[2],
		                    arg0_519 = arg0_523[1];
		                   return cont
		                           ([1,
		                             [0,
		                              aCX,
		                              [0, [1, [0, [0, arg0_519], [0, [0, arg1_520], 0]]], 0]]]);
		                  case 7:
		                   var
		                    arg1_526 = param[2],
		                    arg0_525 = param[1],
		                    res0_527 = [0, arg0_525];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_list,
		                            sexp_of_t$63,
		                            arg1_526,
		                            function(res1_528){
		                             return cont([1, [0, aCY, [0, res0_527, [0, res1_528, 0]]]]);
		                            });
		                  default:
		                   var
		                    arg2_531 = param[3],
		                    arg1_530 = param[2],
		                    arg0_529 = param[1],
		                    members_335 = arg0_529[3],
		                    loc_333 = arg0_529[2],
		                    gid_331 = arg0_529[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_list,
		                            function(param, cont){
		                             var
		                              arg1_342 = param[2],
		                              arg0_341 = param[1],
		                              arg1_338 = arg1_342[2],
		                              arg0_337 = arg1_342[1],
		                              res0_343 = [0, arg0_341];
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_list,
		                                      sexp_of_string,
		                                      arg0_337,
		                                      function(res0_339){
		                                       return caml_exact_trampoline_cps_call
		       (sexp_of_t$63,
		        arg1_338,
		        function(res1_340){
		         var res1_344 = [1, [0, res0_339, [0, res1_340, 0]]];
		         return cont([1, [0, res0_343, [0, res1_344, 0]]]);
		        });
		                                      });
		                            },
		                            members_335,
		                            function(arg_336){
		                             var
		                              bnds_330 = [0, [1, [0, aCO, [0, arg_336, 0]]], 0],
		                              bnds_330$0 =
		                                [0, [1, [0, aCP, [0, [0, loc_333], 0]]], bnds_330];
		                             return caml_exact_trampoline_cps_call
		                                     (sexp_of_int$0,
		                                      gid_331,
		                                      function(arg_332){
		                                       var
		bnds_330 = [0, [1, [0, aCQ, [0, arg_332, 0]]], bnds_330$0],
		res0_532 = [1, bnds_330],
		res1_533 = [0, arg1_530];
		                                       return caml_exact_trampoline_cps_call$1
		       (sexp_of_list,
		        sexp_of_t$63,
		        arg2_531,
		        function(res2_534){
		         return cont
		                 ([1,
		                   [0, aCZ, [0, res0_532, [0, res1_533, [0, res2_534, 0]]]]]);
		        });
		                                      });
		                            });
		                }
		               }
		               function constr(s, t){return [0, -59723313, [0, s, t]];}
		               function inherit(loc, t){return [0, -72987685, [0, loc, t]];}
		               function var$(loc, t){return [6, [0, loc, t]];}
		               function poly_variant(loc, xs){return [5, [0, loc, xs]];}
		               var
		                Not_a_tuple =
		                  [248,
		                   "Bin_shape.For_typerep.Not_a_tuple",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Not_a_tuple,
		                  function(a, cont){
		                   if(a[1] === Not_a_tuple){
		                    var arg0_546 = a[2];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_t$63,
		                             arg0_546,
		                             function(res0_547){
		                              return cont([1, [0, aC0, [0, res0_547, 0]]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aC1], 1));
		                  }]);
		               var
		                Buffer_short =
		                  [248, "Bin_prot__Common.Buffer_short", caml_fresh_oo_id()],
		                Read_error =
		                  [248, "Bin_prot__Common.Read_error", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Read_error,
		                  function(b, cont){
		                   if(b[1] !== Read_error){
		                    b = caml_pop_trap();
		                    return b
		                            (caml_maybe_attach_backtrace([0, Assert_failure, aC4], 1));
		                   }
		                   var arg1_002 = b[3], arg0_001 = b[2];
		                   function a(a){
		                    var res0_003 = [0, a];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_int$0,
		                             arg1_002,
		                             function(res1_004){
		                              return cont([1, [0, aC3, [0, res0_003, [0, res1_004, 0]]]]);
		                             });
		                   }
		                   if(typeof arg0_001 === "number")
		                    switch(arg0_001){
		                      case 0:
		                       return a("Neg_int8");
		                      case 1:
		                       return a("Int_code");
		                      case 2:
		                       return a("Int_overflow");
		                      case 3:
		                       return a("Nat0_code");
		                      case 4:
		                       return a("Nat0_overflow");
		                      case 5:
		                       return a("Int32_code");
		                      case 6:
		                       return a("Int64_code");
		                      case 7:
		                       return a("Nativeint_code");
		                      case 8:
		                       return a("Unit_code");
		                      case 9:
		                       return a("Bool_code");
		                      case 10:
		                       return a("Option_code");
		                      case 11:
		                       return a("String_too_long");
		                      case 12:
		                       return a("Variant_tag");
		                      case 13:
		                       return a("Array_too_long");
		                      default: return a("Hashtbl_too_long");
		                    }
		                   switch(arg0_001[0]){
		                     case 0:
		                      var max_len = arg0_001[2], len = arg0_001[1];
		                      return caml_exact_trampoline_cps_call
		                              (sprintf,
		                               aC2,
		                               function(b){
		                                return caml_trampoline_cps_call3(b, len, max_len, a);
		                               });
		                     case 1:
		                      var loc = arg0_001[1]; return a("Sum_tag / " + loc);
		                     case 2:
		                      var loc$0 = arg0_001[1]; return a("Variant / " + loc$0);
		                     case 3:
		                      var loc$1 = arg0_001[1];
		                      return a("Poly_rec_bound / " + loc$1);
		                     case 4:
		                      var loc$2 = arg0_001[1];
		                      return a("Variant_wrong_type / " + loc$2);
		                     case 5:
		                      var loc$3 = arg0_001[1]; return a("Silly_type / " + loc$3);
		                     default:
		                      var loc$4 = arg0_001[1]; return a("Empty_type / " + loc$4);
		                   }
		                  }]);
		               function assert_pos(pos, cont){
		                var a = pos < 0 ? 1 : 0;
		                return a
		                        ? caml_exact_trampoline_cps_call
		                          (invalid_arg, cst_index_out_of_bounds, cont)
		                        : cont(a);
		               }
		               function check_next(buf, next){
		                var a = caml_ba_dim_1(buf) < next ? 1 : 0;
		                if(a) throw caml_maybe_attach_backtrace(Buffer_short, 1);
		                return a;
		               }
		               function bin_write_float_local(buf, pos, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (assert_pos,
		                         pos,
		                         function(a){
		                          var next = pos + 8 | 0;
		                          check_next(buf, next);
		                          caml_ba_uint8_set64(buf, pos, caml_int64_bits_of_float(x));
		                          return cont(next);
		                         });
		               }
		               var dummy_float_buf = create$2(char, c_layout, 8);
		               caml_callback(bin_write_float_local, [dummy_float_buf, 0, 3.1]);
		               max(5, 5);
		               min(1, 2);
		               function bin_shape_ref(x1){
		                var v1 = [0, x1, 0];
		                return [1, cst_ref, v1];
		               }
		               function bin_shape_option(x1){
		                var v1 = [0, x1, 0];
		                return [1, cst_option, v1];
		               }
		               function bin_shape_list(x1){
		                var v1 = [0, x1, 0];
		                return [1, cst_list, v1];
		               }
		               function bin_shape_array(x1){
		                var v1 = [0, x1, 0];
		                return [1, cst_array, v1];
		               }
		               function maybe_annotate_shape(maybe_uuid, shape){
		                if(! maybe_uuid) return shape;
		                var uuid = maybe_uuid[1];
		                return [0, uuid, shape];
		               }
		               function Make_binable_gen(S){
		                var B = S[1], bin_shape_t = maybe_annotate_shape(S[4], B[1]);
		                return [0, , , , , bin_shape_t];
		               }
		               function Make_binable_without_uuid(S){
		                var Binable = S[1];
		                return Make_binable_gen([0, Binable, , , 0]);
		               }
		               caml_callback(ksprintf, [failwith, aC5]);
		               caml_callback(ksprintf, [failwith, aC6]);
		               try{
		                caml_sys_getenv("FORCE_DROP_INLINE_TEST");
		                var force_drop$0 = 1;
		               }
		               catch(exn){
		                var exn$3 = caml_wrap_exception(exn);
		                if(exn$3 !== Not_found){
		                 d = caml_pop_trap();
		                 var exn$13 = caml_maybe_attach_backtrace(exn$3, 0);
		                 return d(exn$13);
		                }
		                force_drop$0 = 0;
		               }
		               caml_callback(create$5, [0, 23]);
		               bZ = "TESTING_FRAMEWORK";
		               a:
		               {
		                try{
		                 caml_sys_getenv("PPX_INLINE_TEST_LIB_AM_RUNNING_INLINE_TEST");
		                }
		                catch(exn){
		                 var exn$5 = caml_wrap_exception(exn);
		                 if(exn$5 !== Not_found){
		                  b2 = caml_pop_trap();
		                  var exn$11 = caml_maybe_attach_backtrace(exn$5, 0);
		                  return b2(exn$11);
		                 }
		                 try{var val = caml_sys_getenv(bZ);}
		                 catch(exn){
		                  var exn$6 = caml_wrap_exception(exn);
		                  if(exn$6 === Not_found){var am_running = 0; break a;}
		                  e = caml_pop_trap();
		                  var exn$10 = caml_maybe_attach_backtrace(exn$6, 0);
		                  return e(exn$10);
		                 }
		                 if(val !== "inline-test"){am_running = 0; break a;}
		                 am_running = 1;
		                 break a;
		                }
		                am_running = 1;
		               }
		               a:
		               {
		                try{var value$5 = caml_sys_getenv("PPX_MODULE_TIMER");}
		                catch(exn){var am_recording_value = 0; break a;}
		                am_recording_value = [0, value$5];
		               }
		               var am_recording = is_some(am_recording_value);
		               function of_string$50(string, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (chop_suffix_exn,
		                         string,
		                         cst_ns,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_string$5, a, cont);
		                         });
		               }
		               function to_string$63(nanos, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$9,
		                         nanos,
		                         function(s1){return cont(s1 + cst_ns);});
		               }
		               function to_string_with_same_unit(list, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7, list, to_string$63, cont);
		               }
		               function create$26(nested_timer, param){
		                return [0,
		                        cst$1,
		                        min_interval_num,
		                        caml_gc_quick_stat(),
		                        nested_timer,
		                        0];
		               }
		               var
		                definition_timer = create$26(0),
		                module_timer = create$26([0, definition_timer]);
		               function record_start(module_name){
		                if(am_recording){
		                 if(! is_empty$0(module_timer[1]))
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, aDc], 1);
		                 module_timer[1] = module_name;
		                 module_timer[3] = caml_gc_quick_stat();
		                 module_timer[2] = time_now_nanosecond_counter_for_timing();
		                }
		               }
		               function record_until(module_name, cont){
		                if(! am_recording) return cont(am_recording);
		                var
		                 until = time_now_nanosecond_counter_for_timing(),
		                 start = module_timer[2],
		                 gc_stats_after = caml_gc_quick_stat(),
		                 gc_stats_before = module_timer[3],
		                 runtime = symbol$52(until, start),
		                 x = module_timer[1];
		                if(x !== module_name){
		                 var a = caml_pop_trap();
		                 return a
		                         (caml_maybe_attach_backtrace([0, Assert_failure, aDd], 1));
		                }
		                var
		                 gc_events =
		                   [0,
		                    gc_stats_after[4] - gc_stats_before[4] | 0,
		                    gc_stats_after[5] - gc_stats_before[5] | 0,
		                    gc_stats_after[14] - gc_stats_before[14] | 0],
		                 a = module_timer[4];
		                function b(nested_timing_events){
		                 var
		                  timing_event =
		                    [0, module_name, runtime, gc_events, nested_timing_events];
		                 module_timer[5] = [0, timing_event, module_timer[5]];
		                 module_timer[1] = cst$1;
		                 module_timer[2] = min_interval_num;
		                 var match = module_timer[4];
		                 if(! match) return cont();
		                 var nested = match[1];
		                 nested[5] = 0;
		                 return cont();
		                }
		                if(! a) return b(0);
		                var nested = a[1];
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys, nested[5], b);
		               }
		               function gc_events_suffix_string(a, cont){
		                var
		                 compactions = a[3],
		                 major_collections = a[2],
		                 minor_collections = a[1];
		                function to_list(description, count){
		                 if(0 === count) return 0;
		                 var s2 = cst$7 + description, s1 = "" + count;
		                 return [0, s1 + s2, 0];
		                }
		                var a = to_list(cst_compactions, compactions);
		                return caml_exact_trampoline_cps_call$1
		                        (append$0,
		                         to_list("major collections", major_collections),
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (append$0,
		                                   to_list("minor collections", minor_collections),
		                                   a,
		                                   function(strings){
		                                    return is_empty(strings)
		    ? cont(cst$1)
		    : caml_exact_trampoline_cps_call$1
		      (concat$0,
		       aDe,
		       strings,
		       function(s2){return cont("; GC: " + s2);});
		                                   });
		                         });
		               }
		               var
		                format$27 = [0, [0, of_string$50, to_string_with_same_unit]];
		               function timing_events_to_strings(list, indent, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         list,
		                         function(timing_event, cont){return cont(timing_event[2]);},
		                         function(string){
		                          var Format = format$27[1];
		                          return caml_trampoline_cps_call2
		                                  (Format[2],
		                                   string,
		                                   function(duration_strings){
		                                    var prefix = make$0(indent, 32);
		                                    return caml_exact_trampoline_cps_call$0
		    (map2_exn,
		     duration_strings,
		     list,
		     function(duration_string, param, cont){
		      var
		       nested_timing_events = param[4],
		       gc_events = param[3],
		       description = param[1];
		      function a(line, cont){return cont(cst$15 + line);}
		      return caml_exact_trampoline_cps_call$1
		              (timing_events_to_strings,
		               nested_timing_events,
		               indent + 4 | 0,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0,
		                                   0,
		                                   a,
		                                   function(s2){
		                                    return caml_exact_trampoline_cps_call
		    (gc_events_suffix_string,
		     gc_events,
		     function(s1){
		      var s2$0 = s1 + s2;
		      return cont([0, duration_string, description + s2$0]);
		     });
		                                   });
		                         });
		               });
		     },
		     function(list){
		      function a(t, left_column_width){
		       if(! t)
		        return caml_exact_trampoline_cps_call$1
		                (map$7,
		                 list,
		                 function(param, cont){
		                  var right = param[2], left = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (sprintf,
		                           aDf,
		                           function(a){
		                            return caml_trampoline_cps_call4
		                                    (a, left_column_width, left, right, cont);
		                           });
		                 },
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (map$7,
		                           a,
		                           function(line, cont){return cont(prefix + line);},
		                           cont);
		                 });
		       var l = t[2], a$0 = t[1], left = a$0[1];
		       return caml_exact_trampoline_cps_call$1
		               (max$2,
		                left_column_width,
		                caml_ml_string_length(left),
		                function(init){
		                 return caml_exact_trampoline_call2(a, l, init);
		                });
		      }
		      return a(list, 0);
		     });
		                                   });
		                         });
		               }
		               function gc_events(i, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$23,
		                         i,
		                         8,
		                         function(b){
		                          var a = 7 === b ? 1 : 0;
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$23,
		                                   i,
		                                   4,
		                                   function(c){
		                                    var b = 3 === c ? 1 : 0;
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$23,
		     i,
		     2,
		     function(c){c = 1 === c ? 1 : 0; return cont([0, c, b, a]);});
		                                   });
		                         });
		               }
		               var
		                fake_timing_events =
		                  [246,
		                   function(a, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (init$7,
		                             12,
		                             function(i, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (symbol$23,
		                                       i + 1 | 0,
		                                       4,
		                                       function(b){
		function a(a){
		 return caml_exact_trampoline_cps_call
		         (gc_events,
		          i,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (of_int$2,
		                    900 * (i + 1 | 0) | 0,
		                    function(d){
		                     var c = i + 1 | 0;
		                     return caml_exact_trampoline_cps_call
		                             (sprintf,
		                              aDh,
		                              function(e){
		                               return caml_trampoline_cps_call2
		                                       (e, c, function(c){return cont([0, c, d, b, a]);});
		                              });
		                    });
		          });
		}
		return 0 === b
		        ? caml_exact_trampoline_cps_call$1
		          (init$7,
		           i + 1 | 0,
		           function(j, cont){
		            return caml_exact_trampoline_cps_call
		                    (gc_events,
		                     j,
		                     function(a){
		                      return caml_exact_trampoline_cps_call
		                              (of_int$2,
		                               900 * (j + 1 | 0) | 0,
		                               function(c){
		                                var b = j + 1 | 0;
		                                return caml_exact_trampoline_cps_call
		(sprintf,
		 aDg,
		 function(d){
		  return caml_trampoline_cps_call2
		          (d, b, function(b){return cont([0, b, c, a, 0]);});
		 });
		                               });
		                     });
		           },
		           a)
		        : a(0);
		                                       });
		                             },
		                             cont);
		                   }];
		               if(am_recording)
		                at_exit
		                 (function(param, cont){
		                   return caml_exact_trampoline_cps_call
		                           (of_rev_keys,
		                            module_timer[5],
		                            function(timing_events){
		                             return caml_exact_trampoline_cps_call$2
		                                     (value_exn,
		                                      0,
		                                      0,
		                                      0,
		                                      am_recording_value,
		                                      function(string){
		                                       function a(timing_events){
		return caml_exact_trampoline_cps_call$1
		        (timing_events_to_strings,
		         timing_events,
		         0,
		         function(a){return cont(iter$1(a, print_endline));});
		                                       }
		                                       var
		c =
		  "ppx_module_timer: overriding time measurements for testing";
		                                       if(string !== "FAKE_MODULES"){
		caml_push_trap(function(exn){return a(timing_events);});
		var Format = format$27[1];
		return caml_trampoline_cps_call2
		        (Format[1],
		         string,
		         function(override){
		          caml_pop_trap();
		          print_endline(c);
		          return caml_exact_trampoline_cps_call$1
		                  (mapi$0,
		                   timing_events,
		                   function(index, timing_event, cont){
		                    return caml_exact_trampoline_cps_call
		                            (of_int$2,
		                             index + 1 | 0,
		                             function(a){
		                              var runtime = symbol$53(override, a);
		                              return caml_exact_trampoline_cps_call$1
		                                      (mapi$0,
		                                       timing_event[4],
		                                       function(index, nested_timing_event, cont){
		return caml_exact_trampoline_cps_call
		        (of_int$2,
		         index + 1 | 0,
		         function(a){
		          var runtime = symbol$53(override, a);
		          return cont
		                  ([0,
		                    nested_timing_event[1],
		                    runtime,
		                    nested_timing_event[3],
		                    nested_timing_event[4]]);
		         });
		                                       },
		                                       function(nested_timing_events){
		return cont
		        ([0,
		          timing_event[1],
		          runtime,
		          timing_event[3],
		          nested_timing_events]);
		                                       });
		                             });
		                   },
		                   a);
		         });
		                                       }
		                                       print_endline(c);
		                                       var b = caml_obj_tag(fake_timing_events);
		                                       if(250 === b) return a(fake_timing_events[1]);
		                                       if(246 !== b && 244 !== b) return a(fake_timing_events);
		                                       return caml_exact_trampoline_cps_call
		       (force_lazy_block, fake_timing_events, a);
		                                      });
		                            });
		                  });
		               var uid$0 = [0, 0];
		               function next$2(name){
		                var code = uid$0[1];
		                uid$0[1]++;
		                return [0, code, name];
		               }
		               next$2(cst_static);
		               function compare$142(k1, k2){
		                if(k1 === k2) return 0;
		                var
		                 b$0 = k2[1],
		                 a$0 = k1[1],
		                 cmp = caml_int_compare(a$0[1], b$0[1]);
		                if(0 !== cmp) return cmp;
		                var b$1 = k2[2], a$1 = k1[2], a = a$1, b = b$1;
		                for(;;){
		                 if(! a) return b ? -1 : 0;
		                 if(! b) return 1;
		                 var
		                  ys = b[2],
		                  y = b[1],
		                  xs = a[2],
		                  x = a[1],
		                  n = compare$142(x, y);
		                 if(0 !== n) return n;
		                 a = xs;
		                 b = ys;
		                }
		               }
		               function same_witness$0(nm1, nm2){
		                return 0 === compare$142(nm1, nm2) ? [0, 0] : 0;
		               }
		               function bQr(X){
		                var uid = next$2(X[1]);
		                function typename_of_t(a, b, c){
		                 return [0, uid, [0, a, [0, b, [0, c, 0]]]];
		                }
		                return [0, typename_of_t];
		               }
		               function bPQ(X){
		                var uid = next$2(X[1]);
		                function typename_of_t(a, b, cont){
		                 return cont([0, uid, [0, a, [0, b, 0]]]);
		                }
		                return [0, typename_of_t];
		               }
		               function bO8(X){
		                var uid = next$2(X[1]);
		                function typename_of_t(a){return [0, uid, [0, a, 0]];}
		                return [0, typename_of_t];
		               }
		               function cc(X){
		                var uid = next$2(X[1]);
		                return [0, [0, uid, 0]];
		               }
		               var
		                typename_of_int = cc([0, cst_int])[1],
		                h = "int32",
		                typename_of_int32 = cc([0, h])[1],
		                typename_of_int64 = cc([0, cst_int64])[1],
		                b3 = "nativeint",
		                typename_of_nativeint = cc([0, b3])[1],
		                z = "char",
		                typename_of_char = cc([0, z])[1],
		                typename_of_float = cc([0, cst_float])[1],
		                typename_of_string = cc([0, cst_string])[1],
		                typename_of_bytes = cc([0, cst_bytes])[1],
		                typename_of_bool = cc([0, cst_bool])[1],
		                j = "unit",
		                typename_of_unit = cc([0, j])[1],
		                M_option = bO8([0, cst_option]),
		                typename_of_option = M_option[1],
		                M_list = bO8([0, cst_list]),
		                typename_of_list = M_list[1],
		                M_array = bO8([0, cst_array]),
		                typename_of_array = M_array[1],
		                cg = "lazy_t",
		                M_lazy_t = bO8([0, cg]),
		                typename_of_lazy_t = M_lazy_t[1],
		                M_ref = bO8([0, cst_ref]),
		                typename_of_ref = M_ref[1],
		                M_function = bPQ([0, cst_function]),
		                typename_of_function = M_function[1];
		               cc([0, "tuple0"]);
		               var
		                M_tuple2 = bPQ([0, "tuple2"]),
		                typename_of_tuple2 = M_tuple2[1],
		                M_tuple3 = bQr([0, "tuple3"]),
		                typename_of_tuple3 = M_tuple3[1],
		                uid$1 = next$2("tuple4");
		               function typename_of_tuple4(a, b, c, d){
		                return [0, uid$1, [0, a, [0, b, [0, c, [0, d, 0]]]]];
		               }
		               var uid$2 = next$2("tuple5");
		               function typename_of_tuple5(a, b, c, d, e){
		                return [0, uid$2, [0, a, [0, b, [0, c, [0, d, [0, e, 0]]]]]];
		               }
		               var Typerep = caml_callback(init_mod, [aDj, aDi]);
		               function arity$0(param, cont){
		                switch(param[0]){
		                  case 0:
		                   return cont(0);
		                  case 1:
		                   return cont(1);
		                  case 2:
		                   return cont(2);
		                  case 3:
		                   return cont(3);
		                  case 4:
		                   return cont(4);
		                  default: return cont(5);
		                }
		               }
		               function typename_of_t$1(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var rep = param[1]; return cont(rep[2]);
		                  case 1:
		                   var rep$0 = param[1]; return cont(rep$0[3]);
		                  case 2:
		                   var rep$1 = param[1]; return cont(rep$1[4]);
		                  case 3:
		                   var rep$2 = param[1]; return cont(rep$2[5]);
		                  case 4:
		                   var rep$3 = param[1]; return cont(rep$3[6]);
		                  default: var rep$4 = param[1]; return cont(rep$4[7]);
		                }
		               }
		               function name$32(rep, cont){
		                return caml_exact_trampoline_cps_call
		                        (typename_of_t$1,
		                         rep,
		                         function(t){var a = t[1]; return cont(a[2]);});
		               }
		               function arity$1(param, cont){
		                switch(param[0]){
		                  case 0:
		                   return cont(2);
		                  case 1:
		                   return cont(3);
		                  case 2:
		                   return cont(4);
		                  default: return cont(5);
		                }
		               }
		               function typename_of_t$2(f, cont){
		                switch(f[0]){
		                  case 0:
		                   f = f[1];
		                   var b = f[2], a = f[1];
		                   return caml_trampoline_cps_call2
		                           (Typerep[14],
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call2
		                                     (Typerep[14],
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (typename_of_tuple2, a, b, cont);
		                                      });
		                            });
		                  case 1:
		                   f = f[1];
		                   var c = f[3], b$0 = f[2], a$0 = f[1];
		                   return caml_trampoline_cps_call2
		                           (Typerep[14],
		                            c,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (Typerep[14],
		                                      b$0,
		                                      function(b){
		                                       return caml_trampoline_cps_call2
		       (Typerep[14],
		        a$0,
		        function(c){return cont(typename_of_tuple3(c, b, a));});
		                                      });
		                            });
		                  case 2:
		                   f = f[1];
		                   var d = f[4], c$0 = f[3], b$1 = f[2], a$1 = f[1];
		                   return caml_trampoline_cps_call2
		                           (Typerep[14],
		                            d,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (Typerep[14],
		                                      c$0,
		                                      function(b){
		                                       return caml_trampoline_cps_call2
		       (Typerep[14],
		        b$1,
		        function(c){
		         return caml_trampoline_cps_call2
		                 (Typerep[14],
		                  a$1,
		                  function(d){return cont(typename_of_tuple4(d, c, b, a));});
		        });
		                                      });
		                            });
		                  default:
		                   f = f[1];
		                   var
		                    e = f[5],
		                    d$0 = f[4],
		                    c$1 = f[3],
		                    b$2 = f[2],
		                    a$2 = f[1];
		                   return caml_trampoline_cps_call2
		                           (Typerep[14],
		                            e,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (Typerep[14],
		                                      d$0,
		                                      function(b){
		                                       return caml_trampoline_cps_call2
		       (Typerep[14],
		        c$1,
		        function(c){
		         return caml_trampoline_cps_call2
		                 (Typerep[14],
		                  b$2,
		                  function(d){
		                   return caml_trampoline_cps_call2
		                           (Typerep[14],
		                            a$2,
		                            function(e){return cont(typename_of_tuple5(e, d, c, b, a));});
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               function label(t, cont){return cont(t[1]);}
		               function arity(t, cont){return cont(t[3]);}
		               function args_labels(t, cont){return cont(t[4]);}
		               function index$1(t, cont){return cont(t[5]);}
		               function ocaml_repr(t, cont){return cont(t[6]);}
		               function create$27(t, cont){return cont(t[8]);}
		               function tyid(t, cont){return cont(t[7]);}
		               function traverse(t, cont){return cont(t[2]);}
		               function internal_use_only(t, cont){return cont(t);}
		               function typename_of_t(t, cont){return cont(t[1]);}
		               function length$14(t, cont){return cont(t[2].length - 1);}
		               function is_polymorphic(t, cont){return cont(t[3]);}
		               function value$6(t, cont){return cont(t[4]);}
		               function fold$10(t, init, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_left$0, f, init, t[2], cont);
		               }
		               function internal_use_only$0(t, cont){return cont(t);}
		               var
		                Variant =
		                  [0,
		                   typename_of_t,
		                   length$14,
		                   function(t, index, cont){
		                    return cont(caml_check_bound(t[2], index)[index + 1]);
		                   },
		                   is_polymorphic,
		                   value$6,
		                   fold$10,
		                   internal_use_only$0];
		               function label$0(t, cont){return cont(t[1]);}
		               function index$2(t, cont){return cont(t[3]);}
		               function get$9(t, cont){return cont(t[5]);}
		               function is_mutable(t, cont){return cont(t[6]);}
		               function tyid$0(t, cont){return cont(t[4]);}
		               function traverse$0(t, cont){return cont(t[2]);}
		               function internal_use_only$1(t, cont){return cont(t);}
		               function typename_of_t$0(t, cont){return cont(t[1]);}
		               function length$15(t, cont){return cont(t[2].length - 1);}
		               function field$0(t, index, cont){
		                return cont(caml_check_bound(t[2], index)[index + 1]);
		               }
		               function has_double_array_tag(t, cont){return cont(t[3]);}
		               function create$28(t, cont){return cont(t[4]);}
		               function fold$11(t, init, f, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_left$0, f, init, t[2], cont);
		               }
		               function internal_use_only$2(t, cont){return cont(t);}
		               function typename_of_t$3(a, cont){
		                if(typeof a === "number")
		                 switch(a){
		                   case 0:
		                    return cont(typename_of_int);
		                   case 1:
		                    return cont(typename_of_int32);
		                   case 2:
		                    return cont(typename_of_int64);
		                   case 3:
		                    return cont(typename_of_nativeint);
		                   case 4:
		                    return cont(typename_of_char);
		                   case 5:
		                    return cont(typename_of_float);
		                   case 6:
		                    return cont(typename_of_string);
		                   case 7:
		                    return cont(typename_of_bytes);
		                   case 8:
		                    return cont(typename_of_bool);
		                   default: return cont(typename_of_unit);
		                 }
		                switch(a[0]){
		                  case 0:
		                   var rep = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (typename_of_t$3,
		                            rep,
		                            function(a){return cont(typename_of_option(a));});
		                  case 1:
		                   var rep$0 = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (typename_of_t$3,
		                            rep$0,
		                            function(a){return cont(typename_of_list(a));});
		                  case 2:
		                   var rep$1 = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (typename_of_t$3,
		                            rep$1,
		                            function(a){return cont(typename_of_array(a));});
		                  case 3:
		                   var rep$2 = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (typename_of_t$3,
		                            rep$2,
		                            function(a){return cont(typename_of_lazy_t(a));});
		                  case 4:
		                   var rep$3 = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (typename_of_t$3,
		                            rep$3,
		                            function(a){return cont(typename_of_ref(a));});
		                  case 5:
		                   a = a[1];
		                   var rng = a[2], dom = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (typename_of_t$3,
		                            rng,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (typename_of_t$3,
		                                      dom,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (typename_of_function, b, a, cont);
		                                      });
		                            });
		                  case 6:
		                   var rep$4 = a[1];
		                   return caml_trampoline_cps_call2(Typerep[2][2], rep$4, cont);
		                  case 7:
		                   var rep$5 = a[1];
		                   return caml_trampoline_cps_call2
		                           (Typerep[10][1], rep$5, cont);
		                  case 8:
		                   var rep$6 = a[1];
		                   return caml_trampoline_cps_call2(Typerep[6][1], rep$6, cont);
		                  default:
		                   var name = a[1][1];
		                   return caml_exact_trampoline_cps_call
		                           (typename_of_t$1, name, cont);
		                }
		               }
		               function same_witness$1(t1, t2, cont){
		                function a(t1, t2){
		                 a:
		                 {
		                  if(typeof t1 === "number")
		                   switch(t1){
		                     case 0:
		                      if(typeof t2 === "number"){
		                       if(0 === t2) return cont(aDk);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 1:
		                      if(typeof t2 === "number"){
		                       if(1 === t2) return cont(aDl);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 2:
		                      if(typeof t2 === "number"){
		                       if(2 === t2) return cont(aDm);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 3:
		                      if(typeof t2 === "number"){
		                       if(3 === t2) return cont(aDn);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 4:
		                      if(typeof t2 === "number"){
		                       if(4 === t2) return cont(aDo);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 5:
		                      if(typeof t2 === "number"){
		                       if(5 === t2) return cont(aDp);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 6:
		                      if(typeof t2 === "number"){
		                       if(6 === t2) return cont(aDq);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 7:
		                      if(typeof t2 === "number"){
		                       if(7 === t2) return cont(aDr);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     case 8:
		                      if(typeof t2 === "number"){
		                       if(8 === t2) return cont(aDs);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                      break;
		                     default:
		                      if(typeof t2 === "number"){
		                       if(9 === t2) return cont(aDt);
		                       break a;
		                      }
		                      if(9 !== t2[0]) break a;
		                   }
		                  else
		                   switch(t1[0]){
		                     case 0:
		                      var r1 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 0:
		                         var r2$0 = t2[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (same_witness$1,
		                                  r1,
		                                  r2$0,
		                                  function(x){return x ? cont(x) : cont(x);});
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 1:
		                      var r1$0 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 1:
		                         var r2$1 = t2[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (same_witness$1,
		                                  r1$0,
		                                  r2$1,
		                                  function(x){return x ? cont(x) : cont(x);});
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 2:
		                      var r1$1 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 2:
		                         var r2$2 = t2[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (same_witness$1,
		                                  r1$1,
		                                  r2$2,
		                                  function(x){return x ? cont(x) : cont(x);});
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 3:
		                      var r1$2 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 3:
		                         var r2$3 = t2[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (same_witness$1,
		                                  r1$2,
		                                  r2$3,
		                                  function(x){return x ? cont(x) : cont(x);});
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 4:
		                      var r1$3 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 4:
		                         var r2$4 = t2[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (same_witness$1,
		                                  r1$3,
		                                  r2$4,
		                                  function(x){return x ? cont(x) : cont(x);});
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 5:
		                      var b = t1[1], rng1 = b[2], dom1 = b[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 5:
		                         b = t2[1];
		                         var rng2 = b[2], dom2 = b[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (same_witness$1,
		                                  dom1,
		                                  dom2,
		                                  function(match){
		                                   return caml_exact_trampoline_cps_call$1
		   (same_witness$1,
		    rng1,
		    rng2,
		    function(match$0){
		     if(match && match$0) return cont(aDu);
		     return cont(0);
		    });
		                                  });
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 6:
		                      var t1$0 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 6:
		                         var t2$0 = t2[1];
		                         switch(t1$0[0]){
		                           case 0:
		                            b = t1$0[1];
		                            if(0 !== t2$0[0]) return cont(0);
		                            var c = t2$0[1], b2 = c[2], a2 = c[1], b1 = b[2], a1 = b[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (same_witness$1,
		                                     a1,
		                                     a2,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$1
		      (same_witness$1,
		       b1,
		       b2,
		       function(match$0){
		        if(match && match$0) return cont(aDv);
		        return cont(0);
		       });
		                                     });
		                           case 1:
		                            b = t1$0[1];
		                            if(1 !== t2$0[0]) return cont(0);
		                            c = t2$0[1];
		                            var
		                             c2 = c[3],
		                             b2$0 = c[2],
		                             a2$0 = c[1],
		                             c1 = b[3],
		                             b1$0 = b[2],
		                             a1$0 = b[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (same_witness$1,
		                                     a1$0,
		                                     a2$0,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$1
		      (same_witness$1,
		       b1$0,
		       b2$0,
		       function(match$0){
		        return caml_exact_trampoline_cps_call$1
		                (same_witness$1,
		                 c1,
		                 c2,
		                 function(match$1){
		                  if(match && match$0 && match$1) return cont(aDw);
		                  return cont(0);
		                 });
		       });
		                                     });
		                           case 2:
		                            b = t1$0[1];
		                            if(2 !== t2$0[0]) return cont(0);
		                            c = t2$0[1];
		                            var
		                             d2 = c[4],
		                             c2$0 = c[3],
		                             b2$1 = c[2],
		                             a2$1 = c[1],
		                             d1 = b[4],
		                             c1$0 = b[3],
		                             b1$1 = b[2],
		                             a1$1 = b[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (same_witness$1,
		                                     a1$1,
		                                     a2$1,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$1
		      (same_witness$1,
		       b1$1,
		       b2$1,
		       function(match$0){
		        return caml_exact_trampoline_cps_call$1
		                (same_witness$1,
		                 c1$0,
		                 c2$0,
		                 function(match$1){
		                  return caml_exact_trampoline_cps_call$1
		                          (same_witness$1,
		                           d1,
		                           d2,
		                           function(match$2){
		                            if(match && match$0 && match$1 && match$2) return cont(aDx);
		                            return cont(0);
		                           });
		                 });
		       });
		                                     });
		                           default:
		                            b = t1$0[1];
		                            if(3 !== t2$0[0]) return cont(0);
		                            c = t2$0[1];
		                            var
		                             e2 = c[5],
		                             d2$0 = c[4],
		                             c2$1 = c[3],
		                             b2$2 = c[2],
		                             a2$2 = c[1],
		                             e1 = b[5],
		                             d1$0 = b[4],
		                             c1$1 = b[3],
		                             b1$2 = b[2],
		                             a1$2 = b[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (same_witness$1,
		                                     a1$2,
		                                     a2$2,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$1
		      (same_witness$1,
		       b1$2,
		       b2$2,
		       function(match$0){
		        return caml_exact_trampoline_cps_call$1
		                (same_witness$1,
		                 c1$1,
		                 c2$1,
		                 function(match$1){
		                  return caml_exact_trampoline_cps_call$1
		                          (same_witness$1,
		                           d1$0,
		                           d2$0,
		                           function(match$2){
		                            return caml_exact_trampoline_cps_call$1
		                                    (same_witness$1,
		                                     e1,
		                                     e2,
		                                     function(match$3){
		                                      if(match && match$0 && match$1 && match$2 && match$3)
		                                       return cont(aDy);
		                                      return cont(0);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                         }
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 7:
		                      var r1$4 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 7:
		                         var r2$5 = t2[1];
		                         return caml_trampoline_cps_call2
		                                 (Typerep[10][1],
		                                  r2$5,
		                                  function(a){
		                                   return caml_trampoline_cps_call2
		   (Typerep[10][1],
		    r1$4,
		    function(b){return cont(same_witness$0(b, a));});
		                                  });
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     case 8:
		                      var r1$5 = t1[1];
		                      if(typeof t2 === "number") break a;
		                      switch(t2[0]){
		                        case 8:
		                         var r2$6 = t2[1];
		                         return caml_trampoline_cps_call2
		                                 (Typerep[6][1],
		                                  r2$6,
		                                  function(a){
		                                   return caml_trampoline_cps_call2
		   (Typerep[6][1],
		    r1$5,
		    function(b){return cont(same_witness$0(b, a));});
		                                  });
		                        case 9: break;
		                        default: break a;
		                      }
		                      break;
		                     default:
		                      b = t1[1];
		                      var name1 = b[1];
		                      if(typeof t2 !== "number" && 9 === t2[0]){
		                       c = t2[1];
		                       var r2$7 = c[2], name2 = c[1], r1$7 = b[2];
		                       return caml_exact_trampoline_cps_call
		                               (typename_of_t$1,
		                                name2,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call
		 (typename_of_t$1,
		  name1,
		  function(c){
		   var x = same_witness$0(c, b);
		   if(x) return cont(x);
		   if(r1$7){
		    c = r1$7[1];
		    var
		     d = caml_obj_tag(c),
		     e =
		       function(t1){
		        if(! r2$7) return caml_exact_trampoline_call2(a, t1, t2);
		        var b = r2$7[1], c = caml_obj_tag(b);
		        if(250 === c)
		         return caml_exact_trampoline_call2(a, t1, b[1]);
		        if(246 !== c && 244 !== c)
		         return caml_exact_trampoline_call2(a, t1, b);
		        return caml_exact_trampoline_cps_call
		                (force_lazy_block,
		                 b,
		                 function(b){return caml_exact_trampoline_call2(a, t1, b);});
		       };
		    if(250 === d) return e(c[1]);
		    if(246 !== d && 244 !== d) return e(c);
		    return caml_exact_trampoline_cps_call
		            (force_lazy_block, c, e);
		   }
		   if(! r2$7) return cont(0);
		   c = r2$7[1];
		   d = caml_obj_tag(c);
		   if(250 === d)
		    return caml_exact_trampoline_call2(a, t1, c[1]);
		   if(246 !== d && 244 !== d)
		    return caml_exact_trampoline_call2(a, t1, c);
		   return caml_exact_trampoline_cps_call
		           (force_lazy_block,
		            c,
		            function(b){return caml_exact_trampoline_call2(a, t1, b);});
		  });
		                                });
		                      }
		                      var r1$6 = b[2];
		                      if(! r1$6) return cont(0);
		                      b = r1$6[1];
		                      c = caml_obj_tag(b);
		                      if(250 === c)
		                       return caml_exact_trampoline_call2(a, b[1], t2);
		                      if(246 !== c && 244 !== c)
		                       return caml_exact_trampoline_call2(a, b, t2);
		                      return caml_exact_trampoline_cps_call
		                              (force_lazy_block,
		                               b,
		                               function(b){return caml_exact_trampoline_call2(a, b, t2);});
		                   }
		                  var r2 = t2[1][2];
		                  if(! r2) return cont(0);
		                  b = r2[1];
		                  c = caml_obj_tag(b);
		                  if(250 === c)
		                   return caml_exact_trampoline_call2(a, t1, b[1]);
		                  if(246 !== c && 244 !== c)
		                   return caml_exact_trampoline_call2(a, t1, b);
		                  return caml_exact_trampoline_cps_call
		                          (force_lazy_block,
		                           b,
		                           function(b){return caml_exact_trampoline_call2(a, t1, b);});
		                 }
		                 if(typeof t1 === "number"){
		                  if(0 !== t1) return cont(0);
		                 }
		                 else if(9 !== t1[0]) return cont(0);
		                 return cont(0);
		                }
		                return a(t1, t2);
		               }
		               function same(a, b, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (same_witness$1,
		                         a,
		                         b,
		                         function(a){return cont(0 !== a ? 1 : 0);});
		               }
		               function same_witness_exn(a, b, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (same_witness$1,
		                         a,
		                         b,
		                         function(a){
		                          if(a){var proof = a[1]; return cont(proof);}
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Assert_failure, aDz], 1));
		                         });
		               }
		               function head(t, cont){
		                function a(t){
		                 if(typeof t !== "number" && 9 === t[0]){
		                  var b = t[1][2];
		                  if(b){
		                   b = b[1];
		                   var c = caml_obj_tag(b);
		                   if(250 === c) return caml_exact_trampoline_call1(a, b[1]);
		                   if(246 !== c && 244 !== c)
		                    return caml_exact_trampoline_call1(a, b);
		                   return caml_exact_trampoline_cps_call
		                           (force_lazy_block, b, a);
		                  }
		                 }
		                 return cont(t);
		                }
		                return a(t);
		               }
		               caml_callback
		                (update_mod,
		                 [aDA,
		                  Typerep,
		                  [0,
		                   [0, arity$0, typename_of_t$1, name$32],
		                   [0, arity$1, typename_of_t$2],
		                   [0],
		                   [0,
		                    label,
		                    arity,
		                    args_labels,
		                    index$1,
		                    ocaml_repr,
		                    create$27,
		                    tyid,
		                    traverse,
		                    internal_use_only],
		                   [0],
		                   Variant,
		                   [0],
		                   [0,
		                    label$0,
		                    index$2,
		                    get$9,
		                    is_mutable,
		                    tyid$0,
		                    traverse$0,
		                    internal_use_only$1],
		                   [0],
		                   [0,
		                    typename_of_t$0,
		                    length$15,
		                    field$0,
		                    has_double_array_tag,
		                    create$28,
		                    fold$11,
		                    internal_use_only$2],
		                   same,
		                   same_witness$1,
		                   same_witness_exn,
		                   typename_of_t$3,
		                   head]]);
		               function repr_of_poly_variant(variant){
		                if(typeof variant === "number") return variant;
		                var size = variant.length - 1;
		                if(2 !== size)
		                 throw caml_maybe_attach_backtrace
		                        ([0, Assert_failure, aDC], 1);
		                var repr = variant[1];
		                if(typeof repr === "number") return repr;
		                throw caml_maybe_attach_backtrace([0, Assert_failure, aDB], 1);
		               }
		               function hash_variant(s){
		                var b = caml_ml_string_length(s) - 1 | 0, a = 0;
		                if(b < 0)
		                 var accu$1 = a;
		                else {
		                 var accu$0 = a, i = 0;
		                 for(;;){
		                  a = (223 * accu$0 | 0) + caml_string_get(s, i) | 0;
		                  var c = i + 1 | 0;
		                  if(b === i){accu$1 = a; break;}
		                  accu$0 = a;
		                  i = c;
		                 }
		                }
		                var accu = accu$1 & 2147483647;
		                return 1073741823 < accu ? accu + 2147483648 | 0 : accu;
		               }
		               var b1 = hash_variant("Latency_stats");
		               if(repr_of_poly_variant(-894644482) !== b1){
		                b$ = caml_pop_trap();
		                return b$
		                        (caml_maybe_attach_backtrace([0, Assert_failure, bNG], 1));
		               }
		               b1 = hash_variant(cst_zero);
		               if(repr_of_poly_variant(-789508312) !== b1){
		                b4 = caml_pop_trap();
		                return b4
		                        (caml_maybe_attach_backtrace([0, Assert_failure, bNF], 1));
		               }
		               function has_double_array_tag$0(a){
		                return 254 === caml_obj_tag(a) ? 1 : 0;
		               }
		               if(! has_double_array_tag$0([254, 0., 0.])){
		                b$ = caml_pop_trap();
		                return b$
		                        (caml_maybe_attach_backtrace([0, Assert_failure, bNE], 1));
		               }
		               if(has_double_array_tag$0([0, 0., 0.])){
		                b$ = caml_pop_trap();
		                return b$
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aDD], 1));
		               }
		               function bPx(X){bPQ(X);}
		               function cd(X){bO8(X);}
		               function bX(X){cc(X);}
		               set$7("splittable_random");
		               function mix_bits(z, n){
		                return caml_int64_xor
		                        (z, caml_int64_shift_right_unsigned(z, n));
		               }
		               function mix64(z){
		                var
		                 z$0 = caml_int64_mul(mix_bits(z, 33), aDF),
		                 z$1 = caml_int64_mul(mix_bits(z$0, 33), aDG);
		                return mix_bits(z$1, 33);
		               }
		               function next_seed(t){
		                var next = caml_int64_add(t[1], t[2]);
		                t[1] = next;
		                return next;
		               }
		               function next_int64(t){return mix64(next_seed(t));}
		               function bool(state){
		                var x = next_int64(state);
		                return caml_equal(caml_int64_or(x, aDE), x);
		               }
		               function uniform(state, lo, hi, cont){
		                function a(a){
		                 var remainder_maximum = caml_int64_sub(hi, lo);
		                 if(caml_equal(remainder_maximum, draw_maximum))
		                  return cont
		                          (caml_int64_add
		                            (caml_int64_and(next_int64(state), draw_maximum), lo));
		                 if(caml_greaterequal(remainder_maximum, aDJ))
		                  for(;;){
		                   var
		                    draw$0 = caml_int64_and(next_int64(state), draw_maximum),
		                    remainder =
		                      caml_int64_mod
		                       (draw$0, caml_int64_add(remainder_maximum, bl));
		                   if
		                    (caml_lessequal
		                      (caml_int64_sub(draw$0, remainder),
		                       caml_int64_sub(draw_maximum, remainder_maximum)))
		                    return cont(caml_int64_add(remainder, lo));
		                  }
		                 else
		                  for(;;){
		                   var draw = next_int64(state);
		                   if(caml_lessequal(lo, draw) && caml_lessequal(draw, hi))
		                    return cont(draw);
		                  }
		                }
		                if(! caml_greaterthan(lo, hi)) return a();
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int64$0,
		                         hi,
		                         function(c){
		                          var b = [0, [1, [0, aDH, [0, c, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int64$0,
		                                   lo,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (raise_s,
		     [1,
		      [0,
		       [0, "int64: crossed bounds"],
		       [0, [1, [0, aDI, [0, c, 0]]], b]]],
		     a);
		                                   });
		                         });
		               }
		               function uniform$0(state, lo, hi, cont){
		                var
		                 lo$0 = caml_int64_of_int32(lo),
		                 hi$0 = caml_int64_of_int32(hi);
		                return caml_exact_trampoline_cps_call$0
		                        (uniform,
		                         state,
		                         lo$0,
		                         hi$0,
		                         function(a){return cont(caml_int64_to_int32(a));});
		               }
		               function uniform$1(state, lo, hi, cont){
		                var
		                 lo$0 = caml_int64_of_int32(lo),
		                 hi$0 = caml_int64_of_int32(hi);
		                return caml_exact_trampoline_cps_call$0
		                        (uniform,
		                         state,
		                         lo$0,
		                         hi$0,
		                         function(a){return cont(caml_int64_to_int32(a));});
		               }
		               function nativeint(state, lo, hi, cont){
		                var
		                 lo$0 = caml_int64_of_int32(lo),
		                 hi$0 = caml_int64_of_int32(hi);
		                return caml_exact_trampoline_cps_call$0
		                        (uniform,
		                         state,
		                         lo$0,
		                         hi$0,
		                         function(a){return cont(caml_int64_to_int32(a));});
		               }
		               function uniform$2(state, lo, hi, cont){
		                var lo$0 = to_int64$0(lo), hi$0 = to_int64$0(hi);
		                return caml_exact_trampoline_cps_call$0
		                        (uniform,
		                         state,
		                         lo$0,
		                         hi$0,
		                         function(a){return cont(of_int64_trunc$0(a));});
		               }
		               function unit_float_from_int64(int64){
		                return caml_int64_to_float
		                        (caml_int64_shift_right_unsigned(int64, 11))
		                       * 1.1102230246251565e-16;
		               }
		               function unit_float(state){
		                return unit_float_from_int64(next_int64(state));
		               }
		               function float$0(state, lo, hi, cont){
		                var a = is_finite(lo), a = a ? is_finite(hi) : a;
		                function b(b){
		                 function a(lo, hi){
		                  var range = hi - lo;
		                  if(is_finite(range))
		                   return cont(lo + unit_float(state) * range);
		                  var mid = (hi + lo) / 2.;
		                  return bool(state)
		                          ? caml_exact_trampoline_call2(a, lo, mid)
		                          : caml_exact_trampoline_call2(a, mid, hi);
		                 }
		                 if(! (hi < lo)) return a(lo, hi);
		                 return caml_exact_trampoline_cps_call
		                         (sexp_of_float,
		                          hi,
		                          function(sexp){
		                           var b = [0, [1, [0, aDM, [0, sexp, 0]]], 0];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_float,
		                                    lo,
		                                    function(sexp){
		                                     return caml_exact_trampoline_cps_call
		     (raise_s,
		      [1,
		       [0,
		        [0, "float: bounds are crossed"],
		        [0, [1, [0, aDN, [0, sexp, 0]]], b]]],
		      function(b){return a(lo, hi);});
		                                    });
		                          });
		                }
		                if(! (1 - a)) return b();
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_float,
		                         hi,
		                         function(sexp){
		                          var a = [0, [1, [0, aDK, [0, sexp, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_float,
		                                   lo,
		                                   function(sexp){
		                                    return caml_exact_trampoline_cps_call
		    (raise_s,
		     [1,
		      [0,
		       [0, "float: bounds are not finite numbers"],
		       [0, [1, [0, aDL, [0, sexp, 0]]], a]]],
		     b);
		                                   });
		                         });
		               }
		               if(add_environment_var){
		                var
		                 f$12 =
		                   function(param, cont){
		                    return cont
		                            (function(param, cont){
		                              return cont(unit_float_from_int64(int64));
		                             });
		                   },
		                 b1 = force_drop ? -950194894 : 984731018;
		                if(984731018 <= b1){
		                 var libname = libname_ref[1];
		                 try{d = caml_callback(find, [libs_to_entries, libname]);}
		                 catch(exn){
		                  var exn$1 = caml_wrap_exception(exn);
		                  if(exn$1 !== Not_found){
		                   h = caml_pop_trap();
		                   var exn$9 = caml_maybe_attach_backtrace(exn$1, 0);
		                   return h(exn$9);
		                  }
		                  d = 0;
		                 }
		                 caml_callback
		                  (add$0,
		                   [libs_to_entries,
		                    libname,
		                    [0,
		                     [0,
		                      1,
		                      "let int64 = 1L in fun () -> unit_float_from_int64 int64",
		                      cst_src_splittable_random_ml,
		                      "unit_float_from_int64",
		                      cst_src_splittable_random_ml,
		                      263,
		                      0,
		                      99,
		                      [0, f$12],
		                      0],
		                     d]]);
		                }
		               }
		               function Make$14(M){
		                function bits_to_represent(t){
		                 if(! M[12].call(null, t, M[42]))
		                  throw caml_maybe_attach_backtrace
		                         ([0, Assert_failure, aDO], 1);
		                 var t$0 = t, n = [0, 0];
		                 for(;;){
		                  if(! M[15].call(null, t$0, M[42])) return n[1];
		                  var a = M[77].call(null, t$0, 1);
		                  incr$0(n);
		                  t$0 = a;
		                 }
		                }
		                function log_uniform(state, lo, hi, cont){
		                 var
		                  min_bits = bits_to_represent(lo),
		                  max_bits = bits_to_represent(hi);
		                 return caml_exact_trampoline_cps_call$0
		                         (uniform$0,
		                          state,
		                          min_bits,
		                          max_bits,
		                          function(bits){
		                           var
		                            a = M[76].call(null, M[43], bits),
		                            b = M[69].call(null, a);
		                           return caml_trampoline_cps_call2
		                                   (M[20],
		                                    hi,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      b,
		      function(b){
		       var
		        a =
		          bits === 0 ? M[42] : M[76].call(null, M[43], bits - 1 | 0);
		       return caml_trampoline_cps_call2
		               (M[21],
		                lo,
		                function(c){
		                 return caml_trampoline_cps_call2
		                         (c,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (M[100], state, a, b, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return [0, log_uniform];
		               }
		               var
		                For_int =
		                  Make$14
		                   ([0,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     function(b, a){return a <= b ? 1 : 0;},
		                     ,
		                     ,
		                     function(b, a){return a < b ? 1 : 0;},
		                     ,
		                     ,
		                     ,
		                     ,
		                     min$2,
		                     max$2,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     min_value$3,
		                     1,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     pred$2,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     shift_left,
		                     shift_right$0,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     uniform$0]),
		                For_int32 =
		                  Make$14
		                   ([0,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     greater_equal,
		                     ,
		                     ,
		                     symbol$30,
		                     ,
		                     ,
		                     ,
		                     ,
		                     min$9,
		                     max$9,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     min_value$1,
		                     1,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     pred,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     shift_left$2,
		                     shift_right$3,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     uniform$1]),
		                For_int63 =
		                  Make$14
		                   ([0,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     greater_equal$0,
		                     ,
		                     ,
		                     symbol$48,
		                     ,
		                     ,
		                     ,
		                     ,
		                     min$10,
		                     max$10,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     min_interval_num,
		                     min_scale,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     pred$4,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     shift_left$4,
		                     shift_right$5,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     uniform$2]),
		                For_int64 =
		                  Make$14
		                   ([0,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     function(b, a){return caml_greaterequal(b, a);},
		                     ,
		                     ,
		                     function(b, a){return caml_greaterthan(b, a);},
		                     ,
		                     ,
		                     ,
		                     ,
		                     min$3,
		                     max$3,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     min_value,
		                     one,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     pred$0,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     shift_left$1,
		                     shift_right$2,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     uniform]),
		                For_nativeint =
		                  Make$14
		                   ([0,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     symbol$4,
		                     ,
		                     ,
		                     symbol$3,
		                     ,
		                     ,
		                     ,
		                     ,
		                     min$4,
		                     max$4,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     zero,
		                     1,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     pred$1,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     shift_left$0,
		                     shift_right$1,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     ,
		                     nativeint]),
		                log_uniform = For_int[1],
		                log_uniform$0 = For_int32[1],
		                log_uniform$1 = For_int63[1],
		                log_uniform$2 = For_int64[1],
		                log_uniform$3 = For_nativeint[1];
		               unset();
		               function offset$0(param){return param ? 1 : 0;}
		               function generate(t, size, random, cont){
		                if(0 <= size)
		                 return caml_trampoline_cps_call3(t, size, random, cont);
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         size,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (raise_s,
		                                   [1,
		                                    [0,
		                                     [0, "Base_quickcheck.Generator.generate: size < 0"],
		                                     [0, [1, [0, aDP, [0, a, 0]]], 0]]],
		                                   cont);
		                         });
		               }
		               function size(size, param, cont){return cont(size);}
		               function with_size(t, size){
		                function f(param, random, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (generate, t, size, random, cont);
		                }
		                return f;
		               }
		               function filter_map$4(t, f){
		                function loop(size, random, cont){
		                 function a(size){
		                  return caml_exact_trampoline_cps_call$0
		                          (generate,
		                           t,
		                           size,
		                           random,
		                           function(x){
		                            return caml_exact_trampoline_cps_call
		                                    (f,
		                                     x,
		                                     function(match){
		                                      if(match){var y = match[1]; return cont(y);}
		                                      var size$0 = size + 1 | 0;
		                                      return caml_exact_trampoline_call1(a, size$0);
		                                     });
		                           });
		                 }
		                 return a(size);
		                }
		                return loop;
		               }
		               function filter$8(t, f){
		                return filter_map$4
		                        (t,
		                         function(x, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (f, x, function(a){return a ? cont([0, x]) : cont(0);});
		                         });
		               }
		               function return$23(x, cont){
		                function f(a, param, cont){return cont(x);}
		                return cont(f);
		               }
		               function map$37(t, f, cont){
		                function f$0(size, random, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (generate,
		                          t,
		                          size,
		                          random,
		                          function(a){return caml_trampoline_cps_call2(f, a, cont);});
		                }
		                return cont(f$0);
		               }
		               function bind$22(t, f, cont){
		                function f$0(size, random, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (generate,
		                          t,
		                          size,
		                          random,
		                          function(x){
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    x,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (generate, a, size, random, cont);
		                                    });
		                          });
		                }
		                return cont(f$0);
		               }
		               function all$18(list){
		                function f(size, random, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          list,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (generate, a, size, random, cont);
		                          },
		                          cont);
		                }
		                return f;
		               }
		               var
		                For_monad = Make([0, bind$22, return$23, [0, , map$37]]),
		                join$4 = For_monad[7];
		               function of_list$11(list, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (to_array,
		                          list,
		                          function(array){
		                           var hi = array.length - 2 | 0;
		                           function f(param, random, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (uniform$0,
		                                     random,
		                                     0,
		                                     hi,
		                                     function(index){
		                                      return cont(caml_check_bound(array, index)[index + 1]);
		                                     });
		                           }
		                           return cont(f);
		                          });
		                }
		                return is_empty(list)
		                        ? caml_exact_trampoline_cps_call
		                          (raise_s,
		                           [0, "Base_quickcheck.Generator.of_list: empty list"],
		                           a)
		                        : a();
		               }
		               function union$5(list, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_list$11,
		                         list,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(join$4, a, cont);
		                         });
		               }
		               function of_weighted_list(alist, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (unzip,
		                          alist,
		                          function(match){
		                           var values = match[2], weights = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (to_array,
		                                    values,
		                                    function(value_array){
		                                     return caml_exact_trampoline_cps_call$1
		     (init$6,
		      value_array.length - 1,
		      function(param){return 0.;},
		      function(array){
		       function a(t, init){
		        if(! t){
		         var
		          sum = init[2],
		          c =
		            function(a){
		             function f(param, random, cont){
		              return caml_exact_trampoline_cps_call$0
		                      (float$0,
		                       random,
		                       0.,
		                       sum,
		                       function(choice){
		                        return caml_exact_trampoline_cps_call$7
		                                (binary_search$0,
		                                 0,
		                                 0,
		                                 array,
		                                 function(b, a){return caml_float_compare(b, a);},
		                                 926943384,
		                                 choice,
		                                 function(a){
		                                  if(a){
		                                   var index = a[1];
		                                   return cont(caml_check_bound(value_array, index)[index + 1]);
		                                  }
		                                  a = caml_pop_trap();
		                                  return a
		  (caml_maybe_attach_backtrace([0, Assert_failure, aDS], 1));
		                                 });
		                       });
		             }
		             return cont(f);
		            };
		         return sum <= 0.
		                 ? caml_exact_trampoline_cps_call
		                   (raise_s,
		                    [0,
		                     "Base_quickcheck.Generator.of_weighted_list: total weight is zero"],
		                    c)
		                 : c(0);
		        }
		        var l = t[2], weight = t[1], acc = init[2], index = init[1];
		        function b(c){
		         function b(b){
		          var cumulative = acc + weight;
		          caml_check_bound(array, index)[index + 1] = cumulative;
		          var init = [0, index + 1 | 0, cumulative];
		          return caml_exact_trampoline_call2(a, l, init);
		         }
		         if(! (weight < 0.)) return b();
		         return caml_exact_trampoline_cps_call
		                 (sexp_of_float,
		                  weight,
		                  function(sexp){
		                   return caml_exact_trampoline_cps_call
		                           (raise_s,
		                            [1,
		                             [0,
		                              [0,
		                               "Base_quickcheck.Generator.of_weighted_list: weight is negative"],
		                              [0, [1, [0, aDR, [0, sexp, 0]]], 0]]],
		                            b);
		                  });
		        }
		        if(! (1 - is_finite(weight))) return b();
		        return caml_exact_trampoline_cps_call
		                (sexp_of_float,
		                 weight,
		                 function(sexp){
		                  return caml_exact_trampoline_cps_call
		                          (raise_s,
		                           [1,
		                            [0,
		                             [0,
		                              "Base_quickcheck.Generator.of_weighted_list: weight is not finite"],
		                             [0, [1, [0, aDQ, [0, sexp, 0]]], 0]]],
		                           b);
		                 });
		       }
		       return a(weights, [0, 0, 0.]);
		      });
		                                    });
		                          });
		                }
		                return is_empty(alist)
		                        ? caml_exact_trampoline_cps_call
		                          (raise_s,
		                           [0,
		                            "Base_quickcheck.Generator.of_weighted_list: empty list"],
		                           a)
		                        : a();
		               }
		               function weighted_union(alist, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_weighted_list,
		                         alist,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(join$4, a, cont);
		                         });
		               }
		               function of_lazy$0(lazy_t){
		                function f(size, random, cont){
		                 var a = caml_obj_tag(lazy_t);
		                 function b(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (generate, a, size, random, cont);
		                 }
		                 if(250 === a) return b(lazy_t[1]);
		                 if(246 !== a && 244 !== a) return b(lazy_t);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, lazy_t, b);
		                }
		                return f;
		               }
		               function fixed_point(of_generator, cont){
		                var lazy_t = [];
		                caml_update_dummy
		                 (lazy_t,
		                  [246,
		                   function(param, cont){
		                    return caml_exact_trampoline_cps_call
		                            (of_generator, of_lazy$0(lazy_t), cont);
		                   }]);
		                var a = caml_obj_tag(lazy_t);
		                if(250 === a) return cont();
		                if(246 !== a && 244 !== a) return cont(lazy_t);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, lazy_t, cont);
		               }
		               function sizes(a, opt, param){
		                var
		                 min_length = a ? a[1] : 0,
		                 max_length = opt ? opt[1] : max_value;
		                function f(size, random, cont){
		                 if(min_length <= max_length){
		                  var
		                   upper_bound = min_length + size | 0,
		                   a =
		                     function(max_length){
		                      return caml_exact_trampoline_cps_call$0
		                              (log_uniform,
		                               random,
		                               min_length,
		                               max_length,
		                               function(len){
		                                return 0 === len
		? cont(0)
		: caml_exact_trampoline_cps_call$1
		  (init$6,
		   len,
		   function(param){return 0;},
		   function(sizes){
		    var
		     remaining = size - (len - min_length | 0) | 0,
		     max_index = len - 1 | 0;
		    function b(){
		     var a = max_index - 1 | 0;
		     function c(){
		      function f(a){return a;}
		      var
		       m = [0, min_value$3, function(b, a){return b + a | 0;}],
		       a = len - min_length | 0;
		      return caml_exact_trampoline_cps_call$2
		              (sum,
		               fold,
		               m,
		               sizes,
		               f,
		               function(b){
		                if((b + a | 0) === size)
		                 return cont(concat_of_array(sizes));
		                b = caml_pop_trap();
		                return b
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aDT], 1));
		               });
		     }
		     function b(i){
		      return caml_exact_trampoline_cps_call$0
		              (uniform$0,
		               random,
		               i,
		               max_index,
		               function(j){
		                swap(sizes, i, j);
		                var d = i + 1 | 0;
		                return a !== i ? caml_exact_trampoline_call1(b, d) : c();
		               });
		     }
		     return a < 0 ? c() : b(0);
		    }
		    function a(for$){
		     return caml_exact_trampoline_cps_call$0
		             (log_uniform,
		              random,
		              0,
		              max_index,
		              function(index){
		               sizes[index + 1] =
		                caml_check_bound(sizes, index)[index + 1] + 1 | 0;
		               var c = for$ + 1 | 0;
		               return remaining !== for$
		                       ? caml_exact_trampoline_call1(a, c)
		                       : b();
		              });
		    }
		    return remaining < 1 ? b() : a(1);
		   });
		                               });
		                     };
		                  return min_length <= upper_bound
		                          ? caml_exact_trampoline_cps_call$1
		                            (min$2, max_length, upper_bound, a)
		                          : a(max_length);
		                 }
		                 var raise = caml_pop_trap();
		                 return raise
		                         (caml_maybe_attach_backtrace([0, Assert_failure, aDU], 1));
		                }
		                return f;
		               }
		               caml_callback(For_monad[11][1], [0]);
		               function quickcheck_generator_bool(param, random, cont){return cont(bool(random));
		               }
		               function quickcheck_generator_option(value_t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$37,
		                         value_t,
		                         return$4,
		                         function(b){
		                          var a = [0, b, 0];
		                          return caml_trampoline_cps_call2
		                                  (For_monad[11][1],
		                                   0,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (union$5, [0, b, a], cont);
		                                   });
		                         });
		               }
		               function list_generic(min_length, max_length, elt_gen, cont){
		                var a = sizes(min_length, max_length);
		                return caml_trampoline_cps_call3
		                        (For_monad[11][4][2],
		                         a,
		                         function(sizes, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   sizes,
		                                   function(size, cont){return cont(with_size(elt_gen, size));},
		                                   function(a){return cont(all$18(a));});
		                         },
		                         cont);
		               }
		               function quickcheck_generator_list(elt_gen, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (list_generic, 0, 0, elt_gen, cont);
		               }
		               function list_with_length(elt_gen, length, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (list_generic, [0, length], [0, length], elt_gen, cont);
		               }
		               function char_uniform_inclusive(lo, hi){
		                function f(param, random, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (uniform$0, random, lo, hi, cont);
		                }
		                return f;
		               }
		               var
		                char_uppercase = char_uniform_inclusive(65, 90),
		                char_lowercase = char_uniform_inclusive(97, 122),
		                char_digit = char_uniform_inclusive(48, 57),
		                char_print_uniform = char_uniform_inclusive(32, 126),
		                min_value$2 = 0,
		                max_value$1 = 255,
		                char_uniform =
		                  char_uniform_inclusive(min_value$2, max_value$1),
		                char_alpha =
		                  caml_callback
		                   (union$5, [[0, char_lowercase, [0, char_uppercase, 0]]]),
		                char_alphanum =
		                  caml_callback
		                   (weighted_union,
		                    [[0, [0, 52., char_alpha], [0, [0, 10., char_digit], 0]]]);
		               caml_callback
		                (of_list$11, [caml_callback(filter, [all$12, is_whitespace])]);
		               var
		                char_print =
		                  caml_callback
		                   (weighted_union,
		                    [[0,
		                      [0, 10., char_alphanum],
		                      [0, [0, 1., char_print_uniform], 0]]]),
		                d =
		                  [0,
		                   [0, 1., caml_callback(For_monad[11][1], [max_value$1])],
		                   0],
		                quickcheck_generator_char =
		                  caml_callback
		                   (weighted_union,
		                    [[0,
		                      [0, 100., char_print],
		                      [0,
		                       [0, 10., char_uniform],
		                       [0,
		                        [0, 1., caml_callback(For_monad[11][1], [min_value$2])],
		                        d]]]]);
		               function small_int(allow_zero){
		                function f(size, random, cont){
		                 var
		                  lower_bound = 0 ,
		                  upper_bound = size + 1 | 0;
		                 return caml_exact_trampoline_cps_call$0
		                         (log_uniform,
		                          random,
		                          0,
		                          upper_bound - lower_bound | 0,
		                          function(weighted_low){
		                           var weighted_high = upper_bound - weighted_low | 0;
		                           return cont(weighted_high);
		                          });
		                }
		                return f;
		               }
		               var small_positive_or_zero_int = small_int();
		               function For_integer(Integer, cont){
		                function uniform_inclusive(lo, hi){
		                 function f(param, random, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (Integer[100], random, lo, hi, cont);
		                 }
		                 return f;
		                }
		                function log_uniform_inclusive(lo, hi){
		                 function f(param, random, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (Integer[101], random, lo, hi, cont);
		                 }
		                 return f;
		                }
		                function non_uniform(f, lo, hi, cont){
		                 var a = [0, [0, 0.9, f(lo, hi)], 0];
		                 return caml_trampoline_cps_call2
		                         (For_monad[11][1],
		                          hi,
		                          function(c){
		                           var b = [0, [0, 0.05, c], a];
		                           return caml_trampoline_cps_call2
		                                   (For_monad[11][1],
		                                    lo,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (weighted_union, [0, [0, 0.05, a], b], cont);
		                                    });
		                          });
		                }
		                function inclusive(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (non_uniform, uniform_inclusive, a, b, cont);
		                }
		                function log_inclusive(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (non_uniform, log_uniform_inclusive, a, b, cont);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (non_uniform,
		                         log_uniform_inclusive,
		                         Integer[42],
		                         Integer[88],
		                         function(let_syntax_004){
		                          function a(param, cont){
		                           var magnitude = param[2], negative = param[1];
		                           return negative
		                                   ? cont(Integer[74].call(null, magnitude))
		                                   : cont(magnitude);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (For_monad[11][4][4],
		                                   quickcheck_generator_bool,
		                                   let_syntax_004,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (For_monad[11][4][3],
		     b,
		     a,
		     function(all){
		      return cont
		              ([0,
		                ,
		                uniform_inclusive,
		                log_uniform_inclusive,
		                ,
		                inclusive,
		                log_inclusive,
		                ,
		                all]);
		     });
		                                   });
		                         });
		               }
		               var
		                For_int$0 =
		                  caml_callback
		                   (For_integer,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      min_value$3,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      bit_not$2,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      max_value,
		                      min_value$0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      uniform$0,
		                      log_uniform]]),
		                int_inclusive = For_int$0[5],
		                int_uniform_inclusive = For_int$0[2],
		                int_log_uniform_inclusive = For_int$0[3];
		               caml_callback
		                (For_integer,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   min_value$1,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bit_not,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   2147483647,
		                   -2147483648,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   uniform$1,
		                   log_uniform$0]]);
		               var
		                For_int63$0 =
		                  caml_callback
		                   (For_integer,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      min_interval_num,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      bit_not$4,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      max_value_representable,
		                      min_value_representable,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      uniform$2,
		                      log_uniform$1]]),
		                quickcheck_generator = For_int63$0[8],
		                int63_inclusive = For_int63$0[5];
		               caml_callback
		                (For_integer,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   min_value,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bit_not$0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   draw_maximum,
		                   min_int64,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   uniform,
		                   log_uniform$2]]);
		               caml_callback
		                (For_integer,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   zero,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bit_not$1,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   2147483647,
		                   -2147483648,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   nativeint,
		                   log_uniform$3]]);
		               var
		                float_zero_exponent = ieee_exponent(0.),
		                float_zero_mantissa = ieee_mantissa(0.),
		                min_positive_normal_value = 2.2250738585072014e-308,
		                float_max_positive_subnormal_v =
		                  one_ulp(759637122, min_positive_normal_value),
		                min_positive_subnormal_value = 5e-324,
		                float_subnormal_exponent =
		                  ieee_exponent(min_positive_subnormal_value),
		                float_min_subnormal_mantissa =
		                  ieee_mantissa(min_positive_subnormal_value),
		                float_max_subnormal_mantissa =
		                  ieee_mantissa(float_max_positive_subnormal_v),
		                float_min_normal_exponent =
		                  ieee_exponent(min_positive_normal_value),
		                float_max_positive_normal_valu = 1.7976931348623157e308,
		                float_max_normal_exponent =
		                  ieee_exponent(float_max_positive_normal_valu),
		                float_max_normal_mantissa =
		                  ieee_mantissa(float_max_positive_normal_valu),
		                max_value$0 = Infinity,
		                float_inf_exponent = ieee_exponent(max_value$0),
		                float_inf_mantissa = ieee_mantissa(max_value$0),
		                float_nan_exponent = ieee_exponent(none),
		                float_min_nan_mantissa = succ$0(float_inf_mantissa),
		                d = For_int$0[2].call(null, 0, 52),
		                float_normal_mantissa =
		                  caml_callback
		                   (For_monad[11][4][2],
		                    [d,
		                     function(num_bits, cont){
		                      var b = pred$4(shift_left$4(min_scale, num_bits));
		                      function a(bits, cont){
		                       return cont(shift_left$4(bits, 52 - num_bits | 0));
		                      }
		                      return caml_exact_trampoline_cps_call$1
		                              (For_int63$0[5],
		                               min_interval_num,
		                               b,
		                               function(b){
		                                return caml_trampoline_cps_call3
		(For_monad[11][4][3], b, a, cont);
		                               });
		                     }]),
		                lower_bound = ieee_exponent(1.),
		                d =
		                  caml_callback
		                   (For_int$0[6],
		                    [0, float_max_normal_exponent - lower_bound | 0]),
		                d =
		                  [0,
		                   caml_callback
		                    (For_monad[11][4][3],
		                     [d,
		                      function(offset, cont){
		                       return cont(lower_bound + offset | 0);
		                      }]),
		                   0],
		                b1 =
		                  caml_callback
		                   (For_int$0[6],
		                    [0, lower_bound - float_min_normal_exponent | 0]),
		                float_exponent =
		                  caml_callback
		                   (union$5,
		                    [[0,
		                      caml_callback
		                       (For_monad[11][4][3],
		                        [b1,
		                         function(offset, cont){
		                          return cont(lower_bound - offset | 0);
		                         }]),
		                      d]]),
		                float_zero =
		                  caml_callback
		                   (For_monad[11][4][3],
		                    [quickcheck_generator_bool,
		                     function(negative, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (create_ieee_exn,
		                               negative,
		                               float_zero_exponent,
		                               float_zero_mantissa,
		                               cont);
		                     }]),
		                let_syntax_012 =
		                  caml_callback(For_monad[11][1], [float_subnormal_exponent]),
		                let_syntax_013 =
		                  caml_callback
		                   (For_int63$0[6],
		                    [float_min_subnormal_mantissa, float_max_subnormal_mantissa]),
		                d =
		                  caml_callback
		                   (For_monad[11][4][4], [let_syntax_012, let_syntax_013]),
		                d =
		                  caml_callback
		                   (For_monad[11][4][4], [quickcheck_generator_bool, d]),
		                float_subnormal =
		                  caml_callback
		                   (For_monad[11][4][3],
		                    [d,
		                     function(param, cont){
		                      var
		                       match = param[2],
		                       mantissa = match[2],
		                       exponent = match[1],
		                       negative = param[1];
		                      return caml_exact_trampoline_cps_call$0
		                              (create_ieee_exn, negative, exponent, mantissa, cont);
		                     }]),
		                d =
		                  caml_callback
		                   (For_monad[11][4][4],
		                    [float_exponent, float_normal_mantissa]),
		                d =
		                  caml_callback
		                   (For_monad[11][4][4], [quickcheck_generator_bool, d]),
		                float_normal =
		                  caml_callback
		                   (For_monad[11][4][3],
		                    [d,
		                     function(param, cont){
		                      var
		                       match = param[2],
		                       mantissa = match[2],
		                       exponent = match[1],
		                       negative = param[1];
		                      return caml_exact_trampoline_cps_call$0
		                              (create_ieee_exn, negative, exponent, mantissa, cont);
		                     }]),
		                float_infinite =
		                  caml_callback
		                   (For_monad[11][4][3],
		                    [quickcheck_generator_bool,
		                     function(negative, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (create_ieee_exn,
		                               negative,
		                               float_inf_exponent,
		                               float_inf_mantissa,
		                               cont);
		                     }]),
		                let_syntax_021 =
		                  caml_callback(For_monad[11][1], [float_nan_exponent]),
		                let_syntax_022 =
		                  caml_callback
		                   (For_int63$0[5],
		                    [float_min_nan_mantissa, float_max_normal_mantissa]),
		                d =
		                  caml_callback
		                   (For_monad[11][4][4], [let_syntax_021, let_syntax_022]),
		                d =
		                  caml_callback
		                   (For_monad[11][4][4], [quickcheck_generator_bool, d]),
		                float_nan =
		                  caml_callback
		                   (For_monad[11][4][3],
		                    [d,
		                     function(param, cont){
		                      var
		                       match = param[2],
		                       mantissa = match[2],
		                       exponent = match[1],
		                       negative = param[1];
		                      return caml_exact_trampoline_cps_call$0
		                              (create_ieee_exn, negative, exponent, mantissa, cont);
		                     }]);
		               function float_of_class(c){
		                switch(c){
		                  case 0:
		                   return float_infinite;
		                  case 1:
		                   return float_nan;
		                  case 2:
		                   return float_normal;
		                  case 3:
		                   return float_subnormal;
		                  default: return float_zero;
		                }
		               }
		               function float_matching_classes(filter, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         all$0,
		                         function(c, cont){
		                          if(! filter(c)) return cont(0);
		                          var b = float_of_class(c);
		                          switch(c){
		                            case 2:
		                             var a = 100.; break;
		                            case 3:
		                             a = 10.; break;
		                            default: a = 1.;
		                          }
		                          return cont([0, [0, a, b]]);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (weighted_union, a, cont);
		                         });
		               }
		               var
		                quickcheck_generator$0 =
		                  caml_callback
		                   (float_matching_classes,
		                    [function(param){return 2 <= param ? 1 : 0;}]);
		               caml_callback
		                (float_matching_classes,
		                 [function(param){return 1 === param ? 0 : 1;}]);
		               var
		                quickcheck_generator_float =
		                  caml_callback
		                   (float_matching_classes, [function(param){return 1;}]),
		                float_finite_non_zero =
		                  caml_callback
		                   (float_matching_classes,
		                    [function(param){return 1 < param - 2 >>> 0 ? 0 : 1;}]);
		               caml_callback
		                (For_monad[11][4][3],
		                 [float_finite_non_zero,
		                  function(t, cont){return cont(Math.abs(t));}]);
		               caml_callback
		                (For_monad[11][4][3],
		                 [float_finite_non_zero,
		                  function(t, cont){return cont(- Math.abs(t));}]);
		               caml_callback
		                (For_monad[11][4][3],
		                 [quickcheck_generator$0,
		                  function(t, cont){return cont(Math.abs(t));}]);
		               caml_callback
		                (For_monad[11][4][3],
		                 [quickcheck_generator$0,
		                  function(t, cont){return cont(- Math.abs(t));}]);
		               function float_uniform_exclusive
		               (lower_bound, upper_bound, cont){
		                var
		                 a = 1 - is_finite(lower_bound),
		                 a = a || 1 - is_finite(upper_bound);
		                function b(b){
		                 var
		                  lower_inclusive = one_ulp(19067, lower_bound),
		                  upper_inclusive = one_ulp(759637122, upper_bound);
		                 function a(a){
		                  function f(param, random, cont){
		                   return caml_exact_trampoline_cps_call$0
		                           (float$0, random, lower_inclusive, upper_inclusive, cont);
		                  }
		                  return cont(f);
		                 }
		                 if(! (upper_inclusive < lower_inclusive)) return a();
		                 return caml_exact_trampoline_cps_call
		                         (sexp_of_float,
		                          upper_bound,
		                          function(sexp){
		                           var b = [0, [1, [0, aDX, [0, sexp, 0]]], 0];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_float,
		                                    lower_bound,
		                                    function(sexp){
		                                     return caml_exact_trampoline_cps_call
		     (raise_s,
		      [1,
		       [0,
		        [0, "Float.uniform_exclusive: requested range is empty"],
		        [0, [1, [0, aDY, [0, sexp, 0]]], b]]],
		      a);
		                                    });
		                          });
		                }
		                if(! a) return b();
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_float,
		                         upper_bound,
		                         function(sexp){
		                          var a = [0, [1, [0, aDV, [0, sexp, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_float,
		                                   lower_bound,
		                                   function(sexp){
		                                    return caml_exact_trampoline_cps_call
		    (raise_s,
		     [1,
		      [0,
		       [0, "Float.uniform_exclusive: bounds are not finite"],
		       [0, [1, [0, aDW, [0, sexp, 0]]], a]]],
		     b);
		                                   });
		                         });
		               }
		               function float_inclusive(lower_bound, upper_bound, cont){
		                if(lower_bound === upper_bound)
		                 return caml_trampoline_cps_call2
		                         (For_monad[11][1], lower_bound, cont);
		                if(one_ulp(19067, lower_bound) === upper_bound)
		                 return caml_trampoline_cps_call2
		                         (For_monad[11][1],
		                          upper_bound,
		                          function(b){
		                           var a = [0, b, 0];
		                           return caml_trampoline_cps_call2
		                                   (For_monad[11][1],
		                                    lower_bound,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (union$5, [0, b, a], cont);
		                                    });
		                          });
		                return caml_exact_trampoline_cps_call$1
		                        (float_uniform_exclusive,
		                         lower_bound,
		                         upper_bound,
		                         function(b){
		                          var a = [0, [0, 0.9, b], 0];
		                          return caml_trampoline_cps_call2
		                                  (For_monad[11][1],
		                                   upper_bound,
		                                   function(c){
		                                    var b = [0, [0, 0.05, c], a];
		                                    return caml_trampoline_cps_call2
		    (For_monad[11][1],
		     lower_bound,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (weighted_union, [0, [0, 0.05, a], b], cont);
		     });
		                                   });
		                         });
		               }
		               function string_with_length_of(char_gen, length, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (list_with_length,
		                         char_gen,
		                         length,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$37, a, of_char_list, cont);
		                         });
		               }
		               function string_of(char_gen, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (bind$22,
		                         small_positive_or_zero_int,
		                         function(length, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (string_with_length_of, char_gen, length, cont);
		                         },
		                         cont);
		               }
		               var
		                quickcheck_generator_string =
		                  caml_callback(string_of, [quickcheck_generator_char]);
		               function sexp_of(atom, cont){
		                return caml_exact_trampoline_cps_call
		                        (fixed_point,
		                         function(self, cont){
		                          return caml_trampoline_cps_call3
		                                  (For_monad[11][4][2],
		                                   size,
		                                   function(size, cont){
		                                    var a = For_int$0[3].call(null, 0, size + 1 | 0);
		                                    return caml_trampoline_cps_call3
		    (For_monad[11][4][2],
		     a,
		     function(param, cont){
		      if(0 === param)
		       return caml_trampoline_cps_call3
		               (For_monad[11][4][3],
		                atom,
		                function(atom, cont){return cont([0, atom]);},
		                cont);
		      function a(list, cont){return cont([1, list]);}
		      return caml_exact_trampoline_cps_call
		              (quickcheck_generator_list,
		               self,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (For_monad[11][4][3], b, a, cont);
		               });
		     },
		     cont);
		                                   },
		                                   cont);
		                         },
		                         cont);
		               }
		               caml_callback(sexp_of, [quickcheck_generator_string]);
		               function bigarray1(t, kind, layout, length, cont){
		                function b(elts, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_array,
		                          elts,
		                          function(elts){
		                           var
		                            dim = elts.length - 1,
		                            offset$1 = offset$0(layout),
		                            t = create$2(kind, layout, dim),
		                            offset = offset$0(caml_ba_layout(t)),
		                            b = caml_ba_dim_1(t) - 1 | 0;
		                           if(b >= 0){
		                            var i = 0;
		                            for(;;){
		                             caml_ba_get_1(t, i + offset | 0);
		                             var i$0 = i + offset | 0, a = i$0 - offset$1 | 0;
		                             caml_ba_set_1(t, i$0, caml_check_bound(elts, a)[a + 1]);
		                             a = i + 1 | 0;
		                             if(b === i) break;
		                             i = a;
		                            }
		                           }
		                           return cont(t);
		                          });
		                }
		                function a(a){
		                 return caml_trampoline_cps_call3
		                         (For_monad[11][4][3], a, b, cont);
		                }
		                if(! length)
		                 return caml_exact_trampoline_cps_call
		                         (quickcheck_generator_list, t, a);
		                var length$0 = length[1];
		                return caml_exact_trampoline_cps_call$1
		                        (list_with_length, t, length$0, a);
		               }
		               caml_callback(bigarray1, [quickcheck_generator_char, 12, 0, 0]);
		               caml_callback(bigarray1, [quickcheck_generator_float, 0, 1, 0]);
		               caml_callback(bigarray1, [quickcheck_generator_float, 1, 1, 0]);
		               var
		                bigarray2_dim =
		                  caml_callback
		                   (For_monad[11][4][2],
		                    [size,
		                     function(max_total_size, cont){
		                      if(0 === max_total_size)
		                       return caml_trampoline_cps_call2
		                               (For_monad[11][1], aDZ, cont);
		                      var a = int_log_uniform_inclusive(1, max_total_size);
		                      return caml_trampoline_cps_call3
		                              (For_monad[11][4][2],
		                               a,
		                               function(a, cont){
		                                var
		                                 max_b = caml_div(max_total_size, a),
		                                 c = int_log_uniform_inclusive(0, max_b);
		                                function b(b, cont){
		                                 return caml_trampoline_cps_call3
		 (For_monad[11][4][3],
		  quickcheck_generator_bool,
		  function(param, cont){
		   return param ? cont([0, a, b]) : cont([0, b, a]);
		  },
		  cont);
		                                }
		                                return caml_trampoline_cps_call3
		(For_monad[11][4][3],
		 c,
		 function(b_weighted_low, cont){
		  return cont(max_b - b_weighted_low | 0);
		 },
		 function(a){
		  return caml_trampoline_cps_call3
		          (For_monad[11][4][2], a, b, cont);
		 });
		                               },
		                               cont);
		                     }]);
		               function bigarray2(t, kind, layout, cont){
		                return caml_trampoline_cps_call3
		                        (For_monad[11][4][2],
		                         bigarray2_dim,
		                         function(param, cont){
		                          var dim2 = param[2], dim1 = param[1];
		                          function a(elts, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_list_map,
		                                    elts,
		                                    to_array,
		                                    function(elts){
		                                     var
		                                      offset$1 = offset$0(layout),
		                                      t = create$3(kind, layout, dim1, dim2),
		                                      offset = offset$0(caml_ba_layout(t)),
		                                      c = caml_ba_dim_1(t) - 1 | 0;
		                                     if(c >= 0){
		                                      var i = 0;
		                                      for(;;){
		                                       var a = caml_ba_dim_2(t) - 1 | 0;
		                                       if(a >= 0){
		var j = 0;
		for(;;){
		 caml_ba_get_2(t, i + offset | 0, j + offset | 0);
		 var
		  j$0 = j + offset | 0,
		  i$0 = i + offset | 0,
		  b = j$0 - offset$1 | 0,
		  d = i$0 - offset$1 | 0;
		 caml_ba_set_2
		  (t,
		   i$0,
		   j$0,
		   caml_check_bound(caml_check_bound(elts, d)[d + 1], b)[b + 1]);
		 b = j + 1 | 0;
		 if(a === j) break;
		 j = b;
		}
		                                       }
		                                       a = i + 1 | 0;
		                                       if(c === i) break;
		                                       i = a;
		                                      }
		                                     }
		                                     return cont(t);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (list_with_length,
		                                   t,
		                                   dim2,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (list_with_length,
		     b,
		     dim1,
		     function(b){
		      return caml_trampoline_cps_call3
		              (For_monad[11][4][3], b, a, cont);
		     });
		                                   });
		                         },
		                         cont);
		               }
		               caml_callback(bigarray2, [quickcheck_generator_float, 0, 1]);
		               caml_callback(bigarray2, [quickcheck_generator_float, 1, 1]);
		               function quickcheck_shrinker_nativeint(param){return empty$6;}
		               function of_lazy$1(lazy_t){
		                return function(x){
		                 return of_lazy
		                         ([246,
		                           function(a, cont){
		                            a = caml_obj_tag(lazy_t);
		                            function b(a){return caml_trampoline_cps_call2(a, x, cont);}
		                            if(250 === a) return b(lazy_t[1]);
		                            if(246 !== a && 244 !== a) return b(lazy_t);
		                            return caml_exact_trampoline_cps_call
		                                    (force_lazy_block, lazy_t, b);
		                           }]);};
		               }
		               function fixed_point$0(of_shrinker){
		                var lazy_t = [];
		                caml_update_dummy
		                 (lazy_t,
		                  [246,
		                   function(param, cont){
		                    return cont(of_shrinker(of_lazy$1(lazy_t)));
		                   }]);
		                return of_lazy$1(lazy_t);
		               }
		               function quickcheck_shrinker_list(elt_t){
		                return fixed_point$0
		                        (function(list_t){
		                          return function(param, cont){
		                           if(! param) return cont(empty$6);
		                           var tail = param[2], head = param[1];
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    list_t(tail),
		                                    function(tail, cont){return cont([0, head, tail]);},
		                                    function(b){
		                                     var a = [0, b, 0];
		                                     return caml_trampoline_cps_call3
		     (map$11,
		      elt_t(head),
		      function(head, cont){return cont([0, head, tail]);},
		      function(c){
		       var b = [0, c, a];
		       return caml_trampoline_cps_call2
		               (return$6,
		                tail,
		                function(a){return cont(round_robin([0, a, b]));});
		      });
		                                    });};
		                         });
		               }
		               quickcheck_shrinker_list(quickcheck_shrinker_nativeint);
		               fixed_point$0
		                (function(shrinker){
		                  return function(param, cont){
		                   if(0 === param[0]) return cont(empty$6);
		                   var l = param[1];
		                   return caml_trampoline_cps_call3
		                           (map$11,
		                            quickcheck_shrinker_list(shrinker)(l),
		                            function(l, cont){return cont([1, l]);},
		                            function(shrink_list){
		                             return caml_exact_trampoline_cps_call
		                                     (deconstruct,
		                                      l,
		                                      function(shrink_tree){
		                                       return cont
		       (round_robin([0, shrink_list, [0, shrink_tree, 0]]));
		                                      });
		                            });};
		                 });
		               caml_callback
		                (cycle_list_exn, [caml_callback(range, [0, aD1, aD0, 0, 30])]);
		               d = "Balanced_reducer";
		               record_start(d);
		               set$7("balanced_reducer");
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Int_repr";
		               record_start(d);
		               set$7("int_repr");
		               caml_callback(int_inclusive, [-128, 127]);
		               caml_callback(int_inclusive, [min_value$3, 255]);
		               caml_callback(int_inclusive, [-32768, 32767]);
		               caml_callback(int_inclusive, [min_value$3, 65535]);
		               caml_callback(int_inclusive, [-2147483648, 2147483647]);
		               caml_callback(int_inclusive, [min_value$3, -1]);
		               of_int64_trunc$0(aD2);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Base_bigstring";
		               record_start(d);
		               set$7("base_bigstring");
		               unset();
		               caml_callback(record_until, [d]);
		               function bQs(Elt, Sequence){
		                var
		                 equal = Elt[1],
		                 of_bool = Elt[2],
		                 elt1 = of_bool(1),
		                 elt2 = of_bool(0);
		                if(equal(elt1, elt2))
		                 throw caml_maybe_attach_backtrace
		                        ([0, Assert_failure, aD3], 1);
		               }
		               var d = "Filename_base";
		               record_start(d);
		               set$7("filename_base");
		               caml_callback(get$0, [current_temp_dir_name]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Univ_map__Univ_map_intf";
		               record_start(d);
		               b1 = "univ_map";
		               set$7(b1);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Univ_map";
		               record_start(d);
		               set$7(b1);
		               function type_id$0(a){return a;}
		               function sexp_of_type_id(type_id, cont){
		                function a(t){
		                 var str = type_id[3];
		                 return cont
		                         ([1,
		                           [0,
		                            [1, [0, aD6, [0, [0, str], 0]]],
		                            [0, [1, [0, aD5, [0, t, 0]]], 0]]]);
		                }
		                return am_running
		                        ? a(aD4)
		                        : caml_exact_trampoline_cps_call(sexp_of_t$8, type_id[2], a);
		               }
		               function type_id(x_003, cont){
		                var type_id1 = type_id$0(x_003), type_id2 = type_id$0(x_003);
		                return caml_exact_trampoline_cps_call$1
		                        (same_witness,
		                         type_id1,
		                         type_id2,
		                         function(a){
		                          a = a ? 1 : 0;
		                          if(a) return cont(type_id1);
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_type_id,
		                                   type_id2,
		                                   function(b){
		                                    var a = [0, [1, [0, aD7, [0, b, 0]]], 0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_type_id,
		     type_id1,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (raise_s,
		               [1,
		                [0,
		                 [0,
		                  "[Key.type_id] must not provide different type ids when called on the same input"],
		                 [0,
		                  [1, [0, aD9, [0, sexp_of_t$9(dummy, x_003), 0]]],
		                  [0, [1, [0, aD8, [0, b, 0]]], a]]]],
		               cont);
		     });
		                                   });
		                         });
		               }
		               function name_of_key(key, cont){
		                return caml_exact_trampoline_cps_call
		                        (type_id, key, function(A){return cont(A[3]);});
		               }
		               function uid_of_key(key, cont){
		                return caml_exact_trampoline_cps_call
		                        (type_id, key, function(A){return cont(A[2]);});
		               }
		               function find$5(t, key, cont){
		                return caml_exact_trampoline_cps_call
		                        (uid_of_key,
		                         key,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   t,
		                                   a,
		                                   function(a){
		                                    if(! a) return cont(0);
		                                    a = a[1];
		                                    var value = a[2], key$0 = a[1];
		                                    return caml_exact_trampoline_cps_call
		    (type_id,
		     key$0,
		     function(t2){
		      return caml_exact_trampoline_cps_call
		              (type_id,
		               key,
		               function(t1){
		                return caml_exact_trampoline_cps_call$1
		                        (same_witness,
		                         t1,
		                         t2,
		                         function(match){
		                          function a(a){return cont([0, value]);}
		                          return match
		                                  ? a()
		                                  : caml_exact_trampoline_cps_call
		                                    (raise_s,
		                                     message
		                                      ("Type_equal.Id.same_witness_exn got different ids",
		                                       [0, [0, cst$1, [1, [0, t1[4], [0, t2[4], 0]]]], 0]),
		                                     a);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function find_exn$0(t, key, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find$5,
		                         t,
		                         key,
		                         function(match){
		                          if(match){var data = match[1]; return cont(data);}
		                          return caml_exact_trampoline_cps_call
		                                  (name_of_key,
		                                   key,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (failwithf,
		     aD_,
		     function(b){
		      return caml_trampoline_cps_call3(b, a, 0, cont);
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Command__Import";
		               record_start(d);
		               var cst_command = "command";
		               set$7(cst_command);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Command__Env_var";
		               record_start(d);
		               set$7(cst_command);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Command__Shape";
		               record_start(d);
		               set$7(cst_command);
		               caml_callback
		                (create$25,
		                 ["command/src/shape.ml:125:4",
		                  [0, [0, cst_a$0, 0, [3, v0]], 0]]);
		               function loop$1(acc$1, enumerate_478$0, enumerate_479$0){
		                var
		                 acc = acc$1,
		                 enumerate_478 = enumerate_478$0,
		                 enumerate_479 = enumerate_479$0;
		                for(;;){
		                 if(! enumerate_479) return rev(acc);
		                 if(enumerate_478){
		                  var
		                   enumerate_477 = enumerate_479[1],
		                   enumerate_480 = enumerate_478[2],
		                   enumerate_476 = enumerate_478[1],
		                   acc$0 = [0, [0, enumerate_476, enumerate_477], acc];
		                  acc = acc$0;
		                  enumerate_478 = enumerate_480;
		                 }
		                 else {
		                  var enumerate_480$0 = enumerate_479[2];
		                  enumerate_478 = enumerate_474;
		                  enumerate_479 = enumerate_480$0;
		                 }
		                }
		               }
		               loop$1(0, enumerate_474, enumerate_475);
		               make$0(29, 32);
		               caml_callback(to_string_mach, [aD$]);
		               var
		                supported = empty$8([0, comparator$4]),
		                supported$1 = caml_callback(add$4, [supported, 1]),
		                supported$0 = caml_callback(add$4, [supported$1, 2]);
		               caml_callback(add$4, [supported$0, 3]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Command__Command_intf";
		               record_start(d);
		               set$7(cst_command);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Command";
		               record_start(d);
		               set$7(cst_command);
		               var
		                Exit_called =
		                  [248, "Command.Exit_called", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Exit_called,
		                  function(a, cont){
		                   if(a[1] === Exit_called){
		                    var status_002 = a[2];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_int$0,
		                             status_002,
		                             function(arg_003){
		                              var bnds_001 = [0, [1, [0, aEa, [0, arg_003, 0]]], 0];
		                              return cont([1, [0, aEb, bnds_001]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aEc], 1));
		                  }]);
		               caml_callback
		                (create$13, ["----internal-validate-parsing", sexp_of_unit$0]);
		               function return_no_arg(v, cont){return cont([0, [0, v], 0]);}
		               function create$29(complete, key, of_string, cont){
		                return caml_exact_trampoline_cps_call
		                        (from_val, 0, function(extra_doc){return cont();});
		               }
		               caml_callback(create$29, [dummy, dummy, dummy]);
		               caml_callback(create$29, [dummy, dummy, of_string$3]);
		               caml_callback(create$29, [dummy, dummy, dummy]);
		               caml_callback(create$29, [dummy, dummy, of_string$6]);
		               caml_callback(create$29, [dummy, dummy, dummy]);
		               var
		                alist =
		                  caml_callback
		                   (map$7,
		                    [all,
		                     function(t, cont){
		                      return caml_exact_trampoline_cps_call
		                              (string_of_bool, t, function(a){return cont([0, a, t]);});
		                     }]);
		               function make$61(cmp, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_alist$1,
		                         [0, cmp[1]],
		                         alist,
		                         function(match){
		                          var variant = match[1];
		                          function a(a){return cont();}
		                          if(17724 <= variant) return a();
		                          function b(param, cont){
		                           if(param && param[2]) return cont(1);
		                           return cont(0);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   alist,
		                                   function(param, cont){
		                                    var k = param[1];
		                                    return cont([0, k, k]);
		                                   },
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_alist_multi$1,
		     [0, cmp[1]],
		     c,
		     function(c){
		      return caml_exact_trampoline_cps_call$1
		              (filter$5,
		               c,
		               b,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (encode,
		                         b,
		                         function(duplicate_keys){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_list,
		                                   function(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_list, sexp_of_string, a, cont);
		                                   },
		                                   duplicate_keys,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (raise_s,
		     [1,
		      [0,
		       [0, "Command.Spec.Arg_type.of_alist_exn"],
		       [0, [1, [0, aEd, [0, b, 0]]], 0]]],
		     a);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback(make$61, [[0, comparator$2]]);
		               function loop$2(acc$1, enumerate_012$0, enumerate_013$0){
		                var
		                 acc = acc$1,
		                 enumerate_012 = enumerate_012$0,
		                 enumerate_013 = enumerate_013$0;
		                for(;;){
		                 if(! enumerate_013) return rev(acc);
		                 if(enumerate_012){
		                  var
		                   enumerate_011 = enumerate_013[1],
		                   enumerate_014 = enumerate_012[2],
		                   enumerate_010 = enumerate_012[1],
		                   acc$0 = [0, [0, enumerate_010, enumerate_011], acc];
		                  acc = acc$0;
		                  enumerate_012 = enumerate_014;
		                 }
		                 else {
		                  var enumerate_014$0 = enumerate_013[2];
		                  enumerate_012 = enumerate_008;
		                  enumerate_013 = enumerate_014$0;
		                 }
		                }
		               }
		               loop$2(0, enumerate_008, enumerate_009);
		               function parts_exe_basename(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys,
		                         t,
		                         function(match){
		                          if(! match) return cont(0);
		                          var tl = match[2], hd = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (basename$2, hd, function(a){return cont([0, a, tl]);});
		                         });
		               }
		               function parse_more(param, f){
		                var complete = param[3], parse = param[2], name = param[1];
		                function parse$0(arg, for_completion, cont){
		                 return caml_trampoline_cps_call3
		                         (parse,
		                          arg,
		                          for_completion,
		                          function(match){
		                           var update_env = match[2], parser = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (f, parser, function(a){return cont([0, a, update_env]);});
		                          });
		                }
		                return [1, [0, name, parse$0, complete]];
		               }
		               function pack_for_completion(x){
		                switch(x[0]){
		                  case 0:
		                   return 0;
		                  case 3:
		                   var ps = x[1]; return ps;
		                  default: return [0, [0, x], 0];
		                }
		               }
		               function symbol$212(t_left, t_right, cont){
		                a:
		                {
		                 switch(t_left[0]){
		                   case 0:
		                    var f = t_left[1];
		                    switch(t_right[0]){
		                      case 0:
		                       var x = t_right[1];
		                       return cont
		                               ([0,
		                                 function(env, cont){
		                                  return caml_trampoline_cps_call2
		  (f,
		   env,
		   function(f_outcome){
		    return caml_trampoline_cps_call2
		            (x,
		             env,
		             function(x_outcome){
		              return caml_trampoline_cps_call2(f_outcome, x_outcome, cont);
		             });
		   });
		                                 }]);
		                      case 1:
		                       var more = t_right[1];
		                       return cont
		                               (parse_more
		                                 (more,
		                                  function(tr, cont){
		                                   return caml_exact_trampoline_cps_call$1
		   (symbol$212, t_left, tr, cont);
		                                  }));
		                      case 2:
		                       var test = t_right[1];
		                       return cont
		                               ([2,
		                                 function(more, cont){
		                                  return caml_trampoline_cps_call2
		  (test,
		   more,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (symbol$212, t_left, a, cont);
		   });
		                                 }]);
		                      case 4:
		                       var tr = t_right[1], tl = t_left; break a;
		                    }
		                    break;
		                   case 1:
		                    var more$0 = t_left[1];
		                    return cont
		                            (parse_more
		                              (more$0,
		                               function(tl, cont){
		                                return caml_exact_trampoline_cps_call$1
		(symbol$212, tl, t_right, cont);
		                               }));
		                   case 2:
		                    var test$0 = t_left[1];
		                    return cont
		                            ([2,
		                              function(more, cont){
		                               return caml_trampoline_cps_call2
		                                       (test$0,
		more,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (symbol$212, a, t_right, cont);
		});
		                              }]);
		                   case 4:
		                    tr = t_right; tl = t_left[1]; break a;
		                 }
		                 var a = pack_for_completion(t_right);
		                 return caml_exact_trampoline_cps_call$1
		                         (append$0,
		                          pack_for_completion(t_left),
		                          a,
		                          function(a){return cont([3, a]);});
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$212, tl, tr, function(a){return cont([4, a]);});
		               }
		               function return$24(a){
		                return [0, function(param, cont){return cont(a);}];
		               }
		               function symbol_map$14(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$212, return$24(f), t, cont);
		               }
		               var
		                path_key =
		                  caml_callback(create$13, [cst_path, sexp_of_opaque]);
		               caml_callback(create$13, [cst_args, sexp_of_opaque]);
		               caml_callback(create$13, [cst_help$1, sexp_of_opaque]);
		               function wrap_value(v, param, cont){
		                return caml_exact_trampoline_cps_call(return_no_arg, v, cont);
		               }
		               function apply$1(f, x){}
		               function map$38(x, f, cont){return cont();}
		               var
		                zero$2 = 0,
		                path$1 =
		                  [0,
		                   function(param, cont){
		                    function f(env, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_exn$0, env, path_key, cont);
		                    }
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol_map$14,
		                             [0,
		                              function(env, cont){
		                               return caml_exact_trampoline_cps_call(f, env, cont);
		                              }],
		                             wrap_value,
		                             cont);
		                   },
		                   function(param, cont){return cont(zero$2);},
		                   function(param, cont){return cont(0);}];
		               function return$25(v, cont){
		                return cont
		                        ([0,
		                          function(param, cont){
		                           return cont
		                                   (return$24
		                                     (function(param, cont){
		                                       return caml_exact_trampoline_cps_call
		       (return_no_arg, v, cont);
		                                      }));
		                          },
		                          function(param, cont){return cont(zero$2);}]);
		               }
		               var
		                include$118 = Make$0([0, return$25, apply$1, [0, , map$38]]),
		                return$26 = include$118[1],
		                map$39 = include$118[2],
		                apply$2 = include$118[8],
		                include$119 = Make$0([0, return$26, apply$2, [0, , map$39]]),
		                map$40 = include$119[2];
		               caml_callback(create$13, ["subcommands", sexp_of_opaque]);
		               caml_callback(map$40, [path$1, parts_exe_basename]);
		               caml_callback(map$39, [path$1, parts_exe_basename]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Heap_block";
		               record_start(d);
		               set$7("heap_block");
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Diffable__Optional_diff";
		               record_start(d);
		               b1 = "diffable";
		               set$7(b1);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Diffable__Set_diff";
		               record_start(d);
		               set$7(b1);
		               b5 =
		                [0,
		                 [0,
		                  cst_Remove,
		                  [0, var$("lib/src/set_diff.ml:9:20", cst_a$0), 0]],
		                 0];
		               var
		                cst_Add = "Add",
		                v0$4 =
		                  [0,
		                   [0,
		                    cst_Add,
		                    [0, var$("lib/src/set_diff.ml:8:17", cst_a$0), 0]],
		                   b5],
		                group =
		                  caml_callback
		                   (create$25,
		                    ["lib/src/set_diff.ml:7:6",
		                     [0, [0, cst_t, [0, cst_a$0, 0], [3, v0$4]], 0]]),
		                a = var$("lib/src/set_diff.ml:13:16", cst_a$0),
		                group$0 =
		                  caml_callback
		                   (create$25,
		                    ["lib/src/set_diff.ml:13:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, 0],
		                       bin_shape_list([8, group, cst_t, [0, a, 0]])],
		                      0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Diffable__Map_diff";
		               record_start(d);
		               set$7(b1);
		               b5 = "v_diff";
		               bU = [0, var$("lib/src/map_diff.ml:11:23", b5), 0];
		               var
		                cst_k = "k",
		                bU =
		                  [0,
		                   [0,
		                    "Diff",
		                    [0, var$("lib/src/map_diff.ml:11:18", cst_k), bU]],
		                   0],
		                b_ = [0, var$("lib/src/map_diff.ml:10:22", cst_v), 0],
		                b_ =
		                  [0,
		                   [0,
		                    cst_Add,
		                    [0, var$("lib/src/map_diff.ml:10:17", cst_k), b_]],
		                   bU],
		                v0$5 =
		                  [0,
		                   [0,
		                    cst_Remove,
		                    [0, var$("lib/src/map_diff.ml:9:20", cst_k), 0]],
		                   b_],
		                group$1 =
		                  caml_callback
		                   (create$25,
		                    ["lib/src/map_diff.ml:8:6",
		                     [0,
		                      [0, cst_t, [0, cst_k, [0, cst_v, [0, b5, 0]]], [3, v0$5]],
		                      0]]),
		                v_diff = var$("lib/src/map_diff.ml:15:40", b5),
		                v$5 = var$("lib/src/map_diff.ml:15:36", cst_v),
		                k$0 = var$("lib/src/map_diff.ml:15:32", cst_k),
		                group$2 =
		                  caml_callback
		                   (create$25,
		                    ["lib/src/map_diff.ml:15:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_k, [0, cst_v, [0, b5, 0]]],
		                       bin_shape_list
		                        ([8, group$1, cst_t, [0, k$0, [0, v$5, [0, v_diff, 0]]]])],
		                      0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Diffable__Atomic";
		               record_start(d);
		               set$7(b1);
		               unset();
		               caml_callback(record_until, [d]);
		               function b7(M, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create$25,
		                         "lib/src/atomic.ml:36:2",
		                         [0, [0, cst_t, 0, M[8]], 0],
		                         function(group){
		                          var bin_shape_t = [8, group, cst_t, 0];
		                          return cont([0, [0, , , , , , , bin_shape_t]]);
		                         });
		               }
		               var d = "Validate";
		               record_start(d);
		               set$7("validate");
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Import";
		               record_start(d);
		               set$7(cst_core);
		               caml_callback
		                (create$25,
		                 ["core/src/import.ml:68:4",
		                  [0,
		                   [0,
		                    "sexp_opaque",
		                    [0, cst_a$0, 0],
		                    var$("core/src/import.ml:68:26", cst_a$0)],
		                   0]]);
		               cd([0, "core/src/import.ml.sexp_opaque"]);
		               try{caml_sys_getenv(bZ);}
		               catch(exn){
		                var exn$7 = caml_wrap_exception(exn);
		                if(exn$7 !== Not_found){
		                 z = caml_pop_trap();
		                 var exn$8 = caml_maybe_attach_backtrace(exn$7, 0);
		                 return z(exn$8);
		                }
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Sexpable";
		               record_start(d);
		               set$7(cst_core);
		               function V1$0(M){
		                function sexp_of_t(t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (M[2], t, function(a){return cont([0, a]);});
		                }
		                return [0, , , sexp_of_t];
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Binable_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Binable0";
		               record_start(d);
		               set$7(cst_core);
		               function Of_binable_without_uuid(Binable, M){
		                return Make_binable_without_uuid([0, Binable]);
		               }
		               function Of_binable_with_uuid(Binable, M){
		                var caller_identity = M[3];
		                return Make_binable_gen
		                        ([0, Binable, , , [0, caller_identity]]);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Printf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Perms";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$3 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:9:4", [0, [0, cst_t, 0, [3, 0]], 0]]),
		                group$4 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:15:4", [0, [0, cst_t, 0, [3, 0]], 0]]),
		                group$5 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:21:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       poly_variant
		                        ("core/src/perms.ml:21:13", [0, constr(cst_Read, 0), 0])],
		                      0]]),
		                bZ = "Who_can_write",
		                bin_shape_t$20 = [8, group$4, cst_t, 0],
		                group$6 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:27:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       poly_variant
		                        ("core/src/perms.ml:27:13",
		                         [0, constr(bZ, [0, bin_shape_t$20]), 0])],
		                      0]]),
		                bin_shape_t$19 = [8, group$3, cst_t, 0],
		                b1 = [0, constr(bZ, [0, bin_shape_t$19]), 0],
		                bin_shape_t$21 = [8, group$5, cst_t, 0],
		                group$7 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:33:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       poly_variant
		                        ("core/src/perms.ml:34:6",
		                         [0, inherit("core/src/perms.ml:34:8", bin_shape_t$21), b1])],
		                      0]]),
		                bin_shape_t$22 = [8, group$6, cst_t, 0],
		                b1 = [0, inherit("core/src/perms.ml:45:8", bin_shape_t$22), 0],
		                group$8 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:43:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       poly_variant
		                        ("core/src/perms.ml:44:6",
		                         [0, inherit("core/src/perms.ml:44:8", bin_shape_t$21), b1])],
		                      0]]),
		                bZ =
		                  [0,
		                   constr(bZ, [0, var$("core/src/perms.ml:55:26", cst_a$0)]),
		                   0],
		                group$9 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:53:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, 0],
		                       poly_variant
		                        ("core/src/perms.ml:54:6",
		                         [0, inherit("core/src/perms.ml:54:8", bin_shape_t$21), bZ])],
		                      0]]);
		               function Only_used_as_phantom_type1(Name, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create$25,
		                         "core/src/perms.ml:90:8",
		                         [0,
		                          [0,
		                           cst_t,
		                           [0, cst_a$0, 0],
		                           var$("core/src/perms.ml:90:20", cst_a$0)],
		                          0],
		                         function(group){
		                          function bin_shape_t$0(a){
		                           var v2 = [0, a, 0];
		                           return [8, group, cst_t, v2];
		                          }
		                          function bin_shape_t(bin_shape_el){
		                           return maybe_annotate_shape(0, bin_shape_t$0(bin_shape_el));
		                          }
		                          return cont([0, bin_shape_t]);
		                         });
		               }
		               function Only_used_as_phantom_type0(T, cont){
		                return caml_exact_trampoline_cps_call
		                        (Only_used_as_phantom_type1,
		                         dummy,
		                         function(M){
		                          return caml_exact_trampoline_cps_call$1
		                                  (create$25,
		                                   "core/src/perms.ml:115:2",
		                                   [0, [0, cst_t, 0, M[1].call(null, T[5])], 0],
		                                   function(group){
		                                    var bin_shape_t = [8, group, cst_t, 0];
		                                    return cont([0, , , , , bin_shape_t]);
		                                   });
		                         });
		               }
		               var
		                Nobody =
		                  caml_callback
		                   (Only_used_as_phantom_type0, [[0, , , , , bin_shape_t$19]]),
		                Me$0 =
		                  caml_callback
		                   (Only_used_as_phantom_type0, [[0, , , , , bin_shape_t$20]]),
		                Read$3 =
		                  caml_callback
		                   (Only_used_as_phantom_type0, [[0, , , , , bin_shape_t$21]]);
		               caml_callback
		                (Only_used_as_phantom_type0, [[0, , , , , bin_shape_t$22]]);
		               var
		                Read_write =
		                  caml_callback
		                   (Only_used_as_phantom_type0,
		                    [[0, , , , , [8, group$8, cst_t, 0]]]),
		                Immutable =
		                  caml_callback
		                   (Only_used_as_phantom_type0,
		                    [[0, , , , , [8, group$7, cst_t, 0]]]);
		               caml_callback
		                (create$25,
		                 ["core/src/perms.ml:131:4",
		                  [0, [0, "nobody", 0, Nobody[5]], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/perms.ml:132:4", [0, [0, cst_me, 0, Me$0[5]], 0]]);
		               var
		                M$5 = caml_callback(Only_used_as_phantom_type1, [dummy]),
		                a$10 = var$("core/src/perms.ml:137:18", cst_a$0),
		                group$10 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/perms.ml:137:6",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, 0],
		                       M$5[1].call(null, [8, group$9, cst_t, [0, a$10, 0]])],
		                      0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/perms.ml:150:4",
		                  [0, [0, cst_read, 0, Read$3[5]], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/perms.ml:156:4",
		                  [0, [0, "immutable", 0, Immutable[5]], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/perms.ml:159:4",
		                  [0, [0, cst_read_write, 0, Read_write[5]], 0]]);
		               var
		                a$11 = var$("core/src/perms.ml:162:20", cst_a$0),
		                bZ = "perms";
		               caml_callback
		                (create$25,
		                 ["core/src/perms.ml:162:4",
		                  [0,
		                   [0, bZ, [0, cst_a$0, 0], [8, group$10, cst_t, [0, a$11, 0]]],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Comparator";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Source_code_position0";
		               record_start(d);
		               set$7(cst_core);
		               var
		                bin_shape_string$0 = [1, cst_string, 0],
		                bin_shape_int$0 = [1, cst_int, 0],
		                group$11 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/source_code_position0.ml:7:4",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       [2,
		                        [0,
		                         [0, "pos_fname", bin_shape_string$0],
		                         [0,
		                          [0, "pos_lnum", bin_shape_int$0],
		                          [0,
		                           [0, "pos_bol", bin_shape_int$0],
		                           [0, [0, "pos_cnum", bin_shape_int$0], 0]]]]]],
		                      0]]);
		               function compare$143(a_001, b_002, cont){
		                if(a_001 === b_002) return cont(0);
		                var
		                 b = b_002[1],
		                 a = a_001[1],
		                 n$1 = caml_string_compare(a, b);
		                if(0 !== n$1) return cont(n$1);
		                var
		                 b$0 = b_002[2],
		                 a$0 = a_001[2],
		                 n$0 = caml_int_compare(a$0, b$0);
		                if(0 !== n$0) return cont(n$0);
		                var
		                 b$1 = b_002[3],
		                 a$1 = a_001[3],
		                 n = caml_int_compare(a$1, b$1);
		                if(0 !== n) return cont(n);
		                var b$2 = b_002[4], a$2 = a_001[4];
		                return cont(caml_int_compare(a$2, b$2));
		               }
		               function hash_fold_t$1(hsv, arg){
		                var
		                 hsv$2 = Base_internalhash_fold_string(hsv, arg[1]),
		                 hsv$1 = Base_internalhash_fold_int(hsv$2, arg[2]),
		                 hsv$0 = Base_internalhash_fold_int(hsv$1, arg[3]);
		                return Base_internalhash_fold_int(hsv$0, arg[4]);
		               }
		               function hash$22(arg, cont){
		                var hsv = create$8();
		                return cont
		                        (Base_internalhash_get_hash_value(hash_fold_t$1(hsv, arg)));
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Info";
		               record_start(d);
		               set$7(cst_core);
		               var
		                v0$6 =
		                  [0,
		                   [0, cst_Atom, [0, bin_shape_string$0, 0]],
		                   [0, [0, cst_List, [0, bin_shape_list([7, cst_t, 0]), 0]], 0]],
		                group$12 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/info.ml:18:6", [0, [0, cst_t, 0, [3, v0$6]], 0]]),
		                bin_shape_t$24 = [8, group$12, cst_t, 0],
		                include$313 = Of_binable_without_uuid([0, bin_shape_t$24]),
		                bin_shape_t = include$313[5],
		                bin_shape_t$23 = [8, group$11, cst_t, 0];
		               function Extend(Info, cont){
		                var sexp_of_t = Info[9];
		                return caml_exact_trampoline_cps_call$1
		                        (create$25,
		                         "core/src/info.ml:67:10",
		                         [0, [0, cst_t, 0, bin_shape_t$23], 0],
		                         function(group){
		                          var
		                           bin_shape_t$0 = [8, group, cst_t, 0],
		                           a = [0, bin_shape_list([7, cst_t, 0]), 0],
		                           a =
		                             [0,
		                              [0,
		                               cst_Tag_t,
		                               [0, bin_shape_string$0, [0, [7, cst_t, 0], 0]]],
		                              [0,
		                               [0,
		                                cst_Tag_arg,
		                                [0,
		                                 bin_shape_string$0,
		                                 [0, bin_shape_t$24, [0, [7, cst_t, 0], 0]]]],
		                               [0,
		                                [0, cst_Of_list, [0, bin_shape_option(bin_shape_int$0), a]],
		                                [0,
		                                 [0,
		                                  cst_With_backtrace,
		                                  [0, [7, cst_t, 0], [0, bin_shape_string$0, 0]]],
		                                 0]]]],
		                           v0 =
		                             [0,
		                              [0, cst_Could_not_construct, [0, bin_shape_t$24, 0]],
		                              [0,
		                               [0, cst_String, [0, bin_shape_string$0, 0]],
		                               [0,
		                                [0, cst_Exn, [0, bin_shape_t, 0]],
		                                [0,
		                                 [0, cst_Sexp, [0, bin_shape_t$24, 0]],
		                                 [0,
		                                  [0,
		                                   cst_Tag_sexp,
		                                   [0,
		                                    bin_shape_string$0,
		                                    [0, bin_shape_t$24, [0, bin_shape_option(bin_shape_t$0), 0]]]],
		                                  a]]]]];
		                          return caml_exact_trampoline_cps_call$1
		                                  (create$25,
		                                   "core/src/info.ml:77:8",
		                                   [0, [0, cst_t, 0, [3, v0]], 0],
		                                   function(group){
		                                    var
		                                     bin_shape_t$0 = [8, group, cst_t, 0],
		                                     include = Of_binable_without_uuid([0, bin_shape_t$0]),
		                                     bin_shape_t = include[5];
		                                    return caml_exact_trampoline_cps_call$1
		    (create$25,
		     "core/src/info.ml:127:8",
		     [0, [0, cst_t, 0, bin_shape_t], 0],
		     function(group){
		      var bin_shape_t$0 = [8, group, cst_t, 0];
		      return caml_exact_trampoline_cps_call
		              (b7,
		               [0, , , , , , , , bin_shape_t$0],
		               function(include){
		                var
		                 Diff = include[1],
		                 include$0 = Of_binable_without_uuid([0, bin_shape_t$24]),
		                 bin_shape_t$0 = include$0[5],
		                 Stable =
		                   [0,
		                    [0, , , , , , , , , , , , , , , , bin_shape_t, , , , , Diff],
		                    [0, , , , , , , , , , , , bin_shape_t$0]];
		                return caml_exact_trampoline_cps_call$1
		                        (create$25,
		                         "core/src/info.ml:170:2",
		                         [0, [0, cst_t, 0, bin_shape_t], 0],
		                         function(group){
		                          var bin_shape_t = [8, group, cst_t, 0];
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    sexp_of_t,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    Stable,
		                                    bin_shape_t]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                include$120 =
		                  caml_callback
		                   (Extend, [[0, compare$5, , , , , , , , sexp_of_t$2]]),
		                sexp_of_t$64 = include$120[9];
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Error";
		               record_start(d);
		               set$7(cst_core);
		               b1 =
		                caml_callback
		                 (Extend, [[0, compare$5, , , , , , , , sexp_of_t$2]]);
		               b5 = b1[31];
		               b_ = b5[1];
		               bU = b_[16];
		               var bin_shape_t$0 = b1[32];
		               function failwiths(strict, here, message, a, sexp_of_a, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (create$9,
		                         [0, here],
		                         strict,
		                         message,
		                         a,
		                         sexp_of_a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(raise, a, cont);
		                         });
		               }
		               var b_ = b_[21], b5 = b5[2][12], b1 = b1[31][1][21][7];
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Deprecate_pipe_bang";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Fn";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Result";
		               record_start(d);
		               set$7(cst_core);
		               ca =
		                [0,
		                 [0,
		                  cst_Error,
		                  [0, var$("core/src/result.ml:8:17", cst_b), 0]],
		                 0];
		               var
		                v0$7 =
		                  [0,
		                   [0,
		                    cst_Ok,
		                    [0, var$("core/src/result.ml:7:14", cst_a$0), 0]],
		                   ca],
		                ca = "core/src/result.ml:6:4",
		                group$13 =
		                  caml_callback
		                   (create$25,
		                    [ca,
		                     [0, [0, cst_t, [0, cst_a$0, [0, cst_b, 0]], [3, v0$7]], 0]]);
		               function bin_shape_t$1(a, b){
		                var v2 = [0, a, [0, b, 0]];
		                return [8, group$13, cst_t, v2];
		               }
		               var
		                cf = "b_diff",
		                ch = [0, [0, "Diff_error", [0, var$(ca, cf), 0]], 0],
		                cst_a_diff = "a_diff",
		                ch = [0, [0, "Diff_ok", [0, var$(ca, cst_a_diff), 0]], ch],
		                ch = [0, [0, "Set_to_error", [0, var$(ca, cst_b), 0]], ch],
		                v0$8 = [0, [0, "Set_to_ok", [0, var$(ca, cst_a$0), 0]], ch],
		                group$14 =
		                  caml_callback
		                   (create$25,
		                    [ca,
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, [0, cst_b, [0, cst_a_diff, [0, cf, 0]]]],
		                       [3, v0$8]],
		                      0]]);
		               function bin_shape_t$2(a, b, a_diff, b_diff){
		                var v2 = [0, a, [0, b, [0, a_diff, [0, b_diff, 0]]]];
		                return [8, group$14, cst_t, v2];
		               }
		               bPx([0, "core/src/result.ml.Stable.V1.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/result.ml:29:4",
		                  [0,
		                   [0,
		                    cst_t,
		                    0,
		                    bin_shape_t$1(bin_shape_string$0, bin_shape_int$0)],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Or_error";
		               record_start(d);
		               set$7(cst_core);
		               cf = "core/src/or_error.ml:4:0";
		               caml_callback
		                (create$25,
		                 [cf,
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$1
		                     (var$("core/src/or_error.ml:4:13", cst_a$0), bin_shape_t$0)],
		                   0]]);
		               ca = var$(cf, cst_a_diff);
		               caml_callback
		                (create$25,
		                 [cf,
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, [0, cst_a_diff, 0]],
		                    bin_shape_t$2(var$(cf, cst_a$0), bin_shape_t$0, ca, b1)],
		                   0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/or_error.ml:18:4",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$1
		                     (var$("core/src/or_error.ml:18:17", cst_a$0), b5)],
		                   0]]);
		               b5 = "core/src/or_error.ml:25:4";
		               caml_callback
		                (create$25,
		                 [b5,
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$1
		                     (var$("core/src/or_error.ml:25:17", cst_a$0), bU)],
		                   0]]);
		               b_ = b_[7];
		               b1 = var$(b5, cst_a_diff);
		               caml_callback
		                (create$25,
		                 [b5,
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, [0, cst_a_diff, 0]],
		                    bin_shape_t$2(var$(b5, cst_a$0), bU, b1, b_)],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Sequence";
		               record_start(d);
		               set$7(cst_core);
		               caml_callback
		                (create$25,
		                 ["core/src/sequence.ml:6:4",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_list(var$("core/src/sequence.ml:6:16", cst_a$0))],
		                   0]]);
		               bU =
		                [0,
		                 [0, cst_state, var$("core/src/sequence.ml:23:18", cst_s$0)],
		                 0];
		               var
		                v0$9 =
		                  [0,
		                   [0, cst_value, var$("core/src/sequence.ml:22:18", cst_a$0)],
		                   bU],
		                v0$10 =
		                  [0,
		                   [0, cst_state, var$("core/src/sequence.ml:20:24", cst_s$0)],
		                   0],
		                cst_Yield = "Yield";
		               caml_callback
		                (create$25,
		                 ["core/src/sequence.ml:18:2",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, [0, cst_s$0, 0]],
		                    [3,
		                     [0,
		                      aEe,
		                      [0,
		                       [0, "Skip", [0, [2, v0$10], 0]],
		                       [0, [0, cst_Yield, [0, [2, v0$9], 0]], 0]]]]],
		                   0]]);
		               bU = [0, var$("core/src/sequence.ml:34:19", cst_b), 0];
		               bU =
		                [0,
		                 [0,
		                  cst_Both,
		                  [0, var$("core/src/sequence.ml:34:14", cst_a$0), bU]],
		                 0];
		               var
		                cst_Right = "Right",
		                bU =
		                  [0,
		                   [0,
		                    cst_Right,
		                    [0, var$("core/src/sequence.ml:33:15", cst_b), 0]],
		                   bU],
		                cst_Left = "Left",
		                v0$11 =
		                  [0,
		                   [0,
		                    cst_Left,
		                    [0, var$("core/src/sequence.ml:32:14", cst_a$0), 0]],
		                   bU];
		               caml_callback
		                (create$25,
		                 ["core/src/sequence.ml:31:2",
		                  [0, [0, cst_t, [0, cst_a$0, [0, cst_b, 0]], [3, v0$11]], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Quickcheck";
		               record_start(d);
		               set$7(cst_core);
		               caml_callback
		                (cycle_list_exn, [caml_callback(range, [0, 0, aEf, 0, 30])]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Container_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Container";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Ordered_collection_common";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Array";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$15 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/array.ml:13:0",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, 0],
		                       bin_shape_array(var$("core/src/array.ml:13:12", cst_a$0))],
		                      0]]);
		               cd([0, "core/src/array.ml.t"]);
		               var
		                bU = "t_",
		                group$16 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/array.ml:41:4",
		                     [0, [0, bU, 0, bin_shape_array(bin_shape_int$0)], 0]]);
		               function equal$226(b, a){return b === a ? 1 : 0;}
		               function of_bool$2(b){return b ? 1 : 0;}
		               bQs
		                ([0, equal$226, of_bool$2]);
		               var
		                bin_shape_float = [1, cst_float, 0],
		                group$17 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/array.ml:77:4",
		                     [0, [0, bU, 0, bin_shape_array(bin_shape_float)], 0]]);
		               function equal$227(b, a){return b === a ? 1 : 0;}
		               function of_bool$3(b){return b ? 1. : 0.;}
		               bQs
		                ([0, equal$227, of_bool$3]);
		               caml_callback
		                (create$25,
		                 ["core/src/array.ml:421:2",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, [0, bZ, 0]],
		                    bin_shape_array(var$("core/src/array.ml:421:25", cst_a$0))],
		                   0]]);
		               bPx([0, "core/src/array.ml.Permissioned.t"]);
		               var bin_shape_t$25 = [8, group$16, bU, 0];
		               caml_callback
		                (create$25,
		                 ["core/src/array.ml:426:4",
		                  [0, [0, cst_t, [0, bZ, 0], bin_shape_t$25], 0]]);
		               var bin_shape_t$26 = [8, group$17, bU, 0];
		               caml_callback
		                (create$25,
		                 ["core/src/array.ml:432:4",
		                  [0, [0, cst_t, [0, bZ, 0], bin_shape_t$26], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/array.ml:559:2",
		                  [0, [0, cst_t, 0, bin_shape_t$25], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/array.ml:565:2",
		                  [0, [0, cst_t, 0, bin_shape_t$26], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__T";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__List0";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$18 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/list0.ml:5:0",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, 0],
		                       bin_shape_list(var$("core/src/list0.ml:5:12", cst_a$0))],
		                      0]]);
		               function bin_shape_t$3(a){
		                var v2 = [0, a, 0];
		                return [8, group$18, cst_t, v2];
		               }
		               cd([0, "core/src/list0.ml.t"]);
		               bU = [0, var$("core/src/list0.ml:10:26", cst_b), 0];
		               var v0$12 = [0, var$("core/src/list0.ml:10:21", cst_a$0), bU];
		               caml_callback
		                (create$25,
		                 ["core/src/list0.ml:10:2",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, [0, cst_b, 0]],
		                    bin_shape_list([4, v0$12])],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hashtbl";
		               record_start(d);
		               set$7(cst_core);
		               bU = [0, var$("core/src/hashtbl.ml:103:28", cst_b), 0];
		               var
		                v0$13 = [0, var$("core/src/hashtbl.ml:103:23", cst_a$0), bU],
		                cst_el = "el";
		               caml_callback
		                (create$25,
		                 ["core/src/hashtbl.ml:103:4",
		                  [0, [0, cst_el, [0, cst_a$0, [0, cst_b, 0]], [4, v0$13]], 0]]);
		               function Make_plain_with_hashable(T){
		                var hashable = T[2];
		                function create(growth_allowed, size, param, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (create$17, growth_allowed, size, hashable, dummy, cont);
		                }
		                function Provide_of_sexp(Key){}
		                function Provide_bin_io(Key, cont){
		                 var
		                  bin_shape_t = Key[5],
		                  v0 =
		                    [0,
		                     bin_shape_t,
		                     [0, var$("core/src/hashtbl.ml:176:25", cst_a$0), 0]];
		                 return caml_exact_trampoline_cps_call$1
		                         (create$25,
		                          "core/src/hashtbl.ml:176:4",
		                          [0, [0, cst_el, [0, cst_a$0, 0], [4, v0]], 0],
		                          function(group){return cont();});
		                }
		                function Provide_stable_witness(Key){}
		                return [0,
		                        hashable,
		                        ,
		                        create,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Provide_of_sexp,
		                        Provide_bin_io,
		                        Provide_stable_witness];
		               }
		               function Make$15(Key){
		                var Key$0 = [0, Key[2], Key[3], Key[4]],
		                 hashable = [0, Key$0[3], Key$0[1], Key$0[2]],
		                 a = Make_plain_with_hashable([0, , hashable]),
		                 hashable$0 = a[1],
		                 Provide_bin_io = a[18],
		                 Provide_stable_witness = a[19];
		                return [0,
		                        hashable$0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Provide_bin_io,
		                        Provide_stable_witness];
		               }
		               function Make_binable(Key, cont){
		                var
		                 a = Make$15([0, , Key[10], Key[11], Key[12]]),
		                 hashable = a[1],
		                 Provide_bin_io = a[17],
		                 Provide_stable_witness = a[18];
		                return caml_exact_trampoline_cps_call
		                        (Provide_bin_io,
		                         [0, , , , , Key[5]],
		                         function(include){
		                          return cont
		                                  ([0,
		                                    hashable,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    Provide_stable_witness]);
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hash_set_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hash_set";
		               record_start(d);
		               set$7(cst_core);
		               function Make_plain_with_hashable$0(T){
		                function Provide_of_sexp(X){}
		                function Provide_bin_io(X, cont){
		                 var bin_shape_t = X[5];
		                 return caml_exact_trampoline_cps_call$1
		                         (create$25,
		                          "core/src/hash_set.ml:54:4",
		                          [0, [0, cst_el, 0, bin_shape_t], 0],
		                          function(group){return cont();});
		                }
		                function Provide_stable_witness(X){}
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Provide_of_sexp,
		                        Provide_bin_io,
		                        Provide_stable_witness];
		               }
		               function Make$16(Elt){
		                var a = Make_plain_with_hashable$0(),
		                 Provide_bin_io = a[7],
		                 Provide_stable_witness = a[8];
		                return [0, , , , , , Provide_bin_io, Provide_stable_witness];
		               }
		               function Make_binable$0(Elt, cont){
		                var
		                 a = Make$16(),
		                 Provide_bin_io = a[6],
		                 Provide_stable_witness = a[7];
		                return caml_exact_trampoline_cps_call
		                        (Provide_bin_io,
		                         [0, , , , , Elt[5]],
		                         function(include){
		                          return cont([0, , , , , , , Provide_stable_witness]);
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Maybe_bound";
		               record_start(d);
		               set$7(cst_core);
		               bU = "Excl";
		               b1 =
		                [0,
		                 [0,
		                  bU,
		                  [0, var$("core/src/maybe_bound.ml:7:16", cst_a$0), 0]],
		                 aEg];
		               b_ = "Incl";
		               var
		                v0$14 =
		                  [0,
		                   [0,
		                    b_,
		                    [0, var$("core/src/maybe_bound.ml:6:16", cst_a$0), 0]],
		                   b1];
		               caml_callback
		                (create$25,
		                 ["core/src/maybe_bound.ml:5:4",
		                  [0, [0, cst_t, [0, cst_a$0, 0], [3, v0$14]], 0]]);
		               bU =
		                [0,
		                 [0,
		                  bU,
		                  [0, var$("core/src/maybe_bound.ml:25:12", cst_a$0), 0]],
		                 aEh];
		               var
		                v0$15 =
		                  [0,
		                   [0,
		                    b_,
		                    [0, var$("core/src/maybe_bound.ml:24:12", cst_a$0), 0]],
		                   bU],
		                group$19 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/maybe_bound.ml:23:0",
		                     [0, [0, cst_t, [0, cst_a$0, 0], [3, v0$15]], 0]]);
		               function bin_shape_t$4(a){
		                var v2 = [0, a, 0];
		                return [8, group$19, cst_t, v2];
		               }
		               caml_callback
		                (create$25,
		                 ["core/src/maybe_bound.ml:61:2",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$4
		                     (var$("core/src/maybe_bound.ml:61:21", cst_a$0))],
		                   0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/maybe_bound.ml:67:2",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$4
		                     (var$("core/src/maybe_bound.ml:67:21", cst_a$0))],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Map";
		               record_start(d);
		               set$7(cst_core);
		               bU = [0, var$("core/src/map.ml:8:77", cst_v), 0];
		               var
		                v0$16 = [0, var$("core/src/map.ml:8:72", cst_v), bU],
		                bU = [0, constr("Unequal", [0, [4, v0$16]]), 0],
		                bU =
		                  [0,
		                   constr(cst_Right, [0, var$("core/src/map.ml:8:55", cst_v)]),
		                   bU],
		                bU =
		                  [0,
		                   poly_variant
		                    ("core/src/map.ml:8:29",
		                     [0,
		                      constr(cst_Left, [0, var$("core/src/map.ml:8:40", cst_v)]),
		                      bU]),
		                   0],
		                v0$17 = [0, var$("core/src/map.ml:8:24", cst_k), bU];
		               caml_callback
		                (create$25,
		                 ["core/src/map.ml:8:6",
		                  [0, [0, cst_t, [0, cst_k, [0, cst_v, 0]], [4, v0$17]], 0]]);
		               var Using_comparator$0 =
		                  [0,
		                   sexp_of_t$15,
		                   ,
		                   [0,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    is_empty$6,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    find$3,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    fold$6,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    empty_without_value_restrictio$0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   comparator$5,
		                   ,
		                   Empty_without_value_restrictio$0],
		                sexp_of_t$65 = Using_comparator$0[1],
		                comparator$49 = Using_comparator$0[110];
		               bU = [0, var$("core/src/map.ml:517:28", cst_b), 0];
		               var v0$18 = [0, var$("core/src/map.ml:517:23", cst_a$0), bU];
		               caml_callback
		                (create$25,
		                 ["core/src/map.ml:517:4",
		                  [0, [0, cst_el, [0, cst_a$0, [0, cst_b, 0]], [4, v0$18]], 0]]);
		               function Provide_bin_io(Key, cont){
		                var
		                 a = [0, var$("core/src/map.ml:563:23", cst_v), 0],
		                 v0 = [0, Key[5], a];
		                return caml_exact_trampoline_cps_call$1
		                        (create$25,
		                         "core/src/map.ml:563:2",
		                         [0, [0, cst_el, [0, cst_v, 0], [4, v0]], 0],
		                         function(group){return cont();});
		               }
		               function Make_plain_using_comparator(Key){
		                function sexp_of_t(sexp_of_v, t, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (sexp_of_t$65, Key[1], sexp_of_v, dummy, t, cont);
		                }
		                function Provide_of_sexp(Key){}
		                function Provide_bin_io$0(Key, cont){
		                 var bin_shape_t = Key[5];
		                 return caml_exact_trampoline_cps_call
		                         (Provide_bin_io, [0, , , , , bin_shape_t], cont);
		                }
		                function Provide_stable_witness(Key){}
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        sexp_of_t,
		                        ,
		                        Provide_of_sexp,
		                        ,
		                        Provide_bin_io$0,
		                        Provide_stable_witness];
		               }
		               function Make_using_comparator$0(Key_sexp){
		                var a = Make_plain_using_comparator([0, Key_sexp[2]]),
		                 sexp_of_t = a[119],
		                 Provide_bin_io = a[123],
		                 Provide_stable_witness = a[124];
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        sexp_of_t,
		                        ,
		                        ,
		                        Provide_bin_io,
		                        Provide_stable_witness];
		               }
		               function Make_binable_using_comparator(Key_bin_sexp, cont){
		                var
		                 a = Make_using_comparator$0([0, , Key_bin_sexp[10]]),
		                 sexp_of_t = a[117],
		                 Provide_bin_io = a[120],
		                 Provide_stable_witness = a[121];
		                return caml_exact_trampoline_cps_call
		                        (Provide_bin_io,
		                         [0, , , , , Key_bin_sexp[5]],
		                         function(include){
		                          var
		                           v_diff = var$("core/src/map.ml:710:39", cst_a_diff),
		                           v = var$("core/src/map.ml:710:35", cst_a$0),
		                           k = Key_bin_sexp[5];
		                          return caml_exact_trampoline_cps_call$1
		                                  (create$25,
		                                   "core/src/map.ml:710:4",
		                                   [0,
		                                    [0,
		                                     cst_t,
		                                     [0, cst_a$0, [0, cst_a_diff, 0]],
		                                     [8, group$2, cst_t, [0, k, [0, v, [0, v_diff, 0]]]]],
		                                    0],
		                                   function(group){
		                                    return cont
		    ([0,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      sexp_of_t,
		      ,
		      ,
		      ,
		      Provide_stable_witness]);
		                                   });
		                         });
		               }
		               function Make$17(Key_stable, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_binable_using_comparator,
		                         [0, , , , , Key_stable[6], , , , , Key_stable[12]],
		                         function(a){
		                          var Provide_stable_witness = a[121];
		                          Provide_stable_witness();
		                          return cont();
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               function bPj(a, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_binable_using_comparator,
		                         a,
		                         function(a){
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    a[117]]);
		                         });
		               }
		               function bQt(a){Make_using_comparator$0(a);}
		               var d = "Core__Set";
		               record_start(d);
		               set$7(cst_core);
		               var
		                Using_comparator =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Empty_without_value_restrictio];
		               function Creators$0(Elt){Using_comparator[70].call(null);}
		               Creators$0();
		               caml_callback
		                (create$25,
		                 ["core/src/set.ml:280:4",
		                  [0,
		                   [0,
		                    cst_el,
		                    [0, cst_a$0, 0],
		                    var$("core/src/set.ml:280:17", cst_a$0)],
		                   0]]);
		               function Provide_bin_io$0(Elt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create$25,
		                         "core/src/set.ml:320:2",
		                         [0, [0, cst_el, 0, Elt[5]], 0],
		                         function(group){return cont();});
		               }
		               function Make_plain_using_comparator$0(Elt){
		                Creators$0();
		                function Provide_of_sexp(Elt){}
		                function Provide_bin_io(Elt, cont){
		                 var bin_shape_t = Elt[5];
		                 return caml_exact_trampoline_cps_call
		                         (Provide_bin_io$0, [0, , , , , bin_shape_t], cont);
		                }
		                function Provide_stable_witness(Elt){}
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Provide_of_sexp,
		                        ,
		                        Provide_bin_io,
		                        Provide_stable_witness];
		               }
		               function Make_using_comparator$1(Elt_sexp){
		                var a = Make_plain_using_comparator$0(),
		                 Provide_bin_io = a[76],
		                 Provide_stable_witness = a[77];
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Provide_bin_io,
		                        Provide_stable_witness];
		               }
		               function Make_binable_using_comparator$0(Elt_bin_sexp, cont){
		                var
		                 a = Make_using_comparator$1(),
		                 Provide_bin_io = a[73],
		                 Provide_stable_witness = a[74];
		                return caml_exact_trampoline_cps_call
		                        (Provide_bin_io,
		                         [0, , , , , Elt_bin_sexp[5]],
		                         function(include){
		                          var a = Elt_bin_sexp[5];
		                          return caml_exact_trampoline_cps_call$1
		                                  (create$25,
		                                   "core/src/set.ml:460:4",
		                                   [0, [0, cst_t, 0, [8, group$0, cst_t, [0, a, 0]]], 0],
		                                   function(group){
		                                    return cont
		    ([0,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      Provide_stable_witness]);
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               function bPk(a, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_binable_using_comparator$0,
		                         a,
		                         function(a){return cont();});
		               }
		               function bQu(a){Make_using_comparator$1();}
		               var d = "Core__Comparable_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Comparable";
		               record_start(d);
		               set$7(cst_core);
		               function Make_plain(T){
		                T[2];
		                 Make$1(T);
		                Make_plain_using_comparator$0();
		               }
		               function Make$18(T){
		                var
		                 sexp_of_t = T[3],
		                 include = Make$1([0, T[1], T[3]]),
		                 comparator = include[1],
		                 T$0 = [0, , sexp_of_t, comparator];
		                bQt(T$0);
		                bQu();
		               }
		               function Make_binable_using_comparator$1(T, cont){
		                var
		                 M = Make_using_comparator([0, T[10], T[11]]),
		                 symbol = M[4],
		                 compare = M[8],
		                 comparator = M[16];
		                return caml_exact_trampoline_cps_call
		                        (bPj,
		                         T,
		                         function(Map){
		                          return caml_exact_trampoline_cps_call
		                                  (bPk,
		                                   T,
		                                   function(Set){
		                                    return cont
		    ([0,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      symbol,
		      ,
		      ,
		      ,
		      compare,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      comparator]);
		                                   });
		                         });
		               }
		               function Make$19(Elt_stable, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make$17,
		                         Elt_stable,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Make_binable_using_comparator$0,
		                                   [0, , , , , Elt_stable[6]],
		                                   function(a){
		                                    var Provide_stable_witness = a[74];
		                                    Provide_stable_witness();
		                                    return cont();
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               function bQv(M, X, cont){
		                var bin_shape_t = X[5], sexp_of_t = X[10];
		                return caml_exact_trampoline_cps_call
		                        (bPj,
		                         [0, , , , , bin_shape_t, , , , , sexp_of_t],
		                         function(Map){
		                          return caml_exact_trampoline_cps_call
		                                  (bPk,
		                                   [0, , , , , bin_shape_t],
		                                   function(Set){
		                                    return cont
		    ([0, , , , , , , , , , , , , , , , , , , , , Map]);
		                                   });
		                         });
		               }
		               function bQw(M, X){
		                var sexp_of_t = X[2];
		                bQt([0, , sexp_of_t]);
		                bQu();
		               }
		               function cl(a, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_binable_using_comparator$1,
		                         a,
		                         function(a){return cont([0, , , , a[18]]);});
		               }
		               function bPR(T, cont){
		                var
		                 bin_shape_t = T[5],
		                 sexp_of_t = T[11],
		                 include = Make$1([0, T[9], T[11]]),
		                 comparator = include[1];
		                return caml_exact_trampoline_cps_call
		                        (Make_binable_using_comparator$1,
		                         [0, , , , , bin_shape_t, , , , , sexp_of_t, comparator],
		                         function(include){
		                          var compare = include[22], comparator = include[30];
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    compare,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    comparator]);
		                         });
		               }
		               var d = "Core__Doubly_linked_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__List";
		               record_start(d);
		               set$7(cst_core);
		               var
		                Duplicate_found =
		                  [248, "Core__List.Duplicate_found", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Duplicate_found,
		                  function(a, cont){
		                   if(a[1] === Duplicate_found){
		                    var arg1_002 = a[3], arg0_001 = a[2];
		                    return caml_trampoline_cps_call2
		                            (arg0_001,
		                             0,
		                             function(res0_003){
		                              return cont
		                                      ([1, [0, aEi, [0, res0_003, [0, [0, arg1_002], 0]]]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aEj], 1));
		                  }]);
		               caml_callback
		                (create$25,
		                 ["core/src/list.ml:51:4",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$3(var$("core/src/list.ml:51:23", cst_a$0))],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Option";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$20 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/option.ml:4:0",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, 0],
		                       bin_shape_option(var$("core/src/option.ml:4:12", cst_a$0))],
		                      0]]);
		               function bin_shape_t$5(a){
		                var v2 = [0, a, 0];
		                return [8, group$20, cst_t, v2];
		               }
		               cd([0, "core/src/option.ml.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/option.ml:23:4",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$5(var$("core/src/option.ml:23:23", cst_a$0))],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Union_find";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Doubly_linked";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Sexp";
		               record_start(d);
		               set$7(cst_core);
		               var
		                v0$19 =
		                  [0,
		                   [0, cst_Atom, [0, bin_shape_string$0, 0]],
		                   [0, [0, cst_List, [0, bin_shape_list([7, cst_t, 0]), 0]], 0]],
		                group$21 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/sexp.ml:11:4", [0, [0, cst_t, 0, [3, v0$19]], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/sexp.ml:45:2",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$1
		                     (var$("core/src/sexp.ml:45:22", cst_a$0),
		                      [4, [0, [8, group$21, cst_t, 0], [0, bin_shape_t$0, 0]]])],
		                   0]]);
		               var
		                v0$20 =
		                  [0,
		                   [0, cst_value, var$("core/src/sexp.ml:70:14", cst_a$0)],
		                   [0, [0, cst_text, bin_shape_string$0], 0]];
		               caml_callback
		                (create$25,
		                 ["core/src/sexp.ml:69:2",
		                  [0, [0, cst_t, [0, cst_a$0, 0], [2, v0$20]], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/sexp.ml:104:0",
		                  [0,
		                   [0,
		                    "no_raise",
		                    [0, cst_a$0, 0],
		                    var$("core/src/sexp.ml:104:19", cst_a$0)],
		                   0]]);
		               bQw(dummy, [0, , sexp_of_t]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hash_queue";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hashable_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hashable";
		               record_start(d);
		               set$7(cst_core);
		               function Make$20(T){
		                Make$15([0, , T[3], T[4], T[5]]);
		               }
		               function Make_binable$1(T, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_binable,
		                         [0, , , , , T[6], , , , , T[11], T[12], T[13]],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Make_binable$0,
		                                   [0, , , , , T[6]],
		                                   function(a){var hash = T[13]; return cont([0, , hash]);});
		                         });
		               }
		               function Make_binable_with_hashable(T, cont){
		                var T$0 = [0, , T[2]],
		                 b = T[1][6],
		                 a = Make_plain_with_hashable([0, , T$0[2]]),
		                 create = a[3],
		                 Provide_bin_io = a[18];
		                var create$0 = [0, , create][2];
		                return caml_exact_trampoline_cps_call
		                        (Provide_bin_io,
		                         [0, , , , , b],
		                         function(include){
		                          var Elt = T[1],
		                           b = Elt[6],
		                           a = Make_plain_with_hashable$0(),
		                           Provide_bin_io = a[7];
		                          var Table = [0, , , , , create$0];
		                          return caml_exact_trampoline_cps_call
		                                  (Provide_bin_io,
		                                   [0, , , , , b],
		                                   function(include){
		                                    var include$0 = T[1], hash = include$0[13];
		                                    return cont([0, , hash, , Table]);
		                                   });
		                         });
		               }
		               function Make$21(Key, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_binable,
		                         [0, , , , , Key[6], , , , , Key[11], Key[12], Key[13]],
		                         function(a){
		                          var hashable = a[1], Provide_stable_witness = a[18];
		                          Provide_stable_witness();
		                          return caml_exact_trampoline_cps_call
		                                  (Make_binable$0,
		                                   [0, , , , , Key[6]],
		                                   function(a){
		                                    var Provide_stable_witness = a[7];
		                                    Provide_stable_witness();
		                                    return cont([0, , , hashable]);
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hexdump_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Hexdump";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Identifiable_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Identifiable";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               function ce(M, B, cont){
		                var hash = M[2], sexp_of_t = M[4], bin_shape_t = B[5];
		                return caml_exact_trampoline_cps_call$1
		                        (bQv,
		                         dummy,
		                         [0, , , , , bin_shape_t, , , , , sexp_of_t],
		                         function(include){
		                          var Map = include[21], hashable = M[24];
		                          return caml_exact_trampoline_cps_call
		                                  (Make_binable_with_hashable,
		                                   [0, [0, , , , , , bin_shape_t, , , , , , , hash], hashable],
		                                   function(include){
		                                    var hash = include[2], Table = include[4];
		                                    return cont
		    ([0,
		      ,
		      ,
		      ,
		      ,
		      bin_shape_t,
		      ,
		      ,
		      ,
		      ,
		      sexp_of_t,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      ,
		      Map,
		      ,
		      ,
		      hash,
		      ,
		      Table]);
		                                   });
		                         });
		               }
		               var d = "Core__Sign";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$22 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/sign.ml:6:4", [0, [0, cst_t, 0, [3, v0$0]], 0]]);
		               bX([0, "core/src/sign.ml.Stable.V1.t"]);
		               caml_callback
		                (ce,
		                 [[0,
		                   ,
		                   hash$7,
		                   ,
		                   sexp_of_t$5,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   hashable$1],
		                  [0, , , , , [8, group$22, cst_t, 0]]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Int";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$23 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/int.ml:8:6",
		                     [0, [0, cst_t, 0, bin_shape_int$0], 0]]),
		                bin_shape_t$27 = [8, group$23, cst_t, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$27, , , , , , sexp_of_int$0]]);
		               var
		                group$24 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/int.ml:17:2",
		                     [0, [0, cst_t, 0, bin_shape_int$0], 0]]),
		                bin_shape_t$6 =
		                  caml_callback
		                    (ce,
		                     [[0,
		                       ,
		                       hash$8,
		                       ,
		                       sexp_of_int$0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       hashable$2],
		                      [0, , , , , [8, group$24, cst_t, 0]]])
		                   [5],
		                sexp_of_int$1 = [0, , , , , , , , , , sexp_of_int$0][10];
		               bX([0, "core/src/int.ml.t"]);
		               bX([0, "core/src/int.ml.Binary.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int.ml:35:2",
		                  [0, [0, cst_t, 0, bin_shape_t$6], 0]]);
		               bX([0, "core/src/int.ml.Hex.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int.ml:41:2",
		                  [0, [0, cst_t, 0, bin_shape_t$6], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Uchar";
		               record_start(d);
		               set$7(cst_core);
		               var
		                include$314 =
		                  Of_binable_with_uuid
		                   ([0, bin_shape_t$6],
		                    [0, , , "324418b0-897e-11ee-a1ba-aaa233d0b6a7"]),
		                bin_shape_t$7 = include$314[5];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$7, , , , , , sexp_of_t$7]]);
		               var
		                include$121 =
		                  caml_callback
		                   (Make$21,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      bin_shape_t$7,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$3,
		                      sexp_of_t$7,
		                      hash$9]]),
		                hashable$5 = include$121[3];
		               caml_callback
		                (Make_binable_with_hashable,
		                 [[0,
		                   [0, , , , , , bin_shape_t$7, , , , , , , hash$9],
		                   hashable$5]]);
		               caml_callback
		                (bQv,
		                 [dummy, [0, , , , , bin_shape_t$7, , , , , sexp_of_t$7]]);
		               function range$1(param, cont){
		                var until = param[2], start = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$37,
		                         int_uniform_inclusive(start, until),
		                         of_scalar_exn,
		                         cont);
		               }
		               var
		                bU = [0, [0, 1., caml_callback(return$23, [1114111])], 0],
		                bU = [0, [0, 1., caml_callback(return$23, [0])], bU],
		                bU =
		                  [0, [0, 10., caml_callback(range$1, [four_bytes_utf8])], bU],
		                bU =
		                  [0,
		                   [0, 5., caml_callback(range$1, [three_bytes_utf8_part2])],
		                   bU],
		                bU =
		                  [0,
		                   [0, 5., caml_callback(range$1, [three_bytes_utf8_part1])],
		                   bU],
		                bU =
		                  [0, [0, 5., caml_callback(range$1, [two_bytes_utf8])], bU],
		                quickcheck_generator$1 =
		                  caml_callback
		                   (weighted_union,
		                    [[0, [0, 20., caml_callback(range$1, [one_byte_utf8])], bU]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__String";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$25 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/string.ml:12:6",
		                     [0, [0, cst_t, 0, bin_shape_string$0], 0]]),
		                bin_shape_t$28 = [8, group$25, cst_t, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$28, , , , , , sexp_of_string]]);
		               var
		                hashable$6 =
		                  caml_callback
		                    (Make$21,
		                     [[0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       bin_shape_t$28,
		                       ,
		                       ,
		                       ,
		                       ,
		                       compare$4,
		                       sexp_of_string,
		                       function(a, cont){return cont(Base_hash_string(a));}]])
		                   [3];
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$28]]);
		               function Make_utf$0(Utf, cont){
		                var
		                 hash = Utf[3],
		                 sexp_of_t = Utf[5],
		                 compare = Utf[15],
		                 caller_identity = Utf[26],
		                 a = [0, , , caller_identity];
		                return caml_exact_trampoline_cps_call$1
		                        (create$25,
		                         "core/src/string.ml:40:14",
		                         [0, [0, cst_t, 0, bin_shape_string$0], 0],
		                         function(group){
		                          var
		                           bin_shape_t$0 = [8, group, cst_t, 0],
		                           include = Of_binable_with_uuid([0, bin_shape_t$0], a),
		                           bin_shape_t = include[5];
		                          return caml_exact_trampoline_cps_call
		                                  (Make$19,
		                                   [0, , , , , , bin_shape_t, , , , , , sexp_of_t],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (Make$21,
		     [0, , , , , , bin_shape_t, , , , , compare, sexp_of_t, hash],
		     function(include){
		      return cont
		              ([0,
		                [0,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 ,
		                 bin_shape_t]]);
		     });
		                                   });
		                         });
		               }
		               var
		                hash$23 = Utf8$0[3],
		                sexp_of_t$66 = Utf8$0[5],
		                compare$144 = Utf8$0[15],
		                Utf8$1 =
		                  caml_callback
		                   (Make_utf$0,
		                    [[0,
		                      ,
		                      ,
		                      hash$23,
		                      ,
		                      sexp_of_t$66,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$144,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      "5bc29e13-1c6f-4b6d-b431-3befb256ebda"]]),
		                hash$24 = Utf16le$0[3],
		                sexp_of_t$67 = Utf16le$0[5],
		                compare$145 = Utf16le$0[15],
		                Utf16le$1 =
		                  caml_callback
		                   (Make_utf$0,
		                    [[0,
		                      ,
		                      ,
		                      hash$24,
		                      ,
		                      sexp_of_t$67,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$145,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      "7a4f8cac-8fff-11ee-bd11-aaa233d0b6a7"]]),
		                hash$25 = Utf16be$0[3],
		                sexp_of_t$68 = Utf16be$0[5],
		                compare$146 = Utf16be$0[15],
		                Utf16be$1 =
		                  caml_callback
		                   (Make_utf$0,
		                    [[0,
		                      ,
		                      ,
		                      hash$25,
		                      ,
		                      sexp_of_t$68,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$146,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      "7c3a50ce-8fff-11ee-94c6-aaa233d0b6a7"]]),
		                hash$26 = Utf32le$0[3],
		                sexp_of_t$69 = Utf32le$0[5],
		                compare$147 = Utf32le$0[15],
		                Utf32le$1 =
		                  caml_callback
		                   (Make_utf$0,
		                    [[0,
		                      ,
		                      ,
		                      hash$26,
		                      ,
		                      sexp_of_t$69,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$147,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      "961d2214-9252-11ee-9f77-aaa233d0b6a7"]]),
		                hash$27 = Utf32be$0[3],
		                sexp_of_t$70 = Utf32be$0[5],
		                compare$148 = Utf32be$0[15],
		                Utf32be$1 =
		                  caml_callback
		                   (Make_utf$0,
		                    [[0,
		                      ,
		                      ,
		                      hash$27,
		                      ,
		                      sexp_of_t$70,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$148,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      "9fcbae5c-9252-11ee-9f34-aaa233d0b6a7"]]),
		                group$26 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/string.ml:104:4",
		                     [0, [0, cst_t, 0, bin_shape_string$0], 0]]),
		                bin_shape_t$29 = [8, group$26, cst_t, 0];
		               caml_callback
		                (cl,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$29,
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_string,
		                   comparator$3]]);
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$29,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$13,
		                   sexp_of_string,
		                   hash$6]]);
		               caml_callback
		                (create$25,
		                 ["core/src/string.ml:112:0",
		                  [0, [0, cst_t, 0, bin_shape_string$0], 0]]);
		               bX([0, "core/src/string.ml.t"]);
		               var
		                group$27 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/string.ml:122:6",
		                     [0, [0, cst_t, 0, bin_shape_string$0], 0]]),
		                bU =
		                  caml_callback
		                   (ce,
		                    [[0,
		                      ,
		                      function(a, cont){return cont(Base_hash_string(a));},
		                      ,
		                      sexp_of_string,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      hashable$6],
		                     [0, , , , , [8, group$27, cst_t, 0]]]),
		                bin_shape_t$8 = bU[5],
		                sexp_of_string$0 = bU[10],
		                Map$1 = bU[34],
		                hash$28 = bU[37],
		                Table$0 = bU[39],
		                group$28 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/string.ml:128:2",
		                     [0, [0, cst_t, 0, bin_shape_t$8], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$28, cst_t, 0]]]);
		               function Extend_utf(Utf, B, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ce,
		                         [0,
		                          ,
		                          Utf[3],
		                          ,
		                          Utf[5],
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Utf[25]],
		                         B,
		                         function(include){
		                          quickcheck_shrinker_list(quickcheck_shrinker_nativeint);
		                          return caml_exact_trampoline_cps_call
		                                  (quickcheck_generator_list,
		                                   quickcheck_generator$1,
		                                   function(a){return cont();});
		                         });
		               }
		               caml_callback(Extend_utf, [Utf8$0, [0, , , , , Utf8$1[1][31]]]);
		               caml_callback
		                (Extend_utf, [Utf16le$0, [0, , , , , Utf16le$1[1][31]]]);
		               caml_callback
		                (Extend_utf, [Utf16be$0, [0, , , , , Utf16be$1[1][31]]]);
		               caml_callback
		                (Extend_utf, [Utf32le$0, [0, , , , , Utf32le$1[1][31]]]);
		               caml_callback
		                (Extend_utf, [Utf32be$0, [0, , , , , Utf32be$1[1][31]]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Bool";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$29 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/bool.ml:8:6",
		                     [0, [0, cst_t, 0, [1, cst_bool, 0]], 0]]),
		                bin_shape_t$30 = [8, group$29, cst_t, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$30, , , , , , sexp_of_bool]]);
		               bX([0, "core/src/bool.ml.t"]);
		               var
		                group$30 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/bool.ml:24:6",
		                     [0, [0, cst_t, 0, bin_shape_t$30], 0]]),
		                bin_shape_t$9 =
		                  caml_callback
		                    (ce,
		                     [[0,
		                       ,
		                       hash$2,
		                       ,
		                       sexp_of_bool,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       [0, hash$2, compare_bool, sexp_of_bool]],
		                      [0, , , , , [8, group$30, cst_t, 0]]])
		                   [5];
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Bytes";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$31 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/bytes.ml:8:4",
		                     [0, [0, cst_t, 0, [1, cst_bytes, 0]], 0]]);
		               bX([0, "core/src/bytes.ml.Stable.V1.t"]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Char";
		               record_start(d);
		               set$7(cst_core);
		               var
		                bin_shape_char = [1, z, 0],
		                group$32 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/char.ml:8:6",
		                     [0, [0, cst_t, 0, bin_shape_char], 0]]);
		               bX([0, "core/src/char.ml.Stable.V1.T.t"]);
		               caml_callback
		                (Make$19,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [8, group$32, cst_t, 0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_char$0]]);
		               bX([0, "core/src/char.ml.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/char.ml:16:0",
		                  [0, [0, cst_t, 0, bin_shape_char], 0]]);
		               var
		                group$33 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/char.ml:22:6",
		                     [0, [0, cst_t, 0, bin_shape_char], 0]]),
		                bin_shape_t$10 =
		                  caml_callback
		                    (ce,
		                     [[0,
		                       ,
		                       hash$4,
		                       ,
		                       sexp_of_char$0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       hashable$0],
		                      [0, , , , , [8, group$33, cst_t, 0]]])
		                   [5],
		                group$34 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/char.ml:38:4",
		                     [0, [0, cst_t, 0, bin_shape_char], 0]]),
		                bin_shape_t$31 = [8, group$34, cst_t, 0];
		               caml_callback
		                (cl,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$31,
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_char,
		                   comparator$1]]);
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$31,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$11,
		                   sexp_of_char,
		                   hash$5]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Core_pervasives";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Float";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$35 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/float.ml:27:6",
		                     [0, [0, cst_t, 0, bin_shape_float], 0]]);
		               function hash$29(x, cont){return cont(Base_hash_double(x));}
		               bX([0, "core/src/float.ml.Stable.V1.T1.t"]);
		               var bin_shape_t$32 = [8, group$35, cst_t, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$32, , , , , , sexp_of_float$0]]);
		               var
		                hash$30 =
		                  caml_callback
		                    (Make_binable$1,
		                     [[0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       bin_shape_t$32,
		                       ,
		                       ,
		                       ,
		                       ,
		                       function(b, a, cont){return cont(caml_float_compare(b, a));},
		                       sexp_of_float$0,
		                       hash$29]])
		                   [2];
		               caml_callback
		                (bPj, [[0, , , , , bin_shape_t$32, , , , , sexp_of_float$0]]);
		               caml_callback(bPk, [[0, , , , , bin_shape_t$32]]);
		               caml_callback
		                (create$25,
		                 ["core/src/float.ml:120:2",
		                  [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               function compare$149(b, a, cont){
		                return cont(caml_float_compare(b, a));
		               }
		               var d = "Core__Int32";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$36 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/int32.ml:4:2", [0, [0, cst_t, 0, [1, h, 0]], 0]]),
		                bin_shape_t$11 =
		                  caml_callback
		                    (ce,
		                     [[0,
		                       ,
		                       hash$13,
		                       ,
		                       sexp_of_int32$0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       [0, hash$13, compare, sexp_of_int32]],
		                      [0, , , , , [8, group$36, cst_t, 0]]])
		                   [5];
		               bX([0, "core/src/int32.ml.t"]);
		               bX([0, "core/src/int32.ml.Binary.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int32.ml:17:2",
		                  [0, [0, cst_t, 0, bin_shape_t$11], 0]]);
		               bX([0, "core/src/int32.ml.Hex.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int32.ml:23:2",
		                  [0, [0, cst_t, 0, bin_shape_t$11], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Int64";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$37 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/int64.ml:4:2",
		                     [0, [0, cst_t, 0, [1, cst_int64, 0]], 0]]),
		                bin_shape_t$12 =
		                  caml_callback
		                    (ce,
		                     [[0,
		                       ,
		                       hash$12,
		                       ,
		                       sexp_of_int64$0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       [0, hash$12, compare$0, sexp_of_int64]],
		                      [0, , , , , [8, group$37, cst_t, 0]]])
		                   [5];
		               bX([0, "core/src/int64.ml.t"]);
		               bX([0, "core/src/int64.ml.Binary.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int64.ml:17:2",
		                  [0, [0, cst_t, 0, bin_shape_t$12], 0]]);
		               bX([0, "core/src/int64.ml.Hex.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int64.ml:23:2",
		                  [0, [0, cst_t, 0, bin_shape_t$12], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Int63";
		               record_start(d);
		               set$7(cst_core);
		               var bin_shape_int63 = [1, cst_int63, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_int63, , , , , , sexp_of_t$18]]);
		               var
		                bin_shape_t$13 =
		                  caml_callback
		                    (ce,
		                     [[0,
		                       ,
		                       hash$15,
		                       ,
		                       sexp_of_t$18,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       hashable$4],
		                      [0, , , , , bin_shape_int63]])
		                   [5],
		                compare$150 =
		                  [0, , , , , , , , , , , , , , , , , , , compare_time][19];
		               bX([0, "core/src/int63.ml.Binary.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int63.ml:80:2",
		                  [0, [0, cst_t, 0, bin_shape_t$13], 0]]);
		               bX([0, "core/src/int63.ml.Hex.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/int63.ml:86:2",
		                  [0, [0, cst_t, 0, bin_shape_t$13], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Unit";
		               record_start(d);
		               set$7(cst_core);
		               var bin_shape_unit = [1, j, 0];
		               caml_callback
		                (create$25,
		                 ["core/src/unit.ml:8:6",
		                  [0, [0, cst_t, 0, bin_shape_unit], 0]]);
		               var
		                group$38 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/unit.ml:64:6",
		                     [0, [0, cst_t, 0, bin_shape_unit], 0]]);
		               caml_callback
		                (ce,
		                 [[0,
		                   ,
		                   hash$1,
		                   ,
		                   sexp_of_unit$0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   hashable],
		                  [0, , , , , [8, group$38, cst_t, 0]]]);
		               bX([0, "core/src/unit.ml.t"]);
		               var
		                group$39 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/unit.ml:69:0",
		                     [0, [0, cst_t, 0, bin_shape_unit], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Interfaces";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Lazy";
		               record_start(d);
		               set$7(cst_core);
		               var
		                x1$0 = var$("core/src/lazy.ml:8:16", cst_a$0),
		                group$40 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/lazy.ml:8:4",
		                     [0, [0, cst_t, [0, cst_a$0, 0], x1$0], 0]]);
		               cd([0, "core/src/lazy.ml.Stable.V1.t"]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Nativeint";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$41 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/nativeint.ml:4:2",
		                     [0, [0, cst_t, 0, [1, b3, 0]], 0]]),
		                bin_shape_t$14 =
		                  caml_callback
		                    (ce,
		                     [[0,
		                       ,
		                       hash$11,
		                       ,
		                       sexp_of_nativeint$0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       ,
		                       [0, hash$11, compare$1, sexp_of_nativeint]],
		                      [0, , , , , [8, group$41, cst_t, 0]]])
		                   [5];
		               bX([0, "core/src/nativeint.ml.t"]);
		               bX([0, "core/src/nativeint.ml.Binary.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/nativeint.ml:17:2",
		                  [0, [0, cst_t, 0, bin_shape_t$14], 0]]);
		               bX([0, "core/src/nativeint.ml.Hex.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/nativeint.ml:23:2",
		                  [0, [0, cst_t, 0, bin_shape_t$14], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Nothing";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$42 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/nothing.ml:8:6", [0, [0, cst_t, 0, [3, 0]], 0]]);
		               caml_callback
		                (ce,
		                 [[0,
		                   ,
		                   hash$10,
		                   ,
		                   sexp_of_t$13,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   hashable$3],
		                  [0, , , , , [8, group$42, cst_t, 0]]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Never_returns";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Ordering";
		               record_start(d);
		               set$7(cst_core);
		               caml_callback
		                (create$25,
		                 ["core/src/ordering.ml:3:0",
		                  [0, [0, cst_t, 0, [3, v0$1]], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Ref";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$43 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/ref.ml:9:6",
		                     [0,
		                      [0,
		                       cst_t,
		                       [0, cst_a$0, 0],
		                       bin_shape_ref(var$("core/src/ref.ml:9:18", cst_a$0))],
		                      0]]);
		               function bin_shape_t$15(a){
		                var v2 = [0, a, 0];
		                return [8, group$43, cst_t, v2];
		               }
		               cd([0, "core/src/ref.ml.T.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/ref.ml:22:2",
		                  [0,
		                   [0,
		                    cst_t,
		                    [0, cst_a$0, [0, bZ, 0]],
		                    bin_shape_t$15(var$("core/src/ref.ml:22:25", cst_a$0))],
		                   0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Std_internal";
		               record_start(d);
		               set$7(cst_core);
		               var
		                C_malloc_exn =
		                  [248,
		                   "Core__Std_internal.C_malloc_exn",
		                   caml_fresh_oo_id()];
		               register_exception("C_malloc_exn", [0, C_malloc_exn, 0, 0]);
		               function force$0(a, cont){
		                var b = caml_obj_tag(a);
		                if(250 === b) return cont(a[1]);
		                if(246 !== b && 244 !== b) return cont(a);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, a, cont);
		               }
		               var
		                a$12 = var$("core/src/std_internal.ml:85:20", cst_a$0),
		                group$44 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/std_internal.ml:85:4",
		                     [0,
		                      [0,
		                       cst_array,
		                       [0, cst_a$0, 0],
		                       [8, group$15, cst_t, [0, a$12, 0]]],
		                      0]]);
		               function bin_shape_array$0(a){
		                var v2 = [0, a, 0];
		                return [8, group$44, cst_array, v2];
		               }
		               cd([0, "core/src/std_internal.ml.array"]);
		               var
		                group$45 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/std_internal.ml:95:4",
		                     [0, [0, cst_bool, 0, bin_shape_t$9], 0]]);
		               bX([0, "core/src/std_internal.ml.bool"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:106:4",
		                  [0, [0, z, 0, bin_shape_t$10], 0]]);
		               bX([0, "core/src/std_internal.ml.char"]);
		               var
		                group$46 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/std_internal.ml:117:4",
		                     [0, [0, cst_float, 0, bin_shape_t$32], 0]]);
		               function compare_float(a, b, cont){
		                return cont(caml_float_compare(a, b));
		               }
		               bX([0, "core/src/std_internal.ml.float"]);
		               var
		                group$47 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/std_internal.ml:128:4",
		                     [0, [0, cst_int, 0, bin_shape_t$6], 0]]);
		               function compare_int(a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               bX([0, "core/src/std_internal.ml.int"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:139:4",
		                  [0, [0, h, 0, bin_shape_t$11], 0]]);
		               bX([0, "core/src/std_internal.ml.int32"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:150:4",
		                  [0, [0, cst_int64, 0, bin_shape_t$12], 0]]);
		               bX([0, "core/src/std_internal.ml.int64"]);
		               var a$13 = var$("core/src/std_internal.ml:161:21", cst_a$0);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:161:4",
		                  [0,
		                   [0, cg, [0, cst_a$0, 0], [8, group$40, cst_t, [0, a$13, 0]]],
		                   0]]);
		               cd([0, "core/src/std_internal.ml.lazy_t"]);
		               var
		                group$48 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/std_internal.ml:164:4",
		                     [0,
		                      [0,
		                       cst_list,
		                       [0, cst_a$0, 0],
		                       bin_shape_t$3
		                        (var$("core/src/std_internal.ml:164:19", cst_a$0))],
		                      0]]);
		               function bin_shape_list$0(a){
		                var v2 = [0, a, 0];
		                return [8, group$48, cst_list, v2];
		               }
		               cd([0, "core/src/std_internal.ml.list"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:175:4",
		                  [0, [0, b3, 0, bin_shape_t$14], 0]]);
		               bX([0, "core/src/std_internal.ml.nativeint"]);
		               var
		                group$49 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/std_internal.ml:186:4",
		                     [0,
		                      [0,
		                       cst_option,
		                       [0, cst_a$0, 0],
		                       bin_shape_t$5
		                        (var$("core/src/std_internal.ml:186:21", cst_a$0))],
		                      0]]);
		               function bin_shape_option$0(a){
		                var v2 = [0, a, 0];
		                return [8, group$49, cst_option, v2];
		               }
		               cd([0, "core/src/std_internal.ml.option"]);
		               b3 = var$("core/src/std_internal.ml:197:36", cst_err);
		               cg = "ok";
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:197:4",
		                  [0,
		                   [0,
		                    cst_result,
		                    [0, cg, [0, cst_err, 0]],
		                    bin_shape_t$1
		                     (var$("core/src/std_internal.ml:197:31", cg), b3)],
		                   0]]);
		               bPx([0, "core/src/std_internal.ml.result"]);
		               var
		                group$50 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/std_internal.ml:208:4",
		                     [0, [0, cst_string, 0, bin_shape_t$8], 0]]);
		               bX([0, "core/src/std_internal.ml.string"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:219:4",
		                  [0, [0, cst_bytes, 0, [8, group$31, cst_t, 0]], 0]]);
		               bX([0, "core/src/std_internal.ml.bytes"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:229:4",
		                  [0,
		                   [0,
		                    cst_ref,
		                    [0, cst_a$0, 0],
		                    bin_shape_t$15
		                     (var$("core/src/std_internal.ml:229:18", cst_a$0))],
		                   0]]);
		               cd([0, "core/src/std_internal.ml.ref"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:239:4",
		                  [0, [0, j, 0, [8, group$39, cst_t, 0]], 0]]);
		               bX([0, "core/src/std_internal.ml.unit"]);
		               caml_callback
		                (create$25,
		                 ["core/src/std_internal.ml:252:6",
		                  [0,
		                   [0,
		                    "float_array",
		                    0,
		                    bin_shape_array$0([8, group$46, cst_float, 0])],
		                   0]]);
		               bX([0, "core/src/std_internal.ml.float_array"]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Bigstring";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$51 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/bigstring.ml:13:6",
		                     [0, [0, cst_t, 0, [1, "bigstring", 0]], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/bigstring.ml:22:4",
		                  [0, [0, "t_frozen", 0, [8, group$51, cst_t, 0]], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Core_bin_prot";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Md5";
		               record_start(d);
		               set$7(cst_core);
		               function sexp_of_t$71(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_hex,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_string$0, a, cont);
		                         });
		               }
		               function hash$31(t, cont){
		                return caml_exact_trampoline_cps_call(hash$28, t, cont);
		               }
		               function sexp_of_t$72(x, cont){
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_string$0, x, cont);
		               }
		               var
		                include$122 =
		                  Make_binable_without_uuid([0, [0, bin_shape_t$28]]),
		                bin_shape_t$16 = include$122[5];
		               Make$18([0, compare$141, , sexp_of_t$72]);
		               Make$20([0, , , compare$141, sexp_of_t$72, hash$31]);
		               Make$18([0, compare$141, , sexp_of_t$71]);
		               Make$20([0, , , compare$141, sexp_of_t$71, hash$31]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Zone_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Binable";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Timezone_js_loader";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Zone";
		               record_start(d);
		               set$7(cst_core);
		               var
		                Invalid_file_format =
		                  [248, "Core__Zone.Invalid_file_format", caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Invalid_file_format,
		                  function(a, cont){
		                   if(a[1] === Invalid_file_format){
		                    var arg0_001 = a[2];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_string$0,
		                             arg0_001,
		                             function(res0_002){
		                              return cont([1, [0, aEk, [0, res0_002, 0]]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aEl], 1));
		                  }]);
		               var
		                include$315 = Of_binable_without_uuid([0, bin_shape_t$27]),
		                bin_shape_t$17 = include$315[5],
		                bin_shape_string = [8, group$50, cst_string, 0],
		                group$52 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/zone.ml:71:8",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       [2,
		                        [0,
		                         [0, "utc_offset_in_seconds", bin_shape_int63],
		                         [0,
		                          [0, "is_dst", [8, group$45, cst_bool, 0]],
		                          [0, [0, "abbrv", bin_shape_string], 0]]]]],
		                      0]]),
		                bin_shape_int = [8, group$47, cst_int, 0],
		                group$53 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/zone.ml:83:8",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       [2,
		                        [0,
		                         [0, "time_in_seconds_since_epoch", bin_shape_int63],
		                         [0, [0, cst_seconds, bin_shape_int], 0]]]],
		                      0]]),
		                bin_shape_t$33 = [8, group$52, cst_t, 0],
		                group$54 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/zone.ml:91:8",
		                     [0,
		                      [0,
		                       cst_t,
		                       0,
		                       [2,
		                        [0,
		                         [0, "start_time_in_seconds_since_epoch", bin_shape_int63],
		                         [0, [0, "new_regime", bin_shape_t$33], 0]]]],
		                      0]]),
		                j =
		                  [0,
		                   [0, "last_regime_index", bin_shape_t$17],
		                   [0,
		                    [0, "default_local_time_type", bin_shape_t$33],
		                    [0,
		                     [0,
		                      "leap_seconds",
		                      bin_shape_list$0([8, group$53, cst_t, 0])],
		                     0]]],
		                j =
		                  [0,
		                   [0,
		                    "transitions",
		                    bin_shape_array$0([8, group$54, cst_t, 0])],
		                   j],
		                j = [0, [0, "digest", bin_shape_option$0(bin_shape_t$16)], j],
		                v0$21 =
		                  [0,
		                   [0, cst_name, bin_shape_string],
		                   [0,
		                    [0,
		                     "original_filename",
		                     bin_shape_option$0(bin_shape_string)],
		                    j]];
		               caml_callback
		                (create$25,
		                 ["core/src/zone.ml:98:6", [0, [0, cst_t, 0, [2, v0$21]], 0]]);
		               function of_utc_offset_explicit_name(name, offset, cont){
		                if(-24 <= offset && offset <= 24)
		                 return caml_exact_trampoline_cps_call
		                         (of_int$2,
		                          (offset * 60 | 0) * 60 | 0,
		                          function(utc_offset_in_seconds){return cont();});
		                var raise = caml_pop_trap();
		                return raise
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aEm], 1));
		               }
		               function of_utc_offset(offset, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_utc_offset_explicit_name, dummy, offset, cont);
		                }
		                if(offset === 0) return a();
		                var b = stdlib_abs(offset), c = offset < 0 ? cst$33 : cst$32;
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         aEn,
		                         function(d){return caml_trampoline_cps_call3(d, c, b, a);});
		               }
		               caml_callback(of_utc_offset, [0]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Source_code_position";
		               record_start(d);
		               set$7(cst_core);
		               bQw(dummy, [0, , sexp_of_t$0]);
		               Make$20([0, , , compare$143, sexp_of_t$0, hash$22]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Unit_of_time";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Uniform_array";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Tuple";
		               record_start(d);
		               set$7(cst_core);
		               bPx([0, "core/src/tuple.ml.T2.t"]);
		               bQr([0, "core/src/tuple.ml.T3.t"]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Day_of_week";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$55 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/day_of_week.ml:8:6",
		                     [0, [0, cst_t, 0, [3, v0$2]], 0]]);
		               function compare$151(b, a, cont){
		                return cont(caml_int_compare(b, a));
		               }
		               function hash_fold_t$2(hsv, arg){
		                switch(arg){
		                  case 0:
		                   var a = 0; break;
		                  case 1:
		                   a = 1; break;
		                  case 2:
		                   a = 2; break;
		                  case 3:
		                   a = 3; break;
		                  case 4:
		                   a = 4; break;
		                  case 5:
		                   a = 5; break;
		                  default: a = 6;
		                }
		                return Base_internalhash_fold_int(hsv, a);
		               }
		               function hash$32(arg, cont){
		                var hsv = create$8();
		                return cont
		                        (Base_internalhash_get_hash_value(hash_fold_t$2(hsv, arg)));
		               }
		               function f$13(size_020, random_021, cont){return cont(6);}
		               function f$14(size_018, random_019, cont){return cont(5);}
		               function f$15(size_016, random_017, cont){return cont(4);}
		               function f$16(size_014, random_015, cont){return cont(3);}
		               function f$17(size_012, random_013, cont){return cont(2);}
		               function f$18(size_010, random_011, cont){return cont(1);}
		               function f$19(size_008, random_009, cont){return cont(0);}
		               caml_callback
		                (weighted_union,
		                 [[0,
		                   [0, 1., f$19],
		                   [0,
		                    [0, 1., f$18],
		                    [0,
		                     [0, 1., f$17],
		                     [0,
		                      [0, 1., f$16],
		                      [0,
		                       [0, 1., f$15],
		                       [0, [0, 1., f$14], [0, [0, 1., f$13], 0]]]]]]]]);
		               bX([0, "core/src/day_of_week.ml.Stable.V1.T.t"]);
		               function to_string$64(t, cont){
		                switch(t){
		                  case 0:
		                   return cont("SUN");
		                  case 1:
		                   return cont("MON");
		                  case 2:
		                   return cont("TUE");
		                  case 3:
		                   return cont("WED");
		                  case 4:
		                   return cont("THU");
		                  case 5:
		                   return cont("FRI");
		                  default: return cont("SAT");
		                }
		               }
		               var
		                include$123 = V1$0([0, , to_string$64]),
		                sexp_of_t$73 = include$123[3],
		                bin_shape_t$34 = [8, group$55, cst_t, 0],
		                compare$152 =
		                  caml_callback
		                    (bPR,
		                     [[0,
		                       ,
		                       ,
		                       ,
		                       ,
		                       bin_shape_t$34,
		                       ,
		                       ,
		                       ,
		                       compare$151,
		                       ,
		                       sexp_of_t$73]])
		                   [8],
		                include$124 =
		                  caml_callback
		                   (Make_binable$1,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      bin_shape_t$34,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$151,
		                      sexp_of_t$73,
		                      hash$32]]),
		                hash$33 = include$124[2];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$34, , , , , , sexp_of_t$73]]);
		               caml_callback
		                (Make$21,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$34,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$152,
		                   sexp_of_t$73,
		                   hash$33]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Digit_string_helpers";
		               record_start(d);
		               set$7(cst_core);
		               var
		                int63_two = caml_callback(of_int$2, [2]),
		                int63_ten = caml_callback(of_int$2, [10]),
		                int63_twenty = caml_callback(of_int$2, [20]),
		                int63_billion = caml_callback(of_int$2, [1000000000]);
		               symbol$55(max_value_representable, int63_billion);
		               function digits_of_positive_int63(n){
		                if(symbol$49(n, int63_ten)) return 1;
		                var i = digits_of_positive_int63(symbol$55(n, int63_ten));
		                return i + 1 | 0;
		               }
		               var
		                digits_of_int63_max_value =
		                  digits_of_positive_int63(max_value_representable);
		               function max_int63_with(digits, cont){
		                var switcher = digits - 1 | 0;
		                if(8 < switcher >>> 0)
		                 return digits_of_int63_max_value <= digits
		                         ? cont(max_value_representable)
		                         : caml_exact_trampoline_cps_call
		                           (max_int63_with,
		                            digits - 9 | 0,
		                            function(a){
		                             var billions = succ$0(a);
		                             return cont(pred$4(symbol$53(int63_billion, billions)));
		                            });
		                switch(switcher){
		                  case 0:
		                   return caml_exact_trampoline_cps_call(of_int$2, 9, cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call(of_int$2, 99, cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call(of_int$2, 999, cont);
		                  case 3:
		                   return caml_exact_trampoline_cps_call(of_int$2, 9999, cont);
		                  case 4:
		                   return caml_exact_trampoline_cps_call(of_int$2, 99999, cont);
		                  case 5:
		                   return caml_exact_trampoline_cps_call
		                           (of_int$2, 999999, cont);
		                  case 6:
		                   return caml_exact_trampoline_cps_call
		                           (of_int$2, 9999999, cont);
		                  case 7:
		                   return caml_exact_trampoline_cps_call
		                           (of_int$2, 99999999, cont);
		                  default:
		                   return caml_exact_trampoline_cps_call
		                           (of_int$2, 999999999, cont);
		                }
		               }
		               function write_1_digit_int(bytes, pos, int){
		                caml_bytes_unsafe_set(bytes, pos, 48 + int | 0);
		               }
		               function return_tens_and_write_ones(bytes, pos, int){
		                var tens = int / 10 | 0, ones = int - (tens * 10 | 0) | 0;
		                write_1_digit_int(bytes, pos, ones);
		                return tens;
		               }
		               function write_2_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 1 | 0, int);
		                return write_1_digit_int(bytes, pos, tens);
		               }
		               function write_3_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 2 | 0, int);
		                return write_2_digit_int(bytes, pos, tens);
		               }
		               function write_4_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 3 | 0, int);
		                return write_3_digit_int(bytes, pos, tens);
		               }
		               function write_5_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 4 | 0, int);
		                return write_4_digit_int(bytes, pos, tens);
		               }
		               function write_6_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 5 | 0, int);
		                return write_5_digit_int(bytes, pos, tens);
		               }
		               function write_7_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 6 | 0, int);
		                return write_6_digit_int(bytes, pos, tens);
		               }
		               function write_8_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 7 | 0, int);
		                return write_7_digit_int(bytes, pos, tens);
		               }
		               function write_9_digit_int(bytes, pos, int){
		                var
		                 tens = return_tens_and_write_ones(bytes, pos + 8 | 0, int);
		                return write_8_digit_int(bytes, pos, tens);
		               }
		               function read_1_digit_int(string, pos, cont){
		                var char = caml_string_unsafe_get(string, pos);
		                return caml_exact_trampoline_cps_call
		                        (get_digit_exn, char, cont);
		               }
		               function read_2_digit_int(string, pos, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (read_1_digit_int,
		                         string,
		                         pos + 1 | 0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (read_1_digit_int,
		                                   string,
		                                   pos,
		                                   function(b){return cont((b * 10 | 0) + a | 0);});
		                         });
		               }
		               var
		                max_scale = symbol$55(max_value_representable, int63_twenty),
		                module_name = "Digit_string_helpers";
		               function check_pos(name, len, pos, digits, cont){
		                var
		                 a = pos < 0 ? 1 : 0,
		                 a = a || (len < (pos + digits | 0) ? 1 : 0);
		                if(! a) return cont(a);
		                if(pos >= 0 && len > pos)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          aEt,
		                          function(a){
		                           return caml_trampoline_cps_call7
		                                   (a, module_name, name, digits, pos, len, 0, cont);
		                          });
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         aEs,
		                         function(a){
		                          return caml_trampoline_cps_call6
		                                  (a, module_name, name, pos, len, 0, cont);
		                         });
		               }
		               function check_write(name, bytes, pos, digits, max, int, cont){
		                var len = caml_ml_bytes_length(bytes);
		                return caml_exact_trampoline_cps_call$2
		                        (check_pos,
		                         name,
		                         len,
		                         pos,
		                         digits,
		                         function(a){
		                          a = int < 0 ? 1 : 0;
		                          a ||= max < int ? 1 : 0;
		                          if(! a) return cont(a);
		                          return caml_exact_trampoline_cps_call
		                                  (invalid_argf,
		                                   aEu,
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (a, module_name, name, int, max, 0, cont);
		                                   });
		                         });
		               }
		               function write_2_digit_int$0(bytes, pos, int, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (check_write,
		                         "write_2_digit_int",
		                         bytes,
		                         pos,
		                         2,
		                         99,
		                         int,
		                         function(a){
		                          return cont(write_2_digit_int(bytes, pos, int));
		                         });
		               }
		               function write_3_digit_int$0(bytes, pos, int, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (check_write,
		                         "write_3_digit_int",
		                         bytes,
		                         pos,
		                         3,
		                         999,
		                         int,
		                         function(a){
		                          return cont(write_3_digit_int(bytes, pos, int));
		                         });
		               }
		               function write_int63(bytes, pos, digits, int63, cont){
		                var name = "write_int63";
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (max_int63_with,
		                          digits,
		                          function(max){
		                           var len = caml_ml_bytes_length(bytes);
		                           return caml_exact_trampoline_cps_call$2
		                                   (check_pos,
		                                    name,
		                                    len,
		                                    pos,
		                                    digits,
		                                    function(b){
		                                     b = symbol$49(int63, min_interval_num);
		                                     b ||= symbol$48(int63, max);
		                                     function a(digits, int63){
		                                      var switcher = digits - 1 | 0;
		                                      if(8 >= switcher >>> 0)
		                                       switch(switcher){
		 case 0:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_1_digit_int(bytes, pos, a));});
		 case 1:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_2_digit_int(bytes, pos, a));});
		 case 2:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_3_digit_int(bytes, pos, a));});
		 case 3:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_4_digit_int(bytes, pos, a));});
		 case 4:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_5_digit_int(bytes, pos, a));});
		 case 5:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_6_digit_int(bytes, pos, a));});
		 case 6:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_7_digit_int(bytes, pos, a));});
		 case 7:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_8_digit_int(bytes, pos, a));});
		 default:
		  return caml_exact_trampoline_cps_call
		          (to_int_exn$0,
		           int63,
		           function(a){return cont(write_9_digit_int(bytes, pos, a));});
		                                       }
		                                      var
		                                       digits_of_billions = digits - 9 | 0,
		                                       pos$0 = pos + digits_of_billions | 0,
		                                       billions = symbol$55(int63, int63_billion),
		                                       remainder =
		 symbol$52(int63, symbol$53(billions, int63_billion));
		                                      return caml_exact_trampoline_cps_call
		      (to_int_exn$0,
		       remainder,
		       function(b){
		        write_9_digit_int(bytes, pos$0, b);
		        return caml_exact_trampoline_call2
		                (a, digits_of_billions, billions);
		       });
		                                     }
		                                     if(! b) return a(digits, int63);
		                                     return caml_exact_trampoline_cps_call
		     (invalid_argf,
		      [0,
		       [2,
		        0,
		        [12,
		         46,
		         [2,
		          0,
		          [11,
		           cst$9,
		           [24,
		            aEx,
		            function(param, custom_printf_004, cont){
		             return caml_exact_trampoline_cps_call
		                     (to_string$9, custom_printf_004, cont);
		            },
		            [11,
		             cst_out_of_range_0,
		             [24,
		              aEw,
		              function(param, custom_printf_003, cont){
		               return caml_exact_trampoline_cps_call
		                       (to_string$9, custom_printf_003, cont);
		              },
		              aEv]]]]]]]],
		      function(b){
		       return caml_trampoline_cps_call6
		               (b,
		                module_name,
		                name,
		                int63,
		                max,
		                0,
		                function(b){return a(digits, int63);});
		      });
		                                    });
		                          });
		                }
		                if(digits >= 1) return a();
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         aEq,
		                         function(b){
		                          return caml_trampoline_cps_call5
		                                  (b, module_name, name, digits, 0, a);
		                         });
		               }
		               function check_read(name, string, pos, digits, cont){
		                var len = caml_ml_string_length(string);
		                return caml_exact_trampoline_cps_call$2
		                        (check_pos, name, len, pos, digits, cont);
		               }
		               function read_2_digit_int$0(string, pos, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (check_read,
		                         "read_2_digit_int",
		                         string,
		                         pos,
		                         2,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (read_2_digit_int, string, pos, cont);
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Month";
		               record_start(d);
		               set$7(cst_core);
		               function sexp_of_t$74(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(aEy);
		                  case 1:
		                   return cont(aEz);
		                  case 2:
		                   return cont(aEA);
		                  case 3:
		                   return cont(aEB);
		                  case 4:
		                   return cont(aEC);
		                  case 5:
		                   return cont(aED);
		                  case 6:
		                   return cont(aEE);
		                  case 7:
		                   return cont(aEF);
		                  case 8:
		                   return cont(aEG);
		                  case 9:
		                   return cont(aEH);
		                  case 10:
		                   return cont(aEI);
		                  default: return cont(aEJ);
		                }
		               }
		               function compare$153(b, a, cont){
		                return cont(caml_int_compare(b, a));
		               }
		               function f$20(size_034, random_035, cont){return cont(11);}
		               function f$21(size_032, random_033, cont){return cont(10);}
		               function f$22(size_030, random_031, cont){return cont(9);}
		               function f$23(size_028, random_029, cont){return cont(8);}
		               function f$24(size_026, random_027, cont){return cont(7);}
		               function f$25(size_024, random_025, cont){return cont(6);}
		               function f$26(size_022, random_023, cont){return cont(5);}
		               function f$27(size_020, random_021, cont){return cont(4);}
		               function f$28(size_018, random_019, cont){return cont(3);}
		               function f$29(size_016, random_017, cont){return cont(2);}
		               function f$30(size_014, random_015, cont){return cont(1);}
		               function f$31(size_012, random_013, cont){return cont(0);}
		               caml_callback
		                (weighted_union,
		                 [[0,
		                   [0, 1., f$31],
		                   [0,
		                    [0, 1., f$30],
		                    [0,
		                     [0, 1., f$29],
		                     [0,
		                      [0, 1., f$28],
		                      [0,
		                       [0, 1., f$27],
		                       [0,
		                        [0, 1., f$26],
		                        [0,
		                         [0, 1., f$25],
		                         [0,
		                          [0, 1., f$24],
		                          [0,
		                           [0, 1., f$23],
		                           [0,
		                            [0, 1., f$22],
		                            [0, [0, 1., f$21], [0, [0, 1., f$20], 0]]]]]]]]]]]]]);
		               function of_int_exn$4(i, cont){
		                var switcher = i - 1 | 0;
		                if(11 >= switcher >>> 0)
		                 switch(switcher){
		                   case 0:
		                    return cont(0);
		                   case 1:
		                    return cont(1);
		                   case 2:
		                    return cont(2);
		                   case 3:
		                    return cont(3);
		                   case 4:
		                    return cont(4);
		                   case 5:
		                    return cont(5);
		                   case 6:
		                    return cont(6);
		                   case 7:
		                    return cont(7);
		                   case 8:
		                    return cont(8);
		                   case 9:
		                    return cont(9);
		                   case 10:
		                    return cont(10);
		                   default: return cont(11);
		                 }
		                return caml_exact_trampoline_cps_call
		                        (failwithf,
		                         aEK,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, i, 0, cont);
		                         });
		               }
		               function to_int$6(t, cont){
		                switch(t){
		                  case 0:
		                   return cont(1);
		                  case 1:
		                   return cont(2);
		                  case 2:
		                   return cont(3);
		                  case 3:
		                   return cont(4);
		                  case 4:
		                   return cont(5);
		                  case 5:
		                   return cont(6);
		                  case 6:
		                   return cont(7);
		                  case 7:
		                   return cont(8);
		                  case 8:
		                   return cont(9);
		                  case 9:
		                   return cont(10);
		                  case 10:
		                   return cont(11);
		                  default: return cont(12);
		                }
		               }
		               var
		                include$316 = Of_binable_without_uuid([0, bin_shape_t$27]),
		                bin_shape_t$18 = include$316[5],
		                include$125 = make$2(compare$153, sexp_of_t$74),
		                comparator$50 = include$125[1];
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$18,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$153,
		                   sexp_of_t$74,
		                   to_int$6]]);
		               caml_callback
		                (cl,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$18,
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_t$74,
		                   comparator$50]]);
		               var
		                all_strings =
		                  [246,
		                   function(param, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (map$7,
		                             all$9,
		                             function(variant, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (sexp_of_t$74,
		                                       variant,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (to_string_mach, a, cont);
		                                       });
		                             },
		                             function(a){
		                              return caml_exact_trampoline_cps_call(to_array, a, cont);
		                             });
		                   }],
		                table$0 =
		                  [246,
		                   function(param, cont){
		                    return caml_exact_trampoline_cps_call$0
		                            (Table$0[5],
		                             0,
		                             [0, 12],
		                             dummy,
		                             function(table){
		                              var a = caml_obj_tag(all_strings);
		                              function b(t){
		                               var a = t.length - 2 | 0;
		                               function c(i){
		                                var s = t[i + 1];
		                                return caml_exact_trampoline_cps_call
		(of_int_exn$4,
		 i + 1 | 0,
		 function(t){
		  return caml_exact_trampoline_cps_call$0
		          (set$4,
		           table,
		           s,
		           t,
		           function(d){
		            return caml_exact_trampoline_cps_call
		                    (lowercase_ascii$0,
		                     s,
		                     function(d){
		                      return caml_exact_trampoline_cps_call$0
		                              (set$4,
		                               table,
		                               d,
		                               t,
		                               function(d){
		                                return caml_exact_trampoline_cps_call$0
		(set$4,
		 table,
		 uppercase_ascii$0(s),
		 t,
		 function(d){
		  d = i + 1 | 0;
		  return a !== i ? caml_exact_trampoline_call1(c, d) : b();
		 });
		                               });
		                     });
		           });
		 });
		                               }
		                               function b(){return cont(table);}
		                               return a < 0 ? b() : c(0);
		                              }
		                              if(250 === a) return b(all_strings[1]);
		                              if(246 !== a && 244 !== a) return b(all_strings);
		                              return caml_exact_trampoline_cps_call
		                                      (force_lazy_block, all_strings, b);
		                             });
		                   }];
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Date0";
		               record_start(d);
		               set$7(cst_core);
		               function hash$34(x, cont){return cont(hash_int(x));}
		               bX([0, "core/src/date0.ml.Stable.V1.Without_comparable.T.t"]);
		               function create0(year, month, day, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_int$6,
		                         month,
		                         function(a){return cont(year << 16 | a << 8 | day);});
		               }
		               function month$0(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int_exn$4, (t >>> 8 | 0) & 255, cont);
		               }
		               function create_exn(year, month, day, cont){
		                function invalid(year, month, day, msg, cont){
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          [0,
		                           [11,
		                            "Date.create_exn ~y:",
		                            [4,
		                             0,
		                             0,
		                             0,
		                             [11,
		                              " ~m:",
		                              [24,
		                               aEN,
		                               function(a, custom_printf_005, cont){
		                                a = caml_obj_tag(all_strings);
		                                function b(all_strings){
		                                 return caml_exact_trampoline_cps_call
		 (to_int$6,
		  custom_printf_005,
		  function(a){
		   a = a - 1 | 0;
		   return cont(caml_check_bound(all_strings, a)[a + 1]);
		  });
		                                }
		                                if(250 === a) return b(all_strings[1]);
		                                if(246 !== a && 244 !== a) return b(all_strings);
		                                return caml_exact_trampoline_cps_call
		(force_lazy_block, all_strings, b);
		                               },
		                               aEM]]]]],
		                          function(a){
		                           return caml_trampoline_cps_call6
		                                   (a, year, month, day, msg, 0, cont);
		                          });
		                }
		                var a = year < 0, a = a || 9999 < year;
		                function b(b){
		                 function a(a){
		                  switch(month){
		                    case 1:
		                     a = (year % 4 | 0) === 0;
		                     a = a ? 1 - ((year % 100 | 0) === 0) : a;
		                     a ||= (year % 400 | 0) === 0;
		                     var days_in_month = a ? 29 : 28;
		                     break;
		                    case 3:
		                    case 5:
		                    case 8:
		                    case 10:
		                     days_in_month = 30; break;
		                    default: days_in_month = 31;
		                  }
		                  function b(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (create0, year, month, day, cont);
		                  }
		                  return days_in_month < day
		                          ? caml_exact_trampoline_cps_call
		                            (sprintf,
		                             aEO,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (a,
		                                       days_in_month,
		                                       function(a){
		return caml_exact_trampoline_cps_call$2
		        (invalid, year, month, day, a, b);
		                                       });
		                             })
		                          : b();
		                 }
		                 return day <= 0
		                         ? caml_exact_trampoline_cps_call$2
		                           (invalid, year, month, day, "day <= 0", a)
		                         : a(0);
		                }
		                return a
		                        ? caml_exact_trampoline_cps_call$2
		                          (invalid, year, month, day, "year outside of [0..9999]", b)
		                        : b();
		               }
		               function to_string_iso8601_extended(t, cont){
		                var
		                 bytes = caml_create_bytes(10),
		                 int = t >>> 16 | 0,
		                 pos = 0;
		                return caml_exact_trampoline_cps_call$7
		                        (check_write,
		                         "write_4_digit_int",
		                         bytes,
		                         pos,
		                         4,
		                         9999,
		                         int,
		                         function(a){
		                          write_4_digit_int(bytes, pos, int);
		                          caml_bytes_set(bytes, 4, 45);
		                          return caml_exact_trampoline_cps_call
		                                  (month$0,
		                                   t,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (to_int$6,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$0
		              (write_2_digit_int$0,
		               bytes,
		               5,
		               a,
		               function(a){
		                caml_bytes_set(bytes, 7, 45);
		                return caml_exact_trampoline_cps_call$0
		                        (write_2_digit_int$0,
		                         bytes,
		                         8,
		                         t & 255,
		                         function(a){return cont(caml_string_of_bytes(bytes));});
		               });
		     });
		                                   });
		                         });
		               }
		               function parse_year4(string, pos, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (check_read,
		                         "read_4_digit_int",
		                         string,
		                         pos,
		                         4,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (read_1_digit_int,
		                                   string,
		                                   pos + 3 | 0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (read_1_digit_int,
		     string,
		     pos + 2 | 0,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (read_2_digit_int,
		               string,
		               pos,
		               function(c){
		                return cont((((c * 10 | 0) + b | 0) * 10 | 0) + a | 0);
		               });
		     });
		                                   });
		                         });
		               }
		               function of_string$51(str, cont){
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call
		                           (to_string$1,
		                            exn,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (invalid_argf,
		                                      aEP,
		                                      function(b){
		                                       return caml_trampoline_cps_call4(b, str, a, 0, cont);
		                                      });
		                            });
		                  });
		                function invalid(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (failwith, cst_invalid_date + str, cont);
		                }
		                function ensure(b, cont){
		                 var a = 1 - b;
		                 return a
		                         ? caml_exact_trampoline_cps_call(invalid, dummy, cont)
		                         : cont(a);
		                }
		                function month_num(year, month, day, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (read_2_digit_int$0,
		                          str,
		                          day,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (read_2_digit_int$0,
		                                    str,
		                                    month,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (of_int_exn$4,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (parse_year4,
		                str,
		                year,
		                function(c){
		                 return caml_exact_trampoline_cps_call$0
		                         (create_exn, c, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                function month_abrv(year, month, day, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (read_2_digit_int$0,
		                          str,
		                          day,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (sub_fun,
		                                    str,
		                                    month,
		                                    3,
		                                    function(str$0){
		                                     var b = caml_obj_tag(table$0);
		                                     function c(t){
		                                      return caml_exact_trampoline_cps_call$2
		      (find_and_call$0,
		       t,
		       str$0,
		       if_found,
		       if_not_found$0,
		       function(match){
		        function b(b){
		         return caml_exact_trampoline_cps_call$1
		                 (parse_year4,
		                  str,
		                  year,
		                  function(c){
		                   return caml_exact_trampoline_cps_call$0
		                           (create_exn, c, b, a, cont);
		                  });
		        }
		        if(match){var x = match[1]; return b(x);}
		        return caml_exact_trampoline_cps_call
		                (failwithf,
		                 aEL,
		                 function(a){
		                  return caml_trampoline_cps_call3(a, str$0, 0, b);
		                 });
		       });
		                                     }
		                                     if(250 === b) return c(table$0[1]);
		                                     if(246 !== b && 244 !== b) return c(table$0);
		                                     return caml_exact_trampoline_cps_call
		     (force_lazy_block, table$0, c);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (contains$0,
		                         0,
		                         0,
		                         str,
		                         47,
		                         function(b){
		                          function a(a){caml_pop_trap(); return cont(a);}
		                          return b
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (split$0,
		                                     str,
		                                     47,
		                                     function(match){
		                                      function f(y, m, d){
		                                       return caml_exact_trampoline_cps_call
		       (of_string$3,
		        y,
		        function(year){
		         var
		          year$0 =
		            100 <= year
		             ? year
		             : year < 75 ? 2000 + year | 0 : 1900 + year | 0;
		         return caml_exact_trampoline_cps_call
		                 (of_string$3,
		                  m,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (of_int_exn$4,
		                            b,
		                            function(month){
		                             return caml_exact_trampoline_cps_call
		                                     (of_string$3,
		                                      d,
		                                      function(day){
		                                       return caml_exact_trampoline_cps_call$0
		       (create_exn, year$0, month, day, a);
		                                      });
		                            });
		                  });
		        });
		                                      }
		                                      if(match){
		                                       var d = match[2];
		                                       if(d){
		var e = d[2];
		if(e && ! e[2]){
		 var c = e[1], b = d[1], a$0 = match[1];
		 return caml_ml_string_length(a$0) === 4
		         ? f(a$0, b, c)
		         : f(c, a$0, b);
		}
		                                       }
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (invalid,
		       dummy,
		       function(a){
		        var d = a[3], m = a[2], y = a[1];
		        return f(y, m, d);
		       });
		                                     })
		                                  : caml_exact_trampoline_cps_call$2
		                                    (contains$0,
		                                     0,
		                                     0,
		                                     str,
		                                     45,
		                                     function(b){
		                                      if(! b)
		                                       return caml_exact_trampoline_cps_call$2
		       (contains$0,
		        0,
		        0,
		        str,
		        32,
		        function(b){
		         if(! b)
		          return caml_ml_string_length(str) === 9
		                  ? caml_exact_trampoline_cps_call$0(month_abrv, 5, 2, 0, a)
		                  : caml_ml_string_length
		                     (str)
		                    === 8
		                    ? caml_exact_trampoline_cps_call$0(month_num, 0, 4, 6, a)
		                    : caml_exact_trampoline_cps_call(invalid, dummy, a);
		         if(caml_ml_string_length(str) === 11){
		          var x = caml_string_get(str, 2);
		          if(x === 32){
		           var x$0 = caml_string_get(str, 6);
		           if(x$0 === 32)
		            return caml_exact_trampoline_cps_call$0
		                    (month_abrv, 7, 3, 0, a);
		          }
		         }
		         b = caml_ml_string_length(str) === 11 ? 1 : 0;
		         if(b){
		          var x$1 = caml_string_get(str, 4), b = x$1 === 32 ? 1 : 0;
		          if(b)
		           var x$2 = caml_string_get(str, 8), b = x$2 === 32 ? 1 : 0;
		         }
		         return caml_exact_trampoline_cps_call
		                 (ensure,
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (month_abrv, 0, 5, 9, a);
		                  });
		        });
		                                      b = caml_ml_string_length(str) === 10 ? 1 : 0;
		                                      if(b){
		                                       var x = caml_string_get(str, 4), b = x === 45 ? 1 : 0;
		                                       if(b)
		var x$0 = caml_string_get(str, 7), b = x$0 === 45 ? 1 : 0;
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (ensure,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$0
		                (month_num, 0, 5, 8, a);
		       });
		                                     });
		                         });
		               }
		               function sexp_of_t$75(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string_iso8601_extended,
		                         t,
		                         function(a){return cont([0, a]);});
		               }
		               var
		                include$126 = make$2(compare_int, sexp_of_t$75),
		                comparator$51 = include$126[1],
		                bin_shape_t$48 =
		                  [1, "899ee3e0-490a-11e6-a10a-a3734f733566", 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$48, , , , , , sexp_of_t$75]]);
		               caml_callback
		                (Make$21,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$48,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare_int,
		                   sexp_of_t$75,
		                   hash$34]]);
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$48]]);
		               caml_callback
		                (create$25,
		                 ["core/src/date0.ml:291:6",
		                  [0, [0, cst_t, 0, bin_shape_int], 0]]);
		               bX([0, "core/src/date0.ml.Stable.Option.V1.t"]);
		               function sexp_of_t$76(t, cont){
		                var a = 1 - (t === 0) ? [0, t] : 0;
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_option, sexp_of_t$75, a, cont);
		               }
		               var
		                C$0 =
		                  caml_callback
		                   (cl,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      bin_shape_t$48,
		                      ,
		                      ,
		                      ,
		                      ,
		                      sexp_of_t$75,
		                      comparator$51]]),
		                symbol$213 = C$0[4];
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$48]]);
		               function compare$154(a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$48,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$154,
		                   sexp_of_t$75,
		                   hash$34]]);
		               var unix_epoch = caml_callback(create_exn, [1970, 0, 1]);
		               function of_year(y){
		                return (((365 * y | 0) + (y / 4 | 0) | 0) - (y / 100 | 0) | 0)
		                       + (y / 400 | 0)
		                       | 0;
		               }
		               function of_date$5(date, cont){
		                return caml_exact_trampoline_cps_call
		                        (month$0,
		                         date,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_int$6,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$23,
		     a + 9 | 0,
		     12,
		     function(m){
		      var y = (date >>> 16 | 0) - (m / 10 | 0) | 0;
		      return cont
		              ((of_year(y) + (((m * 306 | 0) + 5 | 0) / 10 | 0) | 0)
		               + ((date & 255) - 1 | 0)
		               | 0);
		     });
		                                   });
		                         });
		               }
		               var
		                c_10_000 = caml_callback(of_int$2, [10000]),
		                c_14_780 = caml_callback(of_int$2, [14780]),
		                c_3_652_425 = caml_callback(of_int$2, [3652425]);
		               function to_date$4(days, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int$2,
		                         days,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_int_exn$0,
		                                   symbol$55
		                                    (symbol$51(symbol$53(c_10_000, a), c_14_780), c_3_652_425),
		                                   function(y){
		                                    var ddd = days - of_year(y) | 0;
		                                    if(ddd < 0)
		                                     var
		                                      y$0 = y - 1 | 0,
		                                      ddd$0 = days - of_year(y$0) | 0,
		                                      y$1 = y$0;
		                                    else {ddd$0 = ddd; y$1 = y;}
		                                    var
		                                     mi = ((100 * ddd$0 | 0) + 52 | 0) / 3060 | 0,
		                                     y$2 = y$1 + ((mi + 2 | 0) / 12 | 0) | 0;
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$23,
		     mi + 2 | 0,
		     12,
		     function(a){
		      var
		       m = a + 1 | 0,
		       d =
		         (ddd$0 - (((mi * 306 | 0) + 5 | 0) / 10 | 0) | 0) + 1 | 0;
		      return caml_exact_trampoline_cps_call
		              (of_int_exn$4,
		               m,
		               function(a){
		                return caml_exact_trampoline_cps_call$0
		                        (create_exn, y$2, a, d, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var unix_epoch$0 = caml_callback(of_date$5, [unix_epoch]);
		               function add_days$0(t, days, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_date$5,
		                         t,
		                         function(t){
		                          return caml_exact_trampoline_cps_call
		                                  (to_date$4, t + days | 0, cont);
		                         });
		               }
		               var
		                t1$1 = caml_callback(of_string$51, ["2100-01-01"]),
		                t2$1 = caml_callback(of_string$51, ["1900-01-01"]);
		               if(caml_callback(symbol$213, [t2$1, t1$1])){
		                j =
		                 [0,
		                  [1, [0, aEQ, [0, caml_callback(sexp_of_t$75, [t1$1]), 0]]],
		                  0];
		                caml_callback
		                 (raise_s,
		                  [[1,
		                    [0,
		                     [0, "Date.gen_uniform_incl: bounds are crossed"],
		                     [0,
		                      [1, [0, aER, [0, caml_callback(sexp_of_t$75, [t2$1]), 0]]],
		                      j]]]]);
		               }
		               var
		                t2$0 = caml_callback(of_date$5, [t2$1]),
		                t1$0 = caml_callback(of_date$5, [t1$1]),
		                j =
		                  [0,
		                   [0,
		                    18.,
		                    caml_callback
		                     (map$37,
		                      [int_uniform_inclusive(0, t1$0 - t2$0 | 0),
		                       function(days, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (add_days$0, t2$1, days, cont);
		                       }])],
		                   0],
		                j = [0, [0, 1., caml_callback(return$23, [t1$1])], j],
		                quickcheck_generator$2 =
		                  caml_callback
		                   (weighted_union,
		                    [[0, [0, 1., caml_callback(return$23, [t2$1])], j]]);
		               caml_callback
		                (quickcheck_generator_option, [quickcheck_generator$2]);
		               Make_plain([0, compare_int, sexp_of_t$76]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Ofday_helpers";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Stable_internal";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Float_with_finite_only_serialization";
		               record_start(d);
		               set$7(cst_core);
		               var
		                Nan_or_inf =
		                  [248,
		                   "Core__Float_with_finite_only_serialization.Stable.V1.Nan_or_inf",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Nan_or_inf,
		                  function(param, a){
		                   if(param === Nan_or_inf) return a(aES);
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aET], 1));
		                  }]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Percent";
		               record_start(d);
		               set$7(cst_core);
		               bX([0, "core/src/percent.ml.Stable.V3.t"]);
		               function shift_decimal_point(s, by, cont){
		                function a(s){
		                 return by === 0
		                         ? cont(s)
		                         : caml_exact_trampoline_cps_call$1
		                           (lstrip,
		                            0,
		                            s,
		                            function(s){
		                             var f = caml_ml_string_length(s) - 1 | 0;
		                             function h(d, e$0, not_zero, underscore){
		                              var zero = 1 - not_zero;
		                              if(underscore)
		                               return caml_exact_trampoline_cps_call$1
		                                       (filter$1, s, function(c){return c !== 95 ? 1 : 0;}, a);
		                              if(zero) return cont(s);
		                              if(e$0){
		                               var e = e$0[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (drop_prefix,
		s,
		e + 1 | 0,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (of_string$3,
		          a,
		          function(exp){
		           var exp$0 = exp + by | 0;
		           if(exp$0 === 0)
		            return caml_exact_trampoline_cps_call$1(prefix, s, e, cont);
		           var
		            a = [0, "" + exp$0, 0],
		            b = 0 < exp$0 ? cst$32 : cst$1,
		            c = [0, b, a];
		           return caml_exact_trampoline_cps_call$1
		                   (prefix,
		                    s,
		                    e + 1 | 0,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1
		                             (concat$0, 0, [0, a, c], cont);
		                    });
		          });
		});
		                              }
		                              var x = caml_string_get(s, 0), neg = x === 45;
		                              if(neg)
		                               var signed = neg;
		                              else
		                               var x$0 = caml_string_get(s, 0), signed = x$0 === 43;
		                              function b(s){
		                               function a(s, by){
		                                var len = caml_ml_string_length(s);
		                                return caml_exact_trampoline_cps_call$1
		(rstrip,
		 [0, function(y, cont){return cont(48 === y ? 1 : 0);}],
		 s,
		 function(s1){
		  var
		   by$0 = (by + len | 0) - caml_ml_string_length(s1) | 0,
		   len$0 = caml_ml_string_length(s1);
		  function a(s2){
		   if(! signed) return cont(s2);
		   var s1 = neg ? cst$33 : cst$32;
		   return cont(s1 + s2);
		  }
		  if(by$0 === 0) return a(s1);
		  if(0 < by$0){var s2 = make$0(by$0, 48); return a(s1 + s2);}
		  if((- len$0 | 0) >= by$0)
		   return caml_exact_trampoline_cps_call$1
		           (concat$0,
		            0,
		            [0,
		             "0.",
		             [0, make$0((- by$0 | 0) - len$0 | 0, 48), [0, s1, 0]]],
		            a);
		  return caml_exact_trampoline_cps_call$1
		          (suffix,
		           s1,
		           - by$0 | 0,
		           function(c){
		            var b = [0, cst$14, [0, c, 0]];
		            return caml_exact_trampoline_cps_call$1
		                    (drop_suffix,
		                     s1,
		                     - by$0 | 0,
		                     function(c){
		                      return caml_exact_trampoline_cps_call$1
		                              (concat$0, 0, [0, c, b], a);
		                     });
		           });
		 });
		                               }
		                               if(! d) return a(s, by);
		                               var d$0 = d[1], b = signed ? 1 : 0, d$1 = d$0 - b | 0;
		                               return caml_exact_trampoline_cps_call$1
		                                       (drop_prefix,
		s,
		d$1 + 1 | 0,
		function(suf){
		 return caml_exact_trampoline_cps_call$1
		         (prefix,
		          s,
		          d$1,
		          function(pref){
		           return caml_exact_trampoline_cps_call$1
		                   (lstrip,
		                    [0, function(y, cont){return cont(48 === y ? 1 : 0);}],
		                    pref + suf,
		                    function(s){
		                     var by$0 = by - caml_ml_string_length(suf) | 0;
		                     return a(s, by$0);
		                    });
		          });
		});
		                              }
		                              return signed
		                                      ? caml_exact_trampoline_cps_call$1(drop_prefix, s, 1, b)
		                                      : b(s);
		                             }
		                             function g(d, e, not_zero, underscore, i){
		                              var c = caml_string_get(s, i);
		                              function a(d, e, not_zero, underscore){
		                               var a = i + 1 | 0;
		                               return f !== i
		                                       ? caml_exact_trampoline_call5
		 (g, d, e, not_zero, underscore, a)
		                                       : h(d, e, not_zero, underscore);
		                              }
		                              if(95 === c) return a(d, e, not_zero, 1);
		                              a:
		                              {
		                               if(70 <= c){
		                                if(101 !== c) break a;
		                               }
		                               else {
		                                if(43 > c) break a;
		                                switch(c - 43 | 0){
		                                  case 3:
		                                   var
		                                    b = function(b){return a([0, i], e, not_zero, underscore);};
		                                   if(! is_some(d)) return b(0);
		                                   return caml_exact_trampoline_cps_call
		   (failwithf,
		    aEW,
		    function(a){return caml_trampoline_cps_call3(a, s, 0, b);});
		                                  case 26: break;
		                                  case 0:
		                                  case 2:
		                                  case 5:
		                                   return a(d, e, not_zero, underscore);
		                                  case 6:
		                                  case 7:
		                                  case 8:
		                                  case 9:
		                                  case 10:
		                                  case 11:
		                                  case 12:
		                                  case 13:
		                                  case 14:
		                                   return is_none$0(e)
		   ? a(d, e, 1, underscore)
		   : a(d, e, not_zero, underscore);
		                                  default: break a;
		                                }
		                               }
		                               var
		                                j = function(b){return a(d, [0, i], not_zero, underscore);};
		                               if(! is_some(e)) return j(0);
		                               return caml_exact_trampoline_cps_call
		                                       (failwithf,
		aEU,
		function(a){return caml_trampoline_cps_call3(a, s, 0, j);});
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (failwithf,
		                                       aEV,
		                                       function(b){
		return caml_trampoline_cps_call4
		        (b,
		         c,
		         s,
		         0,
		         function(b){return a(d, e, not_zero, underscore);});
		                                       });
		                             }
		                             var b = 0, c = 0, d = 0, e = 0;
		                             return f < 0 ? h(b, c, d, e) : g(b, c, d, e, 0);
		                            });
		                }
		                return a(s);
		               }
		               var cst$39 = "%", cst_bp = "bp";
		               function to_string_round_trippable(x, cont){
		                var x_abs = Math.abs(x);
		                if(x_abs === 0.) return cont(cst_0x);
		                var
		                 y = caml_format_float(cst_15G, x),
		                 s1 =
		                   caml_float_of_string(y) === x
		                    ? y
		                    : caml_format_float(cst_17G, x);
		                if(x === x && ! is_inf(x) && ! (1. <= x_abs))
		                 return 0.01 <= x_abs
		                         ? caml_exact_trampoline_cps_call$1
		                           (shift_decimal_point,
		                            s1,
		                            2,
		                            function(s1){return cont(s1 + cst$39);})
		                         : caml_exact_trampoline_cps_call$1
		                           (shift_decimal_point,
		                            s1,
		                            4,
		                            function(s1){return cont(s1 + cst_bp);});
		                return cont(s1 + cst_x);
		               }
		               var
		                sexp_of_t$77 = V1$0([0, , to_string_round_trippable])[3],
		                bin_shape_t$50 =
		                  [1,
		                   "b32f2a1e-6b43-11ed-b33b-aac2a563f10a",
		                   [0, bin_shape_t$32, 0]],
		                group$56 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/percent.ml:340:6",
		                     [0, [0, cst_t, 0, bin_shape_t$50], 0]]),
		                include$127 =
		                  caml_callback
		                   (bPR,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      [8, group$56, cst_t, 0],
		                      ,
		                      ,
		                      ,
		                      compare_float,
		                      ,
		                      sexp_of_t$77]]),
		                comparator$52 = include$127[20],
		                group$57 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/percent.ml:344:6",
		                     [0, [0, cst_t, 0, bin_shape_t$50], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$57, cst_t, 0]]]);
		               caml_callback
		                (create$25,
		                 ["core/src/percent.ml:348:6",
		                  [0, [0, cst_t, 0, bin_shape_t$50], 0]]);
		               bX([0, "core/src/percent.ml.Stable.V2.t"]);
		               function to_string$65(x, cont){
		                var x_abs = Math.abs(x);
		                function string(float, cont){
		                 return caml_exact_trampoline_cps_call
		                         (sprintf,
		                          aEX,
		                          function(a){
		                           return caml_trampoline_cps_call2(a, float, cont);
		                          });
		                }
		                return x_abs === 0.
		                        ? cont(cst_0x)
		                        : 1.
		                          <= x_abs
		                          ? caml_exact_trampoline_cps_call
		                            (string, x * 1., function(s1){return cont(s1 + cst_x);})
		                          : 0.01
		                            <= x_abs
		                            ? caml_exact_trampoline_cps_call
		                              (string, x * 100., function(s1){return cont(s1 + cst$39);})
		                            : caml_exact_trampoline_cps_call
		                              (string,
		                               x * 10000.,
		                               function(s1){return cont(s1 + cst_bp);});
		               }
		               var
		                sexp_of_t$78 = V1$0([0, , to_string$65])[3],
		                bin_shape_t$49 =
		                  [1,
		                   "1d1e76bc-ea4b-11eb-a16a-aa5b28d1f4d7",
		                   [0, bin_shape_t$32, 0]],
		                group$58 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/percent.ml:495:6",
		                     [0, [0, cst_t, 0, bin_shape_t$49], 0]]);
		               caml_callback
		                (cl,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [8, group$58, cst_t, 0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_t$78,
		                   comparator$52]]);
		               var
		                group$59 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/percent.ml:502:6",
		                     [0, [0, cst_t, 0, bin_shape_t$49], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$59, cst_t, 0]]]);
		               var
		                group$60 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/percent.ml:515:8",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               caml_callback
		                (cl,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [8, group$60, cst_t, 0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_t$78,
		                   comparator$52]]);
		               var
		                group$61 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/percent.ml:532:8",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$61, cst_t, 0]]]);
		               caml_callback
		                (create$25,
		                 ["core/src/percent.ml:568:6",
		                  [0, [0, cst_t, 0, bin_shape_t$50], 0]]);
		               bX([0, "core/src/percent.ml.Stable.Option.V3.t"]);
		               caml_callback
		                (create$25,
		                 ["core/src/percent.ml:584:6",
		                  [0, [0, cst_t, 0, bin_shape_t$49], 0]]);
		               bX([0, "core/src/percent.ml.Stable.Option.V2.t"]);
		               var
		                group$62 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/percent.ml:674:2",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/percent.ml:682:4",
		                  [0, [0, cst_t, 0, [8, group$62, cst_t, 0]], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Span_helpers";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Span_float";
		               record_start(d);
		               set$7(cst_core);
		               function next$3(t){return one_ulp(19067, t);}
		               function prev(t){return one_ulp(759637122, t);}
		               function to_span_since_epoch(x, cont){return cont(x);}
		               function divide_by_unit_of_time(t, unit_of_time){
		                switch(unit_of_time){
		                  case 0:
		                   return t * 1000000000.;
		                  case 1:
		                   return t * 1000000.;
		                  case 2:
		                   return t * 1000.;
		                  case 3:
		                   return t;
		                  case 4:
		                   return t / 60.;
		                  case 5:
		                   return t / 3600.;
		                  default: return t / 86400.;
		                }
		               }
		               function scale_by_unit_of_time(float, unit_of_time){
		                switch(unit_of_time){
		                  case 0:
		                   var x$4 = float / 1000000000.; return x$4;
		                  case 1:
		                   var x$3 = float / 1000000.; return x$3;
		                  case 2:
		                   var x$2 = float / 1000.; return x$2;
		                  case 3:
		                   return float;
		                  case 4:
		                   var x$1 = float * 60.; return x$1;
		                  case 5:
		                   var x$0 = float * 3600.; return x$0;
		                  default: var x = float * 86400.; return x;
		                }
		               }
		               var
		                T_of_sexp =
		                  [248,
		                   "Core__Span_float.Stable.V1.T_of_sexp",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  T_of_sexp,
		                  function(a, cont){
		                   if(a[1] === T_of_sexp){
		                    var arg1_022 = a[3], arg0_021 = a[2];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_exn,
		                             arg1_022,
		                             function(res1_024){
		                              return cont([1, [0, aEY, [0, arg0_021, [0, res1_024, 0]]]]);
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aEZ], 1));
		                  }]);
		               var
		                T_of_sexp_expected_atom_but_go =
		                  [248,
		                   "Core__Span_float.Stable.V1.T_of_sexp_expected_atom_but_got",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  T_of_sexp_expected_atom_but_go,
		                  function(param, a){
		                   if(param[1] === T_of_sexp_expected_atom_but_go){
		                    var arg0_025 = param[2];
		                    return a([1, [0, aE0, [0, arg0_025, 0]]]);
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aE1], 1));
		                  }]);
		               var
		                group$63 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_float.ml:316:6",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$63, cst_t, 0]]]);
		               var
		                group$64 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_float.ml:327:6",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$64, cst_t, 0]]]);
		               function to_unit_of_time(t){
		                var abs_t = Math.abs(t);
		                return 86400. <= abs_t
		                        ? 6
		                        : 3600.
		                          <= abs_t
		                          ? 5
		                          : 60.
		                            <= abs_t
		                            ? 4
		                            : 1.
		                              <= abs_t
		                              ? 3
		                              : 0.001 <= abs_t ? 2 : 1e-6 <= abs_t ? 1 : 0;
		               }
		               var microsecond = 1e-6, day = 86400.;
		               function of_unit_of_time(param){
		                switch(param){
		                  case 0:
		                   return 1e-9;
		                  case 1:
		                   return microsecond;
		                  case 2:
		                   return 0.001;
		                  case 3:
		                   return 1.;
		                  case 4:
		                   return 60.;
		                  case 5:
		                   return 3600.;
		                  default: return day;
		                }
		               }
		               function suffix_of_unit_of_time(unit_of_time){
		                switch(unit_of_time){
		                  case 0:
		                   return cst_ns;
		                  case 1:
		                   return cst_us;
		                  case 2:
		                   return cst_ms;
		                  case 3:
		                   return cst_s$0;
		                  case 4:
		                   return cst_m;
		                  case 5:
		                   return cst_h$0;
		                  default: return cst_d$0;
		                }
		               }
		               function string_of_float_without_traili(float, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$10,
		                         float,
		                         function(string){
		                          var suffix = cst$14;
		                          return caml_exact_trampoline_cps_call$0
		                                  (is_suffix_gen,
		                                   string,
		                                   suffix,
		                                   equal$2,
		                                   function(a){
		                                    return a
		    ? caml_exact_trampoline_cps_call$1
		      (chop_suffix_exn, string, suffix, cont)
		    : cont(string);
		                                   });
		                         });
		               }
		               function sum$2(sum_t, unit_of_time, magnitude){
		                return sum_t + scale_by_unit_of_time(magnitude, unit_of_time);
		               }
		               var magnitude = 0.;
		               function to_float_string
		               (abs_t, unit_of_time, fixup_unit_of_time, cont){
		                var
		                 magnitude$0 = divide_by_unit_of_time(abs_t, unit_of_time),
		                 sum_t = sum$2(magnitude, unit_of_time, magnitude$0);
		                if(sum_t === abs_t){
		                 var s2 = suffix_of_unit_of_time(unit_of_time);
		                 return caml_exact_trampoline_cps_call
		                         (string_of_float_without_traili,
		                          magnitude$0,
		                          function(s1){return cont(s1 + s2);});
		                }
		                var
		                 magnitude$1 =
		                   sum_t < abs_t
		                    ? magnitude$0
		                    : divide_by_unit_of_time(prev(abs_t), unit_of_time),
		                 sum_t$0 = sum$2(magnitude, unit_of_time, magnitude$1),
		                 rem_t = abs_t - sum_t$0,
		                 fixup_magnitude =
		                   divide_by_unit_of_time(rem_t, fixup_unit_of_time),
		                 s2$0 = suffix_of_unit_of_time(fixup_unit_of_time);
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         aE2,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   fixup_magnitude,
		                                   function(s1){
		                                    var
		                                     s2$1 = s1 + s2$0,
		                                     s1$0 = suffix_of_unit_of_time(unit_of_time),
		                                     s2 = s1$0 + s2$1;
		                                    return caml_exact_trampoline_cps_call
		    (string_of_float_without_traili,
		     magnitude$1,
		     function(s1){return cont(s1 + s2);});
		                                   });
		                         });
		               }
		               function to_int_string_and_sum
		               (unit_of_time, abs_t, sum_t, cont){
		                var
		                 unit_span = of_unit_of_time(unit_of_time),
		                 rem_t = abs_t - sum_t,
		                 magnitude$0 = Math.floor(rem_t / unit_span),
		                 new_sum_t = sum$2(sum_t, unit_of_time, magnitude$0),
		                 new_rem_t = abs_t - new_sum_t;
		                if(new_rem_t === 0.)
		                 var magnitude = magnitude$0;
		                else if(new_rem_t < 0.)
		                 magnitude = magnitude$0 - 1.;
		                else
		                 var
		                  next_magnitude = magnitude$0 + 1.,
		                  next_sum_t = sum$2(sum_t, unit_of_time, next_magnitude),
		                  next_rem_t = abs_t - next_sum_t,
		                  magnitude = next_rem_t < 0. ? magnitude$0 : next_magnitude;
		                if(magnitude <= 0.) return cont([0, cst$1, sum_t]);
		                var
		                 new_sum_t$0 = sum$2(sum_t, unit_of_time, magnitude),
		                 s2 = suffix_of_unit_of_time(unit_of_time);
		                return caml_exact_trampoline_cps_call
		                        (of_float$2,
		                         magnitude,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_string$9,
		                                   a,
		                                   function(s1){
		                                    var string = s1 + s2;
		                                    return cont([0, string, new_sum_t$0]);
		                                   });
		                         });
		               }
		               function symbol$214(s1, s2){
		                return is_empty$0(s1) ? s2 : is_empty$0(s2) ? s1 : s1 + s2;
		               }
		               function to_string$66(float, cont){
		                if(! is_finite(float))
		                 return float !== float
		                         ? cont("NANs")
		                         : float < 0. ? cont("-INFs") : cont("INFs");
		                if(float === 0.) return cont(cst_0s);
		                var
		                 unit_of_time = to_unit_of_time(float),
		                 abs_t = Math.abs(float),
		                 sign = float < 0. ? cst$33 : cst$1;
		                function a(magnitude_string){
		                 return cont(symbol$214(sign, magnitude_string));
		                }
		                if(4 > unit_of_time)
		                 return caml_exact_trampoline_cps_call$0
		                         (to_float_string, abs_t, unit_of_time, 0, a);
		                if(6 <= unit_of_time && 86400. <= next$3(abs_t) - abs_t)
		                 return caml_exact_trampoline_cps_call$0
		                         (to_float_string, abs_t, unit_of_time, 6, a);
		                return caml_exact_trampoline_cps_call$0
		                        (to_int_string_and_sum,
		                         6,
		                         abs_t,
		                         magnitude,
		                         function(match){
		                          var sum_t = match[2], day_string = match[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (to_int_string_and_sum,
		                                   5,
		                                   abs_t,
		                                   sum_t,
		                                   function(match){
		                                    var sum_t = match[2], hour_string = match[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (to_int_string_and_sum,
		     4,
		     abs_t,
		     sum_t,
		     function(match){
		      var sum_t = match[2], minute_string = match[1];
		      function b(float_string){
		       return a
		               (symbol$214
		                 (day_string,
		                  symbol$214
		                   (hour_string, symbol$214(minute_string, float_string))));
		      }
		      if(abs_t <= sum_t) return b(cst$1);
		      var
		       rem_t = abs_t - sum_t,
		       unit_of_time = to_unit_of_time(rem_t),
		       unit_span = of_unit_of_time(unit_of_time),
		       magnitude = rem_t / unit_span,
		       new_sum_t = sum$2(sum_t, unit_of_time, magnitude),
		       new_rem_t = abs_t - new_sum_t;
		      return Math.abs(rem_t) <= Math.abs(new_rem_t)
		              ? b(cst$1)
		              : caml_exact_trampoline_cps_call
		                (iround_down_exn,
		                 caml_log10_float(rem_t),
		                 function(order_of_magnitude_of_first_di){
		                  var t = abs_t - prev(abs_t), half_ulp = t / 2.;
		                  return caml_exact_trampoline_cps_call
		                          (iround_up_exn,
		                           caml_log10_float(half_ulp),
		                           function(i){
		                            var
		                             order_of_magnitude_of_final_di = i - 1 | 0,
		                             number_of_digits =
		                               (1 + order_of_magnitude_of_first_di | 0)
		                               - order_of_magnitude_of_final_di
		                               | 0,
		                             suffix = suffix_of_unit_of_time(unit_of_time);
		                            return caml_exact_trampoline_cps_call
		                                    (sprintf,
		                                     aE3,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (a,
		       number_of_digits,
		       magnitude,
		       function(s1){return b(s1 + suffix);});
		                                     });
		                           });
		                 });
		     });
		                                   });
		                         });
		               }
		               function sexp_of_t$79(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$66, t, function(a){return cont([0, a]);});
		               }
		               var
		                group$65 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_float.ml:716:6",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$65, cst_t, 0]]]);
		               function gen_incl(lo, hi, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (float_inclusive,
		                         lo,
		                         hi,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$37, a, to_span_since_epoch, cont);
		                         });
		               }
		               var
		                group$66 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_float.ml:783:2",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               function hash$35(x, cont){
		                return caml_exact_trampoline_cps_call(hash$30, x, cont);
		               }
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [8, group$66, cst_t, 0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$149,
		                   sexp_of_t$79,
		                   hash$35]]);
		               var
		                group$67 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_float.ml:796:2",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]),
		                bin_shape_t$35 = [8, group$67, cst_t, 0];
		               caml_callback
		                (bPj, [[0, , , , , bin_shape_t$35, , , , , sexp_of_t$79]]);
		               caml_callback(bPk, [[0, , , , , bin_shape_t$35]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Ofday_float";
		               record_start(d);
		               set$7(cst_core);
		               function is_valid(t){
		                var a = 0. <= t ? 1 : 0;
		                return a ? t <= 86400. ? 1 : 0 : a;
		               }
		               function of_span_since_start_of_day_exn(span, cont){
		                var match = classify(span);
		                if(1 === match)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg,
		                          "Ofday.of_span_since_start_of_day_exn: NaN value",
		                          cont);
		                if(! match)
		                 return caml_exact_trampoline_cps_call
		                         (invalid_arg,
		                          "Ofday.of_span_since_start_of_day_exn: infinite value",
		                          cont);
		                if(is_valid(span)) return cont(span);
		                return caml_exact_trampoline_cps_call
		                        (invalid_argf,
		                         [0,
		                          [11,
		                           "Ofday out of range: ",
		                           [24,
		                            aE4,
		                            function(param, custom_printf_001, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (to_string$66, custom_printf_001, cont);
		                            },
		                            0]]],
		                         function(a){
		                          return caml_trampoline_cps_call3(a, span, 0, cont);
		                         });
		               }
		               var
		                start_of_next_day =
		                  caml_callback(of_span_since_start_of_day_exn, [day]);
		               function sub$3(t, span){
		                var t$0 = t - span;
		                return is_valid(t$0) ? [0, t$0] : 0;
		               }
		               function prev$0(t){
		                var candidate = one_ulp(759637122, t);
		                return is_valid(candidate) ? [0, candidate] : 0;
		               }
		               caml_callback
		                (value_exn, [0, 0, 0, sub$3(start_of_next_day, microsecond)]);
		               function to_string_gen(drop_ms, drop_us, trim, float_sec, cont){
		                var drop_us$0 = drop_ms ? drop_us : 1;
		                if(drop_us$0)
		                 return caml_exact_trampoline_cps_call
		                         (int63_round_nearest_portable_a,
		                          float_sec * 1000000.,
		                          function(us){
		                           return caml_exact_trampoline_cps_call
		                                   (of_int$2,
		                                    1000,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (to_int_exn$0,
		      rem$4(us, a),
		      function(us$0){
		       return caml_exact_trampoline_cps_call
		               (of_int$2,
		                1000,
		                function(a){
		                 var ms = symbol$55(us, a);
		                 return caml_exact_trampoline_cps_call
		                         (of_int$2,
		                          1000,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_int_exn$0,
		                                    rem$4(ms, a),
		                                    function(ms$0){
		                                     return caml_exact_trampoline_cps_call
		     (of_int$2,
		      1000,
		      function(a){
		       var sec = symbol$55(ms, a);
		       return caml_exact_trampoline_cps_call
		               (of_int$2,
		                60,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (to_int_exn$0,
		                          rem$4(sec, a),
		                          function(sec$0){
		                           return caml_exact_trampoline_cps_call
		                                   (of_int$2,
		                                    60,
		                                    function(a){
		                                     var min = symbol$55(sec, a);
		                                     return caml_exact_trampoline_cps_call
		     (of_int$2,
		      60,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (to_int_exn$0,
		                rem$4(min, a),
		                function(min$0){
		                 return caml_exact_trampoline_cps_call
		                         (of_int$2,
		                          60,
		                          function(a){
		                           var hr = symbol$55(min, a);
		                           return caml_exact_trampoline_cps_call
		                                   (to_int_exn$0,
		                                    hr,
		                                    function(hr){
		                                     var dont_print_us = drop_us || (trim ? us$0 === 0 : trim);
		                                     if(drop_ms)
		                                      var dont_print_ms = drop_ms;
		                                     else if(trim)
		                                      var a = ms$0 === 0, dont_print_ms = a ? dont_print_us : a;
		                                     else
		                                      dont_print_ms = trim;
		                                     if(trim){
		                                      a = sec$0 === 0;
		                                      var dont_print_s = a ? dont_print_ms : a;
		                                     }
		                                     else
		                                      dont_print_s = trim;
		                                     var
		                                      len =
		dont_print_s
		 ? 5
		 : dont_print_ms ? 8 : dont_print_us ? 12 : 15,
		                                      buf = caml_create_bytes(len);
		                                     return caml_exact_trampoline_cps_call$0
		     (write_2_digit_int$0,
		      buf,
		      0,
		      hr,
		      function(a){
		       caml_bytes_set(buf, 2, 58);
		       return caml_exact_trampoline_cps_call$0
		               (write_2_digit_int$0,
		                buf,
		                3,
		                min$0,
		                function(b){
		                 function a(a){return cont(caml_string_of_bytes(buf));}
		                 return dont_print_s
		                         ? a()
		                         : (caml_bytes_set
		                            (buf, 5, 58),
		                           caml_exact_trampoline_cps_call$0
		                            (write_2_digit_int$0,
		                             buf,
		                             6,
		                             sec$0,
		                             function(b){
		                              return dont_print_ms
		                                      ? a()
		                                      : (caml_bytes_set
		 (buf, 8, 46),
		caml_exact_trampoline_cps_call$0
		 (write_3_digit_int$0,
		  buf,
		  9,
		  ms$0,
		  function(b){
		   return dont_print_us
		           ? a()
		           : caml_exact_trampoline_cps_call$0
		             (write_3_digit_int$0, buf, 12, us$0, a);
		  }));
		                             }));
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                var raise = caml_pop_trap();
		                return raise
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aE5], 1));
		               }
		               function to_string$67(t, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (to_string_gen, 0, 0, 0, t, cont);
		               }
		               function sexp_of_t$80(span, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$67, span, function(a){return cont([0, a]);});
		               }
		               var
		                group$68 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/ofday_float.ml:257:6",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$68, cst_t, 0]]]);
		               function gen_incl$0(lo, hi, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (gen_incl, lo, hi, function(a){return cont();});
		               }
		               caml_callback(gen_incl$0, [0., start_of_next_day]);
		               var
		                group$69 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/ofday_float.ml:283:2",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               function hash$36(x, cont){
		                return caml_exact_trampoline_cps_call(hash$30, x, cont);
		               }
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [8, group$69, cst_t, 0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$149,
		                   sexp_of_t$80,
		                   hash$36]]);
		               var
		                group$70 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/ofday_float.ml:296:2",
		                     [0, [0, cst_t, 0, bin_shape_t$32], 0]]),
		                bin_shape_t$36 = [8, group$70, cst_t, 0];
		               caml_callback
		                (bPj, [[0, , , , , bin_shape_t$36, , , , , sexp_of_t$80]]);
		               caml_callback(bPk, [[0, , , , , bin_shape_t$36]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Time_intf";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Time";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Time_float0";
		               record_start(d);
		               set$7(cst_core);
		               caml_callback(of_int$2, [86400]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Time_float";
		               record_start(d);
		               set$7(cst_core);
		               caml_callback
		                (value_exn, [aE6, 0, 0, prev$0(start_of_next_day)]);
		               var
		                Time_of_string =
		                  [248,
		                   "Core__Time.Make(Time0).Time_of_string",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Time_of_string,
		                  function(a, cont){
		                   if(a[1] === Time_of_string){
		                    var arg1_002 = a[3], arg0_001 = a[2];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_string$0,
		                             arg0_001,
		                             function(res0_003){
		                              return caml_exact_trampoline_cps_call
		                                      (sexp_of_exn,
		                                       arg1_002,
		                                       function(res1_004){
		return cont([1, [0, aE7, [0, res0_003, [0, res1_004, 0]]]]);
		                                       });
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aE8], 1));
		                  }]);
		               caml_callback
		                (create$25,
		                 ["core/src/time_float.ml:25:6",
		                  [0, [0, cst_t, 0, bin_shape_t$32], 0]]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Span_ns";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$71 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:16:2",
		                     [0, [0, cst_t, 0, bin_shape_t$13], 0]]);
		               bX([0, "core/src/span_ns.ml.T.t"]);
		               var
		                nanosecond = caml_callback(of_int$2, [1]),
		                microsecond$0 =
		                  symbol$53(caml_callback(of_int$2, [1000]), nanosecond),
		                millisecond =
		                  symbol$53(caml_callback(of_int$2, [1000]), microsecond$0),
		                second =
		                  symbol$53(caml_callback(of_int$2, [1000]), millisecond),
		                minute = symbol$53(caml_callback(of_int$2, [60]), second),
		                hour = symbol$53(caml_callback(of_int$2, [60]), minute),
		                start_of_next_day$0 =
		                  symbol$53(caml_callback(of_int$2, [24]), hour),
		                float_microsecond = to_float$1(microsecond$0),
		                float_millisecond = to_float$1(millisecond),
		                float_second = to_float$1(second),
		                float_minute = to_float$1(minute),
		                float_hour = to_float$1(hour),
		                float_day = to_float$1(start_of_next_day$0),
		                j = caml_callback(of_int$2, [365]),
		                max_value_for_1us_rounding =
		                  symbol$53
		                   (symbol$53(caml_callback(of_int$2, [135]), j),
		                    start_of_next_day$0),
		                min_value_for_1us_rounding = neg(max_value_for_1us_rounding);
		               function of_int_sec(i, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int$2,
		                         i,
		                         function(a){return cont(symbol$53(a, second));});
		               }
		               function to_us(t){return to_float$1(t) / float_microsecond;}
		               function to_ms(t){return to_float$1(t) / float_millisecond;}
		               function to_sec(t){return to_float$1(t) / float_second;}
		               function to_min(t){return to_float$1(t) / float_minute;}
		               function to_hr(t){return to_float$1(t) / float_hour;}
		               function to_day(t){return to_float$1(t) / float_day;}
		               function to_int_sec(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_int_exn$0, symbol$55(t, second), cont);
		               }
		               function of_unit_of_time$0(u){
		                switch(u){
		                  case 0:
		                   return nanosecond;
		                  case 1:
		                   return microsecond$0;
		                  case 2:
		                   return millisecond;
		                  case 3:
		                   return second;
		                  case 4:
		                   return minute;
		                  case 5:
		                   return hour;
		                  default: return start_of_next_day$0;
		                }
		               }
		               function to_unit_of_time$0(t, cont){
		                var abs_t = abs$1(t);
		                return greater_equal$0(abs_t, start_of_next_day$0)
		                        ? cont(6)
		                        : greater_equal$0
		                           (abs_t, hour)
		                          ? cont(5)
		                          : greater_equal$0
		                             (abs_t, minute)
		                            ? cont(4)
		                            : greater_equal$0
		                               (abs_t, second)
		                              ? cont(3)
		                              : greater_equal$0
		                                 (abs_t, millisecond)
		                                ? cont(2)
		                                : greater_equal$0(abs_t, microsecond$0) ? cont(1) : cont(0);
		               }
		               var
		                bin_shape_t$37 = [8, group$71, cst_t, 0],
		                group$72 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:219:6",
		                     [0, [0, cst_t, 0, bin_shape_t$37], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$72, cst_t, 0]]]);
		               var
		                group$73 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:247:8",
		                     [0, [0, cst_t, 0, bin_shape_t$37], 0]]);
		               function number_of_digits_to_write(span_part_magnitude){
		                if(0 === span_part_magnitude) return 0;
		                if(10 > span_part_magnitude) return 1;
		                if(100 > span_part_magnitude) return 2;
		                if(1000 > span_part_magnitude) return 3;
		                if(10000 > span_part_magnitude) return 4;
		                if(100000 <= span_part_magnitude)
		                 throw caml_maybe_attach_backtrace
		                        ([0, Assert_failure, aE9], 1);
		                return 5;
		               }
		               function number_of_decimal_places_to_wr(billionths, cont){
		                if(0 <= billionths && 999999999 >= billionths)
		                 return 0 === billionths
		                         ? cont(0)
		                         : caml_exact_trampoline_cps_call$1
		                           (symbol$23,
		                            billionths,
		                            10,
		                            function(a){
		                             return 0 === a
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (symbol$23,
		billionths,
		100,
		function(a){
		 return 0 === a
		         ? caml_exact_trampoline_cps_call$1
		           (symbol$23,
		            billionths,
		            1000,
		            function(a){
		             return 0 === a
		                     ? caml_exact_trampoline_cps_call$1
		                       (symbol$23,
		                        billionths,
		                        10000,
		                        function(a){
		                         return 0 === a
		                                 ? caml_exact_trampoline_cps_call$1
		                                   (symbol$23,
		                                    billionths,
		                                    100000,
		                                    function(a){
		                                     return 0 === a
		     ? caml_exact_trampoline_cps_call$1
		       (symbol$23,
		        billionths,
		        1000000,
		        function(a){
		         return 0 === a
		                 ? caml_exact_trampoline_cps_call$1
		                   (symbol$23,
		                    billionths,
		                    10000000,
		                    function(a){
		                     return 0 === a
		                             ? caml_exact_trampoline_cps_call$1
		                               (symbol$23,
		                                billionths,
		                                100000000,
		                                function(a){return 0 === a ? cont(1) : cont(2);})
		                             : cont(3);
		                    })
		                 : cont(4);
		        })
		     : cont(5);
		                                    })
		                                 : cont(6);
		                        })
		                     : cont(7);
		            })
		         : cont(8);
		})
		                                     : cont(9);
		                            });
		                var raise = caml_pop_trap();
		                return raise
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aE_], 1));
		               }
		               function write_char(buf, pos, char){
		                caml_bytes_unsafe_set(buf, pos, char);
		                return pos + 1 | 0;
		               }
		               function write_2_chars(buf, pos, char1, char2){
		                caml_bytes_unsafe_set(buf, pos, char1);
		                caml_bytes_unsafe_set(buf, pos + 1 | 0, char2);
		                return pos + 2 | 0;
		               }
		               function write_digits(buf, pos, digits, int, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int$2,
		                         int,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (write_int63,
		                                   buf,
		                                   pos,
		                                   digits,
		                                   a,
		                                   function(a){return cont(pos + digits | 0);});
		                         });
		               }
		               function write_decimals(buf, pos, decimals, billionths, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (int_pow,
		                         10,
		                         9 - decimals | 0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_int$2,
		                                   caml_div(billionths, a),
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$2
		    (write_int63,
		     buf,
		     pos,
		     decimals,
		     a,
		     function(a){return cont(pos + decimals | 0);});
		                                   });
		                         });
		               }
		               function write_if_non_empty
		               (buf, pos, digits, int, suffix, cont){
		                return 0 === digits
		                        ? cont(pos)
		                        : caml_exact_trampoline_cps_call$2
		                          (write_digits,
		                           buf,
		                           pos,
		                           digits,
		                           int,
		                           function(pos){
		                            var pos$0 = write_char(buf, pos, suffix);
		                            return cont(pos$0);
		                           });
		               }
		               var
		                nanos_of_millisecond =
		                  caml_callback(to_int_exn$0, [millisecond]),
		                nanos_of_microsecond =
		                  caml_callback(to_int_exn$0, [microsecond$0]),
		                int63_60 = caml_callback(of_int$2, [60]),
		                int63_24 = caml_callback(of_int$2, [24]);
		               function create$32(s, ns){
		                return 0 < s
		                        ? 0
		                        : nanos_of_millisecond
		                          <= ns
		                          ? 1
		                          : nanos_of_microsecond <= ns ? 2 : 1 <= ns ? 3 : 4;
		               }
		               function integer$0(t, s, ns){
		                switch(t){
		                  case 0:
		                   return s;
		                  case 1:
		                   return caml_div(ns, nanos_of_millisecond);
		                  case 2:
		                   return caml_div(ns, nanos_of_microsecond);
		                  case 3:
		                   return ns;
		                  default: return 0;
		                }
		               }
		               function billionths(t, ns, cont){
		                switch(t){
		                  case 0:
		                   return cont(ns);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (symbol$23,
		                            ns,
		                            nanos_of_millisecond,
		                            function(a){return cont(a * 1000 | 0);});
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (symbol$23,
		                            ns,
		                            nanos_of_microsecond,
		                            function(a){return cont(a * 1000000 | 0);});
		                  default: return cont(0);
		                }
		               }
		               function length$17(t, digits, decimals){
		                var
		                 digits_len = t ? 4 <= t ? 0 : digits + 2 | 0 : digits + 1 | 0,
		                 decimals_len = 0 < decimals ? decimals + 1 | 0 : 0;
		                return digits_len + decimals_len | 0;
		               }
		               function write_suffix(t, buf, pos){
		                switch(t){
		                  case 0:
		                   return write_char(buf, pos, 115);
		                  case 1:
		                   return write_2_chars(buf, pos, 109, 115);
		                  case 2:
		                   return write_2_chars(buf, pos, 117, 115);
		                  case 3:
		                   return write_2_chars(buf, pos, 110, 115);
		                  default: return pos;
		                }
		               }
		               function write
		               (t, buf, pos, integer, digits, billionths, decimals, cont){
		                return 0 === digits
		                        ? cont(pos)
		                        : caml_exact_trampoline_cps_call$2
		                          (write_digits,
		                           buf,
		                           pos,
		                           digits,
		                           integer,
		                           function(pos){
		                            function a(pos){return cont(write_suffix(t, buf, pos));}
		                            if(0 === decimals) return a(pos);
		                            var pos$0 = write_char(buf, pos, 46);
		                            return caml_exact_trampoline_cps_call$2
		                                    (write_decimals, buf, pos$0, decimals, billionths, a);
		                           });
		               }
		               function to_string$68(t, cont){
		                if(equal$12(t, min_interval_num)) return cont(cst_0s);
		                var
		                 is_negative = symbol$49(t, min_interval_num),
		                 seconds = symbol$55(t, second);
		                return caml_exact_trampoline_cps_call
		                        (to_int_exn$0,
		                         rem$4(t, second),
		                         function(ns){
		                          var seconds$0 = abs$1(seconds), ns$0 = stdlib_abs(ns);
		                          return caml_exact_trampoline_cps_call
		                                  (to_int_exn$0,
		                                   rem$4(seconds$0, int63_60),
		                                   function(s){
		                                    var minutes = symbol$55(seconds$0, int63_60);
		                                    return caml_exact_trampoline_cps_call
		    (to_int_exn$0,
		     rem$4(minutes, int63_60),
		     function(m){
		      var hours = symbol$55(minutes, int63_60);
		      return caml_exact_trampoline_cps_call
		              (to_int_exn$0,
		               rem$4(hours, int63_24),
		               function(h){
		                return caml_exact_trampoline_cps_call
		                        (to_int_exn$0,
		                         symbol$55(hours, int63_24),
		                         function(d){
		                          var
		                           digits_of_d = number_of_digits_to_write(d),
		                           digits_of_h = number_of_digits_to_write(h),
		                           digits_of_m = number_of_digits_to_write(m),
		                           decimal_unit = create$32(s, ns$0),
		                           decimal_unit_integer = integer$0(decimal_unit, s, ns$0);
		                          return caml_exact_trampoline_cps_call$1
		                                  (billionths,
		                                   decimal_unit,
		                                   ns$0,
		                                   function(decimal_unit_billionths){
		                                    var
		                                     digits_of_decimal_unit =
		                                       number_of_digits_to_write(decimal_unit_integer);
		                                    return caml_exact_trampoline_cps_call
		    (number_of_decimal_places_to_wr,
		     decimal_unit_billionths,
		     function(decimals_of_decimal_unit){
		      var
		       sign_len = is_negative ? 1 : 0,
		       d_len = 0 < digits_of_d ? digits_of_d + 1 | 0 : 0,
		       h_len = 0 < digits_of_h ? digits_of_h + 1 | 0 : 0,
		       m_len = 0 < digits_of_m ? digits_of_m + 1 | 0 : 0,
		       decimal_unit_len =
		         length$17
		          (decimal_unit,
		           digits_of_decimal_unit,
		           decimals_of_decimal_unit),
		       string_length =
		         (((sign_len + d_len | 0) + h_len | 0) + m_len | 0)
		         + decimal_unit_len
		         | 0;
		      if(0 < string_length){
		       var
		        buf = caml_create_bytes(string_length),
		        pos = 0,
		        pos$0 = is_negative ? write_char(buf, pos, 45) : pos;
		       return caml_exact_trampoline_cps_call$3
		               (write_if_non_empty,
		                buf,
		                pos$0,
		                digits_of_d,
		                d,
		                100,
		                function(pos){
		                 return caml_exact_trampoline_cps_call$3
		                         (write_if_non_empty,
		                          buf,
		                          pos,
		                          digits_of_h,
		                          h,
		                          104,
		                          function(pos){
		                           return caml_exact_trampoline_cps_call$3
		                                   (write_if_non_empty,
		                                    buf,
		                                    pos,
		                                    digits_of_m,
		                                    m,
		                                    109,
		                                    function(pos){
		                                     return caml_exact_trampoline_cps_call$8
		     (write,
		      decimal_unit,
		      buf,
		      pos,
		      decimal_unit_integer,
		      digits_of_decimal_unit,
		      decimal_unit_billionths,
		      decimals_of_decimal_unit,
		      function(pos){
		       if(pos === string_length)
		        return cont(caml_string_of_bytes(buf));
		       var raise = caml_pop_trap();
		       return raise
		               (caml_maybe_attach_backtrace([0, Assert_failure, aE$], 1));
		      });
		                                    });
		                          });
		                });
		      }
		      var raise = caml_pop_trap();
		      return raise
		              (caml_maybe_attach_backtrace([0, Assert_failure, aFa], 1));
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                int63_10 = caml_callback(of_int$2, [10]),
		                min_mult10_without_underflow =
		                  symbol$55(min_value_representable, int63_10);
		               function invalid_string(string, reason, cont){
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_string$0,
		                         reason,
		                         function(b){
		                          var a = [0, [1, [0, aFb, [0, b, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_string$0,
		                                   string,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (raise_s,
		     [1,
		      [0,
		       [0, "Time_ns.Span.of_string: invalid string"],
		       [0, [1, [0, aFc, [0, b, 0]]], a]]],
		     cont);
		                                   });
		                         });
		               }
		               var
		                cst_span_would_be_outside_of_i =
		                  "span would be outside of int63 range";
		               function add_without_underflow(string, x, y, cont){
		                var sum = O$0[1].call(null, x, y);
		                function a(a){return cont(sum);}
		                return O$0[10].call(null, sum, x)
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_string, string, cst_span_would_be_outside_of_i, a)
		                        : a();
		               }
		               function add_neg_digit(string, int63, char, cont){
		                return caml_exact_trampoline_cps_call
		                        (get_digit_exn,
		                         char,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_int$2,
		                                   a,
		                                   function(digit){
		                                    function a(a){
		                                     a = O$0[5].call(null, digit);
		                                     return caml_exact_trampoline_cps_call$0
		     (add_without_underflow,
		      string,
		      O$0[3].call(null, int63, int63_10),
		      a,
		      cont);
		                                    }
		                                    return O$0[11].call
		     (null, int63, min_mult10_without_underflow)
		    ? caml_exact_trampoline_cps_call$1
		      (invalid_string, string, cst_span_would_be_outside_of_i, a)
		    : a(0);
		                                   });
		                         });
		               }
		               var
		                min_days_without_underflow =
		                  symbol$55(min_value_representable, start_of_next_day$0),
		                min_hours_without_underflow =
		                  symbol$55(min_value_representable, hour),
		                min_minutes_without_underflow =
		                  symbol$55(min_value_representable, minute),
		                min_seconds_without_underflow =
		                  symbol$55(min_value_representable, second),
		                min_milliseconds_without_under =
		                  symbol$55(min_value_representable, millisecond),
		                min_microseconds_without_under =
		                  symbol$55(min_value_representable, microsecond$0),
		                min_nanoseconds_without_underf =
		                  symbol$55(min_value_representable, nanosecond);
		               function min_without_underflow_of_unit_(unit_of_time){
		                switch(unit_of_time){
		                  case 0:
		                   return min_nanoseconds_without_underf;
		                  case 1:
		                   return min_microseconds_without_under;
		                  case 2:
		                   return min_milliseconds_without_under;
		                  case 3:
		                   return min_seconds_without_underflow;
		                  case 4:
		                   return min_minutes_without_underflow;
		                  case 5:
		                   return min_hours_without_underflow;
		                  default: return min_days_without_underflow;
		                }
		               }
		               function negative_part
		               (string,
		                neg_integer,
		                decimal_pos,
		                end_pos,
		                unit_of_time,
		                round_ties_before_negating,
		                cont){
		                var
		                 scale = of_unit_of_time$0(unit_of_time),
		                 min_without_underflow =
		                   min_without_underflow_of_unit_(unit_of_time);
		                function a(b){
		                 var
		                  neg_integer_ns = symbol$53(neg_integer, scale),
		                  fraction_pos = decimal_pos + 1 | 0;
		                 if(end_pos <= fraction_pos) return cont(neg_integer_ns);
		                 var
		                  decimals = end_pos - fraction_pos | 0,
		                  len = caml_ml_string_length(string),
		                  cst_read_int63_decimal = "read_int63_decimal",
		                  name = cst_read_int63_decimal;
		                 function a(a){
		                  a = symbol$49(scale, min_scale);
		                  a ||= symbol$48(scale, max_scale);
		                  function b(a){
		                   return caml_exact_trampoline_cps_call$2
		                           (check_pos,
		                            name,
		                            len,
		                            fraction_pos,
		                            decimals,
		                            function(b){
		                             var
		                              scale$0 = symbol$53(scale, int63_two),
		                              until = fraction_pos + decimals | 0;
		                             function a(divisor, round_at, sum, pos){
		                              if(pos !== until && O$0[11].call(null, round_at, scale$0)){
		                               var
		                                char = caml_string_unsafe_get(string, pos),
		                                b =
		                                  function(divisor, round_at, sum){
		                                   return caml_exact_trampoline_call4
		   (a, divisor, round_at, sum, pos + 1 | 0);
		                                  };
		                               if(58 <= char){
		                                if(95 === char) return b(divisor, round_at, sum);
		                               }
		                               else if(48 <= char)
		                                return caml_exact_trampoline_cps_call
		(get_digit_exn,
		 char,
		 function(a){
		  return caml_exact_trampoline_cps_call
		          (of_int$2,
		           a,
		           function(digit){
		            var
		             c = O$0[3].call(null, divisor, int63_ten),
		             a = O$0[3].call(null, round_at, int63_ten),
		             d = O$0[3].call(null, digit, scale$0),
		             numerator = O$0[2].call(null, d, a),
		             a = O$0[1].call(null, numerator, c),
		             a = O$0[2].call(null, a, min_scale);
		            return caml_exact_trampoline_cps_call$1
		                    (O$0[17],
		                     a,
		                     c,
		                     function(increment){
		                      var
		                       a = O$0[3].call(null, increment, c),
		                       remainder = O$0[2].call(null, numerator, a),
		                       d = O$0[5].call(null, remainder),
		                       e = O$0[1].call(null, sum, increment);
		                      return caml_exact_trampoline_cps_call$1
		                              (min$10, c, scale$0, function(a){return b(a, d, e);});
		                     });
		           });
		 });
		                               return caml_exact_trampoline_cps_call
		                                       (invalid_argf,
		aEo,
		function(a){
		 return caml_trampoline_cps_call4
		         (a,
		          module_name,
		          cst_read_int63_decimal,
		          0,
		          function(a){return b(divisor, round_at, sum);});
		});
		                              }
		                              var
		                               sum$0 =
		                                 O$0[9].call(null, round_at, O$0[15])
		                                  ? round_ties_before_negating
		                                    ? sum
		                                    : O$0[1].call(null, sum, min_scale)
		                                  : sum;
		                              return caml_exact_trampoline_cps_call$0
		                                      (add_without_underflow,
		                                       string,
		                                       neg_integer_ns,
		                                       symbol$54(sum$0),
		                                       cont);
		                             }
		                             return a
		                                     (int63_two, min_scale, min_interval_num, fraction_pos);
		                            });
		                  }
		                  if(! a) return b();
		                  var
		                   c = to_int64$0(max_scale),
		                   d = to_int64$0(min_scale),
		                   e = to_int64$0(scale);
		                  return caml_exact_trampoline_cps_call
		                          (invalid_argf,
		                           aEr,
		                           function(a){
		                            return caml_trampoline_cps_call7
		                                    (a, module_name, name, e, d, c, 0, b);
		                           });
		                 }
		                 if(decimals >= 0) return a(0);
		                 return caml_exact_trampoline_cps_call
		                         (invalid_argf,
		                          aEp,
		                          function(b){
		                           return caml_trampoline_cps_call5
		                                   (b, module_name, name, decimals, 0, a);
		                          });
		                }
		                return symbol$49(neg_integer, min_without_underflow)
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_string, string, cst_span_would_be_outside_of_i, a)
		                        : a();
		               }
		               function of_string$52(string, cont){
		                var len = caml_ml_string_length(string);
		                function a(b){
		                 b = caml_string_unsafe_get(string, 0) - 43 | 0;
		                 a:
		                 {
		                  if(2 >= b >>> 0)
		                   switch(b){
		                     case 0:
		                      var pos = 1, is_negative = 0; break a;
		                     case 2:
		                      pos = 1; is_negative = 1; break a;
		                   }
		                  pos = 0;
		                  is_negative = 0;
		                 }
		                 function a(neg_ns, pos, round_ties_before_negating){
		                  if(pos < len){
		                   var
		                    b =
		                      function(pos, has_digit, i, end_of_digits){
		                       if(pos < len && ! end_of_digits){
		                        var c = caml_string_unsafe_get(string, pos);
		                        if(58 <= c){
		                         if(95 === c){
		                          var pos$0 = pos + 1 | 0;
		                          return caml_exact_trampoline_call4
		                                  (b, pos$0, has_digit, i, end_of_digits);
		                         }
		                        }
		                        else if(48 <= c)
		                         return caml_exact_trampoline_cps_call$0
		                                 (add_neg_digit,
		                                  string,
		                                  i,
		                                  c,
		                                  function(a){
		                                   var pos$0 = pos + 1 | 0;
		                                   return caml_exact_trampoline_call4
		   (b, pos$0, 1, a, end_of_digits);
		                                  });
		                        return caml_exact_trampoline_call4(b, pos, has_digit, i, 1);
		                       }
		                       var d = pos < len;
		                       if(d)
		                        var y = caml_string_unsafe_get(string, pos), d = 46 === y;
		                       if(d){
		                        var
		                         pos$1 = pos + 1 | 0,
		                         end_of_decimals = 0,
		                         has_digit$0 = has_digit,
		                         pos$2 = pos$1;
		                        for(;;){
		                         if(pos$2 >= len){
		                          var has_digit$1 = has_digit$0, pos$5 = pos$2;
		                          break;
		                         }
		                         if(end_of_decimals){
		                          has_digit$1 = has_digit$0;
		                          pos$5 = pos$2;
		                          break;
		                         }
		                         d = caml_string_unsafe_get(string, pos$2);
		                         if(58 <= d){
		                          if(95 === d){
		                           var pos$3 = pos$2 + 1 | 0;
		                           pos$2 = pos$3;
		                           continue;
		                          }
		                         }
		                         else if(48 <= d){
		                          var pos$4 = pos$2 + 1 | 0;
		                          has_digit$0 = 1;
		                          pos$2 = pos$4;
		                          continue;
		                         }
		                         end_of_decimals = 1;
		                        }
		                       }
		                       else {has_digit$1 = has_digit; pos$5 = pos;}
		                       function e(d){
		                        function b(pos$0, unit_of_time){
		                         return caml_exact_trampoline_cps_call$7
		                                 (negative_part,
		                                  string,
		                                  i,
		                                  pos,
		                                  pos$5,
		                                  unit_of_time,
		                                  round_ties_before_negating,
		                                  function(neg_nanos_of_part){
		                                   return caml_exact_trampoline_cps_call$0
		   (add_without_underflow,
		    string,
		    neg_ns,
		    neg_nanos_of_part,
		    function(b){
		     return caml_exact_trampoline_call3
		             (a, b, pos$0, round_ties_before_negating);
		    });
		                                  });
		                        }
		                        var d = "unparseable unit suffix";
		                        if((pos$5 + 1 | 0) < len){
		                         var y = caml_string_unsafe_get(string, pos$5 + 1 | 0);
		                         if(115 === y){
		                          var c = caml_string_unsafe_get(string, pos$5) - 109 | 0;
		                          if(8 >= c >>> 0)
		                           switch(c){
		                             case 0:
		                              return b(pos$5 + 2 | 0, 2);
		                             case 1:
		                              return b(pos$5 + 2 | 0, 0);
		                             case 8:
		                              return b(pos$5 + 2 | 0, 1);
		                           }
		                          return caml_exact_trampoline_cps_call$1
		                                  (invalid_string,
		                                   string,
		                                   d,
		                                   function(a){return b(pos$5, a);});
		                         }
		                        }
		                        if(pos$5 >= len)
		                         return caml_exact_trampoline_cps_call$1
		                                 (invalid_string,
		                                  string,
		                                  "no unit suffix after digits",
		                                  function(a){return b(pos$5, a);});
		                        c = caml_string_unsafe_get(string, pos$5) - 100 | 0;
		                        if(15 >= c >>> 0)
		                         switch(c){
		                           case 0:
		                            var pos$0 = pos$5 + 1 | 0; return b(pos$0, 6);
		                           case 4:
		                            var pos$1 = pos$5 + 1 | 0; return b(pos$1, 5);
		                           case 9:
		                            var pos$2 = pos$5 + 1 | 0; return b(pos$2, 4);
		                           case 15:
		                            var pos$3 = pos$5 + 1 | 0; return b(pos$3, 3);
		                         }
		                        return caml_exact_trampoline_cps_call$1
		                                (invalid_string,
		                                 string,
		                                 d,
		                                 function(a){return b(pos$5, a);});
		                       }
		                       return 1 - has_digit$1
		                               ? caml_exact_trampoline_cps_call$1
		                                 (invalid_string, string, "no digits before unit suffix", e)
		                               : e(0);
		                      };
		                   return b(pos, 0, min_interval_num, 0);
		                  }
		                  function c(ns){return cont(ns);}
		                  return is_negative
		                          ? c(neg_ns)
		                          : symbol$47
		                             (neg_ns, min_value_representable)
		                            ? caml_exact_trampoline_cps_call$1
		                              (invalid_string, string, cst_span_would_be_outside_of_i, c)
		                            : c(symbol$54(neg_ns));
		                 }
		                 return is_negative
		                         ? a(min_interval_num, pos, 1)
		                         : a(min_interval_num, pos, 0);
		                }
		                return 0 === len
		                        ? caml_exact_trampoline_cps_call$1
		                          (invalid_string, string, "empty string", a)
		                        : a(0);
		               }
		               function sexp_of_span(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$68, t, function(a){return cont([0, a]);});
		               }
		               var
		                include$128 = Make$1([0, compare_time, sexp_of_span]),
		                comparator$53 = include$128[1],
		                T$11 =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare_time,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   comparator$53],
		                compare$155 = T$11[10],
		                comparator$54 = T$11[24],
		                bin_shape_t$38 = [8, group$73, cst_t, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$38, , , , , , sexp_of_span]]);
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$38]]);
		               function to_string_hum$1(b, a, opt, unit_of_time, t, cont){
		                var
		                 delimiter = b ? b[1] : 95,
		                 decimals = a ? a[1] : 3,
		                 align_decimal = opt ? opt[1] : 0;
		                return caml_exact_trampoline_cps_call
		                        (to_unit_of_time$0,
		                         t,
		                         function(a){
		                          switch(value$4(unit_of_time, a)){
		                            case 0:
		                             var suffix = cst_ns, float = to_float$1(t); break;
		                            case 1:
		                             suffix = cst_us; float = to_us(t); break;
		                            case 2:
		                             suffix = cst_ms; float = to_ms(t); break;
		                            case 3:
		                             suffix = cst_s$0; float = to_sec(t); break;
		                            case 4:
		                             suffix = cst_m; float = to_min(t); break;
		                            case 5:
		                             suffix = cst_h$0; float = to_hr(t); break;
		                            default:
		                             var float$0 = to_day(t), suffix = cst_d$0, float = float$0;
		                          }
		                          return caml_exact_trampoline_cps_call$3
		                                  (to_string_hum$0,
		                                   [0, delimiter],
		                                   [0, decimals],
		                                   [0, 1 - align_decimal],
		                                   0,
		                                   float,
		                                   function(prefix){
		                                    var
		                                     suffix$0 =
		                                       align_decimal
		? caml_ml_string_length
		   (suffix)
		  === 1
		  ? suffix + cst$7
		  : suffix
		: suffix;
		                                    return cont(prefix + suffix$0);
		                                   });
		                         });
		               }
		               var
		                group$74 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:806:2",
		                     [0, [0, cst_t, 0, bin_shape_t$37], 0]]);
		               function hash$37(x, cont){
		                return caml_exact_trampoline_cps_call(hash$15, x, cont);
		               }
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [8, group$74, cst_t, 0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare_time,
		                   sexp_of_span,
		                   hash$37]]);
		               var
		                group$75 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:812:2",
		                     [0, [0, cst_t, 0, bin_shape_t$37], 0]]);
		               caml_callback
		                (cl,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   [8, group$75, cst_t, 0],
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_span,
		                   comparator$53]]);
		               var
		                group$76 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:819:2",
		                     [0, [0, cst_t, 0, bin_shape_t$37], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$76, cst_t, 0]]]);
		               caml_callback(of_int$2, [500]);
		               to_sec(min_value_for_1us_rounding);
		               to_sec(max_value_for_1us_rounding);
		               var
		                group$77 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:905:2",
		                     [0, [0, cst_t, 0, bin_shape_t$13], 0]]);
		               bX([0, "core/src/span_ns.ml.Option.t"]);
		               function some_is_representable(span, cont){
		                return cont(symbol$50(span, min_value_representable));
		               }
		               var
		                quickcheck_generator$3 =
		                  filter$8(quickcheck_generator, some_is_representable);
		               caml_callback
		                (quickcheck_generator_option, [quickcheck_generator$3]);
		               var
		                bin_shape_t$39 = [8, group$77, cst_t, 0],
		                group$78 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:980:8",
		                     [0, [0, cst_t, 0, bin_shape_t$39], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$78, cst_t, 0]]]);
		               var
		                group$79 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:1007:8",
		                     [0, [0, cst_t, 0, bin_shape_t$39], 0]]);
		               function sexp_of_t$81(t, cont){
		                function a(a){return cont([1, a]);}
		                if(symbol$47(t, min_value_representable)) return a(0);
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_span, t, function(b){return a([0, b, 0]);});
		               }
		               caml_callback(b7, [[0, , , , , , , , [8, group$79, cst_t, 0]]]);
		               var
		                group$80 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:1053:4",
		                     [0, [0, cst_t, 0, bin_shape_t$39], 0]]);
		               function hash$38(x, cont){
		                return caml_exact_trampoline_cps_call(hash$15, x, cont);
		               }
		               var bin_shape_t$40 = [8, group$80, cst_t, 0];
		               caml_callback
		                (bPR,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$40,
		                   ,
		                   ,
		                   ,
		                   compare_time,
		                   ,
		                   sexp_of_t$81]]);
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$40,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare_time,
		                   sexp_of_t$81,
		                   hash$38]]);
		               var
		                group$81 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/span_ns.ml:1063:4",
		                     [0, [0, cst_t, 0, bin_shape_t$40], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$81, cst_t, 0]]]);
		               caml_callback(create$29, [dummy, dummy, of_string$52]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Ofday_ns";
		               record_start(d);
		               set$7(cst_core);
		               bX([0, "core/src/ofday_ns.ml.t"]);
		               symbol$52(start_of_next_day$0, nanosecond);
		               var
		                group$82 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/ofday_ns.ml:63:4",
		                     [0, [0, cst_t, 0, bin_shape_t$38], 0]]);
		               function to_string_with_unit(ns, unit, cont){
		                if
		                 (!
		                  symbol$49(ns, min_interval_num)
		                  && ! symbol$49(start_of_next_day$0, ns))
		                 return caml_exact_trampoline_cps_call
		                         (of_int$2,
		                          60,
		                          function(sixty){
		                           return caml_exact_trampoline_cps_call
		                                   (of_int$2,
		                                    1000,
		                                    function(thousand){
		                                     var us = symbol$55(ns, thousand);
		                                     return caml_exact_trampoline_cps_call
		     (to_int_exn$0,
		      rem$4(ns, thousand),
		      function(ns){
		       var ms = symbol$55(us, thousand);
		       return caml_exact_trampoline_cps_call
		               (to_int_exn$0,
		                rem$4(us, thousand),
		                function(us){
		                 var s = symbol$55(ms, thousand);
		                 return caml_exact_trampoline_cps_call
		                         (to_int_exn$0,
		                          rem$4(ms, thousand),
		                          function(ms){
		                           var m = symbol$55(s, sixty);
		                           return caml_exact_trampoline_cps_call
		                                   (to_int_exn$0,
		                                    rem$4(s, sixty),
		                                    function(s){
		                                     return caml_exact_trampoline_cps_call
		     (to_int_exn$0,
		      symbol$55(m, sixty),
		      function(h){
		       return caml_exact_trampoline_cps_call
		               (to_int_exn$0,
		                rem$4(m, sixty),
		                function(m){
		                 var
		                  unit$0 =
		                    65840584 <= unit
		                     ? unit
		                     : 0
		                       === ns
		                       ? 0
		                         === us
		                         ? 0 === ms ? 0 === s ? 127686388 : 417088404 : 858219297
		                         : 425338712
		                       : 65840584,
		                  len =
		                    127686388 === unit$0
		                     ? 5
		                     : 425338712
		                       <= unit$0
		                       ? 858219297 <= unit$0 ? 12 : 15
		                       : 417088404 <= unit$0 ? 8 : 18,
		                  str = caml_create_bytes(len);
		                 return caml_exact_trampoline_cps_call$0
		                         (write_2_digit_int$0,
		                          str,
		                          0,
		                          h,
		                          function(a){
		                           caml_bytes_set(str, 2, 58);
		                           return caml_exact_trampoline_cps_call$0
		                                   (write_2_digit_int$0,
		                                    str,
		                                    3,
		                                    m,
		                                    function(b){
		                                     function a(a){return cont(caml_string_of_bytes(str));}
		                                     return 127686388 === unit$0
		     ? a()
		     : (caml_bytes_set
		        (str, 5, 58),
		       caml_exact_trampoline_cps_call$0
		        (write_2_digit_int$0,
		         str,
		         6,
		         s,
		         function(b){
		          return 417088404 === unit$0
		                  ? a()
		                  : (caml_bytes_set
		                     (str, 8, 46),
		                    caml_exact_trampoline_cps_call$0
		                     (write_3_digit_int$0,
		                      str,
		                      9,
		                      ms,
		                      function(b){
		                       return 858219297 <= unit$0
		                               ? a()
		                               : caml_exact_trampoline_cps_call$0
		                                 (write_3_digit_int$0,
		                                  str,
		                                  12,
		                                  us,
		                                  function(b){
		                                   return 425338712 <= unit$0
		   ? a()
		   : caml_exact_trampoline_cps_call$0
		     (write_3_digit_int$0, str, 15, ns, a);
		                                  });
		                      }));
		         }));
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                return cont("Incorrect day");
		               }
		               function to_string$69(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_string_with_unit, t, 65840584, cont);
		               }
		               function sexp_of_t$82(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$69, t, function(a){return cont([0, a]);});
		               }
		               var
		                bin_shape_t$41 = [8, group$82, cst_t, 0],
		                group$83 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/ofday_ns.ml:200:6",
		                     [0, [0, cst_t, 0, bin_shape_t$41], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$83, cst_t, 0]]]);
		               var
		                group$84 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/ofday_ns.ml:212:2",
		                     [0, [0, cst_t, 0, bin_shape_t$41], 0]]);
		               function hash$39(x, cont){
		                return caml_exact_trampoline_cps_call(hash$15, x, cont);
		               }
		               var bin_shape_t$42 = [8, group$84, cst_t, 0];
		               caml_callback
		                (cl,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$42,
		                   ,
		                   ,
		                   ,
		                   ,
		                   sexp_of_t$82,
		                   comparator$54]]);
		               caml_callback
		                (Make_binable$1,
		                 [[0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   bin_shape_t$42,
		                   ,
		                   ,
		                   ,
		                   ,
		                   compare$155,
		                   sexp_of_t$82,
		                   hash$39]]);
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$41]]);
		               caml_callback
		                (int63_inclusive, [min_interval_num, start_of_next_day$0]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Time_ns";
		               record_start(d);
		               set$7(cst_core);
		               var
		                group$85 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/time_ns.ml:9:0",
		                     [0, [0, cst_t, 0, bin_shape_t$37], 0]]);
		               bX([0, "core/src/time_ns.ml.t"]);
		               to_sec(min_value_for_1us_rounding);
		               to_sec(max_value_for_1us_rounding);
		               var
		                group$86 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/time_ns.ml:257:4",
		                     [0, [0, cst_t, 0, [8, group$85, cst_t, 0]], 0]]);
		               function seconds_to_string(seconds_span, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_int_sec,
		                         seconds_span,
		                         function(seconds){
		                          var h = seconds / 3600 | 0;
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$23,
		                                   seconds / 60 | 0,
		                                   60,
		                                   function(m){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$23,
		     seconds,
		     60,
		     function(s){
		      return caml_exact_trampoline_cps_call
		              (sprintf,
		               aFd,
		               function(a){
		                return caml_trampoline_cps_call4(a, h, m, s, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function sub_second_to_string(sub_second_span, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_int_exn$0,
		                         sub_second_span,
		                         function(ns){
		                          return 0 === ns
		                                  ? cont(cst$1)
		                                  : caml_exact_trampoline_cps_call$1
		                                    (symbol$23,
		                                     ns,
		                                     100000000,
		                                     function(b){
		                                      if(0 !== b)
		                                       return caml_exact_trampoline_cps_call$1
		       (symbol$23,
		        ns,
		        10000000,
		        function(b){
		         if(0 !== b)
		          return caml_exact_trampoline_cps_call$1
		                  (symbol$23,
		                   ns,
		                   1000000,
		                   function(b){
		                    if(0 !== b)
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$23,
		                              ns,
		                              100000,
		                              function(b){
		                               if(0 !== b)
		                                return caml_exact_trampoline_cps_call$1
		(symbol$23,
		 ns,
		 10000,
		 function(b){
		  if(0 !== b)
		   return caml_exact_trampoline_cps_call$1
		           (symbol$23,
		            ns,
		            1000,
		            function(b){
		             if(0 !== b)
		              return caml_exact_trampoline_cps_call$1
		                      (symbol$23,
		                       ns,
		                       100,
		                       function(b){
		                        if(0 !== b)
		                         return caml_exact_trampoline_cps_call$1
		                                 (symbol$23,
		                                  ns,
		                                  10,
		                                  function(b){
		                                   if(0 !== b)
		                                    return caml_exact_trampoline_cps_call
		    (sprintf,
		     aFm,
		     function(a){return caml_trampoline_cps_call2(a, ns, cont);});
		                                   var a = ns / 10 | 0;
		                                   return caml_exact_trampoline_cps_call
		   (sprintf,
		    aFl,
		    function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                  });
		                        var a = ns / 100 | 0;
		                        return caml_exact_trampoline_cps_call
		                                (sprintf,
		                                 aFk,
		                                 function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                       });
		             var a = ns / 1000 | 0;
		             return caml_exact_trampoline_cps_call
		                     (sprintf,
		                      aFj,
		                      function(b){return caml_trampoline_cps_call2(b, a, cont);});
		            });
		  var a = ns / 10000 | 0;
		  return caml_exact_trampoline_cps_call
		          (sprintf,
		           aFi,
		           function(b){return caml_trampoline_cps_call2(b, a, cont);});
		 });
		                               var a = ns / 100000 | 0;
		                               return caml_exact_trampoline_cps_call
		                                       (sprintf,
		aFh,
		function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                              });
		                    var a = ns / 1000000 | 0;
		                    return caml_exact_trampoline_cps_call
		                            (sprintf,
		                             aFg,
		                             function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                   });
		         var a = ns / 10000000 | 0;
		         return caml_exact_trampoline_cps_call
		                 (sprintf,
		                  aFf,
		                  function(b){return caml_trampoline_cps_call2(b, a, cont);});
		        });
		                                      var a = ns / 100000000 | 0;
		                                      return caml_exact_trampoline_cps_call
		      (sprintf,
		       aFe,
		       function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                     });
		                         });
		               }
		               function to_string$70(span, cont){
		                if
		                 (greater_equal$0(span, min_interval_num)
		                  && symbol$49(span, start_of_next_day$0))
		                 return caml_exact_trampoline_cps_call
		                         (to_int_sec,
		                          span,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (of_int_sec,
		                                    a,
		                                    function(seconds_span){
		                                     var sub_second_span = symbol$52(span, seconds_span);
		                                     return caml_exact_trampoline_cps_call
		     (sub_second_to_string,
		      sub_second_span,
		      function(s2){
		       return caml_exact_trampoline_cps_call
		               (seconds_to_string,
		                seconds_span,
		                function(s1){return cont(s1 + s2);});
		      });
		                                    });
		                          });
		                var raise = caml_pop_trap();
		                return raise
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aFn], 1));
		               }
		               function to_string$71(ns_since_epoch, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_int_exn$3,
		                         1000000000,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_int_exn$3,
		                                   86400,
		                                   function(b){
		                                    var
		                                     ns_per_day = O$0[3].call(null, b, a),
		                                     approx_days_from_epoch =
		                                       O$0[4].call(null, ns_since_epoch, ns_per_day);
		                                    return caml_exact_trampoline_cps_call
		    (of_int_exn$3,
		     0,
		     function(b){
		      function a(days_from_epoch){
		       var
		        a = O$0[3].call(null, ns_per_day, days_from_epoch),
		        span_since_start_of_day =
		          O$0[2].call(null, ns_since_epoch, a);
		       return caml_exact_trampoline_cps_call
		               (to_int_exn$0,
		                days_from_epoch,
		                function(days){
		                 return caml_exact_trampoline_cps_call
		                         (to_date$4,
		                          unix_epoch$0 + days | 0,
		                          function(date){
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$70,
		                                    span_since_start_of_day,
		                                    function(s1){
		                                     var s2$0 = s1 + cst_Z, s2 = cst$7 + s2$0;
		                                     return caml_exact_trampoline_cps_call
		     (to_string_iso8601_extended,
		      date,
		      function(s1){return cont(s1 + s2);});
		                                    });
		                          });
		                });
		      }
		      if(! O$0[11].call(null, ns_since_epoch, b))
		       return a(approx_days_from_epoch);
		      b = O$0[3].call(null, approx_days_from_epoch, ns_per_day);
		      return O$0[12].call(null, b, ns_since_epoch)
		              ? caml_exact_trampoline_cps_call
		                (of_int_exn$3,
		                 1,
		                 function(b){
		                  return a(O$0[2].call(null, approx_days_from_epoch, b));
		                 })
		              : a(approx_days_from_epoch);
		     });
		                                   });
		                         });
		               }
		               var
		                include$129 = Of_stringable([0, , to_string$71]),
		                sexp_of_t$83 = include$129[3];
		               Make$18([0, compare_time, , sexp_of_t$83]);
		               var
		                bin_shape_t$43 = [8, group$86, cst_t, 0],
		                group$87 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/time_ns.ml:395:4",
		                     [0, [0, cst_t, 0, bin_shape_t$43], 0]]);
		               caml_callback(b7, [[0, , , , , , , , [8, group$87, cst_t, 0]]]);
		               var
		                group$88 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/time_ns.ml:403:8",
		                     [0, [0, cst_t, 0, bin_shape_t$43], 0]]),
		                bin_shape_t$44 = [8, group$88, cst_t, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$44, , , , , , sexp_of_t$83]]);
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$44]]);
		               var
		                group$89 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/time_ns.ml:421:2",
		                     [0, [0, cst_t, 0, bin_shape_t$40], 0]]);
		               bX([0, "core/src/time_ns.ml.Option0.t"]);
		               var
		                bin_shape_t$45 = [8, group$89, cst_t, 0],
		                group$90 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/time_ns.ml:460:6",
		                     [0, [0, cst_t, 0, bin_shape_t$45], 0]]);
		               function sexp_of_t$84(t, cont){
		                function b(x_019){
		                 return caml_exact_trampoline_cps_call$1
		                         (sexp_of_option, sexp_of_t$83, x_019, cont);
		                }
		                if(symbol$47(t, min_value_representable)) return b(0);
		                function a(a){return b([0, a]);}
		                return symbol$50(t, min_value_representable)
		                        ? a(t)
		                        : caml_exact_trampoline_cps_call
		                          (raise_s,
		                           [1,
		                            [0,
		                             [0, "core/src/time_ns.ml:439:27"],
		                             [0, [0, "Time_ns.Option.value_exn none"], 0]]],
		                           a);
		               }
		               Make$18([0, compare$150, , sexp_of_t$84]);
		               var bin_shape_t$46 = [8, group$90, cst_t, 0];
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$46]]);
		               var
		                group$91 =
		                  caml_callback
		                   (create$25,
		                    ["core/src/time_ns.ml:482:10",
		                     [0, [0, cst_t, 0, bin_shape_t$46], 0]]),
		                bin_shape_t$47 = [8, group$91, cst_t, 0];
		               caml_callback
		                (Make$19,
		                 [[0, , , , , , bin_shape_t$47, , , , , , sexp_of_t$84]]);
		               caml_callback(b7, [[0, , , , , , , , bin_shape_t$47]]);
		               caml_callback
		                (create$25,
		                 ["core/src/time_ns.ml:510:6",
		                  [0, [0, cst_t, 0, bin_shape_t$45], 0]]);
		               var
		                Time_ns_of_string =
		                  [248,
		                   "Core__Time_ns.To_and_of_string.Time_ns_of_string",
		                   caml_fresh_oo_id()];
		               caml_callback
		                (add$1,
		                 [0,
		                  dummy,
		                  Time_ns_of_string,
		                  function(a, cont){
		                   if(a[1] === Time_ns_of_string){
		                    var arg1_035 = a[3], arg0_034 = a[2];
		                    return caml_exact_trampoline_cps_call
		                            (sexp_of_string$0,
		                             arg0_034,
		                             function(res0_036){
		                              return caml_exact_trampoline_cps_call
		                                      (sexp_of_exn,
		                                       arg1_035,
		                                       function(res1_037){
		return cont([1, [0, aFo, [0, res0_036, [0, res1_037, 0]]]]);
		                                       });
		                             });
		                   }
		                   a = caml_pop_trap();
		                   return a
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aFp], 1));
		                  }]);
		               function span_of_duration(d, cont){return cont(d);}
		               function of_string$53(string, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$52, string, cont);
		               }
		               function to_string_with_same_unit$0(durations, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         durations,
		                         span_of_duration,
		                         function(spans){
		                          return caml_exact_trampoline_cps_call$0
		                                  (max_elt,
		                                   fold_left$1,
		                                   spans,
		                                   compare_time,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (value_map,
		     a,
		     0,
		     to_unit_of_time$0,
		     function(unit_of_time){
		      var a = [0, unit_of_time];
		      return caml_exact_trampoline_cps_call$1
		              (map$7,
		               spans,
		               function(eta, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (to_string_hum$1, 0, 0, aFq, a, eta, cont);
		               },
		               cont);
		     });
		                                   });
		                         });
		               }
		               format$27[1] = [0, of_string$53, to_string_with_same_unit$0];
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Time_ns_alternate_sexp";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Stack";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Filename";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Gc";
		               record_start(d);
		               set$7(cst_core);
		               caml_callback
		                (create$25,
		                 ["core/src/gc.ml:6:6", [0, [0, cst_t, 0, [3, v0$3]], 0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/gc.ml:65:6",
		                  [0,
		                   [0,
		                    cst_t,
		                    0,
		                    [2,
		                     [0,
		                      [0, cst_minor_words, bin_shape_float],
		                      [0,
		                       [0, cst_promoted_words, bin_shape_float],
		                       [0,
		                        [0, cst_major_words, bin_shape_float],
		                        [0,
		                         [0, cst_minor_collections, bin_shape_int$0],
		                         [0,
		                          [0, cst_major_collections, bin_shape_int$0],
		                          [0,
		                           [0, cst_heap_words, bin_shape_int$0],
		                           [0,
		                            [0, cst_heap_chunks, bin_shape_int$0],
		                            [0,
		                             [0, cst_live_words, bin_shape_int$0],
		                             [0,
		                              [0, cst_live_blocks, bin_shape_int$0],
		                              [0,
		                               [0, cst_free_words, bin_shape_int$0],
		                               [0,
		                                [0, cst_free_blocks, bin_shape_int$0],
		                                [0,
		                                 [0, cst_largest_free, bin_shape_int$0],
		                                 [0,
		                                  [0, cst_fragments, bin_shape_int$0],
		                                  [0,
		                                   [0, cst_compactions, bin_shape_int$0],
		                                   [0,
		                                    [0, cst_top_heap_words, bin_shape_int$0],
		                                    [0, [0, cst_stack_size, bin_shape_int$0], 0]]]]]]]]]]]]]]]]]],
		                   0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/gc.ml:87:6",
		                  [0,
		                   [0,
		                    cst_t,
		                    0,
		                    [2,
		                     [0,
		                      [0, cst_minor_words, bin_shape_float],
		                      [0,
		                       [0, cst_promoted_words, bin_shape_float],
		                       [0,
		                        [0, cst_major_words, bin_shape_float],
		                        [0,
		                         [0, cst_minor_collections, bin_shape_int$0],
		                         [0,
		                          [0, cst_major_collections, bin_shape_int$0],
		                          [0,
		                           [0, cst_heap_words, bin_shape_int$0],
		                           [0,
		                            [0, cst_heap_chunks, bin_shape_int$0],
		                            [0,
		                             [0, cst_live_words, bin_shape_int$0],
		                             [0,
		                              [0, cst_live_blocks, bin_shape_int$0],
		                              [0,
		                               [0, cst_free_words, bin_shape_int$0],
		                               [0,
		                                [0, cst_free_blocks, bin_shape_int$0],
		                                [0,
		                                 [0, cst_largest_free, bin_shape_int$0],
		                                 [0,
		                                  [0, cst_fragments, bin_shape_int$0],
		                                  [0,
		                                   [0, cst_compactions, bin_shape_int$0],
		                                   [0,
		                                    [0, cst_top_heap_words, bin_shape_int$0],
		                                    [0,
		                                     [0, cst_stack_size, bin_shape_int$0],
		                                     [0, [0, cst_forced_major_collections, bin_shape_int$0], 0]]]]]]]]]]]]]]]]]]],
		                   0]]);
		               caml_callback
		                (create$25,
		                 ["core/src/gc.ml:139:6",
		                  [0,
		                   [0,
		                    cst_t,
		                    0,
		                    [2,
		                     [0,
		                      [0, cst_minor_heap_size, bin_shape_int$0],
		                      [0,
		                       [0, cst_major_heap_increment, bin_shape_int$0],
		                       [0,
		                        [0, cst_space_overhead, bin_shape_int$0],
		                        [0,
		                         [0, cst_verbose, bin_shape_int$0],
		                         [0,
		                          [0, cst_max_overhead, bin_shape_int$0],
		                          [0,
		                           [0, cst_stack_limit, bin_shape_int$0],
		                           [0,
		                            [0, cst_allocation_policy, bin_shape_int$0],
		                            [0,
		                             [0, cst_window_size, bin_shape_int$0],
		                             [0,
		                              [0, cst_custom_major_ratio, bin_shape_int$0],
		                              [0,
		                               [0, cst_custom_minor_ratio, bin_shape_int$0],
		                               [0, [0, cst_custom_minor_max_size, bin_shape_int$0], 0]]]]]]]]]]]]],
		                   0]]);
		               function compare$156(a_121, b_122, cont){
		                if(a_121 === b_122) return cont(0);
		                var
		                 b = b_122[1],
		                 a = a_121[1],
		                 n$14 = caml_float_compare(a, b);
		                if(0 !== n$14) return cont(n$14);
		                var
		                 b$0 = b_122[2],
		                 a$0 = a_121[2],
		                 n$13 = caml_float_compare(a$0, b$0);
		                if(0 !== n$13) return cont(n$13);
		                var
		                 b$1 = b_122[3],
		                 a$1 = a_121[3],
		                 n$12 = caml_float_compare(a$1, b$1);
		                if(0 !== n$12) return cont(n$12);
		                var
		                 b$2 = b_122[4],
		                 a$2 = a_121[4],
		                 n$11 = caml_int_compare(a$2, b$2);
		                if(0 !== n$11) return cont(n$11);
		                var
		                 b$3 = b_122[5],
		                 a$3 = a_121[5],
		                 n$10 = caml_int_compare(a$3, b$3);
		                if(0 !== n$10) return cont(n$10);
		                var
		                 b$4 = b_122[6],
		                 a$4 = a_121[6],
		                 n$9 = caml_int_compare(a$4, b$4);
		                if(0 !== n$9) return cont(n$9);
		                var
		                 b$5 = b_122[7],
		                 a$5 = a_121[7],
		                 n$8 = caml_int_compare(a$5, b$5);
		                if(0 !== n$8) return cont(n$8);
		                var
		                 b$6 = b_122[8],
		                 a$6 = a_121[8],
		                 n$7 = caml_int_compare(a$6, b$6);
		                if(0 !== n$7) return cont(n$7);
		                var
		                 b$7 = b_122[9],
		                 a$7 = a_121[9],
		                 n$6 = caml_int_compare(a$7, b$7);
		                if(0 !== n$6) return cont(n$6);
		                var
		                 b$8 = b_122[10],
		                 a$8 = a_121[10],
		                 n$5 = caml_int_compare(a$8, b$8);
		                if(0 !== n$5) return cont(n$5);
		                var
		                 b$9 = b_122[11],
		                 a$9 = a_121[11],
		                 n$4 = caml_int_compare(a$9, b$9);
		                if(0 !== n$4) return cont(n$4);
		                var
		                 b$10 = b_122[12],
		                 a$10 = a_121[12],
		                 n$3 = caml_int_compare(a$10, b$10);
		                if(0 !== n$3) return cont(n$3);
		                var
		                 b$11 = b_122[13],
		                 a$11 = a_121[13],
		                 n$2 = caml_int_compare(a$11, b$11);
		                if(0 !== n$2) return cont(n$2);
		                var
		                 b$12 = b_122[14],
		                 a$12 = a_121[14],
		                 n$1 = caml_int_compare(a$12, b$12);
		                if(0 !== n$1) return cont(n$1);
		                var
		                 b$13 = b_122[15],
		                 a$13 = a_121[15],
		                 n$0 = caml_int_compare(a$13, b$13);
		                if(0 !== n$0) return cont(n$0);
		                var
		                 b$14 = b_122[16],
		                 a$14 = a_121[16],
		                 n = caml_int_compare(a$14, b$14);
		                if(0 !== n) return cont(n);
		                var b$15 = b_122[17], a$15 = a_121[17];
		                return cont(caml_int_compare(a$15, b$15));
		               }
		               function sexp_of_t$85(param, cont){
		                var
		                 forced_major_collections_156 = param[17],
		                 stack_size_154 = param[16],
		                 top_heap_words_152 = param[15],
		                 compactions_150 = param[14],
		                 fragments_148 = param[13],
		                 largest_free_146 = param[12],
		                 free_blocks_144 = param[11],
		                 free_words_142 = param[10],
		                 live_blocks_140 = param[9],
		                 live_words_138 = param[8],
		                 heap_chunks_136 = param[7],
		                 heap_words_134 = param[6],
		                 major_collections_132 = param[5],
		                 minor_collections_130 = param[4],
		                 major_words_128 = param[3],
		                 promoted_words_126 = param[2],
		                 minor_words_124 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         forced_major_collections_156,
		                         function(arg_157){
		                          var bnds_123 = [0, [1, [0, aFr, [0, arg_157, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   stack_size_154,
		                                   function(arg_155){
		                                    var
		                                     bnds_123$0 = [0, [1, [0, aFs, [0, arg_155, 0]]], bnds_123];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     top_heap_words_152,
		     function(arg_153){
		      var
		       bnds_123 = [0, [1, [0, aFt, [0, arg_153, 0]]], bnds_123$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               compactions_150,
		               function(arg_151){
		                var
		                 bnds_123$0 = [0, [1, [0, aFu, [0, arg_151, 0]]], bnds_123];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         fragments_148,
		                         function(arg_149){
		                          var
		                           bnds_123 = [0, [1, [0, aFv, [0, arg_149, 0]]], bnds_123$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   largest_free_146,
		                                   function(arg_147){
		                                    var
		                                     bnds_123$0 = [0, [1, [0, aFw, [0, arg_147, 0]]], bnds_123];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     free_blocks_144,
		     function(arg_145){
		      var
		       bnds_123 = [0, [1, [0, aFx, [0, arg_145, 0]]], bnds_123$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               free_words_142,
		               function(arg_143){
		                var
		                 bnds_123$0 = [0, [1, [0, aFy, [0, arg_143, 0]]], bnds_123];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         live_blocks_140,
		                         function(arg_141){
		                          var
		                           bnds_123 = [0, [1, [0, aFz, [0, arg_141, 0]]], bnds_123$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   live_words_138,
		                                   function(arg_139){
		                                    var
		                                     bnds_123$0 = [0, [1, [0, aFA, [0, arg_139, 0]]], bnds_123];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     heap_chunks_136,
		     function(arg_137){
		      var
		       bnds_123 = [0, [1, [0, aFB, [0, arg_137, 0]]], bnds_123$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               heap_words_134,
		               function(arg_135){
		                var
		                 bnds_123$0 = [0, [1, [0, aFC, [0, arg_135, 0]]], bnds_123];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         major_collections_132,
		                         function(arg_133){
		                          var
		                           bnds_123 = [0, [1, [0, aFD, [0, arg_133, 0]]], bnds_123$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   minor_collections_130,
		                                   function(arg_131){
		                                    var
		                                     bnds_123$0 = [0, [1, [0, aFE, [0, arg_131, 0]]], bnds_123];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_float,
		     major_words_128,
		     function(arg_129){
		      var
		       bnds_123 = [0, [1, [0, aFF, [0, arg_129, 0]]], bnds_123$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_float,
		               promoted_words_126,
		               function(arg_127){
		                var
		                 bnds_123$0 = [0, [1, [0, aFG, [0, arg_127, 0]]], bnds_123];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_float,
		                         minor_words_124,
		                         function(arg_125){
		                          var
		                           bnds_123 = [0, [1, [0, aFH, [0, arg_125, 0]]], bnds_123$0];
		                          return cont([1, bnds_123]);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               Make_plain([0, compare$156, sexp_of_t$85]);
		               function compare$157(a_158, b_159, cont){
		                if(a_158 === b_159) return cont(0);
		                var b = b_159[1], a = a_158[1], n$8 = caml_int_compare(a, b);
		                if(0 !== n$8) return cont(n$8);
		                var
		                 b$0 = b_159[2],
		                 a$0 = a_158[2],
		                 n$7 = caml_int_compare(a$0, b$0);
		                if(0 !== n$7) return cont(n$7);
		                var
		                 b$1 = b_159[3],
		                 a$1 = a_158[3],
		                 n$6 = caml_int_compare(a$1, b$1);
		                if(0 !== n$6) return cont(n$6);
		                var
		                 b$2 = b_159[4],
		                 a$2 = a_158[4],
		                 n$5 = caml_int_compare(a$2, b$2);
		                if(0 !== n$5) return cont(n$5);
		                var
		                 b$3 = b_159[5],
		                 a$3 = a_158[5],
		                 n$4 = caml_int_compare(a$3, b$3);
		                if(0 !== n$4) return cont(n$4);
		                var
		                 b$4 = b_159[6],
		                 a$4 = a_158[6],
		                 n$3 = caml_int_compare(a$4, b$4);
		                if(0 !== n$3) return cont(n$3);
		                var
		                 b$5 = b_159[7],
		                 a$5 = a_158[7],
		                 n$2 = caml_int_compare(a$5, b$5);
		                if(0 !== n$2) return cont(n$2);
		                var
		                 b$6 = b_159[8],
		                 a$6 = a_158[8],
		                 n$1 = caml_int_compare(a$6, b$6);
		                if(0 !== n$1) return cont(n$1);
		                var
		                 b$7 = b_159[9],
		                 a$7 = a_158[9],
		                 n$0 = caml_int_compare(a$7, b$7);
		                if(0 !== n$0) return cont(n$0);
		                var
		                 b$8 = b_159[10],
		                 a$8 = a_158[10],
		                 n = caml_int_compare(a$8, b$8);
		                if(0 !== n) return cont(n);
		                var b$9 = b_159[11], a$9 = a_158[11];
		                return cont(caml_int_compare(a$9, b$9));
		               }
		               function sexp_of_t$86(param, cont){
		                var
		                 custom_minor_max_size_181 = param[11],
		                 custom_minor_ratio_179 = param[10],
		                 custom_major_ratio_177 = param[9],
		                 window_size_175 = param[8],
		                 allocation_policy_173 = param[7],
		                 stack_limit_171 = param[6],
		                 max_overhead_169 = param[5],
		                 verbose_167 = param[4],
		                 space_overhead_165 = param[3],
		                 major_heap_increment_163 = param[2],
		                 minor_heap_size_161 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         custom_minor_max_size_181,
		                         function(arg_182){
		                          var bnds_160 = [0, [1, [0, aFI, [0, arg_182, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   custom_minor_ratio_179,
		                                   function(arg_180){
		                                    var
		                                     bnds_160$0 = [0, [1, [0, aFJ, [0, arg_180, 0]]], bnds_160];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     custom_major_ratio_177,
		     function(arg_178){
		      var
		       bnds_160 = [0, [1, [0, aFK, [0, arg_178, 0]]], bnds_160$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               window_size_175,
		               function(arg_176){
		                var
		                 bnds_160$0 = [0, [1, [0, aFL, [0, arg_176, 0]]], bnds_160];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         allocation_policy_173,
		                         function(arg_174){
		                          var
		                           bnds_160 = [0, [1, [0, aFM, [0, arg_174, 0]]], bnds_160$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   stack_limit_171,
		                                   function(arg_172){
		                                    var
		                                     bnds_160$0 = [0, [1, [0, aFN, [0, arg_172, 0]]], bnds_160];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     max_overhead_169,
		     function(arg_170){
		      var
		       bnds_160 = [0, [1, [0, aFO, [0, arg_170, 0]]], bnds_160$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               verbose_167,
		               function(arg_168){
		                var
		                 bnds_160$0 = [0, [1, [0, aFP, [0, arg_168, 0]]], bnds_160];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         space_overhead_165,
		                         function(arg_166){
		                          var
		                           bnds_160 = [0, [1, [0, aFQ, [0, arg_166, 0]]], bnds_160$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   major_heap_increment_163,
		                                   function(arg_164){
		                                    var
		                                     bnds_160$0 = [0, [1, [0, aFR, [0, arg_164, 0]]], bnds_160];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     minor_heap_size_161,
		     function(arg_162){
		      var
		       bnds_160 = [0, [1, [0, aFS, [0, arg_162, 0]]], bnds_160$0];
		      return cont([1, bnds_160]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               Make_plain([0, compare$157, sexp_of_t$86]);
		               caml_int_of_string(cst_0);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Debug";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core__Core_sys";
		               record_start(d);
		               set$7(cst_core);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Core";
		               record_start(d);
		               set$7(cst_core);
		               uncaught_exception_handler[1] = print_with_backtrace;
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental_step_function";
		               record_start(d);
		               set$7("incremental_step_function");
		               function sexp_of_t$87(of_a_001, param, cont){
		                var steps_005 = param[2];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$4,
		                         function(param, cont){
		                          var arg0_007 = param[1];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$83,
		                                   arg0_007,
		                                   function(res0_009){
		                                    return caml_exact_trampoline_cps_call
		    (of_a_001,
		     dummy,
		     function(res1_010){
		      return cont([1, [0, res0_009, [0, res1_010, 0]]]);
		     });
		                                   });
		                         },
		                         steps_005,
		                         function(arg_006){
		                          var bnds_002 = [0, [1, [0, aFT, [0, arg_006, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (of_a_001,
		                                   dummy,
		                                   function(arg_004){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aFU, [0, arg_004, 0]]], bnds_002];
		                                    return cont([1, bnds_002$0]);
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Uopt";
		               record_start(d);
		               set$7("uopt");
		               var cst_Uopt_none = "Uopt.none";
		               function some$1(x, cont){
		                function a(a){return cont(x);}
		                return x === cst_Uopt_none
		                        ? caml_exact_trampoline_cps_call
		                          (failwith, "Uopt.some Uopt.none", a)
		                        : a();
		               }
		               function is_some$2(t){return 1 - (t === cst_Uopt_none);}
		               function value_exn$1(t, cont){
		                return t === cst_Uopt_none
		                        ? caml_exact_trampoline_cps_call
		                          (failwith, "Uopt.value_exn", cont)
		                        : cont(t);
		               }
		               function to_option$5(t, cont){
		                return t === cst_Uopt_none ? cont(0) : cont([0, t]);
		               }
		               var
		                include$317 =
		                  Of_sexpable1([0, , sexp_of_option], [0, to_option$5]),
		                sexp_of_t$88 = include$317[2];
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Thread_safe_queue";
		               record_start(d);
		               set$7("thread_safe_queue");
		               function sexp_of_t$89(of_a_001, param, cont){
		                var
		                 value_003 = param[1],
		                 bnds_002 = [0, [1, [0, aFV, [0, arg_006, 0]]], 0];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         of_a_001,
		                         value_003,
		                         function(arg_004){
		                          var
		                           bnds_002$0 = [0, [1, [0, aFW, [0, arg_004, 0]]], bnds_002];
		                          return cont([1, bnds_002$0]);
		                         });
		               }
		               function sexp_of_t$90(of_a_007, param, cont){
		                var
		                 length_009 = param[1],
		                 front_011 = param[2],
		                 back_013 = param[3],
		                 unused_elts_015 = param[4];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$89, of_a_007, a, cont);
		                         },
		                         unused_elts_015,
		                         function(arg_016){
		                          var bnds_008 = [0, [1, [0, aFX, [0, arg_016, 0]]], 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$89,
		                                   of_a_007,
		                                   back_013,
		                                   function(arg_014){
		                                    var
		                                     bnds_008$0 = [0, [1, [0, aFY, [0, arg_014, 0]]], bnds_008];
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$89,
		     of_a_007,
		     front_011,
		     function(arg_012){
		      var
		       bnds_008 = [0, [1, [0, aFZ, [0, arg_012, 0]]], bnds_008$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               length_009,
		               function(arg_010){
		                var
		                 bnds_008$0 = [0, [1, [0, aF0, [0, arg_010, 0]]], bnds_008];
		                return cont([1, bnds_008$0]);
		               });
		     });
		                                   });
		                         });
		               }
		               var none$3 = cst_Uopt_none;
		               function create$33(param){
		                var elt = [0, none$3, none$3];
		                return [0, 0, elt, elt, none$3];
		               }
		               function dequeue_exn(t, cont){
		                function a(b){
		                 var elt = t[2], a = elt[1];
		                 t[2] = elt[2];
		                 t[1] = t[1] - 1 | 0;
		                 elt[1] = none$3;
		                 elt[2] = t[4];
		                 return caml_exact_trampoline_cps_call
		                         (some$1, elt, function(b){t[4] = b; return cont(a);});
		                }
		                return t[1] === 0
		                        ? caml_exact_trampoline_cps_call$3
		                          (failwiths,
		                           0,
		                           aF2,
		                           "Thread_safe_queue.dequeue_exn of empty queue",
		                           t,
		                           function(x_018, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (sexp_of_t$90,
		                                     function(param, cont){return cont(aF1);},
		                                     x_018,
		                                     cont);
		                           },
		                           a)
		                        : a();
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Tuple_pool__Tuple_type_intf";
		               record_start(d);
		               j = "tuple_pool";
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Tuple_pool__Tuple_type";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Tuple_pool";
		               record_start(d);
		               set$7(j);
		               cd([0, "tuple_pool/src/tuple_pool.ml.Pool.Pointer.t"]);
		               function sexp_of_t$91(param, t, cont){
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         aF4,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a, t, function(a){return cont([0, a]);});
		                         });
		               }
		               function slot_index(t, slot){return (t & 4194303) + slot | 0;}
		               function tuple_id(t, cont){
		                var i = - (t + 1 | 0) | 0;
		                function a(a){return cont(i);}
		                return i < 0
		                        ? caml_exact_trampoline_cps_call$3
		                          (failwiths,
		                           0,
		                           aF3,
		                           "Tuple_id.of_int got negative int",
		                           i,
		                           sexp_of_int$0,
		                           a)
		                        : a();
		               }
		               function max_capacity(slots_per_tuple){
		                return caml_div(4194303, 1 + slots_per_tuple | 0);
		               }
		               function array_indices_per_tuple(t){return 1 + t[1] | 0;}
		               function array_length(t){
		                var a = array_indices_per_tuple(t);
		                return 1 + caml_mul(t[2], a) | 0;
		               }
		               function tuple_num_to_header_index(t, tuple_num){
		                return 1 + caml_mul(tuple_num, array_indices_per_tuple(t)) | 0;
		               }
		               function tuple_num_to_first_slot_index(t, tuple_num){
		                return tuple_num_to_header_index(t, tuple_num) + 1 | 0;
		               }
		               var metadata_index = 0;
		               function sexp_of_t$92(of_slots_014, arr, cont){
		                var
		                 param = arr[metadata_index + 1],
		                 capacity_018 = param[2],
		                 slots_per_tuple_016 = param[1],
		                 length_020 = param[3],
		                 next_id_022 = param[4],
		                 first_free_024 = param[5],
		                 dummy_026 = param[6],
		                 arg_027 = dummy_026 ? [1, [0, arg_006, 0]] : D,
		                 bnds_015 = [0, [1, [0, aF8, [0, arg_027, 0]]], 0];
		                function a(arg_025){
		                 var
		                  bnds_015$0 = [0, [1, [0, aF9, [0, arg_025, 0]]], bnds_015];
		                 return caml_exact_trampoline_cps_call
		                         (sexp_of_int$1,
		                          next_id_022,
		                          function(arg_023){
		                           var
		                            bnds_015 = [0, [1, [0, aF_, [0, arg_023, 0]]], bnds_015$0];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_int$0,
		                                    length_020,
		                                    function(arg_021){
		                                     var
		                                      bnds_015$0 = [0, [1, [0, aF$, [0, arg_021, 0]]], bnds_015];
		                                     return caml_exact_trampoline_cps_call
		     (sexp_of_int$0,
		      capacity_018,
		      function(arg_019){
		       var
		        bnds_015 = [0, [1, [0, aGa, [0, arg_019, 0]]], bnds_015$0];
		       return caml_exact_trampoline_cps_call
		               (sexp_of_int$0,
		                slots_per_tuple_016,
		                function(arg_017){
		                 var
		                  bnds_015$0 = [0, [1, [0, aGb, [0, arg_017, 0]]], bnds_015];
		                 return cont([1, bnds_015$0]);
		                });
		      });
		                                    });
		                          });
		                }
		                if(first_free_024 === 0) return a(aF5);
		                if(0 < first_free_024)
		                 return a([1, [0, aF6, [0, [0, "" + first_free_024], 0]]]);
		                return caml_exact_trampoline_cps_call
		                        (tuple_id,
		                         first_free_024,
		                         function(n){return a([1, [0, aF7, [0, [0, "" + n], 0]]]);});
		               }
		               function header_index_is_in_bounds(t, header_index){
		                var a = 1 <= header_index ? 1 : 0;
		                return a ? header_index < t.length - 1 ? 1 : 0 : a;
		               }
		               function pointer_is_valid(arr, pointer, cont){
		                var a = header_index_is_in_bounds(arr, pointer & 4194303);
		                if(! a) return cont(a);
		                var
		                 header_index = pointer & 4194303,
		                 header = arr[header_index + 1],
		                 a = header < 0 ? 1 : 0;
		                if(! a) return cont(a);
		                var b = pointer >>> 22 | 0;
		                return caml_exact_trampoline_cps_call
		                        (tuple_id,
		                         header,
		                         function(t){return cont((t & 1023) === b ? 1 : 0);});
		               }
		               function unsafe_add_to_free_list
		               (arr, metadata, next_free_header_index){
		                var header = metadata[5];
		                unsafe_set_int_assuming_curren
		                 (arr, next_free_header_index, header);
		                metadata[5] = next_free_header_index;
		               }
		               function create_array(metadata){
		                var
		                 len = array_length(metadata),
		                 arr = caml_make_vect(len, 0);
		                set$0(arr, metadata_index, metadata);
		                return arr;
		               }
		               function unsafe_init_range(t, metadata, lo, hi, cont){
		                var match = metadata[6];
		                function a(){
		                 var a = hi - 1 | 0;
		                 if(a >= lo){
		                  var tuple_num = a;
		                  for(;;){
		                   unsafe_add_to_free_list
		                    (t,
		                     metadata,
		                     tuple_num_to_header_index(metadata, tuple_num));
		                   a = tuple_num - 1 | 0;
		                   if(lo === tuple_num) break;
		                   tuple_num = a;
		                  }
		                 }
		                 return cont();
		                }
		                if(! match) return a();
		                var dummy = match[1], b = hi - 1 | 0;
		                function c(tuple_num){
		                 var d = metadata[1];
		                 return caml_exact_trampoline_cps_call$3
		                         (blit$3,
		                          dummy,
		                          0,
		                          t,
		                          tuple_num_to_first_slot_index(metadata, tuple_num),
		                          d,
		                          function(d){
		                           d = tuple_num + 1 | 0;
		                           return b !== tuple_num
		                                   ? caml_exact_trampoline_call1(c, d)
		                                   : a();
		                          });
		                }
		                return b < lo ? a() : c(lo);
		               }
		               var t0$0 = 1;
		               function free(arr, pointer, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pointer_is_valid,
		                         arr,
		                         pointer,
		                         function(b){
		                          function a(a){
		                           var metadata = arr[metadata_index + 1];
		                           metadata[3] = metadata[3] - 1 | 0;
		                           unsafe_add_to_free_list(arr, metadata, pointer & 4194303);
		                           a = metadata[6];
		                           if(a){
		                            var dummy = a[1], a = metadata[1];
		                            return cont
		                                    (unsafe_blit$2(dummy, 0, arr, slot_index(pointer, t0$0), a));
		                           }
		                           var
		                            pos = slot_index(pointer, t0$0),
		                            a = metadata[1] - 1 | 0;
		                           if(a >= 0){
		                            var i = 0;
		                            for(;;){
		                             var i$0 = pos + i | 0, old_obj = arr[i$0 + 1];
		                             if(1 - (typeof old_obj === "number"))
		                              unsafe_set_with_caml_modify(arr, i$0, 0);
		                             var b = i + 1 | 0;
		                             if(a === i) break;
		                             i = b;
		                            }
		                           }
		                           return cont();
		                          }
		                          return 1 - b
		                                  ? caml_exact_trampoline_cps_call$3
		                                    (failwiths,
		                                     0,
		                                     aGe,
		                                     "Pool.free of invalid pointer",
		                                     [0, pointer, arr],
		                                     function(param, cont){
		                                      var arg1_045 = param[2], arg0_044 = param[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (sexp_of_t$91,
		       dummy,
		       arg0_044,
		       function(res0_046){
		        return caml_exact_trampoline_cps_call$1
		                (sexp_of_t$92,
		                 dummy,
		                 arg1_045,
		                 function(res1_047){
		                  return cont([1, [0, res0_046, [0, res1_047, 0]]]);
		                 });
		       });
		                                     },
		                                     a)
		                                  : a(0);
		                         });
		               }
		               function get$10(arr, p, slot){
		                var i = slot_index(p, slot);
		                return get$3(arr, i);
		               }
		               function set$8(arr, p, slot, x){
		                var i = slot_index(p, slot);
		                return set$0(arr, i, x);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Timing_wheel";
		               record_start(d);
		               set$7("timing_wheel");
		               var max_num_bits = num_bits$4 - 1 | 0;
		               function invariant(t){
		                if(0 > t)
		                 throw caml_maybe_attach_backtrace
		                        ([0, Assert_failure, aGg], 1);
		                if(t <= max_num_bits) return;
		                throw caml_maybe_attach_backtrace([0, Assert_failure, aGf], 1);
		               }
		               function of_int$8(i, cont){invariant(i); return cont(i);}
		               function symbol$215(t1, t2, cont){
		                var t = t1 + t2 | 0;
		                invariant(t);
		                return cont(t);
		               }
		               function symbol$216(t1, t2){
		                var t = t1 - t2 | 0;
		                invariant(t);
		                return t;
		               }
		               function create_exn$0(opt, x_008, cont){
		                var extend_to_max_num_bits = opt ? opt[1] : 0;
		                function a(t){
		                 if(t){
		                  var xs = t[2], bits = t[1];
		                  if(bits > 0) return caml_exact_trampoline_call1(a, xs);
		                  var b = 1;
		                 }
		                 else
		                  b = 0;
		                 function c(c){
		                  var num_bits = 0, t = x_008;
		                  for(;;){
		                   if(! t) break;
		                   var l = t[2], a = t[1], init = num_bits + a | 0;
		                   num_bits = init;
		                   t = l;
		                  }
		                  function b(b){
		                   function a(ints){
		                    return caml_exact_trampoline_cps_call$1
		                            (map$7, ints, of_int$8, cont);
		                   }
		                   if(! extend_to_max_num_bits) return a(x_008);
		                   return caml_exact_trampoline_cps_call$1
		                           (init$7,
		                            max_num_bits - num_bits | 0,
		                            function(param, cont){return cont(1);},
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (append$0, x_008, b, a);
		                            });
		                  }
		                  if(max_num_bits >= num_bits) return b();
		                  return caml_exact_trampoline_cps_call
		                          (sexp_of_int$0,
		                           max_num_bits,
		                           function(c){
		                            var a = [0, [1, [0, aGh, [0, c, 0]]], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (sexp_of_int$0,
		                                     num_bits,
		                                     function(d){
		                                      var c = [0, [1, [0, aGi, [0, d, 0]]], a];
		                                      return caml_exact_trampoline_cps_call$1
		      (sexp_of_list,
		       sexp_of_int$0,
		       x_008,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (raise_s,
		                 [1,
		                  [0,
		                   [0, "Level_bits.create_exn got too many bits"],
		                   [0, a, c]]],
		                 b);
		       });
		                                     });
		                           });
		                 }
		                 if(! b) return c();
		                 return caml_exact_trampoline_cps_call$1
		                         (sexp_of_list,
		                          sexp_of_int$0,
		                          x_008,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (raise_s,
		                                    [1,
		                                     [0,
		                                      [0, "Level_bits.create_exn got nonpositive num bits"],
		                                      [0, a, 0]]],
		                                    c);
		                          });
		                }
		                return is_empty(x_008)
		                        ? caml_exact_trampoline_cps_call
		                          (failwith,
		                           "Level_bits.create_exn requires a nonempty list",
		                           function(b){return a(x_008);})
		                        : a(x_008);
		               }
		               caml_callback(create_exn$0, [0, aGj]);
		               function max_num_level_bits(alarm_precision){
		                invariant(alarm_precision);
		                return symbol$216(max_num_bits, alarm_precision);
		               }
		               function sexp_of_t$93(of_a_035, x_036, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$91, dummy, x_036, cont);
		               }
		               function of_external_exn(pool, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pointer_is_valid,
		                         pool,
		                         t,
		                         function(a){
		                          return a
		                                  ? cont(t)
		                                  : caml_exact_trampoline_cps_call
		                                    (raise_s, [0, "Timing_wheel got invalid alarm"], cont);
		                         });
		               }
		               var t4$0 = 5, t5$0 = 6;
		               function link(pool, prev, next){
		                set$8(pool, prev, t5$0, next);
		                return set$8(pool, next, t4$0, prev);
		               }
		               function iter$8(pool, first, f){
		                var continue$ = 1, current = first;
		                for(;;){
		                 if(! continue$) return;
		                 var next = get$10(pool, current, t5$0);
		                 f(current);
		                 if(next === first) continue$ = 0; else current = next;
		                }
		               }
		               function sexp_of_t$94(of_a_044, param, cont){
		                var
		                 diff_max_min_allowed_key_058 = param[7],
		                 min_key_in_same_slot_mask_056 = param[6],
		                 keys_per_slot_054 = param[5],
		                 bits_per_slot_052 = param[4],
		                 slots_mask_050 = param[3],
		                 bits_048 = param[2],
		                 index_046 = param[1],
		                 length_060 = param[8],
		                 min_allowed_key_062 = param[9],
		                 max_allowed_key_064 = param[10],
		                 bnds_045 = [0, [1, [0, aGk, [0, arg_006, 0]]], 0];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$18,
		                         max_allowed_key_064,
		                         function(arg_065){
		                          var
		                           bnds_045$0 = [0, [1, [0, aGl, [0, arg_065, 0]]], bnds_045];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$18,
		                                   min_allowed_key_062,
		                                   function(arg_063){
		                                    var
		                                     bnds_045 = [0, [1, [0, aGm, [0, arg_063, 0]]], bnds_045$0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     length_060,
		     function(arg_061){
		      var
		       bnds_045$0 = [0, [1, [0, aGn, [0, arg_061, 0]]], bnds_045];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_t$18,
		               diff_max_min_allowed_key_058,
		               function(arg_059){
		                var
		                 bnds_045 = [0, [1, [0, aGo, [0, arg_059, 0]]], bnds_045$0];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$18,
		                         min_key_in_same_slot_mask_056,
		                         function(arg_057){
		                          var
		                           bnds_045$0 = [0, [1, [0, aGp, [0, arg_057, 0]]], bnds_045];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$18,
		                                   keys_per_slot_054,
		                                   function(arg_055){
		                                    var
		                                     bnds_045 = [0, [1, [0, aGq, [0, arg_055, 0]]], bnds_045$0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     bits_per_slot_052,
		     function(arg_053){
		      var
		       bnds_045$0 = [0, [1, [0, aGr, [0, arg_053, 0]]], bnds_045];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_t$18,
		               slots_mask_050,
		               function(arg_051){
		                var
		                 bnds_045 = [0, [1, [0, aGs, [0, arg_051, 0]]], bnds_045$0];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         bits_048,
		                         function(arg_049){
		                          var
		                           bnds_045$0 = [0, [1, [0, aGt, [0, arg_049, 0]]], bnds_045];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   index_046,
		                                   function(arg_047){
		                                    var
		                                     bnds_045 = [0, [1, [0, aGu, [0, arg_047, 0]]], bnds_045$0];
		                                    return cont([1, bnds_045]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function slot$0(t, key, cont){
		                var slots_mask = t[3], bits_per_slot = t[4];
		                return caml_exact_trampoline_cps_call
		                        (to_int_exn$0,
		                         bit_and$0(shift_right$5(key, bits_per_slot), slots_mask),
		                         cont);
		               }
		               function num_levels(t){return t[5].length - 1;}
		               function min_allowed_key(t){
		                var r = caml_check_bound(t[5], 0)[1];
		                return r[9];
		               }
		               function max_allowed_key(t){
		                var
		                 a = num_levels(t) - 1 | 0,
		                 r = caml_check_bound(t[5], a)[a + 1];
		                return r[10];
		               }
		               function internal_iter(t, f){
		                if(0 < t[1]){
		                 var pool = t[2], levels = t[5], b = levels.length - 2 | 0;
		                 if(b >= 0){
		                  var level_index = 0;
		                  for(;;){
		                   var
		                    level =
		                      caml_check_bound(levels, level_index)[level_index + 1];
		                   if(0 < level[8]){
		                    var slots = level[11], a = slots.length - 2 | 0;
		                    if(a >= 0){
		                     var slot_index = 0;
		                     for(;;){
		                      var
		                       elt = caml_check_bound(slots, slot_index)[slot_index + 1];
		                      if(1 - (elt === -15)) iter$8(pool, elt, f);
		                      var c = slot_index + 1 | 0;
		                      if(a === slot_index) break;
		                      slot_index = c;
		                     }
		                    }
		                   }
		                   a = level_index + 1 | 0;
		                   if(b === level_index) break;
		                   level_index = a;
		                  }
		                 }
		                }
		               }
		               var t3$1 = 4;
		               function add_elt(x_114, to_add, cont){
		                var
		                 pool$0 = x_114[2],
		                 key = get$10(pool$0, to_add, t0$0),
		                 a = greater_equal$0(key, min_allowed_key(x_114)),
		                 a = a ? symbol$46(key, max_allowed_key(x_114)) : a;
		                function b(a){
		                 var level_index = 0;
		                 for(;;){
		                  var
		                   r = caml_check_bound(x_114[5], level_index)[level_index + 1];
		                  if(! symbol$48(key, r[10])) break;
		                  var level_index$0 = level_index + 1 | 0;
		                  level_index = level_index$0;
		                 }
		                 var
		                  level =
		                    caml_check_bound(x_114[5], level_index)[level_index + 1],
		                  a = greater_equal$0(key, level[9]),
		                  a = a ? symbol$46(key, level[10]) : a;
		                 function b(a){
		                  level[8] = level[8] + 1 | 0;
		                  set$8(pool$0, to_add, t3$1, level_index);
		                  return caml_exact_trampoline_cps_call$1
		                          (slot$0,
		                           level,
		                           key,
		                           function(slot){
		                            var
		                             slots = level[11],
		                             first = caml_check_bound(slots, slot)[slot + 1];
		                            if(first === -15){
		                             caml_check_bound(slots, slot)[slot + 1] = to_add;
		                             return cont(link(pool$0, to_add, to_add));
		                            }
		                            var prev = get$10(pool$0, first, t4$0);
		                            link(pool$0, prev, to_add);
		                            return cont(link(pool$0, to_add, first));
		                           });
		                 }
		                 if(! (1 - a)) return b();
		                 return caml_exact_trampoline_cps_call$1
		                         (sexp_of_t$94,
		                          dummy,
		                          level,
		                          function(c){
		                           var a = [0, [1, [0, aGF, [0, c, 0]]], 0];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_t$18,
		                                    key,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call
		     (raise_s,
		      [1,
		       [0,
		        [0, "Priority_queue.add_elt key out of level bounds"],
		        [0, [1, [0, aGG, [0, c, 0]]], a]]],
		      b);
		                                    });
		                          });
		                }
		                if(! (1 - a)) return b(0);
		                function sexp_of_a(param){return aGA;}
		                var pool = x_114[2], r = [0, 0];
		                internal_iter
		                 (x_114,
		                  function(elt){
		                   var a = r[1], b = get$10(pool, elt, 3);
		                   r[1] = [0, [0, get$10(pool, elt, t0$0), b], a];
		                  });
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys,
		                         r[1],
		                         function(elts_094){
		                          var
		                           max_allowed_key_092 = max_allowed_key(x_114),
		                           min_allowed_key_090 = min_allowed_key(x_114);
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_list,
		                                   function(param, cont){
		                                    var
		                                     key_084 = param[1],
		                                     arg_087 = sexp_of_a(),
		                                     bnds_083 = [0, [1, [0, aGv, [0, arg_087, 0]]], 0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$18,
		     key_084,
		     function(arg_085){
		      var
		       bnds_083$0 = [0, [1, [0, aGw, [0, arg_085, 0]]], bnds_083];
		      return cont([1, bnds_083$0]);
		     });
		                                   },
		                                   elts_094,
		                                   function(arg_095){
		                                    var bnds_089 = [0, [1, [0, aGx, [0, arg_095, 0]]], 0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$18,
		     max_allowed_key_092,
		     function(arg_093){
		      var
		       bnds_089$0 = [0, [1, [0, aGy, [0, arg_093, 0]]], bnds_089];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_t$18,
		               min_allowed_key_090,
		               function(arg_091){
		                var
		                 bnds_089 = [0, [1, [0, aGz, [0, arg_091, 0]]], bnds_089$0],
		                 a = [0, [1, [0, aGB, [0, [1, bnds_089], 0]]], 0];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$18,
		                         max_allowed_key(x_114),
		                         function(d){
		                          var c = [0, [1, [0, aGC, [0, d, 0]]], a];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$18,
		                                   min_allowed_key(x_114),
		                                   function(d){
		                                    var a = [0, [1, [0, aGD, [0, d, 0]]], c];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$18,
		     key,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (raise_s,
		               [1,
		                [0,
		                 [0, "Priority_queue.add_elt key out of bounds"],
		                 [0, [1, [0, aGE, [0, c, 0]]], a]]],
		               b);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function internal_add(t, key, at, value, cont){
		                var
		                 a = symbol$49(key, min_allowed_key(t)),
		                 a = a || symbol$48(key, max_allowed_key(t));
		                function b(a){
		                 var arr = t[2], t$0 = arr[metadata_index + 1];
		                 function b(){
		                  var
		                   pool = t[2],
		                   metadata = pool[metadata_index + 1],
		                   header_index = metadata[5];
		                  function a(a){
		                   metadata[5] = pool[header_index + 1];
		                   metadata[3] = metadata[3] + 1 | 0;
		                   var tuple_id = metadata[4], header = -1 - tuple_id | 0;
		                   unsafe_set_int_assuming_curren(pool, header_index, header);
		                   a = tuple_id === 2147483647 ? 0 : tuple_id + 1 | 0;
		                   metadata[4] = a;
		                   var
		                    pointer = header_index | (tuple_id & 1023) << 22,
		                    offset = pointer & 4194303,
		                    i = offset + 1 | 0;
		                   unsafe_set(pool, i, key);
		                   var i$0 = offset + 2 | 0;
		                   unsafe_set(pool, i$0, at);
		                   var i$1 = offset + 3 | 0;
		                   unsafe_set(pool, i$1, value);
		                   var i$2 = offset + 4 | 0;
		                   unsafe_set(pool, i$2, -1);
		                   var i$3 = offset + 5 | 0;
		                   unsafe_set(pool, i$3, -15);
		                   var i$4 = offset + 6 | 0;
		                   unsafe_set(pool, i$4, -15);
		                   var p = t[2], key$0 = get$10(p, pointer, t0$0);
		                   if(symbol$49(key$0, t[4])){t[3] = pointer; t[4] = key$0;}
		                   return caml_exact_trampoline_cps_call$1
		                           (add_elt,
		                            t,
		                            pointer,
		                            function(a){t[1] = t[1] + 1 | 0; return cont(pointer);});
		                  }
		                  return header_index === 0
		                          ? caml_exact_trampoline_cps_call$3
		                            (failwiths,
		                             0,
		                             aGd,
		                             "Pool.malloc of full pool",
		                             pool,
		                             function(x_043, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (sexp_of_t$92, dummy, x_043, cont);
		                             },
		                             a)
		                          : a(0);
		                 }
		                 if(t$0[3] !== t$0[2]) return b();
		                 var
		                  arr$0 = t[2],
		                  a = arr$0[metadata_index + 1],
		                  old_capacity = a[2],
		                  slots_per_tuple = a[1],
		                  length = a[3],
		                  next_id = a[4],
		                  dummy$0 = a[6],
		                  a = old_capacity === 0 ? 1 : old_capacity * 2 | 0;
		                 return caml_exact_trampoline_cps_call$1
		                         (min$2,
		                          max_capacity(slots_per_tuple),
		                          a,
		                          function(capacity){
		                           function a(a){
		                            var
		                             header = 0,
		                             metadata =
		                               [0,
		                                slots_per_tuple,
		                                capacity,
		                                length,
		                                next_id,
		                                header,
		                                dummy$0],
		                             arr = create_array(metadata),
		                             start_of_tuples_index = 1;
		                            return caml_exact_trampoline_cps_call$3
		                                    (blit$3,
		                                     arr$0,
		                                     start_of_tuples_index,
		                                     arr,
		                                     start_of_tuples_index,
		                                     caml_mul(old_capacity, array_indices_per_tuple(metadata)),
		                                     function(a){
		                                      var
		                                       metadata$0 = arr$0[metadata_index + 1],
		                                       a = metadata$0[6];
		                                      function c(){
		                                       var
		metadata$1 =
		  [0,
		   metadata$0[1],
		   0,
		   0,
		   metadata$0[4],
		   header,
		   metadata$0[6]];
		                                       set$0(arr$0, metadata_index, metadata$1);
		                                       return caml_exact_trampoline_cps_call$2
		       (unsafe_init_range,
		        arr,
		        metadata,
		        old_capacity,
		        capacity,
		        function(a){
		         a = old_capacity - 1 | 0;
		         if(a >= 0){
		          var tuple_num = a;
		          for(;;){
		           var
		            header_index =
		              tuple_num_to_header_index(metadata, tuple_num),
		            header = arr[header_index + 1];
		           if(1 - (header < 0))
		            unsafe_add_to_free_list(arr, metadata, header_index);
		           a = tuple_num - 1 | 0;
		           if(0 === tuple_num) break;
		           tuple_num = a;
		          }
		         }
		         t[2] = arr;
		         return b();
		        });
		                                      }
		                                      if(a){
		                                       var
		dummy = a[1],
		d = metadata$0[2] - 1 | 0,
		e =
		  function(tuple_num){
		   var
		    header_index =
		      tuple_num_to_header_index(metadata$0, tuple_num);
		   unsafe_set_int_assuming_curren(arr$0, header_index, header);
		   return caml_exact_trampoline_cps_call$3
		           (blit$3,
		            dummy,
		            0,
		            arr$0,
		            header_index + 1 | 0,
		            metadata$0[1],
		            function(a){
		             a = tuple_num + 1 | 0;
		             return d !== tuple_num
		                     ? caml_exact_trampoline_call1(e, a)
		                     : c();
		            });
		  };
		                                       return d < 0 ? c() : e(0);
		                                      }
		                                      a = arr$0.length - 2 | 0;
		                                      if(a < 1) return c();
		                                      var i = start_of_tuples_index;
		                                      for(;;){
		                                       unsafe_set(arr$0, i, 0);
		                                       var f = i + 1 | 0;
		                                       if(a === i) return c();
		                                       i = f;
		                                      }
		                                     });
		                           }
		                           return capacity === old_capacity
		                                   ? caml_exact_trampoline_cps_call$3
		                                     (failwiths,
		                                      0,
		                                      aGc,
		                                      "Pool.grow cannot grow pool; capacity already at maximum",
		                                      capacity,
		                                      sexp_of_int$0,
		                                      a)
		                                   : a();
		                          });
		                }
		                if(! a) return b(0);
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$18,
		                         max_allowed_key(t),
		                         function(c){
		                          var a = [0, [1, [0, aGH, [0, c, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$18,
		                                   min_allowed_key(t),
		                                   function(d){
		                                    var c = [0, [1, [0, aGI, [0, d, 0]]], a];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$18,
		     key,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (raise_s,
		               [1,
		                [0,
		                 [0,
		                  "Timing_wheel.add_at_interval_num got invalid interval num"],
		                 [0, [1, [0, aGJ, [0, a, 0]]], c]]],
		               b);
		     });
		                                   });
		                         });
		               }
		               function internal_remove(t, elt, cont){
		                var pool = t[2], t2 = t[3];
		                if(elt === t2) t[3] = -15;
		                t[1] = t[1] - 1 | 0;
		                var
		                 a = get$10(pool, elt, t3$1),
		                 level = caml_check_bound(t[5], a)[a + 1];
		                level[8] = level[8] - 1 | 0;
		                var slots = level[11];
		                return caml_exact_trampoline_cps_call$1
		                        (slot$0,
		                         level,
		                         get$10(pool, elt, t0$0),
		                         function(slot){
		                          var first = caml_check_bound(slots, slot)[slot + 1];
		                          if(elt === get$10(pool, elt, t5$0)){
		                           caml_check_bound(slots, slot)[slot + 1] = -15;
		                           return cont();
		                          }
		                          if(elt === first){
		                           var a = get$10(pool, elt, t5$0);
		                           caml_check_bound(slots, slot)[slot + 1] = a;
		                          }
		                          var
		                           x$0 = get$10(pool, elt, t5$0),
		                           t$0 = get$10(pool, elt, t4$0);
		                          set$8(pool, t$0, t5$0, x$0);
		                          var
		                           x = get$10(pool, elt, t4$0),
		                           t = get$10(pool, elt, t5$0);
		                          return cont(set$8(pool, t, t4$0, x));
		                         });
		               }
		               function interval_num_unchecked(t, time){
		                var
		                 alarm_precision = t[1][1],
		                 i = shift_right$5(time, alarm_precision);
		                return i;
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Weak_array";
		               record_start(d);
		               set$7("weak_array");
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Weak_pointer";
		               record_start(d);
		               set$7("weak_pointer");
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Weak_hashtbl";
		               record_start(d);
		               set$7("weak_hashtbl");
		               var index$3 = 0;
		               function sexp_of_t$95(of_a_001, sexp_of_a, param, cont){
		                var
		                 keys_with_unused_data_006 = param[2],
		                 entry_by_key_004 = param[1],
		                 bnds_003 = [0, [1, [0, aGO, [0, res0_003, 0]]], 0];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$90,
		                         of_a_001,
		                         keys_with_unused_data_006,
		                         function(arg_007){
		                          var
		                           bnds_003$0 = [0, [1, [0, aGP, [0, arg_007, 0]]], bnds_003];
		                          return caml_exact_trampoline_cps_call$0
		                                  (sexp_of_t$19,
		                                   of_a_001,
		                                   function(t, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (get$1,
		     t,
		     index$3,
		     function(x_001){
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_option, sexp_of_a, x_001, cont);
		     });
		                                   },
		                                   entry_by_key_004,
		                                   function(arg_005){
		                                    var
		                                     bnds_003 = [0, [1, [0, aGQ, [0, arg_005, 0]]], bnds_003$0];
		                                    return cont([1, bnds_003]);
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Before_or_after";
		               record_start(d);
		               j = "incremental";
		               set$7(j);
		               function sexp_of_t$96(param, cont){
		                return param ? cont(aGR) : cont(aGS);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Import";
		               record_start(d);
		               set$7(j);
		               function realloc(t, len, a, cont){
		                var new_t = caml_make_vect(len, a);
		                return caml_exact_trampoline_cps_call$3
		                        (blit$2,
		                         t,
		                         0,
		                         new_t,
		                         0,
		                         t.length - 1,
		                         function(a){return cont(new_t);});
		               }
		               function realloc$0(t, len, cont){
		                var new_t = create$12(len, none$3);
		                return caml_exact_trampoline_cps_call$3
		                        (blit$3,
		                         t,
		                         0,
		                         new_t,
		                         0,
		                         t.length - 1,
		                         function(a){return cont(new_t);});
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Cutoff";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$97(of_a_001, param){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return aGT;
		                   case 1:
		                    return aGU;
		                   default: return aGV;
		                 }
		                switch(param[0]){
		                  case 0:
		                   return [1, [0, aGW, [0, res0_003, 0]]];
		                  case 1:
		                   return [1, [0, aGX, [0, res0_003, 0]]];
		                  default: return [1, [0, aGY, [0, res0_003, 0]]];
		                }
		               }
		               function should_cutoff(t, old_value, new_value, cont){
		                if(typeof t === "number")
		                 switch(t){
		                   case 0:
		                    return cont(1);
		                   case 1:
		                    return cont(0);
		                   default: return cont(old_value === new_value ? 1 : 0);
		                 }
		                if(0 === t[0]){
		                 var f = t[1];
		                 return caml_trampoline_cps_call3
		                         (f,
		                          old_value,
		                          new_value,
		                          function(a){return cont(a === 0 ? 1 : 0);});
		                }
		                var f$0 = t[1];
		                return caml_trampoline_cps_call3
		                        (f$0, old_value, new_value, cont);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Dot_user_info";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$98(x_007, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_list, sexp_of_string$0, x_007, cont);
		               }
		               function sexp_of_t$99(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    arg0_032 = param[1],
		                    attributes_014 = arg0_032[2],
		                    label_012 = arg0_032[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (Map$1[45],
		                            sexp_of_string$0,
		                            attributes_014,
		                            function(arg_015){
		                             var bnds_011 = [0, [1, [0, aGZ, [0, arg_015, 0]]], 0];
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_m_t,
		                                      [0, sexp_of_t$98],
		                                      label_012,
		                                      function(arg_013){
		                                       var
		bnds_011$0 = [0, [1, [0, aG0, [0, arg_013, 0]]], bnds_011];
		                                       return cont([1, [0, aG1, [0, [1, bnds_011$0], 0]]]);
		                                      });
		                            });
		                  case 1:
		                   var arg0_034 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$64,
		                            arg0_034,
		                            function(res0_035){
		                             return cont([1, [0, aG2, [0, res0_035, 0]]]);
		                            });
		                  default:
		                   var new_039 = param[2], prior_037 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$99,
		                            new_039,
		                            function(arg_040){
		                             var bnds_036 = [0, [1, [0, aG3, [0, arg_040, 0]]], 0];
		                             return caml_exact_trampoline_cps_call
		                                     (sexp_of_t$99,
		                                      prior_037,
		                                      function(arg_038){
		                                       var
		bnds_036$0 = [0, [1, [0, aG4, [0, arg_038, 0]]], bnds_036];
		                                       return cont([1, [0, aG5, bnds_036$0]]);
		                                      });
		                            });
		                }
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Node_id";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Stabilization_num";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__On_update_handler";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$100(of_a_009, param){
		                if(typeof param === "number") return 0 === param ? aG$ : aHa;
		                if(0 === param[0]){
		                 var res0_011 = of_a_009();
		                 return [1, [0, aHb, [0, res0_011, 0]]];
		                }
		                var res0_014 = of_a_009(), res1_015 = of_a_009();
		                return [1, [0, aHc, [0, res0_014, [0, res1_015, 0]]]];
		               }
		               function sexp_of_t$101(of_a_017, param, cont){
		                var
		                 previous_update_kind_021 = param[2],
		                 created_at_023 = param[3];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         created_at_023,
		                         function(arg_024){
		                          var bnds_018 = [0, [1, [0, aHd, [0, arg_024, 0]]], 0];
		                          switch(previous_update_kind_021){
		                            case 0:
		                             var arg_022 = aG6; break;
		                            case 1:
		                             arg_022 = aG7; break;
		                            case 2:
		                             arg_022 = aG8; break;
		                            case 3:
		                             arg_022 = aG9; break;
		                            default: arg_022 = aG_;
		                          }
		                          var
		                           bnds_018$0 = [0, [1, [0, aHe, [0, arg_022, 0]]], bnds_018];
		                          return cont
		                                  ([1, [0, [1, [0, aHf, [0, res0_003, 0]]], bnds_018$0]]);
		                         });
		               }
		               function create$34(f, created_at){return [0, f, 0, created_at];
		               }
		               function really_run(t, node_update, cont){
		                var
		                 a =
		                   typeof node_update === "number"
		                    ? 0 === node_update ? 3 : 4
		                    : 0 === node_update[0] ? 1 : 2;
		                t[2] = a;
		                return caml_trampoline_cps_call2(t[1], node_update, cont);
		               }
		               function run$3(t, node_update, now, cont){
		                var b = caml_int_compare(t[3], now) < 0 ? 1 : 0;
		                if(! b) return cont(b);
		                a:
		                {
		                 b:
		                 {
		                  switch(t[2]){
		                    case 0:
		                     if(typeof node_update === "number") break b;
		                     if(0 === node_update[0]) break b;
		                     break a;
		                    case 1:
		                     if(typeof node_update === "number" || 0 !== node_update[0])
		                      break b;
		                     break;
		                    case 2:
		                     if(typeof node_update === "number" || 0 !== node_update[0])
		                      break b;
		                     break;
		                    case 3:
		                     return cont();
		                    default:
		                     if(typeof node_update !== "number"){
		                      if(0 === node_update[0]) break b;
		                      break a;
		                     }
		                     if(0 === node_update) break b;
		                  }
		                  return cont();
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (really_run, t, node_update, cont);
		                }
		                var a = node_update[2];
		                return caml_exact_trampoline_cps_call$1
		                        (really_run, t, [0, a], cont);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Raised_exn";
		               record_start(d);
		               set$7(j);
		               function reraise_with_message(param, msg){
		                param[2]; var exn = param[1];
		                return raise_with_original_backtrace
		                        ([0, Reraised, msg, exn]);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Types";
		               record_start(d);
		               set$7(j);
		               var
		                Adjust_heights_heap = caml_callback(init_mod, [aHj, aHi]),
		                Alarm = caml_callback(init_mod, [aHl, aHk]),
		                Alarm_value = caml_callback(init_mod, [aHn, aHm]),
		                Array_fold = caml_callback(init_mod, [aHp, aHo]),
		                At$0 = caml_callback(init_mod, [aHr, aHq]),
		                At_intervals = caml_callback(init_mod, [aHt, aHs]),
		                Bind = caml_callback(init_mod, [aHv, aHu]),
		                Clock = caml_callback(init_mod, [aHx, aHw]),
		                Expert = caml_callback(init_mod, [aHz, aHy]),
		                Freeze = caml_callback(init_mod, [aHB, aHA]),
		                If_then_else = caml_callback(init_mod, [aHD, aHC]),
		                Internal_observer = caml_callback(init_mod, [aHF, aHE]),
		                Join = caml_callback(init_mod, [aHH, aHG]),
		                Kind = caml_callback(init_mod, [aHJ, aHI]),
		                Node = caml_callback(init_mod, [aHL, aHK]),
		                Observer = caml_callback(init_mod, [aHN, aHM]),
		                Only_in_debug = caml_callback(init_mod, [aHP, aHO]),
		                Packed_weak_hashtbl = caml_callback(init_mod, [aHR, aHQ]),
		                Recompute_heap = caml_callback(init_mod, [aHT, aHS]),
		                Run_on_update_handlers = caml_callback(init_mod, [aHV, aHU]),
		                include$130 = caml_callback(init_mod, [aHX, aHW]),
		                Snapshot = caml_callback(init_mod, [aHZ, aHY]),
		                State$0 = caml_callback(init_mod, [aH1, aH0]),
		                Status = caml_callback(init_mod, [aH3, aH2]),
		                Step_function_node = caml_callback(init_mod, [aH5, aH4]),
		                Unordered_array_fold = caml_callback(init_mod, [aH7, aH6]),
		                Var = caml_callback(init_mod, [aH9, aH8]);
		               caml_callback
		                (update_mod, [aH_, Adjust_heights_heap, Adjust_heights_heap]);
		               caml_callback(update_mod, [aH$, Alarm, Alarm]);
		               caml_callback(update_mod, [aIa, Alarm_value, Alarm_value]);
		               caml_callback(update_mod, [aIb, Array_fold, Array_fold]);
		               caml_callback(update_mod, [aIc, At$0, At$0]);
		               caml_callback(update_mod, [aId, At_intervals, At_intervals]);
		               caml_callback(update_mod, [aIe, Bind, Bind]);
		               caml_callback(update_mod, [aIf, Clock, Clock]);
		               caml_callback(update_mod, [aIg, Expert, Expert]);
		               caml_callback(update_mod, [aIh, Freeze, Freeze]);
		               caml_callback(update_mod, [aIi, If_then_else, If_then_else]);
		               caml_callback
		                (update_mod, [aIj, Internal_observer, Internal_observer]);
		               caml_callback(update_mod, [aIk, Join, Join]);
		               caml_callback(update_mod, [aIl, Kind, Kind]);
		               function sexp_of_node(param, t, cont){
		                var n = t[1];
		                return caml_exact_trampoline_cps_call$1
		                        (concat$0,
		                         0,
		                         [0, cst_n$0, [0, "" + n, 0]],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_string$0, a, cont);
		                         });
		               }
		               function sexp_of_t$102(x_003, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_node, dummy, x_003, cont);
		               }
		               function is_valid$0(t, cont){
		                var match = t[5];
		                if(typeof match === "number" && ! match) return cont(0);
		                return cont(1);
		               }
		               function is_necessary(t, cont){
		                var a = 0 < t[9] ? 1 : 0;
		                if(a)
		                 ;
		                else {
		                 a = is_some$2(t[21]);
		                 if(a)
		                  ;
		                 else {
		                  a = t[5];
		                  a:
		                  {
		                   if(typeof a !== "number" && 7 === a[0]){a = 1; break a;}
		                   a = 0;
		                  }
		                  a ||= t[26];
		                 }
		                }
		                return cont(a);
		               }
		               function type_equal_if_phys_same(t1, t2, cont){return t1 === t2 ? cont([0, 0]) : cont(0);
		               }
		               caml_callback
		                (update_mod,
		                 [aIm,
		                  Node,
		                  [0,
		                   sexp_of_node,
		                   [0, sexp_of_t$102],
		                   is_valid$0,
		                   is_necessary,
		                   type_equal_if_phys_same]]);
		               caml_callback(update_mod, [aIn, Observer, Observer]);
		               caml_callback(update_mod, [aIo, Only_in_debug, Only_in_debug]);
		               caml_callback
		                (update_mod, [aIp, Packed_weak_hashtbl, Packed_weak_hashtbl]);
		               caml_callback
		                (update_mod, [aIq, Recompute_heap, Recompute_heap]);
		               caml_callback
		                (update_mod,
		                 [aIr, Run_on_update_handlers, Run_on_update_handlers]);
		               function sexp_of_t$103(param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call
		                         (sexp_of_string$0, "Top", cont);
		                var bind = param[1], x_004 = bind[1];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         function(param, cont){return cont(aIs);},
		                         x_004,
		                         cont);
		               }
		               caml_callback
		                (update_mod, [aIt, include$130, [0, sexp_of_t$103]]);
		               caml_callback(update_mod, [aIu, Snapshot, Snapshot]);
		               caml_callback(update_mod, [aIv, State$0, State$0]);
		               caml_callback(update_mod, [aIw, Status, Status]);
		               caml_callback
		                (update_mod, [aIx, Step_function_node, Step_function_node]);
		               caml_callback
		                (update_mod,
		                 [aIy, Unordered_array_fold, Unordered_array_fold]);
		               caml_callback(update_mod, [aIz, Var, Var]);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Var";
		               record_start(d);
		               set$7(j);
		               function sexp_of_var(of_a_001, param, cont){
		                var
		                 value_003 = param[1],
		                 value_set_during_stabilization = param[2],
		                 set_at_007 = param[3],
		                 watch_009 = param[4];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         of_a_001,
		                         watch_009,
		                         function(arg_010){
		                          var bnds_002 = [0, [1, [0, aIA, [0, arg_010, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   set_at_007,
		                                   function(arg_008){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aIB, [0, arg_008, 0]]], bnds_002];
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$88,
		     of_a_001,
		     value_set_during_stabilization,
		     function(arg_006){
		      var
		       bnds_002 = [0, [1, [0, aIC, [0, arg_006, 0]]], bnds_002$0];
		      return caml_exact_trampoline_cps_call
		              (of_a_001,
		               value_003,
		               function(arg_004){
		                var
		                 bnds_002$0 = [0, [1, [0, aID, [0, arg_004, 0]]], bnds_002];
		                return cont([1, bnds_002$0]);
		               });
		     });
		                                   });
		                         });
		               }
		               function incr_state(t){return t[4][2];}
		               function sexp_of_t$104(param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_var,
		                         function(param, cont){return cont(aIE);},
		                         param,
		                         function(res0_015){
		                          return cont([1, [0, aIF, [0, res0_015, 0]]]);
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Unordered_array_fold";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$105(of_a_009, of_acc_010, param, cont){
		                var
		                 children_022 = param[6],
		                 full_compute_every_n_changes_0 = param[5],
		                 main_012 = param[1],
		                 fold_value_024 = param[7],
		                 num_changes_since_last_full_co = param[8];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         num_changes_since_last_full_co,
		                         function(arg_027){
		                          var bnds_011 = [0, [1, [0, aIG, [0, arg_027, 0]]], 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$88,
		                                   of_acc_010,
		                                   fold_value_024,
		                                   function(arg_025){
		                                    var
		                                     bnds_011$0 = [0, [1, [0, aIH, [0, arg_025, 0]]], bnds_011];
		                                    return caml_trampoline_cps_call2
		    (Node[1],
		     of_a_009,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_array,
		               a,
		               children_022,
		               function(arg_023){
		                var
		                 bnds_011 = [0, [1, [0, aII, [0, arg_023, 0]]], bnds_011$0];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         full_compute_every_n_changes_0,
		                         function(arg_021){
		                          var
		                           bnds_011$0 = [0, [1, [0, aIJ, [0, arg_021, 0]]], bnds_011],
		                           bnds_011$1 =
		                             [0,
		                              [1, [0, aIL, [0, res0_003, 0]]],
		                              [0, [1, [0, aIK, [0, res0_003, 0]]], bnds_011$0]];
		                          return caml_exact_trampoline_cps_call
		                                  (of_acc_010,
		                                   dummy,
		                                   function(arg_015){
		                                    var
		                                     bnds_011 = [0, [1, [0, aIM, [0, arg_015, 0]]], bnds_011$1];
		                                    return caml_trampoline_cps_call3
		    (Node[1],
		     of_acc_010,
		     main_012,
		     function(arg_013){
		      var
		       bnds_011$0 = [0, [1, [0, aIN, [0, arg_013, 0]]], bnds_011];
		      return cont([1, bnds_011$0]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function force_full_compute(t){t[7] = none$3; t[8] = t[5];}
		               function child_changed
		               (x_031, child, child_index, old_value_opt, new_value, cont){
		                var
		                 child_at_index =
		                   caml_check_bound(x_031[6], child_index)[child_index + 1];
		                return caml_trampoline_cps_call3
		                        (Node[5],
		                         child,
		                         child_at_index,
		                         function(a){
		                          if(! a)
		                           return caml_trampoline_cps_call3
		                                   (Node[1],
		                                    function(param, cont){return cont(aIO);},
		                                    child,
		                                    function(b){
		                                     var a = [0, [1, [0, aIP, [0, b, 0]]], 0];
		                                     return caml_exact_trampoline_cps_call
		     (sexp_of_int$0,
		      child_index,
		      function(c){
		       var b = [0, [1, [0, aIQ, [0, c, 0]]], a];
		       return caml_exact_trampoline_cps_call$0
		               (sexp_of_t$105,
		                function(param, cont){return cont(aIS);},
		                function(param, cont){return cont(aIR);},
		                x_031,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (raise_s,
		                          [1,
		                           [0,
		                            [0, "[Unordered_array_fold.child_changed] mismatch"],
		                            [0, [1, [0, aIT, [0, a, 0]]], b]]],
		                          cont);
		                });
		      });
		                                    });
		                          if(x_031[8] < (x_031[5] - 1 | 0)){
		                           x_031[8] = x_031[8] + 1 | 0;
		                           return caml_exact_trampoline_cps_call
		                                   (value_exn$1,
		                                    old_value_opt,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (value_exn$1,
		      x_031[7],
		      function(b){
		       return caml_trampoline_cps_call4
		               (x_031[4],
		                b,
		                a,
		                new_value,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (some$1, a, function(a){x_031[7] = a; return cont();});
		                });
		      });
		                                    });
		                          }
		                          a = x_031[8] < x_031[5] ? 1 : 0;
		                          return a ? cont(force_full_compute(x_031)) : cont(a);
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Alarm";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Step_function_node";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$106(of_a_001, param, cont){
		                var
		                 main_003 = param[1],
		                 child_005 = param[2],
		                 extracted_step_function_from_c = param[3],
		                 value_009 = param[4],
		                 upcoming_steps_011 = param[5],
		                 alarm_017 = param[6],
		                 bnds_002 =
		                   [0,
		                    [1, [0, aIV, [0, arg_006, 0]]],
		                    [0, [1, [0, aIU, [0, arg_006, 0]]], 0]];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$93,
		                         sexp_of_opaque,
		                         alarm_017,
		                         function(arg_018){
		                          var
		                           bnds_002$0 = [0, [1, [0, aIW, [0, arg_018, 0]]], bnds_002];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$4,
		                                   function(param, cont){
		                                    var arg0_013 = param[1];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$83,
		     arg0_013,
		     function(res0_015){
		      return caml_exact_trampoline_cps_call
		              (of_a_001,
		               dummy,
		               function(res1_016){
		                return cont([1, [0, res0_015, [0, res1_016, 0]]]);
		               });
		     });
		                                   },
		                                   upcoming_steps_011,
		                                   function(arg_012){
		                                    var
		                                     bnds_002 = [0, [1, [0, aIX, [0, arg_012, 0]]], bnds_002$0];
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$88,
		     of_a_001,
		     value_009,
		     function(arg_010){
		      var
		       bnds_002$0 = [0, [1, [0, aIY, [0, arg_010, 0]]], bnds_002];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               extracted_step_function_from_c,
		               function(arg_008){
		                var
		                 bnds_002 = [0, [1, [0, aIZ, [0, arg_008, 0]]], bnds_002$0];
		                return caml_trampoline_cps_call2
		                        (Node[1],
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$87, of_a_001, a, cont);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$88,
		                                   a,
		                                   child_005,
		                                   function(arg_006){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aI0, [0, arg_006, 0]]], bnds_002];
		                                    return caml_trampoline_cps_call3
		    (Node[1],
		     of_a_001,
		     main_003,
		     function(arg_004){
		      var
		       bnds_002 = [0, [1, [0, aI1, [0, arg_004, 0]]], bnds_002$0];
		      return cont([1, bnds_002]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Array_fold";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$107(of_a_001, of_acc_002, param, cont){
		                var children_008 = param[3];
		                return caml_trampoline_cps_call2
		                        (Node[1],
		                         of_a_001,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_array,
		                                   a,
		                                   children_008,
		                                   function(arg_009){
		                                    var
		                                     bnds_003 = [0, [1, [0, aI2, [0, arg_009, 0]]], 0],
		                                     bnds_003$0 = [0, [1, [0, aI3, [0, res0_003, 0]]], bnds_003];
		                                    return caml_exact_trampoline_cps_call
		    (of_acc_002,
		     dummy,
		     function(arg_005){
		      var
		       bnds_003 = [0, [1, [0, aI4, [0, arg_005, 0]]], bnds_003$0];
		      return cont([1, bnds_003]);
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__At";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$108(param, cont){
		                var
		                 at_004 = param[2],
		                 main_002 = param[1],
		                 alarm_006 = param[3],
		                 bnds_001 = [0, [1, [0, aI5, [0, arg_006, 0]]], 0];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$93,
		                         sexp_of_opaque,
		                         alarm_006,
		                         function(arg_007){
		                          var
		                           bnds_001$0 = [0, [1, [0, aI6, [0, arg_007, 0]]], bnds_001];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$83,
		                                   at_004,
		                                   function(arg_005){
		                                    var
		                                     bnds_001 = [0, [1, [0, aI7, [0, arg_005, 0]]], bnds_001$0];
		                                    return caml_trampoline_cps_call3
		    (Node[1],
		     sexp_of_t$96,
		     main_002,
		     function(arg_003){
		      var
		       bnds_001$0 = [0, [1, [0, aI8, [0, arg_003, 0]]], bnds_001];
		      return cont([1, bnds_001$0]);
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__At_intervals";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$109(param, cont){
		                var
		                 interval_006 = param[3],
		                 base_004 = param[2],
		                 main_002 = param[1],
		                 alarm_008 = param[4],
		                 bnds_001 = [0, [1, [0, aI9, [0, arg_006, 0]]], 0];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$93,
		                         sexp_of_opaque,
		                         alarm_008,
		                         function(arg_009){
		                          var
		                           bnds_001$0 = [0, [1, [0, aI_, [0, arg_009, 0]]], bnds_001];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_span,
		                                   interval_006,
		                                   function(arg_007){
		                                    var
		                                     bnds_001 = [0, [1, [0, aI$, [0, arg_007, 0]]], bnds_001$0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$83,
		     base_004,
		     function(arg_005){
		      var
		       bnds_001$0 = [0, [1, [0, aJa, [0, arg_005, 0]]], bnds_001];
		      return caml_trampoline_cps_call3
		              (Node[1],
		               sexp_of_unit$0,
		               main_002,
		               function(arg_003){
		                var
		                 bnds_001 = [0, [1, [0, aJb, [0, arg_003, 0]]], bnds_001$0];
		                return cont([1, bnds_001]);
		               });
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Bind";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$110(of_a_001, of_b_002, param, cont){
		                var
		                 main_004 = param[1],
		                 lhs_change_010 = param[4],
		                 lhs_008 = param[3],
		                 rhs_012 = param[5],
		                 rhs_scope_014 = param[6],
		                 all_nodes_created_on_rhs_016 = param[7];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         Node[2][1],
		                         all_nodes_created_on_rhs_016,
		                         function(arg_017){
		                          var bnds_003 = [0, [1, [0, aJc, [0, arg_017, 0]]], 0];
		                          return caml_trampoline_cps_call2
		                                  (include$130[1],
		                                   rhs_scope_014,
		                                   function(arg_015){
		                                    var
		                                     bnds_003$0 = [0, [1, [0, aJd, [0, arg_015, 0]]], bnds_003];
		                                    return caml_trampoline_cps_call2
		    (Node[1],
		     of_b_002,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$88,
		               a,
		               rhs_012,
		               function(arg_013){
		                var
		                 bnds_003 = [0, [1, [0, aJe, [0, arg_013, 0]]], bnds_003$0];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         sexp_of_unit$0,
		                         lhs_change_010,
		                         function(arg_011){
		                          var
		                           bnds_003$0 = [0, [1, [0, aJf, [0, arg_011, 0]]], bnds_003];
		                          return caml_trampoline_cps_call3
		                                  (Node[1],
		                                   of_a_001,
		                                   lhs_008,
		                                   function(arg_009){
		                                    var
		                                     bnds_003 = [0, [1, [0, aJg, [0, arg_009, 0]]], bnds_003$0],
		                                     bnds_003$1 = [0, [1, [0, aJh, [0, res0_003, 0]]], bnds_003];
		                                    return caml_trampoline_cps_call3
		    (Node[1],
		     of_b_002,
		     main_004,
		     function(arg_005){
		      var
		       bnds_003 = [0, [1, [0, aJi, [0, arg_005, 0]]], bnds_003$1];
		      return cont([1, bnds_003]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Expert";
		               record_start(d);
		               set$7(j);
		               function sexp_of_edge(of_a_001, param, cont){
		                var child_003 = param[1], index_007 = param[3];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         sexp_of_int$0,
		                         index_007,
		                         function(arg_008){
		                          var
		                           bnds_002 = [0, [1, [0, aJj, [0, arg_008, 0]]], 0],
		                           bnds_002$0 = [0, [1, [0, aJk, [0, res0_003, 0]]], bnds_002];
		                          return caml_trampoline_cps_call3
		                                  (Node[1],
		                                   of_a_001,
		                                   child_003,
		                                   function(arg_004){
		                                    var
		                                     bnds_002 = [0, [1, [0, aJl, [0, arg_004, 0]]], bnds_002$0];
		                                    return cont([1, bnds_002]);
		                                   });
		                         });
		               }
		               function sexp_of_packed_edge(param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_edge,
		                         function(param, cont){return cont(aJm);},
		                         param,
		                         function(res0_010){
		                          return cont([1, [0, aJn, [0, res0_010, 0]]]);
		                         });
		               }
		               function observability_change(t, is_now_observable, cont){
		                return caml_trampoline_cps_call2
		                        (t[2],
		                         is_now_observable,
		                         function(a){
		                          if(1 - is_now_observable){t[7] = 1; t[6] = 0;}
		                          return cont();
		                         });
		               }
		               function run_edge_callback(t, child_index, cont){
		                function a(){return cont();}
		                if(! (1 - t[7])) return a();
		                var arr = t[3];
		                return caml_exact_trampoline_cps_call
		                        (value_exn$1,
		                         get$3(arr, child_index),
		                         function(match){
		                          return is_some$2(match[1][4])
		                                  ? caml_trampoline_cps_call2(match[2], match[1][4], cont)
		                                  : a();
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Scope";
		               record_start(d);
		               set$7(j);
		               var sexp_of_t$111 = include$130[1];
		               function height$2(param){
		                if(! param) return -1;
		                var bind = param[1];
		                return bind[4][14];
		               }
		               function is_valid$1(a){
		                if(! a) return 1;
		                var bind = a[1], a = bind[1][5];
		                if(typeof a === "number" && ! a) return 0;
		                return 1;
		               }
		               function is_necessary$0(param, cont){
		                if(! param) return cont(1);
		                var bind = param[1];
		                return caml_trampoline_cps_call2(Node[4], bind[1], cont);
		               }
		               function add_node(t, node, cont){
		                if(node[12] !== t){
		                 var raise = caml_pop_trap();
		                 return raise
		                         (caml_maybe_attach_backtrace([0, Assert_failure, aJx], 1));
		                }
		                if(! t) return cont();
		                var bind = t[1];
		                node[13] = bind[7];
		                return caml_exact_trampoline_cps_call
		                        (some$1, node, function(a){bind[7] = a; return cont();});
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Freeze";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$112(of_a_001, param, cont){
		                var
		                 child_005 = param[2],
		                 main_003 = param[1],
		                 bnds_002 = [0, [1, [0, aJy, [0, res0_003, 0]]], 0];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         of_a_001,
		                         child_005,
		                         function(arg_006){
		                          var
		                           bnds_002$0 = [0, [1, [0, aJz, [0, arg_006, 0]]], bnds_002];
		                          return caml_trampoline_cps_call3
		                                  (Node[1],
		                                   of_a_001,
		                                   main_003,
		                                   function(arg_004){
		                                    var
		                                     bnds_002 = [0, [1, [0, aJA, [0, arg_004, 0]]], bnds_002$0];
		                                    return cont([1, bnds_002]);
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__If_then_else";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$113(of_a_001, param, cont){
		                var
		                 test_change_007 = param[3],
		                 test_005 = param[2],
		                 main_003 = param[1],
		                 current_branch_009 = param[4],
		                 else_013 = param[6],
		                 then_011 = param[5];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         of_a_001,
		                         else_013,
		                         function(arg_014){
		                          var bnds_002 = [0, [1, [0, aJB, [0, arg_014, 0]]], 0];
		                          return caml_trampoline_cps_call3
		                                  (Node[1],
		                                   of_a_001,
		                                   then_011,
		                                   function(arg_012){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aJC, [0, arg_012, 0]]], bnds_002];
		                                    return caml_trampoline_cps_call2
		    (Node[1],
		     of_a_001,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$88,
		               a,
		               current_branch_009,
		               function(arg_010){
		                var
		                 bnds_002 = [0, [1, [0, aJD, [0, arg_010, 0]]], bnds_002$0];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         sexp_of_unit$0,
		                         test_change_007,
		                         function(arg_008){
		                          var
		                           bnds_002$0 = [0, [1, [0, aJE, [0, arg_008, 0]]], bnds_002];
		                          return caml_trampoline_cps_call3
		                                  (Node[1],
		                                   sexp_of_bool,
		                                   test_005,
		                                   function(arg_006){
		                                    var
		                                     bnds_002 = [0, [1, [0, aJF, [0, arg_006, 0]]], bnds_002$0];
		                                    return caml_trampoline_cps_call3
		    (Node[1],
		     of_a_001,
		     main_003,
		     function(arg_004){
		      var
		       bnds_002$0 = [0, [1, [0, aJG, [0, arg_004, 0]]], bnds_002];
		      return cont([1, bnds_002$0]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Join";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$114(of_a_001, param, cont){
		                var
		                 lhs_change_007 = param[3],
		                 lhs_005 = param[2],
		                 main_003 = param[1],
		                 rhs_009 = param[4];
		                return caml_trampoline_cps_call2
		                        (Node[1],
		                         of_a_001,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$88,
		                                   a,
		                                   rhs_009,
		                                   function(arg_010){
		                                    var bnds_002 = [0, [1, [0, aJH, [0, arg_010, 0]]], 0];
		                                    return caml_trampoline_cps_call3
		    (Node[1],
		     sexp_of_unit$0,
		     lhs_change_007,
		     function(arg_008){
		      var
		       bnds_002$0 = [0, [1, [0, aJI, [0, arg_008, 0]]], bnds_002];
		      return caml_trampoline_cps_call2
		              (Node[1],
		               of_a_001,
		               function(a){
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         a,
		                         lhs_005,
		                         function(arg_006){
		                          var
		                           bnds_002 = [0, [1, [0, aJJ, [0, arg_006, 0]]], bnds_002$0];
		                          return caml_trampoline_cps_call3
		                                  (Node[1],
		                                   of_a_001,
		                                   main_003,
		                                   function(arg_004){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aJK, [0, arg_004, 0]]], bnds_002];
		                                    return cont([1, bnds_002$0]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Snapshot";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$115(of_a_001, param, cont){
		                var
		                 value_at_009 = param[4],
		                 at_005 = param[2],
		                 main_003 = param[1],
		                 bnds_002 = [0, [1, [0, aJL, [0, arg_006, 0]]], 0];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         of_a_001,
		                         value_at_009,
		                         function(arg_010){
		                          var
		                           bnds_002$0 = [0, [1, [0, aJM, [0, arg_010, 0]]], bnds_002];
		                          return caml_exact_trampoline_cps_call
		                                  (of_a_001,
		                                   dummy,
		                                   function(arg_008){
		                                    var
		                                     bnds_002 = [0, [1, [0, aJN, [0, arg_008, 0]]], bnds_002$0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$83,
		     at_005,
		     function(arg_006){
		      var
		       bnds_002$0 = [0, [1, [0, aJO, [0, arg_006, 0]]], bnds_002];
		      return caml_trampoline_cps_call3
		              (Node[1],
		               of_a_001,
		               main_003,
		               function(arg_004){
		                var
		                 bnds_002 = [0, [1, [0, aJP, [0, arg_004, 0]]], bnds_002$0];
		                return cont([1, bnds_002]);
		               });
		     });
		                                   });
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Kind";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$116(of_a_001, param, cont){
		                if(typeof param === "number")
		                 return 0 === param ? cont(aJQ) : cont(aJR);
		                switch(param[0]){
		                  case 0:
		                   var arg0_002 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (sexp_of_t$107,
		                            function(param, cont){return cont(aJS);},
		                            of_a_001,
		                            arg0_002,
		                            function(res0_003){
		                             return cont([1, [0, aJT, [0, res0_003, 0]]]);
		                            });
		                  case 1:
		                   var arg0_004 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$108,
		                            arg0_004,
		                            function(res0_005){
		                             return cont([1, [0, aJU, [0, res0_005, 0]]]);
		                            });
		                  case 2:
		                   var arg0_006 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_t$109,
		                            arg0_006,
		                            function(res0_007){
		                             return cont([1, [0, aJV, [0, res0_007, 0]]]);
		                            });
		                  case 3:
		                   var arg0_008 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (sexp_of_t$110,
		                            function(param, cont){return cont(aJX);},
		                            function(param, cont){return cont(aJW);},
		                            arg0_008,
		                            function(res0_009){
		                             return cont([1, [0, aJY, [0, res0_009, 0]]]);
		                            });
		                  case 4:
		                   var arg0_010 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (sexp_of_t$110,
		                            function(param, cont){return cont(aJZ);},
		                            of_a_001,
		                            arg0_010,
		                            function(res0_011){
		                             return cont([1, [0, aJ0, [0, res0_011, 0]]]);
		                            });
		                  case 5:
		                   return caml_exact_trampoline_cps_call
		                           (of_a_001,
		                            dummy,
		                            function(res0_013){
		                             return cont([1, [0, aJ1, [0, res0_013, 0]]]);
		                            });
		                  case 6:
		                   var
		                    arg0_014 = param[1],
		                    children_017 = arg0_014[3],
		                    num_children_019 = arg0_014[4],
		                    force_stale_021 = arg0_014[5],
		                    num_invalid_children_023 = arg0_014[6],
		                    will_fire_all_callbacks_025 = arg0_014[7];
		                   return caml_exact_trampoline_cps_call
		                           (sexp_of_bool,
		                            will_fire_all_callbacks_025,
		                            function(arg_026){
		                             var bnds_012 = [0, [1, [0, aJo, [0, arg_026, 0]]], 0];
		                             return caml_exact_trampoline_cps_call
		                                     (sexp_of_int$0,
		                                      num_invalid_children_023,
		                                      function(arg_024){
		                                       var
		bnds_012$0 = [0, [1, [0, aJp, [0, arg_024, 0]]], bnds_012];
		                                       return caml_exact_trampoline_cps_call
		       (sexp_of_bool,
		        force_stale_021,
		        function(arg_022){
		         var
		          bnds_012 = [0, [1, [0, aJq, [0, arg_022, 0]]], bnds_012$0];
		         return caml_exact_trampoline_cps_call
		                 (sexp_of_int$0,
		                  num_children_019,
		                  function(arg_020){
		                   var
		                    bnds_012$0 = [0, [1, [0, aJr, [0, arg_020, 0]]], bnds_012];
		                   return caml_trampoline_cps_call2
		                           (sexp_of_t$88,
		                            sexp_of_packed_edge,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_t$6,
		                                      a,
		                                      children_017,
		                                      function(arg_018){
		                                       var
		bnds_012 = [0, [1, [0, aJs, [0, arg_018, 0]]], bnds_012$0];
		                                       return cont
		       ([1,
		         [0,
		          aJ2,
		          [0,
		           [1,
		            [0,
		             [1, [0, aJu, [0, res0_003, 0]]],
		             [0, [1, [0, aJt, [0, res0_003, 0]]], bnds_012]]],
		           0]]]);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 7:
		                   var arg0_016 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_t$112,
		                            of_a_001,
		                            arg0_016,
		                            function(res0_017){
		                             return cont([1, [0, aJ3, [0, res0_017, 0]]]);
		                            });
		                  case 8:
		                   var arg0_018 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_t$113,
		                            function(param, cont){return cont(aJ4);},
		                            arg0_018,
		                            function(res0_019){
		                             return cont([1, [0, aJ5, [0, res0_019, 0]]]);
		                            });
		                  case 9:
		                   var arg0_020 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_t$113,
		                            of_a_001,
		                            arg0_020,
		                            function(res0_021){
		                             return cont([1, [0, aJ6, [0, res0_021, 0]]]);
		                            });
		                  case 10:
		                   var arg0_022 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_t$114,
		                            function(param, cont){return cont(aJ7);},
		                            arg0_022,
		                            function(res0_023){
		                             return cont([1, [0, aJ8, [0, res0_023, 0]]]);
		                            });
		                  case 11:
		                   var arg0_024 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_t$114,
		                            of_a_001,
		                            arg0_024,
		                            function(res0_025){
		                             return cont([1, [0, aJ9, [0, res0_025, 0]]]);
		                            });
		                  case 12:
		                   var arg1_027 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aJ_);},
		                            arg1_027,
		                            function(res1_029){
		                             return cont([1, [0, aJ$, [0, res0_003, [0, res1_029, 0]]]]);
		                            });
		                  case 13:
		                   var arg0_030 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_t$115,
		                            of_a_001,
		                            arg0_030,
		                            function(res0_031){
		                             return cont([1, [0, aKa, [0, res0_031, 0]]]);
		                            });
		                  case 14:
		                   var arg0_032 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_t$106,
		                            of_a_001,
		                            arg0_032,
		                            function(res0_033){
		                             return cont([1, [0, aKb, [0, res0_033, 0]]]);
		                            });
		                  case 15:
		                   var arg0_034 = param[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (sexp_of_t$105,
		                            function(param, cont){return cont(aKc);},
		                            of_a_001,
		                            arg0_034,
		                            function(res0_035){
		                             return cont([1, [0, aKd, [0, res0_035, 0]]]);
		                            });
		                  case 16:
		                   var arg0_036 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (sexp_of_var,
		                            of_a_001,
		                            arg0_036,
		                            function(res0_037){
		                             return cont([1, [0, aKe, [0, res0_037, 0]]]);
		                            });
		                  case 17:
		                   var arg2_040 = param[3], arg1_039 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKf);},
		                            arg1_039,
		                            function(res1_042){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKg);},
		                                      arg2_040,
		                                      function(res2_043){
		                                       return cont
		       ([1,
		         [0, aKh, [0, res0_003, [0, res1_042, [0, res2_043, 0]]]]]);
		                                      });
		                            });
		                  case 18:
		                   var
		                    arg3_047 = param[4],
		                    arg2_046 = param[3],
		                    arg1_045 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKi);},
		                            arg1_045,
		                            function(res1_049){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKj);},
		                                      arg2_046,
		                                      function(res2_050){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKk);},
		        arg3_047,
		        function(res3_051){
		         return cont
		                 ([1,
		                   [0,
		                    aKl,
		                    [0,
		                     res0_003,
		                     [0, res1_049, [0, res2_050, [0, res3_051, 0]]]]]]);
		        });
		                                      });
		                            });
		                  case 19:
		                   var
		                    arg4_056 = param[5],
		                    arg3_055 = param[4],
		                    arg2_054 = param[3],
		                    arg1_053 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKm);},
		                            arg1_053,
		                            function(res1_058){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKn);},
		                                      arg2_054,
		                                      function(res2_059){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKo);},
		        arg3_055,
		        function(res3_060){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aKp);},
		                  arg4_056,
		                  function(res4_061){
		                   return cont
		                           ([1,
		                             [0,
		                              aKq,
		                              [0,
		                               res0_003,
		                               [0,
		                                res1_058,
		                                [0, res2_059, [0, res3_060, [0, res4_061, 0]]]]]]]);
		                  });
		        });
		                                      });
		                            });
		                  case 20:
		                   var
		                    arg5_067 = param[6],
		                    arg4_066 = param[5],
		                    arg3_065 = param[4],
		                    arg2_064 = param[3],
		                    arg1_063 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKr);},
		                            arg1_063,
		                            function(res1_069){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKs);},
		                                      arg2_064,
		                                      function(res2_070){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKt);},
		        arg3_065,
		        function(res3_071){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aKu);},
		                  arg4_066,
		                  function(res4_072){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKv);},
		                            arg5_067,
		                            function(res5_073){
		                             return cont
		                                     ([1,
		                                       [0,
		aKw,
		[0,
		 res0_003,
		 [0,
		  res1_069,
		  [0,
		   res2_070,
		   [0, res3_071, [0, res4_072, [0, res5_073, 0]]]]]]]]);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 21:
		                   var
		                    arg6_080 = param[7],
		                    arg5_079 = param[6],
		                    arg4_078 = param[5],
		                    arg3_077 = param[4],
		                    arg2_076 = param[3],
		                    arg1_075 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKx);},
		                            arg1_075,
		                            function(res1_082){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKy);},
		                                      arg2_076,
		                                      function(res2_083){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKz);},
		        arg3_077,
		        function(res3_084){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aKA);},
		                  arg4_078,
		                  function(res4_085){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKB);},
		                            arg5_079,
		                            function(res5_086){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKC);},
		                                      arg6_080,
		                                      function(res6_087){
		                                       return cont
		       ([1,
		         [0,
		          aKD,
		          [0,
		           res0_003,
		           [0,
		            res1_082,
		            [0,
		             res2_083,
		             [0,
		              res3_084,
		              [0, res4_085, [0, res5_086, [0, res6_087, 0]]]]]]]]]);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 22:
		                   var
		                    arg7_095 = param[8],
		                    arg6_094 = param[7],
		                    arg5_093 = param[6],
		                    arg4_092 = param[5],
		                    arg3_091 = param[4],
		                    arg2_090 = param[3],
		                    arg1_089 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKE);},
		                            arg1_089,
		                            function(res1_097){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKF);},
		                                      arg2_090,
		                                      function(res2_098){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKG);},
		        arg3_091,
		        function(res3_099){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aKH);},
		                  arg4_092,
		                  function(res4_100){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKI);},
		                            arg5_093,
		                            function(res5_101){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKJ);},
		                                      arg6_094,
		                                      function(res6_102){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKK);},
		        arg7_095,
		        function(res7_103){
		         return cont
		                 ([1,
		                   [0,
		                    aKL,
		                    [0,
		                     res0_003,
		                     [0,
		                      res1_097,
		                      [0,
		                       res2_098,
		                       [0,
		                        res3_099,
		                        [0,
		                         res4_100,
		                         [0, res5_101, [0, res6_102, [0, res7_103, 0]]]]]]]]]]);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 23:
		                   var
		                    arg8_112 = param[9],
		                    arg7_111 = param[8],
		                    arg6_110 = param[7],
		                    arg5_109 = param[6],
		                    arg4_108 = param[5],
		                    arg3_107 = param[4],
		                    arg2_106 = param[3],
		                    arg1_105 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKM);},
		                            arg1_105,
		                            function(res1_114){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKN);},
		                                      arg2_106,
		                                      function(res2_115){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKO);},
		        arg3_107,
		        function(res3_116){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aKP);},
		                  arg4_108,
		                  function(res4_117){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKQ);},
		                            arg5_109,
		                            function(res5_118){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKR);},
		                                      arg6_110,
		                                      function(res6_119){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKS);},
		        arg7_111,
		        function(res7_120){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aKT);},
		                  arg8_112,
		                  function(res8_121){
		                   return cont
		                           ([1,
		                             [0,
		                              aKU,
		                              [0,
		                               res0_003,
		                               [0,
		                                res1_114,
		                                [0,
		                                 res2_115,
		                                 [0,
		                                  res3_116,
		                                  [0,
		                                   res4_117,
		                                   [0,
		                                    res5_118,
		                                    [0, res6_119, [0, res7_120, [0, res8_121, 0]]]]]]]]]]]);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 24:
		                   var
		                    arg9_131 = param[10],
		                    arg8_130 = param[9],
		                    arg7_129 = param[8],
		                    arg6_128 = param[7],
		                    arg5_127 = param[6],
		                    arg4_126 = param[5],
		                    arg3_125 = param[4],
		                    arg2_124 = param[3],
		                    arg1_123 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKV);},
		                            arg1_123,
		                            function(res1_133){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aKW);},
		                                      arg2_124,
		                                      function(res2_134){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aKX);},
		        arg3_125,
		        function(res3_135){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aKY);},
		                  arg4_126,
		                  function(res4_136){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aKZ);},
		                            arg5_127,
		                            function(res5_137){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aK0);},
		                                      arg6_128,
		                                      function(res6_138){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aK1);},
		        arg7_129,
		        function(res7_139){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aK2);},
		                  arg8_130,
		                  function(res8_140){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aK3);},
		                            arg9_131,
		                            function(res9_141){
		                             return cont
		                                     ([1,
		                                       [0,
		aK4,
		[0,
		 res0_003,
		 [0,
		  res1_133,
		  [0,
		   res2_134,
		   [0,
		    res3_135,
		    [0,
		     res4_136,
		     [0,
		      res5_137,
		      [0,
		       res6_138,
		       [0, res7_139, [0, res8_140, [0, res9_141, 0]]]]]]]]]]]]);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 25:
		                   var
		                    arg10_152 = param[11],
		                    arg9_151 = param[10],
		                    arg8_150 = param[9],
		                    arg7_149 = param[8],
		                    arg6_148 = param[7],
		                    arg5_147 = param[6],
		                    arg4_146 = param[5],
		                    arg3_145 = param[4],
		                    arg2_144 = param[3],
		                    arg1_143 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aK5);},
		                            arg1_143,
		                            function(res1_154){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aK6);},
		                                      arg2_144,
		                                      function(res2_155){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aK7);},
		        arg3_145,
		        function(res3_156){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aK8);},
		                  arg4_146,
		                  function(res4_157){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aK9);},
		                            arg5_147,
		                            function(res5_158){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aK_);},
		                                      arg6_148,
		                                      function(res6_159){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aK$);},
		        arg7_149,
		        function(res7_160){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLa);},
		                  arg8_150,
		                  function(res8_161){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLb);},
		                            arg9_151,
		                            function(res9_162){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLc);},
		                                      arg10_152,
		                                      function(res10_163){
		                                       return cont
		       ([1,
		         [0,
		          aLd,
		          [0,
		           res0_003,
		           [0,
		            res1_154,
		            [0,
		             res2_155,
		             [0,
		              res3_156,
		              [0,
		               res4_157,
		               [0,
		                res5_158,
		                [0,
		                 res6_159,
		                 [0,
		                  res7_160,
		                  [0, res8_161, [0, res9_162, [0, res10_163, 0]]]]]]]]]]]]]);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 26:
		                   var
		                    arg11_175 = param[12],
		                    arg10_174 = param[11],
		                    arg9_173 = param[10],
		                    arg8_172 = param[9],
		                    arg7_171 = param[8],
		                    arg6_170 = param[7],
		                    arg5_169 = param[6],
		                    arg4_168 = param[5],
		                    arg3_167 = param[4],
		                    arg2_166 = param[3],
		                    arg1_165 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLe);},
		                            arg1_165,
		                            function(res1_177){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLf);},
		                                      arg2_166,
		                                      function(res2_178){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLg);},
		        arg3_167,
		        function(res3_179){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLh);},
		                  arg4_168,
		                  function(res4_180){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLi);},
		                            arg5_169,
		                            function(res5_181){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLj);},
		                                      arg6_170,
		                                      function(res6_182){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLk);},
		        arg7_171,
		        function(res7_183){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLl);},
		                  arg8_172,
		                  function(res8_184){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLm);},
		                            arg9_173,
		                            function(res9_185){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLn);},
		                                      arg10_174,
		                                      function(res10_186){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLo);},
		        arg11_175,
		        function(res11_187){
		         return cont
		                 ([1,
		                   [0,
		                    aLp,
		                    [0,
		                     res0_003,
		                     [0,
		                      res1_177,
		                      [0,
		                       res2_178,
		                       [0,
		                        res3_179,
		                        [0,
		                         res4_180,
		                         [0,
		                          res5_181,
		                          [0,
		                           res6_182,
		                           [0,
		                            res7_183,
		                            [0,
		                             res8_184,
		                             [0, res9_185, [0, res10_186, [0, res11_187, 0]]]]]]]]]]]]]]);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 27:
		                   var
		                    arg12_200 = param[13],
		                    arg11_199 = param[12],
		                    arg10_198 = param[11],
		                    arg9_197 = param[10],
		                    arg8_196 = param[9],
		                    arg7_195 = param[8],
		                    arg6_194 = param[7],
		                    arg5_193 = param[6],
		                    arg4_192 = param[5],
		                    arg3_191 = param[4],
		                    arg2_190 = param[3],
		                    arg1_189 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLq);},
		                            arg1_189,
		                            function(res1_202){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLr);},
		                                      arg2_190,
		                                      function(res2_203){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLs);},
		        arg3_191,
		        function(res3_204){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLt);},
		                  arg4_192,
		                  function(res4_205){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLu);},
		                            arg5_193,
		                            function(res5_206){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLv);},
		                                      arg6_194,
		                                      function(res6_207){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLw);},
		        arg7_195,
		        function(res7_208){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLx);},
		                  arg8_196,
		                  function(res8_209){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLy);},
		                            arg9_197,
		                            function(res9_210){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLz);},
		                                      arg10_198,
		                                      function(res10_211){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLA);},
		        arg11_199,
		        function(res11_212){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLB);},
		                  arg12_200,
		                  function(res12_213){
		                   return cont
		                           ([1,
		                             [0,
		                              aLC,
		                              [0,
		                               res0_003,
		                               [0,
		                                res1_202,
		                                [0,
		                                 res2_203,
		                                 [0,
		                                  res3_204,
		                                  [0,
		                                   res4_205,
		                                   [0,
		                                    res5_206,
		                                    [0,
		                                     res6_207,
		                                     [0,
		                                      res7_208,
		                                      [0,
		                                       res8_209,
		                                       [0,
		res9_210,
		[0, res10_211, [0, res11_212, [0, res12_213, 0]]]]]]]]]]]]]]]);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 28:
		                   var
		                    arg13_227 = param[14],
		                    arg12_226 = param[13],
		                    arg11_225 = param[12],
		                    arg10_224 = param[11],
		                    arg9_223 = param[10],
		                    arg8_222 = param[9],
		                    arg7_221 = param[8],
		                    arg6_220 = param[7],
		                    arg5_219 = param[6],
		                    arg4_218 = param[5],
		                    arg3_217 = param[4],
		                    arg2_216 = param[3],
		                    arg1_215 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLD);},
		                            arg1_215,
		                            function(res1_229){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLE);},
		                                      arg2_216,
		                                      function(res2_230){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLF);},
		        arg3_217,
		        function(res3_231){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLG);},
		                  arg4_218,
		                  function(res4_232){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLH);},
		                            arg5_219,
		                            function(res5_233){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLI);},
		                                      arg6_220,
		                                      function(res6_234){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLJ);},
		        arg7_221,
		        function(res7_235){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLK);},
		                  arg8_222,
		                  function(res8_236){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLL);},
		                            arg9_223,
		                            function(res9_237){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLM);},
		                                      arg10_224,
		                                      function(res10_238){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLN);},
		        arg11_225,
		        function(res11_239){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLO);},
		                  arg12_226,
		                  function(res12_240){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLP);},
		                            arg13_227,
		                            function(res13_241){
		                             return cont
		                                     ([1,
		                                       [0,
		aLQ,
		[0,
		 res0_003,
		 [0,
		  res1_229,
		  [0,
		   res2_230,
		   [0,
		    res3_231,
		    [0,
		     res4_232,
		     [0,
		      res5_233,
		      [0,
		       res6_234,
		       [0,
		        res7_235,
		        [0,
		         res8_236,
		         [0,
		          res9_237,
		          [0,
		           res10_238,
		           [0, res11_239, [0, res12_240, [0, res13_241, 0]]]]]]]]]]]]]]]]);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 29:
		                   var
		                    arg14_256 = param[15],
		                    arg13_255 = param[14],
		                    arg12_254 = param[13],
		                    arg11_253 = param[12],
		                    arg10_252 = param[11],
		                    arg9_251 = param[10],
		                    arg8_250 = param[9],
		                    arg7_249 = param[8],
		                    arg6_248 = param[7],
		                    arg5_247 = param[6],
		                    arg4_246 = param[5],
		                    arg3_245 = param[4],
		                    arg2_244 = param[3],
		                    arg1_243 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLR);},
		                            arg1_243,
		                            function(res1_258){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLS);},
		                                      arg2_244,
		                                      function(res2_259){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLT);},
		        arg3_245,
		        function(res3_260){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLU);},
		                  arg4_246,
		                  function(res4_261){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLV);},
		                            arg5_247,
		                            function(res5_262){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aLW);},
		                                      arg6_248,
		                                      function(res6_263){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aLX);},
		        arg7_249,
		        function(res7_264){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aLY);},
		                  arg8_250,
		                  function(res8_265){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aLZ);},
		                            arg9_251,
		                            function(res9_266){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aL0);},
		                                      arg10_252,
		                                      function(res10_267){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aL1);},
		        arg11_253,
		        function(res11_268){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aL2);},
		                  arg12_254,
		                  function(res12_269){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aL3);},
		                            arg13_255,
		                            function(res13_270){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aL4);},
		                                      arg14_256,
		                                      function(res14_271){
		                                       return cont
		       ([1,
		         [0,
		          aL5,
		          [0,
		           res0_003,
		           [0,
		            res1_258,
		            [0,
		             res2_259,
		             [0,
		              res3_260,
		              [0,
		               res4_261,
		               [0,
		                res5_262,
		                [0,
		                 res6_263,
		                 [0,
		                  res7_264,
		                  [0,
		                   res8_265,
		                   [0,
		                    res9_266,
		                    [0,
		                     res10_267,
		                     [0,
		                      res11_268,
		                      [0, res12_269, [0, res13_270, [0, res14_271, 0]]]]]]]]]]]]]]]]]);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var
		                    arg15_287 = param[16],
		                    arg14_286 = param[15],
		                    arg13_285 = param[14],
		                    arg12_284 = param[13],
		                    arg11_283 = param[12],
		                    arg10_282 = param[11],
		                    arg9_281 = param[10],
		                    arg8_280 = param[9],
		                    arg7_279 = param[8],
		                    arg6_278 = param[7],
		                    arg5_277 = param[6],
		                    arg4_276 = param[5],
		                    arg3_275 = param[4],
		                    arg2_274 = param[3],
		                    arg1_273 = param[2];
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aL6);},
		                            arg1_273,
		                            function(res1_289){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aL7);},
		                                      arg2_274,
		                                      function(res2_290){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aL8);},
		        arg3_275,
		        function(res3_291){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aL9);},
		                  arg4_276,
		                  function(res4_292){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aL_);},
		                            arg5_277,
		                            function(res5_293){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aL$);},
		                                      arg6_278,
		                                      function(res6_294){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aMa);},
		        arg7_279,
		        function(res7_295){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aMb);},
		                  arg8_280,
		                  function(res8_296){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aMc);},
		                            arg9_281,
		                            function(res9_297){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aMd);},
		                                      arg10_282,
		                                      function(res10_298){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aMe);},
		        arg11_283,
		        function(res11_299){
		         return caml_trampoline_cps_call3
		                 (Node[1],
		                  function(param, cont){return cont(aMf);},
		                  arg12_284,
		                  function(res12_300){
		                   return caml_trampoline_cps_call3
		                           (Node[1],
		                            function(param, cont){return cont(aMg);},
		                            arg13_285,
		                            function(res13_301){
		                             return caml_trampoline_cps_call3
		                                     (Node[1],
		                                      function(param, cont){return cont(aMh);},
		                                      arg14_286,
		                                      function(res14_302){
		                                       return caml_trampoline_cps_call3
		       (Node[1],
		        function(param, cont){return cont(aMi);},
		        arg15_287,
		        function(res15_303){
		         return cont
		                 ([1,
		                   [0,
		                    aMj,
		                    [0,
		                     res0_003,
		                     [0,
		                      res1_289,
		                      [0,
		                       res2_290,
		                       [0,
		                        res3_291,
		                        [0,
		                         res4_292,
		                         [0,
		                          res5_293,
		                          [0,
		                           res6_294,
		                           [0,
		                            res7_295,
		                            [0,
		                             res8_296,
		                             [0,
		                              res9_297,
		                              [0,
		                               res10_298,
		                               [0,
		                                res11_299,
		                                [0,
		                                 res12_300,
		                                 [0, res13_301, [0, res14_302, [0, res15_303, 0]]]]]]]]]]]]]]]]]]);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               function initial_num_children(t){
		                if(typeof t === "number") return 0 === t ? 0 : 0;
		                switch(t[0]){
		                  case 0:
		                   var children = t[1][3]; return children.length - 1;
		                  case 15:
		                   var children$0 = t[1][6]; return children$0.length - 1;
		                  case 18:
		                   return 3;
		                  case 19:
		                   return 4;
		                  case 20:
		                   return 5;
		                  case 21:
		                   return 6;
		                  case 22:
		                   return 7;
		                  case 23:
		                   return 8;
		                  case 24:
		                   return 9;
		                  case 25:
		                   return 10;
		                  case 26:
		                   return 11;
		                  case 27:
		                   return 12;
		                  case 28:
		                   return 13;
		                  case 29:
		                   return 14;
		                  case 30:
		                   return 15;
		                  case 4:
		                  case 9:
		                  case 11:
		                  case 17:
		                   return 2;
		                  case 1:
		                  case 2:
		                  case 5:
		                  case 6:
		                  case 13:
		                  case 16:
		                   return 0;
		                  default: return 1;
		                }
		               }
		               function iteri_children(t, f, cont){
		                if(typeof t === "number") return 0 === t ? cont() : cont();
		                switch(t[0]){
		                  case 0:
		                   var
		                    children = t[1][3],
		                    b = children.length - 2 | 0,
		                    g = function(){return cont();},
		                    e =
		                      function(i){
		                       return caml_exact_trampoline_cps_call$1
		                               (f,
		                                i,
		                                children[i + 1],
		                                function(a){
		                                 a = i + 1 | 0;
		                                 return b !== i ? caml_exact_trampoline_call1(e, a) : g();
		                                });
		                      };
		                   return b < 0 ? g() : e(0);
		                  case 3:
		                   var bind = t[1];
		                   return caml_exact_trampoline_cps_call$1(f, 0, bind[3], cont);
		                  case 4:
		                   var a = t[1], lhs_change = a[4], rhs = a[5];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            lhs_change,
		                            function(a){
		                             a = is_some$2(rhs);
		                             return a
		                                     ? caml_exact_trampoline_cps_call$1(f, 1, rhs, cont)
		                                     : cont(a);
		                            });
		                  case 6:
		                   a = t[1];
		                   var
		                    children$0 = a[3],
		                    num_children = a[4],
		                    c = num_children - 1 | 0,
		                    i = function(){return cont();},
		                    h =
		                      function(i$0){
		                       return caml_exact_trampoline_cps_call
		                               (value_exn$1,
		                                children$0[i$0 + 1],
		                                function(match){
		                                 return caml_exact_trampoline_cps_call$1
		 (f,
		  i$0,
		  match[1],
		  function(a){
		   a = i$0 + 1 | 0;
		   return c !== i$0 ? caml_exact_trampoline_call1(h, a) : i();
		  });
		                                });
		                      };
		                   return c < 0 ? i() : h(0);
		                  case 9:
		                   a = t[1];
		                   var test_change = a[3], current_branch = a[4];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            test_change,
		                            function(a){
		                             a = is_some$2(current_branch);
		                             return a
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (f, 1, current_branch, cont)
		                                     : cont(a);
		                            });
		                  case 11:
		                   a = t[1];
		                   var lhs_change$0 = a[3], rhs$0 = a[4];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            lhs_change$0,
		                            function(a){
		                             a = is_some$2(rhs$0);
		                             return a
		                                     ? caml_exact_trampoline_cps_call$1(f, 1, rhs$0, cont)
		                                     : cont(a);
		                            });
		                  case 12:
		                   var node0 = t[2];
		                   return caml_exact_trampoline_cps_call$1(f, 0, node0, cont);
		                  case 14:
		                   var child$0 = t[1][2], a = is_some$2(child$0);
		                   return a
		                           ? caml_exact_trampoline_cps_call$1(f, 0, child$0, cont)
		                           : cont(a);
		                  case 15:
		                   var
		                    children$1 = t[1][6],
		                    d = children$1.length - 2 | 0,
		                    k = function(){return cont();},
		                    j =
		                      function(i){
		                       return caml_exact_trampoline_cps_call$1
		                               (f,
		                                i,
		                                children$1[i + 1],
		                                function(a){
		                                 a = i + 1 | 0;
		                                 return d !== i ? caml_exact_trampoline_call1(j, a) : k();
		                                });
		                      };
		                   return d < 0 ? k() : j(0);
		                  case 17:
		                   var node1 = t[3], node0$0 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1(f, 1, node1, cont);
		                            });
		                  case 18:
		                   var node2 = t[4], node1$0 = t[3], node0$1 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1(f, 2, node2, cont);
		                                      });
		                            });
		                  case 19:
		                   var
		                    node3 = t[5],
		                    node2$0 = t[4],
		                    node1$1 = t[3],
		                    node0$2 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$0,
		        function(a){
		         return caml_exact_trampoline_cps_call$1(f, 3, node3, cont);
		        });
		                                      });
		                            });
		                  case 20:
		                   var
		                    node4 = t[6],
		                    node3$0 = t[5],
		                    node2$1 = t[4],
		                    node1$2 = t[3],
		                    node0$3 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$1,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$0,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1(f, 4, node4, cont);
		                  });
		        });
		                                      });
		                            });
		                  case 21:
		                   var
		                    node5 = t[7],
		                    node4$0 = t[6],
		                    node3$1 = t[5],
		                    node2$2 = t[4],
		                    node1$3 = t[3],
		                    node0$4 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$3,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$2,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$1,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1(f, 5, node5, cont);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 22:
		                   var
		                    node6 = t[8],
		                    node5$0 = t[7],
		                    node4$1 = t[6],
		                    node3$2 = t[5],
		                    node2$3 = t[4],
		                    node1$4 = t[3],
		                    node0$5 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$5,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$4,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$3,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$2,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1(f, 6, node6, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 23:
		                   var
		                    node7 = t[9],
		                    node6$0 = t[8],
		                    node5$1 = t[7],
		                    node4$2 = t[6],
		                    node3$3 = t[5],
		                    node2$4 = t[4],
		                    node1$5 = t[3],
		                    node0$6 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$6,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$5,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$4,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$3,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$0,
		        function(a){
		         return caml_exact_trampoline_cps_call$1(f, 7, node7, cont);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 24:
		                   var
		                    node8 = t[10],
		                    node7$0 = t[9],
		                    node6$1 = t[8],
		                    node5$2 = t[7],
		                    node4$3 = t[6],
		                    node3$4 = t[5],
		                    node2$5 = t[4],
		                    node1$6 = t[3],
		                    node0$7 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$7,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$6,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$5,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$4,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$1,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  7,
		                  node7$0,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1(f, 8, node8, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 25:
		                   var
		                    node9 = t[11],
		                    node8$0 = t[10],
		                    node7$1 = t[9],
		                    node6$2 = t[8],
		                    node5$3 = t[7],
		                    node4$4 = t[6],
		                    node3$5 = t[5],
		                    node2$6 = t[4],
		                    node1$7 = t[3],
		                    node0$8 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$8,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$7,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$6,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$5,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$3,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$2,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  7,
		                  node7$1,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            8,
		                            node8$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1(f, 9, node9, cont);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 26:
		                   var
		                    node10 = t[12],
		                    node9$0 = t[11],
		                    node8$1 = t[10],
		                    node7$2 = t[9],
		                    node6$3 = t[8],
		                    node5$4 = t[7],
		                    node4$5 = t[6],
		                    node3$6 = t[5],
		                    node2$7 = t[4],
		                    node1$8 = t[3],
		                    node0$9 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$9,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$8,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$7,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$6,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$5,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$4,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$3,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  7,
		                  node7$2,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            8,
		                            node8$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      9,
		                                      node9$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1(f, 10, node10, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 27:
		                   var
		                    node11 = t[13],
		                    node10$0 = t[12],
		                    node9$1 = t[11],
		                    node8$2 = t[10],
		                    node7$3 = t[9],
		                    node6$4 = t[8],
		                    node5$5 = t[7],
		                    node4$6 = t[6],
		                    node3$7 = t[5],
		                    node2$8 = t[4],
		                    node1$9 = t[3],
		                    node0$10 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$10,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$9,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$8,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$7,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$6,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$5,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$4,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  7,
		                  node7$3,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            8,
		                            node8$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      9,
		                                      node9$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        10,
		        node10$0,
		        function(a){
		         return caml_exact_trampoline_cps_call$1(f, 11, node11, cont);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 28:
		                   var
		                    node12 = t[14],
		                    node11$0 = t[13],
		                    node10$1 = t[12],
		                    node9$2 = t[11],
		                    node8$3 = t[10],
		                    node7$4 = t[9],
		                    node6$5 = t[8],
		                    node5$6 = t[7],
		                    node4$7 = t[6],
		                    node3$8 = t[5],
		                    node2$9 = t[4],
		                    node1$10 = t[3],
		                    node0$11 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$11,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$10,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$9,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$8,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$7,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$6,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$5,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  7,
		                  node7$4,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            8,
		                            node8$3,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      9,
		                                      node9$2,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        10,
		        node10$1,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  11,
		                  node11$0,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1(f, 12, node12, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 29:
		                   var
		                    node13 = t[15],
		                    node12$0 = t[14],
		                    node11$1 = t[13],
		                    node10$2 = t[12],
		                    node9$3 = t[11],
		                    node8$4 = t[10],
		                    node7$5 = t[9],
		                    node6$6 = t[8],
		                    node5$7 = t[7],
		                    node4$8 = t[6],
		                    node3$9 = t[5],
		                    node2$10 = t[4],
		                    node1$11 = t[3],
		                    node0$12 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$12,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$11,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$10,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$9,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$8,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$7,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$6,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  7,
		                  node7$5,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            8,
		                            node8$4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      9,
		                                      node9$3,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        10,
		        node10$2,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  11,
		                  node11$1,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            12,
		                            node12$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1(f, 13, node13, cont);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 30:
		                   var
		                    node14 = t[16],
		                    node13$0 = t[15],
		                    node12$1 = t[14],
		                    node11$2 = t[13],
		                    node10$3 = t[12],
		                    node9$4 = t[11],
		                    node8$5 = t[10],
		                    node7$6 = t[9],
		                    node6$7 = t[8],
		                    node5$8 = t[7],
		                    node4$9 = t[6],
		                    node3$10 = t[5],
		                    node2$11 = t[4],
		                    node1$12 = t[3],
		                    node0$13 = t[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            0,
		                            node0$13,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      1,
		                                      node1$12,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        2,
		        node2$11,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  3,
		                  node3$10,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            4,
		                            node4$9,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      5,
		                                      node5$8,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        6,
		        node6$7,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  7,
		                  node7$6,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            8,
		                            node8$5,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      9,
		                                      node9$4,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (f,
		        10,
		        node10$3,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (f,
		                  11,
		                  node11$2,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (f,
		                            12,
		                            node12$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (f,
		                                      13,
		                                      node13$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1(f, 14, node14, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 7:
		                  case 8:
		                  case 10:
		                   var child = t[1][2];
		                   return caml_exact_trampoline_cps_call$1(f, 0, child, cont);
		                  default: return cont();
		                }
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Node";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$117(of_a_001, param, cont){
		                var
		                 id_003 = param[1],
		                 recomputed_at_007 = param[3],
		                 value_opt_009 = param[4],
		                 kind_011 = param[5],
		                 cutoff_013 = param[6],
		                 changed_at_015 = param[7],
		                 num_on_update_handlers_017 = param[8],
		                 num_parents_019 = param[9],
		                 parent1_and_beyond_021 = param[10],
		                 parent0_023 = param[11],
		                 created_in_025 = param[12],
		                 next_node_in_same_scope_027 = param[13],
		                 height_029 = param[14],
		                 height_in_recompute_heap_031 = param[15],
		                 prev_in_recompute_heap_033 = param[16],
		                 next_in_recompute_heap_035 = param[17],
		                 height_in_adjust_heights_heap_ = param[18],
		                 next_in_adjust_heights_heap_03 = param[19],
		                 old_value_opt_041 = param[20],
		                 observers_043 = param[21],
		                 is_in_handle_after_stabilizati = param[22],
		                 on_update_handlers_047 = param[23],
		                 my_parent_index_in_child_at_in = param[24],
		                 my_child_index_in_parent_at_in = param[25],
		                 force_necessary_053 = param[26],
		                 user_info_055 = param[27],
		                 creation_backtrace_057 = param[28];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_option,
		                         sexp_of_t$20,
		                         creation_backtrace_057,
		                         function(arg_058){
		                          var bnds_002 = [0, [1, [0, aMk, [0, arg_058, 0]]], 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_option,
		                                   sexp_of_t$99,
		                                   user_info_055,
		                                   function(arg_056){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aMl, [0, arg_056, 0]]], bnds_002];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_bool,
		     force_necessary_053,
		     function(arg_054){
		      var
		       bnds_002 = [0, [1, [0, aMm, [0, arg_054, 0]]], bnds_002$0];
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_array,
		               sexp_of_int$0,
		               my_child_index_in_parent_at_in,
		               function(arg_052){
		                var
		                 bnds_002$0 = [0, [1, [0, aMn, [0, arg_052, 0]]], bnds_002];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_array,
		                         sexp_of_int$0,
		                         my_parent_index_in_child_at_in,
		                         function(arg_050){
		                          var
		                           bnds_002 = [0, [1, [0, aMo, [0, arg_050, 0]]], bnds_002$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_list,
		                                   function(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$101, of_a_001, a, cont);
		                                   },
		                                   on_update_handlers_047,
		                                   function(arg_048){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aMp, [0, arg_048, 0]]], bnds_002];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_bool,
		     is_in_handle_after_stabilizati,
		     function(arg_046){
		      var
		       bnds_002 = [0, [1, [0, aMq, [0, arg_046, 0]]], bnds_002$0];
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$88,
		               sexp_of_opaque,
		               observers_043,
		               function(arg_044){
		                var
		                 bnds_002$0 = [0, [1, [0, aMr, [0, arg_044, 0]]], bnds_002];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         of_a_001,
		                         old_value_opt_041,
		                         function(arg_042){
		                          var
		                           bnds_002 = [0, [1, [0, aMs, [0, arg_042, 0]]], bnds_002$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$88,
		                                   Node[2][1],
		                                   next_in_adjust_heights_heap_03,
		                                   function(arg_040){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aMt, [0, arg_040, 0]]], bnds_002];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     height_in_adjust_heights_heap_,
		     function(arg_038){
		      var
		       bnds_002 = [0, [1, [0, aMu, [0, arg_038, 0]]], bnds_002$0];
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$88,
		               Node[2][1],
		               next_in_recompute_heap_035,
		               function(arg_036){
		                var
		                 bnds_002$0 = [0, [1, [0, aMv, [0, arg_036, 0]]], bnds_002];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         Node[2][1],
		                         prev_in_recompute_heap_033,
		                         function(arg_034){
		                          var
		                           bnds_002 = [0, [1, [0, aMw, [0, arg_034, 0]]], bnds_002$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   height_in_recompute_heap_031,
		                                   function(arg_032){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aMx, [0, arg_032, 0]]], bnds_002];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     height_029,
		     function(arg_030){
		      var
		       bnds_002 = [0, [1, [0, aMy, [0, arg_030, 0]]], bnds_002$0];
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$88,
		               Node[2][1],
		               next_node_in_same_scope_027,
		               function(arg_028){
		                var
		                 bnds_002$0 = [0, [1, [0, aMz, [0, arg_028, 0]]], bnds_002];
		                return caml_trampoline_cps_call2
		                        (sexp_of_t$111,
		                         created_in_025,
		                         function(arg_026){
		                          var
		                           bnds_002 = [0, [1, [0, aMA, [0, arg_026, 0]]], bnds_002$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$88,
		                                   Node[2][1],
		                                   parent0_023,
		                                   function(arg_024){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aMB, [0, arg_024, 0]]], bnds_002];
		                                    return caml_trampoline_cps_call2
		    (sexp_of_t$88,
		     Node[2][1],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$6,
		               a,
		               parent1_and_beyond_021,
		               function(arg_022){
		                var
		                 bnds_002 = [0, [1, [0, aMC, [0, arg_022, 0]]], bnds_002$0];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         num_parents_019,
		                         function(arg_020){
		                          var
		                           bnds_002$0 = [0, [1, [0, aMD, [0, arg_020, 0]]], bnds_002];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   num_on_update_handlers_017,
		                                   function(arg_018){
		                                    var
		                                     bnds_002 = [0, [1, [0, aME, [0, arg_018, 0]]], bnds_002$0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     changed_at_015,
		     function(arg_016){
		      var
		       bnds_002$0 = [0, [1, [0, aMF, [0, arg_016, 0]]], bnds_002],
		       arg_014 = sexp_of_t$97(of_a_001, cutoff_013),
		       bnds_002$1 = [0, [1, [0, aMG, [0, arg_014, 0]]], bnds_002$0];
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$116,
		               of_a_001,
		               kind_011,
		               function(arg_012){
		                var
		                 bnds_002 = [0, [1, [0, aMH, [0, arg_012, 0]]], bnds_002$1];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         of_a_001,
		                         value_opt_009,
		                         function(arg_010){
		                          var
		                           bnds_002$0 = [0, [1, [0, aMI, [0, arg_010, 0]]], bnds_002];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   recomputed_at_007,
		                                   function(arg_008){
		                                    var
		                                     bnds_002 = [0, [1, [0, aMJ, [0, arg_008, 0]]], bnds_002$0],
		                                     bnds_002$1 = [0, [1, [0, aMK, [0, arg_006, 0]]], bnds_002];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     id_003,
		     function(arg_004){
		      var
		       bnds_002 = [0, [1, [0, aML, [0, arg_004, 0]]], bnds_002$1];
		      return cont([1, bnds_002]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var is_necessary$1 = Node[4];
		               function iteri_children$0(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (iteri_children, t[5], f, cont);
		               }
		               var is_valid$2 = Node[3];
		               function set_user_info(t, info){
		                if(info) var i = info[1], a = [0, [1, i]]; else a = 0;
		                t[27] = a;
		               }
		               function edge_is_stale(child, parent){
		                return 0 < caml_int_compare(child[7], parent[3]) ? 1 : 0;
		               }
		               function is_stale_with_respect_to_a_chi(t, cont){
		                var is_stale = [0, 0];
		                return caml_exact_trampoline_cps_call$1
		                        (iteri_children$0,
		                         t,
		                         function(a, param, cont){
		                          if(edge_is_stale(param, t)) is_stale[1] = 1;
		                          return cont();
		                         },
		                         function(a){return cont(is_stale[1]);});
		               }
		               function is_stale(t, b){
		                var a = t[5];
		                if(typeof a === "number"){
		                 if(0 === a) return b(0);
		                 b = caml_pop_trap();
		                 return b
		                         (caml_maybe_attach_backtrace([0, Assert_failure, aMM], 1));
		                }
		                switch(a[0]){
		                  case 3:
		                   var t$2 = t[3], a = t$2 === -1 ? 1 : 0;
		                   return a
		                           ? b(a)
		                           : caml_exact_trampoline_cps_call
		                             (is_stale_with_respect_to_a_chi, t, b);
		                  case 6:
		                   var force_stale = a[1][5];
		                   if(force_stale)
		                    var force_stale$0 = force_stale;
		                   else {
		                    var t$3 = t[3], a = t$3 === -1 ? 1 : 0;
		                    if(! a)
		                     return caml_exact_trampoline_cps_call
		                             (is_stale_with_respect_to_a_chi, t, b);
		                    force_stale$0 = a;
		                   }
		                   return b(force_stale$0);
		                  case 8:
		                   var t$4 = t[3], a = t$4 === -1 ? 1 : 0;
		                   return a
		                           ? b(a)
		                           : caml_exact_trampoline_cps_call
		                             (is_stale_with_respect_to_a_chi, t, b);
		                  case 10:
		                   var t$5 = t[3], a = t$5 === -1 ? 1 : 0;
		                   return a
		                           ? b(a)
		                           : caml_exact_trampoline_cps_call
		                             (is_stale_with_respect_to_a_chi, t, b);
		                  case 16:
		                   var set_at = a[1][3];
		                   return b(0 < caml_int_compare(set_at, t[3]) ? 1 : 0);
		                  case 1:
		                  case 2:
		                  case 5:
		                  case 13:
		                   var t$1 = t[3]; return b(t$1 === -1 ? 1 : 0);
		                  default:
		                   var t$0 = t[3], a = t$0 === -1 ? 1 : 0;
		                   return a
		                           ? b(a)
		                           : caml_exact_trampoline_cps_call
		                             (is_stale_with_respect_to_a_chi, t, b);
		                }
		               }
		               function is_in_recompute_heap(t){return 0 <= t[15] ? 1 : 0;}
		               function get_parent(t, index, cont){
		                if(index === 0)
		                 var a = t[11];
		                else
		                 var i = index - 1 | 0, arr = t[10], a = get$3(arr, i);
		                return caml_exact_trampoline_cps_call(value_exn$1, a, cont);
		               }
		               function should_be_invalidated(t, cont){
		                var a = t[5];
		                if(typeof a !== "number")
		                 switch(a[0]){
		                   case 4:
		                    var lhs_change = a[1][4];
		                    return caml_trampoline_cps_call2
		                            (is_valid$2, lhs_change, function(a){return cont(1 - a);});
		                   case 8:
		                   case 10:
		                    var test = a[1][2];
		                    return caml_trampoline_cps_call2
		                            (is_valid$2, test, function(a){return cont(1 - a);});
		                   case 1:
		                   case 2:
		                   case 6:
		                    return cont(0);
		                   case 3:
		                   case 9:
		                   case 11:
		                    var lhs = a[1][3];
		                    return caml_trampoline_cps_call2
		                            (is_valid$2, lhs, function(a){return cont(1 - a);});
		                   case 5:
		                   case 13:
		                   case 16:
		                    return cont(0);
		                   default:
		                    var has = [0, 0];
		                    return caml_exact_trampoline_cps_call$1
		                            (iteri_children$0,
		                             t,
		                             function(a, param, cont){
		                              a = has[1];
		                              function b(a){has[1] = a; return cont();}
		                              return a
		                                      ? b(a)
		                                      : caml_trampoline_cps_call2
		(is_valid$2, param, function(a){return b(1 - a);});
		                             },
		                             function(a){return cont(has[1]);});
		                 }
		                if(0 === a) return cont(0);
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aMN], 1));
		               }
		               var
		                cst_attempt_to_get_value_of_an =
		                  "attempt to get value of an invalid node";
		               function value_exn$2(t, cont){
		                return is_some$2(t[4])
		                        ? cont(t[4])
		                        : caml_exact_trampoline_cps_call$3
		                          (failwiths,
		                           0,
		                           aMP,
		                           cst_attempt_to_get_value_of_an,
		                           t,
		                           function(x_072, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (sexp_of_t$117,
		                                     function(param, cont){return cont(aMO);},
		                                     x_072,
		                                     cont);
		                           },
		                           cont);
		               }
		               function set_cutoff(t, cutoff){t[6] = cutoff;}
		               function is_const(t){
		                var match = t[5];
		                if(typeof match !== "number" && 5 === match[0]) return 1;
		                return 0;
		               }
		               function run_on_update_handlers(t, node_update, now, cont){
		                function a(r){
		                 if(is_empty(r)){
		                  var
		                   b =
		                     function(r){
		                      return is_some$2(r)
		                              ? caml_exact_trampoline_cps_call
		                                (value_exn$1,
		                                 r,
		                                 function(observer){
		                                  var r = observer[7];
		                                  function a(r$0){
		                                   if(is_empty(r$0)) return caml_exact_trampoline_call1(b, r);
		                                   if(! r$0){
		                                    var c = caml_pop_trap();
		                                    return c
		    (caml_maybe_attach_backtrace([0, Assert_failure, aMR], 1));
		                                   }
		                                   var
		                                    rest = r$0[2],
		                                    on_update_handler = r$0[1],
		                                    c = observer[1];
		                                   if(c)
		                                    switch(c - 1 | 0){
		                                      case 0:
		                                       return caml_exact_trampoline_cps_call$0
		       (run$3,
		        on_update_handler,
		        node_update,
		        now,
		        function(b){return caml_exact_trampoline_call1(a, rest);});
		                                      case 2: break;
		                                      default: return caml_exact_trampoline_call1(a, rest);
		                                    }
		                                   c = caml_pop_trap();
		                                   return c
		   (caml_maybe_attach_backtrace([0, Assert_failure, aMQ], 1));
		                                  }
		                                  return a(observer[3]);
		                                 })
		                              : cont();
		                     };
		                  return b(t[21]);
		                 }
		                 if(r){
		                  var rest = r[2], on_update_handler = r[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (run$3,
		                           on_update_handler,
		                           node_update,
		                           now,
		                           function(b){return caml_exact_trampoline_call1(a, rest);});
		                 }
		                 var raise = caml_pop_trap();
		                 return raise
		                         (caml_maybe_attach_backtrace([0, Assert_failure, aMS], 1));
		                }
		                return a(t[23]);
		               }
		               function set_kind(t, kind){
		                t[5] = kind;
		                var len = initial_num_children(kind);
		                t[24] = caml_make_vect(len, -1);
		               }
		               var r$0 = [0, 0];
		               function create$35(state, created_in, kind, cont){
		                var
		                 a = state[18] ? [0, get$4()] : 0,
		                 len = initial_num_children(kind);
		                incr$0(r$0);
		                var
		                 none = -1,
		                 t =
		                   [0,
		                    r$0[1],
		                    state,
		                    none,
		                    none$3,
		                    kind,
		                    2,
		                    none,
		                    0,
		                    0,
		                    empty$7,
		                    none$3,
		                    created_in,
		                    none$3,
		                    -1,
		                    -1,
		                    none$3,
		                    none$3,
		                    -1,
		                    none$3,
		                    none$3,
		                    none$3,
		                    0,
		                    0,
		                    caml_make_vect(len, -1),
		                    [0, -1],
		                    0,
		                    0,
		                    a];
		                return caml_exact_trampoline_cps_call$1
		                        (add_node, created_in, t, function(a){return cont(t);});
		               }
		               function max_num_parents(t){return 1 + (t[10].length - 1) | 0;}
		               function set_parent(child, parent, parent_index){
		                if(parent_index === 0){child[11] = parent; return;}
		                var i = parent_index - 1 | 0, t = child[10];
		                return set_with_caml_modify(t, i, parent);
		               }
		               function link$0(child, child_index, parent, parent_index, cont){
		                return caml_exact_trampoline_cps_call
		                        (some$1,
		                         parent,
		                         function(a){
		                          set_parent(child, a, parent_index);
		                          caml_check_bound(child[25], parent_index)[parent_index + 1]
		                          = child_index;
		                          caml_check_bound(parent[24], child_index)[child_index + 1] = parent_index;
		                          return cont();
		                         });
		               }
		               function add_parent(child, parent, child_index, cont){
		                var b = max_num_parents(child);
		                function a(){
		                 var max_num_children = parent[24].length - 1;
		                 function a(){
		                  return caml_exact_trampoline_cps_call$2
		                          (link$0,
		                           child,
		                           child_index,
		                           parent,
		                           child[9],
		                           function(a){child[9] = child[9] + 1 | 0; return cont();});
		                 }
		                 return max_num_children <= child_index
		                         ? caml_exact_trampoline_cps_call$1
		                           (max$2,
		                            2,
		                            2 * max_num_children | 0,
		                            function(new_max_num_children){
		                             return caml_exact_trampoline_cps_call$0
		                                     (realloc,
		                                      parent[24],
		                                      new_max_num_children,
		                                      -1,
		                                      function(b){parent[24] = b; return a();});
		                            })
		                         : a();
		                }
		                if(child[9] !== b) return a();
		                var new_max_num_parents = 2 * max_num_parents(child) | 0;
		                return caml_exact_trampoline_cps_call$1
		                        (realloc$0,
		                         child[10],
		                         new_max_num_parents - 1 | 0,
		                         function(b){
		                          child[10] = b;
		                          return caml_exact_trampoline_cps_call$0
		                                  (realloc,
		                                   child[25],
		                                   new_max_num_parents,
		                                   -1,
		                                   function(b){child[25] = b; return a();});
		                         });
		               }
		               function remove_parent(child, parent, child_index, cont){
		                var
		                 parent_index =
		                   caml_check_bound(parent[24], child_index)[child_index + 1],
		                 last_parent_index = child[9] - 1 | 0;
		                function a(a){
		                 set_parent(child, none$3, last_parent_index);
		                 child[9] = child[9] - 1 | 0;
		                 return cont();
		                }
		                if(parent_index >= last_parent_index) return a();
		                var i = last_parent_index - 1 | 0, arr = child[10];
		                return caml_exact_trampoline_cps_call
		                        (value_exn$1,
		                         get$3(arr, i),
		                         function(match){
		                          return caml_exact_trampoline_cps_call$2
		                                  (link$0,
		                                   child,
		                                   caml_check_bound(child[25], last_parent_index)
		                                    [last_parent_index + 1],
		                                   match,
		                                   parent_index,
		                                   a);
		                         });
		               }
		               function swap_children_except_in_kind
		               (parent, child1, child_index1, child2, child_index2){
		                var
		                 index_of_parent_in_child1 =
		                   caml_check_bound(parent[24], child_index1)[child_index1 + 1],
		                 index_of_parent_in_child2 =
		                   caml_check_bound(parent[24], child_index2)[child_index2 + 1];
		                caml_check_bound(child1[25], index_of_parent_in_child1)
		                 [index_of_parent_in_child1 + 1]
		                = child_index2;
		                caml_check_bound(child2[25], index_of_parent_in_child2)
		                 [index_of_parent_in_child2 + 1]
		                = child_index1;
		                caml_check_bound(parent[24], child_index1)[child_index1 + 1] = index_of_parent_in_child2;
		                caml_check_bound(parent[24], child_index2)[child_index2 + 1] = index_of_parent_in_child1;
		               }
		               function sexp_of_t$118(x_073, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$117,
		                         function(param, cont){return cont(aMT);},
		                         x_073,
		                         cont);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               function As_list(M){
		                function sexp_of_t(t, cont){
		                 var packed_node = t, ac = 0;
		                 for(;;){
		                  if(! is_some$2(packed_node)) break;
		                  var a = [0, packed_node, ac];
		                  packed_node = M[1].call(null, packed_node);
		                  ac = a;
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (of_rev_keys,
		                          ac,
		                          function(x_074){
		                           return caml_exact_trampoline_cps_call$1
		                                   (sexp_of_list, Node[2][1], x_074, cont);
		                          });
		                }
		                return [0, sexp_of_t];
		               }
		               var d = "Incremental__Recompute_heap";
		               record_start(d);
		               set$7(j);
		               function next$4(param){return param[17];}
		               var As_recompute_list = As_list([0, next$4]);
		               function sexp_of_t$119(a, cont){
		                var
		                 length_003 = a[1],
		                 height_lower_bound_005 = a[2],
		                 nodes_by_height_007 = a[3],
		                 a = nodes_by_height_007.length - 2 | 0,
		                 b = -1;
		                if(a < 0)
		                 var max_nonempty_index$1 = b;
		                else {
		                 var max_nonempty_index = b, i = 0;
		                 for(;;){
		                  var
		                   l = nodes_by_height_007[i + 1],
		                   max_nonempty_index$0 = is_some$2(l) ? i : max_nonempty_index,
		                   b = i + 1 | 0;
		                  if(a === i){
		                   max_nonempty_index$1 = max_nonempty_index$0;
		                   break;
		                  }
		                  max_nonempty_index = max_nonempty_index$0;
		                  i = b;
		                 }
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (sub$1,
		                         nodes_by_height_007,
		                         0,
		                         max_nonempty_index$1 + 1 | 0,
		                         function(x_001){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$6,
		                                   As_recompute_list[1],
		                                   x_001,
		                                   function(arg_008){
		                                    var bnds_002 = [0, [1, [0, aMU, [0, arg_008, 0]]], 0];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     height_lower_bound_005,
		     function(arg_006){
		      var
		       bnds_002$0 = [0, [1, [0, aMV, [0, arg_006, 0]]], bnds_002];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               length_003,
		               function(arg_004){
		                var
		                 bnds_002 = [0, [1, [0, aMW, [0, arg_004, 0]]], bnds_002$0];
		                return cont([1, bnds_002]);
		               });
		     });
		                                   });
		                         });
		               }
		               function create_nodes_by_height(max_height_allowed){
		                var len = max_height_allowed + 1 | 0;
		                return create$12(len, none$3);
		               }
		               function set_prev(next, prev){
		                if(is_some$2(next)) next[16] = prev;
		               }
		               function link$1(t, node, cont){
		                var height = node[14];
		                node[15] = height;
		                var arr = t[3], next = get$3(arr, height);
		                node[17] = next;
		                return caml_exact_trampoline_cps_call
		                        (some$1,
		                         node,
		                         function(a){
		                          set_prev(next, a);
		                          return caml_exact_trampoline_cps_call
		                                  (some$1,
		                                   node,
		                                   function(x){
		                                    var t$0 = t[3];
		                                    return cont(unsafe_set_with_caml_modify(t$0, height, x));
		                                   });
		                         });
		               }
		               function unlink(t, node, cont){
		                var
		                 prev = node[16],
		                 next = node[17],
		                 i = node[15],
		                 arr = t[3],
		                 a = get$3(arr, i);
		                return caml_exact_trampoline_cps_call
		                        (some$1,
		                         node,
		                         function(b){
		                          if(b === a){
		                           var i = node[15], t$0 = t[3];
		                           unsafe_set_with_caml_modify(t$0, i, next);
		                          }
		                          set_prev(next, prev);
		                          if(is_some$2(prev)) prev[17] = next;
		                          node[16] = none$3;
		                          return cont();
		                         });
		               }
		               function add$15(t, node, cont){
		                var height = node[14];
		                if(height < t[2]) t[2] = height;
		                return caml_exact_trampoline_cps_call$1
		                        (link$1,
		                         t,
		                         node,
		                         function(a){t[1] = t[1] + 1 | 0; return cont();});
		               }
		               function remove$6(t, node, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (unlink,
		                         t,
		                         node,
		                         function(a){
		                          node[17] = none$3;
		                          node[15] = -1;
		                          t[1] = t[1] - 1 | 0;
		                          return cont();
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Adjust_heights_heap";
		               record_start(d);
		               set$7(j);
		               function next$5(param){return param[19];}
		               var As_adjust_heights_list = As_list([0, next$5]);
		               function sexp_of_t$120(arr, cont){
		                var b = arr.length - 2 | 0, a = -1;
		                if(b < 0)
		                 var max_nonempty_index$1 = a;
		                else {
		                 var max_nonempty_index = a, i = 0;
		                 for(;;){
		                  var
		                   l = arr[i + 1],
		                   max_nonempty_index$0 = is_some$2(l) ? i : max_nonempty_index,
		                   a = i + 1 | 0;
		                  if(b === i){
		                   max_nonempty_index$1 = max_nonempty_index$0;
		                   break;
		                  }
		                  max_nonempty_index = max_nonempty_index$0;
		                  i = a;
		                 }
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (sub$1,
		                         arr,
		                         0,
		                         max_nonempty_index$1 + 1 | 0,
		                         function(x_001){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$6, As_adjust_heights_list[1], x_001, cont);
		                         });
		               }
		               function create$36(max_height_allowed){
		                var len = max_height_allowed + 1 | 0;
		                return create$12(len, none$3);
		               }
		               function sexp_of_t$121(param, cont){
		                var
		                 length_003 = param[1],
		                 height_lower_bound_005 = param[2],
		                 max_height_seen_007 = param[3],
		                 nodes_by_height_009 = param[4];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$120,
		                         nodes_by_height_009,
		                         function(arg_010){
		                          var bnds_002 = [0, [1, [0, aMX, [0, arg_010, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   max_height_seen_007,
		                                   function(arg_008){
		                                    var
		                                     bnds_002$0 = [0, [1, [0, aMY, [0, arg_008, 0]]], bnds_002];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     height_lower_bound_005,
		     function(arg_006){
		      var
		       bnds_002 = [0, [1, [0, aMZ, [0, arg_006, 0]]], bnds_002$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               length_003,
		               function(arg_004){
		                var
		                 bnds_002$0 = [0, [1, [0, aM0, [0, arg_004, 0]]], bnds_002];
		                return cont([1, bnds_002$0]);
		               });
		     });
		                                   });
		                         });
		               }
		               function max_height_allowed(t){return t[4].length - 2 | 0;}
		               function set_height(t, node, height, cont){
		                function a(a){node[14] = height; return cont();}
		                return t[3] < height
		                        ? (t
		                           [3]
		                          = height,
		                          max_height_allowed(t) < height
		                           ? caml_exact_trampoline_cps_call$3
		                             (failwiths,
		                              0,
		                              aM3,
		                              "node with too large height",
		                              [0,
		                               [0, 920681479, height],
		                               [0, 3850884, max_height_allowed(t)]],
		                              function(param, cont){
		                               var
		                                arg1_019 = param[2],
		                                arg0_018 = param[1],
		                                v_016 = arg0_018[2];
		                               return caml_exact_trampoline_cps_call
		                                       (sexp_of_int$0,
		v_016,
		function(a){
		 var
		  res0_020 = [1, [0, aM1, [0, a, 0]]],
		  v_017 = arg1_019[2];
		 return caml_exact_trampoline_cps_call
		         (sexp_of_int$0,
		          v_017,
		          function(a){
		           var res1_021 = [1, [0, aM2, [0, a, 0]]];
		           return cont([1, [0, res0_020, [0, res1_021, 0]]]);
		          });
		});
		                              },
		                              a)
		                           : a())
		                        : a();
		               }
		               function ensure_height_requirement
		               (t, original_child, original_parent, child, parent, cont){
		                function a(a){
		                 a = parent[14] <= child[14] ? 1 : 0;
		                 if(! a) return cont(a);
		                 function b(){
		                  return caml_exact_trampoline_cps_call$0
		                          (set_height, t, parent, child[14] + 1 | 0, cont);
		                 }
		                 if(parent[18] !== -1) return b();
		                 var height = parent[14];
		                 parent[18] = height;
		                 t[1] = t[1] + 1 | 0;
		                 var arr = t[4];
		                 parent[19] = get$3(arr, height);
		                 return caml_exact_trampoline_cps_call
		                         (some$1,
		                          parent,
		                          function(x){
		                           var t$0 = t[4];
		                           unsafe_set_with_caml_modify(t$0, height, x);
		                           return b();
		                          });
		                }
		                return parent === original_child
		                        ? caml_exact_trampoline_cps_call$3
		                          (failwiths,
		                           0,
		                           aM8,
		                           "adding edge made graph cyclic",
		                           [0,
		                            [0, -977688164, original_child],
		                            [0, -310508246, original_parent]],
		                           function(param, cont){
		                            var
		                             arg1_025 = param[2],
		                             arg0_024 = param[1],
		                             v_022 = arg0_024[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (sexp_of_t$117,
		                                     function(param, cont){return cont(aM4);},
		                                     v_022,
		                                     function(a){
		                                      var
		                                       res0_026 = [1, [0, aM5, [0, a, 0]]],
		                                       v_023 = arg1_025[2];
		                                      return caml_exact_trampoline_cps_call$1
		      (sexp_of_t$117,
		       function(param, cont){return cont(aM6);},
		       v_023,
		       function(a){
		        var res1_027 = [1, [0, aM7, [0, a, 0]]];
		        return cont([1, [0, res0_026, [0, res1_027, 0]]]);
		       });
		                                     });
		                           },
		                           a)
		                        : a(0);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Alarm_value";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Config_intf";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Config";
		               record_start(d);
		               set$7(j);
		               function Default(symbol){return [0, 1];}
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Internal_observer";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$122(param, cont){
		                var x_001 = param[2];
		                return caml_trampoline_cps_call3
		                        (Node[1],
		                         function(param, cont){return cont(aM9);},
		                         x_001,
		                         cont);
		               }
		               function set_prev_in_all(param, t2){param[4] = t2;}
		               function sexp_of_internal_observer(of_a_002, param, cont){
		                var
		                 state_004 = param[1],
		                 observing_006 = param[2],
		                 on_update_handlers_008 = param[3],
		                 prev_in_all_010 = param[4],
		                 next_in_all_012 = param[5],
		                 prev_in_observing_014 = param[6],
		                 next_in_observing_016 = param[7];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$88,
		                         sexp_of_opaque,
		                         next_in_observing_016,
		                         function(arg_017){
		                          var bnds_003 = [0, [1, [0, aNc, [0, arg_017, 0]]], 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$88,
		                                   sexp_of_opaque,
		                                   prev_in_observing_014,
		                                   function(arg_015){
		                                    var
		                                     bnds_003$0 = [0, [1, [0, aNd, [0, arg_015, 0]]], bnds_003];
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$88,
		     sexp_of_t$122,
		     next_in_all_012,
		     function(arg_013){
		      var
		       bnds_003 = [0, [1, [0, aNe, [0, arg_013, 0]]], bnds_003$0];
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$88,
		               sexp_of_t$122,
		               prev_in_all_010,
		               function(arg_011){
		                var
		                 bnds_003$0 = [0, [1, [0, aNf, [0, arg_011, 0]]], bnds_003];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_list,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$101, of_a_002, a, cont);
		                         },
		                         on_update_handlers_008,
		                         function(arg_009){
		                          var
		                           bnds_003 = [0, [1, [0, aNg, [0, arg_009, 0]]], bnds_003$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$117,
		                                   of_a_002,
		                                   observing_006,
		                                   function(arg_007){
		                                    var
		                                     bnds_003$0 = [0, [1, [0, aNh, [0, arg_007, 0]]], bnds_003];
		                                    switch(state_004){
		                                      case 0:
		                                       var arg_005 = aM_; break;
		                                      case 1:
		                                       arg_005 = aM$; break;
		                                      case 2:
		                                       arg_005 = aNa; break;
		                                      default: arg_005 = aNb;
		                                    }
		                                    var
		                                     bnds_003$1 = [0, [1, [0, aNi, [0, arg_005, 0]]], bnds_003$0];
		                                    return cont([1, bnds_003$1]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function incr_state$0(t){return t[2][2];}
		               function sexp_of_t$123(x_025, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_internal_observer,
		                         function(param, cont){return cont(aNs);},
		                         x_025,
		                         cont);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Observer";
		               record_start(d);
		               set$7(j);
		               function sexp_of_t$124(of_a_001, x_002, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_internal_observer, of_a_001, x_002[1], cont);
		               }
		               function observing(t){var r = t[1]; return r[2];}
		               function incr_state$1(t){return incr_state$0(t[1]);}
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__State";
		               record_start(d);
		               set$7(j);
		               function sexp_of_status(param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return cont(aNt);
		                   case 1:
		                    return cont(aNu);
		                   default: return cont(aNv);
		                 }
		                var
		                 arg0_001 = param[1],
		                 backtrace_004 = arg0_001[2],
		                 exn_002 = arg0_001[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$20,
		                         backtrace_004,
		                         function(arg_005){
		                          var bnds_001 = [0, [1, [0, aHg, [0, arg_005, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_exn,
		                                   exn_002,
		                                   function(arg_003){
		                                    var
		                                     bnds_001$0 = [0, [1, [0, aHh, [0, arg_003, 0]]], bnds_001];
		                                    return cont([1, [0, aNw, [0, [1, bnds_001$0], 0]]]);
		                                   });
		                         });
		               }
		               function sexp_of_t$125(param, cont){
		                var arg1_004 = param[2], arg0_003 = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$117,
		                         function(param, cont){return cont(aNx);},
		                         arg0_003,
		                         function(res0_005){
		                          var
		                           res1_006 =
		                             sexp_of_t$100(function(param){return aNy;}, arg1_004);
		                          return cont([1, [0, aNz, [0, res0_005, [0, res1_006, 0]]]]);
		                         });
		               }
		               function sexp_of_t$126(param, cont){
		                var
		                 currently_running_node_008 = param[1],
		                 expert_nodes_created_by_curren = param[2];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_list,
		                         sexp_of_t$118,
		                         expert_nodes_created_by_curren,
		                         function(arg_011){
		                          var bnds_007 = [0, [1, [0, aNA, [0, arg_011, 0]]], 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_option,
		                                   sexp_of_t$118,
		                                   currently_running_node_008,
		                                   function(arg_009){
		                                    var
		                                     bnds_007$0 = [0, [1, [0, aNB, [0, arg_009, 0]]], bnds_007];
		                                    return cont([1, bnds_007$0]);
		                                   });
		                         });
		               }
		               function create$37(param){return [0, 0, 0];}
		               function sexp_of_t$127(param, cont){
		                var arg0_012 = param[1];
		                return caml_exact_trampoline_cps_call$0
		                        (sexp_of_t$95,
		                         function(param, cont){return cont(aND);},
		                         function(param, cont){return cont(aNC);},
		                         arg0_012,
		                         function(res0_013){
		                          return cont([1, [0, aNE, [0, res0_013, 0]]]);
		                         });
		               }
		               function sexp_of_t$128(param, cont){
		                var
		                 status_015 = param[1],
		                 bind_lhs_change_should_invalid = param[2],
		                 stabilization_num_019 = param[3],
		                 current_scope_021 = param[4],
		                 propagate_invalidity_027 = param[7],
		                 adjust_heights_heap_025 = param[6],
		                 recompute_heap_023 = param[5],
		                 num_active_observers_029 = param[8],
		                 all_observers_031 = param[9],
		                 run_on_update_handlers_043 = param[15],
		                 handle_after_stabilization_041 = param[14],
		                 set_during_stabilization_039 = param[13],
		                 disallowed_observers_037 = param[12],
		                 new_observers_035 = param[11],
		                 finalized_observers_033 = param[10],
		                 only_in_debug_045 = param[16],
		                 weak_hashtbls_047 = param[17],
		                 keep_node_creation_backtrace_0 = param[18],
		                 num_nodes_became_necessary_051 = param[19],
		                 num_nodes_became_unnecessary_0 = param[20],
		                 num_nodes_changed_055 = param[21],
		                 num_nodes_created_057 = param[22],
		                 num_nodes_invalidated_059 = param[23],
		                 num_nodes_recomputed_061 = param[24],
		                 num_nodes_recomputed_directly_ = param[25],
		                 num_nodes_recomputed_directly_$0 = param[26],
		                 num_var_sets_067 = param[27];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         num_var_sets_067,
		                         function(arg_068){
		                          var bnds_014 = [0, [1, [0, aNF, [0, arg_068, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   num_nodes_recomputed_directly_$0,
		                                   function(arg_066){
		                                    var
		                                     bnds_014$0 = [0, [1, [0, aNG, [0, arg_066, 0]]], bnds_014];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     num_nodes_recomputed_directly_,
		     function(arg_064){
		      var
		       bnds_014 = [0, [1, [0, aNH, [0, arg_064, 0]]], bnds_014$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               num_nodes_recomputed_061,
		               function(arg_062){
		                var
		                 bnds_014$0 = [0, [1, [0, aNI, [0, arg_062, 0]]], bnds_014];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         num_nodes_invalidated_059,
		                         function(arg_060){
		                          var
		                           bnds_014 = [0, [1, [0, aNJ, [0, arg_060, 0]]], bnds_014$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_int$0,
		                                   num_nodes_created_057,
		                                   function(arg_058){
		                                    var
		                                     bnds_014$0 = [0, [1, [0, aNK, [0, arg_058, 0]]], bnds_014];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_int$0,
		     num_nodes_changed_055,
		     function(arg_056){
		      var
		       bnds_014 = [0, [1, [0, aNL, [0, arg_056, 0]]], bnds_014$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               num_nodes_became_unnecessary_0,
		               function(arg_054){
		                var
		                 bnds_014$0 = [0, [1, [0, aNM, [0, arg_054, 0]]], bnds_014];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         num_nodes_became_necessary_051,
		                         function(arg_052){
		                          var
		                           bnds_014 = [0, [1, [0, aNN, [0, arg_052, 0]]], bnds_014$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_bool,
		                                   keep_node_creation_backtrace_0,
		                                   function(arg_050){
		                                    var
		                                     bnds_014$0 = [0, [1, [0, aNO, [0, arg_050, 0]]], bnds_014];
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$90,
		     sexp_of_t$127,
		     weak_hashtbls_047,
		     function(arg_048){
		      var
		       bnds_014 = [0, [1, [0, aNP, [0, arg_048, 0]]], bnds_014$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_t$126,
		               only_in_debug_045,
		               function(arg_046){
		                var
		                 bnds_014$0 = [0, [1, [0, aNQ, [0, arg_046, 0]]], bnds_014];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$10,
		                         sexp_of_t$125,
		                         run_on_update_handlers_043,
		                         function(arg_044){
		                          var
		                           bnds_014 = [0, [1, [0, aNR, [0, arg_044, 0]]], bnds_014$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$10,
		                                   sexp_of_t$118,
		                                   handle_after_stabilization_041,
		                                   function(arg_042){
		                                    var
		                                     bnds_014$0 = [0, [1, [0, aNS, [0, arg_042, 0]]], bnds_014];
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$10,
		     sexp_of_t$104,
		     set_during_stabilization_039,
		     function(arg_040){
		      var
		       bnds_014 = [0, [1, [0, aNT, [0, arg_040, 0]]], bnds_014$0];
		      return caml_exact_trampoline_cps_call$1
		              (sexp_of_t$10,
		               sexp_of_t$123,
		               disallowed_observers_037,
		               function(arg_038){
		                var
		                 bnds_014$0 = [0, [1, [0, aNU, [0, arg_038, 0]]], bnds_014];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$10,
		                         sexp_of_t$123,
		                         new_observers_035,
		                         function(arg_036){
		                          var
		                           bnds_014 = [0, [1, [0, aNV, [0, arg_036, 0]]], bnds_014$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (sexp_of_t$90,
		                                   sexp_of_t$123,
		                                   finalized_observers_033,
		                                   function(arg_034){
		                                    var
		                                     bnds_014$0 = [0, [1, [0, aNW, [0, arg_034, 0]]], bnds_014];
		                                    return caml_exact_trampoline_cps_call$1
		    (sexp_of_t$88,
		     sexp_of_t$123,
		     all_observers_031,
		     function(arg_032){
		      var
		       bnds_014 = [0, [1, [0, aNX, [0, arg_032, 0]]], bnds_014$0];
		      return caml_exact_trampoline_cps_call
		              (sexp_of_int$0,
		               num_active_observers_029,
		               function(arg_030){
		                var
		                 bnds_014$0 = [0, [1, [0, aNY, [0, arg_030, 0]]], bnds_014];
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$10,
		                         sexp_of_t$118,
		                         propagate_invalidity_027,
		                         function(arg_028){
		                          var
		                           bnds_014 = [0, [1, [0, aNZ, [0, arg_028, 0]]], bnds_014$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$121,
		                                   adjust_heights_heap_025,
		                                   function(arg_026){
		                                    var
		                                     bnds_014$0 = [0, [1, [0, aN0, [0, arg_026, 0]]], bnds_014];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_t$119,
		     recompute_heap_023,
		     function(arg_024){
		      var
		       bnds_014 = [0, [1, [0, aN1, [0, arg_024, 0]]], bnds_014$0];
		      return caml_trampoline_cps_call2
		              (sexp_of_t$111,
		               current_scope_021,
		               function(arg_022){
		                var
		                 bnds_014$0 = [0, [1, [0, aN2, [0, arg_022, 0]]], bnds_014];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_int$0,
		                         stabilization_num_019,
		                         function(arg_020){
		                          var
		                           bnds_014 = [0, [1, [0, aN3, [0, arg_020, 0]]], bnds_014$0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_bool,
		                                   bind_lhs_change_should_invalid,
		                                   function(arg_018){
		                                    var
		                                     bnds_014$0 = [0, [1, [0, aN4, [0, arg_018, 0]]], bnds_014];
		                                    return caml_exact_trampoline_cps_call
		    (sexp_of_status,
		     status_015,
		     function(arg_016){
		      var
		       bnds_014 = [0, [1, [0, aN5, [0, arg_016, 0]]], bnds_014$0];
		      return cont([1, bnds_014]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function now(clock){return clock[2][1];}
		               function ensure_not_stabilizing
		               (t, name, allow_in_update_handler, cont){
		                var a = t[1];
		                if(typeof a === "number")
		                 switch(a){
		                   case 0:
		                    var backtrace = get$4();
		                    return caml_exact_trampoline_cps_call
		                            (sprintf,
		                             aN6,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (a,
		                                       name,
		                                       function(a){
		return caml_exact_trampoline_cps_call$3
		        (failwiths, 0, aN7, a, backtrace, sexp_of_t$20, cont);
		                                       });
		                             });
		                   case 1:
		                    a = 1 - allow_in_update_handler;
		                    if(! a) return cont(a);
		                    var backtrace$0 = get$4();
		                    return caml_exact_trampoline_cps_call
		                            (sprintf,
		                             aN8,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (a,
		                                       name,
		                                       function(a){
		return caml_exact_trampoline_cps_call$3
		        (failwiths, 0, aN9, a, backtrace$0, sexp_of_t$20, cont);
		                                       });
		                             });
		                   default: return cont();
		                 }
		                var raised_exn = a[1];
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         aN_,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   name,
		                                   function(a){
		                                    return cont(reraise_with_message(raised_exn, a));
		                                   });
		                         });
		               }
		               function set_height$0(node, height, cont){
		                var t = node[2];
		                return caml_exact_trampoline_cps_call$0
		                        (set_height, t[6], node, height, cont);
		               }
		               function handle_after_stabilization(node, cont){
		                var a = 1 - node[22];
		                if(! a) return cont(a);
		                var t = node[2];
		                node[22] = 1;
		                return caml_exact_trampoline_cps_call$1
		                        (push, t[14], node, cont);
		               }
		               function remove_children(parent, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (iteri_children$0,
		                         parent,
		                         function(child_index, param, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (remove_child, param, parent, child_index, cont);
		                         },
		                         cont);
		               }
		               function remove_child(child, parent, child_index, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (remove_parent,
		                         child,
		                         parent,
		                         child_index,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (check_if_unnecessary, child, cont);
		                         });
		               }
		               function check_if_unnecessary(node, cont){
		                return caml_trampoline_cps_call2
		                        (is_necessary$1,
		                         node,
		                         function(a){
		                          a = 1 - a;
		                          return a
		                                  ? caml_exact_trampoline_cps_call
		                                    (became_unnecessary, node, cont)
		                                  : cont(a);
		                         });
		               }
		               function became_unnecessary(node, cont){
		                var t = node[2];
		                t[20] = t[20] + 1 | 0;
		                function a(a){
		                 node[14] = -1;
		                 return caml_exact_trampoline_cps_call
		                         (remove_children,
		                          node,
		                          function(a){
		                           a = node[5];
		                           function b(a){
		                            a = is_in_recompute_heap(node);
		                            return a
		                                    ? caml_exact_trampoline_cps_call$1
		                                      (remove$6, t[5], node, cont)
		                                    : cont(a);
		                           }
		                           if(typeof a === "number") return b(0);
		                           switch(a[0]){
		                             case 6:
		                              var p = a[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (observability_change, p, 0, b);
		                             case 15:
		                              var u = a[1]; force_full_compute(u); return b(0);
		                             default: return b(0);
		                           }
		                          });
		                }
		                return 0 < node[8]
		                        ? caml_exact_trampoline_cps_call
		                          (handle_after_stabilization, node, a)
		                        : a();
		               }
		               function remove_alarm(clock, alarm, cont){
		                var t$0 = clock[1], t = t$0[7], p = t[2];
		                return caml_exact_trampoline_cps_call$1
		                        (pointer_is_valid,
		                         p,
		                         alarm,
		                         function(a){
		                          if(! a) return cont(a);
		                          var t$0 = clock[1], t = t$0[7], pool = t[2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_external_exn,
		                                   pool,
		                                   alarm,
		                                   function(elt){
		                                    return caml_exact_trampoline_cps_call$1
		    (internal_remove,
		     t,
		     elt,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (free, pool, elt, cont);
		     });
		                                   });
		                         });
		               }
		               function invalidate_node(node, cont){
		                return caml_trampoline_cps_call2
		                        (is_valid$2,
		                         node,
		                         function(c){
		                          function a(){return cont();}
		                          if(! c) return a();
		                          var t = node[2];
		                          function b(b){
		                           node[4] = none$3;
		                           node[7] = t[3];
		                           node[3] = t[3];
		                           t[23] = t[23] + 1 | 0;
		                           return caml_trampoline_cps_call2
		                                   (is_necessary$1,
		                                    node,
		                                    function(c){
		                                     function b(){
		                                      var b = node[5];
		                                      function c(e){
		                                       set_kind(node, 0);
		                                       var b = node[9] - 1 | 0;
		                                       function d(index){
		return caml_exact_trampoline_cps_call$1
		        (get_parent,
		         node,
		         index,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (push,
		                   t[7],
		                   a,
		                   function(a){
		                    a = index + 1 | 0;
		                    return b !== index ? caml_exact_trampoline_call1(d, a) : c();
		                   });
		         });
		                                       }
		                                       function c(){
		return is_in_recompute_heap(node)
		        ? caml_exact_trampoline_cps_call$1
		          (remove$6, t[5], node, cont)
		        : a();
		                                       }
		                                       return b < 0 ? c() : d(0);
		                                      }
		                                      if(typeof b === "number") return c();
		                                      switch(b[0]){
		case 1:
		 var at = b[1];
		 return caml_exact_trampoline_cps_call$1
		         (remove_alarm, at[4], at[3], c);
		case 2:
		 var at_intervals = b[1];
		 return caml_exact_trampoline_cps_call$1
		         (remove_alarm, at_intervals[5], at_intervals[4], c);
		case 4:
		 var bind = b[1];
		 return caml_exact_trampoline_cps_call
		         (invalidate_nodes_created_on_rh, bind[7], c);
		case 14:
		 b = b[1];
		 var alarm = b[6], clock = b[8];
		 return caml_exact_trampoline_cps_call$1
		         (remove_alarm, clock, alarm, c);
		default: return c();
		                                      }
		                                     }
		                                     return c
		     ? caml_exact_trampoline_cps_call
		       (remove_children,
		        node,
		        function(a){
		         node[14] = height$2(node[12]) + 1 | 0;
		         return b();
		        })
		     : b();
		                                    });
		                          }
		                          return 0 < node[8]
		                                  ? caml_exact_trampoline_cps_call
		                                    (handle_after_stabilization, node, b)
		                                  : b();
		                         });
		               }
		               function invalidate_nodes_created_on_rh(node, cont){
		                function a(r){
		                 if(! is_some$2(r)) return cont();
		                 var b = r[13];
		                 r[13] = none$3;
		                 return caml_exact_trampoline_cps_call
		                         (invalidate_node,
		                          r,
		                          function(c){return caml_exact_trampoline_call1(a, b);});
		                }
		                return a(node);
		               }
		               function rescope_nodes_created_on_rhs
		               (t, first_node_on_rhs, new_scope, cont){
		                function a(r){
		                 if(! is_some$2(r)) return cont();
		                 var b = r[13];
		                 r[13] = none$3;
		                 r[12] = new_scope;
		                 return caml_exact_trampoline_cps_call$1
		                         (add_node,
		                          new_scope,
		                          r,
		                          function(c){return caml_exact_trampoline_call1(a, b);});
		                }
		                return a(first_node_on_rhs);
		               }
		               function propagate_invalidity(t, cont){
		                function a(b){
		                 return is_empty$1(t[7])
		                         ? cont()
		                         : caml_exact_trampoline_cps_call
		                           (pop_exn,
		                            t[7],
		                            function(node){
		                             return caml_trampoline_cps_call2
		                                     (is_valid$2,
		                                      node,
		                                      function(b){
		                                       return b
		       ? caml_exact_trampoline_cps_call
		         (should_be_invalidated,
		          node,
		          function(b){
		           if(b)
		            return caml_exact_trampoline_cps_call
		                    (invalidate_node, node, a);
		           var kind = node[5];
		           if(typeof kind !== "number" && 6 === kind[0]){
		            var expert = kind[1];
		            expert[6] = expert[6] + 1 | 0;
		           }
		           return 1 - is_in_recompute_heap(node)
		                   ? caml_exact_trampoline_cps_call$1(add$15, t[5], node, a)
		                   : caml_exact_trampoline_call1(a, 0);
		          })
		       : caml_exact_trampoline_call1(a, 0);
		                                      });
		                            });
		                }
		                return a();
		               }
		               function add_parent_without_adjusting_h
		               (child, parent, child_index, cont){
		                var t = child[2];
		                return caml_trampoline_cps_call2
		                        (is_necessary$1,
		                         child,
		                         function(was_necessary){
		                          return caml_exact_trampoline_cps_call$0
		                                  (add_parent,
		                                   child,
		                                   parent,
		                                   child_index,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (is_valid$2,
		     child,
		     function(b){
		      function a(b){
		       function a(a){
		        a = parent[5];
		        if(typeof a !== "number" && 6 === a[0]){
		         var e = a[1];
		         return caml_exact_trampoline_cps_call$1
		                 (run_edge_callback, e, child_index, cont);
		        }
		        return cont();
		       }
		       return 1 - was_necessary
		               ? caml_exact_trampoline_cps_call(bQx, child, a)
		               : a(0);
		      }
		      return 1 - b
		              ? caml_exact_trampoline_cps_call$1(push, t[7], parent, a)
		              : a();
		     });
		                                   });
		                         });
		               }
		               function bQx(node, cont){
		                return caml_trampoline_cps_call2
		                        (is_valid$2,
		                         node,
		                         function(b){
		                          function a(b){
		                           function a(b){
		                            var t = node[2];
		                            t[19] = t[19] + 1 | 0;
		                            function a(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (set_height$0,
		                                      node,
		                                      height$2(node[12]) + 1 | 0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (iteri_children$0,
		        node,
		        function(child_index, child, cont){
		         return caml_exact_trampoline_cps_call$0
		                 (add_parent_without_adjusting_h,
		                  child,
		                  node,
		                  child_index,
		                  function(a){
		                   a = node[14] <= child[14] ? 1 : 0;
		                   return a
		                           ? caml_exact_trampoline_cps_call$1
		                             (set_height$0, node, child[14] + 1 | 0, cont)
		                           : cont(a);
		                  });
		        },
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (is_stale,
		                  node,
		                  function(b){
		                   function a(a){
		                    a = node[5];
		                    if(typeof a !== "number" && 6 === a[0]){
		                     var p = a[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (observability_change, p, 1, cont);
		                    }
		                    return cont();
		                   }
		                   return b
		                           ? caml_exact_trampoline_cps_call$1(add$15, t[5], node, a)
		                           : a(0);
		                  });
		        });
		                                      });
		                            }
		                            return 0 < node[8]
		                                    ? caml_exact_trampoline_cps_call
		                                      (handle_after_stabilization, node, a)
		                                    : a();
		                           }
		                           return b
		                                   ? caml_exact_trampoline_cps_call$3
		                                     (failwiths,
		                                      0,
		                                      aOa,
		                                      "Trying to make a node necessary whose defining bind is not necessary",
		                                      node,
		                                      function(x_096, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (sexp_of_t$117,
		        function(param, cont){return cont(aN$);},
		        x_096,
		        cont);
		                                      },
		                                      a)
		                                   : a();
		                          }
		                          return b
		                                  ? caml_exact_trampoline_cps_call
		                                    (is_necessary$0, node[12], function(b){return a(1 - b);})
		                                  : a(b);
		                         });
		               }
		               function became_necessary(node, cont){
		                return caml_exact_trampoline_cps_call
		                        (bQx,
		                         node,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (propagate_invalidity, node[2], cont);
		                         });
		               }
		               function add_parent$0
		               (original_child, original_parent, child_index, cont){
		                var t = original_parent[2];
		                return caml_exact_trampoline_cps_call$0
		                        (add_parent_without_adjusting_h,
		                         original_child,
		                         original_parent,
		                         child_index,
		                         function(c){
		                          function b(){
		                           return caml_exact_trampoline_cps_call
		                                   (propagate_invalidity,
		                                    t,
		                                    function(a){
		                                     a = 1 - is_in_recompute_heap(original_parent);
		                                     if(a)
		                                      var
		                                       t$0 = original_parent[3],
		                                       a = t$0 === -1 ? 1 : 0,
		                                       a = a || edge_is_stale(original_child, original_parent);
		                                     return a
		     ? caml_exact_trampoline_cps_call$1
		       (add$15, t[5], original_parent, cont)
		     : cont(a);
		                                    });
		                          }
		                          if(original_parent[14] > original_child[14]) return b();
		                          var recompute_heap = t[5], t$0 = t[6];
		                          t$0[2] = original_parent[14];
		                          function a(d){
		                           if(0 >= t$0[1]) return b();
		                           var r = t$0[2];
		                           for(;;){
		                            var arr = t$0[4], t$1 = get$3(arr, r);
		                            if(t$1 !== cst_Uopt_none) break;
		                            var r$0 = r + 1 | 0;
		                            r = r$0;
		                           }
		                           t$0[2] = r;
		                           var arr$0 = t$0[4], child = arr$0[r + 1];
		                           child[18] = -1;
		                           t$0[1] = t$0[1] - 1 | 0;
		                           var x = child[19], t = t$0[4];
		                           unsafe_set_with_caml_modify(t, r, x);
		                           child[19] = none$3;
		                           function c(c){
		                            function b(){
		                             var b = child[5];
		                             if(typeof b === "number")
		                              return caml_exact_trampoline_call1(a, 0);
		                             if(3 !== b[0]) return caml_exact_trampoline_call1(a, 0);
		                             var all_nodes_created_on_rhs = b[1][7];
		                             function c(node_on_rhs){
		                              if(! is_some$2(node_on_rhs))
		                               return caml_exact_trampoline_call1(a, 0);
		                              var r = node_on_rhs[13];
		                              return caml_trampoline_cps_call2
		                                      (is_necessary$1,
		                                       node_on_rhs,
		                                       function(a){
		return a
		        ? caml_exact_trampoline_cps_call$3
		          (ensure_height_requirement,
		           t$0,
		           original_child,
		           original_parent,
		           child,
		           node_on_rhs,
		           function(a){return caml_exact_trampoline_call1(c, r);})
		        : caml_exact_trampoline_call1(c, r);
		                                       });
		                             }
		                             return c(all_nodes_created_on_rhs);
		                            }
		                            return 0 < child[9]
		                                    ? caml_exact_trampoline_cps_call
		                                      (value_exn$1,
		                                       child[11],
		                                       function(parent){
		return caml_exact_trampoline_cps_call$3
		        (ensure_height_requirement,
		         t$0,
		         original_child,
		         original_parent,
		         child,
		         parent,
		         function(d){
		          var a = child[9] - 1 | 0;
		          function c(parent_index){
		           var i = parent_index - 1 | 0, arr = child[10];
		           return caml_exact_trampoline_cps_call
		                   (value_exn$1,
		                    get$3(arr, i),
		                    function(match){
		                     return caml_exact_trampoline_cps_call$3
		                             (ensure_height_requirement,
		                              t$0,
		                              original_child,
		                              original_parent,
		                              child,
		                              match,
		                              function(d){
		                               d = parent_index + 1 | 0;
		                               return a !== parent_index
		                                       ? caml_exact_trampoline_call1(c, d)
		                                       : b();
		                              });
		                    });
		          }
		          return a < 1 ? b() : c(1);
		         });
		                                       })
		                                    : b();
		                           }
		                           return is_in_recompute_heap(child)
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (unlink,
		                                      recompute_heap,
		                                      child,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (link$1, recompute_heap, child, c);
		                                      })
		                                   : c();
		                          }
		                          return caml_exact_trampoline_cps_call$3
		                                  (ensure_height_requirement,
		                                   t$0,
		                                   original_child,
		                                   original_parent,
		                                   original_child,
		                                   original_parent,
		                                   a);
		                         });
		               }
		               function run_with_scope(t, scope, f, cont){
		                var saved = t[4];
		                t[4] = scope;
		                caml_push_trap
		                 (function(exn){
		                   t[4] = saved;
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         dummy,
		                         function(v){t[4] = saved; caml_pop_trap(); return cont(v);});
		               }
		               function within_scope(t, scope, f, cont){
		                function a(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (run_with_scope, t, scope, f, cont);
		                }
		                return 1 - is_valid$1(scope)
		                        ? caml_exact_trampoline_cps_call$3
		                          (failwiths,
		                           0,
		                           aOb,
		                           "attempt to run within an invalid scope",
		                           t,
		                           sexp_of_t$128,
		                           a)
		                        : a();
		               }
		               function change_child
		               (parent, old_child, new_child, child_index, cont){
		                if(old_child === cst_Uopt_none)
		                 return caml_exact_trampoline_cps_call$0
		                         (add_parent$0, new_child, parent, child_index, cont);
		                var a = 1 - (old_child === new_child);
		                return a
		                        ? caml_exact_trampoline_cps_call$0
		                          (remove_parent,
		                           old_child,
		                           parent,
		                           child_index,
		                           function(a){
		                            old_child[26] = 1;
		                            return caml_exact_trampoline_cps_call$0
		                                    (add_parent$0,
		                                     new_child,
		                                     parent,
		                                     child_index,
		                                     function(a){
		                                      old_child[26] = 0;
		                                      return caml_exact_trampoline_cps_call
		      (check_if_unnecessary, old_child, cont);
		                                     });
		                           })
		                        : cont(a);
		               }
		               function add_alarm(clock, at, alarm_value, cont){
		                var t = clock[1];
		                function a(b){
		                 function a(a){
		                  a = interval_num_unchecked(t, at);
		                  return caml_exact_trampoline_cps_call$2
		                          (internal_add, t[7], a, at, alarm_value, cont);
		                 }
		                 if(! symbol$49(at, t[5])) return a(0);
		                 return caml_exact_trampoline_cps_call
		                         (sexp_of_t$83,
		                          t[5],
		                          function(c){
		                           var b = [0, [1, [0, aGM, [0, c, 0]]], 0];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_t$83,
		                                    at,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call
		     (raise_s,
		      [1,
		       [0,
		        [0,
		         "Timing_wheel cannot schedule alarm before start of current interval"],
		        [0, [1, [0, aGN, [0, c, 0]]], b]]],
		      a);
		                                    });
		                          });
		                }
		                if(! symbol$48(at, t[6])) return a();
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$83,
		                         t[6],
		                         function(c){
		                          var b = [0, [1, [0, aGK, [0, c, 0]]], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (sexp_of_t$83,
		                                   at,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (raise_s,
		     [1,
		      [0,
		       [0,
		        "Timing_wheel cannot schedule alarm that far in the future"],
		       [0, [1, [0, aGL, [0, c, 0]]], b]]],
		     a);
		                                   });
		                         });
		               }
		               function recompute(node, cont){
		                var t = node[2];
		                t[24] = t[24] + 1 | 0;
		                node[3] = t[3];
		                var b = node[5];
		                if(typeof b !== "number")
		                 switch(b[0]){
		                   case 0:
		                    var
		                     array_fold = b[1],
		                     children$0 = array_fold[3],
		                     f$0 = array_fold[2],
		                     init$0 = array_fold[1],
		                     g = children$0.length - 2 | 0,
		                     l =
		                       function(result){
		                        return caml_exact_trampoline_cps_call$1
		                                (maybe_change_value, node, result, cont);
		                       },
		                     k =
		                       function(result, i){
		                        return caml_exact_trampoline_cps_call
		                                (value_exn$1,
		                                 children$0[i + 1][4],
		                                 function(a){
		                                  return caml_trampoline_cps_call3
		  (f$0,
		   result,
		   a,
		   function(a){
		    var b = i + 1 | 0;
		    return g !== i ? caml_exact_trampoline_call2(k, a, b) : l(a);
		   });
		                                 });
		                       };
		                    return g < 0 ? l(init$0) : k(init$0, 0);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, 0, cont);
		                   case 2:
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, 0, cont);
		                   case 3:
		                    var
		                     bind = b[1],
		                     main = bind[1],
		                     f$1 = bind[2],
		                     lhs = bind[3],
		                     old_rhs = bind[5],
		                     rhs_scope = bind[6],
		                     old_all_nodes_created_on_rhs = bind[7];
		                    bind[7] = none$3;
		                    var saved = t[4];
		                    t[4] = rhs_scope;
		                    caml_push_trap
		                     (function(exn){
		                       t[4] = saved;
		                       var
		                        raise = caml_pop_trap(),
		                        exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                       return raise(exn$0);
		                      });
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             lhs,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (f$1,
		                                       a,
		                                       function(rhs){
		t[4] = saved;
		caml_pop_trap();
		return caml_exact_trampoline_cps_call
		        (some$1,
		         rhs,
		         function(a){
		          bind[5] = a;
		          node[7] = t[3];
		          return caml_exact_trampoline_cps_call$2
		                  (change_child,
		                   main,
		                   old_rhs,
		                   rhs,
		                   1,
		                   function(c){
		                    function b(a){
		                     return caml_exact_trampoline_cps_call$1
		                             (maybe_change_value, node, 0, cont);
		                    }
		                    if(! is_some$2(old_rhs)) return b();
		                    function a(a){
		                     return caml_exact_trampoline_cps_call
		                             (propagate_invalidity, t, b);
		                    }
		                    return t[2]
		                            ? caml_exact_trampoline_cps_call
		                              (invalidate_nodes_created_on_rh,
		                               old_all_nodes_created_on_rhs,
		                               a)
		                            : caml_exact_trampoline_cps_call$0
		                              (rescope_nodes_created_on_rhs,
		                               t,
		                               old_all_nodes_created_on_rhs,
		                               main[12],
		                               a);
		                   });
		         });
		                                       });
		                             });
		                   case 4:
		                    var rhs = b[1][5];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$1,
		                             rhs,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (copy_child, node, a, cont);
		                             });
		                   case 5:
		                    var a = b[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, a, cont);
		                   case 6:
		                    var
		                     expert = b[1],
		                     j =
		                       function(match){
		                        return 144245463 <= match
		                                ? caml_exact_trampoline_cps_call
		                                  (invalidate_node,
		                                   node,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (propagate_invalidity, t, cont);
		                                   })
		                                : caml_trampoline_cps_call2
		                                  (expert[1],
		                                   0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (maybe_change_value, node, a, cont);
		                                   });
		                       };
		                    if(0 < expert[6]) return j(144245463);
		                    expert[5] = 0;
		                    var will_fire_all_callbacks = expert[7];
		                    expert[7] = 0;
		                    var d = function(){return j(17724);};
		                    if(! will_fire_all_callbacks) return d();
		                    var
		                     h = expert[4] - 1 | 0,
		                     i =
		                       function(i$0){
		                        var arr = expert[3];
		                        return caml_exact_trampoline_cps_call
		                                (value_exn$1,
		                                 get$3(arr, i$0),
		                                 function(match){
		                                  return caml_exact_trampoline_cps_call
		  (value_exn$1,
		   match[1][4],
		   function(a){
		    return caml_trampoline_cps_call2
		            (match[2],
		             a,
		             function(a){
		              a = i$0 + 1 | 0;
		              return h !== i$0 ? caml_exact_trampoline_call1(i, a) : d();
		             });
		   });
		                                 });
		                       };
		                    return h < 0 ? d() : i(0);
		                   case 7:
		                    b = b[1];
		                    var only_freeze_when = b[3], child = b[2];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             child,
		                             function(value){
		                              return caml_trampoline_cps_call2
		                                      (only_freeze_when,
		                                       value,
		                                       function(b){
		function a(a){
		 return caml_exact_trampoline_cps_call$1
		         (maybe_change_value, node, value, cont);
		}
		return b
		        ? caml_exact_trampoline_cps_call
		          (remove_children,
		           node,
		           function(b){
		            set_kind(node, [5, value]);
		            return caml_trampoline_cps_call2
		                    (is_necessary$1,
		                     node,
		                     function(b){
		                      return b
		                              ? caml_exact_trampoline_cps_call$1(set_height$0, node, 0, a)
		                              : caml_exact_trampoline_cps_call
		                                (became_unnecessary, node, a);
		                     });
		           })
		        : a();
		                                       });
		                             });
		                   case 8:
		                    var
		                     if_then_else = b[1],
		                     test = if_then_else[2],
		                     main$0 = if_then_else[1],
		                     current_branch = if_then_else[4],
		                     else$ = if_then_else[6],
		                     then = if_then_else[5];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             test,
		                             function(a){
		                              var desired_branch = a ? then : else$;
		                              return caml_exact_trampoline_cps_call
		                                      (some$1,
		                                       desired_branch,
		                                       function(a){
		if_then_else[4] = a;
		node[7] = t[3];
		return caml_exact_trampoline_cps_call$2
		        (change_child,
		         main$0,
		         current_branch,
		         desired_branch,
		         1,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (maybe_change_value, node, 0, cont);
		         });
		                                       });
		                             });
		                   case 9:
		                    var current_branch$0 = b[1][4];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$1,
		                             current_branch$0,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (copy_child, node, a, cont);
		                             });
		                   case 10:
		                    var
		                     join = b[1],
		                     lhs$0 = join[2],
		                     main$1 = join[1],
		                     old_rhs$0 = join[4];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             lhs$0,
		                             function(rhs){
		                              return caml_exact_trampoline_cps_call
		                                      (some$1,
		                                       rhs,
		                                       function(a){
		join[4] = a;
		node[7] = t[3];
		return caml_exact_trampoline_cps_call$2
		        (change_child,
		         main$1,
		         old_rhs$0,
		         rhs,
		         1,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (maybe_change_value, node, 0, cont);
		         });
		                                       });
		                             });
		                   case 11:
		                    var rhs$0 = b[1][4];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$1,
		                             rhs$0,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (copy_child, node, a, cont);
		                             });
		                   case 12:
		                    var n1 = b[2], f$2 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n1,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (f$2,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (maybe_change_value, node, a, cont);
		                                       });
		                             });
		                   case 13:
		                    var before = b[1][3];
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, before, cont);
		                   case 14:
		                    var
		                     step_function_node = b[1],
		                     child$0 = step_function_node[2],
		                     clock = step_function_node[8],
		                     c =
		                       function(a){
		                        var to = now(clock), steps = step_function_node[5];
		                        return caml_exact_trampoline_cps_call
		                                (value_exn$1,
		                                 step_function_node[4],
		                                 function(a1){
		                                  function a(a1, steps){
		                                   return caml_exact_trampoline_cps_call
		   (next,
		    steps,
		    function(b){
		     if(b){
		      b = b[1];
		      var steps2 = b[2], b = b[1], a2 = b[2], step_at = b[1];
		      if(greater_equal$0(to, step_at))
		       return caml_exact_trampoline_call2(a, a2, steps2);
		     }
		     return caml_exact_trampoline_cps_call
		             (some$1,
		              a1,
		              function(a){
		               step_function_node[4] = a;
		               step_function_node[5] = steps;
		               return caml_exact_trampoline_cps_call
		                       (value_exn$1,
		                        step_function_node[4],
		                        function(step_function_value){
		                         return caml_exact_trampoline_cps_call
		                                 (hd$1,
		                                  step_function_node[5],
		                                  function(match){
		                                   function a(){
		                                    return caml_exact_trampoline_cps_call$1
		    (maybe_change_value, node, step_function_value, cont);
		                                   }
		                                   if(! match)
		                                    return child$0 === cst_Uopt_none
		    ? (set_kind(node, [5, step_function_value]), a())
		    : a();
		                                   var at = match[1][1];
		                                   return caml_exact_trampoline_cps_call$0
		   (add_alarm,
		    clock,
		    at,
		    step_function_node[7],
		    function(b){step_function_node[6] = b; return a();});
		                                  });
		                        });
		              });
		    });
		                                  }
		                                  return a(a1, steps);
		                                 });
		                       };
		                    return is_some$2(child$0)
		                            ? caml_exact_trampoline_cps_call
		                              (value_exn$1,
		                               child$0,
		                               function(child){
		                                return 0 < caml_int_compare(child[7], step_function_node[3])
		? (step_function_node
		   [3]
		  = child[7],
		  caml_exact_trampoline_cps_call$1
		   (remove_alarm,
		    clock,
		    step_function_node[6],
		    function(a){
		     return caml_exact_trampoline_cps_call
		             (value_exn$2,
		              child,
		              function(step_function){
		               return caml_exact_trampoline_cps_call
		                       (some$1,
		                        step_function[1],
		                        function(a){
		                         step_function_node[4] = a;
		                         step_function_node[5] = step_function[2];
		                         return is_const(child)
		                                 ? caml_exact_trampoline_cps_call
		                                   (remove_children,
		                                    node,
		                                    function(a){
		                                     step_function_node[2] = none$3;
		                                     return caml_exact_trampoline_cps_call$1
		     (set_height$0, node, height$2(node[12]) + 1 | 0, c);
		                                    })
		                                 : c(0);
		                        });
		              });
		    }))
		: c(0);
		                               })
		                            : c(0);
		                   case 15:
		                    var
		                     u = b[1],
		                     m =
		                       function(){
		                        return caml_exact_trampoline_cps_call
		                                (value_exn$1,
		                                 u[7],
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$1
		  (maybe_change_value, node, a, cont);
		                                 });
		                       };
		                    if(u[8] !== u[5]) return m();
		                    u[8] = 0;
		                    var
		                     children = u[6],
		                     f = u[3],
		                     init = u[2],
		                     e = children.length - 2 | 0,
		                     o =
		                       function(result){
		                        return caml_exact_trampoline_cps_call
		                                (some$1, result, function(a){u[7] = a; return m();});
		                       },
		                     n =
		                       function(result, i){
		                        return caml_exact_trampoline_cps_call
		                                (value_exn$1,
		                                 children[i + 1][4],
		                                 function(a){
		                                  return caml_trampoline_cps_call3
		  (f,
		   result,
		   a,
		   function(a){
		    var b = i + 1 | 0;
		    return e !== i ? caml_exact_trampoline_call2(n, a, b) : o(a);
		   });
		                                 });
		                       };
		                    return e < 0 ? o(init) : n(init, 0);
		                   case 16:
		                    var var$ = b[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, var$[1], cont);
		                   case 17:
		                    var n2 = b[3], n1$0 = b[2], f$3 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n2,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n1$0,
		                                       function(b){
		return caml_trampoline_cps_call3
		        (f$3,
		         b,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (maybe_change_value, node, a, cont);
		         });
		                                       });
		                             });
		                   case 18:
		                    var n3 = b[4], n2$0 = b[3], n1$1 = b[2], f$4 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n3,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n2$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n1$1,
		         function(c){
		          return caml_trampoline_cps_call4
		                  (f$4,
		                   c,
		                   b,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, a, cont);
		                   });
		         });
		                                       });
		                             });
		                   case 19:
		                    var
		                     n4 = b[5],
		                     n3$0 = b[4],
		                     n2$1 = b[3],
		                     n1$2 = b[2],
		                     f$5 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n4,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n3$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n2$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n1$2,
		                   function(d){
		                    return caml_trampoline_cps_call5
		                            (f$5,
		                             d,
		                             c,
		                             b,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (maybe_change_value, node, a, cont);
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 20:
		                    var
		                     n5 = b[6],
		                     n4$0 = b[5],
		                     n3$1 = b[4],
		                     n2$2 = b[3],
		                     n1$3 = b[2],
		                     f$6 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n5,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n4$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n3$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n2$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n1$3,
		                             function(e){
		                              return caml_trampoline_cps_call6
		                                      (f$6,
		                                       e,
		                                       d,
		                                       c,
		                                       b,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (maybe_change_value, node, a, cont);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 21:
		                    var
		                     n6 = b[7],
		                     n5$0 = b[6],
		                     n4$1 = b[5],
		                     n3$2 = b[4],
		                     n2$3 = b[3],
		                     n1$4 = b[2],
		                     f$7 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n6,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n5$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n4$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n3$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n2$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n1$4,
		                                       function(f){
		return caml_trampoline_cps_call7
		        (f$7,
		         f,
		         e,
		         d,
		         c,
		         b,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (maybe_change_value, node, a, cont);
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 22:
		                    var
		                     n7 = b[8],
		                     n6$0 = b[7],
		                     n5$1 = b[6],
		                     n4$2 = b[5],
		                     n3$3 = b[4],
		                     n2$4 = b[3],
		                     n1$5 = b[2],
		                     f$8 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n7,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n6$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n5$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n4$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n3$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n2$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n1$5,
		         function(g){
		          return caml_trampoline_cps_call8
		                  (f$8,
		                   g,
		                   f,
		                   e,
		                   d,
		                   c,
		                   b,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, a, cont);
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 23:
		                    var
		                     n8 = b[9],
		                     n7$0 = b[8],
		                     n6$1 = b[7],
		                     n5$2 = b[6],
		                     n4$3 = b[5],
		                     n3$4 = b[4],
		                     n2$5 = b[3],
		                     n1$6 = b[2],
		                     f$9 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n8,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n7$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n6$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n5$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n4$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n3$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n2$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n1$6,
		                   function(h){
		                    return caml_trampoline_cps_call9
		                            (f$9,
		                             h,
		                             g,
		                             f,
		                             e,
		                             d,
		                             c,
		                             b,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (maybe_change_value, node, a, cont);
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 24:
		                    var
		                     n9 = b[10],
		                     n8$0 = b[9],
		                     n7$1 = b[8],
		                     n6$2 = b[7],
		                     n5$3 = b[6],
		                     n4$4 = b[5],
		                     n3$5 = b[4],
		                     n2$6 = b[3],
		                     n1$7 = b[2],
		                     f$10 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n9,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n8$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n7$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n6$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n5$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n4$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n3$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n2$6,
		                   function(h){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n1$7,
		                             function(i){
		                              return caml_trampoline_cps_call10
		                                      (f$10,
		                                       i,
		                                       h,
		                                       g,
		                                       f,
		                                       e,
		                                       d,
		                                       c,
		                                       b,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (maybe_change_value, node, a, cont);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 25:
		                    var
		                     n10 = b[11],
		                     n9$0 = b[10],
		                     n8$1 = b[9],
		                     n7$2 = b[8],
		                     n6$3 = b[7],
		                     n5$4 = b[6],
		                     n4$5 = b[5],
		                     n3$6 = b[4],
		                     n2$7 = b[3],
		                     n1$8 = b[2],
		                     f$11 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n10,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n9$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n8$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n7$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n6$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n5$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n4$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n3$6,
		                   function(h){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n2$7,
		                             function(i){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n1$8,
		                                       function(j){
		return caml_trampoline_cps_call11
		        (f$11,
		         j,
		         i,
		         h,
		         g,
		         f,
		         e,
		         d,
		         c,
		         b,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (maybe_change_value, node, a, cont);
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 26:
		                    var
		                     n11 = b[12],
		                     n10$0 = b[11],
		                     n9$1 = b[10],
		                     n8$2 = b[9],
		                     n7$3 = b[8],
		                     n6$4 = b[7],
		                     n5$5 = b[6],
		                     n4$6 = b[5],
		                     n3$7 = b[4],
		                     n2$8 = b[3],
		                     n1$9 = b[2],
		                     f$12 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n11,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n10$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n9$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n8$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n7$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n6$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n5$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n4$6,
		                   function(h){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n3$7,
		                             function(i){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n2$8,
		                                       function(j){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n1$9,
		         function(k){
		          return caml_trampoline_cps_call12
		                  (f$12,
		                   k,
		                   j,
		                   i,
		                   h,
		                   g,
		                   f,
		                   e,
		                   d,
		                   c,
		                   b,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, a, cont);
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 27:
		                    var
		                     n12 = b[13],
		                     n11$0 = b[12],
		                     n10$1 = b[11],
		                     n9$2 = b[10],
		                     n8$3 = b[9],
		                     n7$4 = b[8],
		                     n6$5 = b[7],
		                     n5$6 = b[6],
		                     n4$7 = b[5],
		                     n3$8 = b[4],
		                     n2$9 = b[3],
		                     n1$10 = b[2],
		                     f$13 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n12,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n11$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n10$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n9$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n8$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n7$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n6$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n5$6,
		                   function(h){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n4$7,
		                             function(i){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n3$8,
		                                       function(j){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n2$9,
		         function(k){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n1$10,
		                   function(l){
		                    return caml_trampoline_cps_call13
		                            (f$13,
		                             l,
		                             k,
		                             j,
		                             i,
		                             h,
		                             g,
		                             f,
		                             e,
		                             d,
		                             c,
		                             b,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (maybe_change_value, node, a, cont);
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 28:
		                    var
		                     n13 = b[14],
		                     n12$0 = b[13],
		                     n11$1 = b[12],
		                     n10$2 = b[11],
		                     n9$3 = b[10],
		                     n8$4 = b[9],
		                     n7$5 = b[8],
		                     n6$6 = b[7],
		                     n5$7 = b[6],
		                     n4$8 = b[5],
		                     n3$9 = b[4],
		                     n2$10 = b[3],
		                     n1$11 = b[2],
		                     f$14 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n13,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n12$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n11$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n10$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n9$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n8$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n7$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n6$6,
		                   function(h){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n5$7,
		                             function(i){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n4$8,
		                                       function(j){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n3$9,
		         function(k){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n2$10,
		                   function(l){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n1$11,
		                             function(m){
		                              return caml_trampoline_cps_call14
		                                      (f$14,
		                                       m,
		                                       l,
		                                       k,
		                                       j,
		                                       i,
		                                       h,
		                                       g,
		                                       f,
		                                       e,
		                                       d,
		                                       c,
		                                       b,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (maybe_change_value, node, a, cont);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   case 29:
		                    var
		                     n14 = b[15],
		                     n13$0 = b[14],
		                     n12$1 = b[13],
		                     n11$2 = b[12],
		                     n10$3 = b[11],
		                     n9$4 = b[10],
		                     n8$5 = b[9],
		                     n7$6 = b[8],
		                     n6$7 = b[7],
		                     n5$8 = b[6],
		                     n4$9 = b[5],
		                     n3$10 = b[4],
		                     n2$11 = b[3],
		                     n1$12 = b[2],
		                     f$15 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n14,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n13$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n12$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n11$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n10$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n9$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n8$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n7$6,
		                   function(h){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n6$7,
		                             function(i){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n5$8,
		                                       function(j){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n4$9,
		         function(k){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n3$10,
		                   function(l){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n2$11,
		                             function(m){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n1$12,
		                                       function(n){
		return caml_trampoline_cps_call15
		        (f$15,
		         n,
		         m,
		         l,
		         k,
		         j,
		         i,
		         h,
		         g,
		         f,
		         e,
		         d,
		         c,
		         b,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (maybe_change_value, node, a, cont);
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   default:
		                    var
		                     n15 = b[16],
		                     n14$0 = b[15],
		                     n13$1 = b[14],
		                     n12$2 = b[13],
		                     n11$3 = b[12],
		                     n10$4 = b[11],
		                     n9$5 = b[10],
		                     n8$6 = b[9],
		                     n7$7 = b[8],
		                     n6$8 = b[7],
		                     n5$9 = b[6],
		                     n4$10 = b[5],
		                     n3$11 = b[4],
		                     n2$12 = b[3],
		                     n1$13 = b[2],
		                     f$16 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n15,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n14$0,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n13$1,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n12$2,
		                   function(d){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n11$3,
		                             function(e){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n10$4,
		                                       function(f){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n9$5,
		         function(g){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n8$6,
		                   function(h){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n7$7,
		                             function(i){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n6$8,
		                                       function(j){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n5$9,
		         function(k){
		          return caml_exact_trampoline_cps_call
		                  (value_exn$2,
		                   n4$10,
		                   function(l){
		                    return caml_exact_trampoline_cps_call
		                            (value_exn$2,
		                             n3$11,
		                             function(m){
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$2,
		                                       n2$12,
		                                       function(n){
		return caml_exact_trampoline_cps_call
		        (value_exn$2,
		         n1$13,
		         function(o){
		          return caml_trampoline_cps_call16
		                  (f$16,
		                   o,
		                   n,
		                   m,
		                   l,
		                   k,
		                   j,
		                   i,
		                   h,
		                   g,
		                   f,
		                   e,
		                   d,
		                   c,
		                   b,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (maybe_change_value, node, a, cont);
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                 }
		                if(0 === b){
		                 b = caml_pop_trap();
		                 return b
		                         (caml_maybe_attach_backtrace([0, Assert_failure, aOc], 1));
		                }
		                b = caml_pop_trap();
		                return b
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aOd], 1));
		               }
		               function copy_child(parent, child, cont){
		                return caml_trampoline_cps_call2
		                        (is_valid$2,
		                         child,
		                         function(a){
		                          return a
		                                  ? caml_exact_trampoline_cps_call
		                                    (value_exn$2,
		                                     child,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (maybe_change_value, parent, a, cont);
		                                     })
		                                  : caml_exact_trampoline_cps_call
		                                    (invalidate_node,
		                                     parent,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (propagate_invalidity, parent[2], cont);
		                                     });
		                         });
		               }
		               var debug$1 = 0;
		               function maybe_change_value(node, new_value, cont){
		                var
		                 t = node[2],
		                 old_value_opt = node[4],
		                 a = old_value_opt === cst_Uopt_none ? 1 : 0;
		                function b(b){
		                 function a(a){return cont(debug$1);}
		                 return b
		                         ? caml_exact_trampoline_cps_call
		                           (some$1,
		                            new_value,
		                            function(c){
		                             node[4] = c;
		                             node[7] = t[3];
		                             t[21] = t[21] + 1 | 0;
		                             function b(e){
		                              if(1 > node[9]) return a();
		                              var b = node[9] - 1 | 0;
		                              function d(){
		                               return caml_exact_trampoline_cps_call
		                                       (value_exn$1,
		node[11],
		function(parent){
		 var match = parent[5];
		 function b(c){
		  if(! (1 - is_in_recompute_heap(parent))) return a();
		  c = parent[5];
		  a:
		  {
		   if(typeof c !== "number"){
		    switch(c[0]){
		      case 1:
		       c = caml_pop_trap();
		       return c
		               (caml_maybe_attach_backtrace([0, Assert_failure, aOg], 1));
		      case 2:
		       c = caml_pop_trap();
		       return c
		               (caml_maybe_attach_backtrace([0, Assert_failure, aOh], 1));
		      case 3:
		       c = height$2(parent[12]);
		       var can_recompute_now = c < node[14];
		       break;
		      case 4:
		       var b = c[1], can_recompute_now = b[4][14] < node[14];
		       break;
		      case 7:
		       c = height$2(parent[12]);
		       can_recompute_now = c < node[14];
		       break;
		      case 8:
		       c = height$2(parent[12]);
		       can_recompute_now = c < node[14];
		       break;
		      case 9:
		       var i$0 = c[1], can_recompute_now = i$0[3][14] < node[14];
		       break;
		      case 10:
		       c = height$2(parent[12]);
		       can_recompute_now = c < node[14];
		       break;
		      case 11:
		       var j = c[1], can_recompute_now = j[3][14] < node[14];
		       break;
		      case 12:
		       c = height$2(parent[12]);
		       can_recompute_now = c < node[14];
		       break;
		      case 14:
		       c = height$2(parent[12]);
		       can_recompute_now = c < node[14];
		       break;
		      case 5:
		      case 13:
		      case 16:
		       break a;
		      default: can_recompute_now = 0;
		    }
		    if(can_recompute_now){
		     t[25] = t[25] + 1 | 0;
		     return caml_exact_trampoline_cps_call(recompute, parent, a);
		    }
		    var t$0 = t[5];
		    if(t$0[1] === 0)
		     t$0[2] = t$0[3].length - 1;
		    else {
		     var nodes_by_height = t$0[3];
		     for(;;){
		      var i = t$0[2], t$1 = get$3(nodes_by_height, i);
		      if(t$1 !== cst_Uopt_none) break;
		      t$0[2] = t$0[2] + 1 | 0;
		     }
		    }
		    return parent[14] <= t$0[2]
		            ? (t
		               [26]
		              = t[26] + 1 | 0,
		              caml_exact_trampoline_cps_call(recompute, parent, a))
		            : caml_exact_trampoline_cps_call$1(add$15, t[5], parent, a);
		   }
		   if(0 !== c){
		    c = caml_pop_trap();
		    return c
		            (caml_maybe_attach_backtrace([0, Assert_failure, aOf], 1));
		   }
		  }
		  c = caml_pop_trap();
		  return c
		          (caml_maybe_attach_backtrace([0, Assert_failure, aOe], 1));
		 }
		 if(typeof match === "number") return b(0);
		 switch(match[0]){
		   case 6:
		    var
		     p = match[1],
		     child_index = caml_check_bound(node[25], 0)[1];
		    return caml_exact_trampoline_cps_call$1
		            (run_edge_callback, p, child_index, b);
		   case 15:
		    var u = match[1];
		    return caml_exact_trampoline_cps_call$3
		            (child_changed,
		             u,
		             node,
		             caml_check_bound(node[25], 0)[1],
		             old_value_opt,
		             new_value,
		             b);
		   default: return b(0);
		 }
		});
		                              }
		                              function c(parent_index){
		                               var i = parent_index - 1 | 0, arr = node[10];
		                               return caml_exact_trampoline_cps_call
		                                       (value_exn$1,
		get$3(arr, i),
		function(parent){
		 var match = parent[5];
		 function a(e){
		  function a(a){
		   a = parent_index + 1 | 0;
		   return b !== parent_index
		           ? caml_exact_trampoline_call1(c, a)
		           : d();
		  }
		  return 1 - is_in_recompute_heap(parent)
		          ? caml_exact_trampoline_cps_call$1(add$15, t[5], parent, a)
		          : a(0);
		 }
		 if(typeof match === "number") return a();
		 switch(match[0]){
		   case 6:
		    var
		     expert = match[1],
		     child_index =
		       caml_check_bound(node[25], parent_index)[parent_index + 1];
		    return caml_exact_trampoline_cps_call$1
		            (run_edge_callback, expert, child_index, a);
		   case 15:
		    var u = match[1];
		    return caml_exact_trampoline_cps_call$3
		            (child_changed,
		             u,
		             node,
		             caml_check_bound(node[25], parent_index)[parent_index + 1],
		             old_value_opt,
		             new_value,
		             a);
		   default: return a();
		 }
		});
		                              }
		                              return b < 1 ? d() : c(1);
		                             }
		                             return 0 < node[8]
		                                     ? (node
		[20]
		                                       = old_value_opt,
		                                       caml_exact_trampoline_cps_call
		(handle_after_stabilization, node, b))
		                                     : b();
		                            })
		                         : a();
		                }
		                return a
		                        ? b(a)
		                        : caml_exact_trampoline_cps_call$0
		                          (should_cutoff,
		                           node[6],
		                           old_value_opt,
		                           new_value,
		                           function(a){return b(1 - a);});
		               }
		               function recompute_first_node_that_is_n(r, cont){
		                var
		                 nodes_by_height = r[3],
		                 i = r[2],
		                 node = get$3(nodes_by_height, i);
		                for(;;){
		                 if(node !== cst_Uopt_none){
		                  node[15] = -1;
		                  r[1] = r[1] - 1 | 0;
		                  var next = node[17], i$1 = r[2], t = r[3];
		                  set_with_caml_modify(t, i$1, next);
		                  set_prev(next, none$3);
		                  node[17] = none$3;
		                  return caml_exact_trampoline_cps_call(recompute, node, cont);
		                 }
		                 r[2] = r[2] + 1 | 0;
		                 var i$0 = r[2];
		                 node = get$3(nodes_by_height, i$0);
		                }
		               }
		               function unlink_disallowed_observers(t, cont){
		                function a(b){
		                 var t$0 = t[12];
		                 return 0 < t$0[1]
		                         ? caml_exact_trampoline_cps_call
		                           (pop_exn,
		                            t[12],
		                            function(internal_observer){
		                             internal_observer[1] = 3;
		                             return caml_exact_trampoline_cps_call
		                                     (value_exn$1,
		                                      t[9],
		                                      function(all_observers){
		                                       if(internal_observer === all_observers)
		t[9] = internal_observer[5];
		                                       var
		prev = internal_observer[6],
		next = internal_observer[7];
		                                       internal_observer[6] = none$3;
		                                       internal_observer[7] = none$3;
		                                       if(is_some$2(next)) next[6] = prev;
		                                       if(is_some$2(prev)) prev[7] = next;
		                                       var observing = internal_observer[2];
		                                       return caml_exact_trampoline_cps_call
		       (value_exn$1,
		        observing[21],
		        function(b){
		         if(internal_observer === b) observing[21] = next;
		         return caml_exact_trampoline_cps_call
		                 (length$1,
		                  internal_observer[3],
		                  function(b){
		                   observing[8] = observing[8] - b | 0;
		                   internal_observer[3] = 0;
		                   var
		                    prev = internal_observer[4],
		                    next = internal_observer[5];
		                   internal_observer[4] = none$3;
		                   internal_observer[5] = none$3;
		                   if(is_some$2(next)) set_prev_in_all(next, prev);
		                   if(is_some$2(prev)) prev[5] = next;
		                   return caml_exact_trampoline_cps_call
		                           (check_if_unnecessary, internal_observer[2], a);
		                  });
		        });
		                                      });
		                            })
		                         : cont();
		                }
		                return a();
		               }
		               function disallow_future_use(internal_observer, cont){
		                var
		                 t = incr_state$0(internal_observer),
		                 match = internal_observer[1];
		                return 1 === match
		                        ? (t
		                           [8]
		                          = t[8] - 1 | 0,
		                          internal_observer[1] = 2,
		                          caml_exact_trampoline_cps_call$1
		                           (push, t[12], internal_observer, cont))
		                        : match
		                          ? cont(0)
		                          : (t
		                             [8]
		                            = t[8] - 1 | 0,
		                            internal_observer[1] = 3,
		                            internal_observer[3] = 0,
		                            cont(0));
		               }
		               function disallow_finalized_observers(t, cont){
		                function a(b){
		                 var r = t[10];
		                 return 0 < r[1]
		                         ? caml_exact_trampoline_cps_call
		                           (dequeue_exn,
		                            t[10],
		                            function(internal_observer){
		                             return is_empty(internal_observer[3])
		                                     ? caml_exact_trampoline_cps_call
		                                       (disallow_future_use, internal_observer, a)
		                                     : caml_exact_trampoline_call1(a, 0);
		                            })
		                         : cont();
		                }
		                return a();
		               }
		               function create_observer(opt, observing, cont){
		                var
		                 t = observing[2],
		                 internal_observer =
		                   [0, 0, observing, 0, none$3, none$3, none$3, none$3];
		                return caml_exact_trampoline_cps_call$1
		                        (push,
		                         t[11],
		                         internal_observer,
		                         function(a){
		                          t[8] = t[8] + 1 | 0;
		                          return cont([0, internal_observer]);
		                         });
		               }
		               function add_new_observers(t, cont){
		                function a(b){
		                 var t$0 = t[11];
		                 return 0 < t$0[1]
		                         ? caml_exact_trampoline_cps_call
		                           (pop_exn,
		                            t[11],
		                            function(internal_observer){
		                             var b = internal_observer[1];
		                             if(! b){
		                              internal_observer[1] = 1;
		                              var
		                               old_all_observers = t[9],
		                               c =
		                                 function(){
		                                  return caml_exact_trampoline_cps_call
		  (some$1,
		   internal_observer,
		   function(b){
		    t[9] = b;
		    var observing = internal_observer[2];
		    return caml_trampoline_cps_call2
		            (is_necessary$1,
		             observing,
		             function(was_necessary){
		              return caml_exact_trampoline_cps_call
		                      (length$1,
		                       internal_observer[3],
		                       function(c){
		                        observing[8] = observing[8] + c | 0;
		                        var old_observers = observing[21];
		                        function b(){
		                         return caml_exact_trampoline_cps_call
		                                 (some$1,
		                                  internal_observer,
		                                  function(b){
		                                   observing[21] = b;
		                                   return caml_exact_trampoline_cps_call
		   (handle_after_stabilization,
		    observing,
		    function(b){
		     return 1 - was_necessary
		             ? caml_exact_trampoline_cps_call
		               (became_necessary, observing, a)
		             : caml_exact_trampoline_call1(a, 0);
		    });
		                                  });
		                        }
		                        return is_some$2(old_observers)
		                                ? (internal_observer
		                                   [7]
		                                  = old_observers,
		                                  caml_exact_trampoline_cps_call
		                                   (some$1,
		                                    internal_observer,
		                                    function(a){old_observers[6] = a; return b();}))
		                                : b();
		                       });
		             });
		   });
		                                 };
		                              return is_some$2(old_all_observers)
		                                      ? (internal_observer
		 [5]
		= old_all_observers,
		caml_exact_trampoline_cps_call
		 (some$1,
		  internal_observer,
		  function(a){
		   set_prev_in_all(old_all_observers, a);
		   return c();
		  }))
		                                      : c();
		                             }
		                             if(3 <= b) return caml_exact_trampoline_call1(a, 0);
		                             b = caml_pop_trap();
		                             return b
		                                     (caml_maybe_attach_backtrace([0, Assert_failure, aOi], 1));
		                            })
		                         : cont();
		                }
		                return a();
		               }
		               function observer_value_exn(observer, cont){
		                var t$0 = incr_state$1(observer), a = t$0[1];
		                if(typeof a !== "number"){
		                 var raised_exn = a[1];
		                 return cont
		                         (reraise_with_message
		                           (raised_exn,
		                            "Observer.value_exn called after stabilize previously raised"));
		                }
		                if(! a)
		                 return caml_exact_trampoline_cps_call$3
		                         (failwiths,
		                          0,
		                          aOk,
		                          "Observer.value_exn called during stabilization",
		                          observer,
		                          function(x_098, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (sexp_of_t$124,
		                                    function(param, cont){return cont(aOj);},
		                                    x_098,
		                                    cont);
		                          },
		                          cont);
		                var t = observer[1], a = t[1];
		                if(1 !== a)
		                 return a
		                         ? caml_exact_trampoline_cps_call$3
		                           (failwiths,
		                            0,
		                            aNm,
		                            "Observer.value_exn called after disallow_future_use",
		                            t,
		                            function(x_022, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_internal_observer,
		                                      function(param, cont){return cont(aNl);},
		                                      x_022,
		                                      cont);
		                            },
		                            cont)
		                         : caml_exact_trampoline_cps_call$3
		                           (failwiths,
		                            0,
		                            aNo,
		                            "Observer.value_exn called without stabilizing",
		                            t,
		                            function(x_021, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (sexp_of_internal_observer,
		                                      function(param, cont){return cont(aNn);},
		                                      x_021,
		                                      cont);
		                            },
		                            cont);
		                var uopt = t[2][4];
		                function b(a){return cont(uopt);}
		                return uopt === cst_Uopt_none
		                        ? caml_exact_trampoline_cps_call$3
		                          (failwiths,
		                           0,
		                           aNk,
		                           cst_attempt_to_get_value_of_an,
		                           t,
		                           function(x_023, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (sexp_of_internal_observer,
		                                     function(param, cont){return cont(aNj);},
		                                     x_023,
		                                     cont);
		                           },
		                           b)
		                        : b();
		               }
		               function observer_on_update_exn(observer, f, cont){
		                var
		                 t$0 = incr_state$1(observer),
		                 on_update_handler = create$34(f, t$0[3]),
		                 t = observer[1];
		                function b(a){
		                 return caml_exact_trampoline_cps_call
		                         (handle_after_stabilization, observing(observer), cont);
		                }
		                if(2 <= t[1])
		                 return caml_exact_trampoline_cps_call$3
		                         (failwiths,
		                          0,
		                          aNq,
		                          "on_update disallowed",
		                          t,
		                          function(x_024, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (sexp_of_internal_observer,
		                                    function(param, cont){return cont(aNp);},
		                                    x_024,
		                                    cont);
		                          },
		                          b);
		                t[3] = [0, on_update_handler, t[3]];
		                var a = t[1];
		                if(1 === a){
		                 var observing$0 = t[2];
		                 observing$0[8] = observing$0[8] + 1 | 0;
		                 return b();
		                }
		                if(! a) return b();
		                a = caml_pop_trap();
		                return a
		                        (caml_maybe_attach_backtrace([0, Assert_failure, aNr], 1));
		               }
		               function set_var_while_not_stabilizing(var$, value, cont){
		                var t = incr_state(var$);
		                t[27] = t[27] + 1 | 0;
		                var$[1] = value;
		                function a(){return cont();}
		                if(caml_int_compare(var$[3], t[3]) >= 0) return a();
		                var$[3] = t[3];
		                var watch = var$[4];
		                return caml_trampoline_cps_call2
		                        (is_necessary$1,
		                         watch,
		                         function(b){
		                          b = b ? 1 - is_in_recompute_heap(watch) : b;
		                          return b
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (add$15, t[5], watch, cont)
		                                  : a();
		                         });
		               }
		               function set_var(var$, value, cont){
		                var t = incr_state(var$), match = t[1];
		                if(typeof match !== "number"){
		                 var raised_exn = match[1];
		                 return cont
		                         (reraise_with_message
		                           (raised_exn,
		                            "cannot set var -- stabilization previously raised"));
		                }
		                if(match)
		                 return caml_exact_trampoline_cps_call$1
		                         (set_var_while_not_stabilizing, var$, value, cont);
		                var t$0 = var$[2];
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (some$1, value, function(a){var$[2] = a; return cont();});
		                }
		                return t$0 === cst_Uopt_none
		                        ? caml_exact_trampoline_cps_call$1(push, t[13], var$, a)
		                        : a();
		               }
		               function reclaim_space_in_weak_hashtbls(t, cont){
		                function a(){
		                 var r = t[17];
		                 return 0 < r[1]
		                         ? caml_exact_trampoline_cps_call
		                           (dequeue_exn,
		                            t[17],
		                            function(match){
		                             var weak_hashtbl = match[1];
		                             function b(c){
		                              var r = weak_hashtbl[2];
		                              return 0 < r[1]
		                                      ? caml_exact_trampoline_cps_call
		(dequeue_exn,
		 weak_hashtbl[2],
		 function(key){
		  var t = weak_hashtbl[1];
		  return caml_exact_trampoline_cps_call$2
		          (find_and_call$0,
		           t,
		           key,
		           if_found,
		           if_not_found$0,
		           function(match){
		            if(! match) return caml_exact_trampoline_call1(b, 0);
		            var entry = match[1];
		            return caml_exact_trampoline_cps_call$1
		                    (check,
		                     entry,
		                     index$3,
		                     function(a){
		                      return 1 - a
		                              ? caml_exact_trampoline_cps_call$1
		                                (remove$4, weak_hashtbl[1], key, b)
		                              : caml_exact_trampoline_call1(b, 0);
		                     });
		           });
		 })
		                                      : caml_exact_trampoline_call0(a);
		                             }
		                             return b();
		                            })
		                         : cont(0);
		                }
		                return a();
		               }
		               function stabilize_start(t, cont){
		                t[1] = 0;
		                return caml_exact_trampoline_cps_call
		                        (disallow_finalized_observers,
		                         t,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (add_new_observers,
		                                   t,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (unlink_disallowed_observers,
		     t,
		     function(a){return cont(debug$1);});
		                                   });
		                         });
		               }
		               function stabilize_end(t, cont){
		                var t$0 = t[3];
		                t[3] = t$0 + 1 | 0;
		                function a(c){
		                 function b(c){
		                  if(! is_empty$1(t[14]))
		                   return caml_exact_trampoline_cps_call
		                           (pop_exn,
		                            t[14],
		                            function(node){
		                             node[22] = 0;
		                             var old_value = node[20];
		                             node[20] = none$3;
		                             return caml_trampoline_cps_call2
		                                     (is_valid$2,
		                                      node,
		                                      function(c){
		                                       function a(node_update){
		return caml_exact_trampoline_cps_call$1
		        (push, t[15], [0, node, node_update], b);
		                                       }
		                                       return c
		       ? caml_trampoline_cps_call2
		         (is_necessary$1,
		          node,
		          function(b){
		           return b
		                   ? caml_exact_trampoline_cps_call
		                     (value_exn$1,
		                      node[4],
		                      function(new_value){
		                       return old_value === cst_Uopt_none
		                               ? a([0, new_value])
		                               : a([1, old_value, new_value]);
		                      })
		                   : a(1);
		          })
		       : a(0);
		                                      });
		                            });
		                  t[1] = 1;
		                  var now = t[3];
		                  function a(b){
		                   return is_empty$1(t[15])
		                           ? (t
		                              [1]
		                             = 2,
		                             caml_exact_trampoline_cps_call
		                              (reclaim_space_in_weak_hashtbls, t, cont))
		                           : caml_exact_trampoline_cps_call
		                             (pop_exn,
		                              t[15],
		                              function(match){
		                               var node_update = match[2], node = match[1];
		                               return caml_exact_trampoline_cps_call$0
		                                       (run_on_update_handlers, node, node_update, now, a);
		                              });
		                  }
		                  return a();
		                 }
		                 return is_empty$1(t[13])
		                         ? b()
		                         : caml_exact_trampoline_cps_call
		                           (pop_exn,
		                            t[13],
		                            function(match){
		                             return caml_exact_trampoline_cps_call
		                                     (value_exn$1,
		                                      match[2],
		                                      function(value){
		                                       match[2] = none$3;
		                                       return caml_exact_trampoline_cps_call$1
		       (set_var_while_not_stabilizing, match, value, a);
		                                      });
		                            });
		                }
		                return a();
		               }
		               function raise_during_stabilization(t, exn$0){
		                var raised = [0, exn$0, caml_get_exception_raw_backtrace()];
		                t[1] = [0, raised];
		                raised[2]; var exn = raised[1];
		                return raise_with_original_backtrace(exn);
		               }
		               var cst_stabilize = "stabilize";
		               function stabilize(t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (ensure_not_stabilizing,
		                         t,
		                         cst_stabilize,
		                         0,
		                         function(a){
		                          caml_push_trap
		                           (function(exn){
		                             return cont(raise_during_stabilization(t, exn));
		                            });
		                          return caml_exact_trampoline_cps_call
		                                  (stabilize_start,
		                                   t,
		                                   function(b){
		                                    var r = t[5];
		                                    function a(b){
		                                     return 0 < r[1]
		     ? caml_exact_trampoline_cps_call
		       (recompute_first_node_that_is_n, r, a)
		     : caml_exact_trampoline_cps_call
		       (stabilize_end,
		        t,
		        function(a){caml_pop_trap(); return cont(a);});
		                                    }
		                                    return a();
		                                   });
		                         });
		               }
		               function create_node_in(t, created_in, kind, cont){
		                t[22] = t[22] + 1 | 0;
		                return caml_exact_trampoline_cps_call$0
		                        (create$35, t, created_in, kind, cont);
		               }
		               function create_node(t, kind, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (create_node_in, t, t[4], kind, cont);
		               }
		               var top = 0;
		               function create_var(t, opt, value, cont){
		                var
		                 use_current_scope = opt ? opt[1] : 0,
		                 scope = use_current_scope ? t[4] : top;
		                return caml_exact_trampoline_cps_call$0
		                        (create_node_in,
		                         t,
		                         scope,
		                         1,
		                         function(watch){
		                          var var$ = [0, value, none$3, t[3], watch];
		                          set_kind(watch, [16, var$]);
		                          return cont(var$);
		                         });
		               }
		               function const$(t, a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create_node, t, [5, a], cont);
		               }
		               function map$41(n, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create_node, n[2], [12, f, n], cont);
		               }
		               function map2$1(n1, n2, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (create_node, n1[2], [17, f, n1, n2], cont);
		               }
		               var never = 1;
		               function bind$23(lhs, f, cont){
		                var t = lhs[2];
		                return caml_exact_trampoline_cps_call$1
		                        (create_node,
		                         t,
		                         1,
		                         function(lhs_change){
		                          return caml_exact_trampoline_cps_call$1
		                                  (create_node,
		                                   t,
		                                   1,
		                                   function(main){
		                                    var
		                                     bind = [0, main, f, lhs, lhs_change, none$3, top, none$3];
		                                    set_cutoff(lhs_change, never);
		                                    bind[6] = [0, bind];
		                                    set_kind(lhs_change, [3, bind]);
		                                    set_kind(main, [4, bind]);
		                                    return cont(main);
		                                   });
		                         });
		               }
		               function join$5(lhs, cont){
		                var t = lhs[2];
		                return caml_exact_trampoline_cps_call$1
		                        (create_node,
		                         t,
		                         1,
		                         function(lhs_change){
		                          return caml_exact_trampoline_cps_call$1
		                                  (create_node,
		                                   t,
		                                   1,
		                                   function(main){
		                                    var join = [0, main, lhs, lhs_change, none$3];
		                                    set_cutoff(lhs_change, never);
		                                    set_kind(lhs_change, [10, join]);
		                                    set_kind(main, [11, join]);
		                                    return cont(main);
		                                   });
		                         });
		               }
		               function array_fold(t, children, init, f, cont){
		                return children.length - 1 === 0
		                        ? caml_exact_trampoline_cps_call$1(const$, t, init, cont)
		                        : caml_exact_trampoline_cps_call$1
		                          (create_node, t, [0, [0, init, f, children]], cont);
		               }
		               function all$19(t, ts, cont){
		                function a(ac, a, cont){return cont([0, a, ac]);}
		                return caml_exact_trampoline_cps_call
		                        (of_list_rev,
		                         ts,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$2
		                                  (array_fold, t, b, 0, a, cont);
		                         });
		               }
		               function set_freeze(node, child, only_freeze_when, cont){
		                return caml_trampoline_cps_call2
		                        (is_necessary$1,
		                         node,
		                         function(was_necessary){
		                          set_kind(node, [7, [0, node, child, only_freeze_when]]);
		                          return was_necessary
		                                  ? caml_exact_trampoline_cps_call$0
		                                    (add_parent$0, child, node, 0, cont)
		                                  : caml_exact_trampoline_cps_call
		                                    (became_necessary, node, cont);
		                         });
		               }
		               function freeze(child, only_freeze_when, cont){
		                var t = child[2];
		                return caml_exact_trampoline_cps_call$0
		                        (create_node_in,
		                         t,
		                         top,
		                         1,
		                         function(node){
		                          return caml_exact_trampoline_cps_call$0
		                                  (set_freeze,
		                                   node,
		                                   child,
		                                   only_freeze_when,
		                                   function(a){return cont(node);});
		                         });
		               }
		               function create_internal(Config, max_height_allowed){
		                var
		                 adjust_heights_heap =
		                   [0,
		                    0,
		                    max_height_allowed + 1 | 0,
		                    0,
		                    create$36(max_height_allowed)],
		                 recompute_heap =
		                   [0,
		                    0,
		                    max_height_allowed + 1 | 0,
		                    create_nodes_by_height(max_height_allowed)],
		                 a = create$33(),
		                 b = create$37(),
		                 c = create$14(),
		                 d = create$14(),
		                 e = create$14(),
		                 f = create$14(),
		                 g = create$14(),
		                 h = create$33(),
		                 i = create$14(),
		                 t =
		                   [0,
		                    2,
		                    Config[1],
		                    min_value$3,
		                    top,
		                    recompute_heap,
		                    adjust_heights_heap,
		                    i,
		                    0,
		                    none$3,
		                    h,
		                    g,
		                    f,
		                    e,
		                    d,
		                    c,
		                    b,
		                    a,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    0];
		                return t;
		               }
		               function expert_kind_of_node(node, cont){
		                var x_099 = node[5];
		                if(typeof x_099 === "number"){
		                 if(0 === x_099) return cont(none$3);
		                }
		                else if(6 === x_099[0]){
		                 var e = x_099[1];
		                 return caml_exact_trampoline_cps_call(some$1, e, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_t$116,
		                         function(param, cont){return cont(aOl);},
		                         x_099,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (raise_s,
		                                   [1, [0, [0, "unexpected kind for expert node"], [0, a, 0]]],
		                                   cont);
		                         });
		               }
		               function create$38(state, on_observability_change, f, cont){
		                var e = [0, f, on_observability_change, empty$7, 0, 0, 0, 1];
		                return caml_exact_trampoline_cps_call$1
		                        (create_node, state, [6, e], cont);
		               }
		               function make_stale(node, cont){
		                var state = node[2];
		                return caml_exact_trampoline_cps_call
		                        (expert_kind_of_node,
		                         node,
		                         function(e_opt){
		                          function a(){return cont();}
		                          if(! is_some$2(e_opt)) return a();
		                          var match = e_opt[5] ? 534011858 : (e_opt[5] = 1, 17724);
		                          return 534011858 <= match
		                                  ? cont()
		                                  : caml_trampoline_cps_call2
		                                    (is_necessary$1,
		                                     node,
		                                     function(b){
		                                      b = b ? 1 - is_in_recompute_heap(node) : b;
		                                      return b
		      ? caml_exact_trampoline_cps_call$1
		        (add$15, state[5], node, cont)
		      : a();
		                                     });
		                         });
		               }
		               function invalidate(node, cont){
		                var state = node[2];
		                return caml_exact_trampoline_cps_call
		                        (invalidate_node,
		                         node,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (propagate_invalidity, state, cont);
		                         });
		               }
		               function add_dependency(node, packed_edge, cont){
		                var state = node[2];
		                return caml_exact_trampoline_cps_call
		                        (expert_kind_of_node,
		                         node,
		                         function(e_opt){
		                          function a(){return cont();}
		                          if(! is_some$2(e_opt)) return a();
		                          var t = packed_edge[3];
		                          if(t === cst_Uopt_none){
		                           var
		                            b =
		                              function(){
		                               var new_child_index = e_opt[4];
		                               return caml_exact_trampoline_cps_call
		                                       (some$1,
		new_child_index,
		function(b){
		 packed_edge[3] = b;
		 return caml_exact_trampoline_cps_call
		         (some$1,
		          packed_edge,
		          function(x){
		           var t = e_opt[3];
		           set_with_caml_modify(t, new_child_index, x);
		           e_opt[4] = e_opt[4] + 1 | 0;
		           e_opt[5] = 1;
		           return caml_trampoline_cps_call2
		                   (is_necessary$1,
		                    node,
		                    function(b){
		                     return b
		                             ? caml_exact_trampoline_cps_call$0
		                               (add_parent$0,
		                                packed_edge[1],
		                                node,
		                                new_child_index,
		                                function(b){
		                                 return 1 - is_in_recompute_heap(node)
		 ? caml_exact_trampoline_cps_call$1
		   (add$15, state[5], node, cont)
		 : a();
		                                })
		                             : a();
		                    });
		          });
		});
		                              };
		                           return e_opt[3].length - 1 <= e_opt[4]
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (max$2,
		                                      2,
		                                      2 * (e_opt[3].length - 1) | 0,
		                                      function(new_max){
		                                       return caml_exact_trampoline_cps_call$1
		       (realloc$0,
		        e_opt[3],
		        new_max,
		        function(a){e_opt[3] = a; return b();});
		                                      })
		                                   : b();
		                          }
		                          var raise = caml_pop_trap();
		                          return raise
		                                  (caml_maybe_attach_backtrace([0, Assert_failure, aJv], 1));
		                         });
		               }
		               function remove_dependency(node, edge, cont){
		                var state = node[2];
		                return caml_exact_trampoline_cps_call
		                        (expert_kind_of_node,
		                         node,
		                         function(e_opt){
		                          function a(){return cont();}
		                          return is_some$2(e_opt)
		                                  ? caml_exact_trampoline_cps_call
		                                    (value_exn$1,
		                                     edge[3],
		                                     function(child_index1){
		                                      var last_index = e_opt[4] - 1 | 0, arr = e_opt[3];
		                                      return caml_exact_trampoline_cps_call
		      (value_exn$1,
		       get$3(arr, last_index),
		       function(last_edge){
		        return caml_exact_trampoline_cps_call
		                (value_exn$1,
		                 last_edge[3],
		                 function(last_edge_index){
		                  function b(){
		                   var
		                    last_index = e_opt[4] - 1 | 0,
		                    arr = e_opt[3],
		                    packed_edge_opt = get$3(arr, last_index),
		                    t = e_opt[3];
		                   set_with_caml_modify(t, last_index, none$3);
		                   e_opt[4] = last_index;
		                   e_opt[5] = 1;
		                   if(is_some$2(packed_edge_opt)){
		                    packed_edge_opt[3] = none$3;
		                    return caml_trampoline_cps_call2
		                            (is_necessary$1,
		                             node,
		                             function(b){
		                              return b
		                                      ? caml_exact_trampoline_cps_call$0
		(remove_child,
		 edge[1],
		 node,
		 last_edge_index,
		 function(c){
		  function b(b){
		   return caml_trampoline_cps_call2
		           (is_valid$2,
		            edge[1],
		            function(b){
		             return 1 - b ? (e_opt[6] = e_opt[6] - 1 | 0, cont()) : a();
		            });
		  }
		  return 1 - is_in_recompute_heap(node)
		          ? caml_exact_trampoline_cps_call$1
		            (add$15, state[5], node, b)
		          : b();
		 })
		                                      : a();
		                             });
		                   }
		                   var raise = caml_pop_trap();
		                   return raise
		                           (caml_maybe_attach_backtrace([0, Assert_failure, aJw], 1));
		                  }
		                  return child_index1 !== last_edge_index
		                          ? caml_trampoline_cps_call2
		                            (is_necessary$1,
		                             node,
		                             function(a){
		                              if(a)
		                               swap_children_except_in_kind
		                                (node, edge[1], child_index1, last_edge[1], last_edge_index);
		                              var arr = e_opt[3];
		                              return caml_exact_trampoline_cps_call
		                                      (value_exn$1,
		                                       get$3(arr, child_index1),
		                                       function(edge1){
		var arr = e_opt[3];
		return caml_exact_trampoline_cps_call
		        (value_exn$1,
		         get$3(arr, last_edge_index),
		         function(match){
		          return caml_exact_trampoline_cps_call
		                  (some$1,
		                   last_edge_index,
		                   function(a){
		                    edge1[3] = a;
		                    return caml_exact_trampoline_cps_call
		                            (some$1,
		                             child_index1,
		                             function(c){
		                              match[3] = c;
		                              var
		                               t = e_opt[3],
		                               a = get$3(t, child_index1),
		                               b$0 = get$3(t, last_edge_index);
		                              unsafe_set(t, child_index1, b$0);
		                              unsafe_set(t, last_edge_index, a);
		                              return b();
		                             });
		                   });
		         });
		                                       });
		                             })
		                          : b();
		                 });
		       });
		                                     })
		                                  : a();
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Expert1";
		               record_start(d);
		               set$7(j);
		               function create$39(opt, child){
		                var
		                 on_change = opt ? opt[1] : function(a, cont){return cont(0);};
		                return [0, child, on_change, none$3];
		               }
		               function create$40(state, opt, f, cont){
		                var
		                 on_observability_change =
		                   opt ? opt[1] : function(param, cont){return cont(0);};
		                return caml_exact_trampoline_cps_call$0
		                        (create$38, state, on_observability_change, f, cont);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Reduce_balanced";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__For_analyzer";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Node_to_dot";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental__Incremental_intf";
		               record_start(d);
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incremental";
		               record_start(d);
		               set$7(j);
		               function symbol_map$15(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(map$41, t, f, cont);
		               }
		               function symbol_bind$16(t, f, cont){
		                return caml_exact_trampoline_cps_call$1(bind$23, t, f, cont);
		               }
		               function value$7(t){return t[1];}
		               function watch(t){return t[4];}
		               function on_update_exn(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (observer_on_update_exn,
		                         t,
		                         function(param, cont){
		                          if(typeof param === "number")
		                           return 0 === param
		                                   ? caml_exact_trampoline_cps_call(f, 0, cont)
		                                   : caml_exact_trampoline_cps_call$3
		                                     (failwiths,
		                                      0,
		                                      aOn,
		                                      "Incremental bug -- Observer.on_update_exn got unexpected update Unnecessary",
		                                      t,
		                                      function(x_017, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (sexp_of_t$124,
		        function(param, cont){return cont(aOm);},
		        x_017,
		        cont);
		                                      },
		                                      cont);
		                          if(0 === param[0]){
		                           var a = param[1];
		                           return caml_exact_trampoline_cps_call(f, [0, a], cont);
		                          }
		                          var a2 = param[2], a1 = param[1];
		                          return caml_exact_trampoline_cps_call(f, [1, a1, a2], cont);
		                         },
		                         cont);
		               }
		               function disallow_future_use$0(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (disallow_future_use, t[1], cont);
		               }
		               var
		                level_bits$0 = caml_callback(create_exn$0, [aOo, level_bits]),
		                max_num_bits$0 = max_num_level_bits(20);
		               if
		                (caml_callback
		                  (fold_left$1, [level_bits$0, min_value$3, symbol$215])
		                 > max_num_bits$0){
		                var
		                 loop$3 =
		                   function(t, remaining){
		                    if(! t) return;
		                    var t$0 = t[2], b = t[1];
		                    if(remaining <= b) return;
		                    loop$3(t$0, symbol$216(remaining, b));
		                   };
		                loop$3(level_bits$0, max_num_bits$0);
		               }
		               function freeze$0(opt, t, cont){
		                var
		                 when = opt ? opt[1] : function(param, cont){return cont(1);};
		                return caml_exact_trampoline_cps_call$1(freeze, t, when, cont);
		               }
		               function both$3(t1, t2, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (map2$1,
		                         t1,
		                         t2,
		                         function(x1, x2, cont){return cont([0, x1, x2]);},
		                         cont);
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               function bQy(a){
		                var
		                 Incremental_config = Default(),
		                 state = create_internal(Incremental_config, 128);
		                function return$(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (const$, state, a, cont);
		                }
		                function create(use_current_scope, value, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (create_var, state, use_current_scope, value, cont);
		                }
		                function return$0(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (const$, state, a, cont);
		                }
		                function all(ts, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (all$19, state, ts, cont);
		                }
		                function array_fold$0(ts, init, f, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (array_fold, state, ts, init, f, cont);
		                }
		                function stabilize$0(param, cont){
		                 return caml_exact_trampoline_cps_call(stabilize, state, cont);
		                }
		                return [0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        return$0,
		                        map$41,
		                        symbol_map$15,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        bind$23,
		                        symbol_bind$16,
		                        ,
		                        ,
		                        ,
		                        ,
		                        join$5,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        all,
		                        ,
		                        array_fold$0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        [0, , create, set_var, watch, value$7],
		                        ,
		                        ,
		                        ,
		                        ,
		                        stabilize$0,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        ,
		                        [0,
		                         return$,
		                         symbol_map$15,
		                         symbol_bind$16,
		                         [0,
		                          bind$23,
		                          return$,
		                          ,
		                          ,
		                          ,
		                          map$41,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          both$3]]];
		               }
		               var d = "Incr_map__Incr_map_intf";
		               record_start(d);
		               j = "incr_map";
		               set$7(j);
		               unset();
		               caml_callback(record_until, [d]);
		               d = "Incr_map";
		               record_start(d);
		               set$7(j);
		               function no_instrumentation(f, cont){
		                return caml_exact_trampoline_cps_call(f, dummy, cont);
		               }
		               function with_old(instrumentation, i, f, cont){
		                var old = [0, 0];
		                return caml_exact_trampoline_cps_call$1
		                        (map$41,
		                         i,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (instrumentation,
		                                   function(param, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (f,
		     old[1],
		     a,
		     function(b){old[1] = [0, [0, a, b]]; return cont(b);});
		                                   },
		                                   cont);
		                         },
		                         cont);
		               }
		               function unordered_fold
		               (instrumentation,
		                b,
		                update,
		                specialized_initial,
		                a,
		                opt,
		                map,
		                init,
		                add,
		                remove,
		                cont){
		                var
		                 data_equal =
		                   b
		                    ? b[1]
		                    : function(b, a, cont){return cont(b === a ? 1 : 0);},
		                 finalize = a ? a[1] : function(a, cont){return cont(a);},
		                 revert_to_init_when_empty = opt ? opt[1] : 0;
		                function default$(key, old_data, new_data, acc, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (remove,
		                          key,
		                          old_data,
		                          acc,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (add, key, new_data, a, cont);
		                          });
		                }
		                var update$0 = value$4(update, default$);
		                return caml_exact_trampoline_cps_call$0
		                        (with_old,
		                         instrumentation,
		                         map,
		                         function(old, new_in, cont){
		                          function a(acc){
		                           return caml_exact_trampoline_cps_call(finalize, acc, cont);
		                          }
		                          if(old){
		                           var match = old[1], old_out = match[2], old_in = match[1];
		                           if(revert_to_init_when_empty && new_in[3] === 0)
		                            return a(init);
		                           return caml_exact_trampoline_cps_call$3
		                                   (fold_symmetric_diff$1,
		                                    old_in,
		                                    new_in,
		                                    data_equal,
		                                    old_out,
		                                    function(acc, a, cont){
		                                     var change = a[2], key = a[1], variant = change[1];
		                                     if(847852583 === variant){
		                                      var old = change[2];
		                                      return caml_exact_trampoline_cps_call$0
		      (remove, key, old, acc, cont);
		                                     }
		                                     if(1013247643 <= variant){
		                                      a = change[2];
		                                      var new$ = a[2], old$0 = a[1];
		                                      return caml_trampoline_cps_call5
		      (update$0, key, old$0, new$, acc, cont);
		                                     }
		                                     var new$0 = change[2];
		                                     return caml_exact_trampoline_cps_call$0
		     (add, key, new$0, acc, cont);
		                                    },
		                                    a);
		                          }
		                          if(! specialized_initial)
		                           return caml_exact_trampoline_cps_call$0
		                                   (fold$5, new_in, init, add, a);
		                          var initial = specialized_initial[1];
		                          return a(initial(init, new_in));
		                         },
		                         cont);
		               }
		               function with_comparator(comparator$0, map, f, cont){
		                if(! comparator$0)
		                 return caml_exact_trampoline_cps_call$1
		                         (map$41,
		                          map,
		                          get_comparator,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (freeze$0,
		                                    0,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1(bind$23, a, f, cont);
		                                    });
		                          });
		                var comparator = comparator$0[1];
		                return caml_exact_trampoline_cps_call(f, comparator, cont);
		               }
		               function generic_mapi
		               (witness, instrumentation, opt, map, f, cont){
		                var
		                 data_equal =
		                   opt
		                    ? opt[1]
		                    : function(b, a, cont){return cont(b === a ? 1 : 0);};
		                return caml_exact_trampoline_cps_call$0
		                        (with_old,
		                         instrumentation,
		                         map,
		                         function(old, input, cont){
		                          if(0 !== input[3] && old){
		                           var
		                            match = old[1],
		                            old_output = match[2],
		                            old_input = match[1];
		                           return caml_exact_trampoline_cps_call$3
		                                   (fold_symmetric_diff$1,
		                                    old_input,
		                                    input,
		                                    data_equal,
		                                    old_output,
		                                    function(output, param, cont){
		                                     var change = param[2], key = param[1], variant = change[1];
		                                     if(847852583 === variant)
		                                      return caml_exact_trampoline_cps_call$1
		      (remove$2, output, key, cont);
		                                     var
		                                      new_data = 1013247643 <= variant ? change[2][2] : change[2];
		                                     return caml_exact_trampoline_cps_call$1
		     (f,
		      key,
		      new_data,
		      function(res){
		       if(! witness)
		        return caml_exact_trampoline_cps_call$0
		                (set$3, output, key, res, cont);
		       if(! res)
		        return caml_exact_trampoline_cps_call$1
		                (remove$2, output, key, cont);
		       var output_data = res[1];
		       return caml_exact_trampoline_cps_call$0
		               (set$3, output, key, output_data, cont);
		      });
		                                    },
		                                    cont);
		                          }
		                          return witness
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (filter_mapi$1, input, f, cont)
		                                  : caml_exact_trampoline_cps_call$1(mapi$3, input, f, cont);
		                         },
		                         cont);
		               }
		               function mapi$5(opt, data_equal, map, f, cont){
		                var instrumentation = opt ? opt[1] : no_instrumentation;
		                return caml_exact_trampoline_cps_call$3
		                        (generic_mapi, 0, instrumentation, data_equal, map, f, cont);
		               }
		               function filter_mapi$2(opt, data_equal, map, f, cont){
		                var instrumentation = opt ? opt[1] : no_instrumentation;
		                return caml_exact_trampoline_cps_call$3
		                        (generic_mapi, 1, instrumentation, data_equal, map, f, cont);
		               }
		               function map$42(instrumentation, data_equal, map, f, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (mapi$5,
		                         instrumentation,
		                         data_equal,
		                         map,
		                         function(param, data, cont){
		                          return caml_exact_trampoline_cps_call(f, data, cont);
		                         },
		                         cont);
		               }
		               function filter_map$5
		               (instrumentation, data_equal, map, f, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (filter_mapi$2,
		                         instrumentation,
		                         data_equal,
		                         map,
		                         function(param, data, cont){
		                          return caml_exact_trampoline_cps_call(f, data, cont);
		                         },
		                         cont);
		               }
		               function generic_mapi_with_comparator
		               (witness,
		                instrumentation,
		                cutoff,
		                opt,
		                lhs,
		                comparator,
		                f,
		                cont){
		                var
		                 data_equal =
		                   opt
		                    ? opt[1]
		                    : function(b, a, cont){return cont(b === a ? 1 : 0);},
		                 incremental_state = lhs[2],
		                 empty_map = empty$11(comparator),
		                 prev_map = [0, empty_map],
		                 prev_nodes = [0, empty_map],
		                 acc = [0, empty_map];
		                return caml_exact_trampoline_cps_call$0
		                        (create$40,
		                         incremental_state,
		                         0,
		                         function(param, cont){return cont(acc[1]);},
		                         function(result){
		                          var
		                           on_inner_change =
		                             witness
		                              ? function
		                               (key, opt, cont){
		                                var old = acc[1];
		                                function a(a){acc[1] = a; return cont(0);}
		                                if(! opt)
		                                 return caml_exact_trampoline_cps_call$1
		 (remove$2, old, key, a);
		                                var data = opt[1];
		                                return caml_exact_trampoline_cps_call$0
		(set$3, old, key, data, a);
		                               }
		                              : function
		                               (key, data, cont){
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 acc[1],
		 key,
		 data,
		 function(a){acc[1] = a; return cont(0);});
		                               },
		                           lhs_change = [];
		                          caml_update_dummy
		                           (lhs_change,
		                            [246,
		                             function(a, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (map$41,
		                                       lhs,
		                                       function(map, cont){
		return caml_exact_trampoline_cps_call
		        (instrumentation,
		         function(param, cont){
		          return caml_exact_trampoline_cps_call$3
		                  (fold_symmetric_diff$1,
		                   prev_map[1],
		                   map,
		                   data_equal,
		                   prev_nodes[1],
		                   function(nodes, param, cont){
		                    var
		                     changed = param[2],
		                     key = param[1],
		                     variant = changed[1];
		                    return 847852583 === variant
		                            ? caml_exact_trampoline_cps_call$1
		                              (find_packed_by_id_exn,
		                               nodes,
		                               key,
		                               function(match){
		                                var dep = match[2], node = match[1];
		                                return caml_exact_trampoline_cps_call$1
		(remove$2,
		 nodes,
		 key,
		 function(nodes){
		  return caml_exact_trampoline_cps_call$1
		          (remove_dependency,
		           result,
		           dep,
		           function(a){
		            return caml_exact_trampoline_cps_call$1
		                    (remove$2,
		                     acc[1],
		                     key,
		                     function(a){
		                      acc[1] = a;
		                      return caml_exact_trampoline_cps_call
		                              (invalidate, node, function(a){return cont(nodes);});
		                     });
		           });
		 });
		                               })
		                            : 1013247643
		                              <= variant
		                              ? caml_exact_trampoline_cps_call$1
		                                (find_packed_by_id_exn,
		                                 nodes,
		                                 key,
		                                 function(match){
		                                  var node = match[1];
		                                  return caml_exact_trampoline_cps_call
		  (make_stale, node, function(a){return cont(nodes);});
		                                 })
		                              : caml_exact_trampoline_cps_call$0
		                                (create$40,
		                                 incremental_state,
		                                 0,
		                                 function(param, cont){
		                                  return caml_exact_trampoline_cps_call$1
		  (find_packed_by_id_exn, prev_map[1], key, cont);
		                                 },
		                                 function(node){
		                                  if(cutoff){var a = cutoff[1]; set_cutoff(node, a);}
		                                  return caml_exact_trampoline_cps_call
		  (force$0,
		   lhs_change,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (add_dependency,
		             node,
		             create$39(0, a),
		             function(a){
		              return caml_exact_trampoline_cps_call$1
		                      (f,
		                       key,
		                       node,
		                       function(a){
		                        var
		                         user_function_dep =
		                           create$39
		                            ([0,
		                              function(a, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (on_inner_change, key, a, cont);
		                              }],
		                             a);
		                        return caml_exact_trampoline_cps_call$1
		                                (add_dependency,
		                                 result,
		                                 user_function_dep,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$0
		  (set$3, nodes, key, [0, node, user_function_dep], cont);
		                                 });
		                       });
		             });
		   });
		                                 });
		                   },
		                   function(new_nodes){
		                    prev_nodes[1] = new_nodes;
		                    prev_map[1] = map;
		                    return cont(0);
		                   });
		         },
		         cont);
		                                       },
		                                       cont);
		                             }]);
		                          return caml_exact_trampoline_cps_call
		                                  (force$0,
		                                   lhs_change,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (add_dependency,
		     result,
		     create$39(0, a),
		     function(a){return cont(result);});
		                                   });
		                         });
		               }
		               function filter_mapi$3
		               (opt, comparator, cutoff, data_equal, map, f, cont){
		                var instrumentation = opt ? opt[1] : no_instrumentation;
		                return caml_exact_trampoline_cps_call$0
		                        (with_comparator,
		                         comparator,
		                         map,
		                         function(comparator, cont){
		                          return caml_exact_trampoline_cps_call$8
		                                  (generic_mapi_with_comparator,
		                                   1,
		                                   instrumentation,
		                                   cutoff,
		                                   data_equal,
		                                   map,
		                                   comparator,
		                                   f,
		                                   cont);
		                         },
		                         cont);
		               }
		               function filter_map$6
		               (instrumentation, comparator, cutoff, data_equal, map, f, cont){
		                return caml_exact_trampoline_cps_call$7
		                        (filter_mapi$3,
		                         instrumentation,
		                         comparator,
		                         cutoff,
		                         data_equal,
		                         map,
		                         function(param, data, cont){
		                          return caml_exact_trampoline_cps_call(f, data, cont);
		                         },
		                         cont);
		               }
		               function keys$2(opt, comparator, map, cont){
		                var instrumentation = opt ? opt[1] : no_instrumentation;
		                return caml_exact_trampoline_cps_call$0
		                        (with_comparator,
		                         comparator,
		                         map,
		                         function(comparator, cont){
		                          function add(key, param, acc, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (add$4, acc, key, cont);
		                          }
		                          function remove(key, param, acc, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (remove$0, acc, key, cont);
		                          }
		                          function data_equal(a, param, cont){return cont(1);}
		                          return caml_exact_trampoline_cps_call$5
		                                  (unordered_fold,
		                                   instrumentation,
		                                   [0, data_equal],
		                                   0,
		                                   0,
		                                   0,
		                                   aOp,
		                                   map,
		                                   empty$8(comparator),
		                                   add,
		                                   remove,
		                                   cont);
		                         },
		                         cont);
		               }
		               function join_with_comparator
		               (instrumentation, map_incr, comparator, cont){
		                var
		                 incremental_state = map_incr[2],
		                 empty_map = empty$11(comparator),
		                 result_map = [0, empty_map],
		                 old_map_of_incrs = [0, empty_map],
		                 current_dependencies = [0, empty_map];
		                return caml_exact_trampoline_cps_call$0
		                        (create$40,
		                         incremental_state,
		                         0,
		                         function(param, cont){return cont(result_map[1]);},
		                         function(result){
		                          function add_subnode
		                          (current_dependencies, key, data_node, cont){
		                           var
		                            new_dep =
		                              create$39
		                               ([0,
		                                 function(data, cont){
		                                  return caml_exact_trampoline_cps_call$0
		  (set$3,
		   result_map[1],
		   key,
		   data,
		   function(a){result_map[1] = a; return cont(0);});
		                                 }],
		                                data_node);
		                           return caml_exact_trampoline_cps_call$1
		                                   (add_dependency,
		                                    result,
		                                    new_dep,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (set$3, current_dependencies, key, new_dep, cont);
		                                    });
		                          }
		                          function remove_subnode(current_dependencies, key, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id_exn,
		                                    current_dependencies,
		                                    key,
		                                    function(dep){
		                                     return caml_exact_trampoline_cps_call$1
		     (remove_dependency,
		      result,
		      dep,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (remove$2,
		                result_map[1],
		                key,
		                function(a){
		                 result_map[1] = a;
		                 return caml_exact_trampoline_cps_call$1
		                         (remove$2, current_dependencies, key, cont);
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$41,
		                                   map_incr,
		                                   function(map_of_incrs, cont){
		                                    return caml_exact_trampoline_cps_call
		    (instrumentation,
		     function(param, cont){
		      return caml_exact_trampoline_cps_call$3
		              (fold_symmetric_diff$1,
		               old_map_of_incrs[1],
		               map_of_incrs,
		               function(b, a, cont){return cont(b === a ? 1 : 0);},
		               current_dependencies[1],
		               function(current_dependencies, param, cont){
		                var diff = param[2], key = param[1], variant = diff[1];
		                if(847852583 === variant)
		                 return caml_exact_trampoline_cps_call$1
		                         (remove_subnode, current_dependencies, key, cont);
		                if(1013247643 <= variant){
		                 var data_node = diff[2][2];
		                 return caml_exact_trampoline_cps_call$1
		                         (remove_subnode,
		                          current_dependencies,
		                          key,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (add_subnode, a, key, data_node, cont);
		                          });
		                }
		                var data_node$0 = diff[2];
		                return caml_exact_trampoline_cps_call$0
		                        (add_subnode, current_dependencies, key, data_node$0, cont);
		               },
		               function(new_dependency_map){
		                current_dependencies[1] = new_dependency_map;
		                old_map_of_incrs[1] = map_of_incrs;
		                return cont(0);
		               });
		     },
		     cont);
		                                   },
		                                   function(lhs_change){
		                                    return caml_exact_trampoline_cps_call$1
		    (add_dependency,
		     result,
		     create$39(0, lhs_change),
		     function(a){return cont(result);});
		                                   });
		                         });
		               }
		               function join$6(opt, comparator, map, cont){
		                var instrumentation = opt ? opt[1] : no_instrumentation;
		                return caml_exact_trampoline_cps_call$0
		                        (with_comparator,
		                         comparator,
		                         map,
		                         function(comparator, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (join_with_comparator,
		                                   instrumentation,
		                                   map,
		                                   comparator,
		                                   cont);
		                         },
		                         cont);
		               }
		               function rekey
		               (opt, data_equal, map_incr, outer_comparator, f, cont){
		                var instrumentation = opt ? opt[1] : no_instrumentation;
		                function a(a, cont){return cont(a[1]);}
		                return caml_exact_trampoline_cps_call$5
		                        (unordered_fold,
		                         instrumentation,
		                         data_equal,
		                         [0,
		                          function(key, old_data, new_data, param, cont){
		                           var
		                            adds = param[2],
		                            output = param[1],
		                            prev_key = f(key, old_data),
		                            new_key = f(key, new_data);
		                           return caml_exact_trampoline_cps_call
		                                   (comparator$49,
		                                    output,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (a[1],
		      prev_key,
		      new_key,
		      function(a){
		       return a === 0
		               ? caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  output,
		                  new_key,
		                  new_data,
		                  function(a){return cont([0, a, adds]);})
		               : caml_exact_trampoline_cps_call$1
		                 (remove$2,
		                  output,
		                  prev_key,
		                  function(output){
		                   return cont([0, output, [0, [0, new_key, new_data], adds]]);
		                  });
		      });
		                                    });
		                          }],
		                         0,
		                         [0,
		                          function(param, cont){
		                           var adds = param[2], output = param[1];
		                           function a(t, output){
		                            if(! t) return cont([0, output, 0]);
		                            var l = t[2], a$0 = t[1], data = a$0[2], key = a$0[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (add_exn$0,
		                                     output,
		                                     key,
		                                     data,
		                                     function(init){
		                                      return caml_exact_trampoline_call2(a, l, init);
		                                     });
		                           }
		                           return a(adds, output);
		                          }],
		                         aOq,
		                         map_incr,
		                         [0, empty$11(outer_comparator), 0],
		                         function(key, data, param, cont){
		                          var
		                           adds = param[2],
		                           output = param[1],
		                           new_entry = [0, f(key, data), data];
		                          return cont([0, output, [0, new_entry, adds]]);
		                         },
		                         function(key, data, param, cont){
		                          var adds = param[2], output = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (remove$2,
		                                   output,
		                                   f(key, data),
		                                   function(a){return cont([0, a, adds]);});
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$41, b, a, cont);
		                         });
		               }
		               function index_by$0
		               (instrumentation$0,
		                inner_comparator,
		                data_equal,
		                map_incr,
		                outer_comparator,
		                index,
		                cont){
		                var
		                 instrumentation =
		                   instrumentation$0
		                    ? instrumentation$0[1]
		                    : no_instrumentation;
		                return caml_exact_trampoline_cps_call$0
		                        (with_comparator,
		                         inner_comparator,
		                         map_incr,
		                         function(inner_comparator, cont){
		                          return caml_exact_trampoline_cps_call$5
		                                  (unordered_fold,
		                                   instrumentation,
		                                   data_equal,
		                                   0,
		                                   0,
		                                   0,
		                                   aOr,
		                                   map_incr,
		                                   empty$11(outer_comparator),
		                                   function(inner_key, data, outer_map, cont){
		                                    return caml_exact_trampoline_cps_call
		    (index,
		     data,
		     function(match){
		      if(! match) return cont(outer_map);
		      var outer_key = match[1];
		      return caml_exact_trampoline_cps_call$0
		              (update$0,
		               outer_map,
		               outer_key,
		               function(param, cont){
		                if(! param)
		                 return cont(singleton$3(inner_comparator, inner_key)(data));
		                var inner_map = param[1];
		                return caml_exact_trampoline_cps_call$0
		                        (add_exn$0, inner_map, inner_key, data, cont);
		               },
		               cont);
		     });
		                                   },
		                                   function(inner_key, data, outer_map, cont){
		                                    return caml_exact_trampoline_cps_call
		    (index,
		     data,
		     function(match){
		      if(! match) return cont(outer_map);
		      var outer_key = match[1];
		      return caml_exact_trampoline_cps_call$0
		              (change$0,
		               outer_map,
		               outer_key,
		               function(param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call
		                         (failwith,
		                          "BUG: Hit supposedly impossible case in Incr_map.index_by",
		                          cont);
		                var inner_map = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (remove$2,
		                         inner_map,
		                         inner_key,
		                         function(inner_map){
		                          return caml_exact_trampoline_cps_call
		                                  (is_empty$5,
		                                   inner_map,
		                                   function(a){return a ? cont(0) : cont([0, inner_map]);});
		                         });
		               },
		               cont);
		     });
		                                   },
		                                   cont);
		                         },
		                         cont);
		               }
		               function exists$1
		               (instrumentation$0, data_equal, map_incr, f, cont){
		                function a(count, cont){return cont(count !== 0 ? 1 : 0);}
		                var
		                 instrumentation =
		                   instrumentation$0
		                    ? instrumentation$0[1]
		                    : no_instrumentation;
		                return caml_exact_trampoline_cps_call$5
		                        (unordered_fold,
		                         instrumentation,
		                         data_equal,
		                         0,
		                         0,
		                         0,
		                         aOs,
		                         map_incr,
		                         0,
		                         function(key, data, count, cont){
		                          return f(data) ? cont(count + 1 | 0) : cont(count);
		                         },
		                         function(key, data, count, cont){
		                          return f(data) ? cont(count - 1 | 0) : cont(count);
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$41, b, a, cont);
		                         });
		               }
		               function unordered_fold$0
		               (opt,
		                data_equal,
		                update,
		                specialized_initial,
		                finalize,
		                revert_to_init_when_empty,
		                map,
		                init,
		                add,
		                remove,
		                cont){
		                var instrumentation = opt ? opt[1] : no_instrumentation;
		                return caml_exact_trampoline_cps_call$5
		                        (unordered_fold,
		                         instrumentation,
		                         data_equal,
		                         update,
		                         specialized_initial,
		                         finalize,
		                         revert_to_init_when_empty,
		                         map,
		                         init,
		                         add,
		                         remove,
		                         cont);
		               }
		               function update_entry(entry, value, cont){
		                entry[1] = value;
		                return caml_exact_trampoline_cps_call
		                        (make_stale, entry[2], cont);
		               }
		               function slow_path_link_entry
		               (t, entry, key, is_now_observable, cont){
		                var a = caml_obj_tag(entry);
		                function b(entry){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_multi$0,
		                          t[2],
		                          key,
		                          function(current_entries){
		                           function a(t$0){
		                            if(t$0){
		                             var xs = t$0[2], x = t$0[1];
		                             if(entry !== x) return caml_exact_trampoline_call1(a, xs);
		                             var is_linked = 1;
		                            }
		                            else
		                             is_linked = 0;
		                            return is_linked === is_now_observable
		                                    ? cont(0)
		                                    : is_now_observable
		                                      ? caml_exact_trampoline_cps_call$0
		(update$0,
		 t[2],
		 key,
		 function(param, cont){
		  if(param){
		   var other_entries = param[1];
		   if(other_entries){
		    var other_entry = other_entries[1];
		    return caml_exact_trampoline_cps_call$1
		            (update_entry,
		             entry,
		             other_entry[1],
		             function(a){return cont([0, entry, other_entries]);});
		   }
		  }
		  return caml_exact_trampoline_cps_call$1
		          (find_packed_by_id,
		           t[1],
		           key,
		           function(a){
		            return caml_exact_trampoline_cps_call$1
		                    (update_entry,
		                     entry,
		                     a,
		                     function(a){return cont([0, entry, 0]);});
		           });
		 },
		 function(a){t[2] = a; return cont(0);})
		                                      : caml_exact_trampoline_cps_call$1
		(filter,
		 current_entries,
		 function(x, cont){return cont(1 - (entry === x));},
		 function(new_entries){
		  function a(a){t[2] = a; return cont(0);}
		  return is_empty(new_entries)
		          ? caml_exact_trampoline_cps_call$1(remove$2, t[2], key, a)
		          : caml_exact_trampoline_cps_call$0
		            (set$3, t[2], key, new_entries, a);
		 });
		                           }
		                           return a(current_entries);
		                          });
		                }
		                if(250 === a) return b(entry[1]);
		                if(246 !== a && 244 !== a) return b(entry);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, entry, b);
		               }
		               function find$6(t, key, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_multi$0,
		                         t[2],
		                         key,
		                         function(match){
		                          if(match){var entry = match[1]; return cont(entry[2]);}
		                          var t$0 = t[3], incremental_state = t$0[2];
		                          function f(a, cont){
		                           var entry = [];
		                           caml_update_dummy
		                            (entry,
		                             [246,
		                              function(param, cont){
		                               return caml_exact_trampoline_cps_call$0
		                                       (create$40,
		incremental_state,
		[0,
		 function(a, cont){
		  return caml_exact_trampoline_cps_call$2
		          (slow_path_link_entry, t, entry, key, a, cont);
		 }],
		function(param, cont){
		 return caml_exact_trampoline_cps_call
		         (force$0, entry, function(a){return cont(a[1]);});
		},
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (find_packed_by_id,
		          t[1],
		          key,
		          function(b){return cont([0, b, a]);});
		});
		                              }]);
		                           a = caml_obj_tag(entry);
		                           function b(entry){
		                            var a = create$39(0, t[3]);
		                            return caml_exact_trampoline_cps_call$1
		                                    (add_dependency,
		                                     entry[2],
		                                     a,
		                                     function(a){return cont(entry[2]);});
		                           }
		                           if(250 === a) return b(entry[1]);
		                           if(246 !== a && 244 !== a) return b(entry);
		                           return caml_exact_trampoline_cps_call
		                                   (force_lazy_block, entry, b);
		                          }
		                          var t$1 = t[4];
		                          return caml_exact_trampoline_cps_call$0
		                                  (within_scope, incremental_state, t$1, f, cont);
		                         });
		               }
		               unset();
		               caml_callback(record_until, [d]);
		               var id$35 = [0, -1];
		               function create$41(info){
		                id$35[1]++;
		                var uid = id$35[1], Tid = [248, "Tid", caml_fresh_oo_id()];
		                return [0, uid, [0, Tid], info];
		               }
		               function compare$158(a, param, cont){
		                var k1 = param[1], k0 = a[1];
		                return cont(caml_int_compare(k0[1], k1[1]));
		               }
		               var M$6 = k([0, compare$158]), empty$28 = M$6[1];
		               function create_key(param){return create$41(0);}
		               var map$43 = [0, empty$28];
		               function get$11(k, cont){
		                var s = map$43[1];
		                caml_push_trap
		                 (function(exn){
		                   if(exn === Not_found) return cont(0);
		                   var
		                    raise = caml_pop_trap(),
		                    exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                   return raise(exn$0);
		                  });
		                return caml_exact_trampoline_cps_call$1
		                        (M$6[17],
		                         [0, k],
		                         s,
		                         function(a){
		                          var
		                           v = a[2],
		                           k$0 = a[1],
		                           s = k$0[2],
		                           r = k[2],
		                           a = r[1] === s[1] ? aOt : 0,
		                           a = a ? [0, v] : 0;
		                          caml_pop_trap();
		                          return cont(a);
		                         });
		               }
		               function with_binding(k, v, cb, cont){
		                var m = map$43[1];
		                return caml_exact_trampoline_cps_call$0
		                        (M$6[2],
		                         [0, k],
		                         [0, k, v],
		                         m,
		                         function(new_context){
		                          function cb$0(context, cont){
		                           return caml_trampoline_cps_call2(cb, 0, cont);
		                          }
		                          var old = map$43[1];
		                          map$43[1] = new_context;
		                          return caml_exact_trampoline_cps_call$1
		                                  (protect, function(param){map$43[1] = old;}, cb$0, cont);
		                         });
		               }
		               var
		                rstate = caml_callback(make_self_init, [dummy]),
		                current_span = create_key(),
		                d = "component",
		                component =
		                  def
		                   (aOu,
		                    d,
		                    function(ppf, v, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (pp_print_string,
		                              ppf,
		                              v,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (pp_print_char,
		ppf,
		58,
		function(a){return cont(pp_v1(ppf));});
		                              });
		                    }),
		                span_event =
		                  def
		                   (aOx,
		                    "trace.event",
		                    function(fmt, param, cont){
		                     if(0 === param[0]){
		                      var id = param[1][2];
		                      return caml_exact_trampoline_cps_call
		                              (fprintf$0(fmt),
		                               aOv,
		                               function(a){
		                                return caml_trampoline_cps_call3(a, pp$28, id, cont);
		                               });
		                     }
		                     var id$0 = param[1][2];
		                     return caml_exact_trampoline_cps_call
		                             (fprintf$0(fmt),
		                              aOw,
		                              function(a){
		                               return caml_trampoline_cps_call3(a, pp$28, id$0, cont);
		                              });
		                    });
		               function symbol_bind$17(v, f, cont){
		                return caml_exact_trampoline_cps_call(f, v, cont);
		               }
		               function return$27(v){return v;}
		               function catch$1(f, catch$, cont){
		                caml_push_trap
		                 (function(exn){
		                   return caml_exact_trampoline_cps_call(catch$, exn, cont);
		                  });
		                return caml_exact_trampoline_cps_call
		                        (f, dummy, function(a){caml_pop_trap(); return cont(a);});
		               }
		               var context_tags = create_key();
		               getenv_opt("STERE_LOG_SCOPES");
		               var
		                V$5 = [248, "Crdt__Schemas_library.V", caml_fresh_oo_id()],
		                src$3 = create$18(0, "CRDT"),
		                bRw = src_log(src$3)[1];
		               function pp_indent(fmt, n, cont){
		                function b(){return cont(0);}
		                function a(for$){
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          cst$10,
		                          function(c){
		                           c = for$ + 1 | 0;
		                           return n !== for$ ? caml_exact_trampoline_call1(a, c) : b();
		                          });
		                }
		                return n < 1 ? b() : a(1);
		               }
		               function msg$1(level, component$0, cont){
		                function a(msg, cont){
		                 return cont
		                         (return$27
		                           (function(msgf, cont){
		                             function msgf$0(m, cont){
		                              function m$0(header, tags, fmt, cont){
		                               return caml_exact_trampoline_cps_call
		                                       (get$11,
		current_span,
		function(match){
		 if(match)
		  var depth = match[1][1], depth$0 = depth + 1 | 0;
		 else
		  depth$0 = 0;
		 function a(tags){
		  return caml_exact_trampoline_cps_call
		          (get$11,
		           context_tags,
		           function(match){
		            function a(tags){
		             return caml_trampoline_cps_call6
		                     (m,
		                      header,
		                      tags,
		                      symbol$0(aOz, symbol$0(fmt, aOy)),
		                      pp_indent,
		                      depth$0,
		                      cont);
		            }
		            if(! match) return a(tags);
		            var context_tags = match[1];
		            if(! context_tags) return a(tags);
		            var accu = value(tags, empty$12);
		            function b(accu, l$0){
		             if(! l$0) return a([0, accu]);
		             var l = l$0[2], a$0 = l$0[1], value = a$0[2];
		             return caml_exact_trampoline_cps_call$0
		                     (add$7,
		                      a$0[1],
		                      value,
		                      accu,
		                      function(accu){
		                       return caml_exact_trampoline_call2(b, accu, l);
		                      });
		            }
		            return b(accu, context_tags);
		           });
		 }
		 if(! component$0) return a(tags);
		 var component$1 = component$0[1];
		 return caml_exact_trampoline_cps_call$0
		         (add$7,
		          component,
		          component$1,
		          value(tags, empty$12),
		          function(b){return a([0, b]);});
		});
		                              }
		                              return caml_trampoline_cps_call2(msgf, m$0, cont);
		                             }
		                             return caml_trampoline_cps_call2(msg, msgf$0, cont);
		                            }));
		                }
		                return caml_trampoline_cps_call2
		                        (bRw,
		                         level,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$17, b, a, cont);
		                         });
		               }
		               function debug$2(component, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (msg$1, 4, component, cont);
		               }
		               function err$0(component, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (msg$1, 1, component, cont);
		               }
		               function warn$1(component, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (msg$1, 2, component, cont);
		               }
		               function with_msg(level, component, cont){
		                function a(msg, cont){
		                 return cont
		                         (return$27
		                           (function(msgf, f, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (get$11,
		                                      current_span,
		                                      function(parent){
		                                       if(parent)
		var
		 match = parent[1],
		 trace = match[4],
		 depth = match[1],
		 trace$0 = trace,
		 depth$0 = depth + 1 | 0;
		                                       else
		var
		 trace$1 = v4_random(rstate),
		 trace$0 = trace$1,
		 depth$0 = 0;
		                                       var span = [0, depth$0, v4_random(rstate), parent, trace$0];
		                                       function send_end(status, cont){
		return caml_trampoline_cps_call2
		        (msg,
		         function(m, cont){
		          return caml_trampoline_cps_call2
		                  (msgf,
		                   function(header, tags, fmt, cont){
		                    return caml_exact_trampoline_cps_call$0
		                            (add$7,
		                             span_event,
		                             [1, span, status],
		                             value(tags, empty$12),
		                             function(tags){
		                              return caml_trampoline_cps_call4
		                                      (m, header, [0, tags], fmt, cont);
		                             });
		                   },
		                   cont);
		         },
		         cont);
		                                       }
		                                       function a(param, cont){
		function try$(param, cont){
		 function a(result, cont){
		  function a(param, cont){return cont(return$27(result));}
		  return caml_exact_trampoline_cps_call
		          (send_end,
		           aOA,
		           function(b){
		            return caml_exact_trampoline_cps_call$1
		                    (symbol_bind$17, b, a, cont);
		           });
		 }
		 return caml_exact_trampoline_cps_call$0
		         (with_binding,
		          current_span,
		          span,
		          f,
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (symbol_bind$17, b, a, cont);
		          });
		}
		function catch$(exn, cont){
		 function a(a, cont){
		  a = caml_pop_trap();
		  var exn$0 = caml_maybe_attach_backtrace(exn, 1);
		  return a(exn$0);
		 }
		 return caml_exact_trampoline_cps_call
		         (to_string$0,
		          exn,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (send_end,
		                    [1, b],
		                    function(b){
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol_bind$17, b, a, cont);
		                    });
		          });
		}
		return caml_exact_trampoline_cps_call$1
		        (catch$1, try$, catch$, cont);
		                                       }
		                                       return caml_trampoline_cps_call2
		       (msg,
		        function(m, cont){
		         return caml_trampoline_cps_call2
		                 (msgf,
		                  function(header, tags, fmt, cont){
		                   return caml_exact_trampoline_cps_call$0
		                           (add$7,
		                            span_event,
		                            [0, span],
		                            value(tags, empty$12),
		                            function(tags){
		                             return caml_trampoline_cps_call4
		                                     (m, header, [0, tags], fmt, cont);
		                            });
		                  },
		                  cont);
		        },
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol_bind$17, b, a, cont);
		        });
		                                      });
		                            }));
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (msg$1,
		                         level,
		                         component,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$17, b, a, cont);
		                         });
		               }
		               function with_debug(component, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (with_msg, 4, component, cont);
		               }
		               function schema_versioned$358(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    aOB,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               caml_callback(M$2, [[0, comparator$2, schema_versioned$358]]);
		               var letrec_function_context$655 = [];
		               function compare$159(lhs, rhs, cont){
		                var a = rhs[1], b = lhs[1];
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$655[2],
		                         0,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(x){
		                                    return 0 === x
		    ? caml_trampoline_cps_call3
		      (letrec_function_context$655[1], lhs[2], rhs[2], cont)
		    : cont(x);
		                                   });
		                         });
		               }
		               function _0$53(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$655, [0, compare$4, _0$53]);
		               var letrec_function_context$656 = [];
		               function schema_versioned$359(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$656[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aOC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$656[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$656[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$656[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$358,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var replica = param[2][1], timestamp = param[1];
		   return cont([0, timestamp, replica]);
		  },
		  function(param, cont){
		   var replica = param[2], timestamp = param[1];
		   return cont([0, timestamp, [0, replica, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, int_schema], 0, 0],
		   [0, [0, 0, 0, 0, 0, cst_replica, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$656[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$656[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$627 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$656, [0, schematic_cache$627]);
		               caml_callback
		                (schema_versioned$359,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$360(version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$359,
		                         version,
		                         function(schema){
		                          function f(coding, cont){
		                           if(! coding) return cont(schema[3]);
		                           function encode(param, cont){
		                            var replica = param[2], timestamp = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$124,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (a, replica, timestamp, cont);
		                                     });
		                           }
		                           function decode(repr, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (rsplit2,
		                                     repr,
		                                     58,
		                                     function(a){
		                                      if(! a)
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$126,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a, repr, function(a){return cont([1, a]);});
		        });
		                                      a = a[1];
		                                      var
		                                       timestamp = a[2],
		                                       replica = a[1],
		                                       a = int_of_string_opt(timestamp);
		                                      if(! a)
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$125,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a, repr, function(a){return cont([1, a]);});
		        });
		                                      var timestamp$0 = a[1];
		                                      return cont([0, [0, timestamp$0, replica]]);
		                                     });
		                           }
		                           return cont([4, decode, encode, descriptor$1]);
		                          }
		                          return cont([0, schema[1], schema[2], [1, f], schema[4]]);
		                         });
		               }
		               caml_callback
		                (schema_versioned$360,
		                 [function(param, cont){return cont(0);}]);
		               function _10$3(f, param, cont){
		                var replica = param[2], timestamp = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         aOD,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, replica, timestamp, cont);
		                         });
		               }
		               function sexp_of_t$129(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_to_string, _10$3, t, function(a){return cont([0, a]);});
		               }
		               var
		                include$131 = Make$2([0, compare$159, sexp_of_t$129]),
		                symbol$217 = include$131[1],
		                symbol$218 = include$131[2],
		                symbol$219 = include$131[3],
		                symbol$220 = include$131[5],
		                equal$228 = include$131[7],
		                compare$160 = include$131[8],
		                comparator$55 = include$131[16],
		                By$20 =
		                  caml_callback
		                   (M$2, [[0, comparator$55, schema_versioned$360]]),
		                Set$3 =
		                  caml_callback
		                   (M$3, [[0, comparator$55, schema_versioned$360]]);
		               function timestamped_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    function descriptor(schematic_param_a_schema_versi, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_value,
		  0,
		  2,
		  [0, schematic_param_a_schema_versi],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(b){
		       return cont
		               ([7,
		                 function(param, cont){
		                  var value = param[2][1], timestamp = param[1];
		                  return cont([0, timestamp, value]);
		                 },
		                 function(param, cont){
		                  var value = param[2], timestamp = param[1];
		                  return cont([0, timestamp, [0, value, 0]]);
		                 },
		                 [0, [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, b], 0, 0], a]]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$209[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_a$0,
		 schematic_param_a_schema_versi,
		 function(schematic_param_a_schema_versi, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_a_schema_versi,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_a_schema_versi,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$657 = [];
		               function compare$161(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$657[2],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          if(0 !== x) return cont(x);
		                          var a = rhs[2], b = lhs[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$657[1],
		                                   0,
		                                   function(c){
		                                    return caml_trampoline_cps_call3(c, b, a, cont);
		                                   });
		                         });
		               }
		               function _1$52(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$657, [0, _1$52, compare$4]);
		               function pp$123(f, param, cont){
		                var timestamp = param[2], replica = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         aOE,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, replica, timestamp, cont);
		                         });
		               }
		               function schema_versioned$361(version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$360,
		                         version,
		                         function(a){
		                          return cont
		                                  (map$14
		                                    (function(param, cont){
		                                      var replica = param[2], timestamp = param[1];
		                                      return cont([0, [0, replica, timestamp]]);
		                                     },
		                                     function(param, cont){
		                                      var timestamp = param[2], replica = param[1];
		                                      return cont([0, timestamp, replica]);
		                                     },
		                                     a));
		                         });
		               }
		               caml_callback
		                (schema_versioned$361,
		                 [function(param, cont){return cont(0);}]);
		               function sexp_of_t$130(param, cont){
		                var timestamp = param[2], replica = param[1];
		                return cont
		                        ([1, [0, [0, replica], [0, [0, "" + timestamp], 0]]]);
		               }
		               var
		                include$132 = Make$2([0, compare$161, sexp_of_t$130]),
		                symbol$221 = include$132[1],
		                symbol$222 = include$132[2],
		                symbol$223 = include$132[3],
		                symbol$224 = include$132[4],
		                symbol$225 = include$132[5],
		                symbol$226 = include$132[6],
		                compare$162 = include$132[8],
		                comparator$56 = include$132[16];
		               caml_callback
		                (M_printable,
		                 [[0, pp$123, comparator$56, schema_versioned$361]]);
		               var
		                Set$4 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$123, comparator$56, schema_versioned$361]]);
		               function range$2(start, n, cont){
		                return caml_trampoline_cps_call3
		                        (map$11,
		                         range$0(0, 0, 0, start[2], start[2] + n | 0),
		                         function(timestamp, cont){
		                          return cont([0, start[1], timestamp]);
		                         },
		                         cont);
		               }
		               function symbol$227(id, n){return [0, id[1], id[2] + n | 0];}
		               function Monadic$0(Operation){
		                function v(op, cont){return cont([2, op]);}
		                function const$(param, cont){
		                 if(1 !== param[0]) return cont(0);
		                 var v = param[1];
		                 return cont([0, v]);
		                }
		                function return$(v, cont){return cont([1, v]);}
		                function bind(v, f, cont){return cont([0, v, f]);}
		                var
		                 include = Make([0, bind, return$, -349054340]),
		                 symbol_bind = include[1],
		                 symbol_map = include[2],
		                 Monad_infix = include[3],
		                 bind$0 = include[4],
		                 return$0 = include[5],
		                 map = include[6],
		                 join = include[7],
		                 ignore_m = include[8],
		                 Let_syntax = include[11],
		                 a = include[9],
		                 b = include[10];
		                function all_unit(list, cont){
		                 return list
		                         ? caml_exact_trampoline_cps_call$1
		                           (filter,
		                            list,
		                            function(param, cont){
		                             return 1 === param[0] ? cont(0) : cont(1);
		                            },
		                            function(a){
		                             return caml_exact_trampoline_cps_call(b, a, cont);
		                            })
		                         : cont(aOF);
		                }
		                function all(list, cont){
		                 return list
		                         ? caml_exact_trampoline_cps_call(a, list, cont)
		                         : cont(aOG);
		                }
		                function Apply(Apply, cont){
		                 var letrec_function_context = [];
		                 function delta_schema_versioned(schematic_version, cont){
		                  return caml_trampoline_cps_call2
		                          (schematic_version,
		                           V$5,
		                           function(schematic_schema_version){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     letrec_function_context[1][1],
		                                     schematic_schema_version,
		                                     function(match){
		                                      function a(descriptor){
		                                       return cont([0, 0, 0, descriptor, 0]);
		                                      }
		                                      if(! match)
		                                       return caml_exact_trampoline_cps_call
		       (fixpoint,
		        function(schematic_self, cont){
		         return caml_exact_trampoline_cps_call$1
		                 (find_packed_by_id,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  function(match){
		                   if(! match)
		                    return caml_exact_trampoline_cps_call$0
		                            (set$3,
		                             letrec_function_context[1][1],
		                             schematic_schema_version,
		                             schematic_self,
		                             function(a){
		                              letrec_function_context[1][1] = a;
		                              return caml_trampoline_cps_call2
		                                      (Apply[1][1],
		                                       schematic_version,
		                                       function(a){
		var res = [3, a];
		return caml_exact_trampoline_cps_call$0
		        (set$3,
		         letrec_function_context[1][1],
		         schematic_schema_version,
		         res,
		         function(a){
		          letrec_function_context[1][1] = a;
		          return cont(res);
		         });
		                                       });
		                             });
		                   var schema = match[1];
		                   return cont(schema);
		                  });
		        },
		        a);
		                                      var schema = match[1];
		                                      return a(schema);
		                                     });
		                           });
		                 }
		                 var schematic_cache = [0, empty$11([0, comparator$9])];
		                 caml_update_dummy
		                  (letrec_function_context, [0, schematic_cache]);
		                 return caml_exact_trampoline_cps_call
		                         (delta_schema_versioned,
		                          function(param, cont){return cont(0);},
		                          function(delta_schema){
		                           function apply_delta(replica, state, deltas, cont){
		                            return caml_trampoline_cps_call2
		                                    (Apply[2],
		                                     replica,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$0
		      (fold_left$1, deltas, state, a, cont);
		                                     });
		                           }
		                           function apply(id, state, operation, cont){
		                            function apply_local(deltas, state, operation, cont){
		                             function a(deltas, state, operation){
		                              switch(operation[0]){
		                                case 0:
		                                 var f = operation[2], v = operation[1];
		                                 return caml_exact_trampoline_cps_call$0
		 (apply_local,
		  deltas,
		  state,
		  v,
		  function(match){
		   var state = match[3], deltas = match[2], result = match[1];
		   return caml_trampoline_cps_call2
		           (f,
		            result,
		            function(operation){
		             return caml_exact_trampoline_call3
		                     (a, deltas, state, operation);
		            });
		  });
		                                case 1:
		                                 var v$0 = operation[1];
		                                 return cont([0, v$0, deltas, state]);
		                                default:
		                                 var operation$0 = operation[1];
		                                 return caml_trampoline_cps_call4
		 (Apply[3],
		  id,
		  state,
		  operation$0,
		  function(a){
		   var state = a[3], delta = a[2], result = a[1];
		   if(delta)
		    var x = delta[1], a = [0, x, deltas];
		   else
		    a = deltas;
		   return cont([0, result, a, state]);
		  });
		                              }
		                             }
		                             return a(deltas, state, operation);
		                            }
		                            return caml_exact_trampoline_cps_call$0
		                                    (apply_local,
		                                     0,
		                                     state,
		                                     operation,
		                                     function(match){
		                                      var state = match[3], deltas = match[2], result = match[1];
		                                      function a(deltas){return cont([0, result, deltas, state]);}
		                                      return deltas
		      ? caml_exact_trampoline_cps_call
		        (of_rev_keys, deltas, function(b){return a([0, b]);})
		      : a(0);
		                                     });
		                           }
		                           return cont
		                                   ([0,
		                                     delta_schema_versioned,
		                                     delta_schema,
		                                     apply_delta,
		                                     apply]);
		                          });
		                }
		                return [0,
		                        v,
		                        const$,
		                        symbol_bind,
		                        symbol_map,
		                        Monad_infix,
		                        bind$0,
		                        return$0,
		                        map,
		                        join,
		                        ignore_m,
		                        Let_syntax,
		                        all_unit,
		                        all,
		                        Apply];
		               }
		               var cst_Element = "Element", cst_left = "left";
		               function schema_versioned$362(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_delta_schema_v,
		                                    schematic_param_inits_schema_v,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_delta_schema_v,
		                                     schematic_param_inits_schema_v,
		                                     cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_value,
		  0,
		  2,
		  [0, schematic_param_inits_schema_v],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$361,
		      schematic_version,
		      function(c){
		       var
		        default$ = match$210[1],
		        b =
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_left,
		            0,
		            [0, default$],
		            [0, bool_schema],
		            0,
		            0],
		           [0, [0, 0, 0, 0, 0, cst_parent, 0, 2, [0, c], 0, 0], a]];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$361,
		                schematic_version,
		                function(d){
		                 var
		                  a =
		                    [0,
		                     [0,
		                      function(param, cont){
		                       var
		                        f3 = param[4],
		                        f2 = param[3],
		                        f1 = param[2],
		                        f0 = param[1];
		                       return cont([2, f0, f1, f2, f3]);
		                      },
		                      function(param, cont){
		                       if(2 !== param[0]) return cont(0);
		                       var
		                        f3 = param[4],
		                        f2 = param[3],
		                        f1 = param[2],
		                        f0 = param[1];
		                       return cont([0, [0, f0, f1, f2, f3]]);
		                      },
		                      1,
		                      aOH,
		                      cst_insert,
		                      cst_Insert,
		                      [0,
		                       0,
		                       0,
		                       [7,
		                        function(param, cont){
		                         var
		                          a = param[2],
		                          b = a[2],
		                          value = b[2][1],
		                          parent = b[1],
		                          left = a[1],
		                          id = param[1];
		                         return cont([0, id, left, parent, value]);
		                        },
		                        function(param, cont){
		                         var
		                          value = param[4],
		                          parent = param[3],
		                          left = param[2],
		                          id = param[1];
		                         return cont([0, id, [0, left, [0, parent, [0, value, 0]]]]);
		                        },
		                        [0, [0, 0, 0, 0, 0, cst_insert, 0, 2, [0, d], 0, 0], b]],
		                       0],
		                      0],
		                     0],
		                  c =
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_delta,
		                      0,
		                      2,
		                      [0, schematic_param_delta_schema_v],
		                      0,
		                      0],
		                     0];
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$361,
		                          schematic_version,
		                          function(d){
		                           var
		                            b =
		                              [0,
		                               [0,
		                                function(param, cont){
		                                 var f1 = param[2], f0 = param[1];
		                                 return cont([1, f0, f1]);
		                                },
		                                function(param, cont){
		                                 if(1 !== param[0]) return cont(0);
		                                 var f1 = param[2], f0 = param[1];
		                                 return cont([0, [0, f0, f1]]);
		                                },
		                                1,
		                                aOI,
		                                cst_element,
		                                cst_Element,
		                                [0,
		                                 0,
		                                 0,
		                                 [7,
		                                  function(param, cont){
		                                   var delta = param[2][1], id = param[1];
		                                   return cont([0, id, delta]);
		                                  },
		                                  function(param, cont){
		                                   var delta = param[2], id = param[1];
		                                   return cont([0, id, [0, delta, 0]]);
		                                  },
		                                  [0, [0, 0, 0, 0, 0, cst_element, 0, 2, [0, d], 0, 0], c]],
		                                 0],
		                                0],
		                               a];
		                           return caml_exact_trampoline_cps_call
		                                   (Set$4[70],
		                                    schematic_version,
		                                    function(a){
		                                     return cont
		     ([11,
		       0,
		       [0,
		        [0,
		         function(f0, cont){return cont([0, f0]);},
		         function(param, cont){
		          if(0 !== param[0]) return cont(0);
		          var f0 = param[1];
		          return cont([0, f0]);
		         },
		         1,
		         aOJ,
		         cst_delete,
		         cst_Delete,
		         [0,
		          0,
		          0,
		          [7,
		           function(param, cont){var ids = param[1]; return cont(ids);},
		           function(ids, cont){return cont([0, ids, 0]);},
		           [0, [0, 0, 0, 0, 0, cst_delete, 0, 2, [0, a], 0, 0], 0]],
		          0],
		         0],
		        b],
		       0]);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$211[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_delta,
		 schematic_param_delta_schema_v,
		 function(schematic_param_delta_schema_v, cont){
		  return cont
		          ([1,
		            "inits",
		            schematic_param_inits_schema_v,
		            function(schematic_param_inits_schema_v, cont){
		             return caml_exact_trampoline_cps_call$1
		                     (descriptor,
		                      schematic_param_delta_schema_v,
		                      schematic_param_inits_schema_v,
		                      function(a){return cont([0, schematic_schema_id, a]);});
		            }]);
		 }]];
		                                    return caml_exact_trampoline_cps_call$1
		    (descriptor,
		     schematic_param_delta_schema_v,
		     schematic_param_inits_schema_v,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                cst_right = "right",
		                null$5 = cst$1,
		                root_id = [0, null$5, -1];
		               function Make$22(Element, Element_inits, Element_states, cont){
		                var
		                 b = Element_states[7],
		                 a = Element_states[4],
		                 letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, aOK, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$361,
		                                      schematic_version,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$361,
		        schematic_version,
		        function(b){
		         var
		          res =
		            [10,
		             function(param, cont){
		              var e1 = param[2][1], e0 = param[1];
		              return cont([0, e0, e1]);
		             },
		             function(param, cont){
		              var e1 = param[2], e0 = param[1];
		              return cont([0, e0, [0, e1, 0]]);
		             },
		             [0, b, a]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var
		                 c = Element_states[3],
		                 d = Element_states[1],
		                 schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var letrec_function_context = [];
		                          function pp(fmt, param, cont){
		                           var a1 = param[2], a0 = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aOL,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[2],
		      fmt,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                a0,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aOM,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context[1],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      a1,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), aON, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          caml_update_dummy
		                           (letrec_function_context, [0, pp$123, pp$123]);
		                          function compare(a, param, cont){
		                           var
		                            end2 = param[2],
		                            start2 = param[1],
		                            end1 = a[2],
		                            start1 = a[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$222,
		                                    start2,
		                                    start1,
		                                    function(b){
		                                     function a(){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$222,
		       start1,
		       start2,
		       function(b){
		        function a(){
		         return caml_exact_trampoline_cps_call$1
		                 (symbol$225,
		                  end1,
		                  start2,
		                  function(a){
		                   return a
		                           ? cont(-1)
		                           : caml_exact_trampoline_cps_call$1
		                             (symbol$224,
		                              start1,
		                              end2,
		                              function(b){
		                               if(b) return cont(1);
		                               function a(m, cont){
		                                return caml_trampoline_cps_call12
		(m,
		 0,
		 0,
		 aOO,
		 pp$123,
		 start1,
		 pp$123,
		 end1,
		 pp$123,
		 start2,
		 pp$123,
		 end2,
		 cont);
		                               }
		                               return caml_exact_trampoline_cps_call
		                                       (err$0,
		0,
		function(b){
		 return caml_trampoline_cps_call2
		         (b,
		          a,
		          function(match){
		           return caml_trampoline_cps_call3
		                   (compare$162,
		                    start1,
		                    start2,
		                    function(c){
		                     return 0 === c
		                             ? caml_trampoline_cps_call3(compare$162, end1, end2, cont)
		                             : cont(c);
		                    });
		          });
		});
		                              });
		                  });
		        }
		        return b
		                ? caml_exact_trampoline_cps_call$1
		                  (symbol$222,
		                   end2,
		                   end1,
		                   function(b){return b ? cont(0) : a();})
		                : a();
		       });
		                                     }
		                                     return b
		     ? caml_exact_trampoline_cps_call$1
		       (symbol$222,
		        end1,
		        end2,
		        function(b){return b ? cont(0) : a();})
		     : a();
		                                    });
		                          }
		                          function sexp_of_t(param, cont){
		                           var end = param[2], start = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_t$130,
		                                    end,
		                                    function(b){
		                                     var a = [0, b, 0];
		                                     return caml_exact_trampoline_cps_call
		     (sexp_of_t$130,
		      start,
		      function(b){return cont([1, [0, b, a]]);});
		                                    });
		                          }
		                          var
		                           include = Make$2([0, compare, sexp_of_t]),
		                           compare$0 = include[8],
		                           comparator = include[16];
		                          return caml_exact_trampoline_cps_call
		                                  (M_printable,
		                                   [0, pp, comparator, schema_versioned],
		                                   function(Map){
		                                    var e = [];
		                                    function node_schema_versioned(schematic_version, cont){
		                                     return caml_trampoline_cps_call2
		     (schematic_version,
		      V$5,
		      function(schematic_schema_version){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                e[1][1],
		                schematic_schema_version,
		                function(match){
		                 function a(descriptor){
		                  return cont([0, aOP, 0, descriptor, 0]);
		                 }
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (fixpoint,
		                           function(schematic_self, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     e[1][1],
		                                     schematic_schema_version,
		                                     function(match){
		                                      if(! match)
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        e[1][1],
		        schematic_schema_version,
		        schematic_self,
		        function(a){
		         e[1][1] = a;
		         return caml_exact_trampoline_cps_call
		                 (Set$4[70],
		                  schematic_version,
		                  function(b){
		                   var
		                    a = [0, [0, 0, 0, 0, 0, cst_right, 0, 2, [0, b], 0, 0], 0];
		                   return caml_exact_trampoline_cps_call
		                           (Set$4[70],
		                            schematic_version,
		                            function(c){
		                             var
		                              b =
		                                [0,
		                                 [0, 0, 0, 0, 0, "tombstone", 0, 2, [0, bool_schema], 0, 0],
		                                 [0, [0, 0, 0, 0, 0, cst_left, 0, 2, [0, c], 0, 0], a]];
		                             return caml_exact_trampoline_cps_call
		                                     (d,
		                                      schematic_version,
		                                      function(c){
		                                       var
		a = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], b];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$361,
		        schematic_version,
		        function(b){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               b = a[2],
		               c = b[2],
		               right = c[2][1],
		               left = c[1],
		               tombstone = b[1],
		               value = a[1],
		               id = param[1];
		              return cont([0, id, value, tombstone, left, right]);
		             },
		             function(param, cont){
		              var
		               right = param[5],
		               left = param[4],
		               tombstone = param[3],
		               value = param[2],
		               id = param[1];
		              return cont
		                      ([0,
		                        id,
		                        [0, value, [0, tombstone, [0, left, [0, right, 0]]]]]);
		             },
		             [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  e[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){e[1][1] = a; return cont(res);});
		        });
		                                      });
		                            });
		                  });
		        });
		                                      var schema = match[1];
		                                      return cont(schema);
		                                     });
		                           },
		                           a);
		                 var schema = match[1];
		                 return a(schema);
		                });
		      });
		                                    }
		                                    var cst_trees = "trees", letrec_function_context = [];
		                                    function schema_versioned(schematic_version, cont){
		                                     return caml_trampoline_cps_call2
		     (schematic_version,
		      V$5,
		      function(schematic_schema_version){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context[1][1],
		                schematic_schema_version,
		                function(match){
		                 function a(descriptor){
		                  return cont([0, aOQ, 0, descriptor, 0]);
		                 }
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (fixpoint,
		                           function(schematic_self, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     letrec_function_context[1][1],
		                                     schematic_schema_version,
		                                     function(match){
		                                      if(! match)
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        schematic_self,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return caml_exact_trampoline_cps_call
		                 (node_schema_versioned,
		                  schematic_version,
		                  function(a){
		                   return caml_trampoline_cps_call3
		                           (Map[109],
		                            schematic_version,
		                            a,
		                            function(b){
		                             var
		                              a = [0, [0, 0, 0, 0, 0, cst_trees, 0, 2, [0, b], 0, 0], 0];
		                             return caml_exact_trampoline_cps_call
		                                     (Set$4[70],
		                                      schematic_version,
		                                      function(b){
		                                       var
		res =
		  [7,
		   function(param, cont){
		    var trees = param[2][1], roots = param[1];
		    return cont([0, roots, trees]);
		   },
		   function(param, cont){
		    var trees = param[2], roots = param[1];
		    return cont([0, roots, [0, trees, 0]]);
		   },
		   [0, [0, 0, 0, 0, 0, "roots", 0, 2, [0, b], 0, 0], a]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      var schema = match[1];
		                                      return cont(schema);
		                                     });
		                           },
		                           a);
		                 var schema = match[1];
		                 return a(schema);
		                });
		      });
		                                    }
		                                    var schematic_cache = [0, empty$11([0, comparator$9])];
		                                    caml_update_dummy(e, [0, schematic_cache]);
		                                    var schematic_cache$0 = [0, empty$11([0, comparator$9])];
		                                    caml_update_dummy
		                                     (letrec_function_context, [0, schematic_cache$0]);
		                                    return caml_exact_trampoline_cps_call
		    (node_schema_versioned,
		     function(param, cont){return cont(0);},
		     function(node_schema){
		      return caml_exact_trampoline_cps_call
		              (schema_versioned,
		               function(param, cont){return cont(0);},
		               function(schema){
		                function range(param, cont){
		                 var value = param[2], id = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (a,
		                          value,
		                          function(a){
		                           var len = a - 1 | 0;
		                           return cont([0, id, symbol$227(id, len)]);
		                          });
		                }
		                function find(trees, id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id, trees, [0, id, id], cont);
		                }
		                function set(data, cont){
		                 return caml_exact_trampoline_cps_call
		                         (range,
		                          data,
		                          function(a){
		                           return cont
		                                   (function(b, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (set$3, b, a, data, cont);
		                                    });
		                          });
		                }
		                function d(opt, param, cont){
		                 var
		                  tombstones = opt ? opt[1] : 1,
		                  trees = param[2],
		                  roots = param[1],
		                  Yield = [248, cst_Yield, caml_fresh_oo_id()];
		                 function traverse_roots(param, cont){
		                  function traverse_ids(id_set, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (iter$3,
		                            id_set,
		                            function(child_id, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (find,
		                                      trees,
		                                      child_id,
		                                      function(match){
		                                       if(match){
		var tree = match[1];
		return caml_exact_trampoline_cps_call
		        (traverse_tree, tree, cont);
		                                       }
		                                       function a(m, cont){
		return caml_trampoline_cps_call6
		        (m, 0, 0, aOR, pp$123, child_id, cont);
		                                       }
		                                       return caml_exact_trampoline_cps_call
		       (err$0,
		        0,
		        function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                      });
		                            },
		                            cont);
		                  }
		                  function traverse_tree(tree, cont){
		                   return caml_exact_trampoline_cps_call
		                           (traverse_ids,
		                            tree[4],
		                            function(match){
		                             var tombstones$0 = tombstones || 1 - tree[3];
		                             function a(a){
		                              return caml_exact_trampoline_cps_call
		                                      (traverse_ids, tree[5], cont);
		                             }
		                             return tombstones$0
		                                     ? caml_perform_effect([0, Yield, tree], a)
		                                     : a();
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (iter$3,
		                           roots,
		                           function(root_id, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find,
		                                     trees,
		                                     root_id,
		                                     function(match){
		                                      if(match){
		                                       var tree = match[1];
		                                       return caml_exact_trampoline_cps_call
		       (traverse_tree, tree, cont);
		                                      }
		                                      function a(m, cont){
		                                       return caml_trampoline_cps_call6
		       (m, 0, 0, aOS, pp$123, root_id, cont);
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (err$0,
		       0,
		       function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                     });
		                           },
		                           cont);
		                 }
		                 function a(param, cont){
		                  var traverse = param[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (continue_with,
		                           traverse,
		                           0,
		                           [0,
		                            function(param, cont){return cont(0);},
		                            function(b, a){
		                             a = caml_pop_trap();
		                             return a(caml_maybe_attach_backtrace(b, 1));
		                            },
		                            function(eff, cont){
		                             if(eff[1] !== Yield) return cont(0);
		                             var tree = eff[2];
		                             return cont
		                                     ([0,
		                                       function(traverse, cont){
		return cont([0, [0, tree, [0, traverse]]]);
		                                       }]);
		                            }],
		                           cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (fiber,
		                          traverse_roots,
		                          function(b){return cont(unfold$0([0, b], a));});
		                }
		                function make(value, cont){
		                 return caml_exact_trampoline_cps_call
		                         (a,
		                          value,
		                          function(b){
		                           if(0 === b) return cont([0, Set$4[72], Map[111]]);
		                           var a = Map[111];
		                           return caml_exact_trampoline_cps_call
		                                   (set,
		                                    [0, id$29, value, 0, Set$4[72], Set$4[72]],
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (b,
		      a,
		      function(a){
		       return cont([0, Set$4[73].call(null, id$29), a]);
		      });
		                                    });
		                          });
		                }
		                function value_map(t, id, f, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find,
		                          t[2],
		                          id,
		                          function(match){
		                           if(! match) return cont(0);
		                           var tree = match[1], a = tree[5], b = tree[4], c = tree[3];
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    tree[1],
		                                    tree[2],
		                                    function(d){
		                                     var updated_tree = [0, tree[1], d, c, b, a];
		                                     return caml_exact_trampoline_cps_call
		     (range,
		      tree,
		      function(old_range){
		       return caml_exact_trampoline_cps_call
		               (range,
		                updated_tree,
		                function(new_range){
		                 return caml_exact_trampoline_cps_call$1
		                         (remove$2,
		                          t[2],
		                          old_range,
		                          function(trees){
		                           return caml_exact_trampoline_cps_call$0
		                                   (set$3,
		                                    trees,
		                                    new_range,
		                                    updated_tree,
		                                    function(a){return cont([0, [0, t[1], a]]);});
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                function delete$(t, ids, cont){
		                 function c(t, ids){
		                  var match = min_elt$1(ids);
		                  if(! match) return cont(t);
		                  var first_id = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (find,
		                           t[2],
		                           first_id,
		                           function(match){
		                            if(match){
		                             var tree = match[1];
		                             if(! tree[3]){
		                              var value = tree[2];
		                              return caml_exact_trampoline_cps_call
		                                      (a,
		                                       value,
		                                       function(e){
		if(0 !== e)
		 return caml_exact_trampoline_cps_call
		         (range,
		          tree,
		          function(range){
		           return caml_exact_trampoline_cps_call$1
		                   (partition_tf$0,
		                    ids,
		                    function(id, cont){
		                     return caml_trampoline_cps_call3
		                             (compare$0,
		                              range,
		                              [0, id, id],
		                              function(a){return cont(0 === a ? 1 : 0);});
		                    },
		                    function(match){
		                     var ids = match[2], ids_in = match[1];
		                     return caml_exact_trampoline_cps_call
		                             (a,
		                              tree[2],
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (range$2,
		tree[1],
		a,
		function(t$0){
		 var
		  init = [0, 0, 0, 0, [0, tree[1], tree[2], , tree[4]]],
		  next = t$0[2],
		  seed = t$0[1];
		 function a(seed, v){
		  return caml_trampoline_cps_call2
		          (next,
		           seed,
		           function(match){
		            if(typeof match === "number"){
		             var last = v[4], tombstone = v[3], split_trees = v[2];
		             if(! split_trees && ! tombstone){
		              var
		               d =
		                 function(m, cont){
		                  return caml_trampoline_cps_call6
		                          (m, 0, 0, aOV, pp$123, first_id, cont);
		                 };
		              return caml_exact_trampoline_cps_call
		                      (err$0,
		                       0,
		                       function(a){
		                        return caml_trampoline_cps_call2
		                                (a,
		                                 d,
		                                 function(match){
		                                  return caml_exact_trampoline_call2(c, t, ids);
		                                 });
		                       });
		             }
		             var
		              last$0 = [0, last[1], last[2], tombstone, last[4], tree[5]];
		             return caml_exact_trampoline_cps_call$1
		                     (remove$2,
		                      t[2],
		                      [0, first_id, first_id],
		                      function(trees){
		                       function a(t$0, trees){
		                        if(! t$0)
		                         return caml_exact_trampoline_cps_call
		                                 (set,
		                                  last$0,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call
		   (a,
		    trees,
		    function(trees){
		     var t$0 = [0, t[1], trees];
		     return caml_exact_trampoline_call2(c, t$0, ids);
		    });
		                                  });
		                        var l = t$0[2], tree = t$0[1];
		                        return caml_exact_trampoline_cps_call
		                                (set,
		                                 tree,
		                                 function(b){
		                                  return caml_exact_trampoline_cps_call
		  (b,
		   trees,
		   function(init){
		    return caml_exact_trampoline_call2(a, l, init);
		   });
		                                 });
		                       }
		                       return a(split_trees, trees);
		                      });
		            }
		            if(0 === match[0]){
		             var seed = match[1];
		             return caml_exact_trampoline_call2(a, seed, v);
		            }
		            var
		             seed$0 = match[2],
		             id = match[1],
		             tree$0 = v[4],
		             tombstone$0 = v[3],
		             acc = v[2],
		             n = v[1];
		            return caml_exact_trampoline_cps_call$1
		                    (mem$3,
		                     ids_in,
		                     id,
		                     function(deleted){
		                      if(0 !== n && deleted !== tombstone$0)
		                       return caml_exact_trampoline_cps_call$1
		                               (b,
		                                tree$0[2],
		                                n,
		                                function(b){
		                                 var
		                                  value_right = b[2],
		                                  value_left = b[1],
		                                  b = Set$4[72],
		                                  b = [0, symbol$227(tree$0[1], n), value_right, , b],
		                                  c = symbol$227(tree$0[1], n),
		                                  c = Set$4[73].call(null, c);
		                                 return caml_exact_trampoline_call2
		 (a,
		  seed$0,
		  [0,
		   1,
		   [0,
		    [0, tree$0[1], value_left, tombstone$0, tree$0[4], c],
		    acc],
		   deleted,
		   b]);
		                                });
		                      return caml_exact_trampoline_call2
		                              (a, seed$0, [0, n + 1 | 0, acc, deleted, tree$0]);
		                     });
		           });
		 }
		 return a(seed, init);
		});
		                              });
		                    });
		          });
		function d(m, cont){
		 return caml_trampoline_cps_call6
		         (m, 0, 0, aOU, pp$123, first_id, cont);
		}
		return caml_exact_trampoline_cps_call
		        (err$0,
		         0,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   d,
		                   function(match){
		                    return caml_exact_trampoline_cps_call$1
		                            (remove$0,
		                             ids,
		                             first_id,
		                             function(ids){
		                              return caml_exact_trampoline_call2(c, t, ids);
		                             });
		                   });
		         });
		                                       });
		                             }
		                            }
		                            function d(m, cont){
		                             return caml_trampoline_cps_call6
		                                     (m, 0, 0, aOT, pp$123, first_id, cont);
		                            }
		                            return caml_exact_trampoline_cps_call
		                                    (err$0,
		                                     0,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a,
		       d,
		       function(match){
		        return caml_exact_trampoline_cps_call$1
		                (remove$0,
		                 ids,
		                 first_id,
		                 function(ids){
		                  return caml_exact_trampoline_call2(c, t, ids);
		                 });
		       });
		                                     });
		                           });
		                 }
		                 return c(t, ids);
		                }
		                function insert(id, left, parent, value, t, cont){
		                 var new_node = [0, id, value, 0, Set$4[72], Set$4[72]];
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$223,
		                          parent,
		                          root_id,
		                          function(e){
		                           if(! e)
		                            return caml_exact_trampoline_cps_call$1
		                                    (find,
		                                     t[2],
		                                     parent,
		                                     function(match){
		                                      if(! match)
		                                       return caml_exact_trampoline_cps_call$1
		       (symbol$226,
		        parent,
		        [0, null$5, 0],
		        function(c){
		         function a(b){
		          var a = t[2];
		          return caml_exact_trampoline_cps_call
		                  (set,
		                   new_node,
		                   function(b){
		                    return caml_exact_trampoline_cps_call
		                            (b,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (add$4, t[1], id, function(b){return cont([0, b, a]);});
		                             });
		                   });
		         }
		         if(! c) return a();
		         function b(m, cont){
		          return caml_trampoline_cps_call6
		                  (m, 0, 0, aOX, pp$123, parent, cont);
		         }
		         return caml_exact_trampoline_cps_call
		                 (err$0,
		                  0,
		                  function(c){return caml_trampoline_cps_call2(c, b, a);});
		        });
		                                      var parent_tree = match[1];
		                                      return caml_exact_trampoline_cps_call
		      (a,
		       parent_tree[2],
		       function(a){
		        var last_id = symbol$227(parent_tree[1], a - 1 | 0);
		        return caml_exact_trampoline_cps_call$1
		                (symbol$223,
		                 parent_tree[1],
		                 parent,
		                 function(d){
		                  if(d && left){
		                   var a = parent_tree[5];
		                   return caml_exact_trampoline_cps_call$1
		                           (add$4,
		                            parent_tree[4],
		                            id,
		                            function(c){
		                             var
		                              new_parent =
		                                [0, parent_tree[1], parent_tree[2], parent_tree[3], c, a],
		                              b = t[2];
		                             return caml_exact_trampoline_cps_call
		                                     (set,
		                                      new_parent,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (a,
		        b,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (set,
		                  new_node,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (b, a, function(a){return cont([0, t[1], a]);});
		                  });
		        });
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$223,
		                           parent,
		                           last_id,
		                           function(a){
		                            if(a && ! left)
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$223,
		                                      id,
		                                      symbol$227(last_id, 1),
		                                      function(e){
		                                       if(e && is_empty$3(parent_tree[5]) && ! parent_tree[3]){
		var
		 a = parent_tree[5],
		 b = parent_tree[4],
		 d = parent_tree[3];
		return caml_exact_trampoline_cps_call$1
		        (c,
		         parent_tree[2],
		         value,
		         function(c){
		          var
		           new_parent = [0, parent_tree[1], c, d, b, a],
		           map = t[2],
		           key = [0, parent, parent];
		          return caml_exact_trampoline_cps_call$1
		                  (remove$2,
		                   map,
		                   key,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (set,
		                             new_parent,
		                             function(b){
		                              return caml_exact_trampoline_cps_call
		                                      (b, a, function(a){return cont([0, t[1], a]);});
		                             });
		                   });
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (add$4,
		        parent_tree[5],
		        id,
		        function(b){
		         var
		          new_parent =
		            [0,
		             parent_tree[1],
		             parent_tree[2],
		             parent_tree[3],
		             parent_tree[4],
		             b],
		          a = t[2];
		         return caml_exact_trampoline_cps_call
		                 (set,
		                  new_parent,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (b,
		                            a,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (set,
		                                      new_node,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (b, a, function(a){return cont([0, t[1], a]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$221,
		                                     parent,
		                                     parent_tree[1],
		                                     function(c){
		                                      function a(){
		                                       var raise = caml_pop_trap();
		                                       return raise
		       (caml_maybe_attach_backtrace([0, Assert_failure, aOW], 1));
		                                      }
		                                      return c
		      ? caml_exact_trampoline_cps_call$1
		        (symbol$222,
		         parent,
		         last_id,
		         function(e){
		          if(! e) return a();
		          if(left){
		           var c = parent[2] - parent_tree[1][2] | 0;
		           return caml_trampoline_cps_call2
		                   (b,
		                    parent_tree[2],
		                    function(a){
		                     return caml_trampoline_cps_call2
		                             (a,
		                              c,
		                              function(a){
		                               var
		                                value_right = a[2],
		                                value_left = a[1],
		                                a = parent_tree[5],
		                                b = Set$4[73].call(null, id),
		                                right_node = [0, parent, value_right, parent_tree[3], b, a],
		                                a = Set$4[73].call(null, parent),
		                                new_parent =
		                                  [0,
		                                   parent_tree[1],
		                                   value_left,
		                                   parent_tree[3],
		                                   parent_tree[4],
		                                   a],
		                                map = t[2],
		                                key = [0, parent, parent];
		                               return caml_exact_trampoline_cps_call$1
		                                       (remove$2,
		map,
		key,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (set,
		          new_parent,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (b,
		                    a,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (set,
		                              new_node,
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (b,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (set,
		          right_node,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (b, a, function(a){return cont([0, t[1], a]);});
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          }
		          var d = (parent[2] - parent_tree[1][2] | 0) + 1 | 0;
		          return caml_trampoline_cps_call2
		                  (b,
		                   parent_tree[2],
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (a,
		                             d,
		                             function(match){
		                              var
		                               value_right = match[2],
		                               value_left = match[1],
		                               next = symbol$227(parent, 1),
		                               next_node =
		                                 [0,
		                                  next,
		                                  value_right,
		                                  parent_tree[3],
		                                  Set$4[72],
		                                  parent_tree[5]];
		                              return caml_exact_trampoline_cps_call
		                                      (Set$4[75],
		                                       [0, id, [0, next, 0]],
		                                       function(a){
		var
		 new_parent =
		   [0,
		    parent_tree[1],
		    value_left,
		    parent_tree[3],
		    parent_tree[4],
		    a],
		 map = t[2],
		 key = [0, parent, parent];
		return caml_exact_trampoline_cps_call$1
		        (remove$2,
		         map,
		         key,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (set,
		                   new_parent,
		                   function(b){
		                    return caml_exact_trampoline_cps_call
		                            (b,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (set,
		                                       new_node,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (b,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (set,
		                   next_node,
		                   function(b){
		                    return caml_exact_trampoline_cps_call
		                            (b, a, function(a){return cont([0, t[1], a]);});
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         })
		      : a();
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           var d = t[2];
		                           return caml_exact_trampoline_cps_call
		                                   (set,
		                                    new_node,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (a,
		      d,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (add$4, t[1], id, function(b){return cont([0, b, a]);});
		      });
		                                    });
		                          });
		                }
		                function insert_at(n, t, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (d,
		                          0,
		                          t,
		                          function(seq){
		                           function b(i, seq){
		                            return caml_exact_trampoline_cps_call
		                                    (next,
		                                     seq,
		                                     function(c){
		                                      if(! c)
		                                       return caml_exact_trampoline_cps_call
		       (failwith, cst_out_of_bound, cont);
		                                      c = c[1];
		                                      var tail = c[2], tree = c[1];
		                                      return caml_exact_trampoline_cps_call
		      (a,
		       tree[2],
		       function(len){
		        var vis_len = tree[3] ? 0 : len;
		        if((i + vis_len | 0) < n){
		         var i$0 = i + vis_len | 0;
		         return caml_exact_trampoline_call2(b, i$0, tail);
		        }
		        if(n === (i + vis_len | 0)){
		         if(is_empty$3(tree[5]))
		          return cont
		                  ([0, 1037695226, symbol$227(tree[1], len - 1 | 0)]);
		         var i$1 = i + vis_len | 0;
		         return caml_exact_trampoline_call2(b, i$1, tail);
		        }
		        if(i <= n)
		         return cont
		                 ([0, -1036053137, symbol$227(tree[1], n - i | 0)]);
		        var raise = caml_pop_trap();
		        return raise
		                (caml_maybe_attach_backtrace([0, Assert_failure, aOY], 1));
		       });
		                                     });
		                           }
		                           return b(0, seq);
		                          });
		                }
		                function to_sequence(tombstones, t, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (d,
		                          tombstones,
		                          t,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    a,
		                                    function(param, cont){
		                                     var value = param[2], id = param[1];
		                                     return cont([0, id, value]);
		                                    },
		                                    cont);
		                          });
		                }
		                function schema_versioned$0(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call
		                                   (Element_inits[1],
		                                    schematic_version,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (Element[4],
		      schematic_version,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$362,
		                schematic_version,
		                function(c){
		                 return caml_exact_trampoline_cps_call$1
		                         (c, b, a, function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 Tree =
		                   [0,
		                    schema_versioned,
		                    ,
		                    delete$,
		                    insert_at,
		                    insert,
		                    make,
		                    to_sequence,
		                    value_map];
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$0,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var
		                           include = Monadic$0(),
		                           v = include[1],
		                           const$ = include[2],
		                           symbol_bind = include[3],
		                           symbol_map = include[4],
		                           bind = include[6],
		                           return$ = include[7],
		                           map = include[8],
		                           ignore_m = include[10],
		                           Let_syntax = include[11],
		                           all_unit = include[12],
		                           Apply = include[14],
		                           letrec_function_context = [];
		                          function state_schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       function a(descriptor){
		        return cont([0, aOZ, 0, descriptor, 0]);
		       }
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return caml_exact_trampoline_cps_call
		       (Tree[1],
		        schematic_version,
		        function(a){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var trees = param[2][1], clock = param[1];
		              return cont([0, clock, trees]);
		             },
		             function(param, cont){
		              var trees = param[2], clock = param[1];
		              return cont([0, clock, [0, trees, 0]]);
		             },
		             [0,
		              [0, 0, 0, 0, 0, cst_clock, 0, 2, [0, int_schema], 0, 0],
		              [0, [0, 0, 0, 0, 0, cst_trees, 0, 2, [0, a], 0, 0], 0]]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 a);
		       var schema = match[1];
		       return a(schema);
		      });
		                                    });
		                          }
		                          var schematic_cache = [0, empty$11([0, comparator$9])];
		                          caml_update_dummy
		                           (letrec_function_context, [0, schematic_cache]);
		                          var
		                           Delta = [0, schema_versioned$0],
		                           Operation =
		                             [0,
		                              ,
		                              ,
		                              const$,
		                              symbol_bind,
		                              symbol_map,
		                              ,
		                              bind,
		                              return$,
		                              map,
		                              ,
		                              ignore_m,
		                              Let_syntax,
		                              all_unit];
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    function to_sequence(state, cont){
		                                     return caml_trampoline_cps_call2
		     (Tree[7],
		      aO0,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                state,
		                function(s){
		                 function f(param, cont){
		                  var value = param[2], id = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (Element_states[8],
		                           value,
		                           function(a){
		                            return cont
		                                    (mapi$1
		                                      (a,
		                                       function(i, element, cont){
		return cont([0, symbol$227(id, i), element]);
		                                       }));
		                           });
		                 }
		                 return caml_trampoline_cps_call3(bind$5, s, f, cont);
		                });
		      });
		                                    }
		                                    function view(state, cont){
		                                     return caml_exact_trampoline_cps_call
		     (to_sequence,
		      state[2],
		      function(a){
		       return caml_trampoline_cps_call3
		               (map$11,
		                a,
		                function(param, cont){
		                 var element = param[2];
		                 return caml_exact_trampoline_cps_call
		                         (Element[11], element, cont);
		                },
		                cont);
		      });
		                                    }
		                                    function view$0(state, cont){
		                                     return caml_exact_trampoline_cps_call
		     (view,
		      state,
		      function(a){
		       a = memoize(a);
		       return caml_trampoline_cps_call2(Element[7][5], a, cont);
		      });
		                                    }
		                                    function length(t, cont){
		                                     return caml_exact_trampoline_cps_call
		     (view,
		      t,
		      function(a){
		       return caml_exact_trampoline_cps_call(length$2, a, cont);
		      });
		                                    }
		                                    function pos_index(t, i, cont){
		                                     return 0 <= i
		     ? cont(i)
		     : caml_exact_trampoline_cps_call
		       (length, t, function(a){return cont((1 + a | 0) + i | 0);});
		                                    }
		                                    function replace_trees(forest, id, f, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (Tree[8],
		      forest,
		      id,
		      function(tree_id, value, cont){
		       return caml_exact_trampoline_cps_call$0
		               (Element_states[6], value, id[2] - tree_id[2] | 0, f, cont);
		      },
		      cont);
		                                    }
		                                    function make(values, cont){
		                                     return caml_trampoline_cps_call3
		     (Element_states[5],
		      values,
		      Element[10],
		      function(value){
		       return caml_exact_trampoline_cps_call
		               (Tree[6],
		                value,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (Element_states[4],
		                          value,
		                          function(b){return cont([0, b, a]);});
		                });
		      });
		                                    }
		                                    function pp_delta(fmt, param, cont){
		                                     switch(param[0]){
		                                       case 0:
		var ids = param[1], a = Set$4[81];
		return caml_exact_trampoline_cps_call
		        (fprintf$0(fmt),
		         aO1,
		         function(b){
		          return caml_trampoline_cps_call3(b, a, ids, cont);
		         });
		                                       case 1:
		return cont(0);
		                                       default:
		var
		 parent = param[3],
		 left = param[2],
		 id = param[1],
		 b = left ? cst_left : cst_right;
		return caml_exact_trampoline_cps_call
		        (fprintf$0(fmt),
		         aO2,
		         function(a){
		          return caml_trampoline_cps_call6
		                  (a, pp$123, id, b, pp$123, parent, cont);
		         });
		                                     }
		                                    }
		                                    function a(replica, state, param, cont){
		                                     switch(param[0]){
		                                       case 0:
		var ids = param[1];
		return caml_exact_trampoline_cps_call$1
		        (Tree[3],
		         state[2],
		         ids,
		         function(a){return cont([0, state[1], a]);});
		                                       case 1:
		var delta = param[2], id = param[1];
		return caml_exact_trampoline_cps_call$0
		        (replace_trees,
		         state[2],
		         id,
		         function(state, cont){
		          return caml_trampoline_cps_call4
		                  (Element[9], replica, state, delta, cont);
		         },
		         function(match){
		          if(! match) return cont(state);
		          var trees = match[1];
		          return cont([0, state[1], trees]);
		         });
		                                       default:
		var
		 value = param[4],
		 parent = param[3],
		 left = param[2],
		 id$0 = param[1];
		return caml_trampoline_cps_call3
		        (Element_states[5],
		         value,
		         Element[10],
		         function(value){
		          return caml_exact_trampoline_cps_call$3
		                  (Tree[5],
		                   id$0,
		                   left,
		                   parent,
		                   value,
		                   state[2],
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (Element_states[4],
		                             value,
		                             function(b){return cont([0, state[1] + b | 0, a]);});
		                   });
		         });
		                                     }
		                                    }
		                                    function apply_delta(replica, state, delta, cont){
		                                     function b(param, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (a, replica, state, delta, cont);
		                                     }
		                                     function c(m, cont){
		                                      return caml_trampoline_cps_call6
		      (m, 0, 0, aO3, pp_delta, delta, cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (with_debug,
		      0,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                c,
		                function(a){return caml_trampoline_cps_call2(a, b, cont);});
		      });
		                                    }
		                                    function apply(replica, state, param, cont){
		                                     switch(param[0]){
		                                       case 0:
		var length = param[2], index = param[1];
		return caml_exact_trampoline_cps_call$1
		        (pos_index,
		         state,
		         index,
		         function(at){
		          function a(m, cont){
		           return caml_trampoline_cps_call7
		                   (m, 0, 0, aO4, length, index, at, cont);
		          }
		          return caml_exact_trampoline_cps_call
		                  (debug$2,
		                   0,
		                   function(b){
		                    return caml_trampoline_cps_call2
		                            (b,
		                             a,
		                             function(match){
		                              return caml_exact_trampoline_cps_call
		                                      (to_sequence,
		                                       state[2],
		                                       function(s$0){
		var init = [0, 0, Set$4[72]], next = s$0[2], s = s$0[1];
		function a(s, acc){
		 return caml_trampoline_cps_call2
		         (next,
		          s,
		          function(match){
		           function c(ids){
		            function a(a){
		             var delta = [0, ids];
		             return caml_exact_trampoline_cps_call$0
		                     (apply_delta,
		                      replica,
		                      state,
		                      delta,
		                      function(a){return cont([0, 0, [0, delta], a]);});
		            }
		            if(Set$4[5].call(null, ids) >= length) return a();
		            function b(m, cont){
		             return caml_trampoline_cps_call4(m, 0, 0, aO5, cont);
		            }
		            return caml_exact_trampoline_cps_call
		                    (warn$1,
		                     0,
		                     function(c){return caml_trampoline_cps_call2(c, b, a);});
		           }
		           if(typeof match === "number") return c(acc[2]);
		           if(0 === match[0]){
		            var s = match[1];
		            return caml_exact_trampoline_call2(a, s, acc);
		           }
		           var
		            s$0 = match[2],
		            a$0 = match[1],
		            id = a$0[1],
		            ids = acc[2],
		            index = acc[1];
		           function b(match){
		            if(0 === match[0]){
		             var acc = match[1];
		             return caml_exact_trampoline_call2(a, s$0, acc);
		            }
		            var x = match[1];
		            return c(x);
		           }
		           return index < at
		                   ? b([0, [0, index + 1 | 0, ids]])
		                   : (at
		                     + length
		                     | 0)
		                     <= index
		                     ? b([1, ids])
		                     : caml_exact_trampoline_cps_call$1
		                       (add$4,
		                        ids,
		                        id,
		                        function(a){return b([0, [0, index + 1 | 0, a]]);});
		          });
		}
		return a(s, init);
		                                       });
		                             });
		                   });
		         });
		                                       case 1:
		var operation = param[2], index$0 = param[1];
		return caml_exact_trampoline_cps_call$1
		        (pos_index,
		         state,
		         index$0,
		         function(at){
		          function a(m, cont){
		           return caml_trampoline_cps_call6
		                   (m, 0, 0, aO6, index$0, at, cont);
		          }
		          return caml_exact_trampoline_cps_call
		                  (debug$2,
		                   0,
		                   function(b){
		                    return caml_trampoline_cps_call2
		                            (b,
		                             a,
		                             function(match){
		                              return caml_exact_trampoline_cps_call
		                                      (to_sequence,
		                                       state[2],
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (nth,
		         a,
		         at,
		         function(match){
		          if(match){
		           var
		            id = match[1][1],
		            Result = Make$8(),
		            a =
		              function(param, cont){
		               return caml_exact_trampoline_cps_call$0
		                       (replace_trees,
		                        state[2],
		                        id,
		                        function(state, cont){
		                         return caml_trampoline_cps_call4
		                                 (Element[8],
		                                  replica,
		                                  state,
		                                  operation,
		                                  function(match){
		                                   var trees = match[3], delta = match[2], result = match[1];
		                                   return caml_exact_trampoline_cps_call
		   (Result[4],
		    [0, [0, [0, result], delta]],
		    function(a){return cont(trees);});
		                                  });
		                        },
		                        cont);
		              };
		           return caml_trampoline_cps_call2
		                   (Result[7],
		                    0,
		                    function(b){
		                     return caml_trampoline_cps_call2
		                             (b,
		                              a,
		                              function(a){
		                               var result = a[2], trees = a[1];
		                               if(result && trees){
		                                var
		                                 trees$0 = trees[1],
		                                 a = result[1],
		                                 delta = a[2],
		                                 result$0 = a[1];
		                                return caml_trampoline_cps_call3
		(map$17,
		 delta,
		 function(delta, cont){return cont([1, id, delta]);},
		 function(delta){
		  return cont([0, result$0, delta, [0, state[1], trees$0]]);
		 });
		                               }
		                               return caml_exact_trampoline_cps_call$1
		                                       (kasprintf,
		failwith,
		fmt$127,
		function(a){
		 return caml_trampoline_cps_call3(a, pp$123, id, cont);
		});
		                              });
		                    });
		          }
		          function b(m, cont){
		           return caml_trampoline_cps_call6
		                   (m, 0, 0, aO7, index$0, at, cont);
		          }
		          return caml_exact_trampoline_cps_call
		                  (err$0,
		                   0,
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (a, b, function(match){return cont([0, 0, 0, state]);});
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       default:
		var value = param[2], index$1 = param[1];
		return caml_exact_trampoline_cps_call$1
		        (pos_index,
		         state,
		         index$1,
		         function(at){
		          function a(m, cont){
		           return caml_trampoline_cps_call6
		                   (m, 0, 0, aO8, index$1, at, cont);
		          }
		          return caml_exact_trampoline_cps_call
		                  (debug$2,
		                   0,
		                   function(b){
		                    return caml_trampoline_cps_call2
		                            (b,
		                             a,
		                             function(match){
		                              return caml_exact_trampoline_cps_call
		                                      (Element_inits[4],
		                                       value,
		                                       function(t){
		var next = t[2], seed = t[1];
		function a(s){
		 return caml_trampoline_cps_call2
		         (next,
		          s,
		          function(b){
		           if(typeof b === "number")
		            b = 1;
		           else {
		            if(0 === b[0]){
		             var s = b[1];
		             return caml_exact_trampoline_call1(a, s);
		            }
		            b = 0;
		           }
		           if(b) return cont([0, root_id, 0, state]);
		           var id = [0, replica, state[1]];
		           function c(delta){
		            return caml_exact_trampoline_cps_call$0
		                    (apply_delta,
		                     replica,
		                     state,
		                     delta,
		                     function(a){return cont([0, id, [0, delta], a]);});
		           }
		           return 0 === at
		                   ? caml_exact_trampoline_cps_call
		                     (to_sequence,
		                      state[2],
		                      function(a){
		                       return caml_exact_trampoline_cps_call
		                               (hd$1,
		                                a,
		                                function(match){
		                                 if(! match) return c([2, id, 0, root_id, value]);
		                                 var first_id = match[1][1];
		                                 return c([2, id, 1, first_id, value]);
		                                });
		                      })
		                   : caml_exact_trampoline_cps_call$1
		                     (Tree[4],
		                      at,
		                      state[2],
		                      function(match){
		                       var parent = match[2], side = match[1];
		                       function a(m, cont){
		                        var a = 1037695226 <= side ? "right of" : "left of";
		                        return caml_trampoline_cps_call7
		                                (m, 0, 0, aO9, a, pp$123, parent, cont);
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (debug$2,
		                                0,
		                                function(b){
		                                 return caml_trampoline_cps_call2
		 (b,
		  a,
		  function(match){
		   var left = 1037695226 <= side ? 0 : 1;
		   return c([2, id, left, parent, value]);
		  });
		                                });
		                      });
		          });
		}
		return a(seed);
		                                       });
		                             });
		                   });
		         });
		                                     }
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (Apply,
		     [0, Delta, apply_delta, apply],
		     function(include){
		      var
		       delta_schema_versioned = include[1],
		       delta_schema = include[2],
		       apply_delta = include[3],
		       apply = include[4];
		      function delete$(position, length, cont){
		       return caml_exact_trampoline_cps_call
		               (v, [0, position, length], cont);
		      }
		      function element(index, operation, cont){
		       return caml_exact_trampoline_cps_call
		               (v, [1, index, operation], cont);
		      }
		      function element$0(index, op, cont){
		       return caml_exact_trampoline_cps_call$1
		               (element,
		                index,
		                op,
		                function(a){
		                 return caml_exact_trampoline_cps_call(ignore_m, a, cont);
		                });
		      }
		      function insert(index, value, cont){
		       return caml_exact_trampoline_cps_call
		               (v, [2, index, value], cont);
		      }
		      return cont
		              ([0,
		                Element,
		                ,
		                ,
		                Operation,
		                Element_inits,
		                state_schema_versioned,
		                state_schema,
		                ,
		                ,
		                view$0,
		                ,
		                ,
		                ,
		                make,
		                ,
		                delta_schema_versioned,
		                delta_schema,
		                apply_delta,
		                apply,
		                ,
		                delete$,
		                ,
		                element$0,
		                insert]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function bQz(Element, cont){
		                var letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, 0, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (Element[2],
		                                      schematic_version,
		                                      function(a){
		                                       var res = [3, a];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          function set(l, pos, f, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (mapi$0,
		                                    l,
		                                    function(i, v, cont){
		                                     return i === pos
		     ? caml_exact_trampoline_cps_call(f, v, cont)
		     : cont(v);
		                                    },
		                                    cont);
		                          }
		                          var letrec_function_context = [];
		                          function schema_versioned$0(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       function a(descriptor){
		        return cont([0, 0, 0, descriptor, 0]);
		       }
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return caml_trampoline_cps_call2
		       (Element[6][1],
		        schematic_version,
		        function(a){
		         var res = [3, a];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 a);
		       var schema = match[1];
		       return a(schema);
		      });
		                                    });
		                          }
		                          var schematic_cache = [0, empty$11([0, comparator$9])];
		                          caml_update_dummy
		                           (letrec_function_context, [0, schematic_cache]);
		                          var
		                           a =
		                             [0,
		                              schema_versioned,
		                              ,
		                              append$0,
		                              length$1,
		                              map$18,
		                              set,
		                              split_n,
		                              deconstruct];
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$0,
		                                   function(param, cont){return cont(0);},
		                                   function(schema){
		                                    return caml_exact_trampoline_cps_call$0
		    (Make$22,
		     Element,
		     [0, schema_versioned$0, schema, , deconstruct],
		     a,
		     function(a){
		      var c = a[5], b = a[4];
		      return cont
		              ([0,
		                ,
		                [0,
		                 b[4],
		                 b[5],
		                 ,
		                 b[7],
		                 b[8],
		                 b[9],
		                 ,
		                 b[11],
		                 ,
		                 b[13],
		                 b[12],
		                 b[3]],
		                a[6],
		                a[7],
		                a[16],
		                a[17],
		                [0, c[1], c[2]],
		                a[1][7],
		                a[19],
		                a[18],
		                a[14],
		                a[10],
		                ,
		                a[21],
		                ,
		                a[23],
		                a[24]]);
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$658 = [];
		               function schema_versioned$363(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$658[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$658[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$658[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$658[1][1] = a;
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$658[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$658[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$628 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$658, [0, schematic_cache$628]);
		               caml_callback
		                (schema_versioned$363,
		                 [function(param, cont){return cont(0);}]);
		               function b8(Data, cont){
		                function delta_schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$363,
		                                    schematic_version,
		                                    function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (delta_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(delta_schema){
		                          function state_schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call
		     (Data[1],
		      schematic_version,
		      function(a){return cont([0, aO_, 0, a[3], a[4]]);});
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    function apply(c, b, param, a){
		                                     a = caml_pop_trap();
		                                     return a
		     (caml_maybe_attach_backtrace([0, Match_failure, aO$], 1));
		                                    }
		                                    function apply_delta(b, a, param, cont){
		                                     a = caml_pop_trap();
		                                     return a
		     (caml_maybe_attach_backtrace([0, Match_failure, aPa], 1));
		                                    }
		                                    function make(value, cont){return cont(value);}
		                                    function view(a, cont){return cont(a);}
		                                    return cont
		    ([0,
		      ,
		      state_schema_versioned,
		      ,
		      delta_schema_versioned,
		      ,
		      Data,
		      include$0,
		      apply,
		      apply_delta,
		      make,
		      view]);
		                                   });
		                         });
		               }
		               var letrec_function_context$659 = [];
		               function utf8_string_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$659[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$659[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$659[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$659[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var len = param[2][1], data = param[1];
		                                 return cont([0, data, len]);
		                                },
		                                function(param, cont){
		                                 var len = param[2], data = param[1];
		                                 return cont([0, data, [0, len, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_data,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0, [0, 0, 0, 0, 0, "len", 0, 2, [0, int_schema], 0, 0], 0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$659[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$659[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$629 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$659, [0, schematic_cache$629]);
		               caml_callback
		                (utf8_string_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function utf8_to_sequence(f, s){
		                var len = caml_ml_string_length(s);
		                return unfold$0
		                        (0,
		                         function(pos, cont){
		                          if(pos >= len) return cont(0);
		                          var char = get_utf_8_uchar$0(s, pos);
		                          function a(a){
		                           a = pos + utf_decode_length(char) | 0;
		                           return cont([0, [0, f(pos, char), a]]);
		                          }
		                          if(utf_decode_is_valid(char)) return a(0);
		                          function b(m, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (subo,
		                                    [0, pos],
		                                    0,
		                                    s,
		                                    function(a){
		                                     return caml_trampoline_cps_call5(m, 0, 0, aPb, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (err$0,
		                                   0,
		                                   function(c){return caml_trampoline_cps_call2(c, b, a);});
		                         });
		               }
		               function bPl(param, char){return char & 16777215;}
		               function sequence_to_utf8(opt, seq, cont){
		                var
		                 n = opt ? opt[1] : 16,
		                 buf = create$1(n),
		                 next = seq[2],
		                 seed = seq[1];
		                function a(seed){
		                 return caml_trampoline_cps_call2
		                         (next,
		                          seed,
		                          function(match){
		                           if(typeof match === "number")
		                            return caml_exact_trampoline_cps_call(contents, buf, cont);
		                           if(0 === match[0]){
		                            var seed = match[1];
		                            return caml_exact_trampoline_call1(a, seed);
		                           }
		                           var seed$0 = match[2], uc = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (add_utf_8_uchar,
		                                    buf,
		                                    uc,
		                                    function(b){return caml_exact_trampoline_call1(a, seed$0);});
		                          });
		                }
		                return a(seed);
		               }
		               function schema_versioned$364(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (utf8_string_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, aPc, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$364,
		                 [function(param, cont){return cont(0);}]);
		               function append$5(s1, s2, cont){
		                var s2$0 = s2[1], s1$0 = s1[1], s = s1$0 + s2$0;
		                return cont([0, s, s1[2] + s2[2] | 0]);
		               }
		               function length$18(s, cont){return cont(s[2]);}
		               function map$44(s, f, cont){
		                return caml_trampoline_cps_call3
		                        (map$11,
		                         utf8_to_sequence(bPl, s),
		                         f,
		                         function(b){
		                          var seq = memoize(b), next = seq[2], seed = seq[1];
		                          function a(seed, len){
		                           return caml_trampoline_cps_call2
		                                   (next,
		                                    seed,
		                                    function(match){
		                                     if(typeof match === "number")
		                                      return caml_exact_trampoline_cps_call$1
		      (sequence_to_utf8,
		       [0, caml_ml_string_length(s)],
		       seq,
		       function(a){return cont([0, a, len]);});
		                                     if(0 === match[0]){
		                                      var seed = match[1];
		                                      return caml_exact_trampoline_call2(a, seed, len);
		                                     }
		                                     var seed$0 = match[2], v = len + 1 | 0;
		                                     return caml_exact_trampoline_call2(a, seed$0, v);
		                                    });
		                          }
		                          return a(seed, 0);
		                         });
		               }
		               function set$9(s, pos, f, cont){
		                var
		                 a =
		                   mapi$1
		                    (utf8_to_sequence(bPl, s[1]),
		                     function(i, uc, cont){
		                      return i === pos
		                              ? caml_exact_trampoline_cps_call(f, uc, cont)
		                              : cont(uc);
		                     });
		                return caml_exact_trampoline_cps_call$1
		                        (sequence_to_utf8,
		                         [0, 4 * caml_ml_string_length(s[1]) | 0],
		                         a,
		                         function(data){return cont([0, data, s[2]]);});
		               }
		               function split$6(s, n, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (nth,
		                         utf8_to_sequence(function(pos, param){return pos;}, s[1]),
		                         n,
		                         function(match){
		                          if(! match) return cont([0, s, aPd]);
		                          var split = match[1], a = s[2] - n | 0;
		                          return caml_exact_trampoline_cps_call$0
		                                  (subo,
		                                   [0, split],
		                                   0,
		                                   s[1],
		                                   function(c){
		                                    var b = [0, c, a];
		                                    return caml_exact_trampoline_cps_call$0
		    (subo,
		     0,
		     [0, split],
		     s[1],
		     function(a){return cont([0, [0, a, n], b]);});
		                                   });
		                         });
		               }
		               function to_sequence$3(s, cont){
		                return cont(utf8_to_sequence(bPl, s[1]));
		               }
		               function schema_versioned$365(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    bF,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                schema$281 =
		                  [0,
		                   bF,
		                   0,
		                   schematic_param_name_schema_ve[3],
		                   schematic_param_name_schema_ve[4]];
		               function to_sequence$4(s, cont){
		                return cont(utf8_to_sequence(bPl, s));
		               }
		               var
		                schema$147 =
		                  map$14
		                   (function(n, cont){
		                     var match = int_is_scalar(n) ? [0, n] : 0;
		                     if(! match)
		                      return caml_exact_trampoline_cps_call$1
		                              (kasprintf,
		                               fail,
		                               format$22,
		                               function(a){return caml_trampoline_cps_call2(a, n, cont);});
		                     var uc = match[1];
		                     return cont([0, uc]);
		                    },
		                    to_binable$0,
		                    int_schema);
		               function schema_versioned$366(param, cont){return cont(schema$147);
		               }
		               var
		                j =
		                  caml_callback
		                   (Make$22,
		                    [caml_callback(b8, [[0, schema_versioned$366]]),
		                     [0, schema_versioned$365, schema$281, , to_sequence$4],
		                     [0,
		                      schema_versioned$364,
		                      ,
		                      append$5,
		                      length$18,
		                      map$44,
		                      set$9,
		                      split$6,
		                      to_sequence$3]]),
		                insert = j[24],
		                element = j[23],
		                delete$ = j[21],
		                make$62 = j[14],
		                apply_delta = j[18],
		                apply$3 = j[19],
		                Monad$0 = j[1][7],
		                b3 = j[5],
		                Init = [0, b3[1], b3[2]],
		                delta_schema = j[17],
		                delta_schema_versioned = j[16],
		                state_schema = j[7],
		                state_schema_versioned = j[6],
		                b3 = j[4],
		                Operation =
		                  [0,
		                   b3[4],
		                   b3[5],
		                   ,
		                   b3[7],
		                   b3[8],
		                   b3[9],
		                   ,
		                   b3[11],
		                   ,
		                   b3[13],
		                   b3[12],
		                   b3[3]],
		                bRx = j[10];
		               function view$0(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (bRx,
		                         state,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (sequence_to_utf8, aPe, a, cont);
		                         });
		               }
		               function M$7(Incremental, Crdt){
		                var
		                 delta_schema_versioned = Crdt[4],
		                 delta_schema = Crdt[5],
		                 Init = Crdt[6],
		                 apply = Crdt[8],
		                 apply_delta = Crdt[9],
		                 make = Crdt[10],
		                 view = Crdt[11];
		                function make$0(state, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (Incremental[82][4],
		                          0,
		                          state,
		                          function(var$){return cont([0, state, var$]);});
		                }
		                var
		                 state_schema =
		                   map$14
		                    (function(a, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (compose, of_string$14, make$0, a, cont);
		                     },
		                     function(param, cont){
		                      var state = param[1];
		                      return cont(state);
		                     },
		                     Crdt[3]);
		                function state_schema_versioned(param, cont){return cont(state_schema);
		                }
		                function apply$0(replica, incr_state, op, cont){
		                 return caml_trampoline_cps_call4
		                         (apply,
		                          replica,
		                          incr_state[1],
		                          op,
		                          function(match){
		                           var state = match[3], delta = match[2], result = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (Incremental[82][5],
		                                    incr_state[2],
		                                    state,
		                                    function(match){
		                                     return cont([0, result, delta, [0, state, incr_state[2]]]);
		                                    });
		                          });
		                }
		                function apply_delta$0(replica, incr_state, delta, cont){
		                 return caml_trampoline_cps_call4
		                         (apply_delta,
		                          replica,
		                          incr_state[1],
		                          delta,
		                          function(state){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Incremental[82][5],
		                                    incr_state[2],
		                                    state,
		                                    function(match){return cont([0, state, incr_state[2]]);});
		                          });
		                }
		                function make$1(init, cont){
		                 return caml_exact_trampoline_cps_call
		                         (make,
		                          init,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(make$0, a, cont);
		                          });
		                }
		                function view$0(a, cont){
		                 var var$ = a[2], a = Incremental[82][6].call(null, var$);
		                 return caml_exact_trampoline_cps_call$1
		                         (Incremental[72], a, view, cont);
		                }
		                return [0,
		                        ,
		                        state_schema_versioned,
		                        state_schema,
		                        delta_schema_versioned,
		                        delta_schema,
		                        Init,
		                        Incremental,
		                        apply$0,
		                        apply_delta$0,
		                        make$1,
		                        view$0];
		               }
		               function bind$26(x, f, cont){
		                function f$0(param, cont){
		                 var x = param[2], pos = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          x,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    a,
		                                    function(param, cont){
		                                     var y = param[2], pos$0 = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (append$0, pos, pos$0, function(a){return cont([0, a, y]);});
		                                    },
		                                    cont);
		                          });
		                }
		                return caml_trampoline_cps_call3(bind$5, x, f$0, cont);
		               }
		               function of_match1(f){
		                return function(indexed, a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (bind$26,
		                          indexed,
		                          function(x, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (f,
		                                    x,
		                                    a,
		                                    function(y){
		                                     return cont
		     (mapi$1
		       (y, function(i, y, cont){return cont([0, [0, i, 0], y]);}));
		                                    });
		                          },
		                          cont);};
		               }
		               function match1(pattern, matched, a, cont){
		                var x = [0, aPf, matched];
		                return caml_trampoline_cps_call2
		                        (return$6,
		                         x,
		                         function(matched){
		                          return caml_trampoline_cps_call3
		                                  (pattern,
		                                   matched,
		                                   a,
		                                   function(matches){
		                                    return caml_trampoline_cps_call3
		    (map$11, matches, get_data, cont);
		                                   });
		                         });
		               }
		               function repeat$0(pat){
		                return function(indexed, a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (bind$26,
		                          indexed,
		                          function(deltas, cont){
		                           function b(deltas, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (match1,
		                                     pat,
		                                     deltas,
		                                     a,
		                                     function(res){
		                                      return cont
		      (mapi$1
		        (res,
		         function(i, res, cont){return cont([0, [0, i, 0], res]);}));
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (deconstruct,
		                                    deltas,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (bind$26,
		      mapi$1
		       (a,
		        function(i, delta, cont){
		         return cont([0, [0, i, 0], delta]);
		        }),
		      b,
		      cont);
		                                    });
		                          },
		                          cont);};
		               }
		               function schema_versioned$367(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_key_schema_ver,
		                                    schematic_param_init_schema_ve,
		                                    schematic_param_value_schema_v,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_key_schema_ver,
		                                     schematic_param_init_schema_ve,
		                                     schematic_param_value_schema_v,
		                                     cont){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(c){
		       var
		        a =
		          [0,
		           [0,
		            function(param, cont){
		             var f1 = param[2], f0 = param[1];
		             return cont([2, f0, f1]);
		            },
		            function(param, cont){
		             if(2 !== param[0]) return cont(0);
		             var f1 = param[2], f0 = param[1];
		             return cont([0, [0, f0, f1]]);
		            },
		            1,
		            aPg,
		            cst_remove,
		            cst_Remove,
		            [0,
		             0,
		             0,
		             [7,
		              function(param, cont){
		               var id = param[2][1], key = param[1];
		               return cont([0, key, id]);
		              },
		              function(param, cont){
		               var id = param[2], key = param[1];
		               return cont([0, key, [0, id, 0]]);
		              },
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_remove,
		                0,
		                2,
		                [0, schematic_param_key_schema_ver],
		                0,
		                0],
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]]],
		             0],
		            0],
		           0],
		        b =
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_delta,
		            0,
		            2,
		            [0, schematic_param_value_schema_v],
		            0,
		            0],
		           0];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$360,
		                schematic_version,
		                function(e){
		                 var
		                  c =
		                    [0,
		                     [0,
		                      function(param, cont){
		                       var f2 = param[3], f1 = param[2], f0 = param[1];
		                       return cont([1, f0, f1, f2]);
		                      },
		                      function(param, cont){
		                       if(1 !== param[0]) return cont(0);
		                       var f2 = param[3], f1 = param[2], f0 = param[1];
		                       return cont([0, [0, f0, f1, f2]]);
		                      },
		                      1,
		                      aPh,
		                      cst_element,
		                      cst_Element,
		                      [0,
		                       0,
		                       0,
		                       [7,
		                        function(param, cont){
		                         var
		                          a = param[2],
		                          delta = a[2][1],
		                          id = a[1],
		                          key = param[1];
		                         return cont([0, key, id, delta]);
		                        },
		                        function(param, cont){
		                         var delta = param[3], id = param[2], key = param[1];
		                         return cont([0, key, [0, id, [0, delta, 0]]]);
		                        },
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_element,
		                          0,
		                          2,
		                          [0, schematic_param_key_schema_ver],
		                          0,
		                          0],
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, e], 0, 0], b]]],
		                       0],
		                      0],
		                     a],
		                  d =
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_value,
		                      0,
		                      2,
		                      [0, schematic_param_init_schema_ve],
		                      0,
		                      0],
		                     0];
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$360,
		                          schematic_version,
		                          function(a){
		                           return cont
		                                   ([11,
		                                     0,
		                                     [0,
		                                      [0,
		                                       function(param, cont){
		var f2 = param[3], f1 = param[2], f0 = param[1];
		return cont([0, f0, f1, f2]);
		                                       },
		                                       function(param, cont){
		if(0 !== param[0]) return cont(0);
		var f2 = param[3], f1 = param[2], f0 = param[1];
		return cont([0, [0, f0, f1, f2]]);
		                                       },
		                                       1,
		                                       aPi,
		                                       cst_add,
		                                       cst_Add,
		                                       [0,
		0,
		0,
		[7,
		 function(param, cont){
		  var
		   a = param[2],
		   value = a[2][1],
		   id = a[1],
		   key = param[1];
		  return cont([0, key, id, value]);
		 },
		 function(param, cont){
		  var value = param[3], id = param[2], key = param[1];
		  return cont([0, key, [0, id, [0, value, 0]]]);
		 },
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_add,
		   0,
		   2,
		   [0, schematic_param_key_schema_ver],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], d]]],
		0],
		                                       0],
		                                      c],
		                                     0]);
		                          });
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$212[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_key,
		 schematic_param_key_schema_ver,
		 function(schematic_param_key_schema_ver, cont){
		  return cont
		          ([1,
		            cst_init,
		            schematic_param_init_schema_ve,
		            function(schematic_param_init_schema_ve, cont){
		             return cont
		                     ([1,
		                       cst_value,
		                       schematic_param_value_schema_v,
		                       function(schematic_param_value_schema_v, cont){
		                        return caml_exact_trampoline_cps_call$0
		                                (descriptor,
		                                 schematic_param_key_schema_ver,
		                                 schematic_param_init_schema_ve,
		                                 schematic_param_value_schema_v,
		                                 function(a){return cont([0, schematic_schema_id, a]);});
		                       }]);
		            }]);
		 }]];
		                                    return caml_exact_trampoline_cps_call$0
		    (descriptor,
		     schematic_param_key_schema_ver,
		     schematic_param_init_schema_ve,
		     schematic_param_value_schema_v,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function elt_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_state_schema_v, cont){
		                                    function descriptor(schematic_param_state_schema_v, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_value,
		  0,
		  3,
		  [0, schematic_param_state_schema_v],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(b){
		       return cont
		               ([7,
		                 function(param, cont){
		                  var value = param[2][1], id = param[1];
		                  return cont([0, id, value]);
		                 },
		                 function(param, cont){
		                  var value = param[2], id = param[1];
		                  return cont([0, id, [0, value, 0]]);
		                 },
		                 [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$213[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_state,
		 schematic_param_state_schema_v,
		 function(schematic_param_state_schema_v, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_state_schema_v,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_state_schema_v,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               function Make$23(Key, Value, Element, cont){
		                return caml_exact_trampoline_cps_call
		                        (M$2,
		                         [0, Key[18], Key[1]],
		                         function(Map){
		                          var
		                           include = Monadic$0(),
		                           v = include[1],
		                           const$ = include[2],
		                           symbol_bind = include[3],
		                           symbol_map = include[4],
		                           Monad_infix = include[5],
		                           bind = include[6],
		                           return$ = include[7],
		                           map = include[8],
		                           join = include[9],
		                           ignore_m = include[10],
		                           Let_syntax = include[11],
		                           all_unit = include[12],
		                           all = include[13],
		                           Apply = include[14];
		                          function schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_trampoline_cps_call2
		     (Element[4],
		      schematic_version,
		      function(a){
		       return caml_trampoline_cps_call2
		               (Element[6][1],
		                schematic_version,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (Key[1],
		                          schematic_version,
		                          function(c){
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$367,
		                                    schematic_version,
		                                    function(d){
		                                     return caml_exact_trampoline_cps_call$0
		     (d,
		      c,
		      b,
		      a,
		      function(a){return cont([0, aPj, 0, a[3], a[4]]);});
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var
		                           Operation =
		                             [0,
		                              [0],
		                              v,
		                              const$,
		                              symbol_bind,
		                              symbol_map,
		                              Monad_infix,
		                              bind,
		                              return$,
		                              map,
		                              join,
		                              ignore_m,
		                              Let_syntax,
		                              all_unit,
		                              all,
		                              Apply];
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(schema){
		                                    var Delta = [0, schema_versioned, schema];
		                                    function element_schema_versioned(schematic_version, cont){
		                                     return caml_trampoline_cps_call2
		     (schematic_version,
		      V$5,
		      function(schematic_schema_version){
		       return caml_trampoline_cps_call2
		               (Element[2],
		                schematic_version,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (elt_schema_versioned,
		                          schematic_version,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (b, a, function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (element_schema_versioned,
		     function(param, cont){return cont(0);},
		     function(element_schema){
		      function apply_delta(replica, state, param, cont){
		       switch(param[0]){
		         case 0:
		          var value = param[3], id = param[2], key = param[1];
		          return caml_exact_trampoline_cps_call$0
		                  (Map[23],
		                   state,
		                   key,
		                   function(prev, cont){
		                    if(prev){
		                     var elt = prev[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$218,
		                              elt[1],
		                              id,
		                              function(c){
		                               if(c){
		                                var
		                                 a =
		                                   function(m, cont){
		                                    return caml_trampoline_cps_call6
		    (m, 0, 0, aPk, Key[19], key, cont);
		                                   };
		                                return caml_exact_trampoline_cps_call
		(debug$2,
		 0,
		 function(b){
		  return caml_trampoline_cps_call2
		          (b,
		           a,
		           function(match){
		            return caml_trampoline_cps_call2
		                    (Element[10],
		                     value,
		                     function(a){return cont([0, [0, id, [0, a]]]);});
		           });
		 });
		                               }
		                               function b(m, cont){
		                                return caml_trampoline_cps_call10
		(m, 0, 0, aPl, Key[19], key, _10$3, id, _10$3, elt[1], cont);
		                               }
		                               return caml_exact_trampoline_cps_call
		                                       (debug$2,
		0,
		function(a){
		 return caml_trampoline_cps_call2
		         (a, b, function(match){return cont(prev);});
		});
		                              });
		                    }
		                    function a(m, cont){
		                     return caml_trampoline_cps_call6
		                             (m, 0, 0, aPm, Key[19], key, cont);
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (debug$2,
		                             0,
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (b,
		                                       a,
		                                       function(match){
		return caml_trampoline_cps_call2
		        (Element[10],
		         value,
		         function(a){return cont([0, [0, id, [0, a]]]);});
		                                       });
		                             });
		                   },
		                   cont);
		         case 1:
		          var delta = param[3], id$0 = param[2], key$0 = param[1];
		          return caml_exact_trampoline_cps_call$0
		                  (Map[23],
		                   state,
		                   key$0,
		                   function(prev, cont){
		                    if(! prev) return cont(0);
		                    var elt = prev[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol$219,
		                             elt[1],
		                             id$0,
		                             function(a){
		                              if(! a){
		                               var
		                                f =
		                                  function(m, cont){
		                                   return caml_trampoline_cps_call10
		   (m,
		    0,
		    0,
		    aPp,
		    Key[19],
		    key$0,
		    _10$3,
		    id$0,
		    _10$3,
		    elt[1],
		    cont);
		                                  };
		                               return caml_exact_trampoline_cps_call
		                                       (debug$2,
		0,
		function(a){
		 return caml_trampoline_cps_call2
		         (a, f, function(match){return cont(prev);});
		});
		                              }
		                              g
		                               ([0,
		                                 symbol_bind$5,
		                                 symbol_map$5,
		                                 ,
		                                 bind$8,
		                                 return$9,
		                                 map$17,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$3]);
		                              a = elt[2];
		                              function b(value){return cont([0, [0, elt[1], value]]);}
		                              if(a){
		                               var
		                                value = a[1],
		                                c =
		                                  function(param, cont){
		                                   return caml_trampoline_cps_call4
		   (Element[9],
		    replica,
		    value,
		    delta,
		    function(a){return cont([0, a]);});
		                                  },
		                                d =
		                                  function(m, cont){
		                                   return caml_trampoline_cps_call6
		   (m, 0, 0, aPn, Key[19], key$0, cont);
		                                  };
		                               return caml_exact_trampoline_cps_call
		                                       (with_debug,
		0,
		function(a){
		 return caml_trampoline_cps_call2
		         (a,
		          d,
		          function(a){return caml_trampoline_cps_call2(a, c, b);});
		});
		                              }
		                              function e(m, cont){
		                               return caml_trampoline_cps_call6
		                                       (m, 0, 0, aPo, Key[19], key$0, cont);
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (debug$2,
		                                       0,
		                                       function(a){
		return caml_trampoline_cps_call2
		        (a, e, function(match){return b(0);});
		                                       });
		                             });
		                   },
		                   cont);
		         default:
		          var id$1 = param[2], key$1 = param[1];
		          return caml_exact_trampoline_cps_call$0
		                  (Map[23],
		                   state,
		                   key$1,
		                   function(prev, cont){
		                    if(! prev) return cont(0);
		                    var elt = prev[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol$219,
		                             elt[1],
		                             id$1,
		                             function(c){
		                              if(c){
		                               var
		                                a =
		                                  function(m, cont){
		                                   return caml_trampoline_cps_call6
		   (m, 0, 0, aPq, Key[19], key$1, cont);
		                                  };
		                               return caml_exact_trampoline_cps_call
		                                       (debug$2,
		0,
		function(b){
		 return caml_trampoline_cps_call2
		         (b, a, function(match){return cont([0, [0, elt[1], 0]]);});
		});
		                              }
		                              function b(m, cont){
		                               return caml_trampoline_cps_call10
		                                       (m,
		0,
		0,
		aPr,
		Key[19],
		key$1,
		_10$3,
		id$1,
		_10$3,
		elt[1],
		cont);
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (debug$2,
		                                       0,
		                                       function(a){
		return caml_trampoline_cps_call2
		        (a, b, function(match){return cont(prev);});
		                                       });
		                             });
		                   },
		                   cont);
		       }
		      }
		      function next_timestamp(state, k, cont){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$5,
		             symbol_map$5,
		             ,
		             bind$8,
		             return$9,
		             map$17,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$3]),
		        let$ = open[3];
		       function a(elt, cont){return cont([0, elt[1][1]]);}
		       return caml_exact_trampoline_cps_call$1
		               (Map[25],
		                state,
		                k,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          b,
		                          a,
		                          function(t){return cont(1 + value$4(t, 0) | 0);});
		                });
		      }
		      function apply(replica, state, param, cont){
		       switch(param[0]){
		         case 0:
		          var v = param[2], k = param[1];
		          return caml_exact_trampoline_cps_call$1
		                  (next_timestamp,
		                   state,
		                   k,
		                   function(timestamp){
		                    var id = [0, timestamp, replica], delta = [0, k, id, v];
		                    return caml_exact_trampoline_cps_call$0
		                            (apply_delta,
		                             replica,
		                             state,
		                             delta,
		                             function(a){return cont([0, 0, [0, delta], a]);});
		                   });
		         case 1:
		          var op = param[2], k$0 = param[1];
		          return caml_exact_trampoline_cps_call$1
		                  (Map[25],
		                   state,
		                   k$0,
		                   function(a){
		                    if(a){
		                     var elt = a[1], a = elt[2];
		                     if(a){
		                      var value = a[1], id = elt[1];
		                      return caml_trampoline_cps_call4
		                              (Element[8],
		                               replica,
		                               value,
		                               op,
		                               function(match){
		                                var value = match[3], delta_v = match[2], res = match[1];
		                                return caml_trampoline_cps_call3
		(map$17,
		 delta_v,
		 function(delta_v, cont){return cont([1, k$0, id, delta_v]);},
		 function(delta){
		  return caml_exact_trampoline_cps_call$0
		          (Map[17],
		           state,
		           k$0,
		           [0, elt[1], [0, value]],
		           function(state){return cont([0, [0, res], delta, state]);});
		 });
		                               });
		                     }
		                    }
		                    function b(m, cont){
		                     return caml_trampoline_cps_call6
		                             (m, 0, 0, aPs, Key[19], k$0, cont);
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (warn$1,
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (a, b, function(match){return cont([0, 0, 0, state]);});
		                             });
		                   });
		         case 2:
		          var k$1 = param[1];
		          return caml_exact_trampoline_cps_call$1
		                  (Map[25],
		                   state,
		                   k$1,
		                   function(match){
		                    if(match && match[1][2]) return cont([0, 1, 0, state]);
		                    return cont([0, 0, 0, state]);
		                   });
		         default:
		          var k$2 = param[1];
		          return caml_exact_trampoline_cps_call$1
		                  (Map[25],
		                   state,
		                   k$2,
		                   function(match){
		                    if(match){
		                     var elt = match[1], delta = [2, k$2, elt[1]];
		                     return caml_exact_trampoline_cps_call$0
		                             (apply_delta,
		                              replica,
		                              state,
		                              delta,
		                              function(a){return cont([0, 0, [0, delta], a]);});
		                    }
		                    function a(m, cont){
		                     return caml_trampoline_cps_call6
		                             (m, 0, 0, aPt, Key[19], k$2, cont);
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (warn$1,
		                             0,
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (b, a, function(match){return cont([0, 0, 0, state]);});
		                             });
		                   });
		       }
		      }
		      function add(key_pattern, value_pattern, cont){
		       return cont
		               (repeat$0
		                 (of_match1
		                   (function(delta, f, cont){
		                     if(0 !== delta[0]) return cont(empty$6);
		                     var
		                      value = delta[3],
		                      key = delta[1],
		                      open =
		                        g
		                         ([0,
		                           symbol_bind$2,
		                           symbol_map$2,
		                           ,
		                           bind$5,
		                           return$6,
		                           map$11,
		                           ,
		                           ,
		                           ,
		                           ,
		                           Let_syntax$1]),
		                      let$ = open[3];
		                     function a(key_result, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (match1, value_pattern, value, key_result, cont);
		                     }
		                     return caml_exact_trampoline_cps_call$0
		                             (match1,
		                              key_pattern,
		                              key,
		                              f,
		                              function(b){
		                               return caml_trampoline_cps_call3(let$, b, a, cont);
		                              });
		                    })));
		      }
		      function element(key_pattern, delta_pattern, cont){
		       return cont
		               (repeat$0
		                 (of_match1
		                   (function(delta, f, cont){
		                     if(1 !== delta[0]) return cont(empty$6);
		                     var
		                      delta$0 = delta[3],
		                      key = delta[1],
		                      open =
		                        g
		                         ([0,
		                           symbol_bind$2,
		                           symbol_map$2,
		                           ,
		                           bind$5,
		                           return$6,
		                           map$11,
		                           ,
		                           ,
		                           ,
		                           ,
		                           Let_syntax$1]),
		                      let$ = open[3];
		                     function a(key_result, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (match1, delta_pattern, delta$0, key_result, cont);
		                     }
		                     return caml_exact_trampoline_cps_call$0
		                             (match1,
		                              key_pattern,
		                              key,
		                              f,
		                              function(b){
		                               return caml_trampoline_cps_call3(let$, b, a, cont);
		                              });
		                    })));
		      }
		      function remove(key_pattern, cont){
		       return cont
		               (repeat$0
		                 (of_match1
		                   (function(delta, f, cont){
		                     if(2 !== delta[0]) return cont(empty$6);
		                     var key = delta[1];
		                     return caml_exact_trampoline_cps_call$0
		                             (match1, key_pattern, key, f, cont);
		                    })));
		      }
		      return cont
		              ([0,
		                Map,
		                Operation,
		                Delta,
		                element_schema_versioned,
		                element_schema,
		                apply_delta,
		                ,
		                apply,
		                [0, add, element, remove]]);
		     });
		                                   });
		                         });
		               }
		               function Make_op(Incremental, Key, a, Element, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (Make$23,
		                         Key,
		                         dummy,
		                         Element,
		                         function(include){
		                          var
		                           Map = include[1],
		                           Operation = include[2],
		                           Delta = include[3],
		                           element_schema = include[5],
		                           apply_delta = include[6],
		                           apply = include[8],
		                           Pattern = include[9];
		                          function state_schema_versioned(param, cont){
		                           function decode(map, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (Incremental[82][4],
		                                     0,
		                                     map,
		                                     function(a){return cont([0, [0, map, a]]);});
		                           }
		                           function encode(param, cont){
		                            var map = param[1];
		                            return cont(map);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (Map[110],
		                                    element_schema,
		                                    function(map_schema){
		                                     return cont(map$14(decode, encode, map_schema));
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   dummy,
		                                   function(state_schema){
		                                    function schema_versioned(schematic_version, cont){
		                                     return caml_trampoline_cps_call2
		     (schematic_version,
		      V$5,
		      function(schematic_schema_version){
		       return caml_trampoline_cps_call2
		               (Element[6][1],
		                schematic_version,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (Map[109],
		                          schematic_version,
		                          a,
		                          function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned,
		     function(param, cont){return cont(0);},
		     function(schema){
		      var
		       Init = [0, schema_versioned, schema],
		       Monad = Element[7];
		      function apply_delta$0(replica, state, delta, cont){
		       return caml_exact_trampoline_cps_call$0
		               (apply_delta,
		                replica,
		                state[1],
		                delta,
		                function(map){
		                 return caml_exact_trampoline_cps_call$1
		                         (Incremental[82][5],
		                          state[2],
		                          map,
		                          function(match){return cont([0, map, state[2]]);});
		                });
		      }
		      function apply$0(replica, state, operation, cont){
		       return caml_exact_trampoline_cps_call$0
		               (apply,
		                replica,
		                state[1],
		                operation,
		                function(match){
		                 var map = match[3], delta = match[2], result = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (Incremental[82][5],
		                          state[2],
		                          map,
		                          function(match){
		                           return cont([0, result, delta, [0, map, state[2]]]);
		                          });
		                });
		      }
		      return caml_trampoline_cps_call2
		              (Operation[15],
		               [0, Delta, apply_delta$0, apply$0],
		               function(include){
		                var
		                 delta_schema_versioned = include[1],
		                 delta_schema = include[2],
		                 apply_delta = include[3],
		                 apply = include[4];
		                function make(values, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (Map[34],
		                          values,
		                          function(value, cont){
		                           return caml_trampoline_cps_call2
		                                   (Element[10],
		                                    value,
		                                    function(a){return cont([0, aPu, [0, a]]);});
		                          },
		                          function(map){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Incremental[82][4],
		                                    0,
		                                    map,
		                                    function(a){return cont([0, map, a]);});
		                          });
		                }
		                function view(state, cont){
		                 g(Monad);
		                 var a = Incremental[82][6].call(null, state[2]);
		                 return caml_exact_trampoline_cps_call$5
		                         (unordered_fold$0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          a,
		                          Map[111],
		                          function(key, data, map, cont){
		                           var match = data[2];
		                           if(! match) return cont(map);
		                           var value = match[1];
		                           return caml_trampoline_cps_call2
		                                   (Element[11],
		                                    value,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (Map[17], map, key, a, cont);
		                                    });
		                          },
		                          function(key, param, map, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Map[27], map, key, cont);
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (join$6, 0, 0, a, cont);
		                          });
		                }
		                var init = Map[111];
		                function add(k, v, cont){
		                 return caml_trampoline_cps_call2
		                         (Operation[2], [0, k, v], cont);
		                }
		                function element(k, op, cont){
		                 return caml_trampoline_cps_call2
		                         (Operation[2], [1, k, op], cont);
		                }
		                function element$0(k, op, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (element,
		                          k,
		                          op,
		                          function(a){
		                           return caml_trampoline_cps_call2(Operation[11], a, cont);
		                          });
		                }
		                function has(k, cont){
		                 return caml_trampoline_cps_call2(Operation[2], [2, k], cont);
		                }
		                function remove(k, cont){
		                 return caml_trampoline_cps_call2(Operation[2], [3, k], cont);
		                }
		                return cont
		                        ([0,
		                          Map,
		                          Operation,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Pattern,
		                          state_schema_versioned,
		                          state_schema,
		                          Init,
		                          Monad,
		                          delta_schema_versioned,
		                          delta_schema,
		                          apply_delta,
		                          apply,
		                          make,
		                          view,
		                          init,
		                          add,
		                          element,
		                          element$0,
		                          has,
		                          remove]);
		               });
		     });
		                                   });
		                         });
		               }
		               function schema_versioned$368(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_delta_schema_v, cont){
		                                    function descriptor(schematic_param_delta_schema_v, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_delta,
		  0,
		  2,
		  [0, schematic_param_delta_schema_v],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(c){
		       var
		        b =
		          [0, [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, c], 0, 0], a];
		       return caml_exact_trampoline_cps_call
		               (Set$3[70],
		                schematic_version,
		                function(a){
		                 return cont
		                         ([7,
		                           function(param, cont){
		                            var
		                             a = param[2],
		                             delta = a[2][1],
		                             timestamp = a[1],
		                             parents = param[1];
		                            return cont([0, parents, timestamp, delta]);
		                           },
		                           function(param, cont){
		                            var
		                             delta = param[3],
		                             timestamp = param[2],
		                             parents = param[1];
		                            return cont([0, parents, [0, timestamp, [0, delta, 0]]]);
		                           },
		                           [0, [0, 0, 0, 0, 0, cst_parents, 0, 2, [0, a], 0, 0], b]]);
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$214[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_delta,
		 schematic_param_delta_schema_v,
		 function(schematic_param_delta_schema_v, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_delta_schema_v,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_delta_schema_v,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                Map$2 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$2, comparator$2, schema_versioned$358]]),
		                empty$29 = Map$2[111];
		               function schema_versioned$369(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_trampoline_cps_call3
		                                  (Map$2[109],
		                                   schematic_version,
		                                   int_schema,
		                                   function(a){return cont([0, aPv, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$369,
		                 [function(param, cont){return cont(0);}]);
		               var
		                Replica_timestamps =
		                  caml_callback
		                   (M$3, [[0, comparator$55, schema_versioned$360]]);
		               function log_schema(commit_schema_versioned, version, cont){
		                function decode(list, cont){
		                 return caml_exact_trampoline_cps_call
		                         (deconstruct,
		                          list,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    a,
		                                    function(commit, cont){
		                                     var timestamp = commit[2];
		                                     return cont([0, timestamp, commit]);
		                                    },
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_sequence$3,
		      [0, comparator$55],
		      a,
		      function(param){
		       var variant = param[1];
		       if(17724 <= variant){
		        var map = param[2];
		        return cont([0, map]);
		       }
		       var key = param[2];
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$128,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (a, _10$3, key, function(a){return cont([1, a]);});
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (commit_schema_versioned,
		                         version,
		                         function(a){
		                          var schema = list_schema(a);
		                          return cont(map$14(decode, encode, schema));
		                         });
		               }
		               function schema_versioned$370(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    function descriptor(schematic_param_a_schema_versi, cont){
		                                     var
		                                      a =
		[0,
		 [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, int_schema], 0, 0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_value,
		   0,
		   2,
		   [0, schematic_param_a_schema_versi],
		   0,
		   0],
		  0]];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$358,
		      schematic_version,
		      function(b){
		       return cont
		               ([7,
		                 function(param, cont){
		                  var
		                   a = param[2],
		                   value = a[2][1],
		                   timestamp = a[1],
		                   replica = param[1];
		                  return cont([0, replica, timestamp, value]);
		                 },
		                 function(param, cont){
		                  var
		                   value = param[3],
		                   timestamp = param[2],
		                   replica = param[1];
		                  return cont([0, replica, [0, timestamp, [0, value, 0]]]);
		                 },
		                 [0, [0, 0, 0, 0, 0, cst_replica, 0, 3, [0, b], 0, 0], a]]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$215[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_a$0,
		 schematic_param_a_schema_versi,
		 function(schematic_param_a_schema_versi, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_a_schema_versi,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_a_schema_versi,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               var cst_Set = "Set";
		               function schema_versioned$371(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_data_schema_ve, cont){
		                                    function descriptor(schematic_param_data_schema_ve, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_value,
		  0,
		  2,
		  [0, schematic_param_data_schema_ve],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(b){
		       return cont
		               ([11,
		                 0,
		                 [0,
		                  [0,
		                   function(param, cont){
		                    var f1 = param[2], f0 = param[1];
		                    return cont([0, f0, f1]);
		                   },
		                   function(param, cont){
		                    var f1 = param[2], f0 = param[1];
		                    return cont([0, [0, f0, f1]]);
		                   },
		                   1,
		                   0,
		                   cst_set,
		                   cst_Set,
		                   [0,
		                    0,
		                    0,
		                    [7,
		                     function(param, cont){
		                      var value = param[2][1], timestamp = param[1];
		                      return cont([0, timestamp, value]);
		                     },
		                     function(param, cont){
		                      var value = param[2], timestamp = param[1];
		                      return cont([0, timestamp, [0, value, 0]]);
		                     },
		                     [0, [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, b], 0, 0], a]],
		                    0],
		                   0],
		                  0],
		                 0]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$216[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_data,
		 schematic_param_data_schema_ve,
		 function(schematic_param_data_schema_ve, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_data_schema_ve,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_data_schema_ve,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, , a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function schema_versioned$372(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_key_schema_ver,
		                                    schematic_param_data_schema_ve,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_key_schema_ver,
		                                     schematic_param_data_schema_ve){
		                                     return [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){
		        var f2 = param[3], f1 = param[2], f0 = param[1];
		        return cont([0, f0, f1, f2]);
		       },
		       function(param, cont){
		        var f2 = param[3], f1 = param[2], f0 = param[1];
		        return cont([0, [0, f0, f1, f2]]);
		       },
		       1,
		       aPG,
		       cst_set,
		       cst_Set,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var
		           a = param[2],
		           value = a[2][1],
		           overridden = a[1],
		           key = param[1];
		          return cont([0, key, overridden, value]);
		         },
		         function(param, cont){
		          var value = param[3], overridden = param[2], key = param[1];
		          return cont([0, key, [0, overridden, [0, value, 0]]]);
		         },
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_set,
		           0,
		           2,
		           [0, schematic_param_key_schema_ver],
		           0,
		           0],
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            "overridden",
		            0,
		            2,
		            [0, [0, 0, 0, [3, schematic_param_key_schema_ver], 0]],
		            0,
		            0],
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_value,
		             0,
		             2,
		             [0, schematic_param_data_schema_ve],
		             0,
		             0],
		            0]]]],
		        0],
		       0],
		      0],
		     0];
		                                    }
		                                    var
		                                     schematic_schema_id = match$217[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_key,
		 schematic_param_key_schema_ver,
		 function(schematic_param_key_schema_ver, cont){
		  return cont
		          ([1,
		            cst_data,
		            schematic_param_data_schema_ve,
		            function(schematic_param_data_schema_ve, cont){
		             return cont
		                     ([0,
		                       schematic_schema_id,
		                       descriptor
		                        (schematic_param_key_schema_ver,
		                         schematic_param_data_schema_ve)]);
		            }]);
		 }]],
		                                     a =
		                                       descriptor
		(schematic_param_key_schema_ver,
		 schematic_param_data_schema_ve),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, , , a, schematic_parametric]);
		      }
		      if(! match) return b();
		      var name = match[1];
		      return caml_exact_trampoline_cps_call(to_id, name, b);
		     });
		                                   });
		                         });
		               }
		               function Make$24(Crdt, View){
		                var
		                 Operation = Crdt[1],
		                 state_schema_versioned = Crdt[2],
		                 delta_schema_versioned = Crdt[4],
		                 apply = Crdt[8],
		                 apply_delta = Crdt[9],
		                 make = Crdt[10];
		                function view(state, cont){
		                 var a = View[1];
		                 return caml_trampoline_cps_call2
		                         (Crdt[11],
		                          state,
		                          function(b){
		                           return caml_trampoline_cps_call3(Crdt[7][2], b, a, cont);
		                          });
		                }
		                return [0,
		                        Operation,
		                        state_schema_versioned,
		                        ,
		                        delta_schema_versioned,
		                        ,
		                        ,
		                        ,
		                        apply,
		                        apply_delta,
		                        make,
		                        view];
		               }
		               function schema_versioned$373(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_init_schema_ve,
		                                    schematic_param_delta_schema_v,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_init_schema_ve,
		                                     schematic_param_delta_schema_v,
		                                     cont){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(b){
		       var
		        a =
		          [0, [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, b], 0, 0], 0];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$360,
		                schematic_version,
		                function(c){
		                 var
		                  b = [0, [0, 0, 0, 0, 0, cst_parent, 0, 3, [0, c], 0, 0], a];
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$360,
		                          schematic_version,
		                          function(d){
		                           var
		                            a =
		                              [0,
		                               [0,
		                                function(param, cont){
		                                 var f2 = param[3], f1 = param[2], f0 = param[1];
		                                 return cont([2, f0, f1, f2]);
		                                },
		                                function(param, cont){
		                                 if(2 !== param[0]) return cont(0);
		                                 var f2 = param[3], f1 = param[2], f0 = param[1];
		                                 return cont([0, [0, f0, f1, f2]]);
		                                },
		                                1,
		                                0,
		                                cst_move,
		                                "Move",
		                                [0,
		                                 0,
		                                 0,
		                                 [7,
		                                  function(param, cont){
		                                   var
		                                    a = param[2],
		                                    timestamp = a[2][1],
		                                    parent = a[1],
		                                    id = param[1];
		                                   return cont([0, id, parent, timestamp]);
		                                  },
		                                  function(param, cont){
		                                   var timestamp = param[3], parent = param[2], id = param[1];
		                                   return cont([0, id, [0, parent, [0, timestamp, 0]]]);
		                                  },
		                                  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, d], 0, 0], b]],
		                                 0],
		                                0],
		                               0],
		                            c =
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_delta,
		                                0,
		                                2,
		                                [0, schematic_param_delta_schema_v],
		                                0,
		                                0],
		                               0];
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$360,
		                                    schematic_version,
		                                    function(e){
		                                     var
		                                      b =
		[0,
		 [0,
		  function(param, cont){
		   var f1 = param[2], f0 = param[1];
		   return cont([1, f0, f1]);
		  },
		  function(param, cont){
		   if(1 !== param[0]) return cont(0);
		   var f1 = param[2], f0 = param[1];
		   return cont([0, [0, f0, f1]]);
		  },
		  1,
		  0,
		  cst_element,
		  cst_Element,
		  [0,
		   0,
		   0,
		   [7,
		    function(param, cont){
		     var delta = param[2][1], id = param[1];
		     return cont([0, id, delta]);
		    },
		    function(param, cont){
		     var delta = param[2], id = param[1];
		     return cont([0, id, [0, delta, 0]]);
		    },
		    [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, e], 0, 0], c]],
		   0],
		  0],
		 a],
		                                      d =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_value,
		  0,
		  2,
		  [0, schematic_param_init_schema_ve],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(c){
		       var
		        a = [0, [0, 0, 0, 0, 0, cst_parent, 0, 3, [0, c], 0, 0], d];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$360,
		                schematic_version,
		                function(c){
		                 return cont
		                         ([11,
		                           0,
		                           [0,
		                            [0,
		                             function(param, cont){
		                              var f2 = param[3], f1 = param[2], f0 = param[1];
		                              return cont([0, f0, f1, f2]);
		                             },
		                             function(param, cont){
		                              if(0 !== param[0]) return cont(0);
		                              var f2 = param[3], f1 = param[2], f0 = param[1];
		                              return cont([0, [0, f0, f1, f2]]);
		                             },
		                             1,
		                             0,
		                             cst_add,
		                             cst_Add,
		                             [0,
		                              0,
		                              0,
		                              [7,
		                               function(param, cont){
		                                var
		                                 a = param[2],
		                                 value = a[2][1],
		                                 parent = a[1],
		                                 id = param[1];
		                                return cont([0, id, parent, value]);
		                               },
		                               function(param, cont){
		                                var value = param[3], parent = param[2], id = param[1];
		                                return cont([0, id, [0, parent, [0, value, 0]]]);
		                               },
		                               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a]],
		                              0],
		                             0],
		                            b],
		                           0]);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$218[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_init,
		 schematic_param_init_schema_ve,
		 function(schematic_param_init_schema_ve, cont){
		  return cont
		          ([1,
		            cst_delta,
		            schematic_param_delta_schema_v,
		            function(schematic_param_delta_schema_v, cont){
		             return caml_exact_trampoline_cps_call$1
		                     (descriptor,
		                      schematic_param_init_schema_ve,
		                      schematic_param_delta_schema_v,
		                      function(a){return cont([0, schematic_schema_id, a]);});
		            }]);
		 }]];
		                                    return caml_exact_trampoline_cps_call$1
		    (descriptor,
		     schematic_param_init_schema_ve,
		     schematic_param_delta_schema_v,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               function Make$25(Key, Value, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (Make$23,
		                         Key,
		                         Value,
		                         Value,
		                         function(include){
		                          var
		                           Map = include[1],
		                           Operation = include[2],
		                           Delta = include[3],
		                           element_schema_versioned = include[4],
		                           apply_delta = include[6],
		                           apply = include[8],
		                           Pattern = include[9];
		                          function state_schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call
		     (element_schema_versioned,
		      schematic_version,
		      function(a){
		       return caml_trampoline_cps_call3
		               (Map[109],
		                schematic_version,
		                a,
		                function(a){return cont([0, 0, 0, a[3], a[4]]);});
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    function schema_versioned(schematic_version, cont){
		                                     return caml_trampoline_cps_call2
		     (schematic_version,
		      V$5,
		      function(schematic_schema_version){
		       return caml_trampoline_cps_call2
		               (Value[6][1],
		                schematic_version,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (Map[109],
		                          schematic_version,
		                          a,
		                          function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned,
		     function(param, cont){return cont(0);},
		     function(schema){
		      var Init = [0, schema_versioned, schema], Monad = Value[7];
		      return caml_trampoline_cps_call2
		              (Operation[15],
		               [0, Delta, apply_delta, apply],
		               function(include){
		                var
		                 delta_schema_versioned = include[1],
		                 delta_schema = include[2],
		                 apply_delta = include[3],
		                 apply = include[4];
		                function make(values, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (Map[34],
		                          values,
		                          function(value, cont){
		                           return caml_trampoline_cps_call2
		                                   (Value[10],
		                                    value,
		                                    function(a){return cont([0, aPI, [0, a]]);});
		                          },
		                          cont);
		                }
		                function view(state, cont){
		                 var
		                  open = g(Monad),
		                  let$ = open[4],
		                  symbol_map = open[2],
		                  a = Map[114];
		                 return caml_exact_trampoline_cps_call$2
		                         (Map[89],
		                          0,
		                          0,
		                          0,
		                          state,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter_map$1,
		                                    b,
		                                    function(param, cont){
		                                     var data = param[2], key = param[1];
		                                     return caml_trampoline_cps_call3
		     (map$17,
		      data[2],
		      function(value, cont){
		       function a(data, cont){return cont([0, key, data]);}
		       return caml_trampoline_cps_call2
		               (Value[11],
		                value,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      },
		      cont);
		                                    },
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (to_binable,
		      b,
		      function(b){
		       return caml_trampoline_cps_call2
		               (Monad[9],
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                var init = Map[111];
		                function add(k, v, cont){
		                 return caml_trampoline_cps_call2
		                         (Operation[2], [0, k, v], cont);
		                }
		                function element(k, op, cont){
		                 return caml_trampoline_cps_call2
		                         (Operation[2], [1, k, op], cont);
		                }
		                function element$0(k, op, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (element,
		                          k,
		                          op,
		                          function(a){
		                           return caml_trampoline_cps_call2(Operation[11], a, cont);
		                          });
		                }
		                function has(k, cont){
		                 return caml_trampoline_cps_call2(Operation[2], [2, k], cont);
		                }
		                function remove(k, cont){
		                 return caml_trampoline_cps_call2(Operation[2], [3, k], cont);
		                }
		                return cont
		                        ([0,
		                          Map,
		                          Operation,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Pattern,
		                          state_schema_versioned,
		                          state_schema,
		                          Init,
		                          Monad,
		                          delta_schema_versioned,
		                          delta_schema,
		                          apply_delta,
		                          apply,
		                          make,
		                          view,
		                          init,
		                          add,
		                          element,
		                          element$0,
		                          has,
		                          remove]);
		               });
		     });
		                                   });
		                         });
		               }
		               function bPy(Key, Value, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Make$25,
		                         Key,
		                         [0,
		                          ,
		                          Value[3],
		                          ,
		                          Value[5],
		                          ,
		                          Value[7],
		                          Value[8],
		                          Value[9],
		                          Value[10],
		                          Value[11],
		                          Value[12]],
		                         function(include){
		                          var
		                           Map = include[1],
		                           Operation = include[2],
		                           state_schema_versioned = include[8],
		                           Init = include[10],
		                           Monad = include[11],
		                           delta_schema_versioned = include[12],
		                           apply_delta = include[14],
		                           apply = include[15],
		                           make = include[16],
		                           view = include[17],
		                           add = include[19],
		                           element = include[21],
		                           has = include[22],
		                           remove = include[23];
		                          function equal(l, r, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (Map[55], Value[1], l, r, cont);
		                          }
		                          function diff(previous, current, cont){
		                           function to_operation(param, cont){
		                            var a = param[2], variant = a[1], id = param[1];
		                            if(847852583 === variant)
		                             return caml_exact_trampoline_cps_call(remove, id, cont);
		                            if(1013247643 <= variant){
		                             a = a[2];
		                             var current = a[2], previous = a[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (Value[13],
		                                      previous,
		                                      current,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (element, id, a, cont);
		                                      });
		                            }
		                            var data = a[2];
		                            return caml_exact_trampoline_cps_call$1(add, id, data, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (Map[63],
		                                    previous,
		                                    current,
		                                    Value[1],
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (map$11,
		      a,
		      to_operation,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (to_binable,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2(Operation[13], a, cont);
		                });
		      });
		                                    });
		                          }
		                          return cont
		                                  ([0,
		                                    [0,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     ,
		                                     Map[63]],
		                                    Operation,
		                                    state_schema_versioned,
		                                    ,
		                                    delta_schema_versioned,
		                                    ,
		                                    Init,
		                                    Monad,
		                                    apply,
		                                    apply_delta,
		                                    make,
		                                    view,
		                                    ,
		                                    add,
		                                    ,
		                                    element,
		                                    has,
		                                    remove,
		                                    ,
		                                    equal,
		                                    diff]);
		                         });
		               }
		               function bOC(Key, Value, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Make$25,
		                         Key,
		                         [0,
		                          ,
		                          Value[3],
		                          ,
		                          Value[5],
		                          ,
		                          Value[7],
		                          Value[8],
		                          Value[9],
		                          Value[10],
		                          Value[11],
		                          Value[12]],
		                         function(include){
		                          var
		                           Map = include[1],
		                           Operation = include[2],
		                           Pattern = include[7],
		                           state_schema_versioned = include[8],
		                           state_schema = include[9],
		                           Init = include[10],
		                           Monad = include[11],
		                           delta_schema_versioned = include[12],
		                           delta_schema = include[13],
		                           apply_delta = include[14],
		                           apply = include[15],
		                           make = include[16],
		                           view = include[17],
		                           init = include[18],
		                           add = include[19],
		                           element = include[20],
		                           element$0 = include[21],
		                           has = include[22],
		                           remove = include[23];
		                          function equal(m1, m2, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (Map[55], Value[1], m1, m2, cont);
		                          }
		                          function diff(previous, current, cont){
		                           function to_operation(param, cont){
		                            var match = param[2], id = param[1], variant = match[1];
		                            if(847852583 === variant)
		                             return caml_exact_trampoline_cps_call(remove, id, cont);
		                            var data = 1013247643 <= variant ? match[2][2] : match[2];
		                            return caml_exact_trampoline_cps_call$1(add, id, data, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (Map[63],
		                                    previous,
		                                    current,
		                                    Value[1],
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (map$11,
		      a,
		      to_operation,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (to_binable,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2(Operation[13], a, cont);
		                });
		      });
		                                    });
		                          }
		                          return cont
		                                  ([0,
		                                    [0,
		                                     Map[3],
		                                     Map[4],
		                                     Map[5],
		                                     Map[6],
		                                     Map[7],
		                                     Map[8],
		                                     Map[9],
		                                     Map[10],
		                                     Map[11],
		                                     Map[12],
		                                     Map[13],
		                                     Map[14],
		                                     Map[15],
		                                     Map[16],
		                                     Map[17],
		                                     Map[18],
		                                     Map[19],
		                                     Map[20],
		                                     Map[21],
		                                     Map[22],
		                                     Map[23],
		                                     Map[24],
		                                     Map[25],
		                                     Map[26],
		                                     Map[27],
		                                     Map[28],
		                                     Map[29],
		                                     Map[30],
		                                     Map[31],
		                                     Map[32],
		                                     Map[33],
		                                     Map[34],
		                                     Map[35],
		                                     Map[36],
		                                     Map[37],
		                                     Map[38],
		                                     Map[39],
		                                     Map[40],
		                                     Map[41],
		                                     Map[42],
		                                     Map[43],
		                                     Map[44],
		                                     Map[45],
		                                     Map[46],
		                                     Map[47],
		                                     Map[48],
		                                     Map[49],
		                                     Map[50],
		                                     Map[51],
		                                     Map[52],
		                                     Map[53],
		                                     Map[54],
		                                     Map[55],
		                                     Map[56],
		                                     Map[57],
		                                     Map[58],
		                                     Map[59],
		                                     Map[60],
		                                     Map[61],
		                                     Map[63],
		                                     Map[64],
		                                     Map[65],
		                                     Map[66],
		                                     Map[67],
		                                     Map[68],
		                                     Map[69],
		                                     Map[70],
		                                     Map[71],
		                                     Map[72],
		                                     Map[73],
		                                     Map[74],
		                                     Map[75],
		                                     Map[76],
		                                     Map[77],
		                                     Map[78],
		                                     Map[79],
		                                     Map[80],
		                                     Map[81],
		                                     Map[82],
		                                     Map[83],
		                                     Map[84],
		                                     Map[85],
		                                     Map[86],
		                                     Map[87],
		                                     Map[88],
		                                     Map[89],
		                                     Map[90],
		                                     Map[91],
		                                     Map[92],
		                                     Map[95],
		                                     Map[96],
		                                     Map[97],
		                                     Map[98],
		                                     Map[99],
		                                     Map[100],
		                                     Map[103],
		                                     Map[104],
		                                     Map[105],
		                                     Map[106],
		                                     Map[107],
		                                     Map[108],
		                                     Map[109],
		                                     Map[110],
		                                     Map[111],
		                                     Map[112],
		                                     Map[113],
		                                     Map[114],
		                                     Map[115],
		                                     Map[116],
		                                     Map[117],
		                                     Map[118],
		                                     Map[119],
		                                     Map[120],
		                                     Map[121],
		                                     Map[122],
		                                     Map[123],
		                                     Map[124],
		                                     Map[125],
		                                     Map[126],
		                                     Map[127]],
		                                    Operation,
		                                    state_schema_versioned,
		                                    state_schema,
		                                    delta_schema_versioned,
		                                    delta_schema,
		                                    Init,
		                                    Monad,
		                                    apply,
		                                    apply_delta,
		                                    make,
		                                    view,
		                                    init,
		                                    add,
		                                    element,
		                                    element$0,
		                                    has,
		                                    remove,
		                                    Pattern,
		                                    equal,
		                                    diff]);
		                         });
		               }
		               function cm(b, a, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Make$25,
		                         b,
		                         a,
		                         function(b){
		                          var a = b[1];
		                          return cont
		                                  ([0,
		                                    [0,
		                                     a[3],
		                                     a[4],
		                                     a[5],
		                                     a[6],
		                                     a[7],
		                                     a[8],
		                                     a[9],
		                                     a[10],
		                                     a[11],
		                                     a[12],
		                                     a[13],
		                                     a[14],
		                                     a[15],
		                                     a[16],
		                                     a[17],
		                                     a[18],
		                                     a[19],
		                                     a[20],
		                                     a[21],
		                                     a[22],
		                                     a[23],
		                                     a[24],
		                                     a[25],
		                                     a[26],
		                                     a[27],
		                                     a[28],
		                                     a[29],
		                                     a[30],
		                                     a[31],
		                                     a[32],
		                                     a[33],
		                                     a[34],
		                                     a[35],
		                                     a[36],
		                                     a[37],
		                                     a[38],
		                                     a[39],
		                                     a[40],
		                                     a[41],
		                                     a[42],
		                                     a[43],
		                                     a[44],
		                                     a[45],
		                                     a[46],
		                                     a[47],
		                                     a[48],
		                                     a[49],
		                                     a[50],
		                                     a[51],
		                                     a[52],
		                                     a[53],
		                                     a[54],
		                                     a[55],
		                                     a[56],
		                                     a[57],
		                                     a[58],
		                                     a[59],
		                                     a[60],
		                                     a[61],
		                                     a[63],
		                                     a[64],
		                                     a[65],
		                                     a[66],
		                                     a[67],
		                                     a[68],
		                                     a[69],
		                                     a[70],
		                                     a[71],
		                                     a[72],
		                                     a[73],
		                                     a[74],
		                                     a[75],
		                                     a[76],
		                                     a[77],
		                                     a[78],
		                                     a[79],
		                                     a[80],
		                                     a[81],
		                                     a[82],
		                                     a[83],
		                                     a[84],
		                                     a[85],
		                                     a[86],
		                                     a[87],
		                                     a[88],
		                                     a[89],
		                                     a[90],
		                                     a[91],
		                                     a[92],
		                                     a[95],
		                                     a[96],
		                                     a[97],
		                                     a[98],
		                                     a[99],
		                                     a[100],
		                                     a[103],
		                                     a[104],
		                                     a[105],
		                                     a[106],
		                                     a[107],
		                                     a[108],
		                                     a[109],
		                                     a[110],
		                                     a[111],
		                                     a[112],
		                                     a[113],
		                                     a[114],
		                                     a[115],
		                                     a[116],
		                                     a[117],
		                                     a[118],
		                                     a[119],
		                                     a[120],
		                                     a[121],
		                                     a[122],
		                                     a[123],
		                                     a[124],
		                                     a[125],
		                                     a[126],
		                                     a[127]],
		                                    b[2],
		                                    b[8],
		                                    b[9],
		                                    b[12],
		                                    b[13],
		                                    b[10],
		                                    b[11],
		                                    b[15],
		                                    b[14],
		                                    b[16],
		                                    b[17],
		                                    b[18],
		                                    b[19],
		                                    b[20],
		                                    b[21],
		                                    b[22],
		                                    b[23],
		                                    b[7]]);
		                         });
		               }
		               function to_sequence$5(node){
		                function f(param){
		                 if(! param) return 0;
		                 var match = param[1];
		                 if(match){
		                  var tail = param[2], siblings = match[2], first = match[1];
		                  return [1, first, [0, first[3], [0, siblings, tail]]];
		                 }
		                 var tail$0 = param[2];
		                 return [0, tail$0];
		                }
		                var init = [0, node, 0];
		                return [0, init, f];
		               }
		               function up_edges(tree_transform, node){
		                function f(param, cont){
		                 if(! param) return cont(0);
		                 var a = param[1], match = a[2], parent = a[1];
		                 if(match){
		                  var
		                   tail = param[2],
		                   siblings = match[2],
		                   first = match[1],
		                   this$ = tree_transform(first);
		                  return cont
		                          ([1,
		                            [0, this$, parent],
		                            [0,
		                             [0, [0, this$], first[3]],
		                             [0, [0, parent, siblings], tail]]]);
		                 }
		                 var tail$0 = param[2];
		                 return cont([0, tail$0]);
		                }
		                var init = [0, [0, 0, node], 0];
		                return [0, init, f];
		               }
		               function Make$26(Element, cont){
		                var
		                 include = Monadic$0(),
		                 v = include[1],
		                 symbol_bind = include[3],
		                 symbol_map = include[4],
		                 bind = include[6],
		                 return$ = include[7],
		                 map = include[8],
		                 Let_syntax = include[11],
		                 Apply = include[14],
		                 letrec_function_context = [];
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, aPJ, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$360,
		                                      schematic_version,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (option_schema,
		        a,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (timestamped_schema_versioned,
		                  schematic_version,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (b,
		                            a,
		                            function(b){
		                             var
		                              a =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_parent,
		                                  0,
		                                  2,
		                                  [0, schema_versioned$7(schematic_version, b)],
		                                  0,
		                                  0],
		                                 0];
		                             return caml_exact_trampoline_cps_call
		                                     (Element[2],
		                                      schematic_version,
		                                      function(c){
		                                       var
		b = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], a];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$360,
		        schematic_version,
		        function(a){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var
		               a = param[2],
		               parent = a[2][1],
		               value = a[1],
		               id = param[1];
		              return cont([0, id, value, parent]);
		             },
		             function(param, cont){
		              var parent = param[3], value = param[2], id = param[1];
		              return cont([0, id, [0, value, [0, parent, 0]]]);
		             },
		             [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                var
		                 Operation =
		                   [0,
		                    ,
		                    v,
		                    ,
		                    symbol_bind,
		                    symbol_map,
		                    ,
		                    bind,
		                    return$,
		                    map,
		                    ,
		                    ,
		                    Let_syntax,
		                    ,
		                    ,
		                    Apply];
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          function parent(param){
		                           var parent = param[3], hd = parent[1];
		                           return hd[2];
		                          }
		                          function compare(a, param, cont){
		                           var right = param[1], left = a[1];
		                           return caml_trampoline_cps_call3
		                                   (compare$160, left, right, cont);
		                          }
		                          function sexp_of_t(param, cont){
		                           var id = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_t$129, id, cont);
		                          }
		                          var
		                           include = Make$2([0, compare, sexp_of_t]),
		                           comparator = include[16];
		                          function add(value, set, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (add$4, set, value, cont);
		                          }
		                          var empty = empty$8([0, comparator]);
		                          function update(old, value, set, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (remove$0,
		                                    set,
		                                    old,
		                                    function(set){
		                                     return caml_exact_trampoline_cps_call$1
		     (add$4, set, value, cont);
		                                    });
		                          }
		                          function remove(value, map, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (remove$0, map, value, cont);
		                          }
		                          function add$0(value, map, cont){
		                           var id = value[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (set$3, map, id, value, cont);
		                          }
		                          var empty$0 = empty$11([0, comparator$55]);
		                          function update$0(old, value, map, cont){
		                           var old_k = old[1], value_k = value[1];
		                           return caml_trampoline_cps_call3
		                                   (comparator$55[1],
		                                    old_k,
		                                    value_k,
		                                    function(a){
		                                     return 0 === a
		     ? caml_exact_trampoline_cps_call$0
		       (set$3, map, value_k, value, cont)
		     : caml_exact_trampoline_cps_call$1
		       (remove$2,
		        map,
		        old_k,
		        function(map){
		         return caml_exact_trampoline_cps_call$0
		                 (set$3, map, value_k, value, cont);
		        });
		                                    });
		                          }
		                          function remove$1(value, map, cont){
		                           var id = value[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (remove$2, map, id, cont);
		                          }
		                          var
		                           By_id_index =
		                             [0,
		                              add$0,
		                              ,
		                              empty$0,
		                              ,
		                              update$0,
		                              remove$1,
		                              function(Binder){
		                               function find(value, map, cont){
		                                return caml_exact_trampoline_cps_call$1
		(find_packed_by_id, Binder[2].call(null, map), value, cont);
		                               }
		                               function change(value, map, f, cont){
		                                return caml_exact_trampoline_cps_call$1
		(find,
		 value,
		 map,
		 function(found){
		  return caml_exact_trampoline_cps_call
		          (f,
		           found,
		           function(match){
		            if(found){
		             var value = found[1];
		             if(! match)
		              return caml_exact_trampoline_cps_call$1
		                      (Binder[1][7], value, map, cont);
		             var value$0 = match[1];
		             return caml_exact_trampoline_cps_call$0
		                     (Binder[1][6], value, value$0, map, cont);
		            }
		            if(! match) return cont(map);
		            var value$1 = match[1];
		            return caml_exact_trampoline_cps_call$1
		                    (Binder[1][2], value$1, map, cont);
		           });
		 });
		                               }
		                               function update(value, map, f, cont){
		                                return caml_exact_trampoline_cps_call$0
		(change,
		 value,
		 map,
		 function(param, cont){
		  if(! param) return cont(0);
		  var v = param[1];
		  return caml_exact_trampoline_cps_call(f, v, cont);
		 },
		 cont);
		                               }
		                               function set(value, new_value, map, cont){
		                                return caml_exact_trampoline_cps_call$0
		(change,
		 value,
		 map,
		 function(param, cont){return cont([0, new_value]);},
		 cont);
		                               }
		                               function remove(value, map, cont){
		                                return caml_exact_trampoline_cps_call$1
		(find_packed_by_id,
		 Binder[2].call(null, map),
		 value,
		 function(match){
		  if(! match) return cont(map);
		  var value = match[1];
		  return caml_exact_trampoline_cps_call$1
		          (Binder[1][7], value, map, cont);
		 });
		                               }
		                               return [0, change, find, , remove, set, update];
		                              }],
		                           Ordered = [0, add, , empty, is_empty$3, update, remove],
		                           b = Ordered[3],
		                           a = Ordered[1],
		                           letrec_function_context = [];
		                          function compare$0(x, y, cont){
		                           if(! x) return y ? cont(-1) : cont(0);
		                           var a = x[1];
		                           if(! y) return cont(1);
		                           var b = y[1];
		                           return caml_trampoline_cps_call3
		                                   (letrec_function_context[1], a, b, cont);
		                          }
		                          var d = Ordered[6], e = Ordered[5], f = Ordered[4];
		                          caml_update_dummy(letrec_function_context, [0, compare$160]);
		                          function sexp_of_t$0(param, cont){
		                           if(! param) return cont(aPK);
		                           var id = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_t$129, id, cont);
		                          }
		                          var
		                           include$0 = Make$2([0, compare$0, sexp_of_t$0]),
		                           comparator$0 = include$0[16];
		                          function add$1(value, map, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (change$0,
		                                    map,
		                                    parent(value),
		                                    function(param, cont){
		                                     if(! param)
		                                      return caml_exact_trampoline_cps_call$1
		      (a, value, b, function(a){return cont([0, a]);});
		                                     var index = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (a, value, index, function(a){return cont([0, a]);});
		                                    },
		                                    cont);
		                          }
		                          var empty$1 = empty$11([0, comparator$0]);
		                          function remove$3(value, map, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (change$0,
		                                    map,
		                                    parent(value),
		                                    function(param, cont){
		                                     if(! param) return cont(0);
		                                     var index = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (d,
		      value,
		      index,
		      function(index){
		       return f(index) ? cont(0) : cont([0, index]);
		      });
		                                    },
		                                    cont);
		                          }
		                          function update$1(old, value, map, cont){
		                           var old_k = parent(old), value_k = parent(value);
		                           return caml_trampoline_cps_call3
		                                   (comparator$0[1],
		                                    old_k,
		                                    value_k,
		                                    function(c){
		                                     return 0 === c
		     ? caml_exact_trampoline_cps_call$0
		       (change$0,
		        map,
		        value_k,
		        function(param, cont){
		         if(! param)
		          return caml_exact_trampoline_cps_call$1
		                  (a, value, b, function(a){return cont([0, a]);});
		         var index = param[1];
		         return caml_exact_trampoline_cps_call$0
		                 (e, old, value, index, function(a){return cont([0, a]);});
		        },
		        cont)
		     : caml_exact_trampoline_cps_call$1
		       (remove$3,
		        old,
		        map,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (add$1, value, a, cont);
		        });
		                                    });
		                          }
		                          var
		                           By_parent_index =
		                             [0,
		                              add$1,
		                              ,
		                              empty$1,
		                              ,
		                              update$1,
		                              remove$3,
		                              function(Binder){
		                               function find(value, map, cont){
		                                return caml_exact_trampoline_cps_call$1
		(find_packed_by_id, Binder[2].call(null, map), value, cont);
		                               }
		                               return [0, find];
		                              }],
		                           Index$0 =
		                             [0,
		                              By_parent_index[1],
		                              ,
		                              By_parent_index[3],
		                              ,
		                              By_parent_index[5],
		                              By_parent_index[6]],
		                           Index$1 =
		                             [0,
		                              By_id_index[1],
		                              ,
		                              By_id_index[3],
		                              ,
		                              By_id_index[5],
		                              By_id_index[6]];
		                          function First(Binder){
		                           function get(t){
		                            var index = Binder[2].call(null, t)[1];
		                            return index;
		                           }
		                           return [0, , get];
		                          }
		                          function Make_multi_index$0(Value){
		                           function add(value, param, cont){
		                            var index = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (Index$0[1],
		                                     value,
		                                     index,
		                                     function(a){return cont([0, a, 0]);});
		                           }
		                           function update(old, value, param, cont){
		                            var index = param[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (Index$0[5],
		                                     old,
		                                     value,
		                                     index,
		                                     function(a){return cont([0, a, 0]);});
		                           }
		                           var empty = [0, Index$0[3], 0];
		                           function remove(value, param, cont){
		                            var index = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (Index$0[6],
		                                     value,
		                                     index,
		                                     function(a){return cont([0, a, 0]);});
		                           }
		                           var
		                            include =
		                              Make_multi_index
		                               ([0, Value, [0, add, update, empty, remove]]),
		                            Indexes = include[2];
		                           return [0, , , , Indexes];
		                          }
		                          function c(a){
		                           var
		                            Multi_index = Make_multi_index$0(a),
		                            Indexes = Multi_index[4];
		                           return [0, Indexes];
		                          }
		                          function Make(Value){
		                           var Tail = c(Value);
		                           function add(value, param, cont){
		                            var indexes = param[2], index = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (Tail[1][1],
		                                     value,
		                                     indexes,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (Index$1[1],
		       value,
		       index,
		       function(b){return cont([0, b, a]);});
		                                     });
		                           }
		                           function update(old, value, param, cont){
		                            var indexes = param[2], index = param[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (Tail[1][2],
		                                     old,
		                                     value,
		                                     indexes,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$0
		      (Index$1[5],
		       old,
		       value,
		       index,
		       function(b){return cont([0, b, a]);});
		                                     });
		                           }
		                           var empty = [0, Index$1[3], Tail[1][3]];
		                           function remove(value, param, cont){
		                            var indexes = param[2], index = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (Tail[1][4],
		                                     value,
		                                     indexes,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (Index$1[6],
		       value,
		       index,
		       function(b){return cont([0, b, a]);});
		                                     });
		                           }
		                           var
		                            Multi_index =
		                              Make_multi_index
		                               ([0, Value, [0, add, update, empty, remove]]),
		                            add$0 = Multi_index[3],
		                            all = Multi_index[4],
		                            empty$0 = Multi_index[7],
		                            length = Multi_index[8];
		                           function get(param){var index = param[2][1]; return index;}
		                           function get$0(param){
		                            var indexes = param[2][2];
		                            return indexes;
		                           }
		                           return [0,
		                                   ,
		                                   ,
		                                   Multi_index,
		                                   ,
		                                   ,
		                                   add$0,
		                                   all,
		                                   ,
		                                   ,
		                                   empty$0,
		                                   length,
		                                   ,
		                                   ,
		                                   [0, get],
		                                   [0, get$0]];
		                          }
		                          var
		                           Index =
		                             [0,
		                              function(a){
		                               var
		                                include = Make(a),
		                                Multi_index = include[3],
		                                add = include[6],
		                                all = include[7],
		                                empty = include[10],
		                                length = include[11],
		                                Head = include[14],
		                                Tail = include[15],
		                                Second = First([0, , Tail[1]]);
		                               return [0,
		                                       ,
		                                       ,
		                                       all,
		                                       add,
		                                       empty,
		                                       length,
		                                       ,
		                                       ,
		                                       ,
		                                       [0,
		[0, , Multi_index[3], , , , Multi_index[6], Multi_index[9]],
		Head[1]],
		                                       Second];
		                              }],
		                           include$1 = Index[1].call(null, [0, comparator]),
		                           all = include$1[3],
		                           add$2 = include$1[4],
		                           empty$2 = include$1[5],
		                           length = include$1[6],
		                           First$0 = include$1[10],
		                           Second = include$1[11],
		                           By_id = By_id_index[7].call(null, First$0),
		                           By_parent = By_parent_index[7].call(null, Second);
		                          return caml_exact_trampoline_cps_call
		                                  (M$3,
		                                   [0, comparator, schema_versioned],
		                                   function(Set){
		                                    var
		                                     schema =
		                                       map$14
		(function(elements, cont){
		  return caml_exact_trampoline_cps_call$0
		          (Set[35],
		           elements,
		           empty$2,
		           function(x, y, cont){
		            return caml_exact_trampoline_cps_call$1(add$2, y, x, cont);
		           },
		           function(a){
		            return caml_trampoline_cps_call2(of_string$14, a, cont);
		           });
		 },
		 function(mi, cont){
		  return caml_exact_trampoline_cps_call
		          (all,
		           mi,
		           function(a){
		            return caml_exact_trampoline_cps_call(Set[78], a, cont);
		           });
		 },
		 Set[71]);
		                                    function schema_versioned(schematic_version, cont){
		                                     return caml_trampoline_cps_call2
		     (schematic_version,
		      V$5,
		      function(schematic_schema_version){
		       return caml_exact_trampoline_cps_call
		               (Element[4],
		                schematic_version,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (Element[6][1],
		                          schematic_version,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$373,
		                                    schematic_version,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$1
		     (c, b, a, function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned,
		     function(param, cont){return cont(0);},
		     function(schema$0){
		      function schema_versioned$0(schematic_version, cont){
		       return caml_trampoline_cps_call2
		               (schematic_version,
		                V$5,
		                function(schematic_schema_version){
		                 return cont
		                         ([0,
		                           0,
		                           0,
		                           schematic_param_a_schema_versi[3],
		                           schematic_param_a_schema_versi[4]]);
		                });
		      }
		      var
		       schema$1 =
		         [0,
		          0,
		          0,
		          schematic_param_a_schema_versi[3],
		          schematic_param_a_schema_versi[4]],
		       letrec_function_context = [];
		      function state_schema_versioned(schematic_version, cont){
		       return caml_exact_trampoline_cps_call
		               (schematic_version,
		                V$5,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id,
		                          letrec_function_context[1][1],
		                          schematic_schema_version,
		                          function(match){
		                           function a(descriptor){
		                            return cont([0, aPL, 0, descriptor, 0]);
		                           }
		                           if(! match)
		                            return caml_exact_trampoline_cps_call
		                                    (fixpoint,
		                                     function(schematic_self, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       letrec_function_context[1][1],
		       schematic_schema_version,
		       function(match){
		        if(! match)
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  schematic_self,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   var
		                    res =
		                      [7,
		                       function(param, cont){
		                        var nodes = param[2][1], clock = param[1];
		                        return cont([0, clock, nodes]);
		                       },
		                       function(param, cont){
		                        var nodes = param[2], clock = param[1];
		                        return cont([0, clock, [0, nodes, 0]]);
		                       },
		                       [0,
		                        [0, 0, 0, 0, 0, cst_clock, 0, 2, [0, int_schema], 0, 0],
		                        [0, [0, 0, 0, 0, 0, "nodes", 0, 2, [0, schema], 0, 0], 0]]];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        var schema$0 = match[1];
		        return cont(schema$0);
		       });
		                                     },
		                                     a);
		                           var schema$0 = match[1];
		                           return a(schema$0);
		                          });
		                });
		      }
		      var schematic_cache = [0, empty$11([0, comparator$9])];
		      caml_update_dummy
		       (letrec_function_context, [0, schematic_cache]);
		      var
		       Delta = [0, schema_versioned],
		       Init = [0, schema_versioned$0, schema$1];
		      return caml_exact_trampoline_cps_call
		              (state_schema_versioned,
		               function(param, cont){return cont(0);},
		               function(state_schema){
		                function make(param, cont){return cont([0, 0, empty$2]);}
		                function apply_delta_add
		                (replica, state, id, parent, value, cont){
		                 var a = state[2], b = [0, [0, id, parent], 0];
		                 return caml_exact_trampoline_cps_call
		                         (Element[10],
		                          value,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (add$2,
		                                    [0, id, c, b],
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (max$2,
		      state[1],
		      id[1],
		      function(b){return cont([0, b, a]);});
		                                    });
		                          });
		                }
		                function apply_delta_move
		                (replica, state, id, parent, timestamp, cont){
		                 function insert_parent(param, cont){
		                  if(! param) return cont([0, [0, timestamp, parent], 0]);
		                  var head = param[1], tail = param[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$217,
		                           timestamp,
		                           head[1],
		                           function(a){
		                            if(a)
		                             return cont([0, [0, timestamp, parent], [0, head, tail]]);
		                            var tail$0 = param[2];
		                            return caml_exact_trampoline_cps_call
		                                    (insert_parent,
		                                     tail$0,
		                                     function(match){
		                                      var tail = match[2], next = match[1];
		                                      return cont([0, head, [0, next, tail]]);
		                                     });
		                           });
		                 }
		                 function a(node, cont){
		                  return caml_exact_trampoline_cps_call
		                          (elements_of_list,
		                           node[3],
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (insert_parent,
		                                     a,
		                                     function(a){return cont([0, node[1], node[2], a]);});
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (By_id[1],
		                          id,
		                          state[2],
		                          function(b, cont){
		                           return caml_trampoline_cps_call3(map$17, b, a, cont);
		                          },
		                          function(nodes){return cont([0, state[1], nodes]);});
		                }
		                function apply_delta(replica, state, param, cont){
		                 switch(param[0]){
		                   case 0:
		                    var value = param[3], parent = param[2], id = param[1];
		                    return caml_exact_trampoline_cps_call$3
		                            (apply_delta_add, dummy, state, id, parent, value, cont);
		                   case 1:
		                    var id$0 = param[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (By_id[6],
		                             id$0,
		                             state[2],
		                             function(node, cont){
		                              var a = node[3];
		                              return caml_exact_trampoline_cps_call$0
		                                      (Element[9],
		                                       dummy,
		                                       dummy,
		                                       dummy,
		                                       function(b){return cont([0, [0, node[1], b, a]]);});
		                             },
		                             function(nodes){return cont([0, state[1], nodes]);});
		                   default:
		                    var
		                     timestamp = param[3],
		                     parent$0 = param[2],
		                     id$1 = param[1];
		                    return caml_exact_trampoline_cps_call$3
		                            (apply_delta_move,
		                             dummy,
		                             state,
		                             id$1,
		                             parent$0,
		                             timestamp,
		                             cont);
		                 }
		                }
		                function apply(replica, state, param, cont){
		                 switch(param[0]){
		                   case 0:
		                    var
		                     value = param[2],
		                     parent = param[1],
		                     clock = state[1] + 1 | 0,
		                     id = [0, clock, replica];
		                    return caml_exact_trampoline_cps_call$3
		                            (apply_delta_add,
		                             replica,
		                             state,
		                             id,
		                             parent,
		                             value,
		                             function(a){
		                              return cont([0, id, [0, [0, id, parent, value]], a]);
		                             });
		                   case 1:
		                    var id$0 = param[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (By_id[2],
		                             id$0,
		                             state[2],
		                             function(match){
		                              function a(match){
		                               var
		                                value_state = match[3],
		                                delta = match[2],
		                                result = match[1];
		                               return caml_trampoline_cps_call3
		                                       (map$17,
		delta,
		function(delta, cont){return cont([1, id$0, delta]);},
		function(delta){
		 return caml_exact_trampoline_cps_call$0
		         (By_id[6],
		          id$0,
		          state[2],
		          function(node, cont){
		           return cont([0, [0, node[1], value_state, node[3]]]);
		          },
		          function(a){
		           return cont([0, result, delta, [0, state[1], a]]);
		          });
		});
		                              }
		                              return match
		                                      ? caml_exact_trampoline_cps_call$0
		(Element[8], replica, dummy, dummy, a)
		                                      : caml_exact_trampoline_cps_call
		(failwith, "no such element", a);
		                             });
		                   default:
		                    var
		                     parent$0 = param[2],
		                     id$1 = param[1],
		                     timestamp = [0, state[1] + 1 | 0, replica],
		                     delta = [2, id$1, parent$0, timestamp];
		                    return caml_exact_trampoline_cps_call$3
		                            (apply_delta_move,
		                             replica,
		                             state,
		                             id$1,
		                             parent$0,
		                             timestamp,
		                             function(a){return cont([0, 0, [0, delta], a]);});
		                 }
		                }
		                var Operation_atomic = [0, apply_delta];
		                return caml_exact_trampoline_cps_call
		                        (Operation[15],
		                         [0, Delta, apply_delta, apply],
		                         function(include){
		                          var
		                           delta_schema_versioned = include[1],
		                           delta_schema = include[2],
		                           apply_delta = include[3],
		                           apply = include[4];
		                          function view(param, cont){
		                           var nodes = param[2];
		                           g(Element[7]);
		                           function build_tree(a, param, cont){
		                            var
		                             value = param[2],
		                             id = param[1],
		                             leftover = a[2],
		                             index = a[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (By_id[4],
		                                     id,
		                                     leftover,
		                                     function(seen){
		                                      return caml_exact_trampoline_cps_call$1
		      (By_parent[1],
		       [0, id],
		       leftover,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (to_list$3,
		                 value$4(a, Ordered[3]),
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (fold_map,
		                           a,
		                           [0, index, seen],
		                           build_tree,
		                           function(match){
		                            var children = match[2], acc = match[1];
		                            return caml_exact_trampoline_cps_call
		                                    (Element[11],
		                                     value,
		                                     function(a){return cont([0, acc, [0, id, a, children]]);});
		                           });
		                 });
		       });
		                                     });
		                           }
		                           var index = By$20[111];
		                           function a(index, trees){
		                            return caml_exact_trampoline_cps_call$1
		                                    (By_parent[1],
		                                     0,
		                                     trees,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (to_list$3,
		       value$4(b, Ordered[3]),
		       function(roots){
		        return caml_exact_trampoline_cps_call$0
		                (fold_map,
		                 roots,
		                 [0, index, trees],
		                 build_tree,
		                 function(b){
		                  var forest = b[2], b = b[1], leftover = b[2], index = b[1];
		                  function c(match){
		                   return caml_trampoline_cps_call2
		                           (Element[7][5], [0, forest, index], cont);
		                  }
		                  return 0 === length(leftover)
		                          ? c()
		                          : caml_exact_trampoline_cps_call
		                            (all,
		                             leftover,
		                             function(t){
		                              var next = t[2], seed = t[1];
		                              function b(seed, most_recent_edge){
		                               return caml_trampoline_cps_call2
		                                       (next,
		seed,
		function(d){
		 if(typeof d === "number"){
		  if(most_recent_edge){
		   var tree = most_recent_edge[1][2];
		   return caml_exact_trampoline_cps_call$0
		           (By_id[5],
		            tree[1],
		            tree,
		            trees,
		            function(trees){
		             return caml_exact_trampoline_call2(a, index, trees);
		            });
		  }
		  var
		   f =
		     function(m, cont){
		      return caml_trampoline_cps_call4(m, 0, 0, aPM, cont);
		     };
		  return caml_exact_trampoline_cps_call
		          (err$0,
		           0,
		           function(a){return caml_trampoline_cps_call2(a, f, c);});
		 }
		 if(0 === d[0]){
		  var seed = d[1];
		  return caml_exact_trampoline_call2
		          (b, seed, most_recent_edge);
		 }
		 var
		  seed$0 = d[2],
		  tree$0 = d[1],
		  d = tree$0[3],
		  match = d[2];
		 if(! match)
		  return caml_exact_trampoline_call2
		          (b, seed$0, most_recent_edge);
		 var rest = match[2], next = match[1], head = d[1];
		 function e(){
		  return caml_exact_trampoline_call2
		          (b,
		           seed$0,
		           [0,
		            [0, head[1], [0, tree$0[1], tree$0[2], [0, next, rest]]]]);
		 }
		 if(! most_recent_edge) return e();
		 var current_timestamp = most_recent_edge[1][1];
		 return caml_exact_trampoline_cps_call$1
		         (symbol$220,
		          head[1],
		          current_timestamp,
		          function(a){
		           return a
		                   ? caml_exact_trampoline_call2(b, seed$0, most_recent_edge)
		                   : e();
		          });
		});
		                              }
		                              return b(seed, 0);
		                             });
		                 });
		       });
		                                     });
		                           }
		                           return a(index, nodes);
		                          }
		                          function roots(param){var forest = param[1]; return forest;}
		                          function add(parent, value, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (Operation[2], [0, parent, value], cont);
		                          }
		                          function element(id, operation, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (Operation[2], [1, id, operation], cont);
		                          }
		                          function move(parent, id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (Operation[2], [2, id, parent], cont);
		                          }
		                          return cont
		                                  ([0,
		                                    Element,
		                                    Operation,
		                                    ,
		                                    ,
		                                    Delta,
		                                    Init,
		                                    state_schema_versioned,
		                                    state_schema,
		                                    make,
		                                    ,
		                                    ,
		                                    Operation_atomic,
		                                    delta_schema_versioned,
		                                    delta_schema,
		                                    apply_delta,
		                                    apply,
		                                    view,
		                                    ,
		                                    roots,
		                                    ,
		                                    ,
		                                    add,
		                                    element,
		                                    move]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function schema_versioned$375(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_a_schema_versi[3],
		                                    schematic_param_a_schema_versi[4]]);
		                         });
		               }
		               var
		                include$136 = caml_callback(b8, [[0, schema_versioned$375]]),
		                state_schema_versioned$1 = include$136[2],
		                delta_schema_versioned$2 = include$136[4],
		                Init$0 = include$136[6],
		                Monad$1 = include$136[7],
		                apply$7 = include$136[8],
		                apply_delta$3 = include$136[9],
		                make$64 = include$136[10],
		                view$2 = include$136[11];
		               function bOD(Element, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (bOC,
		                         Element,
		                         [0,
		                          equal$5,
		                          ,
		                          state_schema_versioned$1,
		                          ,
		                          delta_schema_versioned$2,
		                          ,
		                          Init$0,
		                          Monad$1,
		                          apply$7,
		                          apply_delta$3,
		                          make$64,
		                          view$2],
		                         function(include){
		                          var
		                           Operation = include[2],
		                           state_schema_versioned = include[3],
		                           delta_schema_versioned = include[5],
		                           apply = include[9],
		                           apply_delta = include[10],
		                           a = include[11],
		                           b = include[12],
		                           c = include[14],
		                           d = include[18],
		                           e = include[21];
		                          return caml_exact_trampoline_cps_call
		                                  (M$2,
		                                   [0, Element[18], Element[1]],
		                                   function(Map){
		                                    return caml_exact_trampoline_cps_call
		    (M$3,
		     [0, Element[18], Element[1]],
		     function(Set){
		      function to_map(set, cont){
		       return caml_exact_trampoline_cps_call$2
		               (Set[53],
		                0,
		                0,
		                0,
		                set,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (map$11,
		                          a,
		                          function(elt, cont){return cont([0, elt, 0]);},
		                          function(a){
		                           return caml_exact_trampoline_cps_call(Map[124], a, cont);
		                          });
		                });
		      }
		      function make(set, cont){
		       return caml_exact_trampoline_cps_call
		               (to_map,
		                set,
		                function(b){return caml_trampoline_cps_call2(a, b, cont);});
		      }
		      function view(state, cont){
		       return caml_trampoline_cps_call2
		               (b,
		                state,
		                function(a){
		                 return caml_exact_trampoline_cps_call$2
		                         (Map[89],
		                          0,
		                          0,
		                          0,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    a,
		                                    function(a, cont){return cont(a[1]);},
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(Set[78], a, cont);
		                                    });
		                          });
		                });
		      }
		      var init = Set[73];
		      function add(elt, cont){
		       return caml_trampoline_cps_call3(c, elt, 0, cont);
		      }
		      function remove(elt, cont){
		       return caml_trampoline_cps_call2(d, elt, cont);
		      }
		      function diff(previous, r, cont){
		       return caml_exact_trampoline_cps_call
		               (to_map,
		                r,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (to_map,
		                          previous,
		                          function(b){
		                           return caml_trampoline_cps_call3(e, b, a, cont);
		                          });
		                });
		      }
		      return cont
		              ([0,
		                [0, , , , , , , , , , Operation[13]],
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                init,
		                add,
		                remove,
		                diff]);
		     });
		                                   });
		                         });
		               }
		               function A(Data, cont){
		                function schema_versioned$0(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return cont
		                                   (function(schematic_param_a_schema_versi, cont){
		                                     var
		                                      id = match$220[1],
		                                      a = schematic_param_a_schema_versi[4],
		                                      b = schematic_param_a_schema_versi[3];
		                                     return caml_exact_trampoline_cps_call$1
		     (combine,
		      schematic_param_a_schema_versi,
		      id,
		      function(c){return cont([0, c, 0, b, a]);});
		                                    });
		                          });
		                }
		                function make(a){return a;}
		                function with_value(value, param){return value;}
		                function view(a){return a;}
		                function schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_trampoline_cps_call2
		                                   (Data[1],
		                                    schematic_version,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$371,
		      schematic_version,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (b, a, function(a){return cont([0, 0, 0, a[3], a[4]]);});
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          var
		                           include = Monadic$0(),
		                           v = include[1],
		                           const$ = include[2],
		                           Apply = include[14];
		                          function state_schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_trampoline_cps_call2
		     (Data[1],
		      schematic_version,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$0,
		                schematic_version,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$370,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (b, a, function(a){return cont([0, aPF, 0, a[3], a[4]]);});
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var Delta = [0, schema_versioned];
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    function apply_delta(c, state, param, cont){
		                                     var value = param[2], timestamp = param[1];
		                                     function a(){return cont(state);}
		                                     if(timestamp[1] < state[2]) return a();
		                                     function b(){
		                                      var a = with_value(value);
		                                      return cont([0, [0, timestamp[2]], timestamp[1], a]);
		                                     }
		                                     if(state[2] !== timestamp[1]) return b();
		                                     var x = timestamp[2];
		                                     return caml_trampoline_cps_call3
		     (map$17,
		      state[1],
		      function(y, cont){return cont(caml_string_lessequal(x, y));},
		      function(c){return value$4(c, 0) ? a() : b();});
		                                    }
		                                    function apply(replica, state, param, cont){
		                                     var
		                                      value = param[1],
		                                      delta = [0, [0, state[2] + 1 | 0, replica], value];
		                                     return caml_exact_trampoline_cps_call$0
		     (apply_delta,
		      replica,
		      state,
		      delta,
		      function(state){return cont([0, 0, [0, delta], state]);});
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (Apply,
		     [0, Delta, apply_delta, apply],
		     function(include){
		      var
		       delta_schema_versioned = include[1],
		       delta_schema = include[2],
		       apply_delta = include[3],
		       apply = include[4];
		      function make$0(value, cont){
		       return cont([0, 0, 0, make(value)]);
		      }
		      function view$0(param, cont){
		       var value = param[3];
		       return cont(view(value));
		      }
		      function set(v$0, cont){
		       return caml_exact_trampoline_cps_call(v, [0, v$0], cont);
		      }
		      return cont
		              ([0,
		                [0, , , , , , , , , , , , const$],
		                state_schema_versioned,
		                state_schema,
		                delta_schema_versioned,
		                delta_schema,
		                Data,
		                include$0,
		                apply,
		                apply_delta,
		                make$0,
		                view$0,
		                set]);
		     });
		                                   });
		                         });
		               }
		               function get$12(a, x, y){
		                var
		                 width = a[3],
		                 contents = a[1],
		                 a = caml_mul(y, width) + x | 0;
		                return caml_check_bound(contents, a)[a + 1];
		               }
		               function Make$27(Elt){
		                function lcs(l, r, cont){
		                 var
		                  length_l = l.length - 1,
		                  length_r = r.length - 1,
		                  height = length_r + 1 | 0,
		                  width = length_l + 1 | 0,
		                  len = caml_mul(width, height),
		                  memo = [0, caml_make_vect(len, 0), , width],
		                  len$0 = caml_mul(length_l + 1 | 0, length_r + 1 | 0),
		                  path = caml_make_vect(len$0, x$1),
		                  end = [0, 1];
		                 function put(x, y, v){
		                  if(get$12(memo, x, y)) return;
		                  var a = end[1];
		                  caml_check_bound(path, a)[a + 1] = [0, x, y];
		                  var
		                   v$0 = [0, v],
		                   width = memo[3],
		                   contents = memo[1],
		                   a = caml_mul(y, width) + x | 0;
		                  caml_check_bound(contents, a)[a + 1] = v$0;
		                  end[1] = end[1] + 1 | 0;
		                 }
		                 function a(start$0){
		                  var
		                   start = start$0 + 1 | 0,
		                   b = start - 1 | 0,
		                   b = caml_check_bound(path, b)[b + 1],
		                   y = b[2],
		                   x = b[1];
		                  if(x < length_l && y < length_r){
		                   var
		                    l$0 = caml_check_bound(l, x)[x + 1],
		                    r$0 = caml_check_bound(r, y)[y + 1];
		                   return caml_exact_trampoline_cps_call$1
		                           (Elt[1],
		                            l$0,
		                            r$0,
		                            function(b){
		                             return b
		                                     ? (put
		(x + 1 | 0, y + 1 | 0, [0, l$0, r$0]),
		                                       caml_exact_trampoline_call1(a, start))
		                                     : (put
		(x + 1 | 0, y, [2, l$0]),
		                                       put(x, y + 1 | 0, [1, r$0]),
		                                       caml_exact_trampoline_call1(a, start));
		                            });
		                  }
		                  if(x < length_l){
		                   put(x + 1 | 0, y, [2, caml_check_bound(l, x)[x + 1]]);
		                   return caml_exact_trampoline_call1(a, start);
		                  }
		                  if(y < length_r){
		                   put(x, y + 1 | 0, [1, caml_check_bound(r, y)[y + 1]]);
		                   return caml_exact_trampoline_call1(a, start);
		                  }
		                  b = param$1;
		                  var x$0 = length_l, y$0 = length_r;
		                  for(;;){
		                   var
		                    lcss = b[2],
		                    current = b[1],
		                    push =
		                      function(current, lcss){
		                       if(! current) return lcss;
		                       var current$0 = current[1];
		                       return [0, current$0, lcss];
		                      };
		                   if(0 === x$0 && 0 === y$0) return cont(push(current, lcss));
		                   b = get$12(memo, x$0, y$0);
		                   if(! b)
		                    return caml_exact_trampoline_cps_call
		                            (failwith, "Lcs map was not filled correctly", cont);
		                   b = b[1];
		                   switch(b[0]){
		                     case 0:
		                      var new_head = b[2], old_head = b[1];
		                      a:
		                      {
		                       if(current){
		                        b = current[1];
		                        if(0 === b[0]){
		                         var
		                          tail = b[1],
		                          lcss$0 = lcss,
		                          current$0 = [0, [0, cons$3([0, old_head, new_head], tail)]];
		                         break a;
		                        }
		                       }
		                       var
		                        lcss$1 = push(current, lcss),
		                        lcss$0 = lcss$1,
		                        current$0 = [0, [0, [0, [0, old_head, new_head], 0]]];
		                      }
		                      var y$1 = y$0 - 1 | 0, x$1 = x$0 - 1 | 0;
		                      b = [0, current$0, lcss$0];
		                      x$0 = x$1;
		                      y$0 = y$1;
		                      break;
		                     case 1:
		                      var head = b[1];
		                      a:
		                      {
		                       if(current){
		                        b = current[1];
		                        if(1 === b[0]){
		                         var
		                          tail$0 = b[1],
		                          lcss$3 = lcss,
		                          current$1 = [0, [1, cons$3(head, tail$0)]];
		                         break a;
		                        }
		                       }
		                       var
		                        lcss$2 = push(current, lcss),
		                        lcss$3 = lcss$2,
		                        current$1 = [0, [1, [0, head, 0]]];
		                      }
		                      var y$2 = y$0 - 1 | 0;
		                      b = [0, current$1, lcss$3];
		                      y$0 = y$2;
		                      break;
		                     default:
		                      var head$0 = b[1];
		                      a:
		                      {
		                       if(current){
		                        b = current[1];
		                        if(2 === b[0]){
		                         var
		                          tail$1 = b[1],
		                          lcss$5 = lcss,
		                          current$2 = [0, [2, cons$3(head$0, tail$1)]];
		                         break a;
		                        }
		                       }
		                       var
		                        lcss$4 = push(current, lcss),
		                        lcss$5 = lcss$4,
		                        current$2 = [0, [2, [0, head$0, 0]]];
		                      }
		                      var x$2 = x$0 - 1 | 0;
		                      b = [0, current$2, lcss$5];
		                      x$0 = x$2;
		                   }
		                  }
		                 }
		                 return a(0);
		                }
		                return [0, lcs];
		               }
		               function itemize(lcs){
		                function f(b, cont){
		                 var a = b[1];
		                 if(! a){
		                  b = b[2];
		                  if(! b) return cont(0);
		                  var tail$5 = b[2], head$4 = b[1];
		                  return cont([0, [0, [0, head$4], tail$5]]);
		                 }
		                 a = a[1];
		                 switch(a[0]){
		                   case 0:
		                    var
		                     rest = b[2],
		                     a = a[1],
		                     tail = a[2],
		                     a = a[1],
		                     new$ = a[2],
		                     old = a[1];
		                    if(tail)
		                     var
		                      tail$0 = tail[2],
		                      head = tail[1],
		                      state = [0, [0, [0, head, tail$0]]];
		                    else
		                     state = 0;
		                    return cont([1, [0, old, new$], [0, state, rest]]);
		                   case 1:
		                    var rest$0 = b[2], b = a[1], tail$1 = b[2], head$0 = b[1];
		                    if(tail$1)
		                     var
		                      tail$2 = tail$1[2],
		                      head$1 = tail$1[1],
		                      state$0 = [0, [1, [0, head$1, tail$2]]];
		                    else
		                     state$0 = 0;
		                    return cont([1, [1, head$0], [0, state$0, rest$0]]);
		                   default:
		                    var rest$1 = b[2], a = a[1], tail$3 = a[2], head$2 = a[1];
		                    if(tail$3)
		                     var
		                      tail$4 = tail$3[2],
		                      head$3 = tail$3[1],
		                      state$1 = [0, [2, [0, head$3, tail$4]]];
		                    else
		                     state$1 = 0;
		                    return cont([1, [2, head$2], [0, state$1, rest$1]]);
		                 }
		                }
		                var init = [0, 0, lcs];
		                return [0, init, f];
		               }
		               function Mru(E, cont){
		                function first_n(n, param){
		                 if(! param) return 0;
		                 var tl = param[2], hd = param[1];
		                 return 0 < n ? [0, hd, first_n(n - 1 | 0, tl)] : 0;
		                }
		                function hits(uses, cont){
		                 function f(param, v, cont){
		                  var count = param[2], hits = param[1];
		                  if(100 <= count) return cont([1, hits]);
		                  var score = 0 === count ? 1000 : 10 < count ? 1 : 10;
		                  return caml_exact_trampoline_cps_call$0
		                          (change$0,
		                           hits,
		                           v,
		                           function(param, cont){
		                            if(! param) return cont([0, score]);
		                            var s = param[1];
		                            return cont([0, s + score | 0]);
		                           },
		                           function(hits){return cont([0, [0, hits, count + 1 | 0]]);});
		                 }
		                 function finish(param, cont){
		                  var hits = param[1];
		                  return cont(hits);
		                 }
		                 var init = [0, empty$11([0, E[16]]), 0];
		                 return caml_exact_trampoline_cps_call$3
		                         (fold_until, fold_left$1, init, f, finish, uses, cont);
		                }
		                var history = 100;
		                function to_list(param, cont){
		                 var uses = param[3];
		                 return cont(first_n(history, uses));
		                }
		                function of_list$0(uses, cont){
		                 var uses$0 = first_n(history, uses);
		                 return caml_exact_trampoline_cps_call
		                         (hits,
		                          uses$0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (length$1,
		                                    uses$0,
		                                    function(b){return cont([0, b, a, uses$0]);});
		                          });
		                }
		                function use(values, param, cont){
		                 var uses = param[3], count = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (length$1,
		                          values,
		                          function(l){
		                           function a(uses){
		                            return caml_exact_trampoline_cps_call
		                                    (hits, uses, function(hits){return cont([0, , , uses]);});
		                           }
		                           return 1000 <= (count + l | 0)
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (append$0, values, first_n(100 - l | 0, uses), a)
		                                   : caml_exact_trampoline_cps_call$1
		                                     (append$0, values, uses, a);
		                          });
		                }
		                function schema_versioned(v, cont){
		                 function decode(uses, cont){
		                  return caml_exact_trampoline_cps_call
		                          (hits,
		                           uses,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (length$1,
		                                     uses,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (of_string$14, [0, b, a, uses], cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (E[18],
		                          dummy,
		                          function(a){
		                           var descriptor = [4, decode, to_list, [3, a]];
		                           return cont([0, 0, 0, descriptor, 0]);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned,
		                         dummy,
		                         function(schema){
		                          function sort_map(t, l, f, cont){
		                           var init = [0, empty$11([0, comparator$4]), 0];
		                           function a(t$0, init){
		                            if(t$0){
		                             var
		                              l = t$0[2],
		                              elt = t$0[1],
		                              others$0 = init[2],
		                              recent$0 = init[1];
		                             return caml_trampoline_cps_call2
		                                     (f,
		                                      elt,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (find_packed_by_id,
		        t[2],
		        b,
		        function(elt_mru){
		         if(! elt_mru)
		          return caml_exact_trampoline_call2
		                  (a, l, [0, recent$0, [0, elt, others$0]]);
		         var idx = elt_mru[1];
		         return caml_exact_trampoline_cps_call$0
		                 (add_multi$0,
		                  recent$0,
		                  idx,
		                  elt,
		                  function(b){
		                   return caml_exact_trampoline_call2(a, l, [0, b, others$0]);
		                  });
		        });
		                                      });
		                            }
		                            var others = init[2], recent = init[1];
		                            return caml_exact_trampoline_cps_call
		                                    (of_rev_keys,
		                                     others,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (encode,
		       recent,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (of_list, b, function(b){return cont(rev_append(b, a));});
		       });
		                                     });
		                           }
		                           return a(l, init);
		                          }
		                          return cont
		                                  ([0,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    ,
		                                    use,
		                                    ,
		                                    schema_versioned,
		                                    ,
		                                    ,
		                                    sort_map,
		                                    of_list$0,
		                                    to_list]);
		                         });
		               }
		               var
		                symbol_bind$20 = include$0[1],
		                symbol_map$18 = include$0[2],
		                Monad_infix$0 = include$0[3],
		                bind$28 = include$0[4],
		                return$31 = include$0[5],
		                map$48 = include$0[6],
		                join$8 = include$0[7],
		                ignore_m$1 = include$0[8],
		                all$21 = include$0[9],
		                all_unit$2 = include$0[10],
		                Let_syntax$12 = include$0[11];
		               function Make_base_atom(a){return a;}
		               function Make_atom(a){return a;}
		               function Make_base_map(b, c, a, cont){
		                return caml_exact_trampoline_cps_call$1(cm, b, a, cont);
		               }
		               function Make_map(b, c, a, cont){
		                return caml_exact_trampoline_cps_call$1(bOC, b, a, cont);
		               }
		               function schema_versioned$378(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_init_schema_ve,
		                                    schematic_param_value_schema_v,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_init_schema_ve,
		                                     schematic_param_value_schema_v,
		                                     cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  function(f0, cont){return cont([1, f0]);},
		  function(param, cont){
		   if(0 === param[0]) return cont(0);
		   var f0 = param[1];
		   return cont([0, f0]);
		  },
		  1,
		  0,
		  cst_value,
		  cst_Value,
		  [0,
		   0,
		   0,
		   [7,
		    function(param, cont){
		     var delta = param[1];
		     return cont(delta);
		    },
		    function(delta, cont){return cont([0, delta, 0]);},
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_delta,
		      0,
		      2,
		      [0, schematic_param_value_schema_v],
		      0,
		      0],
		     0]],
		   0],
		  0],
		 0],
		                                      b =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_init,
		  0,
		  3,
		  [0, schematic_param_init_schema_ve],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$360,
		      schematic_version,
		      function(c){
		       return cont
		               ([11,
		                 aPT,
		                 [0,
		                  [0,
		                   function(param, cont){
		                    var f1 = param[2], f0 = param[1];
		                    return cont([0, f0, f1]);
		                   },
		                   function(param, cont){
		                    if(0 !== param[0]) return cont(0);
		                    var f1 = param[2], f0 = param[1];
		                    return cont([0, [0, f0, f1]]);
		                   },
		                   1,
		                   0,
		                   "reset",
		                   "Reset",
		                   [0,
		                    0,
		                    0,
		                    [7,
		                     function(param, cont){
		                      var init = param[2][1], id = param[1];
		                      return cont([0, id, init]);
		                     },
		                     function(param, cont){
		                      var init = param[2], id = param[1];
		                      return cont([0, id, [0, init, 0]]);
		                     },
		                     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b]],
		                    0],
		                   0],
		                  a],
		                 0]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$221[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_init,
		 schematic_param_init_schema_ve,
		 function(schematic_param_init_schema_ve, cont){
		  return cont
		          ([1,
		            cst_value,
		            schematic_param_value_schema_v,
		            function(schematic_param_value_schema_v, cont){
		             return caml_exact_trampoline_cps_call$1
		                     (descriptor,
		                      schematic_param_init_schema_ve,
		                      schematic_param_value_schema_v,
		                      function(a){return cont([0, schematic_schema_id, a]);});
		            }]);
		 }]];
		                                    return caml_exact_trampoline_cps_call$1
		    (descriptor,
		     schematic_param_init_schema_ve,
		     schematic_param_value_schema_v,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               function Make$28(Value, cont){
		                var
		                 include = Monadic$0(),
		                 v = include[1],
		                 const$ = include[2],
		                 symbol_bind = include[3],
		                 symbol_map = include[4],
		                 bind = include[6],
		                 return$ = include[7],
		                 map = include[8],
		                 ignore_m = include[10],
		                 Let_syntax = include[11],
		                 Apply = include[14],
		                 Monad = Value[7],
		                 letrec_function_context = [];
		                function state_schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, aPU, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (Value[2],
		                                      schematic_version,
		                                      function(b){
		                                       var
		a = [0, [0, 0, 0, 0, 0, cst_value, 0, 3, [0, b], 0, 0], 0];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$360,
		        schematic_version,
		        function(b){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var value = param[2][1], id = param[1];
		              return cont([0, id, value]);
		             },
		             function(param, cont){
		              var value = param[2], id = param[1];
		              return cont([0, id, [0, value, 0]]);
		             },
		             [0, [0, 0, 0, 0, 0, cst_id, 0, 3, [0, b], 0, 0], a]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                var
		                 Operation =
		                   [0,
		                    ,
		                    ,
		                    const$,
		                    symbol_bind,
		                    symbol_map,
		                    ,
		                    bind,
		                    return$,
		                    map,
		                    ,
		                    ignore_m,
		                    Let_syntax];
		                return caml_exact_trampoline_cps_call
		                        (state_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(state_schema){
		                          function schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$4,
		                                    function(schematic_schema_version){
		                                     return caml_trampoline_cps_call2
		     (Value[4],
		      schematic_version,
		      function(a){
		       return caml_trampoline_cps_call2
		               (Value[6][1],
		                schematic_version,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$378,
		                          schematic_version,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (c,
		                                    b,
		                                    a,
		                                    function(a){return cont([0, aPV, 0, a[3], a[4]]);});
		                          });
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(schema){
		                                    function greater(id1_o, id2, cont){
		                                     if(! id1_o) return cont(0);
		                                     var id1 = id1_o[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$217, id1, id2, cont);
		                                    }
		                                    function next_id(replica, param){
		                                     if(! param) return [0, 1, replica];
		                                     var n = param[1][1];
		                                     return [0, n + 1 | 0, replica];
		                                    }
		                                    function apply_delta(replica, state, param, cont){
		                                     if(0 === param[0]){
		                                      var init = param[2], id = param[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (greater,
		       state[1],
		       id,
		       function(a){
		        return a
		                ? cont(state)
		                : caml_trampoline_cps_call3
		                  (map$17,
		                   init,
		                   Value[10],
		                   function(a){return cont([0, [0, id], a]);});
		       });
		                                     }
		                                     var delta = param[1];
		                                     return caml_trampoline_cps_call3
		     (map$17,
		      state[2],
		      function(x, cont){
		       return caml_trampoline_cps_call4
		               (Value[9], replica, x, delta, cont);
		      },
		      function(value){return cont([0, state[1], value]);});
		                                    }
		                                    function apply(replica, state, a, cont){
		                                     if(0 === a[0]){
		                                      var
		                                       init = a[1],
		                                       id = next_id(replica, state[1]),
		                                       delta = [0, id, init];
		                                      return caml_exact_trampoline_cps_call$0
		      (apply_delta,
		       replica,
		       state,
		       delta,
		       function(a){return cont([0, 0, [0, delta], a]);});
		                                     }
		                                     var op = a[1], a = state[2];
		                                     if(! a) return cont([0, 0, 0, state]);
		                                     var value = a[1];
		                                     return caml_trampoline_cps_call4
		     (Value[8],
		      replica,
		      value,
		      op,
		      function(match){
		       var value = match[3], delta_o = match[2], res = match[1];
		       return caml_trampoline_cps_call3
		               (map$17,
		                delta_o,
		                function(delta, cont){return cont([1, delta]);},
		                function(delta_o){
		                 return cont
		                         ([0, [0, res], delta_o, [0, state[1], [0, value]]]);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (Apply,
		     [0, [0, schema_versioned], apply_delta, apply],
		     function(include){
		      var
		       delta_schema_versioned = include[1],
		       delta_schema = include[2],
		       apply_delta = include[3],
		       apply = include[4];
		      function schema_versioned(schematic_version, cont){
		       return caml_trampoline_cps_call2
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_trampoline_cps_call2
		                         (Value[6][1],
		                          schematic_version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (option_schema,
		                                    a,
		                                    function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (schema_versioned,
		               function(param, cont){return cont(0);},
		               function(schema){
		                var Init = [0, schema_versioned, schema];
		                function make(value, cont){
		                 return caml_trampoline_cps_call3
		                         (map$17,
		                          value,
		                          Value[10],
		                          function(a){return cont([0, 0, a]);});
		                }
		                function view(state, cont){
		                 var open = g(Monad), let$ = open[3];
		                 return caml_trampoline_cps_call2
		                         (Monad[5],
		                          0,
		                          function(default$){
		                           var o = state[2];
		                           if(! o) return cont(default$);
		                           var x = o[1];
		                           function a(y, cont){
		                            return caml_trampoline_cps_call2(Monad[5], [0, y], cont);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (Value[11],
		                                    x,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$, b, a, cont);
		                                    });
		                          });
		                }
		                function reset(v_o, cont){
		                 return caml_exact_trampoline_cps_call(v, [0, v_o], cont);
		                }
		                function reset_some(v$0, cont){
		                 return caml_exact_trampoline_cps_call
		                         (v, [0, [0, v$0]], cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (v,
		                         aPW,
		                         function(reset_none){
		                          function value(op, cont){
		                           return caml_exact_trampoline_cps_call(v, [1, op], cont);
		                          }
		                          function value$0(op, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (value,
		                                    op,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(ignore_m, a, cont);
		                                    });
		                          }
		                          return cont
		                                  ([0,
		                                    Operation,
		                                    Monad,
		                                    state_schema_versioned,
		                                    state_schema,
		                                    ,
		                                    ,
		                                    ,
		                                    delta_schema_versioned,
		                                    delta_schema,
		                                    apply_delta,
		                                    apply,
		                                    Init,
		                                    make,
		                                    view,
		                                    ,
		                                    reset,
		                                    reset_some,
		                                    reset_none,
		                                    value,
		                                    value$0]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function Make_fugue_diffable(Fugue, a){
		                var b = Make$27([0, a[1]])[1];
		                function diff(from, to, cont){
		                 var
		                  c = Fugue[2],
		                  open = g([0, c[1], c[2], , c[4], c[5], c[6], , , , , c[11]]),
		                  symbol_map = open[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (b,
		                          from,
		                          to,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$0
		                                   (folding_map,
		                                    b,
		                                    0,
		                                    function(index, diff, cont){
		                                     switch(diff[0]){
		                                       case 0:
		var items = diff[1];
		return caml_exact_trampoline_cps_call
		        (length$11,
		         items,
		         function(a){return cont([0, index + a | 0, 0]);});
		                                       case 1:
		var
		 items$0 = diff[1],
		 b = function(param, cont){return cont(0);};
		return caml_exact_trampoline_cps_call
		        (a[2],
		         items$0,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (Fugue[17],
		                   index,
		                   function(c){
		                    return caml_trampoline_cps_call2
		                            (c,
		                             a,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (symbol_map,
		                                       a,
		                                       b,
		                                       function(b){
		var a = [0, b];
		return caml_exact_trampoline_cps_call
		        (length$11,
		         items$0,
		         function(b){return cont([0, index + b | 0, a]);});
		                                       });
		                             });
		                   });
		         });
		                                       default:
		var items$1 = diff[1];
		return caml_exact_trampoline_cps_call
		        (length$11,
		         items$1,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (Fugue[14],
		                   index,
		                   a,
		                   function(a){return cont([0, index, [0, a]]);});
		         });
		                                     }
		                                    },
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (filter_opt,
		      a,
		      function(l){
		       return l
		               ? caml_exact_trampoline_cps_call
		                 (Fugue[2][10],
		                  l,
		                  function(a){
		                   return caml_trampoline_cps_call2(return$9, a, cont);
		                  })
		               : cont(0);
		      });
		                                    });
		                          });
		                }
		                var
		                 Operation = Fugue[2],
		                 state_schema_versioned = Fugue[3],
		                 state_schema = Fugue[4],
		                 delta_schema_versioned = Fugue[5],
		                 delta_schema = Fugue[6],
		                 Init = Fugue[7],
		                 Monad = Fugue[8],
		                 apply = Fugue[9],
		                 apply_delta = Fugue[10],
		                 make = Fugue[11],
		                 view = Fugue[12],
		                 delete$ = Fugue[14],
		                 element = Fugue[16],
		                 insert = Fugue[17];
		                return [0,
		                        diff,
		                        ,
		                        Operation,
		                        state_schema_versioned,
		                        state_schema,
		                        delta_schema_versioned,
		                        delta_schema,
		                        Init,
		                        Monad,
		                        apply,
		                        apply_delta,
		                        make,
		                        view,
		                        ,
		                        delete$,
		                        ,
		                        element,
		                        insert];
		               }
		               function Fugue_diffable(Item, cont){
		                var equal = Item[1], a = [0, equal, elements_of_list];
		                return caml_exact_trampoline_cps_call
		                        (bQz,
		                         [0,
		                          ,
		                          Item[3],
		                          ,
		                          Item[5],
		                          ,
		                          Item[7],
		                          Item[8],
		                          Item[9],
		                          Item[10],
		                          Item[11],
		                          Item[12]],
		                         function(c){
		                          var
		                           include = Make_fugue_diffable(c, a),
		                           Operation = include[3],
		                           state_schema_versioned = include[4],
		                           state_schema = include[5],
		                           delta_schema_versioned = include[6],
		                           delta_schema = include[7],
		                           Init = include[8],
		                           Monad = include[9],
		                           apply = include[10],
		                           apply_delta = include[11],
		                           make = include[12],
		                           view = include[13],
		                           delete$ = include[15],
		                           element = include[17],
		                           insert = include[18],
		                           b = include[1];
		                          function diff(l, r, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (to_array,
		                                    r,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (to_array,
		      l,
		      function(c){
		       return caml_exact_trampoline_cps_call$1(b, c, a, cont);
		      });
		                                    });
		                          }
		                          var f = Item[1];
		                          function equal(x, y, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_with_local_closure, f, x, y, cont);
		                          }
		                          function view$0(state, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (view,
		                                    state,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (Monad[6], a, to_binable, cont);
		                                    });
		                          }
		                          return cont
		                                  ([0,
		                                    ,
		                                    Operation,
		                                    state_schema_versioned,
		                                    state_schema,
		                                    delta_schema_versioned,
		                                    delta_schema,
		                                    Init,
		                                    Monad,
		                                    apply,
		                                    apply_delta,
		                                    make,
		                                    delete$,
		                                    ,
		                                    element,
		                                    insert,
		                                    diff,
		                                    equal,
		                                    view$0,
		                                    0]);
		                         });
		               }
		               function Fugue_diffable$0(Item, cont){
		                return caml_exact_trampoline_cps_call
		                        (b8,
		                         [0, Item[1]],
		                         function(include){
		                          var
		                           state_schema_versioned = include[2],
		                           delta_schema_versioned = include[4],
		                           Init = include[6],
		                           Monad = include[7],
		                           apply = include[8],
		                           apply_delta = include[9],
		                           make = include[10],
		                           view = include[11],
		                           equal = Item[3];
		                          return caml_exact_trampoline_cps_call
		                                  (Fugue_diffable,
		                                   [0,
		                                    equal,
		                                    ,
		                                    state_schema_versioned,
		                                    ,
		                                    delta_schema_versioned,
		                                    ,
		                                    Init,
		                                    Monad,
		                                    apply,
		                                    apply_delta,
		                                    make,
		                                    view],
		                                   function(include){
		                                    var
		                                     Operation = include[2],
		                                     state_schema_versioned = include[3],
		                                     delta_schema_versioned = include[5],
		                                     Init = include[7],
		                                     apply = include[9],
		                                     apply_delta = include[10],
		                                     make = include[11],
		                                     delete$ = include[12],
		                                     insert = include[15],
		                                     diff = include[16],
		                                     view = include[18];
		                                    return cont
		    ([0,
		      ,
		      ,
		      Operation,
		      state_schema_versioned,
		      ,
		      delta_schema_versioned,
		      ,
		      Init,
		      ,
		      apply,
		      apply_delta,
		      make,
		      delete$,
		      ,
		      ,
		      insert,
		      diff,
		      ,
		      view]);
		                                   });
		                         });
		               }
		               function elements_of_list$0(chars, cont){
		                return caml_exact_trampoline_cps_call
		                        (elements_of_list,
		                         chars,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (deconstruct,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (sequence_to_utf8, 0, a, cont);
		                                   });
		                         });
		               }
		               var
		                Fugue =
		                  Make_fugue_diffable
		                   ([0,
		                     ,
		                     Operation,
		                     state_schema_versioned,
		                     state_schema,
		                     delta_schema_versioned,
		                     delta_schema,
		                     Init,
		                     Monad$0,
		                     apply$3,
		                     apply_delta,
		                     make$62,
		                     view$0,
		                     ,
		                     delete$,
		                     ,
		                     element,
		                     insert],
		                    [0, equal$3, elements_of_list$0]),
		                Operation$0 = Fugue[3],
		                state_schema_versioned$3 = Fugue[4],
		                delta_schema_versioned$4 = Fugue[6],
		                Init$1 = Fugue[8],
		                Monad$2 = Fugue[9],
		                apply$10 = Fugue[10],
		                apply_delta$6 = Fugue[11],
		                make$66 = Fugue[12],
		                view$4 = Fugue[13],
		                insert$0 = Fugue[18],
		                bRI = Fugue[1];
		               function diff$1(lhs, rhs, cont){
		                function array(s, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_array$0, utf8_to_sequence(bPl, s), cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (array,
		                         rhs,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (array,
		                                   lhs,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(bRI, b, a, cont);
		                                   });
		                         });
		               }
		               function make$67(param){return nanoid();}
		               function Make_var(X, cont){
		                var schema_versioned = X[1], schema = X[2];
		                function resolve(a, param, cont){
		                 var right = param[2], left = a[2];
		                 return caml_exact_trampoline_cps_call$1
		                         (X[3], left, right, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (M$2,
		                         [0, comparator$2, thread_id_schema_versioned],
		                         function(Map){
		                          function state_schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned,
		      schematic_version,
		      function(a){
		       return caml_trampoline_cps_call3
		               (Map[109],
		                schematic_version,
		                a,
		                function(a){return cont([0, , , a[3], a[4]]);});
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    function make(param, values){return values;}
		                                    function values(a){return a;}
		                                    function with_values(a, values, param){return values;}
		                                    function view(value, param){return value;}
		                                    return caml_exact_trampoline_cps_call
		    (M$2,
		     [0, comparator$2, thread_id_schema_versioned],
		     function(Set){
		      function schema_versioned$0(schematic_version, cont){
		       return caml_trampoline_cps_call2
		               (schematic_version,
		                V$5,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned,
		                          schematic_version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (thread_id_schema_versioned,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$372,
		      schematic_version,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (c, b, a, function(a){return cont([0, 0, 0, a[3], a[4]]);});
		      });
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$0,
		               function(param, cont){return cont(0);},
		               function(schema$0){
		                var
		                 include = Monadic$0(),
		                 v = include[1],
		                 const$ = include[2],
		                 Apply = include[14];
		                function values_schema_versioned(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned,
		                                    schematic_version,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (Set[109],
		      schematic_version,
		      a,
		      function(a){return cont();});
		                                    });
		                          });
		                }
		                var Delta = [0, schema_versioned$0];
		                return caml_exact_trampoline_cps_call
		                        (values_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(values_schema){
		                          function current(values, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (to_sequence$2,
		                                    0,
		                                    0,
		                                    0,
		                                    values,
		                                    function(values){
		                                     return caml_exact_trampoline_cps_call
		     (next,
		      values,
		      function(a){
		       function c(a){return cont(a[2]);}
		       if(! a)
		        return caml_exact_trampoline_cps_call
		                (failwith, "empty var map", c);
		       a = a[1];
		       var
		        others = a[2],
		        first = a[1],
		        next = others[2],
		        seed = others[1];
		       function b(seed, left){
		        return caml_trampoline_cps_call2
		                (next,
		                 seed,
		                 function(match){
		                  if(typeof match === "number") return c(left);
		                  if(0 === match[0]){
		                   var seed = match[1];
		                   return caml_exact_trampoline_call2(b, seed, left);
		                  }
		                  var
		                   seed$0 = match[2],
		                   right = match[1],
		                   right_value = right[2],
		                   left_value = left[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (resolve,
		                           [0, , left_value],
		                           [0, , right_value],
		                           function(a){
		                            return a
		                                    ? caml_exact_trampoline_call2(b, seed$0, left)
		                                    : caml_exact_trampoline_call2(b, seed$0, right);
		                           });
		                 });
		       }
		       return b(seed, first);
		      });
		                                    });
		                          }
		                          function state_schema_versioned$0(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call
		     (state_schema_versioned,
		      schematic_version,
		      function(a){return cont([0, aPH, 0, a[3], a[4]]);});
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned$0,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    function apply(replica, state, param, cont){
		                                     var
		                                      value = param[1],
		                                      key = make$67(),
		                                      values$0 = values(state);
		                                     return caml_exact_trampoline_cps_call$1
		     (Set[112],
		      key,
		      value,
		      function(b){
		       var a = with_values(value, b);
		       return caml_exact_trampoline_cps_call
		               (keys$0,
		                values$0,
		                function(b){
		                 return cont([0, 0, [0, [0, key, b, value]], a]);
		                });
		      });
		                                    }
		                                    function apply_delta(replica, state, param, cont){
		                                     var value = param[3], overridden = param[2], key = param[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (fold_left$1,
		      overridden,
		      values(state),
		      remove$2,
		      function(a){
		       return caml_exact_trampoline_cps_call$0
		               (add_exn$0,
		                a,
		                key,
		                value,
		                function(values){
		                 return caml_exact_trampoline_cps_call
		                         (current,
		                          values,
		                          function(a){return cont(with_values(dummy, values));});
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (Apply,
		     [0, Delta, apply_delta, apply],
		     function(include){
		      var
		       delta_schema_versioned = include[1],
		       delta_schema = include[2],
		       apply_delta = include[3],
		       apply = include[4];
		      function make$0(value, cont){
		       return caml_exact_trampoline_cps_call$1
		               (Set[112],
		                "000000000000000000000",
		                value,
		                function(a){
		                 return cont(function(a){return make(value, a);}(a));
		                });
		      }
		      function view$0(state, cont){
		       return caml_exact_trampoline_cps_call
		               (current,
		                values(state),
		                function(a){return cont(view(a));});
		      }
		      function set(v$0, cont){
		       return caml_exact_trampoline_cps_call(v, [0, v$0], cont);
		      }
		      var
		       a =
		         [0,
		          ,
		          ,
		          ,
		          ,
		          ,
		          ,
		          ,
		          ,
		          ,
		          delta_schema_versioned,
		          delta_schema,
		          apply_delta,
		          apply],
		       apply_delta$0 = a[12],
		       apply$0 = a[13],
		       delta_schema$0 = a[11],
		       delta_schema_versioned$0 = a[10];
		      return cont
		              ([0,
		                ,
		                [0, , , , , , , , , , , , const$],
		                state_schema_versioned$0,
		                state_schema,
		                delta_schema_versioned$0,
		                delta_schema$0,
		                [0, schema_versioned, schema],
		                include$0,
		                apply$0,
		                apply_delta$0,
		                make$0,
		                view$0,
		                set]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function schema_versioned$379(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$4,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aPX, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$148 =
		                  caml_callback
		                   (schema_versioned$379,
		                    [function(param, cont){return cont(0);}]);
		               function resolve$0(left, right, cont){
		                if(! left) return right ? cont(1) : cont(1);
		                if(! right) return cont(0);
		                var right$0 = right[1], left$0 = left[1];
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$74, left$0, right$0, cont);
		               }
		               var
		                Earliest =
		                  caml_callback
		                   (Make_var,
		                    [[0, schema_versioned$379, schema$148, resolve$0]]);
		               function schema_versioned$380(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$4,
		                                   schematic_version,
		                                   function(a){return cont([0, aPY, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$149 =
		                  caml_callback
		                   (schema_versioned$380,
		                    [function(param, cont){return cont(0);}]);
		               function resolve$1(left, right, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$73, left, right, cont);
		               }
		               var
		                Latest =
		                  caml_callback
		                   (Make_var,
		                    [[0, schema_versioned$380, schema$149, resolve$1]]),
		                Created = caml_callback(b8, [[0, schema_versioned$4]]);
		               function schema_versioned$381(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schema_versioned$182(),
		                                   function(a){return cont([0, aPZ, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$150 =
		                  caml_callback
		                   (schema_versioned$381,
		                    [function(param, cont){return cont(0);}]),
		                Parent =
		                  caml_callback(A, [[0, schema_versioned$381, schema$150]]);
		               function schema_versioned$382(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont([0, bG, 0, bool_schema[3], bool_schema[4]]);
		                         });
		               }
		               var
		                schema$280 = [0, bG, 0, bool_schema[3], bool_schema[4]],
		                include$139 =
		                  caml_callback(A, [[0, schema_versioned$382, schema$280]]);
		               function view$5(s, cont){
		                return s !== cst$1
		                        ? caml_exact_trampoline_cps_call
		                          (of_string$19, s, function(a){return cont([0, a]);})
		                        : cont(0);
		               }
		               var
		                include$318 =
		                  Make$24
		                   ([0,
		                     Operation$0,
		                     state_schema_versioned$3,
		                     ,
		                     delta_schema_versioned$4,
		                     ,
		                     ,
		                     Monad$2,
		                     apply$10,
		                     apply_delta$6,
		                     make$66,
		                     view$4],
		                    [0, view$5]),
		                state_schema_versioned$4 = include$318[2],
		                delta_schema_versioned$5 = include$318[4],
		                apply$11 = include$318[8],
		                apply_delta$7 = include$318[9],
		                bQA = include$318[10],
		                view$6 = include$318[11];
		               function diff$2(from, to, cont){
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         to,
		                         function(eta, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_string$25, 0, eta, cont);
		                         },
		                         function(b){
		                          var a = value$4(b, cst$1);
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   from,
		                                   function(eta, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (to_string$25, 0, eta, cont);
		                                   },
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (diff$1, value$4(b, cst$1), a, cont);
		                                   });
		                         });
		               }
		               var
		                include$140 =
		                  caml_callback
		                   (Make$28,
		                    [[0,
		                      ,
		                      state_schema_versioned$3,
		                      ,
		                      delta_schema_versioned$4,
		                      ,
		                      Init$1,
		                      Monad$2,
		                      apply$10,
		                      apply_delta$6,
		                      make$66,
		                      view$4]]),
		                Operation$1 = include$140[1],
		                state_schema_versioned$5 = include$140[3],
		                delta_schema_versioned$6 = include$140[8],
		                apply_delta$8 = include$140[10],
		                apply$12 = include$140[11],
		                make$68 = include$140[13],
		                view$7 = include$140[14],
		                reset_some = include$140[17],
		                reset_none = include$140[18],
		                value$9 = include$140[19];
		               function diff$3(before, after, cont){
		                if(before){
		                 var before$0 = before[1];
		                 if(! after) return cont(reset_none);
		                 var after$0 = after[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (diff$1,
		                          before$0,
		                          after$0,
		                          function(match){
		                           if(! match)
		                            return caml_trampoline_cps_call2(Operation$1[8], 0, cont);
		                           var diff_op = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (value$9,
		                                    diff_op,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (Operation$1[11], a, cont);
		                                    });
		                          });
		                }
		                if(! after)
		                 return caml_trampoline_cps_call2(Operation$1[8], 0, cont);
		                var
		                 after$1 = after[1],
		                 open =
		                   g
		                    ([0,
		                      Operation$1[4],
		                      Operation$1[5],
		                      ,
		                      Operation$1[7],
		                      Operation$1[8],
		                      Operation$1[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$1[12]]),
		                 let$ = open[3];
		                function a(param, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (insert$0,
		                          0,
		                          after$1,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (value$9,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (Operation$1[11], a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (reset_some,
		                         cst$1,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function schema_versioned$383(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                schema$279 =
		                  [0,
		                   0,
		                   0,
		                   schematic_param_name_schema_ve[3],
		                   schematic_param_name_schema_ve[4]],
		                String_LWW =
		                  caml_callback(A, [[0, schema_versioned$383, schema$279]]);
		               function schema_versioned$384(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schematic_param_name_schema_ve,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                j =
		                  caml_callback
		                   (option_schema, [schematic_param_name_schema_ve]),
		                schema$278 = [0, 0, 0, j[3], j[4]],
		                String_opt_LWW =
		                  caml_callback(A, [[0, schema_versioned$384, schema$278]]);
		               function schema_versioned$385(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$71,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$151 =
		                  caml_callback
		                   (schema_versioned$385,
		                    [function(param, cont){return cont();}]),
		                Response_id_opt_LWW =
		                  caml_callback(A, [[0, schema_versioned$385, schema$151]]);
		               function elements_of_list$1(strings, cont){
		                return caml_exact_trampoline_cps_call
		                        (elements_of_list, strings, cont);
		               }
		               var
		                include$319 =
		                  Make_fugue_diffable
		                   (caml_callback
		                     (bQz,
		                      [[0,
		                        ,
		                        state_schema_versioned$3,
		                        ,
		                        delta_schema_versioned$4,
		                        ,
		                        Init$1,
		                        Monad$2,
		                        apply$10,
		                        apply_delta$6,
		                        make$66,
		                        view$4]]),
		                    [0, equal$4, elements_of_list$1]),
		                state_schema_versioned$6 = include$319[4],
		                delta_schema_versioned$7 = include$319[6],
		                apply$13 = include$319[10],
		                apply_delta$9 = include$319[11],
		                make$69 = include$319[12],
		                view$8 = include$319[13];
		               function Make_get_by_date(Context){
		                var
		                 c = Context[3],
		                 b = Context[1],
		                 a = Context[2],
		                 d = Context[4],
		                 e = b[3],
		                 f = b[2],
		                 g = b[1][2];
		                function get_occurrence_of_default_occu(state, obj, cont){
		                 var open = o(a), let$ = open[4];
		                 function b(exceptional, cont){
		                  return cont(value$4(exceptional, obj));
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (c,
		                          state,
		                          e(obj),
		                          function(a){
		                           return caml_trampoline_cps_call3(let$, a, b, cont);
		                          });
		                }
		                function get_occurrence_of_object(state, obj_rec, subid, cont){
		                 var open = o(a), let$ = open[8], let$0 = open[4];
		                 function b(obj, cont){
		                  function a(obj, cont){
		                   return caml_trampoline_cps_call2(return$9, obj, cont);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (get_occurrence_of_default_occu,
		                           state,
		                           obj,
		                           function(b){
		                            return caml_trampoline_cps_call3(let$0, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (g,
		                          obj_rec,
		                          subid,
		                          function(c){
		                           return caml_trampoline_cps_call2
		                                   (a[6],
		                                    c,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                                    });
		                          });
		                }
		                function get_occurrence(state, id_rec, subid, cont){
		                 var open = o(a), let$ = open[8];
		                 function b(obj_rec, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (get_occurrence_of_object, state, obj_rec, subid, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (d,
		                          state,
		                          id_rec,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                          });
		                }
		                function get(state, id, cont){
		                 o(a);
		                 return caml_exact_trampoline_cps_call$0
		                         (f[1],
		                          id,
		                          function(param, cont){
		                           return caml_exact_trampoline_cps_call$1(c, state, id, cont);
		                          },
		                          function(id_rec, subid, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (get_occurrence, state, id_rec, subid, cont);
		                          },
		                          cont);
		                }
		                function get_occurrence_by_date(state, id_rec, date, cont){
		                 var open = o(Context[2]), let$ = open[8], let$0 = open[3];
		                 function a(obj_rec, cont){
		                  function a(obj, cont){
		                   var b = Context[1][3].call(null, obj);
		                   function a(exceptional, cont){
		                    var obj$0 = value$4(exceptional, obj);
		                    return caml_trampoline_cps_call2
		                            (return$9,
		                             obj$0,
		                             function(a){
		                              return caml_trampoline_cps_call2(Context[2][6], a, cont);
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (Context[3],
		                            state,
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$0, b, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (Context[1][1][3],
		                           obj_rec,
		                           date,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (Context[2][6],
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (Context[4],
		                          state,
		                          id_rec,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                function get_closest_occurrence_after
		                (state, id_rec, date, cont){
		                 var open = o(Context[2]), let$ = open[8], let$0 = open[3];
		                 function a(obj_rec, cont){
		                  function a(obj, cont){
		                   var b = Context[1][3].call(null, obj);
		                   function a(exceptional, cont){
		                    var obj$0 = value$4(exceptional, obj);
		                    return caml_trampoline_cps_call2
		                            (return$9,
		                             obj$0,
		                             function(a){
		                              return caml_trampoline_cps_call2(Context[2][6], a, cont);
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (Context[3],
		                            state,
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$0, b, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (Context[1][1][4],
		                           obj_rec,
		                           date,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (Context[2][6],
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (Context[4],
		                          state,
		                          id_rec,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                return [0,
		                        get_occurrence_of_default_occu,
		                        ,
		                        ,
		                        get,
		                        ,
		                        get_occurrence_by_date,
		                        get_closest_occurrence_after];
		               }
		               var
		                src$4 = create$18(0, "Routine_crdt"),
		                include$141 = src_log(src$4),
		                err$1 = include$141[3],
		                warn$2 = include$141[4],
		                info$0 = include$141[5],
		                debug$3 = include$141[6],
		                include$142 =
		                  caml_callback(A, [[0, schema_versioned$137, schema$48]]),
		                state_schema_versioned$7 = include$142[2],
		                delta_schema_versioned$8 = include$142[4],
		                apply$14 = include$142[8],
		                apply_delta$10 = include$142[9],
		                make$70 = include$142[10],
		                view$9 = include$142[11],
		                set$11 = include$142[12],
		                bOE = cst$1;
		               caml_callback(make$70, [with_text(bOE, content)]);
		               var letrec_function_context$664 = [];
		               function schema_versioned$386(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$664[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aP0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$664[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$664[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$664[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$8,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aP1,
		   cst_kind,
		   "Kind",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$4,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aP2,
		              cst_text,
		              cst_Text,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_text, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$664[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$664[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$634 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$664, [0, schematic_cache$634]);
		               caml_callback
		                (schema_versioned$386,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$143 = Monadic$0(),
		                v$7 = include$143[1],
		                ignore_m$3 = include$143[10],
		                all_unit$4 = include$143[12],
		                Apply$1 = include$143[14],
		                letrec_function_context$665 = [];
		               function state_schema_versioned$8(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$665[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aP3, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$665[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$665[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$665[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$7,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$3,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_text, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (include$48[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        kind = a[2][1],
		                        text = a[1],
		                        id = param[1];
		                       return cont([0, id, text, kind]);
		                      },
		                      function(param, cont){
		                       var kind = param[3], text = param[2], id = param[1];
		                       return cont([0, id, [0, text, [0, kind, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$665[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$665[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$635 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$665, [0, schematic_cache$635]);
		               caml_callback
		                (state_schema_versioned$8,
		                 [function(param, cont){return cont(0);}]);
		               function apply$15(replica, state, param, cont){
		                if(0 === param[0]){
		                 var operation = param[1];
		                 return caml_trampoline_cps_call4
		                         (apply$10,
		                          replica,
		                          state[2],
		                          operation,
		                          function(match){
		                           var text = match[3], delta_o = match[2], res = match[1];
		                           return caml_trampoline_cps_call3
		                                   (map$17,
		                                    delta_o,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta_o){
		                                     return cont
		     ([0, res, delta_o, [0, state[1], text, state[3]]]);
		                                    });
		                          });
		                }
		                var operation$0 = param[1];
		                return caml_trampoline_cps_call4
		                        (apply$14,
		                         replica,
		                         state[3],
		                         operation$0,
		                         function(match){
		                          var kind = match[3], delta_o = match[2], res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   delta_o,
		                                   function(delta, cont){return cont([1, delta]);},
		                                   function(delta_o){
		                                    return cont
		    ([0, res, delta_o, [0, state[1], state[2], kind]]);
		                                   });
		                         });
		               }
		               function apply_delta$11(replica, state, param, cont){
		                if(0 === param[0]){
		                 var delta = param[1], a = state[3];
		                 return caml_trampoline_cps_call4
		                         (apply_delta$6,
		                          replica,
		                          state[2],
		                          delta,
		                          function(b){return cont([0, state[1], b, a]);});
		                }
		                var delta$0 = param[1];
		                return caml_trampoline_cps_call4
		                        (apply_delta$10,
		                         replica,
		                         state[3],
		                         delta$0,
		                         function(a){return cont([0, state[1], state[2], a]);});
		               }
		               var
		                include$144 =
		                  caml_callback
		                   (Apply$1,
		                    [[0, [0, schema_versioned$386], apply_delta$11, apply$15]]),
		                delta_schema_versioned$9 = include$144[1],
		                apply_delta$12 = include$144[3],
		                apply$16 = include$144[4];
		               function make$71(param, cont){
		                var content = param[2], id = param[1];
		                return caml_exact_trampoline_cps_call
		                        (make$70,
		                         with_text(bOE, content),
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (make$66,
		                                   text(content),
		                                   function(b){return cont([0, id, b, a]);});
		                         });
		               }
		               function view$10(param, cont){
		                var kind = param[3], text = param[2], id = param[1];
		                return caml_exact_trampoline_cps_call
		                        (view$9,
		                         kind,
		                         function(content){
		                          return caml_exact_trampoline_cps_call
		                                  (view$4,
		                                   text,
		                                   function(text){
		                                    var content$0 = with_text(text, content);
		                                    return cont([0, id, content$0]);
		                                   });
		                         });
		               }
		               function kind(delta, cont){
		                return caml_exact_trampoline_cps_call(v$7, [1, delta], cont);
		               }
		               function text$1(delta, cont){
		                return caml_exact_trampoline_cps_call(v$7, [0, delta], cont);
		               }
		               var
		                Blocks =
		                  caml_callback
		                   (cm,
		                    [[0,
		                      include$48[4],
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      include$48[24],
		                      include$48[1]],
		                     [0,
		                      ,
		                      state_schema_versioned$8,
		                      ,
		                      delta_schema_versioned$9,
		                      ,
		                      [0, schema_versioned$139],
		                      Monad$2,
		                      apply$16,
		                      apply_delta$12,
		                      make$71,
		                      view$10]]),
		                Blocks_order =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, include$48[4], , include$48[15]]]),
		                Monad$3 = Blocks[8],
		                bRO = Blocks_order[6],
		                bRW = Blocks[5],
		                letrec_function_context$662 = [];
		               function schema_versioned$376(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$662[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aPR, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$662[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$662[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$662[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (bRO,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_second,
		   cst_Second,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_delta, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (bRW,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              cst_first,
		              cst_First,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_delta, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$662[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$662[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                bRJ = Blocks_order[19],
		                bRK = Blocks_order[12],
		                bRL = Blocks_order[11],
		                bRM = Blocks_order[10],
		                bRN = Blocks_order[8],
		                bRP = Blocks_order[4],
		                bRQ = Blocks_order[3][12],
		                bRR = Blocks[12],
		                bRS = Blocks[11],
		                bRT = Blocks[10],
		                bRU = Blocks[9],
		                bRV = Blocks[7],
		                bRX = Blocks[3],
		                bRY = Blocks[2][3],
		                schematic_cache$632 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$662, [0, schematic_cache$632]);
		               caml_callback
		                (schema_versioned$376,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$137 = Monadic$0(),
		                v$6 = include$137[1],
		                symbol_bind$19 = include$137[3],
		                symbol_map$17 = include$137[4],
		                bind$27 = include$137[6],
		                return$30 = include$137[7],
		                map$47 = include$137[8],
		                ignore_m$0 = include$137[10],
		                Let_syntax$11 = include$137[11],
		                all_unit$1 = include$137[12],
		                Apply$0 = include$137[14],
		                letrec_function_context$663 = [];
		               function state_schema_versioned$2(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$663[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aPS, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$663[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$663[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$663[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (bRP,
		                                     schematic_version,
		                                     function(b){
		                                      var a = [0, b, 0];
		                                      return caml_trampoline_cps_call2
		      (bRX,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [10,
		            function(param, cont){
		             var e1 = param[2][1], e0 = param[1];
		             return cont([0, e0, e1]);
		            },
		            function(param, cont){
		             var e1 = param[2], e0 = param[1];
		             return cont([0, e0, [0, e1, 0]]);
		            },
		            [0, b, a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$663[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$663[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$633 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$663, [0, schematic_cache$633]);
		               caml_callback
		                (state_schema_versioned$2,
		                 [function(param, cont){return cont(0);}]);
		               function apply$8(replica, a, param, cont){
		                var second = a[2], first = a[1];
		                if(0 === param[0]){
		                 var delta = param[1];
		                 return caml_trampoline_cps_call4
		                         (bRU,
		                          replica,
		                          first,
		                          delta,
		                          function(match){
		                           var first = match[3], delta = match[2], result = match[1];
		                           return caml_trampoline_cps_call3
		                                   (map$17,
		                                    delta,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta){
		                                     return cont([0, result, delta, [0, first, second]]);
		                                    });
		                          });
		                }
		                var delta$0 = param[1];
		                return caml_trampoline_cps_call4
		                        (bRM,
		                         replica,
		                         second,
		                         delta$0,
		                         function(match){
		                          var second = match[3], delta = match[2], result = match[1];
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   delta,
		                                   function(delta, cont){return cont([1, delta]);},
		                                   function(delta){
		                                    return cont([0, result, delta, [0, first, second]]);
		                                   });
		                         });
		               }
		               function apply_delta$4(replica, a, param, cont){
		                var second = a[2], first = a[1];
		                if(0 === param[0]){
		                 var delta = param[1];
		                 return caml_trampoline_cps_call4
		                         (bRT,
		                          replica,
		                          first,
		                          delta,
		                          function(a){return cont([0, a, second]);});
		                }
		                var delta$0 = param[1];
		                return caml_trampoline_cps_call4
		                        (bRL,
		                         replica,
		                         second,
		                         delta$0,
		                         function(a){return cont([0, first, a]);});
		               }
		               var
		                include$138 =
		                  caml_callback
		                   (Apply$0,
		                    [[0, [0, schema_versioned$376], apply_delta$4, apply$8]]),
		                delta_schema_versioned$3 = include$138[1],
		                apply_delta$5 = include$138[3],
		                apply$9 = include$138[4];
		               function schema_versioned$377(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_trampoline_cps_call2
		                                  (bRN[1],
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (bRV[1],
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (schematic_version,
		               V$5,
		               function(schematic_schema_version){
		                return caml_exact_trampoline_cps_call$1
		                        (function
		                         (schematic_param_first_schema_v,
		                          schematic_param_second_schema_,
		                          cont){
		                          function descriptor
		                          (schematic_param_first_schema_v,
		                           schematic_param_second_schema_){
		                           return [10,
		                                   function(param, cont){
		                                    var e1 = param[2][1], e0 = param[1];
		                                    return cont([0, e0, e1]);
		                                   },
		                                   function(param, cont){
		                                    var e1 = param[2], e0 = param[1];
		                                    return cont([0, e0, [0, e1, 0]]);
		                                   },
		                                   [0,
		                                    schematic_param_first_schema_v,
		                                    [0, schematic_param_second_schema_, 0]]];
		                          }
		                          var
		                           schematic_schema_id = match$219[1],
		                           schematic_parametric =
		                             [0,
		                              [1,
		                               cst_first,
		                               schematic_param_first_schema_v,
		                               function(schematic_param_first_schema_v, cont){
		                                return cont
		([1,
		  cst_second,
		  schematic_param_second_schema_,
		  function(schematic_param_second_schema_, cont){
		   return cont
		           ([0,
		             schematic_schema_id,
		             descriptor
		              (schematic_param_first_schema_v,
		               schematic_param_second_schema_)]);
		  }]);
		                               }]],
		                           parametric = schematic_parametric[1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_parametric,
		                                   parametric,
		                                   function(match){
		                                    function a(a){return cont();}
		                                    if(! match) return a();
		                                    var name = match[1];
		                                    return caml_exact_trampoline_cps_call(to_id, name, a);
		                                   });
		                         },
		                         b,
		                         a,
		                         function(a){return cont();});
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$377,
		                 [function(param, cont){return cont(0);}]);
		               function make$65(param, cont){
		                var second = param[2], first = param[1];
		                return caml_exact_trampoline_cps_call
		                        (bRK,
		                         second,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (bRS, first, function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$3(param, cont){
		                var second = param[2], first = param[1];
		                return caml_exact_trampoline_cps_call
		                        (bRJ,
		                         second,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (bRR,
		                                   first,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (Monad$3[11][4][4], b, a, cont);
		                                   });
		                         });
		               }
		               function blocks(operation, cont){
		                return caml_trampoline_cps_call2
		                        (bRY,
		                         operation,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (v$6, [0, operation], cont);
		                          var value = match[1];
		                          return caml_trampoline_cps_call2(return$30, value, cont);
		                         });
		               }
		               function second$0(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (bRQ,
		                         operation,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (v$6, [1, operation], cont);
		                          var value = match[1];
		                          return caml_trampoline_cps_call2(return$30, value, cont);
		                         });
		               }
		               function view$11(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (view$3,
		                         state,
		                         function(match){
		                          var order = match[2], blocks = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$0,
		                                   order,
		                                   function(a, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id, blocks, a, cont);
		                                   },
		                                   function(a){return cont([0, a]);});
		                         });
		               }
		               function make$72(param, cont){
		                var blocks = param[1];
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         blocks,
		                         function(param, cont){var id = param[1]; return cont(id);},
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (deconstruct,
		                                   blocks,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (map$11,
		     b,
		     function(block, cont){return cont([0, block[1], block]);},
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (of_sequence_exn$1,
		               [0, include$48[24]],
		               b,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (make$65, [0, b, a], cont);
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback(make$72, [aP4]);
		               function add_block(block, cont){
		                return caml_trampoline_cps_call3
		                        (Blocks[14], block[1], block, cont);
		               }
		               function insert_blocks(pos, blocks$0, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$19,
		                      symbol_map$17,
		                      ,
		                      bind$27,
		                      return$30,
		                      map$47,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$11]),
		                 let$ = open[3];
		                function a(param, cont){
		                 return caml_trampoline_cps_call3
		                         (map$18,
		                          blocks$0,
		                          id$32,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (Blocks_order[16],
		                                    pos,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call(second$0, a, cont);
		      });
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         blocks$0,
		                         add_block,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (Blocks[2][13],
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (blocks,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function insert_block(pos, content, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$19,
		                      symbol_map$17,
		                      ,
		                      bind$27,
		                      return$30,
		                      map$47,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$11]),
		                 and = open[5],
		                 let$ = open[3],
		                 id = include$48[29].call(null);
		                function a(param, cont){
		                 return caml_trampoline_cps_call2(return$30, id, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (add_block,
		                         [0, id, content],
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (blocks,
		                                   b,
		                                   function(left){
		                                    return caml_exact_trampoline_cps_call$1
		    (Blocks_order[16],
		     pos,
		     [0, id, 0],
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (second$0,
		               b,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (and,
		                         left,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function remove_blocks(position_ids, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$19,
		                      symbol_map$17,
		                      ,
		                      bind$27,
		                      return$30,
		                      map$47,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$11]),
		                 let$ = open[3];
		                return caml_exact_trampoline_cps_call
		                        (unzip,
		                         position_ids,
		                         function(match){
		                          var ids = match[2], positions = match[1];
		                          function a(param, cont){
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    positions,
		                                    function(pos, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (Blocks_order[13], pos, 1, cont);
		                                    },
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (Blocks_order[3][10],
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call(second$0, a, cont);
		      });
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   ids,
		                                   Blocks[18],
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (Blocks[2][13],
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (blocks,
		               b,
		               function(b){
		                return caml_trampoline_cps_call3(let$, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function remove_block(pos, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (remove_blocks, [0, [0, pos, id], 0], cont);
		               }
		               var
		                bRZ =
		                  g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3])
		                   [4];
		               function update_block_from_diff(param, cont){
		                var a = param[2], variant = a[1], id = param[1];
		                if(847852583 === variant)
		                 return caml_exact_trampoline_cps_call
		                         (debug$3,
		                          function(m, cont){
		                           return caml_trampoline_cps_call4(m, 0, 0, aP6, cont);
		                          },
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (Blocks[18],
		                                    id,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$9, a, cont);
		                                    });
		                          });
		                if(1013247643 <= variant){
		                 a = a[2];
		                 var block = a[2], block_old = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (equal$74,
		                          block_old,
		                          block,
		                          function(a){
		                           return a
		                                   ? cont(0)
		                                   : caml_exact_trampoline_cps_call
		                                     (debug$3,
		                                      function(m, cont){
		                                       return caml_trampoline_cps_call4(m, 0, 0, aP7, cont);
		                                      },
		                                      function(match){
		                                       var
		content_old = text$0(block_old),
		content = text$0(block);
		                                       function a(set_content){
		var
		 content = block[2],
		 kind$0 = with_text(bOE, content),
		 content$0 = block_old[2],
		 kind_old = with_text(bOE, content$0);
		return caml_exact_trampoline_cps_call$1
		        (equal$73,
		         kind$0,
		         kind_old,
		         function(b){
		          function a(a){
		           return caml_exact_trampoline_cps_call
		                   (filter_opt,
		                    [0, set_content, [0, a, 0]],
		                    function(ops){
		                     return ops
		                             ? caml_exact_trampoline_cps_call
		                               (all_unit$4,
		                                ops,
		                                function(a){
		                                 return caml_trampoline_cps_call2
		 (Blocks[16],
		  id,
		  function(b){
		   return caml_trampoline_cps_call2
		           (b,
		            a,
		            function(a){
		             return caml_trampoline_cps_call2(return$9, a, cont);
		            });
		  });
		                                })
		                             : cont(0);
		                    });
		          }
		          return b
		                  ? a(0)
		                  : caml_exact_trampoline_cps_call
		                    (set$11,
		                     kind$0,
		                     function(b){
		                      return caml_exact_trampoline_cps_call
		                              (kind, b, function(b){return a([0, b]);});
		                     });
		         });
		                                       }
		                                       if(content_old === content) return a(0);
		                                       function b(text_op, cont){
		return caml_exact_trampoline_cps_call
		        (text$1,
		         text_op,
		         function(a){
		          return caml_exact_trampoline_cps_call(ignore_m$3, a, cont);
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (diff$1,
		        content_old,
		        content,
		        function(c){return caml_trampoline_cps_call3(bRZ, c, b, a);});
		                                      });
		                          });
		                }
		                var block$0 = a[2];
		                return caml_exact_trampoline_cps_call
		                        (debug$3,
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, aP8, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (add_block, block$0, function(a){return cont([0, a]);});
		                         });
		               }
		               function update_from_diff(f, previous, doc, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function index(document, cont){
		                 return caml_exact_trampoline_cps_call
		                         (deconstruct,
		                          document[1],
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    a,
		                                    function(block, cont){return cont([0, block[1], block]);},
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (of_sequence_reduce$1,
		      [0, include$48[24]],
		      a,
		      function(bl1, bl2, cont){
		       return caml_exact_trampoline_cps_call
		               (err$1,
		                function(m, cont){
		                 return caml_trampoline_cps_call8
		                         (m, 0, 0, aP5, pp$59, bl1, pp$59, bl2, cont);
		                },
		                function(match){return cont(bl2);});
		      },
		      cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (index,
		                         doc,
		                         function(blocks$0){
		                          return caml_exact_trampoline_cps_call
		                                  (index,
		                                   previous,
		                                   function(previous_blocks){
		                                    return caml_exact_trampoline_cps_call$0
		    (symmetric_diff$2,
		     previous_blocks,
		     blocks$0,
		     equal$74,
		     function(block_diffs){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$1,
		               block_diffs,
		               function(diff, cont){
		                function a(op, cont){
		                 return caml_exact_trampoline_cps_call
		                         (f, diff, function(a){return cont([0, op, a]);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (update_block_from_diff,
		                         diff,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               },
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (to_binable,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (unzip,
		                                   a,
		                                   function(match){
		                                    var xs = match[2], block_ops = match[1];
		                                    function a(blocks_op){
		                                     return caml_trampoline_cps_call3
		     (map$18,
		      doc[1],
		      function(param, cont){var id = param[1]; return cont(id);},
		      function(new_order){
		       return caml_trampoline_cps_call3
		               (map$18,
		                previous[1],
		                function(param, cont){var id = param[1]; return cont(id);},
		                function(previous_order){
		                 function a(order_op, cont){
		                  return caml_exact_trampoline_cps_call
		                          (second$0, order_op, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (Blocks_order[17],
		                          previous_order,
		                          new_order,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    b,
		                                    a,
		                                    function(order_op){
		                                     return caml_exact_trampoline_cps_call
		     (filter_opt,
		      [0, blocks_op, [0, order_op, 0]],
		      function(ops){
		       function a(op){return cont([0, op, xs]);}
		       return ops
		               ? caml_exact_trampoline_cps_call
		                 (all_unit$1,
		                  ops,
		                  function(b){
		                   return caml_trampoline_cps_call2(return$9, b, a);
		                  })
		               : a(0);
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return block_ops
		    ? caml_trampoline_cps_call2
		      (Blocks[2][13],
		       block_ops,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (blocks,
		                 b,
		                 function(b){
		                  return caml_trampoline_cps_call2(return$9, b, a);
		                 });
		       })
		    : a(0);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function diff$4(previous, doc, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (update_from_diff,
		                         function(param, cont){return cont(0);},
		                         previous,
		                         doc,
		                         function(a){return cont(a[1]);});
		               }
		               var
		                Integrations =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, schema_versioned$254, , equal$159]]),
		                Mentions =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, schema_versioned$255, , equal$160]]),
		                References =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, schema_versioned$256, , equal$161]]),
		                cst_Integrations = "Integrations",
		                letrec_function_context$666 = [];
		               function schema_versioned$387(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$666[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aP9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$666[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$666[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$666[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (References[6],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aP_,
		   cst_references,
		   "References",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_references, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Mentions[6],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aP$,
		             cst_mentions,
		             "Mentions",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_mentions, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Integrations[6],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aQa,
		                        cst_integrations,
		                        cst_Integrations,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0,
		                           [0, 0, 0, 0, 0, cst_integrations, 0, 2, [0, a], 0, 0],
		                           0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$666[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$666[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$636 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$666, [0, schematic_cache$636]);
		               caml_callback
		                (schema_versioned$387,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$145 = Monadic$0(),
		                v$8 = include$145[1],
		                all_unit$5 = include$145[12],
		                Apply$2 = include$145[14],
		                letrec_function_context$667 = [];
		               function state_schema_versioned$9(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$667[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQb, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$667[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$667[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$667[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (References[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_references, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Mentions[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_mentions, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Integrations[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        references = a[2][1],
		                        mentions = a[1],
		                        integrations = param[1];
		                       return cont([0, integrations, mentions, references]);
		                      },
		                      function(param, cont){
		                       var
		                        references = param[3],
		                        mentions = param[2],
		                        integrations = param[1];
		                       return cont
		                               ([0, integrations, [0, mentions, [0, references, 0]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_integrations, 0, 2, [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$667[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$667[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$637 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$667, [0, schematic_cache$637]);
		               caml_callback
		                (state_schema_versioned$9,
		                 [function(param, cont){return cont(0);}]);
		               function make$73(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (References[12],
		                         init[3],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Mentions[12],
		                                   init[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Integrations[12],
		     init[1],
		     function(c){return cont([0, c, b, a]);});
		                                   });
		                         });
		               }
		               function view$12(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (References[19],
		                         t[3],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Mentions[19],
		                                   t[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Integrations[19],
		     t[1],
		     function(c){return cont([0, c, b, a]);});
		                                   });
		                         });
		               }
		               function apply$17(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Integrations[10],
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var new_state = [0, new_substate, state[2], state[3]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Mentions[10],
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var new_state = [0, state[1], new_substate, state[3]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (References[10],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var new_state = [0, state[1], state[2], new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$13(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Integrations[11],
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont([0, new_substate, state[2], state[3]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Mentions[11],
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont([0, state[1], new_substate, state[3]]);
		                            });
		                  default:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (References[11],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont([0, state[1], state[2], new_substate]);
		                            });
		                }
		               }
		               var
		                include$146 =
		                  caml_callback
		                   (Apply$2,
		                    [[0, [0, schema_versioned$387], apply_delta$13, apply$17]]),
		                delta_schema_versioned$10 = include$146[1],
		                apply_delta$14 = include$146[3],
		                apply$18 = include$146[4];
		               function integrations(op, cont){
		                return caml_exact_trampoline_cps_call(v$8, [0, op], cont);
		               }
		               function mentions(op, cont){
		                return caml_exact_trampoline_cps_call(v$8, [1, op], cont);
		               }
		               function references(op, cont){
		                return caml_exact_trampoline_cps_call(v$8, [2, op], cont);
		               }
		               function diff$5(previous, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (References[17],
		                         previous[3],
		                         t[3],
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   a,
		                                   references,
		                                   function(b){
		                                    var a = [0, b, 0];
		                                    return caml_exact_trampoline_cps_call$1
		    (Mentions[17],
		     previous[2],
		     t[2],
		     function(b){
		      return caml_trampoline_cps_call3
		              (map$17,
		               b,
		               mentions,
		               function(c){
		                var b = [0, c, a];
		                return caml_exact_trampoline_cps_call$1
		                        (Integrations[17],
		                         previous[1],
		                         t[1],
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   a,
		                                   integrations,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0, a, b],
		     function(a){
		      return caml_exact_trampoline_cps_call(all_unit$5, a, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                cst_Context = "Context",
		                cst_Document = "Document",
		                letrec_function_context$668 = [];
		               function schema_versioned$388(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$668[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$668[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$668[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$668[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$3,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQd,
		   cst_document,
		   cst_Document,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_document, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$10,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aQe,
		              cst_context,
		              cst_Context,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_context, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$668[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$668[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$638 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$668, [0, schematic_cache$638]);
		               caml_callback
		                (schema_versioned$388,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$147 = Monadic$0(),
		                v$9 = include$147[1],
		                all_unit$6 = include$147[12],
		                Apply$3 = include$147[14],
		                letrec_function_context$669 = [];
		               function state_schema_versioned$10(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$669[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$669[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$669[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$669[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$2,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_document, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$9,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var document = param[2][1], context = param[1];
		             return cont([0, context, document]);
		            },
		            function(param, cont){
		             var document = param[2], context = param[1];
		             return cont([0, context, [0, document, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_context, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$669[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$669[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$639 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$669, [0, schematic_cache$639]);
		               caml_callback
		                (state_schema_versioned$10,
		                 [function(param, cont){return cont(0);}]);
		               function make$74(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (make$72,
		                         init[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (make$73, init[1], function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$13(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (view$11,
		                         t[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (view$12, t[1], function(b){return cont([0, b, a]);});
		                         });
		               }
		               function apply$19(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                if(0 === op[0]){
		                 var op$0 = op[1];
		                 return caml_trampoline_cps_call4
		                         (apply$18,
		                          replica,
		                          state[1],
		                          op$0,
		                          function(match){
		                           var
		                            new_substate = match[3],
		                            delta = match[2],
		                            res = match[1];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    delta,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta){
		                                     var new_state = [0, new_substate, state[2]];
		                                     return cont([0, res, delta, new_state]);
		                                    });
		                          });
		                }
		                var op$1 = op[1];
		                return caml_trampoline_cps_call4
		                        (apply$9,
		                         replica,
		                         state[2],
		                         op$1,
		                         function(match){
		                          var
		                           new_substate = match[3],
		                           delta = match[2],
		                           res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   delta,
		                                   function(delta, cont){return cont([1, delta]);},
		                                   function(delta){
		                                    var new_state = [0, state[1], new_substate];
		                                    return cont([0, res, delta, new_state]);
		                                   });
		                         });
		               }
		               function apply_delta$15(replica, state, delta, cont){
		                if(0 === delta[0]){
		                 var delta$0 = delta[1];
		                 return caml_trampoline_cps_call4
		                         (apply_delta$14,
		                          replica,
		                          state[1],
		                          delta$0,
		                          function(new_substate){
		                           return cont([0, new_substate, state[2]]);
		                          });
		                }
		                var delta$1 = delta[1];
		                return caml_trampoline_cps_call4
		                        (apply_delta$5,
		                         replica,
		                         state[2],
		                         delta$1,
		                         function(new_substate){
		                          return cont([0, state[1], new_substate]);
		                         });
		               }
		               var
		                include$148 =
		                  caml_callback
		                   (Apply$3,
		                    [[0, [0, schema_versioned$388], apply_delta$15, apply$19]]),
		                delta_schema_versioned$11 = include$148[1],
		                apply_delta$16 = include$148[3],
		                apply$20 = include$148[4];
		               function document$0(op, cont){
		                return caml_exact_trampoline_cps_call(v$9, [1, op], cont);
		               }
		               function diff$6(previous, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (diff$5,
		                         previous[1],
		                         t[1],
		                         function(op){
		                          return caml_exact_trampoline_cps_call
		                                  (v$9,
		                                   [0, op],
		                                   function(x){
		                                    var a = [0, [0, x], 0];
		                                    return caml_exact_trampoline_cps_call$1
		    (diff$4,
		     previous[2],
		     t[2],
		     function(b){
		      return caml_trampoline_cps_call3
		              (map$17,
		               b,
		               document$0,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (filter_opt,
		                         [0, b, a],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(all_unit$6, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                Id$10 = caml_callback(b8, [[0, schema_versioned$110]]),
		                Automations =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, schema_versioned$266, , equal$171]]),
		                Conversations =
		                  caml_callback
		                   (bOD,
		                    [[0,
		                      schema_versioned$259,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$33,
		                      pp$85]]),
		                cst_Automations = "Automations",
		                cst_Conversations = "Conversations",
		                letrec_function_context$670 = [];
		               function schema_versioned$389(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$670[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$670[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$670[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$670[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$11,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([7, f0]);},
		   function(param, cont){
		    if(7 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQh,
		   cst_working_memory,
		   "Working_memory",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_working_memory, 0, 2, [0, b], 0, 0],
		      0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$11,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(6 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQi,
		             cst_user_preferences,
		             "User_preferences",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_user_preferences, 0, 2, [0, c], 0, 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (String_opt_LWW[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([5, f0]);},
		                       function(param, cont){
		                        if(5 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aQj,
		                       cst_name,
		                       cst_Name,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (String_opt_LWW[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(4 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aQk,
		                                 cst_key,
		                                 "Key",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$10[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQl,
		   cst_id,
		   cst_Id,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Conversations[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQm,
		             cst_conversations,
		             cst_Conversations,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_conversations, 0, 2, [0, c], 0, 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Automations[6],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aQn,
		                       cst_automations,
		                       cst_Automations,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_automations, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$11,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aQo,
		                                  cst_agent_instructions,
		                                  "Agent_instructions",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_agent_instructions, 0, 2, [0, b], 0, 0],
		                                     0]],
		                                   0],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$670[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$670[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$640 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$670, [0, schematic_cache$640]);
		               caml_callback
		                (schema_versioned$389,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$149 = Monadic$0(),
		                v$10 = include$149[1],
		                const$0 = include$149[2],
		                all_unit$7 = include$149[12],
		                Apply$4 = include$149[14],
		                letrec_function_context$671 = [];
		               function state_schema_versioned$11(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$671[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQp, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$671[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$671[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$671[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$10,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_working_memory, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$10,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_user_preferences, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (String_opt_LWW[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (String_opt_LWW[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$10[2],
		                                     schematic_version,
		                                     function(c){
		                                      var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                                      return caml_trampoline_cps_call2
		      (Conversations[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_conversations, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (Automations[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_automations, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$10,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  working_memory = f[2][1],
		                                  user_preferences = f[1],
		                                  name = e[1],
		                                  key = d[1],
		                                  id = c[1],
		                                  conversations = b[1],
		                                  automations = a[1],
		                                  agent_instructions = param[1];
		                                 return cont
		 ([0,
		   agent_instructions,
		   automations,
		   conversations,
		   id,
		   key,
		   name,
		   user_preferences,
		   working_memory]);
		                                },
		                                function(param, cont){
		                                 var
		                                  working_memory = param[8],
		                                  user_preferences = param[7],
		                                  name = param[6],
		                                  key = param[5],
		                                  id = param[4],
		                                  conversations = param[3],
		                                  automations = param[2],
		                                  agent_instructions = param[1];
		                                 return cont
		 ([0,
		   agent_instructions,
		   [0,
		    automations,
		    [0,
		     conversations,
		     [0,
		      id,
		      [0,
		       key,
		       [0, name, [0, user_preferences, [0, working_memory, 0]]]]]]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_agent_instructions, 0, 2, [0, b], 0, 0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$671[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$671[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$641 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$671, [0, schematic_cache$641]);
		               var
		                state_schema$1 =
		                  caml_callback
		                   (state_schema_versioned$11,
		                    [function(param, cont){return cont(0);}]);
		               function make$75(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (make$74,
		                         init[8],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (make$74,
		                                   init[7],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (String_opt_LWW[10],
		     init[6],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (String_opt_LWW[10],
		               init[5],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Id$10[10],
		                         init[4],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Conversations[10],
		                                   init[3],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Automations[12],
		     init[2],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (make$74,
		               init[1],
		               function(h){return cont([0, h, g, f, e, d, c, b, a]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$14(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (view$13,
		                         t[8],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (view$13,
		                                   t[7],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (String_opt_LWW[11],
		     t[6],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (String_opt_LWW[11],
		               t[5],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Id$10[11],
		                         t[4],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Conversations[11],
		                                   t[3],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Automations[19],
		     t[2],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (view$13,
		               t[1],
		               function(h){return cont([0, h, g, f, e, d, c, b, a]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$21(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$20,
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   new_substate,
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Automations[10],
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   new_substate,
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Conversations[8],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   new_substate,
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$10[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   new_substate,
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 4:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[8],
		                            replica,
		                            state[5],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   new_substate,
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 5:
		                   var op$4 = op[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[8],
		                            replica,
		                            state[6],
		                            op$4,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   new_substate,
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 6:
		                   var op$5 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$20,
		                            replica,
		                            state[7],
		                            op$5,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   new_substate,
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$6 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$20,
		                            replica,
		                            state[8],
		                            op$6,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([7, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$17(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$16,
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       new_substate,
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Automations[11],
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       new_substate,
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Conversations[9],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       new_substate,
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$10[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       new_substate,
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 4:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[9],
		                            replica,
		                            state[5],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       new_substate,
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 5:
		                   var delta$4 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[9],
		                            replica,
		                            state[6],
		                            delta$4,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       new_substate,
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 6:
		                   var delta$5 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$16,
		                            replica,
		                            state[7],
		                            delta$5,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       new_substate,
		                                       state[8]]);
		                            });
		                  default:
		                   var delta$6 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$16,
		                            replica,
		                            state[8],
		                            delta$6,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       new_substate]);
		                            });
		                }
		               }
		               var
		                include$150 =
		                  caml_callback
		                   (Apply$4,
		                    [[0, [0, schema_versioned$389], apply_delta$17, apply$21]]),
		                delta_schema_versioned$12 = include$150[1],
		                delta_schema$1 = include$150[2],
		                apply_delta$18 = include$150[3],
		                apply$22 = include$150[4];
		               function conversations(op, cont){
		                return caml_exact_trampoline_cps_call(v$10, [2, op], cont);
		               }
		               function Make$29(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$0],
		                      state_schema_versioned$11,
		                      state_schema$1,
		                      delta_schema_versioned$12,
		                      delta_schema$1,
		                      [0, schema_versioned$262, schema$107],
		                      include$0,
		                      apply$22,
		                      apply_delta$18,
		                      make$75,
		                      view$14,
		                      equal$167]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$167,
		                    [0, const$0],
		                    state_schema_versioned$11,
		                    state_schema$1,
		                    delta_schema_versioned$12,
		                    delta_schema$1,
		                    [0, schema_versioned$262, schema$107],
		                    include$0,
		                    apply$22,
		                    apply_delta$18,
		                    make$75,
		                    view$14];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          Agent[4],
		                          Agent[5],
		                          Agent[9],
		                          Agent[10],
		                          Agent[11],
		                          Agent[12],
		                          Agent[13],
		                          Agent[14],
		                          Agent[15],
		                          Agent[16],
		                          Agent[17],
		                          Agent[18],
		                          Agent[19],
		                          Agent[20],
		                          Agent[21],
		                          Agent[22],
		                          Agent[23],
		                          Agent[24],
		                          Agent[1]],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       add = include[14],
		       element = include[16],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                ,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                ,
		                add,
		                ,
		                element,
		                ,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                Ident =
		                  [0,
		                   [0,
		                    symbol_bind$20,
		                    symbol_map$18,
		                    Monad_infix$0,
		                    bind$28,
		                    return$31,
		                    map$48,
		                    join$8,
		                    ignore_m$1,
		                    all$21,
		                    all_unit$2,
		                    Let_syntax$12],
		                   Make_base_atom,
		                   Make_atom,
		                   Make_base_map,
		                   Make_map],
		                include$151 = caml_callback(Make$29, [Ident]),
		                delta_schema_versioned$13 = include$151[5],
		                Id$11 = caml_callback(b8, [[0, schema_versioned$266]]),
		                Steps =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, schema_versioned$263, , equal$168]]),
		                Trigger =
		                  caml_callback(A, [[0, schema_versioned$270, schema$112]]),
		                cst_Steps = "Steps",
		                cst_Trigger = "Trigger",
		                letrec_function_context$672 = [];
		               function schema_versioned$390(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$672[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQq, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$672[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$672[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$672[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aQs,
		                                     aQr,
		                                     1,
		                                     0,
		                                     2,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_trampoline_cps_call2
		      (Trigger[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQt,
		             cst_trigger,
		             cst_Trigger,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aQv,
		                 aQu,
		                 1,
		                 0,
		                 5,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_trampoline_cps_call2
		                          (include$139[4],
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aQw,
		                                 cst_enabled,
		                                 cst_Enabled,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_enabled, 0, 2, [0, d], 0, 0], 0]],
		                                  0],
		                                 a],
		                                b];
		                            return caml_trampoline_cps_call2
		                                    (Steps[6],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQx,
		   cst_steps,
		   cst_Steps,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_steps, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  c];
		                                      return caml_trampoline_cps_call2
		      (String_opt_LWW[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQy,
		             cst_name,
		             cst_Name,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (Id$11[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aQz,
		                        cst_id,
		                        cst_Id,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$672[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$672[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$642 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$672, [0, schematic_cache$642]);
		               caml_callback
		                (schema_versioned$390,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$152 = Monadic$0(),
		                v$11 = include$152[1],
		                const$1 = include$152[2],
		                all_unit$8 = include$152[12],
		                Apply$5 = include$152[14],
		                letrec_function_context$673 = [];
		               function state_schema_versioned$12(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$673[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$673[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$673[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$673[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Trigger[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (include$139[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_enabled, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Steps[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_steps, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (String_opt_LWW[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$11[2],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    trigger = c[2][1],
		    enabled = c[1],
		    steps = b[1],
		    name = a[1],
		    id = param[1];
		   return cont([0, id, name, steps, enabled, trigger]);
		  },
		  function(param, cont){
		   var
		    trigger = param[5],
		    enabled = param[4],
		    steps = param[3],
		    name = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0, name, [0, steps, [0, enabled, [0, trigger, 0]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$673[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$673[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$643 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$673, [0, schematic_cache$643]);
		               var
		                state_schema$2 =
		                  caml_callback
		                   (state_schema_versioned$12,
		                    [function(param, cont){return cont(0);}]);
		               function make$76(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (Trigger[10],
		                         init[5],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[10],
		                                   init[4],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Steps[12],
		     init[3],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (String_opt_LWW[10],
		               init[2],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Id$11[10],
		                         init[1],
		                         function(e){return cont([0, e, d, c, b, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function view$15(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (Trigger[11],
		                         t[5],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[11],
		                                   t[4],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Steps[19],
		     t[3],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (String_opt_LWW[11],
		               t[2],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Id$11[11],
		                         t[1],
		                         function(e){return cont([0, e, d, c, b, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$23(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$11[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, new_substate, state[2], state[3], state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[8],
		                            replica,
		                            state[2],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], new_substate, state[3], state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Steps[10],
		                            replica,
		                            state[3],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], new_substate, state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[8],
		                            replica,
		                            state[4],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], state[3], new_substate, state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Trigger[8],
		                            replica,
		                            state[5],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], state[3], state[4], new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$19(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$11[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0, new_substate, state[2], state[3], state[4], state[5]]);
		                            });
		                  case 1:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[9],
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], new_substate, state[3], state[4], state[5]]);
		                            });
		                  case 2:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Steps[11],
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], new_substate, state[4], state[5]]);
		                            });
		                  case 3:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[9],
		                            replica,
		                            state[4],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], state[3], new_substate, state[5]]);
		                            });
		                  default:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Trigger[9],
		                            replica,
		                            state[5],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], new_substate]);
		                            });
		                }
		               }
		               var
		                include$153 =
		                  caml_callback
		                   (Apply$5,
		                    [[0, [0, schema_versioned$390], apply_delta$19, apply$23]]),
		                delta_schema_versioned$14 = include$153[1],
		                delta_schema$2 = include$153[2],
		                apply_delta$20 = include$153[3],
		                apply$24 = include$153[4],
		                Id$12 = caml_callback(b8, [[0, Automation_run[4]]]),
		                Automation_id = caml_callback(b8, [[0, schema_versioned$266]]);
		               function schema_versioned$391(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schematic_param_name_schema_ve,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                Automation_name =
		                  caml_callback(b8, [[0, schema_versioned$391]]);
		               function schema_versioned$392(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$131,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$392,
		                 [function(param, cont){return cont(0);}]);
		               var Object_id = caml_callback(b8, [[0, schema_versioned$392]]);
		               function schema_versioned$393(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   no_input_schema,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                Object_context =
		                  caml_callback(b8, [[0, schema_versioned$393]]);
		               function schema_versioned$394(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$4,
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$394,
		                 [function(param, cont){return cont(0);}]);
		               var
		                Started_at = caml_callback(b8, [[0, schema_versioned$394]]),
		                Trigger$0 = caml_callback(b8, [[0, schema_versioned$270]]),
		                Status$0 =
		                  caml_callback(A, [[0, schema_versioned$280, schema$115]]),
		                letrec_function_context$674 = [];
		               function schema_versioned$395(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$674[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$674[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$674[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$674[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$281,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$674[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$674[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$644 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$674, [0, schematic_cache$644]);
		               var
		                schema$152 =
		                  caml_callback
		                   (schema_versioned$395,
		                    [function(param, cont){return cont(0);}]),
		                Step_results =
		                  caml_callback(A, [[0, schema_versioned$395, schema$152]]),
		                letrec_function_context$675 = [];
		               function compat_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$675[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQB, 0, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$675[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$675[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$675[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$270,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$281,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_step_results,
		             0,
		             2,
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$280,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$4,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_started_at, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$131,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_object_id$0, 0, 3, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (Automation_run[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_automation_name,
		             0,
		             3,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$266,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var
		                         f7 = param[8],
		                         f6 = param[7],
		                         f5 = param[6],
		                         f4 = param[5],
		                         f3 = param[4],
		                         f2 = param[3],
		                         f1 = param[2],
		                         f0 = param[1];
		                        return cont([1, f0, f1, f2, f3, f4, f5, f6, f7]);
		                       },
		                       function(param, cont){
		                        if(0 === param[0]) return cont(0);
		                        var
		                         f7 = param[8],
		                         f6 = param[7],
		                         f5 = param[6],
		                         f4 = param[5],
		                         f3 = param[4],
		                         f2 = param[3],
		                         f1 = param[2],
		                         f0 = param[1];
		                        return cont([0, [0, f0, f1, f2, f3, f4, f5, f6, f7]]);
		                       },
		                       1,
		                       0,
		                       "without_object_context",
		                       "Without_object_context",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           c = b[2],
		                           d = c[2],
		                           e = d[2],
		                           f = e[2],
		                           trigger = f[2][1],
		                           step_results = f[1],
		                           status = e[1],
		                           started_at = d[1],
		                           object_id = c[1],
		                           id = b[1],
		                           automation_name = a[1],
		                           automation_id = param[1];
		                          return cont
		                                  ([0,
		                                    automation_id,
		                                    automation_name,
		                                    id,
		                                    object_id,
		                                    started_at,
		                                    status,
		                                    step_results,
		                                    trigger]);
		                         },
		                         function(param, cont){
		                          var
		                           trigger = param[8],
		                           step_results = param[7],
		                           status = param[6],
		                           started_at = param[5],
		                           object_id = param[4],
		                           id = param[3],
		                           automation_name = param[2],
		                           automation_id = param[1];
		                          return cont
		                                  ([0,
		                                    automation_id,
		                                    [0,
		                                     automation_name,
		                                     [0,
		                                      id,
		                                      [0,
		                                       object_id,
		                                       [0,
		started_at,
		[0, status, [0, step_results, [0, trigger, 0]]]]]]]]);
		                         },
		                         [0,
		                          [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, c], 0, 0],
		                          b]],
		                        0],
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$282,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_current,
		                                  "Current",
		                                  b,
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$675[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$675[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$645 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$675, [0, schematic_cache$645]);
		               caml_callback
		                (compat_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$396(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (compat_schema_versioned,
		                         v,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (v,
		                                   V$4,
		                                   function(match){
		                                    function c(b){
		                                     var
		                                      schema =
		map$14
		 (function(param, cont){
		   if(0 === param[0]){var t = param[1]; return cont([0, t]);}
		   var
		    trigger = param[8],
		    step_results = param[7],
		    status = param[6],
		    started_at = param[5],
		    object_id = param[4],
		    id = param[3],
		    automation_name = param[2],
		    automation_id = param[1];
		   return cont
		           ([0,
		             [0,
		              automation_id,
		              automation_name,
		              id,
		              object_id,
		              0,
		              started_at,
		              status,
		              step_results,
		              trigger]]);
		  },
		  b,
		  a);
		                                     return cont([0, aQC, schema[2], schema[3], schema[4]]);
		                                    }
		                                    function b(){
		                                     return c(function(t, cont){return cont([0, t]);});
		                                    }
		                                    if(! match) return b();
		                                    var version = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_string_exn,
		     "1.1.3-beta.0.ai-human-in-the-loop",
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$66,
		               version,
		               a,
		               function(a){
		                return a
		                        ? c
		                          (function(param, cont){
		                            var
		                             trigger = param[9],
		                             step_results = param[8],
		                             status = param[7],
		                             started_at = param[6],
		                             object_id = param[4],
		                             id = param[3],
		                             automation_name = param[2],
		                             automation_id = param[1];
		                            return cont
		                                    ([1,
		                                      automation_id,
		                                      automation_name,
		                                      id,
		                                      object_id,
		                                      started_at,
		                                      status,
		                                      step_results,
		                                      trigger]);
		                           })
		                        : b();
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                schema$153 =
		                  caml_callback
		                   (schema_versioned$396,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$676 = [];
		               function schema_versioned$397(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$676[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$676[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$676[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$676[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Trigger$0[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([8, f0]);},
		   function(param, cont){
		    if(8 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQE,
		   cst_trigger,
		   cst_Trigger,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Step_results[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([7, f0]);},
		             function(param, cont){
		              if(7 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQF,
		             cst_step_results,
		             "Step_results",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_step_results, 0, 2, [0, c], 0, 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Status$0[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([6, f0]);},
		                       function(param, cont){
		                        if(6 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aQG,
		                       cst_status,
		                       cst_Status,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (Started_at[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([5, f0]);},
		                                 function(param, cont){
		                                  if(5 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aQH,
		                                 cst_started_at,
		                                 "Started_at",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_started_at, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Object_context[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(4 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQI,
		   cst_object_context,
		   "Object_context",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_object_context, 0, 2, [0, c], 0, 0],
		      0]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (Object_id[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQJ,
		             cst_object_id$0,
		             "Object_id",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_object_id$0, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (Id$12[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aQK,
		                       cst_id,
		                       cst_Id,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (Automation_name[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aQL,
		                                 cst_automation_name,
		                                 "Automation_name",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_automation_name, 0, 2, [0, c], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Automation_id[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    aQM,
		    cst_automation_id,
		    "Automation_id",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var delta = param[1];
		       return cont(delta);
		      },
		      function(delta, cont){return cont([0, delta, 0]);},
		      [0,
		       [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, a], 0, 0],
		       0]],
		     0],
		    0],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$676[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$676[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$646 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$676, [0, schematic_cache$646]);
		               caml_callback
		                (schema_versioned$397,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$154 = Monadic$0(),
		                v$12 = include$154[1],
		                const$2 = include$154[2],
		                Apply$6 = include$154[14],
		                letrec_function_context$677 = [];
		               function state_schema_versioned$13(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$677[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQN, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$677[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$677[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$677[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Trigger$0[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Step_results[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_step_results, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (Status$0[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Started_at[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_started_at, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Object_context[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_object_context, 0, 2, [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (Object_id[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_object_id$0, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Id$12[2],
		                 schematic_version,
		                 function(c){
		                  var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Automation_name[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_automation_name, 0, 2, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Automation_id[2],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    trigger = g[2][1],
		    step_results = g[1],
		    status = f[1],
		    started_at = e[1],
		    object_context = d[1],
		    object_id = c[1],
		    id = b[1],
		    automation_name = a[1],
		    automation_id = param[1];
		   return cont
		           ([0,
		             automation_id,
		             automation_name,
		             id,
		             object_id,
		             object_context,
		             started_at,
		             status,
		             step_results,
		             trigger]);
		  },
		  function(param, cont){
		   var
		    trigger = param[9],
		    step_results = param[8],
		    status = param[7],
		    started_at = param[6],
		    object_context = param[5],
		    object_id = param[4],
		    id = param[3],
		    automation_name = param[2],
		    automation_id = param[1];
		   return cont
		           ([0,
		             automation_id,
		             [0,
		              automation_name,
		              [0,
		               id,
		               [0,
		                object_id,
		                [0,
		                 object_context,
		                 [0,
		                  started_at,
		                  [0, status, [0, step_results, [0, trigger, 0]]]]]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, a], 0, 0],
		   b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$677[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$677[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$647 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$677, [0, schematic_cache$647]);
		               var
		                state_schema$3 =
		                  caml_callback
		                   (state_schema_versioned$13,
		                    [function(param, cont){return cont(0);}]);
		               function make$77(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (Trigger$0[10],
		                         init[9],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Step_results[10],
		                                   init[8],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Status$0[10],
		     init[7],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Started_at[10],
		               init[6],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Object_context[10],
		                         init[5],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Object_id[10],
		                                   init[4],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Id$12[10],
		     init[3],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (Automation_name[10],
		               init[2],
		               function(h){
		                return caml_exact_trampoline_cps_call
		                        (Automation_id[10],
		                         init[1],
		                         function(i){return cont([0, i, h, g, f, e, d, c, b, a]);});
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$16(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (Trigger$0[11],
		                         t[9],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Step_results[11],
		                                   t[8],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Status$0[11],
		     t[7],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Started_at[11],
		               t[6],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Object_context[11],
		                         t[5],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Object_id[11],
		                                   t[4],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Id$12[11],
		     t[3],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (Automation_name[11],
		               t[2],
		               function(h){
		                return caml_exact_trampoline_cps_call
		                        (Automation_id[11],
		                         t[1],
		                         function(i){return cont([0, i, h, g, f, e, d, c, b, a]);});
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$25(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$0
		                           (Automation_id[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   new_substate,
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   return caml_exact_trampoline_cps_call$0
		                           (Automation_name[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   new_substate,
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$12[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   new_substate,
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call$0
		                           (Object_id[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   new_substate,
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 4:
		                   return caml_exact_trampoline_cps_call$0
		                           (Object_context[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   new_substate,
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 5:
		                   return caml_exact_trampoline_cps_call$0
		                           (Started_at[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   new_substate,
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 6:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Status$0[8],
		                            replica,
		                            state[7],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   new_substate,
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 7:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Step_results[8],
		                            replica,
		                            state[8],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([7, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   new_substate,
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   return caml_exact_trampoline_cps_call$0
		                           (Trigger$0[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([8, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$21(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$0
		                           (Automation_id[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       new_substate,
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 1:
		                   return caml_exact_trampoline_cps_call$0
		                           (Automation_name[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       new_substate,
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 2:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$12[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       new_substate,
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call$0
		                           (Object_id[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       new_substate,
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 4:
		                   return caml_exact_trampoline_cps_call$0
		                           (Object_context[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       new_substate,
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 5:
		                   return caml_exact_trampoline_cps_call$0
		                           (Started_at[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       new_substate,
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 6:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Status$0[9],
		                            replica,
		                            state[7],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       new_substate,
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 7:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Step_results[9],
		                            replica,
		                            state[8],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       new_substate,
		                                       state[9]]);
		                            });
		                  default:
		                   return caml_exact_trampoline_cps_call$0
		                           (Trigger$0[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       new_substate]);
		                            });
		                }
		               }
		               var
		                include$155 =
		                  caml_callback
		                   (Apply$6,
		                    [[0, [0, schema_versioned$397], apply_delta$21, apply$25]]),
		                delta_schema_versioned$15 = include$155[1],
		                delta_schema$3 = include$155[2],
		                apply_delta$22 = include$155[3],
		                apply$26 = include$155[4];
		               function set_status(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (Status$0[12],
		                         v,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$12, [6, a], cont);
		                         });
		               }
		               function Make$30(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$2],
		                      state_schema_versioned$13,
		                      state_schema$3,
		                      delta_schema_versioned$15,
		                      delta_schema$3,
		                      [0, schema_versioned$396, schema$153],
		                      include$0,
		                      apply$26,
		                      apply_delta$22,
		                      make$77,
		                      view$16,
		                      equal$185]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$185,
		                    [0, const$2],
		                    state_schema_versioned$13,
		                    state_schema$3,
		                    delta_schema_versioned$15,
		                    delta_schema$3,
		                    [0, schema_versioned$396, schema$153],
		                    include$0,
		                    apply$26,
		                    apply_delta$22,
		                    make$77,
		                    view$16];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          Automation_run[4],
		                          Automation_run[5],
		                          Automation_run[9],
		                          Automation_run[10],
		                          Automation_run[11],
		                          Automation_run[12],
		                          Automation_run[13],
		                          Automation_run[14],
		                          Automation_run[15],
		                          Automation_run[16],
		                          Automation_run[17],
		                          Automation_run[18],
		                          Automation_run[19],
		                          Automation_run[20],
		                          Automation_run[21],
		                          Automation_run[22],
		                          Automation_run[23],
		                          Automation_run[24],
		                          Automation_run[1]],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       add = include[14],
		       element = include[16],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                ,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                ,
		                add,
		                ,
		                element,
		                ,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$156 = caml_callback(Make$30, [Ident]),
		                delta_schema_versioned$16 = include$156[5];
		               function Make$31(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$1],
		                      state_schema_versioned$12,
		                      state_schema$2,
		                      delta_schema_versioned$14,
		                      delta_schema$2,
		                      [0, schema_versioned$271, schema$113],
		                      include$0,
		                      apply$24,
		                      apply_delta$20,
		                      make$76,
		                      view$15,
		                      equal$175]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$175,
		                    [0, const$1],
		                    state_schema_versioned$12,
		                    state_schema$2,
		                    delta_schema_versioned$14,
		                    delta_schema$2,
		                    [0, schema_versioned$271, schema$113],
		                    include$0,
		                    apply$24,
		                    apply_delta$20,
		                    make$76,
		                    view$15];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$266,
		                          schema$111,
		                          symbol$181,
		                          symbol$182,
		                          symbol$183,
		                          symbol$184,
		                          symbol$185,
		                          symbol$186,
		                          equal$171,
		                          compare$116,
		                          min$26,
		                          max$28,
		                          ascending$17,
		                          descending$17,
		                          between$18,
		                          clamp_exn$17,
		                          clamp$17,
		                          comparator$35,
		                          pp$87],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       add = include[14],
		       element = include[16],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                ,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                ,
		                add,
		                ,
		                element,
		                ,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$157 = caml_callback(Make$31, [Ident]),
		                delta_schema_versioned$17 = include$157[5],
		                Id$13 = caml_callback(b8, [[0, schema_versioned$259]]),
		                letrec_function_context$678 = [];
		               function schema_versioned$398(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$678[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$678[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$678[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$678[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$249,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$678[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$678[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$648 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$678, [0, schematic_cache$648]);
		               var
		                schema$154 =
		                  caml_callback
		                   (schema_versioned$398,
		                    [function(param, cont){return cont(0);}]),
		                History =
		                  caml_callback(A, [[0, schema_versioned$398, schema$154]]);
		               function schema_versioned$399(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$260,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$155 =
		                  caml_callback
		                   (schema_versioned$399,
		                    [function(param, cont){return cont(0);}]),
		                In_progress =
		                  caml_callback(A, [[0, schema_versioned$399, schema$155]]),
		                j = caml_callback(M$1, [[0, schema_versioned$110, schema$28]]),
		                Agent_id = caml_callback(A, [[0, j[54], j[55]]]),
		                letrec_function_context$679 = [];
		               function schema_versioned$400(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$679[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQO, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$679[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$679[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$679[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Latest[5],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([8, f0]);},
		   function(param, cont){
		    if(8 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQP,
		   cst_touched_last,
		   "Touched_last",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_touched_last, 0, 2, [0, b], 0, 0],
		      0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$6,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([7, f0]);},
		             function(param, cont){
		              if(7 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQQ,
		             cst_title,
		             cst_Title,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Response_id_opt_LWW[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([6, f0]);},
		                       function(param, cont){
		                        if(6 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aQR,
		                       cst_last_response_id,
		                       "Last_response_id",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_last_response_id, 0, 2, [0, c], 0, 0],
		                          0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (String_opt_LWW[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([5, f0]);},
		                                 function(param, cont){
		                                  if(5 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aQS,
		                                 cst_last_prompt_hash,
		                                 "Last_prompt_hash",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_last_prompt_hash, 0, 2, [0, c], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aQU,
		                                     aQT,
		                                     2,
		                                     1,
		                                     2,
		                                     function(c){
		                                      var a = [0, [0, c, V$4]];
		                                      return caml_trampoline_cps_call2
		      (In_progress[4],
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQV,
		             cst_in_progress,
		             cst_In_progress,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_in_progress, 0, 2, [0, d], 0, 0], 0]],
		              0],
		             a],
		            b];
		        return caml_exact_trampoline_cps_call
		                (Id$13[4],
		                 schematic_version,
		                 function(b){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aQW,
		                       cst_id,
		                       cst_Id,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		                        0],
		                       0],
		                      c];
		                  return caml_trampoline_cps_call2
		                          (History[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aQX,
		                                 cst_history,
		                                 "History",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_history, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aQZ,
		                                     aQY,
		                                     1,
		                                     0,
		                                     2,
		                                     function(c){
		                                      var a = [0, [0, c, V$4]];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$10,
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQ0,
		             cst_context,
		             cst_Context,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_context, 0, 2, [0, d], 0, 0], 0]],
		              0],
		             a],
		            b];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aQ2,
		                 aQ1,
		                 2,
		                 2,
		                 1,
		                 function(b){
		                  var a = [0, [0, b, V$4]];
		                  return caml_trampoline_cps_call2
		                          (Agent_id[4],
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aQ3,
		                                  cst_agent_id,
		                                  "Agent_id",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, b], 0, 0], 0]],
		                                   0],
		                                  a],
		                                 c],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$679[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$679[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$649 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$679, [0, schematic_cache$649]);
		               caml_callback
		                (schema_versioned$400,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$158 = Monadic$0(),
		                v$13 = include$158[1],
		                const$3 = include$158[2],
		                all_unit$9 = include$158[12],
		                Apply$7 = include$158[14],
		                letrec_function_context$680 = [];
		               function state_schema_versioned$14(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$680[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQ4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$680[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$680[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$680[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Latest[3],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_touched_last, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$5,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Response_id_opt_LWW[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_last_response_id, 0, 2, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (String_opt_LWW[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_last_prompt_hash, 0, 2, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (In_progress[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_in_progress, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (Id$13[2],
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (History[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_history, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$9,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_context, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Agent_id[2],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    touched_last = g[2][1],
		    title = g[1],
		    last_response_id = f[1],
		    last_prompt_hash = e[1],
		    in_progress = d[1],
		    id = c[1],
		    history = b[1],
		    context = a[1],
		    agent_id = param[1];
		   return cont
		           ([0,
		             agent_id,
		             context,
		             history,
		             id,
		             in_progress,
		             last_prompt_hash,
		             last_response_id,
		             title,
		             touched_last]);
		  },
		  function(param, cont){
		   var
		    touched_last = param[9],
		    title = param[8],
		    last_response_id = param[7],
		    last_prompt_hash = param[6],
		    in_progress = param[5],
		    id = param[4],
		    history = param[3],
		    context = param[2],
		    agent_id = param[1];
		   return cont
		           ([0,
		             agent_id,
		             [0,
		              context,
		              [0,
		               history,
		               [0,
		                id,
		                [0,
		                 in_progress,
		                 [0,
		                  last_prompt_hash,
		                  [0, last_response_id, [0, title, [0, touched_last, 0]]]]]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$680[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$680[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$650 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$680, [0, schematic_cache$650]);
		               var
		                state_schema$4 =
		                  caml_callback
		                   (state_schema_versioned$14,
		                    [function(param, cont){return cont(0);}]);
		               function make$78(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (Latest[11],
		                         init[9],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (make$68,
		                                   init[8],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Response_id_opt_LWW[10],
		     init[7],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (String_opt_LWW[10],
		               init[6],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (In_progress[10],
		                         init[5],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Id$13[10],
		                                   init[4],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (History[10],
		     init[3],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (make$73,
		               init[2],
		               function(h){
		                return caml_exact_trampoline_cps_call
		                        (Agent_id[10],
		                         init[1],
		                         function(i){return cont([0, i, h, g, f, e, d, c, b, a]);});
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$17(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (Latest[12],
		                         t[9],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (view$7,
		                                   t[8],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Response_id_opt_LWW[11],
		     t[7],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (String_opt_LWW[11],
		               t[6],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (In_progress[11],
		                         t[5],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Id$13[11],
		                                   t[4],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (History[11],
		     t[3],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (view$12,
		               t[2],
		               function(h){
		                return caml_exact_trampoline_cps_call
		                        (Agent_id[11],
		                         t[1],
		                         function(i){return cont([0, i, h, g, f, e, d, c, b, a]);});
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$27(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Agent_id[8],
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   new_substate,
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$18,
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   new_substate,
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (History[8],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   new_substate,
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$13[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   new_substate,
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 4:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (In_progress[8],
		                            replica,
		                            state[5],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   new_substate,
		   state[6],
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 5:
		                   var op$4 = op[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[8],
		                            replica,
		                            state[6],
		                            op$4,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   new_substate,
		   state[7],
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 6:
		                   var op$5 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Response_id_opt_LWW[8],
		                            replica,
		                            state[7],
		                            op$5,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   new_substate,
		   state[8],
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 7:
		                   var op$6 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$12,
		                            replica,
		                            state[8],
		                            op$6,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([7, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   new_substate,
		   state[9]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$7 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Latest[9],
		                            replica,
		                            state[9],
		                            op$7,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([8, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$23(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Agent_id[9],
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       new_substate,
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$14,
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       new_substate,
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (History[9],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       new_substate,
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$13[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       new_substate,
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 4:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (In_progress[9],
		                            replica,
		                            state[5],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       new_substate,
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 5:
		                   var delta$4 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[9],
		                            replica,
		                            state[6],
		                            delta$4,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       new_substate,
		                                       state[7],
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 6:
		                   var delta$5 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Response_id_opt_LWW[9],
		                            replica,
		                            state[7],
		                            delta$5,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       new_substate,
		                                       state[8],
		                                       state[9]]);
		                            });
		                  case 7:
		                   var delta$6 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$8,
		                            replica,
		                            state[8],
		                            delta$6,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       new_substate,
		                                       state[9]]);
		                            });
		                  default:
		                   var delta$7 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Latest[10],
		                            replica,
		                            state[9],
		                            delta$7,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       new_substate]);
		                            });
		                }
		               }
		               var
		                include$159 =
		                  caml_callback
		                   (Apply$7,
		                    [[0, [0, schema_versioned$400], apply_delta$23, apply$27]]),
		                delta_schema_versioned$18 = include$159[1],
		                delta_schema$4 = include$159[2],
		                apply_delta$24 = include$159[3],
		                apply$28 = include$159[4];
		               function set_context(previous, new_ctx, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (diff$5,
		                         previous,
		                         new_ctx,
		                         function(op){
		                          return caml_exact_trampoline_cps_call(v$13, [1, op], cont);
		                         });
		               }
		               function set_in_progress(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (In_progress[12],
		                         v,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$13, [4, a], cont);
		                         });
		               }
		               function Make$32(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$3],
		                      state_schema_versioned$14,
		                      state_schema$4,
		                      delta_schema_versioned$18,
		                      delta_schema$4,
		                      [0, schema_versioned$261, schema$104],
		                      include$0,
		                      apply$28,
		                      apply_delta$24,
		                      make$78,
		                      view$17,
		                      equal$166]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$166,
		                    [0, const$3],
		                    state_schema_versioned$14,
		                    state_schema$4,
		                    delta_schema_versioned$18,
		                    delta_schema$4,
		                    [0, schema_versioned$261, schema$104],
		                    include$0,
		                    apply$28,
		                    apply_delta$24,
		                    make$78,
		                    view$17];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$259,
		                          schema$103,
		                          symbol$169,
		                          symbol$170,
		                          symbol$171,
		                          symbol$172,
		                          symbol$173,
		                          symbol$174,
		                          equal$164,
		                          compare$114,
		                          min$24,
		                          max$26,
		                          ascending$15,
		                          descending$15,
		                          between$16,
		                          clamp_exn$15,
		                          clamp$15,
		                          comparator$33,
		                          pp$85],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       add = include[14],
		       element = include[16],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                ,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                ,
		                add,
		                ,
		                element,
		                ,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$160 = caml_callback(Make$32, [Ident]),
		                delta_schema_versioned$19 = include$160[5],
		                Action =
		                  caml_callback(A, [[0, schema_versioned$264, schema$109]]),
		                Id$14 = caml_callback(b8, [[0, schema_versioned$263]]),
		                letrec_function_context$681 = [];
		               function schema_versioned$401(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$681[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQ5, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$681[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$681[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$681[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (String_opt_LWW[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQ6,
		   cst_name,
		   cst_Name,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (Id$14[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aQ7,
		             cst_id,
		             cst_Id,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Action[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aQ8,
		                        cst_action,
		                        "Action",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_action, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$681[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$681[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$651 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$681, [0, schematic_cache$651]);
		               caml_callback
		                (schema_versioned$401,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$161 = Monadic$0(),
		                v$14 = include$161[1],
		                const$4 = include$161[2],
		                all_unit$10 = include$161[12],
		                Apply$8 = include$161[14],
		                letrec_function_context$682 = [];
		               function state_schema_versioned$15(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$682[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQ9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$682[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$682[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$682[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (String_opt_LWW[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Id$14[2],
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Action[2],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        name = a[2][1],
		                        id = a[1],
		                        action = param[1];
		                       return cont([0, action, id, name]);
		                      },
		                      function(param, cont){
		                       var name = param[3], id = param[2], action = param[1];
		                       return cont([0, action, [0, id, [0, name, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_action, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$682[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$682[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$652 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$682, [0, schematic_cache$652]);
		               var
		                state_schema$5 =
		                  caml_callback
		                   (state_schema_versioned$15,
		                    [function(param, cont){return cont(0);}]);
		               function make$79(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (String_opt_LWW[10],
		                         init[3],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Id$14[10],
		                                   init[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Action[10],
		     init[1],
		     function(c){return cont([0, c, b, a]);});
		                                   });
		                         });
		               }
		               function view$18(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (String_opt_LWW[11],
		                         t[3],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Id$14[11],
		                                   t[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Action[11], t[1], function(c){return cont([0, c, b, a]);});
		                                   });
		                         });
		               }
		               function apply$29(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Action[8],
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var new_state = [0, new_substate, state[2], state[3]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$14[8],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var new_state = [0, state[1], new_substate, state[3]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[8],
		                            replica,
		                            state[3],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var new_state = [0, state[1], state[2], new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$25(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Action[9],
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont([0, new_substate, state[2], state[3]]);
		                            });
		                  case 1:
		                   return caml_exact_trampoline_cps_call$0
		                           (Id$14[9],
		                            replica,
		                            dummy,
		                            dummy,
		                            function(new_substate){
		                             return cont([0, state[1], new_substate, state[3]]);
		                            });
		                  default:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[9],
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(new_substate){
		                             return cont([0, state[1], state[2], new_substate]);
		                            });
		                }
		               }
		               var
		                include$162 =
		                  caml_callback
		                   (Apply$8,
		                    [[0, [0, schema_versioned$401], apply_delta$25, apply$29]]),
		                delta_schema_versioned$20 = include$162[1],
		                delta_schema$5 = include$162[2],
		                apply_delta$26 = include$162[3],
		                apply$30 = include$162[4];
		               function Make$33(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$4],
		                      state_schema_versioned$15,
		                      state_schema$5,
		                      delta_schema_versioned$20,
		                      delta_schema$5,
		                      [0, schema_versioned$265, schema$110],
		                      include$0,
		                      apply$30,
		                      apply_delta$26,
		                      make$79,
		                      view$18,
		                      equal$170]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$170,
		                    [0, const$4],
		                    state_schema_versioned$15,
		                    state_schema$5,
		                    delta_schema_versioned$20,
		                    delta_schema$5,
		                    [0, schema_versioned$265, schema$110],
		                    include$0,
		                    apply$30,
		                    apply_delta$26,
		                    make$79,
		                    view$18];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$263,
		                          schema$108,
		                          symbol$175,
		                          symbol$176,
		                          symbol$177,
		                          symbol$178,
		                          symbol$179,
		                          symbol$180,
		                          equal$168,
		                          compare$115,
		                          min$25,
		                          max$27,
		                          ascending$16,
		                          descending$16,
		                          between$17,
		                          clamp_exn$16,
		                          clamp$16,
		                          comparator$34,
		                          pp$86],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       add = include[14],
		       element = include[16],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                ,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                ,
		                add,
		                ,
		                element,
		                ,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$163 = caml_callback(Make$33, [Ident]),
		                delta_schema_versioned$21 = include$163[5],
		                Assistant$0 =
		                  caml_callback
		                   (Make$28,
		                    [[0,
		                      ,
		                      state_schema_versioned$11,
		                      ,
		                      delta_schema_versioned$12,
		                      ,
		                      [0, schema_versioned$262],
		                      include$0,
		                      apply$22,
		                      apply_delta$18,
		                      make$75,
		                      view$14]]),
		                letrec_function_context$683 = [];
		               function schema_versioned$402(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$683[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aQ_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$683[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$683[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$683[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$19,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aQ$,
		   cst_conversations,
		   cst_Conversations,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_conversations, 0, 2, [0, b], 0, 0],
		      0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$17,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aRa,
		             cst_automations,
		             cst_Automations,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_automations, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$21,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aRb,
		                       cst_steps,
		                       cst_Steps,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_steps, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aRd,
		                           aRc,
		                           1,
		                           0,
		                           5,
		                           function(c){
		                            var b = [0, [0, c, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$16,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aRe,
		   cst_automation_runs,
		   "Automation_runs",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_automation_runs, 0, 2, [0, d], 0, 0],
		      0]],
		    0],
		   b],
		  a];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aRg,
		       aRf,
		       1,
		       0,
		       2,
		       function(b){
		        var a = [0, [0, b, V$4]];
		        return caml_trampoline_cps_call2
		                (Assistant$0[8],
		                 schematic_version,
		                 function(d){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aRh,
		                       cst_assistant,
		                       cst_Assistant,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_assistant, 0, 2, [0, d], 0, 0], 0]],
		                        0],
		                       a],
		                      c];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$13,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aRi,
		                                  cst_agents,
		                                  "Agents",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0, [0, 0, 0, 0, 0, cst_agents, 0, 2, [0, a], 0, 0], 0]],
		                                   0],
		                                  0],
		                                 b],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$683[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$683[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$653 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$683, [0, schematic_cache$653]);
		               caml_callback
		                (schema_versioned$402,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$164 = Monadic$0(),
		                v$15 = include$164[1],
		                Apply$9 = include$164[14],
		                Delta = [0, schema_versioned$402];
		               function Make$34(Context, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make$29,
		                         Context,
		                         function(Agents){
		                          var
		                           value = Assistant$0[20],
		                           Operation = Assistant$0[1],
		                           Monad = Assistant$0[2],
		                           state_schema_versioned = Assistant$0[3],
		                           state_schema = Assistant$0[4],
		                           delta_schema_versioned = Assistant$0[8],
		                           delta_schema = Assistant$0[9],
		                           apply_delta = Assistant$0[10],
		                           apply = Assistant$0[11],
		                           Init = Assistant$0[12],
		                           make = Assistant$0[13],
		                           view = Assistant$0[14];
		                          function equal(a, b, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_option, equal$167, a, b, cont);
		                          }
		                          var
		                           include =
		                             Context[3].call
		                              (null,
		                               [0,
		                                [0, , , , , , , , , , , , Operation[3]],
		                                state_schema_versioned,
		                                state_schema,
		                                delta_schema_versioned,
		                                delta_schema,
		                                Init,
		                                Monad,
		                                apply,
		                                apply_delta,
		                                make,
		                                view,
		                                equal]),
		                           state_schema_versioned$0 = include[2],
		                           apply$0 = include[8],
		                           apply_delta$0 = include[9],
		                           make$0 = include[10],
		                           view$0 = include[11],
		                           Assistant = [0, , , , , , , , , value];
		                          return caml_exact_trampoline_cps_call
		                                  (Make$30,
		                                   Context,
		                                   function(Automation_runs){
		                                    return caml_exact_trampoline_cps_call
		    (Make$33,
		     Context,
		     function(Steps){
		      return caml_exact_trampoline_cps_call
		              (Make$31,
		               Context,
		               function(Automations){
		                return caml_exact_trampoline_cps_call
		                        (Make$32,
		                         Context,
		                         function(Conversations){
		                          var Monad = Context[1], letrec_function_context = [];
		                          function state_schema_versioned(schematic_version, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (schematic_version,
		                                    V$4,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       function a(descriptor){
		        return cont([0, aRj, 0, descriptor, 0]);
		       }
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return caml_trampoline_cps_call2
		       (Conversations[3],
		        schematic_version,
		        function(b){
		         var
		          a =
		            [0,
		             [0, 0, 0, 0, 0, cst_conversations, 0, 2, [0, b], 0, 0],
		             0];
		         return caml_trampoline_cps_call2
		                 (Automations[3],
		                  schematic_version,
		                  function(c){
		                   var
		                    b =
		                      [0, [0, 0, 0, 0, 0, cst_automations, 0, 2, [0, c], 0, 0], a];
		                   return caml_trampoline_cps_call2
		                           (Steps[3],
		                            schematic_version,
		                            function(c){
		                             var
		                              a = [0, [0, 0, 0, 0, 0, cst_steps, 0, 2, [0, c], 0, 0], b];
		                             return caml_trampoline_cps_call2
		                                     (Automation_runs[3],
		                                      schematic_version,
		                                      function(c){
		                                       var
		b =
		  [0,
		   [0, 0, 0, 0, 0, cst_automation_runs, 0, 2, [0, c], 0, 0],
		   a];
		                                       return caml_exact_trampoline_cps_call
		       (state_schema_versioned$0,
		        schematic_version,
		        function(c){
		         var
		          a =
		            [0, [0, 0, 0, 0, 0, cst_assistant, 0, 2, [0, c], 0, 0], b];
		         return caml_trampoline_cps_call2
		                 (Agents[3],
		                  schematic_version,
		                  function(b){
		                   var
		                    res =
		                      [7,
		                       function(param, cont){
		                        var
		                         a = param[2],
		                         b = a[2],
		                         c = b[2],
		                         d = c[2],
		                         conversations = d[2][1],
		                         automations = d[1],
		                         steps = c[1],
		                         automation_runs = b[1],
		                         assistant = a[1],
		                         agents = param[1];
		                        return cont
		                                ([0,
		                                  agents,
		                                  assistant,
		                                  automation_runs,
		                                  steps,
		                                  automations,
		                                  conversations]);
		                       },
		                       function(param, cont){
		                        var
		                         conversations = param[6],
		                         automations = param[5],
		                         steps = param[4],
		                         automation_runs = param[3],
		                         assistant = param[2],
		                         agents = param[1];
		                        return cont
		                                ([0,
		                                  agents,
		                                  [0,
		                                   assistant,
		                                   [0,
		                                    automation_runs,
		                                    [0, steps, [0, automations, [0, conversations, 0]]]]]]);
		                       },
		                       [0, [0, 0, 0, 0, 0, cst_agents, 0, 2, [0, b], 0, 0], a]];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 a);
		       var schema = match[1];
		       return a(schema);
		      });
		                                    });
		                          }
		                          var schematic_cache = [0, empty$11([0, comparator$9])];
		                          caml_update_dummy
		                           (letrec_function_context, [0, schematic_cache]);
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    function apply(replica, state, op, cont){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$5,
		   symbol_map$5,
		   ,
		   bind$8,
		   return$9,
		   map$17,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$3]),
		                                      let$ = open[4];
		                                     switch(op[0]){
		                                       case 0:
		var op$0 = op[1];
		return caml_trampoline_cps_call4
		        (Agents[9],
		         replica,
		         state[1],
		         op$0,
		         function(match){
		          var
		           new_substate = match[3],
		           delta = match[2],
		           res = match[1];
		          return caml_trampoline_cps_call3
		                  (let$,
		                   delta,
		                   function(delta, cont){return cont([0, delta]);},
		                   function(delta){
		                    var
		                     new_state =
		                       [0,
		                        new_substate,
		                        state[2],
		                        state[3],
		                        state[4],
		                        state[5],
		                        state[6]];
		                    return cont([0, res, delta, new_state]);
		                   });
		         });
		                                       case 1:
		var op$1 = op[1];
		return caml_trampoline_cps_call4
		        (apply$0,
		         replica,
		         state[2],
		         op$1,
		         function(match){
		          var
		           new_substate = match[3],
		           delta = match[2],
		           res = match[1];
		          return caml_trampoline_cps_call3
		                  (let$,
		                   delta,
		                   function(delta, cont){return cont([1, delta]);},
		                   function(delta){
		                    var
		                     new_state =
		                       [0,
		                        state[1],
		                        new_substate,
		                        state[3],
		                        state[4],
		                        state[5],
		                        state[6]];
		                    return cont([0, res, delta, new_state]);
		                   });
		         });
		                                       case 2:
		var op$2 = op[1];
		return caml_trampoline_cps_call4
		        (Automation_runs[9],
		         replica,
		         state[3],
		         op$2,
		         function(match){
		          var
		           new_substate = match[3],
		           delta = match[2],
		           res = match[1];
		          return caml_trampoline_cps_call3
		                  (let$,
		                   delta,
		                   function(delta, cont){return cont([2, delta]);},
		                   function(delta){
		                    var
		                     new_state =
		                       [0,
		                        state[1],
		                        state[2],
		                        new_substate,
		                        state[4],
		                        state[5],
		                        state[6]];
		                    return cont([0, res, delta, new_state]);
		                   });
		         });
		                                       case 3:
		var op$3 = op[1];
		return caml_trampoline_cps_call4
		        (Steps[9],
		         replica,
		         state[4],
		         op$3,
		         function(match){
		          var
		           new_substate = match[3],
		           delta = match[2],
		           res = match[1];
		          return caml_trampoline_cps_call3
		                  (let$,
		                   delta,
		                   function(delta, cont){return cont([3, delta]);},
		                   function(delta){
		                    var
		                     new_state =
		                       [0,
		                        state[1],
		                        state[2],
		                        state[3],
		                        new_substate,
		                        state[5],
		                        state[6]];
		                    return cont([0, res, delta, new_state]);
		                   });
		         });
		                                       case 4:
		var op$4 = op[1];
		return caml_trampoline_cps_call4
		        (Automations[9],
		         replica,
		         state[5],
		         op$4,
		         function(match){
		          var
		           new_substate = match[3],
		           delta = match[2],
		           res = match[1];
		          return caml_trampoline_cps_call3
		                  (let$,
		                   delta,
		                   function(delta, cont){return cont([4, delta]);},
		                   function(delta){
		                    var
		                     new_state =
		                       [0,
		                        state[1],
		                        state[2],
		                        state[3],
		                        state[4],
		                        new_substate,
		                        state[6]];
		                    return cont([0, res, delta, new_state]);
		                   });
		         });
		                                       default:
		var op$5 = op[1];
		return caml_trampoline_cps_call4
		        (Conversations[9],
		         replica,
		         state[6],
		         op$5,
		         function(match){
		          var
		           new_substate = match[3],
		           delta = match[2],
		           res = match[1];
		          return caml_trampoline_cps_call3
		                  (let$,
		                   delta,
		                   function(delta, cont){return cont([5, delta]);},
		                   function(delta){
		                    var
		                     new_state =
		                       [0,
		                        state[1],
		                        state[2],
		                        state[3],
		                        state[4],
		                        state[5],
		                        new_substate];
		                    return cont([0, res, delta, new_state]);
		                   });
		         });
		                                     }
		                                    }
		                                    function apply_delta(replica, state, delta, cont){
		                                     switch(delta[0]){
		                                       case 0:
		var delta$0 = delta[1];
		return caml_trampoline_cps_call4
		        (Agents[10],
		         replica,
		         state[1],
		         delta$0,
		         function(new_substate){
		          return cont
		                  ([0,
		                    new_substate,
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6]]);
		         });
		                                       case 1:
		var delta$1 = delta[1];
		return caml_trampoline_cps_call4
		        (apply_delta$0,
		         replica,
		         state[2],
		         delta$1,
		         function(new_substate){
		          return cont
		                  ([0,
		                    state[1],
		                    new_substate,
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6]]);
		         });
		                                       case 2:
		var delta$2 = delta[1];
		return caml_trampoline_cps_call4
		        (Automation_runs[10],
		         replica,
		         state[3],
		         delta$2,
		         function(new_substate){
		          return cont
		                  ([0,
		                    state[1],
		                    state[2],
		                    new_substate,
		                    state[4],
		                    state[5],
		                    state[6]]);
		         });
		                                       case 3:
		var delta$3 = delta[1];
		return caml_trampoline_cps_call4
		        (Steps[10],
		         replica,
		         state[4],
		         delta$3,
		         function(new_substate){
		          return cont
		                  ([0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    new_substate,
		                    state[5],
		                    state[6]]);
		         });
		                                       case 4:
		var delta$4 = delta[1];
		return caml_trampoline_cps_call4
		        (Automations[10],
		         replica,
		         state[5],
		         delta$4,
		         function(new_substate){
		          return cont
		                  ([0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    new_substate,
		                    state[6]]);
		         });
		                                       default:
		var delta$5 = delta[1];
		return caml_trampoline_cps_call4
		        (Conversations[10],
		         replica,
		         state[6],
		         delta$5,
		         function(new_substate){
		          return cont
		                  ([0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    new_substate]);
		         });
		                                     }
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (Apply$9,
		     [0, Delta, apply_delta, apply],
		     function(include){
		      var apply_delta = include[3], apply = include[4];
		      function schema_versioned(schematic_version, cont){
		       return caml_exact_trampoline_cps_call
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$283,
		                          schematic_version,
		                          function(a){return cont();});
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (schema_versioned,
		               function(param, cont){return cont(0);},
		               function(schema){
		                function make(init, cont){
		                 return caml_trampoline_cps_call2
		                         (Conversations[11],
		                          init[6],
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (Automations[11],
		                                    init[4],
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (Steps[11],
		      init[5],
		      function(c){
		       return caml_trampoline_cps_call2
		               (Automation_runs[11],
		                init[3],
		                function(d){
		                 return caml_exact_trampoline_cps_call
		                         (make$0,
		                          init[2],
		                          function(e){
		                           return caml_trampoline_cps_call2
		                                   (Agents[11],
		                                    init[1],
		                                    function(f){return cont([0, f, e, d, c, b, a]);});
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                function view(state, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       Monad[1],
		                       Monad[2],
		                       ,
		                       Monad[4],
		                       Monad[5],
		                       Monad[6],
		                       ,
		                       ,
		                       ,
		                       ,
		                       Monad[11]]),
		                  and = open[6],
		                  let$ = open[4];
		                 function a(a, cont){
		                  var
		                   conversations = a[2],
		                   a = a[1],
		                   automations = a[2],
		                   a = a[1],
		                   steps = a[2],
		                   a = a[1],
		                   automation_runs = a[2],
		                   a = a[1],
		                   assistant = a[2],
		                   agents = a[1];
		                  return cont
		                          ([0,
		                            agents,
		                            assistant,
		                            automation_runs,
		                            automations,
		                            steps,
		                            conversations]);
		                 }
		                 return caml_trampoline_cps_call2
		                         (Agents[12],
		                          state[1],
		                          function(left){
		                           return caml_exact_trampoline_cps_call
		                                   (view$0,
		                                    state[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Automation_runs[12],
		                state[3],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Steps[12],
		                                    state[4],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Automations[12],
		                state[5],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Conversations[12],
		                                    state[6],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 init =
		                   [0,
		                    Agent[27][104],
		                    0,
		                    Automation_run[27][104],
		                    By$15[104],
		                    By$14[104],
		                    By$13[104]];
		                return cont
		                        ([0,
		                          Agents,
		                          Assistant,
		                          Automation_runs,
		                          Steps,
		                          Automations,
		                          Conversations,
		                          ,
		                          ,
		                          state_schema_versioned,
		                          ,
		                          ,
		                          ,
		                          apply_delta,
		                          apply,
		                          ,
		                          make,
		                          view,
		                          ,
		                          init]);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                Ident$0 = caml_callback(Make$34, [Ident]),
		                letrec_function_context$684 = [];
		               function delta_schema_versioned$22(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$684[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$684[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$684[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$684[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$402,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$684[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$684[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$654 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$684, [0, schematic_cache$654]);
		               caml_callback
		                (delta_schema_versioned$22,
		                 [function(param, cont){return cont(0);}]);
		               function agents(op, cont){
		                return caml_exact_trampoline_cps_call(v$15, [0, op], cont);
		               }
		               function assistant(op, cont){
		                return caml_exact_trampoline_cps_call(v$15, [1, op], cont);
		               }
		               function automation_runs(op, cont){
		                return caml_exact_trampoline_cps_call(v$15, [2, op], cont);
		               }
		               function agent_any(id, op, cont){
		                if(0 !== id[0])
		                 return caml_exact_trampoline_cps_call
		                         (Ident$0[2][9],
		                          op,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(assistant, a, cont);
		                          });
		                var id$0 = id[1];
		                return caml_trampoline_cps_call3
		                        (Ident$0[1][16],
		                         id$0,
		                         op,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(agents, a, cont);
		                         });
		               }
		               function steps(op, cont){
		                return caml_exact_trampoline_cps_call(v$15, [3, op], cont);
		               }
		               function automations(op, cont){
		                return caml_exact_trampoline_cps_call(v$15, [4, op], cont);
		               }
		               function conversations$0(op, cont){
		                return caml_exact_trampoline_cps_call(v$15, [5, op], cont);
		               }
		               function schema_versioned$403(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$172,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$156 =
		                  caml_callback
		                   (schema_versioned$403,
		                    [function(param, cont){return cont(0);}]),
		                include$165 =
		                  caml_callback(A, [[0, schema_versioned$403, schema$156]]),
		                state_schema_versioned$16 = include$165[2],
		                delta_schema_versioned$23 = include$165[4],
		                apply$31 = include$165[8],
		                apply_delta$27 = include$165[9],
		                make$80 = include$165[10],
		                view$19 = include$165[11],
		                set$12 = include$165[12],
		                Color =
		                  caml_callback(A, [[0, schema_versioned$205, schema$77]]),
		                Connection =
		                  caml_callback(A, [[0, schema_versioned$116, schema$37]]),
		                Role =
		                  caml_callback(A, [[0, schema_versioned$204, schema$76]]),
		                cst_Color = "Color",
		                cst_Role = "Role",
		                cst_Writable = "Writable",
		                letrec_function_context$685 = [];
		               function schema_versioned$404(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$685[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aRk, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$685[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$685[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$685[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (include$139[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(6 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aRl,
		   cst_writable,
		   cst_Writable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (String_LWW[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(5 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aRm,
		             cst_summary,
		             "Summary",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_summary, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Role[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(4 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aRn,
		                       cst_role,
		                       cst_Role,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_role, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$23,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aRo,
		                                 cst_extension_row,
		                                 cst_Extension_row,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, c], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (include$139[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aRp,
		   cst_disabled,
		   cst_Disabled,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_disabled, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Connection[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aRq,
		             cst_connection,
		             "Connection",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_connection, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Color[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aRr,
		                        cst_color,
		                        cst_Color,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$685[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$685[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$655 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$685, [0, schematic_cache$655]);
		               caml_callback
		                (schema_versioned$404,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$686 = [];
		               function schema_versioned$405(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$686[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$686[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$686[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$686[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$139[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (String_LWW[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_summary, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Role[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_role, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$16,
		                           schematic_version,
		                           function(c){
		                            var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$16,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (include$139[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_disabled, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Connection[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_connection, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Color[2],
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  writable = f[2][1],
		                                  summary = f[1],
		                                  role = e[1],
		                                  id = d[1],
		                                  extension_row = c[1],
		                                  disabled = b[1],
		                                  connection = a[1],
		                                  color = param[1];
		                                 return cont
		 ([0,
		   color,
		   connection,
		   disabled,
		   extension_row,
		   id,
		   role,
		   summary,
		   writable]);
		                                },
		                                function(param, cont){
		                                 var
		                                  writable = param[8],
		                                  summary = param[7],
		                                  role = param[6],
		                                  id = param[5],
		                                  extension_row = param[4],
		                                  disabled = param[3],
		                                  connection = param[2],
		                                  color = param[1];
		                                 return cont
		 ([0,
		   color,
		   [0,
		    connection,
		    [0,
		     disabled,
		     [0,
		      extension_row,
		      [0, id, [0, role, [0, summary, [0, writable, 0]]]]]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$686[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$686[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$656 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$686, [0, schematic_cache$656]);
		               caml_callback
		                (schema_versioned$405,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$166 = Monadic$0(),
		                v$16 = include$166[1],
		                const$5 = include$166[2],
		                all_unit$11 = include$166[12],
		                Apply$10 = include$166[14],
		                letrec_function_context$687 = [];
		               function equal$229(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$687[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$687, [0, equal$123]);
		               function state_schema_versioned$17(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$405,
		                                   schematic_version,
		                                   function(a){return cont([0, aRs, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                state_schema$6 =
		                  caml_callback
		                   (state_schema_versioned$17,
		                    [function(param, cont){return cont(0);}]);
		               function apply$32(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var op = param[1];
		                   return caml_trampoline_cps_call4
		                           (Color[8],
		                            replica,
		                            state[1],
		                            op,
		                            function(match){
		                             var color = match[3], delta_o = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta_o,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta_o){
		                                       return cont
		       ([0,
		         res,
		         delta_o,
		         [0,
		          color,
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8]]]);
		                                      });
		                            });
		                  case 1:
		                   var op$0 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Connection[8],
		                            replica,
		                            state[2],
		                            op$0,
		                            function(match){
		                             var
		                              connection = match[3],
		                              delta_o = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta_o,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta_o){
		                                       return cont
		       ([0,
		         res,
		         delta_o,
		         [0,
		          state[1],
		          connection,
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8]]]);
		                                      });
		                            });
		                  case 2:
		                   var op$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[8],
		                            replica,
		                            state[3],
		                            op$1,
		                            function(match){
		                             var disabled = match[3], delta_o = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta_o,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta_o){
		                                       return cont
		       ([0,
		         res,
		         delta_o,
		         [0,
		          state[1],
		          state[2],
		          disabled,
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8]]]);
		                                      });
		                            });
		                  case 3:
		                   var op$2 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$31,
		                            replica,
		                            state[4],
		                            op$2,
		                            function(match){
		                             var
		                              extension_row = match[3],
		                              delta_o = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta_o,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta_o){
		                                       return cont
		       ([0,
		         res,
		         delta_o,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          extension_row,
		          state[5],
		          state[6],
		          state[7],
		          state[8]]]);
		                                      });
		                            });
		                  case 4:
		                   var op$3 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Role[8],
		                            replica,
		                            state[6],
		                            op$3,
		                            function(match){
		                             var role = match[3], delta_o = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta_o,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta_o){
		                                       return cont
		       ([0,
		         res,
		         delta_o,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          role,
		          state[7],
		          state[8]]]);
		                                      });
		                            });
		                  case 5:
		                   var op$4 = param[1];
		                   return caml_trampoline_cps_call4
		                           (String_LWW[8],
		                            replica,
		                            state[7],
		                            op$4,
		                            function(match){
		                             var summary = match[3], delta_o = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta_o,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta_o){
		                                       return cont
		       ([0,
		         res,
		         delta_o,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          summary,
		          state[8]]]);
		                                      });
		                            });
		                  default:
		                   var op$5 = param[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[8],
		                            replica,
		                            state[8],
		                            op$5,
		                            function(match){
		                             var writable = match[3], delta_o = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta_o,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta_o){
		                                       return cont
		       ([0,
		         res,
		         delta_o,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          writable]]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$28(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[8],
		                    b = state[7],
		                    c = state[6],
		                    d = state[5],
		                    e = state[4],
		                    f = state[3],
		                    g = state[2];
		                   return caml_trampoline_cps_call4
		                           (Color[9],
		                            replica,
		                            state[1],
		                            delta,
		                            function(h){return cont([0, h, g, f, e, d, c, b, a]);});
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    h = state[8],
		                    i = state[7],
		                    j = state[6],
		                    k = state[5],
		                    l = state[4],
		                    m = state[3];
		                   return caml_trampoline_cps_call4
		                           (Connection[9],
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){
		                             return cont([0, state[1], a, m, l, k, j, i, h]);
		                            });
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    n = state[8],
		                    o = state[7],
		                    p = state[6],
		                    q = state[5],
		                    r = state[4];
		                   return caml_trampoline_cps_call4
		                           (include$139[9],
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){
		                             return cont([0, state[1], state[2], a, r, q, p, o, n]);
		                            });
		                  case 3:
		                   var
		                    delta$2 = param[1],
		                    s = state[8],
		                    t = state[7],
		                    u = state[6],
		                    v = state[5];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$27,
		                            replica,
		                            state[4],
		                            delta$2,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], a, v, u, t, s]);
		                            });
		                  case 4:
		                   var delta$3 = param[1], w = state[8], x = state[7];
		                   return caml_trampoline_cps_call4
		                           (Role[9],
		                            replica,
		                            state[6],
		                            delta$3,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       a,
		                                       x,
		                                       w]);
		                            });
		                  case 5:
		                   var delta$4 = param[1], y = state[8];
		                   return caml_trampoline_cps_call4
		                           (String_LWW[9],
		                            replica,
		                            state[7],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       a,
		                                       y]);
		                            });
		                  default:
		                   var delta$5 = param[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[9],
		                            replica,
		                            state[8],
		                            delta$5,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       a]);
		                            });
		                }
		               }
		               var
		                include$167 =
		                  caml_callback
		                   (Apply$10,
		                    [[0, [0, schema_versioned$404], apply_delta$28, apply$32]]),
		                delta_schema_versioned$24 = include$167[1],
		                delta_schema$6 = include$167[2],
		                apply_delta$29 = include$167[3],
		                apply$33 = include$167[4];
		               function make$81(param, cont){
		                var
		                 writable = param[8],
		                 summary = param[7],
		                 role = param[6],
		                 id = param[5],
		                 extension_row = param[4],
		                 disabled = param[3],
		                 connection = param[2],
		                 color = param[1];
		                return caml_exact_trampoline_cps_call
		                        (include$139[10],
		                         writable,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (String_LWW[10],
		                                   summary,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Role[10],
		     role,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (make$80,
		               extension_row,
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (include$139[10],
		                         disabled,
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Connection[10],
		                                   connection,
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Color[10],
		     color,
		     function(g){return cont([0, g, f, e, d, id, c, b, a]);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$20(param, cont){
		                var
		                 writable = param[8],
		                 summary = param[7],
		                 role = param[6],
		                 id = param[5],
		                 extension_row = param[4],
		                 disabled = param[3],
		                 connection = param[2],
		                 color = param[1];
		                return caml_exact_trampoline_cps_call
		                        (include$139[11],
		                         writable,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (String_LWW[11],
		                                   summary,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Role[11],
		     role,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (view$19,
		               extension_row,
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (include$139[11],
		                         disabled,
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Connection[11],
		                                   connection,
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Color[11],
		     color,
		     function(g){
		      return caml_trampoline_cps_call2
		              (include$0[5], [0, g, f, e, d, id, c, b, a], cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function set_role(r, cont){
		                return caml_exact_trampoline_cps_call
		                        (Role[12],
		                         r,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$16, [4, a], cont);
		                         });
		               }
		               function update$1
		               (color,
		                connection,
		                disabled,
		                extension_row,
		                role,
		                summary,
		                writable,
		                param,
		                cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                return caml_trampoline_cps_call3
		                        (let$,
		                         color,
		                         function(color, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Color[12],
		                                   color,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$16, [0, a], cont);
		                                   });
		                         },
		                         function(color){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   connection,
		                                   function(connection, cont){
		                                    return caml_exact_trampoline_cps_call
		    (Connection[12],
		     connection,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$16, [1, a], cont);
		     });
		                                   },
		                                   function(connection){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     disabled,
		     function(disabled, cont){
		      return caml_exact_trampoline_cps_call
		              (include$139[12],
		               disabled,
		               function(a){
		                return caml_exact_trampoline_cps_call(v$16, [2, a], cont);
		               });
		     },
		     function(disabled){
		      return caml_trampoline_cps_call3
		              (let$,
		               extension_row,
		               function(extension_row, cont){
		                return caml_exact_trampoline_cps_call
		                        (set$12,
		                         extension_row,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$16, [3, a], cont);
		                         });
		               },
		               function(extension_row){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         role,
		                         function(role, cont){
		                          return caml_exact_trampoline_cps_call(set_role, role, cont);
		                         },
		                         function(role){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   summary,
		                                   function(summary, cont){
		                                    return caml_exact_trampoline_cps_call
		    (String_LWW[12],
		     summary,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$16, [5, a], cont);
		     });
		                                   },
		                                   function(summary){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     writable,
		     function(writable, cont){
		      return caml_exact_trampoline_cps_call
		              (include$139[12],
		               writable,
		               function(a){
		                return caml_exact_trampoline_cps_call(v$16, [6, a], cont);
		               });
		     },
		     function(writable){
		      return caml_exact_trampoline_cps_call
		              (filter_opt,
		               [0,
		                color,
		                [0,
		                 connection,
		                 [0,
		                  disabled,
		                  [0,
		                   extension_row,
		                   [0, role, [0, summary, [0, writable, 0]]]]]]],
		               function(a){
		                return caml_exact_trampoline_cps_call(all_unit$11, a, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function Make$35(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$5],
		                      state_schema_versioned$17,
		                      state_schema$6,
		                      delta_schema_versioned$24,
		                      delta_schema$6,
		                      [0, schema_versioned$206, schema$78],
		                      include$0,
		                      apply$33,
		                      apply_delta$29,
		                      make$81,
		                      view$20,
		                      equal$229]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$229,
		                    [0, const$5],
		                    state_schema_versioned$17,
		                    state_schema$6,
		                    delta_schema_versioned$24,
		                    delta_schema$6,
		                    [0, schema_versioned$206, schema$78],
		                    include$0,
		                    apply$33,
		                    apply_delta$29,
		                    make$81,
		                    view$20];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$16,
		                          schema$11,
		                          symbol$16,
		                          symbol$12,
		                          symbol$14,
		                          symbol$15,
		                          symbol$11,
		                          symbol$13,
		                          equal$4,
		                          compare$4,
		                          min$6,
		                          max$6,
		                          ascending$2,
		                          descending$2,
		                          between$2,
		                          clamp_exn$1,
		                          clamp$1,
		                          comparator$2,
		                          pp$2],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(Crdt_calendars){
		      var
		       Operation = Crdt_calendars[2],
		       state_schema_versioned = Crdt_calendars[3],
		       delta_schema_versioned = Crdt_calendars[5],
		       Monad = Crdt_calendars[8],
		       apply = Crdt_calendars[9],
		       apply_delta = Crdt_calendars[10],
		       make = Crdt_calendars[11],
		       init = Crdt_calendars[13],
		       element = Crdt_calendars[16];
		      function view(state, cont){
		       return caml_trampoline_cps_call2
		               (Crdt_calendars[12],
		                state,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (Monad[6], a, with_valid_default, cont);
		                });
		      }
		      return cont
		              ([0,
		                ,
		                ,
		                Operation,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                init,
		                ,
		                ,
		                element,
		                ,
		                ,
		                ,
		                ,
		                ,
		                view]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$168 = caml_callback(Make$35, [Ident]),
		                Operation$2 = include$168[3],
		                delta_schema_versioned$25 = include$168[6],
		                element$0 = include$168[16],
		                Dictionary =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$2, comparator$2, string_schema_versioned]]);
		               function schema_versioned$406(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0, 0, 0, no_input_schema[3], no_input_schema[4]]);
		                         });
		               }
		               var
		                schema$277 = [0, 0, 0, no_input_schema[3], no_input_schema[4]],
		                include$169 =
		                  caml_callback(A, [[0, schema_versioned$406, schema$277]]),
		                Operation$3 = include$169[1],
		                state_schema_versioned$18 = include$169[2],
		                state_schema$7 = include$169[3],
		                delta_schema_versioned$26 = include$169[4],
		                delta_schema$7 = include$169[5],
		                Init$2 = include$169[6],
		                Monad$4 = include$169[7],
		                apply$34 = include$169[8],
		                apply_delta$30 = include$169[9],
		                make$82 = include$169[10],
		                view$21 = include$169[11],
		                set$13 = include$169[12];
		               function view_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_trampoline_cps_call3
		                                  (Dictionary[109],
		                                   schematic_version,
		                                   no_input_schema,
		                                   function(a){return cont([0, aRt, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                view_schema =
		                  caml_callback
		                   (view_schema_versioned,
		                    [function(param, cont){return cont(0);}]);
		               function Make$36(b, cont){
		                var
		                 c =
		                   [0,
		                    equal$15,
		                    [0, Operation$3[12]],
		                    state_schema_versioned$18,
		                    state_schema$7,
		                    delta_schema_versioned$26,
		                    delta_schema$7,
		                    Init$2,
		                    Monad$4,
		                    apply$34,
		                    apply_delta$30,
		                    make$82,
		                    view$21],
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      Operation$3,
		                      state_schema_versioned$18,
		                      state_schema$7,
		                      delta_schema_versioned$26,
		                      delta_schema$7,
		                      Init$2,
		                      Monad$4,
		                      apply$34,
		                      apply_delta$30,
		                      make$82,
		                      view$21,
		                      equal$15]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          string_schema_versioned,
		                          schematic_param_name_schema_ve,
		                          symbol$16,
		                          symbol$12,
		                          symbol$14,
		                          symbol$15,
		                          symbol$11,
		                          symbol$13,
		                          equal$4,
		                          compare$4,
		                          min$6,
		                          max$6,
		                          ascending$2,
		                          descending$2,
		                          between$2,
		                          clamp_exn$1,
		                          clamp$1,
		                          comparator$2,
		                          pp$2],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$170 = caml_callback(Make$36, [Ident]),
		                Operation$4 = include$170[2],
		                delta_schema_versioned$27 = include$170[5],
		                add$17 = include$170[14],
		                element$1 = include$170[16],
		                has$0 = include$170[17],
		                remove$7 = include$170[18];
		               function set$14(key, value, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      Operation$4[4],
		                      Operation$4[5],
		                      ,
		                      Operation$4[7],
		                      Operation$4[8],
		                      Operation$4[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$4[12]]),
		                 let$ = open[3];
		                function a(exists, cont){
		                 return exists
		                         ? caml_exact_trampoline_cps_call
		                           (set$13,
		                            value,
		                            function(a){
		                             return caml_trampoline_cps_call3(element$1, key, a, cont);
		                            })
		                         : caml_trampoline_cps_call3(add$17, key, value, cont);
		                }
		                return caml_trampoline_cps_call2
		                        (has$0,
		                         key,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var Email = caml_callback(b8, [[0, schema_versioned$285]]);
		               function schema_versioned$407(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$189,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$157 =
		                  caml_callback
		                   (schema_versioned$407,
		                    [function(param, cont){return cont(0);}]);
		               function resolve$2(left, right, cont){
		                if(! left) return right ? cont(0) : cont(1);
		                var left$0 = left[1];
		                if(! right) return cont(1);
		                var right$0 = right[1];
		                a:
		                {
		                 switch(left$0){
		                   case 0:
		                    if(! right$0){var a = 0; break a;} break;
		                   case 1:
		                    if(1 === right$0){a = 0; break a;} break;
		                   default: if(2 <= right$0){a = 0; break a;}
		                 }
		                 var
		                  to_int =
		                    function(param){
		                     switch(param){
		                       case 0:
		                        return 0;
		                       case 1:
		                        return 1;
		                       default: return 2;
		                     }
		                    },
		                  a = to_int(right$0),
		                  a = caml_int_compare(to_int(left$0), a);
		                }
		                return 0 <= a ? cont(0) : cont(1);
		               }
		               var
		                Synchronization_state =
		                  caml_callback
		                   (Make_var,
		                    [[0, schema_versioned$407, schema$157, resolve$2]]);
		               function schema_versioned$408(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$286,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$158 =
		                  caml_callback
		                   (schema_versioned$408,
		                    [function(param, cont){return cont(0);}]),
		                Error$1 =
		                  caml_callback(A, [[0, schema_versioned$408, schema$158]]),
		                Token_info =
		                  caml_callback(A, [[0, schema_versioned$50, schema$13]]),
		                Userinfo =
		                  caml_callback(A, [[0, schema_versioned$53, schema$15]]),
		                letrec_function_context$688 = [];
		               function schema_versioned$409(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$688[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aRu, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$688[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$688[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$688[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Userinfo[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(4 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aRv,
		   cst_userinfo,
		   "Userinfo",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_userinfo, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Token_info[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aRw,
		             cst_tokeninfo,
		             "Tokeninfo",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_tokeninfo, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Error$1[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aRx,
		                       cst_error,
		                       cst_Error,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_error, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aRz,
		                           aRy,
		                           0,
		                           25,
		                           7,
		                           function(c){
		                            var b = [0, [0, c, V$5]];
		                            return caml_trampoline_cps_call2
		                                    (Synchronization_state[5],
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aRA,
		   cst_contacts_state$0,
		   "Contacts_state",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_contacts_state$0, 0, 2, [0, d], 0, 0],
		      0]],
		    0],
		   b],
		  a];
		                                      return caml_trampoline_cps_call2
		      (Synchronization_state[5],
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aRB,
		              cst_calendars_state$0,
		              "Calendars_state",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0,
		                 [0, 0, 0, 0, 0, cst_calendars_state$0, 0, 2, [0, a], 0, 0],
		                 0]],
		               0],
		              0],
		             c],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$688[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$688[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$657 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$688, [0, schematic_cache$657]);
		               caml_callback
		                (schema_versioned$409,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$171 = Monadic$0(),
		                v$17 = include$171[1],
		                Apply$11 = include$171[14],
		                letrec_function_context$689 = [];
		               function state_schema_versioned$19(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$689[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aRC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$689[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$689[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$689[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Userinfo[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_userinfo, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Token_info[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_tokeninfo, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Error$1[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_error, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Synchronization_state[3],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_contacts_state$0, 0, 2, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Synchronization_state[3],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    userinfo = c[2][1],
		    tokeninfo = c[1],
		    error = b[1],
		    contacts_state = a[1],
		    calendars_state = param[1];
		   return cont
		           ([0,
		             calendars_state,
		             contacts_state,
		             error,
		             tokeninfo,
		             userinfo]);
		  },
		  function(param, cont){
		   var
		    userinfo = param[5],
		    tokeninfo = param[4],
		    error = param[3],
		    contacts_state = param[2],
		    calendars_state = param[1];
		   return cont
		           ([0,
		             calendars_state,
		             [0,
		              contacts_state,
		              [0, error, [0, tokeninfo, [0, userinfo, 0]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_calendars_state$0, 0, 2, [0, a], 0, 0],
		   b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$689[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$689[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$658 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$689, [0, schematic_cache$658]);
		               caml_callback
		                (state_schema_versioned$19,
		                 [function(param, cont){return cont(0);}]);
		               function apply$35(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Synchronization_state[9],
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, new_substate, state[2], state[3], state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Synchronization_state[9],
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], new_substate, state[3], state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Error$1[8],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], new_substate, state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Token_info[8],
		                            replica,
		                            state[4],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], state[3], new_substate, state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$4 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Userinfo[8],
		                            replica,
		                            state[5],
		                            op$4,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], state[3], state[4], new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$31(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Synchronization_state[10],
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0, new_substate, state[2], state[3], state[4], state[5]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Synchronization_state[10],
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], new_substate, state[3], state[4], state[5]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Error$1[9],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], new_substate, state[4], state[5]]);
		                            });
		                  case 3:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Token_info[9],
		                            replica,
		                            state[4],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], state[3], new_substate, state[5]]);
		                            });
		                  default:
		                   var delta$4 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Userinfo[9],
		                            replica,
		                            state[5],
		                            delta$4,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], new_substate]);
		                            });
		                }
		               }
		               var
		                include$172 =
		                  caml_callback
		                   (Apply$11,
		                    [[0, [0, schema_versioned$409], apply_delta$31, apply$35]]),
		                apply_delta$32 = include$172[3],
		                apply$36 = include$172[4],
		                letrec_function_context$690 = [];
		               function delta_schema_versioned$28(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$690[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$690[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$690[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$690[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$409,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$690[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$690[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$659 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$690, [0, schematic_cache$659]);
		               caml_callback
		                (delta_schema_versioned$28,
		                 [function(param, cont){return cont(0);}]);
		               function calendars_state(value, cont){
		                return caml_exact_trampoline_cps_call
		                        (Synchronization_state[13],
		                         value,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$17, [0, a], cont);
		                         });
		               }
		               var letrec_function_context$691 = [];
		               function schema_versioned$410(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$691[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aRD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$691[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$691[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$691[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aRF,
		                                     aRE,
		                                     0,
		                                     25,
		                                     4,
		                                     function(b){
		                                      var a = [0, [0, b, V$5]];
		                                      return caml_exact_trampoline_cps_call
		      (delta_schema_versioned$28,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aRG,
		              cst_google,
		              cst_Google,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_google, 0, 2, [0, b], a, 0], 0]],
		               0],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$691[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$691[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$660 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$691, [0, schematic_cache$660]);
		               caml_callback
		                (schema_versioned$410,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$692 = [];
		               function schema_versioned$411(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$692[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$692[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$692[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$692[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$19,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aRH,
		   cst_google,
		   cst_Google,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var state = param[1];
		      return cont(state);
		     },
		     function(state, cont){return cont([0, state, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_google, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (Email[2],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aRI,
		              cst_email,
		              cst_Email,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var state = param[1];
		                 return cont(state);
		                },
		                function(state, cont){return cont([0, state, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_email, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$692[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$692[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$661 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$692, [0, schematic_cache$661]);
		               caml_callback
		                (schema_versioned$411,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$693 = [];
		               function equal$230(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$693[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$693, [0, equal$189]);
		               function state_schema_versioned$20(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$411,
		                                   schematic_version,
		                                   function(a){return cont([0, aRJ, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                state_schema$8 =
		                  caml_callback
		                   (state_schema_versioned$20,
		                    [function(param, cont){return cont(0);}]),
		                include$173 = Monadic$0(),
		                v$18 = include$173[1],
		                const$6 = include$173[2],
		                ignore_m$4 = include$173[10],
		                Apply$12 = include$173[14];
		               function apply$37(replica, state, operation, cont){
		                var operation$0 = operation[1];
		                if(0 === state[0]){
		                 var
		                  a =
		                    function(m, cont){
		                     return caml_trampoline_cps_call4(m, 0, 0, aRK, cont);
		                    };
		                 return caml_exact_trampoline_cps_call
		                         (err$0,
		                          0,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b, a, function(match){return cont([0, 0, 0, state]);});
		                          });
		                }
		                var state$0 = state[1];
		                return caml_trampoline_cps_call4
		                        (apply$36,
		                         replica,
		                         state$0,
		                         operation$0,
		                         function(match){
		                          var
		                           state = match[3],
		                           deltas = match[2],
		                           result = match[1],
		                           a = [1, state];
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   deltas,
		                                   function(delta, cont){return cont([0, delta]);},
		                                   function(b){return cont([0, [0, result], b, a]);});
		                         });
		               }
		               function apply_delta$33(replica, state, delta, cont){
		                var delta$0 = delta[1];
		                if(0 === state[0]){
		                 var
		                  a =
		                    function(m, cont){
		                     return caml_trampoline_cps_call4(m, 0, 0, aRL, cont);
		                    };
		                 return caml_exact_trampoline_cps_call
		                         (err$0,
		                          0,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b, a, function(match){return cont(state);});
		                          });
		                }
		                var state$0 = state[1];
		                return caml_trampoline_cps_call4
		                        (apply_delta$32,
		                         replica,
		                         state$0,
		                         delta$0,
		                         function(a){return cont([1, a]);});
		               }
		               var
		                include$174 =
		                  caml_callback
		                   (Apply$12,
		                    [[0, [0, schema_versioned$410], apply_delta$33, apply$37]]),
		                delta_schema_versioned$29 = include$174[1],
		                delta_schema$8 = include$174[2],
		                apply_delta$34 = include$174[3],
		                apply$38 = include$174[4];
		               function make$83(param, cont){
		                if(0 === param[0]){
		                 var connection = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (Email[10], connection, function(a){return cont([0, a]);});
		                }
		                var connection$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (Userinfo[10],
		                         connection$0[5],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Token_info[10],
		                                   connection$0[4],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Error$1[10],
		     connection$0[3],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Synchronization_state[11],
		               connection$0[2],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Synchronization_state[11],
		                         connection$0[1],
		                         function(e){return cont([1, [0, e, d, c, b, a]]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function view$22(param, cont){
		                if(0 === param[0]){
		                 var state = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (Email[11],
		                          state,
		                          function(a){
		                           return caml_trampoline_cps_call2(include$0[5], [0, a], cont);
		                          });
		                }
		                var state$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (Userinfo[11],
		                         state$0[5],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Token_info[11],
		                                   state$0[4],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Error$1[11],
		     state$0[3],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Synchronization_state[12],
		               state$0[2],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Synchronization_state[12],
		                         state$0[1],
		                         function(e){
		                          return caml_trampoline_cps_call2
		                                  (include$0[5], [1, [0, e, d, c, b, a]], cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function google(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$18,
		                         [0, operation],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(ignore_m$4, a, cont);
		                         });
		               }
		               var bR0 = [0, schema_versioned$288, schema$117];
		               function Make$37(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$6],
		                      state_schema_versioned$20,
		                      state_schema$8,
		                      delta_schema_versioned$29,
		                      delta_schema$8,
		                      [0, schema_versioned$288, schema$117],
		                      include$0,
		                      apply$38,
		                      apply_delta$34,
		                      make$83,
		                      view$22,
		                      equal$230]),
		                 d =
		                   [0,
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    [0, const$6],
		                    state_schema_versioned$20,
		                    state_schema$8,
		                    delta_schema_versioned$29,
		                    delta_schema$8,
		                    bR0,
		                    include$0,
		                    apply$38,
		                    apply_delta$34,
		                    make$83,
		                    view$22];
		                return caml_trampoline_cps_call2
		                        (b[4],
		                         [0,
		                          schema_versioned$289,
		                          schema$118,
		                          symbol$187,
		                          symbol$188,
		                          symbol$189,
		                          symbol$190,
		                          symbol$191,
		                          symbol$192,
		                          equal$190,
		                          compare$120,
		                          min$27,
		                          max$29,
		                          ascending$18,
		                          descending$18,
		                          between$19,
		                          clamp_exn$18,
		                          clamp$18,
		                          comparator$37,
		                          pp$91],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$175 = caml_callback(Make$37, [Ident]),
		                delta_schema_versioned$30 = include$175[5],
		                element$2 = include$175[16];
		               function schema_versioned$412(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (attendance_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aRM, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$159 =
		                  caml_callback
		                   (schema_versioned$412,
		                    [function(param, cont){return cont(0);}]),
		                include$176 =
		                  caml_callback(A, [[0, schema_versioned$412, schema$159]]),
		                state_schema_versioned$21 = include$176[2],
		                delta_schema_versioned$31 = include$176[4],
		                apply$39 = include$176[8],
		                apply_delta$35 = include$176[9],
		                make$84 = include$176[10],
		                view$23 = include$176[11],
		                set$15 = include$176[12];
		               function schema_versioned$413(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (yes_no_maybe_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aRN, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$160 =
		                  caml_callback
		                   (schema_versioned$413,
		                    [function(param, cont){return cont(0);}]),
		                include$177 =
		                  caml_callback(A, [[0, schema_versioned$413, schema$160]]),
		                state_schema_versioned$22 = include$177[2],
		                delta_schema_versioned$32 = include$177[4],
		                apply$40 = include$177[8],
		                apply_delta$36 = include$177[9],
		                make$85 = include$177[10],
		                view$24 = include$177[11],
		                include$178 = Monadic$0(),
		                Apply$13 = include$178[14],
		                letrec_function_context$694 = [];
		               function compare$163(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$694[1], x, cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$694, [0, compare_attendee]);
		               function schematic_version$92(param, cont){return cont(0);}
		               var
		                schema$161 =
		                  [0,
		                   aRO,
		                   ,
		                   caml_callback
		                     (attendee_schema_versioned$0, [schematic_version$92])
		                    [3]],
		                sexp_of_t$131 = caml_callback(encode$7, [schema$161]),
		                include$179 = Make$2([0, compare$163, sexp_of_t$131]),
		                equal$231 = include$179[7],
		                letrec_function_context$695 = [];
		               function state_schema_versioned$23(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$695[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aRP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$695[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$695[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$695[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$22,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_organizer, 0, 2, [0, bool_schema], 0, 0],
		  [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$5,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              status = b[2][1],
		              organizer = b[1],
		              name = a[1],
		              email = param[1];
		             return cont([0, email, name, organizer, status]);
		            },
		            function(param, cont){
		             var
		              status = param[4],
		              organizer = param[3],
		              name = param[2],
		              email = param[1];
		             return cont
		                     ([0, email, [0, name, [0, organizer, [0, status, 0]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_email,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], a]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$695[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$695[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$662 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$695, [0, schematic_cache$662]);
		               caml_callback
		                (state_schema_versioned$23,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$696 = [];
		               function schema_versioned$414(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$696[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aRQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$696[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$696[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$696[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$32,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_status,
		   cst_Status,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_delta, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$6,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            aRR,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              cst_name,
		              cst_Name,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_delta, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$696[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$696[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$663 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$696, [0, schematic_cache$663]);
		               caml_callback
		                (schema_versioned$414,
		                 [function(param, cont){return cont(0);}]);
		               function apply$41(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          if(0 === param[0]){
		                           var op = param[1];
		                           return caml_trampoline_cps_call4
		                                   (apply$12,
		                                    replica,
		                                    state[2],
		                                    op,
		                                    function(match){
		                                     var name = match[3], delta = match[2], res = match[1];
		                                     return caml_trampoline_cps_call3
		     (a,
		      delta,
		      function(delta, cont){return cont([0, delta]);},
		      function(delta){
		       return cont
		               ([0, res, delta, [0, state[1], name, state[3], state[4]]]);
		      });
		                                    });
		                          }
		                          var op$0 = param[1];
		                          return caml_trampoline_cps_call4
		                                  (apply$40,
		                                   replica,
		                                   state[4],
		                                   op$0,
		                                   function(match){
		                                    var status = match[3], delta = match[2], res = match[1];
		                                    return caml_trampoline_cps_call3
		    (a,
		     delta,
		     function(delta, cont){return cont([1, delta]);},
		     function(delta){
		      return cont
		              ([0, res, delta, [0, state[1], state[2], state[3], status]]);
		     });
		                                   });
		                         });
		               }
		               function apply_delta$37(replica, init, cont){
		                g
		                 ([0,
		                   symbol_bind$5,
		                   symbol_map$5,
		                   ,
		                   bind$8,
		                   return$9,
		                   map$17,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$3]);
		                return cont
		                        (function(param, cont){
		                          if(0 === param[0]){
		                           var delta = param[1], a = init[4], b = init[3];
		                           return caml_trampoline_cps_call4
		                                   (apply_delta$8,
		                                    replica,
		                                    init[2],
		                                    delta,
		                                    function(c){return cont([0, init[1], c, b, a]);});
		                          }
		                          var delta$0 = param[1];
		                          return caml_trampoline_cps_call4
		                                  (apply_delta$36,
		                                   replica,
		                                   init[4],
		                                   delta$0,
		                                   function(a){return cont([0, init[1], init[2], init[3], a]);});
		                         });
		               }
		               var
		                include$180 =
		                  caml_callback
		                   (Apply$13,
		                    [[0, [0, schema_versioned$414], apply_delta$37, apply$41]]),
		                delta_schema_versioned$33 = include$180[1],
		                apply_delta$38 = include$180[3],
		                apply$42 = include$180[4];
		               function schema_versioned$415(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (attendee_schema_versioned$0,
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$415,
		                 [function(param, cont){return cont(0);}]);
		               function make$86(param, cont){
		                var
		                 status = param[4],
		                 organizer = param[3],
		                 name = param[2],
		                 email = param[1];
		                return caml_exact_trampoline_cps_call
		                        (make$85,
		                         status,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (make$68,
		                                   name,
		                                   function(b){return cont([0, email, b, organizer, a]);});
		                         });
		               }
		               function view$25(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (view$24,
		                         state[4],
		                         function(b){
		                          var a = state[3];
		                          return caml_exact_trampoline_cps_call
		                                  (view$7,
		                                   state[2],
		                                   function(c){return cont([0, state[1], c, a, b]);});
		                         });
		               }
		               function schema_versioned$416(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                include$320 =
		                  caml_callback
		                   (bOC,
		                    [[0,
		                      schema_versioned$416,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$2,
		                      pp$2],
		                     [0,
		                      equal$231,
		                      ,
		                      state_schema_versioned$23,
		                      ,
		                      delta_schema_versioned$33,
		                      ,
		                      [0, schema_versioned$415],
		                      include$0,
		                      apply$42,
		                      apply_delta$38,
		                      make$86,
		                      view$25]]),
		                Operation$5 = include$320[2],
		                state_schema_versioned$24 = include$320[3],
		                delta_schema_versioned$34 = include$320[5],
		                apply$43 = include$320[9],
		                apply_delta$39 = include$320[10],
		                make$87 = include$320[11],
		                view$26 = include$320[12],
		                add$18 = include$320[14],
		                remove$8 = include$320[18],
		                diff$7 = include$320[21];
		               function schema_versioned$417(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (availability_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aRS, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$162 =
		                  caml_callback
		                   (schema_versioned$417,
		                    [function(param, cont){return cont(0);}]),
		                include$181 =
		                  caml_callback(A, [[0, schema_versioned$417, schema$162]]),
		                state_schema_versioned$25 = include$181[2],
		                delta_schema_versioned$35 = include$181[4],
		                apply$44 = include$181[8],
		                apply_delta$40 = include$181[9],
		                make$88 = include$181[10],
		                view$27 = include$181[11],
		                set$16 = include$181[12];
		               function schema_versioned$418(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$16,
		                                   schematic_version,
		                                   function(a){return cont([0, aRT, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$163 =
		                  caml_callback
		                   (schema_versioned$418,
		                    [function(param, cont){return cont(0);}]),
		                include$182 =
		                  caml_callback(A, [[0, schema_versioned$418, schema$163]]),
		                state_schema_versioned$26 = include$182[2],
		                delta_schema_versioned$36 = include$182[4],
		                apply$45 = include$182[8],
		                apply_delta$41 = include$182[9],
		                make$89 = include$182[10],
		                view$28 = include$182[11],
		                set$17 = include$182[12];
		               function schema_versioned$419(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$233,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aRU, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$164 =
		                  caml_callback
		                   (schema_versioned$419,
		                    [function(param, cont){return cont(0);}]),
		                Daytime =
		                  caml_callback(A, [[0, schema_versioned$419, schema$164]]),
		                open$11 =
		                  g
		                   ([0,
		                     symbol_bind$5,
		                     symbol_map$5,
		                     ,
		                     bind$8,
		                     return$9,
		                     map$17,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$3]),
		                let$17 = open$11[3],
		                let$18 = open$11[4],
		                letrec_function_context$697 = [];
		               function compare$164(x, y, cont){
		                if(! x) return y ? cont(-1) : cont(0);
		                var a = x[1];
		                if(! y) return cont(1);
		                var b = y[1];
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$697[1], a, b, cont);
		               }
		               caml_update_dummy(letrec_function_context$697, [0, compare$39]);
		               function sexp_of_t$132(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (sexp_of_option, to_sexp, t, cont);
		               }
		               var
		                include$183 = Make$2([0, compare$164, sexp_of_t$132]),
		                equal$232 = include$183[7];
		               function schema_versioned$420(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$1,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aRV, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$165 =
		                  caml_callback
		                   (schema_versioned$420,
		                    [function(param, cont){return cont(0);}]),
		                include$184 =
		                  caml_callback(A, [[0, schema_versioned$420, schema$165]]),
		                state_schema_versioned$27 = include$184[2],
		                delta_schema_versioned$37 = include$184[4],
		                Init$3 = include$184[6],
		                Monad$5 = include$184[7],
		                apply$46 = include$184[8],
		                apply_delta$42 = include$184[9],
		                make$90 = include$184[10],
		                view$29 = include$184[11],
		                set$18 = include$184[12],
		                Exceptions$0 =
		                  caml_callback
		                   (bOC,
		                    [[0,
		                      schema_versioned$1,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$11,
		                      pp_v1$0],
		                     [0,
		                      equal$232,
		                      ,
		                      state_schema_versioned$27,
		                      ,
		                      delta_schema_versioned$37,
		                      ,
		                      Init$3,
		                      Monad$5,
		                      apply$46,
		                      apply_delta$42,
		                      make$90,
		                      view$29]]),
		                Recurrence =
		                  caml_callback(A, [[0, schema_versioned$222, schema$87]]),
		                include$185 = Monadic$0(),
		                v$19 = include$185[1],
		                ignore_m$5 = include$185[10],
		                all_unit$12 = include$185[12],
		                Apply$14 = include$185[14],
		                cst_Attendees = "Attendees",
		                cst_Availability_override = "Availability_override",
		                cst_Description = "Description",
		                cst_Location = "Location",
		                cst_Notes = "Notes",
		                letrec_function_context$698 = [];
		               function schema_versioned$421(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$698[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aRW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$698[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$698[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$698[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([9, f0]);},
		   function(param, cont){
		    if(9 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aRX,
		   cst_title,
		   cst_Title,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Recurrence[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([8, f0]);},
		             function(param, cont){
		              if(8 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aRY,
		             cst_recurrence,
		             cst_Recurrence,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$3,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([7, f0]);},
		                       function(param, cont){
		                        if(7 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aRZ,
		                       cst_notes,
		                       cst_Notes,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$6,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([6, f0]);},
		                                 function(param, cont){
		                                  if(6 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aR0,
		                                 cst_location,
		                                 cst_Location,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_location, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Exceptions$0[5],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aR1,
		   cst_exceptions,
		   "Exceptions",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_exceptions, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$6,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aR2,
		             cst_description,
		             cst_Description,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Daytime[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aR3,
		                       cst_daytime,
		                       cst_Daytime,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_daytime, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$35,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aR4,
		                                 cst_availability_override,
		                                 cst_Availability_override,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_availability_override,
		                                     0,
		                                     2,
		                                     [0, c],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$34,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aR5,
		   cst_attendees,
		   cst_Attendees,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_attendees, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$31,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aR6,
		              cst_attendance,
		              cst_Attendance,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_attendance, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$698[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$698[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$664 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$698, [0, schematic_cache$664]);
		               caml_callback
		                (schema_versioned$421,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$699 = [];
		               function state_schema_versioned$28(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$699[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aR7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$699[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$699[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$699[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$3,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Recurrence[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (state_schema_versioned$2,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$5,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_location, 0, 2, [0, c], 0, 0], a];
		                            return caml_trampoline_cps_call2
		                                    (Exceptions$0[3],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_exceptions, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$5,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Daytime[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_daytime, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$25,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_availability_override,
		                                 0,
		                                 2,
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (state_schema_versioned$24,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_attendees, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$21,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              title = h[2][1],
		              recurrence = h[1],
		              notes = g[1],
		              location = f[1],
		              exceptions = e[1],
		              description = d[1],
		              daytime = c[1],
		              availability_override = b[1],
		              attendees = a[1],
		              attendance = param[1];
		             return cont
		                     ([0,
		                       attendance,
		                       attendees,
		                       availability_override,
		                       daytime,
		                       description,
		                       exceptions,
		                       location,
		                       notes,
		                       recurrence,
		                       title]);
		            },
		            function(param, cont){
		             var
		              title = param[10],
		              recurrence = param[9],
		              notes = param[8],
		              location = param[7],
		              exceptions = param[6],
		              description = param[5],
		              daytime = param[4],
		              availability_override = param[3],
		              attendees = param[2],
		              attendance = param[1];
		             return cont
		                     ([0,
		                       attendance,
		                       [0,
		                        attendees,
		                        [0,
		                         availability_override,
		                         [0,
		                          daytime,
		                          [0,
		                           description,
		                           [0,
		                            exceptions,
		                            [0, location, [0, notes, [0, recurrence, [0, title, 0]]]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_attendance, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$699[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$699[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$665 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$699, [0, schematic_cache$665]);
		               caml_callback
		                (state_schema_versioned$28,
		                 [function(param, cont){return cont(0);}]);
		               function apply$47(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var op = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$39,
		                            replica,
		                            state[1],
		                            op,
		                            function(match){
		                             var attendance = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          attendance,
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 1:
		                   var op$0 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$43,
		                            replica,
		                            state[2],
		                            op$0,
		                            function(match){
		                             var attendees = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          attendees,
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 2:
		                   var op$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$44,
		                            replica,
		                            state[3],
		                            op$1,
		                            function(match){
		                             var
		                              availability_override = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          availability_override,
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 3:
		                   var op$2 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Daytime[8],
		                            replica,
		                            state[4],
		                            op$2,
		                            function(match){
		                             var daytime = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          daytime,
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 4:
		                   var op$3 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$12,
		                            replica,
		                            state[5],
		                            op$3,
		                            function(match){
		                             var
		                              description = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          description,
		          state[6],
		          state[7],
		          state[8],
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 5:
		                   var op$4 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Exceptions$0[9],
		                            replica,
		                            state[6],
		                            op$4,
		                            function(match){
		                             var exceptions = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          exceptions,
		          state[7],
		          state[8],
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 6:
		                   var op$5 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$12,
		                            replica,
		                            state[7],
		                            op$5,
		                            function(match){
		                             var location = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          location,
		          state[8],
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 7:
		                   var op$6 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$9,
		                            replica,
		                            state[8],
		                            op$6,
		                            function(match){
		                             var notes = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([7, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          notes,
		          state[9],
		          state[10]]]);
		                                      });
		                            });
		                  case 8:
		                   var op$7 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Recurrence[8],
		                            replica,
		                            state[9],
		                            op$7,
		                            function(match){
		                             var recurrence = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([8, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          recurrence,
		          state[10]]]);
		                                      });
		                            });
		                  default:
		                   var op$8 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$10,
		                            replica,
		                            state[10],
		                            op$8,
		                            function(match){
		                             var title = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([9, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9],
		          title]]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$43(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[10],
		                    b = state[9],
		                    c = state[8],
		                    d = state[7],
		                    e = state[6],
		                    f = state[5],
		                    g = state[4],
		                    h = state[3],
		                    i = state[2];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$35,
		                            replica,
		                            state[1],
		                            delta,
		                            function(j){return cont([0, j, i, h, g, f, e, d, c, b, a]);});
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    j = state[10],
		                    k = state[9],
		                    l = state[8],
		                    m = state[7],
		                    n = state[6],
		                    o = state[5],
		                    p = state[4],
		                    q = state[3];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$39,
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){
		                             return cont([0, state[1], a, q, p, o, n, m, l, k, j]);
		                            });
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    r = state[10],
		                    s = state[9],
		                    t = state[8],
		                    u = state[7],
		                    v = state[6],
		                    w = state[5],
		                    x = state[4];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$40,
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){
		                             return cont([0, state[1], state[2], a, x, w, v, u, t, s, r]);
		                            });
		                  case 3:
		                   var
		                    delta$2 = param[1],
		                    y = state[10],
		                    z = state[9],
		                    A = state[8],
		                    B = state[7],
		                    C = state[6],
		                    D = state[5];
		                   return caml_trampoline_cps_call4
		                           (Daytime[9],
		                            replica,
		                            state[4],
		                            delta$2,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], a, D, C, B, A, z, y]);
		                            });
		                  case 4:
		                   var
		                    delta$3 = param[1],
		                    E = state[10],
		                    F = state[9],
		                    G = state[8],
		                    H = state[7],
		                    I = state[6];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$8,
		                            replica,
		                            state[5],
		                            delta$3,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       a,
		                                       I,
		                                       H,
		                                       G,
		                                       F,
		                                       E]);
		                            });
		                  case 5:
		                   var
		                    delta$4 = param[1],
		                    J = state[10],
		                    K = state[9],
		                    L = state[8],
		                    M = state[7];
		                   return caml_trampoline_cps_call4
		                           (Exceptions$0[10],
		                            replica,
		                            state[6],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       a,
		                                       M,
		                                       L,
		                                       K,
		                                       J]);
		                            });
		                  case 6:
		                   var
		                    delta$5 = param[1],
		                    N = state[10],
		                    O = state[9],
		                    P = state[8];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$8,
		                            replica,
		                            state[7],
		                            delta$5,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       a,
		                                       P,
		                                       O,
		                                       N]);
		                            });
		                  case 7:
		                   var delta$6 = param[1], Q = state[10], R = state[9];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$5,
		                            replica,
		                            state[8],
		                            delta$6,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       a,
		                                       R,
		                                       Q]);
		                            });
		                  case 8:
		                   var delta$7 = param[1], S = state[10];
		                   return caml_trampoline_cps_call4
		                           (Recurrence[9],
		                            replica,
		                            state[9],
		                            delta$7,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       a,
		                                       S]);
		                            });
		                  default:
		                   var delta$8 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[10],
		                            delta$8,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       a]);
		                            });
		                }
		               }
		               var
		                include$186 =
		                  caml_callback
		                   (Apply$14,
		                    [[0, [0, schema_versioned$421], apply_delta$43, apply$47]]),
		                delta_schema_versioned$38 = include$186[1],
		                apply_delta$44 = include$186[3],
		                apply$48 = include$186[4];
		               function schematic_version$93(param, cont){return cont(0);}
		               caml_callback(schema_versioned$237, [schematic_version$93]);
		               function attendees(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [1, op], cont);
		               }
		               function daytime$0(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [3, op], cont);
		               }
		               function description(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [4, op], cont);
		               }
		               function exceptions(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [5, op], cont);
		               }
		               function location(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [6, op], cont);
		               }
		               function notes(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [7, op], cont);
		               }
		               function recurrence(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [8, op], cont);
		               }
		               function title(op, cont){
		                return caml_exact_trampoline_cps_call(v$19, [9, op], cont);
		               }
		               function schema_versioned$422(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (creator_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aR8, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$166 =
		                  caml_callback
		                   (schema_versioned$422,
		                    [function(param, cont){return cont(0);}]),
		                Creator =
		                  caml_callback(A, [[0, schema_versioned$422, schema$166]]);
		               function schema_versioned$423(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schematic_param_name_schema_ve,
		                                   function(a){return cont([0, bH, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                j =
		                  caml_callback
		                   (option_schema, [schematic_param_name_schema_ve]),
		                schema$276 = [0, bH, 0, j[3], j[4]],
		                Google_event_id =
		                  caml_callback(A, [[0, schema_versioned$423, schema$276]]);
		               function schema_versioned$424(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (link_schema_versioned$1,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aR9, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$167 =
		                  caml_callback
		                   (schema_versioned$424,
		                    [function(param, cont){return cont(0);}]),
		                Link =
		                  caml_callback(A, [[0, schema_versioned$424, schema$167]]),
		                cst_Creator = "Creator",
		                cst_Google_calendar_id = "Google_calendar_id",
		                cst_Google_event_id = "Google_event_id",
		                cst_Link = "Link",
		                letrec_function_context$700 = [];
		               function schema_versioned$425(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$700[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aR_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$700[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$700[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$700[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$38,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aR$,
		   cst_writable,
		   cst_Writable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Link[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSa,
		             cst_link,
		             cst_Link,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_link, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Google_event_id[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aSb,
		                       cst_google_event_id,
		                       cst_Google_event_id,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_google_event_id, 0, 2, [0, c], 0, 0],
		                          0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$36,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aSc,
		                                 cst_google_calendar_id,
		                                 cst_Google_calendar_id,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_google_calendar_id, 0, 2, [0, c], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (include$139[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aSd,
		   cst_draft,
		   cst_Draft,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Creator[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aSe,
		              cst_creator,
		              cst_Creator,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_creator, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$700[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$700[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$666 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$700, [0, schematic_cache$666]);
		               caml_callback
		                (schema_versioned$425,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$701 = [];
		               function equal$233(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$701[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$701, [0, equal$147]);
		               var
		                include$187 = Monadic$0(),
		                v$20 = include$187[1],
		                const$7 = include$187[2],
		                all_unit$13 = include$187[12],
		                Apply$15 = include$187[14],
		                letrec_function_context$702 = [];
		               function state_schema_versioned$29(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$702[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$702[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$702[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$702[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$28,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Link[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_link, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (include$139[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Creator[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_creator, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Google_event_id[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_google_event_id, 0, 2, [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$26,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_google_calendar_id, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$232,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        writable = e[2][1],
		                        link = e[1],
		                        draft = d[1],
		                        creator = c[1],
		                        google_event_id = b[1],
		                        google_calendar_id = a[1],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 google_calendar_id,
		                                 google_event_id,
		                                 creator,
		                                 draft,
		                                 link,
		                                 writable]);
		                      },
		                      function(param, cont){
		                       var
		                        writable = param[7],
		                        link = param[6],
		                        draft = param[5],
		                        creator = param[4],
		                        google_event_id = param[3],
		                        google_calendar_id = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0,
		                                  google_calendar_id,
		                                  [0,
		                                   google_event_id,
		                                   [0, creator, [0, draft, [0, link, [0, writable, 0]]]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$702[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$702[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$667 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$702, [0, schematic_cache$667]);
		               var
		                state_schema$9 =
		                  caml_callback
		                   (state_schema_versioned$29,
		                    [function(param, cont){return cont(0);}]);
		               function apply$49(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var op = param[1];
		                   return caml_trampoline_cps_call4
		                           (Creator[8],
		                            replica,
		                            state[4],
		                            op,
		                            function(match){
		                             var creator = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          creator,
		          state[5],
		          state[6],
		          state[7]]]);
		                                      });
		                            });
		                  case 1:
		                   var op$0 = param[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[8],
		                            replica,
		                            state[5],
		                            op$0,
		                            function(match){
		                             var draft = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          draft,
		          state[6],
		          state[7]]]);
		                                      });
		                            });
		                  case 2:
		                   var op$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$45,
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              google_calendar_id = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          google_calendar_id,
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7]]]);
		                                      });
		                            });
		                  case 3:
		                   var op$2 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Google_event_id[8],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              google_event_id = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          google_event_id,
		          state[4],
		          state[5],
		          state[6],
		          state[7]]]);
		                                      });
		                            });
		                  case 4:
		                   var op$3 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Link[8],
		                            replica,
		                            state[6],
		                            op$3,
		                            function(match){
		                             var link = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          link,
		          state[7]]]);
		                                      });
		                            });
		                  default:
		                   var op$4 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$48,
		                            replica,
		                            state[7],
		                            op$4,
		                            function(match){
		                             var writable = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$18,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          writable]]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$45(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[7],
		                    b = state[6],
		                    c = state[5];
		                   return caml_trampoline_cps_call4
		                           (Creator[9],
		                            replica,
		                            state[4],
		                            delta,
		                            function(d){
		                             return cont([0, state[1], state[2], state[3], d, c, b, a]);
		                            });
		                  case 1:
		                   var delta$0 = param[1], d = state[7], e = state[6];
		                   return caml_trampoline_cps_call4
		                           (include$139[9],
		                            replica,
		                            state[5],
		                            delta$0,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], a, e, d]);
		                            });
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    f = state[7],
		                    g = state[6],
		                    h = state[5],
		                    i = state[4],
		                    j = state[3];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$41,
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(a){return cont([0, state[1], a, j, i, h, g, f]);});
		                  case 3:
		                   var
		                    delta$2 = param[1],
		                    k = state[7],
		                    l = state[6],
		                    m = state[5],
		                    n = state[4];
		                   return caml_trampoline_cps_call4
		                           (Google_event_id[9],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(a){
		                             return cont([0, state[1], state[2], a, n, m, l, k]);
		                            });
		                  case 4:
		                   var delta$3 = param[1], o = state[7];
		                   return caml_trampoline_cps_call4
		                           (Link[9],
		                            replica,
		                            state[6],
		                            delta$3,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], state[5], a, o]);
		                            });
		                  default:
		                   var delta$4 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$44,
		                            replica,
		                            state[7],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       a]);
		                            });
		                }
		               }
		               var
		                include$188 =
		                  caml_callback
		                   (Apply$15,
		                    [[0, [0, schema_versioned$425], apply_delta$45, apply$49]]),
		                delta_schema_versioned$39 = include$188[1],
		                delta_schema$9 = include$188[2],
		                apply_delta$46 = include$188[3],
		                apply$50 = include$188[4];
		               function make$91(param, cont){
		                var
		                 writable = param[7],
		                 link = param[6],
		                 id = param[5],
		                 google_event_id = param[4],
		                 draft = param[3],
		                 creator = param[2],
		                 calendar = param[1],
		                 title = writable[10],
		                 recurrence = writable[9],
		                 notes = writable[8],
		                 location = writable[7],
		                 exceptions = writable[6],
		                 description = writable[5],
		                 daytime = writable[4],
		                 availability_override = writable[3],
		                 attendees = writable[2],
		                 attendance = writable[1];
		                return caml_exact_trampoline_cps_call
		                        (make$66,
		                         title,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Recurrence[10],
		                                   recurrence,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (make$72,
		     notes,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (make$68,
		               location,
		               function(d){
		                return caml_trampoline_cps_call2
		                        (Exceptions$0[11],
		                         exceptions,
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (make$68,
		                                   description,
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Daytime[10],
		     daytime,
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (make$88,
		               availability_override,
		               function(h){
		                return caml_trampoline_cps_call2
		                        (make$87,
		                         attendees,
		                         function(i){
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   attendance,
		                                   unwrap,
		                                   function(j){
		                                    return caml_exact_trampoline_cps_call
		    (make$84,
		     j,
		     function(k){
		      var j = [0, k, i, h, g, f, e, d, c, b, a];
		      return caml_exact_trampoline_cps_call
		              (Link[10],
		               link,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (include$139[10],
		                         draft,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (Creator[10],
		                                   creator,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (Google_event_id[10],
		     google_event_id,
		     function(d){
		      return caml_exact_trampoline_cps_call
		              (make$89,
		               calendar,
		               function(e){return cont([0, id, e, d, c, b, a, j]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$30(param, cont){
		                var
		                 writable = param[7],
		                 link = param[6],
		                 draft = param[5],
		                 creator = param[4],
		                 google_event_id = param[3],
		                 google_calendar_id = param[2],
		                 id = param[1],
		                 title = writable[10],
		                 recurrence = writable[9],
		                 notes = writable[8],
		                 location = writable[7],
		                 exceptions = writable[6],
		                 description = writable[5],
		                 daytime = writable[4],
		                 availability_override = writable[3],
		                 attendees = writable[2],
		                 attendance = writable[1];
		                return caml_exact_trampoline_cps_call
		                        (view$4,
		                         title,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Recurrence[11],
		                                   recurrence,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (view$11,
		     notes,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (view$7,
		               location,
		               function(d){
		                return caml_trampoline_cps_call2
		                        (Exceptions$0[12],
		                         exceptions,
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (view$7,
		                                   description,
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (Daytime[11],
		     daytime,
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (view$27,
		               availability_override,
		               function(h){
		                return caml_trampoline_cps_call2
		                        (view$26,
		                         attendees,
		                         function(i){
		                          return caml_exact_trampoline_cps_call
		                                  (view$23,
		                                   attendance,
		                                   function(j){
		                                    return caml_trampoline_cps_call3
		    (map$17,
		     j,
		     wrap$1,
		     function(k){
		      var j = [0, k, i, h, g, f, e, d, c, b, a];
		      return caml_exact_trampoline_cps_call
		              (Link[11],
		               link,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (Google_event_id[11],
		                         google_event_id,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[11],
		                                   draft,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (Creator[11],
		     creator,
		     function(d){
		      return caml_exact_trampoline_cps_call
		              (view$28,
		               google_calendar_id,
		               function(e){
		                return caml_trampoline_cps_call2
		                        (include$0[5], [0, e, d, c, b, id, a, j], cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function set_draft(draft, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[12],
		                         draft,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$20, [1, a], cont);
		                         });
		               }
		               caml_callback(set_draft, [0]);
		               function writable(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$20, [5, operation], cont);
		               }
		               var
		                open$12 =
		                  g
		                   ([0,
		                     symbol_bind$5,
		                     symbol_map$5,
		                     ,
		                     bind$8,
		                     return$9,
		                     map$17,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$3]),
		                let$19 = open$12[4];
		               function schema_versioned$426(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$109,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aSg, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$168 =
		                  caml_callback
		                   (schema_versioned$426,
		                    [function(param, cont){return cont(0);}]),
		                Task_id_opt =
		                  caml_callback(A, [[0, schema_versioned$426, schema$168]]);
		               function schema_versioned$427(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$223,
		                                   schematic_version,
		                                   function(a){return cont([0, aSh, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$169 =
		                  caml_callback
		                   (schema_versioned$427,
		                    [function(param, cont){return cont(0);}]),
		                Time =
		                  caml_callback(A, [[0, schema_versioned$427, schema$169]]),
		                StrMap =
		                  caml_callback
		                   (M$2, [[0, comparator$2, thread_id_schema_versioned]]),
		                schematic_cache$668 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$703 = [];
		               caml_update_dummy
		                (letrec_function_context$703, [0, schematic_cache$668]);
		               function schematic_version$94(param, cont){return cont(0);}
		               var
		                schematic_schema_version$24 =
		                  caml_callback(schematic_version$94, [V$4]);
		               function bRy(Incremental, Key, O, Element, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (Make_op,
		                         Incremental,
		                         Key,
		                         dummy,
		                         [0,
		                          ,
		                          Element[3],
		                          ,
		                          Element[5],
		                          ,
		                          Element[7],
		                          Element[8],
		                          Element[9],
		                          Element[10],
		                          Element[11],
		                          Element[12]],
		                         function(include){
		                          var
		                           Map = include[1],
		                           Operation = include[2],
		                           Pattern = include[7],
		                           state_schema_versioned = include[8],
		                           state_schema = include[9],
		                           Init = include[10],
		                           Monad = include[11],
		                           delta_schema_versioned = include[12],
		                           delta_schema = include[13],
		                           apply_delta = include[14],
		                           apply = include[15],
		                           make = include[16],
		                           view = include[17],
		                           init = include[18],
		                           add = include[19],
		                           element = include[20],
		                           element$0 = include[21],
		                           has = include[22],
		                           remove = include[23];
		                          function equal(m1, m2, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (Map[55], Element[1], m1, m2, cont);
		                          }
		                          function diff(previous, current, cont){
		                           function to_operation(param, cont){
		                            var match = param[2], id = param[1], variant = match[1];
		                            if(847852583 === variant)
		                             return caml_exact_trampoline_cps_call(remove, id, cont);
		                            var data = 1013247643 <= variant ? match[2][2] : match[2];
		                            return caml_exact_trampoline_cps_call$1(add, id, data, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (Map[63],
		                                    previous,
		                                    current,
		                                    Element[1],
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (map$11,
		      a,
		      to_operation,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (to_binable,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2(Operation[13], a, cont);
		                });
		      });
		                                    });
		                          }
		                          return cont
		                                  ([0,
		                                    [0,
		                                     Map[3],
		                                     Map[4],
		                                     Map[5],
		                                     Map[6],
		                                     Map[7],
		                                     Map[8],
		                                     Map[9],
		                                     Map[10],
		                                     Map[11],
		                                     Map[12],
		                                     Map[13],
		                                     Map[14],
		                                     Map[15],
		                                     Map[16],
		                                     Map[17],
		                                     Map[18],
		                                     Map[19],
		                                     Map[20],
		                                     Map[21],
		                                     Map[22],
		                                     Map[23],
		                                     Map[24],
		                                     Map[25],
		                                     Map[26],
		                                     Map[27],
		                                     Map[28],
		                                     Map[29],
		                                     Map[30],
		                                     Map[31],
		                                     Map[32],
		                                     Map[33],
		                                     Map[34],
		                                     Map[35],
		                                     Map[36],
		                                     Map[37],
		                                     Map[38],
		                                     Map[39],
		                                     Map[40],
		                                     Map[41],
		                                     Map[42],
		                                     Map[43],
		                                     Map[44],
		                                     Map[45],
		                                     Map[46],
		                                     Map[47],
		                                     Map[48],
		                                     Map[49],
		                                     Map[50],
		                                     Map[51],
		                                     Map[52],
		                                     Map[53],
		                                     Map[54],
		                                     Map[55],
		                                     Map[56],
		                                     Map[57],
		                                     Map[58],
		                                     Map[59],
		                                     Map[60],
		                                     Map[61],
		                                     Map[63],
		                                     Map[64],
		                                     Map[65],
		                                     Map[66],
		                                     Map[67],
		                                     Map[68],
		                                     Map[69],
		                                     Map[70],
		                                     Map[71],
		                                     Map[72],
		                                     Map[73],
		                                     Map[74],
		                                     Map[75],
		                                     Map[76],
		                                     Map[77],
		                                     Map[78],
		                                     Map[79],
		                                     Map[80],
		                                     Map[81],
		                                     Map[82],
		                                     Map[83],
		                                     Map[84],
		                                     Map[85],
		                                     Map[86],
		                                     Map[87],
		                                     Map[88],
		                                     Map[89],
		                                     Map[90],
		                                     Map[91],
		                                     Map[92],
		                                     Map[95],
		                                     Map[96],
		                                     Map[97],
		                                     Map[98],
		                                     Map[99],
		                                     Map[100],
		                                     Map[103],
		                                     Map[104],
		                                     Map[105],
		                                     Map[106],
		                                     Map[107],
		                                     Map[108],
		                                     Map[109],
		                                     Map[110],
		                                     Map[111],
		                                     Map[112],
		                                     Map[113],
		                                     Map[114],
		                                     Map[115],
		                                     Map[116],
		                                     Map[117],
		                                     Map[118],
		                                     Map[119],
		                                     Map[120],
		                                     Map[121],
		                                     Map[122],
		                                     Map[123],
		                                     Map[124],
		                                     Map[125],
		                                     Map[126],
		                                     Map[127]],
		                                    Operation,
		                                    state_schema_versioned,
		                                    state_schema,
		                                    delta_schema_versioned,
		                                    delta_schema,
		                                    Init,
		                                    Monad,
		                                    apply,
		                                    apply_delta,
		                                    make,
		                                    view,
		                                    init,
		                                    add,
		                                    element,
		                                    element$0,
		                                    has,
		                                    remove,
		                                    Pattern,
		                                    equal,
		                                    diff]);
		                         });
		               }
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$703[1][1],
		                    schematic_schema_version$24]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$703[1][1],
		                             schematic_schema_version$24,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$703[1][1],
		schematic_schema_version$24,
		schematic_self,
		function(b){
		 letrec_function_context$703[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_title,
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$223,
		          schematic_version$94,
		          function(c){
		           var
		            b = [0, [0, 0, 0, 0, 0, cst_time, 0, 2, [0, c], 0, 0], a];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$109,
		                    schematic_version$94,
		                    function(c){
		                     var
		                      a = [0, [0, 0, 0, 0, 0, cst_task, 0, 3, [0, c], 0, 0], b];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$140,
		                              schematic_version$94,
		                              function(c){
		                               var
		                                b =
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_location,
		                                    0,
		                                    3,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], a]];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$172,
		schematic_version$94,
		function(c){
		 var
		  a =
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_description,
		      0,
		      3,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0, 0, 0, 0, 0, cst_extension_row, 0, 3, [0, c], 0, 0],
		      b]];
		 return caml_exact_trampoline_cps_call
		         (availability_schema_versioned,
		          schematic_version$94,
		          function(c){
		           var
		            b =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_availability_override,
		                0,
		                3,
		                [0, c],
		                0,
		                0],
		               a];
		           return caml_exact_trampoline_cps_call
		                   (attendee_schema_versioned$0,
		                    schematic_version$94,
		                    function(a){
		                     return caml_trampoline_cps_call3
		                             (StrMap[109],
		                              schematic_version$94,
		                              a,
		                              function(c){
		                               var
		                                a =
		                                  [0, [0, 0, 0, 0, 0, cst_attendees, 0, 2, [0, c], 0, 0], b];
		                               return caml_exact_trampoline_cps_call
		                                       (attendance_schema_versioned,
		schematic_version$94,
		function(c){
		 var
		  b =
		    [0, [0, 0, 0, 0, 0, cst_attendance, 0, 3, [0, c], 0, 0], a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$4,
		          schematic_version$94,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 b = a[2],
		                 c = b[2],
		                 d = c[2],
		                 e = d[2],
		                 f = e[2],
		                 g = f[2],
		                 h = g[2],
		                 i = h[2],
		                 title = i[2][1],
		                 time = i[1],
		                 task = h[1],
		                 notes = g[1],
		                 location = f[1],
		                 extension_row = e[1],
		                 description = d[1],
		                 availability_override = c[1],
		                 attendees = b[1],
		                 attendance = a[1],
		                 archived = param[1];
		                return cont
		                        ([0,
		                          archived,
		                          attendance,
		                          attendees,
		                          availability_override,
		                          description,
		                          extension_row,
		                          location,
		                          notes,
		                          task,
		                          time,
		                          title]);
		               },
		               function(param, cont){
		                var
		                 title = param[11],
		                 time = param[10],
		                 task = param[9],
		                 notes = param[8],
		                 location = param[7],
		                 extension_row = param[6],
		                 description = param[5],
		                 availability_override = param[4],
		                 attendees = param[3],
		                 attendance = param[2],
		                 archived = param[1];
		                return cont
		                        ([0,
		                          archived,
		                          [0,
		                           attendance,
		                           [0,
		                            attendees,
		                            [0,
		                             availability_override,
		                             [0,
		                              description,
		                              [0,
		                               extension_row,
		                               [0,
		                                location,
		                                [0, notes, [0, task, [0, time, [0, title, 0]]]]]]]]]]]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_archived, 0, 3, [0, a], 0, 0], b]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$703[1][1],
		                    schematic_schema_version$24,
		                    res,
		                    function(a){
		                     letrec_function_context$703[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_Archived = "Archived",
		                letrec_function_context$704 = [];
		               function schema_versioned$428(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$704[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSi, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$704[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$704[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$704[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([10, f0]);},
		   function(param, cont){
		    if(10 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aSj,
		   cst_title,
		   cst_Title,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Time[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([9, f0]);},
		             function(param, cont){
		              if(9 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSk,
		             cst_time,
		             cst_Time,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_time, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Task_id_opt[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([8, f0]);},
		                       function(param, cont){
		                        if(8 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aSl,
		                       cst_task,
		                       cst_Task,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$3,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([7, f0]);},
		                                 function(param, cont){
		                                  if(7 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aSm,
		                                 cst_notes,
		                                 cst_Notes,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$6,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(6 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aSn,
		   cst_location,
		   cst_Location,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_location, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$23,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(5 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSo,
		             cst_extension_row,
		             cst_Extension_row,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, c], 0, 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$6,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(4 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aSp,
		                       cst_description,
		                       cst_Description,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$35,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aSq,
		                                 cst_availability_override,
		                                 cst_Availability_override,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_availability_override,
		                                     0,
		                                     2,
		                                     [0, c],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$34,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aSr,
		   cst_attendees,
		   cst_Attendees,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_attendees, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$31,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSs,
		             cst_attendance,
		             cst_Attendance,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_attendance, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Earliest[5],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aSt,
		                        cst_archived,
		                        cst_Archived,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$704[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$704[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$669 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$704, [0, schematic_cache$669]);
		               caml_callback
		                (schema_versioned$428,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$189 = Monadic$0(),
		                v$21 = include$189[1],
		                Apply$16 = include$189[14],
		                letrec_function_context$705 = [];
		               function state_schema_versioned$30(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$705[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSu, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$705[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$705[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$705[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$3,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Time[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_time, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Task_id_opt[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$2,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$5,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_location, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$16,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (state_schema_versioned$5,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$25,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_availability_override,
		                                 0,
		                                 2,
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (state_schema_versioned$24,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_attendees, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$21,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_attendance, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Earliest[3],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        title = i[2][1],
		                        time = i[1],
		                        task = h[1],
		                        notes = g[1],
		                        location = f[1],
		                        extension_row = e[1],
		                        description = d[1],
		                        availability_override = c[1],
		                        attendees = b[1],
		                        attendance = a[1],
		                        archived = param[1];
		                       return cont
		                               ([0,
		                                 archived,
		                                 attendance,
		                                 attendees,
		                                 availability_override,
		                                 description,
		                                 extension_row,
		                                 location,
		                                 notes,
		                                 task,
		                                 time,
		                                 title]);
		                      },
		                      function(param, cont){
		                       var
		                        title = param[11],
		                        time = param[10],
		                        task = param[9],
		                        notes = param[8],
		                        location = param[7],
		                        extension_row = param[6],
		                        description = param[5],
		                        availability_override = param[4],
		                        attendees = param[3],
		                        attendance = param[2],
		                        archived = param[1];
		                       return cont
		                               ([0,
		                                 archived,
		                                 [0,
		                                  attendance,
		                                  [0,
		                                   attendees,
		                                   [0,
		                                    availability_override,
		                                    [0,
		                                     description,
		                                     [0,
		                                      extension_row,
		                                      [0,
		                                       location,
		                                       [0, notes, [0, task, [0, time, [0, title, 0]]]]]]]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$705[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$705[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$670 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$705, [0, schematic_cache$670]);
		               caml_callback
		                (state_schema_versioned$30,
		                 [function(param, cont){return cont(0);}]);
		               function apply$51(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Earliest[9],
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   new_substate,
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$39,
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   new_substate,
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$43,
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   new_substate,
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$44,
		                            replica,
		                            state[4],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   new_substate,
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 4:
		                   var op$4 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$12,
		                            replica,
		                            state[5],
		                            op$4,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   new_substate,
		   state[6],
		   state[7],
		   state[8],
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 5:
		                   var op$5 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$31,
		                            replica,
		                            state[6],
		                            op$5,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   new_substate,
		   state[7],
		   state[8],
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 6:
		                   var op$6 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$12,
		                            replica,
		                            state[7],
		                            op$6,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   new_substate,
		   state[8],
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 7:
		                   var op$7 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$9,
		                            replica,
		                            state[8],
		                            op$7,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([7, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   new_substate,
		   state[9],
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 8:
		                   var op$8 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Task_id_opt[8],
		                            replica,
		                            state[9],
		                            op$8,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([8, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   new_substate,
		   state[10],
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 9:
		                   var op$9 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Time[8],
		                            replica,
		                            state[10],
		                            op$9,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([9, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9],
		   new_substate,
		   state[11]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$10 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$10,
		                            replica,
		                            state[11],
		                            op$10,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([10, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8],
		   state[9],
		   state[10],
		   new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$47(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Earliest[10],
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       new_substate,
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$35,
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       new_substate,
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$39,
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       new_substate,
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 3:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$40,
		                            replica,
		                            state[4],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       new_substate,
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 4:
		                   var delta$4 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$8,
		                            replica,
		                            state[5],
		                            delta$4,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       new_substate,
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 5:
		                   var delta$5 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$27,
		                            replica,
		                            state[6],
		                            delta$5,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       new_substate,
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 6:
		                   var delta$6 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$8,
		                            replica,
		                            state[7],
		                            delta$6,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       new_substate,
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 7:
		                   var delta$7 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$5,
		                            replica,
		                            state[8],
		                            delta$7,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       new_substate,
		                                       state[9],
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 8:
		                   var delta$8 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Task_id_opt[9],
		                            replica,
		                            state[9],
		                            delta$8,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       new_substate,
		                                       state[10],
		                                       state[11]]);
		                            });
		                  case 9:
		                   var delta$9 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Time[9],
		                            replica,
		                            state[10],
		                            delta$9,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       new_substate,
		                                       state[11]]);
		                            });
		                  default:
		                   var delta$10 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[11],
		                            delta$10,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       new_substate]);
		                            });
		                }
		               }
		               var
		                include$190 =
		                  caml_callback
		                   (Apply$16,
		                    [[0, [0, schema_versioned$428], apply_delta$47, apply$51]]),
		                delta_schema_versioned$40 = include$190[1],
		                apply_delta$48 = include$190[3],
		                apply$52 = include$190[4];
		               function schema_versioned$429(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (calendar_status_schema_version,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aSv, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$170 =
		                  caml_callback
		                   (schema_versioned$429,
		                    [function(param, cont){return cont(0);}]),
		                Calendar_status =
		                  caml_callback(A, [[0, schema_versioned$429, schema$170]]);
		               function schema_versioned$430(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (creator_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aSw, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$171 =
		                  caml_callback
		                   (schema_versioned$430,
		                    [function(param, cont){return cont(0);}]),
		                Creator$0 =
		                  caml_callback(A, [[0, schema_versioned$430, schema$171]]);
		               function schema_versioned$431(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$16,
		                                   schematic_version,
		                                   function(a){return cont([0, aSx, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$172 =
		                  caml_callback
		                   (schema_versioned$431,
		                    [function(param, cont){return cont(0);}]),
		                Google_calendar_id =
		                  caml_callback(A, [[0, schema_versioned$431, schema$172]]);
		               function schema_versioned$432(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schematic_param_name_schema_ve,
		                                   function(a){return cont([0, bI, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                j =
		                  caml_callback
		                   (option_schema, [schematic_param_name_schema_ve]),
		                schema$275 = [0, bI, 0, j[3], j[4]],
		                Google_event_id$0 =
		                  caml_callback(A, [[0, schema_versioned$432, schema$275]]);
		               function schema_versioned$433(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (link_schema_versioned$1,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aSy, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$173 =
		                  caml_callback
		                   (schema_versioned$433,
		                    [function(param, cont){return cont(0);}]),
		                Link$0 =
		                  caml_callback(A, [[0, schema_versioned$433, schema$173]]);
		               function schema_versioned$434(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$202,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aSz, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$174 =
		                  caml_callback
		                   (schema_versioned$434,
		                    [function(param, cont){return cont(0);}]),
		                Slot_type =
		                  caml_callback(A, [[0, schema_versioned$434, schema$174]]),
		                letrec_function_context$706 = [];
		               function equal$234(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$706[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$706, [0, equal$140]);
		               var letrec_function_context$707 = [];
		               function state_schema_versioned$31(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$707[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$707[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$707[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$707[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$30,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Slot_type[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Link$0[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_link, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (include$139[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Creator$0[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_creator, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (Calendar_status[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_calendar_status, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (Google_event_id$0[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_google_event_id, 0, 2, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (Google_calendar_id[2],
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  writable = g[2][1],
		                                  type = g[1],
		                                  link = f[1],
		                                  draft = e[1],
		                                  creator = d[1],
		                                  calendar_status = c[1],
		                                  google_event_id = b[1],
		                                  google_calendar_id = a[1],
		                                  id = param[1];
		                                 return cont
		 ([0,
		   id,
		   google_calendar_id,
		   google_event_id,
		   calendar_status,
		   creator,
		   draft,
		   link,
		   type,
		   writable]);
		                                },
		                                function(param, cont){
		                                 var
		                                  writable = param[9],
		                                  type = param[8],
		                                  link = param[7],
		                                  draft = param[6],
		                                  creator = param[5],
		                                  calendar_status = param[4],
		                                  google_event_id = param[3],
		                                  google_calendar_id = param[2],
		                                  id = param[1];
		                                 return cont
		 ([0,
		   id,
		   [0,
		    google_calendar_id,
		    [0,
		     google_event_id,
		     [0,
		      calendar_status,
		      [0,
		       creator,
		       [0, draft, [0, link, [0, type, [0, writable, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_google_calendar_id, 0, 2, [0, b], 0, 0],
		                                  a]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$707[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$707[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$671 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$707, [0, schematic_cache$671]);
		               var
		                state_schema$10 =
		                  caml_callback
		                   (state_schema_versioned$31,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$708 = [];
		               function schema_versioned$435(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$708[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$708[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$708[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$708[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$40,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([7, f0]);},
		   function(param, cont){
		    if(7 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aSC,
		   cst_writable,
		   cst_Writable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Slot_type[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(6 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSD,
		             cst_type,
		             cst_Type,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Link$0[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([5, f0]);},
		                       function(param, cont){
		                        if(5 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aSE,
		                       cst_link,
		                       cst_Link,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_link, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Google_event_id$0[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(4 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aSF,
		                                 cst_google_event_id,
		                                 cst_Google_event_id,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_google_event_id, 0, 2, [0, c], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Google_calendar_id[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aSG,
		   cst_google_calendar_id,
		   cst_Google_calendar_id,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_google_calendar_id, 0, 2, [0, c], 0, 0],
		      0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (include$139[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSH,
		             cst_draft,
		             cst_Draft,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_draft, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Creator$0[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aSI,
		                       cst_creator,
		                       cst_Creator,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_creator, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Calendar_status[4],
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aSJ,
		                                  cst_calendar_status,
		                                  "Calendar_status",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_calendar_status, 0, 2, [0, b], 0, 0],
		                                     0]],
		                                   0],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$708[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$708[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$672 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$708, [0, schematic_cache$672]);
		               caml_callback
		                (schema_versioned$435,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$191 = Monadic$0(),
		                v$22 = include$191[1],
		                const$8 = include$191[2],
		                return$33 = include$191[7],
		                ignore_m$6 = include$191[10],
		                all_unit$14 = include$191[12],
		                all$23 = include$191[13],
		                Apply$17 = include$191[14];
		               function apply$53(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var op = param[1];
		                   return caml_trampoline_cps_call4
		                           (Calendar_status[8],
		                            replica,
		                            state[4],
		                            op,
		                            function(match){
		                             var
		                              calendar_status = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          calendar_status,
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9]]]);
		                                      });
		                            });
		                  case 1:
		                   var op$0 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Creator$0[8],
		                            replica,
		                            state[5],
		                            op$0,
		                            function(match){
		                             var creator = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          creator,
		          state[6],
		          state[7],
		          state[8],
		          state[9]]]);
		                                      });
		                            });
		                  case 2:
		                   var op$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[8],
		                            replica,
		                            state[6],
		                            op$1,
		                            function(match){
		                             var draft = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          draft,
		          state[7],
		          state[8],
		          state[9]]]);
		                                      });
		                            });
		                  case 3:
		                   var op$2 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Google_calendar_id[8],
		                            replica,
		                            state[2],
		                            op$2,
		                            function(match){
		                             var
		                              google_calendar_id = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          google_calendar_id,
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9]]]);
		                                      });
		                            });
		                  case 4:
		                   var op$3 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Google_event_id$0[8],
		                            replica,
		                            state[3],
		                            op$3,
		                            function(match){
		                             var
		                              google_event_id = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          google_event_id,
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          state[9]]]);
		                                      });
		                            });
		                  case 5:
		                   var op$4 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Link$0[8],
		                            replica,
		                            state[7],
		                            op$4,
		                            function(match){
		                             var link = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          link,
		          state[8],
		          state[9]]]);
		                                      });
		                            });
		                  case 6:
		                   var op$5 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Slot_type[8],
		                            replica,
		                            state[8],
		                            op$5,
		                            function(match){
		                             var type = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          type,
		          state[9]]]);
		                                      });
		                            });
		                  default:
		                   var op$6 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply$52,
		                            replica,
		                            state[9],
		                            op$6,
		                            function(match){
		                             var writable = match[3], delta = match[2], res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$19,
		                                      delta,
		                                      function(delta, cont){return cont([7, delta]);},
		                                      function(delta){
		                                       return cont
		       ([0,
		         res,
		         delta,
		         [0,
		          state[1],
		          state[2],
		          state[3],
		          state[4],
		          state[5],
		          state[6],
		          state[7],
		          state[8],
		          writable]]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$49(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[9],
		                    b = state[8],
		                    c = state[7],
		                    d = state[6],
		                    e = state[5];
		                   return caml_trampoline_cps_call4
		                           (Calendar_status[9],
		                            replica,
		                            state[4],
		                            delta,
		                            function(f){
		                             return cont
		                                     ([0, state[1], state[2], state[3], f, e, d, c, b, a]);
		                            });
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    f = state[9],
		                    g = state[8],
		                    h = state[7],
		                    i = state[6];
		                   return caml_trampoline_cps_call4
		                           (Creator$0[9],
		                            replica,
		                            state[5],
		                            delta$0,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], a, i, h, g, f]);
		                            });
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    j = state[9],
		                    k = state[8],
		                    l = state[7];
		                   return caml_trampoline_cps_call4
		                           (include$139[9],
		                            replica,
		                            state[6],
		                            delta$1,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       a,
		                                       l,
		                                       k,
		                                       j]);
		                            });
		                  case 3:
		                   var
		                    delta$2 = param[1],
		                    m = state[9],
		                    n = state[8],
		                    o = state[7],
		                    p = state[6],
		                    q = state[5],
		                    r = state[4],
		                    s = state[3];
		                   return caml_trampoline_cps_call4
		                           (Google_calendar_id[9],
		                            replica,
		                            state[2],
		                            delta$2,
		                            function(a){
		                             return cont([0, state[1], a, s, r, q, p, o, n, m]);
		                            });
		                  case 4:
		                   var
		                    delta$3 = param[1],
		                    t = state[9],
		                    u = state[8],
		                    v = state[7],
		                    w = state[6],
		                    x = state[5],
		                    y = state[4];
		                   return caml_trampoline_cps_call4
		                           (Google_event_id$0[9],
		                            replica,
		                            state[3],
		                            delta$3,
		                            function(a){
		                             return cont([0, state[1], state[2], a, y, x, w, v, u, t]);
		                            });
		                  case 5:
		                   var delta$4 = param[1], z = state[9], A = state[8];
		                   return caml_trampoline_cps_call4
		                           (Link$0[9],
		                            replica,
		                            state[7],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       a,
		                                       A,
		                                       z]);
		                            });
		                  case 6:
		                   var delta$5 = param[1], B = state[9];
		                   return caml_trampoline_cps_call4
		                           (Slot_type[9],
		                            replica,
		                            state[8],
		                            delta$5,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       a,
		                                       B]);
		                            });
		                  default:
		                   var delta$6 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$48,
		                            replica,
		                            state[9],
		                            delta$6,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       a]);
		                            });
		                }
		               }
		               var
		                include$192 =
		                  caml_callback
		                   (Apply$17,
		                    [[0, [0, schema_versioned$435], apply_delta$49, apply$53]]),
		                delta_schema_versioned$41 = include$192[1],
		                delta_schema$10 = include$192[2],
		                apply_delta$50 = include$192[3],
		                apply$54 = include$192[4];
		               function make$92(param, cont){
		                var
		                 writable = param[9],
		                 type = param[8],
		                 link = param[7],
		                 id = param[6],
		                 google_event_id = param[5],
		                 draft = param[4],
		                 creator = param[3],
		                 calendar_status = param[2],
		                 calendar = param[1],
		                 title = writable[11],
		                 time = writable[10],
		                 task = writable[9],
		                 notes = writable[8],
		                 location = writable[7],
		                 extension_row = writable[6],
		                 description = writable[5],
		                 availability_override = writable[4],
		                 attendees = writable[3],
		                 attendance = writable[2],
		                 archived = writable[1];
		                return caml_exact_trampoline_cps_call
		                        (make$66,
		                         title,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Time[10],
		                                   time,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Task_id_opt[10],
		     task,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (make$72,
		               notes,
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (make$68,
		                         location,
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (make$80,
		                                   extension_row,
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (make$68,
		     description,
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (make$88,
		               availability_override,
		               function(h){
		                return caml_trampoline_cps_call2
		                        (make$87,
		                         attendees,
		                         function(i){
		                          return caml_exact_trampoline_cps_call
		                                  (make$84,
		                                   attendance,
		                                   function(j){
		                                    return caml_exact_trampoline_cps_call
		    (Earliest[11],
		     archived,
		     function(l){
		      var k = [0, l, j, i, h, g, f, e, d, c, b, a];
		      return caml_exact_trampoline_cps_call
		              (Slot_type[10],
		               type,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (Link$0[10],
		                         link,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[10],
		                                   draft,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (Creator$0[10],
		     creator,
		     function(d){
		      return caml_exact_trampoline_cps_call
		              (Calendar_status[10],
		               calendar_status,
		               function(e){
		                return caml_exact_trampoline_cps_call
		                        (Google_event_id$0[10],
		                         google_event_id,
		                         function(f){
		                          return caml_exact_trampoline_cps_call
		                                  (Google_calendar_id[10],
		                                   calendar,
		                                   function(g){return cont([0, id, g, f, e, d, c, b, a, k]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$31(param, cont){
		                var
		                 writable = param[9],
		                 type = param[8],
		                 link = param[7],
		                 draft = param[6],
		                 creator = param[5],
		                 calendar_status = param[4],
		                 google_event_id = param[3],
		                 google_calendar_id = param[2],
		                 id = param[1];
		                return caml_exact_trampoline_cps_call
		                        (view$4,
		                         writable[11],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Time[11],
		                                   writable[10],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Task_id_opt[11],
		     writable[9],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (view$11,
		               writable[8],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (view$7,
		                         writable[7],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (view$19,
		                                   writable[6],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (view$7,
		     writable[5],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (view$27,
		               writable[4],
		               function(h){
		                return caml_trampoline_cps_call2
		                        (view$26,
		                         writable[3],
		                         function(i){
		                          return caml_exact_trampoline_cps_call
		                                  (view$23,
		                                   writable[2],
		                                   function(j){
		                                    return caml_exact_trampoline_cps_call
		    (Earliest[12],
		     writable[1],
		     function(l){
		      var k = [0, l, j, i, h, g, f, e, d, c, b, a];
		      return caml_exact_trampoline_cps_call
		              (Slot_type[11],
		               type,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (Link$0[11],
		                         link,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (Google_event_id$0[11],
		                                   google_event_id,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (include$139[11],
		     draft,
		     function(d){
		      return caml_exact_trampoline_cps_call
		              (Creator$0[11],
		               creator,
		               function(e){
		                return caml_exact_trampoline_cps_call
		                        (Calendar_status[11],
		                         calendar_status,
		                         function(f){
		                          return caml_exact_trampoline_cps_call
		                                  (Google_calendar_id[11],
		                                   google_calendar_id,
		                                   function(g){
		                                    return caml_trampoline_cps_call2
		    (include$0[5], [0, g, f, e, d, c, id, b, a, k], cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function set_creator(creator, cont){
		                return caml_exact_trampoline_cps_call
		                        (Creator$0[12],
		                         creator,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$22, [1, a], cont);
		                         });
		               }
		               function set_draft$0(b, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[12],
		                         b,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$22, [2, a], cont);
		                         });
		               }
		               caml_callback(set_draft$0, [0]);
		               function attendees$0(op, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$21,
		                         [2, op],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		                         });
		               }
		               function notes$0(op, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$21,
		                         [7, op],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		                         });
		               }
		               function update$2
		               (archived,
		                attendance,
		                attendees,
		                availability_override,
		                calendar_status,
		                creator,
		                description,
		                draft,
		                extension_row,
		                google_calendar_id,
		                google_event_id,
		                link,
		                location,
		                task,
		                time,
		                title,
		                type,
		                param,
		                cont){
		                return caml_trampoline_cps_call3
		                        (let$19,
		                         archived,
		                         function(archived, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Earliest[13],
		                                   archived,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (v$21,
		     [0, a],
		     function(a){
		      return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		     });
		                                   });
		                         },
		                         function(archived_op){
		                          return caml_trampoline_cps_call3
		                                  (let$19,
		                                   attendance,
		                                   function(attendance, cont){
		                                    return caml_exact_trampoline_cps_call
		    (set$15,
		     attendance,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (v$21,
		               [1, a],
		               function(a){
		                return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		               });
		     });
		                                   },
		                                   function(attendance_op){
		                                    return caml_trampoline_cps_call3
		    (let$19,
		     attendees,
		     function(attendees_op, cont){
		      return caml_exact_trampoline_cps_call
		              (attendees$0,
		               attendees_op,
		               function(a){
		                return caml_exact_trampoline_cps_call(ignore_m$6, a, cont);
		               });
		     },
		     function(attendees_op){
		      return caml_trampoline_cps_call3
		              (let$19,
		               availability_override,
		               function(availability_override, cont){
		                return caml_exact_trampoline_cps_call
		                        (set$16,
		                         availability_override,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$21,
		                                   [3, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		                                   });
		                         });
		               },
		               function(availability_override_op){
		                return caml_trampoline_cps_call3
		                        (let$19,
		                         calendar_status,
		                         function(calendar_status, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Calendar_status[12],
		                                   calendar_status,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$22, [0, a], cont);
		                                   });
		                         },
		                         function(calendar_status_op){
		                          return caml_trampoline_cps_call3
		                                  (let$19,
		                                   creator,
		                                   function(creator, cont){
		                                    return caml_exact_trampoline_cps_call
		    (set_creator, creator, cont);
		                                   },
		                                   function(creator_op){
		                                    return caml_trampoline_cps_call3
		    (let$19,
		     description,
		     function(description, cont){
		      return caml_exact_trampoline_cps_call
		              (v$21,
		               [4, description],
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (v$22,
		                         [7, a],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(ignore_m$6, a, cont);
		                         });
		               });
		     },
		     function(description_op){
		      return caml_trampoline_cps_call3
		              (let$19,
		               draft,
		               function(draft, cont){
		                return caml_exact_trampoline_cps_call
		                        (set_draft$0, draft, cont);
		               },
		               function(draft_op){
		                return caml_trampoline_cps_call3
		                        (let$19,
		                         extension_row,
		                         function(extension_row, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (set$12,
		                                   extension_row,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (v$21,
		     [5, a],
		     function(a){
		      return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		     });
		                                   });
		                         },
		                         function(extension_row_op){
		                          return caml_trampoline_cps_call3
		                                  (let$19,
		                                   google_calendar_id,
		                                   function(google_calendar_id, cont){
		                                    return caml_exact_trampoline_cps_call
		    (Google_calendar_id[12],
		     google_calendar_id,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$22, [3, a], cont);
		     });
		                                   },
		                                   function(google_calendar_id_op){
		                                    return caml_trampoline_cps_call3
		    (let$19,
		     google_event_id,
		     function(google_event_id, cont){
		      return caml_exact_trampoline_cps_call
		              (Google_event_id$0[12],
		               google_event_id,
		               function(a){
		                return caml_exact_trampoline_cps_call(v$22, [4, a], cont);
		               });
		     },
		     function(google_event_id_op){
		      return caml_trampoline_cps_call3
		              (let$19,
		               location,
		               function(location, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$21,
		                         [6, location],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$22,
		                                   [7, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$6, a, cont);
		                                   });
		                         });
		               },
		               function(location_op){
		                return caml_trampoline_cps_call3
		                        (let$19,
		                         link,
		                         function(link_o, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Link$0[12],
		                                   link_o,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$22, [5, a], cont);
		                                   });
		                         },
		                         function(link_op){
		                          return caml_trampoline_cps_call3
		                                  (let$19,
		                                   task,
		                                   function(task, cont){
		                                    return caml_exact_trampoline_cps_call
		    (Task_id_opt[12],
		     task,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (v$21,
		               [8, a],
		               function(a){
		                return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		               });
		     });
		                                   },
		                                   function(task_op){
		                                    return caml_trampoline_cps_call3
		    (let$19,
		     time,
		     function(time, cont){
		      return caml_exact_trampoline_cps_call
		              (Time[12],
		               time,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (v$21,
		                         [9, a],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$22, [7, a], cont);
		                         });
		               });
		     },
		     function(time_op){
		      return caml_trampoline_cps_call3
		              (let$19,
		               title,
		               function(title, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$21,
		                         [10, title],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$22,
		                                   [7, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$6, a, cont);
		                                   });
		                         });
		               },
		               function(title_op){
		                return caml_trampoline_cps_call3
		                        (let$19,
		                         type,
		                         function(slot_o, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Slot_type[12],
		                                   slot_o,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$22, [6, a], cont);
		                                   });
		                         },
		                         function(type_op){
		                          return caml_exact_trampoline_cps_call
		                                  (filter_opt,
		                                   [0,
		                                    archived_op,
		                                    [0,
		                                     attendance_op,
		                                     [0,
		                                      attendees_op,
		                                      [0,
		                                       availability_override_op,
		                                       [0,
		calendar_status_op,
		[0,
		 creator_op,
		 [0,
		  description_op,
		  [0,
		   draft_op,
		   [0,
		    extension_row_op,
		    [0,
		     google_calendar_id_op,
		     [0,
		      google_event_id_op,
		      [0,
		       location_op,
		       [0,
		        link_op,
		        [0, task_op, [0, time_op, [0, title_op, [0, type_op, 0]]]]]]]]]]]]]]]]],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(all_unit$14, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function Make$38(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$8],
		                      state_schema_versioned$31,
		                      state_schema$10,
		                      delta_schema_versioned$41,
		                      delta_schema$10,
		                      [0, schema_versioned$230, schema$90],
		                      include$0,
		                      apply$54,
		                      apply_delta$50,
		                      make$92,
		                      view$31,
		                      equal$234]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$234,
		                    [0, const$8],
		                    state_schema_versioned$31,
		                    state_schema$10,
		                    delta_schema_versioned$41,
		                    delta_schema$10,
		                    [0, schema_versioned$230, schema$90],
		                    include$0,
		                    apply$54,
		                    apply_delta$50,
		                    make$92,
		                    view$31];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$102,
		                          schema$263,
		                          symbol$101,
		                          symbol$102,
		                          symbol$103,
		                          symbol$104,
		                          symbol$105,
		                          symbol$106,
		                          equal$51,
		                          compare$58,
		                          min$13,
		                          max$15,
		                          ascending$4,
		                          descending$4,
		                          between$5,
		                          clamp_exn$4,
		                          clamp$4,
		                          comparator$14,
		                          pp$35],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$193 = caml_callback(Make$38, [Ident]),
		                Operation$6 = include$193[2],
		                delta_schema_versioned$42 = include$193[5],
		                add$19 = include$193[14],
		                element$3 = include$193[15],
		                element$4 = include$193[16],
		                remove$9 = include$193[18],
		                bR1 = [0, schema_versioned$239, schema$95];
		               function Make$39(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$7],
		                      state_schema_versioned$29,
		                      state_schema$9,
		                      delta_schema_versioned$39,
		                      delta_schema$9,
		                      [0, schema_versioned$239, schema$95],
		                      include$0,
		                      apply$50,
		                      apply_delta$46,
		                      make$91,
		                      view$30,
		                      equal$233]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$233,
		                    [0, const$7],
		                    state_schema_versioned$29,
		                    state_schema$9,
		                    delta_schema_versioned$39,
		                    delta_schema$9,
		                    bR1,
		                    include$0,
		                    apply$50,
		                    apply_delta$46,
		                    make$91,
		                    view$30];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$232,
		                          schema$91,
		                          symbol$157,
		                          symbol$158,
		                          symbol$159,
		                          symbol$160,
		                          symbol$161,
		                          symbol$162,
		                          equal$141,
		                          compare$111,
		                          min$22,
		                          max$24,
		                          ascending$13,
		                          descending$13,
		                          between$14,
		                          clamp_exn$13,
		                          clamp$13,
		                          comparator$31,
		                          pp$79],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$194 = caml_callback(Make$39, [Ident]),
		                delta_schema_versioned$43 = include$194[5],
		                add$20 = include$194[14],
		                element$5 = include$194[15],
		                element$6 = include$194[16],
		                has$1 = include$194[17],
		                remove$10 = include$194[18],
		                j =
		                  caml_callback
		                   (Make$26, [caml_callback(b8, [[0, schema_versioned$103]])]),
		                move = j[24],
		                add$16 = j[22],
		                delta_schema_versioned$1 = j[13],
		                roots$0 = j[19];
		               function schema_versioned$436(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont([0, bJ, 0, bool_schema[3], bool_schema[4]]);
		                         });
		               }
		               var
		                schema$274 = [0, bJ, 0, bool_schema[3], bool_schema[4]],
		                bRA = j[17],
		                bRB = j[9],
		                bRC = j[15],
		                bRD = j[16],
		                bRE = j[6],
		                bRF = j[14],
		                bRG = j[8],
		                bRH = j[7],
		                Directory_enabled =
		                  caml_callback(A, [[0, schema_versioned$436, schema$274]]);
		               function schema_versioned$437(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont([0, bK, 0, bool_schema[3], bool_schema[4]]);
		                         });
		               }
		               var
		                schema$273 = [0, bK, 0, bool_schema[3], bool_schema[4]],
		                Other_enabled =
		                  caml_callback(A, [[0, schema_versioned$437, schema$273]]),
		                letrec_function_context$709 = [];
		               function schema_versioned$438(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$709[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$709[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$709[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$709[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aSM,
		                                     aSL,
		                                     2,
		                                     3,
		                                     4,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_trampoline_cps_call2
		      (Other_enabled[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSN,
		             cst_other_enabled,
		             "Other_enabled",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_other_enabled$0, 0, 2, [0, c], 0, 0],
		                0]],
		              0],
		             a],
		            0];
		        return caml_trampoline_cps_call2
		                (Directory_enabled[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aSO,
		                        cst_directory_enabled,
		                        "Directory_enabled",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0,
		                           [0, 0, 0, 0, 0, cst_directory_enabled$0, 0, 2, [0, a], 0, 0],
		                           0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$709[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$709[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$673 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$709, [0, schematic_cache$673]);
		               caml_callback
		                (schema_versioned$438,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$195 = Monadic$0(),
		                v$23 = include$195[1],
		                const$9 = include$195[2],
		                all_unit$15 = include$195[12],
		                Apply$18 = include$195[14],
		                letrec_function_context$710 = [];
		               function state_schema_versioned$32(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$710[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$710[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$710[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$710[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Other_enabled[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_other_enabled, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (Directory_enabled[2],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              other_enabled = param[2][1],
		              directory_enabled = param[1];
		             return cont([0, directory_enabled, other_enabled]);
		            },
		            function(param, cont){
		             var other_enabled = param[2], directory_enabled = param[1];
		             return cont([0, directory_enabled, [0, other_enabled, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_directory_enabled, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$710[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$710[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$674 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$710, [0, schematic_cache$674]);
		               var
		                state_schema$11 =
		                  caml_callback
		                   (state_schema_versioned$32,
		                    [function(param, cont){return cont(0);}]);
		               function make$93(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (Other_enabled[10],
		                         init[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Directory_enabled[10],
		                                   init[1],
		                                   function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$32(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (Other_enabled[11],
		                         t[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Directory_enabled[11],
		                                   t[1],
		                                   function(b){return cont([0, b, a]);});
		                         });
		               }
		               function apply$55(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                if(0 === op[0]){
		                 var op$0 = op[1];
		                 return caml_trampoline_cps_call4
		                         (Directory_enabled[8],
		                          replica,
		                          state[1],
		                          op$0,
		                          function(match){
		                           var
		                            new_substate = match[3],
		                            delta = match[2],
		                            res = match[1];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    delta,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta){
		                                     var new_state = [0, new_substate, state[2]];
		                                     return cont([0, res, delta, new_state]);
		                                    });
		                          });
		                }
		                var op$1 = op[1];
		                return caml_trampoline_cps_call4
		                        (Other_enabled[8],
		                         replica,
		                         state[2],
		                         op$1,
		                         function(match){
		                          var
		                           new_substate = match[3],
		                           delta = match[2],
		                           res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   delta,
		                                   function(delta, cont){return cont([1, delta]);},
		                                   function(delta){
		                                    var new_state = [0, state[1], new_substate];
		                                    return cont([0, res, delta, new_state]);
		                                   });
		                         });
		               }
		               function apply_delta$51(replica, state, delta, cont){
		                if(0 === delta[0]){
		                 var delta$0 = delta[1];
		                 return caml_trampoline_cps_call4
		                         (Directory_enabled[9],
		                          replica,
		                          state[1],
		                          delta$0,
		                          function(new_substate){
		                           return cont([0, new_substate, state[2]]);
		                          });
		                }
		                var delta$1 = delta[1];
		                return caml_trampoline_cps_call4
		                        (Other_enabled[9],
		                         replica,
		                         state[2],
		                         delta$1,
		                         function(new_substate){
		                          return cont([0, state[1], new_substate]);
		                         });
		               }
		               var
		                include$196 =
		                  caml_callback
		                   (Apply$18,
		                    [[0, [0, schema_versioned$438], apply_delta$51, apply$55]]),
		                delta_schema_versioned$44 = include$196[1],
		                delta_schema$11 = include$196[2],
		                apply_delta$52 = include$196[3],
		                apply$56 = include$196[4];
		               function set_directory_enabled(directory_enabled, cont){
		                return caml_exact_trampoline_cps_call
		                        (Directory_enabled[12],
		                         directory_enabled,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$23, [0, a], cont);
		                         });
		               }
		               function set_other_enabled(other_enabled, cont){
		                return caml_exact_trampoline_cps_call
		                        (Other_enabled[12],
		                         other_enabled,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$23, [1, a], cont);
		                         });
		               }
		               function Make$40(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$9],
		                      state_schema_versioned$32,
		                      state_schema$11,
		                      delta_schema_versioned$44,
		                      delta_schema$11,
		                      [0, schema_versioned$309, schema$128],
		                      include$0,
		                      apply$56,
		                      apply_delta$52,
		                      make$93,
		                      view$32,
		                      equal$205]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$205,
		                    [0, const$9],
		                    state_schema_versioned$32,
		                    state_schema$11,
		                    delta_schema_versioned$44,
		                    delta_schema$11,
		                    [0, schema_versioned$309, schema$128],
		                    include$0,
		                    apply$56,
		                    apply_delta$52,
		                    make$93,
		                    view$32];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$116,
		                          schema$37,
		                          symbol$125,
		                          symbol$126,
		                          symbol$127,
		                          symbol$128,
		                          symbol$129,
		                          symbol$130,
		                          equal$58,
		                          compare$78,
		                          min$17,
		                          max$19,
		                          ascending$8,
		                          descending$8,
		                          between$9,
		                          clamp_exn$8,
		                          clamp$8,
		                          comparator$21,
		                          pp$43],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       Operation = include[2],
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       add = include[14],
		       element = include[15],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                Operation,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                ,
		                add,
		                element,
		                ,
		                ,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$197 = caml_callback(Make$40, [Ident]),
		                delta_schema_versioned$45 = include$197[5];
		               function schema_versioned$439(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$55,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aSQ, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$175 =
		                  caml_callback
		                   (schema_versioned$439,
		                    [function(param, cont){return cont();}]),
		                Self =
		                  caml_callback(A, [[0, schema_versioned$439, schema$175]]);
		               function schema_versioned$440(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                schema$272 =
		                  [0,
		                   0,
		                   0,
		                   schematic_param_name_schema_ve[3],
		                   schematic_param_name_schema_ve[4]],
		                Secret =
		                  caml_callback(A, [[0, schema_versioned$440, schema$272]]);
		               function schema_versioned$441(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$312,
		                                   schematic_version,
		                                   function(a){return cont([0, aSR, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$176 =
		                  caml_callback
		                   (schema_versioned$441,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$711 = [];
		               function compare$165(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$711[1], x, cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$711, [0, compare$124]);
		               var
		                sexp_of_t$133 = caml_callback(encode$7, [schema$176]),
		                j = caml_callback(A, [[0, schema_versioned$441, schema$176]]),
		                state_schema_versioned$33 = j[2],
		                delta_schema_versioned$46 = j[4],
		                Init$4 = j[6],
		                Monad$6 = j[7],
		                apply$57 = j[8],
		                apply_delta$53 = j[9],
		                make$94 = j[10],
		                view$33 = j[11],
		                include$198 = Make$2([0, compare$165, sexp_of_t$133]),
		                equal$235 = include$198[7],
		                Imports =
		                  caml_callback
		                   (bOC,
		                    [[0,
		                      Id$9[4],
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Id$9[24],
		                      Id$9[1]],
		                     [0,
		                      equal$235,
		                      ,
		                      state_schema_versioned$33,
		                      ,
		                      delta_schema_versioned$46,
		                      ,
		                      Init$4,
		                      Monad$6,
		                      apply$57,
		                      apply_delta$53,
		                      make$94,
		                      view$33]]);
		               function schema_versioned$442(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (people_schema_versioned$1,
		                                   schematic_version,
		                                   function(a){return cont([0, aSS, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$177 =
		                  caml_callback
		                   (schema_versioned$442,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$712 = [];
		               function compare$166(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$712[1], x, cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$712, [0, compare_people]);
		               var
		                sexp_of_t$134 = caml_callback(encode$7, [schema$177]),
		                j = caml_callback(A, [[0, schema_versioned$442, schema$177]]),
		                state_schema_versioned$34 = j[2],
		                delta_schema_versioned$47 = j[4],
		                Init$5 = j[6],
		                Monad$7 = j[7],
		                apply$58 = j[8],
		                apply_delta$54 = j[9],
		                make$95 = j[10],
		                view$34 = j[11],
		                include$199 = Make$2([0, compare$166, sexp_of_t$134]),
		                equal$236 = include$199[7],
		                People$0 =
		                  caml_callback
		                   (bOC,
		                    [[0, bPa, , , , , , , , , , , , , , , , , e, _2$3],
		                     [0,
		                      equal$236,
		                      ,
		                      state_schema_versioned$34,
		                      ,
		                      delta_schema_versioned$47,
		                      ,
		                      Init$5,
		                      Monad$7,
		                      apply$58,
		                      apply_delta$54,
		                      make$95,
		                      view$34]]);
		               function schema_versioned$443(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (database_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, aST, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$178 =
		                  caml_callback
		                   (schema_versioned$443,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$713 = [];
		               function compare$167(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$713[1], x, cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$713, [0, compare_database]);
		               var
		                sexp_of_t$135 = caml_callback(encode$7, [schema$178]),
		                e = caml_callback(A, [[0, schema_versioned$443, schema$178]]),
		                state_schema_versioned$35 = e[2],
		                delta_schema_versioned$48 = e[4],
		                Init$6 = e[6],
		                Monad$8 = e[7],
		                apply$59 = e[8],
		                apply_delta$55 = e[9],
		                make$96 = e[10],
		                view$35 = e[11],
		                include$200 = Make$2([0, compare$167, sexp_of_t$135]),
		                equal$237 = include$200[7],
		                Databases =
		                  caml_callback
		                   (bOC,
		                    [[0, du, , , , , , , , , , , , , , , , , b2, _3$2],
		                     [0,
		                      equal$237,
		                      ,
		                      state_schema_versioned$35,
		                      ,
		                      delta_schema_versioned$48,
		                      ,
		                      Init$6,
		                      Monad$8,
		                      apply$59,
		                      apply_delta$55,
		                      make$96,
		                      view$35]]);
		               function schema_versioned$444(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$174,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$176,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (b, a, function(a){return cont([0, aSU, 0, a[3], a[4]]);});
		     });
		                                   });
		                         });
		               }
		               var
		                schema$179 =
		                  caml_callback
		                   (schema_versioned$444,
		                    [function(param, cont){return cont(0);}]),
		                Status$1 =
		                  caml_callback(A, [[0, schema_versioned$444, schema$179]]),
		                include$201 = Monadic$0(),
		                v$24 = include$201[1],
		                all_unit$16 = include$201[12],
		                Apply$19 = include$201[14],
		                letrec_function_context$714 = [];
		               function state_schema_versioned$36(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$714[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSV, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$714[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$714[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$714[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Status$1[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_trampoline_cps_call2
		      (Databases[3],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_databases, 0, 2, [0, c], 0, 0], a];
		        return caml_trampoline_cps_call2
		                (People$0[3],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_people, 0, 2, [0, c], 0, 0], b];
		                  return caml_trampoline_cps_call2
		                          (Imports[3],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_imports, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Secret[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_secret, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (Self[2],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              status = d[2][1],
		              databases = d[1],
		              people = c[1],
		              imports = b[1],
		              secret = a[1],
		              self = param[1];
		             return cont
		                     ([0, self, secret, imports, people, databases, status]);
		            },
		            function(param, cont){
		             var
		              status = param[6],
		              databases = param[5],
		              people = param[4],
		              imports = param[3],
		              secret = param[2],
		              self = param[1];
		             return cont
		                     ([0,
		                       self,
		                       [0,
		                        secret,
		                        [0, imports, [0, people, [0, databases, [0, status, 0]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_self, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$714[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$714[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$675 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$714, [0, schematic_cache$675]);
		               caml_callback
		                (state_schema_versioned$36,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$715 = [];
		               function schema_versioned$445(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$715[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aSW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$715[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$715[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$715[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Status$1[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aSX,
		   cst_status,
		   cst_Status,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Databases[5],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aSY,
		             cst_databases,
		             "Databases",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_databases, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (People$0[5],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aSZ,
		                       cst_people,
		                       cst_People,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_people, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Imports[5],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aS0,
		                                 cst_imports,
		                                 "Imports",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_imports, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Secret[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aS1,
		   cst_secret,
		   "Secret",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_secret, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Self[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aS2,
		              cst_self,
		              cst_Self,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_self, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$715[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$715[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$676 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$715, [0, schematic_cache$676]);
		               caml_callback
		                (schema_versioned$445,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$446(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$174,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (schema_versioned$313,
		     schematic_version,
		     a,
		     function(a){return cont();});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$446,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$95(param, cont){return cont(0);}
		               caml_callback(schema_versioned$446, [schematic_version$95]);
		               function apply$60(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var op = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Self[8],
		                                      replica,
		                                      state[1],
		                                      op,
		                                      function(match){
		                                       var self = match[3], delta_o = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta_o){
		         return cont
		                 ([0,
		                   res,
		                   delta_o,
		                   [0, self, state[2], state[3], state[4], state[5], state[6]]]);
		        });
		                                      });
		                            case 1:
		                             var op$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Secret[8],
		                                      replica,
		                                      state[2],
		                                      op$0,
		                                      function(match){
		                                       var secret = match[3], delta_o = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta_o){
		         return cont
		                 ([0,
		                   res,
		                   delta_o,
		                   [0,
		                    state[1],
		                    secret,
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 2:
		                             var op$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Imports[9],
		                                      replica,
		                                      state[3],
		                                      op$1,
		                                      function(match){
		                                       var imports = match[3], delta_o = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta_o){
		         return cont
		                 ([0,
		                   res,
		                   delta_o,
		                   [0,
		                    state[1],
		                    state[2],
		                    imports,
		                    state[4],
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 3:
		                             var op$2 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (People$0[9],
		                                      replica,
		                                      state[4],
		                                      op$2,
		                                      function(match){
		                                       var people = match[3], delta_o = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([3, delta]);},
		        function(delta_o){
		         return cont
		                 ([0,
		                   res,
		                   delta_o,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    people,
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 4:
		                             var op$3 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Databases[9],
		                                      replica,
		                                      state[5],
		                                      op$3,
		                                      function(match){
		                                       var
		databases = match[3],
		delta_o = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([4, delta]);},
		        function(delta_o){
		         return cont
		                 ([0,
		                   res,
		                   delta_o,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    databases,
		                    state[6]]]);
		        });
		                                      });
		                            default:
		                             var op$4 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Status$1[8],
		                                      replica,
		                                      state[6],
		                                      op$4,
		                                      function(match){
		                                       var status = match[3], delta_o = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([5, delta]);},
		        function(delta_o){
		         return cont
		                 ([0,
		                   res,
		                   delta_o,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    status]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$56(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[6],
		                    b = state[5],
		                    c = state[4],
		                    d = state[3],
		                    e = state[2];
		                   return caml_trampoline_cps_call4
		                           (Self[9],
		                            replica,
		                            state[1],
		                            delta,
		                            function(f){return cont([0, f, e, d, c, b, a]);});
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    f = state[6],
		                    g = state[5],
		                    h = state[4],
		                    i = state[3];
		                   return caml_trampoline_cps_call4
		                           (Secret[9],
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){return cont([0, state[1], a, i, h, g, f]);});
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    j = state[6],
		                    k = state[5],
		                    l = state[4];
		                   return caml_trampoline_cps_call4
		                           (Imports[10],
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){
		                             return cont([0, state[1], state[2], a, l, k, j]);
		                            });
		                  case 3:
		                   var delta$2 = param[1], m = state[6], n = state[5];
		                   return caml_trampoline_cps_call4
		                           (People$0[10],
		                            replica,
		                            state[4],
		                            delta$2,
		                            function(a){
		                             return cont([0, state[1], state[2], state[3], a, n, m]);
		                            });
		                  case 4:
		                   var delta$3 = param[1], o = state[6];
		                   return caml_trampoline_cps_call4
		                           (Databases[10],
		                            replica,
		                            state[5],
		                            delta$3,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], a, o]);
		                            });
		                  default:
		                   var delta$4 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Status$1[9],
		                            replica,
		                            state[6],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], state[5], a]);
		                            });
		                }
		               }
		               var
		                include$202 =
		                  caml_callback
		                   (Apply$19,
		                    [[0, [0, schema_versioned$445], apply_delta$56, apply$60]]),
		                delta_schema_versioned$49 = include$202[1],
		                apply_delta$57 = include$202[3],
		                apply$61 = include$202[4],
		                include$203 =
		                  caml_callback(A, [[0, schema_versioned$243, schema$96]]),
		                Operation$7 = include$203[1],
		                state_schema_versioned$37 = include$203[2],
		                state_schema$12 = include$203[3],
		                delta_schema_versioned$50 = include$203[4],
		                delta_schema$12 = include$203[5],
		                Init$7 = include$203[6],
		                Monad$9 = include$203[7],
		                apply$62 = include$203[8],
		                apply_delta$58 = include$203[9],
		                make$97 = include$203[10],
		                view$36 = include$203[11];
		               function Make_nested(Context, cont){
		                var
		                 b =
		                   [0,
		                    equal$151,
		                    [0, Operation$7[12]],
		                    state_schema_versioned$37,
		                    state_schema$12,
		                    delta_schema_versioned$50,
		                    delta_schema$12,
		                    Init$7,
		                    Monad$9,
		                    apply$62,
		                    apply_delta$58,
		                    make$97,
		                    view$36],
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      Operation$7,
		                      state_schema_versioned$37,
		                      state_schema$12,
		                      delta_schema_versioned$50,
		                      delta_schema$12,
		                      Init$7,
		                      Monad$9,
		                      apply$62,
		                      apply_delta$58,
		                      make$97,
		                      view$36,
		                      equal$151]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$245,
		                          schema$97,
		                          symbol$163,
		                          symbol$164,
		                          symbol$165,
		                          symbol$166,
		                          symbol$167,
		                          symbol$168,
		                          equal$152,
		                          compare$113,
		                          min$23,
		                          max$25,
		                          ascending$14,
		                          descending$14,
		                          between$15,
		                          clamp_exn$14,
		                          clamp$14,
		                          comparator$32,
		                          pp$84],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(Enabled_data_collections){
		      return cont([0, Enabled_data_collections]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$204 = caml_callback(Make_nested, [Ident]),
		                Enabled_data_collections = include$204[1],
		                include$205 = Monadic$0(),
		                v$25 = include$205[1],
		                ignore_m$7 = include$205[10],
		                Apply$20 = include$205[14],
		                letrec_function_context$716 = [];
		               function schema_versioned$447(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$716[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aS3, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$716[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$716[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$716[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Enabled_data_collections[5],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    aS4,
		    cst_enabled_data_collections,
		    "Enabled_data_collections",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var delta = param[1];
		       return cont(delta);
		      },
		      function(delta, cont){return cont([0, delta, 0]);},
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_enabled_data_collections,
		        0,
		        2,
		        [0, a],
		        0,
		        0],
		       0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$716[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$716[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$677 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$716, [0, schematic_cache$677]);
		               caml_callback
		                (schema_versioned$447,
		                 [function(param, cont){return cont(0);}]);
		               var Delta$0 = [0, schema_versioned$447];
		               function Make$41(Context, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_nested,
		                         Context,
		                         function(include){
		                          var
		                           Enabled_data_collections = include[1],
		                           letrec_function_context = [];
		                          function schema_versioned(schematic_version, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (schematic_version,
		                                    V$4,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       function a(descriptor){return cont([0, , , descriptor, 0]);}
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return caml_trampoline_cps_call2
		       (Enabled_data_collections[3],
		        schematic_version,
		        function(a){
		         var
		          res =
		            [7,
		             function(param, cont){
		              var enabled_data_collections = param[1];
		              return cont([0, enabled_data_collections]);
		             },
		             function(param, cont){
		              var enabled_data_collections = param[1];
		              return cont([0, enabled_data_collections, 0]);
		             },
		             [0,
		              [0,
		               aS5,
		               0,
		               0,
		               0,
		               cst_enabled_data_collections,
		               0,
		               2,
		               [0, a],
		               0,
		               0],
		              0]];
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  res,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   return cont(res);
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 a);
		       var schema = match[1];
		       return a(schema);
		      });
		                                    });
		                          }
		                          var schematic_cache = [0, empty$11([0, comparator$9])];
		                          caml_update_dummy
		                           (letrec_function_context, [0, schematic_cache]);
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(schema){
		                                    function state_schema_versioned(schematic_version, cont){
		                                     return caml_exact_trampoline_cps_call
		     (schematic_version,
		      V$4,
		      function(schematic_schema_version){
		       return caml_exact_trampoline_cps_call
		               (schema_versioned,
		                schematic_version,
		                function(a){return cont([0, aS6, 0, a[3], a[4]]);});
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (state_schema_versioned,
		     function(param, cont){return cont(0);},
		     function(state_schema){
		      function apply(replica, state, cont){
		       var
		        a =
		          g
		            ([0,
		              symbol_bind$5,
		              symbol_map$5,
		              ,
		              bind$8,
		              return$9,
		              map$17,
		              ,
		              ,
		              ,
		              ,
		              Let_syntax$3])
		           [4];
		       return cont
		               (function(param, cont){
		                 var op = param[1];
		                 return caml_trampoline_cps_call4
		                         (Enabled_data_collections[9],
		                          replica,
		                          state[1],
		                          op,
		                          function(match){
		                           var
		                            enabled_data_collections = match[3],
		                            delta_o = match[2],
		                            res = match[1];
		                           return caml_trampoline_cps_call3
		                                   (a,
		                                    delta_o,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta_o){
		                                     return cont
		     ([0, res, delta_o, [0, enabled_data_collections]]);
		                                    });
		                          });
		                });
		      }
		      function apply_delta(replica, state, param, cont){
		       var delta = param[1];
		       return caml_trampoline_cps_call4
		               (Enabled_data_collections[10],
		                replica,
		                state[1],
		                delta,
		                function(a){return cont([0, a]);});
		      }
		      var init = [0, empty$27];
		      return caml_exact_trampoline_cps_call
		              (Apply$20,
		               [0, Delta$0, apply_delta, apply],
		               function(include){
		                var
		                 delta_schema_versioned = include[1],
		                 apply_delta = include[3],
		                 apply = include[4];
		                function view(state, cont){
		                 var
		                  a = Context[1],
		                  open = g([0, a[1], a[2], , a[4], a[5], a[6], , , , , a[11]]),
		                  let$ = open[4];
		                 function b(enabled_data_collections, cont){
		                  return cont([0, enabled_data_collections]);
		                 }
		                 return caml_trampoline_cps_call2
		                         (Enabled_data_collections[12],
		                          state[1],
		                          function(a){
		                           return caml_trampoline_cps_call3(let$, a, b, cont);
		                          });
		                }
		                function make(init, cont){
		                 return caml_trampoline_cps_call2
		                         (Enabled_data_collections[11],
		                          init[1],
		                          function(a){return cont([0, a]);});
		                }
		                return cont
		                        ([0,
		                          Enabled_data_collections,
		                          ,
		                          ,
		                          state_schema_versioned,
		                          ,
		                          ,
		                          init,
		                          delta_schema_versioned,
		                          ,
		                          apply_delta,
		                          apply,
		                          view,
		                          make]);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                include$206 = caml_callback(Make$41, [Ident]),
		                Enabled_data_collections$0 = include$206[1],
		                delta_schema_versioned$51 = include$206[8];
		               function enabled_data_collections(op, cont){
		                return caml_exact_trampoline_cps_call(v$25, [0, op], cont);
		               }
		               var letrec_function_context$717 = [];
		               function schema_versioned$448(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$717[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aS7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$717[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$717[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$717[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aS9,
		                                 cst_integration_app,
		                                 cst_Integration_app,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0,
		                                     aS8,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_integration_app$0,
		                                     0,
		                                     2,
		                                     [0, no_input_schema],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$49,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aS_,
		   cst_notion,
		   cst_Notion,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_notion, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$45,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aS$,
		              cst_google,
		              cst_Google,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_google, 0, 2, [0, a], 0, 0], 0]],
		               0],
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$717[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$717[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$678 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$717, [0, schematic_cache$678]);
		               caml_callback
		                (schema_versioned$448,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$449(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_google_schema_, cont){
		                                    function descriptor(schematic_param_google_schema_, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  function(f0, cont){return cont([2, f0]);},
		  function(param, cont){
		   if(2 !== param[0]) return cont(0);
		   var f0 = param[1];
		   return cont([0, f0]);
		  },
		  1,
		  0,
		  cst_integration_app,
		  cst_Integration_app,
		  [0,
		   0,
		   0,
		   [7,
		    function(param, cont){
		     var integration_app = param[1];
		     return cont(integration_app);
		    },
		    function(integration_app, cont){
		     return cont([0, integration_app, 0]);
		    },
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_integration_app,
		      0,
		      3,
		      [0, no_input_schema],
		      0,
		      0],
		     0]],
		   0],
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (state_schema_versioned$36,
		      schematic_version,
		      function(b){
		       return cont
		               ([11,
		                 0,
		                 [0,
		                  [0,
		                   function(f0, cont){return cont([0, f0]);},
		                   function(param, cont){
		                    if(0 !== param[0]) return cont(0);
		                    var f0 = param[1];
		                    return cont([0, f0]);
		                   },
		                   1,
		                   0,
		                   cst_google,
		                   cst_Google,
		                   [0,
		                    0,
		                    0,
		                    [7,
		                     function(param, cont){
		                      var google = param[1];
		                      return cont(google);
		                     },
		                     function(google, cont){return cont([0, google, 0]);},
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_google,
		                       0,
		                       2,
		                       [0, schematic_param_google_schema_],
		                       0,
		                       0],
		                      0]],
		                    0],
		                   0],
		                  [0,
		                   [0,
		                    function(f0, cont){return cont([1, f0]);},
		                    function(param, cont){
		                     if(1 !== param[0]) return cont(0);
		                     var f0 = param[1];
		                     return cont([0, f0]);
		                    },
		                    1,
		                    0,
		                    cst_notion,
		                    cst_Notion,
		                    [0,
		                     0,
		                     0,
		                     [7,
		                      function(param, cont){
		                       var notion = param[1];
		                       return cont(notion);
		                      },
		                      function(notion, cont){return cont([0, notion, 0]);},
		                      [0, [0, 0, 0, 0, 0, cst_notion, 0, 2, [0, b], 0, 0], 0]],
		                     0],
		                    0],
		                   a]],
		                 0]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$222[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_google,
		 schematic_param_google_schema_,
		 function(schematic_param_google_schema_, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_google_schema_,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_google_schema_,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                include$207 = Monadic$0(),
		                v$26 = include$207[1],
		                const$10 = include$207[2],
		                return$34 = include$207[7],
		                Apply$21 = include$207[14],
		                letrec_function_context$718 = [];
		               function equal$238(lhs, rhs, cont){
		                switch(lhs[0]){
		                  case 0:
		                   var lhs0 = lhs[1];
		                   if(0 === rhs[0]){
		                    var rhs0 = rhs[1];
		                    return caml_trampoline_cps_call3
		                            (letrec_function_context$718[4], lhs0, rhs0, cont);
		                   }
		                   break;
		                  case 1:
		                   var lhs0$0 = lhs[1];
		                   if(1 === rhs[0]){
		                    var rhs0$0 = rhs[1];
		                    return caml_trampoline_cps_call2
		                            (letrec_function_context$718[2],
		                             letrec_function_context$718[3],
		                             function(a){
		                              return caml_trampoline_cps_call3(a, lhs0$0, rhs0$0, cont);
		                             });
		                   }
		                   break;
		                  default:
		                   var lhsignored = lhs[1];
		                   if(2 === rhs[0]){
		                    var rhsignored = rhs[1];
		                    if(lhsignored){
		                     if(rhsignored){
		                      var b = rhsignored[1], a = lhsignored[1];
		                      return caml_trampoline_cps_call3
		                              (letrec_function_context$718[1], a, b, cont);
		                     }
		                    }
		                    else if(! rhsignored) return cont(1);
		                    return cont(0);
		                   }
		                }
		                return cont(0);
		               }
		               caml_update_dummy
		                (letrec_function_context$718,
		                 [0, equal$15, equal$212, equal$101, equal$206]);
		               var letrec_function_context$719 = [];
		               function schema_versioned$450(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$719[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTa, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$719[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$719[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$719[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_integration_app,
		                                 cst_Integration_app,
		                                 [0,
		                                  0,
		                                  aTb,
		                                  [7,
		                                   function(param, cont){
		                                    var ignored = param[1];
		                                    return cont(ignored);
		                                   },
		                                   function(ignored, cont){return cont([0, ignored, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_ignored,
		                                     0,
		                                     3,
		                                     [0, no_input_schema],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$174,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (schema_versioned$313,
		       schematic_version,
		       b,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_notion,
		             cst_Notion,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$310,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      aTc,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        cst_google,
		                        cst_Google,
		                        a,
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$719[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$719[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$679 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$719, [0, schematic_cache$679]);
		               var
		                schema$180 =
		                  caml_callback
		                   (schema_versioned$450,
		                    [function(param, cont){return cont(0);}]),
		                Delta$1 = [0, schema_versioned$448];
		               function Make$42(Context, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make$40,
		                         Context,
		                         function(Google){
		                          var Monad = Context[1];
		                          function state_schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$4,
		                                    function(schematic_schema_version){
		                                     return caml_trampoline_cps_call2
		     (Google[3],
		      schematic_version,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$449,
		                schematic_version,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (b, a, function(a){return cont([0, aTd, 0, a[3], a[4]]);});
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (state_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(state_schema){
		                                    var letrec_function_context = [];
		                                    function equal(x, cont){
		                                     return caml_trampoline_cps_call2
		     (letrec_function_context[1], x, cont);
		                                    }
		                                    caml_update_dummy(letrec_function_context, [0, equal$238]);
		                                    function apply(replica, state, operation, cont){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$5,
		   symbol_map$5,
		   ,
		   bind$8,
		   return$9,
		   map$17,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$3]),
		                                      let$ = open[4];
		                                     if(0 === operation[0]){
		                                      var op = operation[1];
		                                      if(0 !== state[0])
		                                       return caml_exact_trampoline_cps_call
		       (err$1,
		        function(m, cont){
		         return caml_trampoline_cps_call4(m, 0, 0, aTe, cont);
		        },
		        function(match){return cont([0, 0, 0, state]);});
		                                      var google = state[1];
		                                      return caml_trampoline_cps_call4
		      (Google[9],
		       replica,
		       google,
		       op,
		       function(match){
		        var google = match[3], delta_o = match[2], res = match[1];
		        return caml_trampoline_cps_call3
		                (let$,
		                 delta_o,
		                 function(delta, cont){return cont([0, delta]);},
		                 function(delta_o){
		                  return cont([0, [0, res], delta_o, [0, google]]);
		                 });
		       });
		                                     }
		                                     var op$0 = operation[1];
		                                     if(1 !== state[0])
		                                      return caml_exact_trampoline_cps_call
		      (err$1,
		       function(m, cont){
		        return caml_trampoline_cps_call4(m, 0, 0, aTf, cont);
		       },
		       function(match){return cont([0, 0, 0, state]);});
		                                     var notion = state[1];
		                                     return caml_trampoline_cps_call4
		     (apply$61,
		      replica,
		      notion,
		      op$0,
		      function(match){
		       var notion = match[3], delta_o = match[2], res = match[1];
		       return caml_trampoline_cps_call3
		               (let$,
		                delta_o,
		                function(delta, cont){return cont([1, delta]);},
		                function(delta_o){
		                 return cont([0, [0, res], delta_o, [1, notion]]);
		                });
		      });
		                                    }
		                                    function apply_delta(replica, state, delta, cont){
		                                     switch(delta[0]){
		                                       case 0:
		var delta$0 = delta[1];
		if(0 === state[0]){
		 var google = state[1];
		 return caml_trampoline_cps_call4
		         (Google[10],
		          replica,
		          google,
		          delta$0,
		          function(a){return cont([0, a]);});
		}
		break;
		                                       case 1:
		var delta$1 = delta[1];
		if(1 === state[0]){
		 var notion = state[1];
		 return caml_trampoline_cps_call4
		         (apply_delta$57,
		          replica,
		          notion,
		          delta$1,
		          function(a){return cont([1, a]);});
		}
		break;
		                                       default: return cont(state);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (err$1,
		      function(m, cont){
		       return caml_trampoline_cps_call4(m, 0, 0, aTg, cont);
		      },
		      function(match){return cont(state);});
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (Apply$21,
		     [0, Delta$1, apply_delta, apply],
		     function(include){
		      var
		       delta_schema_versioned = include[1],
		       delta_schema = include[2],
		       apply_delta = include[3],
		       apply = include[4];
		      function view(state, cont){
		       var
		        a = Context[1],
		        open = g([0, a[1], a[2], , a[4], a[5], a[6], , , , , a[11]]),
		        let$ = open[4];
		       switch(state[0]){
		         case 0:
		          var
		           google = state[1],
		           b =
		             function(accounts, cont){return cont([0, [0, accounts]]);};
		          return caml_trampoline_cps_call2
		                  (Google[12],
		                   google,
		                   function(a){
		                    return caml_trampoline_cps_call3(let$, a, b, cont);
		                   });
		         case 1:
		          var notion = state[1];
		          return caml_exact_trampoline_cps_call
		                  (Status$1[11],
		                   notion[6],
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (Databases[12],
		                             notion[5],
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (People$0[12],
		                                       notion[4],
		                                       function(c){
		return caml_trampoline_cps_call2
		        (Imports[12],
		         notion[3],
		         function(d){
		          return caml_exact_trampoline_cps_call
		                  (Secret[11],
		                   notion[2],
		                   function(e){
		                    return caml_exact_trampoline_cps_call
		                            (Self[11],
		                             notion[1],
		                             function(f){
		                              return caml_trampoline_cps_call2
		                                      (Context[1][5], [1, [0, f, e, d, c, b, a]], cont);
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         default:
		          var integration_app = state[1];
		          return caml_trampoline_cps_call2
		                  (Context[1][5], [2, integration_app], cont);
		       }
		      }
		      function make(param, cont){
		       switch(param[0]){
		         case 0:
		          var accounts = param[1][1];
		          return caml_trampoline_cps_call2
		                  (Google[11], accounts, function(a){return cont([0, a]);});
		         case 1:
		          var notion = param[1];
		          return caml_exact_trampoline_cps_call
		                  (Status$1[10],
		                   notion[6],
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (Databases[11],
		                             notion[5],
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (People$0[11],
		                                       notion[4],
		                                       function(c){
		return caml_trampoline_cps_call2
		        (Imports[11],
		         notion[3],
		         function(d){
		          return caml_exact_trampoline_cps_call
		                  (Secret[10],
		                   notion[2],
		                   function(e){
		                    return caml_exact_trampoline_cps_call
		                            (Self[10],
		                             notion[1],
		                             function(f){return cont([1, [0, f, e, d, c, b, a]]);});
		                   });
		         });
		                                       });
		                             });
		                   });
		         default: var ignored = param[1]; return cont([2, ignored]);
		       }
		      }
		      function update_notion(previous, config, cont){
		       var
		        status = config[6],
		        databases = config[5],
		        people = config[4],
		        imports = config[3],
		        secret = config[2],
		        self = config[1],
		        previous_status = previous[6],
		        previous_databases = previous[5],
		        previous_people = previous[4],
		        previous_imports = previous[3],
		        previous_secret = previous[2],
		        previous_self = previous[1];
		       a:
		       {
		        if(previous_self){
		         if(self){
		          var x = self[1], x$0 = previous_self[1], a = x$0 === x;
		          break a;
		         }
		        }
		        else if(! self){a = 1; break a;}
		        a = 0;
		       }
		       function b(self){
		        function a(secret){
		         return caml_exact_trampoline_cps_call$0
		                 (equal$211,
		                  equal$235,
		                  previous_imports,
		                  imports,
		                  function(b){
		                   function a(imports){
		                    return caml_exact_trampoline_cps_call$0
		                            (equal$207,
		                             equal_people,
		                             previous_people,
		                             people,
		                             function(b){
		                              function a(people){
		                               return caml_exact_trampoline_cps_call$0
		                                       (equal$208,
		equal_database,
		previous_databases,
		databases,
		function(b){
		 function a(databases){
		  return caml_exact_trampoline_cps_call$0
		          (equal$102,
		           equal$101,
		           previous_status,
		           status,
		           function(b){
		            function a(status){
		             return caml_exact_trampoline_cps_call
		                     (filter_opt,
		                      [0,
		                       self,
		                       [0,
		                        secret,
		                        [0, imports, [0, people, [0, databases, [0, status, 0]]]]]],
		                      function(a){
		                       return caml_trampoline_cps_call3
		                               (map$18,
		                                a,
		                                v$24,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call
		 (all_unit$16,
		  a,
		  function(a){
		   return caml_exact_trampoline_cps_call(v$26, [1, a], cont);
		  });
		                                });
		                      });
		            }
		            return b
		                    ? a(0)
		                    : caml_exact_trampoline_cps_call
		                      (Status$1[12], status, function(b){return a([0, [5, b]]);});
		           });
		 }
		 return b
		         ? a(0)
		         : caml_trampoline_cps_call3
		           (Databases[21],
		            previous_databases,
		            databases,
		            function(b){return a([0, [4, b]]);});
		});
		                              }
		                              return b
		                                      ? a(0)
		                                      : caml_trampoline_cps_call3
		(People$0[21],
		 previous_people,
		 people,
		 function(b){return a([0, [3, b]]);});
		                             });
		                   }
		                   return b
		                           ? a(0)
		                           : caml_trampoline_cps_call3
		                             (Imports[21],
		                              previous_imports,
		                              imports,
		                              function(b){return a([0, [2, b]]);});
		                  });
		        }
		        return previous_secret === secret
		                ? a(0)
		                : caml_exact_trampoline_cps_call
		                  (Secret[12], secret, function(b){return a([0, [1, b]]);});
		       }
		       return a
		               ? b(0)
		               : caml_exact_trampoline_cps_call
		                 (Self[12], self, function(a){return b([0, [0, a]]);});
		      }
		      function update_google(previous, config, cont){
		       return caml_exact_trampoline_cps_call$0
		               (symmetric_diff$2,
		                previous[1],
		                config[1],
		                equal$205,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (map$11,
		                          a,
		                          function(param, cont){
		                           var a = param[2], variant = a[1], account = param[1];
		                           if(847852583 === variant)
		                            return caml_trampoline_cps_call2(Google[18], account, cont);
		                           if(1013247643 <= variant){
		                            a = a[2][2];
		                            var other_enabled = a[2], directory_enabled = a[1];
		                            return caml_exact_trampoline_cps_call
		                                    (set_other_enabled,
		                                     other_enabled,
		                                     function(b){
		                                      var a = [0, b, 0];
		                                      return caml_exact_trampoline_cps_call
		      (set_directory_enabled,
		       directory_enabled,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (all_unit$15,
		                 [0, b, a],
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (Google[15],
		                           account,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(Google[2][11], a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           var config = a[2];
		                           return caml_trampoline_cps_call3
		                                   (Google[14], account, config, cont);
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_binable,
		                                    a,
		                                    function(operations){
		                                     return operations
		     ? caml_trampoline_cps_call2
		       (Google[2][13],
		        operations,
		        function(a){
		         return caml_exact_trampoline_cps_call(v$26, [0, a], cont);
		        })
		     : caml_trampoline_cps_call2(return$34, aTh, cont);
		                                    });
		                          });
		                });
		      }
		      function update(previous, config, cont){
		       if(0 === previous[0]){
		        var previous$0 = previous[1];
		        if(0 === config[0]){
		         var config$0 = config[1];
		         return caml_exact_trampoline_cps_call$1
		                 (update_google, previous$0, config$0, cont);
		        }
		       }
		       else {
		        var previous$1 = previous[1];
		        if(0 !== config[0]){
		         var config$1 = config[1];
		         return caml_exact_trampoline_cps_call$1
		                 (update_notion, previous$1, config$1, cont);
		        }
		       }
		       return caml_exact_trampoline_cps_call
		               (err$1,
		                function(m, cont){
		                 return caml_trampoline_cps_call8
		                         (m,
		                          0,
		                          0,
		                          aTi,
		                          function(a, b, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (_14, _13$1, a, b, cont);
		                          },
		                          previous,
		                          function(a, b, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (_14, _13$1, a, b, cont);
		                          },
		                          config,
		                          cont);
		                },
		                function(match){
		                 return caml_trampoline_cps_call2(return$34, 0, cont);
		                });
		      }
		      return cont
		              ([0,
		                ,
		                Monad,
		                state_schema_versioned,
		                state_schema,
		                equal,
		                delta_schema_versioned,
		                delta_schema,
		                apply_delta,
		                apply,
		                view,
		                make,
		                ,
		                ,
		                ,
		                ,
		                update]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$208 = caml_callback(Make$42, [Ident]),
		                Monad$10 = include$208[2],
		                state_schema_versioned$38 = include$208[3],
		                state_schema$13 = include$208[4],
		                equal$239 = include$208[5],
		                delta_schema_versioned$52 = include$208[6],
		                delta_schema$13 = include$208[7],
		                apply_delta$59 = include$208[8],
		                apply$63 = include$208[9],
		                view$37 = include$208[10],
		                make$98 = include$208[11],
		                update$3 = include$208[16];
		               function Make$43(Context, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make$42,
		                         Context,
		                         function(Legacy_integration_config){
		                          var
		                           a = Legacy_integration_config[2],
		                           b =
		                             [0,
		                              equal$239,
		                              [0, const$10],
		                              state_schema_versioned$38,
		                              state_schema$13,
		                              delta_schema_versioned$52,
		                              delta_schema$13,
		                              [0, schema_versioned$450, schema$180],
		                              [0,
		                               Monad$10[1],
		                               Monad$10[2],
		                               Monad$10[3],
		                               Monad$10[4],
		                               Monad$10[5],
		                               Monad$10[6],
		                               Monad$10[7],
		                               Monad$10[8],
		                               Monad$10[9],
		                               Monad$10[10],
		                               Monad$10[11]],
		                              apply$63,
		                              apply_delta$59,
		                              make$98,
		                              view$37],
		                           c =
		                             [0,
		                              Legacy_integration_config[5],
		                              [0, const$10],
		                              Legacy_integration_config[3],
		                              Legacy_integration_config[4],
		                              Legacy_integration_config[6],
		                              Legacy_integration_config[7],
		                              [0, schema_versioned$450, schema$180],
		                              [0,
		                               a[1],
		                               a[2],
		                               a[3],
		                               a[4],
		                               a[5],
		                               a[6],
		                               a[7],
		                               a[8],
		                               a[9],
		                               a[10],
		                               a[11]],
		                              Legacy_integration_config[9],
		                              Legacy_integration_config[8],
		                              Legacy_integration_config[11],
		                              Legacy_integration_config[10]];
		                          return caml_trampoline_cps_call2
		                                  (Context[5],
		                                   [0,
		                                    schema_versioned$173,
		                                    schema$265,
		                                    symbol$143,
		                                    symbol$144,
		                                    symbol$145,
		                                    symbol$146,
		                                    symbol$147,
		                                    symbol$148,
		                                    equal$100,
		                                    compare$102,
		                                    min$20,
		                                    max$22,
		                                    ascending$11,
		                                    descending$11,
		                                    between$12,
		                                    clamp_exn$11,
		                                    clamp$11,
		                                    comparator$26,
		                                    pp$65],
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     c,
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               b,
		               function(Legacy){
		                function view(input, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (By$10[43],
		                          input,
		                          function(param, cont){
		                           switch(param[0]){
		                             case 0:
		                              var conf = param[1]; return cont([0, [0, conf]]);
		                             case 1:
		                              var conf$0 = param[1]; return cont([0, [1, conf$0]]);
		                             default: return cont(0);
		                           }
		                          },
		                          cont);
		                }
		                var
		                 include =
		                   Make$24
		                    ([0,
		                      [0, , , , , , , , Legacy[2][11]],
		                      Legacy[3],
		                      ,
		                      Legacy[5],
		                      ,
		                      ,
		                      Legacy[8],
		                      Legacy[9],
		                      Legacy[10],
		                      Legacy[11],
		                      Legacy[12]],
		                     [0, view]),
		                 Operation = include[1],
		                 state_schema_versioned = include[2],
		                 delta_schema_versioned = include[4],
		                 apply = include[8],
		                 apply_delta = include[9],
		                 make = include[10],
		                 view$0 = include[11];
		                return cont
		                        ([0,
		                          ,
		                          Legacy,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Operation,
		                          state_schema_versioned,
		                          ,
		                          delta_schema_versioned,
		                          ,
		                          ,
		                          ,
		                          apply,
		                          apply_delta,
		                          make,
		                          view$0]);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                include$209 = caml_callback(Make$43, [Ident]),
		                Legacy = include$209[2],
		                Operation$8 = include$209[13],
		                delta_schema_versioned$53 = include$209[16],
		                element$7 = Legacy[15],
		                remove$11 = Legacy[18],
		                letrec_function_context$720 = [];
		               function t_with_old_agent_schema_versio
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$720[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTj, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$720[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$720[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$720[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aTl,
		                                     aTk,
		                                     0,
		                                     26,
		                                     1,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$105,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_agent,
		             cst_Agent,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var object_id = param[1];
		                return cont(object_id);
		               },
		               function(object_id, cont){return cont([0, object_id, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_object_id$0, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aTn,
		                 aTm,
		                 0,
		                 26,
		                 1,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_exact_trampoline_cps_call
		                          (Table[4],
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, d], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(e){
		                                      var
		                                       d =
		 [0,
		  [0,
		   function(param, cont){
		    var f1 = param[2], f0 = param[1];
		    return cont([3, f0, f1]);
		   },
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f1 = param[2], f0 = param[1];
		    return cont([0, [0, f0, f1]]);
		   },
		   1,
		   0,
		   cst_database,
		   cst_Database,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var table_id = param[2][1], workspace_id = param[1];
		      return cont([0, workspace_id, table_id]);
		     },
		     function(param, cont){
		      var table_id = param[2], workspace_id = param[1];
		      return cont([0, workspace_id, [0, table_id, 0]]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, e], 0, 0],
		      c]],
		    0],
		   a],
		  b];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aTp,
		       aTo,
		       0,
		       25,
		       6,
		       function(b){
		        var a = [0, [0, b, V$4]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$104,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_organization_homepage,
		                       cst_Organization_homepage,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var value = param[1];
		                          return cont(value);
		                         },
		                         function(value, cont){return cont([0, value, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       a],
		                      d];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$316,
		                           schematic_version,
		                           function(c){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0,
		   function(param, cont){
		    var f1 = param[2], f0 = param[1];
		    return cont([1, f0, f1]);
		   },
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f1 = param[2], f0 = param[1];
		    return cont([0, [0, f0, f1]]);
		   },
		   1,
		   0,
		   cst_app_screen,
		   cst_App_screen,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var value = param[2][1], organization = param[1];
		      return cont([0, organization, value]);
		     },
		     function(param, cont){
		      var value = param[2], organization = param[1];
		      return cont([0, organization, [0, value, 0]]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_organization, 0, 3, [0, d], 0, 0],
		      a]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$131,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            aTq,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              cst_object,
		              cst_Object,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var value = param[1];
		                 return cont(value);
		                },
		                function(value, cont){return cont([0, value, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, a], 0, 0], 0]],
		               0],
		              0],
		             c],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$720[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$720[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$680 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$720, [0, schematic_cache$680]);
		               caml_callback
		                (t_with_old_agent_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$721 = [];
		               function target_compat_schema_versioned
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$721[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, 0, 0, descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$721[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$721[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$721[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (t_with_old_agent_schema_versio,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   "old",
		   "Old",
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$317,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_new,
		              cst_New,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$721[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$721[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$681 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$721, [0, schematic_cache$681]);
		               caml_callback
		                (target_compat_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$451(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (target_compat_schema_versioned,
		                         v,
		                         function(a){
		                          return cont
		                                  (map$14
		                                    (function(a, cont){
		                                      if(0 === a[0]){var x = a[1]; return cont([0, x]);}
		                                      var x$0 = a[1];
		                                      switch(x$0[0]){
		case 0:
		 var value = x$0[1], a = [0, value]; break;
		case 1:
		 var
		  value$0 = x$0[2],
		  organization = x$0[1],
		  a = [1, organization, value$0];
		 break;
		case 2:
		 var value$1 = x$0[1], a = [2, value$1]; break;
		case 3:
		 var
		  table_id = x$0[2],
		  workspace_id = x$0[1],
		  a = [3, workspace_id, table_id];
		 break;
		default: var object_id = x$0[1], a = [0, [6, object_id]];
		                                      }
		                                      return cont([0, a]);
		                                     },
		                                     function(x, cont){return cont([0, x]);},
		                                     a));
		                         });
		               }
		               caml_callback
		                (schema_versioned$451,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$210 = caml_callback(b8, [[0, schema_versioned$451]]),
		                state_schema_versioned$39 = include$210[2],
		                delta_schema_versioned$54 = include$210[4],
		                apply$64 = include$210[8],
		                apply_delta$60 = include$210[9],
		                make$99 = include$210[10],
		                view$38 = include$210[11],
		                letrec_function_context$722 = [];
		               function schema_versioned$452(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$722[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$722[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$722[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$722[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_home, 0, 2, [0, bool_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$451,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var home = param[2][1], target = param[1];
		   return cont([0, target, home]);
		  },
		  function(param, cont){
		   var home = param[2], target = param[1];
		   return cont([0, target, [0, home, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$722[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$722[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$682 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$722, [0, schematic_cache$682]);
		               caml_callback
		                (schema_versioned$452,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$723 = [];
		               function schema_versioned$453(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$723[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$723[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$723[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$723[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (include$139[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aTt,
		   cst_home,
		   cst_Home,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_home, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (delta_schema_versioned$54,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aTu,
		              cst_target,
		              "Target",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$723[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$723[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$683 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$723, [0, schematic_cache$683]);
		               caml_callback
		                (schema_versioned$453,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$211 = Monadic$0(),
		                Apply$22 = include$211[14],
		                letrec_function_context$724 = [];
		               function state_schema_versioned$40(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$724[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTv, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$724[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$724[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$724[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$139[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_home, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$39,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var home = param[2][1], target = param[1];
		             return cont([0, target, home]);
		            },
		            function(param, cont){
		             var home = param[2], target = param[1];
		             return cont([0, target, [0, home, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$724[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$724[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$684 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$724, [0, schematic_cache$684]);
		               caml_callback
		                (state_schema_versioned$40,
		                 [function(param, cont){return cont(0);}]);
		               function make$100(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[10],
		                         init[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (make$99, init[1], function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$39(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[11],
		                         t[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (view$38, t[1], function(b){return cont([0, b, a]);});
		                         });
		               }
		               function apply$65(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                if(0 === op[0])
		                 return caml_exact_trampoline_cps_call$0
		                         (apply$64,
		                          replica,
		                          dummy,
		                          dummy,
		                          function(match){
		                           var
		                            new_substate = match[3],
		                            delta = match[2],
		                            res = match[1];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    delta,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta){
		                                     var new_state = [0, new_substate, state[2]];
		                                     return cont([0, res, delta, new_state]);
		                                    });
		                          });
		                var op$0 = op[1];
		                return caml_trampoline_cps_call4
		                        (include$139[8],
		                         replica,
		                         state[2],
		                         op$0,
		                         function(match){
		                          var
		                           new_substate = match[3],
		                           delta = match[2],
		                           res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   delta,
		                                   function(delta, cont){return cont([1, delta]);},
		                                   function(delta){
		                                    var new_state = [0, state[1], new_substate];
		                                    return cont([0, res, delta, new_state]);
		                                   });
		                         });
		               }
		               function apply_delta$61(replica, state, delta, cont){
		                if(0 === delta[0])
		                 return caml_exact_trampoline_cps_call$0
		                         (apply_delta$60,
		                          replica,
		                          dummy,
		                          dummy,
		                          function(new_substate){
		                           return cont([0, new_substate, state[2]]);
		                          });
		                var delta$0 = delta[1];
		                return caml_trampoline_cps_call4
		                        (include$139[9],
		                         replica,
		                         state[2],
		                         delta$0,
		                         function(new_substate){
		                          return cont([0, state[1], new_substate]);
		                         });
		               }
		               var
		                include$212 =
		                  caml_callback
		                   (Apply$22,
		                    [[0, [0, schema_versioned$453], apply_delta$61, apply$65]]),
		                delta_schema_versioned$55 = include$212[1],
		                apply_delta$62 = include$212[3],
		                apply$66 = include$212[4],
		                Menu_items_crdt =
		                  caml_callback
		                   (Fugue_diffable,
		                    [[0,
		                      equal$214,
		                      ,
		                      state_schema_versioned$40,
		                      ,
		                      delta_schema_versioned$55,
		                      ,
		                      [0, schema_versioned$452],
		                      include$0,
		                      apply$66,
		                      apply_delta$62,
		                      make$100,
		                      view$39]]),
		                Operation$9 = Menu_items_crdt[2],
		                delta_schema_versioned$56 = Menu_items_crdt[5],
		                element$8 = Menu_items_crdt[14],
		                insert$1 = Menu_items_crdt[15],
		                diff$8 = Menu_items_crdt[16],
		                letrec_function_context$725 = [];
		               function equal$240(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$725[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$725, [0, equal$224]);
		               var bOF = [];
		               function item_compat_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOF[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, 0, 0, descriptor]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOF[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOF[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOF[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (error_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_error, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (origin_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (integration_app_error_schema_v,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f2 = param[3], f1 = param[2], f0 = param[1];
		                        return cont([1, f0, f1, f2]);
		                       },
		                       function(param, cont){
		                        if(0 === param[0]) return cont(0);
		                        var f2 = param[3], f1 = param[2], f0 = param[1];
		                        return cont([0, [0, f0, f1, f2]]);
		                       },
		                       1,
		                       0,
		                       cst_integration_app_error,
		                       "Integration_app_error",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           error = a[2][1],
		                           origin = a[1],
		                           event = param[1];
		                          return cont([0, event, origin, error]);
		                         },
		                         function(param, cont){
		                          var error = param[3], origin = param[2], event = param[1];
		                          return cont([0, event, [0, origin, [0, error, 0]]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_event, 0, 2, [0, c], 0, 0], b]],
		                        0],
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (item_schema_versioned$0,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_item,
		                                  "Item",
		                                  b,
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOF[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOF[1][1] = a; return cont(res);});
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$726 = [];
		               function integration_app_error_schema_v
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$726[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$726[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$726[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$726[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return cont(aTx);},
		                                  0,
		                                  0,
		                                  cst_integration_app_error,
		                                  "Integration_app_error_const",
		                                  aTw,
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$726[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$726[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$685 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOF, [0, schematic_cache$685]);
		               var schematic_cache$686 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$726, [0, schematic_cache$686]);
		               caml_callback
		                (item_compat_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (integration_app_error_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               function item_schema_versioned$1(version, cont){
		                return caml_exact_trampoline_cps_call
		                        (item_compat_schema_versioned,
		                         version,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (version,
		                                   V$4,
		                                   function(match){
		                                    function c(b){
		                                     var
		                                      schema =
		map$14
		 (function(param, cont){
		   if(0 === param[0]){
		    var item = param[1];
		    return cont([0, item]);
		   }
		   var error = param[3], origin = param[2];
		   return cont([0, [2, [0, [0, origin, error]]]]);
		  },
		  b,
		  a);
		                                     return cont([0, aTy, schema[2], schema[3], schema[4]]);
		                                    }
		                                    function b(){
		                                     return c(function(item, cont){return cont([0, item]);});
		                                    }
		                                    if(! match) return b();
		                                    var version = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_string_exn,
		     "2.1.2-beta.0.google-contacts-limit-directory-notice",
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$66,
		               version,
		               a,
		               function(a){
		                return a
		                        ? c
		                          (function(item, cont){
		                            if(2 === item[0]){
		                             var a = item[1];
		                             if(0 === a[0]){
		                              a = a[1];
		                              var error = a[2], origin = a[1];
		                              return cont([1, 0, origin, error]);
		                             }
		                            }
		                            return cont([0, item]);
		                           })
		                        : b();
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$727 = [];
		               function compat_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$727[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTz, 0, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$727[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$727[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$727[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_viewed, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_archived, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$117,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_location, 0, 2, [0, schema$262], 0, 0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_message,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0, [0, 0, 0, 0, 0, cst_recipient, 0, 2, [0, c], 0, 0], b]]];
		                  return caml_exact_trampoline_cps_call
		                          (item_schema_versioned$1,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_item, 0, 3, [1, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$342,
		                                     schematic_version,
		                                     function(c){
		                                      var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              viewed = f[2][1],
		              archived = f[1],
		              recipient = e[1],
		              message = d[1],
		              location = c[1],
		              item = b[1],
		              id = a[1],
		              created = param[1];
		             return cont
		                     ([0,
		                       created,
		                       id,
		                       item,
		                       location,
		                       message,
		                       recipient,
		                       archived,
		                       viewed]);
		            },
		            function(param, cont){
		             var
		              viewed = param[8],
		              archived = param[7],
		              recipient = param[6],
		              message = param[5],
		              location = param[4],
		              item = param[3],
		              id = param[2],
		              created = param[1];
		             return cont
		                     ([0,
		                       created,
		                       [0,
		                        id,
		                        [0,
		                         item,
		                         [0,
		                          location,
		                          [0, message, [0, recipient, [0, archived, [0, viewed, 0]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$727[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$727[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$687 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$727, [0, schematic_cache$687]);
		               caml_callback
		                (compat_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function decode$12(param, cont){
		                var
		                 viewed = param[8],
		                 archived = param[7],
		                 recipient = param[6],
		                 message = param[5],
		                 location = param[4],
		                 item = param[3],
		                 id = param[2],
		                 created = param[1];
		                return cont
		                        ([0,
		                          [0,
		                           created,
		                           id,
		                           item,
		                           location,
		                           message,
		                           recipient,
		                           archived,
		                           viewed]]);
		               }
		               function encode$11(param, cont){
		                var
		                 viewed = param[8],
		                 archived = param[7],
		                 recipient = param[6],
		                 message = param[5],
		                 location = param[4],
		                 item = param[3],
		                 id = param[2],
		                 created = param[1];
		                return cont
		                        ([0,
		                          created,
		                          id,
		                          item,
		                          location,
		                          message,
		                          recipient,
		                          archived,
		                          viewed]);
		               }
		               function schema_versioned$454(version, cont){
		                return caml_exact_trampoline_cps_call
		                        (compat_schema_versioned$0,
		                         version,
		                         function(a){return cont(map$14(decode$12, encode$11, a));});
		               }
		               var
		                schema$181 =
		                  caml_callback
		                   (schema_versioned$454,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$728 = [];
		               function state_schema_versioned$41(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$728[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$728[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$728[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$728[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Earliest[3],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_viewed, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Earliest[3],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$117,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_location, 0, 2, [0, schema$262], 0, 0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_message,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0, [0, 0, 0, 0, 0, cst_recipient, 0, 2, [0, c], 0, 0], b]]];
		                  return caml_exact_trampoline_cps_call
		                          (item_schema_versioned$1,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_item, 0, 3, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$342,
		                                     schematic_version,
		                                     function(c){
		                                      var a = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              viewed = f[2][1],
		              archived = f[1],
		              recipient = e[1],
		              message = d[1],
		              location = c[1],
		              item = b[1],
		              id = a[1],
		              created = param[1];
		             return cont
		                     ([0,
		                       created,
		                       id,
		                       item,
		                       location,
		                       message,
		                       recipient,
		                       archived,
		                       viewed]);
		            },
		            function(param, cont){
		             var
		              viewed = param[8],
		              archived = param[7],
		              recipient = param[6],
		              message = param[5],
		              location = param[4],
		              item = param[3],
		              id = param[2],
		              created = param[1];
		             return cont
		                     ([0,
		                       created,
		                       [0,
		                        id,
		                        [0,
		                         item,
		                         [0,
		                          location,
		                          [0, message, [0, recipient, [0, archived, [0, viewed, 0]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$728[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$728[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$688 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$728, [0, schematic_cache$688]);
		               var
		                state_schema$14 =
		                  caml_callback
		                   (state_schema_versioned$41,
		                    [function(param, cont){return cont(0);}]),
		                cst_Viewed = "Viewed",
		                letrec_function_context$729 = [];
		               function schema_versioned$455(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$729[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$729[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$729[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$729[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Earliest[5],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aTC,
		   cst_viewed,
		   cst_Viewed,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_viewed, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aTE,
		       aTD,
		       0,
		       25,
		       2,
		       function(c){
		        var b = [0, [0, c, V$4]];
		        return caml_trampoline_cps_call2
		                (Earliest[5],
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aTF,
		                        cst_archived,
		                        cst_Archived,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, c], 0, 0], 0]],
		                         0],
		                        b],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$729[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$729[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$689 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$729, [0, schematic_cache$689]);
		               caml_callback
		                (schema_versioned$455,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$213 = Monadic$0(),
		                const$11 = include$213[2],
		                Apply$23 = include$213[14];
		               function apply$67(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          if(0 === param[0]){
		                           var op = param[1];
		                           return caml_trampoline_cps_call4
		                                   (Earliest[9],
		                                    replica,
		                                    state[7],
		                                    op,
		                                    function(match){
		                                     var archived = match[3], delta = match[2], res = match[1];
		                                     return caml_trampoline_cps_call3
		     (a,
		      delta,
		      function(delta, cont){return cont([0, delta]);},
		      function(delta){
		       return cont
		               ([0,
		                 res,
		                 delta,
		                 [0,
		                  state[1],
		                  state[2],
		                  state[3],
		                  state[4],
		                  state[5],
		                  state[6],
		                  archived,
		                  state[8]]]);
		      });
		                                    });
		                          }
		                          var op$0 = param[1];
		                          return caml_trampoline_cps_call4
		                                  (Earliest[9],
		                                   replica,
		                                   state[8],
		                                   op$0,
		                                   function(match){
		                                    var viewed = match[3], delta = match[2], res = match[1];
		                                    return caml_trampoline_cps_call3
		    (a,
		     delta,
		     function(delta, cont){return cont([1, delta]);},
		     function(delta){
		      return cont
		              ([0,
		                res,
		                delta,
		                [0,
		                 state[1],
		                 state[2],
		                 state[3],
		                 state[4],
		                 state[5],
		                 state[6],
		                 state[7],
		                 viewed]]);
		     });
		                                   });
		                         });
		               }
		               function apply_delta$63(replica, state, param, cont){
		                if(0 === param[0]){
		                 var delta = param[1], a = state[8];
		                 return caml_trampoline_cps_call4
		                         (Earliest[10],
		                          replica,
		                          state[7],
		                          delta,
		                          function(b){
		                           return cont
		                                   ([0,
		                                     state[1],
		                                     state[2],
		                                     state[3],
		                                     state[4],
		                                     state[5],
		                                     state[6],
		                                     b,
		                                     a]);
		                          });
		                }
		                var delta$0 = param[1];
		                return caml_trampoline_cps_call4
		                        (Earliest[10],
		                         replica,
		                         state[8],
		                         delta$0,
		                         function(a){
		                          return cont
		                                  ([0,
		                                    state[1],
		                                    state[2],
		                                    state[3],
		                                    state[4],
		                                    state[5],
		                                    state[6],
		                                    state[7],
		                                    a]);
		                         });
		               }
		               var
		                include$214 =
		                  caml_callback
		                   (Apply$23,
		                    [[0, [0, schema_versioned$455], apply_delta$63, apply$67]]),
		                delta_schema_versioned$57 = include$214[1],
		                delta_schema$14 = include$214[2],
		                apply_delta$64 = include$214[3],
		                apply$68 = include$214[4];
		               function make$101(param, cont){
		                var
		                 viewed = param[8],
		                 archived = param[7],
		                 recipient = param[6],
		                 message = param[5],
		                 location = param[4],
		                 item = param[3],
		                 id = param[2],
		                 created = param[1];
		                return caml_exact_trampoline_cps_call
		                        (Earliest[11],
		                         viewed,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Earliest[11],
		                                   archived,
		                                   function(b){
		                                    return cont
		    ([0, created, id, item, location, message, recipient, b, a]);
		                                   });
		                         });
		               }
		               function view$40(param, cont){
		                var
		                 viewed = param[8],
		                 archived = param[7],
		                 recipient = param[6],
		                 message = param[5],
		                 location = param[4],
		                 item = param[3],
		                 id = param[2],
		                 created = param[1];
		                return caml_exact_trampoline_cps_call
		                        (Earliest[12],
		                         viewed,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Earliest[12],
		                                   archived,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (include$0[5],
		     [0, created, id, item, location, message, recipient, b, a],
		     cont);
		                                   });
		                         });
		               }
		               var bR2 = [0, schema_versioned$454, schema$181];
		               function Make$44(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$11],
		                      state_schema_versioned$41,
		                      state_schema$14,
		                      delta_schema_versioned$57,
		                      delta_schema$14,
		                      [0, schema_versioned$454, schema$181],
		                      include$0,
		                      apply$68,
		                      apply_delta$64,
		                      make$101,
		                      view$40,
		                      equal$240]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$240,
		                    [0, const$11],
		                    state_schema_versioned$41,
		                    state_schema$14,
		                    delta_schema_versioned$57,
		                    delta_schema$14,
		                    bR2,
		                    include$0,
		                    apply$68,
		                    apply_delta$64,
		                    make$101,
		                    view$40];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$342,
		                          schema$143,
		                          symbol$206,
		                          symbol$207,
		                          symbol$208,
		                          symbol$209,
		                          symbol$210,
		                          symbol$211,
		                          equal$220,
		                          compare$131,
		                          min$30,
		                          max$32,
		                          ascending$21,
		                          descending$21,
		                          between$22,
		                          clamp_exn$21,
		                          clamp$21,
		                          comparator$42,
		                          pp$115],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$215 = caml_callback(Make$44, [Ident]),
		                Operation$10 = include$215[2],
		                state_schema_versioned$42 = include$215[3],
		                state_schema$15 = include$215[4],
		                delta_schema_versioned$58 = include$215[5],
		                delta_schema$15 = include$215[6],
		                Init$8 = include$215[7],
		                Monad$11 = include$215[8],
		                apply$69 = include$215[9],
		                apply_delta$65 = include$215[10],
		                make$102 = include$215[11],
		                view$41 = include$215[12],
		                add$21 = include$215[14],
		                remove$12 = include$215[18],
		                equal$241 = include$215[20];
		               function add_notice(notice, cont){
		                return caml_trampoline_cps_call3
		                        (add$21, notice[2], notice, cont);
		               }
		               function Make$45(a, cont){
		                var
		                 b =
		                   [0,
		                    equal$241,
		                    [0, Operation$10[3]],
		                    state_schema_versioned$42,
		                    state_schema$15,
		                    delta_schema_versioned$58,
		                    delta_schema$15,
		                    Init$8,
		                    Monad$11,
		                    apply$69,
		                    apply_delta$65,
		                    make$102,
		                    view$41];
		                return caml_exact_trampoline_cps_call
		                        (Make$44,
		                         a,
		                         function(c){
		                          var
		                           d =
		                             [0,
		                              c[20],
		                              [0, c[2][3]],
		                              c[3],
		                              c[4],
		                              c[5],
		                              c[6],
		                              c[7],
		                              c[8],
		                              c[9],
		                              c[10],
		                              c[11],
		                              c[12]];
		                          return caml_trampoline_cps_call2
		                                  (a[5],
		                                   [0,
		                                    schema_versioned$117,
		                                    schema$38,
		                                    symbol$131,
		                                    symbol$132,
		                                    symbol$133,
		                                    symbol$134,
		                                    symbol$135,
		                                    symbol$136,
		                                    equal$59,
		                                    compare$79,
		                                    min$18,
		                                    max$20,
		                                    ascending$9,
		                                    descending$9,
		                                    between$10,
		                                    clamp_exn$9,
		                                    clamp$9,
		                                    comparator$22,
		                                    pp$44],
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     d,
		     function(a){return caml_trampoline_cps_call2(a, b, cont);});
		                                   });
		                         });
		               }
		               var
		                include$216 = caml_callback(Make$45, [Ident]),
		                Operation$11 = include$216[2],
		                delta_schema_versioned$59 = include$216[5],
		                add$22 = include$216[14],
		                element$9 = include$216[16],
		                has$2 = include$216[17];
		               function schema_versioned$456(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$4,
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$182 =
		                  caml_callback
		                   (schema_versioned$456,
		                    [function(param, cont){return cont(0);}]);
		               function resolve$3(left, right, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$74, left, right, cont);
		               }
		               var
		                include$217 =
		                  caml_callback
		                   (Make_var,
		                    [[0, schema_versioned$456, schema$182, resolve$3]]),
		                Operation$12 = include$217[2],
		                state_schema_versioned$43 = include$217[3],
		                state_schema$16 = include$217[4],
		                delta_schema_versioned$60 = include$217[5],
		                delta_schema$16 = include$217[6],
		                Init$9 = include$217[7],
		                Monad$12 = include$217[8],
		                apply$70 = include$217[9],
		                apply_delta$66 = include$217[10],
		                make$103 = include$217[11],
		                view$42 = include$217[12],
		                set$19 = include$217[13];
		               function Make$46(Context, cont){
		                var
		                 b =
		                   [0,
		                    equal$20,
		                    [0, Operation$12[12]],
		                    state_schema_versioned$43,
		                    state_schema$16,
		                    delta_schema_versioned$60,
		                    delta_schema$16,
		                    Init$9,
		                    Monad$12,
		                    apply$70,
		                    apply_delta$66,
		                    make$103,
		                    view$42],
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      Operation$12,
		                      state_schema_versioned$43,
		                      state_schema$16,
		                      delta_schema_versioned$60,
		                      delta_schema$16,
		                      Init$9,
		                      Monad$12,
		                      apply$70,
		                      apply_delta$66,
		                      make$103,
		                      view$42,
		                      equal$20]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$342,
		                          schema$143,
		                          symbol$206,
		                          symbol$207,
		                          symbol$208,
		                          symbol$209,
		                          symbol$210,
		                          symbol$211,
		                          equal$220,
		                          compare$131,
		                          min$30,
		                          max$32,
		                          ascending$21,
		                          descending$21,
		                          between$22,
		                          clamp_exn$21,
		                          clamp$21,
		                          comparator$42,
		                          pp$115],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       Operation = include[2],
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       add = include[14],
		       element = include[16],
		       has = include[17],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                Operation,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                ,
		                add,
		                ,
		                element,
		                has,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$218 = caml_callback(Make$46, [Ident]),
		                Operation$13 = include$218[2],
		                delta_schema_versioned$61 = include$218[5],
		                add$23 = include$218[14],
		                element$10 = include$218[16],
		                has$3 = include$218[17],
		                remove$13 = include$218[18],
		                include$219 = caml_callback(b8, [[0, schema_versioned$105]]),
		                state_schema_versioned$44 = include$219[2],
		                delta_schema_versioned$62 = include$219[4],
		                Init$10 = include$219[6],
		                Monad$13 = include$219[7],
		                apply$71 = include$219[8],
		                apply_delta$67 = include$219[9],
		                make$104 = include$219[10],
		                view$43 = include$219[11],
		                Base_tree =
		                  caml_callback
		                   (Make$26,
		                    [[0,
		                      ,
		                      state_schema_versioned$44,
		                      ,
		                      delta_schema_versioned$62,
		                      ,
		                      Init$10,
		                      Monad$13,
		                      apply$71,
		                      apply_delta$67,
		                      make$104,
		                      view$43]]),
		                Map_Crdt =
		                  caml_callback
		                   (cm,
		                    [[0,
		                      schema_versioned$105,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$18,
		                      _33],
		                     caml_callback(b8, [[0, schema_versioned$360]])]),
		                letrec_function_context$660 = [];
		               function state_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$660[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aPO, aPN, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$660[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$660[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$660[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Map_Crdt[3],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, "by_elem", 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Base_tree[7],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var by_elem = param[2][1], base = param[1];
		             return cont([0, base, by_elem]);
		            },
		            function(param, cont){
		             var by_elem = param[2], base = param[1];
		             return cont([0, base, [0, by_elem, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_base, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$660[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$660[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$630 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$660, [0, schematic_cache$630]);
		               var
		                state_schema$0 =
		                  caml_callback
		                   (state_schema_versioned$0,
		                    [function(param, cont){return cont(0);}]),
		                include$134 = Monadic$0(),
		                Apply = include$134[14];
		               function elem_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (Base_tree[5][1],
		                                   schematic_version,
		                                   function(a){return cont([0, aPP, 0, a[3], a[4]]);});
		                         });
		               }
		               var letrec_function_context$661 = [];
		               function schema_versioned$374(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$661[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aPQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$661[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$661[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$661[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (elem_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$661[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$661[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$631 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$661, [0, schematic_cache$631]);
		               caml_callback
		                (elem_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (schema_versioned$374,
		                 [function(param, cont){return cont(0);}]);
		               function apply_delta$0(replica, state, cont){
		                return cont
		                        (function(t, cont){
		                          function a(t, init){
		                           if(! t) return cont(init);
		                           var
		                            l = t[2],
		                            delta = t[1],
		                            by_elem = init[2],
		                            base = init[1];
		                           function b(by_elem){
		                            return caml_exact_trampoline_cps_call$0
		                                    (Base_tree[12][1],
		                                     replica,
		                                     base,
		                                     delta,
		                                     function(base){
		                                      var init = [0, base, by_elem];
		                                      return caml_exact_trampoline_call2(a, l, init);
		                                     });
		                           }
		                           if(0 !== delta[0]) return b(by_elem);
		                           var value = delta[3], id = delta[1];
		                           return caml_trampoline_cps_call4
		                                   (Map_Crdt[10],
		                                    replica,
		                                    by_elem,
		                                    [0, [0, value, id, id], 0],
		                                    b);
		                          }
		                          return a(t, state);
		                         });
		               }
		               function apply$4(replica, state, op, cont){
		                var
		                 a = Base_tree[2],
		                 open = g([0, a[4], a[5], , a[7], a[8], a[9], , , , , a[12]]),
		                 let$ = open[3],
		                 symbol_map = open[2];
		                return caml_trampoline_cps_call2
		                        (Map_Crdt[12],
		                         state[2],
		                         function(by_elem){
		                          function get_or_create_tid(id, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    by_elem,
		                                    id,
		                                    function(match){
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call$1
		      (Base_tree[22], 0, id, cont);
		                                     var tid = match[1];
		                                     return caml_trampoline_cps_call2(Base_tree[2][8], tid, cont);
		                                    });
		                          }
		                          function a(op){
		                           return caml_trampoline_cps_call4
		                                   (Base_tree[16],
		                                    replica,
		                                    state[1],
		                                    op,
		                                    function(match){
		                                     var base_delta = match[2], result = match[1];
		                                     function a(new_state){
		                                      return cont([0, result, base_delta, new_state]);
		                                     }
		                                     if(! base_delta) return a(state);
		                                     var delta = base_delta[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (apply_delta$0,
		      replica,
		      state,
		      function(b){
		       return caml_exact_trampoline_cps_call(b, delta, a);
		      });
		                                    });
		                          }
		                          if(0 === op[0]){
		                           var
		                            op$0 = op[2],
		                            id = op[1],
		                            b =
		                              function(tid, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (Base_tree[23], tid, op$0, cont);
		                              };
		                           return caml_exact_trampoline_cps_call
		                                   (get_or_create_tid,
		                                    id,
		                                    function(c){
		                                     return caml_trampoline_cps_call3(let$, c, b, a);
		                                    });
		                          }
		                          var parent = op[2], id$0 = op[1];
		                          function c(tid, cont){
		                           function b(parent, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (Base_tree[24], parent, tid, cont);
		                           }
		                           function a(a){
		                            return caml_trampoline_cps_call3(let$, a, b, cont);
		                           }
		                           if(! parent)
		                            return caml_trampoline_cps_call2(Base_tree[2][8], 0, a);
		                           var id = parent[1];
		                           return caml_exact_trampoline_cps_call
		                                   (get_or_create_tid,
		                                    id,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(symbol_map, b, found, a);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (get_or_create_tid,
		                                   id$0,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, c, a);
		                                   });
		                         });
		               }
		               var
		                include$135 =
		                  caml_callback
		                   (Apply,
		                    [[0, [0, schema_versioned$374], apply_delta$0, apply$4]]),
		                apply_delta$1 = include$135[3],
		                apply$5 = include$135[4];
		               function delta_schema_versioned$0(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$5,
		                         function(schematic_schema_version){
		                          return caml_trampoline_cps_call2
		                                  (Base_tree[13],
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                delta_schema$0 =
		                  caml_callback
		                   (delta_schema_versioned$0,
		                    [function(param, cont){return cont(0);}]);
		               function apply_delta$2(replica, state, delta, cont){
		                return caml_trampoline_cps_call4
		                        (apply_delta$1, replica, state, [0, delta, 0], cont);
		               }
		               function apply$6(replica, state, op, cont){
		                return caml_trampoline_cps_call4
		                        (apply$5,
		                         replica,
		                         state,
		                         op,
		                         function(match){
		                          var state = match[3], deltas = match[2], res = match[1];
		                          if(! deltas) return cont([0, res, 0, state]);
		                          var deltas$0 = deltas[1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_list,
		                                   deltas$0,
		                                   function(a){return cont([0, res, [0, a], state]);});
		                         });
		               }
		               function roots(param){
		                var base = param[1];
		                return Base_tree[19].call(null, base);
		               }
		               function make$63(init, cont){
		                var a = empty$11([0, comparator$18]);
		                return caml_trampoline_cps_call2
		                        (Map_Crdt[11],
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Base_tree[9], dummy, function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$1(state, cont){
		                var open = g(Base_tree[1][7]), let$ = open[4];
		                function a(base, cont){
		                 return caml_trampoline_cps_call2
		                         (Map_Crdt[12],
		                          state[2],
		                          function(by_elem){return cont([0, base, by_elem]);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (Base_tree[17],
		                         state[1],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function up_edges$0(t, cont){
		                return caml_trampoline_cps_call3
		                        (map$11,
		                         up_edges
		                          (function(param){
		                            var value = param[2], id = param[1];
		                            return [0, value, id];
		                           },
		                           roots(t)),
		                         function(a, cont){
		                          var v = a[2], a = a[1], tree_id = a[2], id = a[1];
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   v,
		                                   calendar,
		                                   function(a){return cont([0, id, [0, id, tree_id, a]]);});
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (of_sequence_reduce$1,
		                                   [0, comparator$18],
		                                   a,
		                                   function(a, param, cont){
		                                    var
		                                     parent_r = param[3],
		                                     tid_r = param[2],
		                                     parent_l = a[3],
		                                     tid_l = a[2],
		                                     id = a[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     t[2],
		     id,
		     function(match){
		      function a(){
		       return caml_exact_trampoline_cps_call
		               (failwith, "up_edges: inconsistent tree", cont);
		      }
		      if(! match) return a();
		      var tree_id = match[1];
		      return caml_exact_trampoline_cps_call$1
		              (equal$228,
		               tree_id,
		               tid_l,
		               function(b){
		                return b
		                        ? cont([0, id, tree_id, parent_l])
		                        : caml_exact_trampoline_cps_call$1
		                          (equal$228,
		                           tree_id,
		                           tid_r,
		                           function(b){
		                            return b ? cont([0, id, tree_id, parent_r]) : a();
		                           });
		               });
		     });
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$13,
		     a,
		     function(param, cont){
		      var parent = param[3];
		      return cont(parent);
		     },
		     cont);
		                                   });
		                         });
		               }
		               var
		                bRz = Base_tree[6],
		                Owner =
		                  caml_callback(A, [[0, schema_versioned$104, schema$21]]),
		                letrec_function_context$730 = [];
		               function schema_versioned$457(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$730[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$730[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$730[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$730[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aTH,
		   cst_name,
		   cst_Name,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Owner[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aTI,
		              cst_owner,
		              cst_Owner,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$730[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$730[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$690 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$730, [0, schematic_cache$690]);
		               caml_callback
		                (schema_versioned$457,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$220 = Monadic$0(),
		                v$27 = include$220[1],
		                const$12 = include$220[2],
		                Apply$24 = include$220[14],
		                letrec_function_context$731 = [];
		               function state_schema_versioned$45(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$731[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$731[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$731[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$731[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$3,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Owner[2],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var name = param[2][1], owner = param[1];
		             return cont([0, owner, name]);
		            },
		            function(param, cont){
		             var name = param[2], owner = param[1];
		             return cont([0, owner, [0, name, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$731[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$731[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$691 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$731, [0, schematic_cache$691]);
		               caml_callback
		                (state_schema_versioned$45,
		                 [function(param, cont){return cont(0);}]);
		               function make$105(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (make$66,
		                         init[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Owner[10], init[1], function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$44(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (view$4,
		                         t[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Owner[11], t[1], function(b){return cont([0, b, a]);});
		                         });
		               }
		               function apply$72(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                if(0 === op[0]){
		                 var op$0 = op[1];
		                 return caml_trampoline_cps_call4
		                         (Owner[8],
		                          replica,
		                          state[1],
		                          op$0,
		                          function(match){
		                           var
		                            new_substate = match[3],
		                            delta = match[2],
		                            res = match[1];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    delta,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta){
		                                     var new_state = [0, new_substate, state[2]];
		                                     return cont([0, res, delta, new_state]);
		                                    });
		                          });
		                }
		                var op$1 = op[1];
		                return caml_trampoline_cps_call4
		                        (apply$10,
		                         replica,
		                         state[2],
		                         op$1,
		                         function(match){
		                          var
		                           new_substate = match[3],
		                           delta = match[2],
		                           res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   delta,
		                                   function(delta, cont){return cont([1, delta]);},
		                                   function(delta){
		                                    var new_state = [0, state[1], new_substate];
		                                    return cont([0, res, delta, new_state]);
		                                   });
		                         });
		               }
		               function apply_delta$68(replica, state, delta, cont){
		                if(0 === delta[0]){
		                 var delta$0 = delta[1];
		                 return caml_trampoline_cps_call4
		                         (Owner[9],
		                          replica,
		                          state[1],
		                          delta$0,
		                          function(new_substate){
		                           return cont([0, new_substate, state[2]]);
		                          });
		                }
		                var delta$1 = delta[1];
		                return caml_trampoline_cps_call4
		                        (apply_delta$6,
		                         replica,
		                         state[2],
		                         delta$1,
		                         function(new_substate){
		                          return cont([0, state[1], new_substate]);
		                         });
		               }
		               var
		                include$221 =
		                  caml_callback
		                   (Apply$24,
		                    [[0, [0, schema_versioned$457], apply_delta$68, apply$72]]),
		                delta_schema_versioned$63 = include$221[1],
		                delta_schema$17 = include$221[2],
		                apply_delta$69 = include$221[3],
		                apply$73 = include$221[4],
		                letrec_function_context$732 = [];
		               function equal$242(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$732[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$732, [0, equal$62]);
		               var letrec_function_context$733 = [];
		               function state_schema_versioned$46(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$733[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$733[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$733[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$733[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$45,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$120,
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        writable = a[2][1],
		                        id = a[1],
		                        created = param[1];
		                       return cont([0, created, id, writable]);
		                      },
		                      function(param, cont){
		                       var writable = param[3], id = param[2], created = param[1];
		                       return cont([0, created, [0, id, [0, writable, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$733[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$733[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$692 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$733, [0, schematic_cache$692]);
		               var
		                state_schema$17 =
		                  caml_callback
		                   (state_schema_versioned$46,
		                    [function(param, cont){return cont(0);}]);
		               function apply$74(replica, state, op, cont){
		                return caml_trampoline_cps_call4
		                        (apply$73,
		                         replica,
		                         state[3],
		                         op,
		                         function(match){
		                          var
		                           writable = match[3],
		                           deltas = match[2],
		                           result = match[1];
		                          return cont
		                                  ([0, result, deltas, [0, state[1], state[2], writable]]);
		                         });
		               }
		               function apply_delta$70(replica, state, delta, cont){
		                return caml_trampoline_cps_call4
		                        (apply_delta$69,
		                         replica,
		                         state[3],
		                         delta,
		                         function(a){return cont([0, state[1], state[2], a]);});
		               }
		               function make$106(param, cont){
		                var writable = param[3], id = param[2], created = param[1];
		                return caml_exact_trampoline_cps_call
		                        (make$105,
		                         writable,
		                         function(a){return cont([0, created, id, a]);});
		               }
		               function view$45(param, cont){
		                var writable = param[3], id = param[2], created = param[1];
		                return caml_exact_trampoline_cps_call
		                        (view$44,
		                         writable,
		                         function(a){return cont([0, created, id, a]);});
		               }
		               function name$33(op, cont){
		                return caml_exact_trampoline_cps_call(v$27, [1, op], cont);
		               }
		               var
		                include$222 =
		                  caml_callback(A, [[0, schema_versioned$195, schema$73]]),
		                state_schema_versioned$47 = include$222[2],
		                delta_schema_versioned$64 = include$222[4],
		                Init$11 = include$222[6],
		                Monad$14 = include$222[7],
		                apply$75 = include$222[8],
		                apply_delta$71 = include$222[9],
		                make$107 = include$222[10],
		                view$46 = include$222[11],
		                Members =
		                  caml_callback
		                   (cm,
		                    [[0,
		                      schema_versioned$117,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$22,
		                      pp$44],
		                     [0,
		                      ,
		                      state_schema_versioned$47,
		                      ,
		                      delta_schema_versioned$64,
		                      ,
		                      Init$11,
		                      Monad$14,
		                      apply$75,
		                      apply_delta$71,
		                      make$107,
		                      view$46]]),
		                Members_pending =
		                  caml_callback
		                   (bOD,
		                    [[0,
		                      schema_versioned$192,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$29,
		                      pp$75]]),
		                Owner$0 =
		                  caml_callback(A, [[0, schema_versioned$117, schema$38]]),
		                e =
		                  caml_callback
		                   (M$1,
		                    [[0,
		                      string_schema_versioned,
		                      schematic_param_name_schema_ve]]),
		                Subscription = caml_callback(A, [[0, e[54], e[55]]]),
		                bQB = [0, schema_versioned$121, schema$40],
		                Workspaces$0 =
		                  caml_callback
		                   (cm,
		                    [[0,
		                      schema_versioned$120,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$23,
		                      pp$46],
		                     [0,
		                      ,
		                      state_schema_versioned$46,
		                      ,
		                      delta_schema_versioned$63,
		                      ,
		                      bQB,
		                      include$0,
		                      apply$74,
		                      apply_delta$70,
		                      make$106,
		                      view$45]]),
		                cst_Members = "Members",
		                letrec_function_context$734 = [];
		               function schema_versioned$458(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$734[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTL, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$734[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$734[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$734[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Workspaces$0[5],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aTM,
		   cst_workspaces,
		   "Workspaces",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_workspaces, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Subscription[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aTN,
		             cst_subscription,
		             cst_Subscription,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_subscription, 0, 2, [0, c], 0, 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Owner$0[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aTO,
		                       cst_owner,
		                       cst_Owner,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$4,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aTP,
		                                 cst_name,
		                                 cst_Name,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Members_pending[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aTQ,
		   cst_members_pending$0,
		   "Members_pending",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_members_pending, 0, 2, [0, c], 0, 0],
		      0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Members[5],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aTR,
		              cst_members,
		              cst_Members,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_members, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$734[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$734[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$693 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$734, [0, schematic_cache$693]);
		               caml_callback
		                (schema_versioned$458,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$223 = Monadic$0(),
		                v$28 = include$223[1],
		                const$13 = include$223[2],
		                Apply$25 = include$223[14];
		               function schema_versioned$459(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function
		                                   (schematic_param_members_schema,
		                                    schematic_param_members_pendin,
		                                    schematic_param_name_schema_ve,
		                                    schematic_param_owner_schema_v,
		                                    schematic_param_subscription_s,
		                                    schematic_param_workspaces_sch,
		                                    cont){
		                                    function descriptor
		                                    (schematic_param_members_schema,
		                                     schematic_param_members_pendin,
		                                     schematic_param_name_schema_ve,
		                                     schematic_param_owner_schema_v,
		                                     schematic_param_subscription_s,
		                                     schematic_param_workspaces_sch,
		                                     cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_members,
		  0,
		  2,
		  [0, schematic_param_members_schema],
		  0,
		  0],
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_members_pending$0,
		   0,
		   2,
		   [0, schematic_param_members_pendin],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_owner,
		     0,
		     2,
		     [0, schematic_param_owner_schema_v],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_subscription,
		      0,
		      2,
		      [0, schematic_param_subscription_s],
		      0,
		      0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_workspaces,
		       0,
		       2,
		       [0, schematic_param_workspaces_sch],
		       0,
		       0],
		      0]]]]]];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$4,
		      schematic_version,
		      function(c){
		       var
		        b = [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, c], 0, 0], a];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$104,
		                schematic_version,
		                function(a){
		                 return cont
		                         ([7,
		                           function(param, cont){
		                            var
		                             a = param[2],
		                             b = a[2],
		                             c = b[2],
		                             d = c[2],
		                             e = d[2],
		                             f = e[2],
		                             workspaces = f[2][1],
		                             subscription = f[1],
		                             owner = e[1],
		                             name = d[1],
		                             members_pending = c[1],
		                             members = b[1],
		                             created = a[1],
		                             id = param[1];
		                            return cont
		                                    ([0,
		                                      id,
		                                      created,
		                                      members,
		                                      members_pending,
		                                      name,
		                                      owner,
		                                      subscription,
		                                      workspaces]);
		                           },
		                           function(param, cont){
		                            var
		                             workspaces = param[8],
		                             subscription = param[7],
		                             owner = param[6],
		                             name = param[5],
		                             members_pending = param[4],
		                             members = param[3],
		                             created = param[2],
		                             id = param[1];
		                            return cont
		                                    ([0,
		                                      id,
		                                      [0,
		                                       created,
		                                       [0,
		members,
		[0,
		 members_pending,
		 [0, name, [0, owner, [0, subscription, [0, workspaces, 0]]]]]]]]);
		                           },
		                           [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]]);
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$223[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_members,
		 schematic_param_members_schema,
		 function(schematic_param_members_schema, cont){
		  return cont
		          ([1,
		            cst_members_pending$0,
		            schematic_param_members_pendin,
		            function(schematic_param_members_pendin, cont){
		             return cont
		                     ([1,
		                       cst_name,
		                       schematic_param_name_schema_ve,
		                       function(schematic_param_name_schema_ve, cont){
		                        return cont
		                                ([1,
		                                  cst_owner,
		                                  schematic_param_owner_schema_v,
		                                  function(schematic_param_owner_schema_v, cont){
		                                   return cont
		   ([1,
		     cst_subscription,
		     schematic_param_subscription_s,
		     function(schematic_param_subscription_s, cont){
		      return cont
		              ([1,
		                cst_workspaces,
		                schematic_param_workspaces_sch,
		                function(schematic_param_workspaces_sch, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (descriptor,
		                          schematic_param_members_schema,
		                          schematic_param_members_pendin,
		                          schematic_param_name_schema_ve,
		                          schematic_param_owner_schema_v,
		                          schematic_param_subscription_s,
		                          schematic_param_workspaces_sch,
		                          function(a){return cont([0, schematic_schema_id, a]);});
		                }]);
		     }]);
		                                  }]);
		                       }]);
		            }]);
		 }]];
		                                    return caml_exact_trampoline_cps_call$7
		    (descriptor,
		     schematic_param_members_schema,
		     schematic_param_members_pendin,
		     schematic_param_name_schema_ve,
		     schematic_param_owner_schema_v,
		     schematic_param_subscription_s,
		     schematic_param_workspaces_sch,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, , , a, schematic_parametric]);
		                }
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               var Delta$2 = [0, schema_versioned$458];
		               function Make$47(Context, cont){
		                var
		                 include =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$12],
		                      state_schema_versioned$46,
		                      state_schema$17,
		                      delta_schema_versioned$63,
		                      delta_schema$17,
		                      [0, schema_versioned$121, schema$40],
		                      include$0,
		                      apply$74,
		                      apply_delta$70,
		                      make$106,
		                      view$45,
		                      equal$242]),
		                 Operation = include[1],
		                 state_schema_versioned = include[2],
		                 state_schema = include[3],
		                 delta_schema_versioned = include[4],
		                 delta_schema = include[5],
		                 Init = include[6],
		                 Monad = include[7],
		                 apply = include[8],
		                 apply_delta = include[9],
		                 make = include[10],
		                 view = include[11],
		                 equal = include[12],
		                 Workspace_context =
		                   [0,
		                    Operation,
		                    state_schema_versioned,
		                    state_schema,
		                    delta_schema_versioned,
		                    delta_schema,
		                    Init,
		                    Monad,
		                    apply,
		                    apply_delta,
		                    make,
		                    view,
		                    equal],
		                 b =
		                   [0,
		                    Workspace_context[12],
		                    [0, Workspace_context[1][12]],
		                    Workspace_context[2],
		                    Workspace_context[3],
		                    Workspace_context[4],
		                    Workspace_context[5],
		                    Workspace_context[6],
		                    Workspace_context[7],
		                    Workspace_context[8],
		                    Workspace_context[9],
		                    Workspace_context[10],
		                    Workspace_context[11]],
		                 a =
		                   [0,
		                    equal$242,
		                    [0, const$12],
		                    state_schema_versioned$46,
		                    state_schema$17,
		                    delta_schema_versioned$63,
		                    delta_schema$17,
		                    bQB,
		                    include$0,
		                    apply$74,
		                    apply_delta$70,
		                    make$106,
		                    view$45];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$120,
		                          schema$39,
		                          symbol$137,
		                          symbol$138,
		                          symbol$139,
		                          symbol$140,
		                          symbol$141,
		                          symbol$142,
		                          equal$61,
		                          compare$80,
		                          min$19,
		                          max$21,
		                          ascending$10,
		                          descending$10,
		                          between$11,
		                          clamp_exn$10,
		                          clamp$10,
		                          comparator$23,
		                          pp$46],
		                         function(c){
		                          return caml_trampoline_cps_call2
		                                  (c,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(Workspaces){
		      var letrec_function_context = [];
		      function equal(x, cont){
		       return caml_trampoline_cps_call2
		               (letrec_function_context[1], x, cont);
		      }
		      caml_update_dummy(letrec_function_context, [0, equal$118]);
		      var Monad = Context[1];
		      function state_schema_versioned(schematic_version, cont){
		       return caml_trampoline_cps_call2
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_trampoline_cps_call2
		                         (Workspaces[3],
		                          schematic_version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (Subscription[2],
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (Owner$0[2],
		      schematic_version,
		      function(c){
		       return caml_exact_trampoline_cps_call
		               (state_schema_versioned$3,
		                schematic_version,
		                function(d){
		                 return caml_trampoline_cps_call2
		                         (Members_pending[2],
		                          schematic_version,
		                          function(e){
		                           return caml_trampoline_cps_call2
		                                   (Members[3],
		                                    schematic_version,
		                                    function(f){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$459,
		      schematic_version,
		      function(g){
		       return caml_exact_trampoline_cps_call$7
		               (g,
		                f,
		                e,
		                d,
		                c,
		                b,
		                a,
		                function(a){return cont([0, aTS, 0, a[3], a[4]]);});
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (state_schema_versioned,
		               function(param, cont){return cont(0);},
		               function(state_schema){
		                function apply_delta(replica, state, param, cont){
		                 switch(param[0]){
		                   case 0:
		                    var
		                     delta = param[1],
		                     a = state[8],
		                     b = state[7],
		                     c = state[6],
		                     d = state[5],
		                     e = state[4];
		                    return caml_trampoline_cps_call4
		                            (Members[10],
		                             replica,
		                             state[3],
		                             delta,
		                             function(f){
		                              return cont([0, state[1], state[2], f, e, d, c, b, a]);
		                             });
		                   case 1:
		                    var
		                     delta$0 = param[1],
		                     f = state[8],
		                     g = state[7],
		                     h = state[6],
		                     i = state[5];
		                    return caml_trampoline_cps_call4
		                            (Members_pending[9],
		                             replica,
		                             state[4],
		                             delta$0,
		                             function(a){
		                              return cont
		                                      ([0, state[1], state[2], state[3], a, i, h, g, f]);
		                             });
		                   case 2:
		                    var
		                     delta$1 = param[1],
		                     j = state[8],
		                     k = state[7],
		                     l = state[6];
		                    return caml_trampoline_cps_call4
		                            (apply_delta$6,
		                             replica,
		                             state[5],
		                             delta$1,
		                             function(a){
		                              return cont
		                                      ([0, state[1], state[2], state[3], state[4], a, l, k, j]);
		                             });
		                   case 3:
		                    var delta$2 = param[1], m = state[8], n = state[7];
		                    return caml_trampoline_cps_call4
		                            (Owner$0[9],
		                             replica,
		                             state[6],
		                             delta$2,
		                             function(a){
		                              return cont
		                                      ([0,
		state[1],
		state[2],
		state[3],
		state[4],
		state[5],
		a,
		n,
		m]);
		                             });
		                   case 4:
		                    var delta$3 = param[1], o = state[8];
		                    return caml_trampoline_cps_call4
		                            (Subscription[9],
		                             replica,
		                             state[7],
		                             delta$3,
		                             function(a){
		                              return cont
		                                      ([0,
		state[1],
		state[2],
		state[3],
		state[4],
		state[5],
		state[6],
		a,
		o]);
		                             });
		                   default:
		                    var delta$4 = param[1];
		                    return caml_trampoline_cps_call4
		                            (Workspaces[10],
		                             replica,
		                             state[8],
		                             delta$4,
		                             function(a){
		                              return cont
		                                      ([0,
		state[1],
		state[2],
		state[3],
		state[4],
		state[5],
		state[6],
		state[7],
		a]);
		                             });
		                 }
		                }
		                function apply(replica, state, cont){
		                 var
		                  a =
		                    g
		                      ([0,
		                        symbol_bind$5,
		                        symbol_map$5,
		                        ,
		                        bind$8,
		                        return$9,
		                        map$17,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Let_syntax$3])
		                     [4];
		                 return cont
		                         (function(param, cont){
		                           switch(param[0]){
		                             case 0:
		                              var operation = param[1];
		                              return caml_trampoline_cps_call4
		                                      (Members[9],
		                                       replica,
		                                       state[3],
		                                       operation,
		                                       function(match){
		var members = match[3], delta = match[2], res = match[1];
		return caml_trampoline_cps_call3
		        (a,
		         delta,
		         function(delta, cont){return cont([0, delta]);},
		         function(delta){
		          return cont
		                  ([0,
		                    res,
		                    delta,
		                    [0,
		                     state[1],
		                     state[2],
		                     members,
		                     state[4],
		                     state[5],
		                     state[6],
		                     state[7],
		                     state[8]]]);
		         });
		                                       });
		                             case 1:
		                              var operation$0 = param[1];
		                              return caml_trampoline_cps_call4
		                                      (Members_pending[8],
		                                       replica,
		                                       state[4],
		                                       operation$0,
		                                       function(match){
		var
		 members_pending = match[3],
		 delta = match[2],
		 res = match[1];
		return caml_trampoline_cps_call3
		        (a,
		         delta,
		         function(delta, cont){return cont([1, delta]);},
		         function(delta){
		          return cont
		                  ([0,
		                    res,
		                    delta,
		                    [0,
		                     state[1],
		                     state[2],
		                     state[3],
		                     members_pending,
		                     state[5],
		                     state[6],
		                     state[7],
		                     state[8]]]);
		         });
		                                       });
		                             case 2:
		                              var operation$1 = param[1];
		                              return caml_trampoline_cps_call4
		                                      (apply$10,
		                                       replica,
		                                       state[5],
		                                       operation$1,
		                                       function(match){
		var name = match[3], delta = match[2], res = match[1];
		return caml_trampoline_cps_call3
		        (a,
		         delta,
		         function(delta, cont){return cont([2, delta]);},
		         function(delta){
		          return cont
		                  ([0,
		                    res,
		                    delta,
		                    [0,
		                     state[1],
		                     state[2],
		                     state[3],
		                     state[4],
		                     name,
		                     state[6],
		                     state[7],
		                     state[8]]]);
		         });
		                                       });
		                             case 3:
		                              var operation$2 = param[1];
		                              return caml_trampoline_cps_call4
		                                      (Owner$0[8],
		                                       replica,
		                                       state[6],
		                                       operation$2,
		                                       function(match){
		var owner = match[3], delta = match[2], res = match[1];
		return caml_trampoline_cps_call3
		        (a,
		         delta,
		         function(delta, cont){return cont([3, delta]);},
		         function(delta){
		          return cont
		                  ([0,
		                    res,
		                    delta,
		                    [0,
		                     state[1],
		                     state[2],
		                     state[3],
		                     state[4],
		                     state[5],
		                     owner,
		                     state[7],
		                     state[8]]]);
		         });
		                                       });
		                             case 4:
		                              var operation$3 = param[1];
		                              return caml_trampoline_cps_call4
		                                      (Workspaces[9],
		                                       replica,
		                                       state[8],
		                                       operation$3,
		                                       function(match){
		var workspaces = match[3], delta = match[2], res = match[1];
		return caml_trampoline_cps_call3
		        (a,
		         delta,
		         function(delta, cont){return cont([5, delta]);},
		         function(delta){
		          return cont
		                  ([0,
		                    res,
		                    delta,
		                    [0,
		                     state[1],
		                     state[2],
		                     state[3],
		                     state[4],
		                     state[5],
		                     state[6],
		                     state[7],
		                     workspaces]]);
		         });
		                                       });
		                             default:
		                              var operation$4 = param[1];
		                              return caml_trampoline_cps_call4
		                                      (Subscription[8],
		                                       replica,
		                                       state[7],
		                                       operation$4,
		                                       function(match){
		var
		 subscription = match[3],
		 delta = match[2],
		 res = match[1];
		return caml_trampoline_cps_call3
		        (a,
		         delta,
		         function(delta, cont){return cont([4, delta]);},
		         function(delta){
		          return cont
		                  ([0,
		                    res,
		                    delta,
		                    [0,
		                     state[1],
		                     state[2],
		                     state[3],
		                     state[4],
		                     state[5],
		                     state[6],
		                     subscription,
		                     state[8]]]);
		         });
		                                       });
		                           }
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (Apply$25,
		                         [0, Delta$2, apply_delta, apply],
		                         function(include){
		                          var
		                           delta_schema_versioned = include[1],
		                           delta_schema = include[2],
		                           apply_delta = include[3],
		                           apply = include[4];
		                          function make(param, cont){
		                           var
		                            workspaces = param[4],
		                            a = param[3],
		                            match = a[4],
		                            name = match[2],
		                            owner = match[1],
		                            subscription = a[3],
		                            id = a[2],
		                            created = a[1],
		                            members_pending = param[2],
		                            members = param[1];
		                           return caml_trampoline_cps_call2
		                                   (Workspaces[11],
		                                    workspaces,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (Subscription[10],
		      subscription,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (Owner$0[10],
		                owner,
		                function(c){
		                 return caml_exact_trampoline_cps_call
		                         (make$66,
		                          name,
		                          function(d){
		                           return caml_exact_trampoline_cps_call
		                                   (Members_pending[10],
		                                    members_pending,
		                                    function(e){
		                                     return caml_trampoline_cps_call2
		     (Members[11],
		      members,
		      function(f){
		       return cont([0, id, created, f, e, d, c, b, a]);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          function view(a, cont){
		                           var
		                            workspaces = a[8],
		                            subscription = a[7],
		                            owner = a[6],
		                            name = a[5],
		                            members_pending = a[4],
		                            members = a[3],
		                            created = a[2],
		                            id = a[1],
		                            a = Context[1],
		                            open = g([0, a[1], a[2], , a[4], a[5], a[6], , , , , a[11]]),
		                            let$ = open[4];
		                           function b(workspaces, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (view$4,
		                                     name,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (Owner$0[11],
		       owner,
		       function(c){
		        var b = [0, c, a];
		        return caml_exact_trampoline_cps_call
		                (Subscription[11],
		                 subscription,
		                 function(c){
		                  var a = [0, created, id, c, b];
		                  return caml_exact_trampoline_cps_call
		                          (Members_pending[11],
		                           members_pending,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (Members[12],
		                                     members,
		                                     function(c){return cont([0, c, b, a, workspaces]);});
		                           });
		                 });
		       });
		                                     });
		                           }
		                           return caml_trampoline_cps_call2
		                                   (Workspaces[12],
		                                    workspaces,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(let$, a, b, cont);
		                                    });
		                          }
		                          return cont
		                                  ([0,
		                                    ,
		                                    Workspaces,
		                                    equal,
		                                    Monad,
		                                    state_schema_versioned,
		                                    state_schema,
		                                    delta_schema_versioned,
		                                    delta_schema,
		                                    apply_delta,
		                                    apply,
		                                    make,
		                                    view]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                include$224 = caml_callback(Make$47, [Ident]),
		                Workspaces = include$224[2],
		                equal$243 = include$224[3],
		                Monad$15 = include$224[4],
		                state_schema_versioned$48 = include$224[5],
		                state_schema$18 = include$224[6],
		                delta_schema_versioned$65 = include$224[7],
		                delta_schema$18 = include$224[8],
		                apply_delta$72 = include$224[9],
		                apply$76 = include$224[10],
		                make$108 = include$224[11],
		                view$47 = include$224[12];
		               function members_pending$0(op, cont){
		                return caml_exact_trampoline_cps_call(v$28, [1, op], cont);
		               }
		               function workspaces(op, cont){
		                return caml_exact_trampoline_cps_call(v$28, [4, op], cont);
		               }
		               var
		                bQC = Workspaces[16],
		                bR5 =
		                  [0,
		                   Monad$15[1],
		                   Monad$15[2],
		                   Monad$15[3],
		                   Monad$15[4],
		                   Monad$15[5],
		                   Monad$15[6],
		                   Monad$15[7],
		                   Monad$15[8],
		                   Monad$15[9],
		                   Monad$15[10],
		                   Monad$15[11]],
		                bR6 = [0, schema_versioned$199, schema$74];
		               function Make$48(Context, cont){
		                var
		                 a =
		                   [0,
		                    equal$243,
		                    [0, const$13],
		                    state_schema_versioned$48,
		                    state_schema$18,
		                    delta_schema_versioned$65,
		                    delta_schema$18,
		                    bR6,
		                    bR5,
		                    apply$76,
		                    apply_delta$72,
		                    make$108,
		                    view$47];
		                return caml_exact_trampoline_cps_call
		                        (Make$47,
		                         Context,
		                         function(c){
		                          var
		                           b = c[4],
		                           d =
		                             [0,
		                              c[3],
		                              [0, const$13],
		                              c[5],
		                              c[6],
		                              c[7],
		                              c[8],
		                              [0, schema_versioned$199, schema$74],
		                              [0,
		                               b[1],
		                               b[2],
		                               b[3],
		                               b[4],
		                               b[5],
		                               b[6],
		                               b[7],
		                               b[8],
		                               b[9],
		                               b[10],
		                               b[11]],
		                              c[10],
		                              c[9],
		                              c[11],
		                              c[12]];
		                          return caml_trampoline_cps_call2
		                                  (Context[5],
		                                   [0,
		                                    schema_versioned$104,
		                                    schema$21,
		                                    symbol$113,
		                                    symbol$114,
		                                    symbol$115,
		                                    symbol$116,
		                                    symbol$117,
		                                    symbol$118,
		                                    equal$53,
		                                    compare$60,
		                                    min$15,
		                                    max$17,
		                                    ascending$6,
		                                    descending$6,
		                                    between$7,
		                                    clamp_exn$6,
		                                    clamp$6,
		                                    comparator$17,
		                                    pp$37],
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     d,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(include){
		                var
		                 state_schema_versioned = include[3],
		                 delta_schema_versioned = include[5],
		                 apply = include[9],
		                 apply_delta = include[10],
		                 make = include[11],
		                 view = include[12],
		                 init = include[13],
		                 add = include[14],
		                 element = include[15],
		                 element$0 = include[16],
		                 remove = include[18];
		                return cont
		                        ([0,
		                          ,
		                          ,
		                          state_schema_versioned,
		                          ,
		                          delta_schema_versioned,
		                          ,
		                          ,
		                          ,
		                          apply,
		                          apply_delta,
		                          make,
		                          view,
		                          init,
		                          add,
		                          element,
		                          element$0,
		                          ,
		                          remove]);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                bR3 = Workspaces[18],
		                bR4 = Workspaces[14],
		                include$225 = caml_callback(Make$48, [Ident]),
		                delta_schema_versioned$66 = include$225[5],
		                add$24 = include$225[14],
		                element$11 = include$225[15],
		                element$12 = include$225[16],
		                remove$14 = include$225[18],
		                letrec_function_context$735 = [];
		               function schema_versioned$460(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$735[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aTT, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$735[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$735[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$735[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aTU,
		   cst_title,
		   cst_Title,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$3,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aTV,
		             cst_notes,
		             cst_Notes,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$23,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aTW,
		                       cst_extension_row,
		                       cst_Extension_row,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, c], 0, 0],
		                          0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Earliest[5],
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aTX,
		                                  cst_archived,
		                                  cst_Archived,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, b], 0, 0], 0]],
		                                   0],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$735[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$735[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$694 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$735, [0, schematic_cache$694]);
		               caml_callback
		                (schema_versioned$460,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$736 = [];
		               function schema_versioned$461(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$736[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$736[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$736[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$736[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$3,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Created[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (state_schema_versioned$2,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$103,
		                           schematic_version,
		                           function(c){
		                            var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$16,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (Earliest[3],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              title = d[2][1],
		              created = d[1],
		              notes = c[1],
		              id = b[1],
		              extension_row = a[1],
		              archived = param[1];
		             return cont
		                     ([0, archived, extension_row, id, notes, created, title]);
		            },
		            function(param, cont){
		             var
		              title = param[6],
		              created = param[5],
		              notes = param[4],
		              id = param[3],
		              extension_row = param[2],
		              archived = param[1];
		             return cont
		                     ([0,
		                       archived,
		                       [0,
		                        extension_row,
		                        [0, id, [0, notes, [0, created, [0, title, 0]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$736[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$736[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$695 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$736, [0, schematic_cache$695]);
		               caml_callback
		                (schema_versioned$461,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$226 = Monadic$0(),
		                v$29 = include$226[1],
		                const$14 = include$226[2],
		                ignore_m$8 = include$226[10],
		                all_unit$17 = include$226[12],
		                Apply$26 = include$226[14];
		               function state_schema_versioned$49(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$461,
		                                   schematic_version,
		                                   function(a){return cont([0, aTY, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                state_schema$19 =
		                  caml_callback
		                   (state_schema_versioned$49,
		                    [function(param, cont){return cont(0);}]);
		               function apply$77(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var operation = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Earliest[9],
		                                      replica,
		                                      state[1],
		                                      operation,
		                                      function(match){
		                                       var archived = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    archived,
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 1:
		                             var operation$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$31,
		                                      replica,
		                                      state[2],
		                                      operation$0,
		                                      function(match){
		                                       var
		extension_row = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    extension_row,
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 2:
		                             var operation$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$9,
		                                      replica,
		                                      state[4],
		                                      operation$1,
		                                      function(match){
		                                       var notes = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0, state[1], state[2], state[3], notes, state[5], state[6]]]);
		        });
		                                      });
		                            default:
		                             var operation$2 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$10,
		                                      replica,
		                                      state[6],
		                                      operation$2,
		                                      function(match){
		                                       var title = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([3, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0, state[1], state[2], state[3], state[4], state[5], title]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$73(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[6],
		                    b = state[5],
		                    c = state[4],
		                    d = state[3],
		                    e = state[2];
		                   return caml_trampoline_cps_call4
		                           (Earliest[10],
		                            replica,
		                            state[1],
		                            delta,
		                            function(f){return cont([0, f, e, d, c, b, a]);});
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    f = state[6],
		                    g = state[5],
		                    h = state[4],
		                    i = state[3];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$27,
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){return cont([0, state[1], a, i, h, g, f]);});
		                  case 2:
		                   var delta$1 = param[1], j = state[6], k = state[5];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$5,
		                            replica,
		                            state[4],
		                            delta$1,
		                            function(a){
		                             return cont([0, state[1], state[2], state[3], a, k, j]);
		                            });
		                  default:
		                   var delta$2 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[6],
		                            delta$2,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], state[5], a]);
		                            });
		                }
		               }
		               var
		                include$227 =
		                  caml_callback
		                   (Apply$26,
		                    [[0, [0, schema_versioned$460], apply_delta$73, apply$77]]),
		                delta_schema_versioned$67 = include$227[1],
		                delta_schema$19 = include$227[2],
		                apply_delta$74 = include$227[3],
		                apply$78 = include$227[4];
		               function make$109(param, cont){
		                var
		                 match = param[3],
		                 title = match[4],
		                 extension_row = match[3],
		                 content = match[2],
		                 archived = match[1],
		                 id = param[2],
		                 created = param[1];
		                return caml_exact_trampoline_cps_call
		                        (make$66,
		                         title,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Created[10],
		                                   created,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (make$72,
		     content,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (make$80,
		               extension_row,
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Earliest[11],
		                         archived,
		                         function(e){return cont([0, e, d, id, c, b, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function view$48(param, cont){
		                var
		                 title = param[6],
		                 created = param[5],
		                 notes = param[4],
		                 id = param[3],
		                 extension_row = param[2],
		                 archived = param[1];
		                return caml_exact_trampoline_cps_call
		                        (view$4,
		                         title,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (view$19,
		                                   extension_row,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (view$11,
		     notes,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Earliest[12],
		               archived,
		               function(e){
		                var d = [0, e, c, b, a, 0];
		                return caml_exact_trampoline_cps_call
		                        (Created[11],
		                         created,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (include$0[5], [0, a, id, d], cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function notes$1(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$29, [2, operation], cont);
		               }
		               var bR7 = [0, schema_versioned$347, schema$144];
		               function Make$49(Context, cont){
		                var
		                 a =
		                   Context[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$14],
		                      state_schema_versioned$49,
		                      state_schema$19,
		                      delta_schema_versioned$67,
		                      delta_schema$19,
		                      [0, schema_versioned$347, schema$144],
		                      include$0,
		                      apply$78,
		                      apply_delta$74,
		                      make$109,
		                      view$48,
		                      equal$225]),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 b =
		                   [0,
		                    equal$225,
		                    [0, const$14],
		                    state_schema_versioned$49,
		                    state_schema$19,
		                    delta_schema_versioned$67,
		                    delta_schema$19,
		                    bR7,
		                    include$0,
		                    apply$78,
		                    apply_delta$74,
		                    make$109,
		                    view$48];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$103,
		                          schema$20,
		                          symbol$107,
		                          symbol$108,
		                          symbol$109,
		                          symbol$110,
		                          symbol$111,
		                          symbol$112,
		                          equal$52,
		                          compare$59,
		                          min$14,
		                          max$16,
		                          ascending$5,
		                          descending$5,
		                          between$6,
		                          clamp_exn$5,
		                          clamp$5,
		                          comparator$16,
		                          pp$36],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       Operation = include[2],
		       state_schema_versioned = include[3],
		       delta_schema_versioned = include[5],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       init = include[13],
		       add = include[14],
		       element = include[15],
		       remove = include[18];
		      return cont
		              ([0,
		                ,
		                Operation,
		                state_schema_versioned,
		                ,
		                delta_schema_versioned,
		                ,
		                ,
		                ,
		                apply,
		                apply_delta,
		                make,
		                view,
		                init,
		                add,
		                element,
		                ,
		                ,
		                remove]);
		     });
		                                   });
		                         });
		               }
		               var
		                include$228 = caml_callback(Make$49, [Ident]),
		                Operation$14 = include$228[2],
		                delta_schema_versioned$68 = include$228[5],
		                add$25 = include$228[14],
		                element$13 = include$228[15],
		                remove$15 = include$228[18];
		               function update$4
		               (archived, extension_row, title_pair, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 and = open[6],
		                 let$ = open[4],
		                 let$0 = open[3];
		                return caml_trampoline_cps_call3
		                        (let$,
		                         archived,
		                         function(archived, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Earliest[13],
		                                   archived,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$29, [0, a], cont);
		                                   });
		                         },
		                         function(archived_op){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   extension_row,
		                                   function(extension_row, cont){
		                                    return caml_exact_trampoline_cps_call
		    (set$12,
		     extension_row,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$29, [1, a], cont);
		     });
		                                   },
		                                   function(extension_row_op){
		                                    return caml_trampoline_cps_call3
		    (let$0,
		     title_pair,
		     function(param, cont){
		      var
		       title_after = param[2],
		       title_before = param[1],
		       left = some_if(title_before !== title_after ? 1 : 0, 0);
		      function a(param, cont){
		       var operation = param[2];
		       return caml_exact_trampoline_cps_call
		               (v$29,
		                [3, operation],
		                function(a){
		                 return caml_exact_trampoline_cps_call(ignore_m$8, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$1
		              (diff$1,
		               title_before,
		               title_after,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (and,
		                         left,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               });
		     },
		     function(title_op){
		      return caml_exact_trampoline_cps_call
		              (filter_opt,
		               [0, archived_op, [0, extension_row_op, [0, title_op, 0]]],
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (all_unit$17,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (element$13,
		                                   id,
		                                   function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function add_page
		               (opt, archived, extension_row, created, title, param, cont){
		                var
		                 id = opt ? opt[1] : make$29(),
		                 open =
		                   g
		                    ([0,
		                      Operation$14[4],
		                      Operation$14[5],
		                      ,
		                      Operation$14[7],
		                      Operation$14[8],
		                      Operation$14[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$14[12]]),
		                 let$ = open[3];
		                function a(param, cont){
		                 return caml_trampoline_cps_call2(Operation$14[8], id, cont);
		                }
		                return caml_trampoline_cps_call3
		                        (add$25,
		                         id,
		                         [0,
		                          created,
		                          id,
		                          [0, archived, aTZ, extension_row, title, 0]],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var letrec_function_context$737 = [];
		               function schema_versioned$462(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$737[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aT0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$737[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$737[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$737[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$23,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aT1,
		   cst_extension_row,
		   cst_Extension_row,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, b], 0, 0],
		      0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Earliest[5],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aT2,
		             cst_archived,
		             cst_Archived,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$3,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aT3,
		                        cst_notes,
		                        cst_Notes,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$737[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$737[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$696 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$737, [0, schematic_cache$696]);
		               caml_callback
		                (schema_versioned$462,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$229 = Monadic$0(),
		                v$30 = include$229[1],
		                Apply$27 = include$229[14],
		                letrec_function_context$738 = [];
		               function state_schema_versioned$50(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$738[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aT4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$738[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$738[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$738[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$16,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (Earliest[3],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (state_schema_versioned$2,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        extension_row = a[2][1],
		                        archived = a[1],
		                        notes = param[1];
		                       return cont([0, notes, archived, extension_row]);
		                      },
		                      function(param, cont){
		                       var
		                        extension_row = param[3],
		                        archived = param[2],
		                        notes = param[1];
		                       return cont
		                               ([0, notes, [0, archived, [0, extension_row, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$738[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$738[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$697 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$738, [0, schematic_cache$697]);
		               caml_callback
		                (state_schema_versioned$50,
		                 [function(param, cont){return cont(0);}]);
		               function apply$79(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var op = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Earliest[9],
		                                      replica,
		                                      state[2],
		                                      op,
		                                      function(match){
		                                       var archived = match[3], delta_o = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta_o){
		         return cont
		                 ([0, res, delta_o, [0, state[1], archived, state[3]]]);
		        });
		                                      });
		                            case 1:
		                             var op$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$31,
		                                      replica,
		                                      state[3],
		                                      op$0,
		                                      function(match){
		                                       var
		extension_row = match[3],
		delta_o = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta_o){
		         return cont
		                 ([0, res, delta_o, [0, state[1], state[2], extension_row]]);
		        });
		                                      });
		                            default:
		                             var op$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$9,
		                                      replica,
		                                      state[1],
		                                      op$1,
		                                      function(match){
		                                       var notes = match[3], delta_o = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta_o,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta_o){
		         return cont
		                 ([0, res, delta_o, [0, notes, state[2], state[3]]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$75(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var delta = param[1], a = state[3], b = state[2];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$5,
		                            replica,
		                            state[1],
		                            delta,
		                            function(c){return cont([0, c, b, a]);});
		                  case 1:
		                   var delta$0 = param[1], c = state[3];
		                   return caml_trampoline_cps_call4
		                           (Earliest[10],
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){return cont([0, state[1], a, c]);});
		                  default:
		                   var delta$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$27,
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){return cont([0, state[1], state[2], a]);});
		                }
		               }
		               var
		                include$230 =
		                  caml_callback
		                   (Apply$27,
		                    [[0, [0, schema_versioned$462], apply_delta$75, apply$79]]),
		                delta_schema_versioned$69 = include$230[1],
		                apply_delta$76 = include$230[3],
		                apply$80 = include$230[4];
		               function schema_versioned$463(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (name_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aT5, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$183 =
		                  caml_callback
		                   (schema_versioned$463,
		                    [function(param, cont){return cont(0);}]),
		                Name =
		                  caml_callback(A, [[0, schema_versioned$463, schema$183]]),
		                letrec_function_context$739 = [];
		               function schema_versioned$464(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$739[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aT6, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$739[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$739[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$739[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  current = a[2][1],
		                                  job_title = a[1],
		                                  name = param[1];
		                                 return cont([0, name, job_title, current]);
		                                },
		                                function(param, cont){
		                                 var
		                                  current = param[3],
		                                  job_title = param[2],
		                                  name = param[1];
		                                 return cont([0, name, [0, job_title, [0, current, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_job_title,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, 0, 0, 0, 0, cst_current, 0, 3, [0, bool_schema], 0, 0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$739[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$739[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$698 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$739, [0, schematic_cache$698]);
		               caml_callback
		                (schema_versioned$464,
		                 [function(param, cont){return cont(0);}]);
		               function equal$244(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                a:
		                if(c){
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b$0 = y[1], a$0 = x[1], c = a$0 === b$0 ? 1 : 0;
		                   break a;
		                  }
		                 }
		                 else if(! y){c = 1; break a;}
		                 c = 0;
		                }
		                if(! c) return cont(c);
		                var y$0 = rhs[3], x$0 = lhs[3];
		                if(x$0){
		                 if(y$0){
		                  var b$1 = y$0[1], a$1 = x$0[1];
		                  return cont(a$1 === b$1 ? 1 : 0);
		                 }
		                }
		                else if(! y$0) return cont(1);
		                return cont(0);
		               }
		               var
		                Organizations =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, schema_versioned$464, , equal$244]]);
		               function schema_versioned$465(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                Phones =
		                  caml_callback
		                   (Fugue_diffable$0, [[0, schema_versioned$465, , equal$4]]),
		                Source = caml_callback(b8, [[0, schema_versioned$340]]),
		                letrec_function_context$740 = [];
		               function schema_versioned$466(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$740[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$740[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$740[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$740[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$50,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Source[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_source, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (String_opt_LWW[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_photo, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Phones[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_phones, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$116,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_owner, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$6,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_other_emails, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (Organizations[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_organizations, 0, 2, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (Name[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$3,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_email, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (String_opt_LWW[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_address, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$339,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        writable = i[2][1],
		                        source = i[1],
		                        photo = h[1],
		                        phones = g[1],
		                        owner = f[1],
		                        other_emails = e[1],
		                        organizations = d[1],
		                        name = c[1],
		                        email = b[1],
		                        address = a[1],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 address,
		                                 email,
		                                 name,
		                                 organizations,
		                                 other_emails,
		                                 owner,
		                                 phones,
		                                 photo,
		                                 source,
		                                 writable]);
		                      },
		                      function(param, cont){
		                       var
		                        writable = param[11],
		                        source = param[10],
		                        photo = param[9],
		                        phones = param[8],
		                        owner = param[7],
		                        other_emails = param[6],
		                        organizations = param[5],
		                        name = param[4],
		                        email = param[3],
		                        address = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0,
		                                  address,
		                                  [0,
		                                   email,
		                                   [0,
		                                    name,
		                                    [0,
		                                     organizations,
		                                     [0,
		                                      other_emails,
		                                      [0,
		                                       owner,
		                                       [0, phones, [0, photo, [0, source, [0, writable, 0]]]]]]]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$740[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$740[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$699 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$740, [0, schematic_cache$699]);
		               caml_callback
		                (schema_versioned$466,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Organizations = "Organizations",
		                letrec_function_context$741 = [];
		               function schema_versioned$467(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$741[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aT7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$741[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$741[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$741[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$69,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([7, f0]);},
		   function(param, cont){
		    if(7 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aT8,
		   cst_writable,
		   cst_Writable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_stored, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (String_opt_LWW[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(6 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aT9,
		             cst_photo,
		             "Photo",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_photo, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Phones[6],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([5, f0]);},
		                       function(param, cont){
		                        if(5 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aT_,
		                       cst_phones,
		                       "Phones",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_phones, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$7,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(4 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aT$,
		                                 cst_other_emails,
		                                 "Other_emails",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_other_emails, 0, 2, [0, c], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Organizations[6],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUa,
		   cst_organizations,
		   cst_Organizations,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_organizations, 0, 2, [0, c], 0, 0],
		      0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Name[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aUb,
		             cst_name,
		             cst_Name,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$4,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aUc,
		                       cst_email,
		                       cst_Email,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_email, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (String_opt_LWW[4],
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aUd,
		                                  cst_address,
		                                  "Address",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0, [0, 0, 0, 0, 0, cst_address, 0, 2, [0, b], 0, 0], 0]],
		                                   0],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$741[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$741[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$700 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$741, [0, schematic_cache$700]);
		               caml_callback
		                (schema_versioned$467,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$742 = [];
		               function equal$245(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$742[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$742, [0, equal$219]);
		               function state_schema_versioned$51(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$466,
		                                   schematic_version,
		                                   function(a){return cont([0, aUe, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                state_schema$20 =
		                  caml_callback
		                   (state_schema_versioned$51,
		                    [function(param, cont){return cont(0);}]),
		                include$231 = Monadic$0(),
		                v$31 = include$231[1],
		                const$15 = include$231[2],
		                Apply$28 = include$231[14];
		               function apply$81(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var op = param[1];
		                             return caml_trampoline_cps_call4
		                                     (String_opt_LWW[8],
		                                      replica,
		                                      state[2],
		                                      op,
		                                      function(match){
		                                       var address = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    address,
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8],
		                    state[9],
		                    state[10],
		                    state[11]]]);
		        });
		                                      });
		                            case 1:
		                             var op$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$10,
		                                      replica,
		                                      state[3],
		                                      op$0,
		                                      function(match){
		                                       var email = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    email,
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8],
		                    state[9],
		                    state[10],
		                    state[11]]]);
		        });
		                                      });
		                            case 2:
		                             var op$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Name[8],
		                                      replica,
		                                      state[4],
		                                      op$1,
		                                      function(match){
		                                       var name = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    name,
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8],
		                    state[9],
		                    state[10],
		                    state[11]]]);
		        });
		                                      });
		                            case 3:
		                             var op$2 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Organizations[10],
		                                      replica,
		                                      state[5],
		                                      op$2,
		                                      function(match){
		                                       var
		organizations = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([3, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    organizations,
		                    state[6],
		                    state[7],
		                    state[8],
		                    state[9],
		                    state[10],
		                    state[11]]]);
		        });
		                                      });
		                            case 4:
		                             var op$3 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$13,
		                                      replica,
		                                      state[6],
		                                      op$3,
		                                      function(match){
		                                       var
		other_emails = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([4, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    other_emails,
		                    state[7],
		                    state[8],
		                    state[9],
		                    state[10],
		                    state[11]]]);
		        });
		                                      });
		                            case 5:
		                             var op$4 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Phones[10],
		                                      replica,
		                                      state[8],
		                                      op$4,
		                                      function(match){
		                                       var phones = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([5, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    phones,
		                    state[9],
		                    state[10],
		                    state[11]]]);
		        });
		                                      });
		                            case 6:
		                             var op$5 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (String_opt_LWW[8],
		                                      replica,
		                                      state[9],
		                                      op$5,
		                                      function(match){
		                                       var photo = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([6, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8],
		                    photo,
		                    state[10],
		                    state[11]]]);
		        });
		                                      });
		                            default:
		                             var op$6 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$80,
		                                      replica,
		                                      state[11],
		                                      op$6,
		                                      function(match){
		                                       var writable = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([7, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8],
		                    state[9],
		                    state[10],
		                    writable]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$77(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[11],
		                    b = state[10],
		                    c = state[9],
		                    d = state[8],
		                    e = state[7],
		                    f = state[6],
		                    g = state[5],
		                    h = state[4],
		                    i = state[3];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[9],
		                            replica,
		                            state[2],
		                            delta,
		                            function(j){
		                             return cont([0, state[1], j, i, h, g, f, e, d, c, b, a]);
		                            });
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    j = state[11],
		                    k = state[10],
		                    l = state[9],
		                    m = state[8],
		                    n = state[7],
		                    o = state[6],
		                    p = state[5],
		                    q = state[4];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[3],
		                            delta$0,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], a, q, p, o, n, m, l, k, j]);
		                            });
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    r = state[11],
		                    s = state[10],
		                    t = state[9],
		                    u = state[8],
		                    v = state[7],
		                    w = state[6],
		                    x = state[5];
		                   return caml_trampoline_cps_call4
		                           (Name[9],
		                            replica,
		                            state[4],
		                            delta$1,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], a, x, w, v, u, t, s, r]);
		                            });
		                  case 3:
		                   var
		                    delta$2 = param[1],
		                    y = state[11],
		                    z = state[10],
		                    A = state[9],
		                    B = state[8],
		                    C = state[7],
		                    D = state[6];
		                   return caml_trampoline_cps_call4
		                           (Organizations[11],
		                            replica,
		                            state[5],
		                            delta$2,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       a,
		                                       D,
		                                       C,
		                                       B,
		                                       A,
		                                       z,
		                                       y]);
		                            });
		                  case 4:
		                   var
		                    delta$3 = param[1],
		                    E = state[11],
		                    F = state[10],
		                    G = state[9],
		                    H = state[8],
		                    I = state[7];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$9,
		                            replica,
		                            state[6],
		                            delta$3,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       a,
		                                       I,
		                                       H,
		                                       G,
		                                       F,
		                                       E]);
		                            });
		                  case 5:
		                   var
		                    delta$4 = param[1],
		                    J = state[11],
		                    K = state[10],
		                    L = state[9];
		                   return caml_trampoline_cps_call4
		                           (Phones[11],
		                            replica,
		                            state[8],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       a,
		                                       L,
		                                       K,
		                                       J]);
		                            });
		                  case 6:
		                   var delta$5 = param[1], M = state[11], N = state[10];
		                   return caml_trampoline_cps_call4
		                           (String_opt_LWW[9],
		                            replica,
		                            state[9],
		                            delta$5,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       a,
		                                       N,
		                                       M]);
		                            });
		                  default:
		                   var delta$6 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$76,
		                            replica,
		                            state[11],
		                            delta$6,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8],
		                                       state[9],
		                                       state[10],
		                                       a]);
		                            });
		                }
		               }
		               var
		                include$232 =
		                  caml_callback
		                   (Apply$28,
		                    [[0, [0, schema_versioned$467], apply_delta$77, apply$81]]),
		                delta_schema_versioned$70 = include$232[1],
		                delta_schema$20 = include$232[2],
		                apply_delta$78 = include$232[3],
		                apply$82 = include$232[4];
		               function make$110(param, cont){
		                var
		                 writable = param[11],
		                 source = param[10],
		                 organizations = param[9],
		                 phones = param[8],
		                 photo = param[7],
		                 address = param[6],
		                 name = param[5],
		                 owner = param[4],
		                 other_emails = param[3],
		                 email = param[2],
		                 id = param[1],
		                 extension_row = writable[3],
		                 archived = writable[2],
		                 notes = writable[1];
		                return caml_exact_trampoline_cps_call
		                        (make$80,
		                         extension_row,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Earliest[11],
		                                   archived,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (make$72,
		     notes,
		     function(d){
		      var c = [0, d, b, a];
		      return caml_exact_trampoline_cps_call
		              (Source[10],
		               source,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (String_opt_LWW[10],
		                         photo,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (Phones[12],
		                                   phones,
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call
		    (make$69,
		     other_emails,
		     function(e){
		      return caml_exact_trampoline_cps_call
		              (Organizations[12],
		               organizations,
		               function(f){
		                return caml_exact_trampoline_cps_call
		                        (Name[10],
		                         name,
		                         function(g){
		                          return caml_exact_trampoline_cps_call
		                                  (make$66,
		                                   email,
		                                   function(h){
		                                    return caml_exact_trampoline_cps_call
		    (String_opt_LWW[10],
		     address,
		     function(i){
		      return cont([0, id, i, h, g, f, e, owner, d, b, a, c]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$49(param, cont){
		                var
		                 writable = param[11],
		                 source = param[10],
		                 photo = param[9],
		                 phones = param[8],
		                 owner = param[7],
		                 other_emails = param[6],
		                 organizations = param[5],
		                 name = param[4],
		                 email = param[3],
		                 address = param[2],
		                 id = param[1],
		                 extension_row = writable[3],
		                 archived = writable[2],
		                 notes = writable[1];
		                return caml_exact_trampoline_cps_call
		                        (view$19,
		                         extension_row,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Earliest[12],
		                                   archived,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (view$11,
		     notes,
		     function(d){
		      var c = [0, d, b, a];
		      return caml_exact_trampoline_cps_call
		              (Source[11],
		               source,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (Organizations[19],
		                         organizations,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (Phones[19],
		                                   phones,
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call
		    (String_opt_LWW[11],
		     photo,
		     function(e){
		      return caml_exact_trampoline_cps_call
		              (String_opt_LWW[11],
		               address,
		               function(f){
		                return caml_exact_trampoline_cps_call
		                        (Name[11],
		                         name,
		                         function(g){
		                          return caml_exact_trampoline_cps_call
		                                  (view$8,
		                                   other_emails,
		                                   function(h){
		                                    return caml_exact_trampoline_cps_call
		    (to_binable,
		     h,
		     function(h){
		      return caml_exact_trampoline_cps_call
		              (view$4,
		               email,
		               function(i){
		                return caml_trampoline_cps_call2
		                        (include$0[5],
		                         [0, id, i, h, owner, g, f, e, d, b, a, c],
		                         cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function notes$2(op, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$30,
		                         [2, op],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$31, [7, a], cont);
		                         });
		               }
		               caml_callback
		                (M$2, [[0, comparator$2, thread_id_schema_versioned]]);
		               function Make$50(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$15],
		                      state_schema_versioned$51,
		                      state_schema$20,
		                      delta_schema_versioned$70,
		                      delta_schema$20,
		                      [0, schema_versioned$341, schema$142],
		                      include$0,
		                      apply$82,
		                      apply_delta$78,
		                      make$110,
		                      view$49,
		                      equal$245]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$245,
		                    [0, const$15],
		                    state_schema_versioned$51,
		                    state_schema$20,
		                    delta_schema_versioned$70,
		                    delta_schema$20,
		                    [0, schema_versioned$341, schema$142],
		                    include$0,
		                    apply$82,
		                    apply_delta$78,
		                    make$110,
		                    view$49];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$339,
		                          schema$140,
		                          symbol$200,
		                          symbol$201,
		                          symbol$202,
		                          symbol$203,
		                          symbol$204,
		                          symbol$205,
		                          equal$215,
		                          compare$128,
		                          min$29,
		                          max$31,
		                          ascending$20,
		                          descending$20,
		                          between$21,
		                          clamp_exn$20,
		                          clamp$20,
		                          comparator$41,
		                          pp$114],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$233 = caml_callback(Make$50, [Ident]),
		                delta_schema_versioned$71 = include$233[5],
		                element$14 = include$233[15],
		                element$15 = include$233[16],
		                include$234 =
		                  caml_callback(A, [[0, schema_versioned$15, schema$10]]),
		                state_schema_versioned$52 = include$234[2],
		                delta_schema_versioned$72 = include$234[4],
		                apply$83 = include$234[8],
		                apply_delta$79 = include$234[9],
		                make$111 = include$234[10],
		                view$50 = include$234[11],
		                set$20 = include$234[12],
		                letrec_function_context$743 = [];
		               function schema_versioned$468(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$743[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$743[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$743[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$743[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   aUf,
		   cst_archived,
		   cst_Archived,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var time = param[1];
		      return cont(time);
		     },
		     function(time, cont){return cont([0, time, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_archived, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){
		               return typeof param === "number" ? cont(aUi) : cont(0);
		              },
		              0,
		              0,
		              cst_todo,
		              cst_Open,
		              aUh,
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([0, f0]);},
		               function(param, cont){
		                if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                return cont(0);
		               },
		               1,
		               aUg,
		               cst_completed,
		               cst_Completed,
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var time = param[1];
		                  return cont(time);
		                 },
		                 function(time, cont){return cont([0, time, 0]);},
		                 [0, [0, 0, 0, 0, 0, cst_completed, 0, 2, [0, b], 0, 0], 0]],
		                0],
		               0],
		              a]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$743[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$743[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$701 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$743, [0, schematic_cache$701]);
		               caml_callback
		                (schema_versioned$468,
		                 [function(param, cont){return cont(0);}]);
		               function make$112(completed, archived, param){
		                if(completed){var time = completed[1]; return [0, time];}
		                if(! archived) return 0;
		                var time$0 = archived[1];
		                return [1, time$0];
		               }
		               function to_archived_completed(param){
		                if(typeof param === "number") return aUj;
		                if(0 === param[0]){
		                 var time = param[1];
		                 return [0, 0, [0, time]];
		                }
		                var time$0 = param[1];
		                return [0, [0, time$0], 0];
		               }
		               function schema_versioned$469(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$468,
		                                   schematic_version,
		                                   function(a){return cont([0, aUk, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$184 =
		                  caml_callback
		                   (schema_versioned$469,
		                    [function(param, cont){return cont(0);}]);
		               function resolve$4(left, right, cont){
		                if(typeof left === "number") return cont(1);
		                if(0 === left[0]){
		                 if(typeof right !== "number"){
		                  if(0 !== right[0]) return cont(1);
		                  var tr = right[1], tl = left[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$74, tl, tr, cont);
		                 }
		                }
		                else {
		                 var tl$0 = left[1];
		                 if(typeof right !== "number" && 0 !== right[0]){
		                  var tr$0 = right[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$74, tl$0, tr$0, cont);
		                 }
		                }
		                return cont(0);
		               }
		               var
		                Status$2 =
		                  caml_callback
		                   (Make_var,
		                    [[0, schema_versioned$469, schema$184, resolve$4]]);
		               function schema_versioned$470(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$185,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aUl, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$185 =
		                  caml_callback
		                   (schema_versioned$470,
		                    [function(param, cont){return cont(0);}]),
		                Scheduled =
		                  caml_callback(A, [[0, schema_versioned$470, schema$185]]);
		               function schema_versioned$471(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont([0, bL, 0, bool_schema[3], bool_schema[4]]);
		                         });
		               }
		               var schema$271 = [0, bL, 0, bool_schema[3], bool_schema[4]];
		               function resolve$5(vl, param, cont){return cont(vl);}
		               var
		                Starred =
		                  caml_callback
		                   (Make_var,
		                    [[0, schema_versioned$471, schema$271, resolve$5]]);
		               function schema_versioned$472(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (occurrence_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aUm, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$186 =
		                  caml_callback
		                   (schema_versioned$472,
		                    [function(param, cont){return cont(0);}]),
		                Occurrence =
		                  caml_callback(A, [[0, schema_versioned$472, schema$186]]),
		                include$235 = Monadic$0(),
		                v$32 = include$235[1],
		                Apply$29 = include$235[14],
		                letrec_function_context$744 = [];
		               function state_schema_versioned$53(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$744[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$744[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$744[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$744[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (state_schema_versioned$4,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_url, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$3,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (state_schema_versioned$2,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        url = a[2][1],
		                        title = a[1],
		                        notes = param[1];
		                       return cont([0, notes, title, url]);
		                      },
		                      function(param, cont){
		                       var url = param[3], title = param[2], notes = param[1];
		                       return cont([0, notes, [0, title, [0, url, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$744[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$744[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$702 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$744, [0, schematic_cache$702]);
		               caml_callback
		                (state_schema_versioned$53,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$745 = [];
		               function schema_versioned$473(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$745[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUo, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$745[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$745[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$745[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$5,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUp,
		   cst_url,
		   cst_Url,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_url, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aUq,
		             cst_title,
		             cst_Title,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_title, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$3,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aUr,
		                        cst_notes,
		                        cst_Notes,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$745[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$745[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$703 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$745, [0, schematic_cache$703]);
		               caml_callback
		                (schema_versioned$473,
		                 [function(param, cont){return cont(0);}]);
		               function apply$84(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var operation = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$9,
		                                      replica,
		                                      state[1],
		                                      operation,
		                                      function(match){
		                                       var notes = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta){
		         return cont([0, res, delta, [0, notes, state[2], state[3]]]);
		        });
		                                      });
		                            case 1:
		                             var operation$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$10,
		                                      replica,
		                                      state[2],
		                                      operation$0,
		                                      function(match){
		                                       var title = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta){
		         return cont([0, res, delta, [0, state[1], title, state[3]]]);
		        });
		                                      });
		                            default:
		                             var operation$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$11,
		                                      replica,
		                                      state[3],
		                                      operation$1,
		                                      function(match){
		                                       var url = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta){
		         return cont([0, res, delta, [0, state[1], state[2], url]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$80(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var delta = param[1], a = state[3], b = state[2];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$5,
		                            replica,
		                            state[1],
		                            delta,
		                            function(c){return cont([0, c, b, a]);});
		                  case 1:
		                   var delta$0 = param[1], c = state[3];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){return cont([0, state[1], a, c]);});
		                  default:
		                   var delta$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$7,
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){return cont([0, state[1], state[2], a]);});
		                }
		               }
		               var
		                include$236 =
		                  caml_callback
		                   (Apply$29,
		                    [[0, [0, schema_versioned$473], apply_delta$80, apply$84]]),
		                delta_schema_versioned$73 = include$236[1],
		                apply_delta$81 = include$236[3],
		                apply$85 = include$236[4];
		               function make$113(param, cont){
		                var url$0 = param[3], title = param[2], notes = param[1];
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (make$66,
		                          title,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (make$72, notes, function(c){return cont([0, c, b, a]);});
		                          });
		                }
		                if(! url$0) return caml_trampoline_cps_call2(bQA, cst$1, a);
		                var url = url$0[1];
		                return caml_exact_trampoline_cps_call$1
		                        (to_string$25,
		                         0,
		                         url,
		                         function(b){return caml_trampoline_cps_call2(bQA, b, a);});
		               }
		               function view$51(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (view$11,
		                         state[1],
		                         function(notes){
		                          return caml_exact_trampoline_cps_call
		                                  (view$4,
		                                   state[2],
		                                   function(title){
		                                    return caml_exact_trampoline_cps_call
		    (view$6,
		     state[3],
		     function(url){return cont([0, notes, title, url]);});
		                                   });
		                         });
		               }
		               function notes$3(op, cont){
		                return caml_exact_trampoline_cps_call(v$32, [0, op], cont);
		               }
		               function title$0(op, cont){
		                return caml_exact_trampoline_cps_call(v$32, [1, op], cont);
		               }
		               function url(op, cont){
		                return caml_exact_trampoline_cps_call(v$32, [2, op], cont);
		               }
		               var letrec_function_context$746 = [];
		               function state_schema_versioned$54(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$746[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$746[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$746[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$746[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$53,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_templatable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Occurrence[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_occurrence, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Status$2[3],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Starred[3],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_starred, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Scheduled[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_scheduled, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (Parent[2],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_parent, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (integration_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_integration, 0, 3, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$16,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  templatable = f[2][1],
		                                  occurrence = f[1],
		                                  status = e[1],
		                                  starred = d[1],
		                                  scheduled = c[1],
		                                  parent = b[1],
		                                  integration = a[1],
		                                  extension_row = param[1];
		                                 return cont
		 ([0,
		   extension_row,
		   integration,
		   parent,
		   scheduled,
		   starred,
		   status,
		   occurrence,
		   templatable]);
		                                },
		                                function(param, cont){
		                                 var
		                                  templatable = param[8],
		                                  occurrence = param[7],
		                                  status = param[6],
		                                  starred = param[5],
		                                  scheduled = param[4],
		                                  parent = param[3],
		                                  integration = param[2],
		                                  extension_row = param[1];
		                                 return cont
		 ([0,
		   extension_row,
		   [0,
		    integration,
		    [0,
		     parent,
		     [0,
		      scheduled,
		      [0,
		       starred,
		       [0, status, [0, occurrence, [0, templatable, 0]]]]]]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, b], 0, 0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$746[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$746[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$704 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$746, [0, schematic_cache$704]);
		               caml_callback
		                (state_schema_versioned$54,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$237 = Monadic$0(),
		                v$33 = include$237[1],
		                Apply$30 = include$237[14],
		                cst_Parent = "Parent",
		                cst_Starred = "Starred",
		                cst_Templatable = "Templatable",
		                letrec_function_context$747 = [];
		               function schema_versioned$474(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$747[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUt, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$747[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$747[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$747[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$73,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(6 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUu,
		   cst_templatable,
		   cst_Templatable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_templatable, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Status$2[5],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(5 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aUv,
		             cst_status,
		             cst_Status,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Starred[5],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(4 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aUw,
		                       cst_starred,
		                       cst_Starred,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_starred, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Scheduled[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aUx,
		                                 cst_scheduled,
		                                 "Scheduled",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_scheduled, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Parent[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUy,
		   cst_parent,
		   cst_Parent,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_parent, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Occurrence[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aUz,
		             cst_occurrence,
		             "Occurrence",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_occurrence, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$23,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aUA,
		                        cst_extension_row,
		                        cst_Extension_row,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0,
		                           [0, 0, 0, 0, 0, cst_extension_row, 0, 2, [0, a], 0, 0],
		                           0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$747[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$747[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$705 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$747, [0, schematic_cache$705]);
		               caml_callback
		                (schema_versioned$474,
		                 [function(param, cont){return cont(0);}]);
		               function apply$86(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var operation = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$31,
		                                      replica,
		                                      state[1],
		                                      operation,
		                                      function(match){
		                                       var
		extension_row = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    extension_row,
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8]]]);
		        });
		                                      });
		                            case 1:
		                             var operation$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Parent[8],
		                                      replica,
		                                      state[3],
		                                      operation$0,
		                                      function(match){
		                                       var parent = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    parent,
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8]]]);
		        });
		                                      });
		                            case 2:
		                             var operation$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Scheduled[8],
		                                      replica,
		                                      state[4],
		                                      operation$1,
		                                      function(match){
		                                       var scheduled = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([3, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    scheduled,
		                    state[5],
		                    state[6],
		                    state[7],
		                    state[8]]]);
		        });
		                                      });
		                            case 3:
		                             var operation$2 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Starred[9],
		                                      replica,
		                                      state[5],
		                                      operation$2,
		                                      function(match){
		                                       var starred = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([4, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    starred,
		                    state[6],
		                    state[7],
		                    state[8]]]);
		        });
		                                      });
		                            case 4:
		                             var operation$3 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Status$2[9],
		                                      replica,
		                                      state[6],
		                                      operation$3,
		                                      function(match){
		                                       var status = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([5, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    status,
		                    state[7],
		                    state[8]]]);
		        });
		                                      });
		                            case 5:
		                             var operation$4 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Occurrence[8],
		                                      replica,
		                                      state[7],
		                                      operation$4,
		                                      function(match){
		                                       var occurrence = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    occurrence,
		                    state[8]]]);
		        });
		                                      });
		                            default:
		                             var operation$5 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$85,
		                                      replica,
		                                      state[8],
		                                      operation$5,
		                                      function(match){
		                                       var
		templatable = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([6, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7],
		                    templatable]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$82(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[8],
		                    b = state[7],
		                    c = state[6],
		                    d = state[5],
		                    e = state[4],
		                    f = state[3],
		                    g = state[2];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$27,
		                            replica,
		                            state[1],
		                            delta,
		                            function(h){return cont([0, h, g, f, e, d, c, b, a]);});
		                  case 1:
		                   var delta$0 = param[1], h = state[8];
		                   return caml_trampoline_cps_call4
		                           (Occurrence[9],
		                            replica,
		                            state[7],
		                            delta$0,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       a,
		                                       h]);
		                            });
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    i = state[8],
		                    j = state[7],
		                    k = state[6],
		                    l = state[5],
		                    m = state[4];
		                   return caml_trampoline_cps_call4
		                           (Parent[9],
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){
		                             return cont([0, state[1], state[2], a, m, l, k, j, i]);
		                            });
		                  case 3:
		                   var
		                    delta$2 = param[1],
		                    n = state[8],
		                    o = state[7],
		                    p = state[6],
		                    q = state[5];
		                   return caml_trampoline_cps_call4
		                           (Scheduled[9],
		                            replica,
		                            state[4],
		                            delta$2,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], a, q, p, o, n]);
		                            });
		                  case 4:
		                   var
		                    delta$3 = param[1],
		                    r = state[8],
		                    s = state[7],
		                    t = state[6];
		                   return caml_trampoline_cps_call4
		                           (Starred[10],
		                            replica,
		                            state[5],
		                            delta$3,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], a, t, s, r]);
		                            });
		                  case 5:
		                   var delta$4 = param[1], u = state[8], v = state[7];
		                   return caml_trampoline_cps_call4
		                           (Status$2[10],
		                            replica,
		                            state[6],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       a,
		                                       v,
		                                       u]);
		                            });
		                  default:
		                   var delta$5 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$81,
		                            replica,
		                            state[8],
		                            delta$5,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       a]);
		                            });
		                }
		               }
		               var
		                include$238 =
		                  caml_callback
		                   (Apply$30,
		                    [[0, [0, schema_versioned$474], apply_delta$82, apply$86]]),
		                delta_schema_versioned$74 = include$238[1],
		                apply_delta$83 = include$238[3],
		                apply$87 = include$238[4];
		               function schematic_version$96(param, cont){return cont(0);}
		               caml_callback(Read$0[4], [schematic_version$96]);
		               caml_callback(b8, [[0, schema_versioned$5]]);
		               var
		                include$239 =
		                  caml_callback
		                   (bOD,
		                    [[0,
		                      schema_versioned$102,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$14,
		                      pp$35]]),
		                state_schema_versioned$55 = include$239[2],
		                delta_schema_versioned$75 = include$239[4],
		                apply$88 = include$239[8],
		                apply_delta$84 = include$239[9],
		                make$114 = include$239[10],
		                view$52 = include$239[11],
		                add$26 = include$239[13],
		                remove$16 = include$239[14];
		               function schema_versioned$475(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$180,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){return cont([0, aUB, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               var
		                schema$187 =
		                  caml_callback
		                   (schema_versioned$475,
		                    [function(param, cont){return cont();}]);
		               function resolve$6(left, right, cont){
		                if(! left) return cont(1);
		                if(! right) return cont(0);
		                var right$0 = right[1], left$0 = left[1];
		                return cont(caml_lessequal(left$0, right$0));
		               }
		               var
		                Client_id =
		                  caml_callback
		                   (Make_var,
		                    [[0, schema_versioned$475, schema$187, resolve$6]]),
		                letrec_function_context$748 = [];
		               function schema_versioned$476(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$748[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$748[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$748[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$748[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$74,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUD,
		   cst_writable,
		   cst_Writable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Earliest[5],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aUE,
		             cst_deleted,
		             cst_Deleted,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_deleted, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$75,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aUF,
		                        cst_allocations,
		                        "Allocations",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_allocations, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$748[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$748[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$706 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$748, [0, schematic_cache$706]);
		               caml_callback
		                (schema_versioned$476,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$749 = [];
		               function equal$246(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$749[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$749, [0, equal$106]);
		               var letrec_function_context$750 = [];
		               function state_schema_versioned$56(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$750[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$750[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$750[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$750[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$54,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$109,
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$141,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_etag, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Earliest[3],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_deleted, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Created[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (Client_id[3],
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_client, 0, 2, [0, c], 0, 0], a];
		        return caml_trampoline_cps_call2
		                (state_schema_versioned$55,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        writable = e[2][1],
		                        id = e[1],
		                        etag = d[1],
		                        deleted = c[1],
		                        created = b[1],
		                        client = a[1],
		                        allocations = param[1];
		                       return cont
		                               ([0,
		                                 allocations,
		                                 client,
		                                 created,
		                                 deleted,
		                                 etag,
		                                 id,
		                                 writable]);
		                      },
		                      function(param, cont){
		                       var
		                        writable = param[7],
		                        id = param[6],
		                        etag = param[5],
		                        deleted = param[4],
		                        created = param[3],
		                        client = param[2],
		                        allocations = param[1];
		                       return cont
		                               ([0,
		                                 allocations,
		                                 [0,
		                                  client,
		                                  [0,
		                                   created,
		                                   [0, deleted, [0, etag, [0, id, [0, writable, 0]]]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_allocations, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$750[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$750[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$707 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$750, [0, schematic_cache$707]);
		               var
		                state_schema$21 =
		                  caml_callback
		                   (state_schema_versioned$56,
		                    [function(param, cont){return cont(0);}]),
		                include$240 = Monadic$0(),
		                v$34 = include$240[1],
		                const$16 = include$240[2],
		                ignore_m$9 = include$240[10],
		                all_unit$18 = include$240[12],
		                Apply$31 = include$240[14];
		               function apply$89(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var op = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$88,
		                                      replica,
		                                      state[1],
		                                      op,
		                                      function(match){
		                                       var
		allocations = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    allocations,
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    state[7]]]);
		        });
		                                      });
		                            case 1:
		                             var op$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Earliest[9],
		                                      replica,
		                                      state[4],
		                                      op$0,
		                                      function(match){
		                                       var deleted = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    deleted,
		                    state[5],
		                    state[6],
		                    state[7]]]);
		        });
		                                      });
		                            default:
		                             var op$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$87,
		                                      replica,
		                                      state[7],
		                                      op$1,
		                                      function(match){
		                                       var writable = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6],
		                    writable]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$85(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[7],
		                    b = state[6],
		                    c = state[5],
		                    d = state[4],
		                    e = state[3],
		                    f = state[2];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$84,
		                            replica,
		                            state[1],
		                            delta,
		                            function(g){return cont([0, g, f, e, d, c, b, a]);});
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    g = state[7],
		                    h = state[6],
		                    i = state[5];
		                   return caml_trampoline_cps_call4
		                           (Earliest[10],
		                            replica,
		                            state[4],
		                            delta$0,
		                            function(a){
		                             return cont([0, state[1], state[2], state[3], a, i, h, g]);
		                            });
		                  default:
		                   var delta$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$83,
		                            replica,
		                            state[7],
		                            delta$1,
		                            function(a){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       a]);
		                            });
		                }
		               }
		               var
		                include$241 =
		                  caml_callback
		                   (Apply$31,
		                    [[0, [0, schema_versioned$476], apply_delta$85, apply$89]]),
		                delta_schema_versioned$76 = include$241[1],
		                delta_schema$21 = include$241[2],
		                apply_delta$86 = include$241[3],
		                apply$90 = include$241[4];
		               function make$115(param, cont){
		                var
		                 writable = param[7],
		                 id = param[6],
		                 etag = param[5],
		                 deleted = param[4],
		                 created = param[3],
		                 client = param[2],
		                 allocations = param[1],
		                 templatable = writable[9],
		                 starred = writable[8],
		                 scheduled = writable[7],
		                 parent = writable[6],
		                 occurrence = writable[5],
		                 integration = writable[4],
		                 extension_row = writable[3],
		                 completed = writable[2],
		                 archived = writable[1],
		                 status = make$112(completed, archived);
		                return caml_exact_trampoline_cps_call
		                        (make$113,
		                         templatable,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Occurrence[10],
		                                   occurrence,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Status$2[11],
		     status,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Starred[11],
		               starred,
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Scheduled[10],
		                         scheduled,
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Parent[10],
		                                   parent,
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (make$80,
		     extension_row,
		     function(h){
		      var g = [0, h, integration, f, e, d, c, b, a];
		      return caml_exact_trampoline_cps_call
		              (Earliest[11],
		               deleted,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (Created[10],
		                         created,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (Client_id[11],
		                                   client,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_list$2,
		     [0, comparator$14],
		     allocations,
		     function(d){
		      return caml_exact_trampoline_cps_call
		              (make$114,
		               d,
		               function(d){return cont([0, d, c, b, a, etag, id, g]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$53(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (view$52,
		                         state[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_list$3,
		                                   a,
		                                   function(allocations){
		                                    return caml_exact_trampoline_cps_call
		    (Client_id[12],
		     state[2],
		     function(client){
		      return caml_exact_trampoline_cps_call
		              (Created[11],
		               state[3],
		               function(created){
		                return caml_exact_trampoline_cps_call
		                        (Earliest[12],
		                         state[4],
		                         function(deleted){
		                          var
		                           etag = state[5],
		                           id = state[6],
		                           param = state[7],
		                           templatable = param[8],
		                           occurrence = param[7],
		                           status = param[6],
		                           starred = param[5],
		                           scheduled = param[4],
		                           parent = param[3],
		                           integration = param[2],
		                           extension_row = param[1];
		                          return caml_exact_trampoline_cps_call
		                                  (Status$2[12],
		                                   status,
		                                   function(a){
		                                    a = to_archived_completed(a);
		                                    var completed = a[2], archived = a[1];
		                                    return caml_exact_trampoline_cps_call
		    (view$51,
		     templatable,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (Starred[12],
		               starred,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (Scheduled[11],
		                         scheduled,
		                         function(c){
		                          return caml_exact_trampoline_cps_call
		                                  (Parent[11],
		                                   parent,
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call
		    (Occurrence[11],
		     occurrence,
		     function(e){
		      return caml_exact_trampoline_cps_call
		              (view$19,
		               extension_row,
		               function(f){
		                var
		                 writable =
		                   [0, archived, completed, f, integration, e, d, c, b, a],
		                 view =
		                   [0,
		                    allocations,
		                    client,
		                    created,
		                    deleted,
		                    etag,
		                    id,
		                    writable];
		                return cont(view);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function allocations(op, cont){
		                return caml_exact_trampoline_cps_call(v$34, [0, op], cont);
		               }
		               function set_scheduled(scho, cont){
		                return caml_exact_trampoline_cps_call
		                        (Scheduled[12],
		                         scho,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$33,
		                                   [2, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$34, [2, a], cont);
		                                   });
		                         });
		               }
		               function set_occurrence(occo, cont){
		                return caml_exact_trampoline_cps_call
		                        (Occurrence[12],
		                         occo,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$33,
		                                   [5, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$34, [2, a], cont);
		                                   });
		                         });
		               }
		               function set_parent$0(ido, cont){
		                return caml_exact_trampoline_cps_call
		                        (Parent[12],
		                         ido,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$33,
		                                   [1, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$34, [2, a], cont);
		                                   });
		                         });
		               }
		               function set_status$0(st, cont){
		                return caml_exact_trampoline_cps_call
		                        (Status$2[13],
		                         st,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$33,
		                                   [4, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$34, [2, a], cont);
		                                   });
		                         });
		               }
		               function notes$4(op, cont){
		                return caml_exact_trampoline_cps_call
		                        (notes$3,
		                         op,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$33,
		                                   [6, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$34, [2, a], cont);
		                                   });
		                         });
		               }
		               var letrec_function_context$751 = [];
		               function schema_versioned$477(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$751[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUH, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$751[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$751[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$751[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$73,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUI,
		   cst_templatable,
		   cst_Templatable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_templatable, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$72,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(1 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aUJ,
		             cst_recurrence,
		             cst_Recurrence,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Parent[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aUK,
		                        cst_parent,
		                        cst_Parent,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_parent, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$751[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$751[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$708 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$751, [0, schematic_cache$708]);
		               caml_callback
		                (schema_versioned$477,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$242 = Monadic$0(),
		                v$35 = include$242[1],
		                Apply$32 = include$242[14],
		                letrec_function_context$752 = [];
		               function state_schema_versioned$57(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$752[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUL, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$752[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$752[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$752[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$53,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_templatable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$52,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Parent[2],
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        templatable = a[2][1],
		                        recurrence = a[1],
		                        parent = param[1];
		                       return cont([0, parent, recurrence, templatable]);
		                      },
		                      function(param, cont){
		                       var
		                        templatable = param[3],
		                        recurrence = param[2],
		                        parent = param[1];
		                       return cont
		                               ([0, parent, [0, recurrence, [0, templatable, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_parent, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$752[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$752[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$709 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$752, [0, schematic_cache$709]);
		               caml_callback
		                (state_schema_versioned$57,
		                 [function(param, cont){return cont(0);}]);
		               function apply$91(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var op = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Parent[8],
		                                      replica,
		                                      state[1],
		                                      op,
		                                      function(match){
		                                       var parent = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta){
		         return cont
		                 ([0, res, delta, [0, parent, state[2], state[3]]]);
		        });
		                                      });
		                            case 1:
		                             var op$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$83,
		                                      replica,
		                                      state[2],
		                                      op$0,
		                                      function(match){
		                                       var recurrence = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta){
		         return cont
		                 ([0, res, delta, [0, state[1], recurrence, state[3]]]);
		        });
		                                      });
		                            default:
		                             var op$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (apply$85,
		                                      replica,
		                                      state[3],
		                                      op$1,
		                                      function(match){
		                                       var
		templatable = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta){
		         return cont
		                 ([0, res, delta, [0, state[1], state[2], templatable]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$87(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var delta = param[1], a = state[3], b = state[2];
		                   return caml_trampoline_cps_call4
		                           (Parent[9],
		                            replica,
		                            state[1],
		                            delta,
		                            function(c){return cont([0, c, b, a]);});
		                  case 1:
		                   var delta$0 = param[1], c = state[3];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$79,
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){return cont([0, state[1], a, c]);});
		                  default:
		                   var delta$1 = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$81,
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){return cont([0, state[1], state[2], a]);});
		                }
		               }
		               var
		                include$243 =
		                  caml_callback
		                   (Apply$32,
		                    [[0, [0, schema_versioned$477], apply_delta$87, apply$91]]),
		                delta_schema_versioned$77 = include$243[1],
		                apply_delta$88 = include$243[3],
		                apply$92 = include$243[4];
		               function schematic_version$97(param, cont){return cont(0);}
		               caml_callback(Read$5[5], [schematic_version$97]);
		               var letrec_function_context$753 = [];
		               function schema_versioned$478(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$753[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$753[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$753[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$753[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$57,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$187,
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$141,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_etag, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (Earliest[3],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_deleted, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Created[2],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    writable = c[2][1],
		    id = c[1],
		    etag = b[1],
		    deleted = a[1],
		    created = param[1];
		   return cont([0, created, deleted, etag, id, writable]);
		  },
		  function(param, cont){
		   var
		    writable = param[5],
		    id = param[4],
		    etag = param[3],
		    deleted = param[2],
		    created = param[1];
		   return cont
		           ([0,
		             created,
		             [0, deleted, [0, etag, [0, id, [0, writable, 0]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_created, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$753[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$753[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$710 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$753, [0, schematic_cache$710]);
		               caml_callback
		                (schema_versioned$478,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$754 = [];
		               function schema_versioned$479(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$754[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUM, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$754[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$754[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$754[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$77,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUN,
		   cst_writable,
		   cst_Writable,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_writable, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Earliest[5],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aUO,
		              cst_deleted,
		              cst_Deleted,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_deleted, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$754[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$754[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$711 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$754, [0, schematic_cache$711]);
		               caml_callback
		                (schema_versioned$479,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$755 = [];
		               function equal$247(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$755[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$755, [0, equal$108]);
		               function state_schema_versioned$58(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$478,
		                                   schematic_version,
		                                   function(a){return cont([0, aUP, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                state_schema$22 =
		                  caml_callback
		                   (state_schema_versioned$58,
		                    [function(param, cont){return cont(0);}]),
		                include$244 = Monadic$0(),
		                v$36 = include$244[1],
		                const$17 = include$244[2],
		                ignore_m$10 = include$244[10],
		                all_unit$19 = include$244[12],
		                Apply$33 = include$244[14];
		               function apply$93(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          if(0 === param[0]){
		                           var op = param[1];
		                           return caml_trampoline_cps_call4
		                                   (Earliest[9],
		                                    replica,
		                                    state[2],
		                                    op,
		                                    function(match){
		                                     var deleted = match[3], delta = match[2], res = match[1];
		                                     return caml_trampoline_cps_call3
		     (a,
		      delta,
		      function(delta, cont){return cont([0, delta]);},
		      function(delta){
		       return cont
		               ([0,
		                 res,
		                 delta,
		                 [0, state[1], deleted, state[3], state[4], state[5]]]);
		      });
		                                    });
		                          }
		                          var op$0 = param[1];
		                          return caml_trampoline_cps_call4
		                                  (apply$92,
		                                   replica,
		                                   state[5],
		                                   op$0,
		                                   function(match){
		                                    var writable = match[3], delta = match[2], res = match[1];
		                                    return caml_trampoline_cps_call3
		    (a,
		     delta,
		     function(delta, cont){return cont([1, delta]);},
		     function(delta){
		      return cont
		              ([0,
		                res,
		                delta,
		                [0, state[1], state[2], state[3], state[4], writable]]);
		     });
		                                   });
		                         });
		               }
		               function apply_delta$89(replica, state, param, cont){
		                if(0 === param[0]){
		                 var
		                  delta = param[1],
		                  a = state[5],
		                  b = state[4],
		                  c = state[3];
		                 return caml_trampoline_cps_call4
		                         (Earliest[10],
		                          replica,
		                          state[2],
		                          delta,
		                          function(d){return cont([0, state[1], d, c, b, a]);});
		                }
		                var delta$0 = param[1];
		                return caml_trampoline_cps_call4
		                        (apply_delta$88,
		                         replica,
		                         state[5],
		                         delta$0,
		                         function(a){
		                          return cont([0, state[1], state[2], state[3], state[4], a]);
		                         });
		               }
		               var
		                include$245 =
		                  caml_callback
		                   (Apply$33,
		                    [[0, [0, schema_versioned$479], apply_delta$89, apply$93]]),
		                delta_schema_versioned$78 = include$245[1],
		                delta_schema$22 = include$245[2],
		                apply_delta$90 = include$245[3],
		                apply$94 = include$245[4];
		               function make$116(param, cont){
		                var
		                 writable = param[5],
		                 id = param[4],
		                 etag = param[3],
		                 deleted = param[2],
		                 created = param[1],
		                 templatable = writable[3],
		                 recurrence = writable[2],
		                 parent = writable[1];
		                return caml_exact_trampoline_cps_call
		                        (make$113,
		                         templatable,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (make$111,
		                                   recurrence,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Parent[10],
		     parent,
		     function(d){
		      var c = [0, d, b, a];
		      return caml_exact_trampoline_cps_call
		              (Earliest[11],
		               deleted,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (Created[10],
		                         created,
		                         function(b){return cont([0, b, a, etag, id, c]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function view$54(state, cont){
		                var state$0 = state[5];
		                return caml_exact_trampoline_cps_call
		                        (view$51,
		                         state$0[3],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (view$50,
		                                   state$0[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Parent[11],
		     state$0[1],
		     function(f){
		      var c = [0, f, b, a], d = state[4], e = state[3];
		      return caml_exact_trampoline_cps_call
		              (Earliest[12],
		               state[2],
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (Created[11],
		                         state[1],
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (include$0[5], [0, b, a, e, d, c], cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function set_parent$1(ido, cont){
		                return caml_exact_trampoline_cps_call
		                        (Parent[12],
		                         ido,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$35,
		                                   [0, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$36, [1, a], cont);
		                                   });
		                         });
		               }
		               function set_recurrence(reco, cont){
		                return caml_exact_trampoline_cps_call
		                        (set$20,
		                         reco,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$35,
		                                   [1, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$36, [1, a], cont);
		                                   });
		                         });
		               }
		               function notes$5(op, cont){
		                return caml_exact_trampoline_cps_call
		                        (notes$3,
		                         op,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$35,
		                                   [2, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$36, [1, a], cont);
		                                   });
		                         });
		               }
		               function Make$51(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$17],
		                      state_schema_versioned$58,
		                      state_schema$22,
		                      delta_schema_versioned$78,
		                      delta_schema$22,
		                      [0, schema_versioned$188, schema$71],
		                      include$0,
		                      apply$94,
		                      apply_delta$90,
		                      make$116,
		                      view$54,
		                      equal$247]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$247,
		                    [0, const$17],
		                    state_schema_versioned$58,
		                    state_schema$22,
		                    delta_schema_versioned$78,
		                    delta_schema$22,
		                    [0, schema_versioned$188, schema$71],
		                    include$0,
		                    apply$94,
		                    apply_delta$90,
		                    make$116,
		                    view$54];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$187,
		                          schema$70,
		                          symbol$150,
		                          symbol$151,
		                          symbol$152,
		                          symbol$153,
		                          symbol$154,
		                          symbol$155,
		                          equal$107,
		                          compare$106,
		                          min$21,
		                          max$23,
		                          ascending$12,
		                          descending$12,
		                          between$13,
		                          clamp_exn$12,
		                          clamp$12,
		                          comparator$28,
		                          pp$72],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$246 = caml_callback(Make$51, [Ident]),
		                Operation$15 = include$246[2],
		                delta_schema_versioned$79 = include$246[5],
		                add$27 = include$246[14],
		                element$16 = include$246[15],
		                element$17 = include$246[16],
		                remove$17 = include$246[18];
		               function update$5
		               (deleted, parent, recurrence, title, url$0, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                return caml_trampoline_cps_call3
		                        (let$,
		                         deleted,
		                         function(deleted, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Earliest[13],
		                                   deleted,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$36, [0, a], cont);
		                                   });
		                         },
		                         function(deleted){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   parent,
		                                   function(parent, cont){
		                                    return caml_exact_trampoline_cps_call
		    (set_parent$1, parent, cont);
		                                   },
		                                   function(parent){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     recurrence,
		     function(recurrence, cont){
		      return caml_exact_trampoline_cps_call
		              (set_recurrence, recurrence, cont);
		     },
		     function(recurrence){
		      return caml_trampoline_cps_call3
		              (let$,
		               title,
		               function(title, cont){
		                return caml_exact_trampoline_cps_call
		                        (title$0,
		                         title,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$35,
		                                   [2, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (v$36,
		     [1, a],
		     function(a){
		      return caml_exact_trampoline_cps_call(ignore_m$10, a, cont);
		     });
		                                   });
		                         });
		               },
		               function(title){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         url$0,
		                         function(url$0, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (url,
		                                   url$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (v$35,
		     [2, a],
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (v$36,
		               [1, a],
		               function(a){
		                return caml_exact_trampoline_cps_call(ignore_m$10, a, cont);
		               });
		     });
		                                   });
		                         },
		                         function(url){
		                          return caml_exact_trampoline_cps_call
		                                  (filter_opt,
		                                   [0,
		                                    deleted,
		                                    [0, parent, [0, recurrence, [0, title, [0, url, 0]]]]],
		                                   function(ops){
		                                    function a(a){
		                                     return caml_trampoline_cps_call3
		     (map$17,
		      a,
		      function(op, cont){
		       return caml_trampoline_cps_call3(element$17, id, op, cont);
		      },
		      cont);
		                                    }
		                                    return ops
		    ? caml_exact_trampoline_cps_call
		      (all_unit$19,
		       ops,
		       function(b){
		        return caml_trampoline_cps_call2(return$9, b, a);
		       })
		    : a(0);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function add_recurrent_task
		               (a, parent, url, opt, recurrence, created, cont){
		                var id = a ? a[1] : make$42(), title = opt ? opt[1] : cst$1;
		                g
		                 ([0,
		                   symbol_bind$5,
		                   symbol_map$5,
		                   ,
		                   bind$8,
		                   return$9,
		                   map$17,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$3]);
		                var
		                 open =
		                   g
		                    ([0,
		                      Operation$15[4],
		                      Operation$15[5],
		                      ,
		                      Operation$15[7],
		                      Operation$15[8],
		                      Operation$15[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$15[12]]),
		                 let$ = open[3];
		                function b(param, cont){
		                 return caml_trampoline_cps_call2(Operation$15[8], id, cont);
		                }
		                var
		                 c =
		                   make$43
		                    (created,
		                     id,
		                     [0, parent],
		                     recurrence,
		                     Read$0[1][3].call(null, 0, [0, url], title));
		                return caml_trampoline_cps_call2
		                        (add$27,
		                         id,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(let$, a, b, cont);
		                                   });
		                         });
		               }
		               var letrec_function_context$756 = [];
		               function schema_versioned$480(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$756[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$756[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$756[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$756[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (include$139[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUR,
		   cst_allow_contact_access,
		   "Allow_contact_access",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_allow_contact_access,
		       0,
		       2,
		       [0, b],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (include$139[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aUS,
		              cst_allow_calendar_access,
		              "Allow_calendar_access",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_allow_calendar_access,
		                  0,
		                  2,
		                  [0, b],
		                  0,
		                  0],
		                 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$756[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$756[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$712 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$756, [0, schematic_cache$712]);
		               caml_callback
		                (schema_versioned$480,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$247 = Monadic$0(),
		                v$37 = include$247[1],
		                all_unit$20 = include$247[12],
		                Apply$34 = include$247[14],
		                letrec_function_context$757 = [];
		               function state_schema_versioned$59(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$757[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUT, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$757[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$757[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$757[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$139[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_allow_contact_access,
		   0,
		   2,
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (include$139[2],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              allow_contact_access = param[2][1],
		              allow_calendar_access = param[1];
		             return cont
		                     ([0, allow_calendar_access, allow_contact_access]);
		            },
		            function(param, cont){
		             var
		              allow_contact_access = param[2],
		              allow_calendar_access = param[1];
		             return cont
		                     ([0, allow_calendar_access, [0, allow_contact_access, 0]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_allow_calendar_access,
		              0,
		              2,
		              [0, b],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$757[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$757[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$713 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$757, [0, schematic_cache$713]);
		               caml_callback
		                (state_schema_versioned$59,
		                 [function(param, cont){return cont(0);}]);
		               function apply$95(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          if(0 === param[0]){
		                           var op = param[1];
		                           return caml_trampoline_cps_call4
		                                   (include$139[8],
		                                    replica,
		                                    state[1],
		                                    op,
		                                    function(match){
		                                     var
		                                      allow_calendar_access = match[3],
		                                      delta = match[2],
		                                      res = match[1];
		                                     return caml_trampoline_cps_call3
		     (a,
		      delta,
		      function(delta, cont){return cont([0, delta]);},
		      function(delta){
		       return cont
		               ([0, res, delta, [0, allow_calendar_access, state[2]]]);
		      });
		                                    });
		                          }
		                          var op$0 = param[1];
		                          return caml_trampoline_cps_call4
		                                  (include$139[8],
		                                   replica,
		                                   state[2],
		                                   op$0,
		                                   function(match){
		                                    var
		                                     allow_contact_access = match[3],
		                                     delta = match[2],
		                                     res = match[1];
		                                    return caml_trampoline_cps_call3
		    (a,
		     delta,
		     function(delta, cont){return cont([1, delta]);},
		     function(delta){
		      return cont
		              ([0, res, delta, [0, state[1], allow_contact_access]]);
		     });
		                                   });
		                         });
		               }
		               function apply_delta$91(replica, state, param, cont){
		                if(0 === param[0]){
		                 var delta = param[1], a = state[2];
		                 return caml_trampoline_cps_call4
		                         (include$139[9],
		                          replica,
		                          state[1],
		                          delta,
		                          function(b){return cont([0, b, a]);});
		                }
		                var delta$0 = param[1];
		                return caml_trampoline_cps_call4
		                        (include$139[9],
		                         replica,
		                         state[2],
		                         delta$0,
		                         function(a){return cont([0, state[1], a]);});
		               }
		               var
		                include$248 =
		                  caml_callback
		                   (Apply$34,
		                    [[0, [0, schema_versioned$480], apply_delta$91, apply$95]]),
		                delta_schema_versioned$80 = include$248[1],
		                apply_delta$92 = include$248[3],
		                apply$96 = include$248[4];
		               function make$117(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[10],
		                         init[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[10],
		                                   init[1],
		                                   function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$55(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[11],
		                         state[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[11],
		                                   state[1],
		                                   function(b){return cont([0, b, a]);});
		                         });
		               }
		               caml_callback(v$37, [[0, caml_callback(include$139[12], [1])]]);
		               caml_callback(v$37, [[0, caml_callback(include$139[12], [0])]]);
		               caml_callback(v$37, [[1, caml_callback(include$139[12], [1])]]);
		               caml_callback(v$37, [[1, caml_callback(include$139[12], [0])]]);
		               function update$6
		               (allow_calendar_access, allow_contact_access, param, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                return caml_trampoline_cps_call3
		                        (let$,
		                         allow_calendar_access,
		                         function(allow_calendar_access, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[12],
		                                   allow_calendar_access,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$37, [0, a], cont);
		                                   });
		                         },
		                         function(allow_calendar_access_op){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   allow_contact_access,
		                                   function(allow_contact_access, cont){
		                                    return caml_exact_trampoline_cps_call
		    (include$139[12],
		     allow_contact_access,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$37, [1, a], cont);
		     });
		                                   },
		                                   function(allow_contact_access_op){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0,
		      allow_calendar_access_op,
		      [0, allow_contact_access_op, 0]],
		     function(a){
		      return caml_exact_trampoline_cps_call(all_unit$20, a, cont);
		     });
		                                   });
		                         });
		               }
		               function schema_versioned$481(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               var
		                Access_restrictions =
		                  caml_callback
		                   (cm,
		                    [[0,
		                      schema_versioned$481,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$2,
		                      pp$2],
		                     [0,
		                      ,
		                      state_schema_versioned$59,
		                      ,
		                      delta_schema_versioned$80,
		                      ,
		                      [0, schema_versioned$210],
		                      include$0,
		                      apply$96,
		                      apply_delta$92,
		                      make$117,
		                      view$55]]),
		                Locale =
		                  caml_callback(A, [[0, schema_versioned$207, schema$79]]),
		                Hours =
		                  caml_callback(A, [[0, schema_versioned$214, schema$82]]),
		                Mru_destinations =
		                  caml_callback
		                   (bOD,
		                    [[0,
		                      schema_versioned$131,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$24,
		                      pp$52]]),
		                Mru_people =
		                  caml_callback
		                   (bOD,
		                    [[0,
		                      schema_versioned$481,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$2,
		                      pp$2]]),
		                Week_start =
		                  caml_callback(A, [[0, schema_versioned$6, schema_string]]),
		                letrec_function_context$758 = [];
		               function schema_versioned$482(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$758[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$758[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$758[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$758[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Week_start[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_week_start, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_trampoline_cps_call2
		      (Mru_people[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_mru_people, 0, 2, [0, c], 0, 0], a];
		        return caml_trampoline_cps_call2
		                (Mru_destinations[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_mru_destinations, 0, 2, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (Hours[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_hours, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (Locale[2],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_locale, 0, 2, [0, c], 0, 0], b];
		                                      return caml_trampoline_cps_call2
		      (Access_restrictions[3],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              week_start = d[2][1],
		              mru_people = d[1],
		              mru_destinations = c[1],
		              hours = b[1],
		              locale = a[1],
		              access_restrictions = param[1];
		             return cont
		                     ([0,
		                       access_restrictions,
		                       locale,
		                       hours,
		                       mru_destinations,
		                       mru_people,
		                       week_start]);
		            },
		            function(param, cont){
		             var
		              week_start = param[6],
		              mru_people = param[5],
		              mru_destinations = param[4],
		              hours = param[3],
		              locale = param[2],
		              access_restrictions = param[1];
		             return cont
		                     ([0,
		                       access_restrictions,
		                       [0,
		                        locale,
		                        [0,
		                         hours,
		                         [0, mru_destinations, [0, mru_people, [0, week_start, 0]]]]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_access_restrictions, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$758[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$758[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$714 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$758, [0, schematic_cache$714]);
		               caml_callback
		                (schema_versioned$482,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$759 = [];
		               function schema_versioned$483(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$759[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aUU, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$759[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$759[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$759[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Week_start[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUV,
		   cst_week_start,
		   "Week_start",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_week_start, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Mru_people[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aUW,
		             cst_mru_people,
		             "Mru_people",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_mru_people, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (Mru_destinations[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aUX,
		                       cst_mru_destinations,
		                       "Mru_destinations",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_mru_destinations, 0, 2, [0, c], 0, 0],
		                          0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Hours[4],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aUY,
		                                 cst_hours,
		                                 "Hours",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_hours, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Locale[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aUZ,
		   cst_locale,
		   "Locale",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_locale, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (Access_restrictions[5],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aU0,
		              cst_access_restrictions,
		              "Access_restrictions",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0,
		                 [0, 0, 0, 0, 0, cst_access_restriction, 0, 2, [0, b], 0, 0],
		                 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$759[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$759[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$715 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$759, [0, schematic_cache$715]);
		               caml_callback
		                (schema_versioned$483,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$249 = Monadic$0(),
		                v$38 = include$249[1],
		                const$18 = include$249[2],
		                all_unit$21 = include$249[12],
		                Apply$35 = include$249[14],
		                letrec_function_context$760 = [];
		               function equal$248(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$760[1], x, cont);
		               }
		               caml_update_dummy(letrec_function_context$760, [0, equal$134]);
		               function state_schema_versioned$60(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$482,
		                                   schematic_version,
		                                   function(a){return cont([0, aU1, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                state_schema$23 =
		                  caml_callback
		                   (state_schema_versioned$60,
		                    [function(param, cont){return cont(0);}]);
		               function apply$97(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          switch(param[0]){
		                            case 0:
		                             var op = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Access_restrictions[9],
		                                      replica,
		                                      state[1],
		                                      op,
		                                      function(match){
		                                       var
		access_restrictions = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([0, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    access_restrictions,
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 1:
		                             var op$0 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Locale[8],
		                                      replica,
		                                      state[2],
		                                      op$0,
		                                      function(match){
		                                       var locale = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([1, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    locale,
		                    state[3],
		                    state[4],
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 2:
		                             var op$1 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Hours[8],
		                                      replica,
		                                      state[3],
		                                      op$1,
		                                      function(match){
		                                       var hours = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([2, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0, state[1], state[2], hours, state[4], state[5], state[6]]]);
		        });
		                                      });
		                            case 3:
		                             var op$2 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Mru_destinations[8],
		                                      replica,
		                                      state[4],
		                                      op$2,
		                                      function(match){
		                                       var
		mru_destinations = match[3],
		delta = match[2],
		res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([3, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    mru_destinations,
		                    state[5],
		                    state[6]]]);
		        });
		                                      });
		                            case 4:
		                             var op$3 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Mru_people[8],
		                                      replica,
		                                      state[5],
		                                      op$3,
		                                      function(match){
		                                       var mru_people = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([4, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    mru_people,
		                    state[6]]]);
		        });
		                                      });
		                            default:
		                             var op$4 = param[1];
		                             return caml_trampoline_cps_call4
		                                     (Week_start[8],
		                                      replica,
		                                      state[6],
		                                      op$4,
		                                      function(match){
		                                       var week_start = match[3], delta = match[2], res = match[1];
		                                       return caml_trampoline_cps_call3
		       (a,
		        delta,
		        function(delta, cont){return cont([5, delta]);},
		        function(delta){
		         return cont
		                 ([0,
		                   res,
		                   delta,
		                   [0,
		                    state[1],
		                    state[2],
		                    state[3],
		                    state[4],
		                    state[5],
		                    week_start]]);
		        });
		                                      });
		                          }
		                         });
		               }
		               function apply_delta$93(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var
		                    delta = param[1],
		                    a = state[6],
		                    b = state[5],
		                    c = state[4],
		                    d = state[3],
		                    e = state[2];
		                   return caml_trampoline_cps_call4
		                           (Access_restrictions[10],
		                            replica,
		                            state[1],
		                            delta,
		                            function(f){return cont([0, f, e, d, c, b, a]);});
		                  case 1:
		                   var
		                    delta$0 = param[1],
		                    f = state[6],
		                    g = state[5],
		                    h = state[4],
		                    i = state[3];
		                   return caml_trampoline_cps_call4
		                           (Locale[9],
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){return cont([0, state[1], a, i, h, g, f]);});
		                  case 2:
		                   var
		                    delta$1 = param[1],
		                    j = state[6],
		                    k = state[5],
		                    l = state[4];
		                   return caml_trampoline_cps_call4
		                           (Hours[9],
		                            replica,
		                            state[3],
		                            delta$1,
		                            function(a){
		                             return cont([0, state[1], state[2], a, l, k, j]);
		                            });
		                  case 3:
		                   var delta$2 = param[1], m = state[6], n = state[5];
		                   return caml_trampoline_cps_call4
		                           (Mru_destinations[9],
		                            replica,
		                            state[4],
		                            delta$2,
		                            function(a){
		                             return cont([0, state[1], state[2], state[3], a, n, m]);
		                            });
		                  case 4:
		                   var delta$3 = param[1], o = state[6];
		                   return caml_trampoline_cps_call4
		                           (Mru_people[9],
		                            replica,
		                            state[5],
		                            delta$3,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], a, o]);
		                            });
		                  default:
		                   var delta$4 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Week_start[9],
		                            replica,
		                            state[6],
		                            delta$4,
		                            function(a){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], state[5], a]);
		                            });
		                }
		               }
		               var
		                include$250 =
		                  caml_callback
		                   (Apply$35,
		                    [[0, [0, schema_versioned$483], apply_delta$93, apply$97]]),
		                delta_schema_versioned$81 = include$250[1],
		                delta_schema$23 = include$250[2],
		                apply_delta$94 = include$250[3],
		                apply$98 = include$250[4];
		               function schema_versioned$484(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    0,
		                                    0,
		                                    schematic_param_a_schema_versi[3],
		                                    schematic_param_a_schema_versi[4]]);
		                         });
		               }
		               var
		                schema$270 =
		                  [0,
		                   0,
		                   0,
		                   schematic_param_a_schema_versi[3],
		                   schematic_param_a_schema_versi[4]];
		               function make$118(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (Week_start[10],
		                         6,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Mru_people[10],
		                                   Mru_people[12],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Mru_destinations[10],
		     Mru_destinations[12],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Hours[10],
		               empty$4,
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Locale[10],
		                         aU2,
		                         function(e){
		                          return caml_trampoline_cps_call2
		                                  (Access_restrictions[11],
		                                   Access_restrictions[13],
		                                   function(f){return cont([0, f, e, d, c, b, a]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$56(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (Week_start[11],
		                         state[6],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Mru_people[11],
		                                   state[5],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (to_list$3,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (Mru_destinations[11],
		               state[4],
		               function(c){
		                return caml_exact_trampoline_cps_call
		                        (to_list$3,
		                         c,
		                         function(c){
		                          return caml_exact_trampoline_cps_call
		                                  (Hours[11],
		                                   state[3],
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call
		    (Locale[11],
		     state[2],
		     function(e){
		      return caml_trampoline_cps_call2
		              (Access_restrictions[12],
		               state[1],
		               function(f){return cont([0, f, 0, e, d, c, b, a]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function mru_destinations(op, cont){
		                return caml_exact_trampoline_cps_call(v$38, [3, op], cont);
		               }
		               function mru_people(op, cont){
		                return caml_exact_trampoline_cps_call(v$38, [4, op], cont);
		               }
		               var
		                default$10 =
		                  caml_callback(view$56, [caml_callback(make$118, [dummy])]);
		               if(! caml_callback(equal$134, [empty$25, default$10])){
		                d = caml_pop_trap();
		                return d
		                        (caml_maybe_attach_backtrace([0, Assert_failure, bND], 1));
		               }
		               var
		                CellLWW =
		                  caml_callback(A, [[0, schema_versioned$149, schema$51]]),
		                schematic_cache$716 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$761 = [];
		               caml_update_dummy
		                (letrec_function_context$761, [0, schematic_cache$716]);
		               function schematic_version$98(param, cont){return cont(0);}
		               var
		                schematic_schema_version$25 =
		                  caml_callback(schematic_version$98, [V$4]);
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$761[1][1],
		                    schematic_schema_version$25]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$761[1][1],
		                             schematic_schema_version$25,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$761[1][1],
		schematic_schema_version$25,
		schematic_self,
		function(a){
		 letrec_function_context$761[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$149,
		          schematic_version$98,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var lww = param[1];
		                return cont([0, lww]);
		               },
		               function(param, cont){
		                var lww = param[1];
		                return cont([0, lww, 0]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_lww, 0, 2, [0, a], 0, 0], 0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$761[1][1],
		                    schematic_schema_version$25,
		                    res,
		                    function(a){
		                     letrec_function_context$761[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$762 = [];
		               function schema_versioned$485(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$762[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aU3, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$762[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$762[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$762[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (CellLWW[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    aU4,
		    cst_lww,
		    "Lww",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var delta = param[1];
		       return cont(delta);
		      },
		      function(delta, cont){return cont([0, delta, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_lww, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$762[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$762[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$717 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$762, [0, schematic_cache$717]);
		               caml_callback
		                (schema_versioned$485,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$251 = Monadic$0(),
		                v$39 = include$251[1],
		                return$35 = include$251[7],
		                Apply$36 = include$251[14],
		                letrec_function_context$763 = [];
		               function state_schema_versioned$61(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$763[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aU5, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$763[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$763[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$763[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (CellLWW[2],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var lww = param[1];
		   return cont([0, lww]);
		  },
		  function(param, cont){
		   var lww = param[1];
		   return cont([0, lww, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_lww, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$763[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$763[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$718 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$763, [0, schematic_cache$718]);
		               caml_callback
		                (state_schema_versioned$61,
		                 [function(param, cont){return cont(0);}]);
		               function apply$99(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4],
		                 op$0 = op[1];
		                return caml_trampoline_cps_call4
		                        (CellLWW[8],
		                         replica,
		                         state[1],
		                         op$0,
		                         function(match){
		                          var
		                           new_substate = match[3],
		                           delta = match[2],
		                           res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   delta,
		                                   function(delta, cont){return cont([0, delta]);},
		                                   function(delta){
		                                    return cont([0, res, delta, [0, new_substate]]);
		                                   });
		                         });
		               }
		               function apply_delta$95(replica, state, delta, cont){
		                var delta$0 = delta[1];
		                return caml_trampoline_cps_call4
		                        (CellLWW[9],
		                         replica,
		                         state[1],
		                         delta$0,
		                         function(new_substate){return cont([0, new_substate]);});
		               }
		               var
		                include$252 =
		                  caml_callback
		                   (Apply$36,
		                    [[0, [0, schema_versioned$485], apply_delta$95, apply$99]]),
		                apply_delta$96 = include$252[3],
		                apply$100 = include$252[4],
		                Crdt = [0, , , , , , , apply_delta$96, apply$100],
		                apply_delta$97 = Crdt[7],
		                apply$101 = Crdt[8],
		                letrec_function_context$764 = [];
		               function delta_maybe_list_schema_versio
		               (schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$764[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, aU6, descriptor]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$764[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$764[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$764[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$485,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   "deltalist",
		   "DeltaList",
		   [0, 0, 0, [3, b], 0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$485,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_delta,
		              "Delta",
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$764[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$764[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$719 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$764, [0, schematic_cache$719]);
		               caml_callback
		                (delta_maybe_list_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               function delta_schema_versioned$82(v, cont){
		                return caml_exact_trampoline_cps_call
		                        (delta_maybe_list_schema_versio,
		                         v,
		                         function(a){
		                          return cont
		                                  (map$14
		                                    (function(param, cont){
		                                      if(0 === param[0]){
		                                       var d = param[1];
		                                       return cont([0, [0, d, 0]]);
		                                      }
		                                      var ds = param[1];
		                                      return cont([0, ds]);
		                                     },
		                                     function(ds, cont){return cont([1, ds]);},
		                                     a));
		                         });
		               }
		               var
		                delta_schema$24 =
		                  caml_callback
		                   (delta_schema_versioned$82,
		                    [function(param, cont){return cont(0);}]);
		               function schema_versioned$486(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$149,
		                                   schematic_version,
		                                   function(a){return cont([0, aU7, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$486,
		                 [function(param, cont){return cont(0);}]);
		               function make$119(value, cont){
		                return caml_exact_trampoline_cps_call
		                        (CellLWW[10], value, function(a){return cont([0, a]);});
		               }
		               function view$57(param, cont){
		                var lww = param[1];
		                return caml_exact_trampoline_cps_call(CellLWW[11], lww, cont);
		               }
		               function diff$9(previous, t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (equal$79,
		                         previous,
		                         t,
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call2(return$35, 0, cont)
		                                  : caml_exact_trampoline_cps_call
		                                    (CellLWW[12],
		                                     t,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(v$39, [0, a], cont);
		                                     });
		                         });
		               }
		               function Wrap(T, cont){
		                var
		                 state_schema_versioned = T[3],
		                 delta_schema_versioned = T[5],
		                 Init = T[7],
		                 Monad = T[8],
		                 apply = T[9],
		                 apply_delta = T[10],
		                 make = T[11],
		                 view = T[12],
		                 diff = T[13];
		                return caml_exact_trampoline_cps_call$1
		                        (bPy,
		                         [0,
		                          schema_versioned$142,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          comparator$25,
		                          pp$61],
		                         [0,
		                          equal$79,
		                          ,
		                          state_schema_versioned,
		                          ,
		                          delta_schema_versioned,
		                          ,
		                          Init,
		                          Monad,
		                          apply,
		                          apply_delta,
		                          make,
		                          view,
		                          diff],
		                         function(Record){
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$149,
		                                   schematic_version,
		                                   function(a){
		                                    var letrec_function_context = [];
		                                    function state_schema_versioned(schematic_version, cont){
		                                     return caml_trampoline_cps_call2
		     (schematic_version,
		      V$4,
		      function(schematic_schema_version){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context[1][1],
		                schematic_schema_version,
		                function(match){
		                 function a(descriptor){
		                  return cont([0, aU8, 0, descriptor, 0]);
		                 }
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (fixpoint,
		                           function(schematic_self, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     letrec_function_context[1][1],
		                                     schematic_schema_version,
		                                     function(match){
		                                      if(! match)
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        schematic_self,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return caml_exact_trampoline_cps_call
		                 (state_schema_versioned$61,
		                  schematic_version,
		                  function(b){
		                   var
		                    a =
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([2, f0]);},
		                        function(param, cont){
		                         if(2 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        0,
		                        0,
		                        "leaf",
		                        "Leaf",
		                        b,
		                        0],
		                       0];
		                   return caml_exact_trampoline_cps_call
		                           (state_schema_versioned$2,
		                            schematic_version,
		                            function(c){
		                             var
		                              b =
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([1, f0]);},
		                                  function(param, cont){
		                                   if(1 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_note,
		                                  cst_Note,
		                                  c,
		                                  0],
		                                 a];
		                             return caml_exact_trampoline_cps_call
		                                     (Record[3],
		                                      schematic_version,
		                                      function(a){
		                                       var
		res =
		  [11,
		   0,
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(0 !== param[0]) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     cst_record,
		     cst_Record,
		     a,
		     0],
		    b],
		   0];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      var schema = match[1];
		                                      return cont(schema);
		                                     });
		                           },
		                           a);
		                 var schema = match[1];
		                 return a(schema);
		                });
		      });
		                                    }
		                                    var schematic_cache = [0, empty$11([0, comparator$9])];
		                                    caml_update_dummy
		                                     (letrec_function_context, [0, schematic_cache]);
		                                    return caml_exact_trampoline_cps_call
		    (state_schema_versioned,
		     function(param, cont){return cont(0);},
		     function(state_schema){
		      function make(cell, cont){
		       if(typeof cell !== "number")
		        switch(cell[0]){
		          case 5:
		           var n = cell[1];
		           return caml_exact_trampoline_cps_call
		                   (make$72, n, function(a){return cont([1, a]);});
		          case 6:
		           var b = cell[1];
		           return caml_exact_trampoline_cps_call
		                   (Record[11], b, function(a){return cont([0, a]);});
		        }
		       return caml_exact_trampoline_cps_call
		               (make$119, cell, function(a){return cont([2, a]);});
		      }
		      function view(param, cont){
		       switch(param[0]){
		         case 0:
		          var b = param[1];
		          return caml_exact_trampoline_cps_call
		                  (Record[12], b, function(a){return cont([6, a]);});
		         case 1:
		          var n = param[1];
		          return caml_exact_trampoline_cps_call
		                  (view$11, n, function(a){return cont([5, a]);});
		         default:
		          var l = param[1];
		          return caml_exact_trampoline_cps_call(view$57, l, cont);
		       }
		      }
		      var letrec_function_context = [];
		      function schema_versioned(schematic_version, cont){
		       return caml_trampoline_cps_call2
		               (schematic_version,
		                V$4,
		                function(schematic_schema_version){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id,
		                          letrec_function_context[1][1],
		                          schematic_schema_version,
		                          function(match){
		                           function a(descriptor){
		                            return cont([0, 0, 0, descriptor, 0]);
		                           }
		                           if(! match)
		                            return caml_exact_trampoline_cps_call
		                                    (fixpoint,
		                                     function(schematic_self, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       letrec_function_context[1][1],
		       schematic_schema_version,
		       function(match){
		        if(! match)
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context[1][1],
		                  schematic_schema_version,
		                  schematic_self,
		                  function(a){
		                   letrec_function_context[1][1] = a;
		                   return caml_trampoline_cps_call2
		                           (delta_schema_versioned$3,
		                            schematic_version,
		                            function(b){
		                             var
		                              a =
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([1, f0]);},
		                                  function(param, cont){
		                                   if(0 === param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aU9,
		                                  cst_note,
		                                  cst_Note,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0, [0, 0, 0, 0, 0, cst_note, 0, 2, [0, b], 0, 0], 0]],
		                                   0],
		                                  0],
		                                 0];
		                             return caml_trampoline_cps_call2
		                                     (Record[5],
		                                      schematic_version,
		                                      function(b){
		                                       var
		res =
		  [11,
		   0,
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(0 !== param[0]) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     1,
		     aU_,
		     cst_record,
		     cst_Record,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var delta = param[1];
		        return cont(delta);
		       },
		       function(delta, cont){return cont([0, delta, 0]);},
		       [0, [0, 0, 0, 0, 0, cst_record, 0, 2, [0, b], 0, 0], 0]],
		      0],
		     0],
		    a],
		   0];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        var schema = match[1];
		        return cont(schema);
		       });
		                                     },
		                                     a);
		                           var schema = match[1];
		                           return a(schema);
		                          });
		                });
		      }
		      var schematic_cache = [0, empty$11([0, comparator$9])];
		      caml_update_dummy
		       (letrec_function_context, [0, schematic_cache]);
		      return caml_exact_trampoline_cps_call
		              (schema_versioned,
		               function(param, cont){return cont(0);},
		               function(schema){
		                var include = Monadic$0(), Apply = include[14];
		                function apply(replica, state, operation, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3]),
		                  let$ = open[4];
		                 switch(state[0]){
		                   case 0:
		                    var record_state = state[1];
		                    if(0 === operation[0]){
		                     var operation$0 = operation[1];
		                     return caml_trampoline_cps_call4
		                             (Record[9],
		                              replica,
		                              record_state,
		                              operation$0,
		                              function(match){
		                               var
		                                record_state = match[3],
		                                delta = match[2],
		                                res = match[1];
		                               return caml_trampoline_cps_call3
		                                       (let$,
		delta,
		function(delta, cont){return cont([0, delta]);},
		function(delta){
		 return cont([0, res, delta, [0, record_state]]);
		});
		                              });
		                    }
		                    break;
		                   case 1:
		                    var record_state$0 = state[1];
		                    if(0 !== operation[0]){
		                     var operation$1 = operation[1];
		                     return caml_trampoline_cps_call4
		                             (apply$9,
		                              replica,
		                              record_state$0,
		                              operation$1,
		                              function(match){
		                               var
		                                record_state = match[3],
		                                delta = match[2],
		                                res = match[1];
		                               return caml_trampoline_cps_call3
		                                       (let$,
		delta,
		function(delta, cont){return cont([1, delta]);},
		function(delta){
		 return cont([0, res, delta, [1, record_state]]);
		});
		                              });
		                    }
		                    break;
		                 }
		                 var cst_bad_operation = "bad operation";
		                 return 0 === operation[0]
		                         ? caml_exact_trampoline_cps_call
		                           (invalid_arg, cst_bad_operation, cont)
		                         : caml_exact_trampoline_cps_call
		                           (invalid_arg, cst_bad_operation, cont);
		                }
		                function apply_delta(replica, state, delta, cont){
		                 switch(state[0]){
		                   case 0:
		                    var sub_state = state[1];
		                    if(0 === delta[0]){
		                     var delta$0 = delta[1];
		                     return caml_trampoline_cps_call4
		                             (Record[10],
		                              replica,
		                              sub_state,
		                              delta$0,
		                              function(a){return cont([0, a]);});
		                    }
		                    break;
		                   case 1:
		                    var sub_state$0 = state[1];
		                    if(0 !== delta[0]){
		                     var delta$1 = delta[1];
		                     return caml_trampoline_cps_call4
		                             (apply_delta$5,
		                              replica,
		                              sub_state$0,
		                              delta$1,
		                              function(a){return cont([1, a]);});
		                    }
		                    break;
		                 }
		                 return 0 === delta[0] ? cont(state) : cont(state);
		                }
		                return caml_exact_trampoline_cps_call
		                        (Apply,
		                         [0, [0, schema_versioned], apply_delta, apply],
		                         function(include){
		                          var
		                           delta_schema_versioned = include[1],
		                           delta_schema = include[2],
		                           apply_delta = include[3],
		                           apply = include[4],
		                           letrec_function_context = [];
		                          function schema_versioned(schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$4,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       function a(descriptor){return cont([0, , , descriptor, 0]);}
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return caml_exact_trampoline_cps_call
		       (state_schema_versioned,
		        schematic_version,
		        function(b){
		         var
		          a =
		            [0,
		             [0, 0, 0, 0, 0, cst_timestamp, 0, 2, [0, int_schema], 0, 0],
		             [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, b], 0, 0], 0]];
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$358,
		                  schematic_version,
		                  function(b){
		                   var
		                    res =
		                      [7,
		                       function(param, cont){
		                        var
		                         a = param[2],
		                         value = a[2][1],
		                         timestamp = a[1],
		                         replica = param[1];
		                        return cont([0, replica, timestamp, value]);
		                       },
		                       function(param, cont){
		                        var
		                         value = param[3],
		                         timestamp = param[2],
		                         replica = param[1];
		                        return cont([0, replica, [0, timestamp, [0, value, 0]]]);
		                       },
		                       [0, [0, 0, 0, 0, 0, cst_replica, 0, 3, [0, b], 0, 0], a]];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 a);
		       var schema = match[1];
		       return a(schema);
		      });
		                                    });
		                          }
		                          var schematic_cache = [0, empty$11([0, comparator$9])];
		                          caml_update_dummy
		                           (letrec_function_context, [0, schematic_cache]);
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(schema){
		                                    function left(param){var value = param[3]; return value;}
		                                    function set_left(t, value){return [0, t[1], t[2], value];}
		                                    function right(t, cont){
		                                     return caml_exact_trampoline_cps_call
		     (view,
		      t[3],
		      function(a){return cont([0, [0, t[1], t[2], a]]);});
		                                    }
		                                    function set_right(a, param, cont){
		                                     var lww_state = param[1];
		                                     return caml_exact_trampoline_cps_call
		     (make,
		      lww_state[3],
		      function(a){
		       return cont([0, lww_state[1], lww_state[2], a]);
		      });
		                                    }
		                                    function make$0(init, cont){
		                                     return caml_exact_trampoline_cps_call
		     (make$119,
		      init,
		      function(a){
		       a = a[1];
		       var timestamp = a[2], replica = a[1];
		       return caml_exact_trampoline_cps_call
		               (make,
		                init,
		                function(a){return cont([0, replica, timestamp, a]);});
		      });
		                                    }
		                                    var
		                                     y = delta_schema$24[1],
		                                     x = delta_schema[1],
		                                     Init = [0, schema_versioned$149];
		                                    function a(schema_name){
		                                     var letrec_function_context = [];
		                                     function schema_versioned$0(schematic_version, cont){
		                                      return caml_trampoline_cps_call2
		      (schematic_version,
		       V$5,
		       function(schematic_schema_version){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  function a(descriptor){
		                   var schematic_parametric = schema_name ? 0 : 0;
		                   return cont
		                           ([0, schema_name, 0, descriptor, schematic_parametric]);
		                  }
		                  if(! match)
		                   return caml_exact_trampoline_cps_call
		                           (fixpoint,
		                            function(schematic_self, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (find_packed_by_id,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      function(match){
		                                       if(! match)
		return caml_exact_trampoline_cps_call$0
		        (set$3,
		         letrec_function_context[1][1],
		         schematic_schema_version,
		         schematic_self,
		         function(a){
		          letrec_function_context[1][1] = a;
		          return caml_exact_trampoline_cps_call
		                  (delta_schema_versioned$82,
		                   schematic_version,
		                   function(b){
		                    var
		                     a =
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([1, f0]);},
		                         function(param, cont){
		                          if(0 === param[0]) return cont(0);
		                          var f0 = param[1];
		                          return cont([0, f0]);
		                         },
		                         0,
		                         0,
		                         cst_right,
		                         cst_Right,
		                         b,
		                         0],
		                        0];
		                    return caml_trampoline_cps_call2
		                            (delta_schema_versioned,
		                             schematic_version,
		                             function(b){
		                              var
		                               res =
		                                 [11,
		                                  0,
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([0, f0]);},
		                                    function(param, cont){
		                                     if(0 !== param[0]) return cont(0);
		                                     var f0 = param[1];
		                                     return cont([0, f0]);
		                                    },
		                                    0,
		                                    0,
		                                    cst_left,
		                                    cst_Left,
		                                    b,
		                                    0],
		                                   a],
		                                  0];
		                              return caml_exact_trampoline_cps_call$0
		                                      (set$3,
		                                       letrec_function_context[1][1],
		                                       schematic_schema_version,
		                                       res,
		                                       function(a){
		letrec_function_context[1][1] = a;
		return cont(res);
		                                       });
		                             });
		                   });
		         });
		                                       var schema = match[1];
		                                       return cont(schema);
		                                      });
		                            },
		                            a);
		                  var schema = match[1];
		                  return a(schema);
		                 });
		       });
		                                     }
		                                     var schematic_cache = [0, empty$11([0, comparator$9])];
		                                     caml_update_dummy
		                                      (letrec_function_context, [0, schematic_cache]);
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$0,
		      function(param, cont){return cont(0);},
		      function(schema){
		       var
		        include = Monadic$0(),
		        v = include[1],
		        return$ = include[7],
		        Apply = include[14];
		       function state_schema_versioned(schematic_version, cont){
		        return caml_trampoline_cps_call2
		                (schematic_version,
		                 V$5,
		                 function(schematic_schema_version){
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned,
		                           schematic_version,
		                           function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (state_schema_versioned,
		                function(param, cont){return cont(0);},
		                function(state_schema){
		                 function apply_delta$0(replica, state, param, cont){
		                  if(0 === param[0]){
		                   var delta = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta,
		                            replica,
		                            left(state),
		                            delta,
		                            function(a){return cont(set_left(state, a));});
		                  }
		                  var delta$0 = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (right,
		                           state,
		                           function(a){
		                            return caml_trampoline_cps_call4
		                                    (apply_delta$97,
		                                     replica,
		                                     a,
		                                     delta$0,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (set_right, state, a, cont);
		                                     });
		                           });
		                 }
		                 function apply$0(replica, state, param, cont){
		                  if(0 === param[0]){
		                   var op = param[1];
		                   return caml_trampoline_cps_call4
		                           (apply,
		                            replica,
		                            left(state),
		                            op,
		                            function(match){
		                             var
		                              sub_state = match[3],
		                              delta = match[2],
		                              res = match[1],
		                              a = set_left(state, sub_state);
		                             return caml_trampoline_cps_call3
		                                     (map$17,
		                                      delta,
		                                      function(d, cont){return cont([0, d]);},
		                                      function(b){return cont([0, res, b, a]);});
		                            });
		                  }
		                  var op$0 = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (right,
		                           state,
		                           function(a){
		                            return caml_trampoline_cps_call4
		                                    (apply$101,
		                                     replica,
		                                     a,
		                                     op$0,
		                                     function(match){
		                                      var sub_state = match[3], delta = match[2], res = match[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (set_right,
		       state,
		       sub_state,
		       function(a){
		        return caml_trampoline_cps_call3
		                (map$17,
		                 delta,
		                 function(d, cont){return cont([1, d]);},
		                 function(b){return cont([0, res, b, a]);});
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (Apply,
		                          [0, [0, schema_versioned$0], apply_delta$0, apply$0],
		                          function(include){
		                           var
		                            delta_schema_versioned = include[1],
		                            apply_delta = include[3],
		                            apply = include[4];
		                           function view$0(state, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (view, left(state), cont);
		                           }
		                           function left$0(op, cont){
		                            return caml_exact_trampoline_cps_call(v, [0, op], cont);
		                           }
		                           function right(op, cont){
		                            return caml_exact_trampoline_cps_call(v, [1, op], cont);
		                           }
		                           function delta_schema_versioned$0(v, cont){
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned,
		                                     v,
		                                     function(a){return cont([0, aU$, a[2], a[3], a[4]]);});
		                           }
		                           var Operation = [0, , , , , return$];
		                           return caml_exact_trampoline_cps_call
		                                   (delta_schema_versioned$0,
		                                    function(param, cont){return cont(0);},
		                                    function(delta_schema){
		                                     function diff(previous, new_value, cont){
		                                      if(typeof previous !== "number")
		                                       switch(previous[0]){
		 case 5:
		  if(typeof new_value !== "number" && 5 === new_value[0]){
		   var r2 = new_value[1], r1 = previous[1];
		   return caml_trampoline_cps_call2
		           (return$30,
		            0,
		            function(a){
		             return caml_exact_trampoline_cps_call$1
		                     (diff$4,
		                      r1,
		                      r2,
		                      function(b){
		                       return caml_exact_trampoline_cps_call
		                               (left$0, [2, [1, value$4(b, a)]], cont);
		                      });
		            });
		  }
		  break;
		 case 6:
		  if(typeof new_value !== "number" && 6 === new_value[0]){
		   var r2$0 = new_value[1], r1$0 = previous[1];
		   return caml_exact_trampoline_cps_call$1
		           (Record[21],
		            r1$0,
		            r2$0,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (left$0, [2, [0, a]], cont);
		            });
		  }
		  break;
		                                       }
		                                      return caml_exact_trampoline_cps_call$1
		      (diff$9,
		       previous,
		       new_value,
		       function(a){
		        return caml_exact_trampoline_cps_call(right, a, cont);
		       });
		                                     }
		                                     return cont
		     ([0,
		       Operation,
		       equal$79,
		       state_schema_versioned,
		       ,
		       delta_schema_versioned$0,
		       ,
		       Init,
		       include$0,
		       apply,
		       apply_delta,
		       make$0,
		       view$0,
		       diff]);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    if(x && y){
		                                     var right$0 = y[1], left$0 = x[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$129,
		      function(b){
		       return caml_trampoline_cps_call3
		               (b, left$0, right$0, function(b){return a([0, b]);});
		      });
		                                    }
		                                    return a(0);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                T$12 =
		                  caml_callback
		                   (Wrap,
		                    [caml_callback
		                      (Wrap,
		                       [caml_callback
		                         (Wrap,
		                          [caml_callback
		                            (Wrap,
		                             [caml_callback
		                               (Wrap,
		                                [caml_callback
		                                  (Wrap,
		                                   [caml_callback
		                                     (Wrap,
		                                      [caml_callback
		(Wrap,
		 [caml_callback
		   (Wrap,
		    [caml_callback
		      (Wrap,
		       [caml_callback
		         (Wrap,
		          [caml_callback
		            (Wrap,
		             [caml_callback
		               (Wrap,
		                [caml_callback
		                  (Wrap,
		                   [caml_callback
		                     (Wrap,
		                      [caml_callback
		                        (Wrap,
		                         [caml_callback
		                           (Wrap,
		                            [caml_callback
		                              (Wrap,
		                               [caml_callback
		                                 (Wrap,
		                                  [caml_callback
		                                    (Wrap,
		                                     [[0,
		                                       ,
		                                       ,
		                                       state_schema_versioned$61,
		                                       ,
		                                       delta_schema_versioned$82,
		                                       ,
		                                       [0, schema_versioned$486],
		                                       include$0,
		                                       apply$100,
		                                       apply_delta$96,
		                                       make$119,
		                                       view$57,
		                                       diff$9]])])])])])])])])])])])])])])])])])])])]),
		                Operation$16 = T$12[1],
		                equal$249 = T$12[2],
		                state_schema_versioned$62 = T$12[3],
		                delta_schema_versioned$83 = T$12[5],
		                Init$13 = T$12[7],
		                Monad$16 = T$12[8],
		                apply$102 = T$12[9],
		                apply_delta$98 = T$12[10],
		                make$120 = T$12[11],
		                view$58 = T$12[12],
		                diff$10 = T$12[13],
		                include$253 =
		                  caml_callback(A, [[0, schema_versioned$153, schema$52]]),
		                state_schema_versioned$63 = include$253[2],
		                delta_schema_versioned$84 = include$253[4],
		                apply$103 = include$253[8],
		                apply_delta$99 = include$253[9],
		                make$121 = include$253[10],
		                view$59 = include$253[11],
		                set$21 = include$253[12],
		                include$254 =
		                  caml_callback(A, [[0, schema_versioned$154, schema$53]]),
		                state_schema_versioned$64 = include$254[2],
		                delta_schema_versioned$85 = include$254[4],
		                apply$104 = include$254[8],
		                apply_delta$100 = include$254[9],
		                make$122 = include$254[10],
		                view$60 = include$254[11],
		                set$22 = include$254[12],
		                cst_Schema = "Schema",
		                letrec_function_context$765 = [];
		               function schema_versioned$487(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$765[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVa, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$765[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$765[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$765[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aVc,
		                                     aVb,
		                                     1,
		                                     0,
		                                     4,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$85,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([1, f0]);},
		             function(param, cont){
		              if(0 === param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aVd,
		             cst_data,
		             "Data",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             a],
		            0];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$84,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aVe,
		                        cst_schema$0,
		                        cst_Schema,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_schema$0, 0, 2, [0, a], 0, 0], 0]],
		                         0],
		                        0],
		                       b],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$765[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$765[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$720 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$765, [0, schematic_cache$720]);
		               caml_callback
		                (schema_versioned$487,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$255 = Monadic$0(),
		                v$40 = include$255[1],
		                all_unit$22 = include$255[12],
		                Apply$37 = include$255[14],
		                letrec_function_context$766 = [];
		               function state_schema_versioned$65(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$766[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$766[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$766[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$766[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$64,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$63,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var data = param[2][1], schema = param[1];
		             return cont([0, schema, data]);
		            },
		            function(param, cont){
		             var data = param[2], schema = param[1];
		             return cont([0, schema, [0, data, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_schema$0, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$766[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$766[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$721 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$766, [0, schematic_cache$721]);
		               caml_callback
		                (state_schema_versioned$65,
		                 [function(param, cont){return cont(0);}]);
		               function apply$105(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                if(0 === op[0]){
		                 var op$0 = op[1];
		                 return caml_trampoline_cps_call4
		                         (apply$103,
		                          replica,
		                          state[1],
		                          op$0,
		                          function(match){
		                           var
		                            new_substate = match[3],
		                            delta = match[2],
		                            res = match[1];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    delta,
		                                    function(delta, cont){return cont([0, delta]);},
		                                    function(delta){
		                                     var new_state = [0, new_substate, state[2]];
		                                     return cont([0, res, delta, new_state]);
		                                    });
		                          });
		                }
		                var op$1 = op[1];
		                return caml_trampoline_cps_call4
		                        (apply$104,
		                         replica,
		                         state[2],
		                         op$1,
		                         function(match){
		                          var
		                           new_substate = match[3],
		                           delta = match[2],
		                           res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   delta,
		                                   function(delta, cont){return cont([1, delta]);},
		                                   function(delta){
		                                    var new_state = [0, state[1], new_substate];
		                                    return cont([0, res, delta, new_state]);
		                                   });
		                         });
		               }
		               function apply_delta$101(replica, state, delta, cont){
		                if(0 === delta[0]){
		                 var delta$0 = delta[1];
		                 return caml_trampoline_cps_call4
		                         (apply_delta$99,
		                          replica,
		                          state[1],
		                          delta$0,
		                          function(new_substate){
		                           return cont([0, new_substate, state[2]]);
		                          });
		                }
		                var delta$1 = delta[1];
		                return caml_trampoline_cps_call4
		                        (apply_delta$100,
		                         replica,
		                         state[2],
		                         delta$1,
		                         function(new_substate){
		                          return cont([0, state[1], new_substate]);
		                         });
		               }
		               var
		                include$256 =
		                  caml_callback
		                   (Apply$37,
		                    [[0, [0, schema_versioned$487], apply_delta$101, apply$105]]),
		                delta_schema_versioned$86 = include$256[1],
		                apply_delta$102 = include$256[3],
		                apply$106 = include$256[4],
		                Cell_schema =
		                  caml_callback(A, [[0, schema_versioned$159, schema$55]]);
		               function schema_versioned$488(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (field_schema_versioned$0,
		                                   schematic_version,
		                                   function(a){return cont([0, aVg, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$488,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Permissions = "Permissions",
		                letrec_function_context$767 = [];
		               function schema_versioned$489(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$767[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$767[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$767[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$767[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Cell_schema[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(4 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aVi,
		   cst_value,
		   cst_Value,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$86,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aVj,
		             cst_permissions,
		             cst_Permissions,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (String_LWW[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aVk,
		                       cst_name,
		                       cst_Name,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$6,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aVl,
		                                 cst_description,
		                                 cst_Description,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aVn,
		                                     aVm,
		                                     1,
		                                     0,
		                                     4,
		                                     function(c){
		                                      var a = [0, [0, c, V$4]];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$6,
		       schematic_version,
		       function(c){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aVo,
		              cst_computed,
		              cst_Computed,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_computed, 0, 2, [0, c], 0, 0], 0]],
		               0],
		              a],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$767[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$767[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$722 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$767, [0, schematic_cache$722]);
		               caml_callback
		                (schema_versioned$489,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$257 = Monadic$0(),
		                v$41 = include$257[1],
		                all_unit$23 = include$257[12],
		                Apply$38 = include$257[14],
		                letrec_function_context$768 = [];
		               function state_schema_versioned$66(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$768[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVp, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$768[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$768[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$768[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Cell_schema[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$65,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (String_LWW[2],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$5,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$5,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    value = c[2][1],
		    permissions = c[1],
		    name = b[1],
		    description = a[1],
		    computed = param[1];
		   return cont
		           ([0, computed, description, name, permissions, value]);
		  },
		  function(param, cont){
		   var
		    value = param[5],
		    permissions = param[4],
		    name = param[3],
		    description = param[2],
		    computed = param[1];
		   return cont
		           ([0,
		             computed,
		             [0, description, [0, name, [0, permissions, [0, value, 0]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_computed, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$768[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$768[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$723 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$768, [0, schematic_cache$723]);
		               caml_callback
		                (state_schema_versioned$66,
		                 [function(param, cont){return cont(0);}]);
		               function make$123(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (Cell_schema[10],
		                         init[5],
		                         function(a){
		                          var init$0 = init[4];
		                          return caml_exact_trampoline_cps_call
		                                  (make$122,
		                                   init$0[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (make$121,
		     init$0[1],
		     function(d){
		      var c = [0, d, b];
		      return caml_exact_trampoline_cps_call
		              (String_LWW[10],
		               init[3],
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (make$68,
		                         init[2],
		                         function(d){
		                          return caml_exact_trampoline_cps_call
		                                  (make$68,
		                                   init[1],
		                                   function(e){return cont([0, e, d, b, c, a]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$61(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (Cell_schema[11],
		                         t[5],
		                         function(a){
		                          var t$0 = t[4];
		                          return caml_exact_trampoline_cps_call
		                                  (view$60,
		                                   t$0[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (view$59,
		     t$0[1],
		     function(d){
		      var c = [0, d, b];
		      return caml_exact_trampoline_cps_call
		              (String_LWW[11],
		               t[3],
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (view$7,
		                         t[2],
		                         function(d){
		                          return caml_exact_trampoline_cps_call
		                                  (view$7,
		                                   t[1],
		                                   function(e){return cont([0, e, d, b, c, a]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$107(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$12,
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, new_substate, state[2], state[3], state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$12,
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], new_substate, state[3], state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (String_LWW[8],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], new_substate, state[4], state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$106,
		                            replica,
		                            state[4],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], state[3], new_substate, state[5]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$4 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Cell_schema[8],
		                            replica,
		                            state[5],
		                            op$4,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0, state[1], state[2], state[3], state[4], new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$103(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$8,
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0, new_substate, state[2], state[3], state[4], state[5]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$8,
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], new_substate, state[3], state[4], state[5]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (String_LWW[9],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], new_substate, state[4], state[5]]);
		                            });
		                  case 3:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$102,
		                            replica,
		                            state[4],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], state[3], new_substate, state[5]]);
		                            });
		                  default:
		                   var delta$4 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Cell_schema[9],
		                            replica,
		                            state[5],
		                            delta$4,
		                            function(new_substate){
		                             return cont
		                                     ([0, state[1], state[2], state[3], state[4], new_substate]);
		                            });
		                }
		               }
		               var
		                include$258 =
		                  caml_callback
		                   (Apply$38,
		                    [[0, [0, schema_versioned$489], apply_delta$103, apply$107]]),
		                delta_schema_versioned$87 = include$258[1],
		                apply_delta$104 = include$258[3],
		                apply$108 = include$258[4],
		                e = caml_callback(A, [[0, schema_versioned$128, schema$267]]),
		                Emoji =
		                  caml_callback
		                   (Make$28,
		                    [[0, , e[2], , e[4], , e[6], e[7], e[8], e[9], e[10], e[11]]]),
		                e = caml_callback(A, [[0, schema_versioned$54, schema$262]]),
		                Icon =
		                  caml_callback
		                   (Make$28,
		                    [[0, , e[2], , e[4], , e[6], e[7], e[8], e[9], e[10], e[11]]]),
		                e = caml_callback(A, [[0, schema_versioned$127, schema$43]]),
		                Color$0 =
		                  caml_callback
		                   (Make$28,
		                    [[0, , e[2], , e[4], , e[6], e[7], e[8], e[9], e[10], e[11]]]),
		                e = caml_callback(A, [[0, schema_versioned$160, schema$56]]),
		                Title_field =
		                  caml_callback
		                   (Make$28,
		                    [[0, , e[2], , e[4], , e[6], e[7], e[8], e[9], e[10], e[11]]]),
		                e = caml_callback(A, [[0, schema_versioned$161, schema$57]]),
		                Notes_field =
		                  caml_callback
		                   (Make$28,
		                    [[0, , e[2], , e[4], , e[6], e[7], e[8], e[9], e[10], e[11]]]),
		                Hidden_columns =
		                  caml_callback
		                   (bOD,
		                    [[0,
		                      schema_versioned$142,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$25,
		                      pp$61]]),
		                letrec_function_context$769 = [];
		               function schema_versioned$490(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$769[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVq, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$769[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$769[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$769[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aVs,
		                                     aVr,
		                                     0,
		                                     23,
		                                     1,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_trampoline_cps_call2
		      (Title_field[8],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(5 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aVt,
		             cst_title_field,
		             "Title_field",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_title_field, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aVv,
		                 aVu,
		                 1,
		                 0,
		                 4,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_trampoline_cps_call2
		                          (Notes_field[8],
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(4 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aVw,
		                                 cst_notes_field,
		                                 "Notes_field",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_notes_field, 0, 2, [0, d], 0, 0], 0]],
		                                  0],
		                                 a],
		                                b];
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aVy,
		                                     aVx,
		                                     0,
		                                     25,
		                                     9,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_trampoline_cps_call2
		      (Icon[8],
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aVz,
		             cst_icon,
		             cst_Icon,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_icon, 0, 2, [0, d], 0, 0], 0]],
		              0],
		             a],
		            c];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aVB,
		                 aVA,
		                 1,
		                 0,
		                 4,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_trampoline_cps_call2
		                          (Hidden_columns[4],
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aVC,
		                                 cst_hidden_columns,
		                                 "Hidden_columns",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_hidden_columns, 0, 2, [0, d], 0, 0],
		                                    0]],
		                                  0],
		                                 a],
		                                b];
		                            return caml_trampoline_cps_call2
		                                    (Emoji[8],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aVD,
		   cst_emoji,
		   cst_Emoji,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_emoji, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  c];
		                                      return caml_trampoline_cps_call2
		      (Color$0[8],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              aVE,
		              cst_color,
		              cst_Color,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var delta = param[1];
		                 return cont(delta);
		                },
		                function(delta, cont){return cont([0, delta, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$769[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$769[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$724 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$769, [0, schematic_cache$724]);
		               caml_callback
		                (schema_versioned$490,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$259 = Monadic$0(),
		                v$42 = include$259[1],
		                return$36 = include$259[7],
		                all_unit$24 = include$259[12],
		                Apply$39 = include$259[14],
		                letrec_function_context$770 = [];
		               function state_schema_versioned$67(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$770[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVF, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$770[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$770[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$770[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Title_field[3],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_title_field, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Notes_field[3],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_notes_field, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Icon[3],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_icon, 0, 2, [0, c], 0, 0], b];
		                  return caml_trampoline_cps_call2
		                          (Hidden_columns[2],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_hidden_columns, 0, 2, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (Emoji[3],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_emoji, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (Color$0[3],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              title_field = d[2][1],
		              notes_field = d[1],
		              icon = c[1],
		              hidden_columns = b[1],
		              emoji = a[1],
		              color = param[1];
		             return cont
		                     ([0,
		                       color,
		                       emoji,
		                       hidden_columns,
		                       icon,
		                       notes_field,
		                       title_field]);
		            },
		            function(param, cont){
		             var
		              title_field = param[6],
		              notes_field = param[5],
		              icon = param[4],
		              hidden_columns = param[3],
		              emoji = param[2],
		              color = param[1];
		             return cont
		                     ([0,
		                       color,
		                       [0,
		                        emoji,
		                        [0,
		                         hidden_columns,
		                         [0, icon, [0, notes_field, [0, title_field, 0]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_color, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$770[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$770[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$725 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$770, [0, schematic_cache$725]);
		               caml_callback
		                (state_schema_versioned$67,
		                 [function(param, cont){return cont(0);}]);
		               function make$124(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (Title_field[13],
		                         init[6],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Notes_field[13],
		                                   init[5],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Icon[13],
		     init[4],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Hidden_columns[10],
		               init[3],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Emoji[13],
		                         init[2],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Color$0[13],
		                                   init[1],
		                                   function(f){return cont([0, f, e, d, c, b, a]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$62(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (Title_field[14],
		                         t[6],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Notes_field[14],
		                                   t[5],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Icon[14],
		     t[4],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Hidden_columns[11],
		               t[3],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (Emoji[14],
		                         t[2],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (Color$0[14],
		                                   t[1],
		                                   function(f){return cont([0, f, e, d, c, b, a]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$109(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Color$0[11],
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   new_substate,
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Emoji[11],
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   new_substate,
		   state[3],
		   state[4],
		   state[5],
		   state[6]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Hidden_columns[8],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   new_substate,
		   state[4],
		   state[5],
		   state[6]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Icon[11],
		                            replica,
		                            state[4],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   new_substate,
		   state[5],
		   state[6]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 4:
		                   var op$4 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Notes_field[11],
		                            replica,
		                            state[5],
		                            op$4,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   new_substate,
		   state[6]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$5 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Title_field[11],
		                            replica,
		                            state[6],
		                            op$5,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$105(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Color$0[10],
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       new_substate,
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Emoji[10],
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       new_substate,
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Hidden_columns[9],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       new_substate,
		                                       state[4],
		                                       state[5],
		                                       state[6]]);
		                            });
		                  case 3:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Icon[10],
		                            replica,
		                            state[4],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       new_substate,
		                                       state[5],
		                                       state[6]]);
		                            });
		                  case 4:
		                   var delta$4 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Notes_field[10],
		                            replica,
		                            state[5],
		                            delta$4,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       new_substate,
		                                       state[6]]);
		                            });
		                  default:
		                   var delta$5 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Title_field[10],
		                            replica,
		                            state[6],
		                            delta$5,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       new_substate]);
		                            });
		                }
		               }
		               var
		                include$260 =
		                  caml_callback
		                   (Apply$39,
		                    [[0, [0, schema_versioned$490], apply_delta$105, apply$109]]),
		                delta_schema_versioned$88 = include$260[1],
		                apply_delta$106 = include$260[3],
		                apply$110 = include$260[4],
		                Row_crdt =
		                  caml_callback
		                   (bPy,
		                    [[0,
		                      schema_versioned$142,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$25,
		                      pp$61],
		                     [0,
		                      equal$249,
		                      ,
		                      state_schema_versioned$62,
		                      ,
		                      delta_schema_versioned$83,
		                      ,
		                      Init$13,
		                      Monad$16,
		                      apply$102,
		                      apply_delta$98,
		                      make$120,
		                      view$58,
		                      diff$10]]),
		                Map$3 = Row_crdt[1],
		                Operation$17 = Row_crdt[2],
		                state_schema_versioned$68 = Row_crdt[3],
		                delta_schema_versioned$89 = Row_crdt[5],
		                Init$14 = Row_crdt[7],
		                Monad$17 = Row_crdt[8],
		                apply$111 = Row_crdt[9],
		                apply_delta$107 = Row_crdt[10],
		                make$125 = Row_crdt[11],
		                view$63 = Row_crdt[12],
		                equal$250 = Row_crdt[20];
		               function diff$11(previous_value, new_value, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (Map$3[60],
		                         previous_value,
		                         new_value,
		                         equal$79,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_binable,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (map$18,
		     a,
		     function(a, cont){
		      var diff = a[2], key = a[1], variant = diff[1];
		      if(847852583 === variant)
		       return caml_trampoline_cps_call2
		               (Operation$17[2],
		                [3, key],
		                function(a){
		                 return caml_trampoline_cps_call2(Operation$17[11], a, cont);
		                });
		      if(1013247643 <= variant){
		       a = diff[2];
		       var new_cell = a[2], previous_cell = a[1];
		       return caml_exact_trampoline_cps_call$1
		               (equal$79,
		                previous_cell,
		                new_cell,
		                function(b){
		                 function a(op){
		                  return caml_trampoline_cps_call2
		                          (Operation$17[2],
		                           [1, key, op],
		                           function(a){
		                            return caml_trampoline_cps_call2(Operation$17[11], a, cont);
		                           });
		                 }
		                 return b
		                         ? caml_trampoline_cps_call2(Operation$16[5], 0, a)
		                         : caml_exact_trampoline_cps_call$1
		                           (diff$10, previous_cell, new_cell, a);
		                });
		      }
		      var new_value = diff[2];
		      return caml_trampoline_cps_call2
		              (Operation$17[2],
		               [0, key, new_value],
		               function(a){
		                return caml_trampoline_cps_call2(Operation$17[11], a, cont);
		               });
		     },
		     function(a){
		      return caml_trampoline_cps_call2(Operation$17[13], a, cont);
		     });
		                                   });
		                         });
		               }
		               var
		                include$321 =
		                  caml_callback
		                   (bPy,
		                    [[0,
		                      include$51[4],
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      include$51[24],
		                      include$51[1]],
		                     [0,
		                      equal$250,
		                      ,
		                      state_schema_versioned$68,
		                      ,
		                      delta_schema_versioned$89,
		                      ,
		                      Init$14,
		                      Monad$17,
		                      apply$111,
		                      apply_delta$107,
		                      make$125,
		                      view$63,
		                      diff$11]]),
		                Permissions =
		                  caml_callback(A, [[0, schema_versioned$166, schema$59]]);
		               caml_callback(A, [[0, schema_versioned$159, schema$55]]);
		               var
		                Origin =
		                  caml_callback(A, [[0, schema_versioned$167, schema$60]]),
		                Row_schema =
		                  caml_callback
		                   (cm,
		                    [[0,
		                      schema_versioned$142,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$25,
		                      pp$61],
		                     [0,
		                      ,
		                      state_schema_versioned$66,
		                      ,
		                      delta_schema_versioned$87,
		                      ,
		                      [0, schema_versioned$488],
		                      include$0,
		                      apply$108,
		                      apply_delta$104,
		                      make$123,
		                      view$61]]),
		                cst_Rows = "Rows",
		                letrec_function_context$771 = [];
		               function schema_versioned$491(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$771[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$771[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$771[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$771[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (Origin[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([7, f0]);},
		   function(param, cont){
		    if(7 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aVH,
		   cst_origin,
		   "Origin",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (Permissions[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(6 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aVI,
		             cst_permissions,
		             cst_Permissions,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (include$321[5],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([5, f0]);},
		                       function(param, cont){
		                        if(5 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aVJ,
		                       cst_rows,
		                       cst_Rows,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_rows, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Row_schema[5],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(4 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aVK,
		                                 cst_schema$0,
		                                 cst_Schema,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_schema$0, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$88,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aVL,
		   cst_meta,
		   "Meta",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aVM,
		             cst_description,
		             cst_Description,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$4,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aVN,
		                       cst_data_name,
		                       "Data_name",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_data_name, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$4,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  aVO,
		                                  cst_name,
		                                  cst_Name,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var delta = param[1];
		                                     return cont(delta);
		                                    },
		                                    function(delta, cont){return cont([0, delta, 0]);},
		                                    [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], 0]],
		                                   0],
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$771[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$771[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$726 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$771, [0, schematic_cache$726]);
		               caml_callback
		                (schema_versioned$491,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$261 = Monadic$0(),
		                v$43 = include$261[1],
		                const$19 = include$261[2],
		                return$37 = include$261[7],
		                all_unit$25 = include$261[12],
		                Apply$40 = include$261[14],
		                letrec_function_context$772 = [];
		               function state_schema_versioned$69(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$772[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$772[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$772[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$772[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Origin[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Permissions[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (include$321[3],
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_rows, 0, 2, [0, c], 0, 0], b];
		                  return caml_trampoline_cps_call2
		                          (Row_schema[3],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, cst_schema$0, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$67,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [0, c], 0, 0], b];
		                                      return caml_exact_trampoline_cps_call
		      (state_schema_versioned$3,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_description, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (state_schema_versioned$3,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_data_name, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$3,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  origin = f[2][1],
		                                  permissions = f[1],
		                                  rows = e[1],
		                                  schema = d[1],
		                                  meta = c[1],
		                                  description = b[1],
		                                  data_name = a[1],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   data_name,
		   description,
		   meta,
		   schema,
		   rows,
		   permissions,
		   origin]);
		                                },
		                                function(param, cont){
		                                 var
		                                  origin = param[8],
		                                  permissions = param[7],
		                                  rows = param[6],
		                                  schema = param[5],
		                                  meta = param[4],
		                                  description = param[3],
		                                  data_name = param[2],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   [0,
		    data_name,
		    [0,
		     description,
		     [0,
		      meta,
		      [0, schema, [0, rows, [0, permissions, [0, origin, 0]]]]]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$772[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$772[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$727 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$772, [0, schematic_cache$727]);
		               var
		                state_schema$24 =
		                  caml_callback
		                   (state_schema_versioned$69,
		                    [function(param, cont){return cont(0);}]);
		               function make$126(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (Origin[10],
		                         init[8],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Permissions[10],
		                                   init[7],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (include$321[11],
		     init[6],
		     function(c){
		      return caml_trampoline_cps_call2
		              (Row_schema[11],
		               init[5],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (make$124,
		                         init[4],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (make$66,
		                                   init[3],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (make$66,
		     init[2],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (make$66,
		               init[1],
		               function(h){return cont([0, h, g, f, e, d, c, b, a]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function view$64(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (Origin[11],
		                         t[8],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Permissions[11],
		                                   t[7],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (include$321[12],
		     t[6],
		     function(c){
		      return caml_trampoline_cps_call2
		              (Row_schema[12],
		               t[5],
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (view$62,
		                         t[4],
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (view$4,
		                                   t[3],
		                                   function(f){
		                                    return caml_exact_trampoline_cps_call
		    (view$4,
		     t[2],
		     function(g){
		      return caml_exact_trampoline_cps_call
		              (view$4,
		               t[1],
		               function(h){return cont([0, h, g, f, e, d, c, b, a]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$112(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$10,
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   new_substate,
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$10,
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   new_substate,
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$10,
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   new_substate,
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 3:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (apply$110,
		                            replica,
		                            state[4],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   new_substate,
		   state[5],
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 4:
		                   var op$4 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Row_schema[9],
		                            replica,
		                            state[5],
		                            op$4,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([4, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   new_substate,
		   state[6],
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 5:
		                   var op$5 = op[1];
		                   return caml_trampoline_cps_call4
		                           (include$321[9],
		                            replica,
		                            state[6],
		                            op$5,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([5, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   new_substate,
		   state[7],
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 6:
		                   var op$6 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Permissions[8],
		                            replica,
		                            state[7],
		                            op$6,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([6, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   new_substate,
		   state[8]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$7 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Origin[8],
		                            replica,
		                            state[8],
		                            op$7,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([7, delta]);},
		                                      function(delta){
		                                       var
		new_state =
		  [0,
		   state[1],
		   state[2],
		   state[3],
		   state[4],
		   state[5],
		   state[6],
		   state[7],
		   new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$108(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       new_substate,
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       new_substate,
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$6,
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       new_substate,
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 3:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (apply_delta$106,
		                            replica,
		                            state[4],
		                            delta$3,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       new_substate,
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 4:
		                   var delta$4 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Row_schema[10],
		                            replica,
		                            state[5],
		                            delta$4,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       new_substate,
		                                       state[6],
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 5:
		                   var delta$5 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (include$321[10],
		                            replica,
		                            state[6],
		                            delta$5,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       new_substate,
		                                       state[7],
		                                       state[8]]);
		                            });
		                  case 6:
		                   var delta$6 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Permissions[9],
		                            replica,
		                            state[7],
		                            delta$6,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       new_substate,
		                                       state[8]]);
		                            });
		                  default:
		                   var delta$7 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Origin[9],
		                            replica,
		                            state[8],
		                            delta$7,
		                            function(new_substate){
		                             return cont
		                                     ([0,
		                                       state[1],
		                                       state[2],
		                                       state[3],
		                                       state[4],
		                                       state[5],
		                                       state[6],
		                                       state[7],
		                                       new_substate]);
		                            });
		                }
		               }
		               var
		                include$262 =
		                  caml_callback
		                   (Apply$40,
		                    [[0, [0, schema_versioned$491], apply_delta$108, apply$112]]),
		                delta_schema_versioned$90 = include$262[1],
		                delta_schema$25 = include$262[2],
		                apply_delta$109 = include$262[3],
		                apply$113 = include$262[4];
		               function rows(a, cont){
		                return caml_exact_trampoline_cps_call(v$43, [5, a], cont);
		               }
		               var
		                default_schema_fold_params =
		                  [0,
		                   function(key, new_value, cont){
		                    return caml_trampoline_cps_call3
		                            (Row_schema[14],
		                             key,
		                             new_value,
		                             function(a){
		                              return caml_trampoline_cps_call2(Row_schema[2][11], a, cont);
		                             });
		                   },
		                   function(key, previous_value, cont){
		                    return caml_trampoline_cps_call2
		                            (Row_schema[18],
		                             key,
		                             function(a){
		                              return caml_trampoline_cps_call2(Row_schema[2][11], a, cont);
		                             });
		                   },
		                   function(key, previous, current, cont){
		                    var
		                     new_value = current[5],
		                     new_permission = current[4],
		                     new_name = current[3],
		                     new_description = current[2],
		                     new_computed = current[1],
		                     previous_value = previous[5],
		                     previous_permission = previous[4],
		                     previous_name = previous[3],
		                     previous_description = previous[2],
		                     previous_computed = previous[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (diff$3,
		                             previous_computed,
		                             new_computed,
		                             function(op){
		                              return caml_exact_trampoline_cps_call
		                                      (v$41,
		                                       [0, op],
		                                       function(a){
		var op_computed = [0, a];
		return caml_exact_trampoline_cps_call$1
		        (diff$3,
		         previous_description,
		         new_description,
		         function(op){
		          return caml_exact_trampoline_cps_call
		                  (v$41,
		                   [1, op],
		                   function(b){
		                    var op_description = [0, b];
		                    function a(op_name){
		                     var
		                      current = new_permission[2],
		                      current$0 = new_permission[1],
		                      open =
		                        g
		                         ([0,
		                           symbol_bind$5,
		                           symbol_map$5,
		                           ,
		                           bind$8,
		                           return$9,
		                           map$17,
		                           ,
		                           ,
		                           ,
		                           ,
		                           Let_syntax$3]),
		                      let$ = open[4],
		                      previous = previous_permission[1];
		                     function a(op, cont){
		                      return caml_exact_trampoline_cps_call(v$40, [0, op], cont);
		                     }
		                     return caml_exact_trampoline_cps_call$1
		                             (equal$83,
		                              previous,
		                              current$0,
		                              function(c){
		                               function b(b){
		                                return caml_trampoline_cps_call3
		(let$,
		 b,
		 a,
		 function(schema_op){
		  var previous = previous_permission[2];
		  function a(op, cont){
		   return caml_exact_trampoline_cps_call(v$40, [1, op], cont);
		  }
		  return caml_exact_trampoline_cps_call$1
		          (equal$84,
		           previous,
		           current,
		           function(c){
		            function b(b){
		             return caml_trampoline_cps_call3
		                     (let$,
		                      b,
		                      a,
		                      function(data_op){
		                       function a(match){
		                        function a(op_permission){
		                         return caml_exact_trampoline_cps_call$1
		                                 (equal$89,
		                                  previous_value,
		                                  new_value,
		                                  function(b){
		                                   function a(op_value){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0,
		      op_computed,
		      [0,
		       op_description,
		       [0, op_name, [0, op_permission, [0, op_value, 0]]]]],
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (all_unit$23,
		               a,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (Row_schema[15],
		                         key,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (b,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(Row_schema[2][11], a, cont);
		                                   });
		                         });
		               });
		     });
		                                   }
		                                   return b
		   ? a(0)
		   : caml_exact_trampoline_cps_call
		     (Cell_schema[12],
		      new_value,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (v$41, [4, b], function(b){return a([0, b]);});
		      });
		                                  });
		                        }
		                        if(! match) return a(0);
		                        var op = match[1];
		                        return caml_exact_trampoline_cps_call
		                                (v$41, [3, op], function(b){return a([0, b]);});
		                       }
		                       if(! schema_op && ! data_op) return a(0);
		                       return caml_exact_trampoline_cps_call
		                               (filter_opt,
		                                [0, schema_op, [0, data_op, 0]],
		                                function(b){
		                                 return caml_exact_trampoline_cps_call
		 (all_unit$22, b, function(b){return a([0, b]);});
		                                });
		                      });
		            }
		            return c
		                    ? b(0)
		                    : caml_exact_trampoline_cps_call
		                      (set$22, current, function(a){return b([0, a]);});
		           });
		 });
		                               }
		                               return c
		                                       ? b(0)
		                                       : caml_exact_trampoline_cps_call
		 (set$21, current$0, function(a){return b([0, a]);});
		                              });
		                    }
		                    return previous_name === new_name
		                            ? a(0)
		                            : caml_exact_trampoline_cps_call
		                              (String_LWW[12],
		                               new_name,
		                               function(b){
		                                return caml_exact_trampoline_cps_call
		(v$41, [2, b], function(b){return a([0, b]);});
		                               });
		                   });
		         });
		                                       });
		                             });
		                   }];
		               function diff_schema_fold(fold_params, previous, t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (symmetric_diff$2,
		                         previous,
		                         t,
		                         equal_field,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_binable,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (map$18,
		     a,
		     function(a, cont){
		      var diff = a[2], key = a[1], variant = diff[1];
		      if(847852583 === variant)
		       return caml_exact_trampoline_cps_call$1
		               (fold_params[2], key, dummy, cont);
		      if(1013247643 <= variant){
		       a = diff[2];
		       var current = a[2], previous = a[1];
		       return caml_exact_trampoline_cps_call$0
		               (fold_params[3], key, previous, current, cont);
		      }
		      var new_value = diff[2];
		      return caml_exact_trampoline_cps_call$1
		              (fold_params[1], key, new_value, cont);
		     },
		     function(ops){
		      return caml_trampoline_cps_call2
		              (Row_schema[2][13],
		               ops,
		               function(a){
		                return caml_exact_trampoline_cps_call(v$43, [4, a], cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function diff_schema(previous, t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (diff_schema_fold,
		                         default_schema_fold_params,
		                         previous,
		                         t,
		                         cont);
		               }
		               function diff_excluding_rows(opt, previous, param, cont){
		                var
		                 diff_schema$0 = opt ? opt[1] : diff_schema,
		                 origin = param[8],
		                 permissions = param[7],
		                 schema = param[5],
		                 meta = param[4],
		                 description = param[3],
		                 data_name = param[2],
		                 name = param[1],
		                 previous$0 = previous[1];
		                return caml_exact_trampoline_cps_call$1
		                        (diff$1,
		                         previous$0,
		                         name,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (Fugue[3][5],
		                                   0,
		                                   function(b){
		                                    var a$0 = value$4(a, b);
		                                    return caml_exact_trampoline_cps_call
		    (v$43,
		     [0, a$0],
		     function(name){
		      var previous$0 = previous[2];
		      return caml_exact_trampoline_cps_call$1
		              (diff$1,
		               previous$0,
		               data_name,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (Fugue[3][5],
		                         0,
		                         function(b){
		                          var a$0 = value$4(a, b);
		                          return caml_exact_trampoline_cps_call
		                                  (v$43,
		                                   [1, a$0],
		                                   function(data_name){
		                                    var
		                                     previous$0 = previous[4],
		                                     new_title_field = meta[6],
		                                     new_notes_field = meta[5],
		                                     new_icon = meta[4],
		                                     new_hidden_columns = meta[3],
		                                     new_emoji = meta[2],
		                                     new_color = meta[1],
		                                     previous_title_field = previous$0[6],
		                                     previous_notes_field = previous$0[5],
		                                     previous_icon = previous$0[4],
		                                     previous_hidden_columns = previous$0[3],
		                                     previous_emoji = previous$0[2],
		                                     previous_color = previous$0[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (equal_option,
		     equal$44,
		     previous_icon,
		     new_icon,
		     function(b){
		      function a(icon){
		       a:
		       {
		        if(previous_emoji){
		         if(new_emoji){
		          var
		           x = new_emoji[1],
		           x$0 = previous_emoji[1],
		           a = x$0 === x;
		          break a;
		         }
		        }
		        else if(! new_emoji){a = 1; break a;}
		        a = 0;
		       }
		       function b(emoji){
		        return caml_exact_trampoline_cps_call$0
		                (equal_option,
		                 equal$66,
		                 previous_color,
		                 new_color,
		                 function(b){
		                  function a(color){
		                   return caml_exact_trampoline_cps_call$0
		                           (equal_option,
		                            equal$90,
		                            previous_title_field,
		                            new_title_field,
		                            function(b){
		                             function a(title_field){
		                              return caml_exact_trampoline_cps_call$0
		                                      (equal_option,
		                                       equal$91,
		                                       previous_notes_field,
		                                       new_notes_field,
		                                       function(b){
		function a(notes_field){
		 return caml_exact_trampoline_cps_call$1
		         (Set$1[16],
		          previous_hidden_columns,
		          new_hidden_columns,
		          function(b){
		           function a(hidden_columns){
		            return caml_exact_trampoline_cps_call
		                    (all_unit$24,
		                     [0,
		                      icon,
		                      [0,
		                       emoji,
		                       [0,
		                        color,
		                        [0, title_field, [0, notes_field, [0, hidden_columns, 0]]]]]],
		                     function(a){
		                      return caml_exact_trampoline_cps_call
		                              (v$43,
		                               [3, a],
		                               function(meta){
		                                return caml_exact_trampoline_cps_call$1
		(diff_schema$0,
		 previous[5],
		 schema,
		 function(schema){
		  var previous$0 = previous[3];
		  return caml_exact_trampoline_cps_call$1
		          (diff$1,
		           previous$0,
		           description,
		           function(a){
		            return caml_trampoline_cps_call2
		                    (Fugue[3][5],
		                     0,
		                     function(b){
		                      return caml_exact_trampoline_cps_call
		                              (v$43,
		                               [2, value$4(a, b)],
		                               function(description){
		                                var previous$0 = previous[7];
		                                return caml_exact_trampoline_cps_call$1
		(equal$96,
		 previous$0,
		 permissions,
		 function(b){
		  function a(permissions){
		   var previous$0 = previous[8];
		   return caml_exact_trampoline_cps_call$1
		           (equal$97,
		            previous$0,
		            origin,
		            function(b){
		             function a(origin){
		              return caml_exact_trampoline_cps_call
		                      (all_unit$25,
		                       [0,
		                        data_name,
		                        [0,
		                         name,
		                         [0,
		                          meta,
		                          [0,
		                           schema,
		                           [0, permissions, [0, origin, [0, description, 0]]]]]]],
		                       cont);
		             }
		             return b
		                     ? caml_trampoline_cps_call2(return$37, 0, a)
		                     : caml_exact_trampoline_cps_call
		                       (Origin[12],
		                        origin,
		                        function(a$0){
		                         return caml_exact_trampoline_cps_call(v$43, [7, a$0], a);
		                        });
		            });
		  }
		  return b
		          ? caml_trampoline_cps_call2(return$37, 0, a)
		          : caml_exact_trampoline_cps_call
		            (Permissions[12],
		             permissions,
		             function(a$0){
		              return caml_exact_trampoline_cps_call(v$43, [6, a$0], a);
		             });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           }
		           return b
		                   ? caml_trampoline_cps_call2(return$36, 0, a)
		                   : caml_exact_trampoline_cps_call$1
		                     (Hidden_columns[15],
		                      previous_hidden_columns,
		                      new_hidden_columns,
		                      function(b){
		                       return caml_exact_trampoline_cps_call(v$42, [2, b], a);
		                      });
		          });
		}
		return b
		        ? caml_trampoline_cps_call2(return$36, 0, a)
		        : caml_exact_trampoline_cps_call
		          (Notes_field[16],
		           new_notes_field,
		           function(b){
		            return caml_exact_trampoline_cps_call(v$42, [4, b], a);
		           });
		                                       });
		                             }
		                             return b
		                                     ? caml_trampoline_cps_call2(return$36, 0, a)
		                                     : caml_exact_trampoline_cps_call
		                                       (Title_field[16],
		new_title_field,
		function(b){
		 return caml_exact_trampoline_cps_call(v$42, [5, b], a);
		});
		                            });
		                  }
		                  return b
		                          ? caml_trampoline_cps_call2(return$36, 0, a)
		                          : caml_exact_trampoline_cps_call
		                            (Color$0[16],
		                             new_color,
		                             function(b){
		                              return caml_exact_trampoline_cps_call(v$42, [0, b], a);
		                             });
		                 });
		       }
		       return a
		               ? caml_trampoline_cps_call2(return$36, 0, b)
		               : caml_exact_trampoline_cps_call
		                 (Emoji[16],
		                  new_emoji,
		                  function(a){
		                   return caml_exact_trampoline_cps_call(v$42, [1, a], b);
		                  });
		      }
		      return b
		              ? caml_trampoline_cps_call2(return$36, 0, a)
		              : caml_exact_trampoline_cps_call
		                (Icon[16],
		                 new_icon,
		                 function(b){
		                  return caml_exact_trampoline_cps_call(v$42, [3, b], a);
		                 });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                Db_crdt =
		                  caml_callback
		                   (cm,
		                    [[0,
		                      Table[4],
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Table[24],
		                      Table[1]],
		                     [0,
		                      ,
		                      state_schema_versioned$69,
		                      ,
		                      delta_schema_versioned$90,
		                      ,
		                      [0, schema_versioned$168],
		                      include$0,
		                      apply$113,
		                      apply_delta$109,
		                      make$126,
		                      view$64]]),
		                Map$4 = Db_crdt[1],
		                Operation$18 = Db_crdt[2],
		                delta_schema_versioned$91 = Db_crdt[5],
		                add$28 = Db_crdt[14],
		                element$18 = Db_crdt[15],
		                element$19 = Db_crdt[16],
		                Config =
		                  caml_callback(A, [[0, schema_versioned$306, schema$126]]),
		                e = caml_callback(A, [[0, schema_versioned$185, schema$67]]),
		                Scheduling =
		                  caml_callback
		                   (Make$28,
		                    [[0, , e[2], , e[4], , e[6], e[7], e[8], e[9], e[10], e[11]]]),
		                e = caml_callback(A, [[0, schema_versioned$4, schema$7]]),
		                Status_changed_at =
		                  caml_callback
		                   (Make$28,
		                    [[0, , e[2], , e[4], , e[6], e[7], e[8], e[9], e[10], e[11]]]),
		                cst_Discarded = "Discarded",
		                letrec_function_context$773 = [];
		               function schema_versioned$492(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$773[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$773[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$773[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$773[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aVS,
		                                     aVR,
		                                     1,
		                                     0,
		                                     5,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_trampoline_cps_call2
		      (include$139[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aVT,
		             cst_starred,
		             cst_Starred,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_starred, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             a],
		            0];
		        return caml_trampoline_cps_call2
		                (include$139[4],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aVU,
		                       cst_discarded,
		                       cst_Discarded,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_discarded, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (Status_changed_at[8],
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aVV,
		                                 cst_status_changed_at,
		                                 "Status_changed_at",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_status_changed_at, 0, 2, [0, c], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_trampoline_cps_call2
		                                    (Scheduling[8],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    aVW,
		    cst_scheduling,
		    "Scheduling",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var delta = param[1];
		       return cont(delta);
		      },
		      function(delta, cont){return cont([0, delta, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_scheduling, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$773[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$773[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$728 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$773, [0, schematic_cache$728]);
		               caml_callback
		                (schema_versioned$492,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$263 = Monadic$0(),
		                v$44 = include$263[1],
		                return$38 = include$263[7],
		                all_unit$26 = include$263[12],
		                Apply$41 = include$263[14],
		                letrec_function_context$774 = [];
		               function state_schema_versioned$70(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$774[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$774[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$774[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$774[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$139[2],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_starred, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (include$139[2],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_discarded, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (Status_changed_at[3],
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_status_changed_at, 0, 2, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (Scheduling[3],
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  starred = b[2][1],
		                                  discarded = b[1],
		                                  status_changed_at = a[1],
		                                  scheduling = param[1];
		                                 return cont
		 ([0, scheduling, status_changed_at, discarded, starred]);
		                                },
		                                function(param, cont){
		                                 var
		                                  starred = param[4],
		                                  discarded = param[3],
		                                  status_changed_at = param[2],
		                                  scheduling = param[1];
		                                 return cont
		 ([0,
		   scheduling,
		   [0, status_changed_at, [0, discarded, [0, starred, 0]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_scheduling, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$774[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$774[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$729 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$774, [0, schematic_cache$729]);
		               caml_callback
		                (state_schema_versioned$70,
		                 [function(param, cont){return cont(0);}]);
		               function make$127(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[10],
		                         init[4],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[10],
		                                   init[3],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Status_changed_at[13],
		     init[2],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Scheduling[13],
		               init[1],
		               function(d){return cont([0, d, c, b, a]);});
		     });
		                                   });
		                         });
		               }
		               function view$65(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[11],
		                         t[4],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (include$139[11],
		                                   t[3],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (Status_changed_at[14],
		     t[2],
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (Scheduling[14],
		               t[1],
		               function(d){return cont([0, d, c, b, a]);});
		     });
		                                   });
		                         });
		               }
		               function apply$114(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(op[0]){
		                  case 0:
		                   var op$0 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Scheduling[11],
		                            replica,
		                            state[1],
		                            op$0,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([0, delta]);},
		                                      function(delta){
		                                       var
		new_state = [0, new_substate, state[2], state[3], state[4]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 1:
		                   var op$1 = op[1];
		                   return caml_trampoline_cps_call4
		                           (Status_changed_at[11],
		                            replica,
		                            state[2],
		                            op$1,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([1, delta]);},
		                                      function(delta){
		                                       var
		new_state = [0, state[1], new_substate, state[3], state[4]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  case 2:
		                   var op$2 = op[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[8],
		                            replica,
		                            state[3],
		                            op$2,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([2, delta]);},
		                                      function(delta){
		                                       var
		new_state = [0, state[1], state[2], new_substate, state[4]];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                  default:
		                   var op$3 = op[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[8],
		                            replica,
		                            state[4],
		                            op$3,
		                            function(match){
		                             var
		                              new_substate = match[3],
		                              delta = match[2],
		                              res = match[1];
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      delta,
		                                      function(delta, cont){return cont([3, delta]);},
		                                      function(delta){
		                                       var
		new_state = [0, state[1], state[2], state[3], new_substate];
		                                       return cont([0, res, delta, new_state]);
		                                      });
		                            });
		                }
		               }
		               function apply_delta$110(replica, state, delta, cont){
		                switch(delta[0]){
		                  case 0:
		                   var delta$0 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Scheduling[10],
		                            replica,
		                            state[1],
		                            delta$0,
		                            function(new_substate){
		                             return cont([0, new_substate, state[2], state[3], state[4]]);
		                            });
		                  case 1:
		                   var delta$1 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (Status_changed_at[10],
		                            replica,
		                            state[2],
		                            delta$1,
		                            function(new_substate){
		                             return cont([0, state[1], new_substate, state[3], state[4]]);
		                            });
		                  case 2:
		                   var delta$2 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[9],
		                            replica,
		                            state[3],
		                            delta$2,
		                            function(new_substate){
		                             return cont([0, state[1], state[2], new_substate, state[4]]);
		                            });
		                  default:
		                   var delta$3 = delta[1];
		                   return caml_trampoline_cps_call4
		                           (include$139[9],
		                            replica,
		                            state[4],
		                            delta$3,
		                            function(new_substate){
		                             return cont([0, state[1], state[2], state[3], new_substate]);
		                            });
		                }
		               }
		               var
		                include$264 =
		                  caml_callback
		                   (Apply$41,
		                    [[0, [0, schema_versioned$492], apply_delta$110, apply$114]]),
		                delta_schema_versioned$92 = include$264[1],
		                apply_delta$111 = include$264[3],
		                apply$115 = include$264[4];
		               function scheduling(a, cont){
		                return caml_exact_trampoline_cps_call(v$44, [0, a], cont);
		               }
		               function status_changed_at(a, cont){
		                return caml_exact_trampoline_cps_call(v$44, [1, a], cont);
		               }
		               function discarded(a, cont){
		                return caml_exact_trampoline_cps_call(v$44, [2, a], cont);
		               }
		               function starred(a, cont){
		                return caml_exact_trampoline_cps_call(v$44, [3, a], cont);
		               }
		               function diff$12(previous, current, cont){
		                var y = current[1], x = previous[1];
		                function c(b){
		                 function a(scheduling_op){
		                  var y = current[2], x = previous[2];
		                  function c(b){
		                   function a(status_changed_at_op){
		                    var y = current[3], x = previous[3];
		                    function a(discarded_op){
		                     var y = current[4], x = previous[4];
		                     function a(starred_op){
		                      return caml_exact_trampoline_cps_call
		                              (all_unit$26,
		                               [0,
		                                scheduling_op,
		                                [0,
		                                 status_changed_at_op,
		                                 [0, discarded_op, [0, starred_op, 0]]]],
		                               cont);
		                     }
		                     return x === y
		                             ? caml_trampoline_cps_call2(return$38, 0, a)
		                             : caml_exact_trampoline_cps_call
		                               (include$139[12],
		                                current[4],
		                                function(b){
		                                 return caml_exact_trampoline_cps_call(starred, b, a);
		                                });
		                    }
		                    return x === y
		                            ? caml_trampoline_cps_call2(return$38, 0, a)
		                            : caml_exact_trampoline_cps_call
		                              (include$139[12],
		                               current[3],
		                               function(b){
		                                return caml_exact_trampoline_cps_call(discarded, b, a);
		                               });
		                   }
		                   return b
		                           ? caml_trampoline_cps_call2(return$38, 0, a)
		                           : caml_exact_trampoline_cps_call
		                             (Status_changed_at[16],
		                              current[2],
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (status_changed_at, b, a);
		                              });
		                  }
		                  if(x){
		                   if(y){
		                    var b = y[1], a = x[1];
		                    return caml_exact_trampoline_cps_call$1(equal$20, a, b, c);
		                   }
		                  }
		                  else if(! y) return c(1);
		                  return c(0);
		                 }
		                 return b
		                         ? caml_trampoline_cps_call2(return$38, 0, a)
		                         : caml_exact_trampoline_cps_call
		                           (Scheduling[16],
		                            current[1],
		                            function(b){
		                             return caml_exact_trampoline_cps_call(scheduling, b, a);
		                            });
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_exact_trampoline_cps_call$1(equal$105, a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               var
		                Rows =
		                  caml_callback
		                   (bPy,
		                    [[0,
		                      include$51[4],
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      include$51[24],
		                      include$51[1]],
		                     [0,
		                      equal$203,
		                      ,
		                      state_schema_versioned$70,
		                      ,
		                      delta_schema_versioned$92,
		                      ,
		                      [0, schema_versioned$307],
		                      include$0,
		                      apply$115,
		                      apply_delta$111,
		                      make$127,
		                      view$65,
		                      diff$12]]),
		                letrec_function_context$775 = [];
		               function schema_versioned$493(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$775[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aVY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$775[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$775[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$775[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$306,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$371,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(a){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_set,
		                       cst_Set,
		                       [0, a[1], aVZ, a[3], a[4]],
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aV1,
		                           aV0,
		                           1,
		                           0,
		                           4,
		                           function(c){
		                            var a = [0, [0, c, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (Rows[5],
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aV2,
		   cst_rows,
		   cst_Rows,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_rows, 0, 2, [0, d], 0, 0], 0]],
		    0],
		   a],
		  b];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aV4,
		       aV3,
		       1,
		       0,
		       4,
		       function(b){
		        var a = [0, [0, b, V$4]];
		        return caml_trampoline_cps_call2
		                (Config[4],
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        aV5,
		                        cst_config,
		                        "Config",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var delta = param[1];
		                           return cont(delta);
		                          },
		                          function(delta, cont){return cont([0, delta, 0]);},
		                          [0, [0, 0, 0, 0, 0, cst_config, 0, 2, [0, b], 0, 0], 0]],
		                         0],
		                        a],
		                       c],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$775[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$775[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$730 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$775, [0, schematic_cache$730]);
		               caml_callback
		                (schema_versioned$493,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$265 = Monadic$0(),
		                v$45 = include$265[1],
		                const$20 = include$265[2],
		                Apply$42 = include$265[14],
		                letrec_function_context$776 = [];
		               function state_schema_versioned$71(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$776[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aV6, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$776[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$776[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$776[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Rows[3],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_rows, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Config[2],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var rows = param[2][1], config = param[1];
		             return cont([0, config, rows]);
		            },
		            function(param, cont){
		             var rows = param[2], config = param[1];
		             return cont([0, config, [0, rows, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_config, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$776[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$776[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$731 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$776, [0, schematic_cache$731]);
		               var
		                state_schema$25 =
		                  caml_callback
		                   (state_schema_versioned$71,
		                    [function(param, cont){return cont(0);}]);
		               function make$128(param, cont){
		                var rows = param[2], config = param[1];
		                return caml_exact_trampoline_cps_call
		                        (Rows[11],
		                         rows,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (Config[10], config, function(b){return cont([0, b, a]);});
		                         });
		               }
		               function view$66(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (Config[11],
		                         state[1],
		                         function(config){
		                          return caml_exact_trampoline_cps_call
		                                  (Rows[12],
		                                   state[2],
		                                   function(rows){return cont([0, config, rows]);});
		                         });
		               }
		               function apply$116(replica, state, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [4];
		                return cont
		                        (function(param, cont){
		                          if(0 === param[0]){
		                           var op = param[1];
		                           return caml_trampoline_cps_call4
		                                   (Config[8],
		                                    replica,
		                                    state[1],
		                                    op,
		                                    function(match){
		                                     var config = match[3], delta = match[2], res = match[1];
		                                     return caml_trampoline_cps_call3
		     (a,
		      delta,
		      function(delta, cont){return cont([0, delta]);},
		      function(delta){
		       return cont([0, res, delta, [0, config, state[2]]]);
		      });
		                                    });
		                          }
		                          var op$0 = param[1];
		                          return caml_trampoline_cps_call4
		                                  (Rows[9],
		                                   replica,
		                                   state[2],
		                                   op$0,
		                                   function(match){
		                                    var rows = match[3], delta = match[2], res = match[1];
		                                    return caml_trampoline_cps_call3
		    (a,
		     delta,
		     function(delta, cont){return cont([1, delta]);},
		     function(delta){
		      return cont([0, res, delta, [0, state[1], rows]]);
		     });
		                                   });
		                         });
		               }
		               function apply_delta$112(replica, state, param, cont){
		                switch(param[0]){
		                  case 0:
		                   var delta = param[1], a = state[2];
		                   return caml_trampoline_cps_call4
		                           (Config[9],
		                            replica,
		                            state[1],
		                            delta,
		                            function(b){return cont([0, b, a]);});
		                  case 1:
		                   var delta$0 = param[1];
		                   return caml_trampoline_cps_call4
		                           (Rows[10],
		                            replica,
		                            state[2],
		                            delta$0,
		                            function(a){return cont([0, state[1], a]);});
		                  default:
		                   var lww = param[1], b = state[2];
		                   return caml_trampoline_cps_call4
		                           (Config[9],
		                            replica,
		                            state[1],
		                            [0, lww, 0],
		                            function(a){return cont([0, a, b]);});
		                }
		               }
		               var
		                include$266 =
		                  caml_callback
		                   (Apply$42,
		                    [[0, [0, schema_versioned$493], apply_delta$112, apply$116]]),
		                delta_schema_versioned$93 = include$266[1],
		                delta_schema$26 = include$266[2],
		                apply_delta$113 = include$266[3],
		                apply$117 = include$266[4],
		                letrec_function_context$777 = [];
		               function schema_versioned$494(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$777[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aV7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$777[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$777[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$777[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (include$139[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    aV8,
		    cst_enabled,
		    cst_Enabled,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var delta = param[1];
		       return cont(delta);
		      },
		      function(delta, cont){return cont([0, delta, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_enabled, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$777[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$777[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$732 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$777, [0, schematic_cache$732]);
		               caml_callback
		                (schema_versioned$494,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$267 = Monadic$0(),
		                v$46 = include$267[1],
		                const$21 = include$267[2],
		                Apply$43 = include$267[14],
		                letrec_function_context$778 = [];
		               function state_schema_versioned$72(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$778[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aV9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$778[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$778[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$778[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$139[2],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var enabled = param[1];
		   return cont([0, enabled]);
		  },
		  function(param, cont){
		   var enabled = param[1];
		   return cont([0, enabled, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_enabled, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$778[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$778[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$733 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$778, [0, schematic_cache$733]);
		               var
		                state_schema$26 =
		                  caml_callback
		                   (state_schema_versioned$72,
		                    [function(param, cont){return cont(0);}]);
		               function make$129(init, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[10],
		                         init[1],
		                         function(a){return cont([0, a]);});
		               }
		               function view$67(t, cont){
		                return caml_exact_trampoline_cps_call
		                        (include$139[11], t[1], function(a){return cont([0, a]);});
		               }
		               function apply$118(replica, state, op, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4],
		                 op$0 = op[1];
		                return caml_trampoline_cps_call4
		                        (include$139[8],
		                         replica,
		                         state[1],
		                         op$0,
		                         function(match){
		                          var
		                           new_substate = match[3],
		                           delta = match[2],
		                           res = match[1];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   delta,
		                                   function(delta, cont){return cont([0, delta]);},
		                                   function(delta){
		                                    return cont([0, res, delta, [0, new_substate]]);
		                                   });
		                         });
		               }
		               function apply_delta$114(replica, state, delta, cont){
		                var delta$0 = delta[1];
		                return caml_trampoline_cps_call4
		                        (include$139[9],
		                         replica,
		                         state[1],
		                         delta$0,
		                         function(new_substate){return cont([0, new_substate]);});
		               }
		               var
		                include$268 =
		                  caml_callback
		                   (Apply$43,
		                    [[0, [0, schema_versioned$494], apply_delta$114, apply$118]]),
		                delta_schema_versioned$94 = include$268[1],
		                delta_schema$27 = include$268[2],
		                apply_delta$115 = include$268[3],
		                apply$119 = include$268[4];
		               function Make$52(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$21],
		                      state_schema_versioned$72,
		                      state_schema$26,
		                      delta_schema_versioned$94,
		                      delta_schema$27,
		                      [0, schema_versioned$304, schema$125],
		                      include$0,
		                      apply$119,
		                      apply_delta$115,
		                      make$129,
		                      view$67,
		                      equal$200]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$200,
		                    [0, const$21],
		                    state_schema_versioned$72,
		                    state_schema$26,
		                    delta_schema_versioned$94,
		                    delta_schema$27,
		                    [0, schema_versioned$304, schema$125],
		                    include$0,
		                    apply$119,
		                    apply_delta$115,
		                    make$129,
		                    view$67];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$303,
		                          schema$124,
		                          symbol$193,
		                          symbol$194,
		                          symbol$195,
		                          symbol$196,
		                          symbol$197,
		                          symbol$198,
		                          equal$199,
		                          compare$121,
		                          min$28,
		                          max$30,
		                          ascending$19,
		                          descending$19,
		                          between$20,
		                          clamp_exn$19,
		                          clamp$19,
		                          comparator$40,
		                          pp$94],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$269 = caml_callback(Make$52, [Ident]),
		                Operation$19 = include$269[2],
		                delta_schema_versioned$95 = include$269[5],
		                add$29 = include$269[14],
		                element$20 = include$269[16],
		                has$4 = include$269[17];
		               function set$23(id, enabled, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      Operation$19[4],
		                      Operation$19[5],
		                      ,
		                      Operation$19[7],
		                      Operation$19[8],
		                      Operation$19[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$19[12]]),
		                 let$ = open[3];
		                function a(exists, cont){
		                 return exists
		                         ? caml_exact_trampoline_cps_call
		                           (include$139[12],
		                            enabled,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (v$46,
		                                      [0, a],
		                                      function(a){
		                                       return caml_trampoline_cps_call3(element$20, id, a, cont);
		                                      });
		                            })
		                         : caml_trampoline_cps_call3(add$29, id, [0, enabled], cont);
		                }
		                return caml_trampoline_cps_call2
		                        (has$4,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function Make$53(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$20],
		                      state_schema_versioned$71,
		                      state_schema$25,
		                      delta_schema_versioned$93,
		                      delta_schema$26,
		                      [0, schema_versioned$308, schema$127],
		                      include$0,
		                      apply$117,
		                      apply_delta$113,
		                      make$128,
		                      view$66,
		                      equal$204]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$204,
		                    [0, const$20],
		                    state_schema_versioned$71,
		                    state_schema$25,
		                    delta_schema_versioned$93,
		                    delta_schema$26,
		                    [0, schema_versioned$308, schema$127],
		                    include$0,
		                    apply$117,
		                    apply_delta$113,
		                    make$128,
		                    view$66];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$303,
		                          schema$124,
		                          symbol$193,
		                          symbol$194,
		                          symbol$195,
		                          symbol$196,
		                          symbol$197,
		                          symbol$198,
		                          equal$199,
		                          compare$121,
		                          min$28,
		                          max$30,
		                          ascending$19,
		                          descending$19,
		                          between$20,
		                          clamp_exn$19,
		                          clamp$19,
		                          comparator$40,
		                          pp$94],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$270 = caml_callback(Make$53, [Ident]),
		                Operation$20 = include$270[2],
		                delta_schema_versioned$96 = include$270[5],
		                add$30 = include$270[14],
		                element$21 = include$270[16],
		                has$5 = include$270[17],
		                remove$18 = include$270[18];
		               function upsert(id, config, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      Operation$20[4],
		                      Operation$20[5],
		                      ,
		                      Operation$20[7],
		                      Operation$20[8],
		                      Operation$20[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$20[12]]),
		                 let$ = open[3];
		                function a(exists, cont){
		                 return exists
		                         ? caml_exact_trampoline_cps_call
		                           (Config[12],
		                            config,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (v$45,
		                                      [0, a],
		                                      function(a){
		                                       return caml_trampoline_cps_call3(element$21, id, a, cont);
		                                      });
		                            })
		                         : caml_trampoline_cps_call3
		                           (add$30, id, [0, config, include$51[27][104]], cont);
		                }
		                return caml_trampoline_cps_call2
		                        (has$5,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function set_row
		               (id,
		                row_id,
		                scheduling$0,
		                status_changed_at$0,
		                discarded$0,
		                starred$0,
		                a,
		                cont){
		                a = Rows[2];
		                var
		                 open = g([0, a[4], a[5], , a[7], a[8], a[9], , , , , a[12]]),
		                 let$ = open[3];
		                function b(exists, cont){
		                 if(! exists){
		                  var b = value$4(starred$0, 0), c = value$4(discarded$0, 0);
		                  return caml_exact_trampoline_cps_call
		                          (join$2,
		                           status_changed_at$0,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (join$2,
		                                     scheduling$0,
		                                     function(d){
		                                      return caml_exact_trampoline_cps_call$1
		      (Rows[14],
		       row_id,
		       [0, d, a, c, b],
		       function(a){
		        return caml_trampoline_cps_call2(Rows[2][11], a, cont);
		       });
		                                     });
		                           });
		                 }
		                 function a(scheduling_op){
		                  function a(status_changed_at_op){
		                   function a(discarded_op){
		                    function a(starred_op){
		                     return caml_exact_trampoline_cps_call
		                             (all_unit$26,
		                              [0,
		                               scheduling_op,
		                               [0,
		                                status_changed_at_op,
		                                [0, discarded_op, [0, starred_op, 0]]]],
		                              function(row_op){
		                               return caml_exact_trampoline_cps_call$1
		                                       (Rows[16], row_id, row_op, cont);
		                              });
		                    }
		                    if(! starred$0)
		                     return caml_trampoline_cps_call2(return$38, 0, a);
		                    var v = starred$0[1];
		                    return caml_exact_trampoline_cps_call
		                            (include$139[12],
		                             v,
		                             function(b){
		                              return caml_exact_trampoline_cps_call(starred, b, a);
		                             });
		                   }
		                   if(! discarded$0)
		                    return caml_trampoline_cps_call2(return$38, 0, a);
		                   var v = discarded$0[1];
		                   return caml_exact_trampoline_cps_call
		                           (include$139[12],
		                            v,
		                            function(b){
		                             return caml_exact_trampoline_cps_call(discarded, b, a);
		                            });
		                  }
		                  if(! status_changed_at$0)
		                   return caml_trampoline_cps_call2(return$38, 0, a);
		                  var v = status_changed_at$0[1];
		                  return caml_exact_trampoline_cps_call
		                          (Status_changed_at[16],
		                           v,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (status_changed_at, b, a);
		                           });
		                 }
		                 if(! scheduling$0)
		                  return caml_trampoline_cps_call2(return$38, 0, a);
		                 var v = scheduling$0[1];
		                 return caml_exact_trampoline_cps_call
		                         (Scheduling[16],
		                          v,
		                          function(b){
		                           return caml_exact_trampoline_cps_call(scheduling, b, a);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (Rows[17],
		                         row_id,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   a,
		                                   b,
		                                   function(op){
		                                    return caml_exact_trampoline_cps_call
		    (v$45,
		     [1, op],
		     function(a){
		      return caml_trampoline_cps_call3(element$21, id, a, cont);
		     });
		                                   });
		                         });
		               }
		               var bR8 = [0, schema_versioned$186, schema$68];
		               function Make$54(b, cont){
		                var
		                 a =
		                   b[3].call
		                    (null,
		                     [0,
		                      [0, , , , , , , , , , , , const$16],
		                      state_schema_versioned$56,
		                      state_schema$21,
		                      delta_schema_versioned$76,
		                      delta_schema$21,
		                      [0, schema_versioned$186, schema$68],
		                      include$0,
		                      apply$90,
		                      apply_delta$86,
		                      make$115,
		                      view$53,
		                      equal$246]),
		                 d =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]],
		                 c =
		                   [0,
		                    equal$246,
		                    [0, const$16],
		                    state_schema_versioned$56,
		                    state_schema$21,
		                    delta_schema_versioned$76,
		                    delta_schema$21,
		                    bR8,
		                    include$0,
		                    apply$90,
		                    apply_delta$86,
		                    make$115,
		                    view$53];
		                return caml_trampoline_cps_call2
		                        (b[5],
		                         [0,
		                          schema_versioned$109,
		                          schema$27,
		                          symbol$119,
		                          symbol$120,
		                          symbol$121,
		                          symbol$122,
		                          symbol$123,
		                          symbol$124,
		                          equal$55,
		                          compare$68,
		                          min$16,
		                          max$18,
		                          ascending$7,
		                          descending$7,
		                          between$8,
		                          clamp_exn$7,
		                          clamp$7,
		                          comparator$19,
		                          _16$0],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){return caml_trampoline_cps_call2(a, c, cont);});
		                         });
		               }
		               var
		                include$271 = caml_callback(Make$54, [Ident]),
		                Operation$21 = include$271[2],
		                delta_schema_versioned$97 = include$271[5],
		                add$31 = include$271[14],
		                element$22 = include$271[15],
		                element$23 = include$271[16],
		                has$6 = include$271[17],
		                remove$19 = include$271[18];
		               function update$7
		               (extension_row,
		                occurrence,
		                parent,
		                scheduled,
		                starred,
		                status,
		                title,
		                url$0,
		                task_id,
		                cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                return caml_trampoline_cps_call3
		                        (let$,
		                         status,
		                         function(status, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (set_status$0, status, cont);
		                         },
		                         function(set_status_op){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   extension_row,
		                                   function(extension_row, cont){
		                                    return caml_exact_trampoline_cps_call
		    (set$12,
		     extension_row,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (v$33,
		               [0, a],
		               function(a){
		                return caml_exact_trampoline_cps_call(v$34, [2, a], cont);
		               });
		     });
		                                   },
		                                   function(extension_row_op){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     parent,
		     function(parent, cont){
		      return caml_exact_trampoline_cps_call
		              (set_parent$0, parent, cont);
		     },
		     function(parent_op){
		      return caml_trampoline_cps_call3
		              (let$,
		               scheduled,
		               function(scheduled, cont){
		                return caml_exact_trampoline_cps_call
		                        (set_scheduled, scheduled, cont);
		               },
		               function(scheduled_op){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         starred,
		                         function(is_starred, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Starred[13],
		                                   is_starred,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (v$33,
		     [3, a],
		     function(a){
		      return caml_exact_trampoline_cps_call(v$34, [2, a], cont);
		     });
		                                   });
		                         },
		                         function(starred_op){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   occurrence,
		                                   function(occurrence, cont){
		                                    return caml_exact_trampoline_cps_call
		    (set_occurrence, occurrence, cont);
		                                   },
		                                   function(occurrence_op){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     title,
		     function(title, cont){
		      return caml_exact_trampoline_cps_call
		              (title$0,
		               title,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (v$33,
		                         [6, a],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$34,
		                                   [2, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$9, a, cont);
		                                   });
		                         });
		               });
		     },
		     function(title_op){
		      return caml_trampoline_cps_call3
		              (let$,
		               url$0,
		               function(url$0, cont){
		                return caml_exact_trampoline_cps_call
		                        (url,
		                         url$0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (v$33,
		                                   [6, a],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (v$34,
		     [2, a],
		     function(a){
		      return caml_exact_trampoline_cps_call(ignore_m$9, a, cont);
		     });
		                                   });
		                         });
		               },
		               function(url_op){
		                return caml_exact_trampoline_cps_call
		                        (filter_opt,
		                         [0,
		                          set_status_op,
		                          [0,
		                           extension_row_op,
		                           [0,
		                            parent_op,
		                            [0,
		                             scheduled_op,
		                             [0,
		                              starred_op,
		                              [0, occurrence_op, [0, title_op, [0, url_op, 0]]]]]]]],
		                         function(ops){
		                          function a(a){
		                           return caml_trampoline_cps_call3
		                                   (map$17,
		                                    a,
		                                    function(op, cont){
		                                     return caml_trampoline_cps_call3
		     (element$22,
		      task_id,
		      op,
		      function(a){
		       return caml_trampoline_cps_call2(Operation$21[11], a, cont);
		      });
		                                    },
		                                    cont);
		                          }
		                          return ops
		                                  ? caml_exact_trampoline_cps_call
		                                    (all_unit$18,
		                                     ops,
		                                     function(b){
		                                      return caml_trampoline_cps_call2(return$9, b, a);
		                                     })
		                                  : a(0);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function add_task
		               (b,
		                client_id,
		                extension_row,
		                occurrence,
		                parent,
		                scheduled,
		                starred,
		                a,
		                url,
		                title,
		                created,
		                cont){
		                var
		                 id = b ? b[1] : make$31(),
		                 status = a ? a[1] : 0,
		                 open =
		                   g
		                    ([0,
		                      Operation$21[4],
		                      Operation$21[5],
		                      ,
		                      Operation$21[7],
		                      Operation$21[8],
		                      Operation$21[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$21[12]]),
		                 let$ = open[3],
		                 a = to_archived_completed(status),
		                 completed = a[2],
		                 archived = a[1],
		                 etag = make$34(0, created),
		                 d = Read$0[1][3].call(null, 0, [0, url], title);
		                function c(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (debug$3,
		                          function(m, cont){
		                           return caml_trampoline_cps_call6
		                                   (m, 0, 0, aV_, _16$0, id, cont);
		                          },
		                          function(match){
		                           return caml_trampoline_cps_call2(Operation$21[8], id, cont);
		                          });
		                }
		                return caml_trampoline_cps_call9
		                        (Read$0[8],
		                         archived,
		                         completed,
		                         extension_row,
		                         0,
		                         occurrence,
		                         parent,
		                         scheduled,
		                         starred,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   d,
		                                   function(a){
		                                    return caml_trampoline_cps_call4
		    (make$41,
		     0,
		     [0, client_id],
		     created,
		     function(b){
		      return caml_trampoline_cps_call4
		              (b,
		               0,
		               etag,
		               id,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (add$31,
		                                   id,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_trampoline_cps_call3(let$, a, c, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                include$272 =
		                  caml_callback(A, [[0, schema_versioned$124, schema$42]]),
		                Operation$22 = include$272[1],
		                state_schema_versioned$73 = include$272[2],
		                state_schema$27 = include$272[3],
		                delta_schema_versioned$98 = include$272[4],
		                delta_schema$28 = include$272[5],
		                Init$15 = include$272[6],
		                Monad$18 = include$272[7],
		                apply$120 = include$272[8],
		                apply_delta$116 = include$272[9],
		                make$130 = include$272[10],
		                view$68 = include$272[11],
		                set$24 = include$272[12];
		               function Make$55(Context){
		                var
		                 include =
		                   Context[3].call
		                    (null,
		                     [0,
		                      Operation$22,
		                      state_schema_versioned$73,
		                      state_schema$27,
		                      delta_schema_versioned$98,
		                      delta_schema$28,
		                      Init$15,
		                      Monad$18,
		                      apply$120,
		                      apply_delta$116,
		                      make$130,
		                      view$68,
		                      equal$64]),
		                 Operation = include[1],
		                 state_schema_versioned = include[2],
		                 state_schema = include[3],
		                 delta_schema_versioned = include[4],
		                 delta_schema = include[5],
		                 Init = include[6],
		                 Monad = include[7],
		                 apply = include[8],
		                 apply_delta = include[9],
		                 make = include[10],
		                 view = include[11],
		                 equal = include[12];
		                return [0,
		                        Operation,
		                        state_schema_versioned,
		                        state_schema,
		                        delta_schema_versioned,
		                        delta_schema,
		                        Init,
		                        Monad,
		                        apply,
		                        apply_delta,
		                        make,
		                        view,
		                        equal,
		                        set$24];
		               }
		               var
		                include$273 = Make$55(Ident),
		                Operation$23 = include$273[1],
		                state_schema_versioned$74 = include$273[2],
		                state_schema$28 = include$273[3],
		                delta_schema_versioned$99 = include$273[4],
		                delta_schema$29 = include$273[5],
		                Init$16 = include$273[6],
		                Monad$19 = include$273[7],
		                apply$121 = include$273[8],
		                apply_delta$117 = include$273[9],
		                make$131 = include$273[10],
		                view$69 = include$273[11],
		                equal$251 = include$273[12],
		                set$25 = include$273[13];
		               function Make$56(Context, cont){
		                var
		                 b =
		                   [0,
		                    equal$251,
		                    [0, Operation$23[12]],
		                    state_schema_versioned$74,
		                    state_schema$28,
		                    delta_schema_versioned$99,
		                    delta_schema$29,
		                    Init$16,
		                    Monad$19,
		                    apply$121,
		                    apply_delta$117,
		                    make$131,
		                    view$69],
		                 a = Make$55(Context),
		                 c =
		                   [0,
		                    a[12],
		                    [0, a[1][12]],
		                    a[2],
		                    a[3],
		                    a[4],
		                    a[5],
		                    a[6],
		                    a[7],
		                    a[8],
		                    a[9],
		                    a[10],
		                    a[11]];
		                return caml_trampoline_cps_call2
		                        (Context[5],
		                         [0,
		                          schema_versioned$117,
		                          schema$38,
		                          symbol$131,
		                          symbol$132,
		                          symbol$133,
		                          symbol$134,
		                          symbol$135,
		                          symbol$136,
		                          equal$59,
		                          compare$79,
		                          min$18,
		                          max$20,
		                          ascending$9,
		                          descending$9,
		                          between$10,
		                          clamp_exn$9,
		                          clamp$9,
		                          comparator$22,
		                          pp$44],
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   c,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     b,
		     function(include){
		      var
		       state_schema_versioned = include[3],
		       apply = include[9],
		       apply_delta = include[10],
		       make = include[11],
		       view = include[12],
		       init = include[13],
		       add = include[14],
		       element = include[16],
		       remove = include[18];
		      return caml_exact_trampoline_cps_call
		              (bOD,
		               [0,
		                schema_versioned$117,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                ,
		                comparator$22,
		                pp$44],
		               function(Set){
		                function delta_schema_versioned(schematic_version, cont){
		                 return caml_trampoline_cps_call2
		                         (schematic_version,
		                          V$4,
		                          function(schematic_schema_version){
		                           return caml_trampoline_cps_call2
		                                   (delta_schema_versioned$99,
		                                    schematic_version,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (Init$16[1],
		      schematic_version,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$117,
		                schematic_version,
		                function(c){
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$367,
		                          schematic_version,
		                          function(d){
		                           return caml_exact_trampoline_cps_call$0
		                                   (d,
		                                    c,
		                                    b,
		                                    a,
		                                    function(a){return cont([0, aV$, 0, a[3], a[4]]);});
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (delta_schema_versioned,
		                         function(param, cont){return cont(0);},
		                         function(delta_schema){
		                          var letrec_function_context = [];
		                          function delta_compat_schema_versioned
		                          (schematic_version, cont){
		                           return caml_trampoline_cps_call2
		                                   (schematic_version,
		                                    V$4,
		                                    function(schematic_schema_version){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       function a(descriptor){
		        return cont([0, aWa, 0, descriptor]);
		       }
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return caml_exact_trampoline_cps_call
		       (delta_schema_versioned$2,
		        schematic_version,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (Init$0[1],
		                  schematic_version,
		                  function(b){
		                   return caml_exact_trampoline_cps_call
		                           (schema_versioned$117,
		                            schematic_version,
		                            function(c){
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$367,
		                                      schematic_version,
		                                      function(d){
		                                       return caml_exact_trampoline_cps_call$0
		       (d,
		        c,
		        b,
		        a,
		        function(b){
		         var
		          a =
		            [0,
		             [0,
		              function(f0, cont){return cont([1, f0]);},
		              function(param, cont){
		               if(0 === param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_set,
		              cst_Set,
		              b,
		              0],
		             0];
		         return caml_exact_trampoline_cps_call$3
		                 (make$4,
		                  aWc,
		                  aWb,
		                  0,
		                  25,
		                  9,
		                  function(c){
		                   var b = [0, [0, c, V$4]];
		                   return caml_exact_trampoline_cps_call
		                           (delta_schema_versioned,
		                            schematic_version,
		                            function(c){
		                             var
		                              res =
		                                [11,
		                                 0,
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(0 !== param[0]) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   0,
		                                   0,
		                                   cst_map,
		                                   cst_Map,
		                                   c,
		                                   b],
		                                  a],
		                                 0];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      res,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return cont(res);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 a);
		       var schema = match[1];
		       return a(schema);
		      });
		                                    });
		                          }
		                          var schematic_cache = [0, empty$11([0, comparator$9])];
		                          caml_update_dummy
		                           (letrec_function_context, [0, schematic_cache]);
		                          return caml_exact_trampoline_cps_call
		                                  (delta_compat_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(delta_compat_schema){
		                                    function delta_schema_versioned(v, cont){
		                                     function decode(a, cont){
		                                      if(0 === a[0]){var delta = a[1]; return cont([0, delta]);}
		                                      a = a[1];
		                                      if(2 === a[0]){
		                                       var id$0 = a[2], key$0 = a[1];
		                                       return cont([0, [2, key$0, id$0]]);
		                                      }
		                                      var id = a[2], key = a[1];
		                                      return cont([0, [0, key, id, [0, 1, key]]]);
		                                     }
		                                     function encode(add, cont){
		                                      switch(add[0]){
		case 0:
		 var id = add[2], key = add[1];
		 return add[3][1]
		         ? cont([1, [0, key, id, 0]])
		         : cont([0, add]);
		case 1:
		 return cont([0, add]);
		default: return cont([1, add]);
		                                      }
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (delta_compat_schema_versioned,
		      v,
		      function(a){return cont(map$14(decode, encode, a));});
		                                    }
		                                    function delta_schema_versioned$0(v, cont){
		                                     return caml_exact_trampoline_cps_call
		     (delta_schema_versioned,
		      v,
		      function(a){return cont(list_schema(a));});
		                                    }
		                                    return cont
		    ([0,
		      ,
		      ,
		      state_schema_versioned,
		      ,
		      ,
		      ,
		      ,
		      apply,
		      apply_delta,
		      make,
		      view,
		      init,
		      add,
		      ,
		      element,
		      ,
		      remove,
		      ,
		      ,
		      ,
		      ,
		      delta_schema_versioned$0]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                include$274 = caml_callback(Make$56, [Ident]),
		                add$32 = include$274[13],
		                element$24 = include$274[15],
		                remove$20 = include$274[17],
		                delta_schema_versioned$100 = include$274[22],
		                Email$0 =
		                  caml_callback
		                   (Mru,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$4,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$2,
		                      ,
		                      string_schema_versioned]]),
		                Destination =
		                  caml_callback
		                   (Mru,
		                    [[0,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      compare$85,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      ,
		                      comparator$24,
		                      ,
		                      schema_versioned$131]]);
		               caml_callback(M$3, [[0, comparator$14, schema_versioned$102]]);
		               var
		                cst_events_recurrent = "events_recurrent",
		                cst_notices_personal_archived$0 = "notices_personal_archived",
		                cst_notices_personal_viewed$0 = "notices_personal_viewed",
		                cst_task_binding_settings$0 = "task_binding_settings",
		                cst_task_bindings$0 = "task_bindings",
		                bOG = [];
		               function routine_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOG[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){return cont([0, , , descriptor, 0]);}
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOG[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOG[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOG[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$171,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, aWd, 0, 0, 0, cst_database, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$186,
		       schematic_version,
		       function(b){
		        return caml_trampoline_cps_call3
		                (By$5[102],
		                 schematic_version,
		                 b,
		                 function(c){
		                  var
		                   b = [0, [0, aWe, 0, 0, 0, cst_tasks, 0, 2, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$304,
		                           schematic_version,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (By$17[102],
		                                     schematic_version,
		                                     a,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   aWf,
		   0,
		   0,
		   0,
		   cst_task_binding_settings$0,
		   0,
		   2,
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$308,
		       schematic_version,
		       function(b){
		        return caml_trampoline_cps_call3
		                (By$17[102],
		                 schematic_version,
		                 b,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0, aWg, 0, 0, 0, cst_task_bindings$0, 0, 2, [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$219,
		                           schematic_version,
		                           function(c){
		                            var
		                             a =
		                               [0, [0, aWh, 0, 0, 0, cst_settings, 0, 2, [0, c], 0, 0], b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$188,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (By$11[102],
		       schematic_version,
		       b,
		       function(c){
		        var
		         b =
		           [0,
		            [0, aWi, 0, 0, 0, cst_recurrences, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$105,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, aWj, 0, 0, 0, cst_home, 0, 3, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$318,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 aWk,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_menu_items,
		                                 0,
		                                 2,
		                                 [0, [0, 0, 0, [3, c], 0]],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$341,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (By$18[102],
		       schematic_version,
		       a,
		       function(c){
		        var
		         a =
		           [0, [0, aWl, 0, 0, 0, cst_people, 0, 2, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$347,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (By$2[102],
		                           schematic_version,
		                           b,
		                           function(c){
		                            var
		                             b = [0, [0, aWm, 0, 0, 0, cst_pages, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$199,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (By$3[102],
		       schematic_version,
		       a,
		       function(c){
		        var
		         a =
		           [0,
		            [0, aWn, 0, 0, 0, cst_organizations, 0, 2, [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (By$19[102],
		                           schematic_version,
		                           b,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 aWo,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_notices_personal_viewed$0,
		                                 0,
		                                 2,
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$4,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (By$19[102],
		       schematic_version,
		       a,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             aWp,
		             0,
		             0,
		             0,
		             cst_notices_personal_archived$0,
		             0,
		             2,
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$346,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (By$19[102],
		                           schematic_version,
		                           b,
		                           function(b){
		                            return caml_trampoline_cps_call3
		                                    (By$7[102],
		                                     schematic_version,
		                                     b,
		                                     function(c){
		                                      var
		                                       b =
		 [0, [0, aWq, 0, 0, 0, cst_notices, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (mrus_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, aWr, 0, 0, 0, cst_mrus, 0, 2, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$124,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (By$7[102],
		                           schematic_version,
		                           b,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, aWs, 0, 0, 0, cst_members, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$174,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$315,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (c,
		                 a,
		                 function(a){
		                  return caml_trampoline_cps_call3
		                          (By$10[102],
		                           schematic_version,
		                           a,
		                           function(c){
		                            var
		                             a =
		                               [0,
		                                [0, aWt, 0, 0, 0, cst_integrations, 0, 2, [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$247,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0, aWu, 0, 0, 0, cst_integration_app, 0, 2, [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$360,
		       schematic_version,
		       function(a){
		        return caml_trampoline_cps_call3
		                (By$2[102],
		                 schematic_version,
		                 a,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, "hierarchy_lookup", 0, 2, [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$239,
		                           schematic_version,
		                           function(b){
		                            return caml_trampoline_cps_call3
		                                    (By$12[102],
		                                     schematic_version,
		                                     b,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0, aWv, 0, 0, 0, cst_events_recurrent, 0, 2, [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$230,
		       schematic_version,
		       function(a){
		        return caml_trampoline_cps_call3
		                (By$1[102],
		                 schematic_version,
		                 a,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, aWw, 0, 0, 0, cst_events, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (view_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, aWx, 0, 0, 0, cst_client_data, 0, 2, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$288,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (bRj,
		       schematic_version,
		       a,
		       function(c){
		        var
		         a =
		           [0,
		            [0, aWy, 0, 0, 0, cst_connections, 0, 2, [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$206,
		                 schematic_version,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (By_id$0[109],
		                           schematic_version,
		                           b,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, aWz, 0, 0, 0, cst_calendars, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$283,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    j = i[2],
		    k = j[2],
		    l = k[2],
		    m = l[2],
		    n = m[2],
		    o = n[2],
		    p = o[2],
		    q = p[2],
		    r = q[2],
		    s = r[2],
		    t = s[2],
		    u = t[2],
		    v = u[2],
		    w = v[2],
		    database = w[2][1],
		    tasks = w[1],
		    task_binding_settings = v[1],
		    task_bindings = u[1],
		    settings = t[1],
		    recurrences = s[1],
		    home = r[1],
		    menu_items = q[1],
		    people = p[1],
		    pages = o[1],
		    organizations = n[1],
		    notices_personal_viewed = m[1],
		    notices_personal_archived = l[1],
		    notices = k[1],
		    mrus = j[1],
		    members = i[1],
		    integrations = h[1],
		    integration_app = g[1],
		    hierarchy_lookup = f[1],
		    events_recurrent = e[1],
		    events = d[1],
		    client_data = c[1],
		    connections = b[1],
		    calendars = a[1],
		    ai = param[1];
		   return cont
		           ([0,
		             ai,
		             calendars,
		             connections,
		             client_data,
		             events,
		             events_recurrent,
		             hierarchy_lookup,
		             integration_app,
		             integrations,
		             members,
		             mrus,
		             notices,
		             notices_personal_archived,
		             notices_personal_viewed,
		             organizations,
		             pages,
		             people,
		             menu_items,
		             home,
		             recurrences,
		             settings,
		             task_bindings,
		             task_binding_settings,
		             tasks,
		             database]);
		  },
		  function(param, cont){
		   var
		    database = param[25],
		    tasks = param[24],
		    task_binding_settings = param[23],
		    task_bindings = param[22],
		    settings = param[21],
		    recurrences = param[20],
		    home = param[19],
		    menu_items = param[18],
		    people = param[17],
		    pages = param[16],
		    organizations = param[15],
		    notices_personal_viewed = param[14],
		    notices_personal_archived = param[13],
		    notices = param[12],
		    mrus = param[11],
		    members = param[10],
		    integrations = param[9],
		    integration_app = param[8],
		    hierarchy_lookup = param[7],
		    events_recurrent = param[6],
		    events = param[5],
		    client_data = param[4],
		    connections = param[3],
		    calendars = param[2],
		    ai = param[1];
		   return cont
		           ([0,
		             ai,
		             [0,
		              calendars,
		              [0,
		               connections,
		               [0,
		                client_data,
		                [0,
		                 events,
		                 [0,
		                  events_recurrent,
		                  [0,
		                   hierarchy_lookup,
		                   [0,
		                    integration_app,
		                    [0,
		                     integrations,
		                     [0,
		                      members,
		                      [0,
		                       mrus,
		                       [0,
		                        notices,
		                        [0,
		                         notices_personal_archived,
		                         [0,
		                          notices_personal_viewed,
		                          [0,
		                           organizations,
		                           [0,
		                            pages,
		                            [0,
		                             people,
		                             [0,
		                              menu_items,
		                              [0,
		                               home,
		                               [0,
		                                recurrences,
		                                [0,
		                                 settings,
		                                 [0,
		                                  task_bindings,
		                                  [0, task_binding_settings, [0, tasks, [0, database, 0]]]]]]]]]]]]]]]]]]]]]]]]]);
		  },
		  [0, [0, aWA, 0, 0, 0, cst_ai, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOG[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOG[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$779 = [];
		               function mrus_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$779[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aWB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$779[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$779[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$779[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Email$0[19],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_emails, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Destination[19],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var emails = param[2][1], destinations = param[1];
		             return cont([0, destinations, emails]);
		            },
		            function(param, cont){
		             var emails = param[2], destinations = param[1];
		             return cont([0, destinations, [0, emails, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, "destinations", 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$779[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$779[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$734 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOG, [0, schematic_cache$734]);
		               var schematic_cache$735 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$779, [0, schematic_cache$735]);
		               caml_callback
		                (routine_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (mrus_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               e =
		                caml_callback
		                 (M$1,
		                  [[0,
		                    string_schema_versioned,
		                    schematic_param_name_schema_ve]]);
		               var
		                include$275 = caml_callback(A, [[0, e[54], e[55]]]),
		                state_schema_versioned$75 = include$275[2],
		                delta_schema_versioned$101 = include$275[4],
		                apply$122 = include$275[8],
		                apply_delta$118 = include$275[9],
		                make$132 = include$275[10],
		                e = caml_callback(M$1, [[0, schema_versioned$105, schema$22]]),
		                include$276 = caml_callback(A, [[0, e[54], e[55]]]),
		                Operation$24 = include$276[1],
		                state_schema_versioned$76 = include$276[2],
		                state_schema$29 = include$276[3],
		                delta_schema_versioned$102 = include$276[4],
		                delta_schema$30 = include$276[5],
		                Init$17 = include$276[6],
		                Monad$20 = include$276[7],
		                apply$123 = include$276[8],
		                apply_delta$119 = include$276[9],
		                make$133 = include$276[10],
		                view$70 = include$276[11],
		                set$26 = include$276[12];
		               function equal$252(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (equal_option, equal$54, a, b, cont);
		               }
		               var
		                cst_object_hierarchy$0 = "object_hierarchy",
		                letrec_function_context$780 = [];
		               function schema_versioned$495(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$780[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aWC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$780[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$780[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$780[1][1] = a;
		                            return caml_exact_trampoline_cps_call$3
		                                    (make$4,
		                                     aWE,
		                                     aWD,
		                                     0,
		                                     21,
		                                     9,
		                                     function(b){
		                                      var a = [0, [0, b, V$4]];
		                                      return caml_exact_trampoline_cps_call
		      (delta_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([25, f0]);},
		             function(param, cont){
		              if(25 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aWF,
		             cst_object_hierarchy$0,
		             "Object_hierarchy",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_object_hierarchy, 0, 2, [0, c], 0, 0],
		                0]],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$3
		                (make$4,
		                 aWH,
		                 aWG,
		                 0,
		                 21,
		                 7,
		                 function(c){
		                  var a = [0, [0, c, V$4]];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$91,
		                           schematic_version,
		                           function(d){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([24, f0]);},
		                                 function(param, cont){
		                                  if(24 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aWI,
		                                 cst_tables,
		                                 "Tables",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_tables, 0, 2, [0, d], 0, 0], 0]],
		                                  0],
		                                 a],
		                                b];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$97,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([23, f0]);},
		   function(param, cont){
		    if(23 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aWJ,
		   cst_tasks,
		   cst_Tasks,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_tasks, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  c];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aWL,
		       aWK,
		       1,
		       1,
		       3,
		       function(c){
		        var b = [0, [0, c, V$4]];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$95,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([22, f0]);},
		                       function(param, cont){
		                        if(22 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aWM,
		                       cst_task_binding_settings$0,
		                       "Task_binding_settings",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_task_binding_settings,
		                           0,
		                           2,
		                           [0, d],
		                           0,
		                           0],
		                          0]],
		                        0],
		                       b],
		                      a];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aWO,
		                           aWN,
		                           1,
		                           0,
		                           4,
		                           function(b){
		                            var a = [0, [0, b, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$96,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([21, f0]);},
		   function(param, cont){
		    if(21 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aWP,
		   cst_task_bindings$0,
		   "Task_bindings",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_task_bindings, 0, 2, [0, d], 0, 0],
		      0]],
		    0],
		   a],
		  c];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aWR,
		       aWQ,
		       0,
		       21,
		       8,
		       function(c){
		        var a = [0, [0, c, V$4]];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$101,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([20, f0]);},
		                       function(param, cont){
		                        if(20 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aWS,
		                       cst_subscription,
		                       cst_Subscription,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_subscription, 0, 2, [0, d], 0, 0],
		                          0]],
		                        0],
		                       a],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$81,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([19, f0]);},
		                                 function(param, cont){
		                                  if(19 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aWT,
		                                 cst_settings,
		                                 cst_Settings,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_settings, 0, 2, [0, b], 0, 0], 0]],
		                                  0],
		                                 0],
		                                c];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$79,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([18, f0]);},
		   function(param, cont){
		    if(18 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aWU,
		   cst_recurrences,
		   "Recurrences",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_recurrences, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aWW,
		       aWV,
		       0,
		       23,
		       1,
		       function(c){
		        var a = [0, [0, c, V$4]];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$56,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([17, f0]);},
		                       function(param, cont){
		                        if(17 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aWX,
		                       cst_menu_items,
		                       "Menu_items",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_menu_items$0, 0, 2, [0, d], 0, 0],
		                          0]],
		                        0],
		                       a],
		                      b];
		                  return caml_trampoline_cps_call2
		                          (delta_schema_versioned$71,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([16, f0]);},
		                                 function(param, cont){
		                                  if(16 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 aWY,
		                                 cst_people,
		                                 cst_People,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var delta = param[1];
		                                    return cont(delta);
		                                   },
		                                   function(delta, cont){return cont([0, delta, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_people, 0, 2, [0, b], 0, 0], 0]],
		                                  0],
		                                 0],
		                                c];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$68,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([15, f0]);},
		   function(param, cont){
		    if(15 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aWZ,
		   cst_pages,
		   "Pages",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_pages, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aW1,
		       aW0,
		       0,
		       22,
		       1,
		       function(c){
		        var a = [0, [0, c, V$4]];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$66,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([14, f0]);},
		                       function(param, cont){
		                        if(14 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aW2,
		                       cst_organizations,
		                       cst_Organizations,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_organizations, 0, 2, [0, d], 0, 0],
		                          0]],
		                        0],
		                       a],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aW4,
		                           aW3,
		                           0,
		                           25,
		                           9,
		                           function(b){
		                            var a = [0, [0, b, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$61,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([13, f0]);},
		   function(param, cont){
		    if(13 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aW5,
		   cst_notices_personal_viewed$0,
		   "Notices_personal_viewed",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_notices_personal_viewed,
		       0,
		       2,
		       [0, d],
		       0,
		       0],
		      0]],
		    0],
		   a],
		  c];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aW7,
		       aW6,
		       0,
		       25,
		       9,
		       function(c){
		        var a = [0, [0, c, V$4]];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$61,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([12, f0]);},
		                       function(param, cont){
		                        if(12 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aW8,
		                       cst_notices_personal_archived$0,
		                       "Notices_personal_archived",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_notices_personal_archived,
		                           0,
		                           2,
		                           [0, d],
		                           0,
		                           0],
		                          0]],
		                        0],
		                       a],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aW_,
		                           aW9,
		                           0,
		                           23,
		                           1,
		                           function(b){
		                            var a = [0, [0, b, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$59,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([11, f0]);},
		   function(param, cont){
		    if(11 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aW$,
		   cst_notices,
		   "Notices",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_notices, 0, 2, [0, d], 0, 0], 0]],
		    0],
		   a],
		  c];
		                                      return caml_exact_trampoline_cps_call$3
		      (make$4,
		       aXb,
		       aXa,
		       0,
		       22,
		       1,
		       function(c){
		        var a = [0, [0, c, V$4]];
		        return caml_exact_trampoline_cps_call
		                (delta_schema_versioned$100,
		                 schematic_version,
		                 function(d){
		                  var
		                   c =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([10, f0]);},
		                       function(param, cont){
		                        if(10 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aXc,
		                       cst_members,
		                       cst_Members,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_members, 0, 2, [0, d], 0, 0], 0]],
		                        0],
		                       a],
		                      b];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aXe,
		                           aXd,
		                           1,
		                           0,
		                           1,
		                           function(b){
		                            var a = [0, [0, b, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$102,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([9, f0]);},
		   function(param, cont){
		    if(9 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aXf,
		   cst_home,
		   cst_Home,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_home, 0, 2, [0, d], 0, 0], 0]],
		    0],
		   a],
		  c];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$1,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([8, f0]);},
		             function(param, cont){
		              if(8 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aXg,
		             cst_hierarchy,
		             "Hierarchy",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_hierarchy, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            b];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$53,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([7, f0]);},
		                       function(param, cont){
		                        if(7 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aXh,
		                       cst_integrations,
		                       cst_Integrations,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0,
		                          [0, 0, 0, 0, 0, cst_integrations, 0, 2, [0, c], 0, 0],
		                          0]],
		                        0],
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aXj,
		                           aXi,
		                           0,
		                           23,
		                           0,
		                           function(c){
		                            var a = [0, [0, c, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$51,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(6 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aXk,
		   cst_integration_app,
		   cst_Integration_app,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_integration_app$0, 0, 2, [0, d], 0, 0],
		      0]],
		    0],
		   a],
		  b];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$43,
		       schematic_version,
		       function(b){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(5 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aXl,
		             cst_events_recurrent,
		             "Events_recurrent",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_events_rec, 0, 2, [0, b], 0, 0], 0]],
		              0],
		             0],
		            c];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$42,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(4 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aXm,
		                       cst_events,
		                       "Events",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_events, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aXo,
		                           aXn,
		                           3,
		                           0,
		                           1,
		                           function(c){
		                            var a = [0, [0, c, V$4]];
		                            return caml_trampoline_cps_call2
		                                    (delta_schema_versioned$27,
		                                     schematic_version,
		                                     function(d){
		                                      var
		                                       c =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   aXp,
		   cst_client_data,
		   "Client_data",
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var delta = param[1];
		      return cont(delta);
		     },
		     function(delta, cont){return cont([0, delta, 0]);},
		     [0,
		      [0, 0, 0, 0, 0, cst_client_data$0, 0, 2, [0, d], 0, 0],
		      0]],
		    0],
		   a],
		  b];
		                                      return caml_trampoline_cps_call2
		      (delta_schema_versioned$30,
		       schematic_version,
		       function(b){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(2 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             aXq,
		             cst_connections,
		             cst_Connections,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var delta = param[1];
		                return cont(delta);
		               },
		               function(delta, cont){return cont([0, delta, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_connections, 0, 2, [0, b], 0, 0], 0]],
		              0],
		             0],
		            c];
		        return caml_trampoline_cps_call2
		                (delta_schema_versioned$25,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       aXr,
		                       cst_calendars,
		                       "Calendars",
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var delta = param[1];
		                          return cont(delta);
		                         },
		                         function(delta, cont){return cont([0, delta, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_calendars, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call$3
		                          (make$4,
		                           aXt,
		                           aXs,
		                           1,
		                           0,
		                           2,
		                           function(c){
		                            var a = [0, [0, c, V$4]];
		                            return caml_exact_trampoline_cps_call
		                                    (delta_schema_versioned$22,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    aXu,
		    cst_ai,
		    "Ai",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var delta = param[1];
		       return cont(delta);
		      },
		      function(delta, cont){return cont([0, delta, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_ai, 0, 2, [0, c], 0, 0], 0]],
		     0],
		    a],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$780[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$780[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$736 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$780, [0, schematic_cache$736]);
		               caml_callback
		                (schema_versioned$495,
		                 [function(param, cont){return cont(0);}]);
		               var
		                include$277 = Monadic$0(),
		                v$47 = include$277[1],
		                symbol_bind$22 = include$277[3],
		                symbol_map$20 = include$277[4],
		                bind$30 = include$277[6],
		                return$39 = include$277[7],
		                map$50 = include$277[8],
		                ignore_m$11 = include$277[10],
		                Let_syntax$14 = include$277[11],
		                all_unit$27 = include$277[12],
		                all$24 = include$277[13],
		                Apply$44 = include$277[14],
		                Init$12 = [0, schema_versioned$484, schema$270],
		                Delta$3 = [0, schema_versioned$495];
		               function Make$57(Context, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make$35,
		                         Context,
		                         function(Calendars){
		                          return caml_exact_trampoline_cps_call
		                                  (Make$37,
		                                   Context,
		                                   function(Connections){
		                                    return caml_exact_trampoline_cps_call
		    (Make$36,
		     Context,
		     function(Client_data){
		      return caml_exact_trampoline_cps_call
		              (Make$38,
		               Context,
		               function(Events){
		                return caml_exact_trampoline_cps_call
		                        (Make$39,
		                         Context,
		                         function(a){
		                          var
		                           Events_recurrent =
		                             [0, , , a[3], , , , , , a[9], a[10], a[11], a[12], a[13]],
		                           include =
		                             Context[2].call
		                              (null,
		                               [0,
		                                ,
		                                bRH,
		                                bRG,
		                                delta_schema_versioned$1,
		                                bRF,
		                                bRE,
		                                ,
		                                bRD,
		                                bRC,
		                                bRB,
		                                bRA]),
		                           state_schema_versioned = include[2],
		                           apply = include[8],
		                           apply_delta = include[9],
		                           make = include[10],
		                           view = include[11],
		                           Hierarchy =
		                             [0,
		                              ,
		                              state_schema_versioned,
		                              ,
		                              ,
		                              ,
		                              ,
		                              ,
		                              apply,
		                              apply_delta,
		                              make,
		                              view,
		                              roots$0];
		                          return caml_exact_trampoline_cps_call
		                                  (Make$41,
		                                   Context,
		                                   function(Integration_app){
		                                    return caml_exact_trampoline_cps_call
		    (Make$43,
		     Context,
		     function(Integrations){
		      return caml_exact_trampoline_cps_call
		              (Make$56,
		               Context,
		               function(Members){
		                return caml_exact_trampoline_cps_call
		                        (Make$46,
		                         Context,
		                         function(Notices_personal_archived){
		                          return caml_exact_trampoline_cps_call
		                                  (Make$46,
		                                   Context,
		                                   function(Notices_personal_viewed){
		                                    return caml_exact_trampoline_cps_call
		    (Make$45,
		     Context,
		     function(Notices){
		      return caml_exact_trampoline_cps_call
		              (Make$48,
		               Context,
		               function(Organizations){
		                return caml_exact_trampoline_cps_call
		                        (Make$49,
		                         Context,
		                         function(a){
		                          var
		                           Pages =
		                             [0, , , a[3], , , , , , a[9], a[10], a[11], a[12], a[13]];
		                          return caml_exact_trampoline_cps_call
		                                  (Make$50,
		                                   Context,
		                                   function(People){
		                                    var
		                                     init = Menu_items_crdt[19],
		                                     include =
		                                       Context[3].call
		(null,
		 [0,
		  Menu_items_crdt[2],
		  Menu_items_crdt[3],
		  Menu_items_crdt[4],
		  Menu_items_crdt[5],
		  Menu_items_crdt[6],
		  Menu_items_crdt[7],
		  Menu_items_crdt[8],
		  Menu_items_crdt[9],
		  Menu_items_crdt[10],
		  Menu_items_crdt[11],
		  Menu_items_crdt[18],
		  Menu_items_crdt[17]]),
		                                     state_schema_versioned = include[2],
		                                     apply = include[8],
		                                     apply_delta = include[9],
		                                     make = include[10],
		                                     view = include[11],
		                                     Home =
		                                       Context[3].call
		(null,
		 [0,
		  Operation$24,
		  state_schema_versioned$76,
		  state_schema$29,
		  delta_schema_versioned$102,
		  delta_schema$30,
		  Init$17,
		  Monad$20,
		  apply$123,
		  apply_delta$119,
		  make$133,
		  view$70,
		  equal$252]),
		                                     Menu_items =
		                                       [0,
		,
		,
		,
		,
		,
		,
		init,
		,
		state_schema_versioned,
		,
		,
		,
		,
		,
		apply,
		apply_delta,
		make,
		view];
		                                    return caml_exact_trampoline_cps_call
		    (Make$53,
		     Context,
		     function(Task_bindings){
		      return caml_exact_trampoline_cps_call
		              (Make$52,
		               Context,
		               function(Task_binding_settings){
		                return caml_exact_trampoline_cps_call
		                        (Make$54,
		                         Context,
		                         function(a){
		                          var
		                           Tasks =
		                             [0, , , a[3], , , , , , a[9], a[10], a[11], a[12], a[13]];
		                          return caml_exact_trampoline_cps_call
		                                  (Make$51,
		                                   Context,
		                                   function(Recurrences){
		                                    var
		                                     Settings =
		                                       Context[3].call
		(null,
		 [0,
		  [0, , , , , , , , , , , , const$18],
		  state_schema_versioned$60,
		  state_schema$23,
		  delta_schema_versioned$81,
		  delta_schema$23,
		  Init$12,
		  include$0,
		  apply$98,
		  apply_delta$94,
		  make$118,
		  view$56,
		  equal$248]),
		                                     a =
		                                       Context[3].call
		(null,
		 [0,
		  [0, , , , , , , , , , , , const$19],
		  state_schema_versioned$69,
		  state_schema$24,
		  delta_schema_versioned$90,
		  delta_schema$25,
		  [0, schema_versioned$168, schema$61],
		  include$0,
		  apply$113,
		  apply_delta$109,
		  make$126,
		  view$64,
		  equal$98]),
		                                     c =
		                                       [0,
		a[12],
		[0, a[1][12]],
		a[2],
		a[3],
		a[4],
		a[5],
		a[6],
		a[7],
		a[8],
		a[9],
		a[10],
		a[11]],
		                                     b =
		                                       [0,
		equal$98,
		[0, const$19],
		state_schema_versioned$69,
		state_schema$24,
		delta_schema_versioned$90,
		delta_schema$25,
		[0, schema_versioned$168, schema$61],
		include$0,
		apply$113,
		apply_delta$109,
		make$126,
		view$64];
		                                    return caml_trampoline_cps_call2
		    (Context[5],
		     [0,
		      Table[4],
		      Table[5],
		      Table[9],
		      Table[10],
		      Table[11],
		      Table[12],
		      Table[13],
		      Table[14],
		      Table[15],
		      Table[16],
		      Table[17],
		      Table[18],
		      Table[19],
		      Table[20],
		      Table[21],
		      Table[22],
		      Table[23],
		      Table[24],
		      Table[1]],
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               c,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         b,
		                         function(Tables){
		                          return caml_exact_trampoline_cps_call
		                                  (Make$34,
		                                   Context,
		                                   function(Ai){
		                                    var
		                                     include =
		                                       Context[2].call
		(null,
		 [0,
		  ,
		  state_schema_versioned$0,
		  state_schema$0,
		  delta_schema_versioned$0,
		  delta_schema$0,
		  bRz,
		  ,
		  apply$6,
		  apply_delta$2,
		  make$63,
		  view$1]),
		                                     state_schema_versioned = include[2],
		                                     apply = include[8],
		                                     apply_delta = include[9],
		                                     make = include[10],
		                                     view = include[11];
		                                    function up_edges(t, cont){
		                                     return caml_exact_trampoline_cps_call(up_edges$0, t, cont);
		                                    }
		                                    var
		                                     Monad = Context[1],
		                                     Object_hierarchy =
		                                       [0,
		,
		state_schema_versioned,
		,
		,
		,
		,
		,
		apply,
		apply_delta,
		make,
		view,
		up_edges],
		                                     letrec_function_context = [];
		                                    function state_schema_versioned$1(schematic_version, cont){
		                                     return caml_exact_trampoline_cps_call
		     (schematic_version,
		      V$4,
		      function(schematic_schema_version){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context[1][1],
		                schematic_schema_version,
		                function(match){
		                 function a(descriptor){
		                  return cont([0, aXv, 0, descriptor, 0]);
		                 }
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (fixpoint,
		                           function(schematic_self, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     letrec_function_context[1][1],
		                                     schematic_schema_version,
		                                     function(match){
		                                      if(! match)
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        schematic_self,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return caml_exact_trampoline_cps_call
		                 (Object_hierarchy[2],
		                  schematic_version,
		                  function(b){
		                   var
		                    a =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_object_hierarchy$0, 0, 2, [0, b], 0, 0],
		                       0];
		                   return caml_trampoline_cps_call2
		                           (Tables[3],
		                            schematic_version,
		                            function(c){
		                             var
		                              b = [0, [0, 0, 0, 0, 0, cst_tables, 0, 2, [0, c], 0, 0], a];
		                             return caml_trampoline_cps_call2
		                                     (Tasks[3],
		                                      schematic_version,
		                                      function(c){
		                                       var
		a = [0, [0, 0, 0, 0, 0, cst_tasks, 0, 2, [0, c], 0, 0], b];
		                                       return caml_trampoline_cps_call2
		       (Task_binding_settings[3],
		        schematic_version,
		        function(c){
		         var
		          b =
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_task_binding_settings$0,
		              0,
		              2,
		              [0, c],
		              0,
		              0],
		             a];
		         return caml_trampoline_cps_call2
		                 (Task_bindings[3],
		                  schematic_version,
		                  function(c){
		                   var
		                    a =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_task_bindings$0, 0, 2, [0, c], 0, 0],
		                       b];
		                   return caml_exact_trampoline_cps_call
		                           (state_schema_versioned$75,
		                            schematic_version,
		                            function(c){
		                             var
		                              b =
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_subscription, 0, 2, [0, c], 0, 0],
		                                 a];
		                             return caml_exact_trampoline_cps_call
		                                     (Settings[2],
		                                      schematic_version,
		                                      function(c){
		                                       var
		a =
		  [0, [0, 0, 0, 0, 0, cst_settings, 0, 2, [0, c], 0, 0], b];
		                                       return caml_trampoline_cps_call2
		       (Recurrences[3],
		        schematic_version,
		        function(c){
		         var
		          b =
		            [0, [0, 0, 0, 0, 0, cst_recurrences, 0, 2, [0, c], 0, 0], a];
		         return caml_exact_trampoline_cps_call
		                 (Menu_items[9],
		                  schematic_version,
		                  function(c){
		                   var
		                    a =
		                      [0, [0, 0, 0, 0, 0, cst_menu_items, 0, 2, [0, c], 0, 0], b];
		                   return caml_trampoline_cps_call2
		                           (People[3],
		                            schematic_version,
		                            function(c){
		                             var
		                              b = [0, [0, 0, 0, 0, 0, cst_people, 0, 2, [0, c], 0, 0], a];
		                             return caml_trampoline_cps_call2
		                                     (Pages[3],
		                                      schematic_version,
		                                      function(c){
		                                       var
		a = [0, [0, 0, 0, 0, 0, cst_pages, 0, 2, [0, c], 0, 0], b];
		                                       return caml_trampoline_cps_call2
		       (Organizations[3],
		        schematic_version,
		        function(c){
		         var
		          b =
		            [0,
		             [0, 0, 0, 0, 0, cst_organizations, 0, 2, [0, c], 0, 0],
		             a];
		         return caml_trampoline_cps_call2
		                 (Notices_personal_viewed[3],
		                  schematic_version,
		                  function(c){
		                   var
		                    a =
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_notices_personal_viewed$0,
		                        0,
		                        2,
		                        [0, c],
		                        0,
		                        0],
		                       b];
		                   return caml_trampoline_cps_call2
		                           (Notices_personal_archived[3],
		                            schematic_version,
		                            function(c){
		                             var
		                              b =
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_notices_personal_archived$0,
		                                  0,
		                                  2,
		                                  [0, c],
		                                  0,
		                                  0],
		                                 a];
		                             return caml_trampoline_cps_call2
		                                     (Notices[3],
		                                      schematic_version,
		                                      function(c){
		                                       var
		a = [0, [0, 0, 0, 0, 0, cst_notices, 0, 2, [0, c], 0, 0], b];
		                                       return caml_trampoline_cps_call2
		       (Members[3],
		        schematic_version,
		        function(c){
		         var
		          b = [0, [0, 0, 0, 0, 0, cst_members, 0, 2, [0, c], 0, 0], a];
		         return caml_exact_trampoline_cps_call
		                 (Home[2],
		                  schematic_version,
		                  function(c){
		                   var
		                    a = [0, [0, 0, 0, 0, 0, cst_home, 0, 2, [0, c], 0, 0], b];
		                   return caml_exact_trampoline_cps_call
		                           (Hierarchy[2],
		                            schematic_version,
		                            function(c){
		                             var
		                              b =
		                                [0, [0, 0, 0, 0, 0, cst_hierarchy, 0, 2, [0, c], 0, 0], a];
		                             return caml_trampoline_cps_call2
		                                     (Integrations[14],
		                                      schematic_version,
		                                      function(c){
		                                       var
		a =
		  [0,
		   [0, 0, 0, 0, 0, cst_integrations, 0, 2, [0, c], 0, 0],
		   b];
		                                       return caml_exact_trampoline_cps_call
		       (Integration_app[4],
		        schematic_version,
		        function(c){
		         var
		          b =
		            [0,
		             [0, 0, 0, 0, 0, cst_integration_app, 0, 2, [0, c], 0, 0],
		             a];
		         return caml_trampoline_cps_call2
		                 (Events_recurrent[3],
		                  schematic_version,
		                  function(c){
		                   var
		                    a =
		                      [0,
		                       [0, 0, 0, 0, 0, cst_events_recurrent, 0, 2, [0, c], 0, 0],
		                       b];
		                   return caml_trampoline_cps_call2
		                           (Events[3],
		                            schematic_version,
		                            function(c){
		                             var
		                              b = [0, [0, 0, 0, 0, 0, cst_events, 0, 2, [0, c], 0, 0], a];
		                             return caml_trampoline_cps_call2
		                                     (Client_data[3],
		                                      schematic_version,
		                                      function(c){
		                                       var
		a =
		  [0, [0, 0, 0, 0, 0, cst_client_data, 0, 2, [0, c], 0, 0], b];
		                                       return caml_trampoline_cps_call2
		       (Connections[3],
		        schematic_version,
		        function(c){
		         var
		          b =
		            [0, [0, 0, 0, 0, 0, cst_connections, 0, 2, [0, c], 0, 0], a];
		         return caml_trampoline_cps_call2
		                 (Calendars[4],
		                  schematic_version,
		                  function(c){
		                   var
		                    a =
		                      [0, [0, 0, 0, 0, 0, cst_calendars, 0, 2, [0, c], 0, 0], b];
		                   return caml_exact_trampoline_cps_call
		                           (Ai[9],
		                            schematic_version,
		                            function(b){
		                             var
		                              res =
		                                [7,
		                                 function(param, cont){
		                                  var
		                                   a = param[2],
		                                   b = a[2],
		                                   c = b[2],
		                                   d = c[2],
		                                   e = d[2],
		                                   f = e[2],
		                                   g = f[2],
		                                   h = g[2],
		                                   i = h[2],
		                                   j = i[2],
		                                   k = j[2],
		                                   l = k[2],
		                                   m = l[2],
		                                   n = m[2],
		                                   o = n[2],
		                                   p = o[2],
		                                   q = p[2],
		                                   r = q[2],
		                                   s = r[2],
		                                   t = s[2],
		                                   u = t[2],
		                                   v = u[2],
		                                   w = v[2],
		                                   x = w[2],
		                                   object_hierarchy = x[2][1],
		                                   tables = x[1],
		                                   tasks = w[1],
		                                   task_binding_settings = v[1],
		                                   task_bindings = u[1],
		                                   subscription = t[1],
		                                   settings = s[1],
		                                   recurrences = r[1],
		                                   menu_items = q[1],
		                                   people = p[1],
		                                   pages = o[1],
		                                   organizations = n[1],
		                                   notices_personal_viewed = m[1],
		                                   notices_personal_archived = l[1],
		                                   notices = k[1],
		                                   members = j[1],
		                                   home = i[1],
		                                   hierarchy = h[1],
		                                   integrations = g[1],
		                                   integration_app = f[1],
		                                   events_recurrent = e[1],
		                                   events = d[1],
		                                   client_data = c[1],
		                                   connections = b[1],
		                                   calendars = a[1],
		                                   ai = param[1];
		                                  return cont
		  ([0,
		    ai,
		    calendars,
		    connections,
		    client_data,
		    events,
		    events_recurrent,
		    integration_app,
		    integrations,
		    hierarchy,
		    home,
		    members,
		    notices,
		    notices_personal_archived,
		    notices_personal_viewed,
		    organizations,
		    pages,
		    people,
		    menu_items,
		    recurrences,
		    settings,
		    subscription,
		    task_bindings,
		    task_binding_settings,
		    tasks,
		    tables,
		    object_hierarchy]);
		                                 },
		                                 function(param, cont){
		                                  var
		                                   object_hierarchy = param[26],
		                                   tables = param[25],
		                                   tasks = param[24],
		                                   task_binding_settings = param[23],
		                                   task_bindings = param[22],
		                                   subscription = param[21],
		                                   settings = param[20],
		                                   recurrences = param[19],
		                                   menu_items = param[18],
		                                   people = param[17],
		                                   pages = param[16],
		                                   organizations = param[15],
		                                   notices_personal_viewed = param[14],
		                                   notices_personal_archived = param[13],
		                                   notices = param[12],
		                                   members = param[11],
		                                   home = param[10],
		                                   hierarchy = param[9],
		                                   integrations = param[8],
		                                   integration_app = param[7],
		                                   events_recurrent = param[6],
		                                   events = param[5],
		                                   client_data = param[4],
		                                   connections = param[3],
		                                   calendars = param[2],
		                                   ai = param[1];
		                                  return cont
		  ([0,
		    ai,
		    [0,
		     calendars,
		     [0,
		      connections,
		      [0,
		       client_data,
		       [0,
		        events,
		        [0,
		         events_recurrent,
		         [0,
		          integration_app,
		          [0,
		           integrations,
		           [0,
		            hierarchy,
		            [0,
		             home,
		             [0,
		              members,
		              [0,
		               notices,
		               [0,
		                notices_personal_archived,
		                [0,
		                 notices_personal_viewed,
		                 [0,
		                  organizations,
		                  [0,
		                   pages,
		                   [0,
		                    people,
		                    [0,
		                     menu_items,
		                     [0,
		                      recurrences,
		                      [0,
		                       settings,
		                       [0,
		                        subscription,
		                        [0,
		                         task_bindings,
		                         [0,
		                          task_binding_settings,
		                          [0, tasks, [0, tables, [0, object_hierarchy, 0]]]]]]]]]]]]]]]]]]]]]]]]]]);
		                                 },
		                                 [0, [0, 0, 0, 0, 0, cst_ai, 0, 2, [0, b], 0, 0], a]];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context[1][1],
		                                      schematic_schema_version,
		                                      res,
		                                      function(a){
		                                       letrec_function_context[1][1] = a;
		                                       return cont(res);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      var schema = match[1];
		                                      return cont(schema);
		                                     });
		                           },
		                           a);
		                 var schema = match[1];
		                 return a(schema);
		                });
		      });
		                                    }
		                                    var schematic_cache = [0, empty$11([0, comparator$9])];
		                                    caml_update_dummy
		                                     (letrec_function_context, [0, schematic_cache]);
		                                    return caml_exact_trampoline_cps_call
		    (state_schema_versioned$1,
		     function(param, cont){return cont(0);},
		     function(state_schema){
		      function apply(replica, state, op, cont){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$5,
		             symbol_map$5,
		             ,
		             bind$8,
		             return$9,
		             map$17,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$3]),
		        let$ = open[4];
		       switch(op[0]){
		         case 0:
		          var op$0 = op[1];
		          return caml_trampoline_cps_call4
		                  (Ai[14],
		                   replica,
		                   state[1],
		                   op$0,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([0, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  new_substate,
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 1:
		          var op$1 = op[1];
		          return caml_trampoline_cps_call4
		                  (Calendars[10],
		                   replica,
		                   state[2],
		                   op$1,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([1, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  new_substate,
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 2:
		          var op$2 = op[1];
		          return caml_trampoline_cps_call4
		                  (Connections[9],
		                   replica,
		                   state[3],
		                   op$2,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([2, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  new_substate,
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 3:
		          var op$3 = op[1];
		          return caml_trampoline_cps_call4
		                  (Client_data[9],
		                   replica,
		                   state[4],
		                   op$3,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([3, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  new_substate,
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 4:
		          var op$4 = op[1];
		          return caml_trampoline_cps_call4
		                  (Events[9],
		                   replica,
		                   state[5],
		                   op$4,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([4, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  new_substate,
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 5:
		          var op$5 = op[1];
		          return caml_trampoline_cps_call4
		                  (Events_recurrent[9],
		                   replica,
		                   state[6],
		                   op$5,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([5, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  new_substate,
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 6:
		          var op$6 = op[1];
		          return caml_trampoline_cps_call4
		                  (Integration_app[11],
		                   replica,
		                   state[7],
		                   op$6,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([6, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  new_substate,
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 7:
		          var op$7 = op[1];
		          return caml_trampoline_cps_call4
		                  (Integrations[20],
		                   replica,
		                   state[8],
		                   op$7,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([7, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  new_substate,
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 8:
		          var op$8 = op[1];
		          return caml_trampoline_cps_call4
		                  (Hierarchy[8],
		                   replica,
		                   state[9],
		                   op$8,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([8, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  new_substate,
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 9:
		          var op$9 = op[1];
		          return caml_trampoline_cps_call4
		                  (Home[8],
		                   replica,
		                   state[10],
		                   op$9,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([9, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  new_substate,
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 10:
		          var op$10 = op[1];
		          return caml_trampoline_cps_call4
		                  (Members[8],
		                   replica,
		                   state[11],
		                   op$10,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([10, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  new_substate,
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 11:
		          var op$11 = op[1];
		          return caml_trampoline_cps_call4
		                  (Notices[9],
		                   replica,
		                   state[12],
		                   op$11,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([11, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  new_substate,
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 12:
		          var op$12 = op[1];
		          return caml_trampoline_cps_call4
		                  (Notices_personal_archived[9],
		                   replica,
		                   state[13],
		                   op$12,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([12, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  new_substate,
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 13:
		          var op$13 = op[1];
		          return caml_trampoline_cps_call4
		                  (Notices_personal_viewed[9],
		                   replica,
		                   state[14],
		                   op$13,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([13, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  new_substate,
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 14:
		          var op$14 = op[1];
		          return caml_trampoline_cps_call4
		                  (Organizations[9],
		                   replica,
		                   state[15],
		                   op$14,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([14, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  new_substate,
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 15:
		          var op$15 = op[1];
		          return caml_trampoline_cps_call4
		                  (Pages[9],
		                   replica,
		                   state[16],
		                   op$15,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([15, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  new_substate,
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 16:
		          var op$16 = op[1];
		          return caml_trampoline_cps_call4
		                  (People[9],
		                   replica,
		                   state[17],
		                   op$16,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([16, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  new_substate,
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 17:
		          var op$17 = op[1];
		          return caml_trampoline_cps_call4
		                  (Menu_items[15],
		                   replica,
		                   state[18],
		                   op$17,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([17, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  new_substate,
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 18:
		          var op$18 = op[1];
		          return caml_trampoline_cps_call4
		                  (Recurrences[9],
		                   replica,
		                   state[19],
		                   op$18,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([18, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  new_substate,
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 19:
		          var op$19 = op[1];
		          return caml_trampoline_cps_call4
		                  (Settings[8],
		                   replica,
		                   state[20],
		                   op$19,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([19, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  new_substate,
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 20:
		          var op$20 = op[1];
		          return caml_trampoline_cps_call4
		                  (apply$122,
		                   replica,
		                   state[21],
		                   op$20,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([20, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  new_substate,
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 21:
		          var op$21 = op[1];
		          return caml_trampoline_cps_call4
		                  (Task_bindings[9],
		                   replica,
		                   state[22],
		                   op$21,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([21, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  new_substate,
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 22:
		          var op$22 = op[1];
		          return caml_trampoline_cps_call4
		                  (Task_binding_settings[9],
		                   replica,
		                   state[23],
		                   op$22,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([22, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  new_substate,
		                                  state[24],
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 23:
		          var op$23 = op[1];
		          return caml_trampoline_cps_call4
		                  (Tasks[9],
		                   replica,
		                   state[24],
		                   op$23,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([23, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  new_substate,
		                                  state[25],
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         case 24:
		          var op$24 = op[1];
		          return caml_trampoline_cps_call4
		                  (Tables[9],
		                   replica,
		                   state[25],
		                   op$24,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([24, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  new_substate,
		                                  state[26]];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		         default:
		          var op$25 = op[1];
		          return caml_trampoline_cps_call4
		                  (Object_hierarchy[8],
		                   replica,
		                   state[26],
		                   op$25,
		                   function(match){
		                    var
		                     new_substate = match[3],
		                     delta = match[2],
		                     res = match[1];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             delta,
		                             function(delta, cont){return cont([25, delta]);},
		                             function(delta){
		                              var
		                               new_state =
		                                 [0,
		                                  state[1],
		                                  state[2],
		                                  state[3],
		                                  state[4],
		                                  state[5],
		                                  state[6],
		                                  state[7],
		                                  state[8],
		                                  state[9],
		                                  state[10],
		                                  state[11],
		                                  state[12],
		                                  state[13],
		                                  state[14],
		                                  state[15],
		                                  state[16],
		                                  state[17],
		                                  state[18],
		                                  state[19],
		                                  state[20],
		                                  state[21],
		                                  state[22],
		                                  state[23],
		                                  state[24],
		                                  state[25],
		                                  new_substate];
		                              return cont([0, res, delta, new_state]);
		                             });
		                   });
		       }
		      }
		      function apply_delta(replica, state, delta, cont){
		       switch(delta[0]){
		         case 0:
		          var delta$0 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Ai[13],
		                   replica,
		                   state[1],
		                   delta$0,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              new_substate,
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 1:
		          var delta$1 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Calendars[11],
		                   replica,
		                   state[2],
		                   delta$1,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              new_substate,
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 2:
		          var delta$2 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Connections[10],
		                   replica,
		                   state[3],
		                   delta$2,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              new_substate,
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 3:
		          var delta$3 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Client_data[10],
		                   replica,
		                   state[4],
		                   delta$3,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              new_substate,
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 4:
		          var delta$4 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Events[10],
		                   replica,
		                   state[5],
		                   delta$4,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              new_substate,
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 5:
		          var delta$5 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Events_recurrent[10],
		                   replica,
		                   state[6],
		                   delta$5,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              new_substate,
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 6:
		          var delta$6 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Integration_app[10],
		                   replica,
		                   state[7],
		                   delta$6,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              new_substate,
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 7:
		          var delta$7 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Integrations[21],
		                   replica,
		                   state[8],
		                   delta$7,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              new_substate,
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 8:
		          var delta$8 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Hierarchy[9],
		                   replica,
		                   state[9],
		                   delta$8,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              new_substate,
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 9:
		          var delta$9 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Home[9],
		                   replica,
		                   state[10],
		                   delta$9,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              new_substate,
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 10:
		          var delta$10 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Members[9],
		                   replica,
		                   state[11],
		                   delta$10,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              new_substate,
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 11:
		          var delta$11 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Notices[10],
		                   replica,
		                   state[12],
		                   delta$11,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              new_substate,
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 12:
		          var delta$12 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Notices_personal_archived[10],
		                   replica,
		                   state[13],
		                   delta$12,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              new_substate,
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 13:
		          var delta$13 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Notices_personal_viewed[10],
		                   replica,
		                   state[14],
		                   delta$13,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              new_substate,
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 14:
		          var delta$14 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Organizations[10],
		                   replica,
		                   state[15],
		                   delta$14,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              new_substate,
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 15:
		          var delta$15 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Pages[10],
		                   replica,
		                   state[16],
		                   delta$15,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              new_substate,
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 16:
		          var delta$16 = delta[1];
		          return caml_trampoline_cps_call4
		                  (People[10],
		                   replica,
		                   state[17],
		                   delta$16,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              new_substate,
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 17:
		          var delta$17 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Menu_items[16],
		                   replica,
		                   state[18],
		                   delta$17,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              new_substate,
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 18:
		          var delta$18 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Recurrences[10],
		                   replica,
		                   state[19],
		                   delta$18,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              new_substate,
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 19:
		          var delta$19 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Settings[9],
		                   replica,
		                   state[20],
		                   delta$19,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              new_substate,
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 20:
		          var delta$20 = delta[1];
		          return caml_trampoline_cps_call4
		                  (apply_delta$118,
		                   replica,
		                   state[21],
		                   delta$20,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              new_substate,
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 21:
		          var delta$21 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Task_bindings[10],
		                   replica,
		                   state[22],
		                   delta$21,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              new_substate,
		                              state[23],
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 22:
		          var delta$22 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Task_binding_settings[10],
		                   replica,
		                   state[23],
		                   delta$22,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              new_substate,
		                              state[24],
		                              state[25],
		                              state[26]]);
		                   });
		         case 23:
		          var delta$23 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Tasks[10],
		                   replica,
		                   state[24],
		                   delta$23,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              new_substate,
		                              state[25],
		                              state[26]]);
		                   });
		         case 24:
		          var delta$24 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Tables[10],
		                   replica,
		                   state[25],
		                   delta$24,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              new_substate,
		                              state[26]]);
		                   });
		         default:
		          var delta$25 = delta[1];
		          return caml_trampoline_cps_call4
		                  (Object_hierarchy[9],
		                   replica,
		                   state[26],
		                   delta$25,
		                   function(new_substate){
		                    return cont
		                            ([0,
		                              state[1],
		                              state[2],
		                              state[3],
		                              state[4],
		                              state[5],
		                              state[6],
		                              state[7],
		                              state[8],
		                              state[9],
		                              state[10],
		                              state[11],
		                              state[12],
		                              state[13],
		                              state[14],
		                              state[15],
		                              state[16],
		                              state[17],
		                              state[18],
		                              state[19],
		                              state[20],
		                              state[21],
		                              state[22],
		                              state[23],
		                              state[24],
		                              state[25],
		                              new_substate]);
		                   });
		       }
		      }
		      return caml_exact_trampoline_cps_call
		              (Apply$44,
		               [0, Delta$3, apply_delta, apply],
		               function(include){
		                var delta_schema_versioned = include[1], apply = include[4];
		                function make(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Object_hierarchy[10],
		                          0,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (Tables[11],
		                                    Tables[13],
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (Tasks[11],
		      Tasks[13],
		      function(c){
		       return caml_trampoline_cps_call2
		               (Task_binding_settings[11],
		                Task_binding_settings[13],
		                function(d){
		                 return caml_trampoline_cps_call2
		                         (Task_bindings[11],
		                          Task_bindings[13],
		                          function(e){
		                           return caml_exact_trampoline_cps_call
		                                   (make$132,
		                                    0,
		                                    function(f){
		                                     return caml_exact_trampoline_cps_call
		     (Settings[10],
		      0,
		      function(g){
		       return caml_trampoline_cps_call2
		               (Recurrences[11],
		                Recurrences[13],
		                function(h){
		                 return caml_exact_trampoline_cps_call
		                         (Menu_items[17],
		                          Menu_items[7],
		                          function(i){
		                           return caml_trampoline_cps_call2
		                                   (People[11],
		                                    People[13],
		                                    function(j){
		                                     return caml_trampoline_cps_call2
		     (Pages[11],
		      Pages[13],
		      function(k){
		       return caml_trampoline_cps_call2
		               (Organizations[11],
		                Organizations[13],
		                function(l){
		                 return caml_trampoline_cps_call2
		                         (Notices_personal_viewed[11],
		                          By$19[104],
		                          function(m){
		                           return caml_trampoline_cps_call2
		                                   (Notices_personal_archived[11],
		                                    By$19[104],
		                                    function(n){
		                                     return caml_trampoline_cps_call2
		     (Notices[11],
		      By$7[104],
		      function(o){
		       return caml_trampoline_cps_call2
		               (Members[10],
		                Members[12],
		                function(p){
		                 return caml_exact_trampoline_cps_call
		                         (Home[10],
		                          0,
		                          function(q){
		                           return caml_exact_trampoline_cps_call
		                                   (Hierarchy[10],
		                                    0,
		                                    function(r){
		                                     return caml_trampoline_cps_call2
		     (Integrations[22],
		      By$10[104],
		      function(s){
		       return caml_exact_trampoline_cps_call
		               (Integration_app[13],
		                Integration_app[7],
		                function(t){
		                 return caml_trampoline_cps_call2
		                         (Events_recurrent[11],
		                          Events_recurrent[13],
		                          function(u){
		                           return caml_trampoline_cps_call2
		                                   (Events[11],
		                                    Events[13],
		                                    function(v){
		                                     return caml_trampoline_cps_call2
		     (Client_data[11],
		      Client_data[13],
		      function(w){
		       return caml_trampoline_cps_call2
		               (Connections[11],
		                Connections[13],
		                function(x){
		                 return caml_trampoline_cps_call2
		                         (Calendars[12],
		                          Calendars[13],
		                          function(y){
		                           return caml_exact_trampoline_cps_call
		                                   (Ai[16],
		                                    Ai[19],
		                                    function(z){
		                                     return cont
		     ([0,
		       z,
		       y,
		       x,
		       w,
		       v,
		       u,
		       t,
		       s,
		       r,
		       q,
		       p,
		       o,
		       n,
		       m,
		       l,
		       k,
		       j,
		       i,
		       h,
		       g,
		       f,
		       e,
		       d,
		       c,
		       b,
		       a]);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                function view(state, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       Monad[1],
		                       Monad[2],
		                       ,
		                       Monad[4],
		                       Monad[5],
		                       Monad[6],
		                       ,
		                       ,
		                       ,
		                       ,
		                       Monad[11]]),
		                  and = open[6],
		                  let$ = open[4];
		                 function a(a, cont){
		                  var
		                   database = a[2],
		                   a = a[1],
		                   ai = a[2],
		                   a = a[1],
		                   tasks = a[2],
		                   a = a[1],
		                   home = a[2],
		                   a = a[1],
		                   task_binding_settings = a[2],
		                   a = a[1],
		                   task_bindings = a[2],
		                   a = a[1],
		                   recurrences = a[2],
		                   a = a[1],
		                   menu_items = a[2],
		                   a = a[1],
		                   people = a[2],
		                   a = a[1],
		                   organizations = a[2],
		                   a = a[1],
		                   notices_personal_viewed = a[2],
		                   a = a[1],
		                   notices_personal_archived = a[2],
		                   a = a[1],
		                   notices = a[2],
		                   a = a[1],
		                   members = a[2],
		                   a = a[1],
		                   integrations = a[2],
		                   a = a[1],
		                   integration_app = a[2],
		                   a = a[1],
		                   events_recurrent = a[2],
		                   a = a[1],
		                   events = a[2],
		                   a = a[1],
		                   client_data = a[2],
		                   a = a[1],
		                   connections = a[2],
		                   a = a[1],
		                   b = a[2],
		                   settings = b[3],
		                   mrus = b[2],
		                   calendars = b[1],
		                   a = a[1],
		                   pages = a[2],
		                   hierarchy_lookup = a[1];
		                  return cont
		                          ([0,
		                            ai,
		                            calendars,
		                            connections,
		                            client_data,
		                            events,
		                            events_recurrent,
		                            hierarchy_lookup,
		                            integration_app,
		                            integrations,
		                            members,
		                            mrus,
		                            notices,
		                            notices_personal_archived,
		                            notices_personal_viewed,
		                            organizations,
		                            pages,
		                            people,
		                            menu_items,
		                            home,
		                            recurrences,
		                            settings,
		                            task_bindings,
		                            task_binding_settings,
		                            tasks,
		                            database]);
		                 }
		                 function b(param, cont){
		                  var
		                   hierarchy = param[2],
		                   pages = param[1],
		                   init = [0, By$2[104], pages],
		                   t = to_sequence$5(Hierarchy[12].call(null, hierarchy)),
		                   next = t[2],
		                   seed = t[1];
		                  function a(seed$1, v){
		                   var match = next(seed$1);
		                   if(typeof match === "number") return cont(v);
		                   if(0 === match[0]){
		                    var seed = match[1];
		                    return caml_exact_trampoline_call2(a, seed, v);
		                   }
		                   var
		                    seed$0 = match[2],
		                    a$0 = match[1],
		                    children = a$0[3],
		                    parent_id = a$0[2],
		                    tree_id = a$0[1],
		                    pages = v[2],
		                    lookup = v[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            lookup,
		                            parent_id,
		                            tree_id,
		                            function(lookup){
		                             function b(t, pages){
		                              if(t){
		                               var
		                                l = t[2],
		                                a$0 = t[1],
		                                child_id = a$0[2],
		                                c =
		                                  function(page, cont){
		                                   var a = page[3];
		                                   return cont
		   ([0,
		     page[1],
		     page[2],
		     [0, a[1], a[2], a[3], a[4], [0, parent_id]]]);
		                                  };
		                               return caml_exact_trampoline_cps_call$0
		                                       (change$0,
		pages,
		child_id,
		function(a, cont){
		 return caml_trampoline_cps_call3(map$17, a, c, cont);
		},
		function(init){
		 return caml_exact_trampoline_call2(b, l, init);
		});
		                              }
		                              var v = [0, lookup, pages];
		                              return caml_exact_trampoline_call2(a, seed$0, v);
		                             }
		                             return b(children, pages);
		                            });
		                  }
		                  return a(seed, init);
		                 }
		                 return caml_trampoline_cps_call2
		                         (Pages[12],
		                          state[16],
		                          function(left){
		                           return caml_exact_trampoline_cps_call
		                                   (Hierarchy[11],
		                                    state[9],
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      c,
		      function(c){
		       return caml_trampoline_cps_call3
		               (let$,
		                c,
		                b,
		                function(left){
		                 function b(param, cont){
		                  var atomic_settings = param[2], calendars = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$13,
		                           calendars,
		                           of_calendar,
		                           function(calendar_settings){
		                            var
		                             week_start = atomic_settings[7],
		                             mru_peoples = atomic_settings[6],
		                             mru_destinations = atomic_settings[5],
		                             hours = atomic_settings[4],
		                             locale = atomic_settings[3],
		                             access_restrictions = atomic_settings[1],
		                             settings =
		                               [0,
		                                access_restrictions,
		                                calendar_settings,
		                                locale,
		                                hours,
		                                mru_destinations,
		                                mru_peoples,
		                                week_start];
		                            return caml_exact_trampoline_cps_call
		                                    (Email$0[23],
		                                     settings[6],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (Destination[23],
		       settings[5],
		       function(b){
		        var mrus = [0, b, a];
		        return cont([0, calendars, mrus, settings]);
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (Calendars[22],
		                          state[2],
		                          function(left$0){
		                           return caml_exact_trampoline_cps_call
		                                   (Settings[11],
		                                    state[20],
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left$0,
		      c,
		      function(c){
		       return caml_trampoline_cps_call3
		               (let$,
		                c,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Connections[12],
		                                    state[3],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Client_data[12],
		                state[4],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Events[12],
		                                    state[5],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Events_recurrent[12],
		                state[6],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_exact_trampoline_cps_call
		                                   (Integration_app[12],
		                                    state[7],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_exact_trampoline_cps_call
		               (Integrations[23],
		                state[8],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Members[11],
		                                    state[11],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Notices[12],
		                state[12],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Notices_personal_archived[12],
		                                    state[13],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Notices_personal_viewed[12],
		                state[14],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Organizations[12],
		                                    state[15],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (People[12],
		                state[17],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_exact_trampoline_cps_call
		                                   (Menu_items[18],
		                                    state[18],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Recurrences[12],
		                state[19],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_trampoline_cps_call2
		                                   (Task_bindings[12],
		                                    state[22],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Task_binding_settings[12],
		                state[23],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_exact_trampoline_cps_call
		                                   (Home[11],
		                                    state[10],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       return caml_trampoline_cps_call2
		               (Tasks[12],
		                state[24],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(left){
		                           return caml_exact_trampoline_cps_call
		                                   (Ai[17],
		                                    state[1],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(left){
		       function b(param, cont){
		        var hierarchy = param[2], tables = param[1];
		        return cont([0, tables, hierarchy]);
		       }
		       return caml_trampoline_cps_call2
		               (Tables[12],
		                state[25],
		                function(left$0){
		                 function c(tree, cont){
		                  return caml_exact_trampoline_cps_call
		                          (Object_hierarchy[12],
		                           tree,
		                           function(s){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$13, s, of_option$2, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (Object_hierarchy[11],
		                          state[26],
		                          function(d){
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    d,
		                                    c,
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left$0,
		      c,
		      function(c){
		       return caml_trampoline_cps_call3
		               (let$,
		                c,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (and,
		                          left,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return cont
		                        ([0,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          ,
		                          state_schema_versioned$1,
		                          ,
		                          delta_schema_versioned,
		                          ,
		                          ,
		                          apply,
		                          ,
		                          make,
		                          view]);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback(Make$57, [Ident]);
		               function connections(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [2, operation], cont);
		               }
		               function events(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [4, operation], cont);
		               }
		               function events_recurrent(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [5, operation], cont);
		               }
		               function hierarchy(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [8, operation], cont);
		               }
		               function integration_app(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [6, operation], cont);
		               }
		               function integrations$0(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [7, operation], cont);
		               }
		               function members(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [10, operation], cont);
		               }
		               function notices(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [11, operation], cont);
		               }
		               function notices_personal_archived(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [12, operation], cont);
		               }
		               function notices_personal_viewed(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [13, operation], cont);
		               }
		               function organizations(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [14, operation], cont);
		               }
		               function pages(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [15, operation], cont);
		               }
		               function people(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [16, operation], cont);
		               }
		               function recurrences(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [18, operation], cont);
		               }
		               function task_bindings(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [21, operation], cont);
		               }
		               function tables(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [24, operation], cont);
		               }
		               function tasks(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [23, operation], cont);
		               }
		               function ai$0(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [0, operation], cont);
		               }
		               function settings(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$47, [19, operation], cont);
		               }
		               function to_option$6(param){
		                if(! param) return 0;
		                var x = param[1];
		                return [0, x];
		               }
		               function schema_versioned$496(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (routine_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, aXw, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$496,
		                 [function(param, cont){return cont(0);}]);
		               function get_occurrences(state, date, task_rec_id, cont){
		                var tasks = state[24];
		                return caml_exact_trampoline_cps_call$1
		                        (filter$5,
		                         tasks,
		                         function(a, cont){
		                          a = a[7][5];
		                          if(! a) return cont(0);
		                          var occ = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (equal$107, task_rec_id, occ[2], cont);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (partition_tf$2,
		                                   a,
		                                   function(a, cont){
		                                    a = a[7][7];
		                                    if(a){
		                                     a = a[1];
		                                     if(0 !== a[0]){
		                                      var d = a[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$82, d, date, cont);
		                                     }
		                                    }
		                                    return cont(0);
		                                   },
		                                   function(match){
		                                    var other = match[2], scheduled_after = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (filter_map$3,
		     other,
		     function(task, cont){
		      var a = task[7][7];
		      if(a){
		       a = a[1];
		       if(0 !== a[0]){var d = a[1]; return cont([0, d]);}
		      }
		      return cont(0);
		     },
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (encode,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (of_list$2,
		                         [0, comparator$11],
		                         a,
		                         function(a){
		                          var last_remaining_date = max_elt$1(a);
		                          return caml_exact_trampoline_cps_call
		                                  (keys$0,
		                                   scheduled_after,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (keys$0,
		     other,
		     function(b){return cont([0, b, a, last_remaining_date]);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function get_calendar(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[2], id, cont);
		               }
		               function get_event(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[5], id, cont);
		               }
		               function get_event_recurrent(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[6], id, cont);
		               }
		               function get_page(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[16], id, cont);
		               }
		               function get_tree_id(state, parent, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[7], parent, cont);
		               }
		               function get_person(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[17], id, cont);
		               }
		               function get_task(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[24], id, cont);
		               }
		               function get_task_recurrent(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[20], id, cont);
		               }
		               function remove_extension_row(table_id, param, cont){
		                if(! param)
		                 return caml_trampoline_cps_call2(return$39, 0, cont);
		                var row_id = param[1][1];
		                return caml_exact_trampoline_cps_call
		                        (include$321[18],
		                         row_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (rows,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$19,
		     table_id,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call(tables, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function add_task_from_todo(created, parent, block_todo, cont){
		                function a(a){
		                 return caml_trampoline_cps_call3(map$17, a, tasks, cont);
		                }
		                if(is_empty$0(block_todo[2])) return a(0);
		                var
		                 title = block_todo[2],
		                 checked = block_todo[1],
		                 id = block_todo[3],
		                 status = checked ? [0, [0, created]] : 0;
		                return caml_exact_trampoline_cps_call$6
		                        (add_task,
		                         id,
		                         0,
		                         0,
		                         0,
		                         parent,
		                         0,
		                         0,
		                         status,
		                         0,
		                         title,
		                         created,
		                         function(op){return a([0, op]);});
		               }
		               function unset_task_occurrences(task_ids, cont){
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         task_ids,
		                         function(id, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (set_occurrence,
		                                   0,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$23,
		     id,
		     function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                   });
		                         },
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (Operation$21[13],
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(tasks, a, cont);
		                                   });
		                         });
		               }
		               function shallow_copy_document
		               (depth, date_id, parent, state, time, doc, cont){
		                return caml_exact_trampoline_cps_call
		                        (salt_date,
		                         date_id,
		                         function(salt){
		                          function add_template_task(todo, cont){
		                           var match = todo[3];
		                           if(match)
		                            var task_id = match[1], task_id$0 = task_id, todo$0 = todo;
		                           else
		                            var
		                             task_id$1 = make$31(),
		                             todo$1 = [0, todo[1], todo[2]],
		                             task_id$0 = task_id$1,
		                             todo$0 = todo$1;
		                           function f(task, cont){
		                            return caml_trampoline_cps_call3
		                                    (add$31,
		                                     task_id$0,
		                                     task,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (tasks,
		       a,
		       function(add_template_op){
		        return cont([0, task, add_template_op]);
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$3
		                                   (make_from_fresh_todo,
		                                    todo$0[1],
		                                    time,
		                                    [0, task_id$0],
		                                    parent,
		                                    todo$0[2],
		                                    function(x){
		                                     return caml_trampoline_cps_call3(map$17, x, f, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$0,
		                                   doc[1],
		                                   function(block, cont){
		                                    var a = block[2];
		                                    a:
		                                    {
		                                     if(typeof depth === "number")
		                                      if(3953222 === depth){
		                                       if(typeof a === "number") break a;
		                                       switch(a[0]){
		 case 11:
		  var
		   todo = a[1],
		   f =
		     function(param, cont){
		      var add_template_op = param[2], task = param[1];
		      return caml_exact_trampoline_cps_call$2
		              (materialize_copy_task,
		               date_id,
		               state,
		               time,
		               task,
		               function(match){
		                var occ_op = match[2], salted_id = match[1];
		                return caml_exact_trampoline_cps_call$1
		                        (include$48[31],
		                         salt,
		                         block[1],
		                         function(salted_block_id){
		                          return cont
		                                  ([0,
		                                    [0, add_template_op, [0, occ_op, 0]],
		                                    [0,
		                                     salted_block_id,
		                                     [11, [0, todo[1], todo[2], [0, salted_id]]]]]);
		                         });
		               });
		     },
		   a = todo[3],
		   b =
		     function(x){
		      return caml_trampoline_cps_call3(map$17, x, f, cont);
		     };
		  if(! a)
		   return caml_exact_trampoline_cps_call
		           (add_template_task, todo, b);
		  var task_id = a[1];
		  return caml_exact_trampoline_cps_call$1
		          (get_task,
		           state,
		           task_id,
		           function(match){
		            if(! match)
		             return caml_exact_trampoline_cps_call
		                     (add_template_task, todo, b);
		            var task = match[1];
		            return caml_trampoline_cps_call2
		                    (return$39, 0, function(a){return b([0, [0, task, a]]);});
		           });
		 case 10: break;
		 default: break a;
		                                       }
		                                      }
		                                      else if(1003109192 === depth){
		                                       if(typeof a === "number") break a;
		                                       switch(a[0]){
		 case 11:
		  return cont(0);
		 case 10: break;
		 default: break a;
		                                       }
		                                      }
		                                     if(typeof a !== "number" && 10 === a[0]) return cont(0);
		                                    }
		                                    return cont([0, [0, 0, block]]);
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (unzip,
		     a,
		     function(match){
		      var blocks = match[2], sub_ops = match[1];
		      return caml_exact_trampoline_cps_call
		              (of_list,
		               sub_ops,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (all_unit$27,
		                         a,
		                         function(a){return cont([0, [0, blocks], a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function materialize_copy_task
		               (date_id, state, time, task, cont){
		                return caml_exact_trampoline_cps_call
		                        (salt_date,
		                         date_id,
		                         function(salt){
		                          return caml_exact_trampoline_cps_call$1
		                                  (salt$0,
		                                   salt,
		                                   task[6],
		                                   function(id){
		                                    return caml_exact_trampoline_cps_call$1
		    (get_task,
		     state,
		     id,
		     function(match){
		      return match
		              ? caml_trampoline_cps_call2
		                (return$39, 0, function(a){return cont([0, id, a]);})
		              : caml_exact_trampoline_cps_call$7
		                (shallow_copy_document,
		                 1003109192,
		                 date_id,
		                 [0, [4, id]],
		                 state,
		                 time,
		                 task[7][9][1],
		                 function(match){
		                  var
		                   sub_ops = match[2],
		                   notes = match[1],
		                   open =
		                     g
		                      ([0,
		                        symbol_bind$22,
		                        symbol_map$20,
		                        ,
		                        bind$30,
		                        return$39,
		                        map$50,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Let_syntax$14]),
		                   let$ = open[3];
		                  return caml_trampoline_cps_call3
		                          (let$,
		                           sub_ops,
		                           function(a, cont){
		                            a = task[7];
		                            var
		                             b = task[7][9],
		                             x =
		                               [0,
		                                a[1],
		                                a[2],
		                                a[3],
		                                a[4],
		                                a[5],
		                                a[6],
		                                a[7],
		                                a[8],
		                                [0, notes, b[2], b[3]]],
		                             c = make$34(0, time);
		                            return caml_trampoline_cps_call4
		                                    (make$41,
		                                     0,
		                                     0,
		                                     time,
		                                     function(a){
		                                      return caml_trampoline_cps_call4
		      (a,
		       0,
		       c,
		       id,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 x,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (add$31,
		                           id,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(tasks, a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           },
		                           function(operation){
		                            return caml_exact_trampoline_cps_call
		                                    (ignore_m$11,
		                                     operation,
		                                     function(a){return cont([0, id, a]);});
		                           });
		                 });
		     });
		                                   });
		                         });
		               }
		               function materialize_task_occurrence
		               (next$0, from_date, state, created, task_rec, cont){
		                g
		                 ([0,
		                   Operation$21[4],
		                   Operation$21[5],
		                   ,
		                   Operation$21[7],
		                   Operation$21[8],
		                   Operation$21[9],
		                   ,
		                   ,
		                   ,
		                   ,
		                   Operation$21[12]]);
		                var
		                 recurrence = task_rec[5][2],
		                 next = next$0 ? next$0[1] : 1,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                function a(occurrence, cont){
		                 function a(){return cont([0, occurrence]);}
		                 return next
		                         ? caml_exact_trampoline_cps_call$1
		                           (symbol$81,
		                            occurrence[1],
		                            from_date,
		                            function(b){
		                             return b
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (increment, bPB, occurrence, cont)
		                                     : a();
		                            })
		                         : a();
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (snap,
		                         recurrence,
		                         from_date,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(match){
		                                    if(match){
		                                     var
		                                      occurrence = match[1],
		                                      date_id = occurrence[1],
		                                      id = task_rec[4];
		                                     return caml_exact_trampoline_cps_call
		     (to_bytes$0,
		      id,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (of_bytes$0,
		                a,
		                function(base_id){
		                 return caml_exact_trampoline_cps_call
		                         (salt_date,
		                          date_id,
		                          function(salt){
		                           return caml_exact_trampoline_cps_call$1
		                                   (salt$0,
		                                    salt,
		                                    base_id,
		                                    function(id){
		                                     var recurrence = task_rec[4];
		                                     return caml_exact_trampoline_cps_call$4
		     (Read$0[8],
		      0,
		      0,
		      0,
		      0,
		      [0, [0, date_id, recurrence]],
		      0,
		      [0, [1, date_id]],
		      0,
		      task_rec[5][3],
		      function(b){
		       var a = make$34(0, created);
		       return caml_trampoline_cps_call4
		               (make$41,
		                0,
		                0,
		                created,
		                function(c){
		                 return caml_trampoline_cps_call4
		                         (c,
		                          0,
		                          a,
		                          id,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    b,
		                                    function(task){
		                                     return caml_exact_trampoline_cps_call$7
		     (shallow_copy_document,
		      3953222,
		      occurrence[1],
		      [0, [4, task[6]]],
		      state,
		      created,
		      task[7][9][1],
		      function(a){
		       var
		        sub_op = a[2],
		        notes = a[1],
		        a = task[7],
		        b = task[7][9],
		        task$0 =
		          [0,
		           task[1],
		           task[2],
		           task[3],
		           task[4],
		           task[5],
		           task[6],
		           [0,
		            a[1],
		            a[2],
		            a[3],
		            a[4],
		            a[5],
		            a[6],
		            a[7],
		            a[8],
		            [0, notes, b[2], b[3]]]],
		        open =
		          g
		           ([0,
		             symbol_bind$22,
		             symbol_map$20,
		             ,
		             bind$30,
		             return$39,
		             map$50,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$14]),
		        let$ = open[4],
		        let$0 = open[3];
		       function c(has, cont){
		        return has
		                ? caml_trampoline_cps_call2(return$39, 0, cont)
		                : caml_trampoline_cps_call3
		                  (add$31,
		                   task$0[6],
		                   task$0,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (tasks,
		                             a,
		                             function(op){
		                              function a(param, cont){return cont(1);}
		                              return caml_exact_trampoline_cps_call
		                                      (all_unit$27,
		                                       [0, sub_op, [0, op, 0]],
		                                       function(b){
		return caml_trampoline_cps_call3(let$, b, a, cont);
		                                       });
		                             });
		                   });
		       }
		       return caml_trampoline_cps_call2
		               (has$6,
		                task$0[6],
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (tasks,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (let$0,
		                                    a,
		                                    c,
		                                    function(operation){
		                                     return cont
		     ([0, operation, [0, [0, occurrence[1], task$0[6]]]]);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_trampoline_cps_call2
		    (return$39, 0, function(a){return cont([0, a, 0]);});
		                                   });
		                         });
		               }
		               function add_first_task_occurrence
		               (created, date_created, state, recurrent_task, cont){
		                var a = recurrent_task[5][2][1];
		                function c(next){
		                 return caml_exact_trampoline_cps_call$3
		                         (materialize_task_occurrence,
		                          [0, next],
		                          date_created,
		                          state,
		                          created,
		                          recurrent_task,
		                          function(match){
		                           var date = match[2], op = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (ignore_m$11, op, function(a){return cont([0, a, date]);});
		                          });
		                }
		                function b(){return c(1);}
		                if(0 === a[0])
		                 var start = a[1];
		                else {a = a[2]; if(! a) return b(); start = a[1];}
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$80,
		                         start,
		                         date_created,
		                         function(a){return a ? c(0) : b();});
		               }
		               function materialize_task_occurrences_u
		               (date, starting, state, time, task_rec, cont){
		                function f(previous_date, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (materialize_task_occurrence,
		                          aXz,
		                          previous_date,
		                          state,
		                          time,
		                          task_rec,
		                          function(a){
		                           var next_previous_date = a[2], op = a[1];
		                           function b(){
		                            return caml_exact_trampoline_cps_call
		                                    (ignore_m$11, op, function(a){return cont([0, a, 0]);});
		                           }
		                           if(! next_previous_date) return b();
		                           a = next_previous_date[1];
		                           var occ_id = a[2], next_previous_date$0 = a[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$80,
		                                    next_previous_date$0,
		                                    date,
		                                    function(a){
		                                     if(! a) return b();
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$22,
		   symbol_map$20,
		   ,
		   bind$30,
		   return$39,
		   map$50,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$14]),
		                                      let$ = open[3];
		                                     return caml_trampoline_cps_call3
		     (let$,
		      op,
		      function(generated, cont){
		       if(! generated)
		        return caml_trampoline_cps_call2(return$39, 0, cont);
		       var t = ocaml_ptime_clock_now_d_ps();
		       return caml_exact_trampoline_cps_call
		               (set_status$0,
		                [1, t],
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (element$23,
		                          occ_id,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(tasks, a, cont);
		                                    });
		                          });
		                });
		      },
		      function(op){
		       return caml_exact_trampoline_cps_call
		               (f,
		                next_previous_date$0,
		                function(a){return cont([0, op, a]);});
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (f,
		                         starting,
		                         function(ops){
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$27, ops, cont);
		                         });
		               }
		               function remove_referenced_subtasks
		               (date, state, time, document, cont){
		                function filter_task_id(a, cont){
		                 switch(a[0]){
		                   case 4:
		                    a = a[1];
		                    if(0 === a[0]) return cont(0);
		                    var id = a[1];
		                    return cont([0, [0, id]]);
		                   case 5:
		                    var id$0 = a[1]; return cont([0, [1, id$0]]);
		                   default: return cont(0);
		                 }
		                }
		                function f(a, cont){
		                 var block = a[2];
		                 if(typeof block !== "number")
		                  switch(block[0]){
		                    case 7:
		                     return cont(0);
		                    case 10:
		                     a = block[1][1];
		                     if(a){var id = a[1]; return cont([0, [5, id]]);}
		                     break;
		                    case 11:
		                     a = block[1][3];
		                     if(a){
		                      var task_id = a[1];
		                      return cont([0, task$0(task_id)]);
		                     }
		                     break;
		                  }
		                 return cont(0);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         document[1],
		                         f,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$0,
		                                   a,
		                                   filter_task_id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (partition_map,
		     a,
		     function(a, cont){return cont(a);},
		     function(match){
		      var task_rec_ids = match[2], task_ids = match[1];
		      return caml_exact_trampoline_cps_call$2
		              (remove_tasks,
		               date,
		               state,
		               time,
		               task_ids,
		               function(rm_tasks_op){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         task_rec_ids,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (remove_recurrent_task, date, state, time, a, cont);
		                         },
		                         function(ops){
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$27,
		                                   ops,
		                                   function(rm_tasks_rec_op){
		                                    var
		                                     open =
		                                       g
		([0,
		  symbol_bind$22,
		  symbol_map$20,
		  ,
		  bind$30,
		  return$39,
		  map$50,
		  ,
		  ,
		  ,
		  ,
		  Let_syntax$14]),
		                                     let$ = open[3];
		                                    return caml_trampoline_cps_call3
		    (let$,
		     rm_tasks_op,
		     function(param, cont){return cont(rm_tasks_rec_op);},
		     cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function remove_event(date, state, time, event_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_event,
		                         state,
		                         event_id,
		                         function(match){
		                          if(! match) return cont(0);
		                          var event = match[1];
		                          return caml_exact_trampoline_cps_call$2
		                                  (remove_referenced_subtasks,
		                                   date,
		                                   state,
		                                   time,
		                                   event[9][8],
		                                   function(rm_subtasks_op){
		                                    return caml_exact_trampoline_cps_call$1
		    (remove_extension_row,
		     bP7,
		     event[9][6],
		     function(rm_extension_row_op){
		      return caml_trampoline_cps_call2
		              (remove$9,
		               event_id,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (events,
		                         a,
		                         function(rm_op){
		                          var
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$22,
		                                symbol_map$20,
		                                ,
		                                bind$30,
		                                return$39,
		                                map$50,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$14]),
		                           let$ = open[4];
		                          function a(param, cont){return cont(event);}
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$27,
		                                   [0, rm_subtasks_op, [0, rm_extension_row_op, [0, rm_op, 0]]],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$, b, a, function(op){return cont([0, op]);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function remove_task(date, state, time, task_id, cont){
		                function f(task, cont){
		                 return caml_exact_trampoline_cps_call
		                         (debug$3,
		                          function(m, cont){
		                           return caml_trampoline_cps_call6
		                                   (m, 0, 0, aXA, _16$0, task_id, cont);
		                          },
		                          function(match){
		                           return caml_exact_trampoline_cps_call$2
		                                   (remove_referenced_subtasks,
		                                    date,
		                                    state,
		                                    time,
		                                    task[7][9][1],
		                                    function(rm_sub_op){
		                                     return caml_exact_trampoline_cps_call$1
		     (remove_extension_row,
		      bP6,
		      task[7][3],
		      function(rm_extension_row_op){
		       return caml_exact_trampoline_cps_call$1
		               (filter_map$0,
		                task[1],
		                function(a, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (remove_event, date, state, time, a, cont);
		                },
		                function(ops){
		                 function a(rm_allocs_op){
		                  function f(occurrence, cont){
		                   function f(task_rec, cont){
		                    return caml_exact_trampoline_cps_call$3
		                            (materialize_task_occurrences_u,
		                             date,
		                             occurrence[1],
		                             state,
		                             time,
		                             task_rec,
		                             cont);
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task_recurrent,
		                            state,
		                            occurrence[2],
		                            function(x){
		                             return caml_trampoline_cps_call3(map$17, x, f, cont);
		                            });
		                  }
		                  var x = task[7][5];
		                  return caml_trampoline_cps_call3
		                          (bind$8,
		                           x,
		                           f,
		                           function(spawn_occurrence_op){
		                            return caml_trampoline_cps_call2
		                                    (remove$19,
		                                     task_id,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (tasks,
		       a,
		       function(rm_op){
		        return caml_exact_trampoline_cps_call
		                (filter_opt,
		                 [0,
		                  [0, rm_sub_op],
		                  [0,
		                   [0, rm_extension_row_op],
		                   [0,
		                    rm_allocs_op,
		                    [0, spawn_occurrence_op, [0, [0, rm_op], 0]]]]],
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (all_unit$27,
		                           a,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$9, a, cont);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 }
		                 return ops
		                         ? caml_exact_trampoline_cps_call
		                           (all$24,
		                            ops,
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (ignore_m$11,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call2(return$9, b, a);
		                                      });
		                            })
		                         : a(0);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_task,
		                         state,
		                         task_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                         });
		               }
		               function remove_tasks(date, state, time, task_ids, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         task_ids,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (remove_task, date, state, time, a, cont);
		                         },
		                         function(ops){
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$27, ops, cont);
		                         });
		               }
		               function remove_recurrent_task
		               (date, state, time, task_rec_id, cont){
		                function f(task_rec, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (get_occurrences,
		                          state,
		                          date,
		                          task_rec_id,
		                          function(match){
		                           var task_ids_after = match[2], task_ids_before = match[1];
		                           return caml_exact_trampoline_cps_call$2
		                                   (remove_tasks,
		                                    date,
		                                    state,
		                                    time,
		                                    task_ids_after,
		                                    function(rm_tasks_op){
		                                     return caml_exact_trampoline_cps_call$2
		     (remove_referenced_subtasks,
		      date,
		      state,
		      time,
		      task_rec[5][3][1],
		      function(rm_sub_op){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$22,
		             symbol_map$20,
		             ,
		             bind$30,
		             return$39,
		             map$50,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$14]),
		        and = open[5],
		        let$ = open[3];
		       function a(param, cont){
		        return caml_trampoline_cps_call2
		                (remove$17,
		                 task_rec_id,
		                 function(a){
		                  return caml_exact_trampoline_cps_call(recurrences, a, cont);
		                 });
		       }
		       return caml_trampoline_cps_call3
		               (and,
		                rm_sub_op,
		                rm_tasks_op,
		                function(left){
		                 return caml_exact_trampoline_cps_call
		                         (unset_task_occurrences,
		                          task_ids_before,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (and,
		                                    left,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (let$,
		      b,
		      a,
		      function(op){
		       return caml_trampoline_cps_call2(return$9, op, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_task_recurrent,
		                         state,
		                         task_rec_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                         });
		               }
		               function stop_recurrent_task
		               (date, state, time, task_rec_id, cont){
		                function f(task_rec, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (get_occurrences,
		                          state,
		                          date,
		                          task_rec_id,
		                          function(match){
		                           var task_ids_after = match[2], task_ids_before = match[1];
		                           return caml_exact_trampoline_cps_call$2
		                                   (remove_referenced_subtasks,
		                                    date,
		                                    state,
		                                    time,
		                                    task_rec[5][3][1],
		                                    function(rm_sub_op){
		                                     return caml_exact_trampoline_cps_call$2
		     (remove_tasks,
		      date,
		      state,
		      time,
		      task_ids_after,
		      function(rm_tasks_op){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$22,
		             symbol_map$20,
		             ,
		             bind$30,
		             return$39,
		             map$50,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$14]),
		        and = open[5],
		        let$ = open[3];
		       function a(param, cont){
		        var bounds = task_rec[5][2][1];
		        if(0 === bounds[0])
		         var start = bounds[1], start$0 = [0, start];
		        else
		         var start$1 = bounds[2], start$0 = start$1;
		        var
		         new_bounds = [1, [0, date], start$0],
		         new_rec = [0, new_bounds, task_rec[5][2][2]];
		        return caml_exact_trampoline_cps_call
		                (set_recurrence,
		                 new_rec,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (element$17,
		                           task_rec[4],
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(recurrences, a, cont);
		                                     });
		                           });
		                 });
		       }
		       return caml_trampoline_cps_call3
		               (and,
		                rm_sub_op,
		                rm_tasks_op,
		                function(left){
		                 return caml_exact_trampoline_cps_call
		                         (unset_task_occurrences,
		                          task_ids_before,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (and,
		                                    left,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (let$,
		      b,
		      a,
		      function(op){
		       return caml_trampoline_cps_call2(return$9, op, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_task_recurrent,
		                         state,
		                         task_rec_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                         });
		               }
		               function update_task_from_todo(time, block_todo, task, cont){
		                var
		                 content = block_todo[2],
		                 checked = block_todo[1],
		                 previous_title = task[7][9][2];
		                a:
		                {
		                 if(task[7][2]){
		                  if(! checked){var status = aXy; break a;}
		                 }
		                 else if(checked){status = [0, [0, time]]; break a;}
		                 status = 0;
		                }
		                var
		                 title = some_if(content !== previous_title ? 1 : 0, content);
		                function a(a){
		                 return caml_trampoline_cps_call3(map$17, a, tasks, cont);
		                }
		                if(! status && ! title) return a(0);
		                return caml_exact_trampoline_cps_call
		                        (info$0,
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, aXx, _16$0, task[6], cont);
		                         },
		                         function(match){
		                          var
		                           task_id = task[6],
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$5,
		                                symbol_map$5,
		                                ,
		                                bind$8,
		                                return$9,
		                                map$17,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$3]),
		                           let$ = open[3];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   title,
		                                   function(title, cont){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     some_if(previous_title !== title ? 1 : 0, 0),
		     function(param, cont){
		      return caml_exact_trampoline_cps_call$1
		              (diff$1, previous_title, title, cont);
		     },
		     cont);
		                                   },
		                                   function(title){
		                                    return caml_exact_trampoline_cps_call$4
		    (update$7, 0, 0, 0, 0, 0, status, title, 0, task_id, a);
		                                   });
		                         });
		               }
		               function add_recurrent_task_from_block
		               (created, parent, block_rec, cont){
		                function a(a){
		                 return caml_trampoline_cps_call3
		                         (map$17, a, recurrences, cont);
		                }
		                if(is_empty$0(block_rec[2])) return a(0);
		                var
		                 title = block_rec[2],
		                 recurrence = block_rec[3],
		                 id = block_rec[1];
		                g
		                 ([0,
		                   Operation$15[4],
		                   Operation$15[5],
		                   ,
		                   Operation$15[7],
		                   Operation$15[8],
		                   Operation$15[9],
		                   ,
		                   ,
		                   ,
		                   ,
		                   Operation$15[12]]);
		                return caml_exact_trampoline_cps_call$7
		                        (add_recurrent_task,
		                         id,
		                         parent,
		                         0,
		                         [0, title],
		                         recurrence,
		                         created,
		                         function(op){return a([0, op]);});
		               }
		               function update_recurrent_task_from_blo
		               (block_rec, task_rec, cont){
		                var
		                 previous_title = task_rec[5][3][2],
		                 previous_recurrence = task_rec[5][2],
		                 x = block_rec[2],
		                 title = some_if(x !== previous_title ? 1 : 0, block_rec[2]),
		                 a = block_rec[3];
		                return caml_exact_trampoline_cps_call$1
		                        (equal$32,
		                         previous_recurrence,
		                         block_rec[3],
		                         function(d){
		                          var recurrence = some_if(1 - d, a);
		                          function b(a){
		                           return caml_trampoline_cps_call3
		                                   (map$17, a, recurrences, cont);
		                          }
		                          if(! title && ! recurrence) return b(0);
		                          function c(a){
		                           var
		                            task_rec_id = task_rec[4],
		                            open =
		                              g
		                               ([0,
		                                 symbol_bind$5,
		                                 symbol_map$5,
		                                 ,
		                                 bind$8,
		                                 return$9,
		                                 map$17,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$3]),
		                            let$ = open[3];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    title,
		                                    function(title, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (diff$1, previous_title, title, cont);
		                                    },
		                                    function(title_op){
		                                     return caml_exact_trampoline_cps_call$7
		     (update$5, 0, 0, recurrence, title_op, 0, task_rec_id, b);
		                                    });
		                          }
		                          return is_some(recurrence)
		                                  ? caml_exact_trampoline_cps_call
		                                    (err$1,
		                                     function(m, cont){
		                                      return caml_trampoline_cps_call4(m, 0, 0, aXB, cont);
		                                     },
		                                     c)
		                                  : c();
		                         });
		               }
		               function add_referenced_subtasks(created, parent, doc, cont){
		                function default$(block, cont){
		                 return caml_trampoline_cps_call2
		                         (return$39, [0, block, 0], cont);
		                }
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         doc[1],
		                         function(block, cont){
		                          var a = block[2];
		                          if(typeof a !== "number")
		                           switch(a[0]){
		                             case 10:
		                              var todo = a[1], a = todo[1];
		                              if(a){
		                               var id = a[1];
		                               return caml_exact_trampoline_cps_call
		                                       (err$1,
		function(m, cont){
		 return caml_trampoline_cps_call6
		         (m, 0, 0, aXC, pp$72, id, cont);
		},
		function(match){
		 return caml_exact_trampoline_cps_call(default$, block, cont);
		});
		                              }
		                              var
		                               f =
		                                 function(add_rec_task_op, cont){
		                                  return caml_trampoline_cps_call3
		  (g
		     ([0,
		       symbol_bind$22,
		       symbol_map$20,
		       ,
		       bind$30,
		       return$39,
		       map$50,
		       ,
		       ,
		       ,
		       ,
		       Let_syntax$14])
		    [3],
		   add_rec_task_op,
		   function(task_rec_id, cont){
		    var todo$0 = [0, [0, task_rec_id], todo[2], todo[3]];
		    return caml_trampoline_cps_call2
		            (return$39,
		             [0,
		              [0, block[1], [10, todo$0]],
		              [0, [0, 1007802244, task_rec_id]]],
		             cont);
		   },
		   cont);
		                                 };
		                              return caml_exact_trampoline_cps_call$0
		                                      (add_recurrent_task_from_block,
		                                       created,
		                                       parent,
		                                       todo,
		                                       function(x){
		return caml_trampoline_cps_call3
		        (map$17,
		         x,
		         f,
		         function(op){
		          return caml_exact_trampoline_cps_call
		                  (default$, block, function(a){return cont(value$4(op, a));});
		         });
		                                       });
		                             case 11:
		                              var todo$0 = a[1], a = todo$0[3];
		                              if(a){
		                               var id$0 = a[1];
		                               return caml_exact_trampoline_cps_call
		                                       (err$1,
		function(m, cont){
		 return caml_trampoline_cps_call6
		         (m, 0, 0, aXD, _16$0, id$0, cont);
		},
		function(match){
		 return caml_exact_trampoline_cps_call(default$, block, cont);
		});
		                              }
		                              var
		                               f$0 =
		                                 function(add_task_op, cont){
		                                  return caml_trampoline_cps_call3
		  (g
		     ([0,
		       symbol_bind$22,
		       symbol_map$20,
		       ,
		       bind$30,
		       return$39,
		       map$50,
		       ,
		       ,
		       ,
		       ,
		       Let_syntax$14])
		    [3],
		   add_task_op,
		   function(task_id, cont){
		    var todo = [0, todo$0[1], todo$0[2], [0, task_id]];
		    return caml_trampoline_cps_call2
		            (return$39,
		             [0,
		              [0, block[1], [11, todo]],
		              [0, [0, -339741771, task_id]]],
		             cont);
		   },
		   cont);
		                                 };
		                              return caml_exact_trampoline_cps_call$0
		                                      (add_task_from_todo,
		                                       created,
		                                       parent,
		                                       todo$0,
		                                       function(x){
		return caml_trampoline_cps_call3
		        (map$17,
		         x,
		         f$0,
		         function(op){
		          return caml_exact_trampoline_cps_call
		                  (default$, block, function(a){return cont(value$4(op, a));});
		         });
		                                       });
		                           }
		                          return caml_exact_trampoline_cps_call(default$, block, cont);
		                         },
		                         function(ops){
		                          var
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$22,
		                                symbol_map$20,
		                                ,
		                                bind$30,
		                                return$39,
		                                map$50,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$14]),
		                           let$ = open[3];
		                          function a(block_ids, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (unzip,
		                                    block_ids,
		                                    function(match){
		                                     var ids = match[2], blocks = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (filter_map$0,
		      ids,
		      function(a, cont){return cont(a);},
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (partition_map,
		                a,
		                function(param, cont){
		                 var variant = param[1];
		                 if(1007802244 <= variant){
		                  var id = param[2];
		                  return cont([1, id]);
		                 }
		                 var id$0 = param[2];
		                 return cont([0, id$0]);
		                },
		                function(match){
		                 var task_rec_ids = match[2], task_ids = match[1];
		                 return caml_trampoline_cps_call2
		                         (return$39, [0, [0, blocks], task_ids, task_rec_ids], cont);
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (all$24,
		                                   ops,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               }
		               function get$13(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[5], id, cont);
		               }
		               function get_recurrent(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_event_recurrent, state, id, cont);
		               }
		               var
		                Get =
		                  Make_get_by_date
		                   ([0,
		                     [0,
		                      [0, , make_occurrence, make_occurrence_by_date, snap$1],
		                      [0, value_map$0],
		                      id$34],
		                     Ident2,
		                     get$13,
		                     get_recurrent]);
		               function get$14(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Get[4], state, id, cont);
		               }
		               function case$1(occurrence, orphan, singular, id, x, cont){
		                var t = id(x);
		                if(0 === t[0])
		                 return caml_exact_trampoline_cps_call(singular, x, cont);
		                var
		                 recurrence = t[1],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$22,
		                      symbol_map$20,
		                      ,
		                      bind$30,
		                      return$39,
		                      map$50,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$14]),
		                 let$ = open[3];
		                function a(has, cont){
		                 return has
		                         ? caml_exact_trampoline_cps_call(occurrence, x, cont)
		                         : caml_exact_trampoline_cps_call(orphan, x, cont);
		                }
		                return caml_trampoline_cps_call2
		                        (has$1,
		                         recurrence,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (events_recurrent,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               }
		               function force$1(state, event_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$14,
		                         state,
		                         event_id,
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_event,
		                                   state,
		                                   event_id,
		                                   function(match$0){
		                                    if(match && ! match$0){
		                                     var previous = match[1];
		                                     return caml_exact_trampoline_cps_call$3
		     (case$1,
		      function(ev, cont){
		       return caml_trampoline_cps_call3
		               (add$19,
		                event_id,
		                ev,
		                function(a){
		                 return caml_exact_trampoline_cps_call(events, a, cont);
		                });
		      },
		      function(param, cont){
		       return caml_trampoline_cps_call2(return$39, 0, cont);
		      },
		      function(param, cont){
		       return caml_trampoline_cps_call2(return$39, 0, cont);
		      },
		      function(ev){return ev[6];},
		      previous,
		      cont);
		                                    }
		                                    return caml_trampoline_cps_call2(return$39, 0, cont);
		                                   });
		                         });
		               }
		               function update_notes_from_diff_ignore
		               (lift_document, cascade, previous, notes, cont){
		                var
		                 open$0 =
		                   g
		                    ([0,
		                      symbol_bind$22,
		                      symbol_map$20,
		                      ,
		                      bind$30,
		                      return$39,
		                      map$50,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$14]),
		                 let$2 = open$0[3],
		                 symbol_map$0 = open$0[2];
		                function a(a){
		                 return caml_trampoline_cps_call3
		                         (map$17, a, ignore_m$11, cont);
		                }
		                if(! cascade)
		                 return caml_exact_trampoline_cps_call$0
		                         (update_from_diff,
		                          function(param, cont){return cont(0);},
		                          previous,
		                          notes,
		                          function(match){
		                           var doc_op = match[1];
		                           return caml_trampoline_cps_call3
		                                   (map$17,
		                                    doc_op,
		                                    function(op, cont){
		                                     function a(param, cont){return cont(aXN);}
		                                     return caml_exact_trampoline_cps_call
		     (lift_document[1],
		      op,
		      function(b){
		       return caml_trampoline_cps_call3(symbol_map$0, b, a, cont);
		      });
		                                    },
		                                    a);
		                          });
		                var
		                 match = cascade[1],
		                 state = match[4],
		                 parent = match[3],
		                 time = match[2],
		                 date = match[1],
		                 include =
		                   Syntax2([0, symbol_bind$5, symbol_map$5, Let_syntax$3]),
		                 let$ = include[4],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$22,
		                      symbol_map$20,
		                      ,
		                      bind$30,
		                      return$39,
		                      map$50,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$14]),
		                 let$0 = open[4],
		                 let$1 = open[3],
		                 symbol_map = open[2];
		                function add_task(time, parent, block, todo, cont){
		                 function a(add_task_op, cont){
		                  return caml_trampoline_cps_call3
		                          (let$1,
		                           add_task_op,
		                           function(task_id, cont){
		                            var todo$0 = [0, todo[1], todo[2], [0, task_id]];
		                            return caml_trampoline_cps_call2
		                                    (return$39,
		                                     [0, [0, [0, block[1], [11, todo$0]]], [0, task_id], 0],
		                                     cont);
		                           },
		                           cont);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (add_task_from_todo,
		                          time,
		                          parent,
		                          todo,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                function add_rec_task(time, parent, block, block_rec, cont){
		                 function a(add_rec_task_op, cont){
		                  return caml_trampoline_cps_call3
		                          (let$1,
		                           add_rec_task_op,
		                           function(task_rec_id, cont){
		                            var
		                             block_rec$0 =
		                               [0, [0, task_rec_id], block_rec[2], block_rec[3]];
		                            return caml_trampoline_cps_call2
		                                    (return$39,
		                                     [0,
		                                      [0, [0, block[1], [10, block_rec$0]]],
		                                      0,
		                                      [0, task_rec_id]],
		                                     cont);
		                           },
		                           cont);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (add_recurrent_task_from_block,
		                          time,
		                          parent,
		                          block_rec,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                function update_rec_task
		                (time, state, block, block_rec, task_rec_id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (get_task_recurrent,
		                          state,
		                          task_rec_id,
		                          function(param){
		                           if(! param)
		                            return caml_exact_trampoline_cps_call
		                                    (warn$2,
		                                     function(m, cont){
		                                      return caml_trampoline_cps_call6
		      (m, 0, 0, aXJ, pp$72, task_rec_id, cont);
		                                     },
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$2
		      (add_rec_task, time, 0, block, block_rec, cont);
		                                     });
		                           var task_rec = param[1], x = task_rec[5][1];
		                           function c(b){
		                            function a(b){
		                             function a(op, cont){
		                              return caml_trampoline_cps_call3
		                                      (symbol_map,
		                                       op,
		                                       function(param, cont){return cont(aXI);},
		                                       cont);
		                             }
		                             return caml_exact_trampoline_cps_call$1
		                                     (update_recurrent_task_from_blo,
		                                      block_rec,
		                                      task_rec,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                      });
		                            }
		                            return 1 - b
		                                    ? caml_exact_trampoline_cps_call
		                                      (err$1,
		                                       function(m, cont){
		return caml_trampoline_cps_call4(m, 0, 0, aXH, cont);
		                                       },
		                                       a)
		                                    : a();
		                           }
		                           if(x){
		                            if(parent){
		                             var b = parent[1], a = x[1];
		                             return caml_exact_trampoline_cps_call$1(equal$104, a, b, c);
		                            }
		                           }
		                           else if(! parent) return c(1);
		                           return c(0);
		                          });
		                }
		                function on_removed(block, cont){
		                 var a = block[2];
		                 if(typeof a !== "number")
		                  switch(a[0]){
		                    case 10:
		                     a = a[1][1];
		                     if(a){
		                      var task_rec_id = a[1];
		                      return caml_exact_trampoline_cps_call$2
		                              (stop_recurrent_task, date, state, time, task_rec_id, cont);
		                     }
		                     break;
		                    case 11:
		                     a = a[1][3];
		                     if(a){
		                      var task_id = a[1];
		                      return caml_exact_trampoline_cps_call$2
		                              (remove_task, date, state, time, task_id, cont);
		                     }
		                     break;
		                  }
		                 return cont(0);
		                }
		                function on_added(block, cont){
		                 var a = block[2];
		                 if(typeof a !== "number")
		                  switch(a[0]){
		                    case 10:
		                     var block_rec = a[1], a = block_rec[1];
		                     if(! a)
		                      return caml_exact_trampoline_cps_call$2
		                              (add_rec_task, time, parent, block, block_rec, cont);
		                     var task_rec_id = a[1];
		                     return caml_exact_trampoline_cps_call$3
		                             (update_rec_task,
		                              time,
		                              state,
		                              block,
		                              block_rec,
		                              task_rec_id,
		                              cont);
		                    case 11:
		                     var todo = a[1], a = todo[3];
		                     if(! a)
		                      return caml_exact_trampoline_cps_call$2
		                              (add_task, time, parent, block, todo, cont);
		                     var task_id = a[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (get_task,
		                              state,
		                              task_id,
		                              function(param){
		                               if(! param)
		                                return caml_exact_trampoline_cps_call
		(warn$2,
		 function(m, cont){
		  return caml_trampoline_cps_call6
		          (m, 0, 0, aXG, _16$0, task_id, cont);
		 },
		 function(match){
		  return caml_exact_trampoline_cps_call$2
		          (add_task, time, 0, block, todo, cont);
		 });
		                               var task = param[1], x = task[7][6];
		                               function c(b){
		                                function a(b){
		                                 function a(op, cont){
		                                  return caml_trampoline_cps_call3
		  (symbol_map,
		   op,
		   function(param, cont){return cont(aXF);},
		   cont);
		                                 }
		                                 return caml_exact_trampoline_cps_call$0
		 (update_task_from_todo,
		  time,
		  todo,
		  task,
		  function(b){
		   return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		  });
		                                }
		                                return 1 - b
		? caml_exact_trampoline_cps_call
		  (err$1,
		   function(m, cont){
		    return caml_trampoline_cps_call4(m, 0, 0, aXE, cont);
		   },
		   a)
		: a();
		                               }
		                               if(x){
		                                if(parent){
		                                 var b = parent[1], a = x[1];
		                                 return caml_exact_trampoline_cps_call$1(equal$104, a, b, c);
		                                }
		                               }
		                               else if(! parent) return c(1);
		                               return c(0);
		                              });
		                  }
		                 return cont(0);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (update_from_diff,
		                         function(a, cont){
		                          a = a[2];
		                          var variant = a[1];
		                          if(847852583 === variant){
		                           var block = a[2];
		                           return caml_exact_trampoline_cps_call
		                                   (on_removed,
		                                    block,
		                                    function(op){
		                                     function a(param, cont){return cont(aXK);}
		                                     return caml_trampoline_cps_call3
		     (map$17,
		      op,
		      function(b, cont){
		       return caml_trampoline_cps_call3(map$50, b, a, cont);
		      },
		      cont);
		                                    });
		                          }
		                          if(1013247643 <= variant){
		                           a = a[2];
		                           var block$0 = a[2], block_old = a[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (equal$74,
		                                    block_old,
		                                    block$0,
		                                    function(c){
		                                     if(c) return cont(0);
		                                     c = block_old[2];
		                                     var a = block$0[2];
		                                     function b(){
		                                      return caml_exact_trampoline_cps_call
		      (on_removed,
		       block_old,
		       function(op_rm){
		        return caml_exact_trampoline_cps_call
		                (on_added,
		                 block$0,
		                 function(op_add){
		                  if(op_rm){
		                   var op_rm$0 = op_rm[1];
		                   if(! op_add)
		                    return caml_trampoline_cps_call3
		                            (let$0,
		                             op_rm$0,
		                             function(param, cont){return cont(aXL);},
		                             function(a){return cont([0, a]);});
		                   var op_add$0 = op_add[1];
		                   return caml_trampoline_cps_call3
		                           (let$1,
		                            op_rm$0,
		                            function(param, cont){return cont(op_add$0);},
		                            function(a){return cont([0, a]);});
		                  }
		                  if(! op_add) return cont(0);
		                  var op_add$1 = op_add[1];
		                  return cont([0, op_add$1]);
		                 });
		       });
		                                     }
		                                     if(typeof c === "number") return b();
		                                     switch(c[0]){
		                                       case 10:
		c = c[1][1];
		if(! c) return b();
		if(typeof a === "number") return b();
		if(10 !== a[0]) return b();
		a = a[1][1];
		if(! a) return b();
		var task_id = a[1], task_id_old = c[1];
		return caml_exact_trampoline_cps_call$1
		        (symbol$152,
		         task_id_old,
		         task_id,
		         function(a){
		          return a
		                  ? caml_exact_trampoline_cps_call(on_added, block$0, cont)
		                  : b();
		         });
		                                       case 11:
		c = c[1][3];
		if(! c) return b();
		if(typeof a === "number") return b();
		if(11 !== a[0]) return b();
		a = a[1][3];
		if(! a) return b();
		var task_id$0 = a[1], task_id_old$0 = c[1];
		return caml_exact_trampoline_cps_call$1
		        (symbol$121,
		         task_id_old$0,
		         task_id$0,
		         function(a){
		          return a
		                  ? caml_exact_trampoline_cps_call(on_added, block$0, cont)
		                  : b();
		         });
		                                       default: return b();
		                                     }
		                                    });
		                          }
		                          var block$1 = a[2];
		                          return caml_exact_trampoline_cps_call
		                                  (on_added, block$1, cont);
		                         },
		                         previous,
		                         notes,
		                         function(match){
		                          var sub_ops = match[2], doc_op = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (filter_opt,
		                                   sub_ops,
		                                   function(ops){
		                                    return ops
		    ? caml_trampoline_cps_call2
		      (return$30,
		       0,
		       function(b){
		        var doc_op$0 = value$4(doc_op, b);
		        return caml_exact_trampoline_cps_call
		                (all$24,
		                 ops,
		                 function(sub_op){
		                  function set_kind(bl, cont){
		                   var content = bl[2];
		                   return caml_exact_trampoline_cps_call
		                           (set$11,
		                            with_text(bOE, content),
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (kind,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (Blocks[16],
		        bl[1],
		        function(b){
		         return caml_trampoline_cps_call2
		                 (b,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call(blocks, a, cont);
		                  });
		        });
		                                      });
		                            });
		                  }
		                  function b(param, cont){
		                   return caml_trampoline_cps_call3
		                           (let$2,
		                            sub_op,
		                            function(list, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (of_rev_keys,
		                                      list,
		                                      function(list){
		                                       function a(list, blocks, task_ids, task_rec_ids){
		if(! list)
		 return caml_exact_trampoline_cps_call
		         (filter_opt,
		          task_ids,
		          function(task_ids){
		           return caml_exact_trampoline_cps_call
		                   (filter_opt,
		                    task_rec_ids,
		                    function(task_rec_ids){
		                     return caml_exact_trampoline_cps_call
		                             (filter_opt,
		                              blocks,
		                              function(bls){
		                               if(! bls)
		                                return caml_trampoline_cps_call2
		(return$39, [0, task_ids, task_rec_ids], cont);
		                               function a(param, cont){
		                                return caml_trampoline_cps_call2
		(return$39, [0, task_ids, task_rec_ids], cont);
		                               }
		                               return caml_trampoline_cps_call3
		                                       (map$18,
		bls,
		set_kind,
		function(b){
		 return caml_exact_trampoline_cps_call
		         (all_unit$1,
		          b,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (lift_document[1],
		                    b,
		                    function(b){
		                     return caml_trampoline_cps_call3(let$2, b, a, cont);
		                    });
		          });
		});
		                              });
		                    });
		          });
		var
		 list$0 = list[2],
		 match = list[1],
		 z = match[3],
		 y = match[2],
		 x = match[1],
		 l3 = [0, z, task_rec_ids],
		 l2 = [0, y, task_ids],
		 l1 = [0, x, blocks];
		return caml_exact_trampoline_call4(a, list$0, l1, l2, l3);
		                                       }
		                                       return a(list, 0, 0, 0);
		                                      });
		                            },
		                            cont);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (lift_document[1],
		                           doc_op$0,
		                           function(c){
		                            return caml_trampoline_cps_call3
		                                    (let$2, c, b, function(op){return a([0, op]);});
		                           });
		                 });
		       })
		    : caml_trampoline_cps_call3
		      (map$17,
		       doc_op,
		       function(op, cont){
		        function a(param, cont){return cont(aXM);}
		        return caml_exact_trampoline_cps_call
		                (lift_document[1],
		                 op,
		                 function(b){
		                  return caml_trampoline_cps_call3(symbol_map$0, b, a, cont);
		                 });
		       },
		       a);
		                                   });
		                         });
		               }
		               function update_event_notes_from_diff
		               (cascade, event_id, previous, notes, cont){
		                if(cascade)
		                 var
		                  a0 = cascade[1],
		                  state = a0[3],
		                  time = a0[2],
		                  date = a0[1],
		                  cascade$0 = [0, [0, date, time, [0, [0, event_id]], state]];
		                else
		                 cascade$0 = 0;
		                return caml_exact_trampoline_cps_call$2
		                        (update_notes_from_diff_ignore,
		                         [0,
		                          function(op, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (notes$0,
		                                    op,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$3,
		      event_id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(events, a, cont);
		                });
		      });
		                                    });
		                          }],
		                         cascade$0,
		                         previous,
		                         notes,
		                         cont);
		               }
		               function update_event_recurrent_notes_f
		               (cascade, event_id, previous, notes$0, cont){
		                if(cascade)
		                 var
		                  a0 = cascade[1],
		                  state = a0[3],
		                  time = a0[2],
		                  date = a0[1],
		                  cascade$0 = [0, [0, date, time, [0, [1, event_id]], state]];
		                else
		                 cascade$0 = 0;
		                return caml_exact_trampoline_cps_call$2
		                        (update_notes_from_diff_ignore,
		                         [0,
		                          function(op, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (notes,
		                                    op,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (writable,
		      a,
		      function(a){
		       return caml_trampoline_cps_call2
		               (element$5,
		                event_id,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (events_recurrent, a, cont);
		                          });
		                });
		      });
		                                    });
		                          }],
		                         cascade$0,
		                         previous,
		                         notes$0,
		                         cont);
		               }
		               function update_page_notes_from_diff
		               (cascade, page_id, previous, notes, cont){
		                if(cascade)
		                 var
		                  a0 = cascade[1],
		                  state = a0[3],
		                  time = a0[2],
		                  date = a0[1],
		                  cascade$0 = [0, [0, date, time, [0, [2, page_id]], state]];
		                else
		                 cascade$0 = 0;
		                return caml_exact_trampoline_cps_call$2
		                        (update_notes_from_diff_ignore,
		                         [0,
		                          function(op, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (notes$1,
		                                    op,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$13,
		      page_id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(pages, a, cont);
		                });
		      });
		                                    });
		                          }],
		                         cascade$0,
		                         previous,
		                         notes,
		                         cont);
		               }
		               function update_person_notes_from_diff
		               (cascade, people_id, previous, notes, cont){
		                if(cascade)
		                 var
		                  a0 = cascade[1],
		                  state = a0[3],
		                  time = a0[2],
		                  date = a0[1],
		                  cascade$0 = [0, [0, date, time, [0, [3, people_id]], state]];
		                else
		                 cascade$0 = 0;
		                return caml_exact_trampoline_cps_call$2
		                        (update_notes_from_diff_ignore,
		                         [0,
		                          function(op, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (notes$2,
		                                    op,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$14,
		      people_id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(people, a, cont);
		                });
		      });
		                                    });
		                          }],
		                         cascade$0,
		                         previous,
		                         notes,
		                         cont);
		               }
		               function update_task_notes_from_diff
		               (cascade, task_id, previous, notes, cont){
		                if(cascade)
		                 var
		                  a0 = cascade[1],
		                  state = a0[3],
		                  time = a0[2],
		                  date = a0[1],
		                  cascade$0 = [0, [0, date, time, [0, [4, task_id]], state]];
		                else
		                 cascade$0 = 0;
		                return caml_exact_trampoline_cps_call$2
		                        (update_notes_from_diff_ignore,
		                         [0,
		                          function(op, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (notes$4,
		                                    op,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$22,
		      task_id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(tasks, a, cont);
		                });
		      });
		                                    });
		                          }],
		                         cascade$0,
		                         previous,
		                         notes,
		                         cont);
		               }
		               function update_recurrent_task_notes_fr
		               (cascade, task_rec_id, previous, notes, cont){
		                if(cascade)
		                 var
		                  a0 = cascade[1],
		                  state = a0[3],
		                  time = a0[2],
		                  date = a0[1],
		                  cascade$0 =
		                    [0, [0, date, time, [0, [5, task_rec_id]], state]];
		                else
		                 cascade$0 = 0;
		                return caml_exact_trampoline_cps_call$2
		                        (update_notes_from_diff_ignore,
		                         [0,
		                          function(op, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (notes$5,
		                                    op,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$16,
		      task_rec_id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(recurrences, a, cont);
		                });
		      });
		                                    });
		                          }],
		                         cascade$0,
		                         previous,
		                         notes,
		                         cont);
		               }
		               function find_parent_map_notes(state, parent, f, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                switch(parent[0]){
		                  case 0:
		                   var
		                    parent_event_id = parent[1],
		                    a =
		                      function(parent_event, cont){
		                       function a(doc_op, cont){
		                        function a(param, cont){
		                         return caml_exact_trampoline_cps_call
		                                 (notes$0,
		                                  doc_op,
		                                  function(a){
		                                   return caml_trampoline_cps_call2
		   (element$3,
		    parent_event_id,
		    function(b){
		     return caml_trampoline_cps_call2
		             (b,
		              a,
		              function(a){
		               return caml_exact_trampoline_cps_call(events, a, cont);
		              });
		    });
		                                  });
		                        }
		                        return caml_exact_trampoline_cps_call$1
		                                (force$1,
		                                 state,
		                                 parent_event_id,
		                                 function(b){
		                                  return caml_trampoline_cps_call3
		  (bind$30,
		   b,
		   a,
		   function(a){
		    return caml_exact_trampoline_cps_call
		            (ignore_m$11,
		             a,
		             function(a){
		              return caml_trampoline_cps_call2(return$9, a, cont);
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (f,
		                                parent_event[9][8],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get$14,
		                            state,
		                            parent_event_id,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$, b, a, cont);
		                            });
		                  case 1:
		                   var
		                    parent_id = parent[1],
		                    b =
		                      function(parent, cont){
		                       function a(doc_op, cont){
		                        return caml_exact_trampoline_cps_call
		                                (notes,
		                                 doc_op,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (writable,
		   a,
		   function(a){
		    return caml_trampoline_cps_call2
		            (element$5,
		             parent_id,
		             function(b){
		              return caml_trampoline_cps_call2
		                      (b,
		                       a,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (events_recurrent,
		                                 a,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (ignore_m$11,
		   a,
		   function(a){
		    return caml_trampoline_cps_call2(return$9, a, cont);
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (f,
		                                parent[7][8],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_event_recurrent,
		                            state,
		                            parent_id,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, b, cont);
		                            });
		                  case 2:
		                   var
		                    parent_page_id = parent[1],
		                    c =
		                      function(parent_page, cont){
		                       function a(doc_op, cont){
		                        return caml_exact_trampoline_cps_call
		                                (notes$1,
		                                 doc_op,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (element$13,
		   parent_page_id,
		   function(b){
		    return caml_trampoline_cps_call2
		            (b,
		             a,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (pages,
		                       a,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (ignore_m$11,
		                                 a,
		                                 function(a){
		                                  return caml_trampoline_cps_call2(return$9, a, cont);
		                                 });
		                       });
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (f,
		                                parent_page[3][2],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_page,
		                            state,
		                            parent_page_id,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, c, cont);
		                            });
		                  case 3:
		                   var
		                    parent_person_id = parent[1],
		                    d =
		                      function(parent_person, cont){
		                       function a(doc_op, cont){
		                        return caml_exact_trampoline_cps_call
		                                (notes$2,
		                                 doc_op,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (element$14,
		   parent_person_id,
		   function(b){
		    return caml_trampoline_cps_call2
		            (b,
		             a,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (people,
		                       a,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (ignore_m$11,
		                                 a,
		                                 function(a){
		                                  return caml_trampoline_cps_call2(return$9, a, cont);
		                                 });
		                       });
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (f,
		                                parent_person[11][1],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_person,
		                            state,
		                            parent_person_id,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, d, cont);
		                            });
		                  case 4:
		                   var
		                    parent_task_id = parent[1],
		                    e =
		                      function(parent_task, cont){
		                       function a(doc_op, cont){
		                        return caml_exact_trampoline_cps_call
		                                (notes$4,
		                                 doc_op,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (element$23,
		   parent_task_id,
		   function(b){
		    return caml_trampoline_cps_call2
		            (b,
		             a,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (tasks,
		                       a,
		                       function(a){
		                        return caml_trampoline_cps_call2(return$9, a, cont);
		                       });
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (f,
		                                parent_task[7][9][1],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task,
		                            state,
		                            parent_task_id,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, e, cont);
		                            });
		                  case 5:
		                   var
		                    parent_task_rec_id = parent[1],
		                    h =
		                      function(parent_task_rec, cont){
		                       function a(doc_op, cont){
		                        return caml_exact_trampoline_cps_call
		                                (notes$5,
		                                 doc_op,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (element$17,
		   parent_task_rec_id,
		   function(b){
		    return caml_trampoline_cps_call2
		            (b,
		             a,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (recurrences,
		                       a,
		                       function(a){
		                        return caml_trampoline_cps_call2(return$9, a, cont);
		                       });
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (f,
		                                parent_task_rec[5][3][1],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task_recurrent,
		                            state,
		                            parent_task_rec_id,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, h, cont);
		                            });
		                  default: return cont(0);
		                }
		               }
		               function find_task_block_map(doc, f, task_id, cont){
		                var t = doc[1];
		                function a(i, t){
		                 if(! t) return cont(0);
		                 var l = t[2], x = t[1], b = x[2];
		                 function d(result){
		                  if(result) return cont(result);
		                  var i$0 = i + 1 | 0;
		                  return caml_exact_trampoline_call2(a, i$0, l);
		                 }
		                 function c(){return d(0);}
		                 if(typeof b === "number") return c();
		                 if(11 !== b[0]) return c();
		                 var todo = b[1], b = todo[3];
		                 if(! b) return c();
		                 var block_task_id = b[1], block_id = x[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$121,
		                          block_task_id,
		                          task_id,
		                          function(a){
		                           return a
		                                   ? caml_exact_trampoline_cps_call$0
		                                     (f, i, block_id, todo, function(a){return d([0, a]);})
		                                   : c();
		                          });
		                }
		                return a(0, t);
		               }
		               function update_todo_block_from_task
		               (checked, title, block_id, todo_block, cont){
		                var prev_title = todo_block[2], prev_checked = todo_block[1];
		                function f(title, cont){
		                 function f(param, cont){
		                  function f(op, cont){
		                   return caml_exact_trampoline_cps_call
		                           (text$1,
		                            op,
		                            function(a){
		                             return caml_trampoline_cps_call2(return$9, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (diff$1,
		                           prev_title,
		                           title,
		                           function(x){
		                            return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                           });
		                 }
		                 var x = some_if(prev_title !== title ? 1 : 0, 0);
		                 return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                }
		                return caml_trampoline_cps_call3
		                        (bind$8,
		                         title,
		                         f,
		                         function(text_op_o){
		                          function f(checked, cont){
		                           var
		                            new_todo = [11, [0, checked, todo_block[2], todo_block[3]]];
		                           return caml_exact_trampoline_cps_call
		                                   (set$11,
		                                    with_text(bOE, new_todo),
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (kind,
		      a,
		      function(a){
		       return cont(some_if(1 - (prev_checked === checked), a));
		      });
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   checked,
		                                   f,
		                                   function(kind_op_o){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0, kind_op_o, [0, text_op_o, 0]],
		     function(l){
		      return l
		              ? caml_exact_trampoline_cps_call
		                (all_unit$4,
		                 l,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (Blocks[16],
		                           block_id,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (blocks, a, function(a){return cont([0, a]);});
		                                     });
		                           });
		                 })
		              : cont(0);
		     });
		                                   });
		                         });
		               }
		               function remove_parent_block(state, parent, task_id, cont){
		                function doc_op(doc, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (find_task_block_map,
		                          doc,
		                          function(i, block_id, param, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (remove_block, i, block_id, cont);
		                          },
		                          task_id,
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (find_parent_map_notes, state, parent, doc_op, cont);
		               }
		               function append_parent_block
		               (state, checked, parent, title, task_id, cont){
		                function doc_op(doc, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (find_task_block_map,
		                          doc,
		                          function(param, block_id, todo_block, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (update_todo_block_from_task,
		                                    [0, checked],
		                                    [0, title],
		                                    block_id,
		                                    todo_block,
		                                    cont);
		                          },
		                          task_id,
		                          function(upd_op){
		                           if(! upd_op)
		                            return caml_exact_trampoline_cps_call$1
		                                    (insert_block,
		                                     -1,
		                                     [11, [0, checked, title, [0, task_id]]],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (ignore_m$0,
		       a,
		       function(a){
		        return caml_trampoline_cps_call2(return$9, a, cont);
		       });
		                                     });
		                           var upd_op$0 = upd_op[1];
		                           return caml_exact_trampoline_cps_call
		                                   (err$1,
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call4(m, 0, 0, aXO, cont);
		                                    },
		                                    function(match){return cont(upd_op$0);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (find_parent_map_notes, state, parent, doc_op, cont);
		               }
		               function update_parent_doc_from_patch
		               (state, task_before, patch, task_id, cont){
		                function new_title(param){
		                 var init = task_before[7][9][2], t = patch[9][2];
		                 if(! t) return init;
		                 var title = t[1];
		                 return title;
		                }
		                function new_checked(param){
		                 var init = task_before[7][2], t = patch[2];
		                 if(t)
		                  var completed$0 = t[1], completed = completed$0;
		                 else
		                  completed = init;
		                 return is_some(completed);
		                }
		                var b = task_before[7][6], a = patch[6];
		                if(b){
		                 var parent = b[1];
		                 if(! a){
		                  var
		                   f$0 =
		                     function(completed, cont){return cont(is_some(completed));},
		                   x = patch[2];
		                  return caml_trampoline_cps_call3
		                          (map$17,
		                           x,
		                           f$0,
		                           function(checked){
		                            var title = patch[9][2];
		                            function doc_op(doc, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (find_task_block_map,
		                                      doc,
		                                      function(param, block_id, todo_block, cont){
		                                       return caml_exact_trampoline_cps_call$2
		       (update_todo_block_from_task,
		        checked,
		        title,
		        block_id,
		        todo_block,
		        cont);
		                                      },
		                                      task_id,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(join$2, a, cont);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$0
		                                    (find_parent_map_notes, state, parent, doc_op, cont);
		                           });
		                 }
		                 a = a[1];
		                 if(! a)
		                  return caml_exact_trampoline_cps_call$0
		                          (remove_parent_block, state, parent, task_id, cont);
		                 var
		                  new_parent = a[1],
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$22,
		                       symbol_map$20,
		                       ,
		                       bind$30,
		                       return$39,
		                       map$50,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$14]),
		                  let$ = open[3],
		                  title = new_title(),
		                  checked = new_checked(),
		                  f =
		                    function(rm_op, cont){
		                     function f(app_op, cont){
		                      return caml_trampoline_cps_call3
		                              (let$,
		                               rm_op,
		                               function(param, cont){return cont(app_op);},
		                               function(op){
		                                return caml_trampoline_cps_call2(return$9, op, cont);
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$3
		                             (append_parent_block,
		                              state,
		                              checked,
		                              new_parent,
		                              title,
		                              task_id,
		                              function(x){
		                               return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                              });
		                    };
		                 return caml_exact_trampoline_cps_call$0
		                         (remove_parent_block,
		                          state,
		                          parent,
		                          task_id,
		                          function(x){
		                           return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                          });
		                }
		                if(a){
		                 a = a[1];
		                 if(a){
		                  var
		                   parent$0 = a[1],
		                   title$0 = new_title(),
		                   checked$0 = new_checked();
		                  return caml_exact_trampoline_cps_call$3
		                          (append_parent_block,
		                           state,
		                           checked$0,
		                           parent$0,
		                           title$0,
		                           task_id,
		                           cont);
		                 }
		                }
		                return cont(0);
		               }
		               function update_from_patch_cas
		               (cascade, patch, task_before, cont){
		                var task_id = task_before[6];
		                function f(title, cont){
		                 var title_before = task_before[7][9][2];
		                 function f(param, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (diff$1, title_before, title, cont);
		                 }
		                 var x = some_if(title_before !== title ? 1 : 0, 0);
		                 return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                }
		                var x = patch[9][2];
		                return caml_trampoline_cps_call3
		                        (bind$8,
		                         x,
		                         f,
		                         function(title){
		                          function f(url, cont){
		                           var url_before = task_before[7][9][3];
		                           function f(param, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (diff$2, url_before, url, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_option,
		                                    equal$44,
		                                    url_before,
		                                    url,
		                                    function(a){
		                                     var x = some_if(1 - a, 0);
		                                     return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                                    });
		                          }
		                          var x = patch[9][3];
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   x,
		                                   f,
		                                   function(url){
		                                    var a = patch[1], match = patch[2];
		                                    if(a){
		                                     var archived = a[1];
		                                     if(match)
		                                      var
		                                       completed = match[1],
		                                       status = [0, make$112(completed, archived)];
		                                     else
		                                      status = [0, make$112(0, archived)];
		                                    }
		                                    else if(match)
		                                     var
		                                      completed$0 = match[1],
		                                      status = [0, make$112(completed$0, 0)];
		                                    else
		                                     status = 0;
		                                    function f(tasks_op, cont){
		                                     return caml_exact_trampoline_cps_call(tasks, tasks_op, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$4
		    (update$7,
		     patch[3],
		     patch[5],
		     patch[6],
		     patch[7],
		     patch[8],
		     status,
		     title,
		     url,
		     task_id,
		     function(x){
		      return caml_trampoline_cps_call3
		              (map$17,
		               x,
		               f,
		               function(tasks_op){
		                function f(notes, cont){
		                 var notes_before = task_before[7][9][1];
		                 return caml_exact_trampoline_cps_call$2
		                         (update_task_notes_from_diff,
		                          cascade,
		                          task_id,
		                          notes_before,
		                          notes,
		                          cont);
		                }
		                var x = patch[9][1];
		                return caml_trampoline_cps_call3
		                        (bind$8,
		                         x,
		                         f,
		                         function(notes_op){
		                          function f(param, cont){
		                           var state = param[3];
		                           return caml_exact_trampoline_cps_call$2
		                                   (update_parent_doc_from_patch,
		                                    state,
		                                    task_before,
		                                    patch,
		                                    task_id,
		                                    cont);
		                          }
		                          var x = to_option$6(cascade);
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   x,
		                                   f,
		                                   function(parent_doc_op){
		                                    var a = task_before[7][5];
		                                    function b(occurrence_spawn_op){
		                                     return caml_exact_trampoline_cps_call
		     (filter_opt,
		      [0,
		       tasks_op,
		       [0,
		        notes_op,
		        [0, parent_doc_op, [0, occurrence_spawn_op, 0]]]],
		      function(ops){
		       return ops
		               ? caml_exact_trampoline_cps_call
		                 (all_unit$27,
		                  ops,
		                  function(a){
		                   return caml_trampoline_cps_call2(return$9, a, cont);
		                  })
		               : cont(0);
		      });
		                                    }
		                                    if(a){
		                                     var occurrence = a[1];
		                                     if(status && typeof status[1] !== "number"){
		                                      var
		                                       f =
		 function(param, cont){
		  var state = param[3], time = param[2], date = param[1];
		  function f(task_rec, cont){
		   return caml_exact_trampoline_cps_call$3
		           (materialize_task_occurrences_u,
		            date,
		            occurrence[1],
		            state,
		            time,
		            task_rec,
		            cont);
		  }
		  return caml_exact_trampoline_cps_call$1
		          (get_task_recurrent,
		           state,
		           occurrence[2],
		           function(x){
		            return caml_trampoline_cps_call3(map$17, x, f, cont);
		           });
		 },
		                                       x = to_option$6(cascade);
		                                      return caml_trampoline_cps_call3(bind$8, x, f, b);
		                                     }
		                                    }
		                                    return b(0);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update_from_patch
		               (date, state, time, patch, task_id, cont){
		                function f(task, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (update_from_patch_cas,
		                          [0, [0, date, time, state]],
		                          patch,
		                          task,
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_task,
		                         state,
		                         task_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                         });
		               }
		               function get_agent(state, param, cont){
		                if(0 !== param[0]) return cont(state[1][2]);
		                var id = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[1][1], id, cont);
		               }
		               function all_agents(state, cont){
		                return caml_exact_trampoline_cps_call
		                        (encode,
		                         state[1][1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (append$0, to_list$0(state[1][2]), a, cont);
		                         });
		               }
		               function set_agent_automations(agent, automations, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(operation, cont){
		                 return caml_exact_trampoline_cps_call
		                         (v$10,
		                          [1, operation],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (agent_any,
		                                    agent[4],
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(ai$0, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (Automations[17],
		                         agent[2],
		                         automations,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function get$15(state, automation_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[1][4], automation_id, cont);
		               }
		               function add$33(agent, state, automation, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(agent_op){
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          agent_op,
		                          function(agent_op, cont){
		                           var a = to_list$0(agent_op);
		                           return caml_trampoline_cps_call3
		                                   (Ident$0[5][14],
		                                    automation[1],
		                                    automation,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (automations,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (ai$0,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (all_unit$27, [0, b, a], cont);
		                });
		      });
		                                    });
		                          },
		                          cont);
		                }
		                if(! agent)
		                 return caml_trampoline_cps_call2(of_string$14, 0, a);
		                var agent_id = agent[1];
		                function b(agent, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (append$0,
		                          agent[2],
		                          [0, automation[1], 0],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (set_agent_automations, agent, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_agent,
		                         state,
		                         agent_id,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$, of_option(c, [0, -166690436, agent_id]), b, a);
		                         });
		               }
		               function update$8
		               (name, enabled, trigger, state, automation_id, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(param, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3]),
		                  let$ = open[4];
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          name,
		                          function(name, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (String_opt_LWW[12],
		                                    name,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(v$11, [1, a], cont);
		                                    });
		                          },
		                          function(name){
		                           var
		                            open =
		                              g
		                               ([0,
		                                 symbol_bind$5,
		                                 symbol_map$5,
		                                 ,
		                                 bind$8,
		                                 return$9,
		                                 map$17,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$3]),
		                            let$ = open[4];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    enabled,
		                                    function(enabled, cont){
		                                     return caml_exact_trampoline_cps_call
		     (include$139[12],
		      enabled,
		      function(a){
		       return caml_exact_trampoline_cps_call(v$11, [3, a], cont);
		      });
		                                    },
		                                    function(enabled){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$5,
		   symbol_map$5,
		   ,
		   bind$8,
		   return$9,
		   map$17,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$3]),
		                                      let$ = open[4];
		                                     return caml_trampoline_cps_call3
		     (let$,
		      trigger,
		      function(trigger, cont){
		       return caml_exact_trampoline_cps_call
		               (Trigger[12],
		                trigger,
		                function(a){
		                 return caml_exact_trampoline_cps_call(v$11, [4, a], cont);
		                });
		      },
		      function(trigger){
		       return caml_exact_trampoline_cps_call
		               (filter_opt,
		                [0, name, [0, enabled, [0, trigger, 0]]],
		                function(operations){
		                 return caml_exact_trampoline_cps_call
		                         (all_unit$8,
		                          operations,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (Ident$0[5][16],
		                                    automation_id,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (automations,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(ai$0, a, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get$15,
		                         state,
		                         automation_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$, of_option(b, [0, 115765582, automation_id]), a, cont);
		                         });
		               }
		               function set_steps(automation, steps, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(operation, cont){
		                 return caml_exact_trampoline_cps_call
		                         (v$11,
		                          [2, operation],
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (Ident$0[5][16],
		                                    automation[1],
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (automations,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(ai$0, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (Steps[17],
		                         automation[3],
		                         steps,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function remove_cascading
		               (except_agent, state, automation_id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(param, cont){
		                 return caml_trampoline_cps_call2
		                         (Ident$0[5][18],
		                          automation_id,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (automations,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(ai$0, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         state[1][4],
		                         automation_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(automation_op){
		                                    return caml_exact_trampoline_cps_call$1
		    (to_alist$0,
		     0,
		     state[1][3],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$0,
		               a,
		               function(param, cont){
		                var run = param[2], run_id = param[1];
		                return caml_trampoline_cps_call2
		                        (Ident$0[3][18],
		                         run_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (automation_runs,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (ai$0,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (equal$171,
		               run[1],
		               automation_id,
		               function(b){return cont(some_if(b, a));});
		     });
		                                   });
		                         });
		               },
		               function(run_ops){
		                function a(agent, cont){
		                 function a(a){
		                  return a
		                          ? cont(0)
		                          : caml_exact_trampoline_cps_call$1
		                            (filter,
		                             agent[2],
		                             function(id, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (equal$171,
		                                       id,
		                                       automation_id,
		                                       function(a){return cont(1 - a);});
		                             },
		                             function(automations){
		                              return caml_exact_trampoline_cps_call$1
		                                      (set_agent_automations, agent, automations, cont);
		                             });
		                 }
		                 if(! except_agent) return a(0);
		                 var except_agent$0 = except_agent[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (equal$56, except_agent$0, agent[4], a);
		                }
		                return caml_exact_trampoline_cps_call
		                        (all_agents,
		                         state,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$0,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (append$0,
		     run_ops,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (append$0,
		               to_list$0(automation_op),
		               a,
		               function(operations){
		                return operations
		                        ? caml_exact_trampoline_cps_call
		                          (all_unit$27,
		                           operations,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$9, a, cont);
		                           })
		                        : cont(0);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function add$34(state, agent, conversation, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Conversations[13],
		                          conversation[4],
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (conversations,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (agent_any,
		      agent,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (ai$0,
		                a,
		                function(b){
		                 var a = [0, b, 0];
		                 return caml_trampoline_cps_call3
		                         (Ident$0[6][14],
		                          conversation[4],
		                          conversation,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (conversations$0,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (ai$0,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (all_unit$27, [0, b, a], cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_agent,
		                         state,
		                         agent,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$, of_option(b, [0, -166690436, agent]), a, cont);
		                         });
		               }
		               function update_context(state, conversation_id, context, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(conversation, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (set_context,
		                          conversation[2],
		                          context,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (Ident$0[6][16],
		                                    conversation_id,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (conversations$0,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(ai$0, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         state[1][6],
		                         conversation_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   of_option(b, [0, 362073082, conversation_id]),
		                                   a,
		                                   cont);
		                         });
		               }
		               function remove_cascading$0
		               (except_agent, state, conversation_id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(param, cont){
		                 return caml_trampoline_cps_call2
		                         (Ident$0[6][18],
		                          conversation_id,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (conversations$0,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(ai$0, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         state[1][6],
		                         conversation_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(conversation_op){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     state[1][6],
		     conversation_id,
		     function(a){
		      function b(){return c(0);}
		      function c(a){
		       return caml_exact_trampoline_cps_call$1
		               (append$0,
		                to_list$0(conversation_op),
		                a,
		                function(operations){
		                 return operations
		                         ? caml_exact_trampoline_cps_call
		                           (all_unit$27,
		                            operations,
		                            function(a){
		                             return caml_trampoline_cps_call2(return$9, a, cont);
		                            })
		                         : cont(0);
		                });
		      }
		      if(! a) return b();
		      a = a[1][1];
		      if(! a) return b();
		      var agent_id = a[1];
		      return caml_exact_trampoline_cps_call$0
		              (equal_option,
		               equal$56,
		               except_agent,
		               [0, agent_id],
		               function(a){
		                if(a) return b();
		                return caml_exact_trampoline_cps_call
		                        (Conversations[14],
		                         conversation_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (conversations,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (agent_any,
		     agent_id,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (ai$0, a, function(a){return c([0, a, 0]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update$9(state, param, agent_id, cont){
		                var
		                 working_memory = param[3],
		                 user_preferences = param[2],
		                 agent_instructions = param[1],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(agent, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3]),
		                  let$ = open[4];
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          agent_instructions,
		                          function(prompt, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (diff$6,
		                                    agent[1],
		                                    prompt,
		                                    function(op){
		                                     return caml_exact_trampoline_cps_call(v$10, [0, op], cont);
		                                    });
		                          },
		                          function(agent_instructions){
		                           var
		                            open =
		                              g
		                               ([0,
		                                 symbol_bind$5,
		                                 symbol_map$5,
		                                 ,
		                                 bind$8,
		                                 return$9,
		                                 map$17,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$3]),
		                            let$ = open[4];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    user_preferences,
		                                    function(prompt, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (diff$6,
		      agent[7],
		      prompt,
		      function(op){
		       return caml_exact_trampoline_cps_call(v$10, [6, op], cont);
		      });
		                                    },
		                                    function(user_preferences){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$5,
		   symbol_map$5,
		   ,
		   bind$8,
		   return$9,
		   map$17,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$3]),
		                                      let$ = open[4];
		                                     return caml_trampoline_cps_call3
		     (let$,
		      working_memory,
		      function(prompt, cont){
		       return caml_exact_trampoline_cps_call$1
		               (diff$6,
		                agent[8],
		                prompt,
		                function(op){
		                 return caml_exact_trampoline_cps_call(v$10, [7, op], cont);
		                });
		      },
		      function(working_memory){
		       return caml_exact_trampoline_cps_call
		               (filter_opt,
		                [0,
		                 agent_instructions,
		                 [0, user_preferences, [0, working_memory, 0]]],
		                function(operations){
		                 return caml_exact_trampoline_cps_call
		                         (all_unit$7,
		                          operations,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (agent_any,
		                                    agent[4],
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(ai$0, a, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_agent,
		                         state,
		                         agent_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$, of_option(b, [0, -166690436, agent_id]), a, cont);
		                         });
		               }
		               function remove$21(state, agent_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         state[1][1],
		                         agent_id,
		                         function(match){
		                          if(! match) return cont(0);
		                          var agent = match[1], agent_id_any = [0, agent_id];
		                          return caml_exact_trampoline_cps_call$0
		                                  (fold$5,
		                                   state[1][6],
		                                   agent[3],
		                                   function
		                                   (conversation_id, conversation, conversation_ids, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (equal_option,
		     equal$56,
		     conversation[1],
		     [0, agent_id_any],
		     function(a){
		      return a
		              ? caml_exact_trampoline_cps_call$1
		                (add$4, conversation_ids, conversation_id, cont)
		              : cont(conversation_ids);
		     });
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (to_list$3,
		     a,
		     function(conversation_ids){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$0,
		               agent[2],
		               function(automation_id, cont){
		                function a(t){
		                 function b(shared){
		                  return shared
		                          ? cont(0)
		                          : caml_exact_trampoline_cps_call$0
		                            (remove_cascading,
		                             [0, agent_id_any],
		                             state,
		                             automation_id,
		                             cont);
		                 }
		                 if(! t) return b(0);
		                 var xs = t[2], other_agent = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (equal$56,
		                          other_agent[4],
		                          agent_id_any,
		                          function(c){
		                           c = 1 - c;
		                           function d(c){
		                            return c ? b(1) : caml_exact_trampoline_call1(a, xs);
		                           }
		                           return c
		                                   ? caml_exact_trampoline_cps_call$0
		                                     (mem, other_agent[2], automation_id, equal$171, d)
		                                   : d(c);
		                          });
		                }
		                return caml_exact_trampoline_cps_call(all_agents, state, a);
		               },
		               function(automation_ops){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         conversation_ids,
		                         function(conversation_id, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (remove_cascading$0,
		                                   [0, agent_id_any],
		                                   state,
		                                   conversation_id,
		                                   cont);
		                         },
		                         function(conversation_ops){
		                          return caml_trampoline_cps_call2
		                                  (Ident$0[1][18],
		                                   agent_id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (agents,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (ai$0,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (append$0,
		                         [0, a, automation_ops],
		                         conversation_ops,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$27,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(return$9, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function set_status$1(run_id, status, cont){
		                return caml_exact_trampoline_cps_call
		                        (set_status,
		                         status,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (Ident$0[3][16],
		                                   run_id,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (automation_runs,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call(ai$0, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function add$35(automation, state, step, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(automation_op){
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          automation_op,
		                          function(automation_op, cont){
		                           var a = to_list$0(automation_op);
		                           return caml_trampoline_cps_call3
		                                   (Ident$0[4][14],
		                                    step[2],
		                                    step,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (steps,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (ai$0,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (all_unit$27, [0, b, a], cont);
		                });
		      });
		                                    });
		                          },
		                          cont);
		                }
		                if(! automation)
		                 return caml_trampoline_cps_call2(of_string$14, 0, a);
		                var automation_id = automation[1];
		                function b(automation, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (append$0,
		                          automation[3],
		                          [0, step[2], 0],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (set_steps, automation, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get$15,
		                         state,
		                         automation_id,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$, of_option(c, [0, 115765582, automation_id]), b, a);
		                         });
		               }
		               function update$10(state, param, step_id, cont){
		                var
		                 prompt = param[2],
		                 name = param[1],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(param, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3]),
		                  let$ = open[4];
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          name,
		                          function(name, cont){
		                           var v = [0, name];
		                           return caml_exact_trampoline_cps_call
		                                   (String_opt_LWW[12],
		                                    v,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(v$14, [2, a], cont);
		                                    });
		                          },
		                          function(name){
		                           var
		                            open =
		                              g
		                               ([0,
		                                 symbol_bind$5,
		                                 symbol_map$5,
		                                 ,
		                                 bind$8,
		                                 return$9,
		                                 map$17,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$3]),
		                            let$ = open[4];
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    prompt,
		                                    function(prompt, cont){
		                                     var v = [0, prompt];
		                                     return caml_exact_trampoline_cps_call
		     (Action[12],
		      v,
		      function(a){
		       return caml_exact_trampoline_cps_call(v$14, [0, a], cont);
		      });
		                                    },
		                                    function(prompt){
		                                     return caml_exact_trampoline_cps_call
		     (filter_opt,
		      [0, name, [0, prompt, 0]],
		      function(operations){
		       return caml_exact_trampoline_cps_call
		               (all_unit$10,
		                operations,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (Ident$0[4][16],
		                          step_id,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (steps,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call(ai$0, a, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         state[1][5],
		                         step_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$, of_option(b, [0, 800407811, step_id]), a, cont);
		                         });
		               }
		               function remove$22(state, step_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (exists$0,
		                         state[1][4],
		                         function(automation, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (mem,
		                                   automation[3],
		                                   step_id,
		                                   equal$168,
		                                   function(b){
		                                    function a(a){return cont(a);}
		                                    return b
		    ? caml_exact_trampoline_cps_call
		      (length$1,
		       automation[3],
		       function(b){return a(1 === b ? 1 : 0);})
		    : a(b);
		                                   });
		                         },
		                         function(would_empty_automation){
		                          if(would_empty_automation) return cont(aXR);
		                          function a(automation, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter,
		                                    automation[3],
		                                    function(id, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (equal$168, id, step_id, function(a){return cont(1 - a);});
		                                    },
		                                    function(steps){
		                                     return caml_exact_trampoline_cps_call$1
		     (set_steps, automation, steps, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   state[1][4],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (filter_map$0,
		     b,
		     a,
		     function(automation_ops){
		      return caml_trampoline_cps_call2
		              (Ident$0[4][18],
		               step_id,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (steps,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (ai$0,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (all_unit$27,
		     [0, a, automation_ops],
		     function(a){
		      return caml_trampoline_cps_call2(of_string$14, a, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function add_from_writable
		               (cascade,
		                id,
		                calendar_status,
		                creator,
		                draft,
		                google_calendar_id,
		                google_event_id,
		                link,
		                type,
		                param,
		                cont){
		                var
		                 title = param[11],
		                 time = param[10],
		                 task = param[9],
		                 notes = param[8],
		                 location = param[7],
		                 extension_row = param[6],
		                 description = param[5],
		                 availability_override = param[4],
		                 attendees = param[3],
		                 attendance = param[2],
		                 archived = param[1],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$22,
		                      symbol_map$20,
		                      ,
		                      bind$30,
		                      return$39,
		                      map$50,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$14]),
		                 let$ = open[3],
		                 open$0 =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 and = open$0[6],
		                 let$0 = open$0[4],
		                 let$1 = open$0[3];
		                function a(cascade, cont){
		                 var left = to_option$6(cascade);
		                 function a(a, cont){
		                  var task = a[2], a = a[1], notes = a[2], created = a[1];
		                  return cont([0, created, notes, task]);
		                 }
		                 return caml_trampoline_cps_call2
		                         (return$9,
		                          notes,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (and,
		                                    left,
		                                    b,
		                                    function(left){
		                                     return caml_trampoline_cps_call2
		     (return$9,
		      task,
		      function(b){
		       return caml_trampoline_cps_call3
		               (and,
		                left,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(let$0, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (return$9,
		                         cascade,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$1,
		                                   b,
		                                   a,
		                                   function(created_notes_task){
		                                    return caml_trampoline_cps_call3
		    (map$17,
		     created_notes_task,
		     function(param, cont){
		      var task = param[3];
		      return cont(task);
		     },
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (join$2,
		               a,
		               function(task){
		                function c(event_id, cont){
		                 function b(a, cont){
		                  function c(param, cont){
		                   var sub_rec_task_ids = param[2], sub_task_ids = param[1];
		                   return caml_trampoline_cps_call2
		                           (return$39,
		                            [0, event_id, sub_task_ids, sub_rec_task_ids],
		                            cont);
		                  }
		                  function b(a){
		                   return caml_trampoline_cps_call3(let$, a, c, cont);
		                  }
		                  if(! created_notes_task)
		                   return caml_trampoline_cps_call2(return$39, aXS, b);
		                  a = created_notes_task[1];
		                  var notes = a[2], created = a[1];
		                  function d(param, cont){
		                   var
		                    sub_rec_task_ids = param[3],
		                    sub_task_ids = param[2],
		                    updated_notes = param[1];
		                   function a(param, cont){
		                    return caml_trampoline_cps_call2
		                            (return$39, [0, sub_task_ids, sub_rec_task_ids], cont);
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (insert_blocks,
		                            -1,
		                            updated_notes[1],
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (notes$0,
		                                      b,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (ignore_m$6,
		        b,
		        function(add_notes_op){
		         return caml_trampoline_cps_call3
		                 (element$3,
		                  event_id,
		                  add_notes_op,
		                  function(b){
		                   return caml_trampoline_cps_call2
		                           (Operation$6[11],
		                            b,
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (events,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call3(let$, b, a, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (add_referenced_subtasks,
		                           created,
		                           [0, [0, event_id]],
		                           notes,
		                           function(a){
		                            return caml_trampoline_cps_call3(let$, a, d, b);
		                           });
		                 }
		                 function a(a){
		                  return caml_trampoline_cps_call3(let$, a, b, cont);
		                 }
		                 if(! task)
		                  return caml_trampoline_cps_call2(return$39, 0, a);
		                 var task_id = task[1];
		                 return caml_exact_trampoline_cps_call
		                         (add$26,
		                          event_id,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (allocations,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (element$23,
		      task_id,
		      function(c){
		       return caml_trampoline_cps_call2
		               (c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call(tasks, b, a);
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 id$0 = id ? id[1] : make$28(),
		                 open =
		                   g
		                    ([0,
		                      Operation$6[4],
		                      Operation$6[5],
		                      ,
		                      Operation$6[7],
		                      Operation$6[8],
		                      Operation$6[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$6[12]]),
		                 let$0 = open[3];
		                function a(param, cont){
		                 return caml_trampoline_cps_call2(Operation$6[8], id$0, cont);
		                }
		                var
		                 b =
		                   of_creation
		                    (calendar_status,
		                     creator,
		                     google_event_id,
		                     link,
		                     type,
		                     id$0,
		                     [0,
		                      google_calendar_id,
		                      draft,
		                      make$47
		                       (archived,
		                        attendance,
		                        [0, attendees],
		                        availability_override,
		                        description,
		                        extension_row,
		                        location,
		                        0,
		                        task,
		                        time,
		                        value$4([0, title], cst$1))]);
		                return caml_trampoline_cps_call2
		                        (add$19,
		                         id$0,
		                         function(d){
		                          return caml_trampoline_cps_call2
		                                  (d,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$0,
		     b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (events,
		               a,
		               function(a){
		                return caml_trampoline_cps_call3(let$, a, c, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function upsert$0(cascade, state, event, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_event,
		                         state,
		                         event[6],
		                         function(match){
		                          if(match){
		                           var previous = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$106,
		                                    previous[6],
		                                    event[6],
		                                    function(b){
		                                     function a(upd_op){
		                                      if(0 === upd_op[0]){var op = upd_op[1]; return cont(op);}
		                                      var raise = caml_pop_trap();
		                                      return raise
		      (caml_maybe_attach_backtrace([0, Assert_failure, aXT], 1));
		                                     }
		                                     return b
		     ? a([1, [0, 1013247643, [0, previous[6], event[6]]]])
		     : caml_exact_trampoline_cps_call$1
		       (diff$0,
		        previous[9],
		        event[9],
		        function(patch){
		         var
		          event$0 = previous[9],
		          title = patch[11],
		          time = patch[10],
		          task = patch[9],
		          location = patch[7],
		          extension_row = patch[6],
		          description = patch[5],
		          availability_override = patch[4],
		          attendees = patch[3],
		          attendance = patch[2],
		          archived = patch[1],
		          open =
		            g
		             ([0,
		               symbol_bind$5,
		               symbol_map$5,
		               ,
		               bind$8,
		               return$9,
		               map$17,
		               ,
		               ,
		               ,
		               ,
		               Let_syntax$3]),
		          let$ = open[4],
		          let$0 = open[3];
		         return caml_trampoline_cps_call3
		                 (let$,
		                  attendees,
		                  function(attendees, cont){
		                   var previous = event$0[3];
		                   return caml_trampoline_cps_call3
		                           (diff$7, previous, attendees, cont);
		                  },
		                  function(attendees){
		                   return caml_trampoline_cps_call3
		                           (let$,
		                            description,
		                            function(descr, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (diff$3, event$0[5], descr, cont);
		                            },
		                            function(description){
		                             return caml_trampoline_cps_call3
		                                     (let$,
		                                      location,
		                                      function(loc, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (diff$3, event$0[7], loc, cont);
		                                      },
		                                      function(location){
		                                       return caml_trampoline_cps_call3
		       (let$0,
		        title,
		        function(title, cont){
		         return caml_exact_trampoline_cps_call$1
		                 (diff$1, event$0[11], title, cont);
		        },
		        function(title){
		         function r(a){return a;}
		         return caml_exact_trampoline_cps_call$10
		                 (update$2,
		                  archived,
		                  attendance,
		                  attendees,
		                  availability_override,
		                  0,
		                  0,
		                  description,
		                  0,
		                  extension_row,
		                  0,
		                  0,
		                  0,
		                  location,
		                  r(task),
		                  time,
		                  title,
		                  0,
		                  dummy,
		                  function(patch_op){
		                   var
		                    notes = patch[8],
		                    previous$0 = previous[9][8],
		                    id = previous[6];
		                   function f(param, cont){
		                    var cascade = param[2], notes = param[1];
		                    function f(previous, cont){
		                     function f(notes, cont){
		                      return caml_exact_trampoline_cps_call$2
		                              (update_event_notes_from_diff,
		                               cascade,
		                               id,
		                               previous,
		                               notes,
		                               cont);
		                     }
		                     return caml_trampoline_cps_call3(bind$8, notes, f, cont);
		                    }
		                    return caml_trampoline_cps_call2
		                            (return$9,
		                             previous$0,
		                             function(x){
		                              return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                             });
		                   }
		                   return caml_trampoline_cps_call2
		                           (return$9,
		                            [0, notes, cascade],
		                            function(x){
		                             return caml_trampoline_cps_call3
		                                     (bind$8,
		                                      x,
		                                      f,
		                                      function(notes_op){
		                                       var curr = event[2], prev = previous[2];
		                                       return caml_exact_trampoline_cps_call$0
		       (equal_option,
		        equal_calendar_status,
		        prev,
		        curr,
		        function(b){
		         var
		          calendar_status = some_if(1 - b, curr),
		          curr$0 = event[3],
		          prev = previous[3];
		         return caml_exact_trampoline_cps_call$0
		                 (equal_option,
		                  equal_creator,
		                  prev,
		                  curr$0,
		                  function(b){
		                   var
		                    creator = some_if(1 - b, curr$0),
		                    curr = event[5],
		                    prev = previous[5];
		                   a:
		                   {
		                    if(prev){
		                     if(curr){
		                      var x = curr[1], x$0 = prev[1], b = x$0 === x;
		                      break a;
		                     }
		                    }
		                    else if(! curr){b = 1; break a;}
		                    b = 0;
		                   }
		                   var
		                    google_event_id = some_if(1 - b, curr),
		                    curr$1 = event[7],
		                    prev$0 = previous[7];
		                   return caml_exact_trampoline_cps_call$0
		                           (equal_option,
		                            equal_link,
		                            prev$0,
		                            curr$1,
		                            function(b){
		                             var
		                              link = some_if(1 - b, curr$1),
		                              curr = event[8],
		                              prev = previous[8];
		                             return caml_exact_trampoline_cps_call$0
		                                     (equal_option,
		                                      equal$120,
		                                      prev,
		                                      curr,
		                                      function(b){
		                                       var type = some_if(1 - b, curr);
		                                       return caml_exact_trampoline_cps_call$10
		       (update$2,
		        0,
		        0,
		        0,
		        0,
		        calendar_status,
		        creator,
		        0,
		        0,
		        0,
		        0,
		        google_event_id,
		        link,
		        0,
		        0,
		        0,
		        0,
		        type,
		        dummy,
		        function(upd_op){
		         var b = [0, notes_op, 0];
		         return caml_exact_trampoline_cps_call
		                 (all_unit$14,
		                  [0, patch_op, [0, upd_op, 0]],
		                  function(c){
		                   return caml_trampoline_cps_call2
		                           (element$4,
		                            event[6],
		                            function(d){
		                             return caml_trampoline_cps_call2
		                                     (d,
		                                      c,
		                                      function(c){
		                                       return caml_exact_trampoline_cps_call
		       (events,
		        c,
		        function(c){
		         return caml_trampoline_cps_call2
		                 (return$9,
		                  c,
		                  function(c){
		                   return caml_exact_trampoline_cps_call
		                           (filter_opt,
		                            [0, c, b],
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (all_unit$27,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call2(of_string$14, b, a);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                    });
		                          }
		                          function r(param){
		                           if(! param) return 0;
		                           var a0 = param[1], time = a0[2];
		                           return [0, time];
		                          }
		                          var
		                           cascade$0 = r(cascade),
		                           writable = event[9],
		                           type = event[8],
		                           link = event[7],
		                           id = event[6],
		                           google_event_id = event[5],
		                           draft = event[4],
		                           creator = event[3],
		                           calendar_status = event[2],
		                           calendar = event[1];
		                          return caml_exact_trampoline_cps_call$5
		                                  (add_from_writable,
		                                   cascade$0,
		                                   [0, id],
		                                   calendar_status,
		                                   creator,
		                                   draft,
		                                   calendar,
		                                   google_event_id,
		                                   link,
		                                   type,
		                                   writable,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$11, a, cont);
		                                   });
		                         });
		               }
		               function add_from_writable$0
		               (id,
		                calendar_status,
		                created,
		                creator,
		                draft,
		                google_calendar_id,
		                google_event_id,
		                link,
		                type,
		                event_writable,
		                cont){
		                return caml_exact_trampoline_cps_call$5
		                        (add_from_writable,
		                         [0, created],
		                         id,
		                         calendar_status,
		                         creator,
		                         draft,
		                         google_calendar_id,
		                         google_event_id,
		                         link,
		                         type,
		                         event_writable,
		                         cont);
		               }
		               function upsert$1(date, state, time, event, cont){
		                var cascade = [0, [0, date, time, state]];
		                return caml_exact_trampoline_cps_call$0
		                        (upsert$0, cascade, state, event, cont);
		               }
		               function remove$23(date, state, time, event_id, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (remove_event,
		                         date,
		                         state,
		                         time,
		                         event_id,
		                         function(match){
		                          if(! match) return cont(0);
		                          var
		                           rm_op = match[1],
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$22,
		                                symbol_map$20,
		                                ,
		                                bind$30,
		                                return$39,
		                                map$50,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$14]),
		                           let$ = open[3];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   rm_op,
		                                   function(event, cont){
		                                    function f(task_id, cont){
		                                     return caml_exact_trampoline_cps_call
		     (remove$16,
		      event_id,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (allocations,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (element$23,
		                          task_id,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(tasks, a, cont);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var x = event[9][9];
		                                    return caml_trampoline_cps_call3
		    (map$17,
		     x,
		     f,
		     function(rm_from_allocs_op){
		      return caml_exact_trampoline_cps_call$1
		              (value_or_thunk, rm_from_allocs_op, return$39, cont);
		     });
		                                   },
		                                   function(rm_op){return cont([0, rm_op]);});
		                         });
		               }
		               function get_event_recurrent$0(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, state[6], id, cont);
		               }
		               function add$36(event, cont){
		                return caml_trampoline_cps_call3
		                        (add$20,
		                         event[5],
		                         event,
		                         function(operation){
		                          return caml_exact_trampoline_cps_call
		                                  (events_recurrent, operation, cont);
		                         });
		               }
		               function materialized_occurrences(state, id, cont){
		                function is_occurrence(a, cont){
		                 var
		                  occurrence = a[2],
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3]),
		                  let$ = open[3],
		                  t = occurrence[6];
		                 function b(param, cont){
		                  var
		                   date = param[2],
		                   recurrence = param[1],
		                   a = [0, occurrence, date];
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$159,
		                           recurrence,
		                           id,
		                           function(b){return cont(some_if(b, a));});
		                 }
		                 if(0 === t[0])
		                  a = 0;
		                 else
		                  var
		                   date_id = t[2],
		                   recurrence = t[1],
		                   a = [0, [0, recurrence, date_id]];
		                 return caml_trampoline_cps_call3(let$, a, b, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (to_sequence$2,
		                         0,
		                         0,
		                         0,
		                         state[5],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$1, a, is_occurrence, cont);
		                         });
		               }
		               function update$11(date, time, state, param, cont){
		                var patch = param[2], id = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         state[6],
		                         id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (err$1,
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call6
		     (m, 0, 0, aXX, pp$79, id, cont);
		                                    },
		                                    function(match){
		                                     return caml_trampoline_cps_call2(return$39, 0, cont);
		                                    });
		                          var event = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (debug$3,
		                                   function(m, cont){
		                                    return caml_trampoline_cps_call3
		    (encode$4,
		     schema$92,
		     patch,
		     function(a){
		      return caml_trampoline_cps_call6(m, 0, 0, aXU, _16, a, cont);
		     });
		                                   },
		                                   function(match){
		                                    var
		                                     open =
		                                       g
		([0,
		  symbol_bind$22,
		  symbol_map$20,
		  ,
		  bind$30,
		  return$39,
		  map$50,
		  ,
		  ,
		  ,
		  ,
		  Let_syntax$14]),
		                                     and = open[6],
		                                     let$ = open[4],
		                                     let$0 = open[3],
		                                     title$0 = patch[10],
		                                     recurrence$0 = patch[9],
		                                     notes$0 = patch[8],
		                                     location$0 = patch[7],
		                                     exceptions$0 = patch[6],
		                                     description$0 = patch[5],
		                                     daytime = patch[4],
		                                     availability_override = patch[3],
		                                     attendees$0 = patch[2],
		                                     attendance = patch[1];
		                                    function a(param, cont){return cont(0);}
		                                    function b(a, cont){
		                                     a = patch[8];
		                                     if(! a)
		                                      return caml_trampoline_cps_call2(return$39, 0, cont);
		                                     var notes = a[1];
		                                     return caml_exact_trampoline_cps_call$2
		     (update_event_recurrent_notes_f,
		      [0, [0, date, time, state]],
		      id,
		      event[7][8],
		      notes,
		      function(a){
		       return caml_trampoline_cps_call2
		               (return$39, 0, function(b){return cont(value$4(a, b));});
		      });
		                                    }
		                                    return caml_trampoline_cps_call3
		    (let$18,
		     attendance,
		     function(attendance, cont){
		      return caml_trampoline_cps_call3
		              (map$17,
		               attendance,
		               unwrap,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (set$15,
		                         a,
		                         function(op){
		                          return caml_exact_trampoline_cps_call
		                                  (v$19,
		                                   [0, op],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                                   });
		                         });
		               });
		     },
		     function(attendance){
		      return caml_trampoline_cps_call3
		              (let$18,
		               attendees$0,
		               function(attendees$0, cont){
		                return caml_trampoline_cps_call3
		                        (diff$7,
		                         event[7][2],
		                         attendees$0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (attendees,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                                   });
		                         });
		               },
		               function(attendees){
		                return caml_trampoline_cps_call3
		                        (let$18,
		                         availability_override,
		                         function(availability_override, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (set$16,
		                                   availability_override,
		                                   function(op){
		                                    return caml_exact_trampoline_cps_call
		    (v$19,
		     [2, op],
		     function(a){
		      return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		     });
		                                   });
		                         },
		                         function(availability_override){
		                          return caml_trampoline_cps_call3
		                                  (let$18,
		                                   daytime,
		                                   function(daytime, cont){
		                                    return caml_exact_trampoline_cps_call
		    (Daytime[12],
		     daytime,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (daytime$0,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		               });
		     });
		                                   },
		                                   function(daytime){
		                                    return caml_trampoline_cps_call3
		    (let$18,
		     description$0,
		     function(description$0, cont){
		      return caml_exact_trampoline_cps_call$1
		              (diff$3,
		               event[7][5],
		               description$0,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (description,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                         });
		               });
		     },
		     function(description){
		      return caml_trampoline_cps_call3
		              (let$18,
		               exceptions$0,
		               function(exceptions$0, cont){
		                return caml_trampoline_cps_call3
		                        (Exceptions$0[21],
		                         event[7][6],
		                         exceptions$0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (exceptions,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                                   });
		                         });
		               },
		               function(exceptions){
		                return caml_trampoline_cps_call3
		                        (let$18,
		                         location$0,
		                         function(location$0, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (diff$3,
		                                   event[7][7],
		                                   location$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (location,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		     });
		                                   });
		                         },
		                         function(location){
		                          return caml_trampoline_cps_call3
		                                  (let$17,
		                                   notes$0,
		                                   function(notes$0, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (update_from_diff,
		     function(param, cont){return cont(0);},
		     event[7][8],
		     notes$0,
		     function(match){
		      var operation = match[1];
		      return caml_trampoline_cps_call3
		              (let$18,
		               operation,
		               function(operation, cont){
		                return caml_exact_trampoline_cps_call
		                        (notes,
		                         operation,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                         });
		               },
		               cont);
		     });
		                                   },
		                                   function(notes){
		                                    return caml_trampoline_cps_call3
		    (let$18,
		     recurrence$0,
		     function(recurrence$0, cont){
		      return caml_exact_trampoline_cps_call
		              (Recurrence[12],
		               recurrence$0,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (recurrence,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                         });
		               });
		     },
		     function(recurrence){
		      return caml_trampoline_cps_call3
		              (let$17,
		               title$0,
		               function(title$0, cont){
		                function a(operation, cont){
		                 return caml_exact_trampoline_cps_call
		                         (title,
		                          operation,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (diff$1,
		                         event[7][10],
		                         title$0,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$18, b, a, cont);
		                         });
		               },
		               function(title){
		                return caml_exact_trampoline_cps_call
		                        (filter_opt,
		                         [0,
		                          attendance,
		                          [0,
		                           attendees,
		                           [0,
		                            availability_override,
		                            [0,
		                             daytime,
		                             [0,
		                              description,
		                              [0,
		                               exceptions,
		                               [0, location, [0, notes, [0, recurrence, [0, title, 0]]]]]]]]]],
		                         function(c){
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$12,
		                                   c,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (writable,
		     c,
		     function(c){
		      return caml_trampoline_cps_call2
		              (element$6,
		               event[5],
		               function(d){
		                return caml_trampoline_cps_call2
		                        (d,
		                         c,
		                         function(c){
		                          return caml_exact_trampoline_cps_call
		                                  (events_recurrent,
		                                   c,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (let$0,
		     c,
		     b,
		     function(left){
		      var
		       title = patch[10],
		       recurrence = patch[9],
		       location = patch[7],
		       exceptions = patch[6],
		       description = patch[5],
		       daytime = patch[4],
		       availability_override = patch[3],
		       attendees = patch[2],
		       attendance = patch[1],
		       new_exceptions = value$4(exceptions, event[7][6]),
		       new_recurrence = value$4(recurrence, event[7][9]);
		      function update_occurrence(param, cont){
		       var date_id = param[2], occurrence = param[1];
		       function drop(param, cont){
		        return caml_exact_trampoline_cps_call$2
		                (remove$23,
		                 date,
		                 state,
		                 time,
		                 occurrence[6],
		                 function(a){return cont([1, a]);});
		       }
		       return caml_exact_trampoline_cps_call$0
		               (has_occurrence,
		                new_exceptions,
		                new_recurrence,
		                date_id,
		                function(match){
		                 function a(v){
		                  if(0 !== v[0]){var v$0 = v[1]; return cont(v$0);}
		                  var date = v[1];
		                  function b(v$0){
		                   if(0 === v$0[0]){
		                    var
		                     time = v$0[1],
		                     open =
		                       g
		                        ([0,
		                          symbol_bind$5,
		                          symbol_map$5,
		                          ,
		                          bind$8,
		                          return$9,
		                          map$17,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Let_syntax$3]),
		                     let$ = open[4],
		                     let$0 = open[3];
		                    return caml_trampoline_cps_call3
		                            (let$,
		                             attendance,
		                             function(attendance, cont){
		                              return caml_trampoline_cps_call3
		                                      (let$,
		                                       attendance,
		                                       function(attendance, cont){return cont(attendance);},
		                                       cont);
		                             },
		                             function(attendance){
		                              return caml_trampoline_cps_call3
		                                      (let$,
		                                       attendees,
		                                       function(attendees, cont){
		return caml_trampoline_cps_call3
		        (diff$7, occurrence[9][3], attendees, cont);
		                                       },
		                                       function(attendees){
		return caml_trampoline_cps_call3
		        (let$,
		         description,
		         function(description, cont){
		          return caml_exact_trampoline_cps_call$1
		                  (diff$3, occurrence[9][5], description, cont);
		         },
		         function(description){
		          return caml_trampoline_cps_call3
		                  (let$,
		                   location,
		                   function(location, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (diff$3, occurrence[9][7], location, cont);
		                   },
		                   function(location){
		                    return caml_trampoline_cps_call3
		                            (let$0,
		                             title,
		                             function(title, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (diff$1, occurrence[9][11], title, cont);
		                             },
		                             function(title){
		                              return caml_exact_trampoline_cps_call$10
		                                      (update$2,
		                                       0,
		                                       attendance,
		                                       attendees,
		                                       availability_override,
		                                       0,
		                                       0,
		                                       description,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       location,
		                                       0,
		                                       time,
		                                       title,
		                                       0,
		                                       dummy,
		                                       function(a){
		return caml_trampoline_cps_call2
		        (element$4,
		         occurrence[6],
		         function(b){
		          return caml_trampoline_cps_call2
		                  (b,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (events,
		                             a,
		                             function(a){
		                              return caml_trampoline_cps_call2(return$9, a, cont);
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   }
		                   var v = v$0[1];
		                   return cont(v);
		                  }
		                  if(! daytime) return b(aXV);
		                  var daytime$1 = daytime[1];
		                  if(daytime$1){
		                   var
		                    match = daytime$1[1],
		                    timezone = match[3],
		                    duration = match[2],
		                    daytime$0 = match[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (to_time$2,
		                            timezone,
		                            date,
		                            daytime$0,
		                            function(match){
		                             if(0 !== match[0])
		                              return caml_exact_trampoline_cps_call(drop, dummy, b);
		                             var start = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$78,
		                                      start,
		                                      duration,
		                                      function(end){
		                                       var match = occurrence[9][10];
		                                       function a(time){return b([0, time]);}
		                                       return 2 === match[0]
		       ? caml_exact_trampoline_cps_call$1
		         (symbol$77,
		          match[1],
		          start,
		          function(c){
		           function b(){return a([0, [2, start, end]]);}
		           return c
		                   ? b()
		                   : caml_exact_trampoline_cps_call$1
		                     (symbol$77,
		                      match[2],
		                      end,
		                      function(c){return c ? b() : a(0);});
		          })
		       : a([0, [2, start, end]]);
		                                      });
		                            });
		                  }
		                  var match$0 = occurrence[9][10];
		                  function a(time){return b([0, time]);}
		                  function c(){return a(0);}
		                  switch(match$0[0]){
		                    case 0:
		                     var date$0 = match$0[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$84,
		                              date,
		                              date$0,
		                              function(b){return b ? a([0, [0, date]]) : c();});
		                    case 1:
		                     var start = match$0[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$84,
		                              date,
		                              start,
		                              function(b){return b ? a([0, [1, date, match$0[2]]]) : c();});
		                    default: return a([0, [0, date]]);
		                  }
		                 }
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (debug$3,
		                           function(m, cont){
		                            return caml_trampoline_cps_call6
		                                    (m, 0, 0, aXW, pp_v1$0, date_id, cont);
		                           },
		                           function(match){
		                            return caml_exact_trampoline_cps_call(drop, dummy, a);
		                           });
		                 var date = match[1];
		                 return a([0, date]);
		                });
		      }
		      return caml_exact_trampoline_cps_call$1
		              (materialized_occurrences,
		               state,
		               id,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$1,
		                         b,
		                         update_occurrence,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (to_binable,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (all_unit$27,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (and,
		               left,
		               b,
		               function(b){
		                return caml_trampoline_cps_call3(let$, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function upsert$2(date, state, time, event, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_event_recurrent,
		                         state,
		                         event[5],
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call(add$36, event, cont);
		                          var
		                           previous = match[1],
		                           event$0 = event[7],
		                           previous$0 = previous[7];
		                          function diff(eq, prev, curr, cont){
		                           return caml_trampoline_cps_call3
		                                   (eq,
		                                    prev,
		                                    curr,
		                                    function(a){return cont(some_if(1 - a, curr));});
		                          }
		                          var curr = event$0[1], prev = previous$0[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (equal_option,
		                                   equal$145,
		                                   prev,
		                                   curr,
		                                   function(c){
		                                    var
		                                     attendance = some_if(1 - c, curr),
		                                     a = event$0[2],
		                                     b = previous$0[2];
		                                    return caml_trampoline_cps_call2
		    (_3$10,
		     equal_attendee,
		     function(c){
		      return caml_exact_trampoline_cps_call$0
		              (diff,
		               c,
		               b,
		               a,
		               function(attendees$0){
		                var curr = event$0[3], prev = previous$0[3];
		                return caml_exact_trampoline_cps_call$0
		                        (equal_option,
		                         equal_availability,
		                         prev,
		                         curr,
		                         function(a){
		                          var
		                           availability_override = some_if(1 - a, curr),
		                           curr$0 = event$0[4],
		                           prev = previous$0[4];
		                          return caml_exact_trampoline_cps_call$0
		                                  (equal_option,
		                                   equal$142,
		                                   prev,
		                                   curr$0,
		                                   function(a){
		                                    var
		                                     daytime = some_if(1 - a, curr$0),
		                                     curr = event$0[5],
		                                     prev = previous$0[5];
		                                    a:
		                                    {
		                                     if(prev){
		                                      if(curr){
		                                       var x = curr[1], x$0 = prev[1], a = x$0 === x;
		                                       break a;
		                                      }
		                                     }
		                                     else if(! curr){a = 1; break a;}
		                                     a = 0;
		                                    }
		                                    var description$0 = some_if(1 - a, curr);
		                                    return caml_exact_trampoline_cps_call$0
		    (diff,
		     equal_exceptions,
		     previous$0[6],
		     event$0[6],
		     function(exceptions){
		      var curr = event$0[7], prev = previous$0[7];
		      a:
		      {
		       if(prev){
		        if(curr){
		         var x = curr[1], x$0 = prev[1], a = x$0 === x;
		         break a;
		        }
		       }
		       else if(! curr){a = 1; break a;}
		       a = 0;
		      }
		      var location$0 = some_if(1 - a, curr);
		      return caml_exact_trampoline_cps_call$0
		              (diff,
		               equal$75,
		               previous$0[8],
		               event$0[8],
		               function(notes){
		                return caml_exact_trampoline_cps_call$0
		                        (diff,
		                         equal$137,
		                         previous$0[9],
		                         event$0[9],
		                         function(recurrence$0){
		                          var
		                           curr = event$0[10],
		                           prev = previous$0[10],
		                           title$0 = some_if(1 - (prev === curr), curr),
		                           patch =
		                             [0,
		                              attendance,
		                              attendees$0,
		                              availability_override,
		                              daytime,
		                              description$0,
		                              exceptions,
		                              location$0,
		                              notes,
		                              recurrence$0,
		                              title$0];
		                          return caml_exact_trampoline_cps_call$2
		                                  (update$11,
		                                   date,
		                                   time,
		                                   state,
		                                   [0, event[5], patch],
		                                   function(patch_op){
		                                    var curr = event[2], prev = previous[2];
		                                    return caml_exact_trampoline_cps_call$0
		    (equal_option,
		     equal_creator,
		     prev,
		     curr,
		     function(a){
		      var
		       creator = some_if(1 - a, curr),
		       curr$0 = event[4],
		       prev = previous[4];
		      a:
		      {
		       if(prev){
		        if(curr$0){
		         var x = curr$0[1], x$0 = prev[1], a = x$0 === x;
		         break a;
		        }
		       }
		       else if(! curr$0){a = 1; break a;}
		       a = 0;
		      }
		      var
		       google_event_id = some_if(1 - a, curr$0),
		       curr$1 = event[6],
		       prev$0 = previous[6];
		      return caml_exact_trampoline_cps_call$0
		              (equal_option,
		               equal_link,
		               prev$0,
		               curr$1,
		               function(a){
		                var link = some_if(1 - a, curr$1);
		                return caml_trampoline_cps_call3
		                        (let$18,
		                         0,
		                         function(attendees$0, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attendees,
		                                   attendees$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                                   });
		                         },
		                         function(attendees){
		                          return caml_trampoline_cps_call3
		                                  (let$18,
		                                   0,
		                                   function(daytime, cont){
		                                    return caml_exact_trampoline_cps_call
		    (daytime$0,
		     daytime,
		     function(a){
		      return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		     });
		                                   },
		                                   function(daytime){
		                                    return caml_trampoline_cps_call3
		    (let$18,
		     0,
		     function(description$0, cont){
		      return caml_exact_trampoline_cps_call
		              (description,
		               description$0,
		               function(a){
		                return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		               });
		     },
		     function(description){
		      return caml_trampoline_cps_call3
		              (let$18,
		               0,
		               function(location$0, cont){
		                return caml_exact_trampoline_cps_call
		                        (location,
		                         location$0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                         });
		               },
		               function(location){
		                return caml_trampoline_cps_call3
		                        (let$18,
		                         0,
		                         function(recurrence$0, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (recurrence,
		                                   recurrence$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		                                   });
		                         },
		                         function(recurrence){
		                          return caml_trampoline_cps_call3
		                                  (let$18,
		                                   0,
		                                   function(title$0, cont){
		                                    return caml_exact_trampoline_cps_call
		    (title,
		     title$0,
		     function(a){
		      return caml_exact_trampoline_cps_call(ignore_m$5, a, cont);
		     });
		                                   },
		                                   function(title){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0,
		      attendees,
		      [0,
		       daytime,
		       [0,
		        description,
		        [0, location, [0, recurrence, [0, title, 0]]]]]],
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (all_unit$12,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (writable,
		                         a,
		                         function(writable){
		                          return caml_trampoline_cps_call3
		                                  (let$18,
		                                   creator,
		                                   function(creator, cont){
		                                    return caml_exact_trampoline_cps_call
		    (Creator[12],
		     creator,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$20, [0, a], cont);
		     });
		                                   },
		                                   function(creator){
		                                    return caml_trampoline_cps_call3
		    (let$18,
		     0,
		     function(draft, cont){
		      return caml_exact_trampoline_cps_call
		              (set_draft, draft, cont);
		     },
		     function(draft){
		      return caml_trampoline_cps_call3
		              (let$18,
		               0,
		               function(google_calendar_id, cont){
		                return caml_exact_trampoline_cps_call
		                        (set$17,
		                         google_calendar_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(v$20, [2, a], cont);
		                         });
		               },
		               function(google_calendar_id){
		                return caml_trampoline_cps_call3
		                        (let$18,
		                         google_event_id,
		                         function(google_event_id, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Google_event_id[12],
		                                   google_event_id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$20, [3, a], cont);
		                                   });
		                         },
		                         function(google_event_id){
		                          return caml_trampoline_cps_call3
		                                  (let$18,
		                                   link,
		                                   function(link, cont){
		                                    return caml_exact_trampoline_cps_call
		    (Link[12],
		     link,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$20, [4, a], cont);
		     });
		                                   },
		                                   function(link){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0,
		      creator,
		      [0,
		       draft,
		       [0,
		        google_calendar_id,
		        [0, google_event_id, [0, link, [0, [0, writable], 0]]]]]],
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (all_unit$13,
		               a,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (element$6,
		                         event[5],
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (events_recurrent,
		     a,
		     function(upd_op){
		      return caml_exact_trampoline_cps_call
		              (all_unit$27, [0, patch_op, [0, upd_op, 0]], cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function add_from_writable$1
		               (id,
		                calendar_status,
		                created,
		                creator,
		                draft,
		                google_calendar_id,
		                link,
		                type,
		                event_writable,
		                cont){
		                if(! id)
		                 return caml_exact_trampoline_cps_call$5
		                         (add_from_writable$0,
		                          id,
		                          calendar_status,
		                          created,
		                          creator,
		                          draft,
		                          google_calendar_id,
		                          0,
		                          link,
		                          type,
		                          event_writable,
		                          cont);
		                var id$0 = id[1];
		                function id$1(param){return id$0;}
		                var a = [0, id$0];
		                function f(eta, cont){
		                 return caml_exact_trampoline_cps_call$5
		                         (add_from_writable$0,
		                          a,
		                          calendar_status,
		                          created,
		                          creator,
		                          draft,
		                          google_calendar_id,
		                          0,
		                          link,
		                          type,
		                          eta,
		                          cont);
		                }
		                var unit = [0, id$0, 0, 0];
		                return caml_exact_trampoline_cps_call$3
		                        (case$1,
		                         f,
		                         function(param, cont){
		                          return caml_trampoline_cps_call2(return$39, unit, cont);
		                         },
		                         f,
		                         id$1,
		                         event_writable,
		                         cont);
		               }
		               function get_event$0(state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Get[4], state, id, cont);
		               }
		               function exceptions$0(id, op, cont){
		                return caml_exact_trampoline_cps_call
		                        (exceptions,
		                         op,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (writable,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$6,
		     id,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (events_recurrent, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function add_exception(id, date, moved, cont){
		                return caml_trampoline_cps_call3
		                        (Exceptions$0[14],
		                         date,
		                         moved,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (exceptions$0, id, a, cont);
		                         });
		               }
		               function remove$24(date, state, time, event_id, cont){
		                function a(rec_op){
		                 return caml_exact_trampoline_cps_call$2
		                         (remove$23,
		                          date,
		                          state,
		                          time,
		                          event_id,
		                          function(rm_op){
		                           return caml_exact_trampoline_cps_call
		                                   (filter_opt,
		                                    [0, rm_op, [0, rec_op, 0]],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(all_unit$27, a, cont);
		                                    });
		                          });
		                }
		                if(0 === event_id[0]) return a(0);
		                var date$0 = event_id[2], recurrence = event_id[1];
		                return caml_exact_trampoline_cps_call$0
		                        (add_exception,
		                         recurrence,
		                         date$0,
		                         0,
		                         function(b){
		                          return caml_trampoline_cps_call2(return$9, b, a);
		                         });
		               }
		               function update_parent_exceptions
		               (event_rec, date_id, event_time, cont){
		                var match = event_rec[7][4];
		                function a(new_date){
		                 var moved_date = [0, new_date];
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id,
		                          event_rec[7][6],
		                          date_id,
		                          function(match){
		                           if(match){
		                            var previous_moved_date = match[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (equal_option,
		                                     equal$21,
		                                     previous_moved_date,
		                                     moved_date,
		                                     function(a){
		                                      if(a) return caml_trampoline_cps_call2(return$39, 0, cont);
		                                      var d1 = [0, date_id];
		                                      return caml_exact_trampoline_cps_call$0
		      (equal_option,
		       equal$21,
		       d1,
		       moved_date,
		       function(a){
		        return a
		                ? caml_trampoline_cps_call2
		                  (Exceptions$0[18],
		                   date_id,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$1
		                            (exceptions$0, event_rec[5], a, cont);
		                   })
		                : caml_exact_trampoline_cps_call
		                  (set$18,
		                   moved_date,
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (Exceptions$0[16],
		                             date_id,
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (b,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (exceptions$0, event_rec[5], a, cont);
		                                       });
		                             });
		                   });
		       });
		                                     });
		                           }
		                           var d1 = [0, date_id];
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_option,
		                                    equal$21,
		                                    d1,
		                                    moved_date,
		                                    function(a){
		                                     return a
		     ? caml_trampoline_cps_call2(return$39, 0, cont)
		     : caml_exact_trampoline_cps_call$0
		       (add_exception, event_rec[5], date_id, moved_date, cont);
		                                    });
		                          });
		                }
		                if(2 !== event_time[0]){
		                 var start_date = event_time[1];
		                 return a(start_date);
		                }
		                if(match){
		                 var
		                  start = event_time[1],
		                  daytime = match[1],
		                  tz = daytime[3];
		                 return caml_exact_trampoline_cps_call$1
		                         (of_time$0, tz, start, a);
		                }
		                var start$0 = event_time[1];
		                return caml_exact_trampoline_cps_call
		                        (err$1,
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, aXY, pp$79, event_rec[5], cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_time$0, timezone_local, start$0, a);
		                         });
		               }
		               function update_from_patch$0
		               (date, state, time, patch, event_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_event$0,
		                         state,
		                         event_id,
		                         function(match){
		                          if(! match)
		                           return caml_trampoline_cps_call2(return$39, 0, cont);
		                          var
		                           previous = match[1],
		                           event = patch$2(previous, patch),
		                           t = event[6];
		                          if(0 === t[0])
		                           return caml_exact_trampoline_cps_call$2
		                                   (upsert$1, date, state, time, event, cont);
		                          var date_id = t[2], recurrence = t[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_event_recurrent,
		                                   state,
		                                   recurrence,
		                                   function(match){
		                                    if(! match)
		                                     return caml_trampoline_cps_call2(return$39, 0, cont);
		                                    var event_rec = match[1];
		                                    return caml_exact_trampoline_cps_call$2
		    (upsert$1,
		     date,
		     state,
		     time,
		     event,
		     function(b){
		      var a = [0, b, 0];
		      return caml_exact_trampoline_cps_call$0
		              (update_parent_exceptions,
		               event_rec,
		               date_id,
		               event[9][10],
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (all_unit$27, [0, b, a], cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var get_closest_occurrence_after = Get[7];
		               function move_page(parent, state, page_id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function a(tree_id, cont){
		                 return caml_trampoline_cps_call3
		                         (let$0,
		                          parent,
		                          function(parent, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (get_tree_id, state, parent, cont);
		                          },
		                          function(parent){
		                           return caml_exact_trampoline_cps_call$1
		                                   (move,
		                                    parent,
		                                    tree_id,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(hierarchy, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_tree_id,
		                         state,
		                         page_id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function unarchive_page(state, page_id, cont){
		                function f(page, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (update$4,
		                          aXZ,
		                          0,
		                          0,
		                          page_id,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (pages,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (ignore_m$11,
		      a,
		      function(unarchive_op){
		       function f(parent, cont){
		        function f(parent_page, cont){
		         function f(param, cont){
		          function f(tree_id, cont){
		           return caml_exact_trampoline_cps_call$1
		                   (move,
		                    0,
		                    tree_id,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (hierarchy,
		                              a,
		                              function(a){
		                               return caml_trampoline_cps_call2(return$9, a, cont);
		                              });
		                    });
		          }
		          return caml_exact_trampoline_cps_call$1
		                  (get_tree_id,
		                   state,
		                   page[2],
		                   function(x){
		                    return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                   });
		         }
		         var x = some_if(is_some(parent_page[3][1]), 0);
		         return caml_trampoline_cps_call3(bind$8, x, f, cont);
		        }
		        return caml_exact_trampoline_cps_call$1
		                (get_page,
		                 state,
		                 parent,
		                 function(x){
		                  return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                 });
		       }
		       var x = page[3][5];
		       return caml_trampoline_cps_call3
		               (bind$8,
		                x,
		                f,
		                function(mv_op){
		                 return caml_exact_trampoline_cps_call
		                         (filter_opt,
		                          [0, [0, unarchive_op], [0, mv_op, 0]],
		                          function(a){
		                           return caml_exact_trampoline_cps_call(all_unit$27, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_page,
		                         state,
		                         page_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(map$17, x, f, cont);
		                         });
		               }
		               function update_from_patch$1
		               (date, state, time, patch, page_id, cont){
		                var
		                 parent = patch[5],
		                 title = patch[4],
		                 extension_row = patch[3],
		                 content = patch[2],
		                 archived = patch[1];
		                function f(page_before, cont){
		                 function f(title, cont){
		                  return cont([0, page_before[3][4], title]);
		                 }
		                 return caml_trampoline_cps_call3
		                         (map$17,
		                          title,
		                          f,
		                          function(title){
		                           return caml_exact_trampoline_cps_call$2
		                                   (update$4,
		                                    archived,
		                                    extension_row,
		                                    title,
		                                    page_id,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (pages,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (ignore_m$11,
		                a,
		                function(upd_op){
		                 function f(parent, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (move_page, parent, state, page_id, cont);
		                 }
		                 return caml_trampoline_cps_call3
		                         (bind$8,
		                          parent,
		                          f,
		                          function(mv_op){
		                           function a(notes_op){
		                            return caml_exact_trampoline_cps_call
		                                    (filter_opt,
		                                     [0, mv_op, [0, [0, upd_op], [0, notes_op, 0]]],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call(all_unit$27, a, cont);
		                                     });
		                           }
		                           if(! content) return a(0);
		                           var
		                            notes = content[1],
		                            notes_before = page_before[3][2],
		                            cascade = [0, [0, date, time, state]];
		                           return caml_exact_trampoline_cps_call$2
		                                   (update_page_notes_from_diff,
		                                    cascade,
		                                    page_id,
		                                    notes_before,
		                                    notes,
		                                    a);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_page,
		                         state,
		                         page_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(map$17, x, f, cont);
		                         });
		               }
		               function remove$25(date, state, time, page_id, cont){
		                function f(page, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (remove_referenced_subtasks,
		                          date,
		                          state,
		                          time,
		                          page[3][2],
		                          function(rm_sub_op){
		                           return caml_exact_trampoline_cps_call$1
		                                   (remove_extension_row,
		                                    bP8,
		                                    page[3][3],
		                                    function(rm_extension_row_op){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$22,
		   symbol_map$20,
		   ,
		   bind$30,
		   return$39,
		   map$50,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$14]),
		                                      let$ = open[3];
		                                     return caml_trampoline_cps_call3
		     (let$,
		      rm_sub_op,
		      function(param, cont){
		       return caml_trampoline_cps_call3
		               (let$,
		                rm_extension_row_op,
		                function(param, cont){
		                 return caml_trampoline_cps_call2
		                         (remove$15,
		                          page_id,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(pages, a, cont);
		                          });
		                },
		                cont);
		      },
		      cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_page,
		                         state,
		                         page_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(map$17, x, f, cont);
		                         });
		               }
		               function update_person_from_patch_cas
		               (cascade, patch, person_before, cont){
		                var
		                 people_id = person_before[1],
		                 notes_before = person_before[11][1];
		                function f(archived, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Earliest[13],
		                          archived,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (v$30,
		                                    [0, a],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(v$31, [7, a], cont);
		                                    });
		                          });
		                }
		                var x = patch[2];
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         x,
		                         f,
		                         function(archived_op){
		                          function f(extension_row, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (set$12,
		                                    extension_row,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (v$30,
		      [1, a],
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (v$31,
		                [7, a],
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (element$15,
		                          people_id,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(people, a, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          var x = patch[3];
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   x,
		                                   f,
		                                   function(extension_row_op){
		                                    function f(notes, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (update_person_notes_from_diff,
		      cascade,
		      people_id,
		      notes_before,
		      notes,
		      cont);
		                                    }
		                                    var x = patch[1];
		                                    return caml_trampoline_cps_call3
		    (bind$8,
		     x,
		     f,
		     function(notes_op){
		      var a = [0, notes_op, [0, extension_row_op, 0]];
		      return caml_trampoline_cps_call3
		              (map$17,
		               archived_op,
		               function(op, cont){
		                return caml_trampoline_cps_call3
		                        (element$15,
		                         people_id,
		                         op,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(people, a, cont);
		                         });
		               },
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (filter_opt,
		                         [0, b, a],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$27,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(return$9, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function find_recurrent_task_block_map
		               (doc, f, task_rec_id, cont){
		                var t = doc[1];
		                function a(i, t){
		                 if(! t) return cont(0);
		                 var l = t[2], x = t[1], b = x[2];
		                 function d(result){
		                  if(result) return cont(result);
		                  var i$0 = i + 1 | 0;
		                  return caml_exact_trampoline_call2(a, i$0, l);
		                 }
		                 function c(){return d(0);}
		                 if(typeof b === "number") return c();
		                 if(10 !== b[0]) return c();
		                 var todo = b[1], b = todo[1];
		                 if(! b) return c();
		                 var block_task_rec_id = b[1], block_id = x[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$152,
		                          block_task_rec_id,
		                          task_rec_id,
		                          function(a){
		                           return a
		                                   ? caml_exact_trampoline_cps_call$0
		                                     (f, i, block_id, todo, function(a){return d([0, a]);})
		                                   : c();
		                          });
		                }
		                return a(0, t);
		               }
		               function update_rec_block_from_task
		               (recurrence, title, block_id, rec_block, cont){
		                var prev_title = rec_block[2], prev_rec = rec_block[3];
		                function f(title, cont){
		                 function f(param, cont){
		                  function f(op, cont){
		                   return caml_exact_trampoline_cps_call
		                           (text$1,
		                            op,
		                            function(a){
		                             return caml_trampoline_cps_call2(return$9, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (diff$1,
		                           prev_title,
		                           title,
		                           function(x){
		                            return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                           });
		                 }
		                 var x = some_if(prev_title !== title ? 1 : 0, 0);
		                 return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                }
		                return caml_trampoline_cps_call3
		                        (bind$8,
		                         title,
		                         f,
		                         function(text_op_o){
		                          function f(recurrence, cont){
		                           var
		                            new_block_rec =
		                              [10, [0, rec_block[1], rec_block[2], recurrence]];
		                           return caml_exact_trampoline_cps_call
		                                   (set$11,
		                                    with_text(bOE, new_block_rec),
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (kind,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (equal$32,
		                prev_rec,
		                recurrence,
		                function(b){return cont(some_if(1 - b, a));});
		      });
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   recurrence,
		                                   f,
		                                   function(kind_op_o){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0, kind_op_o, [0, text_op_o, 0]],
		     function(l){
		      return l
		              ? caml_exact_trampoline_cps_call
		                (all_unit$4,
		                 l,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (Blocks[16],
		                           block_id,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (blocks, a, function(a){return cont([0, a]);});
		                                     });
		                           });
		                 })
		              : cont(0);
		     });
		                                   });
		                         });
		               }
		               function remove_parent_block$0
		               (state, parent, task_rec_id, cont){
		                function doc_op(doc, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (find_recurrent_task_block_map,
		                          doc,
		                          function(i, block_id, param, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (remove_block, i, block_id, cont);
		                          },
		                          task_rec_id,
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (find_parent_map_notes, state, parent, doc_op, cont);
		               }
		               function append_parent_block$0
		               (state, recurrence, parent, title, task_rec_id, cont){
		                function doc_op(doc, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (find_recurrent_task_block_map,
		                          doc,
		                          function(param, block_id, todo_block, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (update_rec_block_from_task,
		                                    [0, recurrence],
		                                    [0, title],
		                                    block_id,
		                                    todo_block,
		                                    cont);
		                          },
		                          task_rec_id,
		                          function(upd_op){
		                           if(! upd_op)
		                            return caml_exact_trampoline_cps_call$1
		                                    (insert_block,
		                                     -1,
		                                     [10, [0, [0, task_rec_id], title, recurrence]],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (ignore_m$0,
		       a,
		       function(a){
		        return caml_trampoline_cps_call2(return$9, a, cont);
		       });
		                                     });
		                           var upd_op$0 = upd_op[1];
		                           return caml_exact_trampoline_cps_call
		                                   (err$1,
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call4(m, 0, 0, aX0, cont);
		                                    },
		                                    function(match){return cont(upd_op$0);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (find_parent_map_notes, state, parent, doc_op, cont);
		               }
		               function add_main_recurrent_task_from_w
		               (id, cascade, created, writable, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_time$0,
		                         timezone_local,
		                         created,
		                         function(date_created){
		                          var
		                           open =
		                             g
		                              ([0,
		                                Operation$15[4],
		                                Operation$15[5],
		                                ,
		                                Operation$15[7],
		                                Operation$15[8],
		                                Operation$15[9],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Operation$15[12]]),
		                           let$ = open[3];
		                          function a(id, cont){
		                           function a(param, cont){
		                            return caml_trampoline_cps_call2(Operation$15[8], id, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (insert_blocks,
		                                    -1,
		                                    writable[3][1][1],
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (notes$5,
		      b,
		      function(b){
		       return caml_trampoline_cps_call2
		               (element$16,
		                id,
		                function(c){
		                 return caml_trampoline_cps_call2
		                         (c,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$7
		                                  (add_recurrent_task,
		                                   id,
		                                   writable[1],
		                                   writable[3][3],
		                                   [0, writable[3][2]],
		                                   writable[2],
		                                   created,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     b,
		     a,
		     function(task_rec_op){
		      var
		       open =
		         g
		          ([0,
		            symbol_bind$22,
		            symbol_map$20,
		            ,
		            bind$30,
		            return$39,
		            map$50,
		            ,
		            ,
		            ,
		            ,
		            Let_syntax$14]),
		       let$ = open[3];
		      function a(task_rec_id, cont){
		       function b(param, cont){
		        return caml_trampoline_cps_call2
		                (return$39, task_rec_id, cont);
		       }
		       function a(a){
		        return caml_trampoline_cps_call3(let$, a, b, cont);
		       }
		       if(! cascade)
		        return caml_trampoline_cps_call2(return$39, 0, a);
		       var
		        state = cascade[1],
		        dummy_task_rec =
		          make$43(created, task_rec_id, 0, writable[2], writable[3]);
		       return caml_exact_trampoline_cps_call$2
		               (add_first_task_occurrence,
		                created,
		                date_created,
		                state,
		                dummy_task_rec,
		                function(b){
		                 return caml_exact_trampoline_cps_call(ignore_m$11, b[1], a);
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (recurrences,
		               task_rec_op,
		               function(b){
		                return caml_trampoline_cps_call3(let$, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function update_task_occurrences
		               (date, state, time, task_rec, patch, cont){
		                var
		                 patched =
		                   [0, , , , task_rec[4], [0, , patch, task_rec[5][3]]];
		                return caml_exact_trampoline_cps_call$0
		                        (get_occurrences,
		                         state,
		                         date,
		                         task_rec[4],
		                         function(match){
		                          var
		                           last_remaining_date = match[3],
		                           task_ids_after = match[2],
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$22,
		                                symbol_map$20,
		                                ,
		                                bind$30,
		                                return$39,
		                                map$50,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$14]),
		                           let$ = open[3];
		                          function a(param, cont){
		                           if(! last_remaining_date)
		                            return caml_exact_trampoline_cps_call$2
		                                    (add_first_task_occurrence,
		                                     time,
		                                     date,
		                                     state,
		                                     patched,
		                                     function(match){
		                                      var first_occ_date_opt = match[2], first_occ_op = match[1];
		                                      return caml_trampoline_cps_call3
		      (let$,
		       first_occ_op,
		       function(param, cont){
		        return caml_trampoline_cps_call3
		                (map$17,
		                 first_occ_date_opt,
		                 calendar,
		                 function(a){
		                  var starting = value$4(a, date);
		                  return caml_exact_trampoline_cps_call$3
		                          (materialize_task_occurrences_u,
		                           date,
		                           starting,
		                           state,
		                           time,
		                           patched,
		                           cont);
		                 });
		       },
		       cont);
		                                     });
		                           var starting = last_remaining_date[1];
		                           return caml_exact_trampoline_cps_call$3
		                                   (materialize_task_occurrences_u,
		                                    date,
		                                    starting,
		                                    state,
		                                    time,
		                                    patched,
		                                    cont);
		                          }
		                          return caml_exact_trampoline_cps_call$2
		                                  (remove_tasks,
		                                   date,
		                                   state,
		                                   time,
		                                   task_ids_after,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               }
		               function update_parent_doc
		               (state, task_rec, patch, task_rec_id, cont){
		                function new_title(param){
		                 var init = task_rec[5][3][2], t = patch[3][2];
		                 if(! t) return init;
		                 var title = t[1];
		                 return title;
		                }
		                function new_recurrence(param){
		                 var init = task_rec[5][2], t = patch[2];
		                 if(! t) return init;
		                 var rec = t[1];
		                 return rec;
		                }
		                var b = task_rec[5][1], a = patch[1];
		                if(b){
		                 var parent = b[1];
		                 if(! a){
		                  var
		                   title$0 = patch[3][2],
		                   recurrence$0 = patch[2],
		                   doc_op =
		                     function(doc, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (find_recurrent_task_block_map,
		                               doc,
		                               function(param, block_id, rec_block, cont){
		                                return caml_exact_trampoline_cps_call$2
		(update_rec_block_from_task,
		 recurrence$0,
		 title$0,
		 block_id,
		 rec_block,
		 cont);
		                               },
		                               task_rec_id,
		                               function(a){
		                                return caml_exact_trampoline_cps_call(join$2, a, cont);
		                               });
		                     };
		                  return caml_exact_trampoline_cps_call$0
		                          (find_parent_map_notes, state, parent, doc_op, cont);
		                 }
		                 a = a[1];
		                 if(! a)
		                  return caml_exact_trampoline_cps_call$0
		                          (remove_parent_block$0, state, parent, task_rec_id, cont);
		                 var
		                  new_parent = a[1],
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$22,
		                       symbol_map$20,
		                       ,
		                       bind$30,
		                       return$39,
		                       map$50,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$14]),
		                  let$ = open[3],
		                  title = new_title(),
		                  recurrence = new_recurrence(),
		                  f =
		                    function(rm_op, cont){
		                     function f(app_op, cont){
		                      return caml_trampoline_cps_call3
		                              (let$,
		                               rm_op,
		                               function(param, cont){return cont(app_op);},
		                               function(op){
		                                return caml_trampoline_cps_call2(return$9, op, cont);
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$3
		                             (append_parent_block$0,
		                              state,
		                              recurrence,
		                              new_parent,
		                              title,
		                              task_rec_id,
		                              function(x){
		                               return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                              });
		                    };
		                 return caml_exact_trampoline_cps_call$0
		                         (remove_parent_block$0,
		                          state,
		                          parent,
		                          task_rec_id,
		                          function(x){
		                           return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                          });
		                }
		                if(a){
		                 a = a[1];
		                 if(a){
		                  var
		                   parent$0 = a[1],
		                   title$1 = new_title(),
		                   recurrence$1 = new_recurrence();
		                  return caml_exact_trampoline_cps_call$3
		                          (append_parent_block$0,
		                           state,
		                           recurrence$1,
		                           parent$0,
		                           title$1,
		                           task_rec_id,
		                           cont);
		                 }
		                }
		                return cont(0);
		               }
		               function update_from_patch_cas$0
		               (cascade, date, state, time, patch, task_rec_before, cont){
		                var
		                 match = patch[3],
		                 url = match[3],
		                 title = match[2],
		                 notes = match[1],
		                 recurrence = patch[2],
		                 parent = patch[1],
		                 task_rec_id = task_rec_before[4],
		                 notes_before = task_rec_before[5][3][1],
		                 title_before = task_rec_before[5][3][2],
		                 url_before = task_rec_before[5][3][3];
		                function f(title, cont){
		                 function f(param, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (diff$1, title_before, title, cont);
		                 }
		                 var x = some_if(title_before !== title ? 1 : 0, 0);
		                 return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                }
		                return caml_trampoline_cps_call3
		                        (bind$8,
		                         title,
		                         f,
		                         function(title_op){
		                          function f(url, cont){
		                           function f(param, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (diff$2, url_before, url, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_option,
		                                    equal$44,
		                                    url_before,
		                                    url,
		                                    function(a){
		                                     var x = some_if(1 - a, 0);
		                                     return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   url,
		                                   f,
		                                   function(url_op){
		                                    return caml_exact_trampoline_cps_call$7
		    (update$5,
		     0,
		     parent,
		     recurrence,
		     title_op,
		     url_op,
		     task_rec_id,
		     function(a){
		      return caml_trampoline_cps_call3
		              (map$17,
		               a,
		               recurrences,
		               function(task_rec_op){
		                function f(recurrence, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (update_task_occurrences,
		                          date,
		                          state,
		                          time,
		                          task_rec_before,
		                          recurrence,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(ignore_m$11, a, cont);
		                          });
		                }
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         recurrence,
		                         f,
		                         function(occ_op){
		                          function f(notes, cont){
		                           var cascade$0 = cascade ? [0, [0, date, time, state]] : 0;
		                           return caml_exact_trampoline_cps_call$2
		                                   (update_recurrent_task_notes_fr,
		                                    cascade$0,
		                                    task_rec_id,
		                                    notes_before,
		                                    notes,
		                                    cont);
		                          }
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   notes,
		                                   f,
		                                   function(notes_op){
		                                    function f(param, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (update_parent_doc,
		      state,
		      task_rec_before,
		      patch,
		      task_rec_id,
		      cont);
		                                    }
		                                    var x = to_option$6(cascade);
		                                    return caml_trampoline_cps_call3
		    (bind$8,
		     x,
		     f,
		     function(parent_doc_op){
		      return caml_exact_trampoline_cps_call
		              (filter_opt,
		               [0,
		                task_rec_op,
		                [0, occ_op, [0, notes_op, [0, parent_doc_op, 0]]]],
		               function(ops){
		                return ops
		                        ? caml_exact_trampoline_cps_call
		                          (all_unit$27,
		                           ops,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$9, a, cont);
		                           })
		                        : cont(0);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update_from_patch$2
		               (date, state, time, patch, task_rec_id, cont){
		                function f(task_rec, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (update_from_patch_cas$0,
		                          aX1,
		                          date,
		                          state,
		                          time,
		                          patch,
		                          task_rec,
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_task_recurrent,
		                         state,
		                         task_rec_id,
		                         function(x){
		                          return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                         });
		               }
		               function set_of_list(fcm, l, cont){
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         l,
		                         function(x, cont){return cont([0, x, 0]);},
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (of_alist_reduce$1,
		                                   fcm,
		                                   a,
		                                   function(a, param, cont){return cont(0);},
		                                   cont);
		                         });
		               }
		               function update_mru_destinations_from_d
		               (previous, mru_destinations, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (set_of_list,
		                         [0, comparator$24],
		                         previous,
		                         function(before_map){
		                          return caml_exact_trampoline_cps_call$1
		                                  (set_of_list,
		                                   [0, comparator$24],
		                                   mru_destinations,
		                                   function(after_map){
		                                    return caml_exact_trampoline_cps_call$0
		    (symmetric_diff$2,
		     before_map,
		     after_map,
		     function(a, param, cont){return cont(1);},
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$1,
		               a,
		               function(param, cont){
		                var variant = param[2][1], key = param[1];
		                return 847852583 === variant
		                        ? caml_exact_trampoline_cps_call
		                          (Mru_destinations[14],
		                           key,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$9, a, cont);
		                           })
		                        : 1013247643
		                          <= variant
		                          ? cont(0)
		                          : caml_exact_trampoline_cps_call
		                            (Mru_destinations[13],
		                             key,
		                             function(a){
		                              return caml_trampoline_cps_call2(return$9, a, cont);
		                             });
		               },
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (to_binable,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (Mru_destinations[1][10], a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update_mru_people_from_diff
		               (previous, mru_people, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (set_of_list,
		                         [0, comparator$2],
		                         previous,
		                         function(before_map){
		                          return caml_exact_trampoline_cps_call$1
		                                  (set_of_list,
		                                   [0, comparator$2],
		                                   mru_people,
		                                   function(after_map){
		                                    return caml_exact_trampoline_cps_call$0
		    (symmetric_diff$2,
		     before_map,
		     after_map,
		     function(a, param, cont){return cont(1);},
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$1,
		               a,
		               function(param, cont){
		                var variant = param[2][1], key = param[1];
		                return 847852583 === variant
		                        ? caml_exact_trampoline_cps_call
		                          (Mru_people[14],
		                           key,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$9, a, cont);
		                           })
		                        : 1013247643
		                          <= variant
		                          ? cont(0)
		                          : caml_exact_trampoline_cps_call
		                            (Mru_people[13],
		                             key,
		                             function(a){
		                              return caml_trampoline_cps_call2(return$9, a, cont);
		                             });
		               },
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (to_binable,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2(Mru_people[1][10], a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update_from_patch$3(patch$0, settings$0, cont){
		                var arm = settings$0[1], pm = patch$0[1];
		                return caml_exact_trampoline_cps_call$0
		                        (merge$1,
		                         arm,
		                         pm,
		                         function(key, a, cont){
		                          var variant = a[1];
		                          if(737457313 === variant){
		                           var patch$0 = a[2][2];
		                           return caml_exact_trampoline_cps_call$0
		                                   (update$6,
		                                    patch$0[1],
		                                    patch$0[2],
		                                    dummy,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (Access_restrictions[15],
		      key,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (Access_restrictions[2][11],
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call2(return$9, a, cont);
		                          });
		                });
		      });
		                                    });
		                          }
		                          if(847852583 <= variant) return cont(0);
		                          var patch$1 = a[2], a = patch(empty$3, patch$1);
		                          return caml_trampoline_cps_call3
		                                  (Access_restrictions[14],
		                                   key,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(return$9, a, cont);
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (Access_restrictions[2][13],
		     a,
		     function(access_restrictions){
		      var cm = settings$0[2], pm = patch$0[2];
		      return caml_exact_trampoline_cps_call
		              (normalize_calendars_patch,
		               pm,
		               function(match){
		                var pm = match[2], default$ = match[1];
		                return caml_exact_trampoline_cps_call$0
		                        (merge$1,
		                         cm,
		                         pm,
		                         function(key, a, cont){
		                          var variant = a[1];
		                          if(737457313 === variant){
		                           a = a[2][2];
		                           if(! a)
		                            return caml_trampoline_cps_call2
		                                    (Operation$2[8],
		                                     0,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$9, a, cont);
		                                     });
		                           var patch = a[1];
		                           return caml_exact_trampoline_cps_call$9
		                                   (update$1,
		                                    patch[1],
		                                    0,
		                                    patch[2],
		                                    0,
		                                    patch[3],
		                                    0,
		                                    0,
		                                    dummy,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$0,
		      key,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2(return$9, a, cont);
		                });
		      });
		                                    });
		                          }
		                          if(847852583 <= variant){
		                           var cal_config = a[2];
		                           if(! cal_config[3] && default$)
		                            return caml_exact_trampoline_cps_call
		                                    (set_role,
		                                     1,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (element$0,
		       key,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b,
		                 a,
		                 function(a){
		                  return caml_trampoline_cps_call2(return$9, a, cont);
		                 });
		       });
		                                     });
		                           return cont(0);
		                          }
		                          a = a[2];
		                          if(! a) return cont(0);
		                          var patch$0 = a[1];
		                          return caml_exact_trampoline_cps_call$9
		                                  (update$1,
		                                   patch$0[1],
		                                   0,
		                                   patch$0[2],
		                                   0,
		                                   patch$0[3],
		                                   0,
		                                   0,
		                                   dummy,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$0,
		     key,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_trampoline_cps_call2(return$9, a, cont);
		               });
		     });
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   a,
		                                   function(cals_ops){
		                                    return caml_trampoline_cps_call2
		    (Operation$2[13],
		     cals_ops,
		     function(calendars_op){
		      function f(hours, cont){return cont([0, hours]);}
		      var x = patch$0[3][1];
		      return caml_trampoline_cps_call3
		              (map$17,
		               x,
		               f,
		               function(locale){
		                var a = patch$1(settings$0[4], patch$0[4]);
		                return caml_exact_trampoline_cps_call$1
		                        (equal$131,
		                         patch$0[4],
		                         empty$5,
		                         function(b){
		                          var hours = some_if(1 - b, a);
		                          function f(mru_destinations, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (update_mru_destinations_from_d,
		                                    settings$0[5],
		                                    mru_destinations,
		                                    cont);
		                          }
		                          var x = patch$0[5];
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   x,
		                                   f,
		                                   function(mru_destinations$0){
		                                    function f(mru_people, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (update_mru_people_from_diff,
		      settings$0[6],
		      mru_people,
		      cont);
		                                    }
		                                    var x = patch$0[6];
		                                    return caml_trampoline_cps_call3
		    (map$17,
		     x,
		     f,
		     function(mru_people$0){
		      var
		       week_start = patch$0[7],
		       acc_res = [0, access_restrictions],
		       open =
		         g
		          ([0,
		            symbol_bind$5,
		            symbol_map$5,
		            ,
		            bind$8,
		            return$9,
		            map$17,
		            ,
		            ,
		            ,
		            ,
		            Let_syntax$3]),
		       let$ = open[4];
		      return caml_trampoline_cps_call3
		              (let$,
		               acc_res,
		               function(acc_res, cont){
		                return caml_exact_trampoline_cps_call
		                        (v$38, [0, acc_res], cont);
		               },
		               function(acc_res_op){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         locale,
		                         function(locale, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Locale[12],
		                                   locale,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$38, [1, a], cont);
		                                   });
		                         },
		                         function(locale_op){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   hours,
		                                   function(hours, cont){
		                                    return caml_exact_trampoline_cps_call
		    (Hours[12],
		     hours,
		     function(a){
		      return caml_exact_trampoline_cps_call(v$38, [2, a], cont);
		     });
		                                   },
		                                   function(hours_op){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     mru_destinations$0,
		     function(mru_dests, cont){
		      return caml_exact_trampoline_cps_call
		              (mru_destinations, mru_dests, cont);
		     },
		     function(mru_dests_op){
		      return caml_trampoline_cps_call3
		              (let$,
		               mru_people$0,
		               function(mru_peops, cont){
		                return caml_exact_trampoline_cps_call
		                        (mru_people, mru_peops, cont);
		               },
		               function(mru_peops_op){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         week_start,
		                         function(week_start, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (Week_start[12],
		                                   week_start,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(v$38, [5, a], cont);
		                                   });
		                         },
		                         function(ws_op){
		                          return caml_exact_trampoline_cps_call
		                                  (filter_opt,
		                                   [0,
		                                    acc_res_op,
		                                    [0,
		                                     locale_op,
		                                     [0,
		                                      hours_op,
		                                      [0, mru_dests_op, [0, mru_peops_op, [0, ws_op, 0]]]]]],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (all_unit$21,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (settings,
		               a,
		               function(settings_op){
		                return caml_exact_trampoline_cps_call
		                        (v$47,
		                         [1, calendars_op],
		                         function(calendars_op){
		                          return caml_exact_trampoline_cps_call
		                                  (all_unit$27, [0, settings_op, [0, calendars_op, 0]], cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback(of_string_exn, ["3.0.1-beta.0.client-data"]);
		               var cst_log = "log";
		               function Make$58(Context, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make$57,
		                         Context,
		                         function(a){
		                          var b = a[30], c = a[36], d = a[35], e = a[33], f = a[28];
		                          function commit_schema_versioned(schematic_version, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (schematic_version,
		                                    V$5,
		                                    function(schematic_schema_version){
		                                     return caml_trampoline_cps_call2
		     (b,
		      schematic_version,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$368,
		                schematic_version,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (b, a, function(a){return cont([0, aPE, 0, a[3], a[4]]);});
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (commit_schema_versioned,
		                                   function(param, cont){return cont(0);},
		                                   function(commit_schema){
		                                    function schema_versioned(schematic_version, cont){
		                                     return caml_exact_trampoline_cps_call
		     (schematic_version,
		      V$5,
		      function(schematic_schema_version){
		       return caml_exact_trampoline_cps_call$1
		               (log_schema,
		                commit_schema_versioned,
		                schematic_version,
		                function(a){return cont([0, 0, 0, a[3], a[4]]);});
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned,
		     function(param, cont){return cont(0);},
		     function(schema){
		      var empty = By$20[111];
		      function set(t, local, key, data, cont){
		       return local
		               ? caml_exact_trampoline_cps_call$0
		                 (By$20[17], t, key, data, cont)
		               : cont(t);
		      }
		      function schema_versioned$0(schematic_version, cont){
		       return caml_exact_trampoline_cps_call
		               (schematic_version,
		                V$5,
		                function(schematic_schema_version){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          schematic_version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$368,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (b, a, function(a){return cont();});
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$0,
		               function(param, cont){return cont(0);},
		               function(schema){
		                var letrec_function_context = [];
		                function schema_versioned$0(schematic_version, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schematic_version,
		                          V$5,
		                          function(schematic_schema_version){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    letrec_function_context[1][1],
		                                    schematic_schema_version,
		                                    function(match){
		                                     function a(descriptor){
		                                      return cont([0, aPw, 0, descriptor, 0]);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fixpoint,
		       function(schematic_self, cont){
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 function(match){
		                  if(! match)
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            schematic_self,
		                            function(a){
		                             letrec_function_context[1][1] = a;
		                             return caml_exact_trampoline_cps_call
		                                     (f,
		                                      schematic_version,
		                                      function(b){
		                                       var
		a = [0, [0, aPx, 0, 0, 0, cst_state, 0, 2, [0, b], 0, 0], 0];
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned,
		        schematic_version,
		        function(c){
		         var
		          b = [0, [0, aPy, 0, 0, 0, cst_log, 0, 2, [0, c], 0, 0], a];
		         return caml_exact_trampoline_cps_call
		                 (schema_versioned$358,
		                  schematic_version,
		                  function(c){
		                   var
		                    a = [0, [0, aPz, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b];
		                   return caml_exact_trampoline_cps_call
		                           (Replica_timestamps[70],
		                            schematic_version,
		                            function(c){
		                             var
		                              b = [0, [0, aPA, 0, 0, 0, "heads", 0, 2, [0, c], 0, 0], a];
		                             return caml_exact_trampoline_cps_call
		                                     (schema_versioned$369,
		                                      schematic_version,
		                                      function(a){
		                                       var
		res =
		  [7,
		   function(param, cont){
		    var
		     a = param[2],
		     b = a[2],
		     c = b[2],
		     d = c[2],
		     state = d[2][1],
		     log = d[1],
		     id = c[1],
		     heads = b[1],
		     clocks = a[1],
		     clock = param[1];
		    return cont([0, clock, clocks, heads, id, log, state]);
		   },
		   function(param, cont){
		    var
		     state = param[6],
		     log = param[5],
		     id = param[4],
		     heads = param[3],
		     clocks = param[2],
		     clock = param[1];
		    return cont
		            ([0,
		              clock,
		              [0, clocks, [0, heads, [0, id, [0, log, [0, state, 0]]]]]]);
		   },
		   [0,
		    [0, aPC, 0, 0, 0, cst_clock, 0, 2, [0, int_schema], 0, 0],
		    [0, [0, aPB, 0, 0, 0, "clocks", 0, 2, [0, a], 0, 0], b]]];
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        letrec_function_context[1][1],
		        schematic_schema_version,
		        res,
		        function(a){
		         letrec_function_context[1][1] = a;
		         return cont(res);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  var schema = match[1];
		                  return cont(schema);
		                 });
		       },
		       a);
		                                     var schema = match[1];
		                                     return a(schema);
		                                    });
		                          });
		                }
		                var schematic_cache = [0, empty$11([0, comparator$9])];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$0,
		                         function(param, cont){return cont(0);},
		                         function(schema){
		                          function make(id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (d,
		                                    dummy,
		                                    function(a){
		                                     return cont
		     ([0, 0, empty$29, Replica_timestamps[73], id, empty, a]);
		                                    });
		                          }
		                          function clocks(param){
		                           var clocks = param[2];
		                           return clocks;
		                          }
		                          function fetch_commit(t, local, commit, state, cont){
		                           var timestamp = commit[2];
		                           return caml_exact_trampoline_cps_call$2
		                                   (set,
		                                    t[5],
		                                    local,
		                                    timestamp,
		                                    commit,
		                                    function(b){
		                                     var
		                                      heads = t[3],
		                                      timestamp = commit[2],
		                                      parents = commit[1],
		                                      a = t[4];
		                                     return caml_exact_trampoline_cps_call$0
		     (fold$3,
		      parents,
		      heads,
		      remove$0,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (add$4,
		                c,
		                timestamp,
		                function(c){return cont([0, t[1], t[2], c, a, b, state]);});
		      });
		                                    });
		                          }
		                          function apply(op, init, cont){
		                           var timestamp = [0, init[1], init[4]];
		                           function a(param, cont){
		                            return caml_trampoline_cps_call4
		                                    (e,
		                                     init[4],
		                                     init[6],
		                                     op,
		                                     function(match){
		                                      var state = match[3], delta = match[2], result = match[1];
		                                      function a(t){return cont([0, result, t]);}
		                                      if(! delta) return a(init);
		                                      var
		                                       delta$0 = delta[1],
		                                       b = [0, init[3], timestamp, delta$0],
		                                       c = init[5],
		                                       d = init[4],
		                                       e = init[3];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       init[2],
		       init[4],
		       init[1],
		       function(f){
		        return caml_exact_trampoline_cps_call$2
		                (fetch_commit,
		                 [0, init[1] + 1 | 0, f, e, d, c],
		                 1,
		                 b,
		                 state,
		                 a);
		       });
		                                     });
		                           }
		                           function b(m, cont){
		                            return caml_trampoline_cps_call7
		                                    (m, 0, 0, aPD, init[4], _10$3, timestamp, cont);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (with_debug,
		                                    0,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      b,
		      function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                    });
		                          }
		                          function view(param, cont){
		                           var state = param[6];
		                           return caml_exact_trampoline_cps_call(c, state, cont);
		                          }
		                          function id(param){var id = param[4]; return id;}
		                          return cont
		                                  ([0,
		                                    [0, schema_versioned$0, , , apply, , id, make, view, clocks]]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback(Make$58, [Ident]);
		               o
		                ([0,
		                  symbol_bind$9,
		                  symbol_map$7,
		                  Let_syntax$5,
		                  ,
		                  bind$12,
		                  return$13,
		                  map$25]);
		               var
		                logs_src$3 = create$18(0, "Controller_lib.State"),
		                Logs$2 = src_log(logs_src$3);
		               function mutation_schema_versioned(param){
		                return map$14
		                        (function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$0, -195860570, cont);
		                         },
		                         function(param, cont){return cont(0);},
		                         schematic_param_a_schema_versi);
		               }
		               var mutation_schema = mutation_schema_versioned();
		               function dequeue(a){
		                if(! a) return aX2;
		                var v = a[1];
		                if(! a[2]) return [0, [0, v], 0];
		                var t = a[2], a = dequeue(t), t$0 = a[2], res = a[1];
		                return [0, res, [0, v, t$0]];
		               }
		               function full_organization_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$200,
		                                   schematic_version,
		                                   function(schematic_param_subscription_s){
		                                    return caml_exact_trampoline_cps_call
		    (schematic_version,
		     V$4,
		     function(schematic_schema_version){
		      function descriptor(schematic_param_subscription_s, cont){
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$349,
		                schematic_version,
		                function(b){
		                 var
		                  a =
		                    [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, b], 0, 0], 0];
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$198,
		                          schematic_version,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (b,
		                                    schematic_param_subscription_s,
		                                    function(b){
		                                     return cont
		     ([7,
		       function(param, cont){
		        var permissions = param[2][1], organization = param[1];
		        return cont([0, organization, permissions]);
		       },
		       function(param, cont){
		        var permissions = param[2], organization = param[1];
		        return cont([0, organization, [0, permissions, 0]]);
		       },
		       [0,
		        [0, 0, 0, 0, 0, cst_organization, 0, 2, [1, b], 0, 0],
		        a]]);
		                                    });
		                          });
		                });
		      }
		      var
		       schematic_schema_id = match$224[1],
		       schematic_parametric =
		         [0,
		          [1,
		           cst_subscription,
		           schematic_param_subscription_s,
		           function(schematic_param_subscription_s, cont){
		            return caml_exact_trampoline_cps_call
		                    (descriptor,
		                     schematic_param_subscription_s,
		                     function(a){return cont([0, schematic_schema_id, a]);});
		           }]];
		      return caml_exact_trampoline_cps_call
		              (descriptor,
		               schematic_param_subscription_s,
		               function(a){
		                var parametric = schematic_parametric[1];
		                return caml_exact_trampoline_cps_call
		                        (of_parametric,
		                         parametric,
		                         function(match){
		                          function b(b){
		                           return cont([0, aX4, 0, a, schematic_parametric]);
		                          }
		                          if(! match) return b();
		                          var name = match[1];
		                          return caml_exact_trampoline_cps_call(to_id, name, b);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (full_organization_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               function augment(member, organization, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter,
		                         all$5,
		                         function(action, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (authorize,
		                                   organization,
		                                   member,
		                                   action,
		                                   function(a){return cont(is_ok(a));});
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_list$8,
		                                   a,
		                                   function(permissions){
		                                    var organization$0 = organization[3];
		                                    return cont([0, organization$0, permissions]);
		                                   });
		                         });
		               }
		               var letrec_function_context$781 = [];
		               function for_member_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$781[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aX5, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$781[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$781[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$781[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$351,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$195,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var permissions = param[2][1], member = param[1];
		             return cont([0, member, permissions]);
		            },
		            function(param, cont){
		             var permissions = param[2], member = param[1];
		             return cont([0, member, [0, permissions, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_member, 0, 2, [1, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$781[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$781[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$737 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$781, [0, schematic_cache$737]);
		               caml_callback
		                (for_member_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function augment$0(user, organization, member, cont){
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         all$6,
		                         function(action, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (authorize$0,
		                                   organization,
		                                   user,
		                                   action,
		                                   member,
		                                   function(result){return cont([0, action, result]);});
		                         },
		                         function(authorization_results){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$0,
		                                   authorization_results,
		                                   function(param, cont){
		                                    var result = param[2], action = param[1];
		                                    return is_ok(result) ? cont([0, action]) : cont(0);
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_list$9,
		     a,
		     function(permissions){
		      var
		       open =
		         g
		          ([0,
		            symbol_bind$5,
		            symbol_map$5,
		            ,
		            bind$8,
		            return$9,
		            map$17,
		            ,
		            ,
		            ,
		            ,
		            Let_syntax$3]),
		       let$ = open[4];
		      function a(member, cont){
		       return cont
		               ([0, [0, member, permissions], authorization_results]);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (find_packed_by_id,
		               organization[1],
		               member,
		               function(b){
		                return caml_trampoline_cps_call3(let$, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$782 = [];
		               function schema_versioned$497(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$782[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aX6, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$782[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$782[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$782[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$123,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, "workspace_access_role", 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$356,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$195,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        workspace_access_role = a[2][1],
		                        permissions = a[1],
		                        member = param[1];
		                       return cont([0, member, permissions, workspace_access_role]);
		                      },
		                      function(param, cont){
		                       var
		                        workspace_access_role = param[3],
		                        permissions = param[2],
		                        member = param[1];
		                       return cont
		                               ([0,
		                                 member,
		                                 [0, permissions, [0, workspace_access_role, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_member, 0, 2, [1, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$782[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$782[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$738 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$782, [0, schematic_cache$738]);
		               caml_callback
		                (schema_versioned$497,
		                 [function(param, cont){return cont(0);}]);
		               var
		                Impl$2 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$44, comparator$22, schema_versioned$117]]);
		               function schema_versioned$498(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$497,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (Impl$2[109],
		     schematic_version,
		     a,
		     function(a){return cont([0, aX7, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$498,
		                 [function(param, cont){return cont(0);}]);
		               function map$51(l$1, acc$1){
		                var l = l$1, acc = acc$1;
		                for(;;){
		                 if(! l) return rev(acc);
		                 var
		                  l$0 = l[2],
		                  enumerate_002 = l[1],
		                  acc$0 = [0, [1, enumerate_002], acc];
		                 l = l$0;
		                 acc = acc$0;
		                }
		               }
		               function map$52(l$1, acc$1){
		                var l = l$1, acc = acc$1;
		                for(;;){
		                 if(! l) return rev(acc);
		                 var
		                  l$0 = l[2],
		                  enumerate_001 = l[1],
		                  acc$0 = [0, [0, enumerate_001], acc];
		                 l = l$0;
		                 acc = acc$0;
		                }
		               }
		               var e = map$51(all$8, 0);
		               symbol(map$52(all$7, 0), e);
		               var letrec_function_context$783 = [];
		               function compare$168(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$783[2], lhs0, rhs0, cont);
		                 }
		                }
		                else {
		                 var lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$783[1], lhs0$0, rhs0$0, cont);
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               caml_update_dummy
		                (letrec_function_context$783, [0, compare$138, compare$136]);
		               var letrec_function_context$784 = [];
		               function schema_versioned$499(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$784[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aX8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$784[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$784[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$784[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$354,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   "workspace_data",
		   "Workspace_data",
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$353,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_workspace,
		              cst_Workspace,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$784[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$784[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$739 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$784, [0, schematic_cache$739]);
		               caml_callback
		                (schema_versioned$499,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$785 = [];
		               function pp$124(fmt, param, cont){
		                if(0 === param[0]){
		                 var a0 = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          aX9,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (letrec_function_context$785[2],
		                                    fmt,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      a0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt), aX_, cont);
		      });
		                                    });
		                          });
		                }
		                var a0$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         aX$,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$785[1],
		                                   fmt,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     a0$0,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt), aYa, cont);
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$785, [0, pp$120, pp$119]);
		               function sexp_of_t$136(uuid, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$130,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp$124, uuid, function(a){return cont([0, a]);});
		                         });
		               }
		               var
		                include$279 = Make$2([0, compare$168, sexp_of_t$136]),
		                comparator$57 = include$279[16],
		                T$13 =
		                  caml_callback
		                   (M_printable$0,
		                    [[0, pp$124, comparator$57, schema_versioned$499]]);
		               function schema_versioned$500(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (T$13[70],
		                                   schematic_version,
		                                   function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (schema_versioned$500,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$786 = [];
		               function full_workspace_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$786[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYb, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$786[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$786[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$786[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_default, 0, 0, [0, bool_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$105,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_home, 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$498,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             aYc,
		             0,
		             0,
		             0,
		             cst_personal,
		             0,
		             2,
		             [0, bool_schema],
		             0,
		             0],
		            [0, [0, 0, 0, 0, 0, cst_members, 0, 2, [0, c], 0, 0], b]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$500,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$121,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  home = c[2][1],
		                                  members = c[1],
		                                  personal = b[1],
		                                  permissions = a[1],
		                                  workspace = param[1];
		                                 return cont
		 ([0, workspace, permissions, personal, members, home]);
		                                },
		                                function(param, cont){
		                                 var
		                                  home = param[5],
		                                  members = param[4],
		                                  personal = param[3],
		                                  permissions = param[2],
		                                  workspace = param[1];
		                                 return caml_exact_trampoline_cps_call$1
		 (is_default,
		  workspace[3][1],
		  workspace[2],
		  function(a){
		   return cont
		           ([0,
		             workspace,
		             [0,
		              permissions,
		              [0, personal, [0, members, [0, home, [0, [0, a], 0]]]]]]);
		  });
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [1, a], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$786[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$786[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$740 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$786, [0, schematic_cache$740]);
		               var
		                full_workspace_schema =
		                  caml_callback
		                   (full_workspace_schema_versione,
		                    [function(param, cont){return cont(0);}]),
		                cst_Builtin_type = "Builtin_type",
		                letrec_function_context$787 = [];
		               function origin_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$787[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYd, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$787[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$787[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$787[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aYn);},
		                                  0,
		                                  0,
		                                  cst_user_defined,
		                                  cst_User_defined,
		                                  aYm,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aYl) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_integration_app,
		                                   cst_Integration_app,
		                                   aYk,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(aYj) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_internal_builtin_type_exte,
		                                    cst_Internal_builtin_type_exte,
		                                    aYi,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(aYh) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_internal_builtin_custom_ty,
		                                     cst_Internal_builtin_custom_ty,
		                                     aYg,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 <= param ? cont(aYf) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_builtin_type,
		                                      cst_Builtin_type,
		                                      aYe,
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$787[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$787[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$741 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$787, [0, schematic_cache$741]);
		               caml_callback
		                (origin_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$788 = [];
		               function field_origin_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$788[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYp, aYo, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$788[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$788[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$788[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aYt);},
		                                  0,
		                                  0,
		                                  cst_table,
		                                  cst_Table,
		                                  [0, aV[1], aYs, aV[3], aV[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(aYr) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_virtual,
		                                   "Virtual",
		                                   [0, aU[1], aYq, aU[3], aU[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$788[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$788[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$742 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$788, [0, schematic_cache$742]);
		               caml_callback
		                (field_origin_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$789 = [];
		               function field_with_origin_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$789[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYu, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$789[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$789[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$789[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (field_origin_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (field_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var origin = param[2][1], value = param[1];
		             return cont([0, value, origin]);
		            },
		            function(param, cont){
		             var origin = param[2], value = param[1];
		             return cont([0, value, [0, origin, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [1, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$789[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$789[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$743 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$789, [0, schematic_cache$743]);
		               caml_callback
		                (field_with_origin_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$790 = [];
		               function database_type_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$790[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYw, aYv, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$790[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$790[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$790[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_type,
		                                 0,
		                                 0,
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   [11,
		                                    0,
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(847309489);},
		                                      function(param, cont){return cont(aYy);},
		                                      0,
		                                      0,
		                                      cst_record,
		                                      cst_Record,
		                                      aYx,
		                                      0],
		                                     0],
		                                    1],
		                                   0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (field_with_origin_schema_versi,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (schema_versioned$143,
		       schematic_version,
		       b,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var fields = param[1];
		             return cont([0, fields]);
		            },
		            function(param, cont){
		             var fields = param[1];
		             return cont([0, fields, aYz]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_fields, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$790[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$790[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$744 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$790, [0, schematic_cache$744]);
		               caml_callback
		                (database_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$791 = [];
		               function schema_versioned$501(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$791[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$791[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$791[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$791[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (origin_schema_versioned$1,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$166,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (database_type_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$162,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_name,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_data_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_description,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [0, c], 0, 0], b]]]];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              workspace = g[2][1],
		              origin = g[1],
		              permissions = f[1],
		              type = e[1],
		              meta = d[1],
		              description = c[1],
		              data_name = b[1],
		              name = a[1],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       name,
		                       data_name,
		                       description,
		                       meta,
		                       type,
		                       permissions,
		                       origin,
		                       workspace]);
		            },
		            function(param, cont){
		             var
		              workspace = param[9],
		              origin = param[8],
		              permissions = param[7],
		              type = param[6],
		              meta = param[5],
		              description = param[4],
		              data_name = param[3],
		              name = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        name,
		                        [0,
		                         data_name,
		                         [0,
		                          description,
		                          [0,
		                           meta,
		                           [0, type, [0, permissions, [0, origin, [0, workspace, 0]]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$791[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$791[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$745 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$791, [0, schematic_cache$745]);
		               caml_callback
		                (schema_versioned$501,
		                 [function(param, cont){return cont(0);}]);
		               function title_field$0(database, cont){
		                var a = database[5];
		                return caml_exact_trampoline_cps_call$1
		                        (map$13,
		                         database[6][1],
		                         function(param, cont){
		                          var value = param[1];
		                          return cont(value);
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (title_field, b, a, cont);
		                         });
		               }
		               var letrec_function_context$792 = [];
		               function schema_versioned$502(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$792[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYC, aYB, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$792[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$792[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$792[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$150,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_cell_path, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var cell_path = param[2][1], table_id = param[1];
		             return cont([0, table_id, cell_path]);
		            },
		            function(param, cont){
		             var cell_path = param[2], table_id = param[1];
		             return cont([0, table_id, [0, cell_path, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$792[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$792[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$746 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$792, [0, schematic_cache$746]);
		               caml_callback
		                (schema_versioned$502,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$793 = [];
		               function schema_versioned$503(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$793[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYE, aYD, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$793[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$793[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$793[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$152,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, aYF, 0, 0, 0, "field_info", 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$164,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, aYG, 0, 0, 0, "target_schema", 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$502,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        field_info = a[2][1],
		                        target_schema = a[1],
		                        target_path = param[1];
		                       return cont([0, target_path, target_schema, field_info]);
		                      },
		                      function(param, cont){
		                       var
		                        field_info = param[3],
		                        target_schema = param[2],
		                        target_path = param[1];
		                       return cont
		                               ([0, target_path, [0, target_schema, [0, field_info, 0]]]);
		                      },
		                      [0, [0, aYH, 0, 0, 0, "target_path", 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$793[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$793[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$747 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$793, [0, schematic_cache$747]);
		               caml_callback
		                (schema_versioned$503,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$504(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$503,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (schema_versioned$143,
		     schematic_version,
		     a,
		     function(a){return cont([0, aYI, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$504,
		                 [function(param, cont){return cont(0);}]);
		               var
		                sexp_of_t$137 = caml_callback(encode$7, [schema$54]),
		                include$280 = Make$1([0, compare$100, sexp_of_t$137]),
		                comparator$58 = include$280[1];
		               caml_callback(M$2, [[0, comparator$58, schema_versioned$156]]);
		               var letrec_function_context$794 = [];
		               function path_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$794[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$794[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$794[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$794[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$142,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, "column_id", 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$105,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var column_id = param[2][1], row_path = param[1];
		             return cont([0, row_path, column_id]);
		            },
		            function(param, cont){
		             var column_id = param[2], row_path = param[1];
		             return cont([0, row_path, [0, column_id, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, "row_path", 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$794[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$794[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$748 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$794, [0, schematic_cache$748]);
		               caml_callback
		                (path_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$795 = [];
		               function schema_versioned$505(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$795[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYL, aYK, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$795[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$795[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$795[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$149,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (path_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var content = param[2][1], path = param[1];
		             return cont([0, path, content]);
		            },
		            function(param, cont){
		             var content = param[2], path = param[1];
		             return cont([0, path, [0, content, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_path, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$795[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$795[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$749 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$795, [0, schematic_cache$749]);
		               caml_callback
		                (schema_versioned$505,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_contents = "contents",
		                letrec_function_context$796 = [];
		               function schema_versioned$506(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$796[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYN, aYM, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$796[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$796[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$796[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$169,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, aYO, 0, 0, 0, cst_parent, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$505,
		       schematic_version,
		       function(b){
		        return caml_trampoline_cps_call3
		                (schema_versioned$143,
		                 schematic_version,
		                 b,
		                 function(c){
		                  var
		                   b =
		                     [0, [0, aYP, 0, 0, 0, cst_contents, 0, 2, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$105,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  parent = a[2][1],
		                                  contents = a[1],
		                                  path = param[1];
		                                 return cont([0, path, contents, parent]);
		                                },
		                                function(param, cont){
		                                 var parent = param[3], contents = param[2], path = param[1];
		                                 return cont([0, path, [0, contents, [0, parent, 0]]]);
		                                },
		                                [0, [0, aYQ, 0, 0, 0, cst_path, 0, 2, [0, a], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$796[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$796[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$750 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$796, [0, schematic_cache$750]);
		               caml_callback
		                (schema_versioned$506,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$507(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$506,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (include$51[27][102],
		     schematic_version,
		     a,
		     function(a){return cont([0, aYR, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$507,
		                 [function(param, cont){return cont(0);}]);
		               var cst_rel = "rel";
		               function schema_versioned$508(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_rel_schema_ver, cont){
		                                    function descriptor(schematic_param_rel_schema_ver, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_inverse_relations,
		  0,
		  2,
		  [0, schematic_param_rel_schema_ver],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$164,
		      schematic_version,
		      function(b){
		       return cont
		               ([7,
		                 function(param, cont){
		                  var inverse_relations = param[2][1], contents = param[1];
		                  return cont([0, contents, inverse_relations]);
		                 },
		                 function(param, cont){
		                  var inverse_relations = param[2], contents = param[1];
		                  return cont([0, contents, [0, inverse_relations, 0]]);
		                 },
		                 [0, [0, 0, 0, 0, 0, cst_contents, 0, 2, [0, b], 0, 0], a]]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$225[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_rel,
		 schematic_param_rel_schema_ver,
		 function(schematic_param_rel_schema_ver, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_rel_schema_ver,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_rel_schema_ver,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, aYS, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function static_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_rel_schema_ver, cont){
		                                    function descriptor(schematic_param_rel_schema_ver, cont){
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$501,
		      schematic_version,
		      function(b){
		       var
		        a =
		          [0,
		           [0, 0, 0, 0, 0, cst_graph_database, 0, 2, [0, b], 0, 0],
		           0];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$167,
		                schematic_version,
		                function(c){
		                 var
		                  b = [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [0, c], 0, 0], a];
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$166,
		                          schematic_version,
		                          function(c){
		                           var
		                            a =
		                              [0, [0, 0, 0, 0, 0, cst_permissions, 0, 2, [0, c], 0, 0], b];
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$508,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (b,
		      schematic_param_rel_schema_ver,
		      function(c){
		       var
		        b =
		          [0, [0, 0, 0, 0, 0, cst_schema$0, 0, 2, [0, c], 0, 0], a];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$162,
		                schematic_version,
		                function(c){
		                 var
		                  a =
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_name,
		                      0,
		                      2,
		                      [0, schematic_param_name_schema_ve],
		                      0,
		                      0],
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_data_name,
		                       0,
		                       2,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [0, c], 0, 0], b]]];
		                 return caml_exact_trampoline_cps_call
		                         (Table[4],
		                          schematic_version,
		                          function(b){
		                           return cont
		                                   ([7,
		                                     function(param, cont){
		                                      var
		                                       a = param[2],
		                                       b = a[2],
		                                       c = b[2],
		                                       d = c[2],
		                                       e = d[2],
		                                       f = e[2],
		                                       graph_database = f[2][1],
		                                       origin = f[1],
		                                       permissions = e[1],
		                                       schema = d[1],
		                                       meta = c[1],
		                                       data_name = b[1],
		                                       name = a[1],
		                                       id = param[1];
		                                      return cont
		      ([0,
		        id,
		        name,
		        data_name,
		        meta,
		        schema,
		        permissions,
		        origin,
		        graph_database]);
		                                     },
		                                     function(param, cont){
		                                      var
		                                       graph_database = param[8],
		                                       origin = param[7],
		                                       permissions = param[6],
		                                       schema = param[5],
		                                       meta = param[4],
		                                       data_name = param[3],
		                                       name = param[2],
		                                       id = param[1];
		                                      return cont
		      ([0,
		        id,
		        [0,
		         name,
		         [0,
		          data_name,
		          [0,
		           meta,
		           [0,
		            schema,
		            [0, permissions, [0, origin, [0, graph_database, 0]]]]]]]]);
		                                     },
		                                     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]]);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$226[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_rel,
		 schematic_param_rel_schema_ver,
		 function(schematic_param_rel_schema_ver, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_rel_schema_ver,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_rel_schema_ver,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                schematic_cache$751 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$797 = [];
		               caml_update_dummy
		                (letrec_function_context$797, [0, schematic_cache$751]);
		               function schematic_version$99(param, cont){return cont(0);}
		               var schematic_schema_version$90 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$797[1][1],
		                    schematic_schema_version$90]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$797[1][1],
		                             schematic_schema_version$90,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$797[1][1],
		schematic_schema_version$90,
		schematic_self,
		function(a){
		 letrec_function_context$797[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$504,
		          schematic_version$99,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (function(schematic_param_rel_schema_ver, cont){
		                     function descriptor(schematic_param_rel_schema_ver, cont){
		                      return caml_exact_trampoline_cps_call
		                              (static_schema_versioned,
		                               schematic_version$99,
		                               function(a){
		                                return caml_exact_trampoline_cps_call
		(a,
		 schematic_param_rel_schema_ver,
		 function(b){
		  var
		   a = [0, [0, 0, 0, 0, 0, cst_static, 0, 2, [0, b], 0, 0], 0];
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$507,
		           schematic_version$99,
		           function(b){
		            return cont
		                    ([7,
		                      function(param, cont){
		                       var static$ = param[2][1], rows = param[1];
		                       return cont([0, rows, static$]);
		                      },
		                      function(param, cont){
		                       var static$ = param[2], rows = param[1];
		                       return cont([0, rows, [0, static$, 0]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_rows, 0, 2, [0, b], 0, 0], a]]);
		           });
		 });
		                               });
		                     }
		                     var
		                      schematic_schema_id = match$227[1],
		                      schematic_parametric =
		                        [0,
		                         [1,
		                          cst_rel,
		                          schematic_param_rel_schema_ver,
		                          function(schematic_param_rel_schema_ver, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (descriptor,
		                                    schematic_param_rel_schema_ver,
		                                    function(a){return cont([0, schematic_schema_id, a]);});
		                          }]];
		                     return caml_exact_trampoline_cps_call
		                             (descriptor,
		                              schematic_param_rel_schema_ver,
		                              function(a){
		                               var parametric = schematic_parametric[1];
		                               return caml_exact_trampoline_cps_call
		                                       (of_parametric,
		parametric,
		function(match){
		 function b(b){
		  return cont([0, b, aYT, a, schematic_parametric]);
		 }
		 if(! match) return b(0);
		 var name = match[1];
		 return caml_exact_trampoline_cps_call
		         (to_id, name, function(a){return b([0, a]);});
		});
		                              });
		                    },
		                    a,
		                    function(a){
		                     return caml_trampoline_cps_call3
		                             (Table[27][102],
		                              schematic_version$99,
		                              a,
		                              function(b){
		                               var
		                                a = [0, [0, 0, 0, 0, 0, cst_tables, 0, 2, [0, b], 0, 0], 0];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$120,
		schematic_version$99,
		function(b){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var tables = param[2][1], workspace_id = param[1];
		      return cont([0, workspace_id, tables]);
		     },
		     function(param, cont){
		      var tables = param[2], workspace_id = param[1];
		      return cont([0, workspace_id, [0, tables, 0]]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		      a]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$797[1][1],
		          schematic_schema_version$90,
		          res,
		          function(a){
		           letrec_function_context$797[1][1] = a;
		           return cont(res);
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$798 = [];
		               function expanded_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$798[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYV, aYU, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$798[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$798[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$798[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$51[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_row_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$120,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        row_id = a[2][1],
		                        table_id = a[1],
		                        workspace_id = param[1];
		                       return cont([0, workspace_id, table_id, row_id]);
		                      },
		                      function(param, cont){
		                       var
		                        row_id = param[3],
		                        table_id = param[2],
		                        workspace_id = param[1];
		                       return cont
		                               ([0, workspace_id, [0, table_id, [0, row_id, 0]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_workspace_id, 0, 3, [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$798[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$798[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$752 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$798, [0, schematic_cache$752]);
		               caml_callback
		                (expanded_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function parametric_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    function descriptor(schematic_param_a_schema_versi, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_data,
		  0,
		  2,
		  [0, schematic_param_a_schema_versi],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (expanded_id_schema_versioned,
		      schematic_version,
		      function(b){
		       return cont
		               ([7,
		                 function(param, cont){
		                  var data = param[2][1], expanded_id = param[1];
		                  return cont([0, expanded_id, data]);
		                 },
		                 function(param, cont){
		                  var data = param[2], expanded_id = param[1];
		                  return cont([0, expanded_id, [0, data, 0]]);
		                 },
		                 [0, [0, 0, 0, 0, 0, "expanded_id", 0, 2, [0, b], 0, 0], a]]);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$228[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_a$0,
		 schematic_param_a_schema_versi,
		 function(schematic_param_a_schema_versi, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_a_schema_versi,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_a_schema_versi,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function schema_versioned$509(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_trampoline_cps_call2
		                                  (schema_versioned$92,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (parametric_schema_versioned,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (b, a, function(a){return cont([0, aYX, aYW, a[3], a[4]]);});
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$509,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$799 = [];
		               function schema_versioned$510(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$799[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aYY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$799[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$799[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$799[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$501,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_table,
		   cst_Table,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$162,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_name,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_data_name,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0, [0, 0, 0, 0, 0, cst_meta, 0, 2, [0, c], 0, 0], 0]]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$156,
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [11,
		                      aYZ,
		                      [0,
		                       [0,
		                        function(param, cont){
		                         var
		                          f3 = param[4],
		                          f2 = param[3],
		                          f1 = param[2],
		                          f0 = param[1];
		                         return cont([0, f0, f1, f2, f3]);
		                        },
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var
		                          f3 = param[4],
		                          f2 = param[3],
		                          f1 = param[2],
		                          f0 = param[1];
		                         return cont([0, [0, f0, f1, f2, f3]]);
		                        },
		                        1,
		                        0,
		                        cst_default,
		                        cst_Default,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            b = a[2],
		                            meta = b[2][1],
		                            data_name = b[1],
		                            name = a[1],
		                            id = param[1];
		                           return cont([0, id, name, data_name, meta]);
		                          },
		                          function(param, cont){
		                           var
		                            meta = param[4],
		                            data_name = param[3],
		                            name = param[2],
		                            id = param[1];
		                           return cont
		                                   ([0, id, [0, name, [0, data_name, [0, meta, 0]]]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b]],
		                         0],
		                        0],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$799[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$799[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$753 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$799, [0, schematic_cache$753]);
		               caml_callback
		                (schema_versioned$510,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$754 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$800 = [];
		               caml_update_dummy
		                (letrec_function_context$800, [0, schematic_cache$754]);
		               var
		                schematic_schema_version$40 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$800[1][1],
		                     schematic_schema_version$40]);
		               if(e)
		                var schema$188 = e[1], descriptor$27 = schema$188;
		               else
		                descriptor$27 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$800[1][1],
		                              schematic_schema_version$40,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$800[1][1],
		 schematic_schema_version$40,
		 schematic_self,
		 function(a){
		  letrec_function_context$800[1][1] = a;
		  var
		   res =
		     [11,
		      0,
		      [0,
		       [0,
		        function(param, cont){return cont(0);},
		        function(param, cont){return param ? cont(0) : cont(aZk);},
		        0,
		        0,
		        cst_task,
		        cst_Task,
		        aZj,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(1);},
		         function(param, cont){
		          return 1 === param ? cont(aZi) : cont(0);
		         },
		         0,
		         0,
		         cst_event,
		         cst_Event,
		         aZh,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(2);},
		          function(param, cont){
		           return 2 === param ? cont(aZg) : cont(0);
		          },
		          0,
		          0,
		          cst_page,
		          cst_Page,
		          aZf,
		          0],
		         [0,
		          [0,
		           function(param, cont){return cont(3);},
		           function(param, cont){
		            return 3 === param ? cont(aZe) : cont(0);
		           },
		           0,
		           0,
		           cst_people,
		           cst_People,
		           aZd,
		           0],
		          [0,
		           [0,
		            function(param, cont){return cont(4);},
		            function(param, cont){
		             return 4 === param ? cont(aZc) : cont(0);
		            },
		            0,
		            0,
		            cst_calendar,
		            cst_Calendar,
		            aZb,
		            0],
		           [0,
		            [0,
		             function(param, cont){return cont(5);},
		             function(param, cont){
		              return 5 === param ? cont(aZa) : cont(0);
		             },
		             0,
		             0,
		             cst_member,
		             cst_Member,
		             aY$,
		             0],
		            [0,
		             [0,
		              function(param, cont){return cont(6);},
		              function(param, cont){
		               return 6 === param ? cont(aY_) : cont(0);
		              },
		              0,
		              0,
		              cst_ai_agent,
		              cst_Ai_agent,
		              aY9,
		              0],
		             [0,
		              [0,
		               function(param, cont){return cont(7);},
		               function(param, cont){
		                return 7 === param ? cont(aY8) : cont(0);
		               },
		               0,
		               0,
		               cst_ai_step,
		               "Ai_step",
		               aY7,
		               0],
		              [0,
		               [0,
		                function(param, cont){return cont(8);},
		                function(param, cont){
		                 return 8 === param ? cont(aY6) : cont(0);
		                },
		                0,
		                0,
		                cst_ai_automation$0,
		                cst_Ai_automation,
		                aY5,
		                0],
		               [0,
		                [0,
		                 function(param, cont){return cont(9);},
		                 function(param, cont){
		                  return 9 === param ? cont(aY4) : cont(0);
		                 },
		                 0,
		                 0,
		                 cst_ai_conversation,
		                 cst_Ai_conversation,
		                 aY3,
		                 0],
		                [0,
		                 [0,
		                  function(param, cont){return cont(10);},
		                  function(param, cont){
		                   return 10 <= param ? cont(aY2) : cont(0);
		                  },
		                  0,
		                  0,
		                  cst_ai_automation_run,
		                  cst_Ai_automation_run,
		                  aY1,
		                  0],
		                 0]]]]]]]]]]],
		      0];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$800[1][1],
		           schematic_schema_version$40,
		           res,
		           function(a){
		            letrec_function_context$800[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var kind_schema = [0, aY0, 0, descriptor$27, 0];
		               function id_of(param, cont){
		                switch(param){
		                  case 0:
		                   return cont(bP6);
		                  case 1:
		                   return cont(bP7);
		                  case 2:
		                   return cont(bP8);
		                  case 3:
		                   return cont(bQ6);
		                  case 4:
		                   return cont(bQ7);
		                  case 5:
		                   return caml_exact_trampoline_cps_call
		                           (Table[28], cst_members, cont);
		                  case 6:
		                   return cont(bQ8);
		                  case 7:
		                   return cont(bQ9);
		                  case 8:
		                   return cont(bQ_);
		                  case 9:
		                   return cont(bQ$);
		                  default: return cont(bRa);
		                }
		               }
		               function schematic_version$100(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (features_schema_versioned, [schematic_version$100]),
		                features_schema = [0, aZl, 0, e[3], e[4]],
		                letrec_function_context$801 = [];
		               function compare_document(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$801[3],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          if(0 !== x) return cont(x);
		                          var y = rhs[2], x$0 = lhs[2];
		                          if(! x$0) return y ? cont(-1) : cont(0);
		                          var a = x$0[1];
		                          if(! y) return cont(1);
		                          var
		                           b = y[1],
		                           rhs1 = b[2],
		                           rhs0 = b[1],
		                           lhs1 = a[2],
		                           lhs0 = a[1];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$801[2],
		                                   0,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (a,
		     lhs0,
		     rhs0,
		     function(x){
		      return 0 === x
		              ? caml_trampoline_cps_call2
		                (letrec_function_context$801[1],
		                 0,
		                 function(a){
		                  return caml_trampoline_cps_call3(a, lhs1, rhs1, cont);
		                 })
		              : cont(x);
		     });
		                                   });
		                         });
		               }
		               function _2$28(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _1$53(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$801, [0, _2$28, _1$53, compare$104]);
		               var cst_section = "section", letrec_function_context$802 = [];
		               function document_schema_versioned(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$802[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZm, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$802[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$802[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$802[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var section = param[2][1], id = param[1];
		                                 return cont([0, id, section]);
		                                },
		                                function(param, cont){
		                                 var section = param[2], id = param[1];
		                                 return cont([0, id, [0, section, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_id,
		                                  0,
		                                  2,
		                                  [0, schema_versioned$182()],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_section,
		                                   0,
		                                   3,
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     [10,
		                                      function(param, cont){
		                                       var e1 = param[2][1], e0 = param[1];
		                                       return cont([0, e0, e1]);
		                                      },
		                                      function(param, cont){
		                                       var e1 = param[2], e0 = param[1];
		                                       return cont([0, e0, [0, e1, 0]]);
		                                      },
		                                      [0, schematic_param_name_schema_ve, [0, int_schema, 0]]],
		                                     0]],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$802[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$802[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$755 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$802, [0, schematic_cache$755]);
		               var
		                document_schema =
		                  caml_callback
		                   (document_schema_versioned,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$803 = [];
		               function pp_document(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         aZn,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aZo,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     "Mandate_routine_intf.id",
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$803[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aZp,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aZq,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aZr,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_section,
		                         function(a){
		                          a = x[2];
		                          function b(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    aZx,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), aZy, cont);
		                                    });
		                          }
		                          if(! a)
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_None, b);
		                          var x$0 = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   fmt,
		                                   cst_Some,
		                                   function(a){
		                                    var a1 = x$0[2], a0 = x$0[1];
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aZs,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               aZt,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         a0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   aZu,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     aZv,
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               a1,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         aZw,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string, fmt, cst$18, b);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy(letrec_function_context$803, [0, pp_v$0]);
		               var letrec_function_context$804 = [];
		               function schema_versioned$511(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$804[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZz, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$804[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$804[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$804[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (document_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_document,
		   cst_Document,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$16,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            aZA,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              cst_calendar,
		              cst_Calendar,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){var id = param[1]; return cont(id);},
		                function(id, cont){return cont([0, id, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$804[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$804[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$756 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$804, [0, schematic_cache$756]);
		               caml_callback
		                (schema_versioned$511,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$805 = [];
		               function schema_versioned$512(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$805[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$805[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$805[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$805[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var name = param[2][1], id = param[1];
		                                 return cont([0, id, name]);
		                                },
		                                function(param, cont){
		                                 var name = param[2], id = param[1];
		                                 return cont([0, id, [0, name, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$805[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$805[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$757 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$805, [0, schematic_cache$757]);
		               caml_callback
		                (schema_versioned$512,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$806 = [];
		               function schema_versioned$513(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$806[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$806[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$806[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$806[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$339,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    id = b[2][1],
		    helper = b[1],
		    email_primary = a[1],
		    email = param[1];
		   return cont([0, email, email_primary, helper, id]);
		  },
		  function(param, cont){
		   var
		    id = param[4],
		    helper = param[3],
		    email_primary = param[2],
		    email = param[1];
		   return cont
		           ([0, email, [0, email_primary, [0, helper, [0, id, 0]]]]);
		  },
		  [0,
		   [0,
		    aZF,
		    0,
		    0,
		    0,
		    cst_email,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     aZE,
		     0,
		     0,
		     0,
		     "emailPrimary",
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      aZD,
		      0,
		      0,
		      0,
		      "helper",
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$806[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$806[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$758 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$806, [0, schematic_cache$758]);
		               caml_callback
		                (schema_versioned$513,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$807 = [];
		               function schema_versioned$514(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$807[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$807[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$807[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$807[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var name = param[2][1], id = param[1];
		                                 return cont([0, id, name]);
		                                },
		                                function(param, cont){
		                                 var name = param[2], id = param[1];
		                                 return cont([0, id, [0, name, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$807[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$807[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$759 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$807, [0, schematic_cache$759]);
		               caml_callback
		                (schema_versioned$514,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$515(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$501,
		                                   schematic_version,
		                                   function(schematic_param_type_schema_ve){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$514,
		     schematic_version,
		     function(schematic_param_priority_schem){
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$513,
		               schematic_version,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (participant_schema_versioned,
		                         schematic_version,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (b,
		                                   a,
		                                   function(schematic_param_participant_sc){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$512,
		     schematic_version,
		     function(schematic_param_label_schema_v){
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$511,
		               schematic_version,
		               function(schematic_param_dest_schema_ve){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$0,
		                         function(schematic_schema_version){
		                          function descriptor
		                          (schematic_param_dest_schema_ve,
		                           schematic_param_label_schema_v,
		                           schematic_param_participant_sc,
		                           schematic_param_priority_schem,
		                           schematic_param_type_schema_ve,
		                           cont){
		                           return caml_exact_trampoline_cps_call
		                                   (completion_schema_versioned,
		                                    schematic_version,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$3
		     (a,
		      schematic_param_dest_schema_ve,
		      schematic_param_label_schema_v,
		      schematic_param_participant_sc,
		      schematic_param_priority_schem,
		      schematic_param_type_schema_ve,
		      function(a){
		       return cont
		               ([7,
		                 function(param, cont){
		                  var completions = param[2][1], replaced = param[1];
		                  return cont([0, replaced, completions]);
		                 },
		                 function(param, cont){
		                  var completions = param[2], replaced = param[1];
		                  return cont([0, replaced, [0, completions, 0]]);
		                 },
		                 [0,
		                  [0, 0, 0, 0, 0, "replaced", 0, 2, [0, int_schema], 0, 0],
		                  [0,
		                   [0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    cst_completions,
		                    0,
		                    2,
		                    [0, schema_versioned$7(schematic_version, a)],
		                    0,
		                    0],
		                   0]]]);
		      });
		                                    });
		                          }
		                          var
		                           schematic_schema_id = match$44[1],
		                           schematic_parametric =
		                             [0,
		                              [1,
		                               cst_dest,
		                               schematic_param_dest_schema_ve,
		                               function(schematic_param_dest_schema_ve, cont){
		                                return cont
		([1,
		  cst_label,
		  schematic_param_label_schema_v,
		  function(schematic_param_label_schema_v, cont){
		   return cont
		           ([1,
		             cst_participant,
		             schematic_param_participant_sc,
		             function(schematic_param_participant_sc, cont){
		              return cont
		                      ([1,
		                        cst_priority,
		                        schematic_param_priority_schem,
		                        function(schematic_param_priority_schem, cont){
		                         return cont
		                                 ([1,
		                                   cst_type$0,
		                                   schematic_param_type_schema_ve,
		                                   function(schematic_param_type_schema_ve, cont){
		                                    return caml_exact_trampoline_cps_call$3
		    (descriptor,
		     schematic_param_dest_schema_ve,
		     schematic_param_label_schema_v,
		     schematic_param_participant_sc,
		     schematic_param_priority_schem,
		     schematic_param_type_schema_ve,
		     function(a){return cont([0, schematic_schema_id, a]);});
		                                   }]);
		                        }]);
		             }]);
		  }]);
		                               }]];
		                          return caml_exact_trampoline_cps_call$3
		                                  (descriptor,
		                                   schematic_param_dest_schema_ve,
		                                   schematic_param_label_schema_v,
		                                   schematic_param_participant_sc,
		                                   schematic_param_priority_schem,
		                                   schematic_param_type_schema_ve,
		                                   function(a){
		                                    var parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, aZH, 0, a, schematic_parametric]);
		      }
		      if(! match) return b();
		      var name = match[1];
		      return caml_exact_trampoline_cps_call(to_id, name, b);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$515,
		                 [function(param, cont){return cont(0);}]);
		               function completion_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$501,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$514,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$513,
		               schematic_version,
		               function(c){
		                return caml_exact_trampoline_cps_call
		                        (participant_schema_versioned,
		                         schematic_version,
		                         function(d){
		                          return caml_exact_trampoline_cps_call
		                                  (d,
		                                   c,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$512,
		     schematic_version,
		     function(d){
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$511,
		               schematic_version,
		               function(e){
		                return caml_exact_trampoline_cps_call
		                        (completion_schema_versioned,
		                         schematic_version,
		                         function(f){
		                          return caml_exact_trampoline_cps_call$3
		                                  (f,
		                                   e,
		                                   d,
		                                   c,
		                                   b,
		                                   a,
		                                   function(a){return cont([0, , , a[3], a[4]]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback
		                (completion_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$516(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$501,
		                                   schematic_version,
		                                   function(schematic_param_type_schema_ve){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$202,
		     schematic_version,
		     function(schematic_param_slot_schema_ve){
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$514,
		               schematic_version,
		               function(schematic_param_priority_schem){
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$513,
		                         schematic_version,
		                         function(schematic_param_participant_sc){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$512,
		                                   schematic_version,
		                                   function(schematic_param_label_schema_v){
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$511,
		     schematic_version,
		     function(schematic_param_dest_schema_ve){
		      return caml_exact_trampoline_cps_call
		              (schematic_version,
		               V$0,
		               function(schematic_schema_version){
		                function descriptor$0
		                (schematic_param_dest_schema_ve,
		                 schematic_param_label_schema_v,
		                 schematic_param_participant_sc,
		                 schematic_param_priority_schem,
		                 schematic_param_slot_schema_ve,
		                 schematic_param_type_schema_ve,
		                 cont){
		                 var
		                  a =
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_slot,
		                      0,
		                      3,
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        [10,
		                         function(param, cont){
		                          var e1 = param[2][1], e0 = param[1];
		                          return cont([0, e0, e1]);
		                         },
		                         function(param, cont){
		                          var e1 = param[2], e0 = param[1];
		                          return cont([0, e0, [0, e1, 0]]);
		                         },
		                         [0,
		                          schematic_param_name_schema_ve,
		                          [0, schematic_param_slot_schema_ve, 0]]],
		                        0]],
		                      0,
		                      0],
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_type,
		                       0,
		                       3,
		                       [0, schematic_param_type_schema_ve],
		                       0,
		                       0],
		                      0]];
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$15,
		                          schematic_version,
		                          function(c){
		                           var
		                            b =
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_priority,
		                                0,
		                                3,
		                                [0, schematic_param_priority_schem],
		                                0,
		                                0],
		                               [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 3, [0, c], 0, 0], a]];
		                           return caml_exact_trampoline_cps_call
		                                   (participant_schema_versioned,
		                                    schematic_version,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (a,
		      schematic_param_participant_sc,
		      function(c){
		       var
		        default$ = match$41[1],
		        default$0 = match$42[1],
		        a =
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_destination,
		            0,
		            3,
		            [0, schematic_param_dest_schema_ve],
		            0,
		            0],
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_duration,
		             0,
		             3,
		             [0, [0, q, documentation$0, descriptor, parametric]],
		             0,
		             0],
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_labels,
		              0,
		              [0, default$0],
		              [0, [0, 0, 0, [3, schematic_param_label_schema_v], 0]],
		              0,
		              0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_participants,
		               0,
		               [0, default$],
		               [0, [0, 0, 0, [3, c], 0]],
		               0,
		               0],
		              b]]]];
		       return caml_exact_trampoline_cps_call
		               (option_schema,
		                schema_versioned$2(schematic_version),
		                function(c){
		                 var
		                  b =
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_daytime,
		                      0,
		                      3,
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        [10,
		                         function(param, cont){
		                          var e1 = param[2][1], e0 = param[1];
		                          return cont([0, e0, e1]);
		                         },
		                         function(param, cont){
		                          var e1 = param[2], e0 = param[1];
		                          return cont([0, e0, [0, e1, 0]]);
		                         },
		                         [0, schema_versioned$2(schematic_version), [0, c, 0]]],
		                        0]],
		                      0,
		                      0],
		                     a];
		                 return caml_exact_trampoline_cps_call
		                         (dates_schema_versioned,
		                          schematic_version,
		                          function(a){
		                           return cont
		                                   ([7,
		                                     function(param, cont){
		                                      var
		                                       a = param[2],
		                                       b = a[2],
		                                       c = b[2],
		                                       d = c[2],
		                                       e = d[2],
		                                       f = e[2],
		                                       g = f[2],
		                                       h = g[2],
		                                       type = h[2][1],
		                                       slot = h[1],
		                                       recurrence = g[1],
		                                       priority = f[1],
		                                       participants = e[1],
		                                       labels = d[1],
		                                       duration = c[1],
		                                       destination = b[1],
		                                       daytime = a[1],
		                                       dates = param[1];
		                                      return cont
		      ([0,
		        dates,
		        daytime,
		        destination,
		        duration,
		        labels,
		        participants,
		        priority,
		        recurrence,
		        slot,
		        type]);
		                                     },
		                                     function(param, cont){
		                                      var
		                                       type = param[10],
		                                       slot = param[9],
		                                       recurrence = param[8],
		                                       priority = param[7],
		                                       participants = param[6],
		                                       labels = param[5],
		                                       duration = param[4],
		                                       destination = param[3],
		                                       daytime = param[2],
		                                       dates = param[1];
		                                      return cont
		      ([0,
		        dates,
		        [0,
		         daytime,
		         [0,
		          destination,
		          [0,
		           duration,
		           [0,
		            labels,
		            [0,
		             participants,
		             [0, priority, [0, recurrence, [0, slot, [0, type, 0]]]]]]]]]]);
		                                     },
		                                     [0, [0, 0, 0, 0, 0, cst_dates, 0, 3, [0, a], 0, 0], b]]);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 schematic_schema_id = match$43[1],
		                 schematic_parametric =
		                   [0,
		                    [1,
		                     cst_dest,
		                     schematic_param_dest_schema_ve,
		                     function(schematic_param_dest_schema_ve, cont){
		                      return cont
		                              ([1,
		                                cst_label,
		                                schematic_param_label_schema_v,
		                                function(schematic_param_label_schema_v, cont){
		                                 return cont
		 ([1,
		   cst_participant,
		   schematic_param_participant_sc,
		   function(schematic_param_participant_sc, cont){
		    return cont
		            ([1,
		              cst_priority,
		              schematic_param_priority_schem,
		              function(schematic_param_priority_schem, cont){
		               return cont
		                       ([1,
		                         cst_slot,
		                         schematic_param_slot_schema_ve,
		                         function(schematic_param_slot_schema_ve, cont){
		                          return cont
		                                  ([1,
		                                    cst_type$0,
		                                    schematic_param_type_schema_ve,
		                                    function(schematic_param_type_schema_ve, cont){
		                                     return caml_exact_trampoline_cps_call$7
		     (descriptor$0,
		      schematic_param_dest_schema_ve,
		      schematic_param_label_schema_v,
		      schematic_param_participant_sc,
		      schematic_param_priority_schem,
		      schematic_param_slot_schema_ve,
		      schematic_param_type_schema_ve,
		      function(a){return cont([0, schematic_schema_id, a]);});
		                                    }]);
		                         }]);
		              }]);
		   }]);
		                                }]);
		                     }]];
		                return caml_exact_trampoline_cps_call$7
		                        (descriptor$0,
		                         schematic_param_dest_schema_ve,
		                         schematic_param_label_schema_v,
		                         schematic_param_participant_sc,
		                         schematic_param_priority_schem,
		                         schematic_param_slot_schema_ve,
		                         schematic_param_type_schema_ve,
		                         function(a){
		                          var parametric = schematic_parametric[1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_parametric,
		                                   parametric,
		                                   function(match){
		                                    function b(b){
		                                     return cont([0, aZI, 0, a, schematic_parametric]);
		                                    }
		                                    if(! match) return b();
		                                    var name = match[1];
		                                    return caml_exact_trampoline_cps_call(to_id, name, b);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                schema$189 =
		                  caml_callback
		                   (schema_versioned$516,
		                    [function(param, cont){return cont(0);}]),
		                bOH = [];
		               function action_allocation_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOH[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOH[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOH[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOH[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$202,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_slot,
		   0,
		   3,
		   [0,
		    [0,
		     0,
		     0,
		     [10,
		      function(param, cont){
		       var e1 = param[2][1], e0 = param[1];
		       return cont([0, e0, e1]);
		      },
		      function(param, cont){
		       var e1 = param[2], e0 = param[1];
		       return cont([0, e0, [0, e1, 0]]);
		      },
		      [0, schematic_param_name_schema_ve, [0, b, 0]]],
		     0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$15,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$513,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (participant_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            return caml_exact_trampoline_cps_call
		                                    (c,
		                                     a,
		                                     function(c){
		                                      var
		                                       default$ = match$229[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_duration,
		   0,
		   2,
		   [0, [0, q, documentation$0, descriptor, parametric]],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_participants,
		    0,
		    [0, default$],
		    [0, [0, 0, 0, [3, c], 0]],
		    0,
		    0],
		   b]];
		                                      return caml_exact_trampoline_cps_call
		      (document_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_document, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schema_versioned$2(schematic_version),
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_daytime,
		                       0,
		                       3,
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         [10,
		                          function(param, cont){
		                           var e1 = param[2][1], e0 = param[1];
		                           return cont([0, e0, e1]);
		                          },
		                          function(param, cont){
		                           var e1 = param[2], e0 = param[1];
		                           return cont([0, e0, [0, e1, 0]]);
		                          },
		                          [0, schema_versioned$2(schematic_version), [0, c, 0]]],
		                         0]],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (dates_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b = [0, [0, 0, 0, 0, 0, cst_dates, 0, 3, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$16,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    slot = f[2][1],
		    recurrence = f[1],
		    participants = e[1],
		    duration = d[1],
		    document = c[1],
		    daytime = b[1],
		    dates = a[1],
		    calendar = param[1];
		   return cont
		           ([0,
		             calendar,
		             dates,
		             daytime,
		             document,
		             duration,
		             participants,
		             recurrence,
		             slot]);
		  },
		  function(param, cont){
		   var
		    slot = param[8],
		    recurrence = param[7],
		    participants = param[6],
		    duration = param[5],
		    document = param[4],
		    daytime = param[3],
		    dates = param[2],
		    calendar = param[1];
		   return cont
		           ([0,
		             calendar,
		             [0,
		              dates,
		              [0,
		               daytime,
		               [0,
		                document,
		                [0,
		                 duration,
		                 [0, participants, [0, recurrence, [0, slot, 0]]]]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_calendar, 0, 3, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOH[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOH[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOI = [];
		               function action_time_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOI[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOI[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOI[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOI[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$513,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (participant_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(b){
		                  var
		                   default$ = match$230[1],
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_participants,
		                       0,
		                       [0, default$],
		                       [0, [0, 0, 0, [3, b], 0]],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (document_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_daytime,
		                                 0,
		                                 3,
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   [10,
		                                    function(param, cont){
		                                     var e1 = param[2][1], e0 = param[1];
		                                     return cont([0, e0, e1]);
		                                    },
		                                    function(param, cont){
		                                     var e1 = param[2], e0 = param[1];
		                                     return cont([0, e0, [0, e1, 0]]);
		                                    },
		                                    [0,
		                                     schema_versioned$2(schematic_version),
		                                     [0, [0, q, documentation$0, descriptor, parametric], 0]]],
		                                   0]],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_document, 0, 3, [0, c], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$15,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$1,
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0,
		            [0, 0, 0, 0, 0, cst_date, 0, 2, [0, schema(d, a)], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$16,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        participants = c[2][1],
		                        document = c[1],
		                        daytime = b[1],
		                        date = a[1],
		                        calendar = param[1];
		                       return cont
		                               ([0, calendar, date, daytime, document, participants]);
		                      },
		                      function(param, cont){
		                       var
		                        participants = param[5],
		                        document = param[4],
		                        daytime = param[3],
		                        date = param[2],
		                        calendar = param[1];
		                       return cont
		                               ([0,
		                                 calendar,
		                                 [0, date, [0, daytime, [0, document, [0, participants, 0]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_calendar, 0, 3, [0, a], 0, 0], c]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOI[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bOI[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema$0 = match[1];
		                 return cont(schema$0);
		                });
		      },
		      a);
		                                    var schema$0 = match[1];
		                                    return a(schema$0);
		                                   });
		                         });
		               }
		               var bOJ = [];
		               function action_document_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOJ[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZL, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOJ[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOJ[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOJ[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (block_type_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$231[1],
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_block, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (document_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var block = param[2][1], document = param[1];
		             return cont([0, document, block]);
		            },
		            function(param, cont){
		             var block = param[2], document = param[1];
		             return cont([0, document, [0, block, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_document, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOJ[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOJ[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOK = [];
		               function block_type_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOK[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZM, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOK[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOK[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOK[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(aZS);},
		                                  0,
		                                  0,
		                                  cst_bullet,
		                                  cst_Bullet,
		                                  aZR,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(aZQ) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_bullet_ordered,
		                                   "Bullet_ordered",
		                                   aZP,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(aZO) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_paragraph,
		                                    cst_Paragraph,
		                                    aZN,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOK[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOK[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOL = [];
		               function action_task_postponing_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOL[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZT, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOL[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOL[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOL[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (document_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_document, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$5,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var document = param[2][1], batch = param[1];
		             return cont([0, batch, document]);
		            },
		            function(param, cont){
		             var document = param[2], batch = param[1];
		             return cont([0, batch, [0, document, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_batch, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOL[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOL[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOM = [];
		               function action_task_recurrence_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOM[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZU, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOM[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOM[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOM[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (document_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_document, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$15,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var document = param[2][1], recurrence = param[1];
		             return cont([0, recurrence, document]);
		            },
		            function(param, cont){
		             var document = param[2], recurrence = param[1];
		             return cont([0, recurrence, [0, document, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bOM[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bOM[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bON = [];
		               function action_task_scheduling_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bON[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZV, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bON[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bON[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bON[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (document_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_document, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$1,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var document = param[2][1], date = param[1];
		             return cont([0, date, document]);
		            },
		            function(param, cont){
		             var document = param[2], date = param[1];
		             return cont([0, date, [0, document, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_date, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bON[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bON[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$808 = [];
		               function action_task_document_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$808[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, aZW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$808[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$808[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$808[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (document_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_document, 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$501,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var document = param[2][1], database = param[1];
		             return cont([0, database, document]);
		            },
		            function(param, cont){
		             var document = param[2], database = param[1];
		             return cont([0, database, [0, document, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_database, 0, 3, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$808[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$808[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               function capturable_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_schema_version, cont){
		                                    function descriptor(schematic_param_schema_version, cont){
		                                     var
		                                      a =
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_value,
		  0,
		  2,
		  [1, schematic_param_schema_version],
		  0,
		  0],
		 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$514,
		      schematic_version,
		      function(c){
		       var
		        b =
		          [0, [0, 0, 0, 0, 0, cst_priority, 0, 3, [0, c], 0, 0], a];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$512,
		                schematic_version,
		                function(a){
		                 var default$ = match$232[1];
		                 return cont
		                         ([7,
		                           function(param, cont){
		                            var
		                             a = param[2],
		                             b = a[2],
		                             value = b[2][1],
		                             priority = b[1],
		                             labels = a[1],
		                             capture = param[1];
		                            return cont([0, capture, labels, priority, value]);
		                           },
		                           function(param, cont){
		                            var
		                             value = param[4],
		                             priority = param[3],
		                             labels = param[2],
		                             capture = param[1];
		                            return cont
		                                    ([0, capture, [0, labels, [0, priority, [0, value, 0]]]]);
		                           },
		                           [0,
		                            [0, 0, 0, 0, 0, "capture", 0, 2, [0, bool_schema], 0, 0],
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              cst_labels,
		                              0,
		                              [0, default$],
		                              [0, [0, 0, 0, [3, a], 0]],
		                              0,
		                              0],
		                             b]]]);
		                });
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$233[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_t,
		 schematic_param_schema_version,
		 function(schematic_param_schema_version, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           schematic_param_schema_version,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_schema_version,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){
		                 return cont([0, b, 0, a, schematic_parametric]);
		                }
		                if(! match) return b(0);
		                var name = match[1];
		                return caml_exact_trampoline_cps_call
		                        (to_id, name, function(a){return b([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var schematic_cache$760 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOH, [0, schematic_cache$760]);
		               var schematic_cache$761 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOI, [0, schematic_cache$761]);
		               var schematic_cache$762 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOJ, [0, schematic_cache$762]);
		               var schematic_cache$763 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOK, [0, schematic_cache$763]);
		               var schematic_cache$764 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOL, [0, schematic_cache$764]);
		               var schematic_cache$765 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOM, [0, schematic_cache$765]);
		               var schematic_cache$766 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bON, [0, schematic_cache$766]);
		               var schematic_cache$767 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$808, [0, schematic_cache$767]);
		               var
		                action_allocation_schema =
		                  caml_callback
		                   (action_allocation_schema_versi,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_time_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_document_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (block_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_task_postponing_schema_,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_task_recurrence_schema_,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_task_scheduling_schema_,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (action_task_document_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$768 = [0, empty$11([0, comparator$9])],
		                bOO = [];
		               caml_update_dummy(bOO, [0, schematic_cache$768]);
		               var
		                schematic_cache$769 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$809 = [];
		               caml_update_dummy
		                (letrec_function_context$809, [0, schematic_cache$769]);
		               function schematic_version$101(param, cont){return cont(0);}
		               var
		                schematic_schema_version$89 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [bOO[1][1], schematic_schema_version$89]),
		                cst_Event_creation = "Event_creation",
		                cst_Task_allocation = "Task_allocation",
		                cst_Task_postponing = "Task_postponing",
		                cst_Task_recurrence = "Task_recurrence",
		                cst_Task_scheduling = "Task_scheduling",
		                cst_task_allocation = "task-allocation",
		                cst_task_postponing = "task-postponing",
		                cst_task_recurrence = "task-recurrence",
		                cst_task_scheduling = "task-scheduling";
		               if(e)
		                var schema$190 = e[1], descriptor$28 = schema$190;
		               else
		                descriptor$28 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              bOO[1][1],
		                              schematic_schema_version$89,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bOO[1][1],
		 schematic_schema_version$89,
		 schematic_self,
		 function(a){
		  bOO[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (action_task_document_schema_ve,
		           schematic_version$101,
		           function(a){
		            return caml_exact_trampoline_cps_call
		                    (capturable_schema_versioned,
		                     schematic_version$101,
		                     function(b){
		                      return caml_exact_trampoline_cps_call
		                              (b,
		                               a,
		                               function(b){
		                                var
		                                 a =
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([0, 936373093, f0]);},
		                                     function(param, cont){
		                                      if(typeof param !== "number"){
		                                       var variant = param[1];
		                                       if(936373093 === variant){
		var f0 = param[2];
		return cont([0, f0]);
		                                       }
		                                      }
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_task,
		                                     cst_Task,
		                                     b,
		                                     0],
		                                    0];
		                                return caml_exact_trampoline_cps_call
		(action_task_scheduling_schema_,
		 schematic_version$101,
		 function(b){
		  return caml_exact_trampoline_cps_call
		          (capturable_schema_versioned,
		           schematic_version$101,
		           function(c){
		            return caml_exact_trampoline_cps_call
		                    (c,
		                     b,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           function(f0, cont){return cont([0, 63748398, f0]);},
		                           function(param, cont){
		                            if(typeof param !== "number"){
		                             var variant = param[1];
		                             if(63748398 === variant){
		                              var f0 = param[2];
		                              return cont([0, f0]);
		                             }
		                            }
		                            return cont(0);
		                           },
		                           0,
		                           0,
		                           cst_task_scheduling,
		                           cst_Task_scheduling,
		                           c,
		                           0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (action_task_recurrence_schema_,
		                               schematic_version$101,
		                               function(c){
		                                var
		                                 a =
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([0, 1055840202, f0]);},
		                                     function(param, cont){
		                                      if(typeof param !== "number"){
		                                       var variant = param[1];
		                                       if(1055840202 === variant){
		var f0 = param[2];
		return cont([0, f0]);
		                                       }
		                                      }
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_task_recurrence,
		                                     cst_Task_recurrence,
		                                     c,
		                                     0],
		                                    b];
		                                return caml_exact_trampoline_cps_call
		(action_task_postponing_schema_,
		 schematic_version$101,
		 function(b){
		  return caml_exact_trampoline_cps_call
		          (capturable_schema_versioned,
		           schematic_version$101,
		           function(c){
		            return caml_exact_trampoline_cps_call
		                    (c,
		                     b,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           function(f0, cont){return cont([0, -463576851, f0]);},
		                           function(param, cont){
		                            if(typeof param !== "number"){
		                             var variant = param[1];
		                             if(-463576851 === variant){
		                              var f0 = param[2];
		                              return cont([0, f0]);
		                             }
		                            }
		                            return cont(0);
		                           },
		                           0,
		                           0,
		                           cst_task_postponing,
		                           cst_Task_postponing,
		                           c,
		                           0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (action_document_schema_version,
		                               schematic_version$101,
		                               function(c){
		                                var
		                                 a =
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([0, -719739541, f0]);},
		                                     function(param, cont){
		                                      if(typeof param !== "number"){
		                                       var variant = param[1];
		                                       if(-719739541 === variant){
		var f0 = param[2];
		return cont([0, f0]);
		                                       }
		                                      }
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     "task-move",
		                                     "Task_move",
		                                     c,
		                                     0],
		                                    b];
		                                return caml_exact_trampoline_cps_call
		(action_allocation_schema_versi,
		 schematic_version$101,
		 function(b){
		  return caml_exact_trampoline_cps_call
		          (capturable_schema_versioned,
		           schematic_version$101,
		           function(c){
		            return caml_exact_trampoline_cps_call
		                    (c,
		                     b,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           function(param, cont){return cont(-535055569);},
		                           function(param, cont){
		                            if(typeof param === "number" && -535055569 === param)
		                             return cont(aZY);
		                            return cont(0);
		                           },
		                           0,
		                           0,
		                           "page-creation",
		                           "Page_creation",
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){return cont(0);},
		                             function(param, cont){return cont(0);},
		                             0],
		                            0],
		                           0],
		                          [0,
		                           [0,
		                            function(f0, cont){return cont([0, 144189434, f0]);},
		                            function(param, cont){
		                             if(typeof param !== "number"){
		                              var variant = param[1];
		                              if(144189434 === variant){
		                               var f0 = param[2];
		                               return cont([0, f0]);
		                              }
		                             }
		                             return cont(0);
		                            },
		                            0,
		                            0,
		                            cst_task_allocation,
		                            cst_Task_allocation,
		                            c,
		                            0],
		                           a]];
		                      return caml_exact_trampoline_cps_call
		                              (action_time_schema_versioned,
		                               schematic_version$101,
		                               function(c){
		                                var
		                                 a =
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([0, 81098820, f0]);},
		                                     function(param, cont){
		                                      if(typeof param !== "number"){
		                                       var variant = param[1];
		                                       if(81098820 === variant){
		var f0 = param[2];
		return cont([0, f0]);
		                                       }
		                                      }
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_event_creation,
		                                     cst_Event_creation,
		                                     c,
		                                     0],
		                                    b];
		                                return caml_exact_trampoline_cps_call
		(action_allocation_schema_versi,
		 schematic_version$101,
		 function(c){
		  var
		   b =
		     [0,
		      [0,
		       function(f0, cont){return cont([0, -5494395, f0]);},
		       function(param, cont){
		        if(typeof param !== "number"){
		         var variant = param[1];
		         if(-5494395 === variant){
		          var f0 = param[2];
		          return cont([0, f0]);
		         }
		        }
		        return cont(0);
		       },
		       0,
		       0,
		       "event-allocation",
		       "Event_allocation",
		       c,
		       0],
		      a];
		  return caml_exact_trampoline_cps_call
		          (action_document_schema_version,
		           schematic_version$101,
		           function(a){
		            var
		             res =
		               [11,
		                aZ0,
		                [0,
		                 [0,
		                  function(param, cont){return cont(-971241045);},
		                  function(param, cont){
		                   if(typeof param === "number" && -971241045 === param)
		                    return cont(aZZ);
		                   return cont(0);
		                  },
		                  0,
		                  0,
		                  "capture-note",
		                  "Capture_note",
		                  [0,
		                   0,
		                   0,
		                   [7,
		                    function(param, cont){return cont(0);},
		                    function(param, cont){return cont(0);},
		                    0],
		                   0],
		                  0],
		                 [0,
		                  [0,
		                   function(f0, cont){return cont([0, -494360719, f0]);},
		                   function(param, cont){
		                    if(typeof param !== "number"){
		                     var variant = param[1];
		                     if(-494360719 === variant){
		                      var f0 = param[2];
		                      return cont([0, f0]);
		                     }
		                    }
		                    return cont(0);
		                   },
		                   0,
		                   0,
		                   "document-text",
		                   "Document_text",
		                   a,
		                   0],
		                  b]],
		                1];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     bOO[1][1],
		                     schematic_schema_version$89,
		                     res,
		                     function(a){bOO[1][1] = a; return cont(res);});
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var action_schema$11 = [0, aZX, 0, descriptor$28, 0];
		               function schematic_version$102(param, cont){return cont(0);}
		               var schematic_schema_version$88 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$809[1][1],
		                    schematic_schema_version$88]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$809[1][1],
		                             schematic_schema_version$88,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$809[1][1],
		schematic_schema_version$88,
		schematic_self,
		function(a){
		 letrec_function_context$809[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (action_task_document_schema_ve,
		          schematic_version$102,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                function(f0, cont){return cont([0, 936373093, f0]);},
		                function(param, cont){
		                 if(typeof param !== "number"){
		                  var variant = param[1];
		                  if(936373093 === variant){
		                   var f0 = param[2];
		                   return cont([0, f0]);
		                  }
		                 }
		                 return cont(0);
		                },
		                0,
		                0,
		                cst_task,
		                cst_Task,
		                b,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (action_task_scheduling_schema_,
		                    schematic_version$102,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([0, 63748398, f0]);},
		                          function(param, cont){
		                           if(typeof param !== "number"){
		                            var variant = param[1];
		                            if(63748398 === variant){
		                             var f0 = param[2];
		                             return cont([0, f0]);
		                            }
		                           }
		                           return cont(0);
		                          },
		                          0,
		                          0,
		                          cst_task_scheduling,
		                          cst_Task_scheduling,
		                          c,
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (action_task_recurrence_schema_,
		                              schematic_version$102,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([0, 1055840202, f0]);},
		                                    function(param, cont){
		                                     if(typeof param !== "number"){
		                                      var variant = param[1];
		                                      if(1055840202 === variant){
		                                       var f0 = param[2];
		                                       return cont([0, f0]);
		                                      }
		                                     }
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_task_recurrence,
		                                    cst_Task_recurrence,
		                                    c,
		                                    0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (action_task_postponing_schema_,
		schematic_version$102,
		function(c){
		 var
		  b =
		    [0,
		     [0,
		      function(f0, cont){return cont([0, -463576851, f0]);},
		      function(param, cont){
		       if(typeof param !== "number"){
		        var variant = param[1];
		        if(-463576851 === variant){
		         var f0 = param[2];
		         return cont([0, f0]);
		        }
		       }
		       return cont(0);
		      },
		      0,
		      0,
		      cst_task_postponing,
		      cst_Task_postponing,
		      c,
		      0],
		     a];
		 return caml_exact_trampoline_cps_call
		         (action_allocation_schema_versi,
		          schematic_version$102,
		          function(a){
		           var
		            res =
		              [11,
		               aZ1,
		               [0,
		                [0,
		                 function(f0, cont){return cont([0, 144189434, f0]);},
		                 function(param, cont){
		                  if(typeof param !== "number"){
		                   var variant = param[1];
		                   if(144189434 === variant){
		                    var f0 = param[2];
		                    return cont([0, f0]);
		                   }
		                  }
		                  return cont(0);
		                 },
		                 0,
		                 0,
		                 cst_task_allocation,
		                 cst_Task_allocation,
		                 a,
		                 0],
		                b],
		               1];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$809[1][1],
		                    schematic_schema_version$88,
		                    res,
		                    function(a){
		                     letrec_function_context$809[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_Generic = "Generic",
		                cst_Plan = "Plan",
		                letrec_function_context$810 = [];
		               function schema_versioned$517(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$810[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(a){return cont();}
		                          return match
		                                  ? a()
		                                  : caml_exact_trampoline_cps_call
		                                    (fixpoint,
		                                     function(schematic_self, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       letrec_function_context$810[1][1],
		       schematic_schema_version,
		       function(match){
		        if(! match)
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  letrec_function_context$810[1][1],
		                  schematic_schema_version,
		                  schematic_self,
		                  function(a){
		                   letrec_function_context$810[1][1] = a;
		                   var
		                    res =
		                      [11,
		                       0,
		                       [0,
		                        [0,
		                         function(param, cont){return cont(0);},
		                         function(param, cont){return param ? cont(0) : cont(a0h);},
		                         0,
		                         0,
		                         cst_generic,
		                         cst_Generic,
		                         a0g,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(1);},
		                          function(param, cont){
		                           return 1 === param ? cont(a0f) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_schedule,
		                          "Schedule",
		                          a0e,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(2);},
		                           function(param, cont){
		                            return 2 === param ? cont(a0d) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_postpone,
		                           "Postpone",
		                           a0c,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(3);},
		                            function(param, cont){
		                             return 3 === param ? cont(a0b) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_plan,
		                            cst_Plan,
		                            a0a,
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(4);},
		                             function(param, cont){
		                              return 4 === param ? cont(aZ$) : cont(0);
		                             },
		                             0,
		                             0,
		                             cst_person,
		                             cst_Person,
		                             aZ_,
		                             0],
		                            [0,
		                             [0,
		                              function(param, cont){return cont(5);},
		                              function(param, cont){
		                               return 5 === param ? cont(aZ9) : cont(0);
		                              },
		                              0,
		                              0,
		                              cst_destination,
		                              cst_Destination,
		                              aZ8,
		                              0],
		                             [0,
		                              [0,
		                               function(param, cont){return cont(6);},
		                               function(param, cont){
		                                return 6 === param ? cont(aZ7) : cont(0);
		                               },
		                               0,
		                               0,
		                               cst_date,
		                               cst_Date,
		                               aZ6,
		                               0],
		                              [0,
		                               [0,
		                                function(param, cont){return cont(7);},
		                                function(param, cont){
		                                 return 7 === param ? cont(aZ5) : cont(0);
		                                },
		                                0,
		                                0,
		                                cst_daytime,
		                                cst_Daytime,
		                                aZ4,
		                                0],
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(8);},
		                                 function(param, cont){
		                                  return 8 <= param ? cont(aZ3) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_recurrence,
		                                 cst_Recurrence,
		                                 aZ2,
		                                 0],
		                                0]]]]]]]]],
		                       0];
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            letrec_function_context$810[1][1],
		                            schematic_schema_version,
		                            res,
		                            function(a){
		                             letrec_function_context$810[1][1] = a;
		                             return cont(res);
		                            });
		                  });
		        var schema = match[1];
		        return cont(schema);
		       });
		                                     },
		                                     a);
		                         });
		               }
		               var schematic_cache$770 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$810, [0, schematic_cache$770]);
		               caml_callback
		                (schema_versioned$517, [function(param){return 0;}]);
		               function schematic_version$103(param){return 0;}
		               caml_callback(schema_versioned$517, [schematic_version$103]);
		               caml_callback(M$2, [[0, comparator$28, schema_versioned$187]]);
		               var
		                sexp_of_t$138 = caml_callback(encode$7, [schema$9]),
		                include$281 = Make$1([0, compare$47, sexp_of_t$138]),
		                comparator$59 = include$281[1],
		                letrec_function_context$811 = [];
		               caml_update_dummy
		                (letrec_function_context$811, [0, equal$107, equal$30]);
		               var
		                schematic_cache$771 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$812 = [];
		               caml_update_dummy
		                (letrec_function_context$812, [0, schematic_cache$771]);
		               function schematic_version$104(param, cont){return cont(0);}
		               var
		                schematic_schema_version$87 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$812[1][1],
		                     schematic_schema_version$87]);
		               if(e)
		                var schema$191 = e[1], descriptor$29 = schema$191;
		               else
		                descriptor$29 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$812[1][1],
		                              schematic_schema_version$87,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$812[1][1],
		 schematic_schema_version$87,
		 schematic_self,
		 function(a){
		  letrec_function_context$812[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$187,
		           schematic_version$104,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 "bucket",
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, b], 0]],
		                 0,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$14,
		                     schematic_version$104,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var bucket = param[2][1], frequency = param[1];
		                           return cont([0, frequency, bucket]);
		                          },
		                          function(param, cont){
		                           var bucket = param[2], frequency = param[1];
		                           return cont([0, frequency, [0, bucket, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_frequency, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$812[1][1],
		                               schematic_schema_version$87,
		                               res,
		                               function(a){
		                                letrec_function_context$812[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                frequency_bucket_schema = [0, a0i, 0, descriptor$29, 0],
		                letrec_function_context$813 = [];
		               function content_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$813[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0j, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$813[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$813[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$813[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (todo_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([11, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 11 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_todo,
		   cst_Todo,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (recurrent_task_schema_versione,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([10, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 10 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_recurrent_task,
		             cst_Recurrent_task,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (paragraph_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([9, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 9 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       0,
		                       0,
		                       cst_query,
		                       cst_Query,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (paragraph_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([8, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 8 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_paragraph,
		                                 cst_Paragraph,
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (object_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([7, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_object,
		   cst_Object,
		   c,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (heading_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_heading,
		             cst_Heading,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (paragraph_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(param, cont){return cont(0);},
		                       function(param, cont){
		                        return typeof param === "number" ? cont(a0k) : cont(0);
		                       },
		                       0,
		                       0,
		                       cst_divider,
		                       cst_Divider,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){return cont(0);},
		                         function(param, cont){return cont(0);},
		                         0],
		                        0],
		                       0],
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([5, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_embed,
		                        cst_Embed,
		                        c,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call
		                          (callout_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([4, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_callout,
		                                 cst_Callout,
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (code_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_code,
		   cst_Code,
		   c,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (check_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([2, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             0,
		             0,
		             cst_check,
		             cst_Check,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (bullet_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([1, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       0,
		                       0,
		                       cst_bullet,
		                       cst_Bullet,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (paragraph_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [11,
		                                a0l,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_blockquote,
		                                  cst_Blockquote,
		                                  b,
		                                  0],
		                                 a],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$813[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$813[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$772 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$813, [0, schematic_cache$772]);
		               caml_callback
		                (content_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$773 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$814 = [];
		               caml_update_dummy
		                (letrec_function_context$814, [0, schematic_cache$773]);
		               function schematic_version$105(param, cont){return cont(0);}
		               var schematic_schema_version$86 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$814[1][1],
		                    schematic_schema_version$86]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$814[1][1],
		                             schematic_schema_version$86,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$814[1][1],
		schematic_schema_version$86,
		schematic_self,
		function(a){
		 letrec_function_context$814[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (content_schema_versioned$0,
		          schematic_version$105,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (include$48[4],
		                    schematic_version$105,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var content = param[2][1], id = param[1];
		                          return cont([0, id, content]);
		                         },
		                         function(param, cont){
		                          var content = param[2], id = param[1];
		                          return cont([0, id, [0, content, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              letrec_function_context$814[1][1],
		                              schematic_schema_version$86,
		                              res,
		                              function(a){
		                               letrec_function_context$814[1][1] = a;
		                               return cont(res);
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$815 = [];
		               function schema_versioned$518(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$815[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0m, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$815[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$815[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$815[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$139,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var blocks = param[1];
		   return cont([0, blocks]);
		  },
		  function(param, cont){
		   var blocks = param[1];
		   return cont([0, blocks, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_blocks,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$815[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$815[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$774 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$815, [0, schematic_cache$774]);
		               var
		                schema$192 =
		                  caml_callback
		                   (schema_versioned$518,
		                    [function(param, cont){return cont(0);}]);
		               function to_string$72(doc, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         doc[1],
		                         function(block, cont){return cont(text$0(block));},
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (strip, 0, concat_lines(0, a), cont);
		                         });
		               }
		               var letrec_function_context$816 = [];
		               function client_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$816[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0n, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$816[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$816[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$816[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a0p);},
		                                  0,
		                                  0,
		                                  cst_zapier,
		                                  "Zapier",
		                                  a0o,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(! param) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   0,
		                                   0,
		                                   cst_other,
		                                   cst_Other,
		                                   schematic_param_name_schema_ve,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$816[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$816[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$775 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$816, [0, schematic_cache$775]);
		               caml_callback
		                (client_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$817 = [];
		               function schema_versioned$519(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$817[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0q, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$817[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$817[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$817[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$314,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   0,
		   0,
		   cst_integration,
		   cst_Integration,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (client_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){
		               return typeof param === "number" ? cont(a0s) : cont(0);
		              },
		              0,
		              0,
		              cst_native,
		              "Native",
		              a0r,
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([0, f0]);},
		               function(param, cont){
		                if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                return cont(0);
		               },
		               0,
		               0,
		               cst_client,
		               "Client",
		               b,
		               0],
		              a]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$817[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$817[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$776 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$817, [0, schematic_cache$776]);
		               caml_callback
		                (schema_versioned$519,
		                 [function(param, cont){return cont(0);}]);
		               function id$36(param, cont){
		                var id = param[6];
		                return cont(id);
		               }
		               function todo$0(param){
		                var writable = param[7];
		                return todo(writable);
		               }
		               caml_callback(encode$7, [schema$67]);
		               var schema$193 = Patch[5], make$134 = Patch[8];
		               function is_empty$9(a){
		                if
		                 (!
		                  a[1]
		                  &&
		                   !
		                   a[2]
		                   && ! a[3] && ! a[4] && ! a[5] && ! a[6] && ! a[7] && ! a[8]){a = a[9]; if(! a[1] && ! a[2] && ! a[3]) return 1;}
		                return 0;
		               }
		               make$134(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
		               var schema$194 = Read$0[5];
		               caml_callback(M$2, [[0, comparator$19, schema_versioned$109]]);
		               var letrec_function_context$818 = [];
		               function equal_day(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 function c(b){
		                  if(! b) return cont(b);
		                  var y = rhs[2], x = lhs[2];
		                  function a(x, y){
		                   if(x){
		                    if(y){
		                     var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$818[1],
		                              a$0,
		                              b,
		                              function(b){
		                               return b
		                                       ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                       : cont(b);
		                              });
		                    }
		                   }
		                   else if(! y) return cont(1);
		                   return cont(0);
		                  }
		                  return a(x, y);
		                 }
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$818[2],
		                            a$0,
		                            b,
		                            function(b){
		                             return b ? caml_exact_trampoline_call2(a, x$0, y$0) : c(b);
		                            });
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                return a(x, y);
		               }
		               caml_update_dummy
		                (letrec_function_context$818, [0, equal$68, equal$68]);
		               var letrec_function_context$819 = [];
		               function day_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$819[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0t, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$819[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$819[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$819[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$129,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   a0u,
		   0,
		   0,
		   0,
		   cst_other,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$129,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var other = param[2][1], todo = param[1];
		             return cont([0, todo, other]);
		            },
		            function(param, cont){
		             var other = param[2], todo = param[1];
		             return cont([0, todo, [0, other, 0]]);
		            },
		            [0,
		             [0,
		              a0v,
		              0,
		              0,
		              0,
		              cst_todo,
		              0,
		              2,
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$819[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$819[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$777 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$819, [0, schematic_cache$777]);
		               var
		                day_schema =
		                  caml_callback
		                   (day_schema_versioned,
		                    [function(param, cont){return cont(0);}]);
		               function day_of_entries(entries, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (partition_map,
		                         entries,
		                         function(param, cont){
		                          if(0 === param[0]){
		                           var id = param[2], completed_or_archived_at = param[1];
		                           return cont([0, [0, completed_or_archived_at, id]]);
		                          }
		                          var t = param[1];
		                          return cont([1, t]);
		                         },
		                         function(match){
		                          var todo = match[2], other = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (stable_sort,
		                                   other,
		                                   function(a, param, cont){
		                                    var r = param[1], l = a[1];
		                                    return caml_trampoline_cps_call3(compare$37, l, r, cont);
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$7,
		     a,
		     function(a, cont){return cont(a[2]);},
		     function(other){
		      function compare(l$0, r$0, cont){
		       var y = l$0[1], x = r$0[1], x$0 = caml_int_compare(x, y);
		       if(0 !== x$0) return cont(x$0);
		       var r$1 = r$0[2], l$1 = l$0[2];
		       if(! l$1) return r$1 ? cont(1) : cont(0);
		       var l = l$1[1];
		       if(! r$1) return cont(-1);
		       var r = r$1[1];
		       return caml_trampoline_cps_call3(compare$37, l, r, cont);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (stable_sort,
		               todo,
		               compare,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         a,
		                         function(t, cont){return cont(t[3]);},
		                         function(todo){return cont([0, todo, other]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$820 = [];
		               function equal_batch(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 function c(b){
		                  if(! b) return cont(b);
		                  var y = rhs[2], x = lhs[2];
		                  function a(x, y){
		                   if(x){
		                    if(y){
		                     var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$820[1],
		                              a$0,
		                              b,
		                              function(b){
		                               return b
		                                       ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                       : cont(b);
		                              });
		                    }
		                   }
		                   else if(! y) return cont(1);
		                   return cont(0);
		                  }
		                  return a(x, y);
		                 }
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$820[2],
		                            a$0,
		                            b,
		                            function(b){
		                             return b ? caml_exact_trampoline_call2(a, x$0, y$0) : c(b);
		                            });
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                return a(x, y);
		               }
		               caml_update_dummy
		                (letrec_function_context$820, [0, equal$68, equal_day]);
		               var
		                schematic_cache$778 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$821 = [];
		               caml_update_dummy
		                (letrec_function_context$821, [0, schematic_cache$778]);
		               function schematic_version$106(param, cont){return cont(0);}
		               var
		                schematic_schema_version$26 =
		                  caml_callback(schematic_version$106, [V$4]),
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$821[1][1],
		                     schematic_schema_version$26]),
		                cst_unscheduled = "unscheduled";
		               if(e)
		                var schema$195 = e[1], descriptor$30 = schema$195;
		               else
		                descriptor$30 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$821[1][1],
		                              schematic_schema_version$26,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$821[1][1],
		 schematic_schema_version$26,
		 schematic_self,
		 function(a){
		  letrec_function_context$821[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$129,
		           schematic_version$106,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_unscheduled,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, b], 0]],
		                 0,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (day_schema_versioned,
		                     schematic_version$106,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var unscheduled = param[2][1], scheduled = param[1];
		                           return cont([0, scheduled, unscheduled]);
		                          },
		                          function(param, cont){
		                           var unscheduled = param[2], scheduled = param[1];
		                           return cont([0, scheduled, [0, unscheduled, 0]]);
		                          },
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_scheduled,
		                            0,
		                            2,
		                            [0, [0, 0, 0, [3, b], 0]],
		                            0,
		                            0],
		                           a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$821[1][1],
		                               schematic_schema_version$26,
		                               res,
		                               function(a){
		                                letrec_function_context$821[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var batch_schema = [0, a0w, 0, descriptor$30, 0];
		               caml_callback
		                (init$7, [7, function(param, cont){return cont(a0x);}]);
		               function append_batch(left, right, cont){
		                var a = symbol(left[2], right[2]);
		                return caml_exact_trampoline_cps_call$0
		                        (map2_exn,
		                         left[1],
		                         right[1],
		                         function(l, r, cont){
		                          var a = symbol(l[2], r[2]);
		                          return cont([0, symbol(l[1], r[1]), a]);
		                         },
		                         function(b){return cont([0, b, a]);});
		               }
		               var
		                schematic_cache$779 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$822 = [];
		               caml_update_dummy
		                (letrec_function_context$822, [0, schematic_cache$779]);
		               function schematic_version$107(param, cont){return cont(0);}
		               var
		                schematic_schema_version$27 =
		                  caml_callback(schematic_version$107, [V$4]),
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$822[1][1],
		                     schematic_schema_version$27]),
		                cst_canAllocate = "canAllocate",
		                cst_canEditTitle = "canEditTitle",
		                cst_canMove = "canMove",
		                cst_canRepeat = "canRepeat",
		                cst_integrationStatus = "integrationStatus";
		               if(e)
		                var schema$196 = e[1], descriptor$31 = schema$196;
		               else
		                descriptor$31 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$822[1][1],
		                              schematic_schema_version$27,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$822[1][1],
		 schematic_schema_version$27,
		 schematic_self,
		 function(b){
		  letrec_function_context$822[1][1] = b;
		  var
		   a =
		     [0,
		      [0, 0, 0, 0, 0, cst_todo, 0, 0, [0, bool_schema], 0, 0],
		      0];
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$519,
		           schematic_version$107,
		           function(c){
		            var
		             b =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_canAllocate,
		                 0,
		                 0,
		                 [0, bool_schema],
		                 0,
		                 0],
		                [0,
		                 [0, 0, 0, 0, 0, cst_canDelete, 0, 0, [0, bool_schema], 0, 0],
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_canEditTitle,
		                   0,
		                   0,
		                   [0, bool_schema],
		                   0,
		                   0],
		                  [0,
		                   [0, 0, 0, 0, 0, cst_canMove, 0, 0, [0, bool_schema], 0, 0],
		                   [0,
		                    [0, 0, 0, 0, 0, cst_canRepeat, 0, 0, [0, bool_schema], 0, 0],
		                    [0, [0, 0, 0, 0, 0, cst_context, 0, 1, [0, c], 0, 0], a]]]]]];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$186,
		                     schematic_version$107,
		                     function(a){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var task = param[2][1], integration_status = param[1];
		                           return cont([0, integration_status, task]);
		                          },
		                          function(param, cont){
		                           var task = param[2], integration_status = param[1];
		                           return cont
		                                   ([0,
		                                     integration_status,
		                                     [0,
		                                      task,
		                                      [0,
		                                       a0E,
		                                       [0,
		a0D,
		[0,
		 a0C,
		 [0, a0B, [0, a0A, [0, a0z, [0, [0, todo$0(task)], 0]]]]]]]]]);
		                          },
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_integrationStatus,
		                            0,
		                            3,
		                            [0, no_input_schema],
		                            0,
		                            0],
		                           [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [1, a], 0, 0], b]]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$822[1][1],
		                               schematic_schema_version$27,
		                               res,
		                               function(a){
		                                letrec_function_context$822[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var augmented_schema = [0, a0y, 0, descriptor$31, 0];
		               function augment$1(task, cont){return cont([0, 0, task]);}
		               var
		                Ids =
		                  caml_callback
		                   (M$3, [[0, comparator$19, schema_versioned$109]]),
		                cst_binding = "binding",
		                letrec_function_context$823 = [];
		               function augmented_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$823[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0F, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$823[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$823[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$823[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_todo, 0, 0, [0, bool_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$519,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, 0, 0, 0, 0, cst_context, 0, 1, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$129,
		       schematic_version,
		       function(a){
		        return caml_trampoline_cps_call3
		                (with_id_schema_versioned,
		                 schematic_version,
		                 a,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       a0K,
		                       0,
		                       0,
		                       0,
		                       cst_canAllocate,
		                       0,
		                       2,
		                       [0, bool_schema],
		                       0,
		                       0],
		                      [0,
		                       [0,
		                        a0J,
		                        0,
		                        0,
		                        0,
		                        cst_canDelete,
		                        0,
		                        2,
		                        [0, bool_schema],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         a0I,
		                         0,
		                         0,
		                         0,
		                         cst_canEditTitle,
		                         0,
		                         2,
		                         [0, bool_schema],
		                         0,
		                         0],
		                        [0,
		                         [0, a0H, 0, 0, 0, cst_canMove, 0, 2, [0, bool_schema], 0, 0],
		                         [0,
		                          [0,
		                           a0G,
		                           0,
		                           0,
		                           0,
		                           cst_canRepeat,
		                           0,
		                           2,
		                           [0, bool_schema],
		                           0,
		                           0],
		                          [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [1, c], 0, 0], b]]]]]];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$303,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  task = f[2][1],
		                                  can_repeat = f[1],
		                                  can_move = e[1],
		                                  can_edit_title = d[1],
		                                  can_delete = c[1],
		                                  can_allocate = b[1],
		                                  binding = a[1],
		                                  integration_status = param[1];
		                                 return cont
		 ([0,
		   integration_status,
		   binding,
		   can_allocate,
		   can_delete,
		   can_edit_title,
		   can_move,
		   can_repeat,
		   task]);
		                                },
		                                function(param, cont){
		                                 var
		                                  task = param[8],
		                                  can_repeat = param[7],
		                                  can_move = param[6],
		                                  can_edit_title = param[5],
		                                  can_delete = param[4],
		                                  can_allocate = param[3],
		                                  binding = param[2],
		                                  integration_status = param[1];
		                                 return cont
		 ([0,
		   integration_status,
		   [0,
		    binding,
		    [0,
		     can_allocate,
		     [0,
		      can_delete,
		      [0,
		       can_edit_title,
		       [0,
		        can_move,
		        [0,
		         can_repeat,
		         [0, task, [0, a0L, [0, [0, todo$0(task)], 0]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_integrationStatus,
		                                  0,
		                                  3,
		                                  [0, no_input_schema],
		                                  0,
		                                  0],
		                                 [0, [0, 0, 0, 0, 0, cst_binding, 0, 3, [0, b], 0, 0], a]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$823[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$823[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$780 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$823, [0, schematic_cache$780]);
		               caml_callback
		                (augmented_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function offset_of_week_start(param){return 6 <= param ? 1 : 0;
		               }
		               function date_of_week(week_start, week, cont){
		                var
		                 offset = offset_of_week_start(week_start),
		                 a = - offset | 0;
		                return caml_exact_trampoline_cps_call
		                        (to_date$2,
		                         week,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (add_days, b, a, cont);
		                         });
		               }
		               function week_of_date(week_start, date, cont){
		                var offset = offset_of_week_start(week_start);
		                return caml_exact_trampoline_cps_call$1
		                        (add_days,
		                         date,
		                         offset,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_date$1, a, cont);
		                         });
		               }
		               function compare$169(l, r){
		                function to_n(param){
		                 switch(param){
		                   case 0:
		                    return 0;
		                   case 1:
		                    return 1;
		                   default: return 2;
		                 }
		                }
		                var a = to_n(r);
		                return to_n(l) - a | 0;
		               }
		               function is_empty$10(param){
		                if
		                 (!
		                  param[1]
		                  &&
		                   !
		                   param[2]
		                   &&
		                    !
		                    param[3]
		                    &&
		                     !
		                     param[4]
		                     &&
		                      !
		                      param[5]
		                      &&
		                       !
		                       param[6]
		                       &&
		                        !
		                        param[7]
		                        && ! param[8] && ! param[9] && ! param[10] && ! param[11])
		                 return 1;
		                return 0;
		               }
		               function duration(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (start$2,
		                         timezone,
		                         t,
		                         function(start){
		                          return caml_exact_trampoline_cps_call$1
		                                  (end$1,
		                                   timezone,
		                                   t,
		                                   function(end){
		                                    var s = symbol$58(end, start);
		                                    return cont(s);
		                                   });
		                         });
		               }
		               var sexp_of_t$139 = caml_callback(encode$7, [schema$88]);
		               function compare$170(l, r, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (start$2,
		                         timezone,
		                         r,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (start$2,
		                                   timezone,
		                                   l,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(compare$37, b, a, cont);
		                                   });
		                         });
		               }
		               var
		                include$282 = Make$2([0, compare$170, sexp_of_t$139]),
		                compare$171 = include$282[8],
		                letrec_function_context$824 = [];
		               function augmented_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$824[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0M, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$824[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$824[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$824[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, "movable", 0, 0, [0, bool_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (yes_no_maybe_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0, [0, 0, 0, 0, 0, "willAttend", 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (attendee_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, 0, 0, 0, 0, cst_self, 0, 3, [0, c], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$232,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0, 0, 0, 0, 0, "recurrence_spoon", 0, 3, [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$230,
		                           schematic_version,
		                           function(c){
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, "editable", 0, 2, [0, bool_schema], 0, 0],
		                                [0, [0, 0, 0, 0, 0, cst_event, 0, 2, [1, c], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call
		                                    (availability_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    will_attend = f[2][1],
		    self = f[1],
		    recurrence_spoon = e[1],
		    event = d[1],
		    editable = c[1],
		    available = b[1],
		    attendable = a[1],
		    active = param[1];
		   return cont
		           ([0,
		             active,
		             attendable,
		             available,
		             editable,
		             event,
		             recurrence_spoon,
		             self,
		             will_attend]);
		  },
		  function(param, cont){
		   var
		    will_attend = param[8],
		    self = param[7],
		    recurrence_spoon = param[6],
		    event = param[5],
		    editable = param[4],
		    available = param[3],
		    attendable = param[2],
		    active = param[1];
		   return cont
		           ([0,
		             active,
		             [0,
		              attendable,
		              [0,
		               available,
		               [0,
		                editable,
		                [0,
		                 event,
		                 [0,
		                  recurrence_spoon,
		                  [0, self, [0, will_attend, [0, [0, editable], 0]]]]]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_active, 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0, 0, 0, 0, 0, "attendable", 0, 2, [0, bool_schema], 0, 0],
		    [0, [0, 0, 0, 0, 0, "available", 0, 2, [0, b], 0, 0], a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$824[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$824[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$781 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$824, [0, schematic_cache$781]);
		               caml_callback
		                (augmented_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function augment$2(calendar, event, cont){
		                var calendar_editable = calendar[8], t = event[6];
		                if(0 === t[0])
		                 var recurrence = 0;
		                else
		                 var recurrence$0 = t[1], recurrence = [0, recurrence$0];
		                var self_email = to_string$43(calendar[2]);
		                return caml_exact_trampoline_cps_call
		                        (is_empty$5,
		                         event[9][3],
		                         function(b){
		                          function a(self_organizer){
		                           var o = event[3];
		                           if(o)
		                            var
		                             x = o[1],
		                             x$0 = x[1],
		                             self_creator = x$0 === self_email ? 1 : 0;
		                           else
		                            self_creator = 0;
		                           var
		                            self_organizer$0 = self_organizer || self_creator,
		                            editable =
		                              self_organizer$0 ? calendar_editable : self_organizer$0;
		                           return caml_exact_trampoline_cps_call$1
		                                   (will_attend,
		                                    calendar,
		                                    event,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (attendees_self,
		      calendar,
		      event,
		      function(c){
		       var b = availability$0(event);
		       return caml_exact_trampoline_cps_call$1
		               (active$1,
		                calendar,
		                event,
		                function(d){
		                 return cont
		                         ([0,
		                           d,
		                           calendar_editable,
		                           b,
		                           editable,
		                           event,
		                           recurrence,
		                           c,
		                           a]);
		                });
		      });
		                                    });
		                          }
		                          return b
		                                  ? a(b)
		                                  : caml_exact_trampoline_cps_call$1
		                                    (exists$0,
		                                     event[9][3],
		                                     function(attendee, cont){
		                                      var a = attendee[3];
		                                      if(! a) return cont(a);
		                                      var x = attendee[1];
		                                      return cont(x === self_email ? 1 : 0);
		                                     },
		                                     a);
		                         });
		               }
		               var letrec_function_context$825 = [];
		               function pause_kind_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$825[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0N, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$825[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$825[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$825[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a0T);},
		                                  0,
		                                  0,
		                                  cst_evening,
		                                  "Evening",
		                                  a0S,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(a0R) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_morning,
		                                   "Morning",
		                                   a0Q,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(a0P) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_pause,
		                                    cst_Pause,
		                                    a0O,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$825[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$825[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$782 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$825, [0, schematic_cache$782]);
		               caml_callback
		                (pause_kind_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$826 = [];
		               function pause_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$826[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0U, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$826[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$826[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$826[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (pause_kind_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$4,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_end, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$4,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        kind = a[2][1],
		                        end = a[1],
		                        start = param[1];
		                       return cont([0, start, end, kind]);
		                      },
		                      function(param, cont){
		                       var kind = param[3], end = param[2], start = param[1];
		                       return cont([0, start, [0, end, [0, kind, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_start, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$826[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$826[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$783 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$826, [0, schematic_cache$783]);
		               caml_callback
		                (pause_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$827 = [];
		               function event_or_pause_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$827[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0V, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$827[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$827[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$827[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (pause_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_pause,
		   cst_Pause,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (augmented_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            a0W,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_event,
		              cst_Event,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$827[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$827[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$784 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$827, [0, schematic_cache$784]);
		               var
		                event_or_pause_schema =
		                  caml_callback
		                   (event_or_pause_schema_versione,
		                    [function(param, cont){return cont(0);}]),
		                schematic_cache$785 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$828 = [];
		               caml_update_dummy
		                (letrec_function_context$828, [0, schematic_cache$785]);
		               function schematic_version$108(param, cont){return cont(0);}
		               var
		                schematic_schema_version$85 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$828[1][1],
		                     schematic_schema_version$85]);
		               if(e)
		                var schema$197 = e[1], descriptor$32 = schema$197;
		               else
		                descriptor$32 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$828[1][1],
		                              schematic_schema_version$85,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$828[1][1],
		 schematic_schema_version$85,
		 schematic_self,
		 function(a){
		  letrec_function_context$828[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$229,
		           schematic_version$108,
		           function(a){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var patch = param[2][1], id = param[1];
		                 return cont([0, id, patch]);
		                },
		                function(param, cont){
		                 var patch = param[2], id = param[1];
		                 return cont([0, id, [0, patch, 0]]);
		                },
		                [0,
		                 [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		                 [0, [0, 0, 0, 0, 0, cst_patch, 0, 2, [1, a], 0, 0], 0]]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$828[1][1],
		                     schematic_schema_version$85,
		                     res,
		                     function(a){
		                      letrec_function_context$828[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var patch_schema$0 = [0, a0X, 0, descriptor$32, 0];
		               function archived(event, cont){
		                var a = is_some(event[9][1]);
		                return a
		                        ? cont(a)
		                        : caml_exact_trampoline_cps_call$0
		                          (equal_option, equal_calendar_status, event[2], a0Y, cont);
		               }
		               function notes$6(event){return event[9][8];}
		               function with_notes(notes, event){
		                var
		                 a = event[9],
		                 x =
		                   [0,
		                    event[1],
		                    event[2],
		                    event[3],
		                    event[4],
		                    event[5],
		                    event[6],
		                    event[7],
		                    event[8],
		                    [0,
		                     a[1],
		                     a[2],
		                     a[3],
		                     a[4],
		                     a[5],
		                     a[6],
		                     a[7],
		                     notes,
		                     a[9],
		                     a[10],
		                     a[11]]];
		                return x;
		               }
		               function set_will_attend(calendar, event, will_attend, cont){
		                var email = to_string$43(calendar[2]);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         event[9][3],
		                         email,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   a,
		                                   function(attendee, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (set$3,
		     event[9][3],
		     email,
		     [0, attendee[1], attendee[2], attendee[3], will_attend],
		     cont);
		                                   },
		                                   function(attendees){
		                                    var b = active(calendar[6]), a = event[9][2];
		                                    a:
		                                    {
		                                     if(will_attend)
		                                      switch(will_attend[1]){
		case 0:
		 if(a && a[1]){var attendance = bM; break a;}
		 if(! b){attendance = bM; break a;}
		 break;
		case 1:
		 if(a && ! a[1]){attendance = bN; break a;}
		 if(b){attendance = bN; break a;}
		 break;
		                                      }
		                                     attendance = 0;
		                                    }
		                                    return cont
		    ([0, 0, attendance, attendees, 0, 0, 0, 0, 0, 0, 0, 0]);
		                                   });
		                         });
		               }
		               var
		                Ids$0 =
		                  caml_callback
		                   (M$3, [[0, comparator$14, schema_versioned$102]]);
		               caml_callback(of_schema$1, [schema$95]);
		               function notes$7(event){return event[7][8];}
		               function with_notes$0(notes, event){
		                var
		                 a = event[7],
		                 x =
		                   [0,
		                    event[1],
		                    event[2],
		                    event[3],
		                    event[4],
		                    event[5],
		                    event[6],
		                    [0,
		                     a[1],
		                     a[2],
		                     a[3],
		                     a[4],
		                     a[5],
		                     a[6],
		                     a[7],
		                     notes,
		                     a[9],
		                     a[10]]];
		                return x;
		               }
		               var
		                cst_connectionId = "connectionId",
		                letrec_function_context$829 = [];
		               function schema_versioned$520(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$829[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a0Z, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$829[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$829[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$829[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 a00,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_state,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (connection_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var state = param[2][1], connection_id = param[1];
		   return cont([0, connection_id, state]);
		  },
		  function(param, cont){
		   var state = param[2], connection_id = param[1];
		   return cont([0, connection_id, [0, state, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_connectionId, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$829[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$829[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$786 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$829, [0, schematic_cache$786]);
		               caml_callback
		                (schema_versioned$520,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_integrationKey = "integrationKey",
		                letrec_function_context$830 = [];
		               function schema_versioned$521(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$830[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a01, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$830[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$830[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$830[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$520,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$234[1],
		                                       a =
		 [0,
		  [0,
		   a02,
		   0,
		   0,
		   0,
		   cst_connections,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$250,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var connections = param[2][1], integration_key = param[1];
		             return cont([0, integration_key, connections]);
		            },
		            function(param, cont){
		             var connections = param[2], integration_key = param[1];
		             return cont([0, integration_key, [0, connections, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_integrationKey, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$830[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$830[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$787 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$830, [0, schematic_cache$787]);
		               caml_callback
		                (schema_versioned$521,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$831 = [];
		               function integration_schema_versioned$0
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$831[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, a03, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$831[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$831[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$831[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$235[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$236[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var name = param[2][1], key = param[1];
		   return cont([0, key, name]);
		  },
		  function(param, cont){
		   var name = param[2], key = param[1];
		   return cont([0, key, [0, name, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_key, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$831[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$831[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$788 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$831, [0, schematic_cache$788]);
		               caml_callback
		                (integration_schema_versioned$0, [function(param){return 0;}]);
		               var letrec_function_context$832 = [];
		               function item_schema_versioned$2(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$832[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, a04, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$832[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$832[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$832[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (integration_schema_versioned$0,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$237[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_integration,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$238[1],
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_state, 0, [0, default$], [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$239[1],
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_key, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$240[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  integration = b[2][1],
		                                  state = b[1],
		                                  key = a[1],
		                                  id = param[1];
		                                 return cont([0, id, key, state, integration]);
		                                },
		                                function(param, cont){
		                                 var
		                                  integration = param[4],
		                                  state = param[3],
		                                  key = param[2],
		                                  id = param[1];
		                                 return cont
		 ([0, id, [0, key, [0, state, [0, integration, 0]]]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, b], 0, 0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$832[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$832[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$789 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$832, [0, schematic_cache$789]);
		               caml_callback
		                (item_schema_versioned$2, [function(param){return 0;}]);
		               var
		                schematic_cache$790 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$833 = [];
		               caml_update_dummy
		                (letrec_function_context$833, [0, schematic_cache$790]);
		               function schematic_version$109(param){return 0;}
		               var schematic_schema_version$84 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$833[1][1],
		                    schematic_schema_version$84]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$833[1][1],
		                             schematic_schema_version$84,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$833[1][1],
		schematic_schema_version$84,
		schematic_self,
		function(a){
		 letrec_function_context$833[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (item_schema_versioned$2,
		          schematic_version$109,
		          function(a){
		           var
		            default$ = match$241[1],
		            res =
		              [7,
		               function(param, cont){
		                var items = param[1];
		                return cont([0, items]);
		               },
		               function(param, cont){
		                var items = param[1];
		                return cont([0, items, 0]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_items,
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, a], 0]],
		                 0,
		                 0],
		                0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$833[1][1],
		                    schematic_schema_version$84,
		                    res,
		                    function(a){
		                     letrec_function_context$833[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$834 = [];
		               function schema_versioned$522(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$834[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a05, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$834[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$834[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$834[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$8[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var name = param[2][1], id = param[1];
		   return cont([0, id, name]);
		  },
		  function(param, cont){
		   var name = param[2], id = param[1];
		   return cont([0, id, [0, name, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$834[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$834[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$791 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$834, [0, schematic_cache$791]);
		               caml_callback
		                (schema_versioned$522,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$835 = [];
		               function schema_versioned$523(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$835[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a06, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$835[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$835[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$835[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$522,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   "mcp-server",
		   cst_Mcp_server,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$521,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            a07,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_membrane,
		              cst_Membrane,
		              b,
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$835[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$835[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$792 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$835, [0, schematic_cache$792]);
		               caml_callback
		                (schema_versioned$523,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$836 = [];
		               function interactivity_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$836[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, a08, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$836[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$836[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$836[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(a1c);},
		                        0,
		                        0,
		                        cst_ask_freely,
		                        "Ask_freely",
		                        [0, aY[1], a1b, aY[3], aY[4]],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(a1a) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_ask_if_necessary,
		                         "Ask_if_necessary",
		                         [0, aX[1], a0$, aX[3], aX[4]],
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(a0_) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_never_ask,
		                          "Never_ask",
		                          [0, aW[1], a09, aW[3], aW[4]],
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$836[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$836[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$793 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$836, [0, schematic_cache$793]);
		               caml_callback
		                (interactivity_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$837 = [];
		               function defer_profile_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$837[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, a1d, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$837[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$837[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$837[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(a1h);},
		                        0,
		                        0,
		                        cst_standard,
		                        cst_Standard,
		                        [0, a0[1], a1g, a0[3], a0[4]],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(a1f) : cont(0);},
		                         0,
		                         0,
		                         cst_mobile_demo,
		                         "Mobile_demo",
		                         [0, aZ[1], a1e, aZ[3], aZ[4]],
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$837[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$837[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$794 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$837, [0, schematic_cache$794]);
		               caml_callback
		                (defer_profile_schema_versioned, [function(param){return 0;}]);
		               var
		                schematic_cache$795 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$838 = [];
		               caml_update_dummy
		                (letrec_function_context$838, [0, schematic_cache$795]);
		               function schematic_version$110(param){return 0;}
		               var
		                schematic_schema_version$83 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$838[1][1],
		                     schematic_schema_version$83]);
		               if(e)
		                var schema$198 = e[1], descriptor$33 = schema$198;
		               else
		                descriptor$33 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$838[1][1],
		                              schematic_schema_version$83,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$838[1][1],
		 schematic_schema_version$83,
		 schematic_self,
		 function(a){
		  letrec_function_context$838[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (defer_profile_schema_versioned,
		           schematic_version$110,
		           function(b){
		            var
		             default$ = match$242[1],
		             a =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_defer_profile,
		                 0,
		                 [0, default$],
		                 [0, b],
		                 0,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (interactivity_schema_versioned,
		                     schematic_version$110,
		                     function(b){
		                      var
		                       default$ = match$243[1],
		                       res =
		                         [7,
		                          function(param, cont){
		                           var defer_profile = param[2][1], interactivity = param[1];
		                           return cont([0, interactivity, defer_profile]);
		                          },
		                          function(param, cont){
		                           var defer_profile = param[2], interactivity = param[1];
		                           return cont([0, interactivity, [0, defer_profile, 0]]);
		                          },
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_interactivity,
		                            0,
		                            [0, default$],
		                            [0, b],
		                            0,
		                            0],
		                           a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$838[1][1],
		                               schematic_schema_version$83,
		                               res,
		                               function(a){
		                                letrec_function_context$838[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$199 = [0, a1i, 0, descriptor$33, 0],
		                letrec_function_context$839 = [];
		               function schema_versioned$524(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$839[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1j, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$839[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$839[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$839[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var title = param[2][1], url = param[1];
		                                 return cont([0, url, title]);
		                                },
		                                function(param, cont){
		                                 var title = param[2], url = param[1];
		                                 return cont([0, url, [0, title, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_url,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_title,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$839[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$839[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$796 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$839, [0, schematic_cache$796]);
		               caml_callback
		                (schema_versioned$524,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$797 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$840 = [];
		               caml_update_dummy
		                (letrec_function_context$840, [0, schematic_cache$797]);
		               function schematic_version$111(param, cont){return cont(0);}
		               var
		                schematic_schema_version$82 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$840[1][1],
		                     schematic_schema_version$82]);
		               if(e)
		                var schema$200 = e[1], descriptor$34 = schema$200;
		               else
		                descriptor$34 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$840[1][1],
		                              schematic_schema_version$82,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$840[1][1],
		 schematic_schema_version$82,
		 schematic_self,
		 function(a){
		  letrec_function_context$840[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$524,
		           schematic_version$111,
		           function(b){
		            var
		             default$ = match$244[1],
		             a =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_citations,
		                 0,
		                 [0, default$],
		                 [0, [0, 0, 0, [3, b], 0]],
		                 0,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$518,
		                     schematic_version$111,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var citations = param[2][1], document = param[1];
		                           return cont([0, document, citations]);
		                          },
		                          function(param, cont){
		                           var citations = param[2], document = param[1];
		                           return cont([0, document, [0, citations, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_document, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$840[1][1],
		                               schematic_schema_version$82,
		                               res,
		                               function(a){
		                                letrec_function_context$840[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$201 = [0, a1k, 0, descriptor$34, 0],
		                letrec_function_context$841 = [];
		               caml_update_dummy
		                (letrec_function_context$841, [0, equal$20, equal$164]);
		               var
		                schematic_cache$798 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$842 = [];
		               caml_update_dummy
		                (letrec_function_context$842, [0, schematic_cache$798]);
		               var
		                schematic_schema_version$81 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$842[1][1],
		                     schematic_schema_version$81]);
		               if(e)
		                var schema$202 = e[1], descriptor$35 = schema$202;
		               else
		                descriptor$35 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$842[1][1],
		                              schematic_schema_version$81,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$842[1][1],
		 schematic_schema_version$81,
		 schematic_self,
		 function(a){
		  letrec_function_context$842[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$4,
		           dummy,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_title,
		                 0,
		                 3,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0, 0, 0, 0, 0, cst_touched_last, 0, 2, [0, b], 0, 0],
		                 0]];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$259,
		                     dummy,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            touched_last = a[2][1],
		                            title = a[1],
		                            id = param[1];
		                           return cont([0, id, title, touched_last]);
		                          },
		                          function(param, cont){
		                           var
		                            touched_last = param[3],
		                            title = param[2],
		                            id = param[1];
		                           return cont([0, id, [0, title, [0, touched_last, 0]]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$842[1][1],
		                               schematic_schema_version$81,
		                               res,
		                               function(a){
		                                letrec_function_context$842[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$203 = [0, a1l, 0, descriptor$35, 0],
		                schematic_cache$799 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$843 = [];
		               caml_update_dummy
		                (letrec_function_context$843, [0, schematic_cache$799]);
		               function schematic_version$112(param, cont){return cont(0);}
		               var schematic_schema_version$80 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$843[1][1],
		                    schematic_schema_version$80]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$843[1][1],
		                             schematic_schema_version$80,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$843[1][1],
		schematic_schema_version$80,
		schematic_self,
		function(a){
		 letrec_function_context$843[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$257,
		          schematic_version$112,
		          function(a){
		           var
		            res =
		              [7,
		               function(param, cont){
		                var context = param[1];
		                return cont([0, context]);
		               },
		               function(param, cont){
		                var context = param[1];
		                return cont([0, context, 0]);
		               },
		               [0, [0, 0, 0, 0, 0, cst_context, 0, 3, [0, a], 0, 0], 0]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$843[1][1],
		                    schematic_schema_version$80,
		                    res,
		                    function(a){
		                     letrec_function_context$843[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var schema$204 = Patch$1[4], letrec_function_context$844 = [];
		               function schema_versioned$525(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$844[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1m, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$844[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$844[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$844[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$267,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var workspace_id = param[2][1], kind = param[1];
		             return cont([0, kind, workspace_id]);
		            },
		            function(param, cont){
		             var workspace_id = param[2], kind = param[1];
		             return cont([0, kind, [0, workspace_id, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [1, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$844[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$844[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$800 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$844, [0, schematic_cache$800]);
		               caml_callback
		                (schema_versioned$525,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$845 = [];
		               function schema_versioned$526(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$845[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1n, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$845[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$845[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$845[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Event_kinds[70],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_on_change, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$525,
		       schematic_version,
		       function(d){
		        var
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([1, f0, f1]);
		             },
		             function(param, cont){
		              if(typeof param !== "number" && 0 !== param[0]){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              }
		              return cont(0);
		             },
		             1,
		             0,
		             cst_commit_pattern,
		             cst_Commit_pattern,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var on_change = param[2][1], watched = param[1];
		                return cont([0, watched, on_change]);
		               },
		               function(param, cont){
		                var on_change = param[2], watched = param[1];
		                return cont([0, watched, [0, on_change, 0]]);
		               },
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_watched,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, d], 0]],
		                 0,
		                 0],
		                a]],
		              0],
		             0],
		            0],
		         c =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_timezone,
		             0,
		             2,
		             [0, schema_versioned$126()],
		             0,
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$222,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      a1p,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){
		                         return typeof param === "number" ? cont(a1o) : cont(0);
		                        },
		                        0,
		                        0,
		                        cst_manual,
		                        cst_Manual,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){return cont(0);},
		                          function(param, cont){return cont(0);},
		                          0],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){
		                          var f2 = param[3], f1 = param[2], f0 = param[1];
		                          return cont([0, f0, f1, f2]);
		                         },
		                         function(param, cont){
		                          if(typeof param !== "number" && 0 === param[0]){
		                           var f2 = param[3], f1 = param[2], f0 = param[1];
		                           return cont([0, [0, f0, f1, f2]]);
		                          }
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_recurrent,
		                         cst_Recurrent,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var
		                             a = param[2],
		                             timezone = a[2][1],
		                             recurrence = a[1],
		                             daytime = param[1];
		                            return cont([0, daytime, recurrence, timezone]);
		                           },
		                           function(param, cont){
		                            var
		                             timezone = param[3],
		                             recurrence = param[2],
		                             daytime = param[1];
		                            return cont([0, daytime, [0, recurrence, [0, timezone, 0]]]);
		                           },
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_daytime,
		                             0,
		                             2,
		                             [0, schema_versioned$2(schematic_version)],
		                             0,
		                             0],
		                            [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, a], 0, 0], c]]],
		                          0],
		                         0],
		                        b]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$845[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$845[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$801 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$845, [0, schematic_cache$801]);
		               caml_callback
		                (schema_versioned$526,
		                 [function(param, cont){return cont(0);}]);
		               function to_internal(t, cont){
		                if(typeof t === "number") return cont(0);
		                if(0 === t[0]){
		                 var timezone = t[3], recurrence = t[2], daytime = t[1];
		                 return cont([0, daytime, recurrence, timezone]);
		                }
		                var on_change = t[2], watched = t[1];
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         watched,
		                         function(p, cont){return cont([0, p[1], on_change, p[2]]);},
		                         function(watched){return cont([1, watched]);});
		               }
		               var
		                schematic_cache$802 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$846 = [];
		               caml_update_dummy
		                (letrec_function_context$846, [0, schematic_cache$802]);
		               function schematic_version$113(param, cont){return cont(0);}
		               var
		                schematic_schema_version$79 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$846[1][1],
		                     schematic_schema_version$79]);
		               if(e)
		                var schema$205 = e[1], descriptor$36 = schema$205;
		               else
		                descriptor$36 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$846[1][1],
		                              schematic_schema_version$79,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$846[1][1],
		 schematic_schema_version$79,
		 schematic_self,
		 function(a){
		  letrec_function_context$846[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$526,
		           schematic_version$113,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_enabled, 0, 2, [0, bool_schema], 0, 0],
		                [0, [0, 0, 0, 0, 0, cst_trigger, 0, 2, [0, b], 0, 0], 0]];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$263,
		                     schematic_version$113,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_name,
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_steps,
		                            0,
		                            2,
		                            [0, [0, 0, 0, [3, c], 0]],
		                            0,
		                            0],
		                           a]];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$266,
		                               schematic_version$113,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      b = a[2],
		                                      c = b[2],
		                                      trigger = c[2][1],
		                                      enabled = c[1],
		                                      steps = b[1],
		                                      name = a[1],
		                                      id = param[1];
		                                     return cont([0, id, name, steps, enabled, trigger]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      trigger = param[5],
		                                      enabled = param[4],
		                                      steps = param[3],
		                                      name = param[2],
		                                      id = param[1];
		                                     return cont
		     ([0,
		       id,
		       [0, name, [0, steps, [0, enabled, [0, trigger, 0]]]]]);
		                                    },
		                                    [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$846[1][1],
		 schematic_schema_version$79,
		 res,
		 function(a){
		  letrec_function_context$846[1][1] = a;
		  return cont(res);
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$206 = [0, a1q, 0, descriptor$36, 0];
		               function of_internal(param, cont){
		                var
		                 trigger = param[5],
		                 enabled = param[4],
		                 steps = param[3],
		                 name = param[2],
		                 id = param[1];
		                function a(a){return cont([0, id, name, steps, enabled, a]);}
		                if(typeof trigger === "number") return a(0);
		                if(0 === trigger[0]){
		                 var
		                  timezone = trigger[3],
		                  recurrence = trigger[2],
		                  daytime = trigger[1];
		                 return a([0, daytime, recurrence, timezone]);
		                }
		                var watched = trigger[1];
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         watched,
		                         function(p, cont){return cont(p[2]);},
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (reduce,
		                                   b,
		                                   function(a, b, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (Event_kinds[16],
		     a,
		     b,
		     function(c){
		      function b(b){return cont(a);}
		      return 1 - c
		              ? caml_exact_trampoline_cps_call
		                (failwith,
		                 "not_implemented: automation trigger patterns have different on_change sets",
		                 b)
		              : b();
		     });
		                                   },
		                                   function(b){
		                                    var on_change = value$4(b, Event_kinds[72]);
		                                    return caml_trampoline_cps_call3
		    (map$18,
		     watched,
		     function(p, cont){return cont([0, p[1], p[3]]);},
		     function(watched){return a([1, watched, on_change]);});
		                                   });
		                         });
		               }
		               var letrec_function_context$847 = [];
		               function step_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$847[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1s, a1r, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$847[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$847[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$847[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var name = param[2][1], index = param[1];
		                                 return cont([0, index, name]);
		                                },
		                                function(param, cont){
		                                 var name = param[2], index = param[1];
		                                 return cont([0, index, [0, name, 0]]);
		                                },
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_index, 0, 2, [0, int_schema], 0, 0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$847[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$847[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$803 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$847, [0, schematic_cache$803]);
		               caml_callback
		                (step_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$804 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$848 = [];
		               caml_update_dummy
		                (letrec_function_context$848, [0, schematic_cache$804]);
		               function schematic_version$114(param, cont){return cont(0);}
		               var
		                schematic_schema_version$78 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$848[1][1],
		                     schematic_schema_version$78]);
		               if(e)
		                var schema$207 = e[1], descriptor$37 = schema$207;
		               else
		                descriptor$37 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$848[1][1],
		                              schematic_schema_version$78,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$848[1][1],
		 schematic_schema_version$78,
		 schematic_self,
		 function(a){
		  letrec_function_context$848[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (step_schema_versioned,
		           schematic_version$114,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_name,
		                 0,
		                 2,
		                 [0, schematic_param_name_schema_ve],
		                 0,
		                 0],
		                [0,
		                 [0, 0, 0, 0, 0, cst_steps, 0, 2, [0, int_schema], 0, 0],
		                 [0, [0, 0, 0, 0, 0, cst_step, 0, 2, [0, b], 0, 0], 0]]];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$120,
		                     schematic_version$114,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, c], 0, 0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (Automation_run[4],
		                               schematic_version$114,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      b = a[2],
		                                      c = b[2],
		                                      step = c[2][1],
		                                      steps = c[1],
		                                      name = b[1],
		                                      workspace_id = a[1],
		                                      id = param[1];
		                                     return cont([0, id, workspace_id, name, steps, step]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      step = param[5],
		                                      steps = param[4],
		                                      name = param[3],
		                                      workspace_id = param[2],
		                                      id = param[1];
		                                     return cont
		     ([0,
		       id,
		       [0, workspace_id, [0, name, [0, steps, [0, step, 0]]]]]);
		                                    },
		                                    [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$848[1][1],
		 schematic_schema_version$78,
		 res,
		 function(a){
		  letrec_function_context$848[1][1] = a;
		  return cont(res);
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$208 = [0, a1u, a1t, descriptor$37, 0],
		                schematic_cache$805 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$849 = [];
		               caml_update_dummy
		                (letrec_function_context$849, [0, schematic_cache$805]);
		               function schematic_version$115(param, cont){return cont(0);}
		               var
		                schematic_schema_version$77 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$849[1][1],
		                     schematic_schema_version$77]);
		               if(e)
		                var schema$209 = e[1], descriptor$38 = schema$209;
		               else
		                descriptor$38 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$849[1][1],
		                              schematic_schema_version$77,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$849[1][1],
		 schematic_schema_version$77,
		 schematic_self,
		 function(a){
		  letrec_function_context$849[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$526,
		           schematic_version$115,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_enabled, 0, 3, [0, bool_schema], 0, 0],
		                [0, [0, 0, 0, 0, 0, cst_trigger, 0, 3, [0, b], 0, 0], 0]];
		            return caml_exact_trampoline_cps_call
		                    (option_schema,
		                     schematic_param_name_schema_ve,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            trigger = a[2][1],
		                            enabled = a[1],
		                            name = param[1];
		                           return cont([0, name, enabled, trigger]);
		                          },
		                          function(param, cont){
		                           var trigger = param[3], enabled = param[2], name = param[1];
		                           return cont([0, name, [0, enabled, [0, trigger, 0]]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_name, 0, 3, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$849[1][1],
		                               schematic_schema_version$77,
		                               res,
		                               function(a){
		                                letrec_function_context$849[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$210 = [0, a1v, 0, descriptor$38, 0],
		                schematic_cache$806 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$850 = [];
		               caml_update_dummy
		                (letrec_function_context$850, [0, schematic_cache$806]);
		               function schematic_version$116(param, cont){return cont(0);}
		               var
		                schematic_schema_version$76 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$850[1][1],
		                     schematic_schema_version$76]);
		               if(e)
		                var schema$211 = e[1], descriptor$39 = schema$211;
		               else
		                descriptor$39 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$850[1][1],
		                              schematic_schema_version$76,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$850[1][1],
		 schematic_schema_version$76,
		 schematic_self,
		 function(a){
		  letrec_function_context$850[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (Automation_run[26][65],
		           schematic_version$116,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_pending_resume, 0, 2, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (Automation_run[26][65],
		                     schematic_version$116,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0, 0, 0, 0, 0, cst_pending_user_input, 0, 2, [0, c], 0, 0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (Automation_run[26][65],
		                               schematic_version$116,
		                               function(c){
		                                var
		                                 a = [0, [0, 0, 0, 0, 0, cst_failed, 0, 2, [0, c], 0, 0], b];
		                                return caml_exact_trampoline_cps_call
		(Automation_run[26][65],
		 schematic_version$116,
		 function(b){
		  var
		   res =
		     [7,
		      function(param, cont){
		       var
		        a = param[2],
		        b = a[2],
		        pending_resume = b[2][1],
		        pending_user_input = b[1],
		        failed = a[1],
		        completed = param[1];
		       return cont
		               ([0, completed, failed, pending_user_input, pending_resume]);
		      },
		      function(param, cont){
		       var
		        pending_resume = param[4],
		        pending_user_input = param[3],
		        failed = param[2],
		        completed = param[1];
		       return cont
		               ([0,
		                 completed,
		                 [0, failed, [0, pending_user_input, [0, pending_resume, 0]]]]);
		      },
		      [0, [0, 0, 0, 0, 0, cst_completed, 0, 2, [0, b], 0, 0], a]];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$850[1][1],
		           schematic_schema_version$76,
		           res,
		           function(a){
		            letrec_function_context$850[1][1] = a;
		            return cont(res);
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$212 = [0, a1w, 0, descriptor$39, 0];
		               function create_events_as(a, cont){
		                if(0 === a[0]){
		                 var email = a[1][1];
		                 return caml_exact_trampoline_cps_call
		                         (to_string$51, email, function(a){return cont([0, a, 0]);});
		                }
		                a = a[1][5];
		                var name = a[7], email$0 = a[1];
		                return cont([0, email$0, [0, name]]);
		               }
		               function attend_events_as(a, cont){
		                if(0 === a[0]){
		                 var email = a[1][1];
		                 return caml_exact_trampoline_cps_call
		                         (to_string$51,
		                          email,
		                          function(a){return cont([0, a, 0, 1, a1x]);});
		                }
		                a = a[1][5];
		                var name = a[7], email$0 = a[1];
		                return cont([0, email$0, [0, name], 1, a1y]);
		               }
		               var ById = caml_callback(M$2, [[0, Device[24], Device[4]]]);
		               function environment_schema_versioned$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (environment_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, a1z, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schematic_cache$807 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$851 = [];
		               caml_update_dummy
		                (letrec_function_context$851, [0, schematic_cache$807]);
		               caml_callback
		                (environment_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$117(param, cont){return cont(0);}
		               var
		                schematic_schema_version$75 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$851[1][1],
		                     schematic_schema_version$75]);
		               if(e)
		                var schema$213 = e[1], descriptor$40 = schema$213;
		               else
		                descriptor$40 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$851[1][1],
		                              schematic_schema_version$75,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$851[1][1],
		 schematic_schema_version$75,
		 schematic_self,
		 function(a){
		  letrec_function_context$851[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (environment_schema_versioned$0,
		           schematic_version$117,
		           function(a){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var
		                  a = param[2],
		                  b = a[2],
		                  channel = b[2][1],
		                  pns = b[1],
		                  frontend = a[1],
		                  api = param[1];
		                 return cont([0, api, frontend, pns, channel]);
		                },
		                function(param, cont){
		                 var
		                  channel = param[4],
		                  pns = param[3],
		                  frontend = param[2],
		                  api = param[1];
		                 return cont
		                         ([0, api, [0, frontend, [0, pns, [0, channel, 0]]]]);
		                },
		                [0,
		                 [0, 0, 0, 0, 0, cst_api, 0, 2, [0, schema$262], 0, 0],
		                 [0,
		                  [0, 0, 0, 0, 0, cst_frontend, 0, 2, [0, schema$262], 0, 0],
		                  [0,
		                   [0, 0, 0, 0, 0, "pns", 0, 2, [0, schema$262], 0, 0],
		                   [0, [0, 0, 0, 0, 0, cst_channel, 0, 2, [0, a], 0, 0], 0]]]]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$851[1][1],
		                     schematic_schema_version$75,
		                     res,
		                     function(a){
		                      letrec_function_context$851[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$214 = [0, a1A, 0, descriptor$40, 0];
		               function pp$125(f, e, cont){
		                if(typeof e === "number")
		                 return -610669292 === e
		                         ? caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, "connectivity issue", cont)
		                         : 647871990
		                           <= e
		                           ? 685770833
		                             <= e
		                             ? caml_exact_trampoline_cps_call$1
		                               (pp_print_string, f, "authentication needed", cont)
		                             : caml_exact_trampoline_cps_call$1
		                               (pp_print_string, f, "account is being migrated", cont)
		                           : 19653306
		                             <= e
		                             ? caml_exact_trampoline_cps_call(fprintf$0(f), a1C, cont)
		                             : caml_exact_trampoline_cps_call(fprintf$0(f), a1D, cont);
		                var variant = e[1];
		                if(3257466 <= variant){
		                 if(238161351 > variant){
		                  if(9943782 <= variant){
		                   var e$0 = e[2];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            a1I,
		                            function(a){return caml_trampoline_cps_call2(a, e$0, cont);});
		                  }
		                  var
		                   e$1 = e[2],
		                   pp =
		                     function(a, b, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (pp$24, pp_print_string, a, b, cont);
		                     },
		                   b =
		                     function(fmt, e, cont){
		                      var match = e[2];
		                      if(! match)
		                       return caml_exact_trampoline_cps_call$0
		                               (pp$24, pp_print_string, fmt, e[1], cont);
		                      var pos = match[1];
		                      return caml_exact_trampoline_cps_call
		                              (to_string$2,
		                               pos,
		                               function(b){
		                                var a = e[1];
		                                return caml_exact_trampoline_cps_call
		(fprintf$0(fmt),
		 a1B,
		 function(c){
		  return caml_trampoline_cps_call4(c, pp, a, b, cont);
		 });
		                               });
		                     };
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(f),
		                           a1J,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, b, e$1, cont);
		                           });
		                 }
		                 if(809593979 <= variant){
		                  if(847566860 <= variant){
		                   var workspace = e[2];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(f),
		                            a1E,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, pp$46, workspace, cont);
		                            });
		                  }
		                  var a = e[2], msg = a[2], key = a[1];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(f),
		                           a1F,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, key, msg, cont);
		                           });
		                 }
		                 if(670504498 <= variant){
		                  a = e[2];
		                  var msg$0 = a[2], key$0 = a[1];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(f),
		                           a1G,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, key$0, msg$0, cont);
		                           });
		                 }
		                 var uri = e[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          a1H,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, pp$27, uri, cont);
		                          });
		                }
		                if(-756235133 > variant){
		                 if(-867418942 <= variant){
		                  var minimum_version = e[2][2];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(f),
		                           a1O,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (a, pp$5, minimum_version, cont);
		                           });
		                 }
		                 var reset_time = e[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          a1P,
		                          function(a){
		                           return caml_trampoline_cps_call3(a, _12, reset_time, cont);
		                          });
		                }
		                if(-349351921 <= variant){
		                 if(-325815612 <= variant){
		                  a = e[2];
		                  var e$2 = a[2], name = a[1];
		                  return caml_exact_trampoline_cps_call
		                          (fprintf$0(f),
		                           a1K,
		                           function(a){
		                            return caml_trampoline_cps_call4
		                                    (a, name, pp_decoding, e$2, cont);
		                           });
		                 }
		                 var workspace$0 = e[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          a1L,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a, pp$46, workspace$0, cont);
		                          });
		                }
		                if(-438114087 <= variant){
		                 var reason = e[2];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          a1M,
		                          function(a){
		                           return caml_trampoline_cps_call2(a, reason, cont);
		                          });
		                }
		                var id = e[2];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         a1N,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, pp$2, id, cont);
		                         });
		               }
		               function to_string$73(e, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_to_string, pp$125, e, cont);
		               }
		               function pp_toplevel(f, e, cont){
		                return caml_exact_trampoline_cps_call$1(pp$125, f, e, cont);
		               }
		               function toplevel_to_string(e, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_to_string, pp_toplevel, e, cont);
		               }
		               var
		                cst_destructiveHint = "destructiveHint",
		                cst_idempotentHint = "idempotentHint",
		                cst_openWorldHint = "openWorldHint",
		                cst_readOnlyHint = "readOnlyHint",
		                letrec_function_context$852 = [];
		               function schema_versioned$527(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$852[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1Q, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$852[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$852[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$852[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  open_world_hint = b[2][1],
		                                  idempotent_hint = b[1],
		                                  destructive_hint = a[1],
		                                  read_only_hint = param[1];
		                                 return cont
		 ([0,
		   read_only_hint,
		   destructive_hint,
		   idempotent_hint,
		   open_world_hint]);
		                                },
		                                function(param, cont){
		                                 var
		                                  open_world_hint = param[4],
		                                  idempotent_hint = param[3],
		                                  destructive_hint = param[2],
		                                  read_only_hint = param[1];
		                                 return cont
		 ([0,
		   read_only_hint,
		   [0,
		    destructive_hint,
		    [0, idempotent_hint, [0, open_world_hint, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_readOnlyHint,
		                                  0,
		                                  2,
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_destructiveHint,
		                                   0,
		                                   2,
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_idempotentHint,
		                                    0,
		                                    3,
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_openWorldHint,
		                                     0,
		                                     2,
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$852[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$852[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$808 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$852, [0, schematic_cache$808]);
		               caml_callback
		                (schema_versioned$527,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$809 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$853 = [];
		               caml_update_dummy
		                (letrec_function_context$853, [0, schematic_cache$809]);
		               function schematic_version$118(param, cont){return cont(0);}
		               var
		                schematic_schema_version$74 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$853[1][1],
		                     schematic_schema_version$74]),
		                cst_inputSchema = "inputSchema";
		               if(e)
		                var schema$215 = e[1], descriptor$41 = schema$215;
		               else
		                descriptor$41 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$853[1][1],
		                              schematic_schema_version$74,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$853[1][1],
		 schematic_schema_version$74,
		 schematic_self,
		 function(a){
		  letrec_function_context$853[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$527,
		           schematic_version$118,
		           function(a){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var
		                  a = param[2],
		                  b = a[2],
		                  c = b[2],
		                  d = c[2],
		                  annotations = d[2][1],
		                  input_schema = d[1],
		                  description = c[1],
		                  namespace_path = b[1],
		                  title = a[1],
		                  name = param[1];
		                 return cont
		                         ([0,
		                           name,
		                           title,
		                           namespace_path,
		                           description,
		                           input_schema,
		                           annotations]);
		                },
		                function(param, cont){
		                 var
		                  annotations = param[6],
		                  input_schema = param[5],
		                  description = param[4],
		                  namespace_path = param[3],
		                  title = param[2],
		                  name = param[1];
		                 return cont
		                         ([0,
		                           name,
		                           [0,
		                            title,
		                            [0,
		                             namespace_path,
		                             [0, description, [0, input_schema, [0, annotations, 0]]]]]]);
		                },
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_name,
		                  0,
		                  2,
		                  [0, schematic_param_name_schema_ve],
		                  0,
		                  0],
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_title,
		                   0,
		                   2,
		                   [0, schematic_param_name_schema_ve],
		                   0,
		                   0],
		                  [0,
		                   [0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    "namespacePath",
		                    0,
		                    2,
		                    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                    0,
		                    0],
		                   [0,
		                    [0,
		                     0,
		                     0,
		                     0,
		                     0,
		                     cst_description,
		                     0,
		                     2,
		                     [0, schematic_param_name_schema_ve],
		                     0,
		                     0],
		                    [0,
		                     [0,
		                      0,
		                      0,
		                      0,
		                      0,
		                      cst_inputSchema,
		                      0,
		                      2,
		                      [0, no_input_schema],
		                      0,
		                      0],
		                     [0, [0, 0, 0, 0, 0, cst_annotations, 0, 2, [0, a], 0, 0], 0]]]]]]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$853[1][1],
		                     schematic_schema_version$74,
		                     res,
		                     function(a){
		                      letrec_function_context$853[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$216 = [0, a1R, 0, descriptor$41, 0],
		                schematic_cache$810 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$854 = [];
		               caml_update_dummy
		                (letrec_function_context$854, [0, schematic_cache$810]);
		               var
		                schematic_schema_version$28 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$854[1][1],
		                     schematic_schema_version$28]);
		               if(e)
		                var schema$217 = e[1], descriptor$42 = schema$217;
		               else
		                descriptor$42 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$854[1][1],
		                              schematic_schema_version$28,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$854[1][1],
		 schematic_schema_version$28,
		 schematic_self,
		 function(a){
		  letrec_function_context$854[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (option_schema,
		           schematic_param_name_schema_ve,
		           function(b){
		            var
		             default$ = match$245[1],
		             a =
		               [0,
		                [0, 0, 0, 0, 0, cst_error, 0, [0, default$], [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (option_schema,
		                     no_input_schema,
		                     function(b){
		                      var
		                       default$ = match$246[1],
		                       res =
		                         [7,
		                          function(param, cont){
		                           var error = param[2][1], result = param[1];
		                           return cont([0, result, error]);
		                          },
		                          function(param, cont){
		                           var error = param[2], result = param[1];
		                           return cont([0, result, [0, error, 0]]);
		                          },
		                          [0,
		                           [0, 0, 0, 0, 0, cst_result, 0, [0, default$], [0, b], 0, 0],
		                           a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$854[1][1],
		                               schematic_schema_version$28,
		                               res,
		                               function(a){
		                                letrec_function_context$854[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$218 = [0, a1S, 0, descriptor$42, 0],
		                letrec_function_context$855 = [];
		               function schema_versioned$528(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$855[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1U, a1T, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$855[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$855[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$855[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var value = param[2][1], name = param[1];
		                                 return cont([0, name, value]);
		                                },
		                                function(param, cont){
		                                 var value = param[2], name = param[1];
		                                 return cont([0, name, [0, value, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_value,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$855[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$855[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$811 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$855, [0, schematic_cache$811]);
		               caml_callback
		                (schema_versioned$528,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$856 = [];
		               function schema_versioned$529(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$856[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1W, a1V, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$856[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$856[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$856[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$528,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       default$ = match$247[1],
		                                       default$0 = match$248[1],
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_http,
		    "Http",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){var url = param[1]; return cont(url);},
		      function(url, cont){return cont([0, url, 0]);},
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_url,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       0]],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){
		      var f2 = param[3], f1 = param[2], f0 = param[1];
		      return cont([1, f0, f1, f2]);
		     },
		     function(param, cont){
		      if(0 === param[0]) return cont(0);
		      var f2 = param[3], f1 = param[2], f0 = param[1];
		      return cont([0, [0, f0, f1, f2]]);
		     },
		     1,
		     0,
		     cst_stdio,
		     "Stdio",
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var
		         a = param[2],
		         env = a[2][1],
		         args = a[1],
		         command = param[1];
		        return cont([0, command, args, env]);
		       },
		       function(param, cont){
		        var env = param[3], args = param[2], command = param[1];
		        return cont([0, command, [0, args, [0, env, 0]]]);
		       },
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_command,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_args,
		          0,
		          [0, default$0],
		          [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		          0,
		          0],
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_env,
		           0,
		           [0, default$],
		           [0, [0, 0, 0, [3, a], 0]],
		           0,
		           0],
		          0]]]],
		      0],
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$856[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$856[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$812 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$856, [0, schematic_cache$812]);
		               var
		                schema$219 =
		                  caml_callback
		                   (schema_versioned$529,
		                    [function(param, cont){return cont(0);}]),
		                cst_bearer = "bearer",
		                letrec_function_context$857 = [];
		               function schema_versioned$530(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$857[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1Y, a1X, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$857[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$857[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$857[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   return typeof param === "number" ? cont(a10) : cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_none,
		                                  "No_auth",
		                                  a1Z,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_bearer,
		                                   "Bearer",
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var token = param[1];
		                                      return cont(token);
		                                     },
		                                     function(token, cont){return cont([0, token, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_token,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([1, f0, f1]);
		                                    },
		                                    function(param, cont){
		                                     if(typeof param !== "number" && 0 !== param[0]){
		                                      var f1 = param[2], f0 = param[1];
		                                      return cont([0, [0, f0, f1]]);
		                                     }
		                                     return cont(0);
		                                    },
		                                    1,
		                                    0,
		                                    cst_header,
		                                    "Header",
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var value = param[2][1], name = param[1];
		                                       return cont([0, name, value]);
		                                      },
		                                      function(param, cont){
		                                       var value = param[2], name = param[1];
		                                       return cont([0, name, [0, value, 0]]);
		                                      },
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_name,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_value,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		0]]],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$857[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$857[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$813 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$857, [0, schematic_cache$813]);
		               var
		                schema$220 =
		                  caml_callback
		                   (schema_versioned$530,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$858 = [];
		               function schema_versioned$531(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$858[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a12, a11, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$858[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$858[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$858[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a16);},
		                                  0,
		                                  0,
		                                  cst_readOnly,
		                                  cst_Read_only,
		                                  [0, a2[1], a15, a2[3], a2[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(a14) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_all,
		                                   cst_All,
		                                   [0, a1[1], a13, a1[3], a1[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$858[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$858[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$814 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$858, [0, schematic_cache$814]);
		               var
		                schema$221 =
		                  caml_callback
		                   (schema_versioned$531,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$859 = [];
		               function schema_versioned$532(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$859[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a18, a17, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$859[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$859[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$859[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$527,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    annotations = b[2][1],
		    input_schema = b[1],
		    description = a[1],
		    name = param[1];
		   return cont
		           ([0, name, description, input_schema, annotations]);
		  },
		  function(param, cont){
		   var
		    annotations = param[4],
		    input_schema = param[3],
		    description = param[2],
		    name = param[1];
		   return cont
		           ([0,
		             name,
		             [0, description, [0, input_schema, [0, annotations, 0]]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_description,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_inputSchema,
		      0,
		      2,
		      [0, no_input_schema],
		      0,
		      0],
		     [0, [0, 0, 0, 0, 0, cst_annotations, 0, 2, [0, a], 0, 0], 0]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$859[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$859[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$815 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$859, [0, schematic_cache$815]);
		               caml_callback
		                (schema_versioned$532,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$860 = [];
		               function schema_versioned$533(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$860[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a1_, a19, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$860[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$860[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$860[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$532,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$249[1],
		                                       a =
		 [0,
		  [0,
		   a1$,
		   0,
		   0,
		   0,
		   cst_tools,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$531,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_enabled, 0, 2, [0, bool_schema], 0, 0],
		            [0, [0, 0, 0, 0, 0, cst_trust, 0, 2, [0, c], 0, 0], a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$530,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_auth, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$529,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 a2a,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_transport, 0, 2, [0, c], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call
		                                    (Id$8[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    tools = e[2][1],
		    trust = e[1],
		    enabled = d[1],
		    auth = c[1],
		    transport = b[1],
		    name = a[1],
		    id = param[1];
		   return cont
		           ([0, id, name, transport, auth, enabled, trust, tools]);
		  },
		  function(param, cont){
		   var
		    tools = param[7],
		    trust = param[6],
		    enabled = param[5],
		    auth = param[4],
		    transport = param[3],
		    name = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0,
		              name,
		              [0,
		               transport,
		               [0, auth, [0, enabled, [0, trust, [0, tools, 0]]]]]]]);
		  },
		  [0, [0, a2b, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$860[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$860[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$816 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$860, [0, schematic_cache$816]);
		               var
		                schema$222 =
		                  caml_callback
		                   (schema_versioned$533,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$861 = [];
		               function connection_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$861[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2d, a2c, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$861[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$861[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$861[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                a2f,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   return typeof param === "number" ? cont(a2e) : cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_connected,
		                                  "Connected",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([0, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_failed,
		                                   cst_Failed,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var message = param[1];
		                                      return cont(message);
		                                     },
		                                     function(message, cont){return cont([0, message, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_message,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([1, f0]);},
		                                    function(param, cont){
		                                     if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                     return cont(0);
		                                    },
		                                    1,
		                                    0,
		                                    "authenticationRequired",
		                                    "Authentication_required",
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var message = param[1];
		                                       return cont(message);
		                                      },
		                                      function(message, cont){return cont([0, message, 0]);},
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_message,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(f0, cont){return cont([2, f0]);},
		                                     function(param, cont){
		                                      if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                      return cont(0);
		                                     },
		                                     1,
		                                     0,
		                                     "oauthAvailable",
		                                     "Oauth_available",
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){
		var message = param[1];
		return cont(message);
		                                       },
		                                       function(message, cont){return cont([0, message, 0]);},
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_message,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		0]],
		                                      0],
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$861[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$861[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$817 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$861, [0, schematic_cache$817]);
		               caml_callback
		                (connection_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$818 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$862 = [];
		               caml_update_dummy
		                (letrec_function_context$862, [0, schematic_cache$818]);
		               function schematic_version$119(param, cont){return cont(0);}
		               var
		                schematic_schema_version$73 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$862[1][1],
		                     schematic_schema_version$73]);
		               if(e)
		                var schema$223 = e[1], descriptor$43 = schema$223;
		               else
		                descriptor$43 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$862[1][1],
		                              schematic_schema_version$73,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$862[1][1],
		 schematic_schema_version$73,
		 schematic_self,
		 function(a){
		  letrec_function_context$862[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (connection_schema_versioned,
		           schematic_version$119,
		           function(b){
		            var
		             a =
		               [0, [0, 0, 0, 0, 0, cst_connection, 0, 2, [0, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$533,
		                     schematic_version$119,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var connection = param[2][1], server = param[1];
		                           return cont([0, server, connection]);
		                          },
		                          function(param, cont){
		                           var connection = param[2], server = param[1];
		                           return cont([0, server, [0, connection, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_server, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$862[1][1],
		                               schematic_schema_version$73,
		                               res,
		                               function(a){
		                                letrec_function_context$862[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$224 = [0, a2h, a2g, descriptor$43, 0];
		               function connected(param){
		                return typeof param[2] === "number" ? 1 : 0;
		               }
		               function equal$253(lhs, rhs, cont){
		                var b = rhs[1], a = lhs[1], c = a === b ? 1 : 0;
		                if(c) var b$0 = rhs[2], a$0 = lhs[2], c = a$0 === b$0 ? 1 : 0;
		                if(c) var b$1 = rhs[3], a$1 = lhs[3], c = a$1 === b$1 ? 1 : 0;
		                if(c) var b$2 = rhs[4], a$2 = lhs[4], c = a$2 === b$2 ? 1 : 0;
		                if(c) var b$3 = rhs[5], a$3 = lhs[5], c = a$3 === b$3 ? 1 : 0;
		                if(c) var b$4 = rhs[6], a$4 = lhs[6], c = a$4 === b$4 ? 1 : 0;
		                if(! c) return cont(c);
		                var b$5 = rhs[7], a$5 = lhs[7];
		                return cont(a$5 === b$5 ? 1 : 0);
		               }
		               var letrec_function_context$863 = [];
		               function schema_versioned$534(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$863[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2i, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$863[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$863[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$863[1][1] = a;
		                            var
		                             default$ = match$250[1],
		                             default$0 = match$251[1],
		                             default$1 = match$252[1],
		                             default$2 = match$253[1],
		                             default$3 = match$254[1],
		                             default$4 = match$255[1],
		                             default$5 = match$256[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  tasks = e[2][1],
		                                  gmail = e[1],
		                                  drive = d[1],
		                                  contacts = c[1],
		                                  contact_directory = b[1],
		                                  calendar = a[1],
		                                  basic = param[1];
		                                 return cont
		 ([0,
		   basic,
		   calendar,
		   contact_directory,
		   contacts,
		   drive,
		   gmail,
		   tasks]);
		                                },
		                                function(param, cont){
		                                 var
		                                  tasks = param[7],
		                                  gmail = param[6],
		                                  drive = param[5],
		                                  contacts = param[4],
		                                  contact_directory = param[3],
		                                  calendar = param[2],
		                                  basic = param[1];
		                                 return cont
		 ([0,
		   basic,
		   [0,
		    calendar,
		    [0,
		     contact_directory,
		     [0, contacts, [0, drive, [0, gmail, [0, tasks, 0]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "basic",
		                                  0,
		                                  [0, default$5],
		                                  [0, bool_schema],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_calendar,
		                                   0,
		                                   [0, default$4],
		                                   [0, bool_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    "contact_directory",
		                                    0,
		                                    [0, default$3],
		                                    [0, bool_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_contacts,
		                                     0,
		                                     [0, default$2],
		                                     [0, bool_schema],
		                                     0,
		                                     0],
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_drive,
		                                      0,
		                                      [0, default$1],
		                                      [0, bool_schema],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_gmail,
		                                       0,
		                                       [0, default$0],
		                                       [0, bool_schema],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_tasks,
		0,
		[0, default$],
		[0, bool_schema],
		0,
		0],
		                                       0]]]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$863[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$863[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$819 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$863, [0, schematic_cache$819]);
		               var
		                schema$225 =
		                  caml_callback
		                   (schema_versioned$534,
		                    [function(param, cont){return cont(0);}]),
		                bOP = [];
		               function schema_versioned$535(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOP[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2j, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOP[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOP[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOP[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (details_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    details = a[2][1],
		    uri = a[1],
		    description = param[1];
		   return cont([0, description, uri, details]);
		  },
		  function(param, cont){
		   var
		    details = param[3],
		    uri = param[2],
		    description = param[1];
		   return cont([0, description, [0, uri, [0, details, 0]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_description,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, 0, 0, 0, 0, cst_uri, 0, 3, [0, schema$262], 0, 0],
		    [0, [0, 0, 0, 0, 0, cst_details, 0, 2, [0, a], 0, 0], 0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOP[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOP[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$864 = [];
		               function details_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$864[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2k, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$864[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$864[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$864[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$116,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    "google_reauthenticate",
		    "Google_reauthenticate",
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var account = param[1];
		       return cont(account);
		      },
		      function(account, cont){return cont([0, account, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_account, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$864[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$864[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$820 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOP, [0, schematic_cache$820]);
		               var schematic_cache$821 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$864, [0, schematic_cache$821]);
		               caml_callback
		                (schema_versioned$535,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (details_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$865 = [];
		               function equal_augmented(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$865[2],
		                         lhs[1],
		                         rhs[1],
		                         function(a){
		                          return a
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$865[1], lhs[2], rhs[2], cont)
		                                  : cont(a);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$865, [0, equal$61, equal$224]);
		               var
		                schematic_cache$822 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$866 = [];
		               caml_update_dummy
		                (letrec_function_context$866, [0, schematic_cache$822]);
		               function schematic_version$120(param, cont){return cont(0);}
		               var
		                schematic_schema_version$72 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$866[1][1],
		                     schematic_schema_version$72]);
		               if(e)
		                var schema$226 = e[1], descriptor$44 = schema$226;
		               else
		                descriptor$44 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$866[1][1],
		                              schematic_schema_version$72,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$866[1][1],
		 schematic_schema_version$72,
		 schematic_self,
		 function(a){
		  letrec_function_context$866[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$120,
		           schematic_version$120,
		           function(b){
		            var
		             a =
		               [0,
		                [0, a2m, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$346,
		                     schematic_version$120,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var workspace = param[2][1], data = param[1];
		                           return cont([0, data, workspace]);
		                          },
		                          function(param, cont){
		                           var workspace = param[2], data = param[1];
		                           return cont([0, data, [0, workspace, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [1, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$866[1][1],
		                               schematic_schema_version$72,
		                               res,
		                               function(a){
		                                letrec_function_context$866[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var augmented_schema$0 = [0, a2l, 0, descriptor$44, 0];
		               caml_callback(M$2, [[0, comparator$16, schema_versioned$103]]);
		               var
		                Ids$1 =
		                  caml_callback
		                   (M$3, [[0, comparator$16, schema_versioned$103]]);
		               caml_callback
		                (ok_or_failwith,
		                 [caml_callback(of_string$23, ["page:000000000000000000000"])]);
		               var
		                schematic_cache$823 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$867 = [];
		               caml_update_dummy
		                (letrec_function_context$867, [0, schematic_cache$823]);
		               var
		                schematic_schema_version$71 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$867[1][1],
		                     schematic_schema_version$71]);
		               if(e)
		                var schema$227 = e[1], descriptor$45 = schema$227;
		               else
		                descriptor$45 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$867[1][1],
		                              schematic_schema_version$71,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$867[1][1],
		 schematic_schema_version$71,
		 schematic_self,
		 function(a){
		  letrec_function_context$867[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$120,
		           dummy,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 function(f0, cont){return cont([1, f0]);},
		                 function(param, cont){
		                  if(0 === param[0]) return cont(0);
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 0,
		                 0,
		                 cst_workspace,
		                 cst_Workspace,
		                 b,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$103,
		                     dummy,
		                     function(b){
		                      var
		                       res =
		                         [11,
		                          0,
		                          [0,
		                           [0,
		                            function(f0, cont){return cont([0, f0]);},
		                            function(param, cont){
		                             if(0 !== param[0]) return cont(0);
		                             var f0 = param[1];
		                             return cont([0, f0]);
		                            },
		                            0,
		                            0,
		                            cst_parent,
		                            cst_Parent,
		                            b,
		                            0],
		                           a],
		                          0];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$867[1][1],
		                               schematic_schema_version$71,
		                               res,
		                               function(a){
		                                letrec_function_context$867[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$228 = [0, a2n, 0, descriptor$45, 0],
		                letrec_function_context$868 = [];
		               function workspaced_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$868[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2o, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$868[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$868[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$868[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(b){
		        var
		         default$ = match$257[1],
		         a =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_workspace,
		             0,
		             [0, default$],
		             [0, b],
		             0,
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$347,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var workspace = param[2][1], data = param[1];
		                       return cont([0, data, workspace]);
		                      },
		                      function(param, cont){
		                       var workspace = param[2], data = param[1];
		                       return cont([0, data, [0, workspace, 0]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [1, b], 0, 0], a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$868[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$868[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$824 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$868, [0, schematic_cache$824]);
		               caml_callback
		                (workspaced_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$869 = [];
		               function augmented_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$869[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2p, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$869[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$869[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$869[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (workspaced_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_page, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Ids$1[70],
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var page = param[2][1], children = param[1];
		             return cont([0, children, page]);
		            },
		            function(param, cont){
		             var page = param[2], children = param[1];
		             return cont([0, children, [0, page, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_children, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$869[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$869[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$825 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$869, [0, schematic_cache$825]);
		               caml_callback
		                (augmented_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$870 = [];
		               function chunk_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$870[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2q, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$870[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$870[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$870[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([8, f0]);},
		                                 function(param, cont){
		                                  if(8 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_icon,
		                                 cst_Icon,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var icon = param[1];
		                                    return cont(icon);
		                                   },
		                                   function(icon, cont){return cont([0, icon, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_icon,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([9, f0]);},
		                                  function(param, cont){
		                                   if(9 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_text,
		                                  cst_Text,
		                                  schematic_param_name_schema_ve,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$188,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([7, f0]);},
		   function(param, cont){
		    if(7 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_task_recurrent,
		   cst_Task_recurrent,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var task = param[1];
		      return cont(task);
		     },
		     function(task, cont){return cont([0, task, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$186,
		       schematic_version,
		       function(d){
		        var
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([6, f0]);},
		             function(param, cont){
		              if(6 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_task,
		             cst_Task,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var task = param[1];
		                return cont(task);
		               },
		               function(task, cont){return cont([0, task, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, d], 0, 0], 0]],
		              0],
		             0],
		            b],
		         c =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_name,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$339,
		                 schematic_version,
		                 function(e){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f1 = param[2], f0 = param[1];
		                        return cont([5, f0, f1]);
		                       },
		                       function(param, cont){
		                        if(5 !== param[0]) return cont(0);
		                        var f1 = param[2], f0 = param[1];
		                        return cont([0, [0, f0, f1]]);
		                       },
		                       1,
		                       0,
		                       cst_people,
		                       cst_People,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var name = param[2][1], people = param[1];
		                          return cont([0, people, name]);
		                         },
		                         function(param, cont){
		                          var name = param[2], people = param[1];
		                          return cont([0, people, [0, name, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_people, 0, 2, [0, e], 0, 0], c]],
		                        0],
		                       0],
		                      a],
		                   d =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_title,
		                       0,
		                       2,
		                       [0, schematic_param_name_schema_ve],
		                       0,
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$103,
		                           schematic_version,
		                           function(c){
		                            var
		                             cst_highlight = "highlight",
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_highlight,
		                                 "Highlight",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var highlight = param[1];
		                                    return cont(highlight);
		                                   },
		                                   function(highlight, cont){return cont([0, highlight, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_highlight,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([3, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(3 !== param[0]) return cont(0);
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1]]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_link,
		                                  cst_Link,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var uri = param[2][1], name = param[1];
		                                     return cont([0, name, uri]);
		                                    },
		                                    function(param, cont){
		                                     var uri = param[2], name = param[1];
		                                     return cont([0, name, [0, uri, 0]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_name,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_uri, 0, 2, [0, schema$262], 0, 0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([4, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(4 !== param[0]) return cont(0);
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_page,
		                                   cst_Page,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var title = param[2][1], page = param[1];
		                                      return cont([0, page, title]);
		                                     },
		                                     function(param, cont){
		                                      var title = param[2], page = param[1];
		                                      return cont([0, page, [0, title, 0]]);
		                                     },
		                                     [0, [0, 0, 0, 0, 0, cst_page, 0, 2, [0, c], 0, 0], d]],
		                                    0],
		                                   0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$239,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(1 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_event_recurrent,
		   cst_Event_recurrent,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var event = param[1];
		      return cont(event);
		     },
		     function(event, cont){return cont([0, event, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_event, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$230,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              cst_event,
		              cst_Event,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var event = param[1];
		                 return cont(event);
		                },
		                function(event, cont){return cont([0, event, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_event, 0, 2, [0, a], 0, 0], 0]],
		               0],
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$870[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$870[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$826 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$870, [0, schematic_cache$826]);
		               caml_callback
		                (chunk_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$871 = [];
		               function type_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$871[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2r, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$871[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$871[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$871[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a2x);},
		                                  0,
		                                  0,
		                                  cst_error,
		                                  cst_Error,
		                                  a2w,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(a2v) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_info,
		                                   cst_Info,
		                                   a2u,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(a2t) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_warning,
		                                    cst_Warning,
		                                    a2s,
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$871[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$871[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$827 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$871, [0, schematic_cache$827]);
		               caml_callback
		                (type_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$872 = [];
		               function schema_versioned$536(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$872[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2y, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$872[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$872[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$872[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  0,
		                                  0,
		                                  cst_event,
		                                  cst_Event,
		                                  [0, schema$263[1], a2A, schema$263[3], schema$263[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(0 === param[0]) return cont(0);
		                                    var f0 = param[1];
		                                    return cont([0, f0]);
		                                   },
		                                   0,
		                                   0,
		                                   cst_generic,
		                                   cst_Generic,
		                                   [0,
		                                    schematic_param_name_schema_ve[1],
		                                    a2z,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$872[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$872[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$828 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$872, [0, schematic_cache$828]);
		               caml_callback
		                (schema_versioned$536,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$829 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$873 = [];
		               caml_update_dummy
		                (letrec_function_context$873, [0, schematic_cache$829]);
		               function schematic_version$121(param, cont){return cont(0);}
		               var
		                schematic_schema_version$70 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$873[1][1],
		                     schematic_schema_version$70]);
		               if(e)
		                var schema$229 = e[1], descriptor$46 = schema$229;
		               else
		                descriptor$46 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$873[1][1],
		                              schematic_schema_version$70,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$873[1][1],
		 schematic_schema_version$70,
		 schematic_self,
		 function(a){
		  letrec_function_context$873[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (type_schema_versioned$0,
		           schematic_version$121,
		           function(b){
		            var
		             default$ = match$258[1],
		             a =
		               [0,
		                [0, a2C, 0, 0, 0, cst_type, 0, [0, default$], [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$4,
		                     schematic_version$121,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           a2E,
		                           0,
		                           0,
		                           0,
		                           "message_str",
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0, [0, a2D, 0, 0, 0, cst_time, 0, 2, [0, c], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call
		                              (chunk_schema_versioned,
		                               schematic_version$121,
		                               function(c){
		                                var
		                                 a =
		                                   [0,
		                                    [0, a2G, 0, 0, 0, cst_link, 0, 3, [0, schema$262], 0, 0],
		                                    [0,
		                                     [0,
		                                      a2F,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_message,
		                                      0,
		                                      2,
		                                      [0, schema_versioned$7(schematic_version$121, c)],
		                                      0,
		                                      0],
		                                     b]];
		                                return caml_exact_trampoline_cps_call
		(schema_versioned$536,
		 schematic_version$121,
		 function(b){
		  var
		   res =
		     [7,
		      function(param, cont){
		       var
		        a = param[2],
		        b = a[2],
		        c = b[2],
		        d = c[2],
		        type = d[2][1],
		        time = d[1],
		        message_str = c[1],
		        message = b[1],
		        link = a[1],
		        id = param[1];
		       return cont([0, id, link, message, message_str, time, type]);
		      },
		      function(param, cont){
		       var
		        type = param[6],
		        time = param[5],
		        message_str = param[4],
		        message = param[3],
		        link = param[2],
		        id = param[1];
		       return cont
		               ([0,
		                 id,
		                 [0,
		                  link,
		                  [0, message, [0, message_str, [0, time, [0, type, 0]]]]]]);
		      },
		      [0, [0, a2H, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$873[1][1],
		           schematic_schema_version$70,
		           res,
		           function(a){
		            letrec_function_context$873[1][1] = a;
		            return cont(res);
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$230 = [0, a2B, 0, descriptor$46, 0];
		               function chunk_to_string(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var event = param[1]; return cont(event[9][11]);
		                  case 1:
		                   var event$0 = param[1]; return cont(event$0[7][10]);
		                  case 6:
		                   var task = param[1]; return cont(task[7][9][2]);
		                  case 7:
		                   var task$0 = param[1]; return cont(task$0[5][3][2]);
		                  case 8:
		                   return cont(cst$1);
		                  case 4:
		                  case 5:
		                   var title = param[2]; return cont(title);
		                  default: var highlight = param[1]; return cont(highlight);
		                }
		               }
		               function make$135(b, link, a, opt, message, cont){
		                var id = b ? b[1] : [1, nanoid()];
		                if(a)
		                 var time = a[1];
		                else
		                 var t = ocaml_ptime_clock_now_d_ps(), time = t;
		                var type = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call
		                        (elements_of_list,
		                         message,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   a,
		                                   chunk_to_string,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (concat$0,
		     0,
		     a,
		     function(a){
		      return cont([0, id, link, message, a, time, type]);
		     });
		                                   });
		                         });
		               }
		               var bOQ = [];
		               function authentication_schema_versione$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOQ[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2I, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOQ[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOQ[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bOQ[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 "device_token",
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "referral_id",
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (Device[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    referral_id = b[2][1],
		    device_token = b[1],
		    device_id = a[1],
		    new_user = param[1];
		   return cont
		           ([0, new_user, device_id, device_token, referral_id]);
		  },
		  function(param, cont){
		   var
		    referral_id = param[4],
		    device_token = param[3],
		    device_id = param[2],
		    new_user = param[1];
		   return cont
		           ([0,
		             new_user,
		             [0, device_id, [0, device_token, [0, referral_id, 0]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, "new_user", 0, 2, [0, bool_schema], 0, 0],
		   [0, [0, 0, 0, 0, 0, cst_device_id, 0, 2, [0, b], 0, 0], a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOQ[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOQ[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOR = [];
		               function intention_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOR[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2J, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOR[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOR[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOR[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                a2M,
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(typeof param !== "number" && 0 === param[0]){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   }
		                                   return cont(0);
		                                  },
		                                  1,
		                                  0,
		                                  "add_account",
		                                  "Add_account",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var token = param[2][1], claimed = param[1];
		                                     return cont([0, claimed, token]);
		                                    },
		                                    function(param, cont){
		                                     var token = param[2], claimed = param[1];
		                                     return cont([0, claimed, [0, token, 0]]);
		                                    },
		                                    [0,
		                                     [0, 0, 0, 0, 0, "claimed", 0, 2, [0, bool_schema], 0, 0],
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_token,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([1, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   "join_organization",
		                                   "Join_organization",
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var token = param[1];
		                                      return cont(token);
		                                     },
		                                     function(token, cont){return cont([0, token, 0]);},
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_invitation_token,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      0]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && ! param) return cont(a2L);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_login,
		                                    "Login",
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(1);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && param) return cont(a2K);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     "grant_scopes",
		                                     "Grant_scopes",
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    0]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOR[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOR[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$874 = [];
		               function login_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$874[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2N, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$874[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$874[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$874[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (intention_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, "current_url", 0, 3, [0, schema$262], 0, 0],
		  [0, [0, 0, 0, 0, 0, cst_intention, 0, 2, [1, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (authentication_schema_versione$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              intention = a[2][1],
		              current_url = a[1],
		              authentication = param[1];
		             return cont([0, authentication, current_url, intention]);
		            },
		            function(param, cont){
		             var
		              intention = param[3],
		              current_url = param[2],
		              authentication = param[1];
		             return cont
		                     ([0, authentication, [0, current_url, [0, intention, 0]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_authentication, 0, 3, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$874[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$874[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$830 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOQ, [0, schematic_cache$830]);
		               var schematic_cache$831 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOR, [0, schematic_cache$831]);
		               var schematic_cache$832 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$874, [0, schematic_cache$832]);
		               caml_callback
		                (authentication_schema_versione$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (intention_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (login_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_From_scratch = "From_scratch",
		                cst_Migrating_account = "Migrating_account",
		                bOT = [];
		               function login_progress_step_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOT[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2O, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOT[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOT[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOT[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a2S);},
		                                  0,
		                                  0,
		                                  cst_from_scratch,
		                                  cst_From_scratch,
		                                  [0, a4[1], a2R, a4[3], a4[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(a2Q) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_migrating_account,
		                                   cst_Migrating_account,
		                                   [0, a3[1], a2P, a3[3], a3[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOT[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOT[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_Sign_in = "Sign_in",
		                cst_Upgrade_required = "Upgrade_required",
		                cst_accountCreated = "accountCreated",
		                cst_progress = "progress",
		                cst_sign_in = "sign_in",
		                cst_upgrade_required = "upgrade_required",
		                letrec_function_context$875 = [];
		               function login_status_detail_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$875[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2T, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$875[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$875[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$875[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, a2U, 0, 0, 0, cst_version, 0, 2, [0, schema$261], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (environment_schema_versioned$0,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){return cont(0);},
		   function(param, cont){
		    return typeof param === "number" ? cont(a2W) : cont(0);
		   },
		   0,
		   0,
		   cst_offline,
		   cst_Offline,
		   [0,
		    0,
		    a2V,
		    [7,
		     function(param, cont){return cont(0);},
		     function(param, cont){return cont(0);},
		     0],
		    0],
		   0],
		  [0,
		   [0,
		    function(f0, cont){return cont([2, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    1,
		    0,
		    cst_sign_in,
		    cst_Sign_in,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){var url = param[1]; return cont(url);},
		      function(url, cont){return cont([0, url, 0]);},
		      [0,
		       [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$262], 0, 0],
		       0]],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([3, f0]);},
		     function(param, cont){
		      if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		      return cont(0);
		     },
		     1,
		     0,
		     cst_success,
		     cst_Success,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var account_created = param[1];
		        return cont(account_created);
		       },
		       function(account_created, cont){
		        return cont([0, account_created, 0]);
		       },
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_accountCreated,
		         0,
		         2,
		         [0, bool_schema],
		         0,
		         0],
		        0]],
		      0],
		     0],
		    [0,
		     [0,
		      function(param, cont){
		       var f1 = param[2], f0 = param[1];
		       return cont([4, f0, f1]);
		      },
		      function(param, cont){
		       if(typeof param !== "number" && 4 === param[0]){
		        var f1 = param[2], f0 = param[1];
		        return cont([0, [0, f0, f1]]);
		       }
		       return cont(0);
		      },
		      1,
		      0,
		      cst_upgrade_required,
		      cst_Upgrade_required,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var version = param[2][1], channel = param[1];
		         return cont([0, channel, version]);
		        },
		        function(param, cont){
		         var version = param[2], channel = param[1];
		         return cont([0, channel, [0, version, 0]]);
		        },
		        [0, [0, 0, 0, 0, 0, cst_channel, 0, 2, [0, c], 0, 0], a]],
		       0],
		      0],
		     0]]]];
		                                      return caml_exact_trampoline_cps_call
		      (login_progress_step_schema_ver,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      a2X,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        1,
		                        0,
		                        cst_failure,
		                        cst_Failure,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var error = param[1];
		                           return cont(error);
		                          },
		                          function(error, cont){return cont([0, error, 0]);},
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_error,
		                            0,
		                            2,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           0]],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){
		                          var f1 = param[2], f0 = param[1];
		                          return cont([1, f0, f1]);
		                         },
		                         function(param, cont){
		                          if(typeof param !== "number" && 1 === param[0]){
		                           var f1 = param[2], f0 = param[1];
		                           return cont([0, [0, f0, f1]]);
		                          }
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_in_progress,
		                         cst_In_progress,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var step = param[2][1], progress = param[1];
		                            return cont([0, progress, step]);
		                           },
		                           function(param, cont){
		                            var step = param[2], progress = param[1];
		                            return cont([0, progress, [0, step, 0]]);
		                           },
		                           [0,
		                            [0, 0, 0, 0, 0, cst_progress, 0, 3, [0, float_schema], 0, 0],
		                            [0, [0, 0, 0, 0, 0, cst_step, 0, 2, [0, a], 0, 0], 0]]],
		                          0],
		                         0],
		                        b]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$875[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$875[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$833 = [0, empty$11([0, comparator$9])],
		                bOS = [];
		               caml_update_dummy(bOS, [0, schematic_cache$833]);
		               var schematic_cache$834 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOT, [0, schematic_cache$834]);
		               var schematic_cache$835 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$875, [0, schematic_cache$835]);
		               function schematic_version$122(param, cont){return cont(0);}
		               var schematic_schema_version$69 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [bOS[1][1], schematic_schema_version$69]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             bOS[1][1],
		                             schematic_schema_version$69,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		bOS[1][1],
		schematic_schema_version$69,
		schematic_self,
		function(a){
		 bOS[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (login_status_detail_schema_ver,
		          schematic_version$122,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [1, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (option_schema,
		                    bool_schema,
		                    function(b){
		                     var
		                      res =
		                        [7,
		                         function(param, cont){
		                          var status = param[2][1], success = param[1];
		                          return cont([0, success, status]);
		                         },
		                         function(param, cont){
		                          var status = param[2], success = param[1];
		                          return cont([0, success, [0, status, 0]]);
		                         },
		                         [0, [0, 0, 0, 0, 0, cst_login, 0, 2, [0, b], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call$0
		                             (set$3,
		                              bOS[1][1],
		                              schematic_schema_version$69,
		                              res,
		                              function(a){bOS[1][1] = a; return cont(res);});
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (login_progress_step_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (login_status_detail_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var bOV = [];
		               function login_progress_step_schema_ver$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOV[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a2Z, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOV[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOV[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOV[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a23);},
		                                  0,
		                                  0,
		                                  cst_from_scratch,
		                                  cst_From_scratch,
		                                  [0, a6[1], a22, a6[3], a6[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(a21) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_migrating_account,
		                                   cst_Migrating_account,
		                                   [0, a5[1], a20, a5[3], a5[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     bOV[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){bOV[1][1] = a; return cont(res);});
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$876 = [];
		               function login_status_detail_schema_ver$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$876[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a24, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$876[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$876[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$876[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, a25, 0, 0, 0, cst_version, 0, 2, [0, schema$261], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (environment_schema_versioned$0,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(param, cont){return cont(0);},
		   function(param, cont){
		    return typeof param === "number" ? cont(a27) : cont(0);
		   },
		   0,
		   0,
		   cst_offline,
		   cst_Offline,
		   [0,
		    0,
		    a26,
		    [7,
		     function(param, cont){return cont(0);},
		     function(param, cont){return cont(0);},
		     0],
		    0],
		   0],
		  [0,
		   [0,
		    function(f0, cont){return cont([2, f0]);},
		    function(param, cont){
		     if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		     return cont(0);
		    },
		    1,
		    0,
		    cst_sign_in,
		    cst_Sign_in,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){var url = param[1]; return cont(url);},
		      function(url, cont){return cont([0, url, 0]);},
		      [0,
		       [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$262], 0, 0],
		       0]],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([3, f0]);},
		     function(param, cont){
		      if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		      return cont(0);
		     },
		     1,
		     0,
		     cst_success,
		     cst_Success,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var account_created = param[1];
		        return cont(account_created);
		       },
		       function(account_created, cont){
		        return cont([0, account_created, 0]);
		       },
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_accountCreated,
		         0,
		         2,
		         [0, bool_schema],
		         0,
		         0],
		        0]],
		      0],
		     0],
		    [0,
		     [0,
		      function(param, cont){
		       var f1 = param[2], f0 = param[1];
		       return cont([4, f0, f1]);
		      },
		      function(param, cont){
		       if(typeof param !== "number" && 4 === param[0]){
		        var f1 = param[2], f0 = param[1];
		        return cont([0, [0, f0, f1]]);
		       }
		       return cont(0);
		      },
		      1,
		      0,
		      cst_upgrade_required,
		      cst_Upgrade_required,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var version = param[2][1], channel = param[1];
		         return cont([0, channel, version]);
		        },
		        function(param, cont){
		         var version = param[2], channel = param[1];
		         return cont([0, channel, [0, version, 0]]);
		        },
		        [0, [0, 0, 0, 0, 0, cst_channel, 0, 2, [0, c], 0, 0], a]],
		       0],
		      0],
		     0]]]];
		                                      return caml_exact_trampoline_cps_call
		      (login_progress_step_schema_ver$0,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(a){
		                  var
		                   res =
		                     [11,
		                      a28,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        1,
		                        0,
		                        cst_failure,
		                        cst_Failure,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var error = param[1];
		                           return cont(error);
		                          },
		                          function(error, cont){return cont([0, error, 0]);},
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_error,
		                            0,
		                            2,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           0]],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){
		                          var f1 = param[2], f0 = param[1];
		                          return cont([1, f0, f1]);
		                         },
		                         function(param, cont){
		                          if(typeof param !== "number" && 1 === param[0]){
		                           var f1 = param[2], f0 = param[1];
		                           return cont([0, [0, f0, f1]]);
		                          }
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_in_progress,
		                         cst_In_progress,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var step = param[2][1], progress = param[1];
		                            return cont([0, progress, step]);
		                           },
		                           function(param, cont){
		                            var step = param[2], progress = param[1];
		                            return cont([0, progress, [0, step, 0]]);
		                           },
		                           [0,
		                            [0, 0, 0, 0, 0, cst_progress, 0, 3, [0, float_schema], 0, 0],
		                            [0, [0, 0, 0, 0, 0, cst_step, 0, 2, [0, a], 0, 0], 0]]],
		                          0],
		                         0],
		                        b]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$876[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$876[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$836 = [0, empty$11([0, comparator$9])],
		                bOU = [];
		               caml_update_dummy(bOU, [0, schematic_cache$836]);
		               var schematic_cache$837 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOV, [0, schematic_cache$837]);
		               var schematic_cache$838 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$876, [0, schematic_cache$838]);
		               function schematic_version$123(param, cont){return cont(0);}
		               var
		                schematic_schema_version$68 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [bOU[1][1], schematic_schema_version$68]);
		               if(e)
		                var schema$231 = e[1], descriptor$47 = schema$231;
		               else
		                descriptor$47 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              bOU[1][1],
		                              schematic_schema_version$68,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 bOU[1][1],
		 schematic_schema_version$68,
		 schematic_self,
		 function(a){
		  bOU[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (login_status_detail_schema_ver$0,
		           schematic_version$123,
		           function(b){
		            var
		             a = [0, [0, 0, 0, 0, 0, cst_status, 0, 2, [1, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (option_schema,
		                     bool_schema,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var status = param[2][1], success = param[1];
		                           return cont([0, success, status]);
		                          },
		                          function(param, cont){
		                           var status = param[2], success = param[1];
		                           return cont([0, success, [0, status, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_login, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               bOU[1][1],
		                               schematic_schema_version$68,
		                               res,
		                               function(a){bOU[1][1] = a; return cont(res);});
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var login_status_schema = [0, a2Y, 0, descriptor$47, 0];
		               caml_callback
		                (login_progress_step_schema_ver$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (login_status_detail_schema_ver$0,
		                 [function(param, cont){return cont(0);}]);
		               var bPS = [];
		               function equal_profile(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPS[2],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                          return c
		                                  ? caml_trampoline_cps_call3(bPS[1], lhs[3], rhs[3], cont)
		                                  : cont(c);
		                         });
		               }
		               var bQD = [];
		               function equal_profile_kind(lhs, rhs, cont){
		                if(lhs){
		                 if(rhs){
		                  var rhs0 = rhs[1], lhs0 = lhs[1];
		                  return caml_trampoline_cps_call3(bQD[1], lhs0, rhs0, cont);
		                 }
		                }
		                else if(! rhs) return cont(1);
		                return cont(0);
		               }
		               var letrec_function_context$877 = [];
		               function equal_profile_google(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function c(d){
		                 function c(b){
		                  function a(b){
		                   function a(b){
		                    function a(a){
		                     return a
		                             ? caml_trampoline_cps_call3
		                               (letrec_function_context$877[1], lhs[6], rhs[6], cont)
		                             : cont(a);
		                    }
		                    return b
		                            ? caml_trampoline_cps_call3
		                              (letrec_function_context$877[2], lhs[5], rhs[5], a)
		                            : a(b);
		                   }
		                   return b
		                           ? caml_trampoline_cps_call3
		                             (letrec_function_context$877[3], lhs[4], rhs[4], a)
		                           : a(b);
		                  }
		                  return b
		                          ? caml_trampoline_cps_call3
		                            (letrec_function_context$877[4], lhs[3], rhs[3], a)
		                          : a(b);
		                 }
		                 if(! d) return c(d);
		                 var y = rhs[2], x = lhs[2];
		                 if(x){
		                  if(y){
		                   var b = y[1], a = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$877[5], a, b, c);
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                if(x){
		                 if(y){
		                  var b = y[1], a = x[1];
		                  return caml_trampoline_cps_call3
		                          (letrec_function_context$877[6], a, b, c);
		                 }
		                }
		                else if(! y) return c(1);
		                return c(0);
		               }
		               caml_update_dummy(bPS, [0, equal_profile_kind, equal$112]);
		               caml_update_dummy(bQD, [0, equal_profile_google]);
		               caml_update_dummy
		                (letrec_function_context$877,
		                 [0,
		                  equal_userinfo,
		                  equal$253,
		                  equal$58,
		                  equal$253,
		                  equal$109,
		                  equal$109]);
		               var bOW = [];
		               function profile_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOW[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a29, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOW[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOW[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOW[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (profile_kind_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    kind = a[2][1],
		    main = a[1],
		    email = param[1];
		   return cont([0, email, main, kind]);
		  },
		  function(param, cont){
		   var kind = param[3], main = param[2], email = param[1];
		   return cont([0, email, [0, main, [0, kind, 0]]]);
		  },
		  [0,
		   [0, a2$, 0, 0, 0, cst_email, 0, 2, [0, schema$72], 0, 0],
		   [0,
		    [0, a2_, 0, 0, 0, cst_main, 0, 2, [0, bool_schema], 0, 0],
		    [0, [0, 0, 0, 0, 0, cst_kind, 0, 2, [0, a], 0, 0], 0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOW[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOW[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var bOX = [];
		               function profile_kind_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOX[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a3a, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOX[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOX[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOX[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (profile_google_schema_versione,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  a3c,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){return param ? cont(0) : cont(a3b);},
		    0,
		    0,
		    cst_email,
		    cst_Email,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(! param) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     cst_google,
		     cst_Google,
		     a,
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOX[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOX[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$878 = [];
		               function profile_google_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$878[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a3d, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$878[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$878[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$878[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (userinfo_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, a3e, 0, 0, 0, cst_userinfo, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$534,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, a3f, 0, 0, 0, cst_scopes, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$116,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0, [0, a3g, 0, 0, 0, cst_identity, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$534,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0, a3h, 0, 0, 0, "granted_scopes", 0, 2, [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$189,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0, a3i, 0, 0, 0, cst_contacts_state$0, 0, 3, [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$189,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              userinfo = d[2][1],
		              scopes = d[1],
		              identity = c[1],
		              granted_scopes = b[1],
		              contacts_state = a[1],
		              calendars_state = param[1];
		             return cont
		                     ([0,
		                       calendars_state,
		                       contacts_state,
		                       granted_scopes,
		                       identity,
		                       scopes,
		                       userinfo]);
		            },
		            function(param, cont){
		             var
		              userinfo = param[6],
		              scopes = param[5],
		              identity = param[4],
		              granted_scopes = param[3],
		              contacts_state = param[2],
		              calendars_state = param[1];
		             return cont
		                     ([0,
		                       calendars_state,
		                       [0,
		                        contacts_state,
		                        [0,
		                         granted_scopes,
		                         [0, identity, [0, scopes, [0, userinfo, 0]]]]]]);
		            },
		            [0,
		             [0, a3j, 0, 0, 0, cst_calendars_state$0, 0, 3, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$878[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$878[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$839 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOW, [0, schematic_cache$839]);
		               var schematic_cache$840 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOX, [0, schematic_cache$840]);
		               var schematic_cache$841 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$878, [0, schematic_cache$841]);
		               var
		                profile_schema =
		                  caml_callback
		                   (profile_schema_versioned,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback
		                (profile_kind_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (profile_google_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$879 = [];
		               function missing_scope_info_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$879[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a3k, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$879[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$879[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$879[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$534,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var missing_scopes = param[2][1], grant_uri = param[1];
		   return cont([0, grant_uri, missing_scopes]);
		  },
		  function(param, cont){
		   var missing_scopes = param[2], grant_uri = param[1];
		   return cont([0, grant_uri, [0, missing_scopes, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, "grant_uri", 0, 2, [0, schema$262], 0, 0],
		   [0,
		    [0, 0, 0, 0, 0, "missing_scopes", 0, 2, [0, a], 0, 0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$879[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$879[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$842 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$879, [0, schematic_cache$842]);
		               caml_callback
		                (missing_scope_info_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback(M$2, [[0, comparator$2, schema_versioned$180]]);
		               var letrec_function_context$880 = [];
		               function schema_versioned$537(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$880[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a3m, a3l, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$880[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$880[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$880[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$282,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([12, f0]);},
		   function(param, cont){
		    if(12 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_automation_run,
		   cst_Automation_run,
		   b,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$261,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([11, f0]);},
		             function(param, cont){
		              if(11 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_conversation,
		             cst_Conversation,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$271,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([10, f0]);},
		                       function(param, cont){
		                        if(10 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_automation,
		                       cst_Automation,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$262,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([9, f0]);},
		                                 function(param, cont){
		                                  if(9 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_agent,
		                                 cst_Agent,
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (full_workspace_schema_versione,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([8, f0]);},
		   function(param, cont){
		    if(8 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_workspace,
		   cst_Workspace,
		   c,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$188,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([7, f0]);},
		             function(param, cont){
		              if(7 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_task_recurrent,
		             cst_Task_recurrent,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$186,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([6, f0]);},
		                       function(param, cont){
		                        if(6 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_task,
		                       cst_Task,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$501,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([5, f0]);},
		                                 function(param, cont){
		                                  if(5 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_table_ref,
		                                 cst_Table_ref,
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$341,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(4 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_people,
		   cst_People,
		   c,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$347,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(3 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_page,
		             cst_Page,
		             c,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$163,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_object,
		                       cst_Object,
		                       c,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$239,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_event_recurrent,
		                                 cst_Event_recurrent,
		                                 c,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$230,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_event,
		    cst_Event,
		    a,
		    0],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$880[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$880[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$843 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$880, [0, schematic_cache$843]);
		               caml_callback
		                (schema_versioned$537,
		                 [function(param, cont){return cont(0);}]);
		               var bPT = [];
		               function equal_elem(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (bPT[2],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(! c) return cont(c);
		                          var y = rhs[2], x = lhs[2];
		                          if(x){
		                           if(y){
		                            var b = y[1], a = x[1];
		                            return caml_trampoline_cps_call3(bPT[1], a, b, cont);
		                           }
		                          }
		                          else if(! y) return cont(1);
		                          return cont(0);
		                         });
		               }
		               var letrec_function_context$881 = [];
		               function equal$254(lhs, rhs, cont){
		                var y = rhs[1], x = lhs[1];
		                function a(x, y){
		                 function c(b){
		                  if(! b) return cont(b);
		                  var y = rhs[2], x = lhs[2];
		                  function a(x, y){
		                   if(x){
		                    if(y){
		                     var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$881[1],
		                              a$0,
		                              b,
		                              function(b){
		                               return b
		                                       ? caml_exact_trampoline_call2(a, x$0, y$0)
		                                       : cont(b);
		                              });
		                    }
		                   }
		                   else if(! y) return cont(1);
		                   return cont(0);
		                  }
		                  return a(x, y);
		                 }
		                 if(x){
		                  if(y){
		                   var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$881[2],
		                            a$0,
		                            b,
		                            function(b){
		                             return b ? caml_exact_trampoline_call2(a, x$0, y$0) : c(b);
		                            });
		                  }
		                 }
		                 else if(! y) return c(1);
		                 return c(0);
		                }
		                return a(x, y);
		               }
		               caml_update_dummy(bPT, [0, equal$104, equal$69]);
		               caml_update_dummy
		                (letrec_function_context$881, [0, equal_elem, equal$51]);
		               var bOY = [];
		               function elem_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOY[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a3n, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOY[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOY[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bOY[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_parent,
		                                 0,
		                                 3,
		                                 [0, schema_versioned$182()],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$131,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var parent = param[2][1], id = param[1];
		   return cont([0, id, parent]);
		  },
		  function(param, cont){
		   var parent = param[2], id = param[1];
		   return cont([0, id, [0, parent, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOY[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOY[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$844 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOY, [0, schematic_cache$844]);
		               var
		                schematic_cache$845 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$882 = [];
		               caml_update_dummy
		                (letrec_function_context$882, [0, schematic_cache$845]);
		               caml_callback
		                (elem_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function schematic_version$124(param, cont){return cont(0);}
		               var
		                schematic_schema_version$67 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$882[1][1],
		                     schematic_schema_version$67]);
		               if(e)
		                var schema$232 = e[1], descriptor$48 = schema$232;
		               else
		                descriptor$48 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$882[1][1],
		                              schematic_schema_version$67,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$882[1][1],
		 schematic_schema_version$67,
		 schematic_self,
		 function(a){
		  letrec_function_context$882[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (elem_schema_versioned$0,
		           schematic_version$124,
		           function(a){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var past = param[2][1], future = param[1];
		                 return cont([0, future, past]);
		                },
		                function(param, cont){
		                 var past = param[2], future = param[1];
		                 return cont([0, future, [0, past, 0]]);
		                },
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  "future",
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, schema$263], 0]],
		                  0,
		                  0],
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   "past",
		                   0,
		                   2,
		                   [0, [0, 0, 0, [3, a], 0]],
		                   0,
		                   0],
		                  0]]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$882[1][1],
		                     schematic_schema_version$67,
		                     res,
		                     function(a){
		                      letrec_function_context$882[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$233 = [0, a3o, 0, descriptor$48, 0];
		               function append$6(left, right, cont){
		                var a = symbol(left[2], right[2]);
		                return cont([0, symbol(left[1], right[1]), a]);
		               }
		               var
		                schematic_cache$846 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$883 = [];
		               caml_update_dummy
		                (letrec_function_context$883, [0, schematic_cache$846]);
		               function schematic_version$125(param, cont){return cont(0);}
		               var
		                schematic_schema_version$66 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$883[1][1],
		                     schematic_schema_version$66]),
		                cst_overdue = "overdue",
		                cst_unplanned = "unplanned";
		               if(e)
		                var schema$234 = e[1], descriptor$49 = schema$234;
		               else
		                descriptor$49 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$883[1][1],
		                              schematic_schema_version$66,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$883[1][1],
		 schematic_schema_version$66,
		 schematic_self,
		 function(a){
		  letrec_function_context$883[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$129,
		           schematic_version$125,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 a3q,
		                 0,
		                 0,
		                 0,
		                 cst_upcoming,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, b], 0]],
		                 0,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$129,
		                     schematic_version$125,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           a3r,
		                           0,
		                           0,
		                           0,
		                           cst_unplanned,
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, c], 0]],
		                           0,
		                           0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$129,
		                               schematic_version$125,
		                               function(c){
		                                var
		                                 a =
		                                   [0,
		                                    [0,
		                                     a3s,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_overdue,
		                                     0,
		                                     2,
		                                     [0, [0, 0, 0, [3, c], 0]],
		                                     0,
		                                     0],
		                                    b];
		                                return caml_exact_trampoline_cps_call
		(schema_versioned$129,
		 schematic_version$125,
		 function(c){
		  var
		   b =
		     [0,
		      [0,
		       a3t,
		       0,
		       0,
		       0,
		       "allocated",
		       0,
		       2,
		       [0, [0, 0, 0, [3, c], 0]],
		       0,
		       0],
		      a];
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$129,
		           schematic_version$125,
		           function(c){
		            var
		             a =
		               [0,
		                [0,
		                 a3u,
		                 0,
		                 0,
		                 0,
		                 cst_current,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, c], 0]],
		                 0,
		                 0],
		                b];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$129,
		                     schematic_version$125,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           a3v,
		                           0,
		                           0,
		                           0,
		                           cst_completed,
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, c], 0]],
		                           0,
		                           0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$129,
		                               schematic_version$125,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      b = a[2],
		                                      c = b[2],
		                                      d = c[2],
		                                      e = d[2],
		                                      upcoming = e[2][1],
		                                      unplanned = e[1],
		                                      overdue = d[1],
		                                      allocated = c[1],
		                                      current = b[1],
		                                      completed = a[1],
		                                      archived = param[1];
		                                     return cont
		     ([0,
		       archived,
		       completed,
		       current,
		       allocated,
		       overdue,
		       unplanned,
		       upcoming]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      upcoming = param[7],
		                                      unplanned = param[6],
		                                      overdue = param[5],
		                                      allocated = param[4],
		                                      current = param[3],
		                                      completed = param[2],
		                                      archived = param[1];
		                                     return cont
		     ([0,
		       archived,
		       [0,
		        completed,
		        [0,
		         current,
		         [0,
		          allocated,
		          [0, overdue, [0, unplanned, [0, upcoming, 0]]]]]]]);
		                                    },
		                                    [0,
		                                     [0,
		                                      a3w,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_ignored,
		                                      0,
		                                      2,
		                                      [0, [0, 0, 0, [3, a], 0]],
		                                      0,
		                                      0],
		                                     b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$883[1][1],
		 schematic_schema_version$66,
		 res,
		 function(a){
		  letrec_function_context$883[1][1] = a;
		  return cont(res);
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$235 = [0, a3p, 0, descriptor$49, 0],
		                schematic_cache$847 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$884 = [];
		               caml_update_dummy
		                (letrec_function_context$884, [0, schematic_cache$847]);
		               function schematic_version$126(param, cont){return cont(0);}
		               var
		                schematic_schema_version$65 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$884[1][1],
		                     schematic_schema_version$65]);
		               if(e)
		                var schema$236 = e[1], descriptor$50 = schema$236;
		               else
		                descriptor$50 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$884[1][1],
		                              schematic_schema_version$65,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$884[1][1],
		 schematic_schema_version$65,
		 schematic_self,
		 function(a){
		  letrec_function_context$884[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$129,
		           schematic_version$126,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 a3z,
		                 0,
		                 0,
		                 0,
		                 cst_unplanned,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, b], 0]],
		                 0,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$129,
		                     schematic_version$126,
		                     function(c){
		                      var
		                       b =
		                         [0,
		                          [0,
		                           a3A,
		                           0,
		                           0,
		                           0,
		                           cst_upcoming,
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, c], 0]],
		                           0,
		                           0],
		                          a];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$129,
		                               schematic_version$126,
		                               function(c){
		                                var
		                                 a =
		                                   [0,
		                                    [0,
		                                     a3B,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_overdue,
		                                     0,
		                                     2,
		                                     [0, [0, 0, 0, [3, c], 0]],
		                                     0,
		                                     0],
		                                    b];
		                                return caml_exact_trampoline_cps_call
		(schema_versioned$129,
		 schematic_version$126,
		 function(c){
		  var
		   b =
		     [0,
		      [0,
		       a3C,
		       0,
		       0,
		       0,
		       "postponed",
		       0,
		       2,
		       [0, [0, 0, 0, [3, c], 0]],
		       0,
		       0],
		      a];
		  return caml_exact_trampoline_cps_call
		          (day_schema_versioned,
		           schematic_version$126,
		           function(a){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var
		                  a = param[2],
		                  b = a[2],
		                  c = b[2],
		                  unplanned = c[2][1],
		                  upcoming = c[1],
		                  overdue = b[1],
		                  postponed = a[1],
		                  scheduled = param[1];
		                 return cont
		                         ([0, scheduled, postponed, overdue, upcoming, unplanned]);
		                },
		                function(param, cont){
		                 var
		                  unplanned = param[5],
		                  upcoming = param[4],
		                  overdue = param[3],
		                  postponed = param[2],
		                  scheduled = param[1];
		                 return cont
		                         ([0,
		                           scheduled,
		                           [0,
		                            postponed,
		                            [0, overdue, [0, upcoming, [0, unplanned, 0]]]]]);
		                },
		                [0,
		                 [0,
		                  a3D,
		                  0,
		                  0,
		                  0,
		                  cst_scheduled,
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, a], 0]],
		                  0,
		                  0],
		                 b]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$884[1][1],
		                     schematic_schema_version$65,
		                     res,
		                     function(a){
		                      letrec_function_context$884[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$237 = [0, a3y, a3x, descriptor$50, 0];
		               caml_callback
		                (init$7, [7, function(param, cont){return cont(a3E);}]);
		               function append$7(left, right, cont){
		                var
		                 a = symbol(left[5], right[5]),
		                 b = symbol(left[4], right[4]),
		                 c = symbol(left[3], right[3]),
		                 d = symbol(left[2], right[2]);
		                return caml_exact_trampoline_cps_call$0
		                        (map2_exn,
		                         left[1],
		                         right[1],
		                         function(l, r, cont){
		                          var a = symbol(l[2], r[2]);
		                          return cont([0, symbol(l[1], r[1]), a]);
		                         },
		                         function(e){return cont([0, e, d, c, b, a]);});
		               }
		               var duration_default = minutes(30);
		               minutes(15);
		               var
		                version$1 = caml_callback(trim, [b$]),
		                e = caml_callback(make_version, [version$1, b4, dummy]),
		                version$2 = e[2],
		                dev$0 = e[1];
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var
		                Http_client =
		                  [0, [0, , , , , , , , , catch$0, pp_error$2], , call$2],
		                e = Cohttp(Http_client, String$0),
		                v$2 = of_int_s(120),
		                Handler = With_timeout([0, v$2], e);
		               function with_tag(Log, def, value$0){
		                function add_tag(tags, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (add$7, def, value$0, value(tags, empty$12), cont);
		                }
		                function wrap(log, m, cont){
		                 return caml_exact_trampoline_cps_call
		                         (log,
		                          function(header, tags, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (add_tag,
		                                    tags,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(m, header, [0, a], cont);
		                                    });
		                          },
		                          cont);
		                }
		                function msg(level, log, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (Log[1],
		                          level,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1(wrap, log, a, cont);
		                          },
		                          cont);
		                }
		                function err(log, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 1, log, cont);
		                }
		                function warn(log, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 2, log, cont);
		                }
		                function info(log, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 3, log, cont);
		                }
		                function debug(log, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 4, log, cont);
		                }
		                return [0, , , err, warn, info, debug];
		               }
		               ocaml_mtime_clock_elapsed_ns();
		               function is_tchar(a, cont){
		                a:
		                {
		                 b:
		                 {
		                  if(97 <= a){
		                   a = a - 124 | 0;
		                   if(2 >= a >>> 0){if(1 === a) break a; break b;}
		                   if(-1 <= a) break a;
		                  }
		                  else
		                   if(65 <= a){
		                    if(91 <= a){if(94 <= a) break b; break a;}
		                   }
		                   else {
		                    a = a - 33 | 0;
		                    if(24 < a >>> 0) break a;
		                    switch(a){
		                      case 1:
		                      case 7:
		                      case 8:
		                      case 11:
		                      case 14:
		                       break a;
		                      case 15:
		                      case 16:
		                      case 17:
		                      case 18:
		                      case 19:
		                      case 20:
		                      case 21:
		                      case 22:
		                      case 23:
		                      case 24: break;
		                      default: break b;
		                    }
		                   }
		                  return cont(1);
		                 }
		                 return cont(1);
		                }
		                return cont(0);
		               }
		               function is_whitespace$0(param, cont){
		                if(9 !== param && 32 !== param) return cont(0);
		                return cont(1);
		               }
		               var
		                optional_whitespace = skip_while(is_whitespace$0),
		                e =
		                  skip_while
		                   (function(y, cont){return cont(32 === y ? 1 : 0);}),
		                required_space = symbol$61(char$0(32), e),
		                token$0 = count_while1(is_tchar, substring);
		               function is_quoted_text(param, cont){
		                a:
		                {
		                 if(35 <= param){
		                  if(92 === param || 127 === param) break a;
		                 }
		                 else
		                  if(32 <= param){
		                   if(34 <= param) break a;
		                  }
		                  else if(9 !== param) break a;
		                 return cont(1);
		                }
		                return cont(0);
		               }
		               function is_quoted_pair(param, cont){
		                a:
		                {
		                 if(32 <= param){
		                  if(127 === param) break a;
		                 }
		                 else if(9 !== param) break a;
		                 return cont(1);
		                }
		                return cont(0);
		               }
		               var
		                e = satisfy(is_quoted_pair),
		                escaped_character = symbol$61(char$0(92), e),
		                unescaped_character = satisfy(is_quoted_text),
		                left = char$0(34),
		                left$0 =
		                  symbol$65
		                   (left,
		                    many
		                     (caml_callback
		                       (symbol$64, [escaped_character, unescaped_character]))),
		                quoted_string =
		                  symbol_map$3
		                   (symbol$65(left$0, char$0(34)),
		                    function(param, cont){
		                     var characters = param[1][2];
		                     return caml_exact_trampoline_cps_call
		                             (of_char_list, characters, cont);
		                    }),
		                value$10 = caml_callback(symbol$64, [quoted_string, token$0]),
		                e = char$0(61),
		                auth_param =
		                  symbol_map$3
		                   (symbol$65
		                     (symbol$62
		                       (symbol$62(symbol$62(token$0, optional_whitespace), e),
		                        optional_whitespace),
		                      value$10),
		                    function(param, cont){
		                     var value = param[2], name = param[1];
		                     return caml_exact_trampoline_cps_call
		                             (lowercase_ascii$0,
		                              name,
		                              function(a){return cont([0, a, value]);});
		                    }),
		                auth_param_separator =
		                  symbol$61
		                   (symbol$61(optional_whitespace, char$0(44)),
		                    optional_whitespace),
		                auth_params =
		                  symbol_map$3
		                   (symbol$65
		                     (auth_param,
		                      many(symbol$61(auth_param_separator, auth_param))),
		                    function(param, cont){
		                     var remaining_params = param[2], first_param = param[1];
		                     return cont([0, first_param, remaining_params]);
		                    });
		               function f$32(a, cont){
		                a:
		                {
		                 if(91 <= a){
		                  a = a - 95 | 0;
		                  if(27 < a >>> 0){
		                   if(31 !== a) break a;
		                  }
		                  else if(1 === a) break a;
		                 }
		                 else {
		                  a = a - 43 | 0;
		                  if(14 < a >>> 0){
		                   if(22 > a) break a;
		                  }
		                  else if(1 === a) break a;
		                 }
		                 return cont(1);
		                }
		                return cont(0);
		               }
		               var
		                left$2 = count_while1(f$32, substring),
		                token68 =
		                  symbol_map$3
		                   (symbol$65
		                     (left$2,
		                      take_while
		                       (function(y, cont){return cont(61 === y ? 1 : 0);})),
		                    function(param, cont){return cont(0);}),
		                credentials =
		                  symbol_map$3
		                   (symbol$65
		                     (required_space,
		                      caml_callback
		                       (symbol$64,
		                        [symbol_map$3
		                          (auth_params,
		                           function(params, cont){return cont([0, params]);}),
		                         token68])),
		                    function(param, cont){
		                     var credentials = param[2];
		                     return cont(credentials);
		                    }),
		                challenge =
		                  symbol_map$3
		                   (symbol$65
		                     (token$0,
		                      caml_callback
		                       (option$0, [0, symbol_map$3(credentials, found)])),
		                    function(a, cont){
		                     var credentials = a[2], scheme = a[1];
		                     if(! credentials)
		                      return caml_exact_trampoline_cps_call
		                              (lowercase_ascii$0,
		                               scheme,
		                               function(a){return cont([0, [0, a, 0]]);});
		                     a = credentials[1];
		                     if(! a)
		                      return caml_exact_trampoline_cps_call$1
		                              (equal$7,
		                               scheme,
		                               cst_bearer,
		                               function(a){
		                                if(a) return cont(0);
		                                return caml_exact_trampoline_cps_call
		(lowercase_ascii$0,
		 scheme,
		 function(a){return cont([0, [0, a, 0]]);});
		                               });
		                     var params$0 = a[1];
		                     a:
		                     {
		                      b:
		                      {
		                       var seen = 0, a = params$0;
		                       for(;;){
		                        if(! a) break;
		                        var params = a[2], name = a[1][1], a = seen;
		                        for(;;){
		                         if(a){
		                          var bs = a[2], b = a[1], a = name === b;
		                          if(! a){a = bs; continue;}
		                         }
		                         else
		                          a = 0;
		                         if(a) break b;
		                         var seen$0 = [0, name, seen];
		                         seen = seen$0;
		                         a = params;
		                         break;
		                        }
		                       }
		                       a = 1;
		                       break a;
		                      }
		                      a = 0;
		                     }
		                     return a
		                             ? caml_exact_trampoline_cps_call
		                               (lowercase_ascii$0,
		                                scheme,
		                                function(a){return cont([0, [0, a, params$0]]);})
		                             : cont(0);
		                    }),
		                challenge_separator =
		                  symbol$61
		                   (symbol$61(optional_whitespace, char$0(44)),
		                    optional_whitespace),
		                left$1 =
		                  symbol$65
		                   (optional_whitespace,
		                    caml_callback(option$0, [0, challenge])),
		                parser =
		                  symbol_map$3
		                   (symbol$65
		                     (symbol$65
		                       (symbol$65
		                         (left$1,
		                          many
		                           (symbol$61
		                             (challenge_separator,
		                              caml_callback(option$0, [0, challenge])))),
		                        optional_whitespace),
		                      end_of_input),
		                    function(a, cont){
		                     a = a[1][1];
		                     var remaining_challenges = a[2], first_challenge = a[1][2];
		                     return caml_exact_trampoline_cps_call$1
		                             (filter_map$0,
		                              [0, first_challenge, remaining_challenges],
		                              function(a, cont){return cont(a);},
		                              cont);
		                    });
		               function of_header(value, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         parser,
		                         value,
		                         function(match){
		                          if(0 !== match[0]) return cont(0);
		                          var challenges = match[1];
		                          return cont(challenges);
		                         });
		               }
		               function param$2(param, name, cont){
		                var params = param[2];
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         name,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (find$1, params, equal$4, a, cont);
		                         });
		               }
		               function bearer(headers, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         headers,
		                         function(param, cont){
		                          var value = param[2], name = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (equal$7,
		                                   name,
		                                   cst_www_authenticate,
		                                   function(a){return cont(some_if(a, value));});
		                         },
		                         function(b){
		                          function a(b){
		                           if(b){
		                            var l = b[2], x = b[1], scheme = x[1];
		                            if(scheme !== cst_bearer)
		                             return caml_exact_trampoline_call1(a, l);
		                            b = [0, x];
		                           }
		                           else
		                            b = 0;
		                           return caml_trampoline_cps_call3
		                                   (map$17,
		                                    b,
		                                    function(challenge, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (param$2,
		      challenge,
		      cst_scope,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (param$2,
		                challenge,
		                "resource_metadata",
		                function(b){return cont([0, b, a]);});
		      });
		                                    },
		                                    cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat_map, b, of_header, a);
		                         });
		               }
		               function invalid_url(kind, value, reason, cont){
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         a3G,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (a, value, kind, reason, function(a){return cont([1, a]);});
		                         });
		               }
		               function https_uri(kind, opt, value, cont){
		                var allow_query = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call
		                        (of_string$8,
		                         value,
		                         function(uri){
		                          var
		                           match$0 = scheme(uri),
		                           match$1 = host(uri),
		                           match = get_decoded_opt(uri[7]);
		                          return caml_exact_trampoline_cps_call
		                                  (query,
		                                   uri,
		                                   function(query){
		                                    if(! match$0)
		                                     return caml_exact_trampoline_cps_call$0
		     (invalid_url, kind, value, "it names no scheme", cont);
		                                    var scheme = match$0[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (equal$7,
		     scheme,
		     cst_https,
		     function(a){
		      if(! a)
		       return caml_exact_trampoline_cps_call
		               (sprintf,
		                a3H,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          scheme,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (invalid_url, kind, value, a, cont);
		                          });
		                });
		      if(! match$1)
		       return caml_exact_trampoline_cps_call$0
		               (invalid_url, kind, value, "it names no host", cont);
		      if(match)
		       return caml_exact_trampoline_cps_call$0
		               (invalid_url, kind, value, "it carries a fragment", cont);
		      if(! allow_query && ! is_empty(query))
		       return caml_exact_trampoline_cps_call$0
		               (invalid_url, kind, value, "it carries a query", cont);
		      return cont([0, uri]);
		     });
		                                   });
		                         });
		               }
		               function of_string$54(value, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (https_uri,
		                         "metadata URL",
		                         0,
		                         value,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$15,
		                                   a,
		                                   function(param, cont){return cont([0, value]);},
		                                   cont);
		                         });
		               }
		               function of_uri(uri, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_string$12, 0, uri, function(a){return cont([0, a]);});
		               }
		               function of_string$55(value, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (https_uri,
		                         "resource identifier",
		                         0,
		                         value,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$15,
		                                   a,
		                                   function(uri, cont){
		                                    return caml_exact_trampoline_cps_call
		    (of_string$8,
		     value,
		     function(uri$0){
		      return caml_exact_trampoline_cps_call
		              (query,
		               uri$0,
		               function(b){
		                var a = [0, b];
		                return caml_exact_trampoline_cps_call$1
		                        (path,
		                         0,
		                         uri$0,
		                         function(d){
		                          var b = uri$0[4], c = [0, d];
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   host(uri$0),
		                                   lowercase_ascii$0,
		                                   function(d){
		                                    return caml_trampoline_cps_call3
		    (map$17,
		     scheme(uri$0),
		     lowercase_ascii$0,
		     function(e){
		      return caml_exact_trampoline_cps_call$9
		              (make$3,
		               e,
		               0,
		               d,
		               b,
		               c,
		               a,
		               0,
		               dummy,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (to_string$12, 0, a, function(a){return cont([0, a, uri]);});
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   },
		                                   cont);
		                         });
		               }
		               function metadata_urls(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (path,
		                         0,
		                         t[2],
		                         function(path){
		                          var path$0 = path !== cst$34 ? path : cst$1;
		                          function at(path, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (with_path,
		                                    t[2],
		                                    "/.well-known/oauth-protected-resource" + path,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(of_uri, a, cont);
		                                    });
		                          }
		                          if(is_empty$0(path$0))
		                           return caml_exact_trampoline_cps_call
		                                   (at, cst$1, function(a){return cont([0, a, 0]);});
		                          return caml_exact_trampoline_cps_call
		                                  (at,
		                                   cst$1,
		                                   function(b){
		                                    var a = [0, b, 0];
		                                    return caml_exact_trampoline_cps_call
		    (at, path$0, function(b){return cont([0, b, a]);});
		                                   });
		                         });
		               }
		               function of_string$56(value, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (https_uri,
		                         "issuer identifier",
		                         a3I,
		                         value,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$15,
		                                   a,
		                                   function(uri, cont){return cont([0, value, uri]);},
		                                   cont);
		                         });
		               }
		               function to_string$74(t, cont){return cont(t[1]);}
		               function metadata_urls$0(t, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (path,
		                         0,
		                         t[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (rstrip,
		                                   [0, function(y, cont){return cont(47 === y ? 1 : 0);}],
		                                   a,
		                                   function(path){
		                                    function at(path, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (with_path,
		      t[2],
		      path,
		      function(a){
		       return caml_exact_trampoline_cps_call(of_uri, a, cont);
		      });
		                                    }
		                                    var
		                                     cst_well_known_oauth_authoriza =
		                                       "/.well-known/oauth-authorization-server",
		                                     cst_well_known_openid_configur =
		                                       "/.well-known/openid-configuration";
		                                    if(is_empty$0(path))
		                                     return caml_exact_trampoline_cps_call
		     (at,
		      cst_well_known_openid_configur,
		      function(b){
		       var a = [0, b, 0];
		       return caml_exact_trampoline_cps_call
		               (at,
		                cst_well_known_oauth_authoriza,
		                function(b){return cont([0, b, a]);});
		      });
		                                    return caml_exact_trampoline_cps_call
		    (at,
		     path + cst_well_known_openid_configur,
		     function(b){
		      var a = [0, b, 0];
		      return caml_exact_trampoline_cps_call
		              (at,
		               cst_well_known_openid_configur + path,
		               function(c){
		                var b = [0, c, a];
		                return caml_exact_trampoline_cps_call
		                        (at,
		                         cst_well_known_oauth_authoriza + path,
		                         function(a){return cont([0, a, b]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function of_string$57(value, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (https_uri,
		                         "endpoint URL",
		                         0,
		                         value,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$15,
		                                   a,
		                                   function(param, cont){return cont([0, value]);},
		                                   cont);
		                         });
		               }
		               function obj_field(key, param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(79 === variant){
		                  var fields = param[2];
		                  return caml_exact_trampoline_cps_call$0
		                          (find$1, fields, equal$4, key, cont);
		                 }
		                }
		                return cont(0);
		               }
		               function string_member(key, json, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (obj_field,
		                         key,
		                         json,
		                         function(a){
		                          if(! a) return cont(a3K);
		                          a = a[1];
		                          if(typeof a !== "number"){
		                           var variant = a[1];
		                           if(-976970511 === variant){
		                            var value = a[2];
		                            return cont([0, [0, value]]);
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (sprintf,
		                                   a3J,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a, key, function(a){return cont([1, a]);});
		                                   });
		                         });
		               }
		               function string_list_member(key, json, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (obj_field,
		                         key,
		                         json,
		                         function(a){
		                          if(! a) return cont(a3P);
		                          a = a[1];
		                          if(typeof a !== "number"){
		                           var variant = a[1];
		                           if(65 === variant){
		                            var values = a[2];
		                            return caml_trampoline_cps_call3
		                                    (map$18,
		                                     values,
		                                     function(param, cont){
		                                      if(typeof param !== "number"){
		                                       var variant = param[1];
		                                       if(-976970511 === variant){
		var value = param[2];
		return cont([0, value]);
		                                       }
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (sprintf,
		       a3O,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a, key, function(a){return cont([1, a]);});
		       });
		                                     },
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (all$14,
		       a,
		       function(a){
		        return caml_trampoline_cps_call3(map$15, a, found, cont);
		       });
		                                     });
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (sprintf,
		                                   a3N,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a, key, function(a){return cont([1, a]);});
		                                   });
		                         });
		               }
		               var
		                cst_not_a_JSON_object = "not a JSON object",
		                cst_not_valid_JSON = "not valid JSON";
		               function parse$1(expected_resource, body, cont){
		                function malformed(reason){
		                 return [1,
		                         "malformed protected resource metadata: " + reason];
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string$11,
		                         body,
		                         function(match){
		                          if(0 !== match[0])
		                           return cont(malformed(cst_not_valid_JSON));
		                          var json = match[1];
		                          if(typeof json !== "number"){
		                           var variant = json[1];
		                           if(79 === variant)
		                            return caml_exact_trampoline_cps_call$1
		                                    (string_member,
		                                     cst_resource,
		                                     json,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$1
		      (string_list_member,
		       cst_authorization_servers,
		       json,
		       function(match$0){
		        return caml_exact_trampoline_cps_call$1
		                (string_list_member,
		                 "scopes_supported",
		                 json,
		                 function(match$1){
		                  if(0 === match[0])
		                   if(0 === match$0[0]){
		                    if(0 === match$1[0]){
		                     var a = match[1];
		                     if(! a) return cont(malformed('no "resource"'));
		                     var declared = a[1];
		                     if(declared !== expected_resource)
		                      return caml_exact_trampoline_cps_call
		                              (sprintf,
		                               a3Q,
		                               function(a){
		                                return caml_trampoline_cps_call3
		(a,
		 declared,
		 expected_resource,
		 function(a){return cont([1, a]);});
		                               });
		                     a = match$0[1];
		                     var
		                      cst_no_authorization_servers = 'no "authorization_servers"';
		                     if(! a)
		                      return cont(malformed(cst_no_authorization_servers));
		                     var
		                      scopes_supported = match$1[1],
		                      authorization_servers = a[1];
		                     if(is_empty(authorization_servers))
		                      return cont(malformed(cst_no_authorization_servers));
		                     var
		                      open =
		                        o
		                         ([0,
		                           symbol_bind$4,
		                           symbol_map$4,
		                           Let_syntax$2,
		                           ,
		                           bind$6,
		                           of_string$14,
		                           map$15]),
		                      let$ = open[4],
		                      let$0 = open[3],
		                      b =
		                        function(authorization_servers, cont){
		                         function a(resource, cont){
		                          return cont
		                                  ([0, resource, authorization_servers, scopes_supported]);
		                         }
		                         return caml_exact_trampoline_cps_call
		                                 (of_string$55,
		                                  declared,
		                                  function(b){
		                                   return caml_trampoline_cps_call3(let$, b, a, cont);
		                                  });
		                        };
		                     return caml_trampoline_cps_call3
		                             (map$18,
		                              authorization_servers,
		                              of_string$56,
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (all$14,
		a,
		function(a){
		 return caml_trampoline_cps_call3(let$0, a, b, cont);
		});
		                              });
		                    }
		                    var reason = match$1[1];
		                   }
		                   else
		                    reason = match$0[1];
		                  else
		                   reason = match[1];
		                  return cont(malformed(reason));
		                 });
		       });
		                                     });
		                          }
		                          return cont(malformed(cst_not_a_JSON_object));
		                         });
		               }
		               function parse_endpoint(param, cont){
		                if(! param) return cont(a3R);
		                var value = param[1];
		                return caml_exact_trampoline_cps_call
		                        (of_string$57,
		                         value,
		                         function(a){
		                          return caml_trampoline_cps_call3(map$15, a, found, cont);
		                         });
		               }
		               function parse$2(expected, body, cont){
		                function malformed(reason){
		                 return [1,
		                         "malformed authorization server metadata: " + reason];
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string$11,
		                         body,
		                         function(match){
		                          if(0 !== match[0])
		                           return cont(malformed(cst_not_valid_JSON));
		                          var json = match[1];
		                          if(typeof json !== "number"){
		                           var variant = json[1];
		                           if(79 === variant)
		                            return caml_exact_trampoline_cps_call$1
		                                    (string_member,
		                                     "issuer",
		                                     json,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$1
		      (string_member,
		       "authorization_endpoint",
		       json,
		       function(match$0){
		        return caml_exact_trampoline_cps_call$1
		                (string_member,
		                 "token_endpoint",
		                 json,
		                 function(match$1){
		                  return caml_exact_trampoline_cps_call$1
		                          (string_list_member,
		                           "code_challenge_methods_supported",
		                           json,
		                           function(match$2){
		                            return caml_exact_trampoline_cps_call$1
		                                    (string_list_member,
		                                     "token_endpoint_auth_methods_supported",
		                                     json,
		                                     function(match$3){
		                                      var key = "client_id_metadata_document_supported";
		                                      return caml_exact_trampoline_cps_call$1
		      (obj_field,
		       key,
		       json,
		       function(a){
		        function b(match$4){
		         if(0 === match[0])
		          if(0 === match$0[0])
		           if(0 === match$1[0])
		            if(0 === match$2[0])
		             if(0 === match$3[0]){
		              if(0 === match$4[0]){
		               var match$5 = match[1];
		               if(! match$5) return cont(malformed('no "issuer"'));
		               var issuer = match$5[1], y = expected[1];
		               if(issuer === y){
		                var
		                 client_id_metadata_document_su = match$4[1],
		                 token_endpoint_auth_methods_su = match$3[1],
		                 code_challenge_methods_support = match$2[1],
		                 token_endpoint = match$1[1],
		                 authorization_endpoint = match$0[1],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[3],
		                 a =
		                   function(authorization_endpoint, cont){
		                    function a(token_endpoint, cont){
		                     return cont
		                             ([0,
		                               [0,
		                                expected,
		                                authorization_endpoint,
		                                token_endpoint,
		                                code_challenge_methods_support,
		                                token_endpoint_auth_methods_su,
		                                client_id_metadata_document_su]]);
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (parse_endpoint,
		                             token_endpoint,
		                             function(b){
		                              return caml_trampoline_cps_call3(let$, b, a, cont);
		                             });
		                   };
		                return caml_exact_trampoline_cps_call
		                        (parse_endpoint,
		                         authorization_endpoint,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var b = expected[1];
		               return caml_exact_trampoline_cps_call
		                       (sprintf,
		                        a3S,
		                        function(a){
		                         return caml_trampoline_cps_call3
		                                 (a, issuer, b, function(a){return cont([1, a]);});
		                        });
		              }
		              var reason = match$4[1];
		             }
		             else
		              reason = match$3[1];
		            else
		             reason = match$2[1];
		           else
		            reason = match$1[1];
		          else
		           reason = match$0[1];
		         else
		          reason = match[1];
		         return cont(malformed(reason));
		        }
		        if(! a) return b(a3M);
		        a = a[1];
		        if(typeof a !== "number"){
		         var variant = a[1];
		         if(737456202 === variant){
		          var value = a[2];
		          return b([0, [0, value]]);
		         }
		        }
		        return caml_exact_trampoline_cps_call
		                (sprintf,
		                 a3L,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (a, key, function(a){return b([1, a]);});
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                          }
		                          return cont(malformed(cst_not_a_JSON_object));
		                         });
		               }
		               function authorization_scope(challenge, metadata, cont){
		                function stated(scope, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (strip,
		                          0,
		                          scope,
		                          function(a){
		                           return is_empty$0(a) ? cont(0) : cont([0, scope]);
		                          });
		                }
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                return caml_trampoline_cps_call3
		                        (let$,
		                         challenge,
		                         function(challenge, cont){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   challenge[2],
		                                   function(scope, cont){
		                                    return caml_exact_trampoline_cps_call(stated, scope, cont);
		                                   },
		                                   cont);
		                         },
		                         function(challenged_scope){
		                          if(challenged_scope) return cont(challenged_scope);
		                          var
		                           a =
		                             g
		                               ([0,
		                                 symbol_bind$5,
		                                 symbol_map$5,
		                                 ,
		                                 bind$8,
		                                 return$9,
		                                 map$17,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$3])
		                              [3];
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   metadata[3],
		                                   function(scopes, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (concat$0,
		     a3X,
		     scopes,
		     function(a){
		      return caml_exact_trampoline_cps_call(stated, a, cont);
		     });
		                                   },
		                                   cont);
		                         });
		               }
		               function base64url(raw, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (encode_string, a3Y, [0, uri_safe_alphabet], raw, cont);
		               }
		               function authorization_url
		               (client_id, context, redirect_uri, code_challenge, state, cont){
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         context[2],
		                         function(scope, cont){return cont([0, cst_scope, scope]);},
		                         function(a){
		                          a = to_list$0(a);
		                          var t = context[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (append$0,
		                                   [0,
		                                    a3Z,
		                                    [0,
		                                     [0, cst_client_id, client_id[1]],
		                                     [0,
		                                      [0, cst_redirect_uri, redirect_uri],
		                                      [0,
		                                       [0, "code_challenge", code_challenge],
		                                       [0,
		[0, "code_challenge_method", context[3][3]],
		[0, [0, cst_state, state], [0, [0, cst_resource, t[1]], 0]]]]]]],
		                                   a,
		                                   function(ps){
		                                    var t = context[3][1];
		                                    return caml_exact_trampoline_cps_call
		    (of_string$8,
		     t[1],
		     function(uri){
		      var a = uri[7];
		      return caml_exact_trampoline_cps_call
		              (kv$0,
		               uri[6],
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (map$0,
		                         function(param, cont){
		                          var v = param[2], k = param[1];
		                          return cont([0, k, [0, v, 0]]);
		                         },
		                         ps,
		                         function(c){
		                          c = [0, symbol(c, b)];
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_string$12,
		                                   0,
		                                   [0, uri[1], uri[2], uri[3], uri[4], uri[5], c, a],
		                                   cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function single_param(query, name, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (find$1,
		                         query,
		                         equal$4,
		                         name,
		                         function(a){
		                          if(a){
		                           a = a[1];
		                           if(a){
		                            if(a[2])
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      a30,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a, name, function(a){return cont([1, a]);});
		                                      });
		                            var value = a[1];
		                            return cont([0, [0, value]]);
		                           }
		                          }
		                          return cont(a31);
		                         });
		               }
		               function authorization_response(state, query, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[3];
		                function a(returned, cont){
		                 if(! returned) return cont(a36);
		                 var returned$0 = returned[1];
		                 if(returned$0 !== state) return cont(a35);
		                 function a(error, cont){
		                  if(error){
		                   var
		                    error$0 = error[1],
		                    a =
		                      function(description, cont){
		                       return caml_exact_trampoline_cps_call
		                               (sprintf,
		                                a32,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$0
		 (value_map,
		  description,
		  cst$1,
		  a,
		  function(a){
		   return caml_exact_trampoline_cps_call
		           (sprintf,
		            a33,
		            function(b){
		             return caml_trampoline_cps_call3
		                     (b, error$0, a, function(a){return cont([1, a]);});
		            });
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (single_param,
		                            query,
		                            cst_error_description,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$, b, a, cont);
		                            });
		                  }
		                  function b(code, cont){
		                   if(! code) return cont(a34);
		                   var code$0 = code[1];
		                   return cont([0, code$0]);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (single_param,
		                           query,
		                           cst_code,
		                           function(a){
		                            return caml_trampoline_cps_call3(let$, a, b, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (single_param,
		                          query,
		                          cst_error,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (single_param,
		                         query,
		                         cst_state,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function decode_token_response(body, cont){
		                function malformed(reason){
		                 return [1, "malformed token response: " + reason];
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string$11,
		                         body,
		                         function(match){
		                          if(0 !== match[0])
		                           return cont(malformed(cst_not_valid_JSON));
		                          var json = match[1];
		                          if(typeof json !== "number"){
		                           var variant = json[1];
		                           if(79 === variant)
		                            return caml_exact_trampoline_cps_call$1
		                                    (string_member,
		                                     cst_access_token,
		                                     json,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call$1
		      (string_member,
		       cst_token_type,
		       json,
		       function(a){
		        if(0 === match[0]){
		         var b = match[1];
		         if(b){
		          var access_token = b[1];
		          if(0 === a[0]){
		           a = a[1];
		           if(! a) return cont(malformed('no "token_type"'));
		           var token_type = a[1];
		           return cont([0, [0, access_token, token_type]]);
		          }
		         }
		         if(0 === a[0]) return cont(malformed('no "access_token"'));
		         var reason = a[1];
		        }
		        else
		         reason = match[1];
		        return cont(malformed(reason));
		       });
		                                     });
		                          }
		                          return cont(malformed(cst_not_a_JSON_object));
		                         });
		               }
		               function not(f){
		                return function(x, cont){return cont(1 - f(x));};
		               }
		               function is_special_char(a){
		                a = a - 60 | 0;
		                a:
		                {
		                 if(2 < a >>> 0){
		                  if(-22 !== a) break a;
		                 }
		                 else if(1 === a) break a;
		                 return 1;
		                }
		                return 0;
		               }
		               function markup_opening_char(a){
		                a:
		                {
		                 if(92 <= a){
		                  a = a - 93 | 0;
		                  if(3 < a >>> 0){
		                   if(33 !== a) break a;
		                  }
		                  else if(1 === a) break a;
		                 }
		                 else
		                  if(41 <= a){
		                   if(47 >= a - 43 >>> 0) break a;
		                  }
		                  else if(35 !== a) break a;
		                 return 1;
		                }
		                return 0;
		               }
		               function whitespace$1(y, cont){return cont(32 === y ? 1 : 0);}
		               function alphanum(c, cont){
		                var a = 97 <= c ? 1 : 0, a = a ? c <= 122 ? 1 : 0 : a;
		                if(a)
		                 ;
		                else {a = 65 <= c ? 1 : 0; a = a ? c <= 90 ? 1 : 0 : a;}
		                if(a) return cont(a);
		                var b = 48 <= c ? 1 : 0, b = b ? c <= 57 ? 1 : 0 : b;
		                return cont(b);
		               }
		               function f$33(c, cont){
		                var a = c - 47 | 0;
		                a:
		                {
		                 if(15 < a >>> 0){
		                  a = a + 15 | 0;
		                  if(7 < a >>> 0) break a;
		                  switch(a){case 0:case 2:case 7: break;default: break a;
		                  }
		                 }
		                 else if(12 >= a - 1 >>> 0) break a;
		                 return cont(0);
		                }
		                return cont(31 < c ? 1 : 0);
		               }
		               var attr_name = count_while1(f$33, substring);
		               function tag_name(c, cont){
		                if(47 <= c){
		                 var switcher = c - 58 | 0;
		                 if(6 >= switcher >>> 0)
		                  switch(switcher){
		                    case 0:
		                     return cont(1);
		                    case 2:
		                    case 6:
		                     return cont(1);
		                  }
		                }
		                else if(45 <= c) return cont(1);
		                return caml_exact_trampoline_cps_call(alphanum, c, cont);
		               }
		               var
		                comment =
		                  symbol_bind$3
		                   (string$3("--"),
		                    function(a, cont){
		                     function f(dash, c, cont){
		                      return 2 === dash
		                              ? cont(0)
		                              : 45 === c ? cont([0, dash + 1 | 0]) : cont(a38);
		                     }
		                     var a = take_while(whitespace$1);
		                     return cont
		                             (symbol_map$3
		                               (symbol$62(scan(0, f, substring), a),
		                                function(param, cont){
		                                 var content = param[1];
		                                 return cont(content);
		                                }));
		                    }),
		                e = char$0(62),
		                b4 =
		                  symbol_map$3
		                   (many1(comment), function(c, cont){return cont([0, c]);}),
		                comment$0 = symbol$62(symbol$61(string$3("<!"), b4), e),
		                e = caml_callback(return$7, [cst$7]),
		                e = [0, symbol$61(string$3("nbsp"), e), 0],
		                b4 = caml_callback(return$7, [cst$51]),
		                e = [0, symbol$61(string$3(cst_lt), b4), e],
		                b4 = caml_callback(return$7, [cst$41]),
		                e = [0, symbol$61(string$3(cst_gt), b4), e],
		                b4 = caml_callback(return$7, [cst$5]),
		                named =
		                  caml_callback
		                   (choice, [0, [0, symbol$61(string$3("amp"), b4), e]]),
		                e = char$0(59),
		                entity =
		                  symbol$63
		                   (symbol$62
		                     (symbol$62(symbol$61(char$0(38), named), e), commit),
		                    "entity"),
		                f$34 = not(is_special_char),
		                text$2 =
		                  symbol_map$3
		                   (many1
		                     (symbol$63
		                       (symbol$62
		                         (caml_callback
		                           (symbol$64, [count_while1(f$34, substring), entity]),
		                          commit),
		                        cst_text)),
		                    function(s, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (concat$0, 0, s, function(a){return cont([2, a]);});
		                    });
		               function f$35(block, cont){
		                function string(delim){
		                 var
		                  a = char$0(delim),
		                  b =
		                    take_while
		                     (function(c, cont){return cont(c !== delim ? 1 : 0);});
		                 return symbol$62(symbol$61(char$0(delim), b), a);
		                }
		                var a = string(39);
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$64,
		                         string(34),
		                         a,
		                         function(a){
		                          var
		                           string_literal = symbol$63(a, "string-literal"),
		                           attribute =
		                             symbol$65(attr_name, symbol$61(char$0(61), string_literal));
		                          return caml_exact_trampoline_cps_call$1
		                                  (sep_by,
		                                   count_while1(whitespace$1, substring),
		                                   attribute,
		                                   function(attributes){
		                                    var
		                                     a = char$0(62),
		                                     b = symbol$61(take_while(whitespace$1), attributes),
		                                     c = count_while1(tag_name, substring),
		                                     tag =
		                                       symbol_bind$3
		(symbol$63
		  (symbol$62
		    (symbol$62(symbol$65(symbol$61(char$0(60), c), b), a),
		     commit),
		   "tag-open"),
		 function(c, cont){
		  var attributes = c[2], a = c[1];
		  a:
		  {
		   c = closing_forbidden;
		   for(;;){
		    if(! c) break;
		    var bs = c[2], b = c[1], c = a === b;
		    if(c) break a;
		    c = bs;
		   }
		   c = 0;
		  }
		  if(c)
		   return caml_exact_trampoline_cps_call
		           (return$7, [1, a, attributes, 0], cont);
		  function d(children, cont){
		   function b(param, cont){
		    return cont([1, a, attributes, children]);
		   }
		   return caml_exact_trampoline_cps_call$1
		           (kasprintf,
		            id,
		            fmt$131,
		            function(c){
		             return caml_trampoline_cps_call2
		                     (c,
		                      a,
		                      function(g){
		                       var
		                        e = char$0(62),
		                        c = string$3(a),
		                        f = char$0(47),
		                        close =
		                          symbol$63
		                           (symbol$61
		                             (symbol$61(symbol$61(symbol$61(char$0(60), f), c), e),
		                              commit),
		                            g);
		                       a:
		                       {
		                        c = closing_optional;
		                        for(;;){
		                         if(! c) break;
		                         var bs = c[2], b$0 = c[1], c = a === b$0;
		                         if(c) break a;
		                         c = bs;
		                        }
		                        c = 0;
		                       }
		                       function d(a){return cont(symbol_map$3(a, b));}
		                       return c
		                               ? caml_exact_trampoline_cps_call$1(option$0, 0, close, d)
		                               : d(close);
		                      });
		            });
		  }
		  return caml_exact_trampoline_cps_call$1
		          (kasprintf,
		           id,
		           fmt$132,
		           function(b){
		            return caml_trampoline_cps_call2
		                    (b,
		                     a,
		                     function(a){
		                      return cont(symbol_bind$3(symbol$63(block, a), d));
		                     });
		           });
		 });
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$64,
		     symbol$63(comment$0, cst_comment),
		     text$2,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$64,
		               symbol$63(a, cst_text),
		               tag,
		               function(a){return cont(many(symbol$63(a, "tag")));});
		     });
		                                   });
		                         });
		               }
		               var
		                html_parser = symbol$63(fix(f$35), "HTML"),
		                cst_alt = "alt";
		               function of_html(text, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(html, cont){
		                 function flatten_root(acc){
		                  var cst_div = "div", a = cst_alt;
		                  function flatten(acc, param, cont){
		                   function b(acc, param){
		                    if(! param)
		                     return acc === cst$1 ? cont(0) : cont([0, acc, 0]);
		                    var match = param[1];
		                    switch(match[0]){
		                      case 0:
		                       var tail = param[2];
		                       return caml_exact_trampoline_call2(b, acc, tail);
		                      case 1:
		                       var tag = match[1];
		                       if(tag === cst_br && ! match[3]){
		                        var tail$1 = param[2];
		                        return caml_exact_trampoline_cps_call$1
		                                (flatten,
		                                 cst$1,
		                                 tail$1,
		                                 function(a){return cont([0, acc, a]);});
		                       }
		                       var
		                        tail$0 = param[2],
		                        children = match[3],
		                        attributes = match[2];
		                       return caml_exact_trampoline_cps_call$0
		                               (find$1,
		                                attributes,
		                                equal$4,
		                                a,
		                                function(match){
		                                 if(! match)
		                                  return caml_exact_trampoline_cps_call$1
		  (flatten,
		   cst$1,
		   children,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (concat$0,
		             0,
		             a,
		             function(s2){
		              if(tag === cst_div)
		               return caml_exact_trampoline_cps_call$1
		                       (flatten,
		                        cst$1,
		                        tail$0,
		                        function(a){
		                         var tail = [0, s2, a];
		                         return acc === cst$1 ? cont(tail) : cont([0, acc, tail]);
		                        });
		              var acc$0 = acc + s2;
		              return caml_exact_trampoline_call2(b, acc$0, tail$0);
		             });
		   });
		                                 var alt = match[1], acc$0 = acc + alt;
		                                 return caml_exact_trampoline_call2(b, acc$0, tail$0);
		                                });
		                      default:
		                       var tail$2 = param[2], s2 = match[1], acc$0 = acc + s2;
		                       return caml_exact_trampoline_call2(b, acc$0, tail$2);
		                    }
		                   }
		                   return b(acc, param);
		                  }
		                  function append(acc, s2, tail, cont){
		                   if(! acc)
		                    return caml_exact_trampoline_cps_call
		                            (flatten_root([0, make$33(0, [8, [0, s2]])]), tail, cont);
		                   var block = acc[1], a = block[2];
		                   if(typeof a !== "number" && 8 === a[0]){
		                    var content = a[1][1];
		                    return caml_exact_trampoline_cps_call
		                            (flatten_root([0, make$33(0, [8, [0, content + s2]])]),
		                             tail,
		                             cont);
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (flatten_root([0, make$33(0, [8, [0, s2]])]),
		                            tail,
		                            function(a){return cont([0, block, a]);});
		                  }
		                  function insert(acc, b, tail, cont){
		                   if(! acc)
		                    return caml_exact_trampoline_cps_call
		                            (flatten_root(0),
		                             tail,
		                             function(a){return cont([0, b, a]);});
		                   var block = acc[1];
		                   return caml_exact_trampoline_cps_call
		                           (flatten_root(0),
		                            tail,
		                            function(a){return cont([0, block, [0, b, a]]);});
		                  }
		                  return function(param, cont){
		                   if(param){
		                    var node = param[1];
		                    switch(node[0]){
		                      case 0:
		                       var tail = param[2];
		                       return caml_exact_trampoline_cps_call
		                               (flatten_root(acc), tail, cont);
		                      case 1:
		                       var
		                        tail$0 = param[2],
		                        children = node[3],
		                        attributes = node[2],
		                        tag = node[1];
		                       return caml_exact_trampoline_cps_call$0
		                               (find$1,
		                                attributes,
		                                equal$4,
		                                a,
		                                function(match){
		                                 if(match){
		                                  var alt = match[1];
		                                  return caml_exact_trampoline_cps_call$0
		  (append, acc, alt, tail$0, cont);
		                                 }
		                                 a:
		                                 {
		                                  if(tag !== cst_br){
		                                   if(tag !== cst_div){
		                                    if(tag === cst_li$0)
		                                     return caml_exact_trampoline_cps_call$1
		     (flatten,
		      cst$1,
		      children,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (concat$0,
		                0,
		                a,
		                function(a){
		                 var bullet = make$33(0, [1, [0, 1, a, 0]]);
		                 return caml_exact_trampoline_cps_call$0
		                         (insert, acc, bullet, tail$0, cont);
		                });
		      });
		                                    if(tag !== cst_p){
		                                     if(tag !== "ul") break a;
		                                     return caml_exact_trampoline_cps_call
		     (flatten_root(0),
		      children,
		      function(items){
		       if(! acc)
		        return caml_exact_trampoline_cps_call
		                (flatten_root(0),
		                 tail$0,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (append$0, items, a, cont);
		                 });
		       var block = acc[1];
		       return caml_exact_trampoline_cps_call
		               (flatten_root(0),
		                tail$0,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (append$0, [0, block, items], a, cont);
		                });
		      });
		                                    }
		                                   }
		                                   return caml_exact_trampoline_cps_call$1
		   (flatten,
		    cst$1,
		    children,
		    function(a){
		     return caml_exact_trampoline_cps_call$1
		             (concat$0,
		              0,
		              a,
		              function(a){
		               var p = make$33(0, [8, [0, a]]);
		               return caml_exact_trampoline_cps_call$0
		                       (insert, acc, p, tail$0, cont);
		              });
		    });
		                                  }
		                                  if(! children){
		                                   if(! acc)
		                                    return caml_exact_trampoline_cps_call
		    (flatten_root(0),
		     tail$0,
		     function(a){return cont([0, make$33(0, a39), a]);});
		                                   var block = acc[1];
		                                   return caml_exact_trampoline_cps_call
		   (flatten_root(0),
		    tail$0,
		    function(a){return cont([0, block, a]);});
		                                  }
		                                 }
		                                 if(2 === caml_ml_string_length(tag)){
		                                  var x = caml_string_get(tag, 0);
		                                  if(x === 104){
		                                   var a = caml_string_get(tag, 1) - 48 | 0;
		                                   return caml_exact_trampoline_cps_call$1
		   (flatten,
		    cst$1,
		    children,
		    function(b){
		     return caml_exact_trampoline_cps_call$1
		             (concat$0,
		              0,
		              b,
		              function(b){
		               var heading = make$33(0, [6, [0, b, a, 0]]);
		               return caml_exact_trampoline_cps_call$0
		                       (insert, acc, heading, tail$0, cont);
		              });
		    });
		                                  }
		                                 }
		                                 return caml_exact_trampoline_cps_call$1
		 (flatten,
		  cst$1,
		  [0, node, 0],
		  function(a){
		   return caml_exact_trampoline_cps_call$1
		           (concat$0,
		            0,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call$0
		                     (append, acc, a, tail$0, cont);
		            });
		  });
		                                });
		                      default:
		                       var tail$1 = param[2], t = node[1];
		                       return caml_exact_trampoline_cps_call$0
		                               (append, acc, t, tail$1, cont);
		                    }
		                   }
		                   if(! acc) return cont(0);
		                   var block = acc[1];
		                   return cont([0, block, 0]);};
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (flatten_root(0),
		                          html,
		                          function(l){
		                           return l ? cont(l) : cont([0, make$33(0, a3_), 0]);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         html_parser,
		                         text,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function url_trailing_chars(c, cont){
		                a:
		                {
		                 if(61 <= c){
		                  if(95 <= c){
		                   if(126 !== c && 96 <= c) break a;
		                  }
		                  else if(64 !== c && 62 <= c) break a;
		                 }
		                 else {
		                  var a = c - 35 | 0;
		                  if(10 < a >>> 0){
		                   if(12 !== a) break a;
		                  }
		                  else if(5 >= a - 4 >>> 0) break a;
		                 }
		                 return cont(1);
		                }
		                a = 97 <= c ? 1 : 0;
		                a = a ? c <= 122 ? 1 : 0 : a;
		                if(a)
		                 ;
		                else {
		                 a = 65 <= c ? 1 : 0;
		                 a = a ? c <= 90 ? 1 : 0 : a;
		                 if(a)
		                  ;
		                 else {a = 48 <= c ? 1 : 0; if(a) return cont(c <= 57 ? 1 : 0);
		                 }
		                }
		                return cont(a);
		               }
		               function url_chars(a, cont){
		                a = a - 46 | 0;
		                a:
		                {
		                 if(12 < a >>> 0){
		                  if(17 !== a) break a;
		                 }
		                 else if(10 >= a - 1 >>> 0) break a;
		                 return cont(1);
		                }
		                return cont(0);
		               }
		               var
		                e = count_while1(url_trailing_chars, substring),
		                e =
		                  symbol_map$3
		                   (many1(lift2(symbol_concat, take_while(url_chars), e)),
		                    function(eta, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (concat$0, 0, eta, cont);
		                    }),
		                b4 = string$3("https://"),
		                url$0 =
		                  symbol_map$3
		                   (lift2
		                     (symbol_concat,
		                      caml_callback(symbol$64, [string$3("http://"), b4]),
		                      e),
		                    function(url, cont){
		                     return caml_exact_trampoline_cps_call
		                             (of_string$19, url, function(a){return cont([0, a, 0, 0]);});
		                    });
		               function reference_to_text(referee, block, cont){
		                var pp_v1 = include$48[1];
		                function a(ppf, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_none, ppf, dummy, cont);
		                 var v = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_char,
		                          ppf,
		                          58,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1(pp_v1, ppf, v, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$133,
		                         function(b){
		                          return caml_trampoline_cps_call5
		                                  (b, pp$52, referee, a, block, cont);
		                         });
		               }
		               function to_text(expand_links, rt, cont){
		                var
		                 with_link =
		                   expand_links
		                    ? function
		                     (url, txt, cont){
		                      var s2 = cst$7 + txt;
		                      return caml_exact_trampoline_cps_call$1
		                              (to_string$25, 0, url, function(s1){return cont(s1 + s2);});
		                     }
		                    : function(param, txt, cont){return cont(txt);};
		                function f(a, cont){
		                 switch(a[0]){
		                   case 0:
		                    var b = a[2], url = a[1], a = a[3];
		                    if(a){
		                     var rt = a[1];
		                     return caml_trampoline_cps_call3
		                             (map$18,
		                              rt,
		                              f,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (concat$0,
		0,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (with_link, url, a, cont);
		});
		                              });
		                    }
		                    if(! b)
		                     return caml_exact_trampoline_cps_call$1
		                             (to_string$25, 0, url, cont);
		                    var s = b[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (with_link, url, s, cont);
		                   case 1:
		                    var block = a[2], referee = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (reference_to_text, referee, block, cont);
		                   case 2:
		                    var s$0 = a[1]; return cont(s$0);
		                   default:
		                    var rt$0 = a[2];
		                    return caml_trampoline_cps_call3
		                            (map$18,
		                             rt$0,
		                             f,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (concat$0, 0, a, cont);
		                             });
		                 }
		                }
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         rt,
		                         f,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0, 0, a, cont);
		                         });
		               }
		               function f$36(l, c, cont){
		                if(21 > l){
		                 a:
		                 {
		                  b:
		                  {
		                   if(65 <= c){
		                    var a = c - 91 | 0;
		                    if(5 < a >>> 0){
		                     if(32 <= a) break b;
		                    }
		                    else if(4 !== a) break b;
		                   }
		                   else
		                    if(48 <= c){if(58 <= c) break b;} else if(45 !== c) break b;
		                   a = 1;
		                   break a;
		                  }
		                  a = 0;
		                 }
		                 if(a) return cont([0, l + 1 | 0]);
		                }
		                return cont(0);
		               }
		               var
		                nanoid$0 =
		                  symbol_bind$3
		                   (symbol$63(scan(0, f$36, substring), "nanoid"),
		                    function(param, cont){
		                     if(21 !== param[2]) return cont(fail$0("invalid nanoid"));
		                     var s = param[1];
		                     return caml_exact_trampoline_cps_call(return$7, s, cont);
		                    }),
		                e =
		                  [0,
		                   [0, caml_callback(create$11, [0, cst$10]), " &nbsp;"],
		                   0],
		                e =
		                  [0,
		                   [0, caml_callback(create$11, [0, cst$10]), "&nbsp; "],
		                   e],
		                cst_gt$0 = "&gt;",
		                e =
		                  [0, [0, caml_callback(create$11, [0, cst$41]), cst_gt$0], e],
		                cst_lt$0 = "&lt;",
		                e =
		                  [0, [0, caml_callback(create$11, [0, cst$51]), cst_lt$0], e],
		                cst_amp = "&amp;",
		                special_chars =
		                  [0, [0, caml_callback(create$11, [0, cst$5]), cst_amp], e];
		               function of_result(opt, parser){
		                var f = opt ? opt[1] : function(a, cont){return cont(a);};
		                return symbol_bind$3
		                        (parser,
		                         function(param, cont){
		                          if(0 === param[0]){
		                           var result = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (return$7, result, cont);
		                          }
		                          var error = param[1];
		                          return caml_trampoline_cps_call2
		                                  (f, error, function(a){return cont(fail$0(a));});
		                         });
		               }
		               var
		                markup_char =
		                  symbol_map$3
		                   (satisfy
		                     (function(a, cont){
		                       a:
		                       {
		                        if(92 <= a){
		                         a = a - 93 | 0;
		                         if(3 < a >>> 0){
		                          if(33 !== a) break a;
		                         }
		                         else if(1 === a) break a;
		                        }
		                        else
		                         if(41 <= a){
		                          if(47 >= a - 43 >>> 0) break a;
		                         }
		                         else if(35 !== a) break a;
		                        return cont(1);
		                       }
		                       return cont(0);
		                      }),
		                    function(c, cont){return cont([0, [2, of_char(c)], 0]);});
		               function content$0(expand_urls, cont){
		                var spacing = count_while1(whitespace$1, substring);
		                if(expand_urls){
		                 var
		                  a =
		                    [0,
		                     symbol_map$3
		                      (satisfy(not(markup_opening_char)),
		                       function(c, cont){
		                        return caml_exact_trampoline_cps_call
		                                (to_string$6, c, function(a){return cont([2, a]);});
		                       }),
		                     0];
		                 return caml_exact_trampoline_cps_call$1
		                         (choice,
		                          0,
		                          [0,
		                           url$0,
		                           [0,
		                            symbol_map$3
		                             (lift2
		                               (symbol_concat, count_while1(alphanum, substring), spacing),
		                              function(s, cont){return cont([2, s]);}),
		                            a]],
		                          function(a){return cont(many1(a));});
		                }
		                var f = not(markup_opening_char);
		                return cont
		                        (symbol_map$3
		                          (count_while1(f, substring),
		                           function(s, cont){return cont([0, [2, s], 0]);}));
		               }
		               var
		                content$1 = caml_callback(content$0, [0]),
		                content_or_urls = caml_callback(content$0, [1]),
		                elements$0 =
		                  fix
		                   (function(self, cont){
		                     function markdown_tag(delimiter, tag, content){
		                      var
		                       delimiter$0 = string$3(delimiter),
		                       b = many_till(content, delimiter$0),
		                       a = symbol$61(delimiter$0, content),
		                       p = lift2(cons, a, b);
		                      return symbol_map$3
		                              (p,
		                               function(content, cont){
		                                return caml_exact_trampoline_cps_call
		(of_list,
		 content,
		 function(a){return cont([0, [3, tag, a], 0]);});
		                               });
		                     }
		                     var
		                      underline = markdown_tag(cst$13, 4, self),
		                      strikethrough = markdown_tag(cst$60, 3, self),
		                      em = markdown_tag(cst$52, 2, self),
		                      bold = markdown_tag(cst$58, 0, self),
		                      delimiter = string$3(cst$59),
		                      code =
		                        symbol_map$3
		                         (symbol$61(delimiter, many_till(any_char, delimiter)),
		                          function(chars, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (of_char_list,
		                                    chars,
		                                    function(a){return cont([0, [3, 1, [0, [2, a], 0]], 0]);});
		                          });
		                     function check_link(v, cont){
		                      return caml_exact_trampoline_cps_call
		                              (of_list,
		                               v,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(to_text,
		 0,
		 a,
		 function(v){
		  return caml_exact_trampoline_cps_call
		          (of_string$19,
		           v,
		           function(uri){
		            return caml_exact_trampoline_cps_call
		                    (host$1,
		                     uri,
		                     function(a){
		                      var host = is_some(a);
		                      return caml_exact_trampoline_cps_call
		                              (scheme$1,
		                               uri,
		                               function(b){
		                                var scheme = is_some(b);
		                                function a(match){
		                                 if(! match) return cont(fail$0("invalid link"));
		                                 var uri = match[1];
		                                 return caml_exact_trampoline_cps_call$1
		 (to_string$25,
		  0,
		  uri,
		  function(a){
		   return caml_exact_trampoline_cps_call
		           (return$7, [0, v, a], cont);
		  });
		                                }
		                                if(! host && ! scheme)
		                                 return caml_exact_trampoline_cps_call$1
		 (path$0,
		  0,
		  uri,
		  function(b){
		   return caml_exact_trampoline_cps_call$1
		           (split$0,
		            b,
		            47,
		            function(match){
		             if(! match) return a(0);
		             var path = match[2], host = match[1];
		             return caml_exact_trampoline_cps_call$1
		                     (split$0,
		                      host,
		                      46,
		                      function(b){
		                       return caml_exact_trampoline_cps_call
		                               (of_rev_keys,
		                                b,
		                                function(c){
		                                 if(c && c[2]){
		                                  var extension = c[1];
		                                  a:
		                                  {
		                                   c = v$1;
		                                   for(;;){
		                                    if(! c) break;
		                                    var bs = c[2], b = c[1], c = extension === b;
		                                    if(c) break a;
		                                    c = bs;
		                                   }
		                                   c = 0;
		                                  }
		                                  if(c)
		                                   return caml_exact_trampoline_cps_call$1
		   (concat$0,
		    a3$,
		    path,
		    function(d){
		     var b = [0, [0, d]], c = [0, [0, host]];
		     return caml_exact_trampoline_cps_call
		             (scheme$1,
		              uri,
		              function(d){
		               return caml_exact_trampoline_cps_call$9
		                       (with_uri,
		                        [0, first_some(d, a4a)],
		                        0,
		                        c,
		                        0,
		                        b,
		                        0,
		                        0,
		                        uri,
		                        function(uri){return a([0, uri]);});
		              });
		    });
		                                 }
		                                 return a(0);
		                                });
		                      });
		            });
		  });
		                                return a([0, uri]);
		                               });
		                     });
		           });
		 });
		                               });
		                     }
		                     function a(param, cont){
		                      var link = param[2], name = param[1], a = [0, name];
		                      return caml_exact_trampoline_cps_call
		                              (of_string$19,
		                               link,
		                               function(b){return cont([0, [0, b, a, 0], 0]);});
		                     }
		                     var b = string$3(cst$36);
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$64,
		                              content$1,
		                              markup_char,
		                              function(c){
		                               c = symbol_bind$3(many_till(c, b), check_link);
		                               var
		                                link_short = symbol_map$3(symbol$61(string$3(cst$37), c), a),
		                                sep = string$3(cst$21),
		                                c = string$3(cst_assistant);
		                               return caml_exact_trampoline_cps_call$1
		                                       (symbol$64,
		string$3(cst_agent),
		c,
		function(agent_id){
		 function string_list(sep, l, cont){
		  return caml_exact_trampoline_cps_call$1
		          (reduce,
		           l,
		           function(p1, p2, cont){
		            return cont
		                    (lift2(symbol_concat, lift2(symbol_concat, p1, sep), p2));
		           },
		           function(o){
		            if(! o)
		             return caml_exact_trampoline_cps_call
		                     (invalid_arg, cst_empty_list, cont);
		            var x = o[1];
		            return cont(x);
		           });
		 }
		 function to_id(kind, parser, cont){
		  var a = symbol_map$3(parser, of_string$40);
		  return caml_exact_trampoline_cps_call$1
		          (kasprintf,
		           id,
		           fmt$134,
		           function(b){
		            return caml_trampoline_cps_call2
		                    (b, kind, function(b){return cont(of_result([0, b], a));});
		           });
		 }
		 return caml_exact_trampoline_cps_call$1
		         (string_list,
		          sep,
		          [0,
		           string$3(cst_object),
		           [0, nanoid$0, [0, nanoid$0, [0, nanoid$0, 0]]]],
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (to_id,
		                    "custom object",
		                    a,
		                    function(custom_object_id){
		                     return caml_exact_trampoline_cps_call$1
		                             (string_list,
		                              sep,
		                              [0,
		                               string$3(cst_agent_ref),
		                               [0, nanoid$0, [0, agent_id, [0, nanoid$0, 0]]]],
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (to_id,
		"agent reference",
		a,
		function(agent_ref_id){
		 return caml_exact_trampoline_cps_call$1
		         (string_list,
		          sep,
		          [0,
		           string$3(cst_automation_ref),
		           [0, nanoid$0, [0, nanoid$0, 0]]],
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (to_id,
		                    "automation reference",
		                    a,
		                    function(automation_ref_id){
		                     return caml_exact_trampoline_cps_call$1
		                             (string_list,
		                              sep,
		                              [0,
		                               string$3(cst_conversation_ref),
		                               [0,
		                                nanoid$0,
		                                [0, agent_id, [0, nanoid$0, [0, nanoid$0, 0]]]]],
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (to_id,
		"conversation reference",
		a,
		function(conversation_ref_id){
		 return caml_exact_trampoline_cps_call$1
		         (string_list,
		          sep,
		          [0,
		           string$3(cst_automation_run_ref),
		           [0, nanoid$0, [0, nanoid$0, [0, nanoid$0, 0]]]],
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (to_id,
		                    "automation run reference",
		                    a,
		                    function(automation_run_ref_id){
		                     return caml_exact_trampoline_cps_call$1
		                             (string_list,
		                              sep,
		                              [0,
		                               string$3(cst_table_ref),
		                               [0, nanoid$0, [0, nanoid$0, 0]]],
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (to_id,
		"table ref",
		a,
		function(table_ref_id){
		 return caml_exact_trampoline_cps_call$1
		         (string_list,
		          sep,
		          [0,
		           string$3(cst_workspace_ref),
		           [0, nanoid$0, [0, nanoid$0, 0]]],
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (to_id,
		                    "workspace ref",
		                    a,
		                    function(workspace_ref_id){
		                     var
		                      a = include$48[6],
		                      b =
		                        symbol_map$3
		                         (lift2(symbol_concat, string$3("block:"), nanoid$0), a);
		                     return caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              id,
		                              fmt$135,
		                              function(a){
		                               var
		                                block_id = of_result([0, a], b),
		                                a = [0, nanoid$0, [0, take$2(10), 0]];
		                               return caml_exact_trampoline_cps_call$1
		                                       (string_list,
		sep,
		[0, string$3(cst_event), a],
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (to_id,
		          "event occurrence",
		          a,
		          function(event_occurrence_id){
		           var
		            b = string$3(cst$21),
		            a = [0, string$3(cst_task), 0],
		            a = [0, string$3(cst_task_rec), a],
		            a = [0, string$3(cst_people), a],
		            a = [0, string$3(cst_page), a],
		            a = [0, string$3(cst_event), a];
		           return caml_exact_trampoline_cps_call$1
		                   (choice,
		                    0,
		                    [0, string$3(cst_event_rec), a],
		                    function(c){
		                     var
		                      a =
		                        symbol_map$3
		                         (lift2(symbol_concat, lift2(symbol_concat, c, b), nanoid$0),
		                          of_string$40);
		                     return caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              id,
		                              fmt$136,
		                              function(c){
		                               var object_id = of_result([0, c], a);
		                               function b(param, cont){
		                                var block = param[2], referee = param[1];
		                                return cont([0, [1, referee, block], 0]);
		                               }
		                               return caml_exact_trampoline_cps_call$1
		                                       (choice,
		0,
		[0,
		 custom_object_id,
		 [0,
		  agent_ref_id,
		  [0,
		   automation_ref_id,
		   [0,
		    conversation_ref_id,
		    [0,
		     automation_run_ref_id,
		     [0,
		      table_ref_id,
		      [0,
		       workspace_ref_id,
		       [0, event_occurrence_id, [0, object_id, 0]]]]]]]]],
		function(a){
		 var left = symbol$61(char$0(35), a);
		 return caml_exact_trampoline_cps_call$1
		         (option$0,
		          0,
		          symbol_map$3(symbol$61(char$0(58), block_id), found),
		          function(a){
		           var
		            reference = symbol_map$3(symbol$65(left, a), b),
		            p =
		              [0,
		               function(input, pos, more, fail, succ, cont){
		                var c = unsafe_get_char(input, pos);
		                return 41 !== c
		                        ? caml_trampoline_cps_call5
		                          (succ, input, pos + 1 | 0, more, c, cont)
		                        : caml_exact_trampoline_cps_call
		                          (sprintf,
		                           iX,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     41,
		                                     function(a){
		                                      return caml_trampoline_cps_call6
		      (fail, input, pos, more, 0, a, cont);
		                                     });
		                           });
		               }],
		            a =
		              [0,
		               symbol_map$3
		                (ensure(1, p),
		                 function(c, cont){
		                  return caml_exact_trampoline_cps_call
		                          (to_string$6, c, function(a){return cont([2, a]);});
		                 }),
		               0],
		            a =
		              [0,
		               symbol_map$3
		                (string$3("\\("), function(param, cont){return cont(a4b);}),
		               a];
		           return caml_exact_trampoline_cps_call$1
		                   (choice,
		                    0,
		                    [0,
		                     symbol_map$3
		                      (string$3(cst$23), function(param, cont){return cont(a4c);}),
		                     a],
		                    function(a){
		                     var
		                      link_destination = many(a),
		                      link_text =
		                        fix
		                         (function(self, cont){
		                           var
		                            markup_char =
		                              symbol_map$3
		                               (satisfy
		                                 (function(param, cont){
		                                   a:
		                                   {
		                                    if(43 <= param){
		                                     if(97 <= param){
		                                      if(126 !== param) break a;
		                                     }
		                                     else if(95 > param) break a;
		                                    }
		                                    else if(35 !== param && 41 > param) break a;
		                                    return cont(1);
		                                   }
		                                   return cont(0);
		                                  }),
		                                function(c, cont){return cont([0, [2, of_char(c)], 0]);});
		                           function f(c, cont){
		                            return 92 === c ? cont(0) : cont(1 - markup_opening_char(c));
		                           }
		                           var
		                            a =
		                              [0,
		                               markup_char,
		                               [0,
		                                symbol_map$3
		                                 (count_while1(f, substring),
		                                  function(s, cont){return cont([0, [2, s], 0]);}),
		                                0]],
		                            a = [0, markdown_tag(cst$13, 4, self), a],
		                            a = [0, reference, [0, markdown_tag(cst$60, 3, self), a]],
		                            a = [0, code, [0, markdown_tag(cst$52, 2, self), a]],
		                            a = [0, markdown_tag(cst$58, 0, self), a],
		                            a =
		                              [0,
		                               symbol_map$3
		                                (string$3("\\["), function(param, cont){return cont(a4d);}),
		                               a];
		                           return caml_exact_trampoline_cps_call$1
		                                   (choice,
		                                    0,
		                                    [0,
		                                     symbol_map$3
		                                      (string$3("\\]"), function(param, cont){return cont(a4e);}),
		                                     a],
		                                    cont);
		                          }),
		                      a = string$3(cst$18),
		                      b = many_till(link_text, string$3(cst$29)),
		                      link_long =
		                        symbol_map$3
		                         (symbol$62
		                           (symbol$65(symbol$61(string$3(cst$37), b), link_destination),
		                            a),
		                          function(param, cont){
		                           var url = param[2], text = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (to_text,
		                                    0,
		                                    url,
		                                    function(url){
		                                     return caml_exact_trampoline_cps_call
		     (of_list,
		      text,
		      function(c){
		       var a = [0, c], b = [0, url];
		       return caml_exact_trampoline_cps_call
		               (of_string$19,
		                url,
		                function(c){return cont([0, [0, c, b, a], 0]);});
		      });
		                                    });
		                          });
		                     return caml_exact_trampoline_cps_call$1
		                             (choice,
		                              0,
		                              [0,
		                               bold,
		                               [0,
		                                code,
		                                [0,
		                                 em,
		                                 [0,
		                                  reference,
		                                  [0,
		                                   link_long,
		                                   [0,
		                                    link_short,
		                                    [0,
		                                     strikethrough,
		                                     [0, underline, [0, markup_char, [0, content_or_urls, 0]]]]]]]]]],
		                              cont);
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    }),
		                rich_text_parser =
		                  symbol_map$3
		                   (many(elements$0),
		                    function(elements, cont){
		                     function collate(a){
		                      for(;;){
		                       if(! a) return 0;
		                       var head = a[1];
		                       switch(head[0]){
		                         case 0:
		                          var b = head[3];
		                          if(b){
		                           var
		                            tail = a[2],
		                            content = b[1],
		                            name = head[2],
		                            uri = head[1],
		                            a = collate(tail);
		                           return [0, [0, uri, name, [0, collate(content)]], a];
		                          }
		                          break;
		                         case 2:
		                          b = a[2];
		                          if(b){
		                           var c = b[1];
		                           if(2 === c[0]){
		                            var tail$1 = b[2], s2 = c[1], s1 = head[1];
		                            a = [0, [2, s1 + s2], tail$1];
		                            continue;
		                           }
		                          }
		                          break;
		                         case 3:
		                          var
		                           tail$2 = a[2],
		                           children = head[2],
		                           a = head[1],
		                           c = collate(tail$2);
		                          return [0, [3, a, collate(children)], c];
		                       }
		                       var tail$0 = a[2];
		                       return [0, head, collate(tail$0)];
		                      }
		                     }
		                     return caml_exact_trampoline_cps_call
		                             (of_list, elements, function(a){return cont(collate(a));});
		                    }),
		                cst_nbsp = "&nbsp;";
		               function to_html(opt, tag, txt, text, cont){
		                var
		                 escape = opt ? opt[1] : 1,
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(text, cont){
		                 return caml_exact_trampoline_cps_call
		                         (length$1,
		                          text,
		                          function(length){
		                           function f(i, t, cont){
		                            function f(param, cont){
		                             switch(param[0]){
		                               case 0:
		                                var name = param[2], url = param[1];
		                                if(name){
		                                 if(! param[3]){
		                                  var name$0 = name[1];
		                                  return caml_exact_trampoline_cps_call$1
		  (to_string$25,
		   0,
		   url,
		   function(url){
		    return caml_exact_trampoline_cps_call$0
		            (tag,
		             cst_span,
		             a4o,
		             [0, txt(cst$36), 0],
		             function(b){
		              var a = [0, b, 0];
		              return caml_exact_trampoline_cps_call$0
		                      (tag,
		                       cst_a$0,
		                       [0, [0, [0, cst_href, url], 0]],
		                       [0, txt(name$0), 0],
		                       function(c){
		                        var b = [0, c, a];
		                        return caml_exact_trampoline_cps_call$0
		                                (tag,
		                                 cst_span,
		                                 a4p,
		                                 [0, txt(cst$37), 0],
		                                 function(a){return cont([0, a, b]);});
		                       });
		             });
		   });
		                                 }
		                                }
		                                else if(! param[3])
		                                 return caml_exact_trampoline_cps_call$1
		 (to_string$25,
		  0,
		  url,
		  function(url){
		   return caml_exact_trampoline_cps_call$0
		           (tag,
		            cst_a$0,
		            [0, [0, [0, cst_href, url], 0]],
		            [0, txt(url), 0],
		            function(a){return cont([0, a, 0]);});
		  });
		                                var rt = param[3][1];
		                                return caml_exact_trampoline_cps_call$1
		(to_string$25,
		 0,
		 url,
		 function(url){
		  return caml_exact_trampoline_cps_call$0
		          (tag,
		           cst_span,
		           a4k,
		           [0, txt(cst$18), 0],
		           function(b){
		            var a = [0, b, 0];
		            return caml_exact_trampoline_cps_call$0
		                    (tag,
		                     cst_span,
		                     a4l,
		                     [0, txt(value$4(name, url)), 0],
		                     function(c){
		                      var b = [0, c, a];
		                      return caml_exact_trampoline_cps_call$0
		                              (tag,
		                               cst_span,
		                               a4m,
		                               [0, txt(cst$29), 0],
		                               function(c){
		                                var a = [0, c, b];
		                                return caml_trampoline_cps_call3
		(map$18,
		 rt,
		 f,
		 function(b){
		  return caml_exact_trampoline_cps_call
		          (of_list,
		           b,
		           function(b){
		            return caml_exact_trampoline_cps_call$0
		                    (tag,
		                     cst_a$0,
		                     [0, [0, [0, cst_href, url], 0]],
		                     b,
		                     function(c){
		                      var b = [0, c, a];
		                      return caml_exact_trampoline_cps_call$0
		                              (tag,
		                               cst_span,
		                               a4n,
		                               [0, txt(cst$37), 0],
		                               function(a){return cont([0, a, b]);});
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               case 1:
		                                var block = param[2], referee = param[1];
		                                return caml_exact_trampoline_cps_call$1
		(reference_to_text,
		 referee,
		 block,
		 function(c){
		  var b = [0, txt(c), 0];
		  function a(a){
		   return caml_exact_trampoline_cps_call
		           (to_string$48,
		            referee,
		            function(c){
		             return caml_exact_trampoline_cps_call$0
		                     (tag,
		                      cst_reference,
		                      [0, [0, [0, cst_target, c], a]],
		                      b,
		                      function(a){return cont([0, a, 0]);});
		            });
		  }
		  if(! block) return a(0);
		  var block$0 = block[1];
		  return caml_exact_trampoline_cps_call
		          (include$48[8],
		           block$0,
		           function(b){return a([0, [0, cst_block, b], 0]);});
		 });
		                               case 2:
		                                var
		                                 init = param[1],
		                                 a = function(rendered){return cont([0, txt(rendered), 0]);},
		                                 b =
		                                   function(t, init){
		                                    if(t){
		                                     var l = t[2], a$0 = t[1], repl = a$0[2], pattern = a$0[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (replace_all,
		      pattern,
		      init,
		      repl,
		      function(init){
		       return caml_exact_trampoline_call2(b, l, init);
		      });
		                                    }
		                                    function c(txt){
		                                     if(i !== (length - 1 | 0)) return a(txt);
		                                     var len = caml_ml_string_length(txt);
		                                     if(0 >= len) return a(txt);
		                                     var x = caml_string_get(txt, len - 1 | 0);
		                                     return x === 32
		     ? caml_exact_trampoline_cps_call$0
		       (sub_fun,
		        txt,
		        0,
		        len - 1 | 0,
		        function(s1){return a(s1 + cst_nbsp);})
		     : a(txt);
		                                    }
		                                    if(0 !== i) return c(init);
		                                    var len = caml_ml_string_length(init);
		                                    if(0 >= len) return c(init);
		                                    var x = caml_string_get(init, 0);
		                                    return x === 32
		    ? caml_exact_trampoline_cps_call$0
		      (sub_fun,
		       init,
		       1,
		       len - 1 | 0,
		       function(s2){return c(cst_nbsp + s2);})
		    : c(init);
		                                   };
		                                return escape ? b(special_chars, init) : a(init);
		                               default:
		                                var content = param[2], t = param[1];
		                                return caml_trampoline_cps_call3
		(map$18,
		 content,
		 f,
		 function(a){
		  return caml_exact_trampoline_cps_call
		          (of_list,
		           a,
		           function(content){
		            switch(t){
		              case 0:
		               var match = a4f; break;
		              case 1:
		               match = a4g; break;
		              case 2:
		               match = a4h; break;
		              case 3:
		               match = a4i; break;
		              default: match = a4j;
		            }
		            var t$0 = match[2], markup = match[1];
		            return caml_exact_trampoline_cps_call$0
		                    (tag,
		                     cst_span,
		                     a4q,
		                     [0, txt(markup), 0],
		                     function(b){
		                      var a = [0, b, 0];
		                      return caml_exact_trampoline_cps_call$0
		                              (tag,
		                               t$0,
		                               0,
		                               content,
		                               function(c){
		                                var b = [0, c, a];
		                                return caml_exact_trampoline_cps_call$0
		(tag,
		 cst_span,
		 a4r,
		 [0, txt(markup), 0],
		 function(a){return cont([0, a, b]);});
		                               });
		                     });
		           });
		 });
		                             }
		                            }
		                            return caml_exact_trampoline_cps_call(f, t, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (mapi$0,
		                                    text,
		                                    f,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call(of_list, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         rich_text_parser,
		                         text,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function to_html_string(html, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 symbol_map = open[2];
		                function text(a){return a;}
		                function a(eta, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (concat$0, 0, eta, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (to_html,
		                         0,
		                         function(tag, opt, children, cont){
		                          var
		                           attrs = opt ? opt[1] : 0,
		                           b =
		                             [0,
		                              function(ppf, param, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (pp_print_char, ppf, 61, cont);
		                              }],
		                           a = list(0, pp_print_string),
		                           c =
		                             list
		                              (0,
		                               function(ppf, v, cont){
		                                return caml_exact_trampoline_cps_call$1
		(pp_print_char,
		 ppf,
		 32,
		 function(a){
		  return caml_exact_trampoline_cps_call$3
		          (pair, b, pp_print_string, string$1, ppf, v, cont);
		 });
		                               });
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$137,
		                                   function(b){
		                                    return caml_trampoline_cps_call7
		    (b, tag, c, attrs, a, children, tag, cont);
		                                   });
		                         },
		                         text,
		                         html,
		                         function(b){
		                          return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                         });
		               }
		               function to_text$0(opt, text, cont){
		                var
		                 expand_links = opt ? opt[1] : 0,
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(text, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (to_text, expand_links, text, cont);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         rich_text_parser,
		                         text,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               caml_callback
		                (M$2, [[0, comparator$2, thread_id_schema_versioned]]);
		               function silo(param, kind, name, cont){
		                var storage = param[2], Storage = param[1];
		                return caml_trampoline_cps_call4
		                        (Storage[1],
		                         storage,
		                         kind,
		                         name,
		                         function(a){return cont([0, Storage, a]);});
		               }
		               function delete$0(param, cont){
		                var silo = param[2], Storage = param[1];
		                return caml_trampoline_cps_call2(Storage[3], silo, cont);
		               }
		               function get$16(param, cont){
		                var silo = param[2], Storage = param[1];
		                return caml_trampoline_cps_call2(Storage[4], silo, cont);
		               }
		               function set$27(param, cont){
		                var silo = param[2], Storage = param[1];
		                return caml_trampoline_cps_call2(Storage[5], silo, cont);
		               }
		               var
		                schematic_cache$848 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$885 = [];
		               caml_update_dummy
		                (letrec_function_context$885, [0, schematic_cache$848]);
		               var schematic_schema_version$29 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$885[1][1],
		                    schematic_schema_version$29]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$885[1][1],
		                             schematic_schema_version$29,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$885[1][1],
		schematic_schema_version$29,
		schematic_self,
		function(a){
		 letrec_function_context$885[1][1] = a;
		 a = "pong";
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(f0, cont){return cont([0, f0]);},
		       function(param, cont){
		        if(0 !== param[0]) return cont(0);
		        var f0 = param[1];
		        return cont([0, f0]);
		       },
		       1,
		       0,
		       cst_notification,
		       "Notification",
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var notification = param[1];
		          return cont(notification);
		         },
		         function(notification, cont){
		          return cont([0, notification, 0]);
		         },
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_notification,
		           0,
		           2,
		           [0, no_input_schema],
		           0,
		           0],
		          0]],
		        0],
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(0 === param[0]) return cont(0);
		         var f0 = param[1];
		         return cont([0, f0]);
		        },
		        1,
		        0,
		        a,
		        "Pong",
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){
		           var salt = param[1];
		           return cont(salt);
		          },
		          function(salt, cont){return cont([0, salt, 0]);},
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            a,
		            0,
		            2,
		            [0, schematic_param_name_schema_ve],
		            0,
		            0],
		           0]],
		         0],
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$885[1][1],
		          schematic_schema_version$29,
		          res,
		          function(a){
		           letrec_function_context$885[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$849 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$886 = [];
		               caml_update_dummy
		                (letrec_function_context$886, [0, schematic_cache$849]);
		               var schematic_schema_version$30 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$886[1][1],
		                    schematic_schema_version$30]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$886[1][1],
		                             schematic_schema_version$30,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$886[1][1],
		schematic_schema_version$30,
		schematic_self,
		function(a){
		 letrec_function_context$886[1][1] = a;
		 var
		  res =
		    [11,
		     a4s,
		     [0,
		      [0,
		       function(param, cont){
		        var f1 = param[2], f0 = param[1];
		        return cont([0, f0, f1]);
		       },
		       function(param, cont){
		        if(0 !== param[0]) return cont(0);
		        var f1 = param[2], f0 = param[1];
		        return cont([0, [0, f0, f1]]);
		       },
		       1,
		       0,
		       "authenticate",
		       "Authenticate",
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var version = param[2][1], token = param[1];
		          return cont([0, token, version]);
		         },
		         function(param, cont){
		          var version = param[2], token = param[1];
		          return cont([0, token, [0, version, 0]]);
		         },
		         [0,
		          [0,
		           0,
		           0,
		           0,
		           0,
		           cst_token,
		           0,
		           2,
		           [0, schematic_param_name_schema_ve],
		           0,
		           0],
		          [0,
		           [0, 0, 0, 0, 0, cst_version, 0, 2, [0, schema$261], 0, 0],
		           0]]],
		        0],
		       0],
		      [0,
		       [0,
		        function(f0, cont){return cont([1, f0]);},
		        function(param, cont){
		         if(0 === param[0]) return cont(0);
		         var f0 = param[1];
		         return cont([0, f0]);
		        },
		        1,
		        0,
		        cst_ping,
		        "Ping",
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){
		           var salt = param[1];
		           return cont(salt);
		          },
		          function(salt, cont){return cont([0, salt, 0]);},
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            "salt",
		            0,
		            2,
		            [0, schematic_param_name_schema_ve],
		            0,
		            0],
		           0]],
		         0],
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$886[1][1],
		          schematic_schema_version$30,
		          res,
		          function(a){
		           letrec_function_context$886[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               e = "Trie__Iterator_intf";
		               record_start(e);
		               b4 = "trie";
		               set$7(b4);
		               unset();
		               caml_callback(record_until, [e]);
		               e = "Trie__Iterator";
		               record_start(e);
		               set$7(b4);
		               unset();
		               caml_callback(record_until, [e]);
		               e = "Trie__Keychainable_intf";
		               record_start(e);
		               set$7(b4);
		               unset();
		               caml_callback(record_until, [e]);
		               e = "Trie__Keychainable";
		               record_start(e);
		               set$7(b4);
		               function comparator$60(Chain){return Chain[1][1];}
		               function iterator(Chain){return Chain[3][1];}
		               function start$3(t){var t$0 = iterator(t); return t$0[1];}
		               function is_finished(t){var t$0 = iterator(t); return t$0[2];}
		               function get_exn(t){var t$0 = iterator(t); return t$0[3];}
		               function next_exn(t){var t$0 = iterator(t); return t$0[4];}
		               unset();
		               caml_callback(record_until, [e]);
		               e = "Trie__Trie_intf";
		               record_start(e);
		               set$7(b4);
		               unset();
		               caml_callback(record_until, [e]);
		               e = "Trie";
		               record_start(e);
		               set$7(b4);
		               function is_empty$11(a){
		                var tries = a[2], datum = a[1], a = is_none$0(datum);
		                return a ? Using_comparator$0[3][34].call(null, tries) : a;
		               }
		               var empty$30 = [0, 0, Using_comparator$0[3][109]];
		               function find_trie_and_call
		               (keychainable, t, keychain, if_found, if_not_found, cont){
		                return caml_trampoline_cps_call2
		                        (start$3(keychainable),
		                         keychain,
		                         function(iter){
		                          function a(t, iter){
		                           return caml_trampoline_cps_call3
		                                   (is_finished(keychainable),
		                                    iter,
		                                    keychain,
		                                    function(b){
		                                     return b
		     ? cont(if_found(t))
		     : caml_trampoline_cps_call3
		       (get_exn(keychainable),
		        iter,
		        keychain,
		        function(key){
		         return caml_trampoline_cps_call3
		                 (next_exn(keychainable),
		                  iter,
		                  keychain,
		                  function(iter){
		                   var tries = t[2], b = comparator$60(keychainable);
		                   return caml_exact_trampoline_cps_call$0
		                           (Using_comparator$0[3][44],
		                            b,
		                            tries,
		                            key,
		                            function(match){
		                             if(! match) return cont(if_not_found);
		                             var trie = match[1];
		                             return caml_exact_trampoline_call2(a, trie, iter);
		                            });
		                  });
		        });
		                                    });
		                          }
		                          return a(t, iter);
		                         });
		               }
		               function foldi_at(keychainable, t, init, f, rev_keys, cont){
		                var t$0 = t[1];
		                function b(key, trie, acc, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (foldi_at, dummy, trie, acc, f, [0, key, rev_keys], cont);
		                }
		                function a(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (Using_comparator$0[3][55], t[2], a, b, cont);
		                }
		                if(! t$0) return a(init);
		                var data = t$0[1];
		                return caml_exact_trampoline_cps_call$0
		                        (f, init, rev_keys, data, a);
		               }
		               function foldi(keychainable, t, init, f, cont){
		                function f$0(acc, rev_keys, data, cont){
		                 return caml_trampoline_cps_call2
		                         (keychainable[4],
		                          rev_keys,
		                          function(keychain){return cont(f(acc, keychain, data));});
		                }
		                return caml_exact_trampoline_cps_call$3
		                        (foldi_at, keychainable, t, init, f$0, 0, cont);
		               }
		               function like$1(t, node){
		                if(node === t[2]) return t;
		                var keychainable = t[1];
		                return [0, keychainable, node];
		               }
		               function find_trie(t, keychain, cont){
		                var t$0 = t[2], keychainable = t[1];
		                function a(a){return cont(like$1(t, a));}
		                return is_empty$11(t$0)
		                        ? a(t$0)
		                        : caml_exact_trampoline_cps_call$3
		                          (find_trie_and_call,
		                           keychainable,
		                           t$0,
		                           keychain,
		                           function(a){return a;},
		                           empty$30,
		                           a);
		               }
		               function to_alist$2(t, cont){
		                var t$0 = t[2], keychainable = t[1];
		                return caml_exact_trampoline_cps_call$2
		                        (foldi,
		                         keychainable,
		                         t$0,
		                         0,
		                         function(acc, keychain, data){
		                          return [0, [0, keychain, data], acc];
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call(of_rev_keys, a, cont);
		                         });
		               }
		               unset();
		               caml_callback(record_until, [e]);
		               caml_callback(of_int, [0]);
		               var Inc = bQy();
		               function of_incremental(opt, var$, cont){
		                var
		                 release =
		                   opt ? opt[1] : function(param, cont){return cont(0);};
		                return caml_exact_trampoline_cps_call$1
		                        (create_observer,
		                         0,
		                         var$,
		                         function(obs){
		                          var state = var$[2];
		                          return caml_exact_trampoline_cps_call
		                                  (stabilize,
		                                   state,
		                                   function(match){
		                                    var
		                                     res = [0, obs, release, function(a, cont){return cont(a);}];
		                                    return cont(res);
		                                   });
		                         });
		               }
		               function get$17(param, cont){
		                var map = param[3], obs = param[1];
		                return caml_exact_trampoline_cps_call
		                        (observer_value_exn,
		                         obs,
		                         function(a){return caml_trampoline_cps_call2(map, a, cont);});
		               }
		               function watch$1(opt, var$, f, cont){
		                var
		                 immediate = opt ? opt[1] : 0,
		                 map = var$[3],
		                 obs = var$[1],
		                 inc = observing(obs);
		                return caml_exact_trampoline_cps_call$1
		                        (create_observer,
		                         0,
		                         inc,
		                         function(obs){
		                          return caml_exact_trampoline_cps_call$1
		                                  (on_update_exn,
		                                   obs,
		                                   function(param, cont){
		                                    if(typeof param === "number") return cont(0);
		                                    if(0 === param[0]){
		                                     var v = param[1];
		                                     return immediate
		     ? caml_trampoline_cps_call2
		       (map,
		        v,
		        function(a){
		         return caml_exact_trampoline_cps_call(f, a, cont);
		        })
		     : cont(immediate);
		                                    }
		                                    var v$0 = param[2];
		                                    return caml_trampoline_cps_call2
		    (map,
		     v$0,
		     function(a){
		      return caml_exact_trampoline_cps_call(f, a, cont);
		     });
		                                   },
		                                   function(match){
		                                    var state = inc[2];
		                                    return caml_exact_trampoline_cps_call
		    (stabilize,
		     state,
		     function(match){
		      return cont
		              (function(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (disallow_future_use$0, obs, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function return$40(value, cont){
		                return caml_exact_trampoline_cps_call
		                        (Inc[9],
		                         value,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, a, cont);
		                         });
		               }
		               function make$136(release, value, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Inc[51][2],
		                         0,
		                         value,
		                         function(var$){
		                          var var_inc = var$[4];
		                          function push(value, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (set_var,
		                                    var$,
		                                    value,
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call(Inc[56], dummy, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental,
		                                   release,
		                                   var_inc,
		                                   function(a){return cont([0, a, push]);});
		                         });
		               }
		               function map$53(source, f){
		                return [0,
		                        source[1],
		                        source[2],
		                        function(v, cont){
		                         return caml_trampoline_cps_call2
		                                 (source[3],
		                                  v,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call(f, a, cont);
		                                  });
		                        }];
		               }
		               function release(param, cont){
		                var release = param[2], obs = param[1];
		                return caml_trampoline_cps_call2
		                        (release,
		                         0,
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (disallow_future_use$0, obs, cont);
		                         });
		               }
		               function map2$2(left, right, f, cont){
		                function compute(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (get$17,
		                          right,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (get$17,
		                                    left,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(f, b, a, cont);
		                                    });
		                          });
		                }
		                var unwatch_left = [], unwatch_right = [];
		                function release_var(a, cont){
		                 a = caml_obj_tag(unwatch_left);
		                 function b(a){
		                  return caml_trampoline_cps_call2
		                          (a,
		                           0,
		                           function(a){
		                            a = caml_obj_tag(unwatch_right);
		                            function b(a){
		                             return caml_trampoline_cps_call2
		                                     (a,
		                                      0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (release,
		        left,
		        function(a){
		         return caml_exact_trampoline_cps_call(release, right, cont);
		        });
		                                      });
		                            }
		                            if(250 === a) return b(unwatch_right[1]);
		                            if(246 !== a && 244 !== a) return b(unwatch_right);
		                            return caml_exact_trampoline_cps_call
		                                    (force_lazy_block, unwatch_right, b);
		                           });
		                 }
		                 if(250 === a) return b(unwatch_left[1]);
		                 if(246 !== a && 244 !== a) return b(unwatch_left);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, unwatch_left, b);
		                }
		                var var$ = [];
		                caml_update_dummy
		                 (var$,
		                  [246,
		                   function(param, cont){
		                    return caml_exact_trampoline_cps_call
		                            (compute,
		                             dummy,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (make$136, [0, release_var], a, cont);
		                             });
		                   }]);
		                caml_update_dummy
		                 (unwatch_left,
		                  [246,
		                   function(a, cont){
		                    return caml_exact_trampoline_cps_call$0
		                            (watch$1,
		                             0,
		                             left,
		                             function(param, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (compute,
		                                       dummy,
		                                       function(c){
		var a = caml_obj_tag(var$);
		function b(a){
		 return caml_trampoline_cps_call2(a[2], c, cont);
		}
		if(250 === a) return b(var$[1]);
		if(246 !== a && 244 !== a) return b(var$);
		return caml_exact_trampoline_cps_call
		        (force_lazy_block, var$, b);
		                                       });
		                             },
		                             cont);
		                   }]);
		                caml_update_dummy
		                 (unwatch_right,
		                  [246,
		                   function(a, cont){
		                    return caml_exact_trampoline_cps_call$0
		                            (watch$1,
		                             0,
		                             right,
		                             function(param, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (compute,
		                                       dummy,
		                                       function(c){
		var a = caml_obj_tag(var$);
		function b(a){
		 return caml_trampoline_cps_call2(a[2], c, cont);
		}
		if(250 === a) return b(var$[1]);
		if(246 !== a && 244 !== a) return b(var$);
		return caml_exact_trampoline_cps_call
		        (force_lazy_block, var$, b);
		                                       });
		                             },
		                             cont);
		                   }]);
		                var a = caml_obj_tag(unwatch_left);
		                function b(a){
		                 a = caml_obj_tag(unwatch_right);
		                 function b(a){
		                  a = caml_obj_tag(var$);
		                  function b(a){return cont(a[1]);}
		                  if(250 === a) return b(var$[1]);
		                  if(246 !== a && 244 !== a) return b(var$);
		                  return caml_exact_trampoline_cps_call
		                          (force_lazy_block, var$, b);
		                 }
		                 if(250 === a) return b(0);
		                 if(246 !== a && 244 !== a) return b(0);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, unwatch_right, b);
		                }
		                if(250 === a) return b(0);
		                if(246 !== a && 244 !== a) return b(0);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, unwatch_left, b);
		               }
		               caml_callback
		                (M_printable,
		                 [[0, pp$2, comparator$2, thread_id_schema_versioned]]);
		               function generic_to_graph(op){
		                a:
		                {
		                 if(3805373 <= op){
		                  if(3901498 === op)
		                   return function(lhs, rhs){return [0, lhs, 7, rhs];};
		                  if(192136481 <= op){
		                   if(613978708 > op) break a;
		                  }
		                  else if(103618111 > op)
		                   return function(lhs, rhs){return [0, lhs, 6, rhs];};
		                  return function(lhs, rhs){
		                   return call$1(cst$53, [0, lhs, [0, rhs, 0]]);};
		                 }
		                 if(15500 === op)
		                  return function(lhs, rhs){return [0, lhs, 1, rhs];};
		                 if(17064 <= op){
		                  if(3556728 <= op)
		                   return function(lhs, rhs){return [0, lhs, 3, rhs];};
		                  return function(lhs, rhs){return [0, lhs, 5, rhs];};
		                 }
		                 if(15949 <= op)
		                  return function(lhs, rhs){return [0, lhs, 2, rhs];};
		                }
		                return function(lhs, rhs){
		                 var value = call$1(cst$53, [0, lhs, [0, rhs, 0]]);
		                 return [19, 0, [0, value, none$2]];};
		               }
		               function to_graph(param, cont){
		                var
		                 match = param[2],
		                 rhs = match[2],
		                 op = match[1],
		                 lhs = param[1],
		                 to_graph = generic_to_graph(op),
		                 lhs$0 = name$12(lhs);
		                function b(rhs){
		                 var value = to_graph(lhs$0, rhs);
		                 return cont([0, value, none$2]);
		                }
		                a:
		                if(typeof op === "number"){
		                 b:
		                 {
		                  if(192136482 <= op){
		                   if(259676648 !== op && 613978708 !== op){if(708102797 === op) break b; break a;}
		                   if(typeof rhs === "number") break a;
		                   if(2 !== rhs[0]) break a;
		                   var s = rhs[1], s2 = quote(s);
		                   return b(string$6("^" + s2));
		                  }
		                  if(-23885269 !== op && 103618111 !== op){if(192136481 <= op) break b; break a;}
		                  if(typeof rhs === "number") break a;
		                  if(2 !== rhs[0]) break a;
		                  var s$1 = rhs[1];
		                  return b(string$6(quote(s$1)));
		                 }
		                 if(typeof rhs !== "number" && 2 === rhs[0]){
		                  var s$0 = rhs[1], s1 = quote(s$0);
		                  return b(string$6(s1 + "$"));
		                 }
		                }
		                function a(a){
		                 return caml_exact_trampoline_cps_call(to_ast, a, b);
		                }
		                if(typeof rhs === "number") return a(0);
		                switch(rhs[0]){
		                  case 0:
		                   var value = rhs[1]; return a([1, value]);
		                  case 1:
		                   var value$0 = rhs[1]; return a([0, value$0]);
		                  case 2:
		                   var value$1 = rhs[1]; return a([7, value$1]);
		                  default:
		                   var date = rhs[1];
		                   return caml_exact_trampoline_cps_call(of_date$3, date, a);
		                }
		               }
		               g(include$0);
		               function to_graph$0(param, cont){
		                var
		                 match = param[2],
		                 op = match[2],
		                 rhs = match[1],
		                 lhs = param[1],
		                 lhs_expr = [0, [12, [0, lhs]], none$2];
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         rhs,
		                         function(v, cont){
		                          var value = [16, v];
		                          return cont([0, value, none$2]);
		                         },
		                         function(a){
		                          var
		                           value = [9, a],
		                           inside_expr =
		                             [0, [0, lhs_expr, 4, [0, value, none$2]], none$2];
		                          if(76551432 > op) return cont(inside_expr);
		                          return cont([0, [19, 0, inside_expr], none$2]);
		                         });
		               }
		               g(include$0);
		               g(include$0);
		               var
		                myself = caml_callback(opaque, [cst_myself]),
		                cst_routine$0 = "_routine";
		               function to_graph$1(param, cont){
		                var
		                 match = param[2],
		                 op = match[2],
		                 rhs = match[1],
		                 lhs = param[1],
		                 op$0 = generic_to_graph(op),
		                 lhs$0 =
		                   [0,
		                    [2,
		                     [0,
		                      [2, [0, [12, [0, lhs]], none$2], [0, [0, cst_routine$0]], 0],
		                      none$2],
		                     [0, [0, cst_id]],
		                     0],
		                    none$2];
		                function a(rhs){
		                 var value = op$0(lhs$0, rhs);
		                 return cont([0, value, none$2]);
		                }
		                if(! rhs) return a([0, 0, none$2]);
		                var id = rhs[1];
		                if(typeof id !== "number")
		                 return caml_exact_trampoline_cps_call
		                         (to_string$58,
		                          id,
		                          function(b){
		                           var value = [16, b];
		                           return a([0, value, none$2]);
		                          });
		                return a([0, [12, myself], none$2]);
		               }
		               function to_graph$2(param, cont){
		                var
		                 filter = param[2],
		                 lhs = param[1],
		                 lhs$1 = [0, [12, [0, lhs]], none$2];
		                if(0 !== filter[0]){
		                 var
		                  match_kind = filter[2],
		                  filter$0 = filter[1],
		                  element_identifier = "__routine_collection_element",
		                  a =
		                    function(a){
		                     var
		                      value =
		                        [20, [0, [3, lhs$1, [0, element_identifier]], none$2], a],
		                      filtered = [0, value, none$2];
		                     if(match_kind)
		                      return cont
		                              ([0,
		                                [0,
		                                 [0,
		                                  [1, [0, [12, [0, cst_length]], none$2], [0, filtered, 0]],
		                                  none$2],
		                                 1,
		                                 [0,
		                                  [1, [0, [12, [0, cst_length]], none$2], [0, lhs$1, 0]],
		                                  none$2]],
		                                none$2]);
		                     return cont
		                             ([0,
		                               [0,
		                                [0,
		                                 [1, [0, [12, [0, cst_length]], none$2], [0, filtered, 0]],
		                                 none$2],
		                                2,
		                                [0, value$2, none$2]],
		                               none$2]);
		                    };
		                 switch(filter$0[0]){
		                   case 0:
		                    var f = filter$0[1];
		                    return caml_exact_trampoline_cps_call
		                            (to_graph, [0, element_identifier, f], a);
		                   case 1:
		                    var f$0 = filter$0[1];
		                    return caml_exact_trampoline_cps_call
		                            (to_graph$1, [0, element_identifier, f$0], a);
		                   case 2:
		                    var c = filter$0[1];
		                    return caml_exact_trampoline_cps_call
		                            (to_graph$2, [0, element_identifier, c], a);
		                   default:
		                    var f$1 = filter$0[1];
		                    return caml_exact_trampoline_cps_call
		                            (to_graph$0, [0, element_identifier, f$1], a);
		                 }
		                }
		                var field = filter[2], empty = filter[1];
		                if(field)
		                 var
		                  field$0 = field[1],
		                  lhs$0 = [0, [2, lhs$1, [0, [0, field$0]], 0], none$2];
		                else
		                 lhs$0 = lhs$1;
		                if(empty){
		                 var
		                  value =
		                    [1, [0, [12, [0, cst_length]], none$2], [0, lhs$0, 0]];
		                 return cont
		                         ([0,
		                           [5,
		                            [0,
		                             [0, [0, value, none$2], 2, [0, value$0, none$2]],
		                             none$2],
		                            [0, [12, [0, cst_false]], none$2],
		                            [0, [12, [0, cst_true]], none$2]],
		                           none$2]);
		                }
		                var
		                 value$3 =
		                   [1, [0, [12, [0, cst_length]], none$2], [0, lhs$0, 0]];
		                return cont
		                        ([0,
		                          [0, [0, value$3, none$2], 2, [0, value$1, none$2]],
		                          none$2]);
		               }
		               function to_graph$3(a, cont){
		                switch(a[0]){
		                  case 0:
		                   var atom = a[1], a = atom[2], lhs = atom[1];
		                   switch(a[0]){
		                     case 0:
		                      var filter = a[1];
		                      return caml_exact_trampoline_cps_call
		                              (to_graph, [0, lhs, filter], cont);
		                     case 1:
		                      var filter$0 = a[1];
		                      return caml_exact_trampoline_cps_call
		                              (to_graph$1, [0, lhs, filter$0], cont);
		                     case 2:
		                      var filter$1 = a[1];
		                      return caml_exact_trampoline_cps_call
		                              (to_graph$2, [0, lhs, filter$1], cont);
		                     default:
		                      var filter$2 = a[1];
		                      return caml_exact_trampoline_cps_call
		                              (to_graph$0, [0, lhs, filter$2], cont);
		                   }
		                  case 1:
		                   var rhs = a[2], lhs$0 = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_graph$3,
		                            lhs$0,
		                            function(lhs){
		                             return caml_exact_trampoline_cps_call
		                                     (to_graph$3,
		                                      rhs,
		                                      function(rhs){
		                                       var value = [0, lhs, 0, rhs];
		                                       return cont([0, value, none$2]);
		                                      });
		                            });
		                  default:
		                   var rhs$0 = a[2], lhs$1 = a[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_graph$3,
		                            lhs$1,
		                            function(lhs){
		                             return caml_exact_trampoline_cps_call
		                                     (to_graph$3,
		                                      rhs$0,
		                                      function(rhs){
		                                       var value = [0, lhs, 8, rhs];
		                                       return cont([0, value, none$2]);
		                                      });
		                            });
		                }
		               }
		               var letrec_function_context$887 = [];
		               function schema_versioned$538(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$887[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4t, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$887[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$887[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$887[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var column_name = param[1];
		                                 return cont([0, column_name]);
		                                },
		                                function(param, cont){
		                                 var column_name = param[1];
		                                 return cont([0, column_name, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "column_name",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$887[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$887[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$850 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$887, [0, schematic_cache$850]);
		               caml_callback
		                (schema_versioned$538,
		                 [function(param, cont){return cont(0);}]);
		               var bOZ = [];
		               function schema_versioned$539(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bOZ[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4u, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bOZ[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bOZ[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bOZ[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (direction_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var direction = param[2][1], column_names = param[1];
		   return cont([0, column_names, direction]);
		  },
		  function(param, cont){
		   var direction = param[2], column_names = param[1];
		   return cont([0, column_names, [0, direction, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "column_names",
		    0,
		    2,
		    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_direction, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bOZ[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bOZ[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$888 = [];
		               function direction_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$888[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, 0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$888[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$888[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$888[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a4y);},
		                                  0,
		                                  0,
		                                  cst_ascending,
		                                  "Ascending",
		                                  a4x,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(a4w) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_descending,
		                                   "Descending",
		                                   a4v,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$888[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$888[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$851 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bOZ, [0, schematic_cache$851]);
		               var schematic_cache$852 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$888, [0, schematic_cache$852]);
		               caml_callback
		                (schema_versioned$539,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (direction_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function schema_versioned$540(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  ([0,
		                                    a4z,
		                                    0,
		                                    schematic_param_name_schema_ve[3],
		                                    schematic_param_name_schema_ve[4]]);
		                         });
		               }
		               function to_graph$4(field, cont){
		                var id = [0, field];
		                return cont([0, field, [0, [12, id], none$2]]);
		               }
		               var letrec_function_context$889 = [];
		               function schema_versioned$541(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$889[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4A, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$889[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$889[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$889[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$540,
		                                     schematic_version,
		                                     function(a){
		                                      var res = [3, a];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$889[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$889[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$853 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$889, [0, schematic_cache$853]);
		               caml_callback
		                (schema_versioned$541,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$890 = [];
		               function schema_versioned$542(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$890[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4C, a4B, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$890[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$890[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$890[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, a4D, 0, 0, 0, cst_limit, 0, 3, [0, int_schema], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$539,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b = [0, [0, a4E, 0, 0, 0, "sorting", 0, 3, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$538,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$259[1],
		         a =
		           [0,
		            [0,
		             a4F,
		             0,
		             0,
		             0,
		             "groupings",
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$541,
		                 schematic_version,
		                 function(c){
		                  var
		                   b =
		                     [0,
		                      [0, a4G, 0, 0, 0, "visible_fields", 0, 3, [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$302,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  limit = d[2][1],
		                                  sorting = d[1],
		                                  groupings = c[1],
		                                  visible_fields = b[1],
		                                  filter = a[1],
		                                  source_table_name = param[1];
		                                 return cont
		 ([0,
		   source_table_name,
		   filter,
		   visible_fields,
		   groupings,
		   sorting,
		   limit]);
		                                },
		                                function(param, cont){
		                                 var
		                                  limit = param[6],
		                                  sorting = param[5],
		                                  groupings = param[4],
		                                  visible_fields = param[3],
		                                  filter = param[2],
		                                  source_table_name = param[1];
		                                 return cont
		 ([0,
		   source_table_name,
		   [0,
		    filter,
		    [0,
		     visible_fields,
		     [0, groupings, [0, sorting, [0, limit, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  a4I,
		                                  0,
		                                  0,
		                                  0,
		                                  "source_table_name",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0, [0, a4H, 0, 0, 0, cst_filter, 0, 3, [0, a], 0, 0], b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$890[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$890[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$854 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$890, [0, schematic_cache$854]);
		               var
		                schema$238 =
		                  caml_callback
		                   (schema_versioned$542,
		                    [function(param, cont){return cont(0);}]),
		                routine_field = [0, cst_routine$0],
		                source_database_name = [0, "_routine_source_database"];
		               function to_graph$5(param, cont){
		                var
		                 limit = param[6],
		                 sorting = param[5],
		                 groupings = param[4],
		                 visible_fields = param[3],
		                 filter = param[2],
		                 source_table_name = param[1];
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         filter,
		                         to_graph$3,
		                         function(filter){
		                          var default$ = [0, [12, [0, source_table_name]], none$2];
		                          if(filter)
		                           var
		                            filter$0 = filter[1],
		                            with_filters = [0, [20, default$, filter$0], none$2];
		                          else
		                           with_filters = default$;
		                          function a(sorted){
		                           if(limit)
		                            var
		                             limit$0 = limit[1],
		                             value$0 = [6, caml_int64_of_int32(limit$0)],
		                             value = [22, sorted, [0, value$0, none$2]],
		                             with_limit = [0, value, none$2];
		                           else
		                            with_limit = sorted;
		                           return caml_exact_trampoline_cps_call
		                                   (of_rev_keys,
		                                    groupings,
		                                    function(t){
		                                     function a(t, grouped){
		                                      if(t){
		                                       var
		l = t[2],
		grouping = t[1],
		column_name = grouping[1],
		value$0 =
		  [4, grouped, 0, [0, [12, [0, column_name]], none$2]];
		                                       return caml_exact_trampoline_call2
		       (a, l, [0, value$0, none$2]);
		                                      }
		                                      var value = [3, grouped, source_database_name];
		                                      function b(with_visible_fields){
		                                       return cont(with_visible_fields);
		                                      }
		                                      var named = [0, value, none$2];
		                                      if(! visible_fields) return b(named);
		                                      var visible_fields$0 = visible_fields[1];
		                                      return caml_trampoline_cps_call3
		      (map$18,
		       visible_fields$0,
		       to_graph$4,
		       function(fields){
		        var
		         a =
		           [0,
		            [2,
		             [0, [12, source_database_name], none$2],
		             [0, routine_field],
		             1],
		            none$2];
		        return caml_exact_trampoline_cps_call$1
		                (to_to_string,
		                 _41,
		                 routine_field,
		                 function(d){
		                  var routine_field$0 = [0, d, a];
		                  function c(t){
		                   function a(a){
		                    a = a ? fields : [0, routine_field$0, fields];
		                    var inner_selects = [0, [13, a], none$2], t = groupings;
		                    for(;;){
		                     if(! t){
		                      var value$0 = [15, named, inner_selects];
		                      return b([0, value$0, none$2]);
		                     }
		                     var
		                      l = t[2],
		                      value =
		                        [15,
		                         [0,
		                          [3,
		                           [0, [12, source_database_name], none$2],
		                           source_database_name],
		                          none$2],
		                         inner_selects];
		                     inner_selects = [0, value, none$2];
		                     t = l;
		                    }
		                   }
		                   if(! t) return a(0);
		                   var xs = t[2], x = t[1], name = x[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (symbol$96,
		                            [0, name],
		                            routine_field,
		                            function(b){
		                             return b ? a(1) : caml_exact_trampoline_call1(c, xs);
		                            });
		                  }
		                  return c(fields);
		                 });
		       });
		                                     }
		                                     return a(t, with_limit);
		                                    });
		                          }
		                          if(! sorting) return a(with_filters);
		                          var
		                           sorting$0 = sorting[1],
		                           direction = sorting$0[2],
		                           column_names = sorting$0[1];
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   column_names,
		                                   function(column_name, cont){
		                                    var value = [12, [0, column_name]];
		                                    return cont([0, value, none$2]);
		                                   },
		                                   function(b){
		                                    var
		                                     value = [9, b],
		                                     value$0 =
		                                       [21, with_filters, [0, [0, value, none$2], direction]];
		                                    return a([0, value$0, none$2]);
		                                   });
		                         });
		               }
		               var
		                schematic_cache$855 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$891 = [];
		               caml_update_dummy
		                (letrec_function_context$891, [0, schematic_cache$855]);
		               function schematic_version$127(param){return 0;}
		               var
		                schematic_schema_version$64 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$891[1][1],
		                     schematic_schema_version$64]);
		               if(e)
		                var schema$239 = e[1], descriptor$51 = schema$239;
		               else
		                descriptor$51 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$891[1][1],
		                              schematic_schema_version$64,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$891[1][1],
		 schematic_schema_version$64,
		 schematic_self,
		 function(b){
		  letrec_function_context$891[1][1] = b;
		  var
		   a =
		     [0,
		      [0,
		       function(f0, cont){return cont([1, f0]);},
		       function(param, cont){
		        if(0 === param[0]) return cont(0);
		        var f0 = param[1];
		        return cont([0, f0]);
		       },
		       0,
		       0,
		       "compilation",
		       "Compilation",
		       schematic_param_name_schema_ve,
		       0],
		      0];
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$89,
		           schematic_version$127,
		           function(b){
		            var
		             res =
		               [11,
		                0,
		                [0,
		                 [0,
		                  function(f0, cont){return cont([0, f0]);},
		                  function(param, cont){
		                   if(0 !== param[0]) return cont(0);
		                   var f0 = param[1];
		                   return cont([0, f0]);
		                  },
		                  0,
		                  0,
		                  cst_graph,
		                  "Graph",
		                  b,
		                  0],
		                 a],
		                0];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$891[1][1],
		                     schematic_schema_version$64,
		                     res,
		                     function(a){
		                      letrec_function_context$891[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$240 = [0, a4J, 0, descriptor$51, 0],
		                letrec_function_context$892 = [];
		               function schema_versioned$543(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$892[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4L, a4K, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$892[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$892[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$892[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                a4Q,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && ! param) return cont(a4P);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_int,
		                                  cst_Int,
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 1 === param)
		                                     return cont(a4O);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_bool,
		                                   cst_Bool,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 2 === param)
		                                      return cont(a4N);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_string,
		                                    cst_String,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 3 <= param)
		                                       return cont(a4M);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_date,
		                                     cst_Date,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(f0, cont){return cont([0, f0]);},
		                                      function(param, cont){
		                                       if(typeof param === "number") return cont(0);
		                                       var f0 = param[1];
		                                       return cont([0, f0]);
		                                      },
		                                      1,
		                                      0,
		                                      cst_enum,
		                                      "Enum",
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){
		 var cases = param[1];
		 return cont(cases);
		},
		function(cases, cont){return cont([0, cases, 0]);},
		[0,
		 [0,
		  0,
		  0,
		  0,
		  0,
		  cst_cases,
		  0,
		  2,
		  [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		  0,
		  0],
		 0]],
		                                       0],
		                                      0],
		                                     0]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$892[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$892[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$856 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$892, [0, schematic_cache$856]);
		               caml_callback
		                (schema_versioned$543,
		                 [function(param, cont){return cont(0);}]);
		               var cst_presence = "presence", bO0 = [];
		               function schema_versioned$544(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bO0[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4R, , descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bO0[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO0[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bO0[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 a4S,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_presence,
		                                 0,
		                                 2,
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (comparison_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var presence = param[2][1], comparison = param[1];
		   return cont([0, comparison, presence]);
		  },
		  function(param, cont){
		   var presence = param[2], comparison = param[1];
		   return cont([0, comparison, [0, presence, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_comparison, 0, 3, [1, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       bO0[1][1],
		       schematic_schema_version,
		       res,
		       function(a){bO0[1][1] = a; return cont(res);});
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_operators = "operators",
		                letrec_function_context$893 = [];
		               function comparison_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$893[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4T, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$893[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$893[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$893[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$543,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_rhs, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$296,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var rhs = param[2][1], operators = param[1];
		             return cont([0, operators, rhs]);
		            },
		            function(param, cont){
		             var rhs = param[2], operators = param[1];
		             return cont([0, operators, [0, rhs, 0]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_operators,
		              0,
		              2,
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$893[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$893[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$857 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bO0, [0, schematic_cache$857]);
		               var schematic_cache$858 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$893, [0, schematic_cache$858]);
		               caml_callback
		                (schema_versioned$544,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (comparison_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$894 = [];
		               function schema_versioned$545(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$894[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4V, a4U, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$894[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$894[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$894[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 a4W,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_presence,
		                                 0,
		                                 2,
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (Table[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0, a4X, 0, 0, 0, "target_table", 0, 2, [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$296,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              presence = a[2][1],
		              target_table = a[1],
		              operators = param[1];
		             return cont([0, operators, target_table, presence]);
		            },
		            function(param, cont){
		             var
		              presence = param[3],
		              target_table = param[2],
		              operators = param[1];
		             return cont
		                     ([0, operators, [0, target_table, [0, presence, 0]]]);
		            },
		            [0,
		             [0,
		              a4Y,
		              0,
		              0,
		              0,
		              cst_operators,
		              0,
		              2,
		              [0, [0, 0, 0, [3, a], 0]],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$894[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$894[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$859 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$894, [0, schematic_cache$859]);
		               caml_callback
		                (schema_versioned$545,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$895 = [];
		               function schema_versioned$546(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$895[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a40, a4Z, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$895[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$895[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$895[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 a41,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_presence,
		                                 0,
		                                 2,
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$296,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    presence = a[2][1],
		    operators = a[1],
		    available_values = param[1];
		   return cont([0, available_values, operators, presence]);
		  },
		  function(param, cont){
		   var
		    presence = param[3],
		    operators = param[2],
		    available_values = param[1];
		   return cont
		           ([0, available_values, [0, operators, [0, presence, 0]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "available_values",
		    0,
		    2,
		    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		    0,
		    0],
		   [0,
		    [0,
		     a42,
		     0,
		     0,
		     0,
		     cst_operators,
		     0,
		     2,
		     [0, [0, 0, 0, [3, b], 0]],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$895[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$895[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$860 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$895, [0, schematic_cache$860]);
		               caml_callback
		                (schema_versioned$546,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$896 = [];
		               function schema_versioned$547(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$896[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a44, a43, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$896[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$896[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$896[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$546,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([3, f0]);},
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_membership,
		   cst_Membership,
		   c,
		   0],
		  0],
		                                       b =
		 [0,
		  [0,
		   a45,
		   0,
		   0,
		   0,
		   cst_presence,
		   0,
		   2,
		   [0, bool_schema],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$547,
		       schematic_version,
		       function(d){
		        var
		         c =
		           [0, [0, a46, 0, 0, 0, cst_operation, 0, 3, [0, d], 0, 0], b];
		        return caml_exact_trampoline_cps_call
		                (kind_schema_versioned$2,
		                 schematic_version,
		                 function(d){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var
		                         f3 = param[4],
		                         f2 = param[3],
		                         f1 = param[2],
		                         f0 = param[1];
		                        return cont([2, f0, f1, f2, f3]);
		                       },
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var
		                         f3 = param[4],
		                         f2 = param[3],
		                         f1 = param[2],
		                         f0 = param[1];
		                        return cont([0, [0, f0, f1, f2, f3]]);
		                       },
		                       1,
		                       0,
		                       cst_collection,
		                       cst_Collection,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           b = a[2],
		                           presence = b[2][1],
		                           operation = b[1],
		                           match_kinds = a[1],
		                           field = param[1];
		                          return cont([0, field, match_kinds, operation, presence]);
		                         },
		                         function(param, cont){
		                          var
		                           presence = param[4],
		                           operation = param[3],
		                           match_kinds = param[2],
		                           field = param[1];
		                          return cont
		                                  ([0,
		                                    field,
		                                    [0, match_kinds, [0, operation, [0, presence, 0]]]]);
		                         },
		                         [0,
		                          [0,
		                           a47,
		                           0,
		                           0,
		                           0,
		                           cst_field,
		                           0,
		                           3,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            "match_kinds",
		                            0,
		                            2,
		                            [0, [0, 0, 0, [3, d], 0]],
		                            0,
		                            0],
		                           c]]],
		                        0],
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$545,
		                           schematic_version,
		                           function(c){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_relation,
		                                 cst_Relation,
		                                 c,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$544,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  a49,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    "atomic",
		    "Atomic",
		    [0, b[1], a48, b[3], b[4]],
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$896[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$896[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$861 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$896, [0, schematic_cache$861]);
		               var
		                schema$241 =
		                  caml_callback
		                   (schema_versioned$547,
		                    [function(param, cont){return cont(0);}]);
		               caml_callback(encode$7, [schema$241]);
		               var bO1 = [];
		               function schema_versioned$548(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bO1[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bO1[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO1[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bO1[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (filtering_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, "filtering", 0, 3, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$93,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var filtering = param[2][1], graph_type = param[1];
		             return cont([0, graph_type, filtering]);
		            },
		            function(param, cont){
		             var filtering = param[2], graph_type = param[1];
		             return cont([0, graph_type, [0, filtering, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, "graph_type", 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bO1[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){bO1[1][1] = a; return cont(res);});
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$897 = [];
		               function filtering_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$897[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a4$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$897[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$897[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$897[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (filter_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, "default_filter", 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$547,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              default_filter = param[2][1],
		              available_operations = param[1];
		             return cont([0, available_operations, default_filter]);
		            },
		            function(param, cont){
		             var
		              default_filter = param[2],
		              available_operations = param[1];
		             return cont
		                     ([0, available_operations, [0, default_filter, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, "available_operations", 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$897[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$897[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$862 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bO1, [0, schematic_cache$862]);
		               var schematic_cache$863 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$897, [0, schematic_cache$863]);
		               caml_callback
		                (schema_versioned$548,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (filtering_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                StringMap =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$2, comparator$2, thread_id_schema_versioned]]);
		               function schema_versioned$549(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$548,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (StringMap[109],
		     schematic_version,
		     a,
		     function(a){return cont([0, 0, 0, a[3], a[4]]);});
		                                   });
		                         });
		               }
		               caml_callback
		                (schema_versioned$549,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$864 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$898 = [];
		               caml_update_dummy
		                (letrec_function_context$898, [0, schematic_cache$864]);
		               function schematic_version$128(param, cont){return cont(0);}
		               var
		                schematic_schema_version$63 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$898[1][1],
		                     schematic_schema_version$63]);
		               if(e)
		                var schema$242 = e[1], descriptor$52 = schema$242;
		               else
		                descriptor$52 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$898[1][1],
		                              schematic_schema_version$63,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$898[1][1],
		 schematic_schema_version$63,
		 schematic_self,
		 function(a){
		  letrec_function_context$898[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$549,
		           schematic_version$128,
		           function(b){
		            var
		             a =
		               [0,
		                [0, a5c, 0, 0, 0, "available_columns", 0, 2, [0, b], 0, 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$542,
		                     schematic_version$128,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var available_columns = param[2][1], config = param[1];
		                           return cont([0, config, available_columns]);
		                          },
		                          function(param, cont){
		                           var available_columns = param[2], config = param[1];
		                           return cont([0, config, [0, available_columns, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_config, 0, 2, [1, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$898[1][1],
		                               schematic_schema_version$63,
		                               res,
		                               function(a){
		                                letrec_function_context$898[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$243 = [0, a5b, a5a, descriptor$52, 0],
		                Incremental = bQy(),
		                return$28 = Incremental[9],
		                bind$24 = Incremental[26],
		                map$45 = [0, , Incremental[10]],
		                e = Make([0, bind$24, return$28, map$45]),
		                Monad_infix = e[3],
		                ignore_m = e[8],
		                return$29 = Incremental[9],
		                map$46 = Incremental[10],
		                symbol_map$16 = Incremental[11],
		                bind$25 = Incremental[26],
		                symbol_bind$18 = Incremental[27],
		                join$7 = Incremental[32],
		                all$20 = Incremental[39],
		                array_fold$0 = Incremental[41],
		                stabilize$0 = Incremental[56],
		                Let_syntax$10 = Incremental[76];
		               function all_unit$0(t, cont){
		                function a(a, param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (to_array,
		                         t,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (array_fold$0, b, 0, a, cont);
		                         });
		               }
		               var
		                include$133 = Incremental[51],
		                create$42 = include$133[2],
		                set$10 = include$133[3],
		                watch$0 = include$133[4],
		                value$8 = include$133[5],
		                e = Let_syntax$10[4],
		                M$8 =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   ,
		                   symbol_bind$18,
		                   symbol_map$16,
		                   Monad_infix,
		                   bind$25,
		                   return$29,
		                   map$46,
		                   join$7,
		                   ignore_m,
		                   all$20,
		                   all_unit$0,
		                   [0,
		                    Let_syntax$10[1],
		                    Let_syntax$10[3],
		                    Let_syntax$10[2],
		                    [0, e[2], e[1], e[6], e[21], [0]]],
		                   [0, , , , create$42, set$10, watch$0]],
		                symbol_bind$21 = M$8[71],
		                symbol_map$19 = M$8[72],
		                Monad_infix$1 = M$8[73],
		                bind$29 = M$8[74],
		                return$32 = M$8[75],
		                map$49 = M$8[76],
		                join$9 = M$8[77],
		                ignore_m$2 = M$8[78],
		                all$22 = M$8[79],
		                all_unit$3 = M$8[80],
		                Let_syntax$13 = M$8[81];
		               function Make_base_map$0(b, a, c, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (Make_op,
		                         M$8,
		                         b,
		                         dummy,
		                         a,
		                         function(b){
		                          var a = b[1];
		                          return cont
		                                  ([0,
		                                    [0,
		                                     a[3],
		                                     a[4],
		                                     a[5],
		                                     a[6],
		                                     a[7],
		                                     a[8],
		                                     a[9],
		                                     a[10],
		                                     a[11],
		                                     a[12],
		                                     a[13],
		                                     a[14],
		                                     a[15],
		                                     a[16],
		                                     a[17],
		                                     a[18],
		                                     a[19],
		                                     a[20],
		                                     a[21],
		                                     a[22],
		                                     a[23],
		                                     a[24],
		                                     a[25],
		                                     a[26],
		                                     a[27],
		                                     a[28],
		                                     a[29],
		                                     a[30],
		                                     a[31],
		                                     a[32],
		                                     a[33],
		                                     a[34],
		                                     a[35],
		                                     a[36],
		                                     a[37],
		                                     a[38],
		                                     a[39],
		                                     a[40],
		                                     a[41],
		                                     a[42],
		                                     a[43],
		                                     a[44],
		                                     a[45],
		                                     a[46],
		                                     a[47],
		                                     a[48],
		                                     a[49],
		                                     a[50],
		                                     a[51],
		                                     a[52],
		                                     a[53],
		                                     a[54],
		                                     a[55],
		                                     a[56],
		                                     a[57],
		                                     a[58],
		                                     a[59],
		                                     a[60],
		                                     a[61],
		                                     a[63],
		                                     a[64],
		                                     a[65],
		                                     a[66],
		                                     a[67],
		                                     a[68],
		                                     a[69],
		                                     a[70],
		                                     a[71],
		                                     a[72],
		                                     a[73],
		                                     a[74],
		                                     a[75],
		                                     a[76],
		                                     a[77],
		                                     a[78],
		                                     a[79],
		                                     a[80],
		                                     a[81],
		                                     a[82],
		                                     a[83],
		                                     a[84],
		                                     a[85],
		                                     a[86],
		                                     a[87],
		                                     a[88],
		                                     a[89],
		                                     a[90],
		                                     a[91],
		                                     a[92],
		                                     a[95],
		                                     a[96],
		                                     a[97],
		                                     a[98],
		                                     a[99],
		                                     a[100],
		                                     a[103],
		                                     a[104],
		                                     a[105],
		                                     a[106],
		                                     a[107],
		                                     a[108],
		                                     a[109],
		                                     a[110],
		                                     a[111],
		                                     a[112],
		                                     a[113],
		                                     a[114],
		                                     a[115],
		                                     a[116],
		                                     a[117],
		                                     a[118],
		                                     a[119],
		                                     a[120],
		                                     a[121],
		                                     a[122],
		                                     a[123],
		                                     a[124],
		                                     a[125],
		                                     a[126],
		                                     a[127]],
		                                    b[2],
		                                    b[8],
		                                    b[9],
		                                    b[12],
		                                    b[13],
		                                    b[10],
		                                    b[11],
		                                    b[15],
		                                    b[14],
		                                    b[16],
		                                    b[17],
		                                    b[18],
		                                    b[19],
		                                    b[20],
		                                    b[21],
		                                    b[22],
		                                    b[23],
		                                    b[7]]);
		                         });
		               }
		               function Make_map$0(b, a, c, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (bRy, M$8, b, dummy, a, cont);
		               }
		               var
		                include$278 =
		                  caml_callback
		                   (Make$58,
		                    [[0,
		                      [0,
		                       symbol_bind$21,
		                       symbol_map$19,
		                       Monad_infix$1,
		                       bind$29,
		                       return$32,
		                       map$49,
		                       join$9,
		                       ignore_m$2,
		                       all$22,
		                       all_unit$3,
		                       Let_syntax$13],
		                      function(a){
		                       a = M$7(M$8, a);
		                       return [0, , a[2], , , , , , a[8], a[9], a[10], a[11]];
		                      },
		                      function(X){
		                       var
		                        include =
		                          M$7
		                           (M$8,
		                            [0, , , X[3], X[4], X[5], X[6], , X[8], X[9], X[10], X[11]]),
		                        state_schema_versioned = include[2],
		                        state_schema = include[3],
		                        delta_schema_versioned = include[4],
		                        delta_schema = include[5],
		                        Init = include[6],
		                        Monad = include[7],
		                        apply = include[8],
		                        apply_delta = include[9],
		                        make = include[10],
		                        view = include[11],
		                        equal = X[12],
		                        Operation = X[1];
		                       return [0,
		                               Operation,
		                               state_schema_versioned,
		                               state_schema,
		                               delta_schema_versioned,
		                               delta_schema,
		                               Init,
		                               [0,
		                                Monad[71],
		                                Monad[72],
		                                Monad[73],
		                                Monad[74],
		                                Monad[75],
		                                Monad[76],
		                                Monad[77],
		                                Monad[78],
		                                Monad[79],
		                                Monad[80],
		                                Monad[81]],
		                               apply,
		                               apply_delta,
		                               make,
		                               view,
		                               equal];
		                      },
		                      Make_base_map$0,
		                      Make_map$0]]),
		                Replica = include$278[1],
		                Sequence_id = bQU(include$0),
		                Sequence_result =
		                  bQT
		                   ([0,
		                     symbol_bind$4,
		                     symbol_map$4,
		                     ,
		                     ,
		                     ,
		                     of_string$14,
		                     map$15]),
		                From_lwt_async =
		                  [248,
		                   "Controller_lib__Acid.From_lwt_async",
		                   caml_fresh_oo_id()];
		               function from_lwt_async_printer(param, cont){
		                if(param[1] !== From_lwt_async) return cont(0);
		                var pos = param[3], exn$0 = param[2];
		                return caml_exact_trampoline_cps_call
		                        (to_string$2,
		                         pos,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$138,
		                                   function(b){
		                                    return caml_trampoline_cps_call4
		    (b, exn, exn$0, a, function(a){return cont([0, a]);});
		                                   });
		                         });
		               }
		               register_printer(from_lwt_async_printer);
		               function lwt_async(here, f, cont){
		                function f$0(param, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (catch$,
		                          f,
		                          function(e, a){
		                           a = caml_pop_trap();
		                           return a
		                                   (caml_maybe_attach_backtrace
		                                     ([0, From_lwt_async, e, here], 0));
		                          },
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call(async, f$0, cont);
		               }
		               var src$5 = create$18(a5d, cst_routine);
		               function set_level(src, default$, cont){
		                var
		                 name = tr$0(45, 95, uppercase_ascii$0(src[2])),
		                 o = getenv("ROUTINE_LOG_" + name);
		                function b(level){return cont(set(src[4], level));}
		                if(! o) return b(default$);
		                var x = o[1];
		                function a(t){
		                 if(0 === t[0])
		                  var a = t;
		                 else
		                  var x = t[1], s = x[2], a = [1, s];
		                 return caml_exact_trampoline_cps_call(ok_or_failwith, a, b);
		                }
		                return x !== cst_app
		                        ? x
		                          !== cst_debug
		                          ? x
		                            !== cst_error
		                            ? x
		                              !== cst_info
		                              ? x
		                                !== "quiet"
		                                ? x
		                                  !== cst_warning
		                                  ? caml_exact_trampoline_cps_call
		                                    (sprintf,
		                                     gw,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b, x, function(b){return a([1, [0, 3854881, b]]);});
		                                     })
		                                  : a(gx)
		                                : a(gy)
		                              : a(gz)
		                            : a(gA)
		                          : a(gB)
		                        : a(gC);
		               }
		               function set_all_levels(default$, cont){
		                var t = caml_atomic_load(bQM);
		                function a(t){
		                 if(! t) return cont();
		                 var l = t[2], src = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (set_level,
		                          src,
		                          default$,
		                          function(b){return caml_exact_trampoline_call1(a, l);});
		                }
		                return a(t);
		               }
		               var
		                component$0 =
		                  def
		                   (a5e,
		                    d,
		                    function(ppf, v, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (pp_print_string,
		                              ppf,
		                              v,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (pp_print_char,
		ppf,
		58,
		function(a){return cont(pp_v1(ppf));});
		                              });
		                    });
		               function pp_sep(ppf, v, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_char,
		                         ppf,
		                         58,
		                         function(a){return cont(pp_v1(ppf));});
		               }
		               var
		                attributes =
		                  def
		                   (a5f,
		                    cst_attributes,
		                    list
		                     ([0, semi],
		                      function(ppf, param, cont){
		                       var snd = param[2], fst = param[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_print_string,
		                                ppf,
		                                fst,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (pp_sep,
		  ppf,
		  dummy,
		  function(a){
		   var pp = snd[3], v = snd[1], a = caml_obj_tag(pp);
		   function b(a){
		    return caml_trampoline_cps_call3(a, ppf, v, cont);
		   }
		   if(250 === a) return b(pp[1]);
		   if(246 !== a && 244 !== a) return b(pp);
		   return caml_exact_trampoline_cps_call
		           (force_lazy_block, pp, b);
		  });
		                                });
		                      })),
		                no_report =
		                  def
		                   (a5h,
		                    "noreport",
		                    function(a, b, cont){
		                     return caml_exact_trampoline_cps_call$0
		                             (always, a5g, a, dummy, cont);
		                    });
		               function symbol$228(tags, param, cont){
		                var v = param[2], def = param[1];
		                return caml_exact_trampoline_cps_call$0
		                        (add$7, def, v, tags, cont);
		               }
		               function attr$0(name, value, schema){
		                return [0,
		                        name,
		                        [0,
		                         value,
		                         schema,
		                         [246,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (of_schema$1, schema, cont);
		                          }]]];
		               }
		               function attrs(attrs, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$228, empty$12, [0, attributes, attrs], cont);
		               }
		               var Lwt = src_log$0(src$5), Sync = src_log(src$5);
		               function warn$3(f, cont){
		                return caml_exact_trampoline_cps_call
		                        (Lwt[4],
		                         f,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$23, a, of_string$14, cont);
		                         });
		               }
		               function with_tag$0(def, value$0){
		                function add_tag(tags, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (add$7, def, value$0, value(tags, empty$12), cont);
		                }
		                function wrap(log, m, cont){
		                 return caml_exact_trampoline_cps_call
		                         (log,
		                          function(header, tags, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (add_tag,
		                                    tags,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(m, header, [0, a], cont);
		                                    });
		                          },
		                          cont);
		                }
		                function msg(level, log, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (Lwt[1],
		                          level,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1(wrap, log, a, cont);
		                          },
		                          cont);
		                }
		                function err(log, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 1, log, cont);
		                }
		                function info(log, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 3, log, cont);
		                }
		                function debug(log, cont){
		                 return caml_exact_trampoline_cps_call$1(msg, 4, log, cont);
		                }
		                var
		                 Sync$0 = with_tag(Sync, def, value$0),
		                 Lwt$0 = [0, , , err, , info, debug];
		                function info$0(f, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Lwt$0[5],
		                          f,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$23, a, of_string$14, cont);
		                          });
		                }
		                return [0, , , info$0, , Lwt$0, Sync$0];
		               }
		               function fail_result(fmt, cont){
		                function fail(s, cont){
		                 var x = [0, 9943782, s];
		                 return cont([1, x]);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, fail, fmt, cont);
		               }
		               function fatal$0(here, fmt, cont){
		                function f(s, cont){
		                 return caml_trampoline_cps_call3
		                         (map$17,
		                          here,
		                          to_string$2,
		                          function(b){
		                           function a(ppf, param, cont){
		                            if(! param)
		                             return caml_exact_trampoline_cps_call$1
		                                     (pp_none, ppf, dummy, cont);
		                            var v = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string,
		                                     ppf,
		                                     v,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (pp_print_string, ppf, cst$9, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$139,
		                                    function(c){
		                                     return caml_trampoline_cps_call4
		     (c, a, b, s, function(msg){return cont(fatal(msg));});
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, f, fmt, cont);
		               }
		               function fatal_exn(here, exn, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (fatal$0,
		                         [0, here],
		                         a5i,
		                         function(a){
		                          return caml_trampoline_cps_call3(a, pp$1, exn, cont);
		                         });
		               }
		               function fatal_toplevel(here, error, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (fatal$0,
		                         [0, here],
		                         a5j,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp_toplevel, error, cont);
		                         });
		               }
		               function fatal_result(here, param, cont){
		                if(0 === param[0]){var v = param[1]; return cont(v);}
		                var error = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (fatal_toplevel, here, error, cont);
		               }
		               var
		                e = caml_callback(make$15, [a5m, 0, a5l, 0, 0, 0, 0, dummy]),
		                d = caml_callback(make$15, [a5o, 0, a5n, 0, 0, 0, 0, dummy]),
		                bleeding = [0, caml_callback(api$0, [0]), d, e, a5k],
		                e = caml_callback(make$15, [a5r, 0, a5q, 0, 0, 0, 0, dummy]),
		                d = caml_callback(make$15, [a5t, 0, a5s, 0, 0, 0, 0, dummy]),
		                stable = [0, caml_callback(api$0, [1]), d, e, a5p],
		                bR9 =
		                  caml_callback(make$15, [a5w, 0, a5v, a5u, 0, 0, 0, dummy]),
		                bR_ =
		                  caml_callback(make$15, [a5z, 0, a5y, a5x, 0, 0, 0, dummy]);
		               caml_callback(make$15, [a5C, 0, a5B, a5A, 0, 0, 0, dummy]);
		               var
		                env_api =
		                  [246,
		                   function(a, cont){return cont(getenv_opt("ROUTINE_API"));}],
		                env_pns =
		                  [246,
		                   function(a, cont){return cont(getenv_opt("ROUTINE_PNS"));}],
		                env_bleeding =
		                  [246,
		                   function(a, cont){
		                    return cont(getenv_opt("ROUTINE_BLEEDING"));
		                   }];
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var bO2 = [];
		               function reason_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         bO2[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, a5J, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      bO2[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 bO2[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  bO2[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var reason = param[1];
		                       return cont([0, reason]);
		                      },
		                      function(param, cont){
		                       var reason = param[1];
		                       return cont([0, reason, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_reason,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO2[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bO2[1][1] = a; return cont(res);});
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$865 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bO2, [0, schematic_cache$865]);
		               var
		                schematic_cache$866 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$899 = [];
		               caml_update_dummy
		                (letrec_function_context$899, [0, schematic_cache$866]);
		               caml_callback
		                (reason_schema_versioned, [function(param){return 0;}]);
		               function schematic_version$129(param){return 0;}
		               var schematic_schema_version$62 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$899[1][1],
		                    schematic_schema_version$62]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$899[1][1],
		                             schematic_schema_version$62,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$899[1][1],
		schematic_schema_version$62,
		schematic_self,
		function(b){
		 letrec_function_context$899[1][1] = b;
		 var
		  a =
		    [0,
		     [0,
		      function(f0, cont){return cont([2, f0]);},
		      function(param, cont){
		       if(2 !== param[0]) return cont(0);
		       var f0 = param[1];
		       return cont([0, f0]);
		      },
		      0,
		      0,
		      cst_unstructured,
		      cst_Unstructured,
		      no_input_schema,
		      0],
		     0];
		 return caml_exact_trampoline_cps_call
		         (reason_schema_versioned,
		          schematic_version$129,
		          function(b){
		           var
		            res =
		              [11,
		               0,
		               [0,
		                [0,
		                 function(f0, cont){return cont([0, f0]);},
		                 function(param, cont){
		                  if(0 !== param[0]) return cont(0);
		                  var f0 = param[1];
		                  return cont([0, f0]);
		                 },
		                 1,
		                 0,
		                 cst_upgrade_required,
		                 cst_Upgrade_required,
		                 [0,
		                  0,
		                  0,
		                  [7,
		                   function(param, cont){
		                    var version = param[1];
		                    return cont(version);
		                   },
		                   function(version, cont){return cont([0, version, 0]);},
		                   [0,
		                    [0, 0, 0, 0, 0, cst_version, 0, 2, [0, schema$261], 0, 0],
		                    0]],
		                  0],
		                 0],
		                [0,
		                 [0,
		                  function(f0, cont){return cont([1, f0]);},
		                  function(param, cont){
		                   if(1 !== param[0]) return cont(0);
		                   var f0 = param[1];
		                   return cont([0, f0]);
		                  },
		                  0,
		                  0,
		                  cst_structured,
		                  cst_Structured,
		                  b,
		                  0],
		                 a]],
		               0];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$899[1][1],
		                    schematic_schema_version$62,
		                    res,
		                    function(a){
		                     letrec_function_context$899[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                Body = Handler[1],
		                Coding$0 = Handler[2],
		                Monad = Handler[3],
		                send_content_length = Handler[4];
		               function backoff(errors, uri, resp, cont){
		                function log(pv, v, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Logs[4],
		                          function(m, cont){
		                           return caml_trampoline_cps_call10
		                                   (m, 0, 0, qV, pp_v, uri, pp_retry, errors, pv, v, cont);
		                          },
		                          cont);
		                }
		                function default$(param, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (min$2,
		                          60,
		                          5 * errors | 0,
		                          function(v){
		                           function a(param, cont){
		                            return caml_exact_trampoline_cps_call(return$10, v, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (log,
		                                    function(a, cont){
		                                     return caml_exact_trampoline_cps_call$1(fmt$0, qW, a, cont);
		                                    },
		                                    v,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_bind$6, b, a, cont);
		                                    });
		                          });
		                }
		                var
		                 retry_after = "retry-after",
		                 match = get$7(resp[1], retry_after);
		                if(! match)
		                 return caml_exact_trampoline_cps_call(default$, dummy, cont);
		                var value = match[1];
		                caml_push_trap
		                 (function(exn){
		                   function a(param, cont){
		                    return caml_exact_trampoline_cps_call(default$, dummy, cont);
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (Logs[4],
		                            function(m, cont){
		                             return caml_trampoline_cps_call6
		                                     (m, 0, 0, qX, retry_after, value, cont);
		                            },
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol_bind$6, b, a, cont);
		                            });
		                  });
		                return caml_exact_trampoline_cps_call
		                        (of_string$3,
		                         value,
		                         function(v){
		                          function a(param, cont){
		                           return caml_exact_trampoline_cps_call(return$10, v, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$50,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     retry_after,
		     function(v$0){
		      return caml_exact_trampoline_cps_call$1
		              (log,
		               function(ppf, v, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (fmt$0,
		                         qY,
		                         ppf,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   v,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string,
		     ppf,
		     v$0,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (pp_print_string, ppf, " header)", cont);
		     });
		                                   });
		                         });
		               },
		               v,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol_bind$6,
		                         b,
		                         a,
		                         function(a){caml_pop_trap(); return cont(a);});
		               });
		     });
		                                   });
		                         });
		               }
		               function raw(timeout, headers, body, method, uri, cont){
		                function raw(errors, param, cont){
		                 function a(r, cont){
		                  var resp = r[1], headers = resp[1], a = resp[3];
		                  a:
		                  {
		                   b:
		                   if(typeof a === "number"){
		                    if(-732353682 <= a){
		                     if(65414873 !== a && 731537414 !== a && -732353681 <= a)
		                      break b;
		                    }
		                    else if(-957501398 !== a){
		                     if(-774758938 !== a) break b;
		                     if(get$7(headers, "X-Details")){a = 0; break a;}
		                     a = 1;
		                     break a;
		                    }
		                    a = 1;
		                    break a;
		                   }
		                   a = 0;
		                  }
		                  if(! a)
		                   return caml_trampoline_cps_call2(Handler[3][6], r, cont);
		                  function b(backoff, cont){
		                   var s = backoff;
		                   function a(param, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (raw, errors + 1 | 0, dummy, cont);
		                   }
		                   return caml_exact_trampoline_cps_call$2
		                           (value_exn,
		                            a3F,
		                            0,
		                            0,
		                            of_float_s(s),
		                            function(s){
		                             return caml_exact_trampoline_cps_call
		                                     (sleep,
		                                      s,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (symbol_bind$6, b, a, cont);
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (backoff,
		                           errors,
		                           uri,
		                           resp,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol_bind$6, a, b, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$3
		                         (Handler[5],
		                          timeout,
		                          headers,
		                          body,
		                          method,
		                          uri,
		                          function(b){
		                           return caml_trampoline_cps_call3(Handler[3][5], b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1(raw, 0, dummy, cont);
		               }
		               function pp$126(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, string_of_status, a, b, cont);
		               }
		               function map$54(error){var status = error[1]; return status;}
		               var
		                Status_success = [0, check$0],
		                Fetch_http =
		                  Make$9
		                   (Map_error
		                     (Check_status
		                       (Status_success,
		                        [0, Body, Coding$0, Monad, send_content_length, raw]),
		                      [0, map$54])),
		                Logs$3 = with_tag$0(component$0, "Controller.Document");
		               function crdt_append(doc, section, block, cont){
		                function b(pos){
		                 return caml_exact_trampoline_cps_call$1
		                         (insert_blocks, pos, [0, block, 0], cont);
		                }
		                if(! section) return b(-1);
		                var
		                 title = section[1][1],
		                 blocks = doc[1],
		                 searching = 1,
		                 prev = 0,
		                 n = 0,
		                 param = blocks;
		                for(;;){
		                 if(! param) break;
		                 var head = param[1], a = head[2];
		                 if(typeof a !== "number" && 6 === a[0]){
		                  var tail$0 = param[2], content = a[1][1];
		                  if(searching && content === title){
		                   var n$1 = n + 1 | 0, prev$1 = [0, [0, n, head]];
		                   searching = 0;
		                   prev = prev$1;
		                   n = n$1;
		                   param = tail$0;
		                   continue;
		                  }
		                  if(! searching) break;
		                 }
		                 var
		                  tail = param[2],
		                  n$0 = n + 1 | 0,
		                  prev$0 = [0, [0, n, head]];
		                 prev = prev$0;
		                 n = n$0;
		                 param = tail;
		                }
		                if(! prev)
		                 return caml_exact_trampoline_cps_call
		                         (Logs$3[6][4],
		                          function(m, cont){
		                           return caml_trampoline_cps_call5(m, 0, 0, a5K, title, cont);
		                          },
		                          function(match){return b(-1);});
		                var pos = prev[1][1];
		                return b(pos + 1 | 0);
		               }
		               function compare$172(a, param, cont){
		                var right = param[1], left = a[1];
		                return caml_exact_trampoline_cps_call$1
		                        (include$48[16], left, right, cont);
		               }
		               function sexp_of_t$140(block, cont){
		                return caml_trampoline_cps_call3
		                        (encode$7, schema$49, block, cont);
		               }
		               var
		                include$283 = Make$2([0, compare$172, sexp_of_t$140]),
		                equal$255 = include$283[7],
		                Diff = Make$27([0, equal$255]);
		               function merge_block(base, remote, local, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (equal$73,
		                         base,
		                         remote,
		                         function(a){
		                          return a
		                                  ? cont(local)
		                                  : caml_exact_trampoline_cps_call$1
		                                    (equal$73,
		                                     base,
		                                     local,
		                                     function(a){
		                                      if(a) return cont(remote);
		                                      function merge_field(equal, base, remote, local, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (equal,
		        base,
		        local,
		        function(a){return a ? cont(remote) : cont(local);});
		                                      }
		                                      if(typeof base === "number")
		                                       if(typeof remote === "number"){
		if(typeof local === "number") return cont(0);
		var local$0 = local;
		                                       }
		                                       else
		local$0 = local;
		                                      else
		                                       switch(base[0]){
		 case 0:
		  a = base[1];
		  if
		   (typeof remote === "number"
		    || ! (0 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(0 === local[0]){
		    var
		     local_content = local[1][1],
		     remote_content = remote[1][1],
		     base_content = a[1],
		     a =
		       base_content === local_content
		        ? remote_content
		        : local_content;
		    return cont([0, [0, a]]);
		   }
		   local$0 = remote;
		  }
		  break;
		 case 1:
		  a = base[1];
		  if
		   (typeof remote === "number"
		    || ! (1 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(1 === local[0]){
		    var
		     c = local[1],
		     local_depth = c[3],
		     local_content$0 = c[2],
		     local_list_type = c[1],
		     c = remote[1],
		     remote_depth = c[3],
		     remote_content$0 = c[2],
		     remote_list_type = c[1],
		     base_depth = a[3],
		     base_content$0 = a[2],
		     base_list_type = a[1],
		     d = base_depth === local_depth ? remote_depth : local_depth,
		     e =
		       base_content$0 === local_content$0
		        ? remote_content$0
		        : local_content$0;
		    return caml_exact_trampoline_cps_call$2
		            (merge_field,
		             equal_list_type,
		             base_list_type,
		             remote_list_type,
		             local_list_type,
		             function(a){return cont([1, [0, a, e, d]]);});
		   }
		   local$0 = remote;
		  }
		  break;
		 case 2:
		  a = base[1];
		  if
		   (typeof remote === "number"
		    || ! (2 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(2 === local[0]){
		    c = local[1];
		    var
		     local_depth$0 = c[3],
		     local_content$1 = c[2],
		     local_checked = c[1],
		     c = remote[1],
		     remote_depth$0 = c[3],
		     remote_content$1 = c[2],
		     remote_checked = c[1],
		     base_depth$0 = a[3],
		     base_content$1 = a[2],
		     base_checked = a[1],
		     a =
		       base_depth$0 === local_depth$0
		        ? remote_depth$0
		        : local_depth$0,
		     c =
		       base_content$1 === local_content$1
		        ? remote_content$1
		        : local_content$1,
		     b =
		       base_checked === local_checked
		        ? remote_checked
		        : local_checked;
		    return cont([2, [0, b, c, a]]);
		   }
		   local$0 = remote;
		  }
		  break;
		 case 3:
		  b = base[1];
		  if
		   (typeof remote === "number"
		    || ! (3 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(3 === local[0]){
		    a = local[1];
		    var
		     local_content$2 = a[2],
		     local_language = a[1],
		     a = remote[1],
		     remote_content$2 = a[2],
		     remote_language = a[1],
		     base_content$2 = b[2],
		     base_language = b[1],
		     b =
		       base_content$2 === local_content$2
		        ? remote_content$2
		        : local_content$2,
		     a =
		       base_language === local_language
		        ? remote_language
		        : local_language;
		    return cont([3, [0, a, b]]);
		   }
		   local$0 = remote;
		  }
		  break;
		 case 4:
		  b = base[1];
		  if
		   (typeof remote === "number"
		    || ! (4 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(4 === local[0]){
		    a = local[1];
		    var
		     local_icon = a[3],
		     local_content$3 = a[2],
		     local_background_color = a[1],
		     a = remote[1],
		     remote_icon = a[3],
		     remote_content$3 = a[2],
		     remote_background_color = a[1],
		     base_icon = b[3],
		     base_content$3 = b[2],
		     base_background_color = b[1];
		    return caml_exact_trampoline_cps_call$0
		            (equal_option,
		             equal$70,
		             base_icon,
		             local_icon,
		             function(c){
		              var
		               a = c ? remote_icon : local_icon,
		               b =
		                 base_content$3 === local_content$3
		                  ? remote_content$3
		                  : local_content$3;
		              return caml_exact_trampoline_cps_call$0
		                      (equal_option,
		                       equal$66,
		                       base_background_color,
		                       local_background_color,
		                       function(c){
		                        c = c ? remote_background_color : local_background_color;
		                        return cont([4, [0, c, b, a]]);
		                       });
		             });
		   }
		   local$0 = remote;
		  }
		  break;
		 case 5:
		  b = base[1];
		  if
		   (typeof remote === "number"
		    || ! (5 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(5 === local[0]){
		    var
		     local_content$4 = local[1][1],
		     remote_content$4 = remote[1][1],
		     base_content$4 = b[1],
		     b =
		       base_content$4 === local_content$4
		        ? remote_content$4
		        : local_content$4;
		    return cont([5, [0, b]]);
		   }
		   local$0 = remote;
		  }
		  break;
		 case 6:
		  b = base[1];
		  if
		   (typeof remote === "number"
		    || ! (6 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(6 === local[0]){
		    a = local[1];
		    var
		     local_retracted = a[3],
		     local_level = a[2],
		     local_content$5 = a[1],
		     a = remote[1],
		     remote_retracted = a[3],
		     remote_level = a[2],
		     remote_content$5 = a[1],
		     base_retracted = b[3],
		     base_level = b[2],
		     base_content$5 = b[1],
		     b =
		       base_retracted === local_retracted
		        ? remote_retracted
		        : local_retracted,
		     a = base_level === local_level ? remote_level : local_level,
		     c =
		       base_content$5 === local_content$5
		        ? remote_content$5
		        : local_content$5;
		    return cont([6, [0, c, a, b]]);
		   }
		   local$0 = remote;
		  }
		  break;
		 case 8:
		  c = base[1];
		  if
		   (typeof remote === "number"
		    || ! (8 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(8 === local[0]){
		    var
		     local_content$6 = local[1][1],
		     remote_content$6 = remote[1][1],
		     base_content$6 = c[1],
		     c =
		       base_content$6 === local_content$6
		        ? remote_content$6
		        : local_content$6;
		    return cont([8, [0, c]]);
		   }
		   local$0 = remote;
		  }
		  break;
		 case 10:
		  c = base[1];
		  if
		   (typeof remote === "number"
		    || ! (10 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(10 === local[0]){
		    b = local[1];
		    var
		     local_recurrence = b[3],
		     local_content$7 = b[2],
		     local_recurrent_task_id = b[1],
		     b = remote[1],
		     remote_recurrence = b[3],
		     remote_content$7 = b[2],
		     remote_recurrent_task_id = b[1],
		     base_recurrence = c[3],
		     base_content$7 = c[2],
		     base_recurrent_task_id = c[1];
		    return caml_exact_trampoline_cps_call$2
		            (merge_field,
		             equal$32,
		             base_recurrence,
		             remote_recurrence,
		             local_recurrence,
		             function(b){
		              var
		               a =
		                 base_content$7 === local_content$7
		                  ? remote_content$7
		                  : local_content$7;
		              return caml_exact_trampoline_cps_call$0
		                      (equal_option,
		                       equal$107,
		                       base_recurrent_task_id,
		                       local_recurrent_task_id,
		                       function(c){
		                        c = c ? remote_recurrent_task_id : local_recurrent_task_id;
		                        return cont([10, [0, c, a, b]]);
		                       });
		             });
		   }
		   local$0 = remote;
		  }
		  break;
		 case 11:
		  c = base[1];
		  if
		   (typeof remote === "number"
		    || ! (11 === remote[0] && ! (typeof local === "number")))
		   local$0 = remote;
		  else {
		   if(11 === local[0]){
		    b = local[1];
		    var
		     local_task = b[3],
		     local_content$8 = b[2],
		     local_checked$0 = b[1],
		     b = remote[1],
		     remote_task = b[3],
		     remote_content$8 = b[2],
		     remote_checked$0 = b[1],
		     base_content$8 = c[2],
		     base_checked$0 = c[1],
		     c = first_some(local_task, remote_task),
		     b =
		       base_content$8 === local_content$8
		        ? remote_content$8
		        : local_content$8,
		     a =
		       base_checked$0 === local_checked$0
		        ? remote_checked$0
		        : local_checked$0;
		    return cont([11, [0, a, b, c]]);
		   }
		   local$0 = remote;
		  }
		  break;
		 default: local$0 = remote;
		                                       }
		                                      return cont(local$0);
		                                     });
		                         });
		               }
		               function merge$5(base, remote, local, cont){
		                var
		                 a = [0, attr$0(cst_local, local, schema$192), 0],
		                 a = [0, attr$0(cst_base, base, schema$192), a];
		                return caml_exact_trampoline_cps_call
		                        (attrs,
		                         [0, attr$0(cst_remote, remote, schema$192), a],
		                         function(tags){
		                          return caml_exact_trampoline_cps_call$1
		                                  (equal$75,
		                                   base,
		                                   remote,
		                                   function(a){
		                                    return a
		    ? caml_exact_trampoline_cps_call
		      (Logs$3[6][6],
		       function(m, cont){
		        return caml_trampoline_cps_call4(m, 0, [0, tags], a5L, cont);
		       },
		       function(match){return cont(local);})
		    : caml_exact_trampoline_cps_call$1
		      (equal$75,
		       base,
		       local,
		       function(a){
		        return a
		                ? caml_exact_trampoline_cps_call
		                  (Logs$3[6][6],
		                   function(m, cont){
		                    return caml_trampoline_cps_call4(m, 0, [0, tags], a5M, cont);
		                   },
		                   function(match){return cont(remote);})
		                : caml_exact_trampoline_cps_call
		                  (Logs$3[6][6],
		                   function(m, cont){
		                    return caml_trampoline_cps_call4(m, 0, [0, tags], a5N, cont);
		                   },
		                   function(match){
		                    function blocks(param, cont){
		                     var blocks = param[1];
		                     return caml_exact_trampoline_cps_call
		                             (deconstruct,
		                              blocks,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (map$11,
		a,
		function(block, cont){return cont([0, block[1], block]);},
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (include$48[27][120],
		          a,
		          function(b, param, cont){return cont(b);},
		          cont);
		});
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (blocks,
		                             local,
		                             function(local_blocks){
		                              return caml_exact_trampoline_cps_call
		                                      (blocks,
		                                       remote,
		                                       function(remote_blocks){
		return caml_exact_trampoline_cps_call
		        (blocks,
		         base,
		         function(base_blocks){
		          return caml_exact_trampoline_cps_call
		                  (keys$0,
		                   remote_blocks,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (include$48[26][70],
		                             a,
		                             function(remote_ids){
		                              return caml_exact_trampoline_cps_call
		                                      (keys$0,
		                                       local_blocks,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (include$48[26][70],
		         a,
		         function(local_ids){
		          return caml_exact_trampoline_cps_call$1
		                  (union$0,
		                   remote_ids,
		                   local_ids,
		                   function(ids){
		                    return caml_exact_trampoline_cps_call$2
		                            (to_sequence$0,
		                             0,
		                             0,
		                             0,
		                             ids,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (filter_map$1,
		                                       a,
		                                       function(id, cont){
		return caml_exact_trampoline_cps_call$1
		        (find_packed_by_id,
		         base_blocks,
		         id,
		         function(match){
		          return caml_exact_trampoline_cps_call$1
		                  (find_packed_by_id,
		                   remote_blocks,
		                   id,
		                   function(match$0){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             local_blocks,
		                             id,
		                             function(match$1){
		                              if(! match$0){
		                               if(! match$1) return cont(0);
		                               var local$1 = match$1[1];
		                               return cont([0, [0, id, local$1]]);
		                              }
		                              if(! match$1){
		                               var remote$0 = match$0[1];
		                               return cont([0, [0, id, remote$0]]);
		                              }
		                              if(match){
		                               var
		                                local = match$1[1][2],
		                                remote = match$0[1][2],
		                                base = match[1][2];
		                               return caml_exact_trampoline_cps_call$0
		                                       (merge_block,
		base,
		remote,
		local,
		function(a){return cont([0, [0, id, [0, id, a]]]);});
		                              }
		                              var local$0 = match$1[1];
		                              return cont([0, [0, id, local$0]]);
		                             });
		                   });
		         });
		                                       },
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (include$48[27][120],
		         a,
		         function(b, param, cont){return cont(b);},
		         function(merged_blocks){
		          return caml_exact_trampoline_cps_call
		                  (to_array,
		                   base[1],
		                   function(base){
		                    return caml_exact_trampoline_cps_call
		                            (to_array,
		                             remote[1],
		                             function(remote){
		                              return caml_exact_trampoline_cps_call
		                                      (to_array,
		                                       local[1],
		                                       function(local){
		return caml_exact_trampoline_cps_call$1
		        (Diff[1],
		         base,
		         local,
		         function(a){
		          var remote_diff = itemize(a);
		          return caml_exact_trampoline_cps_call$1
		                  (Diff[1],
		                   base,
		                   remote,
		                   function(b){
		                    var
		                     local_diff = itemize(b),
		                     acc = [0, include$48[26][67], 0];
		                    function a(acc, param){
		                     var local_diff = param[2], remote_diff = param[1];
		                     function add(id, param, cont){
		                      var blocks = param[2], marks = param[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (mem$3,
		                               marks,
		                               id,
		                               function(match){
		                                return caml_exact_trampoline_cps_call$1
		(find_packed_by_id,
		 merged_blocks,
		 id,
		 function(match$0){
		  if(! match && match$0){
		   var block = match$0[1], a = [0, block, blocks];
		   return caml_exact_trampoline_cps_call$1
		           (add$4, marks, id, function(b){return cont([0, b, a]);});
		  }
		  return cont([0, marks, blocks]);
		 });
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call
		                             (next,
		                              remote_diff,
		                              function(match){
		                               return caml_exact_trampoline_cps_call
		                                       (next,
		local_diff,
		function(b){
		 function h(a){return cont([0, a]);}
		 a:
		 {
		  b:
		  {
		   if(match){
		    var f = match[1], d = f[1];
		    switch(d[0]){
		      case 0:
		       if(! b) break b;
		       var
		        c = b[1],
		        e = c[1],
		        remote_diff$0 = f[2],
		        kept = d[2],
		        block_remote = kept[1];
		       switch(e[0]){
		         case 0:
		          var local_diff$0 = c[2], block_local = e[2][1];
		          return caml_exact_trampoline_cps_call$1
		                  (include$48[15],
		                   block_remote,
		                   block_local,
		                   function(b){
		                    if(b){
		                     var param = [0, remote_diff$0, local_diff$0];
		                     return caml_exact_trampoline_cps_call$1
		                             (add,
		                              block_remote,
		                              acc,
		                              function(acc){
		                               return caml_exact_trampoline_call2(a, acc, param);
		                              });
		                    }
		                    b = caml_pop_trap();
		                    return b
		                            (caml_maybe_attach_backtrace([0, Assert_failure, a5O], 1));
		                   });
		         case 2:
		          var
		           local_diff$2 = c[2],
		           kept$0 = kept,
		           remote_diff$1 = remote_diff$0,
		           removed = e[1];
		          break;
		         default: break a;
		       }
		       break;
		      case 1:
		       var
		        block_remote$0 = d[1][1],
		        g =
		          function(){
		           var
		            remote_diff = f[2],
		            param = [0, remote_diff, local_diff];
		           return caml_exact_trampoline_cps_call$1
		                   (add,
		                    block_remote$0,
		                    acc,
		                    function(acc){
		                     return caml_exact_trampoline_call2(a, acc, param);
		                    });
		          };
		       if(! b) return g();
		       b = b[1];
		       d = b[1];
		       var remote_diff$2 = f[2];
		       if(1 !== d[0]) return g();
		       var local_diff$3 = b[2], block_local$0 = d[1][1];
		       return caml_exact_trampoline_cps_call$1
		               (include$48[15],
		                block_remote$0,
		                block_local$0,
		                function(b){
		                 if(! b) return g();
		                 var param = [0, remote_diff$2, local_diff$3];
		                 return caml_exact_trampoline_cps_call$1
		                         (add,
		                          block_local$0,
		                          acc,
		                          function(acc){
		                           return caml_exact_trampoline_call2(a, acc, param);
		                          });
		                });
		      default:
		       if(! b) break b;
		       e = b[1];
		       c = e[1];
		       var remote_diff$3 = f[2], block_remote$1 = d[1];
		       switch(c[0]){
		         case 0:
		          local_diff$2 = e[2];
		          kept$0 = c[2];
		          remote_diff$1 = remote_diff$3;
		          removed = block_remote$1;
		          break;
		         case 2:
		          var local_diff$4 = e[2], block_local$1 = c[1];
		          return caml_exact_trampoline_cps_call$1
		                  (include$48[15],
		                   block_remote$1[1],
		                   block_local$1[1],
		                   function(b){
		                    if(b)
		                     return caml_exact_trampoline_call2
		                             (a, acc, [0, remote_diff$3, local_diff$4]);
		                    b = caml_pop_trap();
		                    return b
		                            (caml_maybe_attach_backtrace([0, Assert_failure, a5Q], 1));
		                   });
		         default: break a;
		       }
		    }
		    return caml_exact_trampoline_cps_call$1
		            (include$48[15],
		             removed[1],
		             kept$0[1],
		             function(b){
		              if(b)
		               return caml_exact_trampoline_call2
		                       (a, acc, [0, remote_diff$1, local_diff$2]);
		              b = caml_pop_trap();
		              return b
		                      (caml_maybe_attach_backtrace([0, Assert_failure, a5P], 1));
		             });
		   }
		   if(! b)
		    return caml_exact_trampoline_cps_call
		            (of_rev_keys, acc[2], h);
		   if(1 === b[1][1][0]) break a;
		  }
		  return caml_exact_trampoline_cps_call
		          (failwith, "invalid merge", h);
		 }
		 c = b[1];
		 var
		  local_diff$1 = c[2],
		  id = c[1][1][1],
		  param = [0, remote_diff, local_diff$1];
		 return caml_exact_trampoline_cps_call$1
		         (add,
		          id,
		          acc,
		          function(acc){
		           return caml_exact_trampoline_call2(a, acc, param);
		          });
		});
		                              });
		                    }
		                    return a(acc, [0, remote_diff, local_diff]);
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		       });
		                                   });
		                         });
		               }
		               caml_callback(M$3, [[0, comparator$14, schema_versioned$102]]);
		               caml_callback(M$2, [[0, comparator$11, schema_versioned$1]]);
		               caml_callback(M$3, [[0, comparator$11, schema_versioned$1]]);
		               var
		                schematic_cache$867 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$900 = [];
		               caml_update_dummy
		                (letrec_function_context$900, [0, schematic_cache$867]);
		               var schematic_schema_version$31 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$900[1][1],
		                    schematic_schema_version$31]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$900[1][1],
		                             schematic_schema_version$31,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$900[1][1],
		schematic_schema_version$31,
		schematic_self,
		function(a){
		 letrec_function_context$900[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var instrument = param[1];
		      return cont([0, instrument]);
		     },
		     function(param, cont){
		      var instrument = param[1];
		      return cont([0, instrument, 0]);
		     },
		     [0,
		      [0,
		       a5R,
		       0,
		       0,
		       0,
		       "instrument",
		       0,
		       2,
		       [0, bool_schema],
		       0,
		       0],
		      0]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$900[1][1],
		          schematic_schema_version$31,
		          res,
		          function(a){
		           letrec_function_context$900[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_Device_patch = "Device_patch",
		                cst_Last_scheduling_set = "Last_scheduling_set",
		                letrec_function_context$901 = [];
		               function mutation_operation_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_kind_schema_ve, cont){
		                                    function descriptor(schematic_param_kind_schema_ve, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$901[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fixpoint,
		                 function(schematic_self, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           letrec_function_context$901[1][1],
		                           schematic_schema_version,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context$901[1][1],
		                                      schematic_schema_version,
		                                      schematic_self,
		                                      function(a){
		                                       letrec_function_context$901[1][1] = a;
		                                       return caml_exact_trampoline_cps_call
		       (schema_versioned$1,
		        schematic_version,
		        function(b){
		         var
		          a =
		            [0,
		             [0,
		              function(f0, cont){return cont([3, f0]);},
		              function(param, cont){
		               if(3 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              "last_scheduling_set",
		              cst_Last_scheduling_set,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var date = param[1];
		                 return cont(date);
		                },
		                function(date, cont){return cont([0, date, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_date, 0, 3, [0, b], 0, 0], 0]],
		               0],
		              0],
		             0];
		         return caml_exact_trampoline_cps_call
		                 (Patch$0[2],
		                  schematic_version,
		                  function(c){
		                   var
		                    b = [0, [0, 0, 0, 0, 0, cst_patch, 0, 2, [0, c], 0, 0], 0];
		                   return caml_exact_trampoline_cps_call
		                           (Device[4],
		                            schematic_version,
		                            function(c){
		                             var
		                              res =
		                                [11,
		                                 a5S,
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(0 !== param[0]) return cont(0);
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   },
		                                   1,
		                                   0,
		                                   "device_patch",
		                                   cst_Device_patch,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var patch = param[2][1], id = param[1];
		                                      return cont([0, id, patch]);
		                                     },
		                                     function(param, cont){
		                                      var patch = param[2], id = param[1];
		                                      return cont([0, id, [0, patch, 0]]);
		                                     },
		                                     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], b]],
		                                    0],
		                                   0],
		                                  a],
		                                 0];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      letrec_function_context$901[1][1],
		                                      schematic_schema_version,
		                                      res,
		                                      function(a){
		                                       letrec_function_context$901[1][1] = a;
		                                       return cont(res);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            var schema = match[1];
		                            return cont(schema);
		                           });
		                 },
		                 cont);
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    }
		                                    var
		                                     schematic_schema_id = match$260[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_kind,
		 schematic_param_kind_schema_ve,
		 function(schematic_param_kind_schema_ve, cont){
		  return caml_exact_trampoline_cps_call
		          (descriptor,
		           dummy,
		           function(a){return cont([0, schematic_schema_id, a]);});
		 }]];
		                                    return caml_exact_trampoline_cps_call
		    (descriptor,
		     schematic_param_kind_schema_ve,
		     function(a){
		      var parametric = schematic_parametric[1];
		      return caml_exact_trampoline_cps_call
		              (of_parametric,
		               parametric,
		               function(match){
		                function b(b){return cont([0, , 0, a]);}
		                if(! match) return b();
		                var name = match[1];
		                return caml_exact_trampoline_cps_call(to_id, name, b);
		               });
		     });
		                                   });
		                         });
		               }
		               var schematic_cache$868 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$901, [0, schematic_cache$868]);
		               function pp_operation(f, param, cont){
		                switch(param[0]){
		                  case 0:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, cst_Device_patch, cont);
		                  case 1:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, "Device_sync", cont);
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, "Devices_sync", cont);
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (pp_print_string, f, cst_Last_scheduling_set, cont);
		                }
		               }
		               function mutation_operation_schema
		               (schematic_param_kind_schema_ve, cont){
		                return caml_exact_trampoline_cps_call
		                        (mutation_operation_schema_vers,
		                         function(param, cont){return cont(0);},
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (a,
		                                   schematic_param_kind_schema_ve,
		                                   function(a){return cont([0, a5U, a[2], a[3], 0]);});
		                         });
		               }
		               function pp_month_short(ppf, month, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$18,
		                         month,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (sub_fun,
		                                   a,
		                                   0,
		                                   3,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_string, ppf, a, cont);
		                                   });
		                         });
		               }
		               function make$137(settings){
		                if(settings[1])
		                 var
		                  daytime =
		                    function(a, b, cont){
		                     return caml_exact_trampoline_cps_call$7
		                             (pp_opt, a5X, a5W, a5V, dummy, a, b, cont);
		                    };
		                else
		                 daytime =
		                  function(a, b, cont){
		                   return caml_exact_trampoline_cps_call$7
		                           (pp_opt, a57, a56, 0, dummy, a, b, cont);
		                  };
		                function date(f, param, cont){
		                 var year = param[3], month = param[2], day = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(f),
		                          a5Y,
		                          function(a){
		                           return caml_trampoline_cps_call6
		                                   (a, pp$11, month, nth$3, day, year, cont);
		                          });
		                }
		                function date_range(f, param, cont){
		                 var end = param[2], start = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (today,
		                          dummy,
		                          function(today){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$69,
		                                    today[2],
		                                    end[2],
		                                    function(i){
		                                     if(i){
		                                      var
		                                       b =
		 function(e){
		  var a = end[1], b = end[2], c = start[1], d = start[2];
		  return caml_exact_trampoline_cps_call
		          (fprintf$0(f),
		           a50,
		           function(e){
		            return caml_trampoline_cps_call7
		                    (e, pp_month_short, d, c, pp_month_short, b, a, cont);
		           });
		 };
		                                      if(today[3] === start[3]) return b(0);
		                                      var c = start[3];
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(f),
		       a5Z,
		       function(a){return caml_trampoline_cps_call2(a, c, b);});
		                                     }
		                                     if(today[3] === start[3]){
		                                      var e = end[1], g = start[1], h = start[2];
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(f),
		       a53,
		       function(a){
		        return caml_trampoline_cps_call5
		                (a, pp_month_short, h, g, e, cont);
		       });
		                                     }
		                                     function a(d){
		                                      var a = end[1], b = start[1], c = start[2];
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(f),
		       a52,
		       function(d){
		        return caml_trampoline_cps_call5
		                (d, pp_month_short, c, b, a, cont);
		       });
		                                     }
		                                     if(today[3] === start[3]) return a();
		                                     var d = start[3];
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(f),
		      a51,
		      function(b){return caml_trampoline_cps_call2(b, d, a);});
		                                    });
		                          });
		                }
		                function date_relative(f, date, cont){
		                 return caml_exact_trampoline_cps_call
		                         (today,
		                          dummy,
		                          function(reference){
		                           var a = to_int$3(reference), diff = to_int$3(date) - a | 0;
		                           if(0 === diff)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, f, cst_today, cont);
		                           if(-1 === diff)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, f, cst_yesterday, cont);
		                           if(1 === diff)
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_print_string, f, cst_tomorrow, cont);
		                           if(0 > diff && -7 <= diff)
		                            return caml_exact_trampoline_cps_call
		                                    (weekday,
		                                     date,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (fprintf$0(f),
		       mi,
		       function(b){
		        return caml_trampoline_cps_call3(b, _11, a, cont);
		       });
		                                     });
		                           if(0 < diff && 6 >= diff)
		                            return caml_exact_trampoline_cps_call
		                                    (weekday,
		                                     date,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$0
		      (of_to_string, to_string$17, f, a, cont);
		                                     });
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_human$0, f, date, cont);
		                          });
		                }
		                function time_relative(f, t, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_time$0,
		                          timezone_local,
		                          t,
		                          function(date){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_time$1,
		                                    timezone_local,
		                                    t,
		                                    function(dt){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(f),
		      a54,
		      function(a){
		       return caml_trampoline_cps_call5
		               (a, date_relative, date, daytime, dt, cont);
		      });
		                                    });
		                          });
		                }
		                function time(f, t, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_time$0,
		                          timezone_local,
		                          t,
		                          function(date$0){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_time$1,
		                                    timezone_local,
		                                    t,
		                                    function(dt){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(f),
		      a55,
		      function(a){
		       return caml_trampoline_cps_call5
		               (a, date, date$0, daytime, dt, cont);
		      });
		                                    });
		                          });
		                }
		                function week(f, week, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_date$2,
		                          week,
		                          function(start){
		                           return caml_exact_trampoline_cps_call$1
		                                   (add_days,
		                                    start,
		                                    6,
		                                    function(end){
		                                     return caml_exact_trampoline_cps_call$1
		     (date_range, f, [0, start, end], cont);
		                                    });
		                          });
		                }
		                return [0,
		                        date,
		                        date_range,
		                        date_relative,
		                        daytime,
		                        settings,
		                        time_relative,
		                        time,
		                        week];
		               }
		               o
		                ([0,
		                  symbol_bind$9,
		                  symbol_map$7,
		                  Let_syntax$5,
		                  ,
		                  bind$12,
		                  return$13,
		                  map$25]);
		               function meeting_emails_set(event, cont){
		                var t = event[9][3];
		                return 1 < t[3]
		                        ? caml_exact_trampoline_cps_call
		                          (keys$0,
		                           event[9][3],
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (of_list$2,
		                                     [0, comparator$2],
		                                     a,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$9, a, cont);
		                                     });
		                           })
		                        : cont(0);
		               }
		               function completed_now_time
		               (now, today, timezone, is_allocation, event, cont){
		                var match = event[9][10];
		                if(2 !== match[0]) return cont([0, [0, today]]);
		                var
		                 end = match[2],
		                 start = match[1],
		                 span = symbol$58(now, end),
		                 zero = of_int_s(0);
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$72,
		                         span,
		                         zero,
		                         function(a){
		                          var end_to_now_abs = a ? symbol$56(span) : span;
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$72,
		                                   end_to_now_abs,
		                                   hours(1),
		                                   function(a){
		                                    if(a && is_allocation) return cont(0);
		                                    var minus_duration = symbol$58(start, end);
		                                    return caml_exact_trampoline_cps_call$1
		    (of_time$1,
		     timezone,
		     now,
		     function(match){
		      var minutes = match[2], hours = match[1];
		      return caml_exact_trampoline_cps_call$1
		              (symbol$23,
		               minutes,
		               15,
		               function(a){
		                var t = [0, hours, minutes - a | 0, 0];
		                return caml_exact_trampoline_cps_call
		                        (of_tuple$1,
		                         t,
		                         function(match){
		                          function a(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (to_time$2,
		                                    timezone,
		                                    today,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (ok_or_failwith,
		      a,
		      function(end_rounded){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$78,
		                end_rounded,
		                minus_duration,
		                function(a){return cont([0, [2, a, end_rounded]]);});
		      });
		                                    });
		                          }
		                          if(0 !== match[0])
		                           return caml_exact_trampoline_cps_call$3
		                                   (create$9,
		                                    here,
		                                    0,
		                                    "invalid daytime",
		                                    t,
		                                    sexp_of_tuple,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call(raise, b, a);
		                                    });
		                          var r = match[1];
		                          return a(r);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function pp_start(opt, locale, f, a, cont){
		                var relative = opt ? opt[1] : 1;
		                if(2 === a[0]){
		                 var start = a[1], a = relative ? locale[6] : locale[7];
		                 return caml_trampoline_cps_call3(a, f, start, cont);
		                }
		                var date = a[1], a = relative ? locale[3] : locale[1];
		                return caml_trampoline_cps_call3(a, f, date, cont);
		               }
		               function symbol$229(inc, cutoff){
		                set_cutoff(inc, [1, cutoff]);
		                return inc;
		               }
		               function symbol$230(inc, info, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$1,
		                         info,
		                         function(a){set_user_info(inc, [0, a]); return cont(inc);});
		               }
		               function map_old(i, f, cont){
		                var old = [0, 0];
		                function f$0(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (f,
		                          old[1],
		                          a,
		                          function(b){old[1] = [0, [0, a, b]]; return cont(b);});
		                }
		                return caml_exact_trampoline_cps_call$1(map$41, i, f$0, cont);
		               }
		               var
		                schematic_cache$869 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$902 = [];
		               caml_update_dummy
		                (letrec_function_context$902, [0, schematic_cache$869]);
		               var schematic_schema_version$32 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$902[1][1],
		                    schematic_schema_version$32]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$902[1][1],
		                             schematic_schema_version$32,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$902[1][1],
		schematic_schema_version$32,
		schematic_self,
		function(a){
		 letrec_function_context$902[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       directory = a[2][1],
		       people_list = a[1],
		       contact = param[1];
		      return cont([0, contact, people_list, directory]);
		     },
		     function(param, cont){
		      var
		       directory = param[3],
		       people_list = param[2],
		       contact = param[1];
		      return cont
		              ([0, contact, [0, people_list, [0, directory, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_contact,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "people_list",
		        0,
		        3,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_directory,
		         0,
		         3,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$902[1][1],
		          schematic_schema_version$32,
		          res,
		          function(a){
		           letrec_function_context$902[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function locale(param, cont){
		                var locale = param[3];
		                return caml_exact_trampoline_cps_call
		                        (observer_value_exn, locale, cont);
		               }
		               function read$0(param, f, cont){
		                var values = param[5], incremental = param[1];
		                return caml_exact_trampoline_cps_call
		                        (f, [0, incremental, values], cont);
		               }
		               function task_bindings$0(t, cont){
		                var values = t[5], task_bindings_value = values[37];
		                return caml_exact_trampoline_cps_call
		                        (observer_value_exn, task_bindings_value, cont);
		               }
		               function profiles(t, cont){
		                var values = t[5], profiles_value = values[27];
		                return caml_exact_trampoline_cps_call
		                        (observer_value_exn, profiles_value, cont);
		               }
		               function profile_google(t, identity, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[3];
		                function a(profile, cont){
		                 var match = profile[3];
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (fail_result,
		                           a58,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, pp$43, identity, cont);
		                           });
		                 var google = match[1];
		                 return cont([0, [0, profile, google]]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_google_id,
		                         identity,
		                         function(identity){
		                          return caml_exact_trampoline_cps_call
		                                  (profiles,
		                                   t,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     b,
		     identity,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$140,
		               function(c){
		                return caml_trampoline_cps_call3
		                        (c,
		                         pp$75,
		                         identity,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$, of_option(b, [0, 9943782, c]), a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function profile_main(t, cont){
		                var values = t[5], profile_value = values[25];
		                return caml_exact_trampoline_cps_call
		                        (observer_value_exn, profile_value, cont);
		               }
		               var
		                schematic_cache$870 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$903 = [];
		               caml_update_dummy
		                (letrec_function_context$903, [0, schematic_cache$870]);
		               var
		                schematic_schema_version$33 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$903[1][1],
		                     schematic_schema_version$33]);
		               if(e)
		                var schema$244 = e[1], descriptor$53 = schema$244;
		               else
		                descriptor$53 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$903[1][1],
		                              schematic_schema_version$33,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$903[1][1],
		 schematic_schema_version$33,
		 schematic_self,
		 function(a){
		  letrec_function_context$903[1][1] = a;
		  var
		   res =
		     [11,
		      a5$,
		      [0,
		       [0,
		        function(f0, cont){return cont([0, f0]);},
		        function(param, cont){
		         if(! param) return cont(0);
		         var f0 = param[1];
		         return cont([0, f0]);
		        },
		        1,
		        0,
		        "open_url",
		        "Open_url",
		        [0,
		         0,
		         0,
		         [7,
		          function(param, cont){var url = param[1]; return cont(url);},
		          function(url, cont){return cont([0, url, 0]);},
		          [0,
		           [0, 0, 0, 0, 0, cst_url, 0, 2, [0, schema$262], 0, 0],
		           0]],
		         0],
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(0);},
		         function(param, cont){return param ? cont(0) : cont(a5_);},
		         0,
		         0,
		         "reauthenticate",
		         "Reauthenticate",
		         [0,
		          0,
		          0,
		          [7,
		           function(param, cont){return cont(0);},
		           function(param, cont){return cont(0);},
		           0],
		          0],
		         0],
		        0]],
		      0];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$903[1][1],
		           schematic_schema_version$33,
		           res,
		           function(a){
		            letrec_function_context$903[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                effect_schema = [0, a59, 0, descriptor$53, 0],
		                Impl$3 = caml_callback(init_mod, [a6b, a6a]);
		               caml_callback(update_mod, [a6c, Impl$3, [0]]);
		               function handle(effects, effect, cont){return cont([0, effect, effects]);
		               }
		               function replaced_with(effects, Effects, init, cont){
		                function a(t, init){
		                 if(! t) return cont(init);
		                 var l = t[2], effect = t[1];
		                 return caml_trampoline_cps_call3
		                         (Effects[1],
		                          init,
		                          effect,
		                          function(init){
		                           return caml_exact_trampoline_call2(a, l, init);
		                          });
		                }
		                return a(effects, init);
		               }
		               function set_f(effects, f, cont){
		                function handle(param, effect, cont){
		                 return caml_trampoline_cps_call2(f, effect, cont);
		                }
		                function replaced_with(a, param, t, cont){return cont(t);}
		                var
		                 match = effects[1][1],
		                 previous_t = match[2],
		                 Previous_effects = match[1],
		                 impl = [0, handle, replaced_with];
		                return caml_trampoline_cps_call4
		                        (Previous_effects[2],
		                         previous_t,
		                         impl,
		                         0,
		                         function(t){effects[1] = [0, [0, impl, t]]; return cont();});
		               }
		               g
		                ([0,
		                  symbol_bind$5,
		                  symbol_map$5,
		                  ,
		                  bind$8,
		                  return$9,
		                  map$17,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$3]);
		               var
		                open$13 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_bind$23 = open$13[1],
		                let$20 = open$13[3],
		                let$21 = open$13[4];
		               function push_lwt(t, opt, event, cont){
		                var extra_attrs = opt ? opt[1] : 0;
		                return caml_trampoline_cps_call3
		                        (let$20,
		                         t[1],
		                         function(metrics, cont){
		                          var metric = make$57(0, [0, extra_attrs], event);
		                          function a(a, cont){
		                           if(0 === a[0])
		                            return caml_trampoline_cps_call2(return$12, 0, cont);
		                           var e = a[1], a = e[2];
		                           if(typeof a === "number" && -610669292 === a)
		                            return caml_trampoline_cps_call2(return$12, 0, cont);
		                           function msgf(m, cont){
		                            function a(a, b, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (of_to_string, string_of_status, a, b, cont);
		                            }
		                            function b(b, cont){return cont(pp_reason$0(a, b));}
		                            function c(a, c, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (pp$24, b, a, c, cont);
		                            }
		                            return caml_exact_trampoline_cps_call
		                                    (event_name$0,
		                                     metric[2],
		                                     function(a){
		                                      return caml_trampoline_cps_call7
		      (m, 0, 0, a6d, a, c, e, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$2
		                                   (kmsg$0, kunit$0, 0, 1, msgf, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (push_metrics,
		                                   metrics,
		                                   metric,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(symbol_bind$23, b, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function push_dont_wait$0(t, opt, event, cont){
		                var extra_attrs = opt ? opt[1] : 0;
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         extra_attrs,
		                         function(param, cont){
		                          var v = param[2], k = param[1];
		                          return cont([0, k, [0, -976970511, v]]);
		                         },
		                         function(extra_attrs){
		                          var metrics = t[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (lwt_async,
		                                   a6e,
		                                   function(param, cont){
		                                    return caml_trampoline_cps_call3
		    (let$21,
		     metrics,
		     function(metrics, cont){
		      return caml_exact_trampoline_cps_call$2
		              (push_dont_wait, metrics, 0, [0, extra_attrs], event, cont);
		     },
		     cont);
		                                   },
		                                   cont);
		                         });
		               }
		               var
		                open$14 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_map$21 = open$14[2],
		                let$22 = open$14[14],
		                Logs$4 = with_tag$0(component$0, "Controller.Auth");
		               function device(V, cont){
		                return caml_trampoline_cps_call2(V[1][6], V[2], cont);
		               }
		               function api$1(V, cont){
		                return caml_trampoline_cps_call2(V[1][3], V[2], cont);
		               }
		               function id$37(V, cont){
		                return caml_trampoline_cps_call2(V[1][8], V[2], cont);
		               }
		               function reauthenticate(V, cont){
		                function a(param, cont){
		                 return caml_trampoline_cps_call3
		                         (symbol_map$21, wait()[1], of_string$14, cont);
		                }
		                return caml_trampoline_cps_call2
		                        (V[1][14],
		                         V[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$22, b, a, cont);
		                         });
		               }
		               function refresh(V, cont){
		                return caml_trampoline_cps_call2(V[1][15], V[2], cont);
		               }
		               function user_id(V, cont){
		                return caml_trampoline_cps_call2(V[1][18], V[2], cont);
		               }
		               var
		                client_secret =
		                  rev$0("IccxiUYStv1HFv9UtWLdyjrz27gANgEQDFumdWA4p0S"),
		                open$15 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_bind$24 = open$15[1],
		                let$23 = open$15[3],
		                let$24 = open$15[4],
		                let$25 = open$15[14],
		                and$5 = open$15[15],
		                connecting_guard = create$21(),
		                reconnected = create$19();
		               function backoff_of_iteration_count(count){
		                var
		                 seconds =
		                   5 < count ? 25 : caml_mul(count - 1 | 0, count - 1 | 0);
		                return of_int_s(seconds);
		               }
		               function offline(name, auth, param, f, cont){
		                var set_online = param[4], is_online = param[2];
		                function wake(r, cont){
		                 function a(param, cont){
		                  return caml_trampoline_cps_call2(return$12, r, cont);
		                 }
		                 return caml_trampoline_cps_call2
		                         (is_online,
		                          0,
		                          function(d){
		                           function b(b){
		                            return caml_exact_trampoline_cps_call$1(let$25, b, a, cont);
		                           }
		                           if(d) return caml_trampoline_cps_call2(return$13, 0, b);
		                           function c(param, cont){
		                            function f(param, cont){
		                             function a(param, cont){
		                              return caml_trampoline_cps_call2
		                                      (set_online,
		                                       1,
		                                       function(match){
		return caml_exact_trampoline_cps_call$1
		        (broadcast,
		         reconnected,
		         0,
		         function(a){
		          return caml_trampoline_cps_call2(return$13, a, cont);
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (pause,
		                                      dummy,
		                                      function(b){
		                                       return caml_trampoline_cps_call3(let$23, b, a, cont);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (with_lock, connecting_guard, f, cont);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (Lwt[5],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call5(m, 0, 0, a6g, name, cont);
		                                    },
		                                    function(a){
		                                     return caml_trampoline_cps_call3(let$23, a, c, b);
		                                    });
		                          });
		                }
		                function loop(count, cont){
		                 function a(result, cont){
		                  a:
		                  if(0 !== result[0]){
		                   var error = result[1];
		                   if(typeof error === "number"){
		                    if(647871990 > error){
		                     var
		                      b =
		                        function(param, cont){
		                         return caml_exact_trampoline_cps_call
		                                 (loop, count + 1 | 0, cont);
		                        },
		                      f =
		                        function(param, cont){
		                         function a(param, cont){
		                          var backoff = backoff_of_iteration_count(count);
		                          function a(param, cont){return cont(0);}
		                          function b(param, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (wait$0,
		                                    [0, connecting_guard],
		                                    reconnected,
		                                    function(b){
		                                     var a = [0, b, 0];
		                                     return caml_exact_trampoline_cps_call
		     (sleep,
		      backoff,
		      function(b){
		       return caml_exact_trampoline_cps_call(pick, [0, b, a], cont);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (Lwt[5],
		                                   function(m, cont){
		                                    return caml_trampoline_cps_call7
		    (m, 0, 0, a6i, name, pp$12, backoff, cont);
		                                   },
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (let$23,
		     c,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$24, b, a, cont);
		     });
		                                   });
		                         }
		                         return caml_trampoline_cps_call2
		                                 (is_online,
		                                  0,
		                                  function(d){
		                                   function b(b){
		                                    return caml_trampoline_cps_call3(let$23, b, a, cont);
		                                   }
		                                   if(! d) return caml_trampoline_cps_call2(return$12, 0, b);
		                                   function c(param, cont){
		                                    return caml_trampoline_cps_call2
		    (set_online,
		     0,
		     function(match){
		      return caml_exact_trampoline_cps_call
		              (Lwt[5],
		               function(m, cont){
		                return caml_trampoline_cps_call5(m, 0, 0, a6j, name, cont);
		               },
		               cont);
		     });
		                                   }
		                                   return caml_exact_trampoline_cps_call
		   (pause,
		    dummy,
		    function(a){
		     return caml_trampoline_cps_call3(let$23, a, c, b);
		    });
		                                  });
		                        };
		                     return caml_exact_trampoline_cps_call$1
		                             (with_lock,
		                              connecting_guard,
		                              f,
		                              function(a){
		                               return caml_trampoline_cps_call3(let$23, a, b, cont);
		                              });
		                    }
		                   }
		                   else if(-438114087 <= error[1]) break a;
		                   var
		                    a =
		                      function(param, cont){
		                       return caml_exact_trampoline_cps_call
		                               (loop, count + 1 | 0, cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (warn$3,
		                            function(m, cont){
		                             return caml_trampoline_cps_call6
		                                     (m, 0, 0, a6h, pp$125, error, cont);
		                            },
		                            function(left){
		                             return caml_exact_trampoline_cps_call
		                                     (reauthenticate,
		                                      auth,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (and$5,
		        left,
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$25, b, a, cont);
		        });
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call(wake, result, cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          dummy,
		                          function(b){
		                           return caml_trampoline_cps_call3(symbol_bind$24, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call(loop, 0, cont);
		               }
		               var no_report$0 = [0, no_report, 0];
		               function background(here, auth, param, action, f, cont){
		                var
		                 shutdown = param[5],
		                 profile = param[3],
		                 err = param[1],
		                 state = shutdown[3];
		                if(typeof state === "number" && state)
		                 return caml_exact_trampoline_cps_call
		                         (Sync[5],
		                          function(m, cont){
		                           return caml_trampoline_cps_call5(m, 0, 0, a6k, action, cont);
		                          },
		                          cont);
		                function f$0(param, cont){
		                 function f$0(param, cont){
		                  function catch$(param, cont){
		                   if(0 === param[0])
		                    return caml_trampoline_cps_call2(return$12, 0, cont);
		                   var e = param[1];
		                   function a(param, cont){
		                    function b(sentry_event_id, cont){
		                     function a(ppf, param, cont){
		                      if(! param)
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_none, ppf, dummy, cont);
		                      var v = param[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (pp_print_string,
		                               ppf,
		                               "[report id ",
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(pp_print_string,
		 ppf,
		 v,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (pp_print_string,
		           ppf,
		           cst$36,
		           function(a){return cont(pp_v1(ppf));});
		 });
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              id,
		                              fmt$141,
		                              function(b){
		                               return caml_trampoline_cps_call6
		                                       (b,
		a,
		sentry_event_id,
		action,
		pp_toplevel,
		e,
		function(a){return caml_trampoline_cps_call2(err, a, cont);});
		                              });
		                    }
		                    function a(a){
		                     return caml_trampoline_cps_call3(let$24, a, b, cont);
		                    }
		                    return dev$0
		                            ? caml_trampoline_cps_call2(return$12, 0, a)
		                            : caml_trampoline_cps_call2
		                              (profile,
		                               0,
		                               function(profile){
		                                var match = profile[3];
		                                if(match)
		                                 var userinfo = match[1][6], name = [0, userinfo[7]];
		                                else
		                                 name = 0;
		                                return caml_exact_trampoline_cps_call
		(user_id,
		 auth,
		 function(b){
		  return caml_exact_trampoline_cps_call
		          (to_string$44,
		           b,
		           function(b){
		            var id$0 = [0, b];
		            return caml_exact_trampoline_cps_call
		                    (to_string$51,
		                     profile[1],
		                     function(c){
		                      var
		                       email = [0, c],
		                       b = [0, [0, email, id$0, 0, name, 0, 0]];
		                      return caml_exact_trampoline_cps_call$1
		                              (kasprintf,
		                               id,
		                               fmt$142,
		                               function(c){
		                                return caml_trampoline_cps_call3
		(c,
		 pp_toplevel,
		 e,
		 function(value){
		  var
		   handled = opt$11[1],
		   c =
		     [0,
		      [0,
		       [0,
		        [0, [0, handled, "controller.background"]],
		        0,
		        action,
		        value],
		       0]];
		  return caml_exact_trampoline_cps_call
		          (distribution,
		           dummy,
		           function(d){
		            return caml_exact_trampoline_cps_call
		                    (dist_to_string,
		                     d,
		                     function(d){
		                      return caml_exact_trampoline_cps_call$2
		                              (make$60,
		                               [0, d],
		                               0,
		                               0,
		                               c,
		                               function(d){
		                                var event = d(0, 0, 0)(a6l, 0, 0, 0, 0, 0)(0, b);
		                                function c(param, cont){return cont([0, event[7]]);}
		                                return caml_trampoline_cps_call3
		(encode$10,
		 schema$146,
		 event,
		 function(event){
		  var msg = [0, event, 0];
		  call$0(bPA, cst_log, msg_to_jv_array(msg));
		  return caml_trampoline_cps_call2
		          (return$12,
		           sentry.captureEvent(event),
		           function(b){
		            return caml_trampoline_cps_call3(let$24, b, c, a);
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (Lwt[3],
		                            function(m, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$228,
		                                      empty$12,
		                                      no_report$0,
		                                      function(a){
		                                       return caml_trampoline_cps_call7
		       (m, 0, [0, a], a6m, action, pp_toplevel, e, cont);
		                                      });
		                            },
		                            function(b){
		                             return caml_trampoline_cps_call3(let$23, b, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (f,
		                           dummy,
		                           function(a){
		                            return caml_trampoline_cps_call3(bind$10, a, catch$, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$3
		                         (protect$0, shutdown, 0, acquire_read, arg$0, f$0, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (lwt_async, value$4(here, a6n), f$0, cont);
		               }
		               function background_offline(here, auth, t, name, f, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (background,
		                         here,
		                         auth,
		                         t,
		                         name,
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (offline, name, auth, t, f, cont);
		                         },
		                         cont);
		               }
		               function throttle_acc(first, add, delay, f){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3],
		                 state = [0, 0, create$21()];
		                return function(arg, cont){
		                 var a = state[1];
		                 if(a)
		                  var current_arg = a[1], a = [0, add(current_arg, arg)];
		                 else
		                  a = [0, first(arg)];
		                 state[1] = a;
		                 return is_empty$8(state[2])
		                         ? caml_exact_trampoline_cps_call$1
		                           (with_lock,
		                            state[2],
		                            function(a, cont){
		                             a = state[1];
		                             if(! a)
		                              return caml_trampoline_cps_call2(return$12, 0, cont);
		                             var x = a[1];
		                             state[1] = 0;
		                             function b(param, cont){
		                              return caml_trampoline_cps_call2(return$12, 0, cont);
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (sleep,
		                                      delay,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (f,
		        x,
		        function(c){
		         return caml_exact_trampoline_cps_call$1
		                 (both$0,
		                  c,
		                  a,
		                  function(a){
		                   return caml_trampoline_cps_call3(let$, a, b, cont);
		                  });
		        });
		                                      });
		                            },
		                            cont)
		                         : caml_trampoline_cps_call2(return$12, 0, cont);};
		               }
		               var
		                open$16 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_bind$25 = open$16[1],
		                symbol_map$22 = open$16[2],
		                let$26 = open$16[3],
		                let$27 = open$16[4],
		                let$28 = open$16[14],
		                let$29 = open$16[17],
		                and$6 = open$16[18],
		                schematic_cache$871 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$904 = [];
		               caml_update_dummy
		                (letrec_function_context$904, [0, schematic_cache$871]);
		               var schematic_schema_version$39 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$904[1][1],
		                    schematic_schema_version$39]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$904[1][1],
		                             schematic_schema_version$39,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$904[1][1],
		schematic_schema_version$39,
		schematic_self,
		function(a){
		 letrec_function_context$904[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(a6r);},
		       0,
		       0,
		       cst_noop,
		       "Noop",
		       a6q,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){return param ? cont(a6p) : cont(0);},
		        0,
		        0,
		        cst_push,
		        "Push",
		        a6o,
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$904[1][1],
		          schematic_schema_version$39,
		          res,
		          function(a){
		           letrec_function_context$904[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                schematic_cache$872 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$905 = [];
		               caml_update_dummy
		                (letrec_function_context$905, [0, schematic_cache$872]);
		               function schematic_version$130(param, cont){return cont(0);}
		               var
		                schematic_schema_version$61 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$905[1][1],
		                     schematic_schema_version$61]),
		                schema$264 = [0, id$20, 0, [4, decode$6, to_string$11, 8], 0];
		               if(e)
		                var schema$245 = e[1], descriptor$54 = schema$245;
		               else
		                descriptor$54 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$905[1][1],
		                              schematic_schema_version$61,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$905[1][1],
		 schematic_schema_version$61,
		 schematic_self,
		 function(a){
		  letrec_function_context$905[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$496,
		           schematic_version$130,
		           function(a){
		            var
		             res =
		               [7,
		                function(param, cont){
		                 var view = param[2][1], version = param[1];
		                 return cont([0, version, view]);
		                },
		                function(param, cont){
		                 var view = param[2], version = param[1];
		                 return cont([0, version, [0, view, 0]]);
		                },
		                [0,
		                 [0, 0, 0, 0, 0, cst_version, 0, 2, [0, schema$264], 0, 0],
		                 [0, [0, 0, 0, 0, 0, cst_view, 0, 2, [0, a], 0, 0], 0]]];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$905[1][1],
		                     schematic_schema_version$61,
		                     res,
		                     function(a){
		                      letrec_function_context$905[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var saved_view_schema = [0, a6s, 0, descriptor$54, 0];
		               function schematic_version$131(param, cont){return cont(0);}
		               var
		                schematic_param_replica_schema =
		                  caml_callback(Replica[1], [schematic_version$131]);
		               function descriptor$13(schematic_param_replica_schema){
		                return [7,
		                        function(param, cont){
		                         var
		                          a = param[2],
		                          version = a[2][1],
		                          replica = a[1],
		                          cookie = param[1];
		                         return cont([0, cookie, replica, version]);
		                        },
		                        function(param, cont){
		                         var
		                          version = param[3],
		                          replica = param[2],
		                          cookie = param[1];
		                         return cont([0, cookie, [0, replica, [0, version, 0]]]);
		                        },
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_cookie,
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_replica,
		                           0,
		                           2,
		                           [1, schematic_param_replica_schema],
		                           0,
		                           0],
		                          [0,
		                           [0, 0, 0, 0, 0, cst_version, 0, 2, [0, schema$264], 0, 0],
		                           0]]]];
		               }
		               var
		                schematic_schema_id = match$114[1],
		                schematic_parametric =
		                  [0,
		                   [1,
		                    cst_replica,
		                    schematic_param_replica_schema,
		                    function(schematic_param_replica_schema, cont){
		                     return cont
		                             ([0,
		                               schematic_schema_id,
		                               descriptor$13(schematic_param_replica_schema)]);
		                    }]],
		                e = descriptor$13(schematic_param_replica_schema),
		                parametric$0 = schematic_parametric[1],
		                d = caml_callback(of_parametric, [parametric$0]);
		               if(d){var name$26 = d[1]; caml_callback(to_id, [name$26]);}
		               function self_clock(replica, cont){
		                var
		                 clocks = Replica[9].call(null, replica),
		                 id = Replica[6].call(null, replica);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         clocks,
		                         id,
		                         function(a){return cont(value$4(a, 0));});
		               }
		               var replica_schema = [0, a6t, 0, e, schematic_parametric];
		               function key_workspace(workspace, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$45,
		                         workspace,
		                         function(name){return cont([0, name, replica_schema]);});
		               }
		               function key_workspace_view(workspace, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$45,
		                         workspace,
		                         function(s1){
		                          var name = s1 + "-view";
		                          return cont([0, name, saved_view_schema]);
		                         });
		               }
		               function cookie_mismatch(crdt, silo, cont){
		                function a(param, cont){
		                 return caml_exact_trampoline_cps_call(fail$2, a6u, cont);
		                }
		                function b(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (key_workspace,
		                         crdt[10],
		                         function(c){
		                          return caml_exact_trampoline_cps_call
		                                  (delete$0,
		                                   silo,
		                                   function(d){
		                                    return caml_trampoline_cps_call2
		    (d,
		     c,
		     function(left){
		      return caml_exact_trampoline_cps_call
		              (key_workspace_view,
		               crdt[10],
		               function(c){
		                return caml_exact_trampoline_cps_call
		                        (delete$0,
		                         silo,
		                         function(d){
		                          return caml_trampoline_cps_call2
		                                  (d,
		                                   c,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$1
		    (and$6,
		     left,
		     c,
		     function(c){
		      return caml_exact_trampoline_cps_call$1
		              (let$29,
		               c,
		               b,
		               function(b){
		                return caml_exact_trampoline_cps_call$1(let$28, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function personal_workspace_id(a){
		                a = a[1];
		                var personal_workspace_id = 0 === a[0] ? a[2] : a[1][1];
		                return personal_workspace_id;
		               }
		               function personal_workspace_id_writable(writable){return writable[1][1];
		               }
		               function state$0(workspace_id, a, cont){
		                a = a[1];
		                if(0 === a[0]){
		                 var
		                  views = a[4],
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3]),
		                  let$ = open[4],
		                  b = function(workspace, cont){return cont(workspace[3]);};
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id,
		                          views,
		                          workspace_id,
		                          function(a){
		                           return caml_trampoline_cps_call3(let$, a, b, cont);
		                          });
		                }
		                var
		                 replicas = a[1][2],
		                 open$0 =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$0 = open$0[4];
		                function c(workspace, cont){return cont(workspace[9]);}
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         value$8(replicas),
		                         workspace_id,
		                         function(a){
		                          return caml_trampoline_cps_call3(let$0, a, c, cont);
		                         });
		               }
		               function state_personal(crdt, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         personal_workspace_id(crdt),
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (value_exn, a6w, 0, a6v, a, cont);
		                         });
		               }
		               function states(a, cont){
		                a = a[1];
		                if(0 === a[0]){
		                 var views = a[4];
		                 return caml_exact_trampoline_cps_call$2
		                         (to_sequence$2,
		                          0,
		                          0,
		                          0,
		                          views,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    a,
		                                    function(param, cont){
		                                     var workspace = param[2], workspace_id = param[1];
		                                     return cont([0, workspace_id, workspace[3]]);
		                                    },
		                                    cont);
		                          });
		                }
		                var replicas = a[1][2];
		                return caml_exact_trampoline_cps_call$2
		                        (to_sequence$2,
		                         0,
		                         0,
		                         0,
		                         value$8(replicas),
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$11,
		                                   a,
		                                   function(param, cont){
		                                    var workspace = param[2], workspace_id = param[1];
		                                    return cont([0, workspace_id, workspace[9]]);
		                                   },
		                                   cont);
		                         });
		               }
		               function bQE(workspace, param, cont){
		                var
		                 replicas = param[2],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(replica, cont){return cont(replica[9]);}
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         value$8(replicas),
		                         workspace,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function bQF(writable, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (bQE,
		                         writable[1],
		                         writable,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (fatal$0, a6y, a6x, cont);
		                          var state = match[1];
		                          return cont(state);
		                         });
		               }
		               function state_incremental_personal(crdt, cont){
		                var
		                 personal_workspace_id$0 = personal_workspace_id(crdt),
		                 match = crdt[1];
		                function a(match){
		                 if(0 === match[0]){var incr = match[1]; return cont(incr);}
		                 var err = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (fatal_toplevel, a6z, err, cont);
		                }
		                if(0 === match[0]){
		                 var views = match[4];
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id,
		                          views,
		                          personal_workspace_id$0,
		                          function(match){
		                           if(! match)
		                            return a([1, [0, 847566860, personal_workspace_id$0]]);
		                           var workspace = match[1];
		                           return a([0, workspace[1]]);
		                          });
		                }
		                var replicas = match[1][2];
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         value$8(replicas),
		                         personal_workspace_id$0,
		                         function(match){
		                          if(! match)
		                           return a([1, [0, 847566860, personal_workspace_id$0]]);
		                          var workspace = match[1];
		                          return a([0, workspace[3]]);
		                         });
		               }
		               function writable$0(param, cont){
		                var match = param[1];
		                if(0 === match[0]){
		                 var
		                  b = function(param, cont){return cont(match[5]);},
		                  a =
		                    function(a){
		                     return caml_trampoline_cps_call3(let$26, a, b, cont);
		                    };
		                 return match[1]
		                         ? caml_trampoline_cps_call2(return$12, 0, a)
		                         : (match
		                            [1]
		                           = 1,
		                           caml_exact_trampoline_cps_call
		                            (Lwt[5],
		                             function(m, cont){
		                              return caml_trampoline_cps_call4(m, 0, 0, a6A, cont);
		                             },
		                             a));
		                }
		                var offline = param[2], content = match[1];
		                return caml_trampoline_cps_call2
		                        (return$12, [0, content, offline], cont);
		               }
		               function sync(a, opt, offline, crdt, replica, cont){
		                var on_success = a ? a[1] : 0, stabilize = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call
		                        (self_clock,
		                         crdt[6],
		                         function(previous_clock){
		                          return caml_exact_trampoline_cps_call
		                                  (self_clock,
		                                   replica,
		                                   function(new_clock){
		                                    if(new_clock < previous_clock)
		                                     return caml_exact_trampoline_cps_call
		     (Sync[3],
		      function(m, cont){
		       return caml_trampoline_cps_call6
		               (m, 0, 0, a6C, new_clock + 1 | 0, previous_clock, cont);
		      },
		      cont);
		                                    function a(a){
		                                     crdt[6] = replica;
		                                     return caml_exact_trampoline_cps_call
		     (observer_value_exn,
		      crdt[5],
		      function(a){
		       crdt[9] = a;
		       return caml_trampoline_cps_call3
		               (crdt[8], offline, on_success, cont);
		      });
		                                    }
		                                    if(! stabilize) return a();
		                                    function b(param, cont){
		                                     return caml_exact_trampoline_cps_call
		     (stabilize$0, dummy, cont);
		                                    }
		                                    return caml_trampoline_cps_call3
		    (run$0,
		     0,
		     cst_stabilize,
		     function(c){return caml_trampoline_cps_call2(c, b, a);});
		                                   });
		                         });
		               }
		               function make_writable_workspace
		               (auth,
		                silo,
		                cookie,
		                load_mode,
		                replica_initial,
		                workspace_id,
		                cont){
		                var mutex = create$21(), pending = [0, 0];
		                function save_workspace_to_api
		                (workspace, offline, replica, cont){
		                 var a = caml_obj_tag(workspace);
		                 function b(workspace){
		                  return mutex[1]
		                          ? (pending[1] = [0, replica], cont(0))
		                          : caml_exact_trampoline_cps_call$3
		                            (background_offline,
		                             a6H,
		                             auth,
		                             offline,
		                             "pushing commits",
		                             function(param, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (with_lock,
		                                       mutex,
		                                       function(param, cont){
		function push(replica, cont){
		 pending[1] = 0;
		 return caml_exact_trampoline_cps_call
		         (api$1,
		          auth,
		          function(match){
		           var api = match[2], Api = match[1];
		           function push_until_workspace_exists(fuel, cont){
		            function a(result, cont){
		             if(! workspace[1])
		              return caml_trampoline_cps_call2(return$13, 0, cont);
		             if(0 === result[0]){
		              var result$0 = result[1];
		              return caml_trampoline_cps_call2
		                      (return$13, [0, result$0], cont);
		             }
		             var match = result[1];
		             if(typeof match !== "number"){
		              var variant = match[1];
		              if(847566860 === variant){
		               if(0 === fuel)
		                return caml_trampoline_cps_call2(return$12, result, cont);
		               var
		                backoff = backoff_of_iteration_count(8 - fuel | 0),
		                a =
		                  function(param, cont){
		                   return caml_exact_trampoline_cps_call
		                           (push_until_workspace_exists, fuel - 1 | 0, cont);
		                  };
		               return caml_exact_trampoline_cps_call
		                       (sleep,
		                        backoff,
		                        function(b){
		                         return caml_trampoline_cps_call3(let$26, b, a, cont);
		                        });
		              }
		             }
		             return caml_trampoline_cps_call2(return$12, result, cont);
		            }
		            return caml_trampoline_cps_call4
		                    (Api[10][3],
		                     api,
		                     workspace[10],
		                     replica,
		                     function(b){
		                      return caml_trampoline_cps_call3(symbol_bind$25, b, a, cont);
		                     });
		           }
		           function a(error, cont){
		            if(0 === error[0]){
		             var a = error[1];
		             if(! a)
		              return caml_trampoline_cps_call2(return$13, 0, cont);
		             var update_replica = a[1][1];
		             return caml_trampoline_cps_call2
		                     (update_replica,
		                      workspace[6],
		                      function(a){
		                       return caml_exact_trampoline_cps_call$3
		                               (sync,
		                                0,
		                                a6D,
		                                offline,
		                                workspace,
		                                a,
		                                function(a){
		                                 a = pending[1];
		                                 if(! a)
		                                  return caml_trampoline_cps_call2(return$13, 0, cont);
		                                 var pending$0 = a[1];
		                                 return caml_trampoline_cps_call2
		 (update_replica,
		  pending$0,
		  function(a){
		   return caml_exact_trampoline_cps_call(push, a, cont);
		  });
		                                });
		                      });
		            }
		            a = error[1];
		            if(typeof a === "number"){
		             if(19653306 === a)
		              return caml_exact_trampoline_cps_call$1
		                      (fatal$0, a6F, a6E, cont);
		             if(-1040617408 > a){
		              var
		               b =
		                 function(ok, cont){
		                  if(0 === ok[0]) return cont(ok);
		                  var error = ok[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (fatal_toplevel, a6G, error, cont);
		                 };
		              return caml_exact_trampoline_cps_call$1
		                      (cookie_mismatch,
		                       workspace,
		                       silo,
		                       function(a){
		                        return caml_trampoline_cps_call3(symbol_map$22, a, b, cont);
		                       });
		             }
		            }
		            return caml_trampoline_cps_call2(return$12, error, cont);
		           }
		           return caml_exact_trampoline_cps_call
		                   (push_until_workspace_exists,
		                    8,
		                    function(b){
		                     return caml_trampoline_cps_call3(symbol_bind$25, b, a, cont);
		                    });
		          });
		}
		return caml_exact_trampoline_cps_call(push, replica, cont);
		                                       },
		                                       cont);
		                             },
		                             cont);
		                 }
		                 if(250 === a) return b(workspace[1]);
		                 if(246 !== a && 244 !== a) return b(workspace);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, workspace, b);
		                }
		                function a(incr){
		                 var mutex_fetch = create$21();
		                 return caml_exact_trampoline_cps_call$1
		                         (create_observer,
		                          0,
		                          incr,
		                          function(obs){
		                           function a(param, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (stabilize$0, dummy, cont);
		                           }
		                           return caml_trampoline_cps_call3
		                                   (run$0,
		                                    0,
		                                    "initial replica view",
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(match){
		       return caml_exact_trampoline_cps_call
		               (observer_value_exn,
		                obs,
		                function(state){
		                 var save_to_disk = [], workspace = [];
		                 caml_update_dummy
		                  (save_to_disk,
		                   [246,
		                    function(a, cont){
		                     function add(a, param){
		                      var
		                       on_success_old = param[2],
		                       on_success = a[2],
		                       offline = a[1];
		                      a:
		                      {
		                       if(! on_success && ! on_success_old){var on_success$0 = 0; break a;}
		                       on_success$0 = 1;
		                      }
		                      return [0, offline, on_success$0];
		                     }
		                     return caml_exact_trampoline_cps_call
		                             (distribution,
		                              dummy,
		                              function(match){
		                               a:
		                               {
		                                if(typeof match === "number" && 2 === match){var delay = of_int_s(5); break a;}
		                                delay = of_int_s(2);
		                               }
		                               var
		                                save =
		                                  throttle_acc
		                                   (function(a){return a;},
		                                    add,
		                                    delay,
		                                    function(a, cont){
		                                     var
		                                      on_success = a[2],
		                                      offline = a[1],
		                                      a = caml_obj_tag(workspace);
		                                     function b(workspace){
		                                      function a(param, cont){
		                                       function a(result, cont){
		if(0 === result[0])
		 return on_success
		         ? caml_trampoline_cps_call3
		           (workspace[7], offline, workspace[6], cont)
		         : cont(0);
		var error = result[1];
		return caml_exact_trampoline_cps_call$1
		        (fatal$0,
		         a6J,
		         a6I,
		         function(a){
		          return caml_trampoline_cps_call3(a, pp$125, error, cont);
		         });
		                                       }
		                                       function b(param, cont){return cont(0);}
		                                       var c = [0, workspace[2], workspace[6], version$2];
		                                       return caml_exact_trampoline_cps_call
		       (key_workspace,
		        workspace[10],
		        function(d){
		         return caml_exact_trampoline_cps_call
		                 (set$27,
		                  silo,
		                  function(e){
		                   return caml_trampoline_cps_call2
		                           (e,
		                            d,
		                            function(d){
		                             return caml_trampoline_cps_call2
		                                     (d,
		                                      c,
		                                      function(left){
		                                       return caml_exact_trampoline_cps_call
		       (distribution,
		        dummy,
		        function(c){
		         a:
		         {if(typeof c === "number" && 2 > c){c = 1; break a;} c = 0;}
		         function d(c){
		          return caml_exact_trampoline_cps_call$1
		                  (and$6,
		                   left,
		                   c,
		                   function(c){
		                    return caml_exact_trampoline_cps_call$1
		                            (let$29,
		                             c,
		                             b,
		                             function(b){
		                              return caml_trampoline_cps_call3(let$27, b, a, cont);
		                             });
		                   });
		         }
		         if(! c) return caml_trampoline_cps_call2(return$13, 0, d);
		         var e = [0, version$2, workspace[9]];
		         return caml_exact_trampoline_cps_call
		                 (key_workspace_view,
		                  workspace[10],
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (set$27,
		                            silo,
		                            function(b){return caml_trampoline_cps_call3(b, a, e, d);});
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      }
		                                      var b = workspace[10];
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$143,
		       function(c){
		        return caml_trampoline_cps_call3
		                (c,
		                 pp$46,
		                 b,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (bQR,
		                           0,
		                           b,
		                           function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                 });
		       });
		                                     }
		                                     if(250 === a) return b(workspace[1]);
		                                     if(246 !== a && 244 !== a) return b(workspace);
		                                     return caml_exact_trampoline_cps_call
		     (force_lazy_block, workspace, b);
		                                    });
		                               return cont
		                                       (function(offline, on_success, cont){
		 return caml_exact_trampoline_cps_call$1
		         (dont_wait,
		          function(param, cont){
		           return caml_exact_trampoline_cps_call
		                   (save, [0, offline, on_success], cont);
		          },
		          function(exn, cont){
		           return caml_exact_trampoline_cps_call
		                   (Sync[3],
		                    function(m, cont){
		                     return caml_trampoline_cps_call6
		                             (m, 0, 0, a6K, pp$1, exn, cont);
		                    },
		                    function(match){
		                     return caml_exact_trampoline_cps_call$1
		                             (fatal_exn, a6L, exn, cont);
		                    });
		          },
		          cont);
		});
		                              });
		                    }]);
		                 var save_to_api = [];
		                 caml_update_dummy
		                  (save_to_api,
		                   [246,
		                    function(a, cont){
		                     return cont
		                             (function(a, b, cont){
		                               return caml_exact_trampoline_cps_call$0
		                                       (save_workspace_to_api, workspace, a, b, cont);
		                              });
		                    }]);
		                 caml_update_dummy
		                  (workspace,
		                   [246,
		                    function(a, cont){
		                     a = caml_obj_tag(save_to_disk);
		                     function b(c){
		                      var a = caml_obj_tag(save_to_api);
		                      function b(a){
		                       return cont
		                               ([0,
		                                 1,
		                                 cookie,
		                                 incr,
		                                 mutex_fetch,
		                                 obs,
		                                 replica_initial,
		                                 a,
		                                 c,
		                                 state,
		                                 workspace_id]);
		                      }
		                      if(250 === a) return b(save_to_api[1]);
		                      if(246 !== a && 244 !== a) return b(save_to_api);
		                      return caml_exact_trampoline_cps_call
		                              (force_lazy_block, save_to_api, b);
		                     }
		                     if(250 === a) return b(save_to_disk[1]);
		                     if(246 !== a && 244 !== a) return b(save_to_disk);
		                     return caml_exact_trampoline_cps_call
		                             (force_lazy_block, save_to_disk, b);
		                    }]);
		                 var a = caml_obj_tag(workspace);
		                 if(250 === a) return cont(workspace[1]);
		                 if(246 !== a && 244 !== a) return cont(workspace);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, workspace, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                if(! load_mode)
		                 return caml_exact_trampoline_cps_call
		                         (Replica[8], replica_initial, a);
		                var replica_var = load_mode[2], incr = load_mode[1];
		                return caml_exact_trampoline_cps_call$1
		                        (set_var,
		                         replica_var,
		                         [0, replica_initial],
		                         function(match){return a(incr);});
		               }
		               function on_new_commits
		               (auth, crdt, offline, workspace_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$139,
		                         workspace_id,
		                         crdt[1],
		                         function(a){
		                          return a
		                                  ? caml_exact_trampoline_cps_call
		                                    (keys$0,
		                                     value$8(crdt[2]),
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (Set$0[70],
		       a,
		       function(prev_workspaces){
		        return caml_exact_trampoline_cps_call
		                (bQF,
		                 crdt,
		                 function(state){
		                  var personal = crdt[1];
		                  return caml_exact_trampoline_cps_call$2
		                          (to_sequence$2,
		                           0,
		                           0,
		                           0,
		                           state[15],
		                           function(s){
		                            function f(param, cont){
		                             var org = param[2];
		                             return caml_exact_trampoline_cps_call$2
		                                     (to_sequence$2,
		                                      0,
		                                      0,
		                                      0,
		                                      org[4],
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (map$11,
		        a,
		        calendar,
		        function(a){
		         return cont
		                 (filter$0
		                   (a,
		                    function(workspace_id, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$142, workspace_id, personal, cont);
		                    }));
		        });
		                                      });
		                            }
		                            return caml_trampoline_cps_call3
		                                    (bind$5,
		                                     s,
		                                     f,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (Set$0[72],
		       a,
		       function(snd_workspaces){
		        return caml_exact_trampoline_cps_call$1
		                (add$4,
		                 snd_workspaces,
		                 crdt[1],
		                 function(workspaces){
		                  var
		                   t = symmetric_diff$0(prev_workspaces, workspaces),
		                   next = t[2],
		                   seed = t[1];
		                  function a(seed){
		                   return caml_trampoline_cps_call2
		                           (next,
		                            seed,
		                            function(match){
		                             if(typeof match === "number") return cont(0);
		                             if(0 === match[0]){
		                              var seed = match[1];
		                              return caml_exact_trampoline_call1(a, seed);
		                             }
		                             var seed$0 = match[2], a$0 = match[1];
		                             if(0 === a$0[0]){
		                              var workspace_id = a$0[1], replicas = value$8(crdt[2]);
		                              return caml_exact_trampoline_cps_call$1
		                                      (find_packed_by_id,
		                                       replicas,
		                                       workspace_id,
		                                       function(o){
		if(o){var workspace = o[1]; workspace[1] = 0;}
		return caml_exact_trampoline_cps_call$1
		        (remove$2,
		         replicas,
		         workspace_id,
		         function(replicas){
		          return caml_exact_trampoline_cps_call$1
		                  (set$10,
		                   crdt[2],
		                   replicas,
		                   function(b){return caml_exact_trampoline_call1(a, seed$0);});
		         });
		                                       });
		                             }
		                             var workspace_id$0 = a$0[1];
		                             return caml_exact_trampoline_cps_call
		                                     (device,
		                                      auth,
		                                      function(match){
		                                       if(0 === match[0])
		var id$0 = match[1], device_id = id$0;
		                                       else
		device_id = Device[29].call(null);
		                                       var b = [0, nanoid(), 0];
		                                       return caml_exact_trampoline_cps_call
		       (Device[8],
		        device_id,
		        function(c){
		         return caml_exact_trampoline_cps_call$1
		                 (concat$0,
		                  a6B,
		                  [0, c, b],
		                  function(replica_id){
		                   return caml_exact_trampoline_cps_call
		                           (Replica[7],
		                            replica_id,
		                            function(replica){
		                             return caml_exact_trampoline_cps_call$7
		                                     (make_writable_workspace,
		                                      auth,
		                                      crdt[3],
		                                      0,
		                                      0,
		                                      replica,
		                                      workspace_id$0,
		                                      function(workspace){
		                                       return caml_exact_trampoline_cps_call$0
		       (set$3,
		        value$8(crdt[2]),
		        workspace_id$0,
		        workspace,
		        function(replicas){
		         return caml_exact_trampoline_cps_call$1
		                 (set$10,
		                  crdt[2],
		                  replicas,
		                  function(match){
		                   function b(param, cont){
		                    function a(error, cont){
		                     a:
		                     if(0 !== error[0]){
		                      var match = error[1];
		                      if(typeof match !== "number" && 847566860 <= match[1])
		                       break a;
		                      return cont(error);
		                     }
		                     return cont(a6M);
		                    }
		                    return caml_exact_trampoline_cps_call$2
		                            (workspace_synchronize_server,
		                             auth,
		                             crdt,
		                             offline,
		                             workspace,
		                             function(b){
		                              return caml_trampoline_cps_call3(symbol_map$22, b, a, cont);
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$144,
		                            function(c){
		                             return caml_trampoline_cps_call3
		                                     (c,
		                                      pp$46,
		                                      workspace_id$0,
		                                      function(c){
		                                       return caml_exact_trampoline_cps_call$3
		       (background_offline,
		        a6N,
		        auth,
		        offline,
		        c,
		        b,
		        function(b){return caml_exact_trampoline_call1(a, seed$0);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  }
		                  return a(seed);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     })
		                                  : cont(a);
		                         });
		               }
		               function apply$124
		               (auth, offline, crdt, authorize, workspace_id, op, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         value$8(crdt[2]),
		                         workspace_id,
		                         function(match){
		                          if(! match) return cont([1, [0, 847566860, workspace_id]]);
		                          var workspace = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (authorize,
		                                   auth,
		                                   workspace,
		                                   function(a){
		                                    return a
		    ? caml_exact_trampoline_cps_call$1
		      (Replica[4],
		       op,
		       workspace[6],
		       function(match){
		        var replica = match[2], result = match[1];
		        return caml_exact_trampoline_cps_call$3
		                (sync,
		                 a6O,
		                 0,
		                 offline,
		                 workspace,
		                 replica,
		                 function(match){
		                  return caml_exact_trampoline_cps_call$2
		                          (on_new_commits,
		                           auth,
		                           crdt,
		                           offline,
		                           workspace_id,
		                           function(match){return cont([0, result]);});
		                 });
		       })
		    : cont([1, [0, -349351921, workspace_id]]);
		                                   });
		                         });
		               }
		               function apply_bypass(auth, crdt, workspace_id, op, cont){
		                var crdt$0 = crdt[1], offline = crdt[2];
		                function authorize(a, param, cont){return cont(1);}
		                return caml_exact_trampoline_cps_call$7
		                        (apply$124,
		                         auth,
		                         offline,
		                         crdt$0,
		                         authorize,
		                         workspace_id,
		                         op,
		                         cont);
		               }
		               function apply$125(auth, crdt, workspace_id, op, cont){
		                var crdt$0 = crdt[1], offline = crdt[2];
		                function authorize(auth, workspace, cont){
		                 return caml_exact_trampoline_cps_call
		                         (user_id,
		                          auth,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    workspace[9][10],
		                                    a,
		                                    function(match){
		                                     if(! match) return cont(0);
		                                     var member = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (equal$63, member[1], 1, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$7
		                        (apply$124,
		                         auth,
		                         offline,
		                         crdt$0,
		                         authorize,
		                         workspace_id,
		                         op,
		                         cont);
		               }
		               function workspace_synchronize_server
		               (auth, crdt, offline, workspace, cont){
		                if(! is_empty$8(workspace[4]))
		                 return caml_trampoline_cps_call2(return$13, 0, cont);
		                function a(apply_commits, cont){
		                 return caml_trampoline_cps_call2
		                         (apply_commits,
		                          workspace[6],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$3
		                                   (sync,
		                                    0,
		                                    0,
		                                    offline,
		                                    workspace,
		                                    a,
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call$2
		     (on_new_commits, auth, crdt, offline, workspace[10], cont);
		                                    });
		                          });
		                }
		                function b(result, cont){
		                 if(0 === result[0])
		                  return caml_trampoline_cps_call2(return$12, result, cont);
		                 var match = result[1];
		                 if(typeof match === "number" && -610669292 > match){
		                  var
		                   a =
		                     function(param, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (cookie_mismatch, workspace, crdt[3], cont);
		                     };
		                  return caml_exact_trampoline_cps_call
		                          (warn$3,
		                           function(m, cont){
		                            return caml_trampoline_cps_call4(m, 0, 0, a6P, cont);
		                           },
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$28, b, a, cont);
		                           });
		                 }
		                 return caml_trampoline_cps_call2(return$12, result, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         auth,
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (with_lock,
		                                   workspace[4],
		                                   function(param, cont){
		                                    function a(param, cont){
		                                     return caml_trampoline_cps_call5
		     (Api[10][2],
		      api,
		      workspace[2],
		      workspace[10],
		      workspace[6],
		      cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (Lwt[6],
		     function(m, cont){
		      return caml_trampoline_cps_call6
		              (m, 0, 0, a6Q, pp$46, workspace[10], cont);
		     },
		     function(b){
		      return caml_trampoline_cps_call3(let$26, b, a, cont);
		     });
		                                   },
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (let$26,
		     c,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$29, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function apply_personal(auth, crdt, op, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (apply$125,
		                         auth,
		                         crdt,
		                         crdt[1][1],
		                         op,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (fatal_result, a6R, a, cont);
		                         });
		               }
		               function task_binding_workspace(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2], workspace_id = param[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (mem$5,
		     state[22],
		     id,
		     function(a){return cont(some_if(a, workspace_id));});
		                                   },
		                                   cont);
		                         });
		               }
		               function get_calendar$0(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_calendar, state, id, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function get_event$1(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_event$0, state, id, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function get_event_recurrent$1(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_event_recurrent$0, state, id, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function get_page$0(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_page, state, id, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function get_person$0(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_person, state, id, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function get_task$0(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_task, state, id, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function get_task_recurrent$0(crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_map,
		                                   a,
		                                   function(param, cont){
		                                    var state = param[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_task_recurrent, state, id, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function state_writable(workspace, writable, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (bQE, workspace, writable[1], cont);
		               }
		               function state_writable_personal(writable, cont){
		                return caml_exact_trampoline_cps_call(bQF, writable[1], cont);
		               }
		               function apply_common(state, op, cont){
		                g
		                 ([0,
		                   symbol_bind$5,
		                   symbol_map$5,
		                   ,
		                   bind$8,
		                   return$9,
		                   map$17,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$3]);
		                switch(op[0]){
		                  case 2:
		                   var devices = op[1];
		                   return caml_exact_trampoline_cps_call
		                           (deconstruct,
		                            devices,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (map$11,
		                                      a,
		                                      function(d, cont){var id = d[2]; return cont([0, id, d]);},
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (ById[124],
		        a,
		        function(devices){
		         return cont
		                 ([0, [0, [0, devices], state[2], state[3], state[4]]]);
		        });
		                                      });
		                            });
		                  case 3:
		                   var date = op[1];
		                   return cont([0, [0, state[1], date, state[3], state[4]]]);
		                  default:
		                   var
		                    device = op[1],
		                    d = device[2],
		                    a = state[4],
		                    b = state[3],
		                    c = state[2];
		                   return caml_trampoline_cps_call3
		                           (map$17,
		                            state[1],
		                            function(a, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3, a, d, device, cont);
		                            },
		                            function(d){return cont([0, [0, d, c, b, a]]);});
		                }
		               }
		               function apply$126(state, op, cont){
		                g
		                 ([0,
		                   symbol_bind$5,
		                   symbol_map$5,
		                   ,
		                   bind$8,
		                   return$9,
		                   map$17,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$3]);
		                if(3 === op[0])
		                 return caml_exact_trampoline_cps_call$1
		                         (apply_common, state, op, cont);
		                var patch = op[2], id = op[1], match = state[1];
		                function a(changed, devices){
		                 return cont
		                         (some_if
		                           (changed, [0, devices, state[2], state[3], state[4]]));
		                }
		                if(! match) return a(0, 0);
		                var devices = match[1], res = [0, 0];
		                function f(v, cont){
		                 if(v)
		                  var
		                   device = v[1],
		                   writable = device[3],
		                   push_token = patch[2],
		                   name = patch[1],
		                   a = value$4(push_token, writable[2]),
		                   a = [0, value$4(name, writable[1]), a],
		                   a = [0, 1, [0, [0, device[1], device[2], a]]];
		                 else
		                  a = a6S;
		                 var v$0 = a[2], r = a[1];
		                 res[1] = [0, r];
		                 return cont(v$0);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (change$0,
		                         devices,
		                         id,
		                         f,
		                         function(devices){
		                          return caml_exact_trampoline_cps_call$2
		                                  (value_exn,
		                                   mA,
		                                   0,
		                                   0,
		                                   res[1],
		                                   function(changed){return a(changed, [0, devices]);});
		                         });
		               }
		               var Logs$5 = with_tag$0(component$0, "Controller.Store");
		               function synchronize(t, operation, cont){
		                var state = t[1];
		                g
		                 ([0,
		                   symbol_bind$5,
		                   symbol_map$5,
		                   ,
		                   bind$8,
		                   return$9,
		                   map$17,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$3]);
		                return caml_exact_trampoline_cps_call$1
		                        (apply_common,
		                         state,
		                         operation,
		                         function(a){
		                          if(! a) return cont([0, t, 0]);
		                          var default$ = a[1], a = t[4];
		                          function b(mutation_base){
		                           var mutations = t[3], b = t[4], c = t[3];
		                           function a(a){return cont([0, [0, default$, a, c, b], 1]);}
		                           return mutations
		                                   ? caml_exact_trampoline_cps_call
		                                     (of_rev_keys,
		                                      mutations,
		                                      function(t){
		                                       function b(t, init){
		if(! t) return a(init);
		var l = t[2], operation = t[1];
		return caml_exact_trampoline_cps_call$1
		        (apply$126,
		         init,
		         operation,
		         function(a){
		          var init$0 = value$4(a, init);
		          return caml_exact_trampoline_call2(b, l, init$0);
		         });
		                                       }
		                                       return b(t, mutation_base);
		                                      })
		                                   : a(mutation_base);
		                          }
		                          if(! a) return b(default$);
		                          var operation = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (apply$126,
		                                   default$,
		                                   operation,
		                                   function(a){return b(value$4(a, default$));});
		                         });
		               }
		               function synchronize_multiple(t, operations, cont){
		                function f(param, op, cont){
		                 var changed = param[2], t = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (synchronize,
		                          t,
		                          op,
		                          function(res){
		                           var changed$0 = changed || res[2];
		                           return cont([0, res[1], changed$0]);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (fold$9(operations), [0, t, 0], f, cont);
		               }
		               function push$0(t, cont){
		                if(is_some(t[4]))
		                 return caml_exact_trampoline_cps_call
		                         (Logs$2[6],
		                          function(m, cont){
		                           return caml_trampoline_cps_call4(m, 0, 0, aX3, cont);
		                          },
		                          function(match){return cont(0);});
		                var match = dequeue(t[3]), mutations = match[2], m = match[1];
		                if(! m) return cont(0);
		                var m$0 = m[1];
		                return cont
		                        ([0, [0, m$0, [0, t[1], t[2], mutations, [0, m$0]]]]);
		               }
		               function commit_state
		               (ops_changed, state_changed, t, incr, new_store, cont){
		                var new_state = new_store[2];
		                function a(a){
		                 var
		                  inputs = incr[2],
		                  Incr = incr[1],
		                  operations = inputs[5],
		                  last_scheduling = inputs[2],
		                  devices = inputs[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (set_var,
		                          devices,
		                          new_state[1],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (set_var,
		                                    last_scheduling,
		                                    new_state[2],
		                                    function(match){
		                                     function b(a){
		                                      return caml_trampoline_cps_call2
		      (Incr[49],
		       0,
		       function(match){t[4] = new_store; return cont(0);});
		                                     }
		                                     if(! ops_changed) return b();
		                                     var pushing = new_store[4], mutations = new_store[3];
		                                     function a(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (set_var, operations, a, b);
		                                     }
		                                     if(! pushing) return a(mutations);
		                                     var pushing$0 = pushing[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (append$0, mutations, [0, pushing$0, 0], a);
		                                    });
		                          });
		                }
		                if(! state_changed) return a();
		                var state = t[4][2];
		                return caml_exact_trampoline_cps_call$0
		                        (trigger$0, t[3], [0, state, new_state], 0, a);
		               }
		               function mutate(t, auth, incr, offline$0, mutations, cont){
		                var match = t[1];
		                function a(){
		                 t[1] = [0, mutations];
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4]),
		                  let$ = open[14],
		                  let$0 = open[4],
		                  let$1 = open[3],
		                  t$0 = t[4];
		                 function a(t$0, init){
		                  if(t$0){
		                   var
		                    l = t$0[2],
		                    mutation = t$0[1],
		                    changed = init[2],
		                    t$1 = init[1],
		                    q = t$1[3];
		                   return caml_exact_trampoline_cps_call
		                           (of_rev_keys,
		                            q,
		                            function(q){
		                             a:
		                             {
		                              b:
		                              {
		                               var acc = 0, b = q;
		                               for(;;){
		                                if(! b) break;
		                                var t = b[2], h = b[1], b = 0;
		                                if(b) break b;
		                                var acc$0 = [0, h, acc];
		                                acc = acc$0;
		                                b = t;
		                               }
		                               b = [0, acc, 0];
		                               break a;
		                              }
		                              var v = b[1], b = [0, rev_append(t, [0, v, acc]), [0, v]];
		                             }
		                             var
		                              mutations = b[1],
		                              mutations$0 = b[2] ? mutations : [0, mutation, mutations];
		                             return caml_exact_trampoline_cps_call$1
		                                     (apply$126,
		                                      t$1[2],
		                                      mutation,
		                                      function(state_changed){
		                                       var
		c = is_some(state_changed),
		d = t$1[4],
		b = value$4(state_changed, t$1[2]),
		b = [0, t$1[1], b, mutations$0, d],
		changed$0 = changed || c;
		                                       return caml_exact_trampoline_call2(a, l, [0, b, changed$0]);
		                                      });
		                            });
		                  }
		                  var state_changed = init[2], store = init[1];
		                  return caml_exact_trampoline_cps_call$3
		                          (commit_state,
		                           1,
		                           state_changed,
		                           t,
		                           incr,
		                           store,
		                           function(match){
		                            t[1] = 0;
		                            function push(param, cont){
		                             function f(param, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (push$0,
		                                       t[4],
		                                       function(a){
		if(! a)
		 return caml_trampoline_cps_call2(return$13, 0, cont);
		a = a[1];
		var store_only_for_assignment = a[2], mutation = a[1];
		t[4] = store_only_for_assignment;
		function b(param, cont){
		 function a(sync_op, cont){
		  if(0 === sync_op[0]){
		   var
		    operations = sync_op[1],
		    t$1 = t[4],
		    t$0 = [0, t$1[1], t$1[2], t$1[3], 0],
		    a =
		      function(t$0, init){
		       if(t$0){
		        var
		         l = t$0[2],
		         operation = t$0[1],
		         changed = init[2],
		         t$1 = init[1];
		        return caml_exact_trampoline_cps_call$1
		                (synchronize,
		                 t$1,
		                 operation,
		                 function(res){
		                  var
		                   changed$0 = changed || res[2],
		                   init = [0, res[1], changed$0];
		                  return caml_exact_trampoline_call2(a, l, init);
		                 });
		       }
		       var state_changed = init[2], store = init[1];
		       return caml_exact_trampoline_cps_call$3
		               (commit_state,
		                1,
		                state_changed,
		                t,
		                incr,
		                store,
		                function(match){
		                 return caml_trampoline_cps_call2(return$13, 1, cont);
		                });
		      };
		   return a(operations, [0, t$0, 0]);
		  }
		  var e = sync_op[1];
		  function b(param, cont){return cont(sync_op);}
		  return caml_exact_trampoline_cps_call
		          (Logs$5[5][3],
		           function(m, cont){
		            return caml_exact_trampoline_cps_call
		                    (mutation_operation_schema,
		                     mutation_schema,
		                     function(b){
		                      var
		                       a =
		                         [0, attributes, [0, attr$0(cst_operation, mutation, b), 0]];
		                      return caml_exact_trampoline_cps_call$1
		                              (symbol$228,
		                               empty$12,
		                               no_report$0,
		                               function(b){
		                                return caml_exact_trampoline_cps_call$1
		(symbol$228,
		 b,
		 a,
		 function(a){
		  return caml_trampoline_cps_call6
		          (m, 0, [0, a], a6T, pp$125, e, cont);
		 });
		                               });
		                     });
		           },
		           function(a){
		            return caml_trampoline_cps_call3(let$0, a, b, cont);
		           });
		 }
		 function service_sync(param, cont){
		  var state = t[4][2];
		  return caml_trampoline_cps_call4
		          (t[2], t, state, mutation, cont);
		 }
		 return caml_exact_trampoline_cps_call$2
		         (offline,
		          "pushing to services",
		          auth,
		          offline$0,
		          service_sync,
		          function(b){
		           return caml_trampoline_cps_call3(let$1, b, a, cont);
		          });
		}
		return caml_exact_trampoline_cps_call
		        (Logs$5[5][6],
		         function(m, cont){
		          return caml_trampoline_cps_call4(m, 0, 0, a6U, cont);
		         },
		         function(a){
		          return caml_trampoline_cps_call3(let$1, a, b, cont);
		         });
		                                       });
		                             }
		                             function a(continue$, cont){
		                              if(continue$)
		                               return caml_exact_trampoline_cps_call(push, dummy, cont);
		                              function a(param, cont){
		                               return caml_trampoline_cps_call2(return$13, 0, cont);
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (Logs$5[5][6],
		                                       function(m, cont){
		return caml_trampoline_cps_call4(m, 0, 0, a6V, cont);
		                                       },
		                                       function(b){
		return caml_trampoline_cps_call3(let$1, b, a, cont);
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$1
		                                     (with_lock,
		                                      t[5],
		                                      f,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$3
		                                    (background,
		                                     a6X,
		                                     auth,
		                                     offline$0,
		                                     "pushing modification to server",
		                                     function(param, cont){
		                                      function a(param, cont){
		                                       return caml_exact_trampoline_cps_call(push, dummy, cont);
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (Logs$5[5][6],
		       function(m, cont){
		        return caml_trampoline_cps_call4(m, 0, 0, a6W, cont);
		       },
		       function(b){
		        return caml_trampoline_cps_call3(let$1, b, a, cont);
		       });
		                                     },
		                                     cont);
		                           });
		                 }
		                 return a(mutations, [0, t$0, 0]);
		                }
		                if(! match) return a();
		                var
		                 ops = match[1],
		                 b = list(0, pp_operation),
		                 c = list(0, pp_operation);
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$145,
		                         function(d){
		                          return caml_trampoline_cps_call5
		                                  (d,
		                                   c,
		                                   mutations,
		                                   b,
		                                   ops,
		                                   function(b){fatal(b); return a();});
		                         });
		               }
		               var
		                schematic_cache$873 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$906 = [];
		               caml_update_dummy
		                (letrec_function_context$906, [0, schematic_cache$873]);
		               var
		                schematic_schema_version$38 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$906[1][1],
		                     schematic_schema_version$38]);
		               if(e)
		                var schema$246 = e[1], descriptor$55 = schema$246;
		               else
		                descriptor$55 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$906[1][1],
		                              schematic_schema_version$38,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$906[1][1],
		 schematic_schema_version$38,
		 schematic_self,
		 function(a){
		  letrec_function_context$906[1][1] = a;
		  var
		   res =
		     [11,
		      0,
		      [0,
		       [0,
		        function(param, cont){return cont(0);},
		        function(param, cont){return param ? cont(0) : cont(a65);},
		        0,
		        0,
		        cst_only_all_day,
		        "Only",
		        a64,
		        0],
		       [0,
		        [0,
		         function(param, cont){return cont(1);},
		         function(param, cont){
		          return 1 === param ? cont(a63) : cont(0);
		         },
		         0,
		         0,
		         cst_with_all_day,
		         "With",
		         a62,
		         0],
		        [0,
		         [0,
		          function(param, cont){return cont(2);},
		          function(param, cont){
		           return 2 <= param ? cont(a61) : cont(0);
		          },
		          0,
		          0,
		          cst_without_all_day,
		          "Without",
		          a60,
		          0],
		         0]]],
		      0];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$906[1][1],
		           schematic_schema_version$38,
		           res,
		           function(a){
		            letrec_function_context$906[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                schema$247 = [0, a6Z, 0, descriptor$55, 0],
		                Logs$6 =
		                  with_tag$0(component$0, "Controller.Events_recurrent");
		               function lookup(t, Incremental, param, id, cont){
		                var lookup = param[7][2];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6, lookup, id, cont);
		               }
		               function id$38(t){return t[5];}
		               function generic(id){return [1, id];}
		               function get_from_state(state, id, cont){
		                var
		                 values = state[5],
		                 incremental = state[1],
		                 events_recurrent = values[7];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         events_recurrent[2],
		                         id,
		                         function(ev_incr){
		                          return caml_trampoline_cps_call3
		                                  (incremental[46],
		                                   0,
		                                   ev_incr,
		                                   function(obs){
		                                    return caml_trampoline_cps_call2
		    (incremental[49],
		     0,
		     function(match){
		      return caml_trampoline_cps_call2
		              (incremental[45][6], obs, cont);
		     });
		                                   });
		                         });
		               }
		               caml_callback(M$3, [[0, comparator$11, schema_versioned$1]]);
		               caml_callback(M$2, [[0, comparator$11, schema_versioned$1]]);
		               function append$8(param, incr, section, id, block, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state,
		                         incr,
		                         id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (Logs$6[6][4],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call6
		     (m, 0, 0, a66, pp$79, id, cont);
		                                    },
		                                    function(match){return cont(0);});
		                          var event = match[1], doc = event[7][8];
		                          return caml_exact_trampoline_cps_call$0
		                                  (crdt_append,
		                                   doc,
		                                   section,
		                                   block,
		                                   function(doc_op){
		                                    return caml_exact_trampoline_cps_call
		    (notes,
		     doc_op,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (writable,
		               a,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (element$5,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (events_recurrent,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (ignore_m$11,
		               a,
		               function(routine_op){
		                return cont([0, [0, event, routine_op]]);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function calendar_readonly(calendars, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         calendars,
		                         id,
		                         function(match){
		                          if(! match) return cont([1, [0, 186335685, id]]);
		                          var calendar = match[1];
		                          return caml_trampoline_cps_call2
		                                  (of_string$14, calendar, cont);
		                         });
		               }
		               function calendar_writable(calendars, id, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[3];
		                function a(calendar, cont){
		                 if(calendar[8])
		                  return caml_trampoline_cps_call2
		                          (of_string$14, calendar, cont);
		                 var x = [0, -756235133, id];
		                 return cont([1, x]);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (calendar_readonly,
		                         calendars,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var
		                schematic_cache$874 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$907 = [];
		               caml_update_dummy
		                (letrec_function_context$907, [0, schematic_cache$874]);
		               function schematic_version$132(param, cont){return cont(0);}
		               var schematic_schema_version$60 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$907[1][1],
		                    schematic_schema_version$60]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$907[1][1],
		                             schematic_schema_version$60,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$907[1][1],
		schematic_schema_version$60,
		schematic_self,
		function(a){
		 letrec_function_context$907[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$202,
		          schematic_version$132,
		          function(b){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_type, 0, 3, [0, b], 0, 0], 0];
		           return caml_exact_trampoline_cps_call
		                   (event_or_pause_schema_versione,
		                    schematic_version$132,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_events,
		                          0,
		                          2,
		                          [0, [0, 0, 0, [3, c], 0]],
		                          0,
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$4,
		                              schematic_version$132,
		                              function(c){
		                               var
		                                a = [0, [0, 0, 0, 0, 0, cst_end, 0, 2, [0, c], 0, 0], b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$4,
		schematic_version$132,
		function(b){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       d = c[2],
		       type = d[2][1],
		       events = d[1],
		       end = c[1],
		       start = b[1],
		       icon = a[1],
		       title = param[1];
		      return cont([0, title, icon, start, end, events, type]);
		     },
		     function(param, cont){
		      var
		       type = param[6],
		       events = param[5],
		       end = param[4],
		       start = param[3],
		       icon = param[2],
		       title = param[1];
		      return cont
		              ([0,
		                title,
		                [0, icon, [0, start, [0, end, [0, events, [0, type, 0]]]]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_title,
		       0,
		       3,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_icon,
		        0,
		        3,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0, [0, 0, 0, 0, 0, cst_start, 0, 2, [0, b], 0, 0], a]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$907[1][1],
		          schematic_schema_version$60,
		          res,
		          function(a){
		           letrec_function_context$907[1][1] = a;
		           return cont(res);
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               of_int_s(7199);
		               function of_events(param, date, events, cont){
		                var evening_start = param[4], day_start = param[1];
		                return caml_exact_trampoline_cps_call
		                        (M$2,
		                         [0, comparator$10, schema_versioned$4],
		                         function(Time_map){
		                          function singleton(ev, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (By$1[105],
		                                    ev[5][6],
		                                    ev,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (end$1,
		      timezone_local,
		      ev[5][9][10],
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (start$2,
		                timezone_local,
		                ev[5][9][10],
		                function(c){return cont([0, [0, c, b], a]);});
		      });
		                                    });
		                          }
		                          function a(groups){
		                           function merge_pass(param, cont){
		                            if(! param) return cont(0);
		                            var tl = param[2], hd = param[1];
		                            function a(t, init){
		                             if(t){
		                              var
		                               l = t[2],
		                               group = t[1],
		                               unmerged$0 = init[2],
		                               merged$0 = init[1],
		                               b = group[1],
		                               end2 = b[2],
		                               start2 = b[1],
		                               b = merged$0[1],
		                               end1 = b[2],
		                               start1 = b[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (symbol$74,
		                                       start1,
		                                       start2,
		                                       function(c){
		function b(c){
		 function b(b){
		  if(! b)
		   return caml_exact_trampoline_call2
		           (a, l, [0, merged$0, [0, group, unmerged$0]]);
		  var
		   group2 = group[2],
		   b = group[1],
		   end2 = b[2],
		   start2 = b[1],
		   group1 = merged$0[2],
		   b = merged$0[1],
		   end1 = b[2],
		   start1 = b[1];
		  return caml_exact_trampoline_cps_call$1
		          (By$1[58],
		           group1,
		           group2,
		           function(b){
		            return caml_exact_trampoline_cps_call$1
		                    (max$13,
		                     end1,
		                     end2,
		                     function(c){
		                      return caml_exact_trampoline_cps_call$1
		                              (min$12,
		                               start1,
		                               start2,
		                               function(d){
		                                return caml_exact_trampoline_call2
		(a, l, [0, [0, [0, d, c], b], unmerged$0]);
		                               });
		                     });
		           });
		 }
		 return c
		         ? b(c)
		         : caml_exact_trampoline_cps_call$1
		           (symbol$74,
		            start2,
		            start1,
		            function(a){
		             return a
		                     ? caml_exact_trampoline_cps_call$1
		                       (symbol$76, start1, end2, b)
		                     : b(a);
		            });
		}
		return c
		        ? caml_exact_trampoline_cps_call$1
		          (symbol$76, start2, end1, b)
		        : b(c);
		                                       });
		                             }
		                             var unmerged = init[2], merged = init[1];
		                             return caml_exact_trampoline_cps_call
		                                     (merge_pass,
		                                      unmerged,
		                                      function(a){return cont([0, merged, a]);});
		                            }
		                            return a(tl, [0, hd, 0]);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (merge_pass,
		                                    groups,
		                                    function(merged){
		                                     return caml_exact_trampoline_cps_call
		     (length$1,
		      groups,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (length$1,
		                merged,
		                function(d){
		                 if(d < b) return caml_exact_trampoline_call1(a, merged);
		                 var init = Time_map[111];
		                 function c(t, groups){
		                  if(! t)
		                   return caml_exact_trampoline_cps_call$0
		                           (fold$5,
		                            groups,
		                            Time_map[111],
		                            function(a, param, time_points, cont){
		                             var by_start = param[2], group_end = param[1];
		                             return caml_exact_trampoline_cps_call$0
		                                     (set$3,
		                                      time_points,
		                                      group_end,
		                                      [0, 622790102, group_end],
		                                      function(time_points){
		                                       return caml_exact_trampoline_cps_call$0
		       (fold$5,
		        by_start,
		        time_points,
		        function(key, data, time_points, cont){
		         return caml_exact_trampoline_cps_call$0
		                 (set$3,
		                  time_points,
		                  key,
		                  [0, 48114461, [0, key, data]],
		                  cont);
		        },
		        cont);
		                                      });
		                            },
		                            function(time_points){
		                             var open = g(include$0), and = open[18], let$ = open[17];
		                             function a(param, cont){
		                              var evening_start = param[2], day_start = param[1];
		                              return caml_exact_trampoline_cps_call
		                                      (min_elt$3,
		                                       time_points,
		                                       function(a){
		function c(){
		 return b([0, -800756764, day_start], time_points);
		}
		function b(initial, time_points){
		 return caml_exact_trampoline_cps_call
		         (max_elt$3,
		          time_points,
		          function(match){
		           function b(time_points){
		            return caml_exact_trampoline_cps_call$0
		                    (fold$5,
		                     time_points,
		                     [0, initial, Time_map[111]],
		                     function(key, data, a, cont){
		                      var day = a[2], start_kind = a[1], variant = start_kind[1];
		                      a:
		                      {
		                       if(48114461 <= variant){
		                        if(622790102 > variant){
		                         a = start_kind[2];
		                         var evs = a[2], start$0 = a[1];
		                         return caml_exact_trampoline_cps_call
		                                 (encode,
		                                  evs,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call
		   (of_list,
		    a,
		    function(a){
		     return caml_trampoline_cps_call3
		             (map$18,
		              a,
		              function(ev, cont){return cont([0, ev]);},
		              function(a){
		               return caml_exact_trampoline_cps_call$0
		                       (Time_map[19],
		                        day,
		                        start$0,
		                        a,
		                        function(day){return cont([0, data, day]);});
		              });
		    });
		                                  });
		                        }
		                        if(typeof data !== "number"){
		                         var variant$0 = data[1];
		                         if(622790102 === variant$0)
		                          return cont([0, [0, 622790102, key], day]);
		                        }
		                       }
		                       else {
		                        if(-740052504 <= variant){
		                         if(typeof data === "number") break a;
		                         var variant$1 = data[1];
		                         if(622790102 === variant$1)
		                          return cont([0, [0, 622790102, key], day]);
		                         break a;
		                        }
		                        if(typeof data !== "number" && 622790102 === data[1])
		                         break a;
		                       }
		                       if(typeof data !== "number" && -800756764 === data[1])
		                        break a;
		                       var
		                        start = start_kind[2],
		                        end = 48114461 <= data[1] ? data[2][1] : data[2];
		                       return caml_exact_trampoline_cps_call$1
		                               (symbol$76,
		                                start,
		                                end,
		                                function(a){
		                                 if(! a) return cont([0, data, day]);
		                                 a:
		                                 {
		                                  if(typeof data !== "number"){
		                                   var variant$0 = data[1];
		                                   if(-740052504 === variant$0){var pause_kind = 0; break a;}
		                                  }
		                                  if(typeof start_kind !== "number"){
		                                   var variant = start_kind[1];
		                                   if(-800756764 === variant){pause_kind = 1; break a;}
		                                  }
		                                  pause_kind = 2;
		                                 }
		                                 var pause = [1, [0, start, key, pause_kind]];
		                                 return caml_exact_trampoline_cps_call$0
		 (Time_map[19],
		  day,
		  start,
		  [0, pause, 0],
		  function(day){return cont([0, data, day]);});
		                                });
		                      }
		                      a = caml_pop_trap();
		                      return a
		                              (caml_maybe_attach_backtrace([0, Assert_failure, a67], 1));
		                     },
		                     function(match){
		                      var day_map = match[2];
		                      return caml_exact_trampoline_cps_call
		                              (encode,
		                               day_map,
		                               function(a){
		                                return caml_exact_trampoline_cps_call(of_list, a, cont);
		                               });
		                     });
		           }
		           function a(){
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     time_points,
		                     evening_start,
		                     [0, -740052504, evening_start],
		                     b);
		           }
		           if(! match) return a();
		           var max_time = match[1][1];
		           return caml_exact_trampoline_cps_call$1
		                   (symbol$73,
		                    max_time,
		                    evening_start,
		                    function(c){return c ? b(time_points) : a();});
		          });
		}
		if(! a) return c();
		a = a[1];
		var min_data = a[2], min_time = a[1];
		return caml_exact_trampoline_cps_call$1
		        (symbol$74,
		         min_time,
		         day_start,
		         function(a){
		          return a
		                  ? caml_exact_trampoline_cps_call$1
		                    (remove$2,
		                     time_points,
		                     min_time,
		                     function(a){return b(min_data, a);})
		                  : c();
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$0
		                                     (to_time$2,
		                                      timezone_local,
		                                      date,
		                                      day_start,
		                                      function(left){
		                                       return caml_exact_trampoline_cps_call$0
		       (to_time$2,
		        timezone_local,
		        date,
		        evening_start,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (and,
		                  left,
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                  });
		        });
		                                      });
		                            });
		                  var
		                   l = t[2],
		                   a = t[1],
		                   group_events = a[2],
		                   match = a[1],
		                   group_end = match[2],
		                   group_start = match[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (fold$5,
		                           group_events,
		                           Time_map[111],
		                           function(param, ev, by_start, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (start$2,
		                                     timezone_local,
		                                     ev[5][9][10],
		                                     function(start){
		                                      return caml_exact_trampoline_cps_call$1
		      (end$1,
		       timezone_local,
		       ev[5][9][10],
		       function(end){
		        return caml_exact_trampoline_cps_call$0
		                (update$0,
		                 by_start,
		                 start,
		                 function(param, cont){
		                  if(! param)
		                   return caml_exact_trampoline_cps_call$1
		                           (Time_map[112], end, [0, ev, 0], cont);
		                  var by_end = param[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (add_multi$0, by_end, end, ev, cont);
		                 },
		                 cont);
		       });
		                                     });
		                           },
		                           function(by_start){
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     groups,
		                                     group_start,
		                                     [0, group_end, by_start],
		                                     function(init){
		                                      return caml_exact_trampoline_call2(c, l, init);
		                                     });
		                           });
		                 }
		                 return c(merged, init);
		                });
		      });
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (map$18, events, singleton, a);
		                         });
		               }
		               var Logs$7 = with_tag$0(component$0, "Controller.Events");
		               function Lookup(Incremental){
		                var
		                 Monad =
		                   S_to_S2
		                    ([0,
		                      Incremental[72],
		                      Incremental[73],
		                      ,
		                      Incremental[75],
		                      Incremental[76],
		                      Incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Incremental[82]]);
		                function get(state, id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find$6, state[6][2], id, cont);
		                }
		                function get_recurrent(state, id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find$6, state[7][2], id, cont);
		                }
		                return Make_get_by_date
		                        ([0,
		                          [0,
		                           [0, , make_occurrence, make_occurrence_by_date, snap$1],
		                           [0, value_map$0],
		                           id$34],
		                          Monad,
		                          get,
		                          get_recurrent]);
		               }
		               function lookup$0(Incremental, state, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (Lookup(Incremental)[4], state, id, cont);
		               }
		               function get_from_state$0(incr, id, cont){
		                var values = incr[5], incremental = incr[1];
		                return caml_exact_trampoline_cps_call$0
		                        (lookup$0,
		                         incremental,
		                         values,
		                         id,
		                         function(event_incr){
		                          return caml_trampoline_cps_call3
		                                  (incremental[46],
		                                   0,
		                                   event_incr,
		                                   function(obs){
		                                    return caml_trampoline_cps_call2
		    (incremental[49],
		     0,
		     function(match){
		      return caml_trampoline_cps_call2
		              (incremental[45][6], obs, cont);
		     });
		                                   });
		                         });
		               }
		               function id$39(t){return t[6];}
		               function generic$0(id){return [0, id];}
		               caml_callback(M$3, [[0, comparator$11, schema_versioned$1]]);
		               caml_callback(M$2, [[0, comparator$11, schema_versioned$1]]);
		               caml_callback(M$3, [[0, comparator$14, schema_versioned$102]]);
		               function append$9(crdt, incr, section, event_id, block, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$0,
		                         incr,
		                         event_id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (Logs$7[6][4],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call6
		     (m, 0, 0, a68, pp$35, event_id, cont);
		                                    },
		                                    function(match){return cont(0);});
		                          var event = match[1], doc = event[9][8];
		                          return caml_exact_trampoline_cps_call$0
		                                  (crdt_append,
		                                   doc,
		                                   section,
		                                   block,
		                                   function(doc_op){
		                                    function a(param, cont){
		                                     return caml_exact_trampoline_cps_call
		     (notes$0,
		      doc_op,
		      function(a){
		       return caml_trampoline_cps_call2
		               (element$3,
		                event_id,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(events, a, cont);
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (state_personal,
		     crdt,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (force$1,
		               b,
		               event_id,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (bind$30,
		                         b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (ignore_m$11,
		                                   a,
		                                   function(routine_op){
		                                    return cont([0, [0, event, routine_op]]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function apply$127(id, event_and_calendar, f, cont){
		                g
		                 ([0,
		                   symbol_bind$8,
		                   symbol_map$6,
		                   ,
		                   bind$10,
		                   return$12,
		                   map$23,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$4]);
		                if(! event_and_calendar)
		                 return caml_exact_trampoline_cps_call
		                         (Logs$7[6][5],
		                          function(m, cont){
		                           return caml_trampoline_cps_call6
		                                   (m, 0, 0, a69, pp$35, id, cont);
		                          },
		                          function(match){return cont(0);});
		                var
		                 match = event_and_calendar[1],
		                 calendar = match[2],
		                 event = match[1];
		                return caml_exact_trampoline_cps_call$1
		                        (f, event, calendar, function(a){return cont([0, a]);});
		               }
		               function day_events(param, primary, date, filter, cont){
		                var
		                 incremental = param[1],
		                 incr_state = param[4],
		                 events_recurrent = incr_state[7],
		                 events = incr_state[6],
		                 calendars = incr_state[1],
		                 by_date = param[2],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 symbol = open[10],
		                 let$ = open[8],
		                 and = open[6],
		                 let$0 = open[4],
		                 let$1 = open[3],
		                 symbol_map = open[2],
		                 symbol_bind = open[1];
		                function augment_if_show(event, cont){
		                 var id$0 = event[1];
		                 function a(calendar, cont){
		                  var a = event[9][10];
		                  function b(show){
		                   return caml_exact_trampoline_cps_call$1
		                           (augment$2,
		                            calendar,
		                            event,
		                            function(a){
		                             a = some_if(show, a);
		                             return caml_trampoline_cps_call2(incremental[76], a, cont);
		                            });
		                  }
		                  switch(filter){
		                    case 0:
		                     if(2 === a[0]) return b(0); break;
		                    case 2:
		                     if(2 !== a[0]) return b(0); break;
		                  }
		                  a = 1 - calendar[3];
		                  return a
		                          ? primary
		                            ? caml_exact_trampoline_cps_call$1
		                              (active$1, calendar, event, b)
		                            : b(is_none$0(event[9][1]))
		                          : b(a);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$146,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (b,
		                                    pp$2,
		                                    id$0,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (find$6,
		      calendars[2],
		      id$0,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$230,
		                c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                function b(id$0, cont){
		                 function a(event, cont){
		                  var is_singular = 0 === id$0[0] ? 1 : 0;
		                  function a(augmented, cont){
		                   var a = some_if(is_singular, augmented);
		                   return caml_trampoline_cps_call2(incremental[76], a, cont);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (augment_if_show,
		                           event,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$147,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (b,
		                                    pp$35,
		                                    id$0,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (find$6,
		      events[2],
		      id$0,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$230,
		                c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                function a(events, cont){
		                 return caml_trampoline_cps_call2
		                         (incremental[80],
		                          events,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (incremental[77], a, filter_opt, cont);
		                          });
		                }
		                function c(a, cont){
		                 return caml_trampoline_cps_call3(map$18, a, b, cont);
		                }
		                function d(a, cont){return cont(value$4(a, 0));}
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         by_date[2],
		                         date,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol,
		                                   b,
		                                   to_list$3,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     d,
		     function(b){
		      return caml_trampoline_cps_call3
		              (symbol_map,
		               b,
		               c,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$1,
		                         b,
		                         a,
		                         function(singular_events){
		                          function f(event, cont){
		                           return caml_trampoline_cps_call3
		                                   (let$1,
		                                    event,
		                                    function(event, cont){
		                                     var id_rec = event[5];
		                                     function a(param, cont){
		                                      if(! param)
		                                       return caml_trampoline_cps_call2(incremental[76], 0, cont);
		                                      var event = param[1];
		                                      return caml_exact_trampoline_cps_call
		      (augment_if_show, event, cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call$0
		     (Lookup(incremental)[6],
		      incr_state,
		      id_rec,
		      date,
		      function(b){
		       return caml_trampoline_cps_call3(symbol_bind, b, a, cont);
		      });
		                                    },
		                                    cont);
		                          }
		                          return caml_exact_trampoline_cps_call$7
		                                  (filter_map$6,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   events_recurrent[1],
		                                   f,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     a,
		     encode,
		     function(occurrences){
		      function a(param, cont){
		       var occurrences = param[2], singular_events = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (append$0, occurrences, singular_events, cont);
		      }
		      return caml_trampoline_cps_call3
		              (and,
		               singular_events,
		               occurrences,
		               function(b){
		                return caml_trampoline_cps_call3(let$0, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function day_events_ids(values, primary, day, filter, cont){
		                var
		                 Incr = values[1],
		                 open =
		                   g
		                    ([0,
		                      Incr[72],
		                      Incr[73],
		                      ,
		                      Incr[75],
		                      Incr[76],
		                      Incr[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Incr[82]]),
		                 symbol_map = open[2];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$148,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   pp_v1$0,
		                                   day,
		                                   function(d){
		                                    function a(x, y, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (equal_with_local_closure, equal$51, x, y, cont);
		                                    }
		                                    function b(e, cont){return cont(e[5][6]);}
		                                    function c(a, cont){
		                                     return caml_trampoline_cps_call3(map$18, a, b, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (day_events,
		     values,
		     primary,
		     day,
		     filter,
		     function(b){
		      return caml_trampoline_cps_call3
		              (symbol_map,
		               b,
		               c,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$230, symbol$229(b, a), d, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function day$0(param, primary, filter, day, cont){
		                var incremental = param[1][1];
		                return caml_exact_trampoline_cps_call
		                        (Logs$7[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a6$, pp_v1$0, day, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$2
		                                  (day_events_ids,
		                                   incremental,
		                                   primary,
		                                   day,
		                                   filter,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function days$1(param, primary, filter, days, cont){
		                var
		                 incremental = param[1][1],
		                 Incr = incremental[1],
		                 open =
		                   g
		                    ([0,
		                      Incr[72],
		                      Incr[73],
		                      ,
		                      Incr[75],
		                      Incr[76],
		                      Incr[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Incr[82]]),
		                 let$ = open[4];
		                return caml_exact_trampoline_cps_call
		                        (Logs$7[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a7a, list([0, comma], pp_v1$0), days, cont);
		                         },
		                         function(match){
		                          function a(days, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (of_list,
		                                    days,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (Ids$0[76],
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call(Ids$0[29], a, cont);
		      });
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   days,
		                                   function(day, cont){
		                                    return caml_exact_trampoline_cps_call$2
		    (day_events_ids, incremental, primary, day, filter, cont);
		                                   },
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (Incr[80],
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function timeline(param, day, cont){
		                var
		                 incremental = param[1][1],
		                 Incr = incremental[1],
		                 open =
		                   g
		                    ([0,
		                      Incr[72],
		                      Incr[73],
		                      ,
		                      Incr[75],
		                      Incr[76],
		                      Incr[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Incr[82]]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                return caml_exact_trampoline_cps_call
		                        (Logs$7[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a7b, pp_v1$0, day, cont);
		                         },
		                         function(match){
		                          function a(events, cont){
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    incremental[4][30],
		                                    function(hours_config, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (of_events,
		      hours_config,
		      day,
		      events,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (ok_or_failwith, a, cont);
		      });
		                                    },
		                                    cont);
		                          }
		                          return caml_exact_trampoline_cps_call$2
		                                  (day_events,
		                                   incremental,
		                                   1,
		                                   day,
		                                   2,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$0,
		     b,
		     a,
		     function(res){
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$149,
		               function(a){
		                return caml_trampoline_cps_call3
		                        (a,
		                         pp_v1$0,
		                         day,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$230,
		                                   res,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function lookup$1(t, incremental, incr_state, id, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (lookup$0, incremental, incr_state, id, cont);
		               }
		               function first_occurrence(a, id, cont){
		                a = a[1][1];
		                var
		                 state = a[4],
		                 incremental = a[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 symbol_bind = open[1];
		                function b(param, cont){
		                 if(! param)
		                  return caml_trampoline_cps_call2(incremental[76], 0, cont);
		                 var event = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (first_time,
		                          event[7],
		                          function(b){
		                           var o = event[7][4];
		                           if(o) var x = o[1], tz = x[3], a = tz; else a = timezone;
		                           return caml_exact_trampoline_cps_call$1
		                                   (start_date$1,
		                                    a,
		                                    b,
		                                    function(first_time){
		                                     return caml_exact_trampoline_cps_call$1
		     (occurrences,
		      first_time,
		      to_mandate(event[7][9]),
		      function(all_times){
		       return caml_exact_trampoline_cps_call$1
		               (filter_map$1,
		                all_times,
		                function(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (make_occurrence, event, a, cont);
		                },
		                function(y){
		                 return caml_exact_trampoline_cps_call$1
		                         (take$1,
		                          y,
		                          1,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_binable,
		                                    a,
		                                    function(occurrences){
		                                     return caml_trampoline_cps_call3
		     (map$18,
		      occurrences,
		      function(occurrence, cont){
		       return caml_exact_trampoline_cps_call$1
		               (Lookup(incremental)[1], state, occurrence, cont);
		      },
		      function(a){
		       return caml_trampoline_cps_call2(incremental[80], a, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (lookup,
		                         dummy,
		                         incremental,
		                         state,
		                         id,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (symbol_bind,
		                                   a,
		                                   b,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental,
		     0,
		     a,
		     function(a){return cont(map$53(a, hd$0));});
		                                   });
		                         });
		               }
		               function merge_windows(windows, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (stable_sort,
		                         windows,
		                         function(a, param, cont){
		                          var s2 = param[1], s1 = a[1];
		                          return caml_trampoline_cps_call3(compare$37, s1, s2, cont);
		                         },
		                         function(t){
		                          function a(t, init){
		                           if(! t)
		                            return caml_exact_trampoline_cps_call
		                                    (of_rev_keys, init, cont);
		                           var l = t[2], a$0 = t[1], end = a$0[2], start = a$0[1];
		                           function b(){
		                            return caml_exact_trampoline_call2
		                                    (a, l, [0, [0, start, end], init]);
		                           }
		                           if(! init) return b();
		                           var
		                            rest = init[2],
		                            match = init[1],
		                            acc_end = match[2],
		                            acc_start = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$74,
		                                    start,
		                                    acc_end,
		                                    function(c){
		                                     return c
		     ? caml_exact_trampoline_cps_call$1
		       (max$13,
		        acc_end,
		        end,
		        function(b){
		         return caml_exact_trampoline_call2
		                 (a, l, [0, [0, acc_start, b], rest]);
		        })
		     : b();
		                                    });
		                          }
		                          return a(t, 0);
		                         });
		               }
		               function remove_busy_windows(available, busy, cont){
		                function a(t, available){
		                 if(! t) return cont(available);
		                 var
		                  l = t[2],
		                  a$0 = t[1],
		                  busy_end = a$0[2],
		                  busy_start = a$0[1];
		                 function f(param, cont){
		                  var end = param[2], start = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$73,
		                           busy_start,
		                           end,
		                           function(b){
		                            function a(){return cont([0, [0, start, end], 0]);}
		                            return b
		                                    ? a()
		                                    : caml_exact_trampoline_cps_call$1
		                                      (symbol$74,
		                                       busy_end,
		                                       start,
		                                       function(b){
		return b
		        ? a()
		        : caml_exact_trampoline_cps_call$1
		          (symbol$73,
		           busy_end,
		           end,
		           function(match){
		            return caml_exact_trampoline_cps_call$1
		                    (symbol$74,
		                     busy_start,
		                     start,
		                     function(a){
		                      return a
		                              ? match ? cont(0) : cont([0, [0, busy_end, end], 0])
		                              : match
		                                ? cont([0, [0, start, busy_start], 0])
		                                : cont
		                                  ([0, [0, start, busy_start], [0, [0, busy_end, end], 0]]);
		                     });
		           });
		                                       });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (concat_map,
		                          available,
		                          f,
		                          function(init){
		                           return caml_exact_trampoline_call2(a, l, init);
		                          });
		                }
		                return a(busy, available);
		               }
		               function busy_windows_from_events
		               (a, opt, crdt, events, start, end, cont){
		                var
		                 warn_missing_event =
		                   a ? a[1] : function(param, cont){return cont();},
		                 warn_missing_calendar =
		                   opt ? opt[1] : function(param, cont){return cont();};
		                return caml_exact_trampoline_cps_call$1
		                        (of_time$0,
		                         timezone_local,
		                         start,
		                         function(start_date){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_time$0,
		                                   timezone_local,
		                                   end,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (add_days,
		     a,
		     1,
		     function(end_date){
		      return caml_exact_trampoline_cps_call
		              (to_binable,
		               enumerate_days(start_date, end_date),
		               function(days){
		                var init = empty$8([0, comparator$14]);
		                function a(t, event_ids){
		                 if(t){
		                  var
		                   l = t[2],
		                   day = t[1],
		                   by_date_observer = events[1][1][3];
		                  return caml_exact_trampoline_cps_call
		                          (observer_value_exn,
		                           by_date_observer,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     b,
		                                     day,
		                                     function(match){
		                                      if(! match)
		                                       return caml_exact_trampoline_call2(a, l, event_ids);
		                                      var events = match[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (union$0,
		       event_ids,
		       events,
		       function(b){return caml_exact_trampoline_call2(a, l, b);});
		                                     });
		                           });
		                 }
		                 function f(l, id, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (get_event$1,
		                           crdt,
		                           id,
		                           function(match){
		                            if(! match)
		                             return caml_exact_trampoline_cps_call
		                                     (warn_missing_event, id, function(match){return cont(l);});
		                            var event = match[1];
		                            function blocks(param){
		                             return availability$0(event) ? 0 : 1;
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (get_calendar$0,
		                                     crdt,
		                                     event[1],
		                                     function(match){
		                                      if(! match)
		                                       return caml_exact_trampoline_cps_call
		       (warn_missing_calendar,
		        event,
		        function(match){
		         return blocks() ? cont([0, event, l]) : cont(l);
		        });
		                                      var calendar = match[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (active$1,
		       calendar,
		       event,
		       function(a){
		        if(a && blocks()) return cont([0, event, l]);
		        return cont(l);
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (fold$3,
		                          event_ids,
		                          0,
		                          f,
		                          function(matching_events){
		                           function f(event, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (end$1,
		                                     timezone_local,
		                                     event[9][10],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (start$2,
		       timezone_local,
		       event[9][10],
		       function(b){return cont([0, b, a]);});
		                                     });
		                           }
		                           return caml_trampoline_cps_call3
		                                   (map$18, matching_events, f, cont);
		                          });
		                }
		                return a(days, init);
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$908 = [];
		               function constraint_kind_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$908[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a7c, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$908[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$908[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$908[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(a7g);},
		                                  0,
		                                  0,
		                                  cst_include,
		                                  "Include",
		                                  a7f,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(a7e) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_exclude,
		                                   "Exclude",
		                                   a7d,
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$908[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$908[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$875 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$908, [0, schematic_cache$875]);
		               caml_callback
		                (constraint_kind_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               function day_available_windows
		               (crdt, events, constraints, from, date, cont){
		                var
		                 open$0 =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$1 = open$0[4],
		                 let$2 = open$0[3],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function to_window(param, cont){
		                 var end = param[2], start = param[1];
		                 function a(start, cont){
		                  function a(end, cont){return cont([0, start, end]);}
		                  return caml_exact_trampoline_cps_call$0
		                          (to_time$2,
		                           timezone_local,
		                           date,
		                           end,
		                           function(b){
		                            return caml_trampoline_cps_call3(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (to_time$2,
		                          timezone_local,
		                          date,
		                          start,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$0, b, a, cont);
		                          });
		                }
		                function occurring(kind, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (filter,
		                          constraints,
		                          function(c, cont){
		                           var lhs = c[1];
		                           a:
		                           {
		                            if(lhs){
		                             if(kind){var a = 1; break a;}
		                            }
		                            else if(! kind){a = 1; break a;}
		                            a = 0;
		                           }
		                           if(! a) return cont(a);
		                           var rule = c[2];
		                           return caml_exact_trampoline_cps_call$1
		                                   (snap,
		                                    [0, a7h, rule],
		                                    date,
		                                    function(match){
		                                     if(! match) return cont(0);
		                                     var snapped = match[1][1];
		                                     return caml_exact_trampoline_cps_call$1
		     (equal$21, snapped, date, cont);
		                                    });
		                          },
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$18, a, function(c, cont){return cont(c[3]);}, cont);
		                          });
		                }
		                function a(included, cont){
		                 function a(excluded, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (remove_busy_windows, included, excluded, cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (occurring,
		                          1,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    b,
		                                    to_window,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (all$14,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          });
		                }
		                function b(windows, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (filter_map$0,
		                          windows,
		                          function(param, cont){
		                           var end = param[2], start = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (max$13,
		                                    start,
		                                    from,
		                                    function(start){
		                                     var a = [0, start, end];
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$76,
		      start,
		      end,
		      function(b){return cont(some_if(b, a));});
		                                    });
		                          },
		                          function(windows){
		                           if(! windows)
		                            return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                           function a(day_start, cont){
		                            function a(day_end, cont){
		                             return caml_exact_trampoline_cps_call$7
		                                     (busy_windows_from_events,
		                                      0,
		                                      0,
		                                      crdt,
		                                      events,
		                                      day_start,
		                                      day_end,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (remove_busy_windows, windows, a, cont);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$0
		                                    (to_time$2,
		                                     timezone_local,
		                                     date,
		                                     latest,
		                                     function(b){
		                                      return caml_trampoline_cps_call3(let$1, b, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (to_time$2,
		                                    timezone_local,
		                                    date,
		                                    midnight,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$2, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (occurring,
		                         0,
		                         function(includes){
		                          function c(c){
		                           return caml_trampoline_cps_call3
		                                   (let$0,
		                                    c,
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(let$2, a, b, cont);
		                                    });
		                          }
		                          if(includes){
		                           var
		                            d =
		                              function(windows, cont){
		                               return caml_exact_trampoline_cps_call
		                                       (merge_windows, windows, cont);
		                              };
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    includes,
		                                    to_window,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (all$14,
		      a,
		      function(a){
		       return caml_trampoline_cps_call3(let$, a, d, c);
		      });
		                                    });
		                          }
		                          function e(window, cont){return cont([0, window, 0]);}
		                          return caml_exact_trampoline_cps_call
		                                  (to_window,
		                                   [0, midnight, latest],
		                                   function(a){
		                                    return caml_trampoline_cps_call3(let$, a, e, c);
		                                   });
		                         });
		               }
		               function find_available_windows
		               (crdt,
		                events,
		                from,
		                limit,
		                constraints,
		                duration,
		                until,
		                param,
		                cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 t = ocaml_ptime_clock_now_d_ps(),
		                 from$0 = value$4(from, t);
		                return caml_exact_trampoline_cps_call$1
		                        (of_time$0,
		                         timezone_local,
		                         from$0,
		                         function(from_date){
		                          if(! until && ! limit)
		                           return cont
		                                   ([1,
		                                     "find_available_windows requires ~until or ~limit to guarantee termination"]);
		                          function fits(param, cont){
		                           var end = param[2], start = param[1];
		                           if(! duration) return cont(1);
		                           var duration$0 = duration[1], s = symbol$58(end, start);
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$70, s, duration$0, cont);
		                          }
		                          var
		                           a =
		                             Sequence_result[7].call
		                              (null,
		                               from_date,
		                               function(date, cont){
		                                function a(){
		                                 return caml_exact_trampoline_cps_call$1
		 (add_days,
		  date,
		  1,
		  function(a){
		   return caml_trampoline_cps_call2
		           (of_string$14, [1, date, a], cont);
		  });
		                                }
		                                if(! until) return a();
		                                var until$0 = until[1];
		                                return caml_exact_trampoline_cps_call$1
		(symbol$82,
		 date,
		 until$0,
		 function(b){
		  return b
		          ? caml_trampoline_cps_call2(of_string$14, 0, cont)
		          : a();
		 });
		                               }),
		                           a =
		                             Sequence_result[32][5].call
		                              (null,
		                               a,
		                               function(date, cont){
		                                function a(windows, cont){
		                                 return cont(Sequence_result[14].call(null, windows));
		                                }
		                                return caml_exact_trampoline_cps_call$3
		(day_available_windows,
		 crdt,
		 events,
		 constraints,
		 from$0,
		 date,
		 function(b){
		  return caml_trampoline_cps_call3(let$, b, a, cont);
		 });
		                               }),
		                           a = Sequence_result[9].call(null, a),
		                           windows = Sequence_result[21].call(null, a, fits);
		                          if(limit)
		                           var
		                            limit$0 = limit[1],
		                            windows$0 = Sequence_result[12].call(null, windows, limit$0);
		                          else
		                           windows$0 = windows;
		                          return caml_exact_trampoline_cps_call
		                                  (Sequence_result[16], windows$0, cont);
		                         });
		               }
		               var Logs$8 = with_tag$0(component$0, "Controller.Mandate");
		               function destination_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (document_schema_versioned,
		                                   schematic_version,
		                                   function(dest){
		                                    return caml_exact_trampoline_cps_call
		    (fixpoint,
		     function(descriptor, cont){
		      var
		       a =
		         [0,
		          field
		           (0,
		            0,
		            0,
		            0,
		            0,
		            2,
		            0,
		            0,
		            cst_children,
		            [0, list_schema([0, id$8, 0, descriptor, 0])]),
		          0];
		      return caml_exact_trampoline_cps_call
		              (matchable_schema_versioned,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (b,
		                         dest,
		                         function(b){
		                          return cont
		                                  (object
		                                    (function(param, cont){
		                                      var children = param[2][1], matchable = param[1];
		                                      return cont([0, matchable, children]);
		                                     },
		                                     function(param, cont){
		                                      var children = param[2], matchable = param[1];
		                                      return cont([0, matchable, [0, children, 0]]);
		                                     },
		                                     [0, field(0, 0, 0, 0, 0, 2, 0, 0, cst_matchable, [0, b]), a]));
		                         });
		               });
		     },
		     function(descriptor){
		      return cont([0, a7i, 0, descriptor, 0]);
		     });
		                                   });
		                         });
		               }
		               var
		                schematic_cache$876 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$909 = [];
		               caml_update_dummy
		                (letrec_function_context$909, [0, schematic_cache$876]);
		               function schematic_version$133(param, cont){return cont(0);}
		               var
		                cst_persons = "persons",
		                cst_types = "types",
		                schematic_schema_version$59 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$909[1][1],
		                    schematic_schema_version$59]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$909[1][1],
		                             schematic_schema_version$59,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$909[1][1],
		schematic_schema_version$59,
		schematic_self,
		function(a){
		 letrec_function_context$909[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$501,
		          schematic_version$133,
		          function(b){
		           var
		            a =
		              [0,
		               [0,
		                0,
		                0,
		                0,
		                0,
		                cst_types,
		                0,
		                2,
		                [0, [0, 0, 0, [3, b], 0]],
		                0,
		                0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$188,
		                    schematic_version$133,
		                    function(b){
		                     return caml_trampoline_cps_call3
		                             (By$11[102],
		                              schematic_version$133,
		                              b,
		                              function(c){
		                               var
		                                b =
		                                  [0,
		                                   [0, 0, 0, 0, 0, "tasks_recurrent", 0, 2, [0, c], 0, 0],
		                                   a];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$186,
		schematic_version$133,
		function(a){
		 return caml_trampoline_cps_call3
		         (By$5[102],
		          schematic_version$133,
		          a,
		          function(c){
		           var
		            a = [0, [0, 0, 0, 0, 0, cst_tasks, 0, 2, [0, c], 0, 0], b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$514,
		                    schematic_version$133,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "priorities",
		                          0,
		                          2,
		                          [0, [0, 0, 0, [3, c], 0]],
		                          0,
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$341,
		                              schematic_version$133,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (By$18[102],
		schematic_version$133,
		a,
		function(c){
		 var
		  a = [0, [0, 0, 0, 0, 0, cst_persons, 0, 2, [0, c], 0, 0], b];
		 return caml_exact_trampoline_cps_call
		         (workspaced_schema_versioned,
		          schematic_version$133,
		          function(b){
		           return caml_trampoline_cps_call3
		                   (By$2[102],
		                    schematic_version$133,
		                    b,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "mru_emails",
		                          0,
		                          2,
		                          [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                          0,
		                          0],
		                         [0, [0, 0, 0, 0, 0, cst_pages, 0, 2, [0, c], 0, 0], a]];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$131,
		                              schematic_version$133,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_mru_destinations,
		                                    0,
		                                    2,
		                                    [0, [0, 0, 0, [3, c], 0]],
		                                    0,
		                                    0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$209,
		schematic_version$133,
		function(c){
		 var
		  b = [0, [0, 0, 0, 0, 0, cst_locale, 0, 2, [0, c], 0, 0], a];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$1,
		          schematic_version$133,
		          function(c){
		           var
		            a =
		              [0,
		               [0, 0, 0, 0, 0, "last_scheduling", 0, 3, [0, c], 0, 0],
		               b];
		           return caml_exact_trampoline_cps_call
		                   (schema_versioned$512,
		                    schematic_version$133,
		                    function(c){
		                     var
		                      b =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_labels,
		                          0,
		                          2,
		                          [0, [0, 0, 0, [3, c], 0]],
		                          0,
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$216,
		                              schematic_version$133,
		                              function(c){
		                               var
		                                a =
		                                  [0,
		                                   [0, 0, 0, 0, 0, "hours_settings", 0, 2, [0, c], 0, 0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (schema_versioned$230,
		schematic_version$133,
		function(b){
		 return caml_trampoline_cps_call3
		         (By$1[102],
		          schematic_version$133,
		          b,
		          function(c){
		           var
		            b = [0, [0, 0, 0, 0, 0, cst_events, 0, 2, [0, c], 0, 0], a];
		           return caml_exact_trampoline_cps_call
		                   (destination_schema_versioned,
		                    schematic_version$133,
		                    function(c){
		                     var
		                      a =
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          "custom_objects",
		                          0,
		                          2,
		                          [0, [0, 0, 0, [3, c], 0]],
		                          0,
		                          0],
		                         b];
		                     return caml_exact_trampoline_cps_call
		                             (schema_versioned$206,
		                              schematic_version$133,
		                              function(b){
		                               return caml_trampoline_cps_call3
		                                       (By_id$0[109],
		schematic_version$133,
		b,
		function(b){
		 var
		  res =
		    [7,
		     function(param, cont){
		      var
		       a = param[2],
		       b = a[2],
		       c = b[2],
		       d = c[2],
		       e = d[2],
		       f = e[2],
		       g = f[2],
		       h = g[2],
		       i = h[2],
		       j = i[2],
		       k = j[2],
		       l = k[2],
		       m = l[2],
		       types = m[2][1],
		       tasks_recurrent = m[1],
		       tasks = l[1],
		       priorities = k[1],
		       persons = j[1],
		       pages = i[1],
		       mru_emails = h[1],
		       mru_destinations = g[1],
		       locale = f[1],
		       last_scheduling = e[1],
		       labels = d[1],
		       hours_settings = c[1],
		       events = b[1],
		       custom_objects = a[1],
		       calendars = param[1];
		      return cont
		              ([0,
		                calendars,
		                custom_objects,
		                events,
		                hours_settings,
		                labels,
		                last_scheduling,
		                locale,
		                mru_destinations,
		                mru_emails,
		                pages,
		                persons,
		                priorities,
		                tasks,
		                tasks_recurrent,
		                types]);
		     },
		     function(param, cont){
		      var
		       types = param[15],
		       tasks_recurrent = param[14],
		       tasks = param[13],
		       priorities = param[12],
		       persons = param[11],
		       pages = param[10],
		       mru_emails = param[9],
		       mru_destinations = param[8],
		       locale = param[7],
		       last_scheduling = param[6],
		       labels = param[5],
		       hours_settings = param[4],
		       events = param[3],
		       custom_objects = param[2],
		       calendars = param[1];
		      return cont
		              ([0,
		                calendars,
		                [0,
		                 custom_objects,
		                 [0,
		                  events,
		                  [0,
		                   hours_settings,
		                   [0,
		                    labels,
		                    [0,
		                     last_scheduling,
		                     [0,
		                      locale,
		                      [0,
		                       mru_destinations,
		                       [0,
		                        mru_emails,
		                        [0,
		                         pages,
		                         [0,
		                          persons,
		                          [0,
		                           priorities,
		                           [0, tasks, [0, tasks_recurrent, [0, types, 0]]]]]]]]]]]]]]]);
		     },
		     [0, [0, 0, 0, 0, 0, cst_calendars, 0, 2, [0, b], 0, 0], a]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$909[1][1],
		          schematic_schema_version$59,
		          res,
		          function(a){
		           letrec_function_context$909[1][1] = a;
		           return cont(res);
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               caml_callback
		                (destination_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function destination_of_object
		               (alternate, opt, id, title, notes, cont){
		                var children = opt ? opt[1] : 0;
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         notes[1],
		                         function(a, cont){
		                          a = a[2];
		                          if(typeof a !== "number" && 6 === a[0]){
		                           a = a[1];
		                           var level = a[2], content = a[1];
		                           return cont
		                                   ([0,
		                                     make_destination
		                                      (content, 0, a7j, [0, id, [0, [0, content, level]]])]);
		                          }
		                          return cont(0);
		                         },
		                         function(headings){
		                          var a = [0, id, 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (append$0,
		                                   headings,
		                                   children,
		                                   function(b){
		                                    return cont(make_destination(title, alternate, [0, b], a));
		                                   });
		                         });
		               }
		               function destination_map(param, f, cont){
		                var children = param[2], matchable = param[1];
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         children,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (destination_map, a, f, cont);
		                         },
		                         function(b){
		                          var a = f(matchable[3]);
		                          return cont([0, [0, matchable[1], matchable[2], a], b]);
		                         });
		               }
		               function parser$0(param, features, cont){
		                var config = param[3];
		                return caml_exact_trampoline_cps_call
		                        (Logs$8[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a7l, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (observer_value_exn,
		                                   config,
		                                   function(config){
		                                    g
		                                     ([0,
		                                       symbol_bind$5,
		                                       symbol_map$5,
		                                       ,
		                                       bind$8,
		                                       return$9,
		                                       map$17,
		                                       ,
		                                       ,
		                                       ,
		                                       ,
		                                       Let_syntax$3]);
		                                    var
		                                     locale = make$137(config[7]),
		                                     now = ocaml_ptime_clock_now_d_ps();
		                                    return caml_exact_trampoline_cps_call
		    (today,
		     dummy,
		     function(today){
		      var t = config[6];
		      function b(scheduling_hint){
		       function a(events){
		        function a(pages){
		         var persons = config[11];
		         function f(param, cont){
		          var
		           person = param[2],
		           open =
		             g
		              ([0,
		                symbol_bind$5,
		                symbol_map$5,
		                ,
		                bind$8,
		                return$9,
		                map$17,
		                ,
		                ,
		                ,
		                ,
		                Let_syntax$3]),
		           and = open[6],
		           let$ = open[4],
		           email_primary = person[2],
		           id$0 = person[1];
		          return caml_trampoline_cps_call3
		                  (let$,
		                   person[5],
		                   function(name, cont){
		                    function a(param, cont){
		                     var given = param[2], family = param[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              id,
		                              fmt$150,
		                              function(a){
		                               return caml_trampoline_cps_call3(a, family, given, cont);
		                              });
		                    }
		                    return caml_trampoline_cps_call3
		                            (and,
		                             name[4],
		                             name[3],
		                             function(b){
		                              return caml_trampoline_cps_call3
		                                      (let$,
		                                       b,
		                                       a,
		                                       function(last){return cont([0, name[1], last]);});
		                             });
		                   },
		                   function(c){
		                    if(c){
		                     c = c[1];
		                     var b = c[2], a = c[1], c = [0, [0, a], [0, b]];
		                    }
		                    else
		                     c = a7k;
		                    var last = c[2], name = c[1];
		                    return caml_exact_trampoline_cps_call
		                            (join$2,
		                             last,
		                             function(last){
		                              var other_emails = person[3], source = person[10];
		                              return cont
		                                      ([0,
		id$0,
		source,
		email_primary,
		other_emails,
		name,
		last,
		person[11][1]]);
		                             });
		                   });
		         }
		         return caml_exact_trampoline_cps_call$2
		                 (to_sequence$2,
		                  0,
		                  0,
		                  0,
		                  persons,
		                  function(a){
		                   return caml_trampoline_cps_call3
		                           (map$11,
		                            a,
		                            f,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (to_binable,
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (stable_sort,
		        a,
		        function(a, param, cont){
		         var
		          notes_r = param[7],
		          name_r = param[5],
		          email_r = param[3],
		          source_r = param[2],
		          notes_l = a[7],
		          name_l = a[5],
		          email_l = a[3],
		          source_l = a[2];
		         if(notes_l[1]){
		          if(! notes_r[1]) return cont(-1);
		         }
		         else if(notes_r[1]) return cont(1);
		         return caml_trampoline_cps_call3
		                 (compare$130,
		                  source_l,
		                  source_r,
		                  function(n){
		                   if(0 !== n) return cont(n);
		                   if(! name_l)
		                    return name_r
		                            ? cont(1)
		                            : cont(caml_string_compare(email_l, email_r));
		                   var l = name_l[1];
		                   if(! name_r) return cont(-1);
		                   var r = name_r[1];
		                   return cont(caml_string_compare(l, r));
		                  });
		        },
		        function(persons){
		         function f(seen_names, param, cont){
		          var
		           notes = param[7],
		           last = param[6],
		           name = param[5],
		           other_emails = param[4],
		           email_primary = param[3],
		           id = param[1];
		          if(last)
		           var last$0 = last[1], alternate = [0, last$0, other_emails];
		          else
		           alternate = other_emails;
		          function a(title, alternate, seen_names){
		           return caml_exact_trampoline_cps_call$3
		                   (destination_of_object,
		                    [0, alternate],
		                    0,
		                    [3, id],
		                    title,
		                    notes,
		                    function(res){return cont([0, seen_names, res]);});
		          }
		          if(! name) return a(email_primary, alternate, seen_names);
		          var name$0 = name[1];
		          return caml_exact_trampoline_cps_call$1
		                  (mem$3,
		                   seen_names,
		                   name$0,
		                   function(b){
		                    return b
		                            ? a(email_primary, [0, name$0, alternate], seen_names)
		                            : caml_exact_trampoline_cps_call$1
		                              (add$4,
		                               seen_names,
		                               name$0,
		                               function(b){
		                                return a(name$0, [0, email_primary, alternate], b);
		                               });
		                   });
		         }
		         return caml_exact_trampoline_cps_call
		                 (deconstruct,
		                  persons,
		                  function(t){
		                   var
		                    init = empty$8([0, comparator$2]),
		                    next = t[2],
		                    s = t[1];
		                   return caml_exact_trampoline_cps_call
		                           (to_binable,
		                            [0,
		                             [0, init, s],
		                             function(param, cont){
		                              var s = param[2], seed = param[1];
		                              return caml_trampoline_cps_call2
		                                      (next,
		                                       s,
		                                       function(match){
		if(typeof match === "number") return cont(0);
		if(0 === match[0]){
		 var s = match[1];
		 return cont([0, [0, seed, s]]);
		}
		var s$0 = match[2], a = match[1];
		return caml_exact_trampoline_cps_call$1
		        (f,
		         seed,
		         a,
		         function(match){
		          var seed = match[2], seed$0 = match[1];
		          return cont([1, seed, [0, seed$0, s$0]]);
		         });
		                                       });
		                             }],
		                            function(destinations){
		                             function f(param, cont){
		                              var
		                               last = param[6],
		                               name = param[5],
		                               other_emails = param[4],
		                               email_primary = param[3],
		                               id = param[1];
		                              function make_entry(opt, email){
		                               var
		                                alternate = opt ? opt[1] : 0,
		                                helper = value$4(name, email);
		                               return [0,
		                                       email,
		                                       alternate,
		                                       [0, email, email_primary, helper, id]];
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (filter_opt,
		                                       [0, name, [0, last, 0]],
		                                       function(b){
		var
		 main_email_entry = make_entry([0, b], email_primary),
		 open =
		   g
		    ([0,
		      symbol_bind$2,
		      symbol_map$2,
		      ,
		      bind$5,
		      return$6,
		      map$11,
		      ,
		      ,
		      ,
		      ,
		      Let_syntax$1]),
		 let$ = open[4];
		function a(email, cont){
		 return caml_exact_trampoline_cps_call
		         (filter_opt,
		          [0, name, [0, last, 0]],
		          function(a){return cont(make_entry([0, a], email));});
		}
		return caml_exact_trampoline_cps_call
		        (deconstruct,
		         other_emails,
		         function(b){
		          return caml_trampoline_cps_call3
		                  (let$,
		                   b,
		                   a,
		                   function(other_emails_entry){
		                    return cont
		                            (shift_right(other_emails_entry, main_email_entry));
		                   });
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (deconstruct,
		                                      persons,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (map$11,
		        a,
		        f,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (concat$1,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (to_binable,
		                            a,
		                            function(a){
		                             function arg(param, cont){
		                              var email = param[3][1];
		                              return cont(email);
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (Email$0[23],
		                                      config[9],
		                                      function(b){
		                                       return caml_trampoline_cps_call2
		       (Email$0[22],
		        b,
		        function(b){
		         return caml_trampoline_cps_call3
		                 (b,
		                  a,
		                  arg,
		                  function(participants){
		                   function a(tasks){
		                    function a(tasks_recurrent){
		                     var custom_objects = features[4] ? config[2] : 0;
		                     return caml_exact_trampoline_cps_call$1
		                             (append$0,
		                              destinations,
		                              custom_objects,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (append$0,
		tasks_recurrent,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (append$0,
		          events,
		          a,
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (append$0,
		                    tasks,
		                    a,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1
		                             (append$0,
		                              pages,
		                              a,
		                              function(a){
		                               function arg(param, cont){
		                                var id = param[1][3][1];
		                                return cont(to_reference_id(id));
		                               }
		                               return caml_exact_trampoline_cps_call
		                                       (Destination[23],
		config[8],
		function(b){
		 return caml_trampoline_cps_call2
		         (Destination[22],
		          b,
		          function(b){
		           return caml_trampoline_cps_call3
		                   (b,
		                    a,
		                    arg,
		                    function(objects){
		                     return caml_exact_trampoline_cps_call$2
		                             (to_sequence$2,
		                              0,
		                              0,
		                              0,
		                              config[1],
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (filter_map$1,
		a,
		function(param, cont){
		 var c = param[2];
		 if(c[8] && ! c[3]){
		  var a = c[7], b = c[5], d = c[6];
		  return caml_exact_trampoline_cps_call$1
		          (equal$121,
		           c[6],
		           1,
		           function(c){return cont([0, [0, c, d, b, a]]);});
		 }
		 return cont(0);
		},
		function(a){
		 return caml_exact_trampoline_cps_call
		         (to_list_rev,
		          a,
		          function(a){
		           return caml_exact_trampoline_cps_call$1
		                   (stable_sort,
		                    a,
		                    function(a, param, cont){
		                     var
		                      name_r = param[4],
		                      role_r = param[2],
		                      primary_r = param[1],
		                      name_l = a[4],
		                      role_l = a[2],
		                      primary_l = a[1],
		                      n$0 = caml_int_compare(primary_l, primary_r);
		                     if(0 !== n$0) return cont(n$0);
		                     var n = compare$169(role_l, role_r);
		                     return 0 === n
		                             ? cont(- caml_string_compare(name_l, name_r) | 0)
		                             : cont(- n | 0);
		                    },
		                    function(l){
		                     var param = l, calendars = 0;
		                     for(;;){
		                      if(! param) break;
		                      var
		                       l$0 = param[2],
		                       a = param[1],
		                       name = a[4],
		                       id = a[3],
		                       accu =
		                         [0, make_destination(name, 0, a7m, [0, id]), calendars];
		                      param = l$0;
		                      calendars = accu;
		                     }
		                     function b(v){return [1, v];}
		                     return caml_trampoline_cps_call3
		                             (map$18,
		                              objects,
		                              function(a, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (destination_map, a, b, cont);
		                              },
		                              function(objects){
		                               return caml_exact_trampoline_cps_call$1
		                                       (append$0,
		objects,
		calendars,
		function(destinations){
		 var slots = empty$11([0, comparator$2]);
		 function f(param, cont){
		  var slots = param[2];
		  function f(slot, cont){
		   var a = slot[5];
		   return caml_exact_trampoline_cps_call
		           (capitalize_ascii,
		            slot[2],
		            function(b){
		             return cont(some_if(0 === slot[5][2] ? 1 : 0, [0, b, a]));
		            });
		  }
		  return caml_exact_trampoline_cps_call$1
		          (filter_map$0, slots, f, cont);
		 }
		 return caml_exact_trampoline_cps_call$2
		         (to_sequence$2,
		          0,
		          0,
		          0,
		          slots,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (map$11,
		                    a,
		                    f,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (to_list_rev,
		                              a,
		                              function(a){
		                               return caml_exact_trampoline_cps_call
		                                       (of_list,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (sort_uniq,
		          function(a, param, cont){
		           var r = param[1], l = a[1];
		           return cont(caml_string_compare(l, r));
		          },
		          a,
		          function(slots){
		           return caml_trampoline_cps_call3
		                   (map$18,
		                    config[5],
		                    function(l, cont){return cont([0, l[2], 0, l]);},
		                    function(labels){
		                     return caml_trampoline_cps_call3
		                             (map$18,
		                              config[12],
		                              function(p, cont){return cont([0, p[2], 0, p]);},
		                              function(priorities){
		                               return caml_trampoline_cps_call3
		                                       (map$18,
		config[15],
		function(db, cont){return cont([0, db[3], 0, db]);},
		function(types){
		 var
		  match = config[4],
		  night_start = match[5],
		  evening_start = match[4],
		  afternoon_start = match[3],
		  noon_start = match[2],
		  day_start = match[1];
		 function f(seen, c, cont){
		  var name = c[1][1];
		  return caml_exact_trampoline_cps_call$1
		          (mem$3,
		           seen,
		           name,
		           function(b){
		            if(b) return cont([0, seen, 0]);
		            var a = [0, c];
		            return caml_exact_trampoline_cps_call$1
		                    (add$4, seen, name, function(b){return cont([0, b, a]);});
		           });
		 }
		 return caml_exact_trampoline_cps_call$0
		         (folding_map,
		          destinations,
		          empty$8([0, comparator$3]),
		          f,
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (filter_opt,
		                    a,
		                    function(destinations){
		                     var a = config[7][1] ? 4735457 : 4735232, b = locale[4];
		                     return caml_exact_trampoline_cps_call$1
		                             (of_time$1,
		                              timezone_local,
		                              now,
		                              function(c){
		                               var
		                                config =
		                                  [0,
		                                   afternoon_start,
		                                   today,
		                                   day_start,
		                                   locale[1],
		                                   c,
		                                   b,
		                                   destinations,
		                                   evening_start,
		                                   features,
		                                   a,
		                                   labels,
		                                   night_start,
		                                   noon_start,
		                                   participants,
		                                   priorities,
		                                   scheduling_hint,
		                                   ,
		                                   timezone_local,
		                                   types];
		                               return caml_exact_trampoline_cps_call
		                                       (make_parser, config, cont);
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    }
		                    return features[4]
		                            ? caml_exact_trampoline_cps_call$2
		                              (to_sequence$2,
		                               0,
		                               0,
		                               0,
		                               config[14],
		                               function(b){
		                                return caml_exact_trampoline_cps_call$1
		(filter_map$1,
		 b,
		 function(param, cont){
		  var t = param[2], id = param[1];
		  return caml_exact_trampoline_cps_call$1
		          (occurrences_count,
		           today,
		           t[5][2],
		           function(match){
		            if(match && 0 === match[1]) return cont(0);
		            var s2 = t[5][3][2];
		            return caml_exact_trampoline_cps_call$3
		                    (destination_of_object,
		                     0,
		                     0,
		                     [5, id],
		                     "\xf0\x9f\x94\x81 " + s2,
		                     t[5][3][1],
		                     function(a){return cont([0, a]);});
		           });
		 },
		 function(b){
		  return caml_exact_trampoline_cps_call(to_list_rev, b, a);
		 });
		                               })
		                            : a(0);
		                   }
		                   return features[4]
		                           ? caml_exact_trampoline_cps_call$2
		                             (to_sequence$2,
		                              0,
		                              0,
		                              0,
		                              config[13],
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (filter_map$1,
		b,
		function(param, cont){
		 var t = param[2], id = param[1];
		 if(! is_some(t[7][2]) && ! is_some(t[7][1]))
		  return caml_exact_trampoline_cps_call$3
		          (destination_of_object,
		           0,
		           0,
		           [4, id],
		           t[7][9][2],
		           t[7][9][1],
		           function(a){return cont([0, a]);});
		 return cont(0);
		},
		function(b){
		 return caml_exact_trampoline_cps_call(to_list_rev, b, a);
		});
		                              })
		                           : a(0);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        }
		        return features[4]
		                ? caml_exact_trampoline_cps_call$2
		                  (to_sequence$2,
		                   0,
		                   0,
		                   0,
		                   config[10],
		                   function(b){
		                    return caml_exact_trampoline_cps_call$1
		                            (filter_map$1,
		                             b,
		                             function(a, cont){
		                              var page = a[2], a = page[1][3][5];
		                              if(! a) return cont(0);
		                              var parent = a[1];
		                              return cont([0, [0, parent, page]]);
		                             },
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1
		                                      (of_sequence_multi$1,
		                                       [0, comparator$16],
		                                       b,
		                                       function(pages_by_parent){
		function dest_of_page(page, cont){
		 var id = page[1][2];
		 return caml_exact_trampoline_cps_call$1
		         (find_packed_by_id,
		          pages_by_parent,
		          id,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (map$18,
		                    value$4(a, 0),
		                    dest_of_page,
		                    function(subpages){
		                     return caml_exact_trampoline_cps_call$3
		                             (destination_of_object,
		                              0,
		                              [0, subpages],
		                              [2, id],
		                              page[1][3][4],
		                              page[1][3][2],
		                              cont);
		                    });
		          });
		}
		return caml_exact_trampoline_cps_call$2
		        (to_sequence$2,
		         0,
		         0,
		         0,
		         config[10],
		         function(b){
		          return caml_exact_trampoline_cps_call$1
		                  (filter_map$1,
		                   b,
		                   function(param, cont){
		                    var page = param[2];
		                    return caml_exact_trampoline_cps_call
		                            (dest_of_page, page, function(a){return cont([0, a]);});
		                   },
		                   function(b){
		                    return caml_exact_trampoline_cps_call(to_list_rev, b, a);
		                   });
		         });
		                                       });
		                             });
		                   })
		                : a(0);
		       }
		       if(! features[4]) return a(0);
		       function compare(a, param, cont){
		        var
		         rcal = param[2],
		         r = param[1],
		         lcal = a[2],
		         l = a[1],
		         n = compare$169(rcal, lcal);
		        return 0 === n
		                ? caml_trampoline_cps_call3(compare$37, r, l, cont)
		                : cont(n);
		       }
		       function filter(event, cont){
		        return caml_exact_trampoline_cps_call
		                (archived,
		                 event,
		                 function(b){
		                  function a(){return cont(0);}
		                  return b
		                          ? a()
		                          : caml_exact_trampoline_cps_call$1
		                            (end$1,
		                             timezone_local,
		                             event[9][10],
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1
		                                      (symbol$76,
		                                       b,
		                                       now,
		                                       function(b){
		return b
		        ? a()
		        : caml_exact_trampoline_cps_call$3
		          (destination_of_object,
		           0,
		           0,
		           [0, event[6]],
		           event[9][11],
		           event[9][8],
		           function(b){
		            var a = event[1];
		            return caml_exact_trampoline_cps_call$1
		                    (start$2,
		                     timezone_local,
		                     event[9][10],
		                     function(c){return cont([0, [0, c, a, b]]);});
		           });
		                                       });
		                             });
		                 });
		       }
		       return caml_exact_trampoline_cps_call$1
		               (filter_map$3,
		                config[3],
		                filter,
		                function(filtered){
		                 function f(a, cont){
		                  a = a[2];
		                  var dest = a[3], cal = a[2], start = a[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           config[1],
		                           cal,
		                           function(match){
		                            if(! match) return cont([0, start, 2, dest]);
		                            var role = match[1][6];
		                            return cont([0, start, role, dest]);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$2
		                         (to_sequence$2,
		                          0,
		                          0,
		                          0,
		                          filtered,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (map$11,
		                                    b,
		                                    f,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (to_binable,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (stable_sort,
		                b,
		                compare,
		                function(l){
		                 var param = l, accu$0 = 0;
		                 for(;;){
		                  if(! param) return a(accu$0);
		                  var
		                   l$0 = param[2],
		                   a$0 = param[1],
		                   event = a$0[3],
		                   accu = [0, event, accu$0];
		                  param = l$0;
		                  accu$0 = accu;
		                 }
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      function a(){return b(0);}
		      if(! t) return a();
		      var date = t[1];
		      return caml_exact_trampoline_cps_call$1
		              (symbol$79,
		               date,
		               today,
		               function(c){return c ? b(t) : a();});
		     });
		                                   });
		                         });
		               }
		               function refine_completions(completions, cont){
		                function hd(n, l){
		                 if(0 !== n && l){
		                  var tl = l[2], v = l[1];
		                  return [0, v, hd(n - 1 | 0, tl)];
		                 }
		                 return 0;
		                }
		                return caml_exact_trampoline_cps_call
		                        (elements_of_list,
		                         completions,
		                         function(completions_values){
		                          var
		                           calendars = 0,
		                           events = 0,
		                           pages = 0,
		                           peoples = 0,
		                           tasks = 0,
		                           param = completions_values;
		                          for(;;){
		                           var
		                            b =
		                              function(destinations){
		                               function finish(a, cont){
		                                a = a[2];
		                                if(! a) return cont(0);
		                                var tail = a[2], head = a[1];
		                                return cont([0, [0, head, tail]]);
		                               }
		                               function f(a, c, cont){
		                                var seen = a[3], res = a[2], count = a[1], p = c[2];
		                                if(5 !== p[0]) return cont(a7n);
		                                a = p[1];
		                                if(0 === a[0])
		                                 var email = a[1], email$0 = email;
		                                else
		                                 var email$1 = a[1][1], email$0 = email$1;
		                                return caml_exact_trampoline_cps_call$1
		(mem$3,
		 seen,
		 email$0,
		 function(a){
		  return a
		          ? cont([0, [0, count, res, seen]])
		          : 4
		            <= count
		            ? cont([1, [0, [0, c, res]]])
		            : caml_exact_trampoline_cps_call$1
		              (add$4,
		               seen,
		               email$0,
		               function(a){
		                return cont([0, [0, count + 1 | 0, [0, c, res], a]]);
		               });
		 });
		                               }
		                               var init = [0, 0, 0, empty$8([0, comparator$2])];
		                               return caml_exact_trampoline_cps_call$3
		                                       (fold_until,
		fold_left$1,
		init,
		f,
		finish,
		completions_values,
		function(a){
		 return caml_trampoline_cps_call3
		         (map$17,
		          a,
		          rev$1,
		          function(participants){
		           if(destinations){
		            var
		             a = destinations[1],
		             tasks = a[5],
		             peoples = a[4],
		             pages = a[3],
		             events = a[2],
		             calendars = a[1];
		            return caml_exact_trampoline_cps_call
		                    (length$1,
		                     events,
		                     function(events_n){
		                      return caml_exact_trampoline_cps_call
		                              (length$1,
		                               pages,
		                               function(pages_n){
		                                return caml_exact_trampoline_cps_call
		(length$1,
		 peoples,
		 function(peoples_n){
		  return caml_exact_trampoline_cps_call
		          (length$1,
		           tasks,
		           function(tasks_n){
		            return caml_exact_trampoline_cps_call$1
		                    (min$2,
		                     ((events_n + pages_n | 0) + peoples_n | 0) + tasks_n | 0,
		                     4,
		                     function(a){
		                      var calendars$0 = hd(5 - a | 0, calendars);
		                      return caml_exact_trampoline_cps_call
		                              (length$1,
		                               calendars$0,
		                               function(a){
		                                var size = 5 - a | 0;
		                                return caml_exact_trampoline_cps_call$1
		(min$2,
		 (events_n + pages_n | 0) + tasks_n | 0,
		 size - 1 | 0,
		 function(a){
		  var peoples$0 = hd(size - a | 0, peoples);
		  return caml_exact_trampoline_cps_call
		          (length$1,
		           peoples$0,
		           function(a){
		            var size$0 = size - a | 0;
		            return caml_exact_trampoline_cps_call$1
		                    (min$2,
		                     events_n + pages_n | 0,
		                     size$0 - 1 | 0,
		                     function(a){
		                      var events$0 = hd(size$0 - a | 0, events);
		                      return caml_exact_trampoline_cps_call
		                              (length$1,
		                               events$0,
		                               function(a){
		                                var size = size$0 - a | 0;
		                                return caml_exact_trampoline_cps_call$1
		(min$2,
		 pages_n,
		 size - 1 | 0,
		 function(a){
		  var tasks$0 = hd(size - a | 0, tasks);
		  return caml_exact_trampoline_cps_call
		          (length$1,
		           tasks$0,
		           function(a){
		            var size$0 = size - a | 0, pages$0 = hd(size$0, pages);
		            return caml_exact_trampoline_cps_call$1
		                    (append$0,
		                     peoples$0,
		                     calendars$0,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (append$0,
		                               events$0,
		                               a,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(append$0,
		 tasks$0,
		 a,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (append$0,
		           pages$0,
		           a,
		           function(match){
		            if(! match) return cont(completions);
		            var tail = match[2], head = match[1];
		            return cont([0, head, tail]);
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           }
		           if(participants){
		            var participants$0 = participants[1];
		            return cont(participants$0);
		           }
		           var
		            tl = completions[2],
		            a = hd(4, tl),
		            hd$0 = completions[1];
		           return cont([0, hd$0, a]);
		          });
		});
		                              };
		                           if(! param) break;
		                           var c = param[1], a = c[2];
		                           if(2 === a[0]){
		                            a = a[1];
		                            if(0 === a[0]){
		                             var tail = param[2], calendars$0 = [0, c, calendars];
		                             calendars = calendars$0;
		                             param = tail;
		                             continue;
		                            }
		                            switch(a[1][1][0]){
		                              case 0:
		                               var tail$0 = param[2], events$0 = [0, c, events];
		                               events = events$0;
		                               param = tail$0;
		                               continue;
		                              case 2:
		                               var tail$1 = param[2], pages$0 = [0, c, pages];
		                               pages = pages$0;
		                               param = tail$1;
		                               continue;
		                              case 3:
		                               var tail$2 = param[2], peoples$0 = [0, c, peoples];
		                               peoples = peoples$0;
		                               param = tail$2;
		                               continue;
		                              case 4:
		                              case 5:
		                               var tail$3 = param[2], tasks$0 = [0, c, tasks];
		                               tasks = tasks$0;
		                               param = tail$3;
		                               continue;
		                            }
		                           }
		                           return b(0);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (of_rev_keys,
		                                   tasks,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_rev_keys,
		     peoples,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (of_rev_keys,
		               pages,
		               function(d){
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys,
		                         events,
		                         function(e){
		                          return caml_exact_trampoline_cps_call
		                                  (of_rev_keys,
		                                   calendars,
		                                   function(f){return b([0, [0, f, e, d, c, a]]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$910 = [];
		               function mandate_parse_result_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$910[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a7o, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$910[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$910[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$910[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_title,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$516,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "html_free",
		   0,
		   2,
		   [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "html_locked",
		    0,
		    2,
		    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_result, 0, 2, [0, c], 0, 0], a]]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$515,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              title = c[2][1],
		              result = c[1],
		              html_locked = b[1],
		              html_free = a[1],
		              completions = param[1];
		             return cont
		                     ([0, completions, html_free, html_locked, result, title]);
		            },
		            function(param, cont){
		             var
		              title = param[5],
		              result = param[4],
		              html_locked = param[3],
		              html_free = param[2],
		              completions = param[1];
		             return cont
		                     ([0,
		                       completions,
		                       [0, html_free, [0, html_locked, [0, result, [0, title, 0]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_completions, 0, 3, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$910[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$910[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$877 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$910, [0, schematic_cache$877]);
		               caml_callback
		                (mandate_parse_result_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               function html_escape(s, cont){
		                var
		                 length = caml_ml_string_length(s),
		                 buffer = create$1(length * 2 | 0);
		                function flush(b, start, i, cont){
		                 var a = start < length ? 1 : 0;
		                 if(! a) return cont(a);
		                 var len = i - start | 0;
		                 return caml_exact_trampoline_cps_call$2
		                         (add_substring, b, s, start, len, cont);
		                }
		                function a(start, i){
		                 if(length <= i)
		                  return caml_exact_trampoline_cps_call$0
		                          (flush,
		                           buffer,
		                           start,
		                           i,
		                           function(match){
		                            return caml_exact_trampoline_cps_call
		                                    (contents, buffer, cont);
		                           });
		                 var start$0 = i + 1 | 0, b = caml_string_get(s, i);
		                 if(40 <= b){
		                  b = b - 60 | 0;
		                  if(2 < b >>> 0)
		                   return caml_exact_trampoline_call2(a, start, start$0);
		                  switch(b){
		                    case 0:
		                     return caml_exact_trampoline_cps_call$0
		                             (flush,
		                              buffer,
		                              start,
		                              i,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (write_stringlit,
		buffer,
		cst_lt$0,
		function(b){
		 return caml_exact_trampoline_call2(a, start$0, start$0);
		});
		                              });
		                    case 2:
		                     return caml_exact_trampoline_cps_call$0
		                             (flush,
		                              buffer,
		                              start,
		                              i,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (write_stringlit,
		buffer,
		cst_gt$0,
		function(b){
		 return caml_exact_trampoline_call2(a, start$0, start$0);
		});
		                              });
		                    default:
		                     return caml_exact_trampoline_call2(a, start, start$0);
		                  }
		                 }
		                 if(32 <= b)
		                  switch(b - 32 | 0){
		                    case 0:
		                     return caml_exact_trampoline_cps_call$0
		                             (flush,
		                              buffer,
		                              start,
		                              i,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (write_stringlit,
		buffer,
		cst_nbsp,
		function(b){
		 return caml_exact_trampoline_call2(a, start$0, start$0);
		});
		                              });
		                    case 2:
		                     return caml_exact_trampoline_cps_call$0
		                             (flush,
		                              buffer,
		                              start,
		                              i,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (write_stringlit,
		buffer,
		"&quot;",
		function(b){
		 return caml_exact_trampoline_call2(a, start$0, start$0);
		});
		                              });
		                    case 6:
		                     return caml_exact_trampoline_cps_call$0
		                             (flush,
		                              buffer,
		                              start,
		                              i,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (write_stringlit,
		buffer,
		cst_amp,
		function(b){
		 return caml_exact_trampoline_call2(a, start$0, start$0);
		});
		                              });
		                    case 7:
		                     return caml_exact_trampoline_cps_call$0
		                             (flush,
		                              buffer,
		                              start,
		                              i,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1
		                                       (write_stringlit,
		buffer,
		"&apos;",
		function(b){
		 return caml_exact_trampoline_call2(a, start$0, start$0);
		});
		                              });
		                    default:
		                     return caml_exact_trampoline_call2(a, start, start$0);
		                  }
		                 return caml_exact_trampoline_call2(a, start, start$0);
		                }
		                return a(0, 0);
		               }
		               function parse$3(parser, locked, s, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$8[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call5(m, 0, 0, a7p, s, cont);
		                         },
		                         function(b){
		                          var
		                           parser$0 = parser[4],
		                           len = caml_ml_string_length(s),
		                           size = caml_ml_string_length(s),
		                           a = create$2(char, c_layout, size),
		                           b = size - 1 | 0;
		                          if(b >= 0){
		                           var i = 0;
		                           for(;;){
		                            caml_ba_set_1(a, i, caml_string_get(s, i));
		                            var c = i + 1 | 0;
		                            if(b === i) break;
		                            i = c;
		                           }
		                          }
		                          function d(r, cont){return cont([1, r]);}
		                          return caml_exact_trampoline_cps_call
		                                  (return$7,
		                                   0,
		                                   function(c){
		                                    var b = symbol$61(end_of_input, c);
		                                    return caml_exact_trampoline_cps_call
		    (return$7,
		     0,
		     function(e){
		      var c = symbol$61(any_char, e);
		      return caml_exact_trampoline_cps_call
		              (return$7,
		               1,
		               function(e){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$64,
		                         symbol$61(satisfy(whitespace), e),
		                         c,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$64,
		                                   c,
		                                   b,
		                                   function(c){
		                                    var skip_parser = symbol_map$3(c, d);
		                                    function b(boundary, param, pos){
		                                     var tokens = param[2], result = param[1];
		                                     return caml_trampoline_cps_call2
		     (parser$0,
		      result,
		      function(c){
		       return caml_trampoline_cps_call3
		               (bind$16,
		                c,
		                function(param, cont){
		                 var completion = param[2], r = param[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (merge_result,
		                          0,
		                          result,
		                          r,
		                          function(match){
		                           if(0 === match[0]){
		                            var result = match[1];
		                            return caml_trampoline_cps_call2
		                                    (return$16, [0, result, completion], cont);
		                           }
		                           var e = match[1];
		                           return caml_exact_trampoline_cps_call(fail$3, e, cont);
		                          });
		                },
		                function(d){
		                 var allocation_parser = symbol_map$3(d, return$1);
		                 function c(parser){
		                  var committed_bytes = 0;
		                  return caml_trampoline_cps_call6
		                          (parser[1],
		                           [0, committed_bytes, committed_bytes, 0, 0, buffer],
		                           0,
		                           1,
		                           fail_k,
		                           succeed_k,
		                           function(c){
		                            return caml_exact_trampoline_cps_call
		                                    (to_exported_state,
		                                     c,
		                                     function(param){
		                                      function c(pos$0, d){
		                                       function e(d){
		var a = d[2], new_pos = d[1];
		function c(boundary, result, tokens, completions){
		 if(new_pos < len)
		  return caml_exact_trampoline_call3
		          (b, boundary, [0, result, tokens], new_pos);
		 var
		  open =
		    o
		     ([0,
		       symbol_bind$4,
		       symbol_map$4,
		       Let_syntax$2,
		       ,
		       bind$6,
		       of_string$14,
		       map$15]),
		  let$ = open[3],
		  type = result[10],
		  slot = result[9],
		  recurrence = result[8],
		  priority = result[7],
		  participants = result[6],
		  labels = result[5],
		  duration = result[4],
		  destination = result[3],
		  daytime = result[2],
		  dates = result[1];
		 o
		  ([0,
		    symbol_bind$4,
		    symbol_map$4,
		    Let_syntax$2,
		    ,
		    bind$6,
		    of_string$14,
		    map$15]);
		 function a(result, cont){
		  return caml_trampoline_cps_call2
		          (of_string$14, [0, result, tokens, completions], cont);
		 }
		 return caml_trampoline_cps_call3
		         (map$17,
		          recurrence,
		          function(rec, cont){
		           var rule = rec[2];
		           function a(a){return cont([0, rec[1], a]);}
		           if(2 !== rule[0]) return a(rule);
		           if(rule[2]) return a(rule);
		           if(! dates) return a(rule);
		           var dates$0 = dates[1], b = rule[3];
		           return caml_exact_trampoline_cps_call
		                   (first_date,
		                    dates$0,
		                    function(c){
		                     return caml_exact_trampoline_cps_call
		                             (weekday,
		                              c,
		                              function(c){
		                               return caml_exact_trampoline_cps_call
		                                       (of_weekdays,
		[0, c, 0],
		function(c){return a([2, rule[1], [0, c], b]);});
		                              });
		                    });
		          },
		          function(recurrence){
		           return caml_trampoline_cps_call2
		                   (of_string$14,
		                    [0,
		                     dates,
		                     daytime,
		                     destination,
		                     duration,
		                     labels,
		                     participants,
		                     priority,
		                     recurrence,
		                     slot,
		                     type],
		                    function(b){
		                     return caml_trampoline_cps_call3
		                             (let$,
		                              b,
		                              a,
		                              function(a){
		                               if(0 !== a[0]) return cont(0);
		                               a = a[1];
		                               var completions = a[3], tokens = a[2], result = a[1];
		                               return caml_trampoline_cps_call3
		                                       (map$17,
		completions,
		function(c, cont){
		 return caml_exact_trampoline_cps_call
		         (refine_completions,
		          c[2],
		          function(a){return cont([0, c[1], a]);});
		},
		function(completions){
		 var init = [0, s, 0];
		 function a(t, init){
		  if(t){
		   var
		    l = t[2],
		    a$0 = t[1],
		    token = a$0[2],
		    match = a$0[1],
		    end = match[2],
		    pos = match[1],
		    chunks$0 = init[2],
		    s = init[1],
		    sub =
		      function(pos, len, cont){
		       return 0 < len
		               ? caml_exact_trampoline_cps_call$0
		                 (sub_fun, s, pos, len, function(a){return cont([0, a]);})
		               : cont(0);
		      },
		    prepend =
		      function(chunks, t, param){
		       if(! param) return chunks;
		       var range = param[1];
		       return [0, [0, range, t], chunks];
		      };
		   return caml_exact_trampoline_cps_call$0
		           (sub_fun,
		            s,
		            0,
		            pos,
		            function(start){
		             return caml_exact_trampoline_cps_call$1
		                     (sub,
		                      pos,
		                      end - pos | 0,
		                      function(mid){
		                       return caml_exact_trampoline_cps_call$1
		                               (sub,
		                                end,
		                                caml_ml_string_length(s) - end | 0,
		                                function(end){
		                                 var
		                                  chunks = prepend(chunks$0, 0, end),
		                                  chunks$1 = prepend(chunks, [0, token], mid),
		                                  init = [0, start, chunks$1];
		                                 return caml_exact_trampoline_call2(a, l, init);
		                                });
		                      });
		            });
		  }
		  var
		   chunks = init[2],
		   start = init[1],
		   tokens =
		     start === cst$1 ? chunks : [0, [0, start, 0], chunks];
		  function f(pos, token, cont){
		   var
		    type = token[2],
		    text = token[1],
		    len = caml_ml_string_length(text),
		    split = locked - pos | 0;
		   function a(res){return cont([0, pos + len | 0, res]);}
		   if(0 < split && split < len)
		    return caml_exact_trampoline_cps_call$0
		            (sub_fun,
		             text,
		             split,
		             len - split | 0,
		             function(c){
		              var x = [0, c, type], b = [0, [1, x], 0];
		              return caml_exact_trampoline_cps_call$0
		                      (sub_fun,
		                       text,
		                       0,
		                       split,
		                       function(c){var x = [0, c, type]; return a([0, [0, x], b]);});
		             });
		   return pos < locked
		           ? a([0, [0, token], 0])
		           : a([0, [1, token], 0]);
		  }
		  return caml_exact_trampoline_cps_call$0
		          (folding_map,
		           tokens,
		           0,
		           f,
		           function(a){
		            return caml_exact_trampoline_cps_call
		                    (of_list,
		                     a,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (partition_map,
		                               a,
		                               function(a, cont){return cont(a);},
		                               function(match){
		                                var free = match[2], locked = match[1];
		                                function compile(tokens, cont){
		                                 function f(param, cont){
		                                  var token = param[2], s = param[1];
		                                  return caml_exact_trampoline_cps_call
		  (html_escape,
		   s,
		   function(text){
		    return token
		            ? token
		               [1]
		              ? caml_exact_trampoline_cps_call$1
		                (concat$0,
		                 0,
		                 [0, '<span class="value">', [0, text, a7q]],
		                 cont)
		              : caml_exact_trampoline_cps_call$1
		                (concat$0,
		                 0,
		                 [0, '<span class="keyword">', [0, text, a7r]],
		                 cont)
		            : cont(text);
		   });
		                                 }
		                                 return caml_trampoline_cps_call3(map$18, tokens, f, cont);
		                                }
		                                return caml_exact_trampoline_cps_call
		(compile,
		 free,
		 function(html_free){
		  return caml_exact_trampoline_cps_call
		          (compile,
		           locked,
		           function(html_locked){
		            return caml_exact_trampoline_cps_call$1
		                    (filter_map$0,
		                     tokens,
		                     function(param, cont){
		                      var t = param[2], text = param[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (strip,
		                               0,
		                               text,
		                               function(text){
		                                var a = is_none$0(t), a = a ? text !== cst$1 ? 1 : 0 : a;
		                                return cont(some_if(a, text));
		                               });
		                     },
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (concat$0,
		                               a7s,
		                               a,
		                               function(title){
		                                return cont
		([0,
		  [0, completions, html_free, html_locked, result, title]]);
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 }
		 return a(tokens, init);
		});
		                              });
		                    });
		          });
		}
		if(0 === a[0]){
		 a = a[1];
		 var
		  state = a[2],
		  a = a[1],
		  completions = a[2],
		  result$0 = a[1],
		  f =
		    function(a, cont){
		     var t = a[2], a = a[1], end = a[2], start = a[1];
		     return cont([0, [0, start + pos | 0, end + pos | 0], t]);
		    };
		 return caml_trampoline_cps_call3
		         (map$18,
		          state[1],
		          f,
		          function(t){
		           var completions$0 = [0, completions];
		           return caml_exact_trampoline_cps_call$1
		                   (append$0,
		                    t,
		                    tokens,
		                    function(a){return c(0, result$0, a, completions$0);});
		          });
		}
		var boundary = a[1];
		return c(boundary, result, tokens, 0);
		                                       }
		                                       switch(d[0]){
		 case 0:
		  d = d[1];
		  var
		   continue$ = d[2],
		   committed = d[1],
		   off = pos$0 + committed | 0;
		  return caml_exact_trampoline_cps_call$2
		          (continue$,
		           a,
		           off,
		           len - off | 0,
		           0,
		           function(state){
		            return caml_exact_trampoline_call2(c, off, state);
		           });
		 case 1:
		  var res = d[2], consumed = d[1];
		  return e([0, pos$0 + consumed | 0, res]);
		 default:
		  var
		   s$0 = d[3],
		   x = d[2],
		   pos$1 = d[1],
		   f = list([0, semi], pp_print_string);
		  return caml_exact_trampoline_cps_call$1
		          (kasprintf,
		           failwith,
		           fmt$47,
		           function(a){
		            return caml_trampoline_cps_call5(a, pos$1, f, x, s$0, e);
		           });
		                                       }
		                                      }
		                                      return c(pos, param);
		                                     });
		                           });
		                 }
		                 return boundary
		                         ? caml_exact_trampoline_cps_call$1
		                           (symbol$64, allocation_parser, skip_parser, c)
		                         : c(skip_parser);
		                });
		      });
		                                    }
		                                    return b
		    (1, [0, make$12(0, 0, 0, 0, 0, 0, 0, 0, 0, 0), 0], 0);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function completion_item_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (completion_schema_versioned$0,
		                                   schematic_version,
		                                   function(a){return cont([0, a7t, 0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (completion_item_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               function complete_participant(parser, string, cont){
		                var participant = parser[5];
		                function a(param, cont){
		                 var value = param[2], text = param[1];
		                 return cont([0, text, [5, value]]);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         participant,
		                         string,
		                         function(b){
		                          if(0 === b[0]) var l = b[1], b = l; else b = 0;
		                          return caml_trampoline_cps_call3(map$18, b, a, cont);
		                         });
		               }
		               function complete_destination(parser, string, cont){
		                var destination = parser[3];
		                function a(param, cont){
		                 var value = param[2], text = param[1];
		                 return cont([0, text, [2, value]]);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         destination,
		                         string,
		                         function(b){
		                          if(0 === b[0]) var l = b[1], b = l; else b = 0;
		                          return caml_trampoline_cps_call3(map$18, b, a, cont);
		                         });
		               }
		               function complete_destination_in_worksp(workspace_id){
		                function is_in_workspace(a, cont){
		                 a = a[2];
		                 if(2 === a[0]){
		                  a = a[1];
		                  if(0 !== a[0]){
		                   a = a[1][1];
		                   if(6 === a[0]){
		                    a = a[1][1];
		                    if(a){
		                     var ow = a[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (equal$61, workspace_id, ow, cont);
		                    }
		                   }
		                  }
		                 }
		                 return cont(1);
		                }
		                return function(parser, input, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (complete_destination,
		                          parser,
		                          input,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter, a, is_in_workspace, cont);
		                          });};
		               }
		               function complete_daytime(parser, string, cont){
		                var daytime = parser[2];
		                function a(param, cont){
		                 var value = param[2], text = param[1];
		                 return cont([0, text, [1, value]]);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         daytime,
		                         string,
		                         function(b){
		                          if(0 === b[0]) var l = b[1], b = l; else b = 0;
		                          return caml_trampoline_cps_call3(map$18, b, a, cont);
		                         });
		               }
		               function complete_date(parser, string, cont){
		                var date = parser[1];
		                function a(param, cont){
		                 var value = param[2], text = param[1];
		                 return cont([0, text, [0, [0, value]]]);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (parse_string,
		                         1,
		                         date,
		                         string,
		                         function(b){
		                          if(0 === b[0]) var l = b[1], b = l; else b = 0;
		                          return caml_trampoline_cps_call3(map$18, b, a, cont);
		                         });
		               }
		               function text$3(fmt, cont){
		                function f(s, cont){return cont([9, s]);}
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, f, fmt, cont);
		               }
		               function highlight(fmt, cont){
		                function f(highlight, cont){return cont([2, highlight]);}
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, f, fmt, cont);
		               }
		               function page(page){return [4, page[2], page[3][4]];}
		               function people$0(people, cont){
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         people[5],
		                         function(param, cont){
		                          var display = param[1];
		                          return cont(display);
		                         },
		                         function(a){
		                          a = value$4(a, people[2]);
		                          return cont([5, people[1], a]);
		                         });
		               }
		               var
		                inbox =
		                  [3, cst_Inbox, caml_callback(of_string$19, ["/inbox"])];
		               function notify(param, link, type, message, cont){
		                var hook = param[1];
		                return caml_exact_trampoline_cps_call$3
		                        (make$135,
		                         0,
		                         link,
		                         0,
		                         type,
		                         message,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (trigger$0, hook[1], a, 0, cont);
		                         });
		               }
		               function notify_f(t, type){
		                function f(s, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (notify, t, 0, type, [0, [9, s], 0], cont);
		                }
		                return function(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf, f, a, cont);};
		               }
		               function lookup$2(t, Incremental, param, id$0, cont){
		                var lookup = param[21][2];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$152,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   pp$36,
		                                   id$0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (find$6,
		     lookup,
		     id$0,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$230, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function get_from_state$1(incr, id, cont){
		                var
		                 values = incr[5],
		                 incremental = incr[1],
		                 pages = values[21];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         pages[2],
		                         id,
		                         function(page_incr){
		                          return caml_trampoline_cps_call3
		                                  (incremental[46],
		                                   0,
		                                   page_incr,
		                                   function(obs){
		                                    return caml_trampoline_cps_call2
		    (incremental[49],
		     0,
		     function(match){
		      return caml_trampoline_cps_call2
		              (incremental[45][6], obs, cont);
		     });
		                                   });
		                         });
		               }
		               function notes$8(page){return page[1][3][2];}
		               function with_notes$1(content, page){
		                var
		                 b = page[1],
		                 a = page[1][3],
		                 x =
		                   [0,
		                    [0, b[1], b[2], [0, a[1], content, a[3], a[4], a[5]]],
		                    page[2]];
		                return x;
		               }
		               function schematic_version$134(param, cont){return cont(0);}
		               caml_callback
		                (workspaced_schema_versioned, [schematic_version$134]);
		               function generic$1(id){return [2, id];}
		               function append$10(param, incr, section, page_id, block, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$1,
		                         incr,
		                         page_id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (Sync[4],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call6
		     (m, 0, 0, a7y, pp$36, page_id, cont);
		                                    },
		                                    function(match){return cont(0);});
		                          var page = match[1], doc = page[1][3][2];
		                          return caml_exact_trampoline_cps_call$0
		                                  (crdt_append,
		                                   doc,
		                                   section,
		                                   block,
		                                   function(doc_op){
		                                    return caml_exact_trampoline_cps_call
		    (notes$1,
		     doc_op,
		     function(a){
		      return caml_trampoline_cps_call2
		              (element$13,
		               page_id,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (pages,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (ignore_m$11,
		     a,
		     function(routine_op){
		      return cont([0, [0, page, routine_op]]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function id$40(param){var id = param[1][2]; return id;}
		               caml_callback
		                (M$2, [[0, comparator$2, thread_id_schema_versioned]]);
		               function lookup$3(t, Incremental, param, id, cont){
		                var lookup = param[22][2];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6, lookup, id, cont);
		               }
		               function generic$2(id){return [3, id];}
		               function get_from_state$2(incr, id, cont){
		                var
		                 values = incr[5],
		                 incremental = incr[1],
		                 peoples = values[22];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         peoples[2],
		                         id,
		                         function(person_incr){
		                          return caml_trampoline_cps_call3
		                                  (incremental[46],
		                                   0,
		                                   person_incr,
		                                   function(obs){
		                                    return caml_trampoline_cps_call2
		    (incremental[49],
		     0,
		     function(match){
		      return caml_trampoline_cps_call2
		              (incremental[45][6], obs, cont);
		     });
		                                   });
		                         });
		               }
		               function notes$9(people){return people[11][1];}
		               function with_notes$2(notes, people){
		                var a = people[11];
		                return [0,
		                        people[1],
		                        people[2],
		                        people[3],
		                        people[4],
		                        people[5],
		                        people[6],
		                        people[7],
		                        people[8],
		                        people[9],
		                        people[10],
		                        [0, notes, a[2], a[3]]];
		               }
		               function append$11(param, incr, section, id, block, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(person, cont){
		                 var doc = person[11][1];
		                 return caml_exact_trampoline_cps_call$0
		                         (crdt_append,
		                          doc,
		                          section,
		                          block,
		                          function(doc_op){
		                           return caml_exact_trampoline_cps_call
		                                   (notes$2,
		                                    doc_op,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$14,
		      id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (people,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (ignore_m$11,
		                                    a,
		                                    function(routine_op){return cont([0, person, routine_op]);});
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$2,
		                         incr,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function id$41(param){var id = param[1]; return id;}
		               var
		                cst_location_type = "location_type",
		                letrec_function_context$911 = [];
		               function pp_location(fmt, param, cont){
		                if(typeof param === "number")
		                 return 0 === param
		                         ? caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Title, cont)
		                         : caml_exact_trampoline_cps_call$1
		                           (pp_print_string, fmt, cst_Description, cont);
		                if(0 === param[0]){
		                 var ablock = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (fprintf$0(fmt),
		                          a7z,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    a7A,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      cst_block,
		      function(a){
		       return caml_trampoline_cps_call2
		               (letrec_function_context$911[1],
		                fmt,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          ablock,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (fprintf$0(fmt),
		                                    a7B,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (fprintf$0(fmt), a7C, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                var alocation_type = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         a7D,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   a7E,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_location_type,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               a7F,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         alocation_type,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   a7G,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), a7H, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var _0$54 = include$48[1];
		               caml_update_dummy(letrec_function_context$911, [0, _0$54]);
		               var letrec_function_context$912 = [];
		               function compare_location(lhs, rhs, cont){
		                if(typeof lhs === "number"){
		                 if(0 === lhs){
		                  if(typeof rhs === "number" && ! rhs) return cont(0);
		                 }
		                 else if(typeof rhs === "number" && rhs) return cont(0);
		                }
		                else
		                 if(0 === lhs[0]){
		                  if(typeof rhs !== "number" && 0 === rhs[0]){
		                   var rhsblock = rhs[1], lhsblock = lhs[1];
		                   return caml_trampoline_cps_call3
		                           (letrec_function_context$912[2], lhsblock, rhsblock, cont);
		                  }
		                 }
		                 else if(typeof rhs !== "number" && 0 !== rhs[0]){
		                  var rhslocation_type = rhs[1], lhslocation_type = lhs[1];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$912[1],
		                           0,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (a, lhslocation_type, rhslocation_type, cont);
		                           });
		                 }
		                function to_int(param){
		                 return typeof param === "number"
		                         ? 0 === param ? 0 : 1
		                         : 0 === param[0] ? 2 : 3;
		                }
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               function _1$54(param, a, b, cont){
		                return cont(caml_string_compare(a, b));
		               }
		               var _0$55 = include$48[16];
		               caml_update_dummy
		                (letrec_function_context$912, [0, _1$54, _0$55]);
		               var letrec_function_context$913 = [];
		               function location_schema_versioned$1(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$913[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a7I, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$913[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$913[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$913[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 1,
		                                 0,
		                                 cst_other,
		                                 cst_Other,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var location_type = param[1];
		                                    return cont(location_type);
		                                   },
		                                   function(location_type, cont){
		                                    return cont([0, location_type, 0]);
		                                   },
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_location_type,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (include$48[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  a7L,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){
		     if(typeof param === "number" && ! param) return cont(a7K);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_title,
		    cst_Title,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(1);},
		     function(param, cont){
		      if(typeof param === "number" && param) return cont(a7J);
		      return cont(0);
		     },
		     0,
		     0,
		     cst_description,
		     cst_Description,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){return cont(0);},
		       function(param, cont){return cont(0);},
		       0],
		      0],
		     0],
		    [0,
		     [0,
		      function(f0, cont){return cont([0, f0]);},
		      function(param, cont){
		       if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		       return cont(0);
		      },
		      1,
		      0,
		      cst_notes,
		      cst_Notes,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var block = param[1];
		         return cont(block);
		        },
		        function(block, cont){return cont([0, block, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_block, 0, 2, [0, b], 0, 0], 0]],
		       0],
		      0],
		     a]]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$913[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$913[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$878 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$913, [0, schematic_cache$878]);
		               caml_callback
		                (location_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$914 = [];
		               function pp$127(fmt, x, cont){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         a7M,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   a7N,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_organization_id,
		     function(b){
		      var a = x[1];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$914[3],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   a7O,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt),
		     a7P,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               a7Q,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_id,
		                         function(b){
		                          var a = x[2];
		                          return caml_trampoline_cps_call2
		                                  (letrec_function_context$914[2],
		                                   fmt,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (fprintf$0(fmt),
		               a7R,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(fmt),
		                         a7S,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   a7T,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a,
		     cst_location,
		     function(b){
		      var a = x[3];
		      return caml_trampoline_cps_call2
		              (letrec_function_context$914[1],
		               fmt,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (fprintf$0(fmt),
		                                   a7U,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (fprintf$0(fmt), a7V, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$914, [0, pp_location, pp$52, pp$37]);
		               var letrec_function_context$915 = [];
		               function compare$173(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$915[3],
		                         lhs[1],
		                         rhs[1],
		                         function(x){
		                          return 0 === x
		                                  ? caml_trampoline_cps_call3
		                                    (letrec_function_context$915[2],
		                                     lhs[2],
		                                     rhs[2],
		                                     function(x){
		                                      return 0 === x
		      ? caml_trampoline_cps_call3
		        (letrec_function_context$915[1], lhs[3], rhs[3], cont)
		      : cont(x);
		                                     })
		                                  : cont(x);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$915,
		                 [0, compare_location, compare$85, compare$60]);
		               var letrec_function_context$916 = [];
		               function schema_versioned$550(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$916[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a7W, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$916[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$916[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$916[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (location_schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$261[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_location,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$131,
		       schematic_version,
		       function(c){
		        var b = [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$104,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        location = a[2][1],
		                        id = a[1],
		                        organization_id = param[1];
		                       return cont([0, organization_id, id, location]);
		                      },
		                      function(param, cont){
		                       var
		                        location = param[3],
		                        id = param[2],
		                        organization_id = param[1];
		                       return cont([0, organization_id, [0, id, [0, location, 0]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_organization_id, 0, 2, [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$916[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$916[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$879 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$916, [0, schematic_cache$879]);
		               var
		                schema$248 =
		                  caml_callback
		                   (schema_versioned$550,
		                    [function(param, cont){return cont(0);}]);
		               function sexp_of_t$141(t, cont){
		                return caml_trampoline_cps_call3
		                        (encode$7, schema$248, t, cont);
		               }
		               var
		                include$284 = Make$2([0, compare$173, sexp_of_t$141]),
		                comparator$61 = include$284[16],
		                letrec_function_context$917 = [];
		               function schema_versioned$551(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$917[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a7Y, a7X, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$917[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$917[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$917[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 a70,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_title,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  a7Z,
		                                  0,
		                                  0,
		                                  0,
		                                  "match_content",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$550,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    match_content = a[2][1],
		    title = a[1],
		    id = param[1];
		   return cont([0, id, title, match_content]);
		  },
		  function(param, cont){
		   var
		    match_content = param[3],
		    title = param[2],
		    id = param[1];
		   return cont([0, id, [0, title, [0, match_content, 0]]]);
		  },
		  [0, [0, a71, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$917[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$917[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$880 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$917, [0, schematic_cache$880]);
		               caml_callback
		                (schema_versioned$551,
		                 [function(param, cont){return cont(0);}]);
		               var
		                M$9 =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$127, comparator$61, schema_versioned$550]]),
		                letrec_function_context$918 = [];
		               function compare$174(lhs, rhs, cont){
		                if(typeof lhs === "number")
		                 switch(lhs){
		                   case 0:
		                    if(typeof rhs === "number" && ! rhs) return cont(0); break;
		                   case 1:
		                    if(typeof rhs === "number" && 1 === rhs) return cont(0);
		                    break;
		                   case 2:
		                    if(typeof rhs === "number" && 2 === rhs) return cont(0);
		                    break;
		                   case 3:
		                    if(typeof rhs === "number" && 3 === rhs) return cont(0);
		                    break;
		                   case 4:
		                    if(typeof rhs === "number" && 4 === rhs) return cont(0);
		                    break;
		                   case 5:
		                    if(typeof rhs === "number" && 5 === rhs) return cont(0);
		                    break;
		                   case 6:
		                    if(typeof rhs === "number" && 6 === rhs) return cont(0);
		                    break;
		                   case 7:
		                    if(typeof rhs === "number" && 7 === rhs) return cont(0);
		                    break;
		                   default:
		                    if(typeof rhs === "number" && 8 <= rhs) return cont(0);
		                 }
		                else
		                 switch(lhs[0]){
		                   case 0:
		                    if(typeof rhs !== "number" && 0 === rhs[0]){
		                     var
		                      rhstable_id = rhs[2],
		                      rhsworkspace_id = rhs[1],
		                      lhstable_id = lhs[2],
		                      lhsworkspace_id = lhs[1],
		                      c =
		                        function(x){
		                         return 0 === x
		                                 ? caml_trampoline_cps_call3
		                                   (letrec_function_context$918[5],
		                                    lhstable_id,
		                                    rhstable_id,
		                                    cont)
		                                 : cont(x);
		                        };
		                     if(! lhsworkspace_id) return rhsworkspace_id ? c(-1) : c(0);
		                     var a = lhsworkspace_id[1];
		                     if(! rhsworkspace_id) return c(1);
		                     var b = rhsworkspace_id[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$918[6], a, b, c);
		                    }
		                    break;
		                   case 1:
		                    if(typeof rhs !== "number" && 1 === rhs[0]){
		                     var rhsorg_id = rhs[1], lhsorg_id = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$918[4], lhsorg_id, rhsorg_id, cont);
		                    }
		                    break;
		                   case 2:
		                    if(typeof rhs !== "number" && 2 === rhs[0]){
		                     var rhsorg_id$0 = rhs[1], lhsorg_id$0 = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$918[3],
		                              lhsorg_id$0,
		                              rhsorg_id$0,
		                              cont);
		                    }
		                    break;
		                   case 3:
		                    if(typeof rhs !== "number" && 3 === rhs[0]){
		                     var rhsorg_id$1 = rhs[1], lhsorg_id$1 = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$918[2],
		                              lhsorg_id$1,
		                              rhsorg_id$1,
		                              cont);
		                    }
		                    break;
		                   default:
		                    if(typeof rhs !== "number" && 4 === rhs[0]){
		                     var rhsorg_id$2 = rhs[1], lhsorg_id$2 = lhs[1];
		                     return caml_trampoline_cps_call3
		                             (letrec_function_context$918[1],
		                              lhsorg_id$2,
		                              rhsorg_id$2,
		                              cont);
		                    }
		                 }
		                function to_int(param){
		                 if(typeof param === "number")
		                  switch(param){
		                    case 0:
		                     return 0;
		                    case 1:
		                     return 1;
		                    case 2:
		                     return 2;
		                    case 3:
		                     return 3;
		                    case 4:
		                     return 4;
		                    case 5:
		                     return 5;
		                    case 6:
		                     return 7;
		                    case 7:
		                     return 8;
		                    default: return 9;
		                  }
		                 switch(param[0]){
		                   case 0:
		                    return 6;
		                   case 1:
		                    return 10;
		                   case 2:
		                    return 11;
		                   case 3:
		                    return 12;
		                   default: return 13;
		                 }
		                }
		                var d = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), d));
		               }
		               var _1$55 = Table[16];
		               caml_update_dummy
		                (letrec_function_context$918,
		                 [0,
		                  compare$60,
		                  compare$60,
		                  compare$60,
		                  compare$60,
		                  _1$55,
		                  compare$80]);
		               var letrec_function_context$919 = [];
		               function schema_versioned$552(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$919[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a72, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$919[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$919[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$919[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([4, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_automation_run,
		   cst_Automation_run,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var org_id = param[1];
		      return cont(org_id);
		     },
		     function(org_id, cont){return cont([0, org_id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([3, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_conversation,
		             cst_Conversation,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var org_id = param[1];
		                return cont(org_id);
		               },
		               function(org_id, cont){return cont([0, org_id, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$104,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_automation,
		                       cst_Automation,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var org_id = param[1];
		                          return cont(org_id);
		                         },
		                         function(org_id, cont){return cont([0, org_id, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$104,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(6);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && 6 === param)
		                                   return cont(a78);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_organization,
		                                 cst_Organization,
		                                 a77,
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(7);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 7 === param)
		                                    return cont(a76);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_table,
		                                  cst_Table,
		                                  a75,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(8);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 8 <= param)
		                                     return cont(a74);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_workspace,
		                                   cst_Workspace,
		                                   a73,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(f0, cont){return cont([1, f0]);},
		                                    function(param, cont){
		                                     if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                     return cont(0);
		                                    },
		                                    1,
		                                    0,
		                                    cst_agent,
		                                    cst_Agent,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){
		                                       var org_id = param[1];
		                                       return cont(org_id);
		                                      },
		                                      function(org_id, cont){return cont([0, org_id, 0]);},
		                                      [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, c], 0, 0], 0]],
		                                     0],
		                                    0],
		                                   a]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (Table[4],
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$120,
		       schematic_version,
		       function(c){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){
		               if(typeof param === "number" && ! param) return cont(a8i);
		               return cont(0);
		              },
		              0,
		              0,
		              cst_event,
		              cst_Event,
		              a8h,
		              0],
		             [0,
		              [0,
		               function(param, cont){return cont(1);},
		               function(param, cont){
		                if(typeof param === "number" && 1 === param)
		                 return cont(a8g);
		                return cont(0);
		               },
		               0,
		               0,
		               cst_event_recurrent,
		               cst_Event_recurrent,
		               a8f,
		               0],
		              [0,
		               [0,
		                function(param, cont){return cont(2);},
		                function(param, cont){
		                 if(typeof param === "number" && 2 === param)
		                  return cont(a8e);
		                 return cont(0);
		                },
		                0,
		                0,
		                cst_page,
		                cst_Page,
		                a8d,
		                0],
		               [0,
		                [0,
		                 function(param, cont){return cont(3);},
		                 function(param, cont){
		                  if(typeof param === "number" && 3 === param)
		                   return cont(a8c);
		                  return cont(0);
		                 },
		                 0,
		                 0,
		                 cst_people,
		                 cst_People,
		                 a8b,
		                 0],
		                [0,
		                 [0,
		                  function(param, cont){return cont(4);},
		                  function(param, cont){
		                   if(typeof param === "number" && 4 === param)
		                    return cont(a8a);
		                   return cont(0);
		                  },
		                  0,
		                  0,
		                  cst_task,
		                  cst_Task,
		                  a7$,
		                  0],
		                 [0,
		                  [0,
		                   function(param, cont){return cont(5);},
		                   function(param, cont){
		                    if(typeof param === "number" && 5 === param)
		                     return cont(a7_);
		                    return cont(0);
		                   },
		                   0,
		                   0,
		                   cst_task_recurrent,
		                   cst_Task_recurrent,
		                   a79,
		                   0],
		                  [0,
		                   [0,
		                    function(param, cont){
		                     var f1 = param[2], f0 = param[1];
		                     return cont([0, f0, f1]);
		                    },
		                    function(param, cont){
		                     if(typeof param !== "number" && 0 === param[0]){
		                      var f1 = param[2], f0 = param[1];
		                      return cont([0, [0, f0, f1]]);
		                     }
		                     return cont(0);
		                    },
		                    1,
		                    0,
		                    cst_object,
		                    cst_Object,
		                    [0,
		                     0,
		                     0,
		                     [7,
		                      function(param, cont){
		                       var table_id = param[2][1], workspace_id = param[1];
		                       return cont([0, workspace_id, table_id]);
		                      },
		                      function(param, cont){
		                       var table_id = param[2], workspace_id = param[1];
		                       return cont([0, workspace_id, [0, table_id, 0]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_workspace_id, 0, 3, [0, c], 0, 0],
		                       a]],
		                     0],
		                    0],
		                   b]]]]]]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$919[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$919[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$881 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$919, [0, schematic_cache$881]);
		               var
		                schema$249 =
		                  caml_callback
		                   (schema_versioned$552,
		                    [function(param, cont){return cont(0);}]),
		                letrec_function_context$920 = [];
		               function pp$128(fmt, param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Event",
		                             cont);
		                   case 1:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Event_recurrent",
		                             cont);
		                   case 2:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Page",
		                             cont);
		                   case 3:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.People",
		                             cont);
		                   case 4:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Task",
		                             cont);
		                   case 5:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Task_recurrent",
		                             cont);
		                   case 6:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Organization",
		                             cont);
		                   case 7:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Table",
		                             cont);
		                   default:
		                    return caml_exact_trampoline_cps_call$1
		                            (pp_print_string,
		                             fmt,
		                             "Controller_search.Document_map.Kind.T.Workspace",
		                             cont);
		                 }
		                switch(param[0]){
		                  case 0:
		                   var atable_id = param[2], aworkspace_id = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            a8j,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8k,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_workspace_id,
		        function(b){
		         function a(a){
		          return caml_exact_trampoline_cps_call
		                  (fprintf$0(fmt),
		                   a8l,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fprintf$0(fmt),
		                             a8m,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       a8n,
		                                       function(a){
		return caml_trampoline_cps_call2
		        (a,
		         cst_table_id,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (letrec_function_context$920[5],
		                   fmt,
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (a,
		                             atable_id,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (fprintf$0(fmt),
		                                       a8o,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (fprintf$0(fmt), a8p, cont);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         }
		         if(! aworkspace_id)
		          return caml_exact_trampoline_cps_call$1
		                  (pp_print_string, fmt, cst_None, a);
		         var x = aworkspace_id[1];
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_string,
		                  fmt,
		                  cst_Some,
		                  function(b){
		                   return caml_trampoline_cps_call2
		                           (letrec_function_context$920[6],
		                            fmt,
		                            function(b){
		                             return caml_trampoline_cps_call2
		                                     (b,
		                                      x,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (pp_print_string, fmt, cst$18, a);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var aorg_id = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            a8q,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8r,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_org_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$920[4],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aorg_id,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8s,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), a8t, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var aorg_id$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            a8u,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8v,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_org_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$920[3],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aorg_id$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8w,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), a8x, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var aorg_id$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            a8y,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8z,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_org_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$920[2],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aorg_id$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8A,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), a8B, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   var aorg_id$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            a8C,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8D,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_org_id,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (letrec_function_context$920[1],
		                  fmt,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aorg_id$2,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      a8E,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), a8F, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                }
		               }
		               var _1$56 = Table[1];
		               caml_update_dummy
		                (letrec_function_context$920,
		                 [0, pp$37, pp$37, pp$37, pp$37, _1$56, pp$46]);
		               function sexp_of_t$142(t, cont){
		                return caml_trampoline_cps_call3
		                        (encode$7, schema$249, t, cont);
		               }
		               function of_id(a){
		                switch(a[0]){
		                  case 0:
		                   return 0;
		                  case 1:
		                   return 1;
		                  case 2:
		                   return 2;
		                  case 3:
		                   return 3;
		                  case 4:
		                   return 4;
		                  case 5:
		                   return 5;
		                  case 6:
		                   a = a[1];
		                   var table_id = a[2], workspace_id = a[1];
		                   return [0, workspace_id, table_id];
		                  case 7:
		                   return 6;
		                  case 8:
		                   return 7;
		                  case 9:
		                   return 8;
		                  case 10:
		                   var org_id = a[1][1]; return [1, org_id];
		                  case 11:
		                   var org_id$0 = a[1][1]; return [2, org_id$0];
		                  case 12:
		                   var org_id$1 = a[1][1]; return [3, org_id$1];
		                  default: var org_id$2 = a[1][1]; return [4, org_id$2];
		                }
		               }
		               var
		                include$285 = Make$2([0, compare$174, sexp_of_t$142]),
		                equal$256 = include$285[7],
		                comparator$62 = include$285[16],
		                Kind_map =
		                  caml_callback
		                   (M_printable,
		                    [[0, pp$128, comparator$62, schema_versioned$552]]),
		                empty$31 = Kind_map[111];
		               function length$19(t, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold$5,
		                         t,
		                         0,
		                         function(param, data, acc, cont){return cont(acc + data[3] | 0);
		                         },
		                         cont);
		               }
		               function filteri$1(t, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (mapi$3,
		                         t,
		                         function(param, data, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filteri$0, data, f, cont);
		                         },
		                         cont);
		               }
		               function find$8(t, uid, cont){
		                var kind = of_id(uid[2]);
		                function a(map, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id, map, uid, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         t,
		                         kind,
		                         function(b){
		                          return caml_trampoline_cps_call3(bind$8, b, a, cont);
		                         });
		               }
		               function to_alist$3(key_order, t, cont){
		                var
		                 order = key_order ? 608542111 <= key_order[1] ? a8G : a8H : 0;
		                return caml_exact_trampoline_cps_call$2
		                        (to_sequence$2,
		                         0,
		                         0,
		                         0,
		                         t,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (bind$5,
		                                   a,
		                                   function(param, cont){
		                                    var map = param[2];
		                                    return caml_exact_trampoline_cps_call$2
		    (M$9[89], order, 0, 0, map, cont);
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(to_binable, a, cont);
		                                   });
		                         });
		               }
		               function find_by_prefix(t, key, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_trie,
		                         t,
		                         key,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(to_alist$2, a, cont);
		                         });
		               }
		               caml_callback(M$3, [[0, comparator$61, schema_versioned$550]]);
		               var
		                UidMap =
		                  caml_callback
		                   (M$2, [[0, comparator$61, schema_versioned$550]]);
		               function hash$40(t){
		                var x = t[1];
		                return caml_string_hash(0, x);
		               }
		               var emptybucket = caml_callback(create$6, [0]);
		               function get_index(t, h){
		                return caml_mod(h & 2147483647, t[1].length - 1);
		               }
		               function create$7(sz){
		                var
		                 sz$0 = 7 <= sz ? sz : 7,
		                 sz$1 = max_array_length < sz$0 ? max_array_length : sz$0;
		                return [0,
		                        caml_make_vect(sz$1, emptybucket),
		                        caml_make_vect(sz$1, [0]),
		                        7,
		                        0,
		                        0];
		               }
		               function add_aux(t, setter, d, h, index, cont){
		                var
		                 bucket = caml_check_bound(t[1], index)[index + 1],
		                 hashes = caml_check_bound(t[2], index)[index + 1],
		                 sz = length$0(bucket);
		                function a(i){
		                 if(sz > i)
		                  return caml_exact_trampoline_cps_call$1
		                          (check,
		                           bucket,
		                           i,
		                           function(b){
		                            if(! b)
		                             return caml_exact_trampoline_cps_call$0
		                                     (setter,
		                                      bucket,
		                                      i,
		                                      d,
		                                      function(a){
		                                       caml_check_bound(hashes, i)[i + 1] = h;
		                                       return cont();
		                                      });
		                            var i$0 = i + 1 | 0;
		                            return caml_exact_trampoline_call1(a, i$0);
		                           });
		                 var
		                  newsz =
		                    min$0
		                     (((3 * sz | 0) / 2 | 0) + 3 | 0, max_array_length - 2 | 0);
		                 function b(a){
		                  return caml_exact_trampoline_cps_call
		                          (create$6,
		                           newsz,
		                           function(newbucket){
		                            var newhashes = caml_make_vect(newsz, 0);
		                            return caml_exact_trampoline_cps_call$3
		                                    (blit$1,
		                                     bucket,
		                                     0,
		                                     newbucket,
		                                     0,
		                                     sz,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$3
		      (blit$0,
		       hashes,
		       0,
		       newhashes,
		       0,
		       sz,
		       function(a){
		        return caml_exact_trampoline_cps_call$0
		                (setter,
		                 newbucket,
		                 sz,
		                 d,
		                 function(a){
		                  caml_check_bound(newhashes, sz)[sz + 1] = h;
		                  caml_check_bound(t[1], index)[index + 1] = newbucket;
		                  caml_check_bound(t[2], index)[index + 1] = newhashes;
		                  a = sz <= t[3];
		                  a = a ? t[3] < newsz : a;
		                  function c(){
		                   var c = ((t[1].length - 1) / 2 | 0) < t[4] ? 1 : 0;
		                   if(! c) return cont(c);
		                   var
		                    oldlen = t[1].length - 1,
		                    newlen =
		                      min$0(((3 * oldlen | 0) / 2 | 0) + 3 | 0, max_array_length);
		                   if(oldlen < newlen){
		                    var
		                     newt = create$7(newlen),
		                     a = t[1],
		                     b = a.length - 2 | 0,
		                     e =
		                       function(){
		                        t[1] = newt[1];
		                        t[2] = newt[2];
		                        t[3] = newt[3];
		                        t[4] = newt[4];
		                        t[5] = caml_mod(t[5], newt[1].length - 1);
		                        return cont();
		                       },
		                     d =
		                       function(i){
		                        var ob = a[i + 1];
		                        function c(oi){
		                         if(length$0(ob) > oi)
		                          return caml_exact_trampoline_cps_call$1
		                                  (check,
		                                   ob,
		                                   oi,
		                                   function(match){
		                                    if(match){
		                                     var
		                                      oh = caml_check_bound(t[2], i)[i + 1],
		                                      setter =
		function(nb, ni, param, cont){
		 return caml_exact_trampoline_cps_call$3
		         (blit$1, ob, oi, nb, ni, 1, cont);
		},
		                                      h = caml_check_bound(oh, oi)[oi + 1];
		                                     return caml_exact_trampoline_cps_call$3
		     (add_aux,
		      newt,
		      setter,
		      0,
		      h,
		      get_index(newt, h),
		      function(a){
		       var i = oi + 1 | 0;
		       return caml_exact_trampoline_call1(c, i);
		      });
		                                    }
		                                    var i$0 = oi + 1 | 0;
		                                    return caml_exact_trampoline_call1(c, i$0);
		                                   });
		                         var a = i + 1 | 0;
		                         return b !== i ? caml_exact_trampoline_call1(d, a) : e();
		                        }
		                        return c(0);
		                       };
		                    return b < 0 ? e() : d(0);
		                   }
		                   t[3] = max_value;
		                   t[4] = 0;
		                   return cont();
		                  }
		                  if(! a) return c();
		                  t[4] = t[4] + 1 | 0;
		                  function b(i){
		                   var
		                    a = t[5],
		                    bucket = caml_check_bound(t[1], a)[a + 1],
		                    a = t[5],
		                    hbucket = caml_check_bound(t[2], a)[a + 1],
		                    len = length$0(bucket),
		                    prev_len = (((len - 3 | 0) * 2 | 0) + 2 | 0) / 3 | 0;
		                   function d(i$0, accu){
		                    if(length$0(bucket) > i$0)
		                     return caml_exact_trampoline_cps_call$1
		                             (check,
		                              bucket,
		                              i$0,
		                              function(a){
		                               a = a ? 1 : 0;
		                               var accu$0 = accu + a | 0, i = i$0 + 1 | 0;
		                               return caml_exact_trampoline_call2(d, i, accu$0);
		                              });
		                    function e(){
		                     t[5] = caml_mod(t[5] + 1 | 0, t[1].length - 1);
		                     var a = i + 1 | 0;
		                     return 2 !== i ? caml_exact_trampoline_call1(b, a) : c();
		                    }
		                    if(accu > prev_len) return e();
		                    var j = length$0(bucket) - 1 | 0;
		                    function a(i, j){
		                     if(prev_len <= j)
		                      return caml_exact_trampoline_cps_call$1
		                              (check,
		                               bucket,
		                               i,
		                               function(b){
		                                if(! b)
		                                 return caml_exact_trampoline_cps_call$1
		 (check,
		  bucket,
		  j,
		  function(b){
		   if(b)
		    return caml_exact_trampoline_cps_call$3
		            (blit$1,
		             bucket,
		             j,
		             bucket,
		             i,
		             1,
		             function(b){
		              b = caml_check_bound(hbucket, j)[j + 1];
		              caml_check_bound(hbucket, i)[i + 1] = b;
		              var j$0 = j - 1 | 0, i$0 = i + 1 | 0;
		              return caml_exact_trampoline_call2(a, i$0, j$0);
		             });
		   var j$0 = j - 1 | 0;
		   return caml_exact_trampoline_call2(a, i, j$0);
		  });
		                                var i$0 = i + 1 | 0;
		                                return caml_exact_trampoline_call2(a, i$0, j);
		                               });
		                     function c(){
		                      var a = t[3] < len, a = a ? prev_len <= t[3] : a;
		                      return a ? (t[4] = t[4] - 1 | 0, e()) : e();
		                     }
		                     if(0 !== prev_len)
		                      return caml_exact_trampoline_cps_call
		                              (create$6,
		                               prev_len,
		                               function(newbucket){
		                                return caml_exact_trampoline_cps_call$3
		(blit$1,
		 bucket,
		 0,
		 newbucket,
		 0,
		 prev_len,
		 function(a){
		  a = t[5];
		  caml_check_bound(t[1], a)[a + 1] = newbucket;
		  return caml_exact_trampoline_cps_call$0
		          (sub$0,
		           hbucket,
		           0,
		           prev_len,
		           function(b){
		            var a = t[5];
		            caml_check_bound(t[2], a)[a + 1] = b;
		            return c();
		           });
		 });
		                               });
		                     var b = t[5];
		                     caml_check_bound(t[1], b)[b + 1] = emptybucket;
		                     b = t[5];
		                     caml_check_bound(t[2], b)[b + 1] = [0];
		                     return c();
		                    }
		                    return a(0, j);
		                   }
		                   return d(0, 0);
		                  }
		                  return b(0);
		                 });
		       });
		                                     });
		                           });
		                 }
		                 return newsz <= sz
		                         ? caml_exact_trampoline_cps_call
		                           (failwith, "Weak.Make: hash bucket cannot grow more", b)
		                         : b();
		                }
		                return a(0);
		               }
		               function find_aux(t, t2, found, notfound, cont){
		                var
		                 h = hash$40(t2),
		                 index = get_index(t, h),
		                 bucket = caml_check_bound(t[1], index)[index + 1],
		                 hashes = caml_check_bound(t[2], index)[index + 1],
		                 sz = length$0(bucket);
		                function a(i){
		                 if(sz <= i) return cont(notfound(h, index));
		                 if(h === caml_check_bound(hashes, i)[i + 1])
		                  return caml_exact_trampoline_cps_call$1
		                          (get$1,
		                           bucket,
		                           i,
		                           function(opt){
		                            if(opt){
		                             var t1 = opt[1];
		                             if(t1[1] === t2[1])
		                              return caml_exact_trampoline_cps_call$2
		                                      (found, bucket, i, opt, t1, cont);
		                            }
		                            var i$0 = i + 1 | 0;
		                            return caml_exact_trampoline_call1(a, i$0);
		                           });
		                 var i$0 = i + 1 | 0;
		                 return caml_exact_trampoline_call1(a, i$0);
		                }
		                return a(0);
		               }
		               function find_opt(t, d, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (find_aux,
		                         t,
		                         d,
		                         function(b, i, o, v, cont){return cont(o);},
		                         function(h, i){return 0;},
		                         cont);
		               }
		               function find$7(t, key, cont){
		                function a(param, cont){
		                 var data = param[2];
		                 return cont(data);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find_opt,
		                         t,
		                         [0, key],
		                         function(b){
		                          return caml_trampoline_cps_call3(map$17, b, a, cont);
		                         });
		               }
		               function add$37(t, key, data, cont){
		                var kv = [0, key, data];
		                return caml_exact_trampoline_cps_call$2
		                        (find_aux,
		                         t,
		                         kv,
		                         function(b, i, o, v, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (set$2, b, i, 0, cont);
		                         },
		                         function(h, i){return 0;},
		                         function(a){
		                          var h = hash$40(kv);
		                          return caml_exact_trampoline_cps_call$3
		                                  (add_aux, t, set$2, [0, kv], h, get_index(t, h), cont);
		                         });
		               }
		               function document_occurences(stats, cont){
		                return caml_exact_trampoline_cps_call
		                        (UidMap[16], stats[1], cont);
		               }
		               function filter_tokens(query){
		                return find_all
		                        (function(s){return 1 < caml_ml_string_length(s) ? 1 : 0;},
		                         query);
		               }
		               function unranked(t, opt, query, cont){
		                var docs = opt ? opt[1] : t[2];
		                function filter_on_token(token, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (find$7,
		                          t[4],
		                          token,
		                          function(match){
		                           if(! match)
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_by_prefix,
		                                     t[3],
		                                     token,
		                                     function(stats){
		                                      return stats
		      ? caml_exact_trampoline_cps_call$1
		        (filteri$1,
		         docs,
		         function(key, param, cont){
		          function a(param){
		           if(! param) return cont(0);
		           var l = param[2], a$0 = param[1], stat = a$0[2];
		           return caml_exact_trampoline_cps_call$1
		                   (UidMap[28],
		                    stat[1],
		                    key,
		                    function(b){
		                     return b ? cont(b) : caml_exact_trampoline_call1(a, l);
		                    });
		          }
		          return a(stats);
		         },
		         function(res){
		          return caml_exact_trampoline_cps_call$0
		                  (add$37, t[4], token, res, function(a){return cont(res);});
		         })
		      : cont(empty$31);
		                                     });
		                           var cached_list = match[1];
		                           return cont(cached_list);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (map$0,
		                         filter_on_token,
		                         query,
		                         function(l){
		                          function a(accu, l$0){
		                           if(! l$0) return cont(accu);
		                           var l = l$0[2], elt = l$0[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (filteri$1,
		                                    accu,
		                                    function(key, param, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find$8, elt, key, function(a){return cont(is_some(a));});
		                                    },
		                                    function(accu){
		                                     return caml_exact_trampoline_call2(a, accu, l);
		                                    });
		                          }
		                          return a(docs, l);
		                         });
		               }
		               function search(t, token, cont){
		                var docs = t[2];
		                return caml_trampoline_cps_call2
		                        (t[1][4],
		                         token,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$0,
		                                   t[1][2],
		                                   a,
		                                   function(tokens$0){
		                                    var tokens = filter_tokens(tokens$0);
		                                    return tokens
		    ? caml_exact_trampoline_cps_call$0
		      (unranked,
		       t,
		       [0, docs],
		       tokens,
		       function(matching_docs){
		        function a(doc, cont){
		         var b = doc[2];
		         function a(accu, l$0){
		          if(! l$0) return cont([0, accu[2], b]);
		          var l = l$0[2], token = l$0[1], score = accu[2];
		          return caml_exact_trampoline_cps_call$1
		                  (find_by_prefix,
		                   t[3],
		                   token,
		                   function(stats){
		                    function b(accu, l$1){
		                     if(l$1){
		                      var l$0 = l$1[2], a$0 = l$1[1], stat = a$0[2];
		                      return caml_exact_trampoline_cps_call
		                              (document_occurences,
		                               stat,
		                               function(a){
		                                var accu$0 = a + accu | 0;
		                                return caml_exact_trampoline_call2(b, accu$0, l$0);
		                               });
		                     }
		                     var value = accu, c = 1. + value;
		                     return caml_exact_trampoline_cps_call
		                             (length$19,
		                              t[2],
		                              function(b){
		                               var inverse = 1. + Math.log(b / c);
		                               return caml_exact_trampoline_cps_call$1
		                                       (find_by_prefix,
		t[3],
		token,
		function(expansions){
		 function b(accu$0, l$1){
		  if(l$1){
		   var l$0 = l$1[2], a$0 = l$1[1], stat = a$0[2], uid = doc[1];
		   return caml_exact_trampoline_cps_call$1
		           (UidMap[25],
		            stat[1],
		            uid,
		            function(match){
		             if(match)
		              var v = match[1], expansion_freq = v;
		             else
		              expansion_freq = 0.;
		             var accu = expansion_freq + accu$0;
		             return caml_exact_trampoline_call2(b, accu, l$0);
		            });
		  }
		  var accu = [0, , score + accu$0 * inverse];
		  return caml_exact_trampoline_call2(a, accu, l);
		 }
		 return b(0., expansions);
		});
		                              });
		                    }
		                    return b(0, stats);
		                   });
		         }
		         return a([0, , 0.], tokens);
		        }
		        return caml_exact_trampoline_cps_call$1
		                (to_alist$3,
		                 0,
		                 matching_docs,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (map$18,
		                           b,
		                           a,
		                           function(docs_with_score){
		                            return caml_exact_trampoline_cps_call$1
		                                    (stable_sort,
		                                     docs_with_score,
		                                     function(a, param, cont){
		                                      var score2 = param[1], score1 = a[1];
		                                      return cont(- caml_float_compare(score1, score2) | 0);
		                                     },
		                                     function(a){
		                                      return caml_trampoline_cps_call3(map$18, a, get_data, cont);
		                                     });
		                           });
		                 });
		       })
		    : cont(0);
		                                   });
		                         });
		               }
		               function search$0(organization, kind, limit, query, t, cont){
		                var a = caml_obj_tag(t);
		                function b(a){
		                 a = a[1];
		                 var index_observer = a[3], Incr = a[1];
		                 return caml_trampoline_cps_call2
		                         (Incr[49],
		                          0,
		                          function(match){
		                           return caml_trampoline_cps_call2
		                                   (Incr[45][6],
		                                    index_observer,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (search,
		      a,
		      query,
		      function(raw_results){
		       function a(filtered_results){
		        function a(filtered_results){
		         if(! limit) return cont(filtered_results);
		         var l = limit[1];
		         return caml_exact_trampoline_cps_call$1
		                 (take$0, filtered_results, l, cont);
		        }
		        if(! kind) return a(filtered_results);
		        var filter$0 = kind[1];
		        return caml_exact_trampoline_cps_call$1
		                (filter,
		                 filtered_results,
		                 function(param, cont){
		                  var id = param[1], actual = of_id(id[2]);
		                  if
		                   (typeof filter$0 !== "number"
		                    &&
		                     0 === filter$0[0]
		                     && typeof actual !== "number" && 0 === actual[0]){
		                   var t2 = actual[2], t1 = filter$0[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (Table[15], t1, t2, cont);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (equal$256, filter$0, actual, cont);
		                 },
		                 a);
		       }
		       if(! organization) return a(raw_results);
		       var org = organization[1];
		       return caml_exact_trampoline_cps_call$1
		               (filter,
		                raw_results,
		                function(param, cont){
		                 var id = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (equal$53, org, id[1], cont);
		                },
		                a);
		      });
		                                    });
		                          });
		                }
		                if(250 === a) return b(t[1]);
		                if(246 !== a && 244 !== a) return b(t);
		                return caml_exact_trampoline_cps_call(force_lazy_block, t, b);
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var Logs$9 = with_tag$0(component$0, "Controller.Tasks");
		               function parents_only(tasks, cont){
		                return caml_exact_trampoline_cps_call
		                        (deconstruct,
		                         tasks,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$11,
		                                   a,
		                                   id$36,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (Ids[78],
		     a,
		     function(ids){
		      return caml_exact_trampoline_cps_call$1
		              (filter,
		               tasks,
		               function(a, cont){
		                a = a[7][6];
		                if(a){
		                 a = a[1];
		                 if(4 === a[0]){
		                  var id = a[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (Ids[7], ids, id, function(a){return cont(1 - a);});
		                 }
		                }
		                return cont(1);
		               },
		               cont);
		     });
		                                   });
		                         });
		               }
		               function day_entries_of_tasks(tasks, cont){
		                return caml_exact_trampoline_cps_call
		                        (parents_only,
		                         tasks,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   a,
		                                   function(t, cont){
		                                    var
		                                     match = t[7],
		                                     starred = match[8],
		                                     completed = match[2],
		                                     archived = match[1],
		                                     created = t[3],
		                                     id = [1, t[6]];
		                                    if(archived)
		                                     var completed_or_archived_at = archived[1];
		                                    else {
		                                     if(! completed)
		                                      return cont([1, [0, starred, [0, created], id]]);
		                                     completed_or_archived_at = completed[1];
		                                    }
		                                    return cont([0, completed_or_archived_at, id]);
		                                   },
		                                   cont);
		                         });
		               }
		               function day_of_tasks(tasks, cont){
		                return caml_exact_trampoline_cps_call
		                        (day_entries_of_tasks,
		                         tasks,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (day_of_entries, a, cont);
		                         });
		               }
		               function lookup$4(t, Incremental, param, id, cont){
		                var tasks_lookup = param[39];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6, tasks_lookup, id, cont);
		               }
		               function generic$3(id){return [4, id];}
		               function get_from_state$3(state, id, cont){
		                var
		                 values = state[5],
		                 incremental = state[1],
		                 tasks_lookup = values[39];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         tasks_lookup,
		                         id,
		                         function(task_incr){
		                          return caml_trampoline_cps_call3
		                                  (incremental[46],
		                                   0,
		                                   task_incr,
		                                   function(obs){
		                                    return caml_trampoline_cps_call2
		    (incremental[49],
		     0,
		     function(match){
		      return caml_trampoline_cps_call2
		              (incremental[45][6], obs, cont);
		     });
		                                   });
		                         });
		               }
		               function notes$10(task){return task[7][9][1];}
		               function with_notes$3(notes, task){
		                var a = task[7], b = task[7][9];
		                return [0,
		                        task[1],
		                        task[2],
		                        task[3],
		                        task[4],
		                        task[5],
		                        task[6],
		                        [0,
		                         a[1],
		                         a[2],
		                         a[3],
		                         a[4],
		                         a[5],
		                         a[6],
		                         a[7],
		                         a[8],
		                         [0, notes, b[2], b[3]]]];
		               }
		               function id$42(param){var id = param[6]; return id;}
		               function append$12(param, incr, section, task_id, block, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$3,
		                         incr,
		                         task_id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (Logs$9[6][4],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call6
		     (m, 0, 0, a8J, _16$0, task_id, cont);
		                                    },
		                                    function(match){return cont(0);});
		                          var task = match[1], doc = task[7][9][1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (crdt_append,
		                                   doc,
		                                   section,
		                                   block,
		                                   function(doc_op){
		                                    return caml_exact_trampoline_cps_call
		    (notes$4,
		     doc_op,
		     function(a){
		      return caml_trampoline_cps_call2
		              (element$22,
		               task_id,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (tasks,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (ignore_m$11,
		     a,
		     function(routine_op){
		      return cont([0, [0, task, routine_op]]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function overdue
		               (Inc, tasks_by_scheduling, week_start, date, cont){
		                var
		                 a =
		                   g
		                    ([0,
		                      Inc[72],
		                      Inc[73],
		                      ,
		                      Inc[75],
		                      Inc[76],
		                      Inc[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Inc[82]]),
		                 b = a[2],
		                 c = a[4];
		                return caml_trampoline_cps_call3
		                        (a[3],
		                         week_start,
		                         function(week_start, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (week_of_date,
		                                   week_start,
		                                   date,
		                                   function(current_week){
		                                    function a(overdue_tasks, cont){return cont(overdue_tasks);}
		                                    return caml_exact_trampoline_cps_call$2
		    (filter_mapi$2,
		     0,
		     0,
		     tasks_by_scheduling,
		     function(key, data, cont){
		      function a(){return cont(0);}
		      if(typeof key === "number") return a();
		      if(0 === key[0]) return a();
		      var match = key[1];
		      if(0 === match[0]){
		       var w = match[1];
		       return caml_exact_trampoline_cps_call$1
		               (symbol$87,
		                w,
		                current_week,
		                function(b){
		                 return b
		                         ? caml_exact_trampoline_cps_call$1
		                           (filter_map$0,
		                            data,
		                            function(t, cont){
		                             var match = t[7][1];
		                             if(! t[7][2] && ! match) return cont([0, t[6]]);
		                             return cont(0);
		                            },
		                            function(a){return cont([0, a]);})
		                         : a();
		                });
		      }
		      var d = match[1];
		      return caml_exact_trampoline_cps_call$1
		              (symbol$83,
		               d,
		               date,
		               function(b){
		                return b
		                        ? caml_exact_trampoline_cps_call$1
		                          (filter_map$0,
		                           data,
		                           function(t, cont){
		                            var match = t[7][1];
		                            if(! t[7][2] && ! match) return cont([0, t[6]]);
		                            return cont(0);
		                           },
		                           function(a){return cont([0, a]);})
		                        : a();
		               });
		     },
		     function(d){
		      return caml_trampoline_cps_call3
		              (b,
		               d,
		               encode,
		               function(d){
		                return caml_trampoline_cps_call3
		                        (b,
		                         d,
		                         of_list,
		                         function(b){
		                          return caml_trampoline_cps_call3(c, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function lookup$5(t, Incremental, param, id, cont){
		                var tasks_recurrent_lookup = param[41];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6, tasks_recurrent_lookup, id, cont);
		               }
		               function generic$4(id){return [5, id];}
		               function get_from_state$4(state, id, cont){
		                var
		                 values = state[5],
		                 incremental = state[1],
		                 tasks_recurrent_lookup = values[41];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         tasks_recurrent_lookup,
		                         id,
		                         function(task_incr){
		                          return caml_trampoline_cps_call3
		                                  (incremental[46],
		                                   0,
		                                   task_incr,
		                                   function(obs){
		                                    return caml_trampoline_cps_call2
		    (incremental[49],
		     0,
		     function(match){
		      return caml_trampoline_cps_call2
		              (incremental[45][6], obs, cont);
		     });
		                                   });
		                         });
		               }
		               function notes$11(task){return task[5][3][1];}
		               function with_notes$4(notes, task){
		                var a = task[5], b = task[5][3];
		                return [0,
		                        task[1],
		                        task[2],
		                        task[3],
		                        task[4],
		                        [0, a[1], a[2], [0, notes, b[2], b[3]]]];
		               }
		               function id$43(param){var id = param[4]; return id;}
		               function append$13
		               (param, incr, section, task_rec_id, block, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$4,
		                         incr,
		                         task_rec_id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (Sync[4],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call6
		     (m, 0, 0, a8K, pp$72, task_rec_id, cont);
		                                    },
		                                    function(match){return cont(0);});
		                          var task_rec = match[1], doc = task_rec[5][3][1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (crdt_append,
		                                   doc,
		                                   section,
		                                   block,
		                                   function(doc_op){
		                                    return caml_exact_trampoline_cps_call
		    (notes$5,
		     doc_op,
		     function(a){
		      return caml_trampoline_cps_call2
		              (element$16,
		               task_rec_id,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (recurrences,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (ignore_m$11,
		     a,
		     function(routine_op){
		      return cont([0, [0, task_rec, routine_op]]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               o
		                ([0,
		                  symbol_bind$9,
		                  symbol_map$7,
		                  Let_syntax$5,
		                  ,
		                  bind$12,
		                  return$13,
		                  map$25]);
		               var
		                schematic_cache$882 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$921 = [];
		               caml_update_dummy
		                (letrec_function_context$921, [0, schematic_cache$882]);
		               var schematic_schema_version$58 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$921[1][1],
		                    schematic_schema_version$58]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$921[1][1],
		                             schematic_schema_version$58,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$921[1][1],
		schematic_schema_version$58,
		schematic_self,
		function(b){
		 letrec_function_context$921[1][1] = b;
		 var
		  a = [0, [0, q, documentation$0, descriptor, parametric], 0];
		 return caml_exact_trampoline_cps_call
		         (schema_versioned$4,
		          dummy,
		          function(b){
		           var
		            res =
		              mapping_schema
		                ([0,
		                  0,
		                  0,
		                  [10,
		                   function(param, cont){
		                    var e1 = param[2][1], e0 = param[1];
		                    return cont([0, e0, e1]);
		                   },
		                   function(param, cont){
		                    var e1 = param[2], e0 = param[1];
		                    return cont([0, e0, [0, e1, 0]]);
		                   },
		                   [0, b, a]],
		                  0])
		               [3];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$921[1][1],
		                    schematic_schema_version$58,
		                    res,
		                    function(a){
		                     letrec_function_context$921[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var letrec_function_context$922 = [];
		               function profile_feature_schema_version
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$922[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, a8M, a8L, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$922[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$922[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$922[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(a8Q);},
		                        0,
		                        0,
		                        cst_calendar,
		                        cst_Calendar,
		                        [0, a8[1], a8P, a8[3], a8[4]],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(a8O) : cont(0);},
		                         0,
		                         0,
		                         cst_contacts,
		                         cst_Contacts,
		                         [0, a7[1], a8N, a7[3], a7[4]],
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$922[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$922[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$883 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$922, [0, schematic_cache$883]);
		               caml_callback
		                (profile_feature_schema_version, [function(param){return 0;}]);
		               function read$1(ctrl){
		                var a = ctrl[9];
		                return function(b, cont){
		                 return caml_exact_trampoline_cps_call$1(read$0, a, b, cont);};
		               }
		               function notify_f$0(ctrl){
		                var a = ctrl[15];
		                return function(b){return notify_f(a, b);};
		               }
		               function notify$0(ctrl){
		                var a = ctrl[15];
		                return function(b, c, d, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (notify, a, b, c, d, cont);};
		               }
		               function warn$4(ctrl){
		                var t = ctrl[15];
		                return function(f, cont){
		                 return caml_exact_trampoline_cps_call
		                         (notify_f(t, a7u), f, cont);};
		               }
		               function err$2(ctrl){
		                var t = ctrl[15];
		                return function(f, cont){
		                 return caml_exact_trampoline_cps_call
		                         (notify_f(t, a7v), f, cont);};
		               }
		               function offline$0(name, ctrl){
		                var a = ctrl[16], b = ctrl[1];
		                return function(c, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (offline, name, b, a, c, cont);};
		               }
		               var
		                open$17 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_bind$26 = open$17[1],
		                symbol_map$23 = open$17[2],
		                symbol$231 = open$17[13],
		                let$30 = open$17[14];
		               function api$2(ctrl, cont){
		                return caml_exact_trampoline_cps_call(api$1, ctrl[1], cont);
		               }
		               function user_id$0(ctrl, cont){
		                return caml_exact_trampoline_cps_call(user_id, ctrl[1], cont);
		               }
		               function claim_account(ctrl, token, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline$0("claiming new account", ctrl),
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (api$2,
		                                   ctrl,
		                                   function(match){
		                                    var api = match[2], Api = match[1];
		                                    return caml_trampoline_cps_call3
		    (Api[1][1], api, token, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function logout(ctrl, cont){
		                var auth = ctrl[1];
		                return caml_exact_trampoline_cps_call
		                        (device,
		                         auth,
		                         function(match){
		                          function a(a){
		                           return caml_trampoline_cps_call2(auth[1][10], auth[2], cont);
		                          }
		                          if(0 !== match[0]) return a();
		                          var device_id = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (Device[8],
		                                   device_id,
		                                   function(c){
		                                    var b = [4, c];
		                                    return caml_exact_trampoline_cps_call
		    (user_id,
		     auth,
		     function(c){
		      c = user([0, c], b);
		      return caml_exact_trampoline_cps_call$0
		              (push_dont_wait$0, ctrl[11], 0, c, a);
		     });
		                                   });
		                         });
		               }
		               function delete_account(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline$0("deleting user account", ctrl),
		                         function(param, cont){
		                          function f(m, cont){
		                           return caml_trampoline_cps_call4(m, 0, 0, a8R, cont);
		                          }
		                          function a(param, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (api$2,
		                                    ctrl,
		                                    function(match){
		                                     var api = match[2], Api = match[1];
		                                     function a(param, cont){
		                                      return caml_exact_trampoline_cps_call
		      (user_id,
		       ctrl[1],
		       function(a){
		        a = user([0, a], 0);
		        return caml_exact_trampoline_cps_call$0
		                (push_dont_wait$0,
		                 ctrl[11],
		                 0,
		                 a,
		                 function(match){
		                  return caml_exact_trampoline_cps_call(logout, ctrl, cont);
		                 });
		       });
		                                     }
		                                     return caml_trampoline_cps_call2
		     (Api[1][2],
		      api,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$30, b, a, cont);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (Lwt[6],
		                                   f,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (map$23,
		     b,
		     of_string$14,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$30, b, a, cont);
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function refresh$0(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline$0("refreshing tokens", ctrl),
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (refresh, ctrl[1], cont);
		                         },
		                         cont);
		               }
		               function request_scopes
		               (ctrl, identity, requested_scopes, redirect_uri, cont){
		                return caml_exact_trampoline_cps_call
		                        (Sync[6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call3
		                                  (encode$5,
		                                   schema$225,
		                                   requested_scopes,
		                                   function(a){
		                                    return caml_trampoline_cps_call8
		    (m, 0, 0, a8S, pp$43, identity, _16, a, cont);
		                                   });
		                         },
		                         function(match){
		                          function f(param, cont){
		                           var incremental = ctrl[9], V = ctrl[1];
		                           function a(param, cont){
		                            if(0 === param[0])
		                             return caml_trampoline_cps_call2(return$13, 0, cont);
		                            var e = param[1];
		                            if(typeof e !== "number"){
		                             var variant = e[1];
		                             if(372688026 === variant){
		                              var info = e[2];
		                              return caml_trampoline_cps_call2(return$13, [0, info], cont);
		                             }
		                            }
		                            return caml_exact_trampoline_cps_call(fail$2, e, cont);
		                           }
		                           return caml_trampoline_cps_call6
		                                   (V[1][17],
		                                    V[2],
		                                    redirect_uri,
		                                    incremental,
		                                    identity,
		                                    requested_scopes,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(symbol_bind$26, b, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (offline$0("Updating integrations access scopes", ctrl),
		                                   f,
		                                   cont);
		                         });
		               }
		               function unlink_account(ctrl, identity, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$2,
		                         ctrl,
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          function f(param, cont){
		                           function a(param, cont){
		                            function a(param, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (refresh, ctrl[1], cont);
		                            }
		                            function b(param, cont){
		                             return param
		                                     ? caml_trampoline_cps_call2(return$13, 0, cont)
		                                     : caml_exact_trampoline_cps_call
		                                       (warn$3,
		function(m, cont){
		 return caml_trampoline_cps_call6
		         (m, 0, 0, a8T, pp$43, identity, cont);
		},
		cont);
		                            }
		                            return caml_trampoline_cps_call3
		                                    (Api[1][8],
		                                     api,
		                                     identity,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$231,
		       c,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$30, b, a, cont);
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (profile_main,
		                                    ctrl[9],
		                                    function(main_profile){
		                                     var b = main_profile[1];
		                                     return caml_exact_trampoline_cps_call
		     (of_google_id,
		      identity,
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (symbol$156,
		                c,
		                b,
		                function(c){
		                 function b(b){
		                  return caml_exact_trampoline_cps_call$1(let$30, b, a, cont);
		                 }
		                 return c
		                         ? caml_exact_trampoline_cps_call(fail$2, a8U, b)
		                         : caml_trampoline_cps_call2(return$13, 0, b);
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (offline$0("unlinking account", ctrl), f, cont);
		                         });
		               }
		               function update_channel(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$2,
		                         ctrl,
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (offline$0("reading update channel", ctrl),
		                                   function(param, cont){
		                                    function a(result, cont){
		                                     if(0 !== result[0]){
		                                      var a = result[1];
		                                      if(typeof a !== "number"){
		                                       var variant = a[1];
		                                       if(-867418942 === variant){
		a = a[2][1];
		if(a){
		 var channel = a[1];
		 return channel ? cont([0, stable]) : cont([0, bleeding]);
		}
		                                       }
		                                      }
		                                     }
		                                     return cont(result);
		                                    }
		                                    return caml_trampoline_cps_call2
		    (Api[1][9],
		     api,
		     function(b){
		      return caml_trampoline_cps_call3(symbol_map$23, b, a, cont);
		     });
		                                   },
		                                   cont);
		                         });
		               }
		               function add_account(ctrl, redirect_uri, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline$0("computing account addition URL", ctrl),
		                         function(param, cont){
		                          var V = ctrl[1];
		                          return caml_trampoline_cps_call4
		                                  (V[1][1], 0, redirect_uri, V[2], cont);
		                         },
		                         cont);
		               }
		               function handle_login_intent(ctrl, login, cont){
		                var match = login[3];
		                if(typeof match === "number")
		                 return caml_trampoline_cps_call2(return$13, 0, cont);
		                if(0 === match[0]){
		                 var token = match[2], claimed = match[1];
		                 return caml_exact_trampoline_cps_call
		                         (offline$0("claiming account", ctrl),
		                          function(param, cont){
		                           return claimed
		                                   ? caml_exact_trampoline_cps_call
		                                     (warn$4(ctrl),
		                                      a8V,
		                                      function(a){
		                                       return caml_trampoline_cps_call2(return$13, a, cont);
		                                      })
		                                   : caml_exact_trampoline_cps_call
		                                     (api$2,
		                                      ctrl,
		                                      function(match){
		                                       var api = match[2], Api = match[1];
		                                       return caml_trampoline_cps_call3
		       (Api[1][1], api, token, cont);
		                                      });
		                          },
		                          cont);
		                }
		                var token$0 = match[1];
		                return caml_exact_trampoline_cps_call
		                        (offline$0("accepting organization invitation", ctrl),
		                         function(param, cont){
		                          var V = ctrl[1];
		                          return caml_trampoline_cps_call2
		                                  (V[1][9],
		                                   V[2],
		                                   function(a){
		                                    return caml_trampoline_cps_call2(a, token$0, cont);
		                                   });
		                         },
		                         cont);
		               }
		               var
		                Logs$10 = with_tag$0(component$0, "Controller.Menu_items"),
		                letrec_function_context$923 = [];
		               function all_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$923[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, a8W, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$923[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$923[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$923[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$318,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_hidden,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$318,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var hidden = param[2][1], visible = param[1];
		             return cont([0, visible, hidden]);
		            },
		            function(param, cont){
		             var hidden = param[2], visible = param[1];
		             return cont([0, visible, [0, hidden, 0]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_visible,
		              0,
		              2,
		              [0, [0, 0, 0, [3, b], 0]],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$923[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$923[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$884 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$923, [0, schematic_cache$884]);
		               caml_callback
		                (all_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function list$1(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$10[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a8Y, cont);
		                         },
		                         function(match){
		                          var values = ctrl[9][5], menu_items = values[45];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, menu_items, cont);
		                         });
		               }
		               function all$25(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (user_id$0,
		                         ctrl,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (personal_organization_of_user_,
		                                   a,
		                                   function(personal_organization){
		                                    var
		                                     param = ctrl[9],
		                                     values = param[5],
		                                     incremental = param[1],
		                                     menu_items = values[45],
		                                     organizations = values[28],
		                                     open =
		                                       g
		([0,
		  incremental[72],
		  incremental[73],
		  ,
		  incremental[75],
		  incremental[76],
		  incremental[77],
		  ,
		  ,
		  ,
		  ,
		  incremental[82]]),
		                                     and = open[6],
		                                     let$ = open[4];
		                                    function a(param, cont){
		                                     var organizations = param[2], menu_items = param[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (filter,
		      menu_items,
		      function(a, cont){
		       a = a[1];
		       switch(a[0]){
		         case 1:
		          a = a[1];
		          if(a){
		           var organization = a[1];
		           return caml_exact_trampoline_cps_call$1
		                   (mem$3, organizations, organization, cont);
		          }
		          break;
		         case 2:
		          var value = a[1];
		          return caml_exact_trampoline_cps_call$1
		                  (mem$3, organizations, value, cont);
		       }
		       return cont(1);
		      },
		      function(items){
		       function a(b){
		        if(b){
		         var l = b[2], x = b[1], home = x[2];
		         if(! home) return caml_exact_trampoline_call1(a, l);
		         b = [0, x];
		        }
		        else
		         b = 0;
		        function c(visible){
		         return caml_exact_trampoline_cps_call
		                 (deconstruct,
		                  all$4,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (filter_map$1,
		                            a,
		                            function(screen, cont){
		                             function a(t){
		                              function c(a){
		                               return a ? cont(0) : cont([0, [0, [1, 0, screen], 0]]);
		                              }
		                              if(! t) return c(0);
		                              var xs = t[2], item = t[1], match = item[1];
		                              function d(){return b(0);}
		                              function b(b){
		                               return b ? c(1) : caml_exact_trampoline_call1(a, xs);
		                              }
		                              if(1 !== match[0]) return d();
		                              var value = match[2], organization = match[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (symbol$199,
		                                       value,
		                                       screen,
		                                       function(a){
		if(! a) return d();
		if(! organization) return b(1);
		var organization$0 = organization[1];
		return caml_exact_trampoline_cps_call$1
		        (symbol$115, organization$0, personal_organization, b);
		                                       });
		                             }
		                             return a(menu_items);
		                            },
		                            function(hidden_personal){
		                             return caml_exact_trampoline_cps_call
		                                     (deconstruct,
		                                      all_organization_specific,
		                                      function(screens){
		                                       return caml_trampoline_cps_call2
		       (symbol$118,
		        personal_organization,
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (filter$3,
		                  organizations,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$2
		                           (to_sequence$0,
		                            0,
		                            0,
		                            0,
		                            a,
		                            function(organizations){
		                             return caml_exact_trampoline_cps_call$1
		                                     (cartesian_product,
		                                      organizations,
		                                      screens,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (filter_map$1,
		        a,
		        function(param, cont){
		         var screen = param[2], screen_organization = param[1];
		         function a(t){
		          function c(a){
		           return a
		                   ? cont(0)
		                   : cont([0, [0, [1, [0, screen_organization], screen], 0]]);
		          }
		          if(! t) return c(0);
		          var xs = t[2], item = t[1], match$0 = item[1];
		          function b(b){
		           return b ? c(1) : caml_exact_trampoline_call1(a, xs);
		          }
		          if(1 === match$0[0]){
		           var match = match$0[1];
		           if(match){
		            var value = match$0[2], organization = match[1];
		            return caml_exact_trampoline_cps_call$1
		                    (symbol$199,
		                     value,
		                     screen,
		                     function(a){
		                      return a
		                              ? caml_exact_trampoline_cps_call$1
		                                (symbol$115, organization, screen_organization, b)
		                              : b(a);
		                     });
		           }
		          }
		          return b(0);
		         }
		         return a(menu_items);
		        },
		        function(hidden_organizations){
		         return caml_exact_trampoline_cps_call
		                 (deconstruct,
		                  [0, hidden_personal, [0, hidden_organizations, 0]],
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (concat$1,
		                            a,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (to_binable, a, function(a){return cont([0, visible, a]);});
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        }
		        return b
		                ? c(items)
		                : caml_exact_trampoline_cps_call
		                  (Logs$10[6][6],
		                   function(m, cont){
		                    return caml_trampoline_cps_call4(m, 0, 0, a8Z, cont);
		                   },
		                   function(match){
		                    if(! items) return c(0);
		                    var tail = items[2], first = items[1];
		                    return c([0, [0, first[1], 1], tail]);
		                   });
		       }
		       return a(items);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$0
		    (keys$2,
		     0,
		     0,
		     organizations[1],
		     function(b){
		      return caml_trampoline_cps_call3
		              (and,
		               menu_items,
		               b,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function modify(opt, ctrl, crdt, f, cont){
		                var reason = opt ? opt[1] : "modify";
		                return caml_exact_trampoline_cps_call
		                        (Logs$10[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call5(m, 0, 0, a80, reason, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (list$1,
		                                   ctrl,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (get$17,
		     a,
		     function(current_items){
		      return caml_exact_trampoline_cps_call
		              (f,
		               current_items,
		               function(new_items){
		                return caml_exact_trampoline_cps_call
		                        (Logs$10[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a8X, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (diff$8,
		                                   current_items,
		                                   new_items,
		                                   function(match){
		                                    if(! match) return cont(0);
		                                    var op = match[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (apply_personal, ctrl[1], crdt, [2, [17, op]], cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function has_target(target, item, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (equal$213, item[1], target, cont);
		               }
		               function replace(ctrl, crdt, new_items, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (modify,
		                         a81,
		                         ctrl,
		                         crdt,
		                         function(param, cont){return cont(new_items);},
		                         cont);
		               }
		               function append$14(ctrl, crdt, new_item, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (modify,
		                         a82,
		                         ctrl,
		                         crdt,
		                         function(currentList, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (append$0, currentList, [0, [0, new_item, 0], 0], cont);
		                         },
		                         cont);
		               }
		               function remove$26(ctrl, crdt, item, cont){
		                function a(x, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (has_target, item, x, function(a){return cont(1 - a);});
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (modify,
		                         a83,
		                         ctrl,
		                         crdt,
		                         function(b, cont){
		                          return caml_exact_trampoline_cps_call$1(filter, b, a, cont);
		                         },
		                         cont);
		               }
		               function toggle(ctrl, crdt, item, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (modify,
		                         a86,
		                         ctrl,
		                         crdt,
		                         function(lst, cont){
		                          function a(t){
		                           function b(a){
		                            return a
		                                    ? caml_exact_trampoline_cps_call
		                                      (Logs$10[6][4],
		                                       function(m, cont){
		return caml_trampoline_cps_call4(m, 0, 0, a84, cont);
		                                       },
		                                       function(match){
		return caml_exact_trampoline_cps_call$1
		        (filter,
		         lst,
		         function(x, cont){
		          return caml_exact_trampoline_cps_call$1
		                  (has_target, item, x, function(a){return cont(1 - a);});
		         },
		         cont);
		                                       })
		                                    : caml_exact_trampoline_cps_call
		                                      (Logs$10[6][4],
		                                       function(m, cont){
		return caml_trampoline_cps_call4(m, 0, 0, a85, cont);
		                                       },
		                                       function(match){return cont([0, [0, item, 0], lst]);});
		                           }
		                           if(! t) return b(0);
		                           var xs = t[2], x = t[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (has_target,
		                                    item,
		                                    x,
		                                    function(c){
		                                     return c ? b(1) : caml_exact_trampoline_call1(a, xs);
		                                    });
		                          }
		                          return a(lst);
		                         },
		                         cont);
		               }
		               function set_home(ctrl, crdt, value, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$10[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a87, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (list$1,
		                                   ctrl,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (get$17,
		     a,
		     function(current_items){
		      function a(t, init){
		       if(t){
		        var
		         l = t[2],
		         a$0 = t[1],
		         acc = init[2],
		         i = init[1],
		         found_item$0 = acc[2],
		         ops$0 = acc[1];
		        return caml_exact_trampoline_cps_call$1
		                (equal$213,
		                 a$0[1],
		                 value,
		                 function(c){
		                  function b(b){
		                   var init = [0, i + 1 | 0, b];
		                   return caml_exact_trampoline_call2(a, l, init);
		                  }
		                  return c
		                          ? caml_exact_trampoline_cps_call
		                            (include$139[12],
		                             1,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (element$8,
		                                       i,
		                                       [2, [1, a]],
		                                       function(new_op){return b([0, [0, new_op, ops$0], 1]);});
		                             })
		                          : caml_exact_trampoline_cps_call
		                            (include$139[12],
		                             0,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (element$8,
		                                       i,
		                                       [2, [1, a]],
		                                       function(new_op){
		return b([0, [0, new_op, ops$0], found_item$0]);
		                                       });
		                             });
		                 });
		       }
		       var match = init[2], found_item = match[2], ops = match[1];
		       return caml_exact_trampoline_cps_call
		               (Operation$9[10],
		                ops,
		                function(op){
		                 function a(op){
		                  return caml_exact_trampoline_cps_call$0
		                          (apply_personal, ctrl[1], crdt, [2, [17, op]], cont);
		                 }
		                 if(found_item) return a(op);
		                 function b(param, cont){return cont(op);}
		                 return caml_exact_trampoline_cps_call$1
		                         (insert$1,
		                          0,
		                          [0, [0, value, 1], 0],
		                          function(c){
		                           return caml_trampoline_cps_call3(Operation$9[4], c, b, a);
		                          });
		                });
		      }
		      return a(current_items, [0, 0, init$3]);
		     });
		                                   });
		                         });
		               }
		               function all$26(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           workspaces = param[2][44],
		                           Incr = param[1],
		                           open =
		                             g
		                              ([0,
		                                Incr[72],
		                                Incr[73],
		                                ,
		                                Incr[75],
		                                Incr[76],
		                                Incr[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Incr[82]]),
		                           symbol_map = open[2];
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   workspaces[1],
		                                   keys$0,
		                                   function(workspaces){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, workspaces, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function sort_organization_workspaces(left, right, cont){
		                function is_default$0(workspace, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (is_default, workspace[3][1], workspace[2], cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (is_default$0,
		                         left,
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (is_default$0,
		                                   right,
		                                   function(match$0){
		                                    if(match){
		                                     if(! match$0) return cont(-1);
		                                    }
		                                    else if(match$0) return cont(1);
		                                    var y = right[3][2], x = left[3][2];
		                                    return cont(caml_string_compare(x, y));
		                                   });
		                         });
		               }
		               function member_add
		               (ctrl, crdt$0, apply, id, access_role, account, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 let$0 = open[3],
		                 crdt = ctrl[2];
		                function a(organization, cont){
		                 function a(res, cont){
		                  var a = workspace(id, organization[3][2], [1, account]);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait$0,
		                           ctrl[11],
		                           0,
		                           a,
		                           function(match){return cont(res);});
		                 }
		                 return caml_trampoline_cps_call3
		                         (add$32,
		                          account,
		                          [0, access_role, account],
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (members,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call4
		     (apply,
		      ctrl[1],
		      crdt$0,
		      id,
		      function(c){
		       return caml_trampoline_cps_call2
		               (c,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         crdt,
		                         function(state){
		                          var organizations = state[15];
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter$5,
		                                   organizations,
		                                   function(org, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (mem$5, org[4], id, cont);
		                                   },
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (to_alist$0,
		     0,
		     b,
		     function(b){
		      function c(b){
		       return caml_trampoline_cps_call3
		               (let$0, of_option(b, [0, 847566860, id]), a, cont);
		      }
		      if(! b) return c(0);
		      var d = b[2], b = b[1], org = b[2], org1 = b[1];
		      if(! d) return c([0, org]);
		      var org2 = d[1][1];
		      return caml_exact_trampoline_cps_call$1
		              (fatal$0,
		               a89,
		               a88,
		               function(a){
		                return caml_trampoline_cps_call7
		                        (a, pp$46, id, pp$37, org1, pp$37, org2, c);
		               });
		     });
		                                   });
		                         });
		               }
		               function create$43(ctrl, crdt, a, opt, workspace$0, cont){
		                if(a)
		                 var created = a[1];
		                else
		                 var t = ocaml_ptime_clock_now_d_ps(), created = t;
		                var id = opt ? opt[1] : make$32();
		                return caml_trampoline_cps_call3
		                        (bR4,
		                         id,
		                         [0, created, id, workspace$0],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (workspaces,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$11,
		     workspace$0[1],
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (organizations,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (apply_personal,
		                                   ctrl[1],
		                                   crdt,
		                                   a,
		                                   function(a){
		                                    a = workspace(id, workspace$0[1], 0);
		                                    return caml_exact_trampoline_cps_call$0
		    (push_dont_wait$0,
		     ctrl[11],
		     0,
		     a,
		     function(match){
		      var open = g(include$0), let$ = open[17];
		      function a(param, cont){return cont(id);}
		      return caml_exact_trampoline_cps_call
		              (user_id,
		               ctrl[1],
		               function(b){
		                return caml_exact_trampoline_cps_call$7
		                        (member_add,
		                         ctrl,
		                         crdt,
		                         apply_bypass,
		                         id,
		                         1,
		                         b,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function get$18(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var workspaces = param[2][44];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   workspaces[2],
		                                   id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function get_organization(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         ctrl[2],
		                         function(match){
		                          var organizations = match[15];
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter$5,
		                                   organizations,
		                                   function(org, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (mem$5, org[4], id, cont);
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (to_alist$0,
		     0,
		     a,
		     function(a){
		      if(! a) return cont(0);
		      var b = a[2], a = a[1], org = a[2], org1 = a[1];
		      if(! b) return cont([0, org]);
		      var org2 = b[1][1];
		      return caml_exact_trampoline_cps_call$1
		              (fatal$0,
		               a8$,
		               a8_,
		               function(a){
		                return caml_trampoline_cps_call7
		                        (a, pp$46, id, pp$37, org1, pp$37, org2, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function get_user(ctrl, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                function a(org, cont){
		                 return caml_exact_trampoline_cps_call
		                         (user_id,
		                          ctrl[1],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id, org[1], a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_organization,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function get_personal(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           workspaces = param[2][44],
		                           Incr = param[1],
		                           open =
		                             g
		                              ([0,
		                                Incr[72],
		                                Incr[73],
		                                ,
		                                Incr[75],
		                                Incr[76],
		                                Incr[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Incr[82]]),
		                           symbol_map = open[2];
		                          return caml_exact_trampoline_cps_call
		                                  (user_id,
		                                   ctrl[1],
		                                   function(id){
		                                    var
		                                     s2 = to_nanoid$1(id),
		                                     s2$0 = cst$21 + s2,
		                                     raw_id = name$25 + s2$0;
		                                    return caml_exact_trampoline_cps_call
		    (of_string$37,
		     raw_id,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (ok_or_failwith,
		               a,
		               function(personal_workspace_id){
		                function a(param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (fatal$0,
		                           a9b,
		                           a9a,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (a, pp$46, personal_workspace_id, cont);
		                           });
		                 var workspace = param[1];
		                 return cont(workspace);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         workspaces[2],
		                         personal_workspace_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   b,
		                                   a,
		                                   function(workspace){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, workspace, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function member_remove(ctrl, crdt, id, account, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function a(organization, cont){
		                 function a(res, cont){
		                  var a = workspace(id, organization[3][2], [3, account]);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait$0,
		                           ctrl[11],
		                           0,
		                           a,
		                           function(match){return cont(res);});
		                 }
		                 return caml_trampoline_cps_call2
		                         (remove$20,
		                          account,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (members,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$2
		     (apply$125,
		      ctrl[1],
		      crdt,
		      id,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_organization,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$0, of_option(b, [0, 847566860, id]), a, cont);
		                         });
		               }
		               function member_set_role
		               (ctrl, crdt, id, account, access_role, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function a(organization, cont){
		                 function a(res, cont){
		                  var a = workspace(id, organization[3][2], a9c);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait$0,
		                           ctrl[11],
		                           0,
		                           a,
		                           function(match){return cont(res);});
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (set$25,
		                          [0, access_role, account],
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (element$24,
		                                    account,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (members,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$2
		                         (apply$125,
		                          ctrl[1],
		                          crdt,
		                          id,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_organization,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$0, of_option(b, [0, 847566860, id]), a, cont);
		                         });
		               }
		               function members$0(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           workspaces = param[2][44],
		                           Incr = param[1],
		                           open =
		                             g
		                              ([0,
		                                Incr[72],
		                                Incr[73],
		                                ,
		                                Incr[75],
		                                Incr[76],
		                                Incr[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Incr[82]]),
		                           let$ = open[4];
		                          function a(workspace, cont){
		                           if(! workspace) return cont(0);
		                           var members = workspace[1][4];
		                           return caml_exact_trampoline_cps_call(keys$0, members, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   workspaces[2],
		                                   id,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     b,
		     a,
		     function(members){
		      return caml_exact_trampoline_cps_call$1
		              (of_incremental, 0, members, cont);
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function all$27(crdt, cont){
		                return caml_exact_trampoline_cps_call
		                        (state_writable_personal,
		                         crdt,
		                         function(match){
		                          var organizations = match[15];
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   organizations,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (map$18,
		     a,
		     function(organization, cont){return cont(organization[4]);},
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (reduce,
		               a,
		               merge_disjoint_exn$0,
		               function(a){
		                return caml_exact_trampoline_cps_call$2
		                        (value_exn, a9d, 0, 0, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function apply_in_organization(ctrl, crdt, workspace, op, cont){
		                return caml_exact_trampoline_cps_call
		                        (workspaces,
		                         op,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (element$12,
		                                   workspace[3][1],
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (organizations,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$0
		                        (apply_personal,
		                         ctrl[1],
		                         crdt,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2(of_string$14, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function remove$27(ctrl, crdt, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (all$27,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   a,
		                                   id,
		                                   function(match){
		                                    if(! match) return cont([1, [0, 847566860, id]]);
		                                    var
		                                     workspace$0 = match[1],
		                                     open =
		                                       o
		([0,
		  symbol_bind$4,
		  symbol_map$4,
		  Let_syntax$2,
		  ,
		  bind$6,
		  of_string$14,
		  map$15]),
		                                     let$ = open[4],
		                                     let$0 = open[3];
		                                    function a(organization, cont){
		                                     function a(res, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (remove$26,
		       ctrl,
		       crdt,
		       [4, id],
		       function(a){
		        a = workspace(id, organization[3][2], 1);
		        return caml_exact_trampoline_cps_call$0
		                (push_dont_wait$0,
		                 ctrl[11],
		                 0,
		                 a,
		                 function(match){return cont(res);});
		       });
		                                     }
		                                     return caml_trampoline_cps_call2
		     (bR3,
		      id,
		      function(b){
		       return caml_exact_trampoline_cps_call$2
		               (apply_in_organization,
		                ctrl,
		                crdt,
		                workspace$0,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (get_organization,
		     ctrl,
		     id,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$0, of_option(b, [0, 847566860, id]), a, cont);
		     });
		                                   });
		                         });
		               }
		               function rename$0(ctrl, crdt, id, new_name, cont){
		                return caml_exact_trampoline_cps_call
		                        (all$27,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   a,
		                                   id,
		                                   function(match){
		                                    if(! match) return cont([1, [0, 847566860, id]]);
		                                    var workspace$0 = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (diff$1,
		     workspace$0[3][2],
		     new_name,
		     function(match){
		      if(! match) return cont(a9f);
		      var
		       operation = match[1],
		       open =
		         o
		          ([0,
		            symbol_bind$4,
		            symbol_map$4,
		            Let_syntax$2,
		            ,
		            bind$6,
		            of_string$14,
		            map$15]),
		       let$ = open[4],
		       let$0 = open[3];
		      function a(organization, cont){
		       function a(res, cont){
		        var a = workspace(id, organization[3][2], a9e);
		        return caml_exact_trampoline_cps_call$0
		                (push_dont_wait$0,
		                 ctrl[11],
		                 0,
		                 a,
		                 function(match){return cont(res);});
		       }
		       return caml_exact_trampoline_cps_call
		               (name$33,
		                operation,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (bQC,
		                          id,
		                          function(c){
		                           return caml_trampoline_cps_call2
		                                   (c,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$2
		     (apply_in_organization,
		      ctrl,
		      crdt,
		      workspace$0,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call$1
		              (get_organization,
		               ctrl,
		               id,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$0, of_option(b, [0, 847566860, id]), a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function set_home$0(ctrl, crdt, id, home_opt, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                function a(state, cont){return cont(state[19]);}
		                return caml_exact_trampoline_cps_call$1
		                        (state_writable,
		                         id,
		                         crdt,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(current_home){
		                                    return caml_exact_trampoline_cps_call$0
		    (equal_option,
		     equal$54,
		     current_home,
		     home_opt,
		     function(b){
		      if(b) return cont(a9g);
		      var
		       open =
		         o
		          ([0,
		            symbol_bind$4,
		            symbol_map$4,
		            Let_syntax$2,
		            ,
		            bind$6,
		            of_string$14,
		            map$15]),
		       let$ = open[3];
		      function a(organization, cont){
		       function a(a, cont){
		        a = workspace(id, organization[3][2], a9h);
		        return caml_exact_trampoline_cps_call$0
		                (push_dont_wait$0,
		                 ctrl[11],
		                 0,
		                 a,
		                 function(match){return cont(a9i);});
		       }
		       return caml_exact_trampoline_cps_call
		               (set$26,
		                home_opt,
		                function(op){
		                 return caml_exact_trampoline_cps_call
		                         (v$47,
		                          [9, op],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply$125,
		                                    ctrl[1],
		                                    crdt,
		                                    id,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$, b, a, cont);
		                                    });
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call$1
		              (get_organization,
		               ctrl,
		               id,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$, of_option(b, [0, 847566860, id]), a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function create$44(ctrl, workspace, mime, name, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          return caml_exact_trampoline_cps_call$2
		                                  (offline,
		                                   "creating attachment",
		                                   ctrl[1],
		                                   ctrl[16],
		                                   function(param, cont){
		                                    return caml_trampoline_cps_call5
		    (Api[11][1][1], api, workspace, mime, name, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function finalize$0(ctrl, workspace, url, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14];
		                function a(id, cont){
		                 return caml_exact_trampoline_cps_call
		                         (api$1,
		                          ctrl[1],
		                          function(match){
		                           var api = match[2], Api = match[1];
		                           return caml_exact_trampoline_cps_call$2
		                                   (offline,
		                                    "finalizing attachment",
		                                    ctrl[1],
		                                    ctrl[16],
		                                    function(param, cont){
		                                     return caml_trampoline_cps_call4
		     (Api[11][1][2], api, workspace, id, cont);
		                                    },
		                                    cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (path$0,
		                         0,
		                         url,
		                         function(c){
		                          function b(list){
		                           if(list){
		                            var x = list[1];
		                            if(list[2]){
		                             var list$0 = list[2];
		                             return caml_exact_trampoline_call1(b, list$0);
		                            }
		                            var c = [0, x];
		                           }
		                           else
		                            c = 0;
		                           return caml_trampoline_cps_call3
		                                   (bind$6,
		                                    of_option(c, "unrecognized attachment URL"),
		                                    of_string$44,
		                                    function(t){
		                                     if(0 === t[0])
		                                      var b = t;
		                                     else
		                                      var error = t[1], b = [1, [0, 9943782, error]];
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1(split$0, c, 47, b);
		                         });
		               }
		               function parent(ctrl, id, cont){
		                g
		                 ([0,
		                   symbol_bind$8,
		                   symbol_map$6,
		                   ,
		                   bind$10,
		                   return$12,
		                   map$23,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$4]);
		                switch(id[0]){
		                  case 2:
		                   var
		                    id$0 = id[1],
		                    f = function(parent, cont){return cont([2, parent]);},
		                    f$0 =
		                      function(param, cont){
		                       var parent = param[1][3][5];
		                       return cont(parent);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_from_state$1,
		                            ctrl[9],
		                            id$0,
		                            function(x){
		                             return caml_trampoline_cps_call3
		                                     (bind$8,
		                                      x,
		                                      f$0,
		                                      function(x){
		                                       return caml_trampoline_cps_call3(map$17, x, f, cont);
		                                      });
		                            });
		                  case 4:
		                   var
		                    id$1 = id[1],
		                    f$1 = function(task, cont){return cont(task[7][6]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_from_state$3,
		                            ctrl[9],
		                            id$1,
		                            function(x){
		                             return caml_trampoline_cps_call3(bind$8, x, f$1, cont);
		                            });
		                  case 5:
		                   var
		                    id$2 = id[1],
		                    f$2 = function(task, cont){return cont(task[5][1]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_from_state$4,
		                            ctrl[9],
		                            id$2,
		                            function(x){
		                             return caml_trampoline_cps_call3(bind$8, x, f$2, cont);
		                            });
		                  default: return cont(0);
		                }
		               }
		               var
		                Logs$11 = with_tag$0(component$0, "Controller.Documents"),
		                bQG =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   [0,
		                    pp$35,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    generic$0]],
		                bQH =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   [0,
		                    pp$36,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    generic$1]],
		                bQI =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   [0,
		                    pp$114,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    generic$2]],
		                bQJ =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   [0,
		                    _16$0,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    generic$3]],
		                bQK =
		                  [0,
		                   ,
		                   ,
		                   ,
		                   [0,
		                    pp$72,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    ,
		                    generic$4]];
		               function append$15(crdt, state, document, block, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function append(O, id, section, cont){
		                 function a(a, cont){
		                  var op = a[2], obj = a[1], a = O[6].call(null, obj);
		                  return cont([0, O[2][4][31].call(null, a), op]);
		                 }
		                 return caml_exact_trampoline_cps_call$3
		                         (O[7],
		                          crdt,
		                          state,
		                          section,
		                          id,
		                          block,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                }
		                var match = document[1];
		                switch(match[0]){
		                  case 0:
		                   var section = document[2], id = match[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (append,
		                            [0, , bQG, , , , id$39, append$9],
		                            id,
		                            section,
		                            cont);
		                  case 1:
		                   var section$0 = document[2], id$0 = match[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (append,
		                            [0,
		                             ,
		                             [0,
		                              ,
		                              ,
		                              ,
		                              [0,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               ,
		                               generic]],
		                             ,
		                             ,
		                             ,
		                             id$38,
		                             append$8],
		                            id$0,
		                            section$0,
		                            cont);
		                  case 2:
		                   var section$1 = document[2], id$1 = match[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (append,
		                            [0, , bQH, , , , id$40, append$10],
		                            id$1,
		                            section$1,
		                            cont);
		                  case 3:
		                   var section$2 = document[2], id$2 = match[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (append,
		                            [0, , bQI, , , , id$41, append$11],
		                            id$2,
		                            section$2,
		                            cont);
		                  case 4:
		                   var section$3 = document[2], id$3 = match[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (append,
		                            [0, , bQJ, , , , id$42, append$12],
		                            id$3,
		                            section$3,
		                            cont);
		                  case 5:
		                   var section$4 = document[2], id$4 = match[1];
		                   return caml_exact_trampoline_cps_call$0
		                           (append,
		                            [0, , bQK, , , , id$43, append$13],
		                            id$4,
		                            section$4,
		                            cont);
		                  default:
		                   return caml_exact_trampoline_cps_call
		                           (Logs$11[6][4],
		                            function(m, cont){
		                             return caml_trampoline_cps_call4(m, 0, 0, a9j, cont);
		                            },
		                            function(match){return cont(0);});
		                }
		               }
		               function remove_todo_crdt(id, task_id, content, cont){
		                function to_matching(pos, block, cont){
		                 function b(){return cont(0);}
		                 if(0 === task_id[0]){
		                  var a = block[2];
		                  if(typeof a === "number") return b();
		                  if(11 !== a[0]) return b();
		                  a = a[1][3];
		                  if(! a) return b();
		                  var task = a[1], id = block[1], task_id$0 = task_id[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$121,
		                           task,
		                           task_id$0,
		                           function(a){
		                            return a ? cont([0, [0, pos, id, block]]) : b();
		                           });
		                 }
		                 a = block[2];
		                 if(typeof a === "number") return b();
		                 if(10 !== a[0]) return b();
		                 a = a[1][1];
		                 if(! a) return b();
		                 var task$0 = a[1], id$0 = block[1], task_id$1 = task_id[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (symbol$152,
		                          task$0,
		                          task_id$1,
		                          function(a){
		                           return a ? cont([0, [0, pos, id$0, block]]) : b();
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (filter_mapi,
		                         content[1],
		                         to_matching,
		                         function(matching){
		                          if(! matching)
		                           return caml_exact_trampoline_cps_call
		                                   (fail_result,
		                                    a9l,
		                                    function(a){
		                                     return caml_trampoline_cps_call5
		     (a, pp$71, task_id, pp_v$0, id, cont);
		                                    });
		                          var extra_blocks = matching[2], block = matching[1][3];
		                          function a(a){
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    matching,
		                                    function(param, cont){
		                                     var id = param[2], pos = param[1];
		                                     return cont([0, pos, id]);
		                                    },
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (remove_blocks,
		      a,
		      function(a){
		       return caml_trampoline_cps_call2
		               (of_string$14, [0, block, a], cont);
		      });
		                                    });
		                          }
		                          return is_empty(extra_blocks)
		                                  ? a()
		                                  : caml_exact_trampoline_cps_call
		                                    (Logs$11[6][4],
		                                     function(m, cont){
		                                      return caml_trampoline_cps_call8
		      (m, 0, 0, a9k, pp$71, task_id, pp_v$0, id, cont);
		                                     },
		                                     a);
		                         });
		               }
		               function remove_todo(id, task_id, content, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[3];
		                switch(id[0]){
		                  case 0:
		                   var
		                    parent_event_id = id[1],
		                    a =
		                      function(param, cont){
		                       var doc_op = param[2], block = param[1];
		                       return caml_exact_trampoline_cps_call
		                               (notes$0,
		                                doc_op,
		                                function(a){
		                                 return caml_trampoline_cps_call2
		 (element$3,
		  parent_event_id,
		  function(b){
		   return caml_trampoline_cps_call2
		           (b,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (events,
		                      a,
		                      function(a){
		                       return caml_exact_trampoline_cps_call
		                               (ignore_m$11,
		                                a,
		                                function(op){
		                                 return caml_trampoline_cps_call2
		 (of_string$14, [0, block, op], cont);
		                                });
		                      });
		            });
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$0
		                           (remove_todo_crdt,
		                            id,
		                            task_id,
		                            content,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$, b, a, cont);
		                            });
		                  case 1:
		                   var
		                    parent_event_id$0 = id[1],
		                    b =
		                      function(param, cont){
		                       var doc_op = param[2], block = param[1];
		                       return caml_exact_trampoline_cps_call
		                               (notes,
		                                doc_op,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call
		 (writable,
		  a,
		  function(a){
		   return caml_trampoline_cps_call2
		           (element$5,
		            parent_event_id$0,
		            function(b){
		             return caml_trampoline_cps_call2
		                     (b,
		                      a,
		                      function(a){
		                       return caml_exact_trampoline_cps_call
		                               (events_recurrent,
		                                a,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call
		 (ignore_m$11,
		  a,
		  function(op){
		   return caml_trampoline_cps_call2
		           (of_string$14, [0, block, op], cont);
		  });
		                                });
		                      });
		            });
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$0
		                           (remove_todo_crdt,
		                            id,
		                            task_id,
		                            content,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, b, cont);
		                            });
		                  case 2:
		                   var
		                    parent_page_id = id[1],
		                    c =
		                      function(param, cont){
		                       var doc_op = param[2], block = param[1];
		                       return caml_exact_trampoline_cps_call
		                               (notes$1,
		                                doc_op,
		                                function(a){
		                                 return caml_trampoline_cps_call2
		 (element$13,
		  parent_page_id,
		  function(b){
		   return caml_trampoline_cps_call2
		           (b,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (pages,
		                      a,
		                      function(a){
		                       return caml_exact_trampoline_cps_call
		                               (ignore_m$11,
		                                a,
		                                function(op){
		                                 return caml_trampoline_cps_call2
		 (of_string$14, [0, block, op], cont);
		                                });
		                      });
		            });
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$0
		                           (remove_todo_crdt,
		                            id,
		                            task_id,
		                            content,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, c, cont);
		                            });
		                  case 3:
		                   var
		                    parent_people_id = id[1],
		                    d =
		                      function(param, cont){
		                       var doc_op = param[2], block = param[1];
		                       return caml_exact_trampoline_cps_call
		                               (notes$2,
		                                doc_op,
		                                function(a){
		                                 return caml_trampoline_cps_call2
		 (element$15,
		  parent_people_id,
		  function(b){
		   return caml_trampoline_cps_call2
		           (b,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (people,
		                      a,
		                      function(op){
		                       return caml_trampoline_cps_call2
		                               (of_string$14, [0, block, op], cont);
		                      });
		            });
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$0
		                           (remove_todo_crdt,
		                            id,
		                            task_id,
		                            content,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, d, cont);
		                            });
		                  case 4:
		                   var
		                    parent_task_id = id[1],
		                    e =
		                      function(param, cont){
		                       var doc_op = param[2], block = param[1];
		                       return caml_exact_trampoline_cps_call
		                               (notes$4,
		                                doc_op,
		                                function(a){
		                                 return caml_trampoline_cps_call2
		 (element$23,
		  parent_task_id,
		  function(b){
		   return caml_trampoline_cps_call2
		           (b,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (tasks,
		                      a,
		                      function(op){
		                       return caml_trampoline_cps_call2
		                               (of_string$14, [0, block, op], cont);
		                      });
		            });
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$0
		                           (remove_todo_crdt,
		                            id,
		                            task_id,
		                            content,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, e, cont);
		                            });
		                  case 5:
		                   var
		                    parent_task_rec_id = id[1],
		                    f =
		                      function(param, cont){
		                       var doc_op = param[2], block = param[1];
		                       return caml_exact_trampoline_cps_call
		                               (notes$5,
		                                doc_op,
		                                function(a){
		                                 return caml_trampoline_cps_call2
		 (element$17,
		  parent_task_rec_id,
		  function(b){
		   return caml_trampoline_cps_call2
		           (b,
		            a,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (recurrences,
		                      a,
		                      function(op){
		                       return caml_trampoline_cps_call2
		                               (of_string$14, [0, block, op], cont);
		                      });
		            });
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$0
		                           (remove_todo_crdt,
		                            id,
		                            task_id,
		                            content,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, f, cont);
		                            });
		                  default: return cont(a9m);
		                }
		               }
		               function fetch_content(crdt, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                switch(id[0]){
		                  case 0:
		                   var
		                    id$0 = id[1],
		                    a = function(event, cont){return cont(event[9][8]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_event$1,
		                            crdt,
		                            id$0,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$, b, a, cont);
		                            });
		                  case 1:
		                   var
		                    id$1 = id[1],
		                    b = function(event, cont){return cont(event[7][8]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_event_recurrent$1,
		                            crdt,
		                            id$1,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, b, cont);
		                            });
		                  case 2:
		                   var
		                    id$2 = id[1],
		                    c = function(page, cont){return cont(page[3][2]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_page$0,
		                            crdt,
		                            id$2,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, c, cont);
		                            });
		                  case 3:
		                   var
		                    id$3 = id[1],
		                    d = function(person, cont){return cont(person[11][1]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_person$0,
		                            crdt,
		                            id$3,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, d, cont);
		                            });
		                  case 4:
		                   var
		                    id$4 = id[1],
		                    e = function(task, cont){return cont(task[7][9][1]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task$0,
		                            crdt,
		                            id$4,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, e, cont);
		                            });
		                  case 5:
		                   var
		                    id$5 = id[1],
		                    f =
		                      function(recurrent_task, cont){
		                       return cont(recurrent_task[5][3][1]);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task_recurrent$0,
		                            crdt,
		                            id$5,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, f, cont);
		                            });
		                  default: return cont(0);
		                }
		               }
		               var letrec_function_context$924 = [];
		               function compare$175(x, cont){
		                return caml_trampoline_cps_call2
		                        (letrec_function_context$924[1], x, cont);
		               }
		               caml_update_dummy
		                (letrec_function_context$924, [0, compare_document]);
		               function schema_versioned$553(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (document_schema_versioned,
		                                   schematic_version,
		                                   function(a){return cont([0, a9n, 0, a[3], a[4]]);});
		                         });
		               }
		               var
		                schema$250 =
		                  caml_callback
		                   (schema_versioned$553,
		                    [function(param, cont){return cont(0);}]),
		                sexp_of_t$143 = caml_callback(encode$7, [schema$250]),
		                include$286 = Make$2([0, compare$175, sexp_of_t$143]),
		                comparator$63 = include$286[16];
		               caml_callback(M$3, [[0, comparator$63, schema_versioned$553]]);
		               function sync_notes(Incremental, param, document, cont){
		                var
		                 tasks_recurrent_lookup = param[41],
		                 tasks_lookup = param[39],
		                 open =
		                   g
		                    ([0,
		                      Incremental[72],
		                      Incremental[73],
		                      ,
		                      Incremental[75],
		                      Incremental[76],
		                      Incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Incremental[82]]),
		                 let$ = open[4],
		                 symbol_map = open[2];
		                function f(block, cont){
		                 var a = block[2];
		                 function b(res){
		                  var a = block[1], b = include$48[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$155,
		                           function(c){
		                            return caml_trampoline_cps_call3
		                                    (c,
		                                     b,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$230, res, a, cont);
		                                     });
		                           });
		                 }
		                 if(typeof a !== "number")
		                  switch(a[0]){
		                    case 10:
		                     var rec_block = a[1], a = rec_block[1];
		                     if(a){
		                      var
		                       id$0 = a[1],
		                       c =
		                         function(param, cont){
		                          if(! param) return cont(0);
		                          var
		                           rec_task = param[1],
		                           content = rec_task[5][3][2],
		                           recurrence = rec_task[5][2],
		                           y = rec_block[2];
		                          function a(){
		                           return cont
		                                   ([0,
		                                     [0, block[1], [10, [0, rec_block[1], content, recurrence]]]]);
		                          }
		                          return content === y
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (equal$32,
		                                     recurrence,
		                                     rec_block[3],
		                                     function(b){return b ? cont([0, block]) : a();})
		                                  : a();
		                         };
		                      return caml_exact_trampoline_cps_call$1
		                              (find$6,
		                               tasks_recurrent_lookup,
		                               id$0,
		                               function(a){
		                                return caml_trampoline_cps_call3(symbol_map, a, c, b);
		                               });
		                     }
		                     break;
		                    case 11:
		                     var todo = a[1], a = todo[3];
		                     if(a){
		                      var
		                       id$1 = a[1],
		                       d =
		                         function(param, cont){
		                          if(! param) return cont([0, block]);
		                          var
		                           task = param[1],
		                           checked = is_some(task[7][2]),
		                           content = task[7][9][2],
		                           y = todo[1];
		                          if(checked === y){
		                           var y$0 = todo[2];
		                           if(content === y$0) return cont([0, block]);
		                          }
		                          return cont
		                                  ([0, [0, block[1], [11, [0, checked, content, todo[3]]]]]);
		                         };
		                      return caml_exact_trampoline_cps_call$1
		                              (find$6,
		                               tasks_lookup,
		                               id$1,
		                               function(a){
		                                return caml_trampoline_cps_call3(symbol_map, a, d, b);
		                               });
		                     }
		                     break;
		                  }
		                 return caml_trampoline_cps_call2
		                         (Incremental[76], [0, block], b);
		                }
		                function a(blocks, cont){return cont([0, blocks]);}
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         document[1],
		                         f,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (Incremental[80],
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     filter_opt,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function Make_object_augmented(O, Get, cont){
		                return caml_exact_trampoline_cps_call
		                        (capitalize_ascii,
		                         O[8],
		                         function(s2){
		                          var Logs = with_tag$0(component$0, "Controller." + s2);
		                          function get_incremental
		                          (ctrl, incremental, values, id$0, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (Logs[6][5],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call6
		     (m, 0, 0, a9o, O[2][4][1], id$0, cont);
		                                    },
		                                    function(match){
		                                     Get[1].call(null);
		                                     var
		                                      open =
		g
		 ([0,
		   incremental[72],
		   incremental[73],
		   ,
		   incremental[75],
		   incremental[76],
		   incremental[77],
		   ,
		   ,
		   ,
		   ,
		   incremental[82]]),
		                                      let$ = open[8],
		                                      let$0 = open[4];
		                                     function a(o, cont){
		                                      function a(o, cont){return cont([0, o]);}
		                                      function b(notes, cont){
		                                       return cont(O[5].call(null, notes, o));
		                                      }
		                                      var c = O[2][4][1];
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$156,
		       function(d){
		        return caml_trampoline_cps_call3
		                (d,
		                 c,
		                 id$0,
		                 function(c){
		                  return caml_exact_trampoline_cps_call$0
		                          (sync_notes,
		                           incremental,
		                           values,
		                           O[4].call(null, o),
		                           function(d){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$230,
		                                     d,
		                                     c,
		                                     function(c){
		                                      return caml_trampoline_cps_call3
		      (let$0,
		       c,
		       b,
		       function(b){
		        return caml_trampoline_cps_call3(let$0, b, a, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$2
		     (O[9],
		      dummy,
		      incremental,
		      values,
		      id$0,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (let$,
		                b,
		                a,
		                function(res){
		                 var a = O[2][4][1];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$157,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (b,
		                                    a,
		                                    id$0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$230,
		      res,
		      a,
		      function(o){
		       var a = O[2][4][1], b = O[8];
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$158,
		                function(c){
		                 return caml_trampoline_cps_call4
		                         (c,
		                          b,
		                          a,
		                          id$0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$230, o, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          function get(ctrl, id, cont){
		                           var
		                            param = ctrl[9],
		                            values = param[5],
		                            incremental = param[1],
		                            open =
		                              g
		                               ([0,
		                                 incremental[72],
		                                 incremental[73],
		                                 ,
		                                 incremental[75],
		                                 incremental[76],
		                                 incremental[77],
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 incremental[82]]),
		                            let$ = open[8],
		                            let$0 = open[4];
		                           function a(obj, cont){
		                            function a(obj, cont){return cont([0, obj]);}
		                            return caml_exact_trampoline_cps_call$2
		                                    (Get[2],
		                                     ctrl,
		                                     incremental,
		                                     values,
		                                     obj,
		                                     function(b){
		                                      return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$2
		                                   (get_incremental,
		                                    ctrl,
		                                    incremental,
		                                    values,
		                                    id,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (let$,
		      b,
		      a,
		      function(obj){
		       return caml_exact_trampoline_cps_call$1
		               (of_incremental, 0, obj, cont);
		      });
		                                    });
		                          }
		                          return cont([0, Logs, , get]);
		                         });
		               }
		               function Make_object(O, Get, cont){
		                var get = Get[1];
		                function augment(a, Incr, param, o, cont){
		                 return caml_trampoline_cps_call2(Incr[76], o, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (Make_object_augmented, O, [0, get, augment], cont);
		               }
		               function get$19(param){}
		               var
		                include$322 =
		                  caml_callback
		                   (Make_object,
		                    [[0,
		                      ,
		                      bQK,
		                      ,
		                      notes$11,
		                      with_notes$4,
		                      ,
		                      ,
		                      "recurrent task",
		                      lookup$5],
		                     [0, get$19]]),
		                Logs$12 = include$322[1],
		                get$20 = include$322[3];
		               function mutate$0(ctrl){
		                var a = ctrl[16], b = ctrl[9], c = ctrl[1], d = ctrl[14];
		                return function(e, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (mutate, d, c, b, a, e, cont);};
		               }
		               function foreground(ctrl, foreground, cont){
		                return foreground
		                        ? caml_exact_trampoline_cps_call
		                          (Sync[5],
		                           function(m, cont){
		                            return caml_trampoline_cps_call4(m, 0, 0, a9p, cont);
		                           },
		                           function(match){
		                            var ticker = ctrl[12];
		                            return caml_exact_trampoline_cps_call
		                                    (async,
		                                     function(param, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (put, ticker[1], qB, cont);
		                                     },
		                                     cont);
		                           })
		                        : caml_exact_trampoline_cps_call
		                          (Sync[5],
		                           function(m, cont){
		                            return caml_trampoline_cps_call4(m, 0, 0, a9q, cont);
		                           },
		                           function(match){
		                            var ticker = ctrl[12];
		                            return caml_exact_trampoline_cps_call
		                                    (async,
		                                     function(param, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (put, ticker[1], 0, cont);
		                                     },
		                                     cont);
		                           });
		               }
		               function now$0(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var now = param[2][18];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, now, cont);
		                         },
		                         cont);
		               }
		               function online(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var online = param[2][19];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, online, cont);
		                         },
		                         cont);
		               }
		               function pending_operations(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var operations = param[2][20];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, operations, cont);
		                         },
		                         cont);
		               }
		               function client_data(ctrl, workspace, key, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var client_data = param[2][2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   client_data[2],
		                                   [0, workspace, key],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function client_data_all(ctrl, workspace, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var client_data_by_workspace = param[2][3], Inc = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   client_data_by_workspace[2],
		                                   workspace,
		                                   function(b){
		                                    var a = Dictionary[111];
		                                    return caml_trampoline_cps_call3
		    (Inc[77],
		     b,
		     function(b, cont){return cont(value$4(b, a));},
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (of_incremental, 0, a, cont);
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function task_bindings$1(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var task_bindings = param[2][33];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, task_bindings, cont);
		                         },
		                         cont);
		               }
		               function task_bindings_by_workspace(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var task_bindings_by_workspace = param[2][34];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, task_bindings_by_workspace, cont);
		                         },
		                         cont);
		               }
		               function task_binding_settings(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var task_binding_settings = param[2][36];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, task_binding_settings, cont);
		                         },
		                         cont);
		               }
		               function premium(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var premium = param[2][23];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, premium, cont);
		                         },
		                         cont);
		               }
		               function state_stuck(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           match = param[2],
		                           operations = match[20],
		                           now = match[18],
		                           Inc = param[1],
		                           open =
		                             g
		                              ([0,
		                                Inc[72],
		                                Inc[73],
		                                ,
		                                Inc[75],
		                                Inc[76],
		                                Inc[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Inc[82]]),
		                           and = open[6],
		                           let$ = open[4];
		                          function a(a, cont){
		                           var now = a[2], last_push = a[1];
		                           if(! last_push) return cont(0);
		                           var
		                            time = last_push[1],
		                            a = minutes(1),
		                            s = symbol$58(now, time);
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$71, s, a, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (map_old,
		                                   operations,
		                                   function(old, ops, cont){
		                                    return caml_exact_trampoline_cps_call
		    (length$1,
		     ops,
		     function(len){
		      if(0 === len) return cont(0);
		      if(old){
		       var a = old[1], old$0 = a[1];
		       if(a[2]){
		        var old_time = a[2];
		        return caml_exact_trampoline_cps_call
		                (length$1,
		                 old$0,
		                 function(a){
		                  if(len >= a) return cont(old_time);
		                  var t = ocaml_ptime_clock_now_d_ps();
		                  return cont([0, t]);
		                 });
		       }
		      }
		      var t = ocaml_ptime_clock_now_d_ps();
		      return cont([0, t]);
		     });
		                                   },
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     b,
		     now,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(stuck){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, stuck, cont);
		               });
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function today$0(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var today = param[2][43];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, today, cont);
		                         },
		                         cont);
		               }
		               function main(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var profile = param[2][24];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, profile, cont);
		                         },
		                         cont);
		               }
		               function all$28(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var profiles = param[2][26];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, profiles[1], cont);
		                         },
		                         cont);
		               }
		               function feature_has(feature, a){
		                a = a[3];
		                if(! a) return 0;
		                a = a[1];
		                var contacts_state = a[2], calendars_state = a[1];
		                return feature
		                        ? is_some(contacts_state)
		                        : is_some(calendars_state);
		               }
		               function feature_has$0(ctrl, profile, feature, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           profiles = param[2][26],
		                           Incr = param[1],
		                           open =
		                             g
		                              ([0,
		                                Incr[72],
		                                Incr[73],
		                                ,
		                                Incr[75],
		                                Incr[76],
		                                Incr[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Incr[82]]),
		                           symbol_map = open[2];
		                          function a(param, cont){
		                           if(! param) return cont(0);
		                           var profile = param[1];
		                           return cont(feature_has(feature, profile));
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   profiles[2],
		                                   profile,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (of_incremental, 0, a, cont);
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function feature_has$1(ctrl, feature, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var profiles = param[2][26], Incr = param[1];
		                          g
		                           ([0,
		                             Incr[72],
		                             Incr[73],
		                             ,
		                             Incr[75],
		                             Incr[76],
		                             Incr[77],
		                             ,
		                             ,
		                             ,
		                             ,
		                             Incr[82]]);
		                          return caml_exact_trampoline_cps_call$2
		                                  (exists$1,
		                                   0,
		                                   [0, equal_profile],
		                                   profiles[1],
		                                   function(a){return feature_has(feature, a);},
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function agenda_tasks(ctrl, date, cont){
		                var
		                 match = ctrl[23][1],
		                 incremental = match[1],
		                 week_start = match[6],
		                 tasks_by_scheduling = match[3],
		                 tasks = match[2],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 and = open[6],
		                 let$ = open[4],
		                 symbol_map = open[2];
		                function is_today(param, cont){
		                 if(! param) return cont(0);
		                 var t = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (of_time$0,
		                          timezone_local,
		                          t,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (equal$21, date, a, cont);
		                          });
		                }
		                function b(task, cont){return cont([1, task[6]]);}
		                function a(a, cont){
		                 var
		                  b = a[2],
		                  archived = b[2],
		                  completed = b[1],
		                  a = a[1],
		                  overdue = a[2],
		                  a = a[1],
		                  upcoming = a[2],
		                  a = a[1],
		                  allocated = a[2],
		                  a = a[1],
		                  current = a[2],
		                  unplanned = a[1];
		                 return cont
		                         ([0,
		                           archived,
		                           completed,
		                           current,
		                           allocated,
		                           overdue,
		                           unplanned,
		                           upcoming]);
		                }
		                function c(a, cont){
		                 return caml_trampoline_cps_call3(map$18, a, b, cont);
		                }
		                function d(a, cont){return cont(value$4(a, 0));}
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         tasks,
		                         1,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   b,
		                                   d,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     c,
		     function(left){
		      function c(a, cont){return cont(a);}
		      function e(t, cont){
		       var a = t[7][1], match = t[7][8];
		       if(! t[7][2] && ! a)
		        return match ? cont([0, [0, t]]) : cont([0, [1, t]]);
		       return cont(0);
		      }
		      function b(param, cont){
		       var unstarred = param[2], starred = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (append$0,
		                starred,
		                unstarred,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (parents_only,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    a,
		                                    function(t, cont){var id = t[6]; return cont([1, id]);},
		                                    cont);
		                          });
		                });
		      }
		      function d(a, cont){
		       return caml_exact_trampoline_cps_call$1
		               (partition_map, a, c, cont);
		      }
		      function f(a, cont){
		       return caml_exact_trampoline_cps_call$1
		               (filter_map$0, a, e, cont);
		      }
		      function h(a, cont){return cont(value$4(a, 0));}
		      return caml_exact_trampoline_cps_call$1
		              (find$6,
		               tasks,
		               [1, [1, date]],
		               function(c){
		                return caml_trampoline_cps_call3
		                        (symbol_map,
		                         c,
		                         h,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   c,
		                                   f,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     c,
		     d,
		     function(c){
		      return caml_trampoline_cps_call3
		              (let$,
		               c,
		               b,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (and,
		                         left,
		                         b,
		                         function(left){
		                          function c(a, cont){return cont(a);}
		                          function e(t, cont){
		                           var a = t[7][1], match = t[7][8];
		                           if(! t[7][2] && ! a)
		                            return match ? cont([0, [0, t]]) : cont([0, [1, t]]);
		                           return cont(0);
		                          }
		                          function b(param, cont){
		                           var unstarred = param[2], starred = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0,
		                                    starred,
		                                    unstarred,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (parents_only,
		      a,
		      function(a){
		       return caml_trampoline_cps_call3
		               (map$18,
		                a,
		                function(t, cont){var id = t[6]; return cont([1, id]);},
		                cont);
		      });
		                                    });
		                          }
		                          function d(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (partition_map, a, c, cont);
		                          }
		                          function f(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter_map$0, a, e, cont);
		                          }
		                          function h(a, cont){return cont(value$4(a, 0));}
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   tasks,
		                                   [0, [1, date]],
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     c,
		     h,
		     function(c){
		      return caml_trampoline_cps_call3
		              (symbol_map,
		               c,
		               f,
		               function(c){
		                return caml_trampoline_cps_call3
		                        (symbol_map,
		                         c,
		                         d,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   c,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     left,
		     b,
		     function(left){
		      var
		       open =
		         g
		          ([0,
		            incremental[72],
		            incremental[73],
		            ,
		            incremental[75],
		            incremental[76],
		            incremental[77],
		            ,
		            ,
		            ,
		            ,
		            incremental[82]]),
		       and$0 = open[6],
		       let$0 = open[4],
		       let$1 = open[3],
		       symbol_map$0 = open[2];
		      function ids(param, cont){
		       if(! param) return cont(0);
		       var tasks = param[1];
		       return caml_trampoline_cps_call3
		               (map$18,
		                tasks,
		                function(t, cont){return cont([1, t[6]]);},
		                cont);
		      }
		      return caml_trampoline_cps_call3
		              (let$1,
		               week_start,
		               function(week_start, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (week_of_date,
		                         week_start,
		                         date,
		                         function(this_week){
		                          function a(param, cont){
		                           var batch = param[2], until_next_week = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0, until_next_week, batch, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (init$7,
		                                   13,
		                                   function(i, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (add_days,
		     date,
		     i + 1 | 0,
		     function(day){
		      function a(param, cont){
		       var todo = param[1];
		       return cont(todo);
		      }
		      function b(a, cont){return cont(value$4(a, 0));}
		      return caml_exact_trampoline_cps_call$1
		              (find$6,
		               tasks,
		               [1, [1, day]],
		               function(c){
		                return caml_trampoline_cps_call3
		                        (symbol_map$0,
		                         c,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map$0,
		                                   b,
		                                   day_of_tasks,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(symbol_map$0, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   },
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (incremental[80],
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (symbol_map$0,
		               b,
		               of_list,
		               function(left){
		                function b(param, cont){
		                 var next_week_batch = param[2], this_week_batch = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (append$0, this_week_batch, next_week_batch, cont);
		                }
		                function c(a, cont){
		                 return caml_trampoline_cps_call3
		                         (map$17, a, parents_only, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         tasks,
		                         [1, [0, this_week]],
		                         function(d){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map$0,
		                                   d,
		                                   c,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (symbol_map$0,
		     c,
		     ids,
		     function(left$0){
		      function c(a, cont){
		       return caml_trampoline_cps_call3
		               (map$17, a, parents_only, cont);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (symbol$88,
		               this_week,
		               1,
		               function(d){
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         tasks,
		                         [1, [0, d]],
		                         function(d){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map$0,
		                                   d,
		                                   c,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (symbol_map$0,
		     c,
		     ids,
		     function(c){
		      return caml_trampoline_cps_call3
		              (and$0,
		               left$0,
		               c,
		               function(c){
		                return caml_trampoline_cps_call3
		                        (let$0,
		                         c,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (and$0,
		                                   left,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               },
		               function(batch){
		                return caml_trampoline_cps_call3
		                        (and,
		                         left,
		                         batch,
		                         function(left){
		                          function b(id, cont){return cont([1, id]);}
		                          function c(a, cont){
		                           return caml_trampoline_cps_call3(map$18, a, b, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$2
		                                  (overdue,
		                                   incremental,
		                                   tasks_by_scheduling,
		                                   week_start,
		                                   date,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     c,
		     function(b){
		      return caml_trampoline_cps_call3
		              (and,
		               left,
		               b,
		               function(left){
		                function c(t, cont){
		                 return caml_exact_trampoline_cps_call
		                         (is_today,
		                          t[7][2],
		                          function(a){
		                           return a
		                                   ? cont([0, [0, -250904213, t[6]]])
		                                   : caml_exact_trampoline_cps_call
		                                     (is_today,
		                                      t[7][1],
		                                      function(a){
		                                       return a ? cont([0, [0, -954191230, t[6]]]) : cont(0);
		                                      });
		                          });
		                }
		                function b(filtered_tasks, cont){
		                 return caml_exact_trampoline_cps_call
		                         (encode,
		                          filtered_tasks,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (of_list,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (partition_map,
		      a,
		      function(param, cont){
		       var variant = param[1];
		       if(-250904213 <= variant){
		        var id = param[2];
		        return cont([0, [1, id]]);
		       }
		       var id$0 = param[2];
		       return cont([1, [1, id$0]]);
		      },
		      cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (map$42,
		                         0,
		                         0,
		                         tasks_by_scheduling,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$0, a, c, cont);
		                         },
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   c,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     left,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, a, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function calendar_tasks(ctrl, week, cont){
		                var
		                 match = ctrl[23][1],
		                 incremental = match[1],
		                 week_start = match[6],
		                 tasks_by_scheduling = match[3],
		                 tasks = match[2],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 and = open[6],
		                 let$ = open[4],
		                 let$0 = open[3],
		                 symbol_map = open[2];
		                return caml_trampoline_cps_call3
		                        (let$0,
		                         week_start,
		                         function(week_start, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (week_of_date,
		                                   week_start,
		                                   week,
		                                   function(week$0){
		                                    function a(a, cont){
		                                     var
		                                      overdue = a[2],
		                                      a = a[1],
		                                      upcoming = a[2],
		                                      a = a[1],
		                                      unplanned = a[2],
		                                      a = a[1],
		                                      postponed = a[2],
		                                      scheduled = a[1];
		                                     return cont
		     ([0, scheduled, postponed, overdue, upcoming, unplanned]);
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (date_of_week,
		     week_start,
		     week$0,
		     function(first_day_of_week){
		      return caml_exact_trampoline_cps_call$1
		              (init$7,
		               7,
		               function(i, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (add_days,
		                         first_day_of_week,
		                         i,
		                         function(day){
		                          function a(a, cont){return cont(value$4(a, 0));}
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   tasks,
		                                   [1, [1, day]],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     a,
		     function(a){
		      return caml_trampoline_cps_call3
		              (symbol_map, a, day_of_tasks, cont);
		     });
		                                   });
		                         });
		               },
		               function(b){
		                return caml_trampoline_cps_call2
		                        (incremental[80],
		                         b,
		                         function(left){
		                          function b(t, cont){return cont([1, t[6]]);}
		                          function c(a, cont){
		                           return caml_trampoline_cps_call3(map$18, a, b, cont);
		                          }
		                          function d(a, cont){return cont(value$4(a, 0));}
		                          function e(a, cont){
		                           return caml_trampoline_cps_call3
		                                   (map$17, a, parents_only, cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   tasks,
		                                   [1, [0, week$0]],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     e,
		     function(b){
		      return caml_trampoline_cps_call3
		              (symbol_map,
		               b,
		               d,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (symbol_map,
		                         b,
		                         c,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   left,
		                                   b,
		                                   function(left){
		                                    function b(task, cont){return cont([1, task[6]]);}
		                                    function c(a, cont){
		                                     return caml_trampoline_cps_call3(map$18, a, b, cont);
		                                    }
		                                    function d(a, cont){return cont(value$4(a, 0));}
		                                    return caml_exact_trampoline_cps_call$1
		    (find$6,
		     tasks,
		     1,
		     function(b){
		      return caml_trampoline_cps_call3
		              (symbol_map,
		               b,
		               d,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (symbol_map,
		                         b,
		                         c,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   left,
		                                   b,
		                                   function(left){
		                                    return caml_exact_trampoline_cps_call$1
		    (init$7,
		     8,
		     function(i, cont){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$88, week$0, i + 1 | 0, cont);
		     },
		     function(weeks_ahead){
		      function b(param, cont){
		       var date_upcoming = param[2], batch_upcoming = param[1];
		       return caml_exact_trampoline_cps_call$1
		               (append$0, batch_upcoming, date_upcoming, cont);
		      }
		      return caml_trampoline_cps_call3
		              (map$18,
		               weeks_ahead,
		               function(future_week, cont){
		                function a(t, cont){return cont([1, t[6]]);}
		                function b(b, cont){
		                 return caml_trampoline_cps_call3(map$18, b, a, cont);
		                }
		                function c(a, cont){return cont(value$4(a, 0));}
		                function d(a, cont){
		                 return caml_trampoline_cps_call3
		                         (map$17, a, parents_only, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         tasks,
		                         [1, [0, future_week]],
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   a,
		                                   d,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     a,
		     c,
		     function(a){
		      return caml_trampoline_cps_call3(symbol_map, a, b, cont);
		     });
		                                   });
		                         });
		               },
		               function(c){
		                return caml_trampoline_cps_call2
		                        (incremental[80],
		                         c,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   c,
		                                   of_list,
		                                   function(left$0){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$88,
		     week$0,
		     1,
		     function(next_week){
		      return caml_exact_trampoline_cps_call$1
		              (date_of_week,
		               week_start,
		               next_week,
		               function(start_date){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$88,
		                         week$0,
		                         8,
		                         function(last_week){
		                          return caml_exact_trampoline_cps_call$1
		                                  (date_of_week,
		                                   week_start,
		                                   last_week,
		                                   function(last_week_start){
		                                    return caml_exact_trampoline_cps_call$1
		    (add_days,
		     last_week_start,
		     6,
		     function(end_date){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$85,
		               end_date,
		               start_date,
		               function(s){
		                var days_count = s[1];
		                return caml_exact_trampoline_cps_call$1
		                        (init$7,
		                         days_count,
		                         function(i, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (add_days,
		                                   start_date,
		                                   i,
		                                   function(future_date){
		                                    function a(param, cont){
		                                     var todo = param[1];
		                                     return cont(todo);
		                                    }
		                                    function b(a, cont){return cont(value$4(a, 0));}
		                                    return caml_exact_trampoline_cps_call$1
		    (find$6,
		     tasks,
		     [1, [1, future_date]],
		     function(c){
		      return caml_trampoline_cps_call3
		              (symbol_map,
		               c,
		               b,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (symbol_map,
		                         b,
		                         day_of_tasks,
		                         function(b){
		                          return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         },
		                         function(c){
		                          return caml_trampoline_cps_call2
		                                  (incremental[80],
		                                   c,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     c,
		     of_list,
		     function(c){
		      return caml_trampoline_cps_call3
		              (and,
		               left$0,
		               c,
		               function(c){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         c,
		                         b,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   left,
		                                   b,
		                                   function(left){
		                                    function b(id, cont){return cont([1, id]);}
		                                    function c(a, cont){
		                                     return caml_trampoline_cps_call3(map$18, a, b, cont);
		                                    }
		                                    return caml_trampoline_cps_call2
		    (incremental[76],
		     week_start,
		     function(b){
		      return caml_exact_trampoline_cps_call$2
		              (overdue,
		               incremental,
		               tasks_by_scheduling,
		               b,
		               week,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (symbol_map,
		                         b,
		                         c,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   left,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, a, cont);
		                         });
		               }
		               function inbox$0(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           a = param[2],
		                           today = a[43],
		                           pages = a[21],
		                           now = a[18],
		                           unplanned = a[8],
		                           events_recurrent = a[7],
		                           events = a[6],
		                           calendars_lookup = a[1][2],
		                           Inc = param[1];
		                          return caml_exact_trampoline_cps_call
		                                  (Sync[5],
		                                   function(m, cont){
		                                    return caml_trampoline_cps_call4(m, 0, 0, a9u, cont);
		                                   },
		                                   function(match){
		                                    function compare(a, param, cont){
		                                     var r = param[1], l = a[1];
		                                     return caml_trampoline_cps_call3(compare$37, r, l, cont);
		                                    }
		                                    var
		                                     open =
		                                       g
		([0,
		  Inc[72],
		  Inc[73],
		  ,
		  Inc[75],
		  Inc[76],
		  Inc[77],
		  ,
		  ,
		  ,
		  ,
		  Inc[82]]),
		                                     let$ = open[8],
		                                     and = open[6],
		                                     let$0 = open[4],
		                                     let$1 = open[3],
		                                     symbol_map = open[2];
		                                    function a(pages, cont){
		                                     return caml_exact_trampoline_cps_call
		     (encode,
		      pages,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (stable_sort, a, compare, cont);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (filter_mapi$2,
		     0,
		     0,
		     pages[1],
		     function(param, page, cont){
		      return caml_trampoline_cps_call3
		              (map$17,
		               page[1][3][5],
		               function(id, cont){return cont([2, id]);},
		               function(b){
		                var
		                 x = page[1][3][4],
		                 a = x === cst$1 ? 1 : 0,
		                 b = [0, page[1][1], [0, [2, page[1][2]], b]],
		                 a = a ? is_none$0(page[1][3][1]) : a;
		                return cont(some_if(a, b));
		               });
		     },
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$0,
		               b,
		               a,
		               function(without_title){
		                function id_if_match(event, cont){
		                 function a(calendar, cont){
		                  var writable = event[9], t = writable[3];
		                  function a(){
		                   return caml_trampoline_cps_call2(Inc[76], 0, cont);
		                  }
		                  return 2 <= t[3]
		                          ? caml_exact_trampoline_cps_call
		                            (archived,
		                             event,
		                             function(b){
		                              return b
		                                      ? a()
		                                      : caml_exact_trampoline_cps_call$1
		(will_attend,
		 calendar,
		 event,
		 function(b){
		  return is_none$0(b)
		          ? caml_exact_trampoline_cps_call$1
		            (augment$2,
		             calendar,
		             event,
		             function(augment){
		              if(augment[1] && augment[2])
		               return caml_trampoline_cps_call3
		                       (let$0,
		                        now,
		                        function(now, cont){
		                         var time = event[9][10];
		                         return caml_exact_trampoline_cps_call$1
		                                 (start$2,
		                                  timezone_local,
		                                  time,
		                                  function(start){
		                                   return caml_exact_trampoline_cps_call$1
		   (start$2,
		    timezone_local,
		    time,
		    function(end){
		     var a = [0, start, event[6]];
		     return caml_exact_trampoline_cps_call$1
		             (symbol$74,
		              now,
		              end,
		              function(b){return cont(some_if(b, a));});
		    });
		                                  });
		                        },
		                        cont);
		              return caml_trampoline_cps_call2(Inc[76], 0, cont);
		             })
		          : a();
		 });
		                             })
		                          : a();
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (find$6,
		                          calendars_lookup,
		                          event[1],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                function a(param, cont){
		                 var
		                  from_events_recurrent = param[2],
		                  from_events = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (encode,
		                          from_events_recurrent,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (encode,
		                                    from_events,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (append$0,
		      b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (stable_sort,
		                a,
		                function(a, param, cont){
		                 var time_r = param[1], time_l = a[1];
		                 return caml_trampoline_cps_call3
		                         (compare$37, time_l, time_r, cont);
		                },
		                function(a){
		                 return caml_trampoline_cps_call3(map$18, a, get_data, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$7
		                        (filter_map$6,
		                         0,
		                         0,
		                         0,
		                         0,
		                         events[1],
		                         function(event, cont){
		                          return caml_trampoline_cps_call3
		                                  (let$1,
		                                   event,
		                                   function(event, cont){
		                                    var t = event[6], a = 0 === t[0] ? 0 : 1;
		                                    return a
		    ? caml_trampoline_cps_call2(Inc[76], 0, cont)
		    : caml_exact_trampoline_cps_call(id_if_match, event, cont);
		                                   },
		                                   cont);
		                         },
		                         function(left){
		                          return caml_trampoline_cps_call3
		                                  (let$1,
		                                   today,
		                                   function(today, cont){
		                                    return caml_exact_trampoline_cps_call$7
		    (filter_map$6,
		     0,
		     0,
		     0,
		     0,
		     events_recurrent[1],
		     function(event_recurrent, cont){
		      return caml_trampoline_cps_call3
		              (let$1,
		               event_recurrent,
		               function(event_recurrent, cont){
		                function a(event, cont){
		                 function a(event, cont){
		                  return caml_exact_trampoline_cps_call
		                          (id_if_match, event, cont);
		                 }
		                 function b(a, cont){return cont(value$4(a, event));}
		                 return caml_exact_trampoline_cps_call$1
		                         (find$6,
		                          events[2],
		                          event[6],
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$1, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (snap$1,
		                         event_recurrent,
		                         today,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (Inc[76],
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                   });
		                         });
		               },
		               cont);
		     },
		     cont);
		                                   },
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (and,
		     left,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$0,
		               b,
		               a,
		               function(unanswered_meetings){
		                function a(param, cont){
		                 var without_title = param[2], unplanned = param[1];
		                 return caml_trampoline_cps_call3
		                         (map$18,
		                          unplanned,
		                          function(t, cont){
		                           var a = t[7][6], a = [0, task$0(t[6]), a];
		                           return cont([0, t[3], a]);
		                          },
		                          function(l2){
		                           function a(a){
		                            return caml_trampoline_cps_call3(map$18, a, get_data, cont);
		                           }
		                           if(! without_title) return a(l2);
		                           if(! l2) return a(without_title);
		                           var
		                            t2 = l2[2],
		                            h2 = l2[1],
		                            t1 = without_title[2],
		                            h1 = without_title[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (compare,
		                                    h1,
		                                    h2,
		                                    function(b){
		                                     if(0 < b){
		                                      var block = [0, h2, 24029];
		                                      return caml_exact_trampoline_cps_call$3
		      (merge_dps,
		       block,
		       1,
		       without_title,
		       t2,
		       compare,
		       function(b){return a(block);});
		                                     }
		                                     var block$0 = [0, h1, 24029];
		                                     return caml_exact_trampoline_cps_call$3
		     (merge_dps,
		      block$0,
		      1,
		      t1,
		      l2,
		      compare,
		      function(b){return a(block$0);});
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call3
		                        (and,
		                         unplanned,
		                         without_title,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$0,
		                                   b,
		                                   a,
		                                   function(past){
		                                    function a(param, cont){
		                                     var past = param[2], future = param[1];
		                                     return cont([0, future, past]);
		                                    }
		                                    return caml_trampoline_cps_call3
		    (and,
		     unanswered_meetings,
		     past,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$0,
		               b,
		               a,
		               function(result){
		                return caml_exact_trampoline_cps_call$1
		                        (symbol$230,
		                         result,
		                         "object inbox",
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, symbol$229(a, equal$254), cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function issues(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var issues = param[2][11];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, issues, cont);
		                         },
		                         cont);
		               }
		               function object$2(ctrl){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                return function(a, cont){
		                 switch(a[0]){
		                   case 0:
		                    var id = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (get_event$1,
		                             ctrl[2],
		                             id,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call(text$3, a9v, cont);
		                              var event = match[1];
		                              return cont([0, event]);
		                             });
		                   case 1:
		                    var id$0 = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (get_event_recurrent$1,
		                             ctrl[2],
		                             id$0,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call(text$3, a9w, cont);
		                              var event = match[1];
		                              return cont([1, event]);
		                             });
		                   case 2:
		                    var id$1 = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (get_page$0,
		                             ctrl[2],
		                             id$1,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call(text$3, a9x, cont);
		                              var p = match[1];
		                              return cont(page(p));
		                             });
		                   case 3:
		                    var
		                     id$2 = a[1],
		                     b =
		                       function(people, cont){
		                        return caml_exact_trampoline_cps_call
		                                (people$0, people, cont);
		                       };
		                    return caml_exact_trampoline_cps_call$1
		                            (get_person$0,
		                             ctrl[2],
		                             id$2,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (let$,
		                                       a,
		                                       b,
		                                       function(param){
		if(! param)
		 return caml_exact_trampoline_cps_call(text$3, msg, cont);
		var notif = param[1];
		return cont(notif);
		                                       });
		                             });
		                   case 4:
		                    a = a[1];
		                    if(0 === a[0])
		                     return caml_exact_trampoline_cps_call(text$3, a9y, cont);
		                    var id$3 = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (get_task$0,
		                             ctrl[2],
		                             id$3,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call(text$3, a9z, cont);
		                              var task = match[1];
		                              return cont([6, task]);
		                             });
		                   case 5:
		                    var id$4 = a[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (get_task_recurrent$0,
		                             ctrl[2],
		                             id$4,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call(text$3, a9A, cont);
		                              var task = match[1];
		                              return cont([7, task]);
		                             });
		                   case 6:
		                    return caml_exact_trampoline_cps_call(text$3, a9B, cont);
		                   case 7:
		                    return caml_exact_trampoline_cps_call(text$3, a9C, cont);
		                   case 8:
		                    return caml_exact_trampoline_cps_call(text$3, a9D, cont);
		                   case 9:
		                    return caml_exact_trampoline_cps_call(text$3, a9E, cont);
		                   case 10:
		                    return caml_exact_trampoline_cps_call(text$3, a9F, cont);
		                   case 11:
		                    return caml_exact_trampoline_cps_call(text$3, a9G, cont);
		                   case 12:
		                    return caml_exact_trampoline_cps_call(text$3, a9H, cont);
		                   default:
		                    return caml_exact_trampoline_cps_call(text$3, a9I, cont);
		                 }};
		               }
		               function push$1(ctrl, id, source, action, cont){
		                var
		                 workspace_id = personal_workspace_id(ctrl[2]),
		                 a = object$0(id, workspace_id, source, action);
		                return caml_exact_trampoline_cps_call$0
		                        (push_dont_wait$0, ctrl[11], 0, a, cont);
		               }
		               function push_nonrec(ctrl, id, action){
		                var a = task$0(id);
		                return function(b, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (push$1, ctrl, a, b, action, cont);};
		               }
		               function allocate(ctrl, task, event, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (locale,
		                         ctrl[9],
		                         function(locale){
		                          return caml_exact_trampoline_cps_call
		                                  (push_nonrec(ctrl, task[6], a9T),
		                                   source,
		                                   function(match){
		                                    var a = event[9][10];
		                                    function b(a, b, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (pp_start, 0, locale, a, b, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (highlight,
		     a9U,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(b){
		                var a = [0, b, 0];
		                return caml_exact_trampoline_cps_call
		                        (text$3,
		                         a9V,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (notify$0(ctrl), 0, 0, [0, [6, task], [0, b, a]], cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function move$0(ctrl, task, destination, source, cont){
		                var a = task[7][6];
		                function b(ppf, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_none, ppf, dummy, cont);
		                 var v = param[1];
		                 return caml_exact_trampoline_cps_call$2
		                         (using, to_string$50, pp_print_string, ppf, v, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$159,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$160,
		     function(b){
		      return caml_trampoline_cps_call3
		              (b,
		               pp_v$0,
		               destination,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (push_nonrec(ctrl, task[6], [1, [0, b, a]]),
		                         source,
		                         function(a){
		                          a = to_reference_id(destination);
		                          return caml_exact_trampoline_cps_call
		                                  (object$2(ctrl),
		                                   a,
		                                   function(b){
		                                    var a = [0, b, 0];
		                                    return caml_exact_trampoline_cps_call
		    (text$3,
		     a9W,
		     function(b){
		      return caml_exact_trampoline_cps_call$0
		              (notify$0(ctrl), 0, 0, [0, [6, task], [0, b, a]], cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var cst_rescheduled = "rescheduled";
		               function patch$4
		               (ctrl, original_task, patched_task, patch, source, cont){
		                if(is_empty$9(patch)) return cont(0);
		                function push_metric(property_name, cont){
		                 var
		                  workspace_id = personal_workspace_id(ctrl[2]),
		                  a =
		                    object$0
		                     (task$0(original_task[6]),
		                      workspace_id,
		                      source,
		                      [0, property_name]);
		                 return caml_exact_trampoline_cps_call$0
		                         (push_dont_wait$0, ctrl[11], 0, a, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (locale,
		                         ctrl[9],
		                         function(locale){
		                          var
		                           c = patch[2],
		                           d = patch[1],
		                           e = patch[7],
		                           b = patch[8],
		                           a = patch[9][2];
		                          if(c)
		                           return c[1]
		                                   ? caml_exact_trampoline_cps_call
		                                     (push_metric,
		                                      cst_completed,
		                                      function(match){
		                                       return caml_exact_trampoline_cps_call
		       (text$3,
		        a9X,
		        function(a){
		         return caml_exact_trampoline_cps_call$0
		                 (notify$0(ctrl),
		                  0,
		                  0,
		                  [0, [6, patched_task], [0, a, 0]],
		                  cont);
		        });
		                                      })
		                                   : caml_exact_trampoline_cps_call
		                                     (push_metric,
		                                      cst_completed,
		                                      function(match){
		                                       return caml_exact_trampoline_cps_call
		       (text$3,
		        a9Y,
		        function(a){
		         return caml_exact_trampoline_cps_call$0
		                 (notify$0(ctrl),
		                  0,
		                  0,
		                  [0, [6, patched_task], [0, a, 0]],
		                  cont);
		        });
		                                      });
		                          if(d)
		                           return d[1]
		                                   ? caml_exact_trampoline_cps_call
		                                     (push_metric,
		                                      cst_ignored,
		                                      function(match){
		                                       return caml_exact_trampoline_cps_call
		       (text$3,
		        a9Z,
		        function(a){
		         return caml_exact_trampoline_cps_call$0
		                 (notify$0(ctrl),
		                  0,
		                  0,
		                  [0, [6, patched_task], [0, a, 0]],
		                  cont);
		        });
		                                      })
		                                   : caml_exact_trampoline_cps_call
		                                     (push_metric,
		                                      cst_completed,
		                                      function(match){
		                                       return caml_exact_trampoline_cps_call
		       (text$3,
		        a90,
		        function(a){
		         return caml_exact_trampoline_cps_call$0
		                 (notify$0(ctrl),
		                  0,
		                  0,
		                  [0, [6, patched_task], [0, a, 0]],
		                  cont);
		        });
		                                      });
		                          if(e){
		                           a = e[1];
		                           b = "planning";
		                           if(! a)
		                            return caml_exact_trampoline_cps_call
		                                    (push_metric,
		                                     b,
		                                     function(a){
		                                      a = original_task[7][7];
		                                      if(! a) return cont(0);
		                                      if(0 === a[1][0])
		                                       return caml_exact_trampoline_cps_call
		       (text$3,
		        a96,
		        function(a){
		         return caml_exact_trampoline_cps_call$0
		                 (notify$0(ctrl),
		                  0,
		                  0,
		                  [0, [6, patched_task], [0, a, 0]],
		                  cont);
		        });
		                                      return caml_exact_trampoline_cps_call
		      (text$3,
		       a97,
		       function(a){
		        return caml_exact_trampoline_cps_call$0
		                (notify$0(ctrl),
		                 0,
		                 0,
		                 [0, [6, patched_task], [0, a, 0]],
		                 cont);
		       });
		                                     });
		                           a = a[1];
		                           if(0 === a[0]){
		                            var batch_week = a[1];
		                            return caml_exact_trampoline_cps_call
		                                    (push_nonrec(ctrl, original_task[6], a91),
		                                     source,
		                                     function(match){
		                                      var a = locale[8];
		                                      return caml_exact_trampoline_cps_call
		      (highlight,
		       a92,
		       function(b){
		        return caml_trampoline_cps_call3
		                (b,
		                 a,
		                 batch_week,
		                 function(b){
		                  var a = [0, [8, cst_batch], [0, b, 0]];
		                  return caml_exact_trampoline_cps_call
		                          (text$3,
		                           a93,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$0
		                                    (notify$0(ctrl),
		                                     0,
		                                     0,
		                                     [0, [6, patched_task], [0, b, a]],
		                                     cont);
		                           });
		                 });
		       });
		                                     });
		                           }
		                           var scheduled = a[1];
		                           return caml_exact_trampoline_cps_call
		                                   (push_metric,
		                                    b,
		                                    function(match){
		                                     var
		                                      verb = original_task[7][7] ? cst_rescheduled : cst_scheduled,
		                                      a = locale[3];
		                                     return caml_exact_trampoline_cps_call
		     (highlight,
		      a94,
		      function(b){
		       return caml_trampoline_cps_call3
		               (b,
		                a,
		                scheduled,
		                function(b){
		                 var a = [0, b, 0];
		                 return caml_exact_trampoline_cps_call
		                         (text$3,
		                          a95,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    verb,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$0
		     (notify$0(ctrl),
		      0,
		      0,
		      [0, [6, patched_task], [0, b, a]],
		      cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          if(b){
		                           var starred = b[1];
		                           return caml_exact_trampoline_cps_call
		                                   (push_metric,
		                                    cst_starred,
		                                    function(match){
		                                     var verb = starred ? cst_starred : "unstarred";
		                                     return caml_exact_trampoline_cps_call
		     (text$3,
		      a98,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                verb,
		                function(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (notify$0(ctrl),
		                          0,
		                          0,
		                          [0, [6, patched_task], [0, a, 0]],
		                          cont);
		                });
		      });
		                                    });
		                          }
		                          if(a)
		                           return caml_exact_trampoline_cps_call
		                                   (push_metric,
		                                    cst_name,
		                                    function(match){
		                                     var a = [0, [6, patched_task], 0];
		                                     return caml_exact_trampoline_cps_call
		     (text$3,
		      a99,
		      function(b){
		       return caml_exact_trampoline_cps_call$0
		               (notify$0(ctrl), 0, 0, [0, b, a], cont);
		      });
		                                    });
		                          return caml_exact_trampoline_cps_call
		                                  (text$3,
		                                   a9_,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (notify$0(ctrl),
		     0,
		     0,
		     [0, [6, patched_task], [0, a, 0]],
		     cont);
		                                   });
		                         });
		               }
		               function edited(ctrl, id, document, source, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(kind, previous){
		                 function is_empty(doc, cont){
		                  var a = doc[1];
		                  a:
		                  if(a){
		                   var b = a[1][2];
		                   if
		                    (typeof b !== "number"
		                     && 8 === b[0] && b[1][1] === cst$1 && ! a[2])
		                    break a;
		                   return cont(0);
		                  }
		                  return cont(1);
		                 }
		                 return caml_trampoline_cps_call3
		                         (map$17,
		                          previous,
		                          is_empty,
		                          function(a){
		                           var match = value$4(a, 1);
		                           return caml_exact_trampoline_cps_call
		                                   (is_empty,
		                                    document,
		                                    function(a){
		                                     if(a && match) return cont();
		                                     var
		                                      workspace_id = personal_workspace_id(ctrl[2]),
		                                      a = object$0(id, workspace_id, source, a_b);
		                                     return caml_exact_trampoline_cps_call$0
		     (push_dont_wait$0,
		      ctrl[11],
		      [0, [0, [0, cst_kind, kind], 0]],
		      a,
		      cont);
		                                    });
		                          });
		                }
		                switch(id[0]){
		                  case 0:
		                   var
		                    id$0 = id[1],
		                    b =
		                      function(param, cont){
		                       var notes = param[9][8];
		                       return cont(notes);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_event$1,
		                            ctrl[2],
		                            id$0,
		                            function(c){
		                             return caml_trampoline_cps_call3
		                                     (let$, c, b, function(b){return a(cst_event, b);});
		                            });
		                  case 1:
		                   var
		                    id$1 = id[1],
		                    c =
		                      function(param, cont){
		                       var notes = param[7][8];
		                       return cont(notes);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_event_recurrent$1,
		                            ctrl[2],
		                            id$1,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (let$, b, c, function(b){return a(cst_event, b);});
		                            });
		                  case 2:
		                   var
		                    id$2 = id[1],
		                    d =
		                      function(param, cont){
		                       var content = param[3][2];
		                       return cont(content);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_page$0,
		                            ctrl[2],
		                            id$2,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (let$, b, d, function(b){return a(cst_page, b);});
		                            });
		                  case 3:
		                   var
		                    id$3 = id[1],
		                    e =
		                      function(param, cont){
		                       var notes = param[11][1];
		                       return cont(notes);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_person$0,
		                            ctrl[2],
		                            id$3,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (let$, b, e, function(b){return a(cst_person, b);});
		                            });
		                  case 4:
		                   var match = id[1];
		                   if(0 === match[0]) return a(cst_task, 0);
		                   var
		                    id$4 = match[1],
		                    f =
		                      function(param, cont){
		                       var notes = param[7][9][1];
		                       return cont(notes);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task$0,
		                            ctrl[2],
		                            id$4,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (let$, b, f, function(b){return a(cst_task, b);});
		                            });
		                  case 5:
		                   var
		                    id$5 = id[1],
		                    h =
		                      function(param, cont){
		                       var notes = param[5][3][1];
		                       return cont(notes);
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task_recurrent$0,
		                            ctrl[2],
		                            id$5,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (let$, b, h, function(b){return a(cst_task, b);});
		                            });
		                  case 6:
		                   return a(cst_object, 0);
		                  case 7:
		                   return a(cst_organization, 0);
		                  case 8:
		                   return a(cst_table, 0);
		                  case 9:
		                   return a(cst_workspace, 0);
		                  case 10:
		                   return a(cst_agent, 0);
		                  case 11:
		                   return a(cst_automation, 0);
		                  case 12:
		                   return a(cst_conversation, 0);
		                  default: return a(cst_automation_run$0, 0);
		                }
		               }
		               function push$2(ctrl, source, extra_attrs, event, action, cont){
		                var
		                 workspace_id = personal_workspace_id(ctrl[2]),
		                 a = object$0([0, event[6]], workspace_id, source, action);
		                return caml_exact_trampoline_cps_call$0
		                        (push_dont_wait$0, ctrl[11], extra_attrs, a, cont);
		               }
		               function create$45(ctrl, event, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (locale,
		                         ctrl[9],
		                         function(locale){
		                          var t = event[9][3], n = t[3];
		                          return caml_exact_trampoline_cps_call$3
		                                  (push$2,
		                                   ctrl,
		                                   source,
		                                   [0, [0, [0, cst_participants, "" + n], 0]],
		                                   event,
		                                   0,
		                                   function(match){
		                                    var a = event[9][10];
		                                    function b(a, b, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (pp_start, 0, locale, a, b, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (highlight,
		     a_g,
		     function(c){
		      return caml_trampoline_cps_call3
		              (c,
		               b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$0
		                        (notify$0(ctrl),
		                         0,
		                         0,
		                         [0, [0, event], [0, a_h, [0, a, 0]]],
		                         cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function attend(ctrl, event, attendance, source, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (push$2,
		                         ctrl,
		                         source,
		                         0,
		                         event,
		                         a_l,
		                         function(match){
		                          var a = [0, a_m, [0, [0, event], 0]];
		                          function b(a, b, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (option, 0, pp_yes_no_maybe, a, b, cont);
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (highlight,
		                                   a_n,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (c,
		     b,
		     attendance,
		     function(b){
		      var msg = [0, a_o, [0, b, a]];
		      return caml_exact_trampoline_cps_call$0
		              (notify$0(ctrl), 0, 0, msg, cont);
		     });
		                                   });
		                         });
		               }
		               function update$12(ctrl, original_event, patch, source, cont){
		                return is_empty$10(patch)
		                        ? cont(0)
		                        : caml_exact_trampoline_cps_call
		                          (locale,
		                           ctrl[9],
		                           function(locale){
		                            var a = patch[1];
		                            function b(msg){
		                             return original_event[4]
		                                     ? cont(0)
		                                     : caml_exact_trampoline_cps_call$0
		                                       (notify$0(ctrl), 0, 0, msg, cont);
		                            }
		                            if(a)
		                             return a[1]
		                                     ? caml_exact_trampoline_cps_call$3
		                                       (push$2,
		ctrl,
		source,
		0,
		original_event,
		a_p,
		function(match){return b([0, [0, original_event], a_q]);})
		                                     : caml_exact_trampoline_cps_call$3
		                                       (push$2,
		ctrl,
		source,
		0,
		original_event,
		a_r,
		function(match){return b([0, [0, original_event], a_s]);});
		                            a = patch[2];
		                            if(a){
		                             a = a[1];
		                             if(a)
		                              return a[1]
		                                      ? caml_exact_trampoline_cps_call$3
		(push$2,
		 ctrl,
		 source,
		 0,
		 original_event,
		 a_t,
		 function(match){return b([0, [0, original_event], a_u]);})
		                                      : caml_exact_trampoline_cps_call$3
		(push$2,
		 ctrl,
		 source,
		 0,
		 original_event,
		 a_v,
		 function(match){return b([0, [0, original_event], a_w]);});
		                            }
		                            a = patch[10];
		                            if(! a)
		                             return caml_exact_trampoline_cps_call$3
		                                     (push$2,
		                                      ctrl,
		                                      source,
		                                      0,
		                                      original_event,
		                                      a_C,
		                                      function(match){return b([0, [0, original_event], a_D]);});
		                            var time = a[1];
		                            return caml_exact_trampoline_cps_call$3
		                                    (push$2,
		                                     ctrl,
		                                     source,
		                                     0,
		                                     original_event,
		                                     a_x,
		                                     function(match){
		                                      return caml_exact_trampoline_cps_call
		      (duration,
		       time,
		       function(new_duration){
		        return caml_exact_trampoline_cps_call
		                (duration,
		                 original_event[9][10],
		                 function(old_duration){
		                  return caml_exact_trampoline_cps_call$1
		                          (equal$18,
		                           old_duration,
		                           new_duration,
		                           function(d){
		                            function a(notif_suffix){
		                             return b([0, [0, original_event], notif_suffix]);
		                            }
		                            if(d){
		                             var
		                              c =
		                                function(a, b, cont){
		                                 return caml_exact_trampoline_cps_call$2
		 (pp_start, 0, locale, a, b, cont);
		                                };
		                             return caml_exact_trampoline_cps_call
		                                     (highlight,
		                                      a_y,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (b, c, time, function(b){return a([0, a_z, [0, b, 0]]);});
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call
		                                    (highlight,
		                                     a_A,
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (b,
		       pp$12,
		       new_duration,
		       function(b){return a([0, a_B, [0, b, 0]]);});
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		               }
		               function push$3(ctrl, id, source, action, cont){
		                var
		                 workspace_id = personal_workspace_id(ctrl[2]),
		                 a = object$0([2, id], workspace_id, source, action);
		                return caml_exact_trampoline_cps_call$0
		                        (push_dont_wait$0, ctrl[11], 0, a, cont);
		               }
		               function get_page$1(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$1, ctrl[9], id, cont);
		               }
		               function push$4(ctrl, id, source, action, cont){
		                var
		                 workspace_id = personal_workspace_id(ctrl[2]),
		                 a = object$0([5, id], workspace_id, source, action);
		                return caml_exact_trampoline_cps_call$0
		                        (push_dont_wait$0, ctrl[11], 0, a, cont);
		               }
		               function move$1(ctrl, task, destination, source, cont){
		                var a = task[5][1];
		                function b(ppf, param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (pp_none, ppf, dummy, cont);
		                 var v = param[1];
		                 return caml_exact_trampoline_cps_call$2
		                         (using, to_string$50, pp_print_string, ppf, v, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$161,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$162,
		     function(b){
		      return caml_trampoline_cps_call3
		              (b,
		               pp_v$0,
		               destination,
		               function(b){
		                return caml_exact_trampoline_cps_call$2
		                        (push$4,
		                         ctrl,
		                         task[4],
		                         source,
		                         [1, [0, b, a]],
		                         function(a){
		                          a = to_reference_id(destination);
		                          return caml_exact_trampoline_cps_call
		                                  (object$2(ctrl),
		                                   a,
		                                   function(b){
		                                    var a = [0, b, 0];
		                                    return caml_exact_trampoline_cps_call
		    (text$3,
		     a_S,
		     function(b){
		      return caml_exact_trampoline_cps_call$0
		              (notify$0(ctrl), 0, 0, [0, [7, task], [0, b, a]], cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function person_display_name(person){
		                var match = person[5];
		                if(! match) return person[2];
		                var display = match[1][1];
		                return display;
		               }
		               function check_writable(crdt, calendar_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_calendar$0,
		                         crdt,
		                         calendar_id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$164,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (a,
		      pp$2,
		      calendar_id,
		      function(a){var x = [0, 9943782, a]; return cont([1, x]);});
		                                    });
		                          var calendar = match[1];
		                          return calendar[8]
		                                  ? caml_trampoline_cps_call2(of_string$14, 0, cont)
		                                  : caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$163,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (a,
		       pp$2,
		       calendar_id,
		       function(a){var x = [0, 9943782, a]; return cont([1, x]);});
		                                     });
		                         });
		               }
		               function default$12(crdt, cont){
		                return caml_exact_trampoline_cps_call
		                        (states,
		                         crdt,
		                         function(s){
		                          function f(param, cont){
		                           var state = param[2];
		                           return caml_exact_trampoline_cps_call$2
		                                   (to_sequence$2,
		                                    0,
		                                    0,
		                                    0,
		                                    state[2],
		                                    function(a){
		                                     return caml_trampoline_cps_call3(map$11, a, get_data, cont);
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (bind$5,
		                                   s,
		                                   f,
		                                   function(cals){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_map,
		     cals,
		     function(calendar, cont){
		      return calendar[6] ? cont(0) : cont([0, calendar]);
		     },
		     function(calendar){
		      if(! calendar) return cont(a_2);
		      var calendar$0 = calendar[1];
		      return caml_trampoline_cps_call2
		              (of_string$14, calendar$0, cont);
		     });
		                                   });
		                         });
		               }
		               var Logs$13 = with_tag$0(component$0, "Controller.Settings");
		               function patch$5(ctrl, crdt, patch, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$13[6][6],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_patch, patch, schema$85), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call4(m, 0, [0, a], a_3, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(a){
		                                    var settings = a[21];
		                                    return caml_exact_trampoline_cps_call$1
		    (update_from_patch$3,
		     patch,
		     settings,
		     function(crdt_op){
		      return caml_exact_trampoline_cps_call$0
		              (apply_personal, ctrl[1], crdt, crdt_op, cont);
		     });
		                                   });
		                         });
		               }
		               function value$11(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var settings = param[2][29];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, settings, cont);
		                         },
		                         cont);
		               }
		               function hours_config(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var settings_hours = param[2][30];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, settings_hours, cont);
		                         },
		                         cont);
		               }
		               function locale$0(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var settings_locale = param[2][31];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, settings_locale, cont);
		                         },
		                         cont);
		               }
		               function allocate_time(ctrl, duration, slots, start, end, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function a(available, cont){
		                 function a(param){
		                  function b(a){
		                   return caml_trampoline_cps_call2(of_string$14, a, cont);
		                  }
		                  if(! param) return b(0);
		                  var
		                   l = param[2],
		                   x = param[1],
		                   end = x[2],
		                   start = x[1],
		                   s = symbol$58(end, start);
		                  return caml_exact_trampoline_cps_call$1
		                          (symbol$70,
		                           s,
		                           duration,
		                           function(c){
		                            var r = some_if(c, start);
		                            return r ? b(r) : caml_exact_trampoline_call1(a, l);
		                           });
		                 }
		                 return a(available);
		                }
		                function b(busy, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (remove_busy_windows, slots, busy, cont);
		                }
		                return caml_exact_trampoline_cps_call$7
		                        (busy_windows_from_events,
		                         [0,
		                          function(id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (warn$4(ctrl),
		                                    a_5,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(a, pp$35, id, cont);
		                                    });
		                          }],
		                         [0,
		                          function(event, cont){
		                           var a = event[9][11];
		                           return caml_exact_trampoline_cps_call
		                                   (warn$4(ctrl),
		                                    a_4,
		                                    function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                          }],
		                         ctrl[2],
		                         ctrl[5],
		                         start,
		                         end,
		                         function(c){
		                          return caml_trampoline_cps_call2
		                                  (of_string$14,
		                                   c,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     c,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$0, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function allocate$0(ctrl, param, title, task_id, cont){
		                var
		                 slot = param[8],
		                 participants = param[6],
		                 duration = param[5],
		                 daytime = param[3],
		                 dates = param[2],
		                 maybe_dest_calendar_id = param[1],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                return caml_exact_trampoline_cps_call
		                        (hours_config,
		                         ctrl,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    var
		                                     evening_start = match[4],
		                                     day_start = match[1],
		                                     now = ocaml_ptime_clock_now_d_ps();
		                                    function b(param, cont){
		                                     var
		                                      dest_calendar_email = param[2],
		                                      dest_calendar_id = param[1];
		                                     function a(d){
		                                      function c(date, cont){
		                                       if(0 === date[0]){
		var
		 a = date[1],
		 end = a[2],
		 start = a[1],
		 participant_to_attendee =
		   function(param, cont){
		    if(0 === param[0]){
		     var email = param[1];
		     return cont([0, email, make_attendee(0, 0, 0, email)]);
		    }
		    var email$0 = param[1][1];
		    return cont([0, email$0, make_attendee(0, 0, 0, email$0)]);
		   };
		return caml_trampoline_cps_call3
		        (map$18,
		         participants,
		         participant_to_attendee,
		         function(a){
		          return caml_exact_trampoline_cps_call$0
		                  (of_alist_reduce$1,
		                   [0, comparator$2],
		                   a,
		                   merge_attendees,
		                   function(invited){
		                    var
		                     myself = make_attendee(0, a_7, a_6, dest_calendar_email);
		                    return caml_exact_trampoline_cps_call
		                            (is_empty$5,
		                             invited,
		                             function(b){
		                              function a(attendees){
		                               return caml_trampoline_cps_call3
		                                       (map$17,
		slot,
		get_data,
		function(type){
		 var
		  a =
		    make$47
		     (0,
		      0,
		      [0, attendees],
		      0,
		      0,
		      0,
		      0,
		      0,
		      task_id,
		      [2, start, end],
		      title),
		  t = ocaml_ptime_clock_now_d_ps();
		 return caml_exact_trampoline_cps_call
		         (function(a){
		            return function(b, cont){
		             return caml_exact_trampoline_cps_call$4
		                     (add_from_writable$1,
		                      0,
		                      0,
		                      t,
		                      0,
		                      0,
		                      dest_calendar_id,
		                      a,
		                      type,
		                      b,
		                      cont);};
		           }
		           (0),
		          a,
		          function(event_op){
		           return caml_exact_trampoline_cps_call$1
		                   (of_time$0,
		                    timezone_local,
		                    end,
		                    function(a){
		                     return caml_trampoline_cps_call2
		                             (of_string$14, [0, event_op, a], cont);
		                    });
		          });
		});
		                              }
		                              return b
		                                      ? a(invited)
		                                      : caml_exact_trampoline_cps_call$0
		(set$3, invited, dest_calendar_email, myself, a);
		                             });
		                   });
		         });
		                                       }
		                                       a = date[1];
		                                       var error = a[2], start$0 = a[1];
		                                       return caml_trampoline_cps_call3
		       (map$17,
		        start$0,
		        function(a, cont){
		         return caml_exact_trampoline_cps_call$1
		                 (of_time$0, timezone_local, a, cont);
		        },
		        function(a){
		         var x = [0, 312767772, [0, a, error]];
		         return cont([1, x]);
		        });
		                                      }
		                                      function b(options){
		                                       return caml_exact_trampoline_cps_call$1
		       (filter_map$1,
		        options,
		        function(param, cont){
		         var end = param[3], start = param[2], date = param[1];
		         return caml_exact_trampoline_cps_call$0
		                 (to_time$2,
		                  timezone_local,
		                  date,
		                  start,
		                  function(start){
		                   function a(end){
		                    if(0 === start[0]){
		                     var start$0 = start[1];
		                     if(0 === end[0]){
		                      var end$0 = end[1];
		                      return caml_trampoline_cps_call2
		                              (return$9, [0, start$0, end$0], cont);
		                     }
		                    }
		                    return cont(0);
		                   }
		                   if(! end) return a(a_8);
		                   var end$0 = end[1];
		                   function b(end, cont){return cont([0, end]);}
		                   return caml_exact_trampoline_cps_call$0
		                           (to_time$2,
		                            timezone_local,
		                            date,
		                            end$0,
		                            function(c){
		                             return caml_trampoline_cps_call3(let$, c, b, a);
		                            });
		                  });
		        },
		        function(a){
		         a = Sequence_result[13].call(null, a);
		         a =
		          Sequence_result[32][5].call
		           (null,
		            a,
		            function(param, cont){
		             var match = param[2], time = param[1];
		             if(! match)
		              return caml_exact_trampoline_cps_call$1
		                      (symbol$78,
		                       time,
		                       duration,
		                       function(end){
		                        var x = [0, time, end];
		                        return caml_trampoline_cps_call2(of_string$14, [0, x], cont);
		                       });
		             var end = match[1];
		             return caml_exact_trampoline_cps_call$1
		                     (max$13,
		                      now,
		                      time,
		                      function(start){
		                       return caml_exact_trampoline_cps_call$1
		                               (symbol$75,
		                                start,
		                                end,
		                                function(b){
		                                 if(b)
		                                  return caml_exact_trampoline_cps_call$1
		  (kasprintf,
		   id,
		   fmt$165,
		   function(a){
		    return caml_trampoline_cps_call5
		            (a,
		             pp$12,
		             duration,
		             _12,
		             start,
		             function(message){
		              var x = [0, [0, start], message];
		              return caml_trampoline_cps_call2(of_string$14, [1, x], cont);
		             });
		   });
		                                 var slots = [0, [0, start, end], 0];
		                                 function a(time_o, cont){
		                                  if(! time_o)
		                                   return caml_exact_trampoline_cps_call$1
		   (kasprintf,
		    id,
		    fmt$166,
		    function(a){
		     return caml_trampoline_cps_call7
		             (a,
		              pp$12,
		              duration,
		              _12,
		              start,
		              _12,
		              end,
		              function(message){
		               var x = [0, [0, start], message];
		               return caml_trampoline_cps_call2(of_string$14, [1, x], cont);
		              });
		    });
		                                  var time = time_o[1];
		                                  return caml_exact_trampoline_cps_call$1
		  (symbol$78,
		   time,
		   duration,
		   function(a){
		    var x = [0, time, a];
		    return caml_trampoline_cps_call2(of_string$14, [0, x], cont);
		   });
		                                 }
		                                 return caml_exact_trampoline_cps_call$3
		 (allocate_time,
		  ctrl,
		  duration,
		  slots,
		  start,
		  end,
		  function(b){
		   return caml_trampoline_cps_call3(let$0, b, a, cont);
		  });
		                                });
		                      });
		            });
		         return caml_exact_trampoline_cps_call$2
		                 (Sequence_result[30],
		                  a,
		                  0,
		                  function(errors, a, cont){
		                   if(0 === a[0]) return cont([1, a]);
		                   var error = a[1];
		                   return cont([0, [0, error, errors]]);
		                  },
		                  function(al, cont){
		                   if(! al)
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             fmt$167,
		                             function(a){
		                              return caml_trampoline_cps_call3
		                                      (a,
		                                       pp$12,
		                                       duration,
		                                       function(a){return cont([1, [0, 0, a]]);});
		                             });
		                   var a = al[1];
		                   if(! al[2]) return cont([1, a]);
		                   function compare(a, param, cont){
		                    var t2 = param[1], t1 = a[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (compare_option, compare$37, t1, t2, cont);
		                   }
		                   return caml_exact_trampoline_cps_call$0
		                           (min_elt,
		                            fold_left$1,
		                            al,
		                            compare,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$2
		                                     (value_exn, a_9, 0, 0, a, function(x){return cont([1, x]);});
		                            });
		                  },
		                  function(a){
		                   return caml_trampoline_cps_call3(let$0, a, c, cont);
		                  });
		        });
		                                      }
		                                      if(! dates)
		                                       return caml_exact_trampoline_cps_call
		       (today,
		        dummy,
		        function(today){
		         function f(date, cont){
		          return caml_exact_trampoline_cps_call$1
		                  (add_days,
		                   date,
		                   1,
		                   function(a){
		                    return cont
		                            ([0, [0, [0, date, day_start, [0, evening_start]], a]]);
		                   });
		         }
		         return caml_exact_trampoline_cps_call$1
		                 (add_days,
		                  today,
		                  1,
		                  function(c){
		                   var future_days = unfold$0(c, f), a = [0, evening_start];
		                   return caml_exact_trampoline_cps_call$1
		                           (of_time$1,
		                            timezone_local,
		                            now,
		                            function(c){
		                             return b(shift_right(future_days, [0, today, c, a]));
		                            });
		                  });
		        });
		                                      var dates$0 = dates[1];
		                                      function a(dates){
		                                       function f(date, cont){
		if(! daytime)
		 return cont([0, date, day_start, [0, evening_start]]);
		var a = daytime[1], match = a[2], start = a[1];
		if(! match) return cont([0, date, start, 0]);
		var end = match[1];
		return cont([0, date, start, [0, end]]);
		                                       }
		                                       return caml_trampoline_cps_call3(map$11, dates, f, b);
		                                      }
		                                      switch(dates$0[0]){
		case 0:
		 var date = dates$0[1];
		 return caml_trampoline_cps_call2(return$6, date, a);
		case 1:
		 var
		  start = dates$0[2],
		  end = dates$0[1],
		  f =
		    function(date, cont){
		     return caml_exact_trampoline_cps_call$1
		             (add_days,
		              date,
		              1,
		              function(b){
		               var a = [0, date, b];
		               return caml_exact_trampoline_cps_call$1
		                       (symbol$83,
		                        date,
		                        end,
		                        function(b){return cont(some_if(b, a));});
		              });
		    };
		 return a(unfold$0(start, f));
		case 2:
		 var year = dates$0[3], month = dates$0[2];
		 return a(days(year, month));
		case 3:
		 var week = dates$0[1];
		 return caml_exact_trampoline_cps_call(days$0, week, a);
		default:
		 var year$0 = dates$0[1];
		 return caml_exact_trampoline_cps_call$1
		         (to_date$0,
		          year$0 + 1 | 0,
		          0,
		          function(end){
		           function f(date, cont){
		            return caml_exact_trampoline_cps_call$1
		                    (add_days,
		                     date,
		                     1,
		                     function(b){
		                      var a = [0, date, b];
		                      return caml_exact_trampoline_cps_call$1
		                              (symbol$83,
		                               date,
		                               end,
		                               function(b){return cont(some_if(b, a));});
		                     });
		           }
		           return caml_exact_trampoline_cps_call$1
		                   (to_date$0,
		                    year$0,
		                    0,
		                    function(b){return a(unfold$0(b, f));});
		          });
		                                      }
		                                     }
		                                     return slot
		     ? caml_exact_trampoline_cps_call
		       (failwith,
		        "Controller.Allocate Slot allocation disabled for now",
		        a)
		     : a();
		                                    }
		                                    function c(dest_calendar, cont){
		                                     function a(email, cont){
		                                      return cont([0, dest_calendar[5], email]);
		                                     }
		                                     function b(param, cont){
		                                      var userinfo = param[2][6];
		                                      return cont(userinfo[1]);
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (profile_google,
		      ctrl[9],
		      dest_calendar[2],
		      function(c){
		       return caml_trampoline_cps_call3
		               (let$,
		                c,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      });
		                                    }
		                                    function a(a){
		                                     return caml_trampoline_cps_call3
		     (let$0,
		      a,
		      c,
		      function(a){
		       return caml_trampoline_cps_call3(let$0, a, b, cont);
		      });
		                                    }
		                                    if(! maybe_dest_calendar_id)
		                                     return caml_exact_trampoline_cps_call
		     (default$12, ctrl[2], a);
		                                    var id$0 = maybe_dest_calendar_id[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (get_calendar$0,
		     ctrl[2],
		     id$0,
		     function(match){
		      if(! match)
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$168,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (b,
		                          pp$2,
		                          id$0,
		                          function(b){var x = [0, 9943782, b]; return a([1, x]);});
		                });
		      var c = match[1];
		      return caml_trampoline_cps_call2(of_string$14, c, a);
		     });
		                                   });
		                         });
		               }
		               function notify_failure(ctrl, res, cont){
		                if(0 === res[0]){
		                 var value = res[1];
		                 return caml_trampoline_cps_call2
		                         (of_string$14, [0, value], cont);
		                }
		                var match = res[1], variant = match[1];
		                if(312767772 > variant) return cont(res);
		                var msg = match[2][2];
		                return caml_exact_trampoline_cps_call
		                        (notify_f$0(ctrl)(a_$),
		                         a__,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   msg,
		                                   function(match){
		                                    return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                                   });
		                         });
		               }
		               function get$21(param){}
		               function augment$3(ctrl, Incr, param, task, cont){
		                return caml_exact_trampoline_cps_call
		                        (augment$1,
		                         task,
		                         function(a){
		                          return caml_trampoline_cps_call2(Incr[76], a, cont);
		                         });
		               }
		               var
		                include$323 =
		                  caml_callback
		                   (Make_object_augmented,
		                    [[0,
		                      ,
		                      bQJ,
		                      ,
		                      notes$10,
		                      with_notes$3,
		                      ,
		                      ,
		                      cst_task,
		                      lookup$4],
		                     [0, get$21, augment$3]]),
		                Logs$14 = include$323[1],
		                get$22 = include$323[3],
		                cst_allocation = "allocation";
		               function allocate$1(ctrl, crdt, id, allocation, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0,
		                                    attr$0(cst_allocation, allocation, action_allocation_schema),
		                                    0],
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, a], a$a, _16$0, id, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (today,
		                                   dummy,
		                                   function(today){
		                                    function f(task, cont){
		                                     function f(param, cont){
		                                      var scheduled = param[2], add_event_op = param[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$82,
		       scheduled,
		       today,
		       function(a){
		        var starred = some_if(a, 0);
		        return caml_exact_trampoline_cps_call$4
		                (update$7,
		                 0,
		                 0,
		                 0,
		                 [0, [0, [1, scheduled]]],
		                 starred,
		                 0,
		                 0,
		                 0,
		                 id,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (Operation$21[8],
		                           0,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (tasks,
		                                     value$4(a, b),
		                                     function(task_op){
		                                      var
		                                       open =
		 g
		  ([0,
		    symbol_bind$22,
		    symbol_map$20,
		    ,
		    bind$30,
		    return$39,
		    map$50,
		    ,
		    ,
		    ,
		    ,
		    Let_syntax$14]),
		                                       let$ = open[3];
		                                      return caml_trampoline_cps_call3
		      (let$,
		       add_event_op,
		       function(event_id, cont){
		        return caml_trampoline_cps_call3
		                (let$,
		                 task_op,
		                 function(param, cont){
		                  return caml_trampoline_cps_call2(return$39, event_id, cont);
		                 },
		                 cont);
		       },
		       function(crdt_op){
		        return caml_exact_trampoline_cps_call$0
		                (apply_personal,
		                 ctrl[1],
		                 crdt,
		                 crdt_op,
		                 function(match){
		                  var event_id = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (get_event$1,
		                           ctrl[2],
		                           event_id,
		                           function(event_o){
		                            function a(a){return cont(event_o);}
		                            if(! event_o) return a();
		                            var event = event_o[1];
		                            return caml_exact_trampoline_cps_call$2
		                                    (allocate, ctrl, task, event, source, a);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$2
		     (allocate$0,
		      ctrl,
		      allocation,
		      task[7][9][2],
		      [0, id],
		      function(x){
		       return caml_trampoline_cps_call3
		               (map$15,
		                x,
		                f,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (notify_failure,
		                          ctrl,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3(map$15, a, join$2, cont);
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (get_task$0,
		     ctrl[2],
		     id,
		     function(match){
		      function a(x){
		       return caml_trampoline_cps_call3(bind$6, x, f, cont);
		      }
		      if(! match)
		       return caml_exact_trampoline_cps_call
		               (fail_result,
		                a$b,
		                function(b){
		                 return caml_trampoline_cps_call3(b, _16$0, id, a);
		                });
		      var task = match[1];
		      return caml_trampoline_cps_call2(of_string$14, task, a);
		     });
		                                   });
		                         });
		               }
		               function bR$(week_start, events, task, cont){
		                function batch_of_date(date, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_date$1,
		                          date,
		                          function(batch){
		                           return caml_exact_trampoline_cps_call
		                                   (weekday,
		                                    date,
		                                    function(match){
		                                     if(6 <= match && 6 <= week_start)
		                                      return caml_exact_trampoline_cps_call$1
		      (symbol$88, batch, 1, cont);
		                                     return cont(batch);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (today,
		                         dummy,
		                         function(today){
		                          return caml_exact_trampoline_cps_call
		                                  (batch_of_date,
		                                   today,
		                                   function(current){
		                                    return is_some(task[7][1])
		    ? cont(0)
		    : caml_exact_trampoline_cps_call
		      (to_week_date,
		       task[7][7],
		       function(c){
		        var a = c[1];
		        function b(batch){
		         function f$0(param, cont){
		          var time = param[9][10];
		          return caml_exact_trampoline_cps_call$1
		                  (start_date$1,
		                   timezone_local,
		                   time,
		                   function(start){
		                    return caml_exact_trampoline_cps_call$1
		                            (symbol$79,
		                             start,
		                             today,
		                             function(a){return cont(some_if(a, start));});
		                   });
		         }
		         var allocations = task[1];
		         function f(param, cont){
		          if(! param) return cont(0);
		          var allocations = param[2], id = param[1];
		          return caml_exact_trampoline_cps_call$1
		                  (find_packed_by_id,
		                   events,
		                   id,
		                   function(match){
		                    if(! match) return cont([0, allocations]);
		                    var event = match[1];
		                    return cont([1, event, allocations]);
		                   });
		         }
		         return caml_exact_trampoline_cps_call$1
		                 (find_map,
		                  [0, allocations, f],
		                  f$0,
		                  function(b){
		                   var a = task[7][2], match = task[7][1];
		                   if(b){
		                    if(! a && ! match){
		                     var allocation = b[1];
		                     return caml_exact_trampoline_cps_call
		                             (batch_of_date,
		                              allocation,
		                              function(a){return cont([0, a]);});
		                    }
		                   }
		                   else if(! a){
		                    if(! batch) return cont(0);
		                    if(! match){
		                     var batch$0 = batch[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$86,
		                              batch$0,
		                              current,
		                              function(a){
		                               return a ? cont([0, current]) : cont([0, batch$0]);
		                              });
		                    }
		                   }
		                   if(match) return cont(0);
		                   var date = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (of_time$0,
		                            timezone_local,
		                            date,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (batch_of_date, a, function(a){return cont([0, a]);});
		                            });
		                  });
		        }
		        if(a && ! c[2]){var batch = a[1]; return b([0, batch]);}
		        a = c[2];
		        if(! a) return b(0);
		        var day = a[1];
		        return caml_exact_trampoline_cps_call
		                (batch_of_date, day, function(a){return b([0, a]);});
		       });
		                                   });
		                         });
		               }
		               function batch(ctrl, batch, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$d, pp$14, batch, cont);
		                         },
		                         function(a){
		                          a = ctrl[23][1];
		                          var
		                           incremental = a[1],
		                           week_start = a[6],
		                           tasks = a[2],
		                           open =
		                             g
		                              ([0,
		                                incremental[72],
		                                incremental[73],
		                                ,
		                                incremental[75],
		                                incremental[76],
		                                incremental[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                incremental[82]]),
		                           and = open[6],
		                           let$ = open[4],
		                           let$0 = open[3],
		                           symbol_map = open[2];
		                          function ids(param, cont){
		                           if(! param) return cont(0);
		                           var tasks = param[1];
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    tasks,
		                                    function(t, cont){return cont([1, t[6]]);},
		                                    cont);
		                          }
		                          function b(param, cont){
		                           var unscheduled = param[2], scheduled = param[1];
		                           return cont([0, scheduled, unscheduled]);
		                          }
		                          return caml_trampoline_cps_call3
		                                  (let$0,
		                                   week_start,
		                                   function(week_start, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (date_of_week,
		     week_start,
		     batch,
		     function(batch_start){
		      return caml_exact_trampoline_cps_call$1
		              (init$7,
		               7,
		               function(i, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (add_days,
		                         batch_start,
		                         i,
		                         function(date){
		                          function a(a, cont){return cont(value$4(a, 0));}
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   tasks,
		                                   [1, [1, date]],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (symbol_map,
		     b,
		     a,
		     function(a){
		      return caml_trampoline_cps_call3
		              (symbol_map, a, day_of_tasks, cont);
		     });
		                                   });
		                         });
		               },
		               function(a){
		                return caml_trampoline_cps_call2(incremental[80], a, cont);
		               });
		     });
		                                   },
		                                   function(left){
		                                    function a(a, cont){
		                                     return caml_trampoline_cps_call3
		     (map$17, a, parents_only, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (find$6,
		     tasks,
		     [1, [0, batch]],
		     function(c){
		      return caml_trampoline_cps_call3
		              (symbol_map,
		               c,
		               a,
		               function(a){
		                return caml_trampoline_cps_call3
		                        (symbol_map,
		                         a,
		                         ids,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   left,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     a,
		     b,
		     function(v){
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$154,
		               function(a){
		                return caml_trampoline_cps_call3
		                        (a,
		                         pp$14,
		                         batch,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$230,
		                                   v,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, symbol$229(a, equal_batch), cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function create$46(ctrl, document, task_writable, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   document_schema,
		                                   function(a){
		                                    a = [0, attr$0(cst_document, document, a), 0];
		                                    return caml_exact_trampoline_cps_call
		    (attrs,
		     [0, attr$0(cst_task, task_writable, schema$194), a],
		     function(a){
		      return caml_trampoline_cps_call4(m, 0, [0, a], a$e, cont);
		     });
		                                   });
		                         },
		                         function(match){
		                          function f(document, cont){return cont(document[1]);}
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   document,
		                                   f,
		                                   function(parent){
		                                    if(parent)
		                                     var
		                                      parent$0 = parent[1],
		                                      task_writable$0 =
		[0,
		 task_writable[1],
		 task_writable[2],
		 task_writable[3],
		 ,
		 task_writable[5],
		 [0, parent$0],
		 task_writable[7],
		 task_writable[8],
		 task_writable[9]];
		                                    else
		                                     task_writable$0 = task_writable;
		                                    return caml_exact_trampoline_cps_call
		    (state_personal,
		     ctrl[2],
		     function(state){
		      var
		       created = ocaml_ptime_clock_now_d_ps(),
		       cascade = [0, state],
		       open$0 =
		         g
		          ([0,
		            symbol_bind$22,
		            symbol_map$20,
		            ,
		            bind$30,
		            return$39,
		            map$50,
		            ,
		            ,
		            ,
		            ,
		            Let_syntax$14]),
		       let$0 = open$0[3],
		       a = task_writable$0[9],
		       d = a[3],
		       a = a[2],
		       e = task_writable$0[8],
		       f = task_writable$0[7],
		       h = task_writable$0[6],
		       i = task_writable$0[5],
		       j = task_writable$0[3],
		       status = make$112(task_writable$0[2], task_writable$0[1]),
		       open =
		         g
		          ([0,
		            Operation$21[4],
		            Operation$21[5],
		            ,
		            Operation$21[7],
		            Operation$21[8],
		            Operation$21[9],
		            ,
		            ,
		            ,
		            ,
		            Operation$21[12]]),
		       let$ = open[3];
		      function b(id, cont){
		       function a(param, cont){
		        return caml_trampoline_cps_call2(Operation$21[8], id, cont);
		       }
		       return caml_exact_trampoline_cps_call$1
		               (insert_blocks,
		                -1,
		                aXP[1],
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (notes$4,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (element$22,
		                                    id,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          });
		                });
		      }
		      function c(main_task_id, cont){
		       var notes = task_writable$0[9][1];
		       function a(param, cont){
		        var
		         task_rec_ids = param[3],
		         task_ids = param[2],
		         updated_notes = param[1];
		        function a(param, cont){
		         function f(parent, cont){
		          function f(state, cont){
		           var a = task_writable$0[9][2];
		           return caml_exact_trampoline_cps_call$3
		                   (append_parent_block,
		                    state,
		                    is_some(task_writable$0[2]),
		                    parent,
		                    a,
		                    main_task_id,
		                    cont);
		          }
		          var x = to_option$6(cascade);
		          return caml_trampoline_cps_call3(bind$8, x, f, cont);
		         }
		         var x = task_writable$0[6];
		         return caml_trampoline_cps_call3
		                 (bind$8,
		                  x,
		                  f,
		                  function(parent_block_op){
		                   function b(param, cont){
		                    return caml_trampoline_cps_call2
		                            (return$39, [0, main_task_id, task_ids, task_rec_ids], cont);
		                   }
		                   function a(op){
		                    return caml_trampoline_cps_call3(let$0, op, b, cont);
		                   }
		                   if(! parent_block_op)
		                    return caml_trampoline_cps_call2(return$39, 0, a);
		                   var op = parent_block_op[1];
		                   return a(op);
		                  });
		        }
		        return caml_exact_trampoline_cps_call$1
		                (insert_blocks,
		                 -1,
		                 updated_notes[1],
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (notes$4,
		                           b,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (element$22,
		                                     main_task_id,
		                                     function(c){
		                                      return caml_trampoline_cps_call2
		      (c,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (tasks,
		                 b,
		                 function(b){
		                  return caml_trampoline_cps_call3(let$0, b, a, cont);
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call$0
		               (add_referenced_subtasks,
		                created,
		                [0, [4, main_task_id]],
		                notes,
		                function(b){
		                 return caml_trampoline_cps_call3(let$0, b, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$6
		              (add_task,
		               0,
		               0,
		               j,
		               i,
		               h,
		               f,
		               e,
		               [0, status],
		               d,
		               a,
		               created,
		               function(a){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         a,
		                         b,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (tasks,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (let$0,
		     a,
		     c,
		     function(add_task_op){
		      var
		       open =
		         g
		          ([0,
		            symbol_bind$22,
		            symbol_map$20,
		            ,
		            bind$30,
		            return$39,
		            map$50,
		            ,
		            ,
		            ,
		            ,
		            Let_syntax$14]),
		       let$ = open[4];
		      return caml_trampoline_cps_call3
		              (let$,
		               add_task_op,
		               function(param, cont){
		                var task_id = param[1];
		                return caml_trampoline_cps_call3
		                        (map$17,
		                         document,
		                         function(doc, cont){return cont(doc[1]);},
		                         function(a){return cont([0, task_id, a]);});
		               },
		               cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function observe_task
		               (opt, allocation, document, source, ctrl, task_id, cont){
		                var notify = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call$1
		                        (get_task$0,
		                         ctrl[2],
		                         task_id,
		                         function(match){
		                          if(! match) return cont();
		                          var task = match[1];
		                          function f(allocation, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (get_event$1, ctrl[2], allocation, cont);
		                          }
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   allocation,
		                                   f,
		                                   function(allocation){
		                                    return caml_exact_trampoline_cps_call
		    (locale,
		     ctrl[9],
		     function(locale){
		      var
		       notify$1 =
		         notify
		          ? notify$0(ctrl)
		          : function(b, a, param, cont){return cont();};
		      function push_metric(param, cont){
		       return caml_exact_trampoline_cps_call
		               (push_nonrec(ctrl, task[6], 0), source, cont);
		      }
		      var scheduled = task[7][7];
		      if(allocation){
		       var time = allocation[1][9][10];
		       return caml_exact_trampoline_cps_call
		               (push_metric,
		                dummy,
		                function(b){
		                 function a(a, b, cont){
		                  return caml_exact_trampoline_cps_call$2
		                          (pp_start, 0, locale, a, b, cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (highlight,
		                          a9J,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (b,
		                                    a,
		                                    time,
		                                    function(b){
		                                     var a = [0, b, 0];
		                                     return caml_exact_trampoline_cps_call
		     (text$3,
		      a9K,
		      function(b){
		       return caml_exact_trampoline_cps_call$0
		               (notify$1, 0, 0, [0, [6, task], [0, b, a]], cont);
		      });
		                                    });
		                          });
		                });
		      }
		      if(! scheduled){
		       if(! document)
		        return caml_exact_trampoline_cps_call
		                (push_metric,
		                 dummy,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (notify$1,
		                           0,
		                           0,
		                           [0, [6, task], [0, a9Q, [0, inbox, 0]]],
		                           cont);
		                 });
		       var document$0 = document[1];
		       return caml_exact_trampoline_cps_call
		               (push_metric,
		                dummy,
		                function(a){
		                 a = to_reference_id(document$0);
		                 return caml_exact_trampoline_cps_call
		                         (object$2(ctrl),
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (notify$1, 0, 0, [0, [6, task], [0, a9P, [0, a, 0]]], cont);
		                          });
		                });
		      }
		      var match = scheduled[1];
		      if(0 === match[0]){
		       var batch = match[1];
		       return caml_exact_trampoline_cps_call
		               (push_metric,
		                dummy,
		                function(b){
		                 var a = locale[8];
		                 return caml_exact_trampoline_cps_call
		                         (highlight,
		                          a9L,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (b,
		                                    a,
		                                    batch,
		                                    function(b){
		                                     var a = [0, [8, cst_batch], [0, b, 0]];
		                                     return caml_exact_trampoline_cps_call
		     (text$3,
		      a9M,
		      function(b){
		       return caml_exact_trampoline_cps_call$0
		               (notify$1, 0, 0, [0, [6, task], [0, b, a]], cont);
		      });
		                                    });
		                          });
		                });
		      }
		      var scheduled$0 = match[1];
		      return caml_exact_trampoline_cps_call
		              (push_metric,
		               dummy,
		               function(b){
		                var a = locale[3];
		                return caml_exact_trampoline_cps_call
		                        (highlight,
		                         a9N,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (b,
		                                   a,
		                                   scheduled$0,
		                                   function(b){
		                                    var a = [0, b, 0];
		                                    return caml_exact_trampoline_cps_call
		    (text$3,
		     a9O,
		     function(b){
		      return caml_exact_trampoline_cps_call$0
		              (notify$1, 0, 0, [0, [6, task], [0, b, a]], cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function create$47
		               (ctrl, crdt, document, notify, source, task_writable, cont){
		                var a = task_writable[7];
		                function b(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (create$46,
		                          ctrl,
		                          document,
		                          task_writable,
		                          function(crdt_op){
		                           return caml_exact_trampoline_cps_call$0
		                                   (apply_personal,
		                                    ctrl[1],
		                                    crdt,
		                                    crdt_op,
		                                    function(match){
		                                     var doc_id_o = match[2], task_id = match[1];
		                                     return caml_exact_trampoline_cps_call$7
		     (observe_task,
		      notify,
		      0,
		      doc_id_o,
		      source,
		      ctrl,
		      task_id,
		      function(match){return cont(task_id);});
		                                    });
		                          });
		                }
		                if(! a) return b();
		                a = a[1];
		                if(0 === a[0]) return b();
		                var date = a[1];
		                return caml_exact_trampoline_cps_call
		                        (mutate$0(ctrl), [0, [3, [0, date]], 0], b);
		               }
		               function create_allocate
		               (ctrl,
		                crdt,
		                document,
		                notify,
		                source,
		                task_writable,
		                allocation,
		                cont){
		                return caml_exact_trampoline_cps_call$0
		                        (create$46,
		                         ctrl,
		                         document,
		                         task_writable,
		                         function(add_task_op){
		                          var
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$22,
		                                symbol_map$20,
		                                ,
		                                bind$30,
		                                return$39,
		                                map$50,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$14]),
		                           let$ = open[3];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   add_task_op,
		                                   function(param, cont){
		                                    var doc_id_o = param[2], task_id = param[1];
		                                    return caml_exact_trampoline_cps_call$2
		    (allocate$0,
		     ctrl,
		     allocation,
		     task_writable[9][2],
		     [0, task_id],
		     function(a){
		      if(0 === a[0]){
		       a = a[1];
		       var scheduled = a[2], event_op = a[1];
		       return caml_trampoline_cps_call3
		               (let$,
		                event_op,
		                function(param, cont){
		                 var event_id = param[1];
		                 function a(param, cont){
		                  return caml_trampoline_cps_call2
		                          (return$39, [0, task_id, doc_id_o, [0, event_id]], cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (add$26,
		                          event_id,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (allocations,
		                                    b,
		                                    function(c){
		                                     var b = [0, c, 0];
		                                     return caml_exact_trampoline_cps_call
		     (set_scheduled,
		      [0, [1, scheduled]],
		      function(c){
		       return caml_exact_trampoline_cps_call
		               (all_unit$18,
		                [0, c, b],
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (element$23,
		                          task_id,
		                          function(c){
		                           return caml_trampoline_cps_call2
		                                   (c,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (tasks,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                },
		                cont);
		      }
		      var err = a[1], variant = err[1];
		      if(312767772 > variant)
		       return caml_exact_trampoline_cps_call$1
		               (fatal$0,
		                a$i,
		                a$h,
		                function(a){
		                 return caml_trampoline_cps_call3(a, pp$125, err, cont);
		                });
		      a = err[2];
		      var msg = a[2], scheduled$0 = a[1];
		      return caml_exact_trampoline_cps_call
		              (notify_f$0(ctrl)(a$g),
		               a$f,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         msg,
		                         function(match){
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   scheduled$0,
		                                   function(sch, cont){return cont([1, sch]);},
		                                   function(scheduled){
		                                    function a(param, cont){
		                                     return caml_trampoline_cps_call2
		     (return$39, [0, task_id, doc_id_o, 0], cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (set_scheduled,
		     scheduled,
		     function(b){
		      return caml_trampoline_cps_call2
		              (element$23,
		               task_id,
		               function(c){
		                return caml_trampoline_cps_call2
		                        (c,
		                         b,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (tasks,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   },
		                                   function(crdt_op){
		                                    return caml_exact_trampoline_cps_call$0
		    (apply_personal,
		     ctrl[1],
		     crdt,
		     crdt_op,
		     function(match){
		      var
		       allocation = match[3],
		       doc_id_o = match[2],
		       task_id = match[1];
		      return caml_exact_trampoline_cps_call$7
		              (observe_task,
		               notify,
		               allocation,
		               doc_id_o,
		               source,
		               ctrl,
		               task_id,
		               function(match){return cont(task_id);});
		     });
		                                   });
		                         });
		               }
		               function move$2
		               (block,
		                construct,
		                get,
		                id_schema,
		                observe,
		                parent$0,
		                pp_id,
		                set_parent,
		                ctrl,
		                crdt,
		                task_id,
		                dest,
		                source,
		                cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          var
		                           a = [0, attr$0(cst_destination, dest, document_schema), 0];
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_task, task_id, id_schema), a],
		                                   function(a){
		                                    return caml_trampoline_cps_call4(m, 0, [0, a], a$j, cont);
		                                   });
		                         },
		                         function(a){
		                          var
		                           open =
		                             o
		                              ([0,
		                                symbol_bind$4,
		                                symbol_map$4,
		                                Let_syntax$2,
		                                ,
		                                bind$6,
		                                of_string$14,
		                                map$15]),
		                           let$ = open[3],
		                           a = construct(task_id);
		                          function b(param, cont){
		                           function a(task, cont){
		                            var previous_parent = parent$0(task);
		                            function b(param, cont){
		                             var old_doc_update = param[2], block = param[1];
		                             function a(new_doc_update, cont){
		                              return caml_exact_trampoline_cps_call$2
		                                      (observe,
		                                       ctrl,
		                                       task,
		                                       dest[1],
		                                       source,
		                                       function(match){
		return caml_exact_trampoline_cps_call$1
		        (set_parent,
		         task_id,
		         dest[1],
		         function(task_parent_update){
		          return caml_exact_trampoline_cps_call
		                  (filter_opt,
		                   [0,
		                    [0, task_parent_update],
		                    [0, old_doc_update, [0, [0, new_doc_update], 0]]],
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (all_unit$27,
		                             a,
		                             function(crdt_op){
		                              return caml_exact_trampoline_cps_call$0
		                                      (apply_personal,
		                                       ctrl[1],
		                                       crdt,
		                                       crdt_op,
		                                       function(match){
		return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$2
		                                     (append$15,
		                                      ctrl[2],
		                                      ctrl[9],
		                                      dest,
		                                      block,
		                                      function(match){
		                                       function b(b){
		return caml_trampoline_cps_call3(let$, b, a, cont);
		                                       }
		                                       if(! match)
		return caml_exact_trampoline_cps_call
		        (fail_result,
		         a$k,
		         function(a){
		          return caml_trampoline_cps_call3(a, pp_document, dest, b);
		         });
		                                       var op = match[1][2];
		                                       return caml_exact_trampoline_cps_call
		       (ignore_m$11,
		        op,
		        function(a){
		         return caml_trampoline_cps_call2(of_string$14, a, b);
		        });
		                                      });
		                            }
		                            function a(a){
		                             return caml_trampoline_cps_call3(let$, a, b, cont);
		                            }
		                            if(! previous_parent)
		                             return caml_trampoline_cps_call2
		                                     (of_string$14, [0, make$33(0, block(task)), 0], a);
		                            var previous_parent$0 = previous_parent[1];
		                            function c(param, cont){
		                             function a(doc, cont){
		                              function a(param, cont){
		                               var op = param[2], block = param[1];
		                               return caml_trampoline_cps_call2
		                                       (of_string$14, [0, block, [0, op]], cont);
		                              }
		                              return caml_exact_trampoline_cps_call$0
		                                      (remove_todo,
		                                       previous_parent$0,
		                                       construct(task_id),
		                                       doc,
		                                       function(b){
		return caml_trampoline_cps_call3(let$, b, a, cont);
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$1
		                                     (fetch_content,
		                                      ctrl[2],
		                                      previous_parent$0,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (let$, of_option(b, a$l), a, cont);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$149,
		                                     previous_parent$0,
		                                     dest[1],
		                                     function(d){
		                                      function b(b){
		                                       return caml_trampoline_cps_call3(let$, b, c, a);
		                                      }
		                                      return d
		      ? b([1, 870531010])
		      : caml_trampoline_cps_call2(of_string$14, 0, b);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (get,
		                                    ctrl[2],
		                                    task_id,
		                                    function(match){
		                                     function b(b){
		                                      return caml_trampoline_cps_call3(let$, b, a, cont);
		                                     }
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (fail_result,
		       a$m,
		       function(a){
		        return caml_trampoline_cps_call3(a, pp_id, task_id, b);
		       });
		                                     var task = match[1];
		                                     return caml_trampoline_cps_call2(of_string$14, task, b);
		                                    });
		                          }
		                          if(0 === a[0])
		                           var id = a[1], task_as_parent = [4, id];
		                          else
		                           var id$0 = a[1], task_as_parent = [5, id$0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$149,
		                                   task_as_parent,
		                                   dest[1],
		                                   function(d){
		                                    function a(a){
		                                     return caml_trampoline_cps_call3
		     (let$,
		      a,
		      b,
		      function(ok){
		       if(0 === ok[0]) return cont(ok);
		       var match = ok[1];
		       if(typeof match === "number") return cont(a$n);
		       var variant = match[1];
		       if(479410653 > variant) return cont(ok);
		       var msg = match[2];
		       return caml_exact_trampoline_cps_call
		               (notify_f$0(ctrl)(a$p),
		                a$o,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a, msg, function(match){return cont(a$q);});
		                });
		      });
		                                    }
		                                    if(d) return a([1, x$2]);
		                                    var
		                                     id = dest[1],
		                                     c =
		                                       Sequence_id[9].call
		(null,
		 id,
		 function(id, cont){
		  function f(id, cont){return cont([0, id, id]);}
		  return caml_exact_trampoline_cps_call$1
		          (parent,
		           ctrl,
		           id,
		           function(x){
		            return caml_trampoline_cps_call3(map$17, x, f, cont);
		           });
		 });
		                                    return caml_trampoline_cps_call2
		    (equal$104,
		     task_as_parent,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (Sequence_id[29],
		               c,
		               b,
		               function(b){
		                return is_some(b)
		                        ? a([1, x$3])
		                        : caml_trampoline_cps_call2(of_string$14, 0, a);
		               });
		     });
		                                   });
		                         });
		               }
		               function move$3(ctrl, crdt, task_id, dest, source, cont){
		                return caml_exact_trampoline_cps_call$12
		                        (move$2,
		                         function(task){
		                          var a = [0, task[6]], b = task[7][9][2];
		                          return [11, [0, is_some(task[7][2]), b, a]];
		                         },
		                         function(task_id){return [0, task_id];},
		                         get_task$0,
		                         schema$27,
		                         move$0,
		                         function(task){return task[7][6];},
		                         _16$0,
		                         function(task_id, dest_id, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (set_parent$0,
		                                   [0, dest_id],
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$23,
		     task_id,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call(tasks, a, cont);
		               });
		     });
		                                   });
		                         },
		                         ctrl,
		                         crdt,
		                         task_id,
		                         dest,
		                         source,
		                         cont);
		               }
		               function orphan(ctrl, crdt, task_id, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$r, _16$0, task_id, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(state){
		                                    function f(parent, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (remove_parent_block,
		      state,
		      parent,
		      task_id,
		      function(rm_op){
		       return caml_exact_trampoline_cps_call$4
		               (update$7,
		                0,
		                0,
		                aXQ,
		                0,
		                0,
		                0,
		                0,
		                0,
		                task_id,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (map$17,
		                          a,
		                          tasks,
		                          function(upd_op){
		                           return caml_exact_trampoline_cps_call
		                                   (filter_opt,
		                                    [0, rm_op, [0, upd_op, 0]],
		                                    function(ops){
		                                     return ops
		     ? caml_exact_trampoline_cps_call
		       (all_unit$27,
		        ops,
		        function(a){
		         return caml_trampoline_cps_call2(return$9, a, cont);
		        })
		     : cont(0);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    function f$0(task, cont){return cont(task[7][6]);}
		                                    return caml_exact_trampoline_cps_call$1
		    (get_task,
		     state,
		     task_id,
		     function(x){
		      return caml_trampoline_cps_call3
		              (bind$8,
		               x,
		               f$0,
		               function(x){
		                return caml_trampoline_cps_call3
		                        (bind$8,
		                         x,
		                         f,
		                         function(crdt_op){
		                          var b = ctrl[1];
		                          if(! crdt_op) return cont(0);
		                          var a = crdt_op[1];
		                          return caml_exact_trampoline_cps_call$0
		                                  (apply_personal, b, crdt, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function delete$1(ctrl, crdt, task_id, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$s, _16$0, task_id, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_task$0,
		                                   ctrl[2],
		                                   task_id,
		                                   function(a){
		                                    function b(proceed){
		                                     if(! proceed) return cont(proceed);
		                                     var time = ocaml_ptime_clock_now_d_ps();
		                                     return caml_exact_trampoline_cps_call
		     (state_personal,
		      ctrl[2],
		      function(state){
		       return caml_exact_trampoline_cps_call
		               (today,
		                dummy,
		                function(date){
		                 return caml_exact_trampoline_cps_call$2
		                         (remove_task,
		                          date,
		                          state,
		                          time,
		                          task_id,
		                          function(match){
		                           function a(crdt_op){
		                            var b = ctrl[1];
		                            if(! crdt_op) return cont(0);
		                            var a = crdt_op[1];
		                            return caml_exact_trampoline_cps_call$0
		                                    (apply_personal, b, crdt, a, cont);
		                           }
		                           if(! match) return a(0);
		                           var rm_task_op = match[1];
		                           function f(task, cont){
		                            function f(parent, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (remove_parent_block, state, parent, task_id, cont);
		                            }
		                            var x = task[7][6];
		                            return caml_trampoline_cps_call3
		                                    (bind$8,
		                                     x,
		                                     f,
		                                     function(rm_parent_block_op){
		                                      return caml_exact_trampoline_cps_call
		      (filter_opt,
		       [0, [0, rm_task_op], [0, rm_parent_block_op, 0]],
		       function(l){
		        return l
		                ? caml_exact_trampoline_cps_call
		                  (all_unit$27, l, function(a){return cont([0, a]);})
		                : cont(0);
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (get_task,
		                                    state,
		                                    task_id,
		                                    function(x){
		                                     return caml_trampoline_cps_call3(bind$8, x, f, a);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    if(! a) return b(1);
		                                    var task = a[1];
		                                    if(task[7][4])
		                                     return caml_exact_trampoline_cps_call
		     (Logs$14[6][3],
		      function(m, cont){
		       return caml_trampoline_cps_call4(m, 0, 0, a$t, cont);
		      },
		      function(match){return b(0);});
		                                    var
		                                     workspace_id = personal_workspace_id(ctrl[2]),
		                                     a = object$0(task$0(task[6]), workspace_id, source, 1);
		                                    return caml_exact_trampoline_cps_call$0
		    (push_dont_wait$0,
		     ctrl[11],
		     0,
		     a,
		     function(match){
		      return caml_exact_trampoline_cps_call
		              (text$3,
		               a9$,
		               function(d){
		                var a = [0, d, 0], c = task[7][9][2];
		                return caml_exact_trampoline_cps_call
		                        (highlight,
		                         a_a,
		                         function(d){
		                          return caml_trampoline_cps_call2
		                                  (d,
		                                   c,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$0
		    (notify$0(ctrl),
		     0,
		     0,
		     [0, c, a],
		     function(match){return b(1);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function upcoming(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a$u, cont);
		                         },
		                         function(a){
		                          a = ctrl[23][1];
		                          var
		                           week_start = a[6],
		                           today = a[5],
		                           tasks_by_scheduling = a[3],
		                           Inc = a[1],
		                           open =
		                             g
		                              ([0,
		                                Inc[72],
		                                Inc[73],
		                                ,
		                                Inc[75],
		                                Inc[76],
		                                Inc[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Inc[82]]),
		                           and = open[5],
		                           let$ = open[3],
		                           symbol_map = open[2];
		                          function b(param, cont){
		                           var week_start = param[2], today = param[1];
		                           function add(key, tasks, batches, cont){
		                            var
		                             open =
		                               g
		                                ([0,
		                                  symbol_bind$5,
		                                  symbol_map$5,
		                                  ,
		                                  bind$8,
		                                  return$9,
		                                  map$17,
		                                  ,
		                                  ,
		                                  ,
		                                  ,
		                                  Let_syntax$3]),
		                             let$ = open[3];
		                            function b(param, cont){
		                             var
		                              update = param[3],
		                              week = param[2],
		                              stale_after = param[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$82,
		                                      today,
		                                      stale_after,
		                                      function(a){
		                                       return a
		       ? cont(0)
		       : caml_exact_trampoline_cps_call$0
		         (update$0,
		          batches,
		          week,
		          function(param, cont){
		           if(! param)
		            return caml_trampoline_cps_call2(update, a8I, cont);
		           var v = param[1];
		           return caml_trampoline_cps_call2(update, v, cont);
		          },
		          function(a){return cont([0, a]);});
		                                      });
		                            }
		                            function a(a){
		                             return caml_trampoline_cps_call3
		                                     (let$, a, b, function(a){return cont(value$4(a, batches));});
		                            }
		                            if(typeof key !== "number" && 0 !== key[0]){
		                             var match = key[1];
		                             if(0 === match[0]){
		                              var
		                               week = match[1],
		                               c =
		                                 function(param, cont){
		                                  var n = param[2];
		                                  return cont([0, 1, n]);
		                                 };
		                              return caml_exact_trampoline_cps_call$1
		                                      (date_of_week,
		                                       week_start,
		                                       week,
		                                       function(b){
		return caml_exact_trampoline_cps_call$1
		        (add_days,
		         b,
		         6,
		         function(b){return a([0, [0, b, week, c]]);});
		                                       });
		                             }
		                             var date = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$82,
		                                      date,
		                                      today,
		                                      function(b){
		                                       if(b)
		var any_todo = b;
		                                       else {
		b = tasks;
		for(;;){
		 if(b){
		  var l = b[2], x = b[1];
		  if(! todo$0(x)){b = l; continue;}
		  b = [0, x];
		 }
		 else
		  b = 0;
		 any_todo = is_some(b);
		 break;
		}
		                                       }
		                                       if(! any_todo) return a(0);
		                                       function c(param, cont){
		var n = param[2], batch = param[1];
		return cont([0, batch, n + 1 | 0]);
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (week_of_date,
		        week_start,
		        date,
		        function(b){return a([0, [0, date, b, c]]);});
		                                      });
		                            }
		                            return a(0);
		                           }
		                           var init = empty$11([0, comparator$12]);
		                           function remove(key, param, batches, cont){
		                            if(typeof key !== "number" && 0 !== key[0]){
		                             var
		                              key$0 = key[1],
		                              a =
		                                function(week, f){
		                                 return caml_exact_trampoline_cps_call$0
		 (change$0,
		  batches,
		  week,
		  function(param, cont){
		   if(! param) return cont(0);
		   var v = param[1];
		   return cont(f(v));
		  },
		  cont);
		                                };
		                             if(0 === key$0[0]){
		                              var week = key$0[1];
		                              return a
		                                      (week,
		                                       function(param){
		if(0 === param[2]) return 0;
		var n = param[2];
		return [0, [0, 0, n]];
		                                       });
		                             }
		                             var
		                              date = key$0[1],
		                              f =
		                                function(param){
		                                 var batch = param[1];
		                                 if(! batch && 1 === param[2]) return 0;
		                                 var n = param[2];
		                                 return [0, [0, batch, n - 1 | 0]];
		                                };
		                             return caml_exact_trampoline_cps_call$1
		                                     (week_of_date,
		                                      week_start,
		                                      date,
		                                      function(week){return a(week, f);});
		                            }
		                            return cont(batches);
		                           }
		                           function update(b, a, param, v, cont){return cont(v);}
		                           return caml_exact_trampoline_cps_call$5
		                                   (unordered_fold$0,
		                                    0,
		                                    0,
		                                    [0, update],
		                                    0,
		                                    0,
		                                    0,
		                                    tasks_by_scheduling,
		                                    init,
		                                    add,
		                                    remove,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (keys$2,
		      0,
		      0,
		      a,
		      function(a){
		       return caml_trampoline_cps_call3
		               (symbol_map, a, to_list$3, cont);
		      });
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   today,
		                                   week_start,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     a,
		     b,
		     function(v){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$230,
		               v,
		               cst_upcoming,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function With_monad(M){
		                var open = g(M), let$ = open[14];
		                function update
		                (ctrl, crdt, task_id, patch, source, continue$, cont){
		                 return caml_exact_trampoline_cps_call
		                         (today,
		                          dummy,
		                          function(today){
		                           var now = ocaml_ptime_clock_now_d_ps();
		                           return caml_exact_trampoline_cps_call
		                                   (Logs$14[6][5],
		                                    function(m, cont){
		                                     return caml_exact_trampoline_cps_call
		     (attrs,
		      [0, attr$0(cst_patch, patch, schema$193), 0],
		      function(a){
		       return caml_trampoline_cps_call6
		               (m, 0, [0, a], a$v, _16$0, task_id, cont);
		      });
		                                    },
		                                    function(match){
		                                     function a(task, cont){
		                                      var match = patch[9][1];
		                                      function a(b){
		                                       if(is_empty$9(patch))
		return caml_trampoline_cps_call2
		        (of_string$14,
		         0,
		         function(a){
		          return caml_trampoline_cps_call2(M[5], a, cont);
		         });
		                                       function remove_event_op(id, cont){
		return caml_exact_trampoline_cps_call
		        (state_personal,
		         ctrl[2],
		         function(a){
		          return caml_exact_trampoline_cps_call$2
		                  (remove$24, today, a, now, id, cont);
		         });
		                                       }
		                                       var b = patch[2];
		                                       function a(ev_ops){
		function a(param, cont){
		 return caml_exact_trampoline_cps_call
		         (state_personal,
		          ctrl[2],
		          function(a){
		           return caml_exact_trampoline_cps_call$3
		                   (update_from_patch,
		                    today,
		                    a,
		                    now,
		                    patch,
		                    task_id,
		                    function(upd_tasks_op){
		                     if(upd_tasks_op)
		                      var x = upd_tasks_op[1], a = [0, x, ev_ops];
		                     else
		                      a = ev_ops;
		                     return caml_exact_trampoline_cps_call
		                             (all_unit$27,
		                              a,
		                              function(crdt_op){
		                               return caml_exact_trampoline_cps_call$0
		                                       (apply_personal,
		ctrl[1],
		crdt,
		crdt_op,
		function(a){
		 var
		  task$0 = task[7],
		  a = patch[9],
		  url = a[3],
		  title = a[2],
		  notes = a[1],
		  starred = patch[8],
		  scheduled = patch[7],
		  parent = patch[6],
		  occurrence = patch[5],
		  integration = patch[4],
		  extension_row = patch[3],
		  completed = patch[2],
		  archived = patch[1];
		 a:
		 {
		  if(completed && completed[1]){var default$ = 0; break a;}
		  default$ = task$0[1];
		 }
		 var archived$0 = value(archived, default$);
		 a:
		 {
		  if(archived && archived[1]){var default$0 = 0; break a;}
		  default$0 = task$0[2];
		 }
		 var
		  completed$0 = value(completed, default$0),
		  archived$1 =
		    archived$0 ? completed$0 ? 0 : archived$0 : archived$0,
		  a = value(url, task$0[9][3]),
		  b = value(title, task$0[9][2]),
		  a = [0, value(notes, task$0[9][1]), b, a],
		  b = value(starred, task$0[8]),
		  c = value(scheduled, task$0[7]),
		  d = value(parent, task$0[6]),
		  e = value(occurrence, task$0[5]),
		  f = value(integration, task$0[4]),
		  c =
		    [0,
		     archived$1,
		     completed$0,
		     value(extension_row, task$0[3]),
		     f,
		     e,
		     d,
		     c,
		     b,
		     a],
		  patched_task =
		    [0, task[1], task[2], task[3], task[4], task[5], task[6], c];
		 return caml_exact_trampoline_cps_call$3
		         (patch$4, ctrl, task, patched_task, patch, source, cont);
		});
		                              });
		                    });
		          });
		}
		return caml_trampoline_cps_call2
		        (continue$,
		         0,
		         function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                       }
		                                       if(b && b[1])
		return caml_exact_trampoline_cps_call
		        (state_personal,
		         ctrl[2],
		         function(b){
		          return caml_exact_trampoline_cps_call
		                  (encode,
		                   b[5],
		                   function(b){
		                    return caml_exact_trampoline_cps_call$1
		                            (filter,
		                             b,
		                             function(a, cont){
		                              a = a[9];
		                              var match = a[9];
		                              if(! match) return cont(0);
		                              var time = a[10], task_id$0 = match[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (to_time$1,
		                                       timezone_local,
		                                       today,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (start$2,
		         timezone_local,
		         time,
		         function(b){
		          return caml_exact_trampoline_cps_call$1
		                  (symbol$73,
		                   b,
		                   a,
		                   function(a){
		                    return a
		                            ? caml_exact_trampoline_cps_call$1
		                              (symbol$121, task_id, task_id$0, cont)
		                            : cont(a);
		                   });
		         });
		                                       });
		                             },
		                             function(match){
		                              if(! match) return a(0);
		                              var first = match[1], remaining = match[2];
		                              return caml_exact_trampoline_cps_call$1
		                                      (end$1,
		                                       timezone_local,
		                                       first[9][10],
		                                       function(b){
		return caml_exact_trampoline_cps_call$1
		        (symbol$75,
		         b,
		         now,
		         function(b){
		          if(b)
		           return caml_exact_trampoline_cps_call$3
		                   (completed_now_time,
		                    now,
		                    today,
		                    timezone_local,
		                    1,
		                    first,
		                    function(end_now_time){
		                     return caml_exact_trampoline_cps_call$10
		                             (update$2,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              end_now_time,
		                              0,
		                              0,
		                              dummy,
		                              function(b){
		                               return caml_trampoline_cps_call2
		                                       (element$3,
		first[6],
		function(c){
		 return caml_trampoline_cps_call2
		         (c,
		          b,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (events,
		                    b,
		                    function(b){
		                     return caml_exact_trampoline_cps_call
		                             (ignore_m$11,
		                              b,
		                              function(end_now_op){
		                               return caml_trampoline_cps_call3
		                                       (map$18,
		remaining,
		function(e, cont){
		 return caml_exact_trampoline_cps_call
		         (remove_event_op, e[6], cont);
		},
		function(b){return a([0, end_now_op, b]);});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          var remaining$0 = match[2];
		          return caml_trampoline_cps_call3
		                  (map$18,
		                   remaining$0,
		                   function(e, cont){
		                    return caml_exact_trampoline_cps_call
		                            (remove_event_op, e[6], cont);
		                   },
		                   a);
		         });
		                                       });
		                             });
		                   });
		         });
		                                       return a(0);
		                                      }
		                                      if(! match) return a(0);
		                                      var notes = match[1];
		                                      return caml_exact_trampoline_cps_call$2
		      (edited, ctrl, task$0(task_id), notes, source, a);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (state_personal,
		      ctrl[2],
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                b[24],
		                task_id,
		                function(match){
		                 function b(b){
		                  return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                 }
		                 if(! match)
		                  return caml_exact_trampoline_cps_call
		                          (fail_result,
		                           a$w,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (a,
		                                     _16$0,
		                                     task_id,
		                                     function(a){return caml_trampoline_cps_call2(M[5], a, b);});
		                           });
		                 var task = match[1];
		                 return caml_trampoline_cps_call2
		                         (of_string$14,
		                          task,
		                          function(a){return caml_trampoline_cps_call2(M[5], a, b);});
		                });
		      });
		                                    });
		                          });
		                }
		                return [0, update];
		               }
		               function update$13(ctrl, crdt, task_id, patch, source, cont){
		                var open = With_monad(include$0), update = open[1];
		                function a(param, f, cont){
		                 return caml_trampoline_cps_call2
		                         (f,
		                          0,
		                          function(a){
		                           return caml_trampoline_cps_call2(of_string$14, a, cont);
		                          });
		                }
		                return caml_trampoline_cps_call6
		                        (update,
		                         ctrl,
		                         crdt,
		                         task_id,
		                         patch,
		                         source,
		                         function(b){return caml_trampoline_cps_call2(b, a, cont);});
		               }
		               function update_with_modal
		               (ctrl, crdt, continue$, task_id, patch, source, cont){
		                var
		                 let$ =
		                   g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4])
		                    [14],
		                 open =
		                   With_monad
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 update = open[1];
		                function a(next_del_event, k, cont){
		                 function a(continue$, cont){
		                  return continue$
		                          ? caml_trampoline_cps_call2
		                            (k,
		                             0,
		                             function(a){
		                              return caml_trampoline_cps_call2(return$13, a, cont);
		                             })
		                          : caml_exact_trampoline_cps_call
		                            (Logs$14[3],
		                             function(m, cont){
		                              return caml_trampoline_cps_call4(m, 0, 0, a$x, cont);
		                             },
		                             cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (continue$,
		                          next_del_event,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                return caml_trampoline_cps_call6
		                        (update,
		                         ctrl,
		                         crdt,
		                         task_id,
		                         patch,
		                         source,
		                         function(b){return caml_trampoline_cps_call2(b, a, cont);});
		               }
		               function task_batch(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         ctrl[2],
		                         function(state){
		                          var a = state[5], b = state[21][7];
		                          return cont
		                                  (function(c, cont){
		                                    return caml_exact_trampoline_cps_call$0(bR$, b, a, c, cont);
		                                   });
		                         });
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               function create$48
		               (ctrl, crdt, document, opt, source, task_rec_writable, cont){
		                var notify = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call
		                        (Logs$12[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   document_schema,
		                                   function(a){
		                                    a = [0, attr$0(cst_document, document, a), 0];
		                                    return caml_exact_trampoline_cps_call
		    (attrs,
		     [0, attr$0(cst_task, task_rec_writable, Read$5[6]), a],
		     function(a){
		      return caml_trampoline_cps_call4(m, 0, [0, a], a$y, cont);
		     });
		                                   });
		                         },
		                         function(match){
		                          var created = ocaml_ptime_clock_now_d_ps();
		                          function f(document, cont){return cont(document[1]);}
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   document,
		                                   f,
		                                   function(parent){
		                                    if(parent)
		                                     var
		                                      parent$0 = parent[1],
		                                      task_rec_writable$0 =
		[0,
		 [0, parent$0],
		 task_rec_writable[2],
		 task_rec_writable[3]];
		                                    else
		                                     task_rec_writable$0 = task_rec_writable;
		                                    return caml_exact_trampoline_cps_call
		    (state_personal,
		     ctrl[2],
		     function(state){
		      var
		       cascade = [0, state],
		       open =
		         g
		          ([0,
		            symbol_bind$22,
		            symbol_map$20,
		            ,
		            bind$30,
		            return$39,
		            map$50,
		            ,
		            ,
		            ,
		            ,
		            Let_syntax$14]),
		       let$ = open[3],
		       notes = task_rec_writable$0[3][1];
		      function a(a, cont){
		       var
		        task_rec_ids = a[3],
		        task_ids = a[2],
		        notes = a[1],
		        a = task_rec_writable$0[3],
		        templatable = [0, notes, a[2], a[3]];
		       function b(main_task_rec_id, cont){
		        function f(parent, cont){
		         function f(state, cont){
		          return caml_exact_trampoline_cps_call$3
		                  (append_parent_block$0,
		                   state,
		                   task_rec_writable$0[2],
		                   parent,
		                   task_rec_writable$0[3][2],
		                   main_task_rec_id,
		                   cont);
		         }
		         var x = to_option$6(cascade);
		         return caml_trampoline_cps_call3(bind$8, x, f, cont);
		        }
		        var x = task_rec_writable$0[1];
		        return caml_trampoline_cps_call3
		                (bind$8,
		                 x,
		                 f,
		                 function(parent_block_op){
		                  function b(param, cont){
		                   return caml_trampoline_cps_call2
		                           (return$39,
		                            [0, main_task_rec_id, task_ids, task_rec_ids],
		                            cont);
		                  }
		                  function a(op){
		                   return caml_trampoline_cps_call3(let$, op, b, cont);
		                  }
		                  if(! parent_block_op)
		                   return caml_trampoline_cps_call2(return$39, 0, a);
		                  var op = parent_block_op[1];
		                  return a(op);
		                 });
		       }
		       return caml_exact_trampoline_cps_call$2
		               (add_main_recurrent_task_from_w,
		                0,
		                cascade,
		                created,
		                [0,
		                 task_rec_writable$0[1],
		                 task_rec_writable$0[2],
		                 templatable],
		                function(a){
		                 return caml_trampoline_cps_call3(let$, a, b, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$0
		              (add_referenced_subtasks,
		               created,
		               task_rec_writable$0[1],
		               notes,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         b,
		                         a,
		                         function(add_task_rec_op){
		                          var
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$22,
		                                symbol_map$20,
		                                ,
		                                bind$30,
		                                return$39,
		                                map$50,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$14]),
		                           let$ = open[4];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   add_task_rec_op,
		                                   function(param, cont){
		                                    var task_rec_id = param[1];
		                                    return caml_trampoline_cps_call3
		    (map$17,
		     document,
		     function(doc, cont){return cont(doc[1]);},
		     function(a){return cont([0, task_rec_id, a]);});
		                                   },
		                                   function(crdt_op){
		                                    return caml_exact_trampoline_cps_call$0
		    (apply_personal,
		     ctrl[1],
		     crdt,
		     crdt_op,
		     function(match){
		      var task_rec_id = match[1];
		      function a(a){return cont(task_rec_id);}
		      return notify
		              ? caml_exact_trampoline_cps_call$1
		                (get_task_recurrent$0,
		                 ctrl[2],
		                 task_rec_id,
		                 function(match){
		                  if(! match) return a();
		                  var task_rec = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (to_string$47,
		                           0,
		                           task_rec[5][2],
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (highlight,
		                                     a9R,
		                                     function(c){
		                                      return caml_trampoline_cps_call2
		      (c,
		       b,
		       function(c){
		        var b = [0, c, 0];
		        return caml_exact_trampoline_cps_call
		                (text$3,
		                 a9S,
		                 function(c){
		                  return caml_exact_trampoline_cps_call$0
		                          (notify$0(ctrl),
		                           0,
		                           0,
		                           [0, [7, task_rec], [0, c, b]],
		                           function(b){
		                            var id = task_rec[4];
		                            return caml_exact_trampoline_cps_call$2
		                                    (push$1, ctrl, [5, id], source, 0, a);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 })
		              : a();
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function delete$2(ctrl, crdt, task_rec_id, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$12[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$z, pp$72, task_rec_id, cont);
		                         },
		                         function(match){
		                          var time = ocaml_ptime_clock_now_d_ps();
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(state){
		                                    return caml_exact_trampoline_cps_call
		    (today,
		     dummy,
		     function(date){
		      return caml_exact_trampoline_cps_call$2
		              (remove_recurrent_task,
		               date,
		               state,
		               time,
		               task_rec_id,
		               function(match){
		                function a(op){
		                 var b = ctrl[1];
		                 if(! op) return cont(0);
		                 var a = op[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (apply_personal, b, crdt, a, cont);
		                }
		                if(! match) return a(0);
		                var rm_task_op = match[1];
		                function f(task, cont){
		                 function f(parent, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (remove_parent_block$0, state, parent, task_rec_id, cont);
		                 }
		                 var x = task[5][1];
		                 return caml_trampoline_cps_call3(bind$8, x, f, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_task_recurrent,
		                         state,
		                         task_rec_id,
		                         function(x){
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   x,
		                                   f,
		                                   function(rm_parent_block_op){
		                                    return caml_exact_trampoline_cps_call
		    (filter_opt,
		     [0, [0, rm_task_op], [0, rm_parent_block_op, 0]],
		     function(l){
		      return l
		              ? caml_exact_trampoline_cps_call
		                (all_unit$27, l, function(b){return a([0, b]);})
		              : a(0);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update$14(ctrl, crdt, id, patch, source, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                return caml_exact_trampoline_cps_call
		                        (Logs$12[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_patch, patch, schema$69), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, a], a$A, pp$72, id, cont);
		                                   });
		                         },
		                         function(match){
		                          function a(recurrent_task, cont){
		                           var t = ocaml_ptime_clock_now_d_ps();
		                           return caml_exact_trampoline_cps_call
		                                   (state_personal,
		                                    ctrl[2],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (today,
		      dummy,
		      function(b){
		       return caml_exact_trampoline_cps_call$3
		               (update_from_patch$2,
		                b,
		                a,
		                t,
		                patch,
		                id,
		                function(op){
		                 function b(a){
		                  a:
		                  {
		                   if(! patch[1] && ! patch[2]){
		                    a = patch[3];
		                    if(! a[1] && ! a[2] && ! a[3]){a = 1; break a;}
		                   }
		                   a = 0;
		                  }
		                  function b(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (get_task_recurrent$0,
		                            ctrl[2],
		                            id,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$2
		                                     (value_exn, a$B, 0, 0, a, cont);
		                            });
		                  }
		                  if(a) return b();
		                  a = patch[2];
		                  if(! a) return b();
		                  var new_recurrence = a[1], a = new_recurrence[1];
		                  function c(){
		                   return caml_exact_trampoline_cps_call$2
		                           (push$4,
		                            ctrl,
		                            recurrent_task[4],
		                            source,
		                            a_N,
		                            function(match){
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_string$47,
		                                      0,
		                                      new_recurrence,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (highlight,
		        a_O,
		        function(c){
		         return caml_trampoline_cps_call2
		                 (c,
		                  a,
		                  function(c){
		                   var a = [0, c, 0];
		                   return caml_exact_trampoline_cps_call
		                           (text$3,
		                            a_P,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$0
		                                     (notify$0(ctrl),
		                                      0,
		                                      0,
		                                      [0, [7, recurrent_task], [0, c, a]],
		                                      b);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  }
		                  if(0 === a[0]) return c();
		                  a = a[1];
		                  if(! a) return c();
		                  var end = a[1];
		                  return caml_exact_trampoline_cps_call
		                          (today,
		                           dummy,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$80,
		                                     end,
		                                     a,
		                                     function(a){
		                                      return a
		      ? caml_exact_trampoline_cps_call$2
		        (push$4,
		         ctrl,
		         recurrent_task[4],
		         source,
		         a_Q,
		         function(match){
		          return caml_exact_trampoline_cps_call
		                  (text$3,
		                   a_R,
		                   function(a){
		                    return caml_exact_trampoline_cps_call$0
		                            (notify$0(ctrl),
		                             0,
		                             0,
		                             [0, [7, recurrent_task], [0, a, 0]],
		                             b);
		                   });
		         })
		      : c();
		                                     });
		                           });
		                 }
		                 var c = ctrl[1];
		                 if(! op) return b(0);
		                 var a = op[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (apply_personal, c, crdt, a, b);
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_task_recurrent$0,
		                                   ctrl[2],
		                                   id,
		                                   function(match){
		                                    function b(b){
		                                     return caml_trampoline_cps_call3(let$, b, a, cont);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fail_result,
		      a$C,
		      function(a){
		       return caml_trampoline_cps_call3(a, pp$72, id, b);
		      });
		                                    var task_rec = match[1];
		                                    return caml_trampoline_cps_call2(of_string$14, task_rec, b);
		                                   });
		                         });
		               }
		               function move$4(ctrl, crdt, task_rec_id, dest, source, cont){
		                return caml_exact_trampoline_cps_call$12
		                        (move$2,
		                         function(task_rec){
		                          return [10,
		                                  [0, [0, task_rec[4]], task_rec[5][3][2], task_rec[5][2]]];
		                         },
		                         function(task_id){return [1, task_id];},
		                         get_task_recurrent$0,
		                         schema$70,
		                         move$1,
		                         function(task){return task[5][1];},
		                         pp$72,
		                         function(task_id, dest_id, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (set_parent$1,
		                                   [0, dest_id],
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$17,
		     task_id,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call(recurrences, a, cont);
		               });
		     });
		                                   });
		                         },
		                         ctrl,
		                         crdt,
		                         task_rec_id,
		                         dest,
		                         source,
		                         cont);
		               }
		               function all$29(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$12[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a$D, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (read$1(ctrl),
		                                   function(param, cont){
		                                    var tasks_recurrent = param[2][40];
		                                    return caml_exact_trampoline_cps_call$2
		    (filter_map$5,
		     0,
		     [0, equal$108],
		     tasks_recurrent,
		     function(task_recurrent, cont){
		      return task_recurrent[2]
		              ? cont(0)
		              : cont([0, task_recurrent]);
		     },
		     function(a){
		      return caml_exact_trampoline_cps_call$7
		              (index_by$0,
		               0,
		               0,
		               [0, equal$108],
		               a,
		               [0, comparator$59],
		               function(tr, cont){return cont([0, tr[5][2][2]]);},
		               function(a){
		                return caml_exact_trampoline_cps_call$2
		                        (mapi$5,
		                         0,
		                         0,
		                         a,
		                         function(frequency, data, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   data,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (stable_sort,
		     a,
		     function(left, right, cont){
		      var y = right[5][3][2], x = left[5][3][2];
		      return cont(caml_string_compare(x, y));
		     },
		     function(a){
		      return caml_trampoline_cps_call3
		              (map$18,
		               a,
		               function(task, cont){return cont(task[4]);},
		               function(bucket){return cont([0, frequency, bucket]);});
		     });
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$41,
		                                   a,
		                                   encode,
		                                   function(result){
		                                    function a(t1, t2, cont){
		                                     function a(t1$0, t2$0){
		                                      if(t1$0){
		                                       if(t2$0){
		var
		 t2 = t2$0[2],
		 rhs = t2$0[1],
		 t1 = t1$0[2],
		 lhs = t1$0[1];
		return caml_trampoline_cps_call3
		        (letrec_function_context$811[2],
		         lhs[1],
		         rhs[1],
		         function(d){
		          function b(b){
		           return b ? caml_exact_trampoline_call2(a, t1, t2) : cont(b);
		          }
		          if(! d) return b(d);
		          var y = rhs[2], x = lhs[2];
		          function c(x$0, y$0){
		           if(x$0){
		            if(y$0){
		             var y = y$0[2], b$0 = y$0[1], x = x$0[2], a = x$0[1];
		             return caml_trampoline_cps_call3
		                     (letrec_function_context$811[1],
		                      a,
		                      b$0,
		                      function(a){
		                       return a ? caml_exact_trampoline_call2(c, x, y) : b(a);
		                      });
		            }
		           }
		           else if(! y$0) return b(1);
		           return b(0);
		          }
		          return c(x, y);
		         });
		                                       }
		                                      }
		                                      else if(! t2$0) return cont(1);
		                                      return cont(0);
		                                     }
		                                     return a(t1, t2);
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$169,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$230,
		               result,
		               b,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, symbol$229(b, a), cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   },
		                                   cont);
		                         });
		               }
		               var Logs$15 = with_tag$0(component$0, "Controller.Calendars");
		               function to_connection(ctrl, calendar_id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                function a(calendar, cont){
		                 return caml_exact_trampoline_cps_call
		                         (state_personal,
		                          ctrl[2],
		                          function(state){
		                           var connection = of_google_email(calendar[2]);
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id, state[3], connection, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_calendar$0,
		                         ctrl[2],
		                         calendar_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(conn){
		                                    if(! conn)
		                                     return caml_exact_trampoline_cps_call$1
		     (fatal$0,
		      a$F,
		      a$E,
		      function(a){
		       return caml_trampoline_cps_call3(a, pp$2, calendar_id, cont);
		      });
		                                    var conn$0 = conn[1];
		                                    return cont(conn$0);
		                                   });
		                         });
		               }
		               function add_self_to_attendees
		               (ctrl, calendar, previous_attendees, attendees, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_connection,
		                         ctrl,
		                         calendar,
		                         function(connection){
		                          return caml_exact_trampoline_cps_call
		                                  (attend_events_as,
		                                   connection,
		                                   function(self_attendee){
		                                    return caml_exact_trampoline_cps_call
		    (is_empty$5,
		     previous_attendees,
		     function(match){
		      function a(){return cont(attendees);}
		      if(! match) return a();
		      if(! attendees) return a();
		      var attendees$0 = attendees[1];
		      return caml_exact_trampoline_cps_call
		              (is_empty$5,
		               attendees$0,
		               function(b){
		                return b
		                        ? a()
		                        : caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           attendees$0,
		                           self_attendee[1],
		                           self_attendee,
		                           function(a){return cont([0, a]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function get$23(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$15[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$G, pp$2, id, cont);
		                         },
		                         function(match){
		                          var values = ctrl[9][5], lookup = values[1][2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   lookup,
		                                   id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function default$13(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$15[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a$H, cont);
		                         },
		                         function(a){
		                          a = ctrl[9];
		                          var
		                           values = a[5],
		                           incremental = a[1],
		                           calendars = values[1],
		                           open =
		                             g
		                              ([0,
		                                incremental[72],
		                                incremental[73],
		                                ,
		                                incremental[75],
		                                incremental[76],
		                                incremental[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                incremental[82]]),
		                           let$ = open[4];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   calendars[1],
		                                   function(calendars, cont){
		                                    return caml_exact_trampoline_cps_call$2
		    (to_sequence$2,
		     0,
		     0,
		     0,
		     calendars,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (find_map,
		               a,
		               function(param, cont){
		                var calendar = param[2];
		                return calendar[6] ? cont(0) : cont([0, calendar]);
		               },
		               cont);
		     });
		                                   },
		                                   function(default$){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental,
		     0,
		     symbol$229
		      (default$,
		       function(a, b, cont){
		        return caml_exact_trampoline_cps_call$0
		                (equal_option, equal$123, a, b, cont);
		       }),
		     cont);
		                                   });
		                         });
		               }
		               function all$30(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$15[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, a$I, cont);
		                         },
		                         function(a){
		                          a = ctrl[9];
		                          var
		                           values = a[5],
		                           incremental = a[1],
		                           calendars = values[1],
		                           open =
		                             g
		                              ([0,
		                                incremental[72],
		                                incremental[73],
		                                ,
		                                incremental[75],
		                                incremental[76],
		                                incremental[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                incremental[82]]),
		                           let$ = open[4];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   calendars[1],
		                                   function(calendars, cont){
		                                    return caml_exact_trampoline_cps_call
		    (encode, calendars, cont);
		                                   },
		                                   function(calendars){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental,
		     0,
		     symbol$229
		      (calendars,
		       function(x, y, cont){
		        return caml_exact_trampoline_cps_call$0
		                (equal_with_local_closure, equal$123, x, y, cont);
		       }),
		     cont);
		                                   });
		                         });
		               }
		               function apply_patch(ctrl, crdt, patch$1, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (state_personal,
		                          ctrl[2],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (update_from_patch$3,
		                                    patch$1,
		                                    a[21],
		                                    function(settings_op){
		                                     return caml_exact_trampoline_cps_call$0
		     (apply_personal, ctrl[1], crdt, settings_op, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         ctrl[2],
		                         function(b){
		                          var
		                           settings = b[21],
		                           calendars = patch$1[2],
		                           access_restrictions = patch$1[1];
		                          function f(b, a, cont){
		                           var variant = a[1];
		                           if(737457313 === variant){
		                            a = a[2];
		                            var patch$0 = a[2], settings = a[1];
		                            return cont([0, patch(settings, patch$0)]);
		                           }
		                           if(847852583 <= variant){
		                            var settings$0 = a[2];
		                            return cont([0, settings$0]);
		                           }
		                           var patch$1 = a[2];
		                           return cont([0, patch(empty$3, patch$1)]);
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (merge$4,
		                                   settings[1],
		                                   access_restrictions,
		                                   f,
		                                   function(access_restrictions){
		                                    return caml_exact_trampoline_cps_call
		    (normalize_calendars_patch,
		     calendars,
		     function(match){
		      var calendars = match[2], default$ = match[1];
		      function f(key, a, cont){
		       var variant = a[1];
		       if(737457313 === variant){
		        a = a[2];
		        var b = a[2], settings = a[1];
		        if(b){
		         var patch = b[1];
		         return cont([0, patch$0(settings, patch)]);
		        }
		        if(! settings[3] && ! default$)
		         return caml_exact_trampoline_cps_call
		                 (warn$0,
		                  function(m, cont){
		                   return caml_trampoline_cps_call6
		                           (m, 0, 0, $G, pp$2, key, cont);
		                  },
		                  function(match){
		                   return cont([0, [0, settings[1], 0, settings[3]]]);
		                  });
		        return cont(0);
		       }
		       if(847852583 <= variant){
		        var settings$0 = a[2];
		        if(! settings$0[3] && default$)
		         return cont([0, [0, settings$0[1], settings$0[2], 1]]);
		        return cont([0, settings$0]);
		       }
		       b = a[2];
		       if(! b) return cont(0);
		       var patch$1 = b[1];
		       return cont([0, patch$0($H, patch$1)]);
		      }
		      return caml_exact_trampoline_cps_call$0
		              (merge$4,
		               settings[2],
		               calendars,
		               f,
		               function(calendars){
		                var
		                 state = ctrl[2],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$0 = open[3];
		                return caml_exact_trampoline_cps_call$1
		                        (count$0,
		                         calendars,
		                         function(param, cont){
		                          var role = param[3];
		                          return caml_exact_trampoline_cps_call$1
		                                  (equal$121, role, 0, cont);
		                         },
		                         function(nb_default){
		                          function b(param, cont){
		                           function a(id, cal, prev, cont){
		                            return caml_trampoline_cps_call3
		                                    (let$0,
		                                     prev,
		                                     function(param, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (equal$121,
		       cal[3],
		       0,
		       function(b){
		        if(! b)
		         return caml_trampoline_cps_call2(of_string$14, 0, cont);
		        function a(param, cont){
		         return cal[2]
		                 ? cont([1, x$4])
		                 : caml_trampoline_cps_call2(of_string$14, 0, cont);
		        }
		        return caml_exact_trampoline_cps_call$1
		                (check_writable,
		                 state,
		                 id,
		                 function(b){
		                  return caml_trampoline_cps_call3(let$0, b, a, cont);
		                 });
		       });
		                                     },
		                                     cont);
		                           }
		                           return caml_trampoline_cps_call2
		                                   (of_string$14,
		                                    0,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$0
		     (fold$5, calendars, b, a, cont);
		                                    });
		                          }
		                          var
		                           c =
		                             0 === nb_default
		                              ? [1, x$5]
		                              : 1 === nb_default ? a$J : [1, x$6];
		                          return caml_trampoline_cps_call3
		                                  (let$0,
		                                   c,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function refresh$1(ctrl, crdt, account, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$15[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$K, pp$43, account, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (calendars_state,
		                                   a$L,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (google,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2
		              (element$2,
		               of_google_email(account),
		               function(b){
		                return caml_trampoline_cps_call2
		                        (b,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (connections,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (apply_personal, ctrl[1], crdt, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function select(ctrl, crdt, id$0, patch, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$15[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_patch, patch, schema$81), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, a], a$M, pp$2, id$0, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_calendar$0,
		                                   ctrl[2],
		                                   id$0,
		                                   function(o){
		                                    function a(a){
		                                     return caml_exact_trampoline_cps_call$9
		     (make$45,
		      0,
		      [0, singleton$3([0, comparator$2], id$0)([0, patch])],
		      0,
		      0,
		      0,
		      0,
		      0,
		      dummy,
		      function(patch){
		       return caml_exact_trampoline_cps_call$0
		               (apply_patch,
		                ctrl,
		                crdt,
		                patch,
		                function(a){
		                 return caml_trampoline_cps_call2(return$12, a, cont);
		                });
		      });
		                                    }
		                                    if(! o) return a();
		                                    var calendar = o[1], b = patch[2], match = patch[3];
		                                    if(match){
		                                     var
		                                      role = match[1],
		                                      c = to_string$52(role),
		                                      d = to_string$52(calendar[6]);
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$170,
		      function(b){
		       return caml_trampoline_cps_call3
		               (b,
		                pp$2,
		                id$0,
		                function(b){
		                 var x = [0, make_edit(b, d, c)];
		                 return caml_exact_trampoline_cps_call$0
		                         (push_dont_wait$0, ctrl[11], 0, [14, x], a);
		                });
		      });
		                                    }
		                                    if(! b) return a();
		                                    var disabled = b[1];
		                                    return caml_exact_trampoline_cps_call
		    (string_of_bool,
		     disabled,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (string_of_bool,
		               calendar[3],
		               function(c){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$171,
		                         function(d){
		                          return caml_trampoline_cps_call3
		                                  (d,
		                                   pp$2,
		                                   id$0,
		                                   function(d){
		                                    var x = [0, make_edit(d, c, b)];
		                                    return caml_exact_trampoline_cps_call$0
		    (push_dont_wait$0, ctrl[11], 0, [14, x], a);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function set_default(ctrl, crdt, id$0, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$15[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$N, pp$2, id$0, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(state){
		                                    var
		                                     open =
		                                       o
		([0,
		  symbol_bind$4,
		  symbol_map$4,
		  Let_syntax$2,
		  ,
		  bind$6,
		  of_string$14,
		  map$15]),
		                                     let$ = open[3];
		                                    function a(param, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      state[2],
		      id$0,
		      function(o){
		       function a(a){
		        return caml_exact_trampoline_cps_call$1
		                (filter_mapi$1,
		                 state[21][2],
		                 function(key, param, cont){
		                  var role = param[3];
		                  g
		                   ([0,
		                     symbol_bind$5,
		                     symbol_map$5,
		                     ,
		                     bind$8,
		                     return$9,
		                     map$17,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$3]);
		                  function a(){return cont(0);}
		                  return id$0 === key
		                          ? a()
		                          : caml_exact_trampoline_cps_call$1
		                            (equal$121,
		                             role,
		                             0,
		                             function(b){
		                              return b ? cont([0, [0, make$44(0, 0, a$O)]]) : a();
		                             });
		                 },
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           a,
		                           id$0,
		                           [0, make$44(0, a$Q, a$P)],
		                           function(calendars){
		                            return caml_exact_trampoline_cps_call$9
		                                    (make$45,
		                                     0,
		                                     [0, calendars],
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     dummy,
		                                     function(patch){
		                                      return caml_exact_trampoline_cps_call$0
		      (apply_patch, ctrl, crdt, patch, cont);
		                                     });
		                           });
		                 });
		       }
		       if(! o) return a();
		       var
		        calendar = o[1],
		        b = to_string$52(0),
		        c = to_string$52(calendar[6]);
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$172,
		                function(d){
		                 return caml_trampoline_cps_call3
		                         (d,
		                          pp$2,
		                          id$0,
		                          function(d){
		                           var x = [0, make_edit(d, c, b)];
		                           return caml_exact_trampoline_cps_call$0
		                                   (push_dont_wait$0, ctrl[11], 0, [14, x], a);
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (check_writable,
		     ctrl[2],
		     id$0,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function ai_state(ctrl, workspace, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(state, cont){return cont(state[1]);}
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               function compare$176(a, param, cont){
		                var
		                 right_id = param[2],
		                 right_time = param[1],
		                 left_id = a[2],
		                 left_time = a[1];
		                return caml_trampoline_cps_call3
		                        (compare$37,
		                         right_time,
		                         left_time,
		                         function(comparison){
		                          return 0 === comparison
		                                  ? caml_exact_trampoline_cps_call$1
		                                    (compare$114, right_id, left_id, cont)
		                                  : cont(comparison);
		                         });
		               }
		               function sexp_of_t$144(param, cont){
		                var id = param[2], time = param[1];
		                return caml_exact_trampoline_cps_call
		                        (to_string$54,
		                         id,
		                         function(b){
		                          var a = [0, [0, b], 0];
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_rfc3339$0,
		                                   0,
		                                   time,
		                                   function(b){return cont([1, [0, [0, b], a]]);});
		                         });
		               }
		               var
		                include$287 = Make$2([0, compare$176, sexp_of_t$144]),
		                comparator$64 = include$287[16];
		               function get_conversation(ctrl, workspace, conversation, cont){
		                var values = ctrl[9][5];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         values[42][4][2],
		                         [0, workspace, conversation],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, a, cont);
		                         });
		               }
		               function all_conversations(ctrl, workspace, agent, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function a(conversation_order, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_list$3,
		                          conversation_order,
		                          function(a){
		                           return caml_trampoline_cps_call3(map$18, a, get_data, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (filter_mapi$2,
		                         0,
		                         [0, equal$166],
		                         values[42][4][1],
		                         function(param, data, cont){
		                          var workspace$0 = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139,
		                                   workspace,
		                                   workspace$0,
		                                   function(b){
		                                    function a(a){return cont(some_if(a, data));}
		                                    if(! b) return a(b);
		                                    var t = data[1];
		                                    if(! t) return a(0);
		                                    var conversation_agent = t[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (equal$56, conversation_agent, agent, a);
		                                   });
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$3
		                                  (rekey,
		                                   0,
		                                   [0, equal$166],
		                                   b,
		                                   [0, comparator$64],
		                                   function(param, data){
		                                    var conversation_id = param[2];
		                                    return [0, data[9], conversation_id];
		                                   },
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$0
		    (keys$2,
		     0,
		     0,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(conversation_ids){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, conversation_ids, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function get_conversation_summary
		               (ctrl, workspace, conversation, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[11];
		                function a(conversation, cont){
		                 return cont
		                         ([0, conversation[4], conversation[8], conversation[9]]);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         values[42][4][2],
		                         [0, workspace, conversation],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(summary){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental,
		     0,
		     symbol$229
		      (summary,
		       function(t, t$0, cont){
		        if(t){
		         if(t$0){
		          var rhs = t$0[1], lhs = t[1];
		          return caml_trampoline_cps_call3
		                  (letrec_function_context$841[2],
		                   lhs[1],
		                   rhs[1],
		                   function(c){
		                    a:
		                    if(c){
		                     var y = rhs[2], x = lhs[2];
		                     if(x){
		                      if(y){var b = y[1], a = x[1], c = a === b ? 1 : 0; break a;}
		                     }
		                     else if(! y){c = 1; break a;}
		                     c = 0;
		                    }
		                    return c
		                            ? caml_trampoline_cps_call3
		                              (letrec_function_context$841[1], lhs[3], rhs[3], cont)
		                            : cont(c);
		                   });
		         }
		        }
		        else if(! t$0) return cont(1);
		        return cont(0);
		       }),
		     cont);
		                                   });
		                         });
		               }
		               function create_conversation
		               (ctrl, crdt, workspace, agent, cont){
		                var
		                 open = g(include$0),
		                 let$ = open[17],
		                 let$0 = open[14],
		                 conversation_id = make$51(),
		                 touched_last = ocaml_ptime_clock_now_d_ps(),
		                 agent_id = [0, agent],
		                 history = opt$12[1],
		                 new_conversation =
		                   [0,
		                    agent_id,
		                    default$,
		                    history,
		                    conversation_id,
		                    0,
		                    0,
		                    0,
		                    0,
		                    touched_last];
		                function a(state, cont){
		                 function a(operation, cont){
		                  function a(param, cont){return cont(conversation_id);}
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           workspace,
		                           operation,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (add$34,
		                          state,
		                          agent,
		                          new_conversation,
		                          function(t){
		                           var b = 0 === t[0] ? t : [1, a$R];
		                           return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$0, of_option(b, a$S), a, cont);
		                         });
		               }
		               function update_conversation_context
		               (ctrl, crdt, workspace, conversation_id, new_context, cont){
		                var open = g(include$0), let$ = open[17], let$0 = open[14];
		                function a(state, cont){
		                 function a(operation, cont){
		                  function a(param, cont){return cont(0);}
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           workspace,
		                           operation,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (update_context,
		                          state,
		                          conversation_id,
		                          new_context,
		                          function(t){
		                           var b = 0 === t[0] ? t : [1, a$T];
		                           return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$0, of_option(b, a$U), a, cont);
		                         });
		               }
		               function delete_conversation
		               (ctrl, crdt, workspace, conversation_id, cont){
		                var open = g(include$0), let$ = open[14];
		                function a(state, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (remove_cascading$0,
		                          0,
		                          state,
		                          conversation_id,
		                          function(match){
		                           if(! match)
		                            return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                           var operation = match[1];
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply$125, ctrl[1], crdt, workspace, operation, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$, of_option(b, [0, 847566860, workspace]), a, cont);
		                         });
		               }
		               caml_callback
		                (of_list$2,
		                 [[0, comparator$2],
		                  [0, cst_routine$0, [0, cst_extension_row, 0]]]);
		               create$18(0, "graph_storage");
		               function relation_targets
		               (ctrl, workspace, workspace_databases, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (equal$61,
		                         personal_workspace_id(ctrl[2]),
		                         workspace,
		                         function(is_default_workspace){
		                          function a(d){
		                           var
		                            a = make$39(),
		                            c =
		                              make$38(0, of_utf8_string("\xf0\x9f\xa7\x94"), 0, 0, 0, 0),
		                            b = [0, empty$23];
		                           return caml_exact_trampoline_cps_call
		                                   (Table[28],
		                                    cst_members,
		                                    function(e){
		                                     var
		                                      builtin_targets =
		symbol
		 ([0,
		   [0,
		    0,
		    [0,
		     e,
		     cst_members,
		     cst_Member,
		     "The builtin workspace member type",
		     c,
		     b,
		     a,
		     4,
		     workspace]],
		   0],
		  d);
		                                     return caml_exact_trampoline_cps_call$1
		     (map$0,
		      function(param, cont){
		       var database = param[2], target = param[1];
		       return cont
		               ([0, target, database[2], database[3], database[5]]);
		      },
		      builtin_targets,
		      function(builtin_entries){
		       return caml_exact_trampoline_cps_call$1
		               (Table[27][56],
		                0,
		                workspace_databases,
		                function(a){
		                 var
		                  custom_entries =
		                    filter_map
		                     (function(param){
		                       var database = param[2];
		                       return 4 <= database[8] ? 0 : [0, [1, database]];
		                      },
		                      a);
		                 return cont(symbol(builtin_entries, custom_entries));
		                });
		      });
		                                    });
		                          }
		                          if(! is_default_workspace) return a(0);
		                          var
		                           b = make$39(),
		                           d =
		                             make$38(0, of_utf8_string("\xf0\x9f\x94\xb2"), 0, 0, 0, 0),
		                           c = [0, empty$23];
		                          return caml_exact_trampoline_cps_call
		                                  (Table[28],
		                                   cst_tasks,
		                                   function(i){
		                                    var
		                                     e = make$39(),
		                                     g =
		                                       make$38(0, of_utf8_string("\xf0\x9f\x93\x84"), 0, 0, 0, 0),
		                                     h =
		                                       [0,
		[0,
		 2,
		 [0,
		  i,
		  cst_tasks,
		  cst_Task,
		  "The builtin task type",
		  d,
		  c,
		  b,
		  4,
		  workspace]],
		0],
		                                     f = [0, empty$23];
		                                    return caml_exact_trampoline_cps_call
		    (Table[28],
		     cst_pages,
		     function(j){
		      var
		       b = make$39(),
		       d =
		         make$38(0, of_utf8_string("\xf0\x9f\x93\x85"), 0, 0, 0, 0),
		       i =
		         [0,
		          [0,
		           1,
		           [0,
		            j,
		            cst_pages,
		            cst_Page,
		            "The builtin page type",
		            g,
		            f,
		            e,
		            4,
		            workspace]],
		          h],
		       c = [0, empty$23];
		      return caml_exact_trampoline_cps_call
		              (Table[28],
		               cst_events,
		               function(j){
		                var
		                 e = make$39(),
		                 g =
		                   make$38(0, of_utf8_string("\xf0\x9f\xa7\x91"), 0, 0, 0, 0),
		                 h =
		                   [0,
		                    [0,
		                     3,
		                     [0,
		                      j,
		                      cst_events,
		                      cst_Event,
		                      "The builtin event type",
		                      d,
		                      c,
		                      b,
		                      4,
		                      workspace]],
		                    i],
		                 f = [0, empty$23];
		                return caml_exact_trampoline_cps_call
		                        (Table[28],
		                         cst_people,
		                         function(b){
		                          return a
		                                  ([0,
		                                    [0,
		                                     4,
		                                     [0,
		                                      b,
		                                      cst_people,
		                                      cst_Person,
		                                      "The builtin people type",
		                                      g,
		                                      f,
		                                      e,
		                                      4,
		                                      workspace]],
		                                    h]);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function get$24(param){}
		               function augment$4(ctrl, incremental, param, event, cont){
		                var
		                 lookup = param[1][2],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function a(calendar, cont){
		                 if(calendar){
		                  var calendar$0 = calendar[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (augment$2, calendar$0, event, cont);
		                 }
		                 var t = event[6];
		                 if(0 === t[0])
		                  var a = 0;
		                 else
		                  var recurrence = t[1], a = [0, recurrence];
		                 return cont
		                         ([0, 1, 0, availability$0(event), 0, event, a, 0, 0]);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         lookup,
		                         event[1],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               var
		                include$324 =
		                  caml_callback
		                   (Make_object_augmented,
		                    [[0, , bQG, , notes$6, with_notes, , , cst_event, lookup$1],
		                     [0, get$24, augment$4]]),
		                Logs$16 = include$324[1],
		                get$25 = include$324[3];
		               function apply_readonly(ctrl, id, deleted, f, cont){
		                var
		                 incr = ctrl[9],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function a(event, cont){
		                 var
		                  values = incr[5],
		                  incremental = incr[1],
		                  calendars = values[1];
		                 return caml_trampoline_cps_call3
		                         (incremental[46],
		                          0,
		                          calendars[1],
		                          function(obs){
		                           return caml_trampoline_cps_call2
		                                   (incremental[49],
		                                    0,
		                                    function(match){
		                                     return caml_trampoline_cps_call2
		     (incremental[45][6],
		      obs,
		      function(calendars){
		       function a(calendar, cont){
		        return cont([0, event, calendar]);
		       }
		       return caml_exact_trampoline_cps_call$1
		               (calendar_readonly,
		                calendars,
		                event[1],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (let$, to_option$2(b), a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$0,
		                         incr,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$0,
		                                   b,
		                                   a,
		                                   function(event_and_calendar){
		                                    return caml_exact_trampoline_cps_call$0
		    (apply$127,
		     id,
		     event_and_calendar,
		     f,
		     function(match){
		      if(! match) return cont(deleted);
		      var res = match[1];
		      return cont(res);
		     });
		                                   });
		                         });
		               }
		               function apply_writable(ctrl, id, deleted, f, cont){
		                var
		                 open$0 =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 symbol_map = open$0[2],
		                 incr = ctrl[9],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[11],
		                 let$0 = open[8],
		                 let$1 = open[4];
		                function c(param, cont){
		                 if(! param) return cont(deleted);
		                 var res = param[1];
		                 return cont(res);
		                }
		                function a(event_and_calendar, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (apply$127, id, event_and_calendar, f, cont);
		                }
		                function b(event, cont){
		                 var
		                  values = incr[5],
		                  incremental = incr[1],
		                  calendars = values[1];
		                 return caml_trampoline_cps_call3
		                         (incremental[46],
		                          0,
		                          calendars[1],
		                          function(obs){
		                           return caml_trampoline_cps_call2
		                                   (incremental[49],
		                                    0,
		                                    function(match){
		                                     return caml_trampoline_cps_call2
		     (incremental[45][6],
		      obs,
		      function(calendars){
		       function a(calendar, cont){
		        return cont([0, event, calendar]);
		       }
		       return caml_exact_trampoline_cps_call$1
		               (calendar_writable,
		                calendars,
		                event[1],
		                function(error){
		                 if(0 === error[0])
		                  var calendar = error[1], b = [0, [0, calendar]];
		                 else
		                  var
		                   variant = error[1][1],
		                   b = 186335685 <= variant ? a6_ : error;
		                 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$0,
		                         incr,
		                         id,
		                         function(d){
		                          return caml_trampoline_cps_call2
		                                  (of_string$14,
		                                   d,
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call$1
		    (let$0,
		     d,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$1,
		               b,
		               a,
		               function(a){
		                return caml_trampoline_cps_call3(symbol_map, a, c, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function complete$1(ctrl, crdt, id, source, cont){
		                var now = ocaml_ptime_clock_now_d_ps();
		                return caml_exact_trampoline_cps_call
		                        (today,
		                         dummy,
		                         function(today){
		                          return caml_exact_trampoline_cps_call
		                                  (Logs$16[6][5],
		                                   function(m, cont){
		                                    return caml_trampoline_cps_call6
		    (m, 0, 0, a$V, pp$35, id, cont);
		                                   },
		                                   function(match){
		                                    function complete(event, calendar, cont){
		                                     var is_allocation = is_some(event[9][9]);
		                                     return caml_exact_trampoline_cps_call$3
		     (completed_now_time,
		      now,
		      today,
		      timezone_local,
		      is_allocation,
		      event,
		      function(end_now_time){
		       return caml_exact_trampoline_cps_call$10
		               (update$2,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                0,
		                end_now_time,
		                0,
		                0,
		                dummy,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (element$3,
		                          event[6],
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (events,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (ignore_m$11,
		                a,
		                function(complete_event_op){
		                 return caml_trampoline_cps_call3
		                         (map$17,
		                          event[9][9],
		                          function(task_id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (set_status$0,
		                                    [0, now],
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$23,
		      task_id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(tasks, a, cont);
		                });
		      });
		                                    });
		                          },
		                          function(complete_task_op){
		                           return caml_exact_trampoline_cps_call
		                                   (filter_opt,
		                                    [0, complete_task_op, [0, [0, complete_event_op], 0]],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (all_unit$27,
		      a,
		      function(crdt_op){
		       return caml_exact_trampoline_cps_call$0
		               (apply_personal,
		                ctrl[1],
		                crdt,
		                crdt_op,
		                function(match){
		                 return caml_exact_trampoline_cps_call$1
		                         (get_event$1,
		                          ctrl[2],
		                          event[6],
		                          function(match){
		                           if(! match) return cont(0);
		                           var event = match[1];
		                           return caml_exact_trampoline_cps_call$3
		                                   (push$2,
		                                    ctrl,
		                                    source,
		                                    0,
		                                    event,
		                                    a_i,
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call$0
		     (notify$0(ctrl), 0, 0, [0, [0, event], a_j], cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (apply_writable, ctrl, id, 0, complete, cont);
		                                   });
		                         });
		               }
		               function with_attendees(ctrl, attendees_sets, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   attendees_sets,
		                                   to_list$3,
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m,
		     0,
		     0,
		     a$W,
		     list([0, semi], list([0, comma], pp_print_string)),
		     a,
		     cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(state){
		                                    return caml_exact_trampoline_cps_call
		    (encode,
		     state[5],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (filter,
		               a,
		               function(event, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         state[2],
		                         event[1],
		                         function(match){
		                          var valid_calendar = match ? 1 : 0;
		                          function a(match){
		                           if(! match) return cont(0);
		                           var emails = match[1];
		                           function a(t){
		                            if(! t) return cont(0);
		                            var xs = t[2], set = t[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (equal$9,
		                                     set,
		                                     emails,
		                                     function(b){
		                                      return b ? cont(1) : caml_exact_trampoline_call1(a, xs);
		                                     });
		                           }
		                           return a(attendees_sets);
		                          }
		                          return valid_calendar
		                                  ? caml_exact_trampoline_cps_call
		                                    (meeting_emails_set, event, a)
		                                  : a(0);
		                         });
		               },
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (stable_sort,
		                         a,
		                         function(a, b, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (start$2,
		                                   timezone_local,
		                                   a[9][10],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (start$2,
		     timezone_local,
		     b[9][10],
		     function(b){
		      return caml_trampoline_cps_call3(compare$37, b, a, cont);
		     });
		                                   });
		                         },
		                         cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function with_same_attendees(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         ctrl[2],
		                         function(state){
		                          function f(event, calendar, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id,
		                                    state[2],
		                                    event[1],
		                                    function(match){
		                                     function a(a){
		                                      var attendees = value$4(a, empty$8([0, comparator$2]));
		                                      return caml_exact_trampoline_cps_call$1
		      (with_attendees, ctrl, [0, attendees, 0], cont);
		                                     }
		                                     return match
		     ? caml_exact_trampoline_cps_call
		       (meeting_emails_set, event, a)
		     : a(0);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$2
		                                  (apply_readonly, ctrl, id, 0, f, cont);
		                         });
		               }
		               function allocate$2(ctrl, crdt, name, allocation, source, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[8];
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0,
		                                    attr$0(cst_action, allocation, action_allocation_schema),
		                                    0],
		                                   function(a){
		                                    return caml_trampoline_cps_call5
		    (m, 0, [0, a], a$X, name, cont);
		                                   });
		                         },
		                         function(match){
		                          function a(param, cont){
		                           var event_op = param[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (apply_personal,
		                                    ctrl[1],
		                                    crdt,
		                                    event_op,
		                                    function(match){
		                                     var event_id = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (get_event$1,
		      ctrl[2],
		      event_id,
		      function(match){
		       if(! match) return cont([1, x$7]);
		       var event = match[1];
		       return caml_exact_trampoline_cps_call$0
		               (create$45,
		                ctrl,
		                event,
		                source,
		                function(match){
		                 return caml_trampoline_cps_call2
		                         (of_string$14, [0, event], cont);
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$2
		                                  (allocate$0,
		                                   ctrl,
		                                   allocation,
		                                   name,
		                                   0,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (notify_failure,
		     ctrl,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (let$,
		               b,
		               a,
		               function(ev_res){
		                return caml_trampoline_cps_call2(return$12, ev_res, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function delete$3(ctrl, crdt, id, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         ctrl[2],
		                         function(state){
		                          o
		                           ([0,
		                             symbol_bind$9,
		                             symbol_map$7,
		                             Let_syntax$5,
		                             ,
		                             bind$12,
		                             return$13,
		                             map$25]);
		                          return caml_exact_trampoline_cps_call
		                                  (Logs$16[6][5],
		                                   function(m, cont){
		                                    return caml_trampoline_cps_call6
		    (m, 0, 0, a$Y, pp$35, id, cont);
		                                   },
		                                   function(match){
		                                    function f(event, calendar, cont){
		                                     var a = event[6], t = ocaml_ptime_clock_now_d_ps();
		                                     return caml_exact_trampoline_cps_call
		     (today,
		      dummy,
		      function(b){
		       return caml_exact_trampoline_cps_call$2
		               (remove$24,
		                b,
		                state,
		                t,
		                a,
		                function(crdt_op_o){
		                 return caml_exact_trampoline_cps_call$0
		                         (apply_personal,
		                          ctrl[1],
		                          crdt,
		                          crdt_op_o,
		                          function(match){
		                           return caml_exact_trampoline_cps_call$1
		                                   (get_event$1,
		                                    ctrl[2],
		                                    event[6],
		                                    function(match){
		                                     if(! match) return cont(0);
		                                     var event = match[1];
		                                     if(event[9][9])
		                                      var notification = " deallocated", metric = 1;
		                                     else {notification = cst_deleted$0; metric = 1;}
		                                     return caml_exact_trampoline_cps_call$3
		     (push$2,
		      ctrl,
		      source,
		      0,
		      event,
		      metric,
		      function(match){
		       return caml_exact_trampoline_cps_call$0
		               (notify$0(ctrl),
		                0,
		                0,
		                [0, [0, event], [0, [9, cst$7 + notification], 0]],
		                cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (apply_writable, ctrl, id, 0, f, cont);
		                                   });
		                         });
		               }
		               var cst_will_attend = "will_attend";
		               function set_will_attend$0
		               (ctrl, crdt, id, will_attend, source, cont){
		                o
		                 ([0,
		                   symbol_bind$4,
		                   symbol_map$4,
		                   Let_syntax$2,
		                   ,
		                   bind$6,
		                   of_string$14,
		                   map$15]);
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   yes_no_maybe_schema,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (attrs,
		     [0, attr$0(cst_will_attend, will_attend, a), 0],
		     function(a){
		      return caml_trampoline_cps_call4(m, 0, [0, a], a$Z, cont);
		     });
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(state){
		                                    function f(original_event, calendar, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (set_will_attend,
		      calendar,
		      original_event,
		      will_attend,
		      function(patch){
		       var t = ocaml_ptime_clock_now_d_ps();
		       return caml_exact_trampoline_cps_call
		               (today,
		                dummy,
		                function(a){
		                 return caml_exact_trampoline_cps_call$3
		                         (update_from_patch$0,
		                          a,
		                          state,
		                          t,
		                          patch,
		                          id,
		                          function(crdt_op){
		                           return caml_exact_trampoline_cps_call$0
		                                   (apply_personal,
		                                    ctrl[1],
		                                    crdt,
		                                    crdt_op,
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call$2
		     (attend, ctrl, original_event, will_attend, source, cont);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (apply_writable, ctrl, id, 0, f, cont);
		                                   });
		                         });
		               }
		               function update$15(ctrl, crdt, patch, source, cont){
		                o
		                 ([0,
		                   symbol_bind$4,
		                   symbol_map$4,
		                   Let_syntax$2,
		                   ,
		                   bind$6,
		                   of_string$14,
		                   map$15]);
		                var id = patch[1];
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_event, patch[2], schema$89), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call4(m, 0, [0, a], a$0, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(state){
		                                    function f(original_event, param, cont){
		                                     var
		                                      init = patch[2],
		                                      a = init[11],
		                                      b = init[10],
		                                      c = init[9],
		                                      d = init[8],
		                                      e = init[7],
		                                      f = init[6],
		                                      g = init[5],
		                                      h = init[4];
		                                     return caml_exact_trampoline_cps_call$2
		     (add_self_to_attendees,
		      ctrl,
		      original_event[1],
		      original_event[9][3],
		      patch[2][3],
		      function(i){
		       var
		        patch = [0, init[1], init[2], i, h, g, f, e, d, c, b, a],
		        t = ocaml_ptime_clock_now_d_ps();
		       return caml_exact_trampoline_cps_call
		               (today,
		                dummy,
		                function(a){
		                 return caml_exact_trampoline_cps_call$3
		                         (update_from_patch$0,
		                          a,
		                          state,
		                          t,
		                          patch,
		                          id,
		                          function(crdt_op){
		                           return caml_exact_trampoline_cps_call$0
		                                   (apply_personal,
		                                    ctrl[1],
		                                    crdt,
		                                    crdt_op,
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call$2
		     (update$12, ctrl, original_event, patch, source, cont);
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$2
		    (apply_writable, ctrl, id, 0, f, cont);
		                                   });
		                         });
		               }
		               function create$49(id, ctrl, crdt, creation, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_creation, creation, creation_schema), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call4(m, 0, [0, a], a$1, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_calendar$0,
		                                   ctrl[2],
		                                   creation[1],
		                                   function(match){
		                                    function a(google_calendar_id){
		                                     return caml_exact_trampoline_cps_call$1
		     (to_connection,
		      ctrl,
		      creation[1],
		      function(connection){
		       return caml_exact_trampoline_cps_call
		               (create_events_as,
		                connection,
		                function(creator){
		                 var
		                  a = [0, creation[3][3]],
		                  b = empty$11([0, comparator$2]);
		                 return caml_exact_trampoline_cps_call$2
		                         (add_self_to_attendees,
		                          ctrl,
		                          creation[1],
		                          b,
		                          a,
		                          function(a){
		                           var
		                            attendees = value$4(a, creation[3][3]),
		                            a = creation[3],
		                            writable =
		                              [0,
		                               a[1],
		                               a[2],
		                               attendees,
		                               a[4],
		                               a[5],
		                               a[6],
		                               a[7],
		                               a[8],
		                               a[9],
		                               a[10],
		                               a[11]],
		                            a = creation[2],
		                            t = ocaml_ptime_clock_now_d_ps();
		                           return caml_exact_trampoline_cps_call$4
		                                   (add_from_writable$1,
		                                    id,
		                                    0,
		                                    t,
		                                    [0, creator],
		                                    a,
		                                    google_calendar_id,
		                                    0,
		                                    0,
		                                    writable,
		                                    function(crdt_op){
		                                     return caml_exact_trampoline_cps_call$0
		     (apply_personal,
		      ctrl[1],
		      crdt,
		      crdt_op,
		      function(match){
		       var event_id = match[1];
		       return cont(event_id);
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    if(match) return a(creation[1]);
		                                    var b = creation[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (fatal$0,
		     a$3,
		     a$2,
		     function(c){
		      return caml_trampoline_cps_call3(c, pp$2, b, a);
		     });
		                                   });
		                         });
		               }
		               function create$50(ctrl, crdt, creation, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (create$49, 0, ctrl, crdt, creation, cont);
		               }
		               function move$5(ctrl, crdt, id, dst_calendar_id, source, cont){
		                o
		                 ([0,
		                   symbol_bind$9,
		                   symbol_map$7,
		                   Let_syntax$5,
		                   ,
		                   bind$12,
		                   return$13,
		                   map$25]);
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_calendar, dst_calendar_id, schema$11), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, a], a$4, pp$35, id, cont);
		                                   });
		                         },
		                         function(match){
		                          function f(event, calendar, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (get$23,
		                                    ctrl,
		                                    dst_calendar_id,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (get$17,
		      a,
		      function(o){
		       function a(target_calendar){
		        return caml_exact_trampoline_cps_call
		                (state_writable_personal,
		                 crdt,
		                 function(state){
		                  var connection = of_google_email(calendar[2]);
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id,
		                           state[3],
		                           connection,
		                           function(match){
		                            function a(old_connection){
		                             var connection = of_google_email(target_calendar[2]);
		                             return caml_exact_trampoline_cps_call$1
		                                     (find_packed_by_id,
		                                      state[3],
		                                      connection,
		                                      function(match){
		                                       function a(new_connection){
		function a(param){
		 function c(match){
		  function a(update_self_attendee){
		   var match = event[3];
		   function c(update_creator){
		    return caml_exact_trampoline_cps_call
		            (all_unit$14,
		             [0, update_self_attendee, [0, update_creator, 0]],
		             function(update_self){
		              var a = [0, update_self, 0];
		              return caml_exact_trampoline_cps_call$10
		                      (update$2,
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       [0, dst_calendar_id],
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       dummy,
		                       function(b){
		                        return caml_exact_trampoline_cps_call
		                                (all$23,
		                                 [0, b, a],
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (element$3,
		   event[6],
		   function(b){
		    return caml_trampoline_cps_call2
		            (b,
		             a,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (events,
		                       a,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (ignore_m$11,
		                                 a,
		                                 function(crdt_op){
		                                  return caml_exact_trampoline_cps_call$0
		  (apply_personal,
		   ctrl[1],
		   crdt,
		   crdt_op,
		   function(match){
		    return caml_exact_trampoline_cps_call$1
		            (get_event$1,
		             ctrl[2],
		             event[6],
		             function(match){
		              if(! match) return cont(0);
		              var event = match[1];
		              return caml_exact_trampoline_cps_call$3
		                      (push$2,
		                       ctrl,
		                       source,
		                       0,
		                       event,
		                       [1, [0, event[1], cst_unknown]],
		                       function(match){
		                        return caml_exact_trampoline_cps_call$0
		                                (notify$0(ctrl), 0, 0, [0, [0, event], a_k], cont);
		                       });
		             });
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       });
		             });
		   }
		   function b(){
		    return caml_trampoline_cps_call2(return$33, 0, c);
		   }
		   if(! match) return b();
		   var creator = match[1];
		   function a(a){
		    return a
		            ? caml_exact_trampoline_cps_call
		              (create_events_as,
		               new_connection,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (set_creator, [0, a], c);
		               })
		            : b();
		   }
		   if(0 === old_connection[0]){
		    var email = old_connection[1][1], d = creator[1];
		    return caml_exact_trampoline_cps_call
		            (to_string$51,
		             email,
		             function(b){return a(b === d ? 1 : 0);});
		   }
		   var email$0 = old_connection[1][5][1];
		   return a(email$0 === creator[1] ? 1 : 0);
		  }
		  if(! match)
		   return caml_trampoline_cps_call2(return$33, 0, a);
		  var current_attendee = match[1];
		  return caml_exact_trampoline_cps_call
		          (attend_events_as,
		           new_connection,
		           function(new_attendee){
		            return caml_trampoline_cps_call3
		                    (add$18,
		                     new_attendee[1],
		                     new_attendee,
		                     function(c){
		                      var b = [0, c, 0];
		                      return caml_trampoline_cps_call2
		                              (remove$8,
		                               current_attendee[1],
		                               function(c){
		                                return caml_trampoline_cps_call2
		(Operation$5[13],
		 [0, c, b],
		 function(b){
		  return caml_exact_trampoline_cps_call(attendees$0, b, a);
		 });
		                               });
		                     });
		           });
		 }
		 if(! param) return c(0);
		 var l = param[2], attendee = param[1];
		 function b(b){
		  return b
		          ? c([0, attendee])
		          : caml_exact_trampoline_call1(a, l);
		 }
		 if(0 === old_connection[0]){
		  var email = old_connection[1][1], d = attendee[1];
		  return caml_exact_trampoline_cps_call
		          (to_string$51,
		           email,
		           function(a){return b(a === d ? 1 : 0);});
		 }
		 var email$0 = old_connection[1][5][1];
		 return b(email$0 === attendee[1] ? 1 : 0);
		}
		return caml_exact_trampoline_cps_call
		        (encode, event[9][3], a);
		                                       }
		                                       if(! match)
		return caml_exact_trampoline_cps_call$1
		        (fatal$0,
		         a$8,
		         a$7,
		         function(b){
		          return caml_trampoline_cps_call3(b, pp$91, connection, a);
		         });
		                                       var conn = match[1];
		                                       return a(conn);
		                                      });
		                            }
		                            if(! match)
		                             return caml_exact_trampoline_cps_call$1
		                                     (fatal$0,
		                                      a$_,
		                                      a$9,
		                                      function(b){
		                                       return caml_trampoline_cps_call3(b, pp$91, connection, a);
		                                      });
		                            var conn = match[1];
		                            return a(conn);
		                           });
		                 });
		       }
		       if(! o)
		        return caml_exact_trampoline_cps_call$1
		                (fatal$0,
		                 a$6,
		                 a$5,
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (b, pp$2, dst_calendar_id, a);
		                 });
		       var x = o[1];
		       return a(x);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$2
		                                  (apply_writable, ctrl, id, 0, f, cont);
		                         });
		               }
		               function publish(ctrl, crdt, event_id, cont){
		                o
		                 ([0,
		                   symbol_bind$4,
		                   symbol_map$4,
		                   Let_syntax$2,
		                   ,
		                   bind$6,
		                   of_string$14,
		                   map$15]);
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$$, pp$35, event_id, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (set_draft$0,
		                                   0,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (element$4,
		     event_id,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (events,
		                         a,
		                         function(op){
		                          return caml_exact_trampoline_cps_call$0
		                                  (apply_personal, ctrl[1], crdt, op, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function tasks$0(ctrl, id, cont){
		                o
		                 ([0,
		                   symbol_bind$9,
		                   symbol_map$7,
		                   Let_syntax$5,
		                   ,
		                   bind$12,
		                   return$13,
		                   map$25]);
		                function f(event, calendar, cont){
		                 var notes = notes$6(event);
		                 return caml_exact_trampoline_cps_call$1
		                         (filter_map$0,
		                          notes[1],
		                          function(a, cont){
		                           a = a[2];
		                           if(typeof a !== "number" && 11 === a[0]){
		                            a = a[1][3];
		                            if(a){
		                             var id = a[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (get_task$0,
		                                      ctrl[2],
		                                      id,
		                                      function(a){
		                                       return caml_trampoline_cps_call3(map$17, a, augment$1, cont);
		                                      });
		                            }
		                           }
		                           return cont(0);
		                          },
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (apply_readonly, ctrl, id, 0, f, cont);
		               }
		               function with_notes$5(ctrl, cont){
		                var values = ctrl[9][5], events = values[6];
		                function f(events, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (to_sequence$2,
		                          0,
		                          0,
		                          0,
		                          events,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter_map$1,
		                                    a,
		                                    function(param, cont){
		                                     var event = param[2];
		                                     return cont(some_if(1 - is_empty(event[9][8][1]), event));
		                                    },
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (to_binable,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (stable_sort,
		                a,
		                function(l, r, cont){
		                 return caml_trampoline_cps_call3
		                         (compare$171,
		                          l[9][10],
		                          r[9][10],
		                          function(a){return cont(- a | 0);});
		                },
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (map$18,
		                          a,
		                          function(param, cont){var id = param[6]; return cont(id);},
		                          cont);
		                });
		      });
		                                    });
		                          });
		                }
		                var t = events[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$41,
		                         t,
		                         f,
		                         function(res){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$230,
		                                   res,
		                                   "events with notes",
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function day$1(ctrl){
		                var a = ctrl[5];
		                return function(b, c, d, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (day$0, a, b, c, d, cont);};
		               }
		               function days$2(ctrl){
		                var a = ctrl[5];
		                return function(b, c, d, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (days$1, a, b, c, d, cont);};
		               }
		               function timeline$0(ctrl, cont){
		                var a = ctrl[5];
		                return cont
		                        (function(b, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (timeline, a, b, cont);
		                         });
		               }
		               function first_occurrence$0(ctrl, cont){
		                var a = ctrl[5];
		                return cont
		                        (function(b, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (first_occurrence, a, b, cont);
		                         });
		               }
		               function upcoming_notifications(ctrl, limit, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$16[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call5(m, 0, 0, baa, limit, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_personal,
		                                   ctrl[2],
		                                   function(state){
		                                    var now = ocaml_ptime_clock_now_d_ps();
		                                    return caml_exact_trampoline_cps_call
		    (today,
		     dummy,
		     function(today){
		      function to_upcoming_notification(event, cont){
		       var match = event[9][10], id$0 = event[6];
		       function a(){return cont(0);}
		       if(2 !== match[0]) return a();
		       var end = match[2], start = match[1];
		       return caml_exact_trampoline_cps_call$1
		               (symbol$75,
		                start,
		                now,
		                function(b){
		                 return b
		                         ? caml_exact_trampoline_cps_call$1
		                           (symbol$75,
		                            end,
		                            now,
		                            function(b){
		                             return b
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (symbol$78,
		start,
		minutes(-10),
		function(notification_time){
		 return caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          id,
		          fmt$151,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (a,
		                    pp$35,
		                    id$0,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$9
		                             (make$15,
		                              a7w,
		                              0,
		                              0,
		                              0,
		                              [0, a],
		                              0,
		                              0,
		                              dummy,
		                              function(link){
		                               return caml_exact_trampoline_cps_call$3
		                                       (make$135,
		[0, [0, id$0]],
		[0, link],
		[0, notification_time],
		0,
		[0, [0, event], a7x],
		function(a){return cont([0, a]);});
		                              });
		                    });
		          });
		})
		                                     : a();
		                            })
		                         : a();
		                });
		      }
		      return caml_exact_trampoline_cps_call$2
		              (to_sequence$2,
		               0,
		               0,
		               0,
		               state[5],
		               function(events){
		                return caml_exact_trampoline_cps_call$2
		                        (to_sequence$2,
		                         0,
		                         0,
		                         0,
		                         state[6],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$1,
		                                   a,
		                                   function(param, cont){
		                                    var
		                                     event_rec_id = param[1],
		                                     open =
		                                       g
		([0,
		  symbol_bind$5,
		  symbol_map$5,
		  ,
		  bind$8,
		  return$9,
		  map$17,
		  ,
		  ,
		  ,
		  ,
		  Let_syntax$3]),
		                                     let$ = open[4];
		                                    function a(event, cont){return cont([0, event[6], event]);}
		                                    return caml_exact_trampoline_cps_call$0
		    (get_closest_occurrence_after,
		     state,
		     event_rec_id,
		     today,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   },
		                                   function(occurrences){
		                                    return caml_exact_trampoline_cps_call$1
		    (filter_map$1,
		     append$1(events, occurrences),
		     function(param, cont){
		      var event = param[2], calendar_id = event[1];
		      return caml_exact_trampoline_cps_call$1
		              (get_calendar,
		               state,
		               calendar_id,
		               function(match){
		                if(! match) return cont(0);
		                var calendar = match[1];
		                function a(){return cont(0);}
		                return calendar[3]
		                        ? a()
		                        : event
		                           [4]
		                          ? a()
		                          : caml_exact_trampoline_cps_call$1
		                            (active$1,
		                             calendar,
		                             event,
		                             function(b){
		                              if(! b) return a();
		                              b = event[9][9];
		                              if(! b) return cont([0, event]);
		                              var task_id = b[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (get_task,
		                                       state,
		                                       task_id,
		                                       function(match){
		if(match && match[1][7][2]) return cont(0);
		return cont([0, event]);
		                                       });
		                             });
		               });
		     },
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$1,
		               a,
		               to_upcoming_notification,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (to_binable,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (stable_sort,
		                                   a,
		                                   function(n1, n2, cont){
		                                    return caml_trampoline_cps_call3
		    (compare$37, n1[5], n2[5], cont);
		                                   },
		                                   function(notifications){
		                                    return caml_exact_trampoline_cps_call$1
		    (take$0, notifications, limit, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                cst_Unviewed = "Unviewed",
		                letrec_function_context$925 = [];
		               function viewed_filter_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$925[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bab, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$925[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$925[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$925[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(baf);},
		                        0,
		                        0,
		                        cst_viewed,
		                        cst_Viewed,
		                        bae,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(bad) : cont(0);},
		                         0,
		                         0,
		                         cst_unviewed,
		                         cst_Unviewed,
		                         bac,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$925[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$925[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$885 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$925, [0, schematic_cache$885]);
		               caml_callback
		                (viewed_filter_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$926 = [];
		               function archived_filter_schema_version
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$926[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bag, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$926[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$926[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$926[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bak);},
		                        0,
		                        0,
		                        cst_archived,
		                        cst_Archived,
		                        baj,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(bai) : cont(0);},
		                         0,
		                         0,
		                         cst_unarchived$0,
		                         "Unarchived",
		                         bah,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$926[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$926[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$886 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$926, [0, schematic_cache$886]);
		               caml_callback
		                (archived_filter_schema_version, [function(param){return 0;}]);
		               var letrec_function_context$927 = [];
		               function filter_schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$927[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bal, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$927[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$927[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$927[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (archived_filter_schema_version,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0, [0, 0, 0, 0, 0, cst_archived, 0, 3, [0, b], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (viewed_filter_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var archived = param[2][1], viewed = param[1];
		   return cont([0, viewed, archived]);
		  },
		  function(param, cont){
		   var archived = param[2], viewed = param[1];
		   return cont([0, viewed, [0, archived, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_viewed, 0, 3, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$927[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$927[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$887 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$927, [0, schematic_cache$887]);
		               caml_callback
		                (filter_schema_versioned$0, [function(param){return 0;}]);
		               function option_max(max, x1, x2, cont){
		                if(x1){
		                 if(x2){
		                  var x2$0 = x2[1], x1$0 = x1[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (max, x1$0, x2$0, function(a){return cont([0, a]);});
		                 }
		                 var some = x1;
		                }
		                else {if(! x2) return cont(x2); some = x2;}
		                return cont(some);
		               }
		               function all$31(filter, ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (user_id,
		                         ctrl[1],
		                         function(current_user){
		                          var
		                           param = ctrl[9],
		                           values = param[5],
		                           incremental = param[1],
		                           open =
		                             g
		                              ([0,
		                                incremental[72],
		                                incremental[73],
		                                ,
		                                incremental[75],
		                                incremental[76],
		                                incremental[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                incremental[82]]),
		                           and = open[6],
		                           let$ = open[4];
		                          return caml_exact_trampoline_cps_call$7
		                                  (filter_mapi$3,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   values[14][1],
		                                   function(notice_id, notice, cont){
		                                    function a(notice, cont){
		                                     var
		                                      match = notice[1],
		                                      viewed = match[8],
		                                      archived = match[7],
		                                      recipient = match[6];
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$133,
		      recipient,
		      current_user,
		      function(a){
		       if(! a) return cont(0);
		       if(filter){
		        a = filter[1];
		        var
		         archived$0 = a[2],
		         viewed$0 = a[1],
		         filter_archived$0 = archived$0,
		         filter_viewed = viewed$0;
		       }
		       else {filter_archived$0 = filter_archived; filter_viewed = 0;
		       }
		       var
		        is_viewed = is_some(viewed),
		        is_archived = is_some(archived),
		        passes_viewed =
		          filter_viewed
		           ? filter_viewed[1] ? 1 - is_viewed : is_viewed
		           : 1,
		        passes_archived =
		          filter_archived$0
		           ? filter_archived$0[1] ? 1 - is_archived : is_archived
		           : 1,
		        passes = passes_viewed ? passes_archived : passes_viewed;
		       return cont(some_if(passes, notice));
		      });
		                                    }
		                                    function b(a, cont){
		                                     var
		                                      viewed = a[2],
		                                      a = a[1],
		                                      archived = a[2],
		                                      notice = a[1],
		                                      init = notice[1],
		                                      b = notice[2];
		                                     return caml_exact_trampoline_cps_call$0
		     (option_max,
		      max$13,
		      viewed,
		      notice[1][8],
		      function(a){
		       return caml_exact_trampoline_cps_call$0
		               (option_max,
		                max$13,
		                archived,
		                notice[1][7],
		                function(c){
		                 var
		                  x =
		                    [0,
		                     [0,
		                      init[1],
		                      init[2],
		                      init[3],
		                      init[4],
		                      init[5],
		                      init[6],
		                      c,
		                      a],
		                     b];
		                 return cont(x);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (find$6,
		     values[15][2],
		     notice_id,
		     function(c){
		      return caml_trampoline_cps_call3
		              (and,
		               notice,
		               c,
		               function(left){
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         values[16][2],
		                         notice_id,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (and,
		                                   left,
		                                   c,
		                                   function(c){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     c,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$7
		    (index_by$0,
		     0,
		     0,
		     [0, equal_augmented],
		     a,
		     [0, comparator$10],
		     function(param, cont){
		      var created = param[1][1];
		      return cont([0, created]);
		     },
		     function(a){
		      return caml_exact_trampoline_cps_call$2
		              (map$42,
		               0,
		               [0,
		                function(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (equal$11, equal_augmented, a, b, cont);
		                }],
		               a,
		               keys$0,
		               function(notices){
		                return caml_trampoline_cps_call3
		                        (let$,
		                         notices,
		                         function(notices, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   notices,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(of_list, a, cont);
		                                   });
		                         },
		                         function(result){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental,
		                                   0,
		                                   symbol$229
		                                    (result,
		                                     function(x, y, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (equal_with_local_closure, equal$220, x, y, cont);
		                                     }),
		                                   cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function get$26(ctrl, id, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 and = open[6],
		                 let$ = open[4];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         values[14][2],
		                         id,
		                         function(notice){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   values[15][2],
		                                   id,
		                                   function(archived){
		                                    return caml_exact_trampoline_cps_call$1
		    (find$6,
		     values[16][2],
		     id,
		     function(viewed){
		      function a(a, cont){
		       var
		        viewed = a[2],
		        a = a[1],
		        archived = a[2],
		        notice$0 = a[1];
		       if(! notice$0) return cont(0);
		       var notice = notice$0[1], init = notice[1], b = notice[2];
		       return caml_exact_trampoline_cps_call$0
		               (option_max,
		                max$13,
		                viewed,
		                notice[1][8],
		                function(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (option_max,
		                          max$13,
		                          archived,
		                          notice[1][7],
		                          function(c){
		                           var
		                            x =
		                              [0,
		                               [0,
		                                init[1],
		                                init[2],
		                                init[3],
		                                init[4],
		                                init[5],
		                                init[6],
		                                c,
		                                a],
		                               b];
		                           return cont([0, x]);
		                          });
		                });
		      }
		      return caml_trampoline_cps_call3
		              (and,
		               notice,
		               archived,
		               function(b){
		                return caml_trampoline_cps_call3
		                        (and,
		                         b,
		                         viewed,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function notify_failure$0(ctrl, action, param, cont){
		                if(0 === param[0]){var x = param[1]; return cont([0, x]);}
		                var err = param[1];
		                return typeof err === "number"
		                        ? -587614909
		                          === err
		                          ? caml_exact_trampoline_cps_call
		                            (warn$4(ctrl),
		                             bam,
		                             function(a){
		                              return caml_trampoline_cps_call2
		                                      (a, action, function(match){return cont(0);});
		                             })
		                          : 831310812
		                            <= err
		                            ? caml_exact_trampoline_cps_call
		                              (warn$4(ctrl),
		                               ban,
		                               function(a){
		                                return caml_trampoline_cps_call2
		(a, action, function(match){return cont(0);});
		                               })
		                            : caml_exact_trampoline_cps_call
		                              (warn$4(ctrl),
		                               bao,
		                               function(a){
		                                return caml_trampoline_cps_call2
		(a, action, function(match){return cont(0);});
		                               })
		                        : caml_exact_trampoline_cps_call
		                          (warn$4(ctrl),
		                           bap,
		                           function(a){
		                            return caml_trampoline_cps_call4
		                                    (a, action, pp$125, err, function(match){return cont(0);});
		                           });
		               }
		               function create_mention(ctrl, crdt, recipient, origin, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(writable_crdt, cont){
		                 var
		                  id = make$58(),
		                  open =
		                    o
		                     ([0,
		                       symbol_bind$4,
		                       symbol_map$4,
		                       Let_syntax$2,
		                       ,
		                       bind$6,
		                       of_string$14,
		                       map$15]),
		                  let$ = open[4],
		                  let$0 = open[3],
		                  workspace_id = origin[1][1];
		                 return caml_trampoline_cps_call3
		                         (let$0,
		                          of_option(workspace_id, 831310812),
		                          function(workspace_id, cont){
		                           function a(triggered, cont){
		                            var created = ocaml_ptime_clock_now_d_ps();
		                            return caml_exact_trampoline_cps_call$8
		                                    (make_mention,
		                                     id,
		                                     created,
		                                     recipient,
		                                     triggered,
		                                     origin,
		                                     0,
		                                     0,
		                                     function(notice){
		                                      var
		                                       open =
		 g
		  ([0,
		    Operation$11[4],
		    Operation$11[5],
		    ,
		    Operation$11[7],
		    Operation$11[8],
		    Operation$11[9],
		    ,
		    ,
		    ,
		    ,
		    Operation$11[12]]),
		                                       let$0 = open[3];
		                                      function a(has, cont){
		                                       function b(param, cont){
		return caml_exact_trampoline_cps_call
		        (add_notice,
		         notice,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (element$9,
		                   recipient,
		                   function(b){return caml_trampoline_cps_call2(b, a, cont);});
		         });
		                                       }
		                                       function a(a){
		return caml_trampoline_cps_call3(let$0, a, b, cont);
		                                       }
		                                       return has
		       ? caml_trampoline_cps_call2(Operation$11[8], 0, a)
		       : caml_trampoline_cps_call3
		         (add$22, recipient, By$19[104], a);
		                                      }
		                                      return caml_trampoline_cps_call2
		      (has$2,
		       recipient,
		       function(b){
		        return caml_trampoline_cps_call3
		                (let$0,
		                 b,
		                 a,
		                 function(notices_op){
		                  return caml_exact_trampoline_cps_call
		                          (notices,
		                           notices_op,
		                           function(crdt_op){
		                            function a(param, cont){return cont(id);}
		                            return caml_exact_trampoline_cps_call$2
		                                    (apply$125,
		                                     ctrl[1],
		                                     writable_crdt,
		                                     workspace_id,
		                                     crdt_op,
		                                     function(b){
		                                      return caml_trampoline_cps_call3(let$, b, a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (get_user,
		                                    ctrl,
		                                    workspace_id,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (let$0, of_option(b, -587614909), a, cont);
		                                    });
		                          },
		                          function(res){
		                           return caml_exact_trampoline_cps_call$0
		                                   (notify_failure$0, ctrl, "create mention", res, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         crdt,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function create_notice
		               (ctrl,
		                crdt,
		                workspace,
		                recipient,
		                location,
		                item,
		                message,
		                cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(writable_crdt, cont){
		                 var
		                  id = make$58(),
		                  open =
		                    o
		                     ([0,
		                       symbol_bind$4,
		                       symbol_map$4,
		                       Let_syntax$2,
		                       ,
		                       bind$6,
		                       of_string$14,
		                       map$15]),
		                  let$ = open[4],
		                  created = ocaml_ptime_clock_now_d_ps();
		                 return caml_exact_trampoline_cps_call$7
		                         (make$59,
		                          [0, created],
		                          [0, id],
		                          item,
		                          location,
		                          recipient,
		                          baq,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    message,
		                                    function(notice){
		                                     var
		                                      open =
		g
		 ([0,
		   Operation$11[4],
		   Operation$11[5],
		   ,
		   Operation$11[7],
		   Operation$11[8],
		   Operation$11[9],
		   ,
		   ,
		   ,
		   ,
		   Operation$11[12]]),
		                                      let$0 = open[3];
		                                     function a(has, cont){
		                                      function b(param, cont){
		                                       return caml_exact_trampoline_cps_call
		       (add_notice,
		        notice,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (element$9,
		                  recipient,
		                  function(b){return caml_trampoline_cps_call2(b, a, cont);});
		        });
		                                      }
		                                      function a(a){
		                                       return caml_trampoline_cps_call3(let$0, a, b, cont);
		                                      }
		                                      return has
		      ? caml_trampoline_cps_call2(Operation$11[8], 0, a)
		      : caml_trampoline_cps_call3
		        (add$22, recipient, By$19[104], a);
		                                     }
		                                     return caml_trampoline_cps_call2
		     (has$2,
		      recipient,
		      function(b){
		       return caml_trampoline_cps_call3
		               (let$0,
		                b,
		                a,
		                function(notices_op){
		                 return caml_exact_trampoline_cps_call
		                         (notices,
		                          notices_op,
		                          function(crdt_op){
		                           function a(param, cont){return cont(id);}
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply$125,
		                                    ctrl[1],
		                                    writable_crdt,
		                                    workspace,
		                                    crdt_op,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (let$,
		      b,
		      a,
		      function(res){
		       return caml_exact_trampoline_cps_call$0
		               (notify_failure$0, ctrl, "create notice", res, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         crdt,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function delete_mention
		               (ctrl, crdt, id, recipient, workspace, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(writable_crdt, cont){
		                 var
		                  open =
		                    o
		                     ([0,
		                       symbol_bind$4,
		                       symbol_map$4,
		                       Let_syntax$2,
		                       ,
		                       bind$6,
		                       of_string$14,
		                       map$15]),
		                  let$ = open[4];
		                 return caml_trampoline_cps_call2
		                         (remove$12,
		                          id,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (element$9,
		                                    recipient,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (notices,
		                a,
		                function(crdt_op){
		                 function a(param, cont){return cont(0);}
		                 return caml_exact_trampoline_cps_call$2
		                         (apply$125,
		                          ctrl[1],
		                          writable_crdt,
		                          workspace,
		                          crdt_op,
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    b,
		                                    a,
		                                    function(res){
		                                     return caml_exact_trampoline_cps_call$0
		     (notify_failure$0,
		      ctrl,
		      "delete mention",
		      res,
		      function(match){return match ? cont(0) : cont(0);});
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         crdt,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function notices_operation
		               (operation, action, ctrl, crdt, notice, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(writable_crdt, cont){
		                 return caml_exact_trampoline_cps_call
		                         (user_id,
		                          ctrl[1],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$133,
		                                    notice[1][6],
		                                    a,
		                                    function(b){
		                                     function a(res){
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$173,
		       function(a){
		        return caml_trampoline_cps_call2
		                (a,
		                 action,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (notify_failure$0,
		                           ctrl,
		                           a,
		                           res,
		                           function(match){return match ? cont(0) : cont(0);});
		                 });
		       });
		                                     }
		                                     return b
		     ? caml_exact_trampoline_cps_call$0
		       (apply_personal,
		        ctrl[1],
		        writable_crdt,
		        operation,
		        function(match){return a(bar);})
		     : a(bas);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         crdt,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function mark$0
		               (routine_notices_op, action, ctrl, crdt, notice, cont){
		                var
		                 mark_time = ocaml_ptime_clock_now_d_ps(),
		                 id$0 = notice[1][2],
		                 open =
		                   g
		                    ([0,
		                      Operation$13[4],
		                      Operation$13[5],
		                      ,
		                      Operation$13[7],
		                      Operation$13[8],
		                      Operation$13[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$13[12]]),
		                 let$ = open[3];
		                function a(has, cont){
		                 return has
		                         ? caml_exact_trampoline_cps_call
		                           (set$19,
		                            mark_time,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (element$10,
		                                      id$0,
		                                      function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                            })
		                         : caml_trampoline_cps_call3(add$23, id$0, mark_time, cont);
		                }
		                return caml_trampoline_cps_call2
		                        (has$3,
		                         id$0,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(notices_op){
		                                    return caml_exact_trampoline_cps_call
		    (routine_notices_op,
		     notices_op,
		     function(operation){
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$174,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         action,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$3
		                                  (notices_operation, operation, a, ctrl, crdt, notice, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function mark_unviewed(ctrl, crdt, notice, cont){
		                var
		                 id$0 = notice[1][2],
		                 open =
		                   g
		                    ([0,
		                      Operation$13[4],
		                      Operation$13[5],
		                      ,
		                      Operation$13[7],
		                      Operation$13[8],
		                      Operation$13[9],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Operation$13[12]]),
		                 let$ = open[3];
		                function a(has, cont){
		                 return has
		                         ? caml_trampoline_cps_call2(remove$13, id$0, cont)
		                         : caml_trampoline_cps_call2(Operation$13[8], 0, cont);
		                }
		                return caml_trampoline_cps_call2
		                        (has$3,
		                         id$0,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(notices_op){
		                                    return caml_exact_trampoline_cps_call
		    (notices_personal_viewed,
		     notices_op,
		     function(operation){
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$175,
		               function(a){
		                return caml_trampoline_cps_call2
		                        (a,
		                         cst_viewed,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$3
		                                  (notices_operation, operation, a, ctrl, crdt, notice, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function get$27(param){}
		               function augment$5(ctrl, incremental, a, page, cont){
		                var
		                 pages = a[21],
		                 a =
		                   g
		                     ([0,
		                       incremental[72],
		                       incremental[73],
		                       ,
		                       incremental[75],
		                       incremental[76],
		                       incremental[77],
		                       ,
		                       ,
		                       ,
		                       ,
		                       incremental[82]])
		                    [4];
		                return caml_trampoline_cps_call3
		                        (a,
		                         pages[1],
		                         function(pages, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (fold$5,
		                                   pages,
		                                   Ids$1[73],
		                                   function(key, data, children, cont){
		                                    var match = data[1][3][5];
		                                    function a(){return cont(children);}
		                                    if(! match) return a();
		                                    var id = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$109,
		     id,
		     page[1][2],
		     function(b){
		      return b
		              ? caml_exact_trampoline_cps_call$1
		                (add$4, children, key, cont)
		              : a();
		     });
		                                   },
		                                   function(children){return cont([0, children, page]);});
		                         },
		                         cont);
		               }
		               var
		                include$325 =
		                  caml_callback
		                   (Make_object_augmented,
		                    [[0, , bQH, , notes$8, with_notes$1, , , cst_page, lookup$2],
		                     [0, get$27, augment$5]]),
		                Logs$17 = include$325[1],
		                get$28 = include$325[3],
		                letrec_function_context$928 = [];
		               function equal_hierarchy(lhs, rhs, cont){
		                return caml_trampoline_cps_call3
		                        (letrec_function_context$928[2],
		                         lhs[1],
		                         rhs[1],
		                         function(c){
		                          if(c) var b = rhs[2], a = lhs[2], c = a === b ? 1 : 0;
		                          if(! c) return cont(c);
		                          var y = rhs[3], x = lhs[3];
		                          function d(x, y){
		                           if(x){
		                            if(y){
		                             var y$0 = y[2], b = y[1], x$0 = x[2], a = x[1];
		                             return caml_trampoline_cps_call3
		                                     (letrec_function_context$928[1],
		                                      a,
		                                      b,
		                                      function(a){
		                                       return a
		       ? caml_exact_trampoline_call2(d, x$0, y$0)
		       : cont(a);
		                                      });
		                            }
		                           }
		                           else if(! y) return cont(1);
		                           return cont(0);
		                          }
		                          return d(x, y);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$928, [0, equal_hierarchy, equal$52]);
		               var letrec_function_context$929 = [];
		               function hierarchy_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$929[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bat, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$929[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$929[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$929[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (hierarchy_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_title,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_children,
		    0,
		    2,
		    [0, [0, 0, 0, [3, b], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$103,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              children = a[2][1],
		              title = a[1],
		              id = param[1];
		             return cont([0, id, title, children]);
		            },
		            function(param, cont){
		             var children = param[3], title = param[2], id = param[1];
		             return cont([0, id, [0, title, [0, children, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$929[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$929[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$888 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$929, [0, schematic_cache$888]);
		               var
		                hierarchy_schema =
		                  caml_callback
		                   (hierarchy_schema_versioned,
		                    [function(param, cont){return cont(0);}]),
		                By_date =
		                  caml_callback(M$2, [[0, comparator$11, schema_versioned$1]]);
		               function workspace_of_id(ctrl, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[3];
		                function a(page, cont){return cont(page[2]);}
		                return caml_exact_trampoline_cps_call$1
		                        (get_from_state$1,
		                         ctrl[9],
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(workspace){
		                                    return cont
		    (value$4(workspace, personal_workspace_id(ctrl[2])));
		                                   });
		                         });
		               }
		               function with_state
		               (ctrl, crdt, workspace, name, keep_going, f, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (state_writable,
		                         workspace,
		                         crdt,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (Logs$17[6][3],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call7
		     (m, 0, 0, bau, pp$46, workspace, name, cont);
		                                    },
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call
		     (err$2(ctrl),
		      bav,
		      function(a){
		       return caml_trampoline_cps_call4
		               (a,
		                pp$46,
		                workspace,
		                name,
		                function(match){return cont(keep_going);});
		      });
		                                    });
		                          var state = match[1];
		                          return caml_exact_trampoline_cps_call(f, state, cont);
		                         });
		               }
		               function archived$0(ctrl, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 pages = values[21];
		                g
		                 ([0,
		                   incremental[72],
		                   incremental[73],
		                   ,
		                   incremental[75],
		                   incremental[76],
		                   incremental[77],
		                   ,
		                   ,
		                   ,
		                   ,
		                   incremental[82]]);
		                function a(x, y, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (equal_with_local_closure, equal$52, x, y, cont);
		                }
		                function b(b, c, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (equal$11, a, b, c, cont);
		                }
		                return caml_exact_trampoline_cps_call$7
		                        (index_by$0,
		                         0,
		                         0,
		                         [0,
		                          function(a, param, cont){
		                           var rhs = param[1][3][1], lhs = a[1][3][1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (equal_option, equal$20, lhs, rhs, cont);
		                          }],
		                         pages[1],
		                         [0, comparator$11],
		                         function(a, cont){
		                          a = a[1][3][1];
		                          if(! a) return cont(0);
		                          var archived = a[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_time$0,
		                                   timezone_local,
		                                   archived,
		                                   function(a){return cont([0, a]);});
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (filter_map$5,
		                                   0,
		                                   0,
		                                   a,
		                                   function(map, cont){
		                                    return caml_exact_trampoline_cps_call
		    (keys$0, map, function(a){return cont([0, a]);});
		                                   },
		                                   function(a){
		                                    var v = symbol$229(a, b);
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, v, cont);
		                                   });
		                         });
		               }
		               function archive(ctrl, crdt, id, source, cont){
		                var now = ocaml_ptime_clock_now_d_ps();
		                return caml_exact_trampoline_cps_call
		                        (Logs$17[6][6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, baw, pp$36, id, cont);
		                         },
		                         function(match){
		                          var incr = ctrl[9];
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_from_state$1,
		                                   incr,
		                                   id,
		                                   function(match){
		                                    function a(all_pages){
		                                     if(! all_pages)
		                                      return caml_exact_trampoline_cps_call
		      (fail_result,
		       bay,
		       function(a){
		        return caml_trampoline_cps_call3(a, pp$36, id, cont);
		       });
		                                     var root = all_pages[1];
		                                     return caml_trampoline_cps_call3
		     (map$18,
		      all_pages,
		      function(param, cont){
		       var id = param[1][2];
		       return caml_exact_trampoline_cps_call$2
		               (update$4,
		                [0, [0, now]],
		                0,
		                0,
		                id,
		                function(a){
		                 return caml_trampoline_cps_call2(Operation$14[11], a, cont);
		                });
		      },
		      function(a){
		       return caml_trampoline_cps_call2
		               (Operation$14[13],
		                a,
		                function(operation){
		                 var
		                  a = personal_workspace_id(ctrl[2]),
		                  workspace = value$4(root[2], a);
		                 return caml_exact_trampoline_cps_call
		                         (pages,
		                          operation,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply$125,
		                                    ctrl[1],
		                                    crdt,
		                                    workspace,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (fatal_result,
		      bax,
		      a,
		      function(match){
		       var page$0 = root[1];
		       return caml_exact_trampoline_cps_call$2
		               (push$3,
		                ctrl,
		                page$0[2],
		                source,
		                a_H,
		                function(a){
		                 a = [0, page(page$0), a_I];
		                 return caml_exact_trampoline_cps_call$0
		                         (notify$0(ctrl),
		                          0,
		                          0,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call2(of_string$14, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    if(! match) return a(0);
		                                    var page$0 = match[1];
		                                    function children(res, page, cont){
		                                     function f(param, data, res, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (equal_option,
		       equal$52,
		       data[1][3][5],
		       [0, page[1][2]],
		       function(a){
		        return a
		                ? caml_exact_trampoline_cps_call$1
		                  (children, [0, data, res], data, cont)
		                : cont(res);
		       });
		                                     }
		                                     var
		                                      values = incr[5],
		                                      incremental = incr[1],
		                                      pages = values[21];
		                                     return caml_trampoline_cps_call3
		     (incremental[46],
		      0,
		      pages[1],
		      function(obs){
		       return caml_trampoline_cps_call2
		               (incremental[49],
		                0,
		                function(match){
		                 return caml_trampoline_cps_call2
		                         (incremental[45][6],
		                          obs,
		                          function(pages){
		                           return caml_exact_trampoline_cps_call$0
		                                   (fold$5, pages, res, f, cont);
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (children,
		     [0, page$0, 0],
		     page$0,
		     function(b){
		      return caml_exact_trampoline_cps_call(of_rev_keys, b, a);
		     });
		                                   });
		                         });
		               }
		               function create$51(ctrl, crdt, title, root, source, cont){
		                var created = ocaml_ptime_clock_now_d_ps();
		                function a(workspace){
		                 if(root){
		                  var match = root[1];
		                  if(0 === match[0])
		                   var parent = match[1], parent$0 = [0, parent];
		                  else
		                   parent$0 = 0;
		                 }
		                 else
		                  parent$0 = 0;
		                 return caml_exact_trampoline_cps_call
		                         (Logs$17[6][6],
		                          function(m, cont){
		                           return caml_trampoline_cps_call8
		                                   (m,
		                                    0,
		                                    0,
		                                    baz,
		                                    pp$46,
		                                    workspace,
		                                    function(a, b, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (option, 0, pp$36, a, b, cont);
		                                    },
		                                    parent$0,
		                                    cont);
		                          },
		                          function(match){
		                           return caml_exact_trampoline_cps_call$1
		                                   (state_writable,
		                                    workspace,
		                                    crdt,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$2
		     (value_exn,
		      baA,
		      0,
		      0,
		      a,
		      function(state){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$22,
		             symbol_map$20,
		             ,
		             bind$30,
		             return$39,
		             map$50,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$14]),
		        let$ = open[4],
		        let$0 = open[3];
		       return caml_exact_trampoline_cps_call$7
		               (add_page,
		                0,
		                0,
		                0,
		                created,
		                title,
		                dummy,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (pages,
		                          a,
		                          function(creation){
		                           var
		                            open =
		                              g
		                               ([0,
		                                 symbol_bind$5,
		                                 symbol_map$5,
		                                 ,
		                                 bind$8,
		                                 return$9,
		                                 map$17,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$3]),
		                            let$1 = open[3];
		                           return caml_trampoline_cps_call3
		                                   (let$1,
		                                    parent$0,
		                                    function(parent, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id, state[7], parent, cont);
		                                    },
		                                    function(parent){
		                                     return caml_trampoline_cps_call3
		     (let$0,
		      creation,
		      function(id, cont){
		       function a(param, cont){return cont(id);}
		       return caml_exact_trampoline_cps_call$1
		               (add$16,
		                parent,
		                id,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (hierarchy,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                });
		      },
		      function(operation){
		       return caml_exact_trampoline_cps_call$2
		               (apply$125,
		                ctrl[1],
		                crdt,
		                workspace,
		                operation,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (fatal_result,
		                          baB,
		                          a,
		                          function(id){
		                           return caml_exact_trampoline_cps_call$2
		                                   (push$3,
		                                    ctrl,
		                                    id,
		                                    source,
		                                    0,
		                                    function(match){
		                                     var
		                                      msg = is_empty$0(title) ? a_E : [0, [4, id, title], a_F];
		                                     return caml_exact_trampoline_cps_call$0
		     (notify$0(ctrl),
		      0,
		      0,
		      msg,
		      function(match){return cont(id);});
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                if(! root) return a(personal_workspace_id(ctrl[2]));
		                var match = root[1];
		                if(0 === match[0]){
		                 var parent = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (workspace_of_id, ctrl, parent, a);
		                }
		                var workspace = match[1];
		                return a(workspace);
		               }
		               function delete$4(ctrl, crdt, id$0, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$17[6][6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, baC, pp$36, id$0, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_from_state$1,
		                                   ctrl[9],
		                                   id$0,
		                                   function(page_o){
		                                    function a(a){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$5,
		   symbol_map$5,
		   ,
		   bind$8,
		   return$9,
		   map$17,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$3]),
		                                      let$ = open[3];
		                                     return caml_trampoline_cps_call3
		     (let$,
		      page_o,
		      function(page, cont){return cont(page[2]);},
		      function(workspace){
		       var
		        workspace$0 =
		          value$4(workspace, personal_workspace_id(ctrl[2]));
		       function a(state, cont){
		        return caml_exact_trampoline_cps_call
		                (today,
		                 dummy,
		                 function(date){
		                  var time = ocaml_ptime_clock_now_d_ps();
		                  return caml_exact_trampoline_cps_call$2
		                          (remove$25,
		                           date,
		                           state,
		                           time,
		                           id$0,
		                           function(op_o){
		                            function a(b){
		                             function a(a){return cont(0);}
		                             if(! page_o) return a();
		                             var page = page_o[1], page$0 = page[1];
		                             return caml_exact_trampoline_cps_call$2
		                                     (push$3,
		                                      ctrl,
		                                      page$0[2],
		                                      source,
		                                      1,
		                                      function(match){
		                                       return caml_exact_trampoline_cps_call
		       (text$3,
		        a_L,
		        function(d){
		         var b = [0, d, 0], c = page$0[3][4];
		         return caml_exact_trampoline_cps_call
		                 (highlight,
		                  a_M,
		                  function(d){
		                   return caml_trampoline_cps_call2
		                           (d,
		                            c,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$0
		                                     (notify$0(ctrl), 0, 0, [0, c, b], a);
		                            });
		                  });
		        });
		                                      });
		                            }
		                            if(! op_o)
		                             return caml_exact_trampoline_cps_call
		                                     (Logs$17[6][4],
		                                      function(m, cont){
		                                       return caml_trampoline_cps_call6
		       (m, 0, 0, baE, pp$36, id$0, cont);
		                                      },
		                                      a);
		                            var op = op_o[1];
		                            return caml_exact_trampoline_cps_call$2
		                                    (apply$125,
		                                     ctrl[1],
		                                     crdt,
		                                     workspace$0,
		                                     op,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (fatal_result, baD, b, a);
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$176,
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (b,
		                          pp$36,
		                          id$0,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$7
		                                   (with_state, ctrl, crdt, workspace$0, b, 0, a, cont);
		                          });
		                });
		      });
		                                    }
		                                    return page_o
		    ? a()
		    : caml_exact_trampoline_cps_call
		      (Logs$17[6][6],
		       function(m, cont){
		        return caml_trampoline_cps_call6
		                (m, 0, 0, baF, pp$36, id$0, cont);
		       },
		       a);
		                                   });
		                         });
		               }
		               function hierarchy$0(ctrl, workspace_id, cont){
		                if(workspace_id)
		                 var id = workspace_id[1], workspace_id$0 = id;
		                else
		                 workspace_id$0 = personal_workspace_id(ctrl[2]);
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 pages = values[21],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function equal(l, r, cont){
		                 var y = r[1][3][4], x = l[1][3][4], a = x === y ? 1 : 0;
		                 function b(a){return cont(a);}
		                 return a
		                         ? caml_exact_trampoline_cps_call$0
		                           (equal_option,
		                            equal$52,
		                            l[1][3][5],
		                            r[1][3][5],
		                            function(a){
		                             return a
		                                     ? caml_exact_trampoline_cps_call$0
		                                       (equal_option, equal$20, l[1][3][1], r[1][3][1], cont)
		                                     : b(a);
		                            })
		                         : b(a);
		                }
		                function a(pages, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (fold$5,
		                          pages,
		                          [0, 0, empty$11([0, comparator$16])],
		                          function(b, page, a, cont){
		                           var sons = a[2], roots = a[1], a = page[1][3][5];
		                           if(! a) return cont([0, [0, page, roots], sons]);
		                           var parent = a[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (add_multi$0,
		                                    sons,
		                                    parent,
		                                    page,
		                                    function(a){return cont([0, roots, a]);});
		                          },
		                          function(match){
		                           var sons = match[2], roots = match[1];
		                           function f(a, cont){
		                            a = a[1];
		                            var title = a[3][4], id = a[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     sons,
		                                     id,
		                                     function(match){
		                                      function a(children){return cont([0, id, title, children]);}
		                                      if(! match) return a(0);
		                                      var children = match[1];
		                                      return caml_trampoline_cps_call3(map$18, children, f, a);
		                                     });
		                           }
		                           return caml_trampoline_cps_call3(map$18, roots, f, cont);
		                          });
		                }
		                function b(x, y, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (equal_with_local_closure, equal_hierarchy, x, y, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (filter_map$5,
		                         0,
		                         [0, equal],
		                         pages[1],
		                         function(page, cont){
		                          var a = is_none$0(page[1][3][1]);
		                          function b(a){return cont(some_if(a, page));}
		                          return a
		                                  ? caml_exact_trampoline_cps_call$0
		                                    (equal_option, equal$61, page[2], [0, workspace_id$0], b)
		                                  : b(a);
		                         },
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   c,
		                                   a,
		                                   function(a){
		                                    var v = symbol$229(a, b);
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, v, cont);
		                                   });
		                         });
		               }
		               function without_title(ctrl, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 pages = values[21],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function a(pages, cont){
		                 function compare(a, param, cont){
		                  var timeR = param[1], timeL = a[1];
		                  return caml_trampoline_cps_call3
		                          (compare$37, timeR, timeL, cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (encode,
		                          pages,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (stable_sort,
		                                    a,
		                                    compare,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(map$18, a, get_data, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (filter_map$5,
		                         0,
		                         0,
		                         pages[1],
		                         function(page, cont){
		                          var p = page[1], x = p[3][4];
		                          return cont
		                                  (some_if(x === cst$1 ? 1 : 0, [0, page[1][1], page[1][2]]));
		                         },
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(v){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$230,
		     v,
		     "pages without title",
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (of_incremental, 0, a, cont);
		     });
		                                   });
		                         });
		               }
		               function move$6(ctrl, crdt, parent, param, source, id$0, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$17[6][6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, baG, pp$36, id$0, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (workspace_of_id,
		                                   ctrl,
		                                   id$0,
		                                   function(workspace){
		                                    function a(state, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (move_page,
		      parent,
		      state,
		      id$0,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fail_result,
		                 baH,
		                 function(a){
		                  return caml_trampoline_cps_call3(a, pp$36, id$0, cont);
		                 });
		       var
		        op = match[1],
		        open =
		          o
		           ([0,
		             symbol_bind$4,
		             symbol_map$4,
		             Let_syntax$2,
		             ,
		             bind$6,
		             of_string$14,
		             map$15]),
		        let$ = open[4];
		       function a(param, cont){
		        return caml_exact_trampoline_cps_call$1
		                (get_page$1,
		                 ctrl,
		                 id$0,
		                 function(match){
		                  if(! match) return cont(0);
		                  var previous_page = match[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (value_map,
		                           previous_page[1][3][5],
		                           cst$1,
		                           to_string$30,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$0
		                                    (value_map,
		                                     parent,
		                                     cst$1,
		                                     to_string$30,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$2
		      (push$3, ctrl, id$0, source, [1, [0, b, a]], cont);
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call$2
		               (apply$125,
		                ctrl[1],
		                crdt,
		                workspace,
		                op,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$177,
		     function(b){
		      return caml_trampoline_cps_call3
		              (b,
		               pp$36,
		               id$0,
		               function(b){
		                return caml_exact_trampoline_cps_call$7
		                        (with_state, ctrl, crdt, workspace, b, baI, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function unarchive(ctrl, crdt, id$0, source, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (workspace_of_id,
		                         ctrl,
		                         id$0,
		                         function(workspace){
		                          return caml_exact_trampoline_cps_call
		                                  (Logs$17[6][6],
		                                   function(m, cont){
		                                    return caml_trampoline_cps_call6
		    (m, 0, 0, baJ, pp$36, id$0, cont);
		                                   },
		                                   function(match){
		                                    function a(state, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (unarchive_page,
		      state,
		      id$0,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fail_result,
		                 baL,
		                 function(a){
		                  return caml_trampoline_cps_call3(a, pp$36, id$0, cont);
		                 });
		       var op = match[1];
		       return caml_exact_trampoline_cps_call$2
		               (apply$125,
		                ctrl[1],
		                crdt,
		                workspace,
		                op,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (fatal_result,
		                          baK,
		                          a,
		                          function(match){
		                           return caml_exact_trampoline_cps_call$1
		                                   (get_page,
		                                    state,
		                                    id$0,
		                                    function(page$0){
		                                     function a(a){
		                                      return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                                     }
		                                     if(! page$0) return a();
		                                     var page$1 = page$0[1];
		                                     return caml_exact_trampoline_cps_call$2
		     (push$3,
		      ctrl,
		      page$1[2],
		      source,
		      a_J,
		      function(b){
		       b = [0, page(page$1), a_K];
		       return caml_exact_trampoline_cps_call$0
		               (notify$0(ctrl), 0, 0, b, a);
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_trampoline_cps_call2
		    (of_string$14,
		     0,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$178,
		               function(c){
		                return caml_trampoline_cps_call3
		                        (c,
		                         pp$36,
		                         id$0,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$7
		                                  (with_state, ctrl, crdt, workspace, c, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update$16(ctrl, crdt, id$0, patch, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$17[6][6],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_patch, patch, Patch$2[5]), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, a], baM, pp$36, id$0, cont);
		                                   });
		                         },
		                         function(b){
		                          b = patch[2];
		                          function a(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (workspace_of_id,
		                                    ctrl,
		                                    id$0,
		                                    function(workspace){
		                                     function a(state, cont){
		                                      return caml_exact_trampoline_cps_call
		      (today,
		       dummy,
		       function(date){
		        var time = ocaml_ptime_clock_now_d_ps();
		        return caml_exact_trampoline_cps_call$3
		                (update_from_patch$1,
		                 date,
		                 state,
		                 time,
		                 patch,
		                 id$0,
		                 function(op_o){
		                  if(! op_o)
		                   return caml_exact_trampoline_cps_call
		                           (fail_result,
		                            baN,
		                            function(a){
		                             return caml_trampoline_cps_call3(a, pp$36, id$0, cont);
		                            });
		                  var op = op_o[1];
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125, ctrl[1], crdt, workspace, op, cont);
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$179,
		      function(b){
		       return caml_trampoline_cps_call3
		               (b,
		                pp$36,
		                id$0,
		                function(b){
		                 return caml_exact_trampoline_cps_call$7
		                         (with_state, ctrl, crdt, workspace, b, baO, a, cont);
		                });
		      });
		                                    });
		                          }
		                          var match = patch[4];
		                          if(! b)
		                           return match
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (get_page$1,
		                                      ctrl,
		                                      id$0,
		                                      function(match){
		                                       return match
		       ? caml_exact_trampoline_cps_call$2
		         (push$3, ctrl, id$0, source, a_G, a)
		       : a();
		                                      })
		                                   : a();
		                          var content = b[1];
		                          return caml_exact_trampoline_cps_call$2
		                                  (edited, ctrl, [2, id$0], content, source, a);
		                         });
		               }
		               function get$29(param){}
		               var
		                bSa = By_date[110],
		                include$326 =
		                  caml_callback
		                   (Make_object,
		                    [[0,
		                      ,
		                      bQI,
		                      ,
		                      notes$9,
		                      with_notes$2,
		                      ,
		                      ,
		                      cst_people,
		                      lookup$3],
		                     [0, get$29]]),
		                Logs$18 = include$326[1],
		                get$30 = include$326[3];
		               function by_email(ctrl, email, cont){
		                var
		                 content = ctrl[18][1],
		                 by_email = content[2],
		                 Incr = content[1],
		                 open =
		                   g
		                    ([0,
		                      Incr[72],
		                      Incr[73],
		                      ,
		                      Incr[75],
		                      Incr[76],
		                      Incr[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Incr[82]]),
		                 let$ = open[8];
		                function a(users, cont){
		                 return caml_exact_trampoline_cps_call
		                         (min_elt$3,
		                          users,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$17,
		                                    a,
		                                    get_data,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(Incr[76], a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         by_email[2],
		                         email,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function refresh$2(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call(return$11, 0, cont);
		               }
		               function update$17(ctrl, crdt, people_id, patch, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$18[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_patch, patch, schema$141), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, a], baP, pp$114, people_id, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_from_state$2,
		                                   ctrl[9],
		                                   people_id,
		                                   function(original_person){
		                                    var time = ocaml_ptime_clock_now_d_ps();
		                                    return caml_exact_trampoline_cps_call
		    (today,
		     dummy,
		     function(today){
		      return caml_exact_trampoline_cps_call
		              (state_personal,
		               ctrl[2],
		               function(state){
		                function f(person, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (update_person_from_patch_cas,
		                          [0, [0, today, time, state]],
		                          patch,
		                          person,
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_person,
		                         state,
		                         people_id,
		                         function(x){
		                          return caml_trampoline_cps_call3
		                                  (bind$8,
		                                   x,
		                                   f,
		                                   function(op){
		                                    function a(b){
		                                     function a(a){return cont(0);}
		                                     if(! original_person) return a();
		                                     var original_person$0 = original_person[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (get_from_state$2,
		      ctrl[9],
		      people_id,
		      function(match){
		       if(match)
		        var p = match[1], patched_person = p;
		       else
		        patched_person = original_person$0;
		       return caml_exact_trampoline_cps_call$1
		               (equal$217,
		                patch,
		                [0, 0, 0, 0],
		                function(c){
		                 function b(b){
		                  b = patch[1];
		                  var c = [3, people_id];
		                  if(! b) return a();
		                  var v = b[1];
		                  return caml_exact_trampoline_cps_call$2
		                          (edited, ctrl, c, v, source, a);
		                 }
		                 if(c) return b(0);
		                 function push_metric(property_name, cont){
		                  var
		                   workspace_id = personal_workspace_id(ctrl[2]),
		                   a =
		                     object$0
		                      ([3, original_person$0[1]],
		                       workspace_id,
		                       source,
		                       [0, property_name]);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait$0, ctrl[11], 0, a, cont);
		                 }
		                 var c = patch[2];
		                 if(c)
		                  return c[1]
		                          ? caml_exact_trampoline_cps_call
		                            (push_metric,
		                             cst_archived,
		                             function(match){
		                              return caml_exact_trampoline_cps_call
		                                      (text$3,
		                                       a_T,
		                                       function(d){
		var a = [0, d, 0], c = person_display_name(patched_person);
		return caml_exact_trampoline_cps_call
		        (highlight,
		         a_U,
		         function(d){
		          return caml_trampoline_cps_call2
		                  (d,
		                   c,
		                   function(d){
		                    var c = [0, d, a];
		                    return caml_exact_trampoline_cps_call
		                            (text$3,
		                             a_V,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$0
		                                      (notify$0(ctrl), 0, 0, [0, a, c], b);
		                             });
		                   });
		         });
		                                       });
		                             })
		                          : caml_exact_trampoline_cps_call
		                            (push_metric,
		                             cst_archived,
		                             function(match){
		                              return caml_exact_trampoline_cps_call
		                                      (text$3,
		                                       a_W,
		                                       function(d){
		var a = [0, d, 0], c = person_display_name(patched_person);
		return caml_exact_trampoline_cps_call
		        (highlight,
		         a_X,
		         function(d){
		          return caml_trampoline_cps_call2
		                  (d,
		                   c,
		                   function(d){
		                    var c = [0, d, a];
		                    return caml_exact_trampoline_cps_call
		                            (text$3,
		                             a_Y,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$0
		                                      (notify$0(ctrl), 0, 0, [0, a, c], b);
		                             });
		                   });
		         });
		                                       });
		                             });
		                 return caml_exact_trampoline_cps_call
		                         (text$3,
		                          a_Z,
		                          function(d){
		                           var a = [0, d, 0], c = person_display_name(patched_person);
		                           return caml_exact_trampoline_cps_call
		                                   (highlight,
		                                    a_0,
		                                    function(d){
		                                     return caml_trampoline_cps_call2
		     (d,
		      c,
		      function(d){
		       var c = [0, d, a];
		       return caml_exact_trampoline_cps_call
		               (text$3,
		                a_1,
		                function(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (notify$0(ctrl), 0, 0, [0, a, c], b);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var b = ctrl[1];
		                                    if(! op) return a();
		                                    var v = op[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (apply_personal, b, crdt, v, a);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                schematic_cache$889 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$930 = [];
		               caml_update_dummy
		                (letrec_function_context$930, [0, schematic_cache$889]);
		               var
		                schematic_schema_version$57 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$930[1][1],
		                     schematic_schema_version$57]);
		               if(e)
		                var schema$251 = e[1], descriptor$56 = schema$251;
		               else
		                descriptor$56 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$930[1][1],
		                              schematic_schema_version$57,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$930[1][1],
		 schematic_schema_version$57,
		 schematic_self,
		 function(a){
		  letrec_function_context$930[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$120,
		           dummy,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 function(f0, cont){return cont([2, f0]);},
		                 function(param, cont){
		                  if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                  return cont(0);
		                 },
		                 0,
		                 0,
		                 "workspace_write_forbidden",
		                 "Workspace_write_forbidden",
		                 b,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (schema_versioned$120,
		                     dummy,
		                     function(b){
		                      var
		                       res =
		                         [11,
		                          baS,
		                          [0,
		                           [0,
		                            function(f0, cont){return cont([0, f0]);},
		                            function(param, cont){
		                             if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                             return cont(0);
		                            },
		                            1,
		                            0,
		                            "duplicate_data_name",
		                            "Duplicate_data_name",
		                            [0,
		                             0,
		                             0,
		                             [7,
		                              function(param, cont){
		                               var name = param[1];
		                               return cont(name);
		                              },
		                              function(name, cont){return cont([0, name, 0]);},
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_name,
		                                0,
		                                2,
		                                [0, schematic_param_name_schema_ve],
		                                0,
		                                0],
		                               0]],
		                             0],
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(0);},
		                             function(param, cont){
		                              return typeof param === "number" ? cont(baR) : cont(0);
		                             },
		                             0,
		                             0,
		                             "not_a_record_type",
		                             "Not_a_record_type",
		                             [0,
		                              0,
		                              0,
		                              [7,
		                               function(param, cont){return cont(0);},
		                               function(param, cont){return cont(0);},
		                               0],
		                              0],
		                             0],
		                            [0,
		                             [0,
		                              function(f0, cont){return cont([1, f0]);},
		                              function(param, cont){
		                               if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                               return cont(0);
		                              },
		                              0,
		                              0,
		                              "workspace_not_found",
		                              "Workspace_not_found",
		                              b,
		                              0],
		                             a]]],
		                          0];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$930[1][1],
		                               schematic_schema_version$57,
		                               res,
		                               function(a){
		                                letrec_function_context$930[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                upsert_database_error_schema = [0, baQ, 0, descriptor$56, 0],
		                letrec_function_context$931 = [];
		               function pp_upsert_database_error(fmt, param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_string,
		                          fmt,
		                          "Controller_graph_intf.Not_a_record_type",
		                          cont);
		                switch(param[0]){
		                  case 0:
		                   var aname = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            baT,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      baU,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        cst_name,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt),
		                  baV,
		                  function(a){
		                   return caml_trampoline_cps_call2
		                           (a,
		                            aname,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (fprintf$0(fmt),
		                                      baW,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (fprintf$0(fmt), baX, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var a0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            baY,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$931[2],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), baZ, cont);
		        });
		                                      });
		                            });
		                  default:
		                   var a0$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(fmt),
		                            ba0,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (letrec_function_context$931[1],
		                                      fmt,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (a,
		        a0$0,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (fprintf$0(fmt), ba1, cont);
		        });
		                                      });
		                            });
		                }
		               }
		               function show_upsert_database_error(x, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$180,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a, pp_upsert_database_error, x, cont);
		                         });
		               }
		               caml_update_dummy
		                (letrec_function_context$931, [0, pp$46, pp$46]);
		               function compile$0(G, vars, workspace, ast, cont){
		                var
		                 a = G[2],
		                 open =
		                   g([0, a[72], a[73], , a[75], a[76], a[77], , , , , a[82]]),
		                 let$ = open[17];
		                function b(query, cont){
		                 return caml_trampoline_cps_call2
		                         (G[1][9][1],
		                          query,
		                          function(match){
		                           var t = match[1];
		                           return caml_trampoline_cps_call2
		                                   (G[1][4][52],
		                                    t,
		                                    function(t){
		                                     var
		                                      buffer = create$1(4096),
		                                      fmt = formatter_of_buffer(buffer);
		                                     return caml_exact_trampoline_cps_call$1
		     (pp_set_margin,
		      fmt,
		      1024,
		      function(match){
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(fmt),
		                ba2,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (a,
		                          pp_expression$0,
		                          ast,
		                          function(match){
		                           return caml_exact_trampoline_cps_call
		                                   (contents,
		                                    buffer,
		                                    function(name){
		                                     return cont
		     ([0,
		       t,
		       function(param, cont){
		        return caml_trampoline_cps_call3
		                (G[15],
		                 name,
		                 query,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (of_incremental, 0, a, cont);
		                 });
		       }]);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call4
		                        (G[12],
		                         vars,
		                         workspace,
		                         ast,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$,
		                                   a,
		                                   b,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function run$4(param, cont){
		                var run = param[2];
		                return caml_trampoline_cps_call2(run, 0, cont);
		               }
		               function compile_command(G, bindings, workspace, ast, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$4,
		                      symbol_map$4,
		                      Let_syntax$2,
		                      ,
		                      bind$6,
		                      of_string$14,
		                      map$15]),
		                 let$ = open[4];
		                function a(command, cont){
		                 return caml_trampoline_cps_call2
		                         (G[1][8][1],
		                          command,
		                          function(match){
		                           var t = match[1];
		                           return caml_trampoline_cps_call2
		                                   (G[1][4][52],
		                                    t,
		                                    function(typ){
		                                     return cont
		     ([0,
		       typ,
		       function(param, cont){
		        return caml_trampoline_cps_call2(G[17], command, cont);
		       },
		       G[16]]);
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call4
		                        (G[13],
		                         bindings,
		                         workspace,
		                         ast,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function run_command_once(param, cont){
		                var controller_writable = param[3], run = param[2];
		                return caml_trampoline_cps_call3
		                        (map$23, controller_writable, run, cont);
		               }
		               function add_database
		               (G,
		                name,
		                description,
		                database_name,
		                meta,
		                workspace,
		                type,
		                cont){
		                return caml_trampoline_cps_call7
		                        (G[4],
		                         workspace,
		                         name,
		                         description,
		                         database_name,
		                         meta,
		                         type,
		                         cont);
		               }
		               function databases(G, cont){
		                return caml_trampoline_cps_call2(G[5], 0, cont);
		               }
		               function get_database(G, workspace, id, cont){
		                return caml_trampoline_cps_call3(G[7], workspace, id, cont);
		               }
		               function get$31(G, id, cont){
		                return caml_trampoline_cps_call2(G[10][1], id, cont);
		               }
		               function display_value(G, id, cont){
		                return caml_trampoline_cps_call2(G[10][2], id, cont);
		               }
		               function create$52(graph, workspace_id, table_id, fields, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14],
		                 symbol = open[13],
		                 symbol_map = open[2],
		                 open$0 = g(include$0),
		                 let$0 = open$0[14],
		                 let$1 = open$0[8];
		                function a(cmd, cont){
		                 function a(param, cont){
		                  if(typeof param !== "number" && 7 === param[0]){
		                   var row_id_str = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (include$51[6],
		                            row_id_str,
		                            function(a){
		                             return caml_trampoline_cps_call2(return$12, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (fail$2, "Unexpected result from add command", cont);
		                 }
		                 function b(t, cont){
		                  if(0 === t[0]) return cont(t);
		                  var x = t[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (to_to_string, pp$30, x, function(a){return cont([1, a]);});
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (run_command_once,
		                          cmd,
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(symbol, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (graph[5],
		                         0,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   b,
		                                   function(dbs){
		                                    function b(db, cont){
		                                     var init = empty$11([0, comparator$2]);
		                                     function a(t, init){
		                                      if(t){
		                                       var
		l = t[2],
		a$0 = t[1],
		acc = init[2],
		i = init[1],
		v = a$0[2];
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$181,
		        function(b){
		         return caml_trampoline_cps_call2
		                 (b,
		                  i,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (set$3,
		                            acc,
		                            b,
		                            v,
		                            function(b){
		                             var init = [0, i + 1 | 0, b];
		                             return caml_exact_trampoline_call2(a, l, init);
		                            });
		                  });
		        });
		                                      }
		                                      var bindings = init[2];
		                                      return caml_exact_trampoline_cps_call$1
		      (mapi$0,
		       fields,
		       function(i, param, cont){
		        var name = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (kasprintf,
		                 id,
		                 fmt$182,
		                 function(a){
		                  return caml_trampoline_cps_call2
		                          (a,
		                           i,
		                           function(s){
		                            var value = [12, [0, s]];
		                            return cont([0, name, [0, value, none$2]]);
		                           });
		                 });
		       },
		       function(field_pairs){
		        var value = [13, field_pairs], s = db[2];
		        return caml_exact_trampoline_cps_call$2
		                (compile_command,
		                 graph,
		                 [0, bindings],
		                 workspace_id,
		                 [0,
		                  [0,
		                   [0, [0, [12, [0, s]], none$2]],
		                   [0, [0, [0, value, none$2]], none$2]],
		                  none$2],
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$183,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b,
		                                     pp$30,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (map_error, a, b, cont);
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return a(fields, [0, 0, init]);
		                                    }
		                                    function c(m, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id, m, table_id, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     dbs,
		     workspace_id,
		     function(d){
		      return caml_exact_trampoline_cps_call$1
		              (let$1,
		               d,
		               c,
		               function(d){
		                var c = Table[1];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$184,
		                         function(e){
		                          return caml_trampoline_cps_call3
		                                  (e,
		                                   c,
		                                   table_id,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$1
		    (let$0,
		     of_option(d, c),
		     b,
		     function(b){
		      return caml_trampoline_cps_call2
		              (return$12,
		               b,
		               function(b){
		                return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function set$28(graph, param, field, value, cont){
		                var
		                 row_id = param[3],
		                 table_id = param[2],
		                 workspace_id = param[1],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[17],
		                 let$0 = open[14],
		                 symbol_map = open[2],
		                 open$0 = g(include$0),
		                 let$1 = open$0[14],
		                 let$2 = open$0[8];
		                function a(cmd, cont){
		                 function a(param, cont){return cont(0);}
		                 function b(t, cont){
		                  if(0 === t[0]) return cont(t);
		                  var x = t[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (to_to_string, pp$30, x, function(a){return cont([1, a]);});
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (run_command_once,
		                          cmd,
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (value_exn,
		                         ba3,
		                         0,
		                         0,
		                         workspace_id,
		                         function(workspace_id){
		                          return caml_trampoline_cps_call2
		                                  (graph[5],
		                                   0,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (get$17,
		     b,
		     function(dbs){
		      function b(db, cont){
		       return caml_exact_trampoline_cps_call
		               (include$51[8],
		                row_id,
		                function(row_id_str){
		                 return caml_exact_trampoline_cps_call$0
		                         (set$3,
		                          empty$11([0, comparator$2]),
		                          cst_row_id,
		                          [7, row_id_str],
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (set$3,
		                                    a,
		                                    cst_value,
		                                    value,
		                                    function(bindings){
		                                     var
		                                      value = [0, [0, field]],
		                                      a = [0, [12, [0, cst_value]], none$2];
		                                     return caml_exact_trampoline_cps_call
		     (of_list_exn,
		      [0, [0, value, none$2], 0],
		      function(b){
		       var value = [2, b, a], s = db[2];
		       return caml_exact_trampoline_cps_call$2
		               (compile_command,
		                graph,
		                [0, bindings],
		                workspace_id,
		                [0,
		                 [0,
		                  [0,
		                   [0,
		                    [17,
		                     [0, [12, [0, s]], none$2],
		                     [0, [12, [0, cst_row_id]], none$2]],
		                    none$2]],
		                  [0, value, none$2]],
		                 none$2],
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$185,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    pp$30,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (map_error, a, b, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      function c(m, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id, m, table_id, cont);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (find_packed_by_id,
		               dbs,
		               workspace_id,
		               function(d){
		                return caml_exact_trampoline_cps_call$1
		                        (let$2,
		                         d,
		                         c,
		                         function(d){
		                          var c = Table[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$186,
		                                   function(e){
		                                    return caml_trampoline_cps_call3
		    (e,
		     c,
		     table_id,
		     function(c){
		      return caml_exact_trampoline_cps_call$1
		              (let$1,
		               of_option(d, c),
		               b,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (return$12,
		                         b,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update_database
		               (G,
		                workspace,
		                id,
		                name,
		                description,
		                database_name,
		                meta,
		                type,
		                cont){
		                return caml_trampoline_cps_call8
		                        (G[11],
		                         workspace,
		                         id,
		                         name,
		                         description,
		                         database_name,
		                         meta,
		                         type,
		                         cont);
		               }
		               function personal_workspace_id$0(G, cont){
		                return caml_trampoline_cps_call2(G[18], 0, cont);
		               }
		               function update_task(graph, id$0, patch, cont){
		                var
		                 row_id = id$0[3],
		                 table_id = id$0[2],
		                 workspace_id = id$0[1],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 and = open[15],
		                 let$ = open[14],
		                 and$0 = open[9],
		                 let$0 = open[8],
		                 let$1 = open[4],
		                 symbol_map = open[2],
		                 match = patch[9],
		                 url = match[3],
		                 title = match[2],
		                 starred = patch[8],
		                 scheduled = patch[7],
		                 completed = patch[2],
		                 archived = patch[1];
		                function a(workspace_id, cont){
		                 function a(param, cont){
		                  var
		                   binding = param[2],
		                   binding_id = param[1],
		                   open =
		                     g
		                      ([0,
		                        symbol_bind$5,
		                        symbol_map$5,
		                        ,
		                        bind$8,
		                        return$9,
		                        map$17,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Let_syntax$3]),
		                   let$2 = open[3];
		                  function a(database, cont){
		                   function set_column(column, result, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             database[6][1],
		                             column,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call(return_ok, 0, cont);
		                              var field = match[1];
		                              return caml_exact_trampoline_cps_call$2
		                                      (set$28,
		                                       graph,
		                                       id$0,
		                                       field[1][3],
		                                       result,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (map_error$0,
		         function(msg, cont){return cont([0, 9943782, msg]);},
		         a,
		         cont);
		                                       });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (title_field$0,
		                            database,
		                            function(title_column){
		                             function a(param, cont){
		                              return caml_exact_trampoline_cps_call(return_ok, 0, cont);
		                             }
		                             function b(param, cont){
		                              var title = param[2], column = param[1][1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (set_column,
		                                       column,
		                                       [7, title],
		                                       function(a){
		return caml_trampoline_cps_call3
		        (symbol_map, a, return$9, cont);
		                                       });
		                             }
		                             return caml_trampoline_cps_call2
		                                     (return$12,
		                                      title_column,
		                                      function(left){
		                                       return caml_trampoline_cps_call2
		       (return$12,
		        patch[9][2],
		        function(c){
		         return caml_exact_trampoline_cps_call$1
		                 (and$0,
		                  left,
		                  c,
		                  function(c){
		                   return caml_exact_trampoline_cps_call$1
		                           (let$0,
		                            c,
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (map$23,
		                                      b,
		                                      function(a, cont){return cont(value$4(a, ba4));},
		                                      function(left){
		                                       function b(a, cont){
		var
		 discarded = a[4],
		 done = a[3],
		 todo = a[2],
		 column = a[1];
		a:
		{
		 var
		  b =
		    function(status, cont){
		     return caml_exact_trampoline_cps_call$1
		             (set_column,
		              column,
		              status,
		              function(a){
		               return caml_trampoline_cps_call3
		                       (symbol_map, a, return$9, cont);
		              });
		    };
		 if(completed){
		  if(completed[1]){a = [0, done[2]]; break a;}
		 }
		 else if(! archived){a = 0; break a;}
		 if(archived && archived[1]){a = [0, discarded[2]]; break a;}
		 a = [0, todo[2]];
		}
		return caml_trampoline_cps_call2
		        (return$12,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$1(let$0, a, b, cont);
		         });
		                                       }
		                                       return caml_trampoline_cps_call2
		       (return$12,
		        binding[1][4],
		        function(c){
		         return caml_exact_trampoline_cps_call$1
		                 (let$0,
		                  c,
		                  b,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (map$23,
		                            b,
		                            function(a, cont){return cont(value$4(a, ba5));},
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (and,
		                                      left,
		                                      b,
		                                      function(left){
		                                       function b(scheduled, cont){
		function a(column, cont){
		 function a(result){
		  return caml_exact_trampoline_cps_call$1
		          (set_column,
		           column,
		           result,
		           function(a){
		            return caml_trampoline_cps_call3
		                    (symbol_map, a, return$9, cont);
		           });
		 }
		 if(scheduled){
		  var match = scheduled[1];
		  if(0 !== match[0]){
		   var d = match[1];
		   return caml_exact_trampoline_cps_call(of_date$3, d, a);
		  }
		 }
		 return a(0);
		}
		return caml_trampoline_cps_call2
		        (return$12,
		         binding[1][5],
		         function(b){
		          return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		         });
		                                       }
		                                       return caml_trampoline_cps_call2
		       (return$12,
		        scheduled,
		        function(c){
		         return caml_exact_trampoline_cps_call$1
		                 (let$0,
		                  c,
		                  b,
		                  function(b){
		                   return caml_trampoline_cps_call3
		                           (map$23,
		                            b,
		                            function(a, cont){return cont(value$4(a, ba6));},
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (and,
		                                      left,
		                                      b,
		                                      function(left){
		                                       function b(param, cont){
		var column = param[2], url = param[1];
		function a(result){
		 return caml_exact_trampoline_cps_call$1
		         (set_column,
		          column,
		          result,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (symbol_map, a, return$9, cont);
		          });
		}
		if(! url) return a(0);
		var u = url[1];
		return caml_exact_trampoline_cps_call$1
		        (to_string$25, 0, u, function(b){return a([7, b]);});
		                                       }
		                                       return caml_trampoline_cps_call2
		       (return$12,
		        url,
		        function(left$0){
		         return caml_trampoline_cps_call2
		                 (return$12,
		                  binding[1][6],
		                  function(c){
		                   return caml_exact_trampoline_cps_call$1
		                           (and$0,
		                            left$0,
		                            c,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$1
		                                     (let$0,
		                                      c,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (map$23,
		        b,
		        function(a, cont){return cont(value$4(a, ba7));},
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (and,
		                  left,
		                  b,
		                  function(left){
		                   function b(title, cont){
		                    function a(param, cont){
		                     var column = param[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (set_column,
		                              column,
		                              [7, title],
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (symbol_map, a, return$9, cont);
		                              });
		                    }
		                    var b = database[5];
		                    return caml_exact_trampoline_cps_call$1
		                            (map$13,
		                             database[6][1],
		                             function(fwo, cont){return cont(fwo[1]);},
		                             function(c){
		                              return caml_exact_trampoline_cps_call$1
		                                      (title_field,
		                                       c,
		                                       b,
		                                       function(b){
		return caml_trampoline_cps_call2
		        (return$12,
		         b,
		         function(b){
		          return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		         });
		                                       });
		                             });
		                   }
		                   return caml_trampoline_cps_call2
		                           (return$12,
		                            title,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$1
		                                     (let$0,
		                                      c,
		                                      b,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (map$23,
		        b,
		        function(a, cont){return cont(value$4(a, ba8));},
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (and,
		                  left,
		                  b,
		                  function(left){
		                   var scheduling = binding[1][5] ? 0 : scheduled;
		                   a:
		                   {
		                    if(completed){
		                     var b = completed[1];
		                     if(b){
		                      var
		                       time = b[1],
		                       discarded = ba9,
		                       status_changed_at = [0, [0, time]];
		                      break a;
		                     }
		                    }
		                    else if(! archived){
		                     discarded = 0;
		                     status_changed_at = 0;
		                     break a;
		                    }
		                    if(archived){
		                     b = archived[1];
		                     if(b)
		                      var
		                       time$0 = b[1],
		                       discarded = ba$,
		                       status_changed_at = [0, [0, time$0]];
		                     else {discarded = bQ; status_changed_at = bR;}
		                    }
		                    else {discarded = bQ; status_changed_at = bR;}
		                   }
		                   function c(b){
		                    return caml_exact_trampoline_cps_call$1
		                            (and,
		                             left,
		                             b,
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                             });
		                   }
		                   if
		                    (!
		                     scheduling
		                     && ! status_changed_at && ! discarded && ! starred)
		                    return caml_exact_trampoline_cps_call(return_ok, 0, c);
		                   var ctrl = graph[3];
		                   function d(crdt, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (task_binding_workspace,
		                             ctrl[2],
		                             binding_id,
		                             function(match){
		                              if(! match) return cont(ba_);
		                              var binding_workspace_id = match[1];
		                              return caml_exact_trampoline_cps_call$8
		                                      (set_row,
		                                       binding_id,
		                                       row_id,
		                                       scheduling,
		                                       status_changed_at,
		                                       discarded,
		                                       starred,
		                                       dummy,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (task_bindings,
		         a,
		         function(a){
		          return caml_exact_trampoline_cps_call$2
		                  (apply$125,
		                   ctrl[1],
		                   crdt,
		                   binding_workspace_id,
		                   a,
		                   function(t){
		                    if(0 === t[0]) return cont(t);
		                    var error = t[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (to_to_string,
		                             pp$125,
		                             error,
		                             function(a){return cont([1, [0, 9943782, a]]);});
		                   });
		         });
		                                       });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (writable$0,
		                            ctrl[2],
		                            function(a){
		                             return caml_trampoline_cps_call3(let$1, a, d, c);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  }
		                  function b(workspace, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id, workspace, table_id, cont);
		                  }
		                  return caml_trampoline_cps_call2
		                          (graph[5],
		                           0,
		                           function(c){
		                            return caml_exact_trampoline_cps_call
		                                    (get$17,
		                                     c,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       c,
		       workspace_id,
		       function(c){
		        return caml_trampoline_cps_call3
		                (let$2,
		                 c,
		                 b,
		                 function(c){
		                  var b = Table[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$187,
		                           function(d){
		                            return caml_trampoline_cps_call5
		                                    (d,
		                                     pp$46,
		                                     workspace_id,
		                                     b,
		                                     table_id,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       of_option(c, [0, 9943782, b]),
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (task_bindings$0,
		                          graph[3][9],
		                          function(c){
		                           function b(param){
		                            function c(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$188,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (c,
		        _33,
		        id$0,
		        function(c){
		         return caml_trampoline_cps_call2
		                 (return$12,
		                  of_option(b, [0, 9943782, c]),
		                  function(b){
		                   return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                  });
		        });
		                                      });
		                            }
		                            if(! param) return c(0);
		                            var l = param[2], x = param[1], binding = x[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (symbol$139,
		                                     binding[1][1],
		                                     workspace_id,
		                                     function(d){
		                                      function a(a){
		                                       return a ? c([0, x]) : caml_exact_trampoline_call1(b, l);
		                                      }
		                                      return d
		      ? caml_exact_trampoline_cps_call$1
		        (Table[11], binding[1][2], table_id, a)
		      : a(d);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$1(to_alist$0, 0, c, b);
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (return$12,
		                         of_option(workspace_id, bba),
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               }
		               function unplanned(graph, cont){
		                var ctrl = graph[3];
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           unplanned = param[2][8],
		                           Inc = param[1],
		                           open =
		                             g
		                              ([0,
		                                Inc[72],
		                                Inc[73],
		                                ,
		                                Inc[75],
		                                Inc[76],
		                                Inc[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Inc[82]]),
		                           let$ = open[4];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   unplanned,
		                                   function(unplanned, cont){
		                                    return caml_trampoline_cps_call3
		    (map$18, unplanned, id$36, cont);
		                                   },
		                                   function(unplanned){
		                                    function a(x, y, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (equal_with_local_closure, equal$55, x, y, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol$230,
		     unplanned,
		     cst_unplanned,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (of_incremental, 0, symbol$229(b, a), cont);
		     });
		                                   });
		                         },
		                         function(b){
		                          function a(id, cont){return cont([1, id]);}
		                          var
		                           tasks =
		                             map$53
		                              (b,
		                               function(b, cont){
		                                return caml_trampoline_cps_call3(map$18, b, a, cont);
		                               });
		                          return caml_trampoline_cps_call2
		                                  (graph[25],
		                                   0,
		                                   function(objects){
		                                    return caml_exact_trampoline_cps_call$0
		    (map2$2, tasks, objects, append$0, cont);
		                                   });
		                         });
		               }
		               function get$32(graph, param, cont){
		                if(0 === param[0]){
		                 var id = param[1];
		                 return caml_trampoline_cps_call2(graph[29], id, cont);
		                }
		                var id$0 = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (get$22,
		                         graph[3],
		                         id$0,
		                         function(b){
		                          function a(param, cont){
		                           var task = param[2], integration_status = param[1];
		                           return cont
		                                   ([0,
		                                     integration_status,
		                                     0,
		                                     1,
		                                     1,
		                                     1,
		                                     1,
		                                     1,
		                                     [0,
		                                      task[1],
		                                      task[2],
		                                      task[3],
		                                      task[4],
		                                      task[5],
		                                      [1, task[6]],
		                                      task[7]]]);
		                          }
		                          return cont
		                                  (map$53
		                                    (b,
		                                     function(b, cont){
		                                      return caml_trampoline_cps_call3(map$17, b, a, cont);
		                                     }));
		                         });
		               }
		               function update$18(graph, crdt, id, patch, source, cont){
		                if(0 === id[0]){
		                 var id$0 = id[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (update_task, graph, id$0, patch, cont);
		                }
		                var id$1 = id[1];
		                return caml_exact_trampoline_cps_call$3
		                        (update$13,
		                         graph[3],
		                         crdt,
		                         id$1,
		                         patch,
		                         source,
		                         function(a){
		                          return caml_trampoline_cps_call2(return$12, a, cont);
		                         });
		               }
		               function day$2(graph, controller, date, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$14[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, a$c, pp_v1$0, date, cont);
		                         },
		                         function(a){
		                          a = controller[23][1];
		                          var
		                           tasks = a[2],
		                           Inc = a[1],
		                           open =
		                             g
		                              ([0,
		                                Inc[72],
		                                Inc[73],
		                                ,
		                                Inc[75],
		                                Inc[76],
		                                Inc[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Inc[82]]),
		                           let$ = open[4];
		                          function b(task_of_date, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (day_entries_of_tasks, value$4(task_of_date, 0), cont);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$6,
		                                   tasks,
		                                   [1, [1, date]],
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (let$,
		     a,
		     b,
		     function(v){
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$153,
		               function(a){
		                return caml_trampoline_cps_call3
		                        (a,
		                         pp_v1$0,
		                         date,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$230,
		                                   v,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental,
		     0,
		     a,
		     function(task_entries){
		      return caml_trampoline_cps_call2
		              (graph[28],
		               date,
		               function(object_entries){
		                return caml_exact_trampoline_cps_call$0
		                        (map2$2,
		                         task_entries,
		                         object_entries,
		                         function(a, b, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (append$0,
		                                   a,
		                                   b,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (day_of_entries, a, cont);
		                                   });
		                         },
		                         cont);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function Make$59(Result){
		                function length(param){
		                 if(! param) return 0;
		                 var tl = param[2];
		                 return 1 + length(tl) | 0;
		                }
		                function encode(Coding, formal, call, cont){
		                 function encode(formal, call, effective, cont){
		                  if(! formal)
		                   return caml_exact_trampoline_cps_call
		                           (of_rev_keys,
		                            effective,
		                            function(a){
		                             return caml_exact_trampoline_cps_call(call, a, cont);
		                            });
		                  var formal$0 = formal[2], schema = formal[1][2];
		                  return cont
		                          (function(arg, cont){
		                            return caml_trampoline_cps_call3
		                                    (Coding[2],
		                                     schema,
		                                     arg,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$0
		      (encode, formal$0, call, [0, a, effective], cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (encode, formal, call, 0, cont);
		                }
		                var
		                 Rpc_error =
		                   [248,
		                    "Controller_lib__Rpc_intf.Args.Make(Result).Rpc_error",
		                    caml_fresh_oo_id()];
		                function fail(fmt, cont){
		                 function f(error, a){
		                  a = caml_pop_trap();
		                  return a
		                          (caml_maybe_attach_backtrace([0, Rpc_error, error], 1));
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf, f, fmt, cont);
		                }
		                function decode
		                (rpc_name, Coding, formal$0, formal, effective, cont){
		                 function a(f, formal, effective){
		                  function c(a){caml_pop_trap(); return cont([0, a]);}
		                  if(! formal)
		                   return effective
		                           ? caml_exact_trampoline_cps_call
		                             (fail,
		                              bbd,
		                              function(a){
		                               return caml_trampoline_cps_call2(a, rpc_name, c);
		                              })
		                           : c(f);
		                  var b = formal[1], match = b[3], schema = b[2], name = b[1];
		                  if(effective){
		                   var
		                    effective_tail = effective[2],
		                    effective$0 = effective[1],
		                    formal_tail = formal[2];
		                   return caml_trampoline_cps_call3
		                           (Coding[4],
		                            schema,
		                            effective$0,
		                            function(match){
		                             if(0 === match[0]){
		                              var arg = match[1];
		                              return caml_trampoline_cps_call2
		                                      (f,
		                                       arg,
		                                       function(b){
		return caml_exact_trampoline_call3
		        (a, b, formal_tail, effective_tail);
		                                       });
		                             }
		                             var e = match[1];
		                             return caml_exact_trampoline_cps_call
		                                     (fail,
		                                      bbb,
		                                      function(b){
		                                       return caml_trampoline_cps_call5
		       (b,
		        rpc_name,
		        name,
		        pp_decoding,
		        e,
		        function(b){
		         return caml_exact_trampoline_call3
		                 (a, b, formal_tail, effective_tail);
		        });
		                                      });
		                            });
		                  }
		                  if(! match)
		                   return caml_exact_trampoline_cps_call
		                           (fail,
		                            bbc,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a, rpc_name, name, pp$7, schema, c);
		                            });
		                  var formal_tail$0 = formal[2], default$ = match[1];
		                  return caml_trampoline_cps_call2
		                          (f,
		                           default$,
		                           function(f){
		                            return caml_exact_trampoline_call3(a, f, formal_tail$0, 0);
		                           });
		                 }
		                 caml_push_trap
		                  (function(exn){
		                    if(exn[1] === Rpc_error){
		                     var error = exn[2];
		                     return cont([1, error]);
		                    }
		                    var
		                     raise = caml_pop_trap(),
		                     exn$0 = caml_maybe_attach_backtrace(exn, 0);
		                    return raise(exn$0);
		                   });
		                 return a(formal$0, formal, effective);
		                }
		                return [0, , length, , encode, decode];
		               }
		               var
		                include$288 = Make$59(),
		                length$20 = include$288[2],
		                Lwt_result = Make$59(),
		                open$18 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_bind$27 = open$18[1],
		                symbol_map$24 = open$18[2],
		                let$31 = open$18[3],
		                let$32 = open$18[4],
		                symbol$232 = open$18[16],
		                let$33 = open$18[20],
		                letrec_function_context$932 = [];
		               function compare$177(lhs, rhs, cont){
		                if(0 === lhs[0]){
		                 var lhs0 = lhs[1];
		                 if(0 === rhs[0]){
		                  var rhs0 = rhs[1];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$932[3],
		                           0,
		                           function(a){
		                            return caml_trampoline_cps_call3(a, lhs0, rhs0, cont);
		                           });
		                 }
		                }
		                else {
		                 var lhs1 = lhs[2], lhs0$0 = lhs[1];
		                 if(0 !== rhs[0]){
		                  var rhs1 = rhs[2], rhs0$0 = rhs[1];
		                  return caml_trampoline_cps_call2
		                          (letrec_function_context$932[2],
		                           0,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (a,
		                                     lhs0$0,
		                                     rhs0$0,
		                                     function(x){
		                                      return 0 === x
		      ? caml_trampoline_cps_call3
		        (letrec_function_context$932[1], lhs1, rhs1, cont)
		      : cont(x);
		                                     });
		                           });
		                 }
		                }
		                function to_int(param){return 0 === param[0] ? 0 : 1;}
		                var a = to_int(rhs);
		                return cont(caml_int_compare(to_int(lhs), a));
		               }
		               function _1$57(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               function _0$56(param, a, b, cont){
		                return cont(caml_int_compare(a, b));
		               }
		               caml_update_dummy
		                (letrec_function_context$932, [0, compare$177, _1$57, _0$56]);
		               var letrec_function_context$933 = [];
		               function schema_versioned$554(schematic_version, cont){
		                return caml_trampoline_cps_call2
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$933[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bbf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$933[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$933[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$933[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$554,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_id,
		    cst_Id,
		    int_schema,
		    0],
		   [0,
		    [0,
		     function(param, cont){
		      var f1 = param[2], f0 = param[1];
		      return cont([1, f0, f1]);
		     },
		     function(param, cont){
		      if(0 === param[0]) return cont(0);
		      var f1 = param[2], f0 = param[1];
		      return cont([0, [0, f0, f1]]);
		     },
		     1,
		     0,
		     "sub_channel",
		     "Sub_channel",
		     [0,
		      0,
		      0,
		      [10,
		       function(param, cont){
		        var e1 = param[2][1], e0 = param[1];
		        return cont([0, e0, e1]);
		       },
		       function(param, cont){
		        var e1 = param[2], e0 = param[1];
		        return cont([0, e0, [0, e1, 0]]);
		       },
		       [0, int_schema, [0, a, 0]]],
		      0],
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$933[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$933[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$890 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$933, [0, schematic_cache$890]);
		               caml_callback
		                (schema_versioned$554,
		                 [function(param, cont){return cont(0);}]);
		               function pp$129(f, param, cont){
		                if(0 === param[0]){
		                 var id = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_print_int, f, id, cont);
		                }
		                var channel = param[2], id$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         bbg,
		                         function(a){
		                          return caml_trampoline_cps_call4
		                                  (a, id$0, pp$129, channel, cont);
		                         });
		               }
		               function sexp_of_t$145(param, cont){
		                if(0 === param[0]){
		                 var id = param[1];
		                 return cont([0, "" + id]);
		                }
		                var channel = param[2], id$0 = param[1];
		                return caml_exact_trampoline_cps_call
		                        (sexp_of_t$145,
		                         channel,
		                         function(a){
		                          return cont([1, [0, [0, "" + id$0], [0, a, 0]]]);
		                         });
		               }
		               var
		                include$289 = Make$2([0, compare$177, sexp_of_t$145]),
		                comparator$65 = include$289[16],
		                schematic_cache$891 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$934 = [];
		               caml_update_dummy
		                (letrec_function_context$934, [0, schematic_cache$891]);
		               var
		                schematic_schema_version$34 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$934[1][1],
		                     schematic_schema_version$34]);
		               if(e)
		                var schema$252 = e[1], descriptor$57 = schema$252;
		               else
		                descriptor$57 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$934[1][1],
		                              schematic_schema_version$34,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$934[1][1],
		 schematic_schema_version$34,
		 schematic_self,
		 function(a){
		  letrec_function_context$934[1][1] = a;
		  var
		   res =
		     [7,
		      function(param, cont){
		       var value_handle = param[2][1], storage_id = param[1];
		       return cont([0, storage_id, value_handle]);
		      },
		      function(param, cont){
		       var value_handle = param[2], storage_id = param[1];
		       return cont([0, storage_id, [0, value_handle, 0]]);
		      },
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        "storage_id",
		        0,
		        2,
		        [0, [0, 0, 0, int_schema[3], int_schema[4]]],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         "value_handle",
		         0,
		         2,
		         [0, [0, 0, 0, int_schema[3], int_schema[4]]],
		         0,
		         0],
		        0]]];
		  return caml_exact_trampoline_cps_call$0
		          (set$3,
		           letrec_function_context$934[1][1],
		           schematic_schema_version$34,
		           res,
		           function(a){
		            letrec_function_context$934[1][1] = a;
		            return cont(res);
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                remote_value_handle_schema = [0, bbh, 0, descriptor$57],
		                Retrieve =
		                  [248, "Controller_lib__Rpc.Retrieve", caml_fresh_oo_id()],
		                Store =
		                  [248, "Controller_lib__Rpc.Store", caml_fresh_oo_id()],
		                Var_local_register =
		                  [248,
		                   "Controller_lib__Rpc.Var_local_register",
		                   caml_fresh_oo_id()];
		               function call_schema(schematic_param_a_schema_versi, cont){
		                function schematic_version(param, cont){return cont(0);}
		                function descriptor(schematic_param_a_schema_versi, cont){
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$554,
		                          schematic_version,
		                          function(b){
		                           var
		                            a =
		                              [0,
		                               [0,
		                                function(f0, cont){return cont([2, f0]);},
		                                function(param, cont){
		                                 if(2 !== param[0]) return cont(0);
		                                 var f0 = param[1];
		                                 return cont([0, f0]);
		                                },
		                                1,
		                                0,
		                                cst_close,
		                                "Close",
		                                [0,
		                                 0,
		                                 0,
		                                 [7,
		                                  function(param, cont){
		                                   var channel_id = param[1];
		                                   return cont(channel_id);
		                                  },
		                                  function(channel_id, cont){return cont([0, channel_id, 0]);},
		                                  [0, [0, 0, 0, 0, 0, cst_channel, 0, 2, [0, b], 0, 0], 0]],
		                                 0],
		                                0],
		                               0];
		                           return caml_exact_trampoline_cps_call$1
		                                   (schema$0,
		                                    schematic_param_a_schema_versi,
		                                    schematic_param_name_schema_ve,
		                                    function(c){
		                                     var
		                                      b =
		[0, [0, 0, 0, 0, 0, cst_response, 0, 2, [0, c], 0, 0], 0];
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$554,
		      schematic_version,
		      function(e){
		       var
		        default$ = match$262[1],
		        c =
		          [0,
		           [0,
		            function(param, cont){
		             var f1 = param[2], f0 = param[1];
		             return cont([1, f0, f1]);
		            },
		            function(param, cont){
		             if(1 !== param[0]) return cont(0);
		             var f1 = param[2], f0 = param[1];
		             return cont([0, [0, f0, f1]]);
		            },
		            1,
		            0,
		            cst_response,
		            "Response",
		            [0,
		             0,
		             0,
		             [7,
		              function(param, cont){
		               var response = param[2][1], channel_id = param[1];
		               return cont([0, channel_id, response]);
		              },
		              function(param, cont){
		               var response = param[2], channel_id = param[1];
		               return cont([0, channel_id, [0, response, 0]]);
		              },
		              [0, [0, 0, 0, 0, 0, cst_channel, 0, 2, [0, e], 0, 0], b]],
		             0],
		            0],
		           a],
		        d =
		          [0,
		           [0,
		            0,
		            0,
		            0,
		            0,
		            cst_call,
		            0,
		            2,
		            [0, schematic_param_name_schema_ve],
		            0,
		            0],
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_args,
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, schematic_param_a_schema_versi], 0]],
		             0,
		             0],
		            0]];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$554,
		                schematic_version,
		                function(a){
		                 return cont
		                         ([11,
		                           0,
		                           [0,
		                            [0,
		                             function(param, cont){
		                              var f2 = param[3], f1 = param[2], f0 = param[1];
		                              return cont([0, f0, f1, f2]);
		                             },
		                             function(param, cont){
		                              if(0 !== param[0]) return cont(0);
		                              var f2 = param[3], f1 = param[2], f0 = param[1];
		                              return cont([0, [0, f0, f1, f2]]);
		                             },
		                             1,
		                             0,
		                             cst_call,
		                             cst_Call,
		                             [0,
		                              0,
		                              0,
		                              [7,
		                               function(param, cont){
		                                var
		                                 a = param[2],
		                                 args = a[2][1],
		                                 call = a[1],
		                                 channel_id = param[1];
		                                return cont([0, channel_id, call, args]);
		                               },
		                               function(param, cont){
		                                var args = param[3], call = param[2], channel_id = param[1];
		                                return cont([0, channel_id, [0, call, [0, args, 0]]]);
		                               },
		                               [0, [0, 0, 0, 0, 0, cst_channel, 0, 2, [0, a], 0, 0], d]],
		                              0],
		                             0],
		                            c],
		                           0]);
		                });
		      });
		                                    });
		                          });
		                }
		                var
		                 schematic_schema_id = match$263[1],
		                 schematic_parametric =
		                   [0,
		                    [1,
		                     cst_a$0,
		                     schematic_param_a_schema_versi,
		                     function(schematic_param_a_schema_versi, cont){
		                      return caml_exact_trampoline_cps_call
		                              (descriptor,
		                               schematic_param_a_schema_versi,
		                               function(a){return cont([0, schematic_schema_id, a]);});
		                     }]];
		                return caml_exact_trampoline_cps_call
		                        (descriptor,
		                         schematic_param_a_schema_versi,
		                         function(a){
		                          var parametric = schematic_parametric[1];
		                          return caml_exact_trampoline_cps_call
		                                  (of_parametric,
		                                   parametric,
		                                   function(match){
		                                    function b(b){
		                                     return cont([0, b, 0, a, schematic_parametric]);
		                                    }
		                                    if(! match) return b(0);
		                                    var name = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (to_id, name, function(a){return b([0, a]);});
		                                   });
		                         });
		               }
		               var
		                Releaser =
		                  [248, "Controller_lib__Rpc.Releaser", caml_fresh_oo_id()];
		               function schema$253(id, side){
		                if(side){
		                 var
		                  a =
		                    map$14
		                     (function(handle, cont){
		                       return caml_perform_effect
		                               ([0, Releaser, handle],
		                                function(release){return cont([0, [0, handle, release]]);});
		                      },
		                      function(param, cont){
		                       var handle = param[1];
		                       return cont(handle);
		                      },
		                      remote_value_handle_schema);
		                 return [0, [0, id], a[2], a[3], a[4]];
		                }
		                var type = create$41(0);
		                function decode(param, cont){
		                 var value_handle = param[2];
		                 return caml_perform_effect
		                         ([0, Retrieve, value_handle, id, type],
		                          function(match){
		                           if(! match)
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     fail,
		                                     format$23,
		                                     function(a){
		                                      return caml_trampoline_cps_call3(a, id, value_handle, cont);
		                                     });
		                           var value = match[1];
		                           return caml_trampoline_cps_call2
		                                   (of_string$14, [1, value], cont);
		                          });
		                }
		                function encode(param, cont){
		                 var value = param[1];
		                 return caml_perform_effect
		                         ([0, Store, [0, id, type, value]], cont);
		                }
		                var
		                 schema = map$14(decode, encode, remote_value_handle_schema);
		                return [0, [0, id], schema[2], schema[3], schema[4]];
		               }
		               var
		                Callback_decode =
		                  [248,
		                   "Controller_lib__Rpc.Callback_decode",
		                   caml_fresh_oo_id()],
		                Callback_register =
		                  [248,
		                   "Controller_lib__Rpc.Callback_register",
		                   caml_fresh_oo_id()],
		                Var_register =
		                  [248,
		                   "Controller_lib__Rpc.Var_register",
		                   caml_fresh_oo_id()];
		               function callback_schema(name, args, result, side){
		                return side
		                        ? map$14
		                          (function(param, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (fatal$0, bbj, bbi, cont);
		                           },
		                           function(f, cont){
		                            return caml_perform_effect
		                                    ([0, Callback_register, args, f, name, result],
		                                     function(match){return cont(name);});
		                           },
		                           schematic_param_name_schema_ve)
		                        : map$14
		                          (function(name, cont){
		                            return caml_perform_effect
		                                    ([0, Callback_decode, args, name, result],
		                                     function(a){
		                                      return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                     });
		                           },
		                           function(param, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (fatal$0, bbl, bbk, cont);
		                           },
		                           schematic_param_name_schema_ve);
		               }
		               function var_schema(payload, cont){
		                var
		                 schematic_cache = [0, empty$11([0, comparator$9])],
		                 letrec_function_context = [];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                function schematic_version(param, cont){return cont(0);}
		                var schematic_schema_version = 0;
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           var var_schema = [0, bbm, 0, descriptor];
		                           function decode(param, cont){
		                            var init = param[2], channel_id = param[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (make$136,
		                                     0,
		                                     init,
		                                     function(match){
		                                      var set = match[2], var$ = match[1];
		                                      return caml_perform_effect
		      ([0,
		        Var_local_register,
		        channel_id,
		        [0, payload, set, var$]],
		       function(match){
		        return caml_trampoline_cps_call2(of_string$14, var$, cont);
		       });
		                                     });
		                           }
		                           function encode(var$, cont){
		                            return caml_perform_effect
		                                    ([0, Var_register, [0, payload, var$]],
		                                     function(channel_id){
		                                      return caml_exact_trampoline_cps_call
		      (get$17,
		       var$,
		       function(a){return cont([0, channel_id, a]);});
		                                     });
		                           }
		                           return cont(map$14(decode, encode, var_schema));
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(b){
		                  letrec_function_context[1][1] = b;
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_init, 0, 2, [0, payload], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$554,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var init = param[2][1], channel_id = param[1];
		                                 return cont([0, channel_id, init]);
		                                },
		                                function(param, cont){
		                                 var init = param[2], channel_id = param[1];
		                                 return cont([0, channel_id, [0, init, 0]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_channel, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               caml_callback(M$2, [[0, comparator$65, schema_versioned$554]]);
		               function Make_remote(Channel, cont){
		                function make(channel, schema, context, handlers, cont){
		                 var
		                  a = wait(),
		                  fatal = a[2],
		                  fataled = a[1],
		                  a = wait(),
		                  finish = a[2],
		                  finished = a[1],
		                  messages = create_empty(),
		                  responses = create_empty(),
		                  a = wait(),
		                  stop = a[2],
		                  stopped = a[1];
		                 return caml_trampoline_cps_call2
		                         (handlers[2],
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (wakeup_exn, fatal, a, cont);
		                          },
		                          function(f){
		                           var handler = [0, stop, finished, messages, responses];
		                           return caml_trampoline_cps_call3
		                                   (symbol_map$24,
		                                    stopped,
		                                    function(param, cont){
		                                     return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                                    },
		                                    function(stopped){
		                                     function read_channel(param, cont){
		                                      function a(value, cont){
		                                       return caml_trampoline_cps_call3
		       (Channel[1][4],
		        schema,
		        value,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (map$15,
		                  a,
		                  function(x, cont){
		                   return caml_trampoline_cps_call2(return$9, [0, x], cont);
		                  },
		                  function(a){
		                   return caml_trampoline_cps_call2(return$12, a, cont);
		                  });
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (Channel[3],
		       channel,
		       function(b){
		        return caml_trampoline_cps_call3
		                (symbol_map$24,
		                 b,
		                 of_string$14,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1(let$33, b, a, cont);
		                 });
		       });
		                                     }
		                                     function read_message(param, cont){
		                                      function a(message, cont){
		                                       return caml_trampoline_cps_call2
		       (return$9,
		        [1, message],
		        function(a){
		         return caml_trampoline_cps_call2(of_string$14, a, cont);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (take$3,
		       messages,
		       function(b){
		        return caml_trampoline_cps_call3(let$32, b, a, cont);
		       });
		                                     }
		                                     function handle(param, cont){
		                                      function loop(channel, message, context, cont){
		                                       function a(a, cont){
		if(0 !== a[0]){
		 var e = a[1];
		 return caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          failwith,
		          fmt$189,
		          function(a){
		           return caml_trampoline_cps_call3(a, pp_decoding, e, cont);
		          });
		}
		a = a[1];
		if(! a)
		 return caml_trampoline_cps_call2(return$12, 0, cont);
		a = a[1];
		if(0 === a[0]){
		 var
		  v = a[1],
		  b =
		    function(context, cont){
		     return caml_exact_trampoline_cps_call
		             (read_channel,
		              dummy,
		              function(a){
		               return caml_exact_trampoline_cps_call$0
		                       (loop, a, message, context, cont);
		              });
		    };
		 return caml_trampoline_cps_call4
		         (f,
		          handler,
		          context,
		          v,
		          function(a){
		           return caml_trampoline_cps_call3(let$31, a, b, cont);
		          });
		}
		var
		 message$0 = a[1][1][1],
		 a = handlers[1].call(null, context, message$0),
		 context$0 = a[2],
		 response = a[1];
		function c(param, cont){
		 return caml_exact_trampoline_cps_call
		         (read_message,
		          dummy,
		          function(a){
		           return caml_exact_trampoline_cps_call$0
		                   (loop, channel, a, context$0, cont);
		          });
		}
		return caml_exact_trampoline_cps_call$1
		        (put,
		         responses,
		         [0, [0, message$0, response]],
		         function(a){
		          return caml_trampoline_cps_call3(let$31, a, c, cont);
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call
		       (choose,
		        [0, channel, [0, message, [0, stopped, [0, fataled, 0]]]],
		        function(b){
		         return caml_trampoline_cps_call3(symbol_bind$27, b, a, cont);
		        });
		                                      }
		                                      function a(param, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (wakeup, finish, 0, cont);
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (read_message,
		       dummy,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (read_channel,
		                 dummy,
		                 function(c){
		                  return caml_exact_trampoline_cps_call$0
		                          (loop,
		                           c,
		                           b,
		                           context,
		                           function(b){
		                            return caml_trampoline_cps_call3(let$32, b, a, cont);
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (dont_wait,
		      handle,
		      function(a, cont){
		       return caml_exact_trampoline_cps_call$1
		               (wakeup_exn, finish, a, cont);
		      },
		      function(match){return cont(handler);});
		                                    });
		                          });
		                }
		                function stopped(param){
		                 var finished = param[2];
		                 return finished;
		                }
		                var Handler = [0, , make, stopped];
		                return caml_exact_trampoline_cps_call
		                        (M$2,
		                         [0, comparator$65, schema_versioned$554],
		                         function(By_channel_id){
		                          return caml_exact_trampoline_cps_call
		                                  (M$2,
		                                   [0, comparator$2, thread_id_schema_versioned],
		                                   function(By_string){
		                                    function make(fatal, channel, cont){
		                                     var res = [];
		                                     function rpc_handler(report_exception, handler, d, a, cont){
		                                      switch(a[0]){
		case 0:
		 var
		  args = a[3],
		  call = a[2],
		  channel_id = a[1],
		  a = caml_obj_tag(res),
		  c =
		    function(remote){
		     var
		      open =
		        g
		         ([0,
		           symbol_bind$5,
		           symbol_map$5,
		           ,
		           bind$8,
		           return$9,
		           map$17,
		           ,
		           ,
		           ,
		           ,
		           Let_syntax$3]),
		      let$ = open[3];
		     function a(channel, cont){
		      return caml_exact_trampoline_cps_call$1
		              (find_packed_by_id, channel, call, cont);
		     }
		     return caml_exact_trampoline_cps_call$1
		             (find_packed_by_id,
		              remote[2],
		              channel_id,
		              function(b){
		               return caml_trampoline_cps_call3
		                       (let$,
		                        b,
		                        a,
		                        function(callback){
		                         if(! callback)
		                          return caml_exact_trampoline_cps_call$1
		                                  (fatal$0,
		                                   bbo,
		                                   bbn,
		                                   function(a){
		                                    return caml_trampoline_cps_call4
		    (a, pp$129, channel_id, call, cont);
		                                   });
		                         var callback$0 = callback[1];
		                         function a(response, cont){
		                          var a = [1, channel_id, response];
		                          return caml_exact_trampoline_cps_call
		                                  (call_schema,
		                                   Channel[1][6],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (Channel[1][2],
		     b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (Channel[2],
		               remote[1],
		               a,
		               function(a){
		                return caml_trampoline_cps_call2(return$12, a, cont);
		               });
		     });
		                                   });
		                         }
		                         return caml_trampoline_cps_call2
		                                 (callback$0,
		                                  args,
		                                  function(b){
		                                   return caml_trampoline_cps_call3(let$31, b, a, cont);
		                                  });
		                        });
		              });
		    };
		 if(250 === a) return c(res[1]);
		 if(246 !== a && 244 !== a) return c(res);
		 return caml_exact_trampoline_cps_call
		         (force_lazy_block, res, c);
		case 1:
		 var
		  response = a[2],
		  channel_id$0 = a[1],
		  a = caml_obj_tag(res),
		  b =
		    function(res){
		     return caml_exact_trampoline_cps_call$1
		             (find_packed_by_id,
		              res[4],
		              channel_id$0,
		              function(match){
		               function a(a){
		                return caml_trampoline_cps_call2(return$12, 0, cont);
		               }
		               if(! match)
		                return caml_exact_trampoline_cps_call
		                        (Sync[6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, bbp, pp$129, channel_id$0, cont);
		                         },
		                         a);
		               var f = match[1][1];
		               return caml_trampoline_cps_call3
		                       (f,
		                        channel_id$0,
		                        response,
		                        function(match){
		                         if(! match)
		                          return caml_exact_trampoline_cps_call$1
		                                  (remove$2,
		                                   res[4],
		                                   channel_id$0,
		                                   function(b){res[4] = b; return a();});
		                         var data = match[1];
		                         return caml_exact_trampoline_cps_call$0
		                                 (set$3,
		                                  res[4],
		                                  channel_id$0,
		                                  data,
		                                  function(b){res[4] = b; return a();});
		                        });
		              });
		    };
		 if(250 === a) return b(res[1]);
		 if(246 !== a && 244 !== a) return b(res);
		 return caml_exact_trampoline_cps_call
		         (force_lazy_block, res, b);
		default:
		 return caml_exact_trampoline_cps_call$1
		         (fatal$0, bbr, bbq, cont);
		                                      }
		                                     }
		                                     caml_update_dummy
		                                      (res,
		                                       [246,
		function(param, cont){
		 var
		  a =
		    [0,
		     function(context, message, payload){
		      throw caml_maybe_attach_backtrace
		             ([0, Match_failure, bbs], 1);
		     },
		     rpc_handler];
		 return caml_exact_trampoline_cps_call
		         (call_schema,
		          Channel[1][6],
		          function(b){
		           return caml_exact_trampoline_cps_call$2
		                   (Handler[2],
		                    channel,
		                    b,
		                    0,
		                    a,
		                    function(a){
		                     return cont
		                             ([0, channel, By_channel_id[111], 0, By_channel_id[111], a]);
		                    });
		          });
		}]);
		                                     var a = caml_obj_tag(res);
		                                     function b(res){
		                                      return caml_exact_trampoline_cps_call$1
		      (dont_wait,
		       function(param, cont){
		        return cont(Handler[3].call(null, res[5]));
		       },
		       fatal,
		       function(match){return cont(res);});
		                                     }
		                                     if(250 === a) return b(res[1]);
		                                     if(246 !== a && 244 !== a) return b(res);
		                                     return caml_exact_trampoline_cps_call
		     (force_lazy_block, res, b);
		                                    }
		                                    function call(t, call, args_schemas, args, schema, f, cont){
		                                     var channel_id = t[3];
		                                     t[3] = t[3] + 1 | 0;
		                                     function wrap(param, cont){
		                                      var f = param[1];
		                                      return cont
		      ([0,
		        function(channel, response, cont){
		         if(0 !== response[0])
		          return caml_trampoline_cps_call3
		                  (f,
		                   channel,
		                   response,
		                   function(a){
		                    return caml_trampoline_cps_call3(map$17, a, wrap, cont);
		                   });
		         var response$0 = response[1];
		         function effc(a, cont){
		          if(a[1] !== Releaser) return cont(0);
		          a = a[2];
		          var value_handle = a[2], storage_id = a[1];
		          return cont
		                  ([0,
		                    function(k, cont){
		                     function release(param, cont){
		                      var a = [2, [1, -1, [1, storage_id, [0, value_handle]]]];
		                      return caml_exact_trampoline_cps_call
		                              (call_schema,
		                               Channel[1][6],
		                               function(b){
		                                return caml_trampoline_cps_call3
		(Channel[1][2],
		 b,
		 a,
		 function(a){
		  return caml_exact_trampoline_cps_call$1
		          (Channel[2], t[1], a, cont);
		 });
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$1
		                             (continue$, k, release, cont);
		                    }]);
		         }
		         return caml_exact_trampoline_cps_call$0
		                 (try_with,
		                  function(param, cont){
		                   return caml_trampoline_cps_call3
		                           (Channel[1][4], schema, response$0, cont);
		                  },
		                  0,
		                  [0, effc],
		                  function(decoded){
		                   if(0 === decoded[0]){
		                    var v = decoded[1];
		                    return caml_trampoline_cps_call3
		                            (f,
		                             channel,
		                             [0, v],
		                             function(a){
		                              return caml_trampoline_cps_call3(map$17, a, wrap, cont);
		                             });
		                   }
		                   var e = decoded[1];
		                   return caml_exact_trampoline_cps_call
		                           (Sync[3],
		                            function(m, cont){
		                             return caml_trampoline_cps_call13
		                                     (m,
		                                      0,
		                                      0,
		                                      bbt,
		                                      call,
		                                      pp$129,
		                                      channel,
		                                      pp_decoding,
		                                      e,
		                                      pp$7,
		                                      schema,
		                                      Channel[1][5],
		                                      response$0,
		                                      cont);
		                            },
		                            function(match){
		                             return caml_exact_trampoline_cps_call$1
		                                     (fatal$0,
		                                      bbv,
		                                      bbu,
		                                      function(a){
		                                       return caml_trampoline_cps_call6
		       (a, call, pp$129, channel, pp_decoding, e, cont);
		                                      });
		                            });
		                  });
		        }]);
		                                     }
		                                     var var_id = [0, 0];
		                                     return caml_exact_trampoline_cps_call
		     (wrap,
		      f,
		      function(f){
		       return caml_exact_trampoline_cps_call$0
		               (set$3,
		                t[4],
		                [0, channel_id],
		                f,
		                function(a){
		                 t[4] = a;
		                 function encode_args(schemas, args, cont){
		                  if(! schemas) return cont(0);
		                  var
		                   args$0 = args[2],
		                   arg = args[1],
		                   schemas$0 = schemas[2],
		                   schema = schemas[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (encode_args,
		                           schemas$0,
		                           args$0,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (Channel[1][2],
		                                     schema,
		                                     arg,
		                                     function(b){return cont([0, b, a]);});
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (try_with,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (encode_args, args_schemas, a, cont);
		                          },
		                          args,
		                          [0,
		                           function(effect, cont){
		                            if(effect[1] === Callback_register){
		                             var
		                              result_schema = effect[5],
		                              name = effect[4],
		                              f = effect[3],
		                              args = effect[2];
		                             return cont
		                                     ([0,
		                                       function(k, cont){
		function callback(effective, cont){
		 return caml_exact_trampoline_cps_call$3
		         (Lwt_result[5],
		          name,
		          [0, , , , Channel[1][4]],
		          f,
		          args,
		          effective,
		          function(error){
		           if(0 !== error[0])
		            return caml_trampoline_cps_call2(return$12, error, cont);
		           var result = error[1];
		           return caml_exact_trampoline_cps_call
		                   (Channel[1][2],
		                    result_schema,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1
		                             (symbol$232,
		                              result,
		                              a,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (map_error$0, toplevel_to_string, a, cont);
		                              });
		                    });
		          });
		}
		return caml_exact_trampoline_cps_call$0
		        (change$0,
		         t[2],
		         [0, channel_id],
		         function(param, cont){
		          if(! param)
		           return caml_exact_trampoline_cps_call$1
		                   (By_string[112],
		                    name,
		                    callback,
		                    function(a){return cont([0, a]);});
		          var callbacks = param[1];
		          return caml_exact_trampoline_cps_call$0
		                  (set$3,
		                   callbacks,
		                   name,
		                   callback,
		                   function(a){return cont([0, a]);});
		         },
		         function(a){
		          t[2] = a;
		          return caml_exact_trampoline_cps_call$1
		                  (continue$, k, 0, cont);
		         });
		                                       }]);
		                            }
		                            if(effect[1] !== Var_register) return cont(0);
		                            var match = effect[2], var$ = match[2], payload = match[1];
		                            return cont
		                                    ([0,
		                                      function(k, cont){
		                                       var channel_id$0 = [1, channel_id, [0, var_id[1]]];
		                                       var_id[1] = var_id[1] + 1 | 0;
		                                       return caml_exact_trampoline_cps_call$0
		       (watch$1,
		        0,
		        var$,
		        function(v, cont){
		         return caml_trampoline_cps_call3
		                 (Channel[1][2],
		                  payload,
		                  v,
		                  function(b){
		                   var a = [1, channel_id$0, [0, b]];
		                   return caml_exact_trampoline_cps_call
		                           (call_schema,
		                            Channel[1][6],
		                            function(b){
		                             return caml_trampoline_cps_call3
		                                     (Channel[1][2],
		                                      b,
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (Channel[2], t[1], a, cont);
		                                      });
		                            });
		                  });
		        },
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (continue$, k, channel_id$0, cont);
		        });
		                                      }]);
		                           }],
		                          function(args){
		                           var a = [0, [0, channel_id], call, args];
		                           return caml_exact_trampoline_cps_call
		                                   (call_schema,
		                                    Channel[1][6],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (Channel[1][2],
		      b,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (Channel[2],
		                t[1],
		                a,
		                function(match){return cont(channel_id);});
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    function hook(t, call$0, args_schemas, args, schema, cont){
		                                     var
		                                      channel = t[1],
		                                      match = create$20(),
		                                      push = match[2],
		                                      stream = match[1],
		                                      handler = [];
		                                     caml_update_dummy
		                                      (handler,
		                                       [0,
		function(channel, value, cont){
		 if(0 === value[0]){
		  var value$0 = value[1];
		  return caml_exact_trampoline_cps_call
		          (push,
		           [0, value$0],
		           function(match){return cont([0, handler]);});
		 }
		 var error = value[1];
		 return caml_exact_trampoline_cps_call
		         (Sync[3],
		          function(m, cont){
		           return caml_trampoline_cps_call8
		                   (m, 0, 0, bbw, call$0, pp$129, channel, error, cont);
		          },
		          function(match){return cont([0, handler]);});
		}]);
		                                     return caml_exact_trampoline_cps_call$7
		     (call,
		      t,
		      call$0,
		      args_schemas,
		      args,
		      schema,
		      handler,
		      function(channel_id){
		       function release(param, cont){
		        var a = [2, [0, channel_id]];
		        return caml_exact_trampoline_cps_call
		                (call_schema,
		                 Channel[1][6],
		                 function(b){
		                  return caml_trampoline_cps_call3
		                          (Channel[1][2],
		                           b,
		                           a,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (Channel[2],
		                                     channel,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a,
		       function(match){
		        return caml_exact_trampoline_cps_call(push, 0, cont);
		       });
		                                     });
		                           });
		                 });
		       }
		       return cont([0, stream, release]);
		      });
		                                    }
		                                    function close(t, channel_id, cont){
		                                     var a = [2, channel_id];
		                                     return caml_exact_trampoline_cps_call
		     (call_schema,
		      Channel[1][6],
		      function(b){
		       return caml_trampoline_cps_call3
		               (Channel[1][2],
		                b,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (Channel[2],
		                          t[1],
		                          function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                });
		      });
		                                    }
		                                    function var$(t, call$0, args_schemas, args, schema, cont){
		                                     var match = wait(), wakeup = match[2], res = match[1];
		                                     return caml_exact_trampoline_cps_call$7
		     (call,
		      t,
		      call$0,
		      args_schemas,
		      args,
		      schema,
		      [0,
		       function(channel, value, cont){
		        if(0 === value[0]){
		         var
		          value$0 = value[1],
		          release =
		            function(param, cont){
		             return caml_exact_trampoline_cps_call$1
		                     (close, t, channel, cont);
		            };
		         return caml_exact_trampoline_cps_call$1
		                 (make$136,
		                  [0, release],
		                  value$0,
		                  function(match){
		                   var update = match[2], var$ = match[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (wakeup_later,
		                            wakeup,
		                            [0, var$],
		                            function(match){
		                             var handler = [];
		                             caml_update_dummy
		                              (handler,
		                               [0,
		                                function(channel, value, cont){
		                                 if(0 === value[0]){
		                                  var value$0 = value[1];
		                                  return caml_trampoline_cps_call2
		  (update,
		   value$0,
		   function(match){return cont([0, handler]);});
		                                 }
		                                 var error = value[1];
		                                 return caml_exact_trampoline_cps_call
		 (Sync[3],
		  function(m, cont){
		   return caml_trampoline_cps_call8
		           (m, 0, 0, bbx, call$0, pp$129, channel, error, cont);
		  },
		  function(match){return cont([0, handler]);});
		                                }]);
		                             return cont([0, handler]);
		                            });
		                  });
		        }
		        var error = value[1];
		        return caml_exact_trampoline_cps_call$1
		                (wakeup_later,
		                 wakeup,
		                 [1, [0, error, channel]],
		                 function(match){return cont(0);});
		       }],
		      function(channel_id){
		       return caml_trampoline_cps_call3
		               (symbol_map$24,
		                res,
		                function(a, cont){
		                 if(0 === a[0]){var value = a[1]; return cont(value);}
		                 a = a[1];
		                 var channel = a[2], error = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (fatal$0,
		                          bbz,
		                          bby,
		                          function(a){
		                           return caml_trampoline_cps_call5
		                                   (a, call$0, pp$129, channel, error, cont);
		                          });
		                },
		                cont);
		      });
		                                    }
		                                    function call$0(t, call$0, args_schemas, args, schema, cont){
		                                     var match = wait(), wakeup$0 = match[2], res = match[1];
		                                     return caml_exact_trampoline_cps_call$7
		     (call,
		      t,
		      call$0,
		      args_schemas,
		      args,
		      schema,
		      [0,
		       function(channel, value, cont){
		        function a(a){return cont(0);}
		        if(0 === value[0])
		         return caml_exact_trampoline_cps_call$1
		                 (wakeup, wakeup$0, value, a);
		        var error = value[1];
		        return caml_exact_trampoline_cps_call$1
		                (wakeup, wakeup$0, [1, [0, error, channel]], a);
		       }],
		      function(channel_id){
		       return caml_trampoline_cps_call3
		               (symbol_map$24,
		                res,
		                function(a, cont){
		                 if(0 === a[0]){var value = a[1]; return cont(value);}
		                 a = a[1];
		                 var channel = a[2], error = a[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (fatal$0,
		                          bbB,
		                          bbA,
		                          function(a){
		                           return caml_trampoline_cps_call5
		                                   (a, call$0, pp$129, channel, error, cont);
		                          });
		                },
		                cont);
		      });
		                                    }
		                                    return cont([0, , , , , , make, , hook, , var$, call$0]);
		                                   });
		                         });
		               }
		               function caml_case(s, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (split_on_chars,
		                         s,
		                         bbC,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   a,
		                                   capitalize_ascii,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (concat$0,
		     bbD,
		     a,
		     function(a){return cont(uncapitalize_ascii(a));});
		                                   });
		                         });
		               }
		               function local_only(side, v){return side ? 0 : [0, v];}
		               function args(from){
		                var match = from[1];
		                if(! match) return bbe;
		                var
		                 tail = match[2],
		                 head = match[1],
		                 tail$0 = args([0, tail])[1];
		                return [0, [0, head, tail$0]];
		               }
		               function f$37(param, f){
		                var return$ = param[1];
		                function apply(args_from, args_to, f, cont){
		                 if(! args_from)
		                  return args_to
		                          ? caml_exact_trampoline_cps_call(failwith, cst_fixme, cont)
		                          : caml_trampoline_cps_call2(return$, f, cont);
		                 var tail_from = args_from[2];
		                 if(! args_to)
		                  return caml_exact_trampoline_cps_call
		                          (failwith, cst_fixme, cont);
		                 var tail_to = args_to[2];
		                 return cont
		                         (function(head, cont){
		                           return caml_trampoline_cps_call2
		                                   (f,
		                                    head,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (apply, tail_from, tail_to, a, cont);
		                                    });
		                          });
		                }
		                return function(a, b, cont){
		                 return caml_exact_trampoline_cps_call$0(apply, f, a, b, cont);};
		               }
		               function call_reactive(name, doc, args, result, f){
		                var value = [2, args, result, f];
		                return [1, doc, name, value];
		               }
		               function call$4(name, doc, args_from, result, f){
		                var args$0 = args([0, args_from])[1];
		                if(f)
		                 var
		                  f$0 = f[1],
		                  a =
		                    [0,
		                     function(ctrl, cont){
		                      return caml_trampoline_cps_call2
		                              (f$0,
		                               ctrl,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(f$37([0, return$13], args_from), args$0, a, cont);
		                               });
		                     }];
		                else
		                 a = 0;
		                var value = [0, args$0, result, a];
		                return [1, doc, name, value];
		               }
		               function call_async(name, doc, args, result, f){
		                var value = [0, args, result, f];
		                return [1, doc, name, value];
		               }
		               function call_hook(name, doc, args, result, f){
		                var value = [1, args, result, f];
		                return [1, doc, name, value];
		               }
		               function send(param, value, cont){
		                var output = param[2];
		                return caml_exact_trampoline_cps_call
		                        (Sync[6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, bbE, _16, value, cont);
		                         },
		                         function(match){
		                          return caml_trampoline_cps_call2(output, [0, value], cont);
		                         });
		               }
		               function receive(param, cont){
		                var input = param[1];
		                function a(value, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Sync[6],
		                          function(m, cont){
		                           return caml_trampoline_cps_call6
		                                   (m,
		                                    0,
		                                    0,
		                                    bbF,
		                                    function(a, b, cont){
		                                     return caml_exact_trampoline_cps_call$2
		     (option, 0, _16, a, b, cont);
		                                    },
		                                    value,
		                                    cont);
		                          },
		                          function(match){return cont(value);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (get$5,
		                         input,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$32, b, a, cont);
		                         });
		               }
		               caml_callback
		                (Make_remote,
		                 [[0,
		                   [0, , encode$4, , decode$2, _16, no_input_schema],
		                   send,
		                   receive]]);
		               function map_context(rpc, map, cont){
		                if(0 === rpc[0])
		                 return caml_trampoline_cps_call3
		                         (map$18,
		                          rpc[2],
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map_context, a, map, cont);
		                          },
		                          function(a){return cont([0, rpc[1], a]);});
		                var value = rpc[3];
		                switch(value[0]){
		                  case 0:
		                   var a = value[3];
		                   if(a)
		                    var
		                     f = a[1],
		                     a =
		                       [0,
		                        value[1],
		                        value[2],
		                        [0,
		                         function(ctx, cont){
		                          return caml_trampoline_cps_call2(f, map(ctx), cont);
		                         }]];
		                   else
		                    a = [0, value[1], value[2], 0];
		                   break;
		                  case 1:
		                   a = value[3];
		                   if(a)
		                    var
		                     f$0 = a[1],
		                     a =
		                       [1,
		                        value[1],
		                        value[2],
		                        [0,
		                         function(ctx, cont){
		                          return caml_trampoline_cps_call2(f$0, map(ctx), cont);
		                         }]];
		                   else
		                    a = [1, value[1], value[2], 0];
		                   break;
		                  default:
		                   a = value[3];
		                   if(a)
		                    var
		                     f$1 = a[1],
		                     a =
		                       [2,
		                        value[1],
		                        value[2],
		                        [0,
		                         function(ctx, cont){
		                          return caml_trampoline_cps_call2(f$1, map(ctx), cont);
		                         }]];
		                   else
		                    a = [2, value[1], value[2], 0];
		                }
		                return cont([1, rpc[1], rpc[2], a]);
		               }
		               function bQL(a, cont){
		                return caml_exact_trampoline_cps_call
		                        (Make_remote,
		                         a,
		                         function(a){return cont([0, , a[6], a[11], a[8], a[10]]);});
		               }
		               var
		                open$19 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_map$25 = open$19[2],
		                let$34 = open$19[3],
		                let$35 = open$19[4],
		                let$36 = open$19[14],
		                open$20 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$37 = open$20[3],
		                let$38 = open$20[4],
		                letrec_function_context$935 = [];
		               function creation_option_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$935[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bbG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$935[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$935[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$935[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (source_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$264[1],
		                                       default$0 = match$265[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_notify,
		   0,
		   [0, default$0],
		   [0, bool_schema],
		   0,
		   0],
		  [0,
		   [0, 0, 0, 0, 0, cst_source, 0, [0, default$], [0, b], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (document_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              source = a[2][1],
		              notify = a[1],
		              document = param[1];
		             return cont([0, document, notify, source]);
		            },
		            function(param, cont){
		             var
		              source = param[3],
		              notify = param[2],
		              document = param[1];
		             return cont([0, document, [0, notify, [0, source, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_document, 0, 3, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$935[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$935[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$892 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$935, [0, schematic_cache$892]);
		               var
		                creation_option_schema =
		                  caml_callback
		                   (creation_option_schema_version,
		                    [function(param, cont){return cont(0);}]),
		                cst_allocate = "allocate",
		                creation_option_default = [0, 0, 0, 2];
		               function rpcs(param, side, cont){
		                var callback_schema = param[1];
		                function local(v){
		                 return local_only
		                         (side,
		                          function(param, cont){
		                           var controller = param[1];
		                           return caml_trampoline_cps_call2(v, controller, cont);
		                          });
		                }
		                var
		                 a =
		                   local
		                    (function(ctrl, id, allocation, source, cont){
		                      function a(crdt, cont){
		                       return caml_exact_trampoline_cps_call$3
		                               (allocate$1,
		                                ctrl,
		                                crdt,
		                                id,
		                                allocation,
		                                source,
		                                function(b){
		                                 function a(ev, cont){return cont(ev[6]);}
		                                 return caml_exact_trampoline_cps_call$1
		 (map$5,
		  b,
		  function(b, cont){
		   return caml_exact_trampoline_cps_call$1(map$9, b, a, cont);
		  },
		  cont);
		                                });
		                      }
		                      return caml_exact_trampoline_cps_call
		                              (writable$0,
		                               ctrl[2],
		                               function(b){
		                                return caml_trampoline_cps_call3(let$38, b, a, cont);
		                               });
		                     }),
		                 task_id = [0, cst_id, schema$27, 0],
		                 generalized_task_id = [0, cst_id, schema$44, 0],
		                 source = [0, cst_source, source_schema, 0];
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schema$263,
		                         function(c){
		                          var
		                           allocate =
		                             call_async
		                              (cst_allocate,
		                               "Allocate a task.",
		                               [0,
		                                task_id,
		                                [0,
		                                 [0, cst_allocation, action_allocation_schema, 0],
		                                 [0, source, 0]]],
		                               c,
		                               a),
		                           batch$0 =
		                             call_reactive
		                              (cst_batch,
		                               "Tasks of a batch.",
		                               [0, [0, cst_week, schema$8, 0], 0],
		                               batch_schema,
		                               local_only
		                                (side,
		                                 function(param, week, cont){
		                                  var graph = param[2], controller = param[1];
		                                  return caml_exact_trampoline_cps_call$1
		  (batch,
		   controller,
		   week,
		   function(tasks){
		    return caml_trampoline_cps_call2
		            (graph[27],
		             week,
		             function(objects){
		              return caml_exact_trampoline_cps_call$0
		                      (map2$2, tasks, objects, append_batch, cont);
		             });
		   });
		                                 })),
		                           b = local(task_batch);
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schema$8,
		                                   function(a){
		                                    var
		                                     batched =
		                                       call$4
		("batched",
		 "The batch of a task, if any.",
		 [0, [0, cst_task, schema$68, 0], 0],
		 a,
		 b),
		                                     a =
		                                       [0,
		call_async
		 (cst_upsert,
		  "Create a binding or update its configuration.",
		  [0,
		   [0, cst_id, schema$124, 0],
		   [0, [0, cst_config, schema$126, 0], 0]],
		  schematic_param_a_schema_versi,
		  local
		   (function(ctrl, id, config, cont){
		     function a(crdt, cont){
		      return caml_exact_trampoline_cps_call$1
		              (task_binding_workspace,
		               ctrl[2],
		               id,
		               function(match){
		                if(match)
		                 var workspace_id = match[1], workspace_id$0 = workspace_id;
		                else
		                 workspace_id$0 = config[1];
		                return caml_exact_trampoline_cps_call$1
		                        (upsert,
		                         id,
		                         config,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (task_bindings,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$2
		    (apply$125, ctrl[1], crdt, workspace_id$0, a, cont);
		                                   });
		                         });
		               });
		     }
		     return caml_exact_trampoline_cps_call
		             (writable$0,
		              ctrl[2],
		              function(b){
		               return caml_trampoline_cps_call3(let$38, b, a, cont);
		              });
		    })),
		0],
		                                     a =
		                                       [0,
		call_async
		 (cst_remove,
		  "Remove a task binding.",
		  [0, [0, cst_id, schema$124, 0], 0],
		  schematic_param_a_schema_versi,
		  local
		   (function(ctrl, id, cont){
		     function a(crdt, cont){
		      var
		       open =
		         o
		          ([0,
		            symbol_bind$1,
		            symbol_map$0,
		            Let_syntax$0,
		            ,
		            bind$1,
		            of_string$0,
		            map$5]),
		       let$ = open[4];
		      return caml_exact_trampoline_cps_call$1
		              (task_binding_workspace,
		               ctrl[2],
		               id,
		               function(match){
		                if(! match) return cont(bbH);
		                var workspace_id = match[1];
		                function a(param, cont){return cont(0);}
		                return caml_trampoline_cps_call2
		                        (remove$18,
		                         id,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (task_bindings,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$2
		    (apply$125,
		     ctrl[1],
		     crdt,
		     workspace_id,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               });
		     }
		     return caml_exact_trampoline_cps_call
		             (writable$0,
		              ctrl[2],
		              function(b){
		               return caml_trampoline_cps_call3(let$38, b, a, cont);
		              });
		    })),
		a],
		                                     c =
		                                       [0,
		call_async
		 (cst_set_enabled,
		  "Enable or disable a task binding for this user.",
		  [0,
		   [0, cst_id, schema$124, 0],
		   [0, [0, cst_enabled, bool_schema, 0], 0]],
		  schematic_param_a_schema_versi,
		  local
		   (function(ctrl, id, enabled, cont){
		     function a(crdt, cont){
		      return caml_exact_trampoline_cps_call$1
		              (set$23,
		               id,
		               enabled,
		               function(operation){
		                return caml_exact_trampoline_cps_call
		                        (v$47,
		                         [22, operation],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (apply_personal,
		                                   ctrl[1],
		                                   crdt,
		                                   a,
		                                   function(match){
		                                    return caml_exact_trampoline_cps_call(of_string$0, 0, cont);
		                                   });
		                         });
		               });
		     }
		     return caml_exact_trampoline_cps_call
		             (writable$0,
		              ctrl[2],
		              function(b){
		               return caml_trampoline_cps_call3(let$38, b, a, cont);
		              });
		    })),
		a],
		                                     d =
		                                       local
		(function(ctrl, cont){
		  return caml_exact_trampoline_cps_call
		          (task_binding_settings, ctrl, cont);
		 });
		                                    return caml_exact_trampoline_cps_call
		    (By$17[103],
		     schema$125,
		     function(e){
		      var
		       a =
		         [0,
		          call_reactive
		           (cst_settings,
		            "Personal enable/disable settings for task bindings, by id.",
		            0,
		            e,
		            d),
		          c],
		       b =
		         local
		          (function(ctrl, cont){
		            return caml_exact_trampoline_cps_call
		                    (task_bindings_by_workspace, ctrl, cont);
		           });
		      return caml_exact_trampoline_cps_call
		              (By$17[103],
		               schema$127,
		               function(c){
		                return caml_exact_trampoline_cps_call
		                        (By$8[103],
		                         c,
		                         function(e){
		                          var
		                           c =
		                             [0,
		                              call_reactive
		                               ("by_workspace",
		                                "Task bindings grouped by the workspace they are stored in.",
		                                0,
		                                e,
		                                b),
		                              a],
		                           d =
		                             local
		                              (function(ctrl, cont){
		                                return caml_exact_trampoline_cps_call
		(task_bindings$1, ctrl, cont);
		                               });
		                          return caml_exact_trampoline_cps_call
		                                  (By$17[103],
		                                   schema$127,
		                                   function(e){
		                                    var
		                                     a =
		                                       [0,
		call_reactive(cst_all, "All task bindings.", 0, e, d),
		c],
		                                     b =
		                                       local
		(function(ctrl, workspace_id, table_id, filter, cont){
		  function a(crdt, cont){
		   var
		    id = make$55(),
		    binding =
		      make$56(0, [0, workspace_id, table_id, filter, 0, 0, 0]);
		   return caml_trampoline_cps_call3
		           (add$30,
		            id,
		            binding,
		            function(a){
		             return caml_exact_trampoline_cps_call
		                     (task_bindings,
		                      a,
		                      function(a){
		                       return caml_exact_trampoline_cps_call$0
		                               (apply_personal,
		                                ctrl[1],
		                                crdt,
		                                a,
		                                function(match){
		                                 return caml_exact_trampoline_cps_call(of_string$0, id, cont);
		                                });
		                      });
		            });
		  }
		  return caml_exact_trampoline_cps_call
		          (writable$0,
		           ctrl[2],
		           function(b){
		            return caml_trampoline_cps_call3(let$38, b, a, cont);
		           });
		 });
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     schema$123,
		     function(schema){
		      var
		       schema$0 = Table[5],
		       binding =
		         [0,
		          call_async
		           (cst_add,
		            "Add a task binding.",
		            [0,
		             [0, cst_workspace_id, schema$39, 0],
		             [0,
		              [0, cst_table_id, schema$0, 0],
		              [0, [0, cst_filter, schema, 0], 0]]],
		            schema$124,
		            b),
		          a],
		       complete =
		         call_async
		          (cst_complete,
		           "Complete a task.",
		           [0, task_id, [0, source, 0]],
		           schematic_param_a_schema_versi,
		           local
		            (function(ctrl, id, source, cont){
		              function a(crdt, cont){
		               var t = ocaml_ptime_clock_now_d_ps();
		               return caml_exact_trampoline_cps_call$3
		                       (update$13,
		                        ctrl,
		                        crdt,
		                        id,
		                        make$134(0, [0, [0, t]], 0, 0, 0, 0, 0, 0, 0, 0, 0),
		                        source,
		                        cont);
		              }
		              return caml_exact_trampoline_cps_call
		                      (writable$0,
		                       ctrl[2],
		                       function(b){
		                        return caml_trampoline_cps_call3(let$38, b, a, cont);
		                       });
		             })),
		       c =
		         local
		          (function(ctrl, task, options, cont){
		            var
		             match = value$4(options, creation_option_default),
		             source = match[3],
		             notify = match[2],
		             document = match[1];
		            function a(crdt, cont){
		             return caml_exact_trampoline_cps_call$7
		                     (create$47,
		                      ctrl,
		                      crdt,
		                      document,
		                      [0, notify],
		                      source,
		                      task,
		                      function(a){
		                       return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                      });
		            }
		            return caml_exact_trampoline_cps_call
		                    (writable$0,
		                     ctrl[2],
		                     function(b){
		                      return caml_trampoline_cps_call3(let$38, b, a, cont);
		                     });
		           });
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               creation_option_schema,
		               function(schema){
		                var
		                 create =
		                   call_async
		                    (cst_create,
		                     "Create a task.",
		                     [0,
		                      [0, cst_task, schema$194, 0],
		                      [0, [0, cst_options, schema, 0], 0]],
		                     schema$27,
		                     c),
		                 create_simple =
		                   call_async
		                    ("create_simple",
		                     "Create a task (simplified for MCP). Usually you only need to pass the title. Do not try to pass the integration_id or distant_task_id.",
		                     [0, [0, cst_task, schema$194, 0], 0],
		                     schema$27,
		                     local
		                      (function(ctrl, task, cont){
		                        var
		                         source = creation_option_default[3],
		                         notify = creation_option_default[2],
		                         document = creation_option_default[1];
		                        function a(crdt, cont){
		                         return caml_exact_trampoline_cps_call$7
		                                 (create$47,
		                                  ctrl,
		                                  crdt,
		                                  document,
		                                  [0, notify],
		                                  source,
		                                  task,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                                  });
		                        }
		                        return caml_exact_trampoline_cps_call
		                                (writable$0,
		                                 ctrl[2],
		                                 function(b){
		                                  return caml_trampoline_cps_call3(let$38, b, a, cont);
		                                 });
		                       })),
		                 a =
		                   local
		                    (function(ctrl, task, allocation, options, cont){
		                      var
		                       match = value$4(options, creation_option_default),
		                       source = match[3],
		                       notify = match[2],
		                       document = match[1];
		                      function a(crdt, cont){
		                       return caml_exact_trampoline_cps_call$8
		                               (create_allocate,
		                                ctrl,
		                                crdt,
		                                document,
		                                [0, notify],
		                                source,
		                                task,
		                                allocation,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                                });
		                      }
		                      return caml_exact_trampoline_cps_call
		                              (writable$0,
		                               ctrl[2],
		                               function(b){
		                                return caml_trampoline_cps_call3(let$38, b, a, cont);
		                               });
		                     });
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         creation_option_schema,
		                         function(schema){
		                          var
		                           create_allocate =
		                             call_async
		                              ("create_allocate",
		                               "Create an allocated task.",
		                               [0,
		                                [0, cst_task, schema$194, 0],
		                                [0,
		                                 [0, cst_allocation, action_allocation_schema, 0],
		                                 [0, [0, cst_options, schema, 0], 0]]],
		                               schema$27,
		                               a),
		                           day =
		                             call_reactive
		                              (cst_day,
		                               "Tasks of a day sorted by: starred < default < (completed or ignored).",
		                               [0, [0, cst_day, schema$5, 0], 0],
		                               day_schema,
		                               local_only
		                                (side,
		                                 function(param, cont){
		                                  var graph = param[2], controller = param[1];
		                                  return cont
		  (function(a, cont){
		    return caml_exact_trampoline_cps_call$0
		            (day$2, graph, controller, a, cont);
		   });
		                                 })),
		                           delete$ =
		                             call_async
		                              (cst_delete,
		                               "Delete a task.",
		                               [0, task_id, [0, source, 0]],
		                               schematic_param_a_schema_versi,
		                               local
		                                (function(ctrl, id, source, cont){
		                                  function a(crdt, cont){
		                                   return caml_exact_trampoline_cps_call$2
		   (delete$1,
		    ctrl,
		    crdt,
		    id,
		    source,
		    function(a){
		     return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		    });
		                                  }
		                                  return caml_exact_trampoline_cps_call
		  (writable$0,
		   ctrl[2],
		   function(b){
		    return caml_trampoline_cps_call3(let$38, b, a, cont);
		   });
		                                 })),
		                           b =
		                             local_only
		                              (side,
		                               function(param, id, cont){
		                                var graph = param[2];
		                                return caml_exact_trampoline_cps_call$1
		(get$32, graph, id, cont);
		                               });
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (augmented_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){
		      var
		       get =
		         call_reactive
		          (cst_get$0, cst_A_task, [0, generalized_task_id, 0], a, b),
		       move =
		         call_async
		          (cst_move,
		           "Move a task.",
		           [0,
		            task_id,
		            [0,
		             [0, cst_destination, document_schema, 0],
		             [0, source, 0]]],
		           schematic_param_a_schema_versi,
		           local
		            (function(ctrl, id, destination, source, cont){
		              function a(crdt, cont){
		               return caml_exact_trampoline_cps_call$3
		                       (move$3, ctrl, crdt, id, destination, source, cont);
		              }
		              return caml_exact_trampoline_cps_call
		                      (writable$0,
		                       ctrl[2],
		                       function(b){
		                        return caml_trampoline_cps_call3(let$38, b, a, cont);
		                       });
		             })),
		       orphan$0 =
		         call_async
		          ("orphan",
		           "Remove task parent.",
		           [0, task_id, 0],
		           schematic_param_a_schema_versi,
		           local
		            (function(ctrl, id, cont){
		              function a(crdt, cont){
		               return caml_exact_trampoline_cps_call$0
		                       (orphan,
		                        ctrl,
		                        crdt,
		                        id,
		                        function(a){
		                         return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                        });
		              }
		              return caml_exact_trampoline_cps_call
		                      (writable$0,
		                       ctrl[2],
		                       function(b){
		                        return caml_trampoline_cps_call3(let$38, b, a, cont);
		                       });
		             })),
		       a =
		         local_only
		          (side,
		           function(param, cont){
		            var graph = param[2];
		            return caml_exact_trampoline_cps_call
		                    (unplanned, graph, cont);
		           }),
		       unplanned$0 =
		         call_reactive
		          (cst_unplanned,
		           "Unplanned tasks.",
		           0,
		           list_schema(schema$44),
		           a),
		       a =
		         local_only
		          (side,
		           function(param, cont){
		            var graph = param[2], controller = param[1];
		            return caml_exact_trampoline_cps_call
		                    (upcoming,
		                     controller,
		                     function(tasks){
		                      return caml_trampoline_cps_call2
		                              (graph[24],
		                               0,
		                               function(objects){
		                                return caml_exact_trampoline_cps_call$0
		(map2$2,
		 tasks,
		 objects,
		 function(tasks, objects, cont){
		  return caml_exact_trampoline_cps_call$1
		          (append$0,
		           tasks,
		           objects,
		           function(a){
		            return caml_exact_trampoline_cps_call$1
		                    (dedup_and_sort, a, compare$40, cont);
		           });
		 },
		 cont);
		                               });
		                     });
		           }),
		       upcoming$0 =
		         call_reactive
		          (cst_upcoming,
		           "Non-allocated organized by week and sorted alphabetically.",
		           0,
		           list_schema(schema$8),
		           a),
		       uncomplete =
		         call_async
		          ("uncomplete",
		           "Uncomplete a task.",
		           [0, task_id, [0, source, 0]],
		           schematic_param_a_schema_versi,
		           local
		            (function(ctrl, id, source, cont){
		              function a(crdt, cont){
		               return caml_exact_trampoline_cps_call$3
		                       (update$13,
		                        ctrl,
		                        crdt,
		                        id,
		                        make$134(0, bbI, 0, 0, 0, 0, 0, 0, 0, 0, 0),
		                        source,
		                        cont);
		              }
		              return caml_exact_trampoline_cps_call
		                      (writable$0,
		                       ctrl[2],
		                       function(b){
		                        return caml_trampoline_cps_call3(let$38, b, a, cont);
		                       });
		             })),
		       c =
		         local_only
		          (side,
		           function(param, id, patch, source, callback, cont){
		            var graph = param[2], ctrl = param[1];
		            function a(crdt, cont){
		             if(0 === id[0])
		              return caml_exact_trampoline_cps_call$3
		                      (update$18, graph, crdt, id, patch, source, cont);
		             var id$0 = id[1];
		             if(! callback)
		              return caml_exact_trampoline_cps_call$3
		                      (update$13,
		                       ctrl,
		                       crdt,
		                       id$0,
		                       patch,
		                       source,
		                       function(a){
		                        return caml_trampoline_cps_call2(return$12, a, cont);
		                       });
		             var continue$ = callback[1];
		             function continue$0(a, cont){
		              if(! a)
		               return caml_trampoline_cps_call2(return$13, 1, cont);
		              var deleted_event = a[1], a = patch[7], b = patch[1];
		              function c
		              (unscheduled,
		               archived,
		               rescheduled,
		               rebatched,
		               reschedule_date){
		               return caml_trampoline_cps_call7
		                       (continue$,
		                        unscheduled,
		                        archived,
		                        rescheduled,
		                        rebatched,
		                        deleted_event,
		                        reschedule_date,
		                        cont);
		              }
		              if(! a)
		               return caml_exact_trampoline_cps_call
		                       (failwith,
		                        "Impossible state detected on task udpate. Deleting allocations cannot happen if schedule is unchanged. Failing.",
		                        function(a){
		                         var
		                          reschedule_date = a[5],
		                          rebatched = a[4],
		                          rescheduled = a[3],
		                          archived = a[2],
		                          unscheduled = a[1];
		                         return c
		                                 (unscheduled,
		                                  archived,
		                                  rescheduled,
		                                  rebatched,
		                                  reschedule_date);
		                        });
		              a = a[1];
		              if(! a){
		               if(b && b[1]) return c(0, 1, 0, 0, 0);
		               return c(1, 0, 0, 0, 0);
		              }
		              b = a[1];
		              if(0 === b[0]){
		               var week = b[1];
		               return caml_exact_trampoline_cps_call
		                       (to_date$2,
		                        week,
		                        function(a){return c(0, 0, 0, 1, [0, a]);});
		              }
		              var date = b[1];
		              return c(0, 0, 1, 0, [0, date]);
		             }
		             return caml_exact_trampoline_cps_call$7
		                     (update_with_modal,
		                      ctrl,
		                      crdt,
		                      continue$0,
		                      id$0,
		                      patch,
		                      source,
		                      cont);
		            }
		            return caml_exact_trampoline_cps_call
		                    (writable$0,
		                     ctrl[2],
		                     function(b){
		                      return caml_trampoline_cps_call3(let$37, b, a, cont);
		                     });
		           });
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$1,
		               dummy,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         a,
		                         function(schema){
		                          var cst_confirm = "confirm";
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   callback_schema
		                                    (cst_confirm,
		                                     [0,
		                                      [0, cst_unscheduled, bool_schema, 0],
		                                      [0,
		                                       [0, cst_archived, bool_schema, 0],
		                                       [0,
		[0, cst_rescheduled, bool_schema, 0],
		[0,
		 [0, "rebatched", bool_schema, 0],
		 [0,
		  [0, "deletedEvent", schema$90, 0],
		  [0, [0, "rescheduleDate", schema, 0], 0]]]]]],
		                                     bool_schema,
		                                     side),
		                                   function(schema){
		                                    var
		                                     update =
		                                       call_async
		(cst_update,
		 "Patch a task.",
		 [0,
		  generalized_task_id,
		  [0,
		   [0, cst_patch, schema$193, 0],
		   [0, source, [0, [0, cst_confirm, schema, 0], 0]]]],
		 schematic_param_a_schema_versi,
		 c);
		                                    return cont
		    ([0,
		      [0, cst_binding, binding],
		      [0,
		       allocate,
		       [0,
		        batch$0,
		        [0,
		         batched,
		         [0,
		          complete,
		          [0,
		           create,
		           [0,
		            create_simple,
		            [0,
		             create_allocate,
		             [0,
		              day,
		              [0,
		               delete$,
		               [0,
		                get,
		                [0,
		                 move,
		                 [0,
		                  orphan$0,
		                  [0,
		                   uncomplete,
		                   [0, upcoming$0, [0, unplanned$0, [0, update, 0]]]]]]]]]]]]]]]]]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$21 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$39 = open$21[4],
		                open$22 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$40 = open$22[4],
		                open$23 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$41 = open$23[4],
		                open$24 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$42 = open$24[4];
		               function decode$13(organization, cont){
		                var opaque = organization[3], a = organization[4];
		                return caml_trampoline_cps_call3
		                        (g
		                           ([0,
		                             symbol_bind$5,
		                             symbol_map$5,
		                             ,
		                             bind$8,
		                             return$9,
		                             map$17,
		                             ,
		                             ,
		                             ,
		                             ,
		                             Let_syntax$3])
		                          [3],
		                         opaque,
		                         function(opaque, cont){
		                          var secret = client_secret + cst$24;
		                          function d(match){
		                           if(0 === match[0]){
		                            var token = match[1];
		                            return cont([0, token]);
		                           }
		                           var e = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (Logs$4[6][3],
		                                    function(m, cont){
		                                     return caml_trampoline_cps_call5(m, 0, 0, a6f, e, cont);
		                                    },
		                                    function(match){return cont(0);});
		                          }
		                          caml_push_trap
		                           (function(exn){
		                             return d([1, "invalid cryptographic token"]);
		                            });
		                          function c(clarified){
		                           return caml_exact_trampoline_cps_call$1
		                                   (String$0[4],
		                                    schema$75,
		                                    clarified,
		                                    function(t){
		                                     function a(a){caml_pop_trap(); return d(a);}
		                                     if(0 === t[0]) return a(t);
		                                     var x = t[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (to_to_string,
		      pp_decoding,
		      x,
		      function(b){return a([1, b]);});
		                                    });
		                          }
		                          caml_push_trap
		                           (function(e){
		                             if(dev) return c(opaque);
		                             var
		                              raise = caml_pop_trap(),
		                              e$0 = caml_maybe_attach_backtrace(e, 0);
		                             return raise(e$0);
		                            });
		                          var a = caml_obj_tag(buffer$0);
		                          function b(t8){
		                           var t14 = t8.alloc(16, 0);
		                           return caml_exact_trampoline_cps_call
		                                   (base64_decode,
		                                    secret,
		                                    function(t13){
		                                     var
		                                      cipher =
		node_crypto.createDecipheriv("aes-256-cbc", t13, t14);
		                                     return caml_exact_trampoline_cps_call
		     (base64_decode,
		      opaque,
		      function(t16){
		       var
		        start = cipher.update(t16),
		        end = cipher.final(),
		        s2 = caml_string_of_jsstring(end.toString()),
		        s1 = caml_string_of_jsstring(start.toString());
		       caml_pop_trap();
		       return c(s1 + s2);
		      });
		                                    });
		                          }
		                          if(250 === a) return b(buffer$0[1]);
		                          if(246 !== a && 244 !== a) return b(buffer$0);
		                          return caml_exact_trampoline_cps_call
		                                  (force_lazy_block, buffer$0, b);
		                         },
		                         function(b){
		                          return cont([0, organization[1], organization[2], b, a]);
		                         });
		               }
		               function get_incr(ctrl, id, cont){
		                function f(param, cont){
		                 var organizations = param[15];
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id, organizations, id, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (state_incremental_personal,
		                         ctrl[2],
		                         function(t){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$41,
		                                   t,
		                                   f,
		                                   function(organization){
		                                    return cont
		    (symbol$229
		      (organization,
		       function(x, y, cont){
		        if(x){
		         if(y){
		          var b = y[1], a = x[1];
		          return caml_trampoline_cps_call3(equal$243, a, b, cont);
		         }
		        }
		        else if(! y) return cont(1);
		        return cont(0);
		       }));
		                                   });
		                         });
		               }
		               function get$33(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         ctrl[2],
		                         function(match){
		                          var organizations = match[15];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id, organizations, id, cont);
		                         });
		               }
		               function get$34(ctrl, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$18,
		                      symbol_map$16,
		                      ,
		                      bind$25,
		                      return$29,
		                      map$46,
		                      ,
		                      ,
		                      ,
		                      ,
		                      [0, , , , [0, , , , Let_syntax$10[4][21]]]]),
		                 let$ = open[11];
		                function a(organization, cont){
		                 return caml_exact_trampoline_cps_call
		                         (user_id$0,
		                          ctrl,
		                          function(owner){
		                           return caml_exact_trampoline_cps_call$1
		                                   (augment,
		                                    owner,
		                                    organization,
		                                    function(for_member){
		                                     var a = for_member[2];
		                                     return caml_exact_trampoline_cps_call
		     (decode$13,
		      for_member[1],
		      function(b){return cont([0, b, a]);});
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_incr,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               }
		               function personal(ctrl, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$18,
		                      symbol_map$16,
		                      ,
		                      bind$25,
		                      return$29,
		                      map$46,
		                      ,
		                      ,
		                      ,
		                      ,
		                      [0, , , , [0, , , , Let_syntax$10[4][21]]]]),
		                 let$ = open[4];
		                function a(organization, cont){
		                 if(! organization)
		                  return caml_exact_trampoline_cps_call$1
		                          (fatal$0, bbL, bbK, cont);
		                 var organization$0 = organization[1];
		                 return cont(organization$0);
		                }
		                return caml_exact_trampoline_cps_call
		                        (user_id$0,
		                         ctrl,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (personal_organization_of_user_,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (get$34,
		     ctrl,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function all$32(ctrl, cont){
		                function f(param, cont){
		                 var organizations = param[15];
		                 return caml_exact_trampoline_cps_call
		                         (keys$0, organizations, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (state_incremental_personal,
		                         ctrl[2],
		                         function(t){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$41,
		                                   t,
		                                   f,
		                                   function(ids){
		                                    return cont
		    (symbol$229
		      (ids,
		       function(x, y, cont){
		        function a(x, y){
		         if(x){
		          if(y){
		           var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		           return caml_exact_trampoline_cps_call$1
		                   (equal$53,
		                    a$0,
		                    b,
		                    function(b){
		                     return b
		                             ? caml_exact_trampoline_call2(a, x$0, y$0)
		                             : cont(b);
		                    });
		          }
		         }
		         else if(! y) return cont(1);
		         return cont(0);
		        }
		        return a(x, y);
		       }));
		                                   });
		                         });
		               }
		               function create$53(ctrl, crdt, name, cont){
		                var created = ocaml_ptime_clock_now_d_ps(), id = make$30();
		                return caml_exact_trampoline_cps_call
		                        (id$37,
		                         ctrl[1],
		                         function(email){
		                          return caml_exact_trampoline_cps_call
		                                  (profile_main,
		                                   ctrl[9],
		                                   function(a){
		                                    a = a[3];
		                                    if(a)
		                                     var userinfo = a[1][6], name$0 = userinfo[7];
		                                    else
		                                     name$0 = cst$1;
		                                    return caml_exact_trampoline_cps_call
		    (user_id,
		     ctrl[1],
		     function(a){
		      var
		       owner_member = [0, 1, email, a, name$0],
		       organization$0 =
		         [0, created, id, 0, [0, owner_member[3], name]],
		       workspaces = By$8[104];
		      return caml_exact_trampoline_cps_call$1
		              (singleton$5,
		               owner_member[3],
		               owner_member,
		               function(members){
		                var
		                 organization$1 =
		                   [0, members, members_pending, organization$0, workspaces];
		                return caml_trampoline_cps_call3
		                        (add$24,
		                         id,
		                         organization$1,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (organizations,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (apply_personal,
		     ctrl[1],
		     crdt,
		     a,
		     function(a){
		      a = organization(id, [0, name, email]);
		      return caml_exact_trampoline_cps_call$0
		              (push_dont_wait$0,
		               ctrl[11],
		               0,
		               a,
		               function(match){
		                var open = g(include$0), let$ = open[17];
		                function a(param, cont){return cont(id);}
		                var b = [0, id, cst_Default];
		                return caml_exact_trampoline_cps_call
		                        (default_workspace_of_organizat,
		                         id,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$3
		                                  (create$43,
		                                   ctrl,
		                                   crdt,
		                                   [0, created],
		                                   [0, c],
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function members$1(ctrl, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$18,
		                      symbol_map$16,
		                      ,
		                      bind$25,
		                      return$29,
		                      map$46,
		                      ,
		                      ,
		                      ,
		                      ,
		                      [0, , , , [0, , , , Let_syntax$10[4][21]]]]),
		                 symbol_map = open[2];
		                function a(param, cont){
		                 if(! param) return cont(0);
		                 var organization = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (keys$0, organization[1], cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_incr,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                         });
		               }
		               function members_pending$1(ctrl, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$18,
		                      symbol_map$16,
		                      ,
		                      bind$25,
		                      return$29,
		                      map$46,
		                      ,
		                      ,
		                      ,
		                      ,
		                      [0, , , , [0, , , , Let_syntax$10[4][21]]]]),
		                 symbol_map = open[2];
		                function a(param, cont){
		                 if(! param) return cont(0);
		                 var organization = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (to_list$3, organization[2], cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_incr,
		                         ctrl,
		                         id,
		                         function(b){
		                          return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                         });
		               }
		               function get_member(ctrl, id, account, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           organizations = param[2][28],
		                           Incr = param[1],
		                           open =
		                             g
		                              ([0,
		                                Incr[72],
		                                Incr[73],
		                                ,
		                                Incr[75],
		                                Incr[76],
		                                Incr[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Incr[82]]),
		                           let$ = open[4];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   organizations[1],
		                                   function(organizations, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     organizations,
		     id,
		     function(match){
		      if(! match) return cont(0);
		      var organization = match[1];
		      return caml_exact_trampoline_cps_call
		              (user_id,
		               ctrl[1],
		               function(current_user){
		                return caml_exact_trampoline_cps_call$0
		                        (augment$0,
		                         current_user,
		                         organization,
		                         account,
		                         function(result){
		                          return caml_trampoline_cps_call3
		                                  (map$17,
		                                   result,
		                                   function(param, cont){
		                                    var authorization_results = param[2], for_member = param[1];
		                                    return caml_exact_trampoline_cps_call
		    (Sync[6],
		     function(m, cont){
		      function pp_auth_result(ppf, param, cont){
		       var reason = param[2], action = param[1];
		       function a(ppf, param, cont){
		        if(0 === param[0])
		         return caml_exact_trampoline_cps_call$0
		                 (always, bbM, ppf, dummy, cont);
		        var e = param[1];
		        return caml_exact_trampoline_cps_call$1
		                (pp_print_string, ppf, e, cont);
		       }
		       return caml_exact_trampoline_cps_call
		               (fprintf$0(ppf),
		                bbN,
		                function(b){
		                 return caml_trampoline_cps_call5
		                         (b, pp$117, action, a, reason, cont);
		                });
		      }
		      return caml_trampoline_cps_call6
		              (m,
		               0,
		               0,
		               bbO,
		               list(0, pp_auth_result),
		               authorization_results,
		               cont);
		     },
		     function(match){return cont(for_member);});
		                                   },
		                                   cont);
		                         });
		               });
		     });
		                                   },
		                                   function(member){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, member, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function rename$1(ctrl, crdt, id, new_name, cont){
		                var open = g(include$0), let$ = open[14];
		                function a(param, cont){
		                 var
		                  default_workspace = param[3],
		                  is_personal = param[2],
		                  old_name = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (diff$1,
		                          old_name,
		                          new_name,
		                          function(match){
		                           if(! match) return cont(bbR);
		                           var op = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (v$28,
		                                    [2, op],
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (element$12,
		      id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call
		                         (organizations,
		                          a,
		                          function(organization_operation){
		                           function a(default_workspace_operation){
		                            return caml_exact_trampoline_cps_call
		                                    (filter_opt,
		                                     [0, default_workspace_operation, 0],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (all_unit$27,
		       [0, organization_operation, a],
		       function(a){
		        return caml_exact_trampoline_cps_call$0
		                (apply_personal,
		                 ctrl[1],
		                 crdt,
		                 a,
		                 function(a){
		                  a = organization(id, bbP);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait$0,
		                           ctrl[11],
		                           0,
		                           a,
		                           function(match){return cont(bbQ);});
		                 });
		       });
		                                     });
		                           }
		                           if(default_workspace){
		                            var workspace = default_workspace[1];
		                            if(is_personal){
		                             var x = workspace[3][2];
		                             if(x === old_name)
		                              return caml_exact_trampoline_cps_call
		                                      (name$33,
		                                       op,
		                                       function(b){
		return caml_trampoline_cps_call2
		        (bQC,
		         workspace[2],
		         function(c){
		          return caml_trampoline_cps_call2
		                  (c,
		                   b,
		                   function(b){
		                    return caml_exact_trampoline_cps_call
		                            (workspaces,
		                             b,
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (element$12,
		                                       id,
		                                       function(c){
		return caml_trampoline_cps_call2
		        (c,
		         b,
		         function(b){
		          return caml_exact_trampoline_cps_call
		                  (organizations, b, function(b){return a([0, b]);});
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                            }
		                           }
		                           return a(0);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get$33,
		                         ctrl,
		                         id,
		                         function(match){
		                          function b(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          }
		                          if(! match) return b(bbS);
		                          var org = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (default_workspace_of_organizat,
		                                   id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     org[4],
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (is_personal,
		               org[3][4][1],
		               id,
		               function(c){return b([0, [0, org[3][4][2], c, a]]);});
		     });
		                                   });
		                         });
		               }
		               function workspaces$0(ctrl, id, cont){
		                function f(param, cont){
		                 if(! param) return cont(0);
		                 var organization = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (keys$0, organization[4], cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (get_incr,
		                         ctrl,
		                         id,
		                         function(t){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$41,
		                                   t,
		                                   f,
		                                   function(workspaces){
		                                    return cont
		    (symbol$229
		      (workspaces,
		       function(x, y, cont){
		        function a(x, y){
		         if(x){
		          if(y){
		           var y$0 = y[2], b = y[1], x$0 = x[2], a$0 = x[1];
		           return caml_exact_trampoline_cps_call$1
		                   (equal$61,
		                    a$0,
		                    b,
		                    function(b){
		                     return b
		                             ? caml_exact_trampoline_call2(a, x$0, y$0)
		                             : cont(b);
		                    });
		          }
		         }
		         else if(! y) return cont(1);
		         return cont(0);
		        }
		        return a(x, y);
		       }));
		                                   });
		                         });
		               }
		               function rpcs$0(param, side, cont){
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$104,
		                         dummy,
		                         function(schema){
		                          var organization_id = [0, cst_organization, schema, 0];
		                          function v(ctrl, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (all$32,
		                                    ctrl,
		                                    function(organizations){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_incremental, 0, organizations, cont);
		                                    });
		                          }
		                          var a = local_only(side, v);
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$104,
		                                   dummy,
		                                   function(c){
		                                    var
		                                     all =
		                                       call_reactive
		(cst_all,
		 "All organizations the user belongs to",
		 0,
		 [0, 0, 0, [3, c], 0],
		 a);
		                                    function v(ctrl, name, cont){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$8,
		   symbol_map$6,
		   ,
		   bind$10,
		   return$12,
		   map$23,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$4]),
		                                      let$ = open[4];
		                                     function a(crdt, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (create$53, ctrl, crdt, name, cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    }
		                                    var
		                                     create =
		                                       call_async
		(cst_create,
		 "Create a new organization owned by the user",
		 [0, [0, cst_name, schematic_param_name_schema_ve, 0], 0],
		 schema$21,
		 local_only(side, v));
		                                    function v$0(ctrl, id, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (get$34,
		      ctrl,
		      id,
		      function(organization){
		       return caml_exact_trampoline_cps_call$1
		               (of_incremental, 0, organization, cont);
		      });
		                                    }
		                                    var b = local_only(side, v$0);
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (full_organization_schema_versi,
		     schematic_version,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               a,
		               function(c){
		                var
		                 get =
		                   call_reactive
		                    (cst_get$0,
		                     "Get organization",
		                     [0, organization_id, 0],
		                     c,
		                     b);
		                function v(ctrl, organization_id, cont){
		                 return caml_exact_trampoline_cps_call
		                         (offline$0("Creating a stripe customer portal", ctrl),
		                          function(param, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (api$1,
		                                    ctrl[1],
		                                    function(match){
		                                     var api = match[2], Api = match[1];
		                                     return caml_trampoline_cps_call3
		     (Api[12][1][1], api, organization_id, cont);
		                                    });
		                          },
		                          cont);
		                }
		                var
		                 make_customer_portal =
		                   call_async
		                    ("make_customer_portal",
		                     "Create a temporary stripe portal for the given organization",
		                     [0, [0, cst_organization_id, schema$21, 0], 0],
		                     customer_portal_schema,
		                     local_only(side, v));
		                function v$0(ctrl, org, price, cont){
		                 return caml_exact_trampoline_cps_call
		                         (api$1,
		                          ctrl[1],
		                          function(match){
		                           var api = match[2], Api = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (offline$0("changing subscription", ctrl),
		                                    function(param, cont){
		                                     return caml_trampoline_cps_call4
		     (Api[14][1], api, org, price, cont);
		                                    },
		                                    cont);
		                          });
		                }
		                var a = local_only(side, v$0);
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schema$262,
		                         function(b){
		                          function schematic_version(param, cont){return cont();}
		                          return caml_exact_trampoline_cps_call
		                                  (Id$1[1],
		                                   schematic_version,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     c,
		     function(schema){
		      var
		       subscribe =
		         call_async
		          ("subscribe",
		           "Change the subscription.",
		           [0, organization_id, [0, [0, cst_price, schema, 0], 0]],
		           b,
		           a);
		      function v(ctrl, cont){
		       return caml_exact_trampoline_cps_call
		               (personal,
		                ctrl,
		                function(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_incremental, 0, a, cont);
		                });
		      }
		      var c = local_only(side, v);
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (full_organization_schema_versi,
		               schematic_version,
		               function(a){
		                var
		                 personal =
		                   call_reactive
		                    (cst_personal, "Get the personal organization", 0, a, c);
		                function v(ctrl, id, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4]),
		                  let$ = open[17],
		                  symbol_map = open[2];
		                 function a(crdt, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (remove$26,
		                           ctrl,
		                           crdt,
		                           [2, id],
		                           function(match){
		                            return caml_trampoline_cps_call2
		                                    (remove$14,
		                                     id,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (organizations,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call$0
		                (apply_personal,
		                 ctrl[1],
		                 crdt,
		                 a,
		                 function(a){
		                  a = organization(id, 0);
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait$0,
		                           ctrl[11],
		                           0,
		                           a,
		                           function(match){return cont(0);});
		                 });
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    b,
		                                    of_string$14,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                    });
		                          });
		                }
		                var
		                 remove =
		                   call_async
		                    (cst_delete,
		                     "Delete organization, and all its workspaces",
		                     [0, organization_id, 0],
		                     schematic_param_a_schema_versi,
		                     local_only(side, v));
		                function v$0(ctrl, id, name, cont){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4]),
		                  let$ = open[14],
		                  symbol_map = open[2];
		                 function a(crdt, cont){
		                  return caml_exact_trampoline_cps_call$2
		                          (rename$1,
		                           ctrl,
		                           crdt,
		                           id,
		                           name,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$12, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    b,
		                                    of_string$14,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                    });
		                          });
		                }
		                var
		                 rename =
		                   call_async
		                    (cst_rename,
		                     "Rename organization",
		                     [0,
		                      organization_id,
		                      [0, [0, cst_name, schematic_param_name_schema_ve, 0], 0]],
		                     schematic_param_a_schema_versi,
		                     local_only(side, v$0));
		                function v$1(ctrl, id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (workspaces$0,
		                          ctrl,
		                          id,
		                          function(workspaces){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_incremental, 0, workspaces, cont);
		                          });
		                }
		                var
		                 a = local_only(side, v$1),
		                 all$0 =
		                   call_reactive
		                    (cst_all,
		                     "All of the organization's workspaces",
		                     [0, organization_id, 0],
		                     list_schema(schema$39),
		                     a);
		                function v$2(ctrl, id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (members$1,
		                          ctrl,
		                          id,
		                          function(members){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_incremental, 0, members, cont);
		                          });
		                }
		                var b = local_only(side, v$2);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$117,
		                         dummy,
		                         function(c){
		                          var
		                           all$1 =
		                             call_reactive
		                              (cst_all,
		                               "Organization members",
		                               [0, organization_id, 0],
		                               [0, 0, 0, [3, c], 0],
		                               b),
		                           a = local_only(side, get_member);
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (for_member_schema_versioned,
		                                   schematic_version,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     b,
		     function(b){
		      var
		       get$0 =
		         call_reactive
		          (cst_get$0,
		           "Organization member",
		           [0, organization_id, [0, [0, cst_account, schema$38, 0], 0]],
		           b,
		           a);
		      function v(ctrl, id, email, cont){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$8,
		             symbol_map$6,
		             ,
		             bind$10,
		             return$12,
		             map$23,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$4]),
		        let$ = open[17],
		        symbol_map = open[2];
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call
		                (Members_pending[13],
		                 email,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (members_pending$0,
		                           a,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (element$12,
		                                     id,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (organizations,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (apply_personal, ctrl[1], crdt, a, cont);
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (symbol_map,
		                          b,
		                          of_string$14,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                });
		      }
		      var
		       invite =
		         call_async
		          ("invite",
		           "Invite new member to organization",
		           [0, organization_id, [0, [0, cst_email, schema$72, 0], 0]],
		           schematic_param_a_schema_versi,
		           local_only(side, v));
		      function v$0(ctrl, id, cont){
		       return caml_exact_trampoline_cps_call$1
		               (members_pending$1,
		                ctrl,
		                id,
		                function(members_pending){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_incremental, 0, members_pending, cont);
		                });
		      }
		      var
		       pending =
		         call_reactive
		          (cst_pending,
		           "Organization invitations",
		           [0, organization_id, 0],
		           [0, 0, 0, [3, schema$72], 0],
		           local_only(side, v$0));
		      function v$1(ctrl, id, account, cont){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$8,
		             symbol_map$6,
		             ,
		             bind$10,
		             return$12,
		             map$23,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$4]),
		        let$ = open[17],
		        symbol_map = open[2];
		       function a(crdt, cont){
		        return caml_trampoline_cps_call2
		                (Members[18],
		                 account,
		                 function(op){
		                  return caml_exact_trampoline_cps_call
		                          (v$28,
		                           [0, op],
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (element$12,
		                                     id,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (organizations,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (apply_personal,
		                           ctrl[1],
		                           crdt,
		                           a,
		                           function(a){
		                            a = organization(id, [5, account]);
		                            return caml_exact_trampoline_cps_call$0
		                                    (push_dont_wait$0,
		                                     ctrl[11],
		                                     0,
		                                     a,
		                                     function(match){return cont(0);});
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (symbol_map,
		                          b,
		                          of_string$14,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                });
		      }
		      var
		       remove$0 =
		         call_async
		          (cst_remove,
		           "Remove member from organization",
		           [0, organization_id, [0, [0, cst_member, schema$38, 0], 0]],
		           schematic_param_a_schema_versi,
		           local_only(side, v$1));
		      function v$2(ctrl, id, email, cont){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind$8,
		             symbol_map$6,
		             ,
		             bind$10,
		             return$12,
		             map$23,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$4]),
		        let$ = open[17],
		        symbol_map = open[2];
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call
		                (Members_pending[14],
		                 email,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (members_pending$0,
		                           a,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (element$12,
		                                     id,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (organizations,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (apply_personal, ctrl[1], crdt, a, cont);
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3
		                         (symbol_map,
		                          b,
		                          of_string$14,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                });
		      }
		      var
		       uninvite =
		         call_async
		          (cst_uninvite,
		           "Revoke invitation to organization",
		           [0, organization_id, [0, [0, cst_email, schema$72, 0], 0]],
		           schematic_param_a_schema_versi,
		           local_only(side, v$2));
		      return cont
		              ([0,
		                all,
		                [0,
		                 create,
		                 [0,
		                  get,
		                  [0,
		                   make_customer_portal,
		                   [0,
		                    [0,
		                     cst_member,
		                     [0,
		                      all$1,
		                      [0,
		                       get$0,
		                       [0, invite, [0, pending, [0, remove$0, [0, uninvite, 0]]]]]]],
		                    [0,
		                     personal,
		                     [0,
		                      remove,
		                      [0,
		                       rename,
		                       [0, subscribe, [0, [0, cst_workspaces, [0, all$0, 0]], 0]]]]]]]]]]);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var user_preferences = [0, default$, empty$0];
		               function create$54
		               (ctrl,
		                crdt,
		                organization,
		                catalog_key,
		                name,
		                instructions_markdown,
		                param,
		                cont){
		                var open = g(include$0), let$ = open[14];
		                return caml_exact_trampoline_cps_call
		                        (default_workspace_of_organizat,
		                         organization,
		                         function(workspace){
		                          var agent_id = Agent[29].call(null);
		                          return caml_exact_trampoline_cps_call$1
		                                  (strip,
		                                   0,
		                                   instructions_markdown,
		                                   function(a){
		                                    var
		                                     instructions_doc =
		                                       is_empty$0(a)
		? empty$0
		: [0, [0, make$33(0, [8, [0, instructions_markdown]]), 0]],
		                                     key = [0, catalog_key],
		                                     conversations = Set$2[67],
		                                     new_agent =
		                                       [0,
		[0, default$, instructions_doc],
		0,
		conversations,
		[0, agent_id],
		key,
		name,
		user_preferences,
		user_preferences],
		                                     a = new_agent[4];
		                                    function c(param, cont){
		                                     return caml_trampoline_cps_call2
		     (of_string$14, agent_id, cont);
		                                    }
		                                    function b(a){
		                                     return caml_exact_trampoline_cps_call$2
		     (apply$125,
		      ctrl[1],
		      crdt,
		      workspace,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$1(let$, a, c, cont);
		      });
		                                    }
		                                    if(0 !== a[0])
		                                     return caml_exact_trampoline_cps_call
		     (Assistant$0[17],
		      new_agent,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (assistant,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call(ai$0, a, b);
		                });
		      });
		                                    var id = a[1];
		                                    return caml_trampoline_cps_call3
		    (Ident$0[1][14],
		     id,
		     new_agent,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (agents,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call(ai$0, a, b);
		               });
		     });
		                                   });
		                         });
		               }
		               function get_incr$0(ai, workspace, agent, cont){
		                if(0 !== agent[0]) return cont(ai[2]);
		                var id = agent[1];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6, ai[1][2], [0, workspace, id], cont);
		               }
		               function get_agent$0(ctrl, workspace, agent, cont){
		                var values = ctrl[9][5];
		                return caml_exact_trampoline_cps_call$0
		                        (get_incr$0,
		                         values[42],
		                         workspace,
		                         agent,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, a, cont);
		                         });
		               }
		               function active_agents(ctrl, workspace, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function a(agent_ids, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_list$3, agent_ids, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (filter_mapi$2,
		                         0,
		                         [0, equal$167],
		                         values[42][1][1],
		                         function(param, data, cont){
		                          var workspace$0 = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139,
		                                   workspace,
		                                   workspace$0,
		                                   function(a){return cont(some_if(a, data));});
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$3
		                                  (rekey,
		                                   0,
		                                   [0, equal$167],
		                                   b,
		                                   [0, Agent[24]],
		                                   function(a, param){var agent_id = a[2]; return agent_id;},
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$0
		    (keys$2,
		     0,
		     0,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function update_agent
		               (ctrl, crdt, workspace, agent, patch, cont){
		                var open = g(include$0), let$ = open[14];
		                function a(state, cont){
		                 function a(operation, cont){
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125, ctrl[1], crdt, workspace, operation, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (update$9,
		                          state,
		                          patch,
		                          agent,
		                          function(t){
		                           var b = 0 === t[0] ? t : [1, -358247754];
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$, of_option(b, -358247754), a, cont);
		                         });
		               }
		               function delete_agent(ctrl, crdt, workspace, agent_id, cont){
		                var open = g(include$0), let$ = open[14];
		                function a(state, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (remove$21,
		                          state,
		                          agent_id,
		                          function(match){
		                           if(! match)
		                            return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                           var operation = match[1];
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply$125, ctrl[1], crdt, workspace, operation, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$, of_option(b, [0, 847566860, workspace]), a, cont);
		                         });
		               }
		               function get_automation(ctrl, workspace, automation, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[11];
		                function a(automation, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_internal, automation, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         values[42][3][2],
		                         [0, workspace, automation],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function active_automations(ctrl, workspace, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function a(automation_ids, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_list$3, automation_ids, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (filter_mapi$2,
		                         0,
		                         [0, equal$175],
		                         values[42][3][1],
		                         function(param, data, cont){
		                          var workspace$0 = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139,
		                                   workspace,
		                                   workspace$0,
		                                   function(a){return cont(some_if(a, data));});
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$3
		                                  (rekey,
		                                   0,
		                                   [0, equal$175],
		                                   b,
		                                   [0, comparator$35],
		                                   function(a, param){
		                                    var automation_id = a[2];
		                                    return automation_id;
		                                   },
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$0
		    (keys$2,
		     0,
		     0,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function automation_runs_by_status_for_
		               (ctrl, workspace, automation_id, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1];
		                g
		                 ([0,
		                   incremental[72],
		                   incremental[73],
		                   ,
		                   incremental[75],
		                   incremental[76],
		                   incremental[77],
		                   ,
		                   ,
		                   ,
		                   ,
		                   incremental[82]]);
		                return caml_exact_trampoline_cps_call$2
		                        (filter_mapi$2,
		                         0,
		                         [0, equal$185],
		                         values[42][6][1],
		                         function(param, data, cont){
		                          var workspace$0 = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139,
		                                   workspace,
		                                   workspace$0,
		                                   function(b){
		                                    function a(a){return cont(some_if(a, data));}
		                                    return b
		    ? caml_exact_trampoline_cps_call$1
		      (symbol$183, data[1], automation_id, a)
		    : a(b);
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$3
		                                  (rekey,
		                                   0,
		                                   [0, equal$185],
		                                   a,
		                                   [0, Automation_run[24]],
		                                   function(a, param){var run_id = a[2]; return run_id;},
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$5
		    (unordered_fold$0,
		     0,
		     [0, equal$185],
		     0,
		     0,
		     0,
		     0,
		     a,
		     [0,
		      Automation_run[26][67],
		      Automation_run[26][67],
		      Automation_run[26][67],
		      Automation_run[26][67]],
		     function(run_id, run, acc, cont){
		      var match = run[7];
		      if(typeof match !== "number")
		       switch(match[0]){
		         case 0:
		          var e = acc[4], f = acc[3];
		          return caml_exact_trampoline_cps_call$1
		                  (add$4,
		                   acc[2],
		                   run_id,
		                   function(a){return cont([0, acc[1], a, f, e]);});
		         case 1:
		          var d = acc[4];
		          return caml_exact_trampoline_cps_call$1
		                  (add$4,
		                   acc[3],
		                   run_id,
		                   function(a){return cont([0, acc[1], acc[2], a, d]);});
		         default:
		          return caml_exact_trampoline_cps_call$1
		                  (add$4,
		                   acc[4],
		                   run_id,
		                   function(a){return cont([0, acc[1], acc[2], acc[3], a]);});
		       }
		      var a = acc[4], b = acc[3], c = acc[2];
		      return caml_exact_trampoline_cps_call$1
		              (add$4,
		               acc[1],
		               run_id,
		               function(d){return cont([0, d, c, b, a]);});
		     },
		     function(run_id, run, acc, cont){
		      var match = run[7];
		      if(typeof match !== "number")
		       switch(match[0]){
		         case 0:
		          var e = acc[4], f = acc[3];
		          return caml_exact_trampoline_cps_call$1
		                  (remove$0,
		                   acc[2],
		                   run_id,
		                   function(a){return cont([0, acc[1], a, f, e]);});
		         case 1:
		          var d = acc[4];
		          return caml_exact_trampoline_cps_call$1
		                  (remove$0,
		                   acc[3],
		                   run_id,
		                   function(a){return cont([0, acc[1], acc[2], a, d]);});
		         default:
		          return caml_exact_trampoline_cps_call$1
		                  (Automation_run[26][9],
		                   acc[4],
		                   run_id,
		                   function(a){return cont([0, acc[1], acc[2], acc[3], a]);});
		       }
		      var a = acc[4], b = acc[3], c = acc[2];
		      return caml_exact_trampoline_cps_call$1
		              (remove$0,
		               acc[1],
		               run_id,
		               function(d){return cont([0, d, c, b, a]);});
		     },
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (of_incremental, 0, a, cont);
		     });
		                                   });
		                         });
		               }
		               function get_automation_run(ctrl, workspace, run_id, cont){
		                var values = ctrl[9][5];
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         values[42][6][2],
		                         [0, workspace, run_id],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental, 0, a, cont);
		                         });
		               }
		               function resume_automation_run
		               (ctrl, crdt, workspace, run_id, answers, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (get_automation_run,
		                         ctrl,
		                         workspace,
		                         run_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(run_opt){
		                                    if(! run_opt)
		                                     return caml_exact_trampoline_cps_call
		     (Sync[4],
		      function(m, cont){
		       return caml_trampoline_cps_call6
		               (m, 0, 0, bbU, Automation_run[1], run_id, cont);
		      },
		      function(match){
		       return caml_trampoline_cps_call2(return$13, 0, cont);
		      });
		                                    var run = run_opt[1], match = run[7];
		                                    if(typeof match !== "number" && 1 === match[0]){
		                                     var conversation = match[2], breakpoint = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (of_answers,
		      breakpoint[4],
		      answers,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (length$1,
		                 answers,
		                 function(a){
		                  var questions = breakpoint[4][1];
		                  return caml_exact_trampoline_cps_call
		                          (length$1,
		                           questions,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$190,
		                                     function(c){
		                                      return caml_trampoline_cps_call3
		      (c,
		       b,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (return_error, [0, 9943782, a], cont);
		       });
		                                     });
		                           });
		                 });
		       var response = match[1];
		       return caml_exact_trampoline_cps_call$1
		               (set_status$1,
		                run_id,
		                [2, breakpoint, response, conversation],
		                function(op){
		                 return caml_exact_trampoline_cps_call$2
		                         (apply$125,
		                          ctrl[1],
		                          crdt,
		                          workspace,
		                          op,
		                          function(a){
		                           return caml_trampoline_cps_call2(return$12, a, cont);
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (return_error, bbT, cont);
		                                   });
		                         });
		               }
		               function agent_automations(ctrl, workspace, agent, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 symbol_map = open[2];
		                function a(param, cont){
		                 if(! param) return cont(0);
		                 var agent = param[1];
		                 return cont(agent[2]);
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (get_incr$0,
		                         values[42],
		                         workspace,
		                         agent,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (symbol_map,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function active_steps(ctrl, workspace, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function a(step_ids, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_list$3, step_ids, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (filter_mapi$2,
		                         0,
		                         [0, equal$170],
		                         values[42][5][1],
		                         function(param, data, cont){
		                          var workspace$0 = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139,
		                                   workspace,
		                                   workspace$0,
		                                   function(a){return cont(some_if(a, data));});
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$3
		                                  (rekey,
		                                   0,
		                                   [0, equal$170],
		                                   b,
		                                   [0, comparator$34],
		                                   function(a, param){var step_id = a[2]; return step_id;},
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$0
		    (keys$2,
		     0,
		     0,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$,
		               b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (of_incremental, 0, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function list_automation_steps
		               (ctrl, workspace, automation, cont){
		                var
		                 param = ctrl[9],
		                 values = param[5],
		                 incremental = param[1],
		                 open =
		                   g
		                    ([0,
		                      incremental[72],
		                      incremental[73],
		                      ,
		                      incremental[75],
		                      incremental[76],
		                      incremental[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      incremental[82]]),
		                 let$ = open[4];
		                function a(automation_opt, cont){
		                 if(! automation_opt) return cont(0);
		                 var automation_data = automation_opt[1];
		                 return cont(automation_data[3]);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (find$6,
		                         values[42][3][2],
		                         [0, workspace, automation],
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, a, cont);
		                                   });
		                         });
		               }
		               function create_step
		               (ctrl, crdt, workspace, automation, a, param, cont){
		                var
		                 prompt = a[2],
		                 name = a[1],
		                 open = g(include$0),
		                 let$ = open[17],
		                 let$0 = open[14],
		                 step_id = make$52(),
		                 new_step = [0, [0, prompt], step_id, [0, name]];
		                function b(state, cont){
		                 function a(operation, cont){
		                  function a(param, cont){return cont(step_id);}
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           workspace,
		                           operation,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (add$35,
		                          automation,
		                          state,
		                          new_step,
		                          function(t){
		                           var b = 0 === t[0] ? t : [1, bbV];
		                           return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$0, of_option(a, bbW), b, cont);
		                         });
		               }
		               function create_automation
		               (ctrl, crdt, workspace, name, steps, agent, param, cont){
		                var
		                 open = g(include$0),
		                 let$ = open[17],
		                 let$0 = open[14],
		                 new_automation = make$54(0, [0, name], steps, 0, 0);
		                function a(state, cont){
		                 function a(operation, cont){
		                  function a(param, cont){return cont(new_automation[1]);}
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           workspace,
		                           operation,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (add$33,
		                          agent,
		                          state,
		                          new_automation,
		                          function(t){
		                           var b = 0 === t[0] ? t : [1, bbX];
		                           return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$0, of_option(b, bbY), a, cont);
		                         });
		               }
		               function update_step(ctrl, crdt, workspace, step, patch, cont){
		                var open = g(include$0), let$ = open[17], let$0 = open[14];
		                function a(state, cont){
		                 function a(operation, cont){
		                  function a(param, cont){return cont(0);}
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           workspace,
		                           operation,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (update$10,
		                          state,
		                          patch,
		                          step,
		                          function(t){
		                           var b = 0 === t[0] ? t : [1, bbZ];
		                           return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$0, of_option(b, bb0), a, cont);
		                         });
		               }
		               function update_automation
		               (ctrl, crdt, workspace, automation, param, cont){
		                var
		                 trigger = param[3],
		                 enabled = param[2],
		                 name = param[1],
		                 open = g(include$0),
		                 let$ = open[17],
		                 let$0 = open[14],
		                 let$1 = open[11];
		                function a(state, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (let$1,
		                          trigger,
		                          function(trigger, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (to_internal, trigger, cont);
		                          },
		                          function(trigger){
		                           function a(operation, cont){
		                            function a(param, cont){return cont(0);}
		                            return caml_exact_trampoline_cps_call$2
		                                    (apply$125,
		                                     ctrl[1],
		                                     crdt,
		                                     workspace,
		                                     operation,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$3
		                                   (update$8,
		                                    name,
		                                    enabled,
		                                    trigger,
		                                    state,
		                                    automation,
		                                    function(t){
		                                     var b = 0 === t[0] ? t : [1, bb1];
		                                     return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$0, of_option(b, bb2), a, cont);
		                         });
		               }
		               function delete_step(ctrl, crdt, workspace, step, cont){
		                var open = g(include$0), let$ = open[14];
		                function a(state, cont){
		                 function a(operation, cont){
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125, ctrl[1], crdt, workspace, operation, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (remove$22,
		                          state,
		                          step,
		                          function(t){
		                           var b = 0 === t[0] ? t : [1, bb3];
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$, of_option(b, bb4), a, cont);
		                         });
		               }
		               function delete_automation
		               (ctrl, crdt, workspace, automation_id, cont){
		                var open = g(include$0), let$ = open[17], let$0 = open[14];
		                function a(state, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (remove_cascading,
		                          0,
		                          state,
		                          automation_id,
		                          function(match){
		                           if(! match)
		                            return caml_trampoline_cps_call2(of_string$14, 0, cont);
		                           var operation = match[1];
		                           function a(param, cont){return cont(0);}
		                           return caml_exact_trampoline_cps_call$2
		                                   (apply$125,
		                                    ctrl[1],
		                                    crdt,
		                                    workspace,
		                                    operation,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$0, of_option(b, [0, 847566860, workspace]), a, cont);
		                         });
		               }
		               var
		                Http$0 = Make$9(Handler),
		                request_timeout$0 = of_int_s(30),
		                client_version = caml_callback(to_string$11, [version$2]);
		               function message$0(message, cont){return cont([0, message, 0]);
		               }
		               function code(param){
		                var status = param[1];
		                return code_of_status(status);
		               }
		               function header(param, name, cont){
		                var headers = param[2];
		                return caml_exact_trampoline_cps_call$0
		                        (find$1, headers, equal$7, name, cont);
		               }
		               function of_response(opt, response, cont){
		                var
		                 what = opt ? opt[1] : "MCP server",
		                 body = response[3],
		                 a = [0, response];
		                return caml_exact_trampoline_cps_call$1
		                        (strip,
		                         0,
		                         body,
		                         function(body){
		                          function b(c){
		                           var b = code(response);
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$193,
		                                    function(d){
		                                     return caml_trampoline_cps_call4
		     (d, what, b, c, function(b){return cont([0, b, a]);});
		                                    });
		                          }
		                          return is_empty$0(body)
		                                  ? b(cst$1)
		                                  : 500
		                                    < caml_ml_string_length(body)
		                                    ? caml_exact_trampoline_cps_call$1
		                                      (prefix,
		                                       body,
		                                       500,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$191,
		         function(c){return caml_trampoline_cps_call2(c, a, b);});
		                                       })
		                                    : caml_exact_trampoline_cps_call$1
		                                      (kasprintf,
		                                       id,
		                                       fmt$192,
		                                       function(a){return caml_trampoline_cps_call2(a, body, b);});
		                         });
		               }
		               function context(prefix, t, cont){
		                var a = t[2], b = t[1];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$194,
		                         function(c){
		                          return caml_trampoline_cps_call3
		                                  (c, prefix, b, function(b){return cont([0, b, a]);});
		                         });
		               }
		               function obj_field$0(key, param, cont){
		                if(typeof param !== "number"){
		                 var variant = param[1];
		                 if(79 === variant){
		                  var fields = param[2];
		                  return caml_exact_trampoline_cps_call$0
		                          (find$1, fields, equal$4, key, cont);
		                 }
		                }
		                return cont(0);
		               }
		               function string_field(key, json, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (obj_field$0,
		                         key,
		                         json,
		                         function(a){
		                          if(a){
		                           a = a[1];
		                           if(typeof a !== "number"){
		                            var variant = a[1];
		                            if(-976970511 === variant){
		                             var s = a[2];
		                             return cont([0, s]);
		                            }
		                           }
		                          }
		                          return cont(0);
		                         });
		               }
		               var bPm = 1;
		               function parse_body(headers, body, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (find$1,
		                         headers,
		                         equal$7,
		                         cst_content_type,
		                         function(a){
		                          var content_type = value$4(a, cst$1);
		                          return caml_exact_trampoline_cps_call$0
		                                  (is_substring_gen,
		                                   bPm,
		                                   content_type,
		                                   "text/event-stream",
		                                   function(a){
		                                    return a
		    ? caml_exact_trampoline_cps_call
		      (split_lines,
		       body,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (filter_map$0,
		                 a,
		                 function(line, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (chop_prefix,
		                           line,
		                           "data:",
		                           function(match){
		                            if(! match) return cont(0);
		                            var rest = match[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (strip,
		                                     0,
		                                     rest,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (of_string$11,
		       a,
		       function(match){
		        if(0 !== match[0]) return cont(0);
		        var json = match[1];
		        return cont([0, json]);
		       });
		                                     });
		                           });
		                 },
		                 cont);
		       })
		    : caml_exact_trampoline_cps_call
		      (of_string$11,
		       body,
		       function(match){
		        if(0 !== match[0]) return cont(0);
		        var json = match[1];
		        return cont([0, json, 0]);
		       });
		                                   });
		                         });
		               }
		               function result_of_message(message, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (obj_field$0,
		                         cst_error,
		                         message,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call$1
		                                   (obj_field$0,
		                                    cst_result,
		                                    message,
		                                    function(match){
		                                     if(! match) return cont(bb7);
		                                     var result = match[1];
		                                     return cont([0, result]);
		                                    });
		                          var err_json = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (string_field,
		                                   cst_message,
		                                   err_json,
		                                   function(match){
		                                    function a(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$195,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b, a, function(a){return cont([1, a]);});
		      });
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (to_string$15, err_json, a);
		                                    var message = match[1];
		                                    return a(message);
		                                   });
		                         });
		               }
		               var
		                cst_protocolVersion = "protocolVersion",
		                max_protocol_version = "2025-11-25";
		               function negotiated_protocol_version
		               (supported, initialize_result, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (string_field,
		                         cst_protocolVersion,
		                         initialize_result,
		                         function(a){
		                          if(! a) return cont([0, max_protocol_version]);
		                          var version = a[1];
		                          a:
		                          {
		                           a = supported;
		                           for(;;){
		                            if(! a) break;
		                            var bs = a[2], b = a[1], a = version === b;
		                            if(a) break a;
		                            a = bs;
		                           }
		                           a = 0;
		                          }
		                          return a
		                                  ? cont([0, version])
		                                  : caml_exact_trampoline_cps_call$1
		                                    (concat$0,
		                                     bb9,
		                                     supported,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$196,
		       function(b){
		        return caml_trampoline_cps_call3
		                (b, version, a, function(a){return cont([1, a]);});
		       });
		                                     });
		                         });
		               }
		               function http_post(url, headers, body, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(response, cont){
		                 if(0 !== response[0])
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$198,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     url,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (message$0, a, function(a){return cont([1, a]);});
		                                     });
		                           });
		                 var
		                  match = response[1],
		                  status = match[3],
		                  headers = match[2],
		                  body = match[1];
		                 return cont([0, [0, status, headers, body]]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string$19,
		                         url,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (to_uri,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$3
		    (Http$0[5][7],
		     [0, request_timeout$0],
		     [0, headers],
		     [0, [0, json_schema, body]],
		     Http$0[3],
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               var
		                http_protocol_versions =
		                  [0,
		                   "2025-03-26",
		                   [0, "2025-06-18", [0, max_protocol_version, 0]]],
		                initialize_params =
		                  [0,
		                   79,
		                   [0,
		                    [0,
		                     cst_protocolVersion,
		                     [0, -976970511, max_protocol_version]],
		                    [0,
		                     bb$,
		                     [0,
		                      [0,
		                       "clientInfo",
		                       [0,
		                        79,
		                        [0,
		                         bb_,
		                         [0, [0, cst_version, [0, -976970511, client_version]], 0]]]],
		                      0]]]];
		               function with_connection(server, f, cont){
		                g
		                 ([0,
		                   symbol_bind$8,
		                   symbol_map$6,
		                   ,
		                   bind$10,
		                   return$12,
		                   map$23,
		                   ,
		                   ,
		                   ,
		                   ,
		                   Let_syntax$4]);
		                var match = server[3];
		                if(0 !== match[0])
		                 return caml_exact_trampoline_cps_call
		                         (message$0,
		                          "stdio MCP servers are not supported on this platform",
		                          function(a){
		                           return caml_exact_trampoline_cps_call(fail$2, a, cont);
		                          });
		                var
		                 url = match[1],
		                 auth = server[4],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14],
		                 let$0 = open[4],
		                 send =
		                   value$4
		                    (0,
		                     function(a, b, cont){
		                      return caml_exact_trampoline_cps_call$0
		                              (http_post, url, a, b, cont);
		                     });
		                function a(auth_headers){
		                 var
		                  session_id = [0, 0],
		                  protocol_version = [0, max_protocol_version];
		                 function post(for_initialize, body, cont){
		                  var
		                   match = session_id[1],
		                   cst_mcp_session_id = "mcp-session-id";
		                  function a(response, cont){
		                   if(0 !== response[0]) return cont(response);
		                   var
		                    response$0 = response[1],
		                    body = response$0[3],
		                    headers = response$0[2],
		                    status = response$0[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (header,
		                            response$0,
		                            cst_mcp_session_id,
		                            function(o){
		                             if(o){var id = o[1]; session_id[1] = [0, id];}
		                             return is_success(code_of_status(status))
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (parse_body,
		headers,
		body,
		function(a){return cont([0, a]);})
		                                     : caml_exact_trampoline_cps_call$1
		                                       (of_response,
		0,
		response$0,
		function(a){return cont([1, a]);});
		                            });
		                  }
		                  if(match)
		                   var
		                    sid = match[1],
		                    session_header = [0, [0, cst_mcp_session_id, sid], 0];
		                  else
		                   session_header = 0;
		                  var
		                   protocol_header =
		                     for_initialize
		                      ? 0
		                      : [0, [0, "mcp-protocol-version", protocol_version[1]], 0];
		                  return caml_exact_trampoline_cps_call$1
		                          (append$0,
		                           session_header,
		                           protocol_header,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (append$0,
		                                     auth_headers,
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (append$0,
		       base,
		       b,
		       function(b){
		        return caml_trampoline_cps_call3
		                (send,
		                 b,
		                 body,
		                 function(b){
		                  return caml_trampoline_cps_call3(let$0, b, a, cont);
		                 });
		       });
		                                     });
		                           });
		                 }
		                 var cst_initialize = "initialize";
		                 function request(id, method, params, cont){
		                  var is_initialize = method === cst_initialize ? 1 : 0;
		                  function a(messages, cont){
		                   function a(param){
		                    function b(match){
		                     function a(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (map_error,
		                               a,
		                               message$0,
		                               function(result){
		                                function a(){
		                                 return caml_trampoline_cps_call2(return$12, result, cont);
		                                }
		                                if(0 !== result[0]) return a();
		                                var json = result[1];
		                                return is_initialize
		? caml_exact_trampoline_cps_call$1
		  (negotiated_protocol_version,
		   http_protocol_versions,
		   json,
		   function(v){
		    if(0 !== v[0]) return a();
		    var version = v[1];
		    protocol_version[1] = version;
		    return a();
		   })
		: a();
		                               });
		                     }
		                     function b(param){
		                      function c(match){
		                       if(! match) return a(bb8);
		                       var message = match[1];
		                       return caml_exact_trampoline_cps_call
		                               (result_of_message, message, a);
		                      }
		                      if(! param) return c(0);
		                      var l = param[2], x = param[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (obj_field$0,
		                               cst_result,
		                               x,
		                               function(a){
		                                a = is_some(a);
		                                function d(a){
		                                 return a ? c([0, x]) : caml_exact_trampoline_call1(b, l);
		                                }
		                                return a
		? d(a)
		: caml_exact_trampoline_cps_call$1
		  (obj_field$0,
		   cst_error,
		   x,
		   function(a){return d(is_some(a));});
		                               });
		                     }
		                     if(! match) return b(messages);
		                     var message = match[1];
		                     return caml_exact_trampoline_cps_call
		                             (result_of_message, message, a);
		                    }
		                    if(! param) return b(0);
		                    var l = param[2], message = param[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (string_field,
		                             cst_id,
		                             message,
		                             function(c){
		                              if(c) var s = c[1], c = s === id; else c = 0;
		                              return c
		                                      ? b([0, message])
		                                      : caml_exact_trampoline_call1(a, l);
		                             });
		                   }
		                   return a(messages);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (post,
		                           is_initialize,
		                           [0,
		                            79,
		                            [0,
		                             bb5,
		                             [0,
		                              [0, cst_id, [0, -976970511, id]],
		                              [0,
		                               [0, cst_method, [0, -976970511, method]],
		                               [0, [0, cst_params, params], 0]]]]],
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 function notify(method, params, cont){
		                  function a(param, cont){return cont(0);}
		                  return caml_exact_trampoline_cps_call$1
		                          (post,
		                           0,
		                           [0,
		                            79,
		                            [0,
		                             bb6,
		                             [0,
		                              [0, cst_method, [0, -976970511, method]],
		                              [0, [0, cst_params, params], 0]]]],
		                           function(b){
		                            return caml_trampoline_cps_call3(let$0, b, a, cont);
		                           });
		                 }
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4]),
		                  let$1 = open[14],
		                  let$2 = open[3],
		                  symbol_map = open[2],
		                  cst_MCP_initialize_failed = "MCP initialize failed";
		                 function a(initialized, cont){
		                  function a(param, cont){
		                   function a(param, cont){
		                    return caml_exact_trampoline_cps_call(f, request, cont);
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (notify,
		                            "notifications/initialized",
		                            bca,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$2, b, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (negotiated_protocol_version,
		                           http_protocol_versions,
		                           initialized,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map_error,
		                                     b,
		                                     message$0,
		                                     function(t){
		                                      function b(b){
		                                       return caml_trampoline_cps_call2
		       (return$12,
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		        });
		                                      }
		                                      if(0 === t[0]) return b(t);
		                                      var x = t[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (context,
		       cst_MCP_initialize_failed,
		       x,
		       function(a){return b([1, a]);});
		                                     });
		                           });
		                 }
		                 function b(t, cont){
		                  if(0 === t[0]) return cont(t);
		                  var x = t[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (context,
		                           cst_MCP_initialize_failed,
		                           x,
		                           function(a){return cont([1, a]);});
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (request,
		                          cst_0,
		                          cst_initialize,
		                          initialize_params,
		                          function(c){
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$1, b, a, cont);
		                                    });
		                          });
		                }
		                if(typeof auth === "number") return a(0);
		                if(0 === auth[0]){
		                 var token = auth[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$197,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    token,
		                                    function(b){return a([0, [0, "authorization", b], 0]);});
		                          });
		                }
		                var value = auth[2], name = auth[1];
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         name,
		                         function(b){return a([0, [0, b, value], 0]);});
		               }
		               function parse_tool(json, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (string_field,
		                         cst_name,
		                         json,
		                         function(match){
		                          if(! match) return cont(0);
		                          var name = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (string_field,
		                                   cst_description,
		                                   json,
		                                   function(a){
		                                    var description = value$4(a, cst$1);
		                                    return caml_exact_trampoline_cps_call$1
		    (obj_field$0,
		     cst_inputSchema,
		     json,
		     function(match){
		      if(match)
		       var schema = match[1], input_schema = schema;
		      else
		       input_schema = bcb;
		      return caml_exact_trampoline_cps_call$1
		              (obj_field$0,
		               cst_annotations,
		               json,
		               function(param){
		                function a(a){
		                 return cont([0, [0, name, description, input_schema, a]]);
		                }
		                if(! param) return a(default_annotations);
		                var annotations = param[1];
		                if(typeof annotations === "number")
		                 return a(default_annotations);
		                var variant = annotations[1];
		                if(79 !== variant) return a(default_annotations);
		                function bool(key, default$, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (obj_field$0,
		                          key,
		                          annotations,
		                          function(a){
		                           if(a){
		                            a = a[1];
		                            if(typeof a !== "number"){
		                             var variant = a[1];
		                             if(737456202 === variant){var b = a[2]; return cont(b);}
		                            }
		                           }
		                           return cont(default$);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (obj_field$0,
		                         cst_idempotentHint,
		                         annotations,
		                         function(c){
		                          a:
		                          {
		                           if(c){
		                            c = c[1];
		                            if(typeof c !== "number"){
		                             var variant = c[1];
		                             if(737456202 === variant){
		                              var b = c[2], idempotent_hint = [0, b];
		                              break a;
		                             }
		                            }
		                           }
		                           idempotent_hint = 0;
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (bool,
		                                   cst_openWorldHint,
		                                   1,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (bool,
		     cst_destructiveHint,
		     1,
		     function(c){
		      return caml_exact_trampoline_cps_call$1
		              (bool,
		               cst_readOnlyHint,
		               0,
		               function(d){return a([0, d, c, idempotent_hint, b]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function list_tools_result(server, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (with_connection,
		                         server,
		                         function(request, cont){
		                          var
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$8,
		                                symbol_map$6,
		                                ,
		                                bind$10,
		                                return$12,
		                                map$23,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$4]),
		                           let$ = open[14];
		                          function a(json, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (obj_field$0,
		                                    cst_tools,
		                                    json,
		                                    function(a){
		                                     function b(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (map_error,
		       a,
		       message$0,
		       function(a){
		        return caml_trampoline_cps_call2(return$12, a, cont);
		       });
		                                     }
		                                     if(! a) return b(a9);
		                                     a = a[1];
		                                     if(typeof a === "number") return b(a9);
		                                     var variant = a[1];
		                                     if(65 !== variant) return b(a9);
		                                     var tools = a[2];
		                                     return caml_exact_trampoline_cps_call$1
		     (filter_map$0,
		      tools,
		      parse_tool,
		      function(a){return b([0, a]);});
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (request,
		                                   cst_1,
		                                   "tools/list",
		                                   bcc,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function content_text(result_json, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (obj_field$0,
		                         cst_content,
		                         result_json,
		                         function(a){
		                          if(a){
		                           a = a[1];
		                           if(typeof a !== "number"){
		                            var variant = a[1];
		                            if(65 === variant){
		                             var items = a[2];
		                             return caml_exact_trampoline_cps_call$1
		                                     (filter_map$0,
		                                      items,
		                                      function(a, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (string_field, cst_text, a, cont);
		                                      },
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (concat$0, bcd, a, cont);
		                                      });
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (to_string$15, result_json, cont);
		                         });
		               }
		               function call_tool(server, name, arguments$, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (with_connection,
		                         server,
		                         function(request, cont){
		                          var
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$8,
		                                symbol_map$6,
		                                ,
		                                bind$10,
		                                return$12,
		                                map$23,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$4]),
		                           symbol_map = open[2];
		                          function a(error, cont){
		                           if(0 !== error[0]) return cont(error);
		                           var result_json = error[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (obj_field$0,
		                                    "isError",
		                                    result_json,
		                                    function(a){
		                                     if(a){
		                                      a = a[1];
		                                      if(typeof a !== "number"){
		                                       var variant = a[1];
		                                       if(737456202 === variant && a[2])
		return caml_exact_trampoline_cps_call
		        (content_text,
		         result_json,
		         function(a){
		          return caml_exact_trampoline_cps_call
		                  (message$0, a, function(a){return cont([1, a]);});
		         });
		                                      }
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (obj_field$0,
		      "structuredContent",
		      result_json,
		      function(match){
		       if(! match) return cont([0, result_json]);
		       var structured = match[1];
		       return cont([0, structured]);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (request,
		                                   cst_1,
		                                   "tools/call",
		                                   [0,
		                                    79,
		                                    [0,
		                                     [0, cst_name, [0, -976970511, name]],
		                                     [0, [0, cst_arguments, arguments$], 0]]],
		                                   function(b){
		                                    return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                                   });
		                         },
		                         function(result){
		                          return caml_trampoline_cps_call3
		                                  (g
		                                     ([0,
		                                       symbol_bind$8,
		                                       symbol_map$6,
		                                       ,
		                                       bind$10,
		                                       return$12,
		                                       map$23,
		                                       ,
		                                       ,
		                                       ,
		                                       ,
		                                       Let_syntax$4])
		                                    [4],
		                                   result,
		                                   function(result, cont){
		                                    if(0 === result[0]) return cont(result);
		                                    var x = result[1], message = x[1];
		                                    return cont([1, message]);
		                                   },
		                                   cont);
		                         });
		               }
		               function organizations$0(param){
		                if(0 === param[0]){var id = param[1]; return [0, id, 0];}
		                var others = param[2], owner = param[1];
		                return [0, owner, others];
		               }
		               function get_system(interactivity, cont){
		                switch(interactivity){
		                  case 0:
		                   var
		                    a =
		                      "When a request is ambiguous or you are unsure how to proceed, ask the user for clarification rather than guessing.";
		                   break;
		                  case 1:
		                   a =
		                    "Proceed on your best reasonable interpretation of the request. Ask the user for clarification only when the request is genuinely ambiguous or you are blocked and cannot make a sensible choice on your own.";
		                   break;
		                  default:
		                   a =
		                    "Do not ask the user questions. Always make a reasonable best-effort choice and proceed.";
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (concat,
		                         cst$61,
		                         [0,
		                          "Follow all safety, permission, and product rules. Never perform irreversible actions unless the user has explicitly instructed you to do so or approved it. Batch independent tool calls: issue all calls whose arguments are known in the same response, even if those tools create/update data.\n\nFor a large, bounded, repetitive batch of eligible tool calls, use Programmatic Tool Calling rather than issuing one direct call per item.",
		                          [0,
		                           a,
		                           [0,
		                            "Always return human-readable responses unless explicitly asked to return a technical response (e.g. a tool call response), in which case you should return valid JSON.",
		                            0]]],
		                         function(a){
		                          return caml_exact_trampoline_cps_call(trim, a, cont);
		                         });
		               }
		               function get_ask_user_conversation_cont
		               (automation_id, automation_run_id, questions, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (mapi,
		                         function(i, question, cont){
		                          var a = question[1], b = i + 1 | 0;
		                          return caml_exact_trampoline_cps_call
		                                  (sprintf,
		                                   bce,
		                                   function(c){
		                                    return caml_trampoline_cps_call3(c, b, a, cont);
		                                   });
		                         },
		                         questions,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat,
		                                   cst$15,
		                                   a,
		                                   function(questions_text){
		                                    return caml_exact_trampoline_cps_call
		    (Automation_run[8],
		     automation_run_id,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (to_string$55,
		               automation_id,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (sprintf,
		                         bcf,
		                         function(c){
		                          return caml_trampoline_cps_call4
		                                  (c,
		                                   b,
		                                   a,
		                                   questions_text,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call(trim, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$936 = [];
		               function month_day_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$936[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$936[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$936[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$936[1][1] = b;
		                            var
		                             a =
		                               [0, [0, 0, 0, 0, 0, "kth", 0, 2, [0, int_schema], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$6,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  bch,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_day,
		    cst_Day,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){var day = param[1]; return cont(day);},
		      function(day, cont){return cont([0, day, 0]);},
		      [0,
		       [0, 0, 0, 0, 0, cst_day, 0, 2, [0, int_schema], 0, 0],
		       0]],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){
		      var f1 = param[2], f0 = param[1];
		      return cont([1, f0, f1]);
		     },
		     function(param, cont){
		      if(0 === param[0]) return cont(0);
		      var f1 = param[2], f0 = param[1];
		      return cont([0, [0, f0, f1]]);
		     },
		     1,
		     0,
		     cst_weekday,
		     cst_Weekday,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){
		        var kth = param[2][1], weekday = param[1];
		        return cont([0, weekday, kth]);
		       },
		       function(param, cont){
		        var kth = param[2], weekday = param[1];
		        return cont([0, weekday, [0, kth, 0]]);
		       },
		       [0, [0, 0, 0, 0, 0, cst_weekday, 0, 2, [0, b], 0, 0], a]],
		      0],
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$936[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$936[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$893 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$936, [0, schematic_cache$893]);
		               caml_callback
		                (month_day_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$937 = [];
		               function rule_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$937[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bci, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$937[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$937[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$937[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schema_versioned$3(schematic_version),
		                                     function(b){
		                                      var
		                                       default$ = match$266[1],
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_month, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$267[1],
		         b =
		           [0,
		            [0,
		             function(param, cont){
		              var f2 = param[3], f1 = param[2], f0 = param[1];
		              return cont([4, f0, f1, f2]);
		             },
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f2 = param[3], f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1, f2]]);
		             },
		             1,
		             0,
		             "year_rule",
		             "Year_rule",
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 month = a[2][1],
		                 day = a[1],
		                 period = param[1];
		                return cont([0, period, day, month]);
		               },
		               function(param, cont){
		                var month = param[3], day = param[2], period = param[1];
		                return cont([0, period, [0, day, [0, month, 0]]]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_period, 0, 2, [0, int_schema], 0, 0],
		                [0,
		                 [0, 0, 0, 0, 0, cst_day, 0, [0, default$], [0, c], 0, 0],
		                 a]]],
		              0],
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (month_day_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(c){
		                            var
		                             default$ = match$268[1],
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 "workday_rule",
		                                 "Workday_rule",
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var period = param[1];
		                                    return cont(period);
		                                   },
		                                   function(period, cont){return cont([0, period, 0]);},
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_period, 0, 2, [0, int_schema], 0, 0],
		                                    0]],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([3, f0, f1]);
		                                  },
		                                  function(param, cont){
		                                   if(3 !== param[0]) return cont(0);
		                                   var f1 = param[2], f0 = param[1];
		                                   return cont([0, [0, f0, f1]]);
		                                  },
		                                  1,
		                                  0,
		                                  "month_rule",
		                                  "Month_rule",
		                                  [0,
		                                   0,
		                                   0,
		                                   [7,
		                                    function(param, cont){
		                                     var day = param[2][1], period = param[1];
		                                     return cont([0, period, day]);
		                                    },
		                                    function(param, cont){
		                                     var day = param[2], period = param[1];
		                                     return cont([0, period, [0, day, 0]]);
		                                    },
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_period, 0, 2, [0, int_schema], 0, 0],
		                                     [0,
		                                      [0, 0, 0, 0, 0, cst_day, 0, [0, default$], [0, c], 0, 0],
		                                      0]]],
		                                   0],
		                                  0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$12,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(b){
		        var
		         default$ = match$269[1],
		         res =
		           [11,
		            bcj,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              "day_rule",
		              "Day_rule",
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var period = param[1];
		                 return cont(period);
		                },
		                function(period, cont){return cont([0, period, 0]);},
		                [0,
		                 [0, 0, 0, 0, 0, cst_period, 0, 2, [0, int_schema], 0, 0],
		                 0]],
		               0],
		              0],
		             [0,
		              [0,
		               function(param, cont){
		                var f1 = param[2], f0 = param[1];
		                return cont([1, f0, f1]);
		               },
		               function(param, cont){
		                if(1 !== param[0]) return cont(0);
		                var f1 = param[2], f0 = param[1];
		                return cont([0, [0, f0, f1]]);
		               },
		               1,
		               0,
		               "week_rule",
		               "Week_rule",
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var weekdays = param[2][1], period = param[1];
		                  return cont([0, period, weekdays]);
		                 },
		                 function(param, cont){
		                  var weekdays = param[2], period = param[1];
		                  return cont([0, period, [0, weekdays, 0]]);
		                 },
		                 [0,
		                  [0, 0, 0, 0, 0, cst_period, 0, 2, [0, int_schema], 0, 0],
		                  [0,
		                   [0,
		                    0,
		                    0,
		                    0,
		                    0,
		                    cst_weekdays,
		                    0,
		                    [0, default$],
		                    [0, b],
		                    0,
		                    0],
		                   0]]],
		                0],
		               0],
		              a]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$937[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$937[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$894 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$937, [0, schematic_cache$894]);
		               caml_callback
		                (rule_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function month_day_to_mandate(param, cont){
		                if(0 === param[0]){var day = param[1]; return cont([0, day]);}
		                var kth = param[2], weekday = param[1];
		                return cont([1, weekday, kth]);
		               }
		               function rule_to_mandate(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var period = param[1]; return cont([0, period]);
		                  case 1:
		                   var weekdays = param[2], period$0 = param[1];
		                   return cont([2, period$0, weekdays, 0]);
		                  case 2:
		                   var period$1 = param[1]; return cont([3, period$1]);
		                  case 3:
		                   var day = param[2], period$2 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (map$3,
		                            day,
		                            month_day_to_mandate,
		                            function(a){return cont([1, period$2, a]);});
		                  default:
		                   var month = param[3], day$0 = param[2], period$3 = param[1];
		                   return cont([4, period$3, day$0, month]);
		                }
		               }
		               var letrec_function_context$938 = [];
		               function object_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$938[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bck, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$938[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$938[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$938[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$51[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_row_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (Table[4],
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$120,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        row_id = a[2][1],
		                        table_id = a[1],
		                        workspace_id = param[1];
		                       return cont([0, workspace_id, table_id, row_id]);
		                      },
		                      function(param, cont){
		                       var
		                        row_id = param[3],
		                        table_id = param[2],
		                        workspace_id = param[1];
		                       return cont
		                               ([0, workspace_id, [0, table_id, [0, row_id, 0]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_workspace_id, 0, 3, [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$938[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$938[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$895 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$938, [0, schematic_cache$895]);
		               caml_callback
		                (object_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$939 = [];
		               function generalized_task_id_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$939[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcl, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$939[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$939[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$939[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$109,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_task,
		   cst_Task,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (object_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [11,
		            bcm,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              1,
		              0,
		              cst_object,
		              cst_Object,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){var id = param[1]; return cont(id);},
		                function(id, cont){return cont([0, id, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, b], 0, 0], 0]],
		               0],
		              0],
		             a],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$939[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$939[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$896 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$939, [0, schematic_cache$896]);
		               caml_callback
		                (generalized_task_id_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$940 = [];
		               function table_ref_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$940[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$940[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$940[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$940[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Table[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$120,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var table_id = param[2][1], workspace_id = param[1];
		             return cont([0, workspace_id, table_id]);
		            },
		            function(param, cont){
		             var table_id = param[2], workspace_id = param[1];
		             return cont([0, workspace_id, [0, table_id, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$940[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$940[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$897 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$940, [0, schematic_cache$897]);
		               caml_callback
		                (table_ref_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$941 = [];
		               function workspace_ref_id_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$941[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bco, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$941[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$941[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$941[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_workspace_id, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var workspace_id = param[2][1], org_id = param[1];
		             return cont([0, org_id, workspace_id]);
		            },
		            function(param, cont){
		             var workspace_id = param[2], org_id = param[1];
		             return cont([0, org_id, [0, workspace_id, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$941[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$941[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$898 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$941, [0, schematic_cache$898]);
		               caml_callback
		                (workspace_ref_id_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$942 = [];
		               function agent_ref_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$942[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcp, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$942[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$942[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$942[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$110,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var agent_id = param[2][1], org_id = param[1];
		             return cont([0, org_id, agent_id]);
		            },
		            function(param, cont){
		             var agent_id = param[2], org_id = param[1];
		             return cont([0, org_id, [0, agent_id, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$942[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$942[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$899 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$942, [0, schematic_cache$899]);
		               caml_callback
		                (agent_ref_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$943 = [];
		               function automation_ref_id_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$943[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcq, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$943[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$943[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$943[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var automation_id = param[2][1], org_id = param[1];
		             return cont([0, org_id, automation_id]);
		            },
		            function(param, cont){
		             var automation_id = param[2], org_id = param[1];
		             return cont([0, org_id, [0, automation_id, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$943[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$943[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$900 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$943, [0, schematic_cache$900]);
		               caml_callback
		                (automation_ref_id_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$944 = [];
		               function conversation_ref_id_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$944[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$944[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$944[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$944[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$259,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_conversation_id, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$110,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, 0, 0, 0, 0, cst_agent_id, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$104,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        conversation_id = a[2][1],
		                        agent_id = a[1],
		                        org_id = param[1];
		                       return cont([0, org_id, agent_id, conversation_id]);
		                      },
		                      function(param, cont){
		                       var
		                        conversation_id = param[3],
		                        agent_id = param[2],
		                        org_id = param[1];
		                       return cont
		                               ([0, org_id, [0, agent_id, [0, conversation_id, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$944[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$944[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$901 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$944, [0, schematic_cache$901]);
		               caml_callback
		                (conversation_ref_id_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$945 = [];
		               function automation_run_ref_id_schema_v
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$945[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$945[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$945[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$945[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Automation_run[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_automation_run_id, 0, 2, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$266,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$104,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        automation_run_id = a[2][1],
		                        automation_id = a[1],
		                        org_id = param[1];
		                       return cont([0, org_id, automation_id, automation_run_id]);
		                      },
		                      function(param, cont){
		                       var
		                        automation_run_id = param[3],
		                        automation_id = param[2],
		                        org_id = param[1];
		                       return cont
		                               ([0, org_id, [0, automation_id, [0, automation_run_id, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_org_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$945[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$945[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$902 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$945, [0, schematic_cache$902]);
		               caml_callback
		                (automation_run_ref_id_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$946 = [];
		               function schema_versioned$555(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$946[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bct, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$946[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$946[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$946[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (automation_run_ref_id_schema_v,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([13, f0]);},
		   function(param, cont){
		    if(13 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_automation_run,
		   cst_Automation_run,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (conversation_ref_id_schema_ver,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([12, f0]);},
		             function(param, cont){
		              if(12 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_conversation,
		             cst_Conversation,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){var id = param[1]; return cont(id);},
		               function(id, cont){return cont([0, id, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (automation_ref_id_schema_versi,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([11, f0]);},
		                       function(param, cont){
		                        if(11 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_automation,
		                       cst_Automation,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){var id = param[1]; return cont(id);},
		                         function(id, cont){return cont([0, id, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (agent_ref_id_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([10, f0]);},
		                                 function(param, cont){
		                                  if(10 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_agent,
		                                 cst_Agent,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){var id = param[1]; return cont(id);},
		                                   function(id, cont){return cont([0, id, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (workspace_ref_id_schema_versio,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([9, f0]);},
		   function(param, cont){
		    if(9 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_workspace_ref,
		   cst_Workspace_ref,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (table_ref_id_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([8, f0]);},
		             function(param, cont){
		              if(8 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_table_ref,
		             cst_Table_ref,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){var id = param[1]; return cont(id);},
		               function(id, cont){return cont([0, id, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$104,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([7, f0]);},
		                       function(param, cont){
		                        if(7 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_organization,
		                       cst_Organization,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){var id = param[1]; return cont(id);},
		                         function(id, cont){return cont([0, id, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (object_id_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([6, f0]);},
		                                 function(param, cont){
		                                  if(6 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_object,
		                                 cst_Object,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){var id = param[1]; return cont(id);},
		                                   function(id, cont){return cont([0, id, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$187,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_task_recurrent,
		   cst_Task_recurrent,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (generalized_task_id_schema_ver,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_task,
		             cst_Task,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){var id = param[1]; return cont(id);},
		               function(id, cont){return cont([0, id, 0]);},
		               [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [1, c], 0, 0], 0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$339,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_people,
		                       cst_People,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){var id = param[1]; return cont(id);},
		                         function(id, cont){return cont([0, id, 0]);},
		                         [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$103,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_page,
		                                 cst_Page,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){var id = param[1]; return cont(id);},
		                                   function(id, cont){return cont([0, id, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$232,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  bcu,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_event,
		    cst_Event,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){var id = param[1]; return cont(id);},
		      function(id, cont){return cont([0, id, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0], 0]],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([1, f0]);},
		     function(param, cont){
		      if(1 !== param[0]) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     1,
		     0,
		     cst_event_recurrent,
		     cst_Event_recurrent,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){var id = param[1]; return cont(id);},
		       function(id, cont){return cont([0, id, 0]);},
		       [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]],
		      0],
		     0],
		    b]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$946[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$946[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$903 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$946, [0, schematic_cache$903]);
		               caml_callback
		                (schema_versioned$555,
		                 [function(param, cont){return cont(0);}]);
		               function object_id(param){
		                var
		                 row_id = param[3],
		                 table_id = param[2],
		                 workspace_id = param[1];
		                return [0, workspace_id, table_id, row_id];
		               }
		               function capped_list_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    function descriptor(schematic_param_a_schema_versi){
		                                     return [7,
		     function(param, cont){
		      var
		       a = param[2],
		       truncated = a[2][1],
		       total = a[1],
		       items = param[1];
		      return cont([0, items, total, truncated]);
		     },
		     function(param, cont){
		      var
		       truncated = param[3],
		       total = param[2],
		       items = param[1];
		      return cont([0, items, [0, total, [0, truncated, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_items,
		       0,
		       2,
		       [0, [0, 0, 0, [3, schematic_param_a_schema_versi], 0]],
		       0,
		       0],
		      [0,
		       [0, bcw, 0, 0, 0, cst_total, 0, 2, [0, int_schema], 0, 0],
		       [0,
		        [0, bcv, 0, 0, 0, "truncated", 0, 2, [0, bool_schema], 0, 0],
		        0]]]];
		                                    }
		                                    var
		                                     schematic_schema_id = match$270[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_a$0,
		 schematic_param_a_schema_versi,
		 function(schematic_param_a_schema_versi, cont){
		  return cont
		          ([0,
		            schematic_schema_id,
		            descriptor(schematic_param_a_schema_versi)]);
		 }]],
		                                     a = descriptor(schematic_param_a_schema_versi),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, bcx, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               function cap(limit, items, cont){
		                return caml_exact_trampoline_cps_call
		                        (length$1,
		                         items,
		                         function(total){
		                          return caml_exact_trampoline_cps_call$1
		                                  (take$0,
		                                   items,
		                                   limit,
		                                   function(items){
		                                    return caml_exact_trampoline_cps_call
		    (length$1,
		     items,
		     function(a){
		      return cont([0, items, total, a < total ? 1 : 0]);
		     });
		                                   });
		                         });
		               }
		               function update_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return cont
		                                  (function(schematic_param_a_schema_versi, cont){
		                                    function descriptor(schematic_param_a_schema_versi){
		                                     return [7,
		     function(param, cont){
		      var update = param[1];
		      return cont([0, update]);
		     },
		     function(param, cont){
		      var update = param[1];
		      return cont([0, update, 0]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_update,
		       0,
		       2,
		       [0, schematic_param_a_schema_versi],
		       0,
		       0],
		      0]];
		                                    }
		                                    var
		                                     schematic_schema_id = match$271[1],
		                                     schematic_parametric =
		                                       [0,
		[1,
		 cst_a$0,
		 schematic_param_a_schema_versi,
		 function(schematic_param_a_schema_versi, cont){
		  return cont
		          ([0,
		            schematic_schema_id,
		            descriptor(schematic_param_a_schema_versi)]);
		 }]],
		                                     a = descriptor(schematic_param_a_schema_versi),
		                                     parametric = schematic_parametric[1];
		                                    return caml_exact_trampoline_cps_call
		    (of_parametric,
		     parametric,
		     function(match){
		      function b(b){
		       return cont([0, b, bcy, a, schematic_parametric]);
		      }
		      if(! match) return b(0);
		      var name = match[1];
		      return caml_exact_trampoline_cps_call
		              (to_id, name, function(a){return b([0, a]);});
		     });
		                                   });
		                         });
		               }
		               function set_field(param){
		                if(! param) return 0;
		                var update = param[1][1];
		                return [0, update];
		               }
		               function map_schema(f){
		                function traverse(s, cont){
		                 var a = s[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          a[17],
		                          traverse,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$7,
		                                    a[16],
		                                    traverse,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$1
		     (map$7,
		      a[15],
		      traverse,
		      function(d){
		       return caml_exact_trampoline_cps_call$1
		               (map$3,
		                a[14],
		                traverse,
		                function(e){
		                 return caml_exact_trampoline_cps_call$1
		                         (map$3,
		                          a[13],
		                          traverse,
		                          function(g){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$3,
		                                    a[12],
		                                    traverse,
		                                    function(h){
		                                     return caml_exact_trampoline_cps_call$1
		     (map$3,
		      a[11],
		      traverse,
		      function(i){
		       return caml_exact_trampoline_cps_call$1
		               (map$3,
		                a[10],
		                traverse,
		                function(j){
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          a[9],
		                          function(param, cont){
		                           var v = param[2], k = param[1];
		                           return caml_exact_trampoline_cps_call
		                                   (traverse, v, function(a){return cont([0, k, a]);});
		                          },
		                          function(k){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$7,
		                                    a[8],
		                                    function(param, cont){
		                                     var v = param[2], k = param[1];
		                                     return caml_exact_trampoline_cps_call
		     (traverse, v, function(a){return cont([0, k, a]);});
		                                    },
		                                    function(l){
		                                     return caml_exact_trampoline_cps_call$1
		     (map$7,
		      a[7],
		      function(param, cont){
		       var v = param[2], k = param[1];
		       return caml_exact_trampoline_cps_call
		               (traverse, v, function(a){return cont([0, k, a]);});
		      },
		      function(m){
		       return caml_exact_trampoline_cps_call$1
		               (map$3,
		                a[6],
		                traverse,
		                function(o){
		                 var other = a[5];
		                 function n(n){
		                  return caml_exact_trampoline_cps_call$1
		                          (map$3,
		                           a[4],
		                           traverse,
		                           function(p){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$3,
		                                     a[3],
		                                     traverse,
		                                     function(q){
		                                      return caml_exact_trampoline_cps_call$1
		      (map$7,
		       a[2],
		       traverse,
		       function(r){
		        return caml_exact_trampoline_cps_call$1
		                (map$3,
		                 a[1],
		                 traverse,
		                 function(a){
		                  var
		                   applicator =
		                     [0, a, r, q, p, n, o, m, l, k, j, i, h, g, e, d, c, b],
		                   init = s[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$7,
		                           s[2][9],
		                           function(param, cont){
		                            var v = param[2], k = param[1];
		                            return caml_exact_trampoline_cps_call
		                                    (traverse, v, function(a){return cont([0, k, a]);});
		                           },
		                           function(a){
		                            var
		                             core =
		                               [0,
		                                init[1],
		                                init[2],
		                                init[3],
		                                init[4],
		                                init[5],
		                                init[6],
		                                init[7],
		                                init[8],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (f, [0, applicator, core, s[3], s[4]], cont);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 }
		                 if(0 !== other[0]) return n(other);
		                 var s$0 = other[1];
		                 return caml_exact_trampoline_cps_call
		                         (traverse, s$0, function(a){return n([0, a]);});
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return traverse;
		               }
		               var
		                strip_schema_metadata =
		                  map_schema
		                   (function(s, cont){
		                     var a = s[2];
		                     return cont
		                             ([0,
		                               s[1],
		                               [0, 0, 0, a[3], a[4], a[5], a[6], a[7], a[8], a[9]],
		                               s[3],
		                               s[4]]);
		                    }),
		                replace_const_with_enum =
		                  map_schema
		                   (function(s, cont){
		                     var a = s[4][18];
		                     if(! a) return cont(s);
		                     var v = a[1], a = s[4];
		                     return cont
		                             ([0,
		                               s[1],
		                               s[2],
		                               s[3],
		                               [0,
		                                a[1],
		                                a[2],
		                                a[3],
		                                a[4],
		                                a[5],
		                                a[6],
		                                a[7],
		                                a[8],
		                                a[9],
		                                a[10],
		                                a[11],
		                                a[12],
		                                a[13],
		                                a[14],
		                                a[15],
		                                a[16],
		                                a[17],
		                                0,
		                                [0, v, 0],
		                                a[20]]]);
		                    }),
		                strip_title =
		                  map_schema
		                   (function(s, cont){
		                     var a = s[3];
		                     return cont
		                             ([0,
		                               s[1],
		                               s[2],
		                               [0, 0, a[2], a[3], a[4], a[5], a[6], a[7]],
		                               s[4]]);
		                    }),
		                strip_ref_siblings =
		                  map_schema
		                   (function(s, cont){
		                     var match = s[2][4];
		                     if(! match) return cont(s);
		                     var ref = match[1];
		                     return cont
		                             (make$6
		                               (0, [0, make_core(0, 0, 0, [0, ref], 0, 0, 0, 0)], 0, 0));
		                    }),
		                ensure_object_type =
		                  map_schema
		                   (function(s, cont){
		                     var a = s[4][20];
		                     if(s[1][7] && ! a){
		                      a = s[4];
		                      return cont
		                              ([0,
		                                s[1],
		                                s[2],
		                                s[3],
		                                [0,
		                                 a[1],
		                                 a[2],
		                                 a[3],
		                                 a[4],
		                                 a[5],
		                                 a[6],
		                                 a[7],
		                                 a[8],
		                                 a[9],
		                                 a[10],
		                                 a[11],
		                                 a[12],
		                                 a[13],
		                                 a[14],
		                                 a[15],
		                                 a[16],
		                                 a[17],
		                                 a[18],
		                                 a[19],
		                                 bcz]]);
		                     }
		                     return cont(s);
		                    }),
		                make_all_properties_required =
		                  map_schema
		                   (function(s, cont){
		                     var properties = s[1][7];
		                     return properties
		                             ? caml_exact_trampoline_cps_call$1
		                               (map$7,
		                                properties,
		                                calendar,
		                                function(required){
		                                 var a = s[4];
		                                 return cont
		 ([0,
		   s[1],
		   s[2],
		   s[3],
		   [0,
		    a[1],
		    a[2],
		    a[3],
		    a[4],
		    a[5],
		    a[6],
		    a[7],
		    a[8],
		    a[9],
		    a[10],
		    a[11],
		    a[12],
		    a[13],
		    a[14],
		    a[15],
		    required,
		    a[17],
		    a[18],
		    a[19],
		    a[20]]]);
		                                })
		                             : cont(s);
		                    });
		               function of_object_exn(here, schema, cont){
		                var a = schema[3];
		                a:
		                {
		                 if(typeof a !== "number" && 7 === a[0]){a = [0, schema]; break a;}
		                 a = 0;
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (value_exn, here, 0, 0, a, cont);
		               }
		               function object_schema(here, opt, schema, cont){
		                var strict = opt ? opt[1] : 1;
		                return caml_exact_trampoline_cps_call$1
		                        (of_object_exn,
		                         here,
		                         schema,
		                         function(a){return cont([0, a, strict]);});
		               }
		               function ensure_properties_present(other, cont){
		                if(typeof other !== "number"){
		                 var variant = other[1];
		                 if(65 === variant){
		                  var items = other[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$7,
		                           items,
		                           ensure_properties_present,
		                           function(a){return cont([0, 65, a]);});
		                 }
		                 if(79 === variant){
		                  var fields = other[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$7,
		                           fields,
		                           function(param, cont){
		                            var v = param[2], k = param[1];
		                            return caml_exact_trampoline_cps_call
		                                    (ensure_properties_present,
		                                     v,
		                                     function(a){return cont([0, k, a]);});
		                           },
		                           function(fields){
		                            function a(t$2){
		                             if(t$2){
		                              var xs$2 = t$2[2], x$2 = t$2[1];
		                              a:
		                              {
		                               if(x$2[1] === cst_type){
		                                var b = x$2[2];
		                                if(typeof b !== "number"){
		                                 var variant = b[1];
		                                 if(-976970511 === variant && b[2] === cst_object){b = 1; break a;}
		                                }
		                               }
		                               b = 0;
		                              }
		                              if(! b) return caml_exact_trampoline_call1(a, xs$2);
		                              var is_object = 1;
		                             }
		                             else
		                              is_object = 0;
		                             a:
		                             {
		                              b:
		                              {
		                               var t$1 = fields;
		                               for(;;){
		                                if(! t$1) break b;
		                                var xs$1 = t$1[2], x$1 = t$1[1], k$1 = x$1[1];
		                                if(k$1 === cst_properties) break;
		                                t$1 = xs$1;
		                               }
		                               var has_properties = 1;
		                               break a;
		                              }
		                              has_properties = 0;
		                             }
		                             a:
		                             {
		                              b:
		                              {
		                               var t$0 = fields;
		                               for(;;){
		                                if(! t$0) break b;
		                                var xs$0 = t$0[2], x$0 = t$0[1], k$0 = x$0[1];
		                                if(k$0 === cst_anyOf) break;
		                                t$0 = xs$0;
		                               }
		                               var has_any_of = 1;
		                               break a;
		                              }
		                              has_any_of = 0;
		                             }
		                             a:
		                             {
		                              b:
		                              {
		                               var t = fields;
		                               for(;;){
		                                if(! t) break b;
		                                var xs = t[2], x = t[1], k = x[1];
		                                if(k === cst_additionalProperties) break;
		                                t = xs;
		                               }
		                               var has_additional_properties = 1;
		                               break a;
		                              }
		                              has_additional_properties = 0;
		                             }
		                             function c(fields){return cont([0, 79, fields]);}
		                             if(! is_object) return c(fields);
		                             if(has_properties) return c(fields);
		                             if(has_any_of) return c(fields);
		                             b = has_additional_properties ? 0 : bcB;
		                             return caml_exact_trampoline_cps_call$1
		                                     (append$0,
		                                      bcA,
		                                      b,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (append$0, fields, a, c);
		                                      });
		                            }
		                            return a(fields);
		                           });
		                 }
		                }
		                return cont(other);
		               }
		               function sanitize_schema(schema, cont){
		                return caml_exact_trampoline_cps_call
		                        (strip_schema_metadata,
		                         schema,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (strip_title,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (strip_ref_siblings,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (replace_const_with_enum,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (ensure_object_type,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (encode$4,
		                                   schema$3,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (b,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (ensure_properties_present, a, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function schema_to_openai_json(schema, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (of_schema$0,
		                         bcC,
		                         schema,
		                         function(schema){
		                          return caml_exact_trampoline_cps_call
		                                  (make_all_properties_required,
		                                   schema,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (sanitize_schema, a, cont);
		                                   });
		                         });
		               }
		               function tool_input_to_json(param, cont){
		                if(typeof param === "number") return cont(bcD);
		                if(0 === param[0]){
		                 var schema = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (schema_to_openai_json, schema, cont);
		                }
		                var raw = param[1];
		                return caml_trampoline_cps_call3
		                        (decode$2,
		                         schema$3,
		                         raw,
		                         function(match){
		                          if(0 !== match[0]) return cont(raw);
		                          var schema = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (strip_schema_metadata,
		                                   schema,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (strip_title,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (strip_ref_siblings,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (replace_const_with_enum,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (encode$4,
		                                   schema$3,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call(b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function strip_null_defaults(other, cont){
		                if(typeof other !== "number"){
		                 var variant = other[1];
		                 if(65 === variant){
		                  var items = other[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$7,
		                           items,
		                           strip_null_defaults,
		                           function(a){return cont([0, 65, a]);});
		                 }
		                 if(79 === variant){
		                  var fields = other[2];
		                  return caml_exact_trampoline_cps_call$1
		                          (filter_map$0,
		                           fields,
		                           function(param, cont){
		                            var value = param[2], key = param[1];
		                            if(key !== cst_default)
		                             return caml_exact_trampoline_cps_call
		                                     (strip_null_defaults,
		                                      value,
		                                      function(a){return cont([0, [0, key, a]]);});
		                            if(typeof value === "number" && 870828711 === value)
		                             return cont(0);
		                            return cont([0, [0, key, value]]);
		                           },
		                           function(a){return cont([0, 79, a]);});
		                 }
		                }
		                return cont(other);
		               }
		               function read$2(world){return [0, 0, world];}
		               function write$0(destructive, idempotent, world, param){return [0, [0, [0, destructive, idempotent]], world];
		               }
		               function tool
		               (name,
		                a,
		                opt,
		                description,
		                behavior,
		                input,
		                output,
		                handler,
		                cont){
		                var
		                 defer_loading = a ? a[1] : 1,
		                 programmatic = opt ? opt[1] : 0;
		                function b(i, cont){
		                 function a(o, cont){return cont([0, 192584839, o]);}
		                 return caml_exact_trampoline_cps_call
		                         (handler,
		                          i,
		                          function(b){
		                           return caml_trampoline_cps_call3(map$25, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (trim,
		                         description,
		                         function(a){
		                          return cont
		                                  ([0,
		                                    [0,
		                                     name,
		                                     defer_loading,
		                                     programmatic,
		                                     a,
		                                     behavior,
		                                     b,
		                                     input,
		                                     output]]);
		                         });
		               }
		               function namespace(name, description, tools, cont){
		                return caml_exact_trampoline_cps_call
		                        (trim,
		                         description,
		                         function(a){return cont([1, name, a, tools]);});
		               }
		               function openai_tools(opt, registry, cont){
		                var
		                 additionally_preloaded_tools =
		                   opt ? opt[1] : empty$8([0, comparator$2]);
		                function supports_programmatic_calling(a){
		                 for(;;){
		                  if(! a) return 0;
		                  var match = a[1];
		                  if(0 === match[0]){
		                   var rest = a[2], programmatic = match[1][3];
		                   if(programmatic) return programmatic;
		                   a = rest;
		                  }
		                  else {
		                   var
		                    rest$0 = a[2],
		                    tools = match[3],
		                    a = supports_programmatic_calling(tools);
		                   if(a) return a;
		                   a = rest$0;
		                  }
		                 }
		                }
		                function concat(parent, tools, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (concat_map,
		                          tools,
		                          function(a, cont){
		                           if(0 === a[0]){
		                            a = a[1];
		                            var
		                             output_schema = a[8],
		                             input_schema = a[7],
		                             description = a[4],
		                             programmatic = a[3],
		                             defer_loading = a[2],
		                             name = a[1];
		                            return caml_exact_trampoline_cps_call
		                                    (tool_input_to_json,
		                                     input_schema,
		                                     function(parameters){
		                                      var a = programmatic ? bcH : 0;
		                                      return caml_exact_trampoline_cps_call$1
		      (mem$3,
		       additionally_preloaded_tools,
		       name,
		       function(e){
		        var d = e ? bcI : defer_loading ? bcJ : 0;
		        if(typeof input_schema === "number")
		         var b = bcF;
		        else if(0 === input_schema[0])
		         var strict = input_schema[2], b = [0, strict];
		        else
		         b = bcG;
		        function c(c){
		         var
		          x = [0, name, [0, description], [0, parameters], c, b, d, a];
		         return cont([0, [0, x], 0]);
		        }
		        return programmatic
		                ? caml_exact_trampoline_cps_call
		                  (schema_to_openai_json,
		                   output_schema,
		                   function(a){return c([0, a]);})
		                : c(0);
		       });
		                                     });
		                           }
		                           var children = a[3], description$0 = a[2], name$0 = a[1];
		                           if(parent){
		                            a = parent[1];
		                            var
		                             parent_description = a[2],
		                             parent_name = a[1],
		                             s2$0 = cst$22 + description$0,
		                             description$2 = parent_description + s2$0,
		                             s2 = cst$13 + name$0,
		                             description$1 = description$2,
		                             name$1 = parent_name + s2;
		                           }
		                           else {description$1 = description$0; name$1 = name$0;}
		                           return caml_exact_trampoline_cps_call$1
		                                   (concat,
		                                    [0, [0, name$1, description$1]],
		                                    children,
		                                    function(match){
		                                     var completed_tools = match[2], leaves = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (map$7,
		      completed_tools,
		      return$2,
		      function(completed_tools){
		       return leaves
		               ? caml_exact_trampoline_cps_call$1
		                 (map$7,
		                  leaves,
		                  function(function_tool, cont){
		                   return cont([0, function_tool]);
		                  },
		                  function(a){
		                   var namespace = [1, [0, name$1, description$1, a]];
		                   return cont([0, [1, namespace], completed_tools]);
		                  })
		               : cont(completed_tools);
		      });
		                                    });
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (partition_map, a, function(a, cont){return cont(a);}, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (concat,
		                         0,
		                         registry,
		                         function(match){
		                          var completed_tools = match[2], toplevel_tools = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   toplevel_tools,
		                                   function(function_tool, cont){
		                                    return cont([0, function_tool]);
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (append$0,
		     a,
		     completed_tools,
		     function(b){
		      var a = supports_programmatic_calling(registry) ? bcK : 0;
		      return caml_exact_trampoline_cps_call$1
		              (append$0, [0, bcM, [0, bcL, a]], b, cont);
		     });
		                                   });
		                         });
		               }
		               function handle_function_call(registry, call_id, call, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3];
		                function concat(tools, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (concat_map,
		                          tools,
		                          function(param, cont){
		                           if(0 === param[0]){
		                            var fn = param[1];
		                            return cont([0, fn, 0]);
		                           }
		                           var tools = param[3];
		                           return caml_exact_trampoline_cps_call(concat, tools, cont);
		                          },
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (concat,
		                         registry,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (of_list_with_key_reduce$1,
		                                   [0, comparator$2],
		                                   a,
		                                   function(param, cont){
		                                    var name = param[1];
		                                    return cont(name);
		                                   },
		                                   function(param, v, cont){return cont(v);},
		                                   function(dispatch_map){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     dispatch_map,
		     call[1],
		     function(a){
		      if(! a){
		       var d = call[1];
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$200,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a,
		                          d,
		                          function(a){
		                           return caml_trampoline_cps_call2(return$12, [1, a], cont);
		                          });
		                });
		      }
		      a = a[1];
		      var
		       output_schema = a[8],
		       input_schema = a[7],
		       handler = a[6];
		      function run(input, cont){
		       function a(result, cont){
		        if(0 !== result[0]){
		         var err = result[1];
		         return caml_trampoline_cps_call2(return$12, [1, err], cont);
		        }
		        var match = result[1], variant = match[1];
		        if(192584839 <= variant){
		         var output = match[2];
		         return caml_trampoline_cps_call3
		                 (encode$4,
		                  output_schema,
		                  output,
		                  function(json_result){
		                   return caml_exact_trampoline_cps_call
		                           (to_string$16,
		                            json_result,
		                            function(json_str){
		                             return caml_trampoline_cps_call2
		                                     (return$12, [0, [0, json_str]], cont);
		                            });
		                  });
		        }
		        var questions = match[2];
		        return caml_trampoline_cps_call2
		                (return$12, [0, [1, questions, call_id]], cont);
		       }
		       return caml_trampoline_cps_call2
		               (handler,
		                input,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      }
		      caml_push_trap
		       (function(e){
		         return caml_exact_trampoline_cps_call
		                 (to_string$1,
		                  e,
		                  function(b){
		                   var a = call[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$199,
		                            function(c){
		                             return caml_trampoline_cps_call3
		                                     (c,
		                                      a,
		                                      b,
		                                      function(error_msg){
		                                       return caml_trampoline_cps_call2
		       (return$12, [1, error_msg], cont);
		                                      });
		                            });
		                  });
		        });
		      function b(a){caml_pop_trap(); return cont(a);}
		      if(typeof input_schema === "number")
		       return caml_exact_trampoline_cps_call(run, 0, b);
		      if(0 !== input_schema[0])
		       return caml_exact_trampoline_cps_call(run, call[2], b);
		      var schema = input_schema[1], c = call[2];
		      return caml_exact_trampoline_cps_call
		              (decode$2,
		               schema,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (a,
		                         c,
		                         function(t){
		                          function a(match){
		                           if(0 === match[0]){
		                            var input = match[1];
		                            return caml_exact_trampoline_cps_call(run, input, b);
		                           }
		                           var e = match[1];
		                           return caml_trampoline_cps_call2(return$12, [1, e], b);
		                          }
		                          if(0 === t[0]) return a(t);
		                          var x = t[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_to_string,
		                                   pp_decoding,
		                                   x,
		                                   function(b){return a([1, b]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function execute_calls(registry, response, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         response[2],
		                         function(param, cont){
		                          if(0 !== param[0]) return cont(0);
		                          var
		                           caller = param[4],
		                           arguments$ = param[3],
		                           name = param[2],
		                           call_id = param[1];
		                          return cont
		                                  ([0, [0, call_id, [0, name, arguments$, caller]]]);
		                         },
		                         function(calls){
		                          if(calls){
		                           a:
		                           {
		                            if(calls && ! calls[2]){var is_single_call = 1; break a;}
		                            is_single_call = 0;
		                           }
		                           var
		                            b =
		                              function(result, cont){
		                               if(0 === result[0]){
		                                var a = result[1], executed = a[2], outputs = a[1];
		                                return caml_exact_trampoline_cps_call
		(of_rev_keys,
		 executed,
		 function(a){
		  return caml_exact_trampoline_cps_call
		          (of_rev_keys, outputs, function(b){return cont([0, b, a]);});
		 });
		                               }
		                               a = result[1][2];
		                               var call_id = a[2], questions = a[1];
		                               return cont([1, questions, call_id]);
		                              };
		                           return caml_exact_trampoline_cps_call$0
		                                   (fold_left_s,
		                                    function(acc, a, cont){
		                                     var call = a[2], call_id = a[1];
		                                     if(0 === acc[0]){
		                                      a = acc[1];
		                                      var
		                                       executed_acc = a[2],
		                                       outputs_acc = a[1],
		                                       continue_with =
		 function(output_str){
		  var
		   api_output =
		     [1, cst_function_call_output, call_id, output_str, call[3]],
		   executed = [0, call[1], call[2], output_str];
		  return [0,
		          [0,
		           [0, api_output, outputs_acc],
		           [0, executed, executed_acc]]];
		 },
		                                       b =
		 function(handle_result, cont){
		  if(0 !== handle_result[0]){
		   var e = handle_result[1];
		   return caml_exact_trampoline_cps_call$1
		           (kasprintf,
		            id,
		            fmt$201,
		            function(a){
		             return caml_trampoline_cps_call2
		                     (a, e, function(a){return cont(continue_with(a));});
		            });
		  }
		  var match = handle_result[1];
		  if(0 === match[0]){
		   var output_str = match[1];
		   return cont(continue_with(output_str));
		  }
		  var questions = match[1];
		  return is_single_call
		          ? cont([1, [0, 605598926, [0, questions, call_id]]])
		          : cont
		            (continue_with
		              ("Error: ask_user must be the only tool call in a response; it was not executed. Call it alone to request user input."));
		 };
		                                      return caml_exact_trampoline_cps_call$0
		      (handle_function_call,
		       registry,
		       call_id,
		       call,
		       function(a){
		        return caml_trampoline_cps_call3(let$, a, b, cont);
		       });
		                                     }
		                                     var e = acc[1];
		                                     return caml_trampoline_cps_call2(return$12, [1, e], cont);
		                                    },
		                                    bcN,
		                                    calls,
		                                    function(a){
		                                     return caml_trampoline_cps_call3(let$, a, b, cont);
		                                    });
		                          }
		                          var t = response[2], t$0 = t;
		                          for(;;){
		                           if(t$0){
		                            var xs = t$0[2], x = t$0[1], a = 1 === x[0] ? 1 : 0;
		                            if(! a){t$0 = xs; continue;}
		                            a = 1;
		                           }
		                           else
		                            a = 0;
		                           var result = a ? 0 : 1;
		                           return caml_trampoline_cps_call2(return$12, result, cont);
		                          }
		                         });
		               }
		               function very_lenient_task_id_schema_ve(v, cont){
		                function decode(s, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (bind,
		                          s,
		                          function(s, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (of_string$29, s, function(a){return cont(ok$0(a));});
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		                          });
		                }
		                function encode(task_id, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (map$3, task_id, to_string$36, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schematic_param_name_schema_ve,
		                         function(a){
		                          var
		                           optional_string_schema = map$14(decode, encode, a),
		                           descriptor = optional_string_schema[3];
		                          return cont([0, id$30, documentation, descriptor, 0]);
		                         });
		               }
		               var letrec_function_context$947 = [];
		               function schema_versioned$556(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$947[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcP, bcO, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$947[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$947[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$947[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (very_lenient_task_id_schema_ve,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    task = a[2][1],
		    content = a[1],
		    checked = param[1];
		   return cont([0, checked, content, task]);
		  },
		  function(param, cont){
		   var task = param[3], content = param[2], checked = param[1];
		   return cont([0, checked, [0, content, [0, task, 0]]]);
		  },
		  [0,
		   [0, bcS, 0, 0, 0, cst_checked, 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0,
		     bcR,
		     0,
		     0,
		     0,
		     cst_content,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0, [0, bcQ, 0, 0, 0, cst_task, 0, 2, [0, a], 0, 0], 0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$947[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$947[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$904 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$947, [0, schematic_cache$904]);
		               caml_callback
		                (schema_versioned$556,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$948 = [];
		               function filter_op_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$948[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bcT, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$948[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$948[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$948[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(bdd);},
		                                  0,
		                                  0,
		                                  cst_eq,
		                                  cst_Eq,
		                                  bdc,
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(bdb) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_neq,
		                                   cst_Neq,
		                                   bda,
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 === param ? cont(bc$) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_lt,
		                                    cst_Lt,
		                                    bc_,
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      return 3 === param ? cont(bc9) : cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_lte,
		                                     cst_Lte,
		                                     bc8,
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(4);},
		                                      function(param, cont){
		                                       return 4 === param ? cont(bc7) : cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_gt,
		                                      cst_Gt,
		                                      bc6,
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(5);},
		                                       function(param, cont){
		return 5 === param ? cont(bc5) : cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_gte,
		                                       cst_Gte,
		                                       bc4,
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(6);},
		function(param, cont){
		 return 6 === param ? cont(bc3) : cont(0);
		},
		0,
		0,
		cst_contains,
		cst_Contains,
		bc2,
		0],
		                                       [0,
		[0,
		 function(param, cont){return cont(7);},
		 function(param, cont){
		  return 7 === param ? cont(bc1) : cont(0);
		 },
		 0,
		 0,
		 cst_inside,
		 cst_Inside,
		 bc0,
		 0],
		[0,
		 [0,
		  function(param, cont){return cont(8);},
		  function(param, cont){
		   return 8 === param ? cont(bcZ) : cont(0);
		  },
		  0,
		  0,
		  cst_not_inside,
		  cst_Not_inside,
		  bcY,
		  0],
		 [0,
		  [0,
		   function(param, cont){return cont(9);},
		   function(param, cont){
		    return 9 === param ? cont(bcX) : cont(0);
		   },
		   0,
		   0,
		   cst_is_empty,
		   "Is_empty",
		   bcW,
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(10);},
		    function(param, cont){
		     return 10 <= param ? cont(bcV) : cont(0);
		    },
		    0,
		    0,
		    cst_is_not_empty,
		    "Is_not_empty",
		    bcU,
		    0],
		   0]]]]]]]]]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$948[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$948[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$905 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$948, [0, schematic_cache$905]);
		               caml_callback
		                (filter_op_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$949 = [];
		               function filter_condition_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$949[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bde, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$949[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$949[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$949[1][1] = b;
		                            var
		                             default$ = match$272[1],
		                             a =
		                               [0,
		                                [0,
		                                 bdf,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_values,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (filter_op_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    values = a[2][1],
		    op = a[1],
		    field = param[1];
		   return cont([0, field, op, values]);
		  },
		  function(param, cont){
		   var values = param[3], op = param[2], field = param[1];
		   return cont([0, field, [0, op, [0, values, 0]]]);
		  },
		  [0,
		   [0,
		    bdg,
		    0,
		    0,
		    0,
		    cst_field,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_op, 0, 2, [0, b], 0, 0], a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$949[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$949[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$906 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$949, [0, schematic_cache$906]);
		               caml_callback
		                (filter_condition_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$950 = [];
		               function filter_match_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$950[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bdh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$950[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$950[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$950[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(bdl);},
		                                  0,
		                                  0,
		                                  cst_all,
		                                  cst_All,
		                                  [0, a$[1], bdk, a$[3], a$[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){return param ? cont(bdj) : cont(0);},
		                                   0,
		                                   0,
		                                   cst_any,
		                                   cst_Any,
		                                   [0, a_[1], bdi, a_[3], a_[4]],
		                                   0],
		                                  0]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$950[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$950[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$907 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$950, [0, schematic_cache$907]);
		               caml_callback
		                (filter_match_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$951 = [];
		               function filter_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$951[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bdm, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$951[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$951[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$951[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (filter_condition_schema_versio,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "conditions",
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (filter_match_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var conditions = param[2][1], match = param[1];
		             return cont([0, match, conditions]);
		            },
		            function(param, cont){
		             var conditions = param[2], match = param[1];
		             return cont([0, match, [0, conditions, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, "match", 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$951[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$951[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$908 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$951, [0, schematic_cache$908]);
		               caml_callback
		                (filter_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$952 = [];
		               function schema_versioned$557(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$952[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bdn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$952[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$952[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$952[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$273[1],
		                                       a =
		 [0,
		  [0, bdo, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (filter_schema_versioned$1,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$274[1],
		                   default$0 = match$275[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        limit = b[2][1],
		                        filter = b[1],
		                        columns = a[1],
		                        table = param[1];
		                       return cont([0, table, columns, filter, limit]);
		                      },
		                      function(param, cont){
		                       var
		                        limit = param[4],
		                        filter = param[3],
		                        columns = param[2],
		                        table = param[1];
		                       return cont
		                               ([0, table, [0, columns, [0, filter, [0, limit, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        bdq,
		                        0,
		                        0,
		                        0,
		                        cst_table,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bdp,
		                         0,
		                         0,
		                         0,
		                         "columns",
		                         0,
		                         [0, default$0],
		                         [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                         0,
		                         0],
		                        [0,
		                         [0, 0, 0, 0, 0, cst_filter, 0, [0, default$], [0, b], 0, 0],
		                         a]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$952[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$952[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$909 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$952, [0, schematic_cache$909]);
		               caml_callback
		                (schema_versioned$557,
		                 [function(param, cont){return cont(0);}]);
		               function fields(db, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (to_alist$1,
		                         0,
		                         db[6][1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   a,
		                                   function(param, cont){
		                                    var field = param[2];
		                                    return cont([0, field[1][3], field[1][5]]);
		                                   },
		                                   cont);
		                         });
		               }
		               function validate_fields(db, field_names, cont){
		                return caml_exact_trampoline_cps_call
		                        (fields,
		                         db,
		                         function(fields){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter,
		                                   field_names,
		                                   function(name, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (mem$0,
		     fields,
		     equal$4,
		     name,
		     function(a){return cont(1 - a);});
		                                   },
		                                   function(unknown){
		                                    return unknown
		    ? caml_exact_trampoline_cps_call$1
		      (concat$0,
		       bdr,
		       unknown,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (kasprintf,
		                 id,
		                 fmt$202,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (b, a, function(a){return cont([1, a]);});
		                 });
		       })
		    : cont(bds);
		                                   });
		                         });
		               }
		               function to_view_filter(db, filter, cont){
		                var open = g(include$0), let$ = open[14];
		                return caml_exact_trampoline_cps_call
		                        (fields,
		                         db,
		                         function(fields){
		                          function op_name(param){
		                           switch(param){
		                             case 0:
		                              return cst_eq;
		                             case 1:
		                              return cst_neq;
		                             case 2:
		                              return cst_lt;
		                             case 3:
		                              return cst_lte;
		                             case 4:
		                              return cst_gt;
		                             case 5:
		                              return cst_gte;
		                             case 6:
		                              return cst_contains;
		                             case 7:
		                              return cst_inside;
		                             case 8:
		                              return cst_not_inside;
		                             case 9:
		                              return cst_is_empty;
		                             default: return cst_is_not_empty;
		                           }
		                          }
		                          function condition_to_atom(cond, cont){
		                           var a = cond[2];
		                           if(7 <= a){
		                            if(9 > a){
		                             var op = 8 === cond[2] ? 76551432 : -764103652;
		                             return cont([0, [0, cond[1], [3, [0, cond[3], op]]]]);
		                            }
		                            if(cond[3])
		                             return caml_exact_trampoline_cps_call
		                                     (length$1,
		                                      cond[3],
		                                      function(b){
		                                       var a = op_name(cond[2]);
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$206,
		        function(c){
		         return caml_trampoline_cps_call3
		                 (c, a, b, function(a){return cont([1, a]);});
		        });
		                                      });
		                            var empty = 9 === cond[2] ? 1 : 0;
		                            return cont([0, [0, cond[1], [2, [0, empty, 0]]]]);
		                           }
		                           a = cond[3];
		                           function c(value_str, cont){
		                            var field_name = cond[1];
		                            function a(field_schema, cont){
		                             if
		                              (typeof field_schema !== "number" && 3 === field_schema[0]){
		                              if(2 <= cond[2]){
		                               var d = op_name(cond[2]);
		                               return caml_exact_trampoline_cps_call$1
		                                       (kasprintf,
		id,
		fmt$207,
		function(a){
		 return caml_trampoline_cps_call2
		         (a, d, function(a){return cont([1, a]);});
		});
		                              }
		                              var
		                               e =
		                                 function(target, cont){
		                                  function a(param, cont){
		                                   var op = 1 === cond[2] ? 3901498 : 15500;
		                                   return cont([0, [0, cond[1], [1, [0, [0, target], op]]]]);
		                                  }
		                                  var b = typeof target === "number" ? bdA : bdB;
		                                  return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                 };
		                              return caml_exact_trampoline_cps_call
		                                      (of_string$46,
		                                       value_str,
		                                       function(t){
		function a(a){
		 return caml_exact_trampoline_cps_call$1(let$, a, e, cont);
		}
		if(0 === t[0]) return a(t);
		var err = t[1];
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$208,
		         function(b){
		          return caml_trampoline_cps_call2
		                  (b, err, function(b){return a([1, b]);});
		         });
		                                       });
		                             }
		                             function c(rhs, cont){
		                              function b(op, cont){
		                               return cont([0, [0, cond[1], [0, [0, op, rhs]]]]);
		                              }
		                              switch(cond[2]){
		                                case 0:
		                                 var a = bdt; break;
		                                case 1:
		                                 a = bdu; break;
		                                case 2:
		                                 a = bdv; break;
		                                case 3:
		                                 a = bdw; break;
		                                case 4:
		                                 a = bdx; break;
		                                case 5:
		                                 a = bdy; break;
		                                case 6:
		                                 a = bdz; break;
		                                default: a = 0;
		                              }
		                              return caml_exact_trampoline_cps_call$1
		                                      (let$,
		                                       of_option(a, "internal error: non-comparison operator"),
		                                       b,
		                                       cont);
		                             }
		                             function a(a){
		                              return caml_exact_trampoline_cps_call$1(let$, a, c, cont);
		                             }
		                             if(typeof field_schema === "number" && 3 > field_schema)
		                              switch(field_schema){
		                                case 0:
		                                 var
		                                  b =
		                                    function(match){
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$204,
		       function(b){
		        return caml_trampoline_cps_call2
		                (b, value_str, function(b){return a([1, b]);});
		       });
		                                     var b = match[1];
		                                     return a([0, [1, b]]);
		                                    };
		                                 caml_push_trap(function(exn){return b(0);});
		                                 return caml_exact_trampoline_cps_call
		 (of_string$2,
		  value_str,
		  function(x){caml_pop_trap(); return b([0, x]);});
		                                case 2:
		                                 a:
		                                 {
		                                  try{var x = caml_int64_of_string(value_str);}
		                                  catch(exn){var match = 0; break a;}
		                                  match = [0, x];
		                                 }
		                                 if(! match)
		                                  return caml_exact_trampoline_cps_call$1
		  (kasprintf,
		   id,
		   fmt$205,
		   function(b){
		    return caml_trampoline_cps_call2
		            (b, value_str, function(b){return a([1, b]);});
		   });
		                                 var i = match[1];
		                                 return a([0, [0, i]]);
		                              }
		                             return a([0, [2, value_str]]);
		                            }
		                            return caml_exact_trampoline_cps_call$0
		                                    (find$1,
		                                     fields,
		                                     equal$4,
		                                     field_name,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$203,
		       function(c){
		        return caml_trampoline_cps_call2
		                (c,
		                 field_name,
		                 function(c){
		                  return caml_exact_trampoline_cps_call$1
		                          (let$, of_option(b, c), a, cont);
		                 });
		       });
		                                     });
		                           }
		                           function b(a){
		                            return caml_exact_trampoline_cps_call$1(let$, a, c, cont);
		                           }
		                           if(a && ! a[2]){var v = a[1]; return b([0, v]);}
		                           return caml_exact_trampoline_cps_call
		                                   (length$1,
		                                    cond[3],
		                                    function(c){
		                                     var a = op_name(cond[2]);
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$209,
		      function(d){
		       return caml_trampoline_cps_call3
		               (d, a, c, function(a){return b([1, a]);});
		      });
		                                    });
		                          }
		                          function a(atoms, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$7,
		                                    atoms,
		                                    function(atom, cont){return cont([0, atom]);},
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (reduce,
		      a,
		      function(lhs, rhs, cont){
		       return filter[1] ? cont([2, lhs, rhs]) : cont([1, lhs, rhs]);
		      },
		      function(a){
		       return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   filter[2],
		                                   condition_to_atom,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (all$10,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function block_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (include$48[4],
		                                   schematic_version,
		                                   function(a){return cont([0, bdE, bdD, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (block_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$953 = [];
		               function supported_block_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$953[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bdG, bdF, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$953[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$953[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$953[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (block_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([10, f0]);},
		   function(param, cont){
		    if(10 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   "existing",
		   "Existing",
		   [0,
		    0,
		    bdH,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$556,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, c], 0, 0], 0];
		        return caml_exact_trampoline_cps_call
		                (block_id_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           c,
		                           function(d){
		                            var
		                             default$ = match$276[1],
		                             c =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([9, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(9 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_todo,
		                                 cst_Todo,
		                                 [0,
		                                  0,
		                                  bdI,
		                                  [7,
		                                   function(param, cont){
		                                    var content = param[2][1], id = param[1];
		                                    return cont([0, id, content]);
		                                   },
		                                   function(param, cont){
		                                    var content = param[2], id = param[1];
		                                    return cont([0, id, [0, content, 0]]);
		                                   },
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		                                    b]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$557,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_view, 0, 2, [1, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (block_id_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(d){
		                  var
		                   default$ = match$277[1],
		                   b =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f1 = param[2], f0 = param[1];
		                        return cont([8, f0, f1]);
		                       },
		                       function(param, cont){
		                        if(8 !== param[0]) return cont(0);
		                        var f1 = param[2], f0 = param[1];
		                        return cont([0, [0, f0, f1]]);
		                       },
		                       1,
		                       0,
		                       cst_query,
		                       cst_Query,
		                       [0,
		                        0,
		                        bdJ,
		                        [7,
		                         function(param, cont){
		                          var view = param[2][1], id = param[1];
		                          return cont([0, id, view]);
		                         },
		                         function(param, cont){
		                          var view = param[2], id = param[1];
		                          return cont([0, id, [0, view, 0]]);
		                         },
		                         [0,
		                          [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		                          a]],
		                        0],
		                       0],
		                      c];
		                  return caml_exact_trampoline_cps_call
		                          (paragraph_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, c], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (block_id_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       c,
		       function(d){
		        var
		         default$ = match$278[1],
		         c =
		           [0,
		            [0,
		             function(param, cont){
		              var f1 = param[2], f0 = param[1];
		              return cont([7, f0, f1]);
		             },
		             function(param, cont){
		              if(7 !== param[0]) return cont(0);
		              var f1 = param[2], f0 = param[1];
		              return cont([0, [0, f0, f1]]);
		             },
		             1,
		             0,
		             cst_paragraph,
		             cst_Paragraph,
		             [0,
		              0,
		              bdK,
		              [7,
		               function(param, cont){
		                var content = param[2][1], id = param[1];
		                return cont([0, id, content]);
		               },
		               function(param, cont){
		                var content = param[2], id = param[1];
		                return cont([0, id, [0, content, 0]]);
		               },
		               [0,
		                [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		                a]],
		              0],
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (heading_schema_versioned,
		                 schematic_version,
		                 function(b){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, b], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (block_id_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(d){
		                                      var
		                                       default$ = match$279[1],
		                                       b =
		 [0,
		  [0,
		   function(param, cont){
		    var f1 = param[2], f0 = param[1];
		    return cont([6, f0, f1]);
		   },
		   function(param, cont){
		    if(6 !== param[0]) return cont(0);
		    var f1 = param[2], f0 = param[1];
		    return cont([0, [0, f0, f1]]);
		   },
		   1,
		   0,
		   cst_heading,
		   cst_Heading,
		   [0,
		    0,
		    bdL,
		    [7,
		     function(param, cont){
		      var content = param[2][1], id = param[1];
		      return cont([0, id, content]);
		     },
		     function(param, cont){
		      var content = param[2], id = param[1];
		      return cont([0, id, [0, content, 0]]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		      a]],
		    0],
		   0],
		  c];
		                                      return caml_exact_trampoline_cps_call
		      (paragraph_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, c], 0, 0], 0];
		        return caml_exact_trampoline_cps_call
		                (block_id_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           c,
		                           function(d){
		                            var
		                             default$ = match$280[1],
		                             c =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([5, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(5 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_embed,
		                                 cst_Embed,
		                                 [0,
		                                  0,
		                                  bdM,
		                                  [7,
		                                   function(param, cont){
		                                    var content = param[2][1], id = param[1];
		                                    return cont([0, id, content]);
		                                   },
		                                   function(param, cont){
		                                    var content = param[2], id = param[1];
		                                    return cont([0, id, [0, content, 0]]);
		                                   },
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		                                    a]],
		                                  0],
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (block_id_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(b){
		        var
		         default$ = match$281[1],
		         a =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             1,
		             0,
		             cst_divider,
		             cst_Divider,
		             [0,
		              0,
		              bdN,
		              [7,
		               function(param, cont){var id = param[1]; return cont(id);},
		               function(id, cont){return cont([0, id, 0]);},
		               [0,
		                [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, b], 0, 0],
		                0]],
		              0],
		             0],
		            c];
		        return caml_exact_trampoline_cps_call
		                (code_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   b = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, c], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (block_id_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     c,
		                                     function(d){
		                                      var
		                                       default$ = match$282[1],
		                                       c =
		 [0,
		  [0,
		   function(param, cont){
		    var f1 = param[2], f0 = param[1];
		    return cont([3, f0, f1]);
		   },
		   function(param, cont){
		    if(3 !== param[0]) return cont(0);
		    var f1 = param[2], f0 = param[1];
		    return cont([0, [0, f0, f1]]);
		   },
		   1,
		   0,
		   cst_code,
		   cst_Code,
		   [0,
		    0,
		    bdO,
		    [7,
		     function(param, cont){
		      var content = param[2][1], id = param[1];
		      return cont([0, id, content]);
		     },
		     function(param, cont){
		      var content = param[2], id = param[1];
		      return cont([0, id, [0, content, 0]]);
		     },
		     [0,
		      [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		      b]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (check_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, b], 0, 0], 0];
		        return caml_exact_trampoline_cps_call
		                (block_id_schema_versioned,
		                 schematic_version,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(d){
		                            var
		                             default$ = match$283[1],
		                             b =
		                               [0,
		                                [0,
		                                 function(param, cont){
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([2, f0, f1]);
		                                 },
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f1 = param[2], f0 = param[1];
		                                  return cont([0, [0, f0, f1]]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_check,
		                                 cst_Check,
		                                 [0,
		                                  0,
		                                  bdP,
		                                  [7,
		                                   function(param, cont){
		                                    var content = param[2][1], id = param[1];
		                                    return cont([0, id, content]);
		                                   },
		                                   function(param, cont){
		                                    var content = param[2], id = param[1];
		                                    return cont([0, id, [0, content, 0]]);
		                                   },
		                                   [0,
		                                    [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		                                    a]],
		                                  0],
		                                 0],
		                                c];
		                            return caml_exact_trampoline_cps_call
		                                    (bullet_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, c], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (block_id_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 c,
		                 function(d){
		                  var
		                   default$ = match$284[1],
		                   c =
		                     [0,
		                      [0,
		                       function(param, cont){
		                        var f1 = param[2], f0 = param[1];
		                        return cont([1, f0, f1]);
		                       },
		                       function(param, cont){
		                        if(1 !== param[0]) return cont(0);
		                        var f1 = param[2], f0 = param[1];
		                        return cont([0, [0, f0, f1]]);
		                       },
		                       1,
		                       0,
		                       cst_bullet,
		                       cst_Bullet,
		                       [0,
		                        0,
		                        bdQ,
		                        [7,
		                         function(param, cont){
		                          var content = param[2][1], id = param[1];
		                          return cont([0, id, content]);
		                         },
		                         function(param, cont){
		                          var content = param[2], id = param[1];
		                          return cont([0, id, [0, content, 0]]);
		                         },
		                         [0,
		                          [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, d], 0, 0],
		                          a]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (paragraph_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             a = [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [1, b], 0, 0], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (block_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(b){
		        var
		         default$ = match$285[1],
		         res =
		           [11,
		            bdS,
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, f0, f1]);
		              },
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              },
		              1,
		              0,
		              cst_blockquote,
		              cst_Blockquote,
		              [0,
		               0,
		               bdR,
		               [7,
		                function(param, cont){
		                 var content = param[2][1], id = param[1];
		                 return cont([0, id, content]);
		                },
		                function(param, cont){
		                 var content = param[2], id = param[1];
		                 return cont([0, id, [0, content, 0]]);
		                },
		                [0,
		                 [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, b], 0, 0],
		                 a]],
		               0],
		              0],
		             c],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$953[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$953[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$910 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$953, [0, schematic_cache$910]);
		               caml_callback
		                (supported_block_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$954 = [];
		               function supported_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$954[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bdU, bdT, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$954[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$954[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$954[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (supported_block_schema_version,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var blocks = param[1];
		   return cont([0, blocks]);
		  },
		  function(param, cont){
		   var blocks = param[1];
		   return cont([0, blocks, 0]);
		  },
		  [0,
		   [0,
		    bdV,
		    0,
		    0,
		    0,
		    cst_blocks,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$954[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$954[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$911 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$954, [0, schematic_cache$911]);
		               caml_callback
		                (supported_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function of_supported(graph, workspace, previous, b, cont){
		                function find(id$0, cont){
		                 function a(param){
		                  function b(b){
		                   var a = include$48[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$211,
		                            function(c){
		                             return caml_trampoline_cps_call3
		                                     (c, a, id$0, function(a){return cont(of_option(b, a));});
		                            });
		                  }
		                  if(! param) return b(0);
		                  var l = param[2], pb = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (include$48[15],
		                           pb[1],
		                           id$0,
		                           function(c){
		                            return c ? b([0, pb]) : caml_exact_trampoline_call1(a, l);
		                           });
		                 }
		                 return a(previous);
		                }
		                function new_or_update(id, content, cont){
		                 if(! id)
		                  return caml_exact_trampoline_cps_call
		                          (of_string$0, [0, include$48[29].call(null), content], cont);
		                 var id$0 = id[1];
		                 return caml_exact_trampoline_cps_call
		                         (find,
		                          id$0,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$5,
		                                    a,
		                                    function(previous_block, cont){
		                                     return cont([0, previous_block[1], content]);
		                                    },
		                                    cont);
		                          });
		                }
		                switch(b[0]){
		                  case 0:
		                   var content$0 = b[2], id$0 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$0, [0, content$0], cont);
		                  case 1:
		                   var content$1 = b[2], id$1 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$1, [1, content$1], cont);
		                  case 2:
		                   var content$2 = b[2], id$2 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$2, [2, content$2], cont);
		                  case 3:
		                   var content$3 = b[2], id$3 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$3, [3, content$3], cont);
		                  case 4:
		                   var id$4 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$4, 0, cont);
		                  case 5:
		                   var content$4 = b[2], id$5 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$5, [5, content$4], cont);
		                  case 6:
		                   var content$5 = b[2], id$6 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$6, [6, content$5], cont);
		                  case 7:
		                   var content$6 = b[2], id$7 = b[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update, id$7, [8, content$6], cont);
		                  case 8:
		                   var
		                    query = b[2],
		                    id$8 = b[1],
		                    a =
		                      function(content, cont){
		                       return caml_exact_trampoline_cps_call$1
		                               (new_or_update, id$8, [9, [0, content]], cont);
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (databases,
		                            graph,
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (get$17,
		                                      b,
		                                      function(databases){
		                                       return caml_exact_trampoline_cps_call$1
		       (find_packed_by_id,
		        databases,
		        workspace,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (bind,
		                  b,
		                  function(databases, cont){
		                   function a(param){
		                    if(! param) return cont(0);
		                    var l = param[2], db = param[1], y = query[1], x = db[2];
		                    return x === y
		                            ? cont([0, db])
		                            : caml_exact_trampoline_call1(a, l);
		                   }
		                   return caml_exact_trampoline_cps_call(encode, databases, a);
		                  },
		                  function(db){
		                   var open = g(include$0), let$ = open[14];
		                   function b(db, cont){
		                    function a(a, cont){
		                     a = query[3];
		                     function c(filter, cont){
		                      var
		                       b = query[4],
		                       a = query[2],
		                       a = some_if(1 - is_empty(query[2]), a),
		                       view = [0, db[2], filter, a, 0, 0, b];
		                      return caml_exact_trampoline_cps_call
		                              (to_graph$5,
		                               view,
		                               function(ast){
		                                function a(param, cont){
		                                 return caml_exact_trampoline_cps_call$1
		 (to_to_string,
		  pp_expression$0,
		  ast,
		  function(a){return cont([0, a]);});
		                                }
		                                return caml_exact_trampoline_cps_call$2
		(compile$0,
		 graph,
		 0,
		 workspace,
		 ast,
		 function(b){
		  return caml_exact_trampoline_cps_call
		          (get$17,
		           b,
		           function(t){
		            function b(b){
		             return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		            }
		            if(0 === t[0]) return b(t);
		            var x = t[1];
		            return caml_exact_trampoline_cps_call$1
		                    (to_to_string, pp$30, x, function(a){return b([1, a]);});
		           });
		 });
		                               });
		                     }
		                     function b(a){
		                      return caml_exact_trampoline_cps_call$1(let$, a, c, cont);
		                     }
		                     if(! a) return b(bdC);
		                     var filter = a[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (to_view_filter, db, filter, b);
		                    }
		                    return caml_exact_trampoline_cps_call$1
		                            (validate_fields,
		                             db,
		                             query[2],
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                             });
		                   }
		                   var c = query[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$210,
		                            function(d){
		                             return caml_trampoline_cps_call2
		                                     (d,
		                                      c,
		                                      function(c){
		                                       return caml_exact_trampoline_cps_call$1
		       (let$,
		        of_option(db, c),
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (map$5,
		                  b,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call(join, a, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 9:
		                   var
		                    content$7 = b[2],
		                    id$9 = b[1],
		                    task = content$7[3],
		                    content = content$7[2],
		                    checked = content$7[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (new_or_update,
		                            id$9,
		                            [11, [0, checked, content, task]],
		                            cont);
		                  default:
		                   var id$10 = b[1];
		                   return caml_exact_trampoline_cps_call(find, id$10, cont);
		                }
		               }
		               function to_supported(b, cont){
		                var id = [0, b[1]], match = b[2];
		                if(typeof match === "number") return cont([4, id]);
		                switch(match[0]){
		                  case 0:
		                   var content$0 = match[1]; return cont([0, id, content$0]);
		                  case 1:
		                   var content$1 = match[1]; return cont([1, id, content$1]);
		                  case 2:
		                   var content$2 = match[1]; return cont([2, id, content$2]);
		                  case 3:
		                   var content$3 = match[1]; return cont([3, id, content$3]);
		                  case 5:
		                   var content$4 = match[1]; return cont([5, id, content$4]);
		                  case 6:
		                   var content$5 = match[1]; return cont([6, id, content$5]);
		                  case 8:
		                   var content$6 = match[1]; return cont([7, id, content$6]);
		                  case 11:
		                   var
		                    content$7 = match[1],
		                    task = content$7[3],
		                    content = content$7[2],
		                    checked = content$7[1];
		                   return cont([9, id, [0, checked, content, task]]);
		                  default: return cont([10, b[1]]);
		                }
		               }
		               function of_supported$0(graph, workspace, opt, doc, cont){
		                var previous = opt ? opt[1] : bdW, a = previous[1];
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         doc[1],
		                         function(b, cont){
		                          return caml_exact_trampoline_cps_call$2
		                                  (of_supported, graph, workspace, a, b, cont);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (all$10,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$5,
		     a,
		     function(blocks, cont){return cont([0, blocks]);},
		     cont);
		                                   });
		                         });
		               }
		               function to_supported$0(doc, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         doc[1],
		                         to_supported,
		                         function(blocks){return cont([0, blocks]);});
		               }
		               var letrec_function_context$955 = [];
		               function response_citation_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$955[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bdX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$955[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$955[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$955[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var title = param[2][1], url = param[1];
		                                 return cont([0, url, title]);
		                                },
		                                function(param, cont){
		                                 var title = param[2], url = param[1];
		                                 return cont([0, url, [0, title, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_url,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_title,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$955[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$955[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$912 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$955, [0, schematic_cache$912]);
		               caml_callback
		                (response_citation_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var
		                schematic_cache$913 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$956 = [];
		               caml_update_dummy
		                (letrec_function_context$956, [0, schematic_cache$913]);
		               function schematic_version$135(param, cont){return cont(0);}
		               var
		                schematic_schema_version$56 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$956[1][1],
		                     schematic_schema_version$56]);
		               if(e)
		                var schema$254 = e[1], descriptor$58 = schema$254;
		               else
		                descriptor$58 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$956[1][1],
		                              schematic_schema_version$56,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$956[1][1],
		 schematic_schema_version$56,
		 schematic_self,
		 function(a){
		  letrec_function_context$956[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (response_citation_schema_versi,
		           schematic_version$135,
		           function(b){
		            var
		             a =
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_citations,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, b], 0]],
		                 0,
		                 0],
		                0];
		            return caml_exact_trampoline_cps_call
		                    (supported_schema_versioned,
		                     schematic_version$135,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var citations = param[2][1], document = param[1];
		                           return cont([0, document, citations]);
		                          },
		                          function(param, cont){
		                           var citations = param[2], document = param[1];
		                           return cont([0, document, [0, citations, 0]]);
		                          },
		                          [0, [0, 0, 0, 0, 0, cst_document, 0, 2, [0, b], 0, 0], a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$956[1][1],
		                               schematic_schema_version$56,
		                               res,
		                               function(a){
		                                letrec_function_context$956[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var rich_response_schema = [0, bdZ, bdY, descriptor$58, 0];
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               function organization_id_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$104,
		                                   schematic_version,
		                                   function(a){return cont([0, bd1, bd0, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (organization_id_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               function workspace_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$120,
		                                   schematic_version,
		                                   function(a){return cont([0, bd3, bd2, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (workspace_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$957 = [];
		               function get_organization_input_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$957[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bd4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$957[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$957[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$957[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (organization_id_schema_version,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var organization = param[1];
		   return cont([0, organization]);
		  },
		  function(param, cont){
		   var organization = param[1];
		   return cont([0, organization, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$957[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$957[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$914 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$957, [0, schematic_cache$914]);
		               caml_callback
		                (get_organization_input_schema_,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$958 = [];
		               function get_workspace_input_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$958[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bd5, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$958[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$958[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$958[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (workspace_id_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var workspace = param[1];
		   return cont([0, workspace]);
		  },
		  function(param, cont){
		   var workspace = param[1];
		   return cont([0, workspace, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_workspaceId, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$958[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$958[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$915 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$958, [0, schematic_cache$915]);
		               caml_callback
		                (get_workspace_input_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$959 = [];
		               function org_output_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$959[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bd6, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$959[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$959[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$959[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (organization_id_schema_version,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var name = param[2][1], id = param[1];
		   return cont([0, id, name]);
		  },
		  function(param, cont){
		   var name = param[2], id = param[1];
		   return cont([0, id, [0, name, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$959[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$959[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$916 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$959, [0, schematic_cache$916]);
		               caml_callback
		                (org_output_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$960 = [];
		               function workspace_summary_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$960[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bd7, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$960[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$960[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$960[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (workspace_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var name = param[2][1], id = param[1];
		   return cont([0, id, name]);
		  },
		  function(param, cont){
		   var name = param[2], id = param[1];
		   return cont([0, id, [0, name, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_workspaceId, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$960[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$960[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$917 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$960, [0, schematic_cache$917]);
		               caml_callback
		                (workspace_summary_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$961 = [];
		               function create_workspace_input_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$961[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bd8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$961[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$961[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$961[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (organization_id_schema_version,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var name = param[2][1], organization = param[1];
		   return cont([0, organization, name]);
		  },
		  function(param, cont){
		   var name = param[2], organization = param[1];
		   return cont([0, organization, [0, name, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$961[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$961[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$918 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$961, [0, schematic_cache$918]);
		               caml_callback
		                (create_workspace_input_schema_,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$962 = [];
		               function create_workspace_output_schema
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$962[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bd9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$962[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$962[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$962[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (workspace_id_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var workspace_id = param[1];
		   return cont([0, workspace_id]);
		  },
		  function(param, cont){
		   var workspace_id = param[1];
		   return cont([0, workspace_id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_workspaceId, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$962[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$962[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$919 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$962, [0, schematic_cache$919]);
		               caml_callback
		                (create_workspace_output_schema,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$963 = [];
		               function list_workspaces_input_schema_v
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$963[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bd_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$963[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$963[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$963[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$286[1],
		                                       a =
		 [0,
		  [0, bd$, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (organization_id_schema_version,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var limit = param[2][1], organization = param[1];
		             return cont([0, organization, limit]);
		            },
		            function(param, cont){
		             var limit = param[2], organization = param[1];
		             return cont([0, organization, [0, limit, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$963[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$963[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$920 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$963, [0, schematic_cache$920]);
		               caml_callback
		                (list_workspaces_input_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$964 = [];
		               function rename_workspace_input_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$964[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bea, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$964[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$964[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$964[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (workspace_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var name = param[2][1], workspace = param[1];
		   return cont([0, workspace, name]);
		  },
		  function(param, cont){
		   var name = param[2], workspace = param[1];
		   return cont([0, workspace, [0, name, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_workspaceId, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$964[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$964[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$921 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$964, [0, schematic_cache$921]);
		               caml_callback
		                (rename_workspace_input_schema_,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$965 = [];
		               function list_members_input_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$965[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, beb, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$965[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$965[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$965[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$287[1],
		                                       a =
		 [0,
		  [0, bec, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var limit = param[2][1], workspace = param[1];
		             return cont([0, workspace, limit]);
		            },
		            function(param, cont){
		             var limit = param[2], workspace = param[1];
		             return cont([0, workspace, [0, limit, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_workspaceId, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$965[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$965[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$922 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$965, [0, schematic_cache$922]);
		               caml_callback
		                (list_members_input_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$966 = [];
		               function member_output_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$966[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bed, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$966[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$966[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$966[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_email,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    email = a[2][1],
		    name = a[1],
		    id = param[1];
		   return cont([0, id, name, email]);
		  },
		  function(param, cont){
		   var email = param[3], name = param[2], id = param[1];
		   return cont([0, id, [0, name, [0, email, 0]]]);
		  },
		  [0, [0, bee, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$966[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$966[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$923 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$966, [0, schematic_cache$923]);
		               caml_callback
		                (member_output_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var default_list_limit = 50;
		               function make_list_workspaces(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (state_personal,
		                         ctrl[2],
		                         function(match){
		                          var organizations = match[15];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   organizations,
		                                   input[1],
		                                   function(match){
		                                    if(! match)
		                                     return caml_trampoline_cps_call2(return$12, beg, cont);
		                                    var org = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (keys$0,
		     org[4],
		     function(ids){
		      var limit = value$4(input[2], default_list_limit);
		      return caml_exact_trampoline_cps_call$1
		              (cap,
		               limit,
		               ids,
		               function(result){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         result[1],
		                         function(id, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get$18,
		                                   ctrl,
		                                   id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (get$17,
		     a,
		     function(match){
		      if(! match) return cont(0);
		      var ws = match[1];
		      return cont([0, [0, id, ws[1][3][2]]]);
		     });
		                                   });
		                         },
		                         function(items){
		                          return caml_trampoline_cps_call2
		                                  (return$12, [0, [0, items, result[2], result[3]]], cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make_create_workspace(ctrl, input, cont){
		                function a(crdt, cont){
		                 var workspace_read = [0, input[1], input[2]];
		                 return caml_exact_trampoline_cps_call$3
		                         (create$43,
		                          ctrl,
		                          crdt,
		                          0,
		                          0,
		                          workspace_read,
		                          function(match){
		                           function a(a){
		                            return caml_trampoline_cps_call2(return$12, a, cont);
		                           }
		                           if(0 === match[0]){
		                            var workspace_id = match[1];
		                            return a([0, [0, workspace_id]]);
		                           }
		                           var error = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (to_to_string,
		                                    pp$125,
		                                    error,
		                                    function(b){return a([1, b]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function make_rename_workspace(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (rename$0,
		                          ctrl,
		                          crdt,
		                          input[1],
		                          input[2],
		                          function(a){
		                           if(0 === a[0])
		                            a = bei;
		                           else {
		                            a = a[1];
		                            var variant = a[1];
		                            if(847566860 <= variant)
		                             a = bej;
		                            else
		                             var msg = a[2], a = [1, msg];
		                           }
		                           return caml_trampoline_cps_call2(return$12, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function make_list_members(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_organization,
		                         ctrl,
		                         input[1],
		                         function(match){
		                          if(! match)
		                           return caml_trampoline_cps_call2(return$12, bek, cont);
		                          var
		                           org = match[1],
		                           limit = value$4(input[2], default_list_limit);
		                          return caml_exact_trampoline_cps_call
		                                  (encode,
		                                   org[1],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (cap,
		     limit,
		     a,
		     function(result){
		      return caml_exact_trampoline_cps_call$1
		              (map$7,
		               result[1],
		               function(m, cont){
		                var a = to_string$42(m[2]);
		                return cont([0, m[3], m[4], a]);
		               },
		               function(items){
		                return caml_trampoline_cps_call2
		                        (return$12, [0, [0, items, result[2], result[3]]], cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$25 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$43 = open$25[3],
		                let$44 = open$25[4],
		                let$45 = open$25[14];
		               function object_id_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$105,
		                                   schematic_version,
		                                   function(a){return cont([0, bes, ber, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (object_id_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function table_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call
		                                  (Table[4],
		                                   schematic_version,
		                                   function(a){return cont([0, beu, bet, a[3], a[4]]);});
		                         });
		               }
		               caml_callback
		                (table_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$967 = [];
		               function get_object_input_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$967[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bev, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$967[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$967[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$967[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (object_id_schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var object = param[1];
		   return cont([0, object]);
		  },
		  function(param, cont){
		   var object = param[1];
		   return cont([0, object, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_object, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$967[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$967[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$924 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$967, [0, schematic_cache$924]);
		               caml_callback
		                (get_object_input_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               function get_extension_row(graph, kind, param, cont){
		                var row_id = param[1];
		                return caml_exact_trampoline_cps_call
		                        (personal_workspace_id$0,
		                         graph,
		                         function(workspace){
		                          return caml_exact_trampoline_cps_call
		                                  (id_of,
		                                   kind,
		                                   function(table_id){
		                                    return caml_exact_trampoline_cps_call
		    (include$51[8],
		     row_id,
		     function(row_id_str){
		      var
		       value = [16, row_id_str],
		       a = [0, [0, cst_rows]],
		       b = [0, value, none$2];
		      return caml_exact_trampoline_cps_call
		              (Table[8],
		               table_id,
		               function(c){
		                var value = [16, c];
		                return caml_exact_trampoline_cps_call$2
		                        (compile$0,
		                         graph,
		                         0,
		                         workspace,
		                         [0,
		                          [17,
		                           [0,
		                            [2,
		                             [0,
		                              [2,
		                               [0, [12, [0, cst_databases]], none$2],
		                               [1, [0, value, none$2]],
		                               0],
		                              none$2],
		                             a,
		                             0],
		                            none$2],
		                           b],
		                          none$2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    if(0 === match[0]){
		                                     var query = match[1];
		                                     return caml_exact_trampoline_cps_call
		     (run$4,
		      query,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (get$17,
		                a,
		                function(match){
		                 if(0 === match[0]){
		                  var result = match[1];
		                  return cont([0, result]);
		                 }
		                 var error = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$212,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a, pp$30, error, function(a){return cont([1, a]);});
		                          });
		                });
		      });
		                                    }
		                                    var err = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$213,
		     function(a){
		      return caml_trampoline_cps_call3
		              (a, pp$30, err, function(a){return cont([1, a]);});
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$968 = [];
		               function list_tables_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$968[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bew, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$968[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$968[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$968[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$288[1],
		                                       a =
		 [0,
		  [0, bex, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var limit = param[2][1], workspace = param[1];
		             return cont([0, workspace, limit]);
		            },
		            function(param, cont){
		             var limit = param[2], workspace = param[1];
		             return cont([0, workspace, [0, limit, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$968[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$968[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$925 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$968, [0, schematic_cache$925]);
		               caml_callback
		                (list_tables_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$969 = [];
		               function table_origin_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$969[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bez, bey, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$969[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$969[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$969[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  return typeof param === "number" ? cont(beB) : cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_builtin_type,
		                                 cst_Builtin_type,
		                                 [0,
		                                  0,
		                                  beA,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (table_id_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_integration_app,
		   cst_Integration_app,
		   [0,
		    0,
		    beC,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (table_id_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            beE,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_user_defined,
		              cst_User_defined,
		              [0,
		               0,
		               beD,
		               [7,
		                function(param, cont){var id = param[1]; return cont(id);},
		                function(id, cont){return cont([0, id, 0]);},
		                [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]],
		               0],
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$969[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$969[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$926 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$969, [0, schematic_cache$926]);
		               caml_callback
		                (table_origin_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_dataName = "dataName",
		                letrec_function_context$970 = [];
		               function table_summary_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$970[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, beF, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$970[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$970[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$970[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (table_origin_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    origin = b[2][1],
		    description = b[1],
		    data_name = a[1],
		    name = param[1];
		   return cont([0, name, data_name, description, origin]);
		  },
		  function(param, cont){
		   var
		    origin = param[4],
		    description = param[3],
		    data_name = param[2],
		    name = param[1];
		   return cont
		           ([0, name, [0, data_name, [0, description, [0, origin, 0]]]]);
		  },
		  [0,
		   [0,
		    beH,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     beG,
		     0,
		     0,
		     0,
		     cst_dataName,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      0,
		      0,
		      0,
		      0,
		      cst_description,
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0, [0, 0, 0, 0, 0, cst_origin, 0, 2, [1, a], 0, 0], 0]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$970[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$970[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$927 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$970, [0, schematic_cache$927]);
		               caml_callback
		                (table_summary_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$971 = [];
		               function get_table_schema_input_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$971[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, beI, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$971[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$971[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$971[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (table_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_table, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var table = param[2][1], workspace = param[1];
		             return cont([0, workspace, table]);
		            },
		            function(param, cont){
		             var table = param[2], workspace = param[1];
		             return cont([0, workspace, [0, table, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$971[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$971[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$928 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$971, [0, schematic_cache$928]);
		               caml_callback
		                (get_table_schema_input_schema_,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$972 = [];
		               function search_rows_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$972[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, beJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$972[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$972[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$972[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (filter_schema_versioned$1,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(b){
		        var
		         default$ = match$289[1],
		         a =
		           [0,
		            [0, 0, 0, 0, 0, cst_filter, 0, [0, default$], [0, b], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (table_id_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   b = [0, [0, 0, 0, 0, 0, cst_table, 0, 2, [0, c], 0, 0], a];
		                  return caml_exact_trampoline_cps_call
		                          (workspace_id_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  filter = a[2][1],
		                                  table = a[1],
		                                  workspace = param[1];
		                                 return cont([0, workspace, table, filter]);
		                                },
		                                function(param, cont){
		                                 var
		                                  filter = param[3],
		                                  table = param[2],
		                                  workspace = param[1];
		                                 return cont([0, workspace, [0, table, [0, filter, 0]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, a], 0, 0], b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$972[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$972[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$929 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$972, [0, schematic_cache$929]);
		               caml_callback
		                (search_rows_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$973 = [];
		               function relation_target_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$973[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, beK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$973[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$973[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$973[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$109,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(6 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_task,
		   cst_Task,
		   [0, a[1], beL, a[3], a[4]],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (object_id_schema_versioned$0,
		       schematic_version,
		       function(a){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(5 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             "table_object",
		             "Table_object",
		             [0, a[1], beM, a[3], a[4]],
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (include$51[4],
		                 schematic_version,
		                 function(a){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(4 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_table_row,
		                       cst_Table_row,
		                       [0, a[1], beN, a[3], a[4]],
		                       0],
		                      c];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$339,
		                           schematic_version,
		                           function(a){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(3 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_people,
		                                 cst_People,
		                                 [0, a[1], beO, a[3], a[4]],
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$103,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([2, f0]);},
		   function(param, cont){
		    if(2 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_page,
		   cst_Page,
		   [0, a[1], beP, a[3], a[4]],
		   0],
		  c];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$117,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_event,
		              cst_Event,
		              [0, schema$263[1], beR, schema$263[3], schema$263[4]],
		              0],
		             [0,
		              [0,
		               function(f0, cont){return cont([1, f0]);},
		               function(param, cont){
		                if(1 !== param[0]) return cont(0);
		                var f0 = param[1];
		                return cont([0, f0]);
		               },
		               0,
		               0,
		               cst_member,
		               cst_Member,
		               [0, a[1], beQ, a[3], a[4]],
		               0],
		              b]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$973[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$973[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$930 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$973, [0, schematic_cache$930]);
		               caml_callback
		                (relation_target_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_Custom_table = "Custom_table",
		                cst_custom_table = "custom_table",
		                letrec_function_context$974 = [];
		               function relation_schema_target_schema_
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$974[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, beS, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$974[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$974[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$974[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && ! param) return cont(be2);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_event,
		                                 cst_Event,
		                                 [0,
		                                  0,
		                                  be1,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(1);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 1 === param)
		                                    return cont(be0);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_member,
		                                  cst_Member,
		                                  [0,
		                                   0,
		                                   beZ,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(2);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 2 === param)
		                                     return cont(beY);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_page,
		                                   cst_Page,
		                                   [0,
		                                    0,
		                                    beX,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(3);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 3 === param)
		                                      return cont(beW);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_people,
		                                    cst_People,
		                                    [0,
		                                     0,
		                                     beV,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(4);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 4 <= param)
		                                       return cont(beU);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_task,
		                                     cst_Task,
		                                     [0,
		                                      0,
		                                      beT,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (table_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  be4,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(typeof param === "number") return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_custom_table,
		    cst_Custom_table,
		    [0,
		     0,
		     be3,
		     [7,
		      function(param, cont){
		       var table = param[1];
		       return cont(table);
		      },
		      function(table, cont){return cont([0, table, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_table, 0, 2, [0, b], 0, 0], 0]],
		     0],
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$974[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$974[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$931 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$974, [0, schematic_cache$931]);
		               caml_callback
		                (relation_schema_target_schema_,
		                 [function(param, cont){return cont(0);}]);
		               var bO3 = [];
		               function field_type_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bO3[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, be5, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bO3[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO3[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bO3[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (relation_schema_target_schema_,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_relation,
		   cst_Relation,
		   [0,
		    0,
		    be6,
		    [7,
		     function(param, cont){
		      var target = param[1];
		      return cont(target);
		     },
		     function(target, cont){return cont([0, target, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (field_type_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_variant,
		             cst_Variant,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var cases = param[1];
		                return cont(cases);
		               },
		               function(cases, cont){return cont([0, cases, 0]);},
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_cases,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, c], 0]],
		                 0,
		                 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (ai_field_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_record,
		                       cst_Record,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var fields = param[1];
		                          return cont(fields);
		                         },
		                         function(fields, cont){return cont([0, fields, 0]);},
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_fields,
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, c], 0]],
		                           0,
		                           0],
		                          0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (field_type_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 1,
		                                 0,
		                                 cst_tuple,
		                                 cst_Tuple,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var elements = param[1];
		                                    return cont(elements);
		                                   },
		                                   function(elements, cont){return cont([0, elements, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_elements,
		                                     0,
		                                     2,
		                                     [0, [0, 0, 0, [3, c], 0]],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (field_type_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_string_const,
		   cst_String_const,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var value = param[1];
		      return cont(value);
		     },
		     function(value, cont){return cont([0, value, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_value,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(5);},
		    function(param, cont){
		     if(typeof param === "number" && 5 === param)
		      return cont(be9);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_date,
		    cst_Date,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(6);},
		     function(param, cont){
		      if(typeof param === "number" && 6 <= param)
		       return cont(be8);
		      return cont(0);
		     },
		     0,
		     0,
		     cst_note,
		     cst_Note,
		     [0,
		      0,
		      be7,
		      [7,
		       function(param, cont){return cont(0);},
		       function(param, cont){return cont(0);},
		       0],
		      0],
		     0],
		    [0,
		     [0,
		      function(f0, cont){return cont([2, f0]);},
		      function(param, cont){
		       if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		       return cont(0);
		      },
		      1,
		      0,
		      cst_list,
		      cst_List,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var elements = param[1];
		         return cont(elements);
		        },
		        function(elements, cont){return cont([0, elements, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_elements, 0, 2, [0, c], 0, 0], 0]],
		       0],
		      0],
		     b]]]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$151,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$290[1],
		                   res =
		                     [11,
		                      bfd,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){
		                         if(typeof param === "number" && ! param) return cont(bfc);
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_bool,
		                        cst_Bool,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){return cont(0);},
		                          function(param, cont){return cont(0);},
		                          0],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          if(typeof param === "number" && 1 === param)
		                           return cont(bfb);
		                          return cont(0);
		                         },
		                         0,
		                         0,
		                         cst_int,
		                         cst_Int,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){return cont(0);},
		                           function(param, cont){return cont(0);},
		                           0],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           if(typeof param === "number" && 2 === param)
		                            return cont(bfa);
		                           return cont(0);
		                          },
		                          0,
		                          0,
		                          cst_float,
		                          cst_Float,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){return cont(0);},
		                            function(param, cont){return cont(0);},
		                            0],
		                           0],
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            if(typeof param === "number" && 3 === param)
		                             return cont(be$);
		                            return cont(0);
		                           },
		                           0,
		                           0,
		                           cst_json,
		                           cst_Json,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){return cont(0);},
		                             function(param, cont){return cont(0);},
		                             0],
		                            0],
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             if(typeof param === "number" && 4 === param)
		                              return cont(be_);
		                             return cont(0);
		                            },
		                            0,
		                            0,
		                            cst_null,
		                            cst_Null,
		                            [0,
		                             0,
		                             0,
		                             [7,
		                              function(param, cont){return cont(0);},
		                              function(param, cont){return cont(0);},
		                              0],
		                             0],
		                            0],
		                           [0,
		                            [0,
		                             function(f0, cont){return cont([0, f0]);},
		                             function(param, cont){
		                              if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                              return cont(0);
		                             },
		                             1,
		                             0,
		                             cst_string,
		                             cst_String,
		                             [0,
		                              0,
		                              0,
		                              [7,
		                               function(param, cont){
		                                var format = param[1];
		                                return cont(format);
		                               },
		                               function(format, cont){return cont([0, format, 0]);},
		                               [0,
		                                [0, 0, 0, 0, 0, cst_format, 0, [0, default$], [0, b], 0, 0],
		                                0]],
		                              0],
		                             0],
		                            a]]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO3[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bO3[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var
		                cst_columnId = "columnId",
		                cst_fieldType = "fieldType",
		                letrec_function_context$975 = [];
		               function ai_field_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$975[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfe, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$975[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$975[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$975[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$291[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_description,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (field_type_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             bff,
		             0,
		             0,
		             0,
		             cst_name,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0, [0, 0, 0, 0, 0, cst_fieldType, 0, 2, [0, c], 0, 0], a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$142,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(a){
		                            var
		                             default$ = match$292[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  description = b[2][1],
		                                  field_type = b[1],
		                                  name = a[1],
		                                  column_id = param[1];
		                                 return cont([0, column_id, name, field_type, description]);
		                                },
		                                function(param, cont){
		                                 var
		                                  description = param[4],
		                                  field_type = param[3],
		                                  name = param[2],
		                                  column_id = param[1];
		                                 return cont
		 ([0,
		   column_id,
		   [0, name, [0, field_type, [0, description, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bfg,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_columnId,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$975[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$975[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$932 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bO3, [0, schematic_cache$932]);
		               var schematic_cache$933 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$975, [0, schematic_cache$933]);
		               caml_callback
		                (field_type_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (ai_field_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var bO4 = [];
		               function field_type_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bO4[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bO4[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO4[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            bO4[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (relation_schema_target_schema_,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_relation,
		   cst_Relation,
		   [0,
		    0,
		    bfi,
		    [7,
		     function(param, cont){
		      var target = param[1];
		      return cont(target);
		     },
		     function(target, cont){return cont([0, target, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (field_type_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             function(f0, cont){return cont([5, f0]);},
		             function(param, cont){
		              if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		              return cont(0);
		             },
		             1,
		             0,
		             cst_variant,
		             cst_Variant,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){
		                var cases = param[1];
		                return cont(cases);
		               },
		               function(cases, cont){return cont([0, cases, 0]);},
		               [0,
		                [0,
		                 0,
		                 0,
		                 0,
		                 0,
		                 cst_cases,
		                 0,
		                 2,
		                 [0, [0, 0, 0, [3, c], 0]],
		                 0,
		                 0],
		                0]],
		              0],
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (ai_field_schema_versioned$0,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([4, f0]);},
		                       function(param, cont){
		                        if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                        return cont(0);
		                       },
		                       1,
		                       0,
		                       cst_record,
		                       cst_Record,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var fields = param[1];
		                          return cont(fields);
		                         },
		                         function(fields, cont){return cont([0, fields, 0]);},
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_fields,
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, c], 0]],
		                           0,
		                           0],
		                          0]],
		                        0],
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (field_type_schema_versioned$0,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([3, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 1,
		                                 0,
		                                 cst_tuple,
		                                 cst_Tuple,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var elements = param[1];
		                                    return cont(elements);
		                                   },
		                                   function(elements, cont){return cont([0, elements, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_elements,
		                                     0,
		                                     2,
		                                     [0, [0, 0, 0, [3, c], 0]],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (field_type_schema_versioned$0,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_string_const,
		   cst_String_const,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var value = param[1];
		      return cont(value);
		     },
		     function(value, cont){return cont([0, value, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_value,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  [0,
		   [0,
		    function(param, cont){return cont(5);},
		    function(param, cont){
		     if(typeof param === "number" && 5 === param)
		      return cont(bfl);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_date,
		    cst_Date,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(param, cont){return cont(6);},
		     function(param, cont){
		      if(typeof param === "number" && 6 <= param)
		       return cont(bfk);
		      return cont(0);
		     },
		     0,
		     0,
		     cst_note,
		     cst_Note,
		     [0,
		      0,
		      bfj,
		      [7,
		       function(param, cont){return cont(0);},
		       function(param, cont){return cont(0);},
		       0],
		      0],
		     0],
		    [0,
		     [0,
		      function(f0, cont){return cont([2, f0]);},
		      function(param, cont){
		       if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		       return cont(0);
		      },
		      1,
		      0,
		      cst_list,
		      cst_List,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var elements = param[1];
		         return cont(elements);
		        },
		        function(elements, cont){return cont([0, elements, 0]);},
		        [0, [0, 0, 0, 0, 0, cst_elements, 0, 2, [0, c], 0, 0], 0]],
		       0],
		      0],
		     b]]]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$151,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$293[1],
		                   res =
		                     [11,
		                      bfr,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){
		                         if(typeof param === "number" && ! param) return cont(bfq);
		                         return cont(0);
		                        },
		                        0,
		                        0,
		                        cst_bool,
		                        cst_Bool,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){return cont(0);},
		                          function(param, cont){return cont(0);},
		                          0],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          if(typeof param === "number" && 1 === param)
		                           return cont(bfp);
		                          return cont(0);
		                         },
		                         0,
		                         0,
		                         cst_int,
		                         cst_Int,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){return cont(0);},
		                           function(param, cont){return cont(0);},
		                           0],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           if(typeof param === "number" && 2 === param)
		                            return cont(bfo);
		                           return cont(0);
		                          },
		                          0,
		                          0,
		                          cst_float,
		                          cst_Float,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){return cont(0);},
		                            function(param, cont){return cont(0);},
		                            0],
		                           0],
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            if(typeof param === "number" && 3 === param)
		                             return cont(bfn);
		                            return cont(0);
		                           },
		                           0,
		                           0,
		                           cst_json,
		                           cst_Json,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){return cont(0);},
		                             function(param, cont){return cont(0);},
		                             0],
		                            0],
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             if(typeof param === "number" && 4 === param)
		                              return cont(bfm);
		                             return cont(0);
		                            },
		                            0,
		                            0,
		                            cst_null,
		                            cst_Null,
		                            [0,
		                             0,
		                             0,
		                             [7,
		                              function(param, cont){return cont(0);},
		                              function(param, cont){return cont(0);},
		                              0],
		                             0],
		                            0],
		                           [0,
		                            [0,
		                             function(f0, cont){return cont([0, f0]);},
		                             function(param, cont){
		                              if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                              return cont(0);
		                             },
		                             1,
		                             0,
		                             cst_string,
		                             cst_String,
		                             [0,
		                              0,
		                              0,
		                              [7,
		                               function(param, cont){
		                                var format = param[1];
		                                return cont(format);
		                               },
		                               function(format, cont){return cont([0, format, 0]);},
		                               [0,
		                                [0, 0, 0, 0, 0, cst_format, 0, [0, default$], [0, b], 0, 0],
		                                0]],
		                              0],
		                             0],
		                            a]]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO4[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bO4[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$976 = [];
		               function ai_field_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$976[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfs, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$976[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$976[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$976[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$294[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_description,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (field_type_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             bft,
		             0,
		             0,
		             0,
		             cst_name,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0, [0, 0, 0, 0, 0, cst_fieldType, 0, 2, [0, c], 0, 0], a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$142,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(a){
		                            var
		                             default$ = match$295[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  description = b[2][1],
		                                  field_type = b[1],
		                                  name = a[1],
		                                  column_id = param[1];
		                                 return cont([0, column_id, name, field_type, description]);
		                                },
		                                function(param, cont){
		                                 var
		                                  description = param[4],
		                                  field_type = param[3],
		                                  name = param[2],
		                                  column_id = param[1];
		                                 return cont
		 ([0,
		   column_id,
		   [0, name, [0, field_type, [0, description, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bfu,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_columnId,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$976[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$976[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$934 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bO4, [0, schematic_cache$934]);
		               var schematic_cache$935 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$976, [0, schematic_cache$935]);
		               caml_callback
		                (field_type_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (ai_field_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var bO5 = [];
		               function cell_value_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bO5[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfw, bfv, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bO5[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO5[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bO5[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([7, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 1,
		                                 0,
		                                 cst_string,
		                                 cst_String,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var value = param[1];
		                                    return cont(value);
		                                   },
		                                   function(value, cont){return cont([0, value, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_value,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (relation_target_schema_version,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_relation,
		   cst_Relation,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var target = param[1];
		      return cont(target);
		     },
		     function(target, cont){return cont([0, target, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (field_value_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(param, cont){return cont(0);},
		             function(param, cont){
		              return typeof param === "number" ? cont(bfx) : cont(0);
		             },
		             0,
		             0,
		             cst_null,
		             cst_Null,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){return cont(0);},
		               function(param, cont){return cont(0);},
		               0],
		              0],
		             0],
		            [0,
		             [0,
		              function(f0, cont){return cont([5, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_object,
		              cst_Object,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var fields = param[1];
		                 return cont(fields);
		                },
		                function(fields, cont){return cont([0, fields, 0]);},
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_fields,
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, c], 0]],
		                  0,
		                  0],
		                 0]],
		               0],
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call
		                (cell_value_schema_versioned,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [11,
		                      bfz,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        1,
		                        0,
		                        cst_bool,
		                        cst_Bool,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var value = param[1];
		                           return cont(value);
		                          },
		                          function(value, cont){return cont([0, value, 0]);},
		                          [0,
		                           [0, 0, 0, 0, 0, cst_value, 0, 2, [0, bool_schema], 0, 0],
		                           0]],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([1, f0]);},
		                         function(param, cont){
		                          if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_date,
		                         cst_Date,
		                         [0,
		                          0,
		                          bfy,
		                          [7,
		                           function(param, cont){
		                            var value = param[1];
		                            return cont(value);
		                           },
		                           function(value, cont){return cont([0, value, 0]);},
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_value,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            0]],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([2, f0]);},
		                          function(param, cont){
		                           if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                           return cont(0);
		                          },
		                          1,
		                          0,
		                          cst_float,
		                          cst_Float,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var value = param[1];
		                             return cont(value);
		                            },
		                            function(value, cont){return cont([0, value, 0]);},
		                            [0,
		                             [0, 0, 0, 0, 0, cst_value, 0, 2, [0, float_schema], 0, 0],
		                             0]],
		                           0],
		                          0],
		                         [0,
		                          [0,
		                           function(f0, cont){return cont([3, f0]);},
		                           function(param, cont){
		                            if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                            return cont(0);
		                           },
		                           1,
		                           0,
		                           cst_int,
		                           cst_Int,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){
		                              var value = param[1];
		                              return cont(value);
		                             },
		                             function(value, cont){return cont([0, value, 0]);},
		                             [0,
		                              [0, 0, 0, 0, 0, cst_value, 0, 2, [0, int64_schema], 0, 0],
		                              0]],
		                            0],
		                           0],
		                          [0,
		                           [0,
		                            function(f0, cont){return cont([4, f0]);},
		                            function(param, cont){
		                             if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                             return cont(0);
		                            },
		                            1,
		                            0,
		                            cst_list,
		                            cst_List,
		                            [0,
		                             0,
		                             0,
		                             [7,
		                              function(param, cont){
		                               var elements = param[1];
		                               return cont(elements);
		                              },
		                              function(elements, cont){return cont([0, elements, 0]);},
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_elements,
		                                0,
		                                2,
		                                [0, [0, 0, 0, [3, b], 0]],
		                                0,
		                                0],
		                               0]],
		                             0],
		                            0],
		                           a]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO5[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bO5[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$977 = [];
		               function field_value_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$977[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$977[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$977[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$977[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (cell_value_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var value = param[2][1], name = param[1];
		   return cont([0, name, value]);
		  },
		  function(param, cont){
		   var value = param[2], name = param[1];
		   return cont([0, name, [0, value, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$977[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$977[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$936 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bO5, [0, schematic_cache$936]);
		               var schematic_cache$937 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$977, [0, schematic_cache$937]);
		               caml_callback
		                (cell_value_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (field_value_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var bO6 = [];
		               function cell_value_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   bO6[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfC, bfB, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                bO6[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO6[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            bO6[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([7, f0]);},
		                                 function(param, cont){
		                                  if(typeof param !== "number" && 7 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                  return cont(0);
		                                 },
		                                 1,
		                                 0,
		                                 cst_string,
		                                 cst_String,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var value = param[1];
		                                    return cont(value);
		                                   },
		                                   function(value, cont){return cont([0, value, 0]);},
		                                   [0,
		                                    [0,
		                                     0,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_value,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    0]],
		                                  0],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (relation_target_schema_version,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([6, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_relation,
		   cst_Relation,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var target = param[1];
		      return cont(target);
		     },
		     function(target, cont){return cont([0, target, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, c], 0, 0], 0]],
		    0],
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (field_value_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         a =
		           [0,
		            [0,
		             function(param, cont){return cont(0);},
		             function(param, cont){
		              return typeof param === "number" ? cont(bfD) : cont(0);
		             },
		             0,
		             0,
		             cst_null,
		             cst_Null,
		             [0,
		              0,
		              0,
		              [7,
		               function(param, cont){return cont(0);},
		               function(param, cont){return cont(0);},
		               0],
		              0],
		             0],
		            [0,
		             [0,
		              function(f0, cont){return cont([5, f0]);},
		              function(param, cont){
		               if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		               return cont(0);
		              },
		              1,
		              0,
		              cst_object,
		              cst_Object,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var fields = param[1];
		                 return cont(fields);
		                },
		                function(fields, cont){return cont([0, fields, 0]);},
		                [0,
		                 [0,
		                  0,
		                  0,
		                  0,
		                  0,
		                  cst_fields,
		                  0,
		                  2,
		                  [0, [0, 0, 0, [3, c], 0]],
		                  0,
		                  0],
		                 0]],
		               0],
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call
		                (cell_value_schema_versioned$0,
		                 schematic_version,
		                 function(b){
		                  var
		                   res =
		                     [11,
		                      bfF,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(typeof param !== "number" && 0 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                         return cont(0);
		                        },
		                        1,
		                        0,
		                        cst_bool,
		                        cst_Bool,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var value = param[1];
		                           return cont(value);
		                          },
		                          function(value, cont){return cont([0, value, 0]);},
		                          [0,
		                           [0, 0, 0, 0, 0, cst_value, 0, 2, [0, bool_schema], 0, 0],
		                           0]],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([1, f0]);},
		                         function(param, cont){
		                          if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_date,
		                         cst_Date,
		                         [0,
		                          0,
		                          bfE,
		                          [7,
		                           function(param, cont){
		                            var value = param[1];
		                            return cont(value);
		                           },
		                           function(value, cont){return cont([0, value, 0]);},
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_value,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            0]],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(f0, cont){return cont([2, f0]);},
		                          function(param, cont){
		                           if(typeof param !== "number" && 2 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                           return cont(0);
		                          },
		                          1,
		                          0,
		                          cst_float,
		                          cst_Float,
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var value = param[1];
		                             return cont(value);
		                            },
		                            function(value, cont){return cont([0, value, 0]);},
		                            [0,
		                             [0, 0, 0, 0, 0, cst_value, 0, 2, [0, float_schema], 0, 0],
		                             0]],
		                           0],
		                          0],
		                         [0,
		                          [0,
		                           function(f0, cont){return cont([3, f0]);},
		                           function(param, cont){
		                            if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                            return cont(0);
		                           },
		                           1,
		                           0,
		                           cst_int,
		                           cst_Int,
		                           [0,
		                            0,
		                            0,
		                            [7,
		                             function(param, cont){
		                              var value = param[1];
		                              return cont(value);
		                             },
		                             function(value, cont){return cont([0, value, 0]);},
		                             [0,
		                              [0, 0, 0, 0, 0, cst_value, 0, 2, [0, int64_schema], 0, 0],
		                              0]],
		                            0],
		                           0],
		                          [0,
		                           [0,
		                            function(f0, cont){return cont([4, f0]);},
		                            function(param, cont){
		                             if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                             return cont(0);
		                            },
		                            1,
		                            0,
		                            cst_list,
		                            cst_List,
		                            [0,
		                             0,
		                             0,
		                             [7,
		                              function(param, cont){
		                               var elements = param[1];
		                               return cont(elements);
		                              },
		                              function(elements, cont){return cont([0, elements, 0]);},
		                              [0,
		                               [0,
		                                0,
		                                0,
		                                0,
		                                0,
		                                cst_elements,
		                                0,
		                                2,
		                                [0, [0, 0, 0, [3, b], 0]],
		                                0,
		                                0],
		                               0]],
		                             0],
		                            0],
		                           a]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           bO6[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){bO6[1][1] = a; return cont(res);});
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var letrec_function_context$978 = [];
		               function field_value_schema_versioned$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$978[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$978[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$978[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$978[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (cell_value_schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var value = param[2][1], name = param[1];
		   return cont([0, name, value]);
		  },
		  function(param, cont){
		   var value = param[2], name = param[1];
		   return cont([0, name, [0, value, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$978[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$978[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$938 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy(bO6, [0, schematic_cache$938]);
		               var schematic_cache$939 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$978, [0, schematic_cache$939]);
		               caml_callback
		                (cell_value_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               caml_callback
		                (field_value_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$979 = [];
		               function cell_value_to_graph_result(param, cont){
		                if(typeof param === "number")
		                 return caml_exact_trampoline_cps_call(of_string$0, 0, cont);
		                switch(param[0]){
		                  case 0:
		                   var value = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_string$0, [0, value], cont);
		                  case 1:
		                   var value$0 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_string$12,
		                            value$0,
		                            function(t){
		                             function a(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (map$5, a, of_date$3, cont);
		                             }
		                             if(0 === t[0]) return a(t);
		                             var x = t[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$214,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (b, value$0, x, function(b){return a([1, b]);});
		                                      });
		                            });
		                  case 2:
		                   var value$1 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_string$0, [2, value$1], cont);
		                  case 3:
		                   var value$2 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_string$0, [1, value$2], cont);
		                  case 4:
		                   var
		                    elements = param[1],
		                    b = function(values, cont){return cont([4, values]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (map$7,
		                            elements,
		                            cell_value_to_graph_result,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (all$10,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context$979[1], a, b, cont);
		                                      });
		                            });
		                  case 5:
		                   var
		                    fields = param[1],
		                    c =
		                      function(pairs, cont){
		                       return caml_exact_trampoline_cps_call
		                               (of_alist_exn$2, pairs, function(a){return cont([6, a]);});
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (map$7,
		                            fields,
		                            function(fv, cont){
		                             function a(r, cont){return cont([0, fv[1], r]);}
		                             return caml_exact_trampoline_cps_call
		                                     (cell_value_to_graph_result,
		                                      fv[2],
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context$979[1], b, a, cont);
		                                      });
		                            },
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (all$10,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (letrec_function_context$979[1], a, c, cont);
		                                      });
		                            });
		                  case 6:
		                   var
		                    target = param[1],
		                    a =
		                      function(id){
		                       return caml_exact_trampoline_cps_call
		                               (of_alist_exn$2,
		                                [0, [0, cst_id, [7, id]], 0],
		                                function(a){
		                                 return caml_exact_trampoline_cps_call
		 (of_alist_exn$2,
		  [0, [0, cst_routine$0, [6, a]], 0],
		  function(a){
		   return caml_exact_trampoline_cps_call
		           (of_string$0, [6, a], cont);
		  });
		                                });
		                      };
		                   switch(target[0]){
		                     case 0:
		                      var id$0 = target[1];
		                      return caml_exact_trampoline_cps_call(to_string$29, id$0, a);
		                     case 1:
		                      var id$1 = target[1];
		                      return caml_exact_trampoline_cps_call(to_string$44, id$1, a);
		                     case 2:
		                      var id$2 = target[1];
		                      return caml_exact_trampoline_cps_call(to_string$30, id$2, a);
		                     case 3:
		                      var id$3 = target[1];
		                      return caml_exact_trampoline_cps_call(to_string$59, id$3, a);
		                     case 4:
		                      var id$4 = target[1];
		                      return caml_exact_trampoline_cps_call
		                              (include$51[8], id$4, a);
		                     case 5:
		                      var obj = target[1];
		                      return caml_exact_trampoline_cps_call
		                              (include$51[8], obj[3], a);
		                     default:
		                      var id$5 = target[1];
		                      return caml_exact_trampoline_cps_call(to_string$36, id$5, a);
		                   }
		                  default:
		                   var value$3 = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_string$0, [7, value$3], cont);
		                }
		               }
		               caml_update_dummy
		                (letrec_function_context$979, [0, g(include$0)[17]]);
		               var letrec_function_context$980 = [];
		               function add_row_input_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$980[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfH, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$980[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$980[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$980[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (field_value_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_fields,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (table_id_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_table, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (workspace_id_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        fields = a[2][1],
		                        table = a[1],
		                        workspace = param[1];
		                       return cont([0, workspace, table, fields]);
		                      },
		                      function(param, cont){
		                       var
		                        fields = param[3],
		                        table = param[2],
		                        workspace = param[1];
		                       return cont([0, workspace, [0, table, [0, fields, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$980[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$980[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$940 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$980, [0, schematic_cache$940]);
		               caml_callback
		                (add_row_input_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$981 = [];
		               function add_row_output_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$981[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfI, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$981[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$981[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$981[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (object_id_schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$981[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$981[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$941 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$981, [0, schematic_cache$941]);
		               caml_callback
		                (add_row_output_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$982 = [];
		               function update_object_field_input_sche
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$982[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfJ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$982[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$982[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$982[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (cell_value_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_field,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (object_id_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              value = a[2][1],
		              field = a[1],
		              id = param[1];
		             return cont([0, id, field, value]);
		            },
		            function(param, cont){
		             var value = param[3], field = param[2], id = param[1];
		             return cont([0, id, [0, field, [0, value, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$982[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$982[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$942 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$982, [0, schematic_cache$942]);
		               caml_callback
		                (update_object_field_input_sche,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$983 = [];
		               function create_table_input_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$983[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$983[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$983[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$983[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (ai_field_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_dataName,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_description,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_fields,
		     0,
		     2,
		     [0, [0, 0, 0, [3, b], 0]],
		     0,
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              fields = b[2][1],
		              description = b[1],
		              data_name = a[1],
		              workspace = param[1];
		             return cont([0, workspace, data_name, description, fields]);
		            },
		            function(param, cont){
		             var
		              fields = param[4],
		              description = param[3],
		              data_name = param[2],
		              workspace = param[1];
		             return cont
		                     ([0,
		                       workspace,
		                       [0, data_name, [0, description, [0, fields, 0]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$983[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$983[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$943 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$983, [0, schematic_cache$943]);
		               caml_callback
		                (create_table_input_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$984 = [];
		               function create_table_output_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$984[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfL, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$984[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$984[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$984[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (table_id_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var table_id = param[1];
		   return cont([0, table_id]);
		  },
		  function(param, cont){
		   var table_id = param[1];
		   return cont([0, table_id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, "tableId", 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$984[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$984[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$944 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$984, [0, schematic_cache$944]);
		               caml_callback
		                (create_table_output_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$985 = [];
		               function update_table_schema_input_sche
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$985[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfM, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$985[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$985[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$985[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (ai_field_schema_versioned$0,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_fields,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (table_id_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_table, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (workspace_id_schema_versioned,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        fields = a[2][1],
		                        table = a[1],
		                        workspace = param[1];
		                       return cont([0, workspace, table, fields]);
		                      },
		                      function(param, cont){
		                       var
		                        fields = param[3],
		                        table = param[2],
		                        workspace = param[1];
		                       return cont([0, workspace, [0, table, [0, fields, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$985[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$985[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$945 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$985, [0, schematic_cache$945]);
		               caml_callback
		                (update_table_schema_input_sche,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$986 = [];
		               function update_note_column_input_schem
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$986[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfN, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$986[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$986[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$986[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (supported_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   "columnName",
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_content, 0, 2, [0, b], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call
		      (object_id_schema_versioned$0,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              content = a[2][1],
		              column_name = a[1],
		              object = param[1];
		             return cont([0, object, column_name, content]);
		            },
		            function(param, cont){
		             var
		              content = param[3],
		              column_name = param[2],
		              object = param[1];
		             return cont([0, object, [0, column_name, [0, content, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_object, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$986[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$986[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$946 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$986, [0, schematic_cache$946]);
		               caml_callback
		                (update_note_column_input_schem,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$987 = [];
		               function delete_object_input_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$987[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfO, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$987[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$987[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$987[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (object_id_schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var object = param[1];
		   return cont([0, object]);
		  },
		  function(param, cont){
		   var object = param[1];
		   return cont([0, object, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_object, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$987[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$987[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$947 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$987, [0, schematic_cache$947]);
		               caml_callback
		                (delete_object_input_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               function cell_schema_of_field_type(ft, cont){
		                if(typeof ft === "number")
		                 switch(ft){
		                   case 0:
		                    return cont(0);
		                   case 1:
		                    return cont(2);
		                   case 2:
		                    return cont(1);
		                   case 3:
		                    return cont(6);
		                   case 4:
		                    return cont(5);
		                   case 5:
		                    return cont(3);
		                   default: return cont(4);
		                 }
		                switch(ft[0]){
		                  case 0:
		                   var format = ft[1]; return cont([4, format]);
		                  case 1:
		                   var value = ft[1]; return cont([5, value]);
		                  case 2:
		                   var elements = ft[1];
		                   return caml_exact_trampoline_cps_call
		                           (cell_schema_of_field_type,
		                            elements,
		                            function(a){return cont([1, a]);});
		                  case 3:
		                   var elements$0 = ft[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (map$7,
		                            elements$0,
		                            cell_schema_of_field_type,
		                            function(a){return cont([6, a]);});
		                  case 4:
		                   var fields = ft[1];
		                   return caml_exact_trampoline_cps_call
		                           (cell_schema_fields_of_ai_field,
		                            fields,
		                            function(a){return cont([2, a]);});
		                  case 5:
		                   var cases = ft[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (map$7,
		                            cases,
		                            cell_schema_of_field_type,
		                            function(a){return cont([7, a]);});
		                  default:
		                   var target = ft[1];
		                   if(typeof target === "number")
		                    switch(target){
		                      case 0:
		                       var a = bfP; break;
		                      case 1:
		                       a = bfQ; break;
		                      case 2:
		                       a = bfR; break;
		                      case 3:
		                       a = bfS; break;
		                      default: a = bfT;
		                    }
		                   else
		                    var table = target[1], a = [0, table];
		                   return cont([3, [0, a, 0]]);
		                }
		               }
		               function cell_schema_fields_of_ai_field(fields, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         fields,
		                         function(af, cont){
		                          var match = af[1];
		                          if(match)
		                           var id = match[1], col_id = id;
		                          else
		                           col_id = make$35();
		                          return caml_exact_trampoline_cps_call
		                                  (cell_schema_of_field_type,
		                                   af[3],
		                                   function(a){
		                                    return cont([0, col_id, make_field(0, af[4], af[2], 0, a)]);
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (of_alist_exn$3, a, cont);
		                         });
		               }
		               function field_type_of_cell_schema(cs$0, cont){
		                a:
		                {
		                 b:
		                 {
		                  c:
		                  {
		                   d:
		                   {
		                    var cs = cs$0;
		                    e:
		                    for(;;){
		                     if(typeof cs === "number")
		                      switch(cs){
		                        case 0:
		                         return cont(0);
		                        case 1:
		                         return cont(2);
		                        case 2:
		                         return cont(1);
		                        case 3:
		                         return cont(5);
		                        case 4:
		                         return cont(6);
		                        case 5:
		                         return cont(4);
		                        default: return cont(3);
		                      }
		                     switch(cs[0]){
		                       case 0:
		                        var schema = cs[1]; cs = schema; break;
		                       case 1:
		                        break a;
		                       case 2:
		                        break b;
		                       case 3:
		                        break c;
		                       case 4:
		                        var format = cs[1]; return cont([0, format]);
		                       case 5:
		                        var value = cs[1]; return cont([1, value]);
		                       case 6:
		                        break d;
		                       default: break e;
		                     }
		                    }
		                    var cases = cs[1];
		                    return caml_exact_trampoline_cps_call$1
		                            (map$7,
		                             cases,
		                             field_type_of_cell_schema,
		                             function(a){return cont([5, a]);});
		                   }
		                   var elements$0 = cs[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (map$7,
		                            elements$0,
		                            field_type_of_cell_schema,
		                            function(a){return cont([3, a]);});
		                  }
		                  var target = cs[1][1];
		                  if(0 === target[0])
		                   var table_id = target[1], a = [0, table_id];
		                  else
		                   switch(target[1]){
		                     case 0:
		                      a = 1; break;
		                     case 1:
		                      a = 2; break;
		                     case 2:
		                      a = 4; break;
		                     case 3:
		                      a = 0; break;
		                     default: a = 3;
		                   }
		                  return cont([6, a]);
		                 }
		                 var fields = cs[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (to_alist$1,
		                          0,
		                          fields,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$7,
		                                    a,
		                                    function(param, cont){
		                                     var f = param[2], col_id = param[1], a = f[2];
		                                     return caml_exact_trampoline_cps_call
		     (field_type_of_cell_schema,
		      f[5],
		      function(b){return cont([0, [0, col_id], f[3], b, a]);});
		                                    },
		                                    function(a){return cont([4, a]);});
		                          });
		                }
		                var elements = cs[1];
		                return caml_exact_trampoline_cps_call
		                        (field_type_of_cell_schema,
		                         elements,
		                         function(a){return cont([2, a]);});
		               }
		               function ai_fields_to_cell_schema(fields, cont){
		                return caml_exact_trampoline_cps_call
		                        (cell_schema_fields_of_ai_field,
		                         fields,
		                         function(a){return cont([2, a]);});
		               }
		               function make_list_tables(graph, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (databases,
		                         graph,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(dbs){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     dbs,
		     input[1],
		     function(match){
		      function a(tables){
		       var limit = value$4(input[2], default_list_limit);
		       return caml_exact_trampoline_cps_call$1
		               (cap,
		                limit,
		                tables,
		                function(a){
		                 return caml_trampoline_cps_call2(return$13, a, cont);
		                });
		      }
		      if(! match) return a(0);
		      var workspace_dbs = match[1];
		      return caml_exact_trampoline_cps_call
		              (encode,
		               workspace_dbs,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         b,
		                         function(db, cont){
		                          function summary(origin){
		                           return [0, [0, db[2], db[3], db[4], origin]];
		                          }
		                          switch(db[8]){
		                            case 0:
		                             return cont(summary([0, db[1]]));
		                            case 1:
		                             return cont(summary([1, db[1]]));
		                            case 4:
		                             return cont(summary(0));
		                            default: return cont(0);
		                          }
		                         },
		                         a);
		               });
		     });
		                                   });
		                         });
		               }
		               function make_get_table_schema(graph, input, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (get_database,
		                         graph,
		                         input[1],
		                         input[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    if(! match)
		                                     return caml_trampoline_cps_call2(return$12, bfU, cont);
		                                    var db = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (to_alist$1,
		     0,
		     db[6][1],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (map$7,
		               a,
		               function(param, cont){
		                var
		                 fwo = param[2],
		                 col_id = param[1],
		                 column_id = fwo[2] ? 0 : [0, col_id],
		                 a = fwo[1][2];
		                return caml_exact_trampoline_cps_call
		                        (field_type_of_cell_schema,
		                         fwo[1][5],
		                         function(b){return cont([0, column_id, fwo[1][3], b, a]);});
		               },
		               function(ai_fields){
		                return caml_trampoline_cps_call2
		                        (return$12, [0, ai_fields], cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$988 = [];
		               function graph_row_id_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$988[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bfW, bfV, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$988[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$988[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$988[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (include$51[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([5, f0]);},
		   function(param, cont){
		    if(5 !== param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_row,
		   "Row",
		   [0, a[1], bfX, a[3], a[4]],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$117,
		       schematic_version,
		       function(a){
		        var
		         c =
		           [0,
		            [0,
		             function(f0, cont){return cont([4, f0]);},
		             function(param, cont){
		              if(4 !== param[0]) return cont(0);
		              var f0 = param[1];
		              return cont([0, f0]);
		             },
		             0,
		             0,
		             cst_member,
		             cst_Member,
		             [0, a[1], bfY, a[3], a[4]],
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$339,
		                 schematic_version,
		                 function(a){
		                  var
		                   b =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([3, f0]);},
		                       function(param, cont){
		                        if(3 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       0,
		                       0,
		                       cst_people,
		                       cst_People,
		                       [0, a[1], bfZ, a[3], a[4]],
		                       0],
		                      c];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$103,
		                           schematic_version,
		                           function(a){
		                            var
		                             c =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([2, f0]);},
		                                 function(param, cont){
		                                  if(2 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 0,
		                                 0,
		                                 cst_page,
		                                 cst_Page,
		                                 [0, a[1], bf0, a[3], a[4]],
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$109,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    0,
		    0,
		    cst_event,
		    cst_Event,
		    [0, schema$263[1], bf2, schema$263[3], schema$263[4]],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([1, f0]);},
		     function(param, cont){
		      if(1 !== param[0]) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     cst_task,
		     cst_Task,
		     [0, a[1], bf1, a[3], a[4]],
		     0],
		    c]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$988[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$988[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$948 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$988, [0, schematic_cache$948]);
		               caml_callback
		                (graph_row_id_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function graph_row_id_of_string(s, cont){
		                var a = [0, -976970511, s];
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (graph_row_id_schema_versioned,
		                         schematic_version,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (decode$2, b, a, function(a){return cont(ok$0(a));});
		                         });
		               }
		               function make_search_table_rows(graph, input, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (get_database,
		                         graph,
		                         input[1],
		                         input[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(a){
		                                    if(! a)
		                                     return caml_trampoline_cps_call2(return$12, bf4, cont);
		                                    var db = a[1], a = input[3];
		                                    function b(ast_result){
		                                     if(0 === ast_result[0]){
		                                      var ast = ast_result[1];
		                                      return caml_exact_trampoline_cps_call$2
		      (compile$0,
		       graph,
		       0,
		       input[1],
		       ast,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (get$17,
		                 a,
		                 function(compile_result){
		                  if(0 === compile_result[0]){
		                   var query = compile_result[1];
		                   return caml_exact_trampoline_cps_call
		                           (run$4,
		                            query,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (get$17,
		                                      a,
		                                      function(a){
		                                       if(0 !== a[0]){
		var error = a[1];
		return caml_exact_trampoline_cps_call$1
		        (to_to_string,
		         pp$30,
		         error,
		         function(a){
		          return caml_trampoline_cps_call2(return$12, [1, a], cont);
		         });
		                                       }
		                                       a = a[1];
		                                       if(typeof a !== "number" && 5 === a[0]){
		var map = a[1];
		return caml_exact_trampoline_cps_call$1
		        (to_alist$0,
		         0,
		         map,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (filter_map$0,
		                   a,
		                   function(param, cont){
		                    var
		                     data = param[2],
		                     key = param[1],
		                     open =
		                       g
		                        ([0,
		                          symbol_bind,
		                          symbol_map$1,
		                          ,
		                          bind,
		                          return$4,
		                          map$3,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Let_syntax]),
		                     let$ = open[4];
		                    function b(id, cont){return cont([0, id, data]);}
		                    function a(a){
		                     return caml_trampoline_cps_call3(let$, a, b, cont);
		                    }
		                    if(typeof key !== "number" && 7 === key[0]){
		                     var s = key[1];
		                     return caml_exact_trampoline_cps_call
		                             (graph_row_id_of_string, s, a);
		                    }
		                    return a(0);
		                   },
		                   function(pairs){
		                    return caml_trampoline_cps_call2
		                            (return$12, [0, pairs], cont);
		                   });
		         });
		                                       }
		                                       return caml_trampoline_cps_call2(return$12, bf3, cont);
		                                      });
		                            });
		                  }
		                  var err = compile_result[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (to_to_string,
		                           pp$30,
		                           err,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$12, [1, a], cont);
		                           });
		                 });
		       });
		                                     }
		                                     var err = ast_result[1];
		                                     return caml_trampoline_cps_call2(return$12, [1, err], cont);
		                                    }
		                                    if(a){
		                                     var
		                                      filter = a[1],
		                                      c =
		function(param, cont){
		 if(param){
		  var view_filter = param[1];
		  return caml_exact_trampoline_cps_call
		          (to_graph$3,
		           view_filter,
		           function(filter_expr){
		            var
		             s = db[2],
		             value = [20, [0, [12, [0, s]], none$2], filter_expr];
		            return cont([0, value, none$2]);
		           });
		 }
		 var s = db[2];
		 return cont([0, [12, [0, s]], none$2]);
		};
		                                     return caml_exact_trampoline_cps_call$1
		     (to_view_filter,
		      db,
		      filter,
		      function(a){
		       return caml_exact_trampoline_cps_call$1(map$5, a, c, b);
		      });
		                                    }
		                                    var s = db[2];
		                                    return b([0, [0, [12, [0, s]], none$2]]);
		                                   });
		                         });
		               }
		               function make_add_table_row(graph, input, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14];
		                return caml_exact_trampoline_cps_call$0
		                        (get_database,
		                         graph,
		                         input[1],
		                         input[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fail$2, cst_Table_not_found, cont);
		                                    var db = match[1];
		                                    function a(param, cont){
		                                     function a(fields, cont){
		                                      function a(result, cont){
		                                       return caml_exact_trampoline_cps_call
		       (return_ok, [0, [0, [0, input[1]], input[2], result]], cont);
		                                      }
		                                      return caml_exact_trampoline_cps_call$2
		      (create$52,
		       graph,
		       input[1],
		       input[2],
		       fields,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (map$7,
		      input[3],
		      function(fv, cont){
		       function a(r, cont){return cont([0, fv[1], r]);}
		       return caml_exact_trampoline_cps_call
		               (cell_value_to_graph_result,
		                fv[2],
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(map$5, b, a, cont);
		                });
		      },
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (all$10,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (return$12,
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (map$7,
		     input[3],
		     function(fv, cont){return cont(fv[1]);},
		     function(field_names){
		      return caml_exact_trampoline_cps_call$1
		              (validate_fields,
		               db,
		               field_names,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (return$12,
		                         b,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make_update_object_field(graph, input, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14];
		                return caml_exact_trampoline_cps_call$2
		                        (value_exn,
		                         bf5,
		                         0,
		                         0,
		                         input[1][1],
		                         function(workspace_id){
		                          return caml_exact_trampoline_cps_call$0
		                                  (get_database,
		                                   graph,
		                                   workspace_id,
		                                   input[1][2],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (get$17,
		     a,
		     function(match){
		      if(! match)
		       return caml_trampoline_cps_call2(return$12, bf6, cont);
		      var db = match[1], field_names = [0, input[2], 0];
		      function a(param, cont){
		       function a(cell_value, cont){
		        function a(param, cont){
		         return caml_exact_trampoline_cps_call(return_ok, 0, cont);
		        }
		        return caml_exact_trampoline_cps_call$2
		                (set$28,
		                 graph,
		                 input[1],
		                 input[2],
		                 cell_value,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (cell_value_to_graph_result,
		                input[3],
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (return$12,
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                });
		      }
		      return caml_exact_trampoline_cps_call$1
		              (validate_fields,
		               db,
		               field_names,
		               function(b){
		                return caml_trampoline_cps_call2
		                        (return$12,
		                         b,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make_create_table(graph, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (ai_fields_to_cell_schema,
		                         input[4],
		                         function(schema){
		                          var b = input[1], c = make$38(0, 0, 0, 0, 0, 0);
		                          function a(result, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (map_error,
		                                    result,
		                                    show_upsert_database_error,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (map$5,
		      a,
		      function(table_id, cont){return cont([0, table_id]);},
		      cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (data_name_to_name,
		                                   input[2],
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call$8
		    (add_database,
		     graph,
		     input[2],
		     input[3],
		     d,
		     c,
		     b,
		     schema,
		     function(b){
		      return caml_trampoline_cps_call3(let$44, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function make_update_table_schema(graph, input, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (get_database,
		                         graph,
		                         input[1],
		                         input[2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    if(! match)
		                                     return caml_trampoline_cps_call2(return$12, bf7, cont);
		                                    var db = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (ai_fields_to_cell_schema,
		     input[3],
		     function(schema){
		      function a(result, cont){
		       return caml_exact_trampoline_cps_call$1
		               (map_error, result, show_upsert_database_error, cont);
		      }
		      return caml_exact_trampoline_cps_call$9
		              (update_database,
		               graph,
		               input[1],
		               input[2],
		               db[3],
		               db[4],
		               db[2],
		               db[5],
		               schema,
		               function(b){
		                return caml_trampoline_cps_call3(let$44, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                cst_Object_id_is_missing_works =
		                  "Object id is missing workspace id";
		               function make_update_note_column(graph, input, cont){
		                var ctrl = graph[3];
		                function a(workspace_id, cont){
		                 function a(db, cont){
		                  function b(column_id, cont){
		                   function a(state, cont){
		                    function a(table, cont){
		                     function a(current_row, cont){
		                      return caml_exact_trampoline_cps_call$1
		                              (find_packed_by_id,
		                               current_row,
		                               column_id,
		                               function(b){
		                                var previous_cell = value$4(b, 0);
		                                a:
		                                {
		                                 if
		                                  (typeof previous_cell !== "number" && 5 === previous_cell[0]){
		                                  var doc = previous_cell[1], previous_doc = [0, doc];
		                                  break a;
		                                 }
		                                 previous_doc = 0;
		                                }
		                                function a(new_cell, cont){
		                                 return caml_exact_trampoline_cps_call$1
		 (diff$10,
		  previous_cell,
		  new_cell,
		  function(cell_diff){
		   return caml_trampoline_cps_call2
		           (Operation$17[2],
		            [1, column_id, cell_diff],
		            function(a){
		             return caml_trampoline_cps_call2
		                     (Operation$17[11],
		                      a,
		                      function(row_diff){
		                       function a(crdt, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (include$321[16],
		                                 input[1][3],
		                                 row_diff,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (rows,
		   a,
		   function(a){
		    return caml_trampoline_cps_call2
		            (element$19,
		             input[1][2],
		             function(b){
		              return caml_trampoline_cps_call2
		                      (b,
		                       a,
		                       function(a){
		                        return caml_exact_trampoline_cps_call
		                                (tables,
		                                 a,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$2
		  (apply$125,
		   ctrl[1],
		   crdt,
		   workspace_id,
		   a,
		   function(result){
		    return 0 === result[0]
		            ? caml_trampoline_cps_call2(return$13, 0, cont)
		            : caml_exact_trampoline_cps_call
		              (fail$2, "Failed to update table cell", cont);
		   });
		                                 });
		                       });
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (writable$0,
		                                ctrl[2],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$43, b, a, cont);
		                                });
		                      });
		            });
		  });
		                                }
		                                return caml_exact_trampoline_cps_call$2
		(of_supported$0,
		 graph,
		 workspace_id,
		 previous_doc,
		 input[3],
		 function(b){
		  return caml_exact_trampoline_cps_call$1
		          (map$5,
		           b,
		           function(doc, cont){return cont([5, doc]);},
		           function(b){
		            return caml_trampoline_cps_call2
		                    (return$12,
		                     b,
		                     function(b){
		                      return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		                     });
		           });
		 });
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              table[6],
		                              input[1][3],
		                              function(b){
		                               return caml_trampoline_cps_call2
		                                       (return$12,
		of_option(b, "Row not found"),
		function(b){
		 return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		});
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             state[25][1],
		                             input[1][2],
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (return$12,
		                                       of_option(b, cst_Table_not_found),
		                                       function(b){
		return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		                                       });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (state$0,
		                            workspace_id,
		                            ctrl[2],
		                            function(b){
		                             return caml_trampoline_cps_call2
		                                     (return$12,
		                                      of_option(b, cst_Workspace_not_found),
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		                                      });
		                            });
		                  }
		                  function a(param){
		                   if(param){
		                    var
		                     l = param[2],
		                     x = param[1],
		                     fwo = x[2],
		                     y = input[2],
		                     x$0 = fwo[1][3];
		                    if(x$0 !== y) return caml_exact_trampoline_call1(a, l);
		                    var c = [0, x];
		                   }
		                   else
		                    c = 0;
		                   var d = input[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$215,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a,
		                                      d,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (map$5,
		        of_option(c, a),
		        calendar,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (return$12,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1(let$45, a, b, cont);
		                  });
		        });
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (to_alist$1, 0, db[6][1], a);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (get_database,
		                          graph,
		                          workspace_id,
		                          input[1][2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (get$17,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      of_option(b, cst_Table_not_found),
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		      });
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (return$12,
		                         of_option(input[1][1], cst_Object_id_is_missing_works),
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		                         });
		               }
		               function make_delete_object(graph, input, cont){
		                var ctrl = graph[3];
		                function a(workspace_id, cont){
		                 function a(db, cont){
		                  function a(crdt, cont){
		                   return caml_exact_trampoline_cps_call
		                           (include$321[18],
		                            input[1][3],
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (rows,
		                                      a,
		                                      function(a){
		                                       return caml_trampoline_cps_call2
		       (element$19,
		        input[1][2],
		        function(b){
		         return caml_trampoline_cps_call2
		                 (b,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (tables,
		                            a,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$2
		                                     (apply$125,
		                                      ctrl[1],
		                                      crdt,
		                                      workspace_id,
		                                      a,
		                                      function(result){
		                                       return 0 === result[0]
		       ? caml_trampoline_cps_call2(return$13, 0, cont)
		       : caml_exact_trampoline_cps_call
		         (fail$2, "Failed to delete table row", cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (writable$0,
		                           ctrl[2],
		                           function(b){
		                            return caml_trampoline_cps_call3(let$43, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (get_database,
		                          graph,
		                          workspace_id,
		                          input[1][2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (get$17,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      of_option(b, cst_Table_not_found),
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		      });
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (return$12,
		                         of_option(input[1][1], cst_Object_id_is_missing_works),
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$45, b, a, cont);
		                         });
		               }
		               var
		                open$26 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$46 = open$26[14],
		                letrec_function_context$989 = [];
		               function contact_summary_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$989[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$989[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$989[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$989[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_email,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$296[1],
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$339,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              email = a[2][1],
		              name = a[1],
		              id = param[1];
		             return cont([0, id, name, email]);
		            },
		            function(param, cont){
		             var email = param[3], name = param[2], id = param[1];
		             return cont([0, id, [0, name, [0, email, 0]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$989[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$989[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$949 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$989, [0, schematic_cache$949]);
		               caml_callback
		                (contact_summary_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$990 = [];
		               function contact_organization_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$990[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$990[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$990[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$990[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(a){
		                                      var
		                                       default$ = match$297[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var job_title = param[2][1], name = param[1];
		   return cont([0, name, job_title]);
		  },
		  function(param, cont){
		   var job_title = param[2], name = param[1];
		   return cont([0, name, [0, job_title, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_job_title,
		     0,
		     [0, default$],
		     [0, a],
		     0,
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$990[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$990[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$950 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$990, [0, schematic_cache$950]);
		               caml_callback
		                (contact_organization_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$991 = [];
		               function get_contact_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$991[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgi, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$991[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$991[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$991[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$339,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var contact = param[1];
		   return cont([0, contact]);
		  },
		  function(param, cont){
		   var contact = param[1];
		   return cont([0, contact, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_contact, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$991[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$991[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$951 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$991, [0, schematic_cache$951]);
		               caml_callback
		                (get_contact_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_extensionRow = "extensionRow",
		                letrec_function_context$992 = [];
		               function get_contact_output_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$992[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgj, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$992[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$992[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$992[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (schema_versioned$92,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, bgk, 0, 0, 0, cst_extensionRow, 0, 3, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$340,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0, [0, bgl, 0, 0, 0, cst_source, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (supported_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (contact_organization_schema_ve,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_phones,
		                                 0,
		                                 2,
		                                 [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_organizations,
		                                  0,
		                                  2,
		                                  [0, [0, 0, 0, [3, c], 0]],
		                                  0,
		                                  0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$298[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_email,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_otherEmails,
		    0,
		    2,
		    [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		    0,
		    0],
		   [0,
		    [0, 0, 0, 0, 0, cst_address, 0, [0, default$], [0, c], 0, 0],
		    b]]];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$299[1],
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$339,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        extension_row = h[2][1],
		                        source = h[1],
		                        notes = g[1],
		                        organizations = f[1],
		                        phones = e[1],
		                        address = d[1],
		                        other_emails = c[1],
		                        email = b[1],
		                        name = a[1],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 name,
		                                 email,
		                                 other_emails,
		                                 address,
		                                 phones,
		                                 organizations,
		                                 notes,
		                                 source,
		                                 extension_row]);
		                      },
		                      function(param, cont){
		                       var
		                        extension_row = param[10],
		                        source = param[9],
		                        notes = param[8],
		                        organizations = param[7],
		                        phones = param[6],
		                        address = param[5],
		                        other_emails = param[4],
		                        email = param[3],
		                        name = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0,
		                                  name,
		                                  [0,
		                                   email,
		                                   [0,
		                                    other_emails,
		                                    [0,
		                                     address,
		                                     [0,
		                                      phones,
		                                      [0,
		                                       organizations,
		                                       [0, notes, [0, source, [0, extension_row, 0]]]]]]]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$992[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$992[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$952 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$992, [0, schematic_cache$952]);
		               caml_callback
		                (get_contact_output_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$993 = [];
		               function list_contacts_input_schema_ver
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$993[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgm, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$993[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$993[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$993[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$300[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var limit = param[1];
		                                 return cont([0, limit]);
		                                },
		                                function(param, cont){
		                                 var limit = param[1];
		                                 return cont([0, limit, 0]);
		                                },
		                                [0,
		                                 [0, bgn, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$993[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$993[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$953 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$993, [0, schematic_cache$953]);
		               caml_callback
		                (list_contacts_input_schema_ver, [function(param){return 0;}]);
		               var letrec_function_context$994 = [];
		               function search_contacts_input_schema_v
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$994[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgo, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$994[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$994[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$994[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$301[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var limit = param[2][1], query = param[1];
		                                 return cont([0, query, limit]);
		                                },
		                                function(param, cont){
		                                 var limit = param[2], query = param[1];
		                                 return cont([0, query, [0, limit, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_query,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bgp, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$994[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$994[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$954 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$994, [0, schematic_cache$954]);
		               caml_callback
		                (search_contacts_input_schema_v, [function(param){return 0;}]);
		               function to_summary(p, cont){
		                var a = p[2];
		                return caml_exact_trampoline_cps_call$1
		                        (map$3,
		                         p[5],
		                         function(n, cont){return cont(n[1]);},
		                         function(b){return cont([0, p[1], b, a]);});
		               }
		               function make_get_contact(graph, input, cont){
		                var ctrl = graph[3];
		                return caml_exact_trampoline_cps_call$1
		                        (get$30,
		                         ctrl,
		                         input[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(a){
		                                    if(! a)
		                                     return caml_trampoline_cps_call2(return$12, bgr, cont);
		                                    a = a[1];
		                                    var
		                                     match = a[11],
		                                     extension_row = match[3],
		                                     notes = match[1],
		                                     source = a[10],
		                                     organizations = a[9],
		                                     phones = a[8],
		                                     address = a[6],
		                                     name = a[5],
		                                     other_emails = a[3],
		                                     email = a[2],
		                                     id = a[1],
		                                     open =
		                                       g
		([0,
		  symbol_bind,
		  symbol_map$1,
		  ,
		  bind,
		  return$4,
		  map$3,
		  ,
		  ,
		  ,
		  ,
		  Let_syntax]),
		                                     let$ = open[4];
		                                    return caml_trampoline_cps_call3
		    (let$,
		     name,
		     function(name, cont){return cont(name[1]);},
		     function(name){
		      return caml_exact_trampoline_cps_call$1
		              (map$7,
		               organizations,
		               function(o, cont){return cont([0, o[1], o[2]]);},
		               function(organizations){
		                function b(extension_row, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_supported$0,
		                          notes,
		                          function(a){
		                           var
		                            output =
		                              [0,
		                               id,
		                               name,
		                               email,
		                               other_emails,
		                               address,
		                               phones,
		                               organizations,
		                               a,
		                               source,
		                               extension_row];
		                           return caml_trampoline_cps_call2
		                                   (return$12, [0, output], cont);
		                          });
		                }
		                function a(a){
		                 return caml_trampoline_cps_call2
		                         (return$12,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1(let$46, a, b, cont);
		                          });
		                }
		                if(! extension_row) return a(bgq);
		                var ext_row = extension_row[1];
		                return caml_exact_trampoline_cps_call$0
		                        (get_extension_row,
		                         graph,
		                         3,
		                         ext_row,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$5, b, found, a);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make_list_contacts(ctrl, input, cont){
		                var
		                 content = ctrl[18][1],
		                 peoples = content[3],
		                 Incr = content[1],
		                 a =
		                   g
		                     ([0,
		                       Incr[72],
		                       Incr[73],
		                       ,
		                       Incr[75],
		                       Incr[76],
		                       Incr[77],
		                       ,
		                       ,
		                       ,
		                       ,
		                       Incr[82]])
		                    [4];
		                return caml_trampoline_cps_call3
		                        (a,
		                         peoples[1],
		                         function(by_id, cont){
		                          return caml_exact_trampoline_cps_call(encode, by_id, cont);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_incremental,
		                                   0,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (get$17,
		     a,
		     function(contacts){
		      var limit = value$4(input[1], default_list_limit);
		      return caml_exact_trampoline_cps_call$1
		              (map$7,
		               contacts,
		               to_summary,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (cap,
		                         limit,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2(return$13, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make_search_contacts(ctrl, input, cont){
		                var
		                 query = input[1],
		                 content = ctrl[18][1],
		                 peoples = content[3],
		                 Incr = content[1],
		                 open =
		                   g
		                    ([0,
		                      Incr[72],
		                      Incr[73],
		                      ,
		                      Incr[75],
		                      Incr[76],
		                      Incr[77],
		                      ,
		                      ,
		                      ,
		                      ,
		                      Incr[82]]),
		                 let$ = open[4];
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         query,
		                         function(query_lower){
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   peoples[1],
		                                   function(by_id, cont){
		                                    return caml_exact_trampoline_cps_call
		    (encode,
		     by_id,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (filter,
		               a,
		               function(person, cont){
		                function matches(s, cont){
		                 return caml_exact_trampoline_cps_call
		                         (lowercase_ascii$0,
		                          s,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (is_substring_gen, bPm, a, query_lower, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (matches,
		                         person[2],
		                         function(c){
		                          function b(a){return cont(a);}
		                          if(c) return b(c);
		                          var t = person[3];
		                          function a(t){
		                           function c(a){
		                            if(a) return b(a);
		                            var o = person[5];
		                            if(! o) return cont(0);
		                            var x = o[1];
		                            return caml_exact_trampoline_cps_call(matches, x[1], cont);
		                           }
		                           if(! t) return c(0);
		                           var xs = t[2], x = t[1];
		                           return caml_exact_trampoline_cps_call
		                                   (matches,
		                                    x,
		                                    function(b){
		                                     return b ? c(1) : caml_exact_trampoline_call1(a, xs);
		                                    });
		                          }
		                          return a(t);
		                         });
		               },
		               cont);
		     });
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental,
		     0,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (get$17,
		               a,
		               function(contacts){
		                var limit = value$4(input[2], default_list_limit);
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         contacts,
		                         to_summary,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (cap,
		                                   limit,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call2(return$13, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$27 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$47 = open$27[14],
		                letrec_function_context$995 = [];
		               function event_time_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$995[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgv, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$995[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$995[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$995[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(f0, cont){return cont([0, f0]);},
		                                  function(param, cont){
		                                   if(0 !== param[0]) return cont(0);
		                                   var f0 = param[1];
		                                   return cont([0, f0]);
		                                  },
		                                  1,
		                                  0,
		                                  cst_date,
		                                  cst_Date,
		                                  [0,
		                                   0,
		                                   bgy,
		                                   [7,
		                                    function(param, cont){
		                                     var date = param[1];
		                                     return cont(date);
		                                    },
		                                    function(date, cont){return cont([0, date, 0]);},
		                                    [0,
		                                     [0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      cst_date,
		                                      0,
		                                      2,
		                                      [0, schematic_param_name_schema_ve],
		                                      0,
		                                      0],
		                                     0]],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([1, f0, f1]);
		                                   },
		                                   function(param, cont){
		                                    if(1 !== param[0]) return cont(0);
		                                    var f1 = param[2], f0 = param[1];
		                                    return cont([0, [0, f0, f1]]);
		                                   },
		                                   1,
		                                   0,
		                                   cst_dates,
		                                   cst_Dates,
		                                   [0,
		                                    0,
		                                    bgx,
		                                    [7,
		                                     function(param, cont){
		                                      var end_date = param[2][1], start_date = param[1];
		                                      return cont([0, start_date, end_date]);
		                                     },
		                                     function(param, cont){
		                                      var end_date = param[2], start_date = param[1];
		                                      return cont([0, start_date, [0, end_date, 0]]);
		                                     },
		                                     [0,
		                                      [0,
		                                       0,
		                                       0,
		                                       0,
		                                       0,
		                                       cst_start_date,
		                                       0,
		                                       2,
		                                       [0, schematic_param_name_schema_ve],
		                                       0,
		                                       0],
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_end_date,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       0]]],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([2, f0, f1]);
		                                    },
		                                    function(param, cont){
		                                     if(2 !== param[0]) return cont(0);
		                                     var f1 = param[2], f0 = param[1];
		                                     return cont([0, [0, f0, f1]]);
		                                    },
		                                    1,
		                                    0,
		                                    cst_times,
		                                    cst_Times,
		                                    [0,
		                                     0,
		                                     bgw,
		                                     [7,
		                                      function(param, cont){
		                                       var end_time = param[2][1], start_time = param[1];
		                                       return cont([0, start_time, end_time]);
		                                      },
		                                      function(param, cont){
		                                       var end_time = param[2], start_time = param[1];
		                                       return cont([0, start_time, [0, end_time, 0]]);
		                                      },
		                                      [0,
		                                       [0,
		0,
		0,
		0,
		0,
		cst_start_time,
		0,
		2,
		[0, schematic_param_name_schema_ve],
		0,
		0],
		                                       [0,
		[0,
		 0,
		 0,
		 0,
		 0,
		 cst_end_time,
		 0,
		 2,
		 [0, schematic_param_name_schema_ve],
		 0,
		 0],
		0]]],
		                                     0],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$995[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$995[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$955 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$995, [0, schematic_cache$955]);
		               caml_callback
		                (event_time_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$996 = [];
		               function attendee_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$996[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgz, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$996[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$996[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$996[1][1] = b;
		                            var
		                             default$ = match$302[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_organizer,
		                                 0,
		                                 [0, default$],
		                                 [0, bool_schema],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$303[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    organizer = a[2][1],
		    name = a[1],
		    email = param[1];
		   return cont([0, email, name, organizer]);
		  },
		  function(param, cont){
		   var organizer = param[3], name = param[2], email = param[1];
		   return cont([0, email, [0, name, [0, organizer, 0]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_email,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$996[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$996[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$956 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$996, [0, schematic_cache$956]);
		               caml_callback
		                (attendee_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$997 = [];
		               function get_event_input_schema_version
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$997[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgA, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$997[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$997[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$997[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var event = param[1];
		                       return cont([0, event]);
		                      },
		                      function(param, cont){
		                       var event = param[1];
		                       return cont([0, event, 0]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_event, 0, 2, [0, schema$263], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$997[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$997[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$957 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$997, [0, schematic_cache$957]);
		               caml_callback
		                (get_event_input_schema_version, [function(param){return 0;}]);
		               var letrec_function_context$998 = [];
		               function get_event_output_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$998[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$998[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$998[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$998[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$109,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, "allocationOfTask", 0, 3, [0, b], 0, 0],
		  0];
		                                      return caml_trampoline_cps_call2
		      (schema_versioned$92,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, bgC, 0, 0, 0, cst_extensionRow, 0, 3, [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (supported_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$16,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0, [0, 0, 0, 0, 0, "calendarId", 0, 2, [0, c], 0, 0], a];
		                            return caml_exact_trampoline_cps_call
		                                    (attendee_schema_versioned$1,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_location,
		   0,
		   3,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_description,
		    0,
		    3,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_attendees,
		     0,
		     2,
		     [0, [0, 0, 0, [3, c], 0]],
		     0,
		     0],
		    b]]];
		                                      return caml_exact_trampoline_cps_call
		      (event_time_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              allocation_of_task = h[2][1],
		              extension_row = h[1],
		              notes = g[1],
		              calendar_id = f[1],
		              attendees = e[1],
		              description = d[1],
		              location = c[1],
		              time = b[1],
		              title = a[1],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       title,
		                       time,
		                       location,
		                       description,
		                       attendees,
		                       calendar_id,
		                       notes,
		                       extension_row,
		                       allocation_of_task]);
		            },
		            function(param, cont){
		             var
		              allocation_of_task = param[10],
		              extension_row = param[9],
		              notes = param[8],
		              calendar_id = param[7],
		              attendees = param[6],
		              description = param[5],
		              location = param[4],
		              time = param[3],
		              title = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        title,
		                        [0,
		                         time,
		                         [0,
		                          location,
		                          [0,
		                           description,
		                           [0,
		                            attendees,
		                            [0,
		                             calendar_id,
		                             [0, notes, [0, extension_row, [0, allocation_of_task, 0]]]]]]]]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_title,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0, [0, 0, 0, 0, 0, cst_time, 0, 2, [0, b], 0, 0], a]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$998[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$998[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$958 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$998, [0, schematic_cache$958]);
		               caml_callback
		                (get_event_output_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$999 = [];
		               function event_time_filter_schema_versi
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$999[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgD, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$999[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$999[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$999[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bgJ);},
		                        0,
		                        0,
		                        cst_all,
		                        cst_All,
		                        [0, bc[1], bgI, bc[3], bc[4]],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bgH) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_all_day,
		                         "All_day",
		                         [0, bb[1], bgG, bb[3], bb[4]],
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(bgF) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_timed,
		                          "Timed",
		                          [0, ba[1], bgE, ba[3], ba[4]],
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$999[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$999[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$959 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$999, [0, schematic_cache$959]);
		               caml_callback
		                (event_time_filter_schema_versi, [function(param){return 0;}]);
		               var letrec_function_context$1000 = [];
		               function list_events_input_schema_versi
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1000[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgK, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1000[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1000[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1000[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$304[1],
		                             a =
		                               [0,
		                                [0, bgL, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (event_time_filter_schema_versi,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(b){
		        var
		         default$ = match$305[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              limit = b[2][1],
		              filter = b[1],
		              end_date = a[1],
		              start_date = param[1];
		             return cont([0, start_date, end_date, filter, limit]);
		            },
		            function(param, cont){
		             var
		              limit = param[4],
		              filter = param[3],
		              end_date = param[2],
		              start_date = param[1];
		             return cont
		                     ([0, start_date, [0, end_date, [0, filter, [0, limit, 0]]]]);
		            },
		            [0,
		             [0,
		              bgO,
		              0,
		              0,
		              0,
		              cst_start_date,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bgN,
		               0,
		               0,
		               0,
		               cst_end_date,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                bgM,
		                0,
		                0,
		                0,
		                cst_filter,
		                0,
		                [0, default$],
		                [0, b],
		                0,
		                0],
		               a]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1000[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1000[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$960 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1000, [0, schematic_cache$960]);
		               caml_callback
		                (list_events_input_schema_versi, [function(param){return 0;}]);
		               var letrec_function_context$1001 = [];
		               function event_summary_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1001[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1001[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1001[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1001[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (event_time_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    time = a[2][1],
		    title = a[1],
		    id = param[1];
		   return cont([0, id, title, time]);
		  },
		  function(param, cont){
		   var time = param[3], title = param[2], id = param[1];
		   return cont([0, id, [0, title, [0, time, 0]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_id, 0, 2, [0, schema$263], 0, 0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_title,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0, [0, 0, 0, 0, 0, cst_time, 0, 2, [0, a], 0, 0], 0]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1001[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1001[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$961 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1001, [0, schematic_cache$961]);
		               caml_callback
		                (event_summary_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1002 = [];
		               function create_event_input_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1002[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgQ, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1002[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1002[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1002[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (attendee_schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$306[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_attendees,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$307[1],
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_description,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$308[1],
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_location,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (event_time_schema_versioned,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_title,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_time, 0, 2, [0, c], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$16,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    attendees = d[2][1],
		    description = d[1],
		    location = c[1],
		    time = b[1],
		    title = a[1],
		    calendar = param[1];
		   return cont
		           ([0,
		             calendar,
		             title,
		             time,
		             location,
		             description,
		             attendees]);
		  },
		  function(param, cont){
		   var
		    attendees = param[6],
		    description = param[5],
		    location = param[4],
		    time = param[3],
		    title = param[2],
		    calendar = param[1];
		   return cont
		           ([0,
		             calendar,
		             [0,
		              title,
		              [0,
		               time,
		               [0, location, [0, description, [0, attendees, 0]]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_calendar, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1002[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1002[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$962 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1002, [0, schematic_cache$962]);
		               caml_callback
		                (create_event_input_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var cst_eventId = "eventId", letrec_function_context$1003 = [];
		               function create_event_output_schema_ver
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1003[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgR, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1003[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1003[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1003[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var event_id = param[1];
		                       return cont([0, event_id]);
		                      },
		                      function(param, cont){
		                       var event_id = param[1];
		                       return cont([0, event_id, 0]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_eventId, 0, 2, [0, schema$263], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1003[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1003[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$963 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1003, [0, schematic_cache$963]);
		               caml_callback
		                (create_event_output_schema_ver, [function(param){return 0;}]);
		               var letrec_function_context$1004 = [];
		               function update_event_input_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1004[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgS, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1004[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1004[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1004[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (a,
		       schematic_param_name_schema_ve,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(b){
		                  var
		                   default$ = match$309[1],
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_title, 0, [0, default$], [0, b], 0, 0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (event_time_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (c,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$310[1],
		                   b =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_time, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (supported_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (c,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$311[1],
		                   a =
		                     [0,
		                      [0, bgT, 0, 0, 0, cst_notes, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (c,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$312[1],
		                   b =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_event, 0, 2, [0, schema$263], 0, 0],
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_location,
		                        0,
		                        [0, default$],
		                        [0, c],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (c,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$313[1],
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_description,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (attendee_schema_versioned$1,
		                           schematic_version,
		                           function(c){
		                            var b = [0, 0, 0, [3, c], 0];
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (c,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$314[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        title = e[2][1],
		                        time = e[1],
		                        notes = d[1],
		                        location = c[1],
		                        event = b[1],
		                        description = a[1],
		                        attendees = param[1];
		                       return cont
		                               ([0,
		                                 attendees,
		                                 description,
		                                 event,
		                                 location,
		                                 notes,
		                                 time,
		                                 title]);
		                      },
		                      function(param, cont){
		                       var
		                        title = param[7],
		                        time = param[6],
		                        notes = param[5],
		                        location = param[4],
		                        event = param[3],
		                        description = param[2],
		                        attendees = param[1];
		                       return cont
		                               ([0,
		                                 attendees,
		                                 [0,
		                                  description,
		                                  [0,
		                                   event,
		                                   [0, location, [0, notes, [0, time, [0, title, 0]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_attendees,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1004[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1004[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$964 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1004, [0, schematic_cache$964]);
		               caml_callback
		                (update_event_input_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1005 = [];
		               function set_attendance_input_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1005[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgU, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1005[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1005[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1005[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (yes_no_maybe_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(a){
		        var
		         default$ = match$315[1],
		         res =
		           [7,
		            function(param, cont){
		             var will_attend = param[2][1], event = param[1];
		             return cont([0, event, will_attend]);
		            },
		            function(param, cont){
		             var will_attend = param[2], event = param[1];
		             return cont([0, event, [0, will_attend, 0]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_event, 0, 2, [0, schema$263], 0, 0],
		             [0,
		              [0,
		               0,
		               0,
		               0,
		               0,
		               cst_will_attend,
		               0,
		               [0, default$],
		               [0, a],
		               0,
		               0],
		              0]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1005[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1005[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$965 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1005, [0, schematic_cache$965]);
		               caml_callback
		                (set_attendance_input_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1006 = [];
		               function complete_event_input_schema_ve
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1006[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgV, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1006[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1006[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1006[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var event = param[1];
		                       return cont([0, event]);
		                      },
		                      function(param, cont){
		                       var event = param[1];
		                       return cont([0, event, 0]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_event, 0, 2, [0, schema$263], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1006[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1006[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$966 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1006, [0, schematic_cache$966]);
		               caml_callback
		                (complete_event_input_schema_ve, [function(param){return 0;}]);
		               var letrec_function_context$1007 = [];
		               function delete_event_input_schema_vers
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1007[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bgW, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1007[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1007[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1007[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var event = param[1];
		                       return cont([0, event]);
		                      },
		                      function(param, cont){
		                       var event = param[1];
		                       return cont([0, event, 0]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_event, 0, 2, [0, schema$263], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1007[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1007[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$967 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1007, [0, schematic_cache$967]);
		               caml_callback
		                (delete_event_input_schema_vers, [function(param){return 0;}]);
		               var letrec_function_context$1008 = [];
		               function daytime_range_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1008[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bgX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1008[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1008[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1008[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var end_time = param[2][1], start_time = param[1];
		                                 return cont([0, start_time, end_time]);
		                                },
		                                function(param, cont){
		                                 var end_time = param[2], start_time = param[1];
		                                 return cont([0, start_time, [0, end_time, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bgZ,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_start_time,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bgY,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_end_time,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1008[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1008[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$968 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1008, [0, schematic_cache$968]);
		               caml_callback
		                (daytime_range_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1009 = [];
		               function custom_constraint_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1009[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bg0, , descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1009[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1009[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1009[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (daytime_range_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, bg1, 0, 0, 0, cst_daytime, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (rule_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, bg2, 0, 0, 0, cst_rule, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (constraint_kind_schema_version,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        daytime = a[2][1],
		                        rule = a[1],
		                        kind = param[1];
		                       return cont([0, kind, rule, daytime]);
		                      },
		                      function(param, cont){
		                       var daytime = param[3], rule = param[2], kind = param[1];
		                       return cont([0, kind, [0, rule, [0, daytime, 0]]]);
		                      },
		                      [0, [0, bg3, 0, 0, 0, cst_kind, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1009[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1009[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$969 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1009, [0, schematic_cache$969]);
		               caml_callback
		                (custom_constraint_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1010 = [];
		               function slot_constraint_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1010[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bg4, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1010[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1010[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1010[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (custom_constraint_schema_versi,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){return param ? cont(0) : cont(bg7);},
		    0,
		    0,
		    cst_business_hours,
		    "Business_hours",
		    [0, bd[1], bg6, bd[3], bd[4]],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(! param) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     cst_rule,
		     "Rule",
		     [0, a[1], bg5, a[3], a[4]],
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1010[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1010[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$970 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1010, [0, schematic_cache$970]);
		               caml_callback
		                (slot_constraint_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var
		                cst_duration_minutes = "duration_minutes",
		                letrec_function_context$1011 = [];
		               function find_available_time_slots_inpu
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1011[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bg8, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1011[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1011[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1011[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$316[1],
		                                       a =
		 [0,
		  [0,
		   bg9,
		   0,
		   0,
		   0,
		   cst_start_date,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$317[1],
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_duration_minutes,
		             0,
		             2,
		             [0, int_schema],
		             0,
		             0],
		            [0,
		             [0,
		              bg$,
		              0,
		              0,
		              0,
		              cst_end_date,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bg_,
		               0,
		               0,
		               0,
		               "max_slots",
		               0,
		               [0, default$],
		               [0, c],
		               0,
		               0],
		              a]]];
		        return caml_exact_trampoline_cps_call
		                (slot_constraint_schema_version,
		                 schematic_version,
		                 function(a){
		                  var
		                   default$ = match$318[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        start_date = c[2][1],
		                        max_slots = c[1],
		                        end_date = b[1],
		                        duration_minutes = a[1],
		                        constraints = param[1];
		                       return cont
		                               ([0,
		                                 constraints,
		                                 duration_minutes,
		                                 end_date,
		                                 max_slots,
		                                 start_date]);
		                      },
		                      function(param, cont){
		                       var
		                        start_date = param[5],
		                        max_slots = param[4],
		                        end_date = param[3],
		                        duration_minutes = param[2],
		                        constraints = param[1];
		                       return cont
		                               ([0,
		                                 constraints,
		                                 [0,
		                                  duration_minutes,
		                                  [0, end_date, [0, max_slots, [0, start_date, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bha,
		                        0,
		                        0,
		                        0,
		                        "constraints",
		                        0,
		                        [0, default$],
		                        [0, [0, 0, 0, [3, a], 0]],
		                        0,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1011[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1011[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$971 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1011, [0, schematic_cache$971]);
		               caml_callback
		                (find_available_time_slots_inpu,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1012 = [];
		               function time_slot_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1012[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bhb, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1012[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1012[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1012[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var end = param[2][1], start = param[1];
		                       return cont([0, start, end]);
		                      },
		                      function(param, cont){
		                       var end = param[2], start = param[1];
		                       return cont([0, start, [0, end, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bhd,
		                        0,
		                        0,
		                        0,
		                        cst_start,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bhc,
		                         0,
		                         0,
		                         0,
		                         cst_end,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1012[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1012[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$972 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1012, [0, schematic_cache$972]);
		               caml_callback
		                (time_slot_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1013 = [];
		               function find_available_time_slots_outp
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1013[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bhe, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1013[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1013[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1013[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (time_slot_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var slots = param[1];
		                                 return cont([0, slots]);
		                                },
		                                function(param, cont){
		                                 var slots = param[1];
		                                 return cont([0, slots, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_slots,
		                                  0,
		                                  2,
		                                  [0, [0, 0, 0, [3, a], 0]],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1013[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1013[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$973 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1013, [0, schematic_cache$973]);
		               caml_callback
		                (find_available_time_slots_outp, [function(param){return 0;}]);
		               function event_time_to_schema(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var date = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_string$12,
		                            date,
		                            function(match){
		                             if(0 !== match[0]) return cont(bhf);
		                             var d = match[1];
		                             return cont([0, [0, d]]);
		                            });
		                  case 1:
		                   var end_date = param[2], start_date = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_string$12,
		                            start_date,
		                            function(match){
		                             return caml_exact_trampoline_cps_call
		                                     (of_string$12,
		                                      end_date,
		                                      function(match$0){
		                                       if(0 === match[0]){
		var start = match[1];
		if(0 === match$0[0]){
		 var end = match$0[1];
		 return cont([0, [1, start, end]]);
		}
		                                       }
		                                       return cont(bhg);
		                                      });
		                            });
		                  default:
		                   var end_time = param[2], start_time = param[1];
		                   return caml_exact_trampoline_cps_call
		                           (of_rfc3339$0,
		                            start_time,
		                            function(match){
		                             return caml_exact_trampoline_cps_call
		                                     (of_rfc3339$0,
		                                      end_time,
		                                      function(match$0){
		                                       if(0 === match[0]){
		var start = match[1];
		if(0 === match$0[0]){
		 var end = match$0[1];
		 return cont([0, [2, start, end]]);
		}
		                                       }
		                                       return cont(bhh);
		                                      });
		                            });
		                }
		               }
		               function schema_to_event_time(param, cont){
		                switch(param[0]){
		                  case 0:
		                   var date = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (to_to_string,
		                            pp_v1$0,
		                            date,
		                            function(a){return cont([0, a]);});
		                  case 1:
		                   var end = param[2], start = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (to_to_string,
		                            pp_v1$0,
		                            end,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_to_string,
		                                      pp_v1$0,
		                                      start,
		                                      function(b){return cont([1, b, a]);});
		                            });
		                  default:
		                   var end$0 = param[2], start$0 = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (to_rfc3339$0,
		                            [0, timezone_local],
		                            end$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_rfc3339$0,
		                                      [0, timezone_local],
		                                      start$0,
		                                      function(b){return cont([2, b, a]);});
		                            });
		                }
		               }
		               function attendees_to_map(attendees, cont){
		                var init = empty$11([0, comparator$2]);
		                function a(t, init){
		                 if(! t) return cont(init);
		                 var
		                  l = t[2],
		                  att = t[1],
		                  schema_att = [0, att[1], att[2], att[3], 0];
		                 return caml_exact_trampoline_cps_call$0
		                         (set$3,
		                          init,
		                          att[1],
		                          schema_att,
		                          function(init){
		                           return caml_exact_trampoline_call2(a, l, init);
		                          });
		                }
		                return a(attendees, init);
		               }
		               function map_to_attendees(map, cont){
		                return caml_exact_trampoline_cps_call
		                        (encode,
		                         map,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   a,
		                                   function(att, cont){
		                                    return cont([0, att[1], att[2], att[3]]);
		                                   },
		                                   cont);
		                         });
		               }
		               function make_get_event(graph, ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$25,
		                         ctrl,
		                         input[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(a){
		                                    if(! a)
		                                     return caml_trampoline_cps_call2(return$12, bhj, cont);
		                                    var
		                                     augmented = a[1],
		                                     event = augmented[5],
		                                     a = event[9],
		                                     title = a[11],
		                                     time = a[10],
		                                     task = a[9],
		                                     notes = a[8],
		                                     location = a[7],
		                                     extension_row = a[6],
		                                     description = a[5],
		                                     attendees = a[3];
		                                    function c(extension_row, cont){
		                                     return caml_exact_trampoline_cps_call
		     (to_supported$0,
		      notes,
		      function(b){
		       var a = event[1];
		       return caml_exact_trampoline_cps_call
		               (map_to_attendees,
		                attendees,
		                function(c){
		                 return caml_exact_trampoline_cps_call
		                         (schema_to_event_time,
		                          time,
		                          function(d){
		                           var
		                            output =
		                              [0,
		                               event[6],
		                               title,
		                               d,
		                               location,
		                               description,
		                               c,
		                               a,
		                               b,
		                               extension_row,
		                               task];
		                           return caml_trampoline_cps_call2
		                                   (return$12, [0, output], cont);
		                          });
		                });
		      });
		                                    }
		                                    function b(a){
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$1(let$47, a, c, cont);
		      });
		                                    }
		                                    if(! extension_row) return b(bhi);
		                                    var ext_row = extension_row[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (get_extension_row,
		     graph,
		     1,
		     ext_row,
		     function(a){
		      return caml_exact_trampoline_cps_call$1(map$5, a, found, b);
		     });
		                                   });
		                         });
		               }
		               function make_list_events(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$12,
		                         input[1],
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (of_string$12,
		                                   input[2],
		                                   function(a){
		                                    if(0 === match[0]){
		                                     var start_date = match[1];
		                                     if(0 === a[0]){
		                                      var end_date = a[1], a = input[3];
		                                      a:
		                                      {
		                                       if(a)
		switch(a[1]){
		  case 1:
		   var filter = 0; break a;
		  case 2:
		   filter = 2; break a;
		}
		                                       filter = 1;
		                                      }
		                                      var
		                                       b =
		 function(acc, current){
		  return caml_exact_trampoline_cps_call$1
		          (symbol$82,
		           current,
		           end_date,
		           function(a){
		            return a
		                    ? caml_exact_trampoline_cps_call
		                      (of_rev_keys,
		                       acc,
		                       function(dates){
		                        return caml_exact_trampoline_cps_call$0
		                                (days$2(ctrl),
		                                 1,
		                                 filter,
		                                 dates,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (get$17,
		   a,
		   function(event_ids){
		    var limit = value$4(input[4], default_list_limit);
		    return caml_exact_trampoline_cps_call$1
		            (cap,
		             limit,
		             event_ids,
		             function(result){
		              return caml_exact_trampoline_cps_call$1
		                      (filter_map$0,
		                       result[1],
		                       function(id, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (get$25,
		                                 ctrl,
		                                 id,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call
		  (get$17,
		   a,
		   function(match){
		    if(! match) return cont(0);
		    var augmented = match[1];
		    return caml_exact_trampoline_cps_call
		            (schema_to_event_time,
		             augmented[5][9][10],
		             function(a){
		              return cont([0, [0, id, augmented[5][9][11], a]]);
		             });
		   });
		                                 });
		                       },
		                       function(items){
		                        return caml_trampoline_cps_call2
		                                (return$13, [0, items, result[2], result[3]], cont);
		                       });
		             });
		   });
		                                 });
		                       })
		                    : caml_exact_trampoline_cps_call$1
		                      (add_days,
		                       current,
		                       1,
		                       function(current$0){
		                        var acc$0 = [0, current, acc];
		                        return caml_exact_trampoline_call2(b, acc$0, current$0);
		                       });
		           });
		 };
		                                      return b(0, start_date);
		                                     }
		                                    }
		                                    return caml_trampoline_cps_call2(return$12, bhk, cont);
		                                   });
		                         });
		               }
		               function make_create_event(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call
		                         (event_time_to_schema,
		                          input[3],
		                          function(match){
		                           if(0 === match[0]){
		                            var
		                             time = match[1],
		                             a = input[2],
		                             b = input[4],
		                             c = input[5];
		                            return caml_exact_trampoline_cps_call
		                                    (attendees_to_map,
		                                     input[6],
		                                     function(d){
		                                      var
		                                       writable = [0, 0, 0, d, 0, c, 0, b, bhl, 0, time, a],
		                                       creation = [0, input[1], 0, writable];
		                                      return caml_exact_trampoline_cps_call$0
		      (create$50,
		       ctrl,
		       crdt,
		       creation,
		       function(event_id){
		        return caml_trampoline_cps_call2
		                (return$12, [0, [0, event_id]], cont);
		       });
		                                     });
		                           }
		                           var err = match[1];
		                           return caml_trampoline_cps_call2(return$12, [1, err], cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function make_update_event(graph, ctrl, param, cont){
		                var
		                 title = param[7],
		                 time = param[6],
		                 notes = param[5],
		                 location = param[4],
		                 event = param[3],
		                 description = param[2],
		                 attendees = param[1];
		                function a(crdt, cont){
		                 var match = set_field(time);
		                 function a(time){
		                  return caml_exact_trampoline_cps_call$1
		                          (map$3,
		                           set_field(attendees),
		                           attendees_to_map,
		                           function(attendees){
		                            var
		                             description$0 = set_field(description),
		                             location$0 = set_field(location),
		                             open = g(include$0),
		                             let$ = open[20],
		                             let$0 = open[14];
		                            function a(notes, cont){
		                             var
		                              title$0 = set_field(title),
		                              patch =
		                                [0,
		                                 0,
		                                 0,
		                                 attendees,
		                                 0,
		                                 description$0,
		                                 0,
		                                 location$0,
		                                 notes,
		                                 0,
		                                 time,
		                                 title$0];
		                             return caml_exact_trampoline_cps_call$2
		                                     (update$15,
		                                      ctrl,
		                                      crdt,
		                                      [0, event, patch],
		                                      6,
		                                      function(match){
		                                       if(0 === match[0])
		return caml_trampoline_cps_call2(return$13, 0, cont);
		                                       var err = match[1], variant = err[1];
		                                       return -438114087 <= variant
		       ? caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          id,
		          fmt$216,
		          function(a){
		           return caml_trampoline_cps_call3
		                   (a,
		                    pp_toplevel,
		                    err,
		                    function(a){
		                     return caml_exact_trampoline_cps_call(fail$2, a, cont);
		                    });
		          })
		       : caml_exact_trampoline_cps_call
		         (fail$2, cst_Calendar_is_readonly, cont);
		                                      });
		                            }
		                            function b(notes, cont){
		                             function a(augmented, cont){
		                              var a = [0, augmented[5][9][8]];
		                              return caml_exact_trampoline_cps_call
		                                      (personal_workspace_id$0,
		                                       graph,
		                                       function(b){
		return caml_exact_trampoline_cps_call$2
		        (of_supported$0,
		         graph,
		         b,
		         a,
		         notes,
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (map$5, a, return$4, cont);
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$1
		                                     (get$25,
		                                      ctrl,
		                                      event,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (get$17,
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (let$0, of_option(b, cst_Event_not_found), a, cont);
		        });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call
		                                    (of_string$0,
		                                     set_field(notes),
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call$1
		      (let$,
		       c,
		       b,
		       function(b){
		        return caml_trampoline_cps_call2
		                (return$12,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1(let$47, b, a, cont);
		                 });
		       });
		                                     });
		                           });
		                 }
		                 if(! match) return a(0);
		                 var t = match[1];
		                 return caml_exact_trampoline_cps_call
		                         (event_time_to_schema,
		                          t,
		                          function(match){
		                           if(0 !== match[0]) return a(0);
		                           var time = match[1];
		                           return a([0, time]);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function make_set_attendance(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (set_will_attend$0,
		                          ctrl,
		                          crdt,
		                          input[1],
		                          input[2],
		                          6,
		                          function(match){
		                           if(0 === match[0])
		                            return caml_trampoline_cps_call2(return$12, bhm, cont);
		                           var err = match[1], variant = err[1];
		                           return -438114087 <= variant
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$217,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (a,
		        pp_toplevel,
		        err,
		        function(error_msg){
		         return caml_trampoline_cps_call2
		                 (return$12, [1, error_msg], cont);
		        });
		                                      })
		                                   : caml_trampoline_cps_call2(return$12, bhn, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function make_complete_event(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (complete$1,
		                          ctrl,
		                          crdt,
		                          input[1],
		                          6,
		                          function(match){
		                           if(0 === match[0])
		                            return caml_trampoline_cps_call2(return$12, bho, cont);
		                           var err = match[1], variant = err[1];
		                           return -438114087 <= variant
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$218,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (a,
		        pp_toplevel,
		        err,
		        function(error_msg){
		         return caml_trampoline_cps_call2
		                 (return$12, [1, error_msg], cont);
		        });
		                                      })
		                                   : caml_trampoline_cps_call2(return$12, bhp, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function make_delete_event(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (delete$3,
		                          ctrl,
		                          crdt,
		                          input[1],
		                          6,
		                          function(match){
		                           if(0 === match[0])
		                            return caml_trampoline_cps_call2(return$12, bhq, cont);
		                           var err = match[1], variant = err[1];
		                           return -438114087 <= variant
		                                   ? caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$219,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (a,
		        pp_toplevel,
		        err,
		        function(error_msg){
		         return caml_trampoline_cps_call2
		                 (return$12, [1, error_msg], cont);
		        });
		                                      })
		                                   : caml_trampoline_cps_call2(return$12, bhr, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function parse_daytime(str, cont){
		                var
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$1,
		                      symbol_map$0,
		                      Let_syntax$0,
		                      ,
		                      bind$1,
		                      of_string$0,
		                      map$5]),
		                 let$ = open[3];
		                function a(a, cont){
		                 var
		                  second_str = a[3],
		                  minute_str = a[2],
		                  hour_str = a[1],
		                  a = int_of_string_opt(hour_str),
		                  match = int_of_string_opt(minute_str),
		                  match$0 = int_of_string_opt(second_str);
		                 function c(param, cont){
		                  var
		                   seconds = param[3],
		                   minutes = param[2],
		                   hours = param[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (make$7, hours, minutes, seconds, cont);
		                 }
		                 function b(a){
		                  return caml_trampoline_cps_call3(let$, a, c, cont);
		                 }
		                 if(a && match && match$0){
		                  var seconds = match$0[1], minutes = match[1], hours = a[1];
		                  return b([0, [0, hours, minutes, seconds]]);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$220,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a, str, function(a){return b([1, a]);});
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         str,
		                         58,
		                         function(match){
		                          function d(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          }
		                          if(match){
		                           var b = match[2];
		                           if(b){
		                            var c = b[2];
		                            if(c && ! c[2]){
		                             var
		                              second_str = c[1],
		                              minute_str = b[1],
		                              hour_str = match[1];
		                             return d([0, [0, hour_str, minute_str, second_str]]);
		                            }
		                           }
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$221,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (a, str, function(a){return d([1, a]);});
		                                   });
		                         });
		               }
		               function translate_constraint(ctrl, a, cont){
		                if(! a)
		                 return caml_exact_trampoline_cps_call
		                         (hours_config,
		                          ctrl,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (get$17,
		                                    a,
		                                    function(match){
		                                     var evening_start = match[4], day_start = match[1];
		                                     return cont([0, [0, 0, bhs, [0, day_start, evening_start]]]);
		                                    });
		                          });
		                a = a[1];
		                var
		                 match = a[3],
		                 end_time = match[2],
		                 start_time = match[1],
		                 rule = a[2],
		                 kind = a[1],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$1,
		                      symbol_map$0,
		                      Let_syntax$0,
		                      ,
		                      bind$1,
		                      of_string$0,
		                      map$5]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                function b(start, cont){
		                 function a(end, cont){
		                  var a = [0, start, end];
		                  return caml_exact_trampoline_cps_call
		                          (rule_to_mandate,
		                           rule,
		                           function(b){return cont([0, kind, b, a]);});
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (parse_daytime,
		                          end_time,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (parse_daytime,
		                         start_time,
		                         function(a){
		                          return caml_trampoline_cps_call3(let$0, a, b, cont);
		                         });
		               }
		               function make_find_available_time_slots(ctrl, param, cont){
		                var
		                 start_date = param[5],
		                 max_slots = param[4],
		                 end_date = param[3],
		                 duration_minutes = param[2],
		                 constraints = param[1],
		                 open =
		                   o
		                    ([0,
		                      symbol_bind$1,
		                      symbol_map$0,
		                      Let_syntax$0,
		                      ,
		                      bind$1,
		                      of_string$0,
		                      map$5]),
		                 let$ = open[8],
		                 let$0 = open[4],
		                 let$1 = open[3];
		                function a(constraints, cont){
		                 function a(from, cont){
		                  function a(until, cont){
		                   var
		                    duration = minutes(duration_minutes),
		                    limit = value$4(max_slots, 20);
		                   return caml_exact_trampoline_cps_call$9
		                           (find_available_windows,
		                            ctrl[2],
		                            ctrl[5],
		                            from,
		                            [0, limit],
		                            constraints,
		                            [0, duration],
		                            [0, until],
		                            dummy,
		                            cont);
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (of_string$12,
		                           end_date,
		                           function(t){
		                            var b = 0 === t[0] ? t : [1, "Invalid end_date format"];
		                            return caml_trampoline_cps_call3(let$1, b, a, cont);
		                           });
		                 }
		                 function b(start_date, cont){
		                  function a(start_date, cont){
		                   function a(time, cont){
		                    var t = ocaml_ptime_clock_now_d_ps();
		                    return caml_exact_trampoline_cps_call$1
		                            (max$13, time, t, function(a){return cont([0, a]);});
		                   }
		                   return caml_exact_trampoline_cps_call$0
		                           (to_time$2,
		                            timezone_local,
		                            start_date,
		                            midnight,
		                            function(b){
		                             return caml_trampoline_cps_call3(let$0, b, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (of_string$12,
		                           start_date,
		                           function(t){
		                            var b = 0 === t[0] ? t : [1, "Invalid start_date format"];
		                            return caml_trampoline_cps_call3(let$1, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (of_string$0,
		                          start_date,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$1, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         constraints,
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (translate_constraint, ctrl, a, cont);
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (all$10,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (let$1,
		     b,
		     a,
		     function(result){
		      if(0 === result[0]){
		       var windows = result[1];
		       return caml_exact_trampoline_cps_call$1
		               (map$7,
		                windows,
		                function(param, cont){
		                 var end = param[2], start = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (to_rfc3339$0,
		                          [0, timezone_local],
		                          end,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (to_rfc3339$0,
		                                    [0, timezone_local],
		                                    start,
		                                    function(b){return cont([0, b, a]);});
		                          });
		                },
		                function(slots){
		                 return caml_trampoline_cps_call2
		                         (return$12, [0, [0, slots]], cont);
		                });
		      }
		      var err = result[1];
		      return caml_trampoline_cps_call2(return$12, [1, err], cont);
		     });
		                                   });
		                         });
		               }
		               function make$138(path, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$222,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   "https://open.routine.co",
		                                   path,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_string$19,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2(of_string$14, a, cont);
		     });
		                                   });
		                         });
		               }
		               var letrec_function_context$1014 = [];
		               function build_link_input_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1014[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1014[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1014[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1014[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$131,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1014[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1014[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$974 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1014, [0, schematic_cache$974]);
		               caml_callback
		                (build_link_input_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1015 = [];
		               function build_reference_input_schema_v
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1015[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1015[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1015[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1015[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$555,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1015[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1015[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$975 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1015, [0, schematic_cache$975]);
		               caml_callback
		                (build_reference_input_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               function make_build_link(input, cont){
		                var id$1 = input[1];
		                function b(a){
		                 return caml_trampoline_cps_call2(return$12, a, cont);
		                }
		                switch(id$1[0]){
		                  case 2:
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$224,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$52,
		                                      id$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$225,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$52,
		                                      id$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 4:
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$226,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$52,
		                                      id$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 5:
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$227,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$52,
		                                      id$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 6:
		                   var a = id$1[1], match = a[1];
		                   if(! match) return b(bhB);
		                   var
		                    row_id = a[3],
		                    table_id = a[2],
		                    workspace_id = match[1],
		                    c = include$51[1],
		                    d = Table[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$228,
		                            function(a){
		                             return caml_trampoline_cps_call7
		                                     (a,
		                                      pp$46,
		                                      workspace_id,
		                                      d,
		                                      table_id,
		                                      c,
		                                      row_id,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 7:
		                   var id$0 = id$1[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$229,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$37,
		                                      id$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 8:
		                   a = id$1[1];
		                   var table_id$0 = a[2], workspace_id$0 = a[1], e = Table[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$230,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a,
		                                      pp$46,
		                                      workspace_id$0,
		                                      e,
		                                      table_id$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 9:
		                   a = id$1[1];
		                   var workspace_id$1 = a[2], org_id = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$231,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a,
		                                      pp$37,
		                                      org_id,
		                                      pp$46,
		                                      workspace_id$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 10:
		                   a = id$1[1];
		                   if(0 !== a[2][0])
		                    return caml_exact_trampoline_cps_call
		                            (make$138, "/assistant", b);
		                   var agent_id = a[2];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$232,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$41,
		                                      agent_id,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 11:
		                   a = id$1[1];
		                   var automation_id = a[2], org_id$0 = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$233,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a,
		                                      pp$37,
		                                      org_id$0,
		                                      pp$87,
		                                      automation_id,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 12:
		                   var agent_id$0 = id$1[1][2];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$234,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$41,
		                                      agent_id$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  case 13:
		                   a = id$1[1];
		                   var automation_id$0 = a[2], org_id$1 = a[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$235,
		                            function(a){
		                             return caml_trampoline_cps_call5
		                                     (a,
		                                      pp$37,
		                                      org_id$1,
		                                      pp$87,
		                                      automation_id$0,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                  default:
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$223,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (a,
		                                      pp$52,
		                                      id$1,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call(make$138, a, b);
		                                      });
		                            });
		                }
		               }
		               function make_build_reference(input, cont){
		                var a = input[1];
		                switch(a[0]){
		                  case 0:
		                   var id$0 = a[1], id$9 = [0, id$0]; break;
		                  case 1:
		                   var id$1 = a[1], id$9 = [1, id$1]; break;
		                  case 2:
		                   var id$2 = a[1], id$9 = [2, id$2]; break;
		                  case 3:
		                   var id$3 = a[1], id$9 = [3, id$3]; break;
		                  case 4:
		                   a = a[1];
		                   if(0 === a[0])
		                    var id$4 = a[1], id$9 = [4, [0, object_id(id$4)]];
		                   else
		                    var id$5 = a[1], id$9 = [4, [1, id$5]];
		                   break;
		                  case 5:
		                   var id$6 = a[1], id$9 = [5, id$6]; break;
		                  case 6:
		                   var id$7 = a[1], id$9 = [6, object_id(id$7)]; break;
		                  case 7:
		                   var id$8 = a[1], id$9 = [7, id$8]; break;
		                  case 8:
		                   a = a[1];
		                   var
		                    table_id = a[2],
		                    workspace_id = a[1],
		                    id$9 = [8, [0, workspace_id, table_id]];
		                   break;
		                  case 9:
		                   a = a[1];
		                   var
		                    workspace_id$0 = a[2],
		                    org_id = a[1],
		                    id$9 = [9, [0, org_id, workspace_id$0]];
		                   break;
		                  case 10:
		                   a = a[1];
		                   var
		                    agent_id = a[2],
		                    org_id$0 = a[1],
		                    id$9 = [10, [0, org_id$0, agent_id]];
		                   break;
		                  case 11:
		                   a = a[1];
		                   var
		                    automation_id = a[2],
		                    org_id$1 = a[1],
		                    id$9 = [11, [0, org_id$1, automation_id]];
		                   break;
		                  case 12:
		                   a = a[1];
		                   var
		                    conversation_id = a[3],
		                    agent_id$0 = a[2],
		                    org_id$2 = a[1],
		                    id$9 = [12, [0, org_id$2, agent_id$0, conversation_id]];
		                   break;
		                  default:
		                   a = a[1];
		                   var
		                    automation_run_id = a[3],
		                    automation_id$0 = a[2],
		                    org_id$3 = a[1],
		                    id$9 =
		                      [13, [0, org_id$3, automation_id$0, automation_run_id]];
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$236,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (a,
		                                   pp$52,
		                                   id$9,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (of_string$14,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2(return$12, a, cont);
		     });
		                                   });
		                         });
		               }
		               function schematic_version$136(param, cont){return cont(0);}
		               var
		                e =
		                  caml_callback
		                   (object_schema,
		                    [bhE,
		                     0,
		                     caml_callback
		                      (build_reference_input_schema_v, [schematic_version$136])]),
		                build_reference_tool =
		                  caml_callback
		                   (tool,
		                    ["buildReference",
		                     0,
		                     0,
		                     "\nBuild an inline object reference for a Routine entity.\nReturns the exact `#<reference-id>` token for the supplied Reference ID. Copy\nthe returned token unchanged into rich document content to link to the entity.\n",
		                     read$2(0),
		                     e,
		                     schematic_param_name_schema_ve,
		                     make_build_reference]);
		               function schematic_version$137(param, cont){return cont(0);}
		               var
		                e =
		                  caml_callback
		                   (object_schema,
		                    [bhF,
		                     0,
		                     caml_callback
		                      (build_link_input_schema_versio, [schematic_version$137])]),
		                build_link_tool =
		                  caml_callback
		                   (tool,
		                    ["buildLink",
		                     0,
		                     0,
		                     "\nBuild an open.routine.co URL for a Routine entity (task, event, page, person, or custom object).\nReturns a shareable link that opens the entity in the app.\n",
		                     read$2(0),
		                     e,
		                     schema$262,
		                     make_build_link]),
		                open$28 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$48 = open$28[4],
		                letrec_function_context$1016 = [];
		               function pin_menu_item_input_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1016[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhG, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1016[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1016[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1016[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$317,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var target = param[1];
		   return cont([0, target]);
		  },
		  function(param, cont){
		   var target = param[1];
		   return cont([0, target, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1016[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1016[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$976 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1016, [0, schematic_cache$976]);
		               caml_callback
		                (pin_menu_item_input_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1017 = [];
		               function unpin_menu_item_input_schema_v
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1017[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhH, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1017[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1017[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1017[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$317,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var target = param[1];
		   return cont([0, target]);
		  },
		  function(param, cont){
		   var target = param[1];
		   return cont([0, target, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_target, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1017[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1017[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$977 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1017, [0, schematic_cache$977]);
		               caml_callback
		                (unpin_menu_item_input_schema_v,
		                 [function(param, cont){return cont(0);}]);
		               function make_pin_menu_item(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (append$14,
		                          ctrl,
		                          crdt,
		                          input[1],
		                          function(match){return cont(bhI);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$48, b, a, cont);
		                         });
		               }
		               function make_unpin_menu_item(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (remove$26,
		                          ctrl,
		                          crdt,
		                          input[1],
		                          function(match){return cont(bhJ);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$48, b, a, cont);
		                         });
		               }
		               var letrec_function_context$1018 = [];
		               function notice_filter_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1018[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bhM, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1018[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1018[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1018[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bhQ);},
		                        0,
		                        0,
		                        cst_viewed,
		                        cst_Viewed,
		                        [0, bf[1], bhP, bf[3], bf[4]],
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(bhO) : cont(0);},
		                         0,
		                         0,
		                         cst_unviewed,
		                         cst_Unviewed,
		                         [0, be[1], bhN, be[3], be[4]],
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1018[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1018[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$978 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1018, [0, schematic_cache$978]);
		               caml_callback
		                (notice_filter_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1019 = [];
		               function list_notices_input_schema_vers
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1019[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bhR, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1019[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1019[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1019[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$319[1],
		                             a =
		                               [0,
		                                [0, bhS, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (notice_filter_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(b){
		        var
		         default$ = match$320[1],
		         res =
		           [7,
		            function(param, cont){
		             var limit = param[2][1], filter = param[1];
		             return cont([0, filter, limit]);
		            },
		            function(param, cont){
		             var limit = param[2], filter = param[1];
		             return cont([0, filter, [0, limit, 0]]);
		            },
		            [0,
		             [0,
		              bhT,
		              0,
		              0,
		              0,
		              cst_filter,
		              0,
		              [0, default$],
		              [0, b],
		              0,
		              0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1019[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1019[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$979 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1019, [0, schematic_cache$979]);
		               caml_callback
		                (list_notices_input_schema_vers, [function(param){return 0;}]);
		               var letrec_function_context$1020 = [];
		               function notice_summary_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1020[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhU, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1020[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1020[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1020[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_message,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0, 0, 0, 0, 0, cst_viewed, 0, 2, [0, bool_schema], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$342,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    viewed = a[2][1],
		    message = a[1],
		    id = param[1];
		   return cont([0, id, message, viewed]);
		  },
		  function(param, cont){
		   var viewed = param[3], message = param[2], id = param[1];
		   return cont([0, id, [0, message, [0, viewed, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1020[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1020[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$980 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1020, [0, schematic_cache$980]);
		               caml_callback
		                (notice_summary_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1021 = [];
		               function notice_id_input_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1021[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhV, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1021[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1021[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1021[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$342,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1021[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1021[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$981 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1021, [0, schematic_cache$981]);
		               caml_callback
		                (notice_id_input_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1022 = [];
		               function create_notice_input_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1022[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1022[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1022[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1022[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_message,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_location,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0, [0, 0, 0, 0, 0, cst_recipient, 0, 2, [0, c], 0, 0], a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$120,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              location = b[2][1],
		              message = b[1],
		              recipient = a[1],
		              workspace = param[1];
		             return cont([0, workspace, recipient, message, location]);
		            },
		            function(param, cont){
		             var
		              location = param[4],
		              message = param[3],
		              recipient = param[2],
		              workspace = param[1];
		             return cont
		                     ([0,
		                       workspace,
		                       [0, recipient, [0, message, [0, location, 0]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_workspace, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1022[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1022[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$982 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1022, [0, schematic_cache$982]);
		               caml_callback
		                (create_notice_input_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1023 = [];
		               function notice_output_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1023[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhX, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1023[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1023[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1023[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$120,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_message,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_location,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, 0, 0, 0, 0, cst_viewed, 0, 2, [0, bool_schema], 0, 0],
		    [0, [0, 0, 0, 0, 0, cst_workspaceId, 0, 2, [0, b], 0, 0], 0]]]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$342,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              workspace_id = c[2][1],
		              viewed = c[1],
		              location = b[1],
		              message = a[1],
		              id = param[1];
		             return cont
		                     ([0, id, message, location, viewed, workspace_id]);
		            },
		            function(param, cont){
		             var
		              workspace_id = param[5],
		              viewed = param[4],
		              location = param[3],
		              message = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        message,
		                        [0, location, [0, viewed, [0, workspace_id, 0]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1023[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1023[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$983 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1023, [0, schematic_cache$983]);
		               caml_callback
		                (notice_output_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1024 = [];
		               function create_notice_output_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1024[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bhY, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1024[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1024[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1024[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$342,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var notice_id = param[1];
		   return cont([0, notice_id]);
		  },
		  function(param, cont){
		   var notice_id = param[1];
		   return cont([0, notice_id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, "noticeId", 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1024[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1024[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$984 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1024, [0, schematic_cache$984]);
		               caml_callback
		                (create_notice_output_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               function make_list_notices(ctrl, input, cont){
		                var
		                 match = input[1],
		                 viewed = match ? match[1] ? bhZ : bh0 : 0;
		                return caml_exact_trampoline_cps_call$1
		                        (all$31,
		                         [0, [0, viewed, 0]],
		                         ctrl,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(ids){
		                                    var limit = value$4(input[2], default_list_limit);
		                                    return caml_exact_trampoline_cps_call$1
		    (cap,
		     limit,
		     ids,
		     function(result){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$0,
		               result[1],
		               function(id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$26,
		                         ctrl,
		                         id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(a){
		                                    if(! a) return cont(0);
		                                    var notice = a[1], a = is_some(notice[1][8]);
		                                    return cont([0, [0, id, notice[1][5], a]]);
		                                   });
		                         });
		               },
		               function(items){
		                return caml_trampoline_cps_call2
		                        (return$13, [0, items, result[2], result[3]], cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function make_create_notice(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$19,
		                         input[4],
		                         function(location){
		                          function a(notice_id_opt, cont){
		                           if(! notice_id_opt)
		                            return caml_exact_trampoline_cps_call
		                                    (fail$2, "Failed to create notice", cont);
		                           var notice_id = notice_id_opt[1];
		                           return caml_trampoline_cps_call2
		                                   (return$13, [0, notice_id], cont);
		                          }
		                          return caml_exact_trampoline_cps_call$8
		                                  (create_notice,
		                                   ctrl,
		                                   ctrl[2],
		                                   input[1],
		                                   input[2],
		                                   location,
		                                   0,
		                                   input[3],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (symbol_bind$6, b, a, cont);
		                                   });
		                         });
		               }
		               var cst_Notice_not_found = "Notice not found";
		               function make_mark_notice_viewed(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$26,
		                         ctrl,
		                         input[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fail$2, cst_Notice_not_found, cont);
		                                    var notice = match[1], crdt = ctrl[2];
		                                    function a(param, cont){
		                                     return caml_trampoline_cps_call2(return$13, 0, cont);
		                                    }
		                                    return caml_exact_trampoline_cps_call$3
		    (mark$0,
		     notices_personal_viewed,
		     bO,
		     ctrl,
		     crdt,
		     notice,
		     function(b){
		      return caml_exact_trampoline_cps_call$1
		              (symbol_bind$6, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function make_mark_notice_archived(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$26,
		                         ctrl,
		                         input[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fail$2, cst_Notice_not_found, cont);
		                                    var notice = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (user_id,
		     ctrl[1],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$136,
		               notice[1][6],
		               a,
		               function(b){
		                if(b)
		                 return caml_exact_trampoline_cps_call
		                         (fail$2, cst_Notice_not_found, cont);
		                if(is_some(notice[1][7]))
		                 return caml_trampoline_cps_call2(return$13, 0, cont);
		                var crdt = ctrl[2];
		                function a(param, cont){
		                 return caml_trampoline_cps_call2(return$13, 0, cont);
		                }
		                return caml_exact_trampoline_cps_call$3
		                        (mark$0,
		                         notices_personal_archived,
		                         bP,
		                         ctrl,
		                         crdt,
		                         notice,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make_delete_notice(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$26,
		                         ctrl,
		                         input[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(match){
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fail$2, cst_Notice_not_found, cont);
		                                    var notice = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (user_id,
		     ctrl[1],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol$136,
		               notice[1][6],
		               a,
		               function(b){
		                if(b)
		                 return caml_exact_trampoline_cps_call
		                         (fail$2, cst_Notice_not_found, cont);
		                function a(param, cont){
		                 return caml_trampoline_cps_call2(return$13, 0, cont);
		                }
		                return caml_exact_trampoline_cps_call$3
		                        (delete_mention,
		                         ctrl,
		                         ctrl[2],
		                         input[1],
		                         notice[1][6],
		                         notice[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$29 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$49 = open$29[3],
		                let$50 = open$29[14],
		                letrec_function_context$1025 = [];
		               function get_page_input_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1025[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bh_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1025[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1025[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1025[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$103,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var page = param[1];
		   return cont([0, page]);
		  },
		  function(param, cont){
		   var page = param[1];
		   return cont([0, page, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_page, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1025[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1025[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$985 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1025, [0, schematic_cache$985]);
		               caml_callback
		                (get_page_input_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1026 = [];
		               function get_page_output_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1026[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bh$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1026[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1026[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1026[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (schema_versioned$92,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, bia, 0, 0, 0, cst_extensionRow, 0, 3, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (supported_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_content, 0, 3, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$103,
		                 schematic_version,
		                 function(c){
		                  var
		                   a =
		                     [0,
		                      [0,
		                       0,
		                       0,
		                       0,
		                       0,
		                       cst_children,
		                       0,
		                       2,
		                       [0, [0, 0, 0, [3, c], 0]],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$103,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_title,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0, [0, 0, 0, 0, 0, cst_parent, 0, 3, [0, c], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$103,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    extension_row = d[2][1],
		    content = d[1],
		    children = c[1],
		    parent = b[1],
		    title = a[1],
		    id = param[1];
		   return cont
		           ([0, id, title, parent, children, content, extension_row]);
		  },
		  function(param, cont){
		   var
		    extension_row = param[6],
		    content = param[5],
		    children = param[4],
		    parent = param[3],
		    title = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0,
		              title,
		              [0,
		               parent,
		               [0, children, [0, content, [0, extension_row, 0]]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1026[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1026[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$986 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1026, [0, schematic_cache$986]);
		               caml_callback
		                (get_page_output_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1027 = [];
		               function create_page_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1027[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bib, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1027[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1027[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1027[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$103,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(a){
		        var
		         default$ = match$321[1],
		         res =
		           [7,
		            function(param, cont){
		             var parent = param[2][1], title = param[1];
		             return cont([0, title, parent]);
		            },
		            function(param, cont){
		             var parent = param[2], title = param[1];
		             return cont([0, title, [0, parent, 0]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_title,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, 0, 0, 0, 0, cst_parent, 0, [0, default$], [0, a], 0, 0],
		              0]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1027[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1027[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$987 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1027, [0, schematic_cache$987]);
		               caml_callback
		                (create_page_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1028 = [];
		               function create_page_output_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1028[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bic, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1028[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1028[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1028[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$103,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var page_id = param[1];
		   return cont([0, page_id]);
		  },
		  function(param, cont){
		   var page_id = param[1];
		   return cont([0, page_id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, "pageId", 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1028[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1028[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$988 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1028, [0, schematic_cache$988]);
		               caml_callback
		                (create_page_output_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1029 = [];
		               function parent_input_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1029[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bid, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1029[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1029[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1029[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$103,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  bih,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){return param ? cont(0) : cont(big);},
		    0,
		    0,
		    cst_root,
		    cst_Root,
		    [0,
		     0,
		     bif,
		     [7,
		      function(param, cont){return cont(0);},
		      function(param, cont){return cont(0);},
		      0],
		     0],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(! param) return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     1,
		     0,
		     cst_page,
		     cst_Page,
		     [0,
		      0,
		      bie,
		      [7,
		       function(param, cont){var id = param[1]; return cont(id);},
		       function(id, cont){return cont([0, id, 0]);},
		       [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]],
		      0],
		     0],
		    0]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1029[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1029[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$989 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1029, [0, schematic_cache$989]);
		               caml_callback
		                (parent_input_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1030 = [];
		               function update_page_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1030[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bii, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1030[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1030[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1030[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (supported_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(b){
		                            var
		                             default$ = match$322[1],
		                             a =
		                               [0,
		                                [0,
		                                 bij,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_content,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (parent_input_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (c,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$323[1],
		                             b =
		                               [0,
		                                [0,
		                                 bik,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_parent,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (a,
		       schematic_param_name_schema_ve,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$324[1],
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_title, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$103,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  content = b[2][1],
		                                  parent = b[1],
		                                  title = a[1],
		                                  page = param[1];
		                                 return cont([0, page, title, parent, content]);
		                                },
		                                function(param, cont){
		                                 var
		                                  content = param[4],
		                                  parent = param[3],
		                                  title = param[2],
		                                  page = param[1];
		                                 return cont
		 ([0, page, [0, title, [0, parent, [0, content, 0]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_page, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1030[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1030[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$990 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1030, [0, schematic_cache$990]);
		               caml_callback
		                (update_page_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               function make_get_page(graph, ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$28,
		                         ctrl,
		                         input[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(a){
		                                    if(! a)
		                                     return caml_trampoline_cps_call2(return$12, bim, cont);
		                                    var
		                                     augmented = a[1],
		                                     page = augmented[2][1],
		                                     a = page[3],
		                                     parent = a[5],
		                                     title = a[4],
		                                     extension_row = a[3],
		                                     content = a[2];
		                                    function b(content){
		                                     return caml_exact_trampoline_cps_call
		     (to_list$3,
		      augmented[1],
		      function(children){
		       function b(extension_row, cont){
		        var
		         output =
		           [0,
		            page[2],
		            title,
		            parent,
		            children,
		            content,
		            extension_row];
		        return caml_trampoline_cps_call2
		                (return$12, [0, output], cont);
		       }
		       function a(a){
		        return caml_trampoline_cps_call2
		                (return$12,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1(let$50, a, b, cont);
		                 });
		       }
		       if(! extension_row) return a(bil);
		       var ext_row = extension_row[1];
		       return caml_exact_trampoline_cps_call$0
		               (get_extension_row,
		                graph,
		                2,
		                ext_row,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(map$5, b, found, a);
		                });
		      });
		                                    }
		                                    return is_empty(content[1])
		    ? b(0)
		    : caml_exact_trampoline_cps_call
		      (to_supported$0, content, function(a){return b([0, a]);});
		                                   });
		                         });
		               }
		               function make_create_page(ctrl, input, cont){
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (map$3,
		                          input[2],
		                          function(p, cont){return cont([0, p]);},
		                          function(root){
		                           return caml_exact_trampoline_cps_call$3
		                                   (create$51,
		                                    ctrl,
		                                    crdt,
		                                    input[1],
		                                    root,
		                                    6,
		                                    function(page_id){
		                                     return caml_trampoline_cps_call2
		     (return$12, [0, [0, page_id]], cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$49, b, a, cont);
		                         });
		               }
		               function make_update_page(graph, ctrl, input, cont){
		                function a(crdt, cont){
		                 var open = g(include$0), let$ = open[20], let$0 = open[14];
		                 function a(content, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (map$3,
		                           set_field(input[3]),
		                           function(param, cont){
		                            if(! param) return cont(0);
		                            var id = param[1];
		                            return cont([0, id]);
		                           },
		                           function(parent){
		                            var a = set_field(input[2]);
		                            return caml_exact_trampoline_cps_call$7
		                                    (Patch$2[3],
		                                     0,
		                                     [0, content],
		                                     0,
		                                     a,
		                                     [0, parent],
		                                     dummy,
		                                     function(patch){
		                                      return caml_exact_trampoline_cps_call$3
		      (update$16,
		       ctrl,
		       crdt,
		       input[1],
		       patch,
		       6,
		       function(t){
		        function a(a){
		         return caml_trampoline_cps_call2(return$12, a, cont);
		        }
		        if(0 === t[0]) return a(t);
		        var x = t[1];
		        return caml_exact_trampoline_cps_call$1
		                (to_to_string,
		                 pp_toplevel,
		                 x,
		                 function(b){return a([1, b]);});
		       });
		                                     });
		                           });
		                 }
		                 function b(content, cont){
		                  function a(augmented, cont){
		                   return caml_exact_trampoline_cps_call
		                           (personal_workspace_id$0,
		                            graph,
		                            function(a){
		                             var workspace = value$4(augmented[2][2], a);
		                             return caml_exact_trampoline_cps_call$2
		                                     (of_supported$0,
		                                      graph,
		                                      workspace,
		                                      [0, augmented[2][1][3][2]],
		                                      content,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (map$5, a, return$4, cont);
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (get$28,
		                           ctrl,
		                           input[1],
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (get$17,
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (let$0, of_option(b, cst_Page_not_found), a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (of_string$0,
		                          set_field(input[4]),
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$50, b, a, cont);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$49, b, a, cont);
		                         });
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var letrec_function_context$1031 = [];
		               function object_kind_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1031[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bir, biq, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1031[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1031[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1031[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(0);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && ! param) return cont(biH);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_event,
		                                 cst_Event,
		                                 [0,
		                                  0,
		                                  biG,
		                                  [7,
		                                   function(param, cont){return cont(0);},
		                                   function(param, cont){return cont(0);},
		                                   0],
		                                  0],
		                                 0],
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(1);},
		                                  function(param, cont){
		                                   if(typeof param === "number" && 1 === param)
		                                    return cont(biF);
		                                   return cont(0);
		                                  },
		                                  0,
		                                  0,
		                                  cst_event_recurrent,
		                                  cst_Event_recurrent,
		                                  [0,
		                                   0,
		                                   biE,
		                                   [7,
		                                    function(param, cont){return cont(0);},
		                                    function(param, cont){return cont(0);},
		                                    0],
		                                   0],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(2);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 2 === param)
		                                     return cont(biD);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_page,
		                                   cst_Page,
		                                   [0,
		                                    0,
		                                    biC,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(3);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 3 === param)
		                                      return cont(biB);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_people,
		                                    cst_People,
		                                    [0,
		                                     0,
		                                     biA,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(4);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 4 === param)
		                                       return cont(biz);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_table,
		                                     cst_Table,
		                                     [0,
		                                      0,
		                                      biy,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(param, cont){return cont(5);},
		                                      function(param, cont){
		                                       if(typeof param === "number" && 5 === param)
		return cont(bix);
		                                       return cont(0);
		                                      },
		                                      0,
		                                      0,
		                                      cst_task,
		                                      cst_Task,
		                                      [0,
		                                       0,
		                                       biw,
		                                       [7,
		function(param, cont){return cont(0);},
		function(param, cont){return cont(0);},
		0],
		                                       0],
		                                      0],
		                                     [0,
		                                      [0,
		                                       function(param, cont){return cont(6);},
		                                       function(param, cont){
		if(typeof param === "number" && 6 === param)
		 return cont(biv);
		return cont(0);
		                                       },
		                                       0,
		                                       0,
		                                       cst_task_recurrent,
		                                       cst_Task_recurrent,
		                                       [0,
		0,
		biu,
		[7,
		 function(param, cont){return cont(0);},
		 function(param, cont){return cont(0);},
		 0],
		0],
		                                       0],
		                                      [0,
		                                       [0,
		function(param, cont){return cont(7);},
		function(param, cont){
		 if(typeof param === "number" && 7 <= param)
		  return cont(bit);
		 return cont(0);
		},
		0,
		0,
		cst_workspace,
		cst_Workspace,
		[0,
		 0,
		 bis,
		 [7,
		  function(param, cont){return cont(0);},
		  function(param, cont){return cont(0);},
		  0],
		 0],
		0],
		                                       0]]]]]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (table_id_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  biJ,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(typeof param === "number") return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_custom_table,
		    cst_Custom_table,
		    [0,
		     0,
		     biI,
		     [7,
		      function(param, cont){
		       var table = param[1];
		       return cont(table);
		      },
		      function(table, cont){return cont([0, table, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_table, 0, 2, [0, b], 0, 0], 0]],
		     0],
		    0],
		   a],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1031[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1031[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$991 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1031, [0, schematic_cache$991]);
		               caml_callback
		                (object_kind_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function controller_kind_of_object_kind(param, cont){
		                if(typeof param === "number")
		                 switch(param){
		                   case 0:
		                    return cont(0);
		                   case 1:
		                    return cont(1);
		                   case 2:
		                    return cont(2);
		                   case 3:
		                    return cont(3);
		                   case 4:
		                    return cont(7);
		                   case 5:
		                    return cont(4);
		                   case 6:
		                    return cont(5);
		                   default: return cont(8);
		                 }
		                var table = param[1];
		                return cont([0, 0, table]);
		               }
		               var letrec_function_context$1032 = [];
		               function search_input_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1032[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, biK, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1032[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1032[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1032[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$325[1],
		                                       a =
		 [0,
		  [0, biL, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (object_kind_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$326[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        limit = a[2][1],
		                        kind = a[1],
		                        query = param[1];
		                       return cont([0, query, kind, limit]);
		                      },
		                      function(param, cont){
		                       var limit = param[3], kind = param[2], query = param[1];
		                       return cont([0, query, [0, kind, [0, limit, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_query,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, biM, 0, 0, 0, cst_kind, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1032[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1032[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$992 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1032, [0, schematic_cache$992]);
		               caml_callback
		                (search_input_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1033 = [];
		               function search_result_schema_versioned
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1033[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, biN, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1033[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1033[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1033[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 biP,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_title,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  biO,
		                                  0,
		                                  0,
		                                  0,
		                                  "matchedText",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$131,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    match_content = a[2][1],
		    title = a[1],
		    id = param[1];
		   return cont([0, id, title, match_content]);
		  },
		  function(param, cont){
		   var
		    match_content = param[3],
		    title = param[2],
		    id = param[1];
		   return cont([0, id, [0, title, [0, match_content, 0]]]);
		  },
		  [0, [0, biQ, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1033[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1033[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$993 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1033, [0, schematic_cache$993]);
		               caml_callback
		                (search_result_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function make_search(ctrl, input, cont){
		                var limit = value$4(input[3], 20);
		                return caml_exact_trampoline_cps_call$1
		                        (map$3,
		                         input[2],
		                         controller_kind_of_object_kind,
		                         function(kind){
		                          return caml_exact_trampoline_cps_call$3
		                                  (search$0,
		                                   0,
		                                   kind,
		                                   [0, limit],
		                                   input[1],
		                                   ctrl[21],
		                                   function(results){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$7,
		     results,
		     function(elt, cont){
		      return cont([0, elt[1][2], elt[2], elt[3]]);
		     },
		     function(output){
		      return caml_trampoline_cps_call2
		              (return$12, [0, output], cont);
		     });
		                                   });
		                         });
		               }
		               var
		                open$30 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$51 = open$30[14],
		                letrec_function_context$1034 = [];
		               function scheduled_date_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1034[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, biS, , descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1034[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1034[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1034[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var date = param[1];
		                                 return cont([0, date]);
		                                },
		                                function(param, cont){
		                                 var date = param[1];
		                                 return cont([0, date, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  biT,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_date,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1034[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1034[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$994 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1034, [0, schematic_cache$994]);
		               caml_callback
		                (scheduled_date_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1035 = [];
		               function scheduled_week_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1035[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, biU, , descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1035[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1035[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1035[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var week = param[1];
		                                 return cont([0, week]);
		                                },
		                                function(param, cont){
		                                 var week = param[1];
		                                 return cont([0, week, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  biV,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_week,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1035[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1035[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$995 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1035, [0, schematic_cache$995]);
		               caml_callback
		                (scheduled_week_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1036 = [];
		               function scheduled_input_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1036[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, biX, biW, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1036[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1036[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1036[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (scheduled_week_schema_versione,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       b =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   0,
		   0,
		   cst_week,
		   cst_Week,
		   [0, a[1], biY, a[3], a[4]],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (scheduled_date_schema_versione,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [11,
		            0,
		            [0,
		             [0,
		              function(f0, cont){return cont([0, f0]);},
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f0 = param[1];
		               return cont([0, f0]);
		              },
		              0,
		              0,
		              cst_date,
		              cst_Date,
		              [0, a[1], biZ, a[3], a[4]],
		              0],
		             b],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1036[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1036[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$996 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1036, [0, schematic_cache$996]);
		               caml_callback
		                (scheduled_input_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1037 = [];
		               function task_status_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1037[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bi0, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1037[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1037[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1037[1][1] = a;
		                            var
		                             res =
		                               [11,
		                                0,
		                                [0,
		                                 [0,
		                                  function(param, cont){return cont(0);},
		                                  function(param, cont){return param ? cont(0) : cont(bi6);},
		                                  0,
		                                  0,
		                                  cst_todo,
		                                  cst_Todo,
		                                  [0, bi[1], bi5, bi[3], bi[4]],
		                                  0],
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    return 1 === param ? cont(bi4) : cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_completed,
		                                   cst_Completed,
		                                   [0, bh[1], bi3, bh[3], bh[4]],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     return 2 <= param ? cont(bi2) : cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_discarded,
		                                    cst_Discarded,
		                                    [0, bg[1], bi1, bg[3], bg[4]],
		                                    0],
		                                   0]]],
		                                0];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1037[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1037[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$997 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1037, [0, schematic_cache$997]);
		               caml_callback
		                (task_status_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1038 = [];
		               function assignee_input_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1038[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bi8, bi7, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1038[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1038[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1038[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 function(param, cont){return cont(1);},
		                                 function(param, cont){
		                                  if(typeof param === "number" && param) return cont(bi_);
		                                  return cont(0);
		                                 },
		                                 0,
		                                 0,
		                                 cst_unassigned,
		                                 "Unassigned",
		                                 [0, bj[1], bi9, bj[3], bj[4]],
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [11,
		  0,
		  [0,
		   [0,
		    function(param, cont){return cont(0);},
		    function(param, cont){
		     if(typeof param === "number" && ! param) return cont(bjb);
		     return cont(0);
		    },
		    0,
		    0,
		    cst_me,
		    "Me",
		    [0, bk[1], bja, bk[3], bk[4]],
		    0],
		   [0,
		    [0,
		     function(f0, cont){return cont([0, f0]);},
		     function(param, cont){
		      if(typeof param === "number") return cont(0);
		      var f0 = param[1];
		      return cont([0, f0]);
		     },
		     0,
		     0,
		     cst_member,
		     cst_Member,
		     [0, b[1], bi$, b[3], b[4]],
		     0],
		    a]],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1038[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1038[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$998 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1038, [0, schematic_cache$998]);
		               caml_callback
		                (assignee_input_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1039 = [];
		               function get_task_input_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1039[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1039[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1039[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1039[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$129,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var task = param[1];
		   return cont([0, task]);
		  },
		  function(param, cont){
		   var task = param[1];
		   return cont([0, task, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1039[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1039[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$999 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1039, [0, schematic_cache$999]);
		               caml_callback
		                (get_task_input_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1040 = [];
		               function get_task_output_schema_version
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1040[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjd, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1040[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1040[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1040[1][1] = a;
		                            return caml_trampoline_cps_call2
		                                    (schema_versioned$92,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0, bje, 0, 0, 0, cst_extensionRow, 0, 3, [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$117,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$327[1],
		                   b =
		                     [0,
		                      [0,
		                       bjf,
		                       0,
		                       0,
		                       0,
		                       cst_assignee,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schema_versioned$182(),
		                           function(c){
		                            var
		                             default$ = match$328[1],
		                             a =
		                               [0,
		                                [0,
		                                 bjg,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_parent,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (supported_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_title,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0, 0, 0, 0, 0, cst_starred, 0, 2, [0, bool_schema], 0, 0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_scheduled,
		     0,
		     3,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0, 0, 0, 0, 0, cst_completed, 0, 2, [0, bool_schema], 0, 0],
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       "allocationIds",
		       0,
		       2,
		       [0, [0, 0, 0, [3, schema$263], 0]],
		       0,
		       0],
		      [0,
		       [0, bji, 0, 0, 0, "contextUrl", 0, 3, [0, schema$262], 0, 0],
		       [0, [0, bjh, 0, 0, 0, cst_notes, 0, 2, [0, c], 0, 0], a]]]]]]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$129,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              i = h[2],
		              extension_row = i[2][1],
		              assignee = i[1],
		              parent = h[1],
		              notes = g[1],
		              url = f[1],
		              allocation_ids = e[1],
		              completed = d[1],
		              scheduled = c[1],
		              starred = b[1],
		              title = a[1],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       title,
		                       starred,
		                       scheduled,
		                       completed,
		                       allocation_ids,
		                       url,
		                       notes,
		                       parent,
		                       assignee,
		                       extension_row]);
		            },
		            function(param, cont){
		             var
		              extension_row = param[11],
		              assignee = param[10],
		              parent = param[9],
		              notes = param[8],
		              url = param[7],
		              allocation_ids = param[6],
		              completed = param[5],
		              scheduled = param[4],
		              starred = param[3],
		              title = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        title,
		                        [0,
		                         starred,
		                         [0,
		                          scheduled,
		                          [0,
		                           completed,
		                           [0,
		                            allocation_ids,
		                            [0,
		                             url,
		                             [0,
		                              notes,
		                              [0, parent, [0, assignee, [0, extension_row, 0]]]]]]]]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1040[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1040[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1000 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1040, [0, schematic_cache$1000]);
		               caml_callback
		                (get_task_output_schema_version,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1041 = [];
		               function create_task_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1041[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjj, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1041[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1041[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1041[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (assignee_input_schema_versione,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(b){
		        var
		         default$ = match$329[1],
		         a =
		           [0,
		            [0,
		             bjk,
		             0,
		             0,
		             0,
		             cst_assignee,
		             0,
		             [0, default$],
		             [0, b],
		             0,
		             0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schema_versioned$182(),
		                 function(c){
		                  var
		                   default$ = match$330[1],
		                   b =
		                     [0,
		                      [0,
		                       bjl,
		                       0,
		                       0,
		                       0,
		                       cst_parent,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (scheduled_input_schema_version,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(c){
		                                      var
		                                       default$ = match$331[1],
		                                       default$0 = match$332[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_title,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_starred,
		    0,
		    [0, default$0],
		    [0, bool_schema],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_scheduled,
		     0,
		     [0, default$],
		     [0, c],
		     0,
		     0],
		    b]]];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              assignee = d[2][1],
		              parent = d[1],
		              scheduled = c[1],
		              starred = b[1],
		              title = a[1],
		              workspace = param[1];
		             return cont
		                     ([0, workspace, title, starred, scheduled, parent, assignee]);
		            },
		            function(param, cont){
		             var
		              assignee = param[6],
		              parent = param[5],
		              scheduled = param[4],
		              starred = param[3],
		              title = param[2],
		              workspace = param[1];
		             return cont
		                     ([0,
		                       workspace,
		                       [0,
		                        title,
		                        [0, starred, [0, scheduled, [0, parent, [0, assignee, 0]]]]]]);
		            },
		            [0, [0, bjm, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1041[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1041[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1001 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1041, [0, schematic_cache$1001]);
		               caml_callback
		                (create_task_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var cst_taskId = "taskId", letrec_function_context$1042 = [];
		               function create_task_output_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1042[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjn, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1042[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1042[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1042[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$129,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var task_id = param[1];
		   return cont([0, task_id]);
		  },
		  function(param, cont){
		   var task_id = param[1];
		   return cont([0, task_id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_taskId, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1042[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1042[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1002 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1042, [0, schematic_cache$1002]);
		               caml_callback
		                (create_task_output_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1043 = [];
		               function update_task_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1043[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjo, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1043[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1043[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1043[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (supported_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(b){
		                            var
		                             default$ = match$333[1],
		                             a =
		                               [0,
		                                [0, bjp, 0, 0, 0, cst_notes, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (assignee_input_schema_versione,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (c,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$334[1],
		                             b =
		                               [0,
		                                [0,
		                                 bjq,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assignee,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (task_status_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (c,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(c){
		                            var
		                             default$ = match$335[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_status, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schema_versioned$182(),
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (c,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$336[1],
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_parent, 0, [0, default$], [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (scheduled_input_schema_version,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (update_schema_versioned,
		                 schematic_version,
		                 function(c){
		                  return caml_exact_trampoline_cps_call
		                          (c,
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(c){
		                                      var
		                                       default$ = match$337[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_scheduled,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 bool_schema,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$338[1],
		                             b =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_starred, 0, [0, default$], [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (a,
		       schematic_param_name_schema_ve,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$339[1],
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_title, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$129,
		                           schematic_version,
		                           function(b){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  notes = f[2][1],
		                                  assignee = f[1],
		                                  status = e[1],
		                                  parent = d[1],
		                                  scheduled = c[1],
		                                  starred = b[1],
		                                  title = a[1],
		                                  task = param[1];
		                                 return cont
		 ([0,
		   task,
		   title,
		   starred,
		   scheduled,
		   parent,
		   status,
		   assignee,
		   notes]);
		                                },
		                                function(param, cont){
		                                 var
		                                  notes = param[8],
		                                  assignee = param[7],
		                                  status = param[6],
		                                  parent = param[5],
		                                  scheduled = param[4],
		                                  starred = param[3],
		                                  title = param[2],
		                                  task = param[1];
		                                 return cont
		 ([0,
		   task,
		   [0,
		    title,
		    [0,
		     starred,
		     [0,
		      scheduled,
		      [0, parent, [0, status, [0, assignee, [0, notes, 0]]]]]]]]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, b], 0, 0], a]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1043[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1043[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1003 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1043, [0, schematic_cache$1003]);
		               caml_callback
		                (update_task_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1044 = [];
		               function list_unplanned_tasks_input_sch
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1044[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1044[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1044[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1044[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$340[1],
		                                       a =
		 [0,
		  [0, bjs, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var limit = param[2][1], workspace = param[1];
		             return cont([0, workspace, limit]);
		            },
		            function(param, cont){
		             var limit = param[2], workspace = param[1];
		             return cont([0, workspace, [0, limit, 0]]);
		            },
		            [0, [0, bjt, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1044[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1044[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1004 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1044, [0, schematic_cache$1004]);
		               caml_callback
		                (list_unplanned_tasks_input_sch,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1045 = [];
		               function list_todays_tasks_input_schema
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1045[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bju, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1045[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1045[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1045[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$341[1],
		                                       a =
		 [0,
		  [0, bjv, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var limit = param[2][1], workspace = param[1];
		             return cont([0, workspace, limit]);
		            },
		            function(param, cont){
		             var limit = param[2], workspace = param[1];
		             return cont([0, workspace, [0, limit, 0]]);
		            },
		            [0, [0, bjw, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1045[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1045[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1005 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1045, [0, schematic_cache$1005]);
		               caml_callback
		                (list_todays_tasks_input_schema,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1046 = [];
		               function list_tasks_input_schema_versio
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1046[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjx, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1046[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1046[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1046[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$342[1],
		                                       a =
		 [0,
		  [0, bjy, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (workspace_id_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var limit = param[2][1], workspace = param[1];
		             return cont([0, workspace, limit]);
		            },
		            function(param, cont){
		             var limit = param[2], workspace = param[1];
		             return cont([0, workspace, [0, limit, 0]]);
		            },
		            [0, [0, bjz, 0, 0, 0, cst_workspace, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1046[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1046[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1006 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1046, [0, schematic_cache$1006]);
		               caml_callback
		                (list_tasks_input_schema_versio,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1047 = [];
		               function generalized_task_summary_schem
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1047[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1047[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1047[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1047[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$343[1],
		                                       a =
		 [0,
		  [0, 0, 0, 0, 0, cst_title, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$129,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var title = param[2][1], id = param[1];
		             return cont([0, id, title]);
		            },
		            function(param, cont){
		             var title = param[2], id = param[1];
		             return cont([0, id, [0, title, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1047[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1047[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1007 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1047, [0, schematic_cache$1007]);
		               caml_callback
		                (generalized_task_summary_schem,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1048 = [];
		               function list_tasks_output_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1048[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1048[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1048[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1048[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (generalized_task_summary_schem,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (capped_list_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(b){
		                  var
		                   a = [0, [0, 0, 0, 0, 0, cst_other, 0, 2, [0, b], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (generalized_task_summary_schem,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (capped_list_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (c,
		       b,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var other = param[2][1], todo = param[1];
		             return cont([0, todo, other]);
		            },
		            function(param, cont){
		             var other = param[2], todo = param[1];
		             return cont([0, todo, [0, other, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_todo, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1048[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1048[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1008 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1048, [0, schematic_cache$1008]);
		               caml_callback
		                (list_tasks_output_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1049 = [];
		               function allocate_task_input_schema_ver
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1049[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1049[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1049[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1049[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_duration_minutes,
		                                 0,
		                                 2,
		                                 [0, int_schema],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$344[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_date,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_start_time,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$129,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              duration_minutes = b[2][1],
		              start_time = b[1],
		              date = a[1],
		              task = param[1];
		             return cont([0, task, date, start_time, duration_minutes]);
		            },
		            function(param, cont){
		             var
		              duration_minutes = param[4],
		              start_time = param[3],
		              date = param[2],
		              task = param[1];
		             return cont
		                     ([0,
		                       task,
		                       [0, date, [0, start_time, [0, duration_minutes, 0]]]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1049[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1049[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1009 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1049, [0, schematic_cache$1009]);
		               caml_callback
		                (allocate_task_input_schema_ver,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1050 = [];
		               function allocate_task_output_schema_ve
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1050[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bjD, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1050[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1050[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1050[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var event_id = param[1];
		                       return cont([0, event_id]);
		                      },
		                      function(param, cont){
		                       var event_id = param[1];
		                       return cont([0, event_id, 0]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_eventId, 0, 3, [0, schema$263], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1050[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1050[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1010 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1050, [0, schematic_cache$1010]);
		               caml_callback
		                (allocate_task_output_schema_ve, [function(param){return 0;}]);
		               var letrec_function_context$1051 = [];
		               function delete_task_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1051[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bjE, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1051[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1051[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1051[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$129,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var task = param[1];
		   return cont([0, task]);
		  },
		  function(param, cont){
		   var task = param[1];
		   return cont([0, task, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_task, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1051[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1051[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1011 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1051, [0, schematic_cache$1011]);
		               caml_callback
		                (delete_task_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               function parse_scheduled(a, cont){
		                if(! a) return cont(bjF);
		                a = a[1];
		                if(0 === a[0]){
		                 var date = a[1][1];
		                 return caml_exact_trampoline_cps_call
		                         (of_string$12,
		                          date,
		                          function(match){
		                           if(0 === match[0]){
		                            var date$0 = match[1];
		                            return cont([0, [0, [1, date$0]]]);
		                           }
		                           var err = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$237,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (a, date, err, function(a){return cont([1, a]);});
		                                    });
		                          });
		                }
		                var week = a[1][1];
		                return caml_exact_trampoline_cps_call
		                        (of_string$13,
		                         week,
		                         function(match){
		                          if(0 === match[0]){
		                           var week$0 = match[1];
		                           return cont([0, [0, [0, week$0]]]);
		                          }
		                          var err = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$238,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (a, week, err, function(a){return cont([1, a]);});
		                                   });
		                         });
		               }
		               function is_personal_workspace(graph, workspace, cont){
		                return caml_exact_trampoline_cps_call
		                        (personal_workspace_id$0,
		                         graph,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139, workspace, a, cont);
		                         });
		               }
		               function member_relation_result(member_id, cont){
		                function obj(fields, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (of_alist_exn$1,
		                          [0, comparator$2],
		                          fields,
		                          function(a){return cont([6, a]);});
		                }
		                return caml_exact_trampoline_cps_call
		                        (to_string$44,
		                         member_id,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (obj,
		                                   [0, [0, cst_id, [7, a]], 0],
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (obj, [0, [0, cst_routine$0, a], 0], cont);
		                                   });
		                         });
		               }
		               function member_relation_column(db, cont){
		                function a(b){
		                 if(! b) return cont(0);
		                 var l = b[2], fwo = b[1], b = fwo[1][5];
		                 a:
		                 {
		                  if(typeof b !== "number" && 3 === b[0]){
		                   b = b[1][1];
		                   if(0 !== b[0] && ! b[1]){var r = [0, fwo[1][3]]; break a;}
		                  }
		                  r = 0;
		                 }
		                 return r ? cont(r) : caml_exact_trampoline_call1(a, l);
		                }
		                return caml_exact_trampoline_cps_call(encode, db[6][1], a);
		               }
		               var
		                assignment_only_org_error =
		                  "Assigning tasks is only supported in organization workspaces.";
		               function resolve_assignee(ctrl, workspace, assignee, cont){
		                if(typeof assignee === "number")
		                 return assignee
		                         ? cont(bjG)
		                         : caml_exact_trampoline_cps_call
		                           (user_id, ctrl[1], function(a){return cont([0, [0, a]]);});
		                var id$0 = assignee[1];
		                return caml_exact_trampoline_cps_call$1
		                        (get_organization,
		                         ctrl,
		                         workspace,
		                         function(match){
		                          if(! match) return cont([1, assignment_only_org_error]);
		                          var org = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (mem$5,
		                                   org[1],
		                                   id$0,
		                                   function(a){
		                                    return a
		    ? cont([0, [0, id$0]])
		    : caml_exact_trampoline_cps_call
		      (to_string$44,
		       id$0,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (kasprintf,
		                 id,
		                 fmt$239,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (b, a, function(a){return cont([1, a]);});
		                 });
		       });
		                                   });
		                         });
		               }
		               function read_object_assignee(graph, object_id, cont){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$5,
		                       symbol_map$5,
		                       ,
		                       bind$8,
		                       return$9,
		                       map$17,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$3])
		                    [3];
		                return caml_trampoline_cps_call3
		                        (a,
		                         object_id[1],
		                         function(workspace, cont){
		                          function b(db, cont){
		                           function b(column, cont){
		                            function b(object, cont){
		                             function field(key, param, cont){
		                              if(typeof param !== "number" && 6 === param[0]){
		                               var value = param[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (find_packed_by_id, value, key, cont);
		                              }
		                              return cont(0);
		                             }
		                             return caml_exact_trampoline_cps_call$1
		                                     (field,
		                                      column,
		                                      object[2],
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (bind$8,
		        a,
		        function(a, cont){
		         return caml_exact_trampoline_cps_call$1
		                 (field, cst_routine$0, a, cont);
		        },
		        function(a){
		         return caml_trampoline_cps_call3
		                 (bind$8,
		                  a,
		                  function(a, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (field, cst_id, a, cont);
		                  },
		                  function(a){
		                   if(a){
		                    a = a[1];
		                    if(typeof a !== "number" && 7 === a[0]){
		                     var id = a[1];
		                     return caml_exact_trampoline_cps_call
		                             (of_string$36, id, function(a){return cont(ok$0(a));});
		                    }
		                   }
		                   return cont(0);
		                  });
		        });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (get$31,
		                                     graph,
		                                     object_id,
		                                     function(c){
		                                      return caml_exact_trampoline_cps_call
		      (get$17,
		       c,
		       function(c){
		        return caml_trampoline_cps_call3(a, ok$0(c), b, cont);
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (member_relation_column,
		                                    db,
		                                    function(c){
		                                     return caml_trampoline_cps_call3(a, c, b, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (get_database,
		                                   graph,
		                                   workspace,
		                                   object_id[2],
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (get$17,
		     c,
		     function(c){
		      return caml_trampoline_cps_call3(a, c, b, cont);
		     });
		                                   });
		                         },
		                         cont);
		               }
		               function personal_ids(ids, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter,
		                         ids,
		                         function(param, cont){
		                          return 0 === param[0] ? cont(0) : cont(1);
		                         },
		                         cont);
		               }
		               function org_task_objects(graph, workspace, cont){
		                return caml_trampoline_cps_call2
		                        (graph[26],
		                         0,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (filter,
		     a,
		     function(a, cont){
		      var id = a[1];
		      if(0 === id[0]){
		       a = id[1][1];
		       if(a){
		        var w = a[1];
		        return caml_exact_trampoline_cps_call$1
		                (symbol$139, w, workspace, cont);
		       }
		      }
		      return cont(0);
		     },
		     cont);
		                                   });
		                         });
		               }
		               function make_task_group(graph, ctrl, ids, limit, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (cap,
		                         limit,
		                         ids,
		                         function(result){
		                          var a = result[3], b = result[2];
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   result[1],
		                                   function(id, cont){
		                                    if(0 === id[0]){
		                                     var object_id = id[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (display_value,
		      graph,
		      object_id,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (get$17,
		                a,
		                function(match){
		                 if(0 !== match[0]) return cont([0, id, 0]);
		                 var title = match[1];
		                 return cont([0, id, [0, title]]);
		                });
		      });
		                                    }
		                                    var task_id = id[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (get$22,
		     ctrl,
		     task_id,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (get$17,
		               a,
		               function(match){
		                if(! match) return cont([0, id, 0]);
		                var augmented = match[1];
		                return cont([0, id, [0, augmented[2][7][9][2]]]);
		               });
		     });
		                                   },
		                                   function(c){return cont([0, c, b, a]);});
		                         });
		               }
		               function make_list_unplanned(graph, ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (is_personal_workspace,
		                         graph,
		                         input[1],
		                         function(b){
		                          function a(ids){
		                           var limit = value$4(input[2], default_list_limit);
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_task_group,
		                                    graph,
		                                    ctrl,
		                                    ids,
		                                    limit,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, [0, a], cont);
		                                    });
		                          }
		                          return b
		                                  ? caml_exact_trampoline_cps_call
		                                    (unplanned,
		                                     graph,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (get$17,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call(personal_ids, b, a);
		       });
		                                     })
		                                  : caml_exact_trampoline_cps_call$1
		                                    (org_task_objects,
		                                     graph,
		                                     input[1],
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (filter_map$0,
		       b,
		       function(param, cont){
		        var is_todo = param[3], scheduled = param[2], id = param[1];
		        if(is_todo && is_none$0(scheduled)) return cont([0, id]);
		        return cont(0);
		       },
		       a);
		                                     });
		                         });
		               }
		               function make_list_todays(graph, ctrl, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (today,
		                         dummy,
		                         function(today){
		                          var limit = value$4(input[2], default_list_limit);
		                          return caml_exact_trampoline_cps_call$1
		                                  (is_personal_workspace,
		                                   graph,
		                                   input[1],
		                                   function(b){
		                                    function a(output){
		                                     return caml_trampoline_cps_call2
		     (return$12, [0, output], cont);
		                                    }
		                                    if(b)
		                                     return caml_exact_trampoline_cps_call$0
		     (day$2,
		      graph,
		      ctrl,
		      today,
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (get$17,
		                b,
		                function(day){
		                 return caml_exact_trampoline_cps_call
		                         (personal_ids,
		                          day[2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_task_group,
		                                    graph,
		                                    ctrl,
		                                    b,
		                                    limit,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (personal_ids,
		      day[1],
		      function(c){
		       return caml_exact_trampoline_cps_call$2
		               (make_task_group,
		                graph,
		                ctrl,
		                c,
		                limit,
		                function(c){return a([0, c, b]);});
		      });
		                                    });
		                          });
		                });
		      });
		                                    function scheduled_by_today(a, cont){
		                                     if(a){
		                                      a = a[1];
		                                      if(0 !== a[0]){
		                                       var d = a[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (symbol$80, d, today, cont);
		                                      }
		                                     }
		                                     return cont(0);
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (org_task_objects,
		     graph,
		     input[1],
		     function(objects){
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$0,
		               objects,
		               function(param, cont){
		                var is_todo = param[3], scheduled = param[2], id = param[1];
		                function a(){return cont(0);}
		                return is_todo
		                        ? caml_exact_trampoline_cps_call
		                          (scheduled_by_today,
		                           scheduled,
		                           function(b){return b ? cont([0, id]) : a();})
		                        : a();
		               },
		               function(todo){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         objects,
		                         function(param, cont){
		                          var is_todo = param[3], scheduled = param[2], id = param[1];
		                          function a(){return cont(0);}
		                          return is_todo
		                                  ? a()
		                                  : caml_exact_trampoline_cps_call
		                                    (scheduled_by_today,
		                                     scheduled,
		                                     function(b){return b ? cont([0, id]) : a();});
		                         },
		                         function(other){
		                          return caml_exact_trampoline_cps_call$2
		                                  (make_task_group,
		                                   graph,
		                                   ctrl,
		                                   other,
		                                   limit,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$2
		    (make_task_group,
		     graph,
		     ctrl,
		     todo,
		     limit,
		     function(c){return a([0, c, b]);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function make_list_tasks(graph, ctrl, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (is_personal_workspace,
		                         graph,
		                         input[1],
		                         function(b){
		                          function a(ids){
		                           var limit = value$4(input[2], default_list_limit);
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_task_group,
		                                    graph,
		                                    ctrl,
		                                    ids,
		                                    limit,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, [0, a], cont);
		                                    });
		                          }
		                          return b
		                                  ? caml_exact_trampoline_cps_call
		                                    (state_personal,
		                                     ctrl[2],
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (to_alist$0,
		       0,
		       b[24],
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (filter_map$0,
		                 b,
		                 function(param, cont){
		                  var task = param[2], id = param[1];
		                  return is_some(task[4]) ? cont(0) : cont([0, [1, id]]);
		                 },
		                 a);
		       });
		                                     })
		                                  : caml_exact_trampoline_cps_call$1
		                                    (org_task_objects,
		                                     graph,
		                                     input[1],
		                                     function(b){
		                                      return caml_trampoline_cps_call3
		      (map$18,
		       b,
		       function(param, cont){var id = param[1]; return cont(id);},
		       a);
		                                     });
		                         });
		               }
		               function make_get_task(graph, input, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get$32,
		                         graph,
		                         input[1],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (get$17,
		                                   a,
		                                   function(a){
		                                    if(! a)
		                                     return caml_trampoline_cps_call2(return$12, bjK, cont);
		                                    var
		                                     augmented = a[1],
		                                     task = augmented[8],
		                                     a = task[7],
		                                     match = a[9],
		                                     url = match[3],
		                                     title = match[2],
		                                     notes = match[1],
		                                     starred = a[8],
		                                     scheduled = a[7],
		                                     parent = a[6],
		                                     extension_row = a[3],
		                                     completed = a[2];
		                                    function c(extension_row, cont){
		                                     var match = task[6];
		                                     function a(assignee){
		                                      return caml_exact_trampoline_cps_call
		      (to_supported$0,
		       notes,
		       function(e){
		        var b = task[1], c = is_some(completed);
		        function a(a){
		         var
		          output =
		            [0,
		             task[6],
		             title,
		             starred,
		             a,
		             c,
		             b,
		             url,
		             e,
		             parent,
		             assignee,
		             extension_row];
		         return caml_trampoline_cps_call2
		                 (return$12, [0, output], cont);
		        }
		        if(! scheduled) return a(0);
		        var sched = scheduled[1];
		        if(0 === sched[0]) return a(0);
		        var d = sched[1];
		        return caml_exact_trampoline_cps_call$1
		                (to_to_string, pp_v1$0, d, function(b){return a([0, b]);});
		       });
		                                     }
		                                     if(0 !== match[0]) return a(0);
		                                     var object_id = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (read_object_assignee, graph, object_id, a);
		                                    }
		                                    function b(a){
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call$1(let$51, a, c, cont);
		      });
		                                    }
		                                    if(! extension_row) return b(bjJ);
		                                    var ext_row = extension_row[1];
		                                    return caml_exact_trampoline_cps_call$0
		    (get_extension_row,
		     graph,
		     0,
		     ext_row,
		     function(a){
		      return caml_trampoline_cps_call3(map$15, a, found, b);
		     });
		                                   });
		                         });
		               }
		               function make_create_task(graph, ctrl, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (personal_workspace_id$0,
		                         graph,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$139,
		                                   input[1],
		                                   a,
		                                   function(a){
		                                    if(! a)
		                                     return input[5]
		     ? caml_trampoline_cps_call2(return$12, bjL, cont)
		     : caml_exact_trampoline_cps_call
		       (task_bindings$0,
		        ctrl[9],
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (to_alist$0,
		                  0,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (filter_map$0,
		                            a,
		                            function(param, cont){
		                             var binding = param[2];
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol$139,
		                                      binding[1][1],
		                                      input[1],
		                                      function(a){
		                                       return a
		       ? caml_exact_trampoline_cps_call$0
		         (get_database,
		          graph,
		          input[1],
		          binding[1][2],
		          function(a){
		           return caml_exact_trampoline_cps_call
		                   (get$17,
		                    a,
		                    function(match){
		                     if(! match) return cont(0);
		                     var db = match[1];
		                     return cont([0, [0, binding, db]]);
		                    });
		          })
		       : cont(0);
		                                      });
		                            },
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (stable_sort,
		                                      a,
		                                      function(d, param, cont){
		                                       var
		b = param[2],
		a = d[2],
		x = a[3],
		y$0 = x === cst_Task ? 1 : 0,
		x$0 = b[3],
		x$2 = x$0 === cst_Task ? 1 : 0,
		c = caml_int_compare(x$2, y$0);
		                                       if(0 !== c) return cont(c);
		                                       var y = b[3], x$1 = a[3];
		                                       return cont(caml_string_compare(x$1, y));
		                                      },
		                                      function(candidates){
		                                       if(! candidates)
		return caml_trampoline_cps_call2(return$12, bjP, cont);
		                                       var
		match = candidates[1],
		db = match[2],
		binding = match[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (map$13,
		        db[6][1],
		        function(fwo, cont){return cont(fwo[1]);},
		        function(row_schema){
		         function a(title_name, cont){
		          var a = binding[1][4];
		          function b(status_field){
		           var b = input[6];
		           function c(assignee_field, cont){
		            return caml_exact_trampoline_cps_call$1
		                    (append$0,
		                     [0, [0, title_name, [7, input[2]]], status_field],
		                     assignee_field,
		                     function(fields){
		                      function a(row_id, cont){
		                       var object_id = [0, [0, input[1]], db[1], row_id];
		                       function a(param, cont){
		                        return caml_trampoline_cps_call2
		                                (return$12, [0, [0, [0, object_id]]], cont);
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (parse_scheduled,
		                                input[4],
		                                function(b){
		                                 function c(b){
		                                  return caml_exact_trampoline_cps_call$1(let$51, b, a, cont);
		                                 }
		                                 if(0 !== b[0]){
		                                  var msg = b[1];
		                                  return caml_trampoline_cps_call2(return$12, [1, msg], c);
		                                 }
		                                 b = b[1];
		                                 if(! b) return caml_trampoline_cps_call2(return$12, bjM, c);
		                                 var
		                                  scheduling = b[1],
		                                  patch =
		                                    make$134(0, 0, 0, 0, 0, 0, 0, [0, [0, scheduling]], 0, 0, 0);
		                                 return caml_exact_trampoline_cps_call$0
		 (update_task,
		  graph,
		  object_id,
		  patch,
		  function(a){
		   return caml_exact_trampoline_cps_call$1
		           (map_error$0,
		            function(param, cont){var msg = param[2]; return cont(msg);},
		            a,
		            c);
		  });
		                                });
		                      }
		                      return caml_exact_trampoline_cps_call$2
		                              (create$52,
		                               graph,
		                               input[1],
		                               db[1],
		                               fields,
		                               function(b){
		                                return caml_exact_trampoline_cps_call$1(let$51, b, a, cont);
		                               });
		                     });
		           }
		           function a(a){
		            return caml_trampoline_cps_call2
		                    (return$12,
		                     a,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1(let$51, a, c, cont);
		                     });
		           }
		           if(! b) return a(bS);
		           var assignee = b[1];
		           if(typeof assignee === "number" && assignee) return a(bS);
		           return caml_exact_trampoline_cps_call
		                   (member_relation_column,
		                    db,
		                    function(match){
		                     if(! match) return a(bjO);
		                     var column = match[1];
		                     return caml_exact_trampoline_cps_call$0
		                             (resolve_assignee,
		                              ctrl,
		                              input[1],
		                              assignee,
		                              function(b){
		                               if(0 !== b[0]){var e = b[1]; return a([1, e]);}
		                               b = b[1];
		                               if(! b) return a(bjN);
		                               var member_id = b[1];
		                               return caml_exact_trampoline_cps_call
		                                       (member_relation_result,
		member_id,
		function(b){return a([0, [0, [0, column, b], 0]]);});
		                              });
		                    });
		          }
		          if(! a) return b(0);
		          a = a[1];
		          var todo = a[2], column = a[1];
		          return caml_exact_trampoline_cps_call$1
		                  (find_packed_by_id,
		                   db[6][1],
		                   column,
		                   function(match){
		                    if(! match) return b(0);
		                    var fwo = match[1];
		                    return b([0, [0, fwo[1][3], todo[2]], 0]);
		                   });
		         }
		         function b(param, cont){
		          var col = param[2];
		          return cont(col[3]);
		         }
		         return caml_exact_trampoline_cps_call$1
		                 (title_field,
		                  row_schema,
		                  db[5],
		                  function(c){
		                   return caml_trampoline_cps_call3
		                           (map$17,
		                            c,
		                            b,
		                            function(b){
		                             return caml_trampoline_cps_call2
		                                     (return$12,
		                                      of_option(b, "The tasks table has no title column."),
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(let$51, b, a, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                    a = input[6];
		                                    a:
		                                    if(a){
		                                     a = a[1];
		                                     if(typeof a === "number" && a) break a;
		                                     return caml_trampoline_cps_call2
		     (return$12, [1, assignment_only_org_error], cont);
		                                    }
		                                    function b(crdt, cont){
		                                     function a(scheduled, cont){
		                                      var
		                                       title = input[2],
		                                       parent = input[5],
		                                       starred = input[3],
		                                       task_read =
		 [0,
		  0,
		  0,
		  0,
		  0,
		  0,
		  parent,
		  scheduled,
		  starred,
		  [0, empty$0, title, 0]];
		                                      return caml_exact_trampoline_cps_call$7
		      (create$47,
		       ctrl,
		       crdt,
		       0,
		       0,
		       6,
		       task_read,
		       function(task_id){
		        return caml_trampoline_cps_call2
		                (return$12, [0, [0, [1, task_id]]], cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (parse_scheduled,
		      input[4],
		      function(b){
		       return caml_trampoline_cps_call2
		               (return$12,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$51, b, a, cont);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (writable$0,
		     ctrl[2],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (symbol_bind$6, a, b, cont);
		     });
		                                   });
		                         });
		               }
		               function make_update_task(graph, input, cont){
		                var ctrl = graph[3];
		                function a(crdt, cont){
		                 var a = set_field(input[4]);
		                 function c(scheduled, cont){
		                  var
		                   parent = set_field(input[5]),
		                   open = g(include$0),
		                   let$ = open[20],
		                   let$0 = open[14];
		                  function a(notes, cont){
		                   var a = set_field(input[6]);
		                   if(a)
		                    switch(a[1]){
		                      case 1:
		                       var
		                        t$0 = ocaml_ptime_clock_now_d_ps(),
		                        completed$0 = [0, [0, t$0]],
		                        archived = bjT;
		                       break;
		                      case 2:
		                       var
		                        t = ocaml_ptime_clock_now_d_ps(),
		                        completed$0 = completed,
		                        archived = [0, [0, t]];
		                       break;
		                      default: completed$0 = bjQ; archived = bjR;
		                    }
		                   else {completed$0 = 0; archived = 0;}
		                   a = set_field(input[2]);
		                   var
		                    patch =
		                      make$134
		                       (archived,
		                        completed$0,
		                        0,
		                        0,
		                        notes,
		                        0,
		                        parent,
		                        scheduled,
		                        set_field(input[3]),
		                        a,
		                        0);
		                   function b(result, cont){
		                    if(0 !== result[0]){
		                     var msg = result[1][2];
		                     return caml_trampoline_cps_call2(return$12, [1, msg], cont);
		                    }
		                    var a = set_field(input[7]);
		                    if(! a)
		                     return caml_trampoline_cps_call2(return$12, bjS, cont);
		                    var assignee = a[1], a = input[1];
		                    if(0 !== a[0])
		                     return caml_trampoline_cps_call2
		                             (return$12, [1, assignment_only_org_error], cont);
		                    var object_id = a[1], a = object_id[1];
		                    if(! a)
		                     return caml_trampoline_cps_call2
		                             (return$12, [1, assignment_only_org_error], cont);
		                    var workspace = a[1];
		                    return caml_exact_trampoline_cps_call$0
		                            (get_database,
		                             graph,
		                             workspace,
		                             object_id[2],
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (get$17,
		                                       a,
		                                       function(match){
		if(! match)
		 return caml_trampoline_cps_call2(return$12, bjI, cont);
		var db = match[1];
		return caml_exact_trampoline_cps_call
		        (member_relation_column,
		         db,
		         function(match){
		          if(! match)
		           return caml_trampoline_cps_call2(return$12, bjH, cont);
		          var field = match[1];
		          return caml_exact_trampoline_cps_call$0
		                  (resolve_assignee,
		                   ctrl,
		                   workspace,
		                   assignee,
		                   function(match){
		                    if(0 !== match[0]){
		                     var e = match[1];
		                     return caml_trampoline_cps_call2(return$12, [1, e], cont);
		                    }
		                    var member_id = match[1];
		                    function a(value){
		                     return caml_exact_trampoline_cps_call$2
		                             (set$28, graph, object_id, field, value, cont);
		                    }
		                    if(! member_id) return a(0);
		                    var id = member_id[1];
		                    return caml_exact_trampoline_cps_call
		                            (member_relation_result, id, a);
		                   });
		         });
		                                       });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$3
		                           (update$18,
		                            graph,
		                            crdt,
		                            input[1],
		                            patch,
		                            6,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (symbol_bind$6, a, b, cont);
		                            });
		                  }
		                  function b(notes, cont){
		                   function a(augmented, cont){
		                    var a = input[1];
		                    function c(workspace, cont){
		                     return caml_exact_trampoline_cps_call$2
		                             (of_supported$0,
		                              graph,
		                              workspace,
		                              [0, augmented[8][7][9][1]],
		                              notes,
		                              function(a){
		                               return caml_trampoline_cps_call3(map$15, a, return$9, cont);
		                              });
		                    }
		                    function b(a){
		                     return caml_exact_trampoline_cps_call$1(let$0, a, c, cont);
		                    }
		                    if(0 !== a[0])
		                     return caml_exact_trampoline_cps_call
		                             (personal_workspace_id$0,
		                              graph,
		                              function(a){return b([0, a]);});
		                    a = a[1][1];
		                    if(! a) return b(bjU);
		                    var workspace = a[1];
		                    return b([0, workspace]);
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (get$32,
		                            graph,
		                            input[1],
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (get$17,
		                                      b,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (let$0, of_option(b, cst_Task_not_found), a, cont);
		                                      });
		                            });
		                  }
		                  return caml_trampoline_cps_call2
		                          (of_string$14,
		                           set_field(input[8]),
		                           function(c){
		                            return caml_exact_trampoline_cps_call$1
		                                    (let$,
		                                     c,
		                                     b,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$51, b, a, cont);
		       });
		                                     });
		                           });
		                 }
		                 function b(a){
		                  return caml_exact_trampoline_cps_call$1(let$51, a, c, cont);
		                 }
		                 if(! a) return caml_trampoline_cps_call2(return$13, 0, b);
		                 a = a[1];
		                 if(! a) return caml_trampoline_cps_call2(return$13, bjV, b);
		                 a = a[1];
		                 if(0 === a[0]){
		                  var date = a[1][1];
		                  return caml_exact_trampoline_cps_call
		                          (of_string$12,
		                           date,
		                           function(match){
		                            if(0 === match[0]){
		                             var date$0 = match[1];
		                             return caml_trampoline_cps_call2
		                                     (return$13, [0, [0, [1, date$0]]], b);
		                            }
		                            var err = match[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$240,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (a,
		       date,
		       err,
		       function(a){
		        return caml_exact_trampoline_cps_call(fail$2, a, b);
		       });
		                                     });
		                           });
		                 }
		                 var week = a[1][1];
		                 return caml_exact_trampoline_cps_call
		                         (of_string$13,
		                          week,
		                          function(match){
		                           if(0 === match[0]){
		                            var week$0 = match[1];
		                            return caml_trampoline_cps_call2
		                                    (return$13, [0, [0, [0, week$0]]], b);
		                           }
		                           var err = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$241,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (a,
		      week,
		      err,
		      function(a){
		       return caml_exact_trampoline_cps_call(fail$2, a, b);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               function make_allocate_task(ctrl, input, cont){
		                var match = input[1];
		                if(0 === match[0])
		                 return caml_trampoline_cps_call2(return$12, bjW, cont);
		                var task = match[1];
		                return caml_exact_trampoline_cps_call
		                        (of_string$12,
		                         input[2],
		                         function(b){
		                          if(0 !== b[0])
		                           return caml_trampoline_cps_call2(return$12, bjX, cont);
		                          var date = b[1], b = input[3];
		                          function a(daytime_opt){
		                           function a(crdt, cont){
		                            var
		                             duration = minutes(input[4]),
		                             allocation =
		                               [0, 0, [0, [0, date]], daytime_opt, 0, duration, 0, 0, 0];
		                            return caml_exact_trampoline_cps_call$3
		                                    (allocate$1,
		                                     ctrl,
		                                     crdt,
		                                     task,
		                                     allocation,
		                                     6,
		                                     function(match){
		                                      if(0 === match[0]){
		                                       var event_opt = match[1];
		                                       return caml_trampoline_cps_call3
		       (map$17,
		        event_opt,
		        function(e, cont){return cont(e[6]);},
		        function(event_id){
		         return caml_trampoline_cps_call2
		                 (return$12, [0, [0, event_id]], cont);
		        });
		                                      }
		                                      var err = match[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (kasprintf,
		       id,
		       fmt$242,
		       function(a){
		        return caml_trampoline_cps_call3
		                (a,
		                 pp_toplevel,
		                 err,
		                 function(error_msg){
		                  return caml_trampoline_cps_call2
		                          (return$12, [1, error_msg], cont);
		                 });
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_bind$6, b, a, cont);
		                                    });
		                          }
		                          if(! b) return a(0);
		                          var time_str = b[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (split$0,
		                                   time_str,
		                                   58,
		                                   function(c){
		                                    if(c){
		                                     var b = c[2];
		                                     if(b && ! b[2]){
		                                      var
		                                       minute_str = b[1],
		                                       hour_str = c[1],
		                                       c = int_of_string_opt(hour_str),
		                                       b = int_of_string_opt(minute_str);
		                                      if(c && b){
		                                       var minutes = b[1], hours = c[1];
		                                       return caml_exact_trampoline_cps_call$0
		       (make$7,
		        hours,
		        minutes,
		        0,
		        function(match){
		         if(0 !== match[0]) return a(0);
		         var dt = match[1];
		         return a([0, [0, dt, 0]]);
		        });
		                                      }
		                                      return a(0);
		                                     }
		                                    }
		                                    return a(0);
		                                   });
		                         });
		               }
		               function make_delete_task(graph, ctrl, input, cont){
		                var match = input[1];
		                if(0 === match[0]){
		                 var object_id = match[1];
		                 return caml_trampoline_cps_call2(graph[9], object_id, cont);
		                }
		                var task = match[1];
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (delete$1,
		                          ctrl,
		                          crdt,
		                          task,
		                          6,
		                          function(match){
		                           return caml_trampoline_cps_call2(return$12, bjY, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol_bind$6, b, a, cont);
		                         });
		               }
		               var letrec_function_context$1052 = [];
		               function schema_versioned$558(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1052[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bj8, bj7, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1052[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1052[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1052[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$272,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       default$ = match$345[1],
		                                       a =
		 [0,
		  [0,
		   bj_,
		   0,
		   0,
		   0,
		   cst_choices,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		   0,
		   0],
		  [0,
		   [0, bj9, 0, 0, 0, cst_answer_count, 0, 2, [0, b], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (supported_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$346[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        answer_count = b[2][1],
		                        choices = b[1],
		                        long = a[1],
		                        short = param[1];
		                       return cont([0, short, long, choices, answer_count]);
		                      },
		                      function(param, cont){
		                       var
		                        answer_count = param[4],
		                        choices = param[3],
		                        long = param[2],
		                        short = param[1];
		                       return cont
		                               ([0, short, [0, long, [0, choices, [0, answer_count, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        bka,
		                        0,
		                        0,
		                        0,
		                        cst_short,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bj$, 0, 0, 0, cst_long, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1052[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1052[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1012 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1052, [0, schematic_cache$1012]);
		               caml_callback
		                (schema_versioned$558,
		                 [function(param, cont){return cont(0);}]);
		               function to_real(graph, workspace, q, cont){
		                var open = g(include$0), let$ = open[17], match = q[2];
		                function b(long, cont){
		                 return cont([0, q[1], long, q[3], q[4]]);
		                }
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                }
		                if(! match) return a(bkb);
		                var supported = match[1];
		                function c(long, cont){return cont([0, long]);}
		                return caml_exact_trampoline_cps_call$2
		                        (of_supported$0,
		                         graph,
		                         workspace,
		                         0,
		                         supported,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, c, a);
		                         });
		               }
		               var letrec_function_context$1053 = [];
		               function ask_user_input_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1053[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkc, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1053[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1053[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1053[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$558,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var questions = param[1];
		   return cont([0, questions]);
		  },
		  function(param, cont){
		   var questions = param[1];
		   return cont([0, questions, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_questions,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1053[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1053[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1013 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1053, [0, schematic_cache$1013]);
		               caml_callback
		                (ask_user_input_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               function make_ask_user(graph, workspace, input, cont){
		                var open = g(include$0), let$ = open[17];
		                function a(questions, cont){
		                 return cont([0, -796571946, questions]);
		                }
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         input[1],
		                         function(a, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (to_real, graph, workspace, a, cont);
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (all$14,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (let$,
		     b,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2(return$12, a, cont);
		     });
		                                   });
		                         });
		               }
		               var null$6 = 0;
		               function register
		               (include_personal, b, workspace, graph, ctrl, opt, param, cont){
		                var include_ask_user = b ? b[1] : 1, extra = opt ? opt[1] : 0;
		                function a(input, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (get$33,
		                          ctrl,
		                          input[1],
		                          function(match){
		                           if(! match)
		                            return caml_trampoline_cps_call2(return$12, bef, cont);
		                           var org = match[1];
		                           return caml_trampoline_cps_call2
		                                   (return$12, [0, [0, input[1], org[3][4][2]]], cont);
		                          });
		                }
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (org_output_schema_versioned,
		                         schematic_version,
		                         function(b){
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (get_organization_input_schema_,
		                                   schematic_version,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$0
		    (object_schema,
		     bel,
		     0,
		     c,
		     function(c){
		      return caml_exact_trampoline_cps_call$9
		              (tool,
		               "getOrganization",
		               0,
		               0,
		               "\nGet the information of an organization given its identifier.\n",
		               read$2(0),
		               c,
		               b,
		               a,
		               function(get_organization){
		                function a(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (make_list_workspaces, ctrl, a, cont);
		                }
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (workspace_summary_schema_versi,
		                         schematic_version,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (capped_list_schema_versioned,
		                                   schematic_version,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call
		    (c,
		     b,
		     function(b){
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (list_workspaces_input_schema_v,
		               schematic_version,
		               function(c){
		                return caml_exact_trampoline_cps_call$0
		                        (object_schema,
		                         bem,
		                         0,
		                         c,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$9
		                                  (tool,
		                                   "listWorkspaces",
		                                   0,
		                                   0,
		                                   "\nList the workspaces associated with an organization.\nReturns a compact summary (id, name) for each, plus the total count.\n",
		                                   read$2(0),
		                                   c,
		                                   b,
		                                   a,
		                                   function(list_workspaces){
		                                    function a(input, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (get$18,
		      ctrl,
		      input[1],
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (get$17,
		                a,
		                function(match){
		                 if(! match)
		                  return caml_trampoline_cps_call2(return$12, beh, cont);
		                 var ws = match[1];
		                 return caml_trampoline_cps_call2
		                         (return$12, [0, [0, input[1], ws[1][3][2]]], cont);
		                });
		      });
		                                    }
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (workspace_summary_schema_versi,
		     schematic_version,
		     function(b){
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (get_workspace_input_schema_ver,
		               schematic_version,
		               function(c){
		                return caml_exact_trampoline_cps_call$0
		                        (object_schema,
		                         ben,
		                         0,
		                         c,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$9
		                                  (tool,
		                                   "getWorkspace",
		                                   0,
		                                   0,
		                                   "\nGet the information of a workspace given its identifier.\n",
		                                   read$2(0),
		                                   c,
		                                   b,
		                                   a,
		                                   function(get_workspace){
		                                    function a(a, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (make_create_workspace, ctrl, a, cont);
		                                    }
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (create_workspace_output_schema,
		     schematic_version,
		     function(b){
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (create_workspace_input_schema_,
		               schematic_version,
		               function(c){
		                return caml_exact_trampoline_cps_call$0
		                        (object_schema,
		                         beo,
		                         0,
		                         c,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$9
		                                  (tool,
		                                   "createWorkspace",
		                                   0,
		                                   0,
		                                   "\nCreate a new workspace in an organization.\nReturns the new workspace identifier.\n",
		                                   write$0(0, 0, 0),
		                                   c,
		                                   b,
		                                   a,
		                                   function(create_workspace){
		                                    function a(a, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (make_rename_workspace, ctrl, a, cont);
		                                    }
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (rename_workspace_input_schema_,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bep,
		               0,
		               b,
		               function(b){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "renameWorkspace",
		                         0,
		                         0,
		                         "\nRename an existing workspace.\n",
		                         write$0(1, 1, 0),
		                         b,
		                         schematic_param_a_schema_versi,
		                         a,
		                         function(rename_workspace){
		                          function a(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (make_list_members, ctrl, a, cont);
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (member_output_schema_versioned,
		                                   schematic_version,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (capped_list_schema_versioned,
		     schematic_version,
		     function(c){
		      return caml_exact_trampoline_cps_call
		              (c,
		               b,
		               function(b){
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (list_members_input_schema_vers,
		                         schematic_version,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$0
		                                  (object_schema,
		                                   beq,
		                                   0,
		                                   c,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$9
		    (tool,
		     cst_listMembers,
		     0,
		     0,
		     "\nList the members of the given workspace's organization.\nReturns a summary (id, name, email) for each, plus the total count.\nUse a member's id to assign a task to them (see createTask / updateTask).\n",
		     read$2(0),
		     c,
		     b,
		     a,
		     function(list_members){
		      var
		       workspace_tools =
		         [0,
		          get_organization,
		          [0,
		           list_workspaces,
		           [0,
		            get_workspace,
		            [0,
		             create_workspace,
		             [0, rename_workspace, [0, list_members, 0]]]]]];
		      function a(a, cont){
		       return caml_exact_trampoline_cps_call$1
		               (make_list_notices, ctrl, a, cont);
		      }
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (notice_summary_schema_versione,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (capped_list_schema_versioned,
		                         schematic_version,
		                         function(c){
		                          return caml_exact_trampoline_cps_call
		                                  (c,
		                                   b,
		                                   function(b){
		                                    function schematic_version(param){return 0;}
		                                    return caml_exact_trampoline_cps_call
		    (list_notices_input_schema_vers,
		     schematic_version,
		     function(c){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bh1,
		               0,
		               c,
		               function(c){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "listNotices",
		                         0,
		                         bh2,
		                         "\nList notices for the current user, most recent first.\nReturns a compact summary (id, message, viewed) for each, plus the total count.\nFor a batch operation, request a sufficiently high limit and check truncated before acting.\n",
		                         read$2(0),
		                         c,
		                         b,
		                         a,
		                         function(list_notices){
		                          function a(input, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (get$26,
		                                    ctrl,
		                                    input[1],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (get$17,
		      a,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call
		                (fail$2, cst_Notice_not_found, cont);
		       var
		        notice = match[1],
		        a = notice[2],
		        b = is_some(notice[1][8]);
		       return caml_exact_trampoline_cps_call$1
		               (to_string$25,
		                0,
		                notice[1][4],
		                function(c){
		                 var output = [0, input[1], notice[1][5], c, b, a];
		                 return caml_trampoline_cps_call2(return$13, output, cont);
		                });
		      });
		                                    });
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (notice_output_schema_versioned,
		                                   schematic_version,
		                                   function(b){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (notice_id_input_schema_version,
		     schematic_version,
		     function(c){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bh3,
		               0,
		               c,
		               function(c){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "getNotice",
		                         0,
		                         0,
		                         "\nGet a notice by its id.\n",
		                         read$2(0),
		                         c,
		                         b,
		                         a,
		                         function(get_notice){
		                          function a(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (make_create_notice, ctrl, a, cont);
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (create_notice_output_schema_ve,
		                                   schematic_version,
		                                   function(b){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (create_notice_input_schema_ver,
		     schematic_version,
		     function(c){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bh4,
		               0,
		               c,
		               function(c){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "createNotice",
		                         0,
		                         0,
		                         "\nCreate a general persistent notice to notify another user in the organization.\n",
		                         write$0(0, 0, 0),
		                         c,
		                         b,
		                         a,
		                         function(create_notice){
		                          function a(a, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (make_mark_notice_viewed, ctrl, a, cont);
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (notice_id_input_schema_version,
		                                   schematic_version,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$0
		    (object_schema,
		     bh5,
		     0,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$9
		              (tool,
		               "markNoticeViewed",
		               0,
		               0,
		               "\nMark a notice as viewed.\n",
		               write$0(1, 0, 0),
		               b,
		               schematic_param_a_schema_versi,
		               a,
		               function(mark_notice_viewed){
		                function a(a, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (make_mark_notice_archived, ctrl, a, cont);
		                }
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (notice_id_input_schema_version,
		                         schematic_version,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (object_schema,
		                                   bh6,
		                                   0,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$9
		    (tool,
		     "archiveNotice",
		     0,
		     bh7,
		     "\nMark a notice as archived, removing it from the inbox.\n",
		     write$0(1, 1, 0),
		     b,
		     schematic_param_a_schema_versi,
		     a,
		     function(archive_notice){
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (notice_id_input_schema_version,
		               schematic_version,
		               bNP
		                (append$0,
		                 to_list$0,
		                 to_to_string,
		                 return$12,
		                 return$13,
		                 pp$30,
		                 schema_versioned$92,
		                 schema_versioned$206,
		                 schema_versioned$509,
		                 get$17,
		                 all_schema_versioned,
		                 all$25,
		                 all$30,
		                 hierarchy_schema_versioned,
		                 hierarchy$0,
		                 get$31,
		                 capped_list_schema_versioned,
		                 null$6,
		                 object_schema,
		                 read$2,
		                 write$0,
		                 tool,
		                 namespace,
		                 workspace_tools,
		                 get_object_input_schema_versio,
		                 list_tables_input_schema_versi,
		                 table_summary_schema_versioned,
		                 get_table_schema_input_schema_,
		                 search_rows_input_schema_versi,
		                 ai_field_schema_versioned$0,
		                 add_row_input_schema_versioned,
		                 add_row_output_schema_versione,
		                 update_object_field_input_sche,
		                 create_table_input_schema_vers,
		                 create_table_output_schema_ver,
		                 update_table_schema_input_sche,
		                 update_note_column_input_schem,
		                 delete_object_input_schema_ver,
		                 make_list_tables,
		                 make_get_table_schema,
		                 graph_row_id_schema_versioned,
		                 make_search_table_rows,
		                 make_add_table_row,
		                 make_update_object_field,
		                 make_create_table,
		                 make_update_table_schema,
		                 make_update_note_column,
		                 make_delete_object,
		                 contact_summary_schema_version,
		                 get_contact_input_schema_versi,
		                 get_contact_output_schema_vers,
		                 list_contacts_input_schema_ver,
		                 search_contacts_input_schema_v,
		                 make_get_contact,
		                 make_list_contacts,
		                 make_search_contacts,
		                 get_event_input_schema_version,
		                 get_event_output_schema_versio,
		                 list_events_input_schema_versi,
		                 event_summary_schema_versioned,
		                 create_event_input_schema_vers,
		                 create_event_output_schema_ver,
		                 update_event_input_schema_vers,
		                 set_attendance_input_schema_ve,
		                 complete_event_input_schema_ve,
		                 delete_event_input_schema_vers,
		                 find_available_time_slots_inpu,
		                 find_available_time_slots_outp,
		                 make_get_event,
		                 make_list_events,
		                 make_create_event,
		                 make_update_event,
		                 make_set_attendance,
		                 make_complete_event,
		                 make_delete_event,
		                 make_find_available_time_slots,
		                 build_reference_tool,
		                 build_link_tool,
		                 pin_menu_item_input_schema_ver,
		                 unpin_menu_item_input_schema_v,
		                 make_pin_menu_item,
		                 make_unpin_menu_item,
		                 list_notices,
		                 get_notice,
		                 create_notice,
		                 mark_notice_viewed,
		                 archive_notice,
		                 function(a, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (make_delete_notice, ctrl, a, cont);
		                 },
		                 get_page_input_schema_versione,
		                 get_page_output_schema_version,
		                 create_page_input_schema_versi,
		                 create_page_output_schema_vers,
		                 update_page_input_schema_versi,
		                 make_get_page,
		                 make_create_page,
		                 make_update_page,
		                 search_input_schema_versioned,
		                 search_result_schema_versioned,
		                 make_search,
		                 get_task_input_schema_versione,
		                 get_task_output_schema_version,
		                 create_task_input_schema_versi,
		                 create_task_output_schema_vers,
		                 update_task_input_schema_versi,
		                 list_unplanned_tasks_input_sch,
		                 list_todays_tasks_input_schema,
		                 list_tasks_input_schema_versio,
		                 generalized_task_summary_schem,
		                 list_tasks_output_schema_versi,
		                 allocate_task_input_schema_ver,
		                 allocate_task_output_schema_ve,
		                 delete_task_input_schema_versi,
		                 make_list_unplanned,
		                 make_list_todays,
		                 make_list_tasks,
		                 make_get_task,
		                 make_create_task,
		                 make_update_task,
		                 make_allocate_task,
		                 make_delete_task,
		                 ask_user_input_schema_versione,
		                 make_ask_user,
		                 ctrl,
		                 graph,
		                 workspace,
		                 include_personal,
		                 include_ask_user,
		                 extra,
		                 schematic_param_a_schema_versi,
		                 schematic_param_name_schema_ve,
		                 cont));
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$31 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$52 = open$31[3],
		                letrec_function_context$1054 = [];
		               function boundaries_schema_versioned$1(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1054[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bke, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1054[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1054[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1054[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$347[1],
		                                       a =
		 [0,
		  [0, bkf, 0, 0, 0, cst_end, 0, [0, default$], [0, b], 0, 0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(b){
		        var
		         default$ = match$348[1],
		         res =
		           [11,
		            bki,
		            [0,
		             [0,
		              function(param, cont){
		               var f1 = param[2], f0 = param[1];
		               return cont([0, f0, f1]);
		              },
		              function(param, cont){
		               if(0 !== param[0]) return cont(0);
		               var f1 = param[2], f0 = param[1];
		               return cont([0, [0, f0, f1]]);
		              },
		              1,
		              0,
		              cst_count,
		              cst_Count,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){
		                 var count = param[2][1], start = param[1];
		                 return cont([0, start, count]);
		                },
		                function(param, cont){
		                 var count = param[2], start = param[1];
		                 return cont([0, start, [0, count, 0]]);
		                },
		                [0,
		                 [0,
		                  bkh,
		                  0,
		                  0,
		                  0,
		                  cst_start,
		                  0,
		                  2,
		                  [0, schematic_param_name_schema_ve],
		                  0,
		                  0],
		                 [0,
		                  [0, 0, 0, 0, 0, cst_count, 0, 2, [0, int_schema], 0, 0],
		                  0]]],
		               0],
		              0],
		             [0,
		              [0,
		               function(param, cont){
		                var f1 = param[2], f0 = param[1];
		                return cont([1, f0, f1]);
		               },
		               function(param, cont){
		                if(0 === param[0]) return cont(0);
		                var f1 = param[2], f0 = param[1];
		                return cont([0, [0, f0, f1]]);
		               },
		               1,
		               0,
		               cst_dates,
		               cst_Dates,
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var end = param[2][1], start = param[1];
		                  return cont([0, start, end]);
		                 },
		                 function(param, cont){
		                  var end = param[2], start = param[1];
		                  return cont([0, start, [0, end, 0]]);
		                 },
		                 [0,
		                  [0, bkg, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                  a]],
		                0],
		               0],
		              0]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1054[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1054[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1014 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1054, [0, schematic_cache$1014]);
		               caml_callback
		                (boundaries_schema_versioned$1,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1055 = [];
		               function recurrence_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1055[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkj, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1055[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1055[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1055[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (boundaries_schema_versioned$1,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0, [0, 0, 0, 0, 0, cst_boundaries, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (rule_schema_versioned,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var boundaries = param[2][1], rule = param[1];
		             return cont([0, rule, boundaries]);
		            },
		            function(param, cont){
		             var boundaries = param[2], rule = param[1];
		             return cont([0, rule, [0, boundaries, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_rule, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1055[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1055[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1015 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1055, [0, schematic_cache$1015]);
		               caml_callback
		                (recurrence_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1056 = [];
		               function trigger_schema_versioned$0(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1056[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkk, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1056[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1056[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1056[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$269,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(typeof param !== "number" && 0 !== param[0]){var f0 = param[1]; return cont([0, f0]);}
		    return cont(0);
		   },
		   1,
		   0,
		   cst_commit_pattern,
		   cst_Commit_pattern,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){
		      var watched = param[1];
		      return cont(watched);
		     },
		     function(watched, cont){return cont([0, watched, 0]);},
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_watched,
		       0,
		       2,
		       [0, [0, 0, 0, [3, c], 0]],
		       0,
		       0],
		      0]],
		    0],
		   0],
		  0],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_timezone,
		   0,
		   2,
		   [0, schema_versioned$126()],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (recurrence_schema_versioned$0,
		       schematic_version,
		       function(c){
		        var
		         res =
		           [11,
		            bkm,
		            [0,
		             [0,
		              function(param, cont){return cont(0);},
		              function(param, cont){
		               return typeof param === "number" ? cont(bkl) : cont(0);
		              },
		              0,
		              0,
		              cst_manual,
		              cst_Manual,
		              [0,
		               0,
		               0,
		               [7,
		                function(param, cont){return cont(0);},
		                function(param, cont){return cont(0);},
		                0],
		               0],
		              0],
		             [0,
		              [0,
		               function(param, cont){
		                var f2 = param[3], f1 = param[2], f0 = param[1];
		                return cont([0, f0, f1, f2]);
		               },
		               function(param, cont){
		                if(typeof param !== "number" && 0 === param[0]){
		                 var f2 = param[3], f1 = param[2], f0 = param[1];
		                 return cont([0, [0, f0, f1, f2]]);
		                }
		                return cont(0);
		               },
		               1,
		               0,
		               cst_recurrent,
		               cst_Recurrent,
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var
		                   a = param[2],
		                   timezone = a[2][1],
		                   recurrence = a[1],
		                   daytime = param[1];
		                  return cont([0, daytime, recurrence, timezone]);
		                 },
		                 function(param, cont){
		                  var
		                   timezone = param[3],
		                   recurrence = param[2],
		                   daytime = param[1];
		                  return cont([0, daytime, [0, recurrence, [0, timezone, 0]]]);
		                 },
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_daytime,
		                   0,
		                   2,
		                   [0, schema_versioned$2(schematic_version)],
		                   0,
		                   0],
		                  [0, [0, 0, 0, 0, 0, cst_recurrence, 0, 2, [0, c], 0, 0], b]]],
		                0],
		               0],
		              a]],
		            0];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1056[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1056[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1016 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1056, [0, schematic_cache$1016]);
		               caml_callback
		                (trigger_schema_versioned$0,
		                 [function(param, cont){return cont(0);}]);
		               function timmy_of_date(s, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$12,
		                         s,
		                         function(match){
		                          if(0 !== match[0])
		                           return caml_exact_trampoline_cps_call
		                                   (sprintf,
		                                    bkn,
		                                    function(a){
		                                     return caml_trampoline_cps_call2
		     (a,
		      s,
		      function(a){
		       return caml_exact_trampoline_cps_call(failwith, a, cont);
		      });
		                                    });
		                          var d = match[1];
		                          return cont(d);
		                         });
		               }
		               function trigger_to_schema(param, cont){
		                if(typeof param === "number") return cont(0);
		                if(0 === param[0]){
		                 var
		                  timezone = param[3],
		                  recurrence = param[2],
		                  daytime = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (rule_to_mandate,
		                          recurrence[1],
		                          function(rule){
		                           var param = recurrence[2];
		                           function a(boundaries){
		                            var mandate_recurrence = [0, boundaries, rule];
		                            return caml_exact_trampoline_cps_call
		                                    (of_mandate,
		                                     mandate_recurrence,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$2
		      (value_exn,
		       0,
		       0,
		       bko,
		       a,
		       function(event_recurrence){
		        return cont([0, daytime, event_recurrence, timezone]);
		       });
		                                     });
		                           }
		                           if(0 === param[0]){
		                            var count = param[2], start = param[1];
		                            return caml_exact_trampoline_cps_call
		                                    (timmy_of_date,
		                                     start,
		                                     function(b){return a([0, b, count]);});
		                           }
		                           var end = param[2], start$0 = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$3,
		                                    start$0,
		                                    timmy_of_date,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (map$3,
		      end,
		      timmy_of_date,
		      function(c){return a([1, c, b]);});
		                                    });
		                          });
		                }
		                var watched = param[1];
		                return cont([1, watched]);
		               }
		               function ai_state$0(ctrl, workspace, cont){
		                function a(state, cont){return cont(state[1]);}
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(map$3, b, a, cont);
		                         });
		               }
		               var letrec_function_context$1057 = [];
		               function update_working_memory_input_sc
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1057[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkp, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1057[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1057[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1057[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (supported_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var working_memory = param[1];
		   return cont([0, working_memory]);
		  },
		  function(param, cont){
		   var working_memory = param[1];
		   return cont([0, working_memory, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_working_memory, 0, 2, [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1057[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1057[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1017 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1057, [0, schematic_cache$1017]);
		               caml_callback
		                (update_working_memory_input_sc,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1058 = [];
		               function step_create_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1058[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkq, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1058[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1058[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1058[1][1] = a;
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var prompt = param[2][1], name = param[1];
		                                 return cont([0, name, prompt]);
		                                },
		                                function(param, cont){
		                                 var prompt = param[2], name = param[1];
		                                 return cont([0, name, [0, prompt, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_prompt,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1058[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1058[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1018 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1058, [0, schematic_cache$1018]);
		               caml_callback
		                (step_create_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1059 = [];
		               function automation_create_input_schema
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1059[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkr, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1059[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1059[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1059[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (step_create_input_schema_versi,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_steps,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (trigger_schema_versioned$0,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$349[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        steps = a[2][1],
		                        trigger = a[1],
		                        name = param[1];
		                       return cont([0, name, trigger, steps]);
		                      },
		                      function(param, cont){
		                       var steps = param[3], trigger = param[2], name = param[1];
		                       return cont([0, name, [0, trigger, [0, steps, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_name,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, 0, 0, 0, 0, cst_trigger, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1059[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1059[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1019 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1059, [0, schematic_cache$1019]);
		               caml_callback
		                (automation_create_input_schema,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1060 = [];
		               function automation_create_output_schem
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1060[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bks, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1060[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1060[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1060[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1060[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1060[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1020 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1060, [0, schematic_cache$1020]);
		               caml_callback
		                (automation_create_output_schem,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1061 = [];
		               function automation_update_input_schema
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1061[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkt, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1061[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1061[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1061[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (trigger_schema_versioned$0,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(b){
		                            var
		                             default$ = match$350[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_trigger, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (update_schema_versioned,
		       schematic_version,
		       function(c){
		        return caml_exact_trampoline_cps_call
		                (c,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$351[1],
		                             b =
		                               [0,
		                                [0, bku, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    trigger = a[2][1],
		    name = a[1],
		    id = param[1];
		   return cont([0, id, name, trigger]);
		  },
		  function(param, cont){
		   var trigger = param[3], name = param[2], id = param[1];
		   return cont([0, id, [0, name, [0, trigger, 0]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1061[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1061[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1021 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1061, [0, schematic_cache$1021]);
		               caml_callback
		                (automation_update_input_schema,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1062 = [];
		               function automation_delete_input_schema
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1062[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkv, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1062[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1062[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1062[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1062[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1062[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1022 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1062, [0, schematic_cache$1022]);
		               caml_callback
		                (automation_delete_input_schema,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1063 = [];
		               function automation_get_input_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1063[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkw, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1063[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1063[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1063[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1063[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1063[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1023 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1063, [0, schematic_cache$1023]);
		               caml_callback
		                (automation_get_input_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1064 = [];
		               function automation_run_get_input_schem
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1064[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkx, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1064[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1064[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1064[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Automation_run[4],
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1064[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1064[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1024 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1064, [0, schematic_cache$1024]);
		               caml_callback
		                (automation_run_get_input_schem,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1065 = [];
		               function automation_run_resume_input_sc
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1065[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bky, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1065[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1065[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1065[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 bkz,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_answers,
		                                 0,
		                                 2,
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   [3, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                                   0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (Automation_run[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var answers = param[2][1], id = param[1];
		   return cont([0, id, answers]);
		  },
		  function(param, cont){
		   var answers = param[2], id = param[1];
		   return cont([0, id, [0, answers, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1065[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1065[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1025 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1065, [0, schematic_cache$1025]);
		               caml_callback
		                (automation_run_resume_input_sc,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1066 = [];
		               function step_create_for_automation_inp
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1066[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkA, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1066[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1066[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1066[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_prompt,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$266,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    prompt = a[2][1],
		    name = a[1],
		    automation_id = param[1];
		   return cont([0, automation_id, name, prompt]);
		  },
		  function(param, cont){
		   var
		    prompt = param[3],
		    name = param[2],
		    automation_id = param[1];
		   return cont([0, automation_id, [0, name, [0, prompt, 0]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_automation_id, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1066[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1066[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1026 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1066, [0, schematic_cache$1026]);
		               caml_callback
		                (step_create_for_automation_inp,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1067 = [];
		               function step_create_output_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1067[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkB, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1067[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1067[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1067[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$263,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1067[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1067[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1027 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1067, [0, schematic_cache$1027]);
		               caml_callback
		                (step_create_output_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1068 = [];
		               function step_update_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1068[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkC, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1068[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1068[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1068[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (update_schema_versioned,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (a,
		       schematic_param_name_schema_ve,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(b){
		                  var
		                   default$ = match$352[1],
		                   a =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_prompt, 0, [0, default$], [0, b], 0, 0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (update_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (b,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(c){
		        var
		         default$ = match$353[1],
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$263,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        prompt = a[2][1],
		                        name = a[1],
		                        id = param[1];
		                       return cont([0, id, name, prompt]);
		                      },
		                      function(param, cont){
		                       var prompt = param[3], name = param[2], id = param[1];
		                       return cont([0, id, [0, name, [0, prompt, 0]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1068[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1068[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1028 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1068, [0, schematic_cache$1028]);
		               caml_callback
		                (step_update_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1069 = [];
		               function step_delete_input_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1069[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bkD, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1069[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1069[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1069[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$263,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1069[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1069[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1029 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1069, [0, schematic_cache$1029]);
		               caml_callback
		                (step_delete_input_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               function prompt_of_string(str){
		                var doc = [0, [0, make$33(0, [8, [0, str]]), 0]];
		                return [0, default$, doc];
		               }
		               function prompt_of_supported
		               (graph, workspace, previous, doc, cont){
		                return caml_exact_trampoline_cps_call$2
		                        (of_supported$0,
		                         graph,
		                         workspace,
		                         [0, previous],
		                         doc,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$5,
		                                   a,
		                                   function(document, cont){
		                                    return cont([0, default$, document]);
		                                   },
		                                   cont);
		                         });
		               }
		               function make_update_working_memory
		               (graph, ctrl, workspace, agent_id, param, cont){
		                var working_memory = param[1];
		                function a(crdt, cont){
		                 var open = g(include$0), let$ = open[14];
		                 function a(state, cont){
		                  function a(agent, cont){
		                   function a(new_prompt, cont){
		                    var working_memory = [0, new_prompt];
		                    function a(operation, cont){
		                     return caml_exact_trampoline_cps_call$2
		                             (apply$125,
		                              ctrl[1],
		                              crdt,
		                              workspace,
		                              operation,
		                              function(t){
		                               if(0 === t[0]) return cont(t);
		                               var x = t[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (kasprintf,
		id,
		fmt$243,
		function(a){
		 return caml_trampoline_cps_call3
		         (a, pp$125, x, function(a){return cont([1, a]);});
		});
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call$0
		                            (update$9,
		                             state,
		                             [0, 0, 0, working_memory],
		                             agent_id,
		                             function(t){
		                              function b(b){
		                               return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                              }
		                              return 0 === t[0]
		                                      ? b(t)
		                                      : caml_exact_trampoline_cps_call$1
		(kasprintf,
		 id,
		 fmt$244,
		 function(a){
		  return caml_trampoline_cps_call3
		          (a, pp$41, agent_id, function(a){return b([1, a]);});
		 });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$2
		                           (prompt_of_supported,
		                            graph,
		                            workspace,
		                            agent[8][2],
		                            working_memory,
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (get_agent,
		                           state,
		                           agent_id,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (kasprintf,
		                                     id,
		                                     fmt$245,
		                                     function(c){
		                                      return caml_trampoline_cps_call3
		      (c,
		       pp$41,
		       agent_id,
		       function(c){
		        return caml_exact_trampoline_cps_call$1
		                (let$, of_option(b, c), a, cont);
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (state$0,
		                          workspace,
		                          ctrl[2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    of_option(b, cst_Workspace_not_found),
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function make_automation_list
		               (ctrl, workspace, agent_id, input, cont){
		                var open = g(include$0), let$ = open[8];
		                function a(state, cont){
		                 if(0 !== agent_id[0]) return cont(state[2]);
		                 var id = agent_id[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id, state[1], id, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (ai_state$0,
		                         ctrl,
		                         workspace,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(agent_opt){
		                                    if(agent_opt)
		                                     var agent = agent_opt[1], automation_ids = agent[2];
		                                    else
		                                     automation_ids = 0;
		                                    return caml_exact_trampoline_cps_call$1
		    (ai_state$0,
		     ctrl,
		     workspace,
		     function(match){
		      function a(automations){
		       return caml_trampoline_cps_call2
		               (return$13, automations, cont);
		      }
		      if(! match) return a(0);
		      var ai = match[1];
		      return caml_exact_trampoline_cps_call$1
		              (filter_map$0,
		               automation_ids,
		               function(id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id, ai[4], id, cont);
		               },
		               a);
		     });
		                                   });
		                         });
		               }
		               function make_automation_create
		               (ctrl, workspace, agent_id, param, cont){
		                var steps = param[3], trigger = param[2], name = param[1];
		                function a(crdt, cont){
		                 var open = g(include$0), let$ = open[14];
		                 function a(state, cont){
		                  var
		                   a = Sequence_result[14].call(null, steps),
		                   a =
		                     Sequence_result[32][5].call
		                      (null,
		                       a,
		                       function(param, cont){
		                        var
		                         prompt = param[2],
		                         name = param[1],
		                         step_id = make$52(),
		                         action = [0, prompt_of_string(prompt)];
		                        function a(operation, cont){
		                         function a(param, cont){return cont([0, step_id]);}
		                         return caml_exact_trampoline_cps_call$2
		                                 (apply$125,
		                                  ctrl[1],
		                                  crdt,
		                                  workspace,
		                                  operation,
		                                  function(t){
		                                   function b(b){
		                                    return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                   }
		                                   if(0 === t[0]) return b(t);
		                                   var x = t[1];
		                                   return caml_exact_trampoline_cps_call$1
		   (kasprintf,
		    id,
		    fmt$247,
		    function(a){
		     return caml_trampoline_cps_call3
		             (a, pp$125, x, function(a){return b([1, a]);});
		    });
		                                  });
		                        }
		                        return caml_exact_trampoline_cps_call$0
		                                (add$35,
		                                 0,
		                                 state,
		                                 [0, action, step_id, [0, name]],
		                                 function(t){
		                                  var
		                                   b = 0 === t[0] ? t : [1, "Could not add automation step"];
		                                  return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                 });
		                       });
		                  function b(step_ids, cont){
		                   var automation_id = make$53();
		                   return caml_exact_trampoline_cps_call
		                           (trigger_to_schema,
		                            value$4(trigger, 0),
		                            function(b){
		                             var
		                              new_automation =
		                                make$54([0, automation_id], [0, name], step_ids, 0, [0, b]);
		                             function a(operation, cont){
		                              function a(param, cont){
		                               return cont([0, [0, automation_id]]);
		                              }
		                              return caml_exact_trampoline_cps_call$2
		                                      (apply$125,
		                                       ctrl[1],
		                                       crdt,
		                                       workspace,
		                                       operation,
		                                       function(t){
		function b(b){
		 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		}
		if(0 === t[0]) return b(t);
		var x = t[1];
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$246,
		         function(a){
		          return caml_trampoline_cps_call3
		                  (a, pp$125, x, function(a){return b([1, a]);});
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$0
		                                     (add$33,
		                                      [0, agent_id],
		                                      state,
		                                      new_automation,
		                                      function(t){
		                                       var b = 0 === t[0] ? t : [1, cst_Agent_not_found];
		                                       return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (Sequence_result[16],
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (state$0,
		                          workspace,
		                          ctrl[2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    of_option(b, cst_Workspace_not_found),
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function make_automation_update(ctrl, workspace, param, cont){
		                var trigger = param[3], name = param[2], id$0 = param[1];
		                function a(crdt, cont){
		                 var open = g(include$0), let$ = open[14], let$0 = open[11];
		                 function a(state, cont){
		                  var name$0 = set_field(name);
		                  return caml_exact_trampoline_cps_call$1
		                          (let$0,
		                           set_field(trigger),
		                           function(trigger, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (trigger_to_schema, trigger, cont);
		                           },
		                           function(trigger){
		                            function a(operation, cont){
		                             return caml_exact_trampoline_cps_call$2
		                                     (apply$125,
		                                      ctrl[1],
		                                      crdt,
		                                      workspace,
		                                      operation,
		                                      function(t){
		                                       if(0 === t[0]) return cont(t);
		                                       var x = t[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$248,
		        function(a){
		         return caml_trampoline_cps_call3
		                 (a, pp$125, x, function(a){return cont([1, a]);});
		        });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$3
		                                    (update$8,
		                                     name$0,
		                                     0,
		                                     trigger,
		                                     state,
		                                     id$0,
		                                     function(t){
		                                      var b = 0 === t[0] ? t : [1, cst_Automation_not_found];
		                                      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (state$0,
		                          workspace,
		                          ctrl[2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    of_option(b, cst_Workspace_not_found),
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function make_automation_delete(ctrl, workspace, param, cont){
		                var automation = param[1];
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$2
		                         (delete_automation,
		                          ctrl,
		                          crdt,
		                          workspace,
		                          automation,
		                          function(t){
		                           function a(a){
		                            return caml_trampoline_cps_call2(return$12, a, cont);
		                           }
		                           if(0 === t[0]) return a(t);
		                           var x = t[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$249,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (b, pp$125, x, function(b){return a([1, b]);});
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function make_step_create(ctrl, workspace, param, cont){
		                var
		                 prompt = param[3],
		                 name = param[2],
		                 automation_id = param[1];
		                function a(crdt, cont){
		                 var open = g(include$0), let$ = open[14];
		                 function a(state, cont){
		                  var
		                   step_id = make$52(),
		                   action = [0, prompt_of_string(prompt)];
		                  function a(operation, cont){
		                   return caml_exact_trampoline_cps_call$2
		                           (apply$125,
		                            ctrl[1],
		                            crdt,
		                            workspace,
		                            operation,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (fatal_result,
		                                      bkE,
		                                      a,
		                                      function(match){return cont([0, [0, step_id]]);});
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (add$35,
		                           [0, automation_id],
		                           state,
		                           [0, action, step_id, [0, name]],
		                           function(t){
		                            var b = 0 === t[0] ? t : [1, cst_Automation_not_found];
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (state$0,
		                          workspace,
		                          ctrl[2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    of_option(b, cst_Workspace_not_found),
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function make_step_update(ctrl, workspace, param, cont){
		                var prompt = param[3], name = param[2], id = param[1];
		                function a(crdt, cont){
		                 var open = g(include$0), let$ = open[14];
		                 function a(state, cont){
		                  var
		                   name$0 = set_field(name),
		                   open =
		                     g
		                      ([0,
		                        symbol_bind,
		                        symbol_map$1,
		                        ,
		                        bind,
		                        return$4,
		                        map$3,
		                        ,
		                        ,
		                        ,
		                        ,
		                        Let_syntax]),
		                   let$0 = open[4];
		                  return caml_trampoline_cps_call3
		                          (let$0,
		                           set_field(prompt),
		                           function(prompt, cont){
		                            return cont(prompt_of_string(prompt));
		                           },
		                           function(prompt){
		                            var patch = [0, name$0, prompt];
		                            function a(operation, cont){
		                             return caml_exact_trampoline_cps_call$2
		                                     (apply$125,
		                                      ctrl[1],
		                                      crdt,
		                                      workspace,
		                                      operation,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$1
		       (fatal_result, bkF, a, function(match){return cont(bkG);});
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$0
		                                    (update$10,
		                                     state,
		                                     patch,
		                                     id,
		                                     function(t){
		                                      var b = 0 === t[0] ? t : [1, cst_Step_not_found];
		                                      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (state$0,
		                          workspace,
		                          ctrl[2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    of_option(b, cst_Workspace_not_found),
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function make_step_delete(ctrl, workspace, input, cont){
		                function a(crdt, cont){
		                 var open = g(include$0), let$ = open[14];
		                 function a(state, cont){
		                  function a(operation, cont){
		                   return caml_exact_trampoline_cps_call$2
		                           (apply$125,
		                            ctrl[1],
		                            crdt,
		                            workspace,
		                            operation,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (fatal_result, bkH, a, function(match){return cont(bkI);});
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (remove$22,
		                           state,
		                           input[1],
		                           function(t){
		                            var
		                             b = 0 === t[0] ? t : [1, cst_Cannot_remove_the_last_ste];
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (state$0,
		                          workspace,
		                          ctrl[2],
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    of_option(b, cst_Workspace_not_found),
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(return$12, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function make_automation_run_resume
		               (ctrl, workspace, param, cont){
		                var answers = param[2], id$0 = param[1];
		                function a(crdt, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (ai_state$0,
		                          ctrl,
		                          workspace,
		                          function(match){
		                           function a(run_opt){
		                            if(! run_opt)
		                             return caml_trampoline_cps_call2(return$12, bkQ, cont);
		                            var run = run_opt[1], match = run[7];
		                            if(typeof match !== "number" && 1 === match[0]){
		                             var conversation = match[2], breakpoint = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (of_answers,
		                                      breakpoint[4],
		                                      answers,
		                                      function(match){
		                                       if(! match)
		return caml_exact_trampoline_cps_call
		        (length$1,
		         answers,
		         function(a){
		          var questions = breakpoint[4][1];
		          return caml_exact_trampoline_cps_call
		                  (length$1,
		                   questions,
		                   function(b){
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             fmt$250,
		                             function(c){
		                              return caml_trampoline_cps_call3
		                                      (c,
		                                       b,
		                                       a,
		                                       function(a){
		return caml_trampoline_cps_call2(return$12, [1, a], cont);
		                                       });
		                             });
		                   });
		         });
		                                       var response = match[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (set_status$1,
		        id$0,
		        [2, breakpoint, response, conversation],
		        function(op){
		         return caml_exact_trampoline_cps_call$2
		                 (apply$125,
		                  ctrl[1],
		                  crdt,
		                  workspace,
		                  op,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$1
		                           (fatal_result,
		                            bkO,
		                            a,
		                            function(match){
		                             return caml_trampoline_cps_call2(return$12, bkP, cont);
		                            });
		                  });
		        });
		                                      });
		                            }
		                            return caml_trampoline_cps_call2(return$12, bkN, cont);
		                           }
		                           if(! match) return a(0);
		                           var ai = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (find_packed_by_id, ai[3], id$0, a);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (writable$0,
		                         ctrl[2],
		                         function(b){
		                          return caml_trampoline_cps_call3(let$52, b, a, cont);
		                         });
		               }
		               function build_tools(graph, ctrl, agent_id, workspace, cont){
		                function a(input, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (make_update_working_memory,
		                          graph,
		                          ctrl,
		                          workspace,
		                          agent_id,
		                          input,
		                          cont);
		                }
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (update_working_memory_input_sc,
		                         schematic_version,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (object_schema,
		                                   bkR,
		                                   0,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$9
		    (tool,
		     "updateWorkingMemory",
		     0,
		     0,
		     "Update this agent's working memory with new information to remember across conversations.",
		     write$0(1, 1, 0),
		     b,
		     schematic_param_a_schema_versi,
		     a,
		     function(update_working_memory){
		      function schematic_version(param, cont){return cont(0);}
		      function a(param, cont){
		       return caml_exact_trampoline_cps_call$2
		               (make_automation_list,
		                ctrl,
		                workspace,
		                agent_id,
		                dummy,
		                cont);
		      }
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$271,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "listAutomations",
		                         0,
		                         0,
		                         "List all automations attached to this agent.",
		                         read$2(0),
		                         0,
		                         [0, 0, 0, [3, b], 0],
		                         a,
		                         function(list_automations){
		                          function a(input, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (make_automation_create,
		                                    ctrl,
		                                    workspace,
		                                    agent_id,
		                                    input,
		                                    cont);
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (automation_create_output_schem,
		                                   schematic_version,
		                                   function(b){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (automation_create_input_schema,
		     schematic_version,
		     function(c){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bkS,
		               0,
		               c,
		               function(c){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         cst_createAutomation,
		                         0,
		                         0,
		                         "Create a new automation with steps. Trigger can be Manual, Recurrent, or Commit_pattern.",
		                         write$0(0, 0, 0),
		                         c,
		                         b,
		                         a,
		                         function(create_automation){
		                          function a(input, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (make_automation_update, ctrl, workspace, input, cont);
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (automation_update_input_schema,
		                                   schematic_version,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$0
		    (object_schema,
		     bkT,
		     0,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$9
		              (tool,
		               "updateAutomation",
		               0,
		               0,
		               'Update an automation\'s name or trigger. Use null to leave a field unchanged; use {"update": value} to set it.',
		               write$0(1, 1, 0),
		               b,
		               schematic_param_a_schema_versi,
		               a,
		               function(update_automation){
		                function a(input, cont){
		                 return caml_exact_trampoline_cps_call$0
		                         (make_automation_delete, ctrl, workspace, input, cont);
		                }
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (automation_delete_input_schema,
		                         schematic_version,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (object_schema,
		                                   bkU,
		                                   0,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$9
		    (tool,
		     "deleteAutomation",
		     0,
		     0,
		     "Delete an automation.",
		     write$0(1, 1, 0),
		     b,
		     schematic_param_a_schema_versi,
		     a,
		     function(delete_automation){
		      function a(input, cont){
		       return caml_exact_trampoline_cps_call$0
		               (make_step_create, ctrl, workspace, input, cont);
		      }
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (step_create_output_schema_vers,
		               schematic_version,
		               function(b){
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (step_create_for_automation_inp,
		                         schematic_version,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$0
		                                  (object_schema,
		                                   bkV,
		                                   0,
		                                   c,
		                                   function(c){
		                                    return caml_exact_trampoline_cps_call$9
		    (tool,
		     "createStep",
		     0,
		     0,
		     "Create a new step in an automation.",
		     write$0(0, 0, 0),
		     c,
		     b,
		     a,
		     function(create_step){
		      function a(input, cont){
		       return caml_exact_trampoline_cps_call$0
		               (make_step_update, ctrl, workspace, input, cont);
		      }
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (step_update_input_schema_versi,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call$0
		                        (object_schema,
		                         bkW,
		                         0,
		                         b,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$9
		                                  (tool,
		                                   "updateStep",
		                                   0,
		                                   0,
		                                   'Update a step\'s name or prompt. Use null to leave a field unchanged; use {"update": value} to set it.',
		                                   write$0(1, 1, 0),
		                                   b,
		                                   no_input_schema,
		                                   a,
		                                   function(update_step){
		                                    function a(input, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (make_step_delete, ctrl, workspace, input, cont);
		                                    }
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (step_delete_input_schema_versi,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bkX,
		               0,
		               b,
		               function(b){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "deleteStep",
		                         0,
		                         0,
		                         "Delete a step from its automation.",
		                         write$0(1, 1, 0),
		                         b,
		                         no_input_schema,
		                         a,
		                         function(delete_step){
		                          function a(input, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (ai_state$0,
		                                    ctrl,
		                                    workspace,
		                                    function(match){
		                                     if(! match)
		                                      return caml_trampoline_cps_call2(return$12, bkK, cont);
		                                     var ai = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      ai[4],
		      input[1],
		      function(match){
		       if(! match)
		        return caml_trampoline_cps_call2(return$12, bkJ, cont);
		       var automation = match[1];
		       return caml_trampoline_cps_call2
		               (return$12, [0, automation], cont);
		      });
		                                    });
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$271,
		                                   schematic_version,
		                                   function(b){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (automation_get_input_schema_ve,
		     schematic_version,
		     function(c){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bkY,
		               0,
		               c,
		               function(c){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "getAutomation",
		                         0,
		                         0,
		                         "Get an automation by ID.",
		                         read$2(0),
		                         c,
		                         b,
		                         a,
		                         function(get_automation){
		                          function a(input, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (ai_state$0,
		                                    ctrl,
		                                    workspace,
		                                    function(match){
		                                     if(! match)
		                                      return caml_trampoline_cps_call2(return$12, bkM, cont);
		                                     var ai = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      ai[3],
		      input[1],
		      function(match){
		       if(! match)
		        return caml_trampoline_cps_call2(return$12, bkL, cont);
		       var run = match[1];
		       return caml_trampoline_cps_call2(return$12, [0, run], cont);
		      });
		                                    });
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$282,
		                                   schematic_version,
		                                   function(b){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (automation_run_get_input_schem,
		     schematic_version,
		     function(c){
		      return caml_exact_trampoline_cps_call$0
		              (object_schema,
		               bkZ,
		               0,
		               c,
		               function(c){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         "getAutomationRun",
		                         0,
		                         0,
		                         "Get an automation run by ID, including its status and step results.",
		                         read$2(0),
		                         c,
		                         b,
		                         a,
		                         function(get_automation_run){
		                          function a(input, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (make_automation_run_resume, ctrl, workspace, input, cont);
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (automation_run_resume_input_sc,
		                                   schematic_version,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$0
		    (object_schema,
		     bk0,
		     0,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$9
		              (tool,
		               "resumeAutomationRun",
		               0,
		               0,
		               "Provide the user's answer and resume a paused automation run that is waiting for user input.",
		               write$0(1, 0, 1),
		               b,
		               no_input_schema,
		               a,
		               function(resume_automation_run){
		                return cont
		                        ([0,
		                          update_working_memory,
		                          [0,
		                           list_automations,
		                           [0,
		                            create_automation,
		                            [0,
		                             update_automation,
		                             [0,
		                              delete_automation,
		                              [0,
		                               create_step,
		                               [0,
		                                update_step,
		                                [0,
		                                 delete_step,
		                                 [0,
		                                  get_automation,
		                                  [0, get_automation_run, [0, resume_automation_run, 0]]]]]]]]]]]);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var cst$30 = "__", cj = 1;
		               function sanitize(name, cont){
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         name,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter$1,
		                                   a,
		                                   function(c){
		                                    var a = is_alphanum(c);
		                                    if(a)
		                                     ;
		                                    else {a = c === 95 ? 1 : 0; if(! a) return c === 32 ? 1 : 0;}
		                                    return a;
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (substr_replace_all_gen,
		     cj,
		     a,
		     cst$7,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (a,
		               cst$13,
		               function(a){
		                return caml_exact_trampoline_cps_call$0
		                        (substr_replace_all_gen,
		                         cj,
		                         a,
		                         cst$30,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(a, cst$13, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function generated_name(server, tool, cont){
		                return caml_exact_trampoline_cps_call
		                        (Id$8[8],
		                         server[1],
		                         function(server_id){
		                          var tool_name = tool[1], server_name = server[2];
		                          return caml_exact_trampoline_cps_call
		                                  (sanitize,
		                                   tool_name,
		                                   function(s2){
		                                    var s2$0 = cst$13 + s2;
		                                    return caml_exact_trampoline_cps_call
		    (sanitize,
		     server_name,
		     function(s1){
		      var base = s1 + s2$0;
		      return caml_exact_trampoline_cps_call$1
		              (prefix,
		               base,
		               64,
		               function(base){
		                var s2 = cst$21 + tool_name, input = server_id + s2;
		                return caml_exact_trampoline_cps_call
		                        (to_hex,
		                         string(input),
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (prefix,
		                                   a,
		                                   8,
		                                   function(hash){
		                                    var
		                                     max_base = (64 - caml_ml_string_length(hash) | 0) - 1 | 0,
		                                     s2 = cst$13 + hash;
		                                    return caml_exact_trampoline_cps_call$1
		    (prefix,
		     base,
		     max_base,
		     function(s1){return cont(s1 + s2);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function tool_allowed(trust, t){return trust ? 1 : t[4][1];}
		               function duplicate_name(servers, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (concat_map,
		                         servers,
		                         function(server, cont){
		                          var a = server[6];
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter,
		                                   server[7],
		                                   function(b, cont){return cont(tool_allowed(a, b));},
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (map$7,
		     a,
		     function(a, cont){
		      return caml_exact_trampoline_cps_call$1
		              (generated_name, server, a, cont);
		     },
		     cont);
		                                   });
		                         },
		                         function(names){
		                          var seen = empty$8([0, comparator$2]);
		                          function a(seen, param){
		                           if(! param) return cont(0);
		                           var names = param[2], name = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (mem$3,
		                                    seen,
		                                    name,
		                                    function(b){
		                                     return b
		     ? cont([0, name])
		     : caml_exact_trampoline_cps_call$1
		       (add$4,
		        seen,
		        name,
		        function(seen){
		         return caml_exact_trampoline_call2(a, seen, names);
		        });
		                                    });
		                          }
		                          return a(seen, names);
		                         });
		               }
		               function register_server(server, cont){
		                var a = server[6];
		                return caml_exact_trampoline_cps_call$1
		                        (filter,
		                         server[7],
		                         function(b, cont){return cont(tool_allowed(a, b));},
		                         function(allowed){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$7,
		                                   allowed,
		                                   function(t, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (generated_name,
		     server,
		     t,
		     function(name){
		      function a(description){
		       var schema = t[3], a = t[4];
		       function c(arguments$, cont){
		        return caml_exact_trampoline_cps_call$0
		                (call_tool, server, t[1], arguments$, cont);
		       }
		       var world = a[4] ? 1 : 0;
		       if(a[1])
		        var b = read$2(world);
		       else {b = value$4(a[3], 0); b = write$0(a[2], b, world);}
		       return caml_exact_trampoline_cps_call$9
		               (tool,
		                name,
		                0,
		                0,
		                description,
		                b,
		                [1, schema],
		                no_input_schema,
		                c,
		                cont);
		      }
		      if(! is_empty$0(t[2])) return a(t[2]);
		      var b = server[2], c = t[1];
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$251,
		               function(d){return caml_trampoline_cps_call3(d, c, b, a);});
		     });
		                                   },
		                                   function(fns){
		                                    if(! fns) return cont(0);
		                                    var a = server[2];
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$252,
		     function(b){
		      return caml_trampoline_cps_call2
		              (b,
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (sanitize,
		                         server[2],
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (namespace, b, a, fns, function(a){return cont([0, a, 0]);});
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                descriptor$59 =
		                  [7,
		                   function(param, cont){return cont(0);},
		                   function(param, cont){return cont(0);},
		                   0];
		               function action$0
		               (action_id, name, description, behavior, schema){
		                return [0,
		                        action_id,
		                        name,
		                        description,
		                        behavior,
		                        schema,
		                        1,
		                        0];
		               }
		               function non_strict_action
		               (action_id, name, description, behavior, schema){
		                return [0,
		                        action_id,
		                        name,
		                        description,
		                        behavior,
		                        schema,
		                        0,
		                        0];
		               }
		               var json_object_schema = mapping_schema(no_input_schema);
		               function integration_call_input_schema
		               (schematic_param_input_schema_v, cont){
		                function descriptor(schematic_param_input_schema_v){
		                 return [7,
		                         function(param, cont){
		                          var input = param[2][1], connection_id = param[1];
		                          return cont([0, connection_id, input]);
		                         },
		                         function(param, cont){
		                          var input = param[2], connection_id = param[1];
		                          return cont([0, connection_id, [0, input, 0]]);
		                         },
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_connectionId,
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_input,
		                            0,
		                            2,
		                            [0, schematic_param_input_schema_v],
		                            0,
		                            0],
		                           0]]];
		                }
		                var
		                 schematic_schema_id = match$354[1],
		                 schematic_parametric =
		                   [0,
		                    [1,
		                     cst_input,
		                     schematic_param_input_schema_v,
		                     function(schematic_param_input_schema_v, cont){
		                      return cont
		                              ([0,
		                                schematic_schema_id,
		                                descriptor(schematic_param_input_schema_v)]);
		                     }]],
		                 a = descriptor(schematic_param_input_schema_v),
		                 parametric = schematic_parametric[1];
		                return caml_exact_trampoline_cps_call
		                        (of_parametric,
		                         parametric,
		                         function(match){
		                          function b(b){
		                           return cont([0, b, 0, a, schematic_parametric]);
		                          }
		                          if(! match) return b(0);
		                          var name = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (to_id, name, function(a){return b([0, a]);});
		                         });
		               }
		               var
		                schematic_cache$1030 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$1070 = [];
		               caml_update_dummy
		                (letrec_function_context$1070, [0, schematic_cache$1030]);
		               var schematic_schema_version$35 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$1070[1][1],
		                    schematic_schema_version$35]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$1070[1][1],
		                             schematic_schema_version$35,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$1070[1][1],
		schematic_schema_version$35,
		schematic_self,
		function(a){
		 letrec_function_context$1070[1][1] = a;
		 var
		  res =
		    [7,
		     function(param, cont){
		      var a = param[2], m = a[2][1], p = a[1], t = param[1];
		      return cont([0, t, p, m]);
		     },
		     function(param, cont){
		      var m = param[3], p = param[2], t = param[1];
		      return cont([0, t, [0, p, [0, m, 0]]]);
		     },
		     [0,
		      [0,
		       0,
		       0,
		       0,
		       0,
		       cst_t,
		       0,
		       2,
		       [0, schematic_param_name_schema_ve],
		       0,
		       0],
		      [0,
		       [0,
		        0,
		        0,
		        0,
		        0,
		        cst_p,
		        0,
		        2,
		        [0, schematic_param_name_schema_ve],
		        0,
		        0],
		       [0,
		        [0,
		         0,
		         0,
		         0,
		         0,
		         cst_m,
		         0,
		         2,
		         [0, schematic_param_name_schema_ve],
		         0,
		         0],
		        0]]]];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$1070[1][1],
		          schematic_schema_version$35,
		          res,
		          function(a){
		           letrec_function_context$1070[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               function make_tool_name
		               (integration_name, operation_name, operation_key, seen, cont){
		                return caml_exact_trampoline_cps_call
		                        (lowercase_ascii$0,
		                         operation_name,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter$1,
		                                   a,
		                                   function(c){
		                                    var a = is_alphanum(c);
		                                    if(a)
		                                     ;
		                                    else {a = c === 32 ? 1 : 0; if(! a) return c === 95 ? 1 : 0;}
		                                    return a;
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (substr_replace_all_gen,
		     cj,
		     a,
		     cst$7,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (a,
		               cst$13,
		               function(a){
		                return caml_exact_trampoline_cps_call$0
		                        (substr_replace_all_gen,
		                         cj,
		                         a,
		                         cst$30,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (a,
		                                   cst$13,
		                                   function(base_name){
		                                    var
		                                     s2 = cst$13 + base_name,
		                                     base_tool_name = integration_name + s2;
		                                    return caml_exact_trampoline_cps_call$1
		    (prefix,
		     base_tool_name,
		     64,
		     function(truncated){
		      return caml_exact_trampoline_cps_call$1
		              (mem$3,
		               seen,
		               truncated,
		               function(a){
		                if(! a) return cont(truncated);
		                return caml_exact_trampoline_cps_call
		                        (to_hex,
		                         string(operation_key),
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (prefix,
		                                   a,
		                                   8,
		                                   function(hash){
		                                    var
		                                     max_base_len =
		                                       (64 - caml_ml_string_length(hash) | 0) - 1 | 0,
		                                     s2 = cst$13 + hash;
		                                    return caml_exact_trampoline_cps_call$1
		    (prefix,
		     truncated,
		     max_base_len,
		     function(s1){return cont(s1 + s2);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function run_integration_action
		               (ctrl,
		                organization_id,
		                connection_id,
		                action_id,
		                extra_input,
		                input_schema,
		                input,
		                cont){
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          function a(input, cont){
		                           function a(result, cont){
		                            if(0 === result[0]){
		                             var json = result[1];
		                             return caml_trampoline_cps_call2(return$12, [0, json], cont);
		                            }
		                            var err = result[1];
		                            return caml_exact_trampoline_cps_call$1
		                                    (to_to_string,
		                                     pp$125,
		                                     err,
		                                     function(err_str){
		                                      function a(param, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$253,
		        function(a){
		         return caml_trampoline_cps_call2
		                 (a,
		                  err_str,
		                  function(a){
		                   return caml_trampoline_cps_call2(return$12, [1, a], cont);
		                  });
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (Lwt[4],
		       function(m, cont){
		        return caml_trampoline_cps_call7
		                (m, 0, 0, bk3, action_id, connection_id, err_str, cont);
		       },
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (symbol_bind$6, b, a, cont);
		       });
		                                     });
		                           }
		                           return caml_trampoline_cps_call7
		                                   (Api[5][2],
		                                    api,
		                                    organization_id,
		                                    connection_id,
		                                    action_id,
		                                    no_input_schema,
		                                    input,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_bind$6, b, a, cont);
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (encode$4,
		                                   input_schema,
		                                   input,
		                                   function(encoded){
		                                    function b(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol_bind$6, b, a, cont);
		                                    }
		                                    if(! extra_input)
		                                     return caml_trampoline_cps_call2(return$12, encoded, b);
		                                    if(typeof encoded !== "number"){
		                                     var variant = encoded[1];
		                                     if(79 === variant){
		                                      var fields = encoded[2];
		                                      return caml_exact_trampoline_cps_call$1
		      (filter,
		       fields,
		       function(param, cont){
		        var key = param[1];
		        return caml_exact_trampoline_cps_call$0
		                (mem$0,
		                 extra_input,
		                 equal$4,
		                 key,
		                 function(a){return cont(1 - a);});
		       },
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (append$0,
		                 a,
		                 extra_input,
		                 function(a){
		                  return caml_trampoline_cps_call2(return$12, [0, 79, a], b);
		                 });
		       });
		                                     }
		                                    }
		                                    function f(param, cont){return cont(encoded);}
		                                    return caml_exact_trampoline_cps_call
		    (Lwt[4],
		     function(m, cont){
		      return caml_exact_trampoline_cps_call$1
		              (map$7,
		               extra_input,
		               calendar,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (concat$0,
		                         bk1,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, bk2, action_id, a, cont);
		                         });
		               });
		     },
		     function(x){
		      return caml_exact_trampoline_cps_call$1(symbol$90, f, x, b);
		     });
		                                   });
		                         });
		               }
		               function register_tools
		               (ctrl, organization_id, integration_name, tools_list, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (fold_map,
		                         tools_list,
		                         empty$8([0, comparator$2]),
		                         function(seen, param, cont){
		                          var
		                           extra_input = param[7],
		                           strict = param[6],
		                           input_schema = param[5],
		                           behavior = param[4],
		                           description = param[3],
		                           name = param[2],
		                           action_id = param[1];
		                          return caml_exact_trampoline_cps_call$2
		                                  (make_tool_name,
		                                   integration_name,
		                                   name,
		                                   action_id,
		                                   seen,
		                                   function(tool_name){
		                                    return caml_exact_trampoline_cps_call
		    (integration_call_input_schema,
		     input_schema,
		     function(call_input_schema){
		      function a(input, cont){
		       return caml_exact_trampoline_cps_call$8
		               (run_integration_action,
		                ctrl,
		                organization_id,
		                input[1],
		                action_id,
		                extra_input,
		                input_schema,
		                input[2],
		                cont);
		      }
		      return caml_exact_trampoline_cps_call$1
		              (of_object_exn,
		               0,
		               call_input_schema,
		               function(b){
		                return caml_exact_trampoline_cps_call$9
		                        (tool,
		                         tool_name,
		                         0,
		                         0,
		                         description,
		                         behavior,
		                         [0, b, strict],
		                         no_input_schema,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (add$4,
		                                   seen,
		                                   tool_name,
		                                   function(b){return cont([0, b, a]);});
		                         });
		               });
		     });
		                                   });
		                         },
		                         function(match){var tools = match[2]; return cont(tools);});
		               }
		               var
		                cst_linkedin_url = "linkedin_url",
		                cst_organization_name = "organization_name",
		                letrec_function_context$1071 = [];
		               function input_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1071[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bk4, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1071[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1071[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1071[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$355[1],
		                             a =
		                               [0,
		                                [0,
		                                 bk5,
		                                 0,
		                                 0,
		                                 0,
		                                 "reveal_phone_number",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$356[1],
		                                       b =
		 [0,
		  [0,
		   bk6,
		   0,
		   0,
		   0,
		   "reveal_personal_emails",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$357[1],
		         a =
		           [0,
		            [0,
		             bk7,
		             0,
		             0,
		             0,
		             cst_linkedin_url,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$358[1],
		                   b =
		                     [0,
		                      [0,
		                       bk8,
		                       0,
		                       0,
		                       0,
		                       cst_organization_name,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$359[1],
		                             a =
		                               [0,
		                                [0,
		                                 bk9,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_domain,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$360[1],
		                                       b =
		 [0,
		  [0, bk_, 0, 0, 0, cst_email, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$361[1],
		         a =
		           [0,
		            [0, bk$, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$362[1],
		                   b =
		                     [0,
		                      [0,
		                       bla,
		                       0,
		                       0,
		                       0,
		                       cst_last_name,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$363[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  reveal_phone_number = g[2][1],
		                                  reveal_personal_emails = g[1],
		                                  linkedin_url = f[1],
		                                  organization_name = e[1],
		                                  domain = d[1],
		                                  email = c[1],
		                                  name = b[1],
		                                  last_name = a[1],
		                                  first_name = param[1];
		                                 return cont
		 ([0,
		   first_name,
		   last_name,
		   name,
		   email,
		   domain,
		   organization_name,
		   linkedin_url,
		   reveal_personal_emails,
		   reveal_phone_number]);
		                                },
		                                function(param, cont){
		                                 var
		                                  reveal_phone_number = param[9],
		                                  reveal_personal_emails = param[8],
		                                  linkedin_url = param[7],
		                                  organization_name = param[6],
		                                  domain = param[5],
		                                  email = param[4],
		                                  name = param[3],
		                                  last_name = param[2],
		                                  first_name = param[1];
		                                 return cont
		 ([0,
		   first_name,
		   [0,
		    last_name,
		    [0,
		     name,
		     [0,
		      email,
		      [0,
		       domain,
		       [0,
		        organization_name,
		        [0,
		         linkedin_url,
		         [0, reveal_personal_emails, [0, reveal_phone_number, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  blb,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_first_name,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1071[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1071[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1031 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1071, [0, schematic_cache$1031]);
		               caml_callback
		                (input_schema_versioned, [function(param){return 0;}]);
		               function schematic_version$138(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned, [schematic_version$138]),
		                action$1 =
		                  action$0
		                   ("69688b4856a492a6ebe92e6c",
		                    "Enrich Person",
		                    "Enrich data for a person using Apollo's database. Provide identifying information like name, email, or domain to find a match. Example: {email: 'jane@apollo.io', domain: 'apollo.io'}.",
		                    read$2(1),
		                    e),
		                letrec_function_context$1072 = [];
		               function input_schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1072[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, blc, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1072[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1072[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1072[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var domain = param[1];
		                       return cont([0, domain]);
		                      },
		                      function(param, cont){
		                       var domain = param[1];
		                       return cont([0, domain, 0]);
		                      },
		                      [0,
		                       [0,
		                        bld,
		                        0,
		                        0,
		                        0,
		                        cst_domain,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1072[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1072[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1032 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1072, [0, schematic_cache$1032]);
		               caml_callback
		                (input_schema_versioned$0, [function(param){return 0;}]);
		               function schematic_version$139(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$0, [schematic_version$139]),
		                action$2 =
		                  action$0
		                   ("69688b4856a492a6ebe92e68",
		                    "Enrich Organization",
		                    "Enrich data for a company using Apollo's database. Returns industry, revenue, employee counts, funding, and contact information. Example: {domain: 'apollo.io'}.",
		                    read$2(1),
		                    e),
		                cst_organization_locations = "organization_locations",
		                cst_organization_num_employees =
		                  "organization_num_employees_ranges",
		                cst_per_page = "per_page",
		                cst_q_keywords = "q_keywords",
		                letrec_function_context$1073 = [];
		               function input_schema_versioned$1(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1073[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, ble, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1073[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1073[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1073[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$364[1],
		                             a =
		                               [0,
		                                [0,
		                                 blf,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_per_page,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$365[1],
		                                       b =
		 [0,
		  [0, blg, 0, 0, 0, cst_page, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$366[1],
		         a =
		           [0,
		            [0,
		             blh,
		             0,
		             0,
		             0,
		             cst_organization_num_employees,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(c){
		                  var
		                   default$ = match$367[1],
		                   b =
		                     [0,
		                      [0,
		                       bli,
		                       0,
		                       0,
		                       0,
		                       "person_locations",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(c){
		                            var
		                             default$ = match$368[1],
		                             a =
		                               [0,
		                                [0,
		                                 blj,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_organization_locations,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$369[1],
		                                       b =
		 [0,
		  [0,
		   blk,
		   0,
		   0,
		   0,
		   "q_organization_domains",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$370[1],
		         a =
		           [0,
		            [0,
		             bll,
		             0,
		             0,
		             0,
		             "person_seniorities",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(c){
		                  var
		                   default$ = match$371[1],
		                   b =
		                     [0,
		                      [0,
		                       blm,
		                       0,
		                       0,
		                       0,
		                       "person_titles",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$372[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  per_page = g[2][1],
		                                  page = g[1],
		                                  organization_num_employees_ran = f[1],
		                                  person_locations = e[1],
		                                  organization_locations = d[1],
		                                  q_organization_domains = c[1],
		                                  person_seniorities = b[1],
		                                  person_titles = a[1],
		                                  q_keywords = param[1];
		                                 return cont
		 ([0,
		   q_keywords,
		   person_titles,
		   person_seniorities,
		   q_organization_domains,
		   organization_locations,
		   person_locations,
		   organization_num_employees_ran,
		   page,
		   per_page]);
		                                },
		                                function(param, cont){
		                                 var
		                                  per_page = param[9],
		                                  page = param[8],
		                                  organization_num_employees_ran = param[7],
		                                  person_locations = param[6],
		                                  organization_locations = param[5],
		                                  q_organization_domains = param[4],
		                                  person_seniorities = param[3],
		                                  person_titles = param[2],
		                                  q_keywords = param[1];
		                                 return cont
		 ([0,
		   q_keywords,
		   [0,
		    person_titles,
		    [0,
		     person_seniorities,
		     [0,
		      q_organization_domains,
		      [0,
		       organization_locations,
		       [0,
		        person_locations,
		        [0,
		         organization_num_employees_ran,
		         [0, page, [0, per_page, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bln,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_q_keywords,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1073[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1073[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1033 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1073, [0, schematic_cache$1033]);
		               caml_callback
		                (input_schema_versioned$1, [function(param){return 0;}]);
		               function schematic_version$140(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$1, [schematic_version$140]),
		                d = "Search People",
		                action$3 =
		                  action$0
		                   ("69688b4856a492a6ebe92e64",
		                    d,
		                    "Search for people in Apollo's database using filters. Optimised for prospecting net-new people; does not consume credits. Example: {person_titles: ['VP of Sales'], q_organization_domains: ['acme.com']}.",
		                    read$2(1),
		                    e),
		                cst_sort_ascending = "sort_ascending",
		                cst_sort_by_field = "sort_by_field",
		                letrec_function_context$1074 = [];
		               function input_schema_versioned$2(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1074[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, blo, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1074[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1074[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1074[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$373[1],
		                             a =
		                               [0,
		                                [0,
		                                 blp,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_per_page,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$374[1],
		                                       b =
		 [0,
		  [0, blq, 0, 0, 0, cst_page, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$375[1],
		         a =
		           [0,
		            [0,
		             blr,
		             0,
		             0,
		             0,
		             cst_sort_ascending,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$376[1],
		                   b =
		                     [0,
		                      [0,
		                       bls,
		                       0,
		                       0,
		                       0,
		                       cst_sort_by_field,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(c){
		                            var
		                             default$ = match$377[1],
		                             a =
		                               [0,
		                                [0,
		                                 blt,
		                                 0,
		                                 0,
		                                 0,
		                                 "contact_stage_ids",
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$378[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    per_page = d[2][1],
		    page = d[1],
		    sort_ascending = c[1],
		    sort_by_field = b[1],
		    contact_stage_ids = a[1],
		    q_keywords = param[1];
		   return cont
		           ([0,
		             q_keywords,
		             contact_stage_ids,
		             sort_by_field,
		             sort_ascending,
		             page,
		             per_page]);
		  },
		  function(param, cont){
		   var
		    per_page = param[6],
		    page = param[5],
		    sort_ascending = param[4],
		    sort_by_field = param[3],
		    contact_stage_ids = param[2],
		    q_keywords = param[1];
		   return cont
		           ([0,
		             q_keywords,
		             [0,
		              contact_stage_ids,
		              [0,
		               sort_by_field,
		               [0, sort_ascending, [0, page, [0, per_page, 0]]]]]]);
		  },
		  [0,
		   [0,
		    blu,
		    0,
		    0,
		    0,
		    cst_q_keywords,
		    0,
		    [0, default$],
		    [0, b],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1074[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1074[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1034 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1074, [0, schematic_cache$1034]);
		               caml_callback
		                (input_schema_versioned$2, [function(param){return 0;}]);
		               function schematic_version$141(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$2, [schematic_version$141]),
		                action$4 =
		                  action$0
		                   ("69688b4856a492a6ebe92e50",
		                    "Search Contacts",
		                    "Search for contacts in your Apollo account. Example: {q_keywords: 'Jane Doe', per_page: 25}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1075 = [];
		               function input_schema_versioned$3(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1075[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, blv, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1075[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1075[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1075[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        blw,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1075[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1075[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1035 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1075, [0, schematic_cache$1035]);
		               caml_callback
		                (input_schema_versioned$3, [function(param){return 0;}]);
		               function schematic_version$142(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$3, [schematic_version$142]),
		                action$5 =
		                  action$0
		                   ("69688b4856a492a6ebe92e54",
		                    "Get Contact",
		                    "Retrieve a contact by ID from your Apollo account. Example: {id: 'abc123'}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1076 = [];
		               function phone_number_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1076[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, blx, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1076[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1076[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1076[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$379[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var type = param[2][1], raw_number = param[1];
		                                 return cont([0, raw_number, type]);
		                                },
		                                function(param, cont){
		                                 var type = param[2], raw_number = param[1];
		                                 return cont([0, raw_number, [0, type, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  blz,
		                                  0,
		                                  0,
		                                  0,
		                                  "raw_number",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bly, 0, 0, 0, cst_type, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1076[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1076[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1036 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1076, [0, schematic_cache$1036]);
		               caml_callback
		                (phone_number_schema_versioned, [function(param){return 0;}]);
		               var
		                cst_account_id = "account_id",
		                cst_label_names = "label_names",
		                cst_owner_id = "owner_id",
		                letrec_function_context$1077 = [];
		               function input_schema_versioned$4(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1077[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, blA, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1077[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1077[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1077[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$380[1],
		                             a =
		                               [0,
		                                [0,
		                                 blB,
		                                 0,
		                                 0,
		                                 0,
		                                 "run_dedupe",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$381[1],
		                                       b =
		 [0,
		  [0,
		   blC,
		   0,
		   0,
		   0,
		   cst_owner_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$382[1],
		         a =
		           [0,
		            [0,
		             blD,
		             0,
		             0,
		             0,
		             cst_label_names,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$383[1],
		                   b =
		                     [0,
		                      [0,
		                       blE,
		                       0,
		                       0,
		                       0,
		                       "present_raw_address",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (phone_number_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, a], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$384[1],
		                                       a =
		 [0,
		  [0,
		   blF,
		   0,
		   0,
		   0,
		   "phone_numbers",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$385[1],
		         b =
		           [0,
		            [0,
		             blG,
		             0,
		             0,
		             0,
		             cst_linkedin_url,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$386[1],
		                   a =
		                     [0,
		                      [0,
		                       blH,
		                       0,
		                       0,
		                       0,
		                       "website_url",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$387[1],
		                             b =
		                               [0,
		                                [0,
		                                 blI,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_account_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$388[1],
		                                       a =
		 [0,
		  [0,
		   blJ,
		   0,
		   0,
		   0,
		   cst_organization_name,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$389[1],
		         b =
		           [0,
		            [0, blK, 0, 0, 0, cst_title, 0, [0, default$], [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$390[1],
		                   a =
		                     [0,
		                      [0, blL, 0, 0, 0, cst_email, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$391[1],
		                             b =
		                               [0,
		                                [0,
		                                 blM,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_last_name,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(a){
		                                      var
		                                       default$ = match$392[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    j = i[2],
		    k = j[2],
		    run_dedupe = k[2][1],
		    owner_id = k[1],
		    label_names = j[1],
		    present_raw_address = i[1],
		    phone_numbers = h[1],
		    linkedin_url = g[1],
		    website_url = f[1],
		    account_id = e[1],
		    organization_name = d[1],
		    title = c[1],
		    email = b[1],
		    last_name = a[1],
		    first_name = param[1];
		   return cont
		           ([0,
		             first_name,
		             last_name,
		             email,
		             title,
		             organization_name,
		             account_id,
		             website_url,
		             linkedin_url,
		             phone_numbers,
		             present_raw_address,
		             label_names,
		             owner_id,
		             run_dedupe]);
		  },
		  function(param, cont){
		   var
		    run_dedupe = param[13],
		    owner_id = param[12],
		    label_names = param[11],
		    present_raw_address = param[10],
		    phone_numbers = param[9],
		    linkedin_url = param[8],
		    website_url = param[7],
		    account_id = param[6],
		    organization_name = param[5],
		    title = param[4],
		    email = param[3],
		    last_name = param[2],
		    first_name = param[1];
		   return cont
		           ([0,
		             first_name,
		             [0,
		              last_name,
		              [0,
		               email,
		               [0,
		                title,
		                [0,
		                 organization_name,
		                 [0,
		                  account_id,
		                  [0,
		                   website_url,
		                   [0,
		                    linkedin_url,
		                    [0,
		                     phone_numbers,
		                     [0,
		                      present_raw_address,
		                      [0, label_names, [0, owner_id, [0, run_dedupe, 0]]]]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    blN,
		    0,
		    0,
		    0,
		    cst_first_name,
		    0,
		    [0, default$],
		    [0, a],
		    0,
		    0],
		   b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1077[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1077[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1037 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1077, [0, schematic_cache$1037]);
		               caml_callback
		                (input_schema_versioned$4, [function(param){return 0;}]);
		               function schematic_version$143(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$4, [schematic_version$143]),
		                action$6 =
		                  action$0
		                   ("69688b4856a492a6ebe92e5c",
		                    "Create Contact",
		                    "Create a new contact in your Apollo account. Example: {first_name: 'Jane', last_name: 'Doe', email: 'jane@acme.com', title: 'VP of Sales', organization_name: 'Acme'}.",
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1078 = [];
		               function input_schema_versioned$5(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1078[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, blO, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1078[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1078[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1078[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(b){
		                            var
		                             default$ = match$393[1],
		                             a =
		                               [0,
		                                [0,
		                                 blP,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_label_names,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$394[1],
		                                       b =
		 [0,
		  [0,
		   blQ,
		   0,
		   0,
		   0,
		   cst_owner_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$395[1],
		         a =
		           [0,
		            [0,
		             blR,
		             0,
		             0,
		             0,
		             cst_account_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$396[1],
		                   b =
		                     [0,
		                      [0,
		                       blS,
		                       0,
		                       0,
		                       0,
		                       cst_organization_name,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$397[1],
		                             a =
		                               [0,
		                                [0, blT, 0, 0, 0, cst_title, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$398[1],
		                                       b =
		 [0,
		  [0, blU, 0, 0, 0, cst_email, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$399[1],
		         a =
		           [0,
		            [0,
		             blV,
		             0,
		             0,
		             0,
		             cst_last_name,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$400[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        label_names = g[2][1],
		                        owner_id = g[1],
		                        account_id = f[1],
		                        organization_name = e[1],
		                        title = d[1],
		                        email = c[1],
		                        last_name = b[1],
		                        first_name = a[1],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 first_name,
		                                 last_name,
		                                 email,
		                                 title,
		                                 organization_name,
		                                 account_id,
		                                 owner_id,
		                                 label_names]);
		                      },
		                      function(param, cont){
		                       var
		                        label_names = param[9],
		                        owner_id = param[8],
		                        account_id = param[7],
		                        organization_name = param[6],
		                        title = param[5],
		                        email = param[4],
		                        last_name = param[3],
		                        first_name = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0,
		                                  first_name,
		                                  [0,
		                                   last_name,
		                                   [0,
		                                    email,
		                                    [0,
		                                     title,
		                                     [0,
		                                      organization_name,
		                                      [0, account_id, [0, owner_id, [0, label_names, 0]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        blX,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         blW,
		                         0,
		                         0,
		                         0,
		                         cst_first_name,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1078[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1078[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1038 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1078, [0, schematic_cache$1038]);
		               caml_callback
		                (input_schema_versioned$5, [function(param){return 0;}]);
		               function schematic_version$144(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$5, [schematic_version$144]),
		                action$7 =
		                  action$0
		                   ("69688b4856a492a6ebe92e58",
		                    "Update Contact",
		                    "Update an existing contact in your Apollo account. Example: {id: 'abc123', title: 'Director of Sales', label_names: ['hot-lead']}.",
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1079 = [];
		               function input_schema_versioned$6(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1079[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, blY, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1079[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1079[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1079[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$401[1],
		                             a =
		                               [0,
		                                [0,
		                                 blZ,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_per_page,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$402[1],
		                                       b =
		 [0,
		  [0, bl0, 0, 0, 0, cst_page, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$403[1],
		         a =
		           [0,
		            [0,
		             bl1,
		             0,
		             0,
		             0,
		             "organization_industry_tag_ids",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(c){
		                  var
		                   default$ = match$404[1],
		                   b =
		                     [0,
		                      [0,
		                       bl2,
		                       0,
		                       0,
		                       0,
		                       cst_organization_num_employees,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(c){
		                            var
		                             default$ = match$405[1],
		                             a =
		                               [0,
		                                [0,
		                                 bl3,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_organization_locations,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$406[1],
		                                       b =
		 [0,
		  [0,
		   bl4,
		   0,
		   0,
		   0,
		   "q_organization_keyword_tags",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$407[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              per_page = e[2][1],
		              page = e[1],
		              organization_industry_tag_ids = d[1],
		              organization_num_employees_ran = c[1],
		              organization_locations = b[1],
		              q_organization_keyword_tags = a[1],
		              q_organization_name = param[1];
		             return cont
		                     ([0,
		                       q_organization_name,
		                       q_organization_keyword_tags,
		                       organization_locations,
		                       organization_num_employees_ran,
		                       organization_industry_tag_ids,
		                       page,
		                       per_page]);
		            },
		            function(param, cont){
		             var
		              per_page = param[7],
		              page = param[6],
		              organization_industry_tag_ids = param[5],
		              organization_num_employees_ran = param[4],
		              organization_locations = param[3],
		              q_organization_keyword_tags = param[2],
		              q_organization_name = param[1];
		             return cont
		                     ([0,
		                       q_organization_name,
		                       [0,
		                        q_organization_keyword_tags,
		                        [0,
		                         organization_locations,
		                         [0,
		                          organization_num_employees_ran,
		                          [0,
		                           organization_industry_tag_ids,
		                           [0, page, [0, per_page, 0]]]]]]]);
		            },
		            [0,
		             [0,
		              bl5,
		              0,
		              0,
		              0,
		              "q_organization_name",
		              0,
		              [0, default$],
		              [0, a],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1079[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1079[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1039 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1079, [0, schematic_cache$1039]);
		               caml_callback
		                (input_schema_versioned$6, [function(param){return 0;}]);
		               function schematic_version$145(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$6, [schematic_version$145]),
		                b4 = "Search Organizations",
		                action$8 =
		                  action$0
		                   ("69688b4856a492a6ebe92e60",
		                    b4,
		                    "Search for organizations in Apollo's database using filters. Example: {q_organization_name: 'Acme', organization_locations: ['United States'], organization_num_employees_ranges: ['51,200']}.",
		                    read$2(1),
		                    e),
		                letrec_function_context$1080 = [];
		               function input_schema_versioned$7(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1080[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bl6, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1080[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1080[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1080[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var organization_id = param[1];
		                       return cont([0, organization_id]);
		                      },
		                      function(param, cont){
		                       var organization_id = param[1];
		                       return cont([0, organization_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bl7,
		                        0,
		                        0,
		                        0,
		                        cst_organization_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1080[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1080[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1040 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1080, [0, schematic_cache$1040]);
		               caml_callback
		                (input_schema_versioned$7, [function(param){return 0;}]);
		               function schematic_version$146(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$7, [schematic_version$146]),
		                b$ = "Get Organization",
		                action$9 =
		                  action$0
		                   ("69688b4856a492a6ebe92dfc",
		                    b$,
		                    "Get complete information about an organization including company details, technologies, and more. Example: {organization_id: 'abc123'}.",
		                    read$2(1),
		                    e),
		                letrec_function_context$1081 = [];
		               function input_schema_versioned$8(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1081[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bl8, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1081[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1081[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1081[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$408[1],
		                             a =
		                               [0,
		                                [0,
		                                 bl9,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_per_page,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$409[1],
		                                       b =
		 [0,
		  [0, bl_, 0, 0, 0, cst_page, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$410[1],
		         a =
		           [0,
		            [0,
		             bl$,
		             0,
		             0,
		             0,
		             cst_sort_ascending,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$411[1],
		                   b =
		                     [0,
		                      [0,
		                       bma,
		                       0,
		                       0,
		                       0,
		                       cst_sort_by_field,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(c){
		                            var
		                             default$ = match$412[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmb,
		                                 0,
		                                 0,
		                                 0,
		                                 "account_stage_ids",
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$413[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    per_page = d[2][1],
		    page = d[1],
		    sort_ascending = c[1],
		    sort_by_field = b[1],
		    account_stage_ids = a[1],
		    q_keywords = param[1];
		   return cont
		           ([0,
		             q_keywords,
		             account_stage_ids,
		             sort_by_field,
		             sort_ascending,
		             page,
		             per_page]);
		  },
		  function(param, cont){
		   var
		    per_page = param[6],
		    page = param[5],
		    sort_ascending = param[4],
		    sort_by_field = param[3],
		    account_stage_ids = param[2],
		    q_keywords = param[1];
		   return cont
		           ([0,
		             q_keywords,
		             [0,
		              account_stage_ids,
		              [0,
		               sort_by_field,
		               [0, sort_ascending, [0, page, [0, per_page, 0]]]]]]);
		  },
		  [0,
		   [0,
		    bmc,
		    0,
		    0,
		    0,
		    cst_q_keywords,
		    0,
		    [0, default$],
		    [0, b],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1081[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1081[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1041 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1081, [0, schematic_cache$1041]);
		               caml_callback
		                (input_schema_versioned$8, [function(param){return 0;}]);
		               function schematic_version$147(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$8, [schematic_version$147]),
		                action$10 =
		                  action$0
		                   ("69688b4856a492a6ebe92e40",
		                    "Search Accounts",
		                    "Search for accounts in your Apollo account. Example: {q_keywords: 'Acme Corp', per_page: 25}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1082 = [];
		               function input_schema_versioned$9(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1082[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmd, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1082[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1082[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1082[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bme,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1082[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1082[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1042 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1082, [0, schematic_cache$1042]);
		               caml_callback
		                (input_schema_versioned$9, [function(param){return 0;}]);
		               function schematic_version$148(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$9, [schematic_version$148]),
		                action$11 =
		                  action$0
		                   ("69688b4856a492a6ebe92e44",
		                    "Get Account",
		                    "Retrieve an account by ID from your Apollo account. Example: {id: 'abc123'}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1083 = [];
		               function input_schema_versioned$10(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1083[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmf, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1083[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1083[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1083[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$414[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmg,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_owner_id,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$415[1],
		                                       b =
		 [0,
		  [0,
		   bmh,
		   0,
		   0,
		   0,
		   "raw_address",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$416[1],
		         a =
		           [0,
		            [0,
		             bmi,
		             0,
		             0,
		             0,
		             cst_phone_number,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$417[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        owner_id = c[2][1],
		                        raw_address = c[1],
		                        phone_number = b[1],
		                        domain = a[1],
		                        name = param[1];
		                       return cont
		                               ([0, name, domain, phone_number, raw_address, owner_id]);
		                      },
		                      function(param, cont){
		                       var
		                        owner_id = param[5],
		                        raw_address = param[4],
		                        phone_number = param[3],
		                        domain = param[2],
		                        name = param[1];
		                       return cont
		                               ([0,
		                                 name,
		                                 [0,
		                                  domain,
		                                  [0, phone_number, [0, raw_address, [0, owner_id, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bmk,
		                        0,
		                        0,
		                        0,
		                        cst_name,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bmj,
		                         0,
		                         0,
		                         0,
		                         cst_domain,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1083[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1083[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1043 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1083, [0, schematic_cache$1043]);
		               caml_callback
		                (input_schema_versioned$10, [function(param){return 0;}]);
		               function schematic_version$149(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$10, [schematic_version$149]),
		                action$12 =
		                  action$0
		                   ("69688b4856a492a6ebe92e4c",
		                    "Create Account",
		                    "Create a new account (company) in your Apollo account. Example: {name: 'Acme Corp', domain: 'acme.com'}.",
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1084 = [];
		               function input_schema_versioned$11(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1084[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bml, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1084[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1084[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1084[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$418[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmm,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_per_page,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$419[1],
		                                       b =
		 [0,
		  [0, bmn, 0, 0, 0, cst_page, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$420[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              per_page = a[2][1],
		              page = a[1],
		              q_keywords = param[1];
		             return cont([0, q_keywords, page, per_page]);
		            },
		            function(param, cont){
		             var
		              per_page = param[3],
		              page = param[2],
		              q_keywords = param[1];
		             return cont([0, q_keywords, [0, page, [0, per_page, 0]]]);
		            },
		            [0,
		             [0,
		              bmo,
		              0,
		              0,
		              0,
		              cst_q_keywords,
		              0,
		              [0, default$],
		              [0, a],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1084[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1084[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1044 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1084, [0, schematic_cache$1044]);
		               caml_callback
		                (input_schema_versioned$11, [function(param){return 0;}]);
		               function schematic_version$150(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$11, [schematic_version$150]),
		                action$13 =
		                  action$0
		                   ("69688b4856a492a6ebe92e2c",
		                    "Search Sequences",
		                    "Search for email sequences in your Apollo account. Example: {q_keywords: 'onboarding', per_page: 25}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1085 = [];
		               function input_schema_versioned$12(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1085[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmp, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1085[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1085[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1085[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$421[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmq,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_per_page,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$422[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var per_page = param[2][1], page = param[1];
		   return cont([0, page, per_page]);
		  },
		  function(param, cont){
		   var per_page = param[2], page = param[1];
		   return cont([0, page, [0, per_page, 0]]);
		  },
		  [0,
		   [0, bmr, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1085[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1085[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1045 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1085, [0, schematic_cache$1045]);
		               caml_callback
		                (input_schema_versioned$12, [function(param){return 0;}]);
		               function schematic_version$151(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$12, [schematic_version$151]),
		                b2 = "List Deals",
		                action$14 =
		                  action$0
		                   ("69688b4856a492a6ebe92e38",
		                    b2,
		                    "List all deals in your Apollo account. Example: {page: 1, per_page: 50}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1086 = [];
		               function input_schema_versioned$13(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1086[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bms, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1086[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1086[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1086[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$423[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var limit = param[1];
		                                 return cont([0, limit]);
		                                },
		                                function(param, cont){
		                                 var limit = param[1];
		                                 return cont([0, limit, 0]);
		                                },
		                                [0,
		                                 [0, bmt, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1086[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1086[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1046 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1086, [0, schematic_cache$1046]);
		               caml_callback
		                (input_schema_versioned$13, [function(param){return 0;}]);
		               function schematic_version$152(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$13, [schematic_version$152]),
		                action$15 =
		                  action$0
		                   ("6a182cd999d882f78bed10fd",
		                    "List Workspaces",
		                    "\nList Asana workspaces visible to the authenticated user.\nUse this first to discover workspace GIDs before listing projects or tasks.\nExample: {limit: 50}.\n",
		                    read$2(0),
		                    e),
		                letrec_function_context$1087 = [];
		               function input_schema_versioned$14(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1087[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmu, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1087[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1087[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1087[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$424[1],
		                             a =
		                               [0,
		                                [0, bmv, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$425[1],
		                                       b =
		 [0,
		  [0,
		   bmw,
		   0,
		   0,
		   0,
		   cst_archived,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$426[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              limit = b[2][1],
		              archived = b[1],
		              team = a[1],
		              workspace = param[1];
		             return cont([0, workspace, team, archived, limit]);
		            },
		            function(param, cont){
		             var
		              limit = param[4],
		              archived = param[3],
		              team = param[2],
		              workspace = param[1];
		             return cont
		                     ([0, workspace, [0, team, [0, archived, [0, limit, 0]]]]);
		            },
		            [0,
		             [0,
		              bmy,
		              0,
		              0,
		              0,
		              cst_workspace,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, bmx, 0, 0, 0, cst_team, 0, [0, default$], [0, a], 0, 0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1087[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1087[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1047 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1087, [0, schematic_cache$1047]);
		               caml_callback
		                (input_schema_versioned$14, [function(param){return 0;}]);
		               function schematic_version$153(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$14, [schematic_version$153]),
		                j = "List Projects",
		                action$16 =
		                  action$0
		                   ("6a182cd999d882f78bed1135",
		                    j,
		                    "\nList projects in an Asana workspace.\nUse List Workspaces first to discover the workspace GID.\nExample: {workspace: '1234567890', archived: false, limit: 50}.\n",
		                    read$2(0),
		                    e),
		                letrec_function_context$1088 = [];
		               function input_schema_versioned$15(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1088[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmz, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1088[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1088[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1088[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var project_gid = param[1];
		                       return cont([0, project_gid]);
		                      },
		                      function(param, cont){
		                       var project_gid = param[1];
		                       return cont([0, project_gid, 0]);
		                      },
		                      [0,
		                       [0,
		                        bmA,
		                        0,
		                        0,
		                        0,
		                        "project_gid",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1088[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1088[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1048 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1088, [0, schematic_cache$1048]);
		               caml_callback
		                (input_schema_versioned$15, [function(param){return 0;}]);
		               function schematic_version$154(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$15, [schematic_version$154]),
		                b3 = "Get Project",
		                action$17 =
		                  action$0
		                   ("6a182cd999d882f78bed112d",
		                    b3,
		                    "\nGet a complete Asana project record by GID.\nExample: {project_gid: '1234567890'}.\n",
		                    read$2(0),
		                    e),
		                cst_project = "project",
		                letrec_function_context$1089 = [];
		               function input_schema_versioned$16(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1089[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmB, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1089[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1089[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1089[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$427[1],
		                             a =
		                               [0,
		                                [0, bmC, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$428[1],
		                                       b =
		 [0,
		  [0,
		   bmD,
		   0,
		   0,
		   0,
		   "modified_since",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$429[1],
		         a =
		           [0,
		            [0,
		             bmE,
		             0,
		             0,
		             0,
		             "completed_since",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$430[1],
		                   b =
		                     [0,
		                      [0,
		                       bmF,
		                       0,
		                       0,
		                       0,
		                       cst_assignee,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$431[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmG,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_section,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$432[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    limit = e[2][1],
		    modified_since = e[1],
		    completed_since = d[1],
		    assignee = c[1],
		    section = b[1],
		    project = a[1],
		    workspace = param[1];
		   return cont
		           ([0,
		             workspace,
		             project,
		             section,
		             assignee,
		             completed_since,
		             modified_since,
		             limit]);
		  },
		  function(param, cont){
		   var
		    limit = param[7],
		    modified_since = param[6],
		    completed_since = param[5],
		    assignee = param[4],
		    section = param[3],
		    project = param[2],
		    workspace = param[1];
		   return cont
		           ([0,
		             workspace,
		             [0,
		              project,
		              [0,
		               section,
		               [0,
		                assignee,
		                [0, completed_since, [0, modified_since, [0, limit, 0]]]]]]]);
		  },
		  [0,
		   [0,
		    bmI,
		    0,
		    0,
		    0,
		    cst_workspace,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bmH,
		     0,
		     0,
		     0,
		     cst_project,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1089[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1089[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1049 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1089, [0, schematic_cache$1049]);
		               caml_callback
		                (input_schema_versioned$16, [function(param){return 0;}]);
		               function schematic_version$155(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$16, [schematic_version$155]),
		                cg = "List Tasks",
		                action$18 =
		                  action$0
		                   ("6a182cd999d882f78bed115d",
		                    cg,
		                    "\nList Asana tasks. Pass a workspace and either a project, a section, or an assignee.\nUse completed_since: 'now' to return incomplete tasks only.\nExamples:\n{workspace: '123', project: '456', completed_since: 'now'}\n{workspace: '123', assignee: 'me', completed_since: 'now'}\n",
		                    read$2(0),
		                    e),
		                cst_task_gid = "task_gid",
		                letrec_function_context$1090 = [];
		               function input_schema_versioned$17(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1090[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmJ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1090[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1090[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1090[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var task_gid = param[1];
		                       return cont([0, task_gid]);
		                      },
		                      function(param, cont){
		                       var task_gid = param[1];
		                       return cont([0, task_gid, 0]);
		                      },
		                      [0,
		                       [0,
		                        bmK,
		                        0,
		                        0,
		                        0,
		                        cst_task_gid,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1090[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1090[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1050 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1090, [0, schematic_cache$1050]);
		               caml_callback
		                (input_schema_versioned$17, [function(param){return 0;}]);
		               function schematic_version$156(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$17, [schematic_version$156]),
		                h = "Get Task",
		                action$19 =
		                  action$0
		                   ("6a182cd999d882f78bed1155",
		                    h,
		                    "\nGet a complete Asana task record by GID.\nExample: {task_gid: '1234567890'}.\n",
		                    read$2(0),
		                    e),
		                cst_due_at = "due_at",
		                cst_due_on = "due_on",
		                cst_html_notes = "html_notes",
		                cst_start_at = "start_at",
		                cst_start_on = "start_on",
		                letrec_function_context$1091 = [];
		               function input_schema_versioned$18(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1091[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bmL, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1091[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1091[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1091[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$433[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmM,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_parent,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$434[1],
		                                       b =
		 [0,
		  [0,
		   bmN,
		   0,
		   0,
		   0,
		   "followers",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$435[1],
		         a =
		           [0,
		            [0, bmO, 0, 0, 0, cst_tags, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$436[1],
		                   b =
		                     [0,
		                      [0,
		                       bmP,
		                       0,
		                       0,
		                       0,
		                       cst_completed,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$437[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmQ,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_start_at,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$438[1],
		                                       b =
		 [0,
		  [0,
		   bmR,
		   0,
		   0,
		   0,
		   cst_start_on,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$439[1],
		         a =
		           [0,
		            [0,
		             bmS,
		             0,
		             0,
		             0,
		             cst_due_at,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$440[1],
		                   b =
		                     [0,
		                      [0,
		                       bmT,
		                       0,
		                       0,
		                       0,
		                       cst_due_on,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$441[1],
		                             a =
		                               [0,
		                                [0,
		                                 bmU,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assignee,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$442[1],
		                                       b =
		 [0,
		  [0,
		   bmV,
		   0,
		   0,
		   0,
		   cst_projects,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$443[1],
		         a =
		           [0,
		            [0,
		             bmW,
		             0,
		             0,
		             0,
		             cst_workspace,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$444[1],
		                   b =
		                     [0,
		                      [0,
		                       bmX,
		                       0,
		                       0,
		                       0,
		                       cst_html_notes,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$445[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  i = h[2],
		                                  j = i[2],
		                                  k = j[2],
		                                  l = k[2],
		                                  parent = l[2][1],
		                                  followers = l[1],
		                                  tags = k[1],
		                                  completed = j[1],
		                                  start_at = i[1],
		                                  start_on = h[1],
		                                  due_at = g[1],
		                                  due_on = f[1],
		                                  assignee = e[1],
		                                  projects = d[1],
		                                  workspace = c[1],
		                                  html_notes = b[1],
		                                  notes = a[1],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   notes,
		   html_notes,
		   workspace,
		   projects,
		   assignee,
		   due_on,
		   due_at,
		   start_on,
		   start_at,
		   completed,
		   tags,
		   followers,
		   parent]);
		                                },
		                                function(param, cont){
		                                 var
		                                  parent = param[14],
		                                  followers = param[13],
		                                  tags = param[12],
		                                  completed = param[11],
		                                  start_at = param[10],
		                                  start_on = param[9],
		                                  due_at = param[8],
		                                  due_on = param[7],
		                                  assignee = param[6],
		                                  projects = param[5],
		                                  workspace = param[4],
		                                  html_notes = param[3],
		                                  notes = param[2],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   [0,
		    notes,
		    [0,
		     html_notes,
		     [0,
		      workspace,
		      [0,
		       projects,
		       [0,
		        assignee,
		        [0,
		         due_on,
		         [0,
		          due_at,
		          [0,
		           start_on,
		           [0,
		            start_at,
		            [0, completed, [0, tags, [0, followers, [0, parent, 0]]]]]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bmZ,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bmY, 0, 0, 0, cst_notes, 0, [0, default$], [0, a], 0, 0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1091[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1091[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1051 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1091, [0, schematic_cache$1051]);
		               caml_callback
		                (input_schema_versioned$18, [function(param){return 0;}]);
		               function schematic_version$157(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$18, [schematic_version$157]),
		                z = "Create Task",
		                action$20 =
		                  action$0
		                   ("6a182cd999d882f78bed114d",
		                    z,
		                    "\nCreate an Asana task. Provide either workspace or at least one project.\nUse GIDs discovered with the workspace and project tools.\nExample: {name: 'Prepare launch', projects: ['456'], assignee: 'me', due_on: '2026-08-01'}.\n",
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1092 = [];
		               function input_schema_versioned$19(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1092[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bm0, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1092[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1092[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1092[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$446[1],
		                             a =
		                               [0,
		                                [0, bm1, 0, 0, 0, "liked", 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$447[1],
		                                       b =
		 [0,
		  [0,
		   bm2,
		   0,
		   0,
		   0,
		   cst_completed,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$448[1],
		         a =
		           [0,
		            [0,
		             bm3,
		             0,
		             0,
		             0,
		             cst_start_at,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$449[1],
		                   b =
		                     [0,
		                      [0,
		                       bm4,
		                       0,
		                       0,
		                       0,
		                       cst_start_on,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$450[1],
		                             a =
		                               [0,
		                                [0,
		                                 bm5,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_due_at,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$451[1],
		                                       b =
		 [0,
		  [0,
		   bm6,
		   0,
		   0,
		   0,
		   cst_due_on,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$452[1],
		         a =
		           [0,
		            [0,
		             bm7,
		             0,
		             0,
		             0,
		             cst_assignee,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$453[1],
		                   b =
		                     [0,
		                      [0,
		                       bm8,
		                       0,
		                       0,
		                       0,
		                       cst_html_notes,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$454[1],
		                             a =
		                               [0,
		                                [0, bm9, 0, 0, 0, cst_notes, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$455[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    liked = i[2][1],
		    completed = i[1],
		    start_at = h[1],
		    start_on = g[1],
		    due_at = f[1],
		    due_on = e[1],
		    assignee = d[1],
		    html_notes = c[1],
		    notes = b[1],
		    name = a[1],
		    task_gid = param[1];
		   return cont
		           ([0,
		             task_gid,
		             name,
		             notes,
		             html_notes,
		             assignee,
		             due_on,
		             due_at,
		             start_on,
		             start_at,
		             completed,
		             liked]);
		  },
		  function(param, cont){
		   var
		    liked = param[11],
		    completed = param[10],
		    start_at = param[9],
		    start_on = param[8],
		    due_at = param[7],
		    due_on = param[6],
		    assignee = param[5],
		    html_notes = param[4],
		    notes = param[3],
		    name = param[2],
		    task_gid = param[1];
		   return cont
		           ([0,
		             task_gid,
		             [0,
		              name,
		              [0,
		               notes,
		               [0,
		                html_notes,
		                [0,
		                 assignee,
		                 [0,
		                  due_on,
		                  [0,
		                   due_at,
		                   [0, start_on, [0, start_at, [0, completed, [0, liked, 0]]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    bm$,
		    0,
		    0,
		    0,
		    cst_task_gid,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bm_, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1092[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1092[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1052 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1092, [0, schematic_cache$1052]);
		               caml_callback
		                (input_schema_versioned$19, [function(param){return 0;}]);
		               function schematic_version$158(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$19, [schematic_version$158]),
		                bZ = "6a182cd999d882f78bed1145",
		                bU = "Update Task",
		                action$21 =
		                  action$0
		                   (bZ,
		                    bU,
		                    "\nUpdate an existing Asana task. Only provided fields are changed.\nExample: {task_gid: '1234567890', name: 'Updated title', due_on: '2026-08-01'}.\n",
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1093 = [];
		               function input_schema_versioned$20(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1093[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bna, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1093[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1093[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1093[1][1] = a;
		                  var
		                   default$ = match$456[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var completed = param[2][1], task_gid = param[1];
		                       return cont([0, task_gid, completed]);
		                      },
		                      function(param, cont){
		                       var completed = param[2], task_gid = param[1];
		                       return cont([0, task_gid, [0, completed, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bnc,
		                        0,
		                        0,
		                        0,
		                        cst_task_gid,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bnb,
		                         0,
		                         0,
		                         0,
		                         cst_completed,
		                         0,
		                         [0, default$],
		                         [0, bool_schema],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1093[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1093[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1053 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1093, [0, schematic_cache$1053]);
		               caml_callback
		                (input_schema_versioned$20, [function(param){return 0;}]);
		               function schematic_version$159(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$20, [schematic_version$159]),
		                b_ = "Complete Task",
		                action$22 =
		                  action$0
		                   (bZ,
		                    b_,
		                    "\nMark an Asana task completed. The completed field defaults to true; pass false to reopen it.\nExample: {task_gid: '1234567890', completed: true}.\n",
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1094 = [];
		               function input_schema_versioned$21(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1094[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnd, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1094[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1094[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1094[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var task_gid = param[1];
		                       return cont([0, task_gid]);
		                      },
		                      function(param, cont){
		                       var task_gid = param[1];
		                       return cont([0, task_gid, 0]);
		                      },
		                      [0,
		                       [0,
		                        bne,
		                        0,
		                        0,
		                        0,
		                        cst_task_gid,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1094[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1094[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1054 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1094, [0, schematic_cache$1054]);
		               caml_callback
		                (input_schema_versioned$21, [function(param){return 0;}]);
		               function schematic_version$160(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$21, [schematic_version$160]),
		                bZ = "Delete Task",
		                action$23 =
		                  action$0
		                   ("6a182cd999d882f78bed113d",
		                    bZ,
		                    "\nPermanently delete an Asana task by GID. This action is irreversible.\nExample: {task_gid: '1234567890'}.\n",
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1095 = [];
		               function linked_record_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1095[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bng, bnf, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1095[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1095[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1095[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        target_record_id = param[2][1],
		                        target_object = param[1];
		                       return cont([0, target_object, target_record_id]);
		                      },
		                      function(param, cont){
		                       var target_record_id = param[2], target_object = param[1];
		                       return cont([0, target_object, [0, target_record_id, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bni,
		                        0,
		                        0,
		                        0,
		                        "target_object",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bnh,
		                         0,
		                         0,
		                         0,
		                         "target_record_id",
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1095[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1095[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1055 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1095, [0, schematic_cache$1055]);
		               caml_callback
		                (linked_record_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1096 = [];
		               function actor_reference_schema_version
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1096[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnk, bnj, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1096[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1096[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1096[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        referenced_actor_id = param[2][1],
		                        referenced_actor_type = param[1];
		                       return cont([0, referenced_actor_type, referenced_actor_id]);
		                      },
		                      function(param, cont){
		                       var
		                        referenced_actor_id = param[2],
		                        referenced_actor_type = param[1];
		                       return cont
		                               ([0, referenced_actor_type, [0, referenced_actor_id, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bnm,
		                        0,
		                        0,
		                        0,
		                        "referenced_actor_type",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bnl,
		                         0,
		                         0,
		                         0,
		                         "referenced_actor_id",
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1096[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1096[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1056 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1096, [0, schematic_cache$1056]);
		               caml_callback
		                (actor_reference_schema_version, [function(param){return 0;}]);
		               var letrec_function_context$1097 = [];
		               function person_name_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1097[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bno, bnn, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1097[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1097[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1097[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        full_name = a[2][1],
		                        last_name = a[1],
		                        first_name = param[1];
		                       return cont([0, first_name, last_name, full_name]);
		                      },
		                      function(param, cont){
		                       var
		                        full_name = param[3],
		                        last_name = param[2],
		                        first_name = param[1];
		                       return cont
		                               ([0, first_name, [0, last_name, [0, full_name, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_first_name,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_last_name,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          bnp,
		                          0,
		                          0,
		                          0,
		                          cst_full_name,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1097[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1097[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1057 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1097, [0, schematic_cache$1057]);
		               caml_callback
		                (person_name_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1098 = [];
		               function input_schema_versioned$22(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1098[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnr, bnq, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1098[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1098[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1098[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$457[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var limit = param[2][1], query = param[1];
		                                 return cont([0, query, limit]);
		                                },
		                                function(param, cont){
		                                 var limit = param[2], query = param[1];
		                                 return cont([0, query, [0, limit, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bnt,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_query,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bns, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1098[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1098[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1058 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1098, [0, schematic_cache$1058]);
		               caml_callback
		                (input_schema_versioned$22, [function(param){return 0;}]);
		               function schematic_version$161(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$22, [schematic_version$161]),
		                b1 = "Search Deals",
		                action$24 =
		                  action$0
		                   ("6a1dbc6d5e295608bf1009b1",
		                    b1,
		                    "\nSearch deal records using full-text search.\nReturns matching deal records with their attributes.\nExample: {query: 'acme corp expansion', limit: 10}.\n",
		                    read$2(0),
		                    e),
		                cst_record_id = "record_id",
		                letrec_function_context$1099 = [];
		               function input_schema_versioned$23(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1099[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnv, bnu, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1099[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1099[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1099[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var record_id = param[1];
		                       return cont([0, record_id]);
		                      },
		                      function(param, cont){
		                       var record_id = param[1];
		                       return cont([0, record_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bnw,
		                        0,
		                        0,
		                        0,
		                        cst_record_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1099[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1099[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1059 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1099, [0, schematic_cache$1059]);
		               caml_callback
		                (input_schema_versioned$23, [function(param){return 0;}]);
		               function schematic_version$162(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$23, [schematic_version$162]),
		                b5 = "Get Deal",
		                action$25 =
		                  action$0
		                   ("6a1dbc6d5e295608bf10097d",
		                    b5,
		                    "\nGet a deal record by its UUID.\nUse 'Search Deals' to find a record_id first.\nExample: {record_id: '11111111-1111-1111-1111-111111111111'}.\n",
		                    read$2(0),
		                    e),
		                cst_stage = "stage",
		                letrec_function_context$1100 = [];
		               function create_deal_values_schema_vers
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1100[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnx, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1100[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1100[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1100[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (actor_reference_schema_version,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$458[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_owner,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$459[1],
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, cst_stage, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$460[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              owner = a[2][1],
		              stage = a[1],
		              name = param[1];
		             return cont([0, name, stage, owner]);
		            },
		            function(param, cont){
		             var owner = param[3], stage = param[2], name = param[1];
		             return cont([0, name, [0, stage, [0, owner, 0]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, a], 0, 0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1100[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1100[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1060 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1100, [0, schematic_cache$1060]);
		               caml_callback
		                (create_deal_values_schema_vers, [function(param){return 0;}]);
		               var letrec_function_context$1101 = [];
		               function input_schema_versioned$24(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1101[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bny, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1101[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1101[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1101[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (create_deal_values_schema_vers,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var values = param[1];
		                                 return cont([0, values]);
		                                },
		                                function(param, cont){
		                                 var values = param[1];
		                                 return cont([0, values, 0]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_values, 0, 2, [0, a], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1101[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1101[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1061 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1101, [0, schematic_cache$1061]);
		               caml_callback
		                (input_schema_versioned$24, [function(param){return 0;}]);
		               function schematic_version$163(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$24, [schematic_version$163]),
		                action$26 =
		                  action$0
		                   ("6a1dbc6d5e295608bf10098a",
		                    "Create Deal",
		                    '\nCreate a new deal record. Pass Attio attribute slugs as keys under \'values\'.\n\n- name: deal title.\n- stage: must match an existing pipeline stage on the workspace (e.g. "Lead", "Qualified", "Won"). If unsure, omit.\n- owner: array of one actor_reference. \'referenced_actor_type\' is always "workspace-member". Only include when you already have a real workspace-member UUID. If unknown, YOU MUST pass an empty array []. Never invent or guess UUIDs.\n\nOmit any field you don\'t have a real value for.\n\nExample:\n  {values: {name: "Acme Expansion", stage: "Lead",\n            owner: [{referenced_actor_type: "workspace-member",\n                     referenced_actor_id: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa"}]}}\n',
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1102 = [];
		               function update_deal_values_schema_vers
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1102[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnz, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1102[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1102[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1102[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (actor_reference_schema_version,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$461[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_owner,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$462[1],
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, cst_stage, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$463[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              owner = a[2][1],
		              stage = a[1],
		              name = param[1];
		             return cont([0, name, stage, owner]);
		            },
		            function(param, cont){
		             var owner = param[3], stage = param[2], name = param[1];
		             return cont([0, name, [0, stage, [0, owner, 0]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, a], 0, 0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1102[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1102[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1062 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1102, [0, schematic_cache$1062]);
		               caml_callback
		                (update_deal_values_schema_vers, [function(param){return 0;}]);
		               var letrec_function_context$1103 = [];
		               function input_schema_versioned$25(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1103[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnA, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1103[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1103[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1103[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (update_deal_values_schema_vers,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var values = param[2][1], record_id = param[1];
		                                 return cont([0, record_id, values]);
		                                },
		                                function(param, cont){
		                                 var values = param[2], record_id = param[1];
		                                 return cont([0, record_id, [0, values, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_record_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0, [0, 0, 0, 0, 0, cst_values, 0, 2, [0, a], 0, 0], 0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1103[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1103[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1063 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1103, [0, schematic_cache$1063]);
		               caml_callback
		                (input_schema_versioned$25, [function(param){return 0;}]);
		               function schematic_version$164(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$25, [schematic_version$164]),
		                ca = "Update Deal",
		                action$27 =
		                  action$0
		                   ("6a1dbc6d5e295608bf100997",
		                    ca,
		                    "\nUpdate attributes on an existing deal record by its UUID.\nOnly attributes you include in 'values' are modified \xe2\x80\x94 other attributes stay untouched.\nUse 'Search Deals' / 'Get Deal' to obtain 'record_id' first.\n\n- stage: must match an existing pipeline stage on the workspace.\n- owner: array of one actor_reference. Only include when reassigning to a real workspace member whose UUID you have. If not changing the owner, pass an empty array []. Never invent UUIDs.\n\nExample (reassign owner):\n  {record_id: \"11111111-1111-1111-1111-111111111111\",\n   values: {owner: [{referenced_actor_type: \"workspace-member\",\n                     referenced_actor_id: \"aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa\"}]}}\n",
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1104 = [];
		               function input_schema_versioned$26(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1104[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnC, bnB, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1104[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1104[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1104[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$464[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var limit = param[2][1], query = param[1];
		                                 return cont([0, query, limit]);
		                                },
		                                function(param, cont){
		                                 var limit = param[2], query = param[1];
		                                 return cont([0, query, [0, limit, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bnE,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_query,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bnD, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1104[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1104[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1064 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1104, [0, schematic_cache$1064]);
		               caml_callback
		                (input_schema_versioned$26, [function(param){return 0;}]);
		               function schematic_version$165(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$26, [schematic_version$165]),
		                action$28 =
		                  action$0
		                   ("6a1dbc6c5e295608bf100908",
		                    d,
		                    "\nSearch person records using full-text search.\nReturns matching people with their attributes.\nExample: {query: 'jane.doe@acme.com', limit: 10}.\n",
		                    read$2(0),
		                    e),
		                letrec_function_context$1105 = [];
		               function input_schema_versioned$27(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1105[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnG, bnF, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1105[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1105[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1105[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var record_id = param[1];
		                       return cont([0, record_id]);
		                      },
		                      function(param, cont){
		                       var record_id = param[1];
		                       return cont([0, record_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bnH,
		                        0,
		                        0,
		                        0,
		                        cst_record_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1105[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1105[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1065 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1105, [0, schematic_cache$1065]);
		               caml_callback
		                (input_schema_versioned$27, [function(param){return 0;}]);
		               function schematic_version$166(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$27, [schematic_version$166]),
		                d = "Get Person",
		                action$29 =
		                  action$0
		                   ("6a1dbc6c5e295608bf1008c7",
		                    d,
		                    "\nGet a person record by its UUID.\nUse 'Search People' to find a record_id first.\nExample: {record_id: '22222222-2222-2222-2222-222222222222'}.\n",
		                    read$2(0),
		                    e),
		                cst_email_addresses = "email_addresses",
		                letrec_function_context$1106 = [];
		               function create_person_values_schema_ve
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1106[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnI, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1106[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1106[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1106[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (linked_record_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$465[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_company,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$466[1],
		                                       default$0 = match$467[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_email_addresses,
		   0,
		   [0, default$0],
		   [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_job_title,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call
		      (person_name_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         default$ = match$468[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              company = b[2][1],
		              job_title = b[1],
		              email_addresses = a[1],
		              name = param[1];
		             return cont([0, name, email_addresses, job_title, company]);
		            },
		            function(param, cont){
		             var
		              company = param[4],
		              job_title = param[3],
		              email_addresses = param[2],
		              name = param[1];
		             return cont
		                     ([0,
		                       name,
		                       [0, email_addresses, [0, job_title, [0, company, 0]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_name,
		              0,
		              [0, default$],
		              [0, [0, 0, 0, [3, a], 0]],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1106[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1106[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1066 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1106, [0, schematic_cache$1066]);
		               caml_callback
		                (create_person_values_schema_ve, [function(param){return 0;}]);
		               var letrec_function_context$1107 = [];
		               function input_schema_versioned$28(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1107[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnJ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1107[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1107[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1107[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (create_person_values_schema_ve,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var values = param[1];
		                                 return cont([0, values]);
		                                },
		                                function(param, cont){
		                                 var values = param[1];
		                                 return cont([0, values, 0]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_values, 0, 2, [0, a], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1107[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1107[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1067 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1107, [0, schematic_cache$1067]);
		               caml_callback
		                (input_schema_versioned$28, [function(param){return 0;}]);
		               function schematic_version$167(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$28, [schematic_version$167]),
		                cf = "Create Person",
		                action$30 =
		                  action$0
		                   ("6a1dbc6c5e295608bf1008d4",
		                    cf,
		                    '\nCreate a new person record. Pass Attio attribute slugs as keys under \'values\'.\n\n- name: array of one person_name. Attio requires \'full_name\'. Pass exactly one element. Pass [] if you only have an email.\n- email_addresses: array of plain email strings. Pass [] if none.\n- job_title: string.\n- company: array of one linked_record with \'target_object: "companies"\'. If unknown or if the company doesn\'t exist yet, YOU MUST pass an empty array []. Never invent UUIDs.\n\nExample:\n  {values: {name: [{first_name: "Jane", last_name: "Doe", full_name: "Jane Doe"}],\n            email_addresses: ["jane@acme.com"],\n            job_title: "CTO",\n            company: []}}\n',
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1108 = [];
		               function update_person_values_schema_ve
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1108[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnK, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1108[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1108[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1108[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (linked_record_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$469[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_company,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$470[1],
		                                       default$0 = match$471[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_email_addresses,
		   0,
		   [0, default$0],
		   [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_job_title,
		    0,
		    [0, default$],
		    [0, c],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call
		      (person_name_schema_versioned,
		       schematic_version,
		       function(a){
		        var
		         default$ = match$472[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              company = b[2][1],
		              job_title = b[1],
		              email_addresses = a[1],
		              name = param[1];
		             return cont([0, name, email_addresses, job_title, company]);
		            },
		            function(param, cont){
		             var
		              company = param[4],
		              job_title = param[3],
		              email_addresses = param[2],
		              name = param[1];
		             return cont
		                     ([0,
		                       name,
		                       [0, email_addresses, [0, job_title, [0, company, 0]]]]);
		            },
		            [0,
		             [0,
		              0,
		              0,
		              0,
		              0,
		              cst_name,
		              0,
		              [0, default$],
		              [0, [0, 0, 0, [3, a], 0]],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1108[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1108[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1068 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1108, [0, schematic_cache$1068]);
		               caml_callback
		                (update_person_values_schema_ve, [function(param){return 0;}]);
		               var letrec_function_context$1109 = [];
		               function input_schema_versioned$29(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1109[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnL, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1109[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1109[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1109[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (update_person_values_schema_ve,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var values = param[2][1], record_id = param[1];
		                                 return cont([0, record_id, values]);
		                                },
		                                function(param, cont){
		                                 var values = param[2], record_id = param[1];
		                                 return cont([0, record_id, [0, values, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_record_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0, [0, 0, 0, 0, 0, cst_values, 0, 2, [0, a], 0, 0], 0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1109[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1109[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1069 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1109, [0, schematic_cache$1069]);
		               caml_callback
		                (input_schema_versioned$29, [function(param){return 0;}]);
		               function schematic_version$168(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$29, [schematic_version$168]),
		                action$31 =
		                  action$0
		                   ("6a1dbc6c5e295608bf1008e1",
		                    "Update Person",
		                    '\nUpdate attributes on an existing person record by its UUID.\n\n- name: array of one person_name. Pass an empty array [] if you don\'t want to change it.\n- email_addresses: array of strings. Pass [] if not updating.\n- job_title: string.\n- company: array of one linked_record. Pass [] if not updating. Never invent UUIDs.\n\nExample:\n  {record_id: "22222222-2222-2222-2222-222222222222",\n   values: {job_title: "CEO",\n            name: [],\n            email_addresses: [],\n            company: [{target_object: "companies", target_record_id: "33333333-3333-3333-3333-333333333333"}]}}\n',
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1110 = [];
		               function input_schema_versioned$30(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1110[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnN, bnM, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1110[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1110[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1110[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$473[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var limit = param[2][1], query = param[1];
		                                 return cont([0, query, limit]);
		                                },
		                                function(param, cont){
		                                 var limit = param[2], query = param[1];
		                                 return cont([0, query, [0, limit, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bnP,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_query,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bnO, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1110[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1110[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1070 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1110, [0, schematic_cache$1070]);
		               caml_callback
		                (input_schema_versioned$30, [function(param){return 0;}]);
		               function schematic_version$169(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$30, [schematic_version$169]),
		                action$32 =
		                  action$0
		                   ("6a1dbc6d5e295608bf100963",
		                    "Search Companies",
		                    "\nSearch company records using full-text search.\nReturns matching companies with their attributes.\nExample: {query: 'acme.com', limit: 10}.\n",
		                    read$2(0),
		                    e),
		                letrec_function_context$1111 = [];
		               function input_schema_versioned$31(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1111[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnR, bnQ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1111[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1111[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1111[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var record_id = param[1];
		                       return cont([0, record_id]);
		                      },
		                      function(param, cont){
		                       var record_id = param[1];
		                       return cont([0, record_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bnS,
		                        0,
		                        0,
		                        0,
		                        cst_record_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1111[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1111[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1071 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1111, [0, schematic_cache$1071]);
		               caml_callback
		                (input_schema_versioned$31, [function(param){return 0;}]);
		               function schematic_version$170(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$31, [schematic_version$170]),
		                action$33 =
		                  action$0
		                   ("6a1dbc6c5e295608bf100922",
		                    "Get Company",
		                    "\nGet a company record by its UUID.\nUse 'Search Companies' to find a record_id first.\nExample: {record_id: '33333333-3333-3333-3333-333333333333'}.\n",
		                    read$2(0),
		                    e),
		                letrec_function_context$1112 = [];
		               function create_company_values_schema_v
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1112[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnU, bnT, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1112[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1112[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1112[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        categories = b[2][1],
		                        description = b[1],
		                        domains = a[1],
		                        name = param[1];
		                       return cont([0, name, domains, description, categories]);
		                      },
		                      function(param, cont){
		                       var
		                        categories = param[4],
		                        description = param[3],
		                        domains = param[2],
		                        name = param[1];
		                       return cont
		                               ([0,
		                                 name,
		                                 [0, domains, [0, description, [0, categories, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_name,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_domains,
		                         0,
		                         2,
		                         [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_description,
		                          0,
		                          3,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           "categories",
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                           0,
		                           0],
		                          0]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1112[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1112[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1072 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1112, [0, schematic_cache$1072]);
		               caml_callback
		                (create_company_values_schema_v, [function(param){return 0;}]);
		               var letrec_function_context$1113 = [];
		               function input_schema_versioned$32(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1113[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnV, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1113[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1113[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1113[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (create_company_values_schema_v,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var values = param[1];
		                                 return cont([0, values]);
		                                },
		                                function(param, cont){
		                                 var values = param[1];
		                                 return cont([0, values, 0]);
		                                },
		                                [0, [0, 0, 0, 0, 0, cst_values, 0, 2, [0, a], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1113[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1113[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1073 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1113, [0, schematic_cache$1073]);
		               caml_callback
		                (input_schema_versioned$32, [function(param){return 0;}]);
		               function schematic_version$171(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$32, [schematic_version$171]),
		                action$34 =
		                  action$0
		                   ("6a1dbc6c5e295608bf10092f",
		                    "Create Company",
		                    "\nCreate a new company record.\nPass attribute slugs as keys under 'values'.\nFor multi-select attributes use arrays; for single-select use scalars.\nExample: {values: {name: 'Acme Corp', domains: ['acme.com'], description: 'Industrial supplies'}}.\n",
		                    write$0(0, 0, 0),
		                    e),
		                cst_assignees = "assignees",
		                cst_deadline_at = "deadline_at",
		                cst_is_completed = "is_completed",
		                cst_linked_records = "linked_records",
		                letrec_function_context$1114 = [];
		               function input_schema_versioned$33(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1114[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bnX, bnW, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1114[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1114[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1114[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (actor_reference_schema_version,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$474[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assignees,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (linked_record_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$475[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_linked_records,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, c], 0]],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$476[1],
		         a =
		           [0,
		            [0,
		             bnY,
		             0,
		             0,
		             0,
		             cst_is_completed,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$477[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        assignees = c[2][1],
		                        linked_records = c[1],
		                        is_completed = b[1],
		                        deadline_at = a[1],
		                        content = param[1];
		                       return cont
		                               ([0,
		                                 content,
		                                 deadline_at,
		                                 is_completed,
		                                 linked_records,
		                                 assignees]);
		                      },
		                      function(param, cont){
		                       var
		                        assignees = param[5],
		                        linked_records = param[4],
		                        is_completed = param[3],
		                        deadline_at = param[2],
		                        content = param[1];
		                       return cont
		                               ([0,
		                                 content,
		                                 [0,
		                                  deadline_at,
		                                  [0, is_completed, [0, linked_records, [0, assignees, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bn0,
		                        0,
		                        0,
		                        0,
		                        cst_content,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bnZ,
		                         0,
		                         0,
		                         0,
		                         cst_deadline_at,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1114[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1114[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1074 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1114, [0, schematic_cache$1074]);
		               caml_callback
		                (input_schema_versioned$33, [function(param){return 0;}]);
		               function schematic_version$172(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$33, [schematic_version$172]),
		                action$35 =
		                  action$0
		                   ("6a1dbc6b5e295608bf100804",
		                    z,
		                    '\nCreate a new task. Tasks can be linked to records (people, companies, deals) and assigned to workspace members.\n\n- linked_records: array of linked_record objects. Pass an empty array [] if none.\n- assignees: array of actor_reference objects. Pass an empty array [] if unassigned. Never invent UUIDs.\n\nExample: \n  {content: "Follow up on proposal", \n   deadline_at: "2026-06-01T17:00:00.000Z", \n   linked_records: [{target_object: "deals", target_record_id: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa"}], \n   assignees: []}\n',
		                    write$0(0, 0, 0),
		                    e),
		                cst_task_id = "task_id",
		                letrec_function_context$1115 = [];
		               function input_schema_versioned$34(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1115[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bn2, bn1, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1115[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1115[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1115[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (actor_reference_schema_version,
		                           schematic_version,
		                           function(b){
		                            var
		                             default$ = match$478[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assignees,
		                                 0,
		                                 [0, default$],
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (linked_record_schema_versioned,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       default$ = match$479[1],
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_linked_records,
		   0,
		   [0, default$],
		   [0, [0, 0, 0, [3, c], 0]],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$480[1],
		         a =
		           [0,
		            [0,
		             bn3,
		             0,
		             0,
		             0,
		             cst_is_completed,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$481[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        assignees = c[2][1],
		                        linked_records = c[1],
		                        is_completed = b[1],
		                        deadline_at = a[1],
		                        task_id = param[1];
		                       return cont
		                               ([0,
		                                 task_id,
		                                 deadline_at,
		                                 is_completed,
		                                 linked_records,
		                                 assignees]);
		                      },
		                      function(param, cont){
		                       var
		                        assignees = param[5],
		                        linked_records = param[4],
		                        is_completed = param[3],
		                        deadline_at = param[2],
		                        task_id = param[1];
		                       return cont
		                               ([0,
		                                 task_id,
		                                 [0,
		                                  deadline_at,
		                                  [0, is_completed, [0, linked_records, [0, assignees, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bn5,
		                        0,
		                        0,
		                        0,
		                        cst_task_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bn4,
		                         0,
		                         0,
		                         0,
		                         cst_deadline_at,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1115[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1115[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1075 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1115, [0, schematic_cache$1075]);
		               caml_callback
		                (input_schema_versioned$34, [function(param){return 0;}]);
		               function schematic_version$173(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$34, [schematic_version$173]),
		                action$36 =
		                  action$0
		                   ("6a1dbc6b5e295608bf10081e",
		                    bU,
		                    '\nUpdate an existing task by its UUID.\nOnly fields included in the input are modified. To mark a task done, set is_completed to true.\n\n- linked_records: array of linked_record objects. Pass [] if not changing.\n- assignees: array of actor_reference objects. Pass [] if not changing.\n\nExample (mark done): \n  {task_id: "44444444-4444-4444-4444-444444444444", is_completed: true, linked_records: [], assignees: []}\n',
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1116 = [];
		               function format_schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1116[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bn7, bn6, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1116[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1116[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1116[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bn$);},
		                        0,
		                        0,
		                        cst_plaintext,
		                        "Plaintext",
		                        bn_,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(bn9) : cont(0);},
		                         0,
		                         0,
		                         cst_markdown,
		                         "Markdown",
		                         bn8,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1116[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1116[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1076 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1116, [0, schematic_cache$1076]);
		               caml_callback
		                (format_schema_versioned$0, [function(param){return 0;}]);
		               var letrec_function_context$1117 = [];
		               function input_schema_versioned$35(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1117[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bob, boa, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1117[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1117[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1117[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (format_schema_versioned$0,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  format = c[2][1],
		                                  content = c[1],
		                                  title = b[1],
		                                  parent_record_id = a[1],
		                                  parent_object = param[1];
		                                 return cont
		 ([0,
		   parent_object,
		   parent_record_id,
		   title,
		   content,
		   format]);
		                                },
		                                function(param, cont){
		                                 var
		                                  format = param[5],
		                                  content = param[4],
		                                  title = param[3],
		                                  parent_record_id = param[2],
		                                  parent_object = param[1];
		                                 return cont
		 ([0,
		   parent_object,
		   [0,
		    parent_record_id,
		    [0, title, [0, content, [0, format, 0]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bof,
		                                  0,
		                                  0,
		                                  0,
		                                  "parent_object",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   boe,
		                                   0,
		                                   0,
		                                   0,
		                                   "parent_record_id",
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bod,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_title,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     boc,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_content,
		                                     0,
		                                     2,
		                                     [0, schematic_param_name_schema_ve],
		                                     0,
		                                     0],
		                                    [0, [0, 0, 0, 0, 0, cst_format, 0, 2, [0, a], 0, 0], 0]]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1117[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1117[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1077 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1117, [0, schematic_cache$1077]);
		               caml_callback
		                (input_schema_versioned$35, [function(param){return 0;}]);
		               function schematic_version$174(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$35, [schematic_version$174]),
		                ch = "Create Note",
		                action$37 =
		                  action$0
		                   ("6a1dbc6b5e295608bf1007dd",
		                    ch,
		                    "\nCreate a note attached to a parent record.\nThe parent is identified by its object slug and record UUID.\nExample: {parent_object: 'people', parent_record_id: '22222222-...', title: 'Intro call notes', content: '# Discussion\\nDiscussed pricing.', format: 'markdown'}.\n",
		                    write$0(0, 0, 0),
		                    e),
		                empty_object_schema = [0, 0, 0, descriptor$59, 0],
		                action$38 =
		                  action$0
		                   ("69de5770c8d8880c3eb4312e",
		                    "Get Authorized User",
		                    "\n     Get information about the currently authenticated ClickUp user.\n     Pass input: {} (no parameters needed).\n     Example: {connectionId: '...', input: {}}.\n    ",
		                    read$2(0),
		                    empty_object_schema),
		                action$39 =
		                  action$0
		                   ("69de5770c8d8880c3eb4311f",
		                    "Get Workspaces",
		                    "\n     Get all ClickUp workspaces (teams) the authenticated user has access to.\n     Use this first to obtain team_id values. Pass input: {} (no parameters needed).\n     Example: {connectionId: '...', input: {}}.\n    ",
		                    read$2(0),
		                    empty_object_schema),
		                letrec_function_context$1118 = [];
		               function input_schema_versioned$36(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1118[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bok, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1118[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1118[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1118[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(a){
		                            var
		                             default$ = match$482[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var archived = param[2][1], team_id = param[1];
		                                 return cont([0, team_id, archived]);
		                                },
		                                function(param, cont){
		                                 var archived = param[2], team_id = param[1];
		                                 return cont([0, team_id, [0, archived, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bom,
		                                  0,
		                                  0,
		                                  0,
		                                  "team_id",
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bol,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_archived,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1118[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1118[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1078 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1118, [0, schematic_cache$1078]);
		               caml_callback
		                (input_schema_versioned$36, [function(param){return 0;}]);
		               function schematic_version$175(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$36, [schematic_version$175]),
		                action$40 =
		                  action$0
		                   ("69de576fc8d8880c3eb430d4",
		                    "List Spaces",
		                    "\n     List all spaces in a ClickUp workspace. Use Get Workspaces to find team_id.\n     Example: {team_id: '12345678'}.\n    ",
		                    read$2(0),
		                    e),
		                cst_space_id = "space_id",
		                letrec_function_context$1119 = [];
		               function input_schema_versioned$37(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1119[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bon, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1119[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1119[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1119[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var space_id = param[1];
		                       return cont([0, space_id]);
		                      },
		                      function(param, cont){
		                       var space_id = param[1];
		                       return cont([0, space_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        boo,
		                        0,
		                        0,
		                        0,
		                        cst_space_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1119[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1119[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1079 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1119, [0, schematic_cache$1079]);
		               caml_callback
		                (input_schema_versioned$37, [function(param){return 0;}]);
		               function schematic_version$176(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$37, [schematic_version$176]),
		                action$41 =
		                  action$0
		                   ("69de576fc8d8880c3eb430ac",
		                    "Get Space",
		                    "\n     Get details of a specific ClickUp space by ID.\n     Example: {space_id: '90011234'}.\n    ",
		                    read$2(0),
		                    e),
		                letrec_function_context$1120 = [];
		               function input_schema_versioned$38(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1120[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bop, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1120[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1120[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1120[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(a){
		                            var
		                             default$ = match$483[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var archived = param[2][1], space_id = param[1];
		                                 return cont([0, space_id, archived]);
		                                },
		                                function(param, cont){
		                                 var archived = param[2], space_id = param[1];
		                                 return cont([0, space_id, [0, archived, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bor,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_space_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   boq,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_archived,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1120[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1120[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1080 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1120, [0, schematic_cache$1080]);
		               caml_callback
		                (input_schema_versioned$38, [function(param){return 0;}]);
		               function schematic_version$177(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$38, [schematic_version$177]),
		                action$42 =
		                  action$0
		                   ("69de576fc8d8880c3eb4308e",
		                    "List Folders",
		                    "\n     List all folders in a ClickUp space.\n     Example: {space_id: '90011234'}.\n    ",
		                    read$2(0),
		                    e),
		                cst_folder_id = "folder_id",
		                letrec_function_context$1121 = [];
		               function input_schema_versioned$39(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1121[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bos, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1121[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1121[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1121[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var folder_id = param[1];
		                       return cont([0, folder_id]);
		                      },
		                      function(param, cont){
		                       var folder_id = param[1];
		                       return cont([0, folder_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bot,
		                        0,
		                        0,
		                        0,
		                        cst_folder_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1121[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1121[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1081 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1121, [0, schematic_cache$1081]);
		               caml_callback
		                (input_schema_versioned$39, [function(param){return 0;}]);
		               function schematic_version$178(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$39, [schematic_version$178]),
		                action$43 =
		                  action$0
		                   ("69de576fc8d8880c3eb43061",
		                    "Get Folder",
		                    "\n     Get details of a specific ClickUp folder by ID.\n     Example: {folder_id: '90112345'}.\n    ",
		                    read$2(0),
		                    e),
		                letrec_function_context$1122 = [];
		               function input_schema_versioned$40(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1122[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bou, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1122[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1122[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1122[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(a){
		                            var
		                             default$ = match$484[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var archived = param[2][1], folder_id = param[1];
		                                 return cont([0, folder_id, archived]);
		                                },
		                                function(param, cont){
		                                 var archived = param[2], folder_id = param[1];
		                                 return cont([0, folder_id, [0, archived, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bow,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_folder_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bov,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_archived,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1122[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1122[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1082 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1122, [0, schematic_cache$1082]);
		               caml_callback
		                (input_schema_versioned$40, [function(param){return 0;}]);
		               function schematic_version$179(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$40, [schematic_version$179]),
		                action$44 =
		                  action$0
		                   ("69de576fc8d8880c3eb43034",
		                    "List Lists in Folder",
		                    "\n     List all lists inside a ClickUp folder.\n     Example: {folder_id: '90112345'}.\n    ",
		                    read$2(0),
		                    e),
		                letrec_function_context$1123 = [];
		               function input_schema_versioned$41(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1123[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, box, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1123[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1123[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1123[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(a){
		                            var
		                             default$ = match$485[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var archived = param[2][1], space_id = param[1];
		                                 return cont([0, space_id, archived]);
		                                },
		                                function(param, cont){
		                                 var archived = param[2], space_id = param[1];
		                                 return cont([0, space_id, [0, archived, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  boz,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_space_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   boy,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_archived,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1123[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1123[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1083 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1123, [0, schematic_cache$1083]);
		               caml_callback
		                (input_schema_versioned$41, [function(param){return 0;}]);
		               function schematic_version$180(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$41, [schematic_version$180]),
		                action$45 =
		                  action$0
		                   ("69de576fc8d8880c3eb43043",
		                    "List Folderless Lists",
		                    "\n     List all lists in a ClickUp space that are not inside any folder.\n     Example: {space_id: '90011234'}.\n    ",
		                    read$2(0),
		                    e),
		                cst_list_id = "list_id",
		                letrec_function_context$1124 = [];
		               function input_schema_versioned$42(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1124[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, boA, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1124[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1124[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1124[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var list_id = param[1];
		                       return cont([0, list_id]);
		                      },
		                      function(param, cont){
		                       var list_id = param[1];
		                       return cont([0, list_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        boB,
		                        0,
		                        0,
		                        0,
		                        cst_list_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1124[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1124[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1084 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1124, [0, schematic_cache$1084]);
		               caml_callback
		                (input_schema_versioned$42, [function(param){return 0;}]);
		               function schematic_version$181(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$42, [schematic_version$181]),
		                action$46 =
		                  action$0
		                   ("69de576fc8d8880c3eb43007",
		                    "Get List",
		                    "\n     Get details of a specific ClickUp list by ID.\n     Example: {list_id: '901234567'}.\n    ",
		                    read$2(0),
		                    e),
		                cst_order_by = "order_by",
		                letrec_function_context$1125 = [];
		               function input_schema_versioned$43(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1125[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, boC, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1125[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1125[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1125[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$486[1],
		                             a =
		                               [0,
		                                [0,
		                                 boD,
		                                 0,
		                                 0,
		                                 0,
		                                 "subtasks",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$487[1],
		                                       b =
		 [0,
		  [0,
		   boE,
		   0,
		   0,
		   0,
		   cst_reverse,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$488[1],
		         a =
		           [0,
		            [0,
		             boF,
		             0,
		             0,
		             0,
		             cst_order_by,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$489[1],
		                   b =
		                     [0,
		                      [0, boG, 0, 0, 0, cst_page, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(c){
		                            var
		                             default$ = match$490[1],
		                             a =
		                               [0,
		                                [0,
		                                 boH,
		                                 0,
		                                 0,
		                                 0,
		                                 "include_closed",
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$491[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    subtasks = e[2][1],
		    reverse = e[1],
		    order_by = d[1],
		    page = c[1],
		    include_closed = b[1],
		    archived = a[1],
		    list_id = param[1];
		   return cont
		           ([0,
		             list_id,
		             archived,
		             include_closed,
		             page,
		             order_by,
		             reverse,
		             subtasks]);
		  },
		  function(param, cont){
		   var
		    subtasks = param[7],
		    reverse = param[6],
		    order_by = param[5],
		    page = param[4],
		    include_closed = param[3],
		    archived = param[2],
		    list_id = param[1];
		   return cont
		           ([0,
		             list_id,
		             [0,
		              archived,
		              [0,
		               include_closed,
		               [0, page, [0, order_by, [0, reverse, [0, subtasks, 0]]]]]]]);
		  },
		  [0,
		   [0,
		    boJ,
		    0,
		    0,
		    0,
		    cst_list_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     boI,
		     0,
		     0,
		     0,
		     cst_archived,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1125[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1125[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1085 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1125, [0, schematic_cache$1085]);
		               caml_callback
		                (input_schema_versioned$43, [function(param){return 0;}]);
		               function schematic_version$182(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$43, [schematic_version$182]),
		                action$47 =
		                  action$0
		                   ("69de576fc8d8880c3eb42fe9",
		                    cg,
		                    "\n     List all tasks in a ClickUp list. Pagination starts at page 0.\n     Example: {list_id: '901234567', include_closed: false, order_by: 'updated', reverse: true}.\n    ",
		                    read$2(0),
		                    e),
		                letrec_function_context$1126 = [];
		               function input_schema_versioned$44(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1126[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, boK, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1126[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1126[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1126[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$492[1],
		                             a =
		                               [0,
		                                [0,
		                                 boL,
		                                 0,
		                                 0,
		                                 0,
		                                 "include_markdown_description",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$493[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    include_markdown_description = a[2][1],
		    include_subtasks = a[1],
		    task_id = param[1];
		   return cont
		           ([0,
		             task_id,
		             include_subtasks,
		             include_markdown_description]);
		  },
		  function(param, cont){
		   var
		    include_markdown_description = param[3],
		    include_subtasks = param[2],
		    task_id = param[1];
		   return cont
		           ([0,
		             task_id,
		             [0, include_subtasks, [0, include_markdown_description, 0]]]);
		  },
		  [0,
		   [0,
		    boN,
		    0,
		    0,
		    0,
		    cst_task_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     boM,
		     0,
		     0,
		     0,
		     "include_subtasks",
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1126[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1126[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1086 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1126, [0, schematic_cache$1086]);
		               caml_callback
		                (input_schema_versioned$44, [function(param){return 0;}]);
		               function schematic_version$183(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$44, [schematic_version$183]),
		                action$48 =
		                  action$0
		                   ("69de576fc8d8880c3eb42fbc",
		                    h,
		                    "\n     Get details of a specific ClickUp task by ID.\n     Example: {task_id: 'abc123', include_markdown_description: true}.\n    ",
		                    read$2(0),
		                    e),
		                cst_due_date_time = "due_date_time",
		                cst_markdown_content = "markdown_content",
		                cst_start_date_time = "start_date_time",
		                cst_time_estimate = "time_estimate",
		                letrec_function_context$1127 = [];
		               function input_schema_versioned$45(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1127[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, boO, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1127[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1127[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1127[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$494[1],
		                             a =
		                               [0,
		                                [0,
		                                 boP,
		                                 0,
		                                 0,
		                                 0,
		                                 "notify_all",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$495[1],
		                                       b =
		 [0,
		  [0,
		   boQ,
		   0,
		   0,
		   0,
		   cst_parent,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$496[1],
		         a =
		           [0,
		            [0, boR, 0, 0, 0, cst_tags, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, int_schema], 0],
		                 function(c){
		                  var
		                   default$ = match$497[1],
		                   b =
		                     [0,
		                      [0,
		                       boS,
		                       0,
		                       0,
		                       0,
		                       cst_assignees,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$498[1],
		                             a =
		                               [0,
		                                [0,
		                                 boT,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_time_estimate,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$499[1],
		                                       b =
		 [0,
		  [0,
		   boU,
		   0,
		   0,
		   0,
		   cst_start_date_time,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$500[1],
		         a =
		           [0,
		            [0,
		             boV,
		             0,
		             0,
		             0,
		             cst_start_date,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$501[1],
		                   b =
		                     [0,
		                      [0,
		                       boW,
		                       0,
		                       0,
		                       0,
		                       cst_due_date_time,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$502[1],
		                             a =
		                               [0,
		                                [0,
		                                 boX,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_due_date,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$503[1],
		                                       b =
		 [0,
		  [0,
		   boY,
		   0,
		   0,
		   0,
		   cst_priority,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$504[1],
		         a =
		           [0,
		            [0,
		             boZ,
		             0,
		             0,
		             0,
		             cst_status,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$505[1],
		                   b =
		                     [0,
		                      [0,
		                       bo0,
		                       0,
		                       0,
		                       0,
		                       cst_markdown_content,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$506[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  i = h[2],
		                                  j = i[2],
		                                  k = j[2],
		                                  l = k[2],
		                                  m = l[2],
		                                  notify_all = m[2][1],
		                                  parent = m[1],
		                                  tags = l[1],
		                                  assignees = k[1],
		                                  time_estimate = j[1],
		                                  start_date_time = i[1],
		                                  start_date = h[1],
		                                  due_date_time = g[1],
		                                  due_date = f[1],
		                                  priority = e[1],
		                                  status = d[1],
		                                  markdown_content = c[1],
		                                  description = b[1],
		                                  name = a[1],
		                                  list_id = param[1];
		                                 return cont
		 ([0,
		   list_id,
		   name,
		   description,
		   markdown_content,
		   status,
		   priority,
		   due_date,
		   due_date_time,
		   start_date,
		   start_date_time,
		   time_estimate,
		   assignees,
		   tags,
		   parent,
		   notify_all]);
		                                },
		                                function(param, cont){
		                                 var
		                                  notify_all = param[15],
		                                  parent = param[14],
		                                  tags = param[13],
		                                  assignees = param[12],
		                                  time_estimate = param[11],
		                                  start_date_time = param[10],
		                                  start_date = param[9],
		                                  due_date_time = param[8],
		                                  due_date = param[7],
		                                  priority = param[6],
		                                  status = param[5],
		                                  markdown_content = param[4],
		                                  description = param[3],
		                                  name = param[2],
		                                  list_id = param[1];
		                                 return cont
		 ([0,
		   list_id,
		   [0,
		    name,
		    [0,
		     description,
		     [0,
		      markdown_content,
		      [0,
		       status,
		       [0,
		        priority,
		        [0,
		         due_date,
		         [0,
		          due_date_time,
		          [0,
		           start_date,
		           [0,
		            start_date_time,
		            [0,
		             time_estimate,
		             [0, assignees, [0, tags, [0, parent, [0, notify_all, 0]]]]]]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bo3,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_list_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bo2,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_name,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bo1,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_description,
		                                    0,
		                                    [0, default$],
		                                    [0, a],
		                                    0,
		                                    0],
		                                   b]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1127[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1127[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1087 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1127, [0, schematic_cache$1087]);
		               caml_callback
		                (input_schema_versioned$45, [function(param){return 0;}]);
		               function schematic_version$184(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$45, [schematic_version$184]),
		                action$49 =
		                  action$0
		                   ("69de576fc8d8880c3eb42fad",
		                    z,
		                    "\n     Create a new task in a ClickUp list. Priority: 1=Urgent, 2=High, 3=Normal, 4=Low. Dates are Unix timestamps in milliseconds.\n     Example: {list_id: '901234567', name: 'Fix login bug', status: 'in progress', priority: 2}.\n    ",
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1128 = [];
		               function input_schema_versioned$46(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1128[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bo4, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1128[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1128[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1128[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$507[1],
		                             a =
		                               [0,
		                                [0,
		                                 bo5,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_archived,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$508[1],
		                                       b =
		 [0,
		  [0,
		   bo6,
		   0,
		   0,
		   0,
		   cst_time_estimate,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$509[1],
		         a =
		           [0,
		            [0,
		             bo7,
		             0,
		             0,
		             0,
		             cst_start_date_time,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$510[1],
		                   b =
		                     [0,
		                      [0,
		                       bo8,
		                       0,
		                       0,
		                       0,
		                       cst_start_date,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(c){
		                            var
		                             default$ = match$511[1],
		                             a =
		                               [0,
		                                [0,
		                                 bo9,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_due_date_time,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$512[1],
		                                       b =
		 [0,
		  [0,
		   bo_,
		   0,
		   0,
		   0,
		   cst_due_date,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$513[1],
		         a =
		           [0,
		            [0,
		             bo$,
		             0,
		             0,
		             0,
		             cst_priority,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$514[1],
		                   b =
		                     [0,
		                      [0,
		                       bpa,
		                       0,
		                       0,
		                       0,
		                       cst_status,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$515[1],
		                             a =
		                               [0,
		                                [0,
		                                 bpb,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_markdown_content,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$516[1],
		                                       b =
		 [0,
		  [0,
		   bpc,
		   0,
		   0,
		   0,
		   cst_description,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$517[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              i = h[2],
		              j = i[2],
		              archived = j[2][1],
		              time_estimate = j[1],
		              start_date_time = i[1],
		              start_date = h[1],
		              due_date_time = g[1],
		              due_date = f[1],
		              priority = e[1],
		              status = d[1],
		              markdown_content = c[1],
		              description = b[1],
		              name = a[1],
		              task_id = param[1];
		             return cont
		                     ([0,
		                       task_id,
		                       name,
		                       description,
		                       markdown_content,
		                       status,
		                       priority,
		                       due_date,
		                       due_date_time,
		                       start_date,
		                       start_date_time,
		                       time_estimate,
		                       archived]);
		            },
		            function(param, cont){
		             var
		              archived = param[12],
		              time_estimate = param[11],
		              start_date_time = param[10],
		              start_date = param[9],
		              due_date_time = param[8],
		              due_date = param[7],
		              priority = param[6],
		              status = param[5],
		              markdown_content = param[4],
		              description = param[3],
		              name = param[2],
		              task_id = param[1];
		             return cont
		                     ([0,
		                       task_id,
		                       [0,
		                        name,
		                        [0,
		                         description,
		                         [0,
		                          markdown_content,
		                          [0,
		                           status,
		                           [0,
		                            priority,
		                            [0,
		                             due_date,
		                             [0,
		                              due_date_time,
		                              [0,
		                               start_date,
		                               [0, start_date_time, [0, time_estimate, [0, archived, 0]]]]]]]]]]]]);
		            },
		            [0,
		             [0,
		              bpe,
		              0,
		              0,
		              0,
		              cst_task_id,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, bpd, 0, 0, 0, cst_name, 0, [0, default$], [0, a], 0, 0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1128[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1128[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1088 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1128, [0, schematic_cache$1088]);
		               caml_callback
		                (input_schema_versioned$46, [function(param){return 0;}]);
		               function schematic_version$185(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$46, [schematic_version$185]),
		                action$50 =
		                  action$0
		                   ("69de576fc8d8880c3eb42fcb",
		                    bU,
		                    "\n     Update an existing ClickUp task. Only include fields to change.\n     Priority:1=Urgent, 2=High, 3=Normal, 4=Low.\n     Example: {task_id: 'abc123', status: 'complete', priority: 1}.\n    ",
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1129 = [];
		               function input_schema_versioned$47(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1129[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bpf, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1129[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1129[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1129[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var task_id = param[1];
		                       return cont([0, task_id]);
		                      },
		                      function(param, cont){
		                       var task_id = param[1];
		                       return cont([0, task_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bpg,
		                        0,
		                        0,
		                        0,
		                        cst_task_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1129[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1129[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1089 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1129, [0, schematic_cache$1089]);
		               caml_callback
		                (input_schema_versioned$47, [function(param){return 0;}]);
		               function schematic_version$186(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$47, [schematic_version$186]),
		                action$51 =
		                  action$0
		                   ("69de576fc8d8880c3eb42fda",
		                    bZ,
		                    "\n     Delete a ClickUp task by ID. This action is irreversible.\n     Example: {task_id: 'abc123'}.\n    ",
		                    write$0(1, 1, 0),
		                    e),
		                cst_profilePicture = "profilePicture",
		                letrec_function_context$1130 = [];
		               function author_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1130[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bpi, bph, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1130[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1130[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1130[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$518[1],
		                             a =
		                               [0,
		                                [0,
		                                 bpj,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_profilePicture,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$519[1],
		                                       b =
		 [0,
		  [0, bpk, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$520[1],
		         a =
		           [0,
		            [0, bpl, 0, 0, 0, cst_email, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$521[1],
		                   b =
		                     [0,
		                      [0,
		                       bpm,
		                       0,
		                       0,
		                       0,
		                       cst_userId,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$522[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  profilePicture = c[2][1],
		                                  name = c[1],
		                                  email = b[1],
		                                  userId = a[1],
		                                  id = param[1];
		                                 return cont([0, id, userId, email, name, profilePicture]);
		                                },
		                                function(param, cont){
		                                 var
		                                  profilePicture = param[5],
		                                  name = param[4],
		                                  email = param[3],
		                                  userId = param[2],
		                                  id = param[1];
		                                 return cont
		 ([0,
		   id,
		   [0, userId, [0, email, [0, name, [0, profilePicture, 0]]]]]);
		                                },
		                                [0,
		                                 [0, bpn, 0, 0, 0, cst_id, 0, [0, default$], [0, a], 0, 0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1130[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1130[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1090 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1130, [0, schematic_cache$1090]);
		               caml_callback
		                (author_schema_versioned, [function(param){return 0;}]);
		               var
		                cst_boardId = "boardId",
		                cst_cursor = "cursor",
		                cst_inReview = "inReview",
		                cst_q = "q",
		                cst_sortBy = "sortBy",
		                cst_sortOrder = "sortOrder",
		                cst_statusId = "statusId",
		                letrec_function_context$1131 = [];
		               function input_schema_versioned$48(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1131[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bpp, bpo, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1131[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1131[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1131[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$523[1],
		                             a =
		                               [0,
		                                [0,
		                                 bpq,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_sortOrder,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$524[1],
		                                       b =
		 [0,
		  [0,
		   bpr,
		   0,
		   0,
		   0,
		   cst_sortBy,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$525[1],
		         a =
		           [0,
		            [0,
		             bps,
		             0,
		             0,
		             0,
		             cst_inReview,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$526[1],
		                   b =
		                     [0,
		                      [0, bpt, 0, 0, 0, cst_q, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(c){
		                            var
		                             default$ = match$527[1],
		                             a =
		                               [0,
		                                [0, bpu, 0, 0, 0, cst_tags, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$528[1],
		                                       b =
		 [0,
		  [0,
		   bpv,
		   0,
		   0,
		   0,
		   cst_statusId,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$529[1],
		         a =
		           [0,
		            [0,
		             bpw,
		             0,
		             0,
		             0,
		             cst_boardId,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$530[1],
		                   b =
		                     [0,
		                      [0,
		                       bpx,
		                       0,
		                       0,
		                       0,
		                       cst_cursor,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$531[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  sortOrder = g[2][1],
		                                  sortBy = g[1],
		                                  inReview = f[1],
		                                  q = e[1],
		                                  tags = d[1],
		                                  statusId = c[1],
		                                  boardId = b[1],
		                                  cursor = a[1],
		                                  limit = param[1];
		                                 return cont
		 ([0,
		   limit,
		   cursor,
		   boardId,
		   statusId,
		   tags,
		   q,
		   inReview,
		   sortBy,
		   sortOrder]);
		                                },
		                                function(param, cont){
		                                 var
		                                  sortOrder = param[9],
		                                  sortBy = param[8],
		                                  inReview = param[7],
		                                  q = param[6],
		                                  tags = param[5],
		                                  statusId = param[4],
		                                  boardId = param[3],
		                                  cursor = param[2],
		                                  limit = param[1];
		                                 return cont
		 ([0,
		   limit,
		   [0,
		    cursor,
		    [0,
		     boardId,
		     [0,
		      statusId,
		      [0,
		       tags,
		       [0, q, [0, inReview, [0, sortBy, [0, sortOrder, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0, bpy, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1131[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1131[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1091 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1131, [0, schematic_cache$1091]);
		               caml_callback
		                (input_schema_versioned$48, [function(param){return 0;}]);
		               function schematic_version$187(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$48, [schematic_version$187]),
		                bY = "List Posts",
		                action$52 =
		                  action$0
		                   ("6a31c417fbeeb9f38cdc736c",
		                    bY,
		                    "List feedback posts for the organization.\nReturns post IDs - use 'Get Post' for full details.\nFilter with boardId, statusId, tags, or q (search).\nPaginate with limit and cursor.\nExample: {input: {boardId: 'abc123', q: 'dark mode', limit: 20}}.",
		                    read$2(1),
		                    e),
		                letrec_function_context$1132 = [];
		               function input_schema_versioned$49(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1132[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bpA, bpz, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1132[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1132[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1132[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bpB,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1132[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1132[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1092 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1132, [0, schematic_cache$1092]);
		               caml_callback
		                (input_schema_versioned$49, [function(param){return 0;}]);
		               function schematic_version$188(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$49, [schematic_version$188]),
		                cst_Get_Post = "Get Post",
		                action$53 =
		                  action$0
		                   ("6a31c418cffc6846860d100d",
		                    cst_Get_Post,
		                    "Get a post by ID with full details.\nIncludes author, status, tags, votes, and custom fields.\nGet IDs from 'List Posts'.\nExample: {input: {id: 'post123'}}.",
		                    read$2(1),
		                    e),
		                cst_commentsEnabled = "commentsEnabled",
		                letrec_function_context$1133 = [];
		               function input_schema_versioned$50(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1133[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bpD, bpC, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1133[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1133[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1133[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (author_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$532[1],
		                                       a =
		 [0,
		  [0,
		   bpE,
		   0,
		   0,
		   0,
		   cst_author,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$533[1],
		         b =
		           [0,
		            [0,
		             bpF,
		             0,
		             0,
		             0,
		             cst_visibility,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$534[1],
		                   a =
		                     [0,
		                      [0,
		                       bpG,
		                       0,
		                       0,
		                       0,
		                       cst_assigneeId,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(c){
		                            var
		                             default$ = match$535[1],
		                             b =
		                               [0,
		                                [0,
		                                 bpH,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_inReview,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$536[1],
		                                       a =
		 [0,
		  [0,
		   bpI,
		   0,
		   0,
		   0,
		   cst_commentsEnabled,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$537[1],
		         b =
		           [0,
		            [0,
		             bpJ,
		             0,
		             0,
		             0,
		             cst_statusId,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(c){
		                  var
		                   default$ = match$538[1],
		                   a =
		                     [0,
		                      [0, bpK, 0, 0, 0, cst_tags, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$539[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  author = h[2][1],
		                                  visibility = h[1],
		                                  assigneeId = g[1],
		                                  inReview = f[1],
		                                  commentsEnabled = e[1],
		                                  statusId = d[1],
		                                  tags = c[1],
		                                  content = b[1],
		                                  boardId = a[1],
		                                  title = param[1];
		                                 return cont
		 ([0,
		   title,
		   boardId,
		   content,
		   tags,
		   statusId,
		   commentsEnabled,
		   inReview,
		   assigneeId,
		   visibility,
		   author]);
		                                },
		                                function(param, cont){
		                                 var
		                                  author = param[10],
		                                  visibility = param[9],
		                                  assigneeId = param[8],
		                                  inReview = param[7],
		                                  commentsEnabled = param[6],
		                                  statusId = param[5],
		                                  tags = param[4],
		                                  content = param[3],
		                                  boardId = param[2],
		                                  title = param[1];
		                                 return cont
		 ([0,
		   title,
		   [0,
		    boardId,
		    [0,
		     content,
		     [0,
		      tags,
		      [0,
		       statusId,
		       [0,
		        commentsEnabled,
		        [0,
		         inReview,
		         [0, assigneeId, [0, visibility, [0, author, 0]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bpN,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_title,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bpM,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_boardId,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bpL,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_content,
		                                    0,
		                                    [0, default$],
		                                    [0, b],
		                                    0,
		                                    0],
		                                   a]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1133[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1133[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1093 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1133, [0, schematic_cache$1093]);
		               caml_callback
		                (input_schema_versioned$50, [function(param){return 0;}]);
		               function schematic_version$189(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$50, [schematic_version$189]),
		                action$54 =
		                  action$0
		                   ("6a31c417cffc6846860d0fe5",
		                    "Create Post",
		                    "Create a feedback post in a board.\n'title' and 'boardId' are required.\nUse 'List Boards' to find a boardId first.\nContent is HTML.\nPass 'author' only to post on behalf of another user.\nExample: {input: {title: 'Add dark mode', boardId: 'board123', content: '<p>Please add a dark theme.<\/p>'}}.",
		                    write$0(0, 0, 1),
		                    e),
		                letrec_function_context$1134 = [];
		               function input_schema_versioned$51(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1134[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bpP, bpO, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1134[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1134[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1134[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (author_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$540[1],
		                                       a =
		 [0,
		  [0,
		   bpQ,
		   0,
		   0,
		   0,
		   cst_author,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$541[1],
		         b =
		           [0,
		            [0,
		             bpR,
		             0,
		             0,
		             0,
		             "sendStatusUpdateEmail",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$542[1],
		                   a =
		                     [0,
		                      [0,
		                       bpS,
		                       0,
		                       0,
		                       0,
		                       cst_visibility,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$543[1],
		                             b =
		                               [0,
		                                [0,
		                                 bpT,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assigneeId,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$544[1],
		                                       a =
		 [0,
		  [0,
		   bpU,
		   0,
		   0,
		   0,
		   cst_inReview,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$545[1],
		         b =
		           [0,
		            [0,
		             bpV,
		             0,
		             0,
		             0,
		             cst_commentsEnabled,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(c){
		                  var
		                   default$ = match$546[1],
		                   a =
		                     [0,
		                      [0, bpW, 0, 0, 0, cst_tags, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$547[1],
		                             b =
		                               [0,
		                                [0,
		                                 bpX,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_statusId,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$548[1],
		                                       a =
		 [0,
		  [0,
		   bpY,
		   0,
		   0,
		   0,
		   cst_boardId,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$549[1],
		         b =
		           [0,
		            [0,
		             bpZ,
		             0,
		             0,
		             0,
		             cst_content,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(a){
		                  var
		                   default$ = match$550[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        j = i[2],
		                        author = j[2][1],
		                        sendStatusUpdateEmail = j[1],
		                        visibility = i[1],
		                        assigneeId = h[1],
		                        inReview = g[1],
		                        commentsEnabled = f[1],
		                        tags = e[1],
		                        statusId = d[1],
		                        boardId = c[1],
		                        content = b[1],
		                        title = a[1],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 title,
		                                 content,
		                                 boardId,
		                                 statusId,
		                                 tags,
		                                 commentsEnabled,
		                                 inReview,
		                                 assigneeId,
		                                 visibility,
		                                 sendStatusUpdateEmail,
		                                 author]);
		                      },
		                      function(param, cont){
		                       var
		                        author = param[12],
		                        sendStatusUpdateEmail = param[11],
		                        visibility = param[10],
		                        assigneeId = param[9],
		                        inReview = param[8],
		                        commentsEnabled = param[7],
		                        tags = param[6],
		                        statusId = param[5],
		                        boardId = param[4],
		                        content = param[3],
		                        title = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0,
		                                  title,
		                                  [0,
		                                   content,
		                                   [0,
		                                    boardId,
		                                    [0,
		                                     statusId,
		                                     [0,
		                                      tags,
		                                      [0,
		                                       commentsEnabled,
		                                       [0,
		inReview,
		[0,
		 assigneeId,
		 [0, visibility, [0, sendStatusUpdateEmail, [0, author, 0]]]]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bp1,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bp0, 0, 0, 0, cst_title, 0, [0, default$], [0, a], 0, 0],
		                        b]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1134[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1134[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1094 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1134, [0, schematic_cache$1094]);
		               caml_callback
		                (input_schema_versioned$51, [function(param){return 0;}]);
		               function schematic_version$190(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$51, [schematic_version$190]),
		                action$55 =
		                  action$0
		                   ("6a31c41882be4cae9a74dacd",
		                    "Update Post",
		                    "Update an existing post.\nOnly the fields you pass are changed.\nUse 'statusId' with 'sendStatusUpdateEmail' to notify voters of status changes.\nExample: {input: {id: 'post123', statusId: 'status456', sendStatusUpdateEmail: true}}.",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1135 = [];
		               function input_schema_versioned$52(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1135[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bp3, bp2, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1135[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1135[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1135[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bp4,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1135[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1135[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1095 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1135, [0, schematic_cache$1095]);
		               caml_callback
		                (input_schema_versioned$52, [function(param){return 0;}]);
		               function schematic_version$191(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$52, [schematic_version$191]),
		                action$56 =
		                  action$0
		                   ("6a328db560a20aee2d71e08a",
		                    "Delete Post",
		                    "Permanently delete a post.\nAll comments and votes on the post are also deleted.\nThis cannot be undone.\nExample: {input: {id: 'post123'}}.",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1136 = [];
		               function input_schema_versioned$53(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1136[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bp6, bp5, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1136[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1136[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1136[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$551[1],
		                             a =
		                               [0,
		                                [0,
		                                 bp7,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_cursor,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$552[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    cursor = a[2][1],
		    limit = a[1],
		    id = param[1];
		   return cont([0, id, limit, cursor]);
		  },
		  function(param, cont){
		   var cursor = param[3], limit = param[2], id = param[1];
		   return cont([0, id, [0, limit, [0, cursor, 0]]]);
		  },
		  [0,
		   [0,
		    bp9,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bp8, 0, 0, 0, cst_limit, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1136[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1136[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1096 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1136, [0, schematic_cache$1096]);
		               caml_callback
		                (input_schema_versioned$53, [function(param){return 0;}]);
		               function schematic_version$192(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$53, [schematic_version$192]),
		                action$57 =
		                  action$0
		                   ("6a31c41959e185edbcb8cdd4",
		                    "List Voters",
		                    "List the users who upvoted a post.\nPaginate with limit and cursor.\nExample: {input: {id: 'post123', limit: 50}}.",
		                    read$2(1),
		                    e),
		                letrec_function_context$1137 = [];
		               function input_schema_versioned$54(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1137[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bp$, bp_, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1137[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1137[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1137[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$553[1],
		                             a =
		                               [0,
		                                [0,
		                                 bqa,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_profilePicture,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$554[1],
		                                       b =
		 [0,
		  [0, bqb, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$555[1],
		         a =
		           [0,
		            [0, bqc, 0, 0, 0, cst_email, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$556[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        profilePicture = c[2][1],
		                        name = c[1],
		                        email = b[1],
		                        userId = a[1],
		                        id = param[1];
		                       return cont([0, id, userId, email, name, profilePicture]);
		                      },
		                      function(param, cont){
		                       var
		                        profilePicture = param[5],
		                        name = param[4],
		                        email = param[3],
		                        userId = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0, userId, [0, email, [0, name, [0, profilePicture, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bqe,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bqd,
		                         0,
		                         0,
		                         0,
		                         cst_userId,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1137[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1137[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1097 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1137, [0, schematic_cache$1097]);
		               caml_callback
		                (input_schema_versioned$54, [function(param){return 0;}]);
		               function schematic_version$193(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$54, [schematic_version$193]),
		                action$58 =
		                  action$0
		                   ("6a328db62bb0a3e272780cb2",
		                    "Add Voter",
		                    "Add an upvote to a post.\nWithout any voter fields, the authenticated user's vote is added.\nPass userId or email to vote on behalf of someone else.\nThe request is idempotent: a duplicate vote is not added.\nExample: {input: {id: 'post123', email: 'user@example.com'}}.",
		                    write$0(0, 1, 1),
		                    e),
		                letrec_function_context$1138 = [];
		               function input_schema_versioned$55(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1138[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bqg, bqf, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1138[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1138[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1138[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$557[1],
		                             a =
		                               [0,
		                                [0, bqh, 0, 0, 0, cst_email, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$558[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    email = a[2][1],
		    userId = a[1],
		    id = param[1];
		   return cont([0, id, userId, email]);
		  },
		  function(param, cont){
		   var email = param[3], userId = param[2], id = param[1];
		   return cont([0, id, [0, userId, [0, email, 0]]]);
		  },
		  [0,
		   [0,
		    bqj,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bqi,
		     0,
		     0,
		     0,
		     cst_userId,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1138[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1138[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1098 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1138, [0, schematic_cache$1098]);
		               caml_callback
		                (input_schema_versioned$55, [function(param){return 0;}]);
		               function schematic_version$194(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$55, [schematic_version$194]),
		                action$59 =
		                  action$0
		                   ("6a328db62b16867d972b41e7",
		                    "Remove Voter",
		                    "Remove an upvote from a post.\nWithout any voter fields, the authenticated user's vote is removed.\nPass userId or email to remove the vote on behalf of someone else.\nExample: {input: {id: 'post123', email: 'user@example.com'}}.",
		                    write$0(1, 0, 1),
		                    e),
		                e = "List Boards",
		                action$60 =
		                  action$0
		                   ("6a328e1a242bfce04b450fbe",
		                    e,
		                    "List all boards (post categories) for the organization.\nBoards are containers for posts.\nUse a board's ID with 'Create Post' or as a filter on 'List Posts'.\nReturns all boards without pagination.\nExample: {input: {}}.",
		                    read$2(1),
		                    empty_object_schema),
		                letrec_function_context$1139 = [];
		               function input_schema_versioned$56(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1139[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bql, bqk, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1139[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1139[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1139[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bqm,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1139[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1139[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1099 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1139, [0, schematic_cache$1099]);
		               caml_callback
		                (input_schema_versioned$56, [function(param){return 0;}]);
		               function schematic_version$195(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$56, [schematic_version$195]),
		                cst_Get_Board = "Get Board",
		                action$61 =
		                  action$0
		                   ("6a328e1aa78c2ef51c591ea4",
		                    cst_Get_Board,
		                    "Get a board by ID.\nIncludes access controls, feature toggles, and localization settings.\nGet IDs from 'List Boards'.\nExample: {input: {id: 'board123'}}.",
		                    read$2(1),
		                    bV),
		                cst_changelogId = "changelogId",
		                cst_postId = "postId",
		                letrec_function_context$1140 = [];
		               function input_schema_versioned$57(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1140[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bqo, bqn, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1140[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1140[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1140[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$559[1],
		                             a =
		                               [0,
		                                [0,
		                                 bqp,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_sortBy,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$560[1],
		                                       b =
		 [0,
		  [0,
		   bqq,
		   0,
		   0,
		   0,
		   cst_cursor,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$561[1],
		         a =
		           [0,
		            [0, bqr, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$562[1],
		                   b =
		                     [0,
		                      [0,
		                       bqs,
		                       0,
		                       0,
		                       0,
		                       cst_inReview,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$563[1],
		                             a =
		                               [0,
		                                [0,
		                                 bqt,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_privacy,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$564[1],
		                                       b =
		 [0,
		  [0,
		   bqu,
		   0,
		   0,
		   0,
		   cst_changelogId,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$565[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              sortBy = e[2][1],
		              cursor = e[1],
		              limit = d[1],
		              inReview = c[1],
		              privacy = b[1],
		              changelogId = a[1],
		              postId = param[1];
		             return cont
		                     ([0,
		                       postId,
		                       changelogId,
		                       privacy,
		                       inReview,
		                       limit,
		                       cursor,
		                       sortBy]);
		            },
		            function(param, cont){
		             var
		              sortBy = param[7],
		              cursor = param[6],
		              limit = param[5],
		              inReview = param[4],
		              privacy = param[3],
		              changelogId = param[2],
		              postId = param[1];
		             return cont
		                     ([0,
		                       postId,
		                       [0,
		                        changelogId,
		                        [0,
		                         privacy,
		                         [0, inReview, [0, limit, [0, cursor, [0, sortBy, 0]]]]]]]);
		            },
		            [0,
		             [0,
		              bqv,
		              0,
		              0,
		              0,
		              cst_postId,
		              0,
		              [0, default$],
		              [0, a],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1140[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1140[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1100 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1140, [0, schematic_cache$1100]);
		               caml_callback
		                (input_schema_versioned$57, [function(param){return 0;}]);
		               function schematic_version$196(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$57, [schematic_version$196]),
		                cst_List_Comments = "List Comments",
		                action$62 =
		                  action$0
		                   ("6a328edece0f061d16326311",
		                    cst_List_Comments,
		                    "List comments for the organization.\nFilter by postId or changelogId to scope to one item.\nComments are threaded via 'parentCommentId' (null for root comments).\nPaginate with limit and cursor.\nExample: {input: {postId: 'post123', sortBy: 'new'}}.",
		                    read$2(1),
		                    bV),
		                letrec_function_context$1141 = [];
		               function input_schema_versioned$58(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1141[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bqx, bqw, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1141[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1141[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1141[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bqy,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1141[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1141[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1101 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1141, [0, schematic_cache$1101]);
		               caml_callback
		                (input_schema_versioned$58, [function(param){return 0;}]);
		               function schematic_version$197(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$58, [schematic_version$197]),
		                cst_Get_Comment = "Get Comment",
		                action$63 =
		                  action$0
		                   ("6a328edf2bb0a3e2727840fb",
		                    cst_Get_Comment,
		                    "Get a comment by ID with full details.\nIncludes author, voting stats, privacy, and threading info.\nExample: {input: {id: 'comment123'}}.",
		                    read$2(1),
		                    bV),
		                cst_isPrivate = "isPrivate",
		                letrec_function_context$1142 = [];
		               function input_schema_versioned$59(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1142[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bqA, bqz, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1142[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1142[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1142[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (author_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$566[1],
		                                       a =
		 [0,
		  [0,
		   bqB,
		   0,
		   0,
		   0,
		   cst_author,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$567[1],
		         b =
		           [0,
		            [0,
		             bqC,
		             0,
		             0,
		             0,
		             "sendNotification",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$568[1],
		                   a =
		                     [0,
		                      [0,
		                       bqD,
		                       0,
		                       0,
		                       0,
		                       cst_isPrivate,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$569[1],
		                             b =
		                               [0,
		                                [0,
		                                 bqE,
		                                 0,
		                                 0,
		                                 0,
		                                 "parentCommentId",
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$570[1],
		                                       a =
		 [0,
		  [0,
		   bqF,
		   0,
		   0,
		   0,
		   cst_changelogId,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(b){
		        var
		         default$ = match$571[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              author = e[2][1],
		              sendNotification = e[1],
		              isPrivate = d[1],
		              parentCommentId = c[1],
		              changelogId = b[1],
		              postId = a[1],
		              content = param[1];
		             return cont
		                     ([0,
		                       content,
		                       postId,
		                       changelogId,
		                       parentCommentId,
		                       isPrivate,
		                       sendNotification,
		                       author]);
		            },
		            function(param, cont){
		             var
		              author = param[7],
		              sendNotification = param[6],
		              isPrivate = param[5],
		              parentCommentId = param[4],
		              changelogId = param[3],
		              postId = param[2],
		              content = param[1];
		             return cont
		                     ([0,
		                       content,
		                       [0,
		                        postId,
		                        [0,
		                         changelogId,
		                         [0,
		                          parentCommentId,
		                          [0, isPrivate, [0, sendNotification, [0, author, 0]]]]]]]);
		            },
		            [0,
		             [0,
		              bqH,
		              0,
		              0,
		              0,
		              cst_content,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bqG,
		               0,
		               0,
		               0,
		               cst_postId,
		               0,
		               [0, default$],
		               [0, b],
		               0,
		               0],
		              a]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1142[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1142[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1102 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1142, [0, schematic_cache$1102]);
		               caml_callback
		                (input_schema_versioned$59, [function(param){return 0;}]);
		               function schematic_version$198(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$59, [schematic_version$198]),
		                cst_Create_Comment = "Create Comment",
		                action$64 =
		                  action$0
		                   ("6a328edfeabbdcfa8436f2bc",
		                    cst_Create_Comment,
		                    "Create a comment on a post or changelog.\n'content' is required and must be HTML.\nProvide either 'postId' or 'changelogId' to set the target.\nPass 'parentCommentId' to reply to an existing comment.\nExample: {input: {postId: 'post123', content: '<p>Great idea!<\/p>'}}.",
		                    write$0(0, 0, 1),
		                    bV),
		                letrec_function_context$1143 = [];
		               function input_schema_versioned$60(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1143[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bqJ, bqI, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1143[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1143[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1143[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$572[1],
		                             a =
		                               [0,
		                                [0,
		                                 bqK,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_inReview,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$573[1],
		                                       b =
		 [0,
		  [0,
		   bqL,
		   0,
		   0,
		   0,
		   "isPinned",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$574[1],
		         a =
		           [0,
		            [0,
		             bqM,
		             0,
		             0,
		             0,
		             cst_isPrivate,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$575[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        inReview = c[2][1],
		                        isPinned = c[1],
		                        isPrivate = b[1],
		                        content = a[1],
		                        id = param[1];
		                       return cont([0, id, content, isPrivate, isPinned, inReview]);
		                      },
		                      function(param, cont){
		                       var
		                        inReview = param[5],
		                        isPinned = param[4],
		                        isPrivate = param[3],
		                        content = param[2],
		                        id = param[1];
		                       return cont
		                               ([0,
		                                 id,
		                                 [0,
		                                  content,
		                                  [0, isPrivate, [0, isPinned, [0, inReview, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bqO,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bqN,
		                         0,
		                         0,
		                         0,
		                         cst_content,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1143[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1143[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1103 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1143, [0, schematic_cache$1103]);
		               caml_callback
		                (input_schema_versioned$60, [function(param){return 0;}]);
		               function schematic_version$199(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$60, [schematic_version$199]),
		                b6 = "Update Comment",
		                action$65 =
		                  action$0
		                   ("6a328edfeabbdcfa8436f300",
		                    b6,
		                    "Update an existing comment.\nOnly the fields you pass are changed.\nContent is HTML.\nExample: {input: {id: 'comment123', content: '<p>Edited.<\/p>'}}.",
		                    write$0(1, 0, 1),
		                    bV),
		                letrec_function_context$1144 = [];
		               function input_schema_versioned$61(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1144[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bqQ, bqP, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1144[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1144[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1144[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bqR,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1144[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1144[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1104 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1144, [0, schematic_cache$1104]);
		               caml_callback
		                (input_schema_versioned$61, [function(param){return 0;}]);
		               function schematic_version$200(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$61, [schematic_version$200]),
		                b0 = "Delete Comment",
		                action$66 =
		                  action$0
		                   ("6a328ee0c738845bc08c56d3",
		                    b0,
		                    "Delete a comment by ID.\nComments with replies are soft-deleted (content becomes \"[deleted]\").\nComments without replies are removed permanently.\nExample: {input: {id: 'comment123'}}.",
		                    write$0(1, 0, 1),
		                    bV);
		               function timestamp_schema_versioned$0(schematic_version){
		                schematic_version(V$4);
		                return [0,
		                        bqW,
		                        bqV,
		                        schematic_param_name_schema_ve[3],
		                        schematic_param_name_schema_ve[4]];
		               }
		               var
		                cst_Asc = "Asc",
		                cst_Desc = "Desc",
		                letrec_function_context$1145 = [];
		               function direction_schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1145[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bqY, bqX, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1145[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1145[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1145[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bq2);},
		                        0,
		                        0,
		                        cst_asc,
		                        cst_Asc,
		                        bq1,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(bq0) : cont(0);},
		                         0,
		                         0,
		                         cst_desc,
		                         cst_Desc,
		                         bqZ,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1145[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1145[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1105 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1145, [0, schematic_cache$1105]);
		               caml_callback
		                (direction_schema_versioned$0, [function(param){return 0;}]);
		               var letrec_function_context$1146 = [];
		               function state_schema_versioned$77(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1146[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bq4, bq3, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1146[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1146[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1146[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bq_);},
		                        0,
		                        0,
		                        cst_open,
		                        cst_Open,
		                        bq9,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bq8) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_closed,
		                         cst_Closed,
		                         bq7,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(bq6) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_all,
		                          cst_All,
		                          bq5,
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1146[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1146[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1106 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1146, [0, schematic_cache$1106]);
		               caml_callback
		                (state_schema_versioned$77, [function(param){return 0;}]);
		               var
		                cst_Comments = "Comments",
		                letrec_function_context$1147 = [];
		               function sort_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1147[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bq$, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1147[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1147[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1147[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(brf);},
		                        0,
		                        0,
		                        cst_created,
		                        cst_Created,
		                        bre,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(brd) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_updated,
		                         cst_Updated,
		                         brc,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(brb) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_comments,
		                          cst_Comments,
		                          bra,
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1147[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1147[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1107 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1147, [0, schematic_cache$1107]);
		               caml_callback
		                (sort_schema_versioned, [function(param){return 0;}]);
		               var cst_repo = "repo", letrec_function_context$1148 = [];
		               function input_schema_versioned$62(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1148[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, brg, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1148[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1148[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1148[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$576[1],
		                             a =
		                               [0,
		                                [0, brh, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$577[1],
		                                       b =
		 [0,
		  [0,
		   bri,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (direction_schema_versioned$0,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$578[1],
		                   a =
		                     [0,
		                      [0,
		                       brj,
		                       0,
		                       0,
		                       0,
		                       cst_direction,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (sort_schema_versioned,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(c){
		                                      var
		                                       default$ = match$579[1],
		                                       b =
		 [0,
		  [0, brk, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$580[1],
		         a =
		           [0,
		            [0,
		             brl,
		             0,
		             0,
		             0,
		             cst_labels,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$581[1],
		                   b =
		                     [0,
		                      [0,
		                       brm,
		                       0,
		                       0,
		                       0,
		                       cst_creator,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$582[1],
		                             a =
		                               [0,
		                                [0,
		                                 brn,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assignee,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$77,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(b){
		        var
		         default$ = match$583[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              page = h[2][1],
		              per_page = h[1],
		              direction = g[1],
		              sort = f[1],
		              labels = e[1],
		              creator = d[1],
		              assignee = c[1],
		              state = b[1],
		              repo = a[1],
		              owner = param[1];
		             return cont
		                     ([0,
		                       owner,
		                       repo,
		                       state,
		                       assignee,
		                       creator,
		                       labels,
		                       sort,
		                       direction,
		                       per_page,
		                       page]);
		            },
		            function(param, cont){
		             var
		              page = param[10],
		              per_page = param[9],
		              direction = param[8],
		              sort = param[7],
		              labels = param[6],
		              creator = param[5],
		              assignee = param[4],
		              state = param[3],
		              repo = param[2],
		              owner = param[1];
		             return cont
		                     ([0,
		                       owner,
		                       [0,
		                        repo,
		                        [0,
		                         state,
		                         [0,
		                          assignee,
		                          [0,
		                           creator,
		                           [0,
		                            labels,
		                            [0, sort, [0, direction, [0, per_page, [0, page, 0]]]]]]]]]]);
		            },
		            [0,
		             [0,
		              brq,
		              0,
		              0,
		              0,
		              cst_owner,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               brp,
		               0,
		               0,
		               0,
		               cst_repo,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0, bro, 0, 0, 0, cst_state, 0, [0, default$], [0, b], 0, 0],
		               a]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1148[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1148[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1108 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1148, [0, schematic_cache$1108]);
		               caml_callback
		                (input_schema_versioned$62, [function(param){return 0;}]);
		               function schematic_version$201(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$62, [schematic_version$201]),
		                bO9 = "List Issues",
		                action$67 =
		                  action$0
		                   ("699c56e3454b98ee35ee2b81",
		                    bO9,
		                    "\nList issues in a GitHub repository.\nReturns issues matching optional filters.\nExample: {owner: 'acme', repo: 'myapp', state: 'open', labels: 'bug'}.\n",
		                    read$2(1),
		                    bV),
		                cst_issue_number = "issue_number",
		                letrec_function_context$1149 = [];
		               function input_schema_versioned$63(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1149[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, brs, brr, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1149[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1149[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1149[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        issue_number = a[2][1],
		                        repo = a[1],
		                        owner = param[1];
		                       return cont([0, owner, repo, issue_number]);
		                      },
		                      function(param, cont){
		                       var
		                        issue_number = param[3],
		                        repo = param[2],
		                        owner = param[1];
		                       return cont([0, owner, [0, repo, [0, issue_number, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        brv,
		                        0,
		                        0,
		                        0,
		                        cst_owner,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bru,
		                         0,
		                         0,
		                         0,
		                         cst_repo,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          brt,
		                          0,
		                          0,
		                          0,
		                          cst_issue_number,
		                          0,
		                          2,
		                          [0, int_schema],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1149[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1149[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1109 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1149, [0, schematic_cache$1109]);
		               caml_callback
		                (input_schema_versioned$63, [function(param){return 0;}]);
		               function schematic_version$202(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$63, [schematic_version$202]),
		                cst_Get_Issue = "Get Issue",
		                action$68 =
		                  action$0
		                   ("699c56e3454b98ee35ee2b78",
		                    cst_Get_Issue,
		                    "\nGet a specific issue by number.\nExample: {owner: 'acme', repo: 'myapp', issue_number: 42}.\n",
		                    read$2(1),
		                    bV),
		                cst_milestone = "milestone",
		                letrec_function_context$1150 = [];
		               function input_schema_versioned$64(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1150[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, brx, brw, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1150[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1150[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1150[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$584[1],
		                             a =
		                               [0,
		                                [0,
		                                 bry,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_milestone,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$585[1],
		                                       b =
		 [0,
		  [0,
		   brz,
		   0,
		   0,
		   0,
		   cst_labels,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$586[1],
		         a =
		           [0,
		            [0,
		             brA,
		             0,
		             0,
		             0,
		             cst_assignees,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$587[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        milestone = e[2][1],
		                        labels = e[1],
		                        assignees = d[1],
		                        body = c[1],
		                        title = b[1],
		                        repo = a[1],
		                        owner = param[1];
		                       return cont
		                               ([0, owner, repo, title, body, assignees, labels, milestone]);
		                      },
		                      function(param, cont){
		                       var
		                        milestone = param[7],
		                        labels = param[6],
		                        assignees = param[5],
		                        body = param[4],
		                        title = param[3],
		                        repo = param[2],
		                        owner = param[1];
		                       return cont
		                               ([0,
		                                 owner,
		                                 [0,
		                                  repo,
		                                  [0,
		                                   title,
		                                   [0, body, [0, assignees, [0, labels, [0, milestone, 0]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        brE,
		                        0,
		                        0,
		                        0,
		                        cst_owner,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         brD,
		                         0,
		                         0,
		                         0,
		                         cst_repo,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          brC,
		                          0,
		                          0,
		                          0,
		                          cst_title,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0, brB, 0, 0, 0, cst_body, 0, [0, default$], [0, b], 0, 0],
		                          a]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1150[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1150[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1110 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1150, [0, schematic_cache$1110]);
		               caml_callback
		                (input_schema_versioned$64, [function(param){return 0;}]);
		               function schematic_version$203(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$64, [schematic_version$203]),
		                cst_Create_Issue = "Create Issue",
		                action$69 =
		                  action$0
		                   ("699c56e3454b98ee35ee2b6f",
		                    cst_Create_Issue,
		                    "\nCreate a new issue in a GitHub repository.\nExample: {owner: 'acme', repo: 'myapp', title: 'Bug: crash on startup', body: 'Steps to reproduce...', labels: ['bug']}.\n",
		                    write$0(0, 0, 1),
		                    bV),
		                letrec_function_context$1151 = [];
		               function state_schema_versioned$78(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1151[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, brF, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1151[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1151[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1151[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(brJ);},
		                        0,
		                        0,
		                        cst_open,
		                        cst_Open,
		                        brI,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(brH) : cont(0);},
		                         0,
		                         0,
		                         cst_closed,
		                         cst_Closed,
		                         brG,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1151[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1151[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1111 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1151, [0, schematic_cache$1111]);
		               caml_callback
		                (state_schema_versioned$78, [function(param){return 0;}]);
		               var letrec_function_context$1152 = [];
		               function state_reason_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1152[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, brK, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1152[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1152[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1152[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(brQ);},
		                        0,
		                        0,
		                        cst_completed,
		                        cst_Completed,
		                        brP,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(brO) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_not_planned,
		                         "Not_planned",
		                         brN,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(brM) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_reopened,
		                          "Reopened",
		                          brL,
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1152[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1152[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1112 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1152, [0, schematic_cache$1112]);
		               caml_callback
		                (state_reason_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1153 = [];
		               function input_schema_versioned$65(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1153[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, brR, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1153[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1153[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1153[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$588[1],
		                             a =
		                               [0,
		                                [0,
		                                 brS,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_milestone,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$589[1],
		                                       b =
		 [0,
		  [0,
		   brT,
		   0,
		   0,
		   0,
		   cst_labels,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$590[1],
		         a =
		           [0,
		            [0,
		             brU,
		             0,
		             0,
		             0,
		             cst_assignees,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (state_reason_schema_versioned,
		                 schematic_version,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$591[1],
		                             b =
		                               [0,
		                                [0,
		                                 brV,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_state_reason,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (state_schema_versioned$78,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       a,
		       function(c){
		        var
		         default$ = match$592[1],
		         a =
		           [0,
		            [0, brW, 0, 0, 0, cst_state, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$593[1],
		                   b =
		                     [0,
		                      [0, brX, 0, 0, 0, cst_body, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$594[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  milestone = h[2][1],
		                                  labels = h[1],
		                                  assignees = g[1],
		                                  state_reason = f[1],
		                                  state = e[1],
		                                  body = d[1],
		                                  title = c[1],
		                                  issue_number = b[1],
		                                  repo = a[1],
		                                  owner = param[1];
		                                 return cont
		 ([0,
		   owner,
		   repo,
		   issue_number,
		   title,
		   body,
		   state,
		   state_reason,
		   assignees,
		   labels,
		   milestone]);
		                                },
		                                function(param, cont){
		                                 var
		                                  milestone = param[10],
		                                  labels = param[9],
		                                  assignees = param[8],
		                                  state_reason = param[7],
		                                  state = param[6],
		                                  body = param[5],
		                                  title = param[4],
		                                  issue_number = param[3],
		                                  repo = param[2],
		                                  owner = param[1];
		                                 return cont
		 ([0,
		   owner,
		   [0,
		    repo,
		    [0,
		     issue_number,
		     [0,
		      title,
		      [0,
		       body,
		       [0,
		        state,
		        [0,
		         state_reason,
		         [0, assignees, [0, labels, [0, milestone, 0]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  br1,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_owner,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   br0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_repo,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    brZ,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_issue_number,
		                                    0,
		                                    2,
		                                    [0, int_schema],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0, brY, 0, 0, 0, cst_title, 0, [0, default$], [0, a], 0, 0],
		                                    b]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1153[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1153[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1113 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1153, [0, schematic_cache$1113]);
		               caml_callback
		                (input_schema_versioned$65, [function(param){return 0;}]);
		               function schematic_version$204(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$65, [schematic_version$204]),
		                bO7 = "Update Issue",
		                action$70 =
		                  action$0
		                   ("699c56e3454b98ee35ee2b8a",
		                    bO7,
		                    "\nUpdate an existing issue.\nUse state='closed' to close or state='open' to reopen.\nExample: {owner: 'acme', repo: 'myapp', issue_number: 42, state: 'closed', state_reason: 'completed'}.\n",
		                    write$0(1, 1, 1),
		                    bV),
		                letrec_function_context$1154 = [];
		               function input_schema_versioned$66(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1154[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, br3, br2, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1154[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1154[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1154[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        body = b[2][1],
		                        issue_number = b[1],
		                        repo = a[1],
		                        owner = param[1];
		                       return cont([0, owner, repo, issue_number, body]);
		                      },
		                      function(param, cont){
		                       var
		                        body = param[4],
		                        issue_number = param[3],
		                        repo = param[2],
		                        owner = param[1];
		                       return cont
		                               ([0, owner, [0, repo, [0, issue_number, [0, body, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        br7,
		                        0,
		                        0,
		                        0,
		                        cst_owner,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         br6,
		                         0,
		                         0,
		                         0,
		                         cst_repo,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          br5,
		                          0,
		                          0,
		                          0,
		                          cst_issue_number,
		                          0,
		                          2,
		                          [0, int_schema],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           br4,
		                           0,
		                           0,
		                           0,
		                           cst_body,
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          0]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1154[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1154[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1114 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1154, [0, schematic_cache$1114]);
		               caml_callback
		                (input_schema_versioned$66, [function(param){return 0;}]);
		               function schematic_version$205(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$66, [schematic_version$205]),
		                action$71 =
		                  action$0
		                   ("699c56e3454b98ee35ee2b93",
		                    "Create Issue Comment",
		                    "\nPost a comment on an issue or pull request.\nExample: {owner: 'acme', repo: 'myapp', issue_number: 42, body: 'Looking into this now.'}.\n",
		                    write$0(0, 0, 1),
		                    bV),
		                letrec_function_context$1155 = [];
		               function input_schema_versioned$67(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1155[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, br9, br8, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1155[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1155[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1155[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$595[1],
		                             a =
		                               [0,
		                                [0, br_, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$596[1],
		                                       b =
		 [0,
		  [0,
		   br$,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       timestamp_schema_versioned$0(schematic_version),
		       function(a){
		        var
		         default$ = match$597[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              page = d[2][1],
		              per_page = d[1],
		              since = c[1],
		              issue_number = b[1],
		              repo = a[1],
		              owner = param[1];
		             return cont
		                     ([0, owner, repo, issue_number, since, per_page, page]);
		            },
		            function(param, cont){
		             var
		              page = param[6],
		              per_page = param[5],
		              since = param[4],
		              issue_number = param[3],
		              repo = param[2],
		              owner = param[1];
		             return cont
		                     ([0,
		                       owner,
		                       [0,
		                        repo,
		                        [0, issue_number, [0, since, [0, per_page, [0, page, 0]]]]]]);
		            },
		            [0,
		             [0,
		              bsd,
		              0,
		              0,
		              0,
		              cst_owner,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bsc,
		               0,
		               0,
		               0,
		               cst_repo,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                bsb,
		                0,
		                0,
		                0,
		                cst_issue_number,
		                0,
		                2,
		                [0, int_schema],
		                0,
		                0],
		               [0,
		                [0, bsa, 0, 0, 0, "since", 0, [0, default$], [0, a], 0, 0],
		                b]]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1155[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1155[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1115 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1155, [0, schematic_cache$1115]);
		               caml_callback
		                (input_schema_versioned$67, [function(param){return 0;}]);
		               function schematic_version$206(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$67, [schematic_version$206]),
		                action$72 =
		                  action$0
		                   ("699c56e3454b98ee35ee2b9c",
		                    "List Issue Comments",
		                    "\nList comments on an issue or pull request.\nExample: {owner: 'acme', repo: 'myapp', issue_number: 42}.\n",
		                    read$2(1),
		                    bV),
		                letrec_function_context$1156 = [];
		               function sort_schema_versioned$0(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1156[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bse, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1156[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1156[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1156[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bso);},
		                        0,
		                        0,
		                        cst_comments,
		                        cst_Comments,
		                        bsn,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bsm) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_reactions,
		                         "Reactions",
		                         bsl,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bsk) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_created,
		                          cst_Created,
		                          bsj,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(bsi) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_updated,
		                           cst_Updated,
		                           bsh,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 <= param ? cont(bsg) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_interactions,
		                            "Interactions",
		                            bsf,
		                            0],
		                           0]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1156[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1156[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1116 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1156, [0, schematic_cache$1116]);
		               caml_callback
		                (sort_schema_versioned$0, [function(param){return 0;}]);
		               var cst_order = "order", letrec_function_context$1157 = [];
		               function input_schema_versioned$68(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1157[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bsp, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1157[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1157[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1157[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$598[1],
		                             a =
		                               [0,
		                                [0, bsq, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$599[1],
		                                       b =
		 [0,
		  [0,
		   bsr,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (direction_schema_versioned$0,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$600[1],
		                   a =
		                     [0,
		                      [0, bss, 0, 0, 0, cst_order, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (sort_schema_versioned$0,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(b){
		                                      var
		                                       default$ = match$601[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    page = c[2][1],
		    per_page = c[1],
		    order = b[1],
		    sort = a[1],
		    q = param[1];
		   return cont([0, q, sort, order, per_page, page]);
		  },
		  function(param, cont){
		   var
		    page = param[5],
		    per_page = param[4],
		    order = param[3],
		    sort = param[2],
		    q = param[1];
		   return cont
		           ([0, q, [0, sort, [0, order, [0, per_page, [0, page, 0]]]]]);
		  },
		  [0,
		   [0,
		    bsu,
		    0,
		    0,
		    0,
		    cst_q,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bst, 0, 0, 0, cst_sort, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1157[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1157[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1117 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1157, [0, schematic_cache$1117]);
		               caml_callback
		                (input_schema_versioned$68, [function(param){return 0;}]);
		               function schematic_version$207(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$68, [schematic_version$207]),
		                action$73 =
		                  action$0
		                   ("699c56e4454b98ee35ee2c2c",
		                    "Search Issues and PRs",
		                    "\nSearch issues and pull requests using GitHub's query syntax.\nExample: {q: 'repo:acme/myapp is:issue is:open label:bug'}.\nSee GitHub search syntax docs for full qualifier reference.\n",
		                    read$2(1),
		                    bV),
		                cst_Public = "Public",
		                letrec_function_context$1158 = [];
		               function type_schema_versioned$1(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1158[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bsv, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1158[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1158[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1158[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bsH);},
		                        0,
		                        0,
		                        cst_all,
		                        cst_All,
		                        bsG,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bsF) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_public,
		                         cst_Public,
		                         bsE,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bsD) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_private,
		                          "Private",
		                          bsC,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(bsB) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_forks,
		                           "Forks",
		                           bsA,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 === param ? cont(bsz) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_sources,
		                            "Sources",
		                            bsy,
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(5);},
		                             function(param, cont){
		                              return 5 <= param ? cont(bsx) : cont(0);
		                             },
		                             0,
		                             0,
		                             cst_member,
		                             cst_Member,
		                             bsw,
		                             0],
		                            0]]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1158[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1158[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1118 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1158, [0, schematic_cache$1118]);
		               caml_callback
		                (type_schema_versioned$1, [function(param){return 0;}]);
		               var
		                cst_Full_name = "Full_name",
		                cst_Pushed = "Pushed",
		                letrec_function_context$1159 = [];
		               function sort_schema_versioned$1(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1159[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bsI, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1159[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1159[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1159[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bsQ);},
		                        0,
		                        0,
		                        cst_created,
		                        cst_Created,
		                        bsP,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bsO) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_updated,
		                         cst_Updated,
		                         bsN,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bsM) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_pushed,
		                          cst_Pushed,
		                          bsL,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 <= param ? cont(bsK) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_full_name,
		                           cst_Full_name,
		                           bsJ,
		                           0],
		                          0]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1159[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1159[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1119 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1159, [0, schematic_cache$1119]);
		               caml_callback
		                (sort_schema_versioned$1, [function(param){return 0;}]);
		               var letrec_function_context$1160 = [];
		               function input_schema_versioned$69(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1160[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bsR, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1160[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1160[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1160[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$602[1],
		                             a =
		                               [0,
		                                [0, bsS, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$603[1],
		                                       b =
		 [0,
		  [0,
		   bsT,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (direction_schema_versioned$0,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$604[1],
		                   a =
		                     [0,
		                      [0,
		                       bsU,
		                       0,
		                       0,
		                       0,
		                       cst_direction,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (sort_schema_versioned$1,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(c){
		                                      var
		                                       default$ = match$605[1],
		                                       b =
		 [0,
		  [0, bsV, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (type_schema_versioned$1,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(a){
		                  var
		                   default$ = match$606[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        page = d[2][1],
		                        per_page = d[1],
		                        direction = c[1],
		                        sort = b[1],
		                        type = a[1],
		                        org = param[1];
		                       return cont([0, org, type, sort, direction, per_page, page]);
		                      },
		                      function(param, cont){
		                       var
		                        page = param[6],
		                        per_page = param[5],
		                        direction = param[4],
		                        sort = param[3],
		                        type = param[2],
		                        org = param[1];
		                       return cont
		                               ([0,
		                                 org,
		                                 [0,
		                                  type,
		                                  [0, sort, [0, direction, [0, per_page, [0, page, 0]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bsX,
		                        0,
		                        0,
		                        0,
		                        cst_org,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bsW, 0, 0, 0, cst_type, 0, [0, default$], [0, a], 0, 0],
		                        b]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1160[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1160[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1120 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1160, [0, schematic_cache$1120]);
		               caml_callback
		                (input_schema_versioned$69, [function(param){return 0;}]);
		               function schematic_version$208(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$69, [schematic_version$208]),
		                action$74 =
		                  action$0
		                   ("699c56e4454b98ee35ee2c35",
		                    "List Organization Repositories",
		                    "\nList all repositories for a GitHub organization.\nExample: {org: 'acme', type: 'public', per_page: 100}.\n",
		                    read$2(1),
		                    bV),
		                letrec_function_context$1161 = [];
		               function type_schema_versioned$2(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1161[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bsY, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1161[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1161[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1161[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bs4);},
		                        0,
		                        0,
		                        cst_all,
		                        cst_All,
		                        bs3,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bs2) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_owner,
		                         cst_Owner,
		                         bs1,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 <= param ? cont(bs0) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_member,
		                          cst_Member,
		                          bsZ,
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1161[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1161[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1121 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1161, [0, schematic_cache$1121]);
		               caml_callback
		                (type_schema_versioned$2, [function(param){return 0;}]);
		               var letrec_function_context$1162 = [];
		               function sort_schema_versioned$2(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1162[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bs5, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1162[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1162[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1162[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(btb);},
		                        0,
		                        0,
		                        cst_created,
		                        cst_Created,
		                        bta,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bs$) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_updated,
		                         cst_Updated,
		                         bs_,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bs9) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_pushed,
		                          cst_Pushed,
		                          bs8,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 <= param ? cont(bs7) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_full_name,
		                           cst_Full_name,
		                           bs6,
		                           0],
		                          0]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1162[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1162[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1122 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1162, [0, schematic_cache$1122]);
		               caml_callback
		                (sort_schema_versioned$2, [function(param){return 0;}]);
		               var letrec_function_context$1163 = [];
		               function input_schema_versioned$70(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1163[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, btc, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1163[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1163[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1163[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$607[1],
		                             a =
		                               [0,
		                                [0, btd, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$608[1],
		                                       b =
		 [0,
		  [0,
		   bte,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (direction_schema_versioned$0,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$609[1],
		                   a =
		                     [0,
		                      [0,
		                       btf,
		                       0,
		                       0,
		                       0,
		                       cst_direction,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (sort_schema_versioned$2,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(c){
		                                      var
		                                       default$ = match$610[1],
		                                       b =
		 [0,
		  [0, btg, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (type_schema_versioned$2,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(a){
		                  var
		                   default$ = match$611[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        page = d[2][1],
		                        per_page = d[1],
		                        direction = c[1],
		                        sort = b[1],
		                        type = a[1],
		                        username = param[1];
		                       return cont
		                               ([0, username, type, sort, direction, per_page, page]);
		                      },
		                      function(param, cont){
		                       var
		                        page = param[6],
		                        per_page = param[5],
		                        direction = param[4],
		                        sort = param[3],
		                        type = param[2],
		                        username = param[1];
		                       return cont
		                               ([0,
		                                 username,
		                                 [0,
		                                  type,
		                                  [0, sort, [0, direction, [0, per_page, [0, page, 0]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bti,
		                        0,
		                        0,
		                        0,
		                        cst_username,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bth, 0, 0, 0, cst_type, 0, [0, default$], [0, a], 0, 0],
		                        b]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1163[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1163[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1123 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1163, [0, schematic_cache$1123]);
		               caml_callback
		                (input_schema_versioned$70, [function(param){return 0;}]);
		               function schematic_version$209(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$70, [schematic_version$209]),
		                action$75 =
		                  action$0
		                   ("699c56e3454b98ee35ee2bed",
		                    "List User Repositories",
		                    "\nList repositories for a GitHub user.\nExample: {username: 'octocat', type: 'owner', per_page: 50}.\n",
		                    read$2(1),
		                    bV),
		                letrec_function_context$1164 = [];
		               function input_schema_versioned$71(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1164[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, btk, btj, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1164[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1164[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1164[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var repo = param[2][1], owner = param[1];
		                       return cont([0, owner, repo]);
		                      },
		                      function(param, cont){
		                       var repo = param[2], owner = param[1];
		                       return cont([0, owner, [0, repo, 0]]);
		                      },
		                      [0,
		                       [0,
		                        btm,
		                        0,
		                        0,
		                        0,
		                        cst_owner,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         btl,
		                         0,
		                         0,
		                         0,
		                         cst_repo,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1164[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1164[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1124 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1164, [0, schematic_cache$1124]);
		               caml_callback
		                (input_schema_versioned$71, [function(param){return 0;}]);
		               function schematic_version$210(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$71, [schematic_version$210]),
		                action$76 =
		                  action$0
		                   ("699c56e3454b98ee35ee2bdb",
		                    "Get Repository",
		                    "\nGet details for a GitHub repository.\nExample: {owner: 'acme', repo: 'myapp'}.\n",
		                    read$2(1),
		                    bV),
		                letrec_function_context$1165 = [];
		               function sort_schema_versioned$3(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1165[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, btn, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1165[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1165[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1165[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(btv);},
		                        0,
		                        0,
		                        cst_created,
		                        cst_Created,
		                        btu,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(btt) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_updated,
		                         cst_Updated,
		                         bts,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(btr) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_popularity,
		                          "Popularity",
		                          btq,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 <= param ? cont(btp) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_long_running,
		                           "Long_running",
		                           bto,
		                           0],
		                          0]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1165[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1165[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1125 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1165, [0, schematic_cache$1125]);
		               caml_callback
		                (sort_schema_versioned$3, [function(param){return 0;}]);
		               var letrec_function_context$1166 = [];
		               function input_schema_versioned$72(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1166[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, btw, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1166[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1166[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1166[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$612[1],
		                             a =
		                               [0,
		                                [0, btx, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$613[1],
		                                       b =
		 [0,
		  [0,
		   bty,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (direction_schema_versioned$0,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$614[1],
		                   a =
		                     [0,
		                      [0,
		                       btz,
		                       0,
		                       0,
		                       0,
		                       cst_direction,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (sort_schema_versioned$3,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(c){
		                                      var
		                                       default$ = match$615[1],
		                                       b =
		 [0,
		  [0, btA, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$616[1],
		         a =
		           [0,
		            [0, btB, 0, 0, 0, cst_base, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$617[1],
		                   b =
		                     [0,
		                      [0, btC, 0, 0, 0, cst_head, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (state_schema_versioned$77,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$618[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    page = g[2][1],
		    per_page = g[1],
		    direction = f[1],
		    sort = e[1],
		    base = d[1],
		    head = c[1],
		    state = b[1],
		    repo = a[1],
		    owner = param[1];
		   return cont
		           ([0,
		             owner,
		             repo,
		             state,
		             head,
		             base,
		             sort,
		             direction,
		             per_page,
		             page]);
		  },
		  function(param, cont){
		   var
		    page = param[9],
		    per_page = param[8],
		    direction = param[7],
		    sort = param[6],
		    base = param[5],
		    head = param[4],
		    state = param[3],
		    repo = param[2],
		    owner = param[1];
		   return cont
		           ([0,
		             owner,
		             [0,
		              repo,
		              [0,
		               state,
		               [0,
		                head,
		                [0,
		                 base,
		                 [0, sort, [0, direction, [0, per_page, [0, page, 0]]]]]]]]]);
		  },
		  [0,
		   [0,
		    btF,
		    0,
		    0,
		    0,
		    cst_owner,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     btE,
		     0,
		     0,
		     0,
		     cst_repo,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0, btD, 0, 0, 0, cst_state, 0, [0, default$], [0, a], 0, 0],
		     b]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1166[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1166[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1126 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1166, [0, schematic_cache$1126]);
		               caml_callback
		                (input_schema_versioned$72, [function(param){return 0;}]);
		               function schematic_version$211(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$72, [schematic_version$211]),
		                action$77 =
		                  action$0
		                   ("699c56e3454b98ee35ee2bb7",
		                    "List Pull Requests",
		                    "\nList pull requests in a GitHub repository.\nExample: {owner: 'acme', repo: 'myapp', state: 'open', base: 'main'}.\n",
		                    read$2(1),
		                    bV),
		                letrec_function_context$1167 = [];
		               function input_schema_versioned$73(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1167[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, btH, btG, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1167[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1167[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1167[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        pull_number = a[2][1],
		                        repo = a[1],
		                        owner = param[1];
		                       return cont([0, owner, repo, pull_number]);
		                      },
		                      function(param, cont){
		                       var
		                        pull_number = param[3],
		                        repo = param[2],
		                        owner = param[1];
		                       return cont([0, owner, [0, repo, [0, pull_number, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        btK,
		                        0,
		                        0,
		                        0,
		                        cst_owner,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         btJ,
		                         0,
		                         0,
		                         0,
		                         cst_repo,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          btI,
		                          0,
		                          0,
		                          0,
		                          "pull_number",
		                          0,
		                          2,
		                          [0, int_schema],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1167[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1167[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1127 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1167, [0, schematic_cache$1127]);
		               caml_callback
		                (input_schema_versioned$73, [function(param){return 0;}]);
		               function schematic_version$212(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$73, [schematic_version$212]),
		                action$78 =
		                  action$0
		                   ("699c56e3454b98ee35ee2bae",
		                    "Get Pull Request",
		                    "\nGet a specific pull request by number.\nExample: {owner: 'acme', repo: 'myapp', pull_number: 123}.\n",
		                    read$2(1),
		                    bV),
		                bV = "Get Current User",
		                action$79 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7b8b",
		                    bV,
		                    "\n        Get the authenticated GitLab user's profile (id, username, name, email).\n        No input required.\n        Example: {}.\n    ",
		                    read$2(0),
		                    empty_object_schema),
		                letrec_function_context$1168 = [];
		               function input_schema_versioned$74(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1168[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, btL, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1168[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1168[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1168[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$619[1],
		                             a =
		                               [0,
		                                [0, btM, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$620[1],
		                                       b =
		 [0,
		  [0,
		   btN,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$621[1],
		         a =
		           [0,
		            [0, btO, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$622[1],
		                   b =
		                     [0,
		                      [0,
		                       btP,
		                       0,
		                       0,
		                       0,
		                       cst_order_by,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(c){
		                            var
		                             default$ = match$623[1],
		                             a =
		                               [0,
		                                [0,
		                                 btQ,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_archived,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$624[1],
		                                       b =
		 [0,
		  [0,
		   btR,
		   0,
		   0,
		   0,
		   cst_visibility,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$625[1],
		         a =
		           [0,
		            [0,
		             btS,
		             0,
		             0,
		             0,
		             cst_starred,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$626[1],
		                   b =
		                     [0,
		                      [0,
		                       btT,
		                       0,
		                       0,
		                       0,
		                       cst_membership,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(c){
		                            var
		                             default$ = match$627[1],
		                             a =
		                               [0,
		                                [0, btU, 0, 0, 0, "owned", 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$628[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    page = h[2][1],
		    per_page = h[1],
		    sort = g[1],
		    order_by = f[1],
		    archived = e[1],
		    visibility = d[1],
		    starred = c[1],
		    membership = b[1],
		    owned = a[1],
		    search = param[1];
		   return cont
		           ([0,
		             search,
		             owned,
		             membership,
		             starred,
		             visibility,
		             archived,
		             order_by,
		             sort,
		             per_page,
		             page]);
		  },
		  function(param, cont){
		   var
		    page = param[10],
		    per_page = param[9],
		    sort = param[8],
		    order_by = param[7],
		    archived = param[6],
		    visibility = param[5],
		    starred = param[4],
		    membership = param[3],
		    owned = param[2],
		    search = param[1];
		   return cont
		           ([0,
		             search,
		             [0,
		              owned,
		              [0,
		               membership,
		               [0,
		                starred,
		                [0,
		                 visibility,
		                 [0,
		                  archived,
		                  [0, order_by, [0, sort, [0, per_page, [0, page, 0]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    btV,
		    0,
		    0,
		    0,
		    cst_search,
		    0,
		    [0, default$],
		    [0, b],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1168[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1168[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1128 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1168, [0, schematic_cache$1128]);
		               caml_callback
		                (input_schema_versioned$74, [function(param){return 0;}]);
		               function schematic_version$213(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$74, [schematic_version$213]),
		                action$80 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bf7",
		                    j,
		                    "\n        List GitLab projects. Filter by membership, ownership, visibility, etc.\n        Example: {membership: true, per_page: 50}.\n    ",
		                    read$2(1),
		                    bn),
		                letrec_function_context$1169 = [];
		               function input_schema_versioned$75(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1169[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, btW, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1169[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1169[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1169[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$629[1],
		                             a =
		                               [0,
		                                [0, btX, 0, 0, 0, "license", 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$630[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    license = a[2][1],
		    statistics = a[1],
		    id = param[1];
		   return cont([0, id, statistics, license]);
		  },
		  function(param, cont){
		   var
		    license = param[3],
		    statistics = param[2],
		    id = param[1];
		   return cont([0, id, [0, statistics, [0, license, 0]]]);
		  },
		  [0,
		   [0,
		    btZ,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     btY,
		     0,
		     0,
		     0,
		     "statistics",
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1169[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1169[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1129 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1169, [0, schematic_cache$1129]);
		               caml_callback
		                (input_schema_versioned$75, [function(param){return 0;}]);
		               function schematic_version$214(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$75, [schematic_version$214]),
		                action$81 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bf3",
		                    b3,
		                    "\n        Get a GitLab project by ID or URL-encoded path.\n        Example: {id: '42'} or {id: 'mygroup%2Fmyproject'}.\n    ",
		                    read$2(1),
		                    bn),
		                cst_assignee_id = "assignee_id",
		                cst_author_id = "author_id",
		                cst_project_id = "project_id",
		                letrec_function_context$1170 = [];
		               function input_schema_versioned$76(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1170[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bt0, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1170[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1170[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1170[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$631[1],
		                             a =
		                               [0,
		                                [0, bt1, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$632[1],
		                                       b =
		 [0,
		  [0,
		   bt2,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$633[1],
		         a =
		           [0,
		            [0, bt3, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$634[1],
		                   b =
		                     [0,
		                      [0,
		                       bt4,
		                       0,
		                       0,
		                       0,
		                       cst_order_by,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$635[1],
		                             a =
		                               [0,
		                                [0,
		                                 bt5,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_search,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$636[1],
		                                       b =
		 [0,
		  [0,
		   bt6,
		   0,
		   0,
		   0,
		   cst_author_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$637[1],
		         a =
		           [0,
		            [0,
		             bt7,
		             0,
		             0,
		             0,
		             cst_assignee_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$638[1],
		                   b =
		                     [0,
		                      [0,
		                       bt8,
		                       0,
		                       0,
		                       0,
		                       cst_milestone,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$639[1],
		                             a =
		                               [0,
		                                [0,
		                                 bt9,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_labels,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$640[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    page = i[2][1],
		    per_page = i[1],
		    sort = h[1],
		    order_by = g[1],
		    search = f[1],
		    author_id = e[1],
		    assignee_id = d[1],
		    milestone = c[1],
		    labels = b[1],
		    state = a[1],
		    project_id = param[1];
		   return cont
		           ([0,
		             project_id,
		             state,
		             labels,
		             milestone,
		             assignee_id,
		             author_id,
		             search,
		             order_by,
		             sort,
		             per_page,
		             page]);
		  },
		  function(param, cont){
		   var
		    page = param[11],
		    per_page = param[10],
		    sort = param[9],
		    order_by = param[8],
		    search = param[7],
		    author_id = param[6],
		    assignee_id = param[5],
		    milestone = param[4],
		    labels = param[3],
		    state = param[2],
		    project_id = param[1];
		   return cont
		           ([0,
		             project_id,
		             [0,
		              state,
		              [0,
		               labels,
		               [0,
		                milestone,
		                [0,
		                 assignee_id,
		                 [0,
		                  author_id,
		                  [0,
		                   search,
		                   [0, order_by, [0, sort, [0, per_page, [0, page, 0]]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    bt$,
		    0,
		    0,
		    0,
		    cst_project_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bt_, 0, 0, 0, cst_state, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1170[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1170[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1130 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1170, [0, schematic_cache$1130]);
		               caml_callback
		                (input_schema_versioned$76, [function(param){return 0;}]);
		               function schematic_version$215(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$76, [schematic_version$215]),
		                action$82 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7be3",
		                    bO9,
		                    "\n        List issues in a GitLab project.\n        Example: {project_id: '42', state: 'opened', labels: 'bug'}.\n    ",
		                    read$2(1),
		                    bn),
		                cst_issue_iid = "issue_iid",
		                letrec_function_context$1171 = [];
		               function input_schema_versioned$77(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1171[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bua, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1171[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1171[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1171[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var issue_iid = param[2][1], project_id = param[1];
		                       return cont([0, project_id, issue_iid]);
		                      },
		                      function(param, cont){
		                       var issue_iid = param[2], project_id = param[1];
		                       return cont([0, project_id, [0, issue_iid, 0]]);
		                      },
		                      [0,
		                       [0,
		                        buc,
		                        0,
		                        0,
		                        0,
		                        cst_project_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bub,
		                         0,
		                         0,
		                         0,
		                         cst_issue_iid,
		                         0,
		                         2,
		                         [0, int_schema],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1171[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1171[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1131 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1171, [0, schematic_cache$1131]);
		               caml_callback
		                (input_schema_versioned$77, [function(param){return 0;}]);
		               function schematic_version$216(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$77, [schematic_version$216]),
		                action$83 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bdf",
		                    cst_Get_Issue,
		                    "\n        Get a specific GitLab issue by its project-internal IID.\n        Example: {project_id: '42', issue_iid: 7}.\n    ",
		                    read$2(1),
		                    bn),
		                cst_assignee_ids = "assignee_ids",
		                cst_confidential = "confidential",
		                cst_milestone_id = "milestone_id",
		                letrec_function_context$1172 = [];
		               function input_schema_versioned$78(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1172[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bud, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1172[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1172[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1172[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$641[1],
		                             a =
		                               [0,
		                                [0,
		                                 bue,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_weight,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$642[1],
		                                       b =
		 [0,
		  [0,
		   buf,
		   0,
		   0,
		   0,
		   cst_confidential,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$643[1],
		         a =
		           [0,
		            [0,
		             bug,
		             0,
		             0,
		             0,
		             cst_due_date,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$644[1],
		                   b =
		                     [0,
		                      [0,
		                       buh,
		                       0,
		                       0,
		                       0,
		                       cst_labels,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$645[1],
		                             a =
		                               [0,
		                                [0,
		                                 bui,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_milestone_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, int_schema], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$646[1],
		                                       b =
		 [0,
		  [0,
		   buj,
		   0,
		   0,
		   0,
		   cst_assignee_ids,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$647[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              weight = g[2][1],
		              confidential = g[1],
		              due_date = f[1],
		              labels = e[1],
		              milestone_id = d[1],
		              assignee_ids = c[1],
		              description = b[1],
		              title = a[1],
		              project_id = param[1];
		             return cont
		                     ([0,
		                       project_id,
		                       title,
		                       description,
		                       assignee_ids,
		                       milestone_id,
		                       labels,
		                       due_date,
		                       confidential,
		                       weight]);
		            },
		            function(param, cont){
		             var
		              weight = param[9],
		              confidential = param[8],
		              due_date = param[7],
		              labels = param[6],
		              milestone_id = param[5],
		              assignee_ids = param[4],
		              description = param[3],
		              title = param[2],
		              project_id = param[1];
		             return cont
		                     ([0,
		                       project_id,
		                       [0,
		                        title,
		                        [0,
		                         description,
		                         [0,
		                          assignee_ids,
		                          [0,
		                           milestone_id,
		                           [0,
		                            labels,
		                            [0, due_date, [0, confidential, [0, weight, 0]]]]]]]]]);
		            },
		            [0,
		             [0,
		              bum,
		              0,
		              0,
		              0,
		              cst_project_id,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bul,
		               0,
		               0,
		               0,
		               cst_title,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                buk,
		                0,
		                0,
		                0,
		                cst_description,
		                0,
		                [0, default$],
		                [0, a],
		                0,
		                0],
		               b]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1172[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1172[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1132 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1172, [0, schematic_cache$1132]);
		               caml_callback
		                (input_schema_versioned$78, [function(param){return 0;}]);
		               function schematic_version$217(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$78, [schematic_version$217]),
		                action$84 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bdb",
		                    cst_Create_Issue,
		                    "\n        Create a new issue in a GitLab project.\n        Example: {project_id: '42', title: 'Login page crash', description: 'Steps to reproduce...', labels: 'bug'}.\n    ",
		                    write$0(0, 0, 1),
		                    bn),
		                cst_state_event = "state_event",
		                letrec_function_context$1173 = [];
		               function input_schema_versioned$79(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1173[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bun, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1173[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1173[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1173[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$648[1],
		                             a =
		                               [0,
		                                [0,
		                                 buo,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_weight,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$649[1],
		                                       b =
		 [0,
		  [0,
		   bup,
		   0,
		   0,
		   0,
		   cst_confidential,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$650[1],
		         a =
		           [0,
		            [0,
		             buq,
		             0,
		             0,
		             0,
		             cst_due_date,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$651[1],
		                   b =
		                     [0,
		                      [0,
		                       bur,
		                       0,
		                       0,
		                       0,
		                       cst_state_event,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$652[1],
		                             a =
		                               [0,
		                                [0,
		                                 bus,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_labels,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$653[1],
		                                       b =
		 [0,
		  [0,
		   but,
		   0,
		   0,
		   0,
		   cst_milestone_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, int_schema], 0],
		       function(c){
		        var
		         default$ = match$654[1],
		         a =
		           [0,
		            [0,
		             buu,
		             0,
		             0,
		             0,
		             cst_assignee_ids,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$655[1],
		                   b =
		                     [0,
		                      [0,
		                       buv,
		                       0,
		                       0,
		                       0,
		                       cst_description,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$656[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  i = h[2],
		                                  weight = i[2][1],
		                                  confidential = i[1],
		                                  due_date = h[1],
		                                  state_event = g[1],
		                                  labels = f[1],
		                                  milestone_id = e[1],
		                                  assignee_ids = d[1],
		                                  description = c[1],
		                                  title = b[1],
		                                  issue_iid = a[1],
		                                  project_id = param[1];
		                                 return cont
		 ([0,
		   project_id,
		   issue_iid,
		   title,
		   description,
		   assignee_ids,
		   milestone_id,
		   labels,
		   state_event,
		   due_date,
		   confidential,
		   weight]);
		                                },
		                                function(param, cont){
		                                 var
		                                  weight = param[11],
		                                  confidential = param[10],
		                                  due_date = param[9],
		                                  state_event = param[8],
		                                  labels = param[7],
		                                  milestone_id = param[6],
		                                  assignee_ids = param[5],
		                                  description = param[4],
		                                  title = param[3],
		                                  issue_iid = param[2],
		                                  project_id = param[1];
		                                 return cont
		 ([0,
		   project_id,
		   [0,
		    issue_iid,
		    [0,
		     title,
		     [0,
		      description,
		      [0,
		       assignee_ids,
		       [0,
		        milestone_id,
		        [0,
		         labels,
		         [0,
		          state_event,
		          [0, due_date, [0, confidential, [0, weight, 0]]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  buy,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_project_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bux,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_issue_iid,
		                                   0,
		                                   2,
		                                   [0, int_schema],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, buw, 0, 0, 0, cst_title, 0, [0, default$], [0, a], 0, 0],
		                                   b]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1173[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1173[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1133 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1173, [0, schematic_cache$1133]);
		               caml_callback
		                (input_schema_versioned$79, [function(param){return 0;}]);
		               function schematic_version$218(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$79, [schematic_version$218]),
		                action$85 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bd7",
		                    bO7,
		                    "\n        Update a GitLab issue. Use state_event='close' to close or state_event='reopen' to reopen.\n        Example: {project_id: '42', issue_iid: 7, state_event: 'close'}.\n    ",
		                    write$0(1, 1, 1),
		                    bn),
		                cst_source_branch = "source_branch",
		                cst_target_branch = "target_branch",
		                letrec_function_context$1174 = [];
		               function input_schema_versioned$80(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1174[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, buz, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1174[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1174[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1174[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$657[1],
		                             a =
		                               [0,
		                                [0, buA, 0, 0, 0, cst_page, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$658[1],
		                                       b =
		 [0,
		  [0,
		   buB,
		   0,
		   0,
		   0,
		   cst_per_page,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$659[1],
		         a =
		           [0,
		            [0, buC, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$660[1],
		                   b =
		                     [0,
		                      [0,
		                       buD,
		                       0,
		                       0,
		                       0,
		                       cst_order_by,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$661[1],
		                             a =
		                               [0,
		                                [0,
		                                 buE,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_search,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$662[1],
		                                       b =
		 [0,
		  [0,
		   buF,
		   0,
		   0,
		   0,
		   cst_target_branch,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$663[1],
		         a =
		           [0,
		            [0,
		             buG,
		             0,
		             0,
		             0,
		             cst_source_branch,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$664[1],
		                   b =
		                     [0,
		                      [0,
		                       buH,
		                       0,
		                       0,
		                       0,
		                       "reviewer_id",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$665[1],
		                             a =
		                               [0,
		                                [0,
		                                 buI,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_assignee_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$666[1],
		                                       b =
		 [0,
		  [0,
		   buJ,
		   0,
		   0,
		   0,
		   cst_author_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$667[1],
		         a =
		           [0,
		            [0,
		             buK,
		             0,
		             0,
		             0,
		             cst_milestone,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$668[1],
		                   b =
		                     [0,
		                      [0,
		                       buL,
		                       0,
		                       0,
		                       0,
		                       cst_labels,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$669[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  i = h[2],
		                                  j = i[2],
		                                  k = j[2],
		                                  l = k[2],
		                                  page = l[2][1],
		                                  per_page = l[1],
		                                  sort = k[1],
		                                  order_by = j[1],
		                                  search = i[1],
		                                  target_branch = h[1],
		                                  source_branch = g[1],
		                                  reviewer_id = f[1],
		                                  assignee_id = e[1],
		                                  author_id = d[1],
		                                  milestone = c[1],
		                                  labels = b[1],
		                                  state = a[1],
		                                  project_id = param[1];
		                                 return cont
		 ([0,
		   project_id,
		   state,
		   labels,
		   milestone,
		   author_id,
		   assignee_id,
		   reviewer_id,
		   source_branch,
		   target_branch,
		   search,
		   order_by,
		   sort,
		   per_page,
		   page]);
		                                },
		                                function(param, cont){
		                                 var
		                                  page = param[14],
		                                  per_page = param[13],
		                                  sort = param[12],
		                                  order_by = param[11],
		                                  search = param[10],
		                                  target_branch = param[9],
		                                  source_branch = param[8],
		                                  reviewer_id = param[7],
		                                  assignee_id = param[6],
		                                  author_id = param[5],
		                                  milestone = param[4],
		                                  labels = param[3],
		                                  state = param[2],
		                                  project_id = param[1];
		                                 return cont
		 ([0,
		   project_id,
		   [0,
		    state,
		    [0,
		     labels,
		     [0,
		      milestone,
		      [0,
		       author_id,
		       [0,
		        assignee_id,
		        [0,
		         reviewer_id,
		         [0,
		          source_branch,
		          [0,
		           target_branch,
		           [0,
		            search,
		            [0, order_by, [0, sort, [0, per_page, [0, page, 0]]]]]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  buN,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_project_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, buM, 0, 0, 0, cst_state, 0, [0, default$], [0, a], 0, 0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1174[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1174[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1134 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1174, [0, schematic_cache$1134]);
		               caml_callback
		                (input_schema_versioned$80, [function(param){return 0;}]);
		               function schematic_version$219(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$80, [schematic_version$219]),
		                action$86 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bcf",
		                    "List Merge Requests",
		                    "\n        List merge requests in a GitLab project.\n        Example: {project_id: '42', state: 'opened', target_branch: 'main'}.\n    ",
		                    read$2(1),
		                    bn),
		                cst_merge_request_iid = "merge_request_iid",
		                letrec_function_context$1175 = [];
		               function input_schema_versioned$81(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1175[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, buO, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1175[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1175[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1175[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$670[1],
		                             a =
		                               [0,
		                                [0,
		                                 buP,
		                                 0,
		                                 0,
		                                 0,
		                                 "include_diverged_commits_count",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$671[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    include_diverged_commits_count = b[2][1],
		    render_html = b[1],
		    merge_request_iid = a[1],
		    project_id = param[1];
		   return cont
		           ([0,
		             project_id,
		             merge_request_iid,
		             render_html,
		             include_diverged_commits_count]);
		  },
		  function(param, cont){
		   var
		    include_diverged_commits_count = param[4],
		    render_html = param[3],
		    merge_request_iid = param[2],
		    project_id = param[1];
		   return cont
		           ([0,
		             project_id,
		             [0,
		              merge_request_iid,
		              [0, render_html, [0, include_diverged_commits_count, 0]]]]);
		  },
		  [0,
		   [0,
		    buS,
		    0,
		    0,
		    0,
		    cst_project_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     buR,
		     0,
		     0,
		     0,
		     cst_merge_request_iid,
		     0,
		     2,
		     [0, int_schema],
		     0,
		     0],
		    [0,
		     [0,
		      buQ,
		      0,
		      0,
		      0,
		      "render_html",
		      0,
		      [0, default$],
		      [0, b],
		      0,
		      0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1175[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1175[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1135 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1175, [0, schematic_cache$1135]);
		               caml_callback
		                (input_schema_versioned$81, [function(param){return 0;}]);
		               function schematic_version$220(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$81, [schematic_version$220]),
		                action$87 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bcb",
		                    "Get Merge Request",
		                    "\n        Get a specific GitLab merge request by IID.\n        Example: {project_id: '42', merge_request_iid: 5}.\n    ",
		                    read$2(1),
		                    bn),
		                cst_remove_source_branch = "remove_source_branch",
		                cst_reviewer_ids = "reviewer_ids",
		                cst_squash = "squash",
		                letrec_function_context$1176 = [];
		               function input_schema_versioned$82(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1176[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, buT, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1176[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1176[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1176[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$672[1],
		                             a =
		                               [0,
		                                [0,
		                                 buU,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_squash,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$673[1],
		                                       b =
		 [0,
		  [0,
		   buV,
		   0,
		   0,
		   0,
		   cst_remove_source_branch,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$674[1],
		         a =
		           [0,
		            [0,
		             buW,
		             0,
		             0,
		             0,
		             cst_milestone_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$675[1],
		                   b =
		                     [0,
		                      [0,
		                       buX,
		                       0,
		                       0,
		                       0,
		                       cst_labels,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, int_schema], 0],
		                           function(c){
		                            var
		                             default$ = match$676[1],
		                             a =
		                               [0,
		                                [0,
		                                 buY,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_reviewer_ids,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, int_schema], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$677[1],
		                                       b =
		 [0,
		  [0,
		   buZ,
		   0,
		   0,
		   0,
		   cst_assignee_ids,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$678[1],
		         a =
		           [0,
		            [0,
		             bu0,
		             0,
		             0,
		             0,
		             cst_assignee_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$679[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        j = i[2],
		                        squash = j[2][1],
		                        remove_source_branch = j[1],
		                        milestone_id = i[1],
		                        labels = h[1],
		                        reviewer_ids = g[1],
		                        assignee_ids = f[1],
		                        assignee_id = e[1],
		                        description = d[1],
		                        title = c[1],
		                        target_branch = b[1],
		                        source_branch = a[1],
		                        project_id = param[1];
		                       return cont
		                               ([0,
		                                 project_id,
		                                 source_branch,
		                                 target_branch,
		                                 title,
		                                 description,
		                                 assignee_id,
		                                 assignee_ids,
		                                 reviewer_ids,
		                                 labels,
		                                 milestone_id,
		                                 remove_source_branch,
		                                 squash]);
		                      },
		                      function(param, cont){
		                       var
		                        squash = param[12],
		                        remove_source_branch = param[11],
		                        milestone_id = param[10],
		                        labels = param[9],
		                        reviewer_ids = param[8],
		                        assignee_ids = param[7],
		                        assignee_id = param[6],
		                        description = param[5],
		                        title = param[4],
		                        target_branch = param[3],
		                        source_branch = param[2],
		                        project_id = param[1];
		                       return cont
		                               ([0,
		                                 project_id,
		                                 [0,
		                                  source_branch,
		                                  [0,
		                                   target_branch,
		                                   [0,
		                                    title,
		                                    [0,
		                                     description,
		                                     [0,
		                                      assignee_id,
		                                      [0,
		                                       assignee_ids,
		                                       [0,
		reviewer_ids,
		[0,
		 labels,
		 [0, milestone_id, [0, remove_source_branch, [0, squash, 0]]]]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bu5,
		                        0,
		                        0,
		                        0,
		                        cst_project_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bu4,
		                         0,
		                         0,
		                         0,
		                         cst_source_branch,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          bu3,
		                          0,
		                          0,
		                          0,
		                          cst_target_branch,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           bu2,
		                           0,
		                           0,
		                           0,
		                           cst_title,
		                           0,
		                           2,
		                           [0, schematic_param_name_schema_ve],
		                           0,
		                           0],
		                          [0,
		                           [0,
		                            bu1,
		                            0,
		                            0,
		                            0,
		                            cst_description,
		                            0,
		                            [0, default$],
		                            [0, b],
		                            0,
		                            0],
		                           a]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1176[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1176[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1136 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1176, [0, schematic_cache$1136]);
		               caml_callback
		                (input_schema_versioned$82, [function(param){return 0;}]);
		               function schematic_version$221(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$82, [schematic_version$221]),
		                action$88 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bc7",
		                    "Create Merge Request",
		                    "\n        Create a new GitLab merge request.\n        Example: {project_id: '42', source_branch: 'feature/my-fix', target_branch: 'main', title: 'Fix login crash'}.\n    ",
		                    write$0(0, 0, 1),
		                    bn),
		                letrec_function_context$1177 = [];
		               function input_schema_versioned$83(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1177[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bu6, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1177[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1177[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1177[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$680[1],
		                             a =
		                               [0,
		                                [0,
		                                 bu7,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_squash,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$681[1],
		                                       b =
		 [0,
		  [0,
		   bu8,
		   0,
		   0,
		   0,
		   cst_remove_source_branch,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$682[1],
		         a =
		           [0,
		            [0,
		             bu9,
		             0,
		             0,
		             0,
		             cst_state_event,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$683[1],
		                   b =
		                     [0,
		                      [0,
		                       bu_,
		                       0,
		                       0,
		                       0,
		                       cst_milestone_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$684[1],
		                             a =
		                               [0,
		                                [0,
		                                 bu$,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_labels,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, int_schema], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$685[1],
		                                       b =
		 [0,
		  [0,
		   bva,
		   0,
		   0,
		   0,
		   cst_reviewer_ids,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, int_schema], 0],
		       function(c){
		        var
		         default$ = match$686[1],
		         a =
		           [0,
		            [0,
		             bvb,
		             0,
		             0,
		             0,
		             cst_assignee_ids,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$687[1],
		                   b =
		                     [0,
		                      [0,
		                       bvc,
		                       0,
		                       0,
		                       0,
		                       cst_assignee_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$688[1],
		                             a =
		                               [0,
		                                [0,
		                                 bvd,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_target_branch,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$689[1],
		                                       b =
		 [0,
		  [0,
		   bve,
		   0,
		   0,
		   0,
		   cst_description,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$690[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              i = h[2],
		              j = i[2],
		              k = j[2],
		              squash = k[2][1],
		              remove_source_branch = k[1],
		              state_event = j[1],
		              milestone_id = i[1],
		              labels = h[1],
		              reviewer_ids = g[1],
		              assignee_ids = f[1],
		              assignee_id = e[1],
		              target_branch = d[1],
		              description = c[1],
		              title = b[1],
		              merge_request_iid = a[1],
		              project_id = param[1];
		             return cont
		                     ([0,
		                       project_id,
		                       merge_request_iid,
		                       title,
		                       description,
		                       target_branch,
		                       assignee_id,
		                       assignee_ids,
		                       reviewer_ids,
		                       labels,
		                       milestone_id,
		                       state_event,
		                       remove_source_branch,
		                       squash]);
		            },
		            function(param, cont){
		             var
		              squash = param[13],
		              remove_source_branch = param[12],
		              state_event = param[11],
		              milestone_id = param[10],
		              labels = param[9],
		              reviewer_ids = param[8],
		              assignee_ids = param[7],
		              assignee_id = param[6],
		              target_branch = param[5],
		              description = param[4],
		              title = param[3],
		              merge_request_iid = param[2],
		              project_id = param[1];
		             return cont
		                     ([0,
		                       project_id,
		                       [0,
		                        merge_request_iid,
		                        [0,
		                         title,
		                         [0,
		                          description,
		                          [0,
		                           target_branch,
		                           [0,
		                            assignee_id,
		                            [0,
		                             assignee_ids,
		                             [0,
		                              reviewer_ids,
		                              [0,
		                               labels,
		                               [0,
		                                milestone_id,
		                                [0, state_event, [0, remove_source_branch, [0, squash, 0]]]]]]]]]]]]]);
		            },
		            [0,
		             [0,
		              bvh,
		              0,
		              0,
		              0,
		              cst_project_id,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bvg,
		               0,
		               0,
		               0,
		               cst_merge_request_iid,
		               0,
		               2,
		               [0, int_schema],
		               0,
		               0],
		              [0,
		               [0, bvf, 0, 0, 0, cst_title, 0, [0, default$], [0, a], 0, 0],
		               b]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1177[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1177[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1137 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1177, [0, schematic_cache$1137]);
		               caml_callback
		                (input_schema_versioned$83, [function(param){return 0;}]);
		               function schematic_version$222(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$83, [schematic_version$222]),
		                action$89 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7bc3",
		                    "Update Merge Request",
		                    "\n        Update a GitLab merge request. Use state_event='close' to close or state_event='reopen' to reopen.\n        Example: {project_id: '42', merge_request_iid: 5, title: 'Fix: login crash (revised)'}.\n    ",
		                    write$0(1, 1, 1),
		                    bn),
		                letrec_function_context$1178 = [];
		               function input_schema_versioned$84(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1178[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvi, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1178[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1178[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1178[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$691[1],
		                             a =
		                               [0,
		                                [0, bvj, 0, 0, 0, "sha", 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$692[1],
		                                       b =
		 [0,
		  [0,
		   bvk,
		   0,
		   0,
		   0,
		   "merge_when_pipeline_succeeds",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$693[1],
		         a =
		           [0,
		            [0,
		             bvl,
		             0,
		             0,
		             0,
		             "should_remove_source_branch",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$694[1],
		                   b =
		                     [0,
		                      [0,
		                       bvm,
		                       0,
		                       0,
		                       0,
		                       cst_squash,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$695[1],
		                             a =
		                               [0,
		                                [0,
		                                 bvn,
		                                 0,
		                                 0,
		                                 0,
		                                 "squash_commit_message",
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$696[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    sha = f[2][1],
		    merge_when_pipeline_succeeds = f[1],
		    should_remove_source_branch = e[1],
		    squash = d[1],
		    squash_commit_message = c[1],
		    merge_commit_message = b[1],
		    merge_request_iid = a[1],
		    project_id = param[1];
		   return cont
		           ([0,
		             project_id,
		             merge_request_iid,
		             merge_commit_message,
		             squash_commit_message,
		             squash,
		             should_remove_source_branch,
		             merge_when_pipeline_succeeds,
		             sha]);
		  },
		  function(param, cont){
		   var
		    sha = param[8],
		    merge_when_pipeline_succeeds = param[7],
		    should_remove_source_branch = param[6],
		    squash = param[5],
		    squash_commit_message = param[4],
		    merge_commit_message = param[3],
		    merge_request_iid = param[2],
		    project_id = param[1];
		   return cont
		           ([0,
		             project_id,
		             [0,
		              merge_request_iid,
		              [0,
		               merge_commit_message,
		               [0,
		                squash_commit_message,
		                [0,
		                 squash,
		                 [0,
		                  should_remove_source_branch,
		                  [0, merge_when_pipeline_succeeds, [0, sha, 0]]]]]]]]);
		  },
		  [0,
		   [0,
		    bvq,
		    0,
		    0,
		    0,
		    cst_project_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bvp,
		     0,
		     0,
		     0,
		     cst_merge_request_iid,
		     0,
		     2,
		     [0, int_schema],
		     0,
		     0],
		    [0,
		     [0,
		      bvo,
		      0,
		      0,
		      0,
		      "merge_commit_message",
		      0,
		      [0, default$],
		      [0, b],
		      0,
		      0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1178[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1178[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1138 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1178, [0, schematic_cache$1138]);
		               caml_callback
		                (input_schema_versioned$84, [function(param){return 0;}]);
		               function schematic_version$223(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$84, [schematic_version$223]),
		                action$90 =
		                  action$0
		                   ("696e0ffc925ff3dbcf0b7b8f",
		                    "Merge Merge Request",
		                    "\n        Merge a GitLab merge request.\n        The MR must be in 'opened' state and pass all required checks.\n        Example: {project_id: '42', merge_request_iid: 5, should_remove_source_branch: true}.\n    ",
		                    write$0(1, 1, 1),
		                    bn),
		                cst_labelIds = "labelIds",
		                cst_maxResults = "maxResults",
		                letrec_function_context$1179 = [];
		               function input_schema_versioned$85(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1179[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvs, bvr, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1179[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1179[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1179[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$697[1],
		                             a =
		                               [0,
		                                [0,
		                                 bvt,
		                                 0,
		                                 0,
		                                 0,
		                                 "includeSpamTrash",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$698[1],
		                                       b =
		 [0,
		  [0,
		   bvu,
		   0,
		   0,
		   0,
		   cst_labelIds,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$699[1],
		         a =
		           [0,
		            [0,
		             bvv,
		             0,
		             0,
		             0,
		             "pageToken",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$700[1],
		                   b =
		                     [0,
		                      [0,
		                       bvw,
		                       0,
		                       0,
		                       0,
		                       cst_maxResults,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$701[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  includeSpamTrash = d[2][1],
		                                  labelIds = d[1],
		                                  pageToken = c[1],
		                                  maxResults = b[1],
		                                  q = a[1],
		                                  userId = param[1];
		                                 return cont
		 ([0,
		   userId,
		   q,
		   maxResults,
		   pageToken,
		   labelIds,
		   includeSpamTrash]);
		                                },
		                                function(param, cont){
		                                 var
		                                  includeSpamTrash = param[6],
		                                  labelIds = param[5],
		                                  pageToken = param[4],
		                                  maxResults = param[3],
		                                  q = param[2],
		                                  userId = param[1];
		                                 return cont
		 ([0,
		   userId,
		   [0,
		    q,
		    [0,
		     maxResults,
		     [0, pageToken, [0, labelIds, [0, includeSpamTrash, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bvy,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_userId,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bvx, 0, 0, 0, cst_q, 0, [0, default$], [0, a], 0, 0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1179[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1179[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1139 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1179, [0, schematic_cache$1139]);
		               caml_callback
		                (input_schema_versioned$85, [function(param){return 0;}]);
		               function schematic_version$224(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$85, [schematic_version$224]),
		                action$91 =
		                  action$0
		                   ("6967a4f8057c6a748080ac14",
		                    "List Messages",
		                    "\nList messages in user's mailbox.\nReturns message IDs - use 'Get Message' for full content.\nUse 'q' param for search (see q field docs for syntax).\nExample: {userId: 'me', q: 'is:unread from:boss@company.com'}.\n",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1180 = [];
		               function input_schema_versioned$86(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1180[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvA, bvz, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1180[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1180[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1180[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(b){
		                            var
		                             default$ = match$702[1],
		                             a =
		                               [0,
		                                [0,
		                                 bvB,
		                                 0,
		                                 0,
		                                 0,
		                                 "metadataHeaders",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$703[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    metadataHeaders = b[2][1],
		    format = b[1],
		    id = a[1],
		    userId = param[1];
		   return cont([0, userId, id, format, metadataHeaders]);
		  },
		  function(param, cont){
		   var
		    metadataHeaders = param[4],
		    format = param[3],
		    id = param[2],
		    userId = param[1];
		   return cont
		           ([0, userId, [0, id, [0, format, [0, metadataHeaders, 0]]]]);
		  },
		  [0,
		   [0,
		    bvE,
		    0,
		    0,
		    0,
		    cst_userId,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bvD,
		     0,
		     0,
		     0,
		     cst_id,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      bvC,
		      0,
		      0,
		      0,
		      cst_format,
		      0,
		      [0, default$],
		      [0, b],
		      0,
		      0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1180[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1180[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1140 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1180, [0, schematic_cache$1140]);
		               caml_callback
		                (input_schema_versioned$86, [function(param){return 0;}]);
		               function schematic_version$225(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$86, [schematic_version$225]),
		                action$92 =
		                  action$0
		                   ("6967a4f8057c6a748080ac10",
		                    "Get Message",
		                    "\nGet message by ID with full content.\nGet IDs from 'List Messages'.\nExample: {userId: 'me', id: 'msg123', format: 'full'}.\n",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1181 = [];
		               function input_schema_versioned$87(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1181[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvG, bvF, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1181[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1181[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1181[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$704[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  threadId = a[2][1],
		                                  raw = a[1],
		                                  userId = param[1];
		                                 return cont([0, userId, raw, threadId]);
		                                },
		                                function(param, cont){
		                                 var threadId = param[3], raw = param[2], userId = param[1];
		                                 return cont([0, userId, [0, raw, [0, threadId, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bvJ,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_userId,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bvI,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_raw,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bvH,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_threadId,
		                                    0,
		                                    [0, default$],
		                                    [0, a],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1181[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1181[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1141 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1181, [0, schematic_cache$1141]);
		               var
		                input_schema =
		                  caml_callback
		                   (input_schema_versioned$87, [function(param){return 0;}]);
		               function schematic_version$226(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$87, [schematic_version$226]),
		                action_id = "6967a4f8057c6a748080abbc",
		                action$93 =
		                  action$0
		                   (action_id,
		                    "Create Raw Draft",
		                    "\nCreate an advanced draft to send later.\nUse only when you need a MIME message that the structured Create Draft tool does\nnot support, such as attachments or inline images. The raw field must be a\ncomplete RFC 2822 MIME message encoded as base64url (see namespace docs).\nExample: {userId: 'me', raw: 'base64url_encoded_message'}.\n",
		                    write$0(0, 0, 0),
		                    bn),
		                letrec_function_context$1182 = [];
		               function body_schema_versioned$1(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1182[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvK, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1182[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1182[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1182[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      bvL,
		                      [0,
		                       [0,
		                        function(f0, cont){return cont([0, f0]);},
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f0 = param[1];
		                         return cont([0, f0]);
		                        },
		                        1,
		                        0,
		                        cst_plain_text,
		                        "Plain_text",
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var text = param[1];
		                           return cont(text);
		                          },
		                          function(text, cont){return cont([0, text, 0]);},
		                          [0,
		                           [0,
		                            0,
		                            0,
		                            0,
		                            0,
		                            cst_text,
		                            0,
		                            2,
		                            [0, schematic_param_name_schema_ve],
		                            0,
		                            0],
		                           0]],
		                         0],
		                        0],
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([1, f0]);},
		                         function(param, cont){
		                          if(1 !== param[0]) return cont(0);
		                          var f0 = param[1];
		                          return cont([0, f0]);
		                         },
		                         1,
		                         0,
		                         cst_html,
		                         "Html",
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var html = param[1];
		                            return cont(html);
		                           },
		                           function(html, cont){return cont([0, html, 0]);},
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_html,
		                             0,
		                             2,
		                             [0, schematic_param_name_schema_ve],
		                             0,
		                             0],
		                            0]],
		                          0],
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){
		                           var f1 = param[2], f0 = param[1];
		                           return cont([2, f0, f1]);
		                          },
		                          function(param, cont){
		                           if(2 !== param[0]) return cont(0);
		                           var f1 = param[2], f0 = param[1];
		                           return cont([0, [0, f0, f1]]);
		                          },
		                          1,
		                          0,
		                          "alternative",
		                          "Alternative",
		                          [0,
		                           0,
		                           0,
		                           [7,
		                            function(param, cont){
		                             var html = param[2][1], text = param[1];
		                             return cont([0, text, html]);
		                            },
		                            function(param, cont){
		                             var html = param[2], text = param[1];
		                             return cont([0, text, [0, html, 0]]);
		                            },
		                            [0,
		                             [0,
		                              0,
		                              0,
		                              0,
		                              0,
		                              cst_text,
		                              0,
		                              2,
		                              [0, schematic_param_name_schema_ve],
		                              0,
		                              0],
		                             [0,
		                              [0,
		                               0,
		                               0,
		                               0,
		                               0,
		                               cst_html,
		                               0,
		                               2,
		                               [0, schematic_param_name_schema_ve],
		                               0,
		                               0],
		                              0]]],
		                           0],
		                          0],
		                         0]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1182[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1182[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1142 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1182, [0, schematic_cache$1142]);
		               caml_callback
		                (body_schema_versioned$1, [function(param){return 0;}]);
		               var
		                cst_bcc = "bcc",
		                cst_subject = "subject",
		                letrec_function_context$1183 = [];
		               function input_schema_versioned$88(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1183[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvM, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1183[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1183[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1183[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$705[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_threadId,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (body_schema_versioned$1,
		                                     schematic_version,
		                                     function(c){
		                                      var
		                                       b =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_subject,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0, [0, 0, 0, 0, 0, cst_body, 0, 2, [0, c], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$706[1],
		         a =
		           [0,
		            [0, 0, 0, 0, 0, cst_bcc, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(b){
		                  var
		                   default$ = match$707[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        thread_id = g[2][1],
		                        body = g[1],
		                        subject = f[1],
		                        bcc = e[1],
		                        cc = d[1],
		                        to = c[1],
		                        from = b[1],
		                        user_id = a[1],
		                        connection_id = param[1];
		                       return cont
		                               ([0,
		                                 connection_id,
		                                 user_id,
		                                 from,
		                                 to,
		                                 cc,
		                                 bcc,
		                                 subject,
		                                 body,
		                                 thread_id]);
		                      },
		                      function(param, cont){
		                       var
		                        thread_id = param[9],
		                        body = param[8],
		                        subject = param[7],
		                        bcc = param[6],
		                        cc = param[5],
		                        to = param[4],
		                        from = param[3],
		                        user_id = param[2],
		                        connection_id = param[1];
		                       return cont
		                               ([0,
		                                 connection_id,
		                                 [0,
		                                  user_id,
		                                  [0,
		                                   from,
		                                   [0,
		                                    to,
		                                    [0,
		                                     cc,
		                                     [0, bcc, [0, subject, [0, body, [0, thread_id, 0]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_connectionId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_userId,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_from,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_to$0,
		                           0,
		                           2,
		                           [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                           0,
		                           0],
		                          [0,
		                           [0, 0, 0, 0, 0, cst_cc, 0, [0, default$], [0, b], 0, 0],
		                           a]]]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1183[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1183[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1143 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1183, [0, schematic_cache$1143]);
		               caml_callback
		                (input_schema_versioned$88, [function(param){return 0;}]);
		               function validate_header_value(field, value, cont){
		                var len = caml_ml_string_length(value), i$0 = 0;
		                for(;;){
		                 var a = i$0 < len;
		                 if(! a) break;
		                 var
		                  char = caml_string_get(value, i$0),
		                  a = char === 13,
		                  a = a || char === 10;
		                 if(a) break;
		                 var i = i$0 + 1 | 0;
		                 i$0 = i;
		                }
		                return a
		                        ? caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$254,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a, field, function(a){return cont([1, a]);});
		                           })
		                        : cont(bvN);
		               }
		               function validate_recipients(field, recipients, cont){
		                if(is_empty(recipients))
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          id,
		                          fmt$255,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a, field, function(a){return cont([1, a]);});
		                          });
		                function f(param, recipient, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (validate_header_value, field, recipient, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (fold_result, fold_left$1, 0, f, recipients, cont);
		               }
		               function wrap_base64(encoded, cont){
		                function a(position, lines){
		                 return position === caml_ml_string_length(encoded)
		                         ? caml_exact_trampoline_cps_call
		                           (of_rev_keys,
		                            lines,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (concat$0, bvO, a, cont);
		                            })
		                         : caml_exact_trampoline_cps_call$1
		                           (min$2,
		                            76,
		                            caml_ml_string_length(encoded) - position | 0,
		                            function(length){
		                             return caml_exact_trampoline_cps_call$0
		                                     (sub_fun,
		                                      encoded,
		                                      position,
		                                      length,
		                                      function(b){
		                                       var
		lines$0 = [0, b, lines],
		position$0 = position + length | 0;
		                                       return caml_exact_trampoline_call2(a, position$0, lines$0);
		                                      });
		                            });
		                }
		                return a(0, 0);
		               }
		               function base64(alphabet, pad, value, cont){
		                return caml_exact_trampoline_cps_call$3
		                        (encode$0,
		                         [0, pad],
		                         [0, alphabet],
		                         0,
		                         0,
		                         value,
		                         function(t){
		                          if(0 === t[0]) return cont(t);
		                          var x = t[1], message = x[2];
		                          return cont([1, message]);
		                         });
		               }
		               function create$55(ctrl, organization_id, input, cont){
		                var
		                 body = input[8],
		                 subject = input[7],
		                 bcc = input[6],
		                 cc = input[5],
		                 to = input[4],
		                 from = input[3],
		                 open = g(include$0),
		                 let$ = open[14];
		                function a(param, cont){
		                 function a(param, cont){
		                  function b(param, cont){
		                   function b(param, cont){
		                    function a(param, cont){
		                     function a(encoded_subject, cont){
		                      function optional_recipients(name, param, cont){
		                       if(! param) return cont(cst$1);
		                       var recipients = param[1];
		                       return caml_exact_trampoline_cps_call$1
		                               (concat$0,
		                                bvP,
		                                recipients,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1
		 (kasprintf,
		  id,
		  fmt$256,
		  function(b){
		   return caml_trampoline_cps_call3(b, name, a, cont);
		  });
		                                });
		                      }
		                      return caml_exact_trampoline_cps_call$1
		                              (optional_recipients,
		                               "Bcc",
		                               bcc,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(optional_recipients,
		 "Cc",
		 cc,
		 function(b){
		  return caml_exact_trampoline_cps_call$1
		          (concat$0,
		           bvQ,
		           to,
		           function(c){
		            return caml_exact_trampoline_cps_call$1
		                    (kasprintf,
		                     id,
		                     fmt$257,
		                     function(d){
		                      return caml_trampoline_cps_call6
		                              (d,
		                               from,
		                               c,
		                               b,
		                               a,
		                               encoded_subject,
		                               function(headers){
		                                function encode_content(content, cont){
		                                 return caml_exact_trampoline_cps_call$0
		 (substr_replace_all_gen,
		  cj,
		  content,
		  cst$31,
		  function(a){
		   return caml_exact_trampoline_cps_call
		           (a,
		            cst$15,
		            function(a){
		             return caml_exact_trampoline_cps_call$0
		                     (substr_replace_all_gen,
		                      cj,
		                      a,
		                      "\r",
		                      function(a){
		                       return caml_exact_trampoline_cps_call
		                               (a,
		                                cst$15,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$0
		 (substr_replace_all_gen,
		  cj,
		  a,
		  cst$15,
		  function(a){
		   return caml_exact_trampoline_cps_call
		           (a,
		            cst$31,
		            function(a){
		             return caml_exact_trampoline_cps_call$0
		                     (base64,
		                      default_alphabet,
		                      1,
		                      a,
		                      function(a){
		                       return caml_exact_trampoline_cps_call$1
		                               (map$5, a, wrap_base64, cont);
		                      });
		            });
		  });
		                                });
		                      });
		            });
		  });
		                                }
		                                function b(source, cont){
		                                 return caml_exact_trampoline_cps_call$0
		 (base64, uri_safe_alphabet, 0, source, cont);
		                                }
		                                function a(a){
		                                 return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                                }
		                                switch(body[0]){
		                                  case 0:
		                                   var text = body[1];
		                                   return caml_exact_trampoline_cps_call
		   (encode_content,
		    text,
		    function(b){
		     return caml_exact_trampoline_cps_call$1
		             (map$5,
		              b,
		              function(text, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (kasprintf,
		                        id,
		                        fmt$258,
		                        function(a){
		                         return caml_trampoline_cps_call3(a, headers, text, cont);
		                        });
		              },
		              a);
		    });
		                                  case 1:
		                                   var html = body[1];
		                                   return caml_exact_trampoline_cps_call
		   (encode_content,
		    html,
		    function(b){
		     return caml_exact_trampoline_cps_call$1
		             (map$5,
		              b,
		              function(html, cont){
		               return caml_exact_trampoline_cps_call$1
		                       (kasprintf,
		                        id,
		                        fmt$259,
		                        function(a){
		                         return caml_trampoline_cps_call3(a, headers, html, cont);
		                        });
		              },
		              a);
		    });
		                                  default:
		                                   var
		                                    html$0 = body[2],
		                                    text$0 = body[1],
		                                    c =
		                                      function(text, cont){
		                                       function a(html, cont){
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$260,
		         function(a){
		          var boundary = "=_routine_ai";
		          return caml_trampoline_cps_call8
		                  (a,
		                   headers,
		                   boundary,
		                   boundary,
		                   text,
		                   boundary,
		                   html,
		                   boundary,
		                   function(a){return cont([0, a]);});
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call
		       (encode_content,
		        html$0,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		        });
		                                      };
		                                   return caml_exact_trampoline_cps_call
		   (encode_content,
		    text$0,
		    function(b){
		     return caml_exact_trampoline_cps_call$1(let$, b, c, a);
		    });
		                                }
		                               });
		                     });
		           });
		 });
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$0
		                             (base64,
		                              default_alphabet,
		                              1,
		                              subject,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call$1
		                            (validate_header_value,
		                             cst_subject,
		                             subject,
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                             });
		                   }
		                   function a(a){
		                    return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                   }
		                   if(! bcc) return a(default$1);
		                   var x = bcc[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (validate_recipients, cst_bcc, x, a);
		                  }
		                  function a(a){
		                   return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                  }
		                  if(! cc) return a(default$2);
		                  var x = cc[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (validate_recipients, cst_cc, x, a);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (validate_recipients,
		                          cst_to$0,
		                          to,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (validate_header_value,
		                         cst_from,
		                         from,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$,
		                                   b,
		                                   a,
		                                   function(match){
		                                    if(0 === match[0]){
		                                     var raw = match[1];
		                                     return caml_exact_trampoline_cps_call$8
		     (run_integration_action,
		      ctrl,
		      organization_id,
		      input[1],
		      action_id,
		      0,
		      input_schema,
		      [0, input[2], raw, input[9]],
		      cont);
		                                    }
		                                    var error = match[1];
		                                    return caml_exact_trampoline_cps_call(fail$2, error, cont);
		                                   });
		                         });
		               }
		               var letrec_function_context$1184 = [];
		               function input_schema_versioned$89(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1184[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvT, bvS, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1184[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1184[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1184[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$708[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  threadId = b[2][1],
		                                  raw = b[1],
		                                  id = a[1],
		                                  userId = param[1];
		                                 return cont([0, userId, id, raw, threadId]);
		                                },
		                                function(param, cont){
		                                 var
		                                  threadId = param[4],
		                                  raw = param[3],
		                                  id = param[2],
		                                  userId = param[1];
		                                 return cont
		 ([0, userId, [0, id, [0, raw, [0, threadId, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bvX,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_userId,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bvW,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_id,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bvV,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_raw,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     bvU,
		                                     0,
		                                     0,
		                                     0,
		                                     cst_threadId,
		                                     0,
		                                     [0, default$],
		                                     [0, a],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1184[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1184[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1144 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1184, [0, schematic_cache$1144]);
		               caml_callback
		                (input_schema_versioned$89, [function(param){return 0;}]);
		               function schematic_version$227(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$89, [schematic_version$227]),
		                action$94 =
		                  action$0
		                   ("6967a4f8057c6a748080abb8",
		                    "Update Draft",
		                    "\nReplace draft content.\nUse RFC 2822 and base64url (see namespace docs).\nTo send unchanged, use 'Send Draft'.\nExample: {userId: 'me', id: 'draft123', raw: 'base64url_encoded_new_content'}.\n",
		                    write$0(1, 1, 0),
		                    bn),
		                letrec_function_context$1185 = [];
		               function input_schema_versioned$90(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1185[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bvZ, bvY, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1185[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1185[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1185[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$709[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  threadId = a[2][1],
		                                  raw = a[1],
		                                  userId = param[1];
		                                 return cont([0, userId, raw, threadId]);
		                                },
		                                function(param, cont){
		                                 var threadId = param[3], raw = param[2], userId = param[1];
		                                 return cont([0, userId, [0, raw, [0, threadId, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bv2,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_userId,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bv1,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_raw,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bv0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_threadId,
		                                    0,
		                                    [0, default$],
		                                    [0, a],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1185[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1185[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1145 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1185, [0, schematic_cache$1145]);
		               caml_callback
		                (input_schema_versioned$90, [function(param){return 0;}]);
		               function schematic_version$228(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$90, [schematic_version$228]),
		                action$95 =
		                  action$0
		                   ("6967a4f8057c6a748080ac0c",
		                    "Send Message",
		                    "\nSend email.\nUse RFC 2822 and base64url encoding (see namespace docs).\nInclude threadId for replies.\nExample: {userId: 'me', raw: 'base64url_encoded_message'}.\n",
		                    write$0(1, 0, 1),
		                    bn),
		                letrec_function_context$1186 = [];
		               function input_schema_versioned$91(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1186[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bv4, bv3, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1186[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1186[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1186[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[2][1], userId = param[1];
		                       return cont([0, userId, id]);
		                      },
		                      function(param, cont){
		                       var id = param[2], userId = param[1];
		                       return cont([0, userId, [0, id, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bv6,
		                        0,
		                        0,
		                        0,
		                        cst_userId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bv5,
		                         0,
		                         0,
		                         0,
		                         cst_id,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1186[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1186[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1146 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1186, [0, schematic_cache$1146]);
		               caml_callback
		                (input_schema_versioned$91, [function(param){return 0;}]);
		               function schematic_version$229(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$91, [schematic_version$229]),
		                action$96 =
		                  action$0
		                   ("6967a4f8057c6a748080abb4",
		                    "Send Draft",
		                    "\nSend draft as-is to recipients in To/Cc/Bcc.\nDraft deleted after send.\nTo edit first, use 'Update Draft'.\nExample: {userId: 'me', id: 'draft123'}.\n",
		                    write$0(1, 0, 1),
		                    bn),
		                cst_campaign = "campaign",
		                letrec_function_context$1187 = [];
		               function input_schema_versioned$92(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1187[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bv8, bv7, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1187[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1187[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1187[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$710[1],
		                             a =
		                               [0,
		                                [0,
		                                 bv9,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_starting_after,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$711[1],
		                                       b =
		 [0,
		  [0, bv_, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$712[1],
		         a =
		           [0,
		            [0, bv$, 0, 0, 0, cst_ids, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$713[1],
		                   b =
		                     [0,
		                      [0,
		                       bwa,
		                       0,
		                       0,
		                       0,
		                       cst_list_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$714[1],
		                             a =
		                               [0,
		                                [0,
		                                 bwb,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_campaign,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$715[1],
		                                       b =
		 [0,
		  [0,
		   bwc,
		   0,
		   0,
		   0,
		   cst_filter,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$716[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              starting_after = e[2][1],
		              limit = e[1],
		              ids = d[1],
		              list_id = c[1],
		              campaign = b[1],
		              filter = a[1],
		              search = param[1];
		             return cont
		                     ([0,
		                       search,
		                       filter,
		                       campaign,
		                       list_id,
		                       ids,
		                       limit,
		                       starting_after]);
		            },
		            function(param, cont){
		             var
		              starting_after = param[7],
		              limit = param[6],
		              ids = param[5],
		              list_id = param[4],
		              campaign = param[3],
		              filter = param[2],
		              search = param[1];
		             return cont
		                     ([0,
		                       search,
		                       [0,
		                        filter,
		                        [0,
		                         campaign,
		                         [0, list_id, [0, ids, [0, limit, [0, starting_after, 0]]]]]]]);
		            },
		            [0,
		             [0,
		              bwd,
		              0,
		              0,
		              0,
		              cst_search,
		              0,
		              [0, default$],
		              [0, a],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1187[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1187[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1147 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1187, [0, schematic_cache$1147]);
		               caml_callback
		                (input_schema_versioned$92, [function(param){return 0;}]);
		               function schematic_version$230(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$92, [schematic_version$230]),
		                action$97 =
		                  action$0
		                   ("6a42473ffa5b1291f56604bf",
		                    "List Leads",
		                    "List leads in the connected Instantly workspace.\nAll parameters are optional; with none provided it returns the first page of all leads.\nUse 'campaign' or 'list_id' to scope to a campaign or list, 'search' for free-text matching, and 'filter' for a predefined status filter.\nPaginate by passing the last lead's 'id' as 'starting_after'.\nExample: {connectionId: '...', input: {campaign: 'b1f...', limit: 50, filter: 'FILTER_LEAD_INTERESTED'}}",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1188 = [];
		               function input_schema_versioned$93(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1188[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwf, bwe, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1188[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1188[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1188[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$717[1],
		                             a =
		                               [0,
		                                [0,
		                                 bwg,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_list_id,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$718[1],
		                                       b =
		 [0,
		  [0,
		   bwh,
		   0,
		   0,
		   0,
		   cst_campaign,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$719[1],
		         a =
		           [0,
		            [0,
		             bwi,
		             0,
		             0,
		             0,
		             "personalization",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$720[1],
		                   b =
		                     [0,
		                      [0,
		                       bwj,
		                       0,
		                       0,
		                       0,
		                       cst_website,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$721[1],
		                             a =
		                               [0,
		                                [0, bwk, 0, 0, 0, cst_phone, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$722[1],
		                                       b =
		 [0,
		  [0,
		   bwl,
		   0,
		   0,
		   0,
		   cst_job_title,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$723[1],
		         a =
		           [0,
		            [0,
		             bwm,
		             0,
		             0,
		             0,
		             "company_name",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$724[1],
		                   b =
		                     [0,
		                      [0,
		                       bwn,
		                       0,
		                       0,
		                       0,
		                       cst_last_name,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$725[1],
		                             a =
		                               [0,
		                                [0,
		                                 bwo,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_first_name,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$726[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    list_id = h[2][1],
		    campaign = h[1],
		    personalization = g[1],
		    website = f[1],
		    phone = e[1],
		    job_title = d[1],
		    company_name = c[1],
		    last_name = b[1],
		    first_name = a[1],
		    email = param[1];
		   return cont
		           ([0,
		             email,
		             first_name,
		             last_name,
		             company_name,
		             job_title,
		             phone,
		             website,
		             personalization,
		             campaign,
		             list_id]);
		  },
		  function(param, cont){
		   var
		    list_id = param[10],
		    campaign = param[9],
		    personalization = param[8],
		    website = param[7],
		    phone = param[6],
		    job_title = param[5],
		    company_name = param[4],
		    last_name = param[3],
		    first_name = param[2],
		    email = param[1];
		   return cont
		           ([0,
		             email,
		             [0,
		              first_name,
		              [0,
		               last_name,
		               [0,
		                company_name,
		                [0,
		                 job_title,
		                 [0,
		                  phone,
		                  [0,
		                   website,
		                   [0, personalization, [0, campaign, [0, list_id, 0]]]]]]]]]]);
		  },
		  [0,
		   [0, bwp, 0, 0, 0, cst_email, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1188[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1188[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1148 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1188, [0, schematic_cache$1148]);
		               caml_callback
		                (input_schema_versioned$93, [function(param){return 0;}]);
		               function schematic_version$231(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$93, [schematic_version$231]),
		                action$98 =
		                  action$0
		                   ("6a42473ea294fed06334f7dc",
		                    "Create Lead",
		                    "Create a new lead in the connected Instantly workspace.\nProvide at least an 'email' to identify the lead.\nPass 'campaign' (campaign UUID) or 'list_id' (list UUID) to add the lead directly to a campaign or list.\nExample: {connectionId: '...', input: {email: 'jane@acme.com', first_name: 'Jane', company_name: 'Acme', campaign: 'b1f...'}}",
		                    write$0(0, 0, 0),
		                    bn),
		                letrec_function_context$1189 = [];
		               function input_schema_versioned$94(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1189[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwr, bwq, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1189[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1189[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1189[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bws,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1189[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1189[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1149 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1189, [0, schematic_cache$1149]);
		               caml_callback
		                (input_schema_versioned$94, [function(param){return 0;}]);
		               function schematic_version$232(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$94, [schematic_version$232]),
		                action$99 =
		                  action$0
		                   ("6a4247401bbdaf54d3743994",
		                    "Get Lead",
		                    "Get a single lead by its ID.\nThe 'id' is the lead UUID, obtainable from 'List Leads'.\nExample: {connectionId: '...', input: {id: '3c9...'}}",
		                    read$2(0),
		                    bn),
		                cst_campaign_id = "campaign_id",
		                letrec_function_context$1190 = [];
		               function input_schema_versioned$95(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1190[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwu, bwt, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1190[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1190[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1190[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$727[1],
		                             a =
		                               [0,
		                                [0,
		                                 bwv,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_list_id,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$728[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    list_id = b[2][1],
		    campaign_id = b[1],
		    interest_value = a[1],
		    lead_email = param[1];
		   return cont
		           ([0, lead_email, interest_value, campaign_id, list_id]);
		  },
		  function(param, cont){
		   var
		    list_id = param[4],
		    campaign_id = param[3],
		    interest_value = param[2],
		    lead_email = param[1];
		   return cont
		           ([0,
		             lead_email,
		             [0, interest_value, [0, campaign_id, [0, list_id, 0]]]]);
		  },
		  [0,
		   [0,
		    bwy,
		    0,
		    0,
		    0,
		    "lead_email",
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bwx,
		     0,
		     0,
		     0,
		     "interest_value",
		     0,
		     3,
		     [0, int_schema],
		     0,
		     0],
		    [0,
		     [0,
		      bww,
		      0,
		      0,
		      0,
		      cst_campaign_id,
		      0,
		      [0, default$],
		      [0, b],
		      0,
		      0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1190[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1190[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1150 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1190, [0, schematic_cache$1150]);
		               caml_callback
		                (input_schema_versioned$95, [function(param){return 0;}]);
		               function schematic_version$233(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$95, [schematic_version$233]),
		                action$100 =
		                  action$0
		                   ("6a424742c2cd5aea998002f9",
		                    "Update Lead Interest Status",
		                    "Update the interest status of a lead, identified by its email.\n'lead_email' and 'interest_value' are required.\n'interest_value' is an integer: 1 Interested, 2 Meeting Booked, 3 Meeting Completed, 4 Won, 0 Out of Office, -1 Not Interested, -2 Wrong Person, -3 Lost, -4 No Show; pass null to reset to \"Lead\".\nProvide 'campaign_id' or 'list_id' to disambiguate which campaign or list the lead belongs to.\nExample: {connectionId: '...', input: {lead_email: 'jane@acme.com', interest_value: 1, campaign_id: 'b1f...'}}",
		                    write$0(1, 1, 0),
		                    bn),
		                letrec_function_context$1191 = [];
		               function input_schema_versioned$96(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1191[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwA, bwz, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1191[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1191[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1191[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$729[1],
		                             a =
		                               [0,
		                                [0,
		                                 bwB,
		                                 0,
		                                 0,
		                                 0,
		                                 "copy_leads",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$730[1],
		                                       b =
		 [0,
		  [0, bwC, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$731[1],
		         a =
		           [0,
		            [0,
		             bwD,
		             0,
		             0,
		             0,
		             cst_filter,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$732[1],
		                   b =
		                     [0,
		                      [0,
		                       bwE,
		                       0,
		                       0,
		                       0,
		                       cst_search,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$733[1],
		                             a =
		                               [0,
		                                [0,
		                                 bwF,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_list_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$734[1],
		                                       b =
		 [0,
		  [0,
		   bwG,
		   0,
		   0,
		   0,
		   cst_campaign,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$735[1],
		         a =
		           [0,
		            [0, bwH, 0, 0, 0, cst_ids, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$736[1],
		                   b =
		                     [0,
		                      [0,
		                       bwI,
		                       0,
		                       0,
		                       0,
		                       "to_list_id",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$737[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  copy_leads = g[2][1],
		                                  limit = g[1],
		                                  filter = f[1],
		                                  search = e[1],
		                                  list_id = d[1],
		                                  campaign = c[1],
		                                  ids = b[1],
		                                  to_list_id = a[1],
		                                  to_campaign_id = param[1];
		                                 return cont
		 ([0,
		   to_campaign_id,
		   to_list_id,
		   ids,
		   campaign,
		   list_id,
		   search,
		   filter,
		   limit,
		   copy_leads]);
		                                },
		                                function(param, cont){
		                                 var
		                                  copy_leads = param[9],
		                                  limit = param[8],
		                                  filter = param[7],
		                                  search = param[6],
		                                  list_id = param[5],
		                                  campaign = param[4],
		                                  ids = param[3],
		                                  to_list_id = param[2],
		                                  to_campaign_id = param[1];
		                                 return cont
		 ([0,
		   to_campaign_id,
		   [0,
		    to_list_id,
		    [0,
		     ids,
		     [0,
		      campaign,
		      [0,
		       list_id,
		       [0, search, [0, filter, [0, limit, [0, copy_leads, 0]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bwJ,
		                                  0,
		                                  0,
		                                  0,
		                                  "to_campaign_id",
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1191[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1191[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1151 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1191, [0, schematic_cache$1151]);
		               caml_callback
		                (input_schema_versioned$96, [function(param){return 0;}]);
		               function schematic_version$234(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$96, [schematic_version$234]),
		                action$101 =
		                  action$0
		                   ("6a4247435ce38733427fcf89",
		                    "Move Leads",
		                    "Move leads into a target campaign or list.\nSpecify exactly one destination: 'to_campaign_id' or 'to_list_id'.\nSelect which leads to move using 'ids' (with a source 'campaign' or 'list_id'), or by 'campaign'/'list_id'/'search'/'filter'.\nSet 'copy_leads' to true to copy rather than move.\nExample: {connectionId: '...', input: {campaign: 'src...', to_campaign_id: 'dst...', filter: 'FILTER_LEAD_INTERESTED'}}",
		                    write$0(1, 0, 0),
		                    bn),
		                letrec_function_context$1192 = [];
		               function input_schema_versioned$97(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1192[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwL, bwK, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1192[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1192[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1192[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$738[1],
		                             a =
		                               [0,
		                                [0,
		                                 bwM,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_starting_after,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$739[1],
		                                       b =
		 [0,
		  [0, bwN, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$740[1],
		         a =
		           [0,
		            [0,
		             bwO,
		             0,
		             0,
		             0,
		             cst_status,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$741[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        starting_after = b[2][1],
		                        limit = b[1],
		                        status = a[1],
		                        search = param[1];
		                       return cont([0, search, status, limit, starting_after]);
		                      },
		                      function(param, cont){
		                       var
		                        starting_after = param[4],
		                        limit = param[3],
		                        status = param[2],
		                        search = param[1];
		                       return cont
		                               ([0,
		                                 search,
		                                 [0, status, [0, limit, [0, starting_after, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        bwP,
		                        0,
		                        0,
		                        0,
		                        cst_search,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1192[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1192[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1152 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1192, [0, schematic_cache$1152]);
		               caml_callback
		                (input_schema_versioned$97, [function(param){return 0;}]);
		               function schematic_version$235(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$97, [schematic_version$235]),
		                action$102 =
		                  action$0
		                   ("6a42476649e48293b97c144e",
		                    "List Campaign",
		                    "List campaigns in the connected Instantly workspace.\nAll parameters are optional.\nUse 'search' to match by campaign name and 'status' to filter by state (0 Draft, 1 Active, 2 Paused, 3 Completed, 4 Running Subsequences).\nPaginate with 'starting_after' using the previous response's next_starting_after value.\nExample: {connectionId: '...', input: {status: 1, limit: 50}}",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1193 = [];
		               function input_schema_versioned$98(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1193[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwR, bwQ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1193[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1193[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1193[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bwS,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1193[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1193[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1153 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1193, [0, schematic_cache$1153]);
		               caml_callback
		                (input_schema_versioned$98, [function(param){return 0;}]);
		               function schematic_version$236(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$98, [schematic_version$236]),
		                action$103 =
		                  action$0
		                   ("6a424767a96d9840233a76bd",
		                    "Get Campaign",
		                    "Get a single campaign by its ID.\nThe 'id' is the campaign UUID, obtainable from 'List Campaign'.\nExample: {connectionId: '...', input: {id: 'b1f...'}}",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1194 = [];
		               function input_schema_versioned$99(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1194[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwU, bwT, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1194[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1194[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1194[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bwV,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1194[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1194[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1154 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1194, [0, schematic_cache$1154]);
		               caml_callback
		                (input_schema_versioned$99, [function(param){return 0;}]);
		               function schematic_version$237(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$99, [schematic_version$237]),
		                action$104 =
		                  action$0
		                   ("6a4247678e24814f81f260ba",
		                    "Activate Campaign",
		                    "Activate (start) or resume a campaign so it begins (or continues) sending.\nThe 'id' is the campaign UUID.\nExample: {connectionId: '...', input: {id: 'b1f...'}}",
		                    write$0(1, 1, 1),
		                    bn),
		                letrec_function_context$1195 = [];
		               function input_schema_versioned$100(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1195[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bwX, bwW, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1195[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1195[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1195[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bwY,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1195[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1195[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1155 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1195, [0, schematic_cache$1155]);
		               caml_callback
		                (input_schema_versioned$100, [function(param){return 0;}]);
		               function schematic_version$238(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$100, [schematic_version$238]),
		                action$105 =
		                  action$0
		                   ("6a424767a294fed06334fd8c",
		                    "Pause Campaign",
		                    "Stop or pause a campaign so it stops sending.\nThe 'id' is the campaign UUID.\nExample: {connectionId: '...', input: {id: 'b1f...'}}",
		                    write$0(1, 1, 0),
		                    bn),
		                cst_eaccount = "eaccount",
		                letrec_function_context$1196 = [];
		               function input_schema_versioned$101(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1196[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bw0, bwZ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1196[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1196[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1196[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$742[1],
		                             a =
		                               [0,
		                                [0,
		                                 bw1,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_starting_after,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$743[1],
		                                       b =
		 [0,
		  [0, bw2, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$744[1],
		         a =
		           [0,
		            [0,
		             bw3,
		             0,
		             0,
		             0,
		             "is_unread",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$745[1],
		                   b =
		                     [0,
		                      [0,
		                       bw4,
		                       0,
		                       0,
		                       0,
		                       "email_type",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$746[1],
		                             a =
		                               [0,
		                                [0, bw5, 0, 0, 0, "lead", 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$747[1],
		                                       b =
		 [0,
		  [0,
		   bw6,
		   0,
		   0,
		   0,
		   cst_eaccount,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$748[1],
		         a =
		           [0,
		            [0,
		             bw7,
		             0,
		             0,
		             0,
		             cst_campaign_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$749[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        starting_after = f[2][1],
		                        limit = f[1],
		                        is_unread = e[1],
		                        email_type = d[1],
		                        lead = c[1],
		                        eaccount = b[1],
		                        campaign_id = a[1],
		                        search = param[1];
		                       return cont
		                               ([0,
		                                 search,
		                                 campaign_id,
		                                 eaccount,
		                                 lead,
		                                 email_type,
		                                 is_unread,
		                                 limit,
		                                 starting_after]);
		                      },
		                      function(param, cont){
		                       var
		                        starting_after = param[8],
		                        limit = param[7],
		                        is_unread = param[6],
		                        email_type = param[5],
		                        lead = param[4],
		                        eaccount = param[3],
		                        campaign_id = param[2],
		                        search = param[1];
		                       return cont
		                               ([0,
		                                 search,
		                                 [0,
		                                  campaign_id,
		                                  [0,
		                                   eaccount,
		                                   [0,
		                                    lead,
		                                    [0,
		                                     email_type,
		                                     [0, is_unread, [0, limit, [0, starting_after, 0]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bw8,
		                        0,
		                        0,
		                        0,
		                        cst_search,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1196[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1196[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1156 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1196, [0, schematic_cache$1156]);
		               caml_callback
		                (input_schema_versioned$101, [function(param){return 0;}]);
		               function schematic_version$239(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$101, [schematic_version$239]),
		                action$106 =
		                  action$0
		                   ("6a4247ae2e706f213b594043",
		                    "List Email",
		                    "List emails from the Instantly Unibox.\nAll parameters are optional.\nFilter with 'campaign_id', 'lead' (lead email), 'eaccount' (sending account), 'email_type' (\"received\"/\"sent\"/\"manual\"), or 'is_unread'.\nSearch a specific thread by passing 'search' as \"thread:<thread_id>\".\nPaginate with 'starting_after'.\nExample: {connectionId: '...', input: {campaign_id: 'b1f...', is_unread: true, limit: 50}}",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1197 = [];
		               function body_schema_versioned$2(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1197[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bw_, bw9, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1197[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1197[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1197[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$750[1],
		                             a =
		                               [0,
		                                [0, bw$, 0, 0, 0, cst_text, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$751[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var text = param[2][1], html = param[1];
		   return cont([0, html, text]);
		  },
		  function(param, cont){
		   var text = param[2], html = param[1];
		   return cont([0, html, [0, text, 0]]);
		  },
		  [0,
		   [0, bxa, 0, 0, 0, cst_html, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1197[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1197[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1157 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1197, [0, schematic_cache$1157]);
		               caml_callback
		                (body_schema_versioned$2, [function(param){return 0;}]);
		               var letrec_function_context$1198 = [];
		               function input_schema_versioned$102(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1198[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxc, bxb, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1198[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1198[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1198[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$752[1],
		                             a =
		                               [0,
		                                [0,
		                                 bxd,
		                                 0,
		                                 0,
		                                 0,
		                                 "bcc_address_email_list",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$753[1],
		                                       b =
		 [0,
		  [0,
		   bxe,
		   0,
		   0,
		   0,
		   "cc_address_email_list",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (body_schema_versioned$2,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              bcc_address_email_list = d[2][1],
		              cc_address_email_list = d[1],
		              body = c[1],
		              subject = b[1],
		              reply_to_uuid = a[1],
		              eaccount = param[1];
		             return cont
		                     ([0,
		                       eaccount,
		                       reply_to_uuid,
		                       subject,
		                       body,
		                       cc_address_email_list,
		                       bcc_address_email_list]);
		            },
		            function(param, cont){
		             var
		              bcc_address_email_list = param[6],
		              cc_address_email_list = param[5],
		              body = param[4],
		              subject = param[3],
		              reply_to_uuid = param[2],
		              eaccount = param[1];
		             return cont
		                     ([0,
		                       eaccount,
		                       [0,
		                        reply_to_uuid,
		                        [0,
		                         subject,
		                         [0,
		                          body,
		                          [0, cc_address_email_list, [0, bcc_address_email_list, 0]]]]]]);
		            },
		            [0,
		             [0,
		              bxi,
		              0,
		              0,
		              0,
		              cst_eaccount,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bxh,
		               0,
		               0,
		               0,
		               "reply_to_uuid",
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0,
		                bxg,
		                0,
		                0,
		                0,
		                cst_subject,
		                0,
		                2,
		                [0, schematic_param_name_schema_ve],
		                0,
		                0],
		               [0, [0, bxf, 0, 0, 0, cst_body, 0, 2, [0, a], 0, 0], b]]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1198[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1198[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1158 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1198, [0, schematic_cache$1158]);
		               caml_callback
		                (input_schema_versioned$102, [function(param){return 0;}]);
		               function schematic_version$240(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$102, [schematic_version$240]),
		                action$107 =
		                  action$0
		                   ("6a4247adff3aa61cfad7e932",
		                    "Reply To Email",
		                    "Reply to an existing email in a thread.\n'eaccount' (a connected sending account), 'reply_to_uuid' (the email being replied to), 'subject', and 'body' are all required.\nSet 'body.html', 'body.text', or both.\nGet 'reply_to_uuid' and the relevant 'eaccount' from 'List Email'.\nExample: {connectionId: '...', input: {eaccount: 'me@myco.com', reply_to_uuid: 'e12...', subject: 'Re: Hello', body: {text: 'Thanks for reaching out!'}}}",
		                    write$0(1, 0, 1),
		                    bn),
		                letrec_function_context$1199 = [];
		               function input_schema_versioned$103(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1199[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxk, bxj, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1199[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1199[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1199[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var thread_id = param[1];
		                       return cont([0, thread_id]);
		                      },
		                      function(param, cont){
		                       var thread_id = param[1];
		                       return cont([0, thread_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bxl,
		                        0,
		                        0,
		                        0,
		                        "thread_id",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1199[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1199[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1159 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1199, [0, schematic_cache$1159]);
		               caml_callback
		                (input_schema_versioned$103, [function(param){return 0;}]);
		               function schematic_version$241(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$103, [schematic_version$241]),
		                action$108 =
		                  action$0
		                   ("6a4247b0a294fed06335069e",
		                    "Mark Thread As Read",
		                    "Mark all emails in a thread as read.\nThe 'thread_id' identifies the conversation thread.\nExample: {connectionId: '...', input: {thread_id: 't9a...'}}",
		                    write$0(1, 1, 0),
		                    bn),
		                letrec_function_context$1200 = [];
		               function type_schema_versioned$3(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1200[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxm, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1200[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1200[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1200[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bxq);},
		                        0,
		                        0,
		                        cst_group,
		                        "Group",
		                        bxp,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(bxo) : cont(0);},
		                         0,
		                         0,
		                         cst_role,
		                         cst_Role,
		                         bxn,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1200[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1200[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1160 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1200, [0, schematic_cache$1160]);
		               caml_callback
		                (type_schema_versioned$3, [function(param){return 0;}]);
		               var letrec_function_context$1201 = [];
		               function schema_versioned$559(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1201[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxr, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1201[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1201[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1201[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$754[1],
		                             a =
		                               [0,
		                                [0,
		                                 bxs,
		                                 0,
		                                 0,
		                                 0,
		                                 "identifier",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$755[1],
		                                       b =
		 [0,
		  [0, bxt, 0, 0, 0, cst_value, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (type_schema_versioned$3,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              identifier = a[2][1],
		              value = a[1],
		              type = param[1];
		             return cont([0, type, value, identifier]);
		            },
		            function(param, cont){
		             var
		              identifier = param[3],
		              value = param[2],
		              type = param[1];
		             return cont([0, type, [0, value, [0, identifier, 0]]]);
		            },
		            [0, [0, bxu, 0, 0, 0, cst_type, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1201[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1201[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1161 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1201, [0, schematic_cache$1161]);
		               caml_callback
		                (schema_versioned$559, [function(param){return 0;}]);
		               var letrec_function_context$1202 = [];
		               function schema_versioned$560(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1202[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxv, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1202[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1202[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1202[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var text = param[2][1], type = param[1];
		                       return cont([0, type, text]);
		                      },
		                      function(param, cont){
		                       var text = param[2], type = param[1];
		                       return cont([0, type, [0, text, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bxx,
		                        0,
		                        0,
		                        0,
		                        cst_type,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bxw,
		                         0,
		                         0,
		                         0,
		                         cst_text,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1202[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1202[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1162 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1202, [0, schematic_cache$1162]);
		               caml_callback
		                (schema_versioned$560, [function(param){return 0;}]);
		               var letrec_function_context$1203 = [];
		               function schema_versioned$561(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1203[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxy, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1203[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1203[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1203[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$560,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var content = param[2][1], type = param[1];
		                                 return cont([0, type, content]);
		                                },
		                                function(param, cont){
		                                 var content = param[2], type = param[1];
		                                 return cont([0, type, [0, content, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bxz,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_content,
		                                   0,
		                                   2,
		                                   [0, [0, 0, 0, [3, a], 0]],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1203[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1203[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1163 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1203, [0, schematic_cache$1163]);
		               caml_callback
		                (schema_versioned$561, [function(param){return 0;}]);
		               var letrec_function_context$1204 = [];
		               function schema_versioned$562(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1204[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxA, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1204[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1204[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1204[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$561,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  content = a[2][1],
		                                  type = a[1],
		                                  version = param[1];
		                                 return cont([0, version, type, content]);
		                                },
		                                function(param, cont){
		                                 var content = param[3], type = param[2], version = param[1];
		                                 return cont([0, version, [0, type, [0, content, 0]]]);
		                                },
		                                [0,
		                                 [0, bxC, 0, 0, 0, cst_version, 0, 2, [0, int_schema], 0, 0],
		                                 [0,
		                                  [0,
		                                   bxB,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_type,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_content,
		                                    0,
		                                    2,
		                                    [0, [0, 0, 0, [3, a], 0]],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1204[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1204[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1164 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1204, [0, schematic_cache$1164]);
		               caml_callback
		                (schema_versioned$562, [function(param){return 0;}]);
		               var cst_expand = "expand", letrec_function_context$1205 = [];
		               function input_schema_versioned$104(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1205[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxE, bxD, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1205[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1205[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1205[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$756[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var expand = param[1];
		                                 return cont([0, expand]);
		                                },
		                                function(param, cont){
		                                 var expand = param[1];
		                                 return cont([0, expand, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  bxF,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_expand,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1205[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1205[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1165 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1205, [0, schematic_cache$1165]);
		               caml_callback
		                (input_schema_versioned$104, [function(param){return 0;}]);
		               function schematic_version$242(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$104, [schematic_version$242]),
		                action$109 =
		                  action$0
		                   ("69d902b3ba50965c0c1a03ac",
		                    bV,
		                    cst_Get_details_of_the_current,
		                    read$2(0),
		                    bn),
		                bn =
		                  [0,
		                   bxH,
		                   bxG,
		                   schematic_param_a_schema_versi[3],
		                   schematic_param_a_schema_versi[4]],
		                action$110 =
		                  action$0
		                   ("69d902b3ba50965c0c1a039d",
		                    "Get Statuses",
		                    cst_Get_all_issue_statuses,
		                    read$2(0),
		                    bn),
		                bn =
		                  [0,
		                   bxJ,
		                   bxI,
		                   schematic_param_a_schema_versi[3],
		                   schematic_param_a_schema_versi[4]],
		                action$111 =
		                  action$0
		                   ("69d902b2ba50965c0c1a038e",
		                    "Get Priorities",
		                    cst_Get_all_issue_priorities,
		                    read$2(0),
		                    bn),
		                bn =
		                  [0,
		                   bxL,
		                   bxK,
		                   schematic_param_a_schema_versi[3],
		                   schematic_param_a_schema_versi[4]],
		                action$112 =
		                  action$0
		                   ("69d902b2ba50965c0c1a037f",
		                    "Get Issue Types",
		                    cst_Get_all_issue_types_availa,
		                    read$2(0),
		                    bn),
		                cst_accountId = "accountId",
		                letrec_function_context$1206 = [];
		               function input_schema_versioned$105(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1206[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxN, bxM, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1206[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1206[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1206[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$757[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var expand = param[2][1], accountId = param[1];
		                                 return cont([0, accountId, expand]);
		                                },
		                                function(param, cont){
		                                 var expand = param[2], accountId = param[1];
		                                 return cont([0, accountId, [0, expand, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bxP,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_accountId,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bxO,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_expand,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1206[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1206[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1166 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1206, [0, schematic_cache$1166]);
		               caml_callback
		                (input_schema_versioned$105, [function(param){return 0;}]);
		               function schematic_version$243(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$105, [schematic_version$243]),
		                action$113 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0370",
		                    "Get User",
		                    "\n      Get details of a specific user by account ID.\n      Example: {accountId: '5b10a2844c20165700ede21g'}.\n    ",
		                    read$2(0),
		                    bn),
		                cst_startAt = "startAt",
		                letrec_function_context$1207 = [];
		               function input_schema_versioned$106(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1207[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxR, bxQ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1207[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1207[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1207[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$758[1],
		                             a =
		                               [0,
		                                [0,
		                                 bxS,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_maxResults,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$759[1],
		                                       b =
		 [0,
		  [0,
		   bxT,
		   0,
		   0,
		   0,
		   cst_startAt,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$760[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              maxResults = b[2][1],
		              startAt = b[1],
		              accountId = a[1],
		              query = param[1];
		             return cont([0, query, accountId, startAt, maxResults]);
		            },
		            function(param, cont){
		             var
		              maxResults = param[4],
		              startAt = param[3],
		              accountId = param[2],
		              query = param[1];
		             return cont
		                     ([0,
		                       query,
		                       [0, accountId, [0, startAt, [0, maxResults, 0]]]]);
		            },
		            [0,
		             [0,
		              bxV,
		              0,
		              0,
		              0,
		              cst_query,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bxU,
		               0,
		               0,
		               0,
		               cst_accountId,
		               0,
		               [0, default$],
		               [0, a],
		               0,
		               0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1207[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1207[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1167 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1207, [0, schematic_cache$1167]);
		               caml_callback
		                (input_schema_versioned$106, [function(param){return 0;}]);
		               function schematic_version$244(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$106, [schematic_version$244]),
		                action$114 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0361",
		                    "Search Users",
		                    "\n      Search for users by name, email, or account ID.\n      Example: {query: 'alice@example.com'}.\n    ",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1208 = [];
		               function input_schema_versioned$107(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1208[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bxX, bxW, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1208[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1208[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1208[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$761[1],
		                             a =
		                               [0,
		                                [0,
		                                 bxY,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_properties,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$762[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    properties = a[2][1],
		    expand = a[1],
		    projectIdOrKey = param[1];
		   return cont([0, projectIdOrKey, expand, properties]);
		  },
		  function(param, cont){
		   var
		    properties = param[3],
		    expand = param[2],
		    projectIdOrKey = param[1];
		   return cont
		           ([0, projectIdOrKey, [0, expand, [0, properties, 0]]]);
		  },
		  [0,
		   [0,
		    bx0,
		    0,
		    0,
		    0,
		    "projectIdOrKey",
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bxZ,
		     0,
		     0,
		     0,
		     cst_expand,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1208[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1208[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1168 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1208, [0, schematic_cache$1168]);
		               caml_callback
		                (input_schema_versioned$107, [function(param){return 0;}]);
		               function schematic_version$245(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$107, [schematic_version$245]),
		                action$115 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0352",
		                    b3,
		                    "\n      Get details of a specific project.\n      Example: {projectIdOrKey: 'PROJ', expand: 'description,lead'}.\n    ",
		                    read$2(0),
		                    bn),
		                letrec_function_context$1209 = [];
		               function input_schema_versioned$108(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1209[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bx2, bx1, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1209[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1209[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1209[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$763[1],
		                             a =
		                               [0,
		                                [0,
		                                 bx3,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_properties,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$764[1],
		                                       b =
		 [0,
		  [0, bx4, 0, 0, 0, "recent", 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$765[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              properties = a[2][1],
		              recent = a[1],
		              expand = param[1];
		             return cont([0, expand, recent, properties]);
		            },
		            function(param, cont){
		             var
		              properties = param[3],
		              recent = param[2],
		              expand = param[1];
		             return cont([0, expand, [0, recent, [0, properties, 0]]]);
		            },
		            [0,
		             [0,
		              bx5,
		              0,
		              0,
		              0,
		              cst_expand,
		              0,
		              [0, default$],
		              [0, a],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1209[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1209[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1169 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1209, [0, schematic_cache$1169]);
		               caml_callback
		                (input_schema_versioned$108, [function(param){return 0;}]);
		               function schematic_version$246(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$108, [schematic_version$246]),
		                action$116 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0343",
		                    "Get All Projects",
		                    "\n      Get a list of all projects visible to the user.\n      Example: {expand: 'description', recent: 10}.\n    ",
		                    read$2(0),
		                    bn),
		                cst_commentId = "commentId",
		                cst_issueIdOrKey = "issueIdOrKey",
		                letrec_function_context$1210 = [];
		               function input_schema_versioned$109(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1210[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bx7, bx6, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1210[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1210[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1210[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var commentId = param[2][1], issueIdOrKey = param[1];
		                       return cont([0, issueIdOrKey, commentId]);
		                      },
		                      function(param, cont){
		                       var commentId = param[2], issueIdOrKey = param[1];
		                       return cont([0, issueIdOrKey, [0, commentId, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bx9,
		                        0,
		                        0,
		                        0,
		                        cst_issueIdOrKey,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bx8,
		                         0,
		                         0,
		                         0,
		                         cst_commentId,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1210[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1210[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1170 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1210, [0, schematic_cache$1170]);
		               caml_callback
		                (input_schema_versioned$109, [function(param){return 0;}]);
		               function schematic_version$247(param){return 0;}
		               var
		                bn =
		                  caml_callback
		                   (input_schema_versioned$109, [schematic_version$247]),
		                action$117 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0334",
		                    b0,
		                    "\n      Delete a comment from an issue.\n      Example: {issueIdOrKey: 'PROJ-123', commentId: '10001'}.\n    ",
		                    write$0(1, 1, 0),
		                    bn),
		                letrec_function_context$1211 = [];
		               function input_schema_versioned$110(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1211[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bx$, bx_, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1211[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1211[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1211[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$559,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$766[1],
		                                       a =
		 [0,
		  [0,
		   bya,
		   0,
		   0,
		   0,
		   cst_visibility,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$562,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              visibility = b[2][1],
		              body = b[1],
		              commentId = a[1],
		              issueIdOrKey = param[1];
		             return cont([0, issueIdOrKey, commentId, body, visibility]);
		            },
		            function(param, cont){
		             var
		              visibility = param[4],
		              body = param[3],
		              commentId = param[2],
		              issueIdOrKey = param[1];
		             return cont
		                     ([0,
		                       issueIdOrKey,
		                       [0, commentId, [0, body, [0, visibility, 0]]]]);
		            },
		            [0,
		             [0,
		              byd,
		              0,
		              0,
		              0,
		              cst_issueIdOrKey,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               byc,
		               0,
		               0,
		               0,
		               cst_commentId,
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0, [0, byb, 0, 0, 0, cst_body, 0, 2, [0, b], 0, 0], a]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1211[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1211[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1171 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1211, [0, schematic_cache$1171]);
		               caml_callback
		                (input_schema_versioned$110, [function(param){return 0;}]);
		               function schematic_version$248(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$110, [schematic_version$248]),
		                action$118 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0325",
		                    b6,
		                    "\n      Update an existing comment on an issue. Body must be in Atlassian Document Format (ADF).\n      Example: {issueIdOrKey: 'PROJ-123', commentId: '10001', body: {type: 'doc', version: 1, content: [{type: 'paragraph', \\\n      content: [{type: 'text', text: 'Updated comment'}]}]}}.\n    ",
		                    write$0(1, 1, 0),
		                    b0),
		                letrec_function_context$1212 = [];
		               function input_schema_versioned$111(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1212[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byf, bye, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1212[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1212[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1212[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$767[1],
		                             a =
		                               [0,
		                                [0,
		                                 byg,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_expand,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$768[1],
		                                       b =
		 [0,
		  [0, byh, 0, 0, 0, "orderBy", 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$769[1],
		         a =
		           [0,
		            [0,
		             byi,
		             0,
		             0,
		             0,
		             cst_maxResults,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(b){
		                  var
		                   default$ = match$770[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        expand = c[2][1],
		                        orderBy = c[1],
		                        maxResults = b[1],
		                        startAt = a[1],
		                        issueIdOrKey = param[1];
		                       return cont
		                               ([0, issueIdOrKey, startAt, maxResults, orderBy, expand]);
		                      },
		                      function(param, cont){
		                       var
		                        expand = param[5],
		                        orderBy = param[4],
		                        maxResults = param[3],
		                        startAt = param[2],
		                        issueIdOrKey = param[1];
		                       return cont
		                               ([0,
		                                 issueIdOrKey,
		                                 [0, startAt, [0, maxResults, [0, orderBy, [0, expand, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        byk,
		                        0,
		                        0,
		                        0,
		                        cst_issueIdOrKey,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         byj,
		                         0,
		                         0,
		                         0,
		                         cst_startAt,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1212[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1212[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1172 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1212, [0, schematic_cache$1172]);
		               caml_callback
		                (input_schema_versioned$111, [function(param){return 0;}]);
		               function schematic_version$249(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$111, [schematic_version$249]),
		                action$119 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0316",
		                    "Get Comments",
		                    "\n      Get all comments on an issue.\n      Example: {issueIdOrKey: 'PROJ-123', orderBy: '-created'}.\n    ",
		                    read$2(0),
		                    b0),
		                letrec_function_context$1213 = [];
		               function input_schema_versioned$112(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1213[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bym, byl, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1213[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1213[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1213[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$559,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$771[1],
		                                       a =
		 [0,
		  [0,
		   byn,
		   0,
		   0,
		   0,
		   cst_visibility,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$562,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              visibility = a[2][1],
		              body = a[1],
		              issueIdOrKey = param[1];
		             return cont([0, issueIdOrKey, body, visibility]);
		            },
		            function(param, cont){
		             var
		              visibility = param[3],
		              body = param[2],
		              issueIdOrKey = param[1];
		             return cont
		                     ([0, issueIdOrKey, [0, body, [0, visibility, 0]]]);
		            },
		            [0,
		             [0,
		              byp,
		              0,
		              0,
		              0,
		              cst_issueIdOrKey,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0, [0, byo, 0, 0, 0, cst_body, 0, 2, [0, b], 0, 0], a]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1213[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1213[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1173 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1213, [0, schematic_cache$1173]);
		               caml_callback
		                (input_schema_versioned$112, [function(param){return 0;}]);
		               function schematic_version$250(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$112, [schematic_version$250]),
		                action$120 =
		                  action$0
		                   ("69d902b2ba50965c0c1a0307",
		                    "Add Comment",
		                    "\n      Add a comment to an issue. Body must be in Atlassian Document Format(ADF).\n      Example: {issueIdOrKey: 'PROJ-123', body: {type: 'doc', version: \\\n      1, content: [{type: 'paragraph', content: [{type: 'text', text: \\\n      'Hello'}]}]}}.\n    ",
		                    write$0(0, 0, 0),
		                    b0),
		                letrec_function_context$1214 = [];
		               function input_schema_versioned$113(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1214[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byr, byq, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1214[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1214[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1214[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$772[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var accountId = param[2][1], issueIdOrKey = param[1];
		                                 return cont([0, issueIdOrKey, accountId]);
		                                },
		                                function(param, cont){
		                                 var accountId = param[2], issueIdOrKey = param[1];
		                                 return cont([0, issueIdOrKey, [0, accountId, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  byt,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_issueIdOrKey,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bys,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_accountId,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1214[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1214[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1174 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1214, [0, schematic_cache$1174]);
		               caml_callback
		                (input_schema_versioned$113, [function(param){return 0;}]);
		               function schematic_version$251(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$113, [schematic_version$251]),
		                action$121 =
		                  action$0
		                   ("69d902b2ba50965c0c1a02f8",
		                    "Assign Issue",
		                    "\n      Assign an issue to a user by account ID. Use accountId: '-1' to unassign.\n      Example: {issueIdOrKey: 'PROJ-123', accountId: '5b10a2844c20165700ede21g'}.\n    ",
		                    write$0(1, 1, 0),
		                    b0),
		                letrec_function_context$1215 = [];
		               function schema_versioned$563(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1215[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byu, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1215[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1215[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1215[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$773[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$774[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[2][1], name = param[1];
		   return cont([0, name, id]);
		  },
		  function(param, cont){
		   var id = param[2], name = param[1];
		   return cont([0, name, [0, id, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1215[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1215[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1175 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1215, [0, schematic_cache$1175]);
		               caml_callback
		                (schema_versioned$563, [function(param){return 0;}]);
		               var letrec_function_context$1216 = [];
		               function schema_versioned$564(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1216[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byv, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1216[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1216[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1216[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$775[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var accountId = param[1];
		                                 return cont([0, accountId]);
		                                },
		                                function(param, cont){
		                                 var accountId = param[1];
		                                 return cont([0, accountId, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_accountId,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1216[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1216[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1176 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1216, [0, schematic_cache$1176]);
		               caml_callback
		                (schema_versioned$564, [function(param){return 0;}]);
		               var letrec_function_context$1217 = [];
		               function schema_versioned$565(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1217[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byw, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1217[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1217[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1217[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$564,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$776[1],
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_assignee,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$563,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$777[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var assignee = param[2][1], resolution = param[1];
		                       return cont([0, resolution, assignee]);
		                      },
		                      function(param, cont){
		                       var assignee = param[2], resolution = param[1];
		                       return cont([0, resolution, [0, assignee, 0]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        "resolution",
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1217[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1217[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1177 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1217, [0, schematic_cache$1177]);
		               caml_callback
		                (schema_versioned$565, [function(param){return 0;}]);
		               var letrec_function_context$1218 = [];
		               function schema_versioned$566(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1218[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byx, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1218[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1218[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1218[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$562,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var body = param[1];
		                                 return cont([0, body]);
		                                },
		                                function(param, cont){
		                                 var body = param[1];
		                                 return cont([0, body, 0]);
		                                },
		                                [0, [0, byy, 0, 0, 0, cst_body, 0, 2, [0, a], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1218[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1218[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1178 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1218, [0, schematic_cache$1178]);
		               caml_callback
		                (schema_versioned$566, [function(param){return 0;}]);
		               var letrec_function_context$1219 = [];
		               function input_schema_versioned$114(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1219[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byz, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1219[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1219[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1219[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$566,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$778[1],
		                                       a =
		 [0,
		  [0,
		   byA,
		   0,
		   0,
		   0,
		   cst_comment,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       json_object_schema,
		       function(c){
		        var
		         default$ = match$779[1],
		         b =
		           [0,
		            [0,
		             byB,
		             0,
		             0,
		             0,
		             cst_update,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$565,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(a){
		                            var
		                             default$ = match$780[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  comment = c[2][1],
		                                  update = c[1],
		                                  fields = b[1],
		                                  transitionId = a[1],
		                                  issueIdOrKey = param[1];
		                                 return cont
		 ([0, issueIdOrKey, transitionId, fields, update, comment]);
		                                },
		                                function(param, cont){
		                                 var
		                                  comment = param[5],
		                                  update = param[4],
		                                  fields = param[3],
		                                  transitionId = param[2],
		                                  issueIdOrKey = param[1];
		                                 return cont
		 ([0,
		   issueIdOrKey,
		   [0, transitionId, [0, fields, [0, update, [0, comment, 0]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  byE,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_issueIdOrKey,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   byD,
		                                   0,
		                                   0,
		                                   0,
		                                   "transitionId",
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    byC,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_fields,
		                                    0,
		                                    [0, default$],
		                                    [0, a],
		                                    0,
		                                    0],
		                                   b]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1219[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1219[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1179 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1219, [0, schematic_cache$1179]);
		               caml_callback
		                (input_schema_versioned$114, [function(param){return 0;}]);
		               function schematic_version$252(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$114, [schematic_version$252]),
		                action$122 =
		                  non_strict_action
		                   ("69d902b2ba50965c0c1a02e9",
		                    "Transition Issue",
		                    "\n      Move an issue through its workflow by performing a transition.\n      Use 'Get Issue Transitions' to find available transition IDs.\n      Example: {issueIdOrKey: 'PROJ-123', transitionId: '31'}.\n    ",
		                    write$0(1, 0, 0),
		                    b0),
		                letrec_function_context$1220 = [];
		               function input_schema_versioned$115(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1220[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byG, byF, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1220[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1220[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1220[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$781[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var expand = param[2][1], issueIdOrKey = param[1];
		                                 return cont([0, issueIdOrKey, expand]);
		                                },
		                                function(param, cont){
		                                 var expand = param[2], issueIdOrKey = param[1];
		                                 return cont([0, issueIdOrKey, [0, expand, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  byI,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_issueIdOrKey,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   byH,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_expand,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1220[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1220[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1180 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1220, [0, schematic_cache$1180]);
		               caml_callback
		                (input_schema_versioned$115, [function(param){return 0;}]);
		               function schematic_version$253(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$115, [schematic_version$253]),
		                action$123 =
		                  action$0
		                   ("69d902b2ba50965c0c1a02da",
		                    "Get Issue Transitions",
		                    "\n      Get available workflow transitions for an issue.\n      Example: {issueIdOrKey: 'PROJ-123', expand: 'transitions.fields'}.\n    ",
		                    read$2(0),
		                    b0),
		                letrec_function_context$1221 = [];
		               function input_schema_versioned$116(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1221[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byK, byJ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1221[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1221[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1221[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$782[1],
		                             a =
		                               [0,
		                                [0,
		                                 byL,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_expand,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$783[1],
		                                       b =
		 [0,
		  [0,
		   byM,
		   0,
		   0,
		   0,
		   "nextPageToken",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$784[1],
		         a =
		           [0,
		            [0,
		             byN,
		             0,
		             0,
		             0,
		             cst_maxResults,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(b){
		                  var
		                   default$ = match$785[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        expand = c[2][1],
		                        nextPageToken = c[1],
		                        maxResults = b[1],
		                        fields = a[1],
		                        jql = param[1];
		                       return cont
		                               ([0, jql, fields, maxResults, nextPageToken, expand]);
		                      },
		                      function(param, cont){
		                       var
		                        expand = param[5],
		                        nextPageToken = param[4],
		                        maxResults = param[3],
		                        fields = param[2],
		                        jql = param[1];
		                       return cont
		                               ([0,
		                                 jql,
		                                 [0,
		                                  fields,
		                                  [0, maxResults, [0, nextPageToken, [0, expand, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        byP,
		                        0,
		                        0,
		                        0,
		                        "jql",
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         byO,
		                         0,
		                         0,
		                         0,
		                         cst_fields,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1221[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1221[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1181 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1221, [0, schematic_cache$1181]);
		               caml_callback
		                (input_schema_versioned$116, [function(param){return 0;}]);
		               function schematic_version$254(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$116, [schematic_version$254]),
		                action$124 =
		                  action$0
		                   ("69d902b2ba50965c0c1a02cb",
		                    "Search Issues (JQL)",
		                    "\n      Search for issues using JQL.\n      Example: {jql: 'project = PROJ AND status = \"In Progress\"', fields: ['summary', 'status']}.\n    ",
		                    read$2(0),
		                    b0),
		                letrec_function_context$1222 = [];
		               function delete_subtasks_schema_version
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1222[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byQ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1222[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1222[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1222[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(byU);},
		                        0,
		                        0,
		                        cst_true,
		                        "True",
		                        byT,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){return param ? cont(byS) : cont(0);},
		                         0,
		                         0,
		                         cst_false,
		                         "False",
		                         byR,
		                         0],
		                        0]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1222[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1222[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1182 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1222, [0, schematic_cache$1182]);
		               caml_callback
		                (delete_subtasks_schema_version, [function(param){return 0;}]);
		               var letrec_function_context$1223 = [];
		               function input_schema_versioned$117(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1223[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byV, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1223[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1223[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1223[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (delete_subtasks_schema_version,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$786[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var deleteSubtasks = param[2][1], issueIdOrKey = param[1];
		   return cont([0, issueIdOrKey, deleteSubtasks]);
		  },
		  function(param, cont){
		   var deleteSubtasks = param[2], issueIdOrKey = param[1];
		   return cont([0, issueIdOrKey, [0, deleteSubtasks, 0]]);
		  },
		  [0,
		   [0,
		    byX,
		    0,
		    0,
		    0,
		    cst_issueIdOrKey,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     byW,
		     0,
		     0,
		     0,
		     "deleteSubtasks",
		     0,
		     [0, default$],
		     [0, a],
		     0,
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1223[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1223[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1183 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1223, [0, schematic_cache$1183]);
		               caml_callback
		                (input_schema_versioned$117, [function(param){return 0;}]);
		               function schematic_version$255(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$117, [schematic_version$255]),
		                b6 = "Delete Issue",
		                action$125 =
		                  action$0
		                   ("69d902b2ba50965c0c1a02bc",
		                    b6,
		                    "\n      Delete an issue from Jira.\n      Example: {issueIdOrKey: 'PROJ-123', deleteSubtasks: 'true'}.\n    ",
		                    write$0(1, 1, 0),
		                    b0),
		                letrec_function_context$1224 = [];
		               function schema_versioned$567(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1224[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byY, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1224[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1224[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1224[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$787[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$788[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[2][1], name = param[1];
		   return cont([0, name, id]);
		  },
		  function(param, cont){
		   var id = param[2], name = param[1];
		   return cont([0, name, [0, id, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1224[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1224[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1184 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1224, [0, schematic_cache$1184]);
		               caml_callback
		                (schema_versioned$567, [function(param){return 0;}]);
		               var letrec_function_context$1225 = [];
		               function schema_versioned$568(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1225[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, byZ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1225[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1225[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1225[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$789[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_emailAddress,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$790[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var emailAddress = param[2][1], accountId = param[1];
		   return cont([0, accountId, emailAddress]);
		  },
		  function(param, cont){
		   var emailAddress = param[2], accountId = param[1];
		   return cont([0, accountId, [0, emailAddress, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_accountId,
		    0,
		    [0, default$],
		    [0, b],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1225[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1225[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1185 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1225, [0, schematic_cache$1185]);
		               caml_callback
		                (schema_versioned$568, [function(param){return 0;}]);
		               var letrec_function_context$1226 = [];
		               function schema_versioned$569(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1226[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, by0, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1226[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1226[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1226[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(b){
		                            var
		                             default$ = match$791[1],
		                             a =
		                               [0,
		                                [0,
		                                 by1,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_labels,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$568,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(c){
		        var
		         default$ = match$792[1],
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_assignee,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$567,
		                 schematic_version,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           a,
		                           function(c){
		                            var
		                             default$ = match$793[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_priority,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$562,
		                                     schematic_version,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       b,
		       function(c){
		        var
		         default$ = match$794[1],
		         b =
		           [0,
		            [0,
		             by2,
		             0,
		             0,
		             0,
		             cst_description,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(a){
		                  var
		                   default$ = match$795[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        labels = c[2][1],
		                        assignee = c[1],
		                        priority = b[1],
		                        description = a[1],
		                        summary = param[1];
		                       return cont
		                               ([0, summary, description, priority, assignee, labels]);
		                      },
		                      function(param, cont){
		                       var
		                        labels = param[5],
		                        assignee = param[4],
		                        priority = param[3],
		                        description = param[2],
		                        summary = param[1];
		                       return cont
		                               ([0,
		                                 summary,
		                                 [0,
		                                  description,
		                                  [0, priority, [0, assignee, [0, labels, 0]]]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_summary, 0, [0, default$], [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1226[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1226[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1186 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1226, [0, schematic_cache$1186]);
		               caml_callback
		                (schema_versioned$569, [function(param){return 0;}]);
		               var letrec_function_context$1227 = [];
		               function input_schema_versioned$118(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1227[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, by4, by3, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1227[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1227[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1227[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$796[1],
		                             a =
		                               [0,
		                                [0,
		                                 by5,
		                                 0,
		                                 0,
		                                 0,
		                                 "notifyUsers",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     json_object_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$797[1],
		                                       b =
		 [0,
		  [0,
		   by6,
		   0,
		   0,
		   0,
		   cst_update,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$569,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(a){
		                  var
		                   default$ = match$798[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        notifyUsers = b[2][1],
		                        update = b[1],
		                        fields = a[1],
		                        issueIdOrKey = param[1];
		                       return cont([0, issueIdOrKey, fields, update, notifyUsers]);
		                      },
		                      function(param, cont){
		                       var
		                        notifyUsers = param[4],
		                        update = param[3],
		                        fields = param[2],
		                        issueIdOrKey = param[1];
		                       return cont
		                               ([0,
		                                 issueIdOrKey,
		                                 [0, fields, [0, update, [0, notifyUsers, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        by8,
		                        0,
		                        0,
		                        0,
		                        cst_issueIdOrKey,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         by7,
		                         0,
		                         0,
		                         0,
		                         cst_fields,
		                         0,
		                         [0, default$],
		                         [0, a],
		                         0,
		                         0],
		                        b]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1227[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1227[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1187 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1227, [0, schematic_cache$1187]);
		               caml_callback
		                (input_schema_versioned$118, [function(param){return 0;}]);
		               function schematic_version$256(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$118, [schematic_version$256]),
		                action$126 =
		                  non_strict_action
		                   ("69d902b2ba50965c0c1a02ad",
		                    bO7,
		                    "\n      Update an existing issue.\n      Use [fields] for simple field updates or [update] for complex operations.\n      Example: {issueIdOrKey: 'PROJ-123', fields: {summary: 'New title', priority: {name: 'High'}}}.\n    ",
		                    write$0(1, 1, 0),
		                    b0),
		                letrec_function_context$1228 = [];
		               function input_schema_versioned$119(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1228[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, by_, by9, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1228[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1228[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1228[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$799[1],
		                             a =
		                               [0,
		                                [0,
		                                 by$,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_expand,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$800[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    expand = a[2][1],
		    fields = a[1],
		    issueIdOrKey = param[1];
		   return cont([0, issueIdOrKey, fields, expand]);
		  },
		  function(param, cont){
		   var
		    expand = param[3],
		    fields = param[2],
		    issueIdOrKey = param[1];
		   return cont([0, issueIdOrKey, [0, fields, [0, expand, 0]]]);
		  },
		  [0,
		   [0,
		    bzb,
		    0,
		    0,
		    0,
		    cst_issueIdOrKey,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bza,
		     0,
		     0,
		     0,
		     cst_fields,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1228[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1228[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1188 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1228, [0, schematic_cache$1188]);
		               caml_callback
		                (input_schema_versioned$119, [function(param){return 0;}]);
		               function schematic_version$257(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$119, [schematic_version$257]),
		                action$127 =
		                  action$0
		                   ("69d902b2ba50965c0c1a029e",
		                    cst_Get_Issue,
		                    "\n      Get details of a specific issue by ID or key.\n      Example: {issueIdOrKey: 'PROJ-123', fields: '*all'}.\n    ",
		                    read$2(0),
		                    b0),
		                letrec_function_context$1229 = [];
		               function schema_versioned$570(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1229[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzc, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1229[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1229[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1229[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$801[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$802[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[2][1], key = param[1];
		   return cont([0, key, id]);
		  },
		  function(param, cont){
		   var id = param[2], key = param[1];
		   return cont([0, key, [0, id, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_key, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1229[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1229[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1189 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1229, [0, schematic_cache$1189]);
		               caml_callback
		                (schema_versioned$570, [function(param){return 0;}]);
		               var letrec_function_context$1230 = [];
		               function schema_versioned$571(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1230[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzd, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1230[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1230[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1230[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$803[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$804[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[2][1], name = param[1];
		   return cont([0, name, id]);
		  },
		  function(param, cont){
		   var id = param[2], name = param[1];
		   return cont([0, name, [0, id, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1230[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1230[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1190 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1230, [0, schematic_cache$1190]);
		               caml_callback
		                (schema_versioned$571, [function(param){return 0;}]);
		               var letrec_function_context$1231 = [];
		               function schema_versioned$572(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1231[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bze, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1231[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1231[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1231[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$562,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$805[1],
		                                       a =
		 [0,
		  [0,
		   bzf,
		   0,
		   0,
		   0,
		   cst_description,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$571,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_summary,
		             0,
		             2,
		             [0, schematic_param_name_schema_ve],
		             0,
		             0],
		            [0, [0, 0, 0, 0, 0, "issuetype", 0, 2, [0, c], 0, 0], a]];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$570,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        description = b[2][1],
		                        issuetype = b[1],
		                        summary = a[1],
		                        project = param[1];
		                       return cont([0, project, summary, issuetype, description]);
		                      },
		                      function(param, cont){
		                       var
		                        description = param[4],
		                        issuetype = param[3],
		                        summary = param[2],
		                        project = param[1];
		                       return cont
		                               ([0,
		                                 project,
		                                 [0, summary, [0, issuetype, [0, description, 0]]]]);
		                      },
		                      [0, [0, 0, 0, 0, 0, cst_project, 0, 2, [0, a], 0, 0], b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1231[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1231[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1191 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1231, [0, schematic_cache$1191]);
		               caml_callback
		                (schema_versioned$572, [function(param){return 0;}]);
		               var letrec_function_context$1232 = [];
		               function input_schema_versioned$120(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1232[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzg, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1232[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1232[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1232[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$572,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var fields = param[1];
		                                 return cont([0, fields]);
		                                },
		                                function(param, cont){
		                                 var fields = param[1];
		                                 return cont([0, fields, 0]);
		                                },
		                                [0, [0, bzh, 0, 0, 0, cst_fields, 0, 2, [0, a], 0, 0], 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1232[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1232[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1192 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1232, [0, schematic_cache$1192]);
		               caml_callback
		                (input_schema_versioned$120, [function(param){return 0;}]);
		               function schematic_version$258(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$120, [schematic_version$258]),
		                action$128 =
		                  action$0
		                   ("69d902b2ba50965c0c1a028f",
		                    cst_Create_Issue,
		                    "\n      Create a new issue.\n      Example: {fields: {project: {key: 'PROJ'}, summary: 'Bug: crash on startup', issuetype: {name: 'Bug'}}}.\n    ",
		                    write$0(0, 0, 0),
		                    b0),
		                letrec_function_context$1233 = [];
		               function id_filter_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1233[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzl, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1233[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1233[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1233[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(b){
		                            var
		                             default$ = match$806[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_in, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$807[1],
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, cst_neq, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$808[1],
		         res =
		           [7,
		            function(param, cont){
		             var a = param[2], in$ = a[2][1], neq = a[1], eq = param[1];
		             return cont([0, eq, neq, in$]);
		            },
		            function(param, cont){
		             var in$ = param[3], neq = param[2], eq = param[1];
		             return cont([0, eq, [0, neq, [0, in$, 0]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_eq, 0, [0, default$], [0, a], 0, 0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1233[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1233[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1193 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1233, [0, schematic_cache$1193]);
		               caml_callback
		                (id_filter_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1234 = [];
		               function string_filter_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1234[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzm, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1234[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1234[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1234[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$809[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_contains,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$810[1],
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, cst_in, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$811[1],
		         a =
		           [0,
		            [0, 0, 0, 0, 0, cst_neq, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$812[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        contains = b[2][1],
		                        in$ = b[1],
		                        neq = a[1],
		                        eq = param[1];
		                       return cont([0, eq, neq, in$, contains]);
		                      },
		                      function(param, cont){
		                       var
		                        contains = param[4],
		                        in$ = param[3],
		                        neq = param[2],
		                        eq = param[1];
		                       return cont([0, eq, [0, neq, [0, in$, [0, contains, 0]]]]);
		                      },
		                      [0,
		                       [0, 0, 0, 0, 0, cst_eq, 0, [0, default$], [0, b], 0, 0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1234[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1234[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1194 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1234, [0, schematic_cache$1194]);
		               caml_callback
		                (string_filter_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1235 = [];
		               function number_filter_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1235[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzn, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1235[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1235[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1235[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$813[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_lte, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$814[1],
		                                       b =
		 [0,
		  [0, 0, 0, 0, 0, cst_lt, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$815[1],
		         a =
		           [0,
		            [0, 0, 0, 0, 0, cst_gte, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$816[1],
		                   b =
		                     [0,
		                      [0, 0, 0, 0, 0, cst_gt, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$817[1],
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_neq, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$818[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    lte = d[2][1],
		    lt = d[1],
		    gte = c[1],
		    gt = b[1],
		    neq = a[1],
		    eq = param[1];
		   return cont([0, eq, neq, gt, gte, lt, lte]);
		  },
		  function(param, cont){
		   var
		    lte = param[6],
		    lt = param[5],
		    gte = param[4],
		    gt = param[3],
		    neq = param[2],
		    eq = param[1];
		   return cont
		           ([0, eq, [0, neq, [0, gt, [0, gte, [0, lt, [0, lte, 0]]]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_eq, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1235[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1235[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1195 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1235, [0, schematic_cache$1195]);
		               caml_callback
		                (number_filter_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1236 = [];
		               function id_relation_filter_schema_vers
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1236[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzo, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1236[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1236[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1236[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (id_filter_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$819[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id]);
		  },
		  function(param, cont){
		   var id = param[1];
		   return cont([0, id, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_id, 0, [0, default$], [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1236[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1236[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1196 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1236, [0, schematic_cache$1196]);
		               caml_callback
		                (id_relation_filter_schema_vers, [function(param){return 0;}]);
		               var letrec_function_context$1237 = [];
		               function name_relation_filter_schema_ve
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1237[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzp, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1237[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1237[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1237[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (string_filter_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$820[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var name = param[1];
		   return cont([0, name]);
		  },
		  function(param, cont){
		   var name = param[1];
		   return cont([0, name, 0]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_name, 0, [0, default$], [0, a], 0, 0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1237[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1237[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1197 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1237, [0, schematic_cache$1197]);
		               caml_callback
		                (name_relation_filter_schema_ve, [function(param){return 0;}]);
		               var
		                cst_cycleId = "cycleId",
		                cst_dueDate = "dueDate",
		                cst_estimate = "estimate",
		                cst_projectId = "projectId",
		                cst_stateId = "stateId",
		                cst_teamId = "teamId",
		                letrec_function_context$1238 = [];
		               function input_schema_versioned$121(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1238[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzr, bzq, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1238[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1238[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1238[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$821[1],
		                             a =
		                               [0,
		                                [0,
		                                 bzs,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_dueDate,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$822[1],
		                                       b =
		 [0,
		  [0,
		   bzt,
		   0,
		   0,
		   0,
		   cst_estimate,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$823[1],
		         a =
		           [0,
		            [0,
		             bzu,
		             0,
		             0,
		             0,
		             cst_cycleId,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$824[1],
		                   b =
		                     [0,
		                      [0,
		                       bzv,
		                       0,
		                       0,
		                       0,
		                       cst_projectId,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(c){
		                            var
		                             default$ = match$825[1],
		                             a =
		                               [0,
		                                [0,
		                                 bzw,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_labelIds,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$826[1],
		                                       b =
		 [0,
		  [0,
		   bzx,
		   0,
		   0,
		   0,
		   cst_stateId,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$827[1],
		         a =
		           [0,
		            [0,
		             bzy,
		             0,
		             0,
		             0,
		             cst_priority,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$828[1],
		                   b =
		                     [0,
		                      [0,
		                       bzz,
		                       0,
		                       0,
		                       0,
		                       cst_assigneeId,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$829[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  i = h[2],
		                                  dueDate = i[2][1],
		                                  estimate = i[1],
		                                  cycleId = h[1],
		                                  projectId = g[1],
		                                  labelIds = f[1],
		                                  stateId = e[1],
		                                  priority = d[1],
		                                  assigneeId = c[1],
		                                  description = b[1],
		                                  title = a[1],
		                                  teamId = param[1];
		                                 return cont
		 ([0,
		   teamId,
		   title,
		   description,
		   assigneeId,
		   priority,
		   stateId,
		   labelIds,
		   projectId,
		   cycleId,
		   estimate,
		   dueDate]);
		                                },
		                                function(param, cont){
		                                 var
		                                  dueDate = param[11],
		                                  estimate = param[10],
		                                  cycleId = param[9],
		                                  projectId = param[8],
		                                  labelIds = param[7],
		                                  stateId = param[6],
		                                  priority = param[5],
		                                  assigneeId = param[4],
		                                  description = param[3],
		                                  title = param[2],
		                                  teamId = param[1];
		                                 return cont
		 ([0,
		   teamId,
		   [0,
		    title,
		    [0,
		     description,
		     [0,
		      assigneeId,
		      [0,
		       priority,
		       [0,
		        stateId,
		        [0,
		         labelIds,
		         [0, projectId, [0, cycleId, [0, estimate, [0, dueDate, 0]]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bzC,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_teamId,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bzB,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_title,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bzA,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_description,
		                                    0,
		                                    [0, default$],
		                                    [0, a],
		                                    0,
		                                    0],
		                                   b]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1238[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1238[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1198 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1238, [0, schematic_cache$1198]);
		               caml_callback
		                (input_schema_versioned$121, [function(param){return 0;}]);
		               function schematic_version$259(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$121, [schematic_version$259]),
		                action$129 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1db46",
		                    cst_Create_Issue,
		                    "\n      Create a new Linear issue.\n      Get teamId from 'List Teams', stateId from 'List Workflow States'.\n      Priority: 0=None, 1=Urgent, 2=High, 3=Medium, 4=Low.\n      Example: {teamId: 'team123', title: 'Fix login bug', priority: 2}.\n    ",
		                    write$0(0, 0, 0),
		                    b0),
		                letrec_function_context$1239 = [];
		               function input_schema_versioned$122(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1239[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzE, bzD, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1239[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1239[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1239[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bzF,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1239[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1239[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1199 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1239, [0, schematic_cache$1199]);
		               caml_callback
		                (input_schema_versioned$122, [function(param){return 0;}]);
		               function schematic_version$260(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$122, [schematic_version$260]),
		                action$130 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1db55",
		                    cst_Get_Issue,
		                    "\n      Get a Linear issue by ID (UUID or shorthand like 'ENG-123').\n      Returns full details including comments, labels, state, and relations.\n      Example: {id: 'ENG-123'}.\n    ",
		                    read$2(0),
		                    b0),
		                letrec_function_context$1240 = [];
		               function input_schema_versioned$123(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1240[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzH, bzG, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1240[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1240[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1240[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$830[1],
		                             a =
		                               [0,
		                                [0,
		                                 bzI,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_dueDate,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$831[1],
		                                       b =
		 [0,
		  [0,
		   bzJ,
		   0,
		   0,
		   0,
		   cst_estimate,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$832[1],
		         a =
		           [0,
		            [0,
		             bzK,
		             0,
		             0,
		             0,
		             cst_cycleId,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$833[1],
		                   b =
		                     [0,
		                      [0,
		                       bzL,
		                       0,
		                       0,
		                       0,
		                       cst_projectId,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(c){
		                            var
		                             default$ = match$834[1],
		                             a =
		                               [0,
		                                [0,
		                                 bzM,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_labelIds,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$835[1],
		                                       b =
		 [0,
		  [0,
		   bzN,
		   0,
		   0,
		   0,
		   cst_stateId,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$836[1],
		         a =
		           [0,
		            [0,
		             bzO,
		             0,
		             0,
		             0,
		             cst_priority,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$837[1],
		                   b =
		                     [0,
		                      [0,
		                       bzP,
		                       0,
		                       0,
		                       0,
		                       cst_assigneeId,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$838[1],
		                             a =
		                               [0,
		                                [0,
		                                 bzQ,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_description,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$839[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    dueDate = i[2][1],
		    estimate = i[1],
		    cycleId = h[1],
		    projectId = g[1],
		    labelIds = f[1],
		    stateId = e[1],
		    priority = d[1],
		    assigneeId = c[1],
		    description = b[1],
		    title = a[1],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             title,
		             description,
		             assigneeId,
		             priority,
		             stateId,
		             labelIds,
		             projectId,
		             cycleId,
		             estimate,
		             dueDate]);
		  },
		  function(param, cont){
		   var
		    dueDate = param[11],
		    estimate = param[10],
		    cycleId = param[9],
		    projectId = param[8],
		    labelIds = param[7],
		    stateId = param[6],
		    priority = param[5],
		    assigneeId = param[4],
		    description = param[3],
		    title = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0,
		              title,
		              [0,
		               description,
		               [0,
		                assigneeId,
		                [0,
		                 priority,
		                 [0,
		                  stateId,
		                  [0,
		                   labelIds,
		                   [0, projectId, [0, cycleId, [0, estimate, [0, dueDate, 0]]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    bzS,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bzR, 0, 0, 0, cst_title, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1240[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1240[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1200 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1240, [0, schematic_cache$1200]);
		               caml_callback
		                (input_schema_versioned$123, [function(param){return 0;}]);
		               function schematic_version$261(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$123, [schematic_version$261]),
		                action$131 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1db64",
		                    bO7,
		                    "\n    Update a Linear issue.\n    Only provided fields are changed.\n    Example: {id: 'ENG-123', stateId: 'state456', priority: 1, assigneeId: 'user789'}.\n  ",
		                    write$0(1, 1, 0),
		                    b0),
		                letrec_function_context$1241 = [];
		               function input_schema_versioned$124(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1241[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzU, bzT, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1241[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1241[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1241[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bzV,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1241[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1241[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1201 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1241, [0, schematic_cache$1201]);
		               caml_callback
		                (input_schema_versioned$124, [function(param){return 0;}]);
		               function schematic_version$262(param){return 0;}
		               var
		                b0 =
		                  caml_callback
		                   (input_schema_versioned$124, [schematic_version$262]),
		                action$132 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1db73",
		                    b6,
		                    "\n      Delete a Linear issue (moves to trash).\n      Example: {id: 'issue-uuid'}.\n    ",
		                    write$0(1, 1, 0),
		                    b0),
		                letrec_function_context$1242 = [];
		               function issue_filter_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1242[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bzX, bzW, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1242[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1242[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1242[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (number_filter_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$840[1],
		                                       a =
		 [0,
		  [0,
		   bzY,
		   0,
		   0,
		   0,
		   cst_priority,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (name_relation_filter_schema_ve,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$841[1],
		                   b =
		                     [0,
		                      [0, bzZ, 0, 0, 0, cst_state, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (id_relation_filter_schema_vers,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(c){
		                                      var
		                                       default$ = match$842[1],
		                                       a =
		 [0,
		  [0, bz0, 0, 0, 0, "cycle", 0, [0, default$], [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (id_relation_filter_schema_vers,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$843[1],
		                   b =
		                     [0,
		                      [0,
		                       bz1,
		                       0,
		                       0,
		                       0,
		                       cst_project,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (id_relation_filter_schema_vers,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(c){
		                                      var
		                                       default$ = match$844[1],
		                                       a =
		 [0,
		  [0, bz2, 0, 0, 0, cst_team, 0, [0, default$], [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (id_relation_filter_schema_vers,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(b){
		                  var
		                   default$ = match$845[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        priority = d[2][1],
		                        state = d[1],
		                        cycle = c[1],
		                        project = b[1],
		                        team = a[1],
		                        assignee = param[1];
		                       return cont
		                               ([0, assignee, team, project, cycle, state, priority]);
		                      },
		                      function(param, cont){
		                       var
		                        priority = param[6],
		                        state = param[5],
		                        cycle = param[4],
		                        project = param[3],
		                        team = param[2],
		                        assignee = param[1];
		                       return cont
		                               ([0,
		                                 assignee,
		                                 [0,
		                                  team,
		                                  [0, project, [0, cycle, [0, state, [0, priority, 0]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bz3,
		                        0,
		                        0,
		                        0,
		                        cst_assignee,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1242[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1242[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1202 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1242, [0, schematic_cache$1202]);
		               caml_callback
		                (issue_filter_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1243 = [];
		               function input_schema_versioned$125(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1243[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bz4, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1243[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1243[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1243[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (issue_filter_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$846[1],
		                                       a =
		 [0,
		  [0,
		   bz5,
		   0,
		   0,
		   0,
		   cst_filter,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$847[1],
		         b =
		           [0,
		            [0, bz6, 0, 0, 0, cst_after, 0, [0, default$], [0, c], 0, 0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(a){
		                  var
		                   default$ = match$848[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        filter = a[2][1],
		                        after = a[1],
		                        first = param[1];
		                       return cont([0, first, after, filter]);
		                      },
		                      function(param, cont){
		                       var filter = param[3], after = param[2], first = param[1];
		                       return cont([0, first, [0, after, [0, filter, 0]]]);
		                      },
		                      [0,
		                       [0, bz7, 0, 0, 0, cst_first, 0, [0, default$], [0, a], 0, 0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1243[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1243[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1203 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1243, [0, schematic_cache$1203]);
		               caml_callback
		                (input_schema_versioned$125, [function(param){return 0;}]);
		               function schematic_version$263(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$125, [schematic_version$263]),
		                action$133 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1db82",
		                    bO9,
		                    '\n      List Linear issues with filtering and pagination. Use filter for assignee/team/state/priority.\n      Use \'Search Issues\' for text search.\n      Example: {first: 50, filter: {"team":{"id":{"eq":"TEAM_ID"}}}}.\n    ',
		                    read$2(0),
		                    b6),
		                letrec_function_context$1244 = [];
		               function input_schema_versioned$126(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1244[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bz9, bz8, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1244[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1244[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1244[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$849[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var first = param[2][1], query = param[1];
		                                 return cont([0, query, first]);
		                                },
		                                function(param, cont){
		                                 var first = param[2], query = param[1];
		                                 return cont([0, query, [0, first, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bz$,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_query,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bz_, 0, 0, 0, cst_first, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1244[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1244[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1204 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1244, [0, schematic_cache$1204]);
		               caml_callback
		                (input_schema_versioned$126, [function(param){return 0;}]);
		               function schematic_version$264(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$126, [schematic_version$264]),
		                action$134 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1db91",
		                    "Search Issues",
		                    "\n      Full-text search for Linear issues.\n      Example: {query: 'login bug', first: 20}.\n    ",
		                    read$2(0),
		                    b6),
		                cst_issueId = "issueId",
		                letrec_function_context$1245 = [];
		               function input_schema_versioned$127(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1245[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAb, bAa, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1245[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1245[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1245[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var body = param[2][1], issueId = param[1];
		                       return cont([0, issueId, body]);
		                      },
		                      function(param, cont){
		                       var body = param[2], issueId = param[1];
		                       return cont([0, issueId, [0, body, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bAd,
		                        0,
		                        0,
		                        0,
		                        cst_issueId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bAc,
		                         0,
		                         0,
		                         0,
		                         cst_body,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1245[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1245[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1205 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1245, [0, schematic_cache$1205]);
		               caml_callback
		                (input_schema_versioned$127, [function(param){return 0;}]);
		               function schematic_version$265(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$127, [schematic_version$265]),
		                action$135 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1dba0",
		                    cst_Create_Comment,
		                    "\n      Add a markdown comment to a Linear issue.\n      Example: {issueId: 'issue-uuid', body: 'Investigated and found root cause...'}.\n    ",
		                    write$0(0, 0, 0),
		                    b6),
		                letrec_function_context$1246 = [];
		               function input_schema_versioned$128(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1246[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAf, bAe, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1246[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1246[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1246[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$850[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var first = param[2][1], issueId = param[1];
		                                 return cont([0, issueId, first]);
		                                },
		                                function(param, cont){
		                                 var first = param[2], issueId = param[1];
		                                 return cont([0, issueId, [0, first, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bAh,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_issueId,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, bAg, 0, 0, 0, cst_first, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1246[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1246[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1206 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1246, [0, schematic_cache$1206]);
		               caml_callback
		                (input_schema_versioned$128, [function(param){return 0;}]);
		               function schematic_version$266(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$128, [schematic_version$266]),
		                action$136 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1dbaf",
		                    cst_List_Comments,
		                    "\n      List comments on a Linear issue.\n      Example: {issueId: 'issue-uuid', first: 20}.\n    ",
		                    read$2(0),
		                    b6),
		                letrec_function_context$1247 = [];
		               function input_schema_versioned$129(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1247[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAj, bAi, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1247[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1247[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1247[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$851[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first]);
		                                },
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first, 0]);
		                                },
		                                [0,
		                                 [0, bAk, 0, 0, 0, cst_first, 0, [0, default$], [0, a], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1247[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1247[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1207 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1247, [0, schematic_cache$1207]);
		               caml_callback
		                (input_schema_versioned$129, [function(param){return 0;}]);
		               function schematic_version$267(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$129, [schematic_version$267]),
		                action$137 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1dbbe",
		                    "List Teams",
		                    "\n      List all Linear teams. Returns team IDs needed to create issues.\n      Example: {first: 50}.\n    ",
		                    read$2(0),
		                    b6),
		                letrec_function_context$1248 = [];
		               function input_schema_versioned$130(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1248[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAm, bAl, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1248[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1248[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1248[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bAn,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1248[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1248[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1208 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1248, [0, schematic_cache$1208]);
		               caml_callback
		                (input_schema_versioned$130, [function(param){return 0;}]);
		               function schematic_version$268(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$130, [schematic_version$268]),
		                action$138 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1dbcd",
		                    "Get Team",
		                    "\n      Get a Linear team by ID, including members, workflow states, labels, and projects.\n      Example: {id: 'team-uuid'}.\n    ",
		                    read$2(0),
		                    b6),
		                letrec_function_context$1249 = [];
		               function input_schema_versioned$131(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1249[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAp, bAo, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1249[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1249[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1249[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$852[1],
		                             a =
		                               [0,
		                                [0, bAq, 0, 0, 0, cst_after, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$853[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var after = param[2][1], first = param[1];
		   return cont([0, first, after]);
		  },
		  function(param, cont){
		   var after = param[2], first = param[1];
		   return cont([0, first, [0, after, 0]]);
		  },
		  [0,
		   [0, bAr, 0, 0, 0, cst_first, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1249[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1249[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1209 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1249, [0, schematic_cache$1209]);
		               caml_callback
		                (input_schema_versioned$131, [function(param){return 0;}]);
		               function schematic_version$269(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$131, [schematic_version$269]),
		                action$139 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1dbdc",
		                    j,
		                    "\n      List all Linear projects with pagination.\n      Example: {first: 50}.\n    ",
		                    read$2(0),
		                    b6),
		                letrec_function_context$1250 = [];
		               function input_schema_versioned$132(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1250[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAt, bAs, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1250[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1250[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1250[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$854[1],
		                             a =
		                               [0,
		                                [0, bAu, 0, 0, 0, cst_color, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$855[1],
		                                       b =
		 [0,
		  [0, bAv, 0, 0, 0, "leadId", 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$856[1],
		         a =
		           [0,
		            [0,
		             bAw,
		             0,
		             0,
		             0,
		             cst_startDate,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$857[1],
		                   b =
		                     [0,
		                      [0,
		                       bAx,
		                       0,
		                       0,
		                       0,
		                       "targetDate",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$858[1],
		                             a =
		                               [0,
		                                [0, bAy, 0, 0, 0, cst_state, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$859[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    color = f[2][1],
		    leadId = f[1],
		    startDate = e[1],
		    targetDate = d[1],
		    state = c[1],
		    description = b[1],
		    teamIds = a[1],
		    name = param[1];
		   return cont
		           ([0,
		             name,
		             teamIds,
		             description,
		             state,
		             targetDate,
		             startDate,
		             leadId,
		             color]);
		  },
		  function(param, cont){
		   var
		    color = param[8],
		    leadId = param[7],
		    startDate = param[6],
		    targetDate = param[5],
		    state = param[4],
		    description = param[3],
		    teamIds = param[2],
		    name = param[1];
		   return cont
		           ([0,
		             name,
		             [0,
		              teamIds,
		              [0,
		               description,
		               [0,
		                state,
		                [0, targetDate, [0, startDate, [0, leadId, [0, color, 0]]]]]]]]);
		  },
		  [0,
		   [0,
		    bAB,
		    0,
		    0,
		    0,
		    cst_name,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bAA,
		     0,
		     0,
		     0,
		     "teamIds",
		     0,
		     2,
		     [0, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		     0,
		     0],
		    [0,
		     [0,
		      bAz,
		      0,
		      0,
		      0,
		      cst_description,
		      0,
		      [0, default$],
		      [0, b],
		      0,
		      0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1250[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1250[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1210 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1250, [0, schematic_cache$1210]);
		               caml_callback
		                (input_schema_versioned$132, [function(param){return 0;}]);
		               function schematic_version$270(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$132, [schematic_version$270]),
		                bO9 = "Create Project",
		                action$140 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1dbeb",
		                    bO9,
		                    "\n      Create a new Linear project.\n      Example: {name: 'Q2 Launch', teamIds: ['team123'], state: 'planned', targetDate: '2024-06-30'}.\n    ",
		                    write$0(0, 0, 0),
		                    b6),
		                letrec_function_context$1251 = [];
		               function input_schema_versioned$133(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1251[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAD, bAC, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1251[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1251[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1251[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$860[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first]);
		                                },
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first, 0]);
		                                },
		                                [0,
		                                 [0, bAE, 0, 0, 0, cst_first, 0, [0, default$], [0, a], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1251[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1251[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1211 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1251, [0, schematic_cache$1211]);
		               caml_callback
		                (input_schema_versioned$133, [function(param){return 0;}]);
		               function schematic_version$271(param){return 0;}
		               var
		                b6 =
		                  caml_callback
		                   (input_schema_versioned$133, [schematic_version$271]),
		                b0 = "List Users",
		                action$141 =
		                  action$0
		                   ("69cfe91f68172d0c3ca1dbfa",
		                    b0,
		                    "\n      List all Linear workspace members. Returns user IDs for assigning issues.\n      Example: {first: 50}.\n    ",
		                    read$2(0),
		                    b6),
		                action$142 =
		                  action$0
		                   ("69cfe92068172d0c3ca1dc09",
		                    bV,
		                    "\n      Get the currently authenticated Linear user with profile and assigned issues.\n      No input required \xe2\x80\x94 pass an empty object {}.\n    ",
		                    read$2(0),
		                    empty_object_schema),
		                letrec_function_context$1252 = [];
		               function input_schema_versioned$134(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1252[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAG, bAF, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1252[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1252[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1252[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$861[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first]);
		                                },
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first, 0]);
		                                },
		                                [0,
		                                 [0, bAH, 0, 0, 0, cst_first, 0, [0, default$], [0, a], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1252[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1252[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1212 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1252, [0, schematic_cache$1212]);
		               caml_callback
		                (input_schema_versioned$134, [function(param){return 0;}]);
		               function schematic_version$272(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$134, [schematic_version$272]),
		                b6 = "List Labels",
		                action$143 =
		                  action$0
		                   ("69cfe92068172d0c3ca1dc18",
		                    b6,
		                    "\n      List all Linear labels. Returns label IDs for issue creation/updates.\n      Example: {first: 100}.\n    ",
		                    read$2(0),
		                    bV),
		                letrec_function_context$1253 = [];
		               function input_schema_versioned$135(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1253[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAJ, bAI, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1253[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1253[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1253[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$862[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first]);
		                                },
		                                function(param, cont){
		                                 var first = param[1];
		                                 return cont([0, first, 0]);
		                                },
		                                [0,
		                                 [0, bAK, 0, 0, 0, cst_first, 0, [0, default$], [0, a], 0, 0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1253[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1253[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1213 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1253, [0, schematic_cache$1213]);
		               caml_callback
		                (input_schema_versioned$135, [function(param){return 0;}]);
		               function schematic_version$273(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$135, [schematic_version$273]),
		                action$144 =
		                  action$0
		                   ("69cfe92068172d0c3ca1dc27",
		                    "List Workflow States",
		                    "\n      List all Linear workflow states. Returns state IDs used when creating or updating issues.\n      Example: {first: 100}.\n    ",
		                    read$2(0),
		                    bV),
		                letrec_function_context$1254 = [];
		               function cycle_filter_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1254[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAM, bAL, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1254[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1254[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1254[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (number_filter_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$863[1],
		                                       a =
		 [0,
		  [0,
		   bAN,
		   0,
		   0,
		   0,
		   cst_number,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (string_filter_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 b,
		                 function(c){
		                  var
		                   default$ = match$864[1],
		                   b =
		                     [0,
		                      [0, bAO, 0, 0, 0, cst_name, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (id_relation_filter_schema_vers,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$865[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    number = a[2][1],
		    name = a[1],
		    team = param[1];
		   return cont([0, team, name, number]);
		  },
		  function(param, cont){
		   var number = param[3], name = param[2], team = param[1];
		   return cont([0, team, [0, name, [0, number, 0]]]);
		  },
		  [0,
		   [0, bAP, 0, 0, 0, cst_team, 0, [0, default$], [0, a], 0, 0],
		   b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1254[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1254[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1214 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1254, [0, schematic_cache$1214]);
		               caml_callback
		                (cycle_filter_schema_versioned, [function(param){return 0;}]);
		               var letrec_function_context$1255 = [];
		               function input_schema_versioned$136(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1255[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAQ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1255[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1255[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1255[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (cycle_filter_schema_versioned,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(b){
		                                      var
		                                       default$ = match$866[1],
		                                       a =
		 [0,
		  [0,
		   bAR,
		   0,
		   0,
		   0,
		   cst_filter,
		   0,
		   [0, default$],
		   [0, b],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(b){
		        var
		         default$ = match$867[1],
		         res =
		           [7,
		            function(param, cont){
		             var filter = param[2][1], first = param[1];
		             return cont([0, first, filter]);
		            },
		            function(param, cont){
		             var filter = param[2], first = param[1];
		             return cont([0, first, [0, filter, 0]]);
		            },
		            [0,
		             [0, bAS, 0, 0, 0, cst_first, 0, [0, default$], [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1255[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1255[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1215 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1255, [0, schematic_cache$1215]);
		               caml_callback
		                (input_schema_versioned$136, [function(param){return 0;}]);
		               function schematic_version$274(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$136, [schematic_version$274]),
		                action$145 =
		                  action$0
		                   ("69cfe92068172d0c3ca1dc36",
		                    "List Cycles",
		                    "\n      List all Linear cycles (sprints) in the organization.\n      Example: {first: 50}.\n    ",
		                    read$2(0),
		                    bV),
		                letrec_function_context$1256 = [];
		               function input_schema_versioned$137(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1256[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bAU, bAT, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1256[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1256[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1256[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$868[1],
		                             a =
		                               [0,
		                                [0,
		                                 bAV,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_description,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$869[1],
		                                       b =
		 [0,
		  [0, bAW, 0, 0, 0, cst_color, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$870[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              description = b[2][1],
		              color = b[1],
		              teamId = a[1],
		              name = param[1];
		             return cont([0, name, teamId, color, description]);
		            },
		            function(param, cont){
		             var
		              description = param[4],
		              color = param[3],
		              teamId = param[2],
		              name = param[1];
		             return cont
		                     ([0, name, [0, teamId, [0, color, [0, description, 0]]]]);
		            },
		            [0,
		             [0,
		              bAY,
		              0,
		              0,
		              0,
		              cst_name,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bAX,
		               0,
		               0,
		               0,
		               cst_teamId,
		               0,
		               [0, default$],
		               [0, a],
		               0,
		               0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1256[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1256[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1216 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1256, [0, schematic_cache$1216]);
		               caml_callback
		                (input_schema_versioned$137, [function(param){return 0;}]);
		               function schematic_version$275(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$137, [schematic_version$275]),
		                bO7 = "Create Label",
		                action$146 =
		                  action$0
		                   ("69cfe92068172d0c3ca1dc45",
		                    bO7,
		                    "\n      Create a new Linear label. Omit teamId for a workspace-level label.\n      Example: {name: 'bug', color: '#FF0000'}.\n    ",
		                    write$0(0, 0, 0),
		                    bV),
		                action$147 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c300",
		                    "Get Current User Profile",
		                    "Get the profile of the authenticated LinkedIn member.\nReturns basic data such as name, headline, and profile picture.\nTakes no input.\nExample: {input: {}}.",
		                    read$2(0),
		                    empty_object_schema),
		                letrec_function_context$1257 = [];
		               function input_schema_versioned$138(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1257[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bA0, bAZ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1257[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1257[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1257[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$871[1],
		                             a =
		                               [0,
		                                [0, bA1, 0, 0, 0, cst_count, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$872[1],
		                                       b =
		 [0,
		  [0, bA2, 0, 0, 0, cst_start, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$873[1],
		         a =
		           [0,
		            [0, bA3, 0, 0, 0, cst_state, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$874[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        count = b[2][1],
		                        start = b[1],
		                        state = a[1],
		                        role = param[1];
		                       return cont([0, role, state, start, count]);
		                      },
		                      function(param, cont){
		                       var
		                        count = param[4],
		                        start = param[3],
		                        state = param[2],
		                        role = param[1];
		                       return cont
		                               ([0, role, [0, state, [0, start, [0, count, 0]]]]);
		                      },
		                      [0,
		                       [0, bA4, 0, 0, 0, cst_role, 0, [0, default$], [0, b], 0, 0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1257[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1257[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1217 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1257, [0, schematic_cache$1217]);
		               caml_callback
		                (input_schema_versioned$138, [function(param){return 0;}]);
		               function schematic_version$276(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$138, [schematic_version$276]),
		                action$148 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c30d",
		                    "Get User Organizations",
		                    "List organizations the authenticated member can administer.\nReturns organization ACLs with roles and states.\nUse a returned organization ID to build the author URN 'urn:li:organization:{id}' for posts, comments, and reactions.\nExample: {input: {role: 'ADMINISTRATOR', state: 'APPROVED'}}.",
		                    read$2(0),
		                    bV),
		                letrec_function_context$1258 = [];
		               function input_schema_versioned$139(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1258[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bA6, bA5, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1258[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1258[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1258[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var organizationId = param[1];
		                       return cont([0, organizationId]);
		                      },
		                      function(param, cont){
		                       var organizationId = param[1];
		                       return cont([0, organizationId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bA7,
		                        0,
		                        0,
		                        0,
		                        cst_organizationId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1258[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1258[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1218 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1258, [0, schematic_cache$1218]);
		               caml_callback
		                (input_schema_versioned$139, [function(param){return 0;}]);
		               function schematic_version$277(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$139, [schematic_version$277]),
		                action$149 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c31a",
		                    b$,
		                    "Get details about a LinkedIn organization (company page) by ID.\nThe member must have admin access to the organization for full details.\nGet organization IDs from 'Get User Organizations'.\nExample: {input: {organizationId: '12345'}}.",
		                    read$2(0),
		                    bV),
		                action$150 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c396",
		                    "Get Connections Count",
		                    "Get the number of 1st-degree connections for the authenticated member.\nTakes no input.\nReturns the total connection count.\nExample: {input: {}}.",
		                    read$2(0),
		                    empty_object_schema),
		                cst_commentary = "commentary",
		                cst_lifecycleState = "lifecycleState",
		                letrec_function_context$1259 = [];
		               function input_schema_versioned$140(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1259[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bA9, bA8, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1259[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1259[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1259[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$875[1],
		                             a =
		                               [0,
		                                [0,
		                                 bA_,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_lifecycleState,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$876[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    lifecycleState = b[2][1],
		    visibility = b[1],
		    commentary = a[1],
		    author = param[1];
		   return cont
		           ([0, author, commentary, visibility, lifecycleState]);
		  },
		  function(param, cont){
		   var
		    lifecycleState = param[4],
		    visibility = param[3],
		    commentary = param[2],
		    author = param[1];
		   return cont
		           ([0,
		             author,
		             [0, commentary, [0, visibility, [0, lifecycleState, 0]]]]);
		  },
		  [0,
		   [0,
		    bBb,
		    0,
		    0,
		    0,
		    cst_author,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bBa,
		     0,
		     0,
		     0,
		     cst_commentary,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      bA$,
		      0,
		      0,
		      0,
		      cst_visibility,
		      0,
		      [0, default$],
		      [0, b],
		      0,
		      0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1259[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1259[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1219 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1259, [0, schematic_cache$1219]);
		               caml_callback
		                (input_schema_versioned$140, [function(param){return 0;}]);
		               function schematic_version$278(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$140, [schematic_version$278]),
		                action$151 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c322",
		                    "Create Text Post",
		                    "Create a text-only post on LinkedIn on behalf of an organization.\nThe author URN comes from 'Get User Organizations'.\nExample: {input: {author: 'urn:li:organization:12345', commentary: 'Hello LinkedIn!'}}.",
		                    write$0(0, 0, 1),
		                    bV),
		                letrec_function_context$1260 = [];
		               function input_schema_versioned$141(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1260[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBd, bBc, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1260[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1260[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1260[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$877[1],
		                             a =
		                               [0,
		                                [0,
		                                 bBe,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_lifecycleState,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$878[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    lifecycleState = c[2][1],
		    visibility = c[1],
		    imageUrn = b[1],
		    commentary = a[1],
		    author = param[1];
		   return cont
		           ([0,
		             author,
		             commentary,
		             imageUrn,
		             visibility,
		             lifecycleState]);
		  },
		  function(param, cont){
		   var
		    lifecycleState = param[5],
		    visibility = param[4],
		    imageUrn = param[3],
		    commentary = param[2],
		    author = param[1];
		   return cont
		           ([0,
		             author,
		             [0,
		              commentary,
		              [0, imageUrn, [0, visibility, [0, lifecycleState, 0]]]]]);
		  },
		  [0,
		   [0,
		    bBi,
		    0,
		    0,
		    0,
		    cst_author,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bBh,
		     0,
		     0,
		     0,
		     cst_commentary,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      bBg,
		      0,
		      0,
		      0,
		      "imageUrn",
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0,
		       bBf,
		       0,
		       0,
		       0,
		       cst_visibility,
		       0,
		       [0, default$],
		       [0, b],
		       0,
		       0],
		      a]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1260[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1260[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1220 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1260, [0, schematic_cache$1220]);
		               caml_callback
		                (input_schema_versioned$141, [function(param){return 0;}]);
		               function schematic_version$279(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$141, [schematic_version$279]),
		                action$152 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c32a",
		                    "Create Image Post",
		                    "Create a post with an image on LinkedIn on behalf of an organization.\nFirst upload the image with 'Initialize Image Upload' and PUT the binary to the returned upload URL.\nThen pass the returned image URN here as 'imageUrn'.\nExample: {input: {author: 'urn:li:organization:12345', commentary: 'Check this out', imageUrn: 'urn:li:image:C49klciosC89'}}.",
		                    write$0(0, 0, 1),
		                    bV),
		                letrec_function_context$1261 = [];
		               function input_schema_versioned$142(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1261[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBk, bBj, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1261[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1261[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1261[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var owner = param[1];
		                       return cont([0, owner]);
		                      },
		                      function(param, cont){
		                       var owner = param[1];
		                       return cont([0, owner, 0]);
		                      },
		                      [0,
		                       [0,
		                        bBl,
		                        0,
		                        0,
		                        0,
		                        cst_owner,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1261[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1261[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1221 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1261, [0, schematic_cache$1221]);
		               caml_callback
		                (input_schema_versioned$142, [function(param){return 0;}]);
		               function schematic_version$280(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$142, [schematic_version$280]),
		                action$153 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c354",
		                    "Initialize Image Upload",
		                    "Initialize an image upload to LinkedIn for an organization.\nReturns an upload URL and an image URN.\nUpload the image binary to the returned upload URL with a PUT request, then pass the image URN to 'Create Image Post'.\nExample: {input: {owner: 'urn:li:organization:12345'}}.",
		                    write$0(0, 0, 1),
		                    bV),
		                cst_postUrn = "postUrn",
		                letrec_function_context$1262 = [];
		               function input_schema_versioned$143(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1262[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBn, bBm, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1262[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1262[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1262[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$879[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var viewContext = param[2][1], postUrn = param[1];
		                                 return cont([0, postUrn, viewContext]);
		                                },
		                                function(param, cont){
		                                 var viewContext = param[2], postUrn = param[1];
		                                 return cont([0, postUrn, [0, viewContext, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bBp,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_postUrn,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bBo,
		                                   0,
		                                   0,
		                                   0,
		                                   "viewContext",
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1262[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1262[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1222 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1262, [0, schematic_cache$1222]);
		               caml_callback
		                (input_schema_versioned$143, [function(param){return 0;}]);
		               function schematic_version$281(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$143, [schematic_version$281]),
		                action$154 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c332",
		                    cst_Get_Post,
		                    "Get a specific LinkedIn post by its URN.\nGet URNs from 'List Posts'.\nExample: {input: {postUrn: 'urn:li:ugcPost:12345'}}.",
		                    read$2(0),
		                    bV),
		                letrec_function_context$1263 = [];
		               function input_schema_versioned$144(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1263[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBr, bBq, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1263[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1263[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1263[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$880[1],
		                             a =
		                               [0,
		                                [0, bBs, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$881[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    start = a[2][1],
		    count = a[1],
		    author = param[1];
		   return cont([0, author, count, start]);
		  },
		  function(param, cont){
		   var start = param[3], count = param[2], author = param[1];
		   return cont([0, author, [0, count, [0, start, 0]]]);
		  },
		  [0,
		   [0,
		    bBu,
		    0,
		    0,
		    0,
		    cst_author,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bBt, 0, 0, 0, cst_count, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1263[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1263[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1223 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1263, [0, schematic_cache$1223]);
		               caml_callback
		                (input_schema_versioned$144, [function(param){return 0;}]);
		               function schematic_version$282(param){return 0;}
		               var
		                bV =
		                  caml_callback
		                   (input_schema_versioned$144, [schematic_version$282]),
		                action$155 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c33f",
		                    bY,
		                    "List posts authored by an organization.\nResults are sorted by lastModifiedAt descending.\nExample: {input: {author: 'urn:li:organization:12345', count: 10}}.",
		                    read$2(0),
		                    bV),
		                letrec_function_context$1264 = [];
		               function input_schema_versioned$145(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1264[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBw, bBv, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1264[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1264[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1264[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$882[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  parentComment = b[2][1],
		                                  message = b[1],
		                                  actor = a[1],
		                                  postUrn = param[1];
		                                 return cont([0, postUrn, actor, message, parentComment]);
		                                },
		                                function(param, cont){
		                                 var
		                                  parentComment = param[4],
		                                  message = param[3],
		                                  actor = param[2],
		                                  postUrn = param[1];
		                                 return cont
		 ([0,
		   postUrn,
		   [0, actor, [0, message, [0, parentComment, 0]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bBA,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_postUrn,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bBz,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_actor,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bBy,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_message,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   [0,
		                                    [0,
		                                     bBx,
		                                     0,
		                                     0,
		                                     0,
		                                     "parentComment",
		                                     0,
		                                     [0, default$],
		                                     [0, a],
		                                     0,
		                                     0],
		                                    0]]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1264[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1264[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1224 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1264, [0, schematic_cache$1224]);
		               caml_callback
		                (input_schema_versioned$145, [function(param){return 0;}]);
		               function schematic_version$283(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$145, [schematic_version$283]),
		                action$156 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c35c",
		                    cst_Create_Comment,
		                    "Create a comment on a LinkedIn post, or a reply to another comment, on behalf of an organization.\nPass 'parentComment' to reply to an existing comment.\nExample: {input: {postUrn: 'urn:li:ugcPost:12345', actor: 'urn:li:organization:12345', message: 'Great post!'}}.",
		                    write$0(0, 0, 1),
		                    bY),
		                letrec_function_context$1265 = [];
		               function input_schema_versioned$146(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1265[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBC, bBB, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1265[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1265[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1265[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$883[1],
		                             a =
		                               [0,
		                                [0, bBD, 0, 0, 0, cst_count, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$884[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    count = a[2][1],
		    start = a[1],
		    postUrn = param[1];
		   return cont([0, postUrn, start, count]);
		  },
		  function(param, cont){
		   var count = param[3], start = param[2], postUrn = param[1];
		   return cont([0, postUrn, [0, start, [0, count, 0]]]);
		  },
		  [0,
		   [0,
		    bBF,
		    0,
		    0,
		    0,
		    cst_postUrn,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bBE, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1265[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1265[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1225 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1265, [0, schematic_cache$1225]);
		               caml_callback
		                (input_schema_versioned$146, [function(param){return 0;}]);
		               function schematic_version$284(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$146, [schematic_version$284]),
		                action$157 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c369",
		                    cst_List_Comments,
		                    "List comments on a LinkedIn post.\nExample: {input: {postUrn: 'urn:li:ugcPost:12345', count: 20}}.",
		                    read$2(0),
		                    bY),
		                cst_entityUrn = "entityUrn",
		                letrec_function_context$1266 = [];
		               function input_schema_versioned$147(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1266[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBH, bBG, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1266[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1266[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1266[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        reactionType = a[2][1],
		                        actor = a[1],
		                        entityUrn = param[1];
		                       return cont([0, entityUrn, actor, reactionType]);
		                      },
		                      function(param, cont){
		                       var
		                        reactionType = param[3],
		                        actor = param[2],
		                        entityUrn = param[1];
		                       return cont
		                               ([0, entityUrn, [0, actor, [0, reactionType, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        bBK,
		                        0,
		                        0,
		                        0,
		                        cst_entityUrn,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bBJ,
		                         0,
		                         0,
		                         0,
		                         cst_actor,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          bBI,
		                          0,
		                          0,
		                          0,
		                          "reactionType",
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1266[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1266[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1226 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1266, [0, schematic_cache$1226]);
		               caml_callback
		                (input_schema_versioned$147, [function(param){return 0;}]);
		               function schematic_version$285(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$147, [schematic_version$285]),
		                action$158 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c37e",
		                    "Create Reaction",
		                    "Add a reaction to a LinkedIn post or comment on behalf of an organization.\nLIKE is equivalent to the traditional like button.\nExample: {input: {entityUrn: 'urn:li:ugcPost:12345', actor: 'urn:li:organization:12345', reactionType: 'LIKE'}}.",
		                    write$0(0, 0, 1),
		                    bY),
		                letrec_function_context$1267 = [];
		               function input_schema_versioned$148(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1267[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBM, bBL, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1267[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1267[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1267[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$885[1],
		                             a =
		                               [0,
		                                [0, bBN, 0, 0, 0, cst_count, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$886[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    count = a[2][1],
		    start = a[1],
		    entityUrn = param[1];
		   return cont([0, entityUrn, start, count]);
		  },
		  function(param, cont){
		   var
		    count = param[3],
		    start = param[2],
		    entityUrn = param[1];
		   return cont([0, entityUrn, [0, start, [0, count, 0]]]);
		  },
		  [0,
		   [0,
		    bBP,
		    0,
		    0,
		    0,
		    cst_entityUrn,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bBO, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1267[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1267[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1227 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1267, [0, schematic_cache$1227]);
		               caml_callback
		                (input_schema_versioned$148, [function(param){return 0;}]);
		               function schematic_version$286(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$148, [schematic_version$286]),
		                action$159 =
		                  action$0
		                   ("6a2fd68920ba20fac2d4c386",
		                    "List Reactions",
		                    "List reactions on a LinkedIn post or comment.\nExample: {input: {entityUrn: 'urn:li:ugcPost:12345', count: 20}}.",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1268 = [];
		               function schema_versioned$573(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1268[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBQ, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1268[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1268[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1268[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var property = param[2][1], value = param[1];
		                       return cont([0, value, property]);
		                      },
		                      function(param, cont){
		                       var property = param[2], value = param[1];
		                       return cont([0, value, [0, property, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bBS,
		                        0,
		                        0,
		                        0,
		                        cst_value,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bBR,
		                         0,
		                         0,
		                         0,
		                         cst_property,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1268[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1268[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1228 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1268, [0, schematic_cache$1228]);
		               caml_callback
		                (schema_versioned$573, [function(param){return 0;}]);
		               var letrec_function_context$1269 = [];
		               function schema_versioned$574(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1269[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBT, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1269[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1269[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1269[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var timestamp = param[2][1], direction = param[1];
		                       return cont([0, direction, timestamp]);
		                      },
		                      function(param, cont){
		                       var timestamp = param[2], direction = param[1];
		                       return cont([0, direction, [0, timestamp, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bBV,
		                        0,
		                        0,
		                        0,
		                        cst_direction,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bBU,
		                         0,
		                         0,
		                         0,
		                         cst_timestamp,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1269[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1269[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1229 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1269, [0, schematic_cache$1229]);
		               caml_callback
		                (schema_versioned$574, [function(param){return 0;}]);
		               var
		                cst_page_size = "page_size",
		                cst_start_cursor = "start_cursor",
		                letrec_function_context$1270 = [];
		               function input_schema_versioned$149(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1270[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bBW, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1270[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1270[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1270[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$887[1],
		                             a =
		                               [0,
		                                [0,
		                                 bBX,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_page_size,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$888[1],
		                                       b =
		 [0,
		  [0,
		   bBY,
		   0,
		   0,
		   0,
		   cst_start_cursor,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$574,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$889[1],
		                   a =
		                     [0,
		                      [0, bBZ, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$573,
		                           schematic_version,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     b,
		                                     function(c){
		                                      var
		                                       default$ = match$890[1],
		                                       b =
		 [0,
		  [0,
		   bB0,
		   0,
		   0,
		   0,
		   cst_filter,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$891[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              page_size = c[2][1],
		              start_cursor = c[1],
		              sort = b[1],
		              filter = a[1],
		              query = param[1];
		             return cont
		                     ([0, query, filter, sort, start_cursor, page_size]);
		            },
		            function(param, cont){
		             var
		              page_size = param[5],
		              start_cursor = param[4],
		              sort = param[3],
		              filter = param[2],
		              query = param[1];
		             return cont
		                     ([0,
		                       query,
		                       [0, filter, [0, sort, [0, start_cursor, [0, page_size, 0]]]]]);
		            },
		            [0,
		             [0, bB1, 0, 0, 0, cst_query, 0, [0, default$], [0, a], 0, 0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1270[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1270[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1230 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1270, [0, schematic_cache$1230]);
		               caml_callback
		                (input_schema_versioned$149, [function(param){return 0;}]);
		               function schematic_version$287(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$149, [schematic_version$287]),
		                action$160 =
		                  action$0
		                   ("6a1d85699c3c400e5b49891e",
		                    "Search",
		                    "\nSearch all pages and databases shared with the integration.\nMatches against page and database titles.\nUse the 'filter' to return only pages or only databases.\nExample: {query: 'Roadmap', filter: {property: 'object', value: 'database'}}.\n",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1271 = [];
		               function input_schema_versioned$150(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1271[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bB3, bB2, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1271[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1271[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1271[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                           function(a){
		                            var
		                             default$ = match$892[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var filter_properties = param[2][1], page_id = param[1];
		                                 return cont([0, page_id, filter_properties]);
		                                },
		                                function(param, cont){
		                                 var filter_properties = param[2], page_id = param[1];
		                                 return cont([0, page_id, [0, filter_properties, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bB5,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_page_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bB4,
		                                   0,
		                                   0,
		                                   0,
		                                   "filter_properties",
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1271[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1271[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1231 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1271, [0, schematic_cache$1231]);
		               caml_callback
		                (input_schema_versioned$150, [function(param){return 0;}]);
		               function schematic_version$288(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$150, [schematic_version$288]),
		                action$161 =
		                  action$0
		                   ("6a1d85699c3c400e5b498938",
		                    "Get Page",
		                    "\nGet a page by ID. Returns its properties, not its content.\nUse 'Get Block Children' to fetch the page body.\nExample: {page_id: 'abc123'}.\n",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1272 = [];
		               function schema_versioned$575(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1272[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bB6, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1272[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1272[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1272[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$893[1],
		                             a =
		                               [0,
		                                [0,
		                                 bB7,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_database_id,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$894[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var database_id = param[2][1], page_id = param[1];
		   return cont([0, page_id, database_id]);
		  },
		  function(param, cont){
		   var database_id = param[2], page_id = param[1];
		   return cont([0, page_id, [0, database_id, 0]]);
		  },
		  [0,
		   [0,
		    bB8,
		    0,
		    0,
		    0,
		    cst_page_id,
		    0,
		    [0, default$],
		    [0, b],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1272[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1272[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1232 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1272, [0, schematic_cache$1232]);
		               caml_callback
		                (schema_versioned$575, [function(param){return 0;}]);
		               var cst_cover = "cover", letrec_function_context$1273 = [];
		               function input_schema_versioned$151(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1273[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bB9, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1273[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1273[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1273[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           json_object_schema,
		                           function(b){
		                            var
		                             default$ = match$895[1],
		                             a =
		                               [0,
		                                [0, bB_, 0, 0, 0, cst_cover, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     json_object_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$896[1],
		                                       default$0 = match$897[1],
		                                       b =
		 [0,
		  [0,
		   bCb,
		   0,
		   0,
		   0,
		   cst_properties,
		   0,
		   2,
		   [0, json_object_schema],
		   0,
		   0],
		  [0,
		   [0,
		    bCa,
		    0,
		    0,
		    0,
		    cst_children,
		    0,
		    [0, default$0],
		    [0, [0, 0, 0, [3, json_object_schema], 0]],
		    0,
		    0],
		   [0,
		    [0, bB$, 0, 0, 0, cst_icon, 0, [0, default$], [0, c], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$575,
		       schematic_version,
		       function(a){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              cover = c[2][1],
		              icon = c[1],
		              children = b[1],
		              properties = a[1],
		              parent = param[1];
		             return cont([0, parent, properties, children, icon, cover]);
		            },
		            function(param, cont){
		             var
		              cover = param[5],
		              icon = param[4],
		              children = param[3],
		              properties = param[2],
		              parent = param[1];
		             return cont
		                     ([0,
		                       parent,
		                       [0, properties, [0, children, [0, icon, [0, cover, 0]]]]]);
		            },
		            [0, [0, bCc, 0, 0, 0, cst_parent, 0, 2, [0, a], 0, 0], b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1273[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1273[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1233 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1273, [0, schematic_cache$1233]);
		               caml_callback
		                (input_schema_versioned$151, [function(param){return 0;}]);
		               function schematic_version$289(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$151, [schematic_version$289]),
		                action$162 =
		                  non_strict_action
		                   ("6a1d85699c3c400e5b49892b",
		                    "Create Page",
		                    "\nCreate a page as a child of a page or database.\nSet exactly one of parent.page_id or parent.database_id.\nFor a database parent, 'properties' keys must match the database schema (see 'Get Database').\nSee the Notion namespace docs for the properties and blocks JSON shape.\n",
		                    write$0(0, 0, 0),
		                    bY),
		                letrec_function_context$1274 = [];
		               function input_schema_versioned$152(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1274[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bCe, bCd, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1274[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1274[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1274[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$898[1],
		                             a =
		                               [0,
		                                [0,
		                                 bCf,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_archived,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     json_object_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$899[1],
		                                       b =
		 [0,
		  [0, bCg, 0, 0, 0, cst_cover, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       json_object_schema,
		       function(c){
		        var
		         default$ = match$900[1],
		         a =
		           [0,
		            [0, bCh, 0, 0, 0, cst_icon, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 json_object_schema,
		                 function(b){
		                  var
		                   default$ = match$901[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        archived = c[2][1],
		                        cover = c[1],
		                        icon = b[1],
		                        properties = a[1],
		                        page_id = param[1];
		                       return cont([0, page_id, properties, icon, cover, archived]);
		                      },
		                      function(param, cont){
		                       var
		                        archived = param[5],
		                        cover = param[4],
		                        icon = param[3],
		                        properties = param[2],
		                        page_id = param[1];
		                       return cont
		                               ([0,
		                                 page_id,
		                                 [0, properties, [0, icon, [0, cover, [0, archived, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bCj,
		                        0,
		                        0,
		                        0,
		                        cst_page_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bCi,
		                         0,
		                         0,
		                         0,
		                         cst_properties,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1274[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1274[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1234 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1274, [0, schematic_cache$1234]);
		               caml_callback
		                (input_schema_versioned$152, [function(param){return 0;}]);
		               function schematic_version$290(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$152, [schematic_version$290]),
		                action$163 =
		                  non_strict_action
		                   ("6a1d85699c3c400e5b498945",
		                    "Update Page",
		                    "\nUpdate page properties, icon, cover, or archived status.\nCannot change page content - use 'Append Block Children' for that.\nExample: {page_id: 'abc123', properties: {Status: {status: {name: 'Done'}}}}.\n",
		                    write$0(1, 1, 0),
		                    bY),
		                letrec_function_context$1275 = [];
		               function input_schema_versioned$153(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1275[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bCl, bCk, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1275[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1275[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1275[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var database_id = param[1];
		                       return cont([0, database_id]);
		                      },
		                      function(param, cont){
		                       var database_id = param[1];
		                       return cont([0, database_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bCm,
		                        0,
		                        0,
		                        0,
		                        cst_database_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1275[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1275[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1235 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1275, [0, schematic_cache$1235]);
		               caml_callback
		                (input_schema_versioned$153, [function(param){return 0;}]);
		               function schematic_version$291(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$153, [schematic_version$291]),
		                action$164 =
		                  action$0
		                   ("6a1d85699c3c400e5b498979",
		                    "Get Database",
		                    "\nGet a database by ID.\nReturns its property schema and metadata - read this before creating or updating\npages in the database so property keys and types match.\nExample: {database_id: 'db123'}.\n",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1276 = [];
		               function schema_versioned$576(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1276[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bCn, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1276[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1276[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1276[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$902[1],
		                             a =
		                               [0,
		                                [0,
		                                 bCo,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_direction,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$903[1],
		                                       b =
		 [0,
		  [0,
		   bCp,
		   0,
		   0,
		   0,
		   cst_timestamp,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$904[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              direction = a[2][1],
		              timestamp = a[1],
		              property = param[1];
		             return cont([0, property, timestamp, direction]);
		            },
		            function(param, cont){
		             var
		              direction = param[3],
		              timestamp = param[2],
		              property = param[1];
		             return cont
		                     ([0, property, [0, timestamp, [0, direction, 0]]]);
		            },
		            [0,
		             [0,
		              bCq,
		              0,
		              0,
		              0,
		              cst_property,
		              0,
		              [0, default$],
		              [0, a],
		              0,
		              0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1276[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1276[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1236 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1276, [0, schematic_cache$1236]);
		               caml_callback
		                (schema_versioned$576, [function(param){return 0;}]);
		               var letrec_function_context$1277 = [];
		               function input_schema_versioned$154(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1277[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bCr, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1277[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1277[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1277[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$905[1],
		                             a =
		                               [0,
		                                [0,
		                                 bCs,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_page_size,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$906[1],
		                                       b =
		 [0,
		  [0,
		   bCt,
		   0,
		   0,
		   0,
		   cst_start_cursor,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$576,
		       schematic_version,
		       function(c){
		        var
		         default$ = match$907[1],
		         a =
		           [0,
		            [0,
		             bCu,
		             0,
		             0,
		             0,
		             "sorts",
		             0,
		             [0, default$],
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 json_object_schema,
		                 function(b){
		                  var
		                   default$ = match$908[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        page_size = c[2][1],
		                        start_cursor = c[1],
		                        sorts = b[1],
		                        filter = a[1],
		                        database_id = param[1];
		                       return cont
		                               ([0, database_id, filter, sorts, start_cursor, page_size]);
		                      },
		                      function(param, cont){
		                       var
		                        page_size = param[5],
		                        start_cursor = param[4],
		                        sorts = param[3],
		                        filter = param[2],
		                        database_id = param[1];
		                       return cont
		                               ([0,
		                                 database_id,
		                                 [0,
		                                  filter,
		                                  [0, sorts, [0, start_cursor, [0, page_size, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bCw,
		                        0,
		                        0,
		                        0,
		                        cst_database_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bCv,
		                         0,
		                         0,
		                         0,
		                         cst_filter,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1277[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1277[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1237 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1277, [0, schematic_cache$1237]);
		               caml_callback
		                (input_schema_versioned$154, [function(param){return 0;}]);
		               function schematic_version$292(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$154, [schematic_version$292]),
		                action$165 =
		                  non_strict_action
		                   ("6a1d85699c3c400e5b498986",
		                    "Query Database",
		                    "\nQuery a database and return the pages that match.\nUse 'Get Database' first to learn the property names and types.\nSee the Notion filter reference for the 'filter' shape.\nExample: {database_id: 'db123', filter: {property: 'Status', status: {equals: 'Done'}}}.\n",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1278 = [];
		               function input_schema_versioned$155(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1278[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bCy, bCx, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1278[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1278[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1278[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$909[1],
		                             a =
		                               [0,
		                                [0,
		                                 bCz,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_page_size,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$910[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    page_size = a[2][1],
		    start_cursor = a[1],
		    block_id = param[1];
		   return cont([0, block_id, start_cursor, page_size]);
		  },
		  function(param, cont){
		   var
		    page_size = param[3],
		    start_cursor = param[2],
		    block_id = param[1];
		   return cont
		           ([0, block_id, [0, start_cursor, [0, page_size, 0]]]);
		  },
		  [0,
		   [0,
		    bCB,
		    0,
		    0,
		    0,
		    cst_block_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bCA,
		     0,
		     0,
		     0,
		     cst_start_cursor,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1278[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1278[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1238 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1278, [0, schematic_cache$1238]);
		               caml_callback
		                (input_schema_versioned$155, [function(param){return 0;}]);
		               function schematic_version$293(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$155, [schematic_version$293]),
		                action$166 =
		                  action$0
		                   ("6a1d85699c3c400e5b4989ba",
		                    "Get Block Children",
		                    "\nGet the children blocks of a page or block - this is how you read page content.\nPass a page ID as 'block_id' to read a whole page.\nExample: {block_id: 'abc123'}.\n",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1279 = [];
		               function input_schema_versioned$156(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1279[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bCD, bCC, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1279[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1279[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1279[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$911[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  after = a[2][1],
		                                  children = a[1],
		                                  block_id = param[1];
		                                 return cont([0, block_id, children, after]);
		                                },
		                                function(param, cont){
		                                 var
		                                  after = param[3],
		                                  children = param[2],
		                                  block_id = param[1];
		                                 return cont([0, block_id, [0, children, [0, after, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bCG,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_block_id,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bCF,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_children,
		                                   0,
		                                   2,
		                                   [0, [0, 0, 0, [3, json_object_schema], 0]],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0, bCE, 0, 0, 0, cst_after, 0, [0, default$], [0, a], 0, 0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1279[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1279[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1239 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1279, [0, schematic_cache$1239]);
		               caml_callback
		                (input_schema_versioned$156, [function(param){return 0;}]);
		               function schematic_version$294(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$156, [schematic_version$294]),
		                action$167 =
		                  non_strict_action
		                   ("6a1d85699c3c400e5b4989c7",
		                    "Append Block Children",
		                    "\nAppend blocks to a page or block - this is how you add content to a page.\nPass a page ID as 'block_id' to add content to a page.\nSee the Notion namespace docs for the block JSON shape.\nExample: {block_id: 'abc123', children: [{type: 'paragraph', paragraph: {rich_text: [{type: 'text', text: {content: 'Hello'}}]}}]}.\n",
		                    write$0(0, 0, 0),
		                    bY);
		               function iso_date_schema_versioned(schematic_version){
		                schematic_version(V$4);
		                return [0,
		                        bCI,
		                        bCH,
		                        schematic_param_name_schema_ve[3],
		                        schematic_param_name_schema_ve[4]];
		               }
		               var
		                schematic_cache$1240 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$1280 = [];
		               caml_update_dummy
		                (letrec_function_context$1280, [0, schematic_cache$1240]);
		               var schematic_schema_version$37 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$1280[1][1],
		                    schematic_schema_version$37]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$1280[1][1],
		                             schematic_schema_version$37,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$1280[1][1],
		schematic_schema_version$37,
		schematic_self,
		function(a){
		 letrec_function_context$1280[1][1] = a;
		 var
		  res =
		    [11,
		     0,
		     [0,
		      [0,
		       function(param, cont){return cont(0);},
		       function(param, cont){return param ? cont(0) : cont(bCM);},
		       0,
		       0,
		       cst_asc,
		       cst_Asc,
		       bCL,
		       0],
		      [0,
		       [0,
		        function(param, cont){return cont(1);},
		        function(param, cont){return param ? cont(bCK) : cont(0);},
		        0,
		        0,
		        cst_desc,
		        cst_Desc,
		        bCJ,
		        0],
		       0]],
		     0];
		 return caml_exact_trampoline_cps_call$0
		         (set$3,
		          letrec_function_context$1280[1][1],
		          schematic_schema_version$37,
		          res,
		          function(a){
		           letrec_function_context$1280[1][1] = a;
		           return cont(res);
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var letrec_function_context$1281 = [];
		               function deal_status_schema_versioned(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1281[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bCO, bCN, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1281[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1281[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1281[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bCY);},
		                        0,
		                        0,
		                        cst_open,
		                        cst_Open,
		                        bCX,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bCW) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_won,
		                         cst_Won,
		                         bCV,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bCU) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_lost,
		                          "Lost",
		                          bCT,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(bCS) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_deleted,
		                           cst_Deleted,
		                           bCR,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 <= param ? cont(bCQ) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_all_not_deleted,
		                            "All_not_deleted",
		                            bCP,
		                            0],
		                           0]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1281[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1281[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1241 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1281, [0, schematic_cache$1241]);
		               caml_callback
		                (deal_status_schema_versioned, [function(param){return 0;}]);
		               var
		                cst_filter_id = "filter_id",
		                letrec_function_context$1282 = [];
		               function input_schema_versioned$157(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1282[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bC0, bCZ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1282[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1282[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1282[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$912[1],
		                             a =
		                               [0,
		                                [0, bC1, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$913[1],
		                                       b =
		 [0,
		  [0, bC2, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       iso_date_schema_versioned(schematic_version),
		       function(c){
		        var
		         default$ = match$914[1],
		         a =
		           [0,
		            [0,
		             bC3,
		             0,
		             0,
		             0,
		             cst_end_date,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 iso_date_schema_versioned(schematic_version),
		                 function(c){
		                  var
		                   default$ = match$915[1],
		                   b =
		                     [0,
		                      [0,
		                       bC4,
		                       0,
		                       0,
		                       0,
		                       cst_start_date,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(c){
		                            var
		                             default$ = match$916[1],
		                             a =
		                               [0,
		                                [0, bC5, 0, 0, 0, cst_done, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$917[1],
		                                       b =
		 [0,
		  [0, bC6, 0, 0, 0, cst_type, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$918[1],
		         a =
		           [0,
		            [0,
		             bC7,
		             0,
		             0,
		             0,
		             cst_filter_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(b){
		                  var
		                   default$ = match$919[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        start = f[2][1],
		                        limit = f[1],
		                        end_date = e[1],
		                        start_date = d[1],
		                        done = c[1],
		                        type = b[1],
		                        filter_id = a[1],
		                        user_id = param[1];
		                       return cont
		                               ([0,
		                                 user_id,
		                                 filter_id,
		                                 type,
		                                 done,
		                                 start_date,
		                                 end_date,
		                                 limit,
		                                 start]);
		                      },
		                      function(param, cont){
		                       var
		                        start = param[8],
		                        limit = param[7],
		                        end_date = param[6],
		                        start_date = param[5],
		                        done = param[4],
		                        type = param[3],
		                        filter_id = param[2],
		                        user_id = param[1];
		                       return cont
		                               ([0,
		                                 user_id,
		                                 [0,
		                                  filter_id,
		                                  [0,
		                                   type,
		                                   [0,
		                                    done,
		                                    [0, start_date, [0, end_date, [0, limit, [0, start, 0]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bC8,
		                        0,
		                        0,
		                        0,
		                        cst_user_id,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1282[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1282[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1242 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1282, [0, schematic_cache$1242]);
		               caml_callback
		                (input_schema_versioned$157, [function(param){return 0;}]);
		               function schematic_version$295(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$157, [schematic_version$295]),
		                action$168 =
		                  action$0
		                   ("6a0d92dd9715bf95dafefb97",
		                    "List Activities",
		                    "List activities (calls, meetings, tasks, etc.) in Pipedrive.\nUse filters to narrow by owner, type, due date, or done state.\nExample: {connectionId: '...', input: {type: 'meeting', done: false}}",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1283 = [];
		               function input_schema_versioned$158(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1283[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bC_, bC9, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1283[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1283[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1283[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0, bC$, 0, 0, 0, cst_id, 0, 2, [0, int_schema], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1283[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1283[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1243 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1283, [0, schematic_cache$1243]);
		               caml_callback
		                (input_schema_versioned$158, [function(param){return 0;}]);
		               function schematic_version$296(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$158, [schematic_version$296]),
		                action$169 =
		                  action$0
		                   ("6a0d92dd9715bf95dafefb79",
		                    "Get Activity",
		                    "Get a specific activity by its Pipedrive ID.\nExample: {connectionId: '...', input: {id: 42}}",
		                    read$2(0),
		                    bY),
		                cst_deal_id = "deal_id",
		                cst_due_time = "due_time",
		                cst_person_id = "person_id",
		                letrec_function_context$1284 = [];
		               function input_schema_versioned$159(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1284[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bDb, bDa, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1284[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1284[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1284[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$920[1],
		                             a =
		                               [0,
		                                [0, bDc, 0, 0, 0, cst_done, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$921[1],
		                                       b =
		 [0,
		  [0, bDd, 0, 0, 0, cst_note, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$922[1],
		         a =
		           [0,
		            [0,
		             bDe,
		             0,
		             0,
		             0,
		             cst_user_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$923[1],
		                   b =
		                     [0,
		                      [0,
		                       bDf,
		                       0,
		                       0,
		                       0,
		                       cst_org_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$924[1],
		                             a =
		                               [0,
		                                [0,
		                                 bDg,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_person_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$925[1],
		                                       b =
		 [0,
		  [0,
		   bDh,
		   0,
		   0,
		   0,
		   cst_deal_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$926[1],
		         a =
		           [0,
		            [0,
		             bDi,
		             0,
		             0,
		             0,
		             cst_duration,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$927[1],
		                   b =
		                     [0,
		                      [0,
		                       bDj,
		                       0,
		                       0,
		                       0,
		                       cst_due_time,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           iso_date_schema_versioned(schematic_version),
		                           function(a){
		                            var
		                             default$ = match$928[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  e = d[2],
		                                  f = e[2],
		                                  g = f[2],
		                                  h = g[2],
		                                  i = h[2],
		                                  done = i[2][1],
		                                  note = i[1],
		                                  user_id = h[1],
		                                  org_id = g[1],
		                                  person_id = f[1],
		                                  deal_id = e[1],
		                                  duration = d[1],
		                                  due_time = c[1],
		                                  due_date = b[1],
		                                  type = a[1],
		                                  subject = param[1];
		                                 return cont
		 ([0,
		   subject,
		   type,
		   due_date,
		   due_time,
		   duration,
		   deal_id,
		   person_id,
		   org_id,
		   user_id,
		   note,
		   done]);
		                                },
		                                function(param, cont){
		                                 var
		                                  done = param[11],
		                                  note = param[10],
		                                  user_id = param[9],
		                                  org_id = param[8],
		                                  person_id = param[7],
		                                  deal_id = param[6],
		                                  duration = param[5],
		                                  due_time = param[4],
		                                  due_date = param[3],
		                                  type = param[2],
		                                  subject = param[1];
		                                 return cont
		 ([0,
		   subject,
		   [0,
		    type,
		    [0,
		     due_date,
		     [0,
		      due_time,
		      [0,
		       duration,
		       [0,
		        deal_id,
		        [0,
		         person_id,
		         [0, org_id, [0, user_id, [0, note, [0, done, 0]]]]]]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bDm,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_subject,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bDl,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_type,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bDk,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_due_date,
		                                    0,
		                                    [0, default$],
		                                    [0, a],
		                                    0,
		                                    0],
		                                   b]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1284[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1284[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1244 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1284, [0, schematic_cache$1244]);
		               caml_callback
		                (input_schema_versioned$159, [function(param){return 0;}]);
		               function schematic_version$297(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$159, [schematic_version$297]),
		                action$170 =
		                  action$0
		                   ("6a0d92dd9715bf95dafefba6",
		                    "Create Activity",
		                    "Create a new activity (call, meeting, task, etc.) in Pipedrive.\nLink it to a deal, person, or organization via the corresponding ID.\nExample: {connectionId: '...', input: {subject: 'Discovery call', type: 'call', due_date: '2026-05-20', due_time: '10:00', person_id: 123}}",
		                    write$0(0, 0, 0),
		                    bY),
		                letrec_function_context$1285 = [];
		               function input_schema_versioned$160(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1285[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bDo, bDn, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1285[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1285[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1285[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$929[1],
		                             a =
		                               [0,
		                                [0, bDp, 0, 0, 0, cst_done, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$930[1],
		                                       b =
		 [0,
		  [0, bDq, 0, 0, 0, cst_note, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$931[1],
		         a =
		           [0,
		            [0,
		             bDr,
		             0,
		             0,
		             0,
		             cst_user_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$932[1],
		                   b =
		                     [0,
		                      [0,
		                       bDs,
		                       0,
		                       0,
		                       0,
		                       cst_org_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$933[1],
		                             a =
		                               [0,
		                                [0,
		                                 bDt,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_person_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$934[1],
		                                       b =
		 [0,
		  [0,
		   bDu,
		   0,
		   0,
		   0,
		   cst_deal_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$935[1],
		         a =
		           [0,
		            [0,
		             bDv,
		             0,
		             0,
		             0,
		             cst_duration,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$936[1],
		                   b =
		                     [0,
		                      [0,
		                       bDw,
		                       0,
		                       0,
		                       0,
		                       cst_due_time,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           iso_date_schema_versioned(schematic_version),
		                           function(c){
		                            var
		                             default$ = match$937[1],
		                             a =
		                               [0,
		                                [0,
		                                 bDx,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_due_date,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$938[1],
		                                       b =
		 [0,
		  [0, bDy, 0, 0, 0, cst_type, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$939[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              i = h[2],
		              j = i[2],
		              done = j[2][1],
		              note = j[1],
		              user_id = i[1],
		              org_id = h[1],
		              person_id = g[1],
		              deal_id = f[1],
		              duration = e[1],
		              due_time = d[1],
		              due_date = c[1],
		              type = b[1],
		              subject = a[1],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       subject,
		                       type,
		                       due_date,
		                       due_time,
		                       duration,
		                       deal_id,
		                       person_id,
		                       org_id,
		                       user_id,
		                       note,
		                       done]);
		            },
		            function(param, cont){
		             var
		              done = param[12],
		              note = param[11],
		              user_id = param[10],
		              org_id = param[9],
		              person_id = param[8],
		              deal_id = param[7],
		              duration = param[6],
		              due_time = param[5],
		              due_date = param[4],
		              type = param[3],
		              subject = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        subject,
		                        [0,
		                         type,
		                         [0,
		                          due_date,
		                          [0,
		                           due_time,
		                           [0,
		                            duration,
		                            [0,
		                             deal_id,
		                             [0,
		                              person_id,
		                              [0, org_id, [0, user_id, [0, note, [0, done, 0]]]]]]]]]]]]);
		            },
		            [0,
		             [0, bDA, 0, 0, 0, cst_id, 0, 2, [0, int_schema], 0, 0],
		             [0,
		              [0,
		               bDz,
		               0,
		               0,
		               0,
		               cst_subject,
		               0,
		               [0, default$],
		               [0, a],
		               0,
		               0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1285[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1285[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1245 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1285, [0, schematic_cache$1245]);
		               caml_callback
		                (input_schema_versioned$160, [function(param){return 0;}]);
		               function schematic_version$298(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$160, [schematic_version$298]),
		                action$171 =
		                  action$0
		                   ("6a0d92dd9715bf95dafefbb5",
		                    "Update Activity",
		                    "Update an existing activity in Pipedrive.\nPass only the fields you want to change.\nUse done=true to mark complete.\nExample: {connectionId: '...', input: {id: 42, done: true, note: 'Followed up via email'}}",
		                    write$0(1, 1, 0),
		                    bY),
		                cst_exact_match = "exact_match",
		                cst_term = "term",
		                letrec_function_context$1286 = [];
		               function input_schema_versioned$161(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1286[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bDC, bDB, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1286[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1286[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1286[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$940[1],
		                             a =
		                               [0,
		                                [0, bDD, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$941[1],
		                                       b =
		 [0,
		  [0, bDE, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (deal_status_schema_versioned,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$942[1],
		                   a =
		                     [0,
		                      [0,
		                       bDF,
		                       0,
		                       0,
		                       0,
		                       cst_status,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$943[1],
		                             b =
		                               [0,
		                                [0,
		                                 bDG,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_organization_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$944[1],
		                                       a =
		 [0,
		  [0,
		   bDH,
		   0,
		   0,
		   0,
		   cst_person_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$945[1],
		         b =
		           [0,
		            [0,
		             bDI,
		             0,
		             0,
		             0,
		             cst_exact_match,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(a){
		                  var
		                   default$ = match$946[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        start = f[2][1],
		                        limit = f[1],
		                        status = e[1],
		                        organization_id = d[1],
		                        person_id = c[1],
		                        exact_match = b[1],
		                        fields = a[1],
		                        term = param[1];
		                       return cont
		                               ([0,
		                                 term,
		                                 fields,
		                                 exact_match,
		                                 person_id,
		                                 organization_id,
		                                 status,
		                                 limit,
		                                 start]);
		                      },
		                      function(param, cont){
		                       var
		                        start = param[8],
		                        limit = param[7],
		                        status = param[6],
		                        organization_id = param[5],
		                        person_id = param[4],
		                        exact_match = param[3],
		                        fields = param[2],
		                        term = param[1];
		                       return cont
		                               ([0,
		                                 term,
		                                 [0,
		                                  fields,
		                                  [0,
		                                   exact_match,
		                                   [0,
		                                    person_id,
		                                    [0, organization_id, [0, status, [0, limit, [0, start, 0]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bDK,
		                        0,
		                        0,
		                        0,
		                        cst_term,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bDJ,
		                         0,
		                         0,
		                         0,
		                         cst_fields,
		                         0,
		                         [0, default$],
		                         [0, a],
		                         0,
		                         0],
		                        b]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1286[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1286[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1246 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1286, [0, schematic_cache$1246]);
		               caml_callback
		                (input_schema_versioned$161, [function(param){return 0;}]);
		               function schematic_version$299(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$161, [schematic_version$299]),
		                action$172 =
		                  action$0
		                   ("6a0d92dc9715bf95dafefab6",
		                    b1,
		                    "Full-text search across deals in Pipedrive.\nReturns deals whose title, notes, or custom fields match the term.\nExample: {connectionId: '...', input: {term: 'Acme renewal', status: 'open'}}",
		                    read$2(0),
		                    bY),
		                cst_stage_id = "stage_id",
		                letrec_function_context$1287 = [];
		               function input_schema_versioned$162(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1287[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bDM, bDL, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1287[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1287[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1287[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$947[1],
		                             a =
		                               [0,
		                                [0, bDN, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$948[1],
		                                       b =
		 [0,
		  [0, bDO, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$949[1],
		         a =
		           [0,
		            [0, bDP, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (deal_status_schema_versioned,
		                 schematic_version,
		                 function(b){
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           b,
		                           function(c){
		                            var
		                             default$ = match$950[1],
		                             b =
		                               [0,
		                                [0,
		                                 bDQ,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_status,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$951[1],
		                                       a =
		 [0,
		  [0,
		   bDR,
		   0,
		   0,
		   0,
		   cst_stage_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$952[1],
		         b =
		           [0,
		            [0,
		             bDS,
		             0,
		             0,
		             0,
		             cst_filter_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(a){
		                  var
		                   default$ = match$953[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        start = e[2][1],
		                        limit = e[1],
		                        sort = d[1],
		                        status = c[1],
		                        stage_id = b[1],
		                        filter_id = a[1],
		                        user_id = param[1];
		                       return cont
		                               ([0,
		                                 user_id,
		                                 filter_id,
		                                 stage_id,
		                                 status,
		                                 sort,
		                                 limit,
		                                 start]);
		                      },
		                      function(param, cont){
		                       var
		                        start = param[7],
		                        limit = param[6],
		                        sort = param[5],
		                        status = param[4],
		                        stage_id = param[3],
		                        filter_id = param[2],
		                        user_id = param[1];
		                       return cont
		                               ([0,
		                                 user_id,
		                                 [0,
		                                  filter_id,
		                                  [0,
		                                   stage_id,
		                                   [0, status, [0, sort, [0, limit, [0, start, 0]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bDT,
		                        0,
		                        0,
		                        0,
		                        cst_user_id,
		                        0,
		                        [0, default$],
		                        [0, a],
		                        0,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1287[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1287[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1247 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1287, [0, schematic_cache$1247]);
		               caml_callback
		                (input_schema_versioned$162, [function(param){return 0;}]);
		               function schematic_version$300(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$162, [schematic_version$300]),
		                action$173 =
		                  action$0
		                   ("6a0d92dc9715bf95dafefa6b",
		                    b2,
		                    "List deals in Pipedrive with optional filtering by owner, stage, or\nstatus.\nPrefer \"Search Deals\" for keyword lookups.\nExample: {connectionId: '...', input: {status: 'open', stage_id: 3}}",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1288 = [];
		               function input_schema_versioned$163(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1288[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bDV, bDU, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1288[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1288[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1288[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0, bDW, 0, 0, 0, cst_id, 0, 2, [0, int_schema], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1288[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1288[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1248 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1288, [0, schematic_cache$1248]);
		               caml_callback
		                (input_schema_versioned$163, [function(param){return 0;}]);
		               function schematic_version$301(param){return 0;}
		               var
		                bY =
		                  caml_callback
		                   (input_schema_versioned$163, [schematic_version$301]),
		                action$174 =
		                  action$0
		                   ("6a0d92dc9715bf95dafefa7a",
		                    b5,
		                    "Get a specific deal by its Pipedrive ID.\nExample: {connectionId: '...', input: {id: 99}}",
		                    read$2(0),
		                    bY),
		                letrec_function_context$1289 = [];
		               function input_schema_versioned$164(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1289[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bDY, bDX, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1289[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1289[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1289[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           float_schema,
		                           function(b){
		                            var
		                             default$ = match$954[1],
		                             a =
		                               [0,
		                                [0,
		                                 bDZ,
		                                 0,
		                                 0,
		                                 0,
		                                 "probability",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     iso_date_schema_versioned(schematic_version),
		                                     function(c){
		                                      var
		                                       default$ = match$955[1],
		                                       b =
		 [0,
		  [0,
		   bD0,
		   0,
		   0,
		   0,
		   "expected_close_date",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (deal_status_schema_versioned,
		       schematic_version,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 a,
		                 function(c){
		                  var
		                   default$ = match$956[1],
		                   a =
		                     [0,
		                      [0,
		                       bD1,
		                       0,
		                       0,
		                       0,
		                       cst_status,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$957[1],
		                             b =
		                               [0,
		                                [0,
		                                 bD2,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_stage_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$958[1],
		                                       a =
		 [0,
		  [0,
		   bD3,
		   0,
		   0,
		   0,
		   cst_org_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$959[1],
		         b =
		           [0,
		            [0,
		             bD4,
		             0,
		             0,
		             0,
		             cst_person_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$960[1],
		                   a =
		                     [0,
		                      [0,
		                       bD5,
		                       0,
		                       0,
		                       0,
		                       cst_user_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      b];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$961[1],
		                             b =
		                               [0,
		                                [0,
		                                 bD6,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_currency,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     float_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$962[1],
		                                       a =
		 [0,
		  [0, bD7, 0, 0, 0, cst_value, 0, [0, default$], [0, c], 0, 0],
		  b];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(b){
		        var
		         default$ = match$963[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              d = c[2],
		              e = d[2],
		              f = e[2],
		              g = f[2],
		              h = g[2],
		              i = h[2],
		              probability = i[2][1],
		              expected_close_date = i[1],
		              status = h[1],
		              stage_id = g[1],
		              org_id = f[1],
		              person_id = e[1],
		              user_id = d[1],
		              currency = c[1],
		              value = b[1],
		              title = a[1],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       title,
		                       value,
		                       currency,
		                       user_id,
		                       person_id,
		                       org_id,
		                       stage_id,
		                       status,
		                       expected_close_date,
		                       probability]);
		            },
		            function(param, cont){
		             var
		              probability = param[11],
		              expected_close_date = param[10],
		              status = param[9],
		              stage_id = param[8],
		              org_id = param[7],
		              person_id = param[6],
		              user_id = param[5],
		              currency = param[4],
		              value = param[3],
		              title = param[2],
		              id = param[1];
		             return cont
		                     ([0,
		                       id,
		                       [0,
		                        title,
		                        [0,
		                         value,
		                         [0,
		                          currency,
		                          [0,
		                           user_id,
		                           [0,
		                            person_id,
		                            [0,
		                             org_id,
		                             [0,
		                              stage_id,
		                              [0, status, [0, expected_close_date, [0, probability, 0]]]]]]]]]]]);
		            },
		            [0,
		             [0, bD9, 0, 0, 0, cst_id, 0, 2, [0, int_schema], 0, 0],
		             [0,
		              [0, bD8, 0, 0, 0, cst_title, 0, [0, default$], [0, b], 0, 0],
		              a]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1289[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1289[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1249 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1289, [0, schematic_cache$1249]);
		               caml_callback
		                (input_schema_versioned$164, [function(param){return 0;}]);
		               function schematic_version$302(param){return 0;}
		               var
		                b5 =
		                  caml_callback
		                   (input_schema_versioned$164, [schematic_version$302]),
		                action$175 =
		                  action$0
		                   ("6a0d92dc9715bf95dafefa98",
		                    ca,
		                    "Update an existing deal in Pipedrive.\nPass only the fields you want to change.\nUse status='won' or 'lost' to close the deal.\nExample: {connectionId: '...', input: {id: 99, status: 'won', value: 25000, currency: 'USD'}}",
		                    write$0(1, 1, 0),
		                    b5),
		                letrec_function_context$1290 = [];
		               function input_schema_versioned$165(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1290[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bD$, bD_, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1290[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1290[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1290[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$964[1],
		                             a =
		                               [0,
		                                [0, bEa, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$965[1],
		                                       b =
		 [0,
		  [0, bEb, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$966[1],
		         a =
		           [0,
		            [0,
		             bEc,
		             0,
		             0,
		             0,
		             cst_organization_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$967[1],
		                   b =
		                     [0,
		                      [0,
		                       bEd,
		                       0,
		                       0,
		                       0,
		                       cst_exact_match,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$968[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  start = d[2][1],
		                                  limit = d[1],
		                                  organization_id = c[1],
		                                  exact_match = b[1],
		                                  fields = a[1],
		                                  term = param[1];
		                                 return cont
		 ([0,
		   term,
		   fields,
		   exact_match,
		   organization_id,
		   limit,
		   start]);
		                                },
		                                function(param, cont){
		                                 var
		                                  start = param[6],
		                                  limit = param[5],
		                                  organization_id = param[4],
		                                  exact_match = param[3],
		                                  fields = param[2],
		                                  term = param[1];
		                                 return cont
		 ([0,
		   term,
		   [0,
		    fields,
		    [0,
		     exact_match,
		     [0, organization_id, [0, limit, [0, start, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bEf,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_term,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bEe,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_fields,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1290[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1290[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1250 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1290, [0, schematic_cache$1250]);
		               caml_callback
		                (input_schema_versioned$165, [function(param){return 0;}]);
		               function schematic_version$303(param){return 0;}
		               var
		                b5 =
		                  caml_callback
		                   (input_schema_versioned$165, [schematic_version$303]),
		                action$176 =
		                  action$0
		                   ("6a0d92dd9715bf95dafefb10",
		                    "Search Persons",
		                    "Full-text search across persons (contacts) in Pipedrive.\nUseful for finding a contact by name, email, or phone.\nExample: {connectionId: '...', input: {term: 'jane@acme.com', exact_match: true}}",
		                    read$2(0),
		                    b5),
		                letrec_function_context$1291 = [];
		               function input_schema_versioned$166(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1291[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bEh, bEg, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1291[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1291[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1291[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0, bEi, 0, 0, 0, cst_id, 0, 2, [0, int_schema], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1291[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1291[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1251 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1291, [0, schematic_cache$1251]);
		               caml_callback
		                (input_schema_versioned$166, [function(param){return 0;}]);
		               function schematic_version$304(param){return 0;}
		               var
		                b5 =
		                  caml_callback
		                   (input_schema_versioned$166, [schematic_version$304]),
		                action$177 =
		                  action$0
		                   ("6a0d92dc9715bf95dafefad4",
		                    d,
		                    "Get a specific person (contact) by their Pipedrive ID.\nExample: {connectionId: '...', input: {id: 123}}",
		                    read$2(0),
		                    b5),
		                letrec_function_context$1292 = [];
		               function input_schema_versioned$167(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1292[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bEk, bEj, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1292[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1292[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1292[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$969[1],
		                             a =
		                               [0,
		                                [0, bEl, 0, 0, 0, cst_label, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$970[1],
		                                       b =
		 [0,
		  [0, bEm, 0, 0, 0, cst_phone, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$971[1],
		         a =
		           [0,
		            [0, bEn, 0, 0, 0, cst_email, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$972[1],
		                   b =
		                     [0,
		                      [0,
		                       bEo,
		                       0,
		                       0,
		                       0,
		                       cst_org_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$973[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  label = d[2][1],
		                                  phone = d[1],
		                                  email = c[1],
		                                  org_id = b[1],
		                                  owner_id = a[1],
		                                  name = param[1];
		                                 return cont
		 ([0, name, owner_id, org_id, email, phone, label]);
		                                },
		                                function(param, cont){
		                                 var
		                                  label = param[6],
		                                  phone = param[5],
		                                  email = param[4],
		                                  org_id = param[3],
		                                  owner_id = param[2],
		                                  name = param[1];
		                                 return cont
		 ([0,
		   name,
		   [0,
		    owner_id,
		    [0, org_id, [0, email, [0, phone, [0, label, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bEq,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_name,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bEp,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_owner_id,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1292[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1292[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1252 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1292, [0, schematic_cache$1252]);
		               caml_callback
		                (input_schema_versioned$167, [function(param){return 0;}]);
		               function schematic_version$305(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$167, [schematic_version$305]),
		                action$178 =
		                  action$0
		                   ("6a0d92dc9715bf95dafefae3",
		                    cf,
		                    "Create a new person (contact) in Pipedrive.\nProvide at least a name; email and phone are arrays where the first entry is the primary.\nExample: {connectionId: '...', input: {name: 'Jane Doe', email: ['jane@acme.com'], org_id: 7}}",
		                    write$0(0, 0, 0),
		                    d),
		                letrec_function_context$1293 = [];
		               function input_schema_versioned$168(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1293[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bEs, bEr, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1293[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1293[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1293[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$974[1],
		                             a =
		                               [0,
		                                [0, bEt, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$975[1],
		                                       b =
		 [0,
		  [0, bEu, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$976[1],
		         a =
		           [0,
		            [0,
		             bEv,
		             0,
		             0,
		             0,
		             cst_exact_match,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$977[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        start = c[2][1],
		                        limit = c[1],
		                        exact_match = b[1],
		                        fields = a[1],
		                        term = param[1];
		                       return cont([0, term, fields, exact_match, limit, start]);
		                      },
		                      function(param, cont){
		                       var
		                        start = param[5],
		                        limit = param[4],
		                        exact_match = param[3],
		                        fields = param[2],
		                        term = param[1];
		                       return cont
		                               ([0,
		                                 term,
		                                 [0, fields, [0, exact_match, [0, limit, [0, start, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bEx,
		                        0,
		                        0,
		                        0,
		                        cst_term,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bEw,
		                         0,
		                         0,
		                         0,
		                         cst_fields,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1293[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1293[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1253 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1293, [0, schematic_cache$1253]);
		               caml_callback
		                (input_schema_versioned$168, [function(param){return 0;}]);
		               function schematic_version$306(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$168, [schematic_version$306]),
		                action$179 =
		                  action$0
		                   ("6a0d92dd9715bf95dafefb6a",
		                    b4,
		                    "Full-text search across organizations (companies) in Pipedrive.\nExample: {connectionId: '...', input: {term: 'Acme Inc', exact_match: true}}",
		                    read$2(0),
		                    d),
		                letrec_function_context$1294 = [];
		               function input_schema_versioned$169(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1294[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bEz, bEy, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1294[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1294[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1294[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0, bEA, 0, 0, 0, cst_id, 0, 2, [0, int_schema], 0, 0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1294[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1294[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1254 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1294, [0, schematic_cache$1254]);
		               caml_callback
		                (input_schema_versioned$169, [function(param){return 0;}]);
		               function schematic_version$307(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$169, [schematic_version$307]),
		                action$180 =
		                  action$0
		                   ("6a0d92dd9715bf95dafefb2e",
		                    b$,
		                    "Get a specific organization (company) by its Pipedrive ID.\nExample: {connectionId: '...', input: {id: 7}}",
		                    read$2(0),
		                    d),
		                cst_lead_id = "lead_id",
		                letrec_function_context$1295 = [];
		               function input_schema_versioned$170(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1295[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bEC, bEB, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1295[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1295[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1295[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$978[1],
		                             a =
		                               [0,
		                                [0,
		                                 bED,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_user_id,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$979[1],
		                                       b =
		 [0,
		  [0,
		   bEE,
		   0,
		   0,
		   0,
		   cst_lead_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$980[1],
		         a =
		           [0,
		            [0,
		             bEF,
		             0,
		             0,
		             0,
		             cst_org_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$981[1],
		                   b =
		                     [0,
		                      [0,
		                       bEG,
		                       0,
		                       0,
		                       0,
		                       cst_person_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(a){
		                            var
		                             default$ = match$982[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  user_id = d[2][1],
		                                  lead_id = d[1],
		                                  org_id = c[1],
		                                  person_id = b[1],
		                                  deal_id = a[1],
		                                  content = param[1];
		                                 return cont
		 ([0, content, deal_id, person_id, org_id, lead_id, user_id]);
		                                },
		                                function(param, cont){
		                                 var
		                                  user_id = param[6],
		                                  lead_id = param[5],
		                                  org_id = param[4],
		                                  person_id = param[3],
		                                  deal_id = param[2],
		                                  content = param[1];
		                                 return cont
		 ([0,
		   content,
		   [0,
		    deal_id,
		    [0, person_id, [0, org_id, [0, lead_id, [0, user_id, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bEI,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_content,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bEH,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_deal_id,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1295[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1295[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1255 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1295, [0, schematic_cache$1255]);
		               caml_callback
		                (input_schema_versioned$170, [function(param){return 0;}]);
		               function schematic_version$308(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$170, [schematic_version$308]),
		                action$181 =
		                  action$0
		                   ("6a0d92de9715bf95dafefc37",
		                    ch,
		                    "Create a note attached to a deal, person, organization, or lead in\nPipedrive.\nAt least one of deal_id, person_id, org_id, or lead_id is required.\nExample: {connectionId: '...', input: {content: 'Customer prefers email follow-ups.', person_id: 123}}",
		                    write$0(0, 0, 0),
		                    d),
		                letrec_function_context$1296 = [];
		               function input_schema_versioned$171(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1296[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bEK, bEJ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1296[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1296[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1296[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$983[1],
		                             a =
		                               [0,
		                                [0, bEL, 0, 0, 0, cst_start, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$984[1],
		                                       b =
		 [0,
		  [0, bEM, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$985[1],
		         a =
		           [0,
		            [0, bEN, 0, 0, 0, cst_sort, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 iso_date_schema_versioned(schematic_version),
		                 function(c){
		                  var
		                   default$ = match$986[1],
		                   b =
		                     [0,
		                      [0,
		                       bEO,
		                       0,
		                       0,
		                       0,
		                       cst_end_date,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           iso_date_schema_versioned(schematic_version),
		                           function(c){
		                            var
		                             default$ = match$987[1],
		                             a =
		                               [0,
		                                [0,
		                                 bEP,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_start_date,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$988[1],
		                                       b =
		 [0,
		  [0,
		   bEQ,
		   0,
		   0,
		   0,
		   cst_lead_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$989[1],
		         a =
		           [0,
		            [0,
		             bER,
		             0,
		             0,
		             0,
		             cst_org_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 int_schema,
		                 function(c){
		                  var
		                   default$ = match$990[1],
		                   b =
		                     [0,
		                      [0,
		                       bES,
		                       0,
		                       0,
		                       0,
		                       cst_person_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(c){
		                            var
		                             default$ = match$991[1],
		                             a =
		                               [0,
		                                [0,
		                                 bET,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_deal_id,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(b){
		                                      var
		                                       default$ = match$992[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    start = h[2][1],
		    limit = h[1],
		    sort = g[1],
		    end_date = f[1],
		    start_date = e[1],
		    lead_id = d[1],
		    org_id = c[1],
		    person_id = b[1],
		    deal_id = a[1],
		    user_id = param[1];
		   return cont
		           ([0,
		             user_id,
		             deal_id,
		             person_id,
		             org_id,
		             lead_id,
		             start_date,
		             end_date,
		             sort,
		             limit,
		             start]);
		  },
		  function(param, cont){
		   var
		    start = param[10],
		    limit = param[9],
		    sort = param[8],
		    end_date = param[7],
		    start_date = param[6],
		    lead_id = param[5],
		    org_id = param[4],
		    person_id = param[3],
		    deal_id = param[2],
		    user_id = param[1];
		   return cont
		           ([0,
		             user_id,
		             [0,
		              deal_id,
		              [0,
		               person_id,
		               [0,
		                org_id,
		                [0,
		                 lead_id,
		                 [0,
		                  start_date,
		                  [0, end_date, [0, sort, [0, limit, [0, start, 0]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    bEU,
		    0,
		    0,
		    0,
		    cst_user_id,
		    0,
		    [0, default$],
		    [0, b],
		    0,
		    0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1296[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1296[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1256 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1296, [0, schematic_cache$1256]);
		               caml_callback
		                (input_schema_versioned$171, [function(param){return 0;}]);
		               function schematic_version$309(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$171, [schematic_version$309]),
		                action$182 =
		                  action$0
		                   ("6a0d92de9715bf95dafefc19",
		                    "List Notes",
		                    "List notes in Pipedrive with optional filtering by linked entity or\nauthor.\nExample: {connectionId: '...', input: {deal_id: 99, sort: 'update_time DESC'}}",
		                    read$2(0),
		                    d);
		               function pin(token_type){
		                var
		                 a = token_type ? cst_user : cst_bot,
		                 extra_input = [0, [0, "tokenType", [0, -976970511, a]], 0];
		                return function(tool){
		                 return [0,
		                         tool[1],
		                         tool[2],
		                         tool[3],
		                         tool[4],
		                         tool[5],
		                         tool[6],
		                         extra_input];};
		               }
		               var
		                as_bot = pin(0),
		                as_user = pin(1),
		                letrec_function_context$1297 = [];
		               function input_schema_versioned$172(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1297[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bEZ, bEY, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1297[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1297[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1297[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$993[1],
		                             a =
		                               [0,
		                                [0,
		                                 bE0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_cursor,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$994[1],
		                                       b =
		 [0,
		  [0, bE1, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$995[1],
		         a =
		           [0,
		            [0,
		             bE2,
		             0,
		             0,
		             0,
		             "exclude_archived",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$996[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        cursor = b[2][1],
		                        limit = b[1],
		                        exclude_archived = a[1],
		                        types = param[1];
		                       return cont([0, types, exclude_archived, limit, cursor]);
		                      },
		                      function(param, cont){
		                       var
		                        cursor = param[4],
		                        limit = param[3],
		                        exclude_archived = param[2],
		                        types = param[1];
		                       return cont
		                               ([0,
		                                 types,
		                                 [0, exclude_archived, [0, limit, [0, cursor, 0]]]]);
		                      },
		                      [0,
		                       [0, bE3, 0, 0, 0, cst_types, 0, [0, default$], [0, b], 0, 0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1297[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1297[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1257 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1297, [0, schematic_cache$1257]);
		               caml_callback
		                (input_schema_versioned$172, [function(param){return 0;}]);
		               function schematic_version$310(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$172, [schematic_version$310]),
		                action$183 =
		                  as_bot
		                   (action$0
		                     ("6a3e4868a21e498fa13a0bb7",
		                      "List Conversations",
		                      "\nLists all channels in a Slack team\n",
		                      read$2(0),
		                      d)),
		                letrec_function_context$1298 = [];
		               function input_schema_versioned$173(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1298[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bE5, bE4, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1298[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1298[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1298[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$997[1],
		                             a =
		                               [0,
		                                [0,
		                                 bE6,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_cursor,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$998[1],
		                                       b =
		 [0,
		  [0, bE7, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$999[1],
		         a =
		           [0,
		            [0,
		             bE8,
		             0,
		             0,
		             0,
		             "inclusive",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$1000[1],
		                   b =
		                     [0,
		                      [0, bE9, 0, 0, 0, "oldest", 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$1001[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  cursor = d[2][1],
		                                  limit = d[1],
		                                  inclusive = c[1],
		                                  oldest = b[1],
		                                  latest = a[1],
		                                  channel = param[1];
		                                 return cont
		 ([0, channel, latest, oldest, inclusive, limit, cursor]);
		                                },
		                                function(param, cont){
		                                 var
		                                  cursor = param[6],
		                                  limit = param[5],
		                                  inclusive = param[4],
		                                  oldest = param[3],
		                                  latest = param[2],
		                                  channel = param[1];
		                                 return cont
		 ([0,
		   channel,
		   [0,
		    latest,
		    [0, oldest, [0, inclusive, [0, limit, [0, cursor, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bE$,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_channel,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bE_,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_latest,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1298[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1298[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1258 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1298, [0, schematic_cache$1258]);
		               caml_callback
		                (input_schema_versioned$173, [function(param){return 0;}]);
		               function schematic_version$311(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$173, [schematic_version$311]),
		                action$184 =
		                  as_user
		                   (action$0
		                     ("6a3e4868a21e498fa13a0b90",
		                      "Get Conversation History",
		                      "\nFetches a conversation's history of messages and events\n",
		                      read$2(0),
		                      d)),
		                letrec_function_context$1299 = [];
		               function input_schema_versioned$174(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1299[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFb, bFa, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1299[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1299[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1299[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$1002[1],
		                             a =
		                               [0,
		                                [0, bFc, 0, 0, 0, "mrkdwn", 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$1003[1],
		                                       b =
		 [0,
		  [0,
		   bFd,
		   0,
		   0,
		   0,
		   "unfurl_media",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$1004[1],
		         a =
		           [0,
		            [0,
		             bFe,
		             0,
		             0,
		             0,
		             "unfurl_links",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$1005[1],
		                   b =
		                     [0,
		                      [0,
		                       bFf,
		                       0,
		                       0,
		                       0,
		                       "reply_broadcast",
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1006[1],
		                             a =
		                               [0,
		                                [0,
		                                 bFg,
		                                 0,
		                                 0,
		                                 0,
		                                 "thread_ts",
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, json_object_schema], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$1007[1],
		                                       b =
		 [0,
		  [0,
		   bFh,
		   0,
		   0,
		   0,
		   cst_attachments,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, json_object_schema], 0],
		       function(c){
		        var
		         default$ = match$1008[1],
		         a =
		           [0,
		            [0,
		             bFi,
		             0,
		             0,
		             0,
		             cst_blocks,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$1009[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        mrkdwn = g[2][1],
		                        unfurl_media = g[1],
		                        unfurl_links = f[1],
		                        reply_broadcast = e[1],
		                        thread_ts = d[1],
		                        attachments = c[1],
		                        blocks = b[1],
		                        text = a[1],
		                        channel = param[1];
		                       return cont
		                               ([0,
		                                 channel,
		                                 text,
		                                 blocks,
		                                 attachments,
		                                 thread_ts,
		                                 reply_broadcast,
		                                 unfurl_links,
		                                 unfurl_media,
		                                 mrkdwn]);
		                      },
		                      function(param, cont){
		                       var
		                        mrkdwn = param[9],
		                        unfurl_media = param[8],
		                        unfurl_links = param[7],
		                        reply_broadcast = param[6],
		                        thread_ts = param[5],
		                        attachments = param[4],
		                        blocks = param[3],
		                        text = param[2],
		                        channel = param[1];
		                       return cont
		                               ([0,
		                                 channel,
		                                 [0,
		                                  text,
		                                  [0,
		                                   blocks,
		                                   [0,
		                                    attachments,
		                                    [0,
		                                     thread_ts,
		                                     [0,
		                                      reply_broadcast,
		                                      [0, unfurl_links, [0, unfurl_media, [0, mrkdwn, 0]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bFk,
		                        0,
		                        0,
		                        0,
		                        cst_channel,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bFj, 0, 0, 0, cst_text, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1299[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1299[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1259 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1299, [0, schematic_cache$1259]);
		               caml_callback
		                (input_schema_versioned$174, [function(param){return 0;}]);
		               function schematic_version$312(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$174, [schematic_version$312]),
		                action$185 =
		                  as_bot
		                   (non_strict_action
		                     ("6a3e4869a21e498fa13a0bf8",
		                      "Post Message",
		                      '\nPost a message to a Slack channel or DM.\nUse channel ID or name (e.g. "#general").\nInclude thread_ts to reply in a thread.\nExample: {channel: "#general", text: "Hello!"}.\n',
		                      write$0(0, 0, 0),
		                      d)),
		                letrec_function_context$1300 = [];
		               function input_schema_versioned$175(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1300[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFm, bFl, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1300[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1300[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1300[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           [0, 0, 0, [3, json_object_schema], 0],
		                           function(b){
		                            var
		                             default$ = match$1010[1],
		                             a =
		                               [0,
		                                [0,
		                                 bFn,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_attachments,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, json_object_schema], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$1011[1],
		                                       b =
		 [0,
		  [0,
		   bFo,
		   0,
		   0,
		   0,
		   cst_blocks,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$1012[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              c = b[2],
		              attachments = c[2][1],
		              blocks = c[1],
		              text = b[1],
		              ts = a[1],
		              channel = param[1];
		             return cont([0, channel, ts, text, blocks, attachments]);
		            },
		            function(param, cont){
		             var
		              attachments = param[5],
		              blocks = param[4],
		              text = param[3],
		              ts = param[2],
		              channel = param[1];
		             return cont
		                     ([0,
		                       channel,
		                       [0, ts, [0, text, [0, blocks, [0, attachments, 0]]]]]);
		            },
		            [0,
		             [0,
		              bFr,
		              0,
		              0,
		              0,
		              cst_channel,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bFq,
		               0,
		               0,
		               0,
		               "ts",
		               0,
		               2,
		               [0, schematic_param_name_schema_ve],
		               0,
		               0],
		              [0,
		               [0, bFp, 0, 0, 0, cst_text, 0, [0, default$], [0, a], 0, 0],
		               b]]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1300[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1300[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1260 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1300, [0, schematic_cache$1260]);
		               caml_callback
		                (input_schema_versioned$175, [function(param){return 0;}]);
		               function schematic_version$313(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$175, [schematic_version$313]),
		                action$186 =
		                  as_bot
		                   (non_strict_action
		                     ("6a3e4869a21e498fa13a0beb",
		                      "Update Message",
		                      '\nUpdate the content of an existing Slack message.\nRequires channel ID and message timestamp (ts).\nExample: {channel: "C1234567890", ts: "1234567890.123456", text: "Updated text"}.\n',
		                      write$0(1, 1, 0),
		                      d)),
		                letrec_function_context$1301 = [];
		               function input_schema_versioned$176(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1301[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFt, bFs, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1301[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1301[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1301[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var message_ts = param[2][1], channel = param[1];
		                       return cont([0, channel, message_ts]);
		                      },
		                      function(param, cont){
		                       var message_ts = param[2], channel = param[1];
		                       return cont([0, channel, [0, message_ts, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bFv,
		                        0,
		                        0,
		                        0,
		                        cst_channel,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bFu,
		                         0,
		                         0,
		                         0,
		                         "message_ts",
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1301[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1301[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1261 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1301, [0, schematic_cache$1261]);
		               caml_callback
		                (input_schema_versioned$176, [function(param){return 0;}]);
		               function schematic_version$314(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$176, [schematic_version$314]),
		                action$187 =
		                  as_user
		                   (action$0
		                     ("6a3e4867a21e498fa13a0a72",
		                      "Get Message Permalink",
		                      '\nGet a permanent URL link to a specific Slack message.\nExample: {channel: "C1234567890", message_ts: "1234567890.123456"}.\n',
		                      read$2(0),
		                      d)),
		                letrec_function_context$1302 = [];
		               function input_schema_versioned$177(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1302[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFx, bFw, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1302[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1302[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1302[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        timestamp = a[2][1],
		                        channel = a[1],
		                        name = param[1];
		                       return cont([0, name, channel, timestamp]);
		                      },
		                      function(param, cont){
		                       var
		                        timestamp = param[3],
		                        channel = param[2],
		                        name = param[1];
		                       return cont([0, name, [0, channel, [0, timestamp, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        bFA,
		                        0,
		                        0,
		                        0,
		                        cst_name,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bFz,
		                         0,
		                         0,
		                         0,
		                         cst_channel,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          bFy,
		                          0,
		                          0,
		                          0,
		                          cst_timestamp,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1302[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1302[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1262 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1302, [0, schematic_cache$1262]);
		               caml_callback
		                (input_schema_versioned$177, [function(param){return 0;}]);
		               function schematic_version$315(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$177, [schematic_version$315]),
		                action$188 =
		                  as_user
		                   (action$0
		                     ("6a3e4868a21e498fa13a0af4",
		                      "Add Reaction",
		                      '\nAdd an emoji reaction to a Slack message.\nExample: {name: "thumbsup", channel: "C1234567890", timestamp: "1234567890.123456"}.\n',
		                      write$0(0, 1, 0),
		                      d)),
		                letrec_function_context$1303 = [];
		               function input_schema_versioned$178(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1303[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFC, bFB, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1303[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1303[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1303[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        name = a[2][1],
		                        timestamp = a[1],
		                        channel = param[1];
		                       return cont([0, channel, timestamp, name]);
		                      },
		                      function(param, cont){
		                       var
		                        name = param[3],
		                        timestamp = param[2],
		                        channel = param[1];
		                       return cont([0, channel, [0, timestamp, [0, name, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        bFF,
		                        0,
		                        0,
		                        0,
		                        cst_channel,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bFE,
		                         0,
		                         0,
		                         0,
		                         cst_timestamp,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          bFD,
		                          0,
		                          0,
		                          0,
		                          cst_name,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1303[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1303[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1263 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1303, [0, schematic_cache$1263]);
		               caml_callback
		                (input_schema_versioned$178, [function(param){return 0;}]);
		               function schematic_version$316(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$178, [schematic_version$316]),
		                action$189 =
		                  as_user
		                   (action$0
		                     ("6a3e4868a21e498fa13a0ae7",
		                      "Remove Reaction",
		                      '\nRemove an emoji reaction from a Slack message or file.\nExample: {name: "thumbsup", channel: "C1234567890", timestamp: "1234567890.123456"}.\n',
		                      write$0(1, 1, 0),
		                      d)),
		                schematic_cache$1264 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$1304 = [];
		               caml_update_dummy
		                (letrec_function_context$1304, [0, schematic_cache$1264]);
		               var schematic_schema_version$36 = 0;
		               if
		                (!
		                 caml_callback
		                  (find_packed_by_id,
		                   [letrec_function_context$1304[1][1],
		                    schematic_schema_version$36]))
		                caml_callback
		                 (fixpoint,
		                  [function(schematic_self, cont){
		                    return caml_exact_trampoline_cps_call$1
		                            (find_packed_by_id,
		                             letrec_function_context$1304[1][1],
		                             schematic_schema_version$36,
		                             function(match){
		                              if(! match)
		                               return caml_exact_trampoline_cps_call$0
		                                       (set$3,
		letrec_function_context$1304[1][1],
		schematic_schema_version$36,
		schematic_self,
		function(a){
		 letrec_function_context$1304[1][1] = a;
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          bool_schema,
		          function(b){
		           var
		            default$ = match$1013[1],
		            a =
		              [0,
		               [0, bFG, 0, 0, 0, cst_full, 0, [0, default$], [0, b], 0, 0],
		               0];
		           return caml_exact_trampoline_cps_call
		                   (option_schema,
		                    schematic_param_name_schema_ve,
		                    function(c){
		                     var
		                      default$ = match$1014[1],
		                      b =
		                        [0,
		                         [0,
		                          bFH,
		                          0,
		                          0,
		                          0,
		                          "file_comment",
		                          0,
		                          [0, default$],
		                          [0, c],
		                          0,
		                          0],
		                         a];
		                     return caml_exact_trampoline_cps_call
		                             (option_schema,
		                              schematic_param_name_schema_ve,
		                              function(c){
		                               var
		                                default$ = match$1015[1],
		                                a =
		                                  [0,
		                                   [0, bFI, 0, 0, 0, cst_file, 0, [0, default$], [0, c], 0, 0],
		                                   b];
		                               return caml_exact_trampoline_cps_call
		                                       (option_schema,
		schematic_param_name_schema_ve,
		function(c){
		 var
		  default$ = match$1016[1],
		  b =
		    [0,
		     [0,
		      bFJ,
		      0,
		      0,
		      0,
		      cst_timestamp,
		      0,
		      [0, default$],
		      [0, c],
		      0,
		      0],
		     a];
		 return caml_exact_trampoline_cps_call
		         (option_schema,
		          schematic_param_name_schema_ve,
		          function(a){
		           var
		            default$ = match$1017[1],
		            res =
		              [7,
		               function(param, cont){
		                var
		                 a = param[2],
		                 b = a[2],
		                 c = b[2],
		                 full = c[2][1],
		                 file_comment = c[1],
		                 file = b[1],
		                 timestamp = a[1],
		                 channel = param[1];
		                return cont
		                        ([0, channel, timestamp, file, file_comment, full]);
		               },
		               function(param, cont){
		                var
		                 full = param[5],
		                 file_comment = param[4],
		                 file = param[3],
		                 timestamp = param[2],
		                 channel = param[1];
		                return cont
		                        ([0,
		                          channel,
		                          [0, timestamp, [0, file, [0, file_comment, [0, full, 0]]]]]);
		               },
		               [0,
		                [0,
		                 bFK,
		                 0,
		                 0,
		                 0,
		                 cst_channel,
		                 0,
		                 [0, default$],
		                 [0, a],
		                 0,
		                 0],
		                b]];
		           return caml_exact_trampoline_cps_call$0
		                   (set$3,
		                    letrec_function_context$1304[1][1],
		                    schematic_schema_version$36,
		                    res,
		                    function(a){
		                     letrec_function_context$1304[1][1] = a;
		                     return cont(res);
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              var schema = match[1];
		                              return cont(schema);
		                             });
		                   }]);
		               var
		                cst_include_locale = "include_locale",
		                letrec_function_context$1305 = [];
		               function input_schema_versioned$179(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1305[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFM, bFL, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1305[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1305[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1305[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(a){
		                            var
		                             default$ = match$1018[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var include_locale = param[2][1], user = param[1];
		                                 return cont([0, user, include_locale]);
		                                },
		                                function(param, cont){
		                                 var include_locale = param[2], user = param[1];
		                                 return cont([0, user, [0, include_locale, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bFO,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_user,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bFN,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_include_locale,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1305[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1305[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1265 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1305, [0, schematic_cache$1265]);
		               caml_callback
		                (input_schema_versioned$179, [function(param){return 0;}]);
		               function schematic_version$317(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$179, [schematic_version$317]),
		                action$190 =
		                  as_bot
		                   (action$0
		                     ("6a3e4868a21e498fa13a0b0e",
		                      "Get User Info",
		                      '\nGet profile information for a Slack user by ID.\nExample: {user: "U1234567890"}.\n',
		                      read$2(0),
		                      d)),
		                letrec_function_context$1306 = [];
		               function input_schema_versioned$180(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1306[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFQ, bFP, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1306[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1306[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1306[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$1019[1],
		                             a =
		                               [0,
		                                [0,
		                                 bFR,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_include_locale,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1020[1],
		                                       b =
		 [0,
		  [0,
		   bFS,
		   0,
		   0,
		   0,
		   cst_cursor,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(a){
		        var
		         default$ = match$1021[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              include_locale = a[2][1],
		              cursor = a[1],
		              limit = param[1];
		             return cont([0, limit, cursor, include_locale]);
		            },
		            function(param, cont){
		             var
		              include_locale = param[3],
		              cursor = param[2],
		              limit = param[1];
		             return cont([0, limit, [0, cursor, [0, include_locale, 0]]]);
		            },
		            [0,
		             [0, bFT, 0, 0, 0, cst_limit, 0, [0, default$], [0, a], 0, 0],
		             b]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1306[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1306[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1266 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1306, [0, schematic_cache$1266]);
		               caml_callback
		                (input_schema_versioned$180, [function(param){return 0;}]);
		               function schematic_version$318(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$180, [schematic_version$318]),
		                action$191 =
		                  as_bot
		                   (action$0
		                     ("6a3e4868a21e498fa13a0b1b",
		                      b0,
		                      "\nList all users in the Slack workspace.\nSupports pagination via cursor.\nExample: {limit: 200}.\n",
		                      read$2(0),
		                      d));
		               function datetime_schema_versioned$0(schematic_version){
		                schematic_version(V$4);
		                return [0,
		                        bFV,
		                        bFU,
		                        schematic_param_name_schema_ve[3],
		                        schematic_param_name_schema_ve[4]];
		               }
		               var
		                d =
		                  [0,
		                   bFX,
		                   bFW,
		                   schematic_param_a_schema_versi[3],
		                   schematic_param_a_schema_versi[4]],
		                action$192 =
		                  action$0
		                   ("6aa2fc615e114695abe63250",
		                    "Get User Projects",
		                    "Get all user projects (lists) in TickTick.\nReturns an array of project objects. Always use this to find the correct projectId before creating or listing tasks.\nExample: {connectionId: '...'}",
		                    read$2(0),
		                    d),
		                letrec_function_context$1307 = [];
		               function input_schema_versioned$181(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1307[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bFZ, bFY, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1307[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1307[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1307[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1022[1],
		                             a =
		                               [0,
		                                [0, bF0, 0, 0, 0, cst_kind, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1023[1],
		                                       b =
		 [0,
		  [0,
		   bF1,
		   0,
		   0,
		   0,
		   "viewMode",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$1024[1],
		         a =
		           [0,
		            [0,
		             bF2,
		             0,
		             0,
		             0,
		             cst_sortOrder,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$1025[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        kind = c[2][1],
		                        view_mode = c[1],
		                        sort_order = b[1],
		                        color = a[1],
		                        name = param[1];
		                       return cont([0, name, color, sort_order, view_mode, kind]);
		                      },
		                      function(param, cont){
		                       var
		                        kind = param[5],
		                        view_mode = param[4],
		                        sort_order = param[3],
		                        color = param[2],
		                        name = param[1];
		                       return cont
		                               ([0,
		                                 name,
		                                 [0, color, [0, sort_order, [0, view_mode, [0, kind, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bF4,
		                        0,
		                        0,
		                        0,
		                        cst_name,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bF3, 0, 0, 0, cst_color, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1307[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1307[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1267 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1307, [0, schematic_cache$1267]);
		               caml_callback
		                (input_schema_versioned$181, [function(param){return 0;}]);
		               function schematic_version$319(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$181, [schematic_version$319]),
		                action$193 =
		                  action$0
		                   ("6aa7f5a7df69df9314c2f250",
		                    bO9,
		                    "Create a new project (list) in TickTick.\nExample: {connectionId: '...', input: {name: 'Work', viewMode: 'list'}}",
		                    write$0(0, 0, 0),
		                    d),
		                letrec_function_context$1308 = [];
		               function input_schema_versioned$182(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1308[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bF6, bF5, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1308[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1308[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1308[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var project_id = param[1];
		                       return cont([0, project_id]);
		                      },
		                      function(param, cont){
		                       var project_id = param[1];
		                       return cont([0, project_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bF7,
		                        0,
		                        0,
		                        0,
		                        cst_projectId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1308[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1308[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1268 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1308, [0, schematic_cache$1268]);
		               caml_callback
		                (input_schema_versioned$182, [function(param){return 0;}]);
		               function schematic_version$320(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$182, [schematic_version$320]),
		                action$194 =
		                  action$0
		                   ("6aa7f499bb76927a509dce91",
		                    "List Undone Tasks",
		                    "List all undone tasks within a specific project in TickTick.\nRequires a projectId.\nExample: {connectionId: '...', input: {projectId: '62f1a3b5e4b0...'}}",
		                    read$2(0),
		                    d),
		                letrec_function_context$1309 = [];
		               function input_schema_versioned$183(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1309[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bF9, bF8, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1309[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1309[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1309[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           datetime_schema_versioned$0(schematic_version),
		                           function(b){
		                            var
		                             default$ = match$1026[1],
		                             a =
		                               [0,
		                                [0,
		                                 bF_,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_dueDate,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     datetime_schema_versioned$0(schematic_version),
		                                     function(c){
		                                      var
		                                       default$ = match$1027[1],
		                                       b =
		 [0,
		  [0,
		   bF$,
		   0,
		   0,
		   0,
		   cst_startDate,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       bool_schema,
		       function(c){
		        var
		         default$ = match$1028[1],
		         a =
		           [0,
		            [0,
		             bGa,
		             0,
		             0,
		             0,
		             "isAllDay",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$1029[1],
		                   b =
		                     [0,
		                      [0,
		                       bGb,
		                       0,
		                       0,
		                       0,
		                       cst_projectId,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$1030[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  d = c[2],
		                                  due_date = d[2][1],
		                                  start_date = d[1],
		                                  is_all_day = c[1],
		                                  project_id = b[1],
		                                  content = a[1],
		                                  title = param[1];
		                                 return cont
		 ([0,
		   title,
		   content,
		   project_id,
		   is_all_day,
		   start_date,
		   due_date]);
		                                },
		                                function(param, cont){
		                                 var
		                                  due_date = param[6],
		                                  start_date = param[5],
		                                  is_all_day = param[4],
		                                  project_id = param[3],
		                                  content = param[2],
		                                  title = param[1];
		                                 return cont
		 ([0,
		   title,
		   [0,
		    content,
		    [0,
		     project_id,
		     [0, is_all_day, [0, start_date, [0, due_date, 0]]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bGd,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_title,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bGc,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_content,
		                                   0,
		                                   [0, default$],
		                                   [0, a],
		                                   0,
		                                   0],
		                                  b]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1309[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1309[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1269 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1309, [0, schematic_cache$1269]);
		               caml_callback
		                (input_schema_versioned$183, [function(param){return 0;}]);
		               function schematic_version$321(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$183, [schematic_version$321]),
		                action$195 =
		                  action$0
		                   ("6aa2f39525ccfe3f3562bc0a",
		                    z,
		                    "Create a new task in TickTick.\nCan be assigned to a specific projectId and have due dates.\nExample: {connectionId: '...', input: {title: 'Buy milk', projectId: '62f1...v'}}",
		                    write$0(0, 0, 0),
		                    d),
		                letrec_function_context$1310 = [];
		               function input_schema_versioned$184(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1310[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGf, bGe, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1310[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1310[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1310[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1031[1],
		                             a =
		                               [0,
		                                [0,
		                                 bGg,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_content,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1032[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    content = b[2][1],
		    title = b[1],
		    project_id = a[1],
		    id = param[1];
		   return cont([0, id, project_id, title, content]);
		  },
		  function(param, cont){
		   var
		    content = param[4],
		    title = param[3],
		    project_id = param[2],
		    id = param[1];
		   return cont
		           ([0, id, [0, project_id, [0, title, [0, content, 0]]]]);
		  },
		  [0,
		   [0,
		    bGj,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bGi,
		     0,
		     0,
		     0,
		     cst_projectId,
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0, bGh, 0, 0, 0, cst_title, 0, [0, default$], [0, b], 0, 0],
		     a]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1310[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1310[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1270 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1310, [0, schematic_cache$1270]);
		               caml_callback
		                (input_schema_versioned$184, [function(param){return 0;}]);
		               function schematic_version$322(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$184, [schematic_version$322]),
		                action$196 =
		                  action$0
		                   ("6aa7f26b865fc569c6a608bd",
		                    bU,
		                    "Update an existing task in TickTick.\nBoth id and projectId are required to locate the task.\nExample: {connectionId: '...', input: {id: '5f48...', projectId: '62f1...', title: 'Buy almond milk'}}",
		                    write$0(1, 1, 0),
		                    d),
		                letrec_function_context$1311 = [];
		               function input_schema_versioned$185(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1311[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGl, bGk, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1311[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1311[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1311[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var task_id = param[2][1], project_id = param[1];
		                       return cont([0, project_id, task_id]);
		                      },
		                      function(param, cont){
		                       var task_id = param[2], project_id = param[1];
		                       return cont([0, project_id, [0, task_id, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bGn,
		                        0,
		                        0,
		                        0,
		                        cst_projectId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bGm,
		                         0,
		                         0,
		                         0,
		                         cst_taskId,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1311[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1311[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1271 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1311, [0, schematic_cache$1271]);
		               caml_callback
		                (input_schema_versioned$185, [function(param){return 0;}]);
		               function schematic_version$323(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$185, [schematic_version$323]),
		                action$197 =
		                  action$0
		                   ("6aa7f3594aaf60baa0b8673b",
		                    b_,
		                    "Mark a specific task as complete in TickTick.\nBoth projectId and taskId are required.\nExample: {connectionId: '...', input: {projectId: '62f1...', taskId: '5f48...'}}",
		                    write$0(1, 1, 0),
		                    d),
		                cst_section_id = "section_id",
		                letrec_function_context$1312 = [];
		               function input_schema_versioned$186(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1312[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGo, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1312[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1312[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1312[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1033[1],
		                             a =
		                               [0,
		                                [0, bGp, 0, 0, 0, cst_ids, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1034[1],
		                                       b =
		 [0,
		  [0,
		   bGq,
		   0,
		   0,
		   0,
		   cst_filter,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1035[1],
		         a =
		           [0,
		            [0, bGr, 0, 0, 0, cst_label, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$1036[1],
		                   b =
		                     [0,
		                      [0,
		                       bGs,
		                       0,
		                       0,
		                       0,
		                       cst_section_id,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$1037[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  b = a[2],
		                                  c = b[2],
		                                  ids = c[2][1],
		                                  filter = c[1],
		                                  label = b[1],
		                                  section_id = a[1],
		                                  project_id = param[1];
		                                 return cont([0, project_id, section_id, label, filter, ids]);
		                                },
		                                function(param, cont){
		                                 var
		                                  ids = param[5],
		                                  filter = param[4],
		                                  label = param[3],
		                                  section_id = param[2],
		                                  project_id = param[1];
		                                 return cont
		 ([0,
		   project_id,
		   [0, section_id, [0, label, [0, filter, [0, ids, 0]]]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bGt,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_project_id,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 b]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1312[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1312[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1272 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1312, [0, schematic_cache$1272]);
		               caml_callback
		                (input_schema_versioned$186, [function(param){return 0;}]);
		               function schematic_version$324(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$186, [schematic_version$324]),
		                action$198 =
		                  action$0
		                   ("6a2fbd33b747e41145fbbc90",
		                    cg,
		                    "\nList Todoist tasks. All filters are optional.\nExample: {project_id: '123'} or {filter: 'today'} or {label: 'work'}.\n",
		                    read$2(0),
		                    d),
		                letrec_function_context$1313 = [];
		               function input_schema_versioned$187(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1313[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGu, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1313[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1313[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1313[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId]);
		                      },
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bGv,
		                        0,
		                        0,
		                        0,
		                        cst_taskId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1313[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1313[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1273 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1313, [0, schematic_cache$1273]);
		               caml_callback
		                (input_schema_versioned$187, [function(param){return 0;}]);
		               function schematic_version$325(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$187, [schematic_version$325]),
		                action$199 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbc9d",
		                    h,
		                    "\nGet a Todoist task by ID.\nExample: {taskId: '123'}.\n",
		                    read$2(0),
		                    d),
		                cst_due_datetime = "due_datetime",
		                cst_due_string = "due_string",
		                cst_duration_unit = "duration_unit",
		                letrec_function_context$1314 = [];
		               function input_schema_versioned$188(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1314[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGw, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1314[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1314[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1314[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1038[1],
		                             a =
		                               [0,
		                                [0,
		                                 bGx,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_duration_unit,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$1039[1],
		                                       b =
		 [0,
		  [0,
		   bGy,
		   0,
		   0,
		   0,
		   cst_duration,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1040[1],
		         a =
		           [0,
		            [0,
		             bGz,
		             0,
		             0,
		             0,
		             cst_assignee_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$1041[1],
		                   b =
		                     [0,
		                      [0,
		                       bGA,
		                       0,
		                       0,
		                       0,
		                       cst_due_datetime,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1042[1],
		                             a =
		                               [0,
		                                [0,
		                                 bGB,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_due_date,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1043[1],
		                                       b =
		 [0,
		  [0,
		   bGC,
		   0,
		   0,
		   0,
		   cst_due_string,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$1044[1],
		         a =
		           [0,
		            [0,
		             bGD,
		             0,
		             0,
		             0,
		             cst_priority,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(c){
		                  var
		                   default$ = match$1045[1],
		                   b =
		                     [0,
		                      [0,
		                       bGE,
		                       0,
		                       0,
		                       0,
		                       cst_labels,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1046[1],
		                             a =
		                               [0,
		                                [0,
		                                 bGF,
		                                 0,
		                                 0,
		                                 0,
		                                 "parent_id",
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1047[1],
		                                       b =
		 [0,
		  [0,
		   bGG,
		   0,
		   0,
		   0,
		   cst_section_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1048[1],
		         a =
		           [0,
		            [0,
		             bGH,
		             0,
		             0,
		             0,
		             cst_project_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$1049[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        h = g[2],
		                        i = h[2],
		                        j = i[2],
		                        k = j[2],
		                        duration_unit = k[2][1],
		                        duration = k[1],
		                        assignee_id = j[1],
		                        due_datetime = i[1],
		                        due_date = h[1],
		                        due_string = g[1],
		                        priority = f[1],
		                        labels = e[1],
		                        parent_id = d[1],
		                        section_id = c[1],
		                        project_id = b[1],
		                        description = a[1],
		                        content = param[1];
		                       return cont
		                               ([0,
		                                 content,
		                                 description,
		                                 project_id,
		                                 section_id,
		                                 parent_id,
		                                 labels,
		                                 priority,
		                                 due_string,
		                                 due_date,
		                                 due_datetime,
		                                 assignee_id,
		                                 duration,
		                                 duration_unit]);
		                      },
		                      function(param, cont){
		                       var
		                        duration_unit = param[13],
		                        duration = param[12],
		                        assignee_id = param[11],
		                        due_datetime = param[10],
		                        due_date = param[9],
		                        due_string = param[8],
		                        priority = param[7],
		                        labels = param[6],
		                        parent_id = param[5],
		                        section_id = param[4],
		                        project_id = param[3],
		                        description = param[2],
		                        content = param[1];
		                       return cont
		                               ([0,
		                                 content,
		                                 [0,
		                                  description,
		                                  [0,
		                                   project_id,
		                                   [0,
		                                    section_id,
		                                    [0,
		                                     parent_id,
		                                     [0,
		                                      labels,
		                                      [0,
		                                       priority,
		                                       [0,
		due_string,
		[0,
		 due_date,
		 [0,
		  due_datetime,
		  [0, assignee_id, [0, duration, [0, duration_unit, 0]]]]]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bGJ,
		                        0,
		                        0,
		                        0,
		                        cst_content,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bGI,
		                         0,
		                         0,
		                         0,
		                         cst_description,
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1314[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1314[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1274 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1314, [0, schematic_cache$1274]);
		               caml_callback
		                (input_schema_versioned$188, [function(param){return 0;}]);
		               function schematic_version$326(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$188, [schematic_version$326]),
		                action$200 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbcaa",
		                    z,
		                    "\nCreate a new Todoist task.\nExample: {content: 'Buy milk', due_string: 'tomorrow', priority: 2}.\n",
		                    write$0(0, 0, 0),
		                    d),
		                letrec_function_context$1315 = [];
		               function input_schema_versioned$189(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1315[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGK, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1315[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1315[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1315[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1050[1],
		                             a =
		                               [0,
		                                [0,
		                                 bGL,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_duration_unit,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$1051[1],
		                                       b =
		 [0,
		  [0,
		   bGM,
		   0,
		   0,
		   0,
		   cst_duration,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1052[1],
		         a =
		           [0,
		            [0,
		             bGN,
		             0,
		             0,
		             0,
		             cst_assignee_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$1053[1],
		                   b =
		                     [0,
		                      [0,
		                       bGO,
		                       0,
		                       0,
		                       0,
		                       cst_due_datetime,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1054[1],
		                             a =
		                               [0,
		                                [0,
		                                 bGP,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_due_date,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1055[1],
		                                       b =
		 [0,
		  [0,
		   bGQ,
		   0,
		   0,
		   0,
		   cst_due_string,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       int_schema,
		       function(c){
		        var
		         default$ = match$1056[1],
		         a =
		           [0,
		            [0,
		             bGR,
		             0,
		             0,
		             0,
		             cst_priority,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                 function(c){
		                  var
		                   default$ = match$1057[1],
		                   b =
		                     [0,
		                      [0,
		                       bGS,
		                       0,
		                       0,
		                       0,
		                       cst_labels,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1058[1],
		                             a =
		                               [0,
		                                [0,
		                                 bGT,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_description,
		                                 0,
		                                 [0, default$],
		                                 [0, c],
		                                 0,
		                                 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1059[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    duration_unit = i[2][1],
		    duration = i[1],
		    assignee_id = h[1],
		    due_datetime = g[1],
		    due_date = f[1],
		    due_string = e[1],
		    priority = d[1],
		    labels = c[1],
		    description = b[1],
		    content = a[1],
		    taskId = param[1];
		   return cont
		           ([0,
		             taskId,
		             content,
		             description,
		             labels,
		             priority,
		             due_string,
		             due_date,
		             due_datetime,
		             assignee_id,
		             duration,
		             duration_unit]);
		  },
		  function(param, cont){
		   var
		    duration_unit = param[11],
		    duration = param[10],
		    assignee_id = param[9],
		    due_datetime = param[8],
		    due_date = param[7],
		    due_string = param[6],
		    priority = param[5],
		    labels = param[4],
		    description = param[3],
		    content = param[2],
		    taskId = param[1];
		   return cont
		           ([0,
		             taskId,
		             [0,
		              content,
		              [0,
		               description,
		               [0,
		                labels,
		                [0,
		                 priority,
		                 [0,
		                  due_string,
		                  [0,
		                   due_date,
		                   [0,
		                    due_datetime,
		                    [0, assignee_id, [0, duration, [0, duration_unit, 0]]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    bGV,
		    0,
		    0,
		    0,
		    cst_taskId,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bGU,
		     0,
		     0,
		     0,
		     cst_content,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1315[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1315[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1275 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1315, [0, schematic_cache$1275]);
		               caml_callback
		                (input_schema_versioned$189, [function(param){return 0;}]);
		               function schematic_version$327(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$189, [schematic_version$327]),
		                action$201 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbcb7",
		                    bU,
		                    "\nUpdate an existing Todoist task. Only provided fields are changed.\nExample: {taskId: '123', content: 'New title', priority: 4}.\n",
		                    write$0(1, 1, 0),
		                    d),
		                letrec_function_context$1316 = [];
		               function input_schema_versioned$190(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1316[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGW, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1316[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1316[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1316[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId]);
		                      },
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bGX,
		                        0,
		                        0,
		                        0,
		                        cst_taskId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1316[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1316[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1276 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1316, [0, schematic_cache$1276]);
		               caml_callback
		                (input_schema_versioned$190, [function(param){return 0;}]);
		               function schematic_version$328(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$190, [schematic_version$328]),
		                action$202 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbcd1",
		                    "Close Task",
		                    "\nMark a Todoist task as completed.\nExample: {taskId: '123'}.\n",
		                    write$0(1, 1, 0),
		                    d),
		                letrec_function_context$1317 = [];
		               function input_schema_versioned$191(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1317[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bGY, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1317[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1317[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1317[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId]);
		                      },
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bGZ,
		                        0,
		                        0,
		                        0,
		                        cst_taskId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1317[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1317[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1277 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1317, [0, schematic_cache$1277]);
		               caml_callback
		                (input_schema_versioned$191, [function(param){return 0;}]);
		               function schematic_version$329(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$191, [schematic_version$329]),
		                action$203 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbcd9",
		                    "Reopen Task",
		                    "\nReopen a completed Todoist task.\nExample: {taskId: '123'}.\n",
		                    write$0(1, 1, 0),
		                    d),
		                letrec_function_context$1318 = [];
		               function input_schema_versioned$192(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1318[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bG0, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1318[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1318[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1318[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId]);
		                      },
		                      function(param, cont){
		                       var taskId = param[1];
		                       return cont([0, taskId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bG1,
		                        0,
		                        0,
		                        0,
		                        cst_taskId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1318[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1318[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1278 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1318, [0, schematic_cache$1278]);
		               caml_callback
		                (input_schema_versioned$192, [function(param){return 0;}]);
		               function schematic_version$330(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$192, [schematic_version$330]),
		                action$204 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbcc4",
		                    bZ,
		                    "\nPermanently delete a Todoist task.\nExample: {taskId: '123'}.\n",
		                    write$0(1, 1, 0),
		                    d),
		                action$205 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbce6",
		                    j,
		                    "\nList all Todoist projects for the authenticated user.\nExample: {input: {}}.\n",
		                    read$2(0),
		                    empty_object_schema),
		                letrec_function_context$1319 = [];
		               function input_schema_versioned$193(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1319[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bG2, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1319[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1319[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1319[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var projectId = param[1];
		                       return cont([0, projectId]);
		                      },
		                      function(param, cont){
		                       var projectId = param[1];
		                       return cont([0, projectId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bG3,
		                        0,
		                        0,
		                        0,
		                        cst_projectId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1319[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1319[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1279 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1319, [0, schematic_cache$1279]);
		               caml_callback
		                (input_schema_versioned$193, [function(param){return 0;}]);
		               function schematic_version$331(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$193, [schematic_version$331]),
		                action$206 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbcf3",
		                    b3,
		                    "\nGet a Todoist project by ID.\nExample: {projectId: '123'}.\n",
		                    read$2(0),
		                    d),
		                letrec_function_context$1320 = [];
		               function input_schema_versioned$194(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1320[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bG4, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1320[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1320[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1320[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var projectId = param[1];
		                       return cont([0, projectId]);
		                      },
		                      function(param, cont){
		                       var projectId = param[1];
		                       return cont([0, projectId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bG5,
		                        0,
		                        0,
		                        0,
		                        cst_projectId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1320[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1320[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1280 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1320, [0, schematic_cache$1280]);
		               caml_callback
		                (input_schema_versioned$194, [function(param){return 0;}]);
		               function schematic_version$332(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$194, [schematic_version$332]),
		                action$207 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbd27",
		                    "Get Project Collaborators",
		                    "\nList collaborators of a Todoist project.\nExample: {projectId: '123'}.\n",
		                    read$2(0),
		                    d),
		                letrec_function_context$1321 = [];
		               function input_schema_versioned$195(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1321[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bG6, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1321[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1321[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1321[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$1060[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var project_id = param[1];
		                                 return cont([0, project_id]);
		                                },
		                                function(param, cont){
		                                 var project_id = param[1];
		                                 return cont([0, project_id, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  bG7,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_project_id,
		                                  0,
		                                  [0, default$],
		                                  [0, a],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1321[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1321[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1281 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1321, [0, schematic_cache$1281]);
		               caml_callback
		                (input_schema_versioned$195, [function(param){return 0;}]);
		               function schematic_version$333(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$195, [schematic_version$333]),
		                action$208 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbd34",
		                    "List Sections",
		                    "\nList Todoist sections, optionally filtered by project.\nExample: {project_id: '123'}.\n",
		                    read$2(0),
		                    d),
		                letrec_function_context$1322 = [];
		               function input_schema_versioned$196(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1322[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bG8, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1322[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1322[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1322[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1061[1],
		                             a =
		                               [0,
		                                [0,
		                                 bG9,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_cursor,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$1062[1],
		                                       b =
		 [0,
		  [0, bG_, 0, 0, 0, cst_limit, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1063[1],
		         a =
		           [0,
		            [0,
		             bG$,
		             0,
		             0,
		             0,
		             cst_project_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$1064[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        cursor = b[2][1],
		                        limit = b[1],
		                        project_id = a[1],
		                        task_id = param[1];
		                       return cont([0, task_id, project_id, limit, cursor]);
		                      },
		                      function(param, cont){
		                       var
		                        cursor = param[4],
		                        limit = param[3],
		                        project_id = param[2],
		                        task_id = param[1];
		                       return cont
		                               ([0, task_id, [0, project_id, [0, limit, [0, cursor, 0]]]]);
		                      },
		                      [0,
		                       [0,
		                        bHa,
		                        0,
		                        0,
		                        0,
		                        cst_task_id,
		                        0,
		                        [0, default$],
		                        [0, b],
		                        0,
		                        0],
		                       a]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1322[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1322[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1282 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1322, [0, schematic_cache$1282]);
		               caml_callback
		                (input_schema_versioned$196, [function(param){return 0;}]);
		               function schematic_version$334(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$196, [schematic_version$334]),
		                action$209 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbd68",
		                    cst_List_Comments,
		                    "\nList comments on a Todoist task or project.\nMUST pass either task_id or project_id \xe2\x80\x94 calling with neither returns an error.\nExample: {task_id: '123'} or {project_id: '456'}.\n",
		                    read$2(0),
		                    d),
		                letrec_function_context$1323 = [];
		               function input_schema_versioned$197(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1323[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHb, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1323[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1323[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1323[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var commentId = param[1];
		                       return cont([0, commentId]);
		                      },
		                      function(param, cont){
		                       var commentId = param[1];
		                       return cont([0, commentId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bHc,
		                        0,
		                        0,
		                        0,
		                        cst_commentId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1323[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1323[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1283 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1323, [0, schematic_cache$1283]);
		               caml_callback
		                (input_schema_versioned$197, [function(param){return 0;}]);
		               function schematic_version$335(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$197, [schematic_version$335]),
		                action$210 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbd82",
		                    cst_Get_Comment,
		                    "\nGet a Todoist comment by ID.\nExample: {commentId: '123'}.\n",
		                    read$2(0),
		                    d),
		                action$211 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbda9",
		                    b6,
		                    "\nList all personal Todoist labels for the authenticated user.\nExample: {input: {}}.\n",
		                    read$2(0),
		                    empty_object_schema),
		                cst_labelId = "labelId",
		                letrec_function_context$1324 = [];
		               function input_schema_versioned$198(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1324[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHd, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1324[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1324[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1324[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var labelId = param[1];
		                       return cont([0, labelId]);
		                      },
		                      function(param, cont){
		                       var labelId = param[1];
		                       return cont([0, labelId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bHe,
		                        0,
		                        0,
		                        0,
		                        cst_labelId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1324[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1324[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1284 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1324, [0, schematic_cache$1284]);
		               caml_callback
		                (input_schema_versioned$198, [function(param){return 0;}]);
		               function schematic_version$336(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$198, [schematic_version$336]),
		                action$212 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbdc3",
		                    "Get Label",
		                    "\nGet a Todoist label by ID.\nExample: {labelId: '123'}.\n",
		                    read$2(0),
		                    d),
		                cst_is_favorite = "is_favorite",
		                letrec_function_context$1325 = [];
		               function input_schema_versioned$199(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1325[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHf, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1325[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1325[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1325[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$1065[1],
		                             a =
		                               [0,
		                                [0,
		                                 bHg,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_is_favorite,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$1066[1],
		                                       b =
		 [0,
		  [0, bHh, 0, 0, 0, cst_order, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$1067[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              is_favorite = b[2][1],
		              order = b[1],
		              color = a[1],
		              name = param[1];
		             return cont([0, name, color, order, is_favorite]);
		            },
		            function(param, cont){
		             var
		              is_favorite = param[4],
		              order = param[3],
		              color = param[2],
		              name = param[1];
		             return cont
		                     ([0, name, [0, color, [0, order, [0, is_favorite, 0]]]]);
		            },
		            [0,
		             [0,
		              bHj,
		              0,
		              0,
		              0,
		              cst_name,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0, bHi, 0, 0, 0, cst_color, 0, [0, default$], [0, a], 0, 0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1325[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1325[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1285 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1325, [0, schematic_cache$1285]);
		               caml_callback
		                (input_schema_versioned$199, [function(param){return 0;}]);
		               function schematic_version$337(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$199, [schematic_version$337]),
		                action$213 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbdb6",
		                    bO7,
		                    "\nCreate a new Todoist label.\nExample: {name: 'urgent', color: 'red'}.\n",
		                    write$0(0, 0, 0),
		                    d),
		                letrec_function_context$1326 = [];
		               function input_schema_versioned$200(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1326[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHk, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1326[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1326[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1326[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$1068[1],
		                             a =
		                               [0,
		                                [0,
		                                 bHl,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_is_favorite,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     int_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$1069[1],
		                                       b =
		 [0,
		  [0, bHm, 0, 0, 0, cst_order, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1070[1],
		         a =
		           [0,
		            [0, bHn, 0, 0, 0, cst_color, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$1071[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        is_favorite = c[2][1],
		                        order = c[1],
		                        color = b[1],
		                        name = a[1],
		                        labelId = param[1];
		                       return cont([0, labelId, name, color, order, is_favorite]);
		                      },
		                      function(param, cont){
		                       var
		                        is_favorite = param[5],
		                        order = param[4],
		                        color = param[3],
		                        name = param[2],
		                        labelId = param[1];
		                       return cont
		                               ([0,
		                                 labelId,
		                                 [0, name, [0, color, [0, order, [0, is_favorite, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bHp,
		                        0,
		                        0,
		                        0,
		                        cst_labelId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bHo, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1326[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1326[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1286 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1326, [0, schematic_cache$1286]);
		               caml_callback
		                (input_schema_versioned$200, [function(param){return 0;}]);
		               function schematic_version$338(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$200, [schematic_version$338]),
		                action$214 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbdd0",
		                    "Update Label",
		                    "\nUpdate an existing Todoist label. Only provided fields are changed.\nExample: {labelId: '123', name: 'critical', color: 'orange'}.\n",
		                    write$0(1, 1, 0),
		                    d),
		                letrec_function_context$1327 = [];
		               function input_schema_versioned$201(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1327[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHq, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1327[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1327[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1327[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var labelId = param[1];
		                       return cont([0, labelId]);
		                      },
		                      function(param, cont){
		                       var labelId = param[1];
		                       return cont([0, labelId, 0]);
		                      },
		                      [0,
		                       [0,
		                        bHr,
		                        0,
		                        0,
		                        0,
		                        cst_labelId,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1327[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1327[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1287 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1327, [0, schematic_cache$1287]);
		               caml_callback
		                (input_schema_versioned$201, [function(param){return 0;}]);
		               function schematic_version$339(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$201, [schematic_version$339]),
		                action$215 =
		                  action$0
		                   ("6a2fbd34b747e41145fbbddd",
		                    "Delete Label",
		                    "\nDelete a Todoist label.\nExample: {labelId: '123'}.\n",
		                    write$0(1, 1, 0),
		                    d),
		                letrec_function_context$1328 = [];
		               function filter_schema_versioned$2(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1328[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHs, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1328[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1328[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1328[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bHG);},
		                        0,
		                        0,
		                        cst_all,
		                        cst_All,
		                        bHF,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bHE) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_closed,
		                         cst_Closed,
		                         bHD,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bHC) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_members,
		                          cst_Members,
		                          bHB,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(bHA) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_open,
		                           cst_Open,
		                           bHz,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 === param ? cont(bHy) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_organization,
		                            cst_Organization,
		                            bHx,
		                            0],
		                           [0,
		                            [0,
		                             function(param, cont){return cont(5);},
		                             function(param, cont){
		                              return 5 === param ? cont(bHw) : cont(0);
		                             },
		                             0,
		                             0,
		                             cst_public,
		                             cst_Public,
		                             bHv,
		                             0],
		                            [0,
		                             [0,
		                              function(param, cont){return cont(6);},
		                              function(param, cont){
		                               return 6 <= param ? cont(bHu) : cont(0);
		                              },
		                              0,
		                              0,
		                              cst_starred,
		                              cst_Starred,
		                              bHt,
		                              0],
		                             0]]]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1328[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1328[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1288 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1328, [0, schematic_cache$1288]);
		               caml_callback
		                (filter_schema_versioned$2, [function(param){return 0;}]);
		               var letrec_function_context$1329 = [];
		               function input_schema_versioned$202(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1329[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHH, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1329[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1329[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1329[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (filter_schema_versioned$2,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$1072[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var filter = param[1];
		   return cont([0, filter]);
		  },
		  function(param, cont){
		   var filter = param[1];
		   return cont([0, filter, 0]);
		  },
		  [0,
		   [0,
		    bHI,
		    0,
		    0,
		    0,
		    cst_filter,
		    0,
		    [0, default$],
		    [0, a],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1329[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1329[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1289 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1329, [0, schematic_cache$1289]);
		               caml_callback
		                (input_schema_versioned$202, [function(param){return 0;}]);
		               function schematic_version$340(param){return 0;}
		               var
		                d =
		                  caml_callback
		                   (input_schema_versioned$202, [schematic_version$340]),
		                action$216 =
		                  action$0
		                   ("69fc67166efa7d0567046a01",
		                    e,
		                    "List all Trello boards the authenticated user belongs to.\nUse 'filter' to narrow by open/closed/starred/etc.\nExample: {connectionId: '...', input: {filter: 'open'}}.",
		                    read$2(0),
		                    d),
		                letrec_function_context$1330 = [];
		               function input_schema_versioned$203(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1330[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHK, bHJ, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1330[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1330[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1330[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bHL,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1330[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1330[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1290 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1330, [0, schematic_cache$1290]);
		               caml_callback
		                (input_schema_versioned$203, [function(param){return 0;}]);
		               function schematic_version$341(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$203, [schematic_version$341]),
		                action$217 =
		                  action$0
		                   ("69fc67166efa7d0567046a10",
		                    cst_Get_Board,
		                    "Get a single Trello board by ID.\nReturns the board's preferences and metadata.\nExample: {connectionId: '...', input: {id: 'boardId'}}.",
		                    read$2(0),
		                    e),
		                cst_None$0 = "None_",
		                letrec_function_context$1331 = [];
		               function filter_schema_versioned$3(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1331[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHM, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1331[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1331[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1331[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bHU);},
		                        0,
		                        0,
		                        cst_all,
		                        cst_All,
		                        bHT,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bHS) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_closed,
		                         cst_Closed,
		                         bHR,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bHQ) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_none,
		                          cst_None$0,
		                          bHP,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 <= param ? cont(bHO) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_open,
		                           cst_Open,
		                           bHN,
		                           0],
		                          0]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1331[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1331[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1291 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1331, [0, schematic_cache$1291]);
		               caml_callback
		                (filter_schema_versioned$3, [function(param){return 0;}]);
		               var letrec_function_context$1332 = [];
		               function input_schema_versioned$204(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1332[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHV, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1332[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1332[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1332[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (filter_schema_versioned$3,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$1073[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var filter = param[2][1], id = param[1];
		   return cont([0, id, filter]);
		  },
		  function(param, cont){
		   var filter = param[2], id = param[1];
		   return cont([0, id, [0, filter, 0]]);
		  },
		  [0,
		   [0,
		    bHX,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bHW,
		     0,
		     0,
		     0,
		     cst_filter,
		     0,
		     [0, default$],
		     [0, a],
		     0,
		     0],
		    0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1332[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1332[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1292 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1332, [0, schematic_cache$1292]);
		               caml_callback
		                (input_schema_versioned$204, [function(param){return 0;}]);
		               function schematic_version$342(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$204, [schematic_version$342]),
		                action$218 =
		                  action$0
		                   ("69fc67176efa7d0567046a3d",
		                    "List Lists On Board",
		                    "List all lists (columns) on a Trello board.\nUse 'filter' to include closed lists.\nExample: {connectionId: '...', input: {id: 'boardId', filter: 'open'}}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1333 = [];
		               function input_schema_versioned$205(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1333[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bHZ, bHY, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1333[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1333[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1333[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bH0,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1333[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1333[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1293 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1333, [0, schematic_cache$1293]);
		               caml_callback
		                (input_schema_versioned$205, [function(param){return 0;}]);
		               function schematic_version$343(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$205, [schematic_version$343]),
		                action$219 =
		                  action$0
		                   ("69fc67176efa7d0567046a6a",
		                    "List Cards On List",
		                    "List cards in a Trello list.\nGet list IDs from 'List Lists On Board'.\nExample: {connectionId: '...', input: {id: 'listId'}}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1334 = [];
		               function input_schema_versioned$206(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1334[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bH2, bH1, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1334[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1334[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1334[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bH3,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1334[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1334[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1294 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1334, [0, schematic_cache$1294]);
		               caml_callback
		                (input_schema_versioned$206, [function(param){return 0;}]);
		               function schematic_version$344(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$206, [schematic_version$344]),
		                action$220 =
		                  action$0
		                   ("69fc67176efa7d0567046a79",
		                    "List Cards On Board",
		                    "List all cards on a Trello board.\nGet board IDs from 'List Boards'.\nExample: {connectionId: '...', input: {id: 'boardId'}}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1335 = [];
		               function input_schema_versioned$207(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1335[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bH5, bH4, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1335[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1335[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1335[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id]);
		                      },
		                      function(param, cont){
		                       var id = param[1];
		                       return cont([0, id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bH6,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1335[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1335[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1295 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1335, [0, schematic_cache$1295]);
		               caml_callback
		                (input_schema_versioned$207, [function(param){return 0;}]);
		               function schematic_version$345(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$207, [schematic_version$345]),
		                action$221 =
		                  action$0
		                   ("69fc67176efa7d0567046a88",
		                    "Get Card",
		                    "Get a single Trello card by ID.\nIncludes members, labels, and basic checklist info.\nExample: {connectionId: '...', input: {id: 'cardId'}}.",
		                    read$2(0),
		                    e),
		                cst_idList = "idList",
		                cst_pos = "pos",
		                letrec_function_context$1336 = [];
		               function input_schema_versioned$208(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1336[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bH8, bH7, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1336[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1336[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1336[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1074[1],
		                             a =
		                               [0,
		                                [0,
		                                 bH9,
		                                 0,
		                                 0,
		                                 0,
		                                 "urlSource",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		                                     function(c){
		                                      var
		                                       default$ = match$1075[1],
		                                       b =
		 [0,
		  [0,
		   bH_,
		   0,
		   0,
		   0,
		   "idLabels",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		       function(c){
		        var
		         default$ = match$1076[1],
		         a =
		           [0,
		            [0,
		             bH$,
		             0,
		             0,
		             0,
		             "idMembers",
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$1077[1],
		                   b =
		                     [0,
		                      [0, bIa, 0, 0, 0, cst_start, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1078[1],
		                             a =
		                               [0,
		                                [0, bIb, 0, 0, 0, cst_due, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1079[1],
		                                       b =
		 [0,
		  [0, bIc, 0, 0, 0, cst_pos, 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1080[1],
		         a =
		           [0,
		            [0, bId, 0, 0, 0, cst_desc, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$1081[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        d = c[2],
		                        e = d[2],
		                        f = e[2],
		                        g = f[2],
		                        urlSource = g[2][1],
		                        idLabels = g[1],
		                        idMembers = f[1],
		                        start = e[1],
		                        due = d[1],
		                        pos = c[1],
		                        desc = b[1],
		                        name = a[1],
		                        idList = param[1];
		                       return cont
		                               ([0,
		                                 idList,
		                                 name,
		                                 desc,
		                                 pos,
		                                 due,
		                                 start,
		                                 idMembers,
		                                 idLabels,
		                                 urlSource]);
		                      },
		                      function(param, cont){
		                       var
		                        urlSource = param[9],
		                        idLabels = param[8],
		                        idMembers = param[7],
		                        start = param[6],
		                        due = param[5],
		                        pos = param[4],
		                        desc = param[3],
		                        name = param[2],
		                        idList = param[1];
		                       return cont
		                               ([0,
		                                 idList,
		                                 [0,
		                                  name,
		                                  [0,
		                                   desc,
		                                   [0,
		                                    pos,
		                                    [0,
		                                     due,
		                                     [0, start, [0, idMembers, [0, idLabels, [0, urlSource, 0]]]]]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bIf,
		                        0,
		                        0,
		                        0,
		                        cst_idList,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0, bIe, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1336[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1336[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1296 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1336, [0, schematic_cache$1296]);
		               caml_callback
		                (input_schema_versioned$208, [function(param){return 0;}]);
		               function schematic_version$346(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$208, [schematic_version$346]),
		                action$222 =
		                  action$0
		                   ("69fc67176efa7d0567046a97",
		                    "Create Card",
		                    "Create a new card on a Trello list.\nGet list IDs from 'List Lists On Board'.\nExample: {connectionId: '...', input: {idList: 'listId', name: 'Write docs', desc: 'Markdown body...'}}.",
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1337 = [];
		               function input_schema_versioned$209(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1337[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIh, bIg, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1337[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1337[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1337[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(b){
		                            var
		                             default$ = match$1082[1],
		                             a =
		                               [0,
		                                [0,
		                                 bIi,
		                                 0,
		                                 0,
		                                 0,
		                                 "subscribed",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     bool_schema,
		                                     function(c){
		                                      var
		                                       default$ = match$1083[1],
		                                       b =
		 [0,
		  [0,
		   bIj,
		   0,
		   0,
		   0,
		   "dueComplete",
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1084[1],
		         a =
		           [0,
		            [0, bIk, 0, 0, 0, cst_start, 0, [0, default$], [0, c], 0, 0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(c){
		                  var
		                   default$ = match$1085[1],
		                   b =
		                     [0,
		                      [0, bIl, 0, 0, 0, cst_due, 0, [0, default$], [0, c], 0, 0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1086[1],
		                             a =
		                               [0,
		                                [0, bIm, 0, 0, 0, cst_pos, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1087[1],
		                                       b =
		 [0,
		  [0, bIn, 0, 0, 0, "idBoard", 0, [0, default$], [0, c], 0, 0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1088[1],
		         a =
		           [0,
		            [0,
		             bIo,
		             0,
		             0,
		             0,
		             cst_idList,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 bool_schema,
		                 function(c){
		                  var
		                   default$ = match$1089[1],
		                   b =
		                     [0,
		                      [0,
		                       bIp,
		                       0,
		                       0,
		                       0,
		                       cst_closed,
		                       0,
		                       [0, default$],
		                       [0, c],
		                       0,
		                       0],
		                      a];
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             default$ = match$1090[1],
		                             a =
		                               [0,
		                                [0, bIq, 0, 0, 0, cst_desc, 0, [0, default$], [0, c], 0, 0],
		                                b];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1091[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    d = c[2],
		    e = d[2],
		    f = e[2],
		    g = f[2],
		    h = g[2],
		    i = h[2],
		    subscribed = i[2][1],
		    dueComplete = i[1],
		    start = h[1],
		    due = g[1],
		    pos = f[1],
		    idBoard = e[1],
		    idList = d[1],
		    closed = c[1],
		    desc = b[1],
		    name = a[1],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             name,
		             desc,
		             closed,
		             idList,
		             idBoard,
		             pos,
		             due,
		             start,
		             dueComplete,
		             subscribed]);
		  },
		  function(param, cont){
		   var
		    subscribed = param[11],
		    dueComplete = param[10],
		    start = param[9],
		    due = param[8],
		    pos = param[7],
		    idBoard = param[6],
		    idList = param[5],
		    closed = param[4],
		    desc = param[3],
		    name = param[2],
		    id = param[1];
		   return cont
		           ([0,
		             id,
		             [0,
		              name,
		              [0,
		               desc,
		               [0,
		                closed,
		                [0,
		                 idList,
		                 [0,
		                  idBoard,
		                  [0,
		                   pos,
		                   [0, due, [0, start, [0, dueComplete, [0, subscribed, 0]]]]]]]]]]]);
		  },
		  [0,
		   [0,
		    bIs,
		    0,
		    0,
		    0,
		    cst_id,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0, bIr, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1337[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1337[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1297 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1337, [0, schematic_cache$1297]);
		               caml_callback
		                (input_schema_versioned$209, [function(param){return 0;}]);
		               function schematic_version$347(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$209, [schematic_version$347]),
		                action$223 =
		                  action$0
		                   ("69fc67176efa7d0567046aa6",
		                    "Update Card",
		                    "Update a Trello card.\nRename, edit description, move (idList/idBoard), set due/start, mark complete, or archive (closed=true).\nExample: {connectionId: '...', input: {id: 'cardId', name: 'New title', dueComplete: true}}.",
		                    write$0(1, 1, 0),
		                    e),
		                letrec_function_context$1338 = [];
		               function input_schema_versioned$210(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1338[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIu, bIt, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1338[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1338[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1338[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var text = param[2][1], id = param[1];
		                       return cont([0, id, text]);
		                      },
		                      function(param, cont){
		                       var text = param[2], id = param[1];
		                       return cont([0, id, [0, text, 0]]);
		                      },
		                      [0,
		                       [0,
		                        bIw,
		                        0,
		                        0,
		                        0,
		                        cst_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bIv,
		                         0,
		                         0,
		                         0,
		                         cst_text,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        0]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1338[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1338[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1298 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1338, [0, schematic_cache$1298]);
		               caml_callback
		                (input_schema_versioned$210, [function(param){return 0;}]);
		               function schematic_version$348(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$210, [schematic_version$348]),
		                action$224 =
		                  action$0
		                   ("69fc67176efa7d0567046ac4",
		                    "Add Comment To Card",
		                    "Post a comment on a Trello card.\nSupports Markdown and @mentions in 'text'.\nExample: {connectionId: '...', input: {id: 'cardId', text: 'Looking into this now.'}}.",
		                    write$0(0, 0, 0),
		                    e),
		                letrec_function_context$1339 = [];
		               function input_schema_versioned$211(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1339[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIy, bIx, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1339[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1339[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1339[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           int_schema,
		                           function(b){
		                            var
		                             default$ = match$1092[1],
		                             a =
		                               [0,
		                                [0,
		                                 bIz,
		                                 0,
		                                 0,
		                                 0,
		                                 "cards_limit",
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1093[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    cards_limit = a[2][1],
		    idBoards = a[1],
		    query = param[1];
		   return cont([0, query, idBoards, cards_limit]);
		  },
		  function(param, cont){
		   var
		    cards_limit = param[3],
		    idBoards = param[2],
		    query = param[1];
		   return cont([0, query, [0, idBoards, [0, cards_limit, 0]]]);
		  },
		  [0,
		   [0,
		    bIB,
		    0,
		    0,
		    0,
		    cst_query,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bIA,
		     0,
		     0,
		     0,
		     "idBoards",
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1339[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1339[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1299 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1339, [0, schematic_cache$1299]);
		               caml_callback
		                (input_schema_versioned$211, [function(param){return 0;}]);
		               function schematic_version$349(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$211, [schematic_version$349]),
		                action$225 =
		                  action$0
		                   ("69fc67176efa7d0567046ad3",
		                    "Search Cards",
		                    "Search Trello cards by query.\nSupports Trello operators (e.g. board:foo, list:bar, member:@me, due:overdue).\nExample: {connectionId: '...', input: {query: 'member:@me due:overdue'}}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1340 = [];
		               function filter_schema_versioned$4(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1340[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIC, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1340[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1340[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1340[1][1] = a;
		                  var
		                   res =
		                     [11,
		                      0,
		                      [0,
		                       [0,
		                        function(param, cont){return cont(0);},
		                        function(param, cont){return param ? cont(0) : cont(bIM);},
		                        0,
		                        0,
		                        cst_all,
		                        cst_All,
		                        bIL,
		                        0],
		                       [0,
		                        [0,
		                         function(param, cont){return cont(1);},
		                         function(param, cont){
		                          return 1 === param ? cont(bIK) : cont(0);
		                         },
		                         0,
		                         0,
		                         cst_closed,
		                         cst_Closed,
		                         bIJ,
		                         0],
		                        [0,
		                         [0,
		                          function(param, cont){return cont(2);},
		                          function(param, cont){
		                           return 2 === param ? cont(bII) : cont(0);
		                          },
		                          0,
		                          0,
		                          cst_none,
		                          cst_None$0,
		                          bIH,
		                          0],
		                         [0,
		                          [0,
		                           function(param, cont){return cont(3);},
		                           function(param, cont){
		                            return 3 === param ? cont(bIG) : cont(0);
		                           },
		                           0,
		                           0,
		                           cst_open,
		                           cst_Open,
		                           bIF,
		                           0],
		                          [0,
		                           [0,
		                            function(param, cont){return cont(4);},
		                            function(param, cont){
		                             return 4 <= param ? cont(bIE) : cont(0);
		                            },
		                            0,
		                            0,
		                            cst_visible,
		                            "Visible",
		                            bID,
		                            0],
		                           0]]]]],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1340[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1340[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1300 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1340, [0, schematic_cache$1300]);
		               caml_callback
		                (filter_schema_versioned$4, [function(param){return 0;}]);
		               var letrec_function_context$1341 = [];
		               function input_schema_versioned$212(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1341[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIN, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1341[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1341[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1341[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (filter_schema_versioned$4,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     a,
		                                     function(a){
		                                      var
		                                       default$ = match$1094[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var filter = param[1];
		   return cont([0, filter]);
		  },
		  function(param, cont){
		   var filter = param[1];
		   return cont([0, filter, 0]);
		  },
		  [0,
		   [0,
		    bIO,
		    0,
		    0,
		    0,
		    cst_filter,
		    0,
		    [0, default$],
		    [0, a],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1341[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1341[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1301 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1341, [0, schematic_cache$1301]);
		               caml_callback
		                (input_schema_versioned$212, [function(param){return 0;}]);
		               function schematic_version$350(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$212, [schematic_version$350]),
		                action$226 =
		                  action$0
		                   ("69fc67176efa7d0567046ae2",
		                    "List My Cards",
		                    "List cards assigned to the authenticated user across all boards.\nUse 'filter' to narrow by open/closed/visible.\nExample: {connectionId: '...', input: {filter: 'open'}}.",
		                    read$2(0),
		                    e),
		                letrec_function_context$1342 = [];
		               function schema_versioned$577(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1342[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIP, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1342[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1342[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1342[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(a){
		                            var
		                             default$ = match$1095[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var text = param[2][1], type = param[1];
		                                 return cont([0, type, text]);
		                                },
		                                function(param, cont){
		                                 var text = param[2], type = param[1];
		                                 return cont([0, type, [0, text, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bIQ,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0, 0, 0, 0, 0, cst_text, 0, [0, default$], [0, a], 0, 0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1342[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1342[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1302 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1342, [0, schematic_cache$1302]);
		               caml_callback
		                (schema_versioned$577, [function(param){return 0;}]);
		               var letrec_function_context$1343 = [];
		               function schema_versioned$578(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1343[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIR, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1343[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1343[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1343[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$577,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var parameters = param[2][1], type = param[1];
		                                 return cont([0, type, parameters]);
		                                },
		                                function(param, cont){
		                                 var parameters = param[2], type = param[1];
		                                 return cont([0, type, [0, parameters, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bIS,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_type,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_parameters,
		                                   0,
		                                   2,
		                                   [0, [0, 0, 0, [3, a], 0]],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1343[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1343[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1303 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1343, [0, schematic_cache$1303]);
		               caml_callback
		                (schema_versioned$578, [function(param){return 0;}]);
		               var letrec_function_context$1344 = [];
		               function schema_versioned$579(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1344[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIT, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1344[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1344[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1344[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1096[1],
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_last_name,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1097[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    last_name = a[2][1],
		    first_name = a[1],
		    formatted_name = param[1];
		   return cont([0, formatted_name, first_name, last_name]);
		  },
		  function(param, cont){
		   var
		    last_name = param[3],
		    first_name = param[2],
		    formatted_name = param[1];
		   return cont
		           ([0, formatted_name, [0, first_name, [0, last_name, 0]]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "formatted_name",
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_first_name,
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1344[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1344[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1304 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1344, [0, schematic_cache$1304]);
		               caml_callback
		                (schema_versioned$579, [function(param){return 0;}]);
		               var letrec_function_context$1345 = [];
		               function schema_versioned$580(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1345[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIU, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1345[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1345[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1345[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1098[1],
		                             a =
		                               [0,
		                                [0, bIV, 0, 0, 0, cst_type, 0, [0, default$], [0, b], 0, 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1099[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var type = param[2][1], phone = param[1];
		   return cont([0, phone, type]);
		  },
		  function(param, cont){
		   var type = param[2], phone = param[1];
		   return cont([0, phone, [0, type, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_phone, 0, [0, default$], [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1345[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1345[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1305 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1345, [0, schematic_cache$1305]);
		               caml_callback
		                (schema_versioned$580, [function(param){return 0;}]);
		               var letrec_function_context$1346 = [];
		               function schema_versioned$581(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1346[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIW, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1346[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1346[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1346[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$580,
		                           schematic_version,
		                           function(b){
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_phones,
		                                 0,
		                                 2,
		                                 [0, [0, 0, 0, [3, b], 0]],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$579,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var phones = param[2][1], name = param[1];
		   return cont([0, name, phones]);
		  },
		  function(param, cont){
		   var phones = param[2], name = param[1];
		   return cont([0, name, [0, phones, 0]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_name, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1346[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1346[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1306 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1346, [0, schematic_cache$1306]);
		               caml_callback
		                (schema_versioned$581, [function(param){return 0;}]);
		               var letrec_function_context$1347 = [];
		               function input_schema_versioned$213(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1347[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bIY, bIX, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1347[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1347[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1347[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           bool_schema,
		                           function(a){
		                            var
		                             default$ = match$1100[1],
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var
		                                  a = param[2],
		                                  preview_url = a[2][1],
		                                  body = a[1],
		                                  to = param[1];
		                                 return cont([0, to, body, preview_url]);
		                                },
		                                function(param, cont){
		                                 var preview_url = param[3], body = param[2], to = param[1];
		                                 return cont([0, to, [0, body, [0, preview_url, 0]]]);
		                                },
		                                [0,
		                                 [0,
		                                  bI1,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_to$0,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bI0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_body,
		                                   0,
		                                   2,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    bIZ,
		                                    0,
		                                    0,
		                                    0,
		                                    "preview_url",
		                                    0,
		                                    [0, default$],
		                                    [0, a],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1347[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1347[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1307 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1347, [0, schematic_cache$1307]);
		               caml_callback
		                (input_schema_versioned$213, [function(param){return 0;}]);
		               function schematic_version$351(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$213, [schematic_version$351]),
		                action$227 =
		                  action$0
		                   ("696859cec997376e0d020ae2",
		                    "Send Text Message",
		                    "\nSend a plain text message to a WhatsApp user.\nSet 'preview_url' to true to render link previews for URLs in the body.\nExample: {to: '16505551234', body: 'Hello there!'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1348 = [];
		               function input_schema_versioned$214(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1348[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bI3, bI2, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1348[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1348[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1348[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$578,
		                           schematic_version,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     [0, 0, 0, [3, a], 0],
		                                     function(a){
		                                      var
		                                       default$ = match$1101[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    components = b[2][1],
		    language_code = b[1],
		    template_name = a[1],
		    to = param[1];
		   return cont
		           ([0, to, template_name, language_code, components]);
		  },
		  function(param, cont){
		   var
		    components = param[4],
		    language_code = param[3],
		    template_name = param[2],
		    to = param[1];
		   return cont
		           ([0,
		             to,
		             [0, template_name, [0, language_code, [0, components, 0]]]]);
		  },
		  [0,
		   [0,
		    bI7,
		    0,
		    0,
		    0,
		    cst_to$0,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bI6,
		     0,
		     0,
		     0,
		     "template_name",
		     0,
		     2,
		     [0, schematic_param_name_schema_ve],
		     0,
		     0],
		    [0,
		     [0,
		      bI5,
		      0,
		      0,
		      0,
		      "language_code",
		      0,
		      2,
		      [0, schematic_param_name_schema_ve],
		      0,
		      0],
		     [0,
		      [0,
		       bI4,
		       0,
		       0,
		       0,
		       "components",
		       0,
		       [0, default$],
		       [0, a],
		       0,
		       0],
		      0]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1348[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1348[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1308 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1348, [0, schematic_cache$1308]);
		               caml_callback
		                (input_schema_versioned$214, [function(param){return 0;}]);
		               function schematic_version$352(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$214, [schematic_version$352]),
		                action$228 =
		                  action$0
		                   ("696859cec997376e0d020ae6",
		                    "Send Template Message",
		                    "\nSend a pre-approved template message to a WhatsApp user.\nTemplates are required for business-initiated conversations outside the 24-hour session window.\nUse 'components' to fill in template placeholders (see components field docs for structure).\nExample: {to: '16505551234', template_name: 'hello_world', language_code: 'en_US'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                cst_caption = "caption",
		                cst_media_id = "media_id",
		                letrec_function_context$1349 = [];
		               function input_schema_versioned$215(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1349[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bI9, bI8, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1349[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1349[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1349[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1102[1],
		                             a =
		                               [0,
		                                [0,
		                                 bI_,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_caption,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1103[1],
		                                       b =
		 [0,
		  [0,
		   bI$,
		   0,
		   0,
		   0,
		   cst_media_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$1104[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              caption = b[2][1],
		              media_id = b[1],
		              image_url = a[1],
		              to = param[1];
		             return cont([0, to, image_url, media_id, caption]);
		            },
		            function(param, cont){
		             var
		              caption = param[4],
		              media_id = param[3],
		              image_url = param[2],
		              to = param[1];
		             return cont
		                     ([0, to, [0, image_url, [0, media_id, [0, caption, 0]]]]);
		            },
		            [0,
		             [0,
		              bJb,
		              0,
		              0,
		              0,
		              cst_to$0,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bJa,
		               0,
		               0,
		               0,
		               cst_image_url,
		               0,
		               [0, default$],
		               [0, a],
		               0,
		               0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1349[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1349[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1309 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1349, [0, schematic_cache$1309]);
		               caml_callback
		                (input_schema_versioned$215, [function(param){return 0;}]);
		               function schematic_version$353(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$215, [schematic_version$353]),
		                action$229 =
		                  action$0
		                   ("696859cec997376e0d020aea",
		                    "Send Image Message",
		                    "\nSend an image message to a WhatsApp user.\nSupports JPEG and PNG formats up to 5MB.\nProvide either 'image_url' (public URL) or 'media_id' (previously uploaded).\nExample: {to: '16505551234', image_url: 'https://example.com/photo.jpg', caption: 'Look!'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1350 = [];
		               function input_schema_versioned$216(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1350[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJd, bJc, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1350[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1350[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1350[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1105[1],
		                             a =
		                               [0,
		                                [0,
		                                 bJe,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_caption,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1106[1],
		                                       b =
		 [0,
		  [0,
		   bJf,
		   0,
		   0,
		   0,
		   cst_filename,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(c){
		        var
		         default$ = match$1107[1],
		         a =
		           [0,
		            [0,
		             bJg,
		             0,
		             0,
		             0,
		             cst_media_id,
		             0,
		             [0, default$],
		             [0, c],
		             0,
		             0],
		            b];
		        return caml_exact_trampoline_cps_call
		                (option_schema,
		                 schematic_param_name_schema_ve,
		                 function(b){
		                  var
		                   default$ = match$1108[1],
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        b = a[2],
		                        c = b[2],
		                        caption = c[2][1],
		                        filename = c[1],
		                        media_id = b[1],
		                        document_url = a[1],
		                        to = param[1];
		                       return cont
		                               ([0, to, document_url, media_id, filename, caption]);
		                      },
		                      function(param, cont){
		                       var
		                        caption = param[5],
		                        filename = param[4],
		                        media_id = param[3],
		                        document_url = param[2],
		                        to = param[1];
		                       return cont
		                               ([0,
		                                 to,
		                                 [0,
		                                  document_url,
		                                  [0, media_id, [0, filename, [0, caption, 0]]]]]);
		                      },
		                      [0,
		                       [0,
		                        bJi,
		                        0,
		                        0,
		                        0,
		                        cst_to$0,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bJh,
		                         0,
		                         0,
		                         0,
		                         "document_url",
		                         0,
		                         [0, default$],
		                         [0, b],
		                         0,
		                         0],
		                        a]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1350[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1350[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1310 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1350, [0, schematic_cache$1310]);
		               caml_callback
		                (input_schema_versioned$216, [function(param){return 0;}]);
		               function schematic_version$354(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$216, [schematic_version$354]),
		                action$230 =
		                  action$0
		                   ("696859cec997376e0d020aee",
		                    "Send Document Message",
		                    "\nSend a document file to a WhatsApp user.\nSupports PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, and more up to 100MB.\nProvide either 'document_url' (public URL) or 'media_id' (previously uploaded).\nExample: {to: '16505551234', document_url: 'https://example.com/report.pdf', filename: 'report.pdf'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1351 = [];
		               function input_schema_versioned$217(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1351[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJk, bJj, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1351[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1351[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1351[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1109[1],
		                             a =
		                               [0,
		                                [0,
		                                 bJl,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_caption,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(c){
		                                      var
		                                       default$ = match$1110[1],
		                                       b =
		 [0,
		  [0,
		   bJm,
		   0,
		   0,
		   0,
		   cst_media_id,
		   0,
		   [0, default$],
		   [0, c],
		   0,
		   0],
		  a];
		                                      return caml_exact_trampoline_cps_call
		      (option_schema,
		       schematic_param_name_schema_ve,
		       function(a){
		        var
		         default$ = match$1111[1],
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              b = a[2],
		              caption = b[2][1],
		              media_id = b[1],
		              video_url = a[1],
		              to = param[1];
		             return cont([0, to, video_url, media_id, caption]);
		            },
		            function(param, cont){
		             var
		              caption = param[4],
		              media_id = param[3],
		              video_url = param[2],
		              to = param[1];
		             return cont
		                     ([0, to, [0, video_url, [0, media_id, [0, caption, 0]]]]);
		            },
		            [0,
		             [0,
		              bJo,
		              0,
		              0,
		              0,
		              cst_to$0,
		              0,
		              2,
		              [0, schematic_param_name_schema_ve],
		              0,
		              0],
		             [0,
		              [0,
		               bJn,
		               0,
		               0,
		               0,
		               "video_url",
		               0,
		               [0, default$],
		               [0, a],
		               0,
		               0],
		              b]]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1351[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1351[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1311 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1351, [0, schematic_cache$1311]);
		               caml_callback
		                (input_schema_versioned$217, [function(param){return 0;}]);
		               function schematic_version$355(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$217, [schematic_version$355]),
		                action$231 =
		                  action$0
		                   ("696859cec997376e0d020af2",
		                    "Send Video Message",
		                    "\nSend a video message to a WhatsApp user.\nSupports MP4 and 3GP formats up to 16MB.\nProvide either 'video_url' (public URL) or 'media_id' (previously uploaded).\nExample: {to: '16505551234', video_url: 'https://example.com/clip.mp4'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1352 = [];
		               function input_schema_versioned$218(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1352[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJq, bJp, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1352[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1352[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1352[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1112[1],
		                             a =
		                               [0,
		                                [0,
		                                 bJr,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_media_id,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1113[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    media_id = a[2][1],
		    audio_url = a[1],
		    to = param[1];
		   return cont([0, to, audio_url, media_id]);
		  },
		  function(param, cont){
		   var
		    media_id = param[3],
		    audio_url = param[2],
		    to = param[1];
		   return cont([0, to, [0, audio_url, [0, media_id, 0]]]);
		  },
		  [0,
		   [0,
		    bJt,
		    0,
		    0,
		    0,
		    cst_to$0,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bJs,
		     0,
		     0,
		     0,
		     "audio_url",
		     0,
		     [0, default$],
		     [0, b],
		     0,
		     0],
		    a]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1352[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1352[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1312 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1352, [0, schematic_cache$1312]);
		               caml_callback
		                (input_schema_versioned$218, [function(param){return 0;}]);
		               function schematic_version$356(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$218, [schematic_version$356]),
		                action$232 =
		                  action$0
		                   ("696859cec997376e0d020af6",
		                    "Send Audio Message",
		                    "\nSend an audio message to a WhatsApp user.\nSupports AAC, MP4, MPEG, AMR, and OGG formats up to 16MB.\nProvide either 'audio_url' (public URL) or 'media_id' (previously uploaded).\nExample: {to: '16505551234', audio_url: 'https://example.com/voice.ogg'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1353 = [];
		               function input_schema_versioned$219(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1353[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJv, bJu, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1353[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1353[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1353[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (option_schema,
		                           schematic_param_name_schema_ve,
		                           function(b){
		                            var
		                             default$ = match$1114[1],
		                             a =
		                               [0,
		                                [0,
		                                 bJw,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_address,
		                                 0,
		                                 [0, default$],
		                                 [0, b],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (option_schema,
		                                     schematic_param_name_schema_ve,
		                                     function(b){
		                                      var
		                                       default$ = match$1115[1],
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    address = c[2][1],
		    name = c[1],
		    longitude = b[1],
		    latitude = a[1],
		    to = param[1];
		   return cont([0, to, latitude, longitude, name, address]);
		  },
		  function(param, cont){
		   var
		    address = param[5],
		    name = param[4],
		    longitude = param[3],
		    latitude = param[2],
		    to = param[1];
		   return cont
		           ([0,
		             to,
		             [0, latitude, [0, longitude, [0, name, [0, address, 0]]]]]);
		  },
		  [0,
		   [0,
		    bJA,
		    0,
		    0,
		    0,
		    cst_to$0,
		    0,
		    2,
		    [0, schematic_param_name_schema_ve],
		    0,
		    0],
		   [0,
		    [0,
		     bJz,
		     0,
		     0,
		     0,
		     cst_latitude,
		     0,
		     2,
		     [0, float_schema],
		     0,
		     0],
		    [0,
		     [0,
		      bJy,
		      0,
		      0,
		      0,
		      cst_longitude,
		      0,
		      2,
		      [0, float_schema],
		      0,
		      0],
		     [0,
		      [0, bJx, 0, 0, 0, cst_name, 0, [0, default$], [0, b], 0, 0],
		      a]]]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1353[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1353[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1313 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1353, [0, schematic_cache$1313]);
		               caml_callback
		                (input_schema_versioned$219, [function(param){return 0;}]);
		               function schematic_version$357(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$219, [schematic_version$357]),
		                action$233 =
		                  action$0
		                   ("696859cfc997376e0d020b02",
		                    "Send Location Message",
		                    "\nSend a location message with coordinates to a WhatsApp user.\nOptionally include a 'name' and 'address' for the location.\nExample: {to: '16505551234', latitude: 37.422, longitude: -122.084, name: 'Googleplex'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1354 = [];
		               function input_schema_versioned$220(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1354[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJC, bJB, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1354[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1354[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1354[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$581,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var contacts = param[2][1], to = param[1];
		                                 return cont([0, to, contacts]);
		                                },
		                                function(param, cont){
		                                 var contacts = param[2], to = param[1];
		                                 return cont([0, to, [0, contacts, 0]]);
		                                },
		                                [0,
		                                 [0,
		                                  bJE,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_to$0,
		                                  0,
		                                  2,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   bJD,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_contacts,
		                                   0,
		                                   2,
		                                   [0, [0, 0, 0, [3, a], 0]],
		                                   0,
		                                   0],
		                                  0]]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1354[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1354[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1314 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1354, [0, schematic_cache$1314]);
		               caml_callback
		                (input_schema_versioned$220, [function(param){return 0;}]);
		               function schematic_version$358(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$220, [schematic_version$358]),
		                action$234 =
		                  action$0
		                   ("696859cfc997376e0d020b06",
		                    "Send Contacts Message",
		                    "\nSend one or more contact cards (vCards) to a WhatsApp user.\nEach contact requires at least a name (see contacts field docs for structure).\nExample: {to: '16505551234', contacts: [{name: {formatted_name: 'John Doe', first_name: 'John'}}]}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                cst_message_id = "message_id",
		                letrec_function_context$1355 = [];
		               function input_schema_versioned$221(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1355[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJG, bJF, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1355[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1355[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1355[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        emoji = a[2][1],
		                        message_id = a[1],
		                        to = param[1];
		                       return cont([0, to, message_id, emoji]);
		                      },
		                      function(param, cont){
		                       var emoji = param[3], message_id = param[2], to = param[1];
		                       return cont([0, to, [0, message_id, [0, emoji, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        bJJ,
		                        0,
		                        0,
		                        0,
		                        cst_to$0,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         bJI,
		                         0,
		                         0,
		                         0,
		                         cst_message_id,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          bJH,
		                          0,
		                          0,
		                          0,
		                          cst_emoji,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1355[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1355[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1315 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1355, [0, schematic_cache$1315]);
		               caml_callback
		                (input_schema_versioned$221, [function(param){return 0;}]);
		               function schematic_version$359(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$221, [schematic_version$359]),
		                action$235 =
		                  action$0
		                   ("696859cfc997376e0d020b0a",
		                    "Send Reaction",
		                    "\nSend a reaction emoji to a specific message.\nSend an empty emoji to remove an existing reaction.\nExample: {to: '16505551234', message_id: 'wamid.abc123', emoji: '\xf0\x9f\x91\x8d'}.\n",
		                    write$0(1, 0, 1),
		                    e),
		                letrec_function_context$1356 = [];
		               function input_schema_versioned$222(schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1356[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJL, bJK, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1356[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1356[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1356[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var message_id = param[1];
		                       return cont([0, message_id]);
		                      },
		                      function(param, cont){
		                       var message_id = param[1];
		                       return cont([0, message_id, 0]);
		                      },
		                      [0,
		                       [0,
		                        bJM,
		                        0,
		                        0,
		                        0,
		                        cst_message_id,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1356[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1356[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1316 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1356, [0, schematic_cache$1316]);
		               caml_callback
		                (input_schema_versioned$222, [function(param){return 0;}]);
		               function schematic_version$360(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (input_schema_versioned$222, [schematic_version$360]),
		                action$236 =
		                  action$0
		                   ("696859cfc997376e0d020b0e",
		                    "Mark Message as Read",
		                    "\nMark a received message as read.\nThis displays the blue checkmarks to the sender.\nExample: {message_id: 'wamid.abc123'}.\n",
		                    write$0(1, 1, 0),
		                    e),
		                cst_issues = "issues",
		                tools =
		                  [0,
		                   action$91,
		                   [0,
		                    action$92,
		                    [0,
		                     action$93,
		                     [0, action$94, [0, action$95, [0, action$96, 0]]]]]],
		                tools$0 =
		                  [0,
		                   action$160,
		                   [0,
		                    action$161,
		                    [0,
		                     action$162,
		                     [0,
		                      action$163,
		                      [0,
		                       action$164,
		                       [0, action$165, [0, action$166, [0, action$167, 0]]]]]]]],
		                tools$1 = [0, action$183, [0, action$184, 0]],
		                tools$2 = [0, action$185, [0, action$186, [0, action$187, 0]]],
		                tools$3 = [0, action$188, [0, action$189, 0]],
		                tools$4 = [0, action$190, [0, action$191, 0]],
		                tools$5 =
		                  [0,
		                   action$216,
		                   [0,
		                    action$217,
		                    [0,
		                     action$218,
		                     [0,
		                      action$219,
		                      [0,
		                       action$220,
		                       [0,
		                        action$221,
		                        [0,
		                         action$222,
		                         [0,
		                          action$223,
		                          [0, action$224, [0, action$225, [0, action$226, 0]]]]]]]]]]],
		                tools$6 =
		                  [0,
		                   action$227,
		                   [0,
		                    action$228,
		                    [0,
		                     action$229,
		                     [0,
		                      action$230,
		                      [0,
		                       action$231,
		                       [0,
		                        action$232,
		                        [0,
		                         action$233,
		                         [0, action$234, [0, action$235, [0, action$236, 0]]]]]]]]]];
		               function register$0(ctrl, organization_id, key, cont){
		                var cst_posts = "posts";
		                switch(key){
		                  case 0:
		                   var a = cst_apolloio;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            a,
		                            [0, action$13, [0, action$14, 0]],
		                            function(b){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      "sequences_deals",
		                                      "Search sequences and list deals",
		                                      b,
		                                      function(c){
		                                       var b = [0, c, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        a,
		        [0,
		         action$8,
		         [0,
		          action$9,
		          [0, action$10, [0, action$11, [0, action$12, 0]]]]],
		        function(c){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_organizations,
		                  "Search and retrieve organizations and accounts",
		                  c,
		                  function(d){
		                   var c = [0, d, b];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            a,
		                            [0,
		                             action$3,
		                             [0,
		                              action$4,
		                              [0, action$5, [0, action$6, [0, action$7, 0]]]]],
		                            function(b){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_contacts,
		                                      "Search, retrieve, create, and update contacts",
		                                      b,
		                                      function(d){
		                                       var b = [0, d, c];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        a,
		        [0, action$1, [0, action$2, 0]],
		        function(a){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  "enrich",
		                  "Enrich person and organization data from Apollo's database",
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_apolloio,
		                            "Apollo.io: enrich, search, create, and update contacts, accounts, organizations, sequences, and deals",
		                            [0, a, b],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 1:
		                   var m = cst_asana;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            m,
		                            [0,
		                             action$18,
		                             [0,
		                              action$19,
		                              [0,
		                               action$20,
		                               [0, action$21, [0, action$22, [0, action$23, 0]]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_tasks,
		                                      "List, retrieve, create, update, complete, reopen, and delete tasks",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        m,
		        [0, action$15, [0, action$16, [0, action$17, 0]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_metadata,
		                  "List workspaces and list or retrieve projects",
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_asana,
		                            "Asana: discover workspaces and projects, then read and manage tasks\n\n# Hierarchy\nAsana organizes work as Workspace > Project > Task. Use List Workspaces and List Projects to discover GIDs before listing or changing tasks.\n\n# Task listing\nList Tasks always needs the workspace GID. Also pass a project, section, or assignee. Use assignee: 'me' for the authenticated user.\n\n# Dates\nDate-only fields use YYYY-MM-DD. Date-time fields use ISO 8601 UTC. Do not send both forms of the same start or due date.\n",
		                            [0, b, a],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  case 2:
		                   var g = cst_clickup;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            g,
		                            [0,
		                             action$47,
		                             [0,
		                              action$48,
		                              [0, action$49, [0, action$50, [0, action$51, 0]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_tasks,
		                                      "List, retrieve, create, update, and delete tasks\n\n# Task priorities\n1 = Urgent, 2 = High, 3 = Normal, 4 = Low.\n\n# Dates\nAll date fields (due_date, start_date) are Unix timestamps in milliseconds.",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        g,
		        [0, action$44, [0, action$45, [0, action$46, 0]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  "lists",
		                  "List and retrieve lists",
		                  b,
		                  function(c){
		                   var b = [0, c, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            g,
		                            [0,
		                             action$38,
		                             [0,
		                              action$39,
		                              [0,
		                               action$40,
		                               [0, action$41, [0, action$42, [0, action$43, 0]]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_metadata,
		                                      "Get user, workspaces, spaces, and folders",
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_clickup,
		        "ClickUp: read and manage tasks, lists, folders, spaces, and workspaces\n\n# Hierarchy\nClickUp organises work as: Workspace (team) > Space > Folder > List > Task.\nUse Get Workspaces to discover team IDs, then List Spaces, List Folders, List Lists in Folder / List Folderless Lists, and finally List Tasks to navigate down.\n",
		        [0, a, b],
		        function(a){return cont([0, a, 0]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 3:
		                   var n = cst_github;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            n,
		                            [0,
		                             action$74,
		                             [0,
		                              action$75,
		                              [0, action$76, [0, action$77, [0, action$78, 0]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      "repos",
		                                      "List and retrieve repository and pull request information",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        n,
		        [0,
		         action$67,
		         [0,
		          action$68,
		          [0,
		           action$69,
		           [0,
		            action$70,
		            [0, action$71, [0, action$72, [0, action$73, 0]]]]]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_issues,
		                  "List, create, search, and update issues and comments",
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_github,
		                            "\nGitHub: list, search, create, and update issues in repositories\n",
		                            [0, b, a],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  case 4:
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            cst_gmail,
		                            tools,
		                            function(b){
		                             function a(a, cont){
		                              return caml_exact_trampoline_cps_call$0
		                                      (create$55, ctrl, organization_id, a, cont);
		                             }
		                             function schematic_version(param){return 0;}
		                             return caml_exact_trampoline_cps_call
		                                     (input_schema_versioned$88,
		                                      schematic_version,
		                                      function(c){
		                                       return caml_exact_trampoline_cps_call$0
		       (object_schema,
		        bvR,
		        0,
		        c,
		        function(c){
		         return caml_exact_trampoline_cps_call$9
		                 (tool,
		                  "gmail_create_draft",
		                  0,
		                  0,
		                  "Create a plain-text or HTML Gmail draft. Use this for normal email drafts and replies.\nChoose a plain-text body, an HTML body, or both bodies; both bodies are sent as a\nmultipart alternative. The subject and body content are encoded as UTF-8,\npreserving accented and other Unicode characters. For attachments or other\ncustom MIME content, use Create Raw Draft.",
		                  write$0(0, 0, 0),
		                  c,
		                  no_input_schema,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_gmail,
		                            'Gmail: read, send, and manage emails\n\n# Message IDs\nEach email has a unique message ID. Get IDs from "List Messages" and use them with "Get Message" to retrieve full content.\n\n# RFC 2822 Format\nUse Create Draft for plain-text, HTML, or multipart alternative emails. It\ncreates the required UTF-8 MIME message and base64url encoding for you.\n\nCreate Raw Draft, Update Draft, and Send Message require an RFC 2822 MIME\nmessage (standard email with headers and body), then base64url encoded. Example\nbefore encoding:\n\n```\nTo: recipient@example.com\nFrom: sender@example.com\nSubject: Test Email\n\nThis is the email body.\n```\n\nBase64url encoding: base64 with `+` \xe2\x86\x92 `-`, `/` \xe2\x86\x92 `_`, padding `=` removed.\n',
		                            [0, a, b],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  case 5:
		                   var e = cst_slack;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            e,
		                            tools$4,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      "users",
		                                      "\nLook up user profiles and list workspace members\n",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        e,
		        tools$3,
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_reactions,
		                  "\nAdd and remove emoji reactions\n",
		                  b,
		                  function(c){
		                   var b = [0, c, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            e,
		                            tools$1,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_conversations,
		                                      "\nList channels and get message history\n",
		                                      a,
		                                      function(c){
		                                       var a = [0, c, b];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        e,
		        tools$2,
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_messages,
		                  "\nPost, update, and get a permalink for messages\n",
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_slack,
		                            "\nSlack messaging: send, react, and manage messages\n",
		                            [0, b, a],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 6:
		                   var b = cst_attio;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            b,
		                            [0, action$35, [0, action$36, [0, action$37, 0]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      bog,
		                                      function(c){
		                                       var
		actor_reference =
		  "{referenced_actor_type: 'workspace-member', referenced_actor_id: '<uuid>'}";
		                                       return caml_trampoline_cps_call2
		       (c,
		        actor_reference,
		        function(c){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  "tasks_notes",
		                  c,
		                  a,
		                  function(c){
		                   var a = [0, c, 0];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            b,
		                            [0, action$32, [0, action$33, [0, action$34, 0]]],
		                            function(c){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      boh,
		                                      function(d){
		                                       var
		attribute_values_intro =
		  "Pass Attio attribute slugs as keys under 'values'. Single-select attributes take a scalar; multi-select attributes take an array.";
		                                       return caml_trampoline_cps_call2
		       (d,
		        attribute_values_intro,
		        function(d){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  "companies",
		                  d,
		                  c,
		                  function(d){
		                   var c = [0, d, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            b,
		                            [0,
		                             action$28,
		                             [0, action$29, [0, action$30, [0, action$31, 0]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      boi,
		                                      function(d){
		                                       return caml_trampoline_cps_call2
		       (d,
		        attribute_values_intro,
		        function(d){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_people,
		                  d,
		                  a,
		                  function(d){
		                   var a = [0, d, c];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            b,
		                            [0,
		                             action$24,
		                             [0, action$25, [0, action$26, [0, action$27, 0]]]],
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      boj,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (c,
		        attribute_values_intro,
		        actor_reference,
		        function(c){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_deals,
		                  c,
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_attio,
		                            'Attio: CRM for managing deals, people, companies, tasks, and notes\n\n# Records and objects\nAttio organizes data as records belonging to objects. Standard objects include "people", "companies", and "deals". Each record is identified by a UUID and has attributes (e.g. name, stage, email).\n',
		                            [0, b, a],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 7:
		                   var
		                    linking_intro =
		                      function(entities, targets, cont){
		                       return caml_exact_trampoline_cps_call
		                               (sprintf,
		                                bEV,
		                                function(a){
		                                 return caml_trampoline_cps_call3(a, entities, targets, cont);
		                                });
		                      },
		                    d = cst_pipedrive;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            d,
		                            [0,
		                             action$179,
		                             [0, action$180, [0, action$181, [0, action$182, 0]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (linking_intro,
		                                      cst_Notes,
		                                      "a deal, person, organization, and/or lead",
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (sprintf,
		        bEW,
		        function(c){
		         return caml_trampoline_cps_call2
		                 (c,
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            "orgs_notes",
		                            b,
		                            a,
		                            function(b){
		                             var a = [0, b, 0];
		                             return caml_exact_trampoline_cps_call$2
		                                     (register_tools,
		                                      ctrl,
		                                      organization_id,
		                                      d,
		                                      [0, action$176, [0, action$177, [0, action$178, 0]]],
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_persons,
		        "Search, retrieve, and create persons (contacts)",
		        b,
		        function(c){
		         var b = [0, c, a];
		         return caml_exact_trampoline_cps_call$2
		                 (register_tools,
		                  ctrl,
		                  organization_id,
		                  d,
		                  [0,
		                   action$172,
		                   [0, action$173, [0, action$174, [0, action$175, 0]]]],
		                  function(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_deals,
		                            "Search, list, retrieve, and update deals",
		                            a,
		                            function(c){
		                             var a = [0, c, b];
		                             return caml_exact_trampoline_cps_call$2
		                                     (register_tools,
		                                      ctrl,
		                                      organization_id,
		                                      d,
		                                      [0,
		                                       action$168,
		                                       [0, action$169, [0, action$170, [0, action$171, 0]]]],
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1
		       (linking_intro,
		        "Activities",
		        "a deal, person, and/or organization",
		        function(c){
		         return caml_exact_trampoline_cps_call
		                 (sprintf,
		                  bEX,
		                  function(d){
		                   return caml_trampoline_cps_call2
		                           (d,
		                            c,
		                            function(c){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      "activities",
		                                      c,
		                                      b,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_pipedrive,
		        'Pipedrive CRM: manage activities, deals, persons, organizations,\nand notes.\n\n# Entity IDs\nPipedrive entities use integer IDs. Use the "Search" or "List" tools to\ndiscover IDs before calling "Get" or "Update".\n',
		        [0, b, a],
		        function(a){return cont([0, a, 0]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 8:
		                   var k = cst_linear;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            k,
		                            [0,
		                             action$141,
		                             [0,
		                              action$142,
		                              [0,
		                               action$143,
		                               [0, action$144, [0, action$145, [0, action$146, 0]]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_metadata,
		                                      "Manage Linear workspace metadata: users, labels, workflow states, and cycles",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        k,
		        [0,
		         action$139,
		         [0, action$140, [0, action$137, [0, action$138, 0]]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_projects,
		                  "Manage Linear projects and teams",
		                  b,
		                  function(c){
		                   var b = [0, c, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            k,
		                            [0,
		                             action$129,
		                             [0,
		                              action$130,
		                              [0,
		                               action$131,
		                               [0,
		                                action$132,
		                                [0,
		                                 action$133,
		                                 [0, action$134, [0, action$135, [0, action$136, 0]]]]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_issues,
		                                      'Create, retrieve, update, delete, and search Linear issues\n\n# Issues\nEach issue has a unique UUID and a shorthand identifier (e.g., "ENG-123"). Use either form with get/update/delete operations.\n\n# Priority\n0 = No priority, 1 = Urgent, 2 = High, 3 = Medium, 4 = Low.\n\n# Filtering issues\n"List Issues" accepts a filter object: {"assignee":{"id":{"eq":"USER_ID"}}}\nFor free-text search use "Search Issues" instead.\n',
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_linear,
		        'Linear: manage issues, projects, teams, cycles, and labels\n\n# Typical workflow\n1. "List Teams" (projects) \xe2\x86\x92 get team IDs.\n2. "List Workflow States" (metadata) \xe2\x86\x92 get state IDs.\n3. "Create Issue" or "Update Issue" (issues) using those IDs.\n',
		        [0, a, b],
		        function(a){return cont([0, a, 0]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 9:
		                   var i = cst_gitlab;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            i,
		                            [0,
		                             action$86,
		                             [0,
		                              action$87,
		                              [0, action$88, [0, action$89, [0, action$90, 0]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      "merge_requests",
		                                      "List, get, create, update, and merge merge requests",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        i,
		        [0,
		         action$82,
		         [0, action$83, [0, action$84, [0, action$85, 0]]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_issues,
		                  "List, get, create, and update issues",
		                  b,
		                  function(c){
		                   var b = [0, c, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            i,
		                            [0, action$79, [0, action$80, [0, action$81, 0]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_projects,
		                                      "Get current user and manage projects",
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_gitlab,
		        "GitLab: manage projects, issues, and merge requests",
		        [0, a, b],
		        function(a){return cont([0, a, 0]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 10:
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            cst_trello,
		                            tools$5,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_trello,
		                                      'Trello: browse boards and lists, and read, create, update, search, and comment on cards.\n\n# IDs\nBoards, lists, and cards are identified by opaque IDs. Get board IDs from "List Boards", list IDs from "List Lists On Board", and card IDs from "List Cards On List", "List Cards On Board", "Search Cards", or "List My Cards".\n\n# Positions\nThe \'pos\' field accepts "top", "bottom", or a positive number passed as a string.\n',
		                                      a,
		                                      function(a){return cont([0, a, 0]);});
		                            });
		                  case 11:
		                   var c = cst_jira;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            c,
		                            [0, action$122, [0, action$123, 0]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      bzi,
		                                      function(b){
		                                       var
		issue_identifiers =
		  '# Issue identifiers\nIssues are identified by their key (e.g. "PROJ-123") or numeric ID (e.g. "10001"). Most actions accept either.',
		adf_spec =
		  'Atlassian Document Format (ADF), a JSON structure for rich text, e.g. {"type":"doc","version":1,"content":[{"type":"paragraph","content":[{"type":"text","text":"..."}]}]}. Full spec: https://developer.atlassian.com/cloud/jira/platform/apis/document/structure/';
		                                       return caml_trampoline_cps_call3
		       (b,
		        issue_identifiers,
		        adf_spec,
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  "workflow",
		                  b,
		                  a,
		                  function(b){
		                   var a = [0, b, 0];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            c,
		                            [0,
		                             action$119,
		                             [0, action$120, [0, action$118, [0, action$117, 0]]]],
		                            function(b){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      bzj,
		                                      function(d){
		                                       return caml_trampoline_cps_call3
		       (d,
		        issue_identifiers,
		        adf_spec,
		        function(d){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_comments,
		                  d,
		                  b,
		                  function(d){
		                   var b = [0, d, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            c,
		                            [0,
		                             action$127,
		                             [0,
		                              action$128,
		                              [0,
		                               action$124,
		                               [0, action$125, [0, action$126, [0, action$121, 0]]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      bzk,
		                                      function(d){
		                                       return caml_trampoline_cps_call3
		       (d,
		        issue_identifiers,
		        adf_spec,
		        function(d){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_issues,
		                  d,
		                  a,
		                  function(d){
		                   var a = [0, d, b];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            c,
		                            [0,
		                             action$109,
		                             [0,
		                              action$110,
		                              [0,
		                               action$111,
		                               [0,
		                                action$112,
		                                [0,
		                                 action$113,
		                                 [0, action$114, [0, action$115, [0, action$116, 0]]]]]]]],
		                            function(b){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_metadata,
		                                      "Get current user, statuses, priorities, issue types, users, and projects",
		                                      b,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_jira,
		        "Jira: read, create, update, and transition issues; manage comments and look up project metadata",
		        [0, b, a],
		        function(a){return cont([0, a, 0]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 12:
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            cst_whatsapp,
		                            tools$6,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_whatsapp,
		                                      'WhatsApp: send messages and media to WhatsApp users\n\n# Recipients\nEvery message targets a recipient phone number (\'to\') in international format with country code and no symbols (e.g., 16505551234).\n\n# Session window\nYou can freely send messages within the 24-hour window after the user\'s last message. To start a conversation outside that window, use "Send Template Message" with a pre-approved template.\n\n# Media\nMedia actions (image, document, video, audio) accept either a public URL or the \'media_id\' of a previously uploaded file. Provide exactly one of the two.\n\n# Message IDs\n"Send Reaction" and "Mark Message as Read" operate on a message ID in wamid format (the ID of a message received from the user).\n',
		                                      a,
		                                      function(a){return cont([0, a, 0]);});
		                            });
		                  case 13:
		                   var o = cst_ticktick;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            o,
		                            [0,
		                             action$194,
		                             [0, action$195, [0, action$196, [0, action$197, 0]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_tasks,
		                                      "Create, update, list, and complete tasks.",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        o,
		        [0, action$192, [0, action$193, 0]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_projects,
		                  "Retrieve and create projects (lists) in TickTick.",
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_ticktick,
		                            'TickTick task manager: manage projects (lists) and tasks.\n\n# Entity IDs\nTickTick uses string IDs for projects and tasks. Use the "Get User Projects" tool to discover valid project IDs before attempting to create, update, or list tasks.',
		                            [0, b, a],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  case 14:
		                   var f = cst_todoist;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            f,
		                            [0,
		                             action$211,
		                             [0,
		                              action$212,
		                              [0, action$213, [0, action$214, [0, action$215, 0]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_labels,
		                                      "List, retrieve, create, update, and delete labels\n\nLabel management operations (get/update/delete) take a label ID, unlike task creation/update which references labels by name.",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        f,
		        [0, action$209, [0, action$210, 0]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_comments,
		                  "List and retrieve comments",
		                  b,
		                  function(c){
		                   var b = [0, c, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            f,
		                            [0,
		                             action$205,
		                             [0, action$206, [0, action$207, [0, action$208, 0]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_projects,
		                                      "List and retrieve projects and sections",
		                                      a,
		                                      function(c){
		                                       var a = [0, c, b];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        f,
		        [0,
		         action$198,
		         [0,
		          action$199,
		          [0,
		           action$200,
		           [0,
		            action$201,
		            [0, action$202, [0, action$203, [0, action$204, 0]]]]]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_tasks,
		                  'List, retrieve, create, update, close, reopen, and delete tasks\n\n# Task priorities\n1 = normal, 2 = medium, 3 = high, 4 = urgent.\n\n# Due dates\nPrefer due_string for natural language (e.g. "tomorrow", "next Monday").\nUse due_date (YYYY-MM-DD) or due_datetime (RFC3339 UTC) for exact dates.\n\n# Labels\nLabels are referenced by name (list of label names) when creating/updating tasks.',
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_todoist,
		                            'Todoist: manage tasks, projects, sections, comments, and labels\n\n# IDs\nUse "List Tasks", "List Projects", etc. to discover IDs before operating on specific items.\n',
		                            [0, b, a],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 15:
		                   var
		                    author_attribution =
		                      function(actions_clause, cont){
		                       return caml_exact_trampoline_cps_call
		                               (sprintf,
		                                bqS,
		                                function(a){
		                                 return caml_trampoline_cps_call2(a, actions_clause, cont);
		                                });
		                      },
		                    h = cst_featurebase;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            h,
		                            [0,
		                             action$62,
		                             [0,
		                              action$63,
		                              [0, action$64, [0, action$65, [0, action$66, 0]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (author_attribution,
		                                      '"Create Comment" accepts',
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call
		       (sprintf,
		        bqT,
		        function(c){
		         return caml_trampoline_cps_call2
		                 (c,
		                  b,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_comments,
		                            b,
		                            a,
		                            function(b){
		                             var a = [0, b, 0];
		                             return caml_exact_trampoline_cps_call$2
		                                     (register_tools,
		                                      ctrl,
		                                      organization_id,
		                                      h,
		                                      [0, action$57, [0, action$58, [0, action$59, 0]]],
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        "voters",
		        'List voters and manage upvotes.\n\nVoters are users who have upvoted a post. Use "Add Voter" / "Remove Voter" to vote on behalf of a user, identified by userId or email.',
		        b,
		        function(c){
		         var b = [0, c, a];
		         return caml_exact_trampoline_cps_call$2
		                 (register_tools,
		                  ctrl,
		                  organization_id,
		                  h,
		                  [0,
		                   action$52,
		                   [0,
		                    action$53,
		                    [0,
		                     action$54,
		                     [0,
		                      action$55,
		                      [0, action$56, [0, action$60, [0, action$61, 0]]]]]]],
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (author_attribution,
		                            '"Create Post" and "Update Post" accept',
		                            function(c){
		                             return caml_exact_trampoline_cps_call
		                                     (sprintf,
		                                      bqU,
		                                      function(d){
		                                       return caml_trampoline_cps_call2
		       (d,
		        c,
		        function(c){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_posts,
		                  c,
		                  a,
		                  function(a){
		                   return caml_exact_trampoline_cps_call$0
		                           (namespace,
		                            cst_featurebase,
		                            'Featurebase: manage feedback posts, boards, comments, and votes.\n\nSee the "posts", "voters", and "comments" subgroups for details specific to each area.\n',
		                            [0, a, b],
		                            function(a){return cont([0, a, 0]);});
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 16:
		                   var l = cst_linkedin;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            l,
		                            [0,
		                             action$156,
		                             [0, action$157, [0, action$158, [0, action$159, 0]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      "engagement",
		                                      "Manage post comments and reactions",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        l,
		        [0,
		         action$151,
		         [0,
		          action$152,
		          [0, action$153, [0, action$154, [0, action$155, 0]]]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  cst_posts,
		                  'Create and manage LinkedIn posts and images\n\n# Images\nTo post an image, first call "Initialize Image Upload", PUT the image binary to the returned upload URL, then pass the returned image URN to "Create Image Post".',
		                  b,
		                  function(c){
		                   var b = [0, c, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            l,
		                            [0,
		                             action$147,
		                             [0, action$148, [0, action$149, [0, action$150, 0]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_profile,
		                                      "Read authenticated user profile and organization access",
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_linkedin,
		        'LinkedIn: read profiles and organizations, publish posts, and manage comments and reactions\n\n# Organization-only\nActs only on behalf of organizations, never individual members. Use organization URNs (from "Get User Organizations"), never \'urn:li:person:...\'.\n\n# URNs\nLinkedIn identifies entities with URNs. Organizations are "urn:li:organization:{id}" and posts are "urn:li:ugcPost:{id}" or "urn:li:share:{id}".\nPass URNs in their raw form, e.g. "urn:li:organization:12345"; do NOT URL-encode them.\n',
		        [0, a, b],
		        function(a){return cont([0, a, 0]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  case 17:
		                   var j = cst_instantly;
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            j,
		                            [0, action$106, [0, action$107, [0, action$108, 0]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_emails,
		                                      "Read the Unibox, reply to messages, and triage threads",
		                                      a,
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$2
		       (register_tools,
		        ctrl,
		        organization_id,
		        j,
		        [0,
		         action$102,
		         [0, action$103, [0, action$104, [0, action$105, 0]]]],
		        function(b){
		         return caml_exact_trampoline_cps_call$0
		                 (namespace,
		                  "campaigns",
		                  "List, inspect, and control campaign sending state",
		                  b,
		                  function(c){
		                   var b = [0, c, a];
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            j,
		                            [0,
		                             action$97,
		                             [0,
		                              action$98,
		                              [0, action$99, [0, action$100, [0, action$101, 0]]]]],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      "leads",
		                                      "Create, read, filter, and route leads across campaigns and lists",
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_instantly,
		        "Instantly: cold-email outreach automation. Manage leads, control campaigns, and triage replies in the Unibox.\n\n# IDs and pagination\nCampaign, list, and lead IDs are UUIDs returned by their respective list/get actions.\nList actions return up to 100 items per page; paginate by passing the previous page's cursor as 'starting_after'.",
		        [0, a, b],
		        function(a){return cont([0, a, 0]);});
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  default:
		                   return caml_exact_trampoline_cps_call$2
		                           (register_tools,
		                            ctrl,
		                            organization_id,
		                            cst_notion,
		                            tools$0,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$0
		                                     (namespace,
		                                      cst_notion,
		                                      'Notion: search, read, and write pages, databases, and blocks\n\n# IDs\nEvery page, database, and block has a UUID. Get IDs from "Search" or "Query Database", then pass them to the other actions.\n\n# Pages vs content\nA page has *properties* (structured fields, e.g. Title, Status) and *content* (the block tree in its body). "Get Page" / "Update Page" work on properties; "Get Block Children" / "Append Block Children" work on content.\n\n# Properties objects\nWhen creating or updating pages inside a database, the `properties` object is keyed by the database\'s property names, and each value matches that property\'s type, e.g.:\n\n```json\n{\n  "Name": { "title": [{ "text": { "content": "My task" } }] },\n  "Status": { "status": { "name": "In progress" } },\n  "Due": { "date": { "start": "2026-07-30" } }\n}\n```\n\nCall "Get Database" first to learn the exact property names and types before writing.\n\n# Blocks\nPage content is a list of block objects. A paragraph block looks like:\n\n```json\n{ "type": "paragraph", "paragraph": { "rich_text": [{ "type": "text", "text": { "content": "Hello" } }] } }\n```\n\nSee https://developers.notion.com/reference for the full properties, block, and filter reference.\n',
		                                      a,
		                                      function(a){return cont([0, a, 0]);});
		                            });
		                }
		               }
		               var letrec_function_context$1357 = [];
		               function integration_choice_schema_vers
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1357[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bJN, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1357[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1357[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1357[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (Id$8[4],
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   function(f0, cont){return cont([1, f0]);},
		   function(param, cont){
		    if(0 === param[0]) return cont(0);
		    var f0 = param[1];
		    return cont([0, f0]);
		   },
		   1,
		   0,
		   cst_mcp_server,
		   cst_Mcp_server,
		   [0,
		    0,
		    0,
		    [7,
		     function(param, cont){var id = param[1]; return cont(id);},
		     function(id, cont){return cont([0, id, 0]);},
		     [0, [0, 0, 0, 0, 0, cst_id, 0, 2, [0, b], 0, 0], 0]],
		    0],
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (connection_id_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0, 0, 0, 0, 0, cst_connectionId, 0, 2, [0, c], 0, 0],
		            0];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$250,
		                 schematic_version,
		                 function(c){
		                  var
		                   res =
		                     [11,
		                      bJO,
		                      [0,
		                       [0,
		                        function(param, cont){
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, f0, f1]);
		                        },
		                        function(param, cont){
		                         if(0 !== param[0]) return cont(0);
		                         var f1 = param[2], f0 = param[1];
		                         return cont([0, [0, f0, f1]]);
		                        },
		                        1,
		                        0,
		                        cst_membrane,
		                        cst_Membrane,
		                        [0,
		                         0,
		                         0,
		                         [7,
		                          function(param, cont){
		                           var connection_id = param[2][1], integration_key = param[1];
		                           return cont([0, integration_key, connection_id]);
		                          },
		                          function(param, cont){
		                           var connection_id = param[2], integration_key = param[1];
		                           return cont([0, integration_key, [0, connection_id, 0]]);
		                          },
		                          [0,
		                           [0, 0, 0, 0, 0, cst_integrationKey, 0, 2, [0, c], 0, 0],
		                           b]],
		                         0],
		                        0],
		                       a],
		                      0];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1357[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1357[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1317 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1357, [0, schematic_cache$1317]);
		               caml_callback
		                (integration_choice_schema_vers,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1358 = [];
		               function enable_integration_input_schem
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1358[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bJP, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1358[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1358[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1358[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (integration_choice_schema_vers,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var integration = param[1];
		   return cont([0, integration]);
		  },
		  function(param, cont){
		   var integration = param[1];
		   return cont([0, integration, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_integration, 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1358[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1358[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1318 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1358, [0, schematic_cache$1318]);
		               caml_callback
		                (enable_integration_input_schem,
		                 [function(param, cont){return cont(0);}]);
		               var
		                open$32 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$53 = open$32[14],
		                letrec_function_context$1359 = [];
		               function search_input_schema_versioned$0
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1359[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJW, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1359[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1359[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1359[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var q = param[1];
		                       return cont([0, q]);
		                      },
		                      function(param, cont){
		                       var q = param[1];
		                       return cont([0, q, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_q,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1359[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1359[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1319 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1359, [0, schematic_cache$1319]);
		               caml_callback
		                (search_input_schema_versioned$0,
		                 [function(param){return 0;}]);
		               var letrec_function_context$1360 = [];
		               function article_output_schema_versione
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1360[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJX, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1360[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1360[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1360[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        body = a[2][1],
		                        url = a[1],
		                        title = param[1];
		                       return cont([0, title, url, body]);
		                      },
		                      function(param, cont){
		                       var body = param[3], url = param[2], title = param[1];
		                       return cont([0, title, [0, url, [0, body, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_title,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       [0,
		                        [0,
		                         0,
		                         0,
		                         0,
		                         0,
		                         cst_url,
		                         0,
		                         2,
		                         [0, schematic_param_name_schema_ve],
		                         0,
		                         0],
		                        [0,
		                         [0,
		                          0,
		                          0,
		                          0,
		                          0,
		                          cst_body,
		                          0,
		                          2,
		                          [0, schematic_param_name_schema_ve],
		                          0,
		                          0],
		                         0]]]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1360[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1360[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1320 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1360, [0, schematic_cache$1320]);
		               caml_callback
		                (article_output_schema_versione, [function(param){return 0;}]);
		               var letrec_function_context$1361 = [];
		               function search_output_schema_versioned
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1361[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJY, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1361[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1361[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1361[1][1] = a;
		                  return caml_exact_trampoline_cps_call
		                          (article_output_schema_versione,
		                           schematic_version,
		                           function(a){
		                            var
		                             res =
		                               [7,
		                                function(param, cont){
		                                 var articles = param[1];
		                                 return cont([0, articles]);
		                                },
		                                function(param, cont){
		                                 var articles = param[1];
		                                 return cont([0, articles, 0]);
		                                },
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  "articles",
		                                  0,
		                                  2,
		                                  [0, [0, 0, 0, [3, a], 0]],
		                                  0,
		                                  0],
		                                 0]];
		                            return caml_exact_trampoline_cps_call$0
		                                    (set$3,
		                                     letrec_function_context$1361[1][1],
		                                     schematic_schema_version,
		                                     res,
		                                     function(a){
		                                      letrec_function_context$1361[1][1] = a;
		                                      return cont(res);
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1321 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1361, [0, schematic_cache$1321]);
		               caml_callback
		                (search_output_schema_versioned, [function(param){return 0;}]);
		               function search_articles(ctrl, input, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          function a(articles, cont){
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    articles,
		                                    function(param, cont){
		                                     var body = param[3], url = param[2], title = param[1];
		                                     return cont([0, title, url, body]);
		                                    },
		                                    function(articles){
		                                     return caml_trampoline_cps_call2
		     (return$13, [0, articles], cont);
		                                    });
		                          }
		                          return caml_trampoline_cps_call3
		                                  (Api[6][1],
		                                   api,
		                                   input[1],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (map_error$0,
		     function(e, cont){
		      return caml_exact_trampoline_cps_call$1
		              (to_to_string,
		               pp$125,
		               e,
		               function(msg){
		                return caml_exact_trampoline_cps_call
		                        (Sync[4],
		                         function(m, cont){
		                          return caml_trampoline_cps_call5(m, 0, 0, bJZ, msg, cont);
		                         },
		                         function(a){return cont(msg);});
		               });
		     },
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$53, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var letrec_function_context$1362 = [];
		               function fetch_url_input_schema_version
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1362[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJ1, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1362[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1362[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1362[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var url = param[1];
		                       return cont([0, url]);
		                      },
		                      function(param, cont){
		                       var url = param[1];
		                       return cont([0, url, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_url,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1362[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1362[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1322 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1362, [0, schematic_cache$1322]);
		               caml_callback
		                (fetch_url_input_schema_version, [function(param){return 0;}]);
		               var letrec_function_context$1363 = [];
		               function fetch_url_output_schema_versio
		               (schematic_version, cont){
		                var schematic_schema_version = schematic_version(V$4);
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context$1363[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           return cont([0, bJ2, 0, descriptor, 0]);
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context$1363[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1363[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(a){
		                  letrec_function_context$1363[1][1] = a;
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var content = param[1];
		                       return cont([0, content]);
		                      },
		                      function(param, cont){
		                       var content = param[1];
		                       return cont([0, content, 0]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_content,
		                        0,
		                        2,
		                        [0, schematic_param_name_schema_ve],
		                        0,
		                        0],
		                       0]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1363[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1363[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var schematic_cache$1323 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1363, [0, schematic_cache$1323]);
		               caml_callback
		                (fetch_url_output_schema_versio, [function(param){return 0;}]);
		               function validate_public_url(url, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$19,
		                         url,
		                         function(uri){
		                          return caml_exact_trampoline_cps_call
		                                  (scheme$1,
		                                   uri,
		                                   function(scheme){
		                                    return caml_exact_trampoline_cps_call
		    (host$1,
		     uri,
		     function(host){
		      if(! scheme) return cont(bJ6);
		      if(! host) return cont(bJ5);
		      var s = scheme[1];
		      if(s !== cst_http && s !== cst_https)
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$262,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a, s, function(a){return cont([1, a]);});
		                });
		      var host$0 = host[1];
		      return caml_exact_trampoline_cps_call$0
		              (is_prefix_gen,
		               host$0,
		               cst$37,
		               equal$2,
		               function(b){
		                function a(host){
		                 return caml_exact_trampoline_cps_call$1
		                         (split$0,
		                          host,
		                          46,
		                          function(parts){
		                           function a(is_private){
		                            var b = host === "::1" ? 1 : 0;
		                            function a(is_private_ipv6){
		                             if(! is_private && ! is_private_ipv6) return cont(bJ4);
		                             return cont(bJ3);
		                            }
		                            return b
		                                    ? a(b)
		                                    : caml_exact_trampoline_cps_call$0
		                                      (is_prefix_gen,
		                                       host,
		                                       "fc",
		                                       equal$2,
		                                       function(b){
		return b
		        ? a(b)
		        : caml_exact_trampoline_cps_call$0
		          (is_prefix_gen, host, "fd", equal$2, a);
		                                       });
		                           }
		                           caml_push_trap
		                            (function(exn){
		                              var b = host === "metadata.google.internal" ? 1 : 0;
		                              return b
		                                      ? a(b)
		                                      : caml_exact_trampoline_cps_call$0
		(is_suffix_gen, host, ".internal", equal$2, a);
		                             });
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$7,
		                                    parts,
		                                    of_string$3,
		                                    function(val){
		                                     caml_pop_trap();
		                                     if(val){
		                                      var c = val[1];
		                                      if(128 <= c){
		                                       if(169 === c){
		c = val[2];
		if(c && 254 === c[1]){
		 c = c[2];
		 if(c){c = c[2]; if(c && ! c[2]) return a(1);}
		}
		                                       }
		                                       else if(172 === c){
		c = val[2];
		if(c){
		 var d = c[2];
		 if(d){
		  d = d[2];
		  if(d && ! d[2]){
		   var b = c[1];
		   if(16 <= b && 31 >= b) return a(1);
		  }
		 }
		}
		                                       }
		                                       else if(192 === c){
		c = val[2];
		if(c && 168 === c[1]){
		 c = c[2];
		 if(c){c = c[2]; if(c && ! c[2]) return a(1);}
		}
		                                       }
		                                      }
		                                      else if(0 === c){
		                                       c = val[2];
		                                       if(c){
		c = c[2];
		if(c){c = c[2]; if(c && ! c[2]) return a(1);}
		                                       }
		                                      }
		                                      else if(10 === c){
		                                       c = val[2];
		                                       if(c){
		c = c[2];
		if(c){c = c[2]; if(c && ! c[2]) return a(1);}
		                                       }
		                                      }
		                                      else if(127 <= c){
		                                       c = val[2];
		                                       if(c){
		c = c[2];
		if(c){c = c[2]; if(c && ! c[2]) return a(1);}
		                                       }
		                                      }
		                                     }
		                                     return a(0);
		                                    });
		                          });
		                }
		                return b
		                        ? caml_exact_trampoline_cps_call$0
		                          (is_suffix_gen,
		                           host$0,
		                           cst$36,
		                           equal$2,
		                           function(b){
		                            return b
		                                    ? caml_exact_trampoline_cps_call$0
		                                      (sub_fun,
		                                       host$0,
		                                       1,
		                                       caml_ml_string_length(host$0) - 2 | 0,
		                                       a)
		                                    : a(host$0);
		                           })
		                        : a(host$0);
		               });
		     });
		                                   });
		                         });
		               }
		               function fetch_url(input, cont){
		                return caml_exact_trampoline_cps_call
		                        (validate_public_url,
		                         input[1],
		                         function(match){
		                          if(0 === match[0]){
		                           var
		                            url = input[1],
		                            a =
		                              function(result, cont){
		                               if(0 === result[0]){
		                                var content = result[1];
		                                return caml_trampoline_cps_call2
		(return$12, [0, [0, content]], cont);
		                               }
		                               var error = result[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (kasprintf,
		id,
		fmt$263,
		function(a){
		 return caml_trampoline_cps_call3
		         (a,
		          pp$126,
		          error,
		          function(error_msg){
		           return caml_trampoline_cps_call2
		                   (return$12, [1, error_msg], cont);
		          });
		});
		                              };
		                           return caml_exact_trampoline_cps_call
		                                   (of_string$19,
		                                    url,
		                                    function(uri){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$8,
		   symbol_map$6,
		   ,
		   bind$10,
		   return$12,
		   map$23,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$4]),
		                                      symbol_bind = open[1];
		                                     function b(a, cont){
		                                      if(0 === a[0]){
		                                       var content = a[1];
		                                       return caml_trampoline_cps_call2(return$13, content, cont);
		                                      }
		                                      a = a[1][2];
		                                      if(typeof a !== "number"){
		                                       var variant = a[1];
		                                       if(804243368 <= variant){
		var error = a[2];
		return caml_exact_trampoline_cps_call(fail$2, error, cont);
		                                       }
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (fail$2, -774758938, cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (to_uri,
		      uri,
		      function(c){
		       return caml_exact_trampoline_cps_call$3
		               (Fetch_http[8],
		                0,
		                0,
		                0,
		                Fetch_http[3],
		                c,
		                function(c){
		                 return caml_trampoline_cps_call3
		                         (symbol_bind,
		                          c,
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol_bind$6, b, a, cont);
		                          });
		                });
		      });
		                                    });
		                          }
		                          var msg = match[1];
		                          return caml_trampoline_cps_call2(return$12, [1, msg], cont);
		                         });
		               }
		               function schematic_version$361(param){return 0;}
		               function schematic_version$362(param){return 0;}
		               var
		                e =
		                  caml_callback
		                   (fetch_url_output_schema_versio, [schematic_version$361]),
		                d =
		                  caml_callback
		                   (object_schema,
		                    [bJ7,
		                     0,
		                     caml_callback
		                      (fetch_url_input_schema_version, [schematic_version$362])]),
		                web_tools =
		                  [0,
		                   caml_callback
		                    (tool,
		                     ["fetchUrl",
		                      0,
		                      0,
		                      "\nFetch the content of a public URL.\nReturns the text content of the page.\nOnly http and https schemes are supported.\nPrivate, internal, or link-local addresses are not allowed.\n",
		                      read$2(1),
		                      d,
		                      e,
		                      fetch_url]),
		                   0];
		               function silo$0(ctrl, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (silo, ctrl[22], 3, cst_external_mcp, cont);
		               }
		               function schematic_version$363(param, cont){return cont(0);}
		               var
		                schema$255 =
		                  [0,
		                   0,
		                   0,
		                   [3,
		                    caml_callback(schema_versioned$533, [schematic_version$363])],
		                   0],
		                servers_key = [0, "servers", schema$255];
		               function list$2(ctrl, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(servers, cont){return cont(value$4(servers, 0));}
		                return caml_exact_trampoline_cps_call
		                        (silo$0,
		                         ctrl,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (get$16,
		                                   b,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     servers_key,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function enabled(ctrl, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(servers, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (filter,
		                          servers,
		                          function(s, cont){return cont(s[5]);},
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (list$2,
		                         ctrl,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function find$9(ctrl, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function a(servers, cont){
		                 function a(param){
		                  if(! param) return cont(0);
		                  var l = param[2], x = param[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (Id$8[15],
		                           x[1],
		                           id,
		                           function(b){
		                            return b ? cont([0, x]) : caml_exact_trampoline_call1(a, l);
		                           });
		                 }
		                 return a(servers);
		                }
		                return caml_exact_trampoline_cps_call
		                        (list$2,
		                         ctrl,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function set_all(ctrl, servers, cont){
		                return caml_exact_trampoline_cps_call
		                        (silo$0,
		                         ctrl,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (set$27,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (a, servers_key, servers, cont);
		                                   });
		                         });
		               }
		               function upsert$3(ctrl, server, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3];
		                function a(servers, cont){
		                 function a(t){
		                  function b(existing){
		                   function a(servers){
		                    return caml_exact_trampoline_cps_call$1
		                            (set_all, ctrl, servers, cont);
		                   }
		                   return existing
		                           ? caml_trampoline_cps_call3
		                             (map$18,
		                              servers,
		                              function(s, cont){
		                               return caml_exact_trampoline_cps_call$1
		                                       (Id$8[15],
		s[1],
		server[1],
		function(a){return a ? cont(server) : cont(s);});
		                              },
		                              a)
		                           : caml_exact_trampoline_cps_call$1
		                             (append$0, servers, [0, server, 0], a);
		                  }
		                  if(! t) return b(0);
		                  var xs = t[2], x = t[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (Id$8[15],
		                           x[1],
		                           server[1],
		                           function(c){
		                            return c ? b(1) : caml_exact_trampoline_call1(a, xs);
		                           });
		                 }
		                 return a(servers);
		                }
		                return caml_exact_trampoline_cps_call
		                        (list$2,
		                         ctrl,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function remove$28(ctrl, id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3];
		                function a(servers, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (filter,
		                          servers,
		                          function(s, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (Id$8[15], s[1], id, function(a){return cont(1 - a);});
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (set_all, ctrl, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (list$2,
		                         ctrl,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function model(a){
		                var default$ = cst_gpt_5_6_luna;
		                if(! dev$0) return default$;
		                a = getenv_opt("OPENAI_MODEL");
		                if(a){var m = a[1]; if(m !== cst$1) return m;}
		                return default$;
		               }
		               var
		                opaque_reference_schema =
		                  map$14
		                   (of_string$40, to_string$48, schematic_param_name_schema_ve),
		                letrec_function_context$1364 = [];
		               function reference_data_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1364[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bJ9, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1364[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1364[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1364[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$555,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var parts = param[2][1], reference_id = param[1];
		   return cont([0, reference_id, parts]);
		  },
		  function(param, cont){
		   var parts = param[2], reference_id = param[1];
		   return cont([0, reference_id, [0, parts, 0]]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    "reference_id",
		    0,
		    2,
		    [0, opaque_reference_schema],
		    0,
		    0],
		   [0, [0, 0, 0, 0, 0, cst_parts, 0, 2, [1, a], 0, 0], 0]]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1364[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1364[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1324 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1364, [0, schematic_cache$1324]);
		               caml_callback
		                (reference_data_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1365 = [];
		               function reference_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1365[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bJ_, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1365[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1365[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1365[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (reference_data_schema_versione,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a = [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, b], 0, 0], 0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$253,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var data = param[2][1], key = param[1];
		             return cont([0, key, data]);
		            },
		            function(param, cont){
		             var data = param[2], key = param[1];
		             return cont([0, key, [0, data, 0]]);
		            },
		            [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, b], 0, 0], a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1365[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1365[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1325 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1365, [0, schematic_cache$1325]);
		               caml_callback
		                (reference_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1366 = [];
		               function schema_versioned$582(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1366[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bJ$, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1366[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1366[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1366[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (reference_schema_versioned,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_references,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$255,
		       schematic_version,
		       function(c){
		        var
		         b =
		           [0,
		            [0,
		             0,
		             0,
		             0,
		             0,
		             cst_mentions,
		             0,
		             2,
		             [0, [0, 0, 0, [3, c], 0]],
		             0,
		             0],
		            a];
		        return caml_exact_trampoline_cps_call
		                (schema_versioned$254,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        references = a[2][1],
		                        mentions = a[1],
		                        integrations = param[1];
		                       return cont([0, integrations, mentions, references]);
		                      },
		                      function(param, cont){
		                       var
		                        references = param[3],
		                        mentions = param[2],
		                        integrations = param[1];
		                       return cont
		                               ([0, integrations, [0, mentions, [0, references, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_integrations,
		                        0,
		                        2,
		                        [0, [0, 0, 0, [3, a], 0]],
		                        0,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1366[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1366[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1326 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1366, [0, schematic_cache$1326]);
		               caml_callback
		                (schema_versioned$582,
		                 [function(param, cont){return cont(0);}]);
		               function encode_prompt_context(context, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         context[3],
		                         function(a, cont){
		                          var data = a[2], key = a[1];
		                          switch(data[0]){
		                            case 0:
		                             var id = data[1], a = [0, id]; break;
		                            case 1:
		                             var id$0 = data[1], a = [1, id$0]; break;
		                            case 2:
		                             var id$1 = data[1], a = [2, id$1]; break;
		                            case 3:
		                             var id$2 = data[1], a = [3, id$2]; break;
		                            case 4:
		                             a = data[1];
		                             if(0 === a[0]){
		                              a = a[1];
		                              var
		                               row_id = a[3],
		                               table_id = a[2],
		                               workspace_id = a[1],
		                               a = [4, [0, [0, workspace_id, table_id, row_id]]];
		                             }
		                             else
		                              var id$3 = a[1], a = [4, [1, id$3]];
		                             break;
		                            case 5:
		                             var id$4 = data[1], a = [5, id$4]; break;
		                            case 6:
		                             a = data[1];
		                             var
		                              row_id$0 = a[3],
		                              table_id$0 = a[2],
		                              workspace_id$0 = a[1],
		                              a = [6, [0, workspace_id$0, table_id$0, row_id$0]];
		                             break;
		                            case 7:
		                             var id$5 = data[1], a = [7, id$5]; break;
		                            case 8:
		                             a = data[1];
		                             var
		                              table_id$1 = a[2],
		                              workspace_id$1 = a[1],
		                              a = [8, [0, workspace_id$1, table_id$1]];
		                             break;
		                            case 9:
		                             a = data[1];
		                             var
		                              workspace_id$2 = a[2],
		                              org_id = a[1],
		                              a = [9, [0, org_id, workspace_id$2]];
		                             break;
		                            case 10:
		                             a = data[1];
		                             var
		                              agent_id = a[2],
		                              org_id$0 = a[1],
		                              a = [10, [0, org_id$0, agent_id]];
		                             break;
		                            case 11:
		                             a = data[1];
		                             var
		                              automation_id = a[2],
		                              org_id$1 = a[1],
		                              a = [11, [0, org_id$1, automation_id]];
		                             break;
		                            case 12:
		                             a = data[1];
		                             var
		                              conversation_id = a[3],
		                              agent_id$0 = a[2],
		                              org_id$2 = a[1],
		                              a = [12, [0, org_id$2, agent_id$0, conversation_id]];
		                             break;
		                            default:
		                             a = data[1];
		                             var
		                              automation_run_id = a[3],
		                              automation_id$0 = a[2],
		                              org_id$3 = a[1],
		                              a = [13, [0, org_id$3, automation_id$0, automation_run_id]];
		                          }
		                          return cont([0, key, [0, data, a]]);
		                         },
		                         function(b){
		                          var a = [0, context[1], context[2], b];
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$582,
		                                   schematic_version,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(encode$4, b, a, cont);
		                                   });
		                         });
		               }
		               function hex_to_string(hex, cont){
		                var n = caml_ml_string_length(hex);
		                function a(){return cont(0);}
		                return 0 === n
		                        ? a()
		                        : caml_exact_trampoline_cps_call$1
		                          (symbol$23,
		                           n,
		                           2,
		                           function(b){
		                            if(0 !== b) return a();
		                            function hex_digit(c, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (between$1,
		                                      c,
		                                      48,
		                                      57,
		                                      function(a){
		                                       return a
		       ? cont([0, c - 48 | 0])
		       : caml_exact_trampoline_cps_call$0
		         (between$1,
		          c,
		          97,
		          102,
		          function(a){
		           return a ? cont([0, (c - 97 | 0) + 10 | 0]) : cont(0);
		          });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (init$7,
		                                     n / 2 | 0,
		                                     function(i, cont){
		                                      return caml_exact_trampoline_cps_call
		      (hex_digit,
		       caml_string_get(hex, i * 2 | 0),
		       function(match){
		        return caml_exact_trampoline_cps_call
		                (hex_digit,
		                 caml_string_get(hex, (i * 2 | 0) + 1 | 0),
		                 function(match$0){
		                  if(match && match$0){
		                   var lo = match$0[1], hi = match[1];
		                   return cont(of_int$0(hi << 4 | lo));
		                  }
		                  return cont(0);
		                 });
		       });
		                                     },
		                                     function(t){
		                                      function a(t, init){
		                                       if(! t)
		return caml_exact_trampoline_cps_call$1
		        (map$3,
		         init,
		         function(chars, cont){
		          return caml_exact_trampoline_cps_call
		                  (of_rev_keys,
		                   chars,
		                   function(a){
		                    return caml_exact_trampoline_cps_call(of_char_list, a, cont);
		                   });
		         },
		         cont);
		                                       var l = t[2], char_opt = t[1];
		                                       if(init && char_opt){
		var c = char_opt[1], chars = init[1];
		return caml_exact_trampoline_call2(a, l, [0, [0, c, chars]]);
		                                       }
		                                       return caml_exact_trampoline_call2(a, l, 0);
		                                      }
		                                      return a(t, init$4);
		                                     });
		                           });
		               }
		               function decode_integration_tokens(message, cont){
		                var n = caml_ml_string_length(message);
		                function a(pos, acc){
		                 return n <= pos
		                         ? caml_exact_trampoline_cps_call
		                           (of_rev_keys,
		                            acc,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (concat$0, bKc, a, cont);
		                            })
		                         : caml_exact_trampoline_cps_call$2
		                           (substr_index_gen,
		                            1,
		                            [0, pos],
		                            message,
		                            ">integration:",
		                            function(match){
		                             if(! match)
		                              return caml_exact_trampoline_cps_call$1
		                                      (drop_prefix,
		                                       message,
		                                       pos,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (of_rev_keys,
		         [0, a, acc],
		         function(a){
		          return caml_exact_trampoline_cps_call$1
		                  (concat$0, bKd, a, cont);
		         });
		                                       });
		                             var token_start = match[1];
		                             return caml_exact_trampoline_cps_call$0
		                                     (sub_fun,
		                                      message,
		                                      pos,
		                                      token_start - pos | 0,
		                                      function(before){
		                                       var body_start = token_start + 13 | 0;
		                                       function b(body_end){
		function d(){
		 return caml_exact_trampoline_cps_call$0
		         (sub_fun,
		          message,
		          body_start,
		          body_end - body_start | 0,
		          function(body){
		           return caml_exact_trampoline_cps_call$1
		                   (split$0,
		                    body,
		                    58,
		                    function(match){
		                     function b(match){
		                      function b(replacement){
		                       var acc$0 = [0, replacement, [0, before, acc]];
		                       return caml_exact_trampoline_call2(a, body_end, acc$0);
		                      }
		                      if(! match)
		                       return caml_exact_trampoline_cps_call$0
		                               (sub_fun,
		                                message,
		                                token_start,
		                                body_end - token_start | 0,
		                                b);
		                      var decoded = match[1];
		                      return b(decoded);
		                     }
		                     if(match){
		                      var match$0 = match[2], hex_key = match[1];
		                      if(! match$0){
		                       var
		                        c =
		                          function(key, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (capitalize_ascii,
		                                    key,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (sprintf,
		      bKb,
		      function(b){return caml_trampoline_cps_call2(b, a, cont);});
		                                    });
		                          };
		                       return caml_exact_trampoline_cps_call
		                               (hex_to_string,
		                                hex_key,
		                                function(a){
		                                 return caml_exact_trampoline_cps_call$1(map$3, a, c, b);
		                                });
		                      }
		                      if(! match$0[2]){
		                       var hex_id = match$0[1];
		                       return caml_exact_trampoline_cps_call
		                               (hex_to_string,
		                                hex_key,
		                                function(match){
		                                 return caml_exact_trampoline_cps_call
		 (hex_to_string,
		  hex_id,
		  function(match$0){
		   if(match && match$0){
		    var id = match$0[1], key = match[1];
		    return caml_exact_trampoline_cps_call
		            (capitalize_ascii,
		             key,
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (sprintf,
		                       bKa,
		                       function(c){
		                        return caml_trampoline_cps_call3
		                                (c, a, id, function(a){return b([0, a]);});
		                       });
		             });
		   }
		   return b(0);
		  });
		                                });
		                      }
		                     }
		                     return b(0);
		                    });
		          });
		}
		if(n <= body_end) return d();
		var c = caml_string_get(message, body_end);
		return caml_exact_trampoline_cps_call
		        (is_whitespace,
		         c,
		         function(a){
		          if(a)
		           ;
		          else {
		           a = c === 64;
		           if(a) ; else {a = c === 62; a ||= c === 33;}
		          }
		          if(a) return d();
		          var pos = body_end + 1 | 0;
		          return caml_exact_trampoline_call1(b, pos);
		         });
		                                       }
		                                       return b(body_start);
		                                      });
		                            });
		                }
		                return a(0, 0);
		               }
		               var letrec_function_context$1367 = [];
		               function env_connection_schema_versione
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1367[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bKe, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1367[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1367[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1367[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_connectionId,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                0];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$251,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var connection_id = param[2][1], integration_key = param[1];
		   return cont([0, integration_key, connection_id]);
		  },
		  function(param, cont){
		   var connection_id = param[2], integration_key = param[1];
		   return cont([0, integration_key, [0, connection_id, 0]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_integrationKey, 0, 2, [0, b], 0, 0],
		   a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1367[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1367[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1327 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1367, [0, schematic_cache$1327]);
		               caml_callback
		                (env_connection_schema_versione,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1368 = [];
		               function env_user_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1368[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bKf, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1368[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1368[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(b){
		                            letrec_function_context$1368[1][1] = b;
		                            var
		                             a =
		                               [0,
		                                [0, 0, 0, 0, 0, cst_email, 0, 2, [0, schema$72], 0, 0],
		                                [0,
		                                 [0,
		                                  0,
		                                  0,
		                                  0,
		                                  0,
		                                  cst_givenName,
		                                  0,
		                                  3,
		                                  [0, schematic_param_name_schema_ve],
		                                  0,
		                                  0],
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_familyName,
		                                   0,
		                                   3,
		                                   [0, schematic_param_name_schema_ve],
		                                   0,
		                                   0],
		                                  [0,
		                                   [0,
		                                    0,
		                                    0,
		                                    0,
		                                    0,
		                                    cst_timezone,
		                                    0,
		                                    2,
		                                    [0, schematic_param_name_schema_ve],
		                                    0,
		                                    0],
		                                   0]]]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$117,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    c = b[2],
		    timezone = c[2][1],
		    family_name = c[1],
		    given_name = b[1],
		    email = a[1],
		    account_id = param[1];
		   return cont
		           ([0, account_id, email, given_name, family_name, timezone]);
		  },
		  function(param, cont){
		   var
		    timezone = param[5],
		    family_name = param[4],
		    given_name = param[3],
		    email = param[2],
		    account_id = param[1];
		   return cont
		           ([0,
		             account_id,
		             [0,
		              email,
		              [0, given_name, [0, family_name, [0, timezone, 0]]]]]);
		  },
		  [0, [0, 0, 0, 0, 0, cst_accountId, 0, 2, [0, b], 0, 0], a]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1368[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1368[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1328 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1368, [0, schematic_cache$1328]);
		               caml_callback
		                (env_user_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1369 = [];
		               function organization_summary_schema_ve
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1369[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bKg, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1369[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1369[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1369[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (workspace_summary_schema_versi,
		                                     schematic_version,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (capped_list_schema_versioned,
		       schematic_version,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (b,
		                 a,
		                 function(b){
		                  var
		                   a =
		                     [0, [0, 0, 0, 0, 0, cst_workspaces, 0, 2, [0, b], 0, 0], 0];
		                  return caml_exact_trampoline_cps_call
		                          (schema_versioned$120,
		                           schematic_version,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 0,
		                                 0,
		                                 0,
		                                 0,
		                                 cst_name,
		                                 0,
		                                 2,
		                                 [0, schematic_param_name_schema_ve],
		                                 0,
		                                 0],
		                                [0,
		                                 [0, 0, 0, 0, 0, "defaultWorkspaceId", 0, 2, [0, c], 0, 0],
		                                 a]];
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$104,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var
		    a = param[2],
		    b = a[2],
		    workspaces = b[2][1],
		    default_workspace_id = b[1],
		    name = a[1],
		    organization_id = param[1];
		   return cont
		           ([0,
		             organization_id,
		             name,
		             default_workspace_id,
		             workspaces]);
		  },
		  function(param, cont){
		   var
		    workspaces = param[4],
		    default_workspace_id = param[3],
		    name = param[2],
		    organization_id = param[1];
		   return cont
		           ([0,
		             organization_id,
		             [0, name, [0, default_workspace_id, [0, workspaces, 0]]]]);
		  },
		  [0,
		   [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, a], 0, 0],
		   b]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1369[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1369[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1329 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1369, [0, schematic_cache$1329]);
		               caml_callback
		                (organization_summary_schema_ve,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1370 = [];
		               function env_context_schema_versioned(schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1370[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bKh, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1370[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1370[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1370[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (env_connection_schema_versione,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_connections,
		   0,
		   2,
		   [0, [0, 0, 0, [3, b], 0]],
		   0,
		   0],
		  0];
		                                      return caml_exact_trampoline_cps_call
		      (env_user_schema_versioned,
		       schematic_version,
		       function(c){
		        var
		         b = [0, [0, 0, 0, 0, 0, cst_user, 0, 2, [0, c], 0, 0], a];
		        return caml_exact_trampoline_cps_call
		                (organization_summary_schema_ve,
		                 schematic_version,
		                 function(a){
		                  var
		                   res =
		                     [7,
		                      function(param, cont){
		                       var
		                        a = param[2],
		                        connections = a[2][1],
		                        user = a[1],
		                        organizations = param[1];
		                       return cont([0, organizations, user, connections]);
		                      },
		                      function(param, cont){
		                       var
		                        connections = param[3],
		                        user = param[2],
		                        organizations = param[1];
		                       return cont
		                               ([0, organizations, [0, user, [0, connections, 0]]]);
		                      },
		                      [0,
		                       [0,
		                        0,
		                        0,
		                        0,
		                        0,
		                        cst_organizations,
		                        0,
		                        2,
		                        [0, [0, 0, 0, [3, a], 0]],
		                        0,
		                        0],
		                       b]];
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1370[1][1],
		                           schematic_schema_version,
		                           res,
		                           function(a){
		                            letrec_function_context$1370[1][1] = a;
		                            return cont(res);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1330 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1370, [0, schematic_cache$1330]);
		               caml_callback
		                (env_context_schema_versioned,
		                 [function(param, cont){return cont(0);}]);
		               function input_item_of_message(msg, cont){
		                var role = msg[1];
		                if(typeof role !== "number" && 0 === role[0]){
		                 var attachments = role[1];
		                 if(attachments){
		                  var text_part = [0, msg[2]];
		                  return caml_exact_trampoline_cps_call$1
		                          (map$7,
		                           attachments,
		                           function(a, cont){
		                            var s = a[3];
		                            return caml_exact_trampoline_cps_call$0
		                                    (is_prefix_gen,
		                                     s,
		                                     "image/",
		                                     equal$2,
		                                     function(b){
		                                      return b
		      ? caml_exact_trampoline_cps_call
		        (to_uri, a[5], function(a){return cont([1, a]);})
		      : caml_exact_trampoline_cps_call
		        (to_uri, a[5], function(a){return cont([2, a]);});
		                                     });
		                           },
		                           function(file_parts){
		                            return cont([2, 948354667, [0, text_part, file_parts]]);
		                           });
		                 }
		                }
		                var
		                 api_role =
		                   typeof role === "number"
		                    ? 0 === role ? 662113039 : 519160618
		                    : 0 === role[0] ? 948354667 : -291661378;
		                return cont([0, api_role, msg[2]]);
		               }
		               function is_empty_content(param, cont){
		                var variant = param[1];
		                if(826371656 <= variant) return cont(0);
		                var s = param[2];
		                return caml_exact_trampoline_cps_call$1
		                        (strip, 0, s, function(a){return cont(is_empty$0(a));});
		               }
		               function format_section_content(label, content, cont){
		                var variant = content[1];
		                if(826371656 <= variant){
		                 var json = content[2];
		                 return caml_exact_trampoline_cps_call
		                         (to_string$15,
		                          json,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (sprintf,
		                                    bKi,
		                                    function(b){
		                                     return caml_trampoline_cps_call3(b, label, a, cont);
		                                    });
		                          });
		                }
		                var text = content[2];
		                return caml_exact_trampoline_cps_call$1
		                        (strip,
		                         0,
		                         text,
		                         function(data){
		                          var data$0 = is_empty$0(data) ? "(none)" : data;
		                          return caml_exact_trampoline_cps_call
		                                  (sprintf,
		                                   bKj,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(a, label, data$0, cont);
		                                   });
		                         });
		               }
		               function build_environment_section
		               (ctrl, integrations, organizations_scope, cont){
		                var organization_ids = organizations$0(organizations_scope);
		                function a(environment_text){
		                 return caml_exact_trampoline_cps_call
		                         (main,
		                          ctrl,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (get$17,
		                                    a,
		                                    function(profile){
		                                     return caml_exact_trampoline_cps_call
		     (user_id,
		      ctrl[1],
		      function(user_id){
		       var match = profile[3];
		       if(match)
		        var
		         userinfo = match[1][6],
		         family_name_opt = userinfo[3],
		         given_name_opt = userinfo[4];
		       else {family_name_opt = 0; given_name_opt = 0;}
		       return caml_exact_trampoline_cps_call
		               (to_string$19,
		                timezone_local,
		                function(a){
		                 var
		                  user =
		                    [0, user_id, profile[1], given_name_opt, family_name_opt, a];
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          integrations,
		                          function(param, cont){
		                           var connection_id = param[2], key = param[1];
		                           return cont([0, key, connection_id]);
		                          },
		                          function(connections){
		                           return caml_exact_trampoline_cps_call
		                                   (state_personal,
		                                    ctrl[2],
		                                    function(match){
		                                     var organizations = match[15];
		                                     return caml_exact_trampoline_cps_call$1
		     (filter_map$0,
		      organization_ids,
		      function(organization_id, cont){
		       var
		        open =
		          g
		           ([0,
		             symbol_bind,
		             symbol_map$1,
		             ,
		             bind,
		             return$4,
		             map$3,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax]),
		        let$ = open[4];
		       function a(org, cont){
		        return caml_exact_trampoline_cps_call
		                (default_workspace_of_organizat,
		                 organization_id,
		                 function(default_workspace_id){
		                  return caml_exact_trampoline_cps_call
		                          (encode,
		                           org[4],
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (stable_sort,
		                                     a,
		                                     sort_organization_workspaces,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (map$7,
		       a,
		       function(workspace, cont){
		        return cont([0, workspace[2], workspace[3][2]]);
		       },
		       function(workspace_summaries){
		        return caml_exact_trampoline_cps_call$1
		                (cap,
		                 10,
		                 workspace_summaries,
		                 function(a){
		                  return cont
		                          ([0, organization_id, org[3][4][2], default_workspace_id, a]);
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                organizations,
		                organization_id,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      },
		      function(organizations){
		       var env_context = [0, organizations, user, connections];
		       function schematic_version(param, cont){return cont(0);}
		       return caml_exact_trampoline_cps_call
		               (env_context_schema_versioned,
		                schematic_version,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (encode$4,
		                          a,
		                          env_context,
		                          function(env_json){
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$15,
		                                    env_json,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (sprintf,
		      bKk,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(envJson){
		                 return caml_exact_trampoline_cps_call$1
		                         (concat$0,
		                          bKl,
		                          [0, environment_text, [0, envJson, 0]],
		                          cont);
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return 0 === organizations_scope[0]
		                        ? caml_exact_trampoline_cps_call
		                          (trim,
		                           "- You are operating inside a single organization whose identifier is unique.\n- You must only reference entities explicitly provided in context.\n- The organization contains one or more workspaces, each with a unique identifier.\n- You can find the list of workspaces with the `listWorkspaces` tool.\n- Workspaces contain one or more databases with unique identifiers.\n- Users may refer to workspaces or databases by human-readable names.\n- The organization may be connected to third-party integrations.\n- All Routine IDs are opaque strings created and owned by Routine; never construct or guess one. Only use IDs obtained from tool responses or from the JSON in this section.\n- IDs are prefixed by their kind: task:..., event:..., page:..., account:..., org:..., workspace:..., etc. Only use an id where its kind matches what is expected.\n",
		                           a)
		                        : caml_exact_trampoline_cps_call
		                          (trim,
		                           "- You are operating on behalf of the User.\n- You have access to all the organizations the user has access to.\n- You must only reference entities explicitly provided in context.\n- The organization contains one or more workspaces, each with a unique identifier.\n- Workspaces contain one or more databases with unique identifiers.\n- Users may refer to workspaces or databases by human-readable names.\n- The organization may be connected to third-party integrations.\n- All Routine IDs are opaque strings created and owned by Routine; never construct or guess one. Only use IDs obtained from tool responses or from the JSON in this section.\n- IDs are prefixed by their kind: task:..., event:..., page:..., account:..., org:..., workspace:..., etc. Only use an id where its kind matches what is expected.\n",
		                           a);
		               }
		               function extract_tools_from_context
		               (graph,
		                ctrl,
		                agent_id,
		                workspace,
		                include_ask_user,
		                connection_manager,
		                opt,
		                context,
		                organizations_scope,
		                cont){
		                var
		                 external_mcp_servers = opt ? opt[1] : 0,
		                 organization_ids = organizations$0(organizations_scope),
		                 organization_id = organizations_scope[1];
		                return caml_exact_trampoline_cps_call
		                        (user_id,
		                         ctrl[1],
		                         function(user_id){
		                          return caml_exact_trampoline_cps_call
		                                  (personal_organization_of_user_,
		                                   user_id,
		                                   function(personal_org_id){
		                                    return caml_exact_trampoline_cps_call$0
		    (mem,
		     organization_ids,
		     personal_org_id,
		     equal$53,
		     function(include_personal){
		      function a(agent_tools){
		       return caml_exact_trampoline_cps_call$8
		               (register,
		                include_personal,
		                [0, include_ask_user],
		                workspace,
		                graph,
		                ctrl,
		                [0, agent_tools],
		                dummy,
		                function(routine_tools){
		                 function a(a, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (search_articles, ctrl, a, cont);
		                 }
		                 function schematic_version(param){return 0;}
		                 return caml_exact_trampoline_cps_call
		                         (search_output_schema_versioned,
		                          schematic_version,
		                          function(b){
		                           function schematic_version(param){return 0;}
		                           return caml_exact_trampoline_cps_call
		                                   (search_input_schema_versioned$0,
		                                    schematic_version,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$0
		     (object_schema,
		      bJ0,
		      0,
		      c,
		      function(c){
		       return caml_exact_trampoline_cps_call$9
		               (tool,
		                "searchArticles",
		                0,
		                0,
		                "Search articles from the Routine help website.\nReturns matching articles with their title, URL, and full HTML content.\nUse this to answer questions about how Routine works.",
		                read$2(0),
		                c,
		                b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (namespace,
		                          cst_help$1,
		                          "Access the Routine help website (https://help.routine.co)",
		                          [0, a, 0],
		                          function(a){
		                           var help_tools = [0, a, 0];
		                           return caml_exact_trampoline_cps_call$1
		                                   (partition_map,
		                                    context[1],
		                                    function(param, cont){
		                                     var org_id = param[3], key = param[1];
		                                     if(0 === key[0]){
		                                      var key$0 = key[1];
		                                      return cont([0, [0, key$0, org_id]]);
		                                     }
		                                     var id = key[1];
		                                     return cont([1, id]);
		                                    },
		                                    function(match){
		                                     var
		                                      mcp_server_ids = match[2],
		                                      membrane_connections = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (of_list$2,
		      [0, Id$8[24]],
		      mcp_server_ids,
		      function(selected_ids){
		       return caml_exact_trampoline_cps_call$1
		               (filter,
		                external_mcp_servers,
		                function(server, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (mem$3, selected_ids, server[1], cont);
		                },
		                function(selected_mcp_servers){
		                 return caml_exact_trampoline_cps_call$1
		                         (map$7,
		                          membrane_connections,
		                          function(param, cont){
		                           var
		                            org_id = param[2],
		                            key = param[1],
		                            org_id$0 = value$4(org_id, organization_id);
		                           return caml_exact_trampoline_cps_call$0
		                                   (register$0, ctrl, org_id$0, key, cont);
		                          },
		                          function(integration_tools_results){
		                           return caml_exact_trampoline_cps_call
		                                   (of_list,
		                                    integration_tools_results,
		                                    function(integration_namespaces){
		                                     var
		                                      cst_Third_party_integrations = "Third-party integrations",
		                                      integration_tools =
		is_empty(integration_namespaces)
		 ? 0
		 : [0,
		   [1,
		    cst_integrations,
		    cst_Third_party_integrations,
		    integration_namespaces],
		   0],
		                                      cst_Tools_from_user_configured =
		"Tools from user-configured external MCP servers",
		                                      cst_mcpServers = "mcpServers";
		                                     function a(connection_management_tools){
		                                      return caml_exact_trampoline_cps_call$1
		      (concat_map,
		       selected_mcp_servers,
		       register_server,
		       function(namespaces){
		        var
		         external_mcp_tools =
		           namespaces
		            ? [0,
		              [1,
		               cst_mcpServers,
		               cst_Tools_from_user_configured,
		               namespaces],
		              0]
		            : 0;
		        return caml_exact_trampoline_cps_call$1
		                (append$0,
		                 connection_management_tools,
		                 external_mcp_tools,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (append$0,
		                           integration_tools,
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (append$0,
		                                     help_tools,
		                                     a,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (append$0,
		       web_tools,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (append$0, routine_tools, a, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     if(! connection_manager) return a(0);
		                                     var manager = connection_manager[1];
		                                     function is_enabled(key, cont){
		                                      var t = context[1];
		                                      function a(t){
		                                       function b(b){
		if(b) return cont(b);
		var t = manager[2][1];
		function a(t){
		 if(! t) return cont(0);
		 var xs = t[2], integration = t[1];
		 return caml_exact_trampoline_cps_call$1
		         (equal$156,
		          integration[1],
		          key,
		          function(b){
		           return b ? cont(1) : caml_exact_trampoline_call1(a, xs);
		          });
		}
		return a(t);
		                                       }
		                                       if(! t) return b(0);
		                                       var xs = t[2], integration = t[1];
		                                       return caml_exact_trampoline_cps_call$1
		       (equal$156,
		        integration[1],
		        key,
		        function(c){
		         return c ? b(1) : caml_exact_trampoline_call1(a, xs);
		        });
		                                      }
		                                      return a(t);
		                                     }
		                                     function record_enabled(integration, tools, cont){
		                                      function a(){
		                                       return caml_exact_trampoline_cps_call$1
		       (append$0,
		        manager[2][1],
		        [0, integration, 0],
		        function(a){manager[2][1] = a; return cont();});
		                                      }
		                                      return is_empty(tools)
		      ? a()
		      : caml_exact_trampoline_cps_call$1
		        (append$0,
		         manager[1][1],
		         tools,
		         function(b){manager[1][1] = b; return a();});
		                                     }
		                                     function schematic_version(param, cont){return cont(0);}
		                                     function b(param, cont){
		                                      return caml_exact_trampoline_cps_call
		      (api$1,
		       ctrl[1],
		       function(match){
		        var api = match[2], Api = match[1];
		        return caml_trampoline_cps_call3
		                (Api[5][3],
		                 api,
		                 organization_id,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (map_error$0,
		                           to_string$73,
		                           a,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (map$25,
		                                     a,
		                                     function(membrane_integrations, cont){
		                                      return caml_exact_trampoline_cps_call$1
		      (map$7,
		       external_mcp_servers,
		       function(server, cont){
		        return cont([1, [0, server[1], server[2]]]);
		       },
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (map$7,
		                 membrane_integrations,
		                 function(integration, cont){return cont([0, integration]);},
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1
		                          (append$0, b, a, cont);
		                 });
		       });
		                                     },
		                                     cont);
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$523,
		      schematic_version,
		      function(c){
		       return caml_exact_trampoline_cps_call$9
		               (tool,
		                "list_integrations",
		                bJQ,
		                0,
		                "\nList the available third-party integrations: Membrane integrations with their configured connections, and locally configured MCP servers.\nFor a Membrane integration with a connection, call `enable_integration` with its integration key and connection ID.\nFor an MCP server, call `enable_integration` with its server ID.\n",
		                read$2(0),
		                null$6,
		                [0, 0, 0, [3, c], 0],
		                b,
		                function(list_tool){
		                 function b(param, cont){
		                  var integration = param[1];
		                  if(0 === integration[0]){
		                   var
		                    connection_id = integration[2],
		                    integration_key = integration[1],
		                    key$0 = [0, integration_key];
		                   return caml_exact_trampoline_cps_call
		                           (is_enabled,
		                            key$0,
		                            function(b){
		                             function a(b){
		                              switch(integration_key){
		                                case 0:
		                                 var a = cst_apolloio; break;
		                                case 1:
		                                 a = cst_asana; break;
		                                case 2:
		                                 a = cst_clickup; break;
		                                case 3:
		                                 a = cst_github; break;
		                                case 4:
		                                 a = cst_gmail; break;
		                                case 5:
		                                 a = cst_slack; break;
		                                case 6:
		                                 a = cst_attio; break;
		                                case 7:
		                                 a = cst_pipedrive; break;
		                                case 8:
		                                 a = cst_linear; break;
		                                case 9:
		                                 a = cst_gitlab; break;
		                                case 10:
		                                 a = cst_trello; break;
		                                case 11:
		                                 a = cst_jira; break;
		                                case 12:
		                                 a = cst_whatsapp; break;
		                                case 13:
		                                 a = cst_ticktick; break;
		                                case 14:
		                                 a = cst_todoist; break;
		                                case 15:
		                                 a = cst_featurebase; break;
		                                case 16:
		                                 a = cst_linkedin; break;
		                                case 17:
		                                 a = cst_instantly; break;
		                                default: a = cst_notion;
		                              }
		                              return caml_exact_trampoline_cps_call
		                                      (sprintf,
		                                       bJR,
		                                       function(b){
		return caml_trampoline_cps_call3
		        (b,
		         connection_id,
		         a,
		         function(a){
		          return caml_trampoline_cps_call2(return$13, a, cont);
		         });
		                                       });
		                             }
		                             if(b) return a();
		                             return caml_exact_trampoline_cps_call$0
		                                     (register$0,
		                                      ctrl,
		                                      organization_id,
		                                      integration_key,
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$0
		       (namespace,
		        cst_integrations,
		        cst_Third_party_integrations,
		        b,
		        function(b){
		         return caml_exact_trampoline_cps_call$1
		                 (record_enabled,
		                  [0, key$0, connection_id, [0, organization_id]],
		                  [0, b, 0],
		                  a);
		        });
		                                      });
		                            });
		                  }
		                  var id$0 = integration[1], key = [1, id$0];
		                  function a(param){
		                   function b(match){
		                    if(! match)
		                     return caml_exact_trampoline_cps_call
		                             (fail$2, "MCP server is not available", cont);
		                    var server = match[1];
		                    return caml_exact_trampoline_cps_call
		                            (is_enabled,
		                             key,
		                             function(b){
		                              if(! b)
		                               return caml_exact_trampoline_cps_call$1
		                                       (filter,
		external_mcp_servers,
		function(existing, cont){
		 return caml_exact_trampoline_cps_call
		         (is_enabled, [1, existing[1]], cont);
		},
		function(active_servers){
		 return caml_exact_trampoline_cps_call
		         (duplicate_name,
		          [0, server, active_servers],
		          function(match){
		           if(match){
		            var name = match[1];
		            return caml_exact_trampoline_cps_call$1
		                    (kasprintf,
		                     id,
		                     fmt$261,
		                     function(a){
		                      return caml_trampoline_cps_call2
		                              (a,
		                               name,
		                               function(a){
		                                return caml_exact_trampoline_cps_call(fail$2, a, cont);
		                               });
		                     });
		           }
		           return caml_exact_trampoline_cps_call$1
		                   (concat_map,
		                    [0, server, 0],
		                    register_server,
		                    function(tools){
		                     function a(a){
		                      return caml_exact_trampoline_cps_call$1
		                              (record_enabled,
		                               [0, key, cst$1, 0],
		                               a,
		                               function(match){
		                                var a = server[2];
		                                return caml_exact_trampoline_cps_call
		(sprintf,
		 bJT,
		 function(b){
		  return caml_trampoline_cps_call2
		          (b,
		           a,
		           function(a){
		            return caml_trampoline_cps_call2(return$13, a, cont);
		           });
		 });
		                               });
		                     }
		                     if(is_empty(tools)) return a(0);
		                     return caml_exact_trampoline_cps_call$0
		                             (namespace,
		                              cst_mcpServers,
		                              cst_Tools_from_user_configured,
		                              tools,
		                              function(b){return a([0, b, 0]);});
		                    });
		          });
		});
		                              var a = server[2];
		                              return caml_exact_trampoline_cps_call
		                                      (sprintf,
		                                       bJS,
		                                       function(b){
		return caml_trampoline_cps_call2
		        (b,
		         a,
		         function(a){
		          return caml_trampoline_cps_call2(return$13, a, cont);
		         });
		                                       });
		                             });
		                   }
		                   if(! param) return b(0);
		                   var l = param[2], server = param[1];
		                   return caml_exact_trampoline_cps_call$1
		                           (Id$8[15],
		                            server[1],
		                            id$0,
		                            function(c){
		                             return c
		                                     ? b([0, server])
		                                     : caml_exact_trampoline_call1(a, l);
		                            });
		                  }
		                  return a(external_mcp_servers);
		                 }
		                 function schematic_version(param, cont){return cont(0);}
		                 return caml_exact_trampoline_cps_call
		                         (enable_integration_input_schem,
		                          schematic_version,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$0
		                                   (object_schema,
		                                    bJU,
		                                    0,
		                                    c,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$9
		     (tool,
		      "enable_integration",
		      bJV,
		      0,
		      "\nEnable an integration for this conversation, making its tools available. Provide a Membrane integration key and connection ID, or an MCP server ID, from `list_integrations`.\nAfter calling, use tool search to discover the integration's tools. The connection stays enabled for future messages in this conversation.\n",
		      write$0(0, 1, 0),
		      c,
		      schematic_param_name_schema_ve,
		      b,
		      function(enable_tool){
		       return a([0, list_tool, [0, enable_tool, 0]]);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      if(! agent_id) return a(0);
		      var id$0 = agent_id[1];
		      return caml_exact_trampoline_cps_call$2
		              (build_tools,
		               graph,
		               ctrl,
		               id$0,
		               workspace,
		               function(b){
		                return caml_exact_trampoline_cps_call$0
		                        (namespace,
		                         cst_agent,
		                         "Manage this agent's working memory and automations",
		                         b,
		                         function(b){return a([0, b, 0]);});
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                cst_AGENT_INSTRUCTIONS = "AGENT INSTRUCTIONS",
		                cst_ENVIRONMENT = "ENVIRONMENT",
		                cst_INTERPRETING_REQUESTS = "INTERPRETING REQUESTS",
		                cst_SYSTEM_RULES = "SYSTEM RULES",
		                cst_USER_PREFERENCES = "USER PREFERENCES",
		                cst_WORKING_MEMORY = "WORKING MEMORY",
		                interpreting_requests_prompt =
		                  'How users phrase requests, and what they usually mean in Routine. Treat these as heuristics for choosing the right area and tool, not strict rules. Apply the same mapping regardless of the language the request is written in.\n\nReferences:\n- A task may include opaque `#<reference-id>` tokens. Resolve them using the matching entry in `CONTEXT.references`, then apply any relevant guidance in this section.\n\nCreating things:\n- "Remind me to X", "I need to X", "don\'t let me forget X", "todo: X" \xe2\x80\x94 the user wants a task. Routine has no separate reminder; a reminder is a task with a scheduled time. Create it under `personal` > `tasks`.\n- "Block time for X", "schedule time to X", "make time for X" \xe2\x80\x94 a task with a scheduled time, not a calendar event.\n- "Meeting/appointment/call/lunch with <someone> at <time>", or any specific clock time involving other people or a place \xe2\x80\x94 a calendar event, under `personal` > `events`.\n- "Add to my journal", "in today\'s journal", "log that I \xe2\x80\xa6" \xe2\x80\x94 the built-in Journal Entry table (name: "journal"), not a page. Use the tools from the tables / tables_write namespaces.\n  Each journal object MUST be titled after its date in the format `mmmm dd, yyyy`, e.g. `June 17, 2026`.\n  There MUST NOT be 2 journal objects with the same title, so check if one exists before creating it.\n  This also applies any time the journal table is referenced.\n\nTerminology:\n- "database", "table", "collection", "list" (referring to a named set of records) \xe2\x80\x94 a custom-type table (the `tables`, `tables_write`, `tables_alter` namespaces), not a page.\n- "workspace" \xe2\x80\x94 a collaboration space (a team or personal area), not a database.';
		               function build_conversation_prompt
		               (graph,
		                ctrl,
		                agent_id,
		                workspace,
		                context,
		                conversation_id,
		                stored_prompt_hash,
		                stored_response_id,
		                history,
		                organizations_scope,
		                response_format,
		                response_format_instructions,
		                opt,
		                connection_manager,
		                ctx,
		                cont){
		                var
		                 options = opt ? opt[1] : default$0,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3],
		                 organization_ids = organizations$0(organizations_scope);
		                return caml_exact_trampoline_cps_call$0
		                        (build_environment_section,
		                         ctrl,
		                         context[1],
		                         organizations_scope,
		                         function(environment_text){
		                          return caml_exact_trampoline_cps_call
		                                  (get_system,
		                                   options[1],
		                                   function(system_text){
		                                    return caml_exact_trampoline_cps_call
		    (trim,
		     interpreting_requests_prompt,
		     function(interpreting_requests_text){
		      return caml_exact_trampoline_cps_call
		              (decode_integration_tokens,
		               ctx[3],
		               function(message_text){
		                return caml_exact_trampoline_cps_call$1
		                        (strip,
		                         0,
		                         message_text,
		                         function(b){
		                          if(is_empty$0(b))
		                           return caml_trampoline_cps_call2(return$12, bKm, cont);
		                          function a(external_mcp_servers, cont){
		                           return caml_exact_trampoline_cps_call$4
		                                   (extract_tools_from_context,
		                                    graph,
		                                    ctrl,
		                                    [0, agent_id],
		                                    workspace,
		                                    0,
		                                    connection_manager,
		                                    [0, external_mcp_servers],
		                                    context,
		                                    organizations_scope,
		                                    function(tools){
		                                     var
		                                      x =
		[0,
		 system_text,
		 interpreting_requests_text,
		 environment_text,
		 ctx[1][1],
		 ctx[1][2],
		 ctx[1][3],
		 organization_ids],
		                                      a = caml_hash(10, 100, 0, x);
		                                     return caml_exact_trampoline_cps_call
		     (sprintf,
		      bKn,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(current_hash){
		                 a:
		                 {
		                  if(stored_response_id && stored_prompt_hash){
		                   var
		                    h = stored_prompt_hash[1],
		                    is_continuation = h === current_hash;
		                   break a;
		                  }
		                  is_continuation = 0;
		                 }
		                 var
		                  previous_response_id =
		                    is_continuation ? stored_response_id : 0;
		                 function a(context_section){
		                  var cst_RESPONSE_FORMAT = "RESPONSE FORMAT";
		                  if(response_format_instructions)
		                   var
		                    text = response_format_instructions[1],
		                    b = [0, [0, cst_RESPONSE_FORMAT, [0, -976970511, text]], 0];
		                  else
		                   b = 0;
		                  var a = ctx[4];
		                  if(a)
		                   var
		                    s = a[1],
		                    a = [0, [0, "AUTOMATION CONTEXT", [0, -976970511, s]], 0];
		                  else
		                   a = 0;
		                  return caml_exact_trampoline_cps_call$1
		                          (append$0,
		                           a,
		                           b,
		                           function(b){
		                            if(context_section)
		                             var
		                              content = context_section[1],
		                              a = [0, [0, "CONTEXT", content], 0];
		                            else
		                             a = 0;
		                            return caml_exact_trampoline_cps_call$1
		                                    (append$0,
		                                     a,
		                                     b,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (decode_integration_tokens,
		       ctx[1][3],
		       function(c){
		        var b = [0, [0, cst_WORKING_MEMORY, [0, -976970511, c]], 0];
		        return caml_exact_trampoline_cps_call
		                (decode_integration_tokens,
		                 ctx[1][2],
		                 function(d){
		                  var
		                   c = [0, [0, cst_USER_PREFERENCES, [0, -976970511, d]], b];
		                  return caml_exact_trampoline_cps_call
		                          (decode_integration_tokens,
		                           ctx[1][1],
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (append$0,
		                                     [0,
		                                      [0, cst_SYSTEM_RULES, [0, -976970511, system_text]],
		                                      [0,
		                                       [0, cst_ENVIRONMENT, [0, -976970511, environment_text]],
		                                       [0,
		[0,
		 cst_INTERPRETING_REQUESTS,
		 [0, -976970511, interpreting_requests_text]],
		[0, [0, cst_AGENT_INSTRUCTIONS, [0, -976970511, b]], c]]]],
		                                     a,
		                                     function(static_sections){
		                                      return caml_exact_trampoline_cps_call$1
		      (filter,
		       static_sections,
		       function(param, cont){
		        var content = param[2];
		        return caml_exact_trampoline_cps_call
		                (is_empty_content,
		                 content,
		                 function(a){return cont(1 - a);});
		       },
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (map$7,
		                 a,
		                 function(param, cont){
		                  var content = param[2], label = param[1];
		                  a:
		                  {
		                   if
		                    (label !== cst_AGENT_INSTRUCTIONS
		                     &&
		                      label !== cst_ENVIRONMENT
		                      &&
		                       label !== cst_INTERPRETING_REQUESTS
		                       && label !== cst_RESPONSE_FORMAT){
		                    if(label !== cst_SYSTEM_RULES){
		                     var role = 948354667;
		                     break a;
		                    }
		                    role = 662113039;
		                    break a;
		                   }
		                   role = 519160618;
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (format_section_content,
		                           label,
		                           content,
		                           function(a){return cont([0, role, a]);});
		                 },
		                 function(static_input){
		                  return caml_exact_trampoline_cps_call$1
		                          (format_section_content,
		                           "TASK",
		                           [0, -976970511, message_text],
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (input_item_of_message,
		                                     [0, [0, ctx[2]], a],
		                                     function(task_input){
		                                      return caml_exact_trampoline_cps_call$1
		      (map$7,
		       history,
		       function(m, cont){
		        return caml_exact_trampoline_cps_call
		                (input_item_of_message, [0, m[1], m[2]], cont);
		       },
		       function(history_input){
		        function a(input){
		         function a(a){
		          return caml_exact_trampoline_cps_call$1
		                  (openai_tools,
		                   [0, a],
		                   tools,
		                   function(tool_list){
		                    if(is_empty(tool_list))
		                     var tool_choice$0 = 0, tools_opt = 0;
		                    else
		                     var
		                      tools_opt$0 = [0, tool_list],
		                      tool_choice$0 = tool_choice,
		                      tools_opt = tools_opt$0;
		                    var a = [0, agent_reasoning];
		                    return caml_exact_trampoline_cps_call$1
		                            (map$3,
		                             response_format,
		                             function(schema, cont){
		                              return cont
		                                      ([0, [0, [0, "json_schema", cst_response, schema, bKo]]]);
		                             },
		                             function(b){
		                              return caml_exact_trampoline_cps_call
		                                      (to_string$54,
		                                       conversation_id,
		                                       function(c){
		var
		 request =
		   [0,
		    model(),
		    input,
		    previous_response_id,
		    tools_opt,
		    tool_choice$0,
		    bKp,
		    [0, [0, cst_conversation_id, c], 0],
		    b,
		    a,
		    0];
		return caml_trampoline_cps_call2
		        (return$12, [0, [0, request, tools, current_hash]], cont);
		                                       });
		                             });
		                   });
		         }
		         return options[2]
		                 ? caml_exact_trampoline_cps_call$1
		                   (of_list$2, [0, comparator$2], bJ8, a)
		                 : a(empty$8([0, comparator$2]));
		        }
		        return is_continuation
		                ? a([0, task_input, 0])
		                : caml_exact_trampoline_cps_call$1
		                  (append$0,
		                   history_input,
		                   [0, task_input, 0],
		                   function(b){
		                    return caml_exact_trampoline_cps_call$1
		                            (append$0, static_input, b, a);
		                   });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 }
		                 if(is_empty(context[3]) && is_empty(context[2]))
		                  return a(0);
		                 return caml_exact_trampoline_cps_call
		                         (encode_prompt_context,
		                          context,
		                          function(json){return a([0, [0, 826371656, json]]);});
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call
		                                  (enabled,
		                                   ctrl,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function build_automation_prompt
		               (graph,
		                ctrl,
		                context,
		                organizations_scope,
		                workspace,
		                previous_response_id,
		                agent_id,
		                initial_input,
		                ctx,
		                cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3];
		                return caml_exact_trampoline_cps_call$0
		                        (build_environment_section,
		                         ctrl,
		                         context[1],
		                         organizations_scope,
		                         function(environment_text){
		                          return caml_exact_trampoline_cps_call
		                                  (get_system,
		                                   1,
		                                   function(system_text){
		                                    return caml_exact_trampoline_cps_call$1
		    (strip,
		     0,
		     ctx[3],
		     function(a){
		      if(is_empty$0(a))
		       return caml_trampoline_cps_call2(return$12, bKq, cont);
		      return caml_exact_trampoline_cps_call
		              (trim,
		               interpreting_requests_prompt,
		               function(interpreting_requests_text){
		                function a(external_mcp_servers, cont){
		                 return caml_exact_trampoline_cps_call$4
		                         (extract_tools_from_context,
		                          graph,
		                          ctrl,
		                          agent_id,
		                          workspace,
		                          1,
		                          0,
		                          [0, external_mcp_servers],
		                          context,
		                          organizations_scope,
		                          function(tools){
		                           return caml_exact_trampoline_cps_call
		                                   (trim,
		                                    "You are running as an automation: a predefined task that runs on the user's behalf without anyone watching in real time. Carry out the operation below autonomously and to completion. If you are genuinely blocked, use `ask_user` (alone) to pause and ask the user \xe2\x80\x94 a last resort, since it halts the run until they reply. An automation may run many times, on a recurrent schedule, triggered by an object change, or directly triggered manually by the user.",
		                                    function(base_automation){
		                                     return caml_exact_trampoline_cps_call
		     (to_string$55,
		      ctx[5],
		      function(b){
		       var a = ctx[6];
		       return caml_exact_trampoline_cps_call
		               (sprintf,
		                bKr,
		                function(c){
		                 return caml_trampoline_cps_call4
		                         (c,
		                          base_automation,
		                          a,
		                          b,
		                          function(with_identity){
		                           var match = ctx[2];
		                           function a(automation_text){
		                            return caml_exact_trampoline_cps_call
		                                    (decode_integration_tokens,
		                                     ctx[3],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$1
		      (strip,
		       0,
		       a,
		       function(b){
		        var a = ctx[4];
		        return caml_exact_trampoline_cps_call
		                (sprintf,
		                 bKt,
		                 function(c){
		                  return caml_trampoline_cps_call3
		                          (c,
		                           a,
		                           b,
		                           function(full_operation_prompt){
		                            var
		                             a =
		                               [0,
		                                [0, "OPERATION", [0, -976970511, full_operation_prompt]],
		                                0];
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$3,
		                                     ctx[1],
		                                     function(agent, cont){
		                                      return caml_exact_trampoline_cps_call
		      (decode_integration_tokens,
		       agent[3],
		       function(b){
		        var a = [0, [0, cst_WORKING_MEMORY, [0, -976970511, b]], 0];
		        return caml_exact_trampoline_cps_call
		                (decode_integration_tokens,
		                 agent[2],
		                 function(b){
		                  return cont
		                          ([0, [0, cst_USER_PREFERENCES, [0, -976970511, b]], a]);
		                 });
		       });
		                                     },
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (of_list,
		       to_list$0(b),
		       function(b){
		        return caml_exact_trampoline_cps_call$1
		                (append$0,
		                 b,
		                 a,
		                 function(a){
		                  var cst_AUTOMATION = "AUTOMATION";
		                  return caml_exact_trampoline_cps_call$1
		                          (append$0,
		                           [0,
		                            [0, cst_AUTOMATION, [0, -976970511, automation_text]],
		                            0],
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$3,
		                                     ctx[1],
		                                     function(agent, cont){
		                                      return caml_exact_trampoline_cps_call
		      (decode_integration_tokens,
		       agent[1],
		       function(a){
		        return cont([0, cst_AGENT_INSTRUCTIONS, [0, -976970511, a]]);
		       });
		                                     },
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1
		      (append$0,
		       to_list$0(b),
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (append$0,
		                 [0,
		                  [0, cst_SYSTEM_RULES, [0, -976970511, system_text]],
		                  [0,
		                   [0, cst_ENVIRONMENT, [0, -976970511, environment_text]],
		                   [0,
		                    [0,
		                     cst_INTERPRETING_REQUESTS,
		                     [0, -976970511, interpreting_requests_text]],
		                    0]]],
		                 a,
		                 function(sections){
		                  return caml_exact_trampoline_cps_call$1
		                          (filter,
		                           sections,
		                           function(param, cont){
		                            var content = param[2];
		                            return caml_exact_trampoline_cps_call
		                                    (is_empty_content,
		                                     content,
		                                     function(a){return cont(1 - a);});
		                           },
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$7,
		                                     a,
		                                     function(param, cont){
		                                      var content = param[2], label = param[1];
		                                      a:
		                                      {
		                                       if
		(label !== cst_AGENT_INSTRUCTIONS
		 &&
		  label !== cst_AUTOMATION
		  &&
		   label !== cst_ENVIRONMENT
		   && label !== cst_INTERPRETING_REQUESTS){
		if(label !== cst_SYSTEM_RULES){
		 var role = 948354667;
		 break a;
		}
		role = 662113039;
		break a;
		                                       }
		                                       role = 519160618;
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (format_section_content,
		       label,
		       content,
		       function(a){return cont([0, role, a]);});
		                                     },
		                                     function(base_input){
		                                      function a(input){
		                                       return caml_exact_trampoline_cps_call$1
		       (openai_tools,
		        0,
		        tools,
		        function(tool_list){
		         if(is_empty(tool_list))
		          var tool_choice = 0, tools_opt = 0;
		         else
		          var
		           tools_opt$0 = [0, tool_list],
		           tool_choice = tool_choice$0,
		           tools_opt = tools_opt$0;
		         var
		          request =
		            [0,
		             model(),
		             input,
		             previous_response_id,
		             tools_opt,
		             tool_choice,
		             bKu,
		             0,
		             0,
		             [0, agent_reasoning],
		             0];
		         return caml_trampoline_cps_call2
		                 (return$12, [0, [0, request, tools]], cont);
		        });
		                                      }
		                                      if(! initial_input) return a(base_input);
		                                      var items = initial_input[1];
		                                      return caml_exact_trampoline_cps_call$1
		      (append$0, base_input, items, a);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           }
		                           if(! match) return a(with_identity);
		                           var obj_context = match[1];
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$15,
		                                    obj_context,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (sprintf,
		      bKs,
		      function(c){
		       return caml_trampoline_cps_call3(c, with_identity, b, a);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (enabled,
		                         ctrl,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$33 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_bind$28 = open$33[1],
		                let$54 = open$33[3],
		                let$55 = open$33[14];
		               function extract_output_text(resp, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (filter_map$0,
		                         resp[2],
		                         function(param, cont){
		                          if(1 !== param[0]) return cont(0);
		                          var content = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (filter_map$0,
		                                   content,
		                                   function(param, cont){
		                                    var text = param[1];
		                                    return cont([0, text]);
		                                   },
		                                   function(texts){
		                                    return is_empty(texts)
		    ? cont(0)
		    : caml_exact_trampoline_cps_call$1
		      (concat$0, bKv, texts, function(a){return cont([0, a]);});
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0,
		                                   bKw,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1(strip, 0, a, cont);
		                                   });
		                         });
		               }
		               function extract_citations(resp, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (concat_map,
		                         resp[2],
		                         function(param, cont){
		                          if(1 !== param[0]) return cont(0);
		                          var content = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat_map,
		                                   content,
		                                   function(param, cont){
		                                    var annotations = param[2];
		                                    return cont(annotations);
		                                   },
		                                   cont);
		                         },
		                         cont);
		               }
		               function call$5
		               (a,
		                dynamic_tools,
		                ctrl,
		                tools,
		                organization_id,
		                opt,
		                request,
		                cont){
		                var
		                 initial_tool_calls = a ? a[1] : 0,
		                 on_progress =
		                   opt
		                    ? opt[1]
		                    : function
		                     (param, cont){
		                      return caml_trampoline_cps_call2(return$13, 0, cont);
		                     };
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api_impl = match[1];
		                          function extra_tools(param){
		                           if(! dynamic_tools) return 0;
		                           var r = dynamic_tools[1];
		                           return r[1];
		                          }
		                          function loop(round, current_request, acc_tool_calls, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0,
		                                    tools,
		                                    extra_tools(),
		                                    function(registry){
		                                     function a(current_request){
		                                      function a(api_result, cont){
		                                       if(0 === api_result[0]){
		var
		 resp = api_result[1],
		 complete_at_round_limit =
		   function(outputs, tool_calls, cont){
		    var
		     a = current_request[10],
		     b = current_request[9],
		     c = current_request[8],
		     d = current_request[7],
		     e = current_request[6],
		     f = current_request[4],
		     g = [0, resp[1]];
		    return caml_exact_trampoline_cps_call$1
		            (append$0,
		             outputs,
		             [0, pause_message, 0],
		             function(i){
		              var
		               final_request =
		                 [0, current_request[1], i, g, f, bKx, e, d, c, b, a];
		              function h(final_result, cont){
		               if(0 === final_result[0]){
		                var final_resp = final_result[1];
		                return caml_exact_trampoline_cps_call
		                        (extract_citations,
		                         final_resp,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (extract_output_text,
		                                   final_resp,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (return$13, [0, [0, final_resp[1], b, tool_calls, a]], cont);
		                                   });
		                         });
		               }
		               var err = final_result[1];
		               return caml_exact_trampoline_cps_call
		                       (return_error, err, cont);
		              }
		              return caml_trampoline_cps_call4
		                      (Api_impl[4][3][2][1],
		                       api,
		                       organization_id,
		                       final_request,
		                       function(a){
		                        return caml_trampoline_cps_call3(let$54, a, h, cont);
		                       });
		             });
		   },
		 a =
		   function(param, cont){
		    if(typeof param === "number"){
		     if(0 === param)
		      return caml_exact_trampoline_cps_call
		              (extract_citations,
		               resp,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (extract_output_text,
		                         resp,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (return$13, [0, [0, resp[1], b, acc_tool_calls, a]], cont);
		                         });
		               });
		     if(10 <= round)
		      return caml_exact_trampoline_cps_call$1
		              (complete_at_round_limit, 0, acc_tool_calls, cont);
		     var
		      next_request =
		        [0,
		         current_request[1],
		         0,
		         [0, resp[1]],
		         current_request[4],
		         current_request[5],
		         current_request[6],
		         current_request[7],
		         current_request[8],
		         current_request[9],
		         current_request[10]];
		     return caml_exact_trampoline_cps_call$0
		             (loop, round + 1 | 0, next_request, acc_tool_calls, cont);
		    }
		    if(0 !== param[0]){
		     var call_id = param[2], questions = param[1];
		     return caml_exact_trampoline_cps_call
		             (return_ok,
		              [1, resp[1], questions, call_id, acc_tool_calls],
		              cont);
		    }
		    var outputs = param[1], executed = param[2];
		    if(10 <= round)
		     return caml_exact_trampoline_cps_call$1
		             (append$0,
		              acc_tool_calls,
		              executed,
		              function(new_tool_calls){
		               function a(param, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (complete_at_round_limit, outputs, new_tool_calls, cont);
		               }
		               return caml_exact_trampoline_cps_call
		                       (on_progress,
		                        new_tool_calls,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1(let$55, b, a, cont);
		                        });
		              });
		    var executed$0 = param[2];
		    return caml_exact_trampoline_cps_call$1
		            (append$0,
		             acc_tool_calls,
		             executed$0,
		             function(new_tool_calls){
		              function a(param, cont){
		               var
		                next_request =
		                  [0,
		                   current_request[1],
		                   outputs,
		                   [0, resp[1]],
		                   current_request[4],
		                   current_request[5],
		                   current_request[6],
		                   current_request[7],
		                   current_request[8],
		                   current_request[9],
		                   current_request[10]];
		               return caml_exact_trampoline_cps_call$0
		                       (loop, round + 1 | 0, next_request, new_tool_calls, cont);
		              }
		              return caml_exact_trampoline_cps_call
		                      (on_progress,
		                       new_tool_calls,
		                       function(b){
		                        return caml_exact_trampoline_cps_call$1(let$55, b, a, cont);
		                       });
		             });
		   };
		return caml_exact_trampoline_cps_call$1
		        (execute_calls,
		         registry,
		         resp,
		         function(b){
		          return caml_trampoline_cps_call3(symbol_bind$28, b, a, cont);
		         });
		                                       }
		                                       var err = api_result[1];
		                                       return caml_exact_trampoline_cps_call
		       (return_error, err, cont);
		                                      }
		                                      return caml_trampoline_cps_call4
		      (Api_impl[4][3][2][1],
		       api,
		       organization_id,
		       current_request,
		       function(b){
		        return caml_trampoline_cps_call3(let$54, b, a, cont);
		       });
		                                     }
		                                     if(! extra_tools()) return a(current_request);
		                                     var
		                                      b = current_request[10],
		                                      c = current_request[9],
		                                      d = current_request[8],
		                                      e = current_request[7],
		                                      f = current_request[6],
		                                      g = current_request[5];
		                                     return caml_exact_trampoline_cps_call$1
		     (append$0,
		      tools,
		      extra_tools(),
		      function(h){
		       return caml_exact_trampoline_cps_call$1
		               (openai_tools,
		                0,
		                h,
		                function(h){
		                 return a
		                         ([0,
		                           current_request[1],
		                           current_request[2],
		                           current_request[3],
		                           [0, h],
		                           g,
		                           f,
		                           e,
		                           d,
		                           c,
		                           b]);
		                });
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$0
		                                  (loop, 0, request, initial_tool_calls, cont);
		                         });
		               }
		               function generate_title
		               (ctrl,
		                crdt,
		                workspace,
		                id$0,
		                organization_id,
		                previous,
		                message,
		                cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3];
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         id,
		                         fmt$264,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (a,
		                                   message,
		                                   function(b){
		                                    var
		                                     title_request =
		                                       [0,
		model(),
		[0, [0, 948354667, b], 0],
		0,
		0,
		0,
		bKz,
		0,
		0,
		bKy,
		0];
		                                    function a(result, cont){
		                                     if(0 !== result[0])
		                                      return caml_trampoline_cps_call2(return$13, 0, cont);
		                                     var match = result[1];
		                                     if(0 !== match[0])
		                                      return caml_trampoline_cps_call2(return$13, 0, cont);
		                                     var response = match[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (diff$3,
		      previous,
		      [0, response[2]],
		      function(operation){
		       return caml_exact_trampoline_cps_call
		               (v$13,
		                [7, operation],
		                function(op){
		                 return caml_trampoline_cps_call2
		                         (Ident$0[6][16],
		                          id$0,
		                          function(a){
		                           return caml_trampoline_cps_call2
		                                   (a,
		                                    op,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (conversations$0,
		      a,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (ai$0,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call$2
		                         (apply$125,
		                          ctrl[1],
		                          crdt,
		                          workspace,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call2(return$12, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$8
		    (call$5,
		     0,
		     0,
		     ctrl,
		     0,
		     organization_id,
		     0,
		     title_request,
		     function(b){
		      return caml_trampoline_cps_call3(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               var
		                open$34 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$56 = open$34[14],
		                decisions_table_id =
		                  caml_callback(Table[28], ["demo_decisions_table_20260414"]),
		                decisions_title_col_id =
		                  caml_callback
		                   (hash$21, ["demo_decisions_title_col_20260414"]),
		                decisions_notes_col_id =
		                  caml_callback
		                   (hash$21, ["demo_decisions_notes_col_20260414"]),
		                decisions_processed_col_id =
		                  caml_callback
		                   (hash$21, ["demo_decisions_processed_col_20260414"]),
		                customers_table_id =
		                  caml_callback(Table[28], ["demo_customers_table_20260414"]),
		                customers_name_col_id =
		                  caml_callback(hash$21, ["demo_customers_name_col_20260414"]),
		                customers_email_col_id =
		                  caml_callback
		                   (hash$21, ["demo_customers_email_col_20260414"]),
		                customers_plan_col_id =
		                  caml_callback(hash$21, ["demo_customers_plan_col_20260414"]),
		                bug_reports_table_id =
		                  caml_callback
		                   (Table[28], ["demo_bug_reports_table_20260414"]),
		                bug_reports_title_col_id =
		                  caml_callback
		                   (hash$21, ["demo_bug_reports_title_col_20260414"]),
		                bug_reports_description_col_id =
		                  caml_callback
		                   (hash$21, ["demo_bug_reports_description_col_20260414"]),
		                bug_reports_status_col_id =
		                  caml_callback
		                   (hash$21, ["demo_bug_reports_status_col_20260414"]),
		                bug_reports_severity_col_id =
		                  caml_callback
		                   (hash$21, ["demo_bug_reports_severity_col_20260414"]),
		                bug_reports_affected_col_id =
		                  caml_callback
		                   (hash$21, ["demo_bug_reports_affected_col_20260414"]),
		                bug_reports_ticket_created_col =
		                  caml_callback
		                   (hash$21, ["demo_bug_reports_ticket_created_col_20260414"]),
		                tickets_table_id =
		                  caml_callback(Table[28], ["demo_tickets_table_20260414"]),
		                tickets_title_col_id =
		                  caml_callback(hash$21, ["demo_tickets_title_col_20260414"]),
		                tickets_status_col_id =
		                  caml_callback(hash$21, ["demo_tickets_status_col_20260414"]),
		                tickets_automate_col_id =
		                  caml_callback
		                   (hash$21, ["demo_tickets_automate_col_20260414"]),
		                tickets_bug_report_col_id =
		                  caml_callback
		                   (hash$21, ["demo_tickets_bug_report_col_20260414"]),
		                tickets_github_url_col_id =
		                  caml_callback
		                   (hash$21, ["demo_tickets_github_url_col_20260414"]),
		                tickets_customers_notified_col =
		                  caml_callback
		                   (hash$21, ["demo_tickets_customers_notified_col_20260422"]),
		                runs_table_id =
		                  caml_callback(Table[28], ["demo_runs_table_20260415"]),
		                runs_name_col_id =
		                  caml_callback(hash$21, ["demo_runs_name_col_20260415"]),
		                runs_status_col_id =
		                  caml_callback(hash$21, ["demo_runs_status_col_20260415"]),
		                runs_success_col_id =
		                  caml_callback(hash$21, ["demo_runs_success_col_20260415"]),
		                runs_notes_col_id =
		                  caml_callback(hash$21, ["demo_runs_notes_col_20260415"]),
		                decisions_data_name = "Demo Decision",
		                decisions_name =
		                  caml_callback(data_name_to_name, [decisions_data_name]),
		                customers_data_name = "Demo Customer",
		                customers_name =
		                  caml_callback(data_name_to_name, [customers_data_name]),
		                bug_reports_data_name = "Demo Bug Report",
		                bug_reports_name =
		                  caml_callback(data_name_to_name, [bug_reports_data_name]),
		                tickets_data_name = "Demo Ticket",
		                tickets_name =
		                  caml_callback(data_name_to_name, [tickets_data_name]),
		                runs_data_name = "Demo Run",
		                runs_name = caml_callback(data_name_to_name, [runs_data_name]),
		                meeting_2w_event_id =
		                  caml_callback(hash$19, ["demo_meeting_2w_20260414"]),
		                meeting_1w_event_id =
		                  caml_callback(hash$19, ["demo_meeting_1w_20260414"]),
		                meeting_today_event_id =
		                  caml_callback(hash$19, ["demo_meeting_today_20260414"]),
		                runs_page_id =
		                  caml_callback(hash$20, ["demo_runs_page_20260415"]),
		                dashboard_page_id =
		                  caml_callback(hash$20, ["demo_dashboard_20260415"]),
		                bigcorp_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_customer_bigcorp_20260414"]),
		                alice_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_customer_alice_20260414"]),
		                customer_nova_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_customer_nova_20260414"]),
		                customer_helix_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_customer_helix_20260414"]),
		                customer_drift_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_customer_drift_20260414"]),
		                bug_report_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_bug_report_login_20260414"]),
		                bug_report_export_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_bug_report_export_20260414"]),
		                bug_report_slowdown_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_bug_report_slowdown_20260414"]),
		                bug_report_notif_row_id =
		                  caml_callback
		                   (include$51[28], ["demo_bug_report_notif_20260414"]);
		               function find_automation_by_name(ctrl, workspace, name, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (ai_state,
		                         ctrl,
		                         workspace,
		                         function(match){
		                          if(! match) return cont(0);
		                          var state = match[1];
		                          function a(b){
		                           if(! b) return cont(0);
		                           var l = b[2], x = b[1], a$0 = x[2], id = x[1], t = a$0[2];
		                           if(t) var x$0 = t[1], b = x$0 === name ? 1 : 0; else b = 0;
		                           var r = some_if(b, id);
		                           return r ? cont(r) : caml_exact_trampoline_call1(a, l);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_alist$0, 0, state[4], a);
		                         });
		               }
		               function col(name, value){
		                return make_field(0, 0, name, 0, value);
		               }
		               function note_col(name){return col(name, 4);}
		               function bool_col(name){return col(name, 0);}
		               function variant_col(name, values, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (map$7,
		                         values,
		                         function(v, cont){return cont([5, v]);},
		                         function(a){return cont(col(name, [7, a]));});
		               }
		               function ensure_table
		               (ctrl, crdt, workspace, table_id, table_def, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(match){
		                          if(! match)
		                           return caml_trampoline_cps_call2(return$13, 0, cont);
		                          var state = match[1], db = state[25];
		                          g
		                           ([0,
		                             Operation$18[4],
		                             Operation$18[5],
		                             ,
		                             Operation$18[7],
		                             Operation$18[8],
		                             Operation$18[9],
		                             ,
		                             ,
		                             ,
		                             ,
		                             Operation$18[12]]);
		                          return caml_trampoline_cps_call3
		                                  (Map$4[23],
		                                   db[1],
		                                   table_id,
		                                   function(previous_table){
		                                    function a(op){
		                                     return caml_exact_trampoline_cps_call
		     (tables,
		      op,
		      function(a){
		       return caml_exact_trampoline_cps_call$2
		               (apply$125,
		                ctrl[1],
		                crdt,
		                workspace,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call2(return$12, a, cont);
		                });
		      });
		                                    }
		                                    if(! previous_table)
		                                     return caml_trampoline_cps_call3
		     (add$28, table_id, table_def, a);
		                                    var
		                                     previous = previous_table[1],
		                                     b =
		                                       [0,
		default_schema_fold_params[1],
		function(key, previous_value, cont){
		 return caml_trampoline_cps_call2(Row_schema[2][8], 0, cont);
		},
		default_schema_fold_params[3]];
		                                    return caml_exact_trampoline_cps_call$0
		    (diff_excluding_rows,
		     [0,
		      function(a, c, cont){
		       return caml_exact_trampoline_cps_call$0
		               (diff_schema_fold, b, a, c, cont);
		      }],
		     previous,
		     table_def,
		     function(b){
		      return caml_trampoline_cps_call2
		              (element$19,
		               table_id,
		               function(c){return caml_trampoline_cps_call2(c, b, a);});
		     });
		                                   });
		                         });
		               }
		               function clear_table_rows
		               (ctrl, crdt, workspace, table_id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(match){
		                          if(! match)
		                           return caml_trampoline_cps_call2(return$13, 0, cont);
		                          var state = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   state[25][1],
		                                   table_id,
		                                   function(match){
		                                    if(! match)
		                                     return caml_trampoline_cps_call2(return$13, 0, cont);
		                                    var table = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (keys$0,
		     table[6],
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (map$7,
		               a,
		               function(row_id, cont){
		                function a(param, cont){
		                 if(! param) return cont([1, [0, 308715285, table_id]]);
		                 var a = param[1];
		                 return cont([0, a]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (include$321[18],
		                         row_id,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (element$18,
		                                   table_id,
		                                   [2, [5, b]],
		                                   function(b){
		                                    return caml_trampoline_cps_call3
		    (Operation$18[9],
		     b,
		     a,
		     function(op){
		      return caml_exact_trampoline_cps_call
		              (tables,
		               op,
		               function(a){
		                return caml_exact_trampoline_cps_call$2
		                        (apply$125,
		                         ctrl[1],
		                         crdt,
		                         workspace,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$5,
		                                   a,
		                                   function(param, cont){
		                                    return 0 === param[0]
		    ? cont(0)
		    : caml_exact_trampoline_cps_call$1(fatal$0, bKE, bKD, cont);
		                                   },
		                                   cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               },
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (all_unit,
		                         a,
		                         function(a){
		                          return caml_trampoline_cps_call2(return$12, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function reset_row
		               (ctrl, crdt, workspace, table_id, row_id, cells, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (state$0,
		                         workspace,
		                         ctrl[2],
		                         function(match){
		                          if(! match)
		                           return caml_trampoline_cps_call2(return$13, 0, cont);
		                          var state = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   state[25][1],
		                                   table_id,
		                                   function(match){
		                                    if(! match)
		                                     return caml_trampoline_cps_call2(return$13, 0, cont);
		                                    var table = match[1];
		                                    function a(t, target_row){
		                                     if(! t)
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       table[6],
		       row_id,
		       function(match){
		        if(! match)
		         return caml_exact_trampoline_cps_call$1
		                 (include$321[14],
		                  row_id,
		                  target_row,
		                  function(rows_op){
		                   return caml_exact_trampoline_cps_call
		                           (rows,
		                            rows_op,
		                            function(a){
		                             return caml_trampoline_cps_call3
		                                     (element$19,
		                                      table_id,
		                                      a,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (tables,
		        a,
		        function(a){
		         return caml_exact_trampoline_cps_call$2
		                 (apply$125,
		                  ctrl[1],
		                  crdt,
		                  workspace,
		                  a,
		                  function(a){
		                   return caml_trampoline_cps_call2(return$12, a, cont);
		                  });
		        });
		                                      });
		                            });
		                  });
		        var current_row = match[1];
		        return caml_exact_trampoline_cps_call$1
		                (diff$11,
		                 current_row,
		                 target_row,
		                 function(row_diff){
		                  return caml_exact_trampoline_cps_call$1
		                          (include$321[16],
		                           row_id,
		                           row_diff,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (rows,
		                                     a,
		                                     function(a){
		                                      return caml_trampoline_cps_call3
		      (element$19,
		       table_id,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (tables,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           workspace,
		                           a,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$12, a, cont);
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     var
		                                      l = t[2],
		                                      a$0 = t[1],
		                                      cell_value = a$0[2],
		                                      col_id = a$0[1];
		                                     return caml_exact_trampoline_cps_call$0
		     (set$3,
		      target_row,
		      col_id,
		      cell_value,
		      function(init){
		       return caml_exact_trampoline_call2(a, l, init);
		      });
		                                    }
		                                    return a(cells, empty$23);
		                                   });
		                         });
		               }
		               function ensure_page
		               (ctrl, crdt, workspace, state, id, title, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (mem$5,
		                         state[16],
		                         id,
		                         function(b){
		                          if(b) return caml_trampoline_cps_call2(return$13, 0, cont);
		                          var
		                           created = ocaml_ptime_clock_now_d_ps(),
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$22,
		                                symbol_map$20,
		                                ,
		                                bind$30,
		                                return$39,
		                                map$50,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$14]),
		                           let$ = open[4],
		                           let$0 = open[3];
		                          function a(page_id, cont){
		                           function a(param, cont){return cont(page_id);}
		                           return caml_exact_trampoline_cps_call$1
		                                   (add$16,
		                                    0,
		                                    page_id,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (hierarchy,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3(let$, b, a, cont);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$7
		                                  (add_page,
		                                   [0, id],
		                                   0,
		                                   0,
		                                   created,
		                                   title,
		                                   dummy,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (pages,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3
		              (let$0,
		               b,
		               a,
		               function(op){
		                function a(param, cont){
		                 return caml_trampoline_cps_call2(return$13, 0, cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (apply$125,
		                         ctrl[1],
		                         crdt,
		                         workspace,
		                         op,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (return$12,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function commit_trigger(workspace, kind, cont){
		                return caml_exact_trampoline_cps_call
		                        (Event_kinds[75],
		                         all$3,
		                         function(a){
		                          return cont([1, [0, [0, kind, workspace], 0], a]);
		                         });
		               }
		               function integration_context(key, connection_id){
		                return [0,
		                        [0, [0, [0, key], connection_id, 0], 0],
		                        default$[2],
		                        default$[3]];
		               }
		               function enhanced_prompt(auto_name, doc, cont){
		                var a = [0, make$33(0, bKF), 0];
		                return caml_exact_trampoline_cps_call$1
		                        (append$0,
		                         doc[1],
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$265,
		                                   function(b){
		                                    return caml_trampoline_cps_call4
		    (b,
		     runs_name,
		     auto_name,
		     runs_name,
		     function(b){
		      return cont([0, [0, make$33(0, [8, [0, b]]), a]]);
		     });
		                                   });
		                         });
		               }
		               function block_h1(content){
		                return make$33(0, [6, [0, content, 1, 0]]);
		               }
		               function block_h2(content){
		                return make$33(0, [6, [0, content, 2, 0]]);
		               }
		               function block_p(content){
		                return make$33(0, [8, [0, content]]);
		               }
		               function block_query(content){
		                return make$33(0, [9, [0, content]]);
		               }
		               function upsert_automation
		               (ctrl,
		                crdt,
		                workspace,
		                agent_id,
		                auto_name,
		                step_name,
		                step_prompt,
		                step_context,
		                trigger,
		                param,
		                cont){
		                var
		                 prompt = [0, value$4(step_context, default$), step_prompt];
		                return caml_exact_trampoline_cps_call$0
		                        (find_automation_by_name,
		                         ctrl,
		                         workspace,
		                         auto_name,
		                         function(match){
		                          if(match){
		                           var id = match[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (list_automation_steps,
		                                    ctrl,
		                                    workspace,
		                                    id,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (get$17,
		      a,
		      function(steps){
		       if(! steps)
		        return caml_exact_trampoline_cps_call(return_ok, id, cont);
		       var
		        first_step = steps[1],
		        step_patch = [0, [0, step_name], [0, prompt]];
		       function a(param, cont){
		        var
		         name = [0, [0, auto_name]],
		         auto_patch = [0, name, 0, trigger];
		        function a(param, cont){
		         return caml_exact_trampoline_cps_call(return_ok, id, cont);
		        }
		        return caml_exact_trampoline_cps_call$3
		                (update_automation,
		                 ctrl,
		                 crdt,
		                 workspace,
		                 id,
		                 auto_patch,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (return$12,
		                           b,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call$3
		               (update_step,
		                ctrl,
		                crdt,
		                workspace,
		                first_step,
		                step_patch,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (return$12,
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                          });
		                });
		      });
		                                    });
		                          }
		                          function a(step_id, cont){
		                           function a(auto_id, cont){
		                            var name = [0, [0, auto_name]];
		                            function a(param, cont){
		                             return caml_exact_trampoline_cps_call
		                                     (return_ok, auto_id, cont);
		                            }
		                            return caml_exact_trampoline_cps_call$3
		                                    (update_automation,
		                                     ctrl,
		                                     crdt,
		                                     workspace,
		                                     auto_id,
		                                     [0, name, 0, trigger],
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$8
		                                   (create_automation,
		                                    ctrl,
		                                    crdt,
		                                    workspace,
		                                    auto_name,
		                                    [0, step_id, 0],
		                                    [0, agent_id],
		                                    dummy,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		      });
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$7
		                                  (create_step,
		                                   ctrl,
		                                   crdt,
		                                   workspace,
		                                   0,
		                                   [0, step_name, prompt],
		                                   dummy,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (return$12,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function setup
		               (ctrl,
		                crdt,
		                organization_id,
		                workspace,
		                slack_connection_id,
		                gmail_connection_id,
		                github_connection_id,
		                github_issues_table_id,
		                gmail_inbox_table_id,
		                calendar_id,
		                cont){
		                function a(agent_id, cont){
		                 var
		                  agent_id_any = [0, agent_id],
		                  open = g(include$0),
		                  let$ = open[8];
		                 function a(param, cont){
		                  function a(param, cont){
		                   var cst_Decisions = "Decisions";
		                   function a(today_event_id, cont){
		                    function make_table(data_name, name, cols, cont){
		                     return caml_exact_trampoline_cps_call
		                             (of_alist_exn$3,
		                              cols,
		                              function(schema){
		                               var
		                                meta = make$38(0, 0, 0, 0, 0, 0),
		                                permissions = make$39();
		                               return cont
		                                       ([0,
		 name,
		 data_name,
		 cst$1,
		 meta,
		 schema,
		 _2$18,
		 permissions,
		 0]);
		                              });
		                    }
		                    var
		                     a =
		                       [0,
		                        [0, decisions_processed_col_id, bool_col("Processed")],
		                        0],
		                     a = [0, [0, decisions_notes_col_id, note_col(cst_Notes)], a];
		                    function b(a, cont){
		                     a = [0, [0, customers_plan_col_id, col(cst_Plan, y)], 0];
		                     a = [0, [0, customers_email_col_id, col(cst_Email, bKB)], a];
		                     function b(a, cont){
		                      a =
		                       [0,
		                        [0,
		                         bug_reports_ticket_created_col,
		                         bool_col("Ticket created")],
		                        0];
		                      function b(param, cont){
		                       function a(a, cont){
		                        a =
		                         [0,
		                          [0,
		                           tickets_customers_notified_col,
		                           bool_col("Customers notified")],
		                          0];
		                        a =
		                         [0,
		                          [0, tickets_github_url_col_id, col("GitHub issue URL", bKC)],
		                          a];
		                        a =
		                         [0,
		                          [0,
		                           tickets_bug_report_col_id,
		                           col("Bug report", [3, [0, [0, bug_reports_table_id], 0]])],
		                          a];
		                        function b(a, cont){
		                         a = [0, [0, runs_notes_col_id, note_col(cst_Notes)], 0];
		                         function b(param, cont){
		                          function a(param, cont){
		                           function a(param, cont){
		                            function a(param, cont){
		                             function a(param, cont){
		                              function a(a, cont){
		                               a = [0, block_p("- gavin.harrison@routine.co (pro)"), 0];
		                               a =
		                                [0, block_p("- candide.thovex@routine.co (enterprise)"), a];
		                               function b(param, cont){
		                                function a(param, cont){
		                                 function a(param, cont){
		                                  function a(param, cont){
		                                   var init = integration_context(5, slack_connection_id);
		                                   function a(prepare_auto_id, cont){
		                                    function a(param, cont){
		                                     function a(param, cont){
		                                      function a(param, cont){
		                                       function a(param, cont){
		function a(param, cont){
		 function a(param, cont){
		  function a(a, cont){
		   a =
		    [0,
		     make$33
		      (0,
		       [3,
		        [0,
		         cst$1,
		         "Attendees: Andrew, Dave\n\n## Discussion\nAndrew opened with a quick status check on the mobile redesign \xe2\x80\x94 design signed off on the onboarding flow yesterday, so dev can pick it up next sprint. Dave then flagged the waitlist sign-up form issue as the most urgent item: Candide is close to churning and Gavin reached out again this morning. Dave has narrowed it down to an overly restrictive email validation regex that rejects valid TLDs \xe2\x80\x94 a well-scoped, self-contained fix that should be straightforward to automate with Cursor. The team also briefly touched on the mobile layout issue affecting Helix; not critical yet but worth scheduling soon.\n\n## Decisions\nPrioritise the waitlist sign-up rejection bug as P0 for today. Given how contained the fix is, automate it via Cursor rather than having Dave context-switch. Move the bug report to in-progress and create a ticket with automate enabled so the Cursor workflow kicks in. Notify Candide and Gavin as soon as the fix is confirmed live. Mobile layout issue to be scheduled for next sprint.\n\n## Action items\nNone."]]),
		     0];
		   a =
		    [0,
		     block_p
		      ("Replace its Routine notes (not description) using `updateEvent` with the following meeting summary, by converting to appropriate fresh Routine blocks:"),
		     a];
		   var
		    blocks =
		      [0,
		       block_p
		        ("Find today's 'Demo Product Meeting' event (the most recent one) using `listEventsForDateRange`."),
		       a];
		   function b(inject_auto_id, cont){
		    function a(state, cont){
		     function a(param, cont){
		      function a(param, cont){
		       function a(param, cont){
		        function a(param, cont){
		         return caml_exact_trampoline_cps_call
		                 (list$1,
		                  ctrl,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (get$17,
		                            a,
		                            function(current_menu){
		                             var target = [0, [2, dashboard_page_id]];
		                             function a(t){
		                              function b(b){
		                               function a(a){
		                                return caml_trampoline_cps_call2
		(return$13, [0, today_event_id, prepare_auto_id], cont);
		                               }
		                               return 1 - b
		                                       ? caml_exact_trampoline_cps_call$0
		 (append$14, ctrl, crdt, target, a)
		                                       : a();
		                              }
		                              if(! t) return b(0);
		                              var xs = t[2], item = t[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (equal$213,
		                                       item[1],
		                                       target,
		                                       function(c){
		return c ? b(1) : caml_exact_trampoline_call1(a, xs);
		                                       });
		                             }
		                             return a(current_menu);
		                            });
		                  });
		        }
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id,
		                 state[16],
		                 dashboard_page_id,
		                 function(match){
		                  if(match)
		                   var page = match[1], current_doc = page[3][2];
		                  else
		                   current_doc = empty$0;
		                  return caml_exact_trampoline_cps_call
		                          (to_string$29,
		                           today_event_id,
		                           function(event_id_str){
		                            return caml_exact_trampoline_cps_call
		                                    (to_string$30,
		                                     runs_page_id,
		                                     function(s2){
		                                      var
		                                       b = [0, block_p(cst$8 + s2), 0],
		                                       b = [0, block_h1("Runs"), b],
		                                       b = [0, block_query(decisions_name), b],
		                                       b = [0, block_h1(cst_Decisions), b],
		                                       b = [0, block_query(tickets_name), b],
		                                       b = [0, block_h1("Tickets"), b],
		                                       b = [0, block_query(bug_reports_name), b],
		                                       c = [0, block_h1("Bug reports"), b];
		                                      return caml_exact_trampoline_cps_call
		      (to_string$31,
		       organization_id,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (to_string$55,
		                 inject_auto_id,
		                 function(d){
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$266,
		                           function(e){
		                            return caml_trampoline_cps_call3
		                                    (e,
		                                     d,
		                                     b,
		                                     function(b){
		                                      b = [0, block_p(b), c];
		                                      var d = [0, block_h1("Step 2: Inject transcript"), b];
		                                      return caml_exact_trampoline_cps_call
		      (to_string$31,
		       organization_id,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (to_string$55,
		                 prepare_auto_id,
		                 function(c){
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$267,
		                           function(e){
		                            return caml_trampoline_cps_call3
		                                    (e,
		                                     c,
		                                     b,
		                                     function(b){
		                                      b = [0, block_p(b), d];
		                                      b = [0, block_h1("Start the scenario"), b];
		                                      b = [0, block_p(cst$8 + event_id_str), b];
		                                      var blocks = [0, block_h1("Today's meeting"), b];
		                                      return caml_exact_trampoline_cps_call$1
		      (diff$4,
		       current_doc,
		       [0, blocks],
		       function(match){
		        function b(b){
		         return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		        }
		        if(! match)
		         return caml_trampoline_cps_call2(return$13, 0, b);
		        var op = match[1];
		        return caml_exact_trampoline_cps_call
		                (ignore_m$0,
		                 op,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (notes$1,
		                           a,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (element$13,
		                                     dashboard_page_id,
		                                     function(c){
		                                      return caml_trampoline_cps_call2
		      (c,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (pages,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           workspace,
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$5,
		                                     a,
		                                     function(param, cont){return cont(0);},
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, b);
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call$7
		               (ensure_page,
		                ctrl,
		                crdt,
		                workspace,
		                state,
		                dashboard_page_id,
		                "Demo Dashboard",
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                });
		      }
		      return caml_exact_trampoline_cps_call$1
		              (find_packed_by_id,
		               state[16],
		               runs_page_id,
		               function(match){
		                if(match)
		                 var page = match[1], current_doc = page[3][2];
		                else
		                 current_doc = empty$0;
		                var blocks = [0, block_query(runs_name), 0];
		                return caml_exact_trampoline_cps_call$1
		                        (diff$4,
		                         current_doc,
		                         [0, blocks],
		                         function(match){
		                          function b(b){
		                           return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                          }
		                          if(! match)
		                           return caml_trampoline_cps_call2(return$13, 0, b);
		                          var op = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (ignore_m$0,
		                                   op,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (notes$1,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2
		              (element$13,
		               runs_page_id,
		               function(c){
		                return caml_trampoline_cps_call2
		                        (c,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (pages,
		                                   a,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$2
		    (apply$125,
		     ctrl[1],
		     crdt,
		     workspace,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (map$5,
		               a,
		               function(param, cont){return cont(0);},
		               function(a){
		                return caml_trampoline_cps_call2(return$12, a, b);
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     }
		     return caml_exact_trampoline_cps_call$7
		             (ensure_page,
		              ctrl,
		              crdt,
		              workspace,
		              state,
		              runs_page_id,
		              "Demo Runs",
		              function(b){
		               return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		              });
		    }
		    return caml_exact_trampoline_cps_call$1
		            (state$0,
		             workspace,
		             ctrl[2],
		             function(match){
		              function b(b){
		               return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		              }
		              if(! match)
		               return caml_exact_trampoline_cps_call(return_error, bKG, b);
		              var s = match[1];
		              return caml_exact_trampoline_cps_call(return_ok, s, b);
		             });
		   }
		   var cst_Demo_Inject_transcript = "Demo Inject transcript";
		   return caml_exact_trampoline_cps_call$1
		           (enhanced_prompt,
		            cst_Demo_Inject_transcript,
		            [0, blocks],
		            function(a){
		             return caml_exact_trampoline_cps_call$5
		                     (upsert_automation,
		                      ctrl,
		                      crdt,
		                      workspace,
		                      agent_id_any,
		                      cst_Demo_Inject_transcript,
		                      "Inject transcript",
		                      a,
		                      0,
		                      bKH,
		                      dummy,
		                      function(a){
		                       return caml_exact_trampoline_cps_call$1(let$56, a, b, cont);
		                      });
		            });
		  }
		  return caml_exact_trampoline_cps_call$1
		          (commit_trigger,
		           workspace,
		           [0, decisions_table_id],
		           function(f){
		            var
		             d = [0, integration_context(4, gmail_connection_id)],
		             b =
		               [0,
		                block_p
		                 ("Then if you sent the email, set the triggering row's 'Processed' field to true."),
		                0],
		             b =
		               [0,
		                block_p
		                 ("If the notes instead contain some other instructions, and Submit is checked, try to follow them."),
		                b],
		             b =
		               [0,
		                block_p
		                 ("If the 'No, do not offer a discount' block is checked, send a polite apology email explaining the issue has been resolved and thanking them for their patience."),
		                b],
		             b =
		               [0,
		                block_p
		                 ("If the 'Yes, offer a 20% discount' block is checked, send them a >Gmail email offering a 20% discount as a goodwill gesture for the inconvenience."),
		                b],
		             b =
		               [0,
		                block_p
		                 ("If it is checked: read the paragraph in the Notes to identify the complaining customer and their email. Then read which option was selected."),
		                b],
		             b =
		               [0,
		                block_p
		                 ("Otherwise, check its Notes field. If the check block with content 'Submit' is not checked, do nothing and finish."),
		                b],
		             c = [0, f],
		             e =
		               [0,
		                block_p
		                 ("If its 'Processed' field is true, do nothing and finish."),
		                b];
		            return caml_exact_trampoline_cps_call$1
		                    (kasprintf,
		                     id,
		                     fmt$268,
		                     function(b){
		                      return caml_trampoline_cps_call2
		                              (b,
		                               decisions_name,
		                               function(b){
		                                var blocks = [0, block_p(b), e];
		                                return caml_exact_trampoline_cps_call$1
		(enhanced_prompt,
		 cst_Demo_Act_on_decision,
		 [0, blocks],
		 function(b){
		  return caml_exact_trampoline_cps_call$5
		          (upsert_automation,
		           ctrl,
		           crdt,
		           workspace,
		           agent_id_any,
		           cst_Demo_Act_on_decision,
		           "Act on decision",
		           b,
		           d,
		           c,
		           dummy,
		           function(b){
		            return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		           });
		 });
		                               });
		                     });
		           });
		 }
		 return caml_exact_trampoline_cps_call$1
		         (state$0,
		          workspace,
		          ctrl[2],
		          function(match){
		           function b(gmail_inbox_table_name){
		            return caml_exact_trampoline_cps_call$1
		                    (commit_trigger,
		                     workspace,
		                     [0, gmail_inbox_table_id],
		                     function(f){
		                      var
		                       d = [0, integration_context(4, gmail_connection_id)],
		                       b =
		                         [0,
		                          block_p
		                           ("After creating the decision, create a notice with `createNotice` with message 'A decision is waiting for your input' and location a URL created using the `buildLink` tool on the compound object id you received as output of creating the decision row."),
		                          0],
		                       b =
		                         [0,
		                          block_p("Be sure to use check blocks, not todo blocks."),
		                          b],
		                       b = [0, block_p("- A check block 'Submit'."), b],
		                       b =
		                         [0,
		                          block_p("- A check block 'No, do not offer a discount'."),
		                          b],
		                       b =
		                         [0,
		                          block_p("- A check block 'Yes, offer a 20% discount'."),
		                          b],
		                       c = [0, f],
		                       e =
		                         [0,
		                          block_p
		                           ("- A paragraph block explaining the situation and identifying the customer and bug report if you found them, as markdown links with URLs created using the `buildLink` tool on the compound object ids you found."),
		                          b];
		                      return caml_exact_trampoline_cps_call$1
		                              (kasprintf,
		                               id,
		                               fmt$269,
		                               function(b){
		                                return caml_trampoline_cps_call2
		(b,
		 decisions_name,
		 function(f){
		  var b = [0, block_p(f), e];
		  return caml_exact_trampoline_cps_call$1
		          (kasprintf,
		           id,
		           fmt$270,
		           function(e){
		            return caml_trampoline_cps_call2
		                    (e,
		                     bug_reports_name,
		                     function(f){
		                      var e = [0, block_p(f), b];
		                      return caml_exact_trampoline_cps_call$1
		                              (kasprintf,
		                               id,
		                               fmt$271,
		                               function(b){
		                                return caml_trampoline_cps_call2
		(b,
		 customers_name,
		 function(b){
		  b = [0, block_p(b), e];
		  var
		   f =
		     [0,
		      block_p
		       ("Get it. Check if it is a complaint from a customer about a bug. If not, do nothing and finish."),
		      b];
		  return caml_exact_trampoline_cps_call$1
		          (kasprintf,
		           id,
		           fmt$272,
		           function(b){
		            return caml_trampoline_cps_call2
		                    (b,
		                     gmail_inbox_table_name,
		                     function(b){
		                      var blocks = [0, block_p(b), f];
		                      return caml_exact_trampoline_cps_call$1
		                              (enhanced_prompt,
		                               cst_Demo_Handle_complaint,
		                               [0, blocks],
		                               function(b){
		                                return caml_exact_trampoline_cps_call$5
		(upsert_automation,
		 ctrl,
		 crdt,
		 workspace,
		 agent_id_any,
		 cst_Demo_Handle_complaint,
		 "Handle complaint",
		 b,
		 d,
		 c,
		 dummy,
		 function(b){
		  return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           }
		           if(! match)
		            return caml_exact_trampoline_cps_call
		                    (Table[8], gmail_inbox_table_id, b);
		           var state = match[1];
		           return caml_exact_trampoline_cps_call$1
		                   (find_packed_by_id,
		                    state[25][1],
		                    gmail_inbox_table_id,
		                    function(match){
		                     if(! match)
		                      return caml_exact_trampoline_cps_call
		                              (Table[8], gmail_inbox_table_id, b);
		                     var table = match[1];
		                     return b(table[1]);
		                    });
		          });
		}
		return caml_exact_trampoline_cps_call$1
		        (commit_trigger,
		         workspace,
		         [0, tickets_table_id],
		         function(d){
		          var
		           b = [0, d],
		           c = [0, integration_context(4, gmail_connection_id)];
		          return caml_exact_trampoline_cps_call$1
		                  (kasprintf,
		                   id,
		                   fmt$273,
		                   function(d){
		                    return caml_trampoline_cps_call2
		                            (d,
		                             tickets_name,
		                             function(e){
		                              var d = [0, block_p(e), 0];
		                              return caml_exact_trampoline_cps_call$1
		                                      (kasprintf,
		                                       id,
		                                       fmt$274,
		                                       function(e){
		return caml_trampoline_cps_call2
		        (e,
		         bug_reports_name,
		         function(e){
		          e = [0, block_p(e), d];
		          var
		           f =
		             [0,
		              block_p
		               ("If its 'Status' field is not 'Completed' or its 'Customers notified' field is true, do nothing and finish."),
		              e];
		          return caml_exact_trampoline_cps_call$1
		                  (kasprintf,
		                   id,
		                   fmt$275,
		                   function(d){
		                    return caml_trampoline_cps_call2
		                            (d,
		                             tickets_name,
		                             function(d){
		                              var blocks = [0, block_p(d), f];
		                              return caml_exact_trampoline_cps_call$1
		                                      (enhanced_prompt,
		                                       cst_Demo_Notify_customers,
		                                       [0, blocks],
		                                       function(d){
		return caml_exact_trampoline_cps_call$5
		        (upsert_automation,
		         ctrl,
		         crdt,
		         workspace,
		         agent_id_any,
		         cst_Demo_Notify_customers,
		         "Notify customers",
		         d,
		         c,
		         b,
		         dummy,
		         function(b){
		          return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (state$0,
		        workspace,
		        ctrl[2],
		        function(match){
		         function b(github_issues_table_name){
		          return caml_exact_trampoline_cps_call$1
		                  (commit_trigger,
		                   workspace,
		                   [0, github_issues_table_id],
		                   function(c){
		                    var b = [0, c];
		                    return caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             id,
		                             fmt$276,
		                             function(c){
		                              return caml_trampoline_cps_call2
		                                      (c,
		                                       tickets_name,
		                                       function(c){
		c = [0, block_p(c), 0];
		var
		 d =
		   [0,
		    block_p
		     ("Read its 'state' field. If its state is not 'closed', do nothing and finish."),
		    c];
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$277,
		         function(c){
		          return caml_trampoline_cps_call2
		                  (c,
		                   github_issues_table_name,
		                   function(c){
		                    var blocks = [0, block_p(c), d];
		                    return caml_exact_trampoline_cps_call$1
		                            (enhanced_prompt,
		                             cst_Demo_Close_ticket,
		                             [0, blocks],
		                             function(c){
		                              return caml_exact_trampoline_cps_call$5
		                                      (upsert_automation,
		                                       ctrl,
		                                       crdt,
		                                       workspace,
		                                       agent_id_any,
		                                       cst_Demo_Close_ticket,
		                                       "Close ticket on GitHub close",
		                                       c,
		                                       0,
		                                       b,
		                                       dummy,
		                                       function(b){
		return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         }
		         if(! match)
		          return caml_exact_trampoline_cps_call
		                  (Table[8], github_issues_table_id, b);
		         var state = match[1];
		         return caml_exact_trampoline_cps_call$1
		                 (find_packed_by_id,
		                  state[25][1],
		                  github_issues_table_id,
		                  function(match){
		                   if(! match)
		                    return caml_exact_trampoline_cps_call
		                            (Table[8], github_issues_table_id, b);
		                   var table = match[1];
		                   return b(table[1]);
		                  });
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (commit_trigger,
		       workspace,
		       [0, tickets_table_id],
		       function(f){
		        var
		         d = [0, integration_context(3, github_connection_id)],
		         b =
		           [0,
		            block_p
		             ("Write back the 'GitHub issue URL' field on the ticket row with the created issue URL."),
		            0],
		         b =
		           [0,
		            block_p
		             ("Then post a comment on that issue with the text '@cursor fix it #<issue number>'."),
		            b],
		         b =
		           [0,
		            block_p
		             ("Otherwise, if its 'Automate' field is true and its 'Github issue URL' is empty, create a >GitHub issue in the `routineco/acme-app` repository with a title matching the ticket Title, and a technical description of the bug."),
		            b],
		         c = [0, f],
		         e =
		           [0,
		            block_p
		             ("If its 'Automate' field is false, or its 'Github issue URL' field is already set, do nothing and finish."),
		            b];
		        return caml_exact_trampoline_cps_call$1
		                (kasprintf,
		                 id,
		                 fmt$278,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (b,
		                           tickets_name,
		                           function(b){
		                            var blocks = [0, block_p(b), e];
		                            return caml_exact_trampoline_cps_call$1
		                                    (enhanced_prompt,
		                                     cst_Demo_Summon_cursor,
		                                     [0, blocks],
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$5
		      (upsert_automation,
		       ctrl,
		       crdt,
		       workspace,
		       agent_id_any,
		       cst_Demo_Summon_cursor,
		       "Create GitHub issue",
		       b,
		       d,
		       c,
		       dummy,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (commit_trigger,
		      workspace,
		      [0, bug_reports_table_id],
		      function(c){
		       var b = [0, c];
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$279,
		                function(c){
		                 return caml_trampoline_cps_call2
		                         (c,
		                          tickets_name,
		                          function(c){
		                           c = [0, block_p(c), 0];
		                           var
		                            d =
		                              [0,
		                               block_p
		                                ("If its 'Status' field is not 'in-progress', or its 'Ticket created' field is true, do nothing and finish."),
		                               c];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$280,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      bug_reports_name,
		      function(c){
		       var blocks = [0, block_p(c), d];
		       return caml_exact_trampoline_cps_call$1
		               (enhanced_prompt,
		                cst_Demo_Create_ticket,
		                [0, blocks],
		                function(c){
		                 return caml_exact_trampoline_cps_call$5
		                         (upsert_automation,
		                          ctrl,
		                          crdt,
		                          workspace,
		                          agent_id_any,
		                          cst_Demo_Create_ticket,
		                          "Create ticket row",
		                          c,
		                          0,
		                          b,
		                          dummy,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (commit_trigger,
		     workspace,
		     0,
		     function(d){
		      var
		       b = [0, d],
		       c = [0, integration_context(5, slack_connection_id)];
		      return caml_exact_trampoline_cps_call$1
		              (kasprintf,
		               id,
		               fmt$281,
		               function(d){
		                return caml_trampoline_cps_call2
		                        (d,
		                         bug_reports_name,
		                         function(d){
		                          d = [0, block_p(d), 0];
		                          d =
		                           [0,
		                            block_p
		                             ("Otherwise, if the event is a meeting (more than one attendees), read its notes (meeting transcript summary). Extract key decisions. Post a summary to >Slack #test-integration-app-bot."),
		                            d];
		                          d =
		                           [0,
		                            block_p
		                             ("If the event time end is more than one day ago, do nothing and finish."),
		                            d];
		                          d =
		                           [0,
		                            block_p
		                             ("If the event has no or one attendee, do nothing and finish."),
		                            d];
		                          var
		                           blocks =
		                             [0,
		                              block_p
		                               ("The triggering object is an event. Get it. If it does not exist, do nothing and finish."),
		                              d];
		                          return caml_exact_trampoline_cps_call$1
		                                  (enhanced_prompt,
		                                   cst_Demo_Post_meeting_summary,
		                                   [0, blocks],
		                                   function(d){
		                                    return caml_exact_trampoline_cps_call$5
		    (upsert_automation,
		     ctrl,
		     crdt,
		     workspace,
		     agent_id_any,
		     cst_Demo_Post_meeting_summary,
		     "Process transcript",
		     d,
		     c,
		     b,
		     dummy,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		     });
		                                   });
		                         });
		               });
		     });
		                                   }
		                                   var
		                                    b =
		                                      [0,
		                                       [0,
		[0,
		 [0, [0, 5], slack_connection_id, 0],
		 [0, [0, [0, 4], gmail_connection_id, 0], 0]],
		init[2],
		init[3]]];
		                                   return caml_exact_trampoline_cps_call$1
		   (kasprintf,
		    id,
		    fmt$282,
		    function(c){
		     return caml_trampoline_cps_call2
		             (c,
		              bug_reports_name,
		              function(c){
		               var blocks = [0, block_p(c), 0];
		               return caml_exact_trampoline_cps_call$5
		                       (upsert_automation,
		                        ctrl,
		                        crdt,
		                        workspace,
		                        agent_id_any,
		                        "Demo Prepare meeting",
		                        "Prepare agenda",
		                        [0, blocks],
		                        b,
		                        0,
		                        dummy,
		                        function(b){
		                         return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                        });
		              });
		    });
		                                  }
		                                  return caml_exact_trampoline_cps_call$7
		  (reset_row,
		   ctrl,
		   crdt,
		   workspace,
		   bug_reports_table_id,
		   bug_report_notif_row_id,
		   [0,
		    [0, bug_reports_title_col_id, bKK],
		    [0,
		     [0, bug_reports_status_col_id, bKJ],
		     [0,
		      [0, bug_reports_severity_col_id, bKI],
		      [0,
		       [0,
		        bug_reports_affected_col_id,
		        [4,
		         [0,
		          [7, [0, [0, customers_table_id, customer_drift_row_id]]],
		          0]]],
		       0]]]],
		   function(b){
		    return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		   });
		                                 }
		                                 return caml_exact_trampoline_cps_call$7
		 (reset_row,
		  ctrl,
		  crdt,
		  workspace,
		  bug_reports_table_id,
		  bug_report_slowdown_row_id,
		  [0,
		   [0, bug_reports_title_col_id, bKN],
		   [0,
		    [0, bug_reports_status_col_id, bKM],
		    [0,
		     [0, bug_reports_severity_col_id, bKL],
		     [0,
		      [0,
		       bug_reports_affected_col_id,
		       [4,
		        [0,
		         [7, [0, [0, customers_table_id, customer_helix_row_id]]],
		         0]]],
		      0]]]],
		  function(b){
		   return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		  });
		                                }
		                                return caml_exact_trampoline_cps_call$7
		(reset_row,
		 ctrl,
		 crdt,
		 workspace,
		 bug_reports_table_id,
		 bug_report_export_row_id,
		 [0,
		  [0, bug_reports_title_col_id, bKQ],
		  [0,
		   [0, bug_reports_status_col_id, bKP],
		   [0,
		    [0, bug_reports_severity_col_id, bKO],
		    [0,
		     [0,
		      bug_reports_affected_col_id,
		      [4,
		       [0,
		        [7, [0, [0, customers_table_id, customer_nova_row_id]]],
		        [0,
		         [7, [0, [0, customers_table_id, customer_drift_row_id]]],
		         0]]]],
		     0]]]],
		 function(b){
		  return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		 });
		                               }
		                               return caml_exact_trampoline_cps_call$7
		                                       (reset_row,
		ctrl,
		crdt,
		workspace,
		bug_reports_table_id,
		bug_report_row_id,
		[0,
		 [0, bug_reports_title_col_id, bKT],
		 [0,
		  [0,
		   bug_reports_description_col_id,
		   [5,
		    [0,
		     [0,
		      block_p("Reported emails that could not join the waitlist:"),
		      a]]]],
		  [0,
		   [0, bug_reports_status_col_id, bKS],
		   [0,
		    [0, bug_reports_severity_col_id, bKR],
		    [0,
		     [0,
		      bug_reports_affected_col_id,
		      [4,
		       [0,
		        [7, [0, [0, customers_table_id, bigcorp_row_id]]],
		        [0, [7, [0, [0, customers_table_id, alice_row_id]]], 0]]]],
		     0]]]]],
		function(a){
		 return caml_exact_trampoline_cps_call$1(let$56, a, b, cont);
		});
		                              }
		                              return caml_exact_trampoline_cps_call$7
		                                      (reset_row,
		                                       ctrl,
		                                       crdt,
		                                       workspace,
		                                       customers_table_id,
		                                       customer_drift_row_id,
		                                       [0,
		[0, customers_name_col_id, bKW],
		[0,
		 [0, customers_email_col_id, bKV],
		 [0, [0, customers_plan_col_id, bKU], 0]]],
		                                       function(b){
		return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$7
		                                     (reset_row,
		                                      ctrl,
		                                      crdt,
		                                      workspace,
		                                      customers_table_id,
		                                      customer_helix_row_id,
		                                      [0,
		                                       [0, customers_name_col_id, bKZ],
		                                       [0,
		[0, customers_email_col_id, bKY],
		[0, [0, customers_plan_col_id, bKX], 0]]],
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$7
		                                    (reset_row,
		                                     ctrl,
		                                     crdt,
		                                     workspace,
		                                     customers_table_id,
		                                     customer_nova_row_id,
		                                     [0,
		                                      [0, customers_name_col_id, bK2],
		                                      [0,
		                                       [0, customers_email_col_id, bK1],
		                                       [0, [0, customers_plan_col_id, bK0], 0]]],
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call$7
		                                   (reset_row,
		                                    ctrl,
		                                    crdt,
		                                    workspace,
		                                    customers_table_id,
		                                    alice_row_id,
		                                    [0,
		                                     [0, customers_name_col_id, bK5],
		                                     [0,
		                                      [0, customers_email_col_id, bK4],
		                                      [0, [0, customers_plan_col_id, bK3], 0]]],
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                    });
		                          }
		                          return caml_exact_trampoline_cps_call$7
		                                  (reset_row,
		                                   ctrl,
		                                   crdt,
		                                   workspace,
		                                   customers_table_id,
		                                   bigcorp_row_id,
		                                   [0,
		                                    [0, customers_name_col_id, bK8],
		                                    [0,
		                                     [0, customers_email_col_id, bK7],
		                                     [0, [0, customers_plan_col_id, bK6], 0]]],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                   });
		                         }
		                         var
		                          c = [0, [0, runs_success_col_id, bool_col(cst_Success)], a];
		                         return caml_exact_trampoline_cps_call$1
		                                 (variant_col,
		                                  cst_Status,
		                                  bK9,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call$0
		   (make_table,
		    runs_data_name,
		    runs_name,
		    [0,
		     [0, runs_name_col_id, col(cst_Name, y)],
		     [0, [0, runs_status_col_id, a], c]],
		    function(a){
		     return caml_exact_trampoline_cps_call$3
		             (ensure_table,
		              ctrl,
		              crdt,
		              workspace,
		              runs_table_id,
		              a,
		              function(a){
		               return caml_exact_trampoline_cps_call$1(let$56, a, b, cont);
		              });
		    });
		                                  });
		                        }
		                        var
		                         c =
		                           [0, [0, tickets_automate_col_id, bool_col("Automate")], a];
		                        return caml_exact_trampoline_cps_call$1
		                                (variant_col,
		                                 cst_Status,
		                                 bK_,
		                                 function(a){
		                                  return caml_exact_trampoline_cps_call$0
		  (make_table,
		   tickets_data_name,
		   tickets_name,
		   [0,
		    [0, tickets_title_col_id, col(cst_Title, y)],
		    [0, [0, tickets_status_col_id, a], c]],
		   function(a){
		    return caml_exact_trampoline_cps_call$3
		            (ensure_table,
		             ctrl,
		             crdt,
		             workspace,
		             tickets_table_id,
		             a,
		             function(a){
		              return caml_exact_trampoline_cps_call$1(let$56, a, b, cont);
		             });
		   });
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call$2
		                               (clear_table_rows,
		                                ctrl,
		                                crdt,
		                                workspace,
		                                tickets_table_id,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                });
		                      }
		                      var
		                       c =
		                         [0,
		                          [0,
		                           bug_reports_affected_col_id,
		                           col
		                            ("Affected customers",
		                             [1, [3, [0, [0, customers_table_id], 0]]])],
		                          a];
		                      return caml_exact_trampoline_cps_call$1
		                              (variant_col,
		                               "Severity",
		                               bK$,
		                               function(d){
		                                var a = [0, [0, bug_reports_severity_col_id, d], c];
		                                return caml_exact_trampoline_cps_call$1
		(variant_col,
		 cst_Status,
		 bLa,
		 function(c){
		  c =
		   [0,
		    [0,
		     bug_reports_description_col_id,
		     note_col(cst_Description)],
		    [0, [0, bug_reports_status_col_id, c], a]];
		  return caml_exact_trampoline_cps_call$0
		          (make_table,
		           bug_reports_data_name,
		           bug_reports_name,
		           [0, [0, bug_reports_title_col_id, col(cst_Title, y)], c],
		           function(a){
		            return caml_exact_trampoline_cps_call$3
		                    (ensure_table,
		                     ctrl,
		                     crdt,
		                     workspace,
		                     bug_reports_table_id,
		                     a,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$1(let$56, a, b, cont);
		                     });
		           });
		 });
		                               });
		                     }
		                     return caml_exact_trampoline_cps_call$0
		                             (make_table,
		                              customers_data_name,
		                              customers_name,
		                              [0, [0, customers_name_col_id, col(cst_Name, y)], a],
		                              function(a){
		                               return caml_exact_trampoline_cps_call$3
		                                       (ensure_table,
		ctrl,
		crdt,
		workspace,
		customers_table_id,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call$1(let$56, a, b, cont);
		});
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call$0
		                            (make_table,
		                             decisions_data_name,
		                             decisions_name,
		                             [0,
		                              [0,
		                               decisions_title_col_id,
		                               make_field(0, 0, cst_Title, [0, make$37(bKA)], value$3)],
		                              a],
		                             function(a){
		                              return caml_exact_trampoline_cps_call$3
		                                      (ensure_table,
		                                       ctrl,
		                                       crdt,
		                                       workspace,
		                                       decisions_table_id,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$1(let$56, a, b, cont);
		                                       });
		                             });
		                   }
		                   function b(state, cont){
		                    var now = ocaml_ptime_clock_now_d_ps();
		                    return caml_exact_trampoline_cps_call
		                            (id$37,
		                             ctrl[1],
		                             function(a){
		                              var
		                               runner_email = to_string$42(a),
		                               a = "dave.null@routine.co",
		                               a = [0, [0, a, make_attendee(0, 0, 0, a)], 0];
		                              return caml_exact_trampoline_cps_call$0
		                                      (of_alist_reduce$1,
		                                       [0, comparator$2],
		                                       [0,
		[0, runner_email, make_attendee(0, 0, 0, runner_email)],
		a],
		                                       merge_attendees,
		                                       function(attendees){
		function a(t){
		 if(t){
		  var
		   l = t[2],
		   a$0 = t[1],
		   weeks_ago = a$0[2],
		   event_id = a$0[1],
		   offset_s = weeks_ago * 604800 | 0;
		  return caml_exact_trampoline_cps_call$2
		          (value_exn,
		           bLc,
		           0,
		           bLb,
		           sub_span(now, of_int_s(offset_s)),
		           function(t){
		            return caml_exact_trampoline_cps_call$2
		                    (value_exn,
		                     bLe,
		                     0,
		                     bLd,
		                     add_span(t, of_int_s(1800)),
		                     function(end){
		                      var event_time = [2, t, end];
		                      return caml_exact_trampoline_cps_call$1
		                              (mem$5,
		                               state[5],
		                               event_id,
		                               function(b){
		                                if(b){
		                                 var attendees$0 = [0, attendees];
		                                 return caml_exact_trampoline_cps_call$2
		 (update$15,
		  ctrl,
		  crdt,
		  [0,
		   event_id,
		   [0, 0, 0, attendees$0, 0, 0, 0, 0, 0, 0, [0, event_time], 0]],
		  6,
		  function(match){
		   return 0 === match[0]
		           ? caml_exact_trampoline_call1(a, l)
		           : caml_exact_trampoline_cps_call$1
		             (fatal$0,
		              bLg,
		              bLf,
		              function(b){return caml_exact_trampoline_call1(a, l);});
		  });
		                                }
		                                var
		                                 creation =
		                                   [0,
		                                    calendar_id,
		                                    0,
		                                    make$47
		                                     (0,
		                                      0,
		                                      [0, attendees],
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      0,
		                                      event_time,
		                                      "Demo Product Meeting")];
		                                return caml_exact_trampoline_cps_call$2
		(create$49,
		 [0, event_id],
		 ctrl,
		 crdt,
		 creation,
		 function(b){return caml_exact_trampoline_call1(a, l);});
		                               });
		                     });
		           });
		 }
		 function set_event_notes(event_id, new_doc, cont){
		  return caml_exact_trampoline_cps_call$1
		          (get_event$1,
		           ctrl[2],
		           event_id,
		           function(match){
		            if(! match) return cont();
		            var
		             notes = [0, new_doc],
		             patch =
		               [0, event_id, [0, 0, 0, 0, 0, 0, 0, 0, notes, 0, 0, 0]];
		            return caml_exact_trampoline_cps_call$2
		                    (update$15,
		                     ctrl,
		                     crdt,
		                     patch,
		                     6,
		                     function(match){
		                      return 0 === match[0]
		                              ? cont()
		                              : caml_exact_trampoline_cps_call$1(fatal$0, bLi, bLh, cont);
		                     });
		           });
		 }
		 return caml_exact_trampoline_cps_call$1
		         (set_event_notes,
		          meeting_today_event_id,
		          empty$0,
		          function(match){
		           function make_meeting_doc
		           (heading,
		            attendees_str,
		            discussion,
		            decisions,
		            action_items){
		            var
		             a = [0, block_p(action_items), 0],
		             a = [0, block_h2("Action items"), a],
		             a = [0, block_p(decisions), a],
		             a = [0, block_h2(cst_Decisions), a],
		             a = [0, block_p(discussion), a],
		             a = [0, block_h2("Discussion"), a],
		             a = [0, block_p("Attendees: " + attendees_str), a];
		            return [0, [0, block_h2(heading), a]];
		           }
		           var
		            cst_Andrew_Dave = "Andrew, Dave",
		            cst_Product_Meeting = "Product Meeting";
		           return caml_exact_trampoline_cps_call$1
		                   (set_event_notes,
		                    meeting_2w_event_id,
		                    make_meeting_doc
		                     (cst_Product_Meeting,
		                      cst_Andrew_Dave,
		                      "Reviewed Q2 roadmap priorities. Agreed to push the analytics dashboard to Q3 to free bandwidth for the mobile redesign. Dave gave a quick update on the confetti animation issue in Firefox - it affects a handful of users but workaround is documented, low urgency. Andrew also mentioned that Candide flagged an issue with the waitlist sign-up form - some users getting rejected even though they have valid email addresses - worth keeping an eye on.",
		                      "Deprioritise analytics dashboard to Q3. Dave to keep monitoring the confetti animation issue and close it out. Investigate the sign-up form rejection reports from Candide. No customer communication on waitlist issue until root cause is confirmed.",
		                      "Dave: look into the sign-up form rejection reports and the confetti animation bug. Andrew: adjust Q2 roadmap doc to reflect dashboard deferral."),
		                    function(match){
		                     return caml_exact_trampoline_cps_call$1
		                             (set_event_notes,
		                              meeting_1w_event_id,
		                              make_meeting_doc
		                               (cst_Product_Meeting,
		                                cst_Andrew_Dave,
		                                "Kicked off with a review of the mobile redesign spec. Both agree the onboarding flow needs another round of feedback from design before dev starts. Dave closed out the confetti animation bug - fix shipped last Thursday, no further complaints. On the sign-up form issue: Dave investigated but the root cause is still unclear - some users silently rejected when trying to join the waitlist with no error shown. Gavin is now also affected in addition to Candide, and Candide has escalated and is threatening churn if not resolved this week.",
		                                "Mobile redesign onboarding flow goes back to design for one more review cycle before dev picks it up. Sign-up form rejection issue escalated to high severity given enterprise customers affected. Fix must ship before next meeting.",
		                                "Dave: find root cause and ship the fix for the sign-up form rejection bug. Andrew: coordinate with design on onboarding flow review. Andrew: prepare agenda for next meeting covering the fix status."),
		                              function(match){
		                               return caml_exact_trampoline_cps_call
		                                       (return_ok, meeting_today_event_id, cont);
		                              });
		                    });
		          });
		}
		return a
		        ([0,
		          [0, meeting_2w_event_id, 2],
		          [0,
		           [0, meeting_1w_event_id, 1],
		           [0, [0, meeting_today_event_id, 0], 0]]]);
		                                       });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call$1
		                           (state$0,
		                            workspace,
		                            ctrl[2],
		                            function(match){
		                             function c(c){
		                              return caml_exact_trampoline_cps_call$1
		                                      (let$56,
		                                       c,
		                                       b,
		                                       function(b){
		return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                       });
		                             }
		                             if(! match)
		                              return caml_exact_trampoline_cps_call(return_error, bLj, c);
		                             var s = match[1];
		                             return caml_exact_trampoline_cps_call(return_ok, s, c);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (iter_s,
		                           function(name, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (find_automation_by_name,
		                                     ctrl,
		                                     workspace,
		                                     name,
		                                     function(match){
		                                      if(! match) return cont(return_unit);
		                                      var id = match[1];
		                                      return caml_exact_trampoline_cps_call$3
		      (update_automation,
		       ctrl,
		       crdt,
		       workspace,
		       id,
		       [0, 0, 0, trigger],
		       function(a){return cont(return_unit);});
		                                     });
		                           },
		                           triggered_automation_names,
		                           function(b){
		                            return caml_exact_trampoline_cps_call
		                                    (ok$1,
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                                     });
		                           });
		                 }
		                 function b(agent_data, cont){
		                  var
		                   new_integrations =
		                     [0,
		                      [0, [0, 5], slack_connection_id, 0],
		                      [0,
		                       [0, [0, 4], gmail_connection_id, 0],
		                       [0, [0, [0, 3], github_connection_id, 0], 0]]],
		                   a = agent_data[1][1],
		                   new_context = [0, new_integrations, a[2], a[3]],
		                   new_prompt = [0, new_context, agent_data[1][2]];
		                  return caml_exact_trampoline_cps_call$3
		                          (update_agent,
		                           ctrl,
		                           crdt,
		                           workspace,
		                           agent_id_any,
		                           [0, [0, new_prompt], 0, 0],
		                           function(a){
		                            return caml_trampoline_cps_call2(return$12, a, cont);
		                           });
		                 }
		                 function c(state, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (find_packed_by_id, state[1], agent_id, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (ai_state,
		                          ctrl,
		                          workspace,
		                          function(d){
		                           return caml_exact_trampoline_cps_call$1
		                                   (let$,
		                                    d,
		                                    c,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (return$12,
		      of_option(c, bLk),
		      function(c){
		       return caml_exact_trampoline_cps_call$1
		               (let$56,
		                c,
		                b,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (ai_state,
		                         ctrl,
		                         workspace,
		                         function(match){
		                          function b(existing){
		                           function b(b){
		                            return caml_exact_trampoline_cps_call$1(let$56, b, a, cont);
		                           }
		                           if(! existing)
		                            return caml_exact_trampoline_cps_call$8
		                                    (create$54,
		                                     ctrl,
		                                     crdt,
		                                     organization_id,
		                                     cst_executive_assistant,
		                                     0,
		                                     cst$1,
		                                     dummy,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, b);
		                                     });
		                           var id = existing[1];
		                           return caml_exact_trampoline_cps_call(return_ok, id, b);
		                          }
		                          if(! match) return b(0);
		                          var state = match[1];
		                          function c(d){
		                           if(! d) return b(0);
		                           var l = d[2], x = d[1], a = x[2], id = x[1], t = a[5];
		                           if(t)
		                            var x$0 = t$0[1], x$1 = t[1], d = x$1 === x$0 ? 1 : 0;
		                           else
		                            d = 0;
		                           var r = some_if(d, id);
		                           return r ? b(r) : caml_exact_trampoline_call1(c, l);
		                          }
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_alist$0, 0, state[1], c);
		                         });
		               }
		               var Http$1 = Make$9(Handler);
		               function to_string$75(value, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (encoded_of_query$0(0), 0, value, cont);
		               }
		               function of_string$58(value, cont){
		                return caml_exact_trampoline_cps_call
		                        (query_of_encoded, value, function(a){return cont([0, a]);});
		               }
		               function encode_versioned$1(schema, value, cont){
		                return caml_trampoline_cps_call3
		                        (encode_versioned,
		                         schema,
		                         value,
		                         function(match){
		                          var json = match[1];
		                          function a(form){return cont([0, form]);}
		                          if(typeof json !== "number"){
		                           var variant = json[1];
		                           if(79 === variant){
		                            var fields = json[2];
		                            return caml_exact_trampoline_cps_call$1
		                                    (filter_map$0,
		                                     fields,
		                                     function(param, cont){
		                                      var value = param[2], name = param[1];
		                                      if(typeof value !== "number"){
		                                       var variant = value[1];
		                                       if(-976970511 === variant){
		var value$0 = value[2];
		return cont([0, [0, name, [0, value$0, 0]]]);
		                                       }
		                                      }
		                                      return cont(0);
		                                     },
		                                     a);
		                           }
		                          }
		                          return a(0);
		                         });
		               }
		               function decode$14(schema, fields, cont){
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         fields,
		                         function(param, cont){
		                          var values = param[2], name = param[1];
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   values,
		                                   function(value, cont){return cont([0, -976970511, value]);},
		                                   function(a){return cont([0, name, [0, 65, a]]);});
		                         },
		                         function(a){
		                          var json = [0, 79, a];
		                          return caml_trampoline_cps_call3
		                                  (decode$2, schema, json, cont);
		                         });
		               }
		               var
		                include$290 =
		                  Make_string
		                   ([0,
		                     ,
		                     ,
		                     encode_versioned$1,
		                     decode$14,
		                     "application/x-www-form-urlencoded",
		                     of_string$58,
		                     to_string$75]),
		                encode$12 = include$290[2],
		                content_type = include$290[5],
		                decode$15 = String[4],
		                e =
		                  Cohttp
		                   (Http_client, [0, , encode$12, , decode$15, content_type]),
		                v$48 = of_int_s(30),
		                Form_http = Make$9(With_timeout([0, v$48], e)),
		                request_timeout = of_int_s(30);
		               function http_get(url, cont){
		                var
		                 url$0 = url[1],
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 symbol_map = open[2];
		                function a(a, cont){
		                 if(0 !== a[0])
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$283,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     url$0,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (message$0, a, function(a){return cont([1, a]);});
		                                     });
		                           });
		                 a = a[1];
		                 var status = a[3], headers = a[2], body = a[1];
		                 return cont([0, [0, status, headers, body]]);
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string$19,
		                         url$0,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (to_uri,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$3
		    (Http$1[5][4],
		     [0, request_timeout],
		     bLl,
		     0,
		     Http$1[3],
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function fetch_first_valid
		               (fetch, parse, subject, candidates, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 symbol_map = open[2],
		                 symbol_bind = open[1];
		                function attempt(param, cont){
		                 var expected = param[2], metadata_url = param[1];
		                 function a(error, cont){
		                  if(0 !== error[0]) return cont(error);
		                  var response = error[1];
		                  function a(){
		                   return caml_exact_trampoline_cps_call$1
		                           (of_response,
		                            [0, metadata_url[1]],
		                            response,
		                            function(a){return cont([1, a]);});
		                  }
		                  if(200 !== code(response)) return a();
		                  return caml_exact_trampoline_cps_call$1
		                          (header,
		                           response,
		                           cst_content_type,
		                           function(o){
		                            function b(b){
		                             return b
		                                     ? caml_exact_trampoline_cps_call$1
		                                       (parse,
		expected,
		response[3],
		function(t){
		 if(0 === t[0]) return cont(t);
		 var message = t[1], a = metadata_url[1];
		 return caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          id,
		          fmt$284,
		          function(b){
		           return caml_trampoline_cps_call3
		                   (b,
		                    a,
		                    message,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (message$0, a, function(a){return cont([1, a]);});
		                    });
		          });
		})
		                                     : a();
		                            }
		                            if(! o) return b(0);
		                            var content_type = o[1];
		                            return caml_exact_trampoline_cps_call
		                                    (lowercase_ascii$0,
		                                     content_type,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call$0
		      (is_substring_gen, bPm, a, cst_application_json, b);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (fetch,
		                          metadata_url,
		                          function(b){
		                           return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                          });
		                }
		                function go(param, cont){
		                 if(! param)
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$285,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     subject,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (message$0,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call(fail$2, a, cont);
		       });
		                                     });
		                           });
		                 var rest = param[2], candidate = param[1];
		                 function a(ok, cont){
		                  return 0 === ok[0]
		                          ? caml_trampoline_cps_call2(return$12, ok, cont)
		                          : rest
		                            ? caml_exact_trampoline_cps_call(go, rest, cont)
		                            : caml_trampoline_cps_call2(return$12, ok, cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (attempt,
		                          candidate,
		                          function(b){
		                           return caml_trampoline_cps_call3(symbol_bind, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call(go, candidates, cont);
		               }
		               function discover_protected_resource(opt, url, response, cont){
		                var
		                 fetch = opt ? opt[1] : http_get,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14];
		                function a(resource, cont){
		                 return caml_exact_trampoline_cps_call
		                         (bearer,
		                          response[2],
		                          function(a){
		                           function b(candidates){
		                            function a(candidates, cont){
		                             return caml_exact_trampoline_cps_call$2
		                                     (fetch_first_valid,
		                                      fetch,
		                                      function(expected, body, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (parse$1, expected, body, cont);
		                                      },
		                                      url,
		                                      candidates,
		                                      cont);
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (map_error,
		                                     candidates,
		                                     message$0,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		       });
		                                     });
		                           }
		                           if(a){
		                            a = a[1][1];
		                            if(a){
		                             var metadata_url = a[1];
		                             return caml_exact_trampoline_cps_call
		                                     (of_string$54,
		                                      metadata_url,
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (map$15,
		        a,
		        function(metadata_url, cont){
		         return cont([0, [0, metadata_url, url], 0]);
		        },
		        b);
		                                      });
		                            }
		                           }
		                           function c(metadata_url, cont){
		                            return cont([0, metadata_url, resource[1]]);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (metadata_urls,
		                                    resource,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (map$18,
		      a,
		      c,
		      function(a){
		       return caml_trampoline_cps_call2(of_string$14, a, b);
		      });
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string$55,
		                         url,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map_error,
		                                   b,
		                                   message$0,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (return$12,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function discover_authorization_server(opt, issuer, cont){
		                var
		                 fetch = opt ? opt[1] : http_get,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14];
		                function a(issuer, cont){
		                 return caml_exact_trampoline_cps_call
		                         (metadata_urls$0,
		                          issuer,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (map$18,
		                                    a,
		                                    function(metadata_url, cont){
		                                     return cont([0, metadata_url, issuer]);
		                                    },
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$2
		     (fetch_first_valid, fetch, parse$2, issuer[1], a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (of_string$56,
		                         issuer,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map_error,
		                                   b,
		                                   message$0,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (return$12,
		     b,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function authorization_context
		               (opt, authorization_server, url, response, cont){
		                var
		                 fetch = opt ? opt[1] : http_get,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14],
		                 symbol_map = open[2];
		                function a(resource_metadata, cont){
		                 function a(selected){
		                  function a(selected, cont){
		                   var
		                    issuers$0 = resource_metadata[2],
		                    issuers = resource_metadata[2];
		                   a:
		                   {
		                    if(issuers && ! issuers[2]){
		                     var issuer = issuers[1], a = [0, issuer];
		                     break a;
		                    }
		                    a = [1, issuers];
		                   }
		                   function c(selected){
		                    function a(issuer, cont){
		                     function a(prerequisites, cont){
		                      return caml_exact_trampoline_cps_call
		                              (bearer,
		                               response[2],
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(authorization_scope,
		 a,
		 resource_metadata,
		 function(a){
		  return caml_trampoline_cps_call2
		          (return$13,
		           [0, resource_metadata[1], a, prerequisites],
		           cont);
		 });
		                               });
		                     }
		                     function b(error, cont){
		                      if(0 !== error[0]) return cont(error);
		                      var metadata = error[1], a = metadata[6];
		                      if(a && ! a[1])
		                       return caml_exact_trampoline_cps_call
		                               (message$0,
		                                "authorization server does not support client metadata documents",
		                                function(x){return cont([1, x]);});
		                      a = metadata[5];
		                      if(a){
		                       var methods$0 = a[1];
		                       a:
		                       {
		                        a = methods$0;
		                        for(;;){
		                         if(! a) break;
		                         var bs$0 = a[2], b$0 = a[1], a = cst_none === b$0;
		                         if(a) break a;
		                         a = bs$0;
		                        }
		                        a = 0;
		                       }
		                       if(! a)
		                        return caml_exact_trampoline_cps_call
		                                (message$0,
		                                 "authorization server does not support unauthenticated public clients",
		                                 function(x){return cont([1, x]);});
		                      }
		                      a = metadata[2];
		                      var e = metadata[3], c = metadata[4];
		                      if(a)
		                       if(e)
		                        if(c){
		                         var methods = c[1], c = methods;
		                         for(;;){
		                          var d = "S256";
		                          if(c){
		                           var bs = c[2], b = c[1], c = d === b;
		                           if(! c){c = bs; continue;}
		                          }
		                          else
		                           c = 0;
		                          if(c){
		                           var
		                            token_endpoint = e[1],
		                            authorization_endpoint = a[1],
		                            d = [0, [0, authorization_endpoint, token_endpoint, d]];
		                           break;
		                          }
		                          d = a3T;
		                          break;
		                         }
		                        }
		                        else
		                         d = a3U;
		                       else
		                        d = a3V;
		                      else
		                       d = a3W;
		                      return caml_exact_trampoline_cps_call$1
		                              (map_error, d, message$0, cont);
		                     }
		                     return caml_exact_trampoline_cps_call$1
		                             (discover_authorization_server,
		                              [0, fetch],
		                              issuer[1],
		                              function(c){
		                               return caml_trampoline_cps_call3
		                                       (symbol_map,
		c,
		b,
		function(b){
		 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		});
		                              });
		                    }
		                    return caml_trampoline_cps_call2
		                            (return$12,
		                             selected,
		                             function(b){
		                              return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                             });
		                   }
		                   a:
		                   {
		                    if(0 === a[0]){
		                     if(! selected){var issuer$1 = a[1]; break a;}
		                    }
		                    else if(! selected){
		                     var issuers$1 = a[1];
		                     return caml_trampoline_cps_call3
		                             (map$18,
		                              issuers$1,
		                              to_string$74,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$1
		                                       (concat$0,
		bLm,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call$1
		         (kasprintf,
		          id,
		          fmt$287,
		          function(b){
		           return caml_trampoline_cps_call3
		                   (b,
		                    url,
		                    a,
		                    function(a){
		                     return caml_exact_trampoline_cps_call
		                             (message$0, a, function(x){return c([1, x]);});
		                    });
		          });
		});
		                              });
		                    }
		                    var issuer$0 = selected[1];
		                    b:
		                    {
		                     a = issuers$0;
		                     for(;;){
		                      if(! a) break;
		                      var
		                       bs = a[2],
		                       b = a[1],
		                       y = b[1],
		                       x = issuer$0[1],
		                       a = x === y;
		                      if(a) break b;
		                      a = bs;
		                     }
		                     a = 0;
		                    }
		                    if(! a){
		                     var d = issuer$0[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (kasprintf,
		                              id,
		                              fmt$286,
		                              function(a){
		                               return caml_trampoline_cps_call3
		                                       (a,
		d,
		url,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (message$0, a, function(x){return c([1, x]);});
		});
		                              });
		                    }
		                    issuer$1 = selected[1];
		                   }
		                   return c([0, issuer$1]);
		                  }
		                  return caml_exact_trampoline_cps_call$1
		                          (map_error,
		                           selected,
		                           message$0,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (return$12,
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                     });
		                           });
		                 }
		                 if(! authorization_server) return a(bLn);
		                 var issuer = authorization_server[1];
		                 return caml_exact_trampoline_cps_call
		                         (of_string$56,
		                          issuer,
		                          function(b){
		                           return caml_trampoline_cps_call3(map$15, b, found, a);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$0
		                        (discover_protected_resource,
		                         [0, fetch],
		                         url,
		                         response,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               }
		               var
		                authorization_timeout = minutes(5),
		                all_channels = [0, bleeding, [0, stable, 0]];
		               function client_id(a, cont){
		                a = caml_obj_tag(env_api);
		                function b(match){
		                 var a = caml_obj_tag(env_pns);
		                 function b(match$0){
		                  var b = 0;
		                  function a(v){
		                   function a(channel){
		                    var param = channel[4];
		                    if(param && param[1]) return cont(stable_client_id);
		                    return cont(bleeding_client_id);
		                   }
		                   if(0 === v[0]){
		                    var
		                     open =
		                       g
		                        ([0,
		                          symbol_bind$5,
		                          symbol_map$5,
		                          ,
		                          bind$8,
		                          return$9,
		                          map$17,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Let_syntax$3]),
		                     let$ = open[3],
		                     location = global$0.location,
		                     d =
		                       function(location, cont){
		                        return caml_exact_trampoline_cps_call
		                                (scheme$1,
		                                 location,
		                                 function(t$0){
		                                  if(t$0)
		                                   var x = t[1], x$0 = t$0[1], a = x$0 === x;
		                                  else
		                                   a = 0;
		                                  function c(param){
		                                   if(! param) return cont(0);
		                                   var l = param[2], x = param[1];
		                                   return caml_exact_trampoline_cps_call
		   (host$1,
		    location,
		    function(t){
		     return caml_exact_trampoline_cps_call
		             (host$1,
		              x[2],
		              function(t$0){
		               a:
		               {
		                if(t$0){
		                 if(t){
		                  var x$0 = t[1], x$1 = t$0[1], a = x$1 === x$0 ? 1 : 0;
		                  break a;
		                 }
		                }
		                else if(! t){a = 1; break a;}
		                a = 0;
		               }
		               var r = some_if(a, x);
		               return r ? cont(r) : caml_exact_trampoline_call1(c, l);
		              });
		    });
		                                  }
		                                  return a
		  ? caml_exact_trampoline_cps_call$9
		    (with_uri,
		     0,
		     a5G,
		     0,
		     0,
		     a5F,
		     a5E,
		     a5D,
		     location,
		     function(frontend){
		      return caml_exact_trampoline_cps_call
		              (force,
		               frontend,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (with_port,
		                         a,
		                         p,
		                         function(a){
		                          return cont([0, [0, uri_of_uri(a), frontend, bR9, b]]);
		                         });
		               });
		     })
		  : c(all_channels);
		                                 });
		                       },
		                     c =
		                       function(b){
		                        return caml_trampoline_cps_call3
		                                (let$,
		                                 b,
		                                 d,
		                                 function(from_location){
		                                  if(from_location)
		                                   var channel = from_location[1], v$0 = [1, channel];
		                                  else
		                                   v$0 = a5H;
		                                  if(0 !== v$0[0]){var v = v$0[1]; return a(v);}
		                                  var b = caml_obj_tag(env_bleeding);
		                                  function c(b){
		                                   if(version$2[4]) return a(bleeding);
		                                   if(version$2[5]) return a(bleeding);
		                                   if(! b) return a(stable);
		                                   b = b[1];
		                                   return b !== cst$1
		   ? b !== cst_0 ? a(bleeding) : a(stable)
		   : a(stable);
		                                  }
		                                  if(250 === b) return c(env_bleeding[1]);
		                                  if(246 !== b && 244 !== b) return c(env_bleeding);
		                                  return caml_exact_trampoline_cps_call
		  (force_lazy_block, env_bleeding, c);
		                                 });
		                       };
		                    return is_some$1(location)
		                            ? caml_exact_trampoline_cps_call
		                              (of_string$19,
		                               caml_string_of_jsstring(location.href),
		                               function(a){
		                                return caml_trampoline_cps_call2(return$9, a, c);
		                               })
		                            : c(0);
		                   }
		                   var v$0 = v[1];
		                   return a(v$0);
		                  }
		                  if(match){
		                   if(match$0){
		                    var pns_uri = match$0[1], api_uri = match[1];
		                    return caml_exact_trampoline_cps_call
		                            (of_string$19,
		                             pns_uri,
		                             function(c){
		                              return caml_exact_trampoline_cps_call
		                                      (of_string$19,
		                                       api_uri,
		                                       function(d){return a([1, [0, d, bR_, c, b]]);});
		                             });
		                   }
		                  }
		                  else if(! match$0) return a(a5I);
		                  return caml_exact_trampoline_cps_call
		                          (failwith,
		                           "None or both of ROUTINE_API and ROUTINE_PNS env vars must be set",
		                           a);
		                 }
		                 if(250 === a) return b(env_pns[1]);
		                 if(246 !== a && 244 !== a) return b(env_pns);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, env_pns, b);
		                }
		                if(250 === a) return b(env_api[1]);
		                if(246 !== a && 244 !== a) return b(env_api);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, env_api, b);
		               }
		               function await_authorization_response(listener, state, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 symbol = open[13];
		                function wait(param, cont){
		                 function a(query, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (single_param,
		                           query,
		                           cst_state,
		                           function(a){
		                            a:
		                            {
		                             if(0 === a[0]){
		                              a = a[1];
		                              if(a){var returned = a[1], a = returned === state; break a;}
		                             }
		                             a = 0;
		                            }
		                            return a
		                                    ? caml_exact_trampoline_cps_call$1
		                                      (authorization_response,
		                                       state,
		                                       query,
		                                       function(a){
		return caml_trampoline_cps_call2(return$13, a, cont);
		                                       })
		                                    : caml_exact_trampoline_cps_call(wait, dummy, cont);
		                           });
		                 }
		                 return caml_trampoline_cps_call2
		                         (listener[2],
		                          0,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(symbol, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call(wait, dummy, cont);
		               }
		               var
		                cst_OAuth_authorization_is_not =
		                  "OAuth authorization is not supported on this platform";
		               function authorize$1(open_url, context, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[17],
		                 let$0 = open[14],
		                 symbol_map = open[2];
		                function a(crypto, cont){
		                 function a(listener, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (finalize,
		                           function(param, cont){
		                            var sha256 = crypto[2], random_bytes = crypto[1];
		                            return caml_trampoline_cps_call2
		                                    (random_bytes,
		                                     32,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (base64url,
		       a,
		       function(verifier){
		        return caml_trampoline_cps_call2
		                (sha256,
		                 verifier,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (base64url,
		                           a,
		                           function(a){
		                            var random_bytes = crypto[1];
		                            return caml_trampoline_cps_call2
		                                    (random_bytes,
		                                     32,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call
		      (base64url,
		       b,
		       function(state){
		        function b(client_id, cont){
		         return caml_exact_trampoline_cps_call$3
		                 (authorization_url,
		                  client_id,
		                  context,
		                  listener[1],
		                  a,
		                  state,
		                  function(url){
		                   return caml_exact_trampoline_cps_call
		                           (open_url,
		                            url,
		                            function(match){
		                             function a(query, cont){
		                              function a(code, cont){
		                               var t = context[3][2], t$0 = context[1];
		                               return cont([0, code, verifier, listener[1], t$0[1], t[1]]);
		                              }
		                              return caml_exact_trampoline_cps_call$1
		                                      (map_error,
		                                       query,
		                                       message$0,
		                                       function(b){
		return caml_trampoline_cps_call2
		        (return$12,
		         b,
		         function(b){
		          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		         });
		                                       });
		                             }
		                             function b(param, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (message$0,
		                                       "gave up waiting for the authorization to be completed in the browser",
		                                       function(a){return cont([1, a]);});
		                             }
		                             return caml_exact_trampoline_cps_call
		                                     (sleep,
		                                      authorization_timeout,
		                                      function(c){
		                                       return caml_trampoline_cps_call3
		       (symbol_map,
		        c,
		        b,
		        function(d){
		         var b = [0, d, 0];
		         function c(t, cont){
		          if(0 === t[0]) return cont(t);
		          var message = t[1];
		          return caml_exact_trampoline_cps_call$1
		                  (kasprintf,
		                   id,
		                   fmt$288,
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (a,
		                             message,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (message$0, a, function(a){return cont([1, a]);});
		                             });
		                   });
		         }
		         return caml_exact_trampoline_cps_call$1
		                 (await_authorization_response,
		                  listener,
		                  state,
		                  function(d){
		                   return caml_trampoline_cps_call3
		                           (symbol_map,
		                            d,
		                            c,
		                            function(c){
		                             return caml_exact_trampoline_cps_call
		                                     (pick,
		                                      [0, c, b],
		                                      function(b){
		                                       return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        }
		        return caml_exact_trampoline_cps_call
		                (client_id,
		                 dummy,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (of_string$57,
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map_error,
		                                     a,
		                                     message$0,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call$1(let$0, a, b, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           },
		                           function(param, cont){
		                            return caml_trampoline_cps_call2(listener[3], 0, cont);
		                           },
		                           cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (message$0,
		                          "receiving an OAuth redirect is not supported on this platform",
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (fail$2,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (message$0,
		                         cst_OAuth_authorization_is_not,
		                         function(b){
		                          return caml_trampoline_cps_call2
		                                  (return$12,
		                                   [1, b],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1(let$0, b, a, cont);
		                                   });
		                         });
		               }
		               function is_authentication_challenge(response){
		                var a = code(response), c = t$1;
		                for(;;){
		                 if(! c) return 0;
		                 var bs = c[2], b = c[1], c = a === b ? 1 : 0;
		                 if(c) return c;
		                 c = bs;
		                }
		               }
		               function probe_authorization_challenge(server, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 symbol_bind = open[1],
		                 match = server[3];
		                if(0 !== match[0])
		                 return caml_exact_trampoline_cps_call
		                         (message$0,
		                          "a stdio MCP server takes its credentials from its environment, not from OAuth",
		                          function(a){
		                           return caml_exact_trampoline_cps_call(fail$2, a, cont);
		                          });
		                var url = match[1];
		                function a(a, cont){
		                 if(0 === a[0])
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$289,
		                           function(a){
		                            return caml_trampoline_cps_call2
		                                    (a,
		                                     url,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (message$0,
		       a,
		       function(a){
		        return caml_exact_trampoline_cps_call(fail$2, a, cont);
		       });
		                                     });
		                           });
		                 var error = a[1], a = error[2];
		                 if(! a)
		                  return caml_exact_trampoline_cps_call(fail$2, error, cont);
		                 var response = a[1];
		                 return is_authentication_challenge(response)
		                         ? caml_trampoline_cps_call2
		                           (return$13, [0, url, response], cont)
		                         : caml_exact_trampoline_cps_call(fail$2, error, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (list_tools_result,
		                         server,
		                         function(b){
		                          return caml_trampoline_cps_call3(symbol_bind, b, a, cont);
		                         });
		               }
		               function discover_authorization_servers(server, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14],
		                 let$0 = open[4];
		                function a(param, cont){
		                 var response = param[2], url = param[1];
		                 function a(metadata, cont){
		                  return caml_trampoline_cps_call3
		                          (map$15,
		                           metadata,
		                           function(metadata, cont){
		                            return caml_trampoline_cps_call3
		                                    (map$18, metadata[2], to_string$74, cont);
		                           },
		                           cont);
		                 }
		                 return caml_exact_trampoline_cps_call$0
		                         (discover_protected_resource,
		                          0,
		                          url,
		                          response,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$0, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (probe_authorization_challenge,
		                         server,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               }
		               function exchange_code(authorization, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[3];
		                return caml_exact_trampoline_cps_call
		                        (of_string$55,
		                         authorization[4],
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (client_id,
		                                   dummy,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_string$57,
		     a,
		     function(match$0){
		      a:
		      {
		       if(0 === match[0]){
		        var resource = match[1];
		        if(0 === match$0[0]){
		         var
		          client_id = match$0[1],
		          request =
		            [0,
		             [0,
		              authorization[1],
		              authorization[3],
		              client_id,
		              authorization[2],
		              resource]];
		         break a;
		        }
		        var message$1 = match$0[1];
		       }
		       else
		        message$1 = match[1];
		       request = [1, message$1];
		      }
		      if(0 === request[0]){
		       var
		        request$0 = request[1],
		        t = request$0[5],
		        t$0 = request$0[3],
		        form =
		          [0,
		           a37,
		           [0,
		            [0, cst_code, request$0[1]],
		            [0,
		             [0, cst_redirect_uri, request$0[2]],
		             [0,
		              [0, cst_client_id, t$0[1]],
		              [0,
		               [0, "code_verifier", request$0[4]],
		               [0, [0, cst_resource, t[1]], 0]]]]]],
		        url = authorization[5],
		        a =
		          function(response, cont){
		           return caml_trampoline_cps_call3
		                   (bind$6,
		                    response,
		                    function(response, cont){
		                     return 200 === code(response)
		                             ? caml_exact_trampoline_cps_call$1
		                               (header,
		                                response,
		                                cst_content_type,
		                                function(match){
		                                 var
		                                  cst_token_endpoint_returned_a_ =
		                                    "token endpoint returned a successful response without JSON";
		                                 if(! match)
		                                  return caml_exact_trampoline_cps_call
		  (message$0,
		   cst_token_endpoint_returned_a_,
		   function(a){return cont([1, a]);});
		                                 var content_type = match[1];
		                                 return caml_exact_trampoline_cps_call
		 (lowercase_ascii$0,
		  content_type,
		  function(a){
		   return caml_exact_trampoline_cps_call$0
		           (is_substring_gen,
		            bPm,
		            a,
		            cst_application_json,
		            function(a){
		             return a
		                     ? caml_exact_trampoline_cps_call
		                       (decode_token_response,
		                        response[3],
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (map_error,
		                                  a,
		                                  message$0,
		                                  function(a){
		                                   return caml_trampoline_cps_call3
		   (bind$6,
		    a,
		    function(token, cont){
		     return caml_exact_trampoline_cps_call$1
		             (equal$7,
		              token[2],
		              cst_bearer,
		              function(b){
		               if(b) return cont([0, token[1]]);
		               var a = token[2];
		               return caml_exact_trampoline_cps_call$1
		                       (kasprintf,
		                        id,
		                        fmt$291,
		                        function(b){
		                         return caml_trampoline_cps_call2
		                                 (b,
		                                  a,
		                                  function(a){
		                                   return caml_exact_trampoline_cps_call
		   (message$0, a, function(a){return cont([1, a]);});
		                                  });
		                        });
		              });
		    },
		    cont);
		                                  });
		                        })
		                     : caml_exact_trampoline_cps_call
		                       (message$0,
		                        cst_token_endpoint_returned_a_,
		                        function(a){return cont([1, a]);});
		            });
		  });
		                                })
		                             : caml_exact_trampoline_cps_call$1
		                               (of_response,
		                                0,
		                                response,
		                                function(a){return cont([1, a]);});
		                    },
		                    function(a){
		                     return caml_trampoline_cps_call2(return$12, a, cont);
		                    });
		          };
		       return caml_trampoline_cps_call3
		               (map$18,
		                form,
		                function(param, cont){
		                 var value = param[2], name = param[1];
		                 return cont([0, name, [0, -976970511, value]]);
		                },
		                function(c){
		                 var
		                  body = [0, 79, c],
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4]),
		                  let$0 = open[4];
		                 function b(response, cont){
		                  if(0 !== response[0])
		                   return caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$290,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a,
		                                      url,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (message$0, a, function(a){return cont([1, a]);});
		                                      });
		                            });
		                  var
		                   match = response[1],
		                   status = match[3],
		                   headers = match[2],
		                   body = match[1];
		                  return cont([0, [0, status, headers, body]]);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (of_string$19,
		                          url,
		                          function(c){
		                           return caml_exact_trampoline_cps_call
		                                   (to_uri,
		                                    c,
		                                    function(c){
		                                     return caml_exact_trampoline_cps_call$3
		     (Form_http[5][7],
		      [0, request_timeout],
		      bLo,
		      [0, [0, json_schema, body]],
		      Http$1[3],
		      c,
		      function(c){
		       return caml_trampoline_cps_call3
		               (let$0,
		                c,
		                b,
		                function(b){
		                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                });
		      });
		                                    });
		                          });
		                });
		      }
		      var message = request[1];
		      return caml_exact_trampoline_cps_call
		              (message$0,
		               message,
		               function(a){
		                return caml_trampoline_cps_call2(return$12, [1, a], cont);
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$35 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$57 = open$35[3],
		                let$58 = open$35[14];
		               function with_server(servers, server, cont){
		                function a(t){
		                 function b(a){
		                  return a
		                          ? caml_trampoline_cps_call3
		                            (map$18,
		                             servers,
		                             function(existing, cont){
		                              return caml_exact_trampoline_cps_call$1
		                                      (Id$8[15],
		                                       existing[1],
		                                       server[1],
		                                       function(a){return a ? cont(server) : cont(existing);});
		                             },
		                             cont)
		                          : caml_exact_trampoline_cps_call$1
		                            (append$0, servers, [0, server, 0], cont);
		                 }
		                 if(! t) return b(0);
		                 var xs = t[2], existing = t[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (Id$8[15],
		                          existing[1],
		                          server[1],
		                          function(c){
		                           return c ? b(1) : caml_exact_trampoline_call1(a, xs);
		                          });
		                }
		                return a(servers);
		               }
		               function connection_of_probe
		               (fetch$1, oauth_supported, server, a, cont){
		                if(0 === a[0]){
		                 var tools = a[1];
		                 return caml_trampoline_cps_call2
		                         (return$12,
		                          [0,
		                           [0,
		                            server[1],
		                            server[2],
		                            server[3],
		                            server[4],
		                            server[5],
		                            server[6],
		                            tools],
		                           0],
		                          cont);
		                }
		                var
		                 error = a[1],
		                 message = error[1],
		                 a = server[3],
		                 match = error[2];
		                a:
		                {
		                 var d = server[4];
		                 if(0 === a[0] && typeof d === "number" && match){
		                  var response = match[1], url = a[1];
		                  if(is_authentication_challenge(response)){a = [0, [0, url, response]]; break a;}
		                 }
		                 a = 0;
		                }
		                if(! a)
		                 return caml_trampoline_cps_call2
		                         (return$12, [0, server, [0, message]], cont);
		                a = a[1];
		                var response$0 = a[2], url$0 = a[1];
		                function e(available, cont){
		                 var
		                  connection =
		                    0 === available[0] ? [2, message] : [1, message];
		                 return caml_trampoline_cps_call2
		                         (return$12, [0, server, connection], cont);
		                }
		                if(oauth_supported)
		                 var supported = oauth_supported[1];
		                else {a = is_some(0); supported = a ? is_some(0) : a;}
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[4];
		                function b(a){
		                 return caml_trampoline_cps_call3(let$57, a, e, cont);
		                }
		                if(! supported)
		                 return caml_exact_trampoline_cps_call
		                         (message$0,
		                          cst_OAuth_authorization_is_not,
		                          function(a){
		                           return caml_exact_trampoline_cps_call(fail$2, a, b);
		                          });
		                if(fetch$1)
		                 var
		                  fetch = fetch$1[1],
		                  fetch$0 = function(url, cont){return cont(fetch());};
		                else
		                 fetch$0 = http_get;
		                function c(context, cont){
		                 return caml_trampoline_cps_call3
		                         (map$15,
		                          context,
		                          function(param, cont){return cont(0);},
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (authorization_context,
		                         [0, fetch$0],
		                         0,
		                         url$0,
		                         response$0,
		                         function(a){
		                          return caml_trampoline_cps_call3(let$, a, c, b);
		                         });
		               }
		               function probe_and_store
		               (list_tools, fetch, oauth_supported, ctrl, server, cont){
		                var list_tools$0 = value$4(list_tools, list_tools_result);
		                function a(result, cont){
		                 function a(param, cont){
		                  var connection = param[2], server = param[1];
		                  function a(servers, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (with_server,
		                            servers,
		                            server,
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (duplicate_name,
		                                      a,
		                                      function(match){
		                                       if(match){
		var name = match[1];
		return caml_exact_trampoline_cps_call$1
		        (kasprintf,
		         id,
		         fmt$292,
		         function(a){
		          return caml_trampoline_cps_call2
		                  (a,
		                   name,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (fail$2, [0, 9943782, a], cont);
		                   });
		         });
		                                       }
		                                       function a(param, cont){
		return caml_trampoline_cps_call2
		        (return$13, [0, server, connection], cont);
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (upsert$3,
		        ctrl,
		        server,
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$58, b, a, cont);
		        });
		                                      });
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (list$2,
		                           ctrl,
		                           function(b){
		                            return caml_trampoline_cps_call3(let$57, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$2
		                         (connection_of_probe,
		                          fetch,
		                          oauth_supported,
		                          server,
		                          result,
		                          function(b){
		                           return caml_trampoline_cps_call3(let$57, b, a, cont);
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (list_tools$0,
		                         server,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$57, b, a, cont);
		                         });
		               }
		               function authorize$2(ctrl, server, open_url, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14];
		                function b(authorized, cont){
		                 if(0 === authorized[0]){
		                  var
		                   authorization = authorized[1],
		                   a =
		                     function(token, cont){
		                      if(0 === token[0]){
		                       var
		                        token$0 = token[1],
		                        a =
		                          function(status, cont){
		                           if(0 !== status[0]){
		                            var error = status[1];
		                            return caml_exact_trampoline_cps_call(fail$2, error, cont);
		                           }
		                           var match = status[1][2];
		                           if(typeof match === "number")
		                            return caml_trampoline_cps_call2(return$13, 0, cont);
		                           var message = match[1];
		                           return caml_trampoline_cps_call2
		                                   (return$13, [0, message], cont);
		                          };
		                       return caml_exact_trampoline_cps_call$3
		                               (probe_and_store,
		                                0,
		                                0,
		                                0,
		                                ctrl,
		                                [0,
		                                 server[1],
		                                 server[2],
		                                 server[3],
		                                 [0, token$0],
		                                 server[5],
		                                 server[6],
		                                 server[7]],
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$57, b, a, cont);
		                                });
		                      }
		                      var error = token[1], message = error[1];
		                      return caml_trampoline_cps_call2
		                              (return$13, [0, message], cont);
		                     };
		                  return caml_exact_trampoline_cps_call
		                          (exchange_code,
		                           authorization,
		                           function(b){
		                            return caml_trampoline_cps_call3(let$57, b, a, cont);
		                           });
		                 }
		                 var error = authorized[1], message = error[1];
		                 return caml_trampoline_cps_call2
		                         (return$13, [0, message], cont);
		                }
		                function a(param, cont){
		                 var response = param[2], url = param[1];
		                 function a(context, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (authorize$1, open_url, context, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$2
		                         (authorization_context,
		                          0,
		                          0,
		                          url,
		                          response,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (probe_authorization_challenge,
		                         server,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$,
		                                   c,
		                                   a,
		                                   function(a){
		                                    return caml_trampoline_cps_call3(let$57, a, b, cont);
		                                   });
		                         });
		               }
		               var
		                open$36 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$59 = open$36[3],
		                let$60 = open$36[14],
		                schematic_cache$1331 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$1371 = [];
		               caml_update_dummy
		                (letrec_function_context$1371, [0, schematic_cache$1331]);
		               function schematic_version$364(param, cont){return cont(0);}
		               var
		                schematic_schema_version$55 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$1371[1][1],
		                     schematic_schema_version$55]);
		               if(e)
		                var schema$256 = e[1], descriptor$60 = schema$256;
		               else
		                descriptor$60 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$1371[1][1],
		                              schematic_schema_version$55,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$1371[1][1],
		 schematic_schema_version$55,
		 schematic_self,
		 function(a){
		  letrec_function_context$1371[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (schema_versioned$86,
		           schematic_version$364,
		           function(b){
		            var
		             a =
		               [0,
		                [0, 0, 0, 0, 0, "fast_mode", 0, 3, [0, bool_schema], 0, 0],
		                [0, [0, 0, 0, 0, 0, cst_model, 0, 3, [0, b], 0, 0], 0]];
		            return caml_exact_trampoline_cps_call
		                    (effort_schema_versioned,
		                     schematic_version$364,
		                     function(b){
		                      var
		                       res =
		                         [7,
		                          function(param, cont){
		                           var
		                            a = param[2],
		                            model = a[2][1],
		                            fast_mode = a[1],
		                            reasoning_effort = param[1];
		                           return cont([0, reasoning_effort, fast_mode, model]);
		                          },
		                          function(param, cont){
		                           var
		                            model = param[3],
		                            fast_mode = param[2],
		                            reasoning_effort = param[1];
		                           return cont
		                                   ([0, reasoning_effort, [0, fast_mode, [0, model, 0]]]);
		                          },
		                          [0,
		                           [0, 0, 0, 0, 0, "reasoning_effort", 0, 3, [0, b], 0, 0],
		                           a]];
		                      return caml_exact_trampoline_cps_call$0
		                              (set$3,
		                               letrec_function_context$1371[1][1],
		                               schematic_schema_version$55,
		                               res,
		                               function(a){
		                                letrec_function_context$1371[1][1] = a;
		                                return cont(res);
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var schema$257 = [0, bLp, 0, descriptor$60, 0];
		               function agent_context(agent, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_string$72,
		                         agent[8][2],
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (to_string$72,
		                                   agent[7][2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (to_string$72,
		     agent[1][2],
		     function(c){return cont([0, c, b, a]);});
		                                   });
		                         });
		               }
		               function merge_prompt_contexts(stored, incoming, cont){
		                function merge_assoc
		                (equal_key, get_key, existing, incoming, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (filter,
		                          incoming,
		                          function(item, cont){
		                           function a(t){
		                            function b(a){return cont(1 - a);}
		                            if(! t) return b(0);
		                            var xs = t[2], x = t[1], c = get_key(item);
		                            return caml_exact_trampoline_cps_call$1
		                                    (equal_key,
		                                     get_key(x),
		                                     c,
		                                     function(c){
		                                      return c ? b(1) : caml_exact_trampoline_call1(a, xs);
		                                     });
		                           }
		                           return a(existing);
		                          },
		                          function(new_items){
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0, existing, new_items, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (merge_assoc,
		                         equal$158,
		                         function(t){return t[1];},
		                         stored[3],
		                         incoming[3],
		                         function(a){
		                          return caml_exact_trampoline_cps_call$2
		                                  (merge_assoc,
		                                   equal$158,
		                                   function(t){return t[1];},
		                                   stored[2],
		                                   incoming[2],
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$2
		    (merge_assoc,
		     equal$156,
		     function(t){return t[1];},
		     stored[1],
		     incoming[1],
		     function(c){return cont([0, c, b, a]);});
		                                   });
		                         });
		               }
		               function organizations_scope_of_agent
		               (ctrl, organization_id, agent, cont){
		                if(! agent) return cont([0, organization_id]);
		                var a = agent[1];
		                return 0 === a[4][0]
		                        ? cont([0, organization_id])
		                        : caml_exact_trampoline_cps_call
		                          (state_personal,
		                           ctrl[2],
		                           function(state_personal){
		                            return caml_exact_trampoline_cps_call
		                                    (keys$0,
		                                     state_personal[15],
		                                     function(all_orgs){
		                                      return caml_trampoline_cps_call2
		      (equal$53,
		       organization_id,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (filter,
		                 all_orgs,
		                 function(b, cont){
		                  return caml_exact_trampoline_cps_call$1(non, a, b, cont);
		                 },
		                 function(a){return cont([1, organization_id, a]);});
		       });
		                                     });
		                           });
		               }
		               function responses_call_offline
		               (opt,
		                dynamic_tools,
		                ctrl,
		                tools,
		                organization_id,
		                on_progress,
		                request,
		                cont){
		                var
		                 initial_tool_calls = opt ? opt[1] : 0,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14],
		                 symbol_map = open[2];
		                function a(result, cont){
		                 return caml_trampoline_cps_call2(return$12, result, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (offline$0("calling the AI model", ctrl),
		                         function(param, cont){
		                          function a(ok, cont){
		                           if(0 === ok[0]) return cont([0, ok]);
		                           var limit = ok[1];
		                           if(typeof limit !== "number"){
		                            var variant = limit[1];
		                            if(-867418942 > variant) return cont([0, [1, limit]]);
		                           }
		                           return cont([1, limit]);
		                          }
		                          return caml_exact_trampoline_cps_call$8
		                                  (call$5,
		                                   [0, initial_tool_calls],
		                                   dynamic_tools,
		                                   ctrl,
		                                   tools,
		                                   organization_id,
		                                   on_progress,
		                                   request,
		                                   function(b){
		                                    return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                                   });
		                         },
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                         });
		               }
		               function conversation_send
		               (graph,
		                ctrl,
		                crdt,
		                attachments,
		                context,
		                conversation_id,
		                organization_id,
		                workspace,
		                response_format,
		                response_format_instructions,
		                b,
		                a,
		                opt,
		                message,
		                cont){
		                var
		                 prompt_options = b ? b[1] : default$0,
		                 model_options = a ? a[1] : default$3,
		                 metric_kind = opt ? opt[1] : 0,
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14],
		                 let$0 = open[4],
		                 let$1 = open[3],
		                 symbol_map = open[2],
		                 symbol_bind = open[1],
		                 open$0 = g(include$0),
		                 let$2 = open$0[8];
		                function c(param, cont){
		                 var
		                  automation_run_context = param[4],
		                  organizations_scope = param[3],
		                  conversation = param[2],
		                  agent = param[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (merge_prompt_contexts,
		                          conversation[2],
		                          context,
		                          function(merged_ctx){
		                           return caml_exact_trampoline_cps_call$1
		                                   (merge_prompt_contexts,
		                                    agent[7][1],
		                                    agent[8][1],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (merge_prompt_contexts,
		      agent[1][1],
		      a,
		      function(agent_ctx){
		       return caml_exact_trampoline_cps_call$1
		               (merge_prompt_contexts,
		                agent_ctx,
		                merged_ctx,
		                function(effective_ctx){
		                 return caml_exact_trampoline_cps_call
		                         (agent_context,
		                          agent,
		                          function(c){
		                           var
		                            prompt_context =
		                              [0, c, attachments, message, automation_run_context],
		                            connection_manager = [0, [0, 0], [0, 0]];
		                           function a(param, cont){
		                            var
		                             current_hash = param[3],
		                             tools = param[2],
		                             request = param[1],
		                             model = model_options[3],
		                             fast_mode = model_options[2],
		                             reasoning_effort = model_options[1];
		                            if(reasoning_effort)
		                             var
		                              effort = reasoning_effort[1],
		                              request$0 =
		                                [0,
		                                 request[1],
		                                 request[2],
		                                 request[3],
		                                 request[4],
		                                 request[5],
		                                 request[6],
		                                 request[7],
		                                 request[8],
		                                 [0, [0, effort]],
		                                 request[10]];
		                            else
		                             request$0 = request;
		                            var
		                             request$1 =
		                               fast_mode
		                                ? fast_mode
		                                   [1]
		                                  ? [0,
		                                    request$0[1],
		                                    request$0[2],
		                                    request$0[3],
		                                    request$0[4],
		                                    request$0[5],
		                                    request$0[6],
		                                    request$0[7],
		                                    request$0[8],
		                                    request$0[9],
		                                    bLq]
		                                  : request$0
		                                : request$0;
		                            function a(request){
		                             function to_tool_calls(calls, cont){
		                              return caml_trampoline_cps_call3
		                                      (map$18,
		                                       calls,
		                                       function(c, cont){return cont([0, c[2], c[1], c[3]]);},
		                                       cont);
		                             }
		                             function apply_in_progress(v, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (set_in_progress,
		                                       v,
		                                       function(a){
		return caml_trampoline_cps_call2
		        (Ident$0[6][16],
		         conversation_id,
		         function(b){
		          return caml_trampoline_cps_call2
		                  (b,
		                   a,
		                   function(a){
		                    return caml_exact_trampoline_cps_call
		                            (conversations$0,
		                             a,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (ai$0,
		                                       a,
		                                       function(a){
		return caml_exact_trampoline_cps_call$2
		        (apply$125,
		         ctrl[1],
		         crdt,
		         workspace,
		         a,
		         function(a){
		          return caml_trampoline_cps_call2(return$12, a, cont);
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             }
		                             function on_progress(tool_calls_so_far, cont){
		                              return caml_exact_trampoline_cps_call
		                                      (to_tool_calls,
		                                       tool_calls_so_far,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (apply_in_progress, [0, [0, a]], cont);
		                                       });
		                             }
		                             function a(call_result, cont){
		                              function b(param, cont){
		                               var
		                                extra_crdt_ops = param[4],
		                                tool_calls = param[3],
		                                citations = param[2],
		                                output_text = param[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (append$0,
		conversation[3],
		[0,
		 [0, [0, attachments], message, 0],
		 [0, [0, [1, tool_calls], output_text, citations], 0]],
		function(full_history){
		 return caml_exact_trampoline_cps_call$1
		         (merge_prompt_contexts,
		          merged_ctx,
		          [0, connection_manager[2][1], default$[2], default$[3]],
		          function(stored_ctx){
		           var t = ocaml_ptime_clock_now_d_ps();
		           function a(param, cont){
		            function a(a){
		             return caml_exact_trampoline_cps_call
		                     (length$1,
		                      citations,
		                      function(a){
		                       return caml_exact_trampoline_cps_call
		                               (length$1,
		                                tool_calls,
		                                function(b){
		                                 b =
		                                  ai_conversation
		                                   (conversation_id,
		                                    organization_id,
		                                    [1, metric_kind, 1 - is_empty(attachments), b, 0, a, 0]);
		                                 return caml_exact_trampoline_cps_call$0
		 (push_dont_wait$0,
		  ctrl[11],
		  0,
		  b,
		  function(match){
		   return caml_trampoline_cps_call2
		           (return$13, [0, output_text, citations], cont);
		  });
		                                });
		                      });
		            }
		            return conversation[8]
		                    ? a()
		                    : caml_exact_trampoline_cps_call
		                      (async,
		                       function(param, cont){
		                        function a(res, cont){
		                         if(0 === res[0]) return cont(0);
		                         var error = res[1];
		                         return caml_exact_trampoline_cps_call
		                                 (Sync[4],
		                                  function(m, cont){
		                                   return caml_trampoline_cps_call6
		   (m, 0, 0, bLr, pp$125, error, cont);
		                                  },
		                                  cont);
		                        }
		                        return caml_exact_trampoline_cps_call$8
		                                (generate_title,
		                                 ctrl,
		                                 crdt,
		                                 workspace,
		                                 conversation_id,
		                                 organization_id,
		                                 0,
		                                 message,
		                                 function(b){
		                                  return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                 });
		                       },
		                       a);
		           }
		           return caml_exact_trampoline_cps_call
		                   (Latest[13],
		                    t,
		                    function(b){
		                     return caml_exact_trampoline_cps_call
		                             (v$13,
		                              [8, b],
		                              function(c){
		                               var b = [0, c, 0];
		                               return caml_exact_trampoline_cps_call
		                                       (set_in_progress,
		0,
		function(d){
		 var c = [0, d, b];
		 return caml_exact_trampoline_cps_call
		         (History[12],
		          full_history,
		          function(b){
		           return caml_exact_trampoline_cps_call
		                   (v$13,
		                    [2, b],
		                    function(d){
		                     var b = [0, d, c];
		                     return caml_exact_trampoline_cps_call$1
		                             (set_context,
		                              conversation[2],
		                              stored_ctx,
		                              function(c){
		                               return caml_exact_trampoline_cps_call$1
		                                       (append$0,
		[0, c, b],
		extra_crdt_ops,
		function(b){
		 return caml_exact_trampoline_cps_call
		         (all_unit$9,
		          b,
		          function(b){
		           return caml_trampoline_cps_call2
		                   (Ident$0[6][16],
		                    conversation_id,
		                    function(c){
		                     return caml_trampoline_cps_call2
		                             (c,
		                              b,
		                              function(b){
		                               return caml_exact_trampoline_cps_call
		                                       (conversations$0,
		b,
		function(b){
		 return caml_exact_trampoline_cps_call
		         (ai$0,
		          b,
		          function(b){
		           return caml_exact_trampoline_cps_call$2
		                   (apply$125,
		                    ctrl[1],
		                    crdt,
		                    workspace,
		                    b,
		                    function(b){
		                     return caml_trampoline_cps_call2
		                             (return$12,
		                              b,
		                              function(b){
		                               return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              });
		                    });
		          });
		});
		                              }
		                              function a(a){
		                               return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                              }
		                              if(0 !== call_result[0])
		                               return caml_exact_trampoline_cps_call(return_error, bLs, a);
		                              var response = call_result[1];
		                              return caml_exact_trampoline_cps_call
		                                      (to_tool_calls,
		                                       response[3],
		                                       function(tool_calls){
		return caml_exact_trampoline_cps_call
		        (String_opt_LWW[12],
		         [0, current_hash],
		         function(b){
		          return caml_exact_trampoline_cps_call
		                  (v$13,
		                   [5, b],
		                   function(c){
		                    var v = [0, response[1]], b = [0, c, 0];
		                    return caml_exact_trampoline_cps_call
		                            (Response_id_opt_LWW[12],
		                             v,
		                             function(c){
		                              return caml_exact_trampoline_cps_call
		                                      (v$13,
		                                       [6, c],
		                                       function(c){
		return caml_exact_trampoline_cps_call
		        (return_ok,
		         [0, response[2], response[4], tool_calls, [0, c, b]],
		         a);
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$8
		                                     (responses_call_offline,
		                                      0,
		                                      [0, connection_manager[1]],
		                                      ctrl,
		                                      tools,
		                                      organization_id,
		                                      [0, on_progress],
		                                      request,
		                                      function(f){
		                                       return caml_trampoline_cps_call3
		       (symbol_bind,
		        f,
		        function(ok, cont){
		         if(0 === ok[0])
		          return caml_trampoline_cps_call2(return$12, ok, cont);
		         function a(param, cont){
		          return caml_trampoline_cps_call2(return$12, ok, cont);
		         }
		         return caml_exact_trampoline_cps_call
		                 (apply_in_progress,
		                  0,
		                  function(b){
		                   return caml_trampoline_cps_call3(let$1, b, a, cont);
		                  });
		        },
		        function(b){
		         return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		        });
		                                      });
		                            }
		                            if(! model) return a(request$1);
		                            var
		                             model$0 = model[1],
		                             b = request$1[10],
		                             c = request$1[9],
		                             d = request$1[8],
		                             e = request$1[7],
		                             f = request$1[6],
		                             g = request$1[5],
		                             h = request$1[4],
		                             i = request$1[3],
		                             j = request$1[2];
		                            return caml_exact_trampoline_cps_call
		                                    (model_name,
		                                     model$0,
		                                     function(k){return a([0, k, j, i, h, g, f, e, d, c, b]);});
		                           }
		                           function b(t, cont){
		                            if(0 === t[0]) return cont(t);
		                            var x = t[1];
		                            return cont([1, [0, 9943782, x]]);
		                           }
		                           return caml_exact_trampoline_cps_call$13
		                                   (build_conversation_prompt,
		                                    graph,
		                                    ctrl,
		                                    agent[4],
		                                    workspace,
		                                    effective_ctx,
		                                    conversation_id,
		                                    conversation[6],
		                                    conversation[7],
		                                    conversation[3],
		                                    organizations_scope,
		                                    response_format,
		                                    response_format_instructions,
		                                    [0, prompt_options],
		                                    [0, connection_manager],
		                                    prompt_context,
		                                    function(c){
		                                     return caml_trampoline_cps_call3
		     (symbol_map,
		      c,
		      b,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                function d(state, cont){
		                 function a(conversation, cont){
		                  function a(agent, cont){
		                   return caml_exact_trampoline_cps_call$0
		                           (organizations_scope_of_agent,
		                            ctrl,
		                            organization_id,
		                            [0, agent],
		                            function(organizations_scope){
		                             function a(b){
		                              function f(automation_run_context){
		                               return cont
		                                       ([0,
		 [0,
		  agent,
		  conversation,
		  organizations_scope,
		  automation_run_context]]);
		                              }
		                              if(! b) return f(0);
		                              var l = b[2], x = b[1], b = x[2], c = b[7];
		                              function e(r){
		                               return r ? f(r) : caml_exact_trampoline_call1(a, l);
		                              }
		                              function d(){return e(0);}
		                              if(typeof c === "number") return d();
		                              if(1 !== c[0]) return d();
		                              var match = c[2];
		                              if(! match) return d();
		                              var
		                               linked_conv_id = match[1],
		                               breakpoint = c[1],
		                               id = b[3],
		                               automation_id = b[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (equal$164,
		                                       linked_conv_id,
		                                       conversation_id,
		                                       function(a){
		if(! a) return d();
		var questions = breakpoint[4][1];
		return caml_exact_trampoline_cps_call$0
		        (get_ask_user_conversation_cont,
		         automation_id,
		         id,
		         questions,
		         function(a){return e([0, a]);});
		                                       });
		                             }
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_alist$0, 0, state[3], a);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call
		                          (encode,
		                           state[1],
		                           function(c){
		                            function b(param){
		                             function c(b){
		                              return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                             }
		                             if(! param) return c(0);
		                             var l = param[2], x = param[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (mem$3,
		                                      x[3],
		                                      conversation_id,
		                                      function(a){
		                                       return a ? c([0, x]) : caml_exact_trampoline_call1(b, l);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (append$0, to_list$0(state[2]), c, b);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (find_packed_by_id,
		                          state[6],
		                          conversation_id,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1(let$2, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (ai_state,
		                         ctrl,
		                         workspace,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (let$2,
		                                   a,
		                                   d,
		                                   function(a){
		                                    return caml_trampoline_cps_call2
		    (return$12,
		     of_option(a, bLt),
		     function(a){
		      return caml_exact_trampoline_cps_call$1(let$, a, c, cont);
		     });
		                                   });
		                         });
		               }
		               function conversation_send_rich
		               (graph,
		                ctrl,
		                crdt,
		                attachments,
		                context,
		                conversation_id,
		                organization_id,
		                workspace,
		                message,
		                cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[14];
		                return caml_exact_trampoline_cps_call$1
		                        (of_object_exn,
		                         bLu,
		                         rich_response_schema,
		                         function(s){
		                          return caml_exact_trampoline_cps_call
		                                  (schema_to_openai_json,
		                                   s,
		                                   function(response_format){
		                                    function a(plain_response, cont){
		                                     var open = g(include$0), let$0 = open[14];
		                                     function a(rich, cont){
		                                      return caml_exact_trampoline_cps_call
		      (state_personal,
		       ctrl[2],
		       function(a){
		        var known_tasks = a[24];
		        return caml_trampoline_cps_call3
		                (map$18,
		                 rich[1][1],
		                 function(block, cont){
		                  function a(){return cont(block);}
		                  if(9 !== block[0]) return a();
		                  var todo = block[2], match = todo[3];
		                  if(! match) return a();
		                  var id = match[1];
		                  return caml_exact_trampoline_cps_call$1
		                          (mem$5,
		                           known_tasks,
		                           id,
		                           function(b){
		                            return b
		                                    ? a()
		                                    : cont([9, block[1], [0, todo[1], todo[2], 0]]);
		                           });
		                 },
		                 function(sanitized_blocks){
		                  function a(document, cont){
		                   return caml_trampoline_cps_call3
		                           (map$18,
		                            rich[2],
		                            function(c, cont){return cont([0, c[1], c[2]]);},
		                            function(a){
		                             return caml_exact_trampoline_cps_call
		                                     (return_ok, [0, document, a], cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$2
		                          (of_supported$0,
		                           graph,
		                           workspace,
		                           0,
		                           [0, sanitized_blocks],
		                           function(t){
		                            if(0 === t[0])
		                             var b = t;
		                            else
		                             var msg = t[1], b = [1, [0, 9943782, msg]];
		                            return caml_trampoline_cps_call2
		                                    (return$12,
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     function b(json, cont){
		                                      return caml_trampoline_cps_call3
		      (decode$2,
		       rich_response_schema,
		       json,
		       function(t){
		        if(0 === t[0]) return cont(t);
		        var x = t[1];
		        return caml_exact_trampoline_cps_call$1
		                (to_to_string,
		                 pp_decoding,
		                 x,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$293,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (b, a, function(a){return cont([1, [0, 9943782, a]]);});
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (of_string$11,
		      plain_response[1],
		      function(t){
		       function c(c){
		        return caml_exact_trampoline_cps_call$1
		                (let$0,
		                 c,
		                 b,
		                 function(b){
		                  return caml_trampoline_cps_call2
		                          (return$12,
		                           b,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 });
		       }
		       if(0 === t[0]) return c(t);
		       var msg = t[1];
		       return caml_exact_trampoline_cps_call$1
		               (kasprintf,
		                id,
		                fmt$294,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (a, msg, function(a){return c([1, [0, 9943782, a]]);});
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call
		    (trim,
		     "\nTo build the output document:\n- for every task you mention, use a Todo block instead of a Bullet block.\n- for every other Routine object you mention, use a reference to it, as returned by the `buildReference` tool.\n- always mention every Routine object you successfully create or edit.\n",
		     function(b){
		      return caml_exact_trampoline_cps_call$14
		              (conversation_send,
		               graph,
		               ctrl,
		               crdt,
		               attachments,
		               context,
		               conversation_id,
		               organization_id,
		               workspace,
		               [0, response_format],
		               [0, b],
		               0,
		               0,
		               bLv,
		               message,
		               function(b){
		                return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function format_answered_questions(param, cont){
		                var answered_questions = param[1];
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         answered_questions,
		                         function(aq, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0,
		                                   bLw,
		                                   aq[2],
		                                   function(b){
		                                    var a = aq[1][1];
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$295,
		     function(c){
		      return caml_trampoline_cps_call3(c, a, b, cont);
		     });
		                                   });
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0, bLx, a, cont);
		                         });
		               }
		               function reference_get(state, object_id, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4],
		                 let$0 = open[3];
		                switch(object_id[0]){
		                  case 0:
		                   var
		                    id = object_id[1],
		                    b = function(obj, cont){return cont([0, obj]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (get_event$0,
		                            state,
		                            id,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, b, cont);
		                            });
		                  case 1:
		                   var
		                    id$0 = object_id[1],
		                    c = function(obj, cont){return cont([1, obj]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            state[6],
		                            id$0,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, c, cont);
		                            });
		                  case 2:
		                   var
		                    id$1 = object_id[1],
		                    d = function(obj, cont){return cont([3, obj]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            state[16],
		                            id$1,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, d, cont);
		                            });
		                  case 3:
		                   var
		                    id$2 = object_id[1],
		                    e = function(obj, cont){return cont([4, obj]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            state[17],
		                            id$2,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, e, cont);
		                            });
		                  case 4:
		                   var a = object_id[1];
		                   if(0 === a[0]) return cont(0);
		                   var
		                    id$3 = a[1],
		                    f = function(obj, cont){return cont([6, obj]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            state[24],
		                            id$3,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, f, cont);
		                            });
		                  case 5:
		                   var
		                    id$4 = object_id[1],
		                    h = function(obj, cont){return cont([7, obj]);};
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            state[20],
		                            id$4,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$, a, h, cont);
		                            });
		                  case 6:
		                   a = object_id[1];
		                   var
		                    row_id = a[3],
		                    table_id = a[2],
		                    i =
		                      function(table, cont){
		                       function a(obj, cont){return cont([2, obj]);}
		                       return caml_exact_trampoline_cps_call$1
		                               (find_packed_by_id,
		                                table[6],
		                                row_id,
		                                function(b){
		                                 return caml_trampoline_cps_call3(let$, b, a, cont);
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            state[25][1],
		                            table_id,
		                            function(a){
		                             return caml_trampoline_cps_call3(let$0, a, i, cont);
		                            });
		                  case 7:
		                  case 8:
		                  case 9:
		                   return caml_exact_trampoline_cps_call
		                           (Sync[3],
		                            function(m, cont){
		                             return caml_trampoline_cps_call4(m, 0, 0, bLA, cont);
		                            },
		                            function(match){return cont(0);});
		                  default:
		                   return caml_exact_trampoline_cps_call
		                           (Sync[3],
		                            function(m, cont){
		                             return caml_trampoline_cps_call4(m, 0, 0, bLB, cont);
		                            },
		                            function(match){return cont(0);});
		                }
		               }
		               function reference_get$0(ctrl, graph){
		                var
		                 b =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 a = b[4],
		                 c = b[3];
		                return function(id, cont){
		                 switch(id[0]){
		                   case 6:
		                    var workspace_id = id[1][1];
		                    if(workspace_id)
		                     var x = workspace_id[1], workspace_id$0 = x;
		                    else
		                     workspace_id$0 = personal_workspace_id(ctrl[2]);
		                    var
		                     d =
		                       function(state, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (reference_get, state, id, cont);
		                       };
		                    return caml_exact_trampoline_cps_call$1
		                            (state$0,
		                             workspace_id$0,
		                             ctrl[2],
		                             function(a){
		                              return caml_trampoline_cps_call3(c, a, d, cont);
		                             });
		                   case 7:
		                    return cont(0);
		                   case 8:
		                    var
		                     b = id[1],
		                     table_id = b[2],
		                     workspace_id$1 = b[1],
		                     e = function(obj, cont){return cont([5, obj]);};
		                    return caml_exact_trampoline_cps_call$0
		                            (get_database,
		                             graph,
		                             workspace_id$1,
		                             table_id,
		                             function(b){
		                              return caml_exact_trampoline_cps_call
		                                      (get$17,
		                                       b,
		                                       function(b){
		return caml_trampoline_cps_call3(a, b, e, cont);
		                                       });
		                             });
		                   case 9:
		                    var
		                     workspace_id$2 = id[1][2],
		                     f = function(obj, cont){return cont([8, obj]);};
		                    return caml_exact_trampoline_cps_call$1
		                            (get$18,
		                             ctrl,
		                             workspace_id$2,
		                             function(b){
		                              return caml_exact_trampoline_cps_call
		                                      (get$17,
		                                       b,
		                                       function(b){
		return caml_trampoline_cps_call3(a, b, f, cont);
		                                       });
		                             });
		                   case 10:
		                    b = id[1];
		                    var agent_id = b[2], org_id = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (default_workspace_of_organizat,
		                             org_id,
		                             function(workspace_id){
		                              function b(obj, cont){return cont([9, obj]);}
		                              return caml_exact_trampoline_cps_call$0
		                                      (get_agent$0,
		                                       ctrl,
		                                       workspace_id,
		                                       agent_id,
		                                       function(c){
		return caml_exact_trampoline_cps_call
		        (get$17,
		         c,
		         function(c){
		          return caml_trampoline_cps_call3(a, c, b, cont);
		         });
		                                       });
		                             });
		                   case 11:
		                    b = id[1];
		                    var automation_id = b[2], org_id$0 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (default_workspace_of_organizat,
		                             org_id$0,
		                             function(workspace_id){
		                              var values = ctrl[9][5];
		                              function b(obj, cont){return cont([10, obj]);}
		                              return caml_exact_trampoline_cps_call$1
		                                      (find$6,
		                                       values[42][3][2],
		                                       [0, workspace_id, automation_id],
		                                       function(c){
		return caml_exact_trampoline_cps_call$1
		        (of_incremental,
		         0,
		         c,
		         function(c){
		          return caml_exact_trampoline_cps_call
		                  (get$17,
		                   c,
		                   function(c){
		                    return caml_trampoline_cps_call3(a, c, b, cont);
		                   });
		         });
		                                       });
		                             });
		                   case 12:
		                    b = id[1];
		                    var conversation_id = b[3], org_id$1 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (default_workspace_of_organizat,
		                             org_id$1,
		                             function(workspace_id){
		                              function b(obj, cont){return cont([11, obj]);}
		                              return caml_exact_trampoline_cps_call$0
		                                      (get_conversation,
		                                       ctrl,
		                                       workspace_id,
		                                       conversation_id,
		                                       function(c){
		return caml_exact_trampoline_cps_call
		        (get$17,
		         c,
		         function(c){
		          return caml_trampoline_cps_call3(a, c, b, cont);
		         });
		                                       });
		                             });
		                   case 13:
		                    b = id[1];
		                    var automation_run_id = b[3], org_id$2 = b[1];
		                    return caml_exact_trampoline_cps_call
		                            (default_workspace_of_organizat,
		                             org_id$2,
		                             function(workspace_id){
		                              function b(obj, cont){return cont([12, obj]);}
		                              return caml_exact_trampoline_cps_call$0
		                                      (get_automation_run,
		                                       ctrl,
		                                       workspace_id,
		                                       automation_run_id,
		                                       function(c){
		return caml_exact_trampoline_cps_call
		        (get$17,
		         c,
		         function(c){
		          return caml_trampoline_cps_call3(a, c, b, cont);
		         });
		                                       });
		                             });
		                   default:
		                    return caml_exact_trampoline_cps_call
		                            (state_personal,
		                             ctrl[2],
		                             function(state){
		                              return caml_exact_trampoline_cps_call$1
		                                      (reference_get, state, id, cont);
		                             });
		                 }};
		               }
		               function run_automation_manual
		               (graph, organization_id, automation_id, agent, object, cont){
		                return caml_exact_trampoline_cps_call
		                        (default_workspace_of_organizat,
		                         organization_id,
		                         function(workspace){
		                          var
		                           ctrl = graph[3],
		                           open =
		                             g
		                              ([0,
		                                symbol_bind$5,
		                                symbol_map$5,
		                                ,
		                                bind$8,
		                                return$9,
		                                map$17,
		                                ,
		                                ,
		                                ,
		                                ,
		                                Let_syntax$3]),
		                           let$ = open[4];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   object,
		                                   function(reference, cont){
		                                    return caml_exact_trampoline_cps_call
		    (reference_get$0(ctrl, graph),
		     reference,
		     function(a){
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$537,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         b,
		                         function(b){
		                          return caml_exact_trampoline_cps_call
		                                  (encode$4,
		                                   b,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (b,
		     a,
		     function(context){return cont([0, reference, context]);});
		                                   });
		                         });
		               });
		     });
		                                   },
		                                   function(object){
		                                    var
		                                     run_id = Automation_run[29].call(null),
		                                     open =
		                                       g
		([0,
		  symbol_bind$8,
		  symbol_map$6,
		  ,
		  bind$10,
		  return$12,
		  map$23,
		  ,
		  ,
		  ,
		  ,
		  Let_syntax$4]),
		                                     let$ = open[14],
		                                     let$0 = open[3];
		                                    function b(run, cont){
		                                     function a(crdt, cont){
		                                      return caml_trampoline_cps_call3
		      (Ident$0[3][14],
		       run[3],
		       run,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (automation_runs,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (ai$0,
		                           a,
		                           function(op){
		                            function a(param, cont){
		                             var steps = run[8];
		                             function a(last_text){
		                              var match = run[7];
		                              if(typeof match === "number")
		                               return caml_trampoline_cps_call2(return$13, last_text, cont);
		                              switch(match[0]){
		                                case 0:
		                                 var message = match[1];
		                                 return caml_exact_trampoline_cps_call$1
		 (kasprintf,
		  id,
		  fmt$298,
		  function(a){
		   return caml_trampoline_cps_call2
		           (a,
		            message,
		            function(a){
		             return caml_trampoline_cps_call2(return$13, a, cont);
		            });
		  });
		                                case 1:
		                                 return caml_trampoline_cps_call2(return$13, last_text, cont);
		                                default:
		                                 return caml_exact_trampoline_cps_call(fail$2, bLC, cont);
		                              }
		                             }
		                             return steps
		                                     ? caml_exact_trampoline_cps_call
		                                       (last_exn, steps, function(b){return a(b[2]);})
		                                     : a(cst$1);
		                            }
		                            return caml_exact_trampoline_cps_call$2
		                                    (apply$125,
		                                     ctrl[1],
		                                     crdt,
		                                     workspace,
		                                     op,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$60, b, a, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$59, b, a, cont);
		      });
		                                    }
		                                    function a(state, cont){
		                                     function a(automation_data, cont){
		                                      var
		                                       step_ids = automation_data[3],
		                                       open = g(include$0),
		                                       let$1 = open[8];
		                                      function a(agent$0, cont){
		                                       return caml_exact_trampoline_cps_call$1
		       (filter_mapi,
		        step_ids,
		        function(i, sid, cont){
		         var open = g(include$0), let$ = open[11];
		         function a(step, cont){return cont([0, i, step]);}
		         return caml_exact_trampoline_cps_call$1
		                 (find_packed_by_id,
		                  state[5],
		                  sid,
		                  function(b){
		                   return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                  });
		        },
		        function(steps){
		         if(is_empty(steps))
		          return caml_exact_trampoline_cps_call
		                  (return_error, bLy, cont);
		         var
		          started_at = ocaml_ptime_clock_now_d_ps(),
		          set_running = ctrl[25][2],
		          cst_Step_1 = "Step 1";
		         if(steps)
		          var
		           s = steps[1][2],
		           initial_step_name = value$4(s[3], cst_Step_1);
		         else
		          initial_step_name = cst_Step_1;
		         var a = [0, 1, initial_step_name];
		         return caml_exact_trampoline_cps_call
		                 (length$1,
		                  steps,
		                  function(b){
		                   var
		                    initial_progress =
		                      [0,
		                       run_id,
		                       workspace,
		                       value$4(automation_data[2], cst_Automation),
		                       b,
		                       a];
		                   return caml_exact_trampoline_cps_call
		                           (get$17,
		                            ctrl[25][1],
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (set_running,
		                                      [0, initial_progress, a],
		                                      function(match){
		                                       function a(result, cont){
		function remove_running(param, cont){
		 function a(a, cont){
		  return caml_exact_trampoline_cps_call$1
		          (Automation_run[15],
		           a[1],
		           run_id,
		           function(a){return cont(1 - a);});
		 }
		 return caml_exact_trampoline_cps_call
		         (get$17,
		          ctrl[25][1],
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (filter,
		                    b,
		                    a,
		                    function(a){
		                     return caml_trampoline_cps_call2(set_running, a, cont);
		                    });
		          });
		}
		function make_run(status, step_results, cont){
		 var
		  open =
		    g
		     ([0,
		       symbol_bind$5,
		       symbol_map$5,
		       ,
		       bind$8,
		       return$9,
		       map$17,
		       ,
		       ,
		       ,
		       ,
		       Let_syntax$3]),
		  let$ = open[4];
		 return caml_trampoline_cps_call3
		         (let$,
		          object,
		          function(object, cont){return cont(object[1]);},
		          function(object_id){
		           return caml_trampoline_cps_call3
		                   (let$,
		                    object,
		                    function(object, cont){return cont(object[2]);},
		                    function(object_context){
		                     var
		                      run =
		                        [0,
		                         automation_id,
		                         automation_data[2],
		                         run_id,
		                         object_id,
		                         object_context,
		                         started_at,
		                         status,
		                         step_results,
		                         automation_data[5]],
		                      metric_status =
		                        typeof status === "number" ? 0 : 0 === status[0] ? 1 : 2,
		                      match = automation_data[5],
		                      metric_trigger =
		                        typeof match === "number" ? 0 : 0 === match[0] ? 1 : 2;
		                     return caml_exact_trampoline_cps_call
		                             (length$1,
		                              steps,
		                              function(a){
		                               var action = [0, metric_trigger, metric_status, a, 0];
		                               return caml_exact_trampoline_cps_call$0
		                                       (push_dont_wait$0,
		ctrl[11],
		0,
		[2,
		 [0, run_id, action, [0, organization_id, automation_id]]],
		function(match){return cont(run);});
		                              });
		                    });
		          });
		}
		if(0 === result[0]){
		 var step_results_rev = result[1][2];
		 return caml_exact_trampoline_cps_call
		         (of_rev_keys,
		          step_results_rev,
		          function(step_results){
		           return caml_exact_trampoline_cps_call
		                   (remove_running,
		                    dummy,
		                    function(match){
		                     return caml_exact_trampoline_cps_call$1
		                             (make_run,
		                              0,
		                              step_results,
		                              function(a){
		                               return caml_exact_trampoline_cps_call(return_ok, a, cont);
		                              });
		                    });
		          });
		}
		var e = result[1];
		if(typeof e !== "number"){
		 var variant = e[1];
		 if(605598926 === variant){
		  var
		   a = e[2],
		   step_results_so_far = a[2],
		   a = a[1],
		   tool_calls = a[5],
		   request = a[4],
		   questions = request[1],
		   call_id = a[3],
		   response_id = a[2],
		   step_id = a[1];
		  return caml_exact_trampoline_cps_call
		          (remove_running,
		           dummy,
		           function(match){
		            var a = Automation_run[1];
		            return caml_exact_trampoline_cps_call$1
		                    (kasprintf,
		                     id,
		                     fmt$296,
		                     function(b){
		                      return caml_trampoline_cps_call5
		                              (b,
		                               pp$87,
		                               automation_id,
		                               a,
		                               run_id,
		                               function(a){
		                                return caml_exact_trampoline_cps_call
		(of_string$19,
		 a,
		 function(location){
		  var
		   automation_name =
		     value$4(automation_data[2], cst_Automation);
		  return caml_trampoline_cps_call3
		          (map$18,
		           questions,
		           function(q, cont){return cont(q[1]);},
		           function(short_questions){
		            var summary = [0, short_questions];
		            return caml_exact_trampoline_cps_call$1
		                    (get$18,
		                     ctrl,
		                     workspace,
		                     function(a){
		                      return caml_exact_trampoline_cps_call
		                              (get$17,
		                               a,
		                               function(workspace_data_opt){
		                                function b(param, cont){
		                                 return caml_exact_trampoline_cps_call$1
		 (make_run,
		  [1,
		   [0, step_id, response_id, call_id, request, tool_calls],
		   0],
		  step_results_so_far,
		  function(a){
		   return caml_exact_trampoline_cps_call(return_ok, a, cont);
		  });
		                                }
		                                function a(a){
		                                 return caml_trampoline_cps_call3(let$0, a, b, cont);
		                                }
		                                if(! workspace_data_opt)
		                                 return caml_trampoline_cps_call2(return$12, 0, a);
		                                var workspace_data = workspace_data_opt[1];
		                                return caml_exact_trampoline_cps_call
		(encode,
		 workspace_data[4],
		 function(b){
		  return caml_exact_trampoline_cps_call$1
		          (iter_s,
		           function(member, cont){
		            var match = summary[1];
		            function c(param, cont){
		             return caml_trampoline_cps_call2(return$12, 0, cont);
		            }
		            function a(a){
		             return caml_exact_trampoline_cps_call$8
		                     (create_notice,
		                      ctrl,
		                      ctrl[2],
		                      workspace,
		                      member[1][3],
		                      location,
		                      [0, [3, run_id, automation_name, summary]],
		                      a,
		                      function(a){
		                       return caml_trampoline_cps_call3(let$0, a, c, cont);
		                      });
		            }
		            if(! match) return a("Waiting for your input");
		            var short = match[1];
		            if(! match[2]) return a(short);
		            var rest = match[2], b = length(rest);
		            return caml_exact_trampoline_cps_call$1
		                    (kasprintf,
		                     id,
		                     fmt$112,
		                     function(c){
		                      return caml_trampoline_cps_call3(c, short, b, a);
		                     });
		           },
		           b,
		           a);
		 });
		                               });
		                     });
		           });
		 });
		                               });
		                     });
		           });
		 }
		}
		return caml_exact_trampoline_cps_call
		        (remove_running,
		         dummy,
		         function(a){
		          a = "Automation failed";
		          if(typeof e === "number")
		           var msg = a;
		          else {
		           var variant = e[1];
		           if(9943782 === variant)
		            var msg$0 = e[2], msg = msg$0;
		           else
		            msg = a;
		          }
		          return caml_exact_trampoline_cps_call$1
		                  (make_run,
		                   [0, msg],
		                   0,
		                   function(a){
		                    return caml_exact_trampoline_cps_call(return_ok, a, cont);
		                   });
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call$0
		       (fold_left_s,
		        function(acc, a, cont){
		         var step = a[2], step_index = a[1];
		         if(0 === acc[0]){
		          a = acc[1];
		          var
		           step_results_rev = a[2],
		           resume_info = a[1],
		           b = step_index + 1 | 0;
		          return caml_exact_trampoline_cps_call$1
		                  (kasprintf,
		                   id,
		                   fmt$297,
		                   function(a){
		                    return caml_trampoline_cps_call2
		                            (a,
		                             b,
		                             function(b){
		                              var
		                               step_name = value$4(step[3], b),
		                               progress =
		                                 [0,
		                                  initial_progress[1],
		                                  initial_progress[2],
		                                  initial_progress[3],
		                                  initial_progress[4],
		                                  [0, step_index + 1 | 0, step_name]];
		                              if(0 <= step_index){
		                               var t = step_ids, n = step_index;
		                               for(;;){
		                                if(! t){b = 0; break;}
		                                var t$0 = t[2], a = t[1];
		                                if(0 === n){b = [0, a]; break;}
		                                var n$0 = n - 1 | 0;
		                                t = t$0;
		                                n = n$0;
		                               }
		                              }
		                              else
		                               b = 0;
		                              function c(step_id_for_step){
		                               function b
		                               (should_skip_step,
		                                previous_response_id,
		                                initial_input_override,
		                                ask_user_tool_call,
		                                initial_tool_calls){
		                                if(should_skip_step)
		                                 return caml_trampoline_cps_call2
		 (return$12, [0, [0, resume_info, step_results_rev]], cont);
		                                function a(a, cont){
		                                 return caml_exact_trampoline_cps_call$1
		 (Automation_run[15],
		  a[1],
		  run_id,
		  function(b){return b ? cont(progress) : cont(a);});
		                                }
		                                return caml_exact_trampoline_cps_call
		(get$17,
		 ctrl[25][1],
		 function(b){
		  return caml_trampoline_cps_call3
		          (map$18,
		           b,
		           a,
		           function(a){
		            return caml_trampoline_cps_call2
		                    (set_running,
		                     a,
		                     function(match){
		                      var prompt = step[1][1];
		                      function b(agent_ctx){
		                       return caml_exact_trampoline_cps_call$1
		                               (merge_prompt_contexts,
		                                agent_ctx,
		                                prompt[1],
		                                function(step_context){
		                                 var
		                                  open =
		                                    g
		                                     ([0,
		                                       symbol_bind$5,
		                                       symbol_map$5,
		                                       ,
		                                       bind$8,
		                                       return$9,
		                                       map$17,
		                                       ,
		                                       ,
		                                       ,
		                                       ,
		                                       Let_syntax$3]),
		                                  let$ = open[4];
		                                 return caml_trampoline_cps_call3
		 (let$,
		  agent$0,
		  function(agent, cont){
		   return caml_exact_trampoline_cps_call
		           (agent_context, agent, cont);
		  },
		  function(agent$1){
		   var document = step[1][1][2];
		   return caml_exact_trampoline_cps_call
		           (to_string$72,
		            document,
		            function(step){
		             return caml_trampoline_cps_call3
		                     (let$,
		                      object,
		                      function(object, cont){return cont(object[2]);},
		                      function(object_context){
		                       var
		                        automation_name =
		                          value$4(automation_data[2], "Unnamed automation"),
		                        automation_ctx =
		                          [0,
		                           agent$1,
		                           object_context,
		                           step,
		                           step_name,
		                           automation_id,
		                           automation_name],
		                        open =
		                          g
		                           ([0,
		                             symbol_bind$8,
		                             symbol_map$6,
		                             ,
		                             bind$10,
		                             return$12,
		                             map$23,
		                             ,
		                             ,
		                             ,
		                             ,
		                             Let_syntax$4]),
		                        let$ = open[14],
		                        symbol_map = open[2];
		                       return caml_exact_trampoline_cps_call$0
		                               (organizations_scope_of_agent,
		                                ctrl,
		                                organization_id,
		                                agent$0,
		                                function(organizations_scope){
		                                 function a(param, cont){
		                                  var tools = param[2], request = param[1];
		                                  return caml_exact_trampoline_cps_call$1
		  (append$0,
		   initial_tool_calls,
		   to_list$0(ask_user_tool_call),
		   function(all_initial_tool_calls){
		    function a(call_result, cont){
		     if(0 !== call_result[0]){
		      var
		       acc_tool_calls = call_result[4],
		       call_id = call_result[3],
		       questions = call_result[2],
		       response_id = call_result[1];
		      return caml_trampoline_cps_call3
		              (map$18,
		               acc_tool_calls,
		               function(c, cont){return cont([0, [0, c[2], c[1], c[3]]]);},
		               function(tool_calls){
		                return caml_exact_trampoline_cps_call
		                        (of_rev_keys,
		                         step_results_rev,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (return_error,
		                                   [0,
		                                    605598926,
		                                    [0,
		                                     [0,
		                                      step_id_for_step,
		                                      response_id,
		                                      call_id,
		                                      [0, questions],
		                                      tool_calls],
		                                     a]],
		                                   cont);
		                         });
		               });
		     }
		     var response = call_result[1];
		     function b(tool_calls){
		      var step_result = [0, step_name, response[2], tool_calls];
		      return caml_exact_trampoline_cps_call
		              (return_ok,
		               [0, 0, [0, step_result, step_results_rev]],
		               cont);
		     }
		     if(! resume_info)
		      return caml_trampoline_cps_call3
		              (map$18,
		               response[3],
		               function(c, cont){return cont([0, [0, c[2], c[1], c[3]]]);},
		               b);
		     var
		      a = resume_info[1],
		      conversation = a[3],
		      resume_response = a[2],
		      prior_tool_calls = a[1][5],
		      ask_user = [1, resume_response, conversation];
		     return caml_exact_trampoline_cps_call
		             (length$1,
		              all_initial_tool_calls,
		              function(n$0){
		               var t$0 = response[3], t = t$0, n = n$0;
		               for(;;){
		                if(! t) break;
		                var tl = t[2];
		                if(0 >= n) break;
		                var n$1 = n - 1 | 0;
		                t = tl;
		                n = n$1;
		               }
		               return caml_trampoline_cps_call3
		                       (map$18,
		                        t,
		                        function(c, cont){return cont([0, [0, c[2], c[1], c[3]]]);},
		                        function(post_resume){
		                         return caml_exact_trampoline_cps_call$1
		                                 (append$0, prior_tool_calls, [0, ask_user, post_resume], b);
		                        });
		              });
		    }
		    return caml_exact_trampoline_cps_call$8
		            (responses_call_offline,
		             [0, all_initial_tool_calls],
		             0,
		             ctrl,
		             tools,
		             organization_id,
		             0,
		             request,
		             function(b){
		              return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		             });
		   });
		                                 }
		                                 function b(t, cont){
		                                  if(0 === t[0]) return cont(t);
		                                  var x = t[1];
		                                  return cont([1, [0, 9943782, x]]);
		                                 }
		                                 return caml_exact_trampoline_cps_call$4
		 (build_automation_prompt,
		  graph,
		  ctrl,
		  step_context,
		  organizations_scope,
		  workspace,
		  previous_response_id,
		  agent,
		  initial_input_override,
		  automation_ctx,
		  function(c){
		   return caml_trampoline_cps_call3
		           (symbol_map,
		            c,
		            b,
		            function(b){
		             return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		            });
		  });
		                                });
		                      });
		            });
		  });
		                                });
		                      }
		                      if(! agent$0) return b(default$);
		                      var a = agent$0[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (merge_prompt_contexts,
		                               a[7][1],
		                               a[8][1],
		                               function(c){
		                                return caml_exact_trampoline_cps_call$1
		(merge_prompt_contexts, a[1][1], c, b);
		                               });
		                     });
		           });
		 });
		                               }
		                               if(! resume_info) return b(0, 0, 0, 0, 0);
		                               var
		                                c = resume_info[1],
		                                a = c[1],
		                                call_id = a[3],
		                                response_id = a[2],
		                                step_id = a[1],
		                                match = a[4];
		                               return caml_exact_trampoline_cps_call$1
		                                       (equal$168,
		step_id_for_step,
		step_id,
		function(d){
		 if(! d) return b(1, 0, 0, 0, 0);
		 var
		  response = c[2],
		  tool_calls = a[5],
		  questions = match[1];
		 return caml_exact_trampoline_cps_call
		         (format_answered_questions,
		          response,
		          function(answers_output){
		           return caml_trampoline_cps_call3
		                   (encode$4,
		                    list_schema(schema$114),
		                    questions,
		                    function(a){
		                     var
		                      ask_user_call =
		                        [0,
		                         cst_ask_user,
		                         [0, 79, [0, [0, cst_questions, a], 0]],
		                         answers_output];
		                     return caml_exact_trampoline_cps_call$1
		                             (filter_map$0,
		                              tool_calls,
		                              function(param, cont){
		                               if(0 !== param[0]) return cont(0);
		                               var c = param[1];
		                               return cont([0, [0, c[2], c[1], c[3]]]);
		                              },
		                              function(converted_tool_calls){
		                               return b
		                                       (0,
		[0, response_id],
		[0,
		 [0,
		  [1, cst_function_call_output, call_id, answers_output, 0],
		  0]],
		[0, ask_user_call],
		converted_tool_calls);
		                              });
		                    });
		          });
		});
		                              }
		                              if(b){var a$0 = b[1]; return c(a$0);}
		                              return caml_exact_trampoline_cps_call
		                                      (length$1,
		                                       step_ids,
		                                       function(a){
		return caml_exact_trampoline_cps_call
		        (invalid_argf,
		         eA,
		         function(b){
		          return caml_trampoline_cps_call4(b, step_index, a, 0, c);
		         });
		                                       });
		                             });
		                   });
		         }
		         var e = acc[1];
		         return caml_trampoline_cps_call2(return$12, [1, e], cont);
		        },
		        initial_acc,
		        steps,
		        function(b){
		         return caml_trampoline_cps_call3(let$0, b, a, cont);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (let$1,
		       agent,
		       function(agent, cont){
		        if(0 !== agent[0]) return cont(state[2]);
		        var id = agent[1];
		        return caml_exact_trampoline_cps_call$1
		                (find_packed_by_id, state[1], id, cont);
		       },
		       function(b){
		        return caml_trampoline_cps_call2
		                (return$13,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      state[4],
		      automation_id,
		      function(b){
		       return caml_trampoline_cps_call2
		               (return$12,
		                of_option(b, bLz),
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (ai_state,
		     ctrl,
		     workspace,
		     function(c){
		      return caml_trampoline_cps_call2
		              (return$12,
		               of_option(c, [0, 847566860, workspace]),
		               function(c){
		                return caml_exact_trampoline_cps_call$1
		                        (let$,
		                         c,
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1(let$60, a, b, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$37 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_map$26 = open$37[2],
		                let$61 = open$37[3],
		                let$62 = open$37[14],
		                letrec_function_context$1372 = [];
		               function ai_limit_exceeded_schema_versi
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1372[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bLE, bLD, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1372[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1372[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1372[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (schema_versioned$1,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var reset_date = param[1];
		   return cont([0, reset_date]);
		  },
		  function(param, cont){
		   var reset_date = param[1];
		   return cont([0, reset_date, 0]);
		  },
		  [0, [0, 0, 0, 0, 0, "reset_date", 0, 2, [0, a], 0, 0], 0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1372[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1372[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1332 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1372, [0, schematic_cache$1332]);
		               caml_callback
		                (ai_limit_exceeded_schema_versi,
		                 [function(param, cont){return cont(0);}]);
		               function ai_with_limit_result_schema
		               (schematic_param_response_schem, cont){
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (ai_limit_exceeded_schema_versi,
		                         schematic_version,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (schema$0,
		                                   schematic_param_response_schem,
		                                   a,
		                                   function(init){
		                                    var id = match$1116[1], a = init[4], b = init[3];
		                                    return caml_exact_trampoline_cps_call$1
		    (combine,
		     schematic_param_response_schem,
		     id,
		     function(c){return cont([0, c, 0, b, a]);});
		                                   });
		                         });
		               }
		               function with_limit_result(param, cont){
		                if(0 === param[0]){
		                 var response = param[1];
		                 return cont([0, [0, response]]);
		                }
		                var e = param[1], variant = e[1];
		                if(-438114087 <= variant) return cont([1, e]);
		                var reset_time = e[2];
		                return caml_exact_trampoline_cps_call$1
		                        (of_time$0,
		                         timezone_local,
		                         reset_time,
		                         function(reset_date){
		                          return cont([0, [1, [0, reset_date]]]);
		                         });
		               }
		               function push_limit_metric
		               (metrics,
		                organization_id,
		                conversation_id,
		                kind,
		                has_attachments,
		                param,
		                cont){
		                if(0 !== param[0]){
		                 var variant = param[1][1];
		                 if(-438114087 > variant)
		                  return caml_exact_trampoline_cps_call$0
		                          (push_dont_wait$0,
		                           metrics,
		                           0,
		                           ai_conversation
		                            (conversation_id,
		                             organization_id,
		                             [1, kind, has_attachments, 0, 0, 0, 1]),
		                           cont);
		                }
		                return cont();
		               }
		               function rpcs$1(config, side, cont){
		                function v(graph, org_id, cont){
		                 return caml_exact_trampoline_cps_call(return$40, 1, cont);
		                }
		                var
		                 is_set_up =
		                   call_reactive
		                    ("is_set_up",
		                     "Check if AI agent types are set up for organization",
		                     [0, [0, cst_organization_id, schema$21, 0], 0],
		                     bool_schema,
		                     local_only(side, v));
		                function v$0(graph, cont){
		                 var
		                  ctrl = graph[3],
		                  param = ctrl[9],
		                  values = param[5],
		                  incremental = param[1],
		                  open =
		                    g
		                     ([0,
		                       incremental[72],
		                       incremental[73],
		                       ,
		                       incremental[75],
		                       incremental[76],
		                       incremental[77],
		                       ,
		                       ,
		                       ,
		                       ,
		                       incremental[82]]),
		                  let$ = open[4];
		                 return caml_trampoline_cps_call3
		                         (let$,
		                          values[42][2],
		                          function(assistant, cont){
		                           return caml_exact_trampoline_cps_call$2
		                                   (value_exn,
		                                    bLF,
		                                    0,
		                                    0,
		                                    assistant,
		                                    function(a){
		                                     a = a[4];
		                                     if(0 === a[0])
		                                      return caml_exact_trampoline_cps_call
		      (failwith, "agent id", cont);
		                                     var id = a[1];
		                                     return cont(id);
		                                    });
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_incremental, 0, a, cont);
		                          });
		                }
		                var
		                 a = local_only(side, v$0),
		                 get =
		                   call_reactive
		                    (cst_get$0,
		                     "Get personal assistant agent ID",
		                     0,
		                     Assistant[5],
		                     a);
		                function v$1(graph, org_id, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace_id){
		                           var ctrl = graph[3];
		                           return caml_exact_trampoline_cps_call$1
		                                   (active_agents, ctrl, workspace_id, cont);
		                          });
		                }
		                var
		                 a = local_only(side, v$1),
		                 all =
		                   call_reactive
		                    (cst_all,
		                     "Get list of active agent IDs in organization",
		                     [0, [0, cst_organization_id, schema$21, 0], 0],
		                     list_schema(Agent[5]),
		                     a);
		                function v$2
		                (graph,
		                 organization,
		                 catalog_key,
		                 name,
		                 instructions_markdown,
		                 cont){
		                 var ctrl = graph[3];
		                 function a(crdt, cont){
		                  function a(agent_id, cont){
		                   var
		                    a =
		                      ai_agent([0, agent_id], organization, [0, catalog_key, 0]);
		                   return caml_exact_trampoline_cps_call$0
		                           (push_dont_wait$0,
		                            ctrl[11],
		                            0,
		                            a,
		                            function(match){
		                             return caml_trampoline_cps_call2(return$13, agent_id, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$8
		                          (create$54,
		                           ctrl,
		                           crdt,
		                           organization,
		                           catalog_key,
		                           name,
		                           instructions_markdown,
		                           dummy,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (return$12,
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$62, b, a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$61, b, a, cont);
		                          });
		                }
		                var
		                 d = local_only(side, v$2),
		                 b = Agent[5],
		                 c =
		                   [0,
		                    [0,
		                     "instructions_markdown",
		                     schematic_param_name_schema_ve,
		                     0],
		                    0];
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schematic_param_name_schema_ve,
		                         function(schema){
		                          var
		                           create =
		                             call_async
		                              (cst_create,
		                               "Create AI agent instance from catalog in organization",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0,
		                                 [0, cst_catalog_key, schematic_param_name_schema_ve, 0],
		                                 [0, [0, cst_name, schema, 0], c]]],
		                               b,
		                               d);
		                          function v(graph, org_id, agent, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace_id){
		                                     var
		                                      ctrl = graph[3],
		                                      open =
		g
		 ([0,
		   symbol_bind$8,
		   symbol_map$6,
		   ,
		   bind$10,
		   return$12,
		   map$23,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$4]),
		                                      let$ = open[14],
		                                      let$0 = open[3];
		                                     function a(crdt, cont){
		                                      function a(a, cont){
		                                       a = ai_agent([0, agent], org_id, 0);
		                                       return caml_exact_trampoline_cps_call$0
		       (push_dont_wait$0,
		        ctrl[11],
		        0,
		        a,
		        function(match){
		         return caml_trampoline_cps_call2(return$13, 0, cont);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$2
		      (delete_agent,
		       ctrl,
		       crdt,
		       workspace_id,
		       agent,
		       function(b){
		        return caml_trampoline_cps_call2
		                (return$12,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$0, b, a, cont);
		      });
		                                    });
		                          }
		                          var
		                           e = local_only(side, v),
		                           schema$0 = Agent[5],
		                           delete$ =
		                             call_async
		                              (cst_delete,
		                               "Delete an AI agent in organization",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0, [0, cst_agent_id, schema$0, 0], 0]],
		                               schematic_param_a_schema_versi,
		                               e);
		                          function v$0(graph, org_id, agent_id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace_id){
		                                     var ctrl = graph[3];
		                                     return caml_exact_trampoline_cps_call$0
		     (get_agent$0, ctrl, workspace_id, agent_id, cont);
		                                    });
		                          }
		                          var a = local_only(side, v$0);
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schema$107,
		                                   function(b){
		                                    var
		                                     get$0 =
		                                       call_reactive
		(cst_get$0,
		 "Get agent data by id in organization",
		 [0,
		  [0, cst_organization_id, schema$21, 0],
		  [0, [0, cst_agent_id, schema$28, 0], 0]],
		 b,
		 a);
		                                    function v(graph, org_id, agent, patch, cont){
		                                     return caml_exact_trampoline_cps_call
		     (default_workspace_of_organizat,
		      org_id,
		      function(workspace){
		       var ctrl = graph[3];
		       function a(crdt, cont){
		        function a(param, cont){
		         return caml_exact_trampoline_cps_call$1
		                 (map$9,
		                  patch[3],
		                  function(param, cont){return cont(cst_working_memory);},
		                  function(b){
		                   var a = [0, b, 0];
		                   return caml_exact_trampoline_cps_call$1
		                           (map$9,
		                            patch[2],
		                            function(param, cont){return cont(cst_user_preferences);},
		                            function(c){
		                             var b = [0, c, a];
		                             return caml_exact_trampoline_cps_call$1
		                                     (map$9,
		                                      patch[1],
		                                      function(param, cont){return cont(cst_agent_instructions);},
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (filter_opt,
		        [0, a, b],
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (concat$0,
		                  bLG,
		                  a,
		                  function(property_name){
		                   var a = ai_agent(agent, org_id, [1, property_name]);
		                   return caml_exact_trampoline_cps_call$0
		                           (push_dont_wait$0,
		                            ctrl[11],
		                            0,
		                            a,
		                            function(match){
		                             return caml_trampoline_cps_call2(return$13, 0, cont);
		                            });
		                  });
		        });
		                                      });
		                            });
		                  });
		        }
		        return caml_exact_trampoline_cps_call$3
		                (update_agent,
		                 ctrl,
		                 crdt,
		                 workspace,
		                 agent,
		                 patch,
		                 function(t){
		                  if(0 === t[0])
		                   var b = t;
		                  else
		                   var
		                    error = t[1],
		                    b = typeof error === "number" ? bLH : error,
		                    b = [1, b];
		                  return caml_trampoline_cps_call2
		                          (return$12,
		                           b,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$62, b, a, cont);
		                           });
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3(let$61, b, a, cont);
		                });
		      });
		                                    }
		                                    var
		                                     update =
		                                       call_async
		(cst_update,
		 "Update an agent in organization",
		 [0,
		  [0, cst_organization_id, schema$21, 0],
		  [0,
		   [0, cst_agent_id, schema$28, 0],
		   [0, [0, cst_patch, schema$106, 0], 0]]],
		 schematic_param_a_schema_versi,
		 local_only(side, v));
		                                    function v$0(graph, org_id, agent_id, cont){
		                                     return caml_exact_trampoline_cps_call
		     (default_workspace_of_organizat,
		      org_id,
		      function(workspace_id){
		       var ctrl = graph[3];
		       return caml_exact_trampoline_cps_call$0
		               (agent_automations, ctrl, workspace_id, agent_id, cont);
		      });
		                                    }
		                                    var
		                                     b = local_only(side, v$0),
		                                     all$0 =
		                                       call_reactive
		(cst_all,
		 "Get list of automation IDs owned by an agent in organization",
		 [0,
		  [0, cst_organization_id, schema$21, 0],
		  [0, [0, cst_agent_id, schema$28, 0], 0]],
		 list_schema(schema$111),
		 b);
		                                    function v$1
		                                    (graph, org_id, agent_id, automation_run_id, cont){
		                                     return caml_exact_trampoline_cps_call
		     (default_workspace_of_organizat,
		      org_id,
		      function(workspace_id){
		       var
		        ctrl = graph[3],
		        open =
		          g
		           ([0,
		             symbol_bind$8,
		             symbol_map$6,
		             ,
		             bind$10,
		             return$12,
		             map$23,
		             ,
		             ,
		             ,
		             ,
		             Let_syntax$4]),
		        let$ = open[14],
		        let$0 = open[3];
		       function b(step_info, cont){
		        function a(crdt, cont){
		         function a(conv_id, cont){
		          function b(a, cont){
		           a =
		            ai_conversation
		             (conv_id, org_id, [0, agent_id, is_some(automation_run_id)]);
		           return caml_exact_trampoline_cps_call$0
		                   (push_dont_wait$0,
		                    ctrl[11],
		                    0,
		                    a,
		                    function(match){
		                     return caml_exact_trampoline_cps_call
		                             (return_ok, conv_id, cont);
		                    });
		          }
		          function a(a){
		           return caml_trampoline_cps_call2
		                   (return$12,
		                    a,
		                    function(a){
		                     return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		                    });
		          }
		          if(! step_info)
		           return caml_exact_trampoline_cps_call(of_string$0, 0, a);
		          var
		           match = step_info[1],
		           breakpoint = match[2],
		           run_id = match[1];
		          return caml_exact_trampoline_cps_call
		                  (set_status,
		                   [1, breakpoint, [0, conv_id]],
		                   function(b){
		                    return caml_trampoline_cps_call2
		                            (Ident$0[3][16],
		                             run_id,
		                             function(c){
		                              return caml_trampoline_cps_call2
		                                      (c,
		                                       b,
		                                       function(b){
		return caml_exact_trampoline_cps_call
		        (automation_runs,
		         b,
		         function(b){
		          return caml_exact_trampoline_cps_call
		                  (ai$0,
		                   b,
		                   function(op){
		                    return caml_exact_trampoline_cps_call$2
		                            (apply$125, ctrl[1], crdt, workspace_id, op, a);
		                   });
		         });
		                                       });
		                             });
		                   });
		         }
		         return caml_exact_trampoline_cps_call$2
		                 (create_conversation,
		                  ctrl,
		                  crdt,
		                  workspace_id,
		                  agent_id,
		                  function(b){
		                   return caml_trampoline_cps_call2
		                           (return$12,
		                            b,
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                            });
		                  });
		        }
		        return caml_exact_trampoline_cps_call
		                (writable$0,
		                 ctrl[2],
		                 function(b){
		                  return caml_trampoline_cps_call3(let$0, b, a, cont);
		                 });
		       }
		       function a(a){
		        return caml_exact_trampoline_cps_call$1(let$, a, b, cont);
		       }
		       if(! automation_run_id)
		        return caml_trampoline_cps_call2(return$13, 0, a);
		       var run_id = automation_run_id[1];
		       return caml_exact_trampoline_cps_call$0
		               (get_automation_run,
		                ctrl,
		                workspace_id,
		                run_id,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (get$17,
		                          b,
		                          function(run_opt){
		                           if(! run_opt)
		                            return caml_exact_trampoline_cps_call(return_error, bLK, a);
		                           var run = run_opt[1], b = run[7];
		                           if(typeof b !== "number" && 1 === b[0]){
		                            var breakpoint = b[1];
		                            if(b[2])
		                             return caml_exact_trampoline_cps_call(fail$2, bLJ, a);
		                            return caml_trampoline_cps_call2
		                                    (return$13, [0, [0, run_id, breakpoint]], a);
		                           }
		                           return caml_exact_trampoline_cps_call(fail$2, bLI, a);
		                          });
		                });
		      });
		                                    }
		                                    var c = local_only(side, v$1);
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     Automation_run[5],
		     function(schema){
		      var
		       create$0 =
		         call_async
		          (cst_create,
		           "Create a new conversation for an agent in organization. 'automation_run_id' is an optional paused automation run to associate this conversation with so that the agent may resume it.",
		           [0,
		            [0, cst_organization_id, schema$21, 0],
		            [0,
		             [0, cst_agent_id, schema$28, 0],
		             [0, [0, cst_automation_run_id, schema, 0], 0]]],
		           schema$103,
		           c);
		      function v(graph, org_id, conversation_id, cont){
		       return caml_exact_trampoline_cps_call
		               (default_workspace_of_organizat,
		                org_id,
		                function(workspace_id){
		                 var ctrl = graph[3];
		                 function a(crdt, cont){
		                  function a(a, cont){
		                   a = ai_conversation(conversation_id, org_id, 0);
		                   return caml_exact_trampoline_cps_call$0
		                           (push_dont_wait$0,
		                            ctrl[11],
		                            0,
		                            a,
		                            function(match){
		                             return caml_trampoline_cps_call2(return$13, 0, cont);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$2
		                          (delete_conversation,
		                           ctrl,
		                           crdt,
		                           workspace_id,
		                           conversation_id,
		                           function(b){
		                            return caml_trampoline_cps_call2
		                                    (return$12,
		                                     b,
		                                     function(b){
		                                      return caml_exact_trampoline_cps_call$1(let$62, b, a, cont);
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$61, b, a, cont);
		                          });
		                });
		      }
		      var
		       delete$0 =
		         call_async
		          (cst_delete,
		           "Delete a conversation in organization",
		           [0,
		            [0, cst_organization_id, schema$21, 0],
		            [0, [0, cst_conversation_id, schema$103, 0], 0]],
		           schematic_param_a_schema_versi,
		           local_only(side, v));
		      function v$0(graph, org_id, conversation_id, cont){
		       return caml_exact_trampoline_cps_call
		               (default_workspace_of_organizat,
		                org_id,
		                function(workspace_id){
		                 var ctrl = graph[3];
		                 return caml_exact_trampoline_cps_call$0
		                         (get_conversation,
		                          ctrl,
		                          workspace_id,
		                          conversation_id,
		                          cont);
		                });
		      }
		      var a = local_only(side, v$0);
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               schema$104,
		               function(b){
		                var
		                 get$1 =
		                   call_reactive
		                    (cst_get$0,
		                     "Get conversation data by id in organization",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0, [0, cst_conversation_id, schema$103, 0], 0]],
		                     b,
		                     a);
		                function v(graph, org_id, agent_id, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace_id){
		                           var ctrl = graph[3];
		                           return caml_exact_trampoline_cps_call$0
		                                   (all_conversations, ctrl, workspace_id, agent_id, cont);
		                          });
		                }
		                var
		                 b = local_only(side, v),
		                 all$1 =
		                   call_reactive
		                    (cst_all,
		                     "Get an agent's conversation IDs in organization, ordered by most recent activity.",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0, [0, cst_agent_id, schema$28, 0], 0]],
		                     list_schema(schema$103),
		                     b);
		                function v$0(graph, org_id, conversation_id, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace_id){
		                           var ctrl = graph[3];
		                           return caml_exact_trampoline_cps_call$0
		                                   (get_conversation_summary,
		                                    ctrl,
		                                    workspace_id,
		                                    conversation_id,
		                                    cont);
		                          });
		                }
		                var c = local_only(side, v$0);
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schema$203,
		                         function(b){
		                          var
		                           get_summary =
		                             call_reactive
		                              ("get_summary",
		                               "Get a conversation summary without its history or context in organization.",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0, [0, cst_conversation_id, schema$103, 0], 0]],
		                               b,
		                               c);
		                          function v
		                          (graph,
		                           context,
		                           org_id,
		                           conversation_id,
		                           message,
		                           attachments,
		                           response_format,
		                           prompt_options,
		                           model_options,
		                           cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace_id){
		                                     var ctrl = graph[3];
		                                     function a(crdt, cont){
		                                      function a(result, cont){
		                                       var a = 1 - is_empty(attachments);
		                                       return caml_exact_trampoline_cps_call$7
		       (push_limit_metric,
		        ctrl[11],
		        org_id,
		        conversation_id,
		        0,
		        a,
		        result,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (with_limit_result, result, cont);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$14
		      (conversation_send,
		       graph,
		       ctrl,
		       crdt,
		       attachments,
		       context,
		       conversation_id,
		       org_id,
		       workspace_id,
		       response_format,
		       0,
		       prompt_options,
		       [0, model_options],
		       0,
		       message,
		       function(b){
		        return caml_trampoline_cps_call3(symbol_map$26, b, a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$61, b, a, cont);
		      });
		                                    });
		                          }
		                          var a = local_only(side, v);
		                          return caml_exact_trampoline_cps_call
		                                  (ai_with_limit_result_schema,
		                                   schema$102,
		                                   function(c){
		                                    var b = [0, [0, "model_options", schema$257, 0], 0];
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     schema$199,
		     function(schema){
		      var d = [0, [0, "prompt_options", schema, 0], b];
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               json_schema,
		               function(schema){
		                function schematic_version(param, cont){return cont(0);}
		                var b = [0, [0, "response_format", schema, 0], d];
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$221,
		                         schematic_version,
		                         function(e){
		                          var
		                           schema = [0, 0, 0, [3, e], 0],
		                           send =
		                             call_async
		                              (cst_send,
		                               '\nSend a message on an existing conversation in organization.\n`model_options` configures the model request. Its `reasoning_effort`, if non-null, controls how much reasoning the model uses and defaults to `high`. Its `fast_mode`, if true, sends the request through OpenAI\'s priority service tier. Its `model`, if non-null, must be one of the models with configured usage pricing.\n`response_format`, if non-null, must be an OpenAI structured output (strict)-compatible JSON schema:\n\n1. valid JSON schema\n2. each object schema must contain `additionalProperties: false`\n3. each object schema property must be required\n\nExample of accepted JSON schema:\n```\n{\n  "type": "object",\n  "additionalProperties": false,\n  "required": [\n    "response",\n    "moodEmoji"\n  ],\n  "properties": {\n    "response": {\n      "type": "string"\n    },\n    "mood": {\n      "type": "string",\n      "enum": [\n        "\xf0\x9f\x98\x86",\n        "\xf0\x9f\x98\xad"\n      ]\n    }\n  }\n}\n```\n\nSee https://developers.openai.com/api/docs/guides/structured-outputs\n',
		                               [0,
		                                [0, cst_context, schema$100, 0],
		                                [0,
		                                 [0, cst_organization_id, schema$21, 0],
		                                 [0,
		                                  [0, cst_conversation_id, schema$103, 0],
		                                  [0,
		                                   [0, cst_message, schematic_param_name_schema_ve, 0],
		                                   [0, [0, cst_attachments, schema, 0], b]]]]],
		                               c,
		                               a);
		                          function v
		                          (graph,
		                           context,
		                           org_id,
		                           conversation_id,
		                           message,
		                           attachments,
		                           cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace_id){
		                                     var ctrl = graph[3];
		                                     function a(crdt, cont){
		                                      function a(result, cont){
		                                       var a = 1 - is_empty(attachments);
		                                       return caml_exact_trampoline_cps_call$7
		       (push_limit_metric,
		        ctrl[11],
		        org_id,
		        conversation_id,
		        1,
		        a,
		        result,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (with_limit_result, result, cont);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$4
		      (conversation_send_rich,
		       graph,
		       ctrl,
		       crdt,
		       attachments,
		       context,
		       conversation_id,
		       org_id,
		       workspace_id,
		       message,
		       function(b){
		        return caml_trampoline_cps_call3(symbol_map$26, b, a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$61, b, a, cont);
		      });
		                                    });
		                          }
		                          var d = local_only(side, v);
		                          return caml_exact_trampoline_cps_call
		                                  (ai_with_limit_result_schema,
		                                   schema$201,
		                                   function(a){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$221,
		     schematic_version,
		     function(b){
		      var
		       schema = [0, 0, 0, [3, b], 0],
		       send_rich =
		         call_async
		          ("send_rich",
		           "Send a message on an existing conversation and receive a response in Routine's rich document format. The response contains a structured document with blocks (headings, bullets, paragraphs, etc.) instead of a plain string. Use this RPC instead of `send` when you want to render the response as a Routine document.",
		           [0,
		            [0, cst_context, schema$100, 0],
		            [0,
		             [0, cst_organization_id, schema$21, 0],
		             [0,
		              [0, cst_conversation_id, schema$103, 0],
		              [0,
		               [0, cst_message, schematic_param_name_schema_ve, 0],
		               [0, [0, cst_attachments, schema, 0], 0]]]]],
		           a,
		           d);
		      function v(graph, org_id, conversation_id, context, cont){
		       return caml_exact_trampoline_cps_call
		               (default_workspace_of_organizat,
		                org_id,
		                function(workspace){
		                 var ctrl = graph[3];
		                 function a(crdt, cont){
		                  return caml_exact_trampoline_cps_call$3
		                          (update_conversation_context,
		                           ctrl,
		                           crdt,
		                           workspace,
		                           conversation_id,
		                           context,
		                           function(a){
		                            return caml_trampoline_cps_call2(return$12, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$61, b, a, cont);
		                          });
		                });
		      }
		      var
		       update_context =
		         call_async
		          ("update_context",
		           "Update the accumulated context of a conversation (e.g. to remove items)",
		           [0,
		            [0, cst_organization_id, schema$21, 0],
		            [0,
		             [0, cst_conversation_id, schema$103, 0],
		             [0, [0, cst_context, schema$100, 0], 0]]],
		           schematic_param_a_schema_versi,
		           local_only(side, v));
		      function v$0(graph, org_id, cont){
		       return caml_exact_trampoline_cps_call
		               (default_workspace_of_organizat,
		                org_id,
		                function(workspace){
		                 var ctrl = graph[3];
		                 return caml_exact_trampoline_cps_call$1
		                         (active_automations, ctrl, workspace, cont);
		                });
		      }
		      var
		       b = local_only(side, v$0),
		       all$2 =
		         call_reactive
		          (cst_all,
		           "Get list of active automation IDs in organization",
		           [0, [0, cst_organization_id, schema$21, 0], 0],
		           list_schema(schema$111),
		           b);
		      function v$1(graph, org_id, name, step_ids, agent, cont){
		       return is_empty(step_ids)
		               ? caml_exact_trampoline_cps_call(return_error, bLL, cont)
		               : caml_exact_trampoline_cps_call
		                 (default_workspace_of_organizat,
		                  org_id,
		                  function(workspace){
		                   var ctrl = graph[3];
		                   function a(crdt, cont){
		                    function a(automation_id, cont){
		                     var a = is_some(agent);
		                     return caml_exact_trampoline_cps_call
		                             (length$1,
		                              step_ids,
		                              function(b){
		                               b = ai_automation(automation_id, org_id, [0, b, a]);
		                               return caml_exact_trampoline_cps_call$0
		                                       (push_dont_wait$0,
		ctrl[11],
		0,
		b,
		function(match){
		 return caml_trampoline_cps_call2
		         (return$13, automation_id, cont);
		});
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call$8
		                            (create_automation,
		                             ctrl,
		                             crdt,
		                             workspace,
		                             name,
		                             step_ids,
		                             agent,
		                             dummy,
		                             function(b){
		                              return caml_trampoline_cps_call2
		                                      (return$12,
		                                       b,
		                                       function(b){
		return caml_exact_trampoline_cps_call$1(let$62, b, a, cont);
		                                       });
		                             });
		                   }
		                   return caml_exact_trampoline_cps_call
		                           (writable$0,
		                            ctrl[2],
		                            function(b){
		                             return caml_trampoline_cps_call3(let$61, b, a, cont);
		                            });
		                  });
		      }
		      var c = local_only(side, v$1);
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               schema$28,
		               function(schema){
		                var
		                 schema$0 = list_schema(schema$108),
		                 create$1 =
		                   call_async
		                    (cst_create,
		                     "Create an automation in organization",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0,
		                       [0, cst_name, schematic_param_name_schema_ve, 0],
		                       [0,
		                        [0, "step_ids", schema$0, 0],
		                        [0, [0, cst_agent_id, schema, 0], 0]]]],
		                     schema$111,
		                     c);
		                function v(graph, org_id, automation, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace){
		                           var ctrl = graph[3];
		                           function a(crdt, cont){
		                            function a(a, cont){
		                             a = ai_automation(automation, org_id, 0);
		                             return caml_exact_trampoline_cps_call$0
		                                     (push_dont_wait$0,
		                                      ctrl[11],
		                                      0,
		                                      a,
		                                      function(match){
		                                       return caml_trampoline_cps_call2(return$13, 0, cont);
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$2
		                                    (delete_automation,
		                                     ctrl,
		                                     crdt,
		                                     workspace,
		                                     automation,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$62, b, a, cont);
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$61, b, a, cont);
		                                    });
		                          });
		                }
		                var
		                 delete$1 =
		                   call_async
		                    (cst_delete,
		                     "Delete an automation",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0, [0, cst_automation_id, schema$111, 0], 0]],
		                     schematic_param_a_schema_versi,
		                     local_only(side, v));
		                function v$0(graph, org_id, automation, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace_id){
		                           var ctrl = graph[3];
		                           return caml_exact_trampoline_cps_call$0
		                                   (get_automation, ctrl, workspace_id, automation, cont);
		                          });
		                }
		                var a = local_only(side, v$0);
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schema$206,
		                         function(b){
		                          var
		                           get$2 =
		                             call_reactive
		                              (cst_get$0,
		                               "Get automation data by object id",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0, [0, cst_automation_id, schema$111, 0], 0]],
		                               b,
		                               a);
		                          function v(graph, org_id, automation_id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace){
		                                     var ctrl = graph[3];
		                                     return caml_exact_trampoline_cps_call$0
		     (automation_runs_by_status_for_,
		      ctrl,
		      workspace,
		      automation_id,
		      cont);
		                                    });
		                          }
		                          var
		                           all$3 =
		                             call_reactive
		                              (cst_all,
		                               "Get all automation run IDs for an organization",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0, [0, cst_automation_id, schema$111, 0], 0]],
		                               schema$212,
		                               local_only(side, v));
		                          function v$0(graph, org_id, run_id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace){
		                                     var ctrl = graph[3];
		                                     function a(crdt, cont){
		                                      return caml_trampoline_cps_call2
		      (Ident$0[3][18],
		       run_id,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (automation_runs,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (ai$0,
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$2
		                                    (apply$125,
		                                     ctrl[1],
		                                     crdt,
		                                     workspace,
		                                     a,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, cont);
		                                     });
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$61, b, a, cont);
		      });
		                                    });
		                          }
		                          var
		                           b = local_only(side, v$0),
		                           schema = Automation_run[5],
		                           delete$2 =
		                             call_async
		                              (cst_delete,
		                               "Delete an automation run record",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0, [0, cst_run_id, schema, 0], 0]],
		                               schematic_param_a_schema_versi,
		                               b);
		                          function v$1(graph, org_id, run_id, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace){
		                                     var ctrl = graph[3];
		                                     return caml_exact_trampoline_cps_call$0
		     (get_automation_run, ctrl, workspace, run_id, cont);
		                                    });
		                          }
		                          var c = local_only(side, v$1);
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schema$116,
		                                   function(b){
		                                    var
		                                     schema = Automation_run[5],
		                                     get$3 =
		                                       call_reactive
		(cst_get$0,
		 "Get an automation run record by ID",
		 [0,
		  [0, cst_organization_id, schema$21, 0],
		  [0, [0, cst_run_id, schema, 0], 0]],
		 b,
		 c),
		                                     a = local_only(side, run_automation_manual);
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     schema$46,
		     function(schema){
		      var b = [0, [0, cst_object_id$0, schema, 0], 0];
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               schema$28,
		               function(schema){
		                var
		                 run_manually =
		                   call_async
		                    ("run_manually",
		                     "Execute multi-step automation with progress tracking",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0,
		                       [0, cst_automation_id, schema$111, 0],
		                       [0, [0, cst_agent_id, schema, 0], b]]],
		                     schematic_param_name_schema_ve,
		                     a);
		                function v(graph, org_id, run_id, answers, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace){
		                           var ctrl = graph[3];
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$3
		                                    (resume_automation_run,
		                                     ctrl,
		                                     crdt,
		                                     workspace,
		                                     run_id,
		                                     answers,
		                                     cont);
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$61, b, a, cont);
		                                    });
		                          });
		                }
		                var
		                 c = local_only(side, v),
		                 schema$0 = Automation_run[5],
		                 resume =
		                   call_async
		                    ("resume",
		                     "Provide user input to resume a paused automation run",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0,
		                       [0, cst_run_id, schema$0, 0],
		                       [0,
		                        [0,
		                         cst_answers,
		                         [0,
		                          0,
		                          0,
		                          [3, [0, 0, 0, [3, schematic_param_name_schema_ve], 0]],
		                          0],
		                         0],
		                        0]]],
		                     schematic_param_a_schema_versi,
		                     c);
		                function v$0(graph, cont){
		                 var ctrl = graph[3];
		                 return cont(ctrl[25][1]);
		                }
		                var
		                 c = local_only(side, v$0),
		                 running =
		                   call_reactive
		                    ("running",
		                     "Get list of currently running automations with progress",
		                     0,
		                     list_schema(schema$208),
		                     c);
		                function v$1(graph, org_id, automation_id, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace_id){
		                           var ctrl = graph[3];
		                           return caml_exact_trampoline_cps_call$0
		                                   (list_automation_steps,
		                                    ctrl,
		                                    workspace_id,
		                                    automation_id,
		                                    cont);
		                          });
		                }
		                var
		                 c = local_only(side, v$1),
		                 all$4 =
		                   call_reactive
		                    (cst_all,
		                     "Get list of step IDs for an automation in organization",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0, [0, cst_automation_id, schema$111, 0], 0]],
		                     list_schema(schema$108),
		                     c);
		                function v$2(graph, org_id, automation_id, patch, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace_id){
		                           var ctrl = graph[3];
		                           function a(crdt, cont){
		                            function a(param, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (map$9,
		                                      patch[3],
		                                      function(param, cont){return cont(cst_trigger);},
		                                      function(b){
		                                       var a = [0, b, 0];
		                                       return caml_exact_trampoline_cps_call$1
		       (map$9,
		        patch[2],
		        function(param, cont){return cont(cst_enabled);},
		        function(c){
		         var b = [0, c, a];
		         return caml_exact_trampoline_cps_call$1
		                 (map$9,
		                  patch[1],
		                  function(param, cont){return cont(cst_name);},
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (filter_opt,
		                            [0, a, b],
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (concat$0,
		                                      bLM,
		                                      a,
		                                      function(property_name){
		                                       var
		a =
		  ai_automation
		   (automation_id, org_id, [1, property_name, patch[2]]);
		                                       return caml_exact_trampoline_cps_call$0
		       (push_dont_wait$0,
		        ctrl[11],
		        0,
		        a,
		        function(match){
		         return caml_trampoline_cps_call2(return$13, 0, cont);
		        });
		                                      });
		                            });
		                  });
		        });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$3
		                                    (update_automation,
		                                     ctrl,
		                                     crdt,
		                                     workspace_id,
		                                     automation_id,
		                                     patch,
		                                     function(b){
		                                      return caml_trampoline_cps_call2
		      (return$12,
		       b,
		       function(b){
		        return caml_exact_trampoline_cps_call$1(let$62, b, a, cont);
		       });
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$61, b, a, cont);
		                                    });
		                          });
		                }
		                var
		                 update$0 =
		                   call_async
		                    (cst_update,
		                     "Update an automation in organization",
		                     [0,
		                      [0, cst_organization_id, schema$21, 0],
		                      [0,
		                       [0, cst_automation_id, schema$111, 0],
		                       [0, [0, cst_patch, schema$210, 0], 0]]],
		                     schematic_param_a_schema_versi,
		                     local_only(side, v$2));
		                function v$3(graph, org_id, cont){
		                 return caml_exact_trampoline_cps_call
		                         (default_workspace_of_organizat,
		                          org_id,
		                          function(workspace_id){
		                           var ctrl = graph[3];
		                           return caml_exact_trampoline_cps_call$1
		                                   (active_steps, ctrl, workspace_id, cont);
		                          });
		                }
		                var
		                 c = local_only(side, v$3),
		                 all$5 =
		                   call_reactive
		                    (cst_all,
		                     "Get list of all step IDs in organization",
		                     [0, [0, cst_organization_id, schema$21, 0], 0],
		                     list_schema(schema$108),
		                     c);
		                function v$4(graph, org_id, payload, automation, cont){
		                 var prompt = payload[2], name = payload[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (strip,
		                          0,
		                          name,
		                          function(a){
		                           return is_empty$0(a)
		                                   ? caml_exact_trampoline_cps_call(return_error, bLN, cont)
		                                   : is_empty
		                                      (prompt[2][1])
		                                     ? caml_exact_trampoline_cps_call(return_error, bLO, cont)
		                                     : caml_exact_trampoline_cps_call
		                                       (default_workspace_of_organizat,
		org_id,
		function(workspace){
		 var ctrl = graph[3];
		 function a(crdt, cont){
		  function a(step_id, cont){
		   function a(a){
		    return caml_trampoline_cps_call2(return$13, step_id, cont);
		   }
		   if(! automation) return a();
		   var
		    automation_id = automation[1],
		    b = ai_automation(automation_id, org_id, 1);
		   return caml_exact_trampoline_cps_call$0
		           (push_dont_wait$0, ctrl[11], 0, b, a);
		  }
		  return caml_exact_trampoline_cps_call$7
		          (create_step,
		           ctrl,
		           crdt,
		           workspace,
		           automation,
		           payload,
		           dummy,
		           function(b){
		            return caml_trampoline_cps_call2
		                    (return$12,
		                     b,
		                     function(b){
		                      return caml_exact_trampoline_cps_call$1(let$62, b, a, cont);
		                     });
		           });
		 }
		 return caml_exact_trampoline_cps_call
		         (writable$0,
		          ctrl[2],
		          function(b){
		           return caml_trampoline_cps_call3(let$61, b, a, cont);
		          });
		});
		                          });
		                }
		                var
		                 d = local_only(side, v$4),
		                 run =
		                   [0,
		                    cst_run,
		                    [0,
		                     all$3,
		                     [0, delete$2, [0, get$3, [0, resume, [0, run_manually, 0]]]]]],
		                 step = [0, cst_step, [0, all$4, 0]];
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schema$111,
		                         function(schema){
		                          var
		                           schema$0 = Create[4],
		                           create$2 =
		                             call_async
		                              (cst_create,
		                               "Create a step in organization",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0,
		                                 [0, cst_payload, schema$0, 0],
		                                 [0, [0, cst_automation_id, schema, 0], 0]]],
		                               schema$108,
		                               d);
		                          function v(graph, org_id, step, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace){
		                                     var ctrl = graph[3];
		                                     function a(crdt, cont){
		                                      return caml_exact_trampoline_cps_call$2
		      (delete_step,
		       ctrl,
		       crdt,
		       workspace,
		       step,
		       function(a){
		        return caml_trampoline_cps_call2(return$12, a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$61, b, a, cont);
		      });
		                                    });
		                          }
		                          var
		                           delete$2 =
		                             call_async
		                              (cst_delete,
		                               "Delete a step in organization",
		                               [0,
		                                [0, cst_organization_id, schema$21, 0],
		                                [0, [0, cst_step_id, schema$108, 0], 0]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v));
		                          function v$0(graph, org_id, step, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    org_id,
		                                    function(workspace_id){
		                                     var ctrl = graph[3], values = ctrl[9][5];
		                                     return caml_exact_trampoline_cps_call$1
		     (find$6,
		      values[42][5][2],
		      [0, workspace_id, step],
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (of_incremental, 0, a, cont);
		      });
		                                    });
		                          }
		                          var a = local_only(side, v$0);
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schema$110,
		                                   function(b){
		                                    var
		                                     get$3 =
		                                       call_reactive
		(cst_get$0,
		 "Get step data by id in organization",
		 [0,
		  [0, cst_organization_id, schema$21, 0],
		  [0, [0, cst_step_id, schema$108, 0], 0]],
		 b,
		 a);
		                                    function v(graph, org_id, step_id, patch, cont){
		                                     var prompt = patch[2], name = patch[1];
		                                     function a(a){
		                                      if(a)
		                                       return caml_exact_trampoline_cps_call
		       (return_error, bLP, cont);
		                                      if(prompt)
		                                       var x = prompt[1], a = is_empty(x[2][1]);
		                                      else
		                                       a = 0;
		                                      return a
		      ? caml_exact_trampoline_cps_call(return_error, bLQ, cont)
		      : caml_exact_trampoline_cps_call
		        (default_workspace_of_organizat,
		         org_id,
		         function(workspace_id){
		          var ctrl = graph[3];
		          function a(crdt, cont){
		           return caml_exact_trampoline_cps_call$3
		                   (update_step,
		                    ctrl,
		                    crdt,
		                    workspace_id,
		                    step_id,
		                    patch,
		                    function(a){
		                     return caml_trampoline_cps_call2(return$12, a, cont);
		                    });
		          }
		          return caml_exact_trampoline_cps_call
		                  (writable$0,
		                   ctrl[2],
		                   function(b){
		                    return caml_trampoline_cps_call3(let$61, b, a, cont);
		                   });
		         });
		                                     }
		                                     if(! name) return a(0);
		                                     var x = name[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (strip, 0, x, function(b){return a(is_empty$0(b));});
		                                    }
		                                    var
		                                     update$1 =
		                                       call_async
		(cst_update,
		 "Update step in organization",
		 [0,
		  [0, cst_organization_id, schema$21, 0],
		  [0,
		   [0, cst_step_id, schema$108, 0],
		   [0, [0, cst_patch, schema$204, 0], 0]]],
		 schematic_param_a_schema_versi,
		 local_only(side, v));
		                                    function v$0
		                                    (graph,
		                                     org_id,
		                                     slack_connection_id,
		                                     gmail_connection_id,
		                                     github_connection_id,
		                                     github_issues_table_id,
		                                     gmail_inbox_table_id,
		                                     calendar_id,
		                                     cont){
		                                     var ctrl = graph[3];
		                                     function a(crdt, cont){
		                                      return caml_exact_trampoline_cps_call
		      (default_workspace_of_organizat,
		       org_id,
		       function(workspace){
		        function a(param, cont){
		         if(0 === param[0]) return cont(bLR);
		         var error = param[1];
		         return typeof error === "number"
		                 ? cont(bLS)
		                 : cont([1, error]);
		        }
		        return caml_exact_trampoline_cps_call$5
		                (setup,
		                 ctrl,
		                 crdt,
		                 org_id,
		                 workspace,
		                 slack_connection_id,
		                 gmail_connection_id,
		                 github_connection_id,
		                 github_issues_table_id,
		                 gmail_inbox_table_id,
		                 calendar_id,
		                 function(b){
		                  return caml_trampoline_cps_call3(symbol_map$26, b, a, cont);
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$61, b, a, cont);
		      });
		                                    }
		                                    var
		                                     b = local_only(side, v$0),
		                                     schema = Table[5],
		                                     schema$0 = Table[5],
		                                     setup_demo =
		                                       call_async
		("setup_demo",
		 "Set up or reset the AI demo scenario",
		 [0,
		  [0, cst_organization_id, schema$21, 0],
		  [0,
		   [0, "slack_connection_id", connection_id_schema, 0],
		   [0,
		    [0, "gmail_connection_id", connection_id_schema, 0],
		    [0,
		     [0, "github_connection_id", connection_id_schema, 0],
		     [0,
		      [0, "github_issues_table_id", schema$0, 0],
		      [0,
		       [0, "gmail_inbox_table_id", schema, 0],
		       [0, [0, "calendar_id", schema$11, 0], 0]]]]]]],
		 schematic_param_a_schema_versi,
		 b);
		                                    return cont
		    ([0,
		      [0,
		       cst_agent,
		       [0,
		        all,
		        [0,
		         [0, cst_automation, [0, all$0, 0]],
		         [0,
		          [0,
		           cst_conversation,
		           [0,
		            all$1,
		            [0,
		             create$0,
		             [0,
		              delete$0,
		              [0,
		               get$1,
		               [0,
		                get_summary,
		                [0, send, [0, send_rich, [0, update_context, 0]]]]]]]]],
		          [0, create, [0, delete$, [0, get$0, [0, update, 0]]]]]]]],
		      [0,
		       [0, cst_assistant, [0, get, 0]],
		       [0,
		        [0,
		         cst_automation,
		         [0,
		          all$2,
		          [0,
		           create$1,
		           [0,
		            delete$1,
		            [0,
		             get$2,
		             [0, run, [0, running, [0, step, [0, update$0, 0]]]]]]]]],
		        [0,
		         is_set_up,
		         [0,
		          [0,
		           cst_step,
		           [0,
		            all$5,
		            [0, create$2, [0, delete$2, [0, get$3, [0, update$1, 0]]]]]],
		          [0, setup_demo, 0]]]]]]);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               var
		                open$38 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_map$27 = open$38[2];
		               function schematic_version$365(param, cont){return cont(0);}
		               caml_callback
		                (schema$0,
		                 [no_input_schema,
		                  caml_callback
		                   (ai_limit_exceeded_schema_versi, [schematic_version$365])]);
		               function authorize$3
		               (ctrl, client_id, redirect_uri, response_type, state, cont){
		                function f(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (api$1,
		                          ctrl[1],
		                          function(match){
		                           var api = match[2], Api = match[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (to_string$25,
		                                    0,
		                                    redirect_uri,
		                                    function(a){
		                                     return caml_trampoline_cps_call6
		     (Api[9][1], state, api, client_id, a, response_type, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (offline$0(cst_obtaining_OAuth_authorizat, ctrl), f, cont);
		               }
		               var
		                open$39 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$63 = open$39[4],
		                open$40 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_map$28 = open$40[2],
		                open$41 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$64 = open$41[4],
		                open$42 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$65 = open$42[4],
		                letrec_function_context$1373 = [];
		               function organization_summary_schema_ve$0
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1373[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bLV, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1373[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1373[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1373[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (workspace_summary_schema_versi,
		                                     schematic_version,
		                                     function(b){
		                                      var
		                                       a =
		 [0,
		  [0,
		   0,
		   0,
		   0,
		   0,
		   cst_name,
		   0,
		   2,
		   [0, schematic_param_name_schema_ve],
		   0,
		   0],
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_workspaces,
		    0,
		    2,
		    [0, [0, 0, 0, [3, b], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call
		      (schema_versioned$104,
		       schematic_version,
		       function(b){
		        var
		         res =
		           [7,
		            function(param, cont){
		             var
		              a = param[2],
		              workspaces = a[2][1],
		              name = a[1],
		              organization_id = param[1];
		             return cont([0, organization_id, name, workspaces]);
		            },
		            function(param, cont){
		             var
		              workspaces = param[3],
		              name = param[2],
		              organization_id = param[1];
		             return cont
		                     ([0, organization_id, [0, name, [0, workspaces, 0]]]);
		            },
		            [0,
		             [0, 0, 0, 0, 0, cst_organizationId, 0, 2, [0, b], 0, 0],
		             a]];
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context$1373[1][1],
		                 schematic_schema_version,
		                 res,
		                 function(a){
		                  letrec_function_context$1373[1][1] = a;
		                  return cont(res);
		                 });
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1333 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1373, [0, schematic_cache$1333]);
		               caml_callback
		                (organization_summary_schema_ve$0,
		                 [function(param, cont){return cont(0);}]);
		               var letrec_function_context$1374 = [];
		               function list_organizations_output_sche
		               (schematic_version, cont){
		                return caml_exact_trampoline_cps_call
		                        (schematic_version,
		                         V$4,
		                         function(schematic_schema_version){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   letrec_function_context$1374[1][1],
		                                   schematic_schema_version,
		                                   function(match){
		                                    function a(descriptor){
		                                     return cont([0, bLW, 0, descriptor, 0]);
		                                    }
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (fixpoint,
		      function(schematic_self, cont){
		       return caml_exact_trampoline_cps_call$1
		               (find_packed_by_id,
		                letrec_function_context$1374[1][1],
		                schematic_schema_version,
		                function(match){
		                 if(! match)
		                  return caml_exact_trampoline_cps_call$0
		                          (set$3,
		                           letrec_function_context$1374[1][1],
		                           schematic_schema_version,
		                           schematic_self,
		                           function(a){
		                            letrec_function_context$1374[1][1] = a;
		                            return caml_exact_trampoline_cps_call
		                                    (organization_summary_schema_ve$0,
		                                     schematic_version,
		                                     function(a){
		                                      var
		                                       res =
		 [7,
		  function(param, cont){
		   var organizations = param[1];
		   return cont([0, organizations]);
		  },
		  function(param, cont){
		   var organizations = param[1];
		   return cont([0, organizations, 0]);
		  },
		  [0,
		   [0,
		    0,
		    0,
		    0,
		    0,
		    cst_organizations,
		    0,
		    2,
		    [0, [0, 0, 0, [3, a], 0]],
		    0,
		    0],
		   0]];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context$1374[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context$1374[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 var schema = match[1];
		                 return cont(schema);
		                });
		      },
		      a);
		                                    var schema = match[1];
		                                    return a(schema);
		                                   });
		                         });
		               }
		               var schematic_cache$1334 = [0, empty$11([0, comparator$9])];
		               caml_update_dummy
		                (letrec_function_context$1374, [0, schematic_cache$1334]);
		               caml_callback
		                (list_organizations_output_sche,
		                 [function(param, cont){return cont(0);}]);
		               function registry(graph, organization_id, integrations, cont){
		                var ctrl = graph[3];
		                function a(organization_id, organizations_scope){
		                 return caml_trampoline_cps_call3
		                         (map$18,
		                          integrations,
		                          function(key, cont){
		                           return cont([0, [0, key], cst$1, [0, organization_id]]);
		                          },
		                          function(integrations){
		                           var context = [0, integrations];
		                           return caml_exact_trampoline_cps_call
		                                   (default_workspace_of_organizat,
		                                    organization_id,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$4
		     (extract_tools_from_context,
		      graph,
		      ctrl,
		      0,
		      a,
		      0,
		      0,
		      0,
		      context,
		      organizations_scope,
		      function(registry){
		       var organization_ids = organizations$0(organizations_scope);
		       function a(param, cont){
		        return caml_exact_trampoline_cps_call
		                (state_personal,
		                 ctrl[2],
		                 function(match){
		                  var organizations = match[15];
		                  return caml_exact_trampoline_cps_call$1
		                          (filter_map$0,
		                           organization_ids,
		                           function(organization_id, cont){
		                            function a(organization, cont){
		                             return caml_exact_trampoline_cps_call$1
		                                     (to_alist$0,
		                                      0,
		                                      organization[4],
		                                      function(a){
		                                       return caml_trampoline_cps_call3
		       (map$18,
		        a,
		        function(param, cont){
		         var workspace = param[2], workspace_id = param[1];
		         return cont([0, workspace_id, workspace[3][2]]);
		        },
		        function(workspaces){
		         return cont
		                 ([0, organization_id, organization[3][4][2], workspaces]);
		        });
		                                      });
		                            }
		                            return caml_exact_trampoline_cps_call$1
		                                    (find_packed_by_id,
		                                     organizations,
		                                     organization_id,
		                                     function(b){
		                                      return caml_trampoline_cps_call3(map$17, b, a, cont);
		                                     });
		                           },
		                           function(organizations){
		                            return caml_trampoline_cps_call2
		                                    (return$13, [0, organizations], cont);
		                           });
		                 });
		       }
		       function schematic_version(param, cont){return cont(0);}
		       return caml_exact_trampoline_cps_call
		               (list_organizations_output_sche,
		                schematic_version,
		                function(b){
		                 return caml_exact_trampoline_cps_call$9
		                         (tool,
		                          "listOrganizations",
		                          0,
		                          0,
		                          "List the organizations configured for this MCP tool registry, including their workspaces.",
		                          read$2(0),
		                          null$6,
		                          b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0, registry, [0, a, 0], cont);
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                if(! organization_id)
		                 return caml_exact_trampoline_cps_call
		                         (user_id,
		                          ctrl[1],
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (personal_organization_of_user_,
		                                    b,
		                                    function(organization_id){
		                                     return caml_exact_trampoline_cps_call
		     (state_personal,
		      ctrl[2],
		      function(b){
		       return caml_exact_trampoline_cps_call
		               (keys$0,
		                b[15],
		                function(all_orgs){
		                 return caml_trampoline_cps_call2
		                         (equal$53,
		                          organization_id,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$1
		                                   (filter,
		                                    all_orgs,
		                                    function(a, cont){
		                                     return caml_exact_trampoline_cps_call$1(non, b, a, cont);
		                                    },
		                                    function(b){
		                                     var organizations_scope = [1, organization_id, b];
		                                     return a(organization_id, organizations_scope);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                var organization_id$0 = organization_id[1];
		                return a(organization_id$0, [0, organization_id$0]);
		               }
		               function public_namespace_path(namespace_path){
		                if(namespace_path && namespace_path[1] === cst_routine){
		                 var namespace_path$0 = namespace_path[2];
		                 return namespace_path$0;
		                }
		                return namespace_path;
		               }
		               function source_name(param){
		                var name = param[2][1];
		                return name;
		               }
		               function mcp_name(namespaced_function, cont){
		                var
		                 namespace_path = namespaced_function[1],
		                 a = [0, source_name(namespaced_function), 0];
		                return caml_exact_trampoline_cps_call$1
		                        (append$0,
		                         public_namespace_path(namespace_path),
		                         a,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (concat$0, bLX, a, cont);
		                         });
		               }
		               function mcp_functions(registry, cont){
		                function collect(namespace_path, tools, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (concat_map,
		                          tools,
		                          function(param, cont){
		                           if(0 === param[0]){
		                            var function$ = param[1];
		                            return cont([0, [0, namespace_path, function$], 0]);
		                           }
		                           var tools = param[3], name = param[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0,
		                                    namespace_path,
		                                    [0, name, 0],
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (collect, a, tools, cont);
		                                    });
		                          },
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (collect,
		                         0,
		                         registry,
		                         function(a){
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   a,
		                                   function(namespaced_function, cont){
		                                    return caml_exact_trampoline_cps_call
		    (mcp_name,
		     namespaced_function,
		     function(a){return cont([0, a, namespaced_function]);});
		                                   },
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_alist_exn$1, [0, comparator$2], a, cont);
		                                   });
		                         });
		               }
		               function descriptor$61(namespaced_function, cont){
		                var
		                 a = namespaced_function[2],
		                 input_schema = a[7],
		                 behavior = a[5],
		                 description = a[4],
		                 namespace_path = namespaced_function[1],
		                 world = behavior[2],
		                 operation = behavior[1];
		                if(operation){
		                 a = operation[1];
		                 var
		                  idempotent = a[2],
		                  destructive = a[1],
		                  idempotent_hint = [0, idempotent],
		                  destructive_hint = destructive,
		                  read_only_hint = 0;
		                }
		                else {
		                 idempotent_hint = 0;
		                 destructive_hint = 0;
		                 read_only_hint = 1;
		                }
		                var
		                 open_world_hint = world ? 1 : 0,
		                 c =
		                   [0,
		                    read_only_hint,
		                    destructive_hint,
		                    idempotent_hint,
		                    open_world_hint];
		                function b(b){
		                 var
		                  namespace_path$0 = namespaced_function[1],
		                  namespace_path$1 = public_namespace_path(namespace_path$0);
		                 function a(a){
		                  return caml_exact_trampoline_cps_call
		                          (mcp_name,
		                           namespaced_function,
		                           function(d){
		                            var
		                             descriptor = [0, d, a, namespace_path, description, b, c];
		                            return cont(descriptor);
		                           });
		                 }
		                 return namespace_path$1
		                         ? caml_trampoline_cps_call3
		                           (map$18,
		                            namespace_path$1,
		                            function(name, cont){
		                             return caml_exact_trampoline_cps_call$0
		                                     (substr_replace_all_gen,
		                                      cj,
		                                      name,
		                                      cst$13,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (a,
		        cst$7,
		        function(a){
		         return caml_exact_trampoline_cps_call
		                 (capitalize_ascii, a, cont);
		        });
		                                      });
		                            },
		                            function(b){
		                             return caml_exact_trampoline_cps_call$1
		                                     (concat$0,
		                                      bLY,
		                                      b,
		                                      function(namespace_title){
		                                       var b = source_name(namespaced_function);
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$299,
		        function(c){
		         return caml_trampoline_cps_call3(c, namespace_title, b, a);
		        });
		                                      });
		                            })
		                         : a(source_name(namespaced_function));
		                }
		                if(typeof input_schema !== "number" && 0 === input_schema[0]){
		                 var schema = input_schema[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (of_schema$0,
		                          bcE,
		                          schema,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (sanitize_schema,
		                                    a,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (strip_null_defaults, a, b);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call
		                        (tool_input_to_json, input_schema, b);
		               }
		               function call_tool$0(registry, name, arguments$, cont){
		                return caml_exact_trampoline_cps_call
		                        (mcp_functions,
		                         registry,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   a,
		                                   name,
		                                   function(match){
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$300,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                name,
		                function(a){
		                 return caml_trampoline_cps_call2
		                         (return$12, [0, 0, [0, a]], cont);
		                });
		      });
		                                    var
		                                     namespaced_function = match[1],
		                                     source_name$0 = source_name(namespaced_function);
		                                    function a(result, cont){
		                                     if(0 !== result[0]){
		                                      var error = result[1];
		                                      return cont([0, 0, [0, error]]);
		                                     }
		                                     var match = result[1];
		                                     if(0 !== match[0]) return cont(bLZ);
		                                     var result$0 = match[1];
		                                     return caml_exact_trampoline_cps_call
		     (of_string$11,
		      result$0,
		      function(match){
		       if(0 === match[0]){
		        var json = match[1];
		        return cont([0, [0, json], 0]);
		       }
		       var msg = match[1];
		       return cont([0, 0, [0, msg]]);
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$0
		    (handle_function_call,
		     registry,
		     cst_mcp,
		     [0, source_name$0, arguments$],
		     function(b){
		      return caml_trampoline_cps_call3(let$65, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function generate_access_token(ctrl, organization_id, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline$0("generating Integration App access token", ctrl),
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (api$1,
		                                   ctrl[1],
		                                   function(match){
		                                    var
		                                     api = match[2],
		                                     Api = match[1],
		                                     body = [0, organization_id];
		                                    return caml_trampoline_cps_call3(Api[5][1], api, body, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function get$35(ctrl, workspace_id, cont){
		                return caml_exact_trampoline_cps_call
		                        (read$1(ctrl),
		                         function(param, cont){
		                          var
		                           integration_app = param[2][10],
		                           Inc = param[1],
		                           open =
		                             g
		                              ([0,
		                                Inc[72],
		                                Inc[73],
		                                ,
		                                Inc[75],
		                                Inc[76],
		                                Inc[77],
		                                ,
		                                ,
		                                ,
		                                ,
		                                Inc[82]]),
		                           let$ = open[4];
		                          return caml_trampoline_cps_call3
		                                  (let$,
		                                   integration_app,
		                                   function(integration_app, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id, integration_app, workspace_id, cont);
		                                   },
		                                   function(integration_app){
		                                    return caml_exact_trampoline_cps_call$1
		    (of_incremental, 0, integration_app, cont);
		                                   });
		                         },
		                         cont);
		               }
		               var
		                open$43 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$66 = open$43[4];
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var
		                Logs$19 = with_tag$0(component$0, "Controller.Integrations");
		               function add$38(ctrl, crdt, config, cont){
		                var metrics = ctrl[11], auth = ctrl[1];
		                return caml_exact_trampoline_cps_call
		                        (Logs$19[6][6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m,
		                                   0,
		                                   0,
		                                   bL1,
		                                   function(a, b, cont){
		                                    return caml_exact_trampoline_cps_call$0
		    (_14, pp$66, a, b, cont);
		                                   },
		                                   config,
		                                   cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map_status,
		                                   function(status, cont){return cont(1);},
		                                   config,
		                                   function(config){
		                                    var integration_id = make$40();
		                                    function a(a){
		                                     return caml_exact_trampoline_cps_call
		     (integrations$0,
		      a,
		      function(op){
		       return caml_exact_trampoline_cps_call$0
		               (apply_personal,
		                auth,
		                crdt,
		                op,
		                function(a){
		                 var
		                  workspace_id = personal_workspace_id_writable(crdt),
		                  a = 0 === config[0] ? cst_google : cst_notion,
		                  b = [0, a],
		                  c = [0, workspace_id];
		                 return caml_exact_trampoline_cps_call
		                         (to_string$49,
		                          integration_id,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (integration,
		                                    a,
		                                    c,
		                                    b,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (push_dont_wait$0,
		      metrics,
		      0,
		      a,
		      function(match){return cont(integration_id);});
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    if(0 === config[0]){
		                                     var conf = config[1];
		                                     return caml_trampoline_cps_call3
		     (Legacy[14], integration_id, [0, conf], a);
		                                    }
		                                    var conf$0 = config[1];
		                                    return caml_trampoline_cps_call3
		    (Legacy[14], integration_id, [1, conf$0], a);
		                                   });
		                         });
		               }
		               function get$36(ctrl, id, cont){
		                function f(param, cont){
		                 var lookup = param[2][9][2];
		                 return caml_exact_trampoline_cps_call$1
		                         (find$6,
		                          lookup,
		                          id,
		                          function(c){
		                           function a(a, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map$34, of_error, a, cont);
		                           }
		                           function b(b, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (map_status, a, b, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$1
		                                   (map$41,
		                                    c,
		                                    function(a, cont){
		                                     return caml_trampoline_cps_call3(map$17, a, b, cont);
		                                    },
		                                    function(config){
		                                     return caml_exact_trampoline_cps_call$1
		     (of_incremental, 0, config, cont);
		                                    });
		                          });
		                }
		                return caml_exact_trampoline_cps_call(read$1(ctrl), f, cont);
		               }
		               function list$3(ctrl, cont){
		                function f(param, cont){
		                 var by_id = param[2][9][1], Incr = param[1];
		                 g
		                  ([0,
		                    Incr[72],
		                    Incr[73],
		                    ,
		                    Incr[75],
		                    Incr[76],
		                    Incr[77],
		                    ,
		                    ,
		                    ,
		                    ,
		                    Incr[82]]);
		                 function a(a, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (map$34, of_error, a, cont);
		                 }
		                 function b(b, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (map_status, a, b, cont);
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (map$41,
		                          by_id,
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$1(map$13, a, b, cont);
		                          },
		                          function(configs){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_incremental, 0, configs, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call(read$1(ctrl), f, cont);
		               }
		               function refresh$3(ctrl, crdt, integration_id, cont){
		                var auth = ctrl[1];
		                return caml_exact_trampoline_cps_call
		                        (Logs$19[6][6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, bL2, pp$65, integration_id, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (state_writable_personal,
		                                   crdt,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (find_packed_by_id,
		     a[9],
		     integration_id,
		     function(match){
		      if(! match) return cont(0);
		      var previous_config = match[1];
		      return caml_exact_trampoline_cps_call$1
		              (map_status,
		               function(status, cont){return cont(1);},
		               previous_config,
		               function(config){
		                return caml_exact_trampoline_cps_call$1
		                        (update$3,
		                         previous_config,
		                         config,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (element$7,
		                                   integration_id,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2
		              (Operation$8[8],
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (integrations$0,
		                         a,
		                         function(op){
		                          return caml_exact_trampoline_cps_call$0
		                                  (apply_personal, auth, crdt, op, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function remove$29(ctrl, crdt, integration_id, cont){
		                var metrics = ctrl[11], auth = ctrl[1];
		                return caml_exact_trampoline_cps_call
		                        (Logs$19[6][6],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, bL3, pp$65, integration_id, cont);
		                         },
		                         function(match){
		                          return caml_trampoline_cps_call2
		                                  (remove$11,
		                                   integration_id,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (integrations$0,
		     a,
		     function(op){
		      return caml_exact_trampoline_cps_call$0
		              (apply_personal,
		               auth,
		               crdt,
		               op,
		               function(match){
		                var
		                 workspace_id = personal_workspace_id_writable(crdt),
		                 a = [0, workspace_id];
		                return caml_exact_trampoline_cps_call
		                        (to_string$49,
		                         integration_id,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$0
		                                  (integration,
		                                   b,
		                                   a,
		                                   0,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$0
		    (push_dont_wait$0, metrics, 0, a, cont);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function update$19(ctrl, crdt, integration_id, config, cont){
		                var auth = ctrl[1];
		                return caml_exact_trampoline_cps_call
		                        (state_writable_personal,
		                         crdt,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (find_packed_by_id,
		                                   a[9],
		                                   integration_id,
		                                   function(match){
		                                    if(! match)
		                                     return caml_exact_trampoline_cps_call
		     (Logs$19[6][4],
		      function(m, cont){
		       return caml_trampoline_cps_call6
		               (m, 0, 0, bL5, pp$65, integration_id, cont);
		      },
		      cont);
		                                    var previous_config = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (map_status,
		     function(status, cont){return cont(1);},
		     config,
		     function(config){
		      return caml_exact_trampoline_cps_call
		              (Logs$19[6][6],
		               function(m, cont){
		                return caml_trampoline_cps_call8
		                        (m,
		                         0,
		                         0,
		                         bL4,
		                         function(a, b, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (_14, _13$1, a, b, cont);
		                         },
		                         previous_config,
		                         function(a, b, cont){
		                          return caml_exact_trampoline_cps_call$0
		                                  (_14, _13$1, a, b, cont);
		                         },
		                         config,
		                         cont);
		               },
		               function(match){
		                return caml_exact_trampoline_cps_call$1
		                        (update$3,
		                         previous_config,
		                         config,
		                         function(a){
		                          return caml_trampoline_cps_call2
		                                  (element$7,
		                                   integration_id,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b,
		     a,
		     function(a){
		      return caml_trampoline_cps_call2
		              (Operation$8[8],
		               a,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (integrations$0,
		                         a,
		                         function(op){
		                          return caml_exact_trampoline_cps_call$0
		                                  (apply_personal, auth, crdt, op, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function exchange_token(ctrl, code, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline$0("exchanging Notion token", ctrl),
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (api$1,
		                                   ctrl[1],
		                                   function(match){
		                                    var api = match[2], Api = match[1];
		                                    return caml_trampoline_cps_call3
		    (Api[4][1][1], api, code, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function generate_import_id(ctrl, cont){return cont(Id$9[29].call(null));
		               }
		               var
		                open$44 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$67 = open$44[4],
		                By_name =
		                  caml_callback
		                   (M$2, [[0, comparator$2, thread_id_schema_versioned]]),
		                open$45 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_map$29 = open$45[2];
		               caml_callback
		                (M$2, [[0, comparator$2, thread_id_schema_versioned]]);
		               var
		                schematic_cache$1335 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$1375 = [];
		               caml_update_dummy
		                (letrec_function_context$1375, [0, schematic_cache$1335]);
		               var
		                schematic_schema_version$54 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$1375[1][1],
		                     schematic_schema_version$54]);
		               if(e)
		                var schema$258 = e[1], descriptor$62 = schema$258;
		               else
		                descriptor$62 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$1375[1][1],
		                              schematic_schema_version$54,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$1375[1][1],
		 schematic_schema_version$54,
		 schematic_self,
		 function(a){
		  letrec_function_context$1375[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (include$51[4],
		           dummy,
		           function(b){
		            var
		             a = [0, [0, 0, 0, 0, 0, cst_row_id, 0, 2, [0, b], 0, 0], 0];
		            return caml_exact_trampoline_cps_call
		                    (Table[4],
		                     dummy,
		                     function(c){
		                      var
		                       b =
		                         [0, [0, 0, 0, 0, 0, cst_table_id, 0, 2, [0, c], 0, 0], a];
		                      return caml_exact_trampoline_cps_call
		                              (schema_versioned$120,
		                               dummy,
		                               function(a){
		                                var
		                                 res =
		                                   [7,
		                                    function(param, cont){
		                                     var
		                                      a = param[2],
		                                      row_id = a[2][1],
		                                      table_id = a[1],
		                                      workspace_id = param[1];
		                                     return cont([0, workspace_id, table_id, row_id]);
		                                    },
		                                    function(param, cont){
		                                     var
		                                      row_id = param[3],
		                                      table_id = param[2],
		                                      workspace_id = param[1];
		                                     return cont
		     ([0, workspace_id, [0, table_id, [0, row_id, 0]]]);
		                                    },
		                                    [0,
		                                     [0, 0, 0, 0, 0, cst_workspace_id, 0, 3, [0, a], 0, 0],
		                                     b]];
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$1375[1][1],
		 schematic_schema_version$54,
		 res,
		 function(a){
		  letrec_function_context$1375[1][1] = a;
		  return cont(res);
		 });
		                               });
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var object_id_schema = [0, bL7, bL6, descriptor$62, 0];
		               function rpcs$2(param, side, cont){
		                var
		                 var_schema = param[5],
		                 result_schema = param[4],
		                 remote_value_schema = param[3],
		                 schematic_param_a_schema_versi$0 = param[2],
		                 schematic_cache = [0, empty$11([0, comparator$9])],
		                 letrec_function_context = [];
		                caml_update_dummy
		                 (letrec_function_context, [0, schematic_cache]);
		                var schematic_schema_version = 0;
		                return caml_exact_trampoline_cps_call$1
		                        (find_packed_by_id,
		                         letrec_function_context[1][1],
		                         schematic_schema_version,
		                         function(match){
		                          function a(descriptor){
		                           var schema = [0, bL8, 0, descriptor];
		                           function decode(param, cont){
		                            switch(param[0]){
		                              case 0:
		                               var value = param[1];
		                               return caml_trampoline_cps_call2
		                                       (of_string$14, [0, value], cont);
		                              case 1:
		                               var value$0 = param[1];
		                               return caml_trampoline_cps_call2
		                                       (of_string$14, [1, value$0], cont);
		                              default:
		                               var value$1 = param[1];
		                               return caml_trampoline_cps_call2
		                                       (of_string$14, [2, value$1], cont);
		                            }
		                           }
		                           function encode(param, cont){
		                            switch(param[0]){
		                              case 0:
		                               var value = param[1]; return cont([0, value]);
		                              case 1:
		                               var value$0 = param[1]; return cont([1, value$0]);
		                              default: var value$1 = param[1]; return cont([2, value$1]);
		                            }
		                           }
		                           var
		                            graph_variable_schema = map$14(decode, encode, schema),
		                            a = [];
		                           function schema_versioned(schematic_version, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (schematic_version,
		                                     V$4,
		                                     function(schematic_schema_version){
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       a[1][1],
		       schematic_schema_version,
		       function(match){
		        function b(descriptor){
		         return cont([0, bL_, 0, descriptor, 0]);
		        }
		        if(! match)
		         return caml_exact_trampoline_cps_call
		                 (fixpoint,
		                  function(schematic_self, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            a[1][1],
		                            schematic_schema_version,
		                            function(match){
		                             if(! match)
		                              return caml_exact_trampoline_cps_call$0
		                                      (set$3,
		                                       a[1][1],
		                                       schematic_schema_version,
		                                       schematic_self,
		                                       function(b){
		a[1][1] = b;
		return caml_exact_trampoline_cps_call
		        (schema_versioned,
		         schematic_version,
		         function(c){
		          var
		           b =
		             [0,
		              [0,
		               function(f0, cont){return cont([6, f0]);},
		               function(param, cont){
		                if(typeof param !== "number" && 6 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                return cont(0);
		               },
		               1,
		               0,
		               cst_variant,
		               cst_Variant,
		               [0,
		                0,
		                0,
		                [7,
		                 function(param, cont){
		                  var cases = param[1];
		                  return cont(cases);
		                 },
		                 function(cases, cont){return cont([0, cases, 0]);},
		                 [0,
		                  [0,
		                   0,
		                   0,
		                   0,
		                   0,
		                   cst_cases,
		                   0,
		                   2,
		                   [0, [0, 0, 0, [3, c], 0]],
		                   0,
		                   0],
		                  0]],
		                0],
		               0],
		              0];
		          return caml_exact_trampoline_cps_call
		                  (schema_versioned,
		                   schematic_version,
		                   function(d){
		                    var
		                     c =
		                       [0,
		                        [0,
		                         function(f0, cont){return cont([5, f0]);},
		                         function(param, cont){
		                          if(typeof param !== "number" && 5 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_tuple,
		                         cst_Tuple,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var elements = param[1];
		                            return cont(elements);
		                           },
		                           function(elements, cont){return cont([0, elements, 0]);},
		                           [0,
		                            [0,
		                             0,
		                             0,
		                             0,
		                             0,
		                             cst_elements,
		                             0,
		                             2,
		                             [0, [0, 0, 0, [3, d], 0]],
		                             0,
		                             0],
		                            0]],
		                          0],
		                         0],
		                        b];
		                    return caml_exact_trampoline_cps_call
		                            (schema_versioned$90,
		                             schematic_version,
		                             function(d){
		                              var
		                               b =
		                                 [0,
		                                  [0,
		                                   function(f0, cont){return cont([4, f0]);},
		                                   function(param, cont){
		                                    if(typeof param !== "number" && 4 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                    return cont(0);
		                                   },
		                                   1,
		                                   0,
		                                   cst_string,
		                                   cst_String,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){
		                                      var format = param[1];
		                                      return cont(format);
		                                     },
		                                     function(format, cont){return cont([0, format, 0]);},
		                                     [0, [0, 0, 0, 0, 0, cst_format, 0, 3, [0, d], 0, 0], 0]],
		                                    0],
		                                   0],
		                                  c];
		                              return caml_exact_trampoline_cps_call
		                                      (field_schema_versioned,
		                                       schematic_version,
		                                       function(d){
		var
		 c =
		   [0,
		    [0,
		     function(param, cont){return cont(4);},
		     function(param, cont){
		      if(typeof param === "number" && 4 <= param)
		       return cont(bL$);
		      return cont(0);
		     },
		     0,
		     0,
		     cst_null,
		     cst_Null,
		     [0,
		      0,
		      0,
		      [7,
		       function(param, cont){return cont(0);},
		       function(param, cont){return cont(0);},
		       0],
		      0],
		     0],
		    [0,
		     [0,
		      function(f0, cont){return cont([3, f0]);},
		      function(param, cont){
		       if(typeof param !== "number" && 3 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		       return cont(0);
		      },
		      1,
		      0,
		      cst_record,
		      cst_Record,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){
		         var fields = param[1];
		         return cont(fields);
		        },
		        function(fields, cont){return cont([0, fields, 0]);},
		        [0,
		         [0,
		          0,
		          0,
		          0,
		          0,
		          cst_fields,
		          0,
		          2,
		          [0, [0, 0, 0, mapping_schema(d)[3], 0]],
		          0,
		          0],
		         0]],
		       0],
		      0],
		     b]];
		return caml_exact_trampoline_cps_call
		        (schema_versioned,
		         schematic_version,
		         function(d){
		          var
		           b = [0, [0, 0, 0, 0, 0, cst_data, 0, 2, [0, d], 0, 0], 0];
		          return caml_exact_trampoline_cps_call
		                  (schema_versioned,
		                   schematic_version,
		                   function(e){
		                    var
		                     d =
		                       [0,
		                        [0,
		                         function(param, cont){
		                          var f1 = param[2], f0 = param[1];
		                          return cont([2, f0, f1]);
		                         },
		                         function(param, cont){
		                          if(typeof param !== "number" && 2 === param[0]){
		                           var f1 = param[2], f0 = param[1];
		                           return cont([0, [0, f0, f1]]);
		                          }
		                          return cont(0);
		                         },
		                         1,
		                         0,
		                         cst_map,
		                         cst_Map,
		                         [0,
		                          0,
		                          0,
		                          [7,
		                           function(param, cont){
		                            var data = param[2][1], key = param[1];
		                            return cont([0, key, data]);
		                           },
		                           function(param, cont){
		                            var data = param[2], key = param[1];
		                            return cont([0, key, [0, data, 0]]);
		                           },
		                           [0, [0, 0, 0, 0, 0, cst_key, 0, 2, [0, e], 0, 0], b]],
		                          0],
		                         0],
		                        c];
		                    return caml_exact_trampoline_cps_call
		                            (schema_versioned,
		                             schematic_version,
		                             function(e){
		                              var
		                               b =
		                                 [0,
		                                  [0,
		                                   function(param, cont){return cont(1);},
		                                   function(param, cont){
		                                    if(typeof param === "number" && 1 === param)
		                                     return cont(bMc);
		                                    return cont(0);
		                                   },
		                                   0,
		                                   0,
		                                   cst_int,
		                                   cst_Int,
		                                   [0,
		                                    0,
		                                    0,
		                                    [7,
		                                     function(param, cont){return cont(0);},
		                                     function(param, cont){return cont(0);},
		                                     0],
		                                    0],
		                                   0],
		                                  [0,
		                                   [0,
		                                    function(param, cont){return cont(2);},
		                                    function(param, cont){
		                                     if(typeof param === "number" && 2 === param)
		                                      return cont(bMb);
		                                     return cont(0);
		                                    },
		                                    0,
		                                    0,
		                                    cst_float,
		                                    cst_Float,
		                                    [0,
		                                     0,
		                                     0,
		                                     [7,
		                                      function(param, cont){return cont(0);},
		                                      function(param, cont){return cont(0);},
		                                      0],
		                                     0],
		                                    0],
		                                   [0,
		                                    [0,
		                                     function(param, cont){return cont(3);},
		                                     function(param, cont){
		                                      if(typeof param === "number" && 3 === param)
		                                       return cont(bMa);
		                                      return cont(0);
		                                     },
		                                     0,
		                                     0,
		                                     cst_json,
		                                     cst_Json,
		                                     [0,
		                                      0,
		                                      0,
		                                      [7,
		                                       function(param, cont){return cont(0);},
		                                       function(param, cont){return cont(0);},
		                                       0],
		                                      0],
		                                     0],
		                                    [0,
		                                     [0,
		                                      function(f0, cont){return cont([1, f0]);},
		                                      function(param, cont){
		                                       if(typeof param !== "number" && 1 === param[0]){var f0 = param[1]; return cont([0, f0]);}
		                                       return cont(0);
		                                      },
		                                      1,
		                                      0,
		                                      cst_list,
		                                      cst_List,
		                                      [0,
		                                       0,
		                                       0,
		                                       [7,
		function(param, cont){
		 var elements = param[1];
		 return cont(elements);
		},
		function(elements, cont){return cont([0, elements, 0]);},
		[0, [0, 0, 0, 0, 0, cst_elements, 0, 2, [0, e], 0, 0], 0]],
		                                       0],
		                                      0],
		                                     d]]]],
		                               c =
		                                 [0,
		                                  [0,
		                                   0,
		                                   0,
		                                   0,
		                                   0,
		                                   cst_value,
		                                   0,
		                                   2,
		                                   [0, schematic_param_a_schema_versi$0],
		                                   0,
		                                   0],
		                                  0];
		                              return caml_exact_trampoline_cps_call
		                                      (schema_versioned,
		                                       schematic_version,
		                                       function(d){
		var
		 res =
		   [11,
		    bMe,
		    [0,
		     [0,
		      function(param, cont){return cont(0);},
		      function(param, cont){
		       if(typeof param === "number" && ! param) return cont(bMd);
		       return cont(0);
		      },
		      0,
		      0,
		      cst_bool,
		      cst_Bool,
		      [0,
		       0,
		       0,
		       [7,
		        function(param, cont){return cont(0);},
		        function(param, cont){return cont(0);},
		        0],
		       0],
		      0],
		     [0,
		      [0,
		       function(param, cont){
		        var f1 = param[2], f0 = param[1];
		        return cont([0, f0, f1]);
		       },
		       function(param, cont){
		        if(typeof param !== "number" && 0 === param[0]){
		         var f1 = param[2], f0 = param[1];
		         return cont([0, [0, f0, f1]]);
		        }
		        return cont(0);
		       },
		       1,
		       0,
		       cst_const,
		       cst_Const,
		       [0,
		        0,
		        0,
		        [7,
		         function(param, cont){
		          var value = param[2][1], value_type = param[1];
		          return cont([0, value_type, value]);
		         },
		         function(param, cont){
		          var value = param[2], value_type = param[1];
		          return cont([0, value_type, [0, value, 0]]);
		         },
		         [0, [0, 0, 0, 0, 0, cst_value_type, 0, 2, [0, d], 0, 0], c]],
		        0],
		       0],
		      b]],
		    0];
		return caml_exact_trampoline_cps_call$0
		        (set$3,
		         a[1][1],
		         schematic_schema_version,
		         res,
		         function(b){a[1][1] = b; return cont(res);});
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             });
		                   });
		         });
		                                       });
		                             var schema = match[1];
		                             return cont(schema);
		                            });
		                  },
		                  b);
		        var schema = match[1];
		        return b(schema);
		       });
		                                     });
		                           }
		                           var letrec_function_context = [];
		                           function field_schema_versioned(schematic_version, cont){
		                            return caml_exact_trampoline_cps_call
		                                    (schematic_version,
		                                     V$4,
		                                     function(schematic_schema_version){
		                                      return caml_exact_trampoline_cps_call$1
		      (find_packed_by_id,
		       letrec_function_context[1][1],
		       schematic_schema_version,
		       function(match){
		        function a(descriptor){
		         return cont([0, bMf, 0, descriptor, 0]);
		        }
		        if(! match)
		         return caml_exact_trampoline_cps_call
		                 (fixpoint,
		                  function(schematic_self, cont){
		                   return caml_exact_trampoline_cps_call$1
		                           (find_packed_by_id,
		                            letrec_function_context[1][1],
		                            schematic_schema_version,
		                            function(match){
		                             if(! match)
		                              return caml_exact_trampoline_cps_call$0
		                                      (set$3,
		                                       letrec_function_context[1][1],
		                                       schematic_schema_version,
		                                       schematic_self,
		                                       function(b){
		letrec_function_context[1][1] = b;
		var
		 default$ = match$1117[1],
		 a =
		   [0,
		    [0,
		     0,
		     0,
		     0,
		     0,
		     cst_writable,
		     0,
		     [0, default$],
		     [0, bool_schema],
		     0,
		     0],
		    0];
		return caml_exact_trampoline_cps_call
		        (schema_versioned,
		         schematic_version,
		         function(b){
		          var
		           res =
		             [7,
		              function(param, cont){
		               var writable = param[2][1], type = param[1];
		               return cont([0, type, writable]);
		              },
		              function(param, cont){
		               var writable = param[2], type = param[1];
		               return cont([0, type, [0, writable, 0]]);
		              },
		              [0, [0, 0, 0, 0, 0, cst_type, 0, 2, [0, b], 0, 0], a]];
		          return caml_exact_trampoline_cps_call$0
		                  (set$3,
		                   letrec_function_context[1][1],
		                   schematic_schema_version,
		                   res,
		                   function(a){
		                    letrec_function_context[1][1] = a;
		                    return cont(res);
		                   });
		         });
		                                       });
		                             var schema = match[1];
		                             return cont(schema);
		                            });
		                  },
		                  a);
		        var schema = match[1];
		        return a(schema);
		       });
		                                     });
		                           }
		                           var schematic_cache = [0, empty$11([0, comparator$9])];
		                           caml_update_dummy(a, [0, schematic_cache]);
		                           var schematic_cache$0 = [0, empty$11([0, comparator$9])];
		                           caml_update_dummy
		                            (letrec_function_context, [0, schematic_cache$0]);
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned,
		                                    function(param, cont){return cont(0);},
		                                    function(graph_result_type_schema){
		                                     return caml_exact_trampoline_cps_call
		     (field_schema_versioned,
		      function(param, cont){return cont(0);},
		      function(field_schema){
		       var
		        graph_command_schema =
		          remote_value_schema("graph-command", side),
		        graph_query_schema =
		          remote_value_schema("graph-query", side);
		       function v(graph, workspace, cont){
		        return caml_exact_trampoline_cps_call
		                (databases,
		                 graph,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (get$17,
		                           a,
		                           function(all_databases){
		                            return caml_exact_trampoline_cps_call$1
		                                    (By$8[23],
		                                     all_databases,
		                                     workspace,
		                                     function(match){
		                                      if(match)
		                                       var dbs = match[1], workspace_databases = dbs;
		                                      else
		                                       workspace_databases = Table[27][104];
		                                      return caml_exact_trampoline_cps_call$0
		      (relation_targets,
		       graph[3],
		       workspace,
		       workspace_databases,
		       cont);
		                                     });
		                           });
		                 });
		       }
		       function schematic_version(param, cont){return cont(0);}
		       var
		        a = local_only(side, v),
		        workspace = [0, cst_workspace, schema$39, 0];
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$510,
		                schematic_version,
		                function(c){
		                 var
		                  relation_targets =
		                    call$4
		                     ("relation_targets",
		                      "Get the possible targets of a relation field.",
		                      [0, workspace, 0],
		                      [0, 0, 0, [3, c], 0],
		                      a);
		                 function v
		                 (graph,
		                  workspace,
		                  name,
		                  database_name,
		                  meta,
		                  type,
		                  description,
		                  cont){
		                  return caml_exact_trampoline_cps_call$8
		                          (add_database,
		                           graph,
		                           name,
		                           description,
		                           database_name,
		                           meta,
		                           workspace,
		                           type,
		                           function(a){
		                            return caml_trampoline_cps_call3
		                                    (symbol_map$29, a, of_string$0, cont);
		                           });
		                 }
		                 var b = local_only(side, v);
		                 return caml_exact_trampoline_cps_call$1
		                         (result_schema,
		                          Table[5],
		                          upsert_database_error_schema,
		                          function(c){
		                           var
		                            add =
		                              call_async
		                               (cst_add,
		                                "Add a database.",
		                                [0,
		                                 workspace,
		                                 [0,
		                                  [0, cst_type_name, schematic_param_name_schema_ve, 0],
		                                  [0,
		                                   [0, cst_database_name, schematic_param_name_schema_ve, 0],
		                                   [0,
		                                    [0, cst_meta, schema$58, 0],
		                                    [0,
		                                     [0, cst_type, schema$55, 0],
		                                     [0,
		                                      [0, cst_description, schematic_param_name_schema_ve, 0],
		                                      0]]]]]],
		                                c,
		                                b);
		                           function v(graph, workspace, id, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (get_database, graph, workspace, id, cont);
		                           }
		                           var a = local_only(side, v);
		                           function schematic_version(param, cont){return cont(0);}
		                           return caml_exact_trampoline_cps_call
		                                   (schema_versioned$501,
		                                    schematic_version,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (option_schema,
		      b,
		      function(c){
		       var
		        schema = Table[5],
		        get =
		          call_reactive
		           (cst_get$0,
		            "Get a database",
		            [0, workspace, [0, [0, cst_id, schema, 0], 0]],
		            c,
		            a);
		       function v(graph, cont){
		        return caml_exact_trampoline_cps_call
		                (databases, graph, cont);
		       }
		       var b = local_only(side, v);
		       function schematic_version(param, cont){return cont(0);}
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$501,
		                schematic_version,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (Table[27][102],
		                          schematic_version,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (By$8[102],
		                                    schematic_version,
		                                    a,
		                                    function(c){
		                                     var
		                                      list =
		call_reactive
		 (cst_list,
		  "List the existing table information, indexed by workspace ID, then by table ID.",
		  0,
		  c,
		  b);
		                                     function v(graph, cont){
		                                      return caml_trampoline_cps_call2(graph[6], 0, cont);
		                                     }
		                                     var a = local_only(side, v);
		                                     function schematic_version(param, cont){return cont(0);}
		                                     return caml_exact_trampoline_cps_call
		     (schema_versioned$501,
		      schematic_version,
		      function(b){
		       return caml_trampoline_cps_call3
		               (Table[27][102],
		                schematic_version,
		                b,
		                function(c){
		                 var
		                  list_personal =
		                    call_reactive
		                     ("list_personal",
		                      "List the existing personal table information, indexed by table ID.",
		                      0,
		                      c,
		                      a);
		                 function v(graph, param, cont){
		                  var table_id = param[2], workspace_id = param[1];
		                  return caml_exact_trampoline_cps_call
		                          (personal_workspace_id$0,
		                           graph,
		                           function(a){
		                            var workspace_id$0 = value$4(workspace_id, a);
		                            return caml_exact_trampoline_cps_call$0
		                                    (get_database, graph, workspace_id$0, table_id, cont);
		                           });
		                 }
		                 var b = local_only(side, v);
		                 function schematic_version(param, cont){return cont(0);}
		                 return caml_exact_trampoline_cps_call
		                         (schema_versioned$501,
		                          schematic_version,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (option_schema,
		                                    a,
		                                    function(a){
		                                     var
		                                      of_object =
		call_reactive
		 ("of_object",
		  "Get the database to which the given object belongs",
		  [0, [0, cst_object_id$0, schema$22, 0], 0],
		  a,
		  b);
		                                     function v(graph, workspace, id, cont){
		                                      return caml_trampoline_cps_call3
		      (graph[8], workspace, id, cont);
		                                     }
		                                     var
		                                      a = local_only(side, v),
		                                      schema = Table[5],
		                                      remove =
		call_async
		 (cst_remove,
		  "Remove a database",
		  [0, workspace, [0, [0, cst_id, schema, 0], 0]],
		  schematic_param_a_schema_versi,
		  a);
		                                     function v$0
		                                     (graph,
		                                      workspace,
		                                      table_id,
		                                      name,
		                                      database_name,
		                                      meta,
		                                      type,
		                                      description,
		                                      cont){
		                                      return caml_exact_trampoline_cps_call$9
		      (update_database,
		       graph,
		       workspace,
		       table_id,
		       name,
		       description,
		       database_name,
		       meta,
		       type,
		       function(a){
		        return caml_trampoline_cps_call3
		                (symbol_map$29, a, of_string$0, cont);
		       });
		                                     }
		                                     var c = local_only(side, v$0);
		                                     return caml_exact_trampoline_cps_call$1
		     (result_schema,
		      schematic_param_a_schema_versi,
		      upsert_database_error_schema,
		      function(b){
		       var
		        schema = Table[5],
		        update =
		          call_async
		           (cst_update,
		            "Update the schema of a given table",
		            [0,
		             workspace,
		             [0,
		              [0, cst_table_id, schema, 0],
		              [0,
		               [0, cst_type_name, schematic_param_name_schema_ve, 0],
		               [0,
		                [0, cst_database_name, schematic_param_name_schema_ve, 0],
		                [0,
		                 [0, cst_meta, schema$58, 0],
		                 [0,
		                  [0, cst_type, schema$55, 0],
		                  [0,
		                   [0, cst_description, schematic_param_name_schema_ve, 0],
		                   0]]]]]]],
		            b,
		            c);
		       function v(graph, cont){return cont(make$35());}
		       var
		        generate_column_id =
		          call$4
		           ("generate_column_id",
		            "Generate a column ID. Should only be used when adding a column to a custom type.",
		            0,
		            schema$50,
		            local_only(side, v));
		       function v$0(graph, workspace, kind, cont){
		        return caml_exact_trampoline_cps_call
		                (id_of,
		                 kind,
		                 function(id){
		                  return caml_exact_trampoline_cps_call$0
		                          (get_database, graph, workspace, id, cont);
		                 });
		       }
		       var a = local_only(side, v$0);
		       function schematic_version(param, cont){return cont(0);}
		       return caml_exact_trampoline_cps_call
		               (schema_versioned$501,
		                schematic_version,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (option_schema,
		                          b,
		                          function(c){
		                           var
		                            get$0 =
		                              call_reactive
		                               (cst_get$0,
		                                "Get a database corresponding to a default type",
		                                [0, workspace, [0, [0, cst_kind, kind_schema, 0], 0]],
		                                c,
		                                a),
		                            b =
		                              side
		                               ? 0
		                               : [0,
		                                 function(graph, workspace, command$0, vars, cont){
		                                  var
		                                   open =
		                                     o
		                                      ([0,
		symbol_bind$1,
		symbol_map$0,
		Let_syntax$0,
		,
		bind$1,
		of_string$0,
		map$5]),
		                                   let$ = open[4],
		                                   let$0 = open[3];
		                                  function a(command, cont){
		                                   function a(command, cont){return cont([1, command]);}
		                                   return caml_exact_trampoline_cps_call$2
		   (compile_command,
		    graph,
		    [0, vars],
		    workspace,
		    command,
		    function(b){
		     return caml_trampoline_cps_call3(let$, b, a, cont);
		    });
		                                  }
		                                  return caml_exact_trampoline_cps_call$1
		  (parse$0,
		   command,
		   command$0,
		   function(b){
		    return caml_trampoline_cps_call3(let$0, b, a, cont);
		   });
		                                 }];
		                           return caml_exact_trampoline_cps_call$1
		                                   (result_schema,
		                                    graph_command_schema,
		                                    schema$18,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call
		     (By_name[110],
		      schematic_param_a_schema_versi$0,
		      function(schema){
		       var
		        cst_compile = "compile",
		        compile =
		          call$4
		           (cst_compile,
		            "Compile graph command.",
		            [0,
		             workspace,
		             [0,
		              [0, cst_command, schematic_param_name_schema_ve, 0],
		              [0, [0, "vars", schema, 0], 0]]],
		            a,
		            b),
		        c =
		          side
		           ? 0
		           : [0,
		             function(param, command, cont){
		              var value = command[1];
		              return caml_exact_trampoline_cps_call
		                      (run_command_once,
		                       value,
		                       function(a){
		                        return caml_trampoline_cps_call3
		                                (symbol_map$29, a, of_string$0, cont);
		                       });
		             }];
		       return caml_exact_trampoline_cps_call$1
		               (result_schema,
		                schematic_param_a_schema_versi$0,
		                schema$18,
		                function(b){
		                 var
		                  run =
		                    call_async
		                     (cst_run,
		                      "Run graph command.",
		                      [0, [0, cst_command, graph_command_schema, 0], 0],
		                      b,
		                      c),
		                  a =
		                    side
		                     ? 0
		                     : [0,
		                       function(graph, workspace, query, vars, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (parse$0,
		                                 expression,
		                                 query,
		                                 function(e){
		                                  if(0 !== e[0])
		                                   return caml_exact_trampoline_cps_call(return$40, e, cont);
		                                  var query = e[1];
		                                  o
		                                   ([0,
		                                     symbol_bind$1,
		                                     symbol_map$0,
		                                     Let_syntax$0,
		                                     ,
		                                     bind$1,
		                                     of_string$0,
		                                     map$5]);
		                                  return caml_exact_trampoline_cps_call$2
		  (compile$0,
		   graph,
		   [0, vars],
		   workspace,
		   query,
		   function(query){
		    return cont
		            (map$53
		              (query,
		               function(value, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_string$0, [1, value], cont);
		               }));
		   });
		                                 });
		                       }];
		                 return caml_exact_trampoline_cps_call$1
		                         (result_schema,
		                          graph_query_schema,
		                          schema$18,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (By_name[110],
		                                    graph_variable_schema,
		                                    function(schema){
		                                     var
		                                      compile$0 =
		call_reactive
		 (cst_compile,
		  "Compile graph query.",
		  [0,
		   workspace,
		   [0,
		    [0, cst_query, schematic_param_name_schema_ve, 0],
		    [0, [0, "variables", schema, 0], 0]]],
		  b,
		  a),
		                                      c =
		side
		 ? 0
		 : [0,
		   function(param, raw_query, cont){
		    var value = raw_query[1];
		    if(0 !== value[0])
		     return caml_exact_trampoline_cps_call
		             (return$40, value, cont);
		    var query = value[1];
		    return caml_exact_trampoline_cps_call(run$4, query, cont);
		   }];
		                                     return caml_exact_trampoline_cps_call$1
		     (result_schema,
		      schematic_param_a_schema_versi$0,
		      schema$18,
		      function(b){
		       var
		        run$0 =
		          call_reactive
		           (cst_run,
		            "Run graph query.",
		            [0, [0, cst_query, graph_query_schema, 0], 0],
		            b,
		            c),
		        a =
		          side
		           ? 0
		           : [0,
		             function(param, raw_query, cont){
		              var value = raw_query[1];
		              if(0 !== value[0]) return cont(value);
		              var query = value[1], t = query[1];
		              return cont([0, t]);
		             }];
		       return caml_exact_trampoline_cps_call$1
		               (result_schema,
		                graph_result_type_schema,
		                schema$18,
		                function(c){
		                 var
		                  type =
		                    call$4
		                     (cst_type,
		                      "Result type of a graph query.",
		                      [0, [0, cst_query, graph_query_schema, 0], 0],
		                      c,
		                      a);
		                 function v(graph, id, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (get$31, graph, id, cont);
		                 }
		                 var b = local_only(side, v);
		                 return caml_exact_trampoline_cps_call
		                         (parametric_schema_versioned,
		                          function(param, cont){return cont(0);},
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (a,
		                                    schematic_param_a_schema_versi$0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (result_schema,
		      a,
		      schema$18,
		      function(c){
		       var
		        get$1 =
		          call_reactive
		           (cst_get$0,
		            "The value of the object.\n        Equivalent to the result of the query `<db_name>[<row_id>].`\n        ",
		            [0, [0, cst_id, schema$22, 0], 0],
		            c,
		            b);
		       function v(graph, id, cont){
		        return caml_exact_trampoline_cps_call$1
		                (display_value, graph, id, cont);
		       }
		       var a = local_only(side, v);
		       return caml_exact_trampoline_cps_call$1
		               (result_schema,
		                schematic_param_name_schema_ve,
		                schematic_param_name_schema_ve,
		                function(c){
		                 var
		                  display_value =
		                    call_reactive
		                     ("display_value",
		                      "The value of the `display_column` for that object. The `display_column` is currently hardcoded to `Title`",
		                      [0, [0, cst_id, schema$22, 0], 0],
		                      c,
		                      a);
		                 function v(param, id, cont){return cont(id);}
		                 var
		                  parse =
		                    call$4
		                     (cst_parse,
		                      "Parse an object id, turning its string representation into the compound one",
		                      [0, [0, cst_id, schema$22, 0], 0],
		                      object_id_schema,
		                      local_only(side, v));
		                 function v$0(param, id, cont){return cont(id);}
		                 var
		                  make =
		                    call$4
		                     (cst_make,
		                      "Build an object id. Reverse of `parse`",
		                      [0, [0, cst_id, object_id_schema, 0], 0],
		                      schema$22,
		                      local_only(side, v$0));
		                 function v$1(param, view, cont){
		                  return caml_exact_trampoline_cps_call
		                          (to_graph$5,
		                           view,
		                           function(a){
		                            return caml_exact_trampoline_cps_call$1
		                                    (to_to_string, pp_expression$0, a, cont);
		                           });
		                 }
		                 var
		                  to_query =
		                    call$4
		                     ("to_query",
		                      "Turn the given view configuration into a graph query",
		                      [0, [0, cst_view, schema$238, 0], 0],
		                      schematic_param_name_schema_ve,
		                      local_only(side, v$1));
		                 function v$2(graph, workspace, query, cont){
		                  return caml_exact_trampoline_cps_call$1
		                          (parse$0,
		                           expression,
		                           query,
		                           function(t){
		                            if(0 === t[0])
		                             var a = t;
		                            else
		                             var err = t[1], a = [1, [0, err]];
		                            return caml_exact_trampoline_cps_call$1
		                                    (bind$1,
		                                     a,
		                                     function(ast, cont){
		                                      return caml_trampoline_cps_call3
		      (graph[20],
		       workspace,
		       ast,
		       function(a){
		        return caml_exact_trampoline_cps_call$1
		                (of_incremental,
		                 0,
		                 a,
		                 function(a){
		                  return caml_exact_trampoline_cps_call(get$17, a, cont);
		                 });
		       });
		                                     },
		                                     cont);
		                           });
		                 }
		                 var b = local_only(side, v$2);
		                 return caml_exact_trampoline_cps_call$1
		                         (result_schema,
		                          schema$243,
		                          schema$240,
		                          function(a){
		                           var
		                            of_query =
		                              call$4
		                               ("of_query",
		                                "Return the view configuration corresponding to the given graph query",
		                                [0,
		                                 workspace,
		                                 [0, [0, cst_query, schematic_param_name_schema_ve, 0], 0]],
		                                a,
		                                b);
		                           return cont
		                                   ([0,
		                                     [0, cst_command, [0, compile, [0, run, 0]]],
		                                     [0,
		                                      [0,
		                                       cst_database,
		                                       [0,
		add,
		[0,
		 [0, "default_types", [0, get$0, 0]],
		 [0,
		  generate_column_id,
		  [0,
		   get,
		   [0,
		    list,
		    [0,
		     list_personal,
		     [0, of_object, [0, remove, [0, update, 0]]]]]]]]]],
		                                      [0,
		                                       relation_targets,
		                                       [0,
		[0,
		 cst_object,
		 [0,
		  display_value,
		  [0, get$1, [0, [0, cst_id, [0, make, [0, parse, 0]]], 0]]]],
		[0,
		 [0, cst_query, [0, compile$0, [0, run$0, [0, type, 0]]]],
		 [0, [0, cst_view, [0, of_query, [0, to_query, 0]]], 0]]]]]]);
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (fixpoint,
		                                    function(schematic_self, cont){
		                                     return caml_exact_trampoline_cps_call$1
		     (find_packed_by_id,
		      letrec_function_context[1][1],
		      schematic_schema_version,
		      function(match){
		       if(! match)
		        return caml_exact_trampoline_cps_call$0
		                (set$3,
		                 letrec_function_context[1][1],
		                 schematic_schema_version,
		                 schematic_self,
		                 function(b){
		                  letrec_function_context[1][1] = b;
		                  var
		                   a =
		                     [0,
		                      [0,
		                       function(f0, cont){return cont([2, f0]);},
		                       function(param, cont){
		                        if(2 !== param[0]) return cont(0);
		                        var f0 = param[1];
		                        return cont([0, f0]);
		                       },
		                       1,
		                       0,
		                       cst_const,
		                       cst_Const,
		                       [0,
		                        0,
		                        0,
		                        [7,
		                         function(param, cont){
		                          var value = param[1];
		                          return cont(value);
		                         },
		                         function(value, cont){return cont([0, value, 0]);},
		                         [0,
		                          [0,
		                           0,
		                           0,
		                           0,
		                           0,
		                           cst_value,
		                           0,
		                           2,
		                           [0, schematic_param_a_schema_versi$0],
		                           0,
		                           0],
		                          0]],
		                        0],
		                       0],
		                      0];
		                  return caml_exact_trampoline_cps_call
		                          (var_schema,
		                           schematic_param_name_schema_ve,
		                           function(c){
		                            var
		                             b =
		                               [0,
		                                [0,
		                                 function(f0, cont){return cont([1, f0]);},
		                                 function(param, cont){
		                                  if(1 !== param[0]) return cont(0);
		                                  var f0 = param[1];
		                                  return cont([0, f0]);
		                                 },
		                                 1,
		                                 0,
		                                 cst_string,
		                                 cst_String,
		                                 [0,
		                                  0,
		                                  0,
		                                  [7,
		                                   function(param, cont){
		                                    var value = param[1];
		                                    return cont(value);
		                                   },
		                                   function(value, cont){return cont([0, value, 0]);},
		                                   [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, c], 0, 0], 0]],
		                                  0],
		                                 0],
		                                a];
		                            return caml_exact_trampoline_cps_call
		                                    (var_schema,
		                                     schema$5,
		                                     function(a){
		                                      var
		                                       res =
		 [11,
		  bL9,
		  [0,
		   [0,
		    function(f0, cont){return cont([0, f0]);},
		    function(param, cont){
		     if(0 !== param[0]) return cont(0);
		     var f0 = param[1];
		     return cont([0, f0]);
		    },
		    1,
		    0,
		    cst_date,
		    cst_Date,
		    [0,
		     0,
		     0,
		     [7,
		      function(param, cont){
		       var value = param[1];
		       return cont(value);
		      },
		      function(value, cont){return cont([0, value, 0]);},
		      [0, [0, 0, 0, 0, 0, cst_value, 0, 2, [0, a], 0, 0], 0]],
		     0],
		    0],
		   b],
		  0];
		                                      return caml_exact_trampoline_cps_call$0
		      (set$3,
		       letrec_function_context[1][1],
		       schematic_schema_version,
		       res,
		       function(a){
		        letrec_function_context[1][1] = a;
		        return cont(res);
		       });
		                                     });
		                           });
		                 });
		       var schema = match[1];
		       return cont(schema);
		      });
		                                    },
		                                    a);
		                          var schema = match[1];
		                          return a(schema);
		                         });
		               }
		               var
		                open$46 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$68 = open$46[3],
		                let$69 = open$46[4],
		                let$70 = open$46[14];
		               function get$37(param){}
		               var
		                include$327 =
		                  caml_callback
		                   (Make_object,
		                    [[0,
		                      ,
		                      [0, , , , [0, pp$79]],
		                      ,
		                      notes$7,
		                      with_notes$0,
		                      ,
		                      ,
		                      cst_event_recurrent$0,
		                      lookup],
		                     [0, get$37]]),
		                Logs$20 = include$327[1],
		                get$38 = include$327[3];
		               function timezone$0(param, cont){
		                return caml_exact_trampoline_cps_call
		                        (of_timmy,
		                         timezone_local,
		                         function(t){
		                          function a(a){
		                           return caml_exact_trampoline_cps_call
		                                   (ok_or_failwith, a, cont);
		                          }
		                          if(0 === t[0]) return a(t);
		                          var x = t[1], tz = x[2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$302,
		                                   function(b){
		                                    return caml_trampoline_cps_call2
		    (b, tz, function(b){return a([1, b]);});
		                                   });
		                         });
		               }
		               function create$56(ctrl, crdt, creation, cont){
		                var id = make$48();
		                return caml_exact_trampoline_cps_call
		                        (Logs$20[6][5],
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_creation, creation, creation_schema$0), 0],
		                                   function(a){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, a], bMi, pp$79, id, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_connection,
		                                   ctrl,
		                                   creation[1],
		                                   function(connection){
		                                    return caml_exact_trampoline_cps_call
		    (create_events_as,
		     connection,
		     function(creator){
		      return caml_exact_trampoline_cps_call
		              (timezone$0,
		               dummy,
		               function(timezone){
		                var
		                 creator$0 = [0, creator],
		                 writable = creation[3],
		                 draft = creation[2],
		                 calendar = creation[1],
		                 title = writable[10],
		                 recurrence = writable[9],
		                 notes = writable[8],
		                 location = writable[7],
		                 exceptions = writable[6],
		                 description = writable[5],
		                 daytime = writable[4],
		                 availability_override = writable[3],
		                 attendees = writable[2],
		                 attendance = writable[1];
		                return caml_trampoline_cps_call3
		                        (g
		                           ([0,
		                             symbol_bind$5,
		                             symbol_map$5,
		                             ,
		                             bind$8,
		                             return$9,
		                             map$17,
		                             ,
		                             ,
		                             ,
		                             ,
		                             Let_syntax$3])
		                          [3],
		                         daytime,
		                         function(time, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (of_time$3, timezone, time, cont);
		                         },
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (add$36,
		                                   [0,
		                                    calendar,
		                                    creator$0,
		                                    draft,
		                                    0,
		                                    id,
		                                    0,
		                                    [0,
		                                     attendance,
		                                     attendees,
		                                     availability_override,
		                                     a,
		                                     description,
		                                     exceptions,
		                                     location,
		                                     notes,
		                                     recurrence,
		                                     title]],
		                                   function(crdt_op){
		                                    return caml_exact_trampoline_cps_call$0
		    (apply_personal,
		     ctrl[1],
		     crdt,
		     crdt_op,
		     function(match){return cont(id);});
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function get$39(ctrl, id, cont){
		                return caml_exact_trampoline_cps_call$1
		                        (get_event_recurrent$1,
		                         ctrl[2],
		                         id,
		                         function(match){
		                          if(! match)
		                           return caml_exact_trampoline_cps_call
		                                   (Logs$20[6][3],
		                                    function(m, cont){
		                                     return caml_exact_trampoline_cps_call
		     (attrs,
		      [0, attr$0(cst_id, id, schema$91), 0],
		      function(a){
		       return caml_trampoline_cps_call4(m, 0, [0, a], bMj, cont);
		      });
		                                    },
		                                    function(a){return cont([1, a]);});
		                          var event = match[1];
		                          return cont([0, event]);
		                         });
		               }
		               function delete$5(ctrl, crdt, id, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$20[6][5],
		                         function(m, cont){
		                          return caml_trampoline_cps_call6
		                                  (m, 0, 0, bMk, pp$79, id, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get$39,
		                                   ctrl,
		                                   id,
		                                   function(v){
		                                    if(0 === v[0]){
		                                     var event = v[1], time = ocaml_ptime_clock_now_d_ps();
		                                     return caml_exact_trampoline_cps_call
		     (state_personal,
		      ctrl[2],
		      function(state){
		       return caml_exact_trampoline_cps_call
		               (today,
		                dummy,
		                function(date){
		                 var
		                  open =
		                    g
		                     ([0,
		                       symbol_bind$22,
		                       symbol_map$20,
		                       ,
		                       bind$30,
		                       return$39,
		                       map$50,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$14]),
		                  and = open[6],
		                  let$ = open[4];
		                 function a(param, cont){return cont(0);}
		                 return caml_trampoline_cps_call2
		                         (remove$10,
		                          id,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (events_recurrent,
		                                    b,
		                                    function(left){
		                                     function remove_occurrence(param, cont){
		                                      var occurrence = param[1];
		                                      return caml_exact_trampoline_cps_call$2
		      (remove$23, date, state, time, occurrence[6], cont);
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (materialized_occurrences,
		      state,
		      id,
		      function(b){
		       return caml_exact_trampoline_cps_call$1
		               (filter_map$1,
		                b,
		                remove_occurrence,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (to_binable,
		                          b,
		                          function(b){
		                           return caml_exact_trampoline_cps_call
		                                   (all_unit$27,
		                                    b,
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (and,
		      left,
		      b,
		      function(b){
		       return caml_trampoline_cps_call3
		               (let$,
		                b,
		                a,
		                function(a){
		                 return caml_exact_trampoline_cps_call$0
		                         (apply_personal,
		                          ctrl[1],
		                          crdt,
		                          a,
		                          function(a){
		                           var
		                            workspace_id = personal_workspace_id(ctrl[2]),
		                            a = object$0([1, event[5]], workspace_id, source, 1);
		                           return caml_exact_trampoline_cps_call$0
		                                   (push_dont_wait$0,
		                                    ctrl[11],
		                                    0,
		                                    a,
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call$0
		     (notify$0(ctrl),
		      0,
		      0,
		      [0, [1, event], a_c],
		      function(match){return cont(0);});
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var v$0 = v[1];
		                                    return cont(v$0);
		                                   });
		                         });
		               }
		               function update$20(ctrl, crdt, patch, source, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$20[6][5],
		                         function(m, cont){
		                          var a = patch[1];
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_patch, patch[2], schema$92), 0],
		                                   function(b){
		                                    return caml_trampoline_cps_call6
		    (m, 0, [0, b], bMl, pp$79, a, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get$39,
		                                   ctrl,
		                                   patch[1],
		                                   function(v$0){
		                                    if(0 === v$0[0]){
		                                     var
		                                      event = v$0[1],
		                                      init = patch[2],
		                                      a = init[10],
		                                      b = init[9],
		                                      c = init[8],
		                                      d = init[7],
		                                      e = init[6],
		                                      f = init[5],
		                                      g = init[4],
		                                      h = init[3];
		                                     return caml_exact_trampoline_cps_call$2
		     (add_self_to_attendees,
		      ctrl,
		      event[1],
		      event[7][2],
		      patch[2][2],
		      function(i){
		       var
		        patch$0 =
		          [0, patch[1], [0, init[1], i, h, g, f, e, d, c, b, a]];
		       return caml_exact_trampoline_cps_call
		               (state_personal,
		                ctrl[2],
		                function(a){
		                 var t = ocaml_ptime_clock_now_d_ps();
		                 return caml_exact_trampoline_cps_call
		                         (today,
		                          dummy,
		                          function(b){
		                           return caml_exact_trampoline_cps_call$2
		                                   (update$11,
		                                    b,
		                                    t,
		                                    a,
		                                    patch$0,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$0
		     (apply_personal,
		      ctrl[1],
		      crdt,
		      a,
		      function(b){
		       var patch = patch$0[2];
		       function a(notif){
		        var msg = [0, [1, event], notif];
		        return caml_exact_trampoline_cps_call$0
		                (notify$0(ctrl),
		                 0,
		                 0,
		                 msg,
		                 function(match){return cont(0);});
		       }
		       if(! patch[10]) return a(a_f);
		       var
		        id = event[5],
		        workspace_id = personal_workspace_id(ctrl[2]),
		        b = object$0([1, id], workspace_id, source, [0, cst_title]);
		       return caml_exact_trampoline_cps_call$0
		               (push_dont_wait$0,
		                ctrl[11],
		                0,
		                b,
		                function(b){return a(a_e);});
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var v = v$0[1];
		                                    return cont(v);
		                                   });
		                         });
		               }
		               function stop(ctrl, crdt, id, date, cont){
		                return caml_exact_trampoline_cps_call
		                        (Logs$20[6][5],
		                         function(m, cont){
		                          var a = [0, attr$0(cst_event, id, schema$91), 0];
		                          return caml_exact_trampoline_cps_call
		                                  (attrs,
		                                   [0, attr$0(cst_date, date, schema$5), a],
		                                   function(a){
		                                    return caml_trampoline_cps_call4(m, 0, [0, a], bMm, cont);
		                                   });
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$1
		                                  (get$39,
		                                   ctrl,
		                                   id,
		                                   function(v){
		                                    if(0 === v[0]){
		                                     var event = v[1], now = ocaml_ptime_clock_now_d_ps();
		                                     return caml_exact_trampoline_cps_call$1
		     (add_days,
		      date,
		      -1,
		      function(last_date){
		       var match = event[7][9][1];
		       if(0 === match[0])
		        var
		         start = match[1],
		         boundaries = [1, [0, last_date], start];
		       else
		        boundaries = [1, [0, last_date], match[2]];
		       var
		        a =
		          [0,
		           id,
		           [0,
		            empty$26[1],
		            empty$26[2],
		            empty$26[3],
		            empty$26[4],
		            empty$26[5],
		            empty$26[6],
		            empty$26[7],
		            empty$26[8],
		            [0, [0, boundaries, event[7][9][2]]],
		            empty$26[10]]];
		       return caml_exact_trampoline_cps_call
		               (state_personal,
		                ctrl[2],
		                function(b){
		                 return caml_exact_trampoline_cps_call$2
		                         (update$11,
		                          date,
		                          now,
		                          b,
		                          a,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$0
		                                   (apply_personal,
		                                    ctrl[1],
		                                    crdt,
		                                    a,
		                                    function(match){
		                                     return caml_exact_trampoline_cps_call$0
		     (notify$0(ctrl),
		      0,
		      0,
		      [0, [1, event], a_d],
		      function(match){return cont(0);});
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    var v$0 = v[1];
		                                    return cont(v$0);
		                                   });
		                         });
		               }
		               function update_this_and_following
		               (ctrl, crdt, occurrence_id, occurrence_patch, cont){
		                var b = g(include$0), c = b[17], a = b[14];
		                if(0 === occurrence_id[0])
		                 return caml_exact_trampoline_cps_call
		                         (fail_result,
		                          bMr,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a, pp$35, occurrence_id, cont);
		                          });
		                var date = occurrence_id[2], recurrence = occurrence_id[1];
		                return is_empty$10(occurrence_patch)
		                        ? cont([0, recurrence])
		                        : caml_exact_trampoline_cps_call
		                          (Logs$20[6][5],
		                           function(m, cont){
		                            var
		                             a = [0, attr$0(cst_event, occurrence_patch, schema$89), 0];
		                            return caml_exact_trampoline_cps_call
		                                    (attrs,
		                                     [0, attr$0(cst_date, date, schema$5), a],
		                                     function(a){
		                                      return caml_trampoline_cps_call6
		      (m, 0, [0, a], bMn, pp$35, occurrence_id, cont);
		                                     });
		                           },
		                           function(match){
		                            return caml_exact_trampoline_cps_call
		                                    (state_writable_personal,
		                                     crdt,
		                                     function(replica){
		                                      function b(occurrence, cont){
		                                       function b(previous, cont){
		var dest = value$4(occurrence_patch[10], occurrence[9][10]);
		function b(new_event, cont){
		 function a(patch, cont){
		  var event = patch$3(new_event, patch);
		  return caml_exact_trampoline_cps_call$2
		          (stop,
		           ctrl,
		           crdt,
		           recurrence,
		           date,
		           function(match){
		            return caml_exact_trampoline_cps_call
		                    (Logs$20[6][6],
		                     function(m, cont){
		                      return caml_exact_trampoline_cps_call
		                              (attrs,
		                               [0, attr$0(cst_event, event, schema$95), 0],
		                               function(a){
		                                return caml_trampoline_cps_call4(m, 0, [0, a], bMo, cont);
		                               });
		                     },
		                     function(match){
		                      return caml_exact_trampoline_cps_call
		                              (add$36,
		                               event,
		                               function(op){
		                                return caml_exact_trampoline_cps_call$0
		(apply_personal,
		 ctrl[1],
		 crdt,
		 op,
		 function(match){return cont(event[5]);});
		                               });
		                     });
		           });
		 }
		 return caml_exact_trampoline_cps_call
		         (timezone$0,
		          dummy,
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (of_occurrence,
		                    b,
		                    occurrence_patch,
		                    function(t){
		                     if(0 === t[0])
		                      var b = t;
		                     else
		                      var x = t[1], b = [1, [0, 9943782, x]];
		                     return caml_exact_trampoline_cps_call$1(c, b, a, cont);
		                    });
		          });
		}
		function d(event, cont){
		 var a = event[7], b = event[6], c = make$48();
		 return cont([0, event[1], event[2], event[3], 0, c, b, a]);
		}
		var e = occurrence[9][10];
		return caml_exact_trampoline_cps_call
		        (timezone$0,
		         dummy,
		         function(f){
		          return caml_exact_trampoline_cps_call$2
		                  (translate$0,
		                   previous,
		                   f,
		                   e,
		                   dest,
		                   function(t){
		                    if(0 === t[0])
		                     var e = t;
		                    else
		                     var x = t[1], e = [1, [0, 9943782, x]];
		                    return caml_exact_trampoline_cps_call$1
		                            (c,
		                             e,
		                             d,
		                             function(c){
		                              return caml_exact_trampoline_cps_call$1(a, c, b, cont);
		                             });
		                   });
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (get_event_recurrent$0,
		        replica,
		        recurrence,
		        function(match){
		         function c(c){
		          return caml_exact_trampoline_cps_call$1(a, c, b, cont);
		         }
		         if(! match)
		          return caml_exact_trampoline_cps_call
		                  (fail_result,
		                   bMp,
		                   function(a){
		                    return caml_trampoline_cps_call3(a, pp$79, recurrence, c);
		                   });
		         var ev = match[1];
		         return c([0, ev]);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (get_event$0,
		       replica,
		       occurrence_id,
		       function(match){
		        function c(c){
		         return caml_exact_trampoline_cps_call$1(a, c, b, cont);
		        }
		        if(! match)
		         return caml_exact_trampoline_cps_call
		                 (fail_result,
		                  bMq,
		                  function(a){
		                   return caml_trampoline_cps_call3(a, pp$35, occurrence_id, c);
		                  });
		        var ev = match[1];
		        return c([0, ev]);
		       });
		                                     });
		                           });
		               }
		               function update_all
		               (ctrl, crdt, occurrence_id, occurrence_patch, cont){
		                var b = g(include$0), a = b[14], c = b[17];
		                if(0 === occurrence_id[0])
		                 return caml_exact_trampoline_cps_call
		                         (fail_result,
		                          bMx,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (a, pp$35, occurrence_id, cont);
		                          });
		                var date_id = occurrence_id[2], recurrence = occurrence_id[1];
		                return is_empty$10(occurrence_patch)
		                        ? cont(bMs)
		                        : caml_exact_trampoline_cps_call
		                          (Logs$20[6][5],
		                           function(m, cont){
		                            var
		                             a = [0, attr$0(cst_event, occurrence_patch, schema$89), 0];
		                            return caml_exact_trampoline_cps_call
		                                    (attrs,
		                                     [0, attr$0(cst_date, date_id, schema$5), a],
		                                     function(a){
		                                      return caml_trampoline_cps_call6
		      (m, 0, [0, a], bMt, pp$35, occurrence_id, cont);
		                                     });
		                           },
		                           function(match){
		                            return caml_exact_trampoline_cps_call
		                                    (state_writable_personal,
		                                     crdt,
		                                     function(replica){
		                                      function b(previous, cont){
		                                       function b(occurrence, cont){
		var match = occurrence_patch[10];
		function d(event, cont){
		 function a(patch, cont){
		  var event$0 = patch$3(event, patch);
		  return caml_exact_trampoline_cps_call
		          (Logs$20[6][6],
		           function(m, cont){
		            return caml_exact_trampoline_cps_call
		                    (attrs,
		                     [0, attr$0(cst_event, event$0, schema$95), 0],
		                     function(a){
		                      return caml_trampoline_cps_call4(m, 0, [0, a], bMu, cont);
		                     });
		           },
		           function(match){
		            var t = ocaml_ptime_clock_now_d_ps();
		            return caml_exact_trampoline_cps_call
		                    (today,
		                     dummy,
		                     function(a){
		                      return caml_exact_trampoline_cps_call$2
		                              (upsert$2,
		                               a,
		                               replica,
		                               t,
		                               event$0,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$0
		(apply_personal,
		 ctrl[1],
		 crdt,
		 a,
		 function(match){return cont(0);});
		                               });
		                     });
		           });
		 }
		 return caml_exact_trampoline_cps_call
		         (timezone$0,
		          dummy,
		          function(b){
		           return caml_exact_trampoline_cps_call$1
		                   (of_occurrence,
		                    b,
		                    occurrence_patch,
		                    function(t){
		                     if(0 === t[0])
		                      var b = t;
		                     else
		                      var x = t[1], b = [1, [0, 9943782, x]];
		                     return caml_exact_trampoline_cps_call$1(c, b, a, cont);
		                    });
		          });
		}
		function b(b){
		 return caml_exact_trampoline_cps_call$1(a, b, d, cont);
		}
		if(! match) return b([0, previous]);
		var
		 time_patch = match[1],
		 start_date = start_date$0(previous[7][9]);
		return caml_exact_trampoline_cps_call$1
		        (equal$21,
		         date_id,
		         start_date,
		         function(c){
		          if(! c) return b([0, previous]);
		          var a = occurrence[9][10];
		          return caml_exact_trampoline_cps_call
		                  (timezone$0,
		                   dummy,
		                   function(c){
		                    return caml_exact_trampoline_cps_call$2
		                            (translate$0,
		                             previous,
		                             c,
		                             a,
		                             time_patch,
		                             function(t){
		                              if(0 === t[0]) return b(t);
		                              var x = t[1];
		                              return b([1, [0, 9943782, x]]);
		                             });
		                   });
		         });
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (get_event$0,
		        replica,
		        occurrence_id,
		        function(match){
		         function c(c){
		          return caml_exact_trampoline_cps_call$1(a, c, b, cont);
		         }
		         if(! match)
		          return caml_exact_trampoline_cps_call
		                  (fail_result,
		                   bMv,
		                   function(a){
		                    return caml_trampoline_cps_call3(a, pp$35, occurrence_id, c);
		                   });
		         var ev = match[1];
		         return c([0, ev]);
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call$1
		      (get_event_recurrent$0,
		       replica,
		       recurrence,
		       function(match){
		        function c(c){
		         return caml_exact_trampoline_cps_call$1(a, c, b, cont);
		        }
		        if(! match)
		         return caml_exact_trampoline_cps_call
		                 (fail_result,
		                  bMw,
		                  function(a){
		                   return caml_trampoline_cps_call3(a, pp$79, recurrence, c);
		                  });
		        var previous = match[1];
		        return c([0, previous]);
		       });
		                                     });
		                           });
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               function drop_errors(ctrl, action, res){
		                var
		                 a =
		                   g
		                     ([0,
		                       symbol_bind$8,
		                       symbol_map$6,
		                       ,
		                       bind$10,
		                       return$12,
		                       map$23,
		                       ,
		                       ,
		                       ,
		                       ,
		                       Let_syntax$4])
		                    [4];
		                return function(res$0, cont){
		                 if(0 !== res$0[0]){
		                  var match = res$0[1], variant = match[1];
		                  if(-438114087 > variant){
		                   var
		                    id = match[2],
		                    b =
		                      function(param, cont){
		                       return caml_exact_trampoline_cps_call
		                               (warn$4(ctrl),
		                                bMy,
		                                function(a){
		                                 return caml_trampoline_cps_call4
		 (a,
		  action,
		  pp$2,
		  id,
		  function(match){
		   return caml_trampoline_cps_call2(of_string$14, res, cont);
		  });
		                                });
		                      };
		                   return caml_exact_trampoline_cps_call
		                           (Lwt[3],
		                            function(m, cont){
		                             return caml_trampoline_cps_call5(m, 0, 0, bMz, action, cont);
		                            },
		                            function(c){
		                             return caml_trampoline_cps_call3(a, c, b, cont);
		                            });
		                  }
		                 }
		                 return caml_trampoline_cps_call2(return$12, res$0, cont);};
		               }
		               function rpcs$3(param, side, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[23],
		                 let$0 = open[4],
		                 let$1 = open[3];
		                function v(ctrl, name, allocation, source, cont){
		                 function a(crdt, cont){
		                  function a(param, cont){var id = param[6]; return cont(id);}
		                  return caml_exact_trampoline_cps_call$3
		                          (allocate$2,
		                           ctrl,
		                           crdt,
		                           name,
		                           allocation,
		                           source,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$1, b, a, cont);
		                          });
		                }
		                var
		                 a = local_only(side, v),
		                 event_id = [0, cst_id, schema$263, 0],
		                 event_rec_id = [0, cst_id, schema$91, 0],
		                 source = [0, cst_source, source_schema, 0];
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         schema$263,
		                         function(c){
		                          var
		                           allocate =
		                             call_async
		                              (cst_allocate,
		                               "Find a free slot to create an event.",
		                               [0,
		                                [0, cst_name, schematic_param_name_schema_ve, 0],
		                                [0,
		                                 [0, cst_allocation, action_allocation_schema, 0],
		                                 [0, source, 0]]],
		                               c,
		                               a);
		                          function v(ctrl, id, source, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$2
		                                    (complete$1,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     source,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (drop_errors(ctrl, cst_complete, 0), a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$1, b, a, cont);
		                                    });
		                          }
		                          var
		                           complete =
		                             call_async
		                              (cst_complete,
		                               "Complete an event.",
		                               [0, event_id, [0, source, 0]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v));
		                          function v$0(ctrl, event, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (create$50,
		                                     ctrl,
		                                     crdt,
		                                     event,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                    });
		                          }
		                          var
		                           create =
		                             call_async
		                              (cst_create,
		                               "Add an event.",
		                               [0, [0, cst_event, creation_schema, 0], 0],
		                               schema$263,
		                               local_only(side, v$0));
		                          function v$1(ctrl, id, send_updates, source, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$2
		                                    (delete$3,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     source,
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (drop_errors(ctrl, cst_delete, 0), a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$1, b, a, cont);
		                                    });
		                          }
		                          var
		                           cst_send_updates = "send_updates",
		                           delete$ =
		                             call_async
		                              (cst_delete,
		                               "Delete an event.",
		                               [0,
		                                event_id,
		                                [0, [0, cst_send_updates, bool_schema, 0], [0, source, 0]]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v$1));
		                          function v$2(ctrl, emails, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (of_list$2,
		                                    [0, comparator$2],
		                                    emails,
		                                    function(attendees){
		                                     return caml_exact_trampoline_cps_call
		     (profiles,
		      ctrl[9],
		      function(a){
		       return caml_exact_trampoline_cps_call$2
		               (to_sequence$2,
		                0,
		                0,
		                0,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (map$11,
		                          a,
		                          function(param, cont){
		                           var email = param[2][1];
		                           return caml_exact_trampoline_cps_call
		                                   (to_string$51,
		                                    email,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (add$4, attendees, a, cont);
		                                    });
		                          },
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_binable,
		                                    a,
		                                    function(possible_sets){
		                                     return caml_exact_trampoline_cps_call$1
		     (with_attendees, ctrl, possible_sets, cont);
		                                    });
		                          });
		                });
		      });
		                                    });
		                          }
		                          function schematic_version(param, cont){return cont(0);}
		                          var b = local_only(side, v$2);
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$230,
		                                   schematic_version,
		                                   function(a){
		                                    var
		                                     find_with_attendees =
		                                       call$4
		("find_with_attendees",
		 "Events with the given attendees.",
		 [0,
		  [0,
		   cst_emails,
		   [0, 0, 0, [3, schematic_param_name_schema_ve], 0],
		   0],
		  0],
		 [0, 0, 0, [3, a], 0],
		 b);
		                                    function v(ctrl, day, filter, secondary, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (day$1(ctrl), 1 - secondary, filter, day, cont);
		                                    }
		                                    var
		                                     a = local_only(side, v),
		                                     day =
		                                       call_reactive
		(cst_day,
		 "The events on a given day.",
		 [0,
		  [0, cst_date, schema$5, 0],
		  [0,
		   [0, cst_filter, schema$247, 0],
		   [0, [0, cst_secondary, bool_schema, 0], 0]]],
		 list_schema(schema$263),
		 a);
		                                    function v$0(ctrl, days, filter, secondary, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (days$2(ctrl), 1 - secondary, filter, days, cont);
		                                    }
		                                    var
		                                     a = local_only(side, v$0),
		                                     c = list_schema(schema$263),
		                                     schema = list_schema(schema$5),
		                                     days =
		                                       call_reactive
		(cst_days$0,
		 "The events on a given set of days.",
		 [0,
		  [0, cst_dates, schema, 0],
		  [0,
		   [0, cst_filter, schema$247, 0],
		   [0, [0, cst_secondary, bool_schema, 0], 0]]],
		 c,
		 a),
		                                     a = local_only(side, tasks$0),
		                                     tasks =
		                                       call$4
		(cst_tasks,
		 "Tasks inside an event notes",
		 [0, event_id, 0],
		 list_schema(augmented_schema),
		 a),
		                                     a = local_only(side, timeline$0),
		                                     timeline =
		                                       call_reactive
		("timeline",
		 "Agenda view for a day.",
		 [0, [0, cst_date, schema$5, 0], 0],
		 list_schema(event_or_pause_schema),
		 a);
		                                    function v$1(ctrl, patch, send_updates, source, cont){
		                                     function a(crdt, cont){
		                                      return caml_exact_trampoline_cps_call$2
		      (update$15,
		       ctrl,
		       crdt,
		       patch,
		       source,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (drop_errors(ctrl, cst_update, 0), a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$1, b, a, cont);
		      });
		                                    }
		                                    var
		                                     update =
		                                       call_async
		(cst_update,
		 "Patch an event.",
		 [0,
		  [0, cst_patch, patch_schema$0, 0],
		  [0, [0, cst_send_updates, bool_schema, 0], [0, source, 0]]],
		 schematic_param_a_schema_versi,
		 local_only(side, v$1));
		                                    function v$2(ctrl, id, will_attend, source, cont){
		                                     function a(crdt, cont){
		                                      return caml_exact_trampoline_cps_call$3
		      (set_will_attend$0,
		       ctrl,
		       crdt,
		       id,
		       will_attend,
		       source,
		       function(a){
		        return caml_exact_trampoline_cps_call
		                (drop_errors(ctrl, cst_set_will_attend, 0), a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$1, b, a, cont);
		      });
		                                    }
		                                    var e = local_only(side, v$2), d = [0, source, 0];
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     yes_no_maybe_schema,
		     function(schema){
		      var
		       set_will_attend =
		         call_async
		          (cst_set_will_attend,
		           "Patch an event's attendance.",
		           [0, event_id, [0, [0, cst_will_attend, schema, 0], d]],
		           schematic_param_a_schema_versi,
		           e);
		      function v
		      (ctrl, id, dst_calendar_id, send_updates, source, cont){
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call$3
		                (move$5,
		                 ctrl,
		                 crdt,
		                 id,
		                 dst_calendar_id,
		                 source,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (drop_errors(ctrl, cst_move, 0), a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3(let$1, b, a, cont);
		                });
		      }
		      var
		       move =
		         call_async
		          (cst_move,
		           "Move an event to another calendar.",
		           [0,
		            event_id,
		            [0,
		             [0, "dst_calendar_id", schema$11, 0],
		             [0, [0, cst_send_updates, bool_schema, 0], [0, source, 0]]]],
		           schematic_param_a_schema_versi,
		           local_only(side, v)),
		       a = local_only(side, get$25);
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (augmented_schema_versioned$0,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         b,
		                         function(b){
		                          var
		                           get =
		                             call_reactive
		                              (cst_get$0, "An event.", [0, event_id, 0], b, a);
		                          function v(ctrl, id, send_updates, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (publish,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                    });
		                          }
		                          var
		                           publish$0 =
		                             call_async
		                              ("publish",
		                               "Make a draft event definitive.",
		                               [0, event_id, [0, [0, cst_send_updates, bool_schema, 0], 0]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v)),
		                           with_notes =
		                             call_reactive
		                              ("with_notes",
		                               "Events with note in antechronological order.",
		                               0,
		                               [0, 0, 0, [3, schema$263], 0],
		                               local_only(side, with_notes$5)),
		                           b = local_only(side, with_same_attendees),
		                           with_same_attendees$0 =
		                             call$4
		                              ("with_same_attendees",
		                               "Events with the same set of attendees as the given event.",
		                               [0, event_id, 0],
		                               list_schema(schema$90),
		                               b);
		                          function v$0(ctrl, event, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (create$56,
		                                     ctrl,
		                                     crdt,
		                                     event,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                    });
		                          }
		                          var
		                           create$0 =
		                             call_async
		                              (cst_create,
		                               "Add a recurring event.",
		                               [0, [0, cst_event, creation_schema$0, 0], 0],
		                               schema$91,
		                               local_only(side, v$0));
		                          function v$1(ctrl, id, source, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$2
		                                    (delete$5,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     source,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$0, b, a, cont);
		                                    });
		                          }
		                          var
		                           delete$0 =
		                             call_async
		                              (cst_delete,
		                               "Delete a recurrent event.",
		                               [0, event_rec_id, [0, source, 0]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v$1)),
		                           c = local_only(side, get$38);
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$239,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(b){
		      var
		       get$0 =
		         call_reactive
		          (cst_get$0,
		           "Get a recurring event.",
		           [0, [0, cst_id, schema$91, 0], 0],
		           b,
		           c);
		      function v(ctrl, id, date, cont){
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call$2
		                (stop,
		                 ctrl,
		                 crdt,
		                 id,
		                 date,
		                 function(a){
		                  return caml_trampoline_cps_call2(of_string$14, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3(let$0, b, a, cont);
		                });
		      }
		      var
		       stop$0 =
		         call_async
		          (cst_stop,
		           "Set a recurring event end date to today.",
		           [0, event_rec_id, [0, [0, cst_date, schema$5, 0], 0]],
		           schematic_param_a_schema_versi,
		           local_only(side, v));
		      function v$0(ctrl, patch, source, cont){
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call$2
		                (update$20,
		                 ctrl,
		                 crdt,
		                 patch,
		                 source,
		                 function(a){
		                  return caml_trampoline_cps_call2(of_string$14, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3(let$0, b, a, cont);
		                });
		      }
		      var
		       update$0 =
		         call_async
		          (cst_update,
		           "Update a recurring event.",
		           [0, [0, cst_patch, patch_schema, 0], [0, source, 0]],
		           schematic_param_a_schema_versi,
		           local_only(side, v$0));
		      function v$1(ctrl, patch, cont){
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call$2
		                (update_all,
		                 ctrl,
		                 crdt,
		                 patch[1],
		                 patch[2],
		                 function(a){
		                  return caml_trampoline_cps_call2(return$12, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3(let$1, b, a, cont);
		                });
		      }
		      var
		       update_all$0 =
		         call_async
		          ("update_all",
		           "Update a recurring event from an occurrence patch.",
		           [0, [0, cst_patch, patch_schema$0, 0], 0],
		           schematic_param_a_schema_versi,
		           local_only(side, v$1));
		      function v$2(ctrl, patch, cont){
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call$2
		                (update_this_and_following,
		                 ctrl,
		                 crdt,
		                 patch[1],
		                 patch[2],
		                 function(a){
		                  return caml_trampoline_cps_call2(return$12, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3(let$1, b, a, cont);
		                });
		      }
		      var
		       update_this_and_following$0 =
		         call_async
		          ("update_this_and_following",
		           "Stop and create a new patched recurring event at an occurrence.",
		           [0, [0, cst_patch, patch_schema$0, 0], 0],
		           schema$91,
		           local_only(side, v$2)),
		       a = local_only(side, first_occurrence$0);
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$230,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call
		                        (option_schema,
		                         b,
		                         function(b){
		                          var
		                           first_occurrence =
		                             call_reactive
		                              ("first_occurrence",
		                               "Get the first occurrence of a recurring event",
		                               [0, event_rec_id, 0],
		                               b,
		                               a);
		                          return cont
		                                  ([0,
		                                    allocate,
		                                    [0,
		                                     complete,
		                                     [0,
		                                      create,
		                                      [0,
		                                       day,
		                                       [0,
		days,
		[0,
		 delete$,
		 [0,
		  find_with_attendees,
		  [0,
		   get,
		   [0,
		    move,
		    [0,
		     publish$0,
		     [0,
		      [0,
		       cst_recurrent,
		       [0,
		        create$0,
		        [0,
		         delete$0,
		         [0,
		          get$0,
		          [0,
		           stop$0,
		           [0,
		            update$0,
		            [0,
		             update_all$0,
		             [0, update_this_and_following$0, [0, first_occurrence, 0]]]]]]]]],
		      [0,
		       set_will_attend,
		       [0,
		        tasks,
		        [0,
		         timeline,
		         [0, update, [0, with_notes, [0, with_same_attendees$0, 0]]]]]]]]]]]]]]]]]);
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function append$16(ctrl, crdt, document, block, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 let$ = open[4];
		                function a(param, cont){
		                 var op = param[2], id = param[1];
		                 return caml_exact_trampoline_cps_call$0
		                         (apply_personal,
		                          ctrl[1],
		                          crdt,
		                          op,
		                          function(match){return cont(id);});
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (append$15,
		                         ctrl[2],
		                         ctrl[9],
		                         document,
		                         block,
		                         function(b){
		                          return caml_trampoline_cps_call3(let$, b, a, cont);
		                         });
		               }
		               function remove_metadata(blocks, cont){
		                return caml_trampoline_cps_call3
		                        (map$18,
		                         blocks,
		                         function(block, cont){
		                          var
		                           a = block[2],
		                           block$0 = [0, include$48[29].call(null), a],
		                           a = block$0[2];
		                          if(typeof a !== "number")
		                           switch(a[0]){
		                             case 10:
		                              var todo = a[1];
		                              if(todo[1])
		                               return cont([0, block$0[1], [10, [0, 0, todo[2], todo[3]]]]);
		                              break;
		                             case 11:
		                              var todo$0 = a[1];
		                              if(todo$0[3])
		                               return cont
		                                       ([0, block$0[1], [11, [0, todo$0[1], todo$0[2], 0]]]);
		                              break;
		                           }
		                          return cont(block$0);
		                         },
		                         cont);
		               }
		               var
		                open$47 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$71 = open$47[4];
		               function get$40(ctrl, cont){
		                var
		                 store = ctrl[14],
		                 offline = ctrl[16],
		                 incr = ctrl[9],
		                 devices = ctrl[4],
		                 auth = ctrl[1];
		                function a(a){
		                 var values = incr[5], by_id = values[5][1];
		                 return caml_exact_trampoline_cps_call$1
		                         (of_incremental, 0, by_id, cont);
		                }
		                if(devices[1]) return a();
		                devices[1] = 0;
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[17];
		                return caml_exact_trampoline_cps_call$3
		                        (background_offline,
		                         a6Y,
		                         auth,
		                         offline,
		                         "loading devices",
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (api$1,
		                                   auth,
		                                   function(match){
		                                    var api = match[2], Api = match[1];
		                                    function a(devices, cont){
		                                     var head = [2, devices];
		                                     return caml_exact_trampoline_cps_call$1
		     (synchronize_multiple,
		      store[4],
		      [0, head, 0],
		      function(match){
		       var state_changed = match[2], store$0 = match[1];
		       return caml_exact_trampoline_cps_call$3
		               (commit_state, 0, state_changed, store, incr, store$0, cont);
		      });
		                                    }
		                                    return caml_trampoline_cps_call2
		    (Api[3][3],
		     api,
		     function(b){
		      return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		     });
		                                   });
		                         },
		                         a);
		               }
		               function patch$6(ctrl, id, patch, cont){
		                return caml_exact_trampoline_cps_call
		                        (mutate$0(ctrl), [0, [0, id, patch], 0], cont);
		               }
		               function perform_action(crdt, title){
		                var b = g(include$0), a = b[17], c = b[14], d = b[11];
		                return function(b, cont){
		                 b = b[2];
		                 var
		                  participants = b[5],
		                  document = b[4],
		                  daytime = b[3],
		                  date = b[2],
		                  calendar = b[1];
		                 function e(h){
		                  function e(calendar, cont){
		                   return caml_trampoline_cps_call3
		                           (map$18,
		                            participants,
		                            function(param, cont){
		                             if(0 === param[0]){
		                              var email = param[1];
		                              return cont([0, email, make_attendee(0, 0, 0, email)]);
		                             }
		                             var email$0 = param[1][1];
		                             return cont([0, email$0, make_attendee(0, 0, 0, email$0)]);
		                            },
		                            function(b){
		                             return caml_exact_trampoline_cps_call$0
		                                     (of_alist_reduce$1,
		                                      [0, comparator$2],
		                                      b,
		                                      merge_attendees,
		                                      function(attendees){
		                                       return caml_exact_trampoline_cps_call
		       (today,
		        dummy,
		        function(today){
		         if(0 !== date[0]){
		          var recurrence = date[1];
		          return caml_exact_trampoline_cps_call$1
		                  (d,
		                   daytime,
		                   function(param, cont){
		                    var duration = param[2], time = param[1];
		                    return caml_exact_trampoline_cps_call
		                            (of_timmy,
		                             timezone_local,
		                             function(t){
		                              function a(a){
		                               return caml_exact_trampoline_cps_call
		                                       (ok_or_failwith,
		a,
		function(timezone){
		 return cont([0, time, duration, timezone]);
		});
		                              }
		                              if(0 === t[0]) return a(t);
		                              var x = t[1], tz = x[2];
		                              return caml_exact_trampoline_cps_call$1
		                                      (kasprintf,
		                                       id,
		                                       fmt$303,
		                                       function(b){
		return caml_trampoline_cps_call2
		        (b, tz, function(b){return a([1, b]);});
		                                       });
		                             });
		                   },
		                   function(daytime){
		                    var match = recurrence[1];
		                    if(0 === match[0])
		                     var
		                      count = match[2],
		                      start = match[1],
		                      boundaries = [0, start, count];
		                    else {
		                     var match$0 = match[2], end = match[1];
		                     if(match$0)
		                      var start$0 = match$0[1], boundaries = [1, end, start$0];
		                     else
		                      boundaries = [1, end, today];
		                    }
		                    var
		                     recurrence$0 = [0, boundaries, recurrence[2]],
		                     open =
		                       g
		                        ([0,
		                          symbol_bind$22,
		                          symbol_map$20,
		                          ,
		                          bind$30,
		                          return$39,
		                          map$50,
		                          ,
		                          ,
		                          ,
		                          ,
		                          Let_syntax$14]),
		                     let$ = open[4],
		                     id = make$48();
		                    function a(param, cont){return cont([1, id]);}
		                    return caml_exact_trampoline_cps_call
		                            (add$36,
		                             [0,
		                              calendar,
		                              0,
		                              0,
		                              0,
		                              id,
		                              0,
		                              make$49(0, [0, attendees], 0, daytime, 0, 0, 0, 0, title)
		                               (recurrence$0)],
		                             function(b){
		                              return caml_trampoline_cps_call3
		                                      (let$,
		                                       b,
		                                       a,
		                                       function(operation){return cont([0, operation]);});
		                             });
		                   });
		         }
		         var date$0 = date[1];
		         function c(event, cont){
		          var
		           open =
		             g
		              ([0,
		                symbol_bind$22,
		                symbol_map$20,
		                ,
		                bind$30,
		                return$39,
		                map$50,
		                ,
		                ,
		                ,
		                ,
		                Let_syntax$14]),
		           let$ = open[4],
		           t = ocaml_ptime_clock_now_d_ps();
		          function a(param, cont){
		           var id = param[1];
		           return cont([0, id]);
		          }
		          return caml_exact_trampoline_cps_call$4
		                  (add_from_writable$1,
		                   0,
		                   0,
		                   t,
		                   0,
		                   0,
		                   calendar,
		                   0,
		                   0,
		                   event,
		                   function(b){
		                    return caml_trampoline_cps_call3(let$, b, a, cont);
		                   });
		         }
		         function e(time, cont){
		          return cont
		                  (make$47
		                    (0, 0, [0, attendees], 0, 0, 0, 0, 0, 0, time, title));
		         }
		         function b(b){
		          return caml_exact_trampoline_cps_call$1
		                  (a,
		                   b,
		                   e,
		                   function(b){
		                    return caml_exact_trampoline_cps_call$1(a, b, c, cont);
		                   });
		         }
		         if(! daytime)
		          return caml_trampoline_cps_call2
		                  (of_string$14, [0, date$0], b);
		         var
		          match = daytime[1],
		          duration = match[2],
		          start = match[1];
		         function f(start, cont){
		          return caml_exact_trampoline_cps_call$1
		                  (symbol$78,
		                   start,
		                   duration,
		                   function(a){return cont([2, start, a]);});
		         }
		         return caml_exact_trampoline_cps_call$0
		                 (to_time$2,
		                  timezone_local,
		                  date$0,
		                  start,
		                  function(t){
		                   if(0 === t[0])
		                    var c = t;
		                   else
		                    var x = t[1], c = [1, [0, 144245463, x]];
		                   return caml_exact_trampoline_cps_call$1(a, c, f, b);
		                  });
		        });
		                                      });
		                            });
		                  }
		                  function b(a){
		                   return caml_exact_trampoline_cps_call$1(c, a, e, cont);
		                  }
		                  if(calendar){
		                   var calendar$0 = calendar[1];
		                   return b([0, calendar$0]);
		                  }
		                  function f(param, cont){var id = param[5]; return cont(id);}
		                  return caml_exact_trampoline_cps_call
		                          (default$12,
		                           crdt,
		                           function(c){
		                            return caml_exact_trampoline_cps_call$1(a, c, f, b);
		                           });
		                 }
		                 return document
		                         ? caml_exact_trampoline_cps_call
		                           (Sync[4],
		                            function(m, cont){
		                             return caml_trampoline_cps_call4(m, 0, 0, bMA, cont);
		                            },
		                            e)
		                         : e();};
		               }
		               var
		                open$48 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$72 = open$48[3],
		                let$73 = open$48[4],
		                schematic_cache$1336 = [0, empty$11([0, comparator$9])],
		                letrec_function_context$1376 = [];
		               caml_update_dummy
		                (letrec_function_context$1376, [0, schematic_cache$1336]);
		               function schematic_version$366(param, cont){return cont(0);}
		               var
		                schematic_schema_version$53 = 0,
		                e =
		                  caml_callback
		                   (find_packed_by_id,
		                    [letrec_function_context$1376[1][1],
		                     schematic_schema_version$53]);
		               if(e)
		                var schema$259 = e[1], descriptor$63 = schema$259;
		               else
		                descriptor$63 =
		                 caml_callback
		                  (fixpoint,
		                   [function(schematic_self, cont){
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              letrec_function_context$1376[1][1],
		                              schematic_schema_version$53,
		                              function(match){
		                               if(! match)
		                                return caml_exact_trampoline_cps_call$0
		(set$3,
		 letrec_function_context$1376[1][1],
		 schematic_schema_version$53,
		 schematic_self,
		 function(a){
		  letrec_function_context$1376[1][1] = a;
		  return caml_exact_trampoline_cps_call
		          (action_time_schema_versioned,
		           schematic_version$366,
		           function(a){
		            var
		             res =
		               [11,
		                bMC,
		                [0,
		                 [0,
		                  function(f0, cont){return cont([0, 81098820, f0]);},
		                  function(param, cont){
		                   var f0 = param[2];
		                   return cont([0, f0]);
		                  },
		                  0,
		                  0,
		                  cst_event_creation,
		                  cst_Event_creation,
		                  a,
		                  0],
		                 0],
		                1];
		            return caml_exact_trampoline_cps_call$0
		                    (set$3,
		                     letrec_function_context$1376[1][1],
		                     schematic_schema_version$53,
		                     res,
		                     function(a){
		                      letrec_function_context$1376[1][1] = a;
		                      return cont(res);
		                     });
		           });
		 });
		                               var schema = match[1];
		                               return cont(schema);
		                              });
		                    }]);
		               var
		                controller_supported_actions_s = [0, bMB, 0, descriptor$63, 0],
		                open$49 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$74 = open$49[4],
		                open$50 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$75 = open$50[3],
		                let$76 = open$50[4],
		                open$51 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                let$77 = open$51[4];
		               function accounts(ctrl, email, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (offline$0("searching accounts", ctrl),
		                                   function(param, cont){
		                                    return caml_trampoline_cps_call3
		    (Api[2][1], api, email, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function impersonate(ctrl, account, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (offline$0("impersonating account", ctrl),
		                                   function(param, cont){
		                                    return caml_trampoline_cps_call3
		    (Api[2][2], api, account, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function access_token(ctrl, cont){
		                return caml_exact_trampoline_cps_call
		                        (offline$0("generating Deepgram access token", ctrl),
		                         function(param, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (api$1,
		                                   ctrl[1],
		                                   function(match){
		                                    var api = match[2], Api = match[1];
		                                    return caml_trampoline_cps_call2(Api[4][2][1], api, cont);
		                                   });
		                         },
		                         cont);
		               }
		               function invite_by_email(ctrl, email, cont){
		                return caml_exact_trampoline_cps_call
		                        (api$1,
		                         ctrl[1],
		                         function(match){
		                          var api = match[2], Api = match[1];
		                          return caml_exact_trampoline_cps_call
		                                  (offline$0("sending invite", ctrl),
		                                   function(param, cont){
		                                    return caml_trampoline_cps_call3
		    (Api[7][1], api, email, cont);
		                                   },
		                                   cont);
		                         });
		               }
		               function pp$130(a, b, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (of_to_string, string_of_status, a, b, cont);
		               }
		               function map$55(error){var status = error[1]; return status;}
		               var
		                Http$2 =
		                  Make$9
		                   (Map_error
		                     (Check_status(Status_success, Handler), [0, map$55]));
		               function download(param, url, cont){
		                var controller = param[1];
		                return caml_exact_trampoline_cps_call$0
		                        (silo,
		                         controller[22],
		                         0,
		                         "downloads",
		                         function(silo){
		                          return caml_exact_trampoline_cps_call$1
		                                  (make$136,
		                                   0,
		                                   0,
		                                   function(match){
		                                    var set = match[2], result = match[1];
		                                    function get(param, cont){
		                                     var
		                                      open =
		g
		 ([0,
		   symbol_bind$8,
		   symbol_map$6,
		   ,
		   bind$10,
		   return$12,
		   map$23,
		   ,
		   ,
		   ,
		   ,
		   Let_syntax$4]),
		                                      symbol_map = open[2],
		                                      symbol_bind = open[1];
		                                     return caml_exact_trampoline_cps_call$1
		     (to_string$25,
		      0,
		      url,
		      function(name){
		       var a = [0, name, schematic_param_name_schema_ve];
		       return caml_exact_trampoline_cps_call
		               (get$16,
		                silo,
		                function(b){
		                 return caml_trampoline_cps_call2
		                         (b,
		                          a,
		                          function(a){
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    a,
		                                    return$2,
		                                    function(cached){
		                                     function cache(content, cont){
		                                      function a(param, cont){
		                                       if(0 === param[0]) return cont(0);
		                                       var e = param[1];
		                                       return caml_exact_trampoline_cps_call
		       (Sync[3],
		        function(m, cont){
		         return caml_trampoline_cps_call6
		                 (m, 0, 0, bME, pp_toplevel, e, cont);
		        },
		        cont);
		                                      }
		                                      var b = [0, name, schematic_param_name_schema_ve];
		                                      return caml_exact_trampoline_cps_call
		      (set$27,
		       silo,
		       function(c){
		        return caml_trampoline_cps_call3
		                (c,
		                 b,
		                 content,
		                 function(b){
		                  return caml_trampoline_cps_call3(symbol_map, b, a, cont);
		                 });
		       });
		                                     }
		                                     function a(param, cont){
		                                      function a(ok, cont){
		                                       if(0 === ok[0])
		return caml_trampoline_cps_call2(return$12, ok, cont);
		                                       var error = ok[1];
		                                       if(typeof error[2] === "number")
		return caml_exact_trampoline_cps_call
		        (fail$2, -610669292, cont);
		                                       function a(a, cont){return cont(pp_reason$0(pp$130, a));}
		                                       function b(b, c, cont){
		return caml_exact_trampoline_cps_call$0
		        (pp$24, a, b, c, cont);
		                                       }
		                                       return caml_exact_trampoline_cps_call$1
		       (kasprintf,
		        id,
		        fmt$304,
		        function(a){
		         return caml_trampoline_cps_call5
		                 (a,
		                  pp$27,
		                  url,
		                  b,
		                  error,
		                  function(a){
		                   return caml_exact_trampoline_cps_call
		                           (fail$2, [0, 9943782, a], cont);
		                  });
		        });
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (to_uri,
		       url,
		       function(b){
		        return caml_exact_trampoline_cps_call$3
		                (Http$2[8],
		                 0,
		                 0,
		                 0,
		                 Http$2[3],
		                 b,
		                 function(b){
		                  return caml_trampoline_cps_call3(symbol_bind, b, a, cont);
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$305,
		      function(b){
		       return caml_trampoline_cps_call3
		               (b,
		                pp$27,
		                url,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (offline$0(b, controller),
		                          a,
		                          function(downloaded){
		                           function a(a, cont){
		                            if(0 !== a[0]){
		                             var
		                              cached = a[1],
		                              b =
		                                function(a){
		                                 return caml_trampoline_cps_call3
		 (symbol_bind,
		  downloaded,
		  function(a, cont){
		   if(0 !== a[0]){
		    var e = a[1];
		    return caml_exact_trampoline_cps_call
		            (Lwt[3],
		             function(m, cont){
		              return caml_trampoline_cps_call6
		                      (m, 0, 0, bMG, pp_toplevel, e, cont);
		             },
		             cont);
		   }
		   var content = a[1];
		   if(cached) var b = cached[1], a = content === b; else a = 0;
		   return a
		           ? caml_trampoline_cps_call2(return$12, 0, cont)
		           : caml_trampoline_cps_call2
		             (set,
		              [0, content],
		              function(match){
		               return caml_exact_trampoline_cps_call(cache, content, cont);
		              });
		  },
		  cont);
		                                };
		                             if(! cached) return b(0);
		                             var content$0 = cached[1];
		                             return caml_trampoline_cps_call2(set, [0, content$0], b);
		                            }
		                            a = a[1];
		                            if(0 === a[0]){
		                             var content = a[1];
		                             return caml_trampoline_cps_call2
		                                     (set,
		                                      [0, content],
		                                      function(match){
		                                       return caml_exact_trampoline_cps_call(cache, content, cont);
		                                      });
		                            }
		                            var e = a[1];
		                            return caml_exact_trampoline_cps_call
		                                    (Lwt[3],
		                                     function(m, cont){
		                                      return caml_trampoline_cps_call6
		      (m, 0, 0, bMF, pp_toplevel, e, cont);
		                                     },
		                                     cont);
		                           }
		                           return caml_trampoline_cps_call3
		                                   (symbol_map,
		                                    downloaded,
		                                    return$1,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call
		     (choose,
		      [0, cached, [0, b, 0]],
		      function(b){
		       return caml_trampoline_cps_call3(symbol_bind, b, a, cont);
		      });
		                                    });
		                          });
		                });
		      });
		                                    });
		                          });
		                });
		      });
		                                    }
		                                    return caml_exact_trampoline_cps_call$1
		    (dont_wait,
		     get,
		     function(exn, cont){
		      return caml_exact_trampoline_cps_call
		              (Sync[3],
		               function(m, cont){
		                return caml_trampoline_cps_call8
		                        (m, 0, 0, bMH, pp$27, url, pp$1, exn, cont);
		               },
		               cont);
		     },
		     function(match){return cont(result);});
		                                   });
		                         });
		               }
		               var
		                dist_schema =
		                  [0, id$26, 0, [4, dist_of_string, dist_to_string, 8], 0],
		                default$11 = [0, [0, [0, handle, replaced_with], 0]];
		               function rpcs$4(config, side, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$8,
		                      symbol_map$6,
		                      ,
		                      bind$10,
		                      return$12,
		                      map$23,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$4]),
		                 let$ = open[17],
		                 let$0 = open[4],
		                 symbol_map = open[2];
		                function a(param){
		                 var controller = param[1];
		                 return controller;
		                }
		                function namespace_ctrl(name, space, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (map_context, [0, name, space], a, cont);
		                }
		                function call_ctrl(name, doc, args, result, f, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (map_context, call$4(name, doc, args, result, f), a, cont);
		                }
		                function call_async_ctrl(name, doc, args, result, f, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (map_context,
		                          call_async(name, doc, args, result, f),
		                          a,
		                          cont);
		                }
		                function call_reactive_ctrl(name, doc, args, result, f, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (map_context,
		                          call_reactive(name, doc, args, result, f),
		                          a,
		                          cont);
		                }
		                function v(param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (to_string$11, version$2, cont);
		                }
		                function v$0(ctrl, id, cont){
		                 function a(crdt, cont){
		                  return caml_exact_trampoline_cps_call
		                          (state_personal,
		                           ctrl[2],
		                           function(state){
		                            return caml_exact_trampoline_cps_call$1
		                                    (Destination[17],
		                                     [0, id, 0],
		                                     state[11][1],
		                                     function(a){
		                                      return caml_exact_trampoline_cps_call
		      (Destination[24],
		       a,
		       function(mru_destinations$0){
		        return caml_exact_trampoline_cps_call$1
		                (update_mru_destinations_from_d,
		                 state[21][5],
		                 mru_destinations$0,
		                 function(a){
		                  return caml_exact_trampoline_cps_call
		                          (mru_destinations,
		                           a,
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (settings,
		                                     a,
		                                     function(crdt_op){
		                                      return caml_exact_trampoline_cps_call$0
		      (apply_personal,
		       ctrl[1],
		       crdt,
		       crdt_op,
		       function(a){
		        return caml_exact_trampoline_cps_call(of_string$0, a, cont);
		       });
		                                     });
		                           });
		                 });
		       });
		                                     });
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$0, b, a, cont);
		                          });
		                }
		                var
		                 b =
		                   [0,
		                    call$4
		                     (cst_version,
		                      "Controller version.",
		                      0,
		                      schematic_param_name_schema_ve,
		                      local_only(side, v)),
		                    0];
		                return caml_exact_trampoline_cps_call$3
		                        (call_async_ctrl,
		                         "use_destination",
		                         "Register that a destination was used, bumping its priority in completions.",
		                         [0, [0, cst_id, schema$46, 0], 0],
		                         schematic_param_a_schema_versi,
		                         local_only(side, v$0),
		                         function(d){
		                          function v(param, id, cont){return cont(id);}
		                          var
		                           space =
		                             [0,
		                              call$4
		                               (cst_parse,
		                                "Decompose an automation run reference id into its components.",
		                                [0, [0, cst_id, schema$36, 0], 0],
		                                record_schema$4,
		                                local_only(side, v)),
		                              0];
		                          function v$0(param, id, cont){return cont(id);}
		                          var
		                           space$0 =
		                             [0,
		                              call$4
		                               (cst_parse,
		                                "Decompose a conversation reference id into its components.",
		                                [0, [0, cst_id, schema$34, 0], 0],
		                                record_schema$3,
		                                local_only(side, v$0)),
		                              0];
		                          function v$1(param, id, cont){return cont(id);}
		                          var
		                           space$1 =
		                             [0,
		                              call$4
		                               (cst_parse,
		                                "Decompose an automation reference id into its components.",
		                                [0, [0, cst_id, schema$32, 0], 0],
		                                record_schema$2,
		                                local_only(side, v$1)),
		                              0];
		                          function v$2(param, id, cont){return cont(id);}
		                          var
		                           space$2 =
		                             [0,
		                              call$4
		                               (cst_parse,
		                                "Decompose an agent reference id into its components.",
		                                [0, [0, cst_id, schema$30, 0], 0],
		                                record_schema$1,
		                                local_only(side, v$2)),
		                              0];
		                          function v$3(param, id, cont){return cont(id);}
		                          var
		                           space$3 =
		                             [0,
		                              call$4
		                               (cst_parse,
		                                "Decompose a workspace_ref id into its components.",
		                                [0, [0, cst_id, schema$26, 0], 0],
		                                record_schema$0,
		                                local_only(side, v$3)),
		                              0];
		                          function v$4(param, id, cont){return cont(id);}
		                          var
		                           space$4 =
		                             [0,
		                              call$4
		                               (cst_parse,
		                                "Decompose a table_ref id into its components.",
		                                [0, [0, cst_id, schema$24, 0], 0],
		                                record_schema,
		                                local_only(side, v$4)),
		                              0];
		                          function v$5(ctrl, id, cont){
		                           var personal = personal_workspace_id(ctrl[2]);
		                           switch(id[0]){
		                             case 6:
		                              var workspace_id = id[1][1];
		                              return cont(value$4(workspace_id, personal));
		                             case 8:
		                              var workspace_id$0 = id[1][1]; return cont(workspace_id$0);
		                             case 9:
		                              var workspace_id$1 = id[1][2]; return cont(workspace_id$1);
		                             case 10:
		                             case 11:
		                             case 12:
		                             case 13:
		                              var org_id = id[1][1];
		                              return caml_exact_trampoline_cps_call
		                                      (default_workspace_of_organizat, org_id, cont);
		                             default: return cont(personal);
		                           }
		                          }
		                          var c = [0, d, b];
		                          return caml_exact_trampoline_cps_call$1
		                                  (namespace_ctrl,
		                                   cst_id,
		                                   [0,
		                                    call$4
		                                     (cst_workspace,
		                                      "Return the workspace that the object referenced by the id lives in.",
		                                      [0, [0, cst_id, schema$46, 0], 0],
		                                      schema$39,
		                                      local_only(side, v$5)),
		                                    [0,
		                                     [0, cst_table_ref, space$4],
		                                     [0,
		                                      [0, cst_workspace_ref, space$3],
		                                      [0,
		                                       [0, cst_agent_ref, space$2],
		                                       [0,
		[0, cst_automation_ref, space$1],
		[0,
		 [0, cst_conversation_ref, space$0],
		 [0, [0, cst_automation_run_ref, space], 0]]]]]]],
		                                   function(d){
		                                    var b = [0, d, c];
		                                    return caml_exact_trampoline_cps_call$3
		    (call_async_ctrl,
		     cst_channel,
		     "The channel we are logged into.",
		     0,
		     schema$214,
		     local_only(side, update_channel),
		     function(e){
		      function v(controller, cont){
		       function a(param, cont){
		        var channel = param[4];
		        return cont(channel);
		       }
		       return caml_exact_trampoline_cps_call
		               (update_channel,
		                controller,
		                function(b){
		                 return caml_exact_trampoline_cps_call$1(let$, b, a, cont);
		                });
		      }
		      var c = [0, e, b], d = local_only(side, v);
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (environment_schema_versioned,
		               schematic_version,
		               function(b){
		                return caml_exact_trampoline_cps_call$3
		                        (call_async_ctrl,
		                         "update_channel",
		                         "The channel to pull updates from.",
		                         0,
		                         b,
		                         d,
		                         function(d){
		                          var b = [0, d, c];
		                          return caml_exact_trampoline_cps_call$3
		                                  (call_reactive_ctrl,
		                                   cst_today,
		                                   "Current date.",
		                                   0,
		                                   schema$5,
		                                   local_only(side, today$0),
		                                   function(d){
		                                    function v(param, cont){
		                                     var t = ocaml_ptime_clock_now_d_ps();
		                                     return caml_exact_trampoline_cps_call$1
		     (gmt_offset_seconds_at_time,
		      timezone_local,
		      t,
		      function(seconds_offset){
		       var
		        sign = 0 <= seconds_offset ? cst$32 : cst$33,
		        minutes = stdlib_abs(seconds_offset) / 60 | 0,
		        hours = minutes / 60 | 0;
		       return caml_exact_trampoline_cps_call$1
		               (symbol$23,
		                minutes,
		                60,
		                function(minutes){
		                 function a(s2){return cont(cst_UTC + s2);}
		                 if(0 === hours && 0 === minutes) return a(cst$1);
		                 return 0 === minutes
		                         ? caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$306,
		                            function(b){
		                             return caml_trampoline_cps_call3(b, sign, hours, a);
		                            })
		                         : caml_exact_trampoline_cps_call$1
		                           (kasprintf,
		                            id,
		                            fmt$307,
		                            function(b){
		                             return caml_trampoline_cps_call4(b, sign, hours, minutes, a);
		                            });
		                });
		      });
		                                    }
		                                    var
		                                     c =
		                                       [0,
		call$4
		 (cst_timezone,
		  "Local timezone.",
		  0,
		  schematic_param_name_schema_ve,
		  local_only(side, v)),
		[0, d, b]];
		                                    return caml_exact_trampoline_cps_call$3
		    (call_reactive_ctrl,
		     "state_stuck",
		     "Whether pending operations have been stuck for more than 1 minute.",
		     0,
		     bool_schema,
		     local_only(side, state_stuck),
		     function(d){
		      function v(ctrl, cont){
		       var t = ctrl[21], a = caml_obj_tag(t);
		       function b(a){return cont(1);}
		       if(250 === a) return b();
		       if(246 !== a && 244 !== a) return b();
		       return caml_exact_trampoline_cps_call
		               (force_lazy_block, t, b);
		      }
		      var b = [0, d, c];
		      return caml_exact_trampoline_cps_call$3
		              (call_ctrl,
		               "build_search_index",
		               "Build the search index now, unless a search has already built it.",
		               0,
		               bool_schema,
		               local_only(side, v),
		               function(e){
		                function v(ctrl, organization, query, limit, cont){
		                 return caml_exact_trampoline_cps_call$3
		                         (search$0, organization, 0, limit, query, ctrl[21], cont);
		                }
		                function schematic_version(param, cont){return cont(0);}
		                var c = [0, e, b], d = local_only(side, v);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$551,
		                         schematic_version,
		                         function(e){
		                          var b = [0, 0, 0, [3, e], 0];
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   int_schema,
		                                   function(schema){
		                                    var
		                                     e =
		                                       [0,
		[0, cst_query, schematic_param_name_schema_ve, 0],
		[0, [0, cst_limit, schema, 0], 0]];
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$104,
		     dummy,
		     function(f){
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               f,
		               function(schema){
		                return caml_exact_trampoline_cps_call$3
		                        (call_ctrl,
		                         cst_search,
		                         "Search for an object or note",
		                         [0, [0, cst_organization, schema, 0], e],
		                         b,
		                         d,
		                         function(d){
		                          var b = [0, d, c];
		                          return caml_exact_trampoline_cps_call$3
		                                  (call_reactive_ctrl,
		                                   cst_premium,
		                                   "Whether the user is premium.",
		                                   0,
		                                   bool_schema,
		                                   local_only(side, premium),
		                                   function(e){
		                                    function schematic_version(param, cont){return cont(0);}
		                                    var
		                                     d = local_only(side, pending_operations),
		                                     parameter = mutation_schema_versioned(),
		                                     c = [0, e, b];
		                                    return caml_exact_trampoline_cps_call
		    (mutation_operation_schema_vers,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call
		              (b,
		               parameter,
		               function(b){
		                return caml_exact_trampoline_cps_call$3
		                        (call_reactive_ctrl,
		                         "pending_operations",
		                         "Operations waiting to be pushed to the server.",
		                         0,
		                         [0, 0, 0, [3, [0, a5T, b[2], b[3], 0]], 0],
		                         d,
		                         function(e){
		                          function v(param, cont){
		                           var os = param[1][8][2];
		                           return cont(os);
		                          }
		                          var d = local_only(side, v);
		                          function v$0(ctrl, f, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (attach,
		                                    ctrl[13][1],
		                                    f,
		                                    function(match){
		                                     var subscription = match[2], hook = match[1];
		                                     ctrl[13][1] = hook;
		                                     return cont
		     (function(param, cont){
		       return caml_exact_trampoline_cps_call$1
		               (detach,
		                ctrl[13][1],
		                subscription,
		                function(a){ctrl[13][1] = a; return cont(0);});
		      });
		                                    });
		                          }
		                          var
		                           b =
		                             [0,
		                              call$4
		                               (cst_os,
		                                "Operating system.",
		                                0,
		                                [0, bMI, any_schema[2], any_schema[3], any_schema[4]],
		                                d),
		                              [0, e, c]],
		                           f = local_only(side, v$0);
		                          return caml_exact_trampoline_cps_call$1
		                                  (map_context,
		                                   call_hook
		                                    ("open_external_url",
		                                     "Uris to open with the OS default handler.",
		                                     0,
		                                     schema$262,
		                                     f),
		                                   a,
		                                   function(c){
		                                    var a = [0, c, b];
		                                    return caml_exact_trampoline_cps_call$3
		    (call_reactive_ctrl,
		     cst_online,
		     "Whether we have connectivity.",
		     0,
		     bool_schema,
		     local_only(side, online),
		     function(c){
		      var b = [0, c, a];
		      return caml_exact_trampoline_cps_call$3
		              (call_reactive_ctrl,
		               cst_now,
		               "Current time down to the minute.",
		               0,
		               schema$7,
		               local_only(side, now$0),
		               function(d){
		                function v(param, cont){return cont(bE);}
		                var c = local_only(side, v), a = [0, d, b];
		                return caml_exact_trampoline_cps_call$1
		                        (config[4],
		                         schematic_param_name_schema_ve,
		                         schematic_param_name_schema_ve,
		                         function(e){
		                          function v(param, cont){return cont(bE);}
		                          var
		                           b =
		                             [0, call$4("log_file", "The current log file.", 0, e, c), a],
		                           d = local_only(side, v);
		                          return caml_exact_trampoline_cps_call$1
		                                  (config[4],
		                                   schematic_param_name_schema_ve,
		                                   schematic_param_name_schema_ve,
		                                   function(e){
		                                    var
		                                     a =
		                                       [0,
		call$4("logs_directory", "The logs directory.", 0, e, d),
		b];
		                                    function schematic_version(param, cont){return cont(0);}
		                                    var c = local_only(side, issues);
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$535,
		     schematic_version,
		     function(b){
		      return caml_exact_trampoline_cps_call$3
		              (call_reactive_ctrl,
		               cst_issues,
		               "List of current issues requiring attention.",
		               0,
		               [0, 0, 0, [3, b], 0],
		               c,
		               function(c){
		                var b = [0, c, a];
		                return caml_exact_trampoline_cps_call$3
		                        (call_async_ctrl,
		                         "invite_by_email",
		                         "Invite contact to use Routine.",
		                         [0, [0, cst_email, schema$72, 0], 0],
		                         schematic_param_a_schema_versi,
		                         local_only(side, invite_by_email),
		                         function(c){
		                          var a = [0, c, b];
		                          return caml_exact_trampoline_cps_call$3
		                                  (call_async_ctrl,
		                                   "deepgram_access_token",
		                                   "Generate a Deepgram access token for speech-to-text.",
		                                   0,
		                                   schematic_param_name_schema_ve,
		                                   local_only(side, access_token),
		                                   function(b){
		                                    function v(param, date, cont){
		                                     var graph = param[2], controller = param[1];
		                                     return caml_trampoline_cps_call2
		     (graph[22],
		      date,
		      function(objects){
		       return caml_exact_trampoline_cps_call$1
		               (calendar_tasks,
		                controller,
		                date,
		                function(tasks){
		                 return caml_exact_trampoline_cps_call$0
		                         (map2$2,
		                          tasks,
		                          objects,
		                          function(tasks, objects, cont){
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$7, tasks, objects, cont);
		                          },
		                          cont);
		                });
		      });
		                                    }
		                                    function v$0(param, date, cont){
		                                     var graph = param[2], controller = param[1];
		                                     return caml_trampoline_cps_call2
		     (graph[21],
		      date,
		      function(objects){
		       return caml_exact_trampoline_cps_call$1
		               (agenda_tasks,
		                controller,
		                date,
		                function(tasks){
		                 return caml_exact_trampoline_cps_call$0
		                         (map2$2,
		                          tasks,
		                          objects,
		                          function(tasks, objects, cont){
		                           var
		                            a = symbol(tasks[7], objects[7]),
		                            b = symbol(tasks[6], objects[6]),
		                            c = symbol(tasks[5], objects[5]),
		                            d = symbol(tasks[4], objects[4]),
		                            e = symbol(tasks[3], objects[3]),
		                            f = symbol(tasks[2], objects[2]);
		                           return cont
		                                   ([0, symbol(tasks[1], objects[1]), f, e, d, c, b, a]);
		                          },
		                          cont);
		                });
		      });
		                                    }
		                                    var
		                                     b =
		                                       [0,
		call_reactive
		 (cst_calendar_tasks,
		  "\n  Tasks for the calendar at the given date.\n  `scheduled`: Tasks scheduled for today and remaining days of the current week (7-element list, one per weekday, starting at the week start).\n  `postponed`: Tasks scheduled for the week (but *not* for a specific day).\n  `overdue`: Tasks scheduled for a past day (including earlier this week) or past week.\n  `upcoming`: Tasks scheduled (day or week) for the next 2 months, starting from next week start.\n  `unplanned`: Tasks with no scheduling.\n  ",
		  [0, [0, cst_date, schema$5, 0], 0],
		  schema$237,
		  local_only(side, v)),
		[0, b, a]];
		                                    function v$1(param, cont){
		                                     var graph = param[2], controller = param[1];
		                                     return caml_trampoline_cps_call2
		     (graph[23],
		      0,
		      function(objects){
		       return caml_exact_trampoline_cps_call
		               (inbox$0,
		                controller,
		                function(inbox){
		                 return caml_exact_trampoline_cps_call$0
		                         (map2$2, inbox, objects, append$6, cont);
		                });
		      });
		                                    }
		                                    var
		                                     b =
		                                       [0,
		call_reactive
		 (cst_agenda_tasks,
		  "Tasks for the agenda",
		  [0, [0, cst_date, schema$5, 0], 0],
		  schema$235,
		  local_only(side, v$0)),
		b];
		                                    function v$2(param, cont){
		                                     var name = param[1][8][3];
		                                     return cont(name);
		                                    }
		                                    var
		                                     c =
		                                       [0,
		call_reactive
		 (cst_inbox,
		  "Universal Inbox.",
		  0,
		  schema$233,
		  local_only(side, v$1)),
		b],
		                                     d = local_only(side, v$2);
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     schematic_param_name_schema_ve,
		     function(a){
		      var
		       b = [0, call$4("hostname", "Hostname.", 0, a, d), c],
		       a = "foreground";
		      return caml_exact_trampoline_cps_call$3
		              (call_ctrl,
		               a,
		               "Notify the controller whether it is being observed.",
		               [0, [0, a, bool_schema, 0], 0],
		               schematic_param_a_schema_versi,
		               local_only(side, foreground),
		               function(c){
		                function v(ctrl, message, cont){
		                 return caml_exact_trampoline_cps_call
		                         (Sync[3],
		                          function(m, cont){
		                           return caml_trampoline_cps_call5
		                                   (m, 0, 0, bMJ, message, cont);
		                          },
		                          function(match){
		                           return caml_exact_trampoline_cps_call
		                                   (err$2(ctrl),
		                                    bMK,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(a, message, cont);
		                                    });
		                          });
		                }
		                var a = [0, c, b];
		                return caml_exact_trampoline_cps_call$3
		                        (call_ctrl,
		                         cst_err,
		                         "Trigger a fatal error.",
		                         [0, [0, cst_message, schematic_param_name_schema_ve, 0], 0],
		                         schematic_param_a_schema_versi,
		                         local_only(side, v),
		                         function(d){
		                          var b = [0, d, a], c = local_only(side, download);
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schematic_param_name_schema_ve,
		                                   function(a){
		                                    function v(param, cont){
		                                     return caml_exact_trampoline_cps_call
		     (distribution, dummy, cont);
		                                    }
		                                    var
		                                     a =
		                                       [0,
		call_reactive
		 (cst_download,
		  "Download a URL, caching it locally.",
		  [0, [0, cst_url, schema$262, 0], 0],
		  a,
		  c),
		b];
		                                    function v$0(param, cont){return cont(dev$0);}
		                                    var
		                                     a =
		                                       [0,
		call$4
		 (cst_distribution,
		  "The distribution of this build.",
		  0,
		  dist_schema,
		  local_only(side, v)),
		a];
		                                    function v$1(param, cont){
		                                     var arch = param[1][8][1];
		                                     return caml_exact_trampoline_cps_call$1
		     (map$9, arch, to_string$57, cont);
		                                    }
		                                    var
		                                     d =
		                                       [0,
		call$4
		 (cst_dev,
		  "Whether this is a development build.",
		  0,
		  bool_schema,
		  local_only(side, v$0)),
		a],
		                                     e = local_only(side, v$1);
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     schematic_param_name_schema_ve,
		     function(c){
		      var
		       b =
		         [0,
		          call$4("arch", "Architecture of this build.", 0, c, e),
		          d],
		       a = local_only(side, all$25);
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (all_schema_versioned,
		               schematic_version,
		               function(d){
		                var
		                 list =
		                   call_reactive
		                    (cst_list, "Get the list of all the pinned items", 0, d, a);
		                function v(ctrl, new_items, cont){
		                 function a(crdt, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (replace,
		                           ctrl,
		                           crdt,
		                           new_items,
		                           function(a){
		                            return caml_trampoline_cps_call2(of_string$14, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$64, b, a, cont);
		                          });
		                }
		                function schematic_version(param, cont){return cont(0);}
		                var c = local_only(side, v);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$318,
		                         schematic_version,
		                         function(d){
		                          var
		                           schema = [0, 0, 0, [3, d], 0],
		                           replace =
		                             call_async
		                              (cst_replace,
		                               "change the whole pinned items list",
		                               [0, [0, "new_items", schema, 0], 0],
		                               schematic_param_a_schema_versi,
		                               c);
		                          function v(ctrl, new_item, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (append$14,
		                                     ctrl,
		                                     crdt,
		                                     new_item,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$64, b, a, cont);
		                                    });
		                          }
		                          var a = local_only(side, v);
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$317,
		                                   schematic_version,
		                                   function(schema){
		                                    var
		                                     append =
		                                       call_async
		(cst_append,
		 "Append an item to the pinned items",
		 [0, [0, "new_item", schema, 0], 0],
		 schematic_param_a_schema_versi,
		 a);
		                                    function v(ctrl, item, cont){
		                                     function a(crdt, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (toggle,
		       ctrl,
		       crdt,
		       item,
		       function(a){
		        return caml_trampoline_cps_call2(of_string$14, a, cont);
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$64, b, a, cont);
		      });
		                                    }
		                                    var c = local_only(side, v);
		                                    function schematic_version(param, cont){return cont(0);}
		                                    return caml_exact_trampoline_cps_call
		    (schema_versioned$317,
		     schematic_version,
		     function(schema){
		      var
		       toggle =
		         call_async
		          (cst_toggle,
		           "Add the given item, or remove it if already present",
		           [0, [0, cst_item, schema, 0], 0],
		           schematic_param_a_schema_versi,
		           c);
		      function v(ctrl, target, cont){
		       function a(crdt, cont){
		        return caml_exact_trampoline_cps_call$0
		                (remove$26,
		                 ctrl,
		                 crdt,
		                 target,
		                 function(a){
		                  return caml_trampoline_cps_call2(of_string$14, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call
		               (writable$0,
		                ctrl[2],
		                function(b){
		                 return caml_trampoline_cps_call3(let$64, b, a, cont);
		                });
		      }
		      var a = local_only(side, v);
		      function schematic_version(param, cont){return cont(0);}
		      return caml_exact_trampoline_cps_call
		              (schema_versioned$317,
		               schematic_version,
		               function(schema){
		                var
		                 remove =
		                   call_async
		                    (cst_remove,
		                     "Remove the item(s) with the given target",
		                     [0, [0, cst_target, schema, 0], 0],
		                     schematic_param_a_schema_versi,
		                     a);
		                function v(ctrl, index, cont){
		                 function a(crdt, cont){
		                  return caml_exact_trampoline_cps_call$0
		                          (set_home,
		                           ctrl,
		                           crdt,
		                           index,
		                           function(a){
		                            return caml_trampoline_cps_call2(of_string$14, a, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$64, b, a, cont);
		                          });
		                }
		                var c = local_only(side, v);
		                function schematic_version(param, cont){return cont(0);}
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$317,
		                         schematic_version,
		                         function(schema){
		                          var
		                           set_home =
		                             call_async
		                              (cst_set_home,
		                               "Set the item with target `element` as the home item",
		                               [0, [0, cst_element, schema, 0], 0],
		                               schematic_param_a_schema_versi,
		                               c);
		                          function v(ctrl, cont){return cont(all$4);}
		                          function schematic_version(param, cont){return cont(0);}
		                          var a = local_only(side, v);
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$316,
		                                   schematic_version,
		                                   function(c){
		                                    var
		                                     space =
		                                       [0,
		call$4
		 ("all_known",
		  "All the known page kinds",
		  0,
		  [0, 0, 0, [3, c], 0],
		  a),
		0];
		                                    return caml_exact_trampoline_cps_call$1
		    (namespace_ctrl,
		     cst_menu_items,
		     [0,
		      list,
		      [0,
		       replace,
		       [0,
		        append,
		        [0,
		         remove,
		         [0, toggle, [0, set_home, [0, [0, cst_page, space], 0]]]]]]],
		     function(e){
		      var cst_flag = "flag";
		      function v(ctrl, flag, value, cont){
		       var a = [0, flag, bool_schema];
		       return caml_exact_trampoline_cps_call$0
		               (silo,
		                ctrl[22],
		                3,
		                cst_flag,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (set$27,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call3(b, a, value, cont);
		                          });
		                });
		      }
		      function v$0(ctrl, flag, cont){
		       var a = [0, flag, bool_schema];
		       return caml_exact_trampoline_cps_call$0
		               (silo,
		                ctrl[22],
		                3,
		                cst_flag,
		                function(b){
		                 return caml_exact_trampoline_cps_call
		                         (get$16,
		                          b,
		                          function(b){
		                           return caml_trampoline_cps_call2
		                                   (b,
		                                    a,
		                                    function(a){
		                                     return caml_trampoline_cps_call3
		     (symbol_map, a, of_string$0, cont);
		                                    });
		                          });
		                });
		      }
		      var
		       c =
		         [0,
		          call_async
		           (cst_set,
		            "Set a flag value",
		            [0,
		             [0, cst_flag, schematic_param_name_schema_ve, 0],
		             [0, [0, cst_value, bool_schema, 0], 0]],
		            schematic_param_a_schema_versi,
		            local_only(side, v)),
		          0],
		       a = [0, e, b],
		       d = local_only(side, v$0);
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               bool_schema,
		               function(b){
		                return caml_exact_trampoline_cps_call$1
		                        (namespace_ctrl,
		                         cst_flag,
		                         [0,
		                          call_async
		                           (cst_get$0,
		                            "Get a flag value",
		                            [0, [0, cst_flag, schematic_param_name_schema_ve, 0], 0],
		                            b,
		                            d),
		                          c],
		                         function(e){
		                          var
		                           b = local_only(side, all$26),
		                           all =
		                             call_reactive
		                              (cst_all,
		                               "All of the user's workspace ids",
		                               0,
		                               list_schema(schema$39),
		                               b),
		                           c = [0, e, a],
		                           d = local_only(side, finalize$0);
		                          function schematic_version(param, cont){return cont(0);}
		                          var
		                           account_id = [0, cst_account, schema$38, 0],
		                           workspace_id = [0, cst_id, schema$39, 0];
		                          return caml_exact_trampoline_cps_call
		                                  (schema_versioned$221,
		                                   schematic_version,
		                                   function(a){
		                                    a =
		                                     [0,
		                                      call_async
		                                       ("finalize",
		"Finalize an attachment to obtain its definitive URL.",
		[0, workspace_id, [0, [0, cst_url, schema$262, 0], 0]],
		a,
		d),
		                                      0];
		                                    var
		                                     space =
		                                       [0,
		call_async
		 (cst_create,
		  "Create an attachment with the given file name and MIME type. Data must subsequently be uploaded at the returned URL with a standard, fetch-compatible HTTP PUT. Once uploaded, call `finalize`.",
		  [0,
		   workspace_id,
		   [0,
		    [0, cst_mime, schematic_param_name_schema_ve, 0],
		    [0, [0, cst_filename, schematic_param_name_schema_ve, 0], 0]]],
		  schema$262,
		  local_only(side, create$44)),
		a];
		                                    function v(ctrl, cont){
		                                     return cont(personal_workspace_id(ctrl[2]));
		                                    }
		                                    var
		                                     personal_id =
		                                       call$4
		("personal_id",
		 "The user's personal workspace id",
		 0,
		 schema$39,
		 local_only(side, v)),
		                                     b = local_only(side, get$18);
		                                    function schematic_version(param, cont){return cont(0);}
		                                    var attachment = [0, cst_attachment, space];
		                                    return caml_exact_trampoline_cps_call
		    (full_workspace_schema_versione,
		     schematic_version,
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               a,
		               function(a){
		                var
		                 get =
		                   call_reactive
		                    (cst_get$0,
		                     "Get a user's workspace",
		                     [0, workspace_id, 0],
		                     a,
		                     b),
		                 get_default =
		                   call_reactive
		                    (cst_default,
		                     "The user's personal workspace",
		                     0,
		                     full_workspace_schema,
		                     local_only(side, get_personal));
		                function v(ctrl, workspace, cont){
		                 function a(crdt, cont){
		                  return caml_exact_trampoline_cps_call$3
		                          (create$43, ctrl, crdt, 0, 0, workspace, cont);
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (writable$0,
		                          ctrl[2],
		                          function(b){
		                           return caml_trampoline_cps_call3(let$35, b, a, cont);
		                          });
		                }
		                var
		                 a = local_only(side, v),
		                 schema = include$293[5],
		                 create =
		                   call_async
		                    (cst_create,
		                     "Create a workspace",
		                     [0, [0, cst_workspace, schema, 0], 0],
		                     schema$39,
		                     a),
		                 d = local_only(side, members$0);
		                return caml_exact_trampoline_cps_call
		                        (schema_versioned$117,
		                         dummy,
		                         function(b){
		                          var
		                           all$0 =
		                             call_reactive
		                              (cst_all,
		                               "Workspace members",
		                               [0, workspace_id, 0],
		                               [0, 0, 0, [3, b], 0],
		                               d);
		                          function v(ctrl, id, access_role, account, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$7
		                                    (member_add,
		                                     ctrl,
		                                     crdt,
		                                     apply$125,
		                                     id,
		                                     access_role,
		                                     account,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (symbol_map$25,
		      b,
		      of_string$14,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$36, b, a, cont);
		      });
		                                    });
		                          }
		                          var
		                           add =
		                             call_async
		                              (cst_add,
		                               "Add workspace member",
		                               [0,
		                                workspace_id,
		                                [0, [0, cst_role, schema$41, 0], [0, account_id, 0]]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v));
		                          function v$0(ctrl, id, account, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$2
		                                    (member_remove,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     account,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (symbol_map$25,
		      b,
		      of_string$14,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$36, b, a, cont);
		      });
		                                    });
		                          }
		                          var
		                           remove =
		                             call_async
		                              (cst_remove,
		                               "Remove workspace member",
		                               [0, workspace_id, [0, account_id, 0]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v$0));
		                          function v$1(ctrl, id, account, new_role, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$3
		                                    (member_set_role,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     account,
		                                     new_role,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3
		     (symbol_map$25,
		      b,
		      of_string$14,
		      function(b){
		       return caml_exact_trampoline_cps_call$1(let$36, b, a, cont);
		      });
		                                    });
		                          }
		                          var
		                           set_role =
		                             call_async
		                              (cst_set_role,
		                               "Update workspace member role",
		                               [0,
		                                workspace_id,
		                                [0, account_id, [0, [0, "new_role", schema$41, 0], 0]]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v$1));
		                          function v$2(ctrl, id, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (remove$27,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$34, b, a, cont);
		                                    });
		                          }
		                          var
		                           remove$0 =
		                             call_async
		                              (cst_remove,
		                               "Delete a workspace",
		                               [0, workspace_id, 0],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v$2));
		                          function v$3(ctrl, id, new_name, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$2
		                                    (rename$0,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     new_name,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$34, b, a, cont);
		                                    });
		                          }
		                          var
		                           rename =
		                             call_async
		                              (cst_rename,
		                               "Rename a workspace",
		                               [0,
		                                workspace_id,
		                                [0, [0, "new_name", schematic_param_name_schema_ve, 0], 0]],
		                               schematic_param_a_schema_versi,
		                               local_only(side, v$3));
		                          function v$4(ctrl, id, home, cont){
		                           function a(crdt, cont){
		                            return caml_exact_trampoline_cps_call$2
		                                    (set_home$0,
		                                     ctrl,
		                                     crdt,
		                                     id,
		                                     home,
		                                     function(a){
		                                      return caml_trampoline_cps_call2(return$12, a, cont);
		                                     });
		                           }
		                           return caml_exact_trampoline_cps_call
		                                   (writable$0,
		                                    ctrl[2],
		                                    function(b){
		                                     return caml_trampoline_cps_call3(let$34, b, a, cont);
		                                    });
		                          }
		                          var
		                           a = local_only(side, v$4),
		                           members =
		                             [0,
		                              cst_member,
		                              [0, all$0, [0, add, [0, remove, [0, set_role, 0]]]]];
		                          return caml_exact_trampoline_cps_call
		                                  (option_schema,
		                                   schema$22,
		                                   function(schema){
		                                    var
		                                     set_home =
		                                       call_async
		(cst_set_home,
		 "Set the workspace home object id",
		 [0, workspace_id, [0, [0, cst_home, schema, 0], 0]],
		 schematic_param_a_schema_versi,
		 a);
		                                    function v(ctrl, id, table_id, config, cont){
		                                     function a(crdt, cont){
		                                      var
		                                       binding_id = make$55(),
		                                       config$0 =
		 [0,
		  id,
		  table_id,
		  config[3],
		  config[4],
		  config[5],
		  config[6]],
		                                       binding = make$56(0, config$0),
		                                       open =
		 o
		  ([0,
		    symbol_bind$1,
		    symbol_map$0,
		    Let_syntax$0,
		    ,
		    bind$1,
		    of_string$0,
		    map$5]),
		                                       let$ = open[4];
		                                      function a(param, cont){return cont(binding_id);}
		                                      return caml_trampoline_cps_call3
		      (add$30,
		       binding_id,
		       binding,
		       function(b){
		        return caml_exact_trampoline_cps_call
		                (task_bindings,
		                 b,
		                 function(b){
		                  return caml_exact_trampoline_cps_call$2
		                          (apply$125,
		                           ctrl[1],
		                           crdt,
		                           id,
		                           b,
		                           function(b){
		                            return caml_trampoline_cps_call3(let$, b, a, cont);
		                           });
		                 });
		       });
		                                     }
		                                     return caml_exact_trampoline_cps_call
		     (writable$0,
		      ctrl[2],
		      function(b){
		       return caml_trampoline_cps_call3(let$35, b, a, cont);
		      });
		                                    }
		                                    var
		                                     b = local_only(side, v),
		                                     schema$0 = Table[5],
		                                     add =
		                                       call_async
		(cst_add,
		 "Create a task binding stored in this workspace, for one of its own tables.",
		 [0,
		  workspace_id,
		  [0,
		   [0, cst_table_id, schema$0, 0],
		   [0, [0, cst_config, schema$126, 0], 0]]],
		 schema$124,
		 b);
		                                    return caml_exact_trampoline_cps_call$1
		    (namespace_ctrl,
		     cst_workspace,
		     [0,
		      all,
		      [0,
		       attachment,
		       [0,
		        create,
		        [0,
		         get,
		         [0,
		          get_default,
		          [0,
		           members,
		           [0,
		            personal_id,
		            [0,
		             remove$0,
		             [0,
		              rename,
		              [0, set_home, [0, [0, cst_task_bindings$0, [0, add, 0]], 0]]]]]]]]]]],
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (option_schema,
		               schematic_param_name_schema_ve,
		               bNQ
		                (of_string$0,
		                 stable_sort,
		                 take$0,
		                 is_some,
		                 value$4,
		                 some_if,
		                 find_packed_by_id,
		                 encode,
		                 bool_schema,
		                 object_wrap,
		                 list_schema,
		                 mapping_schema,
		                 option_schema,
		                 timezone_local,
		                 of_time$0,
		                 of_string$14,
		                 return$9,
		                 to_option$2,
		                 map$18,
		                 schema_versioned$7,
		                 attach,
		                 detach,
		                 trigger$0,
		                 return$12,
		                 return$13,
		                 schema$10,
		                 schema$11,
		                 of_string$19,
		                 Device,
		                 include$48,
		                 schema_versioned$103,
		                 schema$20,
		                 schema$21,
		                 pp$43,
		                 schema_versioned$116,
		                 schema$37,
		                 schema$38,
		                 schema_versioned$118,
		                 schema_versioned$120,
		                 schema$39,
		                 to_string$47,
		                 schema_versioned$131,
		                 schema$46,
		                 schema_versioned$139,
		                 schema$49,
		                 By_id,
		                 schema_versioned$175,
		                 schema$63,
		                 client_grant_schema,
		                 schema$66,
		                 schema$69,
		                 schema$70,
		                 schema_versioned$188,
		                 schema$71,
		                 compare$108,
		                 schema$72,
		                 personal_organization_of_user_,
		                 schema$78,
		                 schema$80,
		                 schema$81,
		                 schema$83,
		                 schema$84,
		                 schema$85,
		                 impersonation_schema,
		                 schema$96,
		                 schema$97,
		                 schema$98,
		                 base_client_schema,
		                 schema$99,
		                 Id$8,
		                 of_google_email,
		                 Patch$0,
		                 schema$120,
		                 access_token_response_schema,
		                 Id$9,
		                 schema_versioned$315,
		                 schema$130,
		                 source_schema,
		                 action_schema$5,
		                 event_schema,
		                 object$0,
		                 ai_mcp_server,
		                 schema$140,
		                 schema$141,
		                 schema_versioned$341,
		                 schema$142,
		                 schema_versioned$342,
		                 schema$143,
		                 mention_origin_schema,
		                 view_schema,
		                 remove$7,
		                 set$14,
		                 Synchronization_state,
		                 v$17,
		                 calendars_state,
		                 google,
		                 element$2,
		                 ignore_m$7,
		                 Enabled_data_collections$0,
		                 enabled_data_collections,
		                 mru_people,
		                 Email$0,
		                 v$47,
		                 connections,
		                 integration_app,
		                 notices_personal_archived,
		                 notices_personal_viewed,
		                 settings,
		                 update_mru_people_from_diff,
		                 features_schema,
		                 document_schema,
		                 frequency_bucket_schema,
		                 schema$192,
		                 ById,
		                 schema$216,
		                 schema$218,
		                 schema$219,
		                 schema$220,
		                 schema$221,
		                 schema$222,
		                 schema$224,
		                 connected,
		                 schema$225,
		                 augmented_schema$0,
		                 schema$228,
		                 augmented_schema_versioned$1,
		                 chunk_schema_versioned,
		                 type_schema_versioned$0,
		                 schema$230,
		                 login_schema_versioned,
		                 profile_schema_versioned,
		                 profile_schema,
		                 missing_scope_info_schema_vers,
		                 map$53,
		                 fail_result,
		                 merge$5,
		                 effect_schema,
		                 default$11,
		                 set_f,
		                 push_lwt,
		                 push_dont_wait$0,
		                 device,
		                 api$1,
		                 user_id,
		                 state_personal,
		                 writable$0,
		                 apply$125,
		                 apply_personal,
		                 state_writable_personal,
		                 parser$0,
		                 mandate_parse_result_schema_ve,
		                 parse$3,
		                 completion_item_schema_version,
		                 complete_participant,
		                 complete_destination,
		                 complete_destination_in_worksp,
		                 complete_daytime,
		                 complete_date,
		                 profile_feature_schema_version,
		                 notify_f$0,
		                 notify$0,
		                 offline$0,
		                 user_id$0,
		                 claim_account,
		                 logout,
		                 delete_account,
		                 refresh$0,
		                 request_scopes,
		                 unlink_account,
		                 add_account,
		                 handle_login_intent,
		                 get$20,
		                 client_data,
		                 client_data_all,
		                 main,
		                 all$28,
		                 feature_has$0,
		                 feature_has$1,
		                 patch$5,
		                 value$11,
		                 hours_config,
		                 locale$0,
		                 create$48,
		                 delete$2,
		                 update$14,
		                 move$4,
		                 all$29,
		                 get$23,
		                 default$13,
		                 all$30,
		                 refresh$1,
		                 select,
		                 set_default,
		                 upcoming_notifications,
		                 filter_schema_versioned$0,
		                 all$31,
		                 get$26,
		                 create_mention,
		                 delete_mention,
		                 mark$0,
		                 mark_unviewed,
		                 get$28,
		                 hierarchy_schema,
		                 archived$0,
		                 archive,
		                 create$51,
		                 delete$4,
		                 hierarchy$0,
		                 without_title,
		                 move$6,
		                 unarchive,
		                 update$16,
		                 bSa,
		                 get$30,
		                 by_email,
		                 refresh$2,
		                 update$17,
		                 local_only,
		                 call_reactive,
		                 call$4,
		                 call_async,
		                 call_hook,
		                 map_context,
		                 creation_option_default,
		                 creation_option_schema_version,
		                 rpcs,
		                 let$39,
		                 let$40,
		                 let$41,
		                 let$42,
		                 rpcs$0,
		                 list$2,
		                 find$9,
		                 upsert$3,
		                 remove$28,
		                 discover_authorization_servers,
		                 probe_and_store,
		                 authorize$2,
		                 ai_with_limit_result_schema,
		                 rpcs$1,
		                 symbol_map$27,
		                 local_only(side, authorize$3),
		                 0,
		                 let$63,
		                 symbol_map$28,
		                 let$65,
		                 registry,
		                 mcp_functions,
		                 descriptor$61,
		                 call_tool$0,
		                 generate_access_token,
		                 get$35,
		                 let$66,
		                 add$38,
		                 get$36,
		                 list$3,
		                 refresh$3,
		                 remove$29,
		                 update$19,
		                 exchange_token,
		                 generate_import_id,
		                 let$67,
		                 rpcs$2,
		                 let$68,
		                 let$69,
		                 let$70,
		                 rpcs$3,
		                 append$16,
		                 remove_metadata,
		                 let$71,
		                 get$40,
		                 patch$6,
		                 perform_action,
		                 let$72,
		                 let$73,
		                 controller_supported_actions_s,
		                 let$74,
		                 let$75,
		                 let$76,
		                 let$77,
		                 accounts,
		                 impersonate,
		                 side,
		                 config,
		                 namespace_ctrl,
		                 [0, a, c],
		                 Read$5,
		                 Patch$2,
		                 schema$262,
		                 schema$263,
		                 schema$265,
		                 [0, cst_client, schema$282, 0],
		                 no_input_schema,
		                 schematic_param_a_schema_versi,
		                 schematic_param_name_schema_ve,
		                 json_schema,
		                 int_schema,
		                 cont));
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               caml_callback(encode$10, [profile_schema]);
		               function js_error_of_string(s){
		                var t1 = caml_jsstring_of_string(s);
		                return new error_constr(t1);
		               }
		               function js_raise(fmt, cont){
		                function f(s, cont){
		                 return cont(caml_throw_js_exception(js_error_of_string(s)));
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf, f, fmt, cont);
		               }
		               var
		                recurrence_of_js_exn = helpers(cst_recurrence, schema$10)[3],
		                e = helpers(cst_document, schema$192),
		                of_js_exn$0 = e[3],
		                to_js$2 = e[1],
		                to_js$3 = helpers(cst_block, schema$49)[1],
		                schema$260 = include$48[5],
		                make$139 = include$48[29],
		                to_js$4 = helpers("block id", schema$260)[1],
		                of_js_exn$1 = helpers("locale configuration", schema$80)[3],
		                of_js_exn$2 = helpers(cst_mandate, schema$189)[3],
		                action_to_js = helpers(cst_action, action_schema$11)[1],
		                of_js_exn$3 = helpers(cst_recurrence, schema$10)[3];
		               function actions
		               (default_document, title, query, contextual, cont){
		                var
		                 open =
		                   g
		                    ([0,
		                      symbol_bind$5,
		                      symbol_map$5,
		                      ,
		                      bind$8,
		                      return$9,
		                      map$17,
		                      ,
		                      ,
		                      ,
		                      ,
		                      Let_syntax$3]),
		                 symbol_bind = open[1];
		                function a(query){
		                 var a = query[3];
		                 if(a){
		                  a = a[1];
		                  if(0 === a[0])
		                   var id = a[1], document = 0, calendar = [0, id];
		                  else
		                   var doc = a[1], document = [0, doc], calendar = 0;
		                 }
		                 else {document = 0; calendar = 0;}
		                 var
		                  duration = value$4(query[4], duration_default),
		                  has_participants = query[6] ? 1 : 0,
		                  participants = query[6],
		                  a = query[8];
		                 if(a){
		                  var recurrence = a[1];
		                  return caml_trampoline_cps_call3
		                          (symbol_bind,
		                           query[2],
		                           function(param, cont){
		                            if(param[2]) return cont(0);
		                            var start = param[1];
		                            return cont([0, [0, start, duration]]);
		                           },
		                           function(daytime){
		                            var
		                             time =
		                               [0, calendar, [1, recurrence], daytime, document, query[6]];
		                            return is_some(daytime)
		                                    ? cont([0, [0, 81098820, time], 0])
		                                    : cont([0, [0, 1055840202, [0, recurrence, document]], 0]);
		                           });
		                 }
		                 var
		                  allocation =
		                    [0,
		                     calendar,
		                     query[1],
		                     query[2],
		                     document,
		                     duration,
		                     participants,
		                     query[8],
		                     query[9]];
		                 if
		                  (!
		                   is_some(query[9])
		                   &&
		                    !
		                    is_some(calendar)
		                    &&
		                     !
		                     is_some(query[4])
		                     && ! is_some(query[2]) && ! has_participants){
		                  a = query[1];
		                  if(a){
		                   var dates = a[1];
		                   if(0 !== dates[0])
		                    return caml_exact_trampoline_cps_call
		                            (first_date,
		                             dates,
		                             function(date){
		                              var
		                               labels = query[5],
		                               priority = query[7],
		                               actions =
		                                 contextual
		                                  ? [0,
		                                    [0, 63748398, [0, 0, labels, priority, [0, date, document]]],
		                                    [0,
		                                     [0, 63748398, [0, 1, labels, priority, [0, date, document]]],
		                                     [0, [0, -5494395, allocation], 0]]]
		                                  : [0,
		                                    [0, 63748398, [0, 0, labels, priority, [0, date, document]]],
		                                    [0,
		                                     [0, 144189434, [0, 0, labels, priority, allocation]],
		                                     [0, [0, -5494395, allocation], 0]]];
		                              function a(match){
		                               if(! match) return cont(actions);
		                               var
		                                batch = match[1],
		                                actions$0 =
		                                  contextual
		                                   ? cons$3
		                                     ([0,
		                                       -463576851,
		                                       [0, 1, labels, priority, [0, batch, document]]],
		                                      actions)
		                                   : actions;
		                               return cont
		                                       (cons$3
		 ([0,
		   -463576851,
		   [0, 0, labels, priority, [0, batch, document]]],
		  actions$0));
		                              }
		                              return dates[0] < 2
		                                      ? a(0)
		                                      : caml_exact_trampoline_cps_call
		(first_date,
		 dates,
		 function(start){
		  return caml_exact_trampoline_cps_call
		          (of_date$1, start, function(batch){return a([0, batch]);});
		 });
		                             });
		                   var date = dates[1], labels = query[5], priority = query[7];
		                   return contextual
		                           ? cont
		                             ([0,
		                               [0, 63748398, [0, 0, labels, priority, [0, date, document]]],
		                               [0,
		                                [0, 63748398, [0, 1, labels, priority, [0, date, document]]],
		                                [0, [0, -5494395, allocation], 0]]])
		                           : cont
		                             ([0,
		                               [0, 63748398, [0, 0, labels, priority, [0, date, document]]],
		                               [0,
		                                [0, 144189434, [0, 0, labels, priority, allocation]],
		                                [0, [0, -5494395, allocation], 0]]]);
		                  }
		                  var
		                   default_document$0 = first_some(document, default_document),
		                   explicitely_redirected = is_some(document),
		                   task =
		                     [0,
		                      936373093,
		                      [0, 0, query[5], query[7], [0, query[10], document]]];
		                  if(! contextual)
		                   return caml_exact_trampoline_cps_call
		                           (today,
		                            dummy,
		                            function(a){
		                             var
		                              scheduling =
		                                [0, 63748398, [0, 0, query[5], query[7], [0, a, document]]];
		                             return caml_exact_trampoline_cps_call
		                                     (today,
		                                      dummy,
		                                      function(a){
		                                       return caml_exact_trampoline_cps_call
		       (of_date$1,
		        a,
		        function(a){
		         var
		          postponing =
		            [0,
		             -463576851,
		             [0, 0, query[5], query[7], [0, a, document]]];
		         if(document){
		          var document$0 = document[1];
		          return cont
		                  ([0,
		                    task,
		                    [0,
		                     scheduling,
		                     [0, postponing, [0, [0, -494360719, [0, document$0, 2]], 0]]]]);
		         }
		         if(default_document$0)
		          var
		           document$1 = default_document$0[1],
		           note = [0, [0, -494360719, [0, document$1, 2]], 0];
		         else
		          note = 0;
		         return cont
		                 ([0,
		                   task,
		                   [0, scheduling, [0, postponing, [0, -535055569, note]]]]);
		        });
		                                      });
		                            });
		                  var
		                   capture_task =
		                     [0,
		                      936373093,
		                      [0, 1, query[5], query[7], [0, query[10], document]]];
		                  if(default_document$0)
		                   var
		                    default_document$1 = default_document$0[1],
		                    redirections =
		                      [0,
		                       [0, -494360719, [0, default_document$1, 2]],
		                       [0,
		                        [0, -494360719, [0, default_document$1, 0]],
		                        [0, [0, -494360719, [0, default_document$1, 1]], 0]]],
		                    actions =
		                      explicitely_redirected
		                       ? redirections
		                       : [0, -971241045, redirections],
		                    with_context = [0, capture_task, actions];
		                  else
		                   with_context = [0, capture_task, bML];
		                  return title === cst$1
		                          ? cont(with_context)
		                          : cont(cons$3(task, with_context));
		                 }
		                 return has_participants
		                         ? cont([0, [0, -5494395, allocation], 0])
		                         : cont
		                           ([0,
		                             [0, 144189434, [0, 0, query[5], query[7], allocation]],
		                             [0, [0, -5494395, allocation], 0]]);
		                }
		                if(query[1]) return a(query);
		                if(! query[2]) return a(query);
		                var
		                 b = query[10],
		                 c = query[9],
		                 d = query[8],
		                 e = query[7],
		                 f = query[6],
		                 h = query[5],
		                 i = query[4],
		                 j = query[3],
		                 k = query[2];
		                return caml_exact_trampoline_cps_call
		                        (today,
		                         dummy,
		                         function(g){
		                          return a([0, [0, [0, g]], k, j, i, h, f, e, d, c, b]);
		                         });
		               }
		               var vue = require$$5, vue_watch = vue.watch;
		               function watch$2(ref, f){
		                var
		                 unwatch = vue_watch(ref, caml_js_wrap_callback_strict(1, f));
		                return function(param, cont){unwatch(); return cont(0);};
		               }
		               var
		                vue_ref = vue.ref,
		                proxy = global$0.Proxy,
		                reflect = global$0.Reflect;
		               function release$0(ref, cont){
		                var metadata = ref.__metadata;
		                metadata[3] = 1;
		                return caml_trampoline_cps_call2
		                        (metadata[4],
		                         0,
		                         function(a){
		                          return caml_trampoline_cps_call2(metadata[5], 0, cont);
		                         });
		               }
		               var
		                finalization_registry = global$0.FinalizationRegistry,
		                finalizer =
		                  new
		                   finalization_registry
		                   (caml_js_wrap_callback_strict
		                     (1,
		                      function(ref, cont){
		                       var metadata = ref.__metadata;
		                       metadata[2] = metadata[2] - 1 | 0;
		                       var
		                        a = 0 === metadata[2] ? 1 : 0,
		                        a = a ? 1 - metadata[3] : a;
		                       return a
		                               ? caml_exact_trampoline_cps_call$1
		                                 (warn,
		                                  0,
		                                  function(m, cont){
		                                   return caml_trampoline_cps_call5
		   (m, 0, 0, bMM, metadata[1], cont);
		                                  },
		                                  function(match){
		                                   return caml_exact_trampoline_cps_call(release$0, ref, cont);
		                                  })
		                               : cont(a);
		                      }));
		               function map$56(v, f){
		                var metadata = v.__metadata;
		                metadata[2] = metadata[2] + 1 | 0;
		                var v$0 = f(v.value), res = vue_ref(v$0);
		                watch$2(v, function(v, cont){return cont(res.value = f(v));});
		                res.__metadata = metadata;
		                return res;
		               }
		               var ref_proxy = [];
		               caml_update_dummy
		                (ref_proxy,
		                 [246,
		                  function(param, cont){
		                   return cont
		                           ({get:
		                             caml_js_wrap_callback_strict
		                              (3,
		                               function(target, prop, receiver, cont){
		                                return prop === cst_release
		? cont
		  (caml_js_wrap_callback_strict
		    (1,
		     function(param, cont){
		      return caml_exact_trampoline_cps_call
		              (release$0, target, function(a){return cont(target.value);});
		     }))
		: prop
		  === cst_map
		  ? cont
		    (caml_js_wrap_callback_strict
		      (1,
		       function(f, cont){
		        var ref = map$56(target, f), a = caml_obj_tag(ref_proxy);
		        function b(a){
		         var res = new proxy(ref, a);
		         finalizer.register(res, ref);
		         return cont(res);
		        }
		        if(250 === a) return b(ref_proxy[1]);
		        if(246 !== a && 244 !== a) return b(ref_proxy);
		        return caml_exact_trampoline_cps_call
		                (force_lazy_block, ref_proxy, b);
		       }))
		  : cont(reflect.get(target, prop, receiver));
		                               }),
		                             has:
		                             caml_js_wrap_callback_strict
		                              (2,
		                               function(target, prop, cont){
		                                var a = prop === cst_release ? 1 : 0;
		                                if(a)
		                                 ;
		                                else {
		                                 a = prop === cst_map ? 1 : 0;
		                                 a ||= reflect.has(target, prop) | 0;
		                                }
		                                return cont(a);
		                               })});
		                  }]);
		               e = caml_obj_tag(ref_proxy);
		               a:
		               if(250 === e)
		                var ref_proxy$0 = ref_proxy[1];
		               else {
		                if(246 !== e && 244 !== e){ref_proxy$0 = ref_proxy; break a;}
		                ref_proxy$0 = caml_callback(force_lazy_block, [ref_proxy]);
		               }
		               function of_var(name, var$, f, cont){
		                return caml_exact_trampoline_cps_call
		                        (get$17,
		                         var$,
		                         function(a){
		                          return caml_exact_trampoline_cps_call
		                                  (f,
		                                   a,
		                                   function(v){
		                                    var ref = vue_ref(v);
		                                    return caml_exact_trampoline_cps_call$0
		    (watch$1,
		     0,
		     var$,
		     function(v, cont){
		      return caml_exact_trampoline_cps_call
		              (f, v, function(a){return cont(ref.value = a);});
		     },
		     function(unwatch){
		      ref.__metadata =
		       [0,
		        name,
		        1,
		        0,
		        unwatch,
		        function(param, cont){
		         return caml_exact_trampoline_cps_call(release, var$, cont);
		        }];
		      var res = new proxy(ref, ref_proxy$0);
		      finalizer.register(res, ref);
		      return cont(res);
		     });
		                                   });
		                         });
		               }
		               function to_var(ref, f, cont){
		                var var$ = [], unwatch = [];
		                caml_update_dummy
		                 (var$,
		                  [246,
		                   function(param, cont){
		                    return caml_exact_trampoline_cps_call
		                            (f,
		                             ref.value,
		                             function(a){
		                              return caml_exact_trampoline_cps_call$1
		                                      (make$136,
		                                       [0,
		function(a, cont){
		 a = caml_obj_tag(unwatch);
		 function b(a){return caml_trampoline_cps_call2(a, 0, cont);}
		 if(250 === a) return b(unwatch[1]);
		 if(246 !== a && 244 !== a) return b(unwatch);
		 return caml_exact_trampoline_cps_call
		         (force_lazy_block, unwatch, b);
		}],
		                                       a,
		                                       cont);
		                             });
		                   }]);
		                caml_update_dummy
		                 (unwatch,
		                  [246,
		                   function(a, cont){
		                    return cont
		                            (watch$2
		                              (ref,
		                               function(v, cont){
		                                return caml_exact_trampoline_cps_call
		(f,
		 v,
		 function(c){
		  var a = caml_obj_tag(var$);
		  function b(a){
		   return caml_trampoline_cps_call2(a[2], c, cont);
		  }
		  if(250 === a) return b(var$[1]);
		  if(246 !== a && 244 !== a) return b(var$);
		  return caml_exact_trampoline_cps_call
		          (force_lazy_block, var$, b);
		 });
		                               }));
		                   }]);
		                var a = caml_obj_tag(unwatch);
		                function b(a){
		                 a = caml_obj_tag(var$);
		                 function b(a){return cont(a[1]);}
		                 if(250 === a) return b(var$[1]);
		                 if(246 !== a && 244 !== a) return b(var$);
		                 return caml_exact_trampoline_cps_call
		                         (force_lazy_block, var$, b);
		                }
		                if(250 === a) return b(0);
		                if(246 !== a && 244 !== a) return b(0);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, unwatch, b);
		               }
		               function to_js$5(convert, hook){
		                function t3(param, witness, cont){
		                 return caml_exact_trampoline_cps_call$1
		                         (detach,
		                          hook[1],
		                          witness,
		                          function(a){hook[1] = a; return cont(0);});
		                }
		                function t2(param, cb, cont){
		                 function cb$0(v, cont){
		                  return caml_exact_trampoline_cps_call
		                          (convert, v, function(a){return cont(cb(a));});
		                 }
		                 return caml_exact_trampoline_cps_call$1
		                         (attach,
		                          hook[1],
		                          cb$0,
		                          function(match){
		                           var witness = match[2], h = match[1];
		                           hook[1] = h;
		                           return cont(witness);
		                          });
		                }
		                return {attach: caml_js_wrap_meth_callback(t2),
		                        detach: caml_js_wrap_meth_callback(t3)};
		               }
		               var
		                open$52 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol_bind$29 = open$52[1],
		                let$78 = open$52[4],
		                finalization_registry$0 = global$0.FinalizationRegistry,
		                finalizer$0 =
		                  new
		                   finalization_registry$0
		                   (caml_js_wrap_callback_strict
		                     (1,
		                      function(release, cont){
		                       return caml_trampoline_cps_call2(release, 0, cont);
		                      }));
		               function variadic_callback(arity, f){
		                function variadic(acc, n){
		                 return 0 === n
		                         ? function
		                          (param, cont){
		                           return caml_exact_trampoline_cps_call(f, acc, cont);
		                          }
		                         : function
		                          (arg, cont){
		                           var a = n - 1 | 0;
		                           return caml_exact_trampoline_cps_call$1
		                                   (append$0,
		                                    acc,
		                                    [0, arg, 0],
		                                    function(b){return cont(variadic(b, a));});
		                          };
		                }
		                return caml_js_wrap_callback_strict
		                        (arity + 1 | 0, variadic(0, arity));
		               }
		               var
		                Coding$3 =
		                  [248,
		                   "Controller_client.Vue_coding.Coding",
		                   caml_fresh_oo_id()];
		               function of_any$2(coding, v, cont){
		                return coding === Coding$3
		                        ? cont([0, v])
		                        : caml_exact_trampoline_cps_call$1
		                          (of_any$1, coding, v, cont);
		               }
		               var
		                name$34 = "Vue",
		                include$291 =
		                  caml_callback
		                   (Make$5,
		                    [[0,
		                      Coding$3,
		                      name$34,
		                      ,
		                      pp$122,
		                      key_get$0,
		                      key_set$0,
		                      null$3,
		                      of_any$2,
		                      of_bool$1,
		                      of_date$4,
		                      of_fields$1,
		                      of_float$5,
		                      of_int$7,
		                      of_int64$1,
		                      of_json$1,
		                      of_list$10,
		                      of_option$3,
		                      of_string$48,
		                      of_time$4,
		                      of_time_local$1,
		                      to_bool$1,
		                      to_date$3,
		                      to_fields$1,
		                      to_float$4,
		                      to_int$5,
		                      to_int64$3,
		                      to_json$1,
		                      to_list$7,
		                      to_option$4,
		                      to_string$61,
		                      to_time$6,
		                      to_time_local$1,
		                      type_name$1]]),
		                encode$13 = include$291[2],
		                decode$16 = include$291[4];
		               function remote_value_schema(id, side){
		                if(! side) return schema$253(id, side);
		                var schema = schema$253(id, side);
		                return [0,
		                        schema[1],
		                        schema[2],
		                        [1,
		                         function(coding, cont){
		                          if(coding && coding[1] === Coding$3){
		                           var
		                            decode =
		                              function(js, cont){
		                               return caml_trampoline_cps_call2
		                                       (of_string$14, js.value, cont);
		                              },
		                            encode =
		                              function(value, cont){
		                               var
		                                release =
		                                  caml_js_wrap_callback_strict
		                                   (1,
		                                    function(param, cont){
		                                     var release = value[2];
		                                     return caml_trampoline_cps_call2(release, 0, cont);
		                                    }),
		                                res = {value: value, release: release};
		                               finalizer$0.register(res, release);
		                               return cont(res);
		                              };
		                           return cont
		                                   ([4,
		                                     decode,
		                                     encode,
		                                     [0,
		                                      [0,
		                                       Coding$3,
		                                       name$34,
		                                       compare$140,
		                                       pp$122,
		                                       key_get$0,
		                                       key_set$0,
		                                       null$3,
		                                       of_any$2,
		                                       of_bool$1,
		                                       of_date$4,
		                                       of_fields$1,
		                                       of_float$5,
		                                       of_int$7,
		                                       of_int64$1,
		                                       of_json$1,
		                                       of_list$10,
		                                       of_option$3,
		                                       of_string$48,
		                                       of_time$4,
		                                       of_time_local$1,
		                                       to_bool$1,
		                                       to_date$3,
		                                       to_fields$1,
		                                       to_float$4,
		                                       to_int$5,
		                                       to_int64$3,
		                                       to_json$1,
		                                       to_list$7,
		                                       to_option$4,
		                                       to_string$61,
		                                       to_time$6,
		                                       to_time_local$1,
		                                       type_name$1]]]);
		                          }
		                          return cont(schema[3]);
		                         }],
		                        schema[4]];
		               }
		               function remote_controller(Remote, remote, cont){
		                function of_rpcs(prefix, js, param, cont){
		                 function a(param){
		                  if(! param) return cont(js);
		                  var match = param[1];
		                  if(0 === match[0]){
		                   var
		                    tail = param[2],
		                    space = match[2],
		                    name = match[1],
		                    s2 = name + cst$14;
		                   return caml_exact_trampoline_cps_call$0
		                           (of_rpcs,
		                            prefix + s2,
		                            {},
		                            space,
		                            function(namespace){
		                             return caml_exact_trampoline_cps_call
		                                     (caml_case,
		                                      name,
		                                      function(b){
		                                       js[b] = namespace;
		                                       return caml_exact_trampoline_call1(a, tail);
		                                      });
		                            });
		                  }
		                  var
		                   tail$0 = param[2],
		                   value = match[3],
		                   name$0 = match[2],
		                   name$1 = prefix + name$0;
		                  function decode_args(formal, effective, cont){
		                   if(! formal)
		                    return effective
		                            ? caml_exact_trampoline_cps_call$1(fatal$0, bMS, bMR, cont)
		                            : cont(bMT);
		                   if(! effective)
		                    return caml_exact_trampoline_cps_call$1
		                            (fatal$0, bMQ, bMP, cont);
		                   var
		                    effective$0 = effective[2],
		                    arg = effective[1],
		                    formal$0 = formal[2],
		                    match = formal[1],
		                    schema = match[2],
		                    arg_name = match[1];
		                   return caml_trampoline_cps_call3
		                           (decode$16,
		                            schema,
		                            arg,
		                            function(match){
		                             if(0 === match[0]){
		                              var arg = match[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (decode_args,
		                                       formal$0,
		                                       effective$0,
		                                       function(match){
		var args = match[2], schemas = match[1];
		return cont([0, [0, schema, schemas], [0, arg, args]]);
		                                       });
		                             }
		                             var e = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (fatal$0,
		                                      bMO,
		                                      bMN,
		                                      function(a){
		                                       return caml_trampoline_cps_call5
		       (a, name$1, arg_name, pp_decoding, e, cont);
		                                      });
		                            });
		                  }
		                  function decode_args_lwt_result(formal, effective, cont){
		                   if(! formal)
		                    return effective
		                            ? caml_exact_trampoline_cps_call$1(fatal$0, bMZ, bMY, cont)
		                            : cont(bM0);
		                   if(! effective)
		                    return caml_exact_trampoline_cps_call$1
		                            (fatal$0, bMX, bMW, cont);
		                   var
		                    effective$0 = effective[2],
		                    arg = effective[1],
		                    formal$0 = formal[2],
		                    match = formal[1],
		                    schema = match[2],
		                    arg_name = match[1];
		                   return caml_trampoline_cps_call3
		                           (decode$16,
		                            schema,
		                            arg,
		                            function(match){
		                             if(0 === match[0]){
		                              var arg = match[1];
		                              return caml_exact_trampoline_cps_call$1
		                                      (decode_args_lwt_result,
		                                       formal$0,
		                                       effective$0,
		                                       function(match){
		var args = match[2], schemas = match[1];
		return cont([0, [0, schema, schemas], [0, arg, args]]);
		                                       });
		                             }
		                             var e = match[1];
		                             return caml_exact_trampoline_cps_call$1
		                                     (fatal$0,
		                                      bMV,
		                                      bMU,
		                                      function(a){
		                                       return caml_trampoline_cps_call5
		       (a, name$1, arg_name, pp_decoding, e, cont);
		                                      });
		                            });
		                  }
		                  var
		                   b =
		                     function(param){
		                       switch(param[0]){
		                         case 0:
		                          var result = param[2], args = param[1];
		                          return variadic_callback
		                                  (Lwt_result[2].call(null, args),
		                                   function(effective, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (decode_args_lwt_result,
		     args,
		     effective,
		     function(match){
		      var
		       args = match[2],
		       schemas = match[1],
		       promise =
		         of_lwt
		          (function(param, cont){
		            return caml_exact_trampoline_cps_call$3
		                    (Remote[3], remote, name$1, schemas, args, result, cont);
		           });
		      function f(res, cont){
		       return caml_trampoline_cps_call3
		               (encode$13, result, res, cont);
		      }
		      var t4 = caml_js_wrap_callback(f);
		      return cont(promise.then(t4));
		     });
		                                   });
		                         case 1:
		                          var result$0 = param[2], args$0 = param[1];
		                          return variadic_callback
		                                  (length$20(args$0),
		                                   function(effective, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (decode_args,
		     args$0,
		     effective,
		     function(match){
		      var
		       args = match[2],
		       schemas = match[1],
		       H = bQS(),
		       hook = [0, H[1]];
		      return caml_exact_trampoline_cps_call$3
		              (Remote[4],
		               remote,
		               name$1,
		               schemas,
		               args,
		               result$0,
		               function(match){
		                var release = match[2], stream = match[1];
		                function loop(param, cont){
		                 function a(param, cont){
		                  if(! param)
		                   return caml_trampoline_cps_call2(return$12, 0, cont);
		                  var value = param[1];
		                  return caml_exact_trampoline_cps_call$0
		                          (trigger$0,
		                           hook[1],
		                           value,
		                           0,
		                           function(match){
		                            return caml_exact_trampoline_cps_call(loop, dummy, cont);
		                           });
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (get$5,
		                          stream,
		                          function(b){
		                           return caml_trampoline_cps_call3(symbol_bind$29, b, a, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (dont_wait,
		                         loop,
		                         function(exn, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (fatal_exn, bM1, exn, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call
		                                  (encode$13,
		                                   result$0,
		                                   function(a){
		                                    var hook$0 = to_js$5(a, hook);
		                                    finalizer$0.register
		                                     (hook$0, caml_js_wrap_callback_strict(1, release));
		                                    return cont(hook$0);
		                                   });
		                         });
		               });
		     });
		                                   });
		                         default:
		                          var result$1 = param[2], args$1 = param[1];
		                          return variadic_callback
		                                  (length$20(args$1),
		                                   function(effective, cont){
		                                    return caml_exact_trampoline_cps_call$1
		    (decode_args,
		     args$1,
		     effective,
		     function(match){
		      var args = match[2], schemas = match[1];
		      function f(param, cont){
		       function a(var$, cont){
		        return caml_exact_trampoline_cps_call
		                (encode$13,
		                 result$1,
		                 function(a){
		                  return caml_exact_trampoline_cps_call$0
		                          (of_var, name$1, var$, a, cont);
		                 });
		       }
		       return caml_exact_trampoline_cps_call$3
		               (Remote[5],
		                remote,
		                name$1,
		                schemas,
		                args,
		                result$1,
		                function(b){
		                 return caml_trampoline_cps_call3(let$78, b, a, cont);
		                });
		      }
		      return cont(of_lwt(f));
		     });
		                                   });
		                       }
		                      }
		                      (value);
		                  return caml_exact_trampoline_cps_call
		                          (caml_case,
		                           name$0,
		                           function(c){
		                            js[c] = b;
		                            return caml_exact_trampoline_call1(a, tail$0);
		                           });
		                 }
		                 return a(param);
		                }
		                function callback_schema$0(name, args, result_schema, side){
		                 var
		                  schema = callback_schema(name, args, result_schema, side);
		                 return side
		                         ? [0,
		                           schema[1],
		                           schema[2],
		                           [1,
		                            function(coding, cont){
		                             if(coding && coding[1] === Coding$3){
		                              var
		                               decode =
		                                 function(js, cont){
		                                  return caml_exact_trampoline_cps_call$0
		  (Lwt_result[4],
		   [0, , encode$13],
		   args,
		   function(args, cont){
		    var match = wait(), wakeup$0 = match[2], result = match[1];
		    return caml_trampoline_cps_call3
		            (map$18,
		             args,
		             function(a, cont){return cont(a);},
		             function(a){
		              return caml_exact_trampoline_cps_call
		                      (to_array,
		                       a,
		                       function(a){
		                        var promise = caml_js_fun_call(js, a);
		                        function k(result, cont){
		                         return caml_trampoline_cps_call3
		                                 (decode$16,
		                                  result_schema,
		                                  result,
		                                  function(t){
		                                   function a(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (wakeup, wakeup$0, a, cont);
		                                   }
		                                   if(0 === t[0]) return a(t);
		                                   var error = t[1];
		                                   return caml_exact_trampoline_cps_call$1
		   (to_to_string,
		    pp_decoding,
		    error,
		    function(b){return a([1, [0, 9943782, b]]);});
		                                  });
		                        }
		                        promise.then(caml_js_wrap_callback_strict(1, k));
		                        return cont(result);
		                       });
		             });
		   },
		   function(a){
		    return caml_trampoline_cps_call2(of_string$14, a, cont);
		   });
		                                 },
		                               encode =
		                                 function(param, cont){
		                                  return caml_exact_trampoline_cps_call$1
		  (fatal$0, bM3, bM2, cont);
		                                 };
		                              return cont
		                                      ([4,
		decode,
		encode,
		[0,
		 [0,
		  Coding$3,
		  name$34,
		  compare$140,
		  pp$122,
		  key_get$0,
		  key_set$0,
		  null$3,
		  of_any$2,
		  of_bool$1,
		  of_date$4,
		  of_fields$1,
		  of_float$5,
		  of_int$7,
		  of_int64$1,
		  of_json$1,
		  of_list$10,
		  of_option$3,
		  of_string$48,
		  of_time$4,
		  of_time_local$1,
		  to_bool$1,
		  to_date$3,
		  to_fields$1,
		  to_float$4,
		  to_int$5,
		  to_int64$3,
		  to_json$1,
		  to_list$7,
		  to_option$4,
		  to_string$61,
		  to_time$6,
		  to_time_local$1,
		  type_name$1]]]);
		                             }
		                             return cont(schema[3]);
		                            }],
		                           schema[4]]
		                         : schema;
		                }
		                function json_to_js(param, cont){
		                 if(typeof param === "number") return cont(null$1);
		                 var variant = param[1];
		                 if(65 === variant){
		                  var
		                   value = param[2],
		                   ja = create$22(0),
		                   a =
		                     function(i, param){
		                      if(! param) return cont(ja);
		                      var vs = param[2], value = param[1];
		                      return caml_exact_trampoline_cps_call
		                              (json_to_js,
		                               value,
		                               function(b){
		                                ja[i] = b;
		                                var i$0 = i + 1 | 0;
		                                return caml_exact_trampoline_call2(a, i$0, vs);
		                               });
		                     };
		                  return a(0, value);
		                 }
		                 if(365180284 <= variant){
		                  if(737456202 <= variant){
		                   var value$0 = param[2];
		                   return cont(! ! value$0);
		                  }
		                  var value$1 = param[2];
		                  return cont(value$1);
		                 }
		                 if(79 <= variant){
		                  var value$2 = param[2];
		                  return caml_trampoline_cps_call3
		                          (map$18,
		                           value$2,
		                           function(param, cont){
		                            var value = param[2], key = param[1];
		                            return caml_exact_trampoline_cps_call
		                                    (json_to_js, value, function(a){return cont([0, key, a]);});
		                           },
		                           function(a){
		                            return caml_exact_trampoline_cps_call
		                                    (to_array, a, function(a){return cont(caml_js_object(a));});
		                           });
		                 }
		                 var value$3 = param[2];
		                 return cont(caml_jsstring_of_string(value$3));
		                }
		                function graph_result_to_js(value, cont){
		                 function conv(param, cont){
		                  if(typeof param === "number") return cont(null$1);
		                  switch(param[0]){
		                    case 0:
		                     var value = param[1]; return cont(! ! value);
		                    case 1:
		                     var
		                      value$0 = param[1],
		                      t1 = caml_int64_format(cst_d, value$0);
		                     return cont(global.BigInt(t1));
		                    case 2:
		                     var value$1 = param[1]; return cont(value$1);
		                    case 3:
		                     var value$2 = param[1];
		                     return caml_exact_trampoline_cps_call
		                             (json_to_js,
		                              value$2,
		                              function(a){return cont({type: cst_json, value: a});});
		                    case 4:
		                     var
		                      value$3 = param[1],
		                      ja = create$22(0),
		                      a =
		                        function(i, param){
		                         if(! param) return cont(ja);
		                         var vs = param[2], v = param[1];
		                         return caml_exact_trampoline_cps_call
		                                 (conv,
		                                  v,
		                                  function(b){
		                                   ja[i] = b;
		                                   var i$0 = i + 1 | 0;
		                                   return caml_exact_trampoline_call2(a, i$0, vs);
		                                  });
		                        };
		                     return a(0, value$3);
		                    case 5:
		                     var value$4 = param[1];
		                     return caml_exact_trampoline_cps_call$0
		                             (of_map, conv, conv, value$4, cont);
		                    case 6:
		                     var value$5 = param[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (map$13,
		                              value$5,
		                              conv,
		                              function(a){
		                               return caml_exact_trampoline_cps_call$2
		                                       (to_sequence$2,
		0,
		0,
		0,
		a,
		function(a){
		 return caml_exact_trampoline_cps_call
		         (to_array$0,
		          a,
		          function(a){return cont(caml_js_object(a));});
		});
		                              });
		                    default:
		                     var value$6 = param[1];
		                     return cont(caml_jsstring_of_string(value$6));
		                  }
		                 }
		                 return caml_exact_trampoline_cps_call(conv, value, cont);
		                }
		                function graph_result_of_js(js, cont){
		                 if(js === null$1) return cont(0);
		                 var typ = typeof js;
		                 if(caml_equal(typ, cst_boolean)) return cont([0, js | 0]);
		                 if(caml_equal(typ, cst_number))
		                  return is_integer(js)
		                          ? cont([1, caml_int64_of_float(js)])
		                          : cont([2, js]);
		                 if(caml_equal(typ, "bigint"))
		                  return cont
		                          ([1,
		                            caml_int64_of_string(caml_string_of_jsstring(js.toString()))]);
		                 if(caml_equal(typ, cst_string))
		                  return cont([7, caml_string_of_jsstring(js)]);
		                 if(! caml_equal(typ, cst_object)) return cont(0);
		                 function a(match){
		                  if(match){var json = match[1]; return cont([3, json]);}
		                  if(is_array(js))
		                   return caml_exact_trampoline_cps_call$1
		                           (to_list$5,
		                            function(a, cont){return cont(a);},
		                            js,
		                            function(arr){
		                             return caml_trampoline_cps_call3
		                                     (map$18,
		                                      arr,
		                                      graph_result_of_js,
		                                      function(a){return cont([4, a]);});
		                            });
		                  var entries_array = global$0.Object.entries(js);
		                  return caml_exact_trampoline_cps_call$1
		                          (to_list$5,
		                           function(entry, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (to_list$5,
		                                     function(a, cont){return cont(a);},
		                                     entry,
		                                     function(entry_array){
		                                      if(entry_array){
		                                       var a = entry_array[2];
		                                       if(a && ! a[2]){
		var
		 value_jv = a[1],
		 key_jv = entry_array[1],
		 key = caml_string_of_jsstring(key_jv);
		return caml_exact_trampoline_cps_call
		        (graph_result_of_js,
		         value_jv,
		         function(value){return cont([0, key, value]);});
		                                       }
		                                      }
		                                      return caml_exact_trampoline_cps_call
		      (failwith, "Invalid Object.entries format", cont);
		                                     });
		                           },
		                           entries_array,
		                           function(entries_list){
		                            return caml_exact_trampoline_cps_call$1
		                                    (of_alist$1,
		                                     [0, comparator$2],
		                                     entries_list,
		                                     function(match){
		                                      var variant = match[1];
		                                      if(17724 <= variant){
		                                       var value = match[2];
		                                       return cont([6, value]);
		                                      }
		                                      var key = match[2];
		                                      return caml_exact_trampoline_cps_call$1
		      (fatal$0,
		       bM5,
		       bM4,
		       function(a){return caml_trampoline_cps_call2(a, key, cont);});
		                                     });
		                           });
		                 }
		                 if(has(cst_type, js) && has(cst_value, js)){
		                  var x = caml_string_of_jsstring(js.type);
		                  if(x !== cst_json) return a(0);
		                  var o = js.value;
		                  return caml_exact_trampoline_cps_call
		                          (of_js, o, function(b){return a([0, b]);});
		                 }
		                 return a(0);
		                }
		                var
		                 graph_result_schema =
		                   [0,
		                    schema$19[1],
		                    schema$19[2],
		                    [1,
		                     function(coding, cont){
		                      if(coding && coding[1] === Coding$3){
		                       var
		                        decode =
		                          function(js, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (graph_result_of_js,
		                                    js,
		                                    function(a){
		                                     return caml_trampoline_cps_call2(of_string$14, a, cont);
		                                    });
		                          },
		                        encode =
		                          function(result, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (graph_result_to_js, result, cont);
		                          };
		                       return cont
		                               ([4,
		                                 decode,
		                                 encode,
		                                 [0,
		                                  [0,
		                                   Coding$3,
		                                   name$34,
		                                   compare$140,
		                                   pp$122,
		                                   key_get$0,
		                                   key_set$0,
		                                   null$3,
		                                   of_any$2,
		                                   of_bool$1,
		                                   of_date$4,
		                                   of_fields$1,
		                                   of_float$5,
		                                   of_int$7,
		                                   of_int64$1,
		                                   of_json$1,
		                                   of_list$10,
		                                   of_option$3,
		                                   of_string$48,
		                                   of_time$4,
		                                   of_time_local$1,
		                                   to_bool$1,
		                                   to_date$3,
		                                   to_fields$1,
		                                   to_float$4,
		                                   to_int$5,
		                                   to_int64$3,
		                                   to_json$1,
		                                   to_list$7,
		                                   to_option$4,
		                                   to_string$61,
		                                   to_time$6,
		                                   to_time_local$1,
		                                   type_name$1]]]);
		                      }
		                      return cont(schema$19[3]);
		                     }],
		                    schema$19[4]];
		                function var_schema$0(value, cont){
		                 return caml_exact_trampoline_cps_call
		                         (var_schema,
		                          value,
		                          function(schema){
		                           o
		                            ([0,
		                              symbol_bind$4,
		                              symbol_map$4,
		                              Let_syntax$2,
		                              ,
		                              bind$6,
		                              of_string$14,
		                              map$15]);
		                           return cont
		                                   ([0,
		                                     schema[1],
		                                     schema[2],
		                                     [1,
		                                      function(coding, cont){
		                                       if(coding && coding[1] === Coding$3){
		var
		 decode =
		   function(js, cont){
		    return caml_exact_trampoline_cps_call$1
		            (to_var,
		             js,
		             function(js, cont){
		              return caml_trampoline_cps_call3
		                      (decode$16,
		                       value,
		                       js,
		                       function(t){
		                        function a(param){
		                         if(0 === param[0]){var v = param[1]; return cont(v);}
		                         var e = param[1];
		                         return caml_exact_trampoline_cps_call$1
		                                 (kasprintf,
		                                  id,
		                                  fmt$308,
		                                  function(a){
		                                   return caml_trampoline_cps_call3
		   (a,
		    pp_toplevel,
		    e,
		    function(a){
		     return caml_exact_trampoline_cps_call$1
		             (throw$, 0, caml_jsstring_of_string(a), cont);
		    });
		                                  });
		                        }
		                        if(0 === t[0]) return a(t);
		                        var error = t[1];
		                        return caml_exact_trampoline_cps_call$1
		                                (to_to_string,
		                                 pp_decoding,
		                                 error,
		                                 function(b){return a([1, [0, 9943782, b]]);});
		                       });
		             },
		             function(a){
		              return caml_trampoline_cps_call2(of_string$14, a, cont);
		             });
		   },
		 encode =
		   function(param, cont){
		    return caml_exact_trampoline_cps_call$1
		            (fatal$0, bM7, bM6, cont);
		   };
		return cont
		        ([4,
		          decode,
		          encode,
		          [0,
		           [0,
		            Coding$3,
		            name$34,
		            compare$140,
		            pp$122,
		            key_get$0,
		            key_set$0,
		            null$3,
		            of_any$2,
		            of_bool$1,
		            of_date$4,
		            of_fields$1,
		            of_float$5,
		            of_int$7,
		            of_int64$1,
		            of_json$1,
		            of_list$10,
		            of_option$3,
		            of_string$48,
		            of_time$4,
		            of_time_local$1,
		            to_bool$1,
		            to_date$3,
		            to_fields$1,
		            to_float$4,
		            to_int$5,
		            to_int64$3,
		            to_json$1,
		            to_list$7,
		            to_option$4,
		            to_string$61,
		            to_time$6,
		            to_time_local$1,
		            type_name$1]]]);
		                                       }
		                                       return cont(schema[3]);
		                                      }],
		                                     schema[4]]);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (rpcs$4,
		                         [0,
		                          callback_schema$0,
		                          graph_result_schema,
		                          remote_value_schema,
		                          schema$0,
		                          var_schema$0],
		                         1,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (of_rpcs, cst$1, {}, a, cont);
		                         });
		               }
		               o
		                ([0,
		                  symbol_bind$9,
		                  symbol_map$7,
		                  Let_syntax$5,
		                  ,
		                  bind$12,
		                  return$13,
		                  map$25]);
		               var
		                ipc =
		                  [246,
		                   function(param, cont){
		                    var t0 = require("electron");
		                    return cont(t0.ipcRenderer);
		                   }];
		               function send_js(name, payload, cont){
		                var a = caml_obj_tag(ipc);
		                function b(ipc){
		                 var t2 = caml_jsstring_of_string(name);
		                 return cont(ipc.send(t2, payload));
		                }
		                if(250 === a) return b(ipc[1]);
		                if(246 !== a && 244 !== a) return b(ipc);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, ipc, b);
		               }
		               function send$0(schema, value, name, cont){
		                function a(payload){
		                 return caml_exact_trampoline_cps_call$1
		                         (send_js, name, payload, cont);
		                }
		                if(schema){
		                 if(value){
		                  var value$0 = value[1], schema$0 = schema[1];
		                  return caml_trampoline_cps_call3
		                          (encode$10, schema$0, value$0, a);
		                 }
		                }
		                else if(! value) return a(undefined$);
		                return caml_exact_trampoline_cps_call
		                        (failwith,
		                         "Ipc.send: specify either both value and schema or neither",
		                         a);
		               }
		               function on$0(name, f, cont){
		                var a = caml_obj_tag(ipc);
		                function b(ipc){
		                 var
		                  callback =
		                    caml_js_wrap_callback_strict
		                     (2,
		                      function(event, payload, cont){
		                       return caml_exact_trampoline_cps_call(f, payload, cont);
		                      });
		                 ipc.on(caml_jsstring_of_string(name), callback);
		                 return cont
		                         (function(param, cont){
		                           ipc.removeListener(caml_jsstring_of_string(name), callback);
		                           return cont(0);
		                          });
		                }
		                if(250 === a) return b(ipc[1]);
		                if(246 !== a && 244 !== a) return b(ipc);
		                return caml_exact_trampoline_cps_call
		                        (force_lazy_block, ipc, b);
		               }
		               var
		                open$53 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol$233 = open$53[10],
		                Logs$21 = with_tag$0(component$0, "Controller.IpcClient");
		               function Make$60(Coding, cont){
		                var cst_rpc = "rpc";
		                function send(param, rpc, cont){
		                 var name = param[1];
		                 return caml_exact_trampoline_cps_call
		                         (Logs$21[6][5],
		                          function(m, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (attrs,
		                                    [0, attr$0(cst_rpc, rpc, Coding[6]), 0],
		                                    function(a){
		                                     return caml_trampoline_cps_call4(m, 0, [0, a], bM8, cont);
		                                    });
		                          },
		                          function(match){
		                           return caml_exact_trampoline_cps_call
		                                   (Coding[7],
		                                    rpc,
		                                    function(a){
		                                     return caml_exact_trampoline_cps_call$1
		     (send_js, name + "-call", a, cont);
		                                    });
		                          });
		                }
		                function receive(param, cont){
		                 var responses = param[2];
		                 function a(js_value, cont){
		                  return caml_exact_trampoline_cps_call
		                          (Coding[8],
		                           js_value,
		                           function(rpc){
		                            return caml_exact_trampoline_cps_call
		                                    (Logs$21[6][5],
		                                     function(m, cont){
		                                      return caml_exact_trampoline_cps_call
		      (attrs,
		       [0, attr$0(cst_rpc, rpc, Coding[6]), 0],
		       function(a){
		        return caml_trampoline_cps_call4(m, 0, [0, a], bM9, cont);
		       });
		                                     },
		                                     function(match){return cont(rpc);});
		                           });
		                 }
		                 function b(a, cont){return cont(a);}
		                 return caml_exact_trampoline_cps_call
		                         (get$5,
		                          responses,
		                          function(c){
		                           return caml_exact_trampoline_cps_call$1
		                                   (symbol$233,
		                                    c,
		                                    b,
		                                    function(b){
		                                     return caml_exact_trampoline_cps_call$1
		     (symbol$233, b, a, cont);
		                                    });
		                          });
		                }
		                function make(name, cont){
		                 var
		                  match = create$20(),
		                  received = match[2],
		                  responses = match[1];
		                 return caml_exact_trampoline_cps_call$1
		                         (on$0,
		                          name + "-response",
		                          function(a, cont){
		                           return caml_exact_trampoline_cps_call$0
		                                   (compose, received, return$9, a, cont);
		                          },
		                          function(listener){
		                           return cont([0, name, responses, [0, listener, 0]]);
		                          });
		                }
		                function release(t, cont){
		                 var a = 1 - t[2];
		                 if(! a) return cont(a);
		                 t[2] = 1;
		                 var f = t[1];
		                 return caml_trampoline_cps_call2(f, 0, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (bQL,
		                         [0,
		                          [0, , Coding[2], , Coding[4], Coding[5], Coding[6]],
		                          send,
		                          receive],
		                         function(Rpcs){
		                          function make$0(name, cont){
		                           return caml_exact_trampoline_cps_call
		                                   (make,
		                                    name,
		                                    function(channel){
		                                     return caml_exact_trampoline_cps_call$1
		     (Rpcs[2],
		      function(a, cont){
		       return caml_exact_trampoline_cps_call$1
		               (fatal_exn, bM_, a, cont);
		      },
		      channel,
		      function(a){
		       return caml_exact_trampoline_cps_call$1
		               (remote_controller,
		                Rpcs,
		                a,
		                function(controller){
		                 var release$0 = channel[3];
		                 controller.release =
		                  caml_js_wrap_callback_strict
		                   (1,
		                    function(param, cont){
		                     return caml_exact_trampoline_cps_call
		                             (release, release$0, cont);
		                    });
		                 function finalize(a, cont){
		                  a = 1 - release$0[2];
		                  return a
		                          ? caml_exact_trampoline_cps_call
		                            (Logs$21[6][4],
		                             function(m, cont){
		                              return caml_trampoline_cps_call5(m, 0, 0, bM$, name, cont);
		                             },
		                             function(match){
		                              return caml_exact_trampoline_cps_call
		                                      (release, release$0, cont);
		                             })
		                          : cont(a);
		                 }
		                 finalizer$0.register
		                  (controller, caml_js_wrap_callback_strict(1, finalize));
		                 return cont(controller);
		                });
		      });
		                                    });
		                          }
		                          return cont([0, , , make$0]);
		                         });
		               }
		               var
		                Json =
		                  caml_callback
		                   (Make$60,
		                    [[0,
		                      ,
		                      encode$5,
		                      ,
		                      decode$3,
		                      pp$10,
		                      no_input_schema,
		                      to_js,
		                      of_js$0]]),
		                cst_invalid_JSON = "{ invalid JSON }";
		               function pp$131(fmt, js, cont){
		                return caml_trampoline_cps_call3
		                        (decode$10,
		                         no_input_schema,
		                         js,
		                         function(match){
		                          if(0 !== match[0])
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_invalid_JSON, cont);
		                          var json = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (_16, fmt, json, cont);
		                         });
		               }
		               function to_js$6(a, cont){return cont(a);}
		               function of_js$2(a, cont){return cont(a);}
		               var schema$1 = [0, 0, 0, [0, include$116], 0];
		               caml_callback
		                (Make$60,
		                 [[0,
		                   ,
		                   encode$10,
		                   ,
		                   decode$10,
		                   pp$131,
		                   schema$1,
		                   to_js$6,
		                   of_js$2]]);
		               var
		                open$54 =
		                  g
		                   ([0,
		                     symbol_bind$8,
		                     symbol_map$6,
		                     ,
		                     bind$10,
		                     return$12,
		                     map$23,
		                     ,
		                     ,
		                     ,
		                     ,
		                     Let_syntax$4]),
		                symbol$234 = open$54[10];
		               function pp$132(fmt, js, cont){
		                return caml_trampoline_cps_call3
		                        (decode$10,
		                         no_input_schema,
		                         js,
		                         function(match){
		                          if(0 !== match[0])
		                           return caml_exact_trampoline_cps_call$1
		                                   (pp_print_string, fmt, cst_invalid_JSON, cont);
		                          var json = match[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (_16, fmt, json, cont);
		                         });
		               }
		               function send$1(param, rpc, cont){
		                var port = param[4], name = param[1];
		                return cont
		                        (post
		                          (0, port, {client: caml_jsstring_of_string(name), rpc: rpc}));
		               }
		               function receive$0(param, cont){
		                var responses = param[3];
		                function a(a, cont){return cont(a);}
		                return caml_exact_trampoline_cps_call
		                        (get$5,
		                         responses,
		                         function(b){
		                          return caml_exact_trampoline_cps_call$1
		                                  (symbol$234, b, a, cont);
		                         });
		               }
		               var
		                Rpcs =
		                  caml_callback
		                   (bQL,
		                    [[0,
		                      [0, , encode$10, , decode$10, pp$132, schema$1],
		                      send$1,
		                      receive$0]]),
		                By_string =
		                  caml_callback
		                   (M$2, [[0, comparator$2, thread_id_schema_versioned]]);
		               function make$140(login, on_progress, cont){
		                var
		                 on_progress$0 =
		                   is_none$1(on_progress)
		                    ? function(param){return 0;}
		                    : function(data){on_progress(data); return 0;},
		                 opts = obj([0]);
		                set_if_some(opts, cst_type, [0, "module"]);
		                set_if_some(opts, "credentials", 0);
		                set_if_some(opts, cst_name, 0);
		                var
		                 worker = new shared$0("/js/controller.js", opts),
		                 port = worker.port,
		                 res = [0, By_string[111]];
		                function f(resolve, reject){
		                 var
		                  controller =
		                    {client:
		                     caml_js_wrap_callback_strict
		                      (1,
		                       function(name$0, cont){
		                        var
		                         name = caml_string_of_jsstring(name$0),
		                         match = create$20(),
		                         received = match[2],
		                         responses = match[1],
		                         channel = [0, name, received, responses, port];
		                        return caml_exact_trampoline_cps_call$0
		                                (set$3,
		                                 res[1],
		                                 name,
		                                 channel,
		                                 function(a){
		                                  res[1] = a;
		                                  return caml_exact_trampoline_cps_call$1
		  (Rpcs[2],
		   function(a, cont){
		    return caml_exact_trampoline_cps_call$1
		            (fatal_exn, bNa, a, cont);
		   },
		   channel,
		   function(a){
		    return caml_exact_trampoline_cps_call$1
		            (remote_controller, Rpcs, a, cont);
		   });
		                                 });
		                       })};
		                 listen$0
		                  (0,
		                   cst_message,
		                   function(message, cont){
		                    var
		                     data = message.data,
		                     client = data.client,
		                     rpc = data.rpc,
		                     match = is_some$1(rpc),
		                     match$0 =
		                       is_none$1(client) ? 0 : [0, caml_string_of_jsstring(client)];
		                    if(match && match$0){
		                     var client$0 = match$0[1];
		                     return caml_exact_trampoline_cps_call$1
		                             (find_packed_by_id,
		                              res[1],
		                              client$0,
		                              function(match){
		                               if(! match) return cont(0);
		                               var received = match[1][2];
		                               return caml_trampoline_cps_call2(received, [0, rpc], cont);
		                              });
		                    }
		                    return caml_exact_trampoline_cps_call
		                            (decode$10,
		                             login_status_schema,
		                             function(a){
		                              return caml_exact_trampoline_cps_call
		                                      (a,
		                                       data,
		                                       function(a){
		if(0 !== a[0]){
		 var already_running = data.already_running;
		 return is_some$1(already_running)
		         ? cont(reject(new global$0.AlreadyRunning))
		         : caml_exact_trampoline_cps_call$1
		           (throw$, 0, "unrecognized controller message", cont);
		}
		var status = a[1], a = status[1];
		if(! a)
		 return caml_trampoline_cps_call3
		         (encode$10,
		          login_status_schema,
		          status,
		          function(a){return cont(on_progress$0(a));});
		if(a[1]){
		 a = status[2];
		 if(typeof a !== "number" && 3 === a[0]){
		  var account_created = a[1];
		  return cont
		          (resolve
		            ({controller: controller,
		              accountCreated: ! ! account_created}));
		 }
		}
		else {
		 a = status[2];
		 if(typeof a !== "number")
		  switch(a[0]){
		    case 0:
		     var error = a[1];
		     return caml_exact_trampoline_cps_call$1
		             (throw$, 0, caml_jsstring_of_string(error), cont);
		    case 2:
		     var url = a[1];
		     return caml_trampoline_cps_call3
		             (encode$10,
		              schema$262,
		              url,
		              function(url){
		               return cont(reject(new global$0.Authenticate(url)));
		              });
		    case 4:
		     var version = a[2];
		     return caml_exact_trampoline_cps_call$1
		             (kasprintf,
		              id,
		              fmt$309,
		              function(a){
		               return caml_trampoline_cps_call3
		                       (a,
		                        pp$5,
		                        version,
		                        function(a){
		                         return caml_exact_trampoline_cps_call$1
		                                 (throw$, 0, caml_jsstring_of_string(a), cont);
		                        });
		              });
		  }
		}
		return caml_exact_trampoline_cps_call$1
		        (throw$, 0, "unrecognized login answer", cont);
		                                       });
		                             });
		                   },
		                   port);
		                 port.start();
		                 return post(0, port, {login: login});
		                }
		                function g(res, rej, cont){
		                 return cont
		                         (f(function(x){return res(x);}, function(x){return rej(x);}));
		                }
		                return cont(new promise(caml_js_wrap_callback_strict(2, g)));
		               }
		               var console_obj = global.console;
		               function console$0(output, opt, level, s, cont){
		                var attributes = opt ? opt[1] : 0;
		                function a(attributes){
		                 switch(level){
		                   case 0:
		                    var meth = cst_log; break;
		                   case 1:
		                    meth = cst_error; break;
		                   case 2:
		                    meth = cst_warn; break;
		                   case 3:
		                    meth = cst_info; break;
		                   default: meth = cst_debug;
		                 }
		                 return caml_exact_trampoline_cps_call
		                         (to_array,
		                          [0, caml_jsstring_of_string(s), attributes],
		                          function(a){
		                           caml_js_meth_call(console_obj, meth, a);
		                           return cont();
		                          });
		                }
		                return output
		                        ? caml_trampoline_cps_call3
		                          (map$18,
		                           attributes,
		                           function(param, cont){
		                            var
		                             match = param[2],
		                             pp = match[3],
		                             value = match[1],
		                             name = param[1],
		                             buffer = create$1(256),
		                             ppf = formatter_of_buffer(buffer);
		                            return caml_exact_trampoline_cps_call$1
		                                    (pp_set_margin,
		                                     ppf,
		                                     200,
		                                     function(a){
		                                      a = caml_obj_tag(pp);
		                                      function b(a){
		                                       return caml_trampoline_cps_call3
		       (a,
		        ppf,
		        value,
		        function(match){
		         return caml_exact_trampoline_cps_call$1
		                 (pp_print_flush,
		                  ppf,
		                  dummy,
		                  function(match){
		                   return caml_exact_trampoline_cps_call
		                           (contents,
		                            buffer,
		                            function(a){
		                             return caml_exact_trampoline_cps_call$1
		                                     (kasprintf,
		                                      id,
		                                      fmt$310,
		                                      function(b){
		                                       return caml_trampoline_cps_call3
		       (b,
		        name,
		        a,
		        function(a){return cont(caml_jsstring_of_string(a));});
		                                      });
		                            });
		                  });
		        });
		                                      }
		                                      if(250 === a) return b(pp[1]);
		                                      if(246 !== a && 244 !== a) return b(pp);
		                                      return caml_exact_trampoline_cps_call
		      (force_lazy_block, pp, b);
		                                     });
		                           },
		                           a)
		                        : caml_exact_trampoline_cps_call$1
		                          (concat_map,
		                           attributes,
		                           function(param, cont){
		                            var
		                             match = param[2],
		                             schema = match[2],
		                             value = match[1],
		                             name = param[1];
		                            return caml_trampoline_cps_call3
		                                    (encode$10,
		                                     schema,
		                                     value,
		                                     function(a){
		                                      return cont
		      ([0, caml_jsstring_of_string(name + cst$21), [0, a, 0]]);
		                                     });
		                           },
		                           a);
		               }
		               var b$0 = create$1(512), fmt$321 = formatter_of_buffer(b$0);
		               caml_callback(pp_set_margin, [fmt$321, 160]);
		               function pp_level(ppf, param, cont){
		                switch(param){
		                  case 0:
		                   return cont(0);
		                  case 1:
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            bNb,
		                            function(a){
		                             return caml_trampoline_cps_call2(a, "\xe2\x9d\x8c", cont);
		                            });
		                  case 2:
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            bNc,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a, "\xe2\x9a\xa0\xef\xb8\x8f", cont);
		                            });
		                  case 3:
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            bNd,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a, "\xe2\x84\xb9\xef\xb8\x8f", cont);
		                            });
		                  default:
		                   return caml_exact_trampoline_cps_call
		                           (fprintf$0(ppf),
		                            bNe,
		                            function(a){
		                             return caml_trampoline_cps_call2
		                                     (a, "\xe2\x9a\x99\xef\xb8\x8f", cont);
		                            });
		                }
		               }
		               function pp_time(output, ppf, param, cont){
		                if(! output) return cont(0);
		                var
		                 t7 = new date_fromTimeValue,
		                 a = t7.getSeconds(),
		                 b = t7.getMinutes(),
		                 c = t7.getHours(),
		                 d = t7.getDate(),
		                 e = t7.getMonth() + 1 | 0,
		                 f = t7.getFullYear();
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(ppf),
		                         bNf,
		                         function(g){
		                          return caml_trampoline_cps_call7(g, f, e, d, c, b, a, cont);
		                         });
		               }
		               function pp_component(ppf, param, cont){
		                if(! param)
		                 return caml_exact_trampoline_cps_call$1
		                         (pp_none, ppf, dummy, cont);
		                var v = param[1];
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_char,
		                         ppf,
		                         91,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (pp_print_string,
		                                   ppf,
		                                   v,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call$1
		    (pp_print_char,
		     ppf,
		     93,
		     function(a){return cont(pp_v1(ppf));});
		                                   });
		                         });
		               }
		               function console_report
		               (output, src, level, over, finish, msgf, cont){
		                function continue$(attributes, report, param, cont){
		                 return caml_exact_trampoline_cps_call
		                         (contents,
		                          b$0,
		                          function(message){
		                           clear$1(b$0);
		                           return caml_exact_trampoline_cps_call$2
		                                   (console$0,
		                                    output,
		                                    attributes,
		                                    level,
		                                    message,
		                                    function(match){
		                                     function a(){
		                                      return caml_trampoline_cps_call2
		      (over,
		       0,
		       function(match){
		        return caml_trampoline_cps_call2(finish, 0, cont);
		       });
		                                     }
		                                     if(1 !== level) return a();
		                                     if(! report) return a();
		                                     var level$0 = 1;
		                                     return caml_trampoline_cps_call3
		     (encode$10,
		      level_schema,
		      level$0,
		      function(t4){
		       var t3 = caml_jsstring_of_string(message);
		       sentry.captureMessage(t3, t4);
		       return a();
		      });
		                                    });
		                          });
		                }
		                return caml_trampoline_cps_call2
		                        (msgf,
		                         function(header, tags, fmt, cont){
		                          function a(attributes, component, report){
		                           if(header){
		                            var
		                             h = header[1],
		                             a =
		                               function(a, b, cont){
		                                return caml_exact_trampoline_cps_call$0
		(pp_time, output, a, dummy, cont);
		                               };
		                            return caml_exact_trampoline_cps_call$0
		                                    (kfprintf,
		                                     function(a, cont){
		                                      return caml_exact_trampoline_cps_call$0
		      (continue$, attributes, report, dummy, cont);
		                                     },
		                                     fmt$321,
		                                     symbol$0(bNh, symbol$0(fmt, bNg)),
		                                     function(b){
		                                      return caml_trampoline_cps_call8
		      (b, pp_level, level, a, 0, h, pp_component, component, cont);
		                                     });
		                           }
		                           function b(a, b, cont){
		                            return caml_exact_trampoline_cps_call$0
		                                    (pp_time, output, a, dummy, cont);
		                           }
		                           return caml_exact_trampoline_cps_call$0
		                                   (kfprintf,
		                                    function(a, cont){
		                                     return caml_exact_trampoline_cps_call$0
		     (continue$, attributes, report, dummy, cont);
		                                    },
		                                    fmt$321,
		                                    symbol$0(bNj, symbol$0(fmt, bNi)),
		                                    function(a){
		                                     return caml_trampoline_cps_call7
		     (a, pp_level, level, b, 0, pp_component, component, cont);
		                                    });
		                          }
		                          if(! tags) return a(0, 0, 1);
		                          var tags$0 = tags[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (find$4,
		                                   no_report,
		                                   tags$0,
		                                   function(b){
		                                    var report = is_none(b);
		                                    return caml_exact_trampoline_cps_call$1
		    (find$4,
		     component$0,
		     tags$0,
		     function(component){
		      return caml_exact_trampoline_cps_call$1
		              (find$4,
		               attributes,
		               tags$0,
		               function(b){return a(b, component, report);});
		     });
		                                   });
		                         },
		                         cont);
		               }
		               var
		                open$55 =
		                  o
		                   ([0,
		                     symbol_bind$4,
		                     symbol_map$4,
		                     Let_syntax$2,
		                     ,
		                     bind$6,
		                     of_string$14,
		                     map$15]),
		                symbol_bind$30 = open$55[1],
		                let$79 = open$55[3],
		                src$6 = create$18(bNk, "v-hotkey"),
		                Logs$22 = with_tag(src_log(src$6), component$0, "Hotkeys");
		               function equal$257(lhs, rhs){
		                var a = lhs;
		                if(62 <= a)
		                 if(93 <= a)
		                  switch(a){
		                    case 93:
		                     if(93 === rhs) return 1; break;
		                    case 94:
		                     if(94 === rhs) return 1; break;
		                    case 95:
		                     if(95 === rhs) return 1; break;
		                    case 96:
		                     if(96 === rhs) return 1; break;
		                    case 97:
		                     if(97 === rhs) return 1; break;
		                    case 98:
		                     if(98 === rhs) return 1; break;
		                    case 99:
		                     if(99 === rhs) return 1; break;
		                    case 100:
		                     if(100 === rhs) return 1; break;
		                    case 101:
		                     if(101 === rhs) return 1; break;
		                    case 102:
		                     if(102 === rhs) return 1; break;
		                    case 103:
		                     if(103 === rhs) return 1; break;
		                    case 104:
		                     if(104 === rhs) return 1; break;
		                    case 105:
		                     if(105 === rhs) return 1; break;
		                    case 106:
		                     if(106 === rhs) return 1; break;
		                    case 107:
		                     if(107 === rhs) return 1; break;
		                    case 108:
		                     if(108 === rhs) return 1; break;
		                    case 109:
		                     if(109 === rhs) return 1; break;
		                    case 110:
		                     if(110 === rhs) return 1; break;
		                    case 111:
		                     if(111 === rhs) return 1; break;
		                    case 112:
		                     if(112 === rhs) return 1; break;
		                    case 113:
		                     if(113 === rhs) return 1; break;
		                    case 114:
		                     if(114 === rhs) return 1; break;
		                    case 115:
		                     if(115 === rhs) return 1; break;
		                    case 116:
		                     if(116 === rhs) return 1; break;
		                    case 117:
		                     if(117 === rhs) return 1; break;
		                    case 118:
		                     if(118 === rhs) return 1; break;
		                    case 119:
		                     if(119 === rhs) return 1; break;
		                    case 120:
		                     if(120 === rhs) return 1; break;
		                    case 121:
		                     if(121 === rhs) return 1; break;
		                    case 122:
		                     if(122 === rhs) return 1; break;
		                    default: if(123 <= rhs) return 1;
		                  }
		                 else
		                  switch(a){
		                    case 62:
		                     if(62 === rhs) return 1; break;
		                    case 63:
		                     if(63 === rhs) return 1; break;
		                    case 64:
		                     if(64 === rhs) return 1; break;
		                    case 65:
		                     if(65 === rhs) return 1; break;
		                    case 66:
		                     if(66 === rhs) return 1; break;
		                    case 67:
		                     if(67 === rhs) return 1; break;
		                    case 68:
		                     if(68 === rhs) return 1; break;
		                    case 69:
		                     if(69 === rhs) return 1; break;
		                    case 70:
		                     if(70 === rhs) return 1; break;
		                    case 71:
		                     if(71 === rhs) return 1; break;
		                    case 72:
		                     if(72 === rhs) return 1; break;
		                    case 73:
		                     if(73 === rhs) return 1; break;
		                    case 74:
		                     if(74 === rhs) return 1; break;
		                    case 75:
		                     if(75 === rhs) return 1; break;
		                    case 76:
		                     if(76 === rhs) return 1; break;
		                    case 77:
		                     if(77 === rhs) return 1; break;
		                    case 78:
		                     if(78 === rhs) return 1; break;
		                    case 79:
		                     if(79 === rhs) return 1; break;
		                    case 80:
		                     if(80 === rhs) return 1; break;
		                    case 81:
		                     if(81 === rhs) return 1; break;
		                    case 82:
		                     if(82 === rhs) return 1; break;
		                    case 83:
		                     if(83 === rhs) return 1; break;
		                    case 84:
		                     if(84 === rhs) return 1; break;
		                    case 85:
		                     if(85 === rhs) return 1; break;
		                    case 86:
		                     if(86 === rhs) return 1; break;
		                    case 87:
		                     if(87 === rhs) return 1; break;
		                    case 88:
		                     if(88 === rhs) return 1; break;
		                    case 89:
		                     if(89 === rhs) return 1; break;
		                    case 90:
		                     if(90 === rhs) return 1; break;
		                    case 91:
		                     if(91 === rhs) return 1; break;
		                    default: if(92 === rhs) return 1;
		                  }
		                else if(31 <= a)
		                 switch(a){
		                   case 31:
		                    if(31 === rhs) return 1; break;
		                   case 32:
		                    if(32 === rhs) return 1; break;
		                   case 33:
		                    if(33 === rhs) return 1; break;
		                   case 34:
		                    if(34 === rhs) return 1; break;
		                   case 35:
		                    if(35 === rhs) return 1; break;
		                   case 36:
		                    if(36 === rhs) return 1; break;
		                   case 37:
		                    if(37 === rhs) return 1; break;
		                   case 38:
		                    if(38 === rhs) return 1; break;
		                   case 39:
		                    if(39 === rhs) return 1; break;
		                   case 40:
		                    if(40 === rhs) return 1; break;
		                   case 41:
		                    if(41 === rhs) return 1; break;
		                   case 42:
		                    if(42 === rhs) return 1; break;
		                   case 43:
		                    if(43 === rhs) return 1; break;
		                   case 44:
		                    if(44 === rhs) return 1; break;
		                   case 45:
		                    if(45 === rhs) return 1; break;
		                   case 46:
		                    if(46 === rhs) return 1; break;
		                   case 47:
		                    if(47 === rhs) return 1; break;
		                   case 48:
		                    if(48 === rhs) return 1; break;
		                   case 49:
		                    if(49 === rhs) return 1; break;
		                   case 50:
		                    if(50 === rhs) return 1; break;
		                   case 51:
		                    if(51 === rhs) return 1; break;
		                   case 52:
		                    if(52 === rhs) return 1; break;
		                   case 53:
		                    if(53 === rhs) return 1; break;
		                   case 54:
		                    if(54 === rhs) return 1; break;
		                   case 55:
		                    if(55 === rhs) return 1; break;
		                   case 56:
		                    if(56 === rhs) return 1; break;
		                   case 57:
		                    if(57 === rhs) return 1; break;
		                   case 58:
		                    if(58 === rhs) return 1; break;
		                   case 59:
		                    if(59 === rhs) return 1; break;
		                   case 60:
		                    if(60 === rhs) return 1; break;
		                   default: if(61 === rhs) return 1;
		                 }
		                else
		                 switch(a){
		                   case 0:
		                    if(! rhs) return 1; break;
		                   case 1:
		                    if(1 === rhs) return 1; break;
		                   case 2:
		                    if(2 === rhs) return 1; break;
		                   case 3:
		                    if(3 === rhs) return 1; break;
		                   case 4:
		                    if(4 === rhs) return 1; break;
		                   case 5:
		                    if(5 === rhs) return 1; break;
		                   case 6:
		                    if(6 === rhs) return 1; break;
		                   case 7:
		                    if(7 === rhs) return 1; break;
		                   case 8:
		                    if(8 === rhs) return 1; break;
		                   case 9:
		                    if(9 === rhs) return 1; break;
		                   case 10:
		                    if(10 === rhs) return 1; break;
		                   case 11:
		                    if(11 === rhs) return 1; break;
		                   case 12:
		                    if(12 === rhs) return 1; break;
		                   case 13:
		                    if(13 === rhs) return 1; break;
		                   case 14:
		                    if(14 === rhs) return 1; break;
		                   case 15:
		                    if(15 === rhs) return 1; break;
		                   case 16:
		                    if(16 === rhs) return 1; break;
		                   case 17:
		                    if(17 === rhs) return 1; break;
		                   case 18:
		                    if(18 === rhs) return 1; break;
		                   case 19:
		                    if(19 === rhs) return 1; break;
		                   case 20:
		                    if(20 === rhs) return 1; break;
		                   case 21:
		                    if(21 === rhs) return 1; break;
		                   case 22:
		                    if(22 === rhs) return 1; break;
		                   case 23:
		                    if(23 === rhs) return 1; break;
		                   case 24:
		                    if(24 === rhs) return 1; break;
		                   case 25:
		                    if(25 === rhs) return 1; break;
		                   case 26:
		                    if(26 === rhs) return 1; break;
		                   case 27:
		                    if(27 === rhs) return 1; break;
		                   case 28:
		                    if(28 === rhs) return 1; break;
		                   case 29:
		                    if(29 === rhs) return 1; break;
		                   default: if(30 === rhs) return 1;
		                 }
		                return 0;
		               }
		               var
		                cst$35 = "'",
		                cst_backspace = "backspace",
		                cst_capslock = "capslock",
		                cst_ctrl = "ctrl",
		                cst_del = "del",
		                cst_down = "down",
		                cst_esc = "esc",
		                cst_f1 = "f1",
		                cst_f10 = "f10",
		                cst_f11 = "f11",
		                cst_f12 = "f12",
		                cst_f2 = "f2",
		                cst_f3 = "f3",
		                cst_f4 = "f4",
		                cst_f5 = "f5",
		                cst_f6 = "f6",
		                cst_f7 = "f7",
		                cst_f8 = "f8",
		                cst_f9 = "f9",
		                cst_j = "j",
		                cst_l = "l",
		                cst_numlock = "numlock",
		                cst_numpad = "numpad*",
		                cst_numpad$1 = "numpad+",
		                cst_numpad$0 = "numpad-",
		                cst_numpad_return = "numpad-return",
		                cst_numpad$2 = "numpad.",
		                cst_numpad$4 = "numpad/",
		                cst_numpad0 = "numpad0",
		                cst_numpad1 = "numpad1",
		                cst_numpad2 = "numpad2",
		                cst_numpad3 = "numpad3",
		                cst_numpad4 = "numpad4",
		                cst_numpad5 = "numpad5",
		                cst_numpad6 = "numpad6",
		                cst_numpad7 = "numpad7",
		                cst_numpad8 = "numpad8",
		                cst_numpad9 = "numpad9",
		                cst_numpad$3 = "numpad=",
		                cst_o$0 = "o",
		                cst_pagedown = "pagedown",
		                cst_pageup = "pageup",
		                cst_r = "r",
		                cst_return = "return",
		                cst_scrolllock = "scrolllock",
		                cst_shift = "shift",
		                cst_up = "up",
		                cst_w = "w",
		                cst_y = "y",
		                cst_z = "z",
		                positions = [0, [0], 0];
		               function of_string$59(key, cont){
		                var switch$ = caml_string_compare(key, cst_home);
		                if(0 <= switch$){
		                 if(0 >= switch$)
		                  return caml_trampoline_cps_call2(of_string$14, 100, cont);
		                 var switch$0 = caml_string_compare(key, cst_numpad$3);
		                 if(0 <= switch$0){
		                  if(0 >= switch$0)
		                   return caml_trampoline_cps_call2(of_string$14, 82, cont);
		                  var switch$1 = caml_string_compare(key, cst_s$0);
		                  if(0 <= switch$1){
		                   if(0 >= switch$1)
		                    return caml_trampoline_cps_call2(of_string$14, 19, cont);
		                   var switch$2 = caml_string_compare(key, cst_up);
		                   if(0 <= switch$2){
		                    if(0 >= switch$2)
		                     return caml_trampoline_cps_call2(of_string$14, 96, cont);
		                    if(key === cst_v)
		                     return caml_trampoline_cps_call2(of_string$14, 22, cont);
		                    if(key === cst_w)
		                     return caml_trampoline_cps_call2(of_string$14, 23, cont);
		                    if(key === cst_windows)
		                     return caml_trampoline_cps_call2(of_string$14, 88, cont);
		                    if(key === cst_x)
		                     return caml_trampoline_cps_call2(of_string$14, 24, cont);
		                    if(key === cst_y)
		                     return caml_trampoline_cps_call2(of_string$14, 25, cont);
		                    if(key === cst_z)
		                     return caml_trampoline_cps_call2(of_string$14, 26, cont);
		                   }
		                   else {
		                    if(key === cst_scrolllock)
		                     return caml_trampoline_cps_call2(of_string$14, 119, cont);
		                    if(key === cst_shift)
		                     return caml_trampoline_cps_call2(of_string$14, 90, cont);
		                    if(key === cst_space)
		                     return caml_trampoline_cps_call2(of_string$14, 41, cont);
		                    if(key === cst_t)
		                     return caml_trampoline_cps_call2(of_string$14, 20, cont);
		                    if(key === cst_tab)
		                     return caml_trampoline_cps_call2(of_string$14, 39, cont);
		                    if(key === cst_u$0)
		                     return caml_trampoline_cps_call2(of_string$14, 21, cont);
		                   }
		                  }
		                  else {
		                   var switch$3 = caml_string_compare(key, "pgdn");
		                   if(0 <= switch$3){
		                    if(0 >= switch$3)
		                     return caml_trampoline_cps_call2(of_string$14, 99, cont);
		                    if(key === "pgup")
		                     return caml_trampoline_cps_call2(of_string$14, 98, cont);
		                    if(key === cst_q)
		                     return caml_trampoline_cps_call2(of_string$14, 17, cont);
		                    if(key === cst_r)
		                     return caml_trampoline_cps_call2(of_string$14, 18, cont);
		                    if(key === cst_return)
		                     return caml_trampoline_cps_call2(of_string$14, 40, cont);
		                    if(key === cst_right)
		                     return caml_trampoline_cps_call2(of_string$14, 95, cont);
		                    if(key === "rightcommand")
		                     return caml_trampoline_cps_call2(of_string$14, 89, cont);
		                   }
		                   else {
		                    if(key === cst_o$0)
		                     return caml_trampoline_cps_call2(of_string$14, 15, cont);
		                    if(key === cst_option)
		                     return caml_trampoline_cps_call2(of_string$14, 88, cont);
		                    if(key === cst_p)
		                     return caml_trampoline_cps_call2(of_string$14, 16, cont);
		                    if(key === cst_pagedown)
		                     return caml_trampoline_cps_call2(of_string$14, 99, cont);
		                    if(key === cst_pageup)
		                     return caml_trampoline_cps_call2(of_string$14, 98, cont);
		                    if(key === cst_pause)
		                     return caml_trampoline_cps_call2(of_string$14, 123, cont);
		                   }
		                  }
		                 }
		                 else {
		                  var switch$4 = caml_string_compare(key, cst_numpad$0);
		                  if(0 <= switch$4){
		                   if(0 >= switch$4)
		                    return caml_trampoline_cps_call2(of_string$14, 79, cont);
		                   var switch$5 = caml_string_compare(key, cst_numpad3);
		                   if(0 <= switch$5){
		                    if(0 >= switch$5)
		                     return caml_trampoline_cps_call2(of_string$14, 71, cont);
		                    if(key === cst_numpad4)
		                     return caml_trampoline_cps_call2(of_string$14, 72, cont);
		                    if(key === cst_numpad5)
		                     return caml_trampoline_cps_call2(of_string$14, 73, cont);
		                    if(key === cst_numpad6)
		                     return caml_trampoline_cps_call2(of_string$14, 74, cont);
		                    if(key === cst_numpad7)
		                     return caml_trampoline_cps_call2(of_string$14, 75, cont);
		                    if(key === cst_numpad8)
		                     return caml_trampoline_cps_call2(of_string$14, 76, cont);
		                    if(key === cst_numpad9)
		                     return caml_trampoline_cps_call2(of_string$14, 77, cont);
		                   }
		                   else {
		                    if(key === cst_numpad_return)
		                     return caml_trampoline_cps_call2(of_string$14, 83, cont);
		                    if(key === cst_numpad$2)
		                     return caml_trampoline_cps_call2(of_string$14, 81, cont);
		                    if(key === cst_numpad$4)
		                     return caml_trampoline_cps_call2(of_string$14, 84, cont);
		                    if(key === cst_numpad0)
		                     return caml_trampoline_cps_call2(of_string$14, 68, cont);
		                    if(key === cst_numpad1)
		                     return caml_trampoline_cps_call2(of_string$14, 69, cont);
		                    if(key === cst_numpad2)
		                     return caml_trampoline_cps_call2(of_string$14, 70, cont);
		                   }
		                  }
		                  else {
		                   var switch$6 = caml_string_compare(key, cst_m);
		                   if(0 <= switch$6){
		                    if(0 >= switch$6)
		                     return caml_trampoline_cps_call2(of_string$14, 13, cont);
		                    if(key === cst_meta)
		                     return caml_trampoline_cps_call2(of_string$14, 88, cont);
		                    if(key === "mod"){
		                     var
		                      platform = caml_string_of_jsstring(navigator.platform),
		                      re_match =
		                        function(regex, cont){
		                         return caml_exact_trampoline_cps_call$1
		                                 (compile_pat,
		                                  0,
		                                  regex,
		                                  function(re){
		                                   var y = caml_ml_string_length(platform), b = y < -1;
		                                   function a(e){
		                                    var
		                                     slen = caml_ml_string_length(platform),
		                                     initial_cat = 32 | inexistant;
		                                    function c(initial_state){
		                                     var last = slen;
		                                     return caml_exact_trampoline_cps_call$8
		     (scan_str,
		      re,
		      positions,
		      platform,
		      initial_state,
		      last,
		      0,
		      0,
		      function(st$0){
		       var state_info = get_info(st$0), x = state_info[1];
		       function c(match){
		        return typeof match === "number" ? cont(0) : cont(1);
		       }
		       if(x > -3){
		        var
		         y =
		           last === slen
		            ? inexistant
		            : category(re, get_color(re, platform, last)),
		         final_cat = 32 | y,
		         e = function(match){var res = match[2]; return c(res);};
		        try{var b = assq(final_cat, state_info[2]);}
		        catch(exn$3){
		         var exn = caml_wrap_exception(exn$3);
		         if(exn !== Not_found){
		          var
		           a = caml_pop_trap(),
		           exn$2 = caml_maybe_attach_backtrace(exn, 0);
		          return a(exn$2);
		         }
		         caml_ml_mutex_lock(re[11]);
		         var
		          d =
		            function(res){caml_ml_mutex_unlock(re[11]); return e(res);};
		         try{a = assq(final_cat, state_info[2]);}
		         catch(exn){
		          var exn$0 = caml_wrap_exception(exn);
		          if(exn$0 === Not_found)
		           return caml_exact_trampoline_cps_call$2
		                   (delta,
		                    re,
		                    final_cat,
		                    null_char,
		                    state_info,
		                    function(st){
		                     var a = status_no_mutex(st), res = [0, st[1], a];
		                     state_info[2] = [0, [0, final_cat, res], state_info[2]];
		                     return d(res);
		                    });
		          a = caml_pop_trap();
		          var exn$1 = caml_maybe_attach_backtrace(exn$0, 0);
		          return a(exn$1);
		         }
		         return d(a);
		        }
		        return e(b);
		       }
		       var s$0 = state_info[3], m = re[11], b = s$0[4];
		       if(b){var s = b[1]; return c(s);}
		       caml_ml_mutex_lock(m);
		       var st = status_no_mutex(s$0);
		       caml_ml_mutex_unlock(m);
		       return c(st);
		      });
		                                    }
		                                    try{var d = assq(initial_cat, re[2]);}
		                                    catch(exn$3){
		                                     var exn = caml_wrap_exception(exn$3);
		                                     if(exn !== Not_found){
		                                      var
		                                       a = caml_pop_trap(),
		                                       exn$2 = caml_maybe_attach_backtrace(exn, 0);
		                                      return a(exn$2);
		                                     }
		                                     caml_ml_mutex_lock(re[11]);
		                                     var
		                                      b =
		function(res){caml_ml_mutex_unlock(re[11]); return c(res);};
		                                     try{a = assq(initial_cat, re[2]);}
		                                     catch(exn){
		                                      var exn$0 = caml_wrap_exception(exn);
		                                      if(exn$0 === Not_found){
		                                       var expr = re[1];
		                                       return caml_exact_trampoline_cps_call$0
		       (mk$0,
		        0,
		        initial_cat,
		        [0, [1, empty$18, expr], 0],
		        function(a){
		         return caml_exact_trampoline_cps_call$1
		                 (find_state,
		                  re,
		                  a,
		                  function(st){
		                   re[2] = [0, [0, initial_cat, st], re[2]];
		                   return b(st);
		                  });
		        });
		                                      }
		                                      a = caml_pop_trap();
		                                      var exn$1 = caml_maybe_attach_backtrace(exn$0, 0);
		                                      return a(exn$1);
		                                     }
		                                     return b(a);
		                                    }
		                                    return c(d);
		                                   }
		                                   return b
		   ? caml_exact_trampoline_cps_call
		     (invalid_arg, "Re.exec: out of bounds", a)
		   : a();
		                                  });
		                        };
		                     return caml_exact_trampoline_cps_call
		                             (re_match,
		                              "^Linux",
		                              function(b){
		                               function a(match){
		                                if(typeof match === "number" && ! match)
		                                 return caml_trampoline_cps_call2(of_string$14, 88, cont);
		                                return caml_trampoline_cps_call2(of_string$14, 86, cont);
		                               }
		                               return b
		                                       ? a(1)
		                                       : caml_exact_trampoline_cps_call
		 (re_match,
		  "^Win",
		  function(b){
		   return b
		           ? a(2)
		           : caml_exact_trampoline_cps_call
		             (re_match,
		              "^Mac",
		              function(b){
		               return b
		                       ? a(0)
		                       : caml_exact_trampoline_cps_call
		                         (re_match,
		                          "^iPhone",
		                          function(c){
		                           function b(){return a(4);}
		                           return c
		                                   ? b()
		                                   : caml_exact_trampoline_cps_call
		                                     (re_match,
		                                      "^iPad",
		                                      function(c){
		                                       return c
		       ? b()
		       : caml_exact_trampoline_cps_call
		         (re_match,
		          "^Android",
		          function(b){return b ? a(3) : a([0, platform]);});
		                                      });
		                          });
		              });
		  });
		                              });
		                    }
		                    if(key === cst_n$0)
		                     return caml_trampoline_cps_call2(of_string$14, 14, cont);
		                    if(key === cst_numlock)
		                     return caml_trampoline_cps_call2(of_string$14, 85, cont);
		                    if(key === cst_numpad)
		                     return caml_trampoline_cps_call2(of_string$14, 78, cont);
		                    if(key === cst_numpad$1)
		                     return caml_trampoline_cps_call2(of_string$14, 80, cont);
		                   }
		                   else {
		                    if(key === cst_i$0)
		                     return caml_trampoline_cps_call2(of_string$14, 9, cont);
		                    if(key === "ins")
		                     return caml_trampoline_cps_call2(of_string$14, 44, cont);
		                    if(key === cst_insert)
		                     return caml_trampoline_cps_call2(of_string$14, 44, cont);
		                    if(key === cst_j)
		                     return caml_trampoline_cps_call2(of_string$14, 10, cont);
		                    if(key === cst_k)
		                     return caml_trampoline_cps_call2(of_string$14, 11, cont);
		                    if(key === cst_l)
		                     return caml_trampoline_cps_call2(of_string$14, 12, cont);
		                    if(key === cst_left)
		                     return caml_trampoline_cps_call2(of_string$14, 94, cont);
		                   }
		                  }
		                 }
		                }
		                else {
		                 var switch$7 = caml_string_compare(key, cst_capslock);
		                 if(0 <= switch$7){
		                  if(0 >= switch$7)
		                   return caml_trampoline_cps_call2(of_string$14, 46, cont);
		                  var switch$8 = caml_string_compare(key, cst_f1);
		                  if(0 <= switch$8){
		                   if(0 >= switch$8)
		                    return caml_trampoline_cps_call2(of_string$14, 56, cont);
		                   var switch$9 = caml_string_compare(key, cst_f5);
		                   if(0 <= switch$9){
		                    if(0 >= switch$9)
		                     return caml_trampoline_cps_call2(of_string$14, 60, cont);
		                    if(key === cst_f6)
		                     return caml_trampoline_cps_call2(of_string$14, 61, cont);
		                    if(key === cst_f7)
		                     return caml_trampoline_cps_call2(of_string$14, 62, cont);
		                    if(key === cst_f8)
		                     return caml_trampoline_cps_call2(of_string$14, 63, cont);
		                    if(key === cst_f9)
		                     return caml_trampoline_cps_call2(of_string$14, 64, cont);
		                    if(key === cst_g)
		                     return caml_trampoline_cps_call2(of_string$14, 7, cont);
		                    if(key === cst_h$0)
		                     return caml_trampoline_cps_call2(of_string$14, 8, cont);
		                   }
		                   else {
		                    if(key === cst_f10)
		                     return caml_trampoline_cps_call2(of_string$14, 65, cont);
		                    if(key === cst_f11)
		                     return caml_trampoline_cps_call2(of_string$14, 66, cont);
		                    if(key === cst_f12)
		                     return caml_trampoline_cps_call2(of_string$14, 67, cont);
		                    if(key === cst_f2)
		                     return caml_trampoline_cps_call2(of_string$14, 57, cont);
		                    if(key === cst_f3)
		                     return caml_trampoline_cps_call2(of_string$14, 58, cont);
		                    if(key === cst_f4)
		                     return caml_trampoline_cps_call2(of_string$14, 59, cont);
		                   }
		                  }
		                  else {
		                   var switch$10 = caml_string_compare(key, cst_down);
		                   if(0 <= switch$10){
		                    if(0 >= switch$10)
		                     return caml_trampoline_cps_call2(of_string$14, 97, cont);
		                    if(key === cst_e)
		                     return caml_trampoline_cps_call2(of_string$14, 5, cont);
		                    if(key === cst_end)
		                     return caml_trampoline_cps_call2(of_string$14, 101, cont);
		                    if(key === "enter")
		                     return caml_trampoline_cps_call2(of_string$14, 40, cont);
		                    if(key === cst_esc)
		                     return caml_trampoline_cps_call2(of_string$14, 42, cont);
		                    if(key === "escape")
		                     return caml_trampoline_cps_call2(of_string$14, 42, cont);
		                    if(key === cst_f$0)
		                     return caml_trampoline_cps_call2(of_string$14, 6, cont);
		                   }
		                   else {
		                    if(key === "cmd")
		                     return caml_trampoline_cps_call2(of_string$14, 88, cont);
		                    if(key === cst_command)
		                     return caml_trampoline_cps_call2(of_string$14, 88, cont);
		                    if(key === "control")
		                     return caml_trampoline_cps_call2(of_string$14, 86, cont);
		                    if(key === cst_ctrl)
		                     return caml_trampoline_cps_call2(of_string$14, 86, cont);
		                    if(key === cst_d$0)
		                     return caml_trampoline_cps_call2(of_string$14, 4, cont);
		                    if(key === cst_del)
		                     return caml_trampoline_cps_call2(of_string$14, 45, cont);
		                    if(key === cst_delete)
		                     return caml_trampoline_cps_call2(of_string$14, 45, cont);
		                   }
		                  }
		                 }
		                 else {
		                  var switch$11 = caml_string_compare(key, cst_9);
		                  if(0 <= switch$11){
		                   if(0 >= switch$11)
		                    return caml_trampoline_cps_call2(of_string$14, 36, cont);
		                   var switch$12 = caml_string_compare(key, cst_a$0);
		                   if(0 <= switch$12){
		                    if(0 >= switch$12)
		                     return caml_trampoline_cps_call2(of_string$14, 1, cont);
		                    if(key === cst_alt)
		                     return caml_trampoline_cps_call2(of_string$14, 92, cont);
		                    if(key === cst_b)
		                     return caml_trampoline_cps_call2(of_string$14, 2, cont);
		                    if(key === cst_backspace)
		                     return caml_trampoline_cps_call2(of_string$14, 43, cont);
		                    if(key === "break")
		                     return caml_trampoline_cps_call2(of_string$14, 123, cont);
		                    if(key === cst_c$0)
		                     return caml_trampoline_cps_call2(of_string$14, 3, cont);
		                    if(key === "caps")
		                     return caml_trampoline_cps_call2(of_string$14, 46, cont);
		                   }
		                   else {
		                    if(key === cst$2)
		                     return caml_trampoline_cps_call2(of_string$14, 49, cont);
		                    if(key === cst$24)
		                     return caml_trampoline_cps_call2(of_string$14, 38, cont);
		                    if(key === cst$37)
		                     return caml_trampoline_cps_call2(of_string$14, 47, cont);
		                    if(key === cst$19)
		                     return caml_trampoline_cps_call2(of_string$14, 52, cont);
		                    if(key === cst$36)
		                     return caml_trampoline_cps_call2(of_string$14, 48, cont);
		                    if(key === cst$59)
		                     return caml_trampoline_cps_call2(of_string$14, 51, cont);
		                   }
		                  }
		                  else {
		                   var switch$13 = caml_string_compare(key, cst_2$2);
		                   if(0 <= switch$13){
		                    if(0 >= switch$13)
		                     return caml_trampoline_cps_call2(of_string$14, 29, cont);
		                    if(key === cst_3)
		                     return caml_trampoline_cps_call2(of_string$14, 30, cont);
		                    if(key === cst_4)
		                     return caml_trampoline_cps_call2(of_string$14, 31, cont);
		                    if(key === cst_5)
		                     return caml_trampoline_cps_call2(of_string$14, 32, cont);
		                    if(key === cst_6)
		                     return caml_trampoline_cps_call2(of_string$14, 33, cont);
		                    if(key === cst_7)
		                     return caml_trampoline_cps_call2(of_string$14, 34, cont);
		                    if(key === cst_8)
		                     return caml_trampoline_cps_call2(of_string$14, 35, cont);
		                   }
		                   else {
		                    if(key === cst$35)
		                     return caml_trampoline_cps_call2(of_string$14, 50, cont);
		                    if(key === cst$25)
		                     return caml_trampoline_cps_call2(of_string$14, 53, cont);
		                    if(key === cst$33)
		                     return caml_trampoline_cps_call2(of_string$14, 37, cont);
		                    if(key === cst$14)
		                     return caml_trampoline_cps_call2(of_string$14, 54, cont);
		                    if(key === cst$34)
		                     return caml_trampoline_cps_call2(of_string$14, 55, cont);
		                    if(key === cst_0)
		                     return caml_trampoline_cps_call2(of_string$14, 27, cont);
		                    if(key === cst_1)
		                     return caml_trampoline_cps_call2(of_string$14, 28, cont);
		                   }
		                  }
		                 }
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (kasprintf,
		                         fail,
		                         format$24,
		                         function(a){return caml_trampoline_cps_call2(a, key, cont);});
		               }
		               function pp$133(ppf, v, cont){
		                var b = v, a = "unidentified";
		                if(53 <= b)
		                 switch(b){
		                   case 53:
		                    a = cst$25; break;
		                   case 54:
		                    a = cst$14; break;
		                   case 55:
		                    a = cst$34; break;
		                   case 56:
		                    a = cst_f1; break;
		                   case 57:
		                    a = cst_f2; break;
		                   case 58:
		                    a = cst_f3; break;
		                   case 59:
		                    a = cst_f4; break;
		                   case 60:
		                    a = cst_f5; break;
		                   case 61:
		                    a = cst_f6; break;
		                   case 62:
		                    a = cst_f7; break;
		                   case 63:
		                    a = cst_f8; break;
		                   case 64:
		                    a = cst_f9; break;
		                   case 65:
		                    a = cst_f10; break;
		                   case 66:
		                    a = cst_f11; break;
		                   case 67:
		                    a = cst_f12; break;
		                   case 68:
		                    a = cst_numpad0; break;
		                   case 69:
		                    a = cst_numpad1; break;
		                   case 70:
		                    a = cst_numpad2; break;
		                   case 71:
		                    a = cst_numpad3; break;
		                   case 72:
		                    a = cst_numpad4; break;
		                   case 73:
		                    a = cst_numpad5; break;
		                   case 74:
		                    a = cst_numpad6; break;
		                   case 75:
		                    a = cst_numpad7; break;
		                   case 76:
		                    a = cst_numpad8; break;
		                   case 77:
		                    a = cst_numpad9; break;
		                   case 78:
		                    a = cst_numpad; break;
		                   case 79:
		                    a = cst_numpad$0; break;
		                   case 80:
		                    a = cst_numpad$1; break;
		                   case 81:
		                    a = cst_numpad$2; break;
		                   case 82:
		                    a = cst_numpad$3; break;
		                   case 83:
		                    a = cst_numpad_return; break;
		                   case 84:
		                    a = cst_numpad$4; break;
		                   case 85:
		                    a = cst_numlock; break;
		                   case 86:
		                    a = cst_ctrl; break;
		                   case 87:
		                    a = cst_ctrl; break;
		                   case 88:
		                    a = cst_meta; break;
		                   case 89:
		                    a = cst_meta; break;
		                   case 90:
		                    a = cst_shift; break;
		                   case 91:
		                    a = cst_shift; break;
		                   case 92:
		                    a = cst_alt; break;
		                   case 93:
		                    a = cst_alt; break;
		                   case 94:
		                    a = cst_left; break;
		                   case 95:
		                    a = cst_right; break;
		                   case 96:
		                    a = cst_up; break;
		                   case 97:
		                    a = cst_down; break;
		                   case 98:
		                    a = cst_pageup; break;
		                   case 99:
		                    a = cst_pagedown; break;
		                   case 100:
		                    a = cst_home; break;
		                   case 101:
		                    a = cst_end; break;
		                   case 119:
		                    a = cst_scrolllock; break;
		                   case 123:
		                    a = cst_pause; break;
		                 }
		                else
		                 switch(b){
		                   case 0: break;
		                   case 1:
		                    a = cst_a$0; break;
		                   case 2:
		                    a = cst_b; break;
		                   case 3:
		                    a = cst_c$0; break;
		                   case 4:
		                    a = cst_d$0; break;
		                   case 5:
		                    a = cst_e; break;
		                   case 6:
		                    a = cst_f$0; break;
		                   case 7:
		                    a = cst_g; break;
		                   case 8:
		                    a = cst_h$0; break;
		                   case 9:
		                    a = cst_i$0; break;
		                   case 10:
		                    a = cst_j; break;
		                   case 11:
		                    a = cst_k; break;
		                   case 12:
		                    a = cst_l; break;
		                   case 13:
		                    a = cst_m; break;
		                   case 14:
		                    a = cst_n$0; break;
		                   case 15:
		                    a = cst_o$0; break;
		                   case 16:
		                    a = cst_p; break;
		                   case 17:
		                    a = cst_q; break;
		                   case 18:
		                    a = cst_r; break;
		                   case 19:
		                    a = cst_s$0; break;
		                   case 20:
		                    a = cst_t; break;
		                   case 21:
		                    a = cst_u$0; break;
		                   case 22:
		                    a = cst_v; break;
		                   case 23:
		                    a = cst_w; break;
		                   case 24:
		                    a = cst_x; break;
		                   case 25:
		                    a = cst_y; break;
		                   case 26:
		                    a = cst_z; break;
		                   case 27:
		                    a = cst_0; break;
		                   case 28:
		                    a = cst_1; break;
		                   case 29:
		                    a = cst_2$2; break;
		                   case 30:
		                    a = cst_3; break;
		                   case 31:
		                    a = cst_4; break;
		                   case 32:
		                    a = cst_5; break;
		                   case 33:
		                    a = cst_6; break;
		                   case 34:
		                    a = cst_7; break;
		                   case 35:
		                    a = cst_8; break;
		                   case 36:
		                    a = cst_9; break;
		                   case 37:
		                    a = cst$33; break;
		                   case 38:
		                    a = cst$24; break;
		                   case 39:
		                    a = cst_tab; break;
		                   case 40:
		                    a = cst_return; break;
		                   case 41:
		                    a = cst_space; break;
		                   case 42:
		                    a = cst_esc; break;
		                   case 43:
		                    a = cst_backspace; break;
		                   case 44:
		                    a = cst_insert; break;
		                   case 45:
		                    a = cst_del; break;
		                   case 46:
		                    a = cst_capslock; break;
		                   case 47:
		                    a = cst$37; break;
		                   case 48:
		                    a = cst$36; break;
		                   case 49:
		                    a = cst$2; break;
		                   case 50:
		                    a = cst$35; break;
		                   case 51:
		                    a = cst$59; break;
		                   default: a = cst$19;
		                 }
		                return caml_exact_trampoline_cps_call$1
		                        (pp_print_string, ppf, a, cont);
		               }
		               function pp$134(f, a, cont){
		                var
		                 modifiers = a[2],
		                 key = a[1],
		                 a = [0, some_if(modifiers[4], cst_shift), 0],
		                 a = [0, some_if(modifiers[3], cst_meta), a],
		                 a = [0, some_if(modifiers[2], cst_ctrl), a],
		                 modifiers$0 = [0, some_if(modifiers[1], cst_alt), a],
		                 b =
		                   list
		                    (0,
		                     function(ppf, param, cont){
		                      if(! param)
		                       return caml_exact_trampoline_cps_call$1
		                               (pp_none, ppf, dummy, cont);
		                      var v = param[1];
		                      return caml_exact_trampoline_cps_call$1
		                              (pp_print_string,
		                               ppf,
		                               v,
		                               function(a){
		                                return caml_exact_trampoline_cps_call$1
		(pp_print_char, ppf, 43, cont);
		                               });
		                     });
		                return caml_exact_trampoline_cps_call
		                        (fprintf$0(f),
		                         bNl,
		                         function(a){
		                          return caml_trampoline_cps_call5
		                                  (a, b, modifiers$0, pp$133, key, cont);
		                         });
		               }
		               function of_keys(keys, cont){
		                function f(a, k, cont){
		                 var mods = a[2], key = a[1], a = k - 86 | 0;
		                 if(7 < a >>> 0)
		                  return is_none$0(key)
		                          ? caml_trampoline_cps_call2
		                            (of_string$14, [0, [0, k], mods], cont)
		                          : caml_exact_trampoline_cps_call$1
		                            (kasprintf,
		                             fail,
		                             format$25,
		                             function(a){
		                              return caml_trampoline_cps_call3(a, pp$133, k, cont);
		                             });
		                 switch(a){
		                   case 0:
		                   case 1:
		                    return caml_trampoline_cps_call2
		                            (of_string$14,
		                             [0, key, [0, mods[1], 1, mods[3], mods[4]]],
		                             cont);
		                   case 2:
		                   case 3:
		                    return caml_trampoline_cps_call2
		                            (of_string$14,
		                             [0, key, [0, mods[1], mods[2], 1, mods[4]]],
		                             cont);
		                   case 4:
		                   case 5:
		                    return caml_trampoline_cps_call2
		                            (of_string$14,
		                             [0, key, [0, mods[1], mods[2], mods[3], 1]],
		                             cont);
		                   default:
		                    return caml_trampoline_cps_call2
		                            (of_string$14,
		                             [0, key, [0, 1, mods[2], mods[3], mods[4]]],
		                             cont);
		                 }
		                }
		                function a(param, cont){
		                 var match = param[1];
		                 if(match){
		                  var modifiers = param[2], key = match[1];
		                  return caml_trampoline_cps_call2
		                          (of_string$14, [0, key, modifiers], cont);
		                 }
		                 var
		                  a =
		                    list
		                     ([0,
		                       function(ppf, param, cont){
		                        return caml_exact_trampoline_cps_call$1
		                                (pp_print_string, ppf, cst$32, cont);
		                       }],
		                      pp$133);
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          fail,
		                          format$26,
		                          function(b){
		                           return caml_trampoline_cps_call3(b, a, keys, cont);
		                          });
		                }
		                return caml_exact_trampoline_cps_call$2
		                        (fold_result,
		                         fold_left$1,
		                         init$5,
		                         f,
		                         keys,
		                         function(b){
		                          return caml_trampoline_cps_call3(symbol_bind$30, b, a, cont);
		                         });
		               }
		               function of_string$60(desc, cont){
		                function a(keys, cont){
		                 return caml_exact_trampoline_cps_call(of_keys, keys, cont);
		                }
		                return caml_exact_trampoline_cps_call$1
		                        (split$0,
		                         desc,
		                         43,
		                         function(b){
		                          return caml_trampoline_cps_call3
		                                  (map$18,
		                                   b,
		                                   of_string$59,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call
		    (all$14,
		     b,
		     function(b){
		      return caml_trampoline_cps_call3(let$79, b, a, cont);
		     });
		                                   });
		                         });
		               }
		               function test$1(hotkey, evt){
		                var
		                 value = evt.keyCode,
		                 b = evt.location - 1 | 0,
		                 a = hotkey[1];
		                if(2 < b >>> 0)
		                 var f = function(v){return v;};
		                else
		                 switch(b){
		                   case 0:
		                    var
		                     value$3 = evt.keyCode,
		                     f =
		                       function(v){
		                        if(v) return v;
		                        if(19 <= value$3){
		                         if(91 === value$3) return 88;
		                        }
		                        else if(16 <= value$3)
		                         switch(value$3 - 16 | 0){
		                           case 0:
		                            return 90;
		                           case 1:
		                            return 86;
		                           default: return 92;
		                         }
		                        return 0;
		                       };
		                    break;
		                   case 1:
		                    var
		                     value$2 = evt.keyCode,
		                     f =
		                       function(v){
		                        if(v) return v;
		                        if(19 <= value$2){
		                         if(91 === value$2) return 89;
		                        }
		                        else if(16 <= value$2)
		                         switch(value$2 - 16 | 0){
		                           case 0:
		                            return 91;
		                           case 1:
		                            return 87;
		                           default: return 93;
		                         }
		                        return 0;
		                       };
		                    break;
		                   default:
		                    var
		                     value$1 = evt.keyCode,
		                     f =
		                       function(v){
		                        if(v) return v;
		                        if(47 <= value$1){
		                         var switcher = value$1 - 96 | 0;
		                         if(15 >= switcher >>> 0)
		                          switch(switcher){
		                            case 0:
		                             return 68;
		                            case 1:
		                             return 69;
		                            case 2:
		                             return 70;
		                            case 3:
		                             return 71;
		                            case 4:
		                             return 72;
		                            case 5:
		                             return 73;
		                            case 6:
		                             return 74;
		                            case 7:
		                             return 75;
		                            case 8:
		                             return 76;
		                            case 9:
		                             return 77;
		                            case 10:
		                             return 78;
		                            case 11:
		                             return 80;
		                            case 13:
		                             return 79;
		                            case 14:
		                             return 81;
		                            case 15:
		                             return 84;
		                          }
		                        }
		                        else if(12 <= value$1)
		                         switch(value$1 - 12 | 0){
		                           case 0:
		                            return 73;
		                           case 1:
		                            return 83;
		                           case 21:
		                            return 77;
		                           case 22:
		                            return 71;
		                           case 23:
		                            return 69;
		                           case 24:
		                            return 75;
		                           case 25:
		                            return 72;
		                           case 26:
		                            return 76;
		                           case 27:
		                            return 74;
		                           case 28:
		                            return 70;
		                           case 33:
		                            return 68;
		                           case 34:
		                            return 81;
		                         }
		                        return 0;
		                       };
		                 }
		                var
		                 value$0 = evt.code,
		                 x = value$0 === undefined$ ? 0 : try_code(value$0),
		                 x$4 = f(x),
		                 b = x$4 || try_key_code_normal(value),
		                 a = equal$257(b, a);
		                if(a){
		                 var
		                  y = hotkey[2][1],
		                  x$0 = evt.altKey | 0,
		                  a = x$0 === y ? 1 : 0;
		                 if(a){
		                  var
		                   y$0 = hotkey[2][2],
		                   x$1 = evt.ctrlKey | 0,
		                   a = x$1 === y$0 ? 1 : 0;
		                  if(a){
		                   var
		                    y$1 = hotkey[2][4],
		                    x$2 = evt.shiftKey | 0,
		                    a = x$2 === y$1 ? 1 : 0;
		                   if(a){
		                    var y$2 = hotkey[2][3], x$3 = evt.metaKey | 0;
		                    return x$3 === y$2 ? 1 : 0;
		                   }
		                  }
		                 }
		                }
		                return a;
		               }
		               function fatal_dev(msg, cont){
		                return caml_exact_trampoline_cps_call
		                        (msg,
		                         function(a, param, cont){return cont(asprintf);},
		                         function(a){return cont(fatal(a));});
		               }
		               function to_bool$2(v, cont){
		                if(v === false$0) return cont(0);
		                if(v === true$0) return cont(1);
		                var
		                 msg =
		                   [0,
		                    "v-hotkey handler returned an unrecognized value, please return true, false or undefined:",
		                    [0, v, 0]];
		                call$0(bPA, cst_error, msg_to_jv_array(msg));
		                return caml_exact_trampoline_cps_call
		                        (Logs$22[3],
		                         function(m, cont){
		                          return caml_trampoline_cps_call4(m, 0, 0, bNm, cont);
		                         },
		                         function(match){return cont(1);});
		               }
		               var
		                Map$5 =
		                  caml_callback
		                   (M$2, [[0, comparator$2, thread_id_schema_versioned]]),
		                bindings = empty$15();
		               function debug$4(opt, element, f, cont){
		                var attrs$0 = opt ? opt[1] : 0;
		                function f$0(m, cont){
		                 return caml_exact_trampoline_cps_call
		                         (f,
		                          function(header, tags, fmt, cont){
		                           var
		                            attrs$1 =
		                              [0, attr$0(cst_element, element, schema$1), attrs$0];
		                           function a(tags){
		                            return caml_trampoline_cps_call4
		                                    (m, header, [0, tags], fmt, cont);
		                           }
		                           if(! tags)
		                            return caml_exact_trampoline_cps_call(attrs, attrs$1, a);
		                           var tags$0 = tags[1];
		                           return caml_exact_trampoline_cps_call$0
		                                   (add$7, attributes, attrs$1, tags$0, a);
		                          },
		                          cont);
		                }
		                return caml_exact_trampoline_cps_call(Logs$22[6], f$0, cont);
		               }
		               function bind$31(param, element, keys, cont){
		                var modifiers = param[2], arg = param[1];
		                function a(b){
		                 function a(a){
		                  function f(key, data, listeners, cont){
		                   return caml_exact_trampoline_cps_call
		                           (of_string$60,
		                            key,
		                            function(match){
		                             if(0 === match[0]){
		                              var
		                               hotkey = match[1],
		                               handler =
		                                 function(doc, t4, cont){
		                                  return test$1(hotkey, t4)
		  ? caml_exact_trampoline_cps_call$0
		    (debug$4,
		     0,
		     element,
		     function(m, cont){
		      return caml_trampoline_cps_call6
		              (m, 0, 0, bNp, pp$134, hotkey, cont);
		     },
		     function(match){
		      var res = data.call(no_handler, t4);
		      function a(a){
		       return a
		               ? (t4.stopImmediatePropagation(), cont(0))
		               : cont(1);
		      }
		      return res === undefined$
		              ? a(1)
		              : caml_exact_trampoline_cps_call(to_bool$2, res, a);
		     })
		  : cont(1);
		                                 };
		                              return cont
		                                      ([0, listen(0, document, "keydown", handler), listeners]);
		                             }
		                             var msg = match[1];
		                             function msg$0(m, cont){
		                              return caml_trampoline_cps_call6
		                                      (m, 0, 0, bNq, key, msg, cont);
		                             }
		                             function a(a){return cont(listeners);}
		                             return dev
		                                     ? caml_exact_trampoline_cps_call(fatal_dev, msg$0, a)
		                                     : caml_exact_trampoline_cps_call(Logs$22[3], msg$0, a);
		                            });
		                  }
		                  return caml_exact_trampoline_cps_call$0
		                          (Map$5[38],
		                           keys,
		                           0,
		                           f,
		                           function(listeners){
		                            return cont(bindings.set(element, listeners));
		                           });
		                 }
		                 if(! modifiers) return a();
		                 function msg(m, cont){
		                  return caml_trampoline_cps_call6
		                          (m,
		                           0,
		                           0,
		                           bNo,
		                           list([0, comma], pp_print_string),
		                           modifiers,
		                           cont);
		                 }
		                 return dev
		                         ? caml_exact_trampoline_cps_call(fatal_dev, msg, a)
		                         : caml_exact_trampoline_cps_call(Logs$22[3], msg, a);
		                }
		                if(! arg) return a();
		                var arg$0 = arg[1];
		                function msg(m, cont){
		                 return caml_trampoline_cps_call5(m, 0, 0, bNn, arg$0, cont);
		                }
		                return dev
		                        ? caml_exact_trampoline_cps_call(fatal_dev, msg, a)
		                        : caml_exact_trampoline_cps_call(Logs$22[3], msg, a);
		               }
		               function unbind(param, element, keys, cont){
		                var listeners = bindings.get(element);
		                function b(){return cont(bindings.delete(element));}
		                function a(t){
		                 if(! t) return b();
		                 var l = t[2], id = t[1];
		                 return caml_trampoline_cps_call2
		                         (id,
		                          0,
		                          function(b){return caml_exact_trampoline_call1(a, l);});
		                }
		                return 1 - (listeners == no_handler) ? a(listeners) : b();
		               }
		               var
		                binding_schema = caml_callback(Map$5[110], [schema$1]),
		                cst_hotkeys = "hotkeys";
		               function hook_mounted(binding, element, keys, cont){
		                var b = list_schema(schematic_param_name_schema_ve);
		                function a(m, cont){
		                 return caml_exact_trampoline_cps_call$0(m, 0, 0, bNr, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (Map$5[56],
		                         keys,
		                         function(c){
		                          return caml_exact_trampoline_cps_call$0
		                                  (debug$4,
		                                   [0, [0, attr$0(cst_hotkeys, c, b), 0]],
		                                   element,
		                                   a,
		                                   function(match){
		                                    return caml_exact_trampoline_cps_call$0
		    (bind$31, binding, element, keys, cont);
		                                   });
		                         });
		               }
		               function hook_updated(binding, element, a, keys, cont){
		                var x = bindings.get(element), a = 1 - (x == no_handler);
		                if(! a) return cont(a);
		                var c = list_schema(schematic_param_name_schema_ve);
		                function b(m, cont){
		                 return caml_exact_trampoline_cps_call$0(m, 0, 0, bNs, cont);
		                }
		                return caml_exact_trampoline_cps_call
		                        (Map$5[56],
		                         keys,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$0
		                                  (debug$4,
		                                   [0, [0, attr$0(cst_hotkeys, a, c), 0]],
		                                   element,
		                                   b,
		                                   function(match){
		                                    return caml_exact_trampoline_cps_call$0
		    (unbind,
		     binding,
		     element,
		     keys,
		     function(a){
		      return caml_exact_trampoline_cps_call$0
		              (bind$31, binding, element, keys, cont);
		     });
		                                   });
		                         });
		               }
		               function hook_unmounted(binding, element, keys, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (debug$4,
		                         0,
		                         element,
		                         function(m, cont){
		                          return caml_exact_trampoline_cps_call$0(m, 0, 0, bNt, cont);
		                         },
		                         function(match){
		                          return caml_exact_trampoline_cps_call$0
		                                  (unbind, dummy, element, dummy, cont);
		                         });
		               }
		               var
		                directives =
		                  [0,
		                   [0,
		                    [0,
		                     binding_schema,
		                     0,
		                     0,
		                     0,
		                     0,
		                     [0, hook_mounted],
		                     [0, hook_unmounted],
		                     [0, hook_updated],
		                     cst_hotkey]],
		                   0];
		               function install(app, opts, cont){
		                var t = directives;
		                for(;;){
		                 if(! t) return cont(0);
		                 var l = t[2], a = t[1], dir = a[1], res = {};
		                 let res$0 = res, dir$0 = dir;
		                 var
		                  decode =
		                    function(v, cont){
		                     return caml_trampoline_cps_call3
		                             (decode$10,
		                              dir$0[1],
		                              v,
		                              function(t){
		                               function a(a){
		                                return caml_exact_trampoline_cps_call
		(ok_or_failwith, a, cont);
		                               }
		                               if(0 === t[0]) return a(t);
		                               var x = t[1];
		                               return caml_exact_trampoline_cps_call$1
		                                       (to_to_string,
		pp_decoding,
		x,
		function(b){return a([1, b]);});
		                              });
		                    },
		                  register_hook =
		                    function(name, hook, call){
		                     if(! hook) return;
		                     var hook$0 = hook[1];
		                     res$0[caml_jsstring_of_string(name)] =
		                      caml_js_wrap_callback_strict
		                       (4,
		                        function(element, binding, vnode, prevVnode, cont){
		                         var
		                          t4 = binding.modifiers,
		                          a = binding.directive,
		                          b = binding.instance;
		                         return caml_trampoline_cps_call3
		                                 (map$18,
		                                  concat_of_array
		                                   (caml_js_to_array(object_constructor.keys(t4))),
		                                  function(a, cont){return cont(caml_string_of_jsstring(a));},
		                                  function(c){
		                                   return caml_trampoline_cps_call3
		   (map$17,
		    to_option$0(binding.arg),
		    function(a, cont){return cont(caml_string_of_jsstring(a));},
		    function(d){
		     return caml_trampoline_cps_call3
		             (hook$0,
		              [0, d, c, b, a],
		              element,
		              function(hook){
		               return caml_exact_trampoline_cps_call
		                       (decode$0,
		                        binding.value,
		                        function(value){
		                         return caml_trampoline_cps_call4
		                                 (call, binding, hook, value, cont);
		                        });
		              });
		    });
		                                  });
		                        });
		                    },
		                  register_hook$0 =
		                    function(name, hook){
		                     return register_hook$1
		                             (name, hook, function(param, h, cont){return cont(h);});
		                    },
		                  register_update_hook =
		                    function(name, hook){
		                     return register_hook$1
		                             (name,
		                              hook,
		                              function(binding, h, cont){
		                               return caml_exact_trampoline_cps_call
		                                       (decode$0,
		binding.oldValue,
		function(a){return caml_trampoline_cps_call2(h, a, cont);});
		                              });
		                    };
		                 let decode$0 = decode, register_hook$1 = register_hook;
		                 register_hook$0("beforeMount", dir[2]);
		                 register_hook$0("beforeUnmount", dir[3]);
		                 register_update_hook("beforeUpdate", dir[4]);
		                 register_hook$0(cst_created, dir[5]);
		                 register_hook$0("mounted", dir[6]);
		                 register_hook$0("unmounted", dir[7]);
		                 register_update_hook(cst_updated, dir[8]);
		                 var t7 = caml_jsstring_of_string(dir[9]);
		                 app.directive(t7, res);
		                 t = l;
		                }
		               }
		               var
		                plugin = caml_js_wrap_callback_strict(2, install),
		                daytime_of_js_exn = helpers(cst_daytime, schema$6)[3];
		               function make$141(locale){
		                function t15(param, week, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_js_exn,
		                          week,
		                          function(b){
		                           var a = locale[8];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$312,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      a,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                b,
		                function(a){return cont(caml_jsstring_of_string(a));});
		      });
		                                    });
		                          });
		                }
		                function t14(a, time$0, cont){
		                 a = of_float_s$0(time$0.getTime() / 1000.);
		                 function b(b){
		                  var a = locale[6];
		                  return caml_exact_trampoline_cps_call$1
		                          (kasprintf,
		                           id,
		                           fmt$313,
		                           function(c){
		                            return caml_trampoline_cps_call2
		                                    (c,
		                                     a,
		                                     function(a){
		                                      return caml_trampoline_cps_call2
		      (a,
		       b,
		       function(a){return cont(caml_jsstring_of_string(a));});
		                                     });
		                           });
		                 }
		                 if(a){var time = a[1]; return b(time);}
		                 var c = time$0.getTime();
		                 return caml_exact_trampoline_cps_call$1
		                         (kasprintf,
		                          failwith,
		                          fmt$122,
		                          function(a){return caml_trampoline_cps_call2(a, c, b);});
		                }
		                function t13(param, daytime, cont){
		                 return caml_exact_trampoline_cps_call
		                         (daytime_of_js_exn,
		                          daytime,
		                          function(b){
		                           var a = locale[4];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$314,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      a,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                b,
		                function(a){return cont(caml_jsstring_of_string(a));});
		      });
		                                    });
		                          });
		                }
		                function t12(param, date, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_js$1,
		                          date,
		                          function(b){
		                           var a = locale[3];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$315,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      a,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                b,
		                function(a){return cont(caml_jsstring_of_string(a));});
		      });
		                                    });
		                          });
		                }
		                function t11(param, start, end, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_js$1,
		                          start,
		                          function(start){
		                           return caml_exact_trampoline_cps_call
		                                   (of_js$1,
		                                    end,
		                                    function(end){
		                                     var a = [0, start, end], b = locale[2];
		                                     return caml_exact_trampoline_cps_call$1
		     (kasprintf,
		      id,
		      fmt$316,
		      function(c){
		       return caml_trampoline_cps_call3
		               (c,
		                b,
		                a,
		                function(a){return cont(caml_jsstring_of_string(a));});
		      });
		                                    });
		                          });
		                }
		                function t10(param, date, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_js$1,
		                          date,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$317,
		                                    function(b){
		                                     return caml_trampoline_cps_call2
		     (b,
		      pp_v1$0,
		      function(b){
		       return caml_trampoline_cps_call2
		               (b,
		                a,
		                function(a){return cont(caml_jsstring_of_string(a));});
		      });
		                                    });
		                          });
		                }
		                function t9(param, date, cont){
		                 return caml_exact_trampoline_cps_call
		                         (of_js$1,
		                          date,
		                          function(b){
		                           var a = locale[1];
		                           return caml_exact_trampoline_cps_call$1
		                                   (kasprintf,
		                                    id,
		                                    fmt$318,
		                                    function(c){
		                                     return caml_trampoline_cps_call2
		     (c,
		      a,
		      function(a){
		       return caml_trampoline_cps_call2
		               (a,
		                b,
		                function(a){return cont(caml_jsstring_of_string(a));});
		      });
		                                    });
		                          });
		                }
		                return {caml: locale,
		                        formatDate: caml_js_wrap_meth_callback(t9),
		                        formatDateISO: caml_js_wrap_meth_callback(t10),
		                        formatDateRange: caml_js_wrap_meth_callback(t11),
		                        formatDateRelative: caml_js_wrap_meth_callback(t12),
		                        formatDaytime: caml_js_wrap_meth_callback(t13),
		                        formatTimeRelative: caml_js_wrap_meth_callback(t14),
		                        formatWeek: caml_js_wrap_meth_callback(t15)};
		               }
		               caml_callback(of_schema$1, [google_error_schema]);
		               function of_lwt$0(p){
		                o
		                 ([0,
		                   symbol_bind$9,
		                   symbol_map$7,
		                   Let_syntax$5,
		                   ,
		                   bind$12,
		                   return$13,
		                   map$25]);
		                var
		                 t12 =
		                   caml_js_wrap_callback
		                    (function(resolve, reject, cont){
		                      function p$0(param, cont){
		                       function a(param, cont){
		                        if(0 === param[0]){
		                         var v = param[1];
		                         return caml_trampoline_cps_call2
		                                 (return$12, resolve(v), cont);
		                        }
		                        var e = param[1];
		                        return caml_exact_trampoline_cps_call$1
		                                (to_to_string,
		                                 pp_toplevel,
		                                 e,
		                                 function(a){
		                                  return caml_trampoline_cps_call2
		  (return$12, reject(js_error_of_string(a)), cont);
		                                 });
		                       }
		                       return caml_exact_trampoline_cps_call
		                               (p,
		                                dummy,
		                                function(b){
		                                 return caml_exact_trampoline_cps_call$1
		 (symbol_bind$8, b, a, cont);
		                                });
		                      }
		                      return caml_exact_trampoline_cps_call$1
		                              (catch$,
		                               p$0,
		                               function(e, cont){
		                                return caml_exact_trampoline_cps_call
		(to_string$0,
		 e,
		 function(msg){
		  var t10 = caml_jsstring_of_string(msg);
		  reject(new error_constr(t10));
		  return caml_trampoline_cps_call2(return$13, 0, cont);
		 });
		                               },
		                               cont);
		                     });
		                return new Promise(t12);
		               }
		               function apply_update(param, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (send$0,
		                         0,
		                         0,
		                         "restart",
		                         function(a){
		                          return caml_exact_trampoline_cps_call(return$11, a, cont);
		                         });
		               }
		               function check_for_update(param, cont){
		                return caml_exact_trampoline_cps_call$0
		                        (send$0,
		                         0,
		                         0,
		                         "check-for-updates",
		                         function(a){
		                          a = caml_obj_tag(ipc);
		                          function b(ipc){
		                           var
		                            open =
		                              g
		                               ([0,
		                                 symbol_bind$8,
		                                 symbol_map$6,
		                                 ,
		                                 bind$10,
		                                 return$12,
		                                 map$23,
		                                 ,
		                                 ,
		                                 ,
		                                 ,
		                                 Let_syntax$4]),
		                            let$ = open[3],
		                            match = wait(),
		                            resolve = match[2],
		                            wait$0 = match[1];
		                           function f(event, payload, cont){
		                            return caml_exact_trampoline_cps_call$1
		                                    (wakeup, resolve, payload, cont);
		                           }
		                           var
		                            callback = caml_js_wrap_callback_strict(2, f),
		                            cst_checked_for_updates = "checked-for-updates";
		                           ipc.once(cst_checked_for_updates, callback);
		                           return caml_trampoline_cps_call3
		                                   (let$,
		                                    wait$0,
		                                    function(value, cont){
		                                     var match = to_option$1(value);
		                                     if(! match)
		                                      return caml_exact_trampoline_cps_call
		      (failwith, "Ipc.on: missing payload", cont);
		                                     var value$0 = match[1];
		                                     return caml_trampoline_cps_call3
		     (decode$10,
		      bool_schema,
		      value$0,
		      function(t){
		       if(0 === t[0])
		        var a = t;
		       else
		        var
		         x = t[1],
		         a = [1, [0, -325815612, [0, cst_checked_for_updates, x]]];
		       return caml_trampoline_cps_call2(return$12, a, cont);
		      });
		                                    },
		                                    cont);
		                          }
		                          if(250 === a) return b(ipc[1]);
		                          if(246 !== a && 244 !== a) return b(ipc);
		                          return caml_exact_trampoline_cps_call
		                                  (force_lazy_block, ipc, b);
		                         });
		               }
		               function apply_update$0(param, cont){
		                var t1 = global.location;
		                return caml_exact_trampoline_cps_call
		                        (return$11, t1.reload(), cont);
		               }
		               function check_for_update$0(param, cont){
		                return caml_exact_trampoline_cps_call(return$11, 0, cont);
		               }
		               g
		                ([0,
		                  symbol_bind$8,
		                  symbol_map$6,
		                  ,
		                  bind$10,
		                  return$12,
		                  map$23,
		                  ,
		                  ,
		                  ,
		                  ,
		                  Let_syntax$4]);
		               var
		                t1$2 = global.location,
		                location$0 =
		                  caml_callback
		                   (of_string$19, [caml_string_of_jsstring(t1$2.href)]),
		                e = caml_callback(host$1, [location$0]),
		                Web = [0, apply_update$0, check_for_update$0],
		                Update =
		                  e
		                   ? e
		                      [1]
		                     !== "desktop.routine.co"
		                     ? Web
		                     : [0, apply_update, check_for_update]
		                   : Web;
		               function t27(param, key, e, cont){return cont(! ! test$1(key, e));
		               }
		               function t26$0(param, s, cont){
		                var s$0 = caml_string_of_jsstring(s);
		                return caml_exact_trampoline_cps_call
		                        (of_string$60,
		                         s$0,
		                         function(t){
		                          if(0 === t[0])
		                           var param = t;
		                          else
		                           var msg = t[1], param = [1, [0, 9943782, msg]];
		                          if(0 === param[0]){var v = param[1]; return cont(v);}
		                          var e = param[1];
		                          return caml_exact_trampoline_cps_call$1
		                                  (kasprintf,
		                                   id,
		                                   fmt$311,
		                                   function(a){
		                                    return caml_trampoline_cps_call3
		    (a,
		     pp_toplevel,
		     e,
		     function(a){
		      var t1 = caml_jsstring_of_string(a);
		      return cont(caml_throw_js_exception(new error_constr(t1)));
		     });
		                                   });
		                         });
		               }
		               var
		                t48 =
		                  {make: caml_js_wrap_meth_callback(t26$0),
		                   test: caml_js_wrap_meth_callback(t27),
		                   plugin: plugin};
		               function t47(self, cont){
		                return cont
		                        (function(s, cont){
		                          var s$0 = caml_string_of_jsstring(s);
		                          return caml_exact_trampoline_cps_call$1
		                                  (to_text$0,
		                                   0,
		                                   s$0,
		                                   function(match){
		                                    if(0 === match[0]){
		                                     var text = match[1];
		                                     return cont(caml_jsstring_of_string(text));
		                                    }
		                                    var s = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (js_raise,
		     bNA,
		     function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                                   });
		                         });
		               }
		               function t46(self, cont){
		                return cont
		                        (function(base, remote, local, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (of_js_exn$0,
		                                   base,
		                                   function(base){
		                                    return caml_exact_trampoline_cps_call
		    (of_js_exn$0,
		     remote,
		     function(remote){
		      return caml_exact_trampoline_cps_call
		              (of_js_exn$0,
		               local,
		               function(local){
		                return caml_exact_trampoline_cps_call$0
		                        (merge$5,
		                         base,
		                         remote,
		                         local,
		                         function(a){
		                          return caml_exact_trampoline_cps_call(to_js$2, a, cont);
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function t45(self, cont){
		                return caml_exact_trampoline_cps_call
		                        (to_js$4, make$139(), cont);
		               }
		               function t44(self, cont){return cont(of_lwt$0(Update[2]));}
		               function t43(self, cont){return cont(of_lwt$0(Update[1]));}
		               function t42(self, cont){
		                return cont
		                        (function(h, s, cont){
		                          function text(t){
		                           return h
		                                   (cst_span,
		                                    obj([0, [0, "innerHTML", caml_jsstring_of_string(t)]]));
		                          }
		                          var s$0 = caml_string_of_jsstring(s);
		                          return caml_exact_trampoline_cps_call$2
		                                  (to_html,
		                                   0,
		                                   function(tag, opt, children, cont){
		                                    var attrs = opt ? opt[1] : 0;
		                                    return caml_trampoline_cps_call3
		    (map$18,
		     attrs,
		     function(param, cont){
		      var prop = param[1];
		      if(prop !== cst_target){
		       var v = param[2];
		       return cont([0, prop, caml_jsstring_of_string(v)]);
		      }
		      var v$0 = param[2];
		      return caml_exact_trampoline_cps_call
		              (of_string$40,
		               v$0,
		               function(match){
		                if(0 !== match[0])
		                 return cont([0, prop, caml_jsstring_of_string(v$0)]);
		                var id = match[1];
		                return caml_trampoline_cps_call3
		                        (encode$10,
		                         schema$46,
		                         id,
		                         function(a){return cont([0, prop, a]);});
		               });
		     },
		     function(a){
		      return caml_exact_trampoline_cps_call
		              (to_array,
		               a,
		               function(a){
		                var
		                 attrs = caml_js_object(a),
		                 ja = create$22(0),
		                 a = children,
		                 i$0 = 0;
		                for(;;){
		                 if(! a)
		                  return cont(h(caml_jsstring_of_string(tag), attrs, ja));
		                 var vs = a[2], v = a[1];
		                 ja[i$0] = v;
		                 var i = i$0 + 1 | 0;
		                 a = vs;
		                 i$0 = i;
		                }
		               });
		     });
		                                   },
		                                   text,
		                                   s$0,
		                                   function(a){
		                                    if(0 !== a[0]){
		                                     var s = a[1];
		                                     return caml_exact_trampoline_cps_call
		     (js_raise,
		      bNB,
		      function(a){return caml_trampoline_cps_call2(a, s, cont);});
		                                    }
		                                    var html = a[1], ja = create$22(0), a = html, i$0 = 0;
		                                    for(;;){
		                                     if(! a) return cont(ja);
		                                     var vs = a[2], v = a[1];
		                                     ja[i$0] = v;
		                                     var i = i$0 + 1 | 0;
		                                     a = vs;
		                                     i$0 = i;
		                                    }
		                                   });
		                         });
		               }
		               function t41(self, cont){
		                return cont
		                        (function(s, cont){
		                          var s$0 = caml_string_of_jsstring(s);
		                          return caml_exact_trampoline_cps_call
		                                  (to_html_string,
		                                   s$0,
		                                   function(match){
		                                    if(0 === match[0]){
		                                     var html = match[1];
		                                     return cont(caml_jsstring_of_string(html));
		                                    }
		                                    var s = match[1];
		                                    return caml_exact_trampoline_cps_call$1
		    (kasprintf,
		     id,
		     fmt$319,
		     function(a){
		      return caml_trampoline_cps_call2
		              (a,
		               s,
		               function(a){
		                return caml_exact_trampoline_cps_call$1
		                        (throw$, 0, caml_jsstring_of_string(a), cont);
		               });
		     });
		                                   });
		                         });
		               }
		               function t40(self, cont){
		                return cont
		                        (function(s, cont){
		                          var s$0 = caml_string_of_jsstring(s);
		                          return caml_exact_trampoline_cps_call
		                                  (of_html,
		                                   s$0,
		                                   function(match){
		                                    if(0 === match[0]){
		                                     var blocks = match[1];
		                                     return caml_trampoline_cps_call3
		     (map$18,
		      blocks,
		      to_js$3,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (to_array,
		                a,
		                function(a){return cont(caml_js_from_array(a));});
		      });
		                                    }
		                                    var e = match[1];
		                                    return caml_exact_trampoline_cps_call
		    (js_raise,
		     bNC,
		     function(a){
		      return caml_trampoline_cps_call3(a, s$0, e, cont);
		     });
		                                   });
		                         });
		               }
		               function t39(self, cont){
		                return cont
		                        (function(recurrence, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (of_js_exn$3,
		                                   recurrence,
		                                   function(recurrence){
		                                    return caml_exact_trampoline_cps_call
		    (today,
		     dummy,
		     function(a){
		      return caml_exact_trampoline_cps_call$1
		              (occurrences_count,
		               a,
		               recurrence,
		               function(a){return cont(option$1(a));});
		     });
		                                   });
		                         });
		               }
		               function t38(self, cont){
		                return cont
		                        (function(n, recurrence, start, cont){
		                          return caml_exact_trampoline_cps_call$1
		                                  (map$9,
		                                   to_option$0(start),
		                                   of_js$1,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (today,
		     dummy,
		     function(b){
		      var start = value$4(a, b);
		      return caml_exact_trampoline_cps_call
		              (recurrence_of_js_exn,
		               recurrence,
		               function(recurrence){
		                return caml_exact_trampoline_cps_call$1
		                        (occurrences,
		                         start,
		                         recurrence,
		                         function(a){
		                          return caml_exact_trampoline_cps_call$1
		                                  (take$1,
		                                   a,
		                                   n,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (to_binable,
		     a,
		     function(a){
		      return caml_trampoline_cps_call3
		              (map$18,
		               a,
		               to_js$1,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (to_array,
		                         a,
		                         function(a){return cont(caml_js_from_array(a));});
		               });
		     });
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function t37(self, cont){
		                return cont
		                        (function(date, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (of_js$1,
		                                   date,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (of_date$1,
		     a,
		     function(a){
		      return caml_exact_trampoline_cps_call(to_js$0, a, cont);
		     });
		                                   });
		                         });
		               }
		               function t36(self, cont){
		                return cont
		                        (function(week, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (of_js_exn,
		                                   week,
		                                   function(week){
		                                    return caml_exact_trampoline_cps_call
		    (to_date$2,
		     week,
		     function(start){
		      return caml_exact_trampoline_cps_call$1
		              (add_days,
		               start,
		               6,
		               function(a){
		                return caml_exact_trampoline_cps_call
		                        (to_js$1,
		                         a,
		                         function(snd){
		                          return caml_exact_trampoline_cps_call
		                                  (to_js$1,
		                                   start,
		                                   function(fst){
		                                    return cont(caml_js_from_array([0, fst, snd]));
		                                   });
		                         });
		               });
		     });
		                                   });
		                         });
		               }
		               function t35(self, cont){
		                return cont
		                        (function(default_document, title, query, contextual, cont){
		                          function schematic_version(param, cont){return cont(0);}
		                          return caml_exact_trampoline_cps_call
		                                  (document_schema_versioned,
		                                   schematic_version,
		                                   function(a){
		                                    return caml_exact_trampoline_cps_call
		    (option_schema,
		     a,
		     function(a){
		      return caml_trampoline_cps_call3
		              (decode$10,
		               a,
		               default_document,
		               function(t){
		                function a(a){
		                 return caml_exact_trampoline_cps_call
		                         (ok_or_failwith,
		                          a,
		                          function(default_document){
		                           var contextual$0 = contextual | 0;
		                           return caml_exact_trampoline_cps_call
		                                   (of_js_exn$2,
		                                    query,
		                                    function(query){
		                                     var title$0 = caml_string_of_jsstring(title);
		                                     return caml_exact_trampoline_cps_call$2
		     (actions,
		      default_document,
		      title$0,
		      query,
		      contextual$0,
		      function(a){
		       return caml_exact_trampoline_cps_call
		               (elements_of_list,
		                a,
		                function(a){
		                 return caml_trampoline_cps_call3
		                         (map$18,
		                          a,
		                          action_to_js,
		                          function(a){
		                           return caml_exact_trampoline_cps_call
		                                   (to_array,
		                                    a,
		                                    function(a){return cont(caml_js_from_array(a));});
		                          });
		                });
		      });
		                                    });
		                          });
		                }
		                if(0 === t[0]) return a(t);
		                var x = t[1];
		                return caml_exact_trampoline_cps_call$1
		                        (to_to_string,
		                         pp_decoding,
		                         x,
		                         function(b){return a([1, b]);});
		               });
		     });
		                                   });
		                         });
		               }
		               function t34(self, cont){
		                return cont
		                        (function(r, every, cont){
		                          var r$0 = to_option$0(r), every$0 = every | 0;
		                          function a(str){return cont(caml_jsstring_of_string(str));}
		                          if(! r$0) return a("No recurrence");
		                          var r$1 = r$0[1];
		                          return caml_exact_trampoline_cps_call
		                                  (recurrence_of_js_exn,
		                                   r$1,
		                                   function(b){
		                                    return caml_exact_trampoline_cps_call$1
		    (to_string$47, [0, every$0], b, a);
		                                   });
		                         });
		               }
		               function t32(self, cont){
		                return cont
		                        (function(config, cont){
		                          return caml_exact_trampoline_cps_call
		                                  (of_js_exn$1,
		                                   config,
		                                   function(a){return cont(make$141(make$137(a)));});
		                         });
		               }
		               function t31(self, cont){
		                function report(src, level, over, k, msgf, cont){
		                 return caml_exact_trampoline_cps_call$7
		                         (console_report, 0, dummy, level, over, k, msgf, cont);
		                }
		                set(reporter, [0, report]);
		                function a(a){
		                 return caml_exact_trampoline_cps_call$1
		                         (set_level,
		                          src$1,
		                          bNw,
		                          function(a){
		                           return caml_exact_trampoline_cps_call$1
		                                   (set_level, src$6, bNx, cont);
		                          });
		                }
		                return dev
		                        ? caml_exact_trampoline_cps_call
		                          (set_all_levels,
		                           bNu,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (set_level, logs_src$1, bNv, a);
		                           })
		                        : caml_exact_trampoline_cps_call
		                          (set_all_levels,
		                           bNy,
		                           function(b){
		                            return caml_exact_trampoline_cps_call$1
		                                    (set_level, src$5, bNz, a);
		                           });
		               }
		               var
		                t30 =
		                  caml_jsstring_of_string
		                   (caml_callback(to_string$11, [version$0])),
		                t29 = ! ! dev,
		                obj$0 =
		                  {dev: t29,
		                   version: t30,
		                   setupLogs: caml_js_wrap_meth_callback(t31),
		                   locale: caml_js_wrap_meth_callback(t32),
		                   mandateCompletionStopper: "​",
		                   ppRecurrence: caml_js_wrap_meth_callback(t34),
		                   consoleActions: caml_js_wrap_meth_callback(t35),
		                   datesOfWeek: caml_js_wrap_meth_callback(t36),
		                   weekOfDate: caml_js_wrap_meth_callback(t37),
		                   nextOccurrences: caml_js_wrap_meth_callback(t38),
		                   occurrenceCount: caml_js_wrap_meth_callback(t39),
		                   richTextOfHTML: caml_js_wrap_meth_callback(t40),
		                   HTMLOfRichText: caml_js_wrap_meth_callback(t41),
		                   elementsOfRichText: caml_js_wrap_meth_callback(t42),
		                   applyUpdate: caml_js_wrap_meth_callback(t43),
		                   checkForUpdate: caml_js_wrap_meth_callback(t44),
		                   makeBlockId: caml_js_wrap_meth_callback(t45),
		                   mergeDocuments: caml_js_wrap_meth_callback(t46),
		                   textOfRichText: caml_js_wrap_meth_callback(t47),
		                   hotkeys: t48},
		                keys$1 = object_constructor.keys(obj$0),
		                t26 =
		                  caml_js_wrap_callback
		                   (function(key, a, param, cont){
		                     return cont(export_js(key, obj$0[key]));
		                    });
		               keys$1.forEach(t26);
		               export$
		                ("makeWebworkerController",
		                 caml_js_wrap_callback_strict(2, make$140));
		               export$
		                ("makeControllerElectronIPCClient",
		                 caml_js_wrap_callback_strict(1, Json[3]));
		               caml_callback(do_at_exit, [dummy]);
		              }
		              return b
		                      ([0,
		                        [0,
		                         Of_sexp_error,
		                         function(a, cont){
		                          if(a[1] === Of_sexp_error){
		                           var sexp = a[3], exc = a[2], b = [0, sexp, 0];
		                           return caml_exact_trampoline_cps_call
		                                   (sexp_of_exn,
		                                    exc,
		                                    function(a){return cont([1, [0, em, [0, a, b]]]);});
		                          }
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Assert_failure, en], 1));
		                         }],
		                        0]);
		             }
		             var
		              ek = [0, cst_src_sexp_conv_ml, 330, 15],
		              ei = [0, "Exit"],
		              ej = [0, cst_src_sexp_conv_ml, 334, 15],
		              eg = [0, m],
		              eh = [0, cst_src_sexp_conv_ml, 338, 15],
		              ee = [0, cst_Failure],
		              ef = [0, cst_src_sexp_conv_ml, 342, 15],
		              ec = [0, h],
		              ed = [0, cst_src_sexp_conv_ml, 346, 15],
		              ea = [0, A],
		              eb = [0, cst_src_sexp_conv_ml, 350, 15],
		              d$ = [0, cst_src_sexp_conv_ml, 354, 15],
		              d9 = [0, "Not_found_s"],
		              d_ = [0, cst_src_sexp_conv_ml, 358, 15],
		              d7 = [0, z],
		              d8 = [0, cst_src_sexp_conv_ml, 362, 15],
		              d5 = [0, "Arg.Help"],
		              d6 = [0, cst_src_sexp_conv_ml, 366, 15],
		              d3 = [0, "Arg.Bad"],
		              d4 = [0, cst_src_sexp_conv_ml, 370, 15],
		              d1 = [0, "Lazy.Undefined"],
		              d2 = [0, cst_src_sexp_conv_ml, 374, 15],
		              dZ = [0, "Parsing.Parse_error"],
		              d0 = [0, cst_src_sexp_conv_ml, 378, 15],
		              dX = [0, "Queue.Empty"],
		              dY = [0, cst_src_sexp_conv_ml, 382, 15],
		              dV = [0, "Scanf.Scan_failure"],
		              dW = [0, cst_src_sexp_conv_ml, 386, 15],
		              dT = [0, "Stack.Empty"],
		              dU = [0, cst_src_sexp_conv_ml, 390, 15],
		              dR = [0, "Sys.Break"],
		              dS = [0, cst_src_sexp_conv_ml, 394, 15];
		             return bT
		                     ([0,
		                       [0,
		                        Assert_failure,
		                        function(param, a){
		                         if(param[1] === Assert_failure){
		                          var arg = param[2];
		                          return caml_exact_trampoline_cps_call$1
		                                  (get_flc_error, cst_Assert_failure, arg, a);
		                         }
		                         a = caml_pop_trap();
		                         return a
		                                 (caml_maybe_attach_backtrace([0, Assert_failure, ek], 1));
		                        }],
		                       [0,
		                        [0,
		                         Exit,
		                         function(param, a){
		                          if(param === Exit) return a(ei);
		                          a = caml_pop_trap();
		                          return a
		                                  (caml_maybe_attach_backtrace([0, Assert_failure, ej], 1));
		                         }],
		                        [0,
		                         [0,
		                          End_of_file,
		                          function(param, a){
		                           if(param === End_of_file) return a(eg);
		                           a = caml_pop_trap();
		                           return a
		                                   (caml_maybe_attach_backtrace([0, Assert_failure, eh], 1));
		                          }],
		                         [0,
		                          [0,
		                           Failure,
		                           function(param, a){
		                            if(param[1] === Failure){
		                             var arg = param[2];
		                             return a([1, [0, ee, [0, [0, arg], 0]]]);
		                            }
		                            a = caml_pop_trap();
		                            return a
		                                    (caml_maybe_attach_backtrace([0, Assert_failure, ef], 1));
		                           }],
		                          [0,
		                           [0,
		                            Not_found,
		                            function(param, a){
		                             if(param === Not_found) return a(ec);
		                             a = caml_pop_trap();
		                             return a
		                                     (caml_maybe_attach_backtrace([0, Assert_failure, ed], 1));
		                            }],
		                           [0,
		                            [0,
		                             Invalid_argument,
		                             function(param, a){
		                              if(param[1] === Invalid_argument){
		                               var arg = param[2];
		                               return a([1, [0, ea, [0, [0, arg], 0]]]);
		                              }
		                              a = caml_pop_trap();
		                              return a
		                                      (caml_maybe_attach_backtrace([0, Assert_failure, eb], 1));
		                             }],
		                            [0,
		                             [0,
		                              Match_failure,
		                              function(param, a){
		                               if(param[1] === Match_failure){
		                                var arg = param[2];
		                                return caml_exact_trampoline_cps_call$1
		(get_flc_error, cst_Match_failure, arg, a);
		                               }
		                               a = caml_pop_trap();
		                               return a
		                                       (caml_maybe_attach_backtrace([0, Assert_failure, d$], 1));
		                              }],
		                             [0,
		                              [0,
		                               Not_found_s,
		                               function(param, a){
		                                if(param[1] === Not_found_s){
		                                 var arg = param[2];
		                                 return a([1, [0, d9, [0, arg, 0]]]);
		                                }
		                                a = caml_pop_trap();
		                                return a
		(caml_maybe_attach_backtrace([0, Assert_failure, d_], 1));
		                               }],
		                              [0,
		                               [0,
		                                Sys_error,
		                                function(param, a){
		                                 if(param[1] === Sys_error){
		                                  var arg = param[2];
		                                  return a([1, [0, d7, [0, [0, arg], 0]]]);
		                                 }
		                                 a = caml_pop_trap();
		                                 return a
		 (caml_maybe_attach_backtrace([0, Assert_failure, d8], 1));
		                                }],
		                               [0,
		                                [0,
		                                 Help,
		                                 function(param, a){
		                                  if(param[1] === Help){
		                                   var arg = param[2];
		                                   return a([1, [0, d5, [0, [0, arg], 0]]]);
		                                  }
		                                  a = caml_pop_trap();
		                                  return a
		  (caml_maybe_attach_backtrace([0, Assert_failure, d6], 1));
		                                 }],
		                                [0,
		                                 [0,
		                                  Bad,
		                                  function(param, a){
		                                   if(param[1] === Bad){
		                                    var arg = param[2];
		                                    return a([1, [0, d3, [0, [0, arg], 0]]]);
		                                   }
		                                   a = caml_pop_trap();
		                                   return a
		   (caml_maybe_attach_backtrace([0, Assert_failure, d4], 1));
		                                  }],
		                                 [0,
		                                  [0,
		                                   Undefined,
		                                   function(param, a){
		                                    if(param === Undefined) return a(d1);
		                                    a = caml_pop_trap();
		                                    return a
		    (caml_maybe_attach_backtrace([0, Assert_failure, d2], 1));
		                                   }],
		                                  [0,
		                                   [0,
		                                    Parse_error,
		                                    function(param, a){
		                                     if(param === Parse_error) return a(dZ);
		                                     a = caml_pop_trap();
		                                     return a
		     (caml_maybe_attach_backtrace([0, Assert_failure, d0], 1));
		                                    }],
		                                   [0,
		                                    [0,
		                                     Empty$0,
		                                     function(param, a){
		                                      if(param === Empty$0) return a(dX);
		                                      a = caml_pop_trap();
		                                      return a
		      (caml_maybe_attach_backtrace([0, Assert_failure, dY], 1));
		                                     }],
		                                    [0,
		                                     [0,
		                                      Scan_failure,
		                                      function(param, a){
		                                       if(param[1] === Scan_failure){
		var arg = param[2];
		return a([1, [0, dV, [0, [0, arg], 0]]]);
		                                       }
		                                       a = caml_pop_trap();
		                                       return a
		       (caml_maybe_attach_backtrace([0, Assert_failure, dW], 1));
		                                      }],
		                                     [0,
		                                      [0,
		                                       Empty,
		                                       function(param, a){
		if(param === Empty) return a(dT);
		a = caml_pop_trap();
		return a
		        (caml_maybe_attach_backtrace([0, Assert_failure, dU], 1));
		                                       }],
		                                      [0,
		                                       [0,
		Break,
		function(param, a){
		 if(param === Break) return a(dR);
		 a = caml_pop_trap();
		 return a
		         (caml_maybe_attach_backtrace([0, Assert_failure, dS], 1));
		}],
		                                       0]]]]]]]]]]]]]]]]]);
		            },
		            []);
		  }
		  (globalThis)); 
	} (controller_bc$1));
	return controller_bc$1.exports;
}

var controller_bcExports = requireController_bc();
var controller_bc = /*@__PURE__*/getDefaultExportFromCjs(controller_bcExports);

export { controller_bc as default };
